var SW = Object.defineProperty, RW = Object.defineProperties;
var kW = Object.getOwnPropertyDescriptors;
var Uh = Object.getOwnPropertySymbols;
var bk = Object.prototype.hasOwnProperty, Ck = Object.prototype.propertyIsEnumerable;
var Gh = Math.pow, ky = (e, t, i) => t in e ? SW(e, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[t] = i, q = (e, t) => {
  for (var i in t || (t = {}))
    bk.call(t, i) && ky(e, i, t[i]);
  if (Uh)
    for (var i of Uh(t))
      Ck.call(t, i) && ky(e, i, t[i]);
  return e;
}, ee = (e, t) => RW(e, kW(t));
var Fe = (e, t) => {
  var i = {};
  for (var r in e)
    bk.call(e, r) && t.indexOf(r) < 0 && (i[r] = e[r]);
  if (e != null && Uh)
    for (var r of Uh(e))
      t.indexOf(r) < 0 && Ck.call(e, r) && (i[r] = e[r]);
  return i;
};
var Ze = (e, t, i) => (ky(e, typeof t != "symbol" ? t + "" : t, i), i);
var Lt = (e, t, i) => new Promise((r, n) => {
  var o = (l) => {
    try {
      a(i.next(l));
    } catch (c) {
      n(c);
    }
  }, s = (l) => {
    try {
      a(i.throw(l));
    } catch (c) {
      n(c);
    }
  }, a = (l) => l.done ? r(l.value) : Promise.resolve(l.value).then(o, s);
  a((i = i.apply(e, t)).next());
});
import { jsxs as V, Fragment as gt, jsx as f } from "react/jsx-runtime";
import * as ft from "react";
import X, { useRef as Ne, useState as se, useEffect as be, useCallback as ye, useMemo as we, createElement as Ei, createContext as Co, useContext as sn, Suspense as Ll, forwardRef as T0, useLayoutEffect as B0, Fragment as bl, isValidElement as ug, cloneElement as dg, useReducer as RN, createRef as wW, useSyncExternalStore as MW, memo as NW, useImperativeHandle as TW } from "react";
import * as mg from "react-dom";
import Kl, { createPortal as ps, flushSync as kN } from "react-dom";
import { useDrag as wN, useDrop as BW, DndProvider as jC } from "react-dnd";
import { HTML5Backend as LC } from "react-dnd-html5-backend";
import { useStore as DW, createStore as OW } from "zustand";
const MN = ft.createContext(null), xk = 4;
function Yt({
  children: e,
  className: t,
  onClick: i,
  title: r
}) {
  const n = Ne(null), o = ft.useContext(MN);
  if (o === null)
    throw new Error("DropDownItem must be used within a DropDown");
  const { registerItem: s } = o;
  return be(() => {
    n && n.current && s(n);
  }, [n, s]), /* @__PURE__ */ f("button", { className: t, onClick: i, ref: n, title: r, type: "button", children: e });
}
function FW({
  children: e,
  dropDownRef: t,
  onClose: i
}) {
  const [r, n] = se(), [o, s] = se(), a = ye(
    (u) => {
      n((m) => m ? [...m, u] : [u]);
    },
    [n]
  ), l = (u) => {
    if (!r)
      return;
    const m = u.key;
    ["Escape", "ArrowUp", "ArrowDown", "Tab"].includes(m) && u.preventDefault(), m === "Escape" || m === "Tab" ? i() : m === "ArrowUp" ? s((g) => {
      if (!g)
        return r[0];
      const h = r.indexOf(g) - 1;
      return r[h === -1 ? r.length - 1 : h];
    }) : m === "ArrowDown" && s((g) => g ? r[r.indexOf(g) + 1] : r[0]);
  }, c = we(
    () => ({
      registerItem: a
    }),
    [a]
  );
  return be(() => {
    r && !o && s(r[0]), o && o.current && o.current.focus();
  }, [r, o]), /* @__PURE__ */ f(MN.Provider, { value: c, children: /* @__PURE__ */ f("div", { className: "maxroll-rich-text-editor-dropdown", ref: t, onKeyDown: l, children: e }) });
}
function Ia({
  disabled: e = !1,
  buttonLabel: t,
  buttonAriaLabel: i,
  buttonClassName: r,
  buttonIconClassName: n,
  children: o,
  stopCloseOnClickSelf: s
}) {
  const a = Ne(null), l = Ne(null), [c, u] = se(!1), m = () => {
    u(!1), l && l.current && l.current.focus();
  };
  return be(() => {
    const g = l.current, h = a.current;
    if (c && g !== null && h !== null) {
      const { top: A, left: y } = g.getBoundingClientRect();
      h.style.top = `${A + g.offsetHeight + xk}px`, h.style.left = `${Math.min(y, window.innerWidth - h.offsetWidth - 20)}px`;
    }
  }, [a, l, c]), be(() => {
    const g = l.current;
    if (g !== null && c) {
      const h = (A) => {
        const y = A.target;
        s && a.current && a.current.contains(y) || g.contains(y) || u(!1);
      };
      return document.addEventListener("click", h), () => {
        document.removeEventListener("click", h);
      };
    }
  }, [a, l, c, s]), be(() => {
    const g = () => {
      if (c) {
        const h = l.current, A = a.current;
        if (h !== null && A !== null) {
          const { top: y } = h.getBoundingClientRect(), E = y + h.offsetHeight + xk;
          E !== A.getBoundingClientRect().top && (A.style.top = `${E}px`);
        }
      }
    };
    return document.addEventListener("scroll", g), () => {
      document.removeEventListener("scroll", g);
    };
  }, [l, a, c]), /* @__PURE__ */ V(gt, { children: [
    /* @__PURE__ */ V(
      "button",
      {
        type: "button",
        disabled: e,
        "aria-label": i || t,
        className: r,
        onClick: () => u(!c),
        ref: l,
        children: [
          n && /* @__PURE__ */ f("span", { className: n }),
          t && /* @__PURE__ */ f("span", { className: "text dropdown-button-text", children: t }),
          /* @__PURE__ */ f("i", { className: "chevron-down" })
        ]
      }
    ),
    c && ps(
      /* @__PURE__ */ f(FW, { dropDownRef: a, onClose: m, children: o }),
      document.body
    )
  ] });
}
var yt = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function Ho(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function NN(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var i = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    i.prototype = t.prototype;
  } else
    i = {};
  return Object.defineProperty(i, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var n = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(i, r, n.get ? n : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), i;
}
var J1 = {}, TN = X;
function VW(e) {
  let t = new URLSearchParams();
  t.append("code", e);
  for (let i = 1; i < arguments.length; i++)
    t.append("v", arguments[i]);
  throw Error(`Minified Lexical error #${e}; visit https://lexical.dev/docs/error?${t} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
}
let BN = TN.createContext(null);
J1.LexicalComposerContext = BN;
J1.createLexicalComposerContext = function(e, t) {
  let i = null;
  return e != null && (i = e[1]), { getTheme: function() {
    return t != null ? t : i != null ? i.getTheme() : null;
  } };
};
J1.useLexicalComposerContext = function() {
  let e = TN.useContext(BN);
  return e == null && VW(8), e;
};
const qW = J1;
var nt = qW, gr = {}, Vr = {}, Be = {};
let P1 = {}, DN = {}, Tm = {}, nm = {}, Pv = {}, e0 = {}, KC = {}, zv = {}, Bm = {}, Dm = {}, Al = {}, YC = {}, UC = {}, ON = {}, FN = {}, VN = {}, qN = {}, jN = {}, LN = {}, KN = {}, e1 = {}, YN = {}, UN = {}, GN = {}, QN = {}, WN = {}, ZN = {}, JN = {}, PN = {}, zN = {}, GC = {}, QC = {}, Hv = {}, HN = {}, XN = {}, _N = {};
function $e(e) {
  let t = new URLSearchParams();
  t.append("code", e);
  for (let i = 1; i < arguments.length; i++)
    t.append("v", arguments[i]);
  throw Error(`Minified Lexical error #${e}; visit https://lexical.dev/docs/error?${t} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
}
let Va = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined", jW = Va && "documentMode" in document ? document.documentMode : null, Xr = Va && /Mac|iPod|iPhone|iPad/.test(navigator.platform), Tl = Va && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent), t1 = Va && "InputEvent" in window && !jW ? "getTargetRanges" in new window.InputEvent("input") : !1, WC = Va && /Version\/[\d.]+.*Safari/.test(navigator.userAgent), z1 = Va && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, LW = Va && /^(?=.*Chrome).*/i.test(navigator.userAgent), ZC = Va && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && !LW, H1 = WC || z1 || ZC ? " " : "​", KW = Tl ? " " : H1, YW = /^[^A-Za-z\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u02b8\u0300-\u0590\u0800-\u1fff\u200e\u2c00-\ufb1c\ufe00-\ufe6f\ufefd-\uffff]*[\u0591-\u07ff\ufb1d-\ufdfd\ufe70-\ufefc]/, UW = /^[^\u0591-\u07ff\ufb1d-\ufdfd\ufe70-\ufefc]*[A-Za-z\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u02b8\u0300-\u0590\u0800-\u1fff\u200e\u2c00-\ufb1c\ufe00-\ufe6f\ufefd-\uffff]/, Rc = { bold: 1, code: 16, highlight: 128, italic: 2, strikethrough: 4, subscript: 32, superscript: 64, underline: 8 }, GW = { directionless: 1, unmergeable: 2 }, Ik = { center: 2, end: 6, justify: 4, left: 1, right: 3, start: 5 }, QW = { 2: "center", 6: "end", 4: "justify", 1: "left", 3: "right", 5: "start" }, WW = { normal: 0, segmented: 2, token: 1 }, ZW = { 0: "normal", 2: "segmented", 1: "token" }, Xv = !1, JC = 0;
function JW(e) {
  JC = e.timeStamp;
}
function wy(e, t, i) {
  return t.__lexicalLineBreak === e || e[`__lexicalKey_${i._key}`] !== void 0;
}
function PW(e) {
  return e.getEditorState().read(() => {
    let t = Bi();
    return t !== null ? t.clone() : null;
  });
}
function $N(e, t, i) {
  Xv = !0;
  let r = 100 < performance.now() - JC;
  try {
    vo(e, () => {
      let n = Bi() || PW(e);
      var o = /* @__PURE__ */ new Map(), s = e.getRootElement(), a = e._editorState, l = e._blockCursorElement;
      let c = !1, u = "";
      for (var m = 0; m < t.length; m++) {
        var g = t[m], h = g.type, A = g.target, y = hg(A, a);
        if (!(y === null && A !== s || Ti(y))) {
          if (h === "characterData") {
            if (g = r && lt(y))
              e: {
                g = n, h = A;
                var E = y;
                if (Tt(g)) {
                  var v = g.anchor.getNode();
                  if (v.is(E) && g.format !== v.getFormat()) {
                    g = !1;
                    break e;
                  }
                }
                g = h.nodeType === 3 && E.isAttached();
              }
            g && (E = Zs(e._window), h = g = null, E !== null && E.anchorNode === A && (g = E.anchorOffset, h = E.focusOffset), A = A.nodeValue, A !== null && $C(y, A, g, h, !1));
          } else if (h === "childList") {
            for (c = !0, h = g.addedNodes, E = 0; E < h.length; E++) {
              v = h[E];
              var C = sT(v), x = v.parentNode;
              x == null || v === l || C !== null || v.nodeName === "BR" && wy(v, x, e) || (Tl && (C = v.innerText || v.nodeValue) && (u += C), x.removeChild(v));
            }
            if (g = g.removedNodes, h = g.length, 0 < h) {
              for (E = 0, v = 0; v < h; v++)
                x = g[v], (x.nodeName === "BR" && wy(x, A, e) || l === x) && (A.appendChild(x), E++);
              h !== E && (A === s && (y = a._nodeMap.get("root")), o.set(A, y));
            }
          }
        }
      }
      if (0 < o.size)
        for (let [
          S,
          R
        ] of o)
          if (Ue(R))
            for (o = R.getChildrenKeys(), s = S.firstChild, a = 0; a < o.length; a++)
              l = e.getElementByKey(o[a]), l !== null && (s == null ? (S.appendChild(l), s = l) : s !== l && S.replaceChild(l, s), s = s.nextSibling);
          else
            lt(R) && R.markDirty();
      if (o = i.takeRecords(), 0 < o.length) {
        for (s = 0; s < o.length; s++)
          for (l = o[s], a = l.addedNodes, l = l.target, m = 0; m < a.length; m++)
            y = a[m], A = y.parentNode, A == null || y.nodeName !== "BR" || wy(y, l, e) || A.removeChild(y);
        i.takeRecords();
      }
      n !== null && (c && (n.dirty = !0, Ys(n)), Tl && uT(e) && n.insertRawText(u));
    });
  } finally {
    Xv = !1;
  }
}
function eT(e) {
  let t = e._observer;
  if (t !== null) {
    let i = t.takeRecords();
    $N(e, i, t);
  }
}
function tT(e) {
  JC === 0 && _1(e).addEventListener("textInput", JW, !0), e._observer = new MutationObserver((t, i) => {
    $N(e, t, i);
  });
}
function Sk(e, t) {
  let i = e.__mode, r = e.__format;
  e = e.__style;
  let n = t.__mode, o = t.__format;
  return t = t.__style, (i === null || i === n) && (r === null || r === o) && (e === null || e === t);
}
function Rk(e, t) {
  let i = e.mergeWithSibling(t), r = Xi()._normalizedNodes;
  return r.add(e.__key), r.add(t.__key), i;
}
function iT(e) {
  if (e.__text === "" && e.isSimpleText() && !e.isUnmergeable())
    e.remove();
  else {
    for (var t; (t = e.getPreviousSibling()) !== null && lt(t) && t.isSimpleText() && !t.isUnmergeable(); )
      if (t.__text === "")
        t.remove();
      else {
        Sk(t, e) && (e = Rk(t, e));
        break;
      }
    for (var i; (i = e.getNextSibling()) !== null && lt(i) && i.isSimpleText() && !i.isUnmergeable(); )
      if (i.__text === "")
        i.remove();
      else {
        Sk(e, i) && Rk(e, i);
        break;
      }
  }
}
function PC(e) {
  return kk(e.anchor), kk(e.focus), e;
}
function kk(e) {
  for (; e.type === "element"; ) {
    var t = e.getNode(), i = e.offset;
    if (i === t.getChildrenSize() ? (t = t.getChildAtIndex(i - 1), i = !0) : (t = t.getChildAtIndex(i), i = !1), lt(t)) {
      e.set(t.__key, i ? t.getTextContentSize() : 0, "text");
      break;
    } else if (!Ue(t))
      break;
    e.set(t.__key, i ? t.getChildrenSize() : 0, "element");
  }
}
let zW = 1, HW = typeof queueMicrotask == "function" ? queueMicrotask : (e) => {
  Promise.resolve().then(e);
};
function zC(e) {
  let t = document.activeElement;
  if (t === null)
    return !1;
  let i = t.nodeName;
  return Ti(hg(e)) && (i === "INPUT" || i === "TEXTAREA" || t.contentEditable === "true" && t.__lexicalEditor == null);
}
function gg(e, t, i) {
  let r = e.getRootElement();
  try {
    return r !== null && r.contains(t) && r.contains(i) && t !== null && !zC(t) && HC(t) === e;
  } catch (n) {
    return !1;
  }
}
function HC(e) {
  for (; e != null; ) {
    let t = e.__lexicalEditor;
    if (t != null)
      return t;
    e = X1(e);
  }
  return null;
}
function _v(e) {
  return e.isToken() || e.isSegmented();
}
function i1(e) {
  for (; e != null; ) {
    if (e.nodeType === 3)
      return e;
    e = e.firstChild;
  }
  return null;
}
function rT(e, t, i) {
  return t = Rc[t], e & t && (i === null || !(i & t)) ? e ^ t : i === null || i & t ? e | t : e;
}
function nT(e) {
  return lt(e) || qm(e) || Ti(e);
}
function oT(e, t) {
  if (t != null)
    e.__key = t;
  else {
    Cn(), 99 < jm && $e(14), t = Xi();
    var i = Js(), r = "" + zW++;
    i._nodeMap.set(r, e), Ue(e) ? t._dirtyElements.set(r, !0) : t._dirtyLeaves.add(r), t._cloneNotNeeded.add(r), t._dirtyType = 1, e.__key = r;
  }
}
function kc(e) {
  var t = e.getParent();
  if (t !== null) {
    let n = e.getWritable();
    t = t.getWritable();
    var i = e.getPreviousSibling();
    if (e = e.getNextSibling(), i === null)
      if (e !== null) {
        var r = e.getWritable();
        t.__first = e.__key, r.__prev = null;
      } else
        t.__first = null;
    else {
      if (r = i.getWritable(), e !== null) {
        let o = e.getWritable();
        o.__prev = r.__key, r.__next = o.__key;
      } else
        r.__next = null;
      n.__prev = null;
    }
    e === null ? i !== null ? (e = i.getWritable(), t.__last = i.__key, e.__next = null) : t.__last = null : (e = e.getWritable(), i !== null ? (i = i.getWritable(), i.__next = e.__key, e.__prev = i.__key) : e.__prev = null, n.__next = null), t.__size--, n.__parent = null;
  }
}
function r1(e) {
  99 < jm && $e(14);
  var t = e.getLatest(), i = t.__parent, r = Js();
  let n = Xi(), o = r._nodeMap;
  if (r = n._dirtyElements, i !== null)
    e:
      for (; i !== null; ) {
        if (r.has(i))
          break e;
        let s = o.get(i);
        if (s === void 0)
          break;
        r.set(i, !1), i = s.__parent;
      }
  t = t.__key, n._dirtyType = 1, Ue(e) ? r.set(t, !0) : n._dirtyLeaves.add(t);
}
function Wr(e) {
  Cn();
  var t = Xi();
  let i = t._compositionKey;
  e !== i && (t._compositionKey = e, i !== null && (t = Mr(i), t !== null && t.getWritable()), e !== null && (e = Mr(e), e !== null && e.getWritable()));
}
function yl() {
  return q0() ? null : Xi()._compositionKey;
}
function Mr(e, t) {
  return e = (t || Js())._nodeMap.get(e), e === void 0 ? null : e;
}
function sT(e, t) {
  let i = Xi();
  return e = e[`__lexicalKey_${i._key}`], e !== void 0 ? Mr(e, t) : null;
}
function hg(e, t) {
  for (; e != null; ) {
    let i = sT(e, t);
    if (i !== null)
      return i;
    e = X1(e);
  }
  return null;
}
function aT(e) {
  let t = Object.assign({}, e._decorators);
  return e._pendingDecorators = t;
}
function wk(e) {
  return e.read(() => Ws().getTextContent());
}
function XW(e, t) {
  vo(e, () => {
    var i = Js();
    if (!i.isEmpty())
      if (t === "root")
        Ws().markDirty();
      else {
        i = i._nodeMap;
        for (let [, r] of i)
          r.markDirty();
      }
  }, e._pendingEditorState === null ? { tag: "history-merge" } : void 0);
}
function Ws() {
  return Js()._nodeMap.get("root");
}
function Ys(e) {
  Cn();
  let t = Js();
  e !== null && (e.dirty = !0, e._cachedNodes = null), t._selection = e;
}
function zu(e) {
  var t = Xi(), i;
  e: {
    for (i = e; i != null; ) {
      let r = i[`__lexicalKey_${t._key}`];
      if (r !== void 0) {
        i = r;
        break e;
      }
      i = X1(i);
    }
    i = null;
  }
  return i === null ? (t = t.getRootElement(), e === t ? Mr("root") : null) : Mr(i);
}
function lT(e) {
  return /[\uD800-\uDBFF][\uDC00-\uDFFF]/g.test(e);
}
function XC(e) {
  let t = [];
  for (; e !== null; )
    t.push(e), e = e._parentEditor;
  return t;
}
function cT() {
  return Math.random().toString(36).replace(/[^a-z]+/g, "").substr(0, 5);
}
function _C(e, t, i) {
  if (t = Zs(t._window), t !== null) {
    var r = t.anchorNode, { anchorOffset: n, focusOffset: o } = t;
    if (r !== null && (t = r.nodeType === 3 ? r.nodeValue : null, r = hg(r), t !== null && lt(r))) {
      if (t === H1 && i) {
        let s = i.length;
        t = i, o = n = s;
      }
      t !== null && $C(r, t, n, o, e);
    }
  }
}
function $C(e, t, i, r, n) {
  let o = e;
  if (o.isAttached() && (n || !o.isDirty())) {
    let c = o.isComposing(), u = t;
    if ((c || n) && t[t.length - 1] === H1 && (u = t.slice(0, -1)), t = o.getTextContent(), n || u !== t)
      if (u === "")
        if (Wr(null), WC || z1 || ZC)
          o.remove();
        else {
          let m = Xi();
          setTimeout(() => {
            m.update(() => {
              o.isAttached() && o.remove();
            });
          }, 20);
        }
      else {
        n = o.getParent(), t = V0();
        var s = o.getTextContentSize(), a = yl(), l = o.getKey();
        o.isToken() || a !== null && l === a && !c || Tt(t) && (n !== null && !n.canInsertTextBefore() && t.anchor.offset === 0 || t.anchor.key === e.__key && t.anchor.offset === 0 && !o.canInsertTextBefore() || t.focus.key === e.__key && t.focus.offset === s && !o.canInsertTextAfter()) ? o.markDirty() : (e = Bi(), Tt(e) && i !== null && r !== null && (e.setTextNodeRange(o, i, o, r), o.isSegmented() && (i = o.getTextContent(), i = wr(i), o.replace(i), o = i)), o.setTextContent(u));
      }
  }
}
function _W(e, t) {
  if (t.isSegmented())
    return !0;
  if (!e.isCollapsed())
    return !1;
  e = e.anchor.offset;
  let i = t.getParentOrThrow(), r = t.isToken();
  return e === 0 ? ((e = !t.canInsertTextBefore() || !i.canInsertTextBefore() || r) || (t = t.getPreviousSibling(), e = (lt(t) || Ue(t) && t.isInline()) && !t.canInsertTextAfter()), e) : e === t.getTextContentSize() ? !t.canInsertTextAfter() || !i.canInsertTextAfter() || r : !1;
}
function om(e, t) {
  e.__lexicalClassNameCache === void 0 && (e.__lexicalClassNameCache = {});
  let i = e.__lexicalClassNameCache, r = i[t];
  return r !== void 0 ? r : (e = e[t], typeof e == "string" ? (e = e.split(" "), i[t] = e) : e);
}
function e2(e, t, i, r, n) {
  i.size !== 0 && (i = r.__type, r = r.__key, t = t.get(i), t === void 0 && $e(33, i), i = t.klass, t = e.get(i), t === void 0 && (t = /* @__PURE__ */ new Map(), e.set(i, t)), e = t.get(r), i = e === "destroyed" && n === "created", (e === void 0 || i) && t.set(r, i ? "updated" : n));
}
function Mk(e, t, i) {
  let r = e.getParent(), n = i;
  return r !== null && (t && i === 0 ? (n = e.getIndexWithinParent(), e = r) : t || i !== e.getChildrenSize() || (n = e.getIndexWithinParent() + 1, e = r)), e.getChildAtIndex(t ? n - 1 : n);
}
function $v(e, t) {
  var i = e.offset;
  return e.type === "element" ? (e = e.getNode(), Mk(e, t, i)) : (e = e.getNode(), t && i === 0 || !t && i === e.getTextContentSize() ? (i = t ? e.getPreviousSibling() : e.getNextSibling(), i === null ? Mk(e.getParentOrThrow(), t, e.getIndexWithinParent() + (t ? 0 : 1)) : i) : null);
}
function uT(e) {
  return e = (e = _1(e).event) && e.inputType, e === "insertFromPaste" || e === "insertFromPasteAsQuotation";
}
function n1(e) {
  return !xn(e) && !e.isLastChild() && !e.isInline();
}
function o1(e, t) {
  return e = e._keyToDOMMap.get(t), e === void 0 && $e(75, t), e;
}
function X1(e) {
  return e = e.assignedSlot || e.parentElement, e !== null && e.nodeType === 11 ? e.host : e;
}
function s1(e, t) {
  for (e = e.getParent(); e !== null; ) {
    if (e.is(t))
      return !0;
    e = e.getParent();
  }
  return !1;
}
function _1(e) {
  return e = e._window, e === null && $e(78), e;
}
function dT(e) {
  for (e = e.getParentOrThrow(); e !== null && !us(e); )
    e = e.getParentOrThrow();
  return e;
}
function us(e) {
  return xn(e) || Ue(e) && e.isShadowRoot();
}
function mT(e) {
  return e = e.constructor.clone(e), oT(e, null), e;
}
function pg(e) {
  var t = Xi();
  let i = e.constructor.getType();
  return t = t._nodes.get(i), t === void 0 && $e(97), t = t.replace, t !== null ? (t = t(e), t instanceof e.constructor || $e(98), t) : e;
}
function My(e, t) {
  e = e.getParent(), !xn(e) || Ue(t) || Ti(t) || $e(99);
}
function Ny(e) {
  return (Ti(e) || Ue(e) && !e.canBeEmpty()) && !e.isInline();
}
function eb(e, t, i) {
  i.style.removeProperty("caret-color"), t._blockCursorElement = null, t = e.parentElement, t !== null && t.removeChild(e);
}
function Zs(e) {
  return Va ? (e || window).getSelection() : null;
}
function gT(e, t) {
  let i = e.getChildAtIndex(t);
  i == null && (i = e), us(e) && $e(102);
  let r = (s) => {
    const a = s.getParentOrThrow(), l = us(a), c = s !== i || l ? mT(s) : s;
    if (l)
      return s.insertAfter(c), [s, c, c];
    const [u, m, g] = r(a);
    return s = s.getNextSiblings(), g.append(c, ...s), [u, m, c];
  }, [n, o] = r(i);
  return [n, o];
}
function a1(e, t) {
  for (; e !== Ws() && e != null; ) {
    if (t(e))
      return e;
    e = e.getParent();
  }
  return null;
}
function $W(e) {
  let t = [], i = [e];
  for (; 0 < i.length; ) {
    let r = i.pop();
    r === void 0 && $e(112), Ue(r) && i.unshift(...r.getChildren()), r !== e && t.push(r);
  }
  return t;
}
function $1(e) {
  return e.nodeType === 1;
}
function hT(e, t, i, r, n, o) {
  for (e = e.getFirstChild(); e !== null; ) {
    let s = e.__key;
    e.__parent === t && (Ue(e) && hT(e, s, i, r, n, o), i.has(s) || o.delete(s), n.push(s)), e = e.getNextSibling();
  }
}
function e9(e, t, i, r) {
  e = e._nodeMap, t = t._nodeMap;
  let n = [];
  for (let [o] of r) {
    let s = t.get(o);
    s === void 0 || s.isAttached() || (Ue(s) && hT(s, o, e, t, n, r), e.has(o) || r.delete(o), n.push(o));
  }
  for (let o of n)
    t.delete(o);
  for (let o of i)
    r = t.get(o), r === void 0 || r.isAttached() || (e.has(o) || i.delete(o), t.delete(o));
}
let Cr = "", bn = "", Ea = "", Bl, rn, Om, pT = !1, t2 = !1, ef, Fp = null, tb, ib, jc, Dl, rb, Fm;
function Vp(e, t) {
  let i = jc.get(e);
  if (t !== null) {
    let r = sb(e);
    r.parentNode === t && t.removeChild(r);
  }
  Dl.has(e) || rn._keyToDOMMap.delete(e), Ue(i) && (e = l1(i, jc), nb(e, 0, e.length - 1, null)), i !== void 0 && e2(Fm, Om, ef, i, "destroyed");
}
function nb(e, t, i, r) {
  for (; t <= i; ++t) {
    let n = e[t];
    n !== void 0 && Vp(n, r);
  }
}
function nc(e, t) {
  e.setProperty("text-align", t);
}
function fT(e, t) {
  var i = Bl.theme.indent;
  if (typeof i == "string") {
    let r = e.classList.contains(i);
    0 < t && !r ? e.classList.add(i) : 1 > t && r && e.classList.remove(i);
  }
  i = getComputedStyle(e).getPropertyValue("--lexical-indent-base-value") || "40px", e.style.setProperty("padding-inline-start", t === 0 ? "" : `calc(${t} * ${i})`);
}
function AT(e, t) {
  e = e.style, t === 0 ? nc(e, "") : t === 1 ? nc(e, "left") : t === 2 ? nc(e, "center") : t === 3 ? nc(e, "right") : t === 4 ? nc(e, "justify") : t === 5 ? nc(e, "start") : t === 6 && nc(e, "end");
}
function qp(e, t, i) {
  let r = Dl.get(e);
  r === void 0 && $e(60);
  let n = r.createDOM(Bl, rn);
  var o = rn._keyToDOMMap;
  if (n["__lexicalKey_" + rn._key] = e, o.set(e, n), lt(r) ? n.setAttribute("data-lexical-text", "true") : Ti(r) && n.setAttribute("data-lexical-decorator", "true"), Ue(r)) {
    if (e = r.__indent, o = r.__size, e !== 0 && fT(n, e), o !== 0) {
      --o, e = l1(r, Dl);
      var s = bn;
      bn = "", ob(e, r, 0, o, n, null), ET(r, n), bn = s;
    }
    e = r.__format, e !== 0 && AT(n, e), r.isInline() || yT(null, r, n), n1(r) && (Cr += `

`, Ea += `

`);
  } else
    o = r.getTextContent(), Ti(r) ? (s = r.decorate(rn, Bl), s !== null && vT(e, s), n.contentEditable = "false") : lt(r) && (r.isDirectionless() || (bn += o)), Cr += o, Ea += o;
  return t !== null && (i != null ? t.insertBefore(n, i) : (i = t.__lexicalLineBreak, i != null ? t.insertBefore(n, i) : t.appendChild(n))), e2(Fm, Om, ef, r, "created"), n;
}
function ob(e, t, i, r, n, o) {
  let s = Cr;
  for (Cr = ""; i <= r; ++i)
    qp(e[i], n, o);
  n1(t) && (Cr += `

`), n.__lexicalTextContent = Cr, Cr = s + Cr;
}
function Nk(e, t) {
  return e = t.get(e), qm(e) || Ti(e) && e.isInline();
}
function yT(e, t, i) {
  e = e !== null && (e.__size === 0 || Nk(e.__last, jc)), t = t.__size === 0 || Nk(t.__last, Dl), e ? t || (t = i.__lexicalLineBreak, t != null && i.removeChild(t), i.__lexicalLineBreak = null) : t && (t = document.createElement("br"), i.__lexicalLineBreak = t, i.appendChild(t));
}
function ET(e, t) {
  var i = t.__lexicalDir;
  if (t.__lexicalDirTextContent !== bn || i !== Fp) {
    let o = bn === "";
    if (o)
      var r = Fp;
    else
      r = bn, r = YW.test(r) ? "rtl" : UW.test(r) ? "ltr" : null;
    if (r !== i) {
      let s = t.classList, a = Bl.theme;
      var n = i !== null ? a[i] : void 0;
      let l = r !== null ? a[r] : void 0;
      n !== void 0 && (typeof n == "string" && (n = n.split(" "), n = a[i] = n), s.remove(...n)), r === null || o && r === "ltr" ? t.removeAttribute("dir") : (l !== void 0 && (typeof l == "string" && (i = l.split(" "), l = a[r] = i), l !== void 0 && s.add(...l)), t.dir = r), t2 || (e.getWritable().__dir = r);
    }
    Fp = r, t.__lexicalDirTextContent = bn, t.__lexicalDir = r;
  }
}
function l1(e, t) {
  let i = [];
  for (e = e.__first; e !== null; ) {
    let r = t.get(e);
    r === void 0 && $e(101), i.push(e), e = r.__next;
  }
  return i;
}
function Pd(e, t) {
  var i = jc.get(e), r = Dl.get(e);
  i !== void 0 && r !== void 0 || $e(61);
  var n = pT || ib.has(e) || tb.has(e);
  let o = o1(rn, e);
  if (i === r && !n)
    return Ue(i) ? (r = o.__lexicalTextContent, r !== void 0 && (Cr += r, Ea += r), r = o.__lexicalDirTextContent, r !== void 0 && (bn += r)) : (r = i.getTextContent(), lt(i) && !i.isDirectionless() && (bn += r), Ea += r, Cr += r), o;
  if (i !== r && n && e2(Fm, Om, ef, r, "updated"), r.updateDOM(i, o, Bl))
    return r = qp(e, null, null), t === null && $e(62), t.replaceChild(r, o), Vp(e, null), r;
  if (Ue(i) && Ue(r)) {
    if (e = r.__indent, e !== i.__indent && fT(o, e), e = r.__format, e !== i.__format && AT(o, e), n) {
      e = r, n = bn, bn = "", t = Cr;
      var s = i.__size, a = e.__size;
      if (Cr = "", s === 1 && a === 1) {
        var l = i.__first, c = e.__first;
        if (l === c)
          Pd(l, o);
        else {
          var u = sb(l);
          c = qp(c, null, null), o.replaceChild(c, u), Vp(l, null);
        }
      } else {
        c = l1(i, jc);
        var m = l1(e, Dl);
        if (s === 0)
          a !== 0 && ob(m, e, 0, a - 1, o, null);
        else if (a === 0)
          s !== 0 && (l = o.__lexicalLineBreak == null, nb(c, 0, s - 1, l ? null : o), l && (o.textContent = ""));
        else {
          var g = c;
          c = m, m = s - 1, s = a - 1;
          let A = o.firstChild, y = 0;
          for (a = 0; y <= m && a <= s; ) {
            var h = g[y];
            let E = c[a];
            if (h === E)
              A = Ty(Pd(E, o)), y++, a++;
            else {
              l === void 0 && (l = new Set(g)), u === void 0 && (u = new Set(c));
              let v = u.has(h), C = l.has(E);
              v ? (C ? (h = o1(rn, E), h === A ? A = Ty(Pd(E, o)) : (A != null ? o.insertBefore(h, A) : o.appendChild(h), Pd(E, o)), y++) : qp(E, o, A), a++) : (A = Ty(sb(h)), Vp(h, o), y++);
            }
          }
          l = y > m, u = a > s, l && !u ? (l = c[s + 1], l = l === void 0 ? null : rn.getElementByKey(l), ob(c, e, a, s, o, l)) : u && !l && nb(g, y, m, o);
        }
      }
      n1(e) && (Cr += `

`), o.__lexicalTextContent = Cr, Cr = t + Cr, ET(e, o), bn = n, xn(r) || r.isInline() || yT(i, r, o);
    }
    n1(r) && (Cr += `

`, Ea += `

`);
  } else
    i = r.getTextContent(), Ti(r) ? (n = r.decorate(rn, Bl), n !== null && vT(e, n)) : lt(r) && !r.isDirectionless() && (bn += i), Cr += i, Ea += i;
  return !t2 && xn(r) && r.__cachedText !== Ea && (r = r.getWritable(), r.__cachedText = Ea), o;
}
function vT(e, t) {
  let i = rn._pendingDecorators, r = rn._decorators;
  if (i === null) {
    if (r[e] === t)
      return;
    i = aT(rn);
  }
  i[e] = t;
}
function Ty(e) {
  return e = e.nextSibling, e !== null && e === rn._blockCursorElement && (e = e.nextSibling), e;
}
function sb(e) {
  let t = rb.get(e);
  return t === void 0 && $e(75, e), t;
}
let ca = Object.freeze({}), ab = [["keydown", l9], ["pointerdown", i9], ["compositionstart", s9], ["compositionend", a9], ["input", o9], ["click", t9], ["cut", ca], ["copy", ca], ["dragstart", ca], ["dragover", ca], ["dragend", ca], ["paste", ca], ["focus", ca], ["blur", ca], ["drop", ca]];
t1 && ab.push(["beforeinput", (e, t) => n9(e, t)]);
let Vm = 0, bT = 0, CT = 0, Wu = null, sm = 0, lb = !1, cb = !1, am = !1, zd = !1, xT = [0, "", 0, "root", 0];
function IT(e, t, i, r, n) {
  let o = e.anchor, s = e.focus, a = o.getNode();
  var l = Xi();
  let c = Zs(l._window), u = c !== null ? c.anchorNode : null, m = o.key;
  l = l.getElementByKey(m);
  let g = i.length;
  return m !== s.key || !lt(a) || (!n && (!t1 || CT < r + 50) || a.isDirty() && 2 > g || lT(i)) && o.offset !== s.offset && !a.isComposing() || _v(a) || a.isDirty() && 1 < g || (n || !t1) && l !== null && !a.isComposing() && u !== i1(l) || c !== null && t !== null && (!t.collapsed || t.startContainer !== c.anchorNode || t.startOffset !== c.anchorOffset) || a.getFormat() !== e.format || a.getStyle() !== e.style || _W(e, a);
}
function Tk(e, t) {
  return e !== null && e.nodeValue !== null && e.nodeType === 3 && t !== 0 && t !== e.nodeValue.length;
}
function Bk(e, t, i) {
  let { anchorNode: r, anchorOffset: n, focusNode: o, focusOffset: s } = e;
  lb && (lb = !1, Tk(r, n) && Tk(o, s)) || vo(t, () => {
    if (!i)
      Ys(null);
    else if (gg(t, r, o)) {
      var a = Bi();
      if (Tt(a)) {
        var l = a.anchor, c = l.getNode();
        if (a.isCollapsed()) {
          e.type === "Range" && e.anchorNode === e.focusNode && (a.dirty = !0);
          var u = _1(t).event;
          u = u ? u.timeStamp : performance.now();
          let [m, g, h, A, y] = xT;
          u < y + 200 && l.offset === h && l.key === A ? (a.format = m, a.style = g) : l.type === "text" ? (a.format = c.getFormat(), a.style = c.getStyle()) : l.type === "element" && (a.format = 0, a.style = "");
        } else {
          l = 255, c = !1, u = a.getNodes();
          let m = u.length;
          for (let g = 0; g < m; g++) {
            let h = u[g];
            if (lt(h) && (c = !0, l &= h.getFormat(), l === 0))
              break;
          }
          a.format = c ? l : 0;
        }
      }
      ot(t, P1, void 0);
    }
  });
}
function t9(e, t) {
  vo(t, () => {
    let i = Bi();
    var r = Zs(t._window);
    let n = V0();
    if (r)
      if (Tt(i)) {
        let s = i.anchor;
        var o = s.getNode();
        s.type === "element" && s.offset === 0 && i.isCollapsed() && !xn(o) && Ws().getChildrenSize() === 1 && o.getTopLevelElementOrThrow().isEmpty() && n !== null && i.is(n) ? (r.removeAllRanges(), i.dirty = !0) : e.detail !== 3 || i.isCollapsed() || (r = i.focus.getNode(), o !== r && (Ue(o) ? o.select(0) : o.getParentOrThrow().select(0)));
      } else
        e.pointerType === "touch" && (o = r.anchorNode, o !== null && (o = o.nodeType, o === 1 || o === 3)) && (r = r2(n, r, t), Ys(r));
    ot(t, DN, e);
  });
}
function i9(e, t) {
  let i = e.target;
  e = e.pointerType, i instanceof Node && e !== "touch" && vo(t, () => {
    Ti(hg(i)) || (cb = !0);
  });
}
function ST(e) {
  return e.getTargetRanges ? (e = e.getTargetRanges(), e.length === 0 ? null : e[0]) : null;
}
function r9(e, t) {
  return e !== t || Ue(e) || Ue(t) || !e.isToken() || !t.isToken();
}
function n9(e, t) {
  let i = e.inputType, r = ST(e);
  i === "deleteCompositionText" || Tl && uT(t) || i !== "insertCompositionText" && vo(t, () => {
    let n = Bi();
    if (i === "deleteContentBackward") {
      if (n === null) {
        var o = V0();
        if (!Tt(o))
          return;
        Ys(o.clone());
      }
      if (Tt(n)) {
        bT === 229 && e.timeStamp < Vm + 30 && t.isComposing() && n.anchor.key === n.focus.key ? (Wr(null), Vm = 0, setTimeout(() => {
          vo(t, () => {
            Wr(null);
          });
        }, 30), Tt(n) && (o = n.anchor.getNode(), o.markDirty(), n.format = o.getFormat(), n.style = o.getStyle())) : (e.preventDefault(), ot(t, Tm, !0));
        return;
      }
    }
    if (Tt(n)) {
      o = e.data, Wu !== null && _C(!1, t, Wu), n.dirty && Wu === null || !n.isCollapsed() || xn(n.anchor.getNode()) || r === null || n.applyDOMRange(r), Wu = null;
      var s = n.focus, a = n.anchor.getNode();
      if (s = s.getNode(), i === "insertText" || i === "insertTranspose")
        o === `
` ? (e.preventDefault(), ot(t, nm, !1)) : o === `

` ? (e.preventDefault(), ot(t, Pv, void 0)) : o == null && e.dataTransfer ? (o = e.dataTransfer.getData("text/plain"), e.preventDefault(), n.insertRawText(o)) : o != null && IT(n, r, o, e.timeStamp, !0) ? (e.preventDefault(), ot(t, e0, o)) : Wu = o, CT = e.timeStamp;
      else
        switch (e.preventDefault(), i) {
          case "insertFromYank":
          case "insertFromDrop":
          case "insertReplacementText":
            ot(t, e0, e);
            break;
          case "insertFromComposition":
            Wr(null), ot(t, e0, e);
            break;
          case "insertLineBreak":
            Wr(null), ot(t, nm, !1);
            break;
          case "insertParagraph":
            Wr(null), am && !z1 ? (am = !1, ot(t, nm, !1)) : ot(t, Pv, void 0);
            break;
          case "insertFromPaste":
          case "insertFromPasteAsQuotation":
            ot(t, KC, e);
            break;
          case "deleteByComposition":
            r9(a, s) && ot(t, zv, e);
            break;
          case "deleteByDrag":
          case "deleteByCut":
            ot(t, zv, e);
            break;
          case "deleteContent":
            ot(t, Tm, !1);
            break;
          case "deleteWordBackward":
            ot(
              t,
              Bm,
              !0
            );
            break;
          case "deleteWordForward":
            ot(t, Bm, !1);
            break;
          case "deleteHardLineBackward":
          case "deleteSoftLineBackward":
            ot(t, Dm, !0);
            break;
          case "deleteContentForward":
          case "deleteHardLineForward":
          case "deleteSoftLineForward":
            ot(t, Dm, !1);
            break;
          case "formatStrikeThrough":
            ot(t, Al, "strikethrough");
            break;
          case "formatBold":
            ot(t, Al, "bold");
            break;
          case "formatItalic":
            ot(t, Al, "italic");
            break;
          case "formatUnderline":
            ot(t, Al, "underline");
            break;
          case "historyUndo":
            ot(t, YC, void 0);
            break;
          case "historyRedo":
            ot(t, UC, void 0);
        }
    }
  });
}
function o9(e, t) {
  e.stopPropagation(), vo(t, () => {
    var i = Bi(), r = e.data, n = ST(e);
    if (r != null && Tt(i) && IT(i, n, r, e.timeStamp, !1)) {
      zd && (ub(t, r), zd = !1);
      var o = i.anchor, s = o.getNode();
      if (n = Zs(t._window), n === null)
        return;
      let a = o.offset;
      (o = t1 && !i.isCollapsed() && lt(s) && n.anchorNode !== null) && (s = s.getTextContent().slice(0, a) + r + s.getTextContent().slice(a + i.focus.offset), n = n.anchorNode, o = s === (n.nodeType === 3 ? n.nodeValue : null)), o || ot(t, e0, r), r = r.length, Tl && 1 < r && e.inputType === "insertCompositionText" && !t.isComposing() && (i.anchor.offset -= r), WC || z1 || ZC || !t.isComposing() || (Vm = 0, Wr(null));
    } else
      _C(!1, t, r !== null ? r : void 0), zd && (ub(t, r || void 0), zd = !1);
    Cn(), i = Xi(), eT(i);
  }), Wu = null;
}
function s9(e, t) {
  vo(t, () => {
    let i = Bi();
    if (Tt(i) && !t.isComposing()) {
      let r = i.anchor, n = i.anchor.getNode();
      Wr(r.key), (e.timeStamp < Vm + 30 || r.type === "element" || !i.isCollapsed() || n.getFormat() !== i.format || n.getStyle() !== i.style) && ot(t, e0, KW);
    }
  });
}
function ub(e, t) {
  var i = e._compositionKey;
  if (Wr(null), i !== null && t != null) {
    if (t === "") {
      t = Mr(i), e = i1(e.getElementByKey(i)), e !== null && e.nodeValue !== null && lt(t) && $C(t, e.nodeValue, null, null, !0);
      return;
    }
    if (t[t.length - 1] === `
` && (i = Bi(), Tt(i))) {
      t = i.focus, i.anchor.set(t.key, t.offset, t.type), ot(e, e1, null);
      return;
    }
  }
  _C(!0, e, t);
}
function a9(e, t) {
  Tl ? zd = !0 : vo(t, () => {
    ub(t, e.data);
  });
}
function l9(e, t) {
  if (Vm = e.timeStamp, bT = e.keyCode, !t.isComposing()) {
    var { keyCode: i, shiftKey: r, ctrlKey: n, metaKey: o, altKey: s } = e;
    if (!ot(t, ON, e)) {
      if (i !== 39 || n || o || s)
        if (i !== 39 || s || r || !n && !o)
          if (i !== 37 || n || o || s)
            if (i !== 37 || s || r || !n && !o)
              if (i !== 38 || n || o)
                if (i !== 40 || n || o)
                  if (i === 13 && r)
                    am = !0, ot(t, e1, e);
                  else if (i === 32)
                    ot(t, YN, e);
                  else if (Xr && n && i === 79)
                    e.preventDefault(), am = !0, ot(t, nm, !0);
                  else if (i !== 13 || r) {
                    var a = Xr ? s || o ? !1 : i === 8 || i === 72 && n : n || s || o ? !1 : i === 8;
                    a ? i === 8 ? ot(t, UN, e) : (e.preventDefault(), ot(t, Tm, !0)) : i === 27 ? ot(
                      t,
                      GN,
                      e
                    ) : (a = Xr ? r || s || o ? !1 : i === 46 || i === 68 && n : n || s || o ? !1 : i === 46, a ? i === 46 ? ot(t, QN, e) : (e.preventDefault(), ot(t, Tm, !1)) : i === 8 && (Xr ? s : n) ? (e.preventDefault(), ot(t, Bm, !0)) : i === 46 && (Xr ? s : n) ? (e.preventDefault(), ot(t, Bm, !1)) : Xr && o && i === 8 ? (e.preventDefault(), ot(t, Dm, !0)) : Xr && o && i === 46 ? (e.preventDefault(), ot(t, Dm, !1)) : i === 66 && !s && (Xr ? o : n) ? (e.preventDefault(), ot(t, Al, "bold")) : i === 85 && !s && (Xr ? o : n) ? (e.preventDefault(), ot(t, Al, "underline")) : i === 73 && !s && (Xr ? o : n) ? (e.preventDefault(), ot(t, Al, "italic")) : i !== 9 || s || n || o ? i === 90 && !r && (Xr ? o : n) ? (e.preventDefault(), ot(t, YC, void 0)) : (a = Xr ? i === 90 && o && r : i === 89 && n || i === 90 && n && r, a ? (e.preventDefault(), ot(t, UC, void 0)) : F0(t._editorState._selection) ? (a = r ? !1 : i === 67 ? Xr ? o : n : !1, a ? (e.preventDefault(), ot(t, GC, e)) : (a = r ? !1 : i === 88 ? Xr ? o : n : !1, a ? (e.preventDefault(), ot(t, QC, e)) : i === 65 && (Xr ? o : n) && (e.preventDefault(), ot(t, Hv, e)))) : !Tl && i === 65 && (Xr ? o : n) && (e.preventDefault(), ot(t, Hv, e))) : ot(t, WN, e));
                  } else
                    am = !1, ot(t, e1, e);
                else
                  ot(t, KN, e);
              else
                ot(t, LN, e);
            else
              ot(t, jN, e);
          else
            ot(t, qN, e);
        else
          ot(t, VN, e);
      else
        ot(t, FN, e);
      (n || r || s || o) && ot(t, _N, e);
    }
  }
}
function RT(e) {
  let t = e.__lexicalEventHandles;
  return t === void 0 && (t = [], e.__lexicalEventHandles = t), t;
}
let t0 = /* @__PURE__ */ new Map();
function kT(e) {
  e = e.target;
  let t = Zs(e == null ? null : e.nodeType === 9 ? e.defaultView : e.ownerDocument.defaultView);
  if (t !== null) {
    var i = HC(t.anchorNode);
    if (i !== null) {
      cb && (cb = !1, vo(i, () => {
        var s = V0(), a = t.anchorNode;
        a !== null && (a = a.nodeType, a === 1 || a === 3) && (s = r2(s, t, i), Ys(s));
      })), e = XC(i), e = e[e.length - 1];
      var r = e._key, n = t0.get(r), o = n || e;
      o !== i && Bk(t, o, !1), Bk(t, i, !0), i !== e ? t0.set(r, i) : n && t0.delete(r);
    }
  }
}
function c9(e, t) {
  sm === 0 && e.ownerDocument.addEventListener("selectionchange", kT), sm++, e.__lexicalEditor = t;
  let i = RT(e);
  for (let r = 0; r < ab.length; r++) {
    let [n, o] = ab[r], s = typeof o == "function" ? (a) => {
      a._lexicalHandled !== !0 && (a._lexicalHandled = !0, t.isEditable() && o(a, t));
    } : (a) => {
      if (a._lexicalHandled !== !0 && (a._lexicalHandled = !0, t.isEditable()))
        switch (n) {
          case "cut":
            return ot(t, QC, a);
          case "copy":
            return ot(t, GC, a);
          case "paste":
            return ot(t, KC, a);
          case "dragstart":
            return ot(t, JN, a);
          case "dragover":
            return ot(t, PN, a);
          case "dragend":
            return ot(
              t,
              zN,
              a
            );
          case "focus":
            return ot(t, HN, a);
          case "blur":
            return ot(t, XN, a);
          case "drop":
            return ot(t, ZN, a);
        }
    };
    e.addEventListener(n, s), i.push(() => {
      e.removeEventListener(n, s);
    });
  }
}
function db(e, t, i) {
  Cn();
  var r = e.__key;
  let n = e.getParent();
  if (n !== null) {
    var o = Bi();
    if (Tt(o) && Ue(e)) {
      var { anchor: s, focus: a } = o, l = s.getNode(), c = a.getNode();
      s1(l, e) && s.set(e.__key, 0, "element"), s1(c, e) && a.set(e.__key, 0, "element");
    }
    if (l = o, c = !1, Tt(l) && t) {
      o = l.anchor;
      let u = l.focus;
      o.key === r && (u1(o, e, n, e.getPreviousSibling(), e.getNextSibling()), c = !0), u.key === r && (u1(u, e, n, e.getPreviousSibling(), e.getNextSibling()), c = !0);
    } else
      F0(l) && t && e.isSelected() && e.selectPrevious();
    Tt(l) && t && !c ? (r = e.getIndexWithinParent(), kc(e), c1(l, n, r, -1)) : kc(e), i || us(n) || n.canBeEmpty() || !n.isEmpty() || db(n, t), t && xn(n) && n.isEmpty() && n.selectEnd();
  }
}
class fg {
  static getType() {
    $e(64, this.name);
  }
  static clone() {
    $e(65, this.name);
  }
  constructor(t) {
    this.__type = this.constructor.getType(), this.__next = this.__prev = this.__parent = null, oT(this, t);
  }
  getType() {
    return this.__type;
  }
  isAttached() {
    for (var t = this.__key; t !== null; ) {
      if (t === "root")
        return !0;
      if (t = Mr(t), t === null)
        break;
      t = t.__parent;
    }
    return !1;
  }
  isSelected(t) {
    if (t = t || Bi(), t == null)
      return !1;
    let i = t.getNodes().some((r) => r.__key === this.__key);
    return lt(this) ? i : Tt(t) && t.anchor.type === "element" && t.focus.type === "element" && t.anchor.key === t.focus.key && t.anchor.offset === t.focus.offset ? !1 : i;
  }
  getKey() {
    return this.__key;
  }
  getIndexWithinParent() {
    var t = this.getParent();
    if (t === null)
      return -1;
    t = t.getFirstChild();
    let i = 0;
    for (; t !== null; ) {
      if (this.is(t))
        return i;
      i++, t = t.getNextSibling();
    }
    return -1;
  }
  getParent() {
    let t = this.getLatest().__parent;
    return t === null ? null : Mr(t);
  }
  getParentOrThrow() {
    let t = this.getParent();
    return t === null && $e(66, this.__key), t;
  }
  getTopLevelElement() {
    let t = this;
    for (; t !== null; ) {
      let i = t.getParent();
      if (us(i))
        return t;
      t = i;
    }
    return null;
  }
  getTopLevelElementOrThrow() {
    let t = this.getTopLevelElement();
    return t === null && $e(67, this.__key), t;
  }
  getParents() {
    let t = [], i = this.getParent();
    for (; i !== null; )
      t.push(i), i = i.getParent();
    return t;
  }
  getParentKeys() {
    let t = [], i = this.getParent();
    for (; i !== null; )
      t.push(i.__key), i = i.getParent();
    return t;
  }
  getPreviousSibling() {
    let t = this.getLatest().__prev;
    return t === null ? null : Mr(t);
  }
  getPreviousSiblings() {
    let t = [];
    var i = this.getParent();
    if (i === null)
      return t;
    for (i = i.getFirstChild(); i !== null && !i.is(this); )
      t.push(i), i = i.getNextSibling();
    return t;
  }
  getNextSibling() {
    let t = this.getLatest().__next;
    return t === null ? null : Mr(t);
  }
  getNextSiblings() {
    let t = [], i = this.getNextSibling();
    for (; i !== null; )
      t.push(i), i = i.getNextSibling();
    return t;
  }
  getCommonAncestor(t) {
    let i = this.getParents();
    var r = t.getParents();
    Ue(this) && i.unshift(this), Ue(t) && r.unshift(t), t = i.length;
    var n = r.length;
    if (t === 0 || n === 0 || i[t - 1] !== r[n - 1])
      return null;
    for (r = new Set(r), n = 0; n < t; n++) {
      let o = i[n];
      if (r.has(o))
        return o;
    }
    return null;
  }
  is(t) {
    return t == null ? !1 : this.__key === t.__key;
  }
  isBefore(t) {
    if (this === t)
      return !1;
    if (t.isParentOf(this))
      return !0;
    if (this.isParentOf(t))
      return !1;
    var i = this.getCommonAncestor(t);
    let r = this;
    for (; ; ) {
      var n = r.getParentOrThrow();
      if (n === i) {
        n = r.getIndexWithinParent();
        break;
      }
      r = n;
    }
    for (r = t; ; ) {
      if (t = r.getParentOrThrow(), t === i) {
        i = r.getIndexWithinParent();
        break;
      }
      r = t;
    }
    return n < i;
  }
  isParentOf(t) {
    let i = this.__key;
    if (i === t.__key)
      return !1;
    for (; t !== null; ) {
      if (t.__key === i)
        return !0;
      t = t.getParent();
    }
    return !1;
  }
  getNodesBetween(t) {
    let i = this.isBefore(t), r = [], n = /* @__PURE__ */ new Set();
    for (var o = this; ; ) {
      var s = o.__key;
      if (n.has(s) || (n.add(s), r.push(o)), o === t)
        break;
      if (s = Ue(o) ? i ? o.getFirstChild() : o.getLastChild() : null, s !== null)
        o = s;
      else if (s = i ? o.getNextSibling() : o.getPreviousSibling(), s !== null)
        o = s;
      else {
        if (o = o.getParentOrThrow(), n.has(o.__key) || r.push(o), o === t)
          break;
        s = o;
        do
          s === null && $e(68), o = i ? s.getNextSibling() : s.getPreviousSibling(), s = s.getParent(), s !== null && (o !== null || n.has(s.__key) || r.push(s));
        while (o === null);
      }
    }
    return i || r.reverse(), r;
  }
  isDirty() {
    let t = Xi()._dirtyLeaves;
    return t !== null && t.has(this.__key);
  }
  getLatest() {
    let t = Mr(this.__key);
    return t === null && $e(113), t;
  }
  getWritable() {
    Cn();
    var t = Js(), i = Xi();
    t = t._nodeMap;
    let r = this.__key, n = this.getLatest(), o = n.__parent;
    i = i._cloneNotNeeded;
    var s = Bi();
    return s !== null && (s._cachedNodes = null), i.has(r) ? (r1(n), n) : (s = n.constructor.clone(n), s.__parent = o, s.__next = n.__next, s.__prev = n.__prev, Ue(n) && Ue(s) ? (s.__first = n.__first, s.__last = n.__last, s.__size = n.__size, s.__indent = n.__indent, s.__format = n.__format, s.__dir = n.__dir) : lt(n) && lt(s) && (s.__format = n.__format, s.__style = n.__style, s.__mode = n.__mode, s.__detail = n.__detail), i.add(r), s.__key = r, r1(s), t.set(r, s), s);
  }
  getTextContent() {
    return "";
  }
  getTextContentSize() {
    return this.getTextContent().length;
  }
  createDOM() {
    $e(70);
  }
  updateDOM() {
    $e(71);
  }
  exportDOM(t) {
    return { element: this.createDOM(t._config, t) };
  }
  exportJSON() {
    $e(72);
  }
  static importJSON() {
    $e(18, this.name);
  }
  static transform() {
    return null;
  }
  remove(t) {
    db(this, !0, t);
  }
  replace(t, i) {
    Cn();
    var r = Bi();
    r !== null && (r = r.clone()), My(this, t);
    let n = this.getLatest(), o = this.__key, s = t.__key, a = t.getWritable();
    t = this.getParentOrThrow().getWritable();
    let l = t.__size;
    kc(a);
    let c = n.getPreviousSibling(), u = n.getNextSibling(), m = n.__prev, g = n.__next, h = n.__parent;
    return db(n, !1, !0), c === null ? t.__first = s : c.getWritable().__next = s, a.__prev = m, u === null ? t.__last = s : u.getWritable().__prev = s, a.__next = g, a.__parent = h, t.__size = l, i && this.getChildren().forEach((A) => {
      a.append(A);
    }), Tt(r) && (Ys(r), i = r.anchor, r = r.focus, i.key === o && Fk(i, a), r.key === o && Fk(r, a)), yl() === o && Wr(s), a;
  }
  insertAfter(t, i = !0) {
    Cn(), My(this, t);
    var r = this.getWritable();
    let n = t.getWritable();
    var o = n.getParent();
    let s = Bi();
    var a = !1, l = !1;
    if (o !== null) {
      var c = t.getIndexWithinParent();
      kc(n), Tt(s) && (l = o.__key, a = s.anchor, o = s.focus, a = a.type === "element" && a.key === l && a.offset === c + 1, l = o.type === "element" && o.key === l && o.offset === c + 1);
    }
    o = this.getNextSibling(), c = this.getParentOrThrow().getWritable();
    let u = n.__key, m = r.__next;
    return o === null ? c.__last = u : o.getWritable().__prev = u, c.__size++, r.__next = u, n.__next = m, n.__prev = r.__key, n.__parent = r.__parent, i && Tt(s) && (i = this.getIndexWithinParent(), c1(s, c, i + 1), r = c.__key, a && s.anchor.set(r, i + 2, "element"), l && s.focus.set(r, i + 2, "element")), t;
  }
  insertBefore(t, i = !0) {
    Cn(), My(this, t);
    var r = this.getWritable();
    let n = t.getWritable(), o = n.__key;
    kc(n);
    let s = this.getPreviousSibling(), a = this.getParentOrThrow().getWritable(), l = r.__prev, c = this.getIndexWithinParent();
    return s === null ? a.__first = o : s.getWritable().__next = o, a.__size++, r.__prev = o, n.__prev = l, n.__next = r.__key, n.__parent = r.__parent, r = Bi(), i && Tt(r) && (i = this.getParentOrThrow(), c1(r, i, c)), t;
  }
  isParentRequired() {
    return !1;
  }
  createParentElementNode() {
    return Lc();
  }
  selectPrevious(t, i) {
    Cn();
    let r = this.getPreviousSibling(), n = this.getParentOrThrow();
    return r === null ? n.select(0, 0) : Ue(r) ? r.select() : lt(r) ? r.select(t, i) : (t = r.getIndexWithinParent() + 1, n.select(t, t));
  }
  selectNext(t, i) {
    Cn();
    let r = this.getNextSibling(), n = this.getParentOrThrow();
    return r === null ? n.select() : Ue(r) ? r.select(0, 0) : lt(r) ? r.select(t, i) : (t = r.getIndexWithinParent(), n.select(t, t));
  }
  markDirty() {
    this.getWritable();
  }
}
class D0 extends fg {
  static getType() {
    return "linebreak";
  }
  static clone(t) {
    return new D0(t.__key);
  }
  constructor(t) {
    super(t);
  }
  getTextContent() {
    return `
`;
  }
  createDOM() {
    return document.createElement("br");
  }
  updateDOM() {
    return !1;
  }
  static importDOM() {
    return { br: (t) => {
      let i = t.parentElement, r, n;
      return i !== null && ((r = i.firstChild) === t || r.nextSibling === t && r.nodeType === 3 && (r.textContent || "").match(/^( |\t|\r?\n)+$/) !== null) && ((n = i.lastChild) === t || n.previousSibling === t && n.nodeType === 3 && (n.textContent || "").match(/^( |\t|\r?\n)+$/) !== null) ? null : { conversion: u9, priority: 0 };
    } };
  }
  static importJSON() {
    return d0();
  }
  exportJSON() {
    return { type: "linebreak", version: 1 };
  }
}
function u9() {
  return { node: d0() };
}
function d0() {
  return pg(new D0());
}
function qm(e) {
  return e instanceof D0;
}
function By(e, t) {
  return t & 16 ? "code" : t & 128 ? "mark" : t & 32 ? "sub" : t & 64 ? "sup" : null;
}
function Dy(e, t) {
  return t & 1 ? "strong" : t & 2 ? "em" : "span";
}
function Oy(e, t, i, r, n) {
  e = r.classList, r = om(n, "base"), r !== void 0 && e.add(...r), r = om(n, "underlineStrikethrough");
  let o = !1, s = t & 8 && t & 4;
  var a = i & 8 && i & 4;
  r !== void 0 && (a ? (o = !0, s || e.add(...r)) : s && e.remove(...r));
  for (let l in Rc)
    a = Rc[l], r = om(n, l), r !== void 0 && (i & a ? !o || l !== "underline" && l !== "strikethrough" ? (!(t & a) || s && l === "underline" || l === "strikethrough") && e.add(...r) : t & a && e.remove(...r) : t & a && e.remove(...r));
}
function Fy(e, t, i) {
  let r = t.firstChild;
  if (i = i.isComposing(), e += i ? H1 : "", r == null)
    t.textContent = e;
  else if (t = r.nodeValue, t !== e)
    if (i || Tl) {
      i = t.length;
      let n = e.length, o = 0, s = 0;
      for (; o < i && o < n && t[o] === e[o]; )
        o++;
      for (; s + o < i && s + o < n && t[i - s - 1] === e[n - s - 1]; )
        s++;
      e = [o, i - o - s, e.slice(o, n - s)];
      let [a, l, c] = e;
      l !== 0 && r.deleteData(a, l), r.insertData(a, c);
    } else
      r.nodeValue = e;
}
function Qh(e, t) {
  return t = document.createElement(t), t.appendChild(e), t;
}
class _c extends fg {
  static getType() {
    return "text";
  }
  static clone(t) {
    return new _c(t.__text, t.__key);
  }
  constructor(t, i) {
    super(i), this.__text = t, this.__format = 0, this.__style = "", this.__detail = this.__mode = 0;
  }
  getFormat() {
    return this.getLatest().__format;
  }
  getDetail() {
    return this.getLatest().__detail;
  }
  getMode() {
    let t = this.getLatest();
    return ZW[t.__mode];
  }
  getStyle() {
    return this.getLatest().__style;
  }
  isToken() {
    return this.getLatest().__mode === 1;
  }
  isComposing() {
    return this.__key === yl();
  }
  isSegmented() {
    return this.getLatest().__mode === 2;
  }
  isDirectionless() {
    return (this.getLatest().__detail & 1) !== 0;
  }
  isUnmergeable() {
    return (this.getLatest().__detail & 2) !== 0;
  }
  hasFormat(t) {
    return t = Rc[t], (this.getFormat() & t) !== 0;
  }
  isSimpleText() {
    return this.__type === "text" && this.__mode === 0;
  }
  getTextContent() {
    return this.getLatest().__text;
  }
  getFormatFlags(t, i) {
    let r = this.getLatest().__format;
    return rT(r, t, i);
  }
  createDOM(t) {
    var i = this.__format, r = By(this, i);
    let n = Dy(this, i), o = document.createElement(r === null ? n : r), s = o;
    return this.hasFormat("code") && o.setAttribute("spellcheck", "false"), r !== null && (s = document.createElement(n), o.appendChild(s)), r = s, Fy(this.__text, r, this), t = t.theme.text, t !== void 0 && Oy(n, 0, i, r, t), i = this.__style, i !== "" && (o.style.cssText = i), o;
  }
  updateDOM(t, i, r) {
    let n = this.__text;
    var o = t.__format, s = this.__format, a = By(this, o);
    let l = By(this, s);
    var c = Dy(this, o);
    let u = Dy(this, s);
    return (a === null ? c : a) !== (l === null ? u : l) ? !0 : a === l && c !== u ? (o = i.firstChild, o == null && $e(48), t = a = document.createElement(u), Fy(n, t, this), r = r.theme.text, r !== void 0 && Oy(u, 0, s, t, r), i.replaceChild(a, o), !1) : (c = i, l !== null && a !== null && (c = i.firstChild, c == null && $e(49)), Fy(n, c, this), r = r.theme.text, r !== void 0 && o !== s && Oy(u, o, s, c, r), s = this.__style, t.__style !== s && (i.style.cssText = s), !1);
  }
  static importDOM() {
    return {
      "#text": () => ({ conversion: g9, priority: 0 }),
      b: () => ({ conversion: m9, priority: 0 }),
      code: () => ({ conversion: Ha, priority: 0 }),
      em: () => ({ conversion: Ha, priority: 0 }),
      i: () => ({ conversion: Ha, priority: 0 }),
      s: () => ({ conversion: Ha, priority: 0 }),
      span: () => ({ conversion: d9, priority: 0 }),
      strong: () => ({ conversion: Ha, priority: 0 }),
      sub: () => ({ conversion: Ha, priority: 0 }),
      sup: () => ({ conversion: Ha, priority: 0 }),
      u: () => ({ conversion: Ha, priority: 0 })
    };
  }
  static importJSON(t) {
    let i = wr(t.text);
    return i.setFormat(t.format), i.setDetail(t.detail), i.setMode(t.mode), i.setStyle(t.style), i;
  }
  exportDOM(t) {
    return { element: t } = super.exportDOM(t), t !== null && $1(t) || $e(132), t.style.whiteSpace = "pre-wrap", this.hasFormat("bold") && (t = Qh(t, "b")), this.hasFormat("italic") && (t = Qh(t, "i")), this.hasFormat("strikethrough") && (t = Qh(t, "s")), this.hasFormat("underline") && (t = Qh(t, "u")), { element: t };
  }
  exportJSON() {
    return {
      detail: this.getDetail(),
      format: this.getFormat(),
      mode: this.getMode(),
      style: this.getStyle(),
      text: this.getTextContent(),
      type: "text",
      version: 1
    };
  }
  selectionTransform() {
  }
  setFormat(t) {
    let i = this.getWritable();
    return i.__format = typeof t == "string" ? Rc[t] : t, i;
  }
  setDetail(t) {
    let i = this.getWritable();
    return i.__detail = typeof t == "string" ? GW[t] : t, i;
  }
  setStyle(t) {
    let i = this.getWritable();
    return i.__style = t, i;
  }
  toggleFormat(t) {
    return t = Rc[t], this.setFormat(this.getFormat() ^ t);
  }
  toggleDirectionless() {
    let t = this.getWritable();
    return t.__detail ^= 1, t;
  }
  toggleUnmergeable() {
    let t = this.getWritable();
    return t.__detail ^= 2, t;
  }
  setMode(t) {
    if (t = WW[t], this.__mode === t)
      return this;
    let i = this.getWritable();
    return i.__mode = t, i;
  }
  setTextContent(t) {
    if (this.__text === t)
      return this;
    let i = this.getWritable();
    return i.__text = t, i;
  }
  select(t, i) {
    Cn();
    let r = Bi();
    var n = this.getTextContent();
    let o = this.__key;
    if (typeof n == "string" ? (n = n.length, t === void 0 && (t = n), i === void 0 && (i = n)) : i = t = 0, Tt(r))
      n = yl(), n !== r.anchor.key && n !== r.focus.key || Wr(o), r.setTextNodeRange(this, t, this, i);
    else
      return DT(o, t, o, i, "text", "text");
    return r;
  }
  spliceText(t, i, r, n) {
    let o = this.getWritable(), s = o.__text, a = r.length, l = t;
    0 > l && (l = a + l, 0 > l && (l = 0));
    let c = Bi();
    return n && Tt(c) && (t += a, c.setTextNodeRange(o, t, o, t)), i = s.slice(0, l) + r + s.slice(l + i), o.__text = i, o;
  }
  canInsertTextBefore() {
    return !0;
  }
  canInsertTextAfter() {
    return !0;
  }
  splitText(...t) {
    Cn();
    var i = this.getLatest(), r = i.getTextContent(), n = i.__key, o = yl(), s = new Set(t);
    t = [];
    for (var a = r.length, l = "", c = 0; c < a; c++)
      l !== "" && s.has(c) && (t.push(l), l = ""), l += r[c];
    if (l !== "" && t.push(l), s = t.length, s === 0)
      return [];
    if (t[0] === r)
      return [i];
    var u = t[0];
    r = i.getParentOrThrow(), c = i.getFormat();
    let m = i.getStyle(), g = i.__detail;
    a = !1, i.isSegmented() ? (l = wr(u), l.__format = c, l.__style = m, l.__detail = g, a = !0) : (l = i.getWritable(), l.__text = u), i = Bi(), l = [l], u = u.length;
    for (let y = 1; y < s; y++) {
      var h = t[y], A = h.length;
      h = wr(h).getWritable(), h.__format = c, h.__style = m, h.__detail = g;
      let E = h.__key;
      if (A = u + A, Tt(i)) {
        let v = i.anchor, C = i.focus;
        v.key === n && v.type === "text" && v.offset > u && v.offset <= A && (v.key = E, v.offset -= u, i.dirty = !0), C.key === n && C.type === "text" && C.offset > u && C.offset <= A && (C.key = E, C.offset -= u, i.dirty = !0);
      }
      o === n && Wr(E), u = A, l.push(h);
    }
    return n = this.getPreviousSibling(), o = this.getNextSibling(), n !== null && r1(n), o !== null && r1(o), n = r.getWritable(), o = this.getIndexWithinParent(), a ? (n.splice(o, 0, l), this.remove()) : n.splice(o, 1, l), Tt(i) && c1(i, r, o, s - 1), l;
  }
  mergeWithSibling(t) {
    var i = t === this.getPreviousSibling();
    i || t === this.getNextSibling() || $e(50);
    var r = this.__key;
    let n = t.__key, o = this.__text, s = o.length;
    yl() === n && Wr(r);
    let a = Bi();
    if (Tt(a)) {
      let l = a.anchor, c = a.focus;
      l !== null && l.key === n && (Uk(l, i, r, t, s), a.dirty = !0), c !== null && c.key === n && (Uk(c, i, r, t, s), a.dirty = !0);
    }
    return r = t.__text, this.setTextContent(i ? r + o : o + r), i = this.getWritable(), t.remove(), i;
  }
  isTextEntity() {
    return !1;
  }
}
function d9(e) {
  let t = e.style.fontWeight === "700", i = e.style.textDecoration === "line-through", r = e.style.fontStyle === "italic", n = e.style.textDecoration === "underline", o = e.style.verticalAlign;
  return { forChild: (s) => (lt(s) && (t && s.toggleFormat("bold"), i && s.toggleFormat("strikethrough"), r && s.toggleFormat("italic"), n && s.toggleFormat("underline"), o === "sub" && s.toggleFormat("subscript"), o === "super" && s.toggleFormat("superscript")), s), node: null };
}
function m9(e) {
  let t = e.style.fontWeight === "normal";
  return { forChild: (i) => (lt(i) && !t && i.toggleFormat("bold"), i), node: null };
}
let Dk = /* @__PURE__ */ new WeakMap();
function g9(e) {
  e.parentElement === null && $e(129);
  for (var t = e.textContent || "", i, r = e.parentNode, n = [e]; r !== null && (i = Dk.get(r)) === void 0 && !(r.nodeName === "PRE" || r.nodeType === 1 && r.style.whiteSpace.startsWith("pre")); )
    n.push(r), r = r.parentNode;
  for (i = i === void 0 ? r : i, r = 0; r < n.length; r++)
    Dk.set(n[r], i);
  if (i !== null) {
    for (t = t.split(/(\r?\n|\t)/), e = [], n = t.length, i = 0; i < n; i++)
      r = t[i], r === `
` || r === `\r
` ? e.push(d0()) : r === "	" ? e.push(tf()) : r !== "" && e.push(wr(r));
    return { node: e };
  }
  if (t = t.replace(/\r/g, "").replace(/[ \t\n]+/g, " "), t === "")
    return { node: null };
  if (t[0] === " ") {
    for (n = e, i = !0; n !== null && (n = Ok(n, !1)) !== null; )
      if (r = n.textContent || "", 0 < r.length) {
        /[ \t\n]$/.test(r) && (t = t.slice(1)), i = !1;
        break;
      }
    i && (t = t.slice(1));
  }
  if (t[t.length - 1] === " ") {
    for (n = !0; e !== null && (e = Ok(e, !0)) !== null; )
      if (0 < (e.textContent || "").replace(/^( |\t|\r?\n)+/, "").length) {
        n = !1;
        break;
      }
    n && (t = t.slice(0, t.length - 1));
  }
  return t === "" ? { node: null } : { node: wr(t) };
}
let h9 = new RegExp(/^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/, "i");
function Ok(e, t) {
  for (; ; ) {
    for (var i = void 0; (i = t ? e.nextSibling : e.previousSibling) === null; )
      if (e = e.parentElement, e === null)
        return null;
    if (e = i, e.nodeType === 1 && (i = e.style.display, i === "" && e.nodeName.match(h9) === null || i !== "" && !i.startsWith("inline")))
      return null;
    for (; (i = t ? e.firstChild : e.lastChild) !== null; )
      e = i;
    if (e.nodeType === 3)
      return e;
    if (e.nodeName === "BR")
      return null;
  }
}
let p9 = { code: "code", em: "italic", i: "italic", s: "strikethrough", strong: "bold", sub: "subscript", sup: "superscript", u: "underline" };
function Ha(e) {
  let t = p9[e.nodeName.toLowerCase()];
  return t === void 0 ? { node: null } : { forChild: (i) => (lt(i) && !i.hasFormat(t) && i.toggleFormat(t), i), node: null };
}
function wr(e = "") {
  return pg(new _c(e));
}
function lt(e) {
  return e instanceof _c;
}
class O0 extends _c {
  static getType() {
    return "tab";
  }
  static clone(t) {
    let i = new O0(t.__key);
    return i.__text = t.__text, i.__format = t.__format, i.__style = t.__style, i;
  }
  constructor(t) {
    super("	", t), this.__detail = 2;
  }
  static importDOM() {
    return null;
  }
  static importJSON(t) {
    let i = tf();
    return i.setFormat(t.format), i.setStyle(t.style), i;
  }
  exportJSON() {
    return ee(q({}, super.exportJSON()), { type: "tab", version: 1 });
  }
  setTextContent() {
    $e(126);
  }
  setDetail() {
    $e(127);
  }
  setMode() {
    $e(128);
  }
  canInsertTextBefore() {
    return !1;
  }
  canInsertTextAfter() {
    return !1;
  }
}
function tf() {
  return pg(new O0());
}
let Us = class {
  constructor(t, i, r) {
    this._selection = null, this.key = t, this.offset = i, this.type = r;
  }
  is(t) {
    return this.key === t.key && this.offset === t.offset && this.type === t.type;
  }
  isBefore(t) {
    let i = this.getNode(), r = t.getNode(), n = this.offset;
    if (t = t.offset, Ue(i)) {
      var o = i.getDescendantByIndex(n);
      i = o != null ? o : i;
    }
    return Ue(r) && (o = r.getDescendantByIndex(t), r = o != null ? o : r), i === r ? n < t : i.isBefore(r);
  }
  getNode() {
    let t = Mr(this.key);
    return t === null && $e(20), t;
  }
  set(t, i, r) {
    let n = this._selection, o = this.key;
    this.key = t, this.offset = i, this.type = r, q0() || (yl() === o && Wr(t), n !== null && (n._cachedNodes = null, n.dirty = !0));
  }
};
function Vy(e, t) {
  let i = t.__key, r = e.offset, n = "element";
  if (lt(t))
    n = "text", t = t.getTextContentSize(), r > t && (r = t);
  else if (!Ue(t)) {
    var o = t.getNextSibling();
    lt(o) ? (i = o.__key, r = 0, n = "text") : (o = t.getParent()) && (i = o.__key, r = t.getIndexWithinParent() + 1);
  }
  e.set(i, r, n);
}
function Fk(e, t) {
  if (Ue(t)) {
    let i = t.getLastDescendant();
    Ue(i) || lt(i) ? Vy(e, i) : Vy(e, t);
  } else
    Vy(e, t);
}
function Vk(e, t, i, r) {
  let n = e.getNode(), o = n.getChildAtIndex(e.offset), s = wr(), a = xn(n) ? Lc().append(s) : s;
  s.setFormat(i), s.setStyle(r), o === null ? n.append(a) : (o.insertBefore(a), t.type === "element" && t.key === e.key && t.offset !== e.offset && t.set(t.key, t.offset + 1, "element")), e.is(t) && t.set(s.__key, 0, "text"), e.set(s.__key, 0, "text");
}
function gl(e, t, i, r) {
  e.key = t, e.offset = i, e.type = r;
}
class rf {
  constructor(t) {
    this.dirty = !1, this._nodes = t, this._cachedNodes = null;
  }
  is(t) {
    if (!F0(t))
      return !1;
    let i = this._nodes, r = t._nodes;
    return i.size === r.size && Array.from(i).every((n) => r.has(n));
  }
  add(t) {
    this.dirty = !0, this._nodes.add(t), this._cachedNodes = null;
  }
  delete(t) {
    this.dirty = !0, this._nodes.delete(t), this._cachedNodes = null;
  }
  clear() {
    this.dirty = !0, this._nodes.clear(), this._cachedNodes = null;
  }
  has(t) {
    return this._nodes.has(t);
  }
  clone() {
    return new rf(new Set(this._nodes));
  }
  extract() {
    return this.getNodes();
  }
  insertRawText() {
  }
  insertText() {
  }
  insertNodes(t, i) {
    let r = this.getNodes(), n = r.length;
    var o = r[n - 1];
    if (lt(o))
      o = o.select();
    else {
      let s = o.getIndexWithinParent() + 1;
      o = o.getParentOrThrow().select(s, s);
    }
    for (o.insertNodes(t, i), t = 0; t < n; t++)
      r[t].remove();
    return !0;
  }
  getNodes() {
    var t = this._cachedNodes;
    if (t !== null)
      return t;
    var i = this._nodes;
    t = [];
    for (let r of i)
      i = Mr(r), i !== null && t.push(i);
    return q0() || (this._cachedNodes = t), t;
  }
  getTextContent() {
    let t = this.getNodes(), i = "";
    for (let r = 0; r < t.length; r++)
      i += t[r].getTextContent();
    return i;
  }
}
function Tt(e) {
  return e instanceof Ag;
}
function mb(e) {
  let [t, , i] = FT(e);
  e = i.getChildren();
  let r = e.length;
  var n = e[0].getChildren().length;
  let o = Array(r);
  for (var s = 0; s < r; s++)
    o[s] = Array(n);
  for (n = 0; n < r; n++) {
    s = e[n].getChildren();
    let a = 0;
    for (let l = 0; l < s.length; l++) {
      for (; o[n][a]; )
        a++;
      let c = s[l], u = c.__rowSpan || 1, m = c.__colSpan || 1;
      for (let g = 0; g < u; g++)
        for (let h = 0; h < m; h++)
          o[n + g][a + h] = c;
      if (t === c)
        return { colSpan: m, columnIndex: a, rowIndex: n, rowSpan: u };
      a += m;
    }
  }
  return null;
}
let wT = class MT {
  constructor(t, i, r) {
    this.gridKey = t, this.anchor = i, this.focus = r, this.dirty = !1, this._cachedNodes = null, i._selection = this, r._selection = this;
  }
  is(t) {
    return i2(t) ? this.gridKey === t.gridKey && this.anchor.is(t.anchor) && this.focus.is(t.focus) : !1;
  }
  set(t, i, r) {
    this.dirty = !0, this.gridKey = t, this.anchor.key = i, this.focus.key = r, this._cachedNodes = null;
  }
  clone() {
    return new MT(this.gridKey, this.anchor, this.focus);
  }
  isCollapsed() {
    return !1;
  }
  isBackward() {
    return this.focus.isBefore(this.anchor);
  }
  getCharacterOffsets() {
    return jp(this);
  }
  extract() {
    return this.getNodes();
  }
  insertRawText() {
  }
  insertText() {
  }
  insertNodes(t, i) {
    let r = this.focus.getNode();
    return PC(r.select(0, r.getChildrenSize())).insertNodes(t, i);
  }
  getShape() {
    var t = Mr(this.anchor.key);
    if (qo(t) || $e(103), t = mb(t), t === null)
      throw Error("getCellRect: expected to find AnchorNode");
    var i = Mr(this.focus.key);
    qo(i) || $e(104);
    let r = mb(i);
    if (r === null)
      throw Error("getCellRect: expected to find focusCellNode");
    i = Math.min(t.columnIndex, r.columnIndex);
    let n = Math.max(t.columnIndex, r.columnIndex), o = Math.min(t.rowIndex, r.rowIndex);
    return t = Math.max(t.rowIndex, r.rowIndex), { fromX: Math.min(
      i,
      n
    ), fromY: Math.min(o, t), toX: Math.max(i, n), toY: Math.max(o, t) };
  }
  getNodes() {
    function t(E) {
      let { cell: v, startColumn: C, startRow: x } = E;
      l = Math.min(l, C), c = Math.min(c, x), u = Math.max(u, C + v.__colSpan - 1), m = Math.max(m, x + v.__rowSpan - 1);
    }
    var i = this._cachedNodes;
    if (i !== null)
      return i;
    var r = this.anchor.getNode();
    i = this.focus.getNode(), r = a1(r, qo);
    var n = a1(i, qo);
    qo(r) || $e(103), qo(n) || $e(104), i = r.getParent(), Lm(i) || $e(105), i = i.getParent(), a2(i) || $e(106);
    let [o, s, a] = OT(i, r, n), l = Math.min(s.startColumn, a.startColumn), c = Math.min(
      s.startRow,
      a.startRow
    ), u = Math.max(s.startColumn + s.cell.__colSpan - 1, a.startColumn + a.cell.__colSpan - 1), m = Math.max(s.startRow + s.cell.__rowSpan - 1, a.startRow + a.cell.__rowSpan - 1);
    r = l, n = c;
    for (var g = l, h = c; l < r || c < n || u > g || m > h; ) {
      if (l < r) {
        var A = h - n;
        --r;
        for (var y = 0; y <= A; y++)
          t(o[n + y][r]);
      }
      if (c < n)
        for (A = g - r, --n, y = 0; y <= A; y++)
          t(o[n][r + y]);
      if (u > g)
        for (A = h - n, g += 1, y = 0; y <= A; y++)
          t(o[n + y][g]);
      if (m > h)
        for (A = g - r, h += 1, y = 0; y <= A; y++)
          t(o[h][r + y]);
    }
    for (i = [i], r = null, n = c; n <= m; n++)
      for (g = l; g <= u; g++)
        ({ cell: h } = o[n][g]), A = h.getParent(), Lm(A) || $e(107), A !== r && i.push(A), i.push(h, ...$W(h)), r = A;
    return q0() || (this._cachedNodes = i), i;
  }
  getTextContent() {
    let t = this.getNodes(), i = "";
    for (let r = 0; r < t.length; r++)
      i += t[r].getTextContent();
    return i;
  }
};
function i2(e) {
  return e instanceof wT;
}
let Ag = class NT {
  constructor(t, i, r, n) {
    this.anchor = t, this.focus = i, this.dirty = !1, this.format = r, this.style = n, this._cachedNodes = null, t._selection = this, i._selection = this;
  }
  is(t) {
    return Tt(t) ? this.anchor.is(t.anchor) && this.focus.is(t.focus) && this.format === t.format && this.style === t.style : !1;
  }
  isBackward() {
    return this.focus.isBefore(this.anchor);
  }
  isCollapsed() {
    return this.anchor.is(this.focus);
  }
  getNodes() {
    var t = this._cachedNodes;
    if (t !== null)
      return t;
    t = this.anchor;
    var i = this.focus, r = t.isBefore(i), n = r ? t : i;
    r = r ? i : t, t = n.getNode(), i = r.getNode();
    let o = n.offset;
    return n = r.offset, Ue(t) && (r = t.getDescendantByIndex(o), t = r != null ? r : t), Ue(i) && (r = i.getDescendantByIndex(n), r !== null && r !== t && i.getChildAtIndex(n) === r && (r = r.getPreviousSibling()), i = r != null ? r : i), t = t.is(i) ? Ue(t) && 0 < t.getChildrenSize() ? [] : [t] : t.getNodesBetween(i), q0() || (this._cachedNodes = t), t;
  }
  setTextNodeRange(t, i, r, n) {
    gl(this.anchor, t.__key, i, "text"), gl(this.focus, r.__key, n, "text"), this._cachedNodes = null, this.dirty = !0;
  }
  getTextContent() {
    let t = this.getNodes();
    if (t.length === 0)
      return "";
    let i = t[0], r = t[t.length - 1], n = this.anchor, o = this.focus, s = n.isBefore(o), [a, l] = jp(this), c = "", u = !0;
    for (let m = 0; m < t.length; m++) {
      let g = t[m];
      if (Ue(g) && !g.isInline())
        u || (c += `
`), u = !g.isEmpty();
      else if (u = !1, lt(g)) {
        let h = g.getTextContent();
        g === i ? g === r ? (n.type !== "element" || o.type !== "element" || o.offset === n.offset) && (h = a < l ? h.slice(a, l) : h.slice(l, a)) : h = s ? h.slice(a) : h.slice(l) : g === r && (h = s ? h.slice(0, l) : h.slice(0, a)), c += h;
      } else
        !Ti(g) && !qm(g) || g === r && this.isCollapsed() || (c += g.getTextContent());
    }
    return c;
  }
  applyDOMRange(t) {
    let i = Xi(), r = i.getEditorState()._selection;
    if (t = BT(t.startContainer, t.startOffset, t.endContainer, t.endOffset, i, r), t !== null) {
      var [n, o] = t;
      gl(this.anchor, n.key, n.offset, n.type), gl(this.focus, o.key, o.offset, o.type), this._cachedNodes = null;
    }
  }
  clone() {
    let t = this.anchor, i = this.focus;
    return new NT(new Us(t.key, t.offset, t.type), new Us(i.key, i.offset, i.type), this.format, this.style);
  }
  toggleFormat(t) {
    this.format = rT(this.format, t, null), this.dirty = !0;
  }
  setStyle(t) {
    this.style = t, this.dirty = !0;
  }
  hasFormat(t) {
    return (this.format & Rc[t]) !== 0;
  }
  insertRawText(t) {
    t = t.split(/(\r?\n|\t)/);
    let i = [], r = t.length;
    for (let n = 0; n < r; n++) {
      let o = t[n];
      o === `
` || o === `\r
` ? i.push(d0()) : o === "	" ? i.push(tf()) : i.push(wr(o));
    }
    this.insertNodes(i);
  }
  insertText(t) {
    var i = this.anchor, r = this.focus, n = this.isCollapsed() || i.isBefore(r), o = this.format, s = this.style;
    n && i.type === "element" ? Vk(i, r, o, s) : n || r.type !== "element" || Vk(r, i, o, s);
    var a = this.getNodes(), l = a.length, c = n ? r : i;
    r = (n ? i : r).offset;
    var u = c.offset;
    i = a[0], lt(i) || $e(26), n = i.getTextContent().length;
    var m = i.getParentOrThrow(), g = a[l - 1];
    if (this.isCollapsed() && r === n && (i.isSegmented() || i.isToken() || !i.canInsertTextAfter() || !m.canInsertTextAfter() && i.getNextSibling() === null)) {
      var h = i.getNextSibling();
      if (lt(h) && h.canInsertTextBefore() && !_v(h) || (h = wr(), h.setFormat(o), m.canInsertTextAfter() ? i.insertAfter(h) : m.insertAfter(h)), h.select(0, 0), i = h, t !== "") {
        this.insertText(t);
        return;
      }
    } else if (this.isCollapsed() && r === 0 && (i.isSegmented() || i.isToken() || !i.canInsertTextBefore() || !m.canInsertTextBefore() && i.getPreviousSibling() === null)) {
      if (h = i.getPreviousSibling(), (!lt(h) || _v(h)) && (h = wr(), h.setFormat(o), m.canInsertTextBefore() ? i.insertBefore(h) : m.insertBefore(h)), h.select(), i = h, t !== "") {
        this.insertText(t);
        return;
      }
    } else if (i.isSegmented() && r !== n)
      m = wr(i.getTextContent()), m.setFormat(o), i.replace(m), i = m;
    else if (!(this.isCollapsed() || t === "" || (h = g.getParent(), m.canInsertTextBefore() && m.canInsertTextAfter() && (!Ue(h) || h.canInsertTextBefore() && h.canInsertTextAfter())))) {
      this.insertText(""), TT(this.anchor, this.focus, null), this.insertText(t);
      return;
    }
    if (l === 1)
      if (i.isToken())
        t = wr(t), t.select(), i.replace(t);
      else {
        if (a = i.getFormat(), l = i.getStyle(), r === u && (a !== o || l !== s))
          if (i.getTextContent() === "")
            i.setFormat(o), i.setStyle(s);
          else {
            a = wr(t), a.setFormat(o), a.setStyle(s), a.select(), r === 0 ? i.insertBefore(a, !1) : ([l] = i.splitText(r), l.insertAfter(a, !1)), a.isComposing() && this.anchor.type === "text" && (this.anchor.offset -= t.length);
            return;
          }
        i = i.spliceText(r, u - r, t, !0), i.getTextContent() === "" ? i.remove() : this.anchor.type === "text" && (i.isComposing() ? this.anchor.offset -= t.length : (this.format = a, this.style = l));
      }
    else {
      if (o = /* @__PURE__ */ new Set([...i.getParentKeys(), ...g.getParentKeys()]), h = Ue(i) ? i : i.getParentOrThrow(), s = Ue(g) ? g : g.getParentOrThrow(), m = g, !h.is(s) && s.isInline())
        do
          m = s, s = s.getParentOrThrow();
        while (s.isInline());
      if (c.type === "text" && (u !== 0 || g.getTextContent() === "") || c.type === "element" && g.getIndexWithinParent() < u)
        if (lt(g) && !g.isToken() && u !== g.getTextContentSize()) {
          if (g.isSegmented()) {
            var A = wr(g.getTextContent());
            g.replace(A), g = A;
          }
          xn(c.getNode()) || (g = g.spliceText(0, u, "")), o.add(g.__key);
        } else
          c = g.getParentOrThrow(), c.canBeEmpty() || c.getChildrenSize() !== 1 ? g.remove() : c.remove();
      else
        o.add(g.__key);
      for (c = s.getChildren(), u = new Set(a), g = h.is(s), h = h.isInline() && i.getNextSibling() === null ? h : i, A = c.length - 1; 0 <= A; A--) {
        let y = c[A];
        if (y.is(i) || Ue(y) && y.isParentOf(i))
          break;
        y.isAttached() && (!u.has(y) || y.is(m) ? g || h.insertAfter(y, !1) : y.remove());
      }
      if (!g)
        for (c = s, u = null; c !== null; )
          s = c.getChildren(), g = s.length, (g === 0 || s[g - 1].is(u)) && (o.delete(c.__key), u = c), c = c.getParent();
      for (i.isToken() ? r === n ? i.select() : (t = wr(t), t.select(), i.replace(t)) : (i = i.spliceText(r, n - r, t, !0), i.getTextContent() === "" ? i.remove() : i.isComposing() && this.anchor.type === "text" && (this.anchor.offset -= t.length)), t = 1; t < l; t++)
        i = a[t], o.has(i.__key) || i.remove();
    }
  }
  removeText() {
    this.insertText("");
  }
  formatText(t) {
    if (this.isCollapsed())
      this.toggleFormat(t), Wr(null);
    else {
      var i = this.getNodes(), r = [];
      for (var n of i)
        lt(n) && r.push(n);
      var o = r.length;
      if (o === 0)
        this.toggleFormat(t), Wr(null);
      else {
        n = this.anchor;
        var s = this.focus, a = this.isBackward();
        i = a ? s : n, n = a ? n : s;
        var l = 0, c = r[0];
        if (s = i.type === "element" ? 0 : i.offset, i.type === "text" && s === c.getTextContentSize() && (l = 1, c = r[1], s = 0), c != null) {
          a = c.getFormatFlags(t, null);
          var u = o - 1, m = r[u];
          if (o = n.type === "text" ? n.offset : m.getTextContentSize(), c.is(m))
            s !== o && (s === 0 && o === c.getTextContentSize() ? c.setFormat(a) : (t = c.splitText(s, o), t = s === 0 ? t[0] : t[1], t.setFormat(a), i.type === "text" && i.set(t.__key, 0, "text"), n.type === "text" && n.set(t.__key, o - s, "text")), this.format = a);
          else {
            s !== 0 && ([, c] = c.splitText(s), s = 0), c.setFormat(a);
            var g = m.getFormatFlags(t, a);
            for (0 < o && (o !== m.getTextContentSize() && ([m] = m.splitText(o)), m.setFormat(g)), l += 1; l < u; l++) {
              let h = r[l];
              if (!h.isToken()) {
                let A = h.getFormatFlags(t, g);
                h.setFormat(A);
              }
            }
            i.type === "text" && i.set(c.__key, s, "text"), n.type === "text" && n.set(m.__key, o, "text"), this.format = a | g;
          }
        }
      }
    }
  }
  insertNodes(t, i) {
    if (!this.isCollapsed()) {
      var r = this.isBackward() ? this.anchor : this.focus, n = r.getNode().getNextSibling();
      if (n = n ? n.getKey() : null, r = (r = r.getNode().getPreviousSibling()) ? r.getKey() : null, this.removeText(), this.isCollapsed() && this.focus.type === "element") {
        if (this.focus.key === n && this.focus.offset === 0) {
          var o = wr();
          this.focus.getNode().insertBefore(o);
        } else
          this.focus.key === r && this.focus.offset === this.focus.getNode().getChildrenSize() && (o = wr(), this.focus.getNode().insertAfter(o));
        o && (this.focus.set(o.__key, 0, "text"), this.anchor.set(o.__key, 0, "text"));
      }
    }
    o = this.anchor, r = o.offset;
    var s = o.getNode();
    n = s, o.type === "element" && (o = o.getNode(), n = o.getChildAtIndex(r - 1), n = n === null ? o : n), o = [];
    var a = s.getNextSiblings(), l = us(s) ? null : s.getTopLevelElementOrThrow();
    if (lt(s))
      if (n = s.getTextContent().length, r === 0 && n !== 0)
        n = s.getPreviousSibling(), n = n !== null ? n : s.getParentOrThrow(), o.push(s);
      else if (r === n)
        n = s;
      else {
        if (s.isToken())
          return !1;
        [n, s] = s.splitText(r), o.push(s);
      }
    s = n, o.push(...a), a = t[0];
    var c = !1, u = null;
    for (let A = 0; A < t.length; A++) {
      var m = t[A];
      if (us(n) || Ti(n) || !Ue(m) || m.isInline())
        c && !Ue(m) && !Ti(m) && us(n.getParent()) && $e(28);
      else {
        if (m.is(a)) {
          if (Ue(n) && n.isEmpty() && n.canReplaceWith(m)) {
            n.replace(m), n = m, c = !0;
            continue;
          }
          if (c = m.getFirstDescendant(), nT(c)) {
            for (var g = c.getParentOrThrow(); g.isInline(); )
              g = g.getParentOrThrow();
            if (u = g.getChildren(), c = u.length, Ue(n)) {
              var h = n.getFirstChild();
              for (let y = 0; y < c; y++) {
                let E = u[y];
                h === null ? n.append(E) : h.insertAfter(E), h = E;
              }
            } else {
              for (h = c - 1; 0 <= h; h--)
                n.insertAfter(u[h]);
              n = n.getParentOrThrow();
            }
            if (u = u[c - 1], g.remove(), c = !0, g.is(m))
              continue;
          }
        }
        lt(n) && (l === null && $e(27), n = l);
      }
      c = !1, Ue(n) && !n.isInline() ? (u = m, Ti(m) && !m.isInline() ? n = t.length === 1 && n.canBeEmpty() && n.isEmpty() ? n.insertBefore(m, !1) : n.insertAfter(m, !1) : Ue(m) ? (m.canBeEmpty() || !m.isEmpty()) && (xn(n) ? (g = n.getChildAtIndex(r), g !== null ? g.insertBefore(m) : n.append(m), n = m) : m.isInline() ? (n.append(m), n = m) : n = n.insertAfter(m, !1)) : (g = n.getFirstChild(), g !== null ? g.insertBefore(m) : n.append(m), n = m)) : !Ue(m) || Ue(m) && m.isInline() || Ti(n) && !n.isInline() ? (u = m, Tt(this) && Ti(m) && (Ue(n) || lt(n)) && !m.isInline() ? (lt(n) ? (g = n.getParentOrThrow(), [n] = n.splitText(r), n = n.getIndexWithinParent() + 1) : (g = n, n = r), [, n] = gT(g, n), n = n.insertBefore(m)) : n = n.insertAfter(m, !1)) : (m = n.getParentOrThrow(), qm(n) && n.remove(), n = m, A--);
    }
    if (i && (lt(s) ? s.select() : (t = n.getPreviousSibling(), lt(t) ? t.select() : (t = n.getIndexWithinParent(), n.getParentOrThrow().select(t, t)))), Ue(n)) {
      if (t = lt(u) ? u : Ue(u) && u.isInline() ? u.getLastDescendant() : n.getLastDescendant(), i || (t === null ? n.select() : lt(t) ? t.getTextContent() === "" ? t.selectPrevious() : t.select() : t.selectNext()), o.length !== 0)
        for (i = n, t = o.length - 1; 0 <= t; t--)
          r = o[t], l = r.getParentOrThrow(), !Ue(n) || gb(r) || Ti(r) && (!r.isInline() || r.isIsolated()) ? Ue(n) || gb(r) ? Ue(r) && !r.canInsertAfter(n) ? (s = l.constructor.clone(l), Ue(s) || $e(29), s.append(r), n.insertAfter(s)) : n.insertAfter(r) : (n.insertBefore(r), n = r) : (i === n ? n.append(r) : n.insertBefore(r), n = r), l.isEmpty() && !l.canBeEmpty() && l.remove();
    } else
      i || (lt(n) ? n.select() : (i = n.getParentOrThrow(), t = n.getIndexWithinParent() + 1, i.select(t, t)));
    return !0;
  }
  insertParagraph() {
    this.isCollapsed() || this.removeText();
    var t = this.anchor, i = t.offset, r = [];
    if (t.type === "text") {
      var n = t.getNode(), o = n.getNextSiblings().reverse(), s = n.getParentOrThrow(), a = s.isInline(), l = a ? s.getTextContentSize() : n.getTextContentSize();
      i === 0 ? o.push(n) : (a && (r = s.getNextSiblings()), i === l || a && i === n.getTextContentSize() || ([, n] = n.splitText(i), o.push(n)));
    } else {
      if (s = t.getNode(), us(s)) {
        o = Lc(), r = s.getChildAtIndex(i), o.select(), r !== null ? r.insertBefore(o, !1) : s.append(o);
        return;
      }
      o = s.getChildren().slice(i).reverse();
    }
    if (n = o.length, i === 0 && 0 < n && s.isInline()) {
      if (r = s.getParentOrThrow(), o = r.insertNewAfter(this, !1), Ue(o))
        for (r = r.getChildren(), s = 0; s < r.length; s++)
          o.append(r[s]);
    } else if (a = s.insertNewAfter(this, !1), a === null)
      this.insertLineBreak();
    else if (Ue(a))
      if (l = s.getFirstChild(), i === 0 && (s.is(t.getNode()) || l && l.is(t.getNode())) && 0 < n)
        s.insertBefore(a);
      else {
        if (s = null, i = r.length, t = a.getParentOrThrow(), 0 < i)
          for (l = 0; l < i; l++)
            t.append(r[l]);
        if (n !== 0)
          for (r = 0; r < n; r++)
            i = o[r], s === null ? a.append(i) : s.insertBefore(i), s = i;
        a.canBeEmpty() || a.getChildrenSize() !== 0 ? a.selectStart() : (a.selectPrevious(), a.remove());
      }
  }
  insertLineBreak(t) {
    let i = d0();
    var r = this.anchor;
    r.type === "element" && (r = r.getNode(), xn(r) && this.insertParagraph()), t ? this.insertNodes([i], !0) : this.insertNodes([i]) && i.selectNext(0, 0);
  }
  getCharacterOffsets() {
    return jp(this);
  }
  extract() {
    var t = this.getNodes(), i = t.length, r = i - 1, n = this.anchor;
    let o = this.focus;
    var s = t[0];
    let a = t[r], [l, c] = jp(this);
    return i === 0 ? [] : i === 1 ? lt(s) && !this.isCollapsed() ? (t = l > c ? c : l, r = s.splitText(t, l > c ? l : c), t = t === 0 ? r[0] : r[1], t != null ? [t] : []) : [s] : (i = n.isBefore(o), lt(s) && (n = i ? l : c, n === s.getTextContentSize() ? t.shift() : n !== 0 && ([, s] = s.splitText(n), t[0] = s)), lt(a) && (s = a.getTextContent().length, i = i ? c : l, i === 0 ? t.pop() : i !== s && ([a] = a.splitText(i), t[r] = a)), t);
  }
  modify(t, i, r) {
    var n = this.focus, o = this.anchor, s = t === "move", a = $v(n, i);
    if (Ti(a) && !a.isIsolated())
      s && a.isKeyboardSelectable() ? (i = hb(), i.add(a.__key), Ys(i)) : (t = i ? a.getPreviousSibling() : a.getNextSibling(), lt(t) ? (a = t.__key, i = i ? t.getTextContent().length : 0, n.set(a, i, "text"), s && o.set(a, i, "text")) : (r = a.getParentOrThrow(), Ue(t) ? (r = t.__key, a = i ? t.getChildrenSize() : 0) : (a = a.getIndexWithinParent(), r = r.__key, i || a++), n.set(r, a, "element"), s && o.set(r, a, "element")));
    else if (o = Xi(), n = Zs(o._window)) {
      var l = o._blockCursorElement, c = o._rootElement;
      if (c === null || l === null || !Ue(a) || a.isInline() || a.canBeEmpty() || eb(l, o, c), n.modify(t, i ? "backward" : "forward", r), 0 < n.rangeCount && (a = n.getRangeAt(0), o = this.anchor.getNode(), o = xn(o) ? o : dT(o), this.applyDOMRange(a), this.dirty = !0, !s)) {
        for (s = this.getNodes(), t = [], r = !1, l = 0; l < s.length; l++)
          c = s[l], s1(c, o) ? t.push(c) : r = !0;
        r && 0 < t.length && (i ? (i = t[0], Ue(i) ? i.selectStart() : i.getParentOrThrow().selectStart()) : (i = t[t.length - 1], Ue(i) ? i.selectEnd() : i.getParentOrThrow().selectEnd())), (n.anchorNode !== a.startContainer || n.anchorOffset !== a.startOffset) && (i = this.focus, s = this.anchor, n = s.key, a = s.offset, o = s.type, gl(s, i.key, i.offset, i.type), gl(i, n, a, o), this._cachedNodes = null);
      }
    }
  }
  deleteCharacter(t) {
    let i = this.isCollapsed();
    if (this.isCollapsed()) {
      var r = this.anchor, n = this.focus, o = r.getNode();
      if (!t && (r.type === "element" && Ue(o) && r.offset === o.getChildrenSize() || r.type === "text" && r.offset === o.getTextContentSize())) {
        var s = o.getParent();
        if (s = o.getNextSibling() || (s === null ? null : s.getNextSibling()), Ue(s) && s.isShadowRoot())
          return;
      }
      if (s = $v(n, t), Ti(s) && !s.isIsolated()) {
        s.isKeyboardSelectable() && Ue(o) && o.getChildrenSize() === 0 ? (o.remove(), t = hb(), t.add(s.__key), Ys(t)) : (s.remove(), Xi().dispatchCommand(P1, void 0));
        return;
      }
      if (!t && Ue(s) && Ue(o) && o.isEmpty()) {
        o.remove(), s.selectStart();
        return;
      }
      if (this.modify("extend", t, "character"), this.isCollapsed()) {
        if (t && r.offset === 0 && (r.type === "element" ? r.getNode() : r.getNode().getParentOrThrow()).collapseAtStart(this))
          return;
      } else {
        if (s = n.type === "text" ? n.getNode() : null, o = r.type === "text" ? r.getNode() : null, s !== null && s.isSegmented()) {
          if (r = n.offset, n = s.getTextContentSize(), s.is(o) || t && r !== n || !t && r !== 0) {
            jk(s, t, r);
            return;
          }
        } else if (o !== null && o.isSegmented() && (r = r.offset, n = o.getTextContentSize(), o.is(s) || t && r !== 0 || !t && r !== n)) {
          jk(o, t, r);
          return;
        }
        if (o = this.anchor, s = this.focus, r = o.getNode(), n = s.getNode(), r === n && o.type === "text" && s.type === "text") {
          var a = o.offset, l = s.offset;
          let c = a < l;
          n = c ? a : l, l = c ? l : a, a = l - 1, n !== a && (r = r.getTextContent().slice(n, l), lT(r) || (t ? s.offset = a : o.offset = a));
        }
      }
    }
    this.removeText(), t && !i && this.isCollapsed() && this.anchor.type === "element" && this.anchor.offset === 0 && (t = this.anchor.getNode(), t.isEmpty() && xn(t.getParent()) && t.getIndexWithinParent() === 0 && t.collapseAtStart(this));
  }
  deleteLine(t) {
    this.isCollapsed() && (this.anchor.type === "text" && this.modify("extend", t, "lineboundary"), (t ? this.focus : this.anchor).offset === 0 && this.modify("extend", t, "character")), this.removeText();
  }
  deleteWord(t) {
    this.isCollapsed() && this.modify("extend", t, "word"), this.removeText();
  }
};
function F0(e) {
  return e instanceof rf;
}
function qk(e) {
  let t = e.offset;
  return e.type === "text" ? t : (e = e.getNode(), t === e.getChildrenSize() ? e.getTextContent().length : 0);
}
function jp(e) {
  let t = e.anchor;
  return e = e.focus, t.type === "element" && e.type === "element" && t.key === e.key && t.offset === e.offset ? [0, 0] : [qk(t), qk(e)];
}
function jk(e, t, i) {
  let r = e.getTextContent().split(/(?=\s)/g), n = r.length, o = 0, s = 0;
  for (let a = 0; a < n; a++) {
    let l = r[a], c = a === n - 1;
    if (s = o, o += l.length, t && o === i || o > i || c) {
      r.splice(a, 1), c && (s = void 0);
      break;
    }
  }
  t = r.join("").trim(), t === "" ? e.remove() : (e.setTextContent(t), e.select(s, s));
}
function Lk(e, t, i, r) {
  var n = t;
  if (e.nodeType === 1) {
    let a = !1;
    var o = e.childNodes, s = o.length;
    n === s && (a = !0, n = s - 1);
    let l = o[n];
    if (s = !1, l === r._blockCursorElement ? (l = o[n + 1], s = !0) : r._blockCursorElement !== null && n--, r = zu(l), lt(r))
      n = a ? r.getTextContentSize() : 0;
    else {
      if (o = zu(e), o === null)
        return null;
      if (Ue(o) ? (e = o.getChildAtIndex(n), (t = Ue(e)) && (t = e.getParent(), t = i === null || t === null || !t.canBeEmpty() || t !== i.getNode()), t && (i = a ? e.getLastDescendant() : e.getFirstDescendant(), i === null ? (o = e, n = 0) : (e = i, o = Ue(e) ? e : e.getParentOrThrow())), lt(e) ? (r = e, o = null, n = a ? e.getTextContentSize() : 0) : e !== o && a && !s && n++) : (n = o.getIndexWithinParent(), n = t === 0 && Ti(o) && zu(e) === o ? n : n + 1, o = o.getParentOrThrow()), Ue(o))
        return new Us(o.__key, n, "element");
    }
  } else
    r = zu(e);
  return lt(r) ? new Us(r.__key, n, "text") : null;
}
function Kk(e, t, i) {
  var r = e.offset, n = e.getNode();
  r === 0 ? (r = n.getPreviousSibling(), n = n.getParent(), t ? (i || !t) && r === null && Ue(n) && n.isInline() && (t = n.getPreviousSibling(), lt(t) && (e.key = t.__key, e.offset = t.getTextContent().length)) : Ue(r) && !i && r.isInline() ? (e.key = r.__key, e.offset = r.getChildrenSize(), e.type = "element") : lt(r) && (e.key = r.__key, e.offset = r.getTextContent().length)) : r === n.getTextContent().length && (r = n.getNextSibling(), n = n.getParent(), t && Ue(r) && r.isInline() ? (e.key = r.__key, e.offset = 0, e.type = "element") : (i || t) && r === null && Ue(n) && n.isInline() && !n.canInsertTextAfter() && (t = n.getNextSibling(), lt(t) && (e.key = t.__key, e.offset = 0)));
}
function TT(e, t, i) {
  if (e.type === "text" && t.type === "text") {
    var r = e.isBefore(t);
    let n = e.is(t);
    Kk(e, r, n), Kk(t, !r, n), n && (t.key = e.key, t.offset = e.offset, t.type = e.type), r = Xi(), r.isComposing() && r._compositionKey !== e.key && Tt(i) && (r = i.anchor, i = i.focus, gl(e, r.key, r.offset, r.type), gl(t, i.key, i.offset, i.type));
  }
}
function BT(e, t, i, r, n, o) {
  return e === null || i === null || !gg(n, e, i) || (t = Lk(e, t, Tt(o) ? o.anchor : null, n), t === null) || (r = Lk(i, r, Tt(o) ? o.focus : null, n), r === null || t.type === "element" && r.type === "element" && (e = zu(e), i = zu(i), Ti(e) && Ti(i))) ? null : (TT(t, r, o), [t, r]);
}
function gb(e) {
  return Ue(e) && !e.isInline();
}
function DT(e, t, i, r, n, o) {
  let s = Js();
  return e = new Ag(new Us(e, t, n), new Us(i, r, o), 0, ""), e.dirty = !0, s._selection = e;
}
function hb() {
  return new rf(/* @__PURE__ */ new Set());
}
function f9(e) {
  let t = e.getEditorState()._selection, i = Zs(e._window);
  return F0(t) || i2(t) ? t.clone() : r2(t, i, e);
}
function r2(e, t, i) {
  var r = i._window;
  if (r === null)
    return null;
  var n = r.event, o = n ? n.type : void 0;
  r = o === "selectionchange", n = !Xv && (r || o === "beforeinput" || o === "compositionstart" || o === "compositionend" || o === "click" && n && n.detail === 3 || o === "drop" || o === void 0);
  let s;
  if (!Tt(e) || n) {
    if (t === null)
      return null;
    if (n = t.anchorNode, o = t.focusNode, s = t.anchorOffset, t = t.focusOffset, r && Tt(e) && !gg(i, n, o))
      return e.clone();
  } else
    return e.clone();
  if (i = BT(n, s, o, t, i, e), i === null)
    return null;
  let [a, l] = i;
  return new Ag(a, l, Tt(e) ? e.format : 0, Tt(e) ? e.style : "");
}
function Bi() {
  return Js()._selection;
}
function V0() {
  return Xi()._editorState._selection;
}
function c1(e, t, i, r = 1) {
  var n = e.anchor, o = e.focus, s = n.getNode(), a = o.getNode();
  if (t.is(s) || t.is(a)) {
    if (s = t.__key, e.isCollapsed())
      t = n.offset, (i <= t && 0 < r || i < t && 0 > r) && (i = Math.max(0, t + r), n.set(s, i, "element"), o.set(s, i, "element"), Yk(e));
    else {
      let c = e.isBackward();
      a = c ? o : n;
      var l = a.getNode();
      n = c ? n : o, o = n.getNode(), t.is(l) && (l = a.offset, (i <= l && 0 < r || i < l && 0 > r) && a.set(s, Math.max(0, l + r), "element")), t.is(o) && (t = n.offset, (i <= t && 0 < r || i < t && 0 > r) && n.set(s, Math.max(0, t + r), "element"));
    }
    Yk(e);
  }
}
function Yk(e) {
  var t = e.anchor, i = t.offset;
  let r = e.focus;
  var n = r.offset, o = t.getNode(), s = r.getNode();
  if (e.isCollapsed())
    Ue(o) && (s = o.getChildrenSize(), s = (n = i >= s) ? o.getChildAtIndex(s - 1) : o.getChildAtIndex(i), lt(s) && (i = 0, n && (i = s.getTextContentSize()), t.set(s.__key, i, "text"), r.set(s.__key, i, "text")));
  else {
    if (Ue(o)) {
      let a = o.getChildrenSize();
      i = (e = i >= a) ? o.getChildAtIndex(a - 1) : o.getChildAtIndex(i), lt(i) && (o = 0, e && (o = i.getTextContentSize()), t.set(i.__key, o, "text"));
    }
    Ue(s) && (i = s.getChildrenSize(), n = (t = n >= i) ? s.getChildAtIndex(i - 1) : s.getChildAtIndex(n), lt(n) && (s = 0, t && (s = n.getTextContentSize()), r.set(n.__key, s, "text")));
  }
}
function A9(e, t) {
  if (t = t.getEditorState()._selection, e = e._selection, Tt(e)) {
    var i = e.anchor;
    let r = e.focus, n;
    i.type === "text" && (n = i.getNode(), n.selectionTransform(t, e)), r.type === "text" && (i = r.getNode(), n !== i && i.selectionTransform(t, e));
  }
}
function u1(e, t, i, r, n) {
  let o = null, s = 0, a = null;
  r !== null ? (o = r.__key, lt(r) ? (s = r.getTextContentSize(), a = "text") : Ue(r) && (s = r.getChildrenSize(), a = "element")) : n !== null && (o = n.__key, lt(n) ? a = "text" : Ue(n) && (a = "element")), o !== null && a !== null ? e.set(o, s, a) : (s = t.getIndexWithinParent(), s === -1 && (s = i.getChildrenSize()), e.set(i.__key, s, "element"));
}
function Uk(e, t, i, r, n) {
  e.type === "text" ? (e.key = i, t || (e.offset += n)) : e.offset > r.getIndexWithinParent() && --e.offset;
}
function OT(e, t, i) {
  let r = [], n = null, o = null;
  e = e.getChildren();
  for (let u = 0; u < e.length; u++) {
    var s = e[u];
    Lm(s) || $e(108);
    var a = s.getChildren();
    s = 0;
    for (let m of a) {
      for (qo(m) || $e(109); r[u] !== void 0 && r[u][s] !== void 0; )
        s++;
      a = u;
      var l = s, c = m;
      let g = { cell: c, startColumn: l, startRow: a }, h = c.__rowSpan, A = c.__colSpan;
      for (let y = 0; y < h; y++) {
        r[a + y] === void 0 && (r[a + y] = []);
        for (let E = 0; E < A; E++)
          r[a + y][l + E] = g;
      }
      t.is(c) && (n = g), i.is(c) && (o = g), s += m.__colSpan;
    }
  }
  return n === null && $e(110), o === null && $e(111), [r, n, o];
}
function FT(e) {
  e instanceof s2 || (e instanceof fg ? (e = a1(e, qo), qo(e) || $e(114)) : (e = a1(e.getNode(), qo), qo(e) || $e(114)));
  let t = e.getParent();
  Lm(t) || $e(115);
  let i = t.getParent();
  return a2(i) || $e(116), [e, t, i];
}
let Nr = null, Tr = null, Zn = !1, qy = !1, jm = 0, Gk = { characterData: !0, childList: !0, subtree: !0 };
function q0() {
  return Zn || Nr !== null && Nr._readOnly;
}
function Cn() {
  Zn && $e(13);
}
function Js() {
  return Nr === null && $e(15), Nr;
}
function Xi() {
  return Tr === null && $e(16), Tr;
}
function Qk(e, t, i) {
  var r = t.__type;
  let n = e._nodes.get(r);
  for (n === void 0 && $e(30, r), e = i.get(r), e === void 0 && (e = Array.from(n.transforms), i.set(r, e)), i = e.length, r = 0; r < i && (e[r](t), t.isAttached()); r++)
    ;
}
function y9(e, t) {
  t = t._dirtyLeaves, e = e._nodeMap;
  for (let i of t)
    t = e.get(i), lt(t) && t.isAttached() && t.isSimpleText() && !t.isUnmergeable() && iT(t);
}
function E9(e, t) {
  let i = t._dirtyLeaves, r = t._dirtyElements;
  e = e._nodeMap;
  let n = yl(), o = /* @__PURE__ */ new Map();
  var s = i;
  let a = s.size;
  for (var l = r, c = l.size; 0 < a || 0 < c; ) {
    if (0 < a) {
      t._dirtyLeaves = /* @__PURE__ */ new Set();
      for (let u of s)
        s = e.get(u), lt(s) && s.isAttached() && s.isSimpleText() && !s.isUnmergeable() && iT(s), s !== void 0 && s !== void 0 && s.__key !== n && s.isAttached() && Qk(t, s, o), i.add(u);
      if (s = t._dirtyLeaves, a = s.size, 0 < a) {
        jm++;
        continue;
      }
    }
    t._dirtyLeaves = /* @__PURE__ */ new Set(), t._dirtyElements = /* @__PURE__ */ new Map();
    for (let u of l)
      l = u[0], c = u[1], (l === "root" || c) && (s = e.get(l), s !== void 0 && s !== void 0 && s.__key !== n && s.isAttached() && Qk(t, s, o), r.set(l, c));
    s = t._dirtyLeaves, a = s.size, l = t._dirtyElements, c = l.size, jm++;
  }
  t._dirtyLeaves = i, t._dirtyElements = r;
}
function n2(e, t) {
  var i = e.type, r = t.get(i);
  if (r === void 0 && $e(17, i), i = r.klass, e.type !== i.getType() && $e(18, i.name), i = i.importJSON(e), e = e.children, Ue(i) && Array.isArray(e))
    for (r = 0; r < e.length; r++) {
      let n = n2(e[r], t);
      i.append(n);
    }
  return i;
}
function Wk(e, t) {
  let i = Nr, r = Zn, n = Tr;
  Nr = e, Zn = !0, Tr = null;
  try {
    return t();
  } finally {
    Nr = i, Zn = r, Tr = n;
  }
}
function wc(e, t) {
  let i = e._pendingEditorState, r = e._rootElement, n = e._headless || r === null;
  if (i !== null) {
    var o = e._editorState, s = o._selection, a = i._selection, l = e._dirtyType !== 0, c = Nr, u = Zn, m = Tr, g = e._updating, h = e._observer, A = null;
    if (e._pendingEditorState = null, e._editorState = i, !n && l && h !== null) {
      Tr = e, Nr = i, Zn = !1, e._updating = !0;
      try {
        let ut = e._dirtyType, qt = e._dirtyElements, Ht = e._dirtyLeaves;
        h.disconnect();
        var y = ut, E = qt, v = Ht;
        bn = Ea = Cr = "", pT = y === 2, Fp = null, rn = e, Bl = e._config, Om = e._nodes, ef = rn._listeners.mutation, tb = E, ib = v, jc = o._nodeMap, Dl = i._nodeMap, t2 = i._readOnly, rb = new Map(e._keyToDOMMap);
        let ri = /* @__PURE__ */ new Map();
        Fm = ri, Pd("root", null), Fm = rb = Bl = Dl = jc = ib = tb = Om = rn = void 0, A = ri;
      } catch (ut) {
        if (ut instanceof Error && e._onError(ut), qy)
          throw ut;
        LT(e, null, r, i), tT(e), e._dirtyType = 2, qy = !0, wc(e, o), qy = !1;
        return;
      } finally {
        h.observe(r, Gk), e._updating = g, Nr = c, Zn = u, Tr = m;
      }
    }
    i._readOnly || (i._readOnly = !0);
    var C = e._dirtyLeaves, x = e._dirtyElements, S = e._normalizedNodes, R = e._updateTags, w = e._deferred;
    l && (e._dirtyType = 0, e._cloneNotNeeded.clear(), e._dirtyLeaves = /* @__PURE__ */ new Set(), e._dirtyElements = /* @__PURE__ */ new Map(), e._normalizedNodes = /* @__PURE__ */ new Set(), e._updateTags = /* @__PURE__ */ new Set());
    var T = e._decorators, N = e._pendingDecorators || T, D = i._nodeMap, O;
    for (O in N)
      D.has(O) || (N === T && (N = aT(e)), delete N[O]);
    var F = n ? null : Zs(e._window);
    if (e._editable && F !== null && (l || a === null || a.dirty)) {
      Tr = e, Nr = i;
      try {
        if (h !== null && h.disconnect(), l || a === null || a.dirty) {
          let ut = e._blockCursorElement;
          ut !== null && eb(ut, e, r);
          e: {
            let qt = F.anchorNode, Ht = F.focusNode, ri = F.anchorOffset, Ke = F.focusOffset, dt = document.activeElement;
            if (!(R.has("collaboration") && dt !== r || dt !== null && zC(dt)))
              if (Tt(a)) {
                var Y = a.anchor, P = a.focus, z = Y.key, W = P.key, H = o1(e, z), Q = o1(e, W), $ = Y.offset, le = P.offset, he = a.format, oe = a.style, ue = a.isCollapsed(), Ae = H, de = Q, fe = !1;
                if (Y.type === "text") {
                  Ae = i1(H);
                  let kt = Y.getNode();
                  fe = kt.getFormat() !== he || kt.getStyle() !== oe;
                } else
                  Tt(s) && s.anchor.type === "text" && (fe = !0);
                if (P.type === "text" && (de = i1(Q)), Ae !== null && de !== null) {
                  if (ue && (s === null || fe || Tt(s) && (s.format !== he || s.style !== oe))) {
                    var Re = performance.now();
                    xT = [he, oe, $, z, Re];
                  }
                  if (ri === $ && Ke === le && qt === Ae && Ht === de && (F.type !== "Range" || !ue) && (dt !== null && r.contains(dt) || r.focus({ preventScroll: !0 }), Y.type !== "element"))
                    break e;
                  try {
                    F.setBaseAndExtent(Ae, $, de, le);
                  } catch (kt) {
                  }
                  if (!R.has("skip-scroll-into-view") && a.isCollapsed() && r !== null && r === document.activeElement) {
                    let kt = a instanceof Ag && a.anchor.type === "element" ? Ae.childNodes[$] || null : 0 < F.rangeCount ? F.getRangeAt(0) : null;
                    if (kt !== null) {
                      let si;
                      if (kt instanceof Text) {
                        let ei = document.createRange();
                        ei.selectNode(kt), si = ei.getBoundingClientRect();
                      } else
                        si = kt.getBoundingClientRect();
                      let Dt = r.ownerDocument, yi = Dt.defaultView;
                      if (yi !== null)
                        for (var { top: qe, bottom: Oe } = si, Xe, Qe, Pe = r; Pe !== null; ) {
                          let ei = Pe === Dt.body;
                          if (ei)
                            Xe = 0, Qe = _1(e).innerHeight;
                          else {
                            let fr = Pe.getBoundingClientRect();
                            Xe = fr.top, Qe = fr.bottom;
                          }
                          let nr = 0;
                          if (qe < Xe ? nr = -(Xe - qe) : Oe > Qe && (nr = Oe - Qe), nr !== 0)
                            if (ei)
                              yi.scrollBy(0, nr);
                            else {
                              let fr = Pe.scrollTop;
                              Pe.scrollTop += nr;
                              let Sr = Pe.scrollTop - fr;
                              qe -= Sr, Oe -= Sr;
                            }
                          if (ei)
                            break;
                          Pe = X1(Pe);
                        }
                    }
                  }
                  lb = !0;
                }
              } else
                s !== null && gg(e, qt, Ht) && F.removeAllRanges();
          }
        }
        e: {
          let ut = e._blockCursorElement;
          if (Tt(a) && a.isCollapsed() && a.anchor.type === "element" && r.contains(document.activeElement)) {
            let qt = a.anchor, Ht = qt.getNode(), ri = qt.offset, Ke = Ht.getChildrenSize(), dt = !1, kt = null;
            if (ri === Ke) {
              let si = Ht.getChildAtIndex(ri - 1);
              Ny(si) && (dt = !0);
            } else {
              let si = Ht.getChildAtIndex(ri);
              if (Ny(si)) {
                let Dt = si.getPreviousSibling();
                (Dt === null || Ny(Dt)) && (dt = !0, kt = e.getElementByKey(si.__key));
              }
            }
            if (dt) {
              let si = e.getElementByKey(Ht.__key);
              if (ut === null) {
                let Dt = e._config.theme, yi = document.createElement("div");
                yi.contentEditable = "false", yi.setAttribute("data-lexical-cursor", "true");
                let ei = Dt.blockCursor;
                if (ei !== void 0) {
                  if (typeof ei == "string") {
                    let nr = ei.split(" ");
                    ei = Dt.blockCursor = nr;
                  }
                  ei !== void 0 && yi.classList.add(...ei);
                }
                e._blockCursorElement = ut = yi;
              }
              r.style.caretColor = "transparent", kt === null ? si.appendChild(ut) : si.insertBefore(ut, kt);
              break e;
            }
          }
          ut !== null && eb(ut, e, r);
        }
        h !== null && h.observe(r, Gk);
      } finally {
        Tr = m, Nr = c;
      }
    }
    if (A !== null) {
      var et = A;
      let ut = Array.from(e._listeners.mutation), qt = ut.length;
      for (let Ht = 0; Ht < qt; Ht++) {
        let [ri, Ke] = ut[Ht], dt = et.get(Ke);
        dt !== void 0 && ri(dt, { dirtyLeaves: C, prevEditorState: o, updateTags: R });
      }
    }
    Tt(a) || a === null || s !== null && s.is(a) || e.dispatchCommand(P1, void 0);
    var At = e._pendingDecorators;
    At !== null && (e._decorators = At, e._pendingDecorators = null, lm("decorator", e, !0, At));
    var Et = wk(t || o), oi = wk(i);
    if (Et !== oi && lm("textcontent", e, !0, oi), lm("update", e, !0, { dirtyElements: x, dirtyLeaves: C, editorState: i, normalizedNodes: S, prevEditorState: t || o, tags: R }), e._deferred = [], w.length !== 0) {
      let ut = e._updating;
      e._updating = !0;
      try {
        for (let qt = 0; qt < w.length; qt++)
          w[qt]();
      } finally {
        e._updating = ut;
      }
    }
    var Ai = e._updates;
    if (Ai.length !== 0) {
      let ut = Ai.shift();
      if (ut) {
        let [qt, Ht] = ut;
        VT(e, qt, Ht);
      }
    }
  }
}
function lm(e, t, i, ...r) {
  let n = t._updating;
  t._updating = i;
  try {
    let o = Array.from(t._listeners[e]);
    for (e = 0; e < o.length; e++)
      o[e].apply(null, r);
  } finally {
    t._updating = n;
  }
}
function ot(e, t, i) {
  if (e._updating === !1 || Tr !== e) {
    let o = !1;
    return e.update(() => {
      o = ot(e, t, i);
    }), o;
  }
  let r = XC(e);
  for (let o = 4; 0 <= o; o--)
    for (let s = 0; s < r.length; s++) {
      var n = r[s]._commands.get(t);
      if (n !== void 0 && (n = n[o], n !== void 0)) {
        n = Array.from(n);
        let a = n.length;
        for (let l = 0; l < a; l++)
          if (n[l](i, e) === !0)
            return !0;
      }
    }
  return !1;
}
function Zk(e, t) {
  let i = e._updates;
  for (t = t || !1; i.length !== 0; ) {
    var r = i.shift();
    if (r) {
      let [n, o] = r, s;
      o !== void 0 && (r = o.onUpdate, s = o.tag, o.skipTransforms && (t = !0), r && e._deferred.push(r), s && e._updateTags.add(s)), n();
    }
  }
  return t;
}
function VT(e, t, i) {
  let r = e._updateTags;
  var n, o = n = !1;
  if (i !== void 0) {
    var s = i.onUpdate;
    n = i.tag, n != null && r.add(n), n = i.skipTransforms || !1, o = i.discrete || !1;
  }
  s && e._deferred.push(s), i = e._editorState, s = e._pendingEditorState;
  let a = !1;
  (s === null || s._readOnly) && (s = e._pendingEditorState = new nf(new Map((s || i)._nodeMap)), a = !0), s._flushSync = o, o = Nr;
  let l = Zn, c = Tr, u = e._updating;
  Nr = s, Zn = !1, e._updating = !0, Tr = e;
  try {
    a && (e._headless ? i._selection != null && (s._selection = i._selection.clone()) : s._selection = f9(e));
    let m = e._compositionKey;
    t(), n = Zk(e, n), A9(s, e), e._dirtyType !== 0 && (n ? y9(s, e) : E9(s, e), Zk(e), e9(i, s, e._dirtyLeaves, e._dirtyElements)), m !== e._compositionKey && (s._flushSync = !0);
    let g = s._selection;
    if (Tt(g)) {
      let h = s._nodeMap, A = g.focus.key;
      h.get(g.anchor.key) !== void 0 && h.get(A) !== void 0 || $e(19);
    } else
      F0(g) && g._nodes.size === 0 && (s._selection = null);
  } catch (m) {
    m instanceof Error && e._onError(m), e._pendingEditorState = i, e._dirtyType = 2, e._cloneNotNeeded.clear(), e._dirtyLeaves = /* @__PURE__ */ new Set(), e._dirtyElements.clear(), wc(e);
    return;
  } finally {
    Nr = o, Zn = l, Tr = c, e._updating = u, jm = 0;
  }
  e._dirtyType !== 0 || v9(s, e) ? s._flushSync ? (s._flushSync = !1, wc(e)) : a && HW(() => {
    wc(e);
  }) : (s._flushSync = !1, a && (r.clear(), e._deferred = [], e._pendingEditorState = null));
}
function vo(e, t, i) {
  e._updating ? e._updates.push([t, i]) : VT(e, t, i);
}
class qT extends fg {
  constructor(t) {
    super(t);
  }
  decorate() {
    $e(47);
  }
  isIsolated() {
    return !1;
  }
  isInline() {
    return !0;
  }
  isKeyboardSelectable() {
    return !0;
  }
}
function Ti(e) {
  return e instanceof qT;
}
class $c extends fg {
  constructor(t) {
    super(t), this.__last = this.__first = null, this.__indent = this.__format = this.__size = 0, this.__dir = null;
  }
  getFormat() {
    return this.getLatest().__format;
  }
  getFormatType() {
    let t = this.getFormat();
    return QW[t] || "";
  }
  getIndent() {
    return this.getLatest().__indent;
  }
  getChildren() {
    let t = [], i = this.getFirstChild();
    for (; i !== null; )
      t.push(i), i = i.getNextSibling();
    return t;
  }
  getChildrenKeys() {
    let t = [], i = this.getFirstChild();
    for (; i !== null; )
      t.push(i.__key), i = i.getNextSibling();
    return t;
  }
  getChildrenSize() {
    return this.getLatest().__size;
  }
  isEmpty() {
    return this.getChildrenSize() === 0;
  }
  isDirty() {
    let t = Xi()._dirtyElements;
    return t !== null && t.has(this.__key);
  }
  isLastChild() {
    let t = this.getLatest(), i = this.getParentOrThrow().getLastChild();
    return i !== null && i.is(t);
  }
  getAllTextNodes() {
    let t = [], i = this.getFirstChild();
    for (; i !== null; ) {
      if (lt(i) && t.push(i), Ue(i)) {
        let r = i.getAllTextNodes();
        t.push(...r);
      }
      i = i.getNextSibling();
    }
    return t;
  }
  getFirstDescendant() {
    let t = this.getFirstChild();
    for (; t !== null; ) {
      if (Ue(t)) {
        let i = t.getFirstChild();
        if (i !== null) {
          t = i;
          continue;
        }
      }
      break;
    }
    return t;
  }
  getLastDescendant() {
    let t = this.getLastChild();
    for (; t !== null; ) {
      if (Ue(t)) {
        let i = t.getLastChild();
        if (i !== null) {
          t = i;
          continue;
        }
      }
      break;
    }
    return t;
  }
  getDescendantByIndex(t) {
    let i = this.getChildren(), r = i.length;
    return t >= r ? (t = i[r - 1], Ue(t) && t.getLastDescendant() || t || null) : (t = i[t], Ue(t) && t.getFirstDescendant() || t || null);
  }
  getFirstChild() {
    let t = this.getLatest().__first;
    return t === null ? null : Mr(t);
  }
  getFirstChildOrThrow() {
    let t = this.getFirstChild();
    return t === null && $e(45, this.__key), t;
  }
  getLastChild() {
    let t = this.getLatest().__last;
    return t === null ? null : Mr(t);
  }
  getLastChildOrThrow() {
    let t = this.getLastChild();
    return t === null && $e(96, this.__key), t;
  }
  getChildAtIndex(t) {
    var i = this.getChildrenSize();
    let r;
    if (t < i / 2) {
      for (r = this.getFirstChild(), i = 0; r !== null && i <= t; ) {
        if (i === t)
          return r;
        r = r.getNextSibling(), i++;
      }
      return null;
    }
    for (r = this.getLastChild(), --i; r !== null && i >= t; ) {
      if (i === t)
        return r;
      r = r.getPreviousSibling(), i--;
    }
    return null;
  }
  getTextContent() {
    let t = "", i = this.getChildren(), r = i.length;
    for (let n = 0; n < r; n++) {
      let o = i[n];
      t += o.getTextContent(), Ue(o) && n !== r - 1 && !o.isInline() && (t += `

`);
    }
    return t;
  }
  getTextContentSize() {
    let t = 0, i = this.getChildren(), r = i.length;
    for (let n = 0; n < r; n++) {
      let o = i[n];
      t += o.getTextContentSize(), Ue(o) && n !== r - 1 && !o.isInline() && (t += 2);
    }
    return t;
  }
  getDirection() {
    return this.getLatest().__dir;
  }
  hasFormat(t) {
    return t !== "" ? (t = Ik[t], (this.getFormat() & t) !== 0) : !1;
  }
  select(t, i) {
    Cn();
    let r = Bi(), n = t, o = i;
    var s = this.getChildrenSize();
    if (!this.canBeEmpty()) {
      if (t === 0 && i === 0) {
        if (t = this.getFirstChild(), lt(t) || Ue(t))
          return t.select(0, 0);
      } else if (!(t !== void 0 && t !== s || i !== void 0 && i !== s) && (t = this.getLastChild(), lt(t) || Ue(t)))
        return t.select();
    }
    if (n === void 0 && (n = s), o === void 0 && (o = s), s = this.__key, Tt(r))
      r.anchor.set(s, n, "element"), r.focus.set(s, o, "element"), r.dirty = !0;
    else
      return DT(s, n, s, o, "element", "element");
    return r;
  }
  selectStart() {
    let t = this.getFirstDescendant();
    return Ue(t) || lt(t) ? t.select(0, 0) : t !== null ? t.selectPrevious() : this.select(0, 0);
  }
  selectEnd() {
    let t = this.getLastDescendant();
    return Ue(t) || lt(t) ? t.select() : t !== null ? t.selectNext() : this.select();
  }
  clear() {
    let t = this.getWritable();
    return this.getChildren().forEach((i) => i.remove()), t;
  }
  append(...t) {
    return this.splice(this.getChildrenSize(), 0, t);
  }
  setDirection(t) {
    let i = this.getWritable();
    return i.__dir = t, i;
  }
  setFormat(t) {
    return this.getWritable().__format = t !== "" ? Ik[t] : 0, this;
  }
  setIndent(t) {
    return this.getWritable().__indent = t, this;
  }
  splice(t, i, r) {
    let n = r.length, o = this.getChildrenSize(), s = this.getWritable(), a = s.__key;
    var l = [], c = [];
    let u = this.getChildAtIndex(t + i), m = null, g = o - i + n;
    if (t !== 0)
      if (t === o)
        m = this.getLastChild();
      else {
        var h = this.getChildAtIndex(t);
        h !== null && (m = h.getPreviousSibling());
      }
    if (0 < i) {
      var A = m === null ? this.getFirstChild() : m.getNextSibling();
      for (h = 0; h < i; h++) {
        A === null && $e(100);
        var y = A.getNextSibling(), E = A.__key;
        A = A.getWritable(), kc(A), c.push(E), A = y;
      }
    }
    for (h = m, y = 0; y < n; y++) {
      E = r[y], h !== null && E.is(h) && (m = h = h.getPreviousSibling()), A = E.getWritable(), A.__parent === a && g--, kc(A);
      let v = E.__key;
      h === null ? (s.__first = v, A.__prev = null) : (h = h.getWritable(), h.__next = v, A.__prev = h.__key), E.__key === a && $e(76), A.__parent = a, l.push(v), h = E;
    }
    if (t + i === o ? h !== null && (h.getWritable().__next = null, s.__last = h.__key) : u !== null && (t = u.getWritable(), h !== null ? (i = h.getWritable(), t.__prev = h.__key, i.__next = u.__key) : t.__prev = null), s.__size = g, c.length && (t = Bi(), Tt(t))) {
      c = new Set(c), l = new Set(l);
      let { anchor: v, focus: C } = t;
      Jk(v, c, l) && u1(v, v.getNode(), this, m, u), Jk(C, c, l) && u1(C, C.getNode(), this, m, u), g !== 0 || this.canBeEmpty() || us(this) || this.remove();
    }
    return s;
  }
  exportJSON() {
    return { children: [], direction: this.getDirection(), format: this.getFormatType(), indent: this.getIndent(), type: "element", version: 1 };
  }
  insertNewAfter() {
    return null;
  }
  canIndent() {
    return !0;
  }
  collapseAtStart() {
    return !1;
  }
  excludeFromCopy() {
    return !1;
  }
  canExtractContents() {
    return !0;
  }
  canReplaceWith() {
    return !0;
  }
  canInsertAfter() {
    return !0;
  }
  canBeEmpty() {
    return !0;
  }
  canInsertTextBefore() {
    return !0;
  }
  canInsertTextAfter() {
    return !0;
  }
  isInline() {
    return !1;
  }
  isShadowRoot() {
    return !1;
  }
  canMergeWith() {
    return !1;
  }
  extractWithChild() {
    return !1;
  }
}
function Ue(e) {
  return e instanceof $c;
}
function Jk(e, t, i) {
  for (e = e.getNode(); e; ) {
    let r = e.__key;
    if (t.has(r) && !i.has(r))
      return !0;
    e = e.getParent();
  }
  return !1;
}
class j0 extends $c {
  static getType() {
    return "root";
  }
  static clone() {
    return new j0();
  }
  constructor() {
    super("root"), this.__cachedText = null;
  }
  getTopLevelElementOrThrow() {
    $e(51);
  }
  getTextContent() {
    let t = this.__cachedText;
    return !q0() && Xi()._dirtyType !== 0 || t === null ? super.getTextContent() : t;
  }
  remove() {
    $e(52);
  }
  replace() {
    $e(53);
  }
  insertBefore() {
    $e(54);
  }
  insertAfter() {
    $e(55);
  }
  updateDOM() {
    return !1;
  }
  append(...t) {
    for (let i = 0; i < t.length; i++) {
      let r = t[i];
      Ue(r) || Ti(r) || $e(56);
    }
    return super.append(...t);
  }
  static importJSON(t) {
    let i = Ws();
    return i.setFormat(t.format), i.setIndent(t.indent), i.setDirection(t.direction), i;
  }
  exportJSON() {
    return { children: [], direction: this.getDirection(), format: this.getFormatType(), indent: this.getIndent(), type: "root", version: 1 };
  }
  collapseAtStart() {
    return !0;
  }
}
function xn(e) {
  return e instanceof j0;
}
function v9(e, t) {
  if (t = t.getEditorState()._selection, e = e._selection, e !== null) {
    if (e.dirty || !e.is(t))
      return !0;
  } else if (t !== null)
    return !0;
  return !1;
}
function o2() {
  return new nf(/* @__PURE__ */ new Map([["root", new j0()]]));
}
function jT(e) {
  let t = e.exportJSON();
  var i = e.constructor;
  t.type !== i.getType() && $e(130, i.name);
  let r = t.children;
  if (Ue(e))
    for (Array.isArray(r) || $e(59, i.name), e = e.getChildren(), i = 0; i < e.length; i++) {
      let n = jT(e[i]);
      r.push(n);
    }
  return t;
}
class nf {
  constructor(t, i) {
    this._nodeMap = t, this._selection = i || null, this._readOnly = this._flushSync = !1;
  }
  isEmpty() {
    return this._nodeMap.size === 1 && this._selection === null;
  }
  read(t) {
    return Wk(this, t);
  }
  clone(t) {
    return t = new nf(this._nodeMap, t === void 0 ? this._selection : t), t._readOnly = !0, t;
  }
  toJSON() {
    return Wk(this, () => ({ root: jT(Ws()) }));
  }
}
class L0 extends $c {
  static getType() {
    return "paragraph";
  }
  static clone(t) {
    return new L0(t.__key);
  }
  createDOM(t) {
    let i = document.createElement("p");
    return t = om(t.theme, "paragraph"), t !== void 0 && i.classList.add(...t), i;
  }
  updateDOM() {
    return !1;
  }
  static importDOM() {
    return { p: () => ({ conversion: b9, priority: 0 }) };
  }
  exportDOM(t) {
    if ({ element: t } = super.exportDOM(t), t && $1(t)) {
      this.isEmpty() && t.append(document.createElement("br"));
      var i = this.getFormatType();
      t.style.textAlign = i, (i = this.getDirection()) && (t.dir = i), i = this.getIndent(), 0 < i && (t.style.textIndent = `${20 * i}px`);
    }
    return { element: t };
  }
  static importJSON(t) {
    let i = Lc();
    return i.setFormat(t.format), i.setIndent(t.indent), i.setDirection(t.direction), i;
  }
  exportJSON() {
    return ee(q({}, super.exportJSON()), { type: "paragraph", version: 1 });
  }
  insertNewAfter(t, i) {
    t = Lc();
    let r = this.getDirection();
    return t.setDirection(r), this.insertAfter(t, i), t;
  }
  collapseAtStart() {
    let t = this.getChildren();
    if (t.length === 0 || lt(t[0]) && t[0].getTextContent().trim() === "") {
      if (this.getNextSibling() !== null)
        return this.selectNext(), this.remove(), !0;
      if (this.getPreviousSibling() !== null)
        return this.selectPrevious(), this.remove(), !0;
    }
    return !1;
  }
}
function b9(e) {
  let t = Lc();
  return e.style && (t.setFormat(e.style.textAlign), e = parseInt(e.style.textIndent, 10) / 20, 0 < e && t.setIndent(e)), { node: t };
}
function Lc() {
  return pg(new L0());
}
function LT(e, t, i, r) {
  let n = e._keyToDOMMap;
  n.clear(), e._editorState = o2(), e._pendingEditorState = r, e._compositionKey = null, e._dirtyType = 0, e._cloneNotNeeded.clear(), e._dirtyLeaves = /* @__PURE__ */ new Set(), e._dirtyElements.clear(), e._normalizedNodes = /* @__PURE__ */ new Set(), e._updateTags = /* @__PURE__ */ new Set(), e._updates = [], e._blockCursorElement = null, r = e._observer, r !== null && (r.disconnect(), e._observer = null), t !== null && (t.textContent = ""), i !== null && (i.textContent = "", n.set("root", i));
}
function C9(e) {
  let t = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Set();
  return e.forEach((r) => {
    if (r = r.klass.importDOM != null ? r.klass.importDOM.bind(r.klass) : null, r != null && !i.has(r)) {
      i.add(r);
      var n = r();
      n !== null && Object.keys(n).forEach((o) => {
        let s = t.get(o);
        s === void 0 && (s = [], t.set(o, s)), s.push(n[o]);
      });
    }
  }), t;
}
class x9 {
  constructor(t, i, r, n, o, s, a) {
    this._parentEditor = i, this._rootElement = null, this._editorState = t, this._compositionKey = this._pendingEditorState = null, this._deferred = [], this._keyToDOMMap = /* @__PURE__ */ new Map(), this._updates = [], this._updating = !1, this._listeners = { decorator: /* @__PURE__ */ new Set(), editable: /* @__PURE__ */ new Set(), mutation: /* @__PURE__ */ new Map(), root: /* @__PURE__ */ new Set(), textcontent: /* @__PURE__ */ new Set(), update: /* @__PURE__ */ new Set() }, this._commands = /* @__PURE__ */ new Map(), this._config = n, this._nodes = r, this._decorators = {}, this._pendingDecorators = null, this._dirtyType = 0, this._cloneNotNeeded = /* @__PURE__ */ new Set(), this._dirtyLeaves = /* @__PURE__ */ new Set(), this._dirtyElements = /* @__PURE__ */ new Map(), this._normalizedNodes = /* @__PURE__ */ new Set(), this._updateTags = /* @__PURE__ */ new Set(), this._observer = null, this._key = cT(), this._onError = o, this._htmlConversions = s, this._editable = a, this._headless = i !== null && i._headless, this._blockCursorElement = this._window = null;
  }
  isComposing() {
    return this._compositionKey != null;
  }
  registerUpdateListener(t) {
    let i = this._listeners.update;
    return i.add(t), () => {
      i.delete(t);
    };
  }
  registerEditableListener(t) {
    let i = this._listeners.editable;
    return i.add(t), () => {
      i.delete(t);
    };
  }
  registerDecoratorListener(t) {
    let i = this._listeners.decorator;
    return i.add(t), () => {
      i.delete(t);
    };
  }
  registerTextContentListener(t) {
    let i = this._listeners.textcontent;
    return i.add(t), () => {
      i.delete(t);
    };
  }
  registerRootListener(t) {
    let i = this._listeners.root;
    return t(this._rootElement, null), i.add(t), () => {
      t(null, this._rootElement), i.delete(t);
    };
  }
  registerCommand(t, i, r) {
    r === void 0 && $e(35);
    let n = this._commands;
    n.has(t) || n.set(t, [/* @__PURE__ */ new Set(), /* @__PURE__ */ new Set(), /* @__PURE__ */ new Set(), /* @__PURE__ */ new Set(), /* @__PURE__ */ new Set()]);
    let o = n.get(t);
    o === void 0 && $e(36, String(t));
    let s = o[r];
    return s.add(i), () => {
      s.delete(i), o.every((a) => a.size === 0) && n.delete(t);
    };
  }
  registerMutationListener(t, i) {
    this._nodes.get(t.getType()) === void 0 && $e(37, t.name);
    let r = this._listeners.mutation;
    return r.set(i, t), () => {
      r.delete(i);
    };
  }
  registerNodeTransformToKlass(t, i) {
    var r = t.getType();
    return r = this._nodes.get(r), r === void 0 && $e(37, t.name), r.transforms.add(i), r;
  }
  registerNodeTransform(t, i) {
    var r = this.registerNodeTransformToKlass(t, i);
    let n = [r];
    return r = r.replaceWithKlass, r != null && (r = this.registerNodeTransformToKlass(r, i), n.push(r)), XW(this, t.getType()), () => {
      n.forEach((o) => o.transforms.delete(i));
    };
  }
  hasNode(t) {
    return this._nodes.has(t.getType());
  }
  hasNodes(t) {
    return t.every(this.hasNode.bind(this));
  }
  dispatchCommand(t, i) {
    return ot(this, t, i);
  }
  getDecorators() {
    return this._decorators;
  }
  getRootElement() {
    return this._rootElement;
  }
  getKey() {
    return this._key;
  }
  setRootElement(t) {
    let i = this._rootElement;
    if (t !== i) {
      let s = om(this._config.theme, "root");
      var r = this._pendingEditorState || this._editorState;
      if (this._rootElement = t, LT(this, i, t, r), i !== null) {
        if (!this._config.disableEvents) {
          sm !== 0 && (sm--, sm === 0 && i.ownerDocument.removeEventListener("selectionchange", kT));
          var n = i.__lexicalEditor;
          if (n != null) {
            if (n._parentEditor !== null) {
              var o = XC(n);
              o = o[o.length - 1]._key, t0.get(o) === n && t0.delete(o);
            } else
              t0.delete(n._key);
            i.__lexicalEditor = null;
          }
          for (n = RT(i), o = 0; o < n.length; o++)
            n[o]();
          i.__lexicalEventHandles = [];
        }
        s != null && i.classList.remove(...s);
      }
      t !== null ? (r = (r = t.ownerDocument) && r.defaultView || null, n = t.style, n.userSelect = "text", n.whiteSpace = "pre-wrap", n.wordBreak = "break-word", t.setAttribute(
        "data-lexical-editor",
        "true"
      ), this._window = r, this._dirtyType = 2, tT(this), this._updateTags.add("history-merge"), wc(this), this._config.disableEvents || c9(t, this), s != null && t.classList.add(...s)) : (this._editorState = r, this._window = this._pendingEditorState = null), lm("root", this, !1, t, i);
    }
  }
  getElementByKey(t) {
    return this._keyToDOMMap.get(t) || null;
  }
  getEditorState() {
    return this._editorState;
  }
  setEditorState(t, i) {
    t.isEmpty() && $e(38), eT(this);
    let r = this._pendingEditorState, n = this._updateTags;
    i = i !== void 0 ? i.tag : null, r === null || r.isEmpty() || (i != null && n.add(i), wc(this)), this._pendingEditorState = t, this._dirtyType = 2, this._dirtyElements.set("root", !1), this._compositionKey = null, i != null && n.add(i), wc(this);
  }
  parseEditorState(t, i) {
    t = typeof t == "string" ? JSON.parse(t) : t;
    let r = o2(), n = Nr, o = Zn, s = Tr, a = this._dirtyElements, l = this._dirtyLeaves, c = this._cloneNotNeeded, u = this._dirtyType;
    this._dirtyElements = /* @__PURE__ */ new Map(), this._dirtyLeaves = /* @__PURE__ */ new Set(), this._cloneNotNeeded = /* @__PURE__ */ new Set(), this._dirtyType = 0, Nr = r, Zn = !1, Tr = this;
    try {
      n2(t.root, this._nodes), i && i(), r._readOnly = !0;
    } catch (m) {
      m instanceof Error && this._onError(m);
    } finally {
      this._dirtyElements = a, this._dirtyLeaves = l, this._cloneNotNeeded = c, this._dirtyType = u, Nr = n, Zn = o, Tr = s;
    }
    return r;
  }
  update(t, i) {
    vo(this, t, i);
  }
  focus(t, i = {}) {
    let r = this._rootElement;
    r !== null && (r.setAttribute("autocapitalize", "off"), vo(this, () => {
      let n = Bi(), o = Ws();
      n !== null ? n.dirty = !0 : o.getChildrenSize() !== 0 && (i.defaultSelection === "rootStart" ? o.selectStart() : o.selectEnd());
    }, { onUpdate: () => {
      r.removeAttribute("autocapitalize"), t && t();
    }, tag: "focus" }), this._pendingEditorState === null && r.removeAttribute("autocapitalize"));
  }
  blur() {
    var t = this._rootElement;
    t !== null && t.blur(), t = Zs(this._window), t !== null && t.removeAllRanges();
  }
  isEditable() {
    return this._editable;
  }
  setEditable(t) {
    this._editable !== t && (this._editable = t, lm("editable", this, !0, t));
  }
  toJSON() {
    return { editorState: this._editorState.toJSON() };
  }
}
class s2 extends $c {
  constructor(t, i) {
    super(i), this.__colSpan = t, this.__rowSpan = 1;
  }
  exportJSON() {
    return ee(q({}, super.exportJSON()), { colSpan: this.__colSpan, rowSpan: this.__rowSpan });
  }
  getColSpan() {
    return this.__colSpan;
  }
  setColSpan(t) {
    return this.getWritable().__colSpan = t, this;
  }
  getRowSpan() {
    return this.__rowSpan;
  }
  setRowSpan(t) {
    return this.getWritable().__rowSpan = t, this;
  }
}
function qo(e) {
  return e instanceof s2;
}
class KT extends $c {
}
function a2(e) {
  return e instanceof KT;
}
class YT extends $c {
}
function Lm(e) {
  return e instanceof YT;
}
Be.$addUpdateTag = function(e) {
  Cn(), Xi()._updateTags.add(e);
};
Be.$applyNodeReplacement = pg;
Be.$copyNode = mT;
Be.$createLineBreakNode = d0;
Be.$createNodeSelection = hb;
Be.$createParagraphNode = Lc;
Be.$createRangeSelection = function() {
  let e = new Us("root", 0, "element"), t = new Us("root", 0, "element");
  return new Ag(e, t, 0, "");
};
Be.$createTabNode = tf;
Be.$createTextNode = wr;
Be.$getAdjacentNode = $v;
Be.$getNearestNodeFromDOMNode = hg;
Be.$getNearestRootOrShadowRoot = dT;
Be.$getNodeByKey = Mr;
Be.$getPreviousSelection = V0;
Be.$getRoot = Ws;
Be.$getSelection = Bi;
Be.$getTextContent = function() {
  let e = Bi();
  return e === null ? "" : e.getTextContent();
};
Be.$hasAncestor = s1;
Be.$hasUpdateTag = function(e) {
  return Xi()._updateTags.has(e);
};
Be.$insertNodes = function(e, t) {
  let i = Bi() || V0();
  return i === null && (i = Ws().selectEnd()), i.insertNodes(e, t);
};
Be.$isBlockElementNode = gb;
Be.$isDecoratorNode = Ti;
Be.$isElementNode = Ue;
Be.$isInlineElementOrDecoratorNode = function(e) {
  return Ue(e) && e.isInline() || Ti(e) && e.isInline();
};
Be.$isLeafNode = nT;
Be.$isLineBreakNode = qm;
Be.$isNodeSelection = F0;
Be.$isParagraphNode = function(e) {
  return e instanceof L0;
};
Be.$isRangeSelection = Tt;
Be.$isRootNode = xn;
Be.$isRootOrShadowRoot = us;
Be.$isTabNode = function(e) {
  return e instanceof O0;
};
Be.$isTextNode = lt;
Be.$nodesOfType = function(e) {
  var t = Js();
  let i = t._readOnly, r = e.getType();
  t = t._nodeMap;
  let n = [];
  for (let [, o] of t)
    o instanceof e && o.__type === r && (i || o.isAttached()) && n.push(o);
  return n;
};
Be.$normalizeSelection__EXPERIMENTAL = PC;
Be.$parseSerializedNode = function(e) {
  return n2(e, Xi()._nodes);
};
Be.$selectAll = function() {
  var e = Ws();
  e = e.select(0, e.getChildrenSize()), Ys(PC(e));
};
Be.$setCompositionKey = Wr;
Be.$setSelection = Ys;
Be.$splitNode = gT;
Be.BLUR_COMMAND = XN;
Be.CAN_REDO_COMMAND = {};
Be.CAN_UNDO_COMMAND = {};
Be.CLEAR_EDITOR_COMMAND = {};
Be.CLEAR_HISTORY_COMMAND = {};
Be.CLICK_COMMAND = DN;
Be.COMMAND_PRIORITY_CRITICAL = 4;
Be.COMMAND_PRIORITY_EDITOR = 0;
Be.COMMAND_PRIORITY_HIGH = 3;
Be.COMMAND_PRIORITY_LOW = 1;
Be.COMMAND_PRIORITY_NORMAL = 2;
Be.CONTROLLED_TEXT_INSERTION_COMMAND = e0;
Be.COPY_COMMAND = GC;
Be.CUT_COMMAND = QC;
Be.DELETE_CHARACTER_COMMAND = Tm;
Be.DELETE_LINE_COMMAND = Dm;
Be.DELETE_WORD_COMMAND = Bm;
Be.DEPRECATED_$computeGridMap = OT;
Be.DEPRECATED_$createGridSelection = function() {
  let e = new Us("root", 0, "element"), t = new Us("root", 0, "element");
  return new wT("root", e, t);
};
Be.DEPRECATED_$getGridCellNodeRect = mb;
Be.DEPRECATED_$getNodeTriplet = FT;
Be.DEPRECATED_$isGridCellNode = qo;
Be.DEPRECATED_$isGridNode = a2;
Be.DEPRECATED_$isGridRowNode = Lm;
Be.DEPRECATED_$isGridSelection = i2;
Be.DEPRECATED_GridCellNode = s2;
Be.DEPRECATED_GridNode = KT;
Be.DEPRECATED_GridRowNode = YT;
Be.DRAGEND_COMMAND = zN;
Be.DRAGOVER_COMMAND = PN;
Be.DRAGSTART_COMMAND = JN;
Be.DROP_COMMAND = ZN;
Be.DecoratorNode = qT;
Be.ElementNode = $c;
Be.FOCUS_COMMAND = HN;
Be.FORMAT_ELEMENT_COMMAND = {};
Be.FORMAT_TEXT_COMMAND = Al;
Be.INDENT_CONTENT_COMMAND = {};
Be.INSERT_LINE_BREAK_COMMAND = nm;
Be.INSERT_PARAGRAPH_COMMAND = Pv;
Be.INSERT_TAB_COMMAND = {};
Be.KEY_ARROW_DOWN_COMMAND = KN;
Be.KEY_ARROW_LEFT_COMMAND = qN;
Be.KEY_ARROW_RIGHT_COMMAND = FN;
Be.KEY_ARROW_UP_COMMAND = LN;
Be.KEY_BACKSPACE_COMMAND = UN;
Be.KEY_DELETE_COMMAND = QN;
Be.KEY_DOWN_COMMAND = ON;
Be.KEY_ENTER_COMMAND = e1;
Be.KEY_ESCAPE_COMMAND = GN;
Be.KEY_MODIFIER_COMMAND = _N;
Be.KEY_SPACE_COMMAND = YN;
Be.KEY_TAB_COMMAND = WN;
Be.LineBreakNode = D0;
Be.MOVE_TO_END = VN;
Be.MOVE_TO_START = jN;
Be.OUTDENT_CONTENT_COMMAND = {};
Be.PASTE_COMMAND = KC;
Be.ParagraphNode = L0;
Be.REDO_COMMAND = UC;
Be.REMOVE_TEXT_COMMAND = zv;
Be.RootNode = j0;
Be.SELECTION_CHANGE_COMMAND = P1;
Be.SELECT_ALL_COMMAND = Hv;
Be.TabNode = O0;
Be.TextNode = _c;
Be.UNDO_COMMAND = YC;
Be.createCommand = function() {
  return {};
};
Be.createEditor = function(e) {
  var t = e || {}, i = Tr, r = t.theme || {};
  let n = e === void 0 ? i : t.parentEditor || null, o = t.disableEvents || !1, s = o2(), a = t.namespace || (n !== null ? n._config.namespace : cT()), l = t.editorState, c = [j0, _c, D0, O0, L0, ...t.nodes || []], u = t.onError;
  if (t = t.editable !== void 0 ? t.editable : !0, e === void 0 && i !== null)
    e = i._nodes;
  else
    for (e = /* @__PURE__ */ new Map(), i = 0; i < c.length; i++) {
      let g = c[i], h = null;
      var m = null;
      typeof g != "function" && (m = g, g = m.replace, h = m.with, m = m.withKlass ? m.withKlass : null);
      let A = g.getType(), y = g.transform(), E = /* @__PURE__ */ new Set();
      y !== null && E.add(y), e.set(A, { klass: g, replace: h, replaceWithKlass: m, transforms: E });
    }
  return r = new x9(s, n, e, { disableEvents: o, namespace: a, theme: r }, u || console.error, C9(e), t), l !== void 0 && (r._pendingEditorState = l, r._dirtyType = 2), r;
};
Be.getNearestEditorFromDOMNode = HC;
Be.isHTMLAnchorElement = function(e) {
  return $1(e) && e.tagName === "A";
};
Be.isHTMLElement = $1;
Be.isSelectionCapturedInDecoratorInput = zC;
Be.isSelectionWithinEditor = gg;
const I9 = Be;
var L = I9, ht = L;
let d1 = /* @__PURE__ */ new Map();
function Pk(e) {
  for (; e != null; ) {
    if (e.nodeType === Node.TEXT_NODE)
      return e;
    e = e.firstChild;
  }
  return null;
}
function zk(e) {
  let t = e.parentNode;
  if (t == null)
    throw Error("Should never happen");
  return [t, Array.from(t.childNodes).indexOf(e)];
}
function UT(e) {
  let t = {};
  e = e.split(";");
  for (let i of e)
    if (i !== "") {
      let [r, n] = i.split(/:([^]+)/);
      t[r.trim()] = n.trim();
    }
  return t;
}
function m1(e) {
  let t = d1.get(e);
  return t === void 0 && (t = UT(e), d1.set(e, t)), t;
}
function S9(e) {
  let t = "";
  for (let i in e)
    i && (t += `${i}: ${e[i]};`);
  return t;
}
function Mu(e, t) {
  var i = m1("getStyle" in e ? e.getStyle() : e.style);
  t = Object.entries(t).reduce((r, [n, o]) => (o === null ? delete r[n] : r[n] = o, r), q({}, i)), i = S9(t), e.setStyle(i), d1.set(i, t);
}
function GT(e, t) {
  var i = e.getNodes(), r = i.length;
  if (ht.DEPRECATED_$isGridSelection(e)) {
    for (var n = ht.$createRangeSelection(), o = n.anchor, s = n.focus, a = 0; a < r; a++) {
      var l = i[a];
      ht.DEPRECATED_$isGridCellNode(l) && (o.set(l.getKey(), 0, "element"), s.set(l.getKey(), l.getChildrenSize(), "element"), GT(ht.$normalizeSelection__EXPERIMENTAL(n), t));
    }
    ht.$setSelection(e);
  } else if (--r, n = i[0], o = i[r], e.isCollapsed())
    Mu(e, t);
  else {
    var c = e.anchor, u = e.focus;
    a = n.getTextContent().length, l = u.offset;
    var m = c.offset, g = c.isBefore(u);
    s = g ? m : l, e = g ? l : m;
    var h = g ? c.type : u.type, A = g ? u.type : c.type;
    if (c = g ? u.key : c.key, ht.$isTextNode(n) && s === a && (u = n.getNextSibling(), ht.$isTextNode(u) && (s = m = 0, n = u)), i.length === 1)
      ht.$isTextNode(n) && (s = h === "element" ? 0 : m > l ? l : m, e = A === "element" ? a : m > l ? m : l, s !== e && (s === 0 && e === a ? (Mu(n, t), n.select(s, e)) : (i = n.splitText(s, e), i = s === 0 ? i[0] : i[1], Mu(i, t), i.select(0, e - s))));
    else
      for (ht.$isTextNode(n) && s < n.getTextContentSize() && (s !== 0 && (n = n.splitText(s)[1]), Mu(n, t)), ht.$isTextNode(o) && (s = o.getTextContent().length, o.__key !== c && e !== 0 && (e = s), e !== s && ([o] = o.splitText(e)), e !== 0 && Mu(o, t)), e = 1; e < r; e++)
        s = i[e], a = s.getKey(), ht.$isTextNode(s) && a !== n.getKey() && a !== o.getKey() && !s.isToken() && Mu(s, t);
  }
}
function R9(e) {
  for (; e !== null && !ht.$isRootOrShadowRoot(e); ) {
    let t = e.getLatest(), i = e.getParent();
    t.getChildrenSize() === 0 && e.remove(!0), e = i;
  }
}
function jy(e, t, i, r, n = null) {
  if (t.length !== 0) {
    var o = t[0], s = /* @__PURE__ */ new Map(), a = [];
    o = ht.$isElementNode(o) ? o : o.getParentOrThrow(), o.isInline() && (o = o.getParentOrThrow());
    for (var l = !1; o !== null; ) {
      var c = o.getPreviousSibling();
      if (c !== null) {
        o = c, l = !0;
        break;
      }
      if (o = o.getParentOrThrow(), ht.$isRootOrShadowRoot(o))
        break;
    }
    c = /* @__PURE__ */ new Set();
    for (var u = 0; u < i; u++) {
      var m = t[u];
      ht.$isElementNode(m) && m.getChildrenSize() === 0 && c.add(m.getKey());
    }
    var g = /* @__PURE__ */ new Set();
    for (u = 0; u < i; u++) {
      m = t[u];
      var h = m.getParent();
      if (h !== null && h.isInline() && (h = h.getParent()), h !== null && ht.$isLeafNode(m) && !g.has(m.getKey())) {
        if (m = h.getKey(), s.get(m) === void 0) {
          let A = r();
          A.setFormat(h.getFormatType()), A.setIndent(h.getIndent()), a.push(A), s.set(m, A), h.getChildren().forEach((y) => {
            A.append(y), g.add(y.getKey()), ht.$isElementNode(y) && y.getChildrenKeys().forEach((E) => g.add(E));
          }), R9(h);
        }
      } else
        c.has(m.getKey()) && (h = r(), h.setFormat(m.getFormatType()), h.setIndent(m.getIndent()), a.push(h), m.remove(!0));
    }
    if (n !== null)
      for (t = 0; t < a.length; t++)
        n.append(a[t]);
    if (t = null, ht.$isRootOrShadowRoot(o))
      if (l)
        if (n !== null)
          o.insertAfter(n);
        else
          for (n = a.length - 1; 0 <= n; n--)
            o.insertAfter(a[n]);
      else if (l = o.getFirstChild(), ht.$isElementNode(l) && (o = l), l === null)
        if (n)
          o.append(n);
        else
          for (n = 0; n < a.length; n++)
            l = a[n], o.append(l), t = l;
      else if (n !== null)
        l.insertBefore(n);
      else
        for (o = 0; o < a.length; o++)
          n = a[o], l.insertBefore(n), t = n;
    else if (n)
      o.insertAfter(n);
    else
      for (n = a.length - 1; 0 <= n; n--)
        l = a[n], o.insertAfter(l), t = l;
    a = ht.$getPreviousSelection(), ht.$isRangeSelection(a) && a.anchor.getNode().isAttached() && a.focus.getNode().isAttached() ? ht.$setSelection(a.clone()) : t !== null ? t.selectEnd() : e.dirty = !0;
  }
}
function QT(e, t, i, r) {
  e.modify(t ? "extend" : "move", i, r);
}
function WT(e) {
  return e = e.anchor.getNode(), (ht.$isRootNode(e) ? e : e.getParentOrThrow()).getDirection() === "rtl";
}
Vr.$addNodeStyle = function(e) {
  e = e.getStyle();
  let t = UT(e);
  d1.set(e, t);
};
Vr.$cloneWithProperties = function(e) {
  let t = e.constructor.clone(e);
  return t.__parent = e.__parent, t.__next = e.__next, t.__prev = e.__prev, ht.$isElementNode(e) && ht.$isElementNode(t) ? (t.__first = e.__first, t.__last = e.__last, t.__size = e.__size, t.__format = e.__format, t.__indent = e.__indent, t.__dir = e.__dir, t) : (ht.$isTextNode(e) && ht.$isTextNode(t) && (t.__format = e.__format, t.__style = e.__style, t.__mode = e.__mode, t.__detail = e.__detail), t);
};
Vr.$getSelectionStyleValueForProperty = function(e, t, i = "") {
  let r = null, n = e.getNodes();
  var o = e.anchor, s = e.focus, a = e.isBackward();
  let l = a ? s.offset : o.offset;
  if (o = a ? s.getNode() : o.getNode(), e.style !== "" && (e = m1(e.style), e !== null && t in e))
    return e[t];
  for (e = 0; e < n.length; e++) {
    var c = n[e];
    if ((e === 0 || l !== 0 || !c.is(o)) && ht.$isTextNode(c)) {
      if (s = t, a = i, c = c.getStyle(), c = m1(c), s = c !== null && c[s] || a, r === null)
        r = s;
      else if (r !== s) {
        r = "";
        break;
      }
    }
  }
  return r === null ? i : r;
};
Vr.$isAtNodeEnd = function(e) {
  return e.type === "text" ? e.offset === e.getNode().getTextContentSize() : e.offset === e.getNode().getChildrenSize();
};
Vr.$isParentElementRTL = WT;
Vr.$moveCaretSelection = QT;
Vr.$moveCharacter = function(e, t, i) {
  let r = WT(e);
  QT(e, t, i ? !r : r, "character");
};
Vr.$patchStyleText = GT;
Vr.$selectAll = function(e) {
  let t = e.anchor;
  e = e.focus;
  var i = t.getNode().getTopLevelElementOrThrow().getParentOrThrow();
  let r = i.getFirstDescendant();
  i = i.getLastDescendant();
  let n = "element", o = "element", s = 0;
  ht.$isTextNode(r) ? n = "text" : ht.$isElementNode(r) || r === null || (r = r.getParentOrThrow()), ht.$isTextNode(i) ? (o = "text", s = i.getTextContentSize()) : ht.$isElementNode(i) || i === null || (i = i.getParentOrThrow()), r && i && (t.set(r.getKey(), 0, n), e.set(i.getKey(), s, o));
};
Vr.$setBlocksType = function(e, t) {
  if (e.anchor.key === "root") {
    t = t();
    var i = ht.$getRoot();
    (e = i.getFirstChild()) ? e.replace(t, !0) : i.append(t);
  } else
    for (i = e.getNodes(), e = e.anchor.getNode().getParentOrThrow(), i.indexOf(e) === -1 && i.push(e), e.isInline() && (e = e.getParentOrThrow(), i.indexOf(e) === -1 && i.push(e)), e = 0; e < i.length; e++) {
      let o = i[e];
      var r = o;
      if (!ht.$isElementNode(r) || ht.$isRootOrShadowRoot(r))
        r = !1;
      else {
        var n = r.getFirstChild();
        n = n === null || ht.$isLineBreakNode(n) || ht.$isTextNode(n) || n.isInline(), r = !r.isInline() && r.canBeEmpty() !== !1 && n;
      }
      r && (r = t(), r.setFormat(o.getFormatType()), r.setIndent(o.getIndent()), o.replace(r, !0));
    }
};
Vr.$shouldOverrideDefaultCharacterSelection = function(e, t) {
  return e = ht.$getAdjacentNode(e.focus, t), ht.$isDecoratorNode(e) && !e.isIsolated() || ht.$isElementNode(e) && !e.isInline() && !e.canBeEmpty();
};
Vr.$sliceSelectedTextNodeContent = function(e, t) {
  if (t.isSelected() && !t.isSegmented() && !t.isToken() && (ht.$isRangeSelection(e) || ht.DEPRECATED_$isGridSelection(e))) {
    var i = e.anchor.getNode(), r = e.focus.getNode(), n = t.is(i), o = t.is(r);
    if (n || o) {
      n = e.isBackward();
      let [s, a] = e.getCharacterOffsets();
      e = i.is(r), o = t.is(n ? r : i), r = t.is(n ? i : r), i = 0;
      let l;
      e ? (i = s > a ? a : s, l = s > a ? s : a) : o ? (i = n ? a : s, l = void 0) : r && (n = n ? s : a, i = 0, l = n), t.__text = t.__text.slice(i, l);
    }
  }
  return t;
};
Vr.$wrapNodes = function(e, t, i = null) {
  var r = e.getNodes();
  let n = r.length;
  var o = e.anchor;
  if (n === 0 || n === 1 && o.type === "element" && o.getNode().getChildrenSize() === 0) {
    e = o.type === "text" ? o.getNode().getParentOrThrow() : o.getNode(), r = e.getChildren();
    let a = t();
    a.setFormat(e.getFormatType()), a.setIndent(e.getIndent()), r.forEach((l) => a.append(l)), i && (a = i.append(a)), e.replace(a);
  } else {
    o = null;
    var s = [];
    for (let a = 0; a < n; a++) {
      let l = r[a];
      ht.$isRootOrShadowRoot(l) ? (jy(e, s, s.length, t, i), s = [], o = l) : o === null || o !== null && ht.$hasAncestor(
        l,
        o
      ) ? s.push(l) : (jy(e, s, s.length, t, i), s = [l]);
    }
    jy(e, s, s.length, t, i);
  }
};
Vr.createDOMRange = function(e, t, i, r, n) {
  let o = t.getKey(), s = r.getKey(), a = document.createRange(), l = e.getElementByKey(o);
  if (e = e.getElementByKey(s), ht.$isTextNode(t) && (l = Pk(l)), ht.$isTextNode(r) && (e = Pk(e)), t === void 0 || r === void 0 || l === null || e === null)
    return null;
  l.nodeName === "BR" && ([l, i] = zk(l)), e.nodeName === "BR" && ([e, n] = zk(e)), t = l.firstChild, l === e && t != null && t.nodeName === "BR" && i === 0 && n === 0 && (n = 1);
  try {
    a.setStart(l, i), a.setEnd(e, n);
  } catch (c) {
    return null;
  }
  return !a.collapsed || i === n && o === s || (a.setStart(e, n), a.setEnd(
    l,
    i
  )), a;
};
Vr.createRectsFromDOMRange = function(e, t) {
  var i = e.getRootElement();
  if (i === null)
    return [];
  e = i.getBoundingClientRect(), i = getComputedStyle(i), i = parseFloat(i.paddingLeft) + parseFloat(i.paddingRight), t = Array.from(t.getClientRects());
  let r = t.length;
  t.sort((o, s) => {
    let a = o.top - s.top;
    return 3 >= Math.abs(a) ? o.left - s.left : a;
  });
  let n;
  for (let o = 0; o < r; o++) {
    let s = t[o], a = s.width + i === e.width;
    n && n.top <= s.top && n.top + n.height > s.top && n.left + n.width > s.left || a ? (t.splice(o--, 1), r--) : n = s;
  }
  return t;
};
Vr.getStyleObjectFromCSS = m1;
Vr.trimTextContentFromAnchor = function(e, t, i) {
  let r = t.getNode();
  if (ht.$isElementNode(r)) {
    var n = r.getDescendantByIndex(t.offset);
    n !== null && (r = n);
  }
  for (; 0 < i && r !== null; ) {
    var o = r.getPreviousSibling(), s = 0;
    if (o === null) {
      n = r.getParentOrThrow();
      for (var a = n.getPreviousSibling(); a === null; ) {
        if (n = n.getParent(), n === null) {
          o = null;
          break;
        }
        a = n.getPreviousSibling();
      }
      n !== null && (s = n.isInline() ? 0 : 2, o = ht.$isElementNode(a) ? a.getLastDescendant() : a);
    }
    if (a = r.getTextContent(), a === "" && ht.$isElementNode(r) && !r.isInline() && (a = `

`), n = a.length, !ht.$isTextNode(r) || i >= n)
      a = r.getParent(), r.remove(), a == null || a.getChildrenSize() !== 0 || ht.$isRootNode(a) || a.remove(), i -= n + s, r = o;
    else {
      let l = r.getKey();
      s = e.getEditorState().read(() => {
        const u = ht.$getNodeByKey(l);
        return ht.$isTextNode(u) && u.isSimpleText() ? u.getTextContent() : null;
      }), o = n - i;
      let c = a.slice(0, o);
      s !== null && s !== a ? (i = ht.$getPreviousSelection(), n = r, r.isSimpleText() ? r.setTextContent(s) : (n = ht.$createTextNode(s), r.replace(n)), ht.$isRangeSelection(i) && i.isCollapsed() && (i = i.anchor.offset, n.select(
        i,
        i
      ))) : r.isSimpleText() ? (s = t.key === l, a = t.offset, a < i && (a = n), i = s ? a - i : 0, n = s ? a : o, s && i === 0 ? ([i] = r.splitText(i, n), i.remove()) : ([, i] = r.splitText(i, n), i.remove())) : (i = ht.$createTextNode(c), r.replace(i)), i = 0;
    }
  }
};
const k9 = Vr;
var wi = k9, w9 = wi, ur = L;
function M9(e) {
  let t = new URLSearchParams();
  t.append("code", e);
  for (let i = 1; i < arguments.length; i++)
    t.append("v", arguments[i]);
  throw Error(`Minified Lexical error #${e}; visit https://lexical.dev/docs/error?${t} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
}
function ZT(e, t) {
  for (let i of t)
    if (e.type.startsWith(i))
      return !0;
  return !1;
}
function JT(e, t) {
  for (; e !== ur.$getRoot() && e != null; ) {
    if (t(e))
      return e;
    e = e.getParent();
  }
  return null;
}
gr.$splitNode = ur.$splitNode;
gr.isHTMLAnchorElement = ur.isHTMLAnchorElement;
gr.isHTMLElement = ur.isHTMLElement;
gr.$dfs = function(e, t) {
  let i = [];
  e = (e || ur.$getRoot()).getLatest(), t = t || (ur.$isElementNode(e) ? e.getLastDescendant() : e);
  for (var r = e, n = 0; (r = r.getParent()) !== null; )
    n++;
  for (r = n; e !== null && !e.is(t); )
    if (i.push({ depth: r, node: e }), ur.$isElementNode(e) && 0 < e.getChildrenSize())
      e = e.getFirstChild(), r++;
    else
      for (n = null; n === null && e !== null; )
        n = e.getNextSibling(), n === null ? (e = e.getParent(), r--) : e = n;
  return e !== null && e.is(t) && i.push({ depth: r, node: e }), i;
};
gr.$filter = function(e, t) {
  let i = [];
  for (let r = 0; r < e.length; r++) {
    let n = t(e[r]);
    n !== null && i.push(n);
  }
  return i;
};
gr.$findMatchingParent = JT;
gr.$getNearestBlockElementAncestorOrThrow = function(e) {
  let t = JT(e, (i) => ur.$isElementNode(i) && !i.isInline());
  return ur.$isElementNode(t) || M9(4, e.__key), t;
};
gr.$getNearestNodeOfType = function(e, t) {
  for (; e != null; ) {
    if (e instanceof t)
      return e;
    e = e.getParent();
  }
  return null;
};
gr.$insertFirst = function(e, t) {
  let i = e.getFirstChild();
  i !== null ? i.insertBefore(t) : e.append(t);
};
gr.$insertNodeToNearestRoot = function(e) {
  var t = ur.$getSelection() || ur.$getPreviousSelection();
  if (ur.$isRangeSelection(t)) {
    var { focus: i } = t;
    if (t = i.getNode(), i = i.offset, ur.$isRootOrShadowRoot(t))
      i = t.getChildAtIndex(i), i == null ? t.append(e) : i.insertBefore(e), e.selectNext();
    else {
      let r, n;
      ur.$isTextNode(t) ? (r = t.getParentOrThrow(), n = t.getIndexWithinParent(), 0 < i && (n += 1, t.splitText(i))) : (r = t, n = i), [, t] = ur.$splitNode(r, n), t.insertBefore(e), t.selectStart();
    }
  } else
    ur.$isNodeSelection(t) || ur.DEPRECATED_$isGridSelection(t) ? (t = t.getNodes(), t[t.length - 1].getTopLevelElementOrThrow().insertAfter(e)) : ur.$getRoot().append(e), t = ur.$createParagraphNode(), e.insertAfter(t), t.select();
  return e.getLatest();
};
gr.$restoreEditorState = function(e, t) {
  let i = /* @__PURE__ */ new Map(), r = e._pendingEditorState;
  for (let [n, o] of t._nodeMap) {
    let s = w9.$cloneWithProperties(o);
    ur.$isTextNode(s) && (s.__text = o.__text), i.set(n, s);
  }
  r && (r._nodeMap = i), e._dirtyType = 2, e = t._selection, ur.$setSelection(e === null ? null : e.clone());
};
gr.$wrapNodeInElement = function(e, t) {
  return t = t(), e.replace(t), t.append(e), t;
};
gr.addClassNamesToElement = function(e, ...t) {
  t.forEach((i) => {
    typeof i == "string" && (i = i.split(" ").filter((r) => r !== ""), e.classList.add(...i));
  });
};
gr.isMimeType = ZT;
gr.mediaFileReader = function(e, t) {
  let i = e[Symbol.iterator]();
  return new Promise((r, n) => {
    let o = [], s = () => {
      const { done: a, value: l } = i.next();
      if (a)
        return r(o);
      const c = new FileReader();
      c.addEventListener("error", n), c.addEventListener("load", () => {
        const u = c.result;
        typeof u == "string" && o.push({ file: l, result: u }), s();
      }), ZT(l, t) ? c.readAsDataURL(l) : s();
    };
    s();
  });
};
gr.mergeRegister = function(...e) {
  return () => {
    e.forEach((t) => t());
  };
};
gr.objectKlassEquals = function(e, t) {
  return e !== null ? Object.getPrototypeOf(e).constructor.name === t.name : !1;
};
gr.registerNestedElementResolver = function(e, t, i, r) {
  return e.registerNodeTransform(t, (n) => {
    e: {
      for (var o = n.getChildren(), s = 0; s < o.length; s++)
        if (o[s] instanceof t) {
          o = null;
          break e;
        }
      for (o = n; o !== null; )
        if (s = o, o = o.getParent(), o instanceof t) {
          o = { child: s, parent: o };
          break e;
        }
      o = null;
    }
    if (o !== null) {
      const { child: a, parent: l } = o;
      if (a.is(n)) {
        if (r(l, n), n = a.getNextSiblings(), o = n.length, l.insertAfter(a), o !== 0) {
          s = i(l), a.insertAfter(s);
          for (let c = 0; c < o; c++)
            s.append(n[c]);
        }
        l.canBeEmpty() || l.getChildrenSize() !== 0 || l.remove();
      }
    }
  });
};
gr.removeClassNamesFromElement = function(e, ...t) {
  t.forEach((i) => {
    typeof i == "string" && e.classList.remove(...i.split(" "));
  });
};
const N9 = gr;
var it = N9, g1 = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
g1.exports;
(function(e, t) {
  (function() {
    var i, r = "4.17.21", n = 200, o = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", s = "Expected a function", a = "Invalid `variable` option passed into `_.template`", l = "__lodash_hash_undefined__", c = 500, u = "__lodash_placeholder__", m = 1, g = 2, h = 4, A = 1, y = 2, E = 1, v = 2, C = 4, x = 8, S = 16, R = 32, w = 64, T = 128, N = 256, D = 512, O = 30, F = "...", Y = 800, P = 16, z = 1, W = 2, H = 3, Q = 1 / 0, $ = 9007199254740991, le = 17976931348623157e292, he = 0 / 0, oe = 4294967295, ue = oe - 1, Ae = oe >>> 1, de = [
      ["ary", T],
      ["bind", E],
      ["bindKey", v],
      ["curry", x],
      ["curryRight", S],
      ["flip", D],
      ["partial", R],
      ["partialRight", w],
      ["rearg", N]
    ], fe = "[object Arguments]", Re = "[object Array]", qe = "[object AsyncFunction]", Oe = "[object Boolean]", Xe = "[object Date]", Qe = "[object DOMException]", Pe = "[object Error]", et = "[object Function]", At = "[object GeneratorFunction]", Et = "[object Map]", oi = "[object Number]", Ai = "[object Null]", ut = "[object Object]", qt = "[object Promise]", Ht = "[object Proxy]", ri = "[object RegExp]", Ke = "[object Set]", dt = "[object String]", kt = "[object Symbol]", si = "[object Undefined]", Dt = "[object WeakMap]", yi = "[object WeakSet]", ei = "[object ArrayBuffer]", nr = "[object DataView]", fr = "[object Float32Array]", Sr = "[object Float64Array]", As = "[object Int8Array]", $s = "[object Int16Array]", od = "[object Int32Array]", mu = "[object Uint8Array]", gu = "[object Uint8ClampedArray]", sd = "[object Uint16Array]", ad = "[object Uint32Array]", Jg = /\b__p \+= '';/g, uA = /\b(__p \+=) '' \+/g, Pg = /(__e\(.*?\)|\b__t\)) \+\n'';/g, zg = /&(?:amp|lt|gt|quot|#39);/g, ld = /[&<>"']/g, dA = RegExp(zg.source), mA = RegExp(ld.source), gA = /<%-([\s\S]+?)%>/g, Hg = /<%([\s\S]+?)%>/g, Xg = /<%=([\s\S]+?)%>/g, hA = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, _g = /^\w*$/, pA = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, hu = /[\\^$.*+?()[\]{}|]/g, ln = RegExp(hu.source), Io = /^\s+/, $g = /\s/, fA = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, oj = /\{\n\/\* \[wrapped with (.+)\] \*/, sj = /,? & /, aj = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, lj = /[()=,{}\[\]\/\s]/, cj = /\\(\\)?/g, uj = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, zI = /\w*$/, dj = /^[-+]0x[0-9a-f]+$/i, mj = /^0b[01]+$/i, gj = /^\[object .+?Constructor\]$/, hj = /^0o[0-7]+$/i, pj = /^(?:0|[1-9]\d*)$/, fj = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, eh = /($^)/, Aj = /['\n\r\u2028\u2029\\]/g, th = "\\ud800-\\udfff", yj = "\\u0300-\\u036f", Ej = "\\ufe20-\\ufe2f", vj = "\\u20d0-\\u20ff", HI = yj + Ej + vj, XI = "\\u2700-\\u27bf", _I = "a-z\\xdf-\\xf6\\xf8-\\xff", bj = "\\xac\\xb1\\xd7\\xf7", Cj = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", xj = "\\u2000-\\u206f", Ij = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", $I = "A-Z\\xc0-\\xd6\\xd8-\\xde", eS = "\\ufe0e\\ufe0f", tS = bj + Cj + xj + Ij, AA = "['’]", Sj = "[" + th + "]", iS = "[" + tS + "]", ih = "[" + HI + "]", rS = "\\d+", Rj = "[" + XI + "]", nS = "[" + _I + "]", oS = "[^" + th + tS + rS + XI + _I + $I + "]", yA = "\\ud83c[\\udffb-\\udfff]", kj = "(?:" + ih + "|" + yA + ")", sS = "[^" + th + "]", EA = "(?:\\ud83c[\\udde6-\\uddff]){2}", vA = "[\\ud800-\\udbff][\\udc00-\\udfff]", pu = "[" + $I + "]", aS = "\\u200d", lS = "(?:" + nS + "|" + oS + ")", wj = "(?:" + pu + "|" + oS + ")", cS = "(?:" + AA + "(?:d|ll|m|re|s|t|ve))?", uS = "(?:" + AA + "(?:D|LL|M|RE|S|T|VE))?", dS = kj + "?", mS = "[" + eS + "]?", Mj = "(?:" + aS + "(?:" + [sS, EA, vA].join("|") + ")" + mS + dS + ")*", Nj = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Tj = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", gS = mS + dS + Mj, Bj = "(?:" + [Rj, EA, vA].join("|") + ")" + gS, Dj = "(?:" + [sS + ih + "?", ih, EA, vA, Sj].join("|") + ")", Oj = RegExp(AA, "g"), Fj = RegExp(ih, "g"), bA = RegExp(yA + "(?=" + yA + ")|" + Dj + gS, "g"), Vj = RegExp([
      pu + "?" + nS + "+" + cS + "(?=" + [iS, pu, "$"].join("|") + ")",
      wj + "+" + uS + "(?=" + [iS, pu + lS, "$"].join("|") + ")",
      pu + "?" + lS + "+" + cS,
      pu + "+" + uS,
      Tj,
      Nj,
      rS,
      Bj
    ].join("|"), "g"), qj = RegExp("[" + aS + th + HI + eS + "]"), jj = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Lj = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], Kj = -1, Ni = {};
    Ni[fr] = Ni[Sr] = Ni[As] = Ni[$s] = Ni[od] = Ni[mu] = Ni[gu] = Ni[sd] = Ni[ad] = !0, Ni[fe] = Ni[Re] = Ni[ei] = Ni[Oe] = Ni[nr] = Ni[Xe] = Ni[Pe] = Ni[et] = Ni[Et] = Ni[oi] = Ni[ut] = Ni[ri] = Ni[Ke] = Ni[dt] = Ni[Dt] = !1;
    var Ri = {};
    Ri[fe] = Ri[Re] = Ri[ei] = Ri[nr] = Ri[Oe] = Ri[Xe] = Ri[fr] = Ri[Sr] = Ri[As] = Ri[$s] = Ri[od] = Ri[Et] = Ri[oi] = Ri[ut] = Ri[ri] = Ri[Ke] = Ri[dt] = Ri[kt] = Ri[mu] = Ri[gu] = Ri[sd] = Ri[ad] = !0, Ri[Pe] = Ri[et] = Ri[Dt] = !1;
    var Yj = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, Uj = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, Gj = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, Qj = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, Wj = parseFloat, Zj = parseInt, hS = typeof yt == "object" && yt && yt.Object === Object && yt, Jj = typeof self == "object" && self && self.Object === Object && self, jr = hS || Jj || Function("return this")(), CA = t && !t.nodeType && t, zl = CA && !0 && e && !e.nodeType && e, pS = zl && zl.exports === CA, xA = pS && hS.process, So = function() {
      try {
        var ge = zl && zl.require && zl.require("util").types;
        return ge || xA && xA.binding && xA.binding("util");
      } catch (Me) {
      }
    }(), fS = So && So.isArrayBuffer, AS = So && So.isDate, yS = So && So.isMap, ES = So && So.isRegExp, vS = So && So.isSet, bS = So && So.isTypedArray;
    function Hn(ge, Me, Ie) {
      switch (Ie.length) {
        case 0:
          return ge.call(Me);
        case 1:
          return ge.call(Me, Ie[0]);
        case 2:
          return ge.call(Me, Ie[0], Ie[1]);
        case 3:
          return ge.call(Me, Ie[0], Ie[1], Ie[2]);
      }
      return ge.apply(Me, Ie);
    }
    function Pj(ge, Me, Ie, at) {
      for (var Nt = -1, ai = ge == null ? 0 : ge.length; ++Nt < ai; ) {
        var Ar = ge[Nt];
        Me(at, Ar, Ie(Ar), ge);
      }
      return at;
    }
    function Ro(ge, Me) {
      for (var Ie = -1, at = ge == null ? 0 : ge.length; ++Ie < at && Me(ge[Ie], Ie, ge) !== !1; )
        ;
      return ge;
    }
    function zj(ge, Me) {
      for (var Ie = ge == null ? 0 : ge.length; Ie-- && Me(ge[Ie], Ie, ge) !== !1; )
        ;
      return ge;
    }
    function CS(ge, Me) {
      for (var Ie = -1, at = ge == null ? 0 : ge.length; ++Ie < at; )
        if (!Me(ge[Ie], Ie, ge))
          return !1;
      return !0;
    }
    function Ya(ge, Me) {
      for (var Ie = -1, at = ge == null ? 0 : ge.length, Nt = 0, ai = []; ++Ie < at; ) {
        var Ar = ge[Ie];
        Me(Ar, Ie, ge) && (ai[Nt++] = Ar);
      }
      return ai;
    }
    function rh(ge, Me) {
      var Ie = ge == null ? 0 : ge.length;
      return !!Ie && fu(ge, Me, 0) > -1;
    }
    function IA(ge, Me, Ie) {
      for (var at = -1, Nt = ge == null ? 0 : ge.length; ++at < Nt; )
        if (Ie(Me, ge[at]))
          return !0;
      return !1;
    }
    function Di(ge, Me) {
      for (var Ie = -1, at = ge == null ? 0 : ge.length, Nt = Array(at); ++Ie < at; )
        Nt[Ie] = Me(ge[Ie], Ie, ge);
      return Nt;
    }
    function Ua(ge, Me) {
      for (var Ie = -1, at = Me.length, Nt = ge.length; ++Ie < at; )
        ge[Nt + Ie] = Me[Ie];
      return ge;
    }
    function SA(ge, Me, Ie, at) {
      var Nt = -1, ai = ge == null ? 0 : ge.length;
      for (at && ai && (Ie = ge[++Nt]); ++Nt < ai; )
        Ie = Me(Ie, ge[Nt], Nt, ge);
      return Ie;
    }
    function Hj(ge, Me, Ie, at) {
      var Nt = ge == null ? 0 : ge.length;
      for (at && Nt && (Ie = ge[--Nt]); Nt--; )
        Ie = Me(Ie, ge[Nt], Nt, ge);
      return Ie;
    }
    function RA(ge, Me) {
      for (var Ie = -1, at = ge == null ? 0 : ge.length; ++Ie < at; )
        if (Me(ge[Ie], Ie, ge))
          return !0;
      return !1;
    }
    var Xj = kA("length");
    function _j(ge) {
      return ge.split("");
    }
    function $j(ge) {
      return ge.match(aj) || [];
    }
    function xS(ge, Me, Ie) {
      var at;
      return Ie(ge, function(Nt, ai, Ar) {
        if (Me(Nt, ai, Ar))
          return at = ai, !1;
      }), at;
    }
    function nh(ge, Me, Ie, at) {
      for (var Nt = ge.length, ai = Ie + (at ? 1 : -1); at ? ai-- : ++ai < Nt; )
        if (Me(ge[ai], ai, ge))
          return ai;
      return -1;
    }
    function fu(ge, Me, Ie) {
      return Me === Me ? dL(ge, Me, Ie) : nh(ge, IS, Ie);
    }
    function eL(ge, Me, Ie, at) {
      for (var Nt = Ie - 1, ai = ge.length; ++Nt < ai; )
        if (at(ge[Nt], Me))
          return Nt;
      return -1;
    }
    function IS(ge) {
      return ge !== ge;
    }
    function SS(ge, Me) {
      var Ie = ge == null ? 0 : ge.length;
      return Ie ? MA(ge, Me) / Ie : he;
    }
    function kA(ge) {
      return function(Me) {
        return Me == null ? i : Me[ge];
      };
    }
    function wA(ge) {
      return function(Me) {
        return ge == null ? i : ge[Me];
      };
    }
    function RS(ge, Me, Ie, at, Nt) {
      return Nt(ge, function(ai, Ar, vi) {
        Ie = at ? (at = !1, ai) : Me(Ie, ai, Ar, vi);
      }), Ie;
    }
    function tL(ge, Me) {
      var Ie = ge.length;
      for (ge.sort(Me); Ie--; )
        ge[Ie] = ge[Ie].value;
      return ge;
    }
    function MA(ge, Me) {
      for (var Ie, at = -1, Nt = ge.length; ++at < Nt; ) {
        var ai = Me(ge[at]);
        ai !== i && (Ie = Ie === i ? ai : Ie + ai);
      }
      return Ie;
    }
    function NA(ge, Me) {
      for (var Ie = -1, at = Array(ge); ++Ie < ge; )
        at[Ie] = Me(Ie);
      return at;
    }
    function iL(ge, Me) {
      return Di(Me, function(Ie) {
        return [Ie, ge[Ie]];
      });
    }
    function kS(ge) {
      return ge && ge.slice(0, TS(ge) + 1).replace(Io, "");
    }
    function Xn(ge) {
      return function(Me) {
        return ge(Me);
      };
    }
    function TA(ge, Me) {
      return Di(Me, function(Ie) {
        return ge[Ie];
      });
    }
    function cd(ge, Me) {
      return ge.has(Me);
    }
    function wS(ge, Me) {
      for (var Ie = -1, at = ge.length; ++Ie < at && fu(Me, ge[Ie], 0) > -1; )
        ;
      return Ie;
    }
    function MS(ge, Me) {
      for (var Ie = ge.length; Ie-- && fu(Me, ge[Ie], 0) > -1; )
        ;
      return Ie;
    }
    function rL(ge, Me) {
      for (var Ie = ge.length, at = 0; Ie--; )
        ge[Ie] === Me && ++at;
      return at;
    }
    var nL = wA(Yj), oL = wA(Uj);
    function sL(ge) {
      return "\\" + Qj[ge];
    }
    function aL(ge, Me) {
      return ge == null ? i : ge[Me];
    }
    function Au(ge) {
      return qj.test(ge);
    }
    function lL(ge) {
      return jj.test(ge);
    }
    function cL(ge) {
      for (var Me, Ie = []; !(Me = ge.next()).done; )
        Ie.push(Me.value);
      return Ie;
    }
    function BA(ge) {
      var Me = -1, Ie = Array(ge.size);
      return ge.forEach(function(at, Nt) {
        Ie[++Me] = [Nt, at];
      }), Ie;
    }
    function NS(ge, Me) {
      return function(Ie) {
        return ge(Me(Ie));
      };
    }
    function Ga(ge, Me) {
      for (var Ie = -1, at = ge.length, Nt = 0, ai = []; ++Ie < at; ) {
        var Ar = ge[Ie];
        (Ar === Me || Ar === u) && (ge[Ie] = u, ai[Nt++] = Ie);
      }
      return ai;
    }
    function oh(ge) {
      var Me = -1, Ie = Array(ge.size);
      return ge.forEach(function(at) {
        Ie[++Me] = at;
      }), Ie;
    }
    function uL(ge) {
      var Me = -1, Ie = Array(ge.size);
      return ge.forEach(function(at) {
        Ie[++Me] = [at, at];
      }), Ie;
    }
    function dL(ge, Me, Ie) {
      for (var at = Ie - 1, Nt = ge.length; ++at < Nt; )
        if (ge[at] === Me)
          return at;
      return -1;
    }
    function mL(ge, Me, Ie) {
      for (var at = Ie + 1; at--; )
        if (ge[at] === Me)
          return at;
      return at;
    }
    function yu(ge) {
      return Au(ge) ? hL(ge) : Xj(ge);
    }
    function Xo(ge) {
      return Au(ge) ? pL(ge) : _j(ge);
    }
    function TS(ge) {
      for (var Me = ge.length; Me-- && $g.test(ge.charAt(Me)); )
        ;
      return Me;
    }
    var gL = wA(Gj);
    function hL(ge) {
      for (var Me = bA.lastIndex = 0; bA.test(ge); )
        ++Me;
      return Me;
    }
    function pL(ge) {
      return ge.match(bA) || [];
    }
    function fL(ge) {
      return ge.match(Vj) || [];
    }
    var AL = function ge(Me) {
      Me = Me == null ? jr : Eu.defaults(jr.Object(), Me, Eu.pick(jr, Lj));
      var Ie = Me.Array, at = Me.Date, Nt = Me.Error, ai = Me.Function, Ar = Me.Math, vi = Me.Object, DA = Me.RegExp, yL = Me.String, ko = Me.TypeError, sh = Ie.prototype, EL = ai.prototype, vu = vi.prototype, ah = Me["__core-js_shared__"], lh = EL.toString, hi = vu.hasOwnProperty, vL = 0, BS = function() {
        var d = /[^.]+$/.exec(ah && ah.keys && ah.keys.IE_PROTO || "");
        return d ? "Symbol(src)_1." + d : "";
      }(), ch = vu.toString, bL = lh.call(vi), CL = jr._, xL = DA(
        "^" + lh.call(hi).replace(hu, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), uh = pS ? Me.Buffer : i, Qa = Me.Symbol, dh = Me.Uint8Array, DS = uh ? uh.allocUnsafe : i, mh = NS(vi.getPrototypeOf, vi), OS = vi.create, FS = vu.propertyIsEnumerable, gh = sh.splice, VS = Qa ? Qa.isConcatSpreadable : i, ud = Qa ? Qa.iterator : i, Hl = Qa ? Qa.toStringTag : i, hh = function() {
        try {
          var d = tc(vi, "defineProperty");
          return d({}, "", {}), d;
        } catch (p) {
        }
      }(), IL = Me.clearTimeout !== jr.clearTimeout && Me.clearTimeout, SL = at && at.now !== jr.Date.now && at.now, RL = Me.setTimeout !== jr.setTimeout && Me.setTimeout, ph = Ar.ceil, fh = Ar.floor, OA = vi.getOwnPropertySymbols, kL = uh ? uh.isBuffer : i, qS = Me.isFinite, wL = sh.join, ML = NS(vi.keys, vi), yr = Ar.max, zr = Ar.min, NL = at.now, TL = Me.parseInt, jS = Ar.random, BL = sh.reverse, FA = tc(Me, "DataView"), dd = tc(Me, "Map"), VA = tc(Me, "Promise"), bu = tc(Me, "Set"), md = tc(Me, "WeakMap"), gd = tc(vi, "create"), Ah = md && new md(), Cu = {}, DL = ic(FA), OL = ic(dd), FL = ic(VA), VL = ic(bu), qL = ic(md), yh = Qa ? Qa.prototype : i, hd = yh ? yh.valueOf : i, LS = yh ? yh.toString : i;
      function U(d) {
        if (_i(d) && !Bt(d) && !(d instanceof Zt)) {
          if (d instanceof wo)
            return d;
          if (hi.call(d, "__wrapped__"))
            return KR(d);
        }
        return new wo(d);
      }
      var xu = function() {
        function d() {
        }
        return function(p) {
          if (!Gi(p))
            return {};
          if (OS)
            return OS(p);
          d.prototype = p;
          var b = new d();
          return d.prototype = i, b;
        };
      }();
      function Eh() {
      }
      function wo(d, p) {
        this.__wrapped__ = d, this.__actions__ = [], this.__chain__ = !!p, this.__index__ = 0, this.__values__ = i;
      }
      U.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: gA,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: Hg,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: Xg,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: U
        }
      }, U.prototype = Eh.prototype, U.prototype.constructor = U, wo.prototype = xu(Eh.prototype), wo.prototype.constructor = wo;
      function Zt(d) {
        this.__wrapped__ = d, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = oe, this.__views__ = [];
      }
      function jL() {
        var d = new Zt(this.__wrapped__);
        return d.__actions__ = Nn(this.__actions__), d.__dir__ = this.__dir__, d.__filtered__ = this.__filtered__, d.__iteratees__ = Nn(this.__iteratees__), d.__takeCount__ = this.__takeCount__, d.__views__ = Nn(this.__views__), d;
      }
      function LL() {
        if (this.__filtered__) {
          var d = new Zt(this);
          d.__dir__ = -1, d.__filtered__ = !0;
        } else
          d = this.clone(), d.__dir__ *= -1;
        return d;
      }
      function KL() {
        var d = this.__wrapped__.value(), p = this.__dir__, b = Bt(d), M = p < 0, j = b ? d.length : 0, Z = _K(0, j, this.__views__), ie = Z.start, ae = Z.end, pe = ae - ie, Te = M ? ae : ie - 1, De = this.__iteratees__, je = De.length, tt = 0, mt = zr(pe, this.__takeCount__);
        if (!b || !M && j == pe && mt == pe)
          return cR(d, this.__actions__);
        var xt = [];
        e:
          for (; pe-- && tt < mt; ) {
            Te += p;
            for (var Vt = -1, It = d[Te]; ++Vt < je; ) {
              var Gt = De[Vt], Pt = Gt.iteratee, eo = Gt.type, dn = Pt(It);
              if (eo == W)
                It = dn;
              else if (!dn) {
                if (eo == z)
                  continue e;
                break e;
              }
            }
            xt[tt++] = It;
          }
        return xt;
      }
      Zt.prototype = xu(Eh.prototype), Zt.prototype.constructor = Zt;
      function Xl(d) {
        var p = -1, b = d == null ? 0 : d.length;
        for (this.clear(); ++p < b; ) {
          var M = d[p];
          this.set(M[0], M[1]);
        }
      }
      function YL() {
        this.__data__ = gd ? gd(null) : {}, this.size = 0;
      }
      function UL(d) {
        var p = this.has(d) && delete this.__data__[d];
        return this.size -= p ? 1 : 0, p;
      }
      function GL(d) {
        var p = this.__data__;
        if (gd) {
          var b = p[d];
          return b === l ? i : b;
        }
        return hi.call(p, d) ? p[d] : i;
      }
      function QL(d) {
        var p = this.__data__;
        return gd ? p[d] !== i : hi.call(p, d);
      }
      function WL(d, p) {
        var b = this.__data__;
        return this.size += this.has(d) ? 0 : 1, b[d] = gd && p === i ? l : p, this;
      }
      Xl.prototype.clear = YL, Xl.prototype.delete = UL, Xl.prototype.get = GL, Xl.prototype.has = QL, Xl.prototype.set = WL;
      function ea(d) {
        var p = -1, b = d == null ? 0 : d.length;
        for (this.clear(); ++p < b; ) {
          var M = d[p];
          this.set(M[0], M[1]);
        }
      }
      function ZL() {
        this.__data__ = [], this.size = 0;
      }
      function JL(d) {
        var p = this.__data__, b = vh(p, d);
        if (b < 0)
          return !1;
        var M = p.length - 1;
        return b == M ? p.pop() : gh.call(p, b, 1), --this.size, !0;
      }
      function PL(d) {
        var p = this.__data__, b = vh(p, d);
        return b < 0 ? i : p[b][1];
      }
      function zL(d) {
        return vh(this.__data__, d) > -1;
      }
      function HL(d, p) {
        var b = this.__data__, M = vh(b, d);
        return M < 0 ? (++this.size, b.push([d, p])) : b[M][1] = p, this;
      }
      ea.prototype.clear = ZL, ea.prototype.delete = JL, ea.prototype.get = PL, ea.prototype.has = zL, ea.prototype.set = HL;
      function ta(d) {
        var p = -1, b = d == null ? 0 : d.length;
        for (this.clear(); ++p < b; ) {
          var M = d[p];
          this.set(M[0], M[1]);
        }
      }
      function XL() {
        this.size = 0, this.__data__ = {
          hash: new Xl(),
          map: new (dd || ea)(),
          string: new Xl()
        };
      }
      function _L(d) {
        var p = Bh(this, d).delete(d);
        return this.size -= p ? 1 : 0, p;
      }
      function $L(d) {
        return Bh(this, d).get(d);
      }
      function eK(d) {
        return Bh(this, d).has(d);
      }
      function tK(d, p) {
        var b = Bh(this, d), M = b.size;
        return b.set(d, p), this.size += b.size == M ? 0 : 1, this;
      }
      ta.prototype.clear = XL, ta.prototype.delete = _L, ta.prototype.get = $L, ta.prototype.has = eK, ta.prototype.set = tK;
      function _l(d) {
        var p = -1, b = d == null ? 0 : d.length;
        for (this.__data__ = new ta(); ++p < b; )
          this.add(d[p]);
      }
      function iK(d) {
        return this.__data__.set(d, l), this;
      }
      function rK(d) {
        return this.__data__.has(d);
      }
      _l.prototype.add = _l.prototype.push = iK, _l.prototype.has = rK;
      function _o(d) {
        var p = this.__data__ = new ea(d);
        this.size = p.size;
      }
      function nK() {
        this.__data__ = new ea(), this.size = 0;
      }
      function oK(d) {
        var p = this.__data__, b = p.delete(d);
        return this.size = p.size, b;
      }
      function sK(d) {
        return this.__data__.get(d);
      }
      function aK(d) {
        return this.__data__.has(d);
      }
      function lK(d, p) {
        var b = this.__data__;
        if (b instanceof ea) {
          var M = b.__data__;
          if (!dd || M.length < n - 1)
            return M.push([d, p]), this.size = ++b.size, this;
          b = this.__data__ = new ta(M);
        }
        return b.set(d, p), this.size = b.size, this;
      }
      _o.prototype.clear = nK, _o.prototype.delete = oK, _o.prototype.get = sK, _o.prototype.has = aK, _o.prototype.set = lK;
      function KS(d, p) {
        var b = Bt(d), M = !b && rc(d), j = !b && !M && za(d), Z = !b && !M && !j && ku(d), ie = b || M || j || Z, ae = ie ? NA(d.length, yL) : [], pe = ae.length;
        for (var Te in d)
          (p || hi.call(d, Te)) && !(ie && // Safari 9 has enumerable `arguments.length` in strict mode.
          (Te == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          j && (Te == "offset" || Te == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          Z && (Te == "buffer" || Te == "byteLength" || Te == "byteOffset") || // Skip index properties.
          oa(Te, pe))) && ae.push(Te);
        return ae;
      }
      function YS(d) {
        var p = d.length;
        return p ? d[JA(0, p - 1)] : i;
      }
      function cK(d, p) {
        return Dh(Nn(d), $l(p, 0, d.length));
      }
      function uK(d) {
        return Dh(Nn(d));
      }
      function qA(d, p, b) {
        (b !== i && !$o(d[p], b) || b === i && !(p in d)) && ia(d, p, b);
      }
      function pd(d, p, b) {
        var M = d[p];
        (!(hi.call(d, p) && $o(M, b)) || b === i && !(p in d)) && ia(d, p, b);
      }
      function vh(d, p) {
        for (var b = d.length; b--; )
          if ($o(d[b][0], p))
            return b;
        return -1;
      }
      function dK(d, p, b, M) {
        return Wa(d, function(j, Z, ie) {
          p(M, j, b(j), ie);
        }), M;
      }
      function US(d, p) {
        return d && Es(p, Rr(p), d);
      }
      function mK(d, p) {
        return d && Es(p, Bn(p), d);
      }
      function ia(d, p, b) {
        p == "__proto__" && hh ? hh(d, p, {
          configurable: !0,
          enumerable: !0,
          value: b,
          writable: !0
        }) : d[p] = b;
      }
      function jA(d, p) {
        for (var b = -1, M = p.length, j = Ie(M), Z = d == null; ++b < M; )
          j[b] = Z ? i : yy(d, p[b]);
        return j;
      }
      function $l(d, p, b) {
        return d === d && (b !== i && (d = d <= b ? d : b), p !== i && (d = d >= p ? d : p)), d;
      }
      function Mo(d, p, b, M, j, Z) {
        var ie, ae = p & m, pe = p & g, Te = p & h;
        if (b && (ie = j ? b(d, M, j, Z) : b(d)), ie !== i)
          return ie;
        if (!Gi(d))
          return d;
        var De = Bt(d);
        if (De) {
          if (ie = eY(d), !ae)
            return Nn(d, ie);
        } else {
          var je = Hr(d), tt = je == et || je == At;
          if (za(d))
            return mR(d, ae);
          if (je == ut || je == fe || tt && !j) {
            if (ie = pe || tt ? {} : TR(d), !ae)
              return pe ? GK(d, mK(ie, d)) : UK(d, US(ie, d));
          } else {
            if (!Ri[je])
              return j ? d : {};
            ie = tY(d, je, ae);
          }
        }
        Z || (Z = new _o());
        var mt = Z.get(d);
        if (mt)
          return mt;
        Z.set(d, ie), sk(d) ? d.forEach(function(It) {
          ie.add(Mo(It, p, b, It, d, Z));
        }) : nk(d) && d.forEach(function(It, Gt) {
          ie.set(Gt, Mo(It, p, b, Gt, d, Z));
        });
        var xt = Te ? pe ? ny : ry : pe ? Bn : Rr, Vt = De ? i : xt(d);
        return Ro(Vt || d, function(It, Gt) {
          Vt && (Gt = It, It = d[Gt]), pd(ie, Gt, Mo(It, p, b, Gt, d, Z));
        }), ie;
      }
      function gK(d) {
        var p = Rr(d);
        return function(b) {
          return GS(b, d, p);
        };
      }
      function GS(d, p, b) {
        var M = b.length;
        if (d == null)
          return !M;
        for (d = vi(d); M--; ) {
          var j = b[M], Z = p[j], ie = d[j];
          if (ie === i && !(j in d) || !Z(ie))
            return !1;
        }
        return !0;
      }
      function QS(d, p, b) {
        if (typeof d != "function")
          throw new ko(s);
        return Cd(function() {
          d.apply(i, b);
        }, p);
      }
      function fd(d, p, b, M) {
        var j = -1, Z = rh, ie = !0, ae = d.length, pe = [], Te = p.length;
        if (!ae)
          return pe;
        b && (p = Di(p, Xn(b))), M ? (Z = IA, ie = !1) : p.length >= n && (Z = cd, ie = !1, p = new _l(p));
        e:
          for (; ++j < ae; ) {
            var De = d[j], je = b == null ? De : b(De);
            if (De = M || De !== 0 ? De : 0, ie && je === je) {
              for (var tt = Te; tt--; )
                if (p[tt] === je)
                  continue e;
              pe.push(De);
            } else
              Z(p, je, M) || pe.push(De);
          }
        return pe;
      }
      var Wa = AR(ys), WS = AR(KA, !0);
      function hK(d, p) {
        var b = !0;
        return Wa(d, function(M, j, Z) {
          return b = !!p(M, j, Z), b;
        }), b;
      }
      function bh(d, p, b) {
        for (var M = -1, j = d.length; ++M < j; ) {
          var Z = d[M], ie = p(Z);
          if (ie != null && (ae === i ? ie === ie && !$n(ie) : b(ie, ae)))
            var ae = ie, pe = Z;
        }
        return pe;
      }
      function pK(d, p, b, M) {
        var j = d.length;
        for (b = Ot(b), b < 0 && (b = -b > j ? 0 : j + b), M = M === i || M > j ? j : Ot(M), M < 0 && (M += j), M = b > M ? 0 : lk(M); b < M; )
          d[b++] = p;
        return d;
      }
      function ZS(d, p) {
        var b = [];
        return Wa(d, function(M, j, Z) {
          p(M, j, Z) && b.push(M);
        }), b;
      }
      function Lr(d, p, b, M, j) {
        var Z = -1, ie = d.length;
        for (b || (b = rY), j || (j = []); ++Z < ie; ) {
          var ae = d[Z];
          p > 0 && b(ae) ? p > 1 ? Lr(ae, p - 1, b, M, j) : Ua(j, ae) : M || (j[j.length] = ae);
        }
        return j;
      }
      var LA = yR(), JS = yR(!0);
      function ys(d, p) {
        return d && LA(d, p, Rr);
      }
      function KA(d, p) {
        return d && JS(d, p, Rr);
      }
      function Ch(d, p) {
        return Ya(p, function(b) {
          return sa(d[b]);
        });
      }
      function ec(d, p) {
        p = Ja(p, d);
        for (var b = 0, M = p.length; d != null && b < M; )
          d = d[vs(p[b++])];
        return b && b == M ? d : i;
      }
      function PS(d, p, b) {
        var M = p(d);
        return Bt(d) ? M : Ua(M, b(d));
      }
      function cn(d) {
        return d == null ? d === i ? si : Ai : Hl && Hl in vi(d) ? XK(d) : uY(d);
      }
      function YA(d, p) {
        return d > p;
      }
      function fK(d, p) {
        return d != null && hi.call(d, p);
      }
      function AK(d, p) {
        return d != null && p in vi(d);
      }
      function yK(d, p, b) {
        return d >= zr(p, b) && d < yr(p, b);
      }
      function UA(d, p, b) {
        for (var M = b ? IA : rh, j = d[0].length, Z = d.length, ie = Z, ae = Ie(Z), pe = 1 / 0, Te = []; ie--; ) {
          var De = d[ie];
          ie && p && (De = Di(De, Xn(p))), pe = zr(De.length, pe), ae[ie] = !b && (p || j >= 120 && De.length >= 120) ? new _l(ie && De) : i;
        }
        De = d[0];
        var je = -1, tt = ae[0];
        e:
          for (; ++je < j && Te.length < pe; ) {
            var mt = De[je], xt = p ? p(mt) : mt;
            if (mt = b || mt !== 0 ? mt : 0, !(tt ? cd(tt, xt) : M(Te, xt, b))) {
              for (ie = Z; --ie; ) {
                var Vt = ae[ie];
                if (!(Vt ? cd(Vt, xt) : M(d[ie], xt, b)))
                  continue e;
              }
              tt && tt.push(xt), Te.push(mt);
            }
          }
        return Te;
      }
      function EK(d, p, b, M) {
        return ys(d, function(j, Z, ie) {
          p(M, b(j), Z, ie);
        }), M;
      }
      function Ad(d, p, b) {
        p = Ja(p, d), d = FR(d, p);
        var M = d == null ? d : d[vs(To(p))];
        return M == null ? i : Hn(M, d, b);
      }
      function zS(d) {
        return _i(d) && cn(d) == fe;
      }
      function vK(d) {
        return _i(d) && cn(d) == ei;
      }
      function bK(d) {
        return _i(d) && cn(d) == Xe;
      }
      function yd(d, p, b, M, j) {
        return d === p ? !0 : d == null || p == null || !_i(d) && !_i(p) ? d !== d && p !== p : CK(d, p, b, M, yd, j);
      }
      function CK(d, p, b, M, j, Z) {
        var ie = Bt(d), ae = Bt(p), pe = ie ? Re : Hr(d), Te = ae ? Re : Hr(p);
        pe = pe == fe ? ut : pe, Te = Te == fe ? ut : Te;
        var De = pe == ut, je = Te == ut, tt = pe == Te;
        if (tt && za(d)) {
          if (!za(p))
            return !1;
          ie = !0, De = !1;
        }
        if (tt && !De)
          return Z || (Z = new _o()), ie || ku(d) ? wR(d, p, b, M, j, Z) : zK(d, p, pe, b, M, j, Z);
        if (!(b & A)) {
          var mt = De && hi.call(d, "__wrapped__"), xt = je && hi.call(p, "__wrapped__");
          if (mt || xt) {
            var Vt = mt ? d.value() : d, It = xt ? p.value() : p;
            return Z || (Z = new _o()), j(Vt, It, b, M, Z);
          }
        }
        return tt ? (Z || (Z = new _o()), HK(d, p, b, M, j, Z)) : !1;
      }
      function xK(d) {
        return _i(d) && Hr(d) == Et;
      }
      function GA(d, p, b, M) {
        var j = b.length, Z = j, ie = !M;
        if (d == null)
          return !Z;
        for (d = vi(d); j--; ) {
          var ae = b[j];
          if (ie && ae[2] ? ae[1] !== d[ae[0]] : !(ae[0] in d))
            return !1;
        }
        for (; ++j < Z; ) {
          ae = b[j];
          var pe = ae[0], Te = d[pe], De = ae[1];
          if (ie && ae[2]) {
            if (Te === i && !(pe in d))
              return !1;
          } else {
            var je = new _o();
            if (M)
              var tt = M(Te, De, pe, d, p, je);
            if (!(tt === i ? yd(De, Te, A | y, M, je) : tt))
              return !1;
          }
        }
        return !0;
      }
      function HS(d) {
        if (!Gi(d) || oY(d))
          return !1;
        var p = sa(d) ? xL : gj;
        return p.test(ic(d));
      }
      function IK(d) {
        return _i(d) && cn(d) == ri;
      }
      function SK(d) {
        return _i(d) && Hr(d) == Ke;
      }
      function RK(d) {
        return _i(d) && Lh(d.length) && !!Ni[cn(d)];
      }
      function XS(d) {
        return typeof d == "function" ? d : d == null ? Dn : typeof d == "object" ? Bt(d) ? eR(d[0], d[1]) : $S(d) : Ek(d);
      }
      function QA(d) {
        if (!bd(d))
          return ML(d);
        var p = [];
        for (var b in vi(d))
          hi.call(d, b) && b != "constructor" && p.push(b);
        return p;
      }
      function kK(d) {
        if (!Gi(d))
          return cY(d);
        var p = bd(d), b = [];
        for (var M in d)
          M == "constructor" && (p || !hi.call(d, M)) || b.push(M);
        return b;
      }
      function WA(d, p) {
        return d < p;
      }
      function _S(d, p) {
        var b = -1, M = Tn(d) ? Ie(d.length) : [];
        return Wa(d, function(j, Z, ie) {
          M[++b] = p(j, Z, ie);
        }), M;
      }
      function $S(d) {
        var p = sy(d);
        return p.length == 1 && p[0][2] ? DR(p[0][0], p[0][1]) : function(b) {
          return b === d || GA(b, d, p);
        };
      }
      function eR(d, p) {
        return ly(d) && BR(p) ? DR(vs(d), p) : function(b) {
          var M = yy(b, d);
          return M === i && M === p ? Ey(b, d) : yd(p, M, A | y);
        };
      }
      function xh(d, p, b, M, j) {
        d !== p && LA(p, function(Z, ie) {
          if (j || (j = new _o()), Gi(Z))
            wK(d, p, ie, b, xh, M, j);
          else {
            var ae = M ? M(uy(d, ie), Z, ie + "", d, p, j) : i;
            ae === i && (ae = Z), qA(d, ie, ae);
          }
        }, Bn);
      }
      function wK(d, p, b, M, j, Z, ie) {
        var ae = uy(d, b), pe = uy(p, b), Te = ie.get(pe);
        if (Te) {
          qA(d, b, Te);
          return;
        }
        var De = Z ? Z(ae, pe, b + "", d, p, ie) : i, je = De === i;
        if (je) {
          var tt = Bt(pe), mt = !tt && za(pe), xt = !tt && !mt && ku(pe);
          De = pe, tt || mt || xt ? Bt(ae) ? De = ae : or(ae) ? De = Nn(ae) : mt ? (je = !1, De = mR(pe, !0)) : xt ? (je = !1, De = gR(pe, !0)) : De = [] : xd(pe) || rc(pe) ? (De = ae, rc(ae) ? De = ck(ae) : (!Gi(ae) || sa(ae)) && (De = TR(pe))) : je = !1;
        }
        je && (ie.set(pe, De), j(De, pe, M, Z, ie), ie.delete(pe)), qA(d, b, De);
      }
      function tR(d, p) {
        var b = d.length;
        if (b)
          return p += p < 0 ? b : 0, oa(p, b) ? d[p] : i;
      }
      function iR(d, p, b) {
        p.length ? p = Di(p, function(Z) {
          return Bt(Z) ? function(ie) {
            return ec(ie, Z.length === 1 ? Z[0] : Z);
          } : Z;
        }) : p = [Dn];
        var M = -1;
        p = Di(p, Xn(Ct()));
        var j = _S(d, function(Z, ie, ae) {
          var pe = Di(p, function(Te) {
            return Te(Z);
          });
          return { criteria: pe, index: ++M, value: Z };
        });
        return tL(j, function(Z, ie) {
          return YK(Z, ie, b);
        });
      }
      function MK(d, p) {
        return rR(d, p, function(b, M) {
          return Ey(d, M);
        });
      }
      function rR(d, p, b) {
        for (var M = -1, j = p.length, Z = {}; ++M < j; ) {
          var ie = p[M], ae = ec(d, ie);
          b(ae, ie) && Ed(Z, Ja(ie, d), ae);
        }
        return Z;
      }
      function NK(d) {
        return function(p) {
          return ec(p, d);
        };
      }
      function ZA(d, p, b, M) {
        var j = M ? eL : fu, Z = -1, ie = p.length, ae = d;
        for (d === p && (p = Nn(p)), b && (ae = Di(d, Xn(b))); ++Z < ie; )
          for (var pe = 0, Te = p[Z], De = b ? b(Te) : Te; (pe = j(ae, De, pe, M)) > -1; )
            ae !== d && gh.call(ae, pe, 1), gh.call(d, pe, 1);
        return d;
      }
      function nR(d, p) {
        for (var b = d ? p.length : 0, M = b - 1; b--; ) {
          var j = p[b];
          if (b == M || j !== Z) {
            var Z = j;
            oa(j) ? gh.call(d, j, 1) : HA(d, j);
          }
        }
        return d;
      }
      function JA(d, p) {
        return d + fh(jS() * (p - d + 1));
      }
      function TK(d, p, b, M) {
        for (var j = -1, Z = yr(ph((p - d) / (b || 1)), 0), ie = Ie(Z); Z--; )
          ie[M ? Z : ++j] = d, d += b;
        return ie;
      }
      function PA(d, p) {
        var b = "";
        if (!d || p < 1 || p > $)
          return b;
        do
          p % 2 && (b += d), p = fh(p / 2), p && (d += d);
        while (p);
        return b;
      }
      function jt(d, p) {
        return dy(OR(d, p, Dn), d + "");
      }
      function BK(d) {
        return YS(wu(d));
      }
      function DK(d, p) {
        var b = wu(d);
        return Dh(b, $l(p, 0, b.length));
      }
      function Ed(d, p, b, M) {
        if (!Gi(d))
          return d;
        p = Ja(p, d);
        for (var j = -1, Z = p.length, ie = Z - 1, ae = d; ae != null && ++j < Z; ) {
          var pe = vs(p[j]), Te = b;
          if (pe === "__proto__" || pe === "constructor" || pe === "prototype")
            return d;
          if (j != ie) {
            var De = ae[pe];
            Te = M ? M(De, pe, ae) : i, Te === i && (Te = Gi(De) ? De : oa(p[j + 1]) ? [] : {});
          }
          pd(ae, pe, Te), ae = ae[pe];
        }
        return d;
      }
      var oR = Ah ? function(d, p) {
        return Ah.set(d, p), d;
      } : Dn, OK = hh ? function(d, p) {
        return hh(d, "toString", {
          configurable: !0,
          enumerable: !1,
          value: by(p),
          writable: !0
        });
      } : Dn;
      function FK(d) {
        return Dh(wu(d));
      }
      function No(d, p, b) {
        var M = -1, j = d.length;
        p < 0 && (p = -p > j ? 0 : j + p), b = b > j ? j : b, b < 0 && (b += j), j = p > b ? 0 : b - p >>> 0, p >>>= 0;
        for (var Z = Ie(j); ++M < j; )
          Z[M] = d[M + p];
        return Z;
      }
      function VK(d, p) {
        var b;
        return Wa(d, function(M, j, Z) {
          return b = p(M, j, Z), !b;
        }), !!b;
      }
      function Ih(d, p, b) {
        var M = 0, j = d == null ? M : d.length;
        if (typeof p == "number" && p === p && j <= Ae) {
          for (; M < j; ) {
            var Z = M + j >>> 1, ie = d[Z];
            ie !== null && !$n(ie) && (b ? ie <= p : ie < p) ? M = Z + 1 : j = Z;
          }
          return j;
        }
        return zA(d, p, Dn, b);
      }
      function zA(d, p, b, M) {
        var j = 0, Z = d == null ? 0 : d.length;
        if (Z === 0)
          return 0;
        p = b(p);
        for (var ie = p !== p, ae = p === null, pe = $n(p), Te = p === i; j < Z; ) {
          var De = fh((j + Z) / 2), je = b(d[De]), tt = je !== i, mt = je === null, xt = je === je, Vt = $n(je);
          if (ie)
            var It = M || xt;
          else
            Te ? It = xt && (M || tt) : ae ? It = xt && tt && (M || !mt) : pe ? It = xt && tt && !mt && (M || !Vt) : mt || Vt ? It = !1 : It = M ? je <= p : je < p;
          It ? j = De + 1 : Z = De;
        }
        return zr(Z, ue);
      }
      function sR(d, p) {
        for (var b = -1, M = d.length, j = 0, Z = []; ++b < M; ) {
          var ie = d[b], ae = p ? p(ie) : ie;
          if (!b || !$o(ae, pe)) {
            var pe = ae;
            Z[j++] = ie === 0 ? 0 : ie;
          }
        }
        return Z;
      }
      function aR(d) {
        return typeof d == "number" ? d : $n(d) ? he : +d;
      }
      function _n(d) {
        if (typeof d == "string")
          return d;
        if (Bt(d))
          return Di(d, _n) + "";
        if ($n(d))
          return LS ? LS.call(d) : "";
        var p = d + "";
        return p == "0" && 1 / d == -Q ? "-0" : p;
      }
      function Za(d, p, b) {
        var M = -1, j = rh, Z = d.length, ie = !0, ae = [], pe = ae;
        if (b)
          ie = !1, j = IA;
        else if (Z >= n) {
          var Te = p ? null : JK(d);
          if (Te)
            return oh(Te);
          ie = !1, j = cd, pe = new _l();
        } else
          pe = p ? [] : ae;
        e:
          for (; ++M < Z; ) {
            var De = d[M], je = p ? p(De) : De;
            if (De = b || De !== 0 ? De : 0, ie && je === je) {
              for (var tt = pe.length; tt--; )
                if (pe[tt] === je)
                  continue e;
              p && pe.push(je), ae.push(De);
            } else
              j(pe, je, b) || (pe !== ae && pe.push(je), ae.push(De));
          }
        return ae;
      }
      function HA(d, p) {
        return p = Ja(p, d), d = FR(d, p), d == null || delete d[vs(To(p))];
      }
      function lR(d, p, b, M) {
        return Ed(d, p, b(ec(d, p)), M);
      }
      function Sh(d, p, b, M) {
        for (var j = d.length, Z = M ? j : -1; (M ? Z-- : ++Z < j) && p(d[Z], Z, d); )
          ;
        return b ? No(d, M ? 0 : Z, M ? Z + 1 : j) : No(d, M ? Z + 1 : 0, M ? j : Z);
      }
      function cR(d, p) {
        var b = d;
        return b instanceof Zt && (b = b.value()), SA(p, function(M, j) {
          return j.func.apply(j.thisArg, Ua([M], j.args));
        }, b);
      }
      function XA(d, p, b) {
        var M = d.length;
        if (M < 2)
          return M ? Za(d[0]) : [];
        for (var j = -1, Z = Ie(M); ++j < M; )
          for (var ie = d[j], ae = -1; ++ae < M; )
            ae != j && (Z[j] = fd(Z[j] || ie, d[ae], p, b));
        return Za(Lr(Z, 1), p, b);
      }
      function uR(d, p, b) {
        for (var M = -1, j = d.length, Z = p.length, ie = {}; ++M < j; ) {
          var ae = M < Z ? p[M] : i;
          b(ie, d[M], ae);
        }
        return ie;
      }
      function _A(d) {
        return or(d) ? d : [];
      }
      function $A(d) {
        return typeof d == "function" ? d : Dn;
      }
      function Ja(d, p) {
        return Bt(d) ? d : ly(d, p) ? [d] : LR(ci(d));
      }
      var qK = jt;
      function Pa(d, p, b) {
        var M = d.length;
        return b = b === i ? M : b, !p && b >= M ? d : No(d, p, b);
      }
      var dR = IL || function(d) {
        return jr.clearTimeout(d);
      };
      function mR(d, p) {
        if (p)
          return d.slice();
        var b = d.length, M = DS ? DS(b) : new d.constructor(b);
        return d.copy(M), M;
      }
      function ey(d) {
        var p = new d.constructor(d.byteLength);
        return new dh(p).set(new dh(d)), p;
      }
      function jK(d, p) {
        var b = p ? ey(d.buffer) : d.buffer;
        return new d.constructor(b, d.byteOffset, d.byteLength);
      }
      function LK(d) {
        var p = new d.constructor(d.source, zI.exec(d));
        return p.lastIndex = d.lastIndex, p;
      }
      function KK(d) {
        return hd ? vi(hd.call(d)) : {};
      }
      function gR(d, p) {
        var b = p ? ey(d.buffer) : d.buffer;
        return new d.constructor(b, d.byteOffset, d.length);
      }
      function hR(d, p) {
        if (d !== p) {
          var b = d !== i, M = d === null, j = d === d, Z = $n(d), ie = p !== i, ae = p === null, pe = p === p, Te = $n(p);
          if (!ae && !Te && !Z && d > p || Z && ie && pe && !ae && !Te || M && ie && pe || !b && pe || !j)
            return 1;
          if (!M && !Z && !Te && d < p || Te && b && j && !M && !Z || ae && b && j || !ie && j || !pe)
            return -1;
        }
        return 0;
      }
      function YK(d, p, b) {
        for (var M = -1, j = d.criteria, Z = p.criteria, ie = j.length, ae = b.length; ++M < ie; ) {
          var pe = hR(j[M], Z[M]);
          if (pe) {
            if (M >= ae)
              return pe;
            var Te = b[M];
            return pe * (Te == "desc" ? -1 : 1);
          }
        }
        return d.index - p.index;
      }
      function pR(d, p, b, M) {
        for (var j = -1, Z = d.length, ie = b.length, ae = -1, pe = p.length, Te = yr(Z - ie, 0), De = Ie(pe + Te), je = !M; ++ae < pe; )
          De[ae] = p[ae];
        for (; ++j < ie; )
          (je || j < Z) && (De[b[j]] = d[j]);
        for (; Te--; )
          De[ae++] = d[j++];
        return De;
      }
      function fR(d, p, b, M) {
        for (var j = -1, Z = d.length, ie = -1, ae = b.length, pe = -1, Te = p.length, De = yr(Z - ae, 0), je = Ie(De + Te), tt = !M; ++j < De; )
          je[j] = d[j];
        for (var mt = j; ++pe < Te; )
          je[mt + pe] = p[pe];
        for (; ++ie < ae; )
          (tt || j < Z) && (je[mt + b[ie]] = d[j++]);
        return je;
      }
      function Nn(d, p) {
        var b = -1, M = d.length;
        for (p || (p = Ie(M)); ++b < M; )
          p[b] = d[b];
        return p;
      }
      function Es(d, p, b, M) {
        var j = !b;
        b || (b = {});
        for (var Z = -1, ie = p.length; ++Z < ie; ) {
          var ae = p[Z], pe = M ? M(b[ae], d[ae], ae, b, d) : i;
          pe === i && (pe = d[ae]), j ? ia(b, ae, pe) : pd(b, ae, pe);
        }
        return b;
      }
      function UK(d, p) {
        return Es(d, ay(d), p);
      }
      function GK(d, p) {
        return Es(d, MR(d), p);
      }
      function Rh(d, p) {
        return function(b, M) {
          var j = Bt(b) ? Pj : dK, Z = p ? p() : {};
          return j(b, d, Ct(M, 2), Z);
        };
      }
      function Iu(d) {
        return jt(function(p, b) {
          var M = -1, j = b.length, Z = j > 1 ? b[j - 1] : i, ie = j > 2 ? b[2] : i;
          for (Z = d.length > 3 && typeof Z == "function" ? (j--, Z) : i, ie && un(b[0], b[1], ie) && (Z = j < 3 ? i : Z, j = 1), p = vi(p); ++M < j; ) {
            var ae = b[M];
            ae && d(p, ae, M, Z);
          }
          return p;
        });
      }
      function AR(d, p) {
        return function(b, M) {
          if (b == null)
            return b;
          if (!Tn(b))
            return d(b, M);
          for (var j = b.length, Z = p ? j : -1, ie = vi(b); (p ? Z-- : ++Z < j) && M(ie[Z], Z, ie) !== !1; )
            ;
          return b;
        };
      }
      function yR(d) {
        return function(p, b, M) {
          for (var j = -1, Z = vi(p), ie = M(p), ae = ie.length; ae--; ) {
            var pe = ie[d ? ae : ++j];
            if (b(Z[pe], pe, Z) === !1)
              break;
          }
          return p;
        };
      }
      function QK(d, p, b) {
        var M = p & E, j = vd(d);
        function Z() {
          var ie = this && this !== jr && this instanceof Z ? j : d;
          return ie.apply(M ? b : this, arguments);
        }
        return Z;
      }
      function ER(d) {
        return function(p) {
          p = ci(p);
          var b = Au(p) ? Xo(p) : i, M = b ? b[0] : p.charAt(0), j = b ? Pa(b, 1).join("") : p.slice(1);
          return M[d]() + j;
        };
      }
      function Su(d) {
        return function(p) {
          return SA(Ak(fk(p).replace(Oj, "")), d, "");
        };
      }
      function vd(d) {
        return function() {
          var p = arguments;
          switch (p.length) {
            case 0:
              return new d();
            case 1:
              return new d(p[0]);
            case 2:
              return new d(p[0], p[1]);
            case 3:
              return new d(p[0], p[1], p[2]);
            case 4:
              return new d(p[0], p[1], p[2], p[3]);
            case 5:
              return new d(p[0], p[1], p[2], p[3], p[4]);
            case 6:
              return new d(p[0], p[1], p[2], p[3], p[4], p[5]);
            case 7:
              return new d(p[0], p[1], p[2], p[3], p[4], p[5], p[6]);
          }
          var b = xu(d.prototype), M = d.apply(b, p);
          return Gi(M) ? M : b;
        };
      }
      function WK(d, p, b) {
        var M = vd(d);
        function j() {
          for (var Z = arguments.length, ie = Ie(Z), ae = Z, pe = Ru(j); ae--; )
            ie[ae] = arguments[ae];
          var Te = Z < 3 && ie[0] !== pe && ie[Z - 1] !== pe ? [] : Ga(ie, pe);
          if (Z -= Te.length, Z < b)
            return IR(
              d,
              p,
              kh,
              j.placeholder,
              i,
              ie,
              Te,
              i,
              i,
              b - Z
            );
          var De = this && this !== jr && this instanceof j ? M : d;
          return Hn(De, this, ie);
        }
        return j;
      }
      function vR(d) {
        return function(p, b, M) {
          var j = vi(p);
          if (!Tn(p)) {
            var Z = Ct(b, 3);
            p = Rr(p), b = function(ae) {
              return Z(j[ae], ae, j);
            };
          }
          var ie = d(p, b, M);
          return ie > -1 ? j[Z ? p[ie] : ie] : i;
        };
      }
      function bR(d) {
        return na(function(p) {
          var b = p.length, M = b, j = wo.prototype.thru;
          for (d && p.reverse(); M--; ) {
            var Z = p[M];
            if (typeof Z != "function")
              throw new ko(s);
            if (j && !ie && Th(Z) == "wrapper")
              var ie = new wo([], !0);
          }
          for (M = ie ? M : b; ++M < b; ) {
            Z = p[M];
            var ae = Th(Z), pe = ae == "wrapper" ? oy(Z) : i;
            pe && cy(pe[0]) && pe[1] == (T | x | R | N) && !pe[4].length && pe[9] == 1 ? ie = ie[Th(pe[0])].apply(ie, pe[3]) : ie = Z.length == 1 && cy(Z) ? ie[ae]() : ie.thru(Z);
          }
          return function() {
            var Te = arguments, De = Te[0];
            if (ie && Te.length == 1 && Bt(De))
              return ie.plant(De).value();
            for (var je = 0, tt = b ? p[je].apply(this, Te) : De; ++je < b; )
              tt = p[je].call(this, tt);
            return tt;
          };
        });
      }
      function kh(d, p, b, M, j, Z, ie, ae, pe, Te) {
        var De = p & T, je = p & E, tt = p & v, mt = p & (x | S), xt = p & D, Vt = tt ? i : vd(d);
        function It() {
          for (var Gt = arguments.length, Pt = Ie(Gt), eo = Gt; eo--; )
            Pt[eo] = arguments[eo];
          if (mt)
            var dn = Ru(It), to = rL(Pt, dn);
          if (M && (Pt = pR(Pt, M, j, mt)), Z && (Pt = fR(Pt, Z, ie, mt)), Gt -= to, mt && Gt < Te) {
            var sr = Ga(Pt, dn);
            return IR(
              d,
              p,
              kh,
              It.placeholder,
              b,
              Pt,
              sr,
              ae,
              pe,
              Te - Gt
            );
          }
          var es = je ? b : this, la = tt ? es[d] : d;
          return Gt = Pt.length, ae ? Pt = dY(Pt, ae) : xt && Gt > 1 && Pt.reverse(), De && pe < Gt && (Pt.length = pe), this && this !== jr && this instanceof It && (la = Vt || vd(la)), la.apply(es, Pt);
        }
        return It;
      }
      function CR(d, p) {
        return function(b, M) {
          return EK(b, d, p(M), {});
        };
      }
      function wh(d, p) {
        return function(b, M) {
          var j;
          if (b === i && M === i)
            return p;
          if (b !== i && (j = b), M !== i) {
            if (j === i)
              return M;
            typeof b == "string" || typeof M == "string" ? (b = _n(b), M = _n(M)) : (b = aR(b), M = aR(M)), j = d(b, M);
          }
          return j;
        };
      }
      function ty(d) {
        return na(function(p) {
          return p = Di(p, Xn(Ct())), jt(function(b) {
            var M = this;
            return d(p, function(j) {
              return Hn(j, M, b);
            });
          });
        });
      }
      function Mh(d, p) {
        p = p === i ? " " : _n(p);
        var b = p.length;
        if (b < 2)
          return b ? PA(p, d) : p;
        var M = PA(p, ph(d / yu(p)));
        return Au(p) ? Pa(Xo(M), 0, d).join("") : M.slice(0, d);
      }
      function ZK(d, p, b, M) {
        var j = p & E, Z = vd(d);
        function ie() {
          for (var ae = -1, pe = arguments.length, Te = -1, De = M.length, je = Ie(De + pe), tt = this && this !== jr && this instanceof ie ? Z : d; ++Te < De; )
            je[Te] = M[Te];
          for (; pe--; )
            je[Te++] = arguments[++ae];
          return Hn(tt, j ? b : this, je);
        }
        return ie;
      }
      function xR(d) {
        return function(p, b, M) {
          return M && typeof M != "number" && un(p, b, M) && (b = M = i), p = aa(p), b === i ? (b = p, p = 0) : b = aa(b), M = M === i ? p < b ? 1 : -1 : aa(M), TK(p, b, M, d);
        };
      }
      function Nh(d) {
        return function(p, b) {
          return typeof p == "string" && typeof b == "string" || (p = Bo(p), b = Bo(b)), d(p, b);
        };
      }
      function IR(d, p, b, M, j, Z, ie, ae, pe, Te) {
        var De = p & x, je = De ? ie : i, tt = De ? i : ie, mt = De ? Z : i, xt = De ? i : Z;
        p |= De ? R : w, p &= ~(De ? w : R), p & C || (p &= ~(E | v));
        var Vt = [
          d,
          p,
          j,
          mt,
          je,
          xt,
          tt,
          ae,
          pe,
          Te
        ], It = b.apply(i, Vt);
        return cy(d) && VR(It, Vt), It.placeholder = M, qR(It, d, p);
      }
      function iy(d) {
        var p = Ar[d];
        return function(b, M) {
          if (b = Bo(b), M = M == null ? 0 : zr(Ot(M), 292), M && qS(b)) {
            var j = (ci(b) + "e").split("e"), Z = p(j[0] + "e" + (+j[1] + M));
            return j = (ci(Z) + "e").split("e"), +(j[0] + "e" + (+j[1] - M));
          }
          return p(b);
        };
      }
      var JK = bu && 1 / oh(new bu([, -0]))[1] == Q ? function(d) {
        return new bu(d);
      } : Iy;
      function SR(d) {
        return function(p) {
          var b = Hr(p);
          return b == Et ? BA(p) : b == Ke ? uL(p) : iL(p, d(p));
        };
      }
      function ra(d, p, b, M, j, Z, ie, ae) {
        var pe = p & v;
        if (!pe && typeof d != "function")
          throw new ko(s);
        var Te = M ? M.length : 0;
        if (Te || (p &= ~(R | w), M = j = i), ie = ie === i ? ie : yr(Ot(ie), 0), ae = ae === i ? ae : Ot(ae), Te -= j ? j.length : 0, p & w) {
          var De = M, je = j;
          M = j = i;
        }
        var tt = pe ? i : oy(d), mt = [
          d,
          p,
          b,
          M,
          j,
          De,
          je,
          Z,
          ie,
          ae
        ];
        if (tt && lY(mt, tt), d = mt[0], p = mt[1], b = mt[2], M = mt[3], j = mt[4], ae = mt[9] = mt[9] === i ? pe ? 0 : d.length : yr(mt[9] - Te, 0), !ae && p & (x | S) && (p &= ~(x | S)), !p || p == E)
          var xt = QK(d, p, b);
        else
          p == x || p == S ? xt = WK(d, p, ae) : (p == R || p == (E | R)) && !j.length ? xt = ZK(d, p, b, M) : xt = kh.apply(i, mt);
        var Vt = tt ? oR : VR;
        return qR(Vt(xt, mt), d, p);
      }
      function RR(d, p, b, M) {
        return d === i || $o(d, vu[b]) && !hi.call(M, b) ? p : d;
      }
      function kR(d, p, b, M, j, Z) {
        return Gi(d) && Gi(p) && (Z.set(p, d), xh(d, p, i, kR, Z), Z.delete(p)), d;
      }
      function PK(d) {
        return xd(d) ? i : d;
      }
      function wR(d, p, b, M, j, Z) {
        var ie = b & A, ae = d.length, pe = p.length;
        if (ae != pe && !(ie && pe > ae))
          return !1;
        var Te = Z.get(d), De = Z.get(p);
        if (Te && De)
          return Te == p && De == d;
        var je = -1, tt = !0, mt = b & y ? new _l() : i;
        for (Z.set(d, p), Z.set(p, d); ++je < ae; ) {
          var xt = d[je], Vt = p[je];
          if (M)
            var It = ie ? M(Vt, xt, je, p, d, Z) : M(xt, Vt, je, d, p, Z);
          if (It !== i) {
            if (It)
              continue;
            tt = !1;
            break;
          }
          if (mt) {
            if (!RA(p, function(Gt, Pt) {
              if (!cd(mt, Pt) && (xt === Gt || j(xt, Gt, b, M, Z)))
                return mt.push(Pt);
            })) {
              tt = !1;
              break;
            }
          } else if (!(xt === Vt || j(xt, Vt, b, M, Z))) {
            tt = !1;
            break;
          }
        }
        return Z.delete(d), Z.delete(p), tt;
      }
      function zK(d, p, b, M, j, Z, ie) {
        switch (b) {
          case nr:
            if (d.byteLength != p.byteLength || d.byteOffset != p.byteOffset)
              return !1;
            d = d.buffer, p = p.buffer;
          case ei:
            return !(d.byteLength != p.byteLength || !Z(new dh(d), new dh(p)));
          case Oe:
          case Xe:
          case oi:
            return $o(+d, +p);
          case Pe:
            return d.name == p.name && d.message == p.message;
          case ri:
          case dt:
            return d == p + "";
          case Et:
            var ae = BA;
          case Ke:
            var pe = M & A;
            if (ae || (ae = oh), d.size != p.size && !pe)
              return !1;
            var Te = ie.get(d);
            if (Te)
              return Te == p;
            M |= y, ie.set(d, p);
            var De = wR(ae(d), ae(p), M, j, Z, ie);
            return ie.delete(d), De;
          case kt:
            if (hd)
              return hd.call(d) == hd.call(p);
        }
        return !1;
      }
      function HK(d, p, b, M, j, Z) {
        var ie = b & A, ae = ry(d), pe = ae.length, Te = ry(p), De = Te.length;
        if (pe != De && !ie)
          return !1;
        for (var je = pe; je--; ) {
          var tt = ae[je];
          if (!(ie ? tt in p : hi.call(p, tt)))
            return !1;
        }
        var mt = Z.get(d), xt = Z.get(p);
        if (mt && xt)
          return mt == p && xt == d;
        var Vt = !0;
        Z.set(d, p), Z.set(p, d);
        for (var It = ie; ++je < pe; ) {
          tt = ae[je];
          var Gt = d[tt], Pt = p[tt];
          if (M)
            var eo = ie ? M(Pt, Gt, tt, p, d, Z) : M(Gt, Pt, tt, d, p, Z);
          if (!(eo === i ? Gt === Pt || j(Gt, Pt, b, M, Z) : eo)) {
            Vt = !1;
            break;
          }
          It || (It = tt == "constructor");
        }
        if (Vt && !It) {
          var dn = d.constructor, to = p.constructor;
          dn != to && "constructor" in d && "constructor" in p && !(typeof dn == "function" && dn instanceof dn && typeof to == "function" && to instanceof to) && (Vt = !1);
        }
        return Z.delete(d), Z.delete(p), Vt;
      }
      function na(d) {
        return dy(OR(d, i, GR), d + "");
      }
      function ry(d) {
        return PS(d, Rr, ay);
      }
      function ny(d) {
        return PS(d, Bn, MR);
      }
      var oy = Ah ? function(d) {
        return Ah.get(d);
      } : Iy;
      function Th(d) {
        for (var p = d.name + "", b = Cu[p], M = hi.call(Cu, p) ? b.length : 0; M--; ) {
          var j = b[M], Z = j.func;
          if (Z == null || Z == d)
            return j.name;
        }
        return p;
      }
      function Ru(d) {
        var p = hi.call(U, "placeholder") ? U : d;
        return p.placeholder;
      }
      function Ct() {
        var d = U.iteratee || Cy;
        return d = d === Cy ? XS : d, arguments.length ? d(arguments[0], arguments[1]) : d;
      }
      function Bh(d, p) {
        var b = d.__data__;
        return nY(p) ? b[typeof p == "string" ? "string" : "hash"] : b.map;
      }
      function sy(d) {
        for (var p = Rr(d), b = p.length; b--; ) {
          var M = p[b], j = d[M];
          p[b] = [M, j, BR(j)];
        }
        return p;
      }
      function tc(d, p) {
        var b = aL(d, p);
        return HS(b) ? b : i;
      }
      function XK(d) {
        var p = hi.call(d, Hl), b = d[Hl];
        try {
          d[Hl] = i;
          var M = !0;
        } catch (Z) {
        }
        var j = ch.call(d);
        return M && (p ? d[Hl] = b : delete d[Hl]), j;
      }
      var ay = OA ? function(d) {
        return d == null ? [] : (d = vi(d), Ya(OA(d), function(p) {
          return FS.call(d, p);
        }));
      } : Sy, MR = OA ? function(d) {
        for (var p = []; d; )
          Ua(p, ay(d)), d = mh(d);
        return p;
      } : Sy, Hr = cn;
      (FA && Hr(new FA(new ArrayBuffer(1))) != nr || dd && Hr(new dd()) != Et || VA && Hr(VA.resolve()) != qt || bu && Hr(new bu()) != Ke || md && Hr(new md()) != Dt) && (Hr = function(d) {
        var p = cn(d), b = p == ut ? d.constructor : i, M = b ? ic(b) : "";
        if (M)
          switch (M) {
            case DL:
              return nr;
            case OL:
              return Et;
            case FL:
              return qt;
            case VL:
              return Ke;
            case qL:
              return Dt;
          }
        return p;
      });
      function _K(d, p, b) {
        for (var M = -1, j = b.length; ++M < j; ) {
          var Z = b[M], ie = Z.size;
          switch (Z.type) {
            case "drop":
              d += ie;
              break;
            case "dropRight":
              p -= ie;
              break;
            case "take":
              p = zr(p, d + ie);
              break;
            case "takeRight":
              d = yr(d, p - ie);
              break;
          }
        }
        return { start: d, end: p };
      }
      function $K(d) {
        var p = d.match(oj);
        return p ? p[1].split(sj) : [];
      }
      function NR(d, p, b) {
        p = Ja(p, d);
        for (var M = -1, j = p.length, Z = !1; ++M < j; ) {
          var ie = vs(p[M]);
          if (!(Z = d != null && b(d, ie)))
            break;
          d = d[ie];
        }
        return Z || ++M != j ? Z : (j = d == null ? 0 : d.length, !!j && Lh(j) && oa(ie, j) && (Bt(d) || rc(d)));
      }
      function eY(d) {
        var p = d.length, b = new d.constructor(p);
        return p && typeof d[0] == "string" && hi.call(d, "index") && (b.index = d.index, b.input = d.input), b;
      }
      function TR(d) {
        return typeof d.constructor == "function" && !bd(d) ? xu(mh(d)) : {};
      }
      function tY(d, p, b) {
        var M = d.constructor;
        switch (p) {
          case ei:
            return ey(d);
          case Oe:
          case Xe:
            return new M(+d);
          case nr:
            return jK(d, b);
          case fr:
          case Sr:
          case As:
          case $s:
          case od:
          case mu:
          case gu:
          case sd:
          case ad:
            return gR(d, b);
          case Et:
            return new M();
          case oi:
          case dt:
            return new M(d);
          case ri:
            return LK(d);
          case Ke:
            return new M();
          case kt:
            return KK(d);
        }
      }
      function iY(d, p) {
        var b = p.length;
        if (!b)
          return d;
        var M = b - 1;
        return p[M] = (b > 1 ? "& " : "") + p[M], p = p.join(b > 2 ? ", " : " "), d.replace(fA, `{
/* [wrapped with ` + p + `] */
`);
      }
      function rY(d) {
        return Bt(d) || rc(d) || !!(VS && d && d[VS]);
      }
      function oa(d, p) {
        var b = typeof d;
        return p = p == null ? $ : p, !!p && (b == "number" || b != "symbol" && pj.test(d)) && d > -1 && d % 1 == 0 && d < p;
      }
      function un(d, p, b) {
        if (!Gi(b))
          return !1;
        var M = typeof p;
        return (M == "number" ? Tn(b) && oa(p, b.length) : M == "string" && p in b) ? $o(b[p], d) : !1;
      }
      function ly(d, p) {
        if (Bt(d))
          return !1;
        var b = typeof d;
        return b == "number" || b == "symbol" || b == "boolean" || d == null || $n(d) ? !0 : _g.test(d) || !hA.test(d) || p != null && d in vi(p);
      }
      function nY(d) {
        var p = typeof d;
        return p == "string" || p == "number" || p == "symbol" || p == "boolean" ? d !== "__proto__" : d === null;
      }
      function cy(d) {
        var p = Th(d), b = U[p];
        if (typeof b != "function" || !(p in Zt.prototype))
          return !1;
        if (d === b)
          return !0;
        var M = oy(b);
        return !!M && d === M[0];
      }
      function oY(d) {
        return !!BS && BS in d;
      }
      var sY = ah ? sa : Ry;
      function bd(d) {
        var p = d && d.constructor, b = typeof p == "function" && p.prototype || vu;
        return d === b;
      }
      function BR(d) {
        return d === d && !Gi(d);
      }
      function DR(d, p) {
        return function(b) {
          return b == null ? !1 : b[d] === p && (p !== i || d in vi(b));
        };
      }
      function aY(d) {
        var p = qh(d, function(M) {
          return b.size === c && b.clear(), M;
        }), b = p.cache;
        return p;
      }
      function lY(d, p) {
        var b = d[1], M = p[1], j = b | M, Z = j < (E | v | T), ie = M == T && b == x || M == T && b == N && d[7].length <= p[8] || M == (T | N) && p[7].length <= p[8] && b == x;
        if (!(Z || ie))
          return d;
        M & E && (d[2] = p[2], j |= b & E ? 0 : C);
        var ae = p[3];
        if (ae) {
          var pe = d[3];
          d[3] = pe ? pR(pe, ae, p[4]) : ae, d[4] = pe ? Ga(d[3], u) : p[4];
        }
        return ae = p[5], ae && (pe = d[5], d[5] = pe ? fR(pe, ae, p[6]) : ae, d[6] = pe ? Ga(d[5], u) : p[6]), ae = p[7], ae && (d[7] = ae), M & T && (d[8] = d[8] == null ? p[8] : zr(d[8], p[8])), d[9] == null && (d[9] = p[9]), d[0] = p[0], d[1] = j, d;
      }
      function cY(d) {
        var p = [];
        if (d != null)
          for (var b in vi(d))
            p.push(b);
        return p;
      }
      function uY(d) {
        return ch.call(d);
      }
      function OR(d, p, b) {
        return p = yr(p === i ? d.length - 1 : p, 0), function() {
          for (var M = arguments, j = -1, Z = yr(M.length - p, 0), ie = Ie(Z); ++j < Z; )
            ie[j] = M[p + j];
          j = -1;
          for (var ae = Ie(p + 1); ++j < p; )
            ae[j] = M[j];
          return ae[p] = b(ie), Hn(d, this, ae);
        };
      }
      function FR(d, p) {
        return p.length < 2 ? d : ec(d, No(p, 0, -1));
      }
      function dY(d, p) {
        for (var b = d.length, M = zr(p.length, b), j = Nn(d); M--; ) {
          var Z = p[M];
          d[M] = oa(Z, b) ? j[Z] : i;
        }
        return d;
      }
      function uy(d, p) {
        if (!(p === "constructor" && typeof d[p] == "function") && p != "__proto__")
          return d[p];
      }
      var VR = jR(oR), Cd = RL || function(d, p) {
        return jr.setTimeout(d, p);
      }, dy = jR(OK);
      function qR(d, p, b) {
        var M = p + "";
        return dy(d, iY(M, mY($K(M), b)));
      }
      function jR(d) {
        var p = 0, b = 0;
        return function() {
          var M = NL(), j = P - (M - b);
          if (b = M, j > 0) {
            if (++p >= Y)
              return arguments[0];
          } else
            p = 0;
          return d.apply(i, arguments);
        };
      }
      function Dh(d, p) {
        var b = -1, M = d.length, j = M - 1;
        for (p = p === i ? M : p; ++b < p; ) {
          var Z = JA(b, j), ie = d[Z];
          d[Z] = d[b], d[b] = ie;
        }
        return d.length = p, d;
      }
      var LR = aY(function(d) {
        var p = [];
        return d.charCodeAt(0) === 46 && p.push(""), d.replace(pA, function(b, M, j, Z) {
          p.push(j ? Z.replace(cj, "$1") : M || b);
        }), p;
      });
      function vs(d) {
        if (typeof d == "string" || $n(d))
          return d;
        var p = d + "";
        return p == "0" && 1 / d == -Q ? "-0" : p;
      }
      function ic(d) {
        if (d != null) {
          try {
            return lh.call(d);
          } catch (p) {
          }
          try {
            return d + "";
          } catch (p) {
          }
        }
        return "";
      }
      function mY(d, p) {
        return Ro(de, function(b) {
          var M = "_." + b[0];
          p & b[1] && !rh(d, M) && d.push(M);
        }), d.sort();
      }
      function KR(d) {
        if (d instanceof Zt)
          return d.clone();
        var p = new wo(d.__wrapped__, d.__chain__);
        return p.__actions__ = Nn(d.__actions__), p.__index__ = d.__index__, p.__values__ = d.__values__, p;
      }
      function gY(d, p, b) {
        (b ? un(d, p, b) : p === i) ? p = 1 : p = yr(Ot(p), 0);
        var M = d == null ? 0 : d.length;
        if (!M || p < 1)
          return [];
        for (var j = 0, Z = 0, ie = Ie(ph(M / p)); j < M; )
          ie[Z++] = No(d, j, j += p);
        return ie;
      }
      function hY(d) {
        for (var p = -1, b = d == null ? 0 : d.length, M = 0, j = []; ++p < b; ) {
          var Z = d[p];
          Z && (j[M++] = Z);
        }
        return j;
      }
      function pY() {
        var d = arguments.length;
        if (!d)
          return [];
        for (var p = Ie(d - 1), b = arguments[0], M = d; M--; )
          p[M - 1] = arguments[M];
        return Ua(Bt(b) ? Nn(b) : [b], Lr(p, 1));
      }
      var fY = jt(function(d, p) {
        return or(d) ? fd(d, Lr(p, 1, or, !0)) : [];
      }), AY = jt(function(d, p) {
        var b = To(p);
        return or(b) && (b = i), or(d) ? fd(d, Lr(p, 1, or, !0), Ct(b, 2)) : [];
      }), yY = jt(function(d, p) {
        var b = To(p);
        return or(b) && (b = i), or(d) ? fd(d, Lr(p, 1, or, !0), i, b) : [];
      });
      function EY(d, p, b) {
        var M = d == null ? 0 : d.length;
        return M ? (p = b || p === i ? 1 : Ot(p), No(d, p < 0 ? 0 : p, M)) : [];
      }
      function vY(d, p, b) {
        var M = d == null ? 0 : d.length;
        return M ? (p = b || p === i ? 1 : Ot(p), p = M - p, No(d, 0, p < 0 ? 0 : p)) : [];
      }
      function bY(d, p) {
        return d && d.length ? Sh(d, Ct(p, 3), !0, !0) : [];
      }
      function CY(d, p) {
        return d && d.length ? Sh(d, Ct(p, 3), !0) : [];
      }
      function xY(d, p, b, M) {
        var j = d == null ? 0 : d.length;
        return j ? (b && typeof b != "number" && un(d, p, b) && (b = 0, M = j), pK(d, p, b, M)) : [];
      }
      function YR(d, p, b) {
        var M = d == null ? 0 : d.length;
        if (!M)
          return -1;
        var j = b == null ? 0 : Ot(b);
        return j < 0 && (j = yr(M + j, 0)), nh(d, Ct(p, 3), j);
      }
      function UR(d, p, b) {
        var M = d == null ? 0 : d.length;
        if (!M)
          return -1;
        var j = M - 1;
        return b !== i && (j = Ot(b), j = b < 0 ? yr(M + j, 0) : zr(j, M - 1)), nh(d, Ct(p, 3), j, !0);
      }
      function GR(d) {
        var p = d == null ? 0 : d.length;
        return p ? Lr(d, 1) : [];
      }
      function IY(d) {
        var p = d == null ? 0 : d.length;
        return p ? Lr(d, Q) : [];
      }
      function SY(d, p) {
        var b = d == null ? 0 : d.length;
        return b ? (p = p === i ? 1 : Ot(p), Lr(d, p)) : [];
      }
      function RY(d) {
        for (var p = -1, b = d == null ? 0 : d.length, M = {}; ++p < b; ) {
          var j = d[p];
          M[j[0]] = j[1];
        }
        return M;
      }
      function QR(d) {
        return d && d.length ? d[0] : i;
      }
      function kY(d, p, b) {
        var M = d == null ? 0 : d.length;
        if (!M)
          return -1;
        var j = b == null ? 0 : Ot(b);
        return j < 0 && (j = yr(M + j, 0)), fu(d, p, j);
      }
      function wY(d) {
        var p = d == null ? 0 : d.length;
        return p ? No(d, 0, -1) : [];
      }
      var MY = jt(function(d) {
        var p = Di(d, _A);
        return p.length && p[0] === d[0] ? UA(p) : [];
      }), NY = jt(function(d) {
        var p = To(d), b = Di(d, _A);
        return p === To(b) ? p = i : b.pop(), b.length && b[0] === d[0] ? UA(b, Ct(p, 2)) : [];
      }), TY = jt(function(d) {
        var p = To(d), b = Di(d, _A);
        return p = typeof p == "function" ? p : i, p && b.pop(), b.length && b[0] === d[0] ? UA(b, i, p) : [];
      });
      function BY(d, p) {
        return d == null ? "" : wL.call(d, p);
      }
      function To(d) {
        var p = d == null ? 0 : d.length;
        return p ? d[p - 1] : i;
      }
      function DY(d, p, b) {
        var M = d == null ? 0 : d.length;
        if (!M)
          return -1;
        var j = M;
        return b !== i && (j = Ot(b), j = j < 0 ? yr(M + j, 0) : zr(j, M - 1)), p === p ? mL(d, p, j) : nh(d, IS, j, !0);
      }
      function OY(d, p) {
        return d && d.length ? tR(d, Ot(p)) : i;
      }
      var FY = jt(WR);
      function WR(d, p) {
        return d && d.length && p && p.length ? ZA(d, p) : d;
      }
      function VY(d, p, b) {
        return d && d.length && p && p.length ? ZA(d, p, Ct(b, 2)) : d;
      }
      function qY(d, p, b) {
        return d && d.length && p && p.length ? ZA(d, p, i, b) : d;
      }
      var jY = na(function(d, p) {
        var b = d == null ? 0 : d.length, M = jA(d, p);
        return nR(d, Di(p, function(j) {
          return oa(j, b) ? +j : j;
        }).sort(hR)), M;
      });
      function LY(d, p) {
        var b = [];
        if (!(d && d.length))
          return b;
        var M = -1, j = [], Z = d.length;
        for (p = Ct(p, 3); ++M < Z; ) {
          var ie = d[M];
          p(ie, M, d) && (b.push(ie), j.push(M));
        }
        return nR(d, j), b;
      }
      function my(d) {
        return d == null ? d : BL.call(d);
      }
      function KY(d, p, b) {
        var M = d == null ? 0 : d.length;
        return M ? (b && typeof b != "number" && un(d, p, b) ? (p = 0, b = M) : (p = p == null ? 0 : Ot(p), b = b === i ? M : Ot(b)), No(d, p, b)) : [];
      }
      function YY(d, p) {
        return Ih(d, p);
      }
      function UY(d, p, b) {
        return zA(d, p, Ct(b, 2));
      }
      function GY(d, p) {
        var b = d == null ? 0 : d.length;
        if (b) {
          var M = Ih(d, p);
          if (M < b && $o(d[M], p))
            return M;
        }
        return -1;
      }
      function QY(d, p) {
        return Ih(d, p, !0);
      }
      function WY(d, p, b) {
        return zA(d, p, Ct(b, 2), !0);
      }
      function ZY(d, p) {
        var b = d == null ? 0 : d.length;
        if (b) {
          var M = Ih(d, p, !0) - 1;
          if ($o(d[M], p))
            return M;
        }
        return -1;
      }
      function JY(d) {
        return d && d.length ? sR(d) : [];
      }
      function PY(d, p) {
        return d && d.length ? sR(d, Ct(p, 2)) : [];
      }
      function zY(d) {
        var p = d == null ? 0 : d.length;
        return p ? No(d, 1, p) : [];
      }
      function HY(d, p, b) {
        return d && d.length ? (p = b || p === i ? 1 : Ot(p), No(d, 0, p < 0 ? 0 : p)) : [];
      }
      function XY(d, p, b) {
        var M = d == null ? 0 : d.length;
        return M ? (p = b || p === i ? 1 : Ot(p), p = M - p, No(d, p < 0 ? 0 : p, M)) : [];
      }
      function _Y(d, p) {
        return d && d.length ? Sh(d, Ct(p, 3), !1, !0) : [];
      }
      function $Y(d, p) {
        return d && d.length ? Sh(d, Ct(p, 3)) : [];
      }
      var eU = jt(function(d) {
        return Za(Lr(d, 1, or, !0));
      }), tU = jt(function(d) {
        var p = To(d);
        return or(p) && (p = i), Za(Lr(d, 1, or, !0), Ct(p, 2));
      }), iU = jt(function(d) {
        var p = To(d);
        return p = typeof p == "function" ? p : i, Za(Lr(d, 1, or, !0), i, p);
      });
      function rU(d) {
        return d && d.length ? Za(d) : [];
      }
      function nU(d, p) {
        return d && d.length ? Za(d, Ct(p, 2)) : [];
      }
      function oU(d, p) {
        return p = typeof p == "function" ? p : i, d && d.length ? Za(d, i, p) : [];
      }
      function gy(d) {
        if (!(d && d.length))
          return [];
        var p = 0;
        return d = Ya(d, function(b) {
          if (or(b))
            return p = yr(b.length, p), !0;
        }), NA(p, function(b) {
          return Di(d, kA(b));
        });
      }
      function ZR(d, p) {
        if (!(d && d.length))
          return [];
        var b = gy(d);
        return p == null ? b : Di(b, function(M) {
          return Hn(p, i, M);
        });
      }
      var sU = jt(function(d, p) {
        return or(d) ? fd(d, p) : [];
      }), aU = jt(function(d) {
        return XA(Ya(d, or));
      }), lU = jt(function(d) {
        var p = To(d);
        return or(p) && (p = i), XA(Ya(d, or), Ct(p, 2));
      }), cU = jt(function(d) {
        var p = To(d);
        return p = typeof p == "function" ? p : i, XA(Ya(d, or), i, p);
      }), uU = jt(gy);
      function dU(d, p) {
        return uR(d || [], p || [], pd);
      }
      function mU(d, p) {
        return uR(d || [], p || [], Ed);
      }
      var gU = jt(function(d) {
        var p = d.length, b = p > 1 ? d[p - 1] : i;
        return b = typeof b == "function" ? (d.pop(), b) : i, ZR(d, b);
      });
      function JR(d) {
        var p = U(d);
        return p.__chain__ = !0, p;
      }
      function hU(d, p) {
        return p(d), d;
      }
      function Oh(d, p) {
        return p(d);
      }
      var pU = na(function(d) {
        var p = d.length, b = p ? d[0] : 0, M = this.__wrapped__, j = function(Z) {
          return jA(Z, d);
        };
        return p > 1 || this.__actions__.length || !(M instanceof Zt) || !oa(b) ? this.thru(j) : (M = M.slice(b, +b + (p ? 1 : 0)), M.__actions__.push({
          func: Oh,
          args: [j],
          thisArg: i
        }), new wo(M, this.__chain__).thru(function(Z) {
          return p && !Z.length && Z.push(i), Z;
        }));
      });
      function fU() {
        return JR(this);
      }
      function AU() {
        return new wo(this.value(), this.__chain__);
      }
      function yU() {
        this.__values__ === i && (this.__values__ = ak(this.value()));
        var d = this.__index__ >= this.__values__.length, p = d ? i : this.__values__[this.__index__++];
        return { done: d, value: p };
      }
      function EU() {
        return this;
      }
      function vU(d) {
        for (var p, b = this; b instanceof Eh; ) {
          var M = KR(b);
          M.__index__ = 0, M.__values__ = i, p ? j.__wrapped__ = M : p = M;
          var j = M;
          b = b.__wrapped__;
        }
        return j.__wrapped__ = d, p;
      }
      function bU() {
        var d = this.__wrapped__;
        if (d instanceof Zt) {
          var p = d;
          return this.__actions__.length && (p = new Zt(this)), p = p.reverse(), p.__actions__.push({
            func: Oh,
            args: [my],
            thisArg: i
          }), new wo(p, this.__chain__);
        }
        return this.thru(my);
      }
      function CU() {
        return cR(this.__wrapped__, this.__actions__);
      }
      var xU = Rh(function(d, p, b) {
        hi.call(d, b) ? ++d[b] : ia(d, b, 1);
      });
      function IU(d, p, b) {
        var M = Bt(d) ? CS : hK;
        return b && un(d, p, b) && (p = i), M(d, Ct(p, 3));
      }
      function SU(d, p) {
        var b = Bt(d) ? Ya : ZS;
        return b(d, Ct(p, 3));
      }
      var RU = vR(YR), kU = vR(UR);
      function wU(d, p) {
        return Lr(Fh(d, p), 1);
      }
      function MU(d, p) {
        return Lr(Fh(d, p), Q);
      }
      function NU(d, p, b) {
        return b = b === i ? 1 : Ot(b), Lr(Fh(d, p), b);
      }
      function PR(d, p) {
        var b = Bt(d) ? Ro : Wa;
        return b(d, Ct(p, 3));
      }
      function zR(d, p) {
        var b = Bt(d) ? zj : WS;
        return b(d, Ct(p, 3));
      }
      var TU = Rh(function(d, p, b) {
        hi.call(d, b) ? d[b].push(p) : ia(d, b, [p]);
      });
      function BU(d, p, b, M) {
        d = Tn(d) ? d : wu(d), b = b && !M ? Ot(b) : 0;
        var j = d.length;
        return b < 0 && (b = yr(j + b, 0)), Kh(d) ? b <= j && d.indexOf(p, b) > -1 : !!j && fu(d, p, b) > -1;
      }
      var DU = jt(function(d, p, b) {
        var M = -1, j = typeof p == "function", Z = Tn(d) ? Ie(d.length) : [];
        return Wa(d, function(ie) {
          Z[++M] = j ? Hn(p, ie, b) : Ad(ie, p, b);
        }), Z;
      }), OU = Rh(function(d, p, b) {
        ia(d, b, p);
      });
      function Fh(d, p) {
        var b = Bt(d) ? Di : _S;
        return b(d, Ct(p, 3));
      }
      function FU(d, p, b, M) {
        return d == null ? [] : (Bt(p) || (p = p == null ? [] : [p]), b = M ? i : b, Bt(b) || (b = b == null ? [] : [b]), iR(d, p, b));
      }
      var VU = Rh(function(d, p, b) {
        d[b ? 0 : 1].push(p);
      }, function() {
        return [[], []];
      });
      function qU(d, p, b) {
        var M = Bt(d) ? SA : RS, j = arguments.length < 3;
        return M(d, Ct(p, 4), b, j, Wa);
      }
      function jU(d, p, b) {
        var M = Bt(d) ? Hj : RS, j = arguments.length < 3;
        return M(d, Ct(p, 4), b, j, WS);
      }
      function LU(d, p) {
        var b = Bt(d) ? Ya : ZS;
        return b(d, jh(Ct(p, 3)));
      }
      function KU(d) {
        var p = Bt(d) ? YS : BK;
        return p(d);
      }
      function YU(d, p, b) {
        (b ? un(d, p, b) : p === i) ? p = 1 : p = Ot(p);
        var M = Bt(d) ? cK : DK;
        return M(d, p);
      }
      function UU(d) {
        var p = Bt(d) ? uK : FK;
        return p(d);
      }
      function GU(d) {
        if (d == null)
          return 0;
        if (Tn(d))
          return Kh(d) ? yu(d) : d.length;
        var p = Hr(d);
        return p == Et || p == Ke ? d.size : QA(d).length;
      }
      function QU(d, p, b) {
        var M = Bt(d) ? RA : VK;
        return b && un(d, p, b) && (p = i), M(d, Ct(p, 3));
      }
      var WU = jt(function(d, p) {
        if (d == null)
          return [];
        var b = p.length;
        return b > 1 && un(d, p[0], p[1]) ? p = [] : b > 2 && un(p[0], p[1], p[2]) && (p = [p[0]]), iR(d, Lr(p, 1), []);
      }), Vh = SL || function() {
        return jr.Date.now();
      };
      function ZU(d, p) {
        if (typeof p != "function")
          throw new ko(s);
        return d = Ot(d), function() {
          if (--d < 1)
            return p.apply(this, arguments);
        };
      }
      function HR(d, p, b) {
        return p = b ? i : p, p = d && p == null ? d.length : p, ra(d, T, i, i, i, i, p);
      }
      function XR(d, p) {
        var b;
        if (typeof p != "function")
          throw new ko(s);
        return d = Ot(d), function() {
          return --d > 0 && (b = p.apply(this, arguments)), d <= 1 && (p = i), b;
        };
      }
      var hy = jt(function(d, p, b) {
        var M = E;
        if (b.length) {
          var j = Ga(b, Ru(hy));
          M |= R;
        }
        return ra(d, M, p, b, j);
      }), _R = jt(function(d, p, b) {
        var M = E | v;
        if (b.length) {
          var j = Ga(b, Ru(_R));
          M |= R;
        }
        return ra(p, M, d, b, j);
      });
      function $R(d, p, b) {
        p = b ? i : p;
        var M = ra(d, x, i, i, i, i, i, p);
        return M.placeholder = $R.placeholder, M;
      }
      function ek(d, p, b) {
        p = b ? i : p;
        var M = ra(d, S, i, i, i, i, i, p);
        return M.placeholder = ek.placeholder, M;
      }
      function tk(d, p, b) {
        var M, j, Z, ie, ae, pe, Te = 0, De = !1, je = !1, tt = !0;
        if (typeof d != "function")
          throw new ko(s);
        p = Bo(p) || 0, Gi(b) && (De = !!b.leading, je = "maxWait" in b, Z = je ? yr(Bo(b.maxWait) || 0, p) : Z, tt = "trailing" in b ? !!b.trailing : tt);
        function mt(sr) {
          var es = M, la = j;
          return M = j = i, Te = sr, ie = d.apply(la, es), ie;
        }
        function xt(sr) {
          return Te = sr, ae = Cd(Gt, p), De ? mt(sr) : ie;
        }
        function Vt(sr) {
          var es = sr - pe, la = sr - Te, vk = p - es;
          return je ? zr(vk, Z - la) : vk;
        }
        function It(sr) {
          var es = sr - pe, la = sr - Te;
          return pe === i || es >= p || es < 0 || je && la >= Z;
        }
        function Gt() {
          var sr = Vh();
          if (It(sr))
            return Pt(sr);
          ae = Cd(Gt, Vt(sr));
        }
        function Pt(sr) {
          return ae = i, tt && M ? mt(sr) : (M = j = i, ie);
        }
        function eo() {
          ae !== i && dR(ae), Te = 0, M = pe = j = ae = i;
        }
        function dn() {
          return ae === i ? ie : Pt(Vh());
        }
        function to() {
          var sr = Vh(), es = It(sr);
          if (M = arguments, j = this, pe = sr, es) {
            if (ae === i)
              return xt(pe);
            if (je)
              return dR(ae), ae = Cd(Gt, p), mt(pe);
          }
          return ae === i && (ae = Cd(Gt, p)), ie;
        }
        return to.cancel = eo, to.flush = dn, to;
      }
      var JU = jt(function(d, p) {
        return QS(d, 1, p);
      }), PU = jt(function(d, p, b) {
        return QS(d, Bo(p) || 0, b);
      });
      function zU(d) {
        return ra(d, D);
      }
      function qh(d, p) {
        if (typeof d != "function" || p != null && typeof p != "function")
          throw new ko(s);
        var b = function() {
          var M = arguments, j = p ? p.apply(this, M) : M[0], Z = b.cache;
          if (Z.has(j))
            return Z.get(j);
          var ie = d.apply(this, M);
          return b.cache = Z.set(j, ie) || Z, ie;
        };
        return b.cache = new (qh.Cache || ta)(), b;
      }
      qh.Cache = ta;
      function jh(d) {
        if (typeof d != "function")
          throw new ko(s);
        return function() {
          var p = arguments;
          switch (p.length) {
            case 0:
              return !d.call(this);
            case 1:
              return !d.call(this, p[0]);
            case 2:
              return !d.call(this, p[0], p[1]);
            case 3:
              return !d.call(this, p[0], p[1], p[2]);
          }
          return !d.apply(this, p);
        };
      }
      function HU(d) {
        return XR(2, d);
      }
      var XU = qK(function(d, p) {
        p = p.length == 1 && Bt(p[0]) ? Di(p[0], Xn(Ct())) : Di(Lr(p, 1), Xn(Ct()));
        var b = p.length;
        return jt(function(M) {
          for (var j = -1, Z = zr(M.length, b); ++j < Z; )
            M[j] = p[j].call(this, M[j]);
          return Hn(d, this, M);
        });
      }), py = jt(function(d, p) {
        var b = Ga(p, Ru(py));
        return ra(d, R, i, p, b);
      }), ik = jt(function(d, p) {
        var b = Ga(p, Ru(ik));
        return ra(d, w, i, p, b);
      }), _U = na(function(d, p) {
        return ra(d, N, i, i, i, p);
      });
      function $U(d, p) {
        if (typeof d != "function")
          throw new ko(s);
        return p = p === i ? p : Ot(p), jt(d, p);
      }
      function eG(d, p) {
        if (typeof d != "function")
          throw new ko(s);
        return p = p == null ? 0 : yr(Ot(p), 0), jt(function(b) {
          var M = b[p], j = Pa(b, 0, p);
          return M && Ua(j, M), Hn(d, this, j);
        });
      }
      function tG(d, p, b) {
        var M = !0, j = !0;
        if (typeof d != "function")
          throw new ko(s);
        return Gi(b) && (M = "leading" in b ? !!b.leading : M, j = "trailing" in b ? !!b.trailing : j), tk(d, p, {
          leading: M,
          maxWait: p,
          trailing: j
        });
      }
      function iG(d) {
        return HR(d, 1);
      }
      function rG(d, p) {
        return py($A(p), d);
      }
      function nG() {
        if (!arguments.length)
          return [];
        var d = arguments[0];
        return Bt(d) ? d : [d];
      }
      function oG(d) {
        return Mo(d, h);
      }
      function sG(d, p) {
        return p = typeof p == "function" ? p : i, Mo(d, h, p);
      }
      function aG(d) {
        return Mo(d, m | h);
      }
      function lG(d, p) {
        return p = typeof p == "function" ? p : i, Mo(d, m | h, p);
      }
      function cG(d, p) {
        return p == null || GS(d, p, Rr(p));
      }
      function $o(d, p) {
        return d === p || d !== d && p !== p;
      }
      var uG = Nh(YA), dG = Nh(function(d, p) {
        return d >= p;
      }), rc = zS(function() {
        return arguments;
      }()) ? zS : function(d) {
        return _i(d) && hi.call(d, "callee") && !FS.call(d, "callee");
      }, Bt = Ie.isArray, mG = fS ? Xn(fS) : vK;
      function Tn(d) {
        return d != null && Lh(d.length) && !sa(d);
      }
      function or(d) {
        return _i(d) && Tn(d);
      }
      function gG(d) {
        return d === !0 || d === !1 || _i(d) && cn(d) == Oe;
      }
      var za = kL || Ry, hG = AS ? Xn(AS) : bK;
      function pG(d) {
        return _i(d) && d.nodeType === 1 && !xd(d);
      }
      function fG(d) {
        if (d == null)
          return !0;
        if (Tn(d) && (Bt(d) || typeof d == "string" || typeof d.splice == "function" || za(d) || ku(d) || rc(d)))
          return !d.length;
        var p = Hr(d);
        if (p == Et || p == Ke)
          return !d.size;
        if (bd(d))
          return !QA(d).length;
        for (var b in d)
          if (hi.call(d, b))
            return !1;
        return !0;
      }
      function AG(d, p) {
        return yd(d, p);
      }
      function yG(d, p, b) {
        b = typeof b == "function" ? b : i;
        var M = b ? b(d, p) : i;
        return M === i ? yd(d, p, i, b) : !!M;
      }
      function fy(d) {
        if (!_i(d))
          return !1;
        var p = cn(d);
        return p == Pe || p == Qe || typeof d.message == "string" && typeof d.name == "string" && !xd(d);
      }
      function EG(d) {
        return typeof d == "number" && qS(d);
      }
      function sa(d) {
        if (!Gi(d))
          return !1;
        var p = cn(d);
        return p == et || p == At || p == qe || p == Ht;
      }
      function rk(d) {
        return typeof d == "number" && d == Ot(d);
      }
      function Lh(d) {
        return typeof d == "number" && d > -1 && d % 1 == 0 && d <= $;
      }
      function Gi(d) {
        var p = typeof d;
        return d != null && (p == "object" || p == "function");
      }
      function _i(d) {
        return d != null && typeof d == "object";
      }
      var nk = yS ? Xn(yS) : xK;
      function vG(d, p) {
        return d === p || GA(d, p, sy(p));
      }
      function bG(d, p, b) {
        return b = typeof b == "function" ? b : i, GA(d, p, sy(p), b);
      }
      function CG(d) {
        return ok(d) && d != +d;
      }
      function xG(d) {
        if (sY(d))
          throw new Nt(o);
        return HS(d);
      }
      function IG(d) {
        return d === null;
      }
      function SG(d) {
        return d == null;
      }
      function ok(d) {
        return typeof d == "number" || _i(d) && cn(d) == oi;
      }
      function xd(d) {
        if (!_i(d) || cn(d) != ut)
          return !1;
        var p = mh(d);
        if (p === null)
          return !0;
        var b = hi.call(p, "constructor") && p.constructor;
        return typeof b == "function" && b instanceof b && lh.call(b) == bL;
      }
      var Ay = ES ? Xn(ES) : IK;
      function RG(d) {
        return rk(d) && d >= -$ && d <= $;
      }
      var sk = vS ? Xn(vS) : SK;
      function Kh(d) {
        return typeof d == "string" || !Bt(d) && _i(d) && cn(d) == dt;
      }
      function $n(d) {
        return typeof d == "symbol" || _i(d) && cn(d) == kt;
      }
      var ku = bS ? Xn(bS) : RK;
      function kG(d) {
        return d === i;
      }
      function wG(d) {
        return _i(d) && Hr(d) == Dt;
      }
      function MG(d) {
        return _i(d) && cn(d) == yi;
      }
      var NG = Nh(WA), TG = Nh(function(d, p) {
        return d <= p;
      });
      function ak(d) {
        if (!d)
          return [];
        if (Tn(d))
          return Kh(d) ? Xo(d) : Nn(d);
        if (ud && d[ud])
          return cL(d[ud]());
        var p = Hr(d), b = p == Et ? BA : p == Ke ? oh : wu;
        return b(d);
      }
      function aa(d) {
        if (!d)
          return d === 0 ? d : 0;
        if (d = Bo(d), d === Q || d === -Q) {
          var p = d < 0 ? -1 : 1;
          return p * le;
        }
        return d === d ? d : 0;
      }
      function Ot(d) {
        var p = aa(d), b = p % 1;
        return p === p ? b ? p - b : p : 0;
      }
      function lk(d) {
        return d ? $l(Ot(d), 0, oe) : 0;
      }
      function Bo(d) {
        if (typeof d == "number")
          return d;
        if ($n(d))
          return he;
        if (Gi(d)) {
          var p = typeof d.valueOf == "function" ? d.valueOf() : d;
          d = Gi(p) ? p + "" : p;
        }
        if (typeof d != "string")
          return d === 0 ? d : +d;
        d = kS(d);
        var b = mj.test(d);
        return b || hj.test(d) ? Zj(d.slice(2), b ? 2 : 8) : dj.test(d) ? he : +d;
      }
      function ck(d) {
        return Es(d, Bn(d));
      }
      function BG(d) {
        return d ? $l(Ot(d), -$, $) : d === 0 ? d : 0;
      }
      function ci(d) {
        return d == null ? "" : _n(d);
      }
      var DG = Iu(function(d, p) {
        if (bd(p) || Tn(p)) {
          Es(p, Rr(p), d);
          return;
        }
        for (var b in p)
          hi.call(p, b) && pd(d, b, p[b]);
      }), uk = Iu(function(d, p) {
        Es(p, Bn(p), d);
      }), Yh = Iu(function(d, p, b, M) {
        Es(p, Bn(p), d, M);
      }), OG = Iu(function(d, p, b, M) {
        Es(p, Rr(p), d, M);
      }), FG = na(jA);
      function VG(d, p) {
        var b = xu(d);
        return p == null ? b : US(b, p);
      }
      var qG = jt(function(d, p) {
        d = vi(d);
        var b = -1, M = p.length, j = M > 2 ? p[2] : i;
        for (j && un(p[0], p[1], j) && (M = 1); ++b < M; )
          for (var Z = p[b], ie = Bn(Z), ae = -1, pe = ie.length; ++ae < pe; ) {
            var Te = ie[ae], De = d[Te];
            (De === i || $o(De, vu[Te]) && !hi.call(d, Te)) && (d[Te] = Z[Te]);
          }
        return d;
      }), jG = jt(function(d) {
        return d.push(i, kR), Hn(dk, i, d);
      });
      function LG(d, p) {
        return xS(d, Ct(p, 3), ys);
      }
      function KG(d, p) {
        return xS(d, Ct(p, 3), KA);
      }
      function YG(d, p) {
        return d == null ? d : LA(d, Ct(p, 3), Bn);
      }
      function UG(d, p) {
        return d == null ? d : JS(d, Ct(p, 3), Bn);
      }
      function GG(d, p) {
        return d && ys(d, Ct(p, 3));
      }
      function QG(d, p) {
        return d && KA(d, Ct(p, 3));
      }
      function WG(d) {
        return d == null ? [] : Ch(d, Rr(d));
      }
      function ZG(d) {
        return d == null ? [] : Ch(d, Bn(d));
      }
      function yy(d, p, b) {
        var M = d == null ? i : ec(d, p);
        return M === i ? b : M;
      }
      function JG(d, p) {
        return d != null && NR(d, p, fK);
      }
      function Ey(d, p) {
        return d != null && NR(d, p, AK);
      }
      var PG = CR(function(d, p, b) {
        p != null && typeof p.toString != "function" && (p = ch.call(p)), d[p] = b;
      }, by(Dn)), zG = CR(function(d, p, b) {
        p != null && typeof p.toString != "function" && (p = ch.call(p)), hi.call(d, p) ? d[p].push(b) : d[p] = [b];
      }, Ct), HG = jt(Ad);
      function Rr(d) {
        return Tn(d) ? KS(d) : QA(d);
      }
      function Bn(d) {
        return Tn(d) ? KS(d, !0) : kK(d);
      }
      function XG(d, p) {
        var b = {};
        return p = Ct(p, 3), ys(d, function(M, j, Z) {
          ia(b, p(M, j, Z), M);
        }), b;
      }
      function _G(d, p) {
        var b = {};
        return p = Ct(p, 3), ys(d, function(M, j, Z) {
          ia(b, j, p(M, j, Z));
        }), b;
      }
      var $G = Iu(function(d, p, b) {
        xh(d, p, b);
      }), dk = Iu(function(d, p, b, M) {
        xh(d, p, b, M);
      }), eQ = na(function(d, p) {
        var b = {};
        if (d == null)
          return b;
        var M = !1;
        p = Di(p, function(Z) {
          return Z = Ja(Z, d), M || (M = Z.length > 1), Z;
        }), Es(d, ny(d), b), M && (b = Mo(b, m | g | h, PK));
        for (var j = p.length; j--; )
          HA(b, p[j]);
        return b;
      });
      function tQ(d, p) {
        return mk(d, jh(Ct(p)));
      }
      var iQ = na(function(d, p) {
        return d == null ? {} : MK(d, p);
      });
      function mk(d, p) {
        if (d == null)
          return {};
        var b = Di(ny(d), function(M) {
          return [M];
        });
        return p = Ct(p), rR(d, b, function(M, j) {
          return p(M, j[0]);
        });
      }
      function rQ(d, p, b) {
        p = Ja(p, d);
        var M = -1, j = p.length;
        for (j || (j = 1, d = i); ++M < j; ) {
          var Z = d == null ? i : d[vs(p[M])];
          Z === i && (M = j, Z = b), d = sa(Z) ? Z.call(d) : Z;
        }
        return d;
      }
      function nQ(d, p, b) {
        return d == null ? d : Ed(d, p, b);
      }
      function oQ(d, p, b, M) {
        return M = typeof M == "function" ? M : i, d == null ? d : Ed(d, p, b, M);
      }
      var gk = SR(Rr), hk = SR(Bn);
      function sQ(d, p, b) {
        var M = Bt(d), j = M || za(d) || ku(d);
        if (p = Ct(p, 4), b == null) {
          var Z = d && d.constructor;
          j ? b = M ? new Z() : [] : Gi(d) ? b = sa(Z) ? xu(mh(d)) : {} : b = {};
        }
        return (j ? Ro : ys)(d, function(ie, ae, pe) {
          return p(b, ie, ae, pe);
        }), b;
      }
      function aQ(d, p) {
        return d == null ? !0 : HA(d, p);
      }
      function lQ(d, p, b) {
        return d == null ? d : lR(d, p, $A(b));
      }
      function cQ(d, p, b, M) {
        return M = typeof M == "function" ? M : i, d == null ? d : lR(d, p, $A(b), M);
      }
      function wu(d) {
        return d == null ? [] : TA(d, Rr(d));
      }
      function uQ(d) {
        return d == null ? [] : TA(d, Bn(d));
      }
      function dQ(d, p, b) {
        return b === i && (b = p, p = i), b !== i && (b = Bo(b), b = b === b ? b : 0), p !== i && (p = Bo(p), p = p === p ? p : 0), $l(Bo(d), p, b);
      }
      function mQ(d, p, b) {
        return p = aa(p), b === i ? (b = p, p = 0) : b = aa(b), d = Bo(d), yK(d, p, b);
      }
      function gQ(d, p, b) {
        if (b && typeof b != "boolean" && un(d, p, b) && (p = b = i), b === i && (typeof p == "boolean" ? (b = p, p = i) : typeof d == "boolean" && (b = d, d = i)), d === i && p === i ? (d = 0, p = 1) : (d = aa(d), p === i ? (p = d, d = 0) : p = aa(p)), d > p) {
          var M = d;
          d = p, p = M;
        }
        if (b || d % 1 || p % 1) {
          var j = jS();
          return zr(d + j * (p - d + Wj("1e-" + ((j + "").length - 1))), p);
        }
        return JA(d, p);
      }
      var hQ = Su(function(d, p, b) {
        return p = p.toLowerCase(), d + (b ? pk(p) : p);
      });
      function pk(d) {
        return vy(ci(d).toLowerCase());
      }
      function fk(d) {
        return d = ci(d), d && d.replace(fj, nL).replace(Fj, "");
      }
      function pQ(d, p, b) {
        d = ci(d), p = _n(p);
        var M = d.length;
        b = b === i ? M : $l(Ot(b), 0, M);
        var j = b;
        return b -= p.length, b >= 0 && d.slice(b, j) == p;
      }
      function fQ(d) {
        return d = ci(d), d && mA.test(d) ? d.replace(ld, oL) : d;
      }
      function AQ(d) {
        return d = ci(d), d && ln.test(d) ? d.replace(hu, "\\$&") : d;
      }
      var yQ = Su(function(d, p, b) {
        return d + (b ? "-" : "") + p.toLowerCase();
      }), EQ = Su(function(d, p, b) {
        return d + (b ? " " : "") + p.toLowerCase();
      }), vQ = ER("toLowerCase");
      function bQ(d, p, b) {
        d = ci(d), p = Ot(p);
        var M = p ? yu(d) : 0;
        if (!p || M >= p)
          return d;
        var j = (p - M) / 2;
        return Mh(fh(j), b) + d + Mh(ph(j), b);
      }
      function CQ(d, p, b) {
        d = ci(d), p = Ot(p);
        var M = p ? yu(d) : 0;
        return p && M < p ? d + Mh(p - M, b) : d;
      }
      function xQ(d, p, b) {
        d = ci(d), p = Ot(p);
        var M = p ? yu(d) : 0;
        return p && M < p ? Mh(p - M, b) + d : d;
      }
      function IQ(d, p, b) {
        return b || p == null ? p = 0 : p && (p = +p), TL(ci(d).replace(Io, ""), p || 0);
      }
      function SQ(d, p, b) {
        return (b ? un(d, p, b) : p === i) ? p = 1 : p = Ot(p), PA(ci(d), p);
      }
      function RQ() {
        var d = arguments, p = ci(d[0]);
        return d.length < 3 ? p : p.replace(d[1], d[2]);
      }
      var kQ = Su(function(d, p, b) {
        return d + (b ? "_" : "") + p.toLowerCase();
      });
      function wQ(d, p, b) {
        return b && typeof b != "number" && un(d, p, b) && (p = b = i), b = b === i ? oe : b >>> 0, b ? (d = ci(d), d && (typeof p == "string" || p != null && !Ay(p)) && (p = _n(p), !p && Au(d)) ? Pa(Xo(d), 0, b) : d.split(p, b)) : [];
      }
      var MQ = Su(function(d, p, b) {
        return d + (b ? " " : "") + vy(p);
      });
      function NQ(d, p, b) {
        return d = ci(d), b = b == null ? 0 : $l(Ot(b), 0, d.length), p = _n(p), d.slice(b, b + p.length) == p;
      }
      function TQ(d, p, b) {
        var M = U.templateSettings;
        b && un(d, p, b) && (p = i), d = ci(d), p = Yh({}, p, M, RR);
        var j = Yh({}, p.imports, M.imports, RR), Z = Rr(j), ie = TA(j, Z), ae, pe, Te = 0, De = p.interpolate || eh, je = "__p += '", tt = DA(
          (p.escape || eh).source + "|" + De.source + "|" + (De === Xg ? uj : eh).source + "|" + (p.evaluate || eh).source + "|$",
          "g"
        ), mt = "//# sourceURL=" + (hi.call(p, "sourceURL") ? (p.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Kj + "]") + `
`;
        d.replace(tt, function(It, Gt, Pt, eo, dn, to) {
          return Pt || (Pt = eo), je += d.slice(Te, to).replace(Aj, sL), Gt && (ae = !0, je += `' +
__e(` + Gt + `) +
'`), dn && (pe = !0, je += `';
` + dn + `;
__p += '`), Pt && (je += `' +
((__t = (` + Pt + `)) == null ? '' : __t) +
'`), Te = to + It.length, It;
        }), je += `';
`;
        var xt = hi.call(p, "variable") && p.variable;
        if (!xt)
          je = `with (obj) {
` + je + `
}
`;
        else if (lj.test(xt))
          throw new Nt(a);
        je = (pe ? je.replace(Jg, "") : je).replace(uA, "$1").replace(Pg, "$1;"), je = "function(" + (xt || "obj") + `) {
` + (xt ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (ae ? ", __e = _.escape" : "") + (pe ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + je + `return __p
}`;
        var Vt = yk(function() {
          return ai(Z, mt + "return " + je).apply(i, ie);
        });
        if (Vt.source = je, fy(Vt))
          throw Vt;
        return Vt;
      }
      function BQ(d) {
        return ci(d).toLowerCase();
      }
      function DQ(d) {
        return ci(d).toUpperCase();
      }
      function OQ(d, p, b) {
        if (d = ci(d), d && (b || p === i))
          return kS(d);
        if (!d || !(p = _n(p)))
          return d;
        var M = Xo(d), j = Xo(p), Z = wS(M, j), ie = MS(M, j) + 1;
        return Pa(M, Z, ie).join("");
      }
      function FQ(d, p, b) {
        if (d = ci(d), d && (b || p === i))
          return d.slice(0, TS(d) + 1);
        if (!d || !(p = _n(p)))
          return d;
        var M = Xo(d), j = MS(M, Xo(p)) + 1;
        return Pa(M, 0, j).join("");
      }
      function VQ(d, p, b) {
        if (d = ci(d), d && (b || p === i))
          return d.replace(Io, "");
        if (!d || !(p = _n(p)))
          return d;
        var M = Xo(d), j = wS(M, Xo(p));
        return Pa(M, j).join("");
      }
      function qQ(d, p) {
        var b = O, M = F;
        if (Gi(p)) {
          var j = "separator" in p ? p.separator : j;
          b = "length" in p ? Ot(p.length) : b, M = "omission" in p ? _n(p.omission) : M;
        }
        d = ci(d);
        var Z = d.length;
        if (Au(d)) {
          var ie = Xo(d);
          Z = ie.length;
        }
        if (b >= Z)
          return d;
        var ae = b - yu(M);
        if (ae < 1)
          return M;
        var pe = ie ? Pa(ie, 0, ae).join("") : d.slice(0, ae);
        if (j === i)
          return pe + M;
        if (ie && (ae += pe.length - ae), Ay(j)) {
          if (d.slice(ae).search(j)) {
            var Te, De = pe;
            for (j.global || (j = DA(j.source, ci(zI.exec(j)) + "g")), j.lastIndex = 0; Te = j.exec(De); )
              var je = Te.index;
            pe = pe.slice(0, je === i ? ae : je);
          }
        } else if (d.indexOf(_n(j), ae) != ae) {
          var tt = pe.lastIndexOf(j);
          tt > -1 && (pe = pe.slice(0, tt));
        }
        return pe + M;
      }
      function jQ(d) {
        return d = ci(d), d && dA.test(d) ? d.replace(zg, gL) : d;
      }
      var LQ = Su(function(d, p, b) {
        return d + (b ? " " : "") + p.toUpperCase();
      }), vy = ER("toUpperCase");
      function Ak(d, p, b) {
        return d = ci(d), p = b ? i : p, p === i ? lL(d) ? fL(d) : $j(d) : d.match(p) || [];
      }
      var yk = jt(function(d, p) {
        try {
          return Hn(d, i, p);
        } catch (b) {
          return fy(b) ? b : new Nt(b);
        }
      }), KQ = na(function(d, p) {
        return Ro(p, function(b) {
          b = vs(b), ia(d, b, hy(d[b], d));
        }), d;
      });
      function YQ(d) {
        var p = d == null ? 0 : d.length, b = Ct();
        return d = p ? Di(d, function(M) {
          if (typeof M[1] != "function")
            throw new ko(s);
          return [b(M[0]), M[1]];
        }) : [], jt(function(M) {
          for (var j = -1; ++j < p; ) {
            var Z = d[j];
            if (Hn(Z[0], this, M))
              return Hn(Z[1], this, M);
          }
        });
      }
      function UQ(d) {
        return gK(Mo(d, m));
      }
      function by(d) {
        return function() {
          return d;
        };
      }
      function GQ(d, p) {
        return d == null || d !== d ? p : d;
      }
      var QQ = bR(), WQ = bR(!0);
      function Dn(d) {
        return d;
      }
      function Cy(d) {
        return XS(typeof d == "function" ? d : Mo(d, m));
      }
      function ZQ(d) {
        return $S(Mo(d, m));
      }
      function JQ(d, p) {
        return eR(d, Mo(p, m));
      }
      var PQ = jt(function(d, p) {
        return function(b) {
          return Ad(b, d, p);
        };
      }), zQ = jt(function(d, p) {
        return function(b) {
          return Ad(d, b, p);
        };
      });
      function xy(d, p, b) {
        var M = Rr(p), j = Ch(p, M);
        b == null && !(Gi(p) && (j.length || !M.length)) && (b = p, p = d, d = this, j = Ch(p, Rr(p)));
        var Z = !(Gi(b) && "chain" in b) || !!b.chain, ie = sa(d);
        return Ro(j, function(ae) {
          var pe = p[ae];
          d[ae] = pe, ie && (d.prototype[ae] = function() {
            var Te = this.__chain__;
            if (Z || Te) {
              var De = d(this.__wrapped__), je = De.__actions__ = Nn(this.__actions__);
              return je.push({ func: pe, args: arguments, thisArg: d }), De.__chain__ = Te, De;
            }
            return pe.apply(d, Ua([this.value()], arguments));
          });
        }), d;
      }
      function HQ() {
        return jr._ === this && (jr._ = CL), this;
      }
      function Iy() {
      }
      function XQ(d) {
        return d = Ot(d), jt(function(p) {
          return tR(p, d);
        });
      }
      var _Q = ty(Di), $Q = ty(CS), eW = ty(RA);
      function Ek(d) {
        return ly(d) ? kA(vs(d)) : NK(d);
      }
      function tW(d) {
        return function(p) {
          return d == null ? i : ec(d, p);
        };
      }
      var iW = xR(), rW = xR(!0);
      function Sy() {
        return [];
      }
      function Ry() {
        return !1;
      }
      function nW() {
        return {};
      }
      function oW() {
        return "";
      }
      function sW() {
        return !0;
      }
      function aW(d, p) {
        if (d = Ot(d), d < 1 || d > $)
          return [];
        var b = oe, M = zr(d, oe);
        p = Ct(p), d -= oe;
        for (var j = NA(M, p); ++b < d; )
          p(b);
        return j;
      }
      function lW(d) {
        return Bt(d) ? Di(d, vs) : $n(d) ? [d] : Nn(LR(ci(d)));
      }
      function cW(d) {
        var p = ++vL;
        return ci(d) + p;
      }
      var uW = wh(function(d, p) {
        return d + p;
      }, 0), dW = iy("ceil"), mW = wh(function(d, p) {
        return d / p;
      }, 1), gW = iy("floor");
      function hW(d) {
        return d && d.length ? bh(d, Dn, YA) : i;
      }
      function pW(d, p) {
        return d && d.length ? bh(d, Ct(p, 2), YA) : i;
      }
      function fW(d) {
        return SS(d, Dn);
      }
      function AW(d, p) {
        return SS(d, Ct(p, 2));
      }
      function yW(d) {
        return d && d.length ? bh(d, Dn, WA) : i;
      }
      function EW(d, p) {
        return d && d.length ? bh(d, Ct(p, 2), WA) : i;
      }
      var vW = wh(function(d, p) {
        return d * p;
      }, 1), bW = iy("round"), CW = wh(function(d, p) {
        return d - p;
      }, 0);
      function xW(d) {
        return d && d.length ? MA(d, Dn) : 0;
      }
      function IW(d, p) {
        return d && d.length ? MA(d, Ct(p, 2)) : 0;
      }
      return U.after = ZU, U.ary = HR, U.assign = DG, U.assignIn = uk, U.assignInWith = Yh, U.assignWith = OG, U.at = FG, U.before = XR, U.bind = hy, U.bindAll = KQ, U.bindKey = _R, U.castArray = nG, U.chain = JR, U.chunk = gY, U.compact = hY, U.concat = pY, U.cond = YQ, U.conforms = UQ, U.constant = by, U.countBy = xU, U.create = VG, U.curry = $R, U.curryRight = ek, U.debounce = tk, U.defaults = qG, U.defaultsDeep = jG, U.defer = JU, U.delay = PU, U.difference = fY, U.differenceBy = AY, U.differenceWith = yY, U.drop = EY, U.dropRight = vY, U.dropRightWhile = bY, U.dropWhile = CY, U.fill = xY, U.filter = SU, U.flatMap = wU, U.flatMapDeep = MU, U.flatMapDepth = NU, U.flatten = GR, U.flattenDeep = IY, U.flattenDepth = SY, U.flip = zU, U.flow = QQ, U.flowRight = WQ, U.fromPairs = RY, U.functions = WG, U.functionsIn = ZG, U.groupBy = TU, U.initial = wY, U.intersection = MY, U.intersectionBy = NY, U.intersectionWith = TY, U.invert = PG, U.invertBy = zG, U.invokeMap = DU, U.iteratee = Cy, U.keyBy = OU, U.keys = Rr, U.keysIn = Bn, U.map = Fh, U.mapKeys = XG, U.mapValues = _G, U.matches = ZQ, U.matchesProperty = JQ, U.memoize = qh, U.merge = $G, U.mergeWith = dk, U.method = PQ, U.methodOf = zQ, U.mixin = xy, U.negate = jh, U.nthArg = XQ, U.omit = eQ, U.omitBy = tQ, U.once = HU, U.orderBy = FU, U.over = _Q, U.overArgs = XU, U.overEvery = $Q, U.overSome = eW, U.partial = py, U.partialRight = ik, U.partition = VU, U.pick = iQ, U.pickBy = mk, U.property = Ek, U.propertyOf = tW, U.pull = FY, U.pullAll = WR, U.pullAllBy = VY, U.pullAllWith = qY, U.pullAt = jY, U.range = iW, U.rangeRight = rW, U.rearg = _U, U.reject = LU, U.remove = LY, U.rest = $U, U.reverse = my, U.sampleSize = YU, U.set = nQ, U.setWith = oQ, U.shuffle = UU, U.slice = KY, U.sortBy = WU, U.sortedUniq = JY, U.sortedUniqBy = PY, U.split = wQ, U.spread = eG, U.tail = zY, U.take = HY, U.takeRight = XY, U.takeRightWhile = _Y, U.takeWhile = $Y, U.tap = hU, U.throttle = tG, U.thru = Oh, U.toArray = ak, U.toPairs = gk, U.toPairsIn = hk, U.toPath = lW, U.toPlainObject = ck, U.transform = sQ, U.unary = iG, U.union = eU, U.unionBy = tU, U.unionWith = iU, U.uniq = rU, U.uniqBy = nU, U.uniqWith = oU, U.unset = aQ, U.unzip = gy, U.unzipWith = ZR, U.update = lQ, U.updateWith = cQ, U.values = wu, U.valuesIn = uQ, U.without = sU, U.words = Ak, U.wrap = rG, U.xor = aU, U.xorBy = lU, U.xorWith = cU, U.zip = uU, U.zipObject = dU, U.zipObjectDeep = mU, U.zipWith = gU, U.entries = gk, U.entriesIn = hk, U.extend = uk, U.extendWith = Yh, xy(U, U), U.add = uW, U.attempt = yk, U.camelCase = hQ, U.capitalize = pk, U.ceil = dW, U.clamp = dQ, U.clone = oG, U.cloneDeep = aG, U.cloneDeepWith = lG, U.cloneWith = sG, U.conformsTo = cG, U.deburr = fk, U.defaultTo = GQ, U.divide = mW, U.endsWith = pQ, U.eq = $o, U.escape = fQ, U.escapeRegExp = AQ, U.every = IU, U.find = RU, U.findIndex = YR, U.findKey = LG, U.findLast = kU, U.findLastIndex = UR, U.findLastKey = KG, U.floor = gW, U.forEach = PR, U.forEachRight = zR, U.forIn = YG, U.forInRight = UG, U.forOwn = GG, U.forOwnRight = QG, U.get = yy, U.gt = uG, U.gte = dG, U.has = JG, U.hasIn = Ey, U.head = QR, U.identity = Dn, U.includes = BU, U.indexOf = kY, U.inRange = mQ, U.invoke = HG, U.isArguments = rc, U.isArray = Bt, U.isArrayBuffer = mG, U.isArrayLike = Tn, U.isArrayLikeObject = or, U.isBoolean = gG, U.isBuffer = za, U.isDate = hG, U.isElement = pG, U.isEmpty = fG, U.isEqual = AG, U.isEqualWith = yG, U.isError = fy, U.isFinite = EG, U.isFunction = sa, U.isInteger = rk, U.isLength = Lh, U.isMap = nk, U.isMatch = vG, U.isMatchWith = bG, U.isNaN = CG, U.isNative = xG, U.isNil = SG, U.isNull = IG, U.isNumber = ok, U.isObject = Gi, U.isObjectLike = _i, U.isPlainObject = xd, U.isRegExp = Ay, U.isSafeInteger = RG, U.isSet = sk, U.isString = Kh, U.isSymbol = $n, U.isTypedArray = ku, U.isUndefined = kG, U.isWeakMap = wG, U.isWeakSet = MG, U.join = BY, U.kebabCase = yQ, U.last = To, U.lastIndexOf = DY, U.lowerCase = EQ, U.lowerFirst = vQ, U.lt = NG, U.lte = TG, U.max = hW, U.maxBy = pW, U.mean = fW, U.meanBy = AW, U.min = yW, U.minBy = EW, U.stubArray = Sy, U.stubFalse = Ry, U.stubObject = nW, U.stubString = oW, U.stubTrue = sW, U.multiply = vW, U.nth = OY, U.noConflict = HQ, U.noop = Iy, U.now = Vh, U.pad = bQ, U.padEnd = CQ, U.padStart = xQ, U.parseInt = IQ, U.random = gQ, U.reduce = qU, U.reduceRight = jU, U.repeat = SQ, U.replace = RQ, U.result = rQ, U.round = bW, U.runInContext = ge, U.sample = KU, U.size = GU, U.snakeCase = kQ, U.some = QU, U.sortedIndex = YY, U.sortedIndexBy = UY, U.sortedIndexOf = GY, U.sortedLastIndex = QY, U.sortedLastIndexBy = WY, U.sortedLastIndexOf = ZY, U.startCase = MQ, U.startsWith = NQ, U.subtract = CW, U.sum = xW, U.sumBy = IW, U.template = TQ, U.times = aW, U.toFinite = aa, U.toInteger = Ot, U.toLength = lk, U.toLower = BQ, U.toNumber = Bo, U.toSafeInteger = BG, U.toString = ci, U.toUpper = DQ, U.trim = OQ, U.trimEnd = FQ, U.trimStart = VQ, U.truncate = qQ, U.unescape = jQ, U.uniqueId = cW, U.upperCase = LQ, U.upperFirst = vy, U.each = PR, U.eachRight = zR, U.first = QR, xy(U, function() {
        var d = {};
        return ys(U, function(p, b) {
          hi.call(U.prototype, b) || (d[b] = p);
        }), d;
      }(), { chain: !1 }), U.VERSION = r, Ro(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(d) {
        U[d].placeholder = U;
      }), Ro(["drop", "take"], function(d, p) {
        Zt.prototype[d] = function(b) {
          b = b === i ? 1 : yr(Ot(b), 0);
          var M = this.__filtered__ && !p ? new Zt(this) : this.clone();
          return M.__filtered__ ? M.__takeCount__ = zr(b, M.__takeCount__) : M.__views__.push({
            size: zr(b, oe),
            type: d + (M.__dir__ < 0 ? "Right" : "")
          }), M;
        }, Zt.prototype[d + "Right"] = function(b) {
          return this.reverse()[d](b).reverse();
        };
      }), Ro(["filter", "map", "takeWhile"], function(d, p) {
        var b = p + 1, M = b == z || b == H;
        Zt.prototype[d] = function(j) {
          var Z = this.clone();
          return Z.__iteratees__.push({
            iteratee: Ct(j, 3),
            type: b
          }), Z.__filtered__ = Z.__filtered__ || M, Z;
        };
      }), Ro(["head", "last"], function(d, p) {
        var b = "take" + (p ? "Right" : "");
        Zt.prototype[d] = function() {
          return this[b](1).value()[0];
        };
      }), Ro(["initial", "tail"], function(d, p) {
        var b = "drop" + (p ? "" : "Right");
        Zt.prototype[d] = function() {
          return this.__filtered__ ? new Zt(this) : this[b](1);
        };
      }), Zt.prototype.compact = function() {
        return this.filter(Dn);
      }, Zt.prototype.find = function(d) {
        return this.filter(d).head();
      }, Zt.prototype.findLast = function(d) {
        return this.reverse().find(d);
      }, Zt.prototype.invokeMap = jt(function(d, p) {
        return typeof d == "function" ? new Zt(this) : this.map(function(b) {
          return Ad(b, d, p);
        });
      }), Zt.prototype.reject = function(d) {
        return this.filter(jh(Ct(d)));
      }, Zt.prototype.slice = function(d, p) {
        d = Ot(d);
        var b = this;
        return b.__filtered__ && (d > 0 || p < 0) ? new Zt(b) : (d < 0 ? b = b.takeRight(-d) : d && (b = b.drop(d)), p !== i && (p = Ot(p), b = p < 0 ? b.dropRight(-p) : b.take(p - d)), b);
      }, Zt.prototype.takeRightWhile = function(d) {
        return this.reverse().takeWhile(d).reverse();
      }, Zt.prototype.toArray = function() {
        return this.take(oe);
      }, ys(Zt.prototype, function(d, p) {
        var b = /^(?:filter|find|map|reject)|While$/.test(p), M = /^(?:head|last)$/.test(p), j = U[M ? "take" + (p == "last" ? "Right" : "") : p], Z = M || /^find/.test(p);
        j && (U.prototype[p] = function() {
          var ie = this.__wrapped__, ae = M ? [1] : arguments, pe = ie instanceof Zt, Te = ae[0], De = pe || Bt(ie), je = function(Gt) {
            var Pt = j.apply(U, Ua([Gt], ae));
            return M && tt ? Pt[0] : Pt;
          };
          De && b && typeof Te == "function" && Te.length != 1 && (pe = De = !1);
          var tt = this.__chain__, mt = !!this.__actions__.length, xt = Z && !tt, Vt = pe && !mt;
          if (!Z && De) {
            ie = Vt ? ie : new Zt(this);
            var It = d.apply(ie, ae);
            return It.__actions__.push({ func: Oh, args: [je], thisArg: i }), new wo(It, tt);
          }
          return xt && Vt ? d.apply(this, ae) : (It = this.thru(je), xt ? M ? It.value()[0] : It.value() : It);
        });
      }), Ro(["pop", "push", "shift", "sort", "splice", "unshift"], function(d) {
        var p = sh[d], b = /^(?:push|sort|unshift)$/.test(d) ? "tap" : "thru", M = /^(?:pop|shift)$/.test(d);
        U.prototype[d] = function() {
          var j = arguments;
          if (M && !this.__chain__) {
            var Z = this.value();
            return p.apply(Bt(Z) ? Z : [], j);
          }
          return this[b](function(ie) {
            return p.apply(Bt(ie) ? ie : [], j);
          });
        };
      }), ys(Zt.prototype, function(d, p) {
        var b = U[p];
        if (b) {
          var M = b.name + "";
          hi.call(Cu, M) || (Cu[M] = []), Cu[M].push({ name: p, func: b });
        }
      }), Cu[kh(i, v).name] = [{
        name: "wrapper",
        func: i
      }], Zt.prototype.clone = jL, Zt.prototype.reverse = LL, Zt.prototype.value = KL, U.prototype.at = pU, U.prototype.chain = fU, U.prototype.commit = AU, U.prototype.next = yU, U.prototype.plant = vU, U.prototype.reverse = bU, U.prototype.toJSON = U.prototype.valueOf = U.prototype.value = CU, U.prototype.first = U.prototype.head, ud && (U.prototype[ud] = EU), U;
    }, Eu = AL();
    zl ? ((zl.exports = Eu)._ = Eu, CA._ = Eu) : jr._ = Eu;
  }).call(yt);
})(g1, g1.exports);
var T9 = g1.exports;
const Ut = /* @__PURE__ */ Ho(T9);
let B9 = (e) => crypto.getRandomValues(new Uint8Array(e)), D9 = (e, t, i) => {
  let r = (2 << Math.log2(e.length - 1)) - 1, n = -~(1.6 * r * t / e.length);
  return (o = t) => {
    let s = "";
    for (; ; ) {
      let a = i(n), l = n | 0;
      for (; l--; )
        if (s += e[a[l] & r] || "", s.length >= o)
          return s;
    }
  };
}, O9 = (e, t = 21) => D9(e, t | 0, B9);
function pb(e, t, i = !1) {
  return i ? pb(t, e) : e == t ? 0 : e == null ? -1 : t == null ? 1 : typeof e == "string" && typeof t == "string" ? e.localeCompare(t, "standard", { sensitivity: "case" }) : t > e ? -1 : 1;
}
function fb(e, t) {
  const i = new URLSearchParams(window.location.search);
  t === void 0 ? i.delete(e) : i.set(e, t);
}
function cm(e, t) {
  return e ? [t] : [];
}
function Hk(e, t, i) {
  return e ? { [t]: i } : {};
}
function F5e(e, t) {
  return t !== void 0 ? { [e]: t } : {};
}
function Gs(e) {
  return e === void 0 ? "" : typeof e == "string" && /^(\w+) ([1-9]|[12][0-9]|3[01]), \d{4}$/.test(e) ? e : (typeof e == "string" ? new Date(e) : e).toLocaleDateString(void 0, {
    year: "numeric",
    month: "long",
    day: "numeric"
  });
}
function eu(e, t = "") {
  return e.startsWith("http") && !e.includes("maxroll") ? e.replace("http://localhost:8788", "").replace("http://localhost", "") : e.replace(t, "").replace("http://localhost:8788", "").replace("http://localhost", "").replace("https://staging.maxroll.net", "").replace("https://backend.maxroll.net", "").replace("https://backend.maxroll.gg", "").replace("https://backend-staging.maxroll.net", "").replace("https://backend-staging.maxroll.gg", "").replace("https://frontend-staging.maxroll.gg", "").replace("https://maxroll.gg", "");
}
const Cc = (e, t) => e || `${t}/images/empty-asset.webp`, PT = (e) => {
  const t = {}, i = e.indexOf("?");
  if (i !== -1) {
    const n = e.slice(i + 1).split("&");
    for (const o of n) {
      const [s, a] = o.split("=");
      t[decodeURIComponent(s)] = decodeURIComponent(a);
    }
  }
  return t;
}, Xk = (e) => e.toLowerCase().replace(/[^a-zA-Z0-9\s]/g, " ").split(/\s+/), V5e = (e, t) => {
  const i = Xk(e);
  return Xk(t).every((n) => i.some((o) => o.includes(n)));
};
function i0(e, t, i = !1, r) {
  return e == t ? !0 : e == null ? !1 : typeof e == "string" && (r ? r(e, t) : e.toLowerCase().includes(t)) ? !0 : typeof e == "number" ? `${e}`.includes(t) : typeof e == "object" && i ? Array.isArray(e) ? e.some((n) => i0(n, t, i)) : Object.keys(e).some((n) => i0(n, t, i)) || Object.values(e).some((n) => i0(n, t, i)) : !1;
}
function of(e, t, i = !1, r) {
  const n = t.toLowerCase();
  return i ? i0(e, n, i) : Object.keys(e).some((o) => i0(o, n, i, r)) || Object.values(e).some((o) => i0(o, n, i, r));
}
function zT(e, t = 300) {
  const i = Ne(e);
  return i.current = e, we(() => {
    const n = () => {
      var o;
      (o = i.current) == null || o.call(i);
    };
    return Ut.debounce(n, t);
  }, [t]);
}
function HT(e, t) {
  be(() => {
    function i(r) {
      var o;
      if (!e)
        return;
      const n = "current" in e ? e.current : e;
      n && !((o = n.contains) != null && o.call(n, r.target)) && t();
    }
    return document.addEventListener("mousedown", i), () => {
      document.removeEventListener("mousedown", i);
    };
  }, [e, t]);
}
function F9(e, t, i) {
  e /= 255, t /= 255, i /= 255;
  const r = Math.max(e, t, i), n = Math.min(e, t, i);
  let o = 0, s, a = (r + n) / 2;
  if (r === n)
    return [0, 0, a];
  const l = r - n;
  return s = a > 0.5 ? l / (2 - r - n) : l / (r + n), r === e && (o = (t - i) / l + (t < i ? 6 : 0)), r === t && (o = (i - e) / l + 2), r === i && (o = (e - t) / l + 4), o /= 6, [o, s, a];
}
function V9(e) {
  const t = typeof e == "number" ? e : e.getTime(), i = Math.round((t - Date.now()) / 1e3), r = Math.abs(i), n = r / (3600 * 24), o = r % (3600 * 24) / 3600, s = r % 3600 / 60, a = [
    ...cm(n >= 1, `${Math.floor(n)}d`),
    ...cm(o >= 1, `${Math.floor(o)}h`),
    ...cm(s >= 1, `${Math.floor(s)}m`),
    `${r % 60}s`
  ], l = a.join(" ");
  return {
    time: a,
    delta: i,
    short: i < 0 ? `${a[0]} ago` : `in ${a[0]}`,
    verbose: i < 0 ? `${l} ago` : `in ${l}`
  };
}
function XT(e) {
  return e.toLowerCase().trim().replace(/ /g, "-").replace(/[\&\+]/, "").split("-").filter((t) => t.length !== 0).join("-");
}
function q9(e) {
  var t, i, r, n, o, s, a, l, c;
  if (typeof e == "string") {
    if (e.includes("watch?v="))
      return (r = (i = (t = e.split("watch?v=")) == null ? void 0 : t[1]) == null ? void 0 : i.split("&")) == null ? void 0 : r[0];
    if (e.includes("embed/"))
      return (s = (o = (n = e.split("embed/")) == null ? void 0 : n[1]) == null ? void 0 : o.split("?")) == null ? void 0 : s[0];
    if (e.includes("youtu.be/"))
      return (c = (l = (a = e.split("youtu.be/")) == null ? void 0 : a[1]) == null ? void 0 : l.split("?")) == null ? void 0 : c[0];
  }
  return e;
}
function sf(...e) {
  return (t) => {
    for (const i of e)
      typeof i == "function" ? i(t) : i && (i.current = t);
  };
}
const j9 = O9("0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz", 8);
function go() {
  return j9();
}
function _T(e, t = !1) {
  const i = [], r = /\[(\/?[a-z0-9-]+)([\s\S]*?)(\/?)\]/gi, n = [];
  let o = 0, s;
  for (; (s = r.exec(e)) !== null; ) {
    const a = s[1].startsWith("/"), l = a ? s[1].slice(1) : s[1], c = L9(s[2]), u = !!s[3];
    if (!(t && (u || !n.length))) {
      if (a) {
        const m = n.pop();
        m && m.type === l && (m.content = e.slice(o, s.index).trim());
      } else {
        const m = {
          type: l,
          attributes: c,
          children: [],
          content: ""
        };
        if (n.push(m), u) {
          n.pop();
          const g = n[n.length - 1];
          g ? g.children.push(m) : i.push(m);
        } else
          i.push(m);
      }
      o = r.lastIndex;
    }
  }
  return i.filter((a) => a.type.length > 1);
}
function L9(e) {
  const t = {};
  for (const i of e.trim().split(" ")) {
    const r = i.trim();
    if (r.includes("=")) {
      const n = r.split("=");
      t[n[0]] = n[1];
    } else
      t[r] = r;
  }
  return t;
}
function K9(r) {
  var n = r, {
    customReferenceSize: e,
    fitToParentId: t
  } = n, i = Fe(n, [
    "customReferenceSize",
    "fitToParentId"
  ]);
  const [o] = gi((g) => ({
    loaded: g.viewport.loaded,
    width: g.viewport.width,
    md: g.viewport.md
  })), [s, a] = se(void 0);
  be(() => {
    if (typeof window == "undefined")
      return;
    let g;
    if (t) {
      const h = document.getElementById(t);
      if (!h)
        return;
      const A = h.clientWidth || 0;
      A !== 0 ? a(A) : (g = new ResizeObserver(function(y) {
        const E = y[0].contentRect.width;
        E === void 0 || E === 0 || (a(E), g == null || g.disconnect());
      }), g.observe(h));
    }
    return () => {
      g == null || g.disconnect();
    };
  }, []);
  const l = o.md ? 144 : 40, c = s || e || o.width - l, u = c >= 970 ? "large-leaderboard" : c >= 728 ? "leaderboard" : "rectangle", m = t !== void 0;
  return o.loaded && (!m || s !== void 0 && s !== 0) ? /* @__PURE__ */ f(Vf, q({ type: u }, i)) : null;
}
const Y9 = /* @__PURE__ */ new Set([
  65534,
  65535,
  131070,
  131071,
  196606,
  196607,
  262142,
  262143,
  327678,
  327679,
  393214,
  393215,
  458750,
  458751,
  524286,
  524287,
  589822,
  589823,
  655358,
  655359,
  720894,
  720895,
  786430,
  786431,
  851966,
  851967,
  917502,
  917503,
  983038,
  983039,
  1048574,
  1048575,
  1114110,
  1114111
]), Oi = "�";
var J;
(function(e) {
  e[e.EOF = -1] = "EOF", e[e.NULL = 0] = "NULL", e[e.TABULATION = 9] = "TABULATION", e[e.CARRIAGE_RETURN = 13] = "CARRIAGE_RETURN", e[e.LINE_FEED = 10] = "LINE_FEED", e[e.FORM_FEED = 12] = "FORM_FEED", e[e.SPACE = 32] = "SPACE", e[e.EXCLAMATION_MARK = 33] = "EXCLAMATION_MARK", e[e.QUOTATION_MARK = 34] = "QUOTATION_MARK", e[e.NUMBER_SIGN = 35] = "NUMBER_SIGN", e[e.AMPERSAND = 38] = "AMPERSAND", e[e.APOSTROPHE = 39] = "APOSTROPHE", e[e.HYPHEN_MINUS = 45] = "HYPHEN_MINUS", e[e.SOLIDUS = 47] = "SOLIDUS", e[e.DIGIT_0 = 48] = "DIGIT_0", e[e.DIGIT_9 = 57] = "DIGIT_9", e[e.SEMICOLON = 59] = "SEMICOLON", e[e.LESS_THAN_SIGN = 60] = "LESS_THAN_SIGN", e[e.EQUALS_SIGN = 61] = "EQUALS_SIGN", e[e.GREATER_THAN_SIGN = 62] = "GREATER_THAN_SIGN", e[e.QUESTION_MARK = 63] = "QUESTION_MARK", e[e.LATIN_CAPITAL_A = 65] = "LATIN_CAPITAL_A", e[e.LATIN_CAPITAL_F = 70] = "LATIN_CAPITAL_F", e[e.LATIN_CAPITAL_X = 88] = "LATIN_CAPITAL_X", e[e.LATIN_CAPITAL_Z = 90] = "LATIN_CAPITAL_Z", e[e.RIGHT_SQUARE_BRACKET = 93] = "RIGHT_SQUARE_BRACKET", e[e.GRAVE_ACCENT = 96] = "GRAVE_ACCENT", e[e.LATIN_SMALL_A = 97] = "LATIN_SMALL_A", e[e.LATIN_SMALL_F = 102] = "LATIN_SMALL_F", e[e.LATIN_SMALL_X = 120] = "LATIN_SMALL_X", e[e.LATIN_SMALL_Z = 122] = "LATIN_SMALL_Z", e[e.REPLACEMENT_CHARACTER = 65533] = "REPLACEMENT_CHARACTER";
})(J = J || (J = {}));
const On = {
  DASH_DASH: "--",
  CDATA_START: "[CDATA[",
  DOCTYPE: "doctype",
  SCRIPT: "script",
  PUBLIC: "public",
  SYSTEM: "system"
};
function $T(e) {
  return e >= 55296 && e <= 57343;
}
function U9(e) {
  return e >= 56320 && e <= 57343;
}
function G9(e, t) {
  return (e - 55296) * 1024 + 9216 + t;
}
function e5(e) {
  return e !== 32 && e !== 10 && e !== 13 && e !== 9 && e !== 12 && e >= 1 && e <= 31 || e >= 127 && e <= 159;
}
function t5(e) {
  return e >= 64976 && e <= 65007 || Y9.has(e);
}
var Se;
(function(e) {
  e.controlCharacterInInputStream = "control-character-in-input-stream", e.noncharacterInInputStream = "noncharacter-in-input-stream", e.surrogateInInputStream = "surrogate-in-input-stream", e.nonVoidHtmlElementStartTagWithTrailingSolidus = "non-void-html-element-start-tag-with-trailing-solidus", e.endTagWithAttributes = "end-tag-with-attributes", e.endTagWithTrailingSolidus = "end-tag-with-trailing-solidus", e.unexpectedSolidusInTag = "unexpected-solidus-in-tag", e.unexpectedNullCharacter = "unexpected-null-character", e.unexpectedQuestionMarkInsteadOfTagName = "unexpected-question-mark-instead-of-tag-name", e.invalidFirstCharacterOfTagName = "invalid-first-character-of-tag-name", e.unexpectedEqualsSignBeforeAttributeName = "unexpected-equals-sign-before-attribute-name", e.missingEndTagName = "missing-end-tag-name", e.unexpectedCharacterInAttributeName = "unexpected-character-in-attribute-name", e.unknownNamedCharacterReference = "unknown-named-character-reference", e.missingSemicolonAfterCharacterReference = "missing-semicolon-after-character-reference", e.unexpectedCharacterAfterDoctypeSystemIdentifier = "unexpected-character-after-doctype-system-identifier", e.unexpectedCharacterInUnquotedAttributeValue = "unexpected-character-in-unquoted-attribute-value", e.eofBeforeTagName = "eof-before-tag-name", e.eofInTag = "eof-in-tag", e.missingAttributeValue = "missing-attribute-value", e.missingWhitespaceBetweenAttributes = "missing-whitespace-between-attributes", e.missingWhitespaceAfterDoctypePublicKeyword = "missing-whitespace-after-doctype-public-keyword", e.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers = "missing-whitespace-between-doctype-public-and-system-identifiers", e.missingWhitespaceAfterDoctypeSystemKeyword = "missing-whitespace-after-doctype-system-keyword", e.missingQuoteBeforeDoctypePublicIdentifier = "missing-quote-before-doctype-public-identifier", e.missingQuoteBeforeDoctypeSystemIdentifier = "missing-quote-before-doctype-system-identifier", e.missingDoctypePublicIdentifier = "missing-doctype-public-identifier", e.missingDoctypeSystemIdentifier = "missing-doctype-system-identifier", e.abruptDoctypePublicIdentifier = "abrupt-doctype-public-identifier", e.abruptDoctypeSystemIdentifier = "abrupt-doctype-system-identifier", e.cdataInHtmlContent = "cdata-in-html-content", e.incorrectlyOpenedComment = "incorrectly-opened-comment", e.eofInScriptHtmlCommentLikeText = "eof-in-script-html-comment-like-text", e.eofInDoctype = "eof-in-doctype", e.nestedComment = "nested-comment", e.abruptClosingOfEmptyComment = "abrupt-closing-of-empty-comment", e.eofInComment = "eof-in-comment", e.incorrectlyClosedComment = "incorrectly-closed-comment", e.eofInCdata = "eof-in-cdata", e.absenceOfDigitsInNumericCharacterReference = "absence-of-digits-in-numeric-character-reference", e.nullCharacterReference = "null-character-reference", e.surrogateCharacterReference = "surrogate-character-reference", e.characterReferenceOutsideUnicodeRange = "character-reference-outside-unicode-range", e.controlCharacterReference = "control-character-reference", e.noncharacterCharacterReference = "noncharacter-character-reference", e.missingWhitespaceBeforeDoctypeName = "missing-whitespace-before-doctype-name", e.missingDoctypeName = "missing-doctype-name", e.invalidCharacterSequenceAfterDoctypeName = "invalid-character-sequence-after-doctype-name", e.duplicateAttribute = "duplicate-attribute", e.nonConformingDoctype = "non-conforming-doctype", e.missingDoctype = "missing-doctype", e.misplacedDoctype = "misplaced-doctype", e.endTagWithoutMatchingOpenElement = "end-tag-without-matching-open-element", e.closingOfElementWithOpenChildElements = "closing-of-element-with-open-child-elements", e.disallowedContentInNoscriptInHead = "disallowed-content-in-noscript-in-head", e.openElementsLeftAfterEof = "open-elements-left-after-eof", e.abandonedHeadElementChild = "abandoned-head-element-child", e.misplacedStartTagForHeadElement = "misplaced-start-tag-for-head-element", e.nestedNoscriptInHead = "nested-noscript-in-head", e.eofInElementThatCanContainOnlyText = "eof-in-element-that-can-contain-only-text";
})(Se = Se || (Se = {}));
const Q9 = 65536;
class W9 {
  constructor(t) {
    this.handler = t, this.html = "", this.pos = -1, this.lastGapPos = -2, this.gapStack = [], this.skipNextNewLine = !1, this.lastChunkWritten = !1, this.endOfChunkHit = !1, this.bufferWaterline = Q9, this.isEol = !1, this.lineStartPos = 0, this.droppedBufferSize = 0, this.line = 1, this.lastErrOffset = -1;
  }
  /** The column on the current line. If we just saw a gap (eg. a surrogate pair), return the index before. */
  get col() {
    return this.pos - this.lineStartPos + +(this.lastGapPos !== this.pos);
  }
  get offset() {
    return this.droppedBufferSize + this.pos;
  }
  getError(t) {
    const { line: i, col: r, offset: n } = this;
    return {
      code: t,
      startLine: i,
      endLine: i,
      startCol: r,
      endCol: r,
      startOffset: n,
      endOffset: n
    };
  }
  _err(t) {
    this.handler.onParseError && this.lastErrOffset !== this.offset && (this.lastErrOffset = this.offset, this.handler.onParseError(this.getError(t)));
  }
  _addGap() {
    this.gapStack.push(this.lastGapPos), this.lastGapPos = this.pos;
  }
  _processSurrogate(t) {
    if (this.pos !== this.html.length - 1) {
      const i = this.html.charCodeAt(this.pos + 1);
      if (U9(i))
        return this.pos++, this._addGap(), G9(t, i);
    } else if (!this.lastChunkWritten)
      return this.endOfChunkHit = !0, J.EOF;
    return this._err(Se.surrogateInInputStream), t;
  }
  willDropParsedChunk() {
    return this.pos > this.bufferWaterline;
  }
  dropParsedChunk() {
    this.willDropParsedChunk() && (this.html = this.html.substring(this.pos), this.lineStartPos -= this.pos, this.droppedBufferSize += this.pos, this.pos = 0, this.lastGapPos = -2, this.gapStack.length = 0);
  }
  write(t, i) {
    this.html.length > 0 ? this.html += t : this.html = t, this.endOfChunkHit = !1, this.lastChunkWritten = i;
  }
  insertHtmlAtCurrentPos(t) {
    this.html = this.html.substring(0, this.pos + 1) + t + this.html.substring(this.pos + 1), this.endOfChunkHit = !1;
  }
  startsWith(t, i) {
    if (this.pos + t.length > this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, !1;
    if (i)
      return this.html.startsWith(t, this.pos);
    for (let r = 0; r < t.length; r++)
      if ((this.html.charCodeAt(this.pos + r) | 32) !== t.charCodeAt(r))
        return !1;
    return !0;
  }
  peek(t) {
    const i = this.pos + t;
    if (i >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, J.EOF;
    const r = this.html.charCodeAt(i);
    return r === J.CARRIAGE_RETURN ? J.LINE_FEED : r;
  }
  advance() {
    if (this.pos++, this.isEol && (this.isEol = !1, this.line++, this.lineStartPos = this.pos), this.pos >= this.html.length)
      return this.endOfChunkHit = !this.lastChunkWritten, J.EOF;
    let t = this.html.charCodeAt(this.pos);
    return t === J.CARRIAGE_RETURN ? (this.isEol = !0, this.skipNextNewLine = !0, J.LINE_FEED) : t === J.LINE_FEED && (this.isEol = !0, this.skipNextNewLine) ? (this.line--, this.skipNextNewLine = !1, this._addGap(), this.advance()) : (this.skipNextNewLine = !1, $T(t) && (t = this._processSurrogate(t)), this.handler.onParseError === null || t > 31 && t < 127 || t === J.LINE_FEED || t === J.CARRIAGE_RETURN || t > 159 && t < 64976 || this._checkForProblematicCharacters(t), t);
  }
  _checkForProblematicCharacters(t) {
    e5(t) ? this._err(Se.controlCharacterInInputStream) : t5(t) && this._err(Se.noncharacterInInputStream);
  }
  retreat(t) {
    for (this.pos -= t; this.pos < this.lastGapPos; )
      this.lastGapPos = this.gapStack.pop(), this.pos--;
    this.isEol = !1;
  }
}
var Xt;
(function(e) {
  e[e.CHARACTER = 0] = "CHARACTER", e[e.NULL_CHARACTER = 1] = "NULL_CHARACTER", e[e.WHITESPACE_CHARACTER = 2] = "WHITESPACE_CHARACTER", e[e.START_TAG = 3] = "START_TAG", e[e.END_TAG = 4] = "END_TAG", e[e.COMMENT = 5] = "COMMENT", e[e.DOCTYPE = 6] = "DOCTYPE", e[e.EOF = 7] = "EOF", e[e.HIBERNATION = 8] = "HIBERNATION";
})(Xt = Xt || (Xt = {}));
function i5(e, t) {
  for (let i = e.attrs.length - 1; i >= 0; i--)
    if (e.attrs[i].name === t)
      return e.attrs[i].value;
  return null;
}
const ul = new Uint16Array(
  // prettier-ignore
  'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map((e) => e.charCodeAt(0))
), Z9 = new Uint16Array(
  // prettier-ignore
  "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map((e) => e.charCodeAt(0))
);
var Ly;
const J9 = /* @__PURE__ */ new Map([
  [0, 65533],
  // C1 Unicode control character reference replacements
  [128, 8364],
  [130, 8218],
  [131, 402],
  [132, 8222],
  [133, 8230],
  [134, 8224],
  [135, 8225],
  [136, 710],
  [137, 8240],
  [138, 352],
  [139, 8249],
  [140, 338],
  [142, 381],
  [145, 8216],
  [146, 8217],
  [147, 8220],
  [148, 8221],
  [149, 8226],
  [150, 8211],
  [151, 8212],
  [152, 732],
  [153, 8482],
  [154, 353],
  [155, 8250],
  [156, 339],
  [158, 382],
  [159, 376]
]), P9 = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
  (Ly = String.fromCodePoint) !== null && Ly !== void 0 ? Ly : function(e) {
    let t = "";
    return e > 65535 && (e -= 65536, t += String.fromCharCode(e >>> 10 & 1023 | 55296), e = 56320 | e & 1023), t += String.fromCharCode(e), t;
  }
);
function z9(e) {
  var t;
  return e >= 55296 && e <= 57343 || e > 1114111 ? 65533 : (t = J9.get(e)) !== null && t !== void 0 ? t : e;
}
var Br;
(function(e) {
  e[e.NUM = 35] = "NUM", e[e.SEMI = 59] = "SEMI", e[e.EQUALS = 61] = "EQUALS", e[e.ZERO = 48] = "ZERO", e[e.NINE = 57] = "NINE", e[e.LOWER_A = 97] = "LOWER_A", e[e.LOWER_F = 102] = "LOWER_F", e[e.LOWER_X = 120] = "LOWER_X", e[e.LOWER_Z = 122] = "LOWER_Z", e[e.UPPER_A = 65] = "UPPER_A", e[e.UPPER_F = 70] = "UPPER_F", e[e.UPPER_Z = 90] = "UPPER_Z";
})(Br || (Br = {}));
const H9 = 32;
var Os;
(function(e) {
  e[e.VALUE_LENGTH = 49152] = "VALUE_LENGTH", e[e.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", e[e.JUMP_TABLE = 127] = "JUMP_TABLE";
})(Os || (Os = {}));
function Ab(e) {
  return e >= Br.ZERO && e <= Br.NINE;
}
function X9(e) {
  return e >= Br.UPPER_A && e <= Br.UPPER_F || e >= Br.LOWER_A && e <= Br.LOWER_F;
}
function _9(e) {
  return e >= Br.UPPER_A && e <= Br.UPPER_Z || e >= Br.LOWER_A && e <= Br.LOWER_Z || Ab(e);
}
function $9(e) {
  return e === Br.EQUALS || _9(e);
}
var kr;
(function(e) {
  e[e.EntityStart = 0] = "EntityStart", e[e.NumericStart = 1] = "NumericStart", e[e.NumericDecimal = 2] = "NumericDecimal", e[e.NumericHex = 3] = "NumericHex", e[e.NamedEntity = 4] = "NamedEntity";
})(kr || (kr = {}));
var fc;
(function(e) {
  e[e.Legacy = 0] = "Legacy", e[e.Strict = 1] = "Strict", e[e.Attribute = 2] = "Attribute";
})(fc || (fc = {}));
class eZ {
  constructor(t, i, r) {
    this.decodeTree = t, this.emitCodePoint = i, this.errors = r, this.state = kr.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = fc.Strict;
  }
  /** Resets the instance to make it reusable. */
  startEntity(t) {
    this.decodeMode = t, this.state = kr.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   *
   * @param string The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(t, i) {
    switch (this.state) {
      case kr.EntityStart:
        return t.charCodeAt(i) === Br.NUM ? (this.state = kr.NumericStart, this.consumed += 1, this.stateNumericStart(t, i + 1)) : (this.state = kr.NamedEntity, this.stateNamedEntity(t, i));
      case kr.NumericStart:
        return this.stateNumericStart(t, i);
      case kr.NumericDecimal:
        return this.stateNumericDecimal(t, i);
      case kr.NumericHex:
        return this.stateNumericHex(t, i);
      case kr.NamedEntity:
        return this.stateNamedEntity(t, i);
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericStart(t, i) {
    return i >= t.length ? -1 : (t.charCodeAt(i) | H9) === Br.LOWER_X ? (this.state = kr.NumericHex, this.consumed += 1, this.stateNumericHex(t, i + 1)) : (this.state = kr.NumericDecimal, this.stateNumericDecimal(t, i));
  }
  addToNumericResult(t, i, r, n) {
    if (i !== r) {
      const o = r - i;
      this.result = this.result * Math.pow(n, o) + parseInt(t.substr(i, o), n), this.consumed += o;
    }
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(t, i) {
    const r = i;
    for (; i < t.length; ) {
      const n = t.charCodeAt(i);
      if (Ab(n) || X9(n))
        i += 1;
      else
        return this.addToNumericResult(t, r, i, 16), this.emitNumericEntity(n, 3);
    }
    return this.addToNumericResult(t, r, i, 16), -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(t, i) {
    const r = i;
    for (; i < t.length; ) {
      const n = t.charCodeAt(i);
      if (Ab(n))
        i += 1;
      else
        return this.addToNumericResult(t, r, i, 10), this.emitNumericEntity(n, 2);
    }
    return this.addToNumericResult(t, r, i, 10), -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   *
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(t, i) {
    var r;
    if (this.consumed <= i)
      return (r = this.errors) === null || r === void 0 || r.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    if (t === Br.SEMI)
      this.consumed += 1;
    else if (this.decodeMode === fc.Strict)
      return 0;
    return this.emitCodePoint(z9(this.result), this.consumed), this.errors && (t !== Br.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(t, i) {
    const { decodeTree: r } = this;
    let n = r[this.treeIndex], o = (n & Os.VALUE_LENGTH) >> 14;
    for (; i < t.length; i++, this.excess++) {
      const s = t.charCodeAt(i);
      if (this.treeIndex = n5(r, n, this.treeIndex + Math.max(1, o), s), this.treeIndex < 0)
        return this.result === 0 || // If we are parsing an attribute
        this.decodeMode === fc.Attribute && // We shouldn't have consumed any characters after the entity,
        (o === 0 || // And there should be no invalid characters.
        $9(s)) ? 0 : this.emitNotTerminatedNamedEntity();
      if (n = r[this.treeIndex], o = (n & Os.VALUE_LENGTH) >> 14, o !== 0) {
        if (s === Br.SEMI)
          return this.emitNamedEntityData(this.treeIndex, o, this.consumed + this.excess);
        this.decodeMode !== fc.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
      }
    }
    return -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   *
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    var t;
    const { result: i, decodeTree: r } = this, n = (r[i] & Os.VALUE_LENGTH) >> 14;
    return this.emitNamedEntityData(i, n, this.consumed), (t = this.errors) === null || t === void 0 || t.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  /**
   * Emit a named entity.
   *
   * @param result The index of the entity in the decode tree.
   * @param valueLength The number of bytes in the entity.
   * @param consumed The number of characters consumed.
   *
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(t, i, r) {
    const { decodeTree: n } = this;
    return this.emitCodePoint(i === 1 ? n[t] & ~Os.VALUE_LENGTH : n[t + 1], r), i === 3 && this.emitCodePoint(n[t + 2], r), r;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   *
   * @returns The number of characters consumed.
   */
  end() {
    var t;
    switch (this.state) {
      case kr.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== fc.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      case kr.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case kr.NumericHex:
        return this.emitNumericEntity(0, 3);
      case kr.NumericStart:
        return (t = this.errors) === null || t === void 0 || t.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      case kr.EntityStart:
        return 0;
    }
  }
}
function r5(e) {
  let t = "";
  const i = new eZ(e, (r) => t += P9(r));
  return function(n, o) {
    let s = 0, a = 0;
    for (; (a = n.indexOf("&", a)) >= 0; ) {
      t += n.slice(s, a), i.startEntity(o);
      const c = i.write(
        n,
        // Skip the "&"
        a + 1
      );
      if (c < 0) {
        s = a + i.end();
        break;
      }
      s = a + c, a = c === 0 ? s + 1 : s;
    }
    const l = t + n.slice(s);
    return t = "", l;
  };
}
function n5(e, t, i, r) {
  const n = (t & Os.BRANCH_LENGTH) >> 7, o = t & Os.JUMP_TABLE;
  if (n === 0)
    return o !== 0 && r === o ? i : -1;
  if (o) {
    const l = r - o;
    return l < 0 || l >= n ? -1 : e[i + l] - 1;
  }
  let s = i, a = s + n - 1;
  for (; s <= a; ) {
    const l = s + a >>> 1, c = e[l];
    if (c < r)
      s = l + 1;
    else if (c > r)
      a = l - 1;
    else
      return e[l + n];
  }
  return -1;
}
r5(ul);
r5(Z9);
var ke;
(function(e) {
  e.HTML = "http://www.w3.org/1999/xhtml", e.MATHML = "http://www.w3.org/1998/Math/MathML", e.SVG = "http://www.w3.org/2000/svg", e.XLINK = "http://www.w3.org/1999/xlink", e.XML = "http://www.w3.org/XML/1998/namespace", e.XMLNS = "http://www.w3.org/2000/xmlns/";
})(ke = ke || (ke = {}));
var Cl;
(function(e) {
  e.TYPE = "type", e.ACTION = "action", e.ENCODING = "encoding", e.PROMPT = "prompt", e.NAME = "name", e.COLOR = "color", e.FACE = "face", e.SIZE = "size";
})(Cl = Cl || (Cl = {}));
var mo;
(function(e) {
  e.NO_QUIRKS = "no-quirks", e.QUIRKS = "quirks", e.LIMITED_QUIRKS = "limited-quirks";
})(mo = mo || (mo = {}));
var Ee;
(function(e) {
  e.A = "a", e.ADDRESS = "address", e.ANNOTATION_XML = "annotation-xml", e.APPLET = "applet", e.AREA = "area", e.ARTICLE = "article", e.ASIDE = "aside", e.B = "b", e.BASE = "base", e.BASEFONT = "basefont", e.BGSOUND = "bgsound", e.BIG = "big", e.BLOCKQUOTE = "blockquote", e.BODY = "body", e.BR = "br", e.BUTTON = "button", e.CAPTION = "caption", e.CENTER = "center", e.CODE = "code", e.COL = "col", e.COLGROUP = "colgroup", e.DD = "dd", e.DESC = "desc", e.DETAILS = "details", e.DIALOG = "dialog", e.DIR = "dir", e.DIV = "div", e.DL = "dl", e.DT = "dt", e.EM = "em", e.EMBED = "embed", e.FIELDSET = "fieldset", e.FIGCAPTION = "figcaption", e.FIGURE = "figure", e.FONT = "font", e.FOOTER = "footer", e.FOREIGN_OBJECT = "foreignObject", e.FORM = "form", e.FRAME = "frame", e.FRAMESET = "frameset", e.H1 = "h1", e.H2 = "h2", e.H3 = "h3", e.H4 = "h4", e.H5 = "h5", e.H6 = "h6", e.HEAD = "head", e.HEADER = "header", e.HGROUP = "hgroup", e.HR = "hr", e.HTML = "html", e.I = "i", e.IMG = "img", e.IMAGE = "image", e.INPUT = "input", e.IFRAME = "iframe", e.KEYGEN = "keygen", e.LABEL = "label", e.LI = "li", e.LINK = "link", e.LISTING = "listing", e.MAIN = "main", e.MALIGNMARK = "malignmark", e.MARQUEE = "marquee", e.MATH = "math", e.MENU = "menu", e.META = "meta", e.MGLYPH = "mglyph", e.MI = "mi", e.MO = "mo", e.MN = "mn", e.MS = "ms", e.MTEXT = "mtext", e.NAV = "nav", e.NOBR = "nobr", e.NOFRAMES = "noframes", e.NOEMBED = "noembed", e.NOSCRIPT = "noscript", e.OBJECT = "object", e.OL = "ol", e.OPTGROUP = "optgroup", e.OPTION = "option", e.P = "p", e.PARAM = "param", e.PLAINTEXT = "plaintext", e.PRE = "pre", e.RB = "rb", e.RP = "rp", e.RT = "rt", e.RTC = "rtc", e.RUBY = "ruby", e.S = "s", e.SCRIPT = "script", e.SECTION = "section", e.SELECT = "select", e.SOURCE = "source", e.SMALL = "small", e.SPAN = "span", e.STRIKE = "strike", e.STRONG = "strong", e.STYLE = "style", e.SUB = "sub", e.SUMMARY = "summary", e.SUP = "sup", e.TABLE = "table", e.TBODY = "tbody", e.TEMPLATE = "template", e.TEXTAREA = "textarea", e.TFOOT = "tfoot", e.TD = "td", e.TH = "th", e.THEAD = "thead", e.TITLE = "title", e.TR = "tr", e.TRACK = "track", e.TT = "tt", e.U = "u", e.UL = "ul", e.SVG = "svg", e.VAR = "var", e.WBR = "wbr", e.XMP = "xmp";
})(Ee = Ee || (Ee = {}));
var I;
(function(e) {
  e[e.UNKNOWN = 0] = "UNKNOWN", e[e.A = 1] = "A", e[e.ADDRESS = 2] = "ADDRESS", e[e.ANNOTATION_XML = 3] = "ANNOTATION_XML", e[e.APPLET = 4] = "APPLET", e[e.AREA = 5] = "AREA", e[e.ARTICLE = 6] = "ARTICLE", e[e.ASIDE = 7] = "ASIDE", e[e.B = 8] = "B", e[e.BASE = 9] = "BASE", e[e.BASEFONT = 10] = "BASEFONT", e[e.BGSOUND = 11] = "BGSOUND", e[e.BIG = 12] = "BIG", e[e.BLOCKQUOTE = 13] = "BLOCKQUOTE", e[e.BODY = 14] = "BODY", e[e.BR = 15] = "BR", e[e.BUTTON = 16] = "BUTTON", e[e.CAPTION = 17] = "CAPTION", e[e.CENTER = 18] = "CENTER", e[e.CODE = 19] = "CODE", e[e.COL = 20] = "COL", e[e.COLGROUP = 21] = "COLGROUP", e[e.DD = 22] = "DD", e[e.DESC = 23] = "DESC", e[e.DETAILS = 24] = "DETAILS", e[e.DIALOG = 25] = "DIALOG", e[e.DIR = 26] = "DIR", e[e.DIV = 27] = "DIV", e[e.DL = 28] = "DL", e[e.DT = 29] = "DT", e[e.EM = 30] = "EM", e[e.EMBED = 31] = "EMBED", e[e.FIELDSET = 32] = "FIELDSET", e[e.FIGCAPTION = 33] = "FIGCAPTION", e[e.FIGURE = 34] = "FIGURE", e[e.FONT = 35] = "FONT", e[e.FOOTER = 36] = "FOOTER", e[e.FOREIGN_OBJECT = 37] = "FOREIGN_OBJECT", e[e.FORM = 38] = "FORM", e[e.FRAME = 39] = "FRAME", e[e.FRAMESET = 40] = "FRAMESET", e[e.H1 = 41] = "H1", e[e.H2 = 42] = "H2", e[e.H3 = 43] = "H3", e[e.H4 = 44] = "H4", e[e.H5 = 45] = "H5", e[e.H6 = 46] = "H6", e[e.HEAD = 47] = "HEAD", e[e.HEADER = 48] = "HEADER", e[e.HGROUP = 49] = "HGROUP", e[e.HR = 50] = "HR", e[e.HTML = 51] = "HTML", e[e.I = 52] = "I", e[e.IMG = 53] = "IMG", e[e.IMAGE = 54] = "IMAGE", e[e.INPUT = 55] = "INPUT", e[e.IFRAME = 56] = "IFRAME", e[e.KEYGEN = 57] = "KEYGEN", e[e.LABEL = 58] = "LABEL", e[e.LI = 59] = "LI", e[e.LINK = 60] = "LINK", e[e.LISTING = 61] = "LISTING", e[e.MAIN = 62] = "MAIN", e[e.MALIGNMARK = 63] = "MALIGNMARK", e[e.MARQUEE = 64] = "MARQUEE", e[e.MATH = 65] = "MATH", e[e.MENU = 66] = "MENU", e[e.META = 67] = "META", e[e.MGLYPH = 68] = "MGLYPH", e[e.MI = 69] = "MI", e[e.MO = 70] = "MO", e[e.MN = 71] = "MN", e[e.MS = 72] = "MS", e[e.MTEXT = 73] = "MTEXT", e[e.NAV = 74] = "NAV", e[e.NOBR = 75] = "NOBR", e[e.NOFRAMES = 76] = "NOFRAMES", e[e.NOEMBED = 77] = "NOEMBED", e[e.NOSCRIPT = 78] = "NOSCRIPT", e[e.OBJECT = 79] = "OBJECT", e[e.OL = 80] = "OL", e[e.OPTGROUP = 81] = "OPTGROUP", e[e.OPTION = 82] = "OPTION", e[e.P = 83] = "P", e[e.PARAM = 84] = "PARAM", e[e.PLAINTEXT = 85] = "PLAINTEXT", e[e.PRE = 86] = "PRE", e[e.RB = 87] = "RB", e[e.RP = 88] = "RP", e[e.RT = 89] = "RT", e[e.RTC = 90] = "RTC", e[e.RUBY = 91] = "RUBY", e[e.S = 92] = "S", e[e.SCRIPT = 93] = "SCRIPT", e[e.SECTION = 94] = "SECTION", e[e.SELECT = 95] = "SELECT", e[e.SOURCE = 96] = "SOURCE", e[e.SMALL = 97] = "SMALL", e[e.SPAN = 98] = "SPAN", e[e.STRIKE = 99] = "STRIKE", e[e.STRONG = 100] = "STRONG", e[e.STYLE = 101] = "STYLE", e[e.SUB = 102] = "SUB", e[e.SUMMARY = 103] = "SUMMARY", e[e.SUP = 104] = "SUP", e[e.TABLE = 105] = "TABLE", e[e.TBODY = 106] = "TBODY", e[e.TEMPLATE = 107] = "TEMPLATE", e[e.TEXTAREA = 108] = "TEXTAREA", e[e.TFOOT = 109] = "TFOOT", e[e.TD = 110] = "TD", e[e.TH = 111] = "TH", e[e.THEAD = 112] = "THEAD", e[e.TITLE = 113] = "TITLE", e[e.TR = 114] = "TR", e[e.TRACK = 115] = "TRACK", e[e.TT = 116] = "TT", e[e.U = 117] = "U", e[e.UL = 118] = "UL", e[e.SVG = 119] = "SVG", e[e.VAR = 120] = "VAR", e[e.WBR = 121] = "WBR", e[e.XMP = 122] = "XMP";
})(I = I || (I = {}));
const tZ = /* @__PURE__ */ new Map([
  [Ee.A, I.A],
  [Ee.ADDRESS, I.ADDRESS],
  [Ee.ANNOTATION_XML, I.ANNOTATION_XML],
  [Ee.APPLET, I.APPLET],
  [Ee.AREA, I.AREA],
  [Ee.ARTICLE, I.ARTICLE],
  [Ee.ASIDE, I.ASIDE],
  [Ee.B, I.B],
  [Ee.BASE, I.BASE],
  [Ee.BASEFONT, I.BASEFONT],
  [Ee.BGSOUND, I.BGSOUND],
  [Ee.BIG, I.BIG],
  [Ee.BLOCKQUOTE, I.BLOCKQUOTE],
  [Ee.BODY, I.BODY],
  [Ee.BR, I.BR],
  [Ee.BUTTON, I.BUTTON],
  [Ee.CAPTION, I.CAPTION],
  [Ee.CENTER, I.CENTER],
  [Ee.CODE, I.CODE],
  [Ee.COL, I.COL],
  [Ee.COLGROUP, I.COLGROUP],
  [Ee.DD, I.DD],
  [Ee.DESC, I.DESC],
  [Ee.DETAILS, I.DETAILS],
  [Ee.DIALOG, I.DIALOG],
  [Ee.DIR, I.DIR],
  [Ee.DIV, I.DIV],
  [Ee.DL, I.DL],
  [Ee.DT, I.DT],
  [Ee.EM, I.EM],
  [Ee.EMBED, I.EMBED],
  [Ee.FIELDSET, I.FIELDSET],
  [Ee.FIGCAPTION, I.FIGCAPTION],
  [Ee.FIGURE, I.FIGURE],
  [Ee.FONT, I.FONT],
  [Ee.FOOTER, I.FOOTER],
  [Ee.FOREIGN_OBJECT, I.FOREIGN_OBJECT],
  [Ee.FORM, I.FORM],
  [Ee.FRAME, I.FRAME],
  [Ee.FRAMESET, I.FRAMESET],
  [Ee.H1, I.H1],
  [Ee.H2, I.H2],
  [Ee.H3, I.H3],
  [Ee.H4, I.H4],
  [Ee.H5, I.H5],
  [Ee.H6, I.H6],
  [Ee.HEAD, I.HEAD],
  [Ee.HEADER, I.HEADER],
  [Ee.HGROUP, I.HGROUP],
  [Ee.HR, I.HR],
  [Ee.HTML, I.HTML],
  [Ee.I, I.I],
  [Ee.IMG, I.IMG],
  [Ee.IMAGE, I.IMAGE],
  [Ee.INPUT, I.INPUT],
  [Ee.IFRAME, I.IFRAME],
  [Ee.KEYGEN, I.KEYGEN],
  [Ee.LABEL, I.LABEL],
  [Ee.LI, I.LI],
  [Ee.LINK, I.LINK],
  [Ee.LISTING, I.LISTING],
  [Ee.MAIN, I.MAIN],
  [Ee.MALIGNMARK, I.MALIGNMARK],
  [Ee.MARQUEE, I.MARQUEE],
  [Ee.MATH, I.MATH],
  [Ee.MENU, I.MENU],
  [Ee.META, I.META],
  [Ee.MGLYPH, I.MGLYPH],
  [Ee.MI, I.MI],
  [Ee.MO, I.MO],
  [Ee.MN, I.MN],
  [Ee.MS, I.MS],
  [Ee.MTEXT, I.MTEXT],
  [Ee.NAV, I.NAV],
  [Ee.NOBR, I.NOBR],
  [Ee.NOFRAMES, I.NOFRAMES],
  [Ee.NOEMBED, I.NOEMBED],
  [Ee.NOSCRIPT, I.NOSCRIPT],
  [Ee.OBJECT, I.OBJECT],
  [Ee.OL, I.OL],
  [Ee.OPTGROUP, I.OPTGROUP],
  [Ee.OPTION, I.OPTION],
  [Ee.P, I.P],
  [Ee.PARAM, I.PARAM],
  [Ee.PLAINTEXT, I.PLAINTEXT],
  [Ee.PRE, I.PRE],
  [Ee.RB, I.RB],
  [Ee.RP, I.RP],
  [Ee.RT, I.RT],
  [Ee.RTC, I.RTC],
  [Ee.RUBY, I.RUBY],
  [Ee.S, I.S],
  [Ee.SCRIPT, I.SCRIPT],
  [Ee.SECTION, I.SECTION],
  [Ee.SELECT, I.SELECT],
  [Ee.SOURCE, I.SOURCE],
  [Ee.SMALL, I.SMALL],
  [Ee.SPAN, I.SPAN],
  [Ee.STRIKE, I.STRIKE],
  [Ee.STRONG, I.STRONG],
  [Ee.STYLE, I.STYLE],
  [Ee.SUB, I.SUB],
  [Ee.SUMMARY, I.SUMMARY],
  [Ee.SUP, I.SUP],
  [Ee.TABLE, I.TABLE],
  [Ee.TBODY, I.TBODY],
  [Ee.TEMPLATE, I.TEMPLATE],
  [Ee.TEXTAREA, I.TEXTAREA],
  [Ee.TFOOT, I.TFOOT],
  [Ee.TD, I.TD],
  [Ee.TH, I.TH],
  [Ee.THEAD, I.THEAD],
  [Ee.TITLE, I.TITLE],
  [Ee.TR, I.TR],
  [Ee.TRACK, I.TRACK],
  [Ee.TT, I.TT],
  [Ee.U, I.U],
  [Ee.UL, I.UL],
  [Ee.SVG, I.SVG],
  [Ee.VAR, I.VAR],
  [Ee.WBR, I.WBR],
  [Ee.XMP, I.XMP]
]);
function af(e) {
  var t;
  return (t = tZ.get(e)) !== null && t !== void 0 ? t : I.UNKNOWN;
}
const Ye = I, iZ = {
  [ke.HTML]: /* @__PURE__ */ new Set([
    Ye.ADDRESS,
    Ye.APPLET,
    Ye.AREA,
    Ye.ARTICLE,
    Ye.ASIDE,
    Ye.BASE,
    Ye.BASEFONT,
    Ye.BGSOUND,
    Ye.BLOCKQUOTE,
    Ye.BODY,
    Ye.BR,
    Ye.BUTTON,
    Ye.CAPTION,
    Ye.CENTER,
    Ye.COL,
    Ye.COLGROUP,
    Ye.DD,
    Ye.DETAILS,
    Ye.DIR,
    Ye.DIV,
    Ye.DL,
    Ye.DT,
    Ye.EMBED,
    Ye.FIELDSET,
    Ye.FIGCAPTION,
    Ye.FIGURE,
    Ye.FOOTER,
    Ye.FORM,
    Ye.FRAME,
    Ye.FRAMESET,
    Ye.H1,
    Ye.H2,
    Ye.H3,
    Ye.H4,
    Ye.H5,
    Ye.H6,
    Ye.HEAD,
    Ye.HEADER,
    Ye.HGROUP,
    Ye.HR,
    Ye.HTML,
    Ye.IFRAME,
    Ye.IMG,
    Ye.INPUT,
    Ye.LI,
    Ye.LINK,
    Ye.LISTING,
    Ye.MAIN,
    Ye.MARQUEE,
    Ye.MENU,
    Ye.META,
    Ye.NAV,
    Ye.NOEMBED,
    Ye.NOFRAMES,
    Ye.NOSCRIPT,
    Ye.OBJECT,
    Ye.OL,
    Ye.P,
    Ye.PARAM,
    Ye.PLAINTEXT,
    Ye.PRE,
    Ye.SCRIPT,
    Ye.SECTION,
    Ye.SELECT,
    Ye.SOURCE,
    Ye.STYLE,
    Ye.SUMMARY,
    Ye.TABLE,
    Ye.TBODY,
    Ye.TD,
    Ye.TEMPLATE,
    Ye.TEXTAREA,
    Ye.TFOOT,
    Ye.TH,
    Ye.THEAD,
    Ye.TITLE,
    Ye.TR,
    Ye.TRACK,
    Ye.UL,
    Ye.WBR,
    Ye.XMP
  ]),
  [ke.MATHML]: /* @__PURE__ */ new Set([Ye.MI, Ye.MO, Ye.MN, Ye.MS, Ye.MTEXT, Ye.ANNOTATION_XML]),
  [ke.SVG]: /* @__PURE__ */ new Set([Ye.TITLE, Ye.FOREIGN_OBJECT, Ye.DESC]),
  [ke.XLINK]: /* @__PURE__ */ new Set(),
  [ke.XML]: /* @__PURE__ */ new Set(),
  [ke.XMLNS]: /* @__PURE__ */ new Set()
};
function o5(e) {
  return e === Ye.H1 || e === Ye.H2 || e === Ye.H3 || e === Ye.H4 || e === Ye.H5 || e === Ye.H6;
}
const rZ = /* @__PURE__ */ new Set([
  Ee.STYLE,
  Ee.SCRIPT,
  Ee.XMP,
  Ee.IFRAME,
  Ee.NOEMBED,
  Ee.NOFRAMES,
  Ee.PLAINTEXT
]);
function nZ(e, t) {
  return rZ.has(e) || t && e === Ee.NOSCRIPT;
}
const oZ = /* @__PURE__ */ new Map([
  [128, 8364],
  [130, 8218],
  [131, 402],
  [132, 8222],
  [133, 8230],
  [134, 8224],
  [135, 8225],
  [136, 710],
  [137, 8240],
  [138, 352],
  [139, 8249],
  [140, 338],
  [142, 381],
  [145, 8216],
  [146, 8217],
  [147, 8220],
  [148, 8221],
  [149, 8226],
  [150, 8211],
  [151, 8212],
  [152, 732],
  [153, 8482],
  [154, 353],
  [155, 8250],
  [156, 339],
  [158, 382],
  [159, 376]
]);
var _;
(function(e) {
  e[e.DATA = 0] = "DATA", e[e.RCDATA = 1] = "RCDATA", e[e.RAWTEXT = 2] = "RAWTEXT", e[e.SCRIPT_DATA = 3] = "SCRIPT_DATA", e[e.PLAINTEXT = 4] = "PLAINTEXT", e[e.TAG_OPEN = 5] = "TAG_OPEN", e[e.END_TAG_OPEN = 6] = "END_TAG_OPEN", e[e.TAG_NAME = 7] = "TAG_NAME", e[e.RCDATA_LESS_THAN_SIGN = 8] = "RCDATA_LESS_THAN_SIGN", e[e.RCDATA_END_TAG_OPEN = 9] = "RCDATA_END_TAG_OPEN", e[e.RCDATA_END_TAG_NAME = 10] = "RCDATA_END_TAG_NAME", e[e.RAWTEXT_LESS_THAN_SIGN = 11] = "RAWTEXT_LESS_THAN_SIGN", e[e.RAWTEXT_END_TAG_OPEN = 12] = "RAWTEXT_END_TAG_OPEN", e[e.RAWTEXT_END_TAG_NAME = 13] = "RAWTEXT_END_TAG_NAME", e[e.SCRIPT_DATA_LESS_THAN_SIGN = 14] = "SCRIPT_DATA_LESS_THAN_SIGN", e[e.SCRIPT_DATA_END_TAG_OPEN = 15] = "SCRIPT_DATA_END_TAG_OPEN", e[e.SCRIPT_DATA_END_TAG_NAME = 16] = "SCRIPT_DATA_END_TAG_NAME", e[e.SCRIPT_DATA_ESCAPE_START = 17] = "SCRIPT_DATA_ESCAPE_START", e[e.SCRIPT_DATA_ESCAPE_START_DASH = 18] = "SCRIPT_DATA_ESCAPE_START_DASH", e[e.SCRIPT_DATA_ESCAPED = 19] = "SCRIPT_DATA_ESCAPED", e[e.SCRIPT_DATA_ESCAPED_DASH = 20] = "SCRIPT_DATA_ESCAPED_DASH", e[e.SCRIPT_DATA_ESCAPED_DASH_DASH = 21] = "SCRIPT_DATA_ESCAPED_DASH_DASH", e[e.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN = 22] = "SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN", e[e.SCRIPT_DATA_ESCAPED_END_TAG_OPEN = 23] = "SCRIPT_DATA_ESCAPED_END_TAG_OPEN", e[e.SCRIPT_DATA_ESCAPED_END_TAG_NAME = 24] = "SCRIPT_DATA_ESCAPED_END_TAG_NAME", e[e.SCRIPT_DATA_DOUBLE_ESCAPE_START = 25] = "SCRIPT_DATA_DOUBLE_ESCAPE_START", e[e.SCRIPT_DATA_DOUBLE_ESCAPED = 26] = "SCRIPT_DATA_DOUBLE_ESCAPED", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_DASH = 27] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH = 28] = "SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH", e[e.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN = 29] = "SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN", e[e.SCRIPT_DATA_DOUBLE_ESCAPE_END = 30] = "SCRIPT_DATA_DOUBLE_ESCAPE_END", e[e.BEFORE_ATTRIBUTE_NAME = 31] = "BEFORE_ATTRIBUTE_NAME", e[e.ATTRIBUTE_NAME = 32] = "ATTRIBUTE_NAME", e[e.AFTER_ATTRIBUTE_NAME = 33] = "AFTER_ATTRIBUTE_NAME", e[e.BEFORE_ATTRIBUTE_VALUE = 34] = "BEFORE_ATTRIBUTE_VALUE", e[e.ATTRIBUTE_VALUE_DOUBLE_QUOTED = 35] = "ATTRIBUTE_VALUE_DOUBLE_QUOTED", e[e.ATTRIBUTE_VALUE_SINGLE_QUOTED = 36] = "ATTRIBUTE_VALUE_SINGLE_QUOTED", e[e.ATTRIBUTE_VALUE_UNQUOTED = 37] = "ATTRIBUTE_VALUE_UNQUOTED", e[e.AFTER_ATTRIBUTE_VALUE_QUOTED = 38] = "AFTER_ATTRIBUTE_VALUE_QUOTED", e[e.SELF_CLOSING_START_TAG = 39] = "SELF_CLOSING_START_TAG", e[e.BOGUS_COMMENT = 40] = "BOGUS_COMMENT", e[e.MARKUP_DECLARATION_OPEN = 41] = "MARKUP_DECLARATION_OPEN", e[e.COMMENT_START = 42] = "COMMENT_START", e[e.COMMENT_START_DASH = 43] = "COMMENT_START_DASH", e[e.COMMENT = 44] = "COMMENT", e[e.COMMENT_LESS_THAN_SIGN = 45] = "COMMENT_LESS_THAN_SIGN", e[e.COMMENT_LESS_THAN_SIGN_BANG = 46] = "COMMENT_LESS_THAN_SIGN_BANG", e[e.COMMENT_LESS_THAN_SIGN_BANG_DASH = 47] = "COMMENT_LESS_THAN_SIGN_BANG_DASH", e[e.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH = 48] = "COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH", e[e.COMMENT_END_DASH = 49] = "COMMENT_END_DASH", e[e.COMMENT_END = 50] = "COMMENT_END", e[e.COMMENT_END_BANG = 51] = "COMMENT_END_BANG", e[e.DOCTYPE = 52] = "DOCTYPE", e[e.BEFORE_DOCTYPE_NAME = 53] = "BEFORE_DOCTYPE_NAME", e[e.DOCTYPE_NAME = 54] = "DOCTYPE_NAME", e[e.AFTER_DOCTYPE_NAME = 55] = "AFTER_DOCTYPE_NAME", e[e.AFTER_DOCTYPE_PUBLIC_KEYWORD = 56] = "AFTER_DOCTYPE_PUBLIC_KEYWORD", e[e.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER = 57] = "BEFORE_DOCTYPE_PUBLIC_IDENTIFIER", e[e.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED = 58] = "DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED", e[e.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED = 59] = "DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED", e[e.AFTER_DOCTYPE_PUBLIC_IDENTIFIER = 60] = "AFTER_DOCTYPE_PUBLIC_IDENTIFIER", e[e.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS = 61] = "BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS", e[e.AFTER_DOCTYPE_SYSTEM_KEYWORD = 62] = "AFTER_DOCTYPE_SYSTEM_KEYWORD", e[e.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER = 63] = "BEFORE_DOCTYPE_SYSTEM_IDENTIFIER", e[e.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED = 64] = "DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED", e[e.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED = 65] = "DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED", e[e.AFTER_DOCTYPE_SYSTEM_IDENTIFIER = 66] = "AFTER_DOCTYPE_SYSTEM_IDENTIFIER", e[e.BOGUS_DOCTYPE = 67] = "BOGUS_DOCTYPE", e[e.CDATA_SECTION = 68] = "CDATA_SECTION", e[e.CDATA_SECTION_BRACKET = 69] = "CDATA_SECTION_BRACKET", e[e.CDATA_SECTION_END = 70] = "CDATA_SECTION_END", e[e.CHARACTER_REFERENCE = 71] = "CHARACTER_REFERENCE", e[e.NAMED_CHARACTER_REFERENCE = 72] = "NAMED_CHARACTER_REFERENCE", e[e.AMBIGUOUS_AMPERSAND = 73] = "AMBIGUOUS_AMPERSAND", e[e.NUMERIC_CHARACTER_REFERENCE = 74] = "NUMERIC_CHARACTER_REFERENCE", e[e.HEXADEMICAL_CHARACTER_REFERENCE_START = 75] = "HEXADEMICAL_CHARACTER_REFERENCE_START", e[e.HEXADEMICAL_CHARACTER_REFERENCE = 76] = "HEXADEMICAL_CHARACTER_REFERENCE", e[e.DECIMAL_CHARACTER_REFERENCE = 77] = "DECIMAL_CHARACTER_REFERENCE", e[e.NUMERIC_CHARACTER_REFERENCE_END = 78] = "NUMERIC_CHARACTER_REFERENCE_END";
})(_ || (_ = {}));
const Wn = {
  DATA: _.DATA,
  RCDATA: _.RCDATA,
  RAWTEXT: _.RAWTEXT,
  SCRIPT_DATA: _.SCRIPT_DATA,
  PLAINTEXT: _.PLAINTEXT,
  CDATA_SECTION: _.CDATA_SECTION
};
function um(e) {
  return e >= J.DIGIT_0 && e <= J.DIGIT_9;
}
function Hd(e) {
  return e >= J.LATIN_CAPITAL_A && e <= J.LATIN_CAPITAL_Z;
}
function sZ(e) {
  return e >= J.LATIN_SMALL_A && e <= J.LATIN_SMALL_Z;
}
function dl(e) {
  return sZ(e) || Hd(e);
}
function yb(e) {
  return dl(e) || um(e);
}
function s5(e) {
  return e >= J.LATIN_CAPITAL_A && e <= J.LATIN_CAPITAL_F;
}
function a5(e) {
  return e >= J.LATIN_SMALL_A && e <= J.LATIN_SMALL_F;
}
function aZ(e) {
  return um(e) || s5(e) || a5(e);
}
function Wh(e) {
  return e + 32;
}
function l5(e) {
  return e === J.SPACE || e === J.LINE_FEED || e === J.TABULATION || e === J.FORM_FEED;
}
function lZ(e) {
  return e === J.EQUALS_SIGN || yb(e);
}
function _k(e) {
  return l5(e) || e === J.SOLIDUS || e === J.GREATER_THAN_SIGN;
}
class cZ {
  constructor(t, i) {
    this.options = t, this.handler = i, this.paused = !1, this.inLoop = !1, this.inForeignNode = !1, this.lastStartTagName = "", this.active = !1, this.state = _.DATA, this.returnState = _.DATA, this.charRefCode = -1, this.consumedAfterSnapshot = -1, this.currentCharacterToken = null, this.currentToken = null, this.currentAttr = { name: "", value: "" }, this.preprocessor = new W9(i), this.currentLocation = this.getCurrentLocation(-1);
  }
  //Errors
  _err(t) {
    var i, r;
    (r = (i = this.handler).onParseError) === null || r === void 0 || r.call(i, this.preprocessor.getError(t));
  }
  // NOTE: `offset` may never run across line boundaries.
  getCurrentLocation(t) {
    return this.options.sourceCodeLocationInfo ? {
      startLine: this.preprocessor.line,
      startCol: this.preprocessor.col - t,
      startOffset: this.preprocessor.offset - t,
      endLine: -1,
      endCol: -1,
      endOffset: -1
    } : null;
  }
  _runParsingLoop() {
    if (!this.inLoop) {
      for (this.inLoop = !0; this.active && !this.paused; ) {
        this.consumedAfterSnapshot = 0;
        const t = this._consume();
        this._ensureHibernation() || this._callState(t);
      }
      this.inLoop = !1;
    }
  }
  //API
  pause() {
    this.paused = !0;
  }
  resume(t) {
    if (!this.paused)
      throw new Error("Parser was already resumed");
    this.paused = !1, !this.inLoop && (this._runParsingLoop(), this.paused || t == null || t());
  }
  write(t, i, r) {
    this.active = !0, this.preprocessor.write(t, i), this._runParsingLoop(), this.paused || r == null || r();
  }
  insertHtmlAtCurrentPos(t) {
    this.active = !0, this.preprocessor.insertHtmlAtCurrentPos(t), this._runParsingLoop();
  }
  //Hibernation
  _ensureHibernation() {
    return this.preprocessor.endOfChunkHit ? (this._unconsume(this.consumedAfterSnapshot), this.active = !1, !0) : !1;
  }
  //Consumption
  _consume() {
    return this.consumedAfterSnapshot++, this.preprocessor.advance();
  }
  _unconsume(t) {
    this.consumedAfterSnapshot -= t, this.preprocessor.retreat(t);
  }
  _reconsumeInState(t, i) {
    this.state = t, this._callState(i);
  }
  _advanceBy(t) {
    this.consumedAfterSnapshot += t;
    for (let i = 0; i < t; i++)
      this.preprocessor.advance();
  }
  _consumeSequenceIfMatch(t, i) {
    return this.preprocessor.startsWith(t, i) ? (this._advanceBy(t.length - 1), !0) : !1;
  }
  //Token creation
  _createStartTagToken() {
    this.currentToken = {
      type: Xt.START_TAG,
      tagName: "",
      tagID: I.UNKNOWN,
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: [],
      location: this.getCurrentLocation(1)
    };
  }
  _createEndTagToken() {
    this.currentToken = {
      type: Xt.END_TAG,
      tagName: "",
      tagID: I.UNKNOWN,
      selfClosing: !1,
      ackSelfClosing: !1,
      attrs: [],
      location: this.getCurrentLocation(2)
    };
  }
  _createCommentToken(t) {
    this.currentToken = {
      type: Xt.COMMENT,
      data: "",
      location: this.getCurrentLocation(t)
    };
  }
  _createDoctypeToken(t) {
    this.currentToken = {
      type: Xt.DOCTYPE,
      name: t,
      forceQuirks: !1,
      publicId: null,
      systemId: null,
      location: this.currentLocation
    };
  }
  _createCharacterToken(t, i) {
    this.currentCharacterToken = {
      type: t,
      chars: i,
      location: this.currentLocation
    };
  }
  //Tag attributes
  _createAttr(t) {
    this.currentAttr = {
      name: t,
      value: ""
    }, this.currentLocation = this.getCurrentLocation(0);
  }
  _leaveAttrName() {
    var t, i;
    const r = this.currentToken;
    if (i5(r, this.currentAttr.name) === null) {
      if (r.attrs.push(this.currentAttr), r.location && this.currentLocation) {
        const n = (t = (i = r.location).attrs) !== null && t !== void 0 ? t : i.attrs = /* @__PURE__ */ Object.create(null);
        n[this.currentAttr.name] = this.currentLocation, this._leaveAttrValue();
      }
    } else
      this._err(Se.duplicateAttribute);
  }
  _leaveAttrValue() {
    this.currentLocation && (this.currentLocation.endLine = this.preprocessor.line, this.currentLocation.endCol = this.preprocessor.col, this.currentLocation.endOffset = this.preprocessor.offset);
  }
  //Token emission
  prepareToken(t) {
    this._emitCurrentCharacterToken(t.location), this.currentToken = null, t.location && (t.location.endLine = this.preprocessor.line, t.location.endCol = this.preprocessor.col + 1, t.location.endOffset = this.preprocessor.offset + 1), this.currentLocation = this.getCurrentLocation(-1);
  }
  emitCurrentTagToken() {
    const t = this.currentToken;
    this.prepareToken(t), t.tagID = af(t.tagName), t.type === Xt.START_TAG ? (this.lastStartTagName = t.tagName, this.handler.onStartTag(t)) : (t.attrs.length > 0 && this._err(Se.endTagWithAttributes), t.selfClosing && this._err(Se.endTagWithTrailingSolidus), this.handler.onEndTag(t)), this.preprocessor.dropParsedChunk();
  }
  emitCurrentComment(t) {
    this.prepareToken(t), this.handler.onComment(t), this.preprocessor.dropParsedChunk();
  }
  emitCurrentDoctype(t) {
    this.prepareToken(t), this.handler.onDoctype(t), this.preprocessor.dropParsedChunk();
  }
  _emitCurrentCharacterToken(t) {
    if (this.currentCharacterToken) {
      switch (t && this.currentCharacterToken.location && (this.currentCharacterToken.location.endLine = t.startLine, this.currentCharacterToken.location.endCol = t.startCol, this.currentCharacterToken.location.endOffset = t.startOffset), this.currentCharacterToken.type) {
        case Xt.CHARACTER: {
          this.handler.onCharacter(this.currentCharacterToken);
          break;
        }
        case Xt.NULL_CHARACTER: {
          this.handler.onNullCharacter(this.currentCharacterToken);
          break;
        }
        case Xt.WHITESPACE_CHARACTER: {
          this.handler.onWhitespaceCharacter(this.currentCharacterToken);
          break;
        }
      }
      this.currentCharacterToken = null;
    }
  }
  _emitEOFToken() {
    const t = this.getCurrentLocation(0);
    t && (t.endLine = t.startLine, t.endCol = t.startCol, t.endOffset = t.startOffset), this._emitCurrentCharacterToken(t), this.handler.onEof({ type: Xt.EOF, location: t }), this.active = !1;
  }
  //Characters emission
  //OPTIMIZATION: specification uses only one type of character tokens (one token per character).
  //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
  //If we have a sequence of characters that belong to the same group, the parser can process it
  //as a single solid character token.
  //So, there are 3 types of character tokens in parse5:
  //1)TokenType.NULL_CHARACTER - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
  //2)TokenType.WHITESPACE_CHARACTER - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
  //3)TokenType.CHARACTER - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
  _appendCharToCurrentCharacterToken(t, i) {
    if (this.currentCharacterToken)
      if (this.currentCharacterToken.type !== t)
        this.currentLocation = this.getCurrentLocation(0), this._emitCurrentCharacterToken(this.currentLocation), this.preprocessor.dropParsedChunk();
      else {
        this.currentCharacterToken.chars += i;
        return;
      }
    this._createCharacterToken(t, i);
  }
  _emitCodePoint(t) {
    const i = l5(t) ? Xt.WHITESPACE_CHARACTER : t === J.NULL ? Xt.NULL_CHARACTER : Xt.CHARACTER;
    this._appendCharToCurrentCharacterToken(i, String.fromCodePoint(t));
  }
  //NOTE: used when we emit characters explicitly.
  //This is always for non-whitespace and non-null characters, which allows us to avoid additional checks.
  _emitChars(t) {
    this._appendCharToCurrentCharacterToken(Xt.CHARACTER, t);
  }
  // Character reference helpers
  _matchNamedCharacterReference(t) {
    let i = null, r = 0, n = !1;
    for (let o = 0, s = ul[0]; o >= 0 && (o = n5(ul, s, o + 1, t), !(o < 0)); t = this._consume()) {
      r += 1, s = ul[o];
      const a = s & Os.VALUE_LENGTH;
      if (a) {
        const l = (a >> 14) - 1;
        if (t !== J.SEMICOLON && this._isCharacterReferenceInAttribute() && lZ(this.preprocessor.peek(1)) ? (i = [J.AMPERSAND], o += l) : (i = l === 0 ? [ul[o] & ~Os.VALUE_LENGTH] : l === 1 ? [ul[++o]] : [ul[++o], ul[++o]], r = 0, n = t !== J.SEMICOLON), l === 0) {
          this._consume();
          break;
        }
      }
    }
    return this._unconsume(r), n && !this.preprocessor.endOfChunkHit && this._err(Se.missingSemicolonAfterCharacterReference), this._unconsume(1), i;
  }
  _isCharacterReferenceInAttribute() {
    return this.returnState === _.ATTRIBUTE_VALUE_DOUBLE_QUOTED || this.returnState === _.ATTRIBUTE_VALUE_SINGLE_QUOTED || this.returnState === _.ATTRIBUTE_VALUE_UNQUOTED;
  }
  _flushCodePointConsumedAsCharacterReference(t) {
    this._isCharacterReferenceInAttribute() ? this.currentAttr.value += String.fromCodePoint(t) : this._emitCodePoint(t);
  }
  // Calling states this way turns out to be much faster than any other approach.
  _callState(t) {
    switch (this.state) {
      case _.DATA: {
        this._stateData(t);
        break;
      }
      case _.RCDATA: {
        this._stateRcdata(t);
        break;
      }
      case _.RAWTEXT: {
        this._stateRawtext(t);
        break;
      }
      case _.SCRIPT_DATA: {
        this._stateScriptData(t);
        break;
      }
      case _.PLAINTEXT: {
        this._statePlaintext(t);
        break;
      }
      case _.TAG_OPEN: {
        this._stateTagOpen(t);
        break;
      }
      case _.END_TAG_OPEN: {
        this._stateEndTagOpen(t);
        break;
      }
      case _.TAG_NAME: {
        this._stateTagName(t);
        break;
      }
      case _.RCDATA_LESS_THAN_SIGN: {
        this._stateRcdataLessThanSign(t);
        break;
      }
      case _.RCDATA_END_TAG_OPEN: {
        this._stateRcdataEndTagOpen(t);
        break;
      }
      case _.RCDATA_END_TAG_NAME: {
        this._stateRcdataEndTagName(t);
        break;
      }
      case _.RAWTEXT_LESS_THAN_SIGN: {
        this._stateRawtextLessThanSign(t);
        break;
      }
      case _.RAWTEXT_END_TAG_OPEN: {
        this._stateRawtextEndTagOpen(t);
        break;
      }
      case _.RAWTEXT_END_TAG_NAME: {
        this._stateRawtextEndTagName(t);
        break;
      }
      case _.SCRIPT_DATA_LESS_THAN_SIGN: {
        this._stateScriptDataLessThanSign(t);
        break;
      }
      case _.SCRIPT_DATA_END_TAG_OPEN: {
        this._stateScriptDataEndTagOpen(t);
        break;
      }
      case _.SCRIPT_DATA_END_TAG_NAME: {
        this._stateScriptDataEndTagName(t);
        break;
      }
      case _.SCRIPT_DATA_ESCAPE_START: {
        this._stateScriptDataEscapeStart(t);
        break;
      }
      case _.SCRIPT_DATA_ESCAPE_START_DASH: {
        this._stateScriptDataEscapeStartDash(t);
        break;
      }
      case _.SCRIPT_DATA_ESCAPED: {
        this._stateScriptDataEscaped(t);
        break;
      }
      case _.SCRIPT_DATA_ESCAPED_DASH: {
        this._stateScriptDataEscapedDash(t);
        break;
      }
      case _.SCRIPT_DATA_ESCAPED_DASH_DASH: {
        this._stateScriptDataEscapedDashDash(t);
        break;
      }
      case _.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataEscapedLessThanSign(t);
        break;
      }
      case _.SCRIPT_DATA_ESCAPED_END_TAG_OPEN: {
        this._stateScriptDataEscapedEndTagOpen(t);
        break;
      }
      case _.SCRIPT_DATA_ESCAPED_END_TAG_NAME: {
        this._stateScriptDataEscapedEndTagName(t);
        break;
      }
      case _.SCRIPT_DATA_DOUBLE_ESCAPE_START: {
        this._stateScriptDataDoubleEscapeStart(t);
        break;
      }
      case _.SCRIPT_DATA_DOUBLE_ESCAPED: {
        this._stateScriptDataDoubleEscaped(t);
        break;
      }
      case _.SCRIPT_DATA_DOUBLE_ESCAPED_DASH: {
        this._stateScriptDataDoubleEscapedDash(t);
        break;
      }
      case _.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH: {
        this._stateScriptDataDoubleEscapedDashDash(t);
        break;
      }
      case _.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN: {
        this._stateScriptDataDoubleEscapedLessThanSign(t);
        break;
      }
      case _.SCRIPT_DATA_DOUBLE_ESCAPE_END: {
        this._stateScriptDataDoubleEscapeEnd(t);
        break;
      }
      case _.BEFORE_ATTRIBUTE_NAME: {
        this._stateBeforeAttributeName(t);
        break;
      }
      case _.ATTRIBUTE_NAME: {
        this._stateAttributeName(t);
        break;
      }
      case _.AFTER_ATTRIBUTE_NAME: {
        this._stateAfterAttributeName(t);
        break;
      }
      case _.BEFORE_ATTRIBUTE_VALUE: {
        this._stateBeforeAttributeValue(t);
        break;
      }
      case _.ATTRIBUTE_VALUE_DOUBLE_QUOTED: {
        this._stateAttributeValueDoubleQuoted(t);
        break;
      }
      case _.ATTRIBUTE_VALUE_SINGLE_QUOTED: {
        this._stateAttributeValueSingleQuoted(t);
        break;
      }
      case _.ATTRIBUTE_VALUE_UNQUOTED: {
        this._stateAttributeValueUnquoted(t);
        break;
      }
      case _.AFTER_ATTRIBUTE_VALUE_QUOTED: {
        this._stateAfterAttributeValueQuoted(t);
        break;
      }
      case _.SELF_CLOSING_START_TAG: {
        this._stateSelfClosingStartTag(t);
        break;
      }
      case _.BOGUS_COMMENT: {
        this._stateBogusComment(t);
        break;
      }
      case _.MARKUP_DECLARATION_OPEN: {
        this._stateMarkupDeclarationOpen(t);
        break;
      }
      case _.COMMENT_START: {
        this._stateCommentStart(t);
        break;
      }
      case _.COMMENT_START_DASH: {
        this._stateCommentStartDash(t);
        break;
      }
      case _.COMMENT: {
        this._stateComment(t);
        break;
      }
      case _.COMMENT_LESS_THAN_SIGN: {
        this._stateCommentLessThanSign(t);
        break;
      }
      case _.COMMENT_LESS_THAN_SIGN_BANG: {
        this._stateCommentLessThanSignBang(t);
        break;
      }
      case _.COMMENT_LESS_THAN_SIGN_BANG_DASH: {
        this._stateCommentLessThanSignBangDash(t);
        break;
      }
      case _.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH: {
        this._stateCommentLessThanSignBangDashDash(t);
        break;
      }
      case _.COMMENT_END_DASH: {
        this._stateCommentEndDash(t);
        break;
      }
      case _.COMMENT_END: {
        this._stateCommentEnd(t);
        break;
      }
      case _.COMMENT_END_BANG: {
        this._stateCommentEndBang(t);
        break;
      }
      case _.DOCTYPE: {
        this._stateDoctype(t);
        break;
      }
      case _.BEFORE_DOCTYPE_NAME: {
        this._stateBeforeDoctypeName(t);
        break;
      }
      case _.DOCTYPE_NAME: {
        this._stateDoctypeName(t);
        break;
      }
      case _.AFTER_DOCTYPE_NAME: {
        this._stateAfterDoctypeName(t);
        break;
      }
      case _.AFTER_DOCTYPE_PUBLIC_KEYWORD: {
        this._stateAfterDoctypePublicKeyword(t);
        break;
      }
      case _.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateBeforeDoctypePublicIdentifier(t);
        break;
      }
      case _.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypePublicIdentifierDoubleQuoted(t);
        break;
      }
      case _.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypePublicIdentifierSingleQuoted(t);
        break;
      }
      case _.AFTER_DOCTYPE_PUBLIC_IDENTIFIER: {
        this._stateAfterDoctypePublicIdentifier(t);
        break;
      }
      case _.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS: {
        this._stateBetweenDoctypePublicAndSystemIdentifiers(t);
        break;
      }
      case _.AFTER_DOCTYPE_SYSTEM_KEYWORD: {
        this._stateAfterDoctypeSystemKeyword(t);
        break;
      }
      case _.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateBeforeDoctypeSystemIdentifier(t);
        break;
      }
      case _.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED: {
        this._stateDoctypeSystemIdentifierDoubleQuoted(t);
        break;
      }
      case _.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED: {
        this._stateDoctypeSystemIdentifierSingleQuoted(t);
        break;
      }
      case _.AFTER_DOCTYPE_SYSTEM_IDENTIFIER: {
        this._stateAfterDoctypeSystemIdentifier(t);
        break;
      }
      case _.BOGUS_DOCTYPE: {
        this._stateBogusDoctype(t);
        break;
      }
      case _.CDATA_SECTION: {
        this._stateCdataSection(t);
        break;
      }
      case _.CDATA_SECTION_BRACKET: {
        this._stateCdataSectionBracket(t);
        break;
      }
      case _.CDATA_SECTION_END: {
        this._stateCdataSectionEnd(t);
        break;
      }
      case _.CHARACTER_REFERENCE: {
        this._stateCharacterReference(t);
        break;
      }
      case _.NAMED_CHARACTER_REFERENCE: {
        this._stateNamedCharacterReference(t);
        break;
      }
      case _.AMBIGUOUS_AMPERSAND: {
        this._stateAmbiguousAmpersand(t);
        break;
      }
      case _.NUMERIC_CHARACTER_REFERENCE: {
        this._stateNumericCharacterReference(t);
        break;
      }
      case _.HEXADEMICAL_CHARACTER_REFERENCE_START: {
        this._stateHexademicalCharacterReferenceStart(t);
        break;
      }
      case _.HEXADEMICAL_CHARACTER_REFERENCE: {
        this._stateHexademicalCharacterReference(t);
        break;
      }
      case _.DECIMAL_CHARACTER_REFERENCE: {
        this._stateDecimalCharacterReference(t);
        break;
      }
      case _.NUMERIC_CHARACTER_REFERENCE_END: {
        this._stateNumericCharacterReferenceEnd(t);
        break;
      }
      default:
        throw new Error("Unknown state");
    }
  }
  // State machine
  // Data state
  //------------------------------------------------------------------
  _stateData(t) {
    switch (t) {
      case J.LESS_THAN_SIGN: {
        this.state = _.TAG_OPEN;
        break;
      }
      case J.AMPERSAND: {
        this.returnState = _.DATA, this.state = _.CHARACTER_REFERENCE;
        break;
      }
      case J.NULL: {
        this._err(Se.unexpectedNullCharacter), this._emitCodePoint(t);
        break;
      }
      case J.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  //  RCDATA state
  //------------------------------------------------------------------
  _stateRcdata(t) {
    switch (t) {
      case J.AMPERSAND: {
        this.returnState = _.RCDATA, this.state = _.CHARACTER_REFERENCE;
        break;
      }
      case J.LESS_THAN_SIGN: {
        this.state = _.RCDATA_LESS_THAN_SIGN;
        break;
      }
      case J.NULL: {
        this._err(Se.unexpectedNullCharacter), this._emitChars(Oi);
        break;
      }
      case J.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // RAWTEXT state
  //------------------------------------------------------------------
  _stateRawtext(t) {
    switch (t) {
      case J.LESS_THAN_SIGN: {
        this.state = _.RAWTEXT_LESS_THAN_SIGN;
        break;
      }
      case J.NULL: {
        this._err(Se.unexpectedNullCharacter), this._emitChars(Oi);
        break;
      }
      case J.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Script data state
  //------------------------------------------------------------------
  _stateScriptData(t) {
    switch (t) {
      case J.LESS_THAN_SIGN: {
        this.state = _.SCRIPT_DATA_LESS_THAN_SIGN;
        break;
      }
      case J.NULL: {
        this._err(Se.unexpectedNullCharacter), this._emitChars(Oi);
        break;
      }
      case J.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // PLAINTEXT state
  //------------------------------------------------------------------
  _statePlaintext(t) {
    switch (t) {
      case J.NULL: {
        this._err(Se.unexpectedNullCharacter), this._emitChars(Oi);
        break;
      }
      case J.EOF: {
        this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Tag open state
  //------------------------------------------------------------------
  _stateTagOpen(t) {
    if (dl(t))
      this._createStartTagToken(), this.state = _.TAG_NAME, this._stateTagName(t);
    else
      switch (t) {
        case J.EXCLAMATION_MARK: {
          this.state = _.MARKUP_DECLARATION_OPEN;
          break;
        }
        case J.SOLIDUS: {
          this.state = _.END_TAG_OPEN;
          break;
        }
        case J.QUESTION_MARK: {
          this._err(Se.unexpectedQuestionMarkInsteadOfTagName), this._createCommentToken(1), this.state = _.BOGUS_COMMENT, this._stateBogusComment(t);
          break;
        }
        case J.EOF: {
          this._err(Se.eofBeforeTagName), this._emitChars("<"), this._emitEOFToken();
          break;
        }
        default:
          this._err(Se.invalidFirstCharacterOfTagName), this._emitChars("<"), this.state = _.DATA, this._stateData(t);
      }
  }
  // End tag open state
  //------------------------------------------------------------------
  _stateEndTagOpen(t) {
    if (dl(t))
      this._createEndTagToken(), this.state = _.TAG_NAME, this._stateTagName(t);
    else
      switch (t) {
        case J.GREATER_THAN_SIGN: {
          this._err(Se.missingEndTagName), this.state = _.DATA;
          break;
        }
        case J.EOF: {
          this._err(Se.eofBeforeTagName), this._emitChars("</"), this._emitEOFToken();
          break;
        }
        default:
          this._err(Se.invalidFirstCharacterOfTagName), this._createCommentToken(2), this.state = _.BOGUS_COMMENT, this._stateBogusComment(t);
      }
  }
  // Tag name state
  //------------------------------------------------------------------
  _stateTagName(t) {
    const i = this.currentToken;
    switch (t) {
      case J.SPACE:
      case J.LINE_FEED:
      case J.TABULATION:
      case J.FORM_FEED: {
        this.state = _.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case J.SOLIDUS: {
        this.state = _.SELF_CLOSING_START_TAG;
        break;
      }
      case J.GREATER_THAN_SIGN: {
        this.state = _.DATA, this.emitCurrentTagToken();
        break;
      }
      case J.NULL: {
        this._err(Se.unexpectedNullCharacter), i.tagName += Oi;
        break;
      }
      case J.EOF: {
        this._err(Se.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        i.tagName += String.fromCodePoint(Hd(t) ? Wh(t) : t);
    }
  }
  // RCDATA less-than sign state
  //------------------------------------------------------------------
  _stateRcdataLessThanSign(t) {
    t === J.SOLIDUS ? this.state = _.RCDATA_END_TAG_OPEN : (this._emitChars("<"), this.state = _.RCDATA, this._stateRcdata(t));
  }
  // RCDATA end tag open state
  //------------------------------------------------------------------
  _stateRcdataEndTagOpen(t) {
    dl(t) ? (this.state = _.RCDATA_END_TAG_NAME, this._stateRcdataEndTagName(t)) : (this._emitChars("</"), this.state = _.RCDATA, this._stateRcdata(t));
  }
  handleSpecialEndTag(t) {
    if (!this.preprocessor.startsWith(this.lastStartTagName, !1))
      return !this._ensureHibernation();
    this._createEndTagToken();
    const i = this.currentToken;
    switch (i.tagName = this.lastStartTagName, this.preprocessor.peek(this.lastStartTagName.length)) {
      case J.SPACE:
      case J.LINE_FEED:
      case J.TABULATION:
      case J.FORM_FEED:
        return this._advanceBy(this.lastStartTagName.length), this.state = _.BEFORE_ATTRIBUTE_NAME, !1;
      case J.SOLIDUS:
        return this._advanceBy(this.lastStartTagName.length), this.state = _.SELF_CLOSING_START_TAG, !1;
      case J.GREATER_THAN_SIGN:
        return this._advanceBy(this.lastStartTagName.length), this.emitCurrentTagToken(), this.state = _.DATA, !1;
      default:
        return !this._ensureHibernation();
    }
  }
  // RCDATA end tag name state
  //------------------------------------------------------------------
  _stateRcdataEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = _.RCDATA, this._stateRcdata(t));
  }
  // RAWTEXT less-than sign state
  //------------------------------------------------------------------
  _stateRawtextLessThanSign(t) {
    t === J.SOLIDUS ? this.state = _.RAWTEXT_END_TAG_OPEN : (this._emitChars("<"), this.state = _.RAWTEXT, this._stateRawtext(t));
  }
  // RAWTEXT end tag open state
  //------------------------------------------------------------------
  _stateRawtextEndTagOpen(t) {
    dl(t) ? (this.state = _.RAWTEXT_END_TAG_NAME, this._stateRawtextEndTagName(t)) : (this._emitChars("</"), this.state = _.RAWTEXT, this._stateRawtext(t));
  }
  // RAWTEXT end tag name state
  //------------------------------------------------------------------
  _stateRawtextEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = _.RAWTEXT, this._stateRawtext(t));
  }
  // Script data less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataLessThanSign(t) {
    switch (t) {
      case J.SOLIDUS: {
        this.state = _.SCRIPT_DATA_END_TAG_OPEN;
        break;
      }
      case J.EXCLAMATION_MARK: {
        this.state = _.SCRIPT_DATA_ESCAPE_START, this._emitChars("<!");
        break;
      }
      default:
        this._emitChars("<"), this.state = _.SCRIPT_DATA, this._stateScriptData(t);
    }
  }
  // Script data end tag open state
  //------------------------------------------------------------------
  _stateScriptDataEndTagOpen(t) {
    dl(t) ? (this.state = _.SCRIPT_DATA_END_TAG_NAME, this._stateScriptDataEndTagName(t)) : (this._emitChars("</"), this.state = _.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data end tag name state
  //------------------------------------------------------------------
  _stateScriptDataEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = _.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data escape start state
  //------------------------------------------------------------------
  _stateScriptDataEscapeStart(t) {
    t === J.HYPHEN_MINUS ? (this.state = _.SCRIPT_DATA_ESCAPE_START_DASH, this._emitChars("-")) : (this.state = _.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data escape start dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapeStartDash(t) {
    t === J.HYPHEN_MINUS ? (this.state = _.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-")) : (this.state = _.SCRIPT_DATA, this._stateScriptData(t));
  }
  // Script data escaped state
  //------------------------------------------------------------------
  _stateScriptDataEscaped(t) {
    switch (t) {
      case J.HYPHEN_MINUS: {
        this.state = _.SCRIPT_DATA_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case J.LESS_THAN_SIGN: {
        this.state = _.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case J.NULL: {
        this._err(Se.unexpectedNullCharacter), this._emitChars(Oi);
        break;
      }
      case J.EOF: {
        this._err(Se.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Script data escaped dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapedDash(t) {
    switch (t) {
      case J.HYPHEN_MINUS: {
        this.state = _.SCRIPT_DATA_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case J.LESS_THAN_SIGN: {
        this.state = _.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case J.NULL: {
        this._err(Se.unexpectedNullCharacter), this.state = _.SCRIPT_DATA_ESCAPED, this._emitChars(Oi);
        break;
      }
      case J.EOF: {
        this._err(Se.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = _.SCRIPT_DATA_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data escaped dash dash state
  //------------------------------------------------------------------
  _stateScriptDataEscapedDashDash(t) {
    switch (t) {
      case J.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case J.LESS_THAN_SIGN: {
        this.state = _.SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN;
        break;
      }
      case J.GREATER_THAN_SIGN: {
        this.state = _.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case J.NULL: {
        this._err(Se.unexpectedNullCharacter), this.state = _.SCRIPT_DATA_ESCAPED, this._emitChars(Oi);
        break;
      }
      case J.EOF: {
        this._err(Se.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = _.SCRIPT_DATA_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data escaped less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataEscapedLessThanSign(t) {
    t === J.SOLIDUS ? this.state = _.SCRIPT_DATA_ESCAPED_END_TAG_OPEN : dl(t) ? (this._emitChars("<"), this.state = _.SCRIPT_DATA_DOUBLE_ESCAPE_START, this._stateScriptDataDoubleEscapeStart(t)) : (this._emitChars("<"), this.state = _.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data escaped end tag open state
  //------------------------------------------------------------------
  _stateScriptDataEscapedEndTagOpen(t) {
    dl(t) ? (this.state = _.SCRIPT_DATA_ESCAPED_END_TAG_NAME, this._stateScriptDataEscapedEndTagName(t)) : (this._emitChars("</"), this.state = _.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data escaped end tag name state
  //------------------------------------------------------------------
  _stateScriptDataEscapedEndTagName(t) {
    this.handleSpecialEndTag(t) && (this._emitChars("</"), this.state = _.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data double escape start state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapeStart(t) {
    if (this.preprocessor.startsWith(On.SCRIPT, !1) && _k(this.preprocessor.peek(On.SCRIPT.length))) {
      this._emitCodePoint(t);
      for (let i = 0; i < On.SCRIPT.length; i++)
        this._emitCodePoint(this._consume());
      this.state = _.SCRIPT_DATA_DOUBLE_ESCAPED;
    } else
      this._ensureHibernation() || (this.state = _.SCRIPT_DATA_ESCAPED, this._stateScriptDataEscaped(t));
  }
  // Script data double escaped state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscaped(t) {
    switch (t) {
      case J.HYPHEN_MINUS: {
        this.state = _.SCRIPT_DATA_DOUBLE_ESCAPED_DASH, this._emitChars("-");
        break;
      }
      case J.LESS_THAN_SIGN: {
        this.state = _.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case J.NULL: {
        this._err(Se.unexpectedNullCharacter), this._emitChars(Oi);
        break;
      }
      case J.EOF: {
        this._err(Se.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // Script data double escaped dash state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedDash(t) {
    switch (t) {
      case J.HYPHEN_MINUS: {
        this.state = _.SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH, this._emitChars("-");
        break;
      }
      case J.LESS_THAN_SIGN: {
        this.state = _.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case J.NULL: {
        this._err(Se.unexpectedNullCharacter), this.state = _.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(Oi);
        break;
      }
      case J.EOF: {
        this._err(Se.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = _.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data double escaped dash dash state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedDashDash(t) {
    switch (t) {
      case J.HYPHEN_MINUS: {
        this._emitChars("-");
        break;
      }
      case J.LESS_THAN_SIGN: {
        this.state = _.SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN, this._emitChars("<");
        break;
      }
      case J.GREATER_THAN_SIGN: {
        this.state = _.SCRIPT_DATA, this._emitChars(">");
        break;
      }
      case J.NULL: {
        this._err(Se.unexpectedNullCharacter), this.state = _.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitChars(Oi);
        break;
      }
      case J.EOF: {
        this._err(Se.eofInScriptHtmlCommentLikeText), this._emitEOFToken();
        break;
      }
      default:
        this.state = _.SCRIPT_DATA_DOUBLE_ESCAPED, this._emitCodePoint(t);
    }
  }
  // Script data double escaped less-than sign state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapedLessThanSign(t) {
    t === J.SOLIDUS ? (this.state = _.SCRIPT_DATA_DOUBLE_ESCAPE_END, this._emitChars("/")) : (this.state = _.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(t));
  }
  // Script data double escape end state
  //------------------------------------------------------------------
  _stateScriptDataDoubleEscapeEnd(t) {
    if (this.preprocessor.startsWith(On.SCRIPT, !1) && _k(this.preprocessor.peek(On.SCRIPT.length))) {
      this._emitCodePoint(t);
      for (let i = 0; i < On.SCRIPT.length; i++)
        this._emitCodePoint(this._consume());
      this.state = _.SCRIPT_DATA_ESCAPED;
    } else
      this._ensureHibernation() || (this.state = _.SCRIPT_DATA_DOUBLE_ESCAPED, this._stateScriptDataDoubleEscaped(t));
  }
  // Before attribute name state
  //------------------------------------------------------------------
  _stateBeforeAttributeName(t) {
    switch (t) {
      case J.SPACE:
      case J.LINE_FEED:
      case J.TABULATION:
      case J.FORM_FEED:
        break;
      case J.SOLIDUS:
      case J.GREATER_THAN_SIGN:
      case J.EOF: {
        this.state = _.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(t);
        break;
      }
      case J.EQUALS_SIGN: {
        this._err(Se.unexpectedEqualsSignBeforeAttributeName), this._createAttr("="), this.state = _.ATTRIBUTE_NAME;
        break;
      }
      default:
        this._createAttr(""), this.state = _.ATTRIBUTE_NAME, this._stateAttributeName(t);
    }
  }
  // Attribute name state
  //------------------------------------------------------------------
  _stateAttributeName(t) {
    switch (t) {
      case J.SPACE:
      case J.LINE_FEED:
      case J.TABULATION:
      case J.FORM_FEED:
      case J.SOLIDUS:
      case J.GREATER_THAN_SIGN:
      case J.EOF: {
        this._leaveAttrName(), this.state = _.AFTER_ATTRIBUTE_NAME, this._stateAfterAttributeName(t);
        break;
      }
      case J.EQUALS_SIGN: {
        this._leaveAttrName(), this.state = _.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case J.QUOTATION_MARK:
      case J.APOSTROPHE:
      case J.LESS_THAN_SIGN: {
        this._err(Se.unexpectedCharacterInAttributeName), this.currentAttr.name += String.fromCodePoint(t);
        break;
      }
      case J.NULL: {
        this._err(Se.unexpectedNullCharacter), this.currentAttr.name += Oi;
        break;
      }
      default:
        this.currentAttr.name += String.fromCodePoint(Hd(t) ? Wh(t) : t);
    }
  }
  // After attribute name state
  //------------------------------------------------------------------
  _stateAfterAttributeName(t) {
    switch (t) {
      case J.SPACE:
      case J.LINE_FEED:
      case J.TABULATION:
      case J.FORM_FEED:
        break;
      case J.SOLIDUS: {
        this.state = _.SELF_CLOSING_START_TAG;
        break;
      }
      case J.EQUALS_SIGN: {
        this.state = _.BEFORE_ATTRIBUTE_VALUE;
        break;
      }
      case J.GREATER_THAN_SIGN: {
        this.state = _.DATA, this.emitCurrentTagToken();
        break;
      }
      case J.EOF: {
        this._err(Se.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._createAttr(""), this.state = _.ATTRIBUTE_NAME, this._stateAttributeName(t);
    }
  }
  // Before attribute value state
  //------------------------------------------------------------------
  _stateBeforeAttributeValue(t) {
    switch (t) {
      case J.SPACE:
      case J.LINE_FEED:
      case J.TABULATION:
      case J.FORM_FEED:
        break;
      case J.QUOTATION_MARK: {
        this.state = _.ATTRIBUTE_VALUE_DOUBLE_QUOTED;
        break;
      }
      case J.APOSTROPHE: {
        this.state = _.ATTRIBUTE_VALUE_SINGLE_QUOTED;
        break;
      }
      case J.GREATER_THAN_SIGN: {
        this._err(Se.missingAttributeValue), this.state = _.DATA, this.emitCurrentTagToken();
        break;
      }
      default:
        this.state = _.ATTRIBUTE_VALUE_UNQUOTED, this._stateAttributeValueUnquoted(t);
    }
  }
  // Attribute value (double-quoted) state
  //------------------------------------------------------------------
  _stateAttributeValueDoubleQuoted(t) {
    switch (t) {
      case J.QUOTATION_MARK: {
        this.state = _.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case J.AMPERSAND: {
        this.returnState = _.ATTRIBUTE_VALUE_DOUBLE_QUOTED, this.state = _.CHARACTER_REFERENCE;
        break;
      }
      case J.NULL: {
        this._err(Se.unexpectedNullCharacter), this.currentAttr.value += Oi;
        break;
      }
      case J.EOF: {
        this._err(Se.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  // Attribute value (single-quoted) state
  //------------------------------------------------------------------
  _stateAttributeValueSingleQuoted(t) {
    switch (t) {
      case J.APOSTROPHE: {
        this.state = _.AFTER_ATTRIBUTE_VALUE_QUOTED;
        break;
      }
      case J.AMPERSAND: {
        this.returnState = _.ATTRIBUTE_VALUE_SINGLE_QUOTED, this.state = _.CHARACTER_REFERENCE;
        break;
      }
      case J.NULL: {
        this._err(Se.unexpectedNullCharacter), this.currentAttr.value += Oi;
        break;
      }
      case J.EOF: {
        this._err(Se.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  // Attribute value (unquoted) state
  //------------------------------------------------------------------
  _stateAttributeValueUnquoted(t) {
    switch (t) {
      case J.SPACE:
      case J.LINE_FEED:
      case J.TABULATION:
      case J.FORM_FEED: {
        this._leaveAttrValue(), this.state = _.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case J.AMPERSAND: {
        this.returnState = _.ATTRIBUTE_VALUE_UNQUOTED, this.state = _.CHARACTER_REFERENCE;
        break;
      }
      case J.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = _.DATA, this.emitCurrentTagToken();
        break;
      }
      case J.NULL: {
        this._err(Se.unexpectedNullCharacter), this.currentAttr.value += Oi;
        break;
      }
      case J.QUOTATION_MARK:
      case J.APOSTROPHE:
      case J.LESS_THAN_SIGN:
      case J.EQUALS_SIGN:
      case J.GRAVE_ACCENT: {
        this._err(Se.unexpectedCharacterInUnquotedAttributeValue), this.currentAttr.value += String.fromCodePoint(t);
        break;
      }
      case J.EOF: {
        this._err(Se.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this.currentAttr.value += String.fromCodePoint(t);
    }
  }
  // After attribute value (quoted) state
  //------------------------------------------------------------------
  _stateAfterAttributeValueQuoted(t) {
    switch (t) {
      case J.SPACE:
      case J.LINE_FEED:
      case J.TABULATION:
      case J.FORM_FEED: {
        this._leaveAttrValue(), this.state = _.BEFORE_ATTRIBUTE_NAME;
        break;
      }
      case J.SOLIDUS: {
        this._leaveAttrValue(), this.state = _.SELF_CLOSING_START_TAG;
        break;
      }
      case J.GREATER_THAN_SIGN: {
        this._leaveAttrValue(), this.state = _.DATA, this.emitCurrentTagToken();
        break;
      }
      case J.EOF: {
        this._err(Se.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(Se.missingWhitespaceBetweenAttributes), this.state = _.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(t);
    }
  }
  // Self-closing start tag state
  //------------------------------------------------------------------
  _stateSelfClosingStartTag(t) {
    switch (t) {
      case J.GREATER_THAN_SIGN: {
        const i = this.currentToken;
        i.selfClosing = !0, this.state = _.DATA, this.emitCurrentTagToken();
        break;
      }
      case J.EOF: {
        this._err(Se.eofInTag), this._emitEOFToken();
        break;
      }
      default:
        this._err(Se.unexpectedSolidusInTag), this.state = _.BEFORE_ATTRIBUTE_NAME, this._stateBeforeAttributeName(t);
    }
  }
  // Bogus comment state
  //------------------------------------------------------------------
  _stateBogusComment(t) {
    const i = this.currentToken;
    switch (t) {
      case J.GREATER_THAN_SIGN: {
        this.state = _.DATA, this.emitCurrentComment(i);
        break;
      }
      case J.EOF: {
        this.emitCurrentComment(i), this._emitEOFToken();
        break;
      }
      case J.NULL: {
        this._err(Se.unexpectedNullCharacter), i.data += Oi;
        break;
      }
      default:
        i.data += String.fromCodePoint(t);
    }
  }
  // Markup declaration open state
  //------------------------------------------------------------------
  _stateMarkupDeclarationOpen(t) {
    this._consumeSequenceIfMatch(On.DASH_DASH, !0) ? (this._createCommentToken(On.DASH_DASH.length + 1), this.state = _.COMMENT_START) : this._consumeSequenceIfMatch(On.DOCTYPE, !1) ? (this.currentLocation = this.getCurrentLocation(On.DOCTYPE.length + 1), this.state = _.DOCTYPE) : this._consumeSequenceIfMatch(On.CDATA_START, !0) ? this.inForeignNode ? this.state = _.CDATA_SECTION : (this._err(Se.cdataInHtmlContent), this._createCommentToken(On.CDATA_START.length + 1), this.currentToken.data = "[CDATA[", this.state = _.BOGUS_COMMENT) : this._ensureHibernation() || (this._err(Se.incorrectlyOpenedComment), this._createCommentToken(2), this.state = _.BOGUS_COMMENT, this._stateBogusComment(t));
  }
  // Comment start state
  //------------------------------------------------------------------
  _stateCommentStart(t) {
    switch (t) {
      case J.HYPHEN_MINUS: {
        this.state = _.COMMENT_START_DASH;
        break;
      }
      case J.GREATER_THAN_SIGN: {
        this._err(Se.abruptClosingOfEmptyComment), this.state = _.DATA;
        const i = this.currentToken;
        this.emitCurrentComment(i);
        break;
      }
      default:
        this.state = _.COMMENT, this._stateComment(t);
    }
  }
  // Comment start dash state
  //------------------------------------------------------------------
  _stateCommentStartDash(t) {
    const i = this.currentToken;
    switch (t) {
      case J.HYPHEN_MINUS: {
        this.state = _.COMMENT_END;
        break;
      }
      case J.GREATER_THAN_SIGN: {
        this._err(Se.abruptClosingOfEmptyComment), this.state = _.DATA, this.emitCurrentComment(i);
        break;
      }
      case J.EOF: {
        this._err(Se.eofInComment), this.emitCurrentComment(i), this._emitEOFToken();
        break;
      }
      default:
        i.data += "-", this.state = _.COMMENT, this._stateComment(t);
    }
  }
  // Comment state
  //------------------------------------------------------------------
  _stateComment(t) {
    const i = this.currentToken;
    switch (t) {
      case J.HYPHEN_MINUS: {
        this.state = _.COMMENT_END_DASH;
        break;
      }
      case J.LESS_THAN_SIGN: {
        i.data += "<", this.state = _.COMMENT_LESS_THAN_SIGN;
        break;
      }
      case J.NULL: {
        this._err(Se.unexpectedNullCharacter), i.data += Oi;
        break;
      }
      case J.EOF: {
        this._err(Se.eofInComment), this.emitCurrentComment(i), this._emitEOFToken();
        break;
      }
      default:
        i.data += String.fromCodePoint(t);
    }
  }
  // Comment less-than sign state
  //------------------------------------------------------------------
  _stateCommentLessThanSign(t) {
    const i = this.currentToken;
    switch (t) {
      case J.EXCLAMATION_MARK: {
        i.data += "!", this.state = _.COMMENT_LESS_THAN_SIGN_BANG;
        break;
      }
      case J.LESS_THAN_SIGN: {
        i.data += "<";
        break;
      }
      default:
        this.state = _.COMMENT, this._stateComment(t);
    }
  }
  // Comment less-than sign bang state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBang(t) {
    t === J.HYPHEN_MINUS ? this.state = _.COMMENT_LESS_THAN_SIGN_BANG_DASH : (this.state = _.COMMENT, this._stateComment(t));
  }
  // Comment less-than sign bang dash state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBangDash(t) {
    t === J.HYPHEN_MINUS ? this.state = _.COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH : (this.state = _.COMMENT_END_DASH, this._stateCommentEndDash(t));
  }
  // Comment less-than sign bang dash dash state
  //------------------------------------------------------------------
  _stateCommentLessThanSignBangDashDash(t) {
    t !== J.GREATER_THAN_SIGN && t !== J.EOF && this._err(Se.nestedComment), this.state = _.COMMENT_END, this._stateCommentEnd(t);
  }
  // Comment end dash state
  //------------------------------------------------------------------
  _stateCommentEndDash(t) {
    const i = this.currentToken;
    switch (t) {
      case J.HYPHEN_MINUS: {
        this.state = _.COMMENT_END;
        break;
      }
      case J.EOF: {
        this._err(Se.eofInComment), this.emitCurrentComment(i), this._emitEOFToken();
        break;
      }
      default:
        i.data += "-", this.state = _.COMMENT, this._stateComment(t);
    }
  }
  // Comment end state
  //------------------------------------------------------------------
  _stateCommentEnd(t) {
    const i = this.currentToken;
    switch (t) {
      case J.GREATER_THAN_SIGN: {
        this.state = _.DATA, this.emitCurrentComment(i);
        break;
      }
      case J.EXCLAMATION_MARK: {
        this.state = _.COMMENT_END_BANG;
        break;
      }
      case J.HYPHEN_MINUS: {
        i.data += "-";
        break;
      }
      case J.EOF: {
        this._err(Se.eofInComment), this.emitCurrentComment(i), this._emitEOFToken();
        break;
      }
      default:
        i.data += "--", this.state = _.COMMENT, this._stateComment(t);
    }
  }
  // Comment end bang state
  //------------------------------------------------------------------
  _stateCommentEndBang(t) {
    const i = this.currentToken;
    switch (t) {
      case J.HYPHEN_MINUS: {
        i.data += "--!", this.state = _.COMMENT_END_DASH;
        break;
      }
      case J.GREATER_THAN_SIGN: {
        this._err(Se.incorrectlyClosedComment), this.state = _.DATA, this.emitCurrentComment(i);
        break;
      }
      case J.EOF: {
        this._err(Se.eofInComment), this.emitCurrentComment(i), this._emitEOFToken();
        break;
      }
      default:
        i.data += "--!", this.state = _.COMMENT, this._stateComment(t);
    }
  }
  // DOCTYPE state
  //------------------------------------------------------------------
  _stateDoctype(t) {
    switch (t) {
      case J.SPACE:
      case J.LINE_FEED:
      case J.TABULATION:
      case J.FORM_FEED: {
        this.state = _.BEFORE_DOCTYPE_NAME;
        break;
      }
      case J.GREATER_THAN_SIGN: {
        this.state = _.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(t);
        break;
      }
      case J.EOF: {
        this._err(Se.eofInDoctype), this._createDoctypeToken(null);
        const i = this.currentToken;
        i.forceQuirks = !0, this.emitCurrentDoctype(i), this._emitEOFToken();
        break;
      }
      default:
        this._err(Se.missingWhitespaceBeforeDoctypeName), this.state = _.BEFORE_DOCTYPE_NAME, this._stateBeforeDoctypeName(t);
    }
  }
  // Before DOCTYPE name state
  //------------------------------------------------------------------
  _stateBeforeDoctypeName(t) {
    if (Hd(t))
      this._createDoctypeToken(String.fromCharCode(Wh(t))), this.state = _.DOCTYPE_NAME;
    else
      switch (t) {
        case J.SPACE:
        case J.LINE_FEED:
        case J.TABULATION:
        case J.FORM_FEED:
          break;
        case J.NULL: {
          this._err(Se.unexpectedNullCharacter), this._createDoctypeToken(Oi), this.state = _.DOCTYPE_NAME;
          break;
        }
        case J.GREATER_THAN_SIGN: {
          this._err(Se.missingDoctypeName), this._createDoctypeToken(null);
          const i = this.currentToken;
          i.forceQuirks = !0, this.emitCurrentDoctype(i), this.state = _.DATA;
          break;
        }
        case J.EOF: {
          this._err(Se.eofInDoctype), this._createDoctypeToken(null);
          const i = this.currentToken;
          i.forceQuirks = !0, this.emitCurrentDoctype(i), this._emitEOFToken();
          break;
        }
        default:
          this._createDoctypeToken(String.fromCodePoint(t)), this.state = _.DOCTYPE_NAME;
      }
  }
  // DOCTYPE name state
  //------------------------------------------------------------------
  _stateDoctypeName(t) {
    const i = this.currentToken;
    switch (t) {
      case J.SPACE:
      case J.LINE_FEED:
      case J.TABULATION:
      case J.FORM_FEED: {
        this.state = _.AFTER_DOCTYPE_NAME;
        break;
      }
      case J.GREATER_THAN_SIGN: {
        this.state = _.DATA, this.emitCurrentDoctype(i);
        break;
      }
      case J.NULL: {
        this._err(Se.unexpectedNullCharacter), i.name += Oi;
        break;
      }
      case J.EOF: {
        this._err(Se.eofInDoctype), i.forceQuirks = !0, this.emitCurrentDoctype(i), this._emitEOFToken();
        break;
      }
      default:
        i.name += String.fromCodePoint(Hd(t) ? Wh(t) : t);
    }
  }
  // After DOCTYPE name state
  //------------------------------------------------------------------
  _stateAfterDoctypeName(t) {
    const i = this.currentToken;
    switch (t) {
      case J.SPACE:
      case J.LINE_FEED:
      case J.TABULATION:
      case J.FORM_FEED:
        break;
      case J.GREATER_THAN_SIGN: {
        this.state = _.DATA, this.emitCurrentDoctype(i);
        break;
      }
      case J.EOF: {
        this._err(Se.eofInDoctype), i.forceQuirks = !0, this.emitCurrentDoctype(i), this._emitEOFToken();
        break;
      }
      default:
        this._consumeSequenceIfMatch(On.PUBLIC, !1) ? this.state = _.AFTER_DOCTYPE_PUBLIC_KEYWORD : this._consumeSequenceIfMatch(On.SYSTEM, !1) ? this.state = _.AFTER_DOCTYPE_SYSTEM_KEYWORD : this._ensureHibernation() || (this._err(Se.invalidCharacterSequenceAfterDoctypeName), i.forceQuirks = !0, this.state = _.BOGUS_DOCTYPE, this._stateBogusDoctype(t));
    }
  }
  // After DOCTYPE public keyword state
  //------------------------------------------------------------------
  _stateAfterDoctypePublicKeyword(t) {
    const i = this.currentToken;
    switch (t) {
      case J.SPACE:
      case J.LINE_FEED:
      case J.TABULATION:
      case J.FORM_FEED: {
        this.state = _.BEFORE_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case J.QUOTATION_MARK: {
        this._err(Se.missingWhitespaceAfterDoctypePublicKeyword), i.publicId = "", this.state = _.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case J.APOSTROPHE: {
        this._err(Se.missingWhitespaceAfterDoctypePublicKeyword), i.publicId = "", this.state = _.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case J.GREATER_THAN_SIGN: {
        this._err(Se.missingDoctypePublicIdentifier), i.forceQuirks = !0, this.state = _.DATA, this.emitCurrentDoctype(i);
        break;
      }
      case J.EOF: {
        this._err(Se.eofInDoctype), i.forceQuirks = !0, this.emitCurrentDoctype(i), this._emitEOFToken();
        break;
      }
      default:
        this._err(Se.missingQuoteBeforeDoctypePublicIdentifier), i.forceQuirks = !0, this.state = _.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Before DOCTYPE public identifier state
  //------------------------------------------------------------------
  _stateBeforeDoctypePublicIdentifier(t) {
    const i = this.currentToken;
    switch (t) {
      case J.SPACE:
      case J.LINE_FEED:
      case J.TABULATION:
      case J.FORM_FEED:
        break;
      case J.QUOTATION_MARK: {
        i.publicId = "", this.state = _.DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case J.APOSTROPHE: {
        i.publicId = "", this.state = _.DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case J.GREATER_THAN_SIGN: {
        this._err(Se.missingDoctypePublicIdentifier), i.forceQuirks = !0, this.state = _.DATA, this.emitCurrentDoctype(i);
        break;
      }
      case J.EOF: {
        this._err(Se.eofInDoctype), i.forceQuirks = !0, this.emitCurrentDoctype(i), this._emitEOFToken();
        break;
      }
      default:
        this._err(Se.missingQuoteBeforeDoctypePublicIdentifier), i.forceQuirks = !0, this.state = _.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // DOCTYPE public identifier (double-quoted) state
  //------------------------------------------------------------------
  _stateDoctypePublicIdentifierDoubleQuoted(t) {
    const i = this.currentToken;
    switch (t) {
      case J.QUOTATION_MARK: {
        this.state = _.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case J.NULL: {
        this._err(Se.unexpectedNullCharacter), i.publicId += Oi;
        break;
      }
      case J.GREATER_THAN_SIGN: {
        this._err(Se.abruptDoctypePublicIdentifier), i.forceQuirks = !0, this.emitCurrentDoctype(i), this.state = _.DATA;
        break;
      }
      case J.EOF: {
        this._err(Se.eofInDoctype), i.forceQuirks = !0, this.emitCurrentDoctype(i), this._emitEOFToken();
        break;
      }
      default:
        i.publicId += String.fromCodePoint(t);
    }
  }
  // DOCTYPE public identifier (single-quoted) state
  //------------------------------------------------------------------
  _stateDoctypePublicIdentifierSingleQuoted(t) {
    const i = this.currentToken;
    switch (t) {
      case J.APOSTROPHE: {
        this.state = _.AFTER_DOCTYPE_PUBLIC_IDENTIFIER;
        break;
      }
      case J.NULL: {
        this._err(Se.unexpectedNullCharacter), i.publicId += Oi;
        break;
      }
      case J.GREATER_THAN_SIGN: {
        this._err(Se.abruptDoctypePublicIdentifier), i.forceQuirks = !0, this.emitCurrentDoctype(i), this.state = _.DATA;
        break;
      }
      case J.EOF: {
        this._err(Se.eofInDoctype), i.forceQuirks = !0, this.emitCurrentDoctype(i), this._emitEOFToken();
        break;
      }
      default:
        i.publicId += String.fromCodePoint(t);
    }
  }
  // After DOCTYPE public identifier state
  //------------------------------------------------------------------
  _stateAfterDoctypePublicIdentifier(t) {
    const i = this.currentToken;
    switch (t) {
      case J.SPACE:
      case J.LINE_FEED:
      case J.TABULATION:
      case J.FORM_FEED: {
        this.state = _.BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS;
        break;
      }
      case J.GREATER_THAN_SIGN: {
        this.state = _.DATA, this.emitCurrentDoctype(i);
        break;
      }
      case J.QUOTATION_MARK: {
        this._err(Se.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), i.systemId = "", this.state = _.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case J.APOSTROPHE: {
        this._err(Se.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers), i.systemId = "", this.state = _.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case J.EOF: {
        this._err(Se.eofInDoctype), i.forceQuirks = !0, this.emitCurrentDoctype(i), this._emitEOFToken();
        break;
      }
      default:
        this._err(Se.missingQuoteBeforeDoctypeSystemIdentifier), i.forceQuirks = !0, this.state = _.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Between DOCTYPE public and system identifiers state
  //------------------------------------------------------------------
  _stateBetweenDoctypePublicAndSystemIdentifiers(t) {
    const i = this.currentToken;
    switch (t) {
      case J.SPACE:
      case J.LINE_FEED:
      case J.TABULATION:
      case J.FORM_FEED:
        break;
      case J.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(i), this.state = _.DATA;
        break;
      }
      case J.QUOTATION_MARK: {
        i.systemId = "", this.state = _.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case J.APOSTROPHE: {
        i.systemId = "", this.state = _.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case J.EOF: {
        this._err(Se.eofInDoctype), i.forceQuirks = !0, this.emitCurrentDoctype(i), this._emitEOFToken();
        break;
      }
      default:
        this._err(Se.missingQuoteBeforeDoctypeSystemIdentifier), i.forceQuirks = !0, this.state = _.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // After DOCTYPE system keyword state
  //------------------------------------------------------------------
  _stateAfterDoctypeSystemKeyword(t) {
    const i = this.currentToken;
    switch (t) {
      case J.SPACE:
      case J.LINE_FEED:
      case J.TABULATION:
      case J.FORM_FEED: {
        this.state = _.BEFORE_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case J.QUOTATION_MARK: {
        this._err(Se.missingWhitespaceAfterDoctypeSystemKeyword), i.systemId = "", this.state = _.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case J.APOSTROPHE: {
        this._err(Se.missingWhitespaceAfterDoctypeSystemKeyword), i.systemId = "", this.state = _.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case J.GREATER_THAN_SIGN: {
        this._err(Se.missingDoctypeSystemIdentifier), i.forceQuirks = !0, this.state = _.DATA, this.emitCurrentDoctype(i);
        break;
      }
      case J.EOF: {
        this._err(Se.eofInDoctype), i.forceQuirks = !0, this.emitCurrentDoctype(i), this._emitEOFToken();
        break;
      }
      default:
        this._err(Se.missingQuoteBeforeDoctypeSystemIdentifier), i.forceQuirks = !0, this.state = _.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Before DOCTYPE system identifier state
  //------------------------------------------------------------------
  _stateBeforeDoctypeSystemIdentifier(t) {
    const i = this.currentToken;
    switch (t) {
      case J.SPACE:
      case J.LINE_FEED:
      case J.TABULATION:
      case J.FORM_FEED:
        break;
      case J.QUOTATION_MARK: {
        i.systemId = "", this.state = _.DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED;
        break;
      }
      case J.APOSTROPHE: {
        i.systemId = "", this.state = _.DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED;
        break;
      }
      case J.GREATER_THAN_SIGN: {
        this._err(Se.missingDoctypeSystemIdentifier), i.forceQuirks = !0, this.state = _.DATA, this.emitCurrentDoctype(i);
        break;
      }
      case J.EOF: {
        this._err(Se.eofInDoctype), i.forceQuirks = !0, this.emitCurrentDoctype(i), this._emitEOFToken();
        break;
      }
      default:
        this._err(Se.missingQuoteBeforeDoctypeSystemIdentifier), i.forceQuirks = !0, this.state = _.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // DOCTYPE system identifier (double-quoted) state
  //------------------------------------------------------------------
  _stateDoctypeSystemIdentifierDoubleQuoted(t) {
    const i = this.currentToken;
    switch (t) {
      case J.QUOTATION_MARK: {
        this.state = _.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case J.NULL: {
        this._err(Se.unexpectedNullCharacter), i.systemId += Oi;
        break;
      }
      case J.GREATER_THAN_SIGN: {
        this._err(Se.abruptDoctypeSystemIdentifier), i.forceQuirks = !0, this.emitCurrentDoctype(i), this.state = _.DATA;
        break;
      }
      case J.EOF: {
        this._err(Se.eofInDoctype), i.forceQuirks = !0, this.emitCurrentDoctype(i), this._emitEOFToken();
        break;
      }
      default:
        i.systemId += String.fromCodePoint(t);
    }
  }
  // DOCTYPE system identifier (single-quoted) state
  //------------------------------------------------------------------
  _stateDoctypeSystemIdentifierSingleQuoted(t) {
    const i = this.currentToken;
    switch (t) {
      case J.APOSTROPHE: {
        this.state = _.AFTER_DOCTYPE_SYSTEM_IDENTIFIER;
        break;
      }
      case J.NULL: {
        this._err(Se.unexpectedNullCharacter), i.systemId += Oi;
        break;
      }
      case J.GREATER_THAN_SIGN: {
        this._err(Se.abruptDoctypeSystemIdentifier), i.forceQuirks = !0, this.emitCurrentDoctype(i), this.state = _.DATA;
        break;
      }
      case J.EOF: {
        this._err(Se.eofInDoctype), i.forceQuirks = !0, this.emitCurrentDoctype(i), this._emitEOFToken();
        break;
      }
      default:
        i.systemId += String.fromCodePoint(t);
    }
  }
  // After DOCTYPE system identifier state
  //------------------------------------------------------------------
  _stateAfterDoctypeSystemIdentifier(t) {
    const i = this.currentToken;
    switch (t) {
      case J.SPACE:
      case J.LINE_FEED:
      case J.TABULATION:
      case J.FORM_FEED:
        break;
      case J.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(i), this.state = _.DATA;
        break;
      }
      case J.EOF: {
        this._err(Se.eofInDoctype), i.forceQuirks = !0, this.emitCurrentDoctype(i), this._emitEOFToken();
        break;
      }
      default:
        this._err(Se.unexpectedCharacterAfterDoctypeSystemIdentifier), this.state = _.BOGUS_DOCTYPE, this._stateBogusDoctype(t);
    }
  }
  // Bogus DOCTYPE state
  //------------------------------------------------------------------
  _stateBogusDoctype(t) {
    const i = this.currentToken;
    switch (t) {
      case J.GREATER_THAN_SIGN: {
        this.emitCurrentDoctype(i), this.state = _.DATA;
        break;
      }
      case J.NULL: {
        this._err(Se.unexpectedNullCharacter);
        break;
      }
      case J.EOF: {
        this.emitCurrentDoctype(i), this._emitEOFToken();
        break;
      }
    }
  }
  // CDATA section state
  //------------------------------------------------------------------
  _stateCdataSection(t) {
    switch (t) {
      case J.RIGHT_SQUARE_BRACKET: {
        this.state = _.CDATA_SECTION_BRACKET;
        break;
      }
      case J.EOF: {
        this._err(Se.eofInCdata), this._emitEOFToken();
        break;
      }
      default:
        this._emitCodePoint(t);
    }
  }
  // CDATA section bracket state
  //------------------------------------------------------------------
  _stateCdataSectionBracket(t) {
    t === J.RIGHT_SQUARE_BRACKET ? this.state = _.CDATA_SECTION_END : (this._emitChars("]"), this.state = _.CDATA_SECTION, this._stateCdataSection(t));
  }
  // CDATA section end state
  //------------------------------------------------------------------
  _stateCdataSectionEnd(t) {
    switch (t) {
      case J.GREATER_THAN_SIGN: {
        this.state = _.DATA;
        break;
      }
      case J.RIGHT_SQUARE_BRACKET: {
        this._emitChars("]");
        break;
      }
      default:
        this._emitChars("]]"), this.state = _.CDATA_SECTION, this._stateCdataSection(t);
    }
  }
  // Character reference state
  //------------------------------------------------------------------
  _stateCharacterReference(t) {
    t === J.NUMBER_SIGN ? this.state = _.NUMERIC_CHARACTER_REFERENCE : yb(t) ? (this.state = _.NAMED_CHARACTER_REFERENCE, this._stateNamedCharacterReference(t)) : (this._flushCodePointConsumedAsCharacterReference(J.AMPERSAND), this._reconsumeInState(this.returnState, t));
  }
  // Named character reference state
  //------------------------------------------------------------------
  _stateNamedCharacterReference(t) {
    const i = this._matchNamedCharacterReference(t);
    if (!this._ensureHibernation())
      if (i) {
        for (let r = 0; r < i.length; r++)
          this._flushCodePointConsumedAsCharacterReference(i[r]);
        this.state = this.returnState;
      } else
        this._flushCodePointConsumedAsCharacterReference(J.AMPERSAND), this.state = _.AMBIGUOUS_AMPERSAND;
  }
  // Ambiguos ampersand state
  //------------------------------------------------------------------
  _stateAmbiguousAmpersand(t) {
    yb(t) ? this._flushCodePointConsumedAsCharacterReference(t) : (t === J.SEMICOLON && this._err(Se.unknownNamedCharacterReference), this._reconsumeInState(this.returnState, t));
  }
  // Numeric character reference state
  //------------------------------------------------------------------
  _stateNumericCharacterReference(t) {
    this.charRefCode = 0, t === J.LATIN_SMALL_X || t === J.LATIN_CAPITAL_X ? this.state = _.HEXADEMICAL_CHARACTER_REFERENCE_START : um(t) ? (this.state = _.DECIMAL_CHARACTER_REFERENCE, this._stateDecimalCharacterReference(t)) : (this._err(Se.absenceOfDigitsInNumericCharacterReference), this._flushCodePointConsumedAsCharacterReference(J.AMPERSAND), this._flushCodePointConsumedAsCharacterReference(J.NUMBER_SIGN), this._reconsumeInState(this.returnState, t));
  }
  // Hexademical character reference start state
  //------------------------------------------------------------------
  _stateHexademicalCharacterReferenceStart(t) {
    aZ(t) ? (this.state = _.HEXADEMICAL_CHARACTER_REFERENCE, this._stateHexademicalCharacterReference(t)) : (this._err(Se.absenceOfDigitsInNumericCharacterReference), this._flushCodePointConsumedAsCharacterReference(J.AMPERSAND), this._flushCodePointConsumedAsCharacterReference(J.NUMBER_SIGN), this._unconsume(2), this.state = this.returnState);
  }
  // Hexademical character reference state
  //------------------------------------------------------------------
  _stateHexademicalCharacterReference(t) {
    s5(t) ? this.charRefCode = this.charRefCode * 16 + t - 55 : a5(t) ? this.charRefCode = this.charRefCode * 16 + t - 87 : um(t) ? this.charRefCode = this.charRefCode * 16 + t - 48 : t === J.SEMICOLON ? this.state = _.NUMERIC_CHARACTER_REFERENCE_END : (this._err(Se.missingSemicolonAfterCharacterReference), this.state = _.NUMERIC_CHARACTER_REFERENCE_END, this._stateNumericCharacterReferenceEnd(t));
  }
  // Decimal character reference state
  //------------------------------------------------------------------
  _stateDecimalCharacterReference(t) {
    um(t) ? this.charRefCode = this.charRefCode * 10 + t - 48 : t === J.SEMICOLON ? this.state = _.NUMERIC_CHARACTER_REFERENCE_END : (this._err(Se.missingSemicolonAfterCharacterReference), this.state = _.NUMERIC_CHARACTER_REFERENCE_END, this._stateNumericCharacterReferenceEnd(t));
  }
  // Numeric character reference end state
  //------------------------------------------------------------------
  _stateNumericCharacterReferenceEnd(t) {
    if (this.charRefCode === J.NULL)
      this._err(Se.nullCharacterReference), this.charRefCode = J.REPLACEMENT_CHARACTER;
    else if (this.charRefCode > 1114111)
      this._err(Se.characterReferenceOutsideUnicodeRange), this.charRefCode = J.REPLACEMENT_CHARACTER;
    else if ($T(this.charRefCode))
      this._err(Se.surrogateCharacterReference), this.charRefCode = J.REPLACEMENT_CHARACTER;
    else if (t5(this.charRefCode))
      this._err(Se.noncharacterCharacterReference);
    else if (e5(this.charRefCode) || this.charRefCode === J.CARRIAGE_RETURN) {
      this._err(Se.controlCharacterReference);
      const i = oZ.get(this.charRefCode);
      i !== void 0 && (this.charRefCode = i);
    }
    this._flushCodePointConsumedAsCharacterReference(this.charRefCode), this._reconsumeInState(this.returnState, t);
  }
}
const c5 = /* @__PURE__ */ new Set([I.DD, I.DT, I.LI, I.OPTGROUP, I.OPTION, I.P, I.RB, I.RP, I.RT, I.RTC]), $k = /* @__PURE__ */ new Set([
  ...c5,
  I.CAPTION,
  I.COLGROUP,
  I.TBODY,
  I.TD,
  I.TFOOT,
  I.TH,
  I.THEAD,
  I.TR
]), Zh = /* @__PURE__ */ new Map([
  [I.APPLET, ke.HTML],
  [I.CAPTION, ke.HTML],
  [I.HTML, ke.HTML],
  [I.MARQUEE, ke.HTML],
  [I.OBJECT, ke.HTML],
  [I.TABLE, ke.HTML],
  [I.TD, ke.HTML],
  [I.TEMPLATE, ke.HTML],
  [I.TH, ke.HTML],
  [I.ANNOTATION_XML, ke.MATHML],
  [I.MI, ke.MATHML],
  [I.MN, ke.MATHML],
  [I.MO, ke.MATHML],
  [I.MS, ke.MATHML],
  [I.MTEXT, ke.MATHML],
  [I.DESC, ke.SVG],
  [I.FOREIGN_OBJECT, ke.SVG],
  [I.TITLE, ke.SVG]
]), uZ = [I.H1, I.H2, I.H3, I.H4, I.H5, I.H6], dZ = [I.TR, I.TEMPLATE, I.HTML], mZ = [I.TBODY, I.TFOOT, I.THEAD, I.TEMPLATE, I.HTML], gZ = [I.TABLE, I.TEMPLATE, I.HTML], hZ = [I.TD, I.TH];
class pZ {
  get currentTmplContentOrNode() {
    return this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : this.current;
  }
  constructor(t, i, r) {
    this.treeAdapter = i, this.handler = r, this.items = [], this.tagIDs = [], this.stackTop = -1, this.tmplCount = 0, this.currentTagId = I.UNKNOWN, this.current = t;
  }
  //Index of element
  _indexOf(t) {
    return this.items.lastIndexOf(t, this.stackTop);
  }
  //Update current element
  _isInTemplate() {
    return this.currentTagId === I.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === ke.HTML;
  }
  _updateCurrentElement() {
    this.current = this.items[this.stackTop], this.currentTagId = this.tagIDs[this.stackTop];
  }
  //Mutations
  push(t, i) {
    this.stackTop++, this.items[this.stackTop] = t, this.current = t, this.tagIDs[this.stackTop] = i, this.currentTagId = i, this._isInTemplate() && this.tmplCount++, this.handler.onItemPush(t, i, !0);
  }
  pop() {
    const t = this.current;
    this.tmplCount > 0 && this._isInTemplate() && this.tmplCount--, this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(t, !0);
  }
  replace(t, i) {
    const r = this._indexOf(t);
    this.items[r] = i, r === this.stackTop && (this.current = i);
  }
  insertAfter(t, i, r) {
    const n = this._indexOf(t) + 1;
    this.items.splice(n, 0, i), this.tagIDs.splice(n, 0, r), this.stackTop++, n === this.stackTop && this._updateCurrentElement(), this.handler.onItemPush(this.current, this.currentTagId, n === this.stackTop);
  }
  popUntilTagNamePopped(t) {
    let i = this.stackTop + 1;
    do
      i = this.tagIDs.lastIndexOf(t, i - 1);
    while (i > 0 && this.treeAdapter.getNamespaceURI(this.items[i]) !== ke.HTML);
    this.shortenToLength(i < 0 ? 0 : i);
  }
  shortenToLength(t) {
    for (; this.stackTop >= t; ) {
      const i = this.current;
      this.tmplCount > 0 && this._isInTemplate() && (this.tmplCount -= 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(i, this.stackTop < t);
    }
  }
  popUntilElementPopped(t) {
    const i = this._indexOf(t);
    this.shortenToLength(i < 0 ? 0 : i);
  }
  popUntilPopped(t, i) {
    const r = this._indexOfTagNames(t, i);
    this.shortenToLength(r < 0 ? 0 : r);
  }
  popUntilNumberedHeaderPopped() {
    this.popUntilPopped(uZ, ke.HTML);
  }
  popUntilTableCellPopped() {
    this.popUntilPopped(hZ, ke.HTML);
  }
  popAllUpToHtmlElement() {
    this.tmplCount = 0, this.shortenToLength(1);
  }
  _indexOfTagNames(t, i) {
    for (let r = this.stackTop; r >= 0; r--)
      if (t.includes(this.tagIDs[r]) && this.treeAdapter.getNamespaceURI(this.items[r]) === i)
        return r;
    return -1;
  }
  clearBackTo(t, i) {
    const r = this._indexOfTagNames(t, i);
    this.shortenToLength(r + 1);
  }
  clearBackToTableContext() {
    this.clearBackTo(gZ, ke.HTML);
  }
  clearBackToTableBodyContext() {
    this.clearBackTo(mZ, ke.HTML);
  }
  clearBackToTableRowContext() {
    this.clearBackTo(dZ, ke.HTML);
  }
  remove(t) {
    const i = this._indexOf(t);
    i >= 0 && (i === this.stackTop ? this.pop() : (this.items.splice(i, 1), this.tagIDs.splice(i, 1), this.stackTop--, this._updateCurrentElement(), this.handler.onItemPop(t, !1)));
  }
  //Search
  tryPeekProperlyNestedBodyElement() {
    return this.stackTop >= 1 && this.tagIDs[1] === I.BODY ? this.items[1] : null;
  }
  contains(t) {
    return this._indexOf(t) > -1;
  }
  getCommonAncestor(t) {
    const i = this._indexOf(t) - 1;
    return i >= 0 ? this.items[i] : null;
  }
  isRootHtmlElementCurrent() {
    return this.stackTop === 0 && this.tagIDs[0] === I.HTML;
  }
  //Element in scope
  hasInScope(t) {
    for (let i = this.stackTop; i >= 0; i--) {
      const r = this.tagIDs[i], n = this.treeAdapter.getNamespaceURI(this.items[i]);
      if (r === t && n === ke.HTML)
        return !0;
      if (Zh.get(r) === n)
        return !1;
    }
    return !0;
  }
  hasNumberedHeaderInScope() {
    for (let t = this.stackTop; t >= 0; t--) {
      const i = this.tagIDs[t], r = this.treeAdapter.getNamespaceURI(this.items[t]);
      if (o5(i) && r === ke.HTML)
        return !0;
      if (Zh.get(i) === r)
        return !1;
    }
    return !0;
  }
  hasInListItemScope(t) {
    for (let i = this.stackTop; i >= 0; i--) {
      const r = this.tagIDs[i], n = this.treeAdapter.getNamespaceURI(this.items[i]);
      if (r === t && n === ke.HTML)
        return !0;
      if ((r === I.UL || r === I.OL) && n === ke.HTML || Zh.get(r) === n)
        return !1;
    }
    return !0;
  }
  hasInButtonScope(t) {
    for (let i = this.stackTop; i >= 0; i--) {
      const r = this.tagIDs[i], n = this.treeAdapter.getNamespaceURI(this.items[i]);
      if (r === t && n === ke.HTML)
        return !0;
      if (r === I.BUTTON && n === ke.HTML || Zh.get(r) === n)
        return !1;
    }
    return !0;
  }
  hasInTableScope(t) {
    for (let i = this.stackTop; i >= 0; i--) {
      const r = this.tagIDs[i];
      if (this.treeAdapter.getNamespaceURI(this.items[i]) === ke.HTML) {
        if (r === t)
          return !0;
        if (r === I.TABLE || r === I.TEMPLATE || r === I.HTML)
          return !1;
      }
    }
    return !0;
  }
  hasTableBodyContextInTableScope() {
    for (let t = this.stackTop; t >= 0; t--) {
      const i = this.tagIDs[t];
      if (this.treeAdapter.getNamespaceURI(this.items[t]) === ke.HTML) {
        if (i === I.TBODY || i === I.THEAD || i === I.TFOOT)
          return !0;
        if (i === I.TABLE || i === I.HTML)
          return !1;
      }
    }
    return !0;
  }
  hasInSelectScope(t) {
    for (let i = this.stackTop; i >= 0; i--) {
      const r = this.tagIDs[i];
      if (this.treeAdapter.getNamespaceURI(this.items[i]) === ke.HTML) {
        if (r === t)
          return !0;
        if (r !== I.OPTION && r !== I.OPTGROUP)
          return !1;
      }
    }
    return !0;
  }
  //Implied end tags
  generateImpliedEndTags() {
    for (; c5.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsThoroughly() {
    for (; $k.has(this.currentTagId); )
      this.pop();
  }
  generateImpliedEndTagsWithExclusion(t) {
    for (; this.currentTagId !== t && $k.has(this.currentTagId); )
      this.pop();
  }
}
const Ky = 3;
var ls;
(function(e) {
  e[e.Marker = 0] = "Marker", e[e.Element = 1] = "Element";
})(ls = ls || (ls = {}));
const e3 = { type: ls.Marker };
class fZ {
  constructor(t) {
    this.treeAdapter = t, this.entries = [], this.bookmark = null;
  }
  //Noah Ark's condition
  //OPTIMIZATION: at first we try to find possible candidates for exclusion using
  //lightweight heuristics without thorough attributes check.
  _getNoahArkConditionCandidates(t, i) {
    const r = [], n = i.length, o = this.treeAdapter.getTagName(t), s = this.treeAdapter.getNamespaceURI(t);
    for (let a = 0; a < this.entries.length; a++) {
      const l = this.entries[a];
      if (l.type === ls.Marker)
        break;
      const { element: c } = l;
      if (this.treeAdapter.getTagName(c) === o && this.treeAdapter.getNamespaceURI(c) === s) {
        const u = this.treeAdapter.getAttrList(c);
        u.length === n && r.push({ idx: a, attrs: u });
      }
    }
    return r;
  }
  _ensureNoahArkCondition(t) {
    if (this.entries.length < Ky)
      return;
    const i = this.treeAdapter.getAttrList(t), r = this._getNoahArkConditionCandidates(t, i);
    if (r.length < Ky)
      return;
    const n = new Map(i.map((s) => [s.name, s.value]));
    let o = 0;
    for (let s = 0; s < r.length; s++) {
      const a = r[s];
      a.attrs.every((l) => n.get(l.name) === l.value) && (o += 1, o >= Ky && this.entries.splice(a.idx, 1));
    }
  }
  //Mutations
  insertMarker() {
    this.entries.unshift(e3);
  }
  pushElement(t, i) {
    this._ensureNoahArkCondition(t), this.entries.unshift({
      type: ls.Element,
      element: t,
      token: i
    });
  }
  insertElementAfterBookmark(t, i) {
    const r = this.entries.indexOf(this.bookmark);
    this.entries.splice(r, 0, {
      type: ls.Element,
      element: t,
      token: i
    });
  }
  removeEntry(t) {
    const i = this.entries.indexOf(t);
    i >= 0 && this.entries.splice(i, 1);
  }
  /**
   * Clears the list of formatting elements up to the last marker.
   *
   * @see https://html.spec.whatwg.org/multipage/parsing.html#clear-the-list-of-active-formatting-elements-up-to-the-last-marker
   */
  clearToLastMarker() {
    const t = this.entries.indexOf(e3);
    t >= 0 ? this.entries.splice(0, t + 1) : this.entries.length = 0;
  }
  //Search
  getElementEntryInScopeWithTagName(t) {
    const i = this.entries.find((r) => r.type === ls.Marker || this.treeAdapter.getTagName(r.element) === t);
    return i && i.type === ls.Element ? i : null;
  }
  getElementEntry(t) {
    return this.entries.find((i) => i.type === ls.Element && i.element === t);
  }
}
function t3(e) {
  return {
    nodeName: "#text",
    value: e,
    parentNode: null
  };
}
const Ac = {
  //Node construction
  createDocument() {
    return {
      nodeName: "#document",
      mode: mo.NO_QUIRKS,
      childNodes: []
    };
  },
  createDocumentFragment() {
    return {
      nodeName: "#document-fragment",
      childNodes: []
    };
  },
  createElement(e, t, i) {
    return {
      nodeName: e,
      tagName: e,
      attrs: i,
      namespaceURI: t,
      childNodes: [],
      parentNode: null
    };
  },
  createCommentNode(e) {
    return {
      nodeName: "#comment",
      data: e,
      parentNode: null
    };
  },
  //Tree mutation
  appendChild(e, t) {
    e.childNodes.push(t), t.parentNode = e;
  },
  insertBefore(e, t, i) {
    const r = e.childNodes.indexOf(i);
    e.childNodes.splice(r, 0, t), t.parentNode = e;
  },
  setTemplateContent(e, t) {
    e.content = t;
  },
  getTemplateContent(e) {
    return e.content;
  },
  setDocumentType(e, t, i, r) {
    const n = e.childNodes.find((o) => o.nodeName === "#documentType");
    if (n)
      n.name = t, n.publicId = i, n.systemId = r;
    else {
      const o = {
        nodeName: "#documentType",
        name: t,
        publicId: i,
        systemId: r,
        parentNode: null
      };
      Ac.appendChild(e, o);
    }
  },
  setDocumentMode(e, t) {
    e.mode = t;
  },
  getDocumentMode(e) {
    return e.mode;
  },
  detachNode(e) {
    if (e.parentNode) {
      const t = e.parentNode.childNodes.indexOf(e);
      e.parentNode.childNodes.splice(t, 1), e.parentNode = null;
    }
  },
  insertText(e, t) {
    if (e.childNodes.length > 0) {
      const i = e.childNodes[e.childNodes.length - 1];
      if (Ac.isTextNode(i)) {
        i.value += t;
        return;
      }
    }
    Ac.appendChild(e, t3(t));
  },
  insertTextBefore(e, t, i) {
    const r = e.childNodes[e.childNodes.indexOf(i) - 1];
    r && Ac.isTextNode(r) ? r.value += t : Ac.insertBefore(e, t3(t), i);
  },
  adoptAttributes(e, t) {
    const i = new Set(e.attrs.map((r) => r.name));
    for (let r = 0; r < t.length; r++)
      i.has(t[r].name) || e.attrs.push(t[r]);
  },
  //Tree traversing
  getFirstChild(e) {
    return e.childNodes[0];
  },
  getChildNodes(e) {
    return e.childNodes;
  },
  getParentNode(e) {
    return e.parentNode;
  },
  getAttrList(e) {
    return e.attrs;
  },
  //Node data
  getTagName(e) {
    return e.tagName;
  },
  getNamespaceURI(e) {
    return e.namespaceURI;
  },
  getTextNodeContent(e) {
    return e.value;
  },
  getCommentNodeContent(e) {
    return e.data;
  },
  getDocumentTypeNodeName(e) {
    return e.name;
  },
  getDocumentTypeNodePublicId(e) {
    return e.publicId;
  },
  getDocumentTypeNodeSystemId(e) {
    return e.systemId;
  },
  //Node types
  isTextNode(e) {
    return e.nodeName === "#text";
  },
  isCommentNode(e) {
    return e.nodeName === "#comment";
  },
  isDocumentTypeNode(e) {
    return e.nodeName === "#documentType";
  },
  isElementNode(e) {
    return Object.prototype.hasOwnProperty.call(e, "tagName");
  },
  // Source code location
  setNodeSourceCodeLocation(e, t) {
    e.sourceCodeLocation = t;
  },
  getNodeSourceCodeLocation(e) {
    return e.sourceCodeLocation;
  },
  updateNodeSourceCodeLocation(e, t) {
    e.sourceCodeLocation = q(q({}, e.sourceCodeLocation), t);
  }
}, u5 = "html", AZ = "about:legacy-compat", yZ = "http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd", d5 = [
  "+//silmaril//dtd html pro v0r11 19970101//",
  "-//as//dtd html 3.0 aswedit + extensions//",
  "-//advasoft ltd//dtd html 3.0 aswedit + extensions//",
  "-//ietf//dtd html 2.0 level 1//",
  "-//ietf//dtd html 2.0 level 2//",
  "-//ietf//dtd html 2.0 strict level 1//",
  "-//ietf//dtd html 2.0 strict level 2//",
  "-//ietf//dtd html 2.0 strict//",
  "-//ietf//dtd html 2.0//",
  "-//ietf//dtd html 2.1e//",
  "-//ietf//dtd html 3.0//",
  "-//ietf//dtd html 3.2 final//",
  "-//ietf//dtd html 3.2//",
  "-//ietf//dtd html 3//",
  "-//ietf//dtd html level 0//",
  "-//ietf//dtd html level 1//",
  "-//ietf//dtd html level 2//",
  "-//ietf//dtd html level 3//",
  "-//ietf//dtd html strict level 0//",
  "-//ietf//dtd html strict level 1//",
  "-//ietf//dtd html strict level 2//",
  "-//ietf//dtd html strict level 3//",
  "-//ietf//dtd html strict//",
  "-//ietf//dtd html//",
  "-//metrius//dtd metrius presentational//",
  "-//microsoft//dtd internet explorer 2.0 html strict//",
  "-//microsoft//dtd internet explorer 2.0 html//",
  "-//microsoft//dtd internet explorer 2.0 tables//",
  "-//microsoft//dtd internet explorer 3.0 html strict//",
  "-//microsoft//dtd internet explorer 3.0 html//",
  "-//microsoft//dtd internet explorer 3.0 tables//",
  "-//netscape comm. corp.//dtd html//",
  "-//netscape comm. corp.//dtd strict html//",
  "-//o'reilly and associates//dtd html 2.0//",
  "-//o'reilly and associates//dtd html extended 1.0//",
  "-//o'reilly and associates//dtd html extended relaxed 1.0//",
  "-//sq//dtd html 2.0 hotmetal + extensions//",
  "-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//",
  "-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//",
  "-//spyglass//dtd html 2.0 extended//",
  "-//sun microsystems corp.//dtd hotjava html//",
  "-//sun microsystems corp.//dtd hotjava strict html//",
  "-//w3c//dtd html 3 1995-03-24//",
  "-//w3c//dtd html 3.2 draft//",
  "-//w3c//dtd html 3.2 final//",
  "-//w3c//dtd html 3.2//",
  "-//w3c//dtd html 3.2s draft//",
  "-//w3c//dtd html 4.0 frameset//",
  "-//w3c//dtd html 4.0 transitional//",
  "-//w3c//dtd html experimental 19960712//",
  "-//w3c//dtd html experimental 970421//",
  "-//w3c//dtd w3 html//",
  "-//w3o//dtd w3 html 3.0//",
  "-//webtechs//dtd mozilla html 2.0//",
  "-//webtechs//dtd mozilla html//"
], EZ = [
  ...d5,
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
], vZ = /* @__PURE__ */ new Set([
  "-//w3o//dtd w3 html strict 3.0//en//",
  "-/w3c/dtd html 4.0 transitional/en",
  "html"
]), m5 = ["-//w3c//dtd xhtml 1.0 frameset//", "-//w3c//dtd xhtml 1.0 transitional//"], bZ = [
  ...m5,
  "-//w3c//dtd html 4.01 frameset//",
  "-//w3c//dtd html 4.01 transitional//"
];
function i3(e, t) {
  return t.some((i) => e.startsWith(i));
}
function CZ(e) {
  return e.name === u5 && e.publicId === null && (e.systemId === null || e.systemId === AZ);
}
function xZ(e) {
  if (e.name !== u5)
    return mo.QUIRKS;
  const { systemId: t } = e;
  if (t && t.toLowerCase() === yZ)
    return mo.QUIRKS;
  let { publicId: i } = e;
  if (i !== null) {
    if (i = i.toLowerCase(), vZ.has(i))
      return mo.QUIRKS;
    let r = t === null ? EZ : d5;
    if (i3(i, r))
      return mo.QUIRKS;
    if (r = t === null ? m5 : bZ, i3(i, r))
      return mo.LIMITED_QUIRKS;
  }
  return mo.NO_QUIRKS;
}
const r3 = {
  TEXT_HTML: "text/html",
  APPLICATION_XML: "application/xhtml+xml"
}, IZ = "definitionurl", SZ = "definitionURL", RZ = new Map([
  "attributeName",
  "attributeType",
  "baseFrequency",
  "baseProfile",
  "calcMode",
  "clipPathUnits",
  "diffuseConstant",
  "edgeMode",
  "filterUnits",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "kernelMatrix",
  "kernelUnitLength",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "limitingConeAngle",
  "markerHeight",
  "markerUnits",
  "markerWidth",
  "maskContentUnits",
  "maskUnits",
  "numOctaves",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "refX",
  "refY",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "specularConstant",
  "specularExponent",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stitchTiles",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textLength",
  "viewBox",
  "viewTarget",
  "xChannelSelector",
  "yChannelSelector",
  "zoomAndPan"
].map((e) => [e.toLowerCase(), e])), kZ = /* @__PURE__ */ new Map([
  ["xlink:actuate", { prefix: "xlink", name: "actuate", namespace: ke.XLINK }],
  ["xlink:arcrole", { prefix: "xlink", name: "arcrole", namespace: ke.XLINK }],
  ["xlink:href", { prefix: "xlink", name: "href", namespace: ke.XLINK }],
  ["xlink:role", { prefix: "xlink", name: "role", namespace: ke.XLINK }],
  ["xlink:show", { prefix: "xlink", name: "show", namespace: ke.XLINK }],
  ["xlink:title", { prefix: "xlink", name: "title", namespace: ke.XLINK }],
  ["xlink:type", { prefix: "xlink", name: "type", namespace: ke.XLINK }],
  ["xml:base", { prefix: "xml", name: "base", namespace: ke.XML }],
  ["xml:lang", { prefix: "xml", name: "lang", namespace: ke.XML }],
  ["xml:space", { prefix: "xml", name: "space", namespace: ke.XML }],
  ["xmlns", { prefix: "", name: "xmlns", namespace: ke.XMLNS }],
  ["xmlns:xlink", { prefix: "xmlns", name: "xlink", namespace: ke.XMLNS }]
]), wZ = new Map([
  "altGlyph",
  "altGlyphDef",
  "altGlyphItem",
  "animateColor",
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "glyphRef",
  "linearGradient",
  "radialGradient",
  "textPath"
].map((e) => [e.toLowerCase(), e])), MZ = /* @__PURE__ */ new Set([
  I.B,
  I.BIG,
  I.BLOCKQUOTE,
  I.BODY,
  I.BR,
  I.CENTER,
  I.CODE,
  I.DD,
  I.DIV,
  I.DL,
  I.DT,
  I.EM,
  I.EMBED,
  I.H1,
  I.H2,
  I.H3,
  I.H4,
  I.H5,
  I.H6,
  I.HEAD,
  I.HR,
  I.I,
  I.IMG,
  I.LI,
  I.LISTING,
  I.MENU,
  I.META,
  I.NOBR,
  I.OL,
  I.P,
  I.PRE,
  I.RUBY,
  I.S,
  I.SMALL,
  I.SPAN,
  I.STRONG,
  I.STRIKE,
  I.SUB,
  I.SUP,
  I.TABLE,
  I.TT,
  I.U,
  I.UL,
  I.VAR
]);
function NZ(e) {
  const t = e.tagID;
  return t === I.FONT && e.attrs.some(({ name: r }) => r === Cl.COLOR || r === Cl.SIZE || r === Cl.FACE) || MZ.has(t);
}
function g5(e) {
  for (let t = 0; t < e.attrs.length; t++)
    if (e.attrs[t].name === IZ) {
      e.attrs[t].name = SZ;
      break;
    }
}
function h5(e) {
  for (let t = 0; t < e.attrs.length; t++) {
    const i = RZ.get(e.attrs[t].name);
    i != null && (e.attrs[t].name = i);
  }
}
function l2(e) {
  for (let t = 0; t < e.attrs.length; t++) {
    const i = kZ.get(e.attrs[t].name);
    i && (e.attrs[t].prefix = i.prefix, e.attrs[t].name = i.name, e.attrs[t].namespace = i.namespace);
  }
}
function TZ(e) {
  const t = wZ.get(e.tagName);
  t != null && (e.tagName = t, e.tagID = af(e.tagName));
}
function BZ(e, t) {
  return t === ke.MATHML && (e === I.MI || e === I.MO || e === I.MN || e === I.MS || e === I.MTEXT);
}
function DZ(e, t, i) {
  if (t === ke.MATHML && e === I.ANNOTATION_XML) {
    for (let r = 0; r < i.length; r++)
      if (i[r].name === Cl.ENCODING) {
        const n = i[r].value.toLowerCase();
        return n === r3.TEXT_HTML || n === r3.APPLICATION_XML;
      }
  }
  return t === ke.SVG && (e === I.FOREIGN_OBJECT || e === I.DESC || e === I.TITLE);
}
function OZ(e, t, i, r) {
  return (!r || r === ke.HTML) && DZ(e, t, i) || (!r || r === ke.MATHML) && BZ(e, t);
}
const FZ = "hidden", VZ = 8, qZ = 3;
var ne;
(function(e) {
  e[e.INITIAL = 0] = "INITIAL", e[e.BEFORE_HTML = 1] = "BEFORE_HTML", e[e.BEFORE_HEAD = 2] = "BEFORE_HEAD", e[e.IN_HEAD = 3] = "IN_HEAD", e[e.IN_HEAD_NO_SCRIPT = 4] = "IN_HEAD_NO_SCRIPT", e[e.AFTER_HEAD = 5] = "AFTER_HEAD", e[e.IN_BODY = 6] = "IN_BODY", e[e.TEXT = 7] = "TEXT", e[e.IN_TABLE = 8] = "IN_TABLE", e[e.IN_TABLE_TEXT = 9] = "IN_TABLE_TEXT", e[e.IN_CAPTION = 10] = "IN_CAPTION", e[e.IN_COLUMN_GROUP = 11] = "IN_COLUMN_GROUP", e[e.IN_TABLE_BODY = 12] = "IN_TABLE_BODY", e[e.IN_ROW = 13] = "IN_ROW", e[e.IN_CELL = 14] = "IN_CELL", e[e.IN_SELECT = 15] = "IN_SELECT", e[e.IN_SELECT_IN_TABLE = 16] = "IN_SELECT_IN_TABLE", e[e.IN_TEMPLATE = 17] = "IN_TEMPLATE", e[e.AFTER_BODY = 18] = "AFTER_BODY", e[e.IN_FRAMESET = 19] = "IN_FRAMESET", e[e.AFTER_FRAMESET = 20] = "AFTER_FRAMESET", e[e.AFTER_AFTER_BODY = 21] = "AFTER_AFTER_BODY", e[e.AFTER_AFTER_FRAMESET = 22] = "AFTER_AFTER_FRAMESET";
})(ne || (ne = {}));
const jZ = {
  startLine: -1,
  startCol: -1,
  startOffset: -1,
  endLine: -1,
  endCol: -1,
  endOffset: -1
}, p5 = /* @__PURE__ */ new Set([I.TABLE, I.TBODY, I.TFOOT, I.THEAD, I.TR]), n3 = {
  scriptingEnabled: !0,
  sourceCodeLocationInfo: !1,
  treeAdapter: Ac,
  onParseError: null
};
let f5 = class {
  constructor(t, i, r = null, n = null) {
    this.fragmentContext = r, this.scriptHandler = n, this.currentToken = null, this.stopped = !1, this.insertionMode = ne.INITIAL, this.originalInsertionMode = ne.INITIAL, this.headElement = null, this.formElement = null, this.currentNotInHTML = !1, this.tmplInsertionModeStack = [], this.pendingCharacterTokens = [], this.hasNonWhitespacePendingCharacterToken = !1, this.framesetOk = !0, this.skipNextNewLine = !1, this.fosterParentingEnabled = !1, this.options = q(q({}, n3), t), this.treeAdapter = this.options.treeAdapter, this.onParseError = this.options.onParseError, this.onParseError && (this.options.sourceCodeLocationInfo = !0), this.document = i != null ? i : this.treeAdapter.createDocument(), this.tokenizer = new cZ(this.options, this), this.activeFormattingElements = new fZ(this.treeAdapter), this.fragmentContextID = r ? af(this.treeAdapter.getTagName(r)) : I.UNKNOWN, this._setContextModes(r != null ? r : this.document, this.fragmentContextID), this.openElements = new pZ(this.document, this.treeAdapter, this);
  }
  // API
  static parse(t, i) {
    const r = new this(i);
    return r.tokenizer.write(t, !0), r.document;
  }
  static getFragmentParser(t, i) {
    const r = q(q({}, n3), i);
    t != null || (t = r.treeAdapter.createElement(Ee.TEMPLATE, ke.HTML, []));
    const n = r.treeAdapter.createElement("documentmock", ke.HTML, []), o = new this(r, n, t);
    return o.fragmentContextID === I.TEMPLATE && o.tmplInsertionModeStack.unshift(ne.IN_TEMPLATE), o._initTokenizerForFragmentParsing(), o._insertFakeRootElement(), o._resetInsertionMode(), o._findFormInFragmentContext(), o;
  }
  getFragment() {
    const t = this.treeAdapter.getFirstChild(this.document), i = this.treeAdapter.createDocumentFragment();
    return this._adoptNodes(t, i), i;
  }
  //Errors
  _err(t, i, r) {
    var n;
    if (!this.onParseError)
      return;
    const o = (n = t.location) !== null && n !== void 0 ? n : jZ, s = {
      code: i,
      startLine: o.startLine,
      startCol: o.startCol,
      startOffset: o.startOffset,
      endLine: r ? o.startLine : o.endLine,
      endCol: r ? o.startCol : o.endCol,
      endOffset: r ? o.startOffset : o.endOffset
    };
    this.onParseError(s);
  }
  //Stack events
  onItemPush(t, i, r) {
    var n, o;
    (o = (n = this.treeAdapter).onItemPush) === null || o === void 0 || o.call(n, t), r && this.openElements.stackTop > 0 && this._setContextModes(t, i);
  }
  onItemPop(t, i) {
    var r, n;
    if (this.options.sourceCodeLocationInfo && this._setEndLocation(t, this.currentToken), (n = (r = this.treeAdapter).onItemPop) === null || n === void 0 || n.call(r, t, this.openElements.current), i) {
      let o, s;
      this.openElements.stackTop === 0 && this.fragmentContext ? (o = this.fragmentContext, s = this.fragmentContextID) : { current: o, currentTagId: s } = this.openElements, this._setContextModes(o, s);
    }
  }
  _setContextModes(t, i) {
    const r = t === this.document || this.treeAdapter.getNamespaceURI(t) === ke.HTML;
    this.currentNotInHTML = !r, this.tokenizer.inForeignNode = !r && !this._isIntegrationPoint(i, t);
  }
  _switchToTextParsing(t, i) {
    this._insertElement(t, ke.HTML), this.tokenizer.state = i, this.originalInsertionMode = this.insertionMode, this.insertionMode = ne.TEXT;
  }
  switchToPlaintextParsing() {
    this.insertionMode = ne.TEXT, this.originalInsertionMode = ne.IN_BODY, this.tokenizer.state = Wn.PLAINTEXT;
  }
  //Fragment parsing
  _getAdjustedCurrentElement() {
    return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
  }
  _findFormInFragmentContext() {
    let t = this.fragmentContext;
    for (; t; ) {
      if (this.treeAdapter.getTagName(t) === Ee.FORM) {
        this.formElement = t;
        break;
      }
      t = this.treeAdapter.getParentNode(t);
    }
  }
  _initTokenizerForFragmentParsing() {
    if (!(!this.fragmentContext || this.treeAdapter.getNamespaceURI(this.fragmentContext) !== ke.HTML))
      switch (this.fragmentContextID) {
        case I.TITLE:
        case I.TEXTAREA: {
          this.tokenizer.state = Wn.RCDATA;
          break;
        }
        case I.STYLE:
        case I.XMP:
        case I.IFRAME:
        case I.NOEMBED:
        case I.NOFRAMES:
        case I.NOSCRIPT: {
          this.tokenizer.state = Wn.RAWTEXT;
          break;
        }
        case I.SCRIPT: {
          this.tokenizer.state = Wn.SCRIPT_DATA;
          break;
        }
        case I.PLAINTEXT: {
          this.tokenizer.state = Wn.PLAINTEXT;
          break;
        }
      }
  }
  //Tree mutation
  _setDocumentType(t) {
    const i = t.name || "", r = t.publicId || "", n = t.systemId || "";
    if (this.treeAdapter.setDocumentType(this.document, i, r, n), t.location) {
      const s = this.treeAdapter.getChildNodes(this.document).find((a) => this.treeAdapter.isDocumentTypeNode(a));
      s && this.treeAdapter.setNodeSourceCodeLocation(s, t.location);
    }
  }
  _attachElementToTree(t, i) {
    if (this.options.sourceCodeLocationInfo) {
      const r = i && ee(q({}, i), {
        startTag: i
      });
      this.treeAdapter.setNodeSourceCodeLocation(t, r);
    }
    if (this._shouldFosterParentOnInsertion())
      this._fosterParentElement(t);
    else {
      const r = this.openElements.currentTmplContentOrNode;
      this.treeAdapter.appendChild(r, t);
    }
  }
  _appendElement(t, i) {
    const r = this.treeAdapter.createElement(t.tagName, i, t.attrs);
    this._attachElementToTree(r, t.location);
  }
  _insertElement(t, i) {
    const r = this.treeAdapter.createElement(t.tagName, i, t.attrs);
    this._attachElementToTree(r, t.location), this.openElements.push(r, t.tagID);
  }
  _insertFakeElement(t, i) {
    const r = this.treeAdapter.createElement(t, ke.HTML, []);
    this._attachElementToTree(r, null), this.openElements.push(r, i);
  }
  _insertTemplate(t) {
    const i = this.treeAdapter.createElement(t.tagName, ke.HTML, t.attrs), r = this.treeAdapter.createDocumentFragment();
    this.treeAdapter.setTemplateContent(i, r), this._attachElementToTree(i, t.location), this.openElements.push(i, t.tagID), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(r, null);
  }
  _insertFakeRootElement() {
    const t = this.treeAdapter.createElement(Ee.HTML, ke.HTML, []);
    this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(t, null), this.treeAdapter.appendChild(this.openElements.current, t), this.openElements.push(t, I.HTML);
  }
  _appendCommentNode(t, i) {
    const r = this.treeAdapter.createCommentNode(t.data);
    this.treeAdapter.appendChild(i, r), this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(r, t.location);
  }
  _insertCharacters(t) {
    let i, r;
    if (this._shouldFosterParentOnInsertion() ? ({ parent: i, beforeElement: r } = this._findFosterParentingLocation(), r ? this.treeAdapter.insertTextBefore(i, t.chars, r) : this.treeAdapter.insertText(i, t.chars)) : (i = this.openElements.currentTmplContentOrNode, this.treeAdapter.insertText(i, t.chars)), !t.location)
      return;
    const n = this.treeAdapter.getChildNodes(i), o = r ? n.lastIndexOf(r) : n.length, s = n[o - 1];
    if (this.treeAdapter.getNodeSourceCodeLocation(s)) {
      const { endLine: l, endCol: c, endOffset: u } = t.location;
      this.treeAdapter.updateNodeSourceCodeLocation(s, { endLine: l, endCol: c, endOffset: u });
    } else
      this.options.sourceCodeLocationInfo && this.treeAdapter.setNodeSourceCodeLocation(s, t.location);
  }
  _adoptNodes(t, i) {
    for (let r = this.treeAdapter.getFirstChild(t); r; r = this.treeAdapter.getFirstChild(t))
      this.treeAdapter.detachNode(r), this.treeAdapter.appendChild(i, r);
  }
  _setEndLocation(t, i) {
    if (this.treeAdapter.getNodeSourceCodeLocation(t) && i.location) {
      const r = i.location, n = this.treeAdapter.getTagName(t), o = (
        // NOTE: For cases like <p> <p> </p> - First 'p' closes without a closing
        // tag and for cases like <td> <p> </td> - 'p' closes without a closing tag.
        i.type === Xt.END_TAG && n === i.tagName ? {
          endTag: q({}, r),
          endLine: r.endLine,
          endCol: r.endCol,
          endOffset: r.endOffset
        } : {
          endLine: r.startLine,
          endCol: r.startCol,
          endOffset: r.startOffset
        }
      );
      this.treeAdapter.updateNodeSourceCodeLocation(t, o);
    }
  }
  //Token processing
  shouldProcessStartTagTokenInForeignContent(t) {
    if (!this.currentNotInHTML)
      return !1;
    let i, r;
    return this.openElements.stackTop === 0 && this.fragmentContext ? (i = this.fragmentContext, r = this.fragmentContextID) : { current: i, currentTagId: r } = this.openElements, t.tagID === I.SVG && this.treeAdapter.getTagName(i) === Ee.ANNOTATION_XML && this.treeAdapter.getNamespaceURI(i) === ke.MATHML ? !1 : (
      // Check that `current` is not an integration point for HTML or MathML elements.
      this.tokenizer.inForeignNode || // If it _is_ an integration point, then we might have to check that it is not an HTML
      // integration point.
      (t.tagID === I.MGLYPH || t.tagID === I.MALIGNMARK) && !this._isIntegrationPoint(r, i, ke.HTML)
    );
  }
  _processToken(t) {
    switch (t.type) {
      case Xt.CHARACTER: {
        this.onCharacter(t);
        break;
      }
      case Xt.NULL_CHARACTER: {
        this.onNullCharacter(t);
        break;
      }
      case Xt.COMMENT: {
        this.onComment(t);
        break;
      }
      case Xt.DOCTYPE: {
        this.onDoctype(t);
        break;
      }
      case Xt.START_TAG: {
        this._processStartTag(t);
        break;
      }
      case Xt.END_TAG: {
        this.onEndTag(t);
        break;
      }
      case Xt.EOF: {
        this.onEof(t);
        break;
      }
      case Xt.WHITESPACE_CHARACTER: {
        this.onWhitespaceCharacter(t);
        break;
      }
    }
  }
  //Integration points
  _isIntegrationPoint(t, i, r) {
    const n = this.treeAdapter.getNamespaceURI(i), o = this.treeAdapter.getAttrList(i);
    return OZ(t, n, o, r);
  }
  //Active formatting elements reconstruction
  _reconstructActiveFormattingElements() {
    const t = this.activeFormattingElements.entries.length;
    if (t) {
      const i = this.activeFormattingElements.entries.findIndex((n) => n.type === ls.Marker || this.openElements.contains(n.element)), r = i < 0 ? t - 1 : i - 1;
      for (let n = r; n >= 0; n--) {
        const o = this.activeFormattingElements.entries[n];
        this._insertElement(o.token, this.treeAdapter.getNamespaceURI(o.element)), o.element = this.openElements.current;
      }
    }
  }
  //Close elements
  _closeTableCell() {
    this.openElements.generateImpliedEndTags(), this.openElements.popUntilTableCellPopped(), this.activeFormattingElements.clearToLastMarker(), this.insertionMode = ne.IN_ROW;
  }
  _closePElement() {
    this.openElements.generateImpliedEndTagsWithExclusion(I.P), this.openElements.popUntilTagNamePopped(I.P);
  }
  //Insertion modes
  _resetInsertionMode() {
    for (let t = this.openElements.stackTop; t >= 0; t--)
      switch (t === 0 && this.fragmentContext ? this.fragmentContextID : this.openElements.tagIDs[t]) {
        case I.TR: {
          this.insertionMode = ne.IN_ROW;
          return;
        }
        case I.TBODY:
        case I.THEAD:
        case I.TFOOT: {
          this.insertionMode = ne.IN_TABLE_BODY;
          return;
        }
        case I.CAPTION: {
          this.insertionMode = ne.IN_CAPTION;
          return;
        }
        case I.COLGROUP: {
          this.insertionMode = ne.IN_COLUMN_GROUP;
          return;
        }
        case I.TABLE: {
          this.insertionMode = ne.IN_TABLE;
          return;
        }
        case I.BODY: {
          this.insertionMode = ne.IN_BODY;
          return;
        }
        case I.FRAMESET: {
          this.insertionMode = ne.IN_FRAMESET;
          return;
        }
        case I.SELECT: {
          this._resetInsertionModeForSelect(t);
          return;
        }
        case I.TEMPLATE: {
          this.insertionMode = this.tmplInsertionModeStack[0];
          return;
        }
        case I.HTML: {
          this.insertionMode = this.headElement ? ne.AFTER_HEAD : ne.BEFORE_HEAD;
          return;
        }
        case I.TD:
        case I.TH: {
          if (t > 0) {
            this.insertionMode = ne.IN_CELL;
            return;
          }
          break;
        }
        case I.HEAD: {
          if (t > 0) {
            this.insertionMode = ne.IN_HEAD;
            return;
          }
          break;
        }
      }
    this.insertionMode = ne.IN_BODY;
  }
  _resetInsertionModeForSelect(t) {
    if (t > 0)
      for (let i = t - 1; i > 0; i--) {
        const r = this.openElements.tagIDs[i];
        if (r === I.TEMPLATE)
          break;
        if (r === I.TABLE) {
          this.insertionMode = ne.IN_SELECT_IN_TABLE;
          return;
        }
      }
    this.insertionMode = ne.IN_SELECT;
  }
  //Foster parenting
  _isElementCausesFosterParenting(t) {
    return p5.has(t);
  }
  _shouldFosterParentOnInsertion() {
    return this.fosterParentingEnabled && this._isElementCausesFosterParenting(this.openElements.currentTagId);
  }
  _findFosterParentingLocation() {
    for (let t = this.openElements.stackTop; t >= 0; t--) {
      const i = this.openElements.items[t];
      switch (this.openElements.tagIDs[t]) {
        case I.TEMPLATE: {
          if (this.treeAdapter.getNamespaceURI(i) === ke.HTML)
            return { parent: this.treeAdapter.getTemplateContent(i), beforeElement: null };
          break;
        }
        case I.TABLE: {
          const r = this.treeAdapter.getParentNode(i);
          return r ? { parent: r, beforeElement: i } : { parent: this.openElements.items[t - 1], beforeElement: null };
        }
      }
    }
    return { parent: this.openElements.items[0], beforeElement: null };
  }
  _fosterParentElement(t) {
    const i = this._findFosterParentingLocation();
    i.beforeElement ? this.treeAdapter.insertBefore(i.parent, t, i.beforeElement) : this.treeAdapter.appendChild(i.parent, t);
  }
  //Special elements
  _isSpecialElement(t, i) {
    const r = this.treeAdapter.getNamespaceURI(t);
    return iZ[r].has(i);
  }
  onCharacter(t) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      hP(this, t);
      return;
    }
    switch (this.insertionMode) {
      case ne.INITIAL: {
        Id(this, t);
        break;
      }
      case ne.BEFORE_HTML: {
        dm(this, t);
        break;
      }
      case ne.BEFORE_HEAD: {
        mm(this, t);
        break;
      }
      case ne.IN_HEAD: {
        gm(this, t);
        break;
      }
      case ne.IN_HEAD_NO_SCRIPT: {
        hm(this, t);
        break;
      }
      case ne.AFTER_HEAD: {
        pm(this, t);
        break;
      }
      case ne.IN_BODY:
      case ne.IN_CAPTION:
      case ne.IN_CELL:
      case ne.IN_TEMPLATE: {
        y5(this, t);
        break;
      }
      case ne.TEXT:
      case ne.IN_SELECT:
      case ne.IN_SELECT_IN_TABLE: {
        this._insertCharacters(t);
        break;
      }
      case ne.IN_TABLE:
      case ne.IN_TABLE_BODY:
      case ne.IN_ROW: {
        Yy(this, t);
        break;
      }
      case ne.IN_TABLE_TEXT: {
        I5(this, t);
        break;
      }
      case ne.IN_COLUMN_GROUP: {
        h1(this, t);
        break;
      }
      case ne.AFTER_BODY: {
        p1(this, t);
        break;
      }
      case ne.AFTER_AFTER_BODY: {
        Lp(this, t);
        break;
      }
    }
  }
  onNullCharacter(t) {
    if (this.skipNextNewLine = !1, this.tokenizer.inForeignNode) {
      gP(this, t);
      return;
    }
    switch (this.insertionMode) {
      case ne.INITIAL: {
        Id(this, t);
        break;
      }
      case ne.BEFORE_HTML: {
        dm(this, t);
        break;
      }
      case ne.BEFORE_HEAD: {
        mm(this, t);
        break;
      }
      case ne.IN_HEAD: {
        gm(this, t);
        break;
      }
      case ne.IN_HEAD_NO_SCRIPT: {
        hm(this, t);
        break;
      }
      case ne.AFTER_HEAD: {
        pm(this, t);
        break;
      }
      case ne.TEXT: {
        this._insertCharacters(t);
        break;
      }
      case ne.IN_TABLE:
      case ne.IN_TABLE_BODY:
      case ne.IN_ROW: {
        Yy(this, t);
        break;
      }
      case ne.IN_COLUMN_GROUP: {
        h1(this, t);
        break;
      }
      case ne.AFTER_BODY: {
        p1(this, t);
        break;
      }
      case ne.AFTER_AFTER_BODY: {
        Lp(this, t);
        break;
      }
    }
  }
  onComment(t) {
    if (this.skipNextNewLine = !1, this.currentNotInHTML) {
      Eb(this, t);
      return;
    }
    switch (this.insertionMode) {
      case ne.INITIAL:
      case ne.BEFORE_HTML:
      case ne.BEFORE_HEAD:
      case ne.IN_HEAD:
      case ne.IN_HEAD_NO_SCRIPT:
      case ne.AFTER_HEAD:
      case ne.IN_BODY:
      case ne.IN_TABLE:
      case ne.IN_CAPTION:
      case ne.IN_COLUMN_GROUP:
      case ne.IN_TABLE_BODY:
      case ne.IN_ROW:
      case ne.IN_CELL:
      case ne.IN_SELECT:
      case ne.IN_SELECT_IN_TABLE:
      case ne.IN_TEMPLATE:
      case ne.IN_FRAMESET:
      case ne.AFTER_FRAMESET: {
        Eb(this, t);
        break;
      }
      case ne.IN_TABLE_TEXT: {
        Sd(this, t);
        break;
      }
      case ne.AFTER_BODY: {
        WZ(this, t);
        break;
      }
      case ne.AFTER_AFTER_BODY:
      case ne.AFTER_AFTER_FRAMESET: {
        ZZ(this, t);
        break;
      }
    }
  }
  onDoctype(t) {
    switch (this.skipNextNewLine = !1, this.insertionMode) {
      case ne.INITIAL: {
        JZ(this, t);
        break;
      }
      case ne.BEFORE_HEAD:
      case ne.IN_HEAD:
      case ne.IN_HEAD_NO_SCRIPT:
      case ne.AFTER_HEAD: {
        this._err(t, Se.misplacedDoctype);
        break;
      }
      case ne.IN_TABLE_TEXT: {
        Sd(this, t);
        break;
      }
    }
  }
  onStartTag(t) {
    this.skipNextNewLine = !1, this.currentToken = t, this._processStartTag(t), t.selfClosing && !t.ackSelfClosing && this._err(t, Se.nonVoidHtmlElementStartTagWithTrailingSolidus);
  }
  /**
   * Processes a given start tag.
   *
   * `onStartTag` checks if a self-closing tag was recognized. When a token
   * is moved inbetween multiple insertion modes, this check for self-closing
   * could lead to false positives. To avoid this, `_processStartTag` is used
   * for nested calls.
   *
   * @param token The token to process.
   */
  _processStartTag(t) {
    this.shouldProcessStartTagTokenInForeignContent(t) ? pP(this, t) : this._startTagOutsideForeignContent(t);
  }
  _startTagOutsideForeignContent(t) {
    switch (this.insertionMode) {
      case ne.INITIAL: {
        Id(this, t);
        break;
      }
      case ne.BEFORE_HTML: {
        PZ(this, t);
        break;
      }
      case ne.BEFORE_HEAD: {
        HZ(this, t);
        break;
      }
      case ne.IN_HEAD: {
        fs(this, t);
        break;
      }
      case ne.IN_HEAD_NO_SCRIPT: {
        $Z(this, t);
        break;
      }
      case ne.AFTER_HEAD: {
        tJ(this, t);
        break;
      }
      case ne.IN_BODY: {
        an(this, t);
        break;
      }
      case ne.IN_TABLE: {
        m0(this, t);
        break;
      }
      case ne.IN_TABLE_TEXT: {
        Sd(this, t);
        break;
      }
      case ne.IN_CAPTION: {
        XJ(this, t);
        break;
      }
      case ne.IN_COLUMN_GROUP: {
        d2(this, t);
        break;
      }
      case ne.IN_TABLE_BODY: {
        uf(this, t);
        break;
      }
      case ne.IN_ROW: {
        df(this, t);
        break;
      }
      case ne.IN_CELL: {
        eP(this, t);
        break;
      }
      case ne.IN_SELECT: {
        k5(this, t);
        break;
      }
      case ne.IN_SELECT_IN_TABLE: {
        iP(this, t);
        break;
      }
      case ne.IN_TEMPLATE: {
        nP(this, t);
        break;
      }
      case ne.AFTER_BODY: {
        sP(this, t);
        break;
      }
      case ne.IN_FRAMESET: {
        aP(this, t);
        break;
      }
      case ne.AFTER_FRAMESET: {
        cP(this, t);
        break;
      }
      case ne.AFTER_AFTER_BODY: {
        dP(this, t);
        break;
      }
      case ne.AFTER_AFTER_FRAMESET: {
        mP(this, t);
        break;
      }
    }
  }
  onEndTag(t) {
    this.skipNextNewLine = !1, this.currentToken = t, this.currentNotInHTML ? fP(this, t) : this._endTagOutsideForeignContent(t);
  }
  _endTagOutsideForeignContent(t) {
    switch (this.insertionMode) {
      case ne.INITIAL: {
        Id(this, t);
        break;
      }
      case ne.BEFORE_HTML: {
        zZ(this, t);
        break;
      }
      case ne.BEFORE_HEAD: {
        XZ(this, t);
        break;
      }
      case ne.IN_HEAD: {
        _Z(this, t);
        break;
      }
      case ne.IN_HEAD_NO_SCRIPT: {
        eJ(this, t);
        break;
      }
      case ne.AFTER_HEAD: {
        iJ(this, t);
        break;
      }
      case ne.IN_BODY: {
        cf(this, t);
        break;
      }
      case ne.TEXT: {
        YJ(this, t);
        break;
      }
      case ne.IN_TABLE: {
        Km(this, t);
        break;
      }
      case ne.IN_TABLE_TEXT: {
        Sd(this, t);
        break;
      }
      case ne.IN_CAPTION: {
        _J(this, t);
        break;
      }
      case ne.IN_COLUMN_GROUP: {
        $J(this, t);
        break;
      }
      case ne.IN_TABLE_BODY: {
        vb(this, t);
        break;
      }
      case ne.IN_ROW: {
        R5(this, t);
        break;
      }
      case ne.IN_CELL: {
        tP(this, t);
        break;
      }
      case ne.IN_SELECT: {
        w5(this, t);
        break;
      }
      case ne.IN_SELECT_IN_TABLE: {
        rP(this, t);
        break;
      }
      case ne.IN_TEMPLATE: {
        oP(this, t);
        break;
      }
      case ne.AFTER_BODY: {
        N5(this, t);
        break;
      }
      case ne.IN_FRAMESET: {
        lP(this, t);
        break;
      }
      case ne.AFTER_FRAMESET: {
        uP(this, t);
        break;
      }
      case ne.AFTER_AFTER_BODY: {
        Lp(this, t);
        break;
      }
    }
  }
  onEof(t) {
    switch (this.insertionMode) {
      case ne.INITIAL: {
        Id(this, t);
        break;
      }
      case ne.BEFORE_HTML: {
        dm(this, t);
        break;
      }
      case ne.BEFORE_HEAD: {
        mm(this, t);
        break;
      }
      case ne.IN_HEAD: {
        gm(this, t);
        break;
      }
      case ne.IN_HEAD_NO_SCRIPT: {
        hm(this, t);
        break;
      }
      case ne.AFTER_HEAD: {
        pm(this, t);
        break;
      }
      case ne.IN_BODY:
      case ne.IN_TABLE:
      case ne.IN_CAPTION:
      case ne.IN_COLUMN_GROUP:
      case ne.IN_TABLE_BODY:
      case ne.IN_ROW:
      case ne.IN_CELL:
      case ne.IN_SELECT:
      case ne.IN_SELECT_IN_TABLE: {
        C5(this, t);
        break;
      }
      case ne.TEXT: {
        UJ(this, t);
        break;
      }
      case ne.IN_TABLE_TEXT: {
        Sd(this, t);
        break;
      }
      case ne.IN_TEMPLATE: {
        M5(this, t);
        break;
      }
      case ne.AFTER_BODY:
      case ne.IN_FRAMESET:
      case ne.AFTER_FRAMESET:
      case ne.AFTER_AFTER_BODY:
      case ne.AFTER_AFTER_FRAMESET: {
        u2(this, t);
        break;
      }
    }
  }
  onWhitespaceCharacter(t) {
    if (this.skipNextNewLine && (this.skipNextNewLine = !1, t.chars.charCodeAt(0) === J.LINE_FEED)) {
      if (t.chars.length === 1)
        return;
      t.chars = t.chars.substr(1);
    }
    if (this.tokenizer.inForeignNode) {
      this._insertCharacters(t);
      return;
    }
    switch (this.insertionMode) {
      case ne.IN_HEAD:
      case ne.IN_HEAD_NO_SCRIPT:
      case ne.AFTER_HEAD:
      case ne.TEXT:
      case ne.IN_COLUMN_GROUP:
      case ne.IN_SELECT:
      case ne.IN_SELECT_IN_TABLE:
      case ne.IN_FRAMESET:
      case ne.AFTER_FRAMESET: {
        this._insertCharacters(t);
        break;
      }
      case ne.IN_BODY:
      case ne.IN_CAPTION:
      case ne.IN_CELL:
      case ne.IN_TEMPLATE:
      case ne.AFTER_BODY:
      case ne.AFTER_AFTER_BODY:
      case ne.AFTER_AFTER_FRAMESET: {
        A5(this, t);
        break;
      }
      case ne.IN_TABLE:
      case ne.IN_TABLE_BODY:
      case ne.IN_ROW: {
        Yy(this, t);
        break;
      }
      case ne.IN_TABLE_TEXT: {
        x5(this, t);
        break;
      }
    }
  }
};
function LZ(e, t) {
  let i = e.activeFormattingElements.getElementEntryInScopeWithTagName(t.tagName);
  return i ? e.openElements.contains(i.element) ? e.openElements.hasInScope(t.tagID) || (i = null) : (e.activeFormattingElements.removeEntry(i), i = null) : b5(e, t), i;
}
function KZ(e, t) {
  let i = null, r = e.openElements.stackTop;
  for (; r >= 0; r--) {
    const n = e.openElements.items[r];
    if (n === t.element)
      break;
    e._isSpecialElement(n, e.openElements.tagIDs[r]) && (i = n);
  }
  return i || (e.openElements.shortenToLength(r < 0 ? 0 : r), e.activeFormattingElements.removeEntry(t)), i;
}
function YZ(e, t, i) {
  let r = t, n = e.openElements.getCommonAncestor(t);
  for (let o = 0, s = n; s !== i; o++, s = n) {
    n = e.openElements.getCommonAncestor(s);
    const a = e.activeFormattingElements.getElementEntry(s), l = a && o >= qZ;
    !a || l ? (l && e.activeFormattingElements.removeEntry(a), e.openElements.remove(s)) : (s = UZ(e, a), r === t && (e.activeFormattingElements.bookmark = a), e.treeAdapter.detachNode(r), e.treeAdapter.appendChild(s, r), r = s);
  }
  return r;
}
function UZ(e, t) {
  const i = e.treeAdapter.getNamespaceURI(t.element), r = e.treeAdapter.createElement(t.token.tagName, i, t.token.attrs);
  return e.openElements.replace(t.element, r), t.element = r, r;
}
function GZ(e, t, i) {
  const r = e.treeAdapter.getTagName(t), n = af(r);
  if (e._isElementCausesFosterParenting(n))
    e._fosterParentElement(i);
  else {
    const o = e.treeAdapter.getNamespaceURI(t);
    n === I.TEMPLATE && o === ke.HTML && (t = e.treeAdapter.getTemplateContent(t)), e.treeAdapter.appendChild(t, i);
  }
}
function QZ(e, t, i) {
  const r = e.treeAdapter.getNamespaceURI(i.element), { token: n } = i, o = e.treeAdapter.createElement(n.tagName, r, n.attrs);
  e._adoptNodes(t, o), e.treeAdapter.appendChild(t, o), e.activeFormattingElements.insertElementAfterBookmark(o, n), e.activeFormattingElements.removeEntry(i), e.openElements.remove(i.element), e.openElements.insertAfter(t, o, n.tagID);
}
function c2(e, t) {
  for (let i = 0; i < VZ; i++) {
    const r = LZ(e, t);
    if (!r)
      break;
    const n = KZ(e, r);
    if (!n)
      break;
    e.activeFormattingElements.bookmark = r;
    const o = YZ(e, n, r.element), s = e.openElements.getCommonAncestor(r.element);
    e.treeAdapter.detachNode(o), s && GZ(e, s, o), QZ(e, n, r);
  }
}
function Eb(e, t) {
  e._appendCommentNode(t, e.openElements.currentTmplContentOrNode);
}
function WZ(e, t) {
  e._appendCommentNode(t, e.openElements.items[0]);
}
function ZZ(e, t) {
  e._appendCommentNode(t, e.document);
}
function u2(e, t) {
  if (e.stopped = !0, t.location) {
    const i = e.fragmentContext ? 0 : 2;
    for (let r = e.openElements.stackTop; r >= i; r--)
      e._setEndLocation(e.openElements.items[r], t);
    if (!e.fragmentContext && e.openElements.stackTop >= 0) {
      const r = e.openElements.items[0], n = e.treeAdapter.getNodeSourceCodeLocation(r);
      if (n && !n.endTag && (e._setEndLocation(r, t), e.openElements.stackTop >= 1)) {
        const o = e.openElements.items[1], s = e.treeAdapter.getNodeSourceCodeLocation(o);
        s && !s.endTag && e._setEndLocation(o, t);
      }
    }
  }
}
function JZ(e, t) {
  e._setDocumentType(t);
  const i = t.forceQuirks ? mo.QUIRKS : xZ(t);
  CZ(t) || e._err(t, Se.nonConformingDoctype), e.treeAdapter.setDocumentMode(e.document, i), e.insertionMode = ne.BEFORE_HTML;
}
function Id(e, t) {
  e._err(t, Se.missingDoctype, !0), e.treeAdapter.setDocumentMode(e.document, mo.QUIRKS), e.insertionMode = ne.BEFORE_HTML, e._processToken(t);
}
function PZ(e, t) {
  t.tagID === I.HTML ? (e._insertElement(t, ke.HTML), e.insertionMode = ne.BEFORE_HEAD) : dm(e, t);
}
function zZ(e, t) {
  const i = t.tagID;
  (i === I.HTML || i === I.HEAD || i === I.BODY || i === I.BR) && dm(e, t);
}
function dm(e, t) {
  e._insertFakeRootElement(), e.insertionMode = ne.BEFORE_HEAD, e._processToken(t);
}
function HZ(e, t) {
  switch (t.tagID) {
    case I.HTML: {
      an(e, t);
      break;
    }
    case I.HEAD: {
      e._insertElement(t, ke.HTML), e.headElement = e.openElements.current, e.insertionMode = ne.IN_HEAD;
      break;
    }
    default:
      mm(e, t);
  }
}
function XZ(e, t) {
  const i = t.tagID;
  i === I.HEAD || i === I.BODY || i === I.HTML || i === I.BR ? mm(e, t) : e._err(t, Se.endTagWithoutMatchingOpenElement);
}
function mm(e, t) {
  e._insertFakeElement(Ee.HEAD, I.HEAD), e.headElement = e.openElements.current, e.insertionMode = ne.IN_HEAD, e._processToken(t);
}
function fs(e, t) {
  switch (t.tagID) {
    case I.HTML: {
      an(e, t);
      break;
    }
    case I.BASE:
    case I.BASEFONT:
    case I.BGSOUND:
    case I.LINK:
    case I.META: {
      e._appendElement(t, ke.HTML), t.ackSelfClosing = !0;
      break;
    }
    case I.TITLE: {
      e._switchToTextParsing(t, Wn.RCDATA);
      break;
    }
    case I.NOSCRIPT: {
      e.options.scriptingEnabled ? e._switchToTextParsing(t, Wn.RAWTEXT) : (e._insertElement(t, ke.HTML), e.insertionMode = ne.IN_HEAD_NO_SCRIPT);
      break;
    }
    case I.NOFRAMES:
    case I.STYLE: {
      e._switchToTextParsing(t, Wn.RAWTEXT);
      break;
    }
    case I.SCRIPT: {
      e._switchToTextParsing(t, Wn.SCRIPT_DATA);
      break;
    }
    case I.TEMPLATE: {
      e._insertTemplate(t), e.activeFormattingElements.insertMarker(), e.framesetOk = !1, e.insertionMode = ne.IN_TEMPLATE, e.tmplInsertionModeStack.unshift(ne.IN_TEMPLATE);
      break;
    }
    case I.HEAD: {
      e._err(t, Se.misplacedStartTagForHeadElement);
      break;
    }
    default:
      gm(e, t);
  }
}
function _Z(e, t) {
  switch (t.tagID) {
    case I.HEAD: {
      e.openElements.pop(), e.insertionMode = ne.AFTER_HEAD;
      break;
    }
    case I.BODY:
    case I.BR:
    case I.HTML: {
      gm(e, t);
      break;
    }
    case I.TEMPLATE: {
      tu(e, t);
      break;
    }
    default:
      e._err(t, Se.endTagWithoutMatchingOpenElement);
  }
}
function tu(e, t) {
  e.openElements.tmplCount > 0 ? (e.openElements.generateImpliedEndTagsThoroughly(), e.openElements.currentTagId !== I.TEMPLATE && e._err(t, Se.closingOfElementWithOpenChildElements), e.openElements.popUntilTagNamePopped(I.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e.tmplInsertionModeStack.shift(), e._resetInsertionMode()) : e._err(t, Se.endTagWithoutMatchingOpenElement);
}
function gm(e, t) {
  e.openElements.pop(), e.insertionMode = ne.AFTER_HEAD, e._processToken(t);
}
function $Z(e, t) {
  switch (t.tagID) {
    case I.HTML: {
      an(e, t);
      break;
    }
    case I.BASEFONT:
    case I.BGSOUND:
    case I.HEAD:
    case I.LINK:
    case I.META:
    case I.NOFRAMES:
    case I.STYLE: {
      fs(e, t);
      break;
    }
    case I.NOSCRIPT: {
      e._err(t, Se.nestedNoscriptInHead);
      break;
    }
    default:
      hm(e, t);
  }
}
function eJ(e, t) {
  switch (t.tagID) {
    case I.NOSCRIPT: {
      e.openElements.pop(), e.insertionMode = ne.IN_HEAD;
      break;
    }
    case I.BR: {
      hm(e, t);
      break;
    }
    default:
      e._err(t, Se.endTagWithoutMatchingOpenElement);
  }
}
function hm(e, t) {
  const i = t.type === Xt.EOF ? Se.openElementsLeftAfterEof : Se.disallowedContentInNoscriptInHead;
  e._err(t, i), e.openElements.pop(), e.insertionMode = ne.IN_HEAD, e._processToken(t);
}
function tJ(e, t) {
  switch (t.tagID) {
    case I.HTML: {
      an(e, t);
      break;
    }
    case I.BODY: {
      e._insertElement(t, ke.HTML), e.framesetOk = !1, e.insertionMode = ne.IN_BODY;
      break;
    }
    case I.FRAMESET: {
      e._insertElement(t, ke.HTML), e.insertionMode = ne.IN_FRAMESET;
      break;
    }
    case I.BASE:
    case I.BASEFONT:
    case I.BGSOUND:
    case I.LINK:
    case I.META:
    case I.NOFRAMES:
    case I.SCRIPT:
    case I.STYLE:
    case I.TEMPLATE:
    case I.TITLE: {
      e._err(t, Se.abandonedHeadElementChild), e.openElements.push(e.headElement, I.HEAD), fs(e, t), e.openElements.remove(e.headElement);
      break;
    }
    case I.HEAD: {
      e._err(t, Se.misplacedStartTagForHeadElement);
      break;
    }
    default:
      pm(e, t);
  }
}
function iJ(e, t) {
  switch (t.tagID) {
    case I.BODY:
    case I.HTML:
    case I.BR: {
      pm(e, t);
      break;
    }
    case I.TEMPLATE: {
      tu(e, t);
      break;
    }
    default:
      e._err(t, Se.endTagWithoutMatchingOpenElement);
  }
}
function pm(e, t) {
  e._insertFakeElement(Ee.BODY, I.BODY), e.insertionMode = ne.IN_BODY, lf(e, t);
}
function lf(e, t) {
  switch (t.type) {
    case Xt.CHARACTER: {
      y5(e, t);
      break;
    }
    case Xt.WHITESPACE_CHARACTER: {
      A5(e, t);
      break;
    }
    case Xt.COMMENT: {
      Eb(e, t);
      break;
    }
    case Xt.START_TAG: {
      an(e, t);
      break;
    }
    case Xt.END_TAG: {
      cf(e, t);
      break;
    }
    case Xt.EOF: {
      C5(e, t);
      break;
    }
  }
}
function A5(e, t) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(t);
}
function y5(e, t) {
  e._reconstructActiveFormattingElements(), e._insertCharacters(t), e.framesetOk = !1;
}
function rJ(e, t) {
  e.openElements.tmplCount === 0 && e.treeAdapter.adoptAttributes(e.openElements.items[0], t.attrs);
}
function nJ(e, t) {
  const i = e.openElements.tryPeekProperlyNestedBodyElement();
  i && e.openElements.tmplCount === 0 && (e.framesetOk = !1, e.treeAdapter.adoptAttributes(i, t.attrs));
}
function oJ(e, t) {
  const i = e.openElements.tryPeekProperlyNestedBodyElement();
  e.framesetOk && i && (e.treeAdapter.detachNode(i), e.openElements.popAllUpToHtmlElement(), e._insertElement(t, ke.HTML), e.insertionMode = ne.IN_FRAMESET);
}
function sJ(e, t) {
  e.openElements.hasInButtonScope(I.P) && e._closePElement(), e._insertElement(t, ke.HTML);
}
function aJ(e, t) {
  e.openElements.hasInButtonScope(I.P) && e._closePElement(), o5(e.openElements.currentTagId) && e.openElements.pop(), e._insertElement(t, ke.HTML);
}
function lJ(e, t) {
  e.openElements.hasInButtonScope(I.P) && e._closePElement(), e._insertElement(t, ke.HTML), e.skipNextNewLine = !0, e.framesetOk = !1;
}
function cJ(e, t) {
  const i = e.openElements.tmplCount > 0;
  (!e.formElement || i) && (e.openElements.hasInButtonScope(I.P) && e._closePElement(), e._insertElement(t, ke.HTML), i || (e.formElement = e.openElements.current));
}
function uJ(e, t) {
  e.framesetOk = !1;
  const i = t.tagID;
  for (let r = e.openElements.stackTop; r >= 0; r--) {
    const n = e.openElements.tagIDs[r];
    if (i === I.LI && n === I.LI || (i === I.DD || i === I.DT) && (n === I.DD || n === I.DT)) {
      e.openElements.generateImpliedEndTagsWithExclusion(n), e.openElements.popUntilTagNamePopped(n);
      break;
    }
    if (n !== I.ADDRESS && n !== I.DIV && n !== I.P && e._isSpecialElement(e.openElements.items[r], n))
      break;
  }
  e.openElements.hasInButtonScope(I.P) && e._closePElement(), e._insertElement(t, ke.HTML);
}
function dJ(e, t) {
  e.openElements.hasInButtonScope(I.P) && e._closePElement(), e._insertElement(t, ke.HTML), e.tokenizer.state = Wn.PLAINTEXT;
}
function mJ(e, t) {
  e.openElements.hasInScope(I.BUTTON) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(I.BUTTON)), e._reconstructActiveFormattingElements(), e._insertElement(t, ke.HTML), e.framesetOk = !1;
}
function gJ(e, t) {
  const i = e.activeFormattingElements.getElementEntryInScopeWithTagName(Ee.A);
  i && (c2(e, t), e.openElements.remove(i.element), e.activeFormattingElements.removeEntry(i)), e._reconstructActiveFormattingElements(), e._insertElement(t, ke.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function hJ(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, ke.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function pJ(e, t) {
  e._reconstructActiveFormattingElements(), e.openElements.hasInScope(I.NOBR) && (c2(e, t), e._reconstructActiveFormattingElements()), e._insertElement(t, ke.HTML), e.activeFormattingElements.pushElement(e.openElements.current, t);
}
function fJ(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, ke.HTML), e.activeFormattingElements.insertMarker(), e.framesetOk = !1;
}
function AJ(e, t) {
  e.treeAdapter.getDocumentMode(e.document) !== mo.QUIRKS && e.openElements.hasInButtonScope(I.P) && e._closePElement(), e._insertElement(t, ke.HTML), e.framesetOk = !1, e.insertionMode = ne.IN_TABLE;
}
function E5(e, t) {
  e._reconstructActiveFormattingElements(), e._appendElement(t, ke.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function v5(e) {
  const t = i5(e, Cl.TYPE);
  return t != null && t.toLowerCase() === FZ;
}
function yJ(e, t) {
  e._reconstructActiveFormattingElements(), e._appendElement(t, ke.HTML), v5(t) || (e.framesetOk = !1), t.ackSelfClosing = !0;
}
function EJ(e, t) {
  e._appendElement(t, ke.HTML), t.ackSelfClosing = !0;
}
function vJ(e, t) {
  e.openElements.hasInButtonScope(I.P) && e._closePElement(), e._appendElement(t, ke.HTML), e.framesetOk = !1, t.ackSelfClosing = !0;
}
function bJ(e, t) {
  t.tagName = Ee.IMG, t.tagID = I.IMG, E5(e, t);
}
function CJ(e, t) {
  e._insertElement(t, ke.HTML), e.skipNextNewLine = !0, e.tokenizer.state = Wn.RCDATA, e.originalInsertionMode = e.insertionMode, e.framesetOk = !1, e.insertionMode = ne.TEXT;
}
function xJ(e, t) {
  e.openElements.hasInButtonScope(I.P) && e._closePElement(), e._reconstructActiveFormattingElements(), e.framesetOk = !1, e._switchToTextParsing(t, Wn.RAWTEXT);
}
function IJ(e, t) {
  e.framesetOk = !1, e._switchToTextParsing(t, Wn.RAWTEXT);
}
function o3(e, t) {
  e._switchToTextParsing(t, Wn.RAWTEXT);
}
function SJ(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, ke.HTML), e.framesetOk = !1, e.insertionMode = e.insertionMode === ne.IN_TABLE || e.insertionMode === ne.IN_CAPTION || e.insertionMode === ne.IN_TABLE_BODY || e.insertionMode === ne.IN_ROW || e.insertionMode === ne.IN_CELL ? ne.IN_SELECT_IN_TABLE : ne.IN_SELECT;
}
function RJ(e, t) {
  e.openElements.currentTagId === I.OPTION && e.openElements.pop(), e._reconstructActiveFormattingElements(), e._insertElement(t, ke.HTML);
}
function kJ(e, t) {
  e.openElements.hasInScope(I.RUBY) && e.openElements.generateImpliedEndTags(), e._insertElement(t, ke.HTML);
}
function wJ(e, t) {
  e.openElements.hasInScope(I.RUBY) && e.openElements.generateImpliedEndTagsWithExclusion(I.RTC), e._insertElement(t, ke.HTML);
}
function MJ(e, t) {
  e._reconstructActiveFormattingElements(), g5(t), l2(t), t.selfClosing ? e._appendElement(t, ke.MATHML) : e._insertElement(t, ke.MATHML), t.ackSelfClosing = !0;
}
function NJ(e, t) {
  e._reconstructActiveFormattingElements(), h5(t), l2(t), t.selfClosing ? e._appendElement(t, ke.SVG) : e._insertElement(t, ke.SVG), t.ackSelfClosing = !0;
}
function s3(e, t) {
  e._reconstructActiveFormattingElements(), e._insertElement(t, ke.HTML);
}
function an(e, t) {
  switch (t.tagID) {
    case I.I:
    case I.S:
    case I.B:
    case I.U:
    case I.EM:
    case I.TT:
    case I.BIG:
    case I.CODE:
    case I.FONT:
    case I.SMALL:
    case I.STRIKE:
    case I.STRONG: {
      hJ(e, t);
      break;
    }
    case I.A: {
      gJ(e, t);
      break;
    }
    case I.H1:
    case I.H2:
    case I.H3:
    case I.H4:
    case I.H5:
    case I.H6: {
      aJ(e, t);
      break;
    }
    case I.P:
    case I.DL:
    case I.OL:
    case I.UL:
    case I.DIV:
    case I.DIR:
    case I.NAV:
    case I.MAIN:
    case I.MENU:
    case I.ASIDE:
    case I.CENTER:
    case I.FIGURE:
    case I.FOOTER:
    case I.HEADER:
    case I.HGROUP:
    case I.DIALOG:
    case I.DETAILS:
    case I.ADDRESS:
    case I.ARTICLE:
    case I.SECTION:
    case I.SUMMARY:
    case I.FIELDSET:
    case I.BLOCKQUOTE:
    case I.FIGCAPTION: {
      sJ(e, t);
      break;
    }
    case I.LI:
    case I.DD:
    case I.DT: {
      uJ(e, t);
      break;
    }
    case I.BR:
    case I.IMG:
    case I.WBR:
    case I.AREA:
    case I.EMBED:
    case I.KEYGEN: {
      E5(e, t);
      break;
    }
    case I.HR: {
      vJ(e, t);
      break;
    }
    case I.RB:
    case I.RTC: {
      kJ(e, t);
      break;
    }
    case I.RT:
    case I.RP: {
      wJ(e, t);
      break;
    }
    case I.PRE:
    case I.LISTING: {
      lJ(e, t);
      break;
    }
    case I.XMP: {
      xJ(e, t);
      break;
    }
    case I.SVG: {
      NJ(e, t);
      break;
    }
    case I.HTML: {
      rJ(e, t);
      break;
    }
    case I.BASE:
    case I.LINK:
    case I.META:
    case I.STYLE:
    case I.TITLE:
    case I.SCRIPT:
    case I.BGSOUND:
    case I.BASEFONT:
    case I.TEMPLATE: {
      fs(e, t);
      break;
    }
    case I.BODY: {
      nJ(e, t);
      break;
    }
    case I.FORM: {
      cJ(e, t);
      break;
    }
    case I.NOBR: {
      pJ(e, t);
      break;
    }
    case I.MATH: {
      MJ(e, t);
      break;
    }
    case I.TABLE: {
      AJ(e, t);
      break;
    }
    case I.INPUT: {
      yJ(e, t);
      break;
    }
    case I.PARAM:
    case I.TRACK:
    case I.SOURCE: {
      EJ(e, t);
      break;
    }
    case I.IMAGE: {
      bJ(e, t);
      break;
    }
    case I.BUTTON: {
      mJ(e, t);
      break;
    }
    case I.APPLET:
    case I.OBJECT:
    case I.MARQUEE: {
      fJ(e, t);
      break;
    }
    case I.IFRAME: {
      IJ(e, t);
      break;
    }
    case I.SELECT: {
      SJ(e, t);
      break;
    }
    case I.OPTION:
    case I.OPTGROUP: {
      RJ(e, t);
      break;
    }
    case I.NOEMBED: {
      o3(e, t);
      break;
    }
    case I.FRAMESET: {
      oJ(e, t);
      break;
    }
    case I.TEXTAREA: {
      CJ(e, t);
      break;
    }
    case I.NOSCRIPT: {
      e.options.scriptingEnabled ? o3(e, t) : s3(e, t);
      break;
    }
    case I.PLAINTEXT: {
      dJ(e, t);
      break;
    }
    case I.COL:
    case I.TH:
    case I.TD:
    case I.TR:
    case I.HEAD:
    case I.FRAME:
    case I.TBODY:
    case I.TFOOT:
    case I.THEAD:
    case I.CAPTION:
    case I.COLGROUP:
      break;
    default:
      s3(e, t);
  }
}
function TJ(e, t) {
  if (e.openElements.hasInScope(I.BODY) && (e.insertionMode = ne.AFTER_BODY, e.options.sourceCodeLocationInfo)) {
    const i = e.openElements.tryPeekProperlyNestedBodyElement();
    i && e._setEndLocation(i, t);
  }
}
function BJ(e, t) {
  e.openElements.hasInScope(I.BODY) && (e.insertionMode = ne.AFTER_BODY, N5(e, t));
}
function DJ(e, t) {
  const i = t.tagID;
  e.openElements.hasInScope(i) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(i));
}
function OJ(e) {
  const t = e.openElements.tmplCount > 0, { formElement: i } = e;
  t || (e.formElement = null), (i || t) && e.openElements.hasInScope(I.FORM) && (e.openElements.generateImpliedEndTags(), t ? e.openElements.popUntilTagNamePopped(I.FORM) : i && e.openElements.remove(i));
}
function FJ(e) {
  e.openElements.hasInButtonScope(I.P) || e._insertFakeElement(Ee.P, I.P), e._closePElement();
}
function VJ(e) {
  e.openElements.hasInListItemScope(I.LI) && (e.openElements.generateImpliedEndTagsWithExclusion(I.LI), e.openElements.popUntilTagNamePopped(I.LI));
}
function qJ(e, t) {
  const i = t.tagID;
  e.openElements.hasInScope(i) && (e.openElements.generateImpliedEndTagsWithExclusion(i), e.openElements.popUntilTagNamePopped(i));
}
function jJ(e) {
  e.openElements.hasNumberedHeaderInScope() && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilNumberedHeaderPopped());
}
function LJ(e, t) {
  const i = t.tagID;
  e.openElements.hasInScope(i) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(i), e.activeFormattingElements.clearToLastMarker());
}
function KJ(e) {
  e._reconstructActiveFormattingElements(), e._insertFakeElement(Ee.BR, I.BR), e.openElements.pop(), e.framesetOk = !1;
}
function b5(e, t) {
  const i = t.tagName, r = t.tagID;
  for (let n = e.openElements.stackTop; n > 0; n--) {
    const o = e.openElements.items[n], s = e.openElements.tagIDs[n];
    if (r === s && (r !== I.UNKNOWN || e.treeAdapter.getTagName(o) === i)) {
      e.openElements.generateImpliedEndTagsWithExclusion(r), e.openElements.stackTop >= n && e.openElements.shortenToLength(n);
      break;
    }
    if (e._isSpecialElement(o, s))
      break;
  }
}
function cf(e, t) {
  switch (t.tagID) {
    case I.A:
    case I.B:
    case I.I:
    case I.S:
    case I.U:
    case I.EM:
    case I.TT:
    case I.BIG:
    case I.CODE:
    case I.FONT:
    case I.NOBR:
    case I.SMALL:
    case I.STRIKE:
    case I.STRONG: {
      c2(e, t);
      break;
    }
    case I.P: {
      FJ(e);
      break;
    }
    case I.DL:
    case I.UL:
    case I.OL:
    case I.DIR:
    case I.DIV:
    case I.NAV:
    case I.PRE:
    case I.MAIN:
    case I.MENU:
    case I.ASIDE:
    case I.BUTTON:
    case I.CENTER:
    case I.FIGURE:
    case I.FOOTER:
    case I.HEADER:
    case I.HGROUP:
    case I.DIALOG:
    case I.ADDRESS:
    case I.ARTICLE:
    case I.DETAILS:
    case I.SECTION:
    case I.SUMMARY:
    case I.LISTING:
    case I.FIELDSET:
    case I.BLOCKQUOTE:
    case I.FIGCAPTION: {
      DJ(e, t);
      break;
    }
    case I.LI: {
      VJ(e);
      break;
    }
    case I.DD:
    case I.DT: {
      qJ(e, t);
      break;
    }
    case I.H1:
    case I.H2:
    case I.H3:
    case I.H4:
    case I.H5:
    case I.H6: {
      jJ(e);
      break;
    }
    case I.BR: {
      KJ(e);
      break;
    }
    case I.BODY: {
      TJ(e, t);
      break;
    }
    case I.HTML: {
      BJ(e, t);
      break;
    }
    case I.FORM: {
      OJ(e);
      break;
    }
    case I.APPLET:
    case I.OBJECT:
    case I.MARQUEE: {
      LJ(e, t);
      break;
    }
    case I.TEMPLATE: {
      tu(e, t);
      break;
    }
    default:
      b5(e, t);
  }
}
function C5(e, t) {
  e.tmplInsertionModeStack.length > 0 ? M5(e, t) : u2(e, t);
}
function YJ(e, t) {
  var i;
  t.tagID === I.SCRIPT && ((i = e.scriptHandler) === null || i === void 0 || i.call(e, e.openElements.current)), e.openElements.pop(), e.insertionMode = e.originalInsertionMode;
}
function UJ(e, t) {
  e._err(t, Se.eofInElementThatCanContainOnlyText), e.openElements.pop(), e.insertionMode = e.originalInsertionMode, e.onEof(t);
}
function Yy(e, t) {
  if (p5.has(e.openElements.currentTagId))
    switch (e.pendingCharacterTokens.length = 0, e.hasNonWhitespacePendingCharacterToken = !1, e.originalInsertionMode = e.insertionMode, e.insertionMode = ne.IN_TABLE_TEXT, t.type) {
      case Xt.CHARACTER: {
        I5(e, t);
        break;
      }
      case Xt.WHITESPACE_CHARACTER: {
        x5(e, t);
        break;
      }
    }
  else
    yg(e, t);
}
function GJ(e, t) {
  e.openElements.clearBackToTableContext(), e.activeFormattingElements.insertMarker(), e._insertElement(t, ke.HTML), e.insertionMode = ne.IN_CAPTION;
}
function QJ(e, t) {
  e.openElements.clearBackToTableContext(), e._insertElement(t, ke.HTML), e.insertionMode = ne.IN_COLUMN_GROUP;
}
function WJ(e, t) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(Ee.COLGROUP, I.COLGROUP), e.insertionMode = ne.IN_COLUMN_GROUP, d2(e, t);
}
function ZJ(e, t) {
  e.openElements.clearBackToTableContext(), e._insertElement(t, ke.HTML), e.insertionMode = ne.IN_TABLE_BODY;
}
function JJ(e, t) {
  e.openElements.clearBackToTableContext(), e._insertFakeElement(Ee.TBODY, I.TBODY), e.insertionMode = ne.IN_TABLE_BODY, uf(e, t);
}
function PJ(e, t) {
  e.openElements.hasInTableScope(I.TABLE) && (e.openElements.popUntilTagNamePopped(I.TABLE), e._resetInsertionMode(), e._processStartTag(t));
}
function zJ(e, t) {
  v5(t) ? e._appendElement(t, ke.HTML) : yg(e, t), t.ackSelfClosing = !0;
}
function HJ(e, t) {
  !e.formElement && e.openElements.tmplCount === 0 && (e._insertElement(t, ke.HTML), e.formElement = e.openElements.current, e.openElements.pop());
}
function m0(e, t) {
  switch (t.tagID) {
    case I.TD:
    case I.TH:
    case I.TR: {
      JJ(e, t);
      break;
    }
    case I.STYLE:
    case I.SCRIPT:
    case I.TEMPLATE: {
      fs(e, t);
      break;
    }
    case I.COL: {
      WJ(e, t);
      break;
    }
    case I.FORM: {
      HJ(e, t);
      break;
    }
    case I.TABLE: {
      PJ(e, t);
      break;
    }
    case I.TBODY:
    case I.TFOOT:
    case I.THEAD: {
      ZJ(e, t);
      break;
    }
    case I.INPUT: {
      zJ(e, t);
      break;
    }
    case I.CAPTION: {
      GJ(e, t);
      break;
    }
    case I.COLGROUP: {
      QJ(e, t);
      break;
    }
    default:
      yg(e, t);
  }
}
function Km(e, t) {
  switch (t.tagID) {
    case I.TABLE: {
      e.openElements.hasInTableScope(I.TABLE) && (e.openElements.popUntilTagNamePopped(I.TABLE), e._resetInsertionMode());
      break;
    }
    case I.TEMPLATE: {
      tu(e, t);
      break;
    }
    case I.BODY:
    case I.CAPTION:
    case I.COL:
    case I.COLGROUP:
    case I.HTML:
    case I.TBODY:
    case I.TD:
    case I.TFOOT:
    case I.TH:
    case I.THEAD:
    case I.TR:
      break;
    default:
      yg(e, t);
  }
}
function yg(e, t) {
  const i = e.fosterParentingEnabled;
  e.fosterParentingEnabled = !0, lf(e, t), e.fosterParentingEnabled = i;
}
function x5(e, t) {
  e.pendingCharacterTokens.push(t);
}
function I5(e, t) {
  e.pendingCharacterTokens.push(t), e.hasNonWhitespacePendingCharacterToken = !0;
}
function Sd(e, t) {
  let i = 0;
  if (e.hasNonWhitespacePendingCharacterToken)
    for (; i < e.pendingCharacterTokens.length; i++)
      yg(e, e.pendingCharacterTokens[i]);
  else
    for (; i < e.pendingCharacterTokens.length; i++)
      e._insertCharacters(e.pendingCharacterTokens[i]);
  e.insertionMode = e.originalInsertionMode, e._processToken(t);
}
const S5 = /* @__PURE__ */ new Set([I.CAPTION, I.COL, I.COLGROUP, I.TBODY, I.TD, I.TFOOT, I.TH, I.THEAD, I.TR]);
function XJ(e, t) {
  const i = t.tagID;
  S5.has(i) ? e.openElements.hasInTableScope(I.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(I.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = ne.IN_TABLE, m0(e, t)) : an(e, t);
}
function _J(e, t) {
  const i = t.tagID;
  switch (i) {
    case I.CAPTION:
    case I.TABLE: {
      e.openElements.hasInTableScope(I.CAPTION) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(I.CAPTION), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = ne.IN_TABLE, i === I.TABLE && Km(e, t));
      break;
    }
    case I.BODY:
    case I.COL:
    case I.COLGROUP:
    case I.HTML:
    case I.TBODY:
    case I.TD:
    case I.TFOOT:
    case I.TH:
    case I.THEAD:
    case I.TR:
      break;
    default:
      cf(e, t);
  }
}
function d2(e, t) {
  switch (t.tagID) {
    case I.HTML: {
      an(e, t);
      break;
    }
    case I.COL: {
      e._appendElement(t, ke.HTML), t.ackSelfClosing = !0;
      break;
    }
    case I.TEMPLATE: {
      fs(e, t);
      break;
    }
    default:
      h1(e, t);
  }
}
function $J(e, t) {
  switch (t.tagID) {
    case I.COLGROUP: {
      e.openElements.currentTagId === I.COLGROUP && (e.openElements.pop(), e.insertionMode = ne.IN_TABLE);
      break;
    }
    case I.TEMPLATE: {
      tu(e, t);
      break;
    }
    case I.COL:
      break;
    default:
      h1(e, t);
  }
}
function h1(e, t) {
  e.openElements.currentTagId === I.COLGROUP && (e.openElements.pop(), e.insertionMode = ne.IN_TABLE, e._processToken(t));
}
function uf(e, t) {
  switch (t.tagID) {
    case I.TR: {
      e.openElements.clearBackToTableBodyContext(), e._insertElement(t, ke.HTML), e.insertionMode = ne.IN_ROW;
      break;
    }
    case I.TH:
    case I.TD: {
      e.openElements.clearBackToTableBodyContext(), e._insertFakeElement(Ee.TR, I.TR), e.insertionMode = ne.IN_ROW, df(e, t);
      break;
    }
    case I.CAPTION:
    case I.COL:
    case I.COLGROUP:
    case I.TBODY:
    case I.TFOOT:
    case I.THEAD: {
      e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = ne.IN_TABLE, m0(e, t));
      break;
    }
    default:
      m0(e, t);
  }
}
function vb(e, t) {
  const i = t.tagID;
  switch (t.tagID) {
    case I.TBODY:
    case I.TFOOT:
    case I.THEAD: {
      e.openElements.hasInTableScope(i) && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = ne.IN_TABLE);
      break;
    }
    case I.TABLE: {
      e.openElements.hasTableBodyContextInTableScope() && (e.openElements.clearBackToTableBodyContext(), e.openElements.pop(), e.insertionMode = ne.IN_TABLE, Km(e, t));
      break;
    }
    case I.BODY:
    case I.CAPTION:
    case I.COL:
    case I.COLGROUP:
    case I.HTML:
    case I.TD:
    case I.TH:
    case I.TR:
      break;
    default:
      Km(e, t);
  }
}
function df(e, t) {
  switch (t.tagID) {
    case I.TH:
    case I.TD: {
      e.openElements.clearBackToTableRowContext(), e._insertElement(t, ke.HTML), e.insertionMode = ne.IN_CELL, e.activeFormattingElements.insertMarker();
      break;
    }
    case I.CAPTION:
    case I.COL:
    case I.COLGROUP:
    case I.TBODY:
    case I.TFOOT:
    case I.THEAD:
    case I.TR: {
      e.openElements.hasInTableScope(I.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = ne.IN_TABLE_BODY, uf(e, t));
      break;
    }
    default:
      m0(e, t);
  }
}
function R5(e, t) {
  switch (t.tagID) {
    case I.TR: {
      e.openElements.hasInTableScope(I.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = ne.IN_TABLE_BODY);
      break;
    }
    case I.TABLE: {
      e.openElements.hasInTableScope(I.TR) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = ne.IN_TABLE_BODY, vb(e, t));
      break;
    }
    case I.TBODY:
    case I.TFOOT:
    case I.THEAD: {
      (e.openElements.hasInTableScope(t.tagID) || e.openElements.hasInTableScope(I.TR)) && (e.openElements.clearBackToTableRowContext(), e.openElements.pop(), e.insertionMode = ne.IN_TABLE_BODY, vb(e, t));
      break;
    }
    case I.BODY:
    case I.CAPTION:
    case I.COL:
    case I.COLGROUP:
    case I.HTML:
    case I.TD:
    case I.TH:
      break;
    default:
      Km(e, t);
  }
}
function eP(e, t) {
  const i = t.tagID;
  S5.has(i) ? (e.openElements.hasInTableScope(I.TD) || e.openElements.hasInTableScope(I.TH)) && (e._closeTableCell(), df(e, t)) : an(e, t);
}
function tP(e, t) {
  const i = t.tagID;
  switch (i) {
    case I.TD:
    case I.TH: {
      e.openElements.hasInTableScope(i) && (e.openElements.generateImpliedEndTags(), e.openElements.popUntilTagNamePopped(i), e.activeFormattingElements.clearToLastMarker(), e.insertionMode = ne.IN_ROW);
      break;
    }
    case I.TABLE:
    case I.TBODY:
    case I.TFOOT:
    case I.THEAD:
    case I.TR: {
      e.openElements.hasInTableScope(i) && (e._closeTableCell(), R5(e, t));
      break;
    }
    case I.BODY:
    case I.CAPTION:
    case I.COL:
    case I.COLGROUP:
    case I.HTML:
      break;
    default:
      cf(e, t);
  }
}
function k5(e, t) {
  switch (t.tagID) {
    case I.HTML: {
      an(e, t);
      break;
    }
    case I.OPTION: {
      e.openElements.currentTagId === I.OPTION && e.openElements.pop(), e._insertElement(t, ke.HTML);
      break;
    }
    case I.OPTGROUP: {
      e.openElements.currentTagId === I.OPTION && e.openElements.pop(), e.openElements.currentTagId === I.OPTGROUP && e.openElements.pop(), e._insertElement(t, ke.HTML);
      break;
    }
    case I.INPUT:
    case I.KEYGEN:
    case I.TEXTAREA:
    case I.SELECT: {
      e.openElements.hasInSelectScope(I.SELECT) && (e.openElements.popUntilTagNamePopped(I.SELECT), e._resetInsertionMode(), t.tagID !== I.SELECT && e._processStartTag(t));
      break;
    }
    case I.SCRIPT:
    case I.TEMPLATE: {
      fs(e, t);
      break;
    }
  }
}
function w5(e, t) {
  switch (t.tagID) {
    case I.OPTGROUP: {
      e.openElements.stackTop > 0 && e.openElements.currentTagId === I.OPTION && e.openElements.tagIDs[e.openElements.stackTop - 1] === I.OPTGROUP && e.openElements.pop(), e.openElements.currentTagId === I.OPTGROUP && e.openElements.pop();
      break;
    }
    case I.OPTION: {
      e.openElements.currentTagId === I.OPTION && e.openElements.pop();
      break;
    }
    case I.SELECT: {
      e.openElements.hasInSelectScope(I.SELECT) && (e.openElements.popUntilTagNamePopped(I.SELECT), e._resetInsertionMode());
      break;
    }
    case I.TEMPLATE: {
      tu(e, t);
      break;
    }
  }
}
function iP(e, t) {
  const i = t.tagID;
  i === I.CAPTION || i === I.TABLE || i === I.TBODY || i === I.TFOOT || i === I.THEAD || i === I.TR || i === I.TD || i === I.TH ? (e.openElements.popUntilTagNamePopped(I.SELECT), e._resetInsertionMode(), e._processStartTag(t)) : k5(e, t);
}
function rP(e, t) {
  const i = t.tagID;
  i === I.CAPTION || i === I.TABLE || i === I.TBODY || i === I.TFOOT || i === I.THEAD || i === I.TR || i === I.TD || i === I.TH ? e.openElements.hasInTableScope(i) && (e.openElements.popUntilTagNamePopped(I.SELECT), e._resetInsertionMode(), e.onEndTag(t)) : w5(e, t);
}
function nP(e, t) {
  switch (t.tagID) {
    case I.BASE:
    case I.BASEFONT:
    case I.BGSOUND:
    case I.LINK:
    case I.META:
    case I.NOFRAMES:
    case I.SCRIPT:
    case I.STYLE:
    case I.TEMPLATE:
    case I.TITLE: {
      fs(e, t);
      break;
    }
    case I.CAPTION:
    case I.COLGROUP:
    case I.TBODY:
    case I.TFOOT:
    case I.THEAD: {
      e.tmplInsertionModeStack[0] = ne.IN_TABLE, e.insertionMode = ne.IN_TABLE, m0(e, t);
      break;
    }
    case I.COL: {
      e.tmplInsertionModeStack[0] = ne.IN_COLUMN_GROUP, e.insertionMode = ne.IN_COLUMN_GROUP, d2(e, t);
      break;
    }
    case I.TR: {
      e.tmplInsertionModeStack[0] = ne.IN_TABLE_BODY, e.insertionMode = ne.IN_TABLE_BODY, uf(e, t);
      break;
    }
    case I.TD:
    case I.TH: {
      e.tmplInsertionModeStack[0] = ne.IN_ROW, e.insertionMode = ne.IN_ROW, df(e, t);
      break;
    }
    default:
      e.tmplInsertionModeStack[0] = ne.IN_BODY, e.insertionMode = ne.IN_BODY, an(e, t);
  }
}
function oP(e, t) {
  t.tagID === I.TEMPLATE && tu(e, t);
}
function M5(e, t) {
  e.openElements.tmplCount > 0 ? (e.openElements.popUntilTagNamePopped(I.TEMPLATE), e.activeFormattingElements.clearToLastMarker(), e.tmplInsertionModeStack.shift(), e._resetInsertionMode(), e.onEof(t)) : u2(e, t);
}
function sP(e, t) {
  t.tagID === I.HTML ? an(e, t) : p1(e, t);
}
function N5(e, t) {
  var i;
  if (t.tagID === I.HTML) {
    if (e.fragmentContext || (e.insertionMode = ne.AFTER_AFTER_BODY), e.options.sourceCodeLocationInfo && e.openElements.tagIDs[0] === I.HTML) {
      e._setEndLocation(e.openElements.items[0], t);
      const r = e.openElements.items[1];
      r && !(!((i = e.treeAdapter.getNodeSourceCodeLocation(r)) === null || i === void 0) && i.endTag) && e._setEndLocation(r, t);
    }
  } else
    p1(e, t);
}
function p1(e, t) {
  e.insertionMode = ne.IN_BODY, lf(e, t);
}
function aP(e, t) {
  switch (t.tagID) {
    case I.HTML: {
      an(e, t);
      break;
    }
    case I.FRAMESET: {
      e._insertElement(t, ke.HTML);
      break;
    }
    case I.FRAME: {
      e._appendElement(t, ke.HTML), t.ackSelfClosing = !0;
      break;
    }
    case I.NOFRAMES: {
      fs(e, t);
      break;
    }
  }
}
function lP(e, t) {
  t.tagID === I.FRAMESET && !e.openElements.isRootHtmlElementCurrent() && (e.openElements.pop(), !e.fragmentContext && e.openElements.currentTagId !== I.FRAMESET && (e.insertionMode = ne.AFTER_FRAMESET));
}
function cP(e, t) {
  switch (t.tagID) {
    case I.HTML: {
      an(e, t);
      break;
    }
    case I.NOFRAMES: {
      fs(e, t);
      break;
    }
  }
}
function uP(e, t) {
  t.tagID === I.HTML && (e.insertionMode = ne.AFTER_AFTER_FRAMESET);
}
function dP(e, t) {
  t.tagID === I.HTML ? an(e, t) : Lp(e, t);
}
function Lp(e, t) {
  e.insertionMode = ne.IN_BODY, lf(e, t);
}
function mP(e, t) {
  switch (t.tagID) {
    case I.HTML: {
      an(e, t);
      break;
    }
    case I.NOFRAMES: {
      fs(e, t);
      break;
    }
  }
}
function gP(e, t) {
  t.chars = Oi, e._insertCharacters(t);
}
function hP(e, t) {
  e._insertCharacters(t), e.framesetOk = !1;
}
function T5(e) {
  for (; e.treeAdapter.getNamespaceURI(e.openElements.current) !== ke.HTML && !e._isIntegrationPoint(e.openElements.currentTagId, e.openElements.current); )
    e.openElements.pop();
}
function pP(e, t) {
  if (NZ(t))
    T5(e), e._startTagOutsideForeignContent(t);
  else {
    const i = e._getAdjustedCurrentElement(), r = e.treeAdapter.getNamespaceURI(i);
    r === ke.MATHML ? g5(t) : r === ke.SVG && (TZ(t), h5(t)), l2(t), t.selfClosing ? e._appendElement(t, r) : e._insertElement(t, r), t.ackSelfClosing = !0;
  }
}
function fP(e, t) {
  if (t.tagID === I.P || t.tagID === I.BR) {
    T5(e), e._endTagOutsideForeignContent(t);
    return;
  }
  for (let i = e.openElements.stackTop; i > 0; i--) {
    const r = e.openElements.items[i];
    if (e.treeAdapter.getNamespaceURI(r) === ke.HTML) {
      e._endTagOutsideForeignContent(t);
      break;
    }
    const n = e.treeAdapter.getTagName(r);
    if (n.toLowerCase() === t.tagName) {
      t.tagName = n, e.openElements.shortenToLength(i);
      break;
    }
  }
}
function B5(e, t) {
  return function(r) {
    let n, o = 0, s = "";
    for (; n = e.exec(r); )
      o !== n.index && (s += r.substring(o, n.index)), s += t.get(n[0].charCodeAt(0)), o = n.index + 1;
    return s + r.substring(o);
  };
}
const AP = B5(/["&\u00A0]/g, /* @__PURE__ */ new Map([
  [34, "&quot;"],
  [38, "&amp;"],
  [160, "&nbsp;"]
])), yP = B5(/[&<>\u00A0]/g, /* @__PURE__ */ new Map([
  [38, "&amp;"],
  [60, "&lt;"],
  [62, "&gt;"],
  [160, "&nbsp;"]
])), EP = /* @__PURE__ */ new Set([
  Ee.AREA,
  Ee.BASE,
  Ee.BASEFONT,
  Ee.BGSOUND,
  Ee.BR,
  Ee.COL,
  Ee.EMBED,
  Ee.FRAME,
  Ee.HR,
  Ee.IMG,
  Ee.INPUT,
  Ee.KEYGEN,
  Ee.LINK,
  Ee.META,
  Ee.PARAM,
  Ee.SOURCE,
  Ee.TRACK,
  Ee.WBR
]);
function D5(e, t) {
  return t.treeAdapter.isElementNode(e) && t.treeAdapter.getNamespaceURI(e) === ke.HTML && EP.has(t.treeAdapter.getTagName(e));
}
const vP = { treeAdapter: Ac, scriptingEnabled: !0 };
function bP(e, t) {
  const i = q(q({}, vP), t);
  return D5(e, i) ? "" : O5(e, i);
}
function O5(e, t) {
  let i = "";
  const r = t.treeAdapter.isElementNode(e) && t.treeAdapter.getTagName(e) === Ee.TEMPLATE && t.treeAdapter.getNamespaceURI(e) === ke.HTML ? t.treeAdapter.getTemplateContent(e) : e, n = t.treeAdapter.getChildNodes(r);
  if (n)
    for (const o of n)
      i += CP(o, t);
  return i;
}
function CP(e, t) {
  return t.treeAdapter.isElementNode(e) ? xP(e, t) : t.treeAdapter.isTextNode(e) ? SP(e, t) : t.treeAdapter.isCommentNode(e) ? RP(e, t) : t.treeAdapter.isDocumentTypeNode(e) ? kP(e, t) : "";
}
function xP(e, t) {
  const i = t.treeAdapter.getTagName(e);
  return `<${i}${IP(e, t)}>${D5(e, t) ? "" : `${O5(e, t)}</${i}>`}`;
}
function IP(e, { treeAdapter: t }) {
  let i = "";
  for (const r of t.getAttrList(e)) {
    if (i += " ", !r.namespace)
      i += r.name;
    else
      switch (r.namespace) {
        case ke.XML: {
          i += `xml:${r.name}`;
          break;
        }
        case ke.XMLNS: {
          r.name !== "xmlns" && (i += "xmlns:"), i += r.name;
          break;
        }
        case ke.XLINK: {
          i += `xlink:${r.name}`;
          break;
        }
        default:
          i += `${r.prefix}:${r.name}`;
      }
    i += `="${AP(r.value)}"`;
  }
  return i;
}
function SP(e, t) {
  const { treeAdapter: i } = t, r = i.getTextNodeContent(e), n = i.getParentNode(e), o = n && i.isElementNode(n) && i.getTagName(n);
  return o && i.getNamespaceURI(n) === ke.HTML && nZ(o, t.scriptingEnabled) ? r : yP(r);
}
function RP(e, { treeAdapter: t }) {
  return `<!--${t.getCommentNodeContent(e)}-->`;
}
function kP(e, { treeAdapter: t }) {
  return `<!DOCTYPE ${t.getDocumentTypeNodeName(e)}>`;
}
function wP(e, t) {
  return f5.parse(e, t);
}
function MP(e, t, i) {
  typeof e == "string" && (i = t, t = e, e = null);
  const r = f5.getFragmentParser(e, i);
  return r.tokenizer.write(t, !0), r.getFragment();
}
function j5e(e) {
  var r, n, o;
  return (o = (n = (r = wP(e).childNodes[0]) == null ? void 0 : r.childNodes) == null ? void 0 : n[1]) == null ? void 0 : o.childNodes;
}
function NP(e) {
  return MP(e != null ? e : "").childNodes;
}
function L5e(e) {
  return bP(e);
}
function Wt(e, t) {
  if (typeof document != "undefined")
    return document.createElement(e);
}
function F5(e) {
  const i = NP(e)[0];
  return i && "value" in i ? i.value : "";
}
class g0 extends L.DecoratorNode {
  constructor(i, r) {
    super(r);
    Ze(this, "__text");
    Ze(this, "__embedType");
    Ze(this, "__id");
    Ze(this, "__profile");
    Ze(this, "__options");
    Ze(this, "__branch");
    Ze(this, "__subType");
    this.__text = i.text, this.__embedType = i.embedType, this.__id = i.id, this.__profile = i.profile, this.__options = i.options, this.__branch = i.branch, this.__subType = i.subType;
  }
  static getType() {
    return "embed";
  }
  static clone(i) {
    return new g0(
      {
        text: i.__text,
        embedType: i.__embedType,
        id: i.__id,
        profile: i.__profile,
        options: i.__options,
        branch: i.__branch,
        subType: i.__subType
      },
      i.__key
    );
  }
  static importJSON(i) {
    return new g0({
      text: i.text,
      embedType: i.embedType,
      id: i.id,
      profile: i.profile,
      options: i.options,
      branch: i.branch,
      subType: i.subType
    });
  }
  exportJSON() {
    return {
      text: this.__text,
      embedType: this.__embedType,
      id: this.__id,
      profile: this.__profile,
      options: this.__options,
      branch: this.__branch,
      subType: this.__subType,
      type: "embed",
      version: 1
    };
  }
  createDOM() {
    return Wt("span");
  }
  updateDOM(i, r, n) {
    return r.firstChild === null;
  }
  decorate(i, r) {
    const n = r.theme.embedRenderer;
    if (this.__embedType === "ad") {
      if (this.__subType == null || this.__subType === "dynamic") {
        const o = go();
        return /* @__PURE__ */ f("div", { id: o, style: { padding: "24px 0" }, children: /* @__PURE__ */ f(K9, { id: `${this.__branch}-builds-${this.__id}`, fitToParentId: o }) });
      }
      return /* @__PURE__ */ f("div", { style: { padding: "24px 0" }, children: /* @__PURE__ */ f(Vf, { id: `${this.__branch}-${this.__id}`, type: this.__subType }) });
    }
    return ["poe-ascendancy"].includes(this.__embedType) ? /* @__PURE__ */ f("div", { className: r.theme.embedWrapper, children: n ? Ei(n, {
      type: this.__embedType,
      id: this.__id,
      profile: this.__profile,
      text: this.__text,
      options: this.__options
    }) : this.__text }) : /* @__PURE__ */ f("span", { className: r.theme.embedWrapper, children: n ? Ei(n, {
      type: this.__embedType,
      id: this.__id,
      profile: this.__profile,
      text: this.__text,
      options: this.__options
    }) : this.__text });
  }
}
function bb(e) {
  return new g0(e);
}
function TP(e) {
  var o;
  const i = e.getTextContent(), r = _T(i);
  if (r.length === 0)
    return null;
  let n = i;
  for (const s of r) {
    const a = new RegExp(
      `\\[${s.type} id=${s.attributes.id}.*?\\[\\/${s.type}\\]`,
      "g"
    ), l = [...n.matchAll(a)][0];
    if (l) {
      const c = ((o = s.attributes) == null ? void 0 : o.icon) !== void 0;
      for (const u of e.splitText(l.index, l.index + l[0].length))
        if (u.getTextContent().startsWith("[")) {
          const m = u, g = bb({
            text: s.content,
            embedType: s.type,
            id: s.attributes.id || "",
            profile: s.attributes.profile || void 0,
            options: {
              options: s.attributes.options,
              preview: s.attributes.preview,
              tooltip: s.attributes.tooltip,
              variant: s.attributes.variant,
              iconOnly: c
            },
            branch: s.attributes.branch || void 0,
            subType: s.attributes.subType || void 0
          });
          return m.replace(g), g;
        }
    }
  }
  return null;
}
function BP(e) {
  let t = e;
  for (; t !== null; ) {
    if (!("isSimpleText" in t) || !t.isSimpleText())
      return;
    t = TP(t);
  }
}
const V5 = L.createCommand(), DP = L.createCommand();
function q5() {
  const [e] = nt.useLexicalComposerContext();
  return be(() => {
    if (!e.hasNodes([g0]))
      throw new Error("EmbedPlugin: EmbedNode not registered on editor");
    return it.mergeRegister(
      e.registerNodeTransform(L.TextNode, BP),
      e.registerCommand(
        V5,
        (t) => (e.update(() => {
          const i = bb({
            embedType: "ad",
            id: `${go()}`,
            text: "",
            branch: "poe",
            subType: t.type || ""
          });
          it.$insertNodeToNearestRoot(L.$createParagraphNode().append(i));
        }), !0),
        L.COMMAND_PRIORITY_LOW
      ),
      e.registerCommand(
        DP,
        (t) => (e.update(() => {
          const i = bb(t);
          ["poe-ascendancy"].includes(t.embedType) ? it.$insertNodeToNearestRoot(L.$createParagraphNode().append(i)) : L.$insertNodes([i]);
        }), !0),
        L.COMMAND_PRIORITY_LOW
      )
    );
  }, [e]), null;
}
var j5 = {}, a3 = nt, Xd = L, f1 = X;
let L5 = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined";
var OP = L5 ? f1.useLayoutEffect : f1.useEffect;
let Jh = { tag: "history-merge" };
function FP(e, t) {
  if (t !== null) {
    if (t === void 0)
      e.update(() => {
        var i = Xd.$getRoot();
        if (i.isEmpty()) {
          let r = Xd.$createParagraphNode();
          i.append(r), i = L5 ? document.activeElement : null, (Xd.$getSelection() !== null || i !== null && i === e.getRootElement()) && r.select();
        }
      }, Jh);
    else if (t !== null)
      switch (typeof t) {
        case "string":
          let i = e.parseEditorState(t);
          e.setEditorState(i, Jh);
          break;
        case "object":
          e.setEditorState(t, Jh);
          break;
        case "function":
          e.update(() => {
            Xd.$getRoot().isEmpty() && t(e);
          }, Jh);
      }
  }
}
j5.LexicalComposer = function({ initialConfig: e, children: t }) {
  let i = f1.useMemo(() => {
    const { theme: r, namespace: n, editor__DEPRECATED: o, nodes: s, onError: a, editorState: l } = e, c = a3.createLexicalComposerContext(null, r);
    let u = o || null;
    if (u === null) {
      const m = Xd.createEditor({ editable: e.editable, namespace: n, nodes: s, onError: (g) => a(g, m), theme: r });
      FP(m, l), u = m;
    }
    return [u, c];
  }, []);
  return OP(() => {
    let r = e.editable, [n] = i;
    n.setEditable(r !== void 0 ? r : !0);
  }, []), f1.createElement(a3.LexicalComposerContext.Provider, { value: i }, t);
};
const VP = j5;
var qP = VP, K5 = {}, jP = nt, l3 = X, LP = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined" ? l3.useLayoutEffect : l3.useEffect;
K5.OnChangePlugin = function({ ignoreHistoryMergeTagChange: e = !0, ignoreSelectionChange: t = !1, onChange: i }) {
  let [r] = jP.useLexicalComposerContext();
  return LP(() => {
    if (i)
      return r.registerUpdateListener(({ editorState: n, dirtyElements: o, dirtyLeaves: s, prevEditorState: a, tags: l }) => {
        t && o.size === 0 && s.size === 0 || e && l.has("history-merge") || a.isEmpty() || i(n, r, l);
      });
  }, [r, e, t, i]), null;
};
const KP = K5;
var YP = KP, Y5 = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function i() {
      for (var r = [], n = 0; n < arguments.length; n++) {
        var o = arguments[n];
        if (o) {
          var s = typeof o;
          if (s === "string" || s === "number")
            r.push(o);
          else if (Array.isArray(o)) {
            if (o.length) {
              var a = i.apply(null, o);
              a && r.push(a);
            }
          } else if (s === "object") {
            if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]")) {
              r.push(o.toString());
              continue;
            }
            for (var l in o)
              t.call(o, l) && o[l] && r.push(l);
          }
        }
      }
      return r.join(" ");
    }
    e.exports ? (i.default = i, e.exports = i) : window.classNames = i;
  })();
})(Y5);
var UP = Y5.exports;
const me = /* @__PURE__ */ Ho(UP);
var U5 = {}, GP = nt, QP = X;
U5.AutoFocusPlugin = function({ defaultSelection: e }) {
  let [t] = GP.useLexicalComposerContext();
  return QP.useEffect(() => {
    t.focus(() => {
      let i = document.activeElement, r = t.getRootElement();
      r === null || i !== null && r.contains(i) || r.focus({ preventScroll: !0 });
    }, { defaultSelection: e });
  }, [e, t]), null;
};
const WP = U5;
var Ym = WP, G5 = {}, mf = {}, Q5 = L;
let m2 = class W5 extends Q5.ElementNode {
  static getType() {
    return "overflow";
  }
  static clone(t) {
    return new W5(t.__key);
  }
  static importJSON() {
    return Z5();
  }
  static importDOM() {
    return null;
  }
  constructor(t) {
    super(t), this.__type = "overflow";
  }
  exportJSON() {
    return ee(q({}, super.exportJSON()), { type: "overflow" });
  }
  createDOM(t) {
    let i = document.createElement("span");
    return t = t.theme.characterLimit, typeof t == "string" && (i.className = t), i;
  }
  updateDOM() {
    return !1;
  }
  insertNewAfter(t, i = !0) {
    return this.getParentOrThrow().insertNewAfter(t, i);
  }
  excludeFromCopy() {
    return !0;
  }
};
function Z5() {
  return Q5.$applyNodeReplacement(new m2());
}
mf.$createOverflowNode = Z5;
mf.$isOverflowNode = function(e) {
  return e instanceof m2;
};
mf.OverflowNode = m2;
const ZP = mf;
var J5 = ZP, Yl = {}, vn = L;
function g2(e, t = !0) {
  return e ? !1 : (e = P5(), t && (e = e.trim()), e === "");
}
function P5() {
  return vn.$getRoot().getTextContent();
}
function z5(e) {
  if (!g2(e, !1))
    return !1;
  e = vn.$getRoot().getChildren();
  let t = e.length;
  if (1 < t)
    return !1;
  for (let r = 0; r < t; r++) {
    var i = e[r];
    if (vn.$isDecoratorNode(i))
      return !1;
    if (vn.$isElementNode(i)) {
      if (!vn.$isParagraphNode(i) || i.__indent !== 0)
        return !1;
      i = i.getChildren();
      let n = i.length;
      for (let o = 0; o < n; o++)
        if (!vn.$isTextNode(i[r]))
          return !1;
    }
  }
  return !0;
}
Yl.$canShowPlaceholder = z5;
Yl.$canShowPlaceholderCurry = function(e) {
  return () => z5(e);
};
Yl.$findTextIntersectionFromCharacters = function(e, t) {
  var i = e.getFirstChild();
  e = 0;
  e:
    for (; i !== null; ) {
      if (vn.$isElementNode(i)) {
        var r = i.getFirstChild();
        if (r !== null) {
          i = r;
          continue;
        }
      } else if (vn.$isTextNode(i)) {
        if (r = i.getTextContentSize(), e + r > t)
          return { node: i, offset: t - e };
        e += r;
      }
      if (r = i.getNextSibling(), r !== null)
        i = r;
      else {
        for (i = i.getParent(); i !== null; ) {
          if (r = i.getNextSibling(), r !== null) {
            i = r;
            continue e;
          }
          i = i.getParent();
        }
        break;
      }
    }
  return null;
};
Yl.$isRootTextContentEmpty = g2;
Yl.$isRootTextContentEmptyCurry = function(e, t) {
  return () => g2(e, t);
};
Yl.$rootTextContent = P5;
Yl.registerLexicalTextEntity = function(e, t, i, r) {
  let n = (s) => {
    const a = vn.$createTextNode(s.getTextContent());
    a.setFormat(s.getFormat()), s.replace(a);
  }, o = e.registerNodeTransform(vn.TextNode, (s) => {
    if (s.isSimpleText()) {
      var a = s.getPreviousSibling(), l = s.getTextContent(), c = s;
      if (vn.$isTextNode(a)) {
        var u = a.getTextContent(), m = t(u + l);
        if (a instanceof i) {
          if (m === null || a.getLatest().__mode !== 0) {
            n(a);
            return;
          }
          if (m = m.end - u.length, 0 < m) {
            c = l.slice(0, m), c = u + c, a.select(), a.setTextContent(c), m === l.length ? s.remove() : (a = l.slice(m), s.setTextContent(a));
            return;
          }
        } else if (m === null || m.start < u.length)
          return;
      }
      for (; ; ) {
        if (s = t(l), l = m = s === null ? "" : l.slice(s.end), m === "") {
          if (u = c.getNextSibling(), vn.$isTextNode(u)) {
            if (m = c.getTextContent() + u.getTextContent(), m = t(m), m === null) {
              u instanceof i ? n(u) : u.markDirty();
              break;
            } else if (m.start !== 0)
              break;
          }
        } else if (u = t(m), u !== null && u.start === 0)
          break;
        if (s === null)
          break;
        if (s.start === 0 && vn.$isTextNode(a) && a.isTextEntity())
          continue;
        let g;
        if (s.start === 0 ? [g, c] = c.splitText(s.end) : [, g, c] = c.splitText(s.start, s.end), s = r(g), s.setFormat(g.getFormat()), g.replace(s), c == null)
          break;
      }
    }
  });
  return e = e.registerNodeTransform(i, (s) => {
    var a = s.getTextContent();
    const l = t(a);
    l === null || l.start !== 0 ? n(s) : a.length > l.end ? s.splitText(l.end) : (a = s.getPreviousSibling(), vn.$isTextNode(a) && a.isTextEntity() && (n(a), n(s)), a = s.getNextSibling(), vn.$isTextNode(a) && a.isTextEntity() && (n(a), s instanceof i && n(s)));
  }), [o, e];
};
const JP = Yl;
var gf = JP, PP = nt, fm = X, _d = J5, zP = gf, c3 = it, ts = L;
function HP(e) {
  let t = new URLSearchParams();
  t.append("code", e);
  for (let i = 1; i < arguments.length; i++)
    t.append("v", arguments[i]);
  throw Error(`Minified Lexical error #${e}; visit https://lexical.dev/docs/error?${t} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
}
function XP(e, t, i = Object.freeze({})) {
  let { strlen: r = (o) => o.length, remainingCharacters: n = () => {
  } } = i;
  fm.useEffect(() => {
    e.hasNodes([_d.OverflowNode]) || HP(57);
  }, [e]), fm.useEffect(() => {
    let o = e.getEditorState().read(zP.$rootTextContent), s = 0;
    return c3.mergeRegister(e.registerTextContentListener((a) => {
      o = a;
    }), e.registerUpdateListener(({ dirtyLeaves: a, dirtyElements: l }) => {
      var c = e.isComposing();
      if (a = 0 < a.size || 0 < l.size, !c && a) {
        if (c = r(o), a = c > t || s !== null && s > t, n(t - c), s === null || a) {
          let u = _P(o, t, r);
          e.update(() => {
            let m = c3.$dfs(), g = m.length, h = 0;
            for (let S = 0; S < g; S += 1) {
              var { node: A } = m[S];
              if (_d.$isOverflowNode(A)) {
                var y = h;
                if (h + A.getTextContentSize() <= u) {
                  var E = A.getParent();
                  y = A.getPreviousSibling();
                  var v = A.getNextSibling();
                  d3(A), A = ts.$getSelection(), !ts.$isRangeSelection(A) || A.anchor.getNode().isAttached() && A.focus.getNode().isAttached() || (ts.$isTextNode(y) ? y.select() : ts.$isTextNode(v) ? v.select() : E !== null && E.select());
                } else
                  y < u && (E = A.getFirstDescendant(), v = E !== null ? E.getTextContentSize() : 0, y += v, E = ts.$isTextNode(E) && E.isSimpleText(), y = y <= u, (E || y) && d3(A));
              } else if (ts.$isLeafNode(A) && (y = h, h += A.getTextContentSize(), h > u && !_d.$isOverflowNode(A.getParent()) && (E = ts.$getSelection(), y < u && ts.$isTextNode(A) && A.isSimpleText() && ([, A] = A.splitText(u - y)), A = u3(A), E !== null && ts.$setSelection(E), y = A.getPreviousSibling(), _d.$isOverflowNode(y)))) {
                v = A.getFirstChild();
                var C = y.getChildren();
                if (E = C.length, v === null)
                  A.append(...C);
                else
                  for (var x = 0; x < E; x++)
                    v.insertBefore(C[x]);
                if (x = ts.$getSelection(), ts.$isRangeSelection(x)) {
                  v = x.anchor, C = v.getNode(), x = x.focus;
                  let R = v.getNode();
                  C.is(y) ? v.set(A.getKey(), v.offset, "element") : C.is(A) && v.set(A.getKey(), E + v.offset, "element"), R.is(y) ? x.set(A.getKey(), x.offset, "element") : R.is(A) && x.set(A.getKey(), E + x.offset, "element");
                }
                y.remove();
              }
            }
          }, { tag: "history-merge" });
        }
        s = c;
      }
    }));
  }, [e, t, n, r]);
}
function _P(e, t, i) {
  var r = Intl.Segmenter;
  let n = 0;
  var o = 0;
  if (typeof r == "function") {
    e = new r().segment(e);
    for (var { segment: s } of e) {
      if (o += i(s), o > t)
        break;
      n += s.length;
    }
  } else
    for (s = Array.from(e), e = s.length, r = 0; r < e; r++) {
      let a = s[r];
      if (o += i(a), o > t)
        break;
      n += a.length;
    }
  return n;
}
function u3(e) {
  let t = _d.$createOverflowNode();
  return e.insertBefore(t), t.append(e), t;
}
function d3(e) {
  let t = e.getChildren(), i = t.length;
  for (let r = 0; r < i; r++)
    e.insertBefore(t[r]);
  return e.remove(), 0 < i ? t[i - 1] : null;
}
let Uy = null;
G5.CharacterLimitPlugin = function({ charset: e = "UTF-16", maxLength: t = 5 }) {
  let [i] = PP.useLexicalComposerContext(), [r, n] = fm.useState(t), o = fm.useMemo(() => ({ remainingCharacters: n, strlen: (s) => {
    if (e === "UTF-8") {
      if (window.TextEncoder === void 0)
        var a = null;
      else
        Uy === null && (Uy = new window.TextEncoder()), a = Uy;
      return a === null ? (a = encodeURIComponent(s).match(/%[89ABab]/g), s = s.length + (a ? a.length : 0)) : s = a.encode(s).length, s;
    }
    if (e === "UTF-16")
      return s.length;
    throw Error("Unrecognized charset");
  } }), [e]);
  return XP(i, t, o), fm.createElement(
    "span",
    { className: `characters-limit ${0 > r ? "characters-limit-exceeded" : ""}` },
    r
  );
};
const $P = G5;
var H5 = $P, X5 = {}, wn = {}, li = L, Ol = it;
function h0(e) {
  let t = new URLSearchParams();
  t.append("code", e);
  for (let i = 1; i < arguments.length; i++)
    t.append("v", arguments[i]);
  throw Error(`Minified Lexical error #${e}; visit https://lexical.dev/docs/error?${t} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
}
function _5(e) {
  let t = 1;
  for (e = e.getParent(); e != null; ) {
    if (Pi(e)) {
      if (e = e.getParent(), Qt(e)) {
        t++, e = e.getParent();
        continue;
      }
      h0(40);
    }
    break;
  }
  return t;
}
function Cb(e) {
  e = e.getParent(), Qt(e) || h0(40);
  let t = e;
  for (; t !== null; )
    t = t.getParent(), Qt(t) && (e = t);
  return e;
}
function $5(e) {
  let t = [];
  e = e.getChildren().filter(Pi);
  for (let i = 0; i < e.length; i++) {
    let r = e[i], n = r.getFirstChild();
    Qt(n) ? t = t.concat($5(n)) : t.push(r);
  }
  return t;
}
function ks(e) {
  return Pi(e) && Qt(e.getFirstChild());
}
function ez(e) {
  for (; e.getNextSibling() == null && e.getPreviousSibling() == null; ) {
    let t = e.getParent();
    if (t == null || !Pi(e) && !Qt(e))
      break;
    e = t;
  }
  e.remove();
}
function m3(e) {
  return po().append(e);
}
function eB(e, t) {
  return Pi(e) && (t.length === 0 || t.length === 1 && e.is(t[0]) && e.getChildrenSize() === 0);
}
function Kc(e, t) {
  e.splice(e.getChildrenSize(), 0, t);
}
function g3(e, t) {
  if (Qt(e))
    return e;
  let i = e.getPreviousSibling(), r = e.getNextSibling(), n = po();
  return n.setFormat(e.getFormatType()), n.setIndent(e.getIndent()), Kc(n, e.getChildren()), Qt(i) && t === i.getListType() ? (i.append(n), e.remove(), Qt(r) && t === r.getListType() && (Kc(i, r.getChildren()), r.remove()), i) : Qt(r) && t === r.getListType() ? (r.getFirstChildOrThrow().insertBefore(n), e.remove(), r) : (t = In(t), t.append(n), e.replace(t), En(t), t);
}
function tB(e, t) {
  var i = e.getLastChild();
  let r = t.getFirstChild();
  i && r && ks(i) && ks(r) && (tB(i.getFirstChild(), r.getFirstChild()), r.remove()), i = t.getChildren(), 0 < i.length && (e.append(...i), En(e)), t.remove();
}
function En(e, t) {
  if (e = t || e.getChildren(), e !== void 0)
    for (t = 0; t < e.length; t++) {
      let o = e[t];
      if (Pi(o)) {
        let s = o.getValue();
        var i = o, r = i.getParent(), n = 1;
        for (r != null && (Qt(r) ? n = r.getStart() : h0(44)), i = i.getPreviousSiblings(), r = 0; r < i.length; r++) {
          let a = i[r];
          Pi(a) && !Qt(a.getFirstChild()) && n++;
        }
        s !== n && o.setValue(n);
      }
    }
}
function tz(e) {
  if (!ks(e)) {
    var t = e.getParent(), i = t ? t.getParent() : void 0, r = i ? i.getParent() : void 0;
    if (Qt(r) && Pi(i) && Qt(t)) {
      var n = t ? t.getFirstChild() : void 0, o = t ? t.getLastChild() : void 0;
      if (e.is(n))
        i.insertBefore(e), t.isEmpty() && i.remove();
      else if (e.is(o))
        i.insertAfter(e), t.isEmpty() && i.remove();
      else {
        var s = t.getListType();
        n = po();
        let a = In(s);
        n.append(a), e.getPreviousSiblings().forEach((l) => a.append(l)), o = po(), s = In(s), o.append(s), Kc(s, e.getNextSiblings()), i.insertBefore(n), i.insertAfter(o), i.replace(e);
      }
      En(t), En(r);
    }
  }
}
let hf = class iB extends li.ElementNode {
  static getType() {
    return "listitem";
  }
  static clone(t) {
    return new iB(t.__value, t.__checked, t.__key);
  }
  constructor(t, i, r) {
    super(r), this.__value = t === void 0 ? 1 : t, this.__checked = i;
  }
  createDOM(t) {
    let i = document.createElement("li"), r = this.getParent();
    return Qt(r) && r.getListType() === "check" && p3(i, this, null), i.value = this.__value, h3(i, t.theme, this), i;
  }
  updateDOM(t, i, r) {
    let n = this.getParent();
    return Qt(n) && n.getListType() === "check" && p3(i, this, t), i.value = this.__value, h3(i, r.theme, this), !1;
  }
  static transform() {
    return (t) => {
      let i = t.getParent();
      Qt(i) && (En(i), i.getListType() !== "check" && t.getChecked() != null && t.setChecked(void 0));
    };
  }
  static importDOM() {
    return { li: () => ({ conversion: iz, priority: 0 }) };
  }
  static importJSON(t) {
    let i = po();
    return i.setChecked(t.checked), i.setValue(t.value), i.setFormat(t.format), i.setDirection(t.direction), i;
  }
  exportJSON() {
    return ee(q({}, super.exportJSON()), { checked: this.getChecked(), type: "listitem", value: this.getValue(), version: 1 });
  }
  append(...t) {
    for (let i = 0; i < t.length; i++) {
      let r = t[i];
      if (li.$isElementNode(r) && this.canMergeWith(r)) {
        let n = r.getChildren();
        this.append(...n), r.remove();
      } else
        super.append(r);
    }
    return this;
  }
  replace(t, i) {
    if (Pi(t))
      return super.replace(t);
    this.setIndent(0);
    let r = this.getParentOrThrow();
    if (!Qt(r))
      return t;
    if (r.__first === this.getKey())
      r.insertBefore(t);
    else if (r.__last === this.getKey())
      r.insertAfter(t);
    else {
      let n = In(r.getListType()), o = this.getNextSibling();
      for (; o; ) {
        let s = o;
        o = o.getNextSibling(), n.append(s);
      }
      r.insertAfter(t), t.insertAfter(n);
    }
    return i && this.getChildren().forEach((n) => {
      t.append(n);
    }), this.remove(), r.getChildrenSize() === 0 && r.remove(), t;
  }
  insertAfter(t, i = !0) {
    var r = this.getParentOrThrow();
    Qt(r) || h0(39);
    var n = this.getNextSiblings();
    if (Pi(t))
      return i = super.insertAfter(t, i), t = t.getParentOrThrow(), Qt(t) && En(t), i;
    if (Qt(t)) {
      for (r = t, t = t.getChildren(), n = t.length - 1; 0 <= n; n--)
        r = t[n], this.insertAfter(r, i);
      return r;
    }
    if (r.insertAfter(t, i), n.length !== 0) {
      let o = In(r.getListType());
      n.forEach((s) => o.append(s)), t.insertAfter(o, i);
    }
    return t;
  }
  remove(t) {
    let i = this.getPreviousSibling(), r = this.getNextSibling();
    super.remove(t), i && r && ks(i) && ks(r) ? (tB(
      i.getFirstChild(),
      r.getFirstChild()
    ), r.remove()) : r && (t = r.getParent(), Qt(t) && En(t));
  }
  insertNewAfter(t, i = !0) {
    return t = po(this.__checked == null ? void 0 : !1), this.insertAfter(t, i), t;
  }
  collapseAtStart(t) {
    let i = li.$createParagraphNode();
    this.getChildren().forEach((s) => i.append(s));
    var r = this.getParentOrThrow(), n = r.getParentOrThrow();
    let o = Pi(n);
    return r.getChildrenSize() === 1 ? o ? (r.remove(), n.select()) : (r.insertBefore(i), r.remove(), r = t.anchor, t = t.focus, n = i.getKey(), r.type === "element" && r.getNode().is(this) && r.set(n, r.offset, "element"), t.type === "element" && t.getNode().is(this) && t.set(n, t.offset, "element")) : (r.insertBefore(i), this.remove()), !0;
  }
  getValue() {
    return this.getLatest().__value;
  }
  setValue(t) {
    this.getWritable().__value = t;
  }
  getChecked() {
    return this.getLatest().__checked;
  }
  setChecked(t) {
    this.getWritable().__checked = t;
  }
  toggleChecked() {
    this.setChecked(!this.__checked);
  }
  getIndent() {
    var t = this.getParent();
    if (t === null)
      return this.getLatest().__indent;
    t = t.getParentOrThrow();
    let i = 0;
    for (; Pi(t); )
      t = t.getParentOrThrow().getParentOrThrow(), i++;
    return i;
  }
  setIndent(t) {
    typeof t == "number" && -1 < t || h0(117);
    let i = this.getIndent();
    for (; i !== t; )
      if (i < t) {
        e: {
          var r = /* @__PURE__ */ new Set();
          if (ks(this) || r.has(this.getKey()))
            break e;
          let a = this.getParent();
          var n = this.getNextSibling(), o = this.getPreviousSibling();
          if (ks(n) && ks(o)) {
            if (o = o.getFirstChild(), Qt(o)) {
              o.append(this);
              var s = n.getFirstChild();
              Qt(s) && (s = s.getChildren(), Kc(o, s), n.remove(), r.add(n.getKey())), En(o);
            }
          } else
            ks(n) ? (n = n.getFirstChild(), Qt(n) && (r = n.getFirstChild(), r !== null && r.insertBefore(this), En(n))) : ks(o) ? (n = o.getFirstChild(), Qt(n) && (n.append(this), En(n))) : Qt(a) && (r = po(), s = In(a.getListType()), r.append(s), s.append(this), o ? o.insertAfter(r) : n ? n.insertBefore(r) : a.append(r), En(s));
          Qt(a) && En(a);
        }
        i++;
      } else
        tz(this), i--;
    return this;
  }
  insertBefore(t) {
    if (Pi(t)) {
      let i = this.getParentOrThrow();
      if (Qt(i)) {
        let r = this.getNextSiblings();
        En(i, r);
      }
    }
    return super.insertBefore(t);
  }
  canInsertAfter(t) {
    return Pi(t);
  }
  canReplaceWith(t) {
    return Pi(t);
  }
  canMergeWith(t) {
    return li.$isParagraphNode(t) || Pi(t);
  }
  extractWithChild(t, i) {
    if (!li.$isRangeSelection(i))
      return !1;
    t = i.anchor.getNode();
    let r = i.focus.getNode();
    return this.isParentOf(t) && this.isParentOf(r) && this.getTextContent().length === i.getTextContent().length;
  }
  isParentRequired() {
    return !0;
  }
  createParentElementNode() {
    return In("bullet");
  }
};
function h3(e, t, i) {
  let r = [], n = [];
  var o = (t = t.list) ? t.listitem : void 0;
  if (t && t.nested)
    var s = t.nested.listitem;
  if (o !== void 0 && (o = o.split(" "), r.push(...o)), t) {
    o = i.getParent(), o = Qt(o) && o.getListType() === "check";
    let a = i.getChecked();
    o && !a || n.push(t.listitemUnchecked), o && a || n.push(t.listitemChecked), o && r.push(a ? t.listitemChecked : t.listitemUnchecked);
  }
  s !== void 0 && (s = s.split(" "), i.getChildren().some((a) => Qt(a)) ? r.push(...s) : n.push(...s)), 0 < n.length && Ol.removeClassNamesFromElement(e, ...n), 0 < r.length && Ol.addClassNamesToElement(
    e,
    ...r
  );
}
function p3(e, t, i) {
  Qt(t.getFirstChild()) ? (e.removeAttribute("role"), e.removeAttribute("tabIndex"), e.removeAttribute("aria-checked")) : (e.setAttribute("role", "checkbox"), e.setAttribute("tabIndex", "-1"), i && t.__checked === i.__checked || e.setAttribute("aria-checked", t.getChecked() ? "true" : "false"));
}
function iz(e) {
  return e = Ol.isHTMLElement(e) && e.getAttribute("aria-checked") === "true", { node: po(e) };
}
function po(e) {
  return li.$applyNodeReplacement(new hf(void 0, e));
}
function Pi(e) {
  return e instanceof hf;
}
let h2 = class rB extends li.ElementNode {
  static getType() {
    return "list";
  }
  static clone(t) {
    return new rB(t.__listType || y3[t.__tag], t.__start, t.__key);
  }
  constructor(t, i, r) {
    super(r), this.__listType = t = y3[t] || t, this.__tag = t === "number" ? "ol" : "ul", this.__start = i;
  }
  getTag() {
    return this.__tag;
  }
  setListType(t) {
    let i = this.getWritable();
    i.__listType = t, i.__tag = t === "number" ? "ol" : "ul";
  }
  getListType() {
    return this.__listType;
  }
  getStart() {
    return this.__start;
  }
  createDOM(t) {
    let i = document.createElement(this.__tag);
    return this.__start !== 1 && i.setAttribute(
      "start",
      String(this.__start)
    ), i.__lexicalListType = this.__listType, f3(i, t.theme, this), i;
  }
  updateDOM(t, i, r) {
    return t.__tag !== this.__tag ? !0 : (f3(i, r.theme, this), !1);
  }
  static importDOM() {
    return { ol: () => ({ conversion: A3, priority: 0 }), ul: () => ({ conversion: A3, priority: 0 }) };
  }
  static importJSON(t) {
    let i = In(t.listType, t.start);
    return i.setFormat(t.format), i.setIndent(t.indent), i.setDirection(t.direction), i;
  }
  exportDOM(t) {
    return { element: t } = super.exportDOM(t), t && Ol.isHTMLElement(t) && (this.__start !== 1 && t.setAttribute("start", String(this.__start)), this.__listType === "check" && t.setAttribute("__lexicalListType", "check")), { element: t };
  }
  exportJSON() {
    return ee(q({}, super.exportJSON()), { listType: this.getListType(), start: this.getStart(), tag: this.getTag(), type: "list", version: 1 });
  }
  canBeEmpty() {
    return !1;
  }
  canIndent() {
    return !1;
  }
  append(...t) {
    for (let r = 0; r < t.length; r++) {
      var i = t[r];
      if (Pi(i))
        super.append(i);
      else {
        let n = po();
        Qt(i) || li.$isElementNode(i) && (i = li.$createTextNode(i.getTextContent())), n.append(i), super.append(n);
      }
    }
    return En(this), this;
  }
  extractWithChild(t) {
    return Pi(t);
  }
};
function f3(e, t, i) {
  let r = [], n = [];
  var o = t.list;
  if (o !== void 0) {
    let a = o[`${i.__tag}Depth`] || [];
    t = _5(i) - 1;
    let l = t % a.length;
    var s = a[l];
    let c = o[i.__tag], u;
    if (o = o.nested, o !== void 0 && o.list && (u = o.list), c !== void 0 && r.push(c), s !== void 0)
      for (s = s.split(" "), r.push(...s), s = 0; s < a.length; s++)
        s !== l && n.push(i.__tag + s);
    u !== void 0 && (i = u.split(" "), 1 < t ? r.push(...i) : n.push(...i));
  }
  0 < n.length && Ol.removeClassNamesFromElement(e, ...n), 0 < r.length && Ol.addClassNamesToElement(e, ...r);
}
function rz(e) {
  let t = [];
  for (let r = 0; r < e.length; r++) {
    var i = e[r];
    Pi(i) ? (t.push(i), i = i.getChildren(), 1 < i.length && i.forEach((n) => {
      Qt(n) && t.push(m3(n));
    })) : t.push(m3(i));
  }
  return t;
}
function A3(e) {
  let t = e.nodeName.toLowerCase(), i = null;
  return t === "ol" ? i = In("number", e.start) : t === "ul" && (i = Ol.isHTMLElement(e) && e.getAttribute("__lexicallisttype") === "check" ? In("check") : In("bullet")), { after: rz, node: i };
}
let y3 = { ol: "number", ul: "bullet" };
function In(e, t = 1) {
  return li.$applyNodeReplacement(new h2(e, t));
}
function Qt(e) {
  return e instanceof h2;
}
let nz = li.createCommand("INSERT_UNORDERED_LIST_COMMAND"), oz = li.createCommand("INSERT_ORDERED_LIST_COMMAND"), sz = li.createCommand("INSERT_CHECK_LIST_COMMAND"), az = li.createCommand("REMOVE_LIST_COMMAND");
wn.$createListItemNode = po;
wn.$createListNode = In;
wn.$getListDepth = _5;
wn.$handleListInsertParagraph = function() {
  var e = li.$getSelection();
  if (!li.$isRangeSelection(e) || !e.isCollapsed() || (e = e.anchor.getNode(), !Pi(e) || e.getChildrenSize() !== 0))
    return !1;
  var t = Cb(e), i = e.getParent();
  Qt(i) || h0(40);
  let r = i.getParent(), n;
  if (li.$isRootOrShadowRoot(r))
    n = li.$createParagraphNode(), t.insertAfter(n);
  else if (Pi(r))
    n = po(), r.insertAfter(n);
  else
    return !1;
  if (n.select(), t = e.getNextSiblings(), 0 < t.length) {
    let o = In(i.getListType());
    li.$isParagraphNode(n) ? n.insertAfter(o) : (i = po(), i.append(o), n.insertAfter(i)), t.forEach((s) => {
      s.remove(), o.append(s);
    });
  }
  return ez(e), !0;
};
wn.$isListItemNode = Pi;
wn.$isListNode = Qt;
wn.INSERT_CHECK_LIST_COMMAND = sz;
wn.INSERT_ORDERED_LIST_COMMAND = oz;
wn.INSERT_UNORDERED_LIST_COMMAND = nz;
wn.ListItemNode = hf;
wn.ListNode = h2;
wn.REMOVE_LIST_COMMAND = az;
wn.insertList = function(e, t) {
  e.update(() => {
    var i = li.$getSelection();
    if (li.$isRangeSelection(i) || li.DEPRECATED_$isGridSelection(i)) {
      var r = i.getNodes();
      i = i.anchor.getNode();
      var n = i.getParent();
      if (eB(i, r))
        r = In(t), li.$isRootOrShadowRoot(n) ? (i.replace(r), n = po(), li.$isElementNode(i) && (n.setFormat(i.getFormatType()), n.setIndent(i.getIndent())), r.append(n)) : Pi(i) && (i = i.getParentOrThrow(), Kc(r, i.getChildren()), i.replace(r));
      else
        for (i = /* @__PURE__ */ new Set(), n = 0; n < r.length; n++) {
          var o = r[n];
          if (li.$isElementNode(o) && o.isEmpty() && !i.has(o.getKey()))
            g3(
              o,
              t
            );
          else if (li.$isLeafNode(o))
            for (o = o.getParent(); o != null; ) {
              let a = o.getKey();
              if (Qt(o)) {
                if (!i.has(a)) {
                  var s = In(t);
                  Kc(s, o.getChildren()), o.replace(s), En(s), i.add(a);
                }
                break;
              } else {
                if (s = o.getParent(), li.$isRootOrShadowRoot(s) && !i.has(a)) {
                  i.add(a), g3(o, t);
                  break;
                }
                o = s;
              }
            }
        }
    }
  });
};
wn.removeList = function(e) {
  e.update(() => {
    let t = li.$getSelection();
    if (li.$isRangeSelection(t)) {
      var i = /* @__PURE__ */ new Set(), r = t.getNodes(), n = t.anchor.getNode();
      if (eB(n, r))
        i.add(Cb(n));
      else
        for (n = 0; n < r.length; n++) {
          var o = r[n];
          li.$isLeafNode(o) && (o = Ol.$getNearestNodeOfType(o, hf), o != null && i.add(Cb(o)));
        }
      for (let s of i) {
        i = s, r = $5(s);
        for (let a of r)
          r = li.$createParagraphNode(), Kc(r, a.getChildren()), i.insertAfter(r), i = r, a.__key === t.anchor.key && t.anchor.set(r.getKey(), 0, "element"), a.__key === t.focus.key && t.focus.set(r.getKey(), 0, "element"), a.remove();
        s.remove();
      }
    }
  });
};
const lz = wn;
var zi = lz, Ts = zi, cz = nt, A1 = it, Ur = L, uz = X;
function nB(e, t) {
  let i = e.target;
  if (i !== null && A1.isHTMLElement(i)) {
    var r = i.firstChild;
    (r == null || !A1.isHTMLElement(r) || r.tagName !== "UL" && r.tagName !== "OL") && (r = i.parentNode) && r.__lexicalListType === "check" && (e = e.pageX, r = i.getBoundingClientRect(), (i.dir === "rtl" ? e < r.right && e > r.right - 20 : e > r.left && e < r.left + 20) && t());
  }
}
function E3(e) {
  nB(e, () => {
    let t = e.target, i = dz(t);
    i != null && i.isEditable() && i.update(() => {
      if (e.target) {
        let r = Ur.$getNearestNodeFromDOMNode(t);
        Ts.$isListItemNode(r) && (t.focus(), r.toggleChecked());
      }
    });
  });
}
function v3(e) {
  nB(e, () => {
    e.preventDefault();
  });
}
function dz(e) {
  for (; e; ) {
    if (e.__lexicalEditor)
      return e.__lexicalEditor;
    e = e.parentNode;
  }
  return null;
}
function xb() {
  let e = document.activeElement;
  return e != null && e.tagName === "LI" && e.parentNode != null && e.parentNode.__lexicalListType === "check" ? e : null;
}
function mz(e, t) {
  let i = t ? e.getPreviousSibling() : e.getNextSibling();
  for (; i == null && Ts.$isListItemNode(e); )
    e = e.getParentOrThrow().getParent(), e != null && (i = t ? e.getPreviousSibling() : e.getNextSibling());
  for (; Ts.$isListItemNode(i); ) {
    if (e = t ? i.getLastChild() : i.getFirstChild(), !Ts.$isListNode(e))
      return i;
    i = t ? e.getLastChild() : e.getFirstChild();
  }
  return null;
}
function b3(e, t, i) {
  let r = xb();
  return r != null && t.update(() => {
    var n = Ur.$getNearestNodeFromDOMNode(r);
    if (Ts.$isListItemNode(n) && (n = mz(n, i), n != null)) {
      n.selectStart();
      let o = t.getElementByKey(n.__key);
      o != null && (e.preventDefault(), setTimeout(() => {
        o.focus();
      }, 0));
    }
  }), !1;
}
X5.CheckListPlugin = function() {
  let [e] = cz.useLexicalComposerContext();
  return uz.useEffect(() => A1.mergeRegister(
    e.registerCommand(Ts.INSERT_CHECK_LIST_COMMAND, () => (Ts.insertList(e, "check"), !0), Ur.COMMAND_PRIORITY_LOW),
    e.registerCommand(Ur.KEY_ARROW_DOWN_COMMAND, (t) => b3(t, e, !1), Ur.COMMAND_PRIORITY_LOW),
    e.registerCommand(Ur.KEY_ARROW_UP_COMMAND, (t) => b3(t, e, !0), Ur.COMMAND_PRIORITY_LOW),
    e.registerCommand(Ur.KEY_ESCAPE_COMMAND, () => {
      if (xb() != null) {
        let t = e.getRootElement();
        return t != null && t.focus(), !0;
      }
      return !1;
    }, Ur.COMMAND_PRIORITY_LOW),
    e.registerCommand(Ur.KEY_SPACE_COMMAND, (t) => {
      let i = xb();
      return i != null && e.isEditable() ? (e.update(() => {
        let r = Ur.$getNearestNodeFromDOMNode(i);
        Ts.$isListItemNode(r) && (t.preventDefault(), r.toggleChecked());
      }), !0) : !1;
    }, Ur.COMMAND_PRIORITY_LOW),
    e.registerCommand(Ur.KEY_ARROW_LEFT_COMMAND, (t) => e.getEditorState().read(() => {
      var i = Ur.$getSelection();
      if (Ur.$isRangeSelection(i) && i.isCollapsed()) {
        var { anchor: r } = i;
        if ((i = r.type === "element") || r.offset === 0) {
          r = r.getNode();
          let n = A1.$findMatchingParent(r, (o) => Ur.$isElementNode(o) && !o.isInline());
          if (Ts.$isListItemNode(n)) {
            let o = n.getParent();
            if (Ts.$isListNode(o) && o.getListType() === "check" && (i || n.getFirstDescendant() === r) && (i = e.getElementByKey(n.__key), i != null && document.activeElement !== i))
              return i.focus(), t.preventDefault(), !0;
          }
        }
      }
      return !1;
    }), Ur.COMMAND_PRIORITY_LOW),
    e.registerRootListener((t, i) => {
      t !== null && (t.addEventListener("click", E3), t.addEventListener("pointerdown", v3)), i !== null && (i.removeEventListener("click", E3), i.removeEventListener("pointerdown", v3));
    })
  )), null;
};
const gz = X5;
var oB = gz, sB = {}, hz = nt, Rd = L, C3 = X, pz = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined" ? C3.useLayoutEffect : C3.useEffect;
sB.ClearEditorPlugin = function({ onClear: e }) {
  let [t] = hz.useLexicalComposerContext();
  return pz(() => t.registerCommand(Rd.CLEAR_EDITOR_COMMAND, () => (t.update(() => {
    if (e == null) {
      let i = Rd.$getRoot(), r = Rd.$getSelection(), n = Rd.$createParagraphNode();
      i.clear(), i.append(n), r !== null && n.select();
    } else
      e();
  }), !0), Rd.COMMAND_PRIORITY_EDITOR), [t, e]), null;
};
const fz = sB;
var Az = fz, qa = {}, aB = it, qs = L;
let yz = /* @__PURE__ */ new Set(["http:", "https:", "mailto:", "sms:", "tel:"]), pf = class lB extends qs.ElementNode {
  static getType() {
    return "link";
  }
  static clone(t) {
    return new lB(t.__url, { rel: t.__rel, target: t.__target, title: t.__title }, t.__key);
  }
  constructor(t, i = {}, r) {
    super(r);
    let { target: n = null, rel: o = null, title: s = null } = i;
    this.__url = t, this.__target = n, this.__rel = o, this.__title = s;
  }
  createDOM(t) {
    let i = document.createElement("a");
    return i.href = this.sanitizeUrl(this.__url), this.__target !== null && (i.target = this.__target), this.__rel !== null && (i.rel = this.__rel), this.__title !== null && (i.title = this.__title), aB.addClassNamesToElement(
      i,
      t.theme.link
    ), i;
  }
  updateDOM(t, i) {
    let r = this.__url, n = this.__target, o = this.__rel, s = this.__title;
    return r !== t.__url && (i.href = r), n !== t.__target && (n ? i.target = n : i.removeAttribute("target")), o !== t.__rel && (o ? i.rel = o : i.removeAttribute("rel")), s !== t.__title && (s ? i.title = s : i.removeAttribute("title")), !1;
  }
  static importDOM() {
    return { a: () => ({ conversion: Ez, priority: 1 }) };
  }
  static importJSON(t) {
    let i = Um(t.url, { rel: t.rel, target: t.target, title: t.title });
    return i.setFormat(t.format), i.setIndent(t.indent), i.setDirection(t.direction), i;
  }
  sanitizeUrl(t) {
    try {
      let i = new URL(t);
      if (!yz.has(i.protocol))
        return "about:blank";
    } catch (i) {
    }
    return t;
  }
  exportJSON() {
    return ee(q({}, super.exportJSON()), { rel: this.getRel(), target: this.getTarget(), title: this.getTitle(), type: "link", url: this.getURL(), version: 1 });
  }
  getURL() {
    return this.getLatest().__url;
  }
  setURL(t) {
    this.getWritable().__url = t;
  }
  getTarget() {
    return this.getLatest().__target;
  }
  setTarget(t) {
    this.getWritable().__target = t;
  }
  getRel() {
    return this.getLatest().__rel;
  }
  setRel(t) {
    this.getWritable().__rel = t;
  }
  getTitle() {
    return this.getLatest().__title;
  }
  setTitle(t) {
    this.getWritable().__title = t;
  }
  insertNewAfter(t, i = !0) {
    return t = this.getParentOrThrow().insertNewAfter(t, i), qs.$isElementNode(t) ? (i = Um(this.__url, { rel: this.__rel, target: this.__target, title: this.__title }), t.append(i), i) : null;
  }
  canInsertTextBefore() {
    return !1;
  }
  canInsertTextAfter() {
    return !1;
  }
  canBeEmpty() {
    return !1;
  }
  isInline() {
    return !0;
  }
  extractWithChild(t, i) {
    if (!qs.$isRangeSelection(i))
      return !1;
    t = i.anchor.getNode();
    let r = i.focus.getNode();
    return this.isParentOf(t) && this.isParentOf(r) && 0 < i.getTextContent().length;
  }
};
function Ez(e) {
  let t = null;
  if (aB.isHTMLAnchorElement(e)) {
    let i = e.textContent;
    i !== null && i !== "" && (t = Um(e.getAttribute("href") || "", { rel: e.getAttribute("rel"), target: e.getAttribute("target"), title: e.getAttribute("title") }));
  }
  return { node: t };
}
function Um(e, t) {
  return qs.$applyNodeReplacement(new pf(e, t));
}
function gc(e) {
  return e instanceof pf;
}
let p2 = class cB extends pf {
  static getType() {
    return "autolink";
  }
  static clone(t) {
    return new cB(t.__url, { rel: t.__rel, target: t.__target, title: t.__title }, t.__key);
  }
  static importJSON(t) {
    let i = Ib(t.url, { rel: t.rel, target: t.target, title: t.title });
    return i.setFormat(t.format), i.setIndent(t.indent), i.setDirection(t.direction), i;
  }
  static importDOM() {
    return null;
  }
  exportJSON() {
    return ee(q({}, super.exportJSON()), { type: "autolink", version: 1 });
  }
  insertNewAfter(t, i = !0) {
    return t = this.getParentOrThrow().insertNewAfter(t, i), qs.$isElementNode(t) ? (i = Ib(this.__url, { rel: this._rel, target: this.__target, title: this.__title }), t.append(i), i) : null;
  }
};
function Ib(e, t) {
  return qs.$applyNodeReplacement(new p2(e, t));
}
let vz = qs.createCommand("TOGGLE_LINK_COMMAND");
function bz(e, t) {
  for (; e !== null && (e = e.getParent()) !== null && !t(e); )
    ;
  return e;
}
qa.$createAutoLinkNode = Ib;
qa.$createLinkNode = Um;
qa.$isAutoLinkNode = function(e) {
  return e instanceof p2;
};
qa.$isLinkNode = gc;
qa.AutoLinkNode = p2;
qa.LinkNode = pf;
qa.TOGGLE_LINK_COMMAND = vz;
qa.toggleLink = function(e, t = {}) {
  let { target: i, title: r } = t, n = t.rel === void 0 ? "noreferrer" : t.rel;
  if (t = qs.$getSelection(), qs.$isRangeSelection(t))
    if (t = t.extract(), e === null)
      t.forEach((s) => {
        if (s = s.getParent(), gc(s)) {
          let a = s.getChildren();
          for (let l = 0; l < a.length; l++)
            s.insertBefore(a[l]);
          s.remove();
        }
      });
    else {
      if (t.length === 1) {
        var o = t[0];
        if (o = gc(o) ? o : bz(o, gc), o !== null) {
          o.setURL(e), i !== void 0 && o.setTarget(i), n !== null && o.setRel(n), r !== void 0 && o.setTitle(r);
          return;
        }
      }
      let s = null, a = null;
      t.forEach((l) => {
        var c = l.getParent();
        if (c !== a && c !== null && (!qs.$isElementNode(l) || l.isInline()))
          if (gc(c))
            a = c, c.setURL(e), i !== void 0 && c.setTarget(i), n !== null && a.setRel(n), r !== void 0 && a.setTitle(r);
          else if (c.is(s) || (s = c, a = Um(e, { rel: n, target: i }), gc(c) ? l.getPreviousSibling() === null ? c.insertBefore(a) : c.insertAfter(a) : l.insertBefore(a)), gc(l)) {
            if (!l.is(a)) {
              if (a !== null) {
                c = l.getChildren();
                for (let u = 0; u < c.length; u++)
                  a.append(c[u]);
              }
              l.remove();
            }
          } else
            a !== null && a.append(l);
      });
    }
};
const Cz = qa;
var Ii = Cz, xz = Ii, Iz = nt, x3 = it, kd = L, Sz = X, Rz = function({ newTab: e = !0 }) {
  let [t] = Iz.useLexicalComposerContext();
  return Sz.useEffect(() => {
    let i = (n) => {
      const o = n.target;
      if (o instanceof Node) {
        var s = kd.getNearestEditorFromDOMNode(o);
        if (s !== null) {
          var a = null, l = null;
          s.update(() => {
            var c = kd.$getNearestNodeFromDOMNode(o);
            if (c !== null)
              if (c = x3.$findMatchingParent(c, kd.$isElementNode), xz.$isLinkNode(c))
                a = c.getURL(), l = c.getTarget();
              else {
                e: {
                  c = x3.isHTMLAnchorElement;
                  let u = o;
                  for (; u != null; ) {
                    if (c(u)) {
                      c = u;
                      break e;
                    }
                    u = u.parentNode;
                  }
                  c = null;
                }
                c !== null && (a = c.href, l = c.target);
              }
          }), a !== null && a !== "" && (s = t.getEditorState().read(kd.$getSelection), (!kd.$isRangeSelection(s) || s.isCollapsed()) && (s = n.type === "auxclick" && n.button === 1, window.open(a, e || s || n.metaKey || n.ctrlKey || l === "_blank" ? "_blank" : "_self")), n.preventDefault());
        }
      }
    }, r = (n) => {
      n.button === 1 && t.isEditable() && i(n);
    };
    return t.registerRootListener((n, o) => {
      o !== null && (o.removeEventListener("click", i), o.removeEventListener("mouseup", r)), n !== null && (n.addEventListener("click", i), n.addEventListener("mouseup", r));
    });
  }, [t, e]), null;
};
const kz = Rz;
var wz = kz;
const Sb = /* @__PURE__ */ Ho(wz);
var Am = X;
function Rb(e, t) {
  return Rb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, r) {
    return i.__proto__ = r, i;
  }, Rb(e, t);
}
function Mz(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Rb(e, t);
}
function Nz(e, t) {
  return e === void 0 && (e = []), t === void 0 && (t = []), e.length !== t.length || e.some(function(i, r) {
    return !Object.is(i, t[r]);
  });
}
var I3 = { error: null }, Tz = function(e) {
  function t() {
    for (var r, n = arguments.length, o = Array(n), s = 0; s < n; s++)
      o[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(o)) || this, r.state = I3, r.resetErrorBoundary = function() {
      for (var a, l = arguments.length, c = Array(l), u = 0; u < l; u++)
        c[u] = arguments[u];
      r.props.onReset == null || (a = r.props).onReset.apply(a, c), r.reset();
    }, r;
  }
  Mz(t, e), t.getDerivedStateFromError = function(r) {
    return { error: r };
  };
  var i = t.prototype;
  return i.reset = function() {
    this.setState(I3);
  }, i.componentDidCatch = function(r, n) {
    var o, s;
    (o = (s = this.props).onError) == null || o.call(s, r, n);
  }, i.componentDidUpdate = function(r, n) {
    var o = this.props.resetKeys;
    if (this.state.error !== null && n.error !== null && Nz(r.resetKeys, o)) {
      var s, a;
      (s = (a = this.props).onResetKeysChange) == null || s.call(a, r.resetKeys, o), this.reset();
    }
  }, i.render = function() {
    var r = this.state.error, n = this.props, o = n.fallbackRender, s = n.FallbackComponent;
    if (n = n.fallback, r !== null) {
      if (r = { error: r, resetErrorBoundary: this.resetErrorBoundary }, Am.isValidElement(n))
        return n;
      if (typeof o == "function")
        return o(r);
      if (s)
        return Am.createElement(s, r);
      throw Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");
    }
    return this.props.children;
  }, t;
}(Am.Component), Bz = function({ children: e, onError: t }) {
  return Am.createElement(Tz, { fallback: Am.createElement("div", { style: { border: "1px solid #f00", color: "#f00", padding: "8px" } }, "An error was thrown."), onError: t }, e);
};
const Dz = Bz;
var Oz = Dz;
const xl = /* @__PURE__ */ Ho(Oz);
var uB = {}, ff = {}, Fz = it, dB = L;
let f2 = class mB extends dB.TextNode {
  static getType() {
    return "hashtag";
  }
  static clone(t) {
    return new mB(t.__text, t.__key);
  }
  constructor(t, i) {
    super(t, i);
  }
  createDOM(t) {
    let i = super.createDOM(t);
    return Fz.addClassNamesToElement(i, t.theme.hashtag), i;
  }
  static importJSON(t) {
    let i = gB(t.text);
    return i.setFormat(t.format), i.setDetail(t.detail), i.setMode(t.mode), i.setStyle(t.style), i;
  }
  exportJSON() {
    return ee(q({}, super.exportJSON()), { type: "hashtag" });
  }
  canInsertTextBefore() {
    return !1;
  }
  isTextEntity() {
    return !0;
  }
};
function gB(e = "") {
  return dB.$applyNodeReplacement(new f2(e));
}
ff.$createHashtagNode = gB;
ff.$isHashtagNode = function(e) {
  return e instanceof f2;
};
ff.HashtagNode = f2;
const Vz = ff;
var A2 = Vz, hB = {}, qz = nt, jz = gf, Lz = it, Kz = X;
hB.useLexicalTextEntity = function(e, t, i) {
  let [r] = qz.useLexicalComposerContext();
  Kz.useEffect(() => Lz.mergeRegister(...jz.registerLexicalTextEntity(r, e, t, i)), [i, r, e, t]);
};
const Yz = hB;
var Uz = Yz, Gy = A2, Gz = nt, Qz = Uz, Qy = X, Wz = RegExp;
let Nu = String.fromCharCode, S3 = "A-Za-zªµºÀ-ÖØ-öø-Ɂɐ-ˁˆ-ˑˠ-ˤˮͺΆΈ-ΊΌΎ-ΡΣ-ώϐ-ϵϷ-ҁҊ-ӎӐ-ӹԀ-ԏԱ-Ֆՙա-ևא-תװ-ײء-غـ-يٮ-ٯٱ-ۓەۥ-ۦۮ-ۯۺ-ۼۿܐܒ-ܯݍ-ݭހ-ޥޱऄ-हऽॐक़-ॡॽঅ-ঌএ-ঐও-নপ-রলশ-হঽৎড়-ঢ়য়-ৡৰ-ৱਅ-ਊਏ-ਐਓ-ਨਪ-ਰਲ-ਲ਼ਵ-ਸ਼ਸ-ਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલ-ળવ-હઽૐૠ-ૡଅ-ଌଏ-ଐଓ-ନପ-ରଲ-ଳଵ-ହଽଡ଼-ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கங-சஜஞ-டண-தந-பம-ஹఅ-ఌఎ-ఐఒ-నప-ళవ-హౠ-ౡಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೞೠ-ೡഅ-ഌഎ-ഐഒ-നപ-ഹൠ-ൡඅ-ඖක-නඳ-රලව-ෆก-ะา-ำเ-ๆກ-ຂຄງ-ຈຊຍດ-ທນ-ຟມ-ຣລວສ-ຫອ-ະາ-ຳຽເ-ໄໆໜ-ໝༀཀ-ཇཉ-ཪྈ-ྋက-အဣ-ဧဩ-ဪၐ-ၕႠ-Ⴥა-ჺჼᄀ-ᅙᅟ-ᆢᆨ-ᇹሀ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏼᐁ-ᙬᙯ-ᙶᚁ-ᚚᚠ-ᛪᜀ-ᜌᜎ-ᜑᜠ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡷᢀ-ᢨᤀ-ᤜᥐ-ᥭᥰ-ᥴᦀ-ᦩᧁ-ᧇᨀ-ᨖᴀ-ᶿḀ-ẛẠ-ỹἀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₔℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℱℳ-ℹℼ-ℿⅅ-ⅉⰀ-Ⱞⰰ-ⱞⲀ-ⳤⴀ-ⴥⴰ-ⵥⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞ々-〆〱-〵〻-〼ぁ-ゖゝ-ゟァ-ヺー-ヿㄅ-ㄬㄱ-ㆎㆠ-ㆷㇰ-ㇿ㐀-䶵一-龻ꀀ-ꒌꠀ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢ가-힣豈-鶴侮-頻並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּ-סּףּ-פּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ̀-ͯ҃-֑҆-ֹֻ-ֽֿׁ-ׂׄ-ׇׅؐ-ًؕ-ٰٞۖ-ۜ۟-ۤۧ-۪ۨ-ܑۭܰ-݊ަ-ްँ-ः़ा-्॑-॔ॢ-ॣঁ-ঃ়া-ৄে-ৈো-্ৗৢ-ৣਁ-ਃ਼ਾ-ੂੇ-ੈੋ-੍ੰ-ੱઁ-ઃ઼ા-ૅે-ૉો-્ૢ-ૣଁ-ଃ଼ା-ୃେ-ୈୋ-୍ୖ-ୗஂா-ூெ-ைொ-்ௗఁ-ఃా-ౄె-ైొ-్ౕ-ౖಂ-ಃ಼ಾ-ೄೆ-ೈೊ-್ೕ-ೖം-ഃാ-ൃെ-ൈൊ-്ൗං-ඃ්ා-ුූෘ-ෟෲ-ෳัิ-ฺ็-๎ັິ-ູົ-ຼ່-ໍ༘-༹༙༵༷༾-༿ཱ-྄྆-྇ྐ-ྗྙ-ྼ࿆ာ-ဲံ-္ၖ-ၙ፟ᜒ-᜔ᜲ-᜴ᝒ-ᝓᝲ-ᝳា-៓៝᠋-᠍ᢩᤠ-ᤫᤰ-᤻ᦰ-ᧀᧈ-ᧉᨗ-ᨛ᷀-᷃⃐-⃥⃜⃡-⃫〪-゙〯-゚ꠂ꠆ꠋꠣ-ꠧﬞ︀-️︠-︣À-ÖØ-öø-ÿĀ-ɏɓ-ɔɖ-ɗəɛɣɨɯɲʉʋʻ̀-ͯḀ-ỿЀ-ӿԀ-ԧⷠ-ⷿꙀ-֑ꚟ-ֿׁ-ׂׄ-ׇׅא-תװ-״﬒-ﬨשׁ-זּטּ-לּמּנּ-סּףּ-פּצּ-ﭏؐ-ؚؠ-ٟٮ-ۓە-ۜ۞-۪ۨ-ۯۺ-ۼۿݐ-ݿࢠࢢ-ࢬࣤ-ࣾﭐ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼ‌-‌ก-ฺเ-๎ᄀ-ᇿ㄰-ㆅꥠ-꥿가-힯ힰ-퟿ﾡ-ￜァ-ヺー-ヾｦ-ﾟ０-９Ａ-Ｚａ-ｚぁ-ゖ゙-ゞ㐀-䶿一-鿿" + (Nu(173824) + "-" + Nu(177983) + Nu(177984) + "-" + Nu(178207) + Nu(194560) + "-" + Nu(195103) + "〃々〻"), { alpha: Zz, alphanumeric: pB, hashChars: Jz } = { alpha: S3, alphanumeric: S3 + "0-9٠-٩۰-۹०-९০-৯੦-੯૦-૯୦-୯௦-௯౦-౯೦-೯൦-൯๐-๙໐-໙༠-༩၀-၉០-៩᠐-᠙᥆-᥏᧐-᧙０-９_", hashChars: "#\\uFF03" }, R3 = "[" + pB + "]", Pz = new Wz("(^|$|[^&/" + (pB + "])([") + (Jz + "])(") + R3 + "*[" + (Zz + "]") + R3 + "*)", "i");
uB.HashtagPlugin = function() {
  let [e] = Gz.useLexicalComposerContext();
  Qy.useEffect(() => {
    if (!e.hasNodes([Gy.HashtagNode]))
      throw Error("HashtagPlugin: HashtagNode not registered on editor");
  }, [e]);
  let t = Qy.useCallback((r) => Gy.$createHashtagNode(r.getTextContent()), []), i = Qy.useCallback((r) => {
    if (r = Pz.exec(r), r === null)
      return null;
    const n = r.index + r[1].length;
    return { end: n + (r[3].length + 1), start: n };
  }, []);
  return Qz.useLexicalTextEntity(i, Gy.HashtagNode, t), null;
};
const zz = uB;
var fB = zz, y2 = {}, E2 = {}, Hz = it, ki = L;
function Xz(e, t, i, r, n) {
  if (e === null || i.size === 0 && r.size === 0 && !n)
    return 0;
  var o = t._selection, s = e._selection;
  if (n)
    return 1;
  if (!(ki.$isRangeSelection(o) && ki.$isRangeSelection(s) && s.isCollapsed() && o.isCollapsed()))
    return 0;
  n = t._nodeMap;
  let a = [];
  for (let l of i)
    i = n.get(l), i !== void 0 && a.push(i);
  for (let [l, c] of r)
    c && (r = n.get(l), r === void 0 || ki.$isRootNode(r) || a.push(r));
  return a.length === 0 ? 0 : 1 < a.length ? (r = t._nodeMap, t = r.get(o.anchor.key), s = r.get(s.anchor.key), t && s && !e._nodeMap.has(t.__key) && ki.$isTextNode(t) && t.__text.length === 1 && o.anchor.offset === 1 ? 2 : 0) : (t = a[0], e = e._nodeMap.get(t.__key), !ki.$isTextNode(e) || !ki.$isTextNode(t) || e.__mode !== t.__mode || (e = e.__text, t = t.__text, e === t) || (o = o.anchor, s = s.anchor, o.key !== s.key || o.type !== "text") ? 0 : (o = o.offset, s = s.offset, e = t.length - e.length, e === 1 && s === o - 1 ? 2 : e === -1 && s === o + 1 ? 3 : e === -1 && s === o ? 4 : 0));
}
function _z(e, t) {
  let i = Date.now(), r = 0;
  return (n, o, s, a, l, c) => {
    let u = Date.now();
    if (c.has("historic"))
      return r = 0, i = u, 2;
    let m = Xz(n, o, a, l, e.isComposing()), g = (() => {
      var h = s === null || s.editor === e, A = c.has("history-push");
      if (!A && h && c.has("history-merge"))
        return 0;
      if (n === null)
        return 1;
      var y = o._selection;
      if (!(0 < a.size || 0 < l.size))
        return y !== null ? 0 : 2;
      if (A === !1 && m !== 0 && m === r && u < i + t && h)
        return 0;
      if (a.size === 1) {
        {
          A = Array.from(a)[0], h = n._nodeMap.get(A), A = o._nodeMap.get(A), y = n._selection;
          let E = o._selection, v = !1;
          ki.$isRangeSelection(y) && ki.$isRangeSelection(E) && (v = y.anchor.type === "element" && y.focus.type === "element" && E.anchor.type === "text" && E.focus.type === "text"), h = !v && ki.$isTextNode(h) && ki.$isTextNode(A) ? h.__type === A.__type && h.__text === A.__text && h.__mode === A.__mode && h.__detail === A.__detail && h.__style === A.__style && h.__format === A.__format && h.__parent === A.__parent : !1;
        }
        if (h)
          return 0;
      }
      return 1;
    })();
    return i = u, r = m, g;
  };
}
E2.createEmptyHistoryState = function() {
  return { current: null, redoStack: [], undoStack: [] };
};
E2.registerHistory = function(e, t, i) {
  let r = _z(e, i);
  i = ({ editorState: s, prevEditorState: a, dirtyLeaves: l, dirtyElements: c, tags: u }) => {
    const m = t.current, g = t.redoStack, h = t.undoStack, A = m === null ? null : m.editorState;
    if (m === null || s !== A) {
      if (a = r(a, s, m, l, c, u), a === 1)
        g.length !== 0 && (t.redoStack = [], e.dispatchCommand(ki.CAN_REDO_COMMAND, !1)), m !== null && (h.push(q({}, m)), e.dispatchCommand(ki.CAN_UNDO_COMMAND, !0));
      else if (a === 2)
        return;
      t.current = { editor: e, editorState: s };
    }
  };
  let n = Hz.mergeRegister(e.registerCommand(
    ki.UNDO_COMMAND,
    () => {
      let s = t.redoStack, a = t.undoStack;
      if (a.length !== 0) {
        let l = t.current, c = a.pop();
        l !== null && (s.push(l), e.dispatchCommand(ki.CAN_REDO_COMMAND, !0)), a.length === 0 && e.dispatchCommand(ki.CAN_UNDO_COMMAND, !1), t.current = c || null, c && c.editor.setEditorState(c.editorState, { tag: "historic" });
      }
      return !0;
    },
    ki.COMMAND_PRIORITY_EDITOR
  ), e.registerCommand(ki.REDO_COMMAND, () => {
    let s = t.redoStack;
    var a = t.undoStack;
    if (s.length !== 0) {
      let l = t.current;
      l !== null && (a.push(l), e.dispatchCommand(ki.CAN_UNDO_COMMAND, !0)), a = s.pop(), s.length === 0 && e.dispatchCommand(ki.CAN_REDO_COMMAND, !1), t.current = a || null, a && a.editor.setEditorState(a.editorState, { tag: "historic" });
    }
    return !0;
  }, ki.COMMAND_PRIORITY_EDITOR), e.registerCommand(ki.CLEAR_EDITOR_COMMAND, () => (t.undoStack = [], t.redoStack = [], t.current = null, !1), ki.COMMAND_PRIORITY_EDITOR), e.registerCommand(ki.CLEAR_HISTORY_COMMAND, () => (t.undoStack = [], t.redoStack = [], t.current = null, e.dispatchCommand(ki.CAN_REDO_COMMAND, !1), e.dispatchCommand(ki.CAN_UNDO_COMMAND, !1), !0), ki.COMMAND_PRIORITY_EDITOR), e.registerUpdateListener(i)), o = e.registerUpdateListener(i);
  return () => {
    n(), o();
  };
};
const $z = E2;
var eH = $z, tH = nt, kb = eH, k3 = X;
function iH(e, t, i = 1e3) {
  let r = k3.useMemo(() => t || kb.createEmptyHistoryState(), [t]);
  k3.useEffect(() => kb.registerHistory(e, r, i), [i, e, r]);
}
y2.createEmptyHistoryState = kb.createEmptyHistoryState;
y2.HistoryPlugin = function({ externalHistoryState: e }) {
  let [t] = tH.useLexicalComposerContext();
  return iH(t, e), null;
};
const rH = y2;
var Mc = rH, AB = {}, Eg = {}, yB = {}, nH = nt, hc = L, Ph = X;
function w3(e, t) {
  return e.getEditorState().read(() => {
    let i = hc.$getNodeByKey(t);
    return i === null ? !1 : i.isSelected();
  });
}
yB.useLexicalNodeSelection = function(e) {
  let [t] = nH.useLexicalComposerContext(), [i, r] = Ph.useState(() => w3(t, e));
  Ph.useEffect(() => {
    let s = !0, a = t.registerUpdateListener(() => {
      s && r(w3(t, e));
    });
    return () => {
      s = !1, a();
    };
  }, [t, e]);
  let n = Ph.useCallback((s) => {
    t.update(() => {
      let a = hc.$getSelection();
      hc.$isNodeSelection(a) || (a = hc.$createNodeSelection(), hc.$setSelection(a)), s ? a.add(e) : a.delete(e);
    });
  }, [t, e]), o = Ph.useCallback(() => {
    t.update(() => {
      const s = hc.$getSelection();
      hc.$isNodeSelection(s) && s.clear();
    });
  }, [t]);
  return [i, n, o];
};
const oH = yB;
var vg = oH, sH = nt, aH = vg, lH = it, Vo = L, Kp = X;
let cH = Vo.createCommand("INSERT_HORIZONTAL_RULE_COMMAND");
function uH({ nodeKey: e }) {
  let [t] = sH.useLexicalComposerContext(), [i, r, n] = aH.useLexicalNodeSelection(e), o = Kp.useCallback((s) => (i && Vo.$isNodeSelection(Vo.$getSelection()) && (s.preventDefault(), s = Vo.$getNodeByKey(e), vB(s) && s.remove()), !1), [i, e]);
  return Kp.useEffect(() => lH.mergeRegister(t.registerCommand(Vo.CLICK_COMMAND, (s) => {
    let a = t.getElementByKey(e);
    return s.target === a ? (s.shiftKey || n(), r(!i), !0) : !1;
  }, Vo.COMMAND_PRIORITY_LOW), t.registerCommand(Vo.KEY_DELETE_COMMAND, o, Vo.COMMAND_PRIORITY_LOW), t.registerCommand(
    Vo.KEY_BACKSPACE_COMMAND,
    o,
    Vo.COMMAND_PRIORITY_LOW
  )), [n, t, i, e, o, r]), Kp.useEffect(() => {
    let s = t.getElementByKey(e);
    s !== null && (s.className = i ? "selected" : "");
  }, [t, i, e]), null;
}
let v2 = class EB extends Vo.DecoratorNode {
  static getType() {
    return "horizontalrule";
  }
  static clone(t) {
    return new EB(t.__key);
  }
  static importJSON() {
    return b2();
  }
  static importDOM() {
    return { hr: () => ({ conversion: dH, priority: 0 }) };
  }
  exportJSON() {
    return { type: "horizontalrule", version: 1 };
  }
  exportDOM() {
    return { element: document.createElement("hr") };
  }
  createDOM() {
    return document.createElement("hr");
  }
  getTextContent() {
    return `
`;
  }
  isInline() {
    return !1;
  }
  updateDOM() {
    return !1;
  }
  decorate() {
    return Kp.createElement(uH, { nodeKey: this.__key });
  }
};
function dH() {
  return { node: b2() };
}
function b2() {
  return Vo.$applyNodeReplacement(new v2());
}
function vB(e) {
  return e instanceof v2;
}
Eg.$createHorizontalRuleNode = b2;
Eg.$isHorizontalRuleNode = vB;
Eg.HorizontalRuleNode = v2;
Eg.INSERT_HORIZONTAL_RULE_COMMAND = cH;
const mH = Eg;
var Il = mH, gH = nt, M3 = Il, hH = it, Wy = L, pH = X;
AB.HorizontalRulePlugin = function() {
  let [e] = gH.useLexicalComposerContext();
  return pH.useEffect(() => e.registerCommand(M3.INSERT_HORIZONTAL_RULE_COMMAND, () => {
    var t = Wy.$getSelection();
    return Wy.$isRangeSelection(t) ? (t.focus.getNode() !== null && (t = M3.$createHorizontalRuleNode(), hH.$insertNodeToNearestRoot(t)), !0) : !1;
  }, Wy.COMMAND_PRIORITY_EDITOR), [e]), null;
};
const fH = AB;
var bB = fH, CB = {}, ya = zi, AH = nt, xB = X, yH = it, wd = L;
function EH(e) {
  xB.useEffect(() => yH.mergeRegister(e.registerCommand(ya.INSERT_ORDERED_LIST_COMMAND, () => (ya.insertList(e, "number"), !0), wd.COMMAND_PRIORITY_LOW), e.registerCommand(ya.INSERT_UNORDERED_LIST_COMMAND, () => (ya.insertList(e, "bullet"), !0), wd.COMMAND_PRIORITY_LOW), e.registerCommand(ya.REMOVE_LIST_COMMAND, () => (ya.removeList(e), !0), wd.COMMAND_PRIORITY_LOW), e.registerCommand(wd.INSERT_PARAGRAPH_COMMAND, () => !!ya.$handleListInsertParagraph(), wd.COMMAND_PRIORITY_LOW)), [e]);
}
CB.ListPlugin = function() {
  let [e] = AH.useLexicalComposerContext();
  return xB.useEffect(() => {
    if (!e.hasNodes([ya.ListNode, ya.ListItemNode]))
      throw Error("ListPlugin: ListNode and/or ListItemNode not registered on editor");
  }, [e]), EH(e), null;
};
const vH = CB;
var IB = vH, SB = {}, bH = nt, ym = X, CH = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined" ? ym.useLayoutEffect : ym.useEffect;
function xH(e) {
  let [t] = bH.useLexicalComposerContext(), i = ym.useMemo(() => e(t), [t, e]), r = ym.useRef(i.initialValueFn()), [n, o] = ym.useState(r.current);
  return CH(() => {
    let { initialValueFn: s, subscribe: a } = i, l = s();
    return r.current !== l && (r.current = l, o(l)), a((c) => {
      r.current = c, o(c);
    });
  }, [i, e]), n;
}
function IH(e) {
  return { initialValueFn: () => e.isEditable(), subscribe: (t) => e.registerEditableListener(t) };
}
var SH = function() {
  return xH(IH);
};
const RH = SH;
var C2 = RH;
const Af = /* @__PURE__ */ Ho(C2);
var RB = {}, zh = L;
RB.registerDragonSupport = function(e) {
  let t = window.location.origin, i = (r) => {
    if (r.origin === t) {
      var n = e.getRootElement();
      if (document.activeElement === n && (n = r.data, typeof n == "string")) {
        try {
          var o = JSON.parse(n);
        } catch (s) {
          return;
        }
        if (o && o.protocol === "nuanria_messaging" && o.type === "request" && (o = o.payload) && o.functionId === "makeChanges" && (o = o.args)) {
          const [s, a, l, c, u] = o;
          e.update(() => {
            const m = zh.$getSelection();
            if (zh.$isRangeSelection(m)) {
              var g = m.anchor;
              let h = g.getNode(), A = 0, y = 0;
              zh.$isTextNode(h) && 0 <= s && 0 <= a && (A = s, y = s + a, m.setTextNodeRange(h, A, h, y)), (A !== y || l !== "") && (m.insertRawText(l), h = g.getNode()), zh.$isTextNode(h) && (A = c, y = c + u, g = h.getTextContentSize(), A = A > g ? g : A, y = y > g ? g : y, m.setTextNodeRange(h, A, h, y)), r.stopImmediatePropagation();
            }
          });
        }
      }
    }
  };
  return window.addEventListener("message", i, !0), () => {
    window.removeEventListener("message", i, !0);
  };
};
const kH = RB;
var kB = kH, wB = {}, ja = {}, x2 = {}, N3 = wi, wH = it, Hu = L;
function MB(e, t, i, r = null) {
  let n = r != null ? t.isSelected(r) : !0, o = Hu.$isElementNode(t) && t.excludeFromCopy("html");
  var s = t;
  r !== null && (s = N3.$cloneWithProperties(t), s = Hu.$isTextNode(s) && r != null ? N3.$sliceSelectedTextNodeContent(r, s) : s);
  let a = Hu.$isElementNode(s) ? s.getChildren() : [], { element: l, after: c } = s.exportDOM(e);
  if (!l)
    return !1;
  let u = document.createDocumentFragment();
  for (let m = 0; m < a.length; m++) {
    let g = a[m], h = MB(e, g, u, r);
    !n && Hu.$isElementNode(t) && h && t.extractWithChild(g, r, "html") && (n = !0);
  }
  return n && !o ? (wH.isHTMLElement(l) && l.append(u), i.append(l), c && (e = c.call(s, l)) && l.replaceWith(e)) : i.append(u), n;
}
let NB = /* @__PURE__ */ new Set(["STYLE", "SCRIPT"]);
function TB(e, t, i = /* @__PURE__ */ new Map(), r) {
  let n = [];
  if (NB.has(e.nodeName))
    return n;
  let o = null;
  var s, { nodeName: a } = e, l = t._htmlConversions.get(a.toLowerCase());
  if (a = null, l !== void 0)
    for (s of l)
      l = s(e), l !== null && (a === null || a.priority < l.priority) && (a = l);
  if (a = (s = a !== null ? a.conversion : null) ? s(e) : null, s = null, a !== null) {
    if (s = a.after, l = a.node, o = Array.isArray(l) ? l[l.length - 1] : l, o !== null) {
      for (var [, c] of i)
        if (o = c(o, r), !o)
          break;
      o && n.push(...Array.isArray(l) ? l : [o]);
    }
    a.forChild != null && i.set(e.nodeName, a.forChild);
  }
  for (e = e.childNodes, r = [], c = 0; c < e.length; c++)
    r.push(...TB(e[c], t, new Map(i), o));
  return s != null && (r = s(r)), o == null ? n = n.concat(r) : Hu.$isElementNode(o) && o.append(...r), n;
}
x2.$generateHtmlFromNodes = function(e, t) {
  if (typeof document == "undefined" || typeof window == "undefined")
    throw Error("To use $generateHtmlFromNodes in headless mode please initialize a headless browser implementation such as JSDom before calling this function.");
  let i = document.createElement("div"), r = Hu.$getRoot().getChildren();
  for (let n = 0; n < r.length; n++)
    MB(e, r[n], i, t);
  return i.innerHTML;
};
x2.$generateNodesFromDOM = function(e, t) {
  t = t.body ? t.body.childNodes : [];
  let i = [];
  for (let n = 0; n < t.length; n++) {
    var r = t[n];
    NB.has(r.nodeName) || (r = TB(r, e), r !== null && (i = i.concat(r)));
  }
  return i;
};
const MH = x2;
var BB = MH, DB = BB, wb = wi, r0 = it, wt = L;
function va(e) {
  let t = new URLSearchParams();
  t.append("code", e);
  for (let i = 1; i < arguments.length; i++)
    t.append("v", arguments[i]);
  throw Error(`Minified Lexical error #${e}; visit https://lexical.dev/docs/error?${t} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
}
let OB = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined";
function FB(e) {
  let t = wt.$getSelection();
  if (t == null)
    throw Error("Expected valid LexicalSelection");
  return wt.$isRangeSelection(t) && t.isCollapsed() || t.getNodes().length === 0 ? "" : DB.$generateHtmlFromNodes(e, t);
}
function VB(e) {
  let t = wt.$getSelection();
  if (t == null)
    throw Error("Expected valid LexicalSelection");
  return wt.$isRangeSelection(t) && t.isCollapsed() || t.getNodes().length === 0 ? null : JSON.stringify(jB(e, t));
}
function Mb(e, t, i) {
  (wt.DEPRECATED_$isGridSelection(i) || r0.$findMatchingParent(i.anchor.getNode(), (r) => wt.DEPRECATED_$isGridCellNode(r)) !== null && r0.$findMatchingParent(i.focus.getNode(), (r) => wt.DEPRECATED_$isGridCellNode(r)) !== null) && t.length === 1 && wt.DEPRECATED_$isGridNode(t[0]) ? TH(t, i, !1, e) : NH(t, i);
}
function NH(e, t) {
  let i = [], r = null;
  for (let n = 0; n < e.length; n++) {
    let o = e[n], s = wt.$isLineBreakNode(o);
    if (s || wt.$isDecoratorNode(o) && o.isInline() || wt.$isElementNode(o) && o.isInline() || wt.$isTextNode(o) || o.isParentRequired()) {
      if (r === null && (r = o.createParentElementNode(), i.push(r), s))
        continue;
      r !== null && r.append(o);
    } else
      i.push(o), r = null;
  }
  wt.$isRangeSelection(t) ? t.insertNodes(i) : wt.DEPRECATED_$isGridSelection(t) && (e = t.anchor.getNode(), wt.DEPRECATED_$isGridCellNode(e) || va(41), e.append(...i));
}
function TH(e, t, i, r) {
  e.length === 1 && wt.DEPRECATED_$isGridNode(e[0]) || va(42);
  var n = e[0];
  e = n.getChildren(), i = n.getFirstChildOrThrow().getChildrenSize();
  var o = n.getChildrenSize(), s = r0.$findMatchingParent(t.anchor.getNode(), (h) => wt.DEPRECATED_$isGridCellNode(h));
  t = (n = s && r0.$findMatchingParent(s, (h) => wt.DEPRECATED_$isGridRowNode(h))) && r0.$findMatchingParent(n, (h) => wt.DEPRECATED_$isGridNode(h)), wt.DEPRECATED_$isGridCellNode(s) && wt.DEPRECATED_$isGridRowNode(n) && wt.DEPRECATED_$isGridNode(t) || va(43);
  var a = n.getIndexWithinParent(), l = Math.min(t.getChildrenSize() - 1, a + o - 1);
  o = s.getIndexWithinParent(), s = Math.min(n.getChildrenSize() - 1, o + i - 1), i = Math.min(o, s), n = Math.min(a, l), o = Math.max(o, s), a = Math.max(a, l), l = t.getChildren(), s = 0;
  let c, u;
  for (let h = n; h <= a; h++) {
    var m = l[h];
    wt.DEPRECATED_$isGridRowNode(m) || va(24);
    var g = e[s];
    wt.DEPRECATED_$isGridRowNode(g) || va(24), m = m.getChildren(), g = g.getChildren();
    let A = 0;
    for (let y = i; y <= o; y++) {
      let E = m[y];
      wt.DEPRECATED_$isGridCellNode(E) || va(25);
      let v = g[A];
      wt.DEPRECATED_$isGridCellNode(v) || va(25), h === n && y === i ? c = E.getKey() : h === a && y === o && (u = E.getKey());
      let C = E.getChildren();
      v.getChildren().forEach((x) => {
        wt.$isTextNode(x) && wt.$createParagraphNode().append(x), E.append(x);
      }), C.forEach((x) => x.remove()), A++;
    }
    s++;
  }
  c && u && (e = wt.DEPRECATED_$createGridSelection(), e.set(t.getKey(), c, u), wt.$setSelection(e), r.dispatchCommand(wt.SELECTION_CHANGE_COMMAND, void 0));
}
function qB(e, t, i, r = []) {
  let n = t != null ? i.isSelected(t) : !0, o = wt.$isElementNode(i) && i.excludeFromCopy("html");
  var s = i;
  if (t !== null) {
    var a = wb.$cloneWithProperties(i);
    s = a = wt.$isTextNode(a) && t != null ? wb.$sliceSelectedTextNodeContent(t, a) : a;
  }
  let l = wt.$isElementNode(s) ? s.getChildren() : [];
  var c = s;
  a = c.exportJSON();
  var u = c.constructor;
  a.type !== u.getType() && va(58, u.name);
  let m = a.children;
  for (wt.$isElementNode(c) && (Array.isArray(m) || va(59, u.name)), wt.$isTextNode(s) && (s = s.__text, 0 < s.length ? a.text = s : n = !1), s = 0; s < l.length; s++)
    c = l[s], u = qB(e, t, c, a.children), !n && wt.$isElementNode(i) && u && i.extractWithChild(c, t, "clone") && (n = !0);
  if (n && !o)
    r.push(a);
  else if (Array.isArray(a.children))
    for (e = 0; e < a.children.length; e++)
      r.push(a.children[e]);
  return n;
}
function jB(e, t) {
  let i = [], r = wt.$getRoot().getChildren();
  for (let n = 0; n < r.length; n++)
    qB(e, t, r[n], i);
  return { namespace: e._config.namespace, nodes: i };
}
function LB(e) {
  let t = [];
  for (let i = 0; i < e.length; i++) {
    let r = wt.$parseSerializedNode(e[i]);
    wt.$isTextNode(r) && wb.$addNodeStyle(r), t.push(r);
  }
  return t;
}
let Tu = null;
function T3(e, t) {
  var i = OB ? (e._window || window).getSelection() : null;
  if (!i)
    return !1;
  var r = i.anchorNode;
  if (i = i.focusNode, r !== null && i !== null && !wt.isSelectionWithinEditor(e, r, i) || (t.preventDefault(), t = t.clipboardData, r = wt.$getSelection(), t === null || r === null))
    return !1;
  i = FB(e), e = VB(e);
  let n = "";
  return r !== null && (n = r.getTextContent()), i !== null && t.setData("text/html", i), e !== null && t.setData("application/x-lexical-editor", e), t.setData("text/plain", n), !0;
}
ja.$generateJSONFromSelectedNodes = jB;
ja.$generateNodesFromSerializedNodes = LB;
ja.$getHtmlContent = FB;
ja.$getLexicalContent = VB;
ja.$insertDataTransferForPlainText = function(e, t) {
  e = e.getData("text/plain") || e.getData("text/uri-list"), e != null && t.insertRawText(e);
};
ja.$insertDataTransferForRichText = function(e, t, i) {
  var r = e.getData("application/x-lexical-editor");
  if (r)
    try {
      let s = JSON.parse(r);
      if (s.namespace === i._config.namespace && Array.isArray(s.nodes)) {
        let a = LB(s.nodes);
        return Mb(i, a, t);
      }
    } catch (s) {
    }
  if (r = e.getData("text/html"))
    try {
      var n = new DOMParser().parseFromString(r, "text/html"), o = DB.$generateNodesFromDOM(i, n);
      return Mb(i, o, t);
    } catch (s) {
    }
  if (e = e.getData("text/plain") || e.getData("text/uri-list"), e != null)
    if (wt.$isRangeSelection(t))
      for (e = e.split(/(\r?\n|\t)/), i = e.length, n = 0; n < i; n++)
        o = e[n], o === `
` || o === `\r
` ? t.insertParagraph() : o === "	" ? t.insertNodes([wt.$createTabNode()]) : t.insertText(o);
    else
      t.insertRawText(e);
};
ja.$insertGeneratedNodes = Mb;
ja.copyToClipboard = function(e, t) {
  return Lt(this, null, function* () {
    if (Tu !== null)
      return !1;
    if (t !== null)
      return new Promise((s) => {
        e.update(() => {
          s(T3(e, t));
        });
      });
    var i = e.getRootElement();
    let r = e._window == null ? window.document : e._window.document, n = OB ? (e._window || window).getSelection() : null;
    if (i === null || n === null)
      return !1;
    let o = r.createElement("span");
    return o.style.cssText = "position: fixed; top: -1000px;", o.append(r.createTextNode("#")), i.append(o), i = new Range(), i.setStart(o, 0), i.setEnd(o, 1), n.removeAllRanges(), n.addRange(i), new Promise((s) => {
      let a = e.registerCommand(wt.COPY_COMMAND, (l) => (r0.objectKlassEquals(l, ClipboardEvent) && (a(), Tu !== null && (window.clearTimeout(Tu), Tu = null), s(T3(e, l))), !0), wt.COMMAND_PRIORITY_CRITICAL);
      Tu = window.setTimeout(() => {
        a(), Tu = null, s(!1);
      }, 50), r.execCommand("copy"), o.remove();
    });
  });
};
const BH = ja;
var KB = BH, I2 = KB, Hh = wi, DH = it, _e = L;
let K0 = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined", OH = K0 && "documentMode" in document ? document.documentMode : null, FH = K0 && "InputEvent" in window && !OH ? "getTargetRanges" in new window.InputEvent("input") : !1, VH = K0 && /Version\/[\d.]+.*Safari/.test(navigator.userAgent), qH = K0 && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, jH = K0 && /^(?=.*Chrome).*/i.test(navigator.userAgent), LH = K0 && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && !jH;
function YB(e, t) {
  t.update(() => {
    if (e !== null) {
      let i = e instanceof KeyboardEvent ? null : e.clipboardData, r = _e.$getSelection();
      if (r !== null && i != null) {
        e.preventDefault();
        let n = I2.$getHtmlContent(t);
        n !== null && i.setData("text/html", n), i.setData("text/plain", r.getTextContent());
      }
    }
  });
}
function KH(e, t) {
  e.preventDefault(), t.update(() => {
    let i = _e.$getSelection(), { clipboardData: r } = e;
    r != null && _e.$isRangeSelection(i) && I2.$insertDataTransferForPlainText(r, i);
  }, { tag: "paste" });
}
function YH(e, t) {
  YB(e, t), t.update(() => {
    let i = _e.$getSelection();
    _e.$isRangeSelection(i) && i.removeText();
  });
}
wB.registerPlainText = function(e) {
  return DH.mergeRegister(
    e.registerCommand(_e.DELETE_CHARACTER_COMMAND, (t) => {
      const i = _e.$getSelection();
      return _e.$isRangeSelection(i) ? (i.deleteCharacter(t), !0) : !1;
    }, _e.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(_e.DELETE_WORD_COMMAND, (t) => {
      const i = _e.$getSelection();
      return _e.$isRangeSelection(i) ? (i.deleteWord(t), !0) : !1;
    }, _e.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(_e.DELETE_LINE_COMMAND, (t) => {
      const i = _e.$getSelection();
      return _e.$isRangeSelection(i) ? (i.deleteLine(t), !0) : !1;
    }, _e.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(_e.CONTROLLED_TEXT_INSERTION_COMMAND, (t) => {
      const i = _e.$getSelection();
      if (!_e.$isRangeSelection(i))
        return !1;
      if (typeof t == "string")
        i.insertText(t);
      else {
        const r = t.dataTransfer;
        r != null ? I2.$insertDataTransferForPlainText(r, i) : (t = t.data) && i.insertText(t);
      }
      return !0;
    }, _e.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(_e.REMOVE_TEXT_COMMAND, () => {
      const t = _e.$getSelection();
      return _e.$isRangeSelection(t) ? (t.removeText(), !0) : !1;
    }, _e.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(
      _e.INSERT_LINE_BREAK_COMMAND,
      (t) => {
        const i = _e.$getSelection();
        return _e.$isRangeSelection(i) ? (i.insertLineBreak(t), !0) : !1;
      },
      _e.COMMAND_PRIORITY_EDITOR
    ),
    e.registerCommand(_e.INSERT_PARAGRAPH_COMMAND, () => {
      const t = _e.$getSelection();
      return _e.$isRangeSelection(t) ? (t.insertLineBreak(), !0) : !1;
    }, _e.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(_e.KEY_ARROW_LEFT_COMMAND, (t) => {
      const i = _e.$getSelection();
      if (!_e.$isRangeSelection(i))
        return !1;
      const r = t.shiftKey;
      return Hh.$shouldOverrideDefaultCharacterSelection(i, !0) ? (t.preventDefault(), Hh.$moveCharacter(
        i,
        r,
        !0
      ), !0) : !1;
    }, _e.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(_e.KEY_ARROW_RIGHT_COMMAND, (t) => {
      const i = _e.$getSelection();
      if (!_e.$isRangeSelection(i))
        return !1;
      const r = t.shiftKey;
      return Hh.$shouldOverrideDefaultCharacterSelection(i, !1) ? (t.preventDefault(), Hh.$moveCharacter(i, r, !1), !0) : !1;
    }, _e.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(_e.KEY_BACKSPACE_COMMAND, (t) => {
      const i = _e.$getSelection();
      return _e.$isRangeSelection(i) ? (t.preventDefault(), e.dispatchCommand(_e.DELETE_CHARACTER_COMMAND, !0)) : !1;
    }, _e.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(_e.KEY_DELETE_COMMAND, (t) => {
      const i = _e.$getSelection();
      return _e.$isRangeSelection(i) ? (t.preventDefault(), e.dispatchCommand(_e.DELETE_CHARACTER_COMMAND, !1)) : !1;
    }, _e.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(_e.KEY_ENTER_COMMAND, (t) => {
      const i = _e.$getSelection();
      if (!_e.$isRangeSelection(i))
        return !1;
      if (t !== null) {
        if ((qH || VH || LH) && FH)
          return !1;
        t.preventDefault();
      }
      return e.dispatchCommand(_e.INSERT_LINE_BREAK_COMMAND, !1);
    }, _e.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(_e.SELECT_ALL_COMMAND, () => (_e.$selectAll(), !0), _e.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(_e.COPY_COMMAND, (t) => {
      const i = _e.$getSelection();
      return _e.$isRangeSelection(i) ? (YB(t, e), !0) : !1;
    }, _e.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(_e.CUT_COMMAND, (t) => {
      const i = _e.$getSelection();
      return _e.$isRangeSelection(i) ? (YH(t, e), !0) : !1;
    }, _e.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(_e.PASTE_COMMAND, (t) => {
      const i = _e.$getSelection();
      return _e.$isRangeSelection(i) ? (KH(t, e), !0) : !1;
    }, _e.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(_e.DROP_COMMAND, (t) => {
      const i = _e.$getSelection();
      return _e.$isRangeSelection(i) ? (t.preventDefault(), !0) : !1;
    }, _e.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(_e.DRAGSTART_COMMAND, (t) => {
      const i = _e.$getSelection();
      return _e.$isRangeSelection(i) ? (t.preventDefault(), !0) : !1;
    }, _e.COMMAND_PRIORITY_EDITOR)
  );
};
const UH = wB;
var GH = UH, UB = nt, QH = C2, jo = X, WH = gf, GB = it, B3 = Kl, ZH = kB, JH = GH, S2 = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined" ? jo.useLayoutEffect : jo.useEffect;
function D3(e) {
  return e.getEditorState().read(WH.$canShowPlaceholderCurry(e.isComposing()));
}
function PH(e) {
  let [t, i] = jo.useState(() => D3(e));
  return S2(() => {
    function r() {
      let n = D3(e);
      i(n);
    }
    return r(), GB.mergeRegister(e.registerUpdateListener(() => {
      r();
    }), e.registerEditableListener(() => {
      r();
    }));
  }, [e]), t;
}
function zH(e, t) {
  let [i, r] = jo.useState(() => e.getDecorators());
  return S2(() => e.registerDecoratorListener((n) => {
    B3.flushSync(() => {
      r(n);
    });
  }), [e]), jo.useEffect(() => {
    r(e.getDecorators());
  }, [e]), jo.useMemo(() => {
    let n = [], o = Object.keys(i);
    for (let s = 0; s < o.length; s++) {
      let a = o[s], l = jo.createElement(t, { onError: (u) => e._onError(u) }, jo.createElement(jo.Suspense, { fallback: null }, i[a])), c = e.getElementByKey(a);
      c !== null && n.push(B3.createPortal(l, c, a));
    }
    return n;
  }, [t, i, e]);
}
function HH(e) {
  S2(() => GB.mergeRegister(JH.registerPlainText(e), ZH.registerDragonSupport(e)), [e]);
}
function XH({ content: e }) {
  var [t] = UB.useLexicalComposerContext();
  t = PH(t);
  let i = QH();
  return t ? typeof e == "function" ? e(i) : e : null;
}
SB.PlainTextPlugin = function({ contentEditable: e, placeholder: t, ErrorBoundary: i }) {
  let [r] = UB.useLexicalComposerContext();
  return i = zH(r, i), HH(r), jo.createElement(jo.Fragment, null, e, jo.createElement(XH, { content: t }), i);
};
const _H = SB;
var QB = _H, WB = {}, Ps = {}, y1 = KB, Xh = wi, Fs = it, Ce = L;
function O3(e, t) {
  return typeof document.caretRangeFromPoint != "undefined" ? (e = document.caretRangeFromPoint(e, t), e === null ? null : { node: e.startContainer, offset: e.startOffset }) : document.caretPositionFromPoint !== "undefined" ? (e = document.caretPositionFromPoint(e, t), e === null ? null : { node: e.offsetNode, offset: e.offset }) : null;
}
let Y0 = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined", $H = Y0 && "documentMode" in document ? document.documentMode : null, eX = Y0 && "InputEvent" in window && !$H ? "getTargetRanges" in new window.InputEvent("input") : !1, tX = Y0 && /Version\/[\d.]+.*Safari/.test(navigator.userAgent), iX = Y0 && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, rX = Y0 && /^(?=.*Chrome).*/i.test(navigator.userAgent), nX = Y0 && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && !rX, Nb = Ce.createCommand("DRAG_DROP_PASTE_FILE"), R2 = class ZB extends Ce.ElementNode {
  static getType() {
    return "quote";
  }
  static clone(t) {
    return new ZB(t.__key);
  }
  constructor(t) {
    super(t);
  }
  createDOM(t) {
    let i = document.createElement("blockquote");
    return Fs.addClassNamesToElement(i, t.theme.quote), i;
  }
  updateDOM() {
    return !1;
  }
  static importDOM() {
    return { blockquote: () => ({ conversion: oX, priority: 0 }) };
  }
  exportDOM(t) {
    if ({ element: t } = super.exportDOM(t), t && Fs.isHTMLElement(t)) {
      this.isEmpty() && t.append(document.createElement("br"));
      var i = this.getFormatType();
      t.style.textAlign = i, (i = this.getDirection()) && (t.dir = i);
    }
    return { element: t };
  }
  static importJSON(t) {
    let i = k2();
    return i.setFormat(t.format), i.setIndent(t.indent), i.setDirection(t.direction), i;
  }
  exportJSON() {
    return ee(q({}, super.exportJSON()), { type: "quote" });
  }
  insertNewAfter(t, i) {
    t = Ce.$createParagraphNode();
    let r = this.getDirection();
    return t.setDirection(r), this.insertAfter(t, i), t;
  }
  collapseAtStart() {
    let t = Ce.$createParagraphNode();
    return this.getChildren().forEach((i) => t.append(i)), this.replace(t), !0;
  }
};
function k2() {
  return Ce.$applyNodeReplacement(new R2());
}
let w2 = class JB extends Ce.ElementNode {
  static getType() {
    return "heading";
  }
  static clone(t) {
    return new JB(t.__tag, t.__key);
  }
  constructor(t, i) {
    super(i), this.__tag = t;
  }
  getTag() {
    return this.__tag;
  }
  createDOM(t) {
    let i = this.__tag, r = document.createElement(i);
    return t = t.theme.heading, t !== void 0 && Fs.addClassNamesToElement(r, t[i]), r;
  }
  updateDOM() {
    return !1;
  }
  static importDOM() {
    return { h1: () => ({ conversion: Bu, priority: 0 }), h2: () => ({ conversion: Bu, priority: 0 }), h3: () => ({ conversion: Bu, priority: 0 }), h4: () => ({ conversion: Bu, priority: 0 }), h5: () => ({
      conversion: Bu,
      priority: 0
    }), h6: () => ({ conversion: Bu, priority: 0 }), p: (t) => (t = t.firstChild, t !== null && F3(t) ? { conversion: () => ({ node: null }), priority: 3 } : null), span: (t) => F3(t) ? { conversion: () => ({ node: Xu("h1") }), priority: 3 } : null };
  }
  exportDOM(t) {
    if ({ element: t } = super.exportDOM(t), t && Fs.isHTMLElement(t)) {
      this.isEmpty() && t.append(document.createElement("br"));
      var i = this.getFormatType();
      t.style.textAlign = i, (i = this.getDirection()) && (t.dir = i);
    }
    return { element: t };
  }
  static importJSON(t) {
    let i = Xu(t.tag);
    return i.setFormat(t.format), i.setIndent(t.indent), i.setDirection(t.direction), i;
  }
  exportJSON() {
    return ee(q({}, super.exportJSON()), { tag: this.getTag(), type: "heading", version: 1 });
  }
  insertNewAfter(t, i = !0) {
    t = t ? t.anchor.offset : 0, t = 0 < t && t < this.getTextContentSize() ? Xu(this.getTag()) : Ce.$createParagraphNode();
    let r = this.getDirection();
    return t.setDirection(r), this.insertAfter(t, i), t;
  }
  collapseAtStart() {
    let t = this.isEmpty() ? Ce.$createParagraphNode() : Xu(this.getTag());
    return this.getChildren().forEach((i) => t.append(i)), this.replace(t), !0;
  }
  extractWithChild() {
    return !0;
  }
};
function F3(e) {
  return e.nodeName.toLowerCase() === "span" ? e.style.fontSize === "26pt" : !1;
}
function Bu(e) {
  let t = e.nodeName.toLowerCase(), i = null;
  return (t === "h1" || t === "h2" || t === "h3" || t === "h4" || t === "h5" || t === "h6") && (i = Xu(t), e.style !== null && i.setFormat(e.style.textAlign)), { node: i };
}
function oX(e) {
  let t = k2();
  return e.style !== null && t.setFormat(e.style.textAlign), { node: t };
}
function Xu(e) {
  return Ce.$applyNodeReplacement(new w2(e));
}
function sX(e, t) {
  e.preventDefault(), t.update(() => {
    let i = Ce.$getSelection(), r = e instanceof InputEvent || e instanceof KeyboardEvent ? null : e.clipboardData;
    r != null && (Ce.$isRangeSelection(i) || Ce.DEPRECATED_$isGridSelection(i)) && y1.$insertDataTransferForRichText(r, i, t);
  }, { tag: "paste" });
}
function aX(e, t) {
  return Lt(this, null, function* () {
    yield y1.copyToClipboard(t, Fs.objectKlassEquals(e, ClipboardEvent) ? e : null), t.update(() => {
      let i = Ce.$getSelection();
      Ce.$isRangeSelection(i) ? i.removeText() : Ce.$isNodeSelection(i) && i.getNodes().forEach((r) => r.remove());
    });
  });
}
function $d(e) {
  let t = null;
  if (e instanceof DragEvent ? t = e.dataTransfer : e instanceof ClipboardEvent && (t = e.clipboardData), t === null)
    return [!1, [], !1];
  var i = t.types;
  return e = i.includes("Files"), i = i.includes("text/html") || i.includes("text/plain"), [e, Array.from(t.files), i];
}
function V3(e) {
  var t = Ce.$getSelection();
  if (!Ce.$isRangeSelection(t))
    return !1;
  let i = /* @__PURE__ */ new Set();
  t = t.getNodes();
  for (let o = 0; o < t.length; o++) {
    var r = t[o], n = r.getKey();
    i.has(n) || (r = Fs.$getNearestBlockElementAncestorOrThrow(r), n = r.getKey(), r.canIndent() && !i.has(n) && (i.add(n), e(r)));
  }
  return 0 < i.size;
}
function _h(e) {
  return e = Ce.$getNearestNodeFromDOMNode(e), Ce.$isDecoratorNode(e);
}
Ps.$createHeadingNode = Xu;
Ps.$createQuoteNode = k2;
Ps.$isHeadingNode = function(e) {
  return e instanceof w2;
};
Ps.$isQuoteNode = function(e) {
  return e instanceof R2;
};
Ps.DRAG_DROP_PASTE = Nb;
Ps.HeadingNode = w2;
Ps.QuoteNode = R2;
Ps.eventFiles = $d;
Ps.registerRichText = function(e) {
  return Fs.mergeRegister(
    e.registerCommand(Ce.CLICK_COMMAND, () => {
      const t = Ce.$getSelection();
      return Ce.$isNodeSelection(t) ? (t.clear(), !0) : !1;
    }, 0),
    e.registerCommand(Ce.DELETE_CHARACTER_COMMAND, (t) => {
      const i = Ce.$getSelection();
      return Ce.$isRangeSelection(i) ? (i.deleteCharacter(t), !0) : !1;
    }, Ce.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Ce.DELETE_WORD_COMMAND, (t) => {
      const i = Ce.$getSelection();
      return Ce.$isRangeSelection(i) ? (i.deleteWord(t), !0) : !1;
    }, Ce.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Ce.DELETE_LINE_COMMAND, (t) => {
      const i = Ce.$getSelection();
      return Ce.$isRangeSelection(i) ? (i.deleteLine(t), !0) : !1;
    }, Ce.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Ce.CONTROLLED_TEXT_INSERTION_COMMAND, (t) => {
      const i = Ce.$getSelection();
      if (typeof t == "string")
        Ce.$isRangeSelection(i) ? i.insertText(t) : Ce.DEPRECATED_$isGridSelection(i);
      else {
        if (!Ce.$isRangeSelection(i) && !Ce.DEPRECATED_$isGridSelection(i))
          return !1;
        const r = t.dataTransfer;
        r != null ? y1.$insertDataTransferForRichText(r, i, e) : Ce.$isRangeSelection(i) && (t = t.data) && i.insertText(t);
      }
      return !0;
    }, Ce.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Ce.REMOVE_TEXT_COMMAND, () => {
      const t = Ce.$getSelection();
      return Ce.$isRangeSelection(t) ? (t.removeText(), !0) : !1;
    }, Ce.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Ce.FORMAT_TEXT_COMMAND, (t) => {
      const i = Ce.$getSelection();
      return Ce.$isRangeSelection(i) ? (i.formatText(t), !0) : !1;
    }, Ce.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Ce.FORMAT_ELEMENT_COMMAND, (t) => {
      var i = Ce.$getSelection();
      if (!Ce.$isRangeSelection(i) && !Ce.$isNodeSelection(i))
        return !1;
      i = i.getNodes();
      for (const r of i)
        i = Fs.$findMatchingParent(r, (n) => Ce.$isElementNode(n) && !n.isInline()), i !== null && i.setFormat(t);
      return !0;
    }, Ce.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Ce.INSERT_LINE_BREAK_COMMAND, (t) => {
      const i = Ce.$getSelection();
      return Ce.$isRangeSelection(i) ? (i.insertLineBreak(t), !0) : !1;
    }, Ce.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Ce.INSERT_PARAGRAPH_COMMAND, () => {
      const t = Ce.$getSelection();
      return Ce.$isRangeSelection(t) ? (t.insertParagraph(), !0) : !1;
    }, Ce.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(
      Ce.INSERT_TAB_COMMAND,
      () => (Ce.$insertNodes([Ce.$createTabNode()]), !0),
      Ce.COMMAND_PRIORITY_EDITOR
    ),
    e.registerCommand(Ce.INDENT_CONTENT_COMMAND, () => V3((t) => {
      const i = t.getIndent();
      t.setIndent(i + 1);
    }), Ce.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Ce.OUTDENT_CONTENT_COMMAND, () => V3((t) => {
      const i = t.getIndent();
      0 < i && t.setIndent(i - 1);
    }), Ce.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Ce.KEY_ARROW_UP_COMMAND, (t) => {
      var i = Ce.$getSelection();
      if (Ce.$isNodeSelection(i) && !_h(t.target)) {
        if (t = i.getNodes(), 0 < t.length)
          return t[0].selectPrevious(), !0;
      } else if (Ce.$isRangeSelection(i) && (i = Ce.$getAdjacentNode(i.focus, !0), !t.shiftKey && Ce.$isDecoratorNode(i) && !i.isIsolated() && !i.isInline()))
        return i.selectPrevious(), t.preventDefault(), !0;
      return !1;
    }, Ce.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Ce.KEY_ARROW_DOWN_COMMAND, (t) => {
      var i = Ce.$getSelection();
      if (Ce.$isNodeSelection(i)) {
        if (t = i.getNodes(), 0 < t.length)
          return t[0].selectNext(0, 0), !0;
      } else if (Ce.$isRangeSelection(i)) {
        let r = i.focus;
        if (r.key === "root" && r.offset === Ce.$getRoot().getChildrenSize())
          return t.preventDefault(), !0;
        if (i = Ce.$getAdjacentNode(
          i.focus,
          !1
        ), !t.shiftKey && Ce.$isDecoratorNode(i) && !i.isIsolated() && !i.isInline())
          return i.selectNext(), t.preventDefault(), !0;
      }
      return !1;
    }, Ce.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Ce.KEY_ARROW_LEFT_COMMAND, (t) => {
      const i = Ce.$getSelection();
      if (Ce.$isNodeSelection(i)) {
        var r = i.getNodes();
        if (0 < r.length)
          return t.preventDefault(), r[0].selectPrevious(), !0;
      }
      return Ce.$isRangeSelection(i) && Xh.$shouldOverrideDefaultCharacterSelection(i, !0) ? (r = t.shiftKey, t.preventDefault(), Xh.$moveCharacter(i, r, !0), !0) : !1;
    }, Ce.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Ce.KEY_ARROW_RIGHT_COMMAND, (t) => {
      const i = Ce.$getSelection();
      if (Ce.$isNodeSelection(i) && !_h(t.target)) {
        var r = i.getNodes();
        if (0 < r.length)
          return t.preventDefault(), r[0].selectNext(0, 0), !0;
      }
      return Ce.$isRangeSelection(i) ? (r = t.shiftKey, Xh.$shouldOverrideDefaultCharacterSelection(i, !1) ? (t.preventDefault(), Xh.$moveCharacter(i, r, !1), !0) : !1) : !1;
    }, Ce.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Ce.KEY_BACKSPACE_COMMAND, (t) => {
      if (_h(t.target))
        return !1;
      const i = Ce.$getSelection();
      if (!Ce.$isRangeSelection(i))
        return !1;
      t.preventDefault(), { anchor: t } = i;
      const r = t.getNode();
      return i.isCollapsed() && t.offset === 0 && !Ce.$isRootNode(r) && 0 < Fs.$getNearestBlockElementAncestorOrThrow(r).getIndent() ? e.dispatchCommand(Ce.OUTDENT_CONTENT_COMMAND, void 0) : e.dispatchCommand(Ce.DELETE_CHARACTER_COMMAND, !0);
    }, Ce.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(
      Ce.KEY_DELETE_COMMAND,
      (t) => {
        if (_h(t.target))
          return !1;
        const i = Ce.$getSelection();
        return Ce.$isRangeSelection(i) ? (t.preventDefault(), e.dispatchCommand(Ce.DELETE_CHARACTER_COMMAND, !1)) : !1;
      },
      Ce.COMMAND_PRIORITY_EDITOR
    ),
    e.registerCommand(Ce.KEY_ENTER_COMMAND, (t) => {
      const i = Ce.$getSelection();
      if (!Ce.$isRangeSelection(i))
        return !1;
      if (t !== null) {
        if ((iX || tX || nX) && eX)
          return !1;
        if (t.preventDefault(), t.shiftKey)
          return e.dispatchCommand(Ce.INSERT_LINE_BREAK_COMMAND, !1);
      }
      return e.dispatchCommand(Ce.INSERT_PARAGRAPH_COMMAND, void 0);
    }, Ce.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Ce.KEY_ESCAPE_COMMAND, () => {
      const t = Ce.$getSelection();
      return Ce.$isRangeSelection(t) ? (e.blur(), !0) : !1;
    }, Ce.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(
      Ce.DROP_COMMAND,
      (t) => {
        const [, i] = $d(t);
        if (0 < i.length) {
          var r = O3(t.clientX, t.clientY);
          if (r !== null) {
            const { offset: o, node: s } = r;
            var n = Ce.$getNearestNodeFromDOMNode(s);
            if (n !== null) {
              if (r = Ce.$createRangeSelection(), Ce.$isTextNode(n))
                r.anchor.set(n.getKey(), o, "text"), r.focus.set(n.getKey(), o, "text");
              else {
                const a = n.getParentOrThrow().getKey();
                n = n.getIndexWithinParent() + 1, r.anchor.set(a, n, "element"), r.focus.set(a, n, "element");
              }
              r = Ce.$normalizeSelection__EXPERIMENTAL(r), Ce.$setSelection(r);
            }
            e.dispatchCommand(Nb, i);
          }
          return t.preventDefault(), !0;
        }
        return t = Ce.$getSelection(), !!Ce.$isRangeSelection(t);
      },
      Ce.COMMAND_PRIORITY_EDITOR
    ),
    e.registerCommand(Ce.DRAGSTART_COMMAND, (t) => {
      [t] = $d(t);
      const i = Ce.$getSelection();
      return !(t && !Ce.$isRangeSelection(i));
    }, Ce.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Ce.DRAGOVER_COMMAND, (t) => {
      var [i] = $d(t);
      const r = Ce.$getSelection();
      return i && !Ce.$isRangeSelection(r) ? !1 : (i = O3(t.clientX, t.clientY), i !== null && (i = Ce.$getNearestNodeFromDOMNode(i.node), Ce.$isDecoratorNode(i) && t.preventDefault()), !0);
    }, Ce.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Ce.SELECT_ALL_COMMAND, () => (Ce.$selectAll(), !0), Ce.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Ce.COPY_COMMAND, (t) => (y1.copyToClipboard(e, Fs.objectKlassEquals(t, ClipboardEvent) ? t : null), !0), Ce.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Ce.CUT_COMMAND, (t) => (aX(t, e), !0), Ce.COMMAND_PRIORITY_EDITOR),
    e.registerCommand(Ce.PASTE_COMMAND, (t) => {
      const [, i, r] = $d(t);
      if (0 < i.length && !r)
        return e.dispatchCommand(Nb, i), !0;
      if (Ce.isSelectionCapturedInDecoratorInput(t.target))
        return !1;
      const n = Ce.$getSelection();
      return Ce.$isRangeSelection(n) || Ce.DEPRECATED_$isGridSelection(n) ? (sX(t, e), !0) : !1;
    }, Ce.COMMAND_PRIORITY_EDITOR)
  );
};
const lX = Ps;
var Jr = lX, PB = nt, cX = C2, Lo = X, uX = gf, zB = it, q3 = Kl, dX = kB, mX = Jr, M2 = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined" ? Lo.useLayoutEffect : Lo.useEffect;
function j3(e) {
  return e.getEditorState().read(uX.$canShowPlaceholderCurry(e.isComposing()));
}
function gX(e) {
  let [t, i] = Lo.useState(() => j3(e));
  return M2(() => {
    function r() {
      let n = j3(e);
      i(n);
    }
    return r(), zB.mergeRegister(e.registerUpdateListener(() => {
      r();
    }), e.registerEditableListener(() => {
      r();
    }));
  }, [e]), t;
}
function hX(e, t) {
  let [i, r] = Lo.useState(() => e.getDecorators());
  return M2(() => e.registerDecoratorListener((n) => {
    q3.flushSync(() => {
      r(n);
    });
  }), [e]), Lo.useEffect(() => {
    r(e.getDecorators());
  }, [e]), Lo.useMemo(() => {
    let n = [], o = Object.keys(i);
    for (let s = 0; s < o.length; s++) {
      let a = o[s], l = Lo.createElement(t, { onError: (u) => e._onError(u) }, Lo.createElement(Lo.Suspense, { fallback: null }, i[a])), c = e.getElementByKey(a);
      c !== null && n.push(q3.createPortal(l, c, a));
    }
    return n;
  }, [t, i, e]);
}
function pX(e) {
  M2(() => zB.mergeRegister(mX.registerRichText(e), dX.registerDragonSupport(e)), [e]);
}
function fX({ content: e }) {
  var [t] = PB.useLexicalComposerContext();
  t = gX(t);
  let i = cX();
  return t ? typeof e == "function" ? e(i) : e : null;
}
WB.RichTextPlugin = function({ contentEditable: e, placeholder: t, ErrorBoundary: i }) {
  let [r] = PB.useLexicalComposerContext();
  return i = hX(r, i), pX(r), Lo.createElement(Lo.Fragment, null, e, Lo.createElement(fX, { content: t }), i);
};
const AX = WB;
var p0 = AX, N2 = {}, yX = nt, L3 = it, ws = L, EX = X;
function vX(e) {
  var t = e.getNodes();
  if (0 < L3.$filter(t, (i) => ws.$isBlockElementNode(i) && i.canIndent() ? i : null).length)
    return !0;
  if (t = e.anchor, e = e.focus, e = e.isBefore(t) ? e : t, t = e.getNode(), t = L3.$getNearestBlockElementAncestorOrThrow(t), t.canIndent()) {
    t = t.getKey();
    let i = ws.$createRangeSelection();
    if (i.anchor.set(t, 0, "element"), i.focus.set(t, 0, "element"), i = ws.$normalizeSelection__EXPERIMENTAL(i), i.anchor.is(e))
      return !0;
  }
  return !1;
}
function HB(e) {
  return e.registerCommand(ws.KEY_TAB_COMMAND, (t) => {
    let i = ws.$getSelection();
    return ws.$isRangeSelection(i) ? (t.preventDefault(), t = vX(i) ? t.shiftKey ? ws.OUTDENT_CONTENT_COMMAND : ws.INDENT_CONTENT_COMMAND : ws.INSERT_TAB_COMMAND, e.dispatchCommand(t, void 0)) : !1;
  }, ws.COMMAND_PRIORITY_EDITOR);
}
N2.TabIndentationPlugin = function() {
  let [e] = yX.useLexicalComposerContext();
  return EX.useEffect(() => HB(e)), null;
};
N2.registerTabIndentation = HB;
const bX = N2;
var XB = bX, _B = {}, ni = {}, xe = L, rr = it;
let $B = /^(\d+(?:\.\d+)?)px$/, Li = { BOTH: 3, COLUMN: 2, NO_STATUS: 0, ROW: 1 }, T2 = class e7 extends xe.DEPRECATED_GridCellNode {
  static getType() {
    return "tablecell";
  }
  static clone(t) {
    let i = new e7(t.__headerState, t.__colSpan, t.__width, t.__key);
    return i.__rowSpan = t.__rowSpan, i.__backgroundColor = t.__backgroundColor, i;
  }
  static importDOM() {
    return { td: () => ({ conversion: K3, priority: 0 }), th: () => ({ conversion: K3, priority: 0 }) };
  }
  static importJSON(t) {
    let i = t.rowSpan || 1, r = Go(t.headerState, t.colSpan || 1, t.width || void 0);
    return r.__rowSpan = i, r.__backgroundColor = t.backgroundColor || null, r;
  }
  constructor(t = Li.NO_STATUS, i = 1, r, n) {
    super(i, n), this.__headerState = t, this.__width = r, this.__backgroundColor = null;
  }
  createDOM(t) {
    let i = document.createElement(this.getTag());
    return this.__width && (i.style.width = `${this.__width}px`), 1 < this.__colSpan && (i.colSpan = this.__colSpan), 1 < this.__rowSpan && (i.rowSpan = this.__rowSpan), this.__backgroundColor !== null && (i.style.backgroundColor = this.__backgroundColor), rr.addClassNamesToElement(i, t.theme.tableCell, this.hasHeader() && t.theme.tableCellHeader), i;
  }
  exportDOM(t) {
    if ({ element: t } = super.exportDOM(t), t) {
      var i = this.getParentOrThrow().getChildrenSize();
      t.style.border = "1px solid black", 1 < this.__colSpan && (t.colSpan = this.__colSpan), 1 < this.__rowSpan && (t.rowSpan = this.__rowSpan), t.style.width = `${this.getWidth() || Math.max(90, 700 / i)}px`, t.style.verticalAlign = "top", t.style.textAlign = "start", i = this.getBackgroundColor(), i !== null ? t.style.backgroundColor = i : this.hasHeader() && (t.style.backgroundColor = "#f2f3f5");
    }
    return { element: t };
  }
  exportJSON() {
    return ee(q({}, super.exportJSON()), {
      backgroundColor: this.getBackgroundColor(),
      headerState: this.__headerState,
      type: "tablecell",
      width: this.getWidth()
    });
  }
  getTag() {
    return this.hasHeader() ? "th" : "td";
  }
  setHeaderStyles(t) {
    return this.getWritable().__headerState = t, this.__headerState;
  }
  getHeaderStyles() {
    return this.getLatest().__headerState;
  }
  setWidth(t) {
    return this.getWritable().__width = t, this.__width;
  }
  getWidth() {
    return this.getLatest().__width;
  }
  getBackgroundColor() {
    return this.getLatest().__backgroundColor;
  }
  setBackgroundColor(t) {
    this.getWritable().__backgroundColor = t;
  }
  toggleHeaderStyle(t) {
    let i = this.getWritable();
    return i.__headerState = (i.__headerState & t) === t ? i.__headerState - t : i.__headerState + t, i;
  }
  hasHeaderState(t) {
    return (this.getHeaderStyles() & t) === t;
  }
  hasHeader() {
    return this.getLatest().__headerState !== Li.NO_STATUS;
  }
  updateDOM(t) {
    return t.__headerState !== this.__headerState || t.__width !== this.__width || t.__colSpan !== this.__colSpan || t.__rowSpan !== this.__rowSpan || t.__backgroundColor !== this.__backgroundColor;
  }
  isShadowRoot() {
    return !0;
  }
  collapseAtStart() {
    return !0;
  }
  canBeEmpty() {
    return !1;
  }
  canIndent() {
    return !1;
  }
};
function K3(e) {
  var t = e.nodeName.toLowerCase();
  let i;
  return $B.test(e.style.width) && (i = parseFloat(e.style.width)), t = Go(t === "th" ? Li.ROW : Li.NO_STATUS, e.colSpan, i), t.__rowSpan = e.rowSpan, e = e.style.backgroundColor, e !== "" && (t.__backgroundColor = e), { forChild: (r, n) => ti(n) && !xe.$isElementNode(r) ? (n = xe.$createParagraphNode(), xe.$isLineBreakNode(r) && r.getTextContent() === `
` ? null : (n.append(r), n)) : r, node: t };
}
function Go(e, t = 1, i) {
  return xe.$applyNodeReplacement(new T2(e, t, i));
}
function ti(e) {
  return e instanceof T2;
}
let B2 = class t7 extends xe.DEPRECATED_GridRowNode {
  static getType() {
    return "tablerow";
  }
  static clone(t) {
    return new t7(t.__height, t.__key);
  }
  static importDOM() {
    return { tr: () => ({ conversion: CX, priority: 0 }) };
  }
  static importJSON(t) {
    return Yc(t.height);
  }
  constructor(t, i) {
    super(i), this.__height = t;
  }
  exportJSON() {
    return ee(q({}, super.exportJSON()), { type: "tablerow", version: 1 });
  }
  createDOM(t) {
    let i = document.createElement("tr");
    return this.__height && (i.style.height = `${this.__height}px`), rr.addClassNamesToElement(i, t.theme.tableRow), i;
  }
  isShadowRoot() {
    return !0;
  }
  setHeight(t) {
    return this.getWritable().__height = t, this.__height;
  }
  getHeight() {
    return this.getLatest().__height;
  }
  updateDOM(t) {
    return t.__height !== this.__height;
  }
  canBeEmpty() {
    return !1;
  }
  canIndent() {
    return !1;
  }
};
function CX(e) {
  let t;
  return $B.test(e.style.height) && (t = parseFloat(e.style.height)), { node: Yc(t) };
}
function Yc(e) {
  return xe.$applyNodeReplacement(new B2(e));
}
function Uc(e) {
  return e instanceof B2;
}
function xr(e) {
  let t = new URLSearchParams();
  t.append("code", e);
  for (let i = 1; i < arguments.length; i++)
    t.append("v", arguments[i]);
  throw Error(`Minified Lexical error #${e}; visit https://lexical.dev/docs/error?${t} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
}
let xX = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined", i7 = class {
  constructor(t, i) {
    this.isHighlightingCells = !1, this.focusY = this.focusX = this.anchorY = this.anchorX = -1, this.listenersToRemove = /* @__PURE__ */ new Set(), this.tableNodeKey = i, this.editor = t, this.grid = { cells: [], columns: 0, rows: 0 }, this.focusCell = this.anchorCell = this.focusCellNodeKey = this.anchorCellNodeKey = this.gridSelection = null, this.hasHijackedSelectionStyles = !1, this.trackTableGrid();
  }
  getGrid() {
    return this.grid;
  }
  removeListeners() {
    Array.from(this.listenersToRemove).forEach((t) => t());
  }
  trackTableGrid() {
    let t = new MutationObserver((i) => {
      this.editor.update(() => {
        var r = !1;
        for (let n = 0; n < i.length; n++) {
          const o = i[n].target.nodeName;
          if (o === "TABLE" || o === "TR") {
            r = !0;
            break;
          }
        }
        if (r) {
          if (r = this.editor.getElementByKey(this.tableNodeKey), !r)
            throw Error("Expected to find TableElement in DOM");
          this.grid = Yp(r);
        }
      });
    });
    this.editor.update(() => {
      let i = this.editor.getElementByKey(this.tableNodeKey);
      if (!i)
        throw Error("Expected to find TableElement in DOM");
      this.grid = Yp(i), t.observe(i, { childList: !0, subtree: !0 });
    });
  }
  clearHighlight() {
    let t = this.editor;
    this.isHighlightingCells = !1, this.focusY = this.focusX = this.anchorY = this.anchorX = -1, this.focusCell = this.anchorCell = this.focusCellNodeKey = this.anchorCellNodeKey = this.gridSelection = null, this.hasHijackedSelectionStyles = !1, this.enableHighlightStyle(), t.update(() => {
      var i = xe.$getNodeByKey(this.tableNodeKey);
      if (!Sl(i))
        throw Error("Expected TableNode.");
      if (i = t.getElementByKey(this.tableNodeKey), !i)
        throw Error("Expected to find TableElement in DOM");
      i = Yp(i), $h(t, i, null), xe.$setSelection(null), t.dispatchCommand(
        xe.SELECTION_CHANGE_COMMAND,
        void 0
      );
    });
  }
  enableHighlightStyle() {
    let t = this.editor;
    t.update(() => {
      let i = t.getElementByKey(this.tableNodeKey);
      if (!i)
        throw Error("Expected to find TableElement in DOM");
      rr.removeClassNamesFromElement(i, t._config.theme.tableSelection), i.classList.remove("disable-selection"), this.hasHijackedSelectionStyles = !1;
    });
  }
  disableHighlightStyle() {
    let t = this.editor;
    t.update(() => {
      let i = t.getElementByKey(this.tableNodeKey);
      if (!i)
        throw Error("Expected to find TableElement in DOM");
      rr.addClassNamesToElement(i, t._config.theme.tableSelection), this.hasHijackedSelectionStyles = !0;
    });
  }
  updateTableGridSelection(t) {
    if (t != null && t.gridKey === this.tableNodeKey) {
      let i = this.editor;
      this.gridSelection = t, this.isHighlightingCells = !0, this.disableHighlightStyle(), $h(i, this.grid, this.gridSelection);
    } else
      t == null && this.clearHighlight();
  }
  setFocusCellForSelection(t, i = !1) {
    let r = this.editor;
    r.update(() => {
      var n = xe.$getNodeByKey(this.tableNodeKey);
      if (!Sl(n))
        throw Error("Expected TableNode.");
      if (!r.getElementByKey(this.tableNodeKey))
        throw Error("Expected to find TableElement in DOM");
      n = t.x;
      let o = t.y;
      if (this.focusCell = t, this.anchorCell !== null) {
        let s = xX ? (r._window || window).getSelection() : null;
        s && s.setBaseAndExtent(this.anchorCell.elem, 0, this.focusCell.elem, 0);
      }
      if (!this.isHighlightingCells && (this.anchorX !== n || this.anchorY !== o || i))
        this.isHighlightingCells = !0, this.disableHighlightStyle();
      else if (n === this.focusX && o === this.focusY)
        return;
      this.focusX = n, this.focusY = o, this.isHighlightingCells && (n = xe.$getNearestNodeFromDOMNode(t.elem), this.gridSelection != null && this.anchorCellNodeKey != null && ti(n) && (n = n.getKey(), this.gridSelection = this.gridSelection.clone() || xe.DEPRECATED_$createGridSelection(), this.focusCellNodeKey = n, this.gridSelection.set(this.tableNodeKey, this.anchorCellNodeKey, this.focusCellNodeKey), xe.$setSelection(this.gridSelection), r.dispatchCommand(xe.SELECTION_CHANGE_COMMAND, void 0), $h(r, this.grid, this.gridSelection)));
    });
  }
  setAnchorCellForSelection(t) {
    this.isHighlightingCells = !1, this.anchorCell = t, this.anchorX = t.x, this.anchorY = t.y, this.editor.update(() => {
      var i = xe.$getNearestNodeFromDOMNode(t.elem);
      ti(i) && (i = i.getKey(), this.gridSelection = xe.DEPRECATED_$createGridSelection(), this.anchorCellNodeKey = i);
    });
  }
  formatCells(t) {
    this.editor.update(() => {
      let i = xe.$getSelection();
      xe.DEPRECATED_$isGridSelection(i) || xr(11);
      let r = xe.$createRangeSelection(), n = r.anchor, o = r.focus;
      i.getNodes().forEach((s) => {
        ti(s) && s.getTextContentSize() !== 0 && (n.set(s.getKey(), 0, "element"), o.set(s.getKey(), s.getChildrenSize(), "element"), r.formatText(t));
      }), xe.$setSelection(i), this.editor.dispatchCommand(xe.SELECTION_CHANGE_COMMAND, void 0);
    });
  }
  clearText() {
    let t = this.editor;
    t.update(() => {
      let i = xe.$getNodeByKey(this.tableNodeKey);
      if (!Sl(i))
        throw Error("Expected TableNode.");
      var r = xe.$getSelection();
      xe.DEPRECATED_$isGridSelection(r) || xr(11), r = r.getNodes().filter(ti), r.length === this.grid.columns * this.grid.rows ? (i.selectPrevious(), i.remove(), xe.$getRoot().selectStart()) : (r.forEach((n) => {
        if (xe.$isElementNode(n)) {
          let o = xe.$createParagraphNode(), s = xe.$createTextNode();
          o.append(s), n.append(o), n.getChildren().forEach((a) => {
            a !== o && a.remove();
          });
        }
      }), $h(t, this.grid, null), xe.$setSelection(null), t.dispatchCommand(xe.SELECTION_CHANGE_COMMAND, void 0));
    });
  }
};
function Tb(e) {
  for (; e != null; ) {
    let t = e.nodeName;
    if (t === "TD" || t === "TH") {
      if (e = e._cell, e === void 0)
        break;
      return e;
    }
    e = e.parentNode;
  }
  return null;
}
function Yp(e) {
  let t = [], i = { cells: t, columns: 0, rows: 0 };
  var r = e.firstChild;
  let n = e = 0;
  for (t.length = 0; r != null; ) {
    var o = r.nodeName;
    if (o === "TD" || o === "TH") {
      o = r, o = { elem: o, hasBackgroundColor: o.style.backgroundColor !== "", highlighted: !1, x: e, y: n }, r._cell = o;
      let s = t[n];
      s === void 0 && (s = t[n] = []), s[e] = o;
    } else if (o = r.firstChild, o != null) {
      r = o;
      continue;
    }
    if (o = r.nextSibling, o != null)
      e++, r = o;
    else if (o = r.parentNode, o != null) {
      if (r = o.nextSibling, r == null)
        break;
      n++, e = 0;
    }
  }
  return i.columns = e + 1, i.rows = n + 1, i;
}
function $h(e, t, i) {
  let r = new Set(i ? i.getNodes() : []);
  D2(t, (n, o) => {
    let s = n.elem;
    r.has(o) ? (n.highlighted = !0, n7(e, n)) : (n.highlighted = !1, o7(e, n), s.getAttribute("style") || s.removeAttribute("style"));
  });
}
function D2(e, t) {
  ({ cells: e } = e);
  for (let i = 0; i < e.length; i++) {
    let r = e[i];
    if (r)
      for (let n = 0; n < r.length; n++) {
        let o = r[n];
        if (!o)
          continue;
        let s = xe.$getNearestNodeFromDOMNode(o.elem);
        s !== null && t(o, s, { x: n, y: i });
      }
  }
}
function Y3(e, t) {
  t.disableHighlightStyle(), D2(t.grid, (i) => {
    i.highlighted = !0, n7(e, i);
  });
}
function IX(e, t) {
  t.enableHighlightStyle(), D2(t.grid, (i) => {
    let r = i.elem;
    i.highlighted = !1, o7(e, i), r.getAttribute("style") || r.removeAttribute("style");
  });
}
let r7 = (e, t, i, r, n) => {
  const o = n === "forward";
  switch (n) {
    case "backward":
    case "forward":
      return i !== (o ? e.grid.columns - 1 : 0) ? (e = t.getCellNodeFromCordsOrThrow(i + (o ? 1 : -1), r, e.grid), o ? e.selectStart() : e.selectEnd()) : r !== (o ? e.grid.rows - 1 : 0) ? (e = t.getCellNodeFromCordsOrThrow(o ? 0 : e.grid.columns - 1, r + (o ? 1 : -1), e.grid), o ? e.selectStart() : e.selectEnd()) : o ? t.selectNext() : t.selectPrevious(), !0;
    case "up":
      return r !== 0 ? t.getCellNodeFromCordsOrThrow(i, r - 1, e.grid).selectEnd() : t.selectPrevious(), !0;
    case "down":
      return r !== e.grid.rows - 1 ? t.getCellNodeFromCordsOrThrow(i, r + 1, e.grid).selectStart() : t.selectNext(), !0;
    default:
      return !1;
  }
}, SX = (e, t, i, r, n) => {
  const o = n === "forward";
  switch (n) {
    case "backward":
    case "forward":
      return i !== (o ? e.grid.columns - 1 : 0) && e.setFocusCellForSelection(t.getCellFromCordsOrThrow(i + (o ? 1 : -1), r, e.grid)), !0;
    case "up":
      return r !== 0 ? (e.setFocusCellForSelection(t.getCellFromCordsOrThrow(i, r - 1, e.grid)), !0) : !1;
    case "down":
      return r !== e.grid.rows - 1 ? (e.setFocusCellForSelection(t.getCellFromCordsOrThrow(i, r + 1, e.grid)), !0) : !1;
    default:
      return !1;
  }
};
function Zu(e, t) {
  if (xe.$isRangeSelection(e) || xe.DEPRECATED_$isGridSelection(e)) {
    let i = t.isParentOf(e.anchor.getNode());
    return e = t.isParentOf(e.focus.getNode()), i && e;
  }
  return !1;
}
function n7(e, t) {
  e = t.elem, t = xe.$getNearestNodeFromDOMNode(e), ti(t) || xr(131), t.getBackgroundColor() === null ? e.style.setProperty("background-color", "rgb(172,206,247)") : e.style.setProperty("background-image", "linear-gradient(to right, rgba(172,206,247,0.85), rgba(172,206,247,0.85))"), e.style.setProperty("caret-color", "transparent");
}
function o7(e, t) {
  e = t.elem, t = xe.$getNearestNodeFromDOMNode(e), ti(t) || xr(131), t.getBackgroundColor() === null && e.style.removeProperty("background-color"), e.style.removeProperty("background-image"), e.style.removeProperty("caret-color");
}
function Zy(e) {
  return e = rr.$findMatchingParent(e, ti), ti(e) ? e : null;
}
function U3(e) {
  return e = rr.$findMatchingParent(e, Sl), Sl(e) ? e : null;
}
function ep(e, t, i, r, n) {
  var o = xe.$getSelection();
  if (!Zu(o, r))
    return !1;
  if (xe.$isRangeSelection(o) && o.isCollapsed()) {
    if (i === "backward" || i === "forward")
      return !1;
    let { anchor: l, focus: c } = o;
    o = rr.$findMatchingParent(l.getNode(), ti);
    var s = rr.$findMatchingParent(c.getNode(), ti);
    if (!ti(o) || !o.is(s))
      return !1;
    s = e.getElementByKey(o.__key);
    var a = e.getElementByKey(l.key);
    if (a == null || s == null)
      return !1;
    if (l.type === "element")
      s = a.getBoundingClientRect();
    else {
      if (s = window.getSelection(), s === null || s.rangeCount === 0)
        return !1;
      s = s.getRangeAt(0).getBoundingClientRect();
    }
    if (a = i === "up" ? o.getFirstChild() : o.getLastChild(), a == null || (e = e.getElementByKey(a.__key), e == null))
      return !1;
    if (e = e.getBoundingClientRect(), i === "up" ? e.top > s.top - s.height : s.bottom + s.height > e.bottom) {
      if (Em(t), o = r.getCordsFromCellNode(o, n.grid), t.shiftKey)
        i = r.getCellFromCordsOrThrow(o.x, o.y, n.grid), n.setAnchorCellForSelection(i), n.setFocusCellForSelection(i, !0);
      else
        return r7(n, r, o.x, o.y, i);
      return !0;
    }
  } else if (xe.DEPRECATED_$isGridSelection(o)) {
    let { anchor: l, focus: c } = o;
    return o = rr.$findMatchingParent(
      l.getNode(),
      ti
    ), e = rr.$findMatchingParent(c.getNode(), ti), !ti(o) || !ti(e) ? !1 : (Em(t), t.shiftKey ? (t = r.getCordsFromCellNode(e, n.grid), SX(n, r, t.x, t.y, i)) : (e.selectEnd(), !0));
  }
  return !1;
}
function Em(e) {
  e.preventDefault(), e.stopImmediatePropagation(), e.stopPropagation();
}
let O2 = class s7 extends xe.DEPRECATED_GridNode {
  static getType() {
    return "table";
  }
  static clone(t) {
    return new s7(t.__key);
  }
  static importDOM() {
    return { table: () => ({ conversion: RX, priority: 1 }) };
  }
  static importJSON() {
    return yf();
  }
  constructor(t) {
    super(t);
  }
  exportJSON() {
    return ee(q({}, super.exportJSON()), { type: "table", version: 1 });
  }
  createDOM(t) {
    let i = document.createElement("table");
    return rr.addClassNamesToElement(i, t.theme.table), i;
  }
  updateDOM() {
    return !1;
  }
  exportDOM(t) {
    return ee(q({}, super.exportDOM(t)), { after: (i) => {
      if (i) {
        let r = i.cloneNode(), n = document.createElement("colgroup"), o = document.createElement("tbody");
        if (rr.isHTMLElement(i) && o.append(...i.children), i = this.getFirstChildOrThrow(), !Uc(i))
          throw Error("Expected to find row node.");
        i = i.getChildrenSize();
        for (let s = 0; s < i; s++) {
          let a = document.createElement("col");
          n.append(a);
        }
        return r.replaceChildren(n, o), r;
      }
    } });
  }
  canExtractContents() {
    return !1;
  }
  canBeEmpty() {
    return !1;
  }
  isShadowRoot() {
    return !0;
  }
  getCordsFromCellNode(t, i) {
    let { rows: r, cells: n } = i;
    for (i = 0; i < r; i++) {
      var o = n[i];
      if (o != null && (o = o.findIndex((s) => {
        if (s)
          return { elem: s } = s, xe.$getNearestNodeFromDOMNode(s) === t;
      }), o !== -1))
        return { x: o, y: i };
    }
    throw Error("Cell not found in table.");
  }
  getCellFromCords(t, i, r) {
    return { cells: r } = r, i = r[i], i == null ? null : (t = i[t], t == null ? null : t);
  }
  getCellFromCordsOrThrow(t, i, r) {
    if (t = this.getCellFromCords(t, i, r), !t)
      throw Error("Cell not found at cords.");
    return t;
  }
  getCellNodeFromCords(t, i, r) {
    return t = this.getCellFromCords(t, i, r), t == null ? null : (t = xe.$getNearestNodeFromDOMNode(t.elem), ti(t) ? t : null);
  }
  getCellNodeFromCordsOrThrow(t, i, r) {
    if (t = this.getCellNodeFromCords(t, i, r), !t)
      throw Error("Node at cords not TableCellNode.");
    return t;
  }
  canSelectBefore() {
    return !0;
  }
  canIndent() {
    return !1;
  }
};
function RX() {
  return { node: yf() };
}
function yf() {
  return xe.$applyNodeReplacement(new O2());
}
function Sl(e) {
  return e instanceof O2;
}
function F2(e) {
  if (e = rr.$findMatchingParent(e, (t) => Uc(t)), Uc(e))
    return e;
  throw Error("Expected table cell to be inside of table row.");
}
function V2(e) {
  if (e = rr.$findMatchingParent(e, (t) => Sl(t)), Sl(e))
    return e;
  throw Error("Expected table cell to be inside of table.");
}
function a7(e, t) {
  let i = V2(e), { x: r, y: n } = i.getCordsFromCellNode(e, t);
  return { above: i.getCellNodeFromCords(r, n - 1, t), below: i.getCellNodeFromCords(r, n + 1, t), left: i.getCellNodeFromCords(r - 1, n, t), right: i.getCellNodeFromCords(r + 1, n, t) };
}
function Gm(e) {
  e = e.getFirstDescendant(), e === null && xr(124), e.getParentOrThrow().selectStart();
}
function q2(e, t) {
  let i = e.getFirstChild();
  i !== null ? i.insertBefore(t) : e.append(t);
}
let kX = xe.createCommand("INSERT_TABLE_COMMAND");
ni.$createTableCellNode = Go;
ni.$createTableNode = yf;
ni.$createTableNodeWithDimensions = function(e, t, i = !0) {
  let r = yf();
  for (let o = 0; o < e; o++) {
    let s = Yc();
    for (let a = 0; a < t; a++) {
      var n = Li.NO_STATUS;
      typeof i == "object" ? (o === 0 && i.rows && (n |= Li.ROW), a === 0 && i.columns && (n |= Li.COLUMN)) : i && (o === 0 && (n |= Li.ROW), a === 0 && (n |= Li.COLUMN)), n = Go(n);
      let l = xe.$createParagraphNode();
      l.append(xe.$createTextNode()), n.append(l), s.append(n);
    }
    r.append(s);
  }
  return r;
};
ni.$createTableRowNode = Yc;
ni.$deleteTableColumn = function(e, t) {
  let i = e.getChildren();
  for (let n = 0; n < i.length; n++) {
    var r = i[n];
    if (Uc(r)) {
      if (r = r.getChildren(), t >= r.length || 0 > t)
        throw Error("Table column target index out of range");
      r[t].remove();
    }
  }
  return e;
};
ni.$deleteTableColumn__EXPERIMENTAL = function() {
  var e = xe.$getSelection();
  xe.$isRangeSelection(e) || xe.DEPRECATED_$isGridSelection(e) || xr(118);
  var t = e.anchor.getNode();
  e = e.focus.getNode();
  let [i, , r] = xe.DEPRECATED_$getNodeTriplet(t);
  [t] = xe.DEPRECATED_$getNodeTriplet(e);
  let [n, o, s] = xe.DEPRECATED_$computeGridMap(r, i, t);
  var { startColumn: a } = o;
  let { startRow: l, startColumn: c } = s;
  e = Math.min(a, c), a = Math.max(a + i.__colSpan - 1, c + t.__colSpan - 1);
  let u = a - e + 1;
  if (n[0].length === a - e + 1)
    r.selectPrevious(), r.remove();
  else {
    var m = n.length;
    for (let g = 0; g < m; g++)
      for (let h = e; h <= a; h++) {
        let { cell: A, startColumn: y } = n[g][h];
        y < e ? h === e && A.setColSpan(A.__colSpan - Math.min(u, A.__colSpan - (e - y))) : y + A.__colSpan - 1 > a ? h === a && A.setColSpan(A.__colSpan - (a - y + 1)) : A.remove();
      }
    e = n[l], t = e[c + t.__colSpan], t !== void 0 ? ({ cell: t } = t, Gm(t)) : ({ cell: t } = e[c - 1], Gm(t));
  }
};
ni.$deleteTableRow__EXPERIMENTAL = function() {
  var e = xe.$getSelection();
  xe.$isRangeSelection(e) || xe.DEPRECATED_$isGridSelection(e) || xr(118);
  var t = e.anchor.getNode();
  e = e.focus.getNode();
  let [i, , r] = xe.DEPRECATED_$getNodeTriplet(t);
  [e] = xe.DEPRECATED_$getNodeTriplet(e);
  let [n, o, s] = xe.DEPRECATED_$computeGridMap(r, i, e);
  ({ startRow: t } = o);
  var { startRow: a } = s;
  if (e = a + e.__rowSpan - 1, n.length === e - t + 1)
    r.remove();
  else {
    a = n[0].length;
    var l = n[e + 1], c = r.getChildAtIndex(e + 1);
    for (let m = e; m >= t; m--) {
      for (var u = a - 1; 0 <= u; u--) {
        let {
          cell: g,
          startRow: h,
          startColumn: A
        } = n[m][u];
        if (A === u && (m === t && h < t && g.setRowSpan(g.__rowSpan - (h - t)), h >= t && h + g.__rowSpan - 1 > e))
          if (g.setRowSpan(g.__rowSpan - (e - h + 1)), c === null && xr(122), u === 0)
            q2(c, g);
          else {
            let { cell: y } = l[u - 1];
            y.insertAfter(g);
          }
      }
      u = r.getChildAtIndex(m), xe.DEPRECATED_$isGridRowNode(u) || xr(123, String(m)), u.remove();
    }
    l !== void 0 ? ({ cell: t } = l[0], Gm(t)) : ({ cell: t } = n[t - 1][0], Gm(t));
  }
};
ni.$getElementGridForTableNode = function(e, t) {
  if (e = e.getElementByKey(t.getKey()), e == null)
    throw Error("Table Element Not Found");
  return Yp(e);
};
ni.$getTableCellNodeFromLexicalNode = function(e) {
  return e = rr.$findMatchingParent(e, (t) => ti(t)), ti(e) ? e : null;
};
ni.$getTableColumnIndexFromTableCellNode = function(e) {
  return F2(e).getChildren().findIndex((t) => t.is(e));
};
ni.$getTableNodeFromLexicalNodeOrThrow = V2;
ni.$getTableRowIndexFromTableCellNode = function(e) {
  let t = F2(e);
  return V2(t).getChildren().findIndex((i) => i.is(t));
};
ni.$getTableRowNodeFromTableCellNodeOrThrow = F2;
ni.$insertTableColumn = function(e, t, i = !0, r, n) {
  let o = e.getChildren();
  for (let l = 0; l < o.length; l++) {
    let c = o[l];
    if (Uc(c))
      for (let u = 0; u < r; u++) {
        var s = c.getChildren();
        if (t >= s.length || 0 > t)
          throw Error("Table column target index out of range");
        s = s[t], ti(s) || xr(12);
        let { left: m, right: g } = a7(s, n);
        var a = Li.NO_STATUS;
        (m && m.hasHeaderState(Li.ROW) || g && g.hasHeaderState(Li.ROW)) && (a |= Li.ROW), a = Go(a), a.append(xe.$createParagraphNode()), i ? s.insertAfter(a) : s.insertBefore(a);
      }
  }
  return e;
};
ni.$insertTableColumn__EXPERIMENTAL = function(e = !0) {
  function t() {
    let m = Go(Li.NO_STATUS).append(xe.$createParagraphNode());
    return c === null && (c = m), m;
  }
  var i = xe.$getSelection();
  xe.$isRangeSelection(i) || xe.DEPRECATED_$isGridSelection(i) || xr(118);
  var r = i.anchor.getNode();
  i = i.focus.getNode(), [r] = xe.DEPRECATED_$getNodeTriplet(r);
  let [n, , o] = xe.DEPRECATED_$getNodeTriplet(i), [s, a, l] = xe.DEPRECATED_$computeGridMap(o, n, r);
  r = s.length, i = e ? Math.max(a.startColumn, l.startColumn) : Math.min(a.startColumn, l.startColumn), e = e ? i + n.__colSpan - 1 : i - 1, i = o.getFirstChild(), xe.DEPRECATED_$isGridRowNode(i) || xr(120);
  let c = null;
  var u = i;
  e:
    for (i = 0; i < r; i++) {
      i !== 0 && (u = u.getNextSibling(), xe.DEPRECATED_$isGridRowNode(u) || xr(121));
      let m = s[i];
      if (0 > e) {
        q2(u, t());
        continue;
      }
      let { cell: g, startColumn: h, startRow: A } = m[e];
      if (h + g.__colSpan - 1 <= e) {
        let y = g, E = A, v = e;
        for (; E !== i && 1 < y.__rowSpan; )
          if (v -= g.__colSpan, 0 <= v) {
            let { cell: C, startRow: x } = m[v];
            y = C, E = x;
          } else {
            u.append(t());
            continue e;
          }
        y.insertAfter(t());
      } else
        g.setColSpan(g.__colSpan + 1);
    }
  c !== null && Gm(c);
};
ni.$insertTableRow = function(e, t, i = !0, r, n) {
  var o = e.getChildren();
  if (t >= o.length || 0 > t)
    throw Error("Table row target index out of range");
  if (t = o[t], Uc(t))
    for (o = 0; o < r; o++) {
      let a = t.getChildren(), l = a.length, c = Yc();
      for (let u = 0; u < l; u++) {
        var s = a[u];
        ti(s) || xr(12);
        let { above: m, below: g } = a7(s, n);
        s = Li.NO_STATUS;
        let h = m && m.getWidth() || g && g.getWidth() || void 0;
        (m && m.hasHeaderState(Li.COLUMN) || g && g.hasHeaderState(Li.COLUMN)) && (s |= Li.COLUMN), s = Go(s, 1, h), s.append(xe.$createParagraphNode()), c.append(s);
      }
      i ? t.insertAfter(c) : t.insertBefore(c);
    }
  else
    throw Error("Row before insertion index does not exist.");
  return e;
};
ni.$insertTableRow__EXPERIMENTAL = function(e = !0) {
  var t = xe.$getSelection();
  xe.$isRangeSelection(t) || xe.DEPRECATED_$isGridSelection(t) || xr(118), t = t.focus.getNode();
  let [i, , r] = xe.DEPRECATED_$getNodeTriplet(t), [n, o] = xe.DEPRECATED_$computeGridMap(r, i, i);
  t = n[0].length;
  var { startRow: s } = o;
  if (e) {
    e = s + i.__rowSpan - 1;
    var a = n[e];
    s = Yc();
    for (var l = 0; l < t; l++) {
      let { cell: c, startRow: u } = a[l];
      u + c.__rowSpan - 1 <= e ? s.append(Go(Li.NO_STATUS)) : c.setRowSpan(c.__rowSpan + 1);
    }
    t = r.getChildAtIndex(e), xe.DEPRECATED_$isGridRowNode(t) || xr(119), t.insertAfter(s);
  } else {
    for (a = n[s], e = Yc(), l = 0; l < t; l++) {
      let { cell: c, startRow: u } = a[l];
      u === s ? e.append(Go(Li.NO_STATUS)) : c.setRowSpan(c.__rowSpan + 1);
    }
    t = r.getChildAtIndex(s), xe.DEPRECATED_$isGridRowNode(t) || xr(119), t.insertBefore(e);
  }
};
ni.$isTableCellNode = ti;
ni.$isTableNode = Sl;
ni.$isTableRowNode = Uc;
ni.$removeTableRowAtIndex = function(e, t) {
  let i = e.getChildren();
  if (t >= i.length || 0 > t)
    throw Error("Expected table cell to be inside of table row.");
  return i[t].remove(), e;
};
ni.$unmergeCell = function() {
  var e = xe.$getSelection();
  xe.$isRangeSelection(e) || xe.DEPRECATED_$isGridSelection(e) || xr(118), e = e.anchor.getNode();
  let [t, i, r] = xe.DEPRECATED_$getNodeTriplet(e);
  e = t.__colSpan;
  let n = t.__rowSpan;
  if (1 < e) {
    for (var o = 1; o < e; o++)
      t.insertAfter(Go(Li.NO_STATUS));
    t.setColSpan(1);
  }
  if (1 < n) {
    let [l, c] = xe.DEPRECATED_$computeGridMap(r, t, t), { startColumn: u, startRow: m } = c, g;
    for (o = 1; o < n; o++) {
      var s = m + o;
      let h = l[s];
      g = (g || i).getNextSibling(), xe.DEPRECATED_$isGridRowNode(g) || xr(125);
      var a = null;
      for (let A = 0; A < u; A++) {
        let y = h[A], E = y.cell;
        y.startRow === s && (a = E), 1 < E.__colSpan && (A += E.__colSpan - 1);
      }
      if (a === null)
        for (a = 0; a < e; a++)
          q2(g, Go(Li.NO_STATUS));
      else
        for (s = 0; s < e; s++)
          a.insertAfter(Go(Li.NO_STATUS));
    }
    t.setRowSpan(1);
  }
};
ni.INSERT_TABLE_COMMAND = kX;
ni.TableCellHeaderStates = Li;
ni.TableCellNode = T2;
ni.TableNode = O2;
ni.TableRowNode = B2;
ni.TableSelection = i7;
ni.applyTableHandlers = function(e, t, i, r) {
  function n(u) {
    return u = e.getCordsFromCellNode(u, s.grid), e.getCellFromCordsOrThrow(u.x, u.y, s.grid);
  }
  let o = i.getRootElement();
  if (o === null)
    throw Error("No root element.");
  let s = new i7(i, e.getKey()), a = i._window || window;
  t.__lexicalTableSelection = s, t.addEventListener("mousedown", (u) => {
    setTimeout(() => {
      if (u.button === 0 && a) {
        var m = Tb(u.target);
        m !== null && (Em(u), s.setAnchorCellForSelection(m));
        var g = () => {
          a.removeEventListener("mouseup", g), a.removeEventListener(
            "mousemove",
            h
          );
        }, h = (A) => {
          const y = Tb(A.target);
          y === null || s.anchorX === y.x && s.anchorY === y.y || (A.preventDefault(), s.setFocusCellForSelection(y));
        };
        a.addEventListener("mouseup", g), a.addEventListener("mousemove", h);
      }
    }, 0);
  });
  let l = (u) => {
    u.button === 0 && i.update(() => {
      const m = xe.$getSelection(), g = u.target;
      xe.DEPRECATED_$isGridSelection(m) && m.gridKey === s.tableNodeKey && o.contains(g) && s.clearHighlight();
    });
  };
  a.addEventListener("mousedown", l), s.listenersToRemove.add(() => a.removeEventListener("mousedown", l)), s.listenersToRemove.add(i.registerCommand(
    xe.KEY_ARROW_DOWN_COMMAND,
    (u) => ep(i, u, "down", e, s),
    xe.COMMAND_PRIORITY_HIGH
  )), s.listenersToRemove.add(i.registerCommand(xe.KEY_ARROW_UP_COMMAND, (u) => ep(i, u, "up", e, s), xe.COMMAND_PRIORITY_HIGH)), s.listenersToRemove.add(i.registerCommand(xe.KEY_ARROW_LEFT_COMMAND, (u) => ep(i, u, "backward", e, s), xe.COMMAND_PRIORITY_HIGH)), s.listenersToRemove.add(i.registerCommand(xe.KEY_ARROW_RIGHT_COMMAND, (u) => ep(i, u, "forward", e, s), xe.COMMAND_PRIORITY_HIGH)), s.listenersToRemove.add(i.registerCommand(xe.KEY_ESCAPE_COMMAND, (u) => {
    var m = xe.$getSelection();
    return xe.DEPRECATED_$isGridSelection(m) && (m = rr.$findMatchingParent(m.focus.getNode(), ti), ti(m)) ? (Em(u), m.selectEnd(), !0) : !1;
  }, xe.COMMAND_PRIORITY_HIGH));
  let c = (u) => () => {
    var m = xe.$getSelection();
    if (!Zu(m, e))
      return !1;
    if (xe.DEPRECATED_$isGridSelection(m))
      return s.clearText(), !0;
    if (xe.$isRangeSelection(m)) {
      const A = rr.$findMatchingParent(m.anchor.getNode(), (y) => ti(y));
      if (!ti(A))
        return !1;
      var g = m.anchor.getNode(), h = m.focus.getNode();
      if (g = e.isParentOf(g), h = e.isParentOf(h), g && !h || h && !g)
        return s.clearText(), !0;
      if (g = (h = rr.$findMatchingParent(m.anchor.getNode(), (y) => xe.$isElementNode(y))) && rr.$findMatchingParent(h, (y) => xe.$isElementNode(y) && ti(y.getParent())), !xe.$isElementNode(g) || !xe.$isElementNode(h))
        return !1;
      if (u === xe.DELETE_LINE_COMMAND && g.getPreviousSibling() === null)
        return !0;
      if ((u === xe.DELETE_CHARACTER_COMMAND || u === xe.DELETE_WORD_COMMAND) && m.isCollapsed() && m.anchor.offset === 0 && h !== g) {
        m = h.getChildren();
        const y = xe.$createParagraphNode();
        return m.forEach((E) => y.append(E)), h.replace(y), h.getWritable().__parent = A.getKey(), !0;
      }
    }
    return !1;
  };
  return [xe.DELETE_WORD_COMMAND, xe.DELETE_LINE_COMMAND, xe.DELETE_CHARACTER_COMMAND].forEach((u) => {
    s.listenersToRemove.add(i.registerCommand(u, c(u), xe.COMMAND_PRIORITY_CRITICAL));
  }), t = (u) => {
    const m = xe.$getSelection();
    return Zu(m, e) ? xe.DEPRECATED_$isGridSelection(m) ? (u.preventDefault(), u.stopPropagation(), s.clearText(), !0) : (xe.$isRangeSelection(m) && (u = rr.$findMatchingParent(m.anchor.getNode(), (g) => ti(g)), ti(u)), !1) : !1;
  }, s.listenersToRemove.add(i.registerCommand(xe.KEY_BACKSPACE_COMMAND, t, xe.COMMAND_PRIORITY_CRITICAL)), s.listenersToRemove.add(i.registerCommand(xe.KEY_DELETE_COMMAND, t, xe.COMMAND_PRIORITY_CRITICAL)), s.listenersToRemove.add(i.registerCommand(xe.FORMAT_TEXT_COMMAND, (u) => {
    let m = xe.$getSelection();
    return Zu(m, e) ? xe.DEPRECATED_$isGridSelection(m) ? (s.formatCells(u), !0) : (xe.$isRangeSelection(m) && (u = rr.$findMatchingParent(m.anchor.getNode(), (g) => ti(g)), ti(u)), !1) : !1;
  }, xe.COMMAND_PRIORITY_CRITICAL)), s.listenersToRemove.add(i.registerCommand(xe.CONTROLLED_TEXT_INSERTION_COMMAND, () => {
    var u = xe.$getSelection();
    return Zu(u, e) && (xe.DEPRECATED_$isGridSelection(u) ? s.clearHighlight() : xe.$isRangeSelection(u) && (u = rr.$findMatchingParent(u.anchor.getNode(), (m) => ti(m)), ti(u))), !1;
  }, xe.COMMAND_PRIORITY_CRITICAL)), r && s.listenersToRemove.add(i.registerCommand(xe.KEY_TAB_COMMAND, (u) => {
    var m = xe.$getSelection();
    return !xe.$isRangeSelection(m) || !m.isCollapsed() || !Zu(m, e) || (m = Zy(m.anchor.getNode()), m === null) ? !1 : (Em(u), m = e.getCordsFromCellNode(m, s.grid), r7(s, e, m.x, m.y, u.shiftKey ? "backward" : "forward"), !0);
  }, xe.COMMAND_PRIORITY_CRITICAL)), s.listenersToRemove.add(i.registerCommand(
    xe.FOCUS_COMMAND,
    () => e.isSelected(),
    xe.COMMAND_PRIORITY_HIGH
  )), s.listenersToRemove.add(i.registerCommand(xe.SELECTION_CHANGE_COMMAND, () => {
    let u = xe.$getSelection(), m = xe.$getPreviousSelection();
    if (xe.$isRangeSelection(u)) {
      let { anchor: E, focus: v } = u;
      var g = E.getNode(), h = v.getNode();
      g = Zy(g), h = Zy(h);
      var A = g && e.is(U3(g)), y = h && e.is(U3(h));
      let C = A !== y;
      y = A && y, A = u.isBackward(), C ? (g = u.clone(), g.focus.set(e.getKey(), A ? 0 : e.getChildrenSize(), "element"), xe.$setSelection(g), Y3(i, s)) : y && !g.is(h) && (s.setAnchorCellForSelection(n(g)), s.setFocusCellForSelection(
        n(h),
        !0
      ));
    }
    return u && !u.is(m) && (xe.DEPRECATED_$isGridSelection(u) || xe.DEPRECATED_$isGridSelection(m)) && s.gridSelection && !s.gridSelection.is(m) ? (xe.DEPRECATED_$isGridSelection(u) && u.gridKey === s.tableNodeKey ? s.updateTableGridSelection(u) : !xe.DEPRECATED_$isGridSelection(u) && xe.DEPRECATED_$isGridSelection(m) && m.gridKey === s.tableNodeKey && s.updateTableGridSelection(null), !1) : (s.hasHijackedSelectionStyles && !e.isSelected() ? IX(i, s) : !s.hasHijackedSelectionStyles && e.isSelected() && Y3(i, s), !1);
  }, xe.COMMAND_PRIORITY_CRITICAL)), s;
};
ni.getCellFromTarget = Tb;
ni.getTableSelectionFromTableElement = function(e) {
  return e.__lexicalTableSelection;
};
const wX = ni;
var ct = wX, MX = nt, io = ct, G3 = it, Xa = L, tp = X;
function NX(e) {
  let t = new URLSearchParams();
  t.append("code", e);
  for (let i = 1; i < arguments.length; i++)
    t.append("v", arguments[i]);
  throw Error(`Minified Lexical error #${e}; visit https://lexical.dev/docs/error?${t} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
}
_B.TablePlugin = function({ hasCellMerge: e = !0, hasCellBackgroundColor: t = !0, hasTabHandler: i = !0 }) {
  let [r] = MX.useLexicalComposerContext();
  return tp.useEffect(() => (r.hasNodes([io.TableNode, io.TableCellNode, io.TableRowNode]) || NX(10), r.registerCommand(io.INSERT_TABLE_COMMAND, ({ columns: n, rows: o, includeHeaders: s }) => (n = io.$createTableNodeWithDimensions(Number(o), Number(n), s), G3.$insertNodeToNearestRoot(n), n = n.getFirstDescendant(), Xa.$isTextNode(n) && n.select(), !0), Xa.COMMAND_PRIORITY_EDITOR)), [r]), tp.useEffect(
    () => {
      let n = /* @__PURE__ */ new Map(), o = (a) => {
        const l = a.getKey(), c = r.getElementByKey(l);
        c && !n.has(l) && (a = io.applyTableHandlers(a, c, r, i), n.set(l, a));
      };
      r.getEditorState().read(() => {
        let a = Xa.$nodesOfType(io.TableNode);
        for (let l of a)
          io.$isTableNode(l) && o(l);
      });
      let s = r.registerMutationListener(io.TableNode, (a) => {
        for (const [l, c] of a)
          c === "created" ? r.getEditorState().read(() => {
            const u = Xa.$getNodeByKey(l);
            io.$isTableNode(u) && o(u);
          }) : c === "destroyed" && (a = n.get(l), a !== void 0 && (a.removeListeners(), n.delete(l)));
      });
      return () => {
        s();
        for (let [, a] of n)
          a.removeListeners();
      };
    },
    [r, i]
  ), tp.useEffect(() => {
    if (!e)
      return r.registerNodeTransform(io.TableCellNode, (n) => {
        if (1 < n.getColSpan() || 1 < n.getRowSpan()) {
          var [, , o] = Xa.DEPRECATED_$getNodeTriplet(n);
          [n] = Xa.DEPRECATED_$computeGridMap(o, n, n);
          let a = n.length, l = n[0].length;
          if (o = o.getFirstChild(), !Xa.DEPRECATED_$isGridRowNode(o))
            throw Error("Expected TableNode first child to be a RowNode");
          let c = [];
          for (let u = 0; u < a; u++) {
            if (u !== 0 && (o = o.getNextSibling(), !Xa.DEPRECATED_$isGridRowNode(o)))
              throw Error("Expected TableNode first child to be a RowNode");
            let m = null;
            for (let g = 0; g < l; g++) {
              var s = n[u][g];
              let h = s.cell;
              s.startRow === u && s.startColumn === g ? (m = h, c.push(h)) : (1 < h.getColSpan() || 1 < h.getRowSpan()) && (s = io.$createTableCellNode(h.__headerState), m !== null ? m.insertAfter(s) : G3.$insertFirst(o, s));
            }
          }
          for (let u of c)
            u.setColSpan(1), u.setRowSpan(1);
        }
      });
  }, [r, e]), tp.useEffect(() => {
    if (!t)
      return r.registerNodeTransform(io.TableCellNode, (n) => {
        n.getBackgroundColor() !== null && n.setBackgroundColor(null);
      });
  }, [r, t, e]), null;
};
const TX = _B;
var l7 = TX;
const iu = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined", Bb = {
  disableBeforeInput: !1,
  emptyEditor: !1,
  isAutocomplete: !1,
  isCharLimit: !1,
  isCharLimitUtf8: !1,
  isMaxLength: !1,
  isRichText: !0,
  measureTypingPerf: !1,
  shouldUseLexicalContextMenu: !1,
  showNestedEditorTreeView: !1,
  showTableOfContents: !1,
  showTreeView: !0,
  tableCellBackgroundColor: !0,
  tableCellMerge: !0
}, c7 = Co({
  setOption: (e, t) => {
  },
  settings: Bb
}), BX = ({
  children: e,
  initialSettings: t
}) => {
  const [i, r] = se(q(q({}, Bb), t)), n = ye(
    (s, a) => {
      r((l) => ee(q({}, l), {
        [s]: a
      })), q(q({}, Bb), t)[s] === a ? Q3(s, null) : Q3(s, a);
    },
    [t]
  ), o = we(() => ({ setOption: n, settings: i }), [n, i]);
  return /* @__PURE__ */ f(c7.Provider, { value: o, children: e });
}, j2 = () => sn(c7);
function Q3(e, t) {
  const i = new URL(window.location.href), r = new URLSearchParams(i.search);
  t !== null ? r.has(e) ? r.set(e, String(t)) : r.append(e, String(t)) : r.has(e) && r.delete(e), i.search = r.toString(), window.history.pushState(null, "", i.toString());
}
const u7 = Co({}), DX = ({ children: e }) => {
  const t = we(() => ({ historyState: Mc.createEmptyHistoryState() }), []);
  return /* @__PURE__ */ f(u7.Provider, { value: t, children: e });
}, L2 = () => sn(u7);
var hr = {}, d7 = { exports: {} };
(function(e) {
  var t = typeof window != "undefined" ? window : typeof WorkerGlobalScope != "undefined" && self instanceof WorkerGlobalScope ? self : {};
  /**
   * Prism: Lightweight, robust, elegant syntax highlighting
   *
   * @license MIT <https://opensource.org/licenses/MIT>
   * @author Lea Verou <https://lea.verou.me>
   * @namespace
   * @public
   */
  var i = function(r) {
    var n = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i, o = 0, s = {}, a = {
      /**
       * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
       * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
       * additional languages or plugins yourself.
       *
       * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
       *
       * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
       * empty Prism object into the global scope before loading the Prism script like this:
       *
       * ```js
       * window.Prism = window.Prism || {};
       * Prism.manual = true;
       * // add a new <script> to load Prism's script
       * ```
       *
       * @default false
       * @type {boolean}
       * @memberof Prism
       * @public
       */
      manual: r.Prism && r.Prism.manual,
      /**
       * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
       * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
       * own worker, you don't want it to do this.
       *
       * By setting this value to `true`, Prism will not add its own listeners to the worker.
       *
       * You obviously have to change this value before Prism executes. To do this, you can add an
       * empty Prism object into the global scope before loading the Prism script like this:
       *
       * ```js
       * window.Prism = window.Prism || {};
       * Prism.disableWorkerMessageHandler = true;
       * // Load Prism's script
       * ```
       *
       * @default false
       * @type {boolean}
       * @memberof Prism
       * @public
       */
      disableWorkerMessageHandler: r.Prism && r.Prism.disableWorkerMessageHandler,
      /**
       * A namespace for utility methods.
       *
       * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
       * change or disappear at any time.
       *
       * @namespace
       * @memberof Prism
       */
      util: {
        encode: function C(x) {
          return x instanceof l ? new l(x.type, C(x.content), x.alias) : Array.isArray(x) ? x.map(C) : x.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
        },
        /**
         * Returns the name of the type of the given value.
         *
         * @param {any} o
         * @returns {string}
         * @example
         * type(null)      === 'Null'
         * type(undefined) === 'Undefined'
         * type(123)       === 'Number'
         * type('foo')     === 'String'
         * type(true)      === 'Boolean'
         * type([1, 2])    === 'Array'
         * type({})        === 'Object'
         * type(String)    === 'Function'
         * type(/abc+/)    === 'RegExp'
         */
        type: function(C) {
          return Object.prototype.toString.call(C).slice(8, -1);
        },
        /**
         * Returns a unique number for the given object. Later calls will still return the same number.
         *
         * @param {Object} obj
         * @returns {number}
         */
        objId: function(C) {
          return C.__id || Object.defineProperty(C, "__id", { value: ++o }), C.__id;
        },
        /**
         * Creates a deep clone of the given object.
         *
         * The main intended use of this function is to clone language definitions.
         *
         * @param {T} o
         * @param {Record<number, any>} [visited]
         * @returns {T}
         * @template T
         */
        clone: function C(x, S) {
          S = S || {};
          var R, w;
          switch (a.util.type(x)) {
            case "Object":
              if (w = a.util.objId(x), S[w])
                return S[w];
              R = /** @type {Record<string, any>} */
              {}, S[w] = R;
              for (var T in x)
                x.hasOwnProperty(T) && (R[T] = C(x[T], S));
              return (
                /** @type {any} */
                R
              );
            case "Array":
              return w = a.util.objId(x), S[w] ? S[w] : (R = [], S[w] = R, /** @type {Array} */
              /** @type {any} */
              x.forEach(function(N, D) {
                R[D] = C(N, S);
              }), /** @type {any} */
              R);
            default:
              return x;
          }
        },
        /**
         * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
         *
         * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
         *
         * @param {Element} element
         * @returns {string}
         */
        getLanguage: function(C) {
          for (; C; ) {
            var x = n.exec(C.className);
            if (x)
              return x[1].toLowerCase();
            C = C.parentElement;
          }
          return "none";
        },
        /**
         * Sets the Prism `language-xxxx` class of the given element.
         *
         * @param {Element} element
         * @param {string} language
         * @returns {void}
         */
        setLanguage: function(C, x) {
          C.className = C.className.replace(RegExp(n, "gi"), ""), C.classList.add("language-" + x);
        },
        /**
         * Returns the script element that is currently executing.
         *
         * This does __not__ work for line script element.
         *
         * @returns {HTMLScriptElement | null}
         */
        currentScript: function() {
          if (typeof document == "undefined")
            return null;
          if ("currentScript" in document && 1 < 2)
            return (
              /** @type {any} */
              document.currentScript
            );
          try {
            throw new Error();
          } catch (R) {
            var C = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(R.stack) || [])[1];
            if (C) {
              var x = document.getElementsByTagName("script");
              for (var S in x)
                if (x[S].src == C)
                  return x[S];
            }
            return null;
          }
        },
        /**
         * Returns whether a given class is active for `element`.
         *
         * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
         * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
         * given class is just the given class with a `no-` prefix.
         *
         * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
         * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
         * ancestors have the given class or the negated version of it, then the default activation will be returned.
         *
         * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
         * version of it, the class is considered active.
         *
         * @param {Element} element
         * @param {string} className
         * @param {boolean} [defaultActivation=false]
         * @returns {boolean}
         */
        isActive: function(C, x, S) {
          for (var R = "no-" + x; C; ) {
            var w = C.classList;
            if (w.contains(x))
              return !0;
            if (w.contains(R))
              return !1;
            C = C.parentElement;
          }
          return !!S;
        }
      },
      /**
       * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
       *
       * @namespace
       * @memberof Prism
       * @public
       */
      languages: {
        /**
         * The grammar for plain, unformatted text.
         */
        plain: s,
        plaintext: s,
        text: s,
        txt: s,
        /**
         * Creates a deep copy of the language with the given id and appends the given tokens.
         *
         * If a token in `redef` also appears in the copied language, then the existing token in the copied language
         * will be overwritten at its original position.
         *
         * ## Best practices
         *
         * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
         * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
         * understand the language definition because, normally, the order of tokens matters in Prism grammars.
         *
         * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
         * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
         *
         * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
         * @param {Grammar} redef The new tokens to append.
         * @returns {Grammar} The new language created.
         * @public
         * @example
         * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
         *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
         *     // at its original position
         *     'comment': { ... },
         *     // CSS doesn't have a 'color' token, so this token will be appended
         *     'color': /\b(?:red|green|blue)\b/
         * });
         */
        extend: function(C, x) {
          var S = a.util.clone(a.languages[C]);
          for (var R in x)
            S[R] = x[R];
          return S;
        },
        /**
         * Inserts tokens _before_ another token in a language definition or any other grammar.
         *
         * ## Usage
         *
         * This helper method makes it easy to modify existing languages. For example, the CSS language definition
         * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
         * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
         * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
         * this:
         *
         * ```js
         * Prism.languages.markup.style = {
         *     // token
         * };
         * ```
         *
         * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
         * before existing tokens. For the CSS example above, you would use it like this:
         *
         * ```js
         * Prism.languages.insertBefore('markup', 'cdata', {
         *     'style': {
         *         // token
         *     }
         * });
         * ```
         *
         * ## Special cases
         *
         * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
         * will be ignored.
         *
         * This behavior can be used to insert tokens after `before`:
         *
         * ```js
         * Prism.languages.insertBefore('markup', 'comment', {
         *     'comment': Prism.languages.markup.comment,
         *     // tokens after 'comment'
         * });
         * ```
         *
         * ## Limitations
         *
         * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
         * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
         * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
         * deleting properties which is necessary to insert at arbitrary positions.
         *
         * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
         * Instead, it will create a new object and replace all references to the target object with the new one. This
         * can be done without temporarily deleting properties, so the iteration order is well-defined.
         *
         * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
         * you hold the target object in a variable, then the value of the variable will not change.
         *
         * ```js
         * var oldMarkup = Prism.languages.markup;
         * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
         *
         * assert(oldMarkup !== Prism.languages.markup);
         * assert(newMarkup === Prism.languages.markup);
         * ```
         *
         * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
         * object to be modified.
         * @param {string} before The key to insert before.
         * @param {Grammar} insert An object containing the key-value pairs to be inserted.
         * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
         * object to be modified.
         *
         * Defaults to `Prism.languages`.
         * @returns {Grammar} The new grammar object.
         * @public
         */
        insertBefore: function(C, x, S, R) {
          R = R || /** @type {any} */
          a.languages;
          var w = R[C], T = {};
          for (var N in w)
            if (w.hasOwnProperty(N)) {
              if (N == x)
                for (var D in S)
                  S.hasOwnProperty(D) && (T[D] = S[D]);
              S.hasOwnProperty(N) || (T[N] = w[N]);
            }
          var O = R[C];
          return R[C] = T, a.languages.DFS(a.languages, function(F, Y) {
            Y === O && F != C && (this[F] = T);
          }), T;
        },
        // Traverse a language definition with Depth First Search
        DFS: function C(x, S, R, w) {
          w = w || {};
          var T = a.util.objId;
          for (var N in x)
            if (x.hasOwnProperty(N)) {
              S.call(x, N, x[N], R || N);
              var D = x[N], O = a.util.type(D);
              O === "Object" && !w[T(D)] ? (w[T(D)] = !0, C(D, S, null, w)) : O === "Array" && !w[T(D)] && (w[T(D)] = !0, C(D, S, N, w));
            }
        }
      },
      plugins: {},
      /**
       * This is the most high-level function in Prism’s API.
       * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
       * each one of them.
       *
       * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
       *
       * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
       * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
       * @memberof Prism
       * @public
       */
      highlightAll: function(C, x) {
        a.highlightAllUnder(document, C, x);
      },
      /**
       * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
       * {@link Prism.highlightElement} on each one of them.
       *
       * The following hooks will be run:
       * 1. `before-highlightall`
       * 2. `before-all-elements-highlight`
       * 3. All hooks of {@link Prism.highlightElement} for each element.
       *
       * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
       * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
       * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
       * @memberof Prism
       * @public
       */
      highlightAllUnder: function(C, x, S) {
        var R = {
          callback: S,
          container: C,
          selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
        };
        a.hooks.run("before-highlightall", R), R.elements = Array.prototype.slice.apply(R.container.querySelectorAll(R.selector)), a.hooks.run("before-all-elements-highlight", R);
        for (var w = 0, T; T = R.elements[w++]; )
          a.highlightElement(T, x === !0, R.callback);
      },
      /**
       * Highlights the code inside a single element.
       *
       * The following hooks will be run:
       * 1. `before-sanity-check`
       * 2. `before-highlight`
       * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
       * 4. `before-insert`
       * 5. `after-highlight`
       * 6. `complete`
       *
       * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
       * the element's language.
       *
       * @param {Element} element The element containing the code.
       * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
       * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
       * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
       * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
       *
       * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
       * asynchronous highlighting to work. You can build your own bundle on the
       * [Download page](https://prismjs.com/download.html).
       * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
       * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
       * @memberof Prism
       * @public
       */
      highlightElement: function(C, x, S) {
        var R = a.util.getLanguage(C), w = a.languages[R];
        a.util.setLanguage(C, R);
        var T = C.parentElement;
        T && T.nodeName.toLowerCase() === "pre" && a.util.setLanguage(T, R);
        var N = C.textContent, D = {
          element: C,
          language: R,
          grammar: w,
          code: N
        };
        function O(Y) {
          D.highlightedCode = Y, a.hooks.run("before-insert", D), D.element.innerHTML = D.highlightedCode, a.hooks.run("after-highlight", D), a.hooks.run("complete", D), S && S.call(D.element);
        }
        if (a.hooks.run("before-sanity-check", D), T = D.element.parentElement, T && T.nodeName.toLowerCase() === "pre" && !T.hasAttribute("tabindex") && T.setAttribute("tabindex", "0"), !D.code) {
          a.hooks.run("complete", D), S && S.call(D.element);
          return;
        }
        if (a.hooks.run("before-highlight", D), !D.grammar) {
          O(a.util.encode(D.code));
          return;
        }
        if (x && r.Worker) {
          var F = new Worker(a.filename);
          F.onmessage = function(Y) {
            O(Y.data);
          }, F.postMessage(JSON.stringify({
            language: D.language,
            code: D.code,
            immediateClose: !0
          }));
        } else
          O(a.highlight(D.code, D.grammar, D.language));
      },
      /**
       * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
       * and the language definitions to use, and returns a string with the HTML produced.
       *
       * The following hooks will be run:
       * 1. `before-tokenize`
       * 2. `after-tokenize`
       * 3. `wrap`: On each {@link Token}.
       *
       * @param {string} text A string with the code to be highlighted.
       * @param {Grammar} grammar An object containing the tokens to use.
       *
       * Usually a language definition like `Prism.languages.markup`.
       * @param {string} language The name of the language definition passed to `grammar`.
       * @returns {string} The highlighted HTML.
       * @memberof Prism
       * @public
       * @example
       * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
       */
      highlight: function(C, x, S) {
        var R = {
          code: C,
          grammar: x,
          language: S
        };
        if (a.hooks.run("before-tokenize", R), !R.grammar)
          throw new Error('The language "' + R.language + '" has no grammar.');
        return R.tokens = a.tokenize(R.code, R.grammar), a.hooks.run("after-tokenize", R), l.stringify(a.util.encode(R.tokens), R.language);
      },
      /**
       * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
       * and the language definitions to use, and returns an array with the tokenized code.
       *
       * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
       *
       * This method could be useful in other contexts as well, as a very crude parser.
       *
       * @param {string} text A string with the code to be highlighted.
       * @param {Grammar} grammar An object containing the tokens to use.
       *
       * Usually a language definition like `Prism.languages.markup`.
       * @returns {TokenStream} An array of strings and tokens, a token stream.
       * @memberof Prism
       * @public
       * @example
       * let code = `var foo = 0;`;
       * let tokens = Prism.tokenize(code, Prism.languages.javascript);
       * tokens.forEach(token => {
       *     if (token instanceof Prism.Token && token.type === 'number') {
       *         console.log(`Found numeric literal: ${token.content}`);
       *     }
       * });
       */
      tokenize: function(C, x) {
        var S = x.rest;
        if (S) {
          for (var R in S)
            x[R] = S[R];
          delete x.rest;
        }
        var w = new m();
        return g(w, w.head, C), u(C, w, x, w.head, 0), A(w);
      },
      /**
       * @namespace
       * @memberof Prism
       * @public
       */
      hooks: {
        all: {},
        /**
         * Adds the given callback to the list of callbacks for the given hook.
         *
         * The callback will be invoked when the hook it is registered for is run.
         * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
         *
         * One callback function can be registered to multiple hooks and the same hook multiple times.
         *
         * @param {string} name The name of the hook.
         * @param {HookCallback} callback The callback function which is given environment variables.
         * @public
         */
        add: function(C, x) {
          var S = a.hooks.all;
          S[C] = S[C] || [], S[C].push(x);
        },
        /**
         * Runs a hook invoking all registered callbacks with the given environment variables.
         *
         * Callbacks will be invoked synchronously and in the order in which they were registered.
         *
         * @param {string} name The name of the hook.
         * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
         * @public
         */
        run: function(C, x) {
          var S = a.hooks.all[C];
          if (!(!S || !S.length))
            for (var R = 0, w; w = S[R++]; )
              w(x);
        }
      },
      Token: l
    };
    r.Prism = a;
    function l(C, x, S, R) {
      this.type = C, this.content = x, this.alias = S, this.length = (R || "").length | 0;
    }
    l.stringify = function C(x, S) {
      if (typeof x == "string")
        return x;
      if (Array.isArray(x)) {
        var R = "";
        return x.forEach(function(O) {
          R += C(O, S);
        }), R;
      }
      var w = {
        type: x.type,
        content: C(x.content, S),
        tag: "span",
        classes: ["token", x.type],
        attributes: {},
        language: S
      }, T = x.alias;
      T && (Array.isArray(T) ? Array.prototype.push.apply(w.classes, T) : w.classes.push(T)), a.hooks.run("wrap", w);
      var N = "";
      for (var D in w.attributes)
        N += " " + D + '="' + (w.attributes[D] || "").replace(/"/g, "&quot;") + '"';
      return "<" + w.tag + ' class="' + w.classes.join(" ") + '"' + N + ">" + w.content + "</" + w.tag + ">";
    };
    function c(C, x, S, R) {
      C.lastIndex = x;
      var w = C.exec(S);
      if (w && R && w[1]) {
        var T = w[1].length;
        w.index += T, w[0] = w[0].slice(T);
      }
      return w;
    }
    function u(C, x, S, R, w, T) {
      for (var N in S)
        if (!(!S.hasOwnProperty(N) || !S[N])) {
          var D = S[N];
          D = Array.isArray(D) ? D : [D];
          for (var O = 0; O < D.length; ++O) {
            if (T && T.cause == N + "," + O)
              return;
            var F = D[O], Y = F.inside, P = !!F.lookbehind, z = !!F.greedy, W = F.alias;
            if (z && !F.pattern.global) {
              var H = F.pattern.toString().match(/[imsuy]*$/)[0];
              F.pattern = RegExp(F.pattern.source, H + "g");
            }
            for (var Q = F.pattern || F, $ = R.next, le = w; $ !== x.tail && !(T && le >= T.reach); le += $.value.length, $ = $.next) {
              var he = $.value;
              if (x.length > C.length)
                return;
              if (!(he instanceof l)) {
                var oe = 1, ue;
                if (z) {
                  if (ue = c(Q, le, C, P), !ue || ue.index >= C.length)
                    break;
                  var Re = ue.index, Ae = ue.index + ue[0].length, de = le;
                  for (de += $.value.length; Re >= de; )
                    $ = $.next, de += $.value.length;
                  if (de -= $.value.length, le = de, $.value instanceof l)
                    continue;
                  for (var fe = $; fe !== x.tail && (de < Ae || typeof fe.value == "string"); fe = fe.next)
                    oe++, de += fe.value.length;
                  oe--, he = C.slice(le, de), ue.index -= le;
                } else if (ue = c(Q, 0, he, P), !ue)
                  continue;
                var Re = ue.index, qe = ue[0], Oe = he.slice(0, Re), Xe = he.slice(Re + qe.length), Qe = le + he.length;
                T && Qe > T.reach && (T.reach = Qe);
                var Pe = $.prev;
                Oe && (Pe = g(x, Pe, Oe), le += Oe.length), h(x, Pe, oe);
                var et = new l(N, Y ? a.tokenize(qe, Y) : qe, W, qe);
                if ($ = g(x, Pe, et), Xe && g(x, $, Xe), oe > 1) {
                  var At = {
                    cause: N + "," + O,
                    reach: Qe
                  };
                  u(C, x, S, $.prev, le, At), T && At.reach > T.reach && (T.reach = At.reach);
                }
              }
            }
          }
        }
    }
    function m() {
      var C = { value: null, prev: null, next: null }, x = { value: null, prev: C, next: null };
      C.next = x, this.head = C, this.tail = x, this.length = 0;
    }
    function g(C, x, S) {
      var R = x.next, w = { value: S, prev: x, next: R };
      return x.next = w, R.prev = w, C.length++, w;
    }
    function h(C, x, S) {
      for (var R = x.next, w = 0; w < S && R !== C.tail; w++)
        R = R.next;
      x.next = R, R.prev = x, C.length -= w;
    }
    function A(C) {
      for (var x = [], S = C.head.next; S !== C.tail; )
        x.push(S.value), S = S.next;
      return x;
    }
    if (!r.document)
      return r.addEventListener && (a.disableWorkerMessageHandler || r.addEventListener("message", function(C) {
        var x = JSON.parse(C.data), S = x.language, R = x.code, w = x.immediateClose;
        r.postMessage(a.highlight(R, a.languages[S], S)), w && r.close();
      }, !1)), a;
    var y = a.util.currentScript();
    y && (a.filename = y.src, y.hasAttribute("data-manual") && (a.manual = !0));
    function E() {
      a.manual || a.highlightAll();
    }
    if (!a.manual) {
      var v = document.readyState;
      v === "loading" || v === "interactive" && y && y.defer ? document.addEventListener("DOMContentLoaded", E) : window.requestAnimationFrame ? window.requestAnimationFrame(E) : window.setTimeout(E, 16);
    }
    return a;
  }(t);
  e.exports && (e.exports = i), typeof yt != "undefined" && (yt.Prism = i), i.languages.markup = {
    comment: {
      pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
      greedy: !0
    },
    prolog: {
      pattern: /<\?[\s\S]+?\?>/,
      greedy: !0
    },
    doctype: {
      // https://www.w3.org/TR/xml/#NT-doctypedecl
      pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
      greedy: !0,
      inside: {
        "internal-subset": {
          pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
          lookbehind: !0,
          greedy: !0,
          inside: null
          // see below
        },
        string: {
          pattern: /"[^"]*"|'[^']*'/,
          greedy: !0
        },
        punctuation: /^<!|>$|[[\]]/,
        "doctype-tag": /^DOCTYPE/i,
        name: /[^\s<>'"]+/
      }
    },
    cdata: {
      pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
      greedy: !0
    },
    tag: {
      pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
      greedy: !0,
      inside: {
        tag: {
          pattern: /^<\/?[^\s>\/]+/,
          inside: {
            punctuation: /^<\/?/,
            namespace: /^[^\s>\/:]+:/
          }
        },
        "special-attr": [],
        "attr-value": {
          pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
          inside: {
            punctuation: [
              {
                pattern: /^=/,
                alias: "attr-equals"
              },
              {
                pattern: /^(\s*)["']|["']$/,
                lookbehind: !0
              }
            ]
          }
        },
        punctuation: /\/?>/,
        "attr-name": {
          pattern: /[^\s>\/]+/,
          inside: {
            namespace: /^[^\s>\/:]+:/
          }
        }
      }
    },
    entity: [
      {
        pattern: /&[\da-z]{1,8};/i,
        alias: "named-entity"
      },
      /&#x?[\da-f]{1,8};/i
    ]
  }, i.languages.markup.tag.inside["attr-value"].inside.entity = i.languages.markup.entity, i.languages.markup.doctype.inside["internal-subset"].inside = i.languages.markup, i.hooks.add("wrap", function(r) {
    r.type === "entity" && (r.attributes.title = r.content.replace(/&amp;/, "&"));
  }), Object.defineProperty(i.languages.markup.tag, "addInlined", {
    /**
     * Adds an inlined language to markup.
     *
     * An example of an inlined language is CSS with `<style>` tags.
     *
     * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
     * case insensitive.
     * @param {string} lang The language key.
     * @example
     * addInlined('style', 'css');
     */
    value: function(n, o) {
      var s = {};
      s["language-" + o] = {
        pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
        lookbehind: !0,
        inside: i.languages[o]
      }, s.cdata = /^<!\[CDATA\[|\]\]>$/i;
      var a = {
        "included-cdata": {
          pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
          inside: s
        }
      };
      a["language-" + o] = {
        pattern: /[\s\S]+/,
        inside: i.languages[o]
      };
      var l = {};
      l[n] = {
        pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
          return n;
        }), "i"),
        lookbehind: !0,
        greedy: !0,
        inside: a
      }, i.languages.insertBefore("markup", "cdata", l);
    }
  }), Object.defineProperty(i.languages.markup.tag, "addAttribute", {
    /**
     * Adds an pattern to highlight languages embedded in HTML attributes.
     *
     * An example of an inlined language is CSS with `style` attributes.
     *
     * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
     * case insensitive.
     * @param {string} lang The language key.
     * @example
     * addAttribute('style', 'css');
     */
    value: function(r, n) {
      i.languages.markup.tag.inside["special-attr"].push({
        pattern: RegExp(
          /(^|["'\s])/.source + "(?:" + r + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source,
          "i"
        ),
        lookbehind: !0,
        inside: {
          "attr-name": /^[^\s=]+/,
          "attr-value": {
            pattern: /=[\s\S]+/,
            inside: {
              value: {
                pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                lookbehind: !0,
                alias: [n, "language-" + n],
                inside: i.languages[n]
              },
              punctuation: [
                {
                  pattern: /^=/,
                  alias: "attr-equals"
                },
                /"|'/
              ]
            }
          }
        }
      });
    }
  }), i.languages.html = i.languages.markup, i.languages.mathml = i.languages.markup, i.languages.svg = i.languages.markup, i.languages.xml = i.languages.extend("markup", {}), i.languages.ssml = i.languages.xml, i.languages.atom = i.languages.xml, i.languages.rss = i.languages.xml, function(r) {
    var n = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
    r.languages.css = {
      comment: /\/\*[\s\S]*?\*\//,
      atrule: {
        pattern: RegExp("@[\\w-](?:" + /[^;{\s"']|\s+(?!\s)/.source + "|" + n.source + ")*?" + /(?:;|(?=\s*\{))/.source),
        inside: {
          rule: /^@[\w-]+/,
          "selector-function-argument": {
            pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
            lookbehind: !0,
            alias: "selector"
          },
          keyword: {
            pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
            lookbehind: !0
          }
          // See rest below
        }
      },
      url: {
        // https://drafts.csswg.org/css-values-3/#urls
        pattern: RegExp("\\burl\\((?:" + n.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)", "i"),
        greedy: !0,
        inside: {
          function: /^url/i,
          punctuation: /^\(|\)$/,
          string: {
            pattern: RegExp("^" + n.source + "$"),
            alias: "url"
          }
        }
      },
      selector: {
        pattern: RegExp(`(^|[{}\\s])[^{}\\s](?:[^{};"'\\s]|\\s+(?![\\s{])|` + n.source + ")*(?=\\s*\\{)"),
        lookbehind: !0
      },
      string: {
        pattern: n,
        greedy: !0
      },
      property: {
        pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
        lookbehind: !0
      },
      important: /!important\b/i,
      function: {
        pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
        lookbehind: !0
      },
      punctuation: /[(){};:,]/
    }, r.languages.css.atrule.inside.rest = r.languages.css;
    var o = r.languages.markup;
    o && (o.tag.addInlined("style", "css"), o.tag.addAttribute("style", "css"));
  }(i), i.languages.clike = {
    comment: [
      {
        pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
        lookbehind: !0,
        greedy: !0
      },
      {
        pattern: /(^|[^\\:])\/\/.*/,
        lookbehind: !0,
        greedy: !0
      }
    ],
    string: {
      pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
      greedy: !0
    },
    "class-name": {
      pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
      lookbehind: !0,
      inside: {
        punctuation: /[.\\]/
      }
    },
    keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    boolean: /\b(?:false|true)\b/,
    function: /\b\w+(?=\()/,
    number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    punctuation: /[{}[\];(),.:]/
  }, i.languages.javascript = i.languages.extend("clike", {
    "class-name": [
      i.languages.clike["class-name"],
      {
        pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
        lookbehind: !0
      }
    ],
    keyword: [
      {
        pattern: /((?:^|\})\s*)catch\b/,
        lookbehind: !0
      },
      {
        pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
        lookbehind: !0
      }
    ],
    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
    function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    number: {
      pattern: RegExp(
        /(^|[^\w$])/.source + "(?:" + // constant
        (/NaN|Infinity/.source + "|" + // binary integer
        /0[bB][01]+(?:_[01]+)*n?/.source + "|" + // octal integer
        /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + // hexadecimal integer
        /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + // decimal bigint
        /\d+(?:_\d+)*n/.source + "|" + // decimal number (integer or float) but no bigint
        /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ")" + /(?![\w$])/.source
      ),
      lookbehind: !0
    },
    operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
  }), i.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/, i.languages.insertBefore("javascript", "keyword", {
    regex: {
      pattern: RegExp(
        // lookbehind
        // eslint-disable-next-line regexp/no-dupe-characters-character-class
        /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + // Regex pattern:
        // There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
        // classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
        // with the only syntax, so we have to define 2 different regex patterns.
        /\//.source + "(?:" + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + "|" + // `v` flag syntax. This supports 3 levels of nested character classes.
        /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ")" + // lookahead
        /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source
      ),
      lookbehind: !0,
      greedy: !0,
      inside: {
        "regex-source": {
          pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
          lookbehind: !0,
          alias: "language-regex",
          inside: i.languages.regex
        },
        "regex-delimiter": /^\/|\/$/,
        "regex-flags": /^[a-z]+$/
      }
    },
    // This must be declared before keyword because we use "function" inside the look-forward
    "function-variable": {
      pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
      alias: "function"
    },
    parameter: [
      {
        pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
        lookbehind: !0,
        inside: i.languages.javascript
      },
      {
        pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
        lookbehind: !0,
        inside: i.languages.javascript
      },
      {
        pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
        lookbehind: !0,
        inside: i.languages.javascript
      },
      {
        pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
        lookbehind: !0,
        inside: i.languages.javascript
      }
    ],
    constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
  }), i.languages.insertBefore("javascript", "string", {
    hashbang: {
      pattern: /^#!.*/,
      greedy: !0,
      alias: "comment"
    },
    "template-string": {
      pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
      greedy: !0,
      inside: {
        "template-punctuation": {
          pattern: /^`|`$/,
          alias: "string"
        },
        interpolation: {
          pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
          lookbehind: !0,
          inside: {
            "interpolation-punctuation": {
              pattern: /^\$\{|\}$/,
              alias: "punctuation"
            },
            rest: i.languages.javascript
          }
        },
        string: /[\s\S]+/
      }
    },
    "string-property": {
      pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
      lookbehind: !0,
      greedy: !0,
      alias: "property"
    }
  }), i.languages.insertBefore("javascript", "operator", {
    "literal-property": {
      pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
      lookbehind: !0,
      alias: "property"
    }
  }), i.languages.markup && (i.languages.markup.tag.addInlined("script", "javascript"), i.languages.markup.tag.addAttribute(
    /on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source,
    "javascript"
  )), i.languages.js = i.languages.javascript, function() {
    if (typeof i == "undefined" || typeof document == "undefined")
      return;
    Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector);
    var r = "Loading…", n = function(y, E) {
      return "✖ Error " + y + " while fetching file: " + E;
    }, o = "✖ Error: File does not exist or is empty", s = {
      js: "javascript",
      py: "python",
      rb: "ruby",
      ps1: "powershell",
      psm1: "powershell",
      sh: "bash",
      bat: "batch",
      h: "c",
      tex: "latex"
    }, a = "data-src-status", l = "loading", c = "loaded", u = "failed", m = "pre[data-src]:not([" + a + '="' + c + '"]):not([' + a + '="' + l + '"])';
    function g(y, E, v) {
      var C = new XMLHttpRequest();
      C.open("GET", y, !0), C.onreadystatechange = function() {
        C.readyState == 4 && (C.status < 400 && C.responseText ? E(C.responseText) : C.status >= 400 ? v(n(C.status, C.statusText)) : v(o));
      }, C.send(null);
    }
    function h(y) {
      var E = /^\s*(\d+)\s*(?:(,)\s*(?:(\d+)\s*)?)?$/.exec(y || "");
      if (E) {
        var v = Number(E[1]), C = E[2], x = E[3];
        return C ? x ? [v, Number(x)] : [v, void 0] : [v, v];
      }
    }
    i.hooks.add("before-highlightall", function(y) {
      y.selector += ", " + m;
    }), i.hooks.add("before-sanity-check", function(y) {
      var E = (
        /** @type {HTMLPreElement} */
        y.element
      );
      if (E.matches(m)) {
        y.code = "", E.setAttribute(a, l);
        var v = E.appendChild(document.createElement("CODE"));
        v.textContent = r;
        var C = E.getAttribute("data-src"), x = y.language;
        if (x === "none") {
          var S = (/\.(\w+)$/.exec(C) || [, "none"])[1];
          x = s[S] || S;
        }
        i.util.setLanguage(v, x), i.util.setLanguage(E, x);
        var R = i.plugins.autoloader;
        R && R.loadLanguages(x), g(
          C,
          function(w) {
            E.setAttribute(a, c);
            var T = h(E.getAttribute("data-range"));
            if (T) {
              var N = w.split(/\r\n?|\n/g), D = T[0], O = T[1] == null ? N.length : T[1];
              D < 0 && (D += N.length), D = Math.max(0, Math.min(D - 1, N.length)), O < 0 && (O += N.length), O = Math.max(0, Math.min(O, N.length)), w = N.slice(D, O).join(`
`), E.hasAttribute("data-start") || E.setAttribute("data-start", String(D + 1));
            }
            v.textContent = w, i.highlightElement(v);
          },
          function(w) {
            E.setAttribute(a, u), v.textContent = w;
          }
        );
      }
    }), i.plugins.fileHighlight = {
      /**
       * Executes the File Highlight plugin for all matching `pre` elements under the given container.
       *
       * Note: Elements which are already loaded or currently loading will not be touched by this method.
       *
       * @param {ParentNode} [container=document]
       */
      highlight: function(E) {
        for (var v = (E || document).querySelectorAll(m), C = 0, x; x = v[C++]; )
          i.highlightElement(x);
      }
    };
    var A = !1;
    i.fileHighlight = function() {
      A || (console.warn("Prism.fileHighlight is deprecated. Use `Prism.plugins.fileHighlight.highlight` instead."), A = !0), i.plugins.fileHighlight.highlight.apply(this, arguments);
    };
  }();
})(d7);
var OX = d7.exports;
Prism.languages.clike = {
  comment: [
    {
      pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
      lookbehind: !0,
      greedy: !0
    },
    {
      pattern: /(^|[^\\:])\/\/.*/,
      lookbehind: !0,
      greedy: !0
    }
  ],
  string: {
    pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
    greedy: !0
  },
  "class-name": {
    pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
    lookbehind: !0,
    inside: {
      punctuation: /[.\\]/
    }
  },
  keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
  boolean: /\b(?:false|true)\b/,
  function: /\b\w+(?=\()/,
  number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
  operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
  punctuation: /[{}[\];(),.:]/
};
Prism.languages.javascript = Prism.languages.extend("clike", {
  "class-name": [
    Prism.languages.clike["class-name"],
    {
      pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
      lookbehind: !0
    }
  ],
  keyword: [
    {
      pattern: /((?:^|\})\s*)catch\b/,
      lookbehind: !0
    },
    {
      pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
      lookbehind: !0
    }
  ],
  // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
  function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
  number: {
    pattern: RegExp(
      /(^|[^\w$])/.source + "(?:" + // constant
      (/NaN|Infinity/.source + "|" + // binary integer
      /0[bB][01]+(?:_[01]+)*n?/.source + "|" + // octal integer
      /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + // hexadecimal integer
      /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + // decimal bigint
      /\d+(?:_\d+)*n/.source + "|" + // decimal number (integer or float) but no bigint
      /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ")" + /(?![\w$])/.source
    ),
    lookbehind: !0
  },
  operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
});
Prism.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;
Prism.languages.insertBefore("javascript", "keyword", {
  regex: {
    pattern: RegExp(
      // lookbehind
      // eslint-disable-next-line regexp/no-dupe-characters-character-class
      /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + // Regex pattern:
      // There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
      // classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
      // with the only syntax, so we have to define 2 different regex patterns.
      /\//.source + "(?:" + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + "|" + // `v` flag syntax. This supports 3 levels of nested character classes.
      /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ")" + // lookahead
      /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source
    ),
    lookbehind: !0,
    greedy: !0,
    inside: {
      "regex-source": {
        pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
        lookbehind: !0,
        alias: "language-regex",
        inside: Prism.languages.regex
      },
      "regex-delimiter": /^\/|\/$/,
      "regex-flags": /^[a-z]+$/
    }
  },
  // This must be declared before keyword because we use "function" inside the look-forward
  "function-variable": {
    pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
    alias: "function"
  },
  parameter: [
    {
      pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
      lookbehind: !0,
      inside: Prism.languages.javascript
    },
    {
      pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
      lookbehind: !0,
      inside: Prism.languages.javascript
    },
    {
      pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
      lookbehind: !0,
      inside: Prism.languages.javascript
    },
    {
      pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
      lookbehind: !0,
      inside: Prism.languages.javascript
    }
  ],
  constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});
Prism.languages.insertBefore("javascript", "string", {
  hashbang: {
    pattern: /^#!.*/,
    greedy: !0,
    alias: "comment"
  },
  "template-string": {
    pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
    greedy: !0,
    inside: {
      "template-punctuation": {
        pattern: /^`|`$/,
        alias: "string"
      },
      interpolation: {
        pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
        lookbehind: !0,
        inside: {
          "interpolation-punctuation": {
            pattern: /^\$\{|\}$/,
            alias: "punctuation"
          },
          rest: Prism.languages.javascript
        }
      },
      string: /[\s\S]+/
    }
  },
  "string-property": {
    pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
    lookbehind: !0,
    greedy: !0,
    alias: "property"
  }
});
Prism.languages.insertBefore("javascript", "operator", {
  "literal-property": {
    pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
    lookbehind: !0,
    alias: "property"
  }
});
Prism.languages.markup && (Prism.languages.markup.tag.addInlined("script", "javascript"), Prism.languages.markup.tag.addAttribute(
  /on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source,
  "javascript"
));
Prism.languages.js = Prism.languages.javascript;
Prism.languages.markup = {
  comment: {
    pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
    greedy: !0
  },
  prolog: {
    pattern: /<\?[\s\S]+?\?>/,
    greedy: !0
  },
  doctype: {
    // https://www.w3.org/TR/xml/#NT-doctypedecl
    pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
    greedy: !0,
    inside: {
      "internal-subset": {
        pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
        lookbehind: !0,
        greedy: !0,
        inside: null
        // see below
      },
      string: {
        pattern: /"[^"]*"|'[^']*'/,
        greedy: !0
      },
      punctuation: /^<!|>$|[[\]]/,
      "doctype-tag": /^DOCTYPE/i,
      name: /[^\s<>'"]+/
    }
  },
  cdata: {
    pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
    greedy: !0
  },
  tag: {
    pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
    greedy: !0,
    inside: {
      tag: {
        pattern: /^<\/?[^\s>\/]+/,
        inside: {
          punctuation: /^<\/?/,
          namespace: /^[^\s>\/:]+:/
        }
      },
      "special-attr": [],
      "attr-value": {
        pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
        inside: {
          punctuation: [
            {
              pattern: /^=/,
              alias: "attr-equals"
            },
            {
              pattern: /^(\s*)["']|["']$/,
              lookbehind: !0
            }
          ]
        }
      },
      punctuation: /\/?>/,
      "attr-name": {
        pattern: /[^\s>\/]+/,
        inside: {
          namespace: /^[^\s>\/:]+:/
        }
      }
    }
  },
  entity: [
    {
      pattern: /&[\da-z]{1,8};/i,
      alias: "named-entity"
    },
    /&#x?[\da-f]{1,8};/i
  ]
};
Prism.languages.markup.tag.inside["attr-value"].inside.entity = Prism.languages.markup.entity;
Prism.languages.markup.doctype.inside["internal-subset"].inside = Prism.languages.markup;
Prism.hooks.add("wrap", function(e) {
  e.type === "entity" && (e.attributes.title = e.content.replace(/&amp;/, "&"));
});
Object.defineProperty(Prism.languages.markup.tag, "addInlined", {
  /**
   * Adds an inlined language to markup.
   *
   * An example of an inlined language is CSS with `<style>` tags.
   *
   * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
   * case insensitive.
   * @param {string} lang The language key.
   * @example
   * addInlined('style', 'css');
   */
  value: function(t, i) {
    var r = {};
    r["language-" + i] = {
      pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
      lookbehind: !0,
      inside: Prism.languages[i]
    }, r.cdata = /^<!\[CDATA\[|\]\]>$/i;
    var n = {
      "included-cdata": {
        pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
        inside: r
      }
    };
    n["language-" + i] = {
      pattern: /[\s\S]+/,
      inside: Prism.languages[i]
    };
    var o = {};
    o[t] = {
      pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
        return t;
      }), "i"),
      lookbehind: !0,
      greedy: !0,
      inside: n
    }, Prism.languages.insertBefore("markup", "cdata", o);
  }
});
Object.defineProperty(Prism.languages.markup.tag, "addAttribute", {
  /**
   * Adds an pattern to highlight languages embedded in HTML attributes.
   *
   * An example of an inlined language is CSS with `style` attributes.
   *
   * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
   * case insensitive.
   * @param {string} lang The language key.
   * @example
   * addAttribute('style', 'css');
   */
  value: function(e, t) {
    Prism.languages.markup.tag.inside["special-attr"].push({
      pattern: RegExp(
        /(^|["'\s])/.source + "(?:" + e + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source,
        "i"
      ),
      lookbehind: !0,
      inside: {
        "attr-name": /^[^\s=]+/,
        "attr-value": {
          pattern: /=[\s\S]+/,
          inside: {
            value: {
              pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
              lookbehind: !0,
              alias: [t, "language-" + t],
              inside: Prism.languages[t]
            },
            punctuation: [
              {
                pattern: /^=/,
                alias: "attr-equals"
              },
              /"|'/
            ]
          }
        }
      }
    });
  }
});
Prism.languages.html = Prism.languages.markup;
Prism.languages.mathml = Prism.languages.markup;
Prism.languages.svg = Prism.languages.markup;
Prism.languages.xml = Prism.languages.extend("markup", {});
Prism.languages.ssml = Prism.languages.xml;
Prism.languages.atom = Prism.languages.xml;
Prism.languages.rss = Prism.languages.xml;
(function(e) {
  var t = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;
  function i(u) {
    return u = u.replace(/<inner>/g, function() {
      return t;
    }), RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + "(?:" + u + ")");
  }
  var r = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source, n = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(/__/g, function() {
    return r;
  }), o = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source;
  e.languages.markdown = e.languages.extend("markup", {}), e.languages.insertBefore("markdown", "prolog", {
    "front-matter-block": {
      pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/,
      lookbehind: !0,
      greedy: !0,
      inside: {
        punctuation: /^---|---$/,
        "front-matter": {
          pattern: /\S+(?:\s+\S+)*/,
          alias: ["yaml", "language-yaml"],
          inside: e.languages.yaml
        }
      }
    },
    blockquote: {
      // > ...
      pattern: /^>(?:[\t ]*>)*/m,
      alias: "punctuation"
    },
    table: {
      pattern: RegExp("^" + n + o + "(?:" + n + ")*", "m"),
      inside: {
        "table-data-rows": {
          pattern: RegExp("^(" + n + o + ")(?:" + n + ")*$"),
          lookbehind: !0,
          inside: {
            "table-data": {
              pattern: RegExp(r),
              inside: e.languages.markdown
            },
            punctuation: /\|/
          }
        },
        "table-line": {
          pattern: RegExp("^(" + n + ")" + o + "$"),
          lookbehind: !0,
          inside: {
            punctuation: /\||:?-{3,}:?/
          }
        },
        "table-header-row": {
          pattern: RegExp("^" + n + "$"),
          inside: {
            "table-header": {
              pattern: RegExp(r),
              alias: "important",
              inside: e.languages.markdown
            },
            punctuation: /\|/
          }
        }
      }
    },
    code: [
      {
        // Prefixed by 4 spaces or 1 tab and preceded by an empty line
        pattern: /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/,
        lookbehind: !0,
        alias: "keyword"
      },
      {
        // ```optional language
        // code block
        // ```
        pattern: /^```[\s\S]*?^```$/m,
        greedy: !0,
        inside: {
          "code-block": {
            pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m,
            lookbehind: !0
          },
          "code-language": {
            pattern: /^(```).+/,
            lookbehind: !0
          },
          punctuation: /```/
        }
      }
    ],
    title: [
      {
        // title 1
        // =======
        // title 2
        // -------
        pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m,
        alias: "important",
        inside: {
          punctuation: /==+$|--+$/
        }
      },
      {
        // # title 1
        // ###### title 6
        pattern: /(^\s*)#.+/m,
        lookbehind: !0,
        alias: "important",
        inside: {
          punctuation: /^#+|#+$/
        }
      }
    ],
    hr: {
      // ***
      // ---
      // * * *
      // -----------
      pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,
      lookbehind: !0,
      alias: "punctuation"
    },
    list: {
      // * item
      // + item
      // - item
      // 1. item
      pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,
      lookbehind: !0,
      alias: "punctuation"
    },
    "url-reference": {
      // [id]: http://example.com "Optional title"
      // [id]: http://example.com 'Optional title'
      // [id]: http://example.com (Optional title)
      // [id]: <http://example.com> "Optional title"
      pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,
      inside: {
        variable: {
          pattern: /^(!?\[)[^\]]+/,
          lookbehind: !0
        },
        string: /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,
        punctuation: /^[\[\]!:]|[<>]/
      },
      alias: "url"
    },
    bold: {
      // **strong**
      // __strong__
      // allow one nested instance of italic text using the same delimiter
      pattern: i(/\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source),
      lookbehind: !0,
      greedy: !0,
      inside: {
        content: {
          pattern: /(^..)[\s\S]+(?=..$)/,
          lookbehind: !0,
          inside: {}
          // see below
        },
        punctuation: /\*\*|__/
      }
    },
    italic: {
      // *em*
      // _em_
      // allow one nested instance of bold text using the same delimiter
      pattern: i(/\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source),
      lookbehind: !0,
      greedy: !0,
      inside: {
        content: {
          pattern: /(^.)[\s\S]+(?=.$)/,
          lookbehind: !0,
          inside: {}
          // see below
        },
        punctuation: /[*_]/
      }
    },
    strike: {
      // ~~strike through~~
      // ~strike~
      // eslint-disable-next-line regexp/strict
      pattern: i(/(~~?)(?:(?!~)<inner>)+\2/.source),
      lookbehind: !0,
      greedy: !0,
      inside: {
        content: {
          pattern: /(^~~?)[\s\S]+(?=\1$)/,
          lookbehind: !0,
          inside: {}
          // see below
        },
        punctuation: /~~?/
      }
    },
    "code-snippet": {
      // `code`
      // ``code``
      pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/,
      lookbehind: !0,
      greedy: !0,
      alias: ["code", "keyword"]
    },
    url: {
      // [example](http://example.com "Optional title")
      // [example][id]
      // [example] [id]
      pattern: i(/!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source),
      lookbehind: !0,
      greedy: !0,
      inside: {
        operator: /^!/,
        content: {
          pattern: /(^\[)[^\]]+(?=\])/,
          lookbehind: !0,
          inside: {}
          // see below
        },
        variable: {
          pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/,
          lookbehind: !0
        },
        url: {
          pattern: /(^\]\()[^\s)]+/,
          lookbehind: !0
        },
        string: {
          pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/,
          lookbehind: !0
        }
      }
    }
  }), ["url", "bold", "italic", "strike"].forEach(function(u) {
    ["url", "bold", "italic", "strike", "code-snippet"].forEach(function(m) {
      u !== m && (e.languages.markdown[u].inside.content.inside[m] = e.languages.markdown[m]);
    });
  }), e.hooks.add("after-tokenize", function(u) {
    if (u.language !== "markdown" && u.language !== "md")
      return;
    function m(g) {
      if (!(!g || typeof g == "string"))
        for (var h = 0, A = g.length; h < A; h++) {
          var y = g[h];
          if (y.type !== "code") {
            m(y.content);
            continue;
          }
          var E = y.content[1], v = y.content[3];
          if (E && v && E.type === "code-language" && v.type === "code-block" && typeof E.content == "string") {
            var C = E.content.replace(/\b#/g, "sharp").replace(/\b\+\+/g, "pp");
            C = (/[a-z][\w-]*/i.exec(C) || [""])[0].toLowerCase();
            var x = "language-" + C;
            v.alias ? typeof v.alias == "string" ? v.alias = [v.alias, x] : v.alias.push(x) : v.alias = [x];
          }
        }
    }
    m(u.tokens);
  }), e.hooks.add("wrap", function(u) {
    if (u.type === "code-block") {
      for (var m = "", g = 0, h = u.classes.length; g < h; g++) {
        var A = u.classes[g], y = /language-(.+)/.exec(A);
        if (y) {
          m = y[1];
          break;
        }
      }
      var E = e.languages[m];
      if (E)
        u.content = e.highlight(c(u.content), E, m);
      else if (m && m !== "none" && e.plugins.autoloader) {
        var v = "md-" + (/* @__PURE__ */ new Date()).valueOf() + "-" + Math.floor(Math.random() * 1e16);
        u.attributes.id = v, e.plugins.autoloader.loadLanguages(m, function() {
          var C = document.getElementById(v);
          C && (C.innerHTML = e.highlight(C.textContent, e.languages[m], m));
        });
      }
    }
  });
  var s = RegExp(e.languages.markup.tag.pattern.source, "gi"), a = {
    amp: "&",
    lt: "<",
    gt: ">",
    quot: '"'
  }, l = String.fromCodePoint || String.fromCharCode;
  function c(u) {
    var m = u.replace(s, "");
    return m = m.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function(g, h) {
      if (h = h.toLowerCase(), h[0] === "#") {
        var A;
        return h[1] === "x" ? A = parseInt(h.slice(2), 16) : A = Number(h.slice(1)), l(A);
      } else {
        var y = a[h];
        return y || g;
      }
    }), m;
  }
  e.languages.md = e.languages.markdown;
})(Prism);
Prism.languages.c = Prism.languages.extend("clike", {
  comment: {
    pattern: /\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/,
    greedy: !0
  },
  string: {
    // https://en.cppreference.com/w/c/language/string_literal
    pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
    greedy: !0
  },
  "class-name": {
    pattern: /(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/,
    lookbehind: !0
  },
  keyword: /\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|__attribute__|asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|inline|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|typeof|union|unsigned|void|volatile|while)\b/,
  function: /\b[a-z_]\w*(?=\s*\()/i,
  number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i,
  operator: />>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/
});
Prism.languages.insertBefore("c", "string", {
  char: {
    // https://en.cppreference.com/w/c/language/character_constant
    pattern: /'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n]){0,32}'/,
    greedy: !0
  }
});
Prism.languages.insertBefore("c", "string", {
  macro: {
    // allow for multiline macro definitions
    // spaces after the # character compile fine with gcc
    pattern: /(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im,
    lookbehind: !0,
    greedy: !0,
    alias: "property",
    inside: {
      string: [
        {
          // highlight the path of the include statement as a string
          pattern: /^(#\s*include\s*)<[^>]+>/,
          lookbehind: !0
        },
        Prism.languages.c.string
      ],
      char: Prism.languages.c.char,
      comment: Prism.languages.c.comment,
      "macro-name": [
        {
          pattern: /(^#\s*define\s+)\w+\b(?!\()/i,
          lookbehind: !0
        },
        {
          pattern: /(^#\s*define\s+)\w+\b(?=\()/i,
          lookbehind: !0,
          alias: "function"
        }
      ],
      // highlight macro directives as keywords
      directive: {
        pattern: /^(#\s*)[a-z]+/,
        lookbehind: !0,
        alias: "keyword"
      },
      "directive-hash": /^#/,
      punctuation: /##|\\(?=[\r\n])/,
      expression: {
        pattern: /\S[\s\S]*/,
        inside: Prism.languages.c
      }
    }
  }
});
Prism.languages.insertBefore("c", "function", {
  // highlight predefined macros as constants
  constant: /\b(?:EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|__DATE__|__FILE__|__LINE__|__TIMESTAMP__|__TIME__|__func__|stderr|stdin|stdout)\b/
});
delete Prism.languages.c.boolean;
(function(e) {
  var t = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
  e.languages.css = {
    comment: /\/\*[\s\S]*?\*\//,
    atrule: {
      pattern: RegExp("@[\\w-](?:" + /[^;{\s"']|\s+(?!\s)/.source + "|" + t.source + ")*?" + /(?:;|(?=\s*\{))/.source),
      inside: {
        rule: /^@[\w-]+/,
        "selector-function-argument": {
          pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
          lookbehind: !0,
          alias: "selector"
        },
        keyword: {
          pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
          lookbehind: !0
        }
        // See rest below
      }
    },
    url: {
      // https://drafts.csswg.org/css-values-3/#urls
      pattern: RegExp("\\burl\\((?:" + t.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)", "i"),
      greedy: !0,
      inside: {
        function: /^url/i,
        punctuation: /^\(|\)$/,
        string: {
          pattern: RegExp("^" + t.source + "$"),
          alias: "url"
        }
      }
    },
    selector: {
      pattern: RegExp(`(^|[{}\\s])[^{}\\s](?:[^{};"'\\s]|\\s+(?![\\s{])|` + t.source + ")*(?=\\s*\\{)"),
      lookbehind: !0
    },
    string: {
      pattern: t,
      greedy: !0
    },
    property: {
      pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
      lookbehind: !0
    },
    important: /!important\b/i,
    function: {
      pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
      lookbehind: !0
    },
    punctuation: /[(){};:,]/
  }, e.languages.css.atrule.inside.rest = e.languages.css;
  var i = e.languages.markup;
  i && (i.tag.addInlined("style", "css"), i.tag.addAttribute("style", "css"));
})(Prism);
Prism.languages.objectivec = Prism.languages.extend("c", {
  string: {
    pattern: /@?"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
    greedy: !0
  },
  keyword: /\b(?:asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|in|inline|int|long|register|return|self|short|signed|sizeof|static|struct|super|switch|typedef|typeof|union|unsigned|void|volatile|while)\b|(?:@interface|@end|@implementation|@protocol|@class|@public|@protected|@private|@property|@try|@catch|@finally|@throw|@synthesize|@dynamic|@selector)\b/,
  operator: /-[->]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|\|?|[~^%?*\/@]/
});
delete Prism.languages.objectivec["class-name"];
Prism.languages.objc = Prism.languages.objectivec;
Prism.languages.sql = {
  comment: {
    pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
    lookbehind: !0
  },
  variable: [
    {
      pattern: /@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/,
      greedy: !0
    },
    /@[\w.$]+/
  ],
  string: {
    pattern: /(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\]|\2\2)*\2/,
    greedy: !0,
    lookbehind: !0
  },
  identifier: {
    pattern: /(^|[^@\\])`(?:\\[\s\S]|[^`\\]|``)*`/,
    greedy: !0,
    lookbehind: !0,
    inside: {
      punctuation: /^`|`$/
    }
  },
  function: /\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MID|MIN|MOD|NOW|ROUND|SUM|UCASE)(?=\s*\()/i,
  // Should we highlight user defined functions too?
  keyword: /\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:COL|_INSERT)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURN(?:ING|S)?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i,
  boolean: /\b(?:FALSE|NULL|TRUE)\b/i,
  number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
  operator: /[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|DIV|ILIKE|IN|IS|LIKE|NOT|OR|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i,
  punctuation: /[;[\]()`,.]/
};
Prism.languages.python = {
  comment: {
    pattern: /(^|[^\\])#.*/,
    lookbehind: !0,
    greedy: !0
  },
  "string-interpolation": {
    pattern: /(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i,
    greedy: !0,
    inside: {
      interpolation: {
        // "{" <expression> <optional "!s", "!r", or "!a"> <optional ":" format specifier> "}"
        pattern: /((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/,
        lookbehind: !0,
        inside: {
          "format-spec": {
            pattern: /(:)[^:(){}]+(?=\}$)/,
            lookbehind: !0
          },
          "conversion-option": {
            pattern: /![sra](?=[:}]$)/,
            alias: "punctuation"
          },
          rest: null
        }
      },
      string: /[\s\S]+/
    }
  },
  "triple-quoted-string": {
    pattern: /(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i,
    greedy: !0,
    alias: "string"
  },
  string: {
    pattern: /(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i,
    greedy: !0
  },
  function: {
    pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,
    lookbehind: !0
  },
  "class-name": {
    pattern: /(\bclass\s+)\w+/i,
    lookbehind: !0
  },
  decorator: {
    pattern: /(^[\t ]*)@\w+(?:\.\w+)*/m,
    lookbehind: !0,
    alias: ["annotation", "punctuation"],
    inside: {
      punctuation: /\./
    }
  },
  keyword: /\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/,
  builtin: /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,
  boolean: /\b(?:False|None|True)\b/,
  number: /\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i,
  operator: /[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
  punctuation: /[{}[\];(),.:]/
};
Prism.languages.python["string-interpolation"].inside.interpolation.inside.rest = Prism.languages.python;
Prism.languages.py = Prism.languages.python;
(function(e) {
  for (var t = /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\//.source, i = 0; i < 2; i++)
    t = t.replace(/<self>/g, function() {
      return t;
    });
  t = t.replace(/<self>/g, function() {
    return /[^\s\S]/.source;
  }), e.languages.rust = {
    comment: [
      {
        pattern: RegExp(/(^|[^\\])/.source + t),
        lookbehind: !0,
        greedy: !0
      },
      {
        pattern: /(^|[^\\:])\/\/.*/,
        lookbehind: !0,
        greedy: !0
      }
    ],
    string: {
      pattern: /b?"(?:\\[\s\S]|[^\\"])*"|b?r(#*)"(?:[^"]|"(?!\1))*"\1/,
      greedy: !0
    },
    char: {
      pattern: /b?'(?:\\(?:x[0-7][\da-fA-F]|u\{(?:[\da-fA-F]_*){1,6}\}|.)|[^\\\r\n\t'])'/,
      greedy: !0
    },
    attribute: {
      pattern: /#!?\[(?:[^\[\]"]|"(?:\\[\s\S]|[^\\"])*")*\]/,
      greedy: !0,
      alias: "attr-name",
      inside: {
        string: null
        // see below
      }
    },
    // Closure params should not be confused with bitwise OR |
    "closure-params": {
      pattern: /([=(,:]\s*|\bmove\s*)\|[^|]*\||\|[^|]*\|(?=\s*(?:\{|->))/,
      lookbehind: !0,
      greedy: !0,
      inside: {
        "closure-punctuation": {
          pattern: /^\||\|$/,
          alias: "punctuation"
        },
        rest: null
        // see below
      }
    },
    "lifetime-annotation": {
      pattern: /'\w+/,
      alias: "symbol"
    },
    "fragment-specifier": {
      pattern: /(\$\w+:)[a-z]+/,
      lookbehind: !0,
      alias: "punctuation"
    },
    variable: /\$\w+/,
    "function-definition": {
      pattern: /(\bfn\s+)\w+/,
      lookbehind: !0,
      alias: "function"
    },
    "type-definition": {
      pattern: /(\b(?:enum|struct|trait|type|union)\s+)\w+/,
      lookbehind: !0,
      alias: "class-name"
    },
    "module-declaration": [
      {
        pattern: /(\b(?:crate|mod)\s+)[a-z][a-z_\d]*/,
        lookbehind: !0,
        alias: "namespace"
      },
      {
        pattern: /(\b(?:crate|self|super)\s*)::\s*[a-z][a-z_\d]*\b(?:\s*::(?:\s*[a-z][a-z_\d]*\s*::)*)?/,
        lookbehind: !0,
        alias: "namespace",
        inside: {
          punctuation: /::/
        }
      }
    ],
    keyword: [
      // https://github.com/rust-lang/reference/blob/master/src/keywords.md
      /\b(?:Self|abstract|as|async|await|become|box|break|const|continue|crate|do|dyn|else|enum|extern|final|fn|for|if|impl|in|let|loop|macro|match|mod|move|mut|override|priv|pub|ref|return|self|static|struct|super|trait|try|type|typeof|union|unsafe|unsized|use|virtual|where|while|yield)\b/,
      // primitives and str
      // https://doc.rust-lang.org/stable/rust-by-example/primitives.html
      /\b(?:bool|char|f(?:32|64)|[ui](?:8|16|32|64|128|size)|str)\b/
    ],
    // functions can technically start with an upper-case letter, but this will introduce a lot of false positives
    // and Rust's naming conventions recommend snake_case anyway.
    // https://doc.rust-lang.org/1.0.0/style/style/naming/README.html
    function: /\b[a-z_]\w*(?=\s*(?:::\s*<|\())/,
    macro: {
      pattern: /\b\w+!/,
      alias: "property"
    },
    constant: /\b[A-Z_][A-Z_\d]+\b/,
    "class-name": /\b[A-Z]\w*\b/,
    namespace: {
      pattern: /(?:\b[a-z][a-z_\d]*\s*::\s*)*\b[a-z][a-z_\d]*\s*::(?!\s*<)/,
      inside: {
        punctuation: /::/
      }
    },
    // Hex, oct, bin, dec numbers with visual separators and type suffix
    number: /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)(?:_?(?:f32|f64|[iu](?:8|16|32|64|size)?))?\b/,
    boolean: /\b(?:false|true)\b/,
    punctuation: /->|\.\.=|\.{1,3}|::|[{}[\];(),:]/,
    operator: /[-+*\/%!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?=?|[@?]/
  }, e.languages.rust["closure-params"].inside.rest = e.languages.rust, e.languages.rust.attribute.inside.string = e.languages.rust.string;
})(Prism);
Prism.languages.swift = {
  comment: {
    // Nested comments are supported up to 2 levels
    pattern: /(^|[^\\:])(?:\/\/.*|\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\/)/,
    lookbehind: !0,
    greedy: !0
  },
  "string-literal": [
    // https://docs.swift.org/swift-book/LanguageGuide/StringsAndCharacters.html
    {
      pattern: RegExp(
        /(^|[^"#])/.source + "(?:" + /"(?:\\(?:\((?:[^()]|\([^()]*\))*\)|\r\n|[^(])|[^\\\r\n"])*"/.source + "|" + /"""(?:\\(?:\((?:[^()]|\([^()]*\))*\)|[^(])|[^\\"]|"(?!""))*"""/.source + ")" + /(?!["#])/.source
      ),
      lookbehind: !0,
      greedy: !0,
      inside: {
        interpolation: {
          pattern: /(\\\()(?:[^()]|\([^()]*\))*(?=\))/,
          lookbehind: !0,
          inside: null
          // see below
        },
        "interpolation-punctuation": {
          pattern: /^\)|\\\($/,
          alias: "punctuation"
        },
        punctuation: /\\(?=[\r\n])/,
        string: /[\s\S]+/
      }
    },
    {
      pattern: RegExp(
        /(^|[^"#])(#+)/.source + "(?:" + /"(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|\r\n|[^#])|[^\\\r\n])*?"/.source + "|" + /"""(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|[^#])|[^\\])*?"""/.source + ")\\2"
      ),
      lookbehind: !0,
      greedy: !0,
      inside: {
        interpolation: {
          pattern: /(\\#+\()(?:[^()]|\([^()]*\))*(?=\))/,
          lookbehind: !0,
          inside: null
          // see below
        },
        "interpolation-punctuation": {
          pattern: /^\)|\\#+\($/,
          alias: "punctuation"
        },
        string: /[\s\S]+/
      }
    }
  ],
  directive: {
    // directives with conditions
    pattern: RegExp(
      /#/.source + "(?:" + (/(?:elseif|if)\b/.source + "(?:[ 	]*" + /(?:![ \t]*)?(?:\b\w+\b(?:[ \t]*\((?:[^()]|\([^()]*\))*\))?|\((?:[^()]|\([^()]*\))*\))(?:[ \t]*(?:&&|\|\|))?/.source + ")+") + "|" + /(?:else|endif)\b/.source + ")"
    ),
    alias: "property",
    inside: {
      "directive-name": /^#\w+/,
      boolean: /\b(?:false|true)\b/,
      number: /\b\d+(?:\.\d+)*\b/,
      operator: /!|&&|\|\||[<>]=?/,
      punctuation: /[(),]/
    }
  },
  literal: {
    pattern: /#(?:colorLiteral|column|dsohandle|file(?:ID|Literal|Path)?|function|imageLiteral|line)\b/,
    alias: "constant"
  },
  "other-directive": {
    pattern: /#\w+\b/,
    alias: "property"
  },
  attribute: {
    pattern: /@\w+/,
    alias: "atrule"
  },
  "function-definition": {
    pattern: /(\bfunc\s+)\w+/,
    lookbehind: !0,
    alias: "function"
  },
  label: {
    // https://docs.swift.org/swift-book/LanguageGuide/ControlFlow.html#ID141
    pattern: /\b(break|continue)\s+\w+|\b[a-zA-Z_]\w*(?=\s*:\s*(?:for|repeat|while)\b)/,
    lookbehind: !0,
    alias: "important"
  },
  keyword: /\b(?:Any|Protocol|Self|Type|actor|as|assignment|associatedtype|associativity|async|await|break|case|catch|class|continue|convenience|default|defer|deinit|didSet|do|dynamic|else|enum|extension|fallthrough|fileprivate|final|for|func|get|guard|higherThan|if|import|in|indirect|infix|init|inout|internal|is|isolated|lazy|left|let|lowerThan|mutating|none|nonisolated|nonmutating|open|operator|optional|override|postfix|precedencegroup|prefix|private|protocol|public|repeat|required|rethrows|return|right|safe|self|set|some|static|struct|subscript|super|switch|throw|throws|try|typealias|unowned|unsafe|var|weak|where|while|willSet)\b/,
  boolean: /\b(?:false|true)\b/,
  nil: {
    pattern: /\bnil\b/,
    alias: "constant"
  },
  "short-argument": /\$\d+\b/,
  omit: {
    pattern: /\b_\b/,
    alias: "keyword"
  },
  number: /\b(?:[\d_]+(?:\.[\de_]+)?|0x[a-f0-9_]+(?:\.[a-f0-9p_]+)?|0b[01_]+|0o[0-7_]+)\b/i,
  // A class name must start with an upper-case letter and be either 1 letter long or contain a lower-case letter.
  "class-name": /\b[A-Z](?:[A-Z_\d]*[a-z]\w*)?\b/,
  function: /\b[a-z_]\w*(?=\s*\()/i,
  constant: /\b(?:[A-Z_]{2,}|k[A-Z][A-Za-z_]+)\b/,
  // Operators are generic in Swift. Developers can even create new operators (e.g. +++).
  // https://docs.swift.org/swift-book/ReferenceManual/zzSummaryOfTheGrammar.html#ID481
  // This regex only supports ASCII operators.
  operator: /[-+*/%=!<>&|^~?]+|\.[.\-+*/%=!<>&|^~?]+/,
  punctuation: /[{}[\]();,.:\\]/
};
Prism.languages.swift["string-literal"].forEach(function(e) {
  e.inside.interpolation.inside = Prism.languages.swift;
});
(function(e) {
  e.languages.typescript = e.languages.extend("javascript", {
    "class-name": {
      pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
      lookbehind: !0,
      greedy: !0,
      inside: null
      // see below
    },
    builtin: /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/
  }), e.languages.typescript.keyword.push(
    /\b(?:abstract|declare|is|keyof|readonly|require)\b/,
    // keywords that have to be followed by an identifier
    /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/,
    // This is for `import type *, {}`
    /\btype\b(?=\s*(?:[\{*]|$))/
  ), delete e.languages.typescript.parameter, delete e.languages.typescript["literal-property"];
  var t = e.languages.extend("typescript", {});
  delete t["class-name"], e.languages.typescript["class-name"].inside = t, e.languages.insertBefore("typescript", "function", {
    decorator: {
      pattern: /@[$\w\xA0-\uFFFF]+/,
      inside: {
        at: {
          pattern: /^@/,
          alias: "operator"
        },
        function: /^[\s\S]+/
      }
    },
    "generic-function": {
      // e.g. foo<T extends "bar" | "baz">( ...
      pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
      greedy: !0,
      inside: {
        function: /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
        generic: {
          pattern: /<[\s\S]+/,
          // everything after the first <
          alias: "class-name",
          inside: t
        }
      }
    }
  }), e.languages.ts = e.languages.typescript;
})(Prism);
(function(e) {
  var t = /\b(?:abstract|assert|boolean|break|byte|case|catch|char|class|const|continue|default|do|double|else|enum|exports|extends|final|finally|float|for|goto|if|implements|import|instanceof|int|interface|long|module|native|new|non-sealed|null|open|opens|package|permits|private|protected|provides|public|record(?!\s*[(){}[\]<>=%~.:,;?+\-*/&|^])|requires|return|sealed|short|static|strictfp|super|switch|synchronized|this|throw|throws|to|transient|transitive|try|uses|var|void|volatile|while|with|yield)\b/, i = /(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source, r = {
    pattern: RegExp(/(^|[^\w.])/.source + i + /[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source),
    lookbehind: !0,
    inside: {
      namespace: {
        pattern: /^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,
        inside: {
          punctuation: /\./
        }
      },
      punctuation: /\./
    }
  };
  e.languages.java = e.languages.extend("clike", {
    string: {
      pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"/,
      lookbehind: !0,
      greedy: !0
    },
    "class-name": [
      r,
      {
        // variables, parameters, and constructor references
        // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
        pattern: RegExp(/(^|[^\w.])/.source + i + /[A-Z]\w*(?=\s+\w+\s*[;,=()]|\s*(?:\[[\s,]*\]\s*)?::\s*new\b)/.source),
        lookbehind: !0,
        inside: r.inside
      },
      {
        // class names based on keyword
        // this to support class names (or generic parameters) which do not contain a lower case letter (also works for methods)
        pattern: RegExp(/(\b(?:class|enum|extends|implements|instanceof|interface|new|record|throws)\s+)/.source + i + /[A-Z]\w*\b/.source),
        lookbehind: !0,
        inside: r.inside
      }
    ],
    keyword: t,
    function: [
      e.languages.clike.function,
      {
        pattern: /(::\s*)[a-z_]\w*/,
        lookbehind: !0
      }
    ],
    number: /\b0b[01][01_]*L?\b|\b0x(?:\.[\da-f_p+-]+|[\da-f_]+(?:\.[\da-f_p+-]+)?)\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfl]?/i,
    operator: {
      pattern: /(^|[^.])(?:<<=?|>>>?=?|->|--|\+\+|&&|\|\||::|[?:~]|[-+*/%&|^!=<>]=?)/m,
      lookbehind: !0
    },
    constant: /\b[A-Z][A-Z_\d]+\b/
  }), e.languages.insertBefore("java", "string", {
    "triple-quoted-string": {
      // http://openjdk.java.net/jeps/355#Description
      pattern: /"""[ \t]*[\r\n](?:(?:"|"")?(?:\\.|[^"\\]))*"""/,
      greedy: !0,
      alias: "string"
    },
    char: {
      pattern: /'(?:\\.|[^'\\\r\n]){1,6}'/,
      greedy: !0
    }
  }), e.languages.insertBefore("java", "class-name", {
    annotation: {
      pattern: /(^|[^.])@\w+(?:\s*\.\s*\w+)*/,
      lookbehind: !0,
      alias: "punctuation"
    },
    generics: {
      pattern: /<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&))*>)*>)*>)*>/,
      inside: {
        "class-name": r,
        keyword: t,
        punctuation: /[<>(),.:]/,
        operator: /[?&|]/
      }
    },
    import: [
      {
        pattern: RegExp(/(\bimport\s+)/.source + i + /(?:[A-Z]\w*|\*)(?=\s*;)/.source),
        lookbehind: !0,
        inside: {
          namespace: r.inside.namespace,
          punctuation: /\./,
          operator: /\*/,
          "class-name": /\w+/
        }
      },
      {
        pattern: RegExp(/(\bimport\s+static\s+)/.source + i + /(?:\w+|\*)(?=\s*;)/.source),
        lookbehind: !0,
        alias: "static",
        inside: {
          namespace: r.inside.namespace,
          static: /\b\w+$/,
          punctuation: /\./,
          operator: /\*/,
          "class-name": /\w+/
        }
      }
    ],
    namespace: {
      pattern: RegExp(
        /(\b(?:exports|import(?:\s+static)?|module|open|opens|package|provides|requires|to|transitive|uses|with)\s+)(?!<keyword>)[a-z]\w*(?:\.[a-z]\w*)*\.?/.source.replace(/<keyword>/g, function() {
          return t.source;
        })
      ),
      lookbehind: !0,
      inside: {
        punctuation: /\./
      }
    }
  });
})(Prism);
(function(e) {
  var t = /\b(?:alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|char8_t|class|co_await|co_return|co_yield|compl|concept|const|const_cast|consteval|constexpr|constinit|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|final|float|for|friend|goto|if|import|inline|int|int16_t|int32_t|int64_t|int8_t|long|module|mutable|namespace|new|noexcept|nullptr|operator|override|private|protected|public|register|reinterpret_cast|requires|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|uint16_t|uint32_t|uint64_t|uint8_t|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/, i = /\b(?!<keyword>)\w+(?:\s*\.\s*\w+)*\b/.source.replace(/<keyword>/g, function() {
    return t.source;
  });
  e.languages.cpp = e.languages.extend("c", {
    "class-name": [
      {
        pattern: RegExp(/(\b(?:class|concept|enum|struct|typename)\s+)(?!<keyword>)\w+/.source.replace(/<keyword>/g, function() {
          return t.source;
        })),
        lookbehind: !0
      },
      // This is intended to capture the class name of method implementations like:
      //   void foo::bar() const {}
      // However! The `foo` in the above example could also be a namespace, so we only capture the class name if
      // it starts with an uppercase letter. This approximation should give decent results.
      /\b[A-Z]\w*(?=\s*::\s*\w+\s*\()/,
      // This will capture the class name before destructors like:
      //   Foo::~Foo() {}
      /\b[A-Z_]\w*(?=\s*::\s*~\w+\s*\()/i,
      // This also intends to capture the class name of method implementations but here the class has template
      // parameters, so it can't be a namespace (until C++ adds generic namespaces).
      /\b\w+(?=\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>\s*::\s*\w+\s*\()/
    ],
    keyword: t,
    number: {
      pattern: /(?:\b0b[01']+|\b0x(?:[\da-f']+(?:\.[\da-f']*)?|\.[\da-f']+)(?:p[+-]?[\d']+)?|(?:\b[\d']+(?:\.[\d']*)?|\B\.[\d']+)(?:e[+-]?[\d']+)?)[ful]{0,4}/i,
      greedy: !0
    },
    operator: />>=?|<<=?|->|--|\+\+|&&|\|\||[?:~]|<=>|[-+*/%&|^!=<>]=?|\b(?:and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/,
    boolean: /\b(?:false|true)\b/
  }), e.languages.insertBefore("cpp", "string", {
    module: {
      // https://en.cppreference.com/w/cpp/language/modules
      pattern: RegExp(
        /(\b(?:import|module)\s+)/.source + "(?:" + // header-name
        /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|<[^<>\r\n]*>/.source + "|" + // module name or partition or both
        /<mod-name>(?:\s*:\s*<mod-name>)?|:\s*<mod-name>/.source.replace(/<mod-name>/g, function() {
          return i;
        }) + ")"
      ),
      lookbehind: !0,
      greedy: !0,
      inside: {
        string: /^[<"][\s\S]+/,
        operator: /:/,
        punctuation: /\./
      }
    },
    "raw-string": {
      pattern: /R"([^()\\ ]{0,16})\([\s\S]*?\)\1"/,
      alias: "string",
      greedy: !0
    }
  }), e.languages.insertBefore("cpp", "keyword", {
    "generic-function": {
      pattern: /\b(?!operator\b)[a-z_]\w*\s*<(?:[^<>]|<[^<>]*>)*>(?=\s*\()/i,
      inside: {
        function: /^\w+/,
        generic: {
          pattern: /<[\s\S]+/,
          alias: "class-name",
          inside: e.languages.cpp
        }
      }
    }
  }), e.languages.insertBefore("cpp", "operator", {
    "double-colon": {
      pattern: /::/,
      alias: "punctuation"
    }
  }), e.languages.insertBefore("cpp", "class-name", {
    // the base clause is an optional list of parent classes
    // https://en.cppreference.com/w/cpp/language/class
    "base-clause": {
      pattern: /(\b(?:class|struct)\s+\w+\s*:\s*)[^;{}"'\s]+(?:\s+[^;{}"'\s]+)*(?=\s*[;{])/,
      lookbehind: !0,
      greedy: !0,
      inside: e.languages.extend("cpp", {})
    }
  }), e.languages.insertBefore("inside", "double-colon", {
    // All untokenized words that are not namespaces should be class names
    "class-name": /\b[a-z_]\w*\b(?!\s*::)/i
  }, e.languages.cpp["base-clause"]);
})(Prism);
var n0 = OX, Nc = it, Ve = L;
let W3 = (e) => e != null && n0.languages.hasOwnProperty(e) ? e : void 0;
function m7(e, t) {
  for (let i of e.childNodes) {
    if (Nc.isHTMLElement(i) && i.tagName === t)
      return !0;
    m7(i, t);
  }
  return !1;
}
let o0 = class g7 extends Ve.ElementNode {
  static getType() {
    return "code";
  }
  static clone(t) {
    return new g7(t.__language, t.__key);
  }
  constructor(t, i) {
    super(i), this.__language = W3(t);
  }
  createDOM(t) {
    let i = document.createElement("code");
    return Nc.addClassNamesToElement(i, t.theme.code), i.setAttribute("spellcheck", "false"), (t = this.getLanguage()) && i.setAttribute("data-highlight-language", t), i;
  }
  updateDOM(t, i) {
    let r = this.__language;
    return t = t.__language, r ? r !== t && i.setAttribute("data-highlight-language", r) : t && i.removeAttribute("data-highlight-language"), !1;
  }
  exportDOM() {
    let t = document.createElement("pre");
    t.setAttribute("spellcheck", "false");
    let i = this.getLanguage();
    return i && t.setAttribute("data-highlight-language", i), { element: t };
  }
  static importDOM() {
    return { code: (t) => t.textContent != null && (/\r?\n/.test(t.textContent) || m7(t, "BR")) ? { conversion: Z3, priority: 1 } : null, div: () => ({ conversion: FX, priority: 1 }), pre: () => ({ conversion: Z3, priority: 0 }), table: (t) => Jy(t) ? { conversion: VX, priority: 3 } : null, td: (t) => {
      let i = t.closest("table");
      return t.classList.contains("js-file-line") ? { conversion: qX, priority: 3 } : i && Jy(i) ? { conversion: J3, priority: 3 } : null;
    }, tr: (t) => (t = t.closest("table")) && Jy(t) ? { conversion: J3, priority: 3 } : null };
  }
  static importJSON(t) {
    let i = U0(t.language);
    return i.setFormat(t.format), i.setIndent(t.indent), i.setDirection(t.direction), i;
  }
  exportJSON() {
    return ee(q({}, super.exportJSON()), { language: this.getLanguage(), type: "code", version: 1 });
  }
  insertNewAfter(t, i = !0) {
    var r = this.getChildren(), n = r.length;
    if (2 <= n && r[n - 1].getTextContent() === `
` && r[n - 2].getTextContent() === `
` && t.isCollapsed() && t.anchor.key === this.__key && t.anchor.offset === n)
      return r[n - 1].remove(), r[n - 2].remove(), t = Ve.$createParagraphNode(), this.insertAfter(t, i), t;
    if (i = t.anchor, r = t.focus, i = (i.isBefore(r) ? i : r).getNode(), ji(i) || Ve.$isTabNode(i)) {
      for (i = Rl(i), r = []; ; )
        if (Ve.$isTabNode(i))
          r.push(Ve.$createTabNode()), i = i.getNextSibling();
        else if (ji(i)) {
          n = 0;
          let o = i.getTextContent(), s = i.getTextContentSize();
          for (; n < s && o[n] === " "; n++)
            ;
          if (n !== 0 && r.push(Ef(" ".repeat(n))), n !== s)
            break;
          i = i.getNextSibling();
        } else
          break;
      if (0 < r.length)
        return t.insertNodes([
          Ve.$createLineBreakNode(),
          ...r
        ]), r[r.length - 1];
    }
    return null;
  }
  canIndent() {
    return !1;
  }
  collapseAtStart() {
    let t = Ve.$createParagraphNode();
    return this.getChildren().forEach((i) => t.append(i)), this.replace(t), !0;
  }
  setLanguage(t) {
    this.getWritable().__language = W3(t);
  }
  getLanguage() {
    return this.getLatest().__language;
  }
};
function U0(e) {
  return Ve.$applyNodeReplacement(new o0(e));
}
function gs(e) {
  return e instanceof o0;
}
function Z3(e) {
  let t;
  return Nc.isHTMLElement(e) && (t = e.getAttribute("data-highlight-language")), { node: U0(t) };
}
function FX(e) {
  let t = e.style.fontFamily.match("monospace") !== null;
  return t || jX(e) ? { after: (i) => {
    let r = e.parentNode;
    return r != null && e !== r.lastChild && i.push(Ve.$createLineBreakNode()), i;
  }, node: t ? U0() : null } : { node: null };
}
function VX() {
  return { node: U0() };
}
function J3() {
  return { node: null };
}
function qX(e) {
  return { after: (t) => (e.parentNode && e.parentNode.nextSibling && t.push(Ve.$createLineBreakNode()), t), node: null };
}
function jX(e) {
  for (e = e.parentElement; e !== null; ) {
    if (e.style.fontFamily.match("monospace") !== null)
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function Jy(e) {
  return e.classList.contains("js-file-line-container");
}
let h7 = { c: "C", clike: "C-like", cpp: "C++", css: "CSS", html: "HTML", java: "Java", js: "JavaScript", markdown: "Markdown", objc: "Objective-C", plain: "Plain Text", py: "Python", rust: "Rust", sql: "SQL", swift: "Swift", typescript: "TypeScript", xml: "XML" }, p7 = { cpp: "cpp", java: "java", javascript: "js", md: "markdown", plaintext: "plain", python: "py", text: "plain", ts: "typescript" };
function f7(e) {
  return p7[e] || e;
}
let Qm = class A7 extends Ve.TextNode {
  constructor(t, i, r) {
    super(t, r), this.__highlightType = i;
  }
  static getType() {
    return "code-highlight";
  }
  static clone(t) {
    return new A7(t.__text, t.__highlightType || void 0, t.__key);
  }
  getHighlightType() {
    return this.getLatest().__highlightType;
  }
  createDOM(t) {
    let i = super.createDOM(t);
    return t = Py(t.theme, this.__highlightType), Nc.addClassNamesToElement(i, t), i;
  }
  updateDOM(t, i, r) {
    let n = super.updateDOM(t, i, r);
    return t = Py(r.theme, t.__highlightType), r = Py(r.theme, this.__highlightType), t !== r && (t && Nc.removeClassNamesFromElement(
      i,
      t
    ), r && Nc.addClassNamesToElement(i, r)), n;
  }
  static importJSON(t) {
    let i = Ef(t.text, t.highlightType);
    return i.setFormat(t.format), i.setDetail(t.detail), i.setMode(t.mode), i.setStyle(t.style), i;
  }
  exportJSON() {
    return ee(q({}, super.exportJSON()), { highlightType: this.getHighlightType(), type: "code-highlight", version: 1 });
  }
  setFormat() {
    return this;
  }
  isParentRequired() {
    return !0;
  }
  createParentElementNode() {
    return U0();
  }
};
function Py(e, t) {
  return t && e && e.codeHighlight && e.codeHighlight[t];
}
function Ef(e, t) {
  return Ve.$applyNodeReplacement(new Qm(e, t));
}
function ji(e) {
  return e instanceof Qm;
}
function Rl(e) {
  let t = e;
  for (; ji(e) || Ve.$isTabNode(e); )
    t = e, e = e.getPreviousSibling();
  return t;
}
function s0(e) {
  let t = e;
  for (; ji(e) || Ve.$isTabNode(e); )
    t = e, e = e.getNextSibling();
  return t;
}
let y7 = { defaultLanguage: "javascript", tokenize(e, t) {
  return n0.tokenize(e, n0.languages[t || ""] || n0.languages[this.defaultLanguage]);
} };
function E7(e, t) {
  let i = null;
  var r = null, n = e;
  let o = t, s = e.getTextContent();
  for (; ; ) {
    if (o === 0) {
      if (n = n.getPreviousSibling(), n === null)
        break;
      if (!(ji(n) || Ve.$isTabNode(n) || Ve.$isLineBreakNode(n)))
        throw Error("Expected a valid Code Node: CodeHighlightNode, TabNode, LineBreakNode");
      if (Ve.$isLineBreakNode(n)) {
        i = { node: n, offset: 1 };
        break;
      }
      o = Math.max(0, n.getTextContentSize() - 1), s = n.getTextContent();
    } else
      o--;
    let a = s[o];
    ji(n) && a !== " " && (r = { node: n, offset: o });
  }
  if (r !== null)
    return r;
  if (r = null, t < e.getTextContentSize() ? ji(e) && (r = e.getTextContent()[t]) : (n = e.getNextSibling(), ji(n) && (r = n.getTextContent()[0])), r !== null && r !== " ")
    return i;
  e:
    for (r = e, n = e.getTextContent(), e = e.getTextContentSize(); ; ) {
      if (!ji(r) || t === e) {
        if (r = r.getNextSibling(), r === null || Ve.$isLineBreakNode(r)) {
          e = null;
          break e;
        }
        ji(r) && (t = 0, n = r.getTextContent(), e = r.getTextContentSize());
      }
      if (ji(r)) {
        if (n[t] !== " ") {
          e = { node: r, offset: t };
          break e;
        }
        t++;
      }
    }
  return e !== null ? e : i;
}
function v7(e) {
  if (e = s0(e), Ve.$isLineBreakNode(e))
    throw Error("Unexpected lineBreakNode in getEndOfCodeInLine");
  return e;
}
function P3(e, t, i) {
  let r = e.getParent();
  gs(r) ? b7(r, t, i) : ji(e) && e.replace(Ve.$createTextNode(e.__text));
}
let zy = /* @__PURE__ */ new Set();
function b7(e, t, i) {
  let r = e.getKey();
  zy.has(r) || (zy.add(r), e.getLanguage() === void 0 && e.setLanguage(i.defaultLanguage), t.update(() => {
    LX(r, () => {
      var n = Ve.$getNodeByKey(r);
      if (!gs(n) || !n.isAttached())
        return !1;
      var o = n.getTextContent();
      o = i.tokenize(o, n.getLanguage() || i.defaultLanguage), o = Db(o);
      var s = n.getChildren();
      for (n = 0; n < s.length && z3(s[n], o[n]); )
        n++;
      var a = s.length;
      let l = o.length, c = Math.min(a, l) - n, u = 0;
      for (; u < c; )
        if (u++, !z3(s[a - u], o[l - u])) {
          u--;
          break;
        }
      s = n, a -= u, o = o.slice(n, l - u);
      let { from: m, to: g, nodesForReplacement: h } = { from: s, nodesForReplacement: o, to: a };
      return m !== g || h.length ? (e.splice(m, g - m, h), !0) : !1;
    });
  }, { onUpdate: () => {
    zy.delete(r);
  }, skipTransforms: !0 }));
}
function Db(e, t) {
  let i = [];
  for (let r of e)
    if (typeof r == "string") {
      e = r.split(/(\n|\t)/);
      let n = e.length;
      for (let o = 0; o < n; o++) {
        let s = e[o];
        s === `
` || s === `\r
` ? i.push(Ve.$createLineBreakNode()) : s === "	" ? i.push(Ve.$createTabNode()) : 0 < s.length && i.push(Ef(s, t));
      }
    } else
      ({ content: e } = r), typeof e == "string" ? i.push(...Db([e], r.type)) : Array.isArray(e) && i.push(...Db(e, r.type));
  return i;
}
function LX(e, t) {
  if (e = Ve.$getNodeByKey(e), gs(e) && e.isAttached()) {
    var i = Ve.$getSelection();
    if (Ve.$isRangeSelection(i)) {
      i = i.anchor;
      var r = i.offset, n = i.type === "element" && Ve.$isLineBreakNode(e.getChildAtIndex(i.offset - 1)), o = 0;
      if (!n) {
        let s = i.getNode();
        o = r + s.getPreviousSiblings().reduce((a, l) => a + l.getTextContentSize(), 0);
      }
      t() && (n ? i.getNode().select(r, r) : e.getChildren().some((s) => {
        let a = Ve.$isTextNode(s);
        if (a || Ve.$isLineBreakNode(s)) {
          let l = s.getTextContentSize();
          if (a && l >= o)
            return s.select(o, o), !0;
          o -= l;
        }
        return !1;
      }));
    } else
      t();
  }
}
function z3(e, t) {
  return ji(e) && ji(t) && e.__text === t.__text && e.__highlightType === t.__highlightType || Ve.$isTabNode(e) && Ve.$isTabNode(t) || Ve.$isLineBreakNode(e) && Ve.$isLineBreakNode(t);
}
function vf(e) {
  if (!Ve.$isRangeSelection(e))
    return !1;
  var t = e.anchor.getNode();
  return e = e.focus.getNode(), t.is(e) && gs(t) ? !0 : (t = t.getParent(), gs(t) && t.is(e.getParent()));
}
function C7(e) {
  e = e.getNodes();
  let t = [[]];
  if (e.length === 1 && gs(e[0]))
    return t;
  let i = t[0];
  for (let r = 0; r < e.length; r++) {
    let n = e[r];
    if (!(ji(n) || Ve.$isTabNode(n) || Ve.$isLineBreakNode(n)))
      throw Error("Expected selection to be inside CodeBlock and consisting of CodeHighlightNode, TabNode and LineBreakNode");
    Ve.$isLineBreakNode(n) ? r !== 0 && 0 < i.length && (i = [], t.push(i)) : i.push(n);
  }
  return t;
}
function KX(e) {
  var t = Ve.$getSelection();
  if (!Ve.$isRangeSelection(t) || !vf(t))
    return null;
  let i = e ? Ve.OUTDENT_CONTENT_COMMAND : Ve.INDENT_CONTENT_COMMAND;
  if (e = e ? Ve.OUTDENT_CONTENT_COMMAND : Ve.INSERT_TAB_COMMAND, 1 < C7(t).length)
    return i;
  var r = t.getNodes()[0];
  if (!(gs(r) || ji(r) || Ve.$isTabNode(r) || Ve.$isLineBreakNode(r)))
    throw Error("Expected selection firstNode to be CodeHighlightNode or TabNode");
  if (gs(r))
    return i;
  let n = Rl(r);
  r = s0(r);
  var o = t.anchor;
  let s = t.focus;
  return s.isBefore(o) ? t = s : (t = o, o = s), n !== null && r !== null && t.key === n.getKey() && t.offset === 0 && o.key === r.getKey() && o.offset === r.getTextContentSize() ? i : e;
}
function H3(e) {
  var t = Ve.$getSelection();
  if (!Ve.$isRangeSelection(t) || !vf(t))
    return !1;
  var i = C7(t);
  let r = i.length;
  if (1 < i.length) {
    for (t = 0; t < r; t++) {
      var n = i[t];
      0 < n.length && (n = n[0], t === 0 && (n = Rl(n)), n !== null && (e === Ve.INDENT_CONTENT_COMMAND ? n.insertBefore(Ve.$createTabNode()) : Ve.$isTabNode(n) && n.remove()));
    }
    return !0;
  }
  if (i = t.getNodes()[0], !(gs(i) || ji(i) || Ve.$isTabNode(i) || Ve.$isLineBreakNode(i)))
    throw Error("Expected selection firstNode to be CodeHighlightNode or CodeTabNode");
  if (gs(i))
    return e === Ve.INDENT_CONTENT_COMMAND && t.insertNodes([Ve.$createTabNode()]), !0;
  if (i = Rl(i), i === null)
    throw Error("Expected getFirstCodeNodeOfLine to return a valid Code Node");
  return e === Ve.INDENT_CONTENT_COMMAND ? Ve.$isLineBreakNode(i) ? i.insertAfter(Ve.$createTabNode()) : i.insertBefore(Ve.$createTabNode()) : Ve.$isTabNode(i) && i.remove(), !0;
}
function X3(e, t) {
  let i = Ve.$getSelection();
  if (!Ve.$isRangeSelection(i))
    return !1;
  let { anchor: r, focus: n } = i, o = r.offset, s = n.offset, a = r.getNode(), l = n.getNode();
  var c = e === Ve.KEY_ARROW_UP_COMMAND;
  if (!vf(i) || !ji(a) && !Ve.$isTabNode(a) || !ji(l) && !Ve.$isTabNode(l))
    return !1;
  if (!t.altKey) {
    if (i.isCollapsed()) {
      if (e = a.getParentOrThrow(), c && o === 0 && a.getPreviousSibling() === null) {
        if (e.getPreviousSibling() === null)
          return e.selectPrevious(), t.preventDefault(), !0;
      } else if (!c && o === a.getTextContentSize() && a.getNextSibling() === null && e.getNextSibling() === null)
        return e.selectNext(), t.preventDefault(), !0;
    }
    return !1;
  }
  let u;
  if (a.isBefore(l)) {
    var m = Rl(a);
    u = s0(l);
  } else
    m = Rl(l), u = s0(a);
  if (m == null || u == null)
    return !1;
  let g = m.getNodesBetween(u);
  for (let A = 0; A < g.length; A++) {
    let y = g[A];
    if (!ji(y) && !Ve.$isTabNode(y) && !Ve.$isLineBreakNode(y))
      return !1;
  }
  if (t.preventDefault(), t.stopPropagation(), t = c ? m.getPreviousSibling() : u.getNextSibling(), !Ve.$isLineBreakNode(t) || (m = c ? t.getPreviousSibling() : t.getNextSibling(), m == null))
    return !0;
  c = ji(m) || Ve.$isTabNode(m) || Ve.$isLineBreakNode(m) ? c ? Rl(m) : s0(m) : null;
  let h = c != null ? c : m;
  return t.remove(), g.forEach((A) => A.remove()), e === Ve.KEY_ARROW_UP_COMMAND ? (g.forEach((A) => h.insertBefore(A)), h.insertBefore(t)) : (h.insertAfter(t), h = t, g.forEach((A) => {
    h.insertAfter(A), h = A;
  })), i.setTextNodeRange(a, o, l, s), !0;
}
function _3(e, t) {
  let i = Ve.$getSelection();
  if (!Ve.$isRangeSelection(i))
    return !1;
  let { anchor: r, focus: n } = i;
  var o = r.getNode();
  let s = n.getNode();
  if (e = e === Ve.MOVE_TO_START, !ji(o) && !Ve.$isTabNode(o) || !ji(s) && !Ve.$isTabNode(s))
    return !1;
  if (e)
    if (o = E7(s, n.offset), o !== null) {
      let { node: a, offset: l } = o;
      Ve.$isLineBreakNode(a) ? a.selectNext(0, 0) : i.setTextNodeRange(a, l, a, l);
    } else
      s.getParentOrThrow().selectStart();
  else
    v7(s).select();
  return t.preventDefault(), t.stopPropagation(), !0;
}
hr.$createCodeHighlightNode = Ef;
hr.$createCodeNode = U0;
hr.$isCodeHighlightNode = ji;
hr.$isCodeNode = gs;
hr.CODE_LANGUAGE_FRIENDLY_NAME_MAP = h7;
hr.CODE_LANGUAGE_MAP = p7;
hr.CodeHighlightNode = Qm;
hr.CodeNode = o0;
hr.DEFAULT_CODE_LANGUAGE = "javascript";
hr.PrismTokenizer = y7;
hr.getCodeLanguages = () => Object.keys(n0.languages).filter((e) => typeof n0.languages[e] != "function").sort();
hr.getDefaultCodeLanguage = () => "javascript";
hr.getEndOfCodeInLine = v7;
hr.getFirstCodeNodeOfLine = Rl;
hr.getLanguageFriendlyName = function(e) {
  return e = f7(e), h7[e] || e;
};
hr.getLastCodeNodeOfLine = s0;
hr.getStartOfCodeInLine = E7;
hr.normalizeCodeLang = f7;
hr.registerCodeHighlighting = function(e, t) {
  if (!e.hasNodes([o0, Qm]))
    throw Error("CodeHighlightPlugin: CodeNode or CodeHighlightNode not registered on editor");
  return t == null && (t = y7), Nc.mergeRegister(
    e.registerMutationListener(o0, (i) => {
      e.update(() => {
        for (let [o, s] of i)
          if (s !== "destroyed") {
            var r = Ve.$getNodeByKey(o);
            if (r !== null)
              e: {
                var n = r;
                if (r = e.getElementByKey(n.getKey()), r === null)
                  break e;
                n = n.getChildren();
                let a = n.length;
                if (a === r.__cachedChildrenLength)
                  break e;
                r.__cachedChildrenLength = a;
                let l = "1", c = 1;
                for (let u = 0; u < a; u++)
                  Ve.$isLineBreakNode(n[u]) && (l += `
` + ++c);
                r.setAttribute("data-gutter", l);
              }
          }
      });
    }),
    e.registerNodeTransform(o0, (i) => b7(i, e, t)),
    e.registerNodeTransform(Ve.TextNode, (i) => P3(i, e, t)),
    e.registerNodeTransform(Qm, (i) => P3(i, e, t)),
    e.registerCommand(Ve.KEY_TAB_COMMAND, (i) => {
      let r = KX(i.shiftKey);
      return r === null ? !1 : (i.preventDefault(), e.dispatchCommand(r, void 0), !0);
    }, Ve.COMMAND_PRIORITY_LOW),
    e.registerCommand(Ve.INSERT_TAB_COMMAND, () => {
      let i = Ve.$getSelection();
      return vf(i) ? (Ve.$insertNodes([Ve.$createTabNode()]), !0) : !1;
    }, Ve.COMMAND_PRIORITY_LOW),
    e.registerCommand(Ve.INDENT_CONTENT_COMMAND, () => H3(Ve.INDENT_CONTENT_COMMAND), Ve.COMMAND_PRIORITY_LOW),
    e.registerCommand(Ve.OUTDENT_CONTENT_COMMAND, () => H3(Ve.OUTDENT_CONTENT_COMMAND), Ve.COMMAND_PRIORITY_LOW),
    e.registerCommand(Ve.KEY_ARROW_UP_COMMAND, (i) => X3(Ve.KEY_ARROW_UP_COMMAND, i), Ve.COMMAND_PRIORITY_LOW),
    e.registerCommand(Ve.KEY_ARROW_DOWN_COMMAND, (i) => X3(Ve.KEY_ARROW_DOWN_COMMAND, i), Ve.COMMAND_PRIORITY_LOW),
    e.registerCommand(Ve.MOVE_TO_END, (i) => _3(Ve.MOVE_TO_END, i), Ve.COMMAND_PRIORITY_LOW),
    e.registerCommand(Ve.MOVE_TO_START, (i) => _3(Ve.MOVE_TO_START, i), Ve.COMMAND_PRIORITY_LOW)
  );
};
const YX = hr;
var nn = YX;
const x7 = Co([
  (e) => () => {
  },
  (e) => {
  }
]), UX = ({ children: e }) => {
  const t = we(() => {
    let i = null;
    const r = /* @__PURE__ */ new Set();
    return [
      (n) => (n(i), r.add(n), () => {
        r.delete(n);
      }),
      (n) => {
        i = n;
        for (const o of r)
          o(n);
      }
    ];
  }, []);
  return /* @__PURE__ */ f(x7.Provider, { value: t, children: e });
}, I7 = () => {
  const [e, t] = sn(x7), [i, r] = se(null);
  return be(() => e((n) => {
    r(n);
  }), [e]), [i, t];
}, E1 = /* @__PURE__ */ new WeakMap();
function $3(e) {
  const t = e.changedTouches[0];
  return t === void 0 ? null : [t.clientX, t.clientY];
}
function GX(e, t) {
  let i = E1.get(e);
  if (i === void 0) {
    const r = /* @__PURE__ */ new Set(), n = (s) => {
      i !== void 0 && (i.start = $3(s));
    }, o = (s) => {
      if (i === void 0)
        return;
      const a = i.start;
      if (a === null)
        return;
      const l = $3(s);
      for (const c of r)
        l !== null && c([l[0] - a[0], l[1] - a[1]], s);
    };
    e.addEventListener("touchstart", n), e.addEventListener("touchend", o), i = {
      handleTouchend: o,
      handleTouchstart: n,
      listeners: r,
      start: null
    }, E1.set(e, i);
  }
  return i.listeners.add(t), () => QX(e, t);
}
function QX(e, t) {
  const i = E1.get(e);
  if (i === void 0)
    return;
  const r = i.listeners;
  r.delete(t), r.size === 0 && (E1.delete(e), e.removeEventListener("touchstart", i.handleTouchstart), e.removeEventListener("touchend", i.handleTouchend));
}
function WX(e, t) {
  return GX(e, (i, r) => {
    const [n, o] = i;
    n > 0 && n > Math.abs(o) && t(n, r);
  });
}
const Ob = Math.random().toString(36).replace(/[^a-z]+/g, "").substring(0, 5);
function e4(e) {
  if (!L.$isRangeSelection(e) || !e.isCollapsed())
    return [!1, ""];
  const t = e.getNodes()[0], i = e.anchor;
  if (!L.$isTextNode(t) || !t.isSimpleText() || !wi.$isAtNodeEnd(i))
    return [!1, ""];
  const r = [], n = t.getTextContent();
  let o = t.getTextContentSize(), s;
  for (; o-- && o >= 0 && (s = n[o]) !== " "; )
    r.push(s);
  return r.length === 0 ? [!1, ""] : [!0, r.reverse().join("")];
}
function ZX() {
  return ye((e) => {
    const t = new JX();
    console.time("query");
    const i = t.query(e);
    return console.timeEnd("query"), i;
  }, []);
}
function S7() {
  const [e] = nt.useLexicalComposerContext(), [, t] = I7(), i = ZX();
  return be(() => {
    let r = null, n = null, o = null, s = null;
    function a() {
      const E = r !== null ? L.$getNodeByKey(r) : null;
      E !== null && E.isAttached() && (E.remove(), r = null), s !== null && (s.dismiss(), s = null), n = null, o = null, t(null);
    }
    function l(E, v) {
      s !== E || v === null || e.update(
        () => {
          const C = L.$getSelection(), [x, S] = e4(C);
          if (!x || S !== n || !L.$isRangeSelection(C))
            return;
          const R = C.clone(), w = R7(Ob);
          r = w.getKey(), C.insertNodes([w]), L.$setSelection(R), o = v, t(v);
        },
        { tag: "history-merge" }
      );
    }
    function c(E) {
      const v = E.getKey();
      E.__uuid === Ob && v !== r && a();
    }
    function u() {
      e.update(() => {
        const E = L.$getSelection(), [v, C] = e4(E);
        if (!v) {
          a();
          return;
        }
        C !== n && (a(), s = i(C), s.promise.then((x) => {
          s !== null && l(s, x);
        }).catch((x) => {
          console.error(x);
        }), n = C);
      });
    }
    function m() {
      if (o === null || r === null)
        return !1;
      const E = L.$getNodeByKey(r);
      if (E === null)
        return !1;
      const v = L.$createTextNode(o);
      return E.replace(v), v.selectNext(), a(), !0;
    }
    function g(E) {
      return m() ? (E.preventDefault(), !0) : !1;
    }
    function h(E, v) {
      e.update(() => {
        m() && v.preventDefault();
      });
    }
    function A() {
      e.update(() => {
        a();
      });
    }
    const y = e.getRootElement();
    return it.mergeRegister(
      e.registerNodeTransform(G0, c),
      e.registerUpdateListener(u),
      e.registerCommand(L.KEY_TAB_COMMAND, g, L.COMMAND_PRIORITY_LOW),
      e.registerCommand(L.KEY_ARROW_RIGHT_COMMAND, g, L.COMMAND_PRIORITY_LOW),
      ...y !== null ? [WX(y, h)] : [],
      A
    );
  }, [e, i, t]), null;
}
class JX {
  constructor() {
    Ze(this, "DATABASE", PX);
    Ze(this, "LATENCY", 200);
    Ze(this, "query", (t) => {
      let i = !1;
      const r = () => {
        i = !0;
      }, n = new Promise((o, s) => {
        setTimeout(() => {
          if (i)
            return s("Dismissed");
          const a = t.length;
          if (t === "" || a < 4)
            return o(null);
          const l = t.charCodeAt(0), c = l >= 65 && l <= 90, u = c ? String.fromCharCode(l + 32) + t.substring(1) : t, m = this.DATABASE.find(
            (A) => {
              var y;
              return (y = A.startsWith(u)) != null ? y : null;
            }
          );
          if (m === void 0)
            return o(null);
          const h = (c ? String.fromCharCode(m.charCodeAt(0) - 32) + m.substring(1) : m).substring(a);
          return o(h === "" ? null : h);
        }, this.LATENCY);
      });
      return {
        dismiss: r,
        promise: n
      };
    });
  }
}
const PX = [
  "information",
  "available",
  "copyright",
  "university",
  "management",
  "international",
  "development",
  "education",
  "community",
  "technology",
  "following",
  "resources",
  "including",
  "directory",
  "government",
  "department",
  "description",
  "insurance",
  "different",
  "categories",
  "conditions",
  "accessories",
  "september",
  "questions",
  "application",
  "financial",
  "equipment",
  "performance",
  "experience",
  "important",
  "activities",
  "additional",
  "something",
  "professional",
  "committee",
  "washington",
  "california",
  "reference",
  "companies",
  "computers",
  "president",
  "australia",
  "discussion",
  "entertainment",
  "agreement",
  "marketing",
  "association",
  "collection",
  "solutions",
  "electronics",
  "technical",
  "microsoft",
  "conference",
  "environment",
  "statement",
  "downloads",
  "applications",
  "requirements",
  "individual",
  "subscribe",
  "everything",
  "production",
  "commercial",
  "advertising",
  "treatment",
  "newsletter",
  "knowledge",
  "currently",
  "construction",
  "registered",
  "protection",
  "engineering",
  "published",
  "corporate",
  "customers",
  "materials",
  "countries",
  "standards",
  "political",
  "advertise",
  "environmental",
  "availability",
  "employment",
  "commission",
  "administration",
  "institute",
  "sponsored",
  "electronic",
  "condition",
  "effective",
  "organization",
  "selection",
  "corporation",
  "executive",
  "necessary",
  "according",
  "particular",
  "facilities",
  "opportunities",
  "appropriate",
  "statistics",
  "investment",
  "christmas",
  "registration",
  "furniture",
  "wednesday",
  "structure",
  "distribution",
  "industrial",
  "potential",
  "responsible",
  "communications",
  "associated",
  "foundation",
  "documents",
  "communication",
  "independent",
  "operating",
  "developed",
  "telephone",
  "population",
  "navigation",
  "operations",
  "therefore",
  "christian",
  "understand",
  "publications",
  "worldwide",
  "connection",
  "publisher",
  "introduction",
  "properties",
  "accommodation",
  "excellent",
  "opportunity",
  "assessment",
  "especially",
  "interface",
  "operation",
  "restaurants",
  "beautiful",
  "locations",
  "significant",
  "technologies",
  "manufacturer",
  "providing",
  "authority",
  "considered",
  "programme",
  "enterprise",
  "educational",
  "employees",
  "alternative",
  "processing",
  "responsibility",
  "resolution",
  "publication",
  "relations",
  "photography",
  "components",
  "assistance",
  "completed",
  "organizations",
  "otherwise",
  "transportation",
  "disclaimer",
  "membership",
  "recommended",
  "background",
  "character",
  "maintenance",
  "functions",
  "trademarks",
  "phentermine",
  "submitted",
  "television",
  "interested",
  "throughout",
  "established",
  "programming",
  "regarding",
  "instructions",
  "increased",
  "understanding",
  "beginning",
  "associates",
  "instruments",
  "businesses",
  "specified",
  "restaurant",
  "procedures",
  "relationship",
  "traditional",
  "sometimes",
  "themselves",
  "transport",
  "interesting",
  "evaluation",
  "implementation",
  "galleries",
  "references",
  "presented",
  "literature",
  "respective",
  "definition",
  "secretary",
  "networking",
  "australian",
  "magazines",
  "francisco",
  "individuals",
  "guidelines",
  "installation",
  "described",
  "attention",
  "difference",
  "regulations",
  "certificate",
  "directions",
  "documentation",
  "automotive",
  "successful",
  "communities",
  "situation",
  "publishing",
  "emergency",
  "developing",
  "determine",
  "temperature",
  "announcements",
  "historical",
  "ringtones",
  "difficult",
  "scientific",
  "satellite",
  "particularly",
  "functional",
  "monitoring",
  "architecture",
  "recommend",
  "dictionary",
  "accounting",
  "manufacturing",
  "professor",
  "generally",
  "continued",
  "techniques",
  "permission",
  "generation",
  "component",
  "guarantee",
  "processes",
  "interests",
  "paperback",
  "classifieds",
  "supported",
  "competition",
  "providers",
  "characters",
  "thousands",
  "apartments",
  "generated",
  "administrative",
  "practices",
  "reporting",
  "essential",
  "affiliate",
  "immediately",
  "designated",
  "integrated",
  "configuration",
  "comprehensive",
  "universal",
  "presentation",
  "languages",
  "compliance",
  "improvement",
  "pennsylvania",
  "challenge",
  "acceptance",
  "strategies",
  "affiliates",
  "multimedia",
  "certified",
  "computing",
  "interactive",
  "procedure",
  "leadership",
  "religious",
  "breakfast",
  "developer",
  "approximately",
  "recommendations",
  "comparison",
  "automatically",
  "minnesota",
  "adventure",
  "institutions",
  "assistant",
  "advertisement",
  "headlines",
  "yesterday",
  "determined",
  "wholesale",
  "extension",
  "statements",
  "completely",
  "electrical",
  "applicable",
  "manufacturers",
  "classical",
  "dedicated",
  "direction",
  "basketball",
  "wisconsin",
  "personnel",
  "identified",
  "professionals",
  "advantage",
  "newsletters",
  "estimated",
  "anonymous",
  "miscellaneous",
  "integration",
  "interview",
  "framework",
  "installed",
  "massachusetts",
  "associate",
  "frequently",
  "discussions",
  "laboratory",
  "destination",
  "intelligence",
  "specifications",
  "tripadvisor",
  "residential",
  "decisions",
  "industries",
  "partnership",
  "editorial",
  "expression",
  "provisions",
  "principles",
  "suggestions",
  "replacement",
  "strategic",
  "economics",
  "compatible",
  "apartment",
  "netherlands",
  "consulting",
  "recreation",
  "participants",
  "favorites",
  "translation",
  "estimates",
  "protected",
  "philadelphia",
  "officials",
  "contained",
  "legislation",
  "parameters",
  "relationships",
  "tennessee",
  "representative",
  "frequency",
  "introduced",
  "departments",
  "residents",
  "displayed",
  "performed",
  "administrator",
  "addresses",
  "permanent",
  "agriculture",
  "constitutes",
  "portfolio",
  "practical",
  "delivered",
  "collectibles",
  "infrastructure",
  "exclusive",
  "originally",
  "utilities",
  "philosophy",
  "regulation",
  "reduction",
  "nutrition",
  "recording",
  "secondary",
  "wonderful",
  "announced",
  "prevention",
  "mentioned",
  "automatic",
  "healthcare",
  "maintained",
  "increasing",
  "connected",
  "directors",
  "participation",
  "containing",
  "combination",
  "amendment",
  "guaranteed",
  "libraries",
  "distributed",
  "singapore",
  "enterprises",
  "convention",
  "principal",
  "certification",
  "previously",
  "buildings",
  "household",
  "batteries",
  "positions",
  "subscription",
  "contemporary",
  "panasonic",
  "permalink",
  "signature",
  "provision",
  "certainly",
  "newspaper",
  "liability",
  "trademark",
  "trackback",
  "americans",
  "promotion",
  "conversion",
  "reasonable",
  "broadband",
  "influence",
  "importance",
  "webmaster",
  "prescription",
  "specifically",
  "represent",
  "conservation",
  "louisiana",
  "javascript",
  "marketplace",
  "evolution",
  "certificates",
  "objectives",
  "suggested",
  "concerned",
  "structures",
  "encyclopedia",
  "continuing",
  "interracial",
  "competitive",
  "suppliers",
  "preparation",
  "receiving",
  "accordance",
  "discussed",
  "elizabeth",
  "reservations",
  "playstation",
  "instruction",
  "annotation",
  "differences",
  "establish",
  "expressed",
  "paragraph",
  "mathematics",
  "compensation",
  "conducted",
  "percentage",
  "mississippi",
  "requested",
  "connecticut",
  "personals",
  "immediate",
  "agricultural",
  "supporting",
  "collections",
  "participate",
  "specialist",
  "experienced",
  "investigation",
  "institution",
  "searching",
  "proceedings",
  "transmission",
  "characteristics",
  "experiences",
  "extremely",
  "verzeichnis",
  "contracts",
  "concerning",
  "developers",
  "equivalent",
  "chemistry",
  "neighborhood",
  "variables",
  "continues",
  "curriculum",
  "psychology",
  "responses",
  "circumstances",
  "identification",
  "appliances",
  "elementary",
  "unlimited",
  "printable",
  "enforcement",
  "hardcover",
  "celebrity",
  "chocolate",
  "hampshire",
  "bluetooth",
  "controlled",
  "requirement",
  "authorities",
  "representatives",
  "pregnancy",
  "biography",
  "attractions",
  "transactions",
  "authorized",
  "retirement",
  "financing",
  "efficiency",
  "efficient",
  "commitment",
  "specialty",
  "interviews",
  "qualified",
  "discovery",
  "classified",
  "confidence",
  "lifestyle",
  "consistent",
  "clearance",
  "connections",
  "inventory",
  "converter",
  "organisation",
  "objective",
  "indicated",
  "securities",
  "volunteer",
  "democratic",
  "switzerland",
  "parameter",
  "processor",
  "dimensions",
  "contribute",
  "challenges",
  "recognition",
  "submission",
  "encourage",
  "regulatory",
  "inspection",
  "consumers",
  "territory",
  "transaction",
  "manchester",
  "contributions",
  "continuous",
  "resulting",
  "cambridge",
  "initiative",
  "execution",
  "disability",
  "increases",
  "contractor",
  "examination",
  "indicates",
  "committed",
  "extensive",
  "affordable",
  "candidate",
  "databases",
  "outstanding",
  "perspective",
  "messenger",
  "tournament",
  "consideration",
  "discounts",
  "catalogue",
  "publishers",
  "caribbean",
  "reservation",
  "remaining",
  "depending",
  "expansion",
  "purchased",
  "performing",
  "collected",
  "absolutely",
  "featuring",
  "implement",
  "scheduled",
  "calculator",
  "significantly",
  "temporary",
  "sufficient",
  "awareness",
  "vancouver",
  "contribution",
  "measurement",
  "constitution",
  "packaging",
  "consultation",
  "northwest",
  "classroom",
  "democracy",
  "wallpaper",
  "merchandise",
  "resistance",
  "baltimore",
  "candidates",
  "charlotte",
  "biological",
  "transition",
  "preferences",
  "instrument",
  "classification",
  "physician",
  "hollywood",
  "wikipedia",
  "spiritual",
  "photographs",
  "relatively",
  "satisfaction",
  "represents",
  "pittsburgh",
  "preferred",
  "intellectual",
  "comfortable",
  "interaction",
  "listening",
  "effectively",
  "experimental",
  "revolution",
  "consolidation",
  "landscape",
  "dependent",
  "mechanical",
  "consultants",
  "applicant",
  "cooperation",
  "acquisition",
  "implemented",
  "directories",
  "recognized",
  "notification",
  "licensing",
  "textbooks",
  "diversity",
  "cleveland",
  "investments",
  "accessibility",
  "sensitive",
  "templates",
  "completion",
  "universities",
  "technique",
  "contractors",
  "subscriptions",
  "calculate",
  "alexander",
  "broadcast",
  "converted",
  "anniversary",
  "improvements",
  "specification",
  "accessible",
  "accessory",
  "typically",
  "representation",
  "arrangements",
  "conferences",
  "uniprotkb",
  "consumption",
  "birmingham",
  "afternoon",
  "consultant",
  "controller",
  "ownership",
  "committees",
  "legislative",
  "researchers",
  "unsubscribe",
  "molecular",
  "residence",
  "attorneys",
  "operators",
  "sustainable",
  "philippines",
  "statistical",
  "innovation",
  "employers",
  "definitions",
  "elections",
  "stainless",
  "newspapers",
  "hospitals",
  "exception",
  "successfully",
  "indonesia",
  "primarily",
  "capabilities",
  "recommendation",
  "recruitment",
  "organized",
  "improving",
  "expensive",
  "organisations",
  "explained",
  "programmes",
  "expertise",
  "mechanism",
  "jewellery",
  "eventually",
  "agreements",
  "considering",
  "innovative",
  "conclusion",
  "disorders",
  "collaboration",
  "detection",
  "formation",
  "engineers",
  "proposals",
  "moderator",
  "tutorials",
  "settlement",
  "collectables",
  "fantastic",
  "governments",
  "purchasing",
  "appointed",
  "operational",
  "corresponding",
  "descriptions",
  "determination",
  "animation",
  "productions",
  "telecommunications",
  "instructor",
  "approaches",
  "highlights",
  "designers",
  "melbourne",
  "scientists",
  "blackjack",
  "argentina",
  "possibility",
  "commissioner",
  "dangerous",
  "reliability",
  "unfortunately",
  "respectively",
  "volunteers",
  "attachment",
  "appointment",
  "workshops",
  "hurricane",
  "represented",
  "mortgages",
  "responsibilities",
  "carefully",
  "productivity",
  "investors",
  "underground",
  "diagnosis",
  "principle",
  "vacations",
  "calculated",
  "appearance",
  "incorporated",
  "notebooks",
  "algorithm",
  "valentine",
  "involving",
  "investing",
  "christopher",
  "admission",
  "terrorism",
  "parliament",
  "situations",
  "allocated",
  "corrections",
  "structural",
  "municipal",
  "describes",
  "disabilities",
  "substance",
  "prohibited",
  "addressed",
  "simulation",
  "initiatives",
  "concentration",
  "interpretation",
  "bankruptcy",
  "optimization",
  "substances",
  "discovered",
  "restrictions",
  "participating",
  "exhibition",
  "composition",
  "nationwide",
  "definitely",
  "existence",
  "commentary",
  "limousines",
  "developments",
  "immigration",
  "destinations",
  "necessarily",
  "attribute",
  "apparently",
  "surrounding",
  "mountains",
  "popularity",
  "postposted",
  "coordinator",
  "obviously",
  "fundamental",
  "substantial",
  "progressive",
  "championship",
  "sacramento",
  "impossible",
  "depression",
  "testimonials",
  "memorabilia",
  "cartridge",
  "explanation",
  "cincinnati",
  "subsection",
  "electricity",
  "permitted",
  "workplace",
  "confirmed",
  "wallpapers",
  "infection",
  "eligibility",
  "involvement",
  "placement",
  "observations",
  "vbulletin",
  "subsequent",
  "motorcycle",
  "disclosure",
  "establishment",
  "presentations",
  "undergraduate",
  "occupation",
  "donations",
  "associations",
  "citysearch",
  "radiation",
  "seriously",
  "elsewhere",
  "pollution",
  "conservative",
  "guestbook",
  "effectiveness",
  "demonstrate",
  "atmosphere",
  "experiment",
  "purchases",
  "federation",
  "assignment",
  "chemicals",
  "everybody",
  "nashville",
  "counseling",
  "acceptable",
  "satisfied",
  "measurements",
  "milwaukee",
  "medication",
  "warehouse",
  "shareware",
  "violation",
  "configure",
  "stability",
  "southwest",
  "institutional",
  "expectations",
  "independence",
  "metabolism",
  "personally",
  "excellence",
  "somewhere",
  "attributes",
  "recognize",
  "screening",
  "thumbnail",
  "forgotten",
  "intelligent",
  "edinburgh",
  "obligation",
  "regardless",
  "restricted",
  "republican",
  "merchants",
  "attendance",
  "arguments",
  "amsterdam",
  "adventures",
  "announcement",
  "appreciate",
  "regularly",
  "mechanisms",
  "customize",
  "tradition",
  "indicators",
  "emissions",
  "physicians",
  "complaint",
  "experiments",
  "afghanistan",
  "scholarship",
  "governance",
  "supplements",
  "camcorder",
  "implementing",
  "ourselves",
  "conversation",
  "capability",
  "producing",
  "precision",
  "contributed",
  "reproduction",
  "ingredients",
  "franchise",
  "complaints",
  "promotions",
  "rehabilitation",
  "maintaining",
  "environments",
  "reception",
  "correctly",
  "consequences",
  "geography",
  "appearing",
  "integrity",
  "discrimination",
  "processed",
  "implications",
  "functionality",
  "intermediate",
  "emotional",
  "platforms",
  "overnight",
  "geographic",
  "preliminary",
  "districts",
  "introduce",
  "promotional",
  "chevrolet",
  "specialists",
  "generator",
  "suspension",
  "correction",
  "authentication",
  "communicate",
  "supplement",
  "showtimes",
  "promoting",
  "machinery",
  "bandwidth",
  "probability",
  "dimension",
  "schedules",
  "admissions",
  "quarterly",
  "illustrated",
  "continental",
  "alternate",
  "achievement",
  "limitations",
  "automated",
  "passenger",
  "convenient",
  "orientation",
  "childhood",
  "flexibility",
  "jurisdiction",
  "displaying",
  "encouraged",
  "cartridges",
  "declaration",
  "automation",
  "advantages",
  "preparing",
  "recipient",
  "extensions",
  "athletics",
  "southeast",
  "alternatives",
  "determining",
  "personalized",
  "conditioning",
  "partnerships",
  "destruction",
  "increasingly",
  "migration",
  "basically",
  "conventional",
  "applicants",
  "occupational",
  "adjustment",
  "treatments",
  "camcorders",
  "difficulty",
  "collective",
  "coalition",
  "enrollment",
  "producers",
  "collector",
  "interfaces",
  "advertisers",
  "representing",
  "observation",
  "restoration",
  "convenience",
  "returning",
  "opposition",
  "container",
  "defendant",
  "confirmation",
  "supervisor",
  "peripherals",
  "bestsellers",
  "departure",
  "minneapolis",
  "interactions",
  "intervention",
  "attraction",
  "modification",
  "customized",
  "understood",
  "assurance",
  "happening",
  "amendments",
  "metropolitan",
  "compilation",
  "verification",
  "attractive",
  "recordings",
  "jefferson",
  "gardening",
  "obligations",
  "orchestra",
  "polyphonic",
  "outsourcing",
  "adjustable",
  "allocation",
  "discipline",
  "demonstrated",
  "identifying",
  "alphabetical",
  "dispatched",
  "installing",
  "voluntary",
  "photographer",
  "messaging",
  "constructed",
  "additions",
  "requiring",
  "engagement",
  "refinance",
  "calendars",
  "arrangement",
  "conclusions",
  "bibliography",
  "compatibility",
  "furthermore",
  "cooperative",
  "measuring",
  "jacksonville",
  "headquarters",
  "transfers",
  "transformation",
  "attachments",
  "administrators",
  "personality",
  "facilitate",
  "subscriber",
  "priorities",
  "bookstore",
  "parenting",
  "incredible",
  "commonwealth",
  "pharmaceutical",
  "manhattan",
  "workforce",
  "organizational",
  "portuguese",
  "everywhere",
  "discharge",
  "halloween",
  "hazardous",
  "methodology",
  "housewares",
  "reputation",
  "resistant",
  "democrats",
  "recycling",
  "qualifications",
  "slideshow",
  "variation",
  "transferred",
  "photograph",
  "distributor",
  "underlying",
  "wrestling",
  "photoshop",
  "gathering",
  "projection",
  "mathematical",
  "specialized",
  "diagnostic",
  "indianapolis",
  "corporations",
  "criticism",
  "automobile",
  "confidential",
  "statutory",
  "accommodations",
  "northeast",
  "downloaded",
  "paintings",
  "injection",
  "yorkshire",
  "populations",
  "protective",
  "initially",
  "indicator",
  "eliminate",
  "sunglasses",
  "preference",
  "threshold",
  "venezuela",
  "exploration",
  "sequences",
  "astronomy",
  "translate",
  "announces",
  "compression",
  "establishing",
  "constitutional",
  "perfectly",
  "instantly",
  "litigation",
  "submissions",
  "broadcasting",
  "horizontal",
  "terrorist",
  "informational",
  "ecommerce",
  "suffering",
  "prospective",
  "ultimately",
  "artificial",
  "spectacular",
  "coordination",
  "connector",
  "affiliated",
  "activation",
  "naturally",
  "subscribers",
  "mitsubishi",
  "underwear",
  "potentially",
  "constraints",
  "inclusive",
  "dimensional",
  "considerable",
  "selecting",
  "processors",
  "pantyhose",
  "difficulties",
  "complexity",
  "constantly",
  "barcelona",
  "presidential",
  "documentary",
  "territories",
  "palestinian",
  "legislature",
  "hospitality",
  "procurement",
  "theoretical",
  "exercises",
  "surveillance",
  "protocols",
  "highlight",
  "substitute",
  "inclusion",
  "hopefully",
  "brilliant",
  "evaluated",
  "assignments",
  "termination",
  "households",
  "authentic",
  "montgomery",
  "architectural",
  "louisville",
  "macintosh",
  "movements",
  "amenities",
  "virtually",
  "authorization",
  "projector",
  "comparative",
  "psychological",
  "surprised",
  "genealogy",
  "expenditure",
  "liverpool",
  "connectivity",
  "algorithms",
  "similarly",
  "collaborative",
  "excluding",
  "commander",
  "suggestion",
  "spotlight",
  "investigate",
  "connecting",
  "logistics",
  "proportion",
  "significance",
  "symposium",
  "essentials",
  "protecting",
  "transmitted",
  "screenshots",
  "intensive",
  "switching",
  "correspondence",
  "supervision",
  "expenditures",
  "separation",
  "testimony",
  "celebrities",
  "mandatory",
  "boundaries",
  "syndication",
  "celebration",
  "filtering",
  "luxembourg",
  "offensive",
  "deployment",
  "colleagues",
  "separated",
  "directive",
  "governing",
  "retailers",
  "occasionally",
  "attending",
  "recruiting",
  "instructional",
  "traveling",
  "permissions",
  "biotechnology",
  "prescribed",
  "catherine",
  "reproduced",
  "calculation",
  "consolidated",
  "occasions",
  "equations",
  "exceptional",
  "respondents",
  "considerations",
  "queensland",
  "musicians",
  "composite",
  "unavailable",
  "essentially",
  "designing",
  "assessments",
  "brunswick",
  "sensitivity",
  "preservation",
  "streaming",
  "intensity",
  "technological",
  "syndicate",
  "antivirus",
  "addressing",
  "discounted",
  "bangladesh",
  "constitute",
  "concluded",
  "desperate",
  "demonstration",
  "governmental",
  "manufactured",
  "graduation",
  "variations",
  "addiction",
  "springfield",
  "synthesis",
  "undefined",
  "unemployment",
  "enhancement",
  "newcastle",
  "performances",
  "societies",
  "brazilian",
  "identical",
  "petroleum",
  "norwegian",
  "retention",
  "exchanges",
  "soundtrack",
  "wondering",
  "profession",
  "separately",
  "physiology",
  "collecting",
  "participant",
  "scholarships",
  "recreational",
  "dominican",
  "friendship",
  "expanding",
  "provincial",
  "investigations",
  "medications",
  "rochester",
  "advertiser",
  "encryption",
  "downloadable",
  "sophisticated",
  "possession",
  "laboratories",
  "vegetables",
  "thumbnails",
  "stockings",
  "respondent",
  "destroyed",
  "manufacture",
  "wordpress",
  "vulnerability",
  "accountability",
  "celebrate",
  "accredited",
  "appliance",
  "compressed",
  "scheduling",
  "perspectives",
  "mortality",
  "christians",
  "therapeutic",
  "impressive",
  "accordingly",
  "architect",
  "challenging",
  "microwave",
  "accidents",
  "relocation",
  "contributors",
  "violations",
  "temperatures",
  "competitions",
  "discretion",
  "cosmetics",
  "repository",
  "concentrations",
  "christianity",
  "negotiations",
  "realistic",
  "generating",
  "christina",
  "congressional",
  "photographic",
  "modifications",
  "millennium",
  "achieving",
  "fisheries",
  "exceptions",
  "reactions",
  "macromedia",
  "companion",
  "divisions",
  "additionally",
  "fellowship",
  "victorian",
  "copyrights",
  "lithuania",
  "mastercard",
  "chronicles",
  "obtaining",
  "distribute",
  "decorative",
  "enlargement",
  "campaigns",
  "conjunction",
  "instances",
  "indigenous",
  "validation",
  "corruption",
  "incentives",
  "cholesterol",
  "differential",
  "scientist",
  "starsmerchant",
  "arthritis",
  "nevertheless",
  "practitioners",
  "transcript",
  "inflation",
  "compounds",
  "contracting",
  "structured",
  "reasonably",
  "graduates",
  "recommends",
  "controlling",
  "distributors",
  "arlington",
  "particles",
  "extraordinary",
  "indicating",
  "coordinate",
  "exclusively",
  "limitation",
  "widescreen",
  "illustration",
  "construct",
  "inquiries",
  "inspiration",
  "affecting",
  "downloading",
  "aggregate",
  "forecasts",
  "complicated",
  "shopzilla",
  "decorating",
  "expressions",
  "shakespeare",
  "connectors",
  "conflicts",
  "travelers",
  "offerings",
  "incorrect",
  "furnishings",
  "guatemala",
  "perception",
  "renaissance",
  "pathology",
  "ordinance",
  "photographers",
  "infections",
  "configured",
  "festivals",
  "possibilities",
  "contributing",
  "analytical",
  "circulation",
  "assumption",
  "jerusalem",
  "transexuales",
  "invention",
  "technician",
  "executives",
  "enquiries",
  "cognitive",
  "exploring",
  "registrar",
  "supporters",
  "withdrawal",
  "predicted",
  "saskatchewan",
  "cancellation",
  "ministers",
  "veterinary",
  "prostores",
  "relevance",
  "incentive",
  "butterfly",
  "mechanics",
  "numerical",
  "reflection",
  "accompanied",
  "invitation",
  "princeton",
  "spirituality",
  "meanwhile",
  "proprietary",
  "childrens",
  "thumbzilla",
  "porcelain",
  "pichunter",
  "translated",
  "columnists",
  "consensus",
  "delivering",
  "journalism",
  "intention",
  "undertaken",
  "statewide",
  "semiconductor",
  "illustrations",
  "happiness",
  "substantially",
  "identifier",
  "calculations",
  "conducting",
  "accomplished",
  "calculators",
  "impression",
  "correlation",
  "fragrance",
  "neighbors",
  "transparent",
  "charleston",
  "champions",
  "selections",
  "projectors",
  "inappropriate",
  "comparing",
  "vocational",
  "pharmacies",
  "introducing",
  "appreciated",
  "albuquerque",
  "distinguished",
  "projected",
  "assumptions",
  "shareholders",
  "developmental",
  "regulated",
  "anticipated",
  "completing",
  "comparable",
  "confusion",
  "copyrighted",
  "warranties",
  "documented",
  "paperbacks",
  "keyboards",
  "vulnerable",
  "reflected",
  "respiratory",
  "notifications",
  "transexual",
  "mainstream",
  "evaluating",
  "subcommittee",
  "maternity",
  "journalists",
  "foundations",
  "volleyball",
  "liabilities",
  "decreased",
  "tolerance",
  "creativity",
  "describing",
  "lightning",
  "quotations",
  "inspector",
  "bookmarks",
  "behavioral",
  "riverside",
  "bathrooms",
  "abilities",
  "initiated",
  "nonprofit",
  "lancaster",
  "suspended",
  "containers",
  "attitudes",
  "simultaneously",
  "integrate",
  "sociology",
  "screenshot",
  "exhibitions",
  "confident",
  "retrieved",
  "officially",
  "consortium",
  "recipients",
  "delicious",
  "traditions",
  "periodically",
  "hungarian",
  "referring",
  "transform",
  "educators",
  "vegetable",
  "humanities",
  "independently",
  "alignment",
  "henderson",
  "britannica",
  "competitors",
  "visibility",
  "consciousness",
  "encounter",
  "resolutions",
  "accessing",
  "attempted",
  "witnesses",
  "administered",
  "strengthen",
  "frederick",
  "aggressive",
  "advertisements",
  "sublimedirectory",
  "disturbed",
  "determines",
  "sculpture",
  "motivation",
  "pharmacology",
  "passengers",
  "quantities",
  "petersburg",
  "consistently",
  "powerpoint",
  "obituaries",
  "punishment",
  "appreciation",
  "subsequently",
  "providence",
  "restriction",
  "incorporate",
  "backgrounds",
  "treasurer",
  "lightweight",
  "transcription",
  "complications",
  "scripting",
  "remembered",
  "synthetic",
  "testament",
  "specifics",
  "partially",
  "wilderness",
  "generations",
  "tournaments",
  "sponsorship",
  "headphones",
  "proceeding",
  "volkswagen",
  "uncertainty",
  "breakdown",
  "reconstruction",
  "subsidiary",
  "strengths",
  "encouraging",
  "furnished",
  "terrorists",
  "comparisons",
  "beneficial",
  "distributions",
  "viewpicture",
  "threatened",
  "republicans",
  "discusses",
  "responded",
  "abstracts",
  "prediction",
  "pharmaceuticals",
  "thesaurus",
  "individually",
  "battlefield",
  "literally",
  "ecological",
  "appraisal",
  "consisting",
  "submitting",
  "citations",
  "geographical",
  "mozambique",
  "disclaimers",
  "championships",
  "sheffield",
  "finishing",
  "wellington",
  "prospects",
  "bulgarian",
  "aboriginal",
  "remarkable",
  "preventing",
  "productive",
  "boulevard",
  "compliant",
  "penalties",
  "imagination",
  "refurbished",
  "activated",
  "conferencing",
  "armstrong",
  "politicians",
  "trackbacks",
  "accommodate",
  "christine",
  "accepting",
  "precipitation",
  "isolation",
  "sustained",
  "approximate",
  "programmer",
  "greetings",
  "inherited",
  "incomplete",
  "chronicle",
  "legitimate",
  "biographies",
  "investigator",
  "plaintiff",
  "prisoners",
  "mediterranean",
  "nightlife",
  "architects",
  "entrepreneur",
  "freelance",
  "excessive",
  "screensaver",
  "valuation",
  "unexpected",
  "cigarette",
  "characteristic",
  "metallica",
  "consequently",
  "appointments",
  "narrative",
  "academics",
  "quantitative",
  "screensavers",
  "subdivision",
  "distinction",
  "livestock",
  "exemption",
  "sustainability",
  "formatting",
  "nutritional",
  "nicaragua",
  "affiliation",
  "relatives",
  "satisfactory",
  "revolutionary",
  "bracelets",
  "telephony",
  "breathing",
  "thickness",
  "adjustments",
  "graphical",
  "discussing",
  "aerospace",
  "meaningful",
  "maintains",
  "shortcuts",
  "voyeurweb",
  "extending",
  "specifies",
  "accreditation",
  "blackberry",
  "meditation",
  "microphone",
  "macedonia",
  "combining",
  "instrumental",
  "organizing",
  "moderators",
  "kazakhstan",
  "standings",
  "partition",
  "invisible",
  "translations",
  "commodity",
  "kilometers",
  "thanksgiving",
  "guarantees",
  "indication",
  "congratulations",
  "cigarettes",
  "controllers",
  "consultancy",
  "conventions",
  "coordinates",
  "responding",
  "physically",
  "stakeholders",
  "hydrocodone",
  "consecutive",
  "attempting",
  "representations",
  "competing",
  "peninsula",
  "accurately",
  "considers",
  "ministries",
  "vacancies",
  "parliamentary",
  "acknowledge",
  "thoroughly",
  "nottingham",
  "identifies",
  "questionnaire",
  "qualification",
  "modelling",
  "miniature",
  "interstate",
  "consequence",
  "systematic",
  "perceived",
  "madagascar",
  "presenting",
  "troubleshooting",
  "uzbekistan",
  "centuries",
  "magnitude",
  "richardson",
  "fragrances",
  "vocabulary",
  "earthquake",
  "fundraising",
  "geological",
  "assessing",
  "introduces",
  "webmasters",
  "computational",
  "acdbentity",
  "participated",
  "handhelds",
  "answering",
  "impressed",
  "conspiracy",
  "organizer",
  "combinations",
  "preceding",
  "cumulative",
  "amplifier",
  "arbitrary",
  "prominent",
  "lexington",
  "contacted",
  "recorders",
  "occasional",
  "innovations",
  "postcards",
  "reviewing",
  "explicitly",
  "transsexual",
  "citizenship",
  "informative",
  "girlfriend",
  "bloomberg",
  "hierarchy",
  "influenced",
  "abandoned",
  "complement",
  "mauritius",
  "checklist",
  "requesting",
  "lauderdale",
  "scenarios",
  "extraction",
  "elevation",
  "utilization",
  "beverages",
  "calibration",
  "efficiently",
  "entertaining",
  "prerequisite",
  "hypothesis",
  "medicines",
  "regression",
  "enhancements",
  "renewable",
  "intersection",
  "passwords",
  "consistency",
  "collectors",
  "azerbaijan",
  "astrology",
  "occurring",
  "supplemental",
  "travelling",
  "induction",
  "precisely",
  "spreading",
  "provinces",
  "widespread",
  "incidence",
  "incidents",
  "enhancing",
  "interference",
  "palestine",
  "listprice",
  "atmospheric",
  "knowledgestorm",
  "referenced",
  "publicity",
  "proposition",
  "allowance",
  "designation",
  "duplicate",
  "criterion",
  "civilization",
  "vietnamese",
  "tremendous",
  "corrected",
  "encountered",
  "internationally",
  "surrounded",
  "creatures",
  "commented",
  "accomplish",
  "vegetarian",
  "newfoundland",
  "investigated",
  "ambassador",
  "stephanie",
  "contacting",
  "vegetation",
  "findarticles",
  "specially",
  "infectious",
  "continuity",
  "phenomenon",
  "conscious",
  "referrals",
  "differently",
  "integrating",
  "revisions",
  "reasoning",
  "charitable",
  "annotated",
  "convinced",
  "burlington",
  "replacing",
  "researcher",
  "watershed",
  "occupations",
  "acknowledged",
  "equilibrium",
  "characterized",
  "privilege",
  "qualifying",
  "estimation",
  "pediatric",
  "techrepublic",
  "institutes",
  "brochures",
  "traveller",
  "appropriations",
  "suspected",
  "benchmark",
  "beginners",
  "instructors",
  "highlighted",
  "stationery",
  "unauthorized",
  "competent",
  "contributor",
  "demonstrates",
  "gradually",
  "desirable",
  "journalist",
  "afterwards",
  "religions",
  "explosion",
  "signatures",
  "disciplines",
  "daughters",
  "conversations",
  "simplified",
  "motherboard",
  "bibliographic",
  "champagne",
  "deviation",
  "superintendent",
  "housewives",
  "influences",
  "inspections",
  "irrigation",
  "hydraulic",
  "robertson",
  "penetration",
  "conviction",
  "omissions",
  "retrieval",
  "qualities",
  "prototype",
  "importantly",
  "apparatus",
  "explaining",
  "nomination",
  "empirical",
  "dependence",
  "sexuality",
  "polyester",
  "commitments",
  "suggesting",
  "remainder",
  "privileges",
  "televisions",
  "specializing",
  "commodities",
  "motorcycles",
  "concentrate",
  "reproductive",
  "molecules",
  "refrigerator",
  "intervals",
  "sentences",
  "exclusion",
  "workstation",
  "holocaust",
  "receivers",
  "disposition",
  "navigator",
  "investigators",
  "marijuana",
  "cathedral",
  "fairfield",
  "fascinating",
  "landscapes",
  "lafayette",
  "computation",
  "cardiovascular",
  "salvation",
  "predictions",
  "accompanying",
  "selective",
  "arbitration",
  "configuring",
  "editorials",
  "sacrifice",
  "removable",
  "convergence",
  "gibraltar",
  "anthropology",
  "malpractice",
  "reporters",
  "necessity",
  "rendering",
  "hepatitis",
  "nationally",
  "waterproof",
  "specialties",
  "humanitarian",
  "invitations",
  "functioning",
  "economies",
  "alexandria",
  "bacterial",
  "undertake",
  "continuously",
  "achievements",
  "convertible",
  "secretariat",
  "paragraphs",
  "adolescent",
  "nominations",
  "cancelled",
  "introductory",
  "reservoir",
  "occurrence",
  "worcester",
  "demographic",
  "disciplinary",
  "respected",
  "portraits",
  "interpreted",
  "evaluations",
  "elimination",
  "hypothetical",
  "immigrants",
  "complimentary",
  "helicopter",
  "performer",
  "commissions",
  "powerseller",
  "graduated",
  "surprising",
  "unnecessary",
  "dramatically",
  "yugoslavia",
  "characterization",
  "likelihood",
  "fundamentals",
  "contamination",
  "endangered",
  "compromise",
  "expiration",
  "namespace",
  "peripheral",
  "negotiation",
  "opponents",
  "nominated",
  "confidentiality",
  "electoral",
  "changelog",
  "alternatively",
  "greensboro",
  "controversial",
  "recovered",
  "upgrading",
  "frontpage",
  "demanding",
  "defensive",
  "forbidden",
  "programmers",
  "monitored",
  "installations",
  "deutschland",
  "practitioner",
  "motivated",
  "smithsonian",
  "examining",
  "revelation",
  "delegation",
  "dictionaries",
  "greenhouse",
  "transparency",
  "currencies",
  "survivors",
  "positioning",
  "descending",
  "temporarily",
  "frequencies",
  "reflections",
  "municipality",
  "detective",
  "experiencing",
  "fireplace",
  "endorsement",
  "psychiatry",
  "persistent",
  "summaries",
  "looksmart",
  "magnificent",
  "colleague",
  "adaptation",
  "paintball",
  "enclosure",
  "supervisors",
  "westminster",
  "distances",
  "absorption",
  "treasures",
  "transcripts",
  "disappointed",
  "continually",
  "communist",
  "collectible",
  "entrepreneurs",
  "creations",
  "acquisitions",
  "biodiversity",
  "excitement",
  "presently",
  "mysterious",
  "librarian",
  "subsidiaries",
  "stockholm",
  "indonesian",
  "therapist",
  "promising",
  "relaxation",
  "thereafter",
  "commissioners",
  "forwarding",
  "nightmare",
  "reductions",
  "southampton",
  "organisms",
  "telescope",
  "portsmouth",
  "advancement",
  "harassment",
  "generators",
  "generates",
  "replication",
  "inexpensive",
  "receptors",
  "interventions",
  "huntington",
  "internship",
  "aluminium",
  "snowboard",
  "beastality",
  "evanescence",
  "coordinated",
  "shipments",
  "antarctica",
  "chancellor",
  "controversy",
  "legendary",
  "beautifully",
  "antibodies",
  "examinations",
  "immunology",
  "departmental",
  "terminology",
  "gentleman",
  "reproduce",
  "convicted",
  "roommates",
  "threatening",
  "spokesman",
  "activists",
  "frankfurt",
  "encourages",
  "assembled",
  "restructuring",
  "terminals",
  "simulations",
  "sufficiently",
  "conditional",
  "crossword",
  "conceptual",
  "liechtenstein",
  "translator",
  "automobiles",
  "continent",
  "longitude",
  "challenged",
  "telecharger",
  "insertion",
  "instrumentation",
  "constraint",
  "groundwater",
  "strengthening",
  "insulation",
  "infringement",
  "subjective",
  "swaziland",
  "varieties",
  "mediawiki",
  "configurations"
];
class G0 extends L.DecoratorNode {
  constructor(i, r) {
    super(r);
    // TODO add comment
    Ze(this, "__uuid");
    this.__uuid = i;
  }
  static clone(i) {
    return new G0(i.__uuid, i.__key);
  }
  static getType() {
    return "autocomplete";
  }
  static importJSON(i) {
    return R7(i.uuid);
  }
  exportJSON() {
    return ee(q({}, super.exportJSON()), {
      type: "autocomplete",
      uuid: this.__uuid,
      version: 1
    });
  }
  updateDOM(i, r, n) {
    return !1;
  }
  createDOM(i) {
    return Wt("span");
  }
  decorate() {
    return this.__uuid !== Ob ? null : /* @__PURE__ */ f(zX, {});
  }
}
function R7(e) {
  return new G0(e);
}
function zX() {
  const [e] = I7(), t = window.navigator.userAgentData, i = t !== void 0 ? t.mobile : window.innerWidth <= 800 && window.innerHeight <= 600;
  return /* @__PURE__ */ V("span", { style: { color: "#ccc" }, spellCheck: "false", children: [
    e,
    " ",
    i ? "(SWIPE ⮕)" : "(TAB)"
  ] });
}
class Q0 extends L.TextNode {
  constructor(i, r, n) {
    super(r, n);
    Ze(this, "__className");
    this.__className = i;
  }
  static getType() {
    return "emoji";
  }
  static clone(i) {
    return new Q0(i.__className, i.__text, i.__key);
  }
  createDOM(i) {
    const r = Wt("span"), n = super.createDOM(i);
    return r.className = this.__className, n.className = "emoji-inner", r.appendChild(n), r;
  }
  updateDOM(i, r, n) {
    const o = r.firstChild;
    return o === null ? !0 : (super.updateDOM(i, o, n), !1);
  }
  static importJSON(i) {
    const r = k7(i.className, i.text);
    return r.setFormat(i.format), r.setDetail(i.detail), r.setMode(i.mode), r.setStyle(i.style), r;
  }
  exportJSON() {
    return ee(q({}, super.exportJSON()), {
      className: this.getClassName(),
      type: "emoji"
    });
  }
  getClassName() {
    return this.getLatest().__className;
  }
}
function k7(e, t) {
  const i = new Q0(e, t).setMode("token");
  return L.$applyNodeReplacement(i);
}
class uo {
  // The + prefix indicates that these fields aren't writeable
  // Lexer holding the input string.
  // Start offset, zero-based inclusive.
  // End offset, zero-based exclusive.
  constructor(t, i, r) {
    this.lexer = void 0, this.start = void 0, this.end = void 0, this.lexer = t, this.start = i, this.end = r;
  }
  /**
   * Merges two `SourceLocation`s from location providers, given they are
   * provided in order of appearance.
   * - Returns the first one's location if only the first is provided.
   * - Returns a merged range of the first and the last if both are provided
   *   and their lexers match.
   * - Otherwise, returns null.
   */
  static range(t, i) {
    return i ? !t || !t.loc || !i.loc || t.loc.lexer !== i.loc.lexer ? null : new uo(t.loc.lexer, t.loc.start, i.loc.end) : t && t.loc;
  }
}
class js {
  // don't expand the token
  // used in \noexpand
  constructor(t, i) {
    this.text = void 0, this.loc = void 0, this.noexpand = void 0, this.treatAsRelax = void 0, this.text = t, this.loc = i;
  }
  /**
   * Given a pair of tokens (this and endToken), compute a `Token` encompassing
   * the whole input range enclosed by these two.
   */
  range(t, i) {
    return new js(i, uo.range(this, t));
  }
}
class We {
  // Error start position based on passed-in Token or ParseNode.
  // Length of affected text based on passed-in Token or ParseNode.
  // The underlying error message without any context added.
  constructor(t, i) {
    this.name = void 0, this.position = void 0, this.length = void 0, this.rawMessage = void 0;
    var r = "KaTeX parse error: " + t, n, o, s = i && i.loc;
    if (s && s.start <= s.end) {
      var a = s.lexer.input;
      n = s.start, o = s.end, n === a.length ? r += " at end of input: " : r += " at position " + (n + 1) + ": ";
      var l = a.slice(n, o).replace(/[^]/g, "$&̲"), c;
      n > 15 ? c = "…" + a.slice(n - 15, n) : c = a.slice(0, n);
      var u;
      o + 15 < a.length ? u = a.slice(o, o + 15) + "…" : u = a.slice(o), r += c + l + u;
    }
    var m = new Error(r);
    return m.name = "ParseError", m.__proto__ = We.prototype, m.position = n, n != null && o != null && (m.length = o - n), m.rawMessage = t, m;
  }
}
We.prototype.__proto__ = Error.prototype;
var HX = function(t, i) {
  return t.indexOf(i) !== -1;
}, XX = function(t, i) {
  return t === void 0 ? i : t;
}, _X = /([A-Z])/g, $X = function(t) {
  return t.replace(_X, "-$1").toLowerCase();
}, e_ = {
  "&": "&amp;",
  ">": "&gt;",
  "<": "&lt;",
  '"': "&quot;",
  "'": "&#x27;"
}, t_ = /[&><"']/g;
function i_(e) {
  return String(e).replace(t_, (t) => e_[t]);
}
var w7 = function e(t) {
  return t.type === "ordgroup" || t.type === "color" ? t.body.length === 1 ? e(t.body[0]) : t : t.type === "font" ? e(t.body) : t;
}, r_ = function(t) {
  var i = w7(t);
  return i.type === "mathord" || i.type === "textord" || i.type === "atom";
}, n_ = function(t) {
  if (!t)
    throw new Error("Expected non-null, but got " + String(t));
  return t;
}, o_ = function(t) {
  var i = /^\s*([^\\/#]*?)(?::|&#0*58|&#x0*3a)/i.exec(t);
  return i != null ? i[1] : "_relative";
}, Rt = {
  contains: HX,
  deflt: XX,
  escape: i_,
  hyphenate: $X,
  getBaseElem: w7,
  isCharacterBox: r_,
  protocolFromUrl: o_
}, Up = {
  displayMode: {
    type: "boolean",
    description: "Render math in display mode, which puts the math in display style (so \\int and \\sum are large, for example), and centers the math on the page on its own line.",
    cli: "-d, --display-mode"
  },
  output: {
    type: {
      enum: ["htmlAndMathml", "html", "mathml"]
    },
    description: "Determines the markup language of the output.",
    cli: "-F, --format <type>"
  },
  leqno: {
    type: "boolean",
    description: "Render display math in leqno style (left-justified tags)."
  },
  fleqn: {
    type: "boolean",
    description: "Render display math flush left."
  },
  throwOnError: {
    type: "boolean",
    default: !0,
    cli: "-t, --no-throw-on-error",
    cliDescription: "Render errors (in the color given by --error-color) instead of throwing a ParseError exception when encountering an error."
  },
  errorColor: {
    type: "string",
    default: "#cc0000",
    cli: "-c, --error-color <color>",
    cliDescription: "A color string given in the format 'rgb' or 'rrggbb' (no #). This option determines the color of errors rendered by the -t option.",
    cliProcessor: (e) => "#" + e
  },
  macros: {
    type: "object",
    cli: "-m, --macro <def>",
    cliDescription: "Define custom macro of the form '\\foo:expansion' (use multiple -m arguments for multiple macros).",
    cliDefault: [],
    cliProcessor: (e, t) => (t.push(e), t)
  },
  minRuleThickness: {
    type: "number",
    description: "Specifies a minimum thickness, in ems, for fraction lines, `\\sqrt` top lines, `{array}` vertical lines, `\\hline`, `\\hdashline`, `\\underline`, `\\overline`, and the borders of `\\fbox`, `\\boxed`, and `\\fcolorbox`.",
    processor: (e) => Math.max(0, e),
    cli: "--min-rule-thickness <size>",
    cliProcessor: parseFloat
  },
  colorIsTextColor: {
    type: "boolean",
    description: "Makes \\color behave like LaTeX's 2-argument \\textcolor, instead of LaTeX's one-argument \\color mode change.",
    cli: "-b, --color-is-text-color"
  },
  strict: {
    type: [{
      enum: ["warn", "ignore", "error"]
    }, "boolean", "function"],
    description: "Turn on strict / LaTeX faithfulness mode, which throws an error if the input uses features that are not supported by LaTeX.",
    cli: "-S, --strict",
    cliDefault: !1
  },
  trust: {
    type: ["boolean", "function"],
    description: "Trust the input, enabling all HTML features such as \\url.",
    cli: "-T, --trust"
  },
  maxSize: {
    type: "number",
    default: 1 / 0,
    description: "If non-zero, all user-specified sizes, e.g. in \\rule{500em}{500em}, will be capped to maxSize ems. Otherwise, elements and spaces can be arbitrarily large",
    processor: (e) => Math.max(0, e),
    cli: "-s, --max-size <n>",
    cliProcessor: parseInt
  },
  maxExpand: {
    type: "number",
    default: 1e3,
    description: "Limit the number of macro expansions to the specified number, to prevent e.g. infinite macro loops. If set to Infinity, the macro expander will try to fully expand as in LaTeX.",
    processor: (e) => Math.max(0, e),
    cli: "-e, --max-expand <n>",
    cliProcessor: (e) => e === "Infinity" ? 1 / 0 : parseInt(e)
  },
  globalGroup: {
    type: "boolean",
    cli: !1
  }
};
function s_(e) {
  if (e.default)
    return e.default;
  var t = e.type, i = Array.isArray(t) ? t[0] : t;
  if (typeof i != "string")
    return i.enum[0];
  switch (i) {
    case "boolean":
      return !1;
    case "string":
      return "";
    case "number":
      return 0;
    case "object":
      return {};
  }
}
class K2 {
  constructor(t) {
    this.displayMode = void 0, this.output = void 0, this.leqno = void 0, this.fleqn = void 0, this.throwOnError = void 0, this.errorColor = void 0, this.macros = void 0, this.minRuleThickness = void 0, this.colorIsTextColor = void 0, this.strict = void 0, this.trust = void 0, this.maxSize = void 0, this.maxExpand = void 0, this.globalGroup = void 0, t = t || {};
    for (var i in Up)
      if (Up.hasOwnProperty(i)) {
        var r = Up[i];
        this[i] = t[i] !== void 0 ? r.processor ? r.processor(t[i]) : t[i] : s_(r);
      }
  }
  /**
   * Report nonstrict (non-LaTeX-compatible) input.
   * Can safely not be called if `this.strict` is false in JavaScript.
   */
  reportNonstrict(t, i, r) {
    var n = this.strict;
    if (typeof n == "function" && (n = n(t, i, r)), !(!n || n === "ignore")) {
      if (n === !0 || n === "error")
        throw new We("LaTeX-incompatible input and strict mode is set to 'error': " + (i + " [" + t + "]"), r);
      n === "warn" ? typeof console != "undefined" && console.warn("LaTeX-incompatible input and strict mode is set to 'warn': " + (i + " [" + t + "]")) : typeof console != "undefined" && console.warn("LaTeX-incompatible input and strict mode is set to " + ("unrecognized '" + n + "': " + i + " [" + t + "]"));
    }
  }
  /**
   * Check whether to apply strict (LaTeX-adhering) behavior for unusual
   * input (like `\\`).  Unlike `nonstrict`, will not throw an error;
   * instead, "error" translates to a return value of `true`, while "ignore"
   * translates to a return value of `false`.  May still print a warning:
   * "warn" prints a warning and returns `false`.
   * This is for the second category of `errorCode`s listed in the README.
   */
  useStrictBehavior(t, i, r) {
    var n = this.strict;
    if (typeof n == "function")
      try {
        n = n(t, i, r);
      } catch (o) {
        n = "error";
      }
    return !n || n === "ignore" ? !1 : n === !0 || n === "error" ? !0 : n === "warn" ? (typeof console != "undefined" && console.warn("LaTeX-incompatible input and strict mode is set to 'warn': " + (i + " [" + t + "]")), !1) : (typeof console != "undefined" && console.warn("LaTeX-incompatible input and strict mode is set to " + ("unrecognized '" + n + "': " + i + " [" + t + "]")), !1);
  }
  /**
   * Check whether to test potentially dangerous input, and return
   * `true` (trusted) or `false` (untrusted).  The sole argument `context`
   * should be an object with `command` field specifying the relevant LaTeX
   * command (as a string starting with `\`), and any other arguments, etc.
   * If `context` has a `url` field, a `protocol` field will automatically
   * get added by this function (changing the specified object).
   */
  isTrusted(t) {
    t.url && !t.protocol && (t.protocol = Rt.protocolFromUrl(t.url));
    var i = typeof this.trust == "function" ? this.trust(t) : this.trust;
    return !!i;
  }
}
class _a {
  constructor(t, i, r) {
    this.id = void 0, this.size = void 0, this.cramped = void 0, this.id = t, this.size = i, this.cramped = r;
  }
  /**
   * Get the style of a superscript given a base in the current style.
   */
  sup() {
    return Ns[a_[this.id]];
  }
  /**
   * Get the style of a subscript given a base in the current style.
   */
  sub() {
    return Ns[l_[this.id]];
  }
  /**
   * Get the style of a fraction numerator given the fraction in the current
   * style.
   */
  fracNum() {
    return Ns[c_[this.id]];
  }
  /**
   * Get the style of a fraction denominator given the fraction in the current
   * style.
   */
  fracDen() {
    return Ns[u_[this.id]];
  }
  /**
   * Get the cramped version of a style (in particular, cramping a cramped style
   * doesn't change the style).
   */
  cramp() {
    return Ns[d_[this.id]];
  }
  /**
   * Get a text or display version of this style.
   */
  text() {
    return Ns[m_[this.id]];
  }
  /**
   * Return true if this style is tightly spaced (scriptstyle/scriptscriptstyle)
   */
  isTight() {
    return this.size >= 2;
  }
}
var Y2 = 0, v1 = 1, a0 = 2, ka = 3, Wm = 4, Yo = 5, f0 = 6, Sn = 7, Ns = [new _a(Y2, 0, !1), new _a(v1, 0, !0), new _a(a0, 1, !1), new _a(ka, 1, !0), new _a(Wm, 2, !1), new _a(Yo, 2, !0), new _a(f0, 3, !1), new _a(Sn, 3, !0)], a_ = [Wm, Yo, Wm, Yo, f0, Sn, f0, Sn], l_ = [Yo, Yo, Yo, Yo, Sn, Sn, Sn, Sn], c_ = [a0, ka, Wm, Yo, f0, Sn, f0, Sn], u_ = [ka, ka, Yo, Yo, Sn, Sn, Sn, Sn], d_ = [v1, v1, ka, ka, Yo, Yo, Sn, Sn], m_ = [Y2, v1, a0, ka, a0, ka, a0, ka], bt = {
  DISPLAY: Ns[Y2],
  TEXT: Ns[a0],
  SCRIPT: Ns[Wm],
  SCRIPTSCRIPT: Ns[f0]
}, Fb = [{
  // Latin characters beyond the Latin-1 characters we have metrics for.
  // Needed for Czech, Hungarian and Turkish text, for example.
  name: "latin",
  blocks: [
    [256, 591],
    // Latin Extended-A and Latin Extended-B
    [768, 879]
    // Combining Diacritical marks
  ]
}, {
  // The Cyrillic script used by Russian and related languages.
  // A Cyrillic subset used to be supported as explicitly defined
  // symbols in symbols.js
  name: "cyrillic",
  blocks: [[1024, 1279]]
}, {
  // Armenian
  name: "armenian",
  blocks: [[1328, 1423]]
}, {
  // The Brahmic scripts of South and Southeast Asia
  // Devanagari (0900–097F)
  // Bengali (0980–09FF)
  // Gurmukhi (0A00–0A7F)
  // Gujarati (0A80–0AFF)
  // Oriya (0B00–0B7F)
  // Tamil (0B80–0BFF)
  // Telugu (0C00–0C7F)
  // Kannada (0C80–0CFF)
  // Malayalam (0D00–0D7F)
  // Sinhala (0D80–0DFF)
  // Thai (0E00–0E7F)
  // Lao (0E80–0EFF)
  // Tibetan (0F00–0FFF)
  // Myanmar (1000–109F)
  name: "brahmic",
  blocks: [[2304, 4255]]
}, {
  name: "georgian",
  blocks: [[4256, 4351]]
}, {
  // Chinese and Japanese.
  // The "k" in cjk is for Korean, but we've separated Korean out
  name: "cjk",
  blocks: [
    [12288, 12543],
    // CJK symbols and punctuation, Hiragana, Katakana
    [19968, 40879],
    // CJK ideograms
    [65280, 65376]
    // Fullwidth punctuation
    // TODO: add halfwidth Katakana and Romanji glyphs
  ]
}, {
  // Korean
  name: "hangul",
  blocks: [[44032, 55215]]
}];
function g_(e) {
  for (var t = 0; t < Fb.length; t++)
    for (var i = Fb[t], r = 0; r < i.blocks.length; r++) {
      var n = i.blocks[r];
      if (e >= n[0] && e <= n[1])
        return i.name;
    }
  return null;
}
var Gp = [];
Fb.forEach((e) => e.blocks.forEach((t) => Gp.push(...t)));
function M7(e) {
  for (var t = 0; t < Gp.length; t += 2)
    if (e >= Gp[t] && e <= Gp[t + 1])
      return !0;
  return !1;
}
var Du = 80, h_ = function(t, i) {
  return "M95," + (622 + t + i) + `
c-2.7,0,-7.17,-2.7,-13.5,-8c-5.8,-5.3,-9.5,-10,-9.5,-14
c0,-2,0.3,-3.3,1,-4c1.3,-2.7,23.83,-20.7,67.5,-54
c44.2,-33.3,65.8,-50.3,66.5,-51c1.3,-1.3,3,-2,5,-2c4.7,0,8.7,3.3,12,10
s173,378,173,378c0.7,0,35.3,-71,104,-213c68.7,-142,137.5,-285,206.5,-429
c69,-144,104.5,-217.7,106.5,-221
l` + t / 2.075 + " -" + t + `
c5.3,-9.3,12,-14,20,-14
H400000v` + (40 + t) + `H845.2724
s-225.272,467,-225.272,467s-235,486,-235,486c-2.7,4.7,-9,7,-19,7
c-6,0,-10,-1,-12,-3s-194,-422,-194,-422s-65,47,-65,47z
M` + (834 + t) + " " + i + "h400000v" + (40 + t) + "h-400000z";
}, p_ = function(t, i) {
  return "M263," + (601 + t + i) + `c0.7,0,18,39.7,52,119
c34,79.3,68.167,158.7,102.5,238c34.3,79.3,51.8,119.3,52.5,120
c340,-704.7,510.7,-1060.3,512,-1067
l` + t / 2.084 + " -" + t + `
c4.7,-7.3,11,-11,19,-11
H40000v` + (40 + t) + `H1012.3
s-271.3,567,-271.3,567c-38.7,80.7,-84,175,-136,283c-52,108,-89.167,185.3,-111.5,232
c-22.3,46.7,-33.8,70.3,-34.5,71c-4.7,4.7,-12.3,7,-23,7s-12,-1,-12,-1
s-109,-253,-109,-253c-72.7,-168,-109.3,-252,-110,-252c-10.7,8,-22,16.7,-34,26
c-22,17.3,-33.3,26,-34,26s-26,-26,-26,-26s76,-59,76,-59s76,-60,76,-60z
M` + (1001 + t) + " " + i + "h400000v" + (40 + t) + "h-400000z";
}, f_ = function(t, i) {
  return "M983 " + (10 + t + i) + `
l` + t / 3.13 + " -" + t + `
c4,-6.7,10,-10,18,-10 H400000v` + (40 + t) + `
H1013.1s-83.4,268,-264.1,840c-180.7,572,-277,876.3,-289,913c-4.7,4.7,-12.7,7,-24,7
s-12,0,-12,0c-1.3,-3.3,-3.7,-11.7,-7,-25c-35.3,-125.3,-106.7,-373.3,-214,-744
c-10,12,-21,25,-33,39s-32,39,-32,39c-6,-5.3,-15,-14,-27,-26s25,-30,25,-30
c26.7,-32.7,52,-63,76,-91s52,-60,52,-60s208,722,208,722
c56,-175.3,126.3,-397.3,211,-666c84.7,-268.7,153.8,-488.2,207.5,-658.5
c53.7,-170.3,84.5,-266.8,92.5,-289.5z
M` + (1001 + t) + " " + i + "h400000v" + (40 + t) + "h-400000z";
}, A_ = function(t, i) {
  return "M424," + (2398 + t + i) + `
c-1.3,-0.7,-38.5,-172,-111.5,-514c-73,-342,-109.8,-513.3,-110.5,-514
c0,-2,-10.7,14.3,-32,49c-4.7,7.3,-9.8,15.7,-15.5,25c-5.7,9.3,-9.8,16,-12.5,20
s-5,7,-5,7c-4,-3.3,-8.3,-7.7,-13,-13s-13,-13,-13,-13s76,-122,76,-122s77,-121,77,-121
s209,968,209,968c0,-2,84.7,-361.7,254,-1079c169.3,-717.3,254.7,-1077.7,256,-1081
l` + t / 4.223 + " -" + t + `c4,-6.7,10,-10,18,-10 H400000
v` + (40 + t) + `H1014.6
s-87.3,378.7,-272.6,1166c-185.3,787.3,-279.3,1182.3,-282,1185
c-2,6,-10,9,-24,9
c-8,0,-12,-0.7,-12,-2z M` + (1001 + t) + " " + i + `
h400000v` + (40 + t) + "h-400000z";
}, y_ = function(t, i) {
  return "M473," + (2713 + t + i) + `
c339.3,-1799.3,509.3,-2700,510,-2702 l` + t / 5.298 + " -" + t + `
c3.3,-7.3,9.3,-11,18,-11 H400000v` + (40 + t) + `H1017.7
s-90.5,478,-276.2,1466c-185.7,988,-279.5,1483,-281.5,1485c-2,6,-10,9,-24,9
c-8,0,-12,-0.7,-12,-2c0,-1.3,-5.3,-32,-16,-92c-50.7,-293.3,-119.7,-693.3,-207,-1200
c0,-1.3,-5.3,8.7,-16,30c-10.7,21.3,-21.3,42.7,-32,64s-16,33,-16,33s-26,-26,-26,-26
s76,-153,76,-153s77,-151,77,-151c0.7,0.7,35.7,202,105,604c67.3,400.7,102,602.7,104,
606zM` + (1001 + t) + " " + i + "h400000v" + (40 + t) + "H1017.7z";
}, E_ = function(t) {
  var i = t / 2;
  return "M400000 " + t + " H0 L" + i + " 0 l65 45 L145 " + (t - 80) + " H400000z";
}, v_ = function(t, i, r) {
  var n = r - 54 - i - t;
  return "M702 " + (t + i) + "H400000" + (40 + t) + `
H742v` + n + `l-4 4-4 4c-.667.7 -2 1.5-4 2.5s-4.167 1.833-6.5 2.5-5.5 1-9.5 1
h-12l-28-84c-16.667-52-96.667 -294.333-240-727l-212 -643 -85 170
c-4-3.333-8.333-7.667-13 -13l-13-13l77-155 77-156c66 199.333 139 419.667
219 661 l218 661zM702 ` + i + "H400000v" + (40 + t) + "H742z";
}, b_ = function(t, i, r) {
  i = 1e3 * i;
  var n = "";
  switch (t) {
    case "sqrtMain":
      n = h_(i, Du);
      break;
    case "sqrtSize1":
      n = p_(i, Du);
      break;
    case "sqrtSize2":
      n = f_(i, Du);
      break;
    case "sqrtSize3":
      n = A_(i, Du);
      break;
    case "sqrtSize4":
      n = y_(i, Du);
      break;
    case "sqrtTall":
      n = v_(i, Du, r);
  }
  return n;
}, C_ = function(t, i) {
  switch (t) {
    case "⎜":
      return "M291 0 H417 V" + i + " H291z M291 0 H417 V" + i + " H291z";
    case "∣":
      return "M145 0 H188 V" + i + " H145z M145 0 H188 V" + i + " H145z";
    case "∥":
      return "M145 0 H188 V" + i + " H145z M145 0 H188 V" + i + " H145z" + ("M367 0 H410 V" + i + " H367z M367 0 H410 V" + i + " H367z");
    case "⎟":
      return "M457 0 H583 V" + i + " H457z M457 0 H583 V" + i + " H457z";
    case "⎢":
      return "M319 0 H403 V" + i + " H319z M319 0 H403 V" + i + " H319z";
    case "⎥":
      return "M263 0 H347 V" + i + " H263z M263 0 H347 V" + i + " H263z";
    case "⎪":
      return "M384 0 H504 V" + i + " H384z M384 0 H504 V" + i + " H384z";
    case "⏐":
      return "M312 0 H355 V" + i + " H312z M312 0 H355 V" + i + " H312z";
    case "‖":
      return "M257 0 H300 V" + i + " H257z M257 0 H300 V" + i + " H257z" + ("M478 0 H521 V" + i + " H478z M478 0 H521 V" + i + " H478z");
    default:
      return "";
  }
}, t4 = {
  // The doubleleftarrow geometry is from glyph U+21D0 in the font KaTeX Main
  doubleleftarrow: `M262 157
l10-10c34-36 62.7-77 86-123 3.3-8 5-13.3 5-16 0-5.3-6.7-8-20-8-7.3
 0-12.2.5-14.5 1.5-2.3 1-4.8 4.5-7.5 10.5-49.3 97.3-121.7 169.3-217 216-28
 14-57.3 25-88 33-6.7 2-11 3.8-13 5.5-2 1.7-3 4.2-3 7.5s1 5.8 3 7.5
c2 1.7 6.3 3.5 13 5.5 68 17.3 128.2 47.8 180.5 91.5 52.3 43.7 93.8 96.2 124.5
 157.5 9.3 8 15.3 12.3 18 13h6c12-.7 18-4 18-10 0-2-1.7-7-5-15-23.3-46-52-87
-86-123l-10-10h399738v-40H218c328 0 0 0 0 0l-10-8c-26.7-20-65.7-43-117-69 2.7
-2 6-3.7 10-5 36.7-16 72.3-37.3 107-64l10-8h399782v-40z
m8 0v40h399730v-40zm0 194v40h399730v-40z`,
  // doublerightarrow is from glyph U+21D2 in font KaTeX Main
  doublerightarrow: `M399738 392l
-10 10c-34 36-62.7 77-86 123-3.3 8-5 13.3-5 16 0 5.3 6.7 8 20 8 7.3 0 12.2-.5
 14.5-1.5 2.3-1 4.8-4.5 7.5-10.5 49.3-97.3 121.7-169.3 217-216 28-14 57.3-25 88
-33 6.7-2 11-3.8 13-5.5 2-1.7 3-4.2 3-7.5s-1-5.8-3-7.5c-2-1.7-6.3-3.5-13-5.5-68
-17.3-128.2-47.8-180.5-91.5-52.3-43.7-93.8-96.2-124.5-157.5-9.3-8-15.3-12.3-18
-13h-6c-12 .7-18 4-18 10 0 2 1.7 7 5 15 23.3 46 52 87 86 123l10 10H0v40h399782
c-328 0 0 0 0 0l10 8c26.7 20 65.7 43 117 69-2.7 2-6 3.7-10 5-36.7 16-72.3 37.3
-107 64l-10 8H0v40zM0 157v40h399730v-40zm0 194v40h399730v-40z`,
  // leftarrow is from glyph U+2190 in font KaTeX Main
  leftarrow: `M400000 241H110l3-3c68.7-52.7 113.7-120
 135-202 4-14.7 6-23 6-25 0-7.3-7-11-21-11-8 0-13.2.8-15.5 2.5-2.3 1.7-4.2 5.8
-5.5 12.5-1.3 4.7-2.7 10.3-4 17-12 48.7-34.8 92-68.5 130S65.3 228.3 18 247
c-10 4-16 7.7-18 11 0 8.7 6 14.3 18 17 47.3 18.7 87.8 47 121.5 85S196 441.3 208
 490c.7 2 1.3 5 2 9s1.2 6.7 1.5 8c.3 1.3 1 3.3 2 6s2.2 4.5 3.5 5.5c1.3 1 3.3
 1.8 6 2.5s6 1 10 1c14 0 21-3.7 21-11 0-2-2-10.3-6-25-20-79.3-65-146.7-135-202
 l-3-3h399890zM100 241v40h399900v-40z`,
  // overbrace is from glyphs U+23A9/23A8/23A7 in font KaTeX_Size4-Regular
  leftbrace: `M6 548l-6-6v-35l6-11c56-104 135.3-181.3 238-232 57.3-28.7 117
-45 179-50h399577v120H403c-43.3 7-81 15-113 26-100.7 33-179.7 91-237 174-2.7
 5-6 9-10 13-.7 1-7.3 1-20 1H6z`,
  leftbraceunder: `M0 6l6-6h17c12.688 0 19.313.3 20 1 4 4 7.313 8.3 10 13
 35.313 51.3 80.813 93.8 136.5 127.5 55.688 33.7 117.188 55.8 184.5 66.5.688
 0 2 .3 4 1 18.688 2.7 76 4.3 172 5h399450v120H429l-6-1c-124.688-8-235-61.7
-331-161C60.687 138.7 32.312 99.3 7 54L0 41V6z`,
  // overgroup is from the MnSymbol package (public domain)
  leftgroup: `M400000 80
H435C64 80 168.3 229.4 21 260c-5.9 1.2-18 0-18 0-2 0-3-1-3-3v-38C76 61 257 0
 435 0h399565z`,
  leftgroupunder: `M400000 262
H435C64 262 168.3 112.6 21 82c-5.9-1.2-18 0-18 0-2 0-3 1-3 3v38c76 158 257 219
 435 219h399565z`,
  // Harpoons are from glyph U+21BD in font KaTeX Main
  leftharpoon: `M0 267c.7 5.3 3 10 7 14h399993v-40H93c3.3
-3.3 10.2-9.5 20.5-18.5s17.8-15.8 22.5-20.5c50.7-52 88-110.3 112-175 4-11.3 5
-18.3 3-21-1.3-4-7.3-6-18-6-8 0-13 .7-15 2s-4.7 6.7-8 16c-42 98.7-107.3 174.7
-196 228-6.7 4.7-10.7 8-12 10-1.3 2-2 5.7-2 11zm100-26v40h399900v-40z`,
  leftharpoonplus: `M0 267c.7 5.3 3 10 7 14h399993v-40H93c3.3-3.3 10.2-9.5
 20.5-18.5s17.8-15.8 22.5-20.5c50.7-52 88-110.3 112-175 4-11.3 5-18.3 3-21-1.3
-4-7.3-6-18-6-8 0-13 .7-15 2s-4.7 6.7-8 16c-42 98.7-107.3 174.7-196 228-6.7 4.7
-10.7 8-12 10-1.3 2-2 5.7-2 11zm100-26v40h399900v-40zM0 435v40h400000v-40z
m0 0v40h400000v-40z`,
  leftharpoondown: `M7 241c-4 4-6.333 8.667-7 14 0 5.333.667 9 2 11s5.333
 5.333 12 10c90.667 54 156 130 196 228 3.333 10.667 6.333 16.333 9 17 2 .667 5
 1 9 1h5c10.667 0 16.667-2 18-6 2-2.667 1-9.667-3-21-32-87.333-82.667-157.667
-152-211l-3-3h399907v-40zM93 281 H400000 v-40L7 241z`,
  leftharpoondownplus: `M7 435c-4 4-6.3 8.7-7 14 0 5.3.7 9 2 11s5.3 5.3 12
 10c90.7 54 156 130 196 228 3.3 10.7 6.3 16.3 9 17 2 .7 5 1 9 1h5c10.7 0 16.7
-2 18-6 2-2.7 1-9.7-3-21-32-87.3-82.7-157.7-152-211l-3-3h399907v-40H7zm93 0
v40h399900v-40zM0 241v40h399900v-40zm0 0v40h399900v-40z`,
  // hook is from glyph U+21A9 in font KaTeX Main
  lefthook: `M400000 281 H103s-33-11.2-61-33.5S0 197.3 0 164s14.2-61.2 42.5
-83.5C70.8 58.2 104 47 142 47 c16.7 0 25 6.7 25 20 0 12-8.7 18.7-26 20-40 3.3
-68.7 15.7-86 37-10 12-15 25.3-15 40 0 22.7 9.8 40.7 29.5 54 19.7 13.3 43.5 21
 71.5 23h399859zM103 281v-40h399897v40z`,
  leftlinesegment: `M40 281 V428 H0 V94 H40 V241 H400000 v40z
M40 281 V428 H0 V94 H40 V241 H400000 v40z`,
  leftmapsto: `M40 281 V448H0V74H40V241H400000v40z
M40 281 V448H0V74H40V241H400000v40z`,
  // tofrom is from glyph U+21C4 in font KaTeX AMS Regular
  leftToFrom: `M0 147h400000v40H0zm0 214c68 40 115.7 95.7 143 167h22c15.3 0 23
-.3 23-1 0-1.3-5.3-13.7-16-37-18-35.3-41.3-69-70-101l-7-8h399905v-40H95l7-8
c28.7-32 52-65.7 70-101 10.7-23.3 16-35.7 16-37 0-.7-7.7-1-23-1h-22C115.7 265.3
 68 321 0 361zm0-174v-40h399900v40zm100 154v40h399900v-40z`,
  longequal: `M0 50 h400000 v40H0z m0 194h40000v40H0z
M0 50 h400000 v40H0z m0 194h40000v40H0z`,
  midbrace: `M200428 334
c-100.7-8.3-195.3-44-280-108-55.3-42-101.7-93-139-153l-9-14c-2.7 4-5.7 8.7-9 14
-53.3 86.7-123.7 153-211 199-66.7 36-137.3 56.3-212 62H0V214h199568c178.3-11.7
 311.7-78.3 403-201 6-8 9.7-12 11-12 .7-.7 6.7-1 18-1s17.3.3 18 1c1.3 0 5 4 11
 12 44.7 59.3 101.3 106.3 170 141s145.3 54.3 229 60h199572v120z`,
  midbraceunder: `M199572 214
c100.7 8.3 195.3 44 280 108 55.3 42 101.7 93 139 153l9 14c2.7-4 5.7-8.7 9-14
 53.3-86.7 123.7-153 211-199 66.7-36 137.3-56.3 212-62h199568v120H200432c-178.3
 11.7-311.7 78.3-403 201-6 8-9.7 12-11 12-.7.7-6.7 1-18 1s-17.3-.3-18-1c-1.3 0
-5-4-11-12-44.7-59.3-101.3-106.3-170-141s-145.3-54.3-229-60H0V214z`,
  oiintSize1: `M512.6 71.6c272.6 0 320.3 106.8 320.3 178.2 0 70.8-47.7 177.6
-320.3 177.6S193.1 320.6 193.1 249.8c0-71.4 46.9-178.2 319.5-178.2z
m368.1 178.2c0-86.4-60.9-215.4-368.1-215.4-306.4 0-367.3 129-367.3 215.4 0 85.8
60.9 214.8 367.3 214.8 307.2 0 368.1-129 368.1-214.8z`,
  oiintSize2: `M757.8 100.1c384.7 0 451.1 137.6 451.1 230 0 91.3-66.4 228.8
-451.1 228.8-386.3 0-452.7-137.5-452.7-228.8 0-92.4 66.4-230 452.7-230z
m502.4 230c0-111.2-82.4-277.2-502.4-277.2s-504 166-504 277.2
c0 110 84 276 504 276s502.4-166 502.4-276z`,
  oiiintSize1: `M681.4 71.6c408.9 0 480.5 106.8 480.5 178.2 0 70.8-71.6 177.6
-480.5 177.6S202.1 320.6 202.1 249.8c0-71.4 70.5-178.2 479.3-178.2z
m525.8 178.2c0-86.4-86.8-215.4-525.7-215.4-437.9 0-524.7 129-524.7 215.4 0
85.8 86.8 214.8 524.7 214.8 438.9 0 525.7-129 525.7-214.8z`,
  oiiintSize2: `M1021.2 53c603.6 0 707.8 165.8 707.8 277.2 0 110-104.2 275.8
-707.8 275.8-606 0-710.2-165.8-710.2-275.8C311 218.8 415.2 53 1021.2 53z
m770.4 277.1c0-131.2-126.4-327.6-770.5-327.6S248.4 198.9 248.4 330.1
c0 130 128.8 326.4 772.7 326.4s770.5-196.4 770.5-326.4z`,
  rightarrow: `M0 241v40h399891c-47.3 35.3-84 78-110 128
-16.7 32-27.7 63.7-33 95 0 1.3-.2 2.7-.5 4-.3 1.3-.5 2.3-.5 3 0 7.3 6.7 11 20
 11 8 0 13.2-.8 15.5-2.5 2.3-1.7 4.2-5.5 5.5-11.5 2-13.3 5.7-27 11-41 14.7-44.7
 39-84.5 73-119.5s73.7-60.2 119-75.5c6-2 9-5.7 9-11s-3-9-9-11c-45.3-15.3-85
-40.5-119-75.5s-58.3-74.8-73-119.5c-4.7-14-8.3-27.3-11-40-1.3-6.7-3.2-10.8-5.5
-12.5-2.3-1.7-7.5-2.5-15.5-2.5-14 0-21 3.7-21 11 0 2 2 10.3 6 25 20.7 83.3 67
 151.7 139 205zm0 0v40h399900v-40z`,
  rightbrace: `M400000 542l
-6 6h-17c-12.7 0-19.3-.3-20-1-4-4-7.3-8.3-10-13-35.3-51.3-80.8-93.8-136.5-127.5
s-117.2-55.8-184.5-66.5c-.7 0-2-.3-4-1-18.7-2.7-76-4.3-172-5H0V214h399571l6 1
c124.7 8 235 61.7 331 161 31.3 33.3 59.7 72.7 85 118l7 13v35z`,
  rightbraceunder: `M399994 0l6 6v35l-6 11c-56 104-135.3 181.3-238 232-57.3
 28.7-117 45-179 50H-300V214h399897c43.3-7 81-15 113-26 100.7-33 179.7-91 237
-174 2.7-5 6-9 10-13 .7-1 7.3-1 20-1h17z`,
  rightgroup: `M0 80h399565c371 0 266.7 149.4 414 180 5.9 1.2 18 0 18 0 2 0
 3-1 3-3v-38c-76-158-257-219-435-219H0z`,
  rightgroupunder: `M0 262h399565c371 0 266.7-149.4 414-180 5.9-1.2 18 0 18
 0 2 0 3 1 3 3v38c-76 158-257 219-435 219H0z`,
  rightharpoon: `M0 241v40h399993c4.7-4.7 7-9.3 7-14 0-9.3
-3.7-15.3-11-18-92.7-56.7-159-133.7-199-231-3.3-9.3-6-14.7-8-16-2-1.3-7-2-15-2
-10.7 0-16.7 2-18 6-2 2.7-1 9.7 3 21 15.3 42 36.7 81.8 64 119.5 27.3 37.7 58
 69.2 92 94.5zm0 0v40h399900v-40z`,
  rightharpoonplus: `M0 241v40h399993c4.7-4.7 7-9.3 7-14 0-9.3-3.7-15.3-11
-18-92.7-56.7-159-133.7-199-231-3.3-9.3-6-14.7-8-16-2-1.3-7-2-15-2-10.7 0-16.7
 2-18 6-2 2.7-1 9.7 3 21 15.3 42 36.7 81.8 64 119.5 27.3 37.7 58 69.2 92 94.5z
m0 0v40h399900v-40z m100 194v40h399900v-40zm0 0v40h399900v-40z`,
  rightharpoondown: `M399747 511c0 7.3 6.7 11 20 11 8 0 13-.8 15-2.5s4.7-6.8
 8-15.5c40-94 99.3-166.3 178-217 13.3-8 20.3-12.3 21-13 5.3-3.3 8.5-5.8 9.5
-7.5 1-1.7 1.5-5.2 1.5-10.5s-2.3-10.3-7-15H0v40h399908c-34 25.3-64.7 57-92 95
-27.3 38-48.7 77.7-64 119-3.3 8.7-5 14-5 16zM0 241v40h399900v-40z`,
  rightharpoondownplus: `M399747 705c0 7.3 6.7 11 20 11 8 0 13-.8
 15-2.5s4.7-6.8 8-15.5c40-94 99.3-166.3 178-217 13.3-8 20.3-12.3 21-13 5.3-3.3
 8.5-5.8 9.5-7.5 1-1.7 1.5-5.2 1.5-10.5s-2.3-10.3-7-15H0v40h399908c-34 25.3
-64.7 57-92 95-27.3 38-48.7 77.7-64 119-3.3 8.7-5 14-5 16zM0 435v40h399900v-40z
m0-194v40h400000v-40zm0 0v40h400000v-40z`,
  righthook: `M399859 241c-764 0 0 0 0 0 40-3.3 68.7-15.7 86-37 10-12 15-25.3
 15-40 0-22.7-9.8-40.7-29.5-54-19.7-13.3-43.5-21-71.5-23-17.3-1.3-26-8-26-20 0
-13.3 8.7-20 26-20 38 0 71 11.2 99 33.5 0 0 7 5.6 21 16.7 14 11.2 21 33.5 21
 66.8s-14 61.2-42 83.5c-28 22.3-61 33.5-99 33.5L0 241z M0 281v-40h399859v40z`,
  rightlinesegment: `M399960 241 V94 h40 V428 h-40 V281 H0 v-40z
M399960 241 V94 h40 V428 h-40 V281 H0 v-40z`,
  rightToFrom: `M400000 167c-70.7-42-118-97.7-142-167h-23c-15.3 0-23 .3-23
 1 0 1.3 5.3 13.7 16 37 18 35.3 41.3 69 70 101l7 8H0v40h399905l-7 8c-28.7 32
-52 65.7-70 101-10.7 23.3-16 35.7-16 37 0 .7 7.7 1 23 1h23c24-69.3 71.3-125 142
-167z M100 147v40h399900v-40zM0 341v40h399900v-40z`,
  // twoheadleftarrow is from glyph U+219E in font KaTeX AMS Regular
  twoheadleftarrow: `M0 167c68 40
 115.7 95.7 143 167h22c15.3 0 23-.3 23-1 0-1.3-5.3-13.7-16-37-18-35.3-41.3-69
-70-101l-7-8h125l9 7c50.7 39.3 85 86 103 140h46c0-4.7-6.3-18.7-19-42-18-35.3
-40-67.3-66-96l-9-9h399716v-40H284l9-9c26-28.7 48-60.7 66-96 12.7-23.333 19
-37.333 19-42h-46c-18 54-52.3 100.7-103 140l-9 7H95l7-8c28.7-32 52-65.7 70-101
 10.7-23.333 16-35.7 16-37 0-.7-7.7-1-23-1h-22C115.7 71.3 68 127 0 167z`,
  twoheadrightarrow: `M400000 167
c-68-40-115.7-95.7-143-167h-22c-15.3 0-23 .3-23 1 0 1.3 5.3 13.7 16 37 18 35.3
 41.3 69 70 101l7 8h-125l-9-7c-50.7-39.3-85-86-103-140h-46c0 4.7 6.3 18.7 19 42
 18 35.3 40 67.3 66 96l9 9H0v40h399716l-9 9c-26 28.7-48 60.7-66 96-12.7 23.333
-19 37.333-19 42h46c18-54 52.3-100.7 103-140l9-7h125l-7 8c-28.7 32-52 65.7-70
 101-10.7 23.333-16 35.7-16 37 0 .7 7.7 1 23 1h22c27.3-71.3 75-127 143-167z`,
  // tilde1 is a modified version of a glyph from the MnSymbol package
  tilde1: `M200 55.538c-77 0-168 73.953-177 73.953-3 0-7
-2.175-9-5.437L2 97c-1-2-2-4-2-6 0-4 2-7 5-9l20-12C116 12 171 0 207 0c86 0
 114 68 191 68 78 0 168-68 177-68 4 0 7 2 9 5l12 19c1 2.175 2 4.35 2 6.525 0
 4.35-2 7.613-5 9.788l-19 13.05c-92 63.077-116.937 75.308-183 76.128
-68.267.847-113-73.952-191-73.952z`,
  // ditto tilde2, tilde3, & tilde4
  tilde2: `M344 55.266c-142 0-300.638 81.316-311.5 86.418
-8.01 3.762-22.5 10.91-23.5 5.562L1 120c-1-2-1-3-1-4 0-5 3-9 8-10l18.4-9C160.9
 31.9 283 0 358 0c148 0 188 122 331 122s314-97 326-97c4 0 8 2 10 7l7 21.114
c1 2.14 1 3.21 1 4.28 0 5.347-3 9.626-7 10.696l-22.3 12.622C852.6 158.372 751
 181.476 676 181.476c-149 0-189-126.21-332-126.21z`,
  tilde3: `M786 59C457 59 32 175.242 13 175.242c-6 0-10-3.457
-11-10.37L.15 138c-1-7 3-12 10-13l19.2-6.4C378.4 40.7 634.3 0 804.3 0c337 0
 411.8 157 746.8 157 328 0 754-112 773-112 5 0 10 3 11 9l1 14.075c1 8.066-.697
 16.595-6.697 17.492l-21.052 7.31c-367.9 98.146-609.15 122.696-778.15 122.696
 -338 0-409-156.573-744-156.573z`,
  tilde4: `M786 58C457 58 32 177.487 13 177.487c-6 0-10-3.345
-11-10.035L.15 143c-1-7 3-12 10-13l22-6.7C381.2 35 637.15 0 807.15 0c337 0 409
 177 744 177 328 0 754-127 773-127 5 0 10 3 11 9l1 14.794c1 7.805-3 13.38-9
 14.495l-20.7 5.574c-366.85 99.79-607.3 139.372-776.3 139.372-338 0-409
 -175.236-744-175.236z`,
  // vec is from glyph U+20D7 in font KaTeX Main
  vec: `M377 20c0-5.333 1.833-10 5.5-14S391 0 397 0c4.667 0 8.667 1.667 12 5
3.333 2.667 6.667 9 10 19 6.667 24.667 20.333 43.667 41 57 7.333 4.667 11
10.667 11 18 0 6-1 10-3 12s-6.667 5-14 9c-28.667 14.667-53.667 35.667-75 63
-1.333 1.333-3.167 3.5-5.5 6.5s-4 4.833-5 5.5c-1 .667-2.5 1.333-4.5 2s-4.333 1
-7 1c-4.667 0-9.167-1.833-13.5-5.5S337 184 337 178c0-12.667 15.667-32.333 47-59
H213l-171-1c-8.667-6-13-12.333-13-19 0-4.667 4.333-11.333 13-20h359
c-16-25.333-24-45-24-59z`,
  // widehat1 is a modified version of a glyph from the MnSymbol package
  widehat1: `M529 0h5l519 115c5 1 9 5 9 10 0 1-1 2-1 3l-4 22
c-1 5-5 9-11 9h-2L532 67 19 159h-2c-5 0-9-4-11-9l-5-22c-1-6 2-12 8-13z`,
  // ditto widehat2, widehat3, & widehat4
  widehat2: `M1181 0h2l1171 176c6 0 10 5 10 11l-2 23c-1 6-5 10
-11 10h-1L1182 67 15 220h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z`,
  widehat3: `M1181 0h2l1171 236c6 0 10 5 10 11l-2 23c-1 6-5 10
-11 10h-1L1182 67 15 280h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z`,
  widehat4: `M1181 0h2l1171 296c6 0 10 5 10 11l-2 23c-1 6-5 10
-11 10h-1L1182 67 15 340h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z`,
  // widecheck paths are all inverted versions of widehat
  widecheck1: `M529,159h5l519,-115c5,-1,9,-5,9,-10c0,-1,-1,-2,-1,-3l-4,-22c-1,
-5,-5,-9,-11,-9h-2l-512,92l-513,-92h-2c-5,0,-9,4,-11,9l-5,22c-1,6,2,12,8,13z`,
  widecheck2: `M1181,220h2l1171,-176c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,
-11,-10h-1l-1168,153l-1167,-153h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z`,
  widecheck3: `M1181,280h2l1171,-236c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,
-11,-10h-1l-1168,213l-1167,-213h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z`,
  widecheck4: `M1181,340h2l1171,-296c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,
-11,-10h-1l-1168,273l-1167,-273h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z`,
  // The next ten paths support reaction arrows from the mhchem package.
  // Arrows for \ce{<-->} are offset from xAxis by 0.22ex, per mhchem in LaTeX
  // baraboveleftarrow is mostly from glyph U+2190 in font KaTeX Main
  baraboveleftarrow: `M400000 620h-399890l3 -3c68.7 -52.7 113.7 -120 135 -202
c4 -14.7 6 -23 6 -25c0 -7.3 -7 -11 -21 -11c-8 0 -13.2 0.8 -15.5 2.5
c-2.3 1.7 -4.2 5.8 -5.5 12.5c-1.3 4.7 -2.7 10.3 -4 17c-12 48.7 -34.8 92 -68.5 130
s-74.2 66.3 -121.5 85c-10 4 -16 7.7 -18 11c0 8.7 6 14.3 18 17c47.3 18.7 87.8 47
121.5 85s56.5 81.3 68.5 130c0.7 2 1.3 5 2 9s1.2 6.7 1.5 8c0.3 1.3 1 3.3 2 6
s2.2 4.5 3.5 5.5c1.3 1 3.3 1.8 6 2.5s6 1 10 1c14 0 21 -3.7 21 -11
c0 -2 -2 -10.3 -6 -25c-20 -79.3 -65 -146.7 -135 -202l-3 -3h399890z
M100 620v40h399900v-40z M0 241v40h399900v-40zM0 241v40h399900v-40z`,
  // rightarrowabovebar is mostly from glyph U+2192, KaTeX Main
  rightarrowabovebar: `M0 241v40h399891c-47.3 35.3-84 78-110 128-16.7 32
-27.7 63.7-33 95 0 1.3-.2 2.7-.5 4-.3 1.3-.5 2.3-.5 3 0 7.3 6.7 11 20 11 8 0
13.2-.8 15.5-2.5 2.3-1.7 4.2-5.5 5.5-11.5 2-13.3 5.7-27 11-41 14.7-44.7 39
-84.5 73-119.5s73.7-60.2 119-75.5c6-2 9-5.7 9-11s-3-9-9-11c-45.3-15.3-85-40.5
-119-75.5s-58.3-74.8-73-119.5c-4.7-14-8.3-27.3-11-40-1.3-6.7-3.2-10.8-5.5
-12.5-2.3-1.7-7.5-2.5-15.5-2.5-14 0-21 3.7-21 11 0 2 2 10.3 6 25 20.7 83.3 67
151.7 139 205zm96 379h399894v40H0zm0 0h399904v40H0z`,
  // The short left harpoon has 0.5em (i.e. 500 units) kern on the left end.
  // Ref from mhchem.sty: \rlap{\raisebox{-.22ex}{$\kern0.5em
  baraboveshortleftharpoon: `M507,435c-4,4,-6.3,8.7,-7,14c0,5.3,0.7,9,2,11
c1.3,2,5.3,5.3,12,10c90.7,54,156,130,196,228c3.3,10.7,6.3,16.3,9,17
c2,0.7,5,1,9,1c0,0,5,0,5,0c10.7,0,16.7,-2,18,-6c2,-2.7,1,-9.7,-3,-21
c-32,-87.3,-82.7,-157.7,-152,-211c0,0,-3,-3,-3,-3l399351,0l0,-40
c-398570,0,-399437,0,-399437,0z M593 435 v40 H399500 v-40z
M0 281 v-40 H399908 v40z M0 281 v-40 H399908 v40z`,
  rightharpoonaboveshortbar: `M0,241 l0,40c399126,0,399993,0,399993,0
c4.7,-4.7,7,-9.3,7,-14c0,-9.3,-3.7,-15.3,-11,-18c-92.7,-56.7,-159,-133.7,-199,
-231c-3.3,-9.3,-6,-14.7,-8,-16c-2,-1.3,-7,-2,-15,-2c-10.7,0,-16.7,2,-18,6
c-2,2.7,-1,9.7,3,21c15.3,42,36.7,81.8,64,119.5c27.3,37.7,58,69.2,92,94.5z
M0 241 v40 H399908 v-40z M0 475 v-40 H399500 v40z M0 475 v-40 H399500 v40z`,
  shortbaraboveleftharpoon: `M7,435c-4,4,-6.3,8.7,-7,14c0,5.3,0.7,9,2,11
c1.3,2,5.3,5.3,12,10c90.7,54,156,130,196,228c3.3,10.7,6.3,16.3,9,17c2,0.7,5,1,9,
1c0,0,5,0,5,0c10.7,0,16.7,-2,18,-6c2,-2.7,1,-9.7,-3,-21c-32,-87.3,-82.7,-157.7,
-152,-211c0,0,-3,-3,-3,-3l399907,0l0,-40c-399126,0,-399993,0,-399993,0z
M93 435 v40 H400000 v-40z M500 241 v40 H400000 v-40z M500 241 v40 H400000 v-40z`,
  shortrightharpoonabovebar: `M53,241l0,40c398570,0,399437,0,399437,0
c4.7,-4.7,7,-9.3,7,-14c0,-9.3,-3.7,-15.3,-11,-18c-92.7,-56.7,-159,-133.7,-199,
-231c-3.3,-9.3,-6,-14.7,-8,-16c-2,-1.3,-7,-2,-15,-2c-10.7,0,-16.7,2,-18,6
c-2,2.7,-1,9.7,3,21c15.3,42,36.7,81.8,64,119.5c27.3,37.7,58,69.2,92,94.5z
M500 241 v40 H399408 v-40z M500 435 v40 H400000 v-40z`
}, x_ = function(t, i) {
  switch (t) {
    case "lbrack":
      return "M403 1759 V84 H666 V0 H319 V1759 v" + i + ` v1759 h347 v-84
H403z M403 1759 V0 H319 V1759 v` + i + " v1759 h84z";
    case "rbrack":
      return "M347 1759 V0 H0 V84 H263 V1759 v" + i + ` v1759 H0 v84 H347z
M347 1759 V0 H263 V1759 v` + i + " v1759 h84z";
    case "vert":
      return "M145 15 v585 v" + i + ` v585 c2.667,10,9.667,15,21,15
c10,0,16.667,-5,20,-15 v-585 v` + -i + ` v-585 c-2.667,-10,-9.667,-15,-21,-15
c-10,0,-16.667,5,-20,15z M188 15 H145 v585 v` + i + " v585 h43z";
    case "doublevert":
      return "M145 15 v585 v" + i + ` v585 c2.667,10,9.667,15,21,15
c10,0,16.667,-5,20,-15 v-585 v` + -i + ` v-585 c-2.667,-10,-9.667,-15,-21,-15
c-10,0,-16.667,5,-20,15z M188 15 H145 v585 v` + i + ` v585 h43z
M367 15 v585 v` + i + ` v585 c2.667,10,9.667,15,21,15
c10,0,16.667,-5,20,-15 v-585 v` + -i + ` v-585 c-2.667,-10,-9.667,-15,-21,-15
c-10,0,-16.667,5,-20,15z M410 15 H367 v585 v` + i + " v585 h43z";
    case "lfloor":
      return "M319 602 V0 H403 V602 v" + i + ` v1715 h263 v84 H319z
MM319 602 V0 H403 V602 v` + i + " v1715 H319z";
    case "rfloor":
      return "M319 602 V0 H403 V602 v" + i + ` v1799 H0 v-84 H319z
MM319 602 V0 H403 V602 v` + i + " v1715 H319z";
    case "lceil":
      return "M403 1759 V84 H666 V0 H319 V1759 v" + i + ` v602 h84z
M403 1759 V0 H319 V1759 v` + i + " v602 h84z";
    case "rceil":
      return "M347 1759 V0 H0 V84 H263 V1759 v" + i + ` v602 h84z
M347 1759 V0 h-84 V1759 v` + i + " v602 h84z";
    case "lparen":
      return `M863,9c0,-2,-2,-5,-6,-9c0,0,-17,0,-17,0c-12.7,0,-19.3,0.3,-20,1
c-5.3,5.3,-10.3,11,-15,17c-242.7,294.7,-395.3,682,-458,1162c-21.3,163.3,-33.3,349,
-36,557 l0,` + (i + 84) + `c0.2,6,0,26,0,60c2,159.3,10,310.7,24,454c53.3,528,210,
949.7,470,1265c4.7,6,9.7,11.7,15,17c0.7,0.7,7,1,19,1c0,0,18,0,18,0c4,-4,6,-7,6,-9
c0,-2.7,-3.3,-8.7,-10,-18c-135.3,-192.7,-235.5,-414.3,-300.5,-665c-65,-250.7,-102.5,
-544.7,-112.5,-882c-2,-104,-3,-167,-3,-189
l0,-` + (i + 92) + `c0,-162.7,5.7,-314,17,-454c20.7,-272,63.7,-513,129,-723c65.3,
-210,155.3,-396.3,270,-559c6.7,-9.3,10,-15.3,10,-18z`;
    case "rparen":
      return `M76,0c-16.7,0,-25,3,-25,9c0,2,2,6.3,6,13c21.3,28.7,42.3,60.3,
63,95c96.7,156.7,172.8,332.5,228.5,527.5c55.7,195,92.8,416.5,111.5,664.5
c11.3,139.3,17,290.7,17,454c0,28,1.7,43,3.3,45l0,` + (i + 9) + `
c-3,4,-3.3,16.7,-3.3,38c0,162,-5.7,313.7,-17,455c-18.7,248,-55.8,469.3,-111.5,664
c-55.7,194.7,-131.8,370.3,-228.5,527c-20.7,34.7,-41.7,66.3,-63,95c-2,3.3,-4,7,-6,11
c0,7.3,5.7,11,17,11c0,0,11,0,11,0c9.3,0,14.3,-0.3,15,-1c5.3,-5.3,10.3,-11,15,-17
c242.7,-294.7,395.3,-681.7,458,-1161c21.3,-164.7,33.3,-350.7,36,-558
l0,-` + (i + 144) + `c-2,-159.3,-10,-310.7,-24,-454c-53.3,-528,-210,-949.7,
-470,-1265c-4.7,-6,-9.7,-11.7,-15,-17c-0.7,-0.7,-6.7,-1,-18,-1z`;
    default:
      throw new Error("Unknown stretchy delimiter.");
  }
};
class bg {
  // HtmlDomNode
  // Never used; needed for satisfying interface.
  constructor(t) {
    this.children = void 0, this.classes = void 0, this.height = void 0, this.depth = void 0, this.maxFontSize = void 0, this.style = void 0, this.children = t, this.classes = [], this.height = 0, this.depth = 0, this.maxFontSize = 0, this.style = {};
  }
  hasClass(t) {
    return Rt.contains(this.classes, t);
  }
  /** Convert the fragment into a node. */
  toNode() {
    for (var t = document.createDocumentFragment(), i = 0; i < this.children.length; i++)
      t.appendChild(this.children[i].toNode());
    return t;
  }
  /** Convert the fragment into HTML markup. */
  toMarkup() {
    for (var t = "", i = 0; i < this.children.length; i++)
      t += this.children[i].toMarkup();
    return t;
  }
  /**
   * Converts the math node into a string, similar to innerText. Applies to
   * MathDomNode's only.
   */
  toText() {
    var t = (i) => i.toText();
    return this.children.map(t).join("");
  }
}
var Vs = {
  "AMS-Regular": {
    32: [0, 0, 0, 0, 0.25],
    65: [0, 0.68889, 0, 0, 0.72222],
    66: [0, 0.68889, 0, 0, 0.66667],
    67: [0, 0.68889, 0, 0, 0.72222],
    68: [0, 0.68889, 0, 0, 0.72222],
    69: [0, 0.68889, 0, 0, 0.66667],
    70: [0, 0.68889, 0, 0, 0.61111],
    71: [0, 0.68889, 0, 0, 0.77778],
    72: [0, 0.68889, 0, 0, 0.77778],
    73: [0, 0.68889, 0, 0, 0.38889],
    74: [0.16667, 0.68889, 0, 0, 0.5],
    75: [0, 0.68889, 0, 0, 0.77778],
    76: [0, 0.68889, 0, 0, 0.66667],
    77: [0, 0.68889, 0, 0, 0.94445],
    78: [0, 0.68889, 0, 0, 0.72222],
    79: [0.16667, 0.68889, 0, 0, 0.77778],
    80: [0, 0.68889, 0, 0, 0.61111],
    81: [0.16667, 0.68889, 0, 0, 0.77778],
    82: [0, 0.68889, 0, 0, 0.72222],
    83: [0, 0.68889, 0, 0, 0.55556],
    84: [0, 0.68889, 0, 0, 0.66667],
    85: [0, 0.68889, 0, 0, 0.72222],
    86: [0, 0.68889, 0, 0, 0.72222],
    87: [0, 0.68889, 0, 0, 1],
    88: [0, 0.68889, 0, 0, 0.72222],
    89: [0, 0.68889, 0, 0, 0.72222],
    90: [0, 0.68889, 0, 0, 0.66667],
    107: [0, 0.68889, 0, 0, 0.55556],
    160: [0, 0, 0, 0, 0.25],
    165: [0, 0.675, 0.025, 0, 0.75],
    174: [0.15559, 0.69224, 0, 0, 0.94666],
    240: [0, 0.68889, 0, 0, 0.55556],
    295: [0, 0.68889, 0, 0, 0.54028],
    710: [0, 0.825, 0, 0, 2.33334],
    732: [0, 0.9, 0, 0, 2.33334],
    770: [0, 0.825, 0, 0, 2.33334],
    771: [0, 0.9, 0, 0, 2.33334],
    989: [0.08167, 0.58167, 0, 0, 0.77778],
    1008: [0, 0.43056, 0.04028, 0, 0.66667],
    8245: [0, 0.54986, 0, 0, 0.275],
    8463: [0, 0.68889, 0, 0, 0.54028],
    8487: [0, 0.68889, 0, 0, 0.72222],
    8498: [0, 0.68889, 0, 0, 0.55556],
    8502: [0, 0.68889, 0, 0, 0.66667],
    8503: [0, 0.68889, 0, 0, 0.44445],
    8504: [0, 0.68889, 0, 0, 0.66667],
    8513: [0, 0.68889, 0, 0, 0.63889],
    8592: [-0.03598, 0.46402, 0, 0, 0.5],
    8594: [-0.03598, 0.46402, 0, 0, 0.5],
    8602: [-0.13313, 0.36687, 0, 0, 1],
    8603: [-0.13313, 0.36687, 0, 0, 1],
    8606: [0.01354, 0.52239, 0, 0, 1],
    8608: [0.01354, 0.52239, 0, 0, 1],
    8610: [0.01354, 0.52239, 0, 0, 1.11111],
    8611: [0.01354, 0.52239, 0, 0, 1.11111],
    8619: [0, 0.54986, 0, 0, 1],
    8620: [0, 0.54986, 0, 0, 1],
    8621: [-0.13313, 0.37788, 0, 0, 1.38889],
    8622: [-0.13313, 0.36687, 0, 0, 1],
    8624: [0, 0.69224, 0, 0, 0.5],
    8625: [0, 0.69224, 0, 0, 0.5],
    8630: [0, 0.43056, 0, 0, 1],
    8631: [0, 0.43056, 0, 0, 1],
    8634: [0.08198, 0.58198, 0, 0, 0.77778],
    8635: [0.08198, 0.58198, 0, 0, 0.77778],
    8638: [0.19444, 0.69224, 0, 0, 0.41667],
    8639: [0.19444, 0.69224, 0, 0, 0.41667],
    8642: [0.19444, 0.69224, 0, 0, 0.41667],
    8643: [0.19444, 0.69224, 0, 0, 0.41667],
    8644: [0.1808, 0.675, 0, 0, 1],
    8646: [0.1808, 0.675, 0, 0, 1],
    8647: [0.1808, 0.675, 0, 0, 1],
    8648: [0.19444, 0.69224, 0, 0, 0.83334],
    8649: [0.1808, 0.675, 0, 0, 1],
    8650: [0.19444, 0.69224, 0, 0, 0.83334],
    8651: [0.01354, 0.52239, 0, 0, 1],
    8652: [0.01354, 0.52239, 0, 0, 1],
    8653: [-0.13313, 0.36687, 0, 0, 1],
    8654: [-0.13313, 0.36687, 0, 0, 1],
    8655: [-0.13313, 0.36687, 0, 0, 1],
    8666: [0.13667, 0.63667, 0, 0, 1],
    8667: [0.13667, 0.63667, 0, 0, 1],
    8669: [-0.13313, 0.37788, 0, 0, 1],
    8672: [-0.064, 0.437, 0, 0, 1.334],
    8674: [-0.064, 0.437, 0, 0, 1.334],
    8705: [0, 0.825, 0, 0, 0.5],
    8708: [0, 0.68889, 0, 0, 0.55556],
    8709: [0.08167, 0.58167, 0, 0, 0.77778],
    8717: [0, 0.43056, 0, 0, 0.42917],
    8722: [-0.03598, 0.46402, 0, 0, 0.5],
    8724: [0.08198, 0.69224, 0, 0, 0.77778],
    8726: [0.08167, 0.58167, 0, 0, 0.77778],
    8733: [0, 0.69224, 0, 0, 0.77778],
    8736: [0, 0.69224, 0, 0, 0.72222],
    8737: [0, 0.69224, 0, 0, 0.72222],
    8738: [0.03517, 0.52239, 0, 0, 0.72222],
    8739: [0.08167, 0.58167, 0, 0, 0.22222],
    8740: [0.25142, 0.74111, 0, 0, 0.27778],
    8741: [0.08167, 0.58167, 0, 0, 0.38889],
    8742: [0.25142, 0.74111, 0, 0, 0.5],
    8756: [0, 0.69224, 0, 0, 0.66667],
    8757: [0, 0.69224, 0, 0, 0.66667],
    8764: [-0.13313, 0.36687, 0, 0, 0.77778],
    8765: [-0.13313, 0.37788, 0, 0, 0.77778],
    8769: [-0.13313, 0.36687, 0, 0, 0.77778],
    8770: [-0.03625, 0.46375, 0, 0, 0.77778],
    8774: [0.30274, 0.79383, 0, 0, 0.77778],
    8776: [-0.01688, 0.48312, 0, 0, 0.77778],
    8778: [0.08167, 0.58167, 0, 0, 0.77778],
    8782: [0.06062, 0.54986, 0, 0, 0.77778],
    8783: [0.06062, 0.54986, 0, 0, 0.77778],
    8785: [0.08198, 0.58198, 0, 0, 0.77778],
    8786: [0.08198, 0.58198, 0, 0, 0.77778],
    8787: [0.08198, 0.58198, 0, 0, 0.77778],
    8790: [0, 0.69224, 0, 0, 0.77778],
    8791: [0.22958, 0.72958, 0, 0, 0.77778],
    8796: [0.08198, 0.91667, 0, 0, 0.77778],
    8806: [0.25583, 0.75583, 0, 0, 0.77778],
    8807: [0.25583, 0.75583, 0, 0, 0.77778],
    8808: [0.25142, 0.75726, 0, 0, 0.77778],
    8809: [0.25142, 0.75726, 0, 0, 0.77778],
    8812: [0.25583, 0.75583, 0, 0, 0.5],
    8814: [0.20576, 0.70576, 0, 0, 0.77778],
    8815: [0.20576, 0.70576, 0, 0, 0.77778],
    8816: [0.30274, 0.79383, 0, 0, 0.77778],
    8817: [0.30274, 0.79383, 0, 0, 0.77778],
    8818: [0.22958, 0.72958, 0, 0, 0.77778],
    8819: [0.22958, 0.72958, 0, 0, 0.77778],
    8822: [0.1808, 0.675, 0, 0, 0.77778],
    8823: [0.1808, 0.675, 0, 0, 0.77778],
    8828: [0.13667, 0.63667, 0, 0, 0.77778],
    8829: [0.13667, 0.63667, 0, 0, 0.77778],
    8830: [0.22958, 0.72958, 0, 0, 0.77778],
    8831: [0.22958, 0.72958, 0, 0, 0.77778],
    8832: [0.20576, 0.70576, 0, 0, 0.77778],
    8833: [0.20576, 0.70576, 0, 0, 0.77778],
    8840: [0.30274, 0.79383, 0, 0, 0.77778],
    8841: [0.30274, 0.79383, 0, 0, 0.77778],
    8842: [0.13597, 0.63597, 0, 0, 0.77778],
    8843: [0.13597, 0.63597, 0, 0, 0.77778],
    8847: [0.03517, 0.54986, 0, 0, 0.77778],
    8848: [0.03517, 0.54986, 0, 0, 0.77778],
    8858: [0.08198, 0.58198, 0, 0, 0.77778],
    8859: [0.08198, 0.58198, 0, 0, 0.77778],
    8861: [0.08198, 0.58198, 0, 0, 0.77778],
    8862: [0, 0.675, 0, 0, 0.77778],
    8863: [0, 0.675, 0, 0, 0.77778],
    8864: [0, 0.675, 0, 0, 0.77778],
    8865: [0, 0.675, 0, 0, 0.77778],
    8872: [0, 0.69224, 0, 0, 0.61111],
    8873: [0, 0.69224, 0, 0, 0.72222],
    8874: [0, 0.69224, 0, 0, 0.88889],
    8876: [0, 0.68889, 0, 0, 0.61111],
    8877: [0, 0.68889, 0, 0, 0.61111],
    8878: [0, 0.68889, 0, 0, 0.72222],
    8879: [0, 0.68889, 0, 0, 0.72222],
    8882: [0.03517, 0.54986, 0, 0, 0.77778],
    8883: [0.03517, 0.54986, 0, 0, 0.77778],
    8884: [0.13667, 0.63667, 0, 0, 0.77778],
    8885: [0.13667, 0.63667, 0, 0, 0.77778],
    8888: [0, 0.54986, 0, 0, 1.11111],
    8890: [0.19444, 0.43056, 0, 0, 0.55556],
    8891: [0.19444, 0.69224, 0, 0, 0.61111],
    8892: [0.19444, 0.69224, 0, 0, 0.61111],
    8901: [0, 0.54986, 0, 0, 0.27778],
    8903: [0.08167, 0.58167, 0, 0, 0.77778],
    8905: [0.08167, 0.58167, 0, 0, 0.77778],
    8906: [0.08167, 0.58167, 0, 0, 0.77778],
    8907: [0, 0.69224, 0, 0, 0.77778],
    8908: [0, 0.69224, 0, 0, 0.77778],
    8909: [-0.03598, 0.46402, 0, 0, 0.77778],
    8910: [0, 0.54986, 0, 0, 0.76042],
    8911: [0, 0.54986, 0, 0, 0.76042],
    8912: [0.03517, 0.54986, 0, 0, 0.77778],
    8913: [0.03517, 0.54986, 0, 0, 0.77778],
    8914: [0, 0.54986, 0, 0, 0.66667],
    8915: [0, 0.54986, 0, 0, 0.66667],
    8916: [0, 0.69224, 0, 0, 0.66667],
    8918: [0.0391, 0.5391, 0, 0, 0.77778],
    8919: [0.0391, 0.5391, 0, 0, 0.77778],
    8920: [0.03517, 0.54986, 0, 0, 1.33334],
    8921: [0.03517, 0.54986, 0, 0, 1.33334],
    8922: [0.38569, 0.88569, 0, 0, 0.77778],
    8923: [0.38569, 0.88569, 0, 0, 0.77778],
    8926: [0.13667, 0.63667, 0, 0, 0.77778],
    8927: [0.13667, 0.63667, 0, 0, 0.77778],
    8928: [0.30274, 0.79383, 0, 0, 0.77778],
    8929: [0.30274, 0.79383, 0, 0, 0.77778],
    8934: [0.23222, 0.74111, 0, 0, 0.77778],
    8935: [0.23222, 0.74111, 0, 0, 0.77778],
    8936: [0.23222, 0.74111, 0, 0, 0.77778],
    8937: [0.23222, 0.74111, 0, 0, 0.77778],
    8938: [0.20576, 0.70576, 0, 0, 0.77778],
    8939: [0.20576, 0.70576, 0, 0, 0.77778],
    8940: [0.30274, 0.79383, 0, 0, 0.77778],
    8941: [0.30274, 0.79383, 0, 0, 0.77778],
    8994: [0.19444, 0.69224, 0, 0, 0.77778],
    8995: [0.19444, 0.69224, 0, 0, 0.77778],
    9416: [0.15559, 0.69224, 0, 0, 0.90222],
    9484: [0, 0.69224, 0, 0, 0.5],
    9488: [0, 0.69224, 0, 0, 0.5],
    9492: [0, 0.37788, 0, 0, 0.5],
    9496: [0, 0.37788, 0, 0, 0.5],
    9585: [0.19444, 0.68889, 0, 0, 0.88889],
    9586: [0.19444, 0.74111, 0, 0, 0.88889],
    9632: [0, 0.675, 0, 0, 0.77778],
    9633: [0, 0.675, 0, 0, 0.77778],
    9650: [0, 0.54986, 0, 0, 0.72222],
    9651: [0, 0.54986, 0, 0, 0.72222],
    9654: [0.03517, 0.54986, 0, 0, 0.77778],
    9660: [0, 0.54986, 0, 0, 0.72222],
    9661: [0, 0.54986, 0, 0, 0.72222],
    9664: [0.03517, 0.54986, 0, 0, 0.77778],
    9674: [0.11111, 0.69224, 0, 0, 0.66667],
    9733: [0.19444, 0.69224, 0, 0, 0.94445],
    10003: [0, 0.69224, 0, 0, 0.83334],
    10016: [0, 0.69224, 0, 0, 0.83334],
    10731: [0.11111, 0.69224, 0, 0, 0.66667],
    10846: [0.19444, 0.75583, 0, 0, 0.61111],
    10877: [0.13667, 0.63667, 0, 0, 0.77778],
    10878: [0.13667, 0.63667, 0, 0, 0.77778],
    10885: [0.25583, 0.75583, 0, 0, 0.77778],
    10886: [0.25583, 0.75583, 0, 0, 0.77778],
    10887: [0.13597, 0.63597, 0, 0, 0.77778],
    10888: [0.13597, 0.63597, 0, 0, 0.77778],
    10889: [0.26167, 0.75726, 0, 0, 0.77778],
    10890: [0.26167, 0.75726, 0, 0, 0.77778],
    10891: [0.48256, 0.98256, 0, 0, 0.77778],
    10892: [0.48256, 0.98256, 0, 0, 0.77778],
    10901: [0.13667, 0.63667, 0, 0, 0.77778],
    10902: [0.13667, 0.63667, 0, 0, 0.77778],
    10933: [0.25142, 0.75726, 0, 0, 0.77778],
    10934: [0.25142, 0.75726, 0, 0, 0.77778],
    10935: [0.26167, 0.75726, 0, 0, 0.77778],
    10936: [0.26167, 0.75726, 0, 0, 0.77778],
    10937: [0.26167, 0.75726, 0, 0, 0.77778],
    10938: [0.26167, 0.75726, 0, 0, 0.77778],
    10949: [0.25583, 0.75583, 0, 0, 0.77778],
    10950: [0.25583, 0.75583, 0, 0, 0.77778],
    10955: [0.28481, 0.79383, 0, 0, 0.77778],
    10956: [0.28481, 0.79383, 0, 0, 0.77778],
    57350: [0.08167, 0.58167, 0, 0, 0.22222],
    57351: [0.08167, 0.58167, 0, 0, 0.38889],
    57352: [0.08167, 0.58167, 0, 0, 0.77778],
    57353: [0, 0.43056, 0.04028, 0, 0.66667],
    57356: [0.25142, 0.75726, 0, 0, 0.77778],
    57357: [0.25142, 0.75726, 0, 0, 0.77778],
    57358: [0.41951, 0.91951, 0, 0, 0.77778],
    57359: [0.30274, 0.79383, 0, 0, 0.77778],
    57360: [0.30274, 0.79383, 0, 0, 0.77778],
    57361: [0.41951, 0.91951, 0, 0, 0.77778],
    57366: [0.25142, 0.75726, 0, 0, 0.77778],
    57367: [0.25142, 0.75726, 0, 0, 0.77778],
    57368: [0.25142, 0.75726, 0, 0, 0.77778],
    57369: [0.25142, 0.75726, 0, 0, 0.77778],
    57370: [0.13597, 0.63597, 0, 0, 0.77778],
    57371: [0.13597, 0.63597, 0, 0, 0.77778]
  },
  "Caligraphic-Regular": {
    32: [0, 0, 0, 0, 0.25],
    65: [0, 0.68333, 0, 0.19445, 0.79847],
    66: [0, 0.68333, 0.03041, 0.13889, 0.65681],
    67: [0, 0.68333, 0.05834, 0.13889, 0.52653],
    68: [0, 0.68333, 0.02778, 0.08334, 0.77139],
    69: [0, 0.68333, 0.08944, 0.11111, 0.52778],
    70: [0, 0.68333, 0.09931, 0.11111, 0.71875],
    71: [0.09722, 0.68333, 0.0593, 0.11111, 0.59487],
    72: [0, 0.68333, 965e-5, 0.11111, 0.84452],
    73: [0, 0.68333, 0.07382, 0, 0.54452],
    74: [0.09722, 0.68333, 0.18472, 0.16667, 0.67778],
    75: [0, 0.68333, 0.01445, 0.05556, 0.76195],
    76: [0, 0.68333, 0, 0.13889, 0.68972],
    77: [0, 0.68333, 0, 0.13889, 1.2009],
    78: [0, 0.68333, 0.14736, 0.08334, 0.82049],
    79: [0, 0.68333, 0.02778, 0.11111, 0.79611],
    80: [0, 0.68333, 0.08222, 0.08334, 0.69556],
    81: [0.09722, 0.68333, 0, 0.11111, 0.81667],
    82: [0, 0.68333, 0, 0.08334, 0.8475],
    83: [0, 0.68333, 0.075, 0.13889, 0.60556],
    84: [0, 0.68333, 0.25417, 0, 0.54464],
    85: [0, 0.68333, 0.09931, 0.08334, 0.62583],
    86: [0, 0.68333, 0.08222, 0, 0.61278],
    87: [0, 0.68333, 0.08222, 0.08334, 0.98778],
    88: [0, 0.68333, 0.14643, 0.13889, 0.7133],
    89: [0.09722, 0.68333, 0.08222, 0.08334, 0.66834],
    90: [0, 0.68333, 0.07944, 0.13889, 0.72473],
    160: [0, 0, 0, 0, 0.25]
  },
  "Fraktur-Regular": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69141, 0, 0, 0.29574],
    34: [0, 0.69141, 0, 0, 0.21471],
    38: [0, 0.69141, 0, 0, 0.73786],
    39: [0, 0.69141, 0, 0, 0.21201],
    40: [0.24982, 0.74947, 0, 0, 0.38865],
    41: [0.24982, 0.74947, 0, 0, 0.38865],
    42: [0, 0.62119, 0, 0, 0.27764],
    43: [0.08319, 0.58283, 0, 0, 0.75623],
    44: [0, 0.10803, 0, 0, 0.27764],
    45: [0.08319, 0.58283, 0, 0, 0.75623],
    46: [0, 0.10803, 0, 0, 0.27764],
    47: [0.24982, 0.74947, 0, 0, 0.50181],
    48: [0, 0.47534, 0, 0, 0.50181],
    49: [0, 0.47534, 0, 0, 0.50181],
    50: [0, 0.47534, 0, 0, 0.50181],
    51: [0.18906, 0.47534, 0, 0, 0.50181],
    52: [0.18906, 0.47534, 0, 0, 0.50181],
    53: [0.18906, 0.47534, 0, 0, 0.50181],
    54: [0, 0.69141, 0, 0, 0.50181],
    55: [0.18906, 0.47534, 0, 0, 0.50181],
    56: [0, 0.69141, 0, 0, 0.50181],
    57: [0.18906, 0.47534, 0, 0, 0.50181],
    58: [0, 0.47534, 0, 0, 0.21606],
    59: [0.12604, 0.47534, 0, 0, 0.21606],
    61: [-0.13099, 0.36866, 0, 0, 0.75623],
    63: [0, 0.69141, 0, 0, 0.36245],
    65: [0, 0.69141, 0, 0, 0.7176],
    66: [0, 0.69141, 0, 0, 0.88397],
    67: [0, 0.69141, 0, 0, 0.61254],
    68: [0, 0.69141, 0, 0, 0.83158],
    69: [0, 0.69141, 0, 0, 0.66278],
    70: [0.12604, 0.69141, 0, 0, 0.61119],
    71: [0, 0.69141, 0, 0, 0.78539],
    72: [0.06302, 0.69141, 0, 0, 0.7203],
    73: [0, 0.69141, 0, 0, 0.55448],
    74: [0.12604, 0.69141, 0, 0, 0.55231],
    75: [0, 0.69141, 0, 0, 0.66845],
    76: [0, 0.69141, 0, 0, 0.66602],
    77: [0, 0.69141, 0, 0, 1.04953],
    78: [0, 0.69141, 0, 0, 0.83212],
    79: [0, 0.69141, 0, 0, 0.82699],
    80: [0.18906, 0.69141, 0, 0, 0.82753],
    81: [0.03781, 0.69141, 0, 0, 0.82699],
    82: [0, 0.69141, 0, 0, 0.82807],
    83: [0, 0.69141, 0, 0, 0.82861],
    84: [0, 0.69141, 0, 0, 0.66899],
    85: [0, 0.69141, 0, 0, 0.64576],
    86: [0, 0.69141, 0, 0, 0.83131],
    87: [0, 0.69141, 0, 0, 1.04602],
    88: [0, 0.69141, 0, 0, 0.71922],
    89: [0.18906, 0.69141, 0, 0, 0.83293],
    90: [0.12604, 0.69141, 0, 0, 0.60201],
    91: [0.24982, 0.74947, 0, 0, 0.27764],
    93: [0.24982, 0.74947, 0, 0, 0.27764],
    94: [0, 0.69141, 0, 0, 0.49965],
    97: [0, 0.47534, 0, 0, 0.50046],
    98: [0, 0.69141, 0, 0, 0.51315],
    99: [0, 0.47534, 0, 0, 0.38946],
    100: [0, 0.62119, 0, 0, 0.49857],
    101: [0, 0.47534, 0, 0, 0.40053],
    102: [0.18906, 0.69141, 0, 0, 0.32626],
    103: [0.18906, 0.47534, 0, 0, 0.5037],
    104: [0.18906, 0.69141, 0, 0, 0.52126],
    105: [0, 0.69141, 0, 0, 0.27899],
    106: [0, 0.69141, 0, 0, 0.28088],
    107: [0, 0.69141, 0, 0, 0.38946],
    108: [0, 0.69141, 0, 0, 0.27953],
    109: [0, 0.47534, 0, 0, 0.76676],
    110: [0, 0.47534, 0, 0, 0.52666],
    111: [0, 0.47534, 0, 0, 0.48885],
    112: [0.18906, 0.52396, 0, 0, 0.50046],
    113: [0.18906, 0.47534, 0, 0, 0.48912],
    114: [0, 0.47534, 0, 0, 0.38919],
    115: [0, 0.47534, 0, 0, 0.44266],
    116: [0, 0.62119, 0, 0, 0.33301],
    117: [0, 0.47534, 0, 0, 0.5172],
    118: [0, 0.52396, 0, 0, 0.5118],
    119: [0, 0.52396, 0, 0, 0.77351],
    120: [0.18906, 0.47534, 0, 0, 0.38865],
    121: [0.18906, 0.47534, 0, 0, 0.49884],
    122: [0.18906, 0.47534, 0, 0, 0.39054],
    160: [0, 0, 0, 0, 0.25],
    8216: [0, 0.69141, 0, 0, 0.21471],
    8217: [0, 0.69141, 0, 0, 0.21471],
    58112: [0, 0.62119, 0, 0, 0.49749],
    58113: [0, 0.62119, 0, 0, 0.4983],
    58114: [0.18906, 0.69141, 0, 0, 0.33328],
    58115: [0.18906, 0.69141, 0, 0, 0.32923],
    58116: [0.18906, 0.47534, 0, 0, 0.50343],
    58117: [0, 0.69141, 0, 0, 0.33301],
    58118: [0, 0.62119, 0, 0, 0.33409],
    58119: [0, 0.47534, 0, 0, 0.50073]
  },
  "Main-Bold": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0, 0, 0.35],
    34: [0, 0.69444, 0, 0, 0.60278],
    35: [0.19444, 0.69444, 0, 0, 0.95833],
    36: [0.05556, 0.75, 0, 0, 0.575],
    37: [0.05556, 0.75, 0, 0, 0.95833],
    38: [0, 0.69444, 0, 0, 0.89444],
    39: [0, 0.69444, 0, 0, 0.31944],
    40: [0.25, 0.75, 0, 0, 0.44722],
    41: [0.25, 0.75, 0, 0, 0.44722],
    42: [0, 0.75, 0, 0, 0.575],
    43: [0.13333, 0.63333, 0, 0, 0.89444],
    44: [0.19444, 0.15556, 0, 0, 0.31944],
    45: [0, 0.44444, 0, 0, 0.38333],
    46: [0, 0.15556, 0, 0, 0.31944],
    47: [0.25, 0.75, 0, 0, 0.575],
    48: [0, 0.64444, 0, 0, 0.575],
    49: [0, 0.64444, 0, 0, 0.575],
    50: [0, 0.64444, 0, 0, 0.575],
    51: [0, 0.64444, 0, 0, 0.575],
    52: [0, 0.64444, 0, 0, 0.575],
    53: [0, 0.64444, 0, 0, 0.575],
    54: [0, 0.64444, 0, 0, 0.575],
    55: [0, 0.64444, 0, 0, 0.575],
    56: [0, 0.64444, 0, 0, 0.575],
    57: [0, 0.64444, 0, 0, 0.575],
    58: [0, 0.44444, 0, 0, 0.31944],
    59: [0.19444, 0.44444, 0, 0, 0.31944],
    60: [0.08556, 0.58556, 0, 0, 0.89444],
    61: [-0.10889, 0.39111, 0, 0, 0.89444],
    62: [0.08556, 0.58556, 0, 0, 0.89444],
    63: [0, 0.69444, 0, 0, 0.54305],
    64: [0, 0.69444, 0, 0, 0.89444],
    65: [0, 0.68611, 0, 0, 0.86944],
    66: [0, 0.68611, 0, 0, 0.81805],
    67: [0, 0.68611, 0, 0, 0.83055],
    68: [0, 0.68611, 0, 0, 0.88194],
    69: [0, 0.68611, 0, 0, 0.75555],
    70: [0, 0.68611, 0, 0, 0.72361],
    71: [0, 0.68611, 0, 0, 0.90416],
    72: [0, 0.68611, 0, 0, 0.9],
    73: [0, 0.68611, 0, 0, 0.43611],
    74: [0, 0.68611, 0, 0, 0.59444],
    75: [0, 0.68611, 0, 0, 0.90138],
    76: [0, 0.68611, 0, 0, 0.69166],
    77: [0, 0.68611, 0, 0, 1.09166],
    78: [0, 0.68611, 0, 0, 0.9],
    79: [0, 0.68611, 0, 0, 0.86388],
    80: [0, 0.68611, 0, 0, 0.78611],
    81: [0.19444, 0.68611, 0, 0, 0.86388],
    82: [0, 0.68611, 0, 0, 0.8625],
    83: [0, 0.68611, 0, 0, 0.63889],
    84: [0, 0.68611, 0, 0, 0.8],
    85: [0, 0.68611, 0, 0, 0.88472],
    86: [0, 0.68611, 0.01597, 0, 0.86944],
    87: [0, 0.68611, 0.01597, 0, 1.18888],
    88: [0, 0.68611, 0, 0, 0.86944],
    89: [0, 0.68611, 0.02875, 0, 0.86944],
    90: [0, 0.68611, 0, 0, 0.70277],
    91: [0.25, 0.75, 0, 0, 0.31944],
    92: [0.25, 0.75, 0, 0, 0.575],
    93: [0.25, 0.75, 0, 0, 0.31944],
    94: [0, 0.69444, 0, 0, 0.575],
    95: [0.31, 0.13444, 0.03194, 0, 0.575],
    97: [0, 0.44444, 0, 0, 0.55902],
    98: [0, 0.69444, 0, 0, 0.63889],
    99: [0, 0.44444, 0, 0, 0.51111],
    100: [0, 0.69444, 0, 0, 0.63889],
    101: [0, 0.44444, 0, 0, 0.52708],
    102: [0, 0.69444, 0.10903, 0, 0.35139],
    103: [0.19444, 0.44444, 0.01597, 0, 0.575],
    104: [0, 0.69444, 0, 0, 0.63889],
    105: [0, 0.69444, 0, 0, 0.31944],
    106: [0.19444, 0.69444, 0, 0, 0.35139],
    107: [0, 0.69444, 0, 0, 0.60694],
    108: [0, 0.69444, 0, 0, 0.31944],
    109: [0, 0.44444, 0, 0, 0.95833],
    110: [0, 0.44444, 0, 0, 0.63889],
    111: [0, 0.44444, 0, 0, 0.575],
    112: [0.19444, 0.44444, 0, 0, 0.63889],
    113: [0.19444, 0.44444, 0, 0, 0.60694],
    114: [0, 0.44444, 0, 0, 0.47361],
    115: [0, 0.44444, 0, 0, 0.45361],
    116: [0, 0.63492, 0, 0, 0.44722],
    117: [0, 0.44444, 0, 0, 0.63889],
    118: [0, 0.44444, 0.01597, 0, 0.60694],
    119: [0, 0.44444, 0.01597, 0, 0.83055],
    120: [0, 0.44444, 0, 0, 0.60694],
    121: [0.19444, 0.44444, 0.01597, 0, 0.60694],
    122: [0, 0.44444, 0, 0, 0.51111],
    123: [0.25, 0.75, 0, 0, 0.575],
    124: [0.25, 0.75, 0, 0, 0.31944],
    125: [0.25, 0.75, 0, 0, 0.575],
    126: [0.35, 0.34444, 0, 0, 0.575],
    160: [0, 0, 0, 0, 0.25],
    163: [0, 0.69444, 0, 0, 0.86853],
    168: [0, 0.69444, 0, 0, 0.575],
    172: [0, 0.44444, 0, 0, 0.76666],
    176: [0, 0.69444, 0, 0, 0.86944],
    177: [0.13333, 0.63333, 0, 0, 0.89444],
    184: [0.17014, 0, 0, 0, 0.51111],
    198: [0, 0.68611, 0, 0, 1.04166],
    215: [0.13333, 0.63333, 0, 0, 0.89444],
    216: [0.04861, 0.73472, 0, 0, 0.89444],
    223: [0, 0.69444, 0, 0, 0.59722],
    230: [0, 0.44444, 0, 0, 0.83055],
    247: [0.13333, 0.63333, 0, 0, 0.89444],
    248: [0.09722, 0.54167, 0, 0, 0.575],
    305: [0, 0.44444, 0, 0, 0.31944],
    338: [0, 0.68611, 0, 0, 1.16944],
    339: [0, 0.44444, 0, 0, 0.89444],
    567: [0.19444, 0.44444, 0, 0, 0.35139],
    710: [0, 0.69444, 0, 0, 0.575],
    711: [0, 0.63194, 0, 0, 0.575],
    713: [0, 0.59611, 0, 0, 0.575],
    714: [0, 0.69444, 0, 0, 0.575],
    715: [0, 0.69444, 0, 0, 0.575],
    728: [0, 0.69444, 0, 0, 0.575],
    729: [0, 0.69444, 0, 0, 0.31944],
    730: [0, 0.69444, 0, 0, 0.86944],
    732: [0, 0.69444, 0, 0, 0.575],
    733: [0, 0.69444, 0, 0, 0.575],
    915: [0, 0.68611, 0, 0, 0.69166],
    916: [0, 0.68611, 0, 0, 0.95833],
    920: [0, 0.68611, 0, 0, 0.89444],
    923: [0, 0.68611, 0, 0, 0.80555],
    926: [0, 0.68611, 0, 0, 0.76666],
    928: [0, 0.68611, 0, 0, 0.9],
    931: [0, 0.68611, 0, 0, 0.83055],
    933: [0, 0.68611, 0, 0, 0.89444],
    934: [0, 0.68611, 0, 0, 0.83055],
    936: [0, 0.68611, 0, 0, 0.89444],
    937: [0, 0.68611, 0, 0, 0.83055],
    8211: [0, 0.44444, 0.03194, 0, 0.575],
    8212: [0, 0.44444, 0.03194, 0, 1.14999],
    8216: [0, 0.69444, 0, 0, 0.31944],
    8217: [0, 0.69444, 0, 0, 0.31944],
    8220: [0, 0.69444, 0, 0, 0.60278],
    8221: [0, 0.69444, 0, 0, 0.60278],
    8224: [0.19444, 0.69444, 0, 0, 0.51111],
    8225: [0.19444, 0.69444, 0, 0, 0.51111],
    8242: [0, 0.55556, 0, 0, 0.34444],
    8407: [0, 0.72444, 0.15486, 0, 0.575],
    8463: [0, 0.69444, 0, 0, 0.66759],
    8465: [0, 0.69444, 0, 0, 0.83055],
    8467: [0, 0.69444, 0, 0, 0.47361],
    8472: [0.19444, 0.44444, 0, 0, 0.74027],
    8476: [0, 0.69444, 0, 0, 0.83055],
    8501: [0, 0.69444, 0, 0, 0.70277],
    8592: [-0.10889, 0.39111, 0, 0, 1.14999],
    8593: [0.19444, 0.69444, 0, 0, 0.575],
    8594: [-0.10889, 0.39111, 0, 0, 1.14999],
    8595: [0.19444, 0.69444, 0, 0, 0.575],
    8596: [-0.10889, 0.39111, 0, 0, 1.14999],
    8597: [0.25, 0.75, 0, 0, 0.575],
    8598: [0.19444, 0.69444, 0, 0, 1.14999],
    8599: [0.19444, 0.69444, 0, 0, 1.14999],
    8600: [0.19444, 0.69444, 0, 0, 1.14999],
    8601: [0.19444, 0.69444, 0, 0, 1.14999],
    8636: [-0.10889, 0.39111, 0, 0, 1.14999],
    8637: [-0.10889, 0.39111, 0, 0, 1.14999],
    8640: [-0.10889, 0.39111, 0, 0, 1.14999],
    8641: [-0.10889, 0.39111, 0, 0, 1.14999],
    8656: [-0.10889, 0.39111, 0, 0, 1.14999],
    8657: [0.19444, 0.69444, 0, 0, 0.70277],
    8658: [-0.10889, 0.39111, 0, 0, 1.14999],
    8659: [0.19444, 0.69444, 0, 0, 0.70277],
    8660: [-0.10889, 0.39111, 0, 0, 1.14999],
    8661: [0.25, 0.75, 0, 0, 0.70277],
    8704: [0, 0.69444, 0, 0, 0.63889],
    8706: [0, 0.69444, 0.06389, 0, 0.62847],
    8707: [0, 0.69444, 0, 0, 0.63889],
    8709: [0.05556, 0.75, 0, 0, 0.575],
    8711: [0, 0.68611, 0, 0, 0.95833],
    8712: [0.08556, 0.58556, 0, 0, 0.76666],
    8715: [0.08556, 0.58556, 0, 0, 0.76666],
    8722: [0.13333, 0.63333, 0, 0, 0.89444],
    8723: [0.13333, 0.63333, 0, 0, 0.89444],
    8725: [0.25, 0.75, 0, 0, 0.575],
    8726: [0.25, 0.75, 0, 0, 0.575],
    8727: [-0.02778, 0.47222, 0, 0, 0.575],
    8728: [-0.02639, 0.47361, 0, 0, 0.575],
    8729: [-0.02639, 0.47361, 0, 0, 0.575],
    8730: [0.18, 0.82, 0, 0, 0.95833],
    8733: [0, 0.44444, 0, 0, 0.89444],
    8734: [0, 0.44444, 0, 0, 1.14999],
    8736: [0, 0.69224, 0, 0, 0.72222],
    8739: [0.25, 0.75, 0, 0, 0.31944],
    8741: [0.25, 0.75, 0, 0, 0.575],
    8743: [0, 0.55556, 0, 0, 0.76666],
    8744: [0, 0.55556, 0, 0, 0.76666],
    8745: [0, 0.55556, 0, 0, 0.76666],
    8746: [0, 0.55556, 0, 0, 0.76666],
    8747: [0.19444, 0.69444, 0.12778, 0, 0.56875],
    8764: [-0.10889, 0.39111, 0, 0, 0.89444],
    8768: [0.19444, 0.69444, 0, 0, 0.31944],
    8771: [222e-5, 0.50222, 0, 0, 0.89444],
    8773: [0.027, 0.638, 0, 0, 0.894],
    8776: [0.02444, 0.52444, 0, 0, 0.89444],
    8781: [222e-5, 0.50222, 0, 0, 0.89444],
    8801: [222e-5, 0.50222, 0, 0, 0.89444],
    8804: [0.19667, 0.69667, 0, 0, 0.89444],
    8805: [0.19667, 0.69667, 0, 0, 0.89444],
    8810: [0.08556, 0.58556, 0, 0, 1.14999],
    8811: [0.08556, 0.58556, 0, 0, 1.14999],
    8826: [0.08556, 0.58556, 0, 0, 0.89444],
    8827: [0.08556, 0.58556, 0, 0, 0.89444],
    8834: [0.08556, 0.58556, 0, 0, 0.89444],
    8835: [0.08556, 0.58556, 0, 0, 0.89444],
    8838: [0.19667, 0.69667, 0, 0, 0.89444],
    8839: [0.19667, 0.69667, 0, 0, 0.89444],
    8846: [0, 0.55556, 0, 0, 0.76666],
    8849: [0.19667, 0.69667, 0, 0, 0.89444],
    8850: [0.19667, 0.69667, 0, 0, 0.89444],
    8851: [0, 0.55556, 0, 0, 0.76666],
    8852: [0, 0.55556, 0, 0, 0.76666],
    8853: [0.13333, 0.63333, 0, 0, 0.89444],
    8854: [0.13333, 0.63333, 0, 0, 0.89444],
    8855: [0.13333, 0.63333, 0, 0, 0.89444],
    8856: [0.13333, 0.63333, 0, 0, 0.89444],
    8857: [0.13333, 0.63333, 0, 0, 0.89444],
    8866: [0, 0.69444, 0, 0, 0.70277],
    8867: [0, 0.69444, 0, 0, 0.70277],
    8868: [0, 0.69444, 0, 0, 0.89444],
    8869: [0, 0.69444, 0, 0, 0.89444],
    8900: [-0.02639, 0.47361, 0, 0, 0.575],
    8901: [-0.02639, 0.47361, 0, 0, 0.31944],
    8902: [-0.02778, 0.47222, 0, 0, 0.575],
    8968: [0.25, 0.75, 0, 0, 0.51111],
    8969: [0.25, 0.75, 0, 0, 0.51111],
    8970: [0.25, 0.75, 0, 0, 0.51111],
    8971: [0.25, 0.75, 0, 0, 0.51111],
    8994: [-0.13889, 0.36111, 0, 0, 1.14999],
    8995: [-0.13889, 0.36111, 0, 0, 1.14999],
    9651: [0.19444, 0.69444, 0, 0, 1.02222],
    9657: [-0.02778, 0.47222, 0, 0, 0.575],
    9661: [0.19444, 0.69444, 0, 0, 1.02222],
    9667: [-0.02778, 0.47222, 0, 0, 0.575],
    9711: [0.19444, 0.69444, 0, 0, 1.14999],
    9824: [0.12963, 0.69444, 0, 0, 0.89444],
    9825: [0.12963, 0.69444, 0, 0, 0.89444],
    9826: [0.12963, 0.69444, 0, 0, 0.89444],
    9827: [0.12963, 0.69444, 0, 0, 0.89444],
    9837: [0, 0.75, 0, 0, 0.44722],
    9838: [0.19444, 0.69444, 0, 0, 0.44722],
    9839: [0.19444, 0.69444, 0, 0, 0.44722],
    10216: [0.25, 0.75, 0, 0, 0.44722],
    10217: [0.25, 0.75, 0, 0, 0.44722],
    10815: [0, 0.68611, 0, 0, 0.9],
    10927: [0.19667, 0.69667, 0, 0, 0.89444],
    10928: [0.19667, 0.69667, 0, 0, 0.89444],
    57376: [0.19444, 0.69444, 0, 0, 0]
  },
  "Main-BoldItalic": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0.11417, 0, 0.38611],
    34: [0, 0.69444, 0.07939, 0, 0.62055],
    35: [0.19444, 0.69444, 0.06833, 0, 0.94444],
    37: [0.05556, 0.75, 0.12861, 0, 0.94444],
    38: [0, 0.69444, 0.08528, 0, 0.88555],
    39: [0, 0.69444, 0.12945, 0, 0.35555],
    40: [0.25, 0.75, 0.15806, 0, 0.47333],
    41: [0.25, 0.75, 0.03306, 0, 0.47333],
    42: [0, 0.75, 0.14333, 0, 0.59111],
    43: [0.10333, 0.60333, 0.03306, 0, 0.88555],
    44: [0.19444, 0.14722, 0, 0, 0.35555],
    45: [0, 0.44444, 0.02611, 0, 0.41444],
    46: [0, 0.14722, 0, 0, 0.35555],
    47: [0.25, 0.75, 0.15806, 0, 0.59111],
    48: [0, 0.64444, 0.13167, 0, 0.59111],
    49: [0, 0.64444, 0.13167, 0, 0.59111],
    50: [0, 0.64444, 0.13167, 0, 0.59111],
    51: [0, 0.64444, 0.13167, 0, 0.59111],
    52: [0.19444, 0.64444, 0.13167, 0, 0.59111],
    53: [0, 0.64444, 0.13167, 0, 0.59111],
    54: [0, 0.64444, 0.13167, 0, 0.59111],
    55: [0.19444, 0.64444, 0.13167, 0, 0.59111],
    56: [0, 0.64444, 0.13167, 0, 0.59111],
    57: [0, 0.64444, 0.13167, 0, 0.59111],
    58: [0, 0.44444, 0.06695, 0, 0.35555],
    59: [0.19444, 0.44444, 0.06695, 0, 0.35555],
    61: [-0.10889, 0.39111, 0.06833, 0, 0.88555],
    63: [0, 0.69444, 0.11472, 0, 0.59111],
    64: [0, 0.69444, 0.09208, 0, 0.88555],
    65: [0, 0.68611, 0, 0, 0.86555],
    66: [0, 0.68611, 0.0992, 0, 0.81666],
    67: [0, 0.68611, 0.14208, 0, 0.82666],
    68: [0, 0.68611, 0.09062, 0, 0.87555],
    69: [0, 0.68611, 0.11431, 0, 0.75666],
    70: [0, 0.68611, 0.12903, 0, 0.72722],
    71: [0, 0.68611, 0.07347, 0, 0.89527],
    72: [0, 0.68611, 0.17208, 0, 0.8961],
    73: [0, 0.68611, 0.15681, 0, 0.47166],
    74: [0, 0.68611, 0.145, 0, 0.61055],
    75: [0, 0.68611, 0.14208, 0, 0.89499],
    76: [0, 0.68611, 0, 0, 0.69777],
    77: [0, 0.68611, 0.17208, 0, 1.07277],
    78: [0, 0.68611, 0.17208, 0, 0.8961],
    79: [0, 0.68611, 0.09062, 0, 0.85499],
    80: [0, 0.68611, 0.0992, 0, 0.78721],
    81: [0.19444, 0.68611, 0.09062, 0, 0.85499],
    82: [0, 0.68611, 0.02559, 0, 0.85944],
    83: [0, 0.68611, 0.11264, 0, 0.64999],
    84: [0, 0.68611, 0.12903, 0, 0.7961],
    85: [0, 0.68611, 0.17208, 0, 0.88083],
    86: [0, 0.68611, 0.18625, 0, 0.86555],
    87: [0, 0.68611, 0.18625, 0, 1.15999],
    88: [0, 0.68611, 0.15681, 0, 0.86555],
    89: [0, 0.68611, 0.19803, 0, 0.86555],
    90: [0, 0.68611, 0.14208, 0, 0.70888],
    91: [0.25, 0.75, 0.1875, 0, 0.35611],
    93: [0.25, 0.75, 0.09972, 0, 0.35611],
    94: [0, 0.69444, 0.06709, 0, 0.59111],
    95: [0.31, 0.13444, 0.09811, 0, 0.59111],
    97: [0, 0.44444, 0.09426, 0, 0.59111],
    98: [0, 0.69444, 0.07861, 0, 0.53222],
    99: [0, 0.44444, 0.05222, 0, 0.53222],
    100: [0, 0.69444, 0.10861, 0, 0.59111],
    101: [0, 0.44444, 0.085, 0, 0.53222],
    102: [0.19444, 0.69444, 0.21778, 0, 0.4],
    103: [0.19444, 0.44444, 0.105, 0, 0.53222],
    104: [0, 0.69444, 0.09426, 0, 0.59111],
    105: [0, 0.69326, 0.11387, 0, 0.35555],
    106: [0.19444, 0.69326, 0.1672, 0, 0.35555],
    107: [0, 0.69444, 0.11111, 0, 0.53222],
    108: [0, 0.69444, 0.10861, 0, 0.29666],
    109: [0, 0.44444, 0.09426, 0, 0.94444],
    110: [0, 0.44444, 0.09426, 0, 0.64999],
    111: [0, 0.44444, 0.07861, 0, 0.59111],
    112: [0.19444, 0.44444, 0.07861, 0, 0.59111],
    113: [0.19444, 0.44444, 0.105, 0, 0.53222],
    114: [0, 0.44444, 0.11111, 0, 0.50167],
    115: [0, 0.44444, 0.08167, 0, 0.48694],
    116: [0, 0.63492, 0.09639, 0, 0.385],
    117: [0, 0.44444, 0.09426, 0, 0.62055],
    118: [0, 0.44444, 0.11111, 0, 0.53222],
    119: [0, 0.44444, 0.11111, 0, 0.76777],
    120: [0, 0.44444, 0.12583, 0, 0.56055],
    121: [0.19444, 0.44444, 0.105, 0, 0.56166],
    122: [0, 0.44444, 0.13889, 0, 0.49055],
    126: [0.35, 0.34444, 0.11472, 0, 0.59111],
    160: [0, 0, 0, 0, 0.25],
    168: [0, 0.69444, 0.11473, 0, 0.59111],
    176: [0, 0.69444, 0, 0, 0.94888],
    184: [0.17014, 0, 0, 0, 0.53222],
    198: [0, 0.68611, 0.11431, 0, 1.02277],
    216: [0.04861, 0.73472, 0.09062, 0, 0.88555],
    223: [0.19444, 0.69444, 0.09736, 0, 0.665],
    230: [0, 0.44444, 0.085, 0, 0.82666],
    248: [0.09722, 0.54167, 0.09458, 0, 0.59111],
    305: [0, 0.44444, 0.09426, 0, 0.35555],
    338: [0, 0.68611, 0.11431, 0, 1.14054],
    339: [0, 0.44444, 0.085, 0, 0.82666],
    567: [0.19444, 0.44444, 0.04611, 0, 0.385],
    710: [0, 0.69444, 0.06709, 0, 0.59111],
    711: [0, 0.63194, 0.08271, 0, 0.59111],
    713: [0, 0.59444, 0.10444, 0, 0.59111],
    714: [0, 0.69444, 0.08528, 0, 0.59111],
    715: [0, 0.69444, 0, 0, 0.59111],
    728: [0, 0.69444, 0.10333, 0, 0.59111],
    729: [0, 0.69444, 0.12945, 0, 0.35555],
    730: [0, 0.69444, 0, 0, 0.94888],
    732: [0, 0.69444, 0.11472, 0, 0.59111],
    733: [0, 0.69444, 0.11472, 0, 0.59111],
    915: [0, 0.68611, 0.12903, 0, 0.69777],
    916: [0, 0.68611, 0, 0, 0.94444],
    920: [0, 0.68611, 0.09062, 0, 0.88555],
    923: [0, 0.68611, 0, 0, 0.80666],
    926: [0, 0.68611, 0.15092, 0, 0.76777],
    928: [0, 0.68611, 0.17208, 0, 0.8961],
    931: [0, 0.68611, 0.11431, 0, 0.82666],
    933: [0, 0.68611, 0.10778, 0, 0.88555],
    934: [0, 0.68611, 0.05632, 0, 0.82666],
    936: [0, 0.68611, 0.10778, 0, 0.88555],
    937: [0, 0.68611, 0.0992, 0, 0.82666],
    8211: [0, 0.44444, 0.09811, 0, 0.59111],
    8212: [0, 0.44444, 0.09811, 0, 1.18221],
    8216: [0, 0.69444, 0.12945, 0, 0.35555],
    8217: [0, 0.69444, 0.12945, 0, 0.35555],
    8220: [0, 0.69444, 0.16772, 0, 0.62055],
    8221: [0, 0.69444, 0.07939, 0, 0.62055]
  },
  "Main-Italic": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0.12417, 0, 0.30667],
    34: [0, 0.69444, 0.06961, 0, 0.51444],
    35: [0.19444, 0.69444, 0.06616, 0, 0.81777],
    37: [0.05556, 0.75, 0.13639, 0, 0.81777],
    38: [0, 0.69444, 0.09694, 0, 0.76666],
    39: [0, 0.69444, 0.12417, 0, 0.30667],
    40: [0.25, 0.75, 0.16194, 0, 0.40889],
    41: [0.25, 0.75, 0.03694, 0, 0.40889],
    42: [0, 0.75, 0.14917, 0, 0.51111],
    43: [0.05667, 0.56167, 0.03694, 0, 0.76666],
    44: [0.19444, 0.10556, 0, 0, 0.30667],
    45: [0, 0.43056, 0.02826, 0, 0.35778],
    46: [0, 0.10556, 0, 0, 0.30667],
    47: [0.25, 0.75, 0.16194, 0, 0.51111],
    48: [0, 0.64444, 0.13556, 0, 0.51111],
    49: [0, 0.64444, 0.13556, 0, 0.51111],
    50: [0, 0.64444, 0.13556, 0, 0.51111],
    51: [0, 0.64444, 0.13556, 0, 0.51111],
    52: [0.19444, 0.64444, 0.13556, 0, 0.51111],
    53: [0, 0.64444, 0.13556, 0, 0.51111],
    54: [0, 0.64444, 0.13556, 0, 0.51111],
    55: [0.19444, 0.64444, 0.13556, 0, 0.51111],
    56: [0, 0.64444, 0.13556, 0, 0.51111],
    57: [0, 0.64444, 0.13556, 0, 0.51111],
    58: [0, 0.43056, 0.0582, 0, 0.30667],
    59: [0.19444, 0.43056, 0.0582, 0, 0.30667],
    61: [-0.13313, 0.36687, 0.06616, 0, 0.76666],
    63: [0, 0.69444, 0.1225, 0, 0.51111],
    64: [0, 0.69444, 0.09597, 0, 0.76666],
    65: [0, 0.68333, 0, 0, 0.74333],
    66: [0, 0.68333, 0.10257, 0, 0.70389],
    67: [0, 0.68333, 0.14528, 0, 0.71555],
    68: [0, 0.68333, 0.09403, 0, 0.755],
    69: [0, 0.68333, 0.12028, 0, 0.67833],
    70: [0, 0.68333, 0.13305, 0, 0.65277],
    71: [0, 0.68333, 0.08722, 0, 0.77361],
    72: [0, 0.68333, 0.16389, 0, 0.74333],
    73: [0, 0.68333, 0.15806, 0, 0.38555],
    74: [0, 0.68333, 0.14028, 0, 0.525],
    75: [0, 0.68333, 0.14528, 0, 0.76888],
    76: [0, 0.68333, 0, 0, 0.62722],
    77: [0, 0.68333, 0.16389, 0, 0.89666],
    78: [0, 0.68333, 0.16389, 0, 0.74333],
    79: [0, 0.68333, 0.09403, 0, 0.76666],
    80: [0, 0.68333, 0.10257, 0, 0.67833],
    81: [0.19444, 0.68333, 0.09403, 0, 0.76666],
    82: [0, 0.68333, 0.03868, 0, 0.72944],
    83: [0, 0.68333, 0.11972, 0, 0.56222],
    84: [0, 0.68333, 0.13305, 0, 0.71555],
    85: [0, 0.68333, 0.16389, 0, 0.74333],
    86: [0, 0.68333, 0.18361, 0, 0.74333],
    87: [0, 0.68333, 0.18361, 0, 0.99888],
    88: [0, 0.68333, 0.15806, 0, 0.74333],
    89: [0, 0.68333, 0.19383, 0, 0.74333],
    90: [0, 0.68333, 0.14528, 0, 0.61333],
    91: [0.25, 0.75, 0.1875, 0, 0.30667],
    93: [0.25, 0.75, 0.10528, 0, 0.30667],
    94: [0, 0.69444, 0.06646, 0, 0.51111],
    95: [0.31, 0.12056, 0.09208, 0, 0.51111],
    97: [0, 0.43056, 0.07671, 0, 0.51111],
    98: [0, 0.69444, 0.06312, 0, 0.46],
    99: [0, 0.43056, 0.05653, 0, 0.46],
    100: [0, 0.69444, 0.10333, 0, 0.51111],
    101: [0, 0.43056, 0.07514, 0, 0.46],
    102: [0.19444, 0.69444, 0.21194, 0, 0.30667],
    103: [0.19444, 0.43056, 0.08847, 0, 0.46],
    104: [0, 0.69444, 0.07671, 0, 0.51111],
    105: [0, 0.65536, 0.1019, 0, 0.30667],
    106: [0.19444, 0.65536, 0.14467, 0, 0.30667],
    107: [0, 0.69444, 0.10764, 0, 0.46],
    108: [0, 0.69444, 0.10333, 0, 0.25555],
    109: [0, 0.43056, 0.07671, 0, 0.81777],
    110: [0, 0.43056, 0.07671, 0, 0.56222],
    111: [0, 0.43056, 0.06312, 0, 0.51111],
    112: [0.19444, 0.43056, 0.06312, 0, 0.51111],
    113: [0.19444, 0.43056, 0.08847, 0, 0.46],
    114: [0, 0.43056, 0.10764, 0, 0.42166],
    115: [0, 0.43056, 0.08208, 0, 0.40889],
    116: [0, 0.61508, 0.09486, 0, 0.33222],
    117: [0, 0.43056, 0.07671, 0, 0.53666],
    118: [0, 0.43056, 0.10764, 0, 0.46],
    119: [0, 0.43056, 0.10764, 0, 0.66444],
    120: [0, 0.43056, 0.12042, 0, 0.46389],
    121: [0.19444, 0.43056, 0.08847, 0, 0.48555],
    122: [0, 0.43056, 0.12292, 0, 0.40889],
    126: [0.35, 0.31786, 0.11585, 0, 0.51111],
    160: [0, 0, 0, 0, 0.25],
    168: [0, 0.66786, 0.10474, 0, 0.51111],
    176: [0, 0.69444, 0, 0, 0.83129],
    184: [0.17014, 0, 0, 0, 0.46],
    198: [0, 0.68333, 0.12028, 0, 0.88277],
    216: [0.04861, 0.73194, 0.09403, 0, 0.76666],
    223: [0.19444, 0.69444, 0.10514, 0, 0.53666],
    230: [0, 0.43056, 0.07514, 0, 0.71555],
    248: [0.09722, 0.52778, 0.09194, 0, 0.51111],
    338: [0, 0.68333, 0.12028, 0, 0.98499],
    339: [0, 0.43056, 0.07514, 0, 0.71555],
    710: [0, 0.69444, 0.06646, 0, 0.51111],
    711: [0, 0.62847, 0.08295, 0, 0.51111],
    713: [0, 0.56167, 0.10333, 0, 0.51111],
    714: [0, 0.69444, 0.09694, 0, 0.51111],
    715: [0, 0.69444, 0, 0, 0.51111],
    728: [0, 0.69444, 0.10806, 0, 0.51111],
    729: [0, 0.66786, 0.11752, 0, 0.30667],
    730: [0, 0.69444, 0, 0, 0.83129],
    732: [0, 0.66786, 0.11585, 0, 0.51111],
    733: [0, 0.69444, 0.1225, 0, 0.51111],
    915: [0, 0.68333, 0.13305, 0, 0.62722],
    916: [0, 0.68333, 0, 0, 0.81777],
    920: [0, 0.68333, 0.09403, 0, 0.76666],
    923: [0, 0.68333, 0, 0, 0.69222],
    926: [0, 0.68333, 0.15294, 0, 0.66444],
    928: [0, 0.68333, 0.16389, 0, 0.74333],
    931: [0, 0.68333, 0.12028, 0, 0.71555],
    933: [0, 0.68333, 0.11111, 0, 0.76666],
    934: [0, 0.68333, 0.05986, 0, 0.71555],
    936: [0, 0.68333, 0.11111, 0, 0.76666],
    937: [0, 0.68333, 0.10257, 0, 0.71555],
    8211: [0, 0.43056, 0.09208, 0, 0.51111],
    8212: [0, 0.43056, 0.09208, 0, 1.02222],
    8216: [0, 0.69444, 0.12417, 0, 0.30667],
    8217: [0, 0.69444, 0.12417, 0, 0.30667],
    8220: [0, 0.69444, 0.1685, 0, 0.51444],
    8221: [0, 0.69444, 0.06961, 0, 0.51444],
    8463: [0, 0.68889, 0, 0, 0.54028]
  },
  "Main-Regular": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0, 0, 0.27778],
    34: [0, 0.69444, 0, 0, 0.5],
    35: [0.19444, 0.69444, 0, 0, 0.83334],
    36: [0.05556, 0.75, 0, 0, 0.5],
    37: [0.05556, 0.75, 0, 0, 0.83334],
    38: [0, 0.69444, 0, 0, 0.77778],
    39: [0, 0.69444, 0, 0, 0.27778],
    40: [0.25, 0.75, 0, 0, 0.38889],
    41: [0.25, 0.75, 0, 0, 0.38889],
    42: [0, 0.75, 0, 0, 0.5],
    43: [0.08333, 0.58333, 0, 0, 0.77778],
    44: [0.19444, 0.10556, 0, 0, 0.27778],
    45: [0, 0.43056, 0, 0, 0.33333],
    46: [0, 0.10556, 0, 0, 0.27778],
    47: [0.25, 0.75, 0, 0, 0.5],
    48: [0, 0.64444, 0, 0, 0.5],
    49: [0, 0.64444, 0, 0, 0.5],
    50: [0, 0.64444, 0, 0, 0.5],
    51: [0, 0.64444, 0, 0, 0.5],
    52: [0, 0.64444, 0, 0, 0.5],
    53: [0, 0.64444, 0, 0, 0.5],
    54: [0, 0.64444, 0, 0, 0.5],
    55: [0, 0.64444, 0, 0, 0.5],
    56: [0, 0.64444, 0, 0, 0.5],
    57: [0, 0.64444, 0, 0, 0.5],
    58: [0, 0.43056, 0, 0, 0.27778],
    59: [0.19444, 0.43056, 0, 0, 0.27778],
    60: [0.0391, 0.5391, 0, 0, 0.77778],
    61: [-0.13313, 0.36687, 0, 0, 0.77778],
    62: [0.0391, 0.5391, 0, 0, 0.77778],
    63: [0, 0.69444, 0, 0, 0.47222],
    64: [0, 0.69444, 0, 0, 0.77778],
    65: [0, 0.68333, 0, 0, 0.75],
    66: [0, 0.68333, 0, 0, 0.70834],
    67: [0, 0.68333, 0, 0, 0.72222],
    68: [0, 0.68333, 0, 0, 0.76389],
    69: [0, 0.68333, 0, 0, 0.68056],
    70: [0, 0.68333, 0, 0, 0.65278],
    71: [0, 0.68333, 0, 0, 0.78472],
    72: [0, 0.68333, 0, 0, 0.75],
    73: [0, 0.68333, 0, 0, 0.36111],
    74: [0, 0.68333, 0, 0, 0.51389],
    75: [0, 0.68333, 0, 0, 0.77778],
    76: [0, 0.68333, 0, 0, 0.625],
    77: [0, 0.68333, 0, 0, 0.91667],
    78: [0, 0.68333, 0, 0, 0.75],
    79: [0, 0.68333, 0, 0, 0.77778],
    80: [0, 0.68333, 0, 0, 0.68056],
    81: [0.19444, 0.68333, 0, 0, 0.77778],
    82: [0, 0.68333, 0, 0, 0.73611],
    83: [0, 0.68333, 0, 0, 0.55556],
    84: [0, 0.68333, 0, 0, 0.72222],
    85: [0, 0.68333, 0, 0, 0.75],
    86: [0, 0.68333, 0.01389, 0, 0.75],
    87: [0, 0.68333, 0.01389, 0, 1.02778],
    88: [0, 0.68333, 0, 0, 0.75],
    89: [0, 0.68333, 0.025, 0, 0.75],
    90: [0, 0.68333, 0, 0, 0.61111],
    91: [0.25, 0.75, 0, 0, 0.27778],
    92: [0.25, 0.75, 0, 0, 0.5],
    93: [0.25, 0.75, 0, 0, 0.27778],
    94: [0, 0.69444, 0, 0, 0.5],
    95: [0.31, 0.12056, 0.02778, 0, 0.5],
    97: [0, 0.43056, 0, 0, 0.5],
    98: [0, 0.69444, 0, 0, 0.55556],
    99: [0, 0.43056, 0, 0, 0.44445],
    100: [0, 0.69444, 0, 0, 0.55556],
    101: [0, 0.43056, 0, 0, 0.44445],
    102: [0, 0.69444, 0.07778, 0, 0.30556],
    103: [0.19444, 0.43056, 0.01389, 0, 0.5],
    104: [0, 0.69444, 0, 0, 0.55556],
    105: [0, 0.66786, 0, 0, 0.27778],
    106: [0.19444, 0.66786, 0, 0, 0.30556],
    107: [0, 0.69444, 0, 0, 0.52778],
    108: [0, 0.69444, 0, 0, 0.27778],
    109: [0, 0.43056, 0, 0, 0.83334],
    110: [0, 0.43056, 0, 0, 0.55556],
    111: [0, 0.43056, 0, 0, 0.5],
    112: [0.19444, 0.43056, 0, 0, 0.55556],
    113: [0.19444, 0.43056, 0, 0, 0.52778],
    114: [0, 0.43056, 0, 0, 0.39167],
    115: [0, 0.43056, 0, 0, 0.39445],
    116: [0, 0.61508, 0, 0, 0.38889],
    117: [0, 0.43056, 0, 0, 0.55556],
    118: [0, 0.43056, 0.01389, 0, 0.52778],
    119: [0, 0.43056, 0.01389, 0, 0.72222],
    120: [0, 0.43056, 0, 0, 0.52778],
    121: [0.19444, 0.43056, 0.01389, 0, 0.52778],
    122: [0, 0.43056, 0, 0, 0.44445],
    123: [0.25, 0.75, 0, 0, 0.5],
    124: [0.25, 0.75, 0, 0, 0.27778],
    125: [0.25, 0.75, 0, 0, 0.5],
    126: [0.35, 0.31786, 0, 0, 0.5],
    160: [0, 0, 0, 0, 0.25],
    163: [0, 0.69444, 0, 0, 0.76909],
    167: [0.19444, 0.69444, 0, 0, 0.44445],
    168: [0, 0.66786, 0, 0, 0.5],
    172: [0, 0.43056, 0, 0, 0.66667],
    176: [0, 0.69444, 0, 0, 0.75],
    177: [0.08333, 0.58333, 0, 0, 0.77778],
    182: [0.19444, 0.69444, 0, 0, 0.61111],
    184: [0.17014, 0, 0, 0, 0.44445],
    198: [0, 0.68333, 0, 0, 0.90278],
    215: [0.08333, 0.58333, 0, 0, 0.77778],
    216: [0.04861, 0.73194, 0, 0, 0.77778],
    223: [0, 0.69444, 0, 0, 0.5],
    230: [0, 0.43056, 0, 0, 0.72222],
    247: [0.08333, 0.58333, 0, 0, 0.77778],
    248: [0.09722, 0.52778, 0, 0, 0.5],
    305: [0, 0.43056, 0, 0, 0.27778],
    338: [0, 0.68333, 0, 0, 1.01389],
    339: [0, 0.43056, 0, 0, 0.77778],
    567: [0.19444, 0.43056, 0, 0, 0.30556],
    710: [0, 0.69444, 0, 0, 0.5],
    711: [0, 0.62847, 0, 0, 0.5],
    713: [0, 0.56778, 0, 0, 0.5],
    714: [0, 0.69444, 0, 0, 0.5],
    715: [0, 0.69444, 0, 0, 0.5],
    728: [0, 0.69444, 0, 0, 0.5],
    729: [0, 0.66786, 0, 0, 0.27778],
    730: [0, 0.69444, 0, 0, 0.75],
    732: [0, 0.66786, 0, 0, 0.5],
    733: [0, 0.69444, 0, 0, 0.5],
    915: [0, 0.68333, 0, 0, 0.625],
    916: [0, 0.68333, 0, 0, 0.83334],
    920: [0, 0.68333, 0, 0, 0.77778],
    923: [0, 0.68333, 0, 0, 0.69445],
    926: [0, 0.68333, 0, 0, 0.66667],
    928: [0, 0.68333, 0, 0, 0.75],
    931: [0, 0.68333, 0, 0, 0.72222],
    933: [0, 0.68333, 0, 0, 0.77778],
    934: [0, 0.68333, 0, 0, 0.72222],
    936: [0, 0.68333, 0, 0, 0.77778],
    937: [0, 0.68333, 0, 0, 0.72222],
    8211: [0, 0.43056, 0.02778, 0, 0.5],
    8212: [0, 0.43056, 0.02778, 0, 1],
    8216: [0, 0.69444, 0, 0, 0.27778],
    8217: [0, 0.69444, 0, 0, 0.27778],
    8220: [0, 0.69444, 0, 0, 0.5],
    8221: [0, 0.69444, 0, 0, 0.5],
    8224: [0.19444, 0.69444, 0, 0, 0.44445],
    8225: [0.19444, 0.69444, 0, 0, 0.44445],
    8230: [0, 0.123, 0, 0, 1.172],
    8242: [0, 0.55556, 0, 0, 0.275],
    8407: [0, 0.71444, 0.15382, 0, 0.5],
    8463: [0, 0.68889, 0, 0, 0.54028],
    8465: [0, 0.69444, 0, 0, 0.72222],
    8467: [0, 0.69444, 0, 0.11111, 0.41667],
    8472: [0.19444, 0.43056, 0, 0.11111, 0.63646],
    8476: [0, 0.69444, 0, 0, 0.72222],
    8501: [0, 0.69444, 0, 0, 0.61111],
    8592: [-0.13313, 0.36687, 0, 0, 1],
    8593: [0.19444, 0.69444, 0, 0, 0.5],
    8594: [-0.13313, 0.36687, 0, 0, 1],
    8595: [0.19444, 0.69444, 0, 0, 0.5],
    8596: [-0.13313, 0.36687, 0, 0, 1],
    8597: [0.25, 0.75, 0, 0, 0.5],
    8598: [0.19444, 0.69444, 0, 0, 1],
    8599: [0.19444, 0.69444, 0, 0, 1],
    8600: [0.19444, 0.69444, 0, 0, 1],
    8601: [0.19444, 0.69444, 0, 0, 1],
    8614: [0.011, 0.511, 0, 0, 1],
    8617: [0.011, 0.511, 0, 0, 1.126],
    8618: [0.011, 0.511, 0, 0, 1.126],
    8636: [-0.13313, 0.36687, 0, 0, 1],
    8637: [-0.13313, 0.36687, 0, 0, 1],
    8640: [-0.13313, 0.36687, 0, 0, 1],
    8641: [-0.13313, 0.36687, 0, 0, 1],
    8652: [0.011, 0.671, 0, 0, 1],
    8656: [-0.13313, 0.36687, 0, 0, 1],
    8657: [0.19444, 0.69444, 0, 0, 0.61111],
    8658: [-0.13313, 0.36687, 0, 0, 1],
    8659: [0.19444, 0.69444, 0, 0, 0.61111],
    8660: [-0.13313, 0.36687, 0, 0, 1],
    8661: [0.25, 0.75, 0, 0, 0.61111],
    8704: [0, 0.69444, 0, 0, 0.55556],
    8706: [0, 0.69444, 0.05556, 0.08334, 0.5309],
    8707: [0, 0.69444, 0, 0, 0.55556],
    8709: [0.05556, 0.75, 0, 0, 0.5],
    8711: [0, 0.68333, 0, 0, 0.83334],
    8712: [0.0391, 0.5391, 0, 0, 0.66667],
    8715: [0.0391, 0.5391, 0, 0, 0.66667],
    8722: [0.08333, 0.58333, 0, 0, 0.77778],
    8723: [0.08333, 0.58333, 0, 0, 0.77778],
    8725: [0.25, 0.75, 0, 0, 0.5],
    8726: [0.25, 0.75, 0, 0, 0.5],
    8727: [-0.03472, 0.46528, 0, 0, 0.5],
    8728: [-0.05555, 0.44445, 0, 0, 0.5],
    8729: [-0.05555, 0.44445, 0, 0, 0.5],
    8730: [0.2, 0.8, 0, 0, 0.83334],
    8733: [0, 0.43056, 0, 0, 0.77778],
    8734: [0, 0.43056, 0, 0, 1],
    8736: [0, 0.69224, 0, 0, 0.72222],
    8739: [0.25, 0.75, 0, 0, 0.27778],
    8741: [0.25, 0.75, 0, 0, 0.5],
    8743: [0, 0.55556, 0, 0, 0.66667],
    8744: [0, 0.55556, 0, 0, 0.66667],
    8745: [0, 0.55556, 0, 0, 0.66667],
    8746: [0, 0.55556, 0, 0, 0.66667],
    8747: [0.19444, 0.69444, 0.11111, 0, 0.41667],
    8764: [-0.13313, 0.36687, 0, 0, 0.77778],
    8768: [0.19444, 0.69444, 0, 0, 0.27778],
    8771: [-0.03625, 0.46375, 0, 0, 0.77778],
    8773: [-0.022, 0.589, 0, 0, 0.778],
    8776: [-0.01688, 0.48312, 0, 0, 0.77778],
    8781: [-0.03625, 0.46375, 0, 0, 0.77778],
    8784: [-0.133, 0.673, 0, 0, 0.778],
    8801: [-0.03625, 0.46375, 0, 0, 0.77778],
    8804: [0.13597, 0.63597, 0, 0, 0.77778],
    8805: [0.13597, 0.63597, 0, 0, 0.77778],
    8810: [0.0391, 0.5391, 0, 0, 1],
    8811: [0.0391, 0.5391, 0, 0, 1],
    8826: [0.0391, 0.5391, 0, 0, 0.77778],
    8827: [0.0391, 0.5391, 0, 0, 0.77778],
    8834: [0.0391, 0.5391, 0, 0, 0.77778],
    8835: [0.0391, 0.5391, 0, 0, 0.77778],
    8838: [0.13597, 0.63597, 0, 0, 0.77778],
    8839: [0.13597, 0.63597, 0, 0, 0.77778],
    8846: [0, 0.55556, 0, 0, 0.66667],
    8849: [0.13597, 0.63597, 0, 0, 0.77778],
    8850: [0.13597, 0.63597, 0, 0, 0.77778],
    8851: [0, 0.55556, 0, 0, 0.66667],
    8852: [0, 0.55556, 0, 0, 0.66667],
    8853: [0.08333, 0.58333, 0, 0, 0.77778],
    8854: [0.08333, 0.58333, 0, 0, 0.77778],
    8855: [0.08333, 0.58333, 0, 0, 0.77778],
    8856: [0.08333, 0.58333, 0, 0, 0.77778],
    8857: [0.08333, 0.58333, 0, 0, 0.77778],
    8866: [0, 0.69444, 0, 0, 0.61111],
    8867: [0, 0.69444, 0, 0, 0.61111],
    8868: [0, 0.69444, 0, 0, 0.77778],
    8869: [0, 0.69444, 0, 0, 0.77778],
    8872: [0.249, 0.75, 0, 0, 0.867],
    8900: [-0.05555, 0.44445, 0, 0, 0.5],
    8901: [-0.05555, 0.44445, 0, 0, 0.27778],
    8902: [-0.03472, 0.46528, 0, 0, 0.5],
    8904: [5e-3, 0.505, 0, 0, 0.9],
    8942: [0.03, 0.903, 0, 0, 0.278],
    8943: [-0.19, 0.313, 0, 0, 1.172],
    8945: [-0.1, 0.823, 0, 0, 1.282],
    8968: [0.25, 0.75, 0, 0, 0.44445],
    8969: [0.25, 0.75, 0, 0, 0.44445],
    8970: [0.25, 0.75, 0, 0, 0.44445],
    8971: [0.25, 0.75, 0, 0, 0.44445],
    8994: [-0.14236, 0.35764, 0, 0, 1],
    8995: [-0.14236, 0.35764, 0, 0, 1],
    9136: [0.244, 0.744, 0, 0, 0.412],
    9137: [0.244, 0.745, 0, 0, 0.412],
    9651: [0.19444, 0.69444, 0, 0, 0.88889],
    9657: [-0.03472, 0.46528, 0, 0, 0.5],
    9661: [0.19444, 0.69444, 0, 0, 0.88889],
    9667: [-0.03472, 0.46528, 0, 0, 0.5],
    9711: [0.19444, 0.69444, 0, 0, 1],
    9824: [0.12963, 0.69444, 0, 0, 0.77778],
    9825: [0.12963, 0.69444, 0, 0, 0.77778],
    9826: [0.12963, 0.69444, 0, 0, 0.77778],
    9827: [0.12963, 0.69444, 0, 0, 0.77778],
    9837: [0, 0.75, 0, 0, 0.38889],
    9838: [0.19444, 0.69444, 0, 0, 0.38889],
    9839: [0.19444, 0.69444, 0, 0, 0.38889],
    10216: [0.25, 0.75, 0, 0, 0.38889],
    10217: [0.25, 0.75, 0, 0, 0.38889],
    10222: [0.244, 0.744, 0, 0, 0.412],
    10223: [0.244, 0.745, 0, 0, 0.412],
    10229: [0.011, 0.511, 0, 0, 1.609],
    10230: [0.011, 0.511, 0, 0, 1.638],
    10231: [0.011, 0.511, 0, 0, 1.859],
    10232: [0.024, 0.525, 0, 0, 1.609],
    10233: [0.024, 0.525, 0, 0, 1.638],
    10234: [0.024, 0.525, 0, 0, 1.858],
    10236: [0.011, 0.511, 0, 0, 1.638],
    10815: [0, 0.68333, 0, 0, 0.75],
    10927: [0.13597, 0.63597, 0, 0, 0.77778],
    10928: [0.13597, 0.63597, 0, 0, 0.77778],
    57376: [0.19444, 0.69444, 0, 0, 0]
  },
  "Math-BoldItalic": {
    32: [0, 0, 0, 0, 0.25],
    48: [0, 0.44444, 0, 0, 0.575],
    49: [0, 0.44444, 0, 0, 0.575],
    50: [0, 0.44444, 0, 0, 0.575],
    51: [0.19444, 0.44444, 0, 0, 0.575],
    52: [0.19444, 0.44444, 0, 0, 0.575],
    53: [0.19444, 0.44444, 0, 0, 0.575],
    54: [0, 0.64444, 0, 0, 0.575],
    55: [0.19444, 0.44444, 0, 0, 0.575],
    56: [0, 0.64444, 0, 0, 0.575],
    57: [0.19444, 0.44444, 0, 0, 0.575],
    65: [0, 0.68611, 0, 0, 0.86944],
    66: [0, 0.68611, 0.04835, 0, 0.8664],
    67: [0, 0.68611, 0.06979, 0, 0.81694],
    68: [0, 0.68611, 0.03194, 0, 0.93812],
    69: [0, 0.68611, 0.05451, 0, 0.81007],
    70: [0, 0.68611, 0.15972, 0, 0.68889],
    71: [0, 0.68611, 0, 0, 0.88673],
    72: [0, 0.68611, 0.08229, 0, 0.98229],
    73: [0, 0.68611, 0.07778, 0, 0.51111],
    74: [0, 0.68611, 0.10069, 0, 0.63125],
    75: [0, 0.68611, 0.06979, 0, 0.97118],
    76: [0, 0.68611, 0, 0, 0.75555],
    77: [0, 0.68611, 0.11424, 0, 1.14201],
    78: [0, 0.68611, 0.11424, 0, 0.95034],
    79: [0, 0.68611, 0.03194, 0, 0.83666],
    80: [0, 0.68611, 0.15972, 0, 0.72309],
    81: [0.19444, 0.68611, 0, 0, 0.86861],
    82: [0, 0.68611, 421e-5, 0, 0.87235],
    83: [0, 0.68611, 0.05382, 0, 0.69271],
    84: [0, 0.68611, 0.15972, 0, 0.63663],
    85: [0, 0.68611, 0.11424, 0, 0.80027],
    86: [0, 0.68611, 0.25555, 0, 0.67778],
    87: [0, 0.68611, 0.15972, 0, 1.09305],
    88: [0, 0.68611, 0.07778, 0, 0.94722],
    89: [0, 0.68611, 0.25555, 0, 0.67458],
    90: [0, 0.68611, 0.06979, 0, 0.77257],
    97: [0, 0.44444, 0, 0, 0.63287],
    98: [0, 0.69444, 0, 0, 0.52083],
    99: [0, 0.44444, 0, 0, 0.51342],
    100: [0, 0.69444, 0, 0, 0.60972],
    101: [0, 0.44444, 0, 0, 0.55361],
    102: [0.19444, 0.69444, 0.11042, 0, 0.56806],
    103: [0.19444, 0.44444, 0.03704, 0, 0.5449],
    104: [0, 0.69444, 0, 0, 0.66759],
    105: [0, 0.69326, 0, 0, 0.4048],
    106: [0.19444, 0.69326, 0.0622, 0, 0.47083],
    107: [0, 0.69444, 0.01852, 0, 0.6037],
    108: [0, 0.69444, 88e-4, 0, 0.34815],
    109: [0, 0.44444, 0, 0, 1.0324],
    110: [0, 0.44444, 0, 0, 0.71296],
    111: [0, 0.44444, 0, 0, 0.58472],
    112: [0.19444, 0.44444, 0, 0, 0.60092],
    113: [0.19444, 0.44444, 0.03704, 0, 0.54213],
    114: [0, 0.44444, 0.03194, 0, 0.5287],
    115: [0, 0.44444, 0, 0, 0.53125],
    116: [0, 0.63492, 0, 0, 0.41528],
    117: [0, 0.44444, 0, 0, 0.68102],
    118: [0, 0.44444, 0.03704, 0, 0.56666],
    119: [0, 0.44444, 0.02778, 0, 0.83148],
    120: [0, 0.44444, 0, 0, 0.65903],
    121: [0.19444, 0.44444, 0.03704, 0, 0.59028],
    122: [0, 0.44444, 0.04213, 0, 0.55509],
    160: [0, 0, 0, 0, 0.25],
    915: [0, 0.68611, 0.15972, 0, 0.65694],
    916: [0, 0.68611, 0, 0, 0.95833],
    920: [0, 0.68611, 0.03194, 0, 0.86722],
    923: [0, 0.68611, 0, 0, 0.80555],
    926: [0, 0.68611, 0.07458, 0, 0.84125],
    928: [0, 0.68611, 0.08229, 0, 0.98229],
    931: [0, 0.68611, 0.05451, 0, 0.88507],
    933: [0, 0.68611, 0.15972, 0, 0.67083],
    934: [0, 0.68611, 0, 0, 0.76666],
    936: [0, 0.68611, 0.11653, 0, 0.71402],
    937: [0, 0.68611, 0.04835, 0, 0.8789],
    945: [0, 0.44444, 0, 0, 0.76064],
    946: [0.19444, 0.69444, 0.03403, 0, 0.65972],
    947: [0.19444, 0.44444, 0.06389, 0, 0.59003],
    948: [0, 0.69444, 0.03819, 0, 0.52222],
    949: [0, 0.44444, 0, 0, 0.52882],
    950: [0.19444, 0.69444, 0.06215, 0, 0.50833],
    951: [0.19444, 0.44444, 0.03704, 0, 0.6],
    952: [0, 0.69444, 0.03194, 0, 0.5618],
    953: [0, 0.44444, 0, 0, 0.41204],
    954: [0, 0.44444, 0, 0, 0.66759],
    955: [0, 0.69444, 0, 0, 0.67083],
    956: [0.19444, 0.44444, 0, 0, 0.70787],
    957: [0, 0.44444, 0.06898, 0, 0.57685],
    958: [0.19444, 0.69444, 0.03021, 0, 0.50833],
    959: [0, 0.44444, 0, 0, 0.58472],
    960: [0, 0.44444, 0.03704, 0, 0.68241],
    961: [0.19444, 0.44444, 0, 0, 0.6118],
    962: [0.09722, 0.44444, 0.07917, 0, 0.42361],
    963: [0, 0.44444, 0.03704, 0, 0.68588],
    964: [0, 0.44444, 0.13472, 0, 0.52083],
    965: [0, 0.44444, 0.03704, 0, 0.63055],
    966: [0.19444, 0.44444, 0, 0, 0.74722],
    967: [0.19444, 0.44444, 0, 0, 0.71805],
    968: [0.19444, 0.69444, 0.03704, 0, 0.75833],
    969: [0, 0.44444, 0.03704, 0, 0.71782],
    977: [0, 0.69444, 0, 0, 0.69155],
    981: [0.19444, 0.69444, 0, 0, 0.7125],
    982: [0, 0.44444, 0.03194, 0, 0.975],
    1009: [0.19444, 0.44444, 0, 0, 0.6118],
    1013: [0, 0.44444, 0, 0, 0.48333],
    57649: [0, 0.44444, 0, 0, 0.39352],
    57911: [0.19444, 0.44444, 0, 0, 0.43889]
  },
  "Math-Italic": {
    32: [0, 0, 0, 0, 0.25],
    48: [0, 0.43056, 0, 0, 0.5],
    49: [0, 0.43056, 0, 0, 0.5],
    50: [0, 0.43056, 0, 0, 0.5],
    51: [0.19444, 0.43056, 0, 0, 0.5],
    52: [0.19444, 0.43056, 0, 0, 0.5],
    53: [0.19444, 0.43056, 0, 0, 0.5],
    54: [0, 0.64444, 0, 0, 0.5],
    55: [0.19444, 0.43056, 0, 0, 0.5],
    56: [0, 0.64444, 0, 0, 0.5],
    57: [0.19444, 0.43056, 0, 0, 0.5],
    65: [0, 0.68333, 0, 0.13889, 0.75],
    66: [0, 0.68333, 0.05017, 0.08334, 0.75851],
    67: [0, 0.68333, 0.07153, 0.08334, 0.71472],
    68: [0, 0.68333, 0.02778, 0.05556, 0.82792],
    69: [0, 0.68333, 0.05764, 0.08334, 0.7382],
    70: [0, 0.68333, 0.13889, 0.08334, 0.64306],
    71: [0, 0.68333, 0, 0.08334, 0.78625],
    72: [0, 0.68333, 0.08125, 0.05556, 0.83125],
    73: [0, 0.68333, 0.07847, 0.11111, 0.43958],
    74: [0, 0.68333, 0.09618, 0.16667, 0.55451],
    75: [0, 0.68333, 0.07153, 0.05556, 0.84931],
    76: [0, 0.68333, 0, 0.02778, 0.68056],
    77: [0, 0.68333, 0.10903, 0.08334, 0.97014],
    78: [0, 0.68333, 0.10903, 0.08334, 0.80347],
    79: [0, 0.68333, 0.02778, 0.08334, 0.76278],
    80: [0, 0.68333, 0.13889, 0.08334, 0.64201],
    81: [0.19444, 0.68333, 0, 0.08334, 0.79056],
    82: [0, 0.68333, 773e-5, 0.08334, 0.75929],
    83: [0, 0.68333, 0.05764, 0.08334, 0.6132],
    84: [0, 0.68333, 0.13889, 0.08334, 0.58438],
    85: [0, 0.68333, 0.10903, 0.02778, 0.68278],
    86: [0, 0.68333, 0.22222, 0, 0.58333],
    87: [0, 0.68333, 0.13889, 0, 0.94445],
    88: [0, 0.68333, 0.07847, 0.08334, 0.82847],
    89: [0, 0.68333, 0.22222, 0, 0.58056],
    90: [0, 0.68333, 0.07153, 0.08334, 0.68264],
    97: [0, 0.43056, 0, 0, 0.52859],
    98: [0, 0.69444, 0, 0, 0.42917],
    99: [0, 0.43056, 0, 0.05556, 0.43276],
    100: [0, 0.69444, 0, 0.16667, 0.52049],
    101: [0, 0.43056, 0, 0.05556, 0.46563],
    102: [0.19444, 0.69444, 0.10764, 0.16667, 0.48959],
    103: [0.19444, 0.43056, 0.03588, 0.02778, 0.47697],
    104: [0, 0.69444, 0, 0, 0.57616],
    105: [0, 0.65952, 0, 0, 0.34451],
    106: [0.19444, 0.65952, 0.05724, 0, 0.41181],
    107: [0, 0.69444, 0.03148, 0, 0.5206],
    108: [0, 0.69444, 0.01968, 0.08334, 0.29838],
    109: [0, 0.43056, 0, 0, 0.87801],
    110: [0, 0.43056, 0, 0, 0.60023],
    111: [0, 0.43056, 0, 0.05556, 0.48472],
    112: [0.19444, 0.43056, 0, 0.08334, 0.50313],
    113: [0.19444, 0.43056, 0.03588, 0.08334, 0.44641],
    114: [0, 0.43056, 0.02778, 0.05556, 0.45116],
    115: [0, 0.43056, 0, 0.05556, 0.46875],
    116: [0, 0.61508, 0, 0.08334, 0.36111],
    117: [0, 0.43056, 0, 0.02778, 0.57246],
    118: [0, 0.43056, 0.03588, 0.02778, 0.48472],
    119: [0, 0.43056, 0.02691, 0.08334, 0.71592],
    120: [0, 0.43056, 0, 0.02778, 0.57153],
    121: [0.19444, 0.43056, 0.03588, 0.05556, 0.49028],
    122: [0, 0.43056, 0.04398, 0.05556, 0.46505],
    160: [0, 0, 0, 0, 0.25],
    915: [0, 0.68333, 0.13889, 0.08334, 0.61528],
    916: [0, 0.68333, 0, 0.16667, 0.83334],
    920: [0, 0.68333, 0.02778, 0.08334, 0.76278],
    923: [0, 0.68333, 0, 0.16667, 0.69445],
    926: [0, 0.68333, 0.07569, 0.08334, 0.74236],
    928: [0, 0.68333, 0.08125, 0.05556, 0.83125],
    931: [0, 0.68333, 0.05764, 0.08334, 0.77986],
    933: [0, 0.68333, 0.13889, 0.05556, 0.58333],
    934: [0, 0.68333, 0, 0.08334, 0.66667],
    936: [0, 0.68333, 0.11, 0.05556, 0.61222],
    937: [0, 0.68333, 0.05017, 0.08334, 0.7724],
    945: [0, 0.43056, 37e-4, 0.02778, 0.6397],
    946: [0.19444, 0.69444, 0.05278, 0.08334, 0.56563],
    947: [0.19444, 0.43056, 0.05556, 0, 0.51773],
    948: [0, 0.69444, 0.03785, 0.05556, 0.44444],
    949: [0, 0.43056, 0, 0.08334, 0.46632],
    950: [0.19444, 0.69444, 0.07378, 0.08334, 0.4375],
    951: [0.19444, 0.43056, 0.03588, 0.05556, 0.49653],
    952: [0, 0.69444, 0.02778, 0.08334, 0.46944],
    953: [0, 0.43056, 0, 0.05556, 0.35394],
    954: [0, 0.43056, 0, 0, 0.57616],
    955: [0, 0.69444, 0, 0, 0.58334],
    956: [0.19444, 0.43056, 0, 0.02778, 0.60255],
    957: [0, 0.43056, 0.06366, 0.02778, 0.49398],
    958: [0.19444, 0.69444, 0.04601, 0.11111, 0.4375],
    959: [0, 0.43056, 0, 0.05556, 0.48472],
    960: [0, 0.43056, 0.03588, 0, 0.57003],
    961: [0.19444, 0.43056, 0, 0.08334, 0.51702],
    962: [0.09722, 0.43056, 0.07986, 0.08334, 0.36285],
    963: [0, 0.43056, 0.03588, 0, 0.57141],
    964: [0, 0.43056, 0.1132, 0.02778, 0.43715],
    965: [0, 0.43056, 0.03588, 0.02778, 0.54028],
    966: [0.19444, 0.43056, 0, 0.08334, 0.65417],
    967: [0.19444, 0.43056, 0, 0.05556, 0.62569],
    968: [0.19444, 0.69444, 0.03588, 0.11111, 0.65139],
    969: [0, 0.43056, 0.03588, 0, 0.62245],
    977: [0, 0.69444, 0, 0.08334, 0.59144],
    981: [0.19444, 0.69444, 0, 0.08334, 0.59583],
    982: [0, 0.43056, 0.02778, 0, 0.82813],
    1009: [0.19444, 0.43056, 0, 0.08334, 0.51702],
    1013: [0, 0.43056, 0, 0.05556, 0.4059],
    57649: [0, 0.43056, 0, 0.02778, 0.32246],
    57911: [0.19444, 0.43056, 0, 0.08334, 0.38403]
  },
  "SansSerif-Bold": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0, 0, 0.36667],
    34: [0, 0.69444, 0, 0, 0.55834],
    35: [0.19444, 0.69444, 0, 0, 0.91667],
    36: [0.05556, 0.75, 0, 0, 0.55],
    37: [0.05556, 0.75, 0, 0, 1.02912],
    38: [0, 0.69444, 0, 0, 0.83056],
    39: [0, 0.69444, 0, 0, 0.30556],
    40: [0.25, 0.75, 0, 0, 0.42778],
    41: [0.25, 0.75, 0, 0, 0.42778],
    42: [0, 0.75, 0, 0, 0.55],
    43: [0.11667, 0.61667, 0, 0, 0.85556],
    44: [0.10556, 0.13056, 0, 0, 0.30556],
    45: [0, 0.45833, 0, 0, 0.36667],
    46: [0, 0.13056, 0, 0, 0.30556],
    47: [0.25, 0.75, 0, 0, 0.55],
    48: [0, 0.69444, 0, 0, 0.55],
    49: [0, 0.69444, 0, 0, 0.55],
    50: [0, 0.69444, 0, 0, 0.55],
    51: [0, 0.69444, 0, 0, 0.55],
    52: [0, 0.69444, 0, 0, 0.55],
    53: [0, 0.69444, 0, 0, 0.55],
    54: [0, 0.69444, 0, 0, 0.55],
    55: [0, 0.69444, 0, 0, 0.55],
    56: [0, 0.69444, 0, 0, 0.55],
    57: [0, 0.69444, 0, 0, 0.55],
    58: [0, 0.45833, 0, 0, 0.30556],
    59: [0.10556, 0.45833, 0, 0, 0.30556],
    61: [-0.09375, 0.40625, 0, 0, 0.85556],
    63: [0, 0.69444, 0, 0, 0.51945],
    64: [0, 0.69444, 0, 0, 0.73334],
    65: [0, 0.69444, 0, 0, 0.73334],
    66: [0, 0.69444, 0, 0, 0.73334],
    67: [0, 0.69444, 0, 0, 0.70278],
    68: [0, 0.69444, 0, 0, 0.79445],
    69: [0, 0.69444, 0, 0, 0.64167],
    70: [0, 0.69444, 0, 0, 0.61111],
    71: [0, 0.69444, 0, 0, 0.73334],
    72: [0, 0.69444, 0, 0, 0.79445],
    73: [0, 0.69444, 0, 0, 0.33056],
    74: [0, 0.69444, 0, 0, 0.51945],
    75: [0, 0.69444, 0, 0, 0.76389],
    76: [0, 0.69444, 0, 0, 0.58056],
    77: [0, 0.69444, 0, 0, 0.97778],
    78: [0, 0.69444, 0, 0, 0.79445],
    79: [0, 0.69444, 0, 0, 0.79445],
    80: [0, 0.69444, 0, 0, 0.70278],
    81: [0.10556, 0.69444, 0, 0, 0.79445],
    82: [0, 0.69444, 0, 0, 0.70278],
    83: [0, 0.69444, 0, 0, 0.61111],
    84: [0, 0.69444, 0, 0, 0.73334],
    85: [0, 0.69444, 0, 0, 0.76389],
    86: [0, 0.69444, 0.01528, 0, 0.73334],
    87: [0, 0.69444, 0.01528, 0, 1.03889],
    88: [0, 0.69444, 0, 0, 0.73334],
    89: [0, 0.69444, 0.0275, 0, 0.73334],
    90: [0, 0.69444, 0, 0, 0.67223],
    91: [0.25, 0.75, 0, 0, 0.34306],
    93: [0.25, 0.75, 0, 0, 0.34306],
    94: [0, 0.69444, 0, 0, 0.55],
    95: [0.35, 0.10833, 0.03056, 0, 0.55],
    97: [0, 0.45833, 0, 0, 0.525],
    98: [0, 0.69444, 0, 0, 0.56111],
    99: [0, 0.45833, 0, 0, 0.48889],
    100: [0, 0.69444, 0, 0, 0.56111],
    101: [0, 0.45833, 0, 0, 0.51111],
    102: [0, 0.69444, 0.07639, 0, 0.33611],
    103: [0.19444, 0.45833, 0.01528, 0, 0.55],
    104: [0, 0.69444, 0, 0, 0.56111],
    105: [0, 0.69444, 0, 0, 0.25556],
    106: [0.19444, 0.69444, 0, 0, 0.28611],
    107: [0, 0.69444, 0, 0, 0.53056],
    108: [0, 0.69444, 0, 0, 0.25556],
    109: [0, 0.45833, 0, 0, 0.86667],
    110: [0, 0.45833, 0, 0, 0.56111],
    111: [0, 0.45833, 0, 0, 0.55],
    112: [0.19444, 0.45833, 0, 0, 0.56111],
    113: [0.19444, 0.45833, 0, 0, 0.56111],
    114: [0, 0.45833, 0.01528, 0, 0.37222],
    115: [0, 0.45833, 0, 0, 0.42167],
    116: [0, 0.58929, 0, 0, 0.40417],
    117: [0, 0.45833, 0, 0, 0.56111],
    118: [0, 0.45833, 0.01528, 0, 0.5],
    119: [0, 0.45833, 0.01528, 0, 0.74445],
    120: [0, 0.45833, 0, 0, 0.5],
    121: [0.19444, 0.45833, 0.01528, 0, 0.5],
    122: [0, 0.45833, 0, 0, 0.47639],
    126: [0.35, 0.34444, 0, 0, 0.55],
    160: [0, 0, 0, 0, 0.25],
    168: [0, 0.69444, 0, 0, 0.55],
    176: [0, 0.69444, 0, 0, 0.73334],
    180: [0, 0.69444, 0, 0, 0.55],
    184: [0.17014, 0, 0, 0, 0.48889],
    305: [0, 0.45833, 0, 0, 0.25556],
    567: [0.19444, 0.45833, 0, 0, 0.28611],
    710: [0, 0.69444, 0, 0, 0.55],
    711: [0, 0.63542, 0, 0, 0.55],
    713: [0, 0.63778, 0, 0, 0.55],
    728: [0, 0.69444, 0, 0, 0.55],
    729: [0, 0.69444, 0, 0, 0.30556],
    730: [0, 0.69444, 0, 0, 0.73334],
    732: [0, 0.69444, 0, 0, 0.55],
    733: [0, 0.69444, 0, 0, 0.55],
    915: [0, 0.69444, 0, 0, 0.58056],
    916: [0, 0.69444, 0, 0, 0.91667],
    920: [0, 0.69444, 0, 0, 0.85556],
    923: [0, 0.69444, 0, 0, 0.67223],
    926: [0, 0.69444, 0, 0, 0.73334],
    928: [0, 0.69444, 0, 0, 0.79445],
    931: [0, 0.69444, 0, 0, 0.79445],
    933: [0, 0.69444, 0, 0, 0.85556],
    934: [0, 0.69444, 0, 0, 0.79445],
    936: [0, 0.69444, 0, 0, 0.85556],
    937: [0, 0.69444, 0, 0, 0.79445],
    8211: [0, 0.45833, 0.03056, 0, 0.55],
    8212: [0, 0.45833, 0.03056, 0, 1.10001],
    8216: [0, 0.69444, 0, 0, 0.30556],
    8217: [0, 0.69444, 0, 0, 0.30556],
    8220: [0, 0.69444, 0, 0, 0.55834],
    8221: [0, 0.69444, 0, 0, 0.55834]
  },
  "SansSerif-Italic": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0.05733, 0, 0.31945],
    34: [0, 0.69444, 316e-5, 0, 0.5],
    35: [0.19444, 0.69444, 0.05087, 0, 0.83334],
    36: [0.05556, 0.75, 0.11156, 0, 0.5],
    37: [0.05556, 0.75, 0.03126, 0, 0.83334],
    38: [0, 0.69444, 0.03058, 0, 0.75834],
    39: [0, 0.69444, 0.07816, 0, 0.27778],
    40: [0.25, 0.75, 0.13164, 0, 0.38889],
    41: [0.25, 0.75, 0.02536, 0, 0.38889],
    42: [0, 0.75, 0.11775, 0, 0.5],
    43: [0.08333, 0.58333, 0.02536, 0, 0.77778],
    44: [0.125, 0.08333, 0, 0, 0.27778],
    45: [0, 0.44444, 0.01946, 0, 0.33333],
    46: [0, 0.08333, 0, 0, 0.27778],
    47: [0.25, 0.75, 0.13164, 0, 0.5],
    48: [0, 0.65556, 0.11156, 0, 0.5],
    49: [0, 0.65556, 0.11156, 0, 0.5],
    50: [0, 0.65556, 0.11156, 0, 0.5],
    51: [0, 0.65556, 0.11156, 0, 0.5],
    52: [0, 0.65556, 0.11156, 0, 0.5],
    53: [0, 0.65556, 0.11156, 0, 0.5],
    54: [0, 0.65556, 0.11156, 0, 0.5],
    55: [0, 0.65556, 0.11156, 0, 0.5],
    56: [0, 0.65556, 0.11156, 0, 0.5],
    57: [0, 0.65556, 0.11156, 0, 0.5],
    58: [0, 0.44444, 0.02502, 0, 0.27778],
    59: [0.125, 0.44444, 0.02502, 0, 0.27778],
    61: [-0.13, 0.37, 0.05087, 0, 0.77778],
    63: [0, 0.69444, 0.11809, 0, 0.47222],
    64: [0, 0.69444, 0.07555, 0, 0.66667],
    65: [0, 0.69444, 0, 0, 0.66667],
    66: [0, 0.69444, 0.08293, 0, 0.66667],
    67: [0, 0.69444, 0.11983, 0, 0.63889],
    68: [0, 0.69444, 0.07555, 0, 0.72223],
    69: [0, 0.69444, 0.11983, 0, 0.59722],
    70: [0, 0.69444, 0.13372, 0, 0.56945],
    71: [0, 0.69444, 0.11983, 0, 0.66667],
    72: [0, 0.69444, 0.08094, 0, 0.70834],
    73: [0, 0.69444, 0.13372, 0, 0.27778],
    74: [0, 0.69444, 0.08094, 0, 0.47222],
    75: [0, 0.69444, 0.11983, 0, 0.69445],
    76: [0, 0.69444, 0, 0, 0.54167],
    77: [0, 0.69444, 0.08094, 0, 0.875],
    78: [0, 0.69444, 0.08094, 0, 0.70834],
    79: [0, 0.69444, 0.07555, 0, 0.73611],
    80: [0, 0.69444, 0.08293, 0, 0.63889],
    81: [0.125, 0.69444, 0.07555, 0, 0.73611],
    82: [0, 0.69444, 0.08293, 0, 0.64584],
    83: [0, 0.69444, 0.09205, 0, 0.55556],
    84: [0, 0.69444, 0.13372, 0, 0.68056],
    85: [0, 0.69444, 0.08094, 0, 0.6875],
    86: [0, 0.69444, 0.1615, 0, 0.66667],
    87: [0, 0.69444, 0.1615, 0, 0.94445],
    88: [0, 0.69444, 0.13372, 0, 0.66667],
    89: [0, 0.69444, 0.17261, 0, 0.66667],
    90: [0, 0.69444, 0.11983, 0, 0.61111],
    91: [0.25, 0.75, 0.15942, 0, 0.28889],
    93: [0.25, 0.75, 0.08719, 0, 0.28889],
    94: [0, 0.69444, 0.0799, 0, 0.5],
    95: [0.35, 0.09444, 0.08616, 0, 0.5],
    97: [0, 0.44444, 981e-5, 0, 0.48056],
    98: [0, 0.69444, 0.03057, 0, 0.51667],
    99: [0, 0.44444, 0.08336, 0, 0.44445],
    100: [0, 0.69444, 0.09483, 0, 0.51667],
    101: [0, 0.44444, 0.06778, 0, 0.44445],
    102: [0, 0.69444, 0.21705, 0, 0.30556],
    103: [0.19444, 0.44444, 0.10836, 0, 0.5],
    104: [0, 0.69444, 0.01778, 0, 0.51667],
    105: [0, 0.67937, 0.09718, 0, 0.23889],
    106: [0.19444, 0.67937, 0.09162, 0, 0.26667],
    107: [0, 0.69444, 0.08336, 0, 0.48889],
    108: [0, 0.69444, 0.09483, 0, 0.23889],
    109: [0, 0.44444, 0.01778, 0, 0.79445],
    110: [0, 0.44444, 0.01778, 0, 0.51667],
    111: [0, 0.44444, 0.06613, 0, 0.5],
    112: [0.19444, 0.44444, 0.0389, 0, 0.51667],
    113: [0.19444, 0.44444, 0.04169, 0, 0.51667],
    114: [0, 0.44444, 0.10836, 0, 0.34167],
    115: [0, 0.44444, 0.0778, 0, 0.38333],
    116: [0, 0.57143, 0.07225, 0, 0.36111],
    117: [0, 0.44444, 0.04169, 0, 0.51667],
    118: [0, 0.44444, 0.10836, 0, 0.46111],
    119: [0, 0.44444, 0.10836, 0, 0.68334],
    120: [0, 0.44444, 0.09169, 0, 0.46111],
    121: [0.19444, 0.44444, 0.10836, 0, 0.46111],
    122: [0, 0.44444, 0.08752, 0, 0.43472],
    126: [0.35, 0.32659, 0.08826, 0, 0.5],
    160: [0, 0, 0, 0, 0.25],
    168: [0, 0.67937, 0.06385, 0, 0.5],
    176: [0, 0.69444, 0, 0, 0.73752],
    184: [0.17014, 0, 0, 0, 0.44445],
    305: [0, 0.44444, 0.04169, 0, 0.23889],
    567: [0.19444, 0.44444, 0.04169, 0, 0.26667],
    710: [0, 0.69444, 0.0799, 0, 0.5],
    711: [0, 0.63194, 0.08432, 0, 0.5],
    713: [0, 0.60889, 0.08776, 0, 0.5],
    714: [0, 0.69444, 0.09205, 0, 0.5],
    715: [0, 0.69444, 0, 0, 0.5],
    728: [0, 0.69444, 0.09483, 0, 0.5],
    729: [0, 0.67937, 0.07774, 0, 0.27778],
    730: [0, 0.69444, 0, 0, 0.73752],
    732: [0, 0.67659, 0.08826, 0, 0.5],
    733: [0, 0.69444, 0.09205, 0, 0.5],
    915: [0, 0.69444, 0.13372, 0, 0.54167],
    916: [0, 0.69444, 0, 0, 0.83334],
    920: [0, 0.69444, 0.07555, 0, 0.77778],
    923: [0, 0.69444, 0, 0, 0.61111],
    926: [0, 0.69444, 0.12816, 0, 0.66667],
    928: [0, 0.69444, 0.08094, 0, 0.70834],
    931: [0, 0.69444, 0.11983, 0, 0.72222],
    933: [0, 0.69444, 0.09031, 0, 0.77778],
    934: [0, 0.69444, 0.04603, 0, 0.72222],
    936: [0, 0.69444, 0.09031, 0, 0.77778],
    937: [0, 0.69444, 0.08293, 0, 0.72222],
    8211: [0, 0.44444, 0.08616, 0, 0.5],
    8212: [0, 0.44444, 0.08616, 0, 1],
    8216: [0, 0.69444, 0.07816, 0, 0.27778],
    8217: [0, 0.69444, 0.07816, 0, 0.27778],
    8220: [0, 0.69444, 0.14205, 0, 0.5],
    8221: [0, 0.69444, 316e-5, 0, 0.5]
  },
  "SansSerif-Regular": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0, 0, 0.31945],
    34: [0, 0.69444, 0, 0, 0.5],
    35: [0.19444, 0.69444, 0, 0, 0.83334],
    36: [0.05556, 0.75, 0, 0, 0.5],
    37: [0.05556, 0.75, 0, 0, 0.83334],
    38: [0, 0.69444, 0, 0, 0.75834],
    39: [0, 0.69444, 0, 0, 0.27778],
    40: [0.25, 0.75, 0, 0, 0.38889],
    41: [0.25, 0.75, 0, 0, 0.38889],
    42: [0, 0.75, 0, 0, 0.5],
    43: [0.08333, 0.58333, 0, 0, 0.77778],
    44: [0.125, 0.08333, 0, 0, 0.27778],
    45: [0, 0.44444, 0, 0, 0.33333],
    46: [0, 0.08333, 0, 0, 0.27778],
    47: [0.25, 0.75, 0, 0, 0.5],
    48: [0, 0.65556, 0, 0, 0.5],
    49: [0, 0.65556, 0, 0, 0.5],
    50: [0, 0.65556, 0, 0, 0.5],
    51: [0, 0.65556, 0, 0, 0.5],
    52: [0, 0.65556, 0, 0, 0.5],
    53: [0, 0.65556, 0, 0, 0.5],
    54: [0, 0.65556, 0, 0, 0.5],
    55: [0, 0.65556, 0, 0, 0.5],
    56: [0, 0.65556, 0, 0, 0.5],
    57: [0, 0.65556, 0, 0, 0.5],
    58: [0, 0.44444, 0, 0, 0.27778],
    59: [0.125, 0.44444, 0, 0, 0.27778],
    61: [-0.13, 0.37, 0, 0, 0.77778],
    63: [0, 0.69444, 0, 0, 0.47222],
    64: [0, 0.69444, 0, 0, 0.66667],
    65: [0, 0.69444, 0, 0, 0.66667],
    66: [0, 0.69444, 0, 0, 0.66667],
    67: [0, 0.69444, 0, 0, 0.63889],
    68: [0, 0.69444, 0, 0, 0.72223],
    69: [0, 0.69444, 0, 0, 0.59722],
    70: [0, 0.69444, 0, 0, 0.56945],
    71: [0, 0.69444, 0, 0, 0.66667],
    72: [0, 0.69444, 0, 0, 0.70834],
    73: [0, 0.69444, 0, 0, 0.27778],
    74: [0, 0.69444, 0, 0, 0.47222],
    75: [0, 0.69444, 0, 0, 0.69445],
    76: [0, 0.69444, 0, 0, 0.54167],
    77: [0, 0.69444, 0, 0, 0.875],
    78: [0, 0.69444, 0, 0, 0.70834],
    79: [0, 0.69444, 0, 0, 0.73611],
    80: [0, 0.69444, 0, 0, 0.63889],
    81: [0.125, 0.69444, 0, 0, 0.73611],
    82: [0, 0.69444, 0, 0, 0.64584],
    83: [0, 0.69444, 0, 0, 0.55556],
    84: [0, 0.69444, 0, 0, 0.68056],
    85: [0, 0.69444, 0, 0, 0.6875],
    86: [0, 0.69444, 0.01389, 0, 0.66667],
    87: [0, 0.69444, 0.01389, 0, 0.94445],
    88: [0, 0.69444, 0, 0, 0.66667],
    89: [0, 0.69444, 0.025, 0, 0.66667],
    90: [0, 0.69444, 0, 0, 0.61111],
    91: [0.25, 0.75, 0, 0, 0.28889],
    93: [0.25, 0.75, 0, 0, 0.28889],
    94: [0, 0.69444, 0, 0, 0.5],
    95: [0.35, 0.09444, 0.02778, 0, 0.5],
    97: [0, 0.44444, 0, 0, 0.48056],
    98: [0, 0.69444, 0, 0, 0.51667],
    99: [0, 0.44444, 0, 0, 0.44445],
    100: [0, 0.69444, 0, 0, 0.51667],
    101: [0, 0.44444, 0, 0, 0.44445],
    102: [0, 0.69444, 0.06944, 0, 0.30556],
    103: [0.19444, 0.44444, 0.01389, 0, 0.5],
    104: [0, 0.69444, 0, 0, 0.51667],
    105: [0, 0.67937, 0, 0, 0.23889],
    106: [0.19444, 0.67937, 0, 0, 0.26667],
    107: [0, 0.69444, 0, 0, 0.48889],
    108: [0, 0.69444, 0, 0, 0.23889],
    109: [0, 0.44444, 0, 0, 0.79445],
    110: [0, 0.44444, 0, 0, 0.51667],
    111: [0, 0.44444, 0, 0, 0.5],
    112: [0.19444, 0.44444, 0, 0, 0.51667],
    113: [0.19444, 0.44444, 0, 0, 0.51667],
    114: [0, 0.44444, 0.01389, 0, 0.34167],
    115: [0, 0.44444, 0, 0, 0.38333],
    116: [0, 0.57143, 0, 0, 0.36111],
    117: [0, 0.44444, 0, 0, 0.51667],
    118: [0, 0.44444, 0.01389, 0, 0.46111],
    119: [0, 0.44444, 0.01389, 0, 0.68334],
    120: [0, 0.44444, 0, 0, 0.46111],
    121: [0.19444, 0.44444, 0.01389, 0, 0.46111],
    122: [0, 0.44444, 0, 0, 0.43472],
    126: [0.35, 0.32659, 0, 0, 0.5],
    160: [0, 0, 0, 0, 0.25],
    168: [0, 0.67937, 0, 0, 0.5],
    176: [0, 0.69444, 0, 0, 0.66667],
    184: [0.17014, 0, 0, 0, 0.44445],
    305: [0, 0.44444, 0, 0, 0.23889],
    567: [0.19444, 0.44444, 0, 0, 0.26667],
    710: [0, 0.69444, 0, 0, 0.5],
    711: [0, 0.63194, 0, 0, 0.5],
    713: [0, 0.60889, 0, 0, 0.5],
    714: [0, 0.69444, 0, 0, 0.5],
    715: [0, 0.69444, 0, 0, 0.5],
    728: [0, 0.69444, 0, 0, 0.5],
    729: [0, 0.67937, 0, 0, 0.27778],
    730: [0, 0.69444, 0, 0, 0.66667],
    732: [0, 0.67659, 0, 0, 0.5],
    733: [0, 0.69444, 0, 0, 0.5],
    915: [0, 0.69444, 0, 0, 0.54167],
    916: [0, 0.69444, 0, 0, 0.83334],
    920: [0, 0.69444, 0, 0, 0.77778],
    923: [0, 0.69444, 0, 0, 0.61111],
    926: [0, 0.69444, 0, 0, 0.66667],
    928: [0, 0.69444, 0, 0, 0.70834],
    931: [0, 0.69444, 0, 0, 0.72222],
    933: [0, 0.69444, 0, 0, 0.77778],
    934: [0, 0.69444, 0, 0, 0.72222],
    936: [0, 0.69444, 0, 0, 0.77778],
    937: [0, 0.69444, 0, 0, 0.72222],
    8211: [0, 0.44444, 0.02778, 0, 0.5],
    8212: [0, 0.44444, 0.02778, 0, 1],
    8216: [0, 0.69444, 0, 0, 0.27778],
    8217: [0, 0.69444, 0, 0, 0.27778],
    8220: [0, 0.69444, 0, 0, 0.5],
    8221: [0, 0.69444, 0, 0, 0.5]
  },
  "Script-Regular": {
    32: [0, 0, 0, 0, 0.25],
    65: [0, 0.7, 0.22925, 0, 0.80253],
    66: [0, 0.7, 0.04087, 0, 0.90757],
    67: [0, 0.7, 0.1689, 0, 0.66619],
    68: [0, 0.7, 0.09371, 0, 0.77443],
    69: [0, 0.7, 0.18583, 0, 0.56162],
    70: [0, 0.7, 0.13634, 0, 0.89544],
    71: [0, 0.7, 0.17322, 0, 0.60961],
    72: [0, 0.7, 0.29694, 0, 0.96919],
    73: [0, 0.7, 0.19189, 0, 0.80907],
    74: [0.27778, 0.7, 0.19189, 0, 1.05159],
    75: [0, 0.7, 0.31259, 0, 0.91364],
    76: [0, 0.7, 0.19189, 0, 0.87373],
    77: [0, 0.7, 0.15981, 0, 1.08031],
    78: [0, 0.7, 0.3525, 0, 0.9015],
    79: [0, 0.7, 0.08078, 0, 0.73787],
    80: [0, 0.7, 0.08078, 0, 1.01262],
    81: [0, 0.7, 0.03305, 0, 0.88282],
    82: [0, 0.7, 0.06259, 0, 0.85],
    83: [0, 0.7, 0.19189, 0, 0.86767],
    84: [0, 0.7, 0.29087, 0, 0.74697],
    85: [0, 0.7, 0.25815, 0, 0.79996],
    86: [0, 0.7, 0.27523, 0, 0.62204],
    87: [0, 0.7, 0.27523, 0, 0.80532],
    88: [0, 0.7, 0.26006, 0, 0.94445],
    89: [0, 0.7, 0.2939, 0, 0.70961],
    90: [0, 0.7, 0.24037, 0, 0.8212],
    160: [0, 0, 0, 0, 0.25]
  },
  "Size1-Regular": {
    32: [0, 0, 0, 0, 0.25],
    40: [0.35001, 0.85, 0, 0, 0.45834],
    41: [0.35001, 0.85, 0, 0, 0.45834],
    47: [0.35001, 0.85, 0, 0, 0.57778],
    91: [0.35001, 0.85, 0, 0, 0.41667],
    92: [0.35001, 0.85, 0, 0, 0.57778],
    93: [0.35001, 0.85, 0, 0, 0.41667],
    123: [0.35001, 0.85, 0, 0, 0.58334],
    125: [0.35001, 0.85, 0, 0, 0.58334],
    160: [0, 0, 0, 0, 0.25],
    710: [0, 0.72222, 0, 0, 0.55556],
    732: [0, 0.72222, 0, 0, 0.55556],
    770: [0, 0.72222, 0, 0, 0.55556],
    771: [0, 0.72222, 0, 0, 0.55556],
    8214: [-99e-5, 0.601, 0, 0, 0.77778],
    8593: [1e-5, 0.6, 0, 0, 0.66667],
    8595: [1e-5, 0.6, 0, 0, 0.66667],
    8657: [1e-5, 0.6, 0, 0, 0.77778],
    8659: [1e-5, 0.6, 0, 0, 0.77778],
    8719: [0.25001, 0.75, 0, 0, 0.94445],
    8720: [0.25001, 0.75, 0, 0, 0.94445],
    8721: [0.25001, 0.75, 0, 0, 1.05556],
    8730: [0.35001, 0.85, 0, 0, 1],
    8739: [-599e-5, 0.606, 0, 0, 0.33333],
    8741: [-599e-5, 0.606, 0, 0, 0.55556],
    8747: [0.30612, 0.805, 0.19445, 0, 0.47222],
    8748: [0.306, 0.805, 0.19445, 0, 0.47222],
    8749: [0.306, 0.805, 0.19445, 0, 0.47222],
    8750: [0.30612, 0.805, 0.19445, 0, 0.47222],
    8896: [0.25001, 0.75, 0, 0, 0.83334],
    8897: [0.25001, 0.75, 0, 0, 0.83334],
    8898: [0.25001, 0.75, 0, 0, 0.83334],
    8899: [0.25001, 0.75, 0, 0, 0.83334],
    8968: [0.35001, 0.85, 0, 0, 0.47222],
    8969: [0.35001, 0.85, 0, 0, 0.47222],
    8970: [0.35001, 0.85, 0, 0, 0.47222],
    8971: [0.35001, 0.85, 0, 0, 0.47222],
    9168: [-99e-5, 0.601, 0, 0, 0.66667],
    10216: [0.35001, 0.85, 0, 0, 0.47222],
    10217: [0.35001, 0.85, 0, 0, 0.47222],
    10752: [0.25001, 0.75, 0, 0, 1.11111],
    10753: [0.25001, 0.75, 0, 0, 1.11111],
    10754: [0.25001, 0.75, 0, 0, 1.11111],
    10756: [0.25001, 0.75, 0, 0, 0.83334],
    10758: [0.25001, 0.75, 0, 0, 0.83334]
  },
  "Size2-Regular": {
    32: [0, 0, 0, 0, 0.25],
    40: [0.65002, 1.15, 0, 0, 0.59722],
    41: [0.65002, 1.15, 0, 0, 0.59722],
    47: [0.65002, 1.15, 0, 0, 0.81111],
    91: [0.65002, 1.15, 0, 0, 0.47222],
    92: [0.65002, 1.15, 0, 0, 0.81111],
    93: [0.65002, 1.15, 0, 0, 0.47222],
    123: [0.65002, 1.15, 0, 0, 0.66667],
    125: [0.65002, 1.15, 0, 0, 0.66667],
    160: [0, 0, 0, 0, 0.25],
    710: [0, 0.75, 0, 0, 1],
    732: [0, 0.75, 0, 0, 1],
    770: [0, 0.75, 0, 0, 1],
    771: [0, 0.75, 0, 0, 1],
    8719: [0.55001, 1.05, 0, 0, 1.27778],
    8720: [0.55001, 1.05, 0, 0, 1.27778],
    8721: [0.55001, 1.05, 0, 0, 1.44445],
    8730: [0.65002, 1.15, 0, 0, 1],
    8747: [0.86225, 1.36, 0.44445, 0, 0.55556],
    8748: [0.862, 1.36, 0.44445, 0, 0.55556],
    8749: [0.862, 1.36, 0.44445, 0, 0.55556],
    8750: [0.86225, 1.36, 0.44445, 0, 0.55556],
    8896: [0.55001, 1.05, 0, 0, 1.11111],
    8897: [0.55001, 1.05, 0, 0, 1.11111],
    8898: [0.55001, 1.05, 0, 0, 1.11111],
    8899: [0.55001, 1.05, 0, 0, 1.11111],
    8968: [0.65002, 1.15, 0, 0, 0.52778],
    8969: [0.65002, 1.15, 0, 0, 0.52778],
    8970: [0.65002, 1.15, 0, 0, 0.52778],
    8971: [0.65002, 1.15, 0, 0, 0.52778],
    10216: [0.65002, 1.15, 0, 0, 0.61111],
    10217: [0.65002, 1.15, 0, 0, 0.61111],
    10752: [0.55001, 1.05, 0, 0, 1.51112],
    10753: [0.55001, 1.05, 0, 0, 1.51112],
    10754: [0.55001, 1.05, 0, 0, 1.51112],
    10756: [0.55001, 1.05, 0, 0, 1.11111],
    10758: [0.55001, 1.05, 0, 0, 1.11111]
  },
  "Size3-Regular": {
    32: [0, 0, 0, 0, 0.25],
    40: [0.95003, 1.45, 0, 0, 0.73611],
    41: [0.95003, 1.45, 0, 0, 0.73611],
    47: [0.95003, 1.45, 0, 0, 1.04445],
    91: [0.95003, 1.45, 0, 0, 0.52778],
    92: [0.95003, 1.45, 0, 0, 1.04445],
    93: [0.95003, 1.45, 0, 0, 0.52778],
    123: [0.95003, 1.45, 0, 0, 0.75],
    125: [0.95003, 1.45, 0, 0, 0.75],
    160: [0, 0, 0, 0, 0.25],
    710: [0, 0.75, 0, 0, 1.44445],
    732: [0, 0.75, 0, 0, 1.44445],
    770: [0, 0.75, 0, 0, 1.44445],
    771: [0, 0.75, 0, 0, 1.44445],
    8730: [0.95003, 1.45, 0, 0, 1],
    8968: [0.95003, 1.45, 0, 0, 0.58334],
    8969: [0.95003, 1.45, 0, 0, 0.58334],
    8970: [0.95003, 1.45, 0, 0, 0.58334],
    8971: [0.95003, 1.45, 0, 0, 0.58334],
    10216: [0.95003, 1.45, 0, 0, 0.75],
    10217: [0.95003, 1.45, 0, 0, 0.75]
  },
  "Size4-Regular": {
    32: [0, 0, 0, 0, 0.25],
    40: [1.25003, 1.75, 0, 0, 0.79167],
    41: [1.25003, 1.75, 0, 0, 0.79167],
    47: [1.25003, 1.75, 0, 0, 1.27778],
    91: [1.25003, 1.75, 0, 0, 0.58334],
    92: [1.25003, 1.75, 0, 0, 1.27778],
    93: [1.25003, 1.75, 0, 0, 0.58334],
    123: [1.25003, 1.75, 0, 0, 0.80556],
    125: [1.25003, 1.75, 0, 0, 0.80556],
    160: [0, 0, 0, 0, 0.25],
    710: [0, 0.825, 0, 0, 1.8889],
    732: [0, 0.825, 0, 0, 1.8889],
    770: [0, 0.825, 0, 0, 1.8889],
    771: [0, 0.825, 0, 0, 1.8889],
    8730: [1.25003, 1.75, 0, 0, 1],
    8968: [1.25003, 1.75, 0, 0, 0.63889],
    8969: [1.25003, 1.75, 0, 0, 0.63889],
    8970: [1.25003, 1.75, 0, 0, 0.63889],
    8971: [1.25003, 1.75, 0, 0, 0.63889],
    9115: [0.64502, 1.155, 0, 0, 0.875],
    9116: [1e-5, 0.6, 0, 0, 0.875],
    9117: [0.64502, 1.155, 0, 0, 0.875],
    9118: [0.64502, 1.155, 0, 0, 0.875],
    9119: [1e-5, 0.6, 0, 0, 0.875],
    9120: [0.64502, 1.155, 0, 0, 0.875],
    9121: [0.64502, 1.155, 0, 0, 0.66667],
    9122: [-99e-5, 0.601, 0, 0, 0.66667],
    9123: [0.64502, 1.155, 0, 0, 0.66667],
    9124: [0.64502, 1.155, 0, 0, 0.66667],
    9125: [-99e-5, 0.601, 0, 0, 0.66667],
    9126: [0.64502, 1.155, 0, 0, 0.66667],
    9127: [1e-5, 0.9, 0, 0, 0.88889],
    9128: [0.65002, 1.15, 0, 0, 0.88889],
    9129: [0.90001, 0, 0, 0, 0.88889],
    9130: [0, 0.3, 0, 0, 0.88889],
    9131: [1e-5, 0.9, 0, 0, 0.88889],
    9132: [0.65002, 1.15, 0, 0, 0.88889],
    9133: [0.90001, 0, 0, 0, 0.88889],
    9143: [0.88502, 0.915, 0, 0, 1.05556],
    10216: [1.25003, 1.75, 0, 0, 0.80556],
    10217: [1.25003, 1.75, 0, 0, 0.80556],
    57344: [-499e-5, 0.605, 0, 0, 1.05556],
    57345: [-499e-5, 0.605, 0, 0, 1.05556],
    57680: [0, 0.12, 0, 0, 0.45],
    57681: [0, 0.12, 0, 0, 0.45],
    57682: [0, 0.12, 0, 0, 0.45],
    57683: [0, 0.12, 0, 0, 0.45]
  },
  "Typewriter-Regular": {
    32: [0, 0, 0, 0, 0.525],
    33: [0, 0.61111, 0, 0, 0.525],
    34: [0, 0.61111, 0, 0, 0.525],
    35: [0, 0.61111, 0, 0, 0.525],
    36: [0.08333, 0.69444, 0, 0, 0.525],
    37: [0.08333, 0.69444, 0, 0, 0.525],
    38: [0, 0.61111, 0, 0, 0.525],
    39: [0, 0.61111, 0, 0, 0.525],
    40: [0.08333, 0.69444, 0, 0, 0.525],
    41: [0.08333, 0.69444, 0, 0, 0.525],
    42: [0, 0.52083, 0, 0, 0.525],
    43: [-0.08056, 0.53055, 0, 0, 0.525],
    44: [0.13889, 0.125, 0, 0, 0.525],
    45: [-0.08056, 0.53055, 0, 0, 0.525],
    46: [0, 0.125, 0, 0, 0.525],
    47: [0.08333, 0.69444, 0, 0, 0.525],
    48: [0, 0.61111, 0, 0, 0.525],
    49: [0, 0.61111, 0, 0, 0.525],
    50: [0, 0.61111, 0, 0, 0.525],
    51: [0, 0.61111, 0, 0, 0.525],
    52: [0, 0.61111, 0, 0, 0.525],
    53: [0, 0.61111, 0, 0, 0.525],
    54: [0, 0.61111, 0, 0, 0.525],
    55: [0, 0.61111, 0, 0, 0.525],
    56: [0, 0.61111, 0, 0, 0.525],
    57: [0, 0.61111, 0, 0, 0.525],
    58: [0, 0.43056, 0, 0, 0.525],
    59: [0.13889, 0.43056, 0, 0, 0.525],
    60: [-0.05556, 0.55556, 0, 0, 0.525],
    61: [-0.19549, 0.41562, 0, 0, 0.525],
    62: [-0.05556, 0.55556, 0, 0, 0.525],
    63: [0, 0.61111, 0, 0, 0.525],
    64: [0, 0.61111, 0, 0, 0.525],
    65: [0, 0.61111, 0, 0, 0.525],
    66: [0, 0.61111, 0, 0, 0.525],
    67: [0, 0.61111, 0, 0, 0.525],
    68: [0, 0.61111, 0, 0, 0.525],
    69: [0, 0.61111, 0, 0, 0.525],
    70: [0, 0.61111, 0, 0, 0.525],
    71: [0, 0.61111, 0, 0, 0.525],
    72: [0, 0.61111, 0, 0, 0.525],
    73: [0, 0.61111, 0, 0, 0.525],
    74: [0, 0.61111, 0, 0, 0.525],
    75: [0, 0.61111, 0, 0, 0.525],
    76: [0, 0.61111, 0, 0, 0.525],
    77: [0, 0.61111, 0, 0, 0.525],
    78: [0, 0.61111, 0, 0, 0.525],
    79: [0, 0.61111, 0, 0, 0.525],
    80: [0, 0.61111, 0, 0, 0.525],
    81: [0.13889, 0.61111, 0, 0, 0.525],
    82: [0, 0.61111, 0, 0, 0.525],
    83: [0, 0.61111, 0, 0, 0.525],
    84: [0, 0.61111, 0, 0, 0.525],
    85: [0, 0.61111, 0, 0, 0.525],
    86: [0, 0.61111, 0, 0, 0.525],
    87: [0, 0.61111, 0, 0, 0.525],
    88: [0, 0.61111, 0, 0, 0.525],
    89: [0, 0.61111, 0, 0, 0.525],
    90: [0, 0.61111, 0, 0, 0.525],
    91: [0.08333, 0.69444, 0, 0, 0.525],
    92: [0.08333, 0.69444, 0, 0, 0.525],
    93: [0.08333, 0.69444, 0, 0, 0.525],
    94: [0, 0.61111, 0, 0, 0.525],
    95: [0.09514, 0, 0, 0, 0.525],
    96: [0, 0.61111, 0, 0, 0.525],
    97: [0, 0.43056, 0, 0, 0.525],
    98: [0, 0.61111, 0, 0, 0.525],
    99: [0, 0.43056, 0, 0, 0.525],
    100: [0, 0.61111, 0, 0, 0.525],
    101: [0, 0.43056, 0, 0, 0.525],
    102: [0, 0.61111, 0, 0, 0.525],
    103: [0.22222, 0.43056, 0, 0, 0.525],
    104: [0, 0.61111, 0, 0, 0.525],
    105: [0, 0.61111, 0, 0, 0.525],
    106: [0.22222, 0.61111, 0, 0, 0.525],
    107: [0, 0.61111, 0, 0, 0.525],
    108: [0, 0.61111, 0, 0, 0.525],
    109: [0, 0.43056, 0, 0, 0.525],
    110: [0, 0.43056, 0, 0, 0.525],
    111: [0, 0.43056, 0, 0, 0.525],
    112: [0.22222, 0.43056, 0, 0, 0.525],
    113: [0.22222, 0.43056, 0, 0, 0.525],
    114: [0, 0.43056, 0, 0, 0.525],
    115: [0, 0.43056, 0, 0, 0.525],
    116: [0, 0.55358, 0, 0, 0.525],
    117: [0, 0.43056, 0, 0, 0.525],
    118: [0, 0.43056, 0, 0, 0.525],
    119: [0, 0.43056, 0, 0, 0.525],
    120: [0, 0.43056, 0, 0, 0.525],
    121: [0.22222, 0.43056, 0, 0, 0.525],
    122: [0, 0.43056, 0, 0, 0.525],
    123: [0.08333, 0.69444, 0, 0, 0.525],
    124: [0.08333, 0.69444, 0, 0, 0.525],
    125: [0.08333, 0.69444, 0, 0, 0.525],
    126: [0, 0.61111, 0, 0, 0.525],
    127: [0, 0.61111, 0, 0, 0.525],
    160: [0, 0, 0, 0, 0.525],
    176: [0, 0.61111, 0, 0, 0.525],
    184: [0.19445, 0, 0, 0, 0.525],
    305: [0, 0.43056, 0, 0, 0.525],
    567: [0.22222, 0.43056, 0, 0, 0.525],
    711: [0, 0.56597, 0, 0, 0.525],
    713: [0, 0.56555, 0, 0, 0.525],
    714: [0, 0.61111, 0, 0, 0.525],
    715: [0, 0.61111, 0, 0, 0.525],
    728: [0, 0.61111, 0, 0, 0.525],
    730: [0, 0.61111, 0, 0, 0.525],
    770: [0, 0.61111, 0, 0, 0.525],
    771: [0, 0.61111, 0, 0, 0.525],
    776: [0, 0.61111, 0, 0, 0.525],
    915: [0, 0.61111, 0, 0, 0.525],
    916: [0, 0.61111, 0, 0, 0.525],
    920: [0, 0.61111, 0, 0, 0.525],
    923: [0, 0.61111, 0, 0, 0.525],
    926: [0, 0.61111, 0, 0, 0.525],
    928: [0, 0.61111, 0, 0, 0.525],
    931: [0, 0.61111, 0, 0, 0.525],
    933: [0, 0.61111, 0, 0, 0.525],
    934: [0, 0.61111, 0, 0, 0.525],
    936: [0, 0.61111, 0, 0, 0.525],
    937: [0, 0.61111, 0, 0, 0.525],
    8216: [0, 0.61111, 0, 0, 0.525],
    8217: [0, 0.61111, 0, 0, 0.525],
    8242: [0, 0.61111, 0, 0, 0.525],
    9251: [0.11111, 0.21944, 0, 0, 0.525]
  }
}, ip = {
  slant: [0.25, 0.25, 0.25],
  // sigma1
  space: [0, 0, 0],
  // sigma2
  stretch: [0, 0, 0],
  // sigma3
  shrink: [0, 0, 0],
  // sigma4
  xHeight: [0.431, 0.431, 0.431],
  // sigma5
  quad: [1, 1.171, 1.472],
  // sigma6
  extraSpace: [0, 0, 0],
  // sigma7
  num1: [0.677, 0.732, 0.925],
  // sigma8
  num2: [0.394, 0.384, 0.387],
  // sigma9
  num3: [0.444, 0.471, 0.504],
  // sigma10
  denom1: [0.686, 0.752, 1.025],
  // sigma11
  denom2: [0.345, 0.344, 0.532],
  // sigma12
  sup1: [0.413, 0.503, 0.504],
  // sigma13
  sup2: [0.363, 0.431, 0.404],
  // sigma14
  sup3: [0.289, 0.286, 0.294],
  // sigma15
  sub1: [0.15, 0.143, 0.2],
  // sigma16
  sub2: [0.247, 0.286, 0.4],
  // sigma17
  supDrop: [0.386, 0.353, 0.494],
  // sigma18
  subDrop: [0.05, 0.071, 0.1],
  // sigma19
  delim1: [2.39, 1.7, 1.98],
  // sigma20
  delim2: [1.01, 1.157, 1.42],
  // sigma21
  axisHeight: [0.25, 0.25, 0.25],
  // sigma22
  // These font metrics are extracted from TeX by using tftopl on cmex10.tfm;
  // they correspond to the font parameters of the extension fonts (family 3).
  // See the TeXbook, page 441. In AMSTeX, the extension fonts scale; to
  // match cmex7, we'd use cmex7.tfm values for script and scriptscript
  // values.
  defaultRuleThickness: [0.04, 0.049, 0.049],
  // xi8; cmex7: 0.049
  bigOpSpacing1: [0.111, 0.111, 0.111],
  // xi9
  bigOpSpacing2: [0.166, 0.166, 0.166],
  // xi10
  bigOpSpacing3: [0.2, 0.2, 0.2],
  // xi11
  bigOpSpacing4: [0.6, 0.611, 0.611],
  // xi12; cmex7: 0.611
  bigOpSpacing5: [0.1, 0.143, 0.143],
  // xi13; cmex7: 0.143
  // The \sqrt rule width is taken from the height of the surd character.
  // Since we use the same font at all sizes, this thickness doesn't scale.
  sqrtRuleThickness: [0.04, 0.04, 0.04],
  // This value determines how large a pt is, for metrics which are defined
  // in terms of pts.
  // This value is also used in katex.less; if you change it make sure the
  // values match.
  ptPerEm: [10, 10, 10],
  // The space between adjacent `|` columns in an array definition. From
  // `\showthe\doublerulesep` in LaTeX. Equals 2.0 / ptPerEm.
  doubleRuleSep: [0.2, 0.2, 0.2],
  // The width of separator lines in {array} environments. From
  // `\showthe\arrayrulewidth` in LaTeX. Equals 0.4 / ptPerEm.
  arrayRuleWidth: [0.04, 0.04, 0.04],
  // Two values from LaTeX source2e:
  fboxsep: [0.3, 0.3, 0.3],
  //        3 pt / ptPerEm
  fboxrule: [0.04, 0.04, 0.04]
  // 0.4 pt / ptPerEm
}, i4 = {
  // Latin-1
  Å: "A",
  Ð: "D",
  Þ: "o",
  å: "a",
  ð: "d",
  þ: "o",
  // Cyrillic
  А: "A",
  Б: "B",
  В: "B",
  Г: "F",
  Д: "A",
  Е: "E",
  Ж: "K",
  З: "3",
  И: "N",
  Й: "N",
  К: "K",
  Л: "N",
  М: "M",
  Н: "H",
  О: "O",
  П: "N",
  Р: "P",
  С: "C",
  Т: "T",
  У: "y",
  Ф: "O",
  Х: "X",
  Ц: "U",
  Ч: "h",
  Ш: "W",
  Щ: "W",
  Ъ: "B",
  Ы: "X",
  Ь: "B",
  Э: "3",
  Ю: "X",
  Я: "R",
  а: "a",
  б: "b",
  в: "a",
  г: "r",
  д: "y",
  е: "e",
  ж: "m",
  з: "e",
  и: "n",
  й: "n",
  к: "n",
  л: "n",
  м: "m",
  н: "n",
  о: "o",
  п: "n",
  р: "p",
  с: "c",
  т: "o",
  у: "y",
  ф: "b",
  х: "x",
  ц: "n",
  ч: "n",
  ш: "w",
  щ: "w",
  ъ: "a",
  ы: "m",
  ь: "a",
  э: "e",
  ю: "m",
  я: "r"
};
function I_(e, t) {
  Vs[e] = t;
}
function U2(e, t, i) {
  if (!Vs[t])
    throw new Error("Font metrics not found for font: " + t + ".");
  var r = e.charCodeAt(0), n = Vs[t][r];
  if (!n && e[0] in i4 && (r = i4[e[0]].charCodeAt(0), n = Vs[t][r]), !n && i === "text" && M7(r) && (n = Vs[t][77]), n)
    return {
      depth: n[0],
      height: n[1],
      italic: n[2],
      skew: n[3],
      width: n[4]
    };
}
var Hy = {};
function S_(e) {
  var t;
  if (e >= 5 ? t = 0 : e >= 3 ? t = 1 : t = 2, !Hy[t]) {
    var i = Hy[t] = {
      cssEmPerMu: ip.quad[t] / 18
    };
    for (var r in ip)
      ip.hasOwnProperty(r) && (i[r] = ip[r][t]);
  }
  return Hy[t];
}
var R_ = [
  // Each element contains [textsize, scriptsize, scriptscriptsize].
  // The size mappings are taken from TeX with \normalsize=10pt.
  [1, 1, 1],
  // size1: [5, 5, 5]              \tiny
  [2, 1, 1],
  // size2: [6, 5, 5]
  [3, 1, 1],
  // size3: [7, 5, 5]              \scriptsize
  [4, 2, 1],
  // size4: [8, 6, 5]              \footnotesize
  [5, 2, 1],
  // size5: [9, 6, 5]              \small
  [6, 3, 1],
  // size6: [10, 7, 5]             \normalsize
  [7, 4, 2],
  // size7: [12, 8, 6]             \large
  [8, 6, 3],
  // size8: [14.4, 10, 7]          \Large
  [9, 7, 6],
  // size9: [17.28, 12, 10]        \LARGE
  [10, 8, 7],
  // size10: [20.74, 14.4, 12]     \huge
  [11, 10, 9]
  // size11: [24.88, 20.74, 17.28] \HUGE
], r4 = [
  // fontMetrics.js:getGlobalMetrics also uses size indexes, so if
  // you change size indexes, change that function.
  0.5,
  0.6,
  0.7,
  0.8,
  0.9,
  1,
  1.2,
  1.44,
  1.728,
  2.074,
  2.488
], n4 = function(t, i) {
  return i.size < 2 ? t : R_[t - 1][i.size - 1];
};
class ba {
  // A font family applies to a group of fonts (i.e. SansSerif), while a font
  // represents a specific font (i.e. SansSerif Bold).
  // See: https://tex.stackexchange.com/questions/22350/difference-between-textrm-and-mathrm
  /**
   * The base size index.
   */
  constructor(t) {
    this.style = void 0, this.color = void 0, this.size = void 0, this.textSize = void 0, this.phantom = void 0, this.font = void 0, this.fontFamily = void 0, this.fontWeight = void 0, this.fontShape = void 0, this.sizeMultiplier = void 0, this.maxSize = void 0, this.minRuleThickness = void 0, this._fontMetrics = void 0, this.style = t.style, this.color = t.color, this.size = t.size || ba.BASESIZE, this.textSize = t.textSize || this.size, this.phantom = !!t.phantom, this.font = t.font || "", this.fontFamily = t.fontFamily || "", this.fontWeight = t.fontWeight || "", this.fontShape = t.fontShape || "", this.sizeMultiplier = r4[this.size - 1], this.maxSize = t.maxSize, this.minRuleThickness = t.minRuleThickness, this._fontMetrics = void 0;
  }
  /**
   * Returns a new options object with the same properties as "this".  Properties
   * from "extension" will be copied to the new options object.
   */
  extend(t) {
    var i = {
      style: this.style,
      size: this.size,
      textSize: this.textSize,
      color: this.color,
      phantom: this.phantom,
      font: this.font,
      fontFamily: this.fontFamily,
      fontWeight: this.fontWeight,
      fontShape: this.fontShape,
      maxSize: this.maxSize,
      minRuleThickness: this.minRuleThickness
    };
    for (var r in t)
      t.hasOwnProperty(r) && (i[r] = t[r]);
    return new ba(i);
  }
  /**
   * Return an options object with the given style. If `this.style === style`,
   * returns `this`.
   */
  havingStyle(t) {
    return this.style === t ? this : this.extend({
      style: t,
      size: n4(this.textSize, t)
    });
  }
  /**
   * Return an options object with a cramped version of the current style. If
   * the current style is cramped, returns `this`.
   */
  havingCrampedStyle() {
    return this.havingStyle(this.style.cramp());
  }
  /**
   * Return an options object with the given size and in at least `\textstyle`.
   * Returns `this` if appropriate.
   */
  havingSize(t) {
    return this.size === t && this.textSize === t ? this : this.extend({
      style: this.style.text(),
      size: t,
      textSize: t,
      sizeMultiplier: r4[t - 1]
    });
  }
  /**
   * Like `this.havingSize(BASESIZE).havingStyle(style)`. If `style` is omitted,
   * changes to at least `\textstyle`.
   */
  havingBaseStyle(t) {
    t = t || this.style.text();
    var i = n4(ba.BASESIZE, t);
    return this.size === i && this.textSize === ba.BASESIZE && this.style === t ? this : this.extend({
      style: t,
      size: i
    });
  }
  /**
   * Remove the effect of sizing changes such as \Huge.
   * Keep the effect of the current style, such as \scriptstyle.
   */
  havingBaseSizing() {
    var t;
    switch (this.style.id) {
      case 4:
      case 5:
        t = 3;
        break;
      case 6:
      case 7:
        t = 1;
        break;
      default:
        t = 6;
    }
    return this.extend({
      style: this.style.text(),
      size: t
    });
  }
  /**
   * Create a new options object with the given color.
   */
  withColor(t) {
    return this.extend({
      color: t
    });
  }
  /**
   * Create a new options object with "phantom" set to true.
   */
  withPhantom() {
    return this.extend({
      phantom: !0
    });
  }
  /**
   * Creates a new options object with the given math font or old text font.
   * @type {[type]}
   */
  withFont(t) {
    return this.extend({
      font: t
    });
  }
  /**
   * Create a new options objects with the given fontFamily.
   */
  withTextFontFamily(t) {
    return this.extend({
      fontFamily: t,
      font: ""
    });
  }
  /**
   * Creates a new options object with the given font weight
   */
  withTextFontWeight(t) {
    return this.extend({
      fontWeight: t,
      font: ""
    });
  }
  /**
   * Creates a new options object with the given font weight
   */
  withTextFontShape(t) {
    return this.extend({
      fontShape: t,
      font: ""
    });
  }
  /**
   * Return the CSS sizing classes required to switch from enclosing options
   * `oldOptions` to `this`. Returns an array of classes.
   */
  sizingClasses(t) {
    return t.size !== this.size ? ["sizing", "reset-size" + t.size, "size" + this.size] : [];
  }
  /**
   * Return the CSS sizing classes required to switch to the base size. Like
   * `this.havingSize(BASESIZE).sizingClasses(this)`.
   */
  baseSizingClasses() {
    return this.size !== ba.BASESIZE ? ["sizing", "reset-size" + this.size, "size" + ba.BASESIZE] : [];
  }
  /**
   * Return the font metrics for this size.
   */
  fontMetrics() {
    return this._fontMetrics || (this._fontMetrics = S_(this.size)), this._fontMetrics;
  }
  /**
   * Gets the CSS color of the current options object
   */
  getColor() {
    return this.phantom ? "transparent" : this.color;
  }
}
ba.BASESIZE = 6;
var Vb = {
  // https://en.wikibooks.org/wiki/LaTeX/Lengths and
  // https://tex.stackexchange.com/a/8263
  pt: 1,
  // TeX point
  mm: 7227 / 2540,
  // millimeter
  cm: 7227 / 254,
  // centimeter
  in: 72.27,
  // inch
  bp: 803 / 800,
  // big (PostScript) points
  pc: 12,
  // pica
  dd: 1238 / 1157,
  // didot
  cc: 14856 / 1157,
  // cicero (12 didot)
  nd: 685 / 642,
  // new didot
  nc: 1370 / 107,
  // new cicero (12 new didot)
  sp: 1 / 65536,
  // scaled point (TeX's internal smallest unit)
  // https://tex.stackexchange.com/a/41371
  px: 803 / 800
  // \pdfpxdimen defaults to 1 bp in pdfTeX and LuaTeX
}, k_ = {
  ex: !0,
  em: !0,
  mu: !0
}, N7 = function(t) {
  return typeof t != "string" && (t = t.unit), t in Vb || t in k_ || t === "ex";
}, Hi = function(t, i) {
  var r;
  if (t.unit in Vb)
    r = Vb[t.unit] / i.fontMetrics().ptPerEm / i.sizeMultiplier;
  else if (t.unit === "mu")
    r = i.fontMetrics().cssEmPerMu;
  else {
    var n;
    if (i.style.isTight() ? n = i.havingStyle(i.style.text()) : n = i, t.unit === "ex")
      r = n.fontMetrics().xHeight;
    else if (t.unit === "em")
      r = n.fontMetrics().quad;
    else
      throw new We("Invalid unit: '" + t.unit + "'");
    n !== i && (r *= n.sizeMultiplier / i.sizeMultiplier);
  }
  return Math.min(t.number * r, i.maxSize);
}, He = function(t) {
  return +t.toFixed(4) + "em";
}, Fl = function(t) {
  return t.filter((i) => i).join(" ");
}, T7 = function(t, i, r) {
  if (this.classes = t || [], this.attributes = {}, this.height = 0, this.depth = 0, this.maxFontSize = 0, this.style = r || {}, i) {
    i.style.isTight() && this.classes.push("mtight");
    var n = i.getColor();
    n && (this.style.color = n);
  }
}, B7 = function(t) {
  var i = document.createElement(t);
  i.className = Fl(this.classes);
  for (var r in this.style)
    this.style.hasOwnProperty(r) && (i.style[r] = this.style[r]);
  for (var n in this.attributes)
    this.attributes.hasOwnProperty(n) && i.setAttribute(n, this.attributes[n]);
  for (var o = 0; o < this.children.length; o++)
    i.appendChild(this.children[o].toNode());
  return i;
}, D7 = function(t) {
  var i = "<" + t;
  this.classes.length && (i += ' class="' + Rt.escape(Fl(this.classes)) + '"');
  var r = "";
  for (var n in this.style)
    this.style.hasOwnProperty(n) && (r += Rt.hyphenate(n) + ":" + this.style[n] + ";");
  r && (i += ' style="' + Rt.escape(r) + '"');
  for (var o in this.attributes)
    this.attributes.hasOwnProperty(o) && (i += " " + o + '="' + Rt.escape(this.attributes[o]) + '"');
  i += ">";
  for (var s = 0; s < this.children.length; s++)
    i += this.children[s].toMarkup();
  return i += "</" + t + ">", i;
};
class Cg {
  constructor(t, i, r, n) {
    this.children = void 0, this.attributes = void 0, this.classes = void 0, this.height = void 0, this.depth = void 0, this.width = void 0, this.maxFontSize = void 0, this.style = void 0, T7.call(this, t, r, n), this.children = i || [];
  }
  /**
   * Sets an arbitrary attribute on the span. Warning: use this wisely. Not
   * all browsers support attributes the same, and having too many custom
   * attributes is probably bad.
   */
  setAttribute(t, i) {
    this.attributes[t] = i;
  }
  hasClass(t) {
    return Rt.contains(this.classes, t);
  }
  toNode() {
    return B7.call(this, "span");
  }
  toMarkup() {
    return D7.call(this, "span");
  }
}
class G2 {
  constructor(t, i, r, n) {
    this.children = void 0, this.attributes = void 0, this.classes = void 0, this.height = void 0, this.depth = void 0, this.maxFontSize = void 0, this.style = void 0, T7.call(this, i, n), this.children = r || [], this.setAttribute("href", t);
  }
  setAttribute(t, i) {
    this.attributes[t] = i;
  }
  hasClass(t) {
    return Rt.contains(this.classes, t);
  }
  toNode() {
    return B7.call(this, "a");
  }
  toMarkup() {
    return D7.call(this, "a");
  }
}
let w_ = class {
  constructor(t, i, r) {
    this.src = void 0, this.alt = void 0, this.classes = void 0, this.height = void 0, this.depth = void 0, this.maxFontSize = void 0, this.style = void 0, this.alt = i, this.src = t, this.classes = ["mord"], this.style = r;
  }
  hasClass(t) {
    return Rt.contains(this.classes, t);
  }
  toNode() {
    var t = document.createElement("img");
    t.src = this.src, t.alt = this.alt, t.className = "mord";
    for (var i in this.style)
      this.style.hasOwnProperty(i) && (t.style[i] = this.style[i]);
    return t;
  }
  toMarkup() {
    var t = "<img  src='" + this.src + " 'alt='" + this.alt + "' ", i = "";
    for (var r in this.style)
      this.style.hasOwnProperty(r) && (i += Rt.hyphenate(r) + ":" + this.style[r] + ";");
    return i && (t += ' style="' + Rt.escape(i) + '"'), t += "'/>", t;
  }
};
var M_ = {
  î: "ı̂",
  ï: "ı̈",
  í: "ı́",
  // 'ī': '\u0131\u0304', // enable when we add Extended Latin
  ì: "ı̀"
};
class Zo {
  constructor(t, i, r, n, o, s, a, l) {
    this.text = void 0, this.height = void 0, this.depth = void 0, this.italic = void 0, this.skew = void 0, this.width = void 0, this.maxFontSize = void 0, this.classes = void 0, this.style = void 0, this.text = t, this.height = i || 0, this.depth = r || 0, this.italic = n || 0, this.skew = o || 0, this.width = s || 0, this.classes = a || [], this.style = l || {}, this.maxFontSize = 0;
    var c = g_(this.text.charCodeAt(0));
    c && this.classes.push(c + "_fallback"), /[îïíì]/.test(this.text) && (this.text = M_[this.text]);
  }
  hasClass(t) {
    return Rt.contains(this.classes, t);
  }
  /**
   * Creates a text node or span from a symbol node. Note that a span is only
   * created if it is needed.
   */
  toNode() {
    var t = document.createTextNode(this.text), i = null;
    this.italic > 0 && (i = document.createElement("span"), i.style.marginRight = He(this.italic)), this.classes.length > 0 && (i = i || document.createElement("span"), i.className = Fl(this.classes));
    for (var r in this.style)
      this.style.hasOwnProperty(r) && (i = i || document.createElement("span"), i.style[r] = this.style[r]);
    return i ? (i.appendChild(t), i) : t;
  }
  /**
   * Creates markup for a symbol node.
   */
  toMarkup() {
    var t = !1, i = "<span";
    this.classes.length && (t = !0, i += ' class="', i += Rt.escape(Fl(this.classes)), i += '"');
    var r = "";
    this.italic > 0 && (r += "margin-right:" + this.italic + "em;");
    for (var n in this.style)
      this.style.hasOwnProperty(n) && (r += Rt.hyphenate(n) + ":" + this.style[n] + ";");
    r && (t = !0, i += ' style="' + Rt.escape(r) + '"');
    var o = Rt.escape(this.text);
    return t ? (i += ">", i += o, i += "</span>", i) : o;
  }
}
class Ta {
  constructor(t, i) {
    this.children = void 0, this.attributes = void 0, this.children = t || [], this.attributes = i || {};
  }
  toNode() {
    var t = "http://www.w3.org/2000/svg", i = document.createElementNS(t, "svg");
    for (var r in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, r) && i.setAttribute(r, this.attributes[r]);
    for (var n = 0; n < this.children.length; n++)
      i.appendChild(this.children[n].toNode());
    return i;
  }
  toMarkup() {
    var t = '<svg xmlns="http://www.w3.org/2000/svg"';
    for (var i in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, i) && (t += " " + i + "='" + this.attributes[i] + "'");
    t += ">";
    for (var r = 0; r < this.children.length; r++)
      t += this.children[r].toMarkup();
    return t += "</svg>", t;
  }
}
class Vl {
  constructor(t, i) {
    this.pathName = void 0, this.alternate = void 0, this.pathName = t, this.alternate = i;
  }
  toNode() {
    var t = "http://www.w3.org/2000/svg", i = document.createElementNS(t, "path");
    return this.alternate ? i.setAttribute("d", this.alternate) : i.setAttribute("d", t4[this.pathName]), i;
  }
  toMarkup() {
    return this.alternate ? "<path d='" + this.alternate + "'/>" : "<path d='" + t4[this.pathName] + "'/>";
  }
}
class qb {
  constructor(t) {
    this.attributes = void 0, this.attributes = t || {};
  }
  toNode() {
    var t = "http://www.w3.org/2000/svg", i = document.createElementNS(t, "line");
    for (var r in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, r) && i.setAttribute(r, this.attributes[r]);
    return i;
  }
  toMarkup() {
    var t = "<line";
    for (var i in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, i) && (t += " " + i + "='" + this.attributes[i] + "'");
    return t += "/>", t;
  }
}
function o4(e) {
  if (e instanceof Zo)
    return e;
  throw new Error("Expected symbolNode but got " + String(e) + ".");
}
function N_(e) {
  if (e instanceof Cg)
    return e;
  throw new Error("Expected span<HtmlDomNode> but got " + String(e) + ".");
}
var T_ = {
  bin: 1,
  close: 1,
  inner: 1,
  open: 1,
  punct: 1,
  rel: 1
}, B_ = {
  "accent-token": 1,
  mathord: 1,
  "op-token": 1,
  spacing: 1,
  textord: 1
}, Mi = {
  math: {},
  text: {}
};
function k(e, t, i, r, n, o) {
  Mi[e][n] = {
    font: t,
    group: i,
    replace: r
  }, o && r && (Mi[e][r] = Mi[e][n]);
}
var B = "math", Le = "text", K = "main", te = "ams", Ki = "accent-token", st = "bin", Mn = "close", W0 = "inner", vt = "mathord", pr = "op-token", xo = "open", bf = "punct", re = "rel", La = "spacing", ce = "textord";
k(B, K, re, "≡", "\\equiv", !0);
k(B, K, re, "≺", "\\prec", !0);
k(B, K, re, "≻", "\\succ", !0);
k(B, K, re, "∼", "\\sim", !0);
k(B, K, re, "⊥", "\\perp");
k(B, K, re, "⪯", "\\preceq", !0);
k(B, K, re, "⪰", "\\succeq", !0);
k(B, K, re, "≃", "\\simeq", !0);
k(B, K, re, "∣", "\\mid", !0);
k(B, K, re, "≪", "\\ll", !0);
k(B, K, re, "≫", "\\gg", !0);
k(B, K, re, "≍", "\\asymp", !0);
k(B, K, re, "∥", "\\parallel");
k(B, K, re, "⋈", "\\bowtie", !0);
k(B, K, re, "⌣", "\\smile", !0);
k(B, K, re, "⊑", "\\sqsubseteq", !0);
k(B, K, re, "⊒", "\\sqsupseteq", !0);
k(B, K, re, "≐", "\\doteq", !0);
k(B, K, re, "⌢", "\\frown", !0);
k(B, K, re, "∋", "\\ni", !0);
k(B, K, re, "∝", "\\propto", !0);
k(B, K, re, "⊢", "\\vdash", !0);
k(B, K, re, "⊣", "\\dashv", !0);
k(B, K, re, "∋", "\\owns");
k(B, K, bf, ".", "\\ldotp");
k(B, K, bf, "⋅", "\\cdotp");
k(B, K, ce, "#", "\\#");
k(Le, K, ce, "#", "\\#");
k(B, K, ce, "&", "\\&");
k(Le, K, ce, "&", "\\&");
k(B, K, ce, "ℵ", "\\aleph", !0);
k(B, K, ce, "∀", "\\forall", !0);
k(B, K, ce, "ℏ", "\\hbar", !0);
k(B, K, ce, "∃", "\\exists", !0);
k(B, K, ce, "∇", "\\nabla", !0);
k(B, K, ce, "♭", "\\flat", !0);
k(B, K, ce, "ℓ", "\\ell", !0);
k(B, K, ce, "♮", "\\natural", !0);
k(B, K, ce, "♣", "\\clubsuit", !0);
k(B, K, ce, "℘", "\\wp", !0);
k(B, K, ce, "♯", "\\sharp", !0);
k(B, K, ce, "♢", "\\diamondsuit", !0);
k(B, K, ce, "ℜ", "\\Re", !0);
k(B, K, ce, "♡", "\\heartsuit", !0);
k(B, K, ce, "ℑ", "\\Im", !0);
k(B, K, ce, "♠", "\\spadesuit", !0);
k(B, K, ce, "§", "\\S", !0);
k(Le, K, ce, "§", "\\S");
k(B, K, ce, "¶", "\\P", !0);
k(Le, K, ce, "¶", "\\P");
k(B, K, ce, "†", "\\dag");
k(Le, K, ce, "†", "\\dag");
k(Le, K, ce, "†", "\\textdagger");
k(B, K, ce, "‡", "\\ddag");
k(Le, K, ce, "‡", "\\ddag");
k(Le, K, ce, "‡", "\\textdaggerdbl");
k(B, K, Mn, "⎱", "\\rmoustache", !0);
k(B, K, xo, "⎰", "\\lmoustache", !0);
k(B, K, Mn, "⟯", "\\rgroup", !0);
k(B, K, xo, "⟮", "\\lgroup", !0);
k(B, K, st, "∓", "\\mp", !0);
k(B, K, st, "⊖", "\\ominus", !0);
k(B, K, st, "⊎", "\\uplus", !0);
k(B, K, st, "⊓", "\\sqcap", !0);
k(B, K, st, "∗", "\\ast");
k(B, K, st, "⊔", "\\sqcup", !0);
k(B, K, st, "◯", "\\bigcirc", !0);
k(B, K, st, "∙", "\\bullet", !0);
k(B, K, st, "‡", "\\ddagger");
k(B, K, st, "≀", "\\wr", !0);
k(B, K, st, "⨿", "\\amalg");
k(B, K, st, "&", "\\And");
k(B, K, re, "⟵", "\\longleftarrow", !0);
k(B, K, re, "⇐", "\\Leftarrow", !0);
k(B, K, re, "⟸", "\\Longleftarrow", !0);
k(B, K, re, "⟶", "\\longrightarrow", !0);
k(B, K, re, "⇒", "\\Rightarrow", !0);
k(B, K, re, "⟹", "\\Longrightarrow", !0);
k(B, K, re, "↔", "\\leftrightarrow", !0);
k(B, K, re, "⟷", "\\longleftrightarrow", !0);
k(B, K, re, "⇔", "\\Leftrightarrow", !0);
k(B, K, re, "⟺", "\\Longleftrightarrow", !0);
k(B, K, re, "↦", "\\mapsto", !0);
k(B, K, re, "⟼", "\\longmapsto", !0);
k(B, K, re, "↗", "\\nearrow", !0);
k(B, K, re, "↩", "\\hookleftarrow", !0);
k(B, K, re, "↪", "\\hookrightarrow", !0);
k(B, K, re, "↘", "\\searrow", !0);
k(B, K, re, "↼", "\\leftharpoonup", !0);
k(B, K, re, "⇀", "\\rightharpoonup", !0);
k(B, K, re, "↙", "\\swarrow", !0);
k(B, K, re, "↽", "\\leftharpoondown", !0);
k(B, K, re, "⇁", "\\rightharpoondown", !0);
k(B, K, re, "↖", "\\nwarrow", !0);
k(B, K, re, "⇌", "\\rightleftharpoons", !0);
k(B, te, re, "≮", "\\nless", !0);
k(B, te, re, "", "\\@nleqslant");
k(B, te, re, "", "\\@nleqq");
k(B, te, re, "⪇", "\\lneq", !0);
k(B, te, re, "≨", "\\lneqq", !0);
k(B, te, re, "", "\\@lvertneqq");
k(B, te, re, "⋦", "\\lnsim", !0);
k(B, te, re, "⪉", "\\lnapprox", !0);
k(B, te, re, "⊀", "\\nprec", !0);
k(B, te, re, "⋠", "\\npreceq", !0);
k(B, te, re, "⋨", "\\precnsim", !0);
k(B, te, re, "⪹", "\\precnapprox", !0);
k(B, te, re, "≁", "\\nsim", !0);
k(B, te, re, "", "\\@nshortmid");
k(B, te, re, "∤", "\\nmid", !0);
k(B, te, re, "⊬", "\\nvdash", !0);
k(B, te, re, "⊭", "\\nvDash", !0);
k(B, te, re, "⋪", "\\ntriangleleft");
k(B, te, re, "⋬", "\\ntrianglelefteq", !0);
k(B, te, re, "⊊", "\\subsetneq", !0);
k(B, te, re, "", "\\@varsubsetneq");
k(B, te, re, "⫋", "\\subsetneqq", !0);
k(B, te, re, "", "\\@varsubsetneqq");
k(B, te, re, "≯", "\\ngtr", !0);
k(B, te, re, "", "\\@ngeqslant");
k(B, te, re, "", "\\@ngeqq");
k(B, te, re, "⪈", "\\gneq", !0);
k(B, te, re, "≩", "\\gneqq", !0);
k(B, te, re, "", "\\@gvertneqq");
k(B, te, re, "⋧", "\\gnsim", !0);
k(B, te, re, "⪊", "\\gnapprox", !0);
k(B, te, re, "⊁", "\\nsucc", !0);
k(B, te, re, "⋡", "\\nsucceq", !0);
k(B, te, re, "⋩", "\\succnsim", !0);
k(B, te, re, "⪺", "\\succnapprox", !0);
k(B, te, re, "≆", "\\ncong", !0);
k(B, te, re, "", "\\@nshortparallel");
k(B, te, re, "∦", "\\nparallel", !0);
k(B, te, re, "⊯", "\\nVDash", !0);
k(B, te, re, "⋫", "\\ntriangleright");
k(B, te, re, "⋭", "\\ntrianglerighteq", !0);
k(B, te, re, "", "\\@nsupseteqq");
k(B, te, re, "⊋", "\\supsetneq", !0);
k(B, te, re, "", "\\@varsupsetneq");
k(B, te, re, "⫌", "\\supsetneqq", !0);
k(B, te, re, "", "\\@varsupsetneqq");
k(B, te, re, "⊮", "\\nVdash", !0);
k(B, te, re, "⪵", "\\precneqq", !0);
k(B, te, re, "⪶", "\\succneqq", !0);
k(B, te, re, "", "\\@nsubseteqq");
k(B, te, st, "⊴", "\\unlhd");
k(B, te, st, "⊵", "\\unrhd");
k(B, te, re, "↚", "\\nleftarrow", !0);
k(B, te, re, "↛", "\\nrightarrow", !0);
k(B, te, re, "⇍", "\\nLeftarrow", !0);
k(B, te, re, "⇏", "\\nRightarrow", !0);
k(B, te, re, "↮", "\\nleftrightarrow", !0);
k(B, te, re, "⇎", "\\nLeftrightarrow", !0);
k(B, te, re, "△", "\\vartriangle");
k(B, te, ce, "ℏ", "\\hslash");
k(B, te, ce, "▽", "\\triangledown");
k(B, te, ce, "◊", "\\lozenge");
k(B, te, ce, "Ⓢ", "\\circledS");
k(B, te, ce, "®", "\\circledR");
k(Le, te, ce, "®", "\\circledR");
k(B, te, ce, "∡", "\\measuredangle", !0);
k(B, te, ce, "∄", "\\nexists");
k(B, te, ce, "℧", "\\mho");
k(B, te, ce, "Ⅎ", "\\Finv", !0);
k(B, te, ce, "⅁", "\\Game", !0);
k(B, te, ce, "‵", "\\backprime");
k(B, te, ce, "▲", "\\blacktriangle");
k(B, te, ce, "▼", "\\blacktriangledown");
k(B, te, ce, "■", "\\blacksquare");
k(B, te, ce, "⧫", "\\blacklozenge");
k(B, te, ce, "★", "\\bigstar");
k(B, te, ce, "∢", "\\sphericalangle", !0);
k(B, te, ce, "∁", "\\complement", !0);
k(B, te, ce, "ð", "\\eth", !0);
k(Le, K, ce, "ð", "ð");
k(B, te, ce, "╱", "\\diagup");
k(B, te, ce, "╲", "\\diagdown");
k(B, te, ce, "□", "\\square");
k(B, te, ce, "□", "\\Box");
k(B, te, ce, "◊", "\\Diamond");
k(B, te, ce, "¥", "\\yen", !0);
k(Le, te, ce, "¥", "\\yen", !0);
k(B, te, ce, "✓", "\\checkmark", !0);
k(Le, te, ce, "✓", "\\checkmark");
k(B, te, ce, "ℶ", "\\beth", !0);
k(B, te, ce, "ℸ", "\\daleth", !0);
k(B, te, ce, "ℷ", "\\gimel", !0);
k(B, te, ce, "ϝ", "\\digamma", !0);
k(B, te, ce, "ϰ", "\\varkappa");
k(B, te, xo, "┌", "\\@ulcorner", !0);
k(B, te, Mn, "┐", "\\@urcorner", !0);
k(B, te, xo, "└", "\\@llcorner", !0);
k(B, te, Mn, "┘", "\\@lrcorner", !0);
k(B, te, re, "≦", "\\leqq", !0);
k(B, te, re, "⩽", "\\leqslant", !0);
k(B, te, re, "⪕", "\\eqslantless", !0);
k(B, te, re, "≲", "\\lesssim", !0);
k(B, te, re, "⪅", "\\lessapprox", !0);
k(B, te, re, "≊", "\\approxeq", !0);
k(B, te, st, "⋖", "\\lessdot");
k(B, te, re, "⋘", "\\lll", !0);
k(B, te, re, "≶", "\\lessgtr", !0);
k(B, te, re, "⋚", "\\lesseqgtr", !0);
k(B, te, re, "⪋", "\\lesseqqgtr", !0);
k(B, te, re, "≑", "\\doteqdot");
k(B, te, re, "≓", "\\risingdotseq", !0);
k(B, te, re, "≒", "\\fallingdotseq", !0);
k(B, te, re, "∽", "\\backsim", !0);
k(B, te, re, "⋍", "\\backsimeq", !0);
k(B, te, re, "⫅", "\\subseteqq", !0);
k(B, te, re, "⋐", "\\Subset", !0);
k(B, te, re, "⊏", "\\sqsubset", !0);
k(B, te, re, "≼", "\\preccurlyeq", !0);
k(B, te, re, "⋞", "\\curlyeqprec", !0);
k(B, te, re, "≾", "\\precsim", !0);
k(B, te, re, "⪷", "\\precapprox", !0);
k(B, te, re, "⊲", "\\vartriangleleft");
k(B, te, re, "⊴", "\\trianglelefteq");
k(B, te, re, "⊨", "\\vDash", !0);
k(B, te, re, "⊪", "\\Vvdash", !0);
k(B, te, re, "⌣", "\\smallsmile");
k(B, te, re, "⌢", "\\smallfrown");
k(B, te, re, "≏", "\\bumpeq", !0);
k(B, te, re, "≎", "\\Bumpeq", !0);
k(B, te, re, "≧", "\\geqq", !0);
k(B, te, re, "⩾", "\\geqslant", !0);
k(B, te, re, "⪖", "\\eqslantgtr", !0);
k(B, te, re, "≳", "\\gtrsim", !0);
k(B, te, re, "⪆", "\\gtrapprox", !0);
k(B, te, st, "⋗", "\\gtrdot");
k(B, te, re, "⋙", "\\ggg", !0);
k(B, te, re, "≷", "\\gtrless", !0);
k(B, te, re, "⋛", "\\gtreqless", !0);
k(B, te, re, "⪌", "\\gtreqqless", !0);
k(B, te, re, "≖", "\\eqcirc", !0);
k(B, te, re, "≗", "\\circeq", !0);
k(B, te, re, "≜", "\\triangleq", !0);
k(B, te, re, "∼", "\\thicksim");
k(B, te, re, "≈", "\\thickapprox");
k(B, te, re, "⫆", "\\supseteqq", !0);
k(B, te, re, "⋑", "\\Supset", !0);
k(B, te, re, "⊐", "\\sqsupset", !0);
k(B, te, re, "≽", "\\succcurlyeq", !0);
k(B, te, re, "⋟", "\\curlyeqsucc", !0);
k(B, te, re, "≿", "\\succsim", !0);
k(B, te, re, "⪸", "\\succapprox", !0);
k(B, te, re, "⊳", "\\vartriangleright");
k(B, te, re, "⊵", "\\trianglerighteq");
k(B, te, re, "⊩", "\\Vdash", !0);
k(B, te, re, "∣", "\\shortmid");
k(B, te, re, "∥", "\\shortparallel");
k(B, te, re, "≬", "\\between", !0);
k(B, te, re, "⋔", "\\pitchfork", !0);
k(B, te, re, "∝", "\\varpropto");
k(B, te, re, "◀", "\\blacktriangleleft");
k(B, te, re, "∴", "\\therefore", !0);
k(B, te, re, "∍", "\\backepsilon");
k(B, te, re, "▶", "\\blacktriangleright");
k(B, te, re, "∵", "\\because", !0);
k(B, te, re, "⋘", "\\llless");
k(B, te, re, "⋙", "\\gggtr");
k(B, te, st, "⊲", "\\lhd");
k(B, te, st, "⊳", "\\rhd");
k(B, te, re, "≂", "\\eqsim", !0);
k(B, K, re, "⋈", "\\Join");
k(B, te, re, "≑", "\\Doteq", !0);
k(B, te, st, "∔", "\\dotplus", !0);
k(B, te, st, "∖", "\\smallsetminus");
k(B, te, st, "⋒", "\\Cap", !0);
k(B, te, st, "⋓", "\\Cup", !0);
k(B, te, st, "⩞", "\\doublebarwedge", !0);
k(B, te, st, "⊟", "\\boxminus", !0);
k(B, te, st, "⊞", "\\boxplus", !0);
k(B, te, st, "⋇", "\\divideontimes", !0);
k(B, te, st, "⋉", "\\ltimes", !0);
k(B, te, st, "⋊", "\\rtimes", !0);
k(B, te, st, "⋋", "\\leftthreetimes", !0);
k(B, te, st, "⋌", "\\rightthreetimes", !0);
k(B, te, st, "⋏", "\\curlywedge", !0);
k(B, te, st, "⋎", "\\curlyvee", !0);
k(B, te, st, "⊝", "\\circleddash", !0);
k(B, te, st, "⊛", "\\circledast", !0);
k(B, te, st, "⋅", "\\centerdot");
k(B, te, st, "⊺", "\\intercal", !0);
k(B, te, st, "⋒", "\\doublecap");
k(B, te, st, "⋓", "\\doublecup");
k(B, te, st, "⊠", "\\boxtimes", !0);
k(B, te, re, "⇢", "\\dashrightarrow", !0);
k(B, te, re, "⇠", "\\dashleftarrow", !0);
k(B, te, re, "⇇", "\\leftleftarrows", !0);
k(B, te, re, "⇆", "\\leftrightarrows", !0);
k(B, te, re, "⇚", "\\Lleftarrow", !0);
k(B, te, re, "↞", "\\twoheadleftarrow", !0);
k(B, te, re, "↢", "\\leftarrowtail", !0);
k(B, te, re, "↫", "\\looparrowleft", !0);
k(B, te, re, "⇋", "\\leftrightharpoons", !0);
k(B, te, re, "↶", "\\curvearrowleft", !0);
k(B, te, re, "↺", "\\circlearrowleft", !0);
k(B, te, re, "↰", "\\Lsh", !0);
k(B, te, re, "⇈", "\\upuparrows", !0);
k(B, te, re, "↿", "\\upharpoonleft", !0);
k(B, te, re, "⇃", "\\downharpoonleft", !0);
k(B, K, re, "⊶", "\\origof", !0);
k(B, K, re, "⊷", "\\imageof", !0);
k(B, te, re, "⊸", "\\multimap", !0);
k(B, te, re, "↭", "\\leftrightsquigarrow", !0);
k(B, te, re, "⇉", "\\rightrightarrows", !0);
k(B, te, re, "⇄", "\\rightleftarrows", !0);
k(B, te, re, "↠", "\\twoheadrightarrow", !0);
k(B, te, re, "↣", "\\rightarrowtail", !0);
k(B, te, re, "↬", "\\looparrowright", !0);
k(B, te, re, "↷", "\\curvearrowright", !0);
k(B, te, re, "↻", "\\circlearrowright", !0);
k(B, te, re, "↱", "\\Rsh", !0);
k(B, te, re, "⇊", "\\downdownarrows", !0);
k(B, te, re, "↾", "\\upharpoonright", !0);
k(B, te, re, "⇂", "\\downharpoonright", !0);
k(B, te, re, "⇝", "\\rightsquigarrow", !0);
k(B, te, re, "⇝", "\\leadsto");
k(B, te, re, "⇛", "\\Rrightarrow", !0);
k(B, te, re, "↾", "\\restriction");
k(B, K, ce, "‘", "`");
k(B, K, ce, "$", "\\$");
k(Le, K, ce, "$", "\\$");
k(Le, K, ce, "$", "\\textdollar");
k(B, K, ce, "%", "\\%");
k(Le, K, ce, "%", "\\%");
k(B, K, ce, "_", "\\_");
k(Le, K, ce, "_", "\\_");
k(Le, K, ce, "_", "\\textunderscore");
k(B, K, ce, "∠", "\\angle", !0);
k(B, K, ce, "∞", "\\infty", !0);
k(B, K, ce, "′", "\\prime");
k(B, K, ce, "△", "\\triangle");
k(B, K, ce, "Γ", "\\Gamma", !0);
k(B, K, ce, "Δ", "\\Delta", !0);
k(B, K, ce, "Θ", "\\Theta", !0);
k(B, K, ce, "Λ", "\\Lambda", !0);
k(B, K, ce, "Ξ", "\\Xi", !0);
k(B, K, ce, "Π", "\\Pi", !0);
k(B, K, ce, "Σ", "\\Sigma", !0);
k(B, K, ce, "Υ", "\\Upsilon", !0);
k(B, K, ce, "Φ", "\\Phi", !0);
k(B, K, ce, "Ψ", "\\Psi", !0);
k(B, K, ce, "Ω", "\\Omega", !0);
k(B, K, ce, "A", "Α");
k(B, K, ce, "B", "Β");
k(B, K, ce, "E", "Ε");
k(B, K, ce, "Z", "Ζ");
k(B, K, ce, "H", "Η");
k(B, K, ce, "I", "Ι");
k(B, K, ce, "K", "Κ");
k(B, K, ce, "M", "Μ");
k(B, K, ce, "N", "Ν");
k(B, K, ce, "O", "Ο");
k(B, K, ce, "P", "Ρ");
k(B, K, ce, "T", "Τ");
k(B, K, ce, "X", "Χ");
k(B, K, ce, "¬", "\\neg", !0);
k(B, K, ce, "¬", "\\lnot");
k(B, K, ce, "⊤", "\\top");
k(B, K, ce, "⊥", "\\bot");
k(B, K, ce, "∅", "\\emptyset");
k(B, te, ce, "∅", "\\varnothing");
k(B, K, vt, "α", "\\alpha", !0);
k(B, K, vt, "β", "\\beta", !0);
k(B, K, vt, "γ", "\\gamma", !0);
k(B, K, vt, "δ", "\\delta", !0);
k(B, K, vt, "ϵ", "\\epsilon", !0);
k(B, K, vt, "ζ", "\\zeta", !0);
k(B, K, vt, "η", "\\eta", !0);
k(B, K, vt, "θ", "\\theta", !0);
k(B, K, vt, "ι", "\\iota", !0);
k(B, K, vt, "κ", "\\kappa", !0);
k(B, K, vt, "λ", "\\lambda", !0);
k(B, K, vt, "μ", "\\mu", !0);
k(B, K, vt, "ν", "\\nu", !0);
k(B, K, vt, "ξ", "\\xi", !0);
k(B, K, vt, "ο", "\\omicron", !0);
k(B, K, vt, "π", "\\pi", !0);
k(B, K, vt, "ρ", "\\rho", !0);
k(B, K, vt, "σ", "\\sigma", !0);
k(B, K, vt, "τ", "\\tau", !0);
k(B, K, vt, "υ", "\\upsilon", !0);
k(B, K, vt, "ϕ", "\\phi", !0);
k(B, K, vt, "χ", "\\chi", !0);
k(B, K, vt, "ψ", "\\psi", !0);
k(B, K, vt, "ω", "\\omega", !0);
k(B, K, vt, "ε", "\\varepsilon", !0);
k(B, K, vt, "ϑ", "\\vartheta", !0);
k(B, K, vt, "ϖ", "\\varpi", !0);
k(B, K, vt, "ϱ", "\\varrho", !0);
k(B, K, vt, "ς", "\\varsigma", !0);
k(B, K, vt, "φ", "\\varphi", !0);
k(B, K, st, "∗", "*", !0);
k(B, K, st, "+", "+");
k(B, K, st, "−", "-", !0);
k(B, K, st, "⋅", "\\cdot", !0);
k(B, K, st, "∘", "\\circ", !0);
k(B, K, st, "÷", "\\div", !0);
k(B, K, st, "±", "\\pm", !0);
k(B, K, st, "×", "\\times", !0);
k(B, K, st, "∩", "\\cap", !0);
k(B, K, st, "∪", "\\cup", !0);
k(B, K, st, "∖", "\\setminus", !0);
k(B, K, st, "∧", "\\land");
k(B, K, st, "∨", "\\lor");
k(B, K, st, "∧", "\\wedge", !0);
k(B, K, st, "∨", "\\vee", !0);
k(B, K, ce, "√", "\\surd");
k(B, K, xo, "⟨", "\\langle", !0);
k(B, K, xo, "∣", "\\lvert");
k(B, K, xo, "∥", "\\lVert");
k(B, K, Mn, "?", "?");
k(B, K, Mn, "!", "!");
k(B, K, Mn, "⟩", "\\rangle", !0);
k(B, K, Mn, "∣", "\\rvert");
k(B, K, Mn, "∥", "\\rVert");
k(B, K, re, "=", "=");
k(B, K, re, ":", ":");
k(B, K, re, "≈", "\\approx", !0);
k(B, K, re, "≅", "\\cong", !0);
k(B, K, re, "≥", "\\ge");
k(B, K, re, "≥", "\\geq", !0);
k(B, K, re, "←", "\\gets");
k(B, K, re, ">", "\\gt", !0);
k(B, K, re, "∈", "\\in", !0);
k(B, K, re, "", "\\@not");
k(B, K, re, "⊂", "\\subset", !0);
k(B, K, re, "⊃", "\\supset", !0);
k(B, K, re, "⊆", "\\subseteq", !0);
k(B, K, re, "⊇", "\\supseteq", !0);
k(B, te, re, "⊈", "\\nsubseteq", !0);
k(B, te, re, "⊉", "\\nsupseteq", !0);
k(B, K, re, "⊨", "\\models");
k(B, K, re, "←", "\\leftarrow", !0);
k(B, K, re, "≤", "\\le");
k(B, K, re, "≤", "\\leq", !0);
k(B, K, re, "<", "\\lt", !0);
k(B, K, re, "→", "\\rightarrow", !0);
k(B, K, re, "→", "\\to");
k(B, te, re, "≱", "\\ngeq", !0);
k(B, te, re, "≰", "\\nleq", !0);
k(B, K, La, " ", "\\ ");
k(B, K, La, " ", "\\space");
k(B, K, La, " ", "\\nobreakspace");
k(Le, K, La, " ", "\\ ");
k(Le, K, La, " ", " ");
k(Le, K, La, " ", "\\space");
k(Le, K, La, " ", "\\nobreakspace");
k(B, K, La, null, "\\nobreak");
k(B, K, La, null, "\\allowbreak");
k(B, K, bf, ",", ",");
k(B, K, bf, ";", ";");
k(B, te, st, "⊼", "\\barwedge", !0);
k(B, te, st, "⊻", "\\veebar", !0);
k(B, K, st, "⊙", "\\odot", !0);
k(B, K, st, "⊕", "\\oplus", !0);
k(B, K, st, "⊗", "\\otimes", !0);
k(B, K, ce, "∂", "\\partial", !0);
k(B, K, st, "⊘", "\\oslash", !0);
k(B, te, st, "⊚", "\\circledcirc", !0);
k(B, te, st, "⊡", "\\boxdot", !0);
k(B, K, st, "△", "\\bigtriangleup");
k(B, K, st, "▽", "\\bigtriangledown");
k(B, K, st, "†", "\\dagger");
k(B, K, st, "⋄", "\\diamond");
k(B, K, st, "⋆", "\\star");
k(B, K, st, "◃", "\\triangleleft");
k(B, K, st, "▹", "\\triangleright");
k(B, K, xo, "{", "\\{");
k(Le, K, ce, "{", "\\{");
k(Le, K, ce, "{", "\\textbraceleft");
k(B, K, Mn, "}", "\\}");
k(Le, K, ce, "}", "\\}");
k(Le, K, ce, "}", "\\textbraceright");
k(B, K, xo, "{", "\\lbrace");
k(B, K, Mn, "}", "\\rbrace");
k(B, K, xo, "[", "\\lbrack", !0);
k(Le, K, ce, "[", "\\lbrack", !0);
k(B, K, Mn, "]", "\\rbrack", !0);
k(Le, K, ce, "]", "\\rbrack", !0);
k(B, K, xo, "(", "\\lparen", !0);
k(B, K, Mn, ")", "\\rparen", !0);
k(Le, K, ce, "<", "\\textless", !0);
k(Le, K, ce, ">", "\\textgreater", !0);
k(B, K, xo, "⌊", "\\lfloor", !0);
k(B, K, Mn, "⌋", "\\rfloor", !0);
k(B, K, xo, "⌈", "\\lceil", !0);
k(B, K, Mn, "⌉", "\\rceil", !0);
k(B, K, ce, "\\", "\\backslash");
k(B, K, ce, "∣", "|");
k(B, K, ce, "∣", "\\vert");
k(Le, K, ce, "|", "\\textbar", !0);
k(B, K, ce, "∥", "\\|");
k(B, K, ce, "∥", "\\Vert");
k(Le, K, ce, "∥", "\\textbardbl");
k(Le, K, ce, "~", "\\textasciitilde");
k(Le, K, ce, "\\", "\\textbackslash");
k(Le, K, ce, "^", "\\textasciicircum");
k(B, K, re, "↑", "\\uparrow", !0);
k(B, K, re, "⇑", "\\Uparrow", !0);
k(B, K, re, "↓", "\\downarrow", !0);
k(B, K, re, "⇓", "\\Downarrow", !0);
k(B, K, re, "↕", "\\updownarrow", !0);
k(B, K, re, "⇕", "\\Updownarrow", !0);
k(B, K, pr, "∐", "\\coprod");
k(B, K, pr, "⋁", "\\bigvee");
k(B, K, pr, "⋀", "\\bigwedge");
k(B, K, pr, "⨄", "\\biguplus");
k(B, K, pr, "⋂", "\\bigcap");
k(B, K, pr, "⋃", "\\bigcup");
k(B, K, pr, "∫", "\\int");
k(B, K, pr, "∫", "\\intop");
k(B, K, pr, "∬", "\\iint");
k(B, K, pr, "∭", "\\iiint");
k(B, K, pr, "∏", "\\prod");
k(B, K, pr, "∑", "\\sum");
k(B, K, pr, "⨂", "\\bigotimes");
k(B, K, pr, "⨁", "\\bigoplus");
k(B, K, pr, "⨀", "\\bigodot");
k(B, K, pr, "∮", "\\oint");
k(B, K, pr, "∯", "\\oiint");
k(B, K, pr, "∰", "\\oiiint");
k(B, K, pr, "⨆", "\\bigsqcup");
k(B, K, pr, "∫", "\\smallint");
k(Le, K, W0, "…", "\\textellipsis");
k(B, K, W0, "…", "\\mathellipsis");
k(Le, K, W0, "…", "\\ldots", !0);
k(B, K, W0, "…", "\\ldots", !0);
k(B, K, W0, "⋯", "\\@cdots", !0);
k(B, K, W0, "⋱", "\\ddots", !0);
k(B, K, ce, "⋮", "\\varvdots");
k(B, K, Ki, "ˊ", "\\acute");
k(B, K, Ki, "ˋ", "\\grave");
k(B, K, Ki, "¨", "\\ddot");
k(B, K, Ki, "~", "\\tilde");
k(B, K, Ki, "ˉ", "\\bar");
k(B, K, Ki, "˘", "\\breve");
k(B, K, Ki, "ˇ", "\\check");
k(B, K, Ki, "^", "\\hat");
k(B, K, Ki, "⃗", "\\vec");
k(B, K, Ki, "˙", "\\dot");
k(B, K, Ki, "˚", "\\mathring");
k(B, K, vt, "", "\\@imath");
k(B, K, vt, "", "\\@jmath");
k(B, K, ce, "ı", "ı");
k(B, K, ce, "ȷ", "ȷ");
k(Le, K, ce, "ı", "\\i", !0);
k(Le, K, ce, "ȷ", "\\j", !0);
k(Le, K, ce, "ß", "\\ss", !0);
k(Le, K, ce, "æ", "\\ae", !0);
k(Le, K, ce, "œ", "\\oe", !0);
k(Le, K, ce, "ø", "\\o", !0);
k(Le, K, ce, "Æ", "\\AE", !0);
k(Le, K, ce, "Œ", "\\OE", !0);
k(Le, K, ce, "Ø", "\\O", !0);
k(Le, K, Ki, "ˊ", "\\'");
k(Le, K, Ki, "ˋ", "\\`");
k(Le, K, Ki, "ˆ", "\\^");
k(Le, K, Ki, "˜", "\\~");
k(Le, K, Ki, "ˉ", "\\=");
k(Le, K, Ki, "˘", "\\u");
k(Le, K, Ki, "˙", "\\.");
k(Le, K, Ki, "¸", "\\c");
k(Le, K, Ki, "˚", "\\r");
k(Le, K, Ki, "ˇ", "\\v");
k(Le, K, Ki, "¨", '\\"');
k(Le, K, Ki, "˝", "\\H");
k(Le, K, Ki, "◯", "\\textcircled");
var O7 = {
  "--": !0,
  "---": !0,
  "``": !0,
  "''": !0
};
k(Le, K, ce, "–", "--", !0);
k(Le, K, ce, "–", "\\textendash");
k(Le, K, ce, "—", "---", !0);
k(Le, K, ce, "—", "\\textemdash");
k(Le, K, ce, "‘", "`", !0);
k(Le, K, ce, "‘", "\\textquoteleft");
k(Le, K, ce, "’", "'", !0);
k(Le, K, ce, "’", "\\textquoteright");
k(Le, K, ce, "“", "``", !0);
k(Le, K, ce, "“", "\\textquotedblleft");
k(Le, K, ce, "”", "''", !0);
k(Le, K, ce, "”", "\\textquotedblright");
k(B, K, ce, "°", "\\degree", !0);
k(Le, K, ce, "°", "\\degree");
k(Le, K, ce, "°", "\\textdegree", !0);
k(B, K, ce, "£", "\\pounds");
k(B, K, ce, "£", "\\mathsterling", !0);
k(Le, K, ce, "£", "\\pounds");
k(Le, K, ce, "£", "\\textsterling", !0);
k(B, te, ce, "✠", "\\maltese");
k(Le, te, ce, "✠", "\\maltese");
var s4 = '0123456789/@."';
for (var Xy = 0; Xy < s4.length; Xy++) {
  var a4 = s4.charAt(Xy);
  k(B, K, ce, a4, a4);
}
var l4 = '0123456789!@*()-=+";:?/.,';
for (var _y = 0; _y < l4.length; _y++) {
  var c4 = l4.charAt(_y);
  k(Le, K, ce, c4, c4);
}
var b1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
for (var $y = 0; $y < b1.length; $y++) {
  var rp = b1.charAt($y);
  k(B, K, vt, rp, rp), k(Le, K, ce, rp, rp);
}
k(B, te, ce, "C", "ℂ");
k(Le, te, ce, "C", "ℂ");
k(B, te, ce, "H", "ℍ");
k(Le, te, ce, "H", "ℍ");
k(B, te, ce, "N", "ℕ");
k(Le, te, ce, "N", "ℕ");
k(B, te, ce, "P", "ℙ");
k(Le, te, ce, "P", "ℙ");
k(B, te, ce, "Q", "ℚ");
k(Le, te, ce, "Q", "ℚ");
k(B, te, ce, "R", "ℝ");
k(Le, te, ce, "R", "ℝ");
k(B, te, ce, "Z", "ℤ");
k(Le, te, ce, "Z", "ℤ");
k(B, K, vt, "h", "ℎ");
k(Le, K, vt, "h", "ℎ");
var St = "";
for (var mn = 0; mn < b1.length; mn++) {
  var $i = b1.charAt(mn);
  St = String.fromCharCode(55349, 56320 + mn), k(B, K, vt, $i, St), k(Le, K, ce, $i, St), St = String.fromCharCode(55349, 56372 + mn), k(B, K, vt, $i, St), k(Le, K, ce, $i, St), St = String.fromCharCode(55349, 56424 + mn), k(B, K, vt, $i, St), k(Le, K, ce, $i, St), St = String.fromCharCode(55349, 56580 + mn), k(B, K, vt, $i, St), k(Le, K, ce, $i, St), St = String.fromCharCode(55349, 56684 + mn), k(B, K, vt, $i, St), k(Le, K, ce, $i, St), St = String.fromCharCode(55349, 56736 + mn), k(B, K, vt, $i, St), k(Le, K, ce, $i, St), St = String.fromCharCode(55349, 56788 + mn), k(B, K, vt, $i, St), k(Le, K, ce, $i, St), St = String.fromCharCode(55349, 56840 + mn), k(B, K, vt, $i, St), k(Le, K, ce, $i, St), St = String.fromCharCode(55349, 56944 + mn), k(B, K, vt, $i, St), k(Le, K, ce, $i, St), mn < 26 && (St = String.fromCharCode(55349, 56632 + mn), k(B, K, vt, $i, St), k(Le, K, ce, $i, St), St = String.fromCharCode(55349, 56476 + mn), k(B, K, vt, $i, St), k(Le, K, ce, $i, St));
}
St = String.fromCharCode(55349, 56668);
k(B, K, vt, "k", St);
k(Le, K, ce, "k", St);
for (var oc = 0; oc < 10; oc++) {
  var $a = oc.toString();
  St = String.fromCharCode(55349, 57294 + oc), k(B, K, vt, $a, St), k(Le, K, ce, $a, St), St = String.fromCharCode(55349, 57314 + oc), k(B, K, vt, $a, St), k(Le, K, ce, $a, St), St = String.fromCharCode(55349, 57324 + oc), k(B, K, vt, $a, St), k(Le, K, ce, $a, St), St = String.fromCharCode(55349, 57334 + oc), k(B, K, vt, $a, St), k(Le, K, ce, $a, St);
}
var jb = "ÐÞþ";
for (var eE = 0; eE < jb.length; eE++) {
  var np = jb.charAt(eE);
  k(B, K, vt, np, np), k(Le, K, ce, np, np);
}
var op = [
  ["mathbf", "textbf", "Main-Bold"],
  // A-Z bold upright
  ["mathbf", "textbf", "Main-Bold"],
  // a-z bold upright
  ["mathnormal", "textit", "Math-Italic"],
  // A-Z italic
  ["mathnormal", "textit", "Math-Italic"],
  // a-z italic
  ["boldsymbol", "boldsymbol", "Main-BoldItalic"],
  // A-Z bold italic
  ["boldsymbol", "boldsymbol", "Main-BoldItalic"],
  // a-z bold italic
  // Map fancy A-Z letters to script, not calligraphic.
  // This aligns with unicode-math and math fonts (except Cambria Math).
  ["mathscr", "textscr", "Script-Regular"],
  // A-Z script
  ["", "", ""],
  // a-z script.  No font
  ["", "", ""],
  // A-Z bold script. No font
  ["", "", ""],
  // a-z bold script. No font
  ["mathfrak", "textfrak", "Fraktur-Regular"],
  // A-Z Fraktur
  ["mathfrak", "textfrak", "Fraktur-Regular"],
  // a-z Fraktur
  ["mathbb", "textbb", "AMS-Regular"],
  // A-Z double-struck
  ["mathbb", "textbb", "AMS-Regular"],
  // k double-struck
  // Note that we are using a bold font, but font metrics for regular Fraktur.
  ["mathboldfrak", "textboldfrak", "Fraktur-Regular"],
  // A-Z bold Fraktur
  ["mathboldfrak", "textboldfrak", "Fraktur-Regular"],
  // a-z bold Fraktur
  ["mathsf", "textsf", "SansSerif-Regular"],
  // A-Z sans-serif
  ["mathsf", "textsf", "SansSerif-Regular"],
  // a-z sans-serif
  ["mathboldsf", "textboldsf", "SansSerif-Bold"],
  // A-Z bold sans-serif
  ["mathboldsf", "textboldsf", "SansSerif-Bold"],
  // a-z bold sans-serif
  ["mathitsf", "textitsf", "SansSerif-Italic"],
  // A-Z italic sans-serif
  ["mathitsf", "textitsf", "SansSerif-Italic"],
  // a-z italic sans-serif
  ["", "", ""],
  // A-Z bold italic sans. No font
  ["", "", ""],
  // a-z bold italic sans. No font
  ["mathtt", "texttt", "Typewriter-Regular"],
  // A-Z monospace
  ["mathtt", "texttt", "Typewriter-Regular"]
  // a-z monospace
], u4 = [
  ["mathbf", "textbf", "Main-Bold"],
  // 0-9 bold
  ["", "", ""],
  // 0-9 double-struck. No KaTeX font.
  ["mathsf", "textsf", "SansSerif-Regular"],
  // 0-9 sans-serif
  ["mathboldsf", "textboldsf", "SansSerif-Bold"],
  // 0-9 bold sans-serif
  ["mathtt", "texttt", "Typewriter-Regular"]
  // 0-9 monospace
], D_ = function(t, i) {
  var r = t.charCodeAt(0), n = t.charCodeAt(1), o = (r - 55296) * 1024 + (n - 56320) + 65536, s = i === "math" ? 0 : 1;
  if (119808 <= o && o < 120484) {
    var a = Math.floor((o - 119808) / 26);
    return [op[a][2], op[a][s]];
  } else if (120782 <= o && o <= 120831) {
    var l = Math.floor((o - 120782) / 10);
    return [u4[l][2], u4[l][s]];
  } else {
    if (o === 120485 || o === 120486)
      return [op[0][2], op[0][s]];
    if (120486 < o && o < 120782)
      return ["", ""];
    throw new We("Unsupported character: " + t);
  }
}, Cf = function(t, i, r) {
  return Mi[r][t] && Mi[r][t].replace && (t = Mi[r][t].replace), {
    value: t,
    metrics: U2(t, i, r)
  };
}, as = function(t, i, r, n, o) {
  var s = Cf(t, i, r), a = s.metrics;
  t = s.value;
  var l;
  if (a) {
    var c = a.italic;
    (r === "text" || n && n.font === "mathit") && (c = 0), l = new Zo(t, a.height, a.depth, c, a.skew, a.width, o);
  } else
    typeof console != "undefined" && console.warn("No character metrics " + ("for '" + t + "' in style '" + i + "' and mode '" + r + "'")), l = new Zo(t, 0, 0, 0, 0, 0, o);
  if (n) {
    l.maxFontSize = n.sizeMultiplier, n.style.isTight() && l.classes.push("mtight");
    var u = n.getColor();
    u && (l.style.color = u);
  }
  return l;
}, O_ = function(t, i, r, n) {
  return n === void 0 && (n = []), r.font === "boldsymbol" && Cf(t, "Main-Bold", i).metrics ? as(t, "Main-Bold", i, r, n.concat(["mathbf"])) : t === "\\" || Mi[i][t].font === "main" ? as(t, "Main-Regular", i, r, n) : as(t, "AMS-Regular", i, r, n.concat(["amsrm"]));
}, F_ = function(t, i, r, n, o) {
  return o !== "textord" && Cf(t, "Math-BoldItalic", i).metrics ? {
    fontName: "Math-BoldItalic",
    fontClass: "boldsymbol"
  } : {
    fontName: "Main-Bold",
    fontClass: "mathbf"
  };
}, V_ = function(t, i, r) {
  var n = t.mode, o = t.text, s = ["mord"], a = n === "math" || n === "text" && i.font, l = a ? i.font : i.fontFamily, c = "", u = "";
  if (o.charCodeAt(0) === 55349 && ([c, u] = D_(o, n)), c.length > 0)
    return as(o, c, n, i, s.concat(u));
  if (l) {
    var m, g;
    if (l === "boldsymbol") {
      var h = F_(o, n, i, s, r);
      m = h.fontName, g = [h.fontClass];
    } else
      a ? (m = q7[l].fontName, g = [l]) : (m = sp(l, i.fontWeight, i.fontShape), g = [l, i.fontWeight, i.fontShape]);
    if (Cf(o, m, n).metrics)
      return as(o, m, n, i, s.concat(g));
    if (O7.hasOwnProperty(o) && m.slice(0, 10) === "Typewriter") {
      for (var A = [], y = 0; y < o.length; y++)
        A.push(as(o[y], m, n, i, s.concat(g)));
      return V7(A);
    }
  }
  if (r === "mathord")
    return as(o, "Math-Italic", n, i, s.concat(["mathnormal"]));
  if (r === "textord") {
    var E = Mi[n][o] && Mi[n][o].font;
    if (E === "ams") {
      var v = sp("amsrm", i.fontWeight, i.fontShape);
      return as(o, v, n, i, s.concat("amsrm", i.fontWeight, i.fontShape));
    } else if (E === "main" || !E) {
      var C = sp("textrm", i.fontWeight, i.fontShape);
      return as(o, C, n, i, s.concat(i.fontWeight, i.fontShape));
    } else {
      var x = sp(E, i.fontWeight, i.fontShape);
      return as(o, x, n, i, s.concat(x, i.fontWeight, i.fontShape));
    }
  } else
    throw new Error("unexpected type: " + r + " in makeOrd");
}, q_ = (e, t) => {
  if (Fl(e.classes) !== Fl(t.classes) || e.skew !== t.skew || e.maxFontSize !== t.maxFontSize)
    return !1;
  if (e.classes.length === 1) {
    var i = e.classes[0];
    if (i === "mbin" || i === "mord")
      return !1;
  }
  for (var r in e.style)
    if (e.style.hasOwnProperty(r) && e.style[r] !== t.style[r])
      return !1;
  for (var n in t.style)
    if (t.style.hasOwnProperty(n) && e.style[n] !== t.style[n])
      return !1;
  return !0;
}, j_ = (e) => {
  for (var t = 0; t < e.length - 1; t++) {
    var i = e[t], r = e[t + 1];
    i instanceof Zo && r instanceof Zo && q_(i, r) && (i.text += r.text, i.height = Math.max(i.height, r.height), i.depth = Math.max(i.depth, r.depth), i.italic = r.italic, e.splice(t + 1, 1), t--);
  }
  return e;
}, Q2 = function(t) {
  for (var i = 0, r = 0, n = 0, o = 0; o < t.children.length; o++) {
    var s = t.children[o];
    s.height > i && (i = s.height), s.depth > r && (r = s.depth), s.maxFontSize > n && (n = s.maxFontSize);
  }
  t.height = i, t.depth = r, t.maxFontSize = n;
}, Yn = function(t, i, r, n) {
  var o = new Cg(t, i, r, n);
  return Q2(o), o;
}, F7 = (e, t, i, r) => new Cg(e, t, i, r), L_ = function(t, i, r) {
  var n = Yn([t], [], i);
  return n.height = Math.max(r || i.fontMetrics().defaultRuleThickness, i.minRuleThickness), n.style.borderBottomWidth = He(n.height), n.maxFontSize = 1, n;
}, K_ = function(t, i, r, n) {
  var o = new G2(t, i, r, n);
  return Q2(o), o;
}, V7 = function(t) {
  var i = new bg(t);
  return Q2(i), i;
}, Y_ = function(t, i) {
  return t instanceof bg ? Yn([], [t], i) : t;
}, U_ = function(t) {
  if (t.positionType === "individualShift") {
    for (var i = t.children, r = [i[0]], n = -i[0].shift - i[0].elem.depth, o = n, s = 1; s < i.length; s++) {
      var a = -i[s].shift - o - i[s].elem.depth, l = a - (i[s - 1].elem.height + i[s - 1].elem.depth);
      o = o + a, r.push({
        type: "kern",
        size: l
      }), r.push(i[s]);
    }
    return {
      children: r,
      depth: n
    };
  }
  var c;
  if (t.positionType === "top") {
    for (var u = t.positionData, m = 0; m < t.children.length; m++) {
      var g = t.children[m];
      u -= g.type === "kern" ? g.size : g.elem.height + g.elem.depth;
    }
    c = u;
  } else if (t.positionType === "bottom")
    c = -t.positionData;
  else {
    var h = t.children[0];
    if (h.type !== "elem")
      throw new Error('First child must have type "elem".');
    if (t.positionType === "shift")
      c = -h.elem.depth - t.positionData;
    else if (t.positionType === "firstBaseline")
      c = -h.elem.depth;
    else
      throw new Error("Invalid positionType " + t.positionType + ".");
  }
  return {
    children: t.children,
    depth: c
  };
}, G_ = function(t, i) {
  for (var {
    children: r,
    depth: n
  } = U_(t), o = 0, s = 0; s < r.length; s++) {
    var a = r[s];
    if (a.type === "elem") {
      var l = a.elem;
      o = Math.max(o, l.maxFontSize, l.height);
    }
  }
  o += 2;
  var c = Yn(["pstrut"], []);
  c.style.height = He(o);
  for (var u = [], m = n, g = n, h = n, A = 0; A < r.length; A++) {
    var y = r[A];
    if (y.type === "kern")
      h += y.size;
    else {
      var E = y.elem, v = y.wrapperClasses || [], C = y.wrapperStyle || {}, x = Yn(v, [c, E], void 0, C);
      x.style.top = He(-o - h - E.depth), y.marginLeft && (x.style.marginLeft = y.marginLeft), y.marginRight && (x.style.marginRight = y.marginRight), u.push(x), h += E.height + E.depth;
    }
    m = Math.min(m, h), g = Math.max(g, h);
  }
  var S = Yn(["vlist"], u);
  S.style.height = He(g);
  var R;
  if (m < 0) {
    var w = Yn([], []), T = Yn(["vlist"], [w]);
    T.style.height = He(-m);
    var N = Yn(["vlist-s"], [new Zo("​")]);
    R = [Yn(["vlist-r"], [S, N]), Yn(["vlist-r"], [T])];
  } else
    R = [Yn(["vlist-r"], [S])];
  var D = Yn(["vlist-t"], R);
  return R.length === 2 && D.classes.push("vlist-t2"), D.height = g, D.depth = -m, D;
}, Q_ = (e, t) => {
  var i = Yn(["mspace"], [], t), r = Hi(e, t);
  return i.style.marginRight = He(r), i;
}, sp = function(t, i, r) {
  var n = "";
  switch (t) {
    case "amsrm":
      n = "AMS";
      break;
    case "textrm":
      n = "Main";
      break;
    case "textsf":
      n = "SansSerif";
      break;
    case "texttt":
      n = "Typewriter";
      break;
    default:
      n = t;
  }
  var o;
  return i === "textbf" && r === "textit" ? o = "BoldItalic" : i === "textbf" ? o = "Bold" : i === "textit" ? o = "Italic" : o = "Regular", n + "-" + o;
}, q7 = {
  // styles
  mathbf: {
    variant: "bold",
    fontName: "Main-Bold"
  },
  mathrm: {
    variant: "normal",
    fontName: "Main-Regular"
  },
  textit: {
    variant: "italic",
    fontName: "Main-Italic"
  },
  mathit: {
    variant: "italic",
    fontName: "Main-Italic"
  },
  mathnormal: {
    variant: "italic",
    fontName: "Math-Italic"
  },
  // "boldsymbol" is missing because they require the use of multiple fonts:
  // Math-BoldItalic and Main-Bold.  This is handled by a special case in
  // makeOrd which ends up calling boldsymbol.
  // families
  mathbb: {
    variant: "double-struck",
    fontName: "AMS-Regular"
  },
  mathcal: {
    variant: "script",
    fontName: "Caligraphic-Regular"
  },
  mathfrak: {
    variant: "fraktur",
    fontName: "Fraktur-Regular"
  },
  mathscr: {
    variant: "script",
    fontName: "Script-Regular"
  },
  mathsf: {
    variant: "sans-serif",
    fontName: "SansSerif-Regular"
  },
  mathtt: {
    variant: "monospace",
    fontName: "Typewriter-Regular"
  }
}, j7 = {
  //   path, width, height
  vec: ["vec", 0.471, 0.714],
  // values from the font glyph
  oiintSize1: ["oiintSize1", 0.957, 0.499],
  // oval to overlay the integrand
  oiintSize2: ["oiintSize2", 1.472, 0.659],
  oiiintSize1: ["oiiintSize1", 1.304, 0.499],
  oiiintSize2: ["oiiintSize2", 1.98, 0.659]
}, W_ = function(t, i) {
  var [r, n, o] = j7[t], s = new Vl(r), a = new Ta([s], {
    width: He(n),
    height: He(o),
    // Override CSS rule `.katex svg { width: 100% }`
    style: "width:" + He(n),
    viewBox: "0 0 " + 1e3 * n + " " + 1e3 * o,
    preserveAspectRatio: "xMinYMin"
  }), l = F7(["overlay"], [a], i);
  return l.height = o, l.style.height = He(o), l.style.width = He(n), l;
}, ve = {
  fontMap: q7,
  makeSymbol: as,
  mathsym: O_,
  makeSpan: Yn,
  makeSvgSpan: F7,
  makeLineSpan: L_,
  makeAnchor: K_,
  makeFragment: V7,
  wrapFragment: Y_,
  makeVList: G_,
  makeOrd: V_,
  makeGlue: Q_,
  staticSvg: W_,
  svgData: j7,
  tryCombineChars: j_
}, Zi = {
  number: 3,
  unit: "mu"
}, sc = {
  number: 4,
  unit: "mu"
}, ua = {
  number: 5,
  unit: "mu"
}, Z_ = {
  mord: {
    mop: Zi,
    mbin: sc,
    mrel: ua,
    minner: Zi
  },
  mop: {
    mord: Zi,
    mop: Zi,
    mrel: ua,
    minner: Zi
  },
  mbin: {
    mord: sc,
    mop: sc,
    mopen: sc,
    minner: sc
  },
  mrel: {
    mord: ua,
    mop: ua,
    mopen: ua,
    minner: ua
  },
  mopen: {},
  mclose: {
    mop: Zi,
    mbin: sc,
    mrel: ua,
    minner: Zi
  },
  mpunct: {
    mord: Zi,
    mop: Zi,
    mrel: ua,
    mopen: Zi,
    mclose: Zi,
    mpunct: Zi,
    minner: Zi
  },
  minner: {
    mord: Zi,
    mop: Zi,
    mbin: sc,
    mrel: ua,
    mopen: Zi,
    mpunct: Zi,
    minner: Zi
  }
}, J_ = {
  mord: {
    mop: Zi
  },
  mop: {
    mord: Zi,
    mop: Zi
  },
  mbin: {},
  mrel: {},
  mopen: {},
  mclose: {
    mop: Zi
  },
  mpunct: {},
  minner: {
    mop: Zi
  }
}, L7 = {}, C1 = {}, x1 = {};
function rt(e) {
  for (var {
    type: t,
    names: i,
    props: r,
    handler: n,
    htmlBuilder: o,
    mathmlBuilder: s
  } = e, a = {
    type: t,
    numArgs: r.numArgs,
    argTypes: r.argTypes,
    allowedInArgument: !!r.allowedInArgument,
    allowedInText: !!r.allowedInText,
    allowedInMath: r.allowedInMath === void 0 ? !0 : r.allowedInMath,
    numOptionalArgs: r.numOptionalArgs || 0,
    infix: !!r.infix,
    primitive: !!r.primitive,
    handler: n
  }, l = 0; l < i.length; ++l)
    L7[i[l]] = a;
  t && (o && (C1[t] = o), s && (x1[t] = s));
}
function ru(e) {
  var {
    type: t,
    htmlBuilder: i,
    mathmlBuilder: r
  } = e;
  rt({
    type: t,
    names: [],
    props: {
      numArgs: 0
    },
    handler() {
      throw new Error("Should never be called.");
    },
    htmlBuilder: i,
    mathmlBuilder: r
  });
}
var I1 = function(t) {
  return t.type === "ordgroup" && t.body.length === 1 ? t.body[0] : t;
}, dr = function(t) {
  return t.type === "ordgroup" ? t.body : [t];
}, Ba = ve.makeSpan, P_ = ["leftmost", "mbin", "mopen", "mrel", "mop", "mpunct"], z_ = ["rightmost", "mrel", "mclose", "mpunct"], H_ = {
  display: bt.DISPLAY,
  text: bt.TEXT,
  script: bt.SCRIPT,
  scriptscript: bt.SCRIPTSCRIPT
}, X_ = {
  mord: "mord",
  mop: "mop",
  mbin: "mbin",
  mrel: "mrel",
  mopen: "mopen",
  mclose: "mclose",
  mpunct: "mpunct",
  minner: "minner"
}, Ir = function(t, i, r, n) {
  n === void 0 && (n = [null, null]);
  for (var o = [], s = 0; s < t.length; s++) {
    var a = ii(t[s], i);
    if (a instanceof bg) {
      var l = a.children;
      o.push(...l);
    } else
      o.push(a);
  }
  if (ve.tryCombineChars(o), !r)
    return o;
  var c = i;
  if (t.length === 1) {
    var u = t[0];
    u.type === "sizing" ? c = i.havingSize(u.size) : u.type === "styling" && (c = i.havingStyle(H_[u.style]));
  }
  var m = Ba([n[0] || "leftmost"], [], i), g = Ba([n[1] || "rightmost"], [], i), h = r === "root";
  return d4(o, (A, y) => {
    var E = y.classes[0], v = A.classes[0];
    E === "mbin" && Rt.contains(z_, v) ? y.classes[0] = "mord" : v === "mbin" && Rt.contains(P_, E) && (A.classes[0] = "mord");
  }, {
    node: m
  }, g, h), d4(o, (A, y) => {
    var E = Lb(y), v = Lb(A), C = E && v ? A.hasClass("mtight") ? J_[E][v] : Z_[E][v] : null;
    if (C)
      return ve.makeGlue(C, c);
  }, {
    node: m
  }, g, h), o;
}, d4 = function e(t, i, r, n, o) {
  n && t.push(n);
  for (var s = 0; s < t.length; s++) {
    var a = t[s], l = K7(a);
    if (l) {
      e(l.children, i, r, null, o);
      continue;
    }
    var c = !a.hasClass("mspace");
    if (c) {
      var u = i(a, r.node);
      u && (r.insertAfter ? r.insertAfter(u) : (t.unshift(u), s++));
    }
    c ? r.node = a : o && a.hasClass("newline") && (r.node = Ba(["leftmost"])), r.insertAfter = ((m) => (g) => {
      t.splice(m + 1, 0, g), s++;
    })(s);
  }
  n && t.pop();
}, K7 = function(t) {
  return t instanceof bg || t instanceof G2 || t instanceof Cg && t.hasClass("enclosing") ? t : null;
}, __ = function e(t, i) {
  var r = K7(t);
  if (r) {
    var n = r.children;
    if (n.length) {
      if (i === "right")
        return e(n[n.length - 1], "right");
      if (i === "left")
        return e(n[0], "left");
    }
  }
  return t;
}, Lb = function(t, i) {
  return t ? (i && (t = __(t, i)), X_[t.classes[0]] || null) : null;
}, Zm = function(t, i) {
  var r = ["nulldelimiter"].concat(t.baseSizingClasses());
  return Ba(i.concat(r));
}, ii = function(t, i, r) {
  if (!t)
    return Ba();
  if (C1[t.type]) {
    var n = C1[t.type](t, i);
    if (r && i.size !== r.size) {
      n = Ba(i.sizingClasses(r), [n], i);
      var o = i.sizeMultiplier / r.sizeMultiplier;
      n.height *= o, n.depth *= o;
    }
    return n;
  } else
    throw new We("Got group of unknown type: '" + t.type + "'");
};
function ap(e, t) {
  var i = Ba(["base"], e, t), r = Ba(["strut"]);
  return r.style.height = He(i.height + i.depth), i.depth && (r.style.verticalAlign = He(-i.depth)), i.children.unshift(r), i;
}
function Kb(e, t) {
  var i = null;
  e.length === 1 && e[0].type === "tag" && (i = e[0].tag, e = e[0].body);
  var r = Ir(e, t, "root"), n;
  r.length === 2 && r[1].hasClass("tag") && (n = r.pop());
  for (var o = [], s = [], a = 0; a < r.length; a++)
    if (s.push(r[a]), r[a].hasClass("mbin") || r[a].hasClass("mrel") || r[a].hasClass("allowbreak")) {
      for (var l = !1; a < r.length - 1 && r[a + 1].hasClass("mspace") && !r[a + 1].hasClass("newline"); )
        a++, s.push(r[a]), r[a].hasClass("nobreak") && (l = !0);
      l || (o.push(ap(s, t)), s = []);
    } else
      r[a].hasClass("newline") && (s.pop(), s.length > 0 && (o.push(ap(s, t)), s = []), o.push(r[a]));
  s.length > 0 && o.push(ap(s, t));
  var c;
  i ? (c = ap(Ir(i, t, !0)), c.classes = ["tag"], o.push(c)) : n && o.push(n);
  var u = Ba(["katex-html"], o);
  if (u.setAttribute("aria-hidden", "true"), c) {
    var m = c.children[0];
    m.style.height = He(u.height + u.depth), u.depth && (m.style.verticalAlign = He(-u.depth));
  }
  return u;
}
function Y7(e) {
  return new bg(e);
}
class Ko {
  constructor(t, i, r) {
    this.type = void 0, this.attributes = void 0, this.children = void 0, this.classes = void 0, this.type = t, this.attributes = {}, this.children = i || [], this.classes = r || [];
  }
  /**
   * Sets an attribute on a MathML node. MathML depends on attributes to convey a
   * semantic content, so this is used heavily.
   */
  setAttribute(t, i) {
    this.attributes[t] = i;
  }
  /**
   * Gets an attribute on a MathML node.
   */
  getAttribute(t) {
    return this.attributes[t];
  }
  /**
   * Converts the math node into a MathML-namespaced DOM element.
   */
  toNode() {
    var t = document.createElementNS("http://www.w3.org/1998/Math/MathML", this.type);
    for (var i in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, i) && t.setAttribute(i, this.attributes[i]);
    this.classes.length > 0 && (t.className = Fl(this.classes));
    for (var r = 0; r < this.children.length; r++)
      t.appendChild(this.children[r].toNode());
    return t;
  }
  /**
   * Converts the math node into an HTML markup string.
   */
  toMarkup() {
    var t = "<" + this.type;
    for (var i in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, i) && (t += " " + i + '="', t += Rt.escape(this.attributes[i]), t += '"');
    this.classes.length > 0 && (t += ' class ="' + Rt.escape(Fl(this.classes)) + '"'), t += ">";
    for (var r = 0; r < this.children.length; r++)
      t += this.children[r].toMarkup();
    return t += "</" + this.type + ">", t;
  }
  /**
   * Converts the math node into a string, similar to innerText, but escaped.
   */
  toText() {
    return this.children.map((t) => t.toText()).join("");
  }
}
class vm {
  constructor(t) {
    this.text = void 0, this.text = t;
  }
  /**
   * Converts the text node into a DOM text node.
   */
  toNode() {
    return document.createTextNode(this.text);
  }
  /**
   * Converts the text node into escaped HTML markup
   * (representing the text itself).
   */
  toMarkup() {
    return Rt.escape(this.toText());
  }
  /**
   * Converts the text node into a string
   * (representing the text itself).
   */
  toText() {
    return this.text;
  }
}
class $_ {
  /**
   * Create a Space node with width given in CSS ems.
   */
  constructor(t) {
    this.width = void 0, this.character = void 0, this.width = t, t >= 0.05555 && t <= 0.05556 ? this.character = " " : t >= 0.1666 && t <= 0.1667 ? this.character = " " : t >= 0.2222 && t <= 0.2223 ? this.character = " " : t >= 0.2777 && t <= 0.2778 ? this.character = "  " : t >= -0.05556 && t <= -0.05555 ? this.character = " ⁣" : t >= -0.1667 && t <= -0.1666 ? this.character = " ⁣" : t >= -0.2223 && t <= -0.2222 ? this.character = " ⁣" : t >= -0.2778 && t <= -0.2777 ? this.character = " ⁣" : this.character = null;
  }
  /**
   * Converts the math node into a MathML-namespaced DOM element.
   */
  toNode() {
    if (this.character)
      return document.createTextNode(this.character);
    var t = document.createElementNS("http://www.w3.org/1998/Math/MathML", "mspace");
    return t.setAttribute("width", He(this.width)), t;
  }
  /**
   * Converts the math node into an HTML markup string.
   */
  toMarkup() {
    return this.character ? "<mtext>" + this.character + "</mtext>" : '<mspace width="' + He(this.width) + '"/>';
  }
  /**
   * Converts the math node into a string, similar to innerText.
   */
  toText() {
    return this.character ? this.character : " ";
  }
}
var Ge = {
  MathNode: Ko,
  TextNode: vm,
  SpaceNode: $_,
  newDocumentFragment: Y7
}, Jo = function(t, i, r) {
  return Mi[i][t] && Mi[i][t].replace && t.charCodeAt(0) !== 55349 && !(O7.hasOwnProperty(t) && r && (r.fontFamily && r.fontFamily.slice(4, 6) === "tt" || r.font && r.font.slice(4, 6) === "tt")) && (t = Mi[i][t].replace), new Ge.TextNode(t);
}, W2 = function(t) {
  return t.length === 1 ? t[0] : new Ge.MathNode("mrow", t);
}, Z2 = function(t, i) {
  if (i.fontFamily === "texttt")
    return "monospace";
  if (i.fontFamily === "textsf")
    return i.fontShape === "textit" && i.fontWeight === "textbf" ? "sans-serif-bold-italic" : i.fontShape === "textit" ? "sans-serif-italic" : i.fontWeight === "textbf" ? "bold-sans-serif" : "sans-serif";
  if (i.fontShape === "textit" && i.fontWeight === "textbf")
    return "bold-italic";
  if (i.fontShape === "textit")
    return "italic";
  if (i.fontWeight === "textbf")
    return "bold";
  var r = i.font;
  if (!r || r === "mathnormal")
    return null;
  var n = t.mode;
  if (r === "mathit")
    return "italic";
  if (r === "boldsymbol")
    return t.type === "textord" ? "bold" : "bold-italic";
  if (r === "mathbf")
    return "bold";
  if (r === "mathbb")
    return "double-struck";
  if (r === "mathfrak")
    return "fraktur";
  if (r === "mathscr" || r === "mathcal")
    return "script";
  if (r === "mathsf")
    return "sans-serif";
  if (r === "mathtt")
    return "monospace";
  var o = t.text;
  if (Rt.contains(["\\imath", "\\jmath"], o))
    return null;
  Mi[n][o] && Mi[n][o].replace && (o = Mi[n][o].replace);
  var s = ve.fontMap[r].fontName;
  return U2(o, s, n) ? ve.fontMap[r].variant : null;
}, zn = function(t, i, r) {
  if (t.length === 1) {
    var n = Si(t[0], i);
    return r && n instanceof Ko && n.type === "mo" && (n.setAttribute("lspace", "0em"), n.setAttribute("rspace", "0em")), [n];
  }
  for (var o = [], s, a = 0; a < t.length; a++) {
    var l = Si(t[a], i);
    if (l instanceof Ko && s instanceof Ko) {
      if (l.type === "mtext" && s.type === "mtext" && l.getAttribute("mathvariant") === s.getAttribute("mathvariant")) {
        s.children.push(...l.children);
        continue;
      } else if (l.type === "mn" && s.type === "mn") {
        s.children.push(...l.children);
        continue;
      } else if (l.type === "mi" && l.children.length === 1 && s.type === "mn") {
        var c = l.children[0];
        if (c instanceof vm && c.text === ".") {
          s.children.push(...l.children);
          continue;
        }
      } else if (s.type === "mi" && s.children.length === 1) {
        var u = s.children[0];
        if (u instanceof vm && u.text === "̸" && (l.type === "mo" || l.type === "mi" || l.type === "mn")) {
          var m = l.children[0];
          m instanceof vm && m.text.length > 0 && (m.text = m.text.slice(0, 1) + "̸" + m.text.slice(1), o.pop());
        }
      }
    }
    o.push(l), s = l;
  }
  return o;
}, ql = function(t, i, r) {
  return W2(zn(t, i, r));
}, Si = function(t, i) {
  if (!t)
    return new Ge.MathNode("mrow");
  if (x1[t.type]) {
    var r = x1[t.type](t, i);
    return r;
  } else
    throw new We("Got group of unknown type: '" + t.type + "'");
};
function m4(e, t, i, r, n) {
  var o = zn(e, i), s;
  o.length === 1 && o[0] instanceof Ko && Rt.contains(["mrow", "mtable"], o[0].type) ? s = o[0] : s = new Ge.MathNode("mrow", o);
  var a = new Ge.MathNode("annotation", [new Ge.TextNode(t)]);
  a.setAttribute("encoding", "application/x-tex");
  var l = new Ge.MathNode("semantics", [s, a]), c = new Ge.MathNode("math", [l]);
  c.setAttribute("xmlns", "http://www.w3.org/1998/Math/MathML"), r && c.setAttribute("display", "block");
  var u = n ? "katex" : "katex-mathml";
  return ve.makeSpan([u], [c]);
}
var U7 = function(t) {
  return new ba({
    style: t.displayMode ? bt.DISPLAY : bt.TEXT,
    maxSize: t.maxSize,
    minRuleThickness: t.minRuleThickness
  });
}, G7 = function(t, i) {
  if (i.displayMode) {
    var r = ["katex-display"];
    i.leqno && r.push("leqno"), i.fleqn && r.push("fleqn"), t = ve.makeSpan(r, [t]);
  }
  return t;
}, e$ = function(t, i, r) {
  var n = U7(r), o;
  if (r.output === "mathml")
    return m4(t, i, n, r.displayMode, !0);
  if (r.output === "html") {
    var s = Kb(t, n);
    o = ve.makeSpan(["katex"], [s]);
  } else {
    var a = m4(t, i, n, r.displayMode, !1), l = Kb(t, n);
    o = ve.makeSpan(["katex"], [a, l]);
  }
  return G7(o, r);
}, t$ = function(t, i, r) {
  var n = U7(r), o = Kb(t, n), s = ve.makeSpan(["katex"], [o]);
  return G7(s, r);
}, i$ = {
  widehat: "^",
  widecheck: "ˇ",
  widetilde: "~",
  utilde: "~",
  overleftarrow: "←",
  underleftarrow: "←",
  xleftarrow: "←",
  overrightarrow: "→",
  underrightarrow: "→",
  xrightarrow: "→",
  underbrace: "⏟",
  overbrace: "⏞",
  overgroup: "⏠",
  undergroup: "⏡",
  overleftrightarrow: "↔",
  underleftrightarrow: "↔",
  xleftrightarrow: "↔",
  Overrightarrow: "⇒",
  xRightarrow: "⇒",
  overleftharpoon: "↼",
  xleftharpoonup: "↼",
  overrightharpoon: "⇀",
  xrightharpoonup: "⇀",
  xLeftarrow: "⇐",
  xLeftrightarrow: "⇔",
  xhookleftarrow: "↩",
  xhookrightarrow: "↪",
  xmapsto: "↦",
  xrightharpoondown: "⇁",
  xleftharpoondown: "↽",
  xrightleftharpoons: "⇌",
  xleftrightharpoons: "⇋",
  xtwoheadleftarrow: "↞",
  xtwoheadrightarrow: "↠",
  xlongequal: "=",
  xtofrom: "⇄",
  xrightleftarrows: "⇄",
  xrightequilibrium: "⇌",
  // Not a perfect match.
  xleftequilibrium: "⇋",
  // None better available.
  "\\cdrightarrow": "→",
  "\\cdleftarrow": "←",
  "\\cdlongequal": "="
}, r$ = function(t) {
  var i = new Ge.MathNode("mo", [new Ge.TextNode(i$[t.replace(/^\\/, "")])]);
  return i.setAttribute("stretchy", "true"), i;
}, n$ = {
  //   path(s), minWidth, height, align
  overrightarrow: [["rightarrow"], 0.888, 522, "xMaxYMin"],
  overleftarrow: [["leftarrow"], 0.888, 522, "xMinYMin"],
  underrightarrow: [["rightarrow"], 0.888, 522, "xMaxYMin"],
  underleftarrow: [["leftarrow"], 0.888, 522, "xMinYMin"],
  xrightarrow: [["rightarrow"], 1.469, 522, "xMaxYMin"],
  "\\cdrightarrow": [["rightarrow"], 3, 522, "xMaxYMin"],
  // CD minwwidth2.5pc
  xleftarrow: [["leftarrow"], 1.469, 522, "xMinYMin"],
  "\\cdleftarrow": [["leftarrow"], 3, 522, "xMinYMin"],
  Overrightarrow: [["doublerightarrow"], 0.888, 560, "xMaxYMin"],
  xRightarrow: [["doublerightarrow"], 1.526, 560, "xMaxYMin"],
  xLeftarrow: [["doubleleftarrow"], 1.526, 560, "xMinYMin"],
  overleftharpoon: [["leftharpoon"], 0.888, 522, "xMinYMin"],
  xleftharpoonup: [["leftharpoon"], 0.888, 522, "xMinYMin"],
  xleftharpoondown: [["leftharpoondown"], 0.888, 522, "xMinYMin"],
  overrightharpoon: [["rightharpoon"], 0.888, 522, "xMaxYMin"],
  xrightharpoonup: [["rightharpoon"], 0.888, 522, "xMaxYMin"],
  xrightharpoondown: [["rightharpoondown"], 0.888, 522, "xMaxYMin"],
  xlongequal: [["longequal"], 0.888, 334, "xMinYMin"],
  "\\cdlongequal": [["longequal"], 3, 334, "xMinYMin"],
  xtwoheadleftarrow: [["twoheadleftarrow"], 0.888, 334, "xMinYMin"],
  xtwoheadrightarrow: [["twoheadrightarrow"], 0.888, 334, "xMaxYMin"],
  overleftrightarrow: [["leftarrow", "rightarrow"], 0.888, 522],
  overbrace: [["leftbrace", "midbrace", "rightbrace"], 1.6, 548],
  underbrace: [["leftbraceunder", "midbraceunder", "rightbraceunder"], 1.6, 548],
  underleftrightarrow: [["leftarrow", "rightarrow"], 0.888, 522],
  xleftrightarrow: [["leftarrow", "rightarrow"], 1.75, 522],
  xLeftrightarrow: [["doubleleftarrow", "doublerightarrow"], 1.75, 560],
  xrightleftharpoons: [["leftharpoondownplus", "rightharpoonplus"], 1.75, 716],
  xleftrightharpoons: [["leftharpoonplus", "rightharpoondownplus"], 1.75, 716],
  xhookleftarrow: [["leftarrow", "righthook"], 1.08, 522],
  xhookrightarrow: [["lefthook", "rightarrow"], 1.08, 522],
  overlinesegment: [["leftlinesegment", "rightlinesegment"], 0.888, 522],
  underlinesegment: [["leftlinesegment", "rightlinesegment"], 0.888, 522],
  overgroup: [["leftgroup", "rightgroup"], 0.888, 342],
  undergroup: [["leftgroupunder", "rightgroupunder"], 0.888, 342],
  xmapsto: [["leftmapsto", "rightarrow"], 1.5, 522],
  xtofrom: [["leftToFrom", "rightToFrom"], 1.75, 528],
  // The next three arrows are from the mhchem package.
  // In mhchem.sty, min-length is 2.0em. But these arrows might appear in the
  // document as \xrightarrow or \xrightleftharpoons. Those have
  // min-length = 1.75em, so we set min-length on these next three to match.
  xrightleftarrows: [["baraboveleftarrow", "rightarrowabovebar"], 1.75, 901],
  xrightequilibrium: [["baraboveshortleftharpoon", "rightharpoonaboveshortbar"], 1.75, 716],
  xleftequilibrium: [["shortbaraboveleftharpoon", "shortrightharpoonabovebar"], 1.75, 716]
}, o$ = function(t) {
  return t.type === "ordgroup" ? t.body.length : 1;
}, s$ = function(t, i) {
  function r() {
    var a = 4e5, l = t.label.slice(1);
    if (Rt.contains(["widehat", "widecheck", "widetilde", "utilde"], l)) {
      var c = t, u = o$(c.base), m, g, h;
      if (u > 5)
        l === "widehat" || l === "widecheck" ? (m = 420, a = 2364, h = 0.42, g = l + "4") : (m = 312, a = 2340, h = 0.34, g = "tilde4");
      else {
        var A = [1, 1, 2, 2, 3, 3][u];
        l === "widehat" || l === "widecheck" ? (a = [0, 1062, 2364, 2364, 2364][A], m = [0, 239, 300, 360, 420][A], h = [0, 0.24, 0.3, 0.3, 0.36, 0.42][A], g = l + A) : (a = [0, 600, 1033, 2339, 2340][A], m = [0, 260, 286, 306, 312][A], h = [0, 0.26, 0.286, 0.3, 0.306, 0.34][A], g = "tilde" + A);
      }
      var y = new Vl(g), E = new Ta([y], {
        width: "100%",
        height: He(h),
        viewBox: "0 0 " + a + " " + m,
        preserveAspectRatio: "none"
      });
      return {
        span: ve.makeSvgSpan([], [E], i),
        minWidth: 0,
        height: h
      };
    } else {
      var v = [], C = n$[l], [x, S, R] = C, w = R / 1e3, T = x.length, N, D;
      if (T === 1) {
        var O = C[3];
        N = ["hide-tail"], D = [O];
      } else if (T === 2)
        N = ["halfarrow-left", "halfarrow-right"], D = ["xMinYMin", "xMaxYMin"];
      else if (T === 3)
        N = ["brace-left", "brace-center", "brace-right"], D = ["xMinYMin", "xMidYMin", "xMaxYMin"];
      else
        throw new Error(`Correct katexImagesData or update code here to support
                    ` + T + " children.");
      for (var F = 0; F < T; F++) {
        var Y = new Vl(x[F]), P = new Ta([Y], {
          width: "400em",
          height: He(w),
          viewBox: "0 0 " + a + " " + R,
          preserveAspectRatio: D[F] + " slice"
        }), z = ve.makeSvgSpan([N[F]], [P], i);
        if (T === 1)
          return {
            span: z,
            minWidth: S,
            height: w
          };
        z.style.height = He(w), v.push(z);
      }
      return {
        span: ve.makeSpan(["stretchy"], v, i),
        minWidth: S,
        height: w
      };
    }
  }
  var {
    span: n,
    minWidth: o,
    height: s
  } = r();
  return n.height = s, n.style.height = He(s), o > 0 && (n.style.minWidth = He(o)), n;
}, a$ = function(t, i, r, n, o) {
  var s, a = t.height + t.depth + r + n;
  if (/fbox|color|angl/.test(i)) {
    if (s = ve.makeSpan(["stretchy", i], [], o), i === "fbox") {
      var l = o.color && o.getColor();
      l && (s.style.borderColor = l);
    }
  } else {
    var c = [];
    /^[bx]cancel$/.test(i) && c.push(new qb({
      x1: "0",
      y1: "0",
      x2: "100%",
      y2: "100%",
      "stroke-width": "0.046em"
    })), /^x?cancel$/.test(i) && c.push(new qb({
      x1: "0",
      y1: "100%",
      x2: "100%",
      y2: "0",
      "stroke-width": "0.046em"
    }));
    var u = new Ta(c, {
      width: "100%",
      height: He(a)
    });
    s = ve.makeSvgSpan([], [u], o);
  }
  return s.height = a, s.style.height = He(a), s;
}, Da = {
  encloseSpan: a$,
  mathMLnode: r$,
  svgSpan: s$
};
function Ft(e, t) {
  if (!e || e.type !== t)
    throw new Error("Expected node of type " + t + ", but got " + (e ? "node of type " + e.type : String(e)));
  return e;
}
function J2(e) {
  var t = xf(e);
  if (!t)
    throw new Error("Expected node of symbol group type, but got " + (e ? "node of type " + e.type : String(e)));
  return t;
}
function xf(e) {
  return e && (e.type === "atom" || B_.hasOwnProperty(e.type)) ? e : null;
}
var P2 = (e, t) => {
  var i, r, n;
  e && e.type === "supsub" ? (r = Ft(e.base, "accent"), i = r.base, e.base = i, n = N_(ii(e, t)), e.base = r) : (r = Ft(e, "accent"), i = r.base);
  var o = ii(i, t.havingCrampedStyle()), s = r.isShifty && Rt.isCharacterBox(i), a = 0;
  if (s) {
    var l = Rt.getBaseElem(i), c = ii(l, t.havingCrampedStyle());
    a = o4(c).skew;
  }
  var u = r.label === "\\c", m = u ? o.height + o.depth : Math.min(o.height, t.fontMetrics().xHeight), g;
  if (r.isStretchy)
    g = Da.svgSpan(r, t), g = ve.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: o
      }, {
        type: "elem",
        elem: g,
        wrapperClasses: ["svg-align"],
        wrapperStyle: a > 0 ? {
          width: "calc(100% - " + He(2 * a) + ")",
          marginLeft: He(2 * a)
        } : void 0
      }]
    }, t);
  else {
    var h, A;
    r.label === "\\vec" ? (h = ve.staticSvg("vec", t), A = ve.svgData.vec[1]) : (h = ve.makeOrd({
      mode: r.mode,
      text: r.label
    }, t, "textord"), h = o4(h), h.italic = 0, A = h.width, u && (m += h.depth)), g = ve.makeSpan(["accent-body"], [h]);
    var y = r.label === "\\textcircled";
    y && (g.classes.push("accent-full"), m = o.height);
    var E = a;
    y || (E -= A / 2), g.style.left = He(E), r.label === "\\textcircled" && (g.style.top = ".2em"), g = ve.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: o
      }, {
        type: "kern",
        size: -m
      }, {
        type: "elem",
        elem: g
      }]
    }, t);
  }
  var v = ve.makeSpan(["mord", "accent"], [g], t);
  return n ? (n.children[0] = v, n.height = Math.max(v.height, n.height), n.classes[0] = "mord", n) : v;
}, Q7 = (e, t) => {
  var i = e.isStretchy ? Da.mathMLnode(e.label) : new Ge.MathNode("mo", [Jo(e.label, e.mode)]), r = new Ge.MathNode("mover", [Si(e.base, t), i]);
  return r.setAttribute("accent", "true"), r;
}, l$ = new RegExp(["\\acute", "\\grave", "\\ddot", "\\tilde", "\\bar", "\\breve", "\\check", "\\hat", "\\vec", "\\dot", "\\mathring"].map((e) => "\\" + e).join("|"));
rt({
  type: "accent",
  names: ["\\acute", "\\grave", "\\ddot", "\\tilde", "\\bar", "\\breve", "\\check", "\\hat", "\\vec", "\\dot", "\\mathring", "\\widecheck", "\\widehat", "\\widetilde", "\\overrightarrow", "\\overleftarrow", "\\Overrightarrow", "\\overleftrightarrow", "\\overgroup", "\\overlinesegment", "\\overleftharpoon", "\\overrightharpoon"],
  props: {
    numArgs: 1
  },
  handler: (e, t) => {
    var i = I1(t[0]), r = !l$.test(e.funcName), n = !r || e.funcName === "\\widehat" || e.funcName === "\\widetilde" || e.funcName === "\\widecheck";
    return {
      type: "accent",
      mode: e.parser.mode,
      label: e.funcName,
      isStretchy: r,
      isShifty: n,
      base: i
    };
  },
  htmlBuilder: P2,
  mathmlBuilder: Q7
});
rt({
  type: "accent",
  names: ["\\'", "\\`", "\\^", "\\~", "\\=", "\\u", "\\.", '\\"', "\\c", "\\r", "\\H", "\\v", "\\textcircled"],
  props: {
    numArgs: 1,
    allowedInText: !0,
    allowedInMath: !0,
    // unless in strict mode
    argTypes: ["primitive"]
  },
  handler: (e, t) => {
    var i = t[0], r = e.parser.mode;
    return r === "math" && (e.parser.settings.reportNonstrict("mathVsTextAccents", "LaTeX's accent " + e.funcName + " works only in text mode"), r = "text"), {
      type: "accent",
      mode: r,
      label: e.funcName,
      isStretchy: !1,
      isShifty: !0,
      base: i
    };
  },
  htmlBuilder: P2,
  mathmlBuilder: Q7
});
rt({
  type: "accentUnder",
  names: ["\\underleftarrow", "\\underrightarrow", "\\underleftrightarrow", "\\undergroup", "\\underlinesegment", "\\utilde"],
  props: {
    numArgs: 1
  },
  handler: (e, t) => {
    var {
      parser: i,
      funcName: r
    } = e, n = t[0];
    return {
      type: "accentUnder",
      mode: i.mode,
      label: r,
      base: n
    };
  },
  htmlBuilder: (e, t) => {
    var i = ii(e.base, t), r = Da.svgSpan(e, t), n = e.label === "\\utilde" ? 0.12 : 0, o = ve.makeVList({
      positionType: "top",
      positionData: i.height,
      children: [{
        type: "elem",
        elem: r,
        wrapperClasses: ["svg-align"]
      }, {
        type: "kern",
        size: n
      }, {
        type: "elem",
        elem: i
      }]
    }, t);
    return ve.makeSpan(["mord", "accentunder"], [o], t);
  },
  mathmlBuilder: (e, t) => {
    var i = Da.mathMLnode(e.label), r = new Ge.MathNode("munder", [Si(e.base, t), i]);
    return r.setAttribute("accentunder", "true"), r;
  }
});
var lp = (e) => {
  var t = new Ge.MathNode("mpadded", e ? [e] : []);
  return t.setAttribute("width", "+0.6em"), t.setAttribute("lspace", "0.3em"), t;
};
rt({
  type: "xArrow",
  names: [
    "\\xleftarrow",
    "\\xrightarrow",
    "\\xLeftarrow",
    "\\xRightarrow",
    "\\xleftrightarrow",
    "\\xLeftrightarrow",
    "\\xhookleftarrow",
    "\\xhookrightarrow",
    "\\xmapsto",
    "\\xrightharpoondown",
    "\\xrightharpoonup",
    "\\xleftharpoondown",
    "\\xleftharpoonup",
    "\\xrightleftharpoons",
    "\\xleftrightharpoons",
    "\\xlongequal",
    "\\xtwoheadrightarrow",
    "\\xtwoheadleftarrow",
    "\\xtofrom",
    // The next 3 functions are here to support the mhchem extension.
    // Direct use of these functions is discouraged and may break someday.
    "\\xrightleftarrows",
    "\\xrightequilibrium",
    "\\xleftequilibrium",
    // The next 3 functions are here only to support the {CD} environment.
    "\\\\cdrightarrow",
    "\\\\cdleftarrow",
    "\\\\cdlongequal"
  ],
  props: {
    numArgs: 1,
    numOptionalArgs: 1
  },
  handler(e, t, i) {
    var {
      parser: r,
      funcName: n
    } = e;
    return {
      type: "xArrow",
      mode: r.mode,
      label: n,
      body: t[0],
      below: i[0]
    };
  },
  // Flow is unable to correctly infer the type of `group`, even though it's
  // unambiguously determined from the passed-in `type` above.
  htmlBuilder(e, t) {
    var i = t.style, r = t.havingStyle(i.sup()), n = ve.wrapFragment(ii(e.body, r, t), t), o = e.label.slice(0, 2) === "\\x" ? "x" : "cd";
    n.classes.push(o + "-arrow-pad");
    var s;
    e.below && (r = t.havingStyle(i.sub()), s = ve.wrapFragment(ii(e.below, r, t), t), s.classes.push(o + "-arrow-pad"));
    var a = Da.svgSpan(e, t), l = -t.fontMetrics().axisHeight + 0.5 * a.height, c = -t.fontMetrics().axisHeight - 0.5 * a.height - 0.111;
    (n.depth > 0.25 || e.label === "\\xleftequilibrium") && (c -= n.depth);
    var u;
    if (s) {
      var m = -t.fontMetrics().axisHeight + s.height + 0.5 * a.height + 0.111;
      u = ve.makeVList({
        positionType: "individualShift",
        children: [{
          type: "elem",
          elem: n,
          shift: c
        }, {
          type: "elem",
          elem: a,
          shift: l
        }, {
          type: "elem",
          elem: s,
          shift: m
        }]
      }, t);
    } else
      u = ve.makeVList({
        positionType: "individualShift",
        children: [{
          type: "elem",
          elem: n,
          shift: c
        }, {
          type: "elem",
          elem: a,
          shift: l
        }]
      }, t);
    return u.children[0].children[0].children[1].classes.push("svg-align"), ve.makeSpan(["mrel", "x-arrow"], [u], t);
  },
  mathmlBuilder(e, t) {
    var i = Da.mathMLnode(e.label);
    i.setAttribute("minsize", e.label.charAt(0) === "x" ? "1.75em" : "3.0em");
    var r;
    if (e.body) {
      var n = lp(Si(e.body, t));
      if (e.below) {
        var o = lp(Si(e.below, t));
        r = new Ge.MathNode("munderover", [i, o, n]);
      } else
        r = new Ge.MathNode("mover", [i, n]);
    } else if (e.below) {
      var s = lp(Si(e.below, t));
      r = new Ge.MathNode("munder", [i, s]);
    } else
      r = lp(), r = new Ge.MathNode("mover", [i, r]);
    return r;
  }
});
var c$ = ve.makeSpan;
function W7(e, t) {
  var i = Ir(e.body, t, !0);
  return c$([e.mclass], i, t);
}
function Z7(e, t) {
  var i, r = zn(e.body, t);
  return e.mclass === "minner" ? i = new Ge.MathNode("mpadded", r) : e.mclass === "mord" ? e.isCharacterBox ? (i = r[0], i.type = "mi") : i = new Ge.MathNode("mi", r) : (e.isCharacterBox ? (i = r[0], i.type = "mo") : i = new Ge.MathNode("mo", r), e.mclass === "mbin" ? (i.attributes.lspace = "0.22em", i.attributes.rspace = "0.22em") : e.mclass === "mpunct" ? (i.attributes.lspace = "0em", i.attributes.rspace = "0.17em") : e.mclass === "mopen" || e.mclass === "mclose" ? (i.attributes.lspace = "0em", i.attributes.rspace = "0em") : e.mclass === "minner" && (i.attributes.lspace = "0.0556em", i.attributes.width = "+0.1111em")), i;
}
rt({
  type: "mclass",
  names: ["\\mathord", "\\mathbin", "\\mathrel", "\\mathopen", "\\mathclose", "\\mathpunct", "\\mathinner"],
  props: {
    numArgs: 1,
    primitive: !0
  },
  handler(e, t) {
    var {
      parser: i,
      funcName: r
    } = e, n = t[0];
    return {
      type: "mclass",
      mode: i.mode,
      mclass: "m" + r.slice(5),
      // TODO(kevinb): don't prefix with 'm'
      body: dr(n),
      isCharacterBox: Rt.isCharacterBox(n)
    };
  },
  htmlBuilder: W7,
  mathmlBuilder: Z7
});
var If = (e) => {
  var t = e.type === "ordgroup" && e.body.length ? e.body[0] : e;
  return t.type === "atom" && (t.family === "bin" || t.family === "rel") ? "m" + t.family : "mord";
};
rt({
  type: "mclass",
  names: ["\\@binrel"],
  props: {
    numArgs: 2
  },
  handler(e, t) {
    var {
      parser: i
    } = e;
    return {
      type: "mclass",
      mode: i.mode,
      mclass: If(t[0]),
      body: dr(t[1]),
      isCharacterBox: Rt.isCharacterBox(t[1])
    };
  }
});
rt({
  type: "mclass",
  names: ["\\stackrel", "\\overset", "\\underset"],
  props: {
    numArgs: 2
  },
  handler(e, t) {
    var {
      parser: i,
      funcName: r
    } = e, n = t[1], o = t[0], s;
    r !== "\\stackrel" ? s = If(n) : s = "mrel";
    var a = {
      type: "op",
      mode: n.mode,
      limits: !0,
      alwaysHandleSupSub: !0,
      parentIsSupSub: !1,
      symbol: !1,
      suppressBaseShift: r !== "\\stackrel",
      body: dr(n)
    }, l = {
      type: "supsub",
      mode: o.mode,
      base: a,
      sup: r === "\\underset" ? null : o,
      sub: r === "\\underset" ? o : null
    };
    return {
      type: "mclass",
      mode: i.mode,
      mclass: s,
      body: [l],
      isCharacterBox: Rt.isCharacterBox(l)
    };
  },
  htmlBuilder: W7,
  mathmlBuilder: Z7
});
rt({
  type: "pmb",
  names: ["\\pmb"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler(e, t) {
    var {
      parser: i
    } = e;
    return {
      type: "pmb",
      mode: i.mode,
      mclass: If(t[0]),
      body: dr(t[0])
    };
  },
  htmlBuilder(e, t) {
    var i = Ir(e.body, t, !0), r = ve.makeSpan([e.mclass], i, t);
    return r.style.textShadow = "0.02em 0.01em 0.04px", r;
  },
  mathmlBuilder(e, t) {
    var i = zn(e.body, t), r = new Ge.MathNode("mstyle", i);
    return r.setAttribute("style", "text-shadow: 0.02em 0.01em 0.04px"), r;
  }
});
var u$ = {
  ">": "\\\\cdrightarrow",
  "<": "\\\\cdleftarrow",
  "=": "\\\\cdlongequal",
  A: "\\uparrow",
  V: "\\downarrow",
  "|": "\\Vert",
  ".": "no arrow"
}, g4 = () => ({
  type: "styling",
  body: [],
  mode: "math",
  style: "display"
}), h4 = (e) => e.type === "textord" && e.text === "@", d$ = (e, t) => (e.type === "mathord" || e.type === "atom") && e.text === t;
function m$(e, t, i) {
  var r = u$[e];
  switch (r) {
    case "\\\\cdrightarrow":
    case "\\\\cdleftarrow":
      return i.callFunction(r, [t[0]], [t[1]]);
    case "\\uparrow":
    case "\\downarrow": {
      var n = i.callFunction("\\\\cdleft", [t[0]], []), o = {
        type: "atom",
        text: r,
        mode: "math",
        family: "rel"
      }, s = i.callFunction("\\Big", [o], []), a = i.callFunction("\\\\cdright", [t[1]], []), l = {
        type: "ordgroup",
        mode: "math",
        body: [n, s, a]
      };
      return i.callFunction("\\\\cdparent", [l], []);
    }
    case "\\\\cdlongequal":
      return i.callFunction("\\\\cdlongequal", [], []);
    case "\\Vert": {
      var c = {
        type: "textord",
        text: "\\Vert",
        mode: "math"
      };
      return i.callFunction("\\Big", [c], []);
    }
    default:
      return {
        type: "textord",
        text: " ",
        mode: "math"
      };
  }
}
function g$(e) {
  var t = [];
  for (e.gullet.beginGroup(), e.gullet.macros.set("\\cr", "\\\\\\relax"), e.gullet.beginGroup(); ; ) {
    t.push(e.parseExpression(!1, "\\\\")), e.gullet.endGroup(), e.gullet.beginGroup();
    var i = e.fetch().text;
    if (i === "&" || i === "\\\\")
      e.consume();
    else if (i === "\\end") {
      t[t.length - 1].length === 0 && t.pop();
      break;
    } else
      throw new We("Expected \\\\ or \\cr or \\end", e.nextToken);
  }
  for (var r = [], n = [r], o = 0; o < t.length; o++) {
    for (var s = t[o], a = g4(), l = 0; l < s.length; l++)
      if (!h4(s[l]))
        a.body.push(s[l]);
      else {
        r.push(a), l += 1;
        var c = J2(s[l]).text, u = new Array(2);
        if (u[0] = {
          type: "ordgroup",
          mode: "math",
          body: []
        }, u[1] = {
          type: "ordgroup",
          mode: "math",
          body: []
        }, !("=|.".indexOf(c) > -1))
          if ("<>AV".indexOf(c) > -1)
            for (var m = 0; m < 2; m++) {
              for (var g = !0, h = l + 1; h < s.length; h++) {
                if (d$(s[h], c)) {
                  g = !1, l = h;
                  break;
                }
                if (h4(s[h]))
                  throw new We("Missing a " + c + " character to complete a CD arrow.", s[h]);
                u[m].body.push(s[h]);
              }
              if (g)
                throw new We("Missing a " + c + " character to complete a CD arrow.", s[l]);
            }
          else
            throw new We('Expected one of "<>AV=|." after @', s[l]);
        var A = m$(c, u, e), y = {
          type: "styling",
          body: [A],
          mode: "math",
          style: "display"
          // CD is always displaystyle.
        };
        r.push(y), a = g4();
      }
    o % 2 === 0 ? r.push(a) : r.shift(), r = [], n.push(r);
  }
  e.gullet.endGroup(), e.gullet.endGroup();
  var E = new Array(n[0].length).fill({
    type: "align",
    align: "c",
    pregap: 0.25,
    // CD package sets \enskip between columns.
    postgap: 0.25
    // So pre and post each get half an \enskip, i.e. 0.25em.
  });
  return {
    type: "array",
    mode: "math",
    body: n,
    arraystretch: 1,
    addJot: !0,
    rowGaps: [null],
    cols: E,
    colSeparationType: "CD",
    hLinesBeforeRow: new Array(n.length + 1).fill([])
  };
}
rt({
  type: "cdlabel",
  names: ["\\\\cdleft", "\\\\cdright"],
  props: {
    numArgs: 1
  },
  handler(e, t) {
    var {
      parser: i,
      funcName: r
    } = e;
    return {
      type: "cdlabel",
      mode: i.mode,
      side: r.slice(4),
      label: t[0]
    };
  },
  htmlBuilder(e, t) {
    var i = t.havingStyle(t.style.sup()), r = ve.wrapFragment(ii(e.label, i, t), t);
    return r.classes.push("cd-label-" + e.side), r.style.bottom = He(0.8 - r.depth), r.height = 0, r.depth = 0, r;
  },
  mathmlBuilder(e, t) {
    var i = new Ge.MathNode("mrow", [Si(e.label, t)]);
    return i = new Ge.MathNode("mpadded", [i]), i.setAttribute("width", "0"), e.side === "left" && i.setAttribute("lspace", "-1width"), i.setAttribute("voffset", "0.7em"), i = new Ge.MathNode("mstyle", [i]), i.setAttribute("displaystyle", "false"), i.setAttribute("scriptlevel", "1"), i;
  }
});
rt({
  type: "cdlabelparent",
  names: ["\\\\cdparent"],
  props: {
    numArgs: 1
  },
  handler(e, t) {
    var {
      parser: i
    } = e;
    return {
      type: "cdlabelparent",
      mode: i.mode,
      fragment: t[0]
    };
  },
  htmlBuilder(e, t) {
    var i = ve.wrapFragment(ii(e.fragment, t), t);
    return i.classes.push("cd-vert-arrow"), i;
  },
  mathmlBuilder(e, t) {
    return new Ge.MathNode("mrow", [Si(e.fragment, t)]);
  }
});
rt({
  type: "textord",
  names: ["\\@char"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler(e, t) {
    for (var {
      parser: i
    } = e, r = Ft(t[0], "ordgroup"), n = r.body, o = "", s = 0; s < n.length; s++) {
      var a = Ft(n[s], "textord");
      o += a.text;
    }
    var l = parseInt(o), c;
    if (isNaN(l))
      throw new We("\\@char has non-numeric argument " + o);
    if (l < 0 || l >= 1114111)
      throw new We("\\@char with invalid code point " + o);
    return l <= 65535 ? c = String.fromCharCode(l) : (l -= 65536, c = String.fromCharCode((l >> 10) + 55296, (l & 1023) + 56320)), {
      type: "textord",
      mode: i.mode,
      text: c
    };
  }
});
var J7 = (e, t) => {
  var i = Ir(e.body, t.withColor(e.color), !1);
  return ve.makeFragment(i);
}, P7 = (e, t) => {
  var i = zn(e.body, t.withColor(e.color)), r = new Ge.MathNode("mstyle", i);
  return r.setAttribute("mathcolor", e.color), r;
};
rt({
  type: "color",
  names: ["\\textcolor"],
  props: {
    numArgs: 2,
    allowedInText: !0,
    argTypes: ["color", "original"]
  },
  handler(e, t) {
    var {
      parser: i
    } = e, r = Ft(t[0], "color-token").color, n = t[1];
    return {
      type: "color",
      mode: i.mode,
      color: r,
      body: dr(n)
    };
  },
  htmlBuilder: J7,
  mathmlBuilder: P7
});
rt({
  type: "color",
  names: ["\\color"],
  props: {
    numArgs: 1,
    allowedInText: !0,
    argTypes: ["color"]
  },
  handler(e, t) {
    var {
      parser: i,
      breakOnTokenText: r
    } = e, n = Ft(t[0], "color-token").color;
    i.gullet.macros.set("\\current@color", n);
    var o = i.parseExpression(!0, r);
    return {
      type: "color",
      mode: i.mode,
      color: n,
      body: o
    };
  },
  htmlBuilder: J7,
  mathmlBuilder: P7
});
rt({
  type: "cr",
  names: ["\\\\"],
  props: {
    numArgs: 0,
    numOptionalArgs: 0,
    allowedInText: !0
  },
  handler(e, t, i) {
    var {
      parser: r
    } = e, n = r.gullet.future().text === "[" ? r.parseSizeGroup(!0) : null, o = !r.settings.displayMode || !r.settings.useStrictBehavior("newLineInDisplayMode", "In LaTeX, \\\\ or \\newline does nothing in display mode");
    return {
      type: "cr",
      mode: r.mode,
      newLine: o,
      size: n && Ft(n, "size").value
    };
  },
  // The following builders are called only at the top level,
  // not within tabular/array environments.
  htmlBuilder(e, t) {
    var i = ve.makeSpan(["mspace"], [], t);
    return e.newLine && (i.classes.push("newline"), e.size && (i.style.marginTop = He(Hi(e.size, t)))), i;
  },
  mathmlBuilder(e, t) {
    var i = new Ge.MathNode("mspace");
    return e.newLine && (i.setAttribute("linebreak", "newline"), e.size && i.setAttribute("height", He(Hi(e.size, t)))), i;
  }
});
var Yb = {
  "\\global": "\\global",
  "\\long": "\\\\globallong",
  "\\\\globallong": "\\\\globallong",
  "\\def": "\\gdef",
  "\\gdef": "\\gdef",
  "\\edef": "\\xdef",
  "\\xdef": "\\xdef",
  "\\let": "\\\\globallet",
  "\\futurelet": "\\\\globalfuture"
}, z7 = (e) => {
  var t = e.text;
  if (/^(?:[\\{}$&#^_]|EOF)$/.test(t))
    throw new We("Expected a control sequence", e);
  return t;
}, h$ = (e) => {
  var t = e.gullet.popToken();
  return t.text === "=" && (t = e.gullet.popToken(), t.text === " " && (t = e.gullet.popToken())), t;
}, H7 = (e, t, i, r) => {
  var n = e.gullet.macros.get(i.text);
  n == null && (i.noexpand = !0, n = {
    tokens: [i],
    numArgs: 0,
    // reproduce the same behavior in expansion
    unexpandable: !e.gullet.isExpandable(i.text)
  }), e.gullet.macros.set(t, n, r);
};
rt({
  type: "internal",
  names: [
    "\\global",
    "\\long",
    "\\\\globallong"
    // can’t be entered directly
  ],
  props: {
    numArgs: 0,
    allowedInText: !0
  },
  handler(e) {
    var {
      parser: t,
      funcName: i
    } = e;
    t.consumeSpaces();
    var r = t.fetch();
    if (Yb[r.text])
      return (i === "\\global" || i === "\\\\globallong") && (r.text = Yb[r.text]), Ft(t.parseFunction(), "internal");
    throw new We("Invalid token after macro prefix", r);
  }
});
rt({
  type: "internal",
  names: ["\\def", "\\gdef", "\\edef", "\\xdef"],
  props: {
    numArgs: 0,
    allowedInText: !0,
    primitive: !0
  },
  handler(e) {
    var {
      parser: t,
      funcName: i
    } = e, r = t.gullet.popToken(), n = r.text;
    if (/^(?:[\\{}$&#^_]|EOF)$/.test(n))
      throw new We("Expected a control sequence", r);
    for (var o = 0, s, a = [[]]; t.gullet.future().text !== "{"; )
      if (r = t.gullet.popToken(), r.text === "#") {
        if (t.gullet.future().text === "{") {
          s = t.gullet.future(), a[o].push("{");
          break;
        }
        if (r = t.gullet.popToken(), !/^[1-9]$/.test(r.text))
          throw new We('Invalid argument number "' + r.text + '"');
        if (parseInt(r.text) !== o + 1)
          throw new We('Argument number "' + r.text + '" out of order');
        o++, a.push([]);
      } else {
        if (r.text === "EOF")
          throw new We("Expected a macro definition");
        a[o].push(r.text);
      }
    var {
      tokens: l
    } = t.gullet.consumeArg();
    return s && l.unshift(s), (i === "\\edef" || i === "\\xdef") && (l = t.gullet.expandTokens(l), l.reverse()), t.gullet.macros.set(n, {
      tokens: l,
      numArgs: o,
      delimiters: a
    }, i === Yb[i]), {
      type: "internal",
      mode: t.mode
    };
  }
});
rt({
  type: "internal",
  names: [
    "\\let",
    "\\\\globallet"
    // can’t be entered directly
  ],
  props: {
    numArgs: 0,
    allowedInText: !0,
    primitive: !0
  },
  handler(e) {
    var {
      parser: t,
      funcName: i
    } = e, r = z7(t.gullet.popToken());
    t.gullet.consumeSpaces();
    var n = h$(t);
    return H7(t, r, n, i === "\\\\globallet"), {
      type: "internal",
      mode: t.mode
    };
  }
});
rt({
  type: "internal",
  names: [
    "\\futurelet",
    "\\\\globalfuture"
    // can’t be entered directly
  ],
  props: {
    numArgs: 0,
    allowedInText: !0,
    primitive: !0
  },
  handler(e) {
    var {
      parser: t,
      funcName: i
    } = e, r = z7(t.gullet.popToken()), n = t.gullet.popToken(), o = t.gullet.popToken();
    return H7(t, r, o, i === "\\\\globalfuture"), t.gullet.pushToken(o), t.gullet.pushToken(n), {
      type: "internal",
      mode: t.mode
    };
  }
});
var em = function(t, i, r) {
  var n = Mi.math[t] && Mi.math[t].replace, o = U2(n || t, i, r);
  if (!o)
    throw new Error("Unsupported symbol " + t + " and font size " + i + ".");
  return o;
}, z2 = function(t, i, r, n) {
  var o = r.havingBaseStyle(i), s = ve.makeSpan(n.concat(o.sizingClasses(r)), [t], r), a = o.sizeMultiplier / r.sizeMultiplier;
  return s.height *= a, s.depth *= a, s.maxFontSize = o.sizeMultiplier, s;
}, X7 = function(t, i, r) {
  var n = i.havingBaseStyle(r), o = (1 - i.sizeMultiplier / n.sizeMultiplier) * i.fontMetrics().axisHeight;
  t.classes.push("delimcenter"), t.style.top = He(o), t.height -= o, t.depth += o;
}, p$ = function(t, i, r, n, o, s) {
  var a = ve.makeSymbol(t, "Main-Regular", o, n), l = z2(a, i, n, s);
  return r && X7(l, n, i), l;
}, f$ = function(t, i, r, n) {
  return ve.makeSymbol(t, "Size" + i + "-Regular", r, n);
}, _7 = function(t, i, r, n, o, s) {
  var a = f$(t, i, o, n), l = z2(ve.makeSpan(["delimsizing", "size" + i], [a], n), bt.TEXT, n, s);
  return r && X7(l, n, bt.TEXT), l;
}, tE = function(t, i, r) {
  var n;
  i === "Size1-Regular" ? n = "delim-size1" : n = "delim-size4";
  var o = ve.makeSpan(["delimsizinginner", n], [ve.makeSpan([], [ve.makeSymbol(t, i, r)])]);
  return {
    type: "elem",
    elem: o
  };
}, iE = function(t, i, r) {
  var n = Vs["Size4-Regular"][t.charCodeAt(0)] ? Vs["Size4-Regular"][t.charCodeAt(0)][4] : Vs["Size1-Regular"][t.charCodeAt(0)][4], o = new Vl("inner", C_(t, Math.round(1e3 * i))), s = new Ta([o], {
    width: He(n),
    height: He(i),
    // Override CSS rule `.katex svg { width: 100% }`
    style: "width:" + He(n),
    viewBox: "0 0 " + 1e3 * n + " " + Math.round(1e3 * i),
    preserveAspectRatio: "xMinYMin"
  }), a = ve.makeSvgSpan([], [s], r);
  return a.height = i, a.style.height = He(i), a.style.width = He(n), {
    type: "elem",
    elem: a
  };
}, Ub = 8e-3, cp = {
  type: "kern",
  size: -1 * Ub
}, A$ = ["|", "\\lvert", "\\rvert", "\\vert"], y$ = ["\\|", "\\lVert", "\\rVert", "\\Vert"], $7 = function(t, i, r, n, o, s) {
  var a, l, c, u, m = "", g = 0;
  a = c = u = t, l = null;
  var h = "Size1-Regular";
  t === "\\uparrow" ? c = u = "⏐" : t === "\\Uparrow" ? c = u = "‖" : t === "\\downarrow" ? a = c = "⏐" : t === "\\Downarrow" ? a = c = "‖" : t === "\\updownarrow" ? (a = "\\uparrow", c = "⏐", u = "\\downarrow") : t === "\\Updownarrow" ? (a = "\\Uparrow", c = "‖", u = "\\Downarrow") : Rt.contains(A$, t) ? (c = "∣", m = "vert", g = 333) : Rt.contains(y$, t) ? (c = "∥", m = "doublevert", g = 556) : t === "[" || t === "\\lbrack" ? (a = "⎡", c = "⎢", u = "⎣", h = "Size4-Regular", m = "lbrack", g = 667) : t === "]" || t === "\\rbrack" ? (a = "⎤", c = "⎥", u = "⎦", h = "Size4-Regular", m = "rbrack", g = 667) : t === "\\lfloor" || t === "⌊" ? (c = a = "⎢", u = "⎣", h = "Size4-Regular", m = "lfloor", g = 667) : t === "\\lceil" || t === "⌈" ? (a = "⎡", c = u = "⎢", h = "Size4-Regular", m = "lceil", g = 667) : t === "\\rfloor" || t === "⌋" ? (c = a = "⎥", u = "⎦", h = "Size4-Regular", m = "rfloor", g = 667) : t === "\\rceil" || t === "⌉" ? (a = "⎤", c = u = "⎥", h = "Size4-Regular", m = "rceil", g = 667) : t === "(" || t === "\\lparen" ? (a = "⎛", c = "⎜", u = "⎝", h = "Size4-Regular", m = "lparen", g = 875) : t === ")" || t === "\\rparen" ? (a = "⎞", c = "⎟", u = "⎠", h = "Size4-Regular", m = "rparen", g = 875) : t === "\\{" || t === "\\lbrace" ? (a = "⎧", l = "⎨", u = "⎩", c = "⎪", h = "Size4-Regular") : t === "\\}" || t === "\\rbrace" ? (a = "⎫", l = "⎬", u = "⎭", c = "⎪", h = "Size4-Regular") : t === "\\lgroup" || t === "⟮" ? (a = "⎧", u = "⎩", c = "⎪", h = "Size4-Regular") : t === "\\rgroup" || t === "⟯" ? (a = "⎫", u = "⎭", c = "⎪", h = "Size4-Regular") : t === "\\lmoustache" || t === "⎰" ? (a = "⎧", u = "⎭", c = "⎪", h = "Size4-Regular") : (t === "\\rmoustache" || t === "⎱") && (a = "⎫", u = "⎩", c = "⎪", h = "Size4-Regular");
  var A = em(a, h, o), y = A.height + A.depth, E = em(c, h, o), v = E.height + E.depth, C = em(u, h, o), x = C.height + C.depth, S = 0, R = 1;
  if (l !== null) {
    var w = em(l, h, o);
    S = w.height + w.depth, R = 2;
  }
  var T = y + x + S, N = Math.max(0, Math.ceil((i - T) / (R * v))), D = T + N * R * v, O = n.fontMetrics().axisHeight;
  r && (O *= n.sizeMultiplier);
  var F = D / 2 - O, Y = [];
  if (m.length > 0) {
    var P = D - y - x, z = Math.round(D * 1e3), W = x_(m, Math.round(P * 1e3)), H = new Vl(m, W), Q = (g / 1e3).toFixed(3) + "em", $ = (z / 1e3).toFixed(3) + "em", le = new Ta([H], {
      width: Q,
      height: $,
      viewBox: "0 0 " + g + " " + z
    }), he = ve.makeSvgSpan([], [le], n);
    he.height = z / 1e3, he.style.width = Q, he.style.height = $, Y.push({
      type: "elem",
      elem: he
    });
  } else {
    if (Y.push(tE(u, h, o)), Y.push(cp), l === null) {
      var oe = D - y - x + 2 * Ub;
      Y.push(iE(c, oe, n));
    } else {
      var ue = (D - y - x - S) / 2 + 2 * Ub;
      Y.push(iE(c, ue, n)), Y.push(cp), Y.push(tE(l, h, o)), Y.push(cp), Y.push(iE(c, ue, n));
    }
    Y.push(cp), Y.push(tE(a, h, o));
  }
  var Ae = n.havingBaseStyle(bt.TEXT), de = ve.makeVList({
    positionType: "bottom",
    positionData: F,
    children: Y
  }, Ae);
  return z2(ve.makeSpan(["delimsizing", "mult"], [de], Ae), bt.TEXT, n, s);
}, rE = 80, nE = 0.08, oE = function(t, i, r, n, o) {
  var s = b_(t, n, r), a = new Vl(t, s), l = new Ta([a], {
    // Note: 1000:1 ratio of viewBox to document em width.
    width: "400em",
    height: He(i),
    viewBox: "0 0 400000 " + r,
    preserveAspectRatio: "xMinYMin slice"
  });
  return ve.makeSvgSpan(["hide-tail"], [l], o);
}, E$ = function(t, i) {
  var r = i.havingBaseSizing(), n = rD("\\surd", t * r.sizeMultiplier, iD, r), o = r.sizeMultiplier, s = Math.max(0, i.minRuleThickness - i.fontMetrics().sqrtRuleThickness), a, l = 0, c = 0, u = 0, m;
  return n.type === "small" ? (u = 1e3 + 1e3 * s + rE, t < 1 ? o = 1 : t < 1.4 && (o = 0.7), l = (1 + s + nE) / o, c = (1 + s) / o, a = oE("sqrtMain", l, u, s, i), a.style.minWidth = "0.853em", m = 0.833 / o) : n.type === "large" ? (u = (1e3 + rE) * bm[n.size], c = (bm[n.size] + s) / o, l = (bm[n.size] + s + nE) / o, a = oE("sqrtSize" + n.size, l, u, s, i), a.style.minWidth = "1.02em", m = 1 / o) : (l = t + s + nE, c = t + s, u = Math.floor(1e3 * t + s) + rE, a = oE("sqrtTall", l, u, s, i), a.style.minWidth = "0.742em", m = 1.056), a.height = c, a.style.height = He(l), {
    span: a,
    advanceWidth: m,
    // Calculate the actual line width.
    // This actually should depend on the chosen font -- e.g. \boldmath
    // should use the thicker surd symbols from e.g. KaTeX_Main-Bold, and
    // have thicker rules.
    ruleWidth: (i.fontMetrics().sqrtRuleThickness + s) * o
  };
}, eD = ["(", "\\lparen", ")", "\\rparen", "[", "\\lbrack", "]", "\\rbrack", "\\{", "\\lbrace", "\\}", "\\rbrace", "\\lfloor", "\\rfloor", "⌊", "⌋", "\\lceil", "\\rceil", "⌈", "⌉", "\\surd"], v$ = ["\\uparrow", "\\downarrow", "\\updownarrow", "\\Uparrow", "\\Downarrow", "\\Updownarrow", "|", "\\|", "\\vert", "\\Vert", "\\lvert", "\\rvert", "\\lVert", "\\rVert", "\\lgroup", "\\rgroup", "⟮", "⟯", "\\lmoustache", "\\rmoustache", "⎰", "⎱"], tD = ["<", ">", "\\langle", "\\rangle", "/", "\\backslash", "\\lt", "\\gt"], bm = [0, 1.2, 1.8, 2.4, 3], b$ = function(t, i, r, n, o) {
  if (t === "<" || t === "\\lt" || t === "⟨" ? t = "\\langle" : (t === ">" || t === "\\gt" || t === "⟩") && (t = "\\rangle"), Rt.contains(eD, t) || Rt.contains(tD, t))
    return _7(t, i, !1, r, n, o);
  if (Rt.contains(v$, t))
    return $7(t, bm[i], !1, r, n, o);
  throw new We("Illegal delimiter: '" + t + "'");
}, C$ = [{
  type: "small",
  style: bt.SCRIPTSCRIPT
}, {
  type: "small",
  style: bt.SCRIPT
}, {
  type: "small",
  style: bt.TEXT
}, {
  type: "large",
  size: 1
}, {
  type: "large",
  size: 2
}, {
  type: "large",
  size: 3
}, {
  type: "large",
  size: 4
}], x$ = [{
  type: "small",
  style: bt.SCRIPTSCRIPT
}, {
  type: "small",
  style: bt.SCRIPT
}, {
  type: "small",
  style: bt.TEXT
}, {
  type: "stack"
}], iD = [{
  type: "small",
  style: bt.SCRIPTSCRIPT
}, {
  type: "small",
  style: bt.SCRIPT
}, {
  type: "small",
  style: bt.TEXT
}, {
  type: "large",
  size: 1
}, {
  type: "large",
  size: 2
}, {
  type: "large",
  size: 3
}, {
  type: "large",
  size: 4
}, {
  type: "stack"
}], I$ = function(t) {
  if (t.type === "small")
    return "Main-Regular";
  if (t.type === "large")
    return "Size" + t.size + "-Regular";
  if (t.type === "stack")
    return "Size4-Regular";
  throw new Error("Add support for delim type '" + t.type + "' here.");
}, rD = function(t, i, r, n) {
  for (var o = Math.min(2, 3 - n.style.size), s = o; s < r.length && r[s].type !== "stack"; s++) {
    var a = em(t, I$(r[s]), "math"), l = a.height + a.depth;
    if (r[s].type === "small") {
      var c = n.havingBaseStyle(r[s].style);
      l *= c.sizeMultiplier;
    }
    if (l > i)
      return r[s];
  }
  return r[r.length - 1];
}, nD = function(t, i, r, n, o, s) {
  t === "<" || t === "\\lt" || t === "⟨" ? t = "\\langle" : (t === ">" || t === "\\gt" || t === "⟩") && (t = "\\rangle");
  var a;
  Rt.contains(tD, t) ? a = C$ : Rt.contains(eD, t) ? a = iD : a = x$;
  var l = rD(t, i, a, n);
  return l.type === "small" ? p$(t, l.style, r, n, o, s) : l.type === "large" ? _7(t, l.size, r, n, o, s) : $7(t, i, r, n, o, s);
}, S$ = function(t, i, r, n, o, s) {
  var a = n.fontMetrics().axisHeight * n.sizeMultiplier, l = 901, c = 5 / n.fontMetrics().ptPerEm, u = Math.max(i - a, r + a), m = Math.max(
    // In real TeX, calculations are done using integral values which are
    // 65536 per pt, or 655360 per em. So, the division here truncates in
    // TeX but doesn't here, producing different results. If we wanted to
    // exactly match TeX's calculation, we could do
    //   Math.floor(655360 * maxDistFromAxis / 500) *
    //    delimiterFactor / 655360
    // (To see the difference, compare
    //    x^{x^{\left(\rule{0.1em}{0.68em}\right)}}
    // in TeX and KaTeX)
    u / 500 * l,
    2 * u - c
  );
  return nD(t, m, !0, n, o, s);
}, wa = {
  sqrtImage: E$,
  sizedDelim: b$,
  sizeToMaxHeight: bm,
  customSizedDelim: nD,
  leftRightDelim: S$
}, p4 = {
  "\\bigl": {
    mclass: "mopen",
    size: 1
  },
  "\\Bigl": {
    mclass: "mopen",
    size: 2
  },
  "\\biggl": {
    mclass: "mopen",
    size: 3
  },
  "\\Biggl": {
    mclass: "mopen",
    size: 4
  },
  "\\bigr": {
    mclass: "mclose",
    size: 1
  },
  "\\Bigr": {
    mclass: "mclose",
    size: 2
  },
  "\\biggr": {
    mclass: "mclose",
    size: 3
  },
  "\\Biggr": {
    mclass: "mclose",
    size: 4
  },
  "\\bigm": {
    mclass: "mrel",
    size: 1
  },
  "\\Bigm": {
    mclass: "mrel",
    size: 2
  },
  "\\biggm": {
    mclass: "mrel",
    size: 3
  },
  "\\Biggm": {
    mclass: "mrel",
    size: 4
  },
  "\\big": {
    mclass: "mord",
    size: 1
  },
  "\\Big": {
    mclass: "mord",
    size: 2
  },
  "\\bigg": {
    mclass: "mord",
    size: 3
  },
  "\\Bigg": {
    mclass: "mord",
    size: 4
  }
}, R$ = ["(", "\\lparen", ")", "\\rparen", "[", "\\lbrack", "]", "\\rbrack", "\\{", "\\lbrace", "\\}", "\\rbrace", "\\lfloor", "\\rfloor", "⌊", "⌋", "\\lceil", "\\rceil", "⌈", "⌉", "<", ">", "\\langle", "⟨", "\\rangle", "⟩", "\\lt", "\\gt", "\\lvert", "\\rvert", "\\lVert", "\\rVert", "\\lgroup", "\\rgroup", "⟮", "⟯", "\\lmoustache", "\\rmoustache", "⎰", "⎱", "/", "\\backslash", "|", "\\vert", "\\|", "\\Vert", "\\uparrow", "\\Uparrow", "\\downarrow", "\\Downarrow", "\\updownarrow", "\\Updownarrow", "."];
function Sf(e, t) {
  var i = xf(e);
  if (i && Rt.contains(R$, i.text))
    return i;
  throw i ? new We("Invalid delimiter '" + i.text + "' after '" + t.funcName + "'", e) : new We("Invalid delimiter type '" + e.type + "'", e);
}
rt({
  type: "delimsizing",
  names: ["\\bigl", "\\Bigl", "\\biggl", "\\Biggl", "\\bigr", "\\Bigr", "\\biggr", "\\Biggr", "\\bigm", "\\Bigm", "\\biggm", "\\Biggm", "\\big", "\\Big", "\\bigg", "\\Bigg"],
  props: {
    numArgs: 1,
    argTypes: ["primitive"]
  },
  handler: (e, t) => {
    var i = Sf(t[0], e);
    return {
      type: "delimsizing",
      mode: e.parser.mode,
      size: p4[e.funcName].size,
      mclass: p4[e.funcName].mclass,
      delim: i.text
    };
  },
  htmlBuilder: (e, t) => e.delim === "." ? ve.makeSpan([e.mclass]) : wa.sizedDelim(e.delim, e.size, t, e.mode, [e.mclass]),
  mathmlBuilder: (e) => {
    var t = [];
    e.delim !== "." && t.push(Jo(e.delim, e.mode));
    var i = new Ge.MathNode("mo", t);
    e.mclass === "mopen" || e.mclass === "mclose" ? i.setAttribute("fence", "true") : i.setAttribute("fence", "false"), i.setAttribute("stretchy", "true");
    var r = He(wa.sizeToMaxHeight[e.size]);
    return i.setAttribute("minsize", r), i.setAttribute("maxsize", r), i;
  }
});
function f4(e) {
  if (!e.body)
    throw new Error("Bug: The leftright ParseNode wasn't fully parsed.");
}
rt({
  type: "leftright-right",
  names: ["\\right"],
  props: {
    numArgs: 1,
    primitive: !0
  },
  handler: (e, t) => {
    var i = e.parser.gullet.macros.get("\\current@color");
    if (i && typeof i != "string")
      throw new We("\\current@color set to non-string in \\right");
    return {
      type: "leftright-right",
      mode: e.parser.mode,
      delim: Sf(t[0], e).text,
      color: i
      // undefined if not set via \color
    };
  }
});
rt({
  type: "leftright",
  names: ["\\left"],
  props: {
    numArgs: 1,
    primitive: !0
  },
  handler: (e, t) => {
    var i = Sf(t[0], e), r = e.parser;
    ++r.leftrightDepth;
    var n = r.parseExpression(!1);
    --r.leftrightDepth, r.expect("\\right", !1);
    var o = Ft(r.parseFunction(), "leftright-right");
    return {
      type: "leftright",
      mode: r.mode,
      body: n,
      left: i.text,
      right: o.delim,
      rightColor: o.color
    };
  },
  htmlBuilder: (e, t) => {
    f4(e);
    for (var i = Ir(e.body, t, !0, ["mopen", "mclose"]), r = 0, n = 0, o = !1, s = 0; s < i.length; s++)
      i[s].isMiddle ? o = !0 : (r = Math.max(i[s].height, r), n = Math.max(i[s].depth, n));
    r *= t.sizeMultiplier, n *= t.sizeMultiplier;
    var a;
    if (e.left === "." ? a = Zm(t, ["mopen"]) : a = wa.leftRightDelim(e.left, r, n, t, e.mode, ["mopen"]), i.unshift(a), o)
      for (var l = 1; l < i.length; l++) {
        var c = i[l], u = c.isMiddle;
        u && (i[l] = wa.leftRightDelim(u.delim, r, n, u.options, e.mode, []));
      }
    var m;
    if (e.right === ".")
      m = Zm(t, ["mclose"]);
    else {
      var g = e.rightColor ? t.withColor(e.rightColor) : t;
      m = wa.leftRightDelim(e.right, r, n, g, e.mode, ["mclose"]);
    }
    return i.push(m), ve.makeSpan(["minner"], i, t);
  },
  mathmlBuilder: (e, t) => {
    f4(e);
    var i = zn(e.body, t);
    if (e.left !== ".") {
      var r = new Ge.MathNode("mo", [Jo(e.left, e.mode)]);
      r.setAttribute("fence", "true"), i.unshift(r);
    }
    if (e.right !== ".") {
      var n = new Ge.MathNode("mo", [Jo(e.right, e.mode)]);
      n.setAttribute("fence", "true"), e.rightColor && n.setAttribute("mathcolor", e.rightColor), i.push(n);
    }
    return W2(i);
  }
});
rt({
  type: "middle",
  names: ["\\middle"],
  props: {
    numArgs: 1,
    primitive: !0
  },
  handler: (e, t) => {
    var i = Sf(t[0], e);
    if (!e.parser.leftrightDepth)
      throw new We("\\middle without preceding \\left", i);
    return {
      type: "middle",
      mode: e.parser.mode,
      delim: i.text
    };
  },
  htmlBuilder: (e, t) => {
    var i;
    if (e.delim === ".")
      i = Zm(t, []);
    else {
      i = wa.sizedDelim(e.delim, 1, t, e.mode, []);
      var r = {
        delim: e.delim,
        options: t
      };
      i.isMiddle = r;
    }
    return i;
  },
  mathmlBuilder: (e, t) => {
    var i = e.delim === "\\vert" || e.delim === "|" ? Jo("|", "text") : Jo(e.delim, e.mode), r = new Ge.MathNode("mo", [i]);
    return r.setAttribute("fence", "true"), r.setAttribute("lspace", "0.05em"), r.setAttribute("rspace", "0.05em"), r;
  }
});
var H2 = (e, t) => {
  var i = ve.wrapFragment(ii(e.body, t), t), r = e.label.slice(1), n = t.sizeMultiplier, o, s = 0, a = Rt.isCharacterBox(e.body);
  if (r === "sout")
    o = ve.makeSpan(["stretchy", "sout"]), o.height = t.fontMetrics().defaultRuleThickness / n, s = -0.5 * t.fontMetrics().xHeight;
  else if (r === "phase") {
    var l = Hi({
      number: 0.6,
      unit: "pt"
    }, t), c = Hi({
      number: 0.35,
      unit: "ex"
    }, t), u = t.havingBaseSizing();
    n = n / u.sizeMultiplier;
    var m = i.height + i.depth + l + c;
    i.style.paddingLeft = He(m / 2 + l);
    var g = Math.floor(1e3 * m * n), h = E_(g), A = new Ta([new Vl("phase", h)], {
      width: "400em",
      height: He(g / 1e3),
      viewBox: "0 0 400000 " + g,
      preserveAspectRatio: "xMinYMin slice"
    });
    o = ve.makeSvgSpan(["hide-tail"], [A], t), o.style.height = He(m), s = i.depth + l + c;
  } else {
    /cancel/.test(r) ? a || i.classes.push("cancel-pad") : r === "angl" ? i.classes.push("anglpad") : i.classes.push("boxpad");
    var y = 0, E = 0, v = 0;
    /box/.test(r) ? (v = Math.max(
      t.fontMetrics().fboxrule,
      // default
      t.minRuleThickness
      // User override.
    ), y = t.fontMetrics().fboxsep + (r === "colorbox" ? 0 : v), E = y) : r === "angl" ? (v = Math.max(t.fontMetrics().defaultRuleThickness, t.minRuleThickness), y = 4 * v, E = Math.max(0, 0.25 - i.depth)) : (y = a ? 0.2 : 0, E = y), o = Da.encloseSpan(i, r, y, E, t), /fbox|boxed|fcolorbox/.test(r) ? (o.style.borderStyle = "solid", o.style.borderWidth = He(v)) : r === "angl" && v !== 0.049 && (o.style.borderTopWidth = He(v), o.style.borderRightWidth = He(v)), s = i.depth + E, e.backgroundColor && (o.style.backgroundColor = e.backgroundColor, e.borderColor && (o.style.borderColor = e.borderColor));
  }
  var C;
  if (e.backgroundColor)
    C = ve.makeVList({
      positionType: "individualShift",
      children: [
        // Put the color background behind inner;
        {
          type: "elem",
          elem: o,
          shift: s
        },
        {
          type: "elem",
          elem: i,
          shift: 0
        }
      ]
    }, t);
  else {
    var x = /cancel|phase/.test(r) ? ["svg-align"] : [];
    C = ve.makeVList({
      positionType: "individualShift",
      children: [
        // Write the \cancel stroke on top of inner.
        {
          type: "elem",
          elem: i,
          shift: 0
        },
        {
          type: "elem",
          elem: o,
          shift: s,
          wrapperClasses: x
        }
      ]
    }, t);
  }
  return /cancel/.test(r) && (C.height = i.height, C.depth = i.depth), /cancel/.test(r) && !a ? ve.makeSpan(["mord", "cancel-lap"], [C], t) : ve.makeSpan(["mord"], [C], t);
}, X2 = (e, t) => {
  var i = 0, r = new Ge.MathNode(e.label.indexOf("colorbox") > -1 ? "mpadded" : "menclose", [Si(e.body, t)]);
  switch (e.label) {
    case "\\cancel":
      r.setAttribute("notation", "updiagonalstrike");
      break;
    case "\\bcancel":
      r.setAttribute("notation", "downdiagonalstrike");
      break;
    case "\\phase":
      r.setAttribute("notation", "phasorangle");
      break;
    case "\\sout":
      r.setAttribute("notation", "horizontalstrike");
      break;
    case "\\fbox":
      r.setAttribute("notation", "box");
      break;
    case "\\angl":
      r.setAttribute("notation", "actuarial");
      break;
    case "\\fcolorbox":
    case "\\colorbox":
      if (i = t.fontMetrics().fboxsep * t.fontMetrics().ptPerEm, r.setAttribute("width", "+" + 2 * i + "pt"), r.setAttribute("height", "+" + 2 * i + "pt"), r.setAttribute("lspace", i + "pt"), r.setAttribute("voffset", i + "pt"), e.label === "\\fcolorbox") {
        var n = Math.max(
          t.fontMetrics().fboxrule,
          // default
          t.minRuleThickness
          // user override
        );
        r.setAttribute("style", "border: " + n + "em solid " + String(e.borderColor));
      }
      break;
    case "\\xcancel":
      r.setAttribute("notation", "updiagonalstrike downdiagonalstrike");
      break;
  }
  return e.backgroundColor && r.setAttribute("mathbackground", e.backgroundColor), r;
};
rt({
  type: "enclose",
  names: ["\\colorbox"],
  props: {
    numArgs: 2,
    allowedInText: !0,
    argTypes: ["color", "text"]
  },
  handler(e, t, i) {
    var {
      parser: r,
      funcName: n
    } = e, o = Ft(t[0], "color-token").color, s = t[1];
    return {
      type: "enclose",
      mode: r.mode,
      label: n,
      backgroundColor: o,
      body: s
    };
  },
  htmlBuilder: H2,
  mathmlBuilder: X2
});
rt({
  type: "enclose",
  names: ["\\fcolorbox"],
  props: {
    numArgs: 3,
    allowedInText: !0,
    argTypes: ["color", "color", "text"]
  },
  handler(e, t, i) {
    var {
      parser: r,
      funcName: n
    } = e, o = Ft(t[0], "color-token").color, s = Ft(t[1], "color-token").color, a = t[2];
    return {
      type: "enclose",
      mode: r.mode,
      label: n,
      backgroundColor: s,
      borderColor: o,
      body: a
    };
  },
  htmlBuilder: H2,
  mathmlBuilder: X2
});
rt({
  type: "enclose",
  names: ["\\fbox"],
  props: {
    numArgs: 1,
    argTypes: ["hbox"],
    allowedInText: !0
  },
  handler(e, t) {
    var {
      parser: i
    } = e;
    return {
      type: "enclose",
      mode: i.mode,
      label: "\\fbox",
      body: t[0]
    };
  }
});
rt({
  type: "enclose",
  names: ["\\cancel", "\\bcancel", "\\xcancel", "\\sout", "\\phase"],
  props: {
    numArgs: 1
  },
  handler(e, t) {
    var {
      parser: i,
      funcName: r
    } = e, n = t[0];
    return {
      type: "enclose",
      mode: i.mode,
      label: r,
      body: n
    };
  },
  htmlBuilder: H2,
  mathmlBuilder: X2
});
rt({
  type: "enclose",
  names: ["\\angl"],
  props: {
    numArgs: 1,
    argTypes: ["hbox"],
    allowedInText: !1
  },
  handler(e, t) {
    var {
      parser: i
    } = e;
    return {
      type: "enclose",
      mode: i.mode,
      label: "\\angl",
      body: t[0]
    };
  }
});
var oD = {};
function zs(e) {
  for (var {
    type: t,
    names: i,
    props: r,
    handler: n,
    htmlBuilder: o,
    mathmlBuilder: s
  } = e, a = {
    type: t,
    numArgs: r.numArgs || 0,
    allowedInText: !1,
    numOptionalArgs: 0,
    handler: n
  }, l = 0; l < i.length; ++l)
    oD[i[l]] = a;
  o && (C1[t] = o), s && (x1[t] = s);
}
var sD = {};
function G(e, t) {
  sD[e] = t;
}
function A4(e) {
  var t = [];
  e.consumeSpaces();
  var i = e.fetch().text;
  for (i === "\\relax" && (e.consume(), e.consumeSpaces(), i = e.fetch().text); i === "\\hline" || i === "\\hdashline"; )
    e.consume(), t.push(i === "\\hdashline"), e.consumeSpaces(), i = e.fetch().text;
  return t;
}
var Rf = (e) => {
  var t = e.parser.settings;
  if (!t.displayMode)
    throw new We("{" + e.envName + "} can be used only in display mode.");
};
function _2(e) {
  if (e.indexOf("ed") === -1)
    return e.indexOf("*") === -1;
}
function Ul(e, t, i) {
  var {
    hskipBeforeAndAfter: r,
    addJot: n,
    cols: o,
    arraystretch: s,
    colSeparationType: a,
    autoTag: l,
    singleRow: c,
    emptySingleRow: u,
    maxNumCols: m,
    leqno: g
  } = t;
  if (e.gullet.beginGroup(), c || e.gullet.macros.set("\\cr", "\\\\\\relax"), !s) {
    var h = e.gullet.expandMacroAsText("\\arraystretch");
    if (h == null)
      s = 1;
    else if (s = parseFloat(h), !s || s < 0)
      throw new We("Invalid \\arraystretch: " + h);
  }
  e.gullet.beginGroup();
  var A = [], y = [A], E = [], v = [], C = l != null ? [] : void 0;
  function x() {
    l && e.gullet.macros.set("\\@eqnsw", "1", !0);
  }
  function S() {
    C && (e.gullet.macros.get("\\df@tag") ? (C.push(e.subparse([new js("\\df@tag")])), e.gullet.macros.set("\\df@tag", void 0, !0)) : C.push(!!l && e.gullet.macros.get("\\@eqnsw") === "1"));
  }
  for (x(), v.push(A4(e)); ; ) {
    var R = e.parseExpression(!1, c ? "\\end" : "\\\\");
    e.gullet.endGroup(), e.gullet.beginGroup(), R = {
      type: "ordgroup",
      mode: e.mode,
      body: R
    }, i && (R = {
      type: "styling",
      mode: e.mode,
      style: i,
      body: [R]
    }), A.push(R);
    var w = e.fetch().text;
    if (w === "&") {
      if (m && A.length === m) {
        if (c || a)
          throw new We("Too many tab characters: &", e.nextToken);
        e.settings.reportNonstrict("textEnv", "Too few columns specified in the {array} column argument.");
      }
      e.consume();
    } else if (w === "\\end") {
      S(), A.length === 1 && R.type === "styling" && R.body[0].body.length === 0 && (y.length > 1 || !u) && y.pop(), v.length < y.length + 1 && v.push([]);
      break;
    } else if (w === "\\\\") {
      e.consume();
      var T = void 0;
      e.gullet.future().text !== " " && (T = e.parseSizeGroup(!0)), E.push(T ? T.value : null), S(), v.push(A4(e)), A = [], y.push(A), x();
    } else
      throw new We("Expected & or \\\\ or \\cr or \\end", e.nextToken);
  }
  return e.gullet.endGroup(), e.gullet.endGroup(), {
    type: "array",
    mode: e.mode,
    addJot: n,
    arraystretch: s,
    body: y,
    cols: o,
    rowGaps: E,
    hskipBeforeAndAfter: r,
    hLinesBeforeRow: v,
    colSeparationType: a,
    tags: C,
    leqno: g
  };
}
function $2(e) {
  return e.slice(0, 1) === "d" ? "display" : "text";
}
var Hs = function(t, i) {
  var r, n, o = t.body.length, s = t.hLinesBeforeRow, a = 0, l = new Array(o), c = [], u = Math.max(
    // From LaTeX \showthe\arrayrulewidth. Equals 0.04 em.
    i.fontMetrics().arrayRuleWidth,
    i.minRuleThickness
    // User override.
  ), m = 1 / i.fontMetrics().ptPerEm, g = 5 * m;
  if (t.colSeparationType && t.colSeparationType === "small") {
    var h = i.havingStyle(bt.SCRIPT).sizeMultiplier;
    g = 0.2778 * (h / i.sizeMultiplier);
  }
  var A = t.colSeparationType === "CD" ? Hi({
    number: 3,
    unit: "ex"
  }, i) : 12 * m, y = 3 * m, E = t.arraystretch * A, v = 0.7 * E, C = 0.3 * E, x = 0;
  function S(qt) {
    for (var Ht = 0; Ht < qt.length; ++Ht)
      Ht > 0 && (x += 0.25), c.push({
        pos: x,
        isDashed: qt[Ht]
      });
  }
  for (S(s[0]), r = 0; r < t.body.length; ++r) {
    var R = t.body[r], w = v, T = C;
    a < R.length && (a = R.length);
    var N = new Array(R.length);
    for (n = 0; n < R.length; ++n) {
      var D = ii(R[n], i);
      T < D.depth && (T = D.depth), w < D.height && (w = D.height), N[n] = D;
    }
    var O = t.rowGaps[r], F = 0;
    O && (F = Hi(O, i), F > 0 && (F += C, T < F && (T = F), F = 0)), t.addJot && (T += y), N.height = w, N.depth = T, x += w, N.pos = x, x += T + F, l[r] = N, S(s[r + 1]);
  }
  var Y = x / 2 + i.fontMetrics().axisHeight, P = t.cols || [], z = [], W, H, Q = [];
  if (t.tags && t.tags.some((qt) => qt))
    for (r = 0; r < o; ++r) {
      var $ = l[r], le = $.pos - Y, he = t.tags[r], oe = void 0;
      he === !0 ? oe = ve.makeSpan(["eqn-num"], [], i) : he === !1 ? oe = ve.makeSpan([], [], i) : oe = ve.makeSpan([], Ir(he, i, !0), i), oe.depth = $.depth, oe.height = $.height, Q.push({
        type: "elem",
        elem: oe,
        shift: le
      });
    }
  for (
    n = 0, H = 0;
    // Continue while either there are more columns or more column
    // descriptions, so trailing separators don't get lost.
    n < a || H < P.length;
    ++n, ++H
  ) {
    for (var ue = P[H] || {}, Ae = !0; ue.type === "separator"; ) {
      if (Ae || (W = ve.makeSpan(["arraycolsep"], []), W.style.width = He(i.fontMetrics().doubleRuleSep), z.push(W)), ue.separator === "|" || ue.separator === ":") {
        var de = ue.separator === "|" ? "solid" : "dashed", fe = ve.makeSpan(["vertical-separator"], [], i);
        fe.style.height = He(x), fe.style.borderRightWidth = He(u), fe.style.borderRightStyle = de, fe.style.margin = "0 " + He(-u / 2);
        var Re = x - Y;
        Re && (fe.style.verticalAlign = He(-Re)), z.push(fe);
      } else
        throw new We("Invalid separator type: " + ue.separator);
      H++, ue = P[H] || {}, Ae = !1;
    }
    if (!(n >= a)) {
      var qe = void 0;
      (n > 0 || t.hskipBeforeAndAfter) && (qe = Rt.deflt(ue.pregap, g), qe !== 0 && (W = ve.makeSpan(["arraycolsep"], []), W.style.width = He(qe), z.push(W)));
      var Oe = [];
      for (r = 0; r < o; ++r) {
        var Xe = l[r], Qe = Xe[n];
        if (Qe) {
          var Pe = Xe.pos - Y;
          Qe.depth = Xe.depth, Qe.height = Xe.height, Oe.push({
            type: "elem",
            elem: Qe,
            shift: Pe
          });
        }
      }
      Oe = ve.makeVList({
        positionType: "individualShift",
        children: Oe
      }, i), Oe = ve.makeSpan(["col-align-" + (ue.align || "c")], [Oe]), z.push(Oe), (n < a - 1 || t.hskipBeforeAndAfter) && (qe = Rt.deflt(ue.postgap, g), qe !== 0 && (W = ve.makeSpan(["arraycolsep"], []), W.style.width = He(qe), z.push(W)));
    }
  }
  if (l = ve.makeSpan(["mtable"], z), c.length > 0) {
    for (var et = ve.makeLineSpan("hline", i, u), At = ve.makeLineSpan("hdashline", i, u), Et = [{
      type: "elem",
      elem: l,
      shift: 0
    }]; c.length > 0; ) {
      var oi = c.pop(), Ai = oi.pos - Y;
      oi.isDashed ? Et.push({
        type: "elem",
        elem: At,
        shift: Ai
      }) : Et.push({
        type: "elem",
        elem: et,
        shift: Ai
      });
    }
    l = ve.makeVList({
      positionType: "individualShift",
      children: Et
    }, i);
  }
  if (Q.length === 0)
    return ve.makeSpan(["mord"], [l], i);
  var ut = ve.makeVList({
    positionType: "individualShift",
    children: Q
  }, i);
  return ut = ve.makeSpan(["tag"], [ut], i), ve.makeFragment([l, ut]);
}, k$ = {
  c: "center ",
  l: "left ",
  r: "right "
}, Xs = function(t, i) {
  for (var r = [], n = new Ge.MathNode("mtd", [], ["mtr-glue"]), o = new Ge.MathNode("mtd", [], ["mml-eqn-num"]), s = 0; s < t.body.length; s++) {
    for (var a = t.body[s], l = [], c = 0; c < a.length; c++)
      l.push(new Ge.MathNode("mtd", [Si(a[c], i)]));
    t.tags && t.tags[s] && (l.unshift(n), l.push(n), t.leqno ? l.unshift(o) : l.push(o)), r.push(new Ge.MathNode("mtr", l));
  }
  var u = new Ge.MathNode("mtable", r), m = t.arraystretch === 0.5 ? 0.1 : 0.16 + t.arraystretch - 1 + (t.addJot ? 0.09 : 0);
  u.setAttribute("rowspacing", He(m));
  var g = "", h = "";
  if (t.cols && t.cols.length > 0) {
    var A = t.cols, y = "", E = !1, v = 0, C = A.length;
    A[0].type === "separator" && (g += "top ", v = 1), A[A.length - 1].type === "separator" && (g += "bottom ", C -= 1);
    for (var x = v; x < C; x++)
      A[x].type === "align" ? (h += k$[A[x].align], E && (y += "none "), E = !0) : A[x].type === "separator" && E && (y += A[x].separator === "|" ? "solid " : "dashed ", E = !1);
    u.setAttribute("columnalign", h.trim()), /[sd]/.test(y) && u.setAttribute("columnlines", y.trim());
  }
  if (t.colSeparationType === "align") {
    for (var S = t.cols || [], R = "", w = 1; w < S.length; w++)
      R += w % 2 ? "0em " : "1em ";
    u.setAttribute("columnspacing", R.trim());
  } else
    t.colSeparationType === "alignat" || t.colSeparationType === "gather" ? u.setAttribute("columnspacing", "0em") : t.colSeparationType === "small" ? u.setAttribute("columnspacing", "0.2778em") : t.colSeparationType === "CD" ? u.setAttribute("columnspacing", "0.5em") : u.setAttribute("columnspacing", "1em");
  var T = "", N = t.hLinesBeforeRow;
  g += N[0].length > 0 ? "left " : "", g += N[N.length - 1].length > 0 ? "right " : "";
  for (var D = 1; D < N.length - 1; D++)
    T += N[D].length === 0 ? "none " : N[D][0] ? "dashed " : "solid ";
  return /[sd]/.test(T) && u.setAttribute("rowlines", T.trim()), g !== "" && (u = new Ge.MathNode("menclose", [u]), u.setAttribute("notation", g.trim())), t.arraystretch && t.arraystretch < 1 && (u = new Ge.MathNode("mstyle", [u]), u.setAttribute("scriptlevel", "1")), u;
}, aD = function(t, i) {
  t.envName.indexOf("ed") === -1 && Rf(t);
  var r = [], n = t.envName.indexOf("at") > -1 ? "alignat" : "align", o = t.envName === "split", s = Ul(t.parser, {
    cols: r,
    addJot: !0,
    autoTag: o ? void 0 : _2(t.envName),
    emptySingleRow: !0,
    colSeparationType: n,
    maxNumCols: o ? 2 : void 0,
    leqno: t.parser.settings.leqno
  }, "display"), a, l = 0, c = {
    type: "ordgroup",
    mode: t.mode,
    body: []
  };
  if (i[0] && i[0].type === "ordgroup") {
    for (var u = "", m = 0; m < i[0].body.length; m++) {
      var g = Ft(i[0].body[m], "textord");
      u += g.text;
    }
    a = Number(u), l = a * 2;
  }
  var h = !l;
  s.body.forEach(function(v) {
    for (var C = 1; C < v.length; C += 2) {
      var x = Ft(v[C], "styling"), S = Ft(x.body[0], "ordgroup");
      S.body.unshift(c);
    }
    if (h)
      l < v.length && (l = v.length);
    else {
      var R = v.length / 2;
      if (a < R)
        throw new We("Too many math in a row: " + ("expected " + a + ", but got " + R), v[0]);
    }
  });
  for (var A = 0; A < l; ++A) {
    var y = "r", E = 0;
    A % 2 === 1 ? y = "l" : A > 0 && h && (E = 1), r[A] = {
      type: "align",
      align: y,
      pregap: E,
      postgap: 0
    };
  }
  return s.colSeparationType = h ? "align" : "alignat", s;
};
zs({
  type: "array",
  names: ["array", "darray"],
  props: {
    numArgs: 1
  },
  handler(e, t) {
    var i = xf(t[0]), r = i ? [t[0]] : Ft(t[0], "ordgroup").body, n = r.map(function(s) {
      var a = J2(s), l = a.text;
      if ("lcr".indexOf(l) !== -1)
        return {
          type: "align",
          align: l
        };
      if (l === "|")
        return {
          type: "separator",
          separator: "|"
        };
      if (l === ":")
        return {
          type: "separator",
          separator: ":"
        };
      throw new We("Unknown column alignment: " + l, s);
    }), o = {
      cols: n,
      hskipBeforeAndAfter: !0,
      // \@preamble in lttab.dtx
      maxNumCols: n.length
    };
    return Ul(e.parser, o, $2(e.envName));
  },
  htmlBuilder: Hs,
  mathmlBuilder: Xs
});
zs({
  type: "array",
  names: ["matrix", "pmatrix", "bmatrix", "Bmatrix", "vmatrix", "Vmatrix", "matrix*", "pmatrix*", "bmatrix*", "Bmatrix*", "vmatrix*", "Vmatrix*"],
  props: {
    numArgs: 0
  },
  handler(e) {
    var t = {
      matrix: null,
      pmatrix: ["(", ")"],
      bmatrix: ["[", "]"],
      Bmatrix: ["\\{", "\\}"],
      vmatrix: ["|", "|"],
      Vmatrix: ["\\Vert", "\\Vert"]
    }[e.envName.replace("*", "")], i = "c", r = {
      hskipBeforeAndAfter: !1,
      cols: [{
        type: "align",
        align: i
      }]
    };
    if (e.envName.charAt(e.envName.length - 1) === "*") {
      var n = e.parser;
      if (n.consumeSpaces(), n.fetch().text === "[") {
        if (n.consume(), n.consumeSpaces(), i = n.fetch().text, "lcr".indexOf(i) === -1)
          throw new We("Expected l or c or r", n.nextToken);
        n.consume(), n.consumeSpaces(), n.expect("]"), n.consume(), r.cols = [{
          type: "align",
          align: i
        }];
      }
    }
    var o = Ul(e.parser, r, $2(e.envName)), s = Math.max(0, ...o.body.map((a) => a.length));
    return o.cols = new Array(s).fill({
      type: "align",
      align: i
    }), t ? {
      type: "leftright",
      mode: e.mode,
      body: [o],
      left: t[0],
      right: t[1],
      rightColor: void 0
      // \right uninfluenced by \color in array
    } : o;
  },
  htmlBuilder: Hs,
  mathmlBuilder: Xs
});
zs({
  type: "array",
  names: ["smallmatrix"],
  props: {
    numArgs: 0
  },
  handler(e) {
    var t = {
      arraystretch: 0.5
    }, i = Ul(e.parser, t, "script");
    return i.colSeparationType = "small", i;
  },
  htmlBuilder: Hs,
  mathmlBuilder: Xs
});
zs({
  type: "array",
  names: ["subarray"],
  props: {
    numArgs: 1
  },
  handler(e, t) {
    var i = xf(t[0]), r = i ? [t[0]] : Ft(t[0], "ordgroup").body, n = r.map(function(s) {
      var a = J2(s), l = a.text;
      if ("lc".indexOf(l) !== -1)
        return {
          type: "align",
          align: l
        };
      throw new We("Unknown column alignment: " + l, s);
    });
    if (n.length > 1)
      throw new We("{subarray} can contain only one column");
    var o = {
      cols: n,
      hskipBeforeAndAfter: !1,
      arraystretch: 0.5
    };
    if (o = Ul(e.parser, o, "script"), o.body.length > 0 && o.body[0].length > 1)
      throw new We("{subarray} can contain only one column");
    return o;
  },
  htmlBuilder: Hs,
  mathmlBuilder: Xs
});
zs({
  type: "array",
  names: ["cases", "dcases", "rcases", "drcases"],
  props: {
    numArgs: 0
  },
  handler(e) {
    var t = {
      arraystretch: 1.2,
      cols: [{
        type: "align",
        align: "l",
        pregap: 0,
        // TODO(kevinb) get the current style.
        // For now we use the metrics for TEXT style which is what we were
        // doing before.  Before attempting to get the current style we
        // should look at TeX's behavior especially for \over and matrices.
        postgap: 1
        /* 1em quad */
      }, {
        type: "align",
        align: "l",
        pregap: 0,
        postgap: 0
      }]
    }, i = Ul(e.parser, t, $2(e.envName));
    return {
      type: "leftright",
      mode: e.mode,
      body: [i],
      left: e.envName.indexOf("r") > -1 ? "." : "\\{",
      right: e.envName.indexOf("r") > -1 ? "\\}" : ".",
      rightColor: void 0
    };
  },
  htmlBuilder: Hs,
  mathmlBuilder: Xs
});
zs({
  type: "array",
  names: ["align", "align*", "aligned", "split"],
  props: {
    numArgs: 0
  },
  handler: aD,
  htmlBuilder: Hs,
  mathmlBuilder: Xs
});
zs({
  type: "array",
  names: ["gathered", "gather", "gather*"],
  props: {
    numArgs: 0
  },
  handler(e) {
    Rt.contains(["gather", "gather*"], e.envName) && Rf(e);
    var t = {
      cols: [{
        type: "align",
        align: "c"
      }],
      addJot: !0,
      colSeparationType: "gather",
      autoTag: _2(e.envName),
      emptySingleRow: !0,
      leqno: e.parser.settings.leqno
    };
    return Ul(e.parser, t, "display");
  },
  htmlBuilder: Hs,
  mathmlBuilder: Xs
});
zs({
  type: "array",
  names: ["alignat", "alignat*", "alignedat"],
  props: {
    numArgs: 1
  },
  handler: aD,
  htmlBuilder: Hs,
  mathmlBuilder: Xs
});
zs({
  type: "array",
  names: ["equation", "equation*"],
  props: {
    numArgs: 0
  },
  handler(e) {
    Rf(e);
    var t = {
      autoTag: _2(e.envName),
      emptySingleRow: !0,
      singleRow: !0,
      maxNumCols: 1,
      leqno: e.parser.settings.leqno
    };
    return Ul(e.parser, t, "display");
  },
  htmlBuilder: Hs,
  mathmlBuilder: Xs
});
zs({
  type: "array",
  names: ["CD"],
  props: {
    numArgs: 0
  },
  handler(e) {
    return Rf(e), g$(e.parser);
  },
  htmlBuilder: Hs,
  mathmlBuilder: Xs
});
G("\\nonumber", "\\gdef\\@eqnsw{0}");
G("\\notag", "\\nonumber");
rt({
  type: "text",
  // Doesn't matter what this is.
  names: ["\\hline", "\\hdashline"],
  props: {
    numArgs: 0,
    allowedInText: !0,
    allowedInMath: !0
  },
  handler(e, t) {
    throw new We(e.funcName + " valid only within array environment");
  }
});
var y4 = oD;
rt({
  type: "environment",
  names: ["\\begin", "\\end"],
  props: {
    numArgs: 1,
    argTypes: ["text"]
  },
  handler(e, t) {
    var {
      parser: i,
      funcName: r
    } = e, n = t[0];
    if (n.type !== "ordgroup")
      throw new We("Invalid environment name", n);
    for (var o = "", s = 0; s < n.body.length; ++s)
      o += Ft(n.body[s], "textord").text;
    if (r === "\\begin") {
      if (!y4.hasOwnProperty(o))
        throw new We("No such environment: " + o, n);
      var a = y4[o], {
        args: l,
        optArgs: c
      } = i.parseArguments("\\begin{" + o + "}", a), u = {
        mode: i.mode,
        envName: o,
        parser: i
      }, m = a.handler(u, l, c);
      i.expect("\\end", !1);
      var g = i.nextToken, h = Ft(i.parseFunction(), "environment");
      if (h.name !== o)
        throw new We("Mismatch: \\begin{" + o + "} matched by \\end{" + h.name + "}", g);
      return m;
    }
    return {
      type: "environment",
      mode: i.mode,
      name: o,
      nameGroup: n
    };
  }
});
var lD = (e, t) => {
  var i = e.font, r = t.withFont(i);
  return ii(e.body, r);
}, cD = (e, t) => {
  var i = e.font, r = t.withFont(i);
  return Si(e.body, r);
}, E4 = {
  "\\Bbb": "\\mathbb",
  "\\bold": "\\mathbf",
  "\\frak": "\\mathfrak",
  "\\bm": "\\boldsymbol"
};
rt({
  type: "font",
  names: [
    // styles, except \boldsymbol defined below
    "\\mathrm",
    "\\mathit",
    "\\mathbf",
    "\\mathnormal",
    // families
    "\\mathbb",
    "\\mathcal",
    "\\mathfrak",
    "\\mathscr",
    "\\mathsf",
    "\\mathtt",
    // aliases, except \bm defined below
    "\\Bbb",
    "\\bold",
    "\\frak"
  ],
  props: {
    numArgs: 1,
    allowedInArgument: !0
  },
  handler: (e, t) => {
    var {
      parser: i,
      funcName: r
    } = e, n = I1(t[0]), o = r;
    return o in E4 && (o = E4[o]), {
      type: "font",
      mode: i.mode,
      font: o.slice(1),
      body: n
    };
  },
  htmlBuilder: lD,
  mathmlBuilder: cD
});
rt({
  type: "mclass",
  names: ["\\boldsymbol", "\\bm"],
  props: {
    numArgs: 1
  },
  handler: (e, t) => {
    var {
      parser: i
    } = e, r = t[0], n = Rt.isCharacterBox(r);
    return {
      type: "mclass",
      mode: i.mode,
      mclass: If(r),
      body: [{
        type: "font",
        mode: i.mode,
        font: "boldsymbol",
        body: r
      }],
      isCharacterBox: n
    };
  }
});
rt({
  type: "font",
  names: ["\\rm", "\\sf", "\\tt", "\\bf", "\\it", "\\cal"],
  props: {
    numArgs: 0,
    allowedInText: !0
  },
  handler: (e, t) => {
    var {
      parser: i,
      funcName: r,
      breakOnTokenText: n
    } = e, {
      mode: o
    } = i, s = i.parseExpression(!0, n), a = "math" + r.slice(1);
    return {
      type: "font",
      mode: o,
      font: a,
      body: {
        type: "ordgroup",
        mode: i.mode,
        body: s
      }
    };
  },
  htmlBuilder: lD,
  mathmlBuilder: cD
});
var uD = (e, t) => {
  var i = t;
  return e === "display" ? i = i.id >= bt.SCRIPT.id ? i.text() : bt.DISPLAY : e === "text" && i.size === bt.DISPLAY.size ? i = bt.TEXT : e === "script" ? i = bt.SCRIPT : e === "scriptscript" && (i = bt.SCRIPTSCRIPT), i;
}, ex = (e, t) => {
  var i = uD(e.size, t.style), r = i.fracNum(), n = i.fracDen(), o;
  o = t.havingStyle(r);
  var s = ii(e.numer, o, t);
  if (e.continued) {
    var a = 8.5 / t.fontMetrics().ptPerEm, l = 3.5 / t.fontMetrics().ptPerEm;
    s.height = s.height < a ? a : s.height, s.depth = s.depth < l ? l : s.depth;
  }
  o = t.havingStyle(n);
  var c = ii(e.denom, o, t), u, m, g;
  e.hasBarLine ? (e.barSize ? (m = Hi(e.barSize, t), u = ve.makeLineSpan("frac-line", t, m)) : u = ve.makeLineSpan("frac-line", t), m = u.height, g = u.height) : (u = null, m = 0, g = t.fontMetrics().defaultRuleThickness);
  var h, A, y;
  i.size === bt.DISPLAY.size || e.size === "display" ? (h = t.fontMetrics().num1, m > 0 ? A = 3 * g : A = 7 * g, y = t.fontMetrics().denom1) : (m > 0 ? (h = t.fontMetrics().num2, A = g) : (h = t.fontMetrics().num3, A = 3 * g), y = t.fontMetrics().denom2);
  var E;
  if (u) {
    var C = t.fontMetrics().axisHeight;
    h - s.depth - (C + 0.5 * m) < A && (h += A - (h - s.depth - (C + 0.5 * m))), C - 0.5 * m - (c.height - y) < A && (y += A - (C - 0.5 * m - (c.height - y)));
    var x = -(C - 0.5 * m);
    E = ve.makeVList({
      positionType: "individualShift",
      children: [{
        type: "elem",
        elem: c,
        shift: y
      }, {
        type: "elem",
        elem: u,
        shift: x
      }, {
        type: "elem",
        elem: s,
        shift: -h
      }]
    }, t);
  } else {
    var v = h - s.depth - (c.height - y);
    v < A && (h += 0.5 * (A - v), y += 0.5 * (A - v)), E = ve.makeVList({
      positionType: "individualShift",
      children: [{
        type: "elem",
        elem: c,
        shift: y
      }, {
        type: "elem",
        elem: s,
        shift: -h
      }]
    }, t);
  }
  o = t.havingStyle(i), E.height *= o.sizeMultiplier / t.sizeMultiplier, E.depth *= o.sizeMultiplier / t.sizeMultiplier;
  var S;
  i.size === bt.DISPLAY.size ? S = t.fontMetrics().delim1 : i.size === bt.SCRIPTSCRIPT.size ? S = t.havingStyle(bt.SCRIPT).fontMetrics().delim2 : S = t.fontMetrics().delim2;
  var R, w;
  return e.leftDelim == null ? R = Zm(t, ["mopen"]) : R = wa.customSizedDelim(e.leftDelim, S, !0, t.havingStyle(i), e.mode, ["mopen"]), e.continued ? w = ve.makeSpan([]) : e.rightDelim == null ? w = Zm(t, ["mclose"]) : w = wa.customSizedDelim(e.rightDelim, S, !0, t.havingStyle(i), e.mode, ["mclose"]), ve.makeSpan(["mord"].concat(o.sizingClasses(t)), [R, ve.makeSpan(["mfrac"], [E]), w], t);
}, tx = (e, t) => {
  var i = new Ge.MathNode("mfrac", [Si(e.numer, t), Si(e.denom, t)]);
  if (!e.hasBarLine)
    i.setAttribute("linethickness", "0px");
  else if (e.barSize) {
    var r = Hi(e.barSize, t);
    i.setAttribute("linethickness", He(r));
  }
  var n = uD(e.size, t.style);
  if (n.size !== t.style.size) {
    i = new Ge.MathNode("mstyle", [i]);
    var o = n.size === bt.DISPLAY.size ? "true" : "false";
    i.setAttribute("displaystyle", o), i.setAttribute("scriptlevel", "0");
  }
  if (e.leftDelim != null || e.rightDelim != null) {
    var s = [];
    if (e.leftDelim != null) {
      var a = new Ge.MathNode("mo", [new Ge.TextNode(e.leftDelim.replace("\\", ""))]);
      a.setAttribute("fence", "true"), s.push(a);
    }
    if (s.push(i), e.rightDelim != null) {
      var l = new Ge.MathNode("mo", [new Ge.TextNode(e.rightDelim.replace("\\", ""))]);
      l.setAttribute("fence", "true"), s.push(l);
    }
    return W2(s);
  }
  return i;
};
rt({
  type: "genfrac",
  names: [
    "\\dfrac",
    "\\frac",
    "\\tfrac",
    "\\dbinom",
    "\\binom",
    "\\tbinom",
    "\\\\atopfrac",
    // can’t be entered directly
    "\\\\bracefrac",
    "\\\\brackfrac"
    // ditto
  ],
  props: {
    numArgs: 2,
    allowedInArgument: !0
  },
  handler: (e, t) => {
    var {
      parser: i,
      funcName: r
    } = e, n = t[0], o = t[1], s, a = null, l = null, c = "auto";
    switch (r) {
      case "\\dfrac":
      case "\\frac":
      case "\\tfrac":
        s = !0;
        break;
      case "\\\\atopfrac":
        s = !1;
        break;
      case "\\dbinom":
      case "\\binom":
      case "\\tbinom":
        s = !1, a = "(", l = ")";
        break;
      case "\\\\bracefrac":
        s = !1, a = "\\{", l = "\\}";
        break;
      case "\\\\brackfrac":
        s = !1, a = "[", l = "]";
        break;
      default:
        throw new Error("Unrecognized genfrac command");
    }
    switch (r) {
      case "\\dfrac":
      case "\\dbinom":
        c = "display";
        break;
      case "\\tfrac":
      case "\\tbinom":
        c = "text";
        break;
    }
    return {
      type: "genfrac",
      mode: i.mode,
      continued: !1,
      numer: n,
      denom: o,
      hasBarLine: s,
      leftDelim: a,
      rightDelim: l,
      size: c,
      barSize: null
    };
  },
  htmlBuilder: ex,
  mathmlBuilder: tx
});
rt({
  type: "genfrac",
  names: ["\\cfrac"],
  props: {
    numArgs: 2
  },
  handler: (e, t) => {
    var {
      parser: i,
      funcName: r
    } = e, n = t[0], o = t[1];
    return {
      type: "genfrac",
      mode: i.mode,
      continued: !0,
      numer: n,
      denom: o,
      hasBarLine: !0,
      leftDelim: null,
      rightDelim: null,
      size: "display",
      barSize: null
    };
  }
});
rt({
  type: "infix",
  names: ["\\over", "\\choose", "\\atop", "\\brace", "\\brack"],
  props: {
    numArgs: 0,
    infix: !0
  },
  handler(e) {
    var {
      parser: t,
      funcName: i,
      token: r
    } = e, n;
    switch (i) {
      case "\\over":
        n = "\\frac";
        break;
      case "\\choose":
        n = "\\binom";
        break;
      case "\\atop":
        n = "\\\\atopfrac";
        break;
      case "\\brace":
        n = "\\\\bracefrac";
        break;
      case "\\brack":
        n = "\\\\brackfrac";
        break;
      default:
        throw new Error("Unrecognized infix genfrac command");
    }
    return {
      type: "infix",
      mode: t.mode,
      replaceWith: n,
      token: r
    };
  }
});
var v4 = ["display", "text", "script", "scriptscript"], b4 = function(t) {
  var i = null;
  return t.length > 0 && (i = t, i = i === "." ? null : i), i;
};
rt({
  type: "genfrac",
  names: ["\\genfrac"],
  props: {
    numArgs: 6,
    allowedInArgument: !0,
    argTypes: ["math", "math", "size", "text", "math", "math"]
  },
  handler(e, t) {
    var {
      parser: i
    } = e, r = t[4], n = t[5], o = I1(t[0]), s = o.type === "atom" && o.family === "open" ? b4(o.text) : null, a = I1(t[1]), l = a.type === "atom" && a.family === "close" ? b4(a.text) : null, c = Ft(t[2], "size"), u, m = null;
    c.isBlank ? u = !0 : (m = c.value, u = m.number > 0);
    var g = "auto", h = t[3];
    if (h.type === "ordgroup") {
      if (h.body.length > 0) {
        var A = Ft(h.body[0], "textord");
        g = v4[Number(A.text)];
      }
    } else
      h = Ft(h, "textord"), g = v4[Number(h.text)];
    return {
      type: "genfrac",
      mode: i.mode,
      numer: r,
      denom: n,
      continued: !1,
      hasBarLine: u,
      barSize: m,
      leftDelim: s,
      rightDelim: l,
      size: g
    };
  },
  htmlBuilder: ex,
  mathmlBuilder: tx
});
rt({
  type: "infix",
  names: ["\\above"],
  props: {
    numArgs: 1,
    argTypes: ["size"],
    infix: !0
  },
  handler(e, t) {
    var {
      parser: i,
      funcName: r,
      token: n
    } = e;
    return {
      type: "infix",
      mode: i.mode,
      replaceWith: "\\\\abovefrac",
      size: Ft(t[0], "size").value,
      token: n
    };
  }
});
rt({
  type: "genfrac",
  names: ["\\\\abovefrac"],
  props: {
    numArgs: 3,
    argTypes: ["math", "size", "math"]
  },
  handler: (e, t) => {
    var {
      parser: i,
      funcName: r
    } = e, n = t[0], o = n_(Ft(t[1], "infix").size), s = t[2], a = o.number > 0;
    return {
      type: "genfrac",
      mode: i.mode,
      numer: n,
      denom: s,
      continued: !1,
      hasBarLine: a,
      barSize: o,
      leftDelim: null,
      rightDelim: null,
      size: "auto"
    };
  },
  htmlBuilder: ex,
  mathmlBuilder: tx
});
var dD = (e, t) => {
  var i = t.style, r, n;
  e.type === "supsub" ? (r = e.sup ? ii(e.sup, t.havingStyle(i.sup()), t) : ii(e.sub, t.havingStyle(i.sub()), t), n = Ft(e.base, "horizBrace")) : n = Ft(e, "horizBrace");
  var o = ii(n.base, t.havingBaseStyle(bt.DISPLAY)), s = Da.svgSpan(n, t), a;
  if (n.isOver ? (a = ve.makeVList({
    positionType: "firstBaseline",
    children: [{
      type: "elem",
      elem: o
    }, {
      type: "kern",
      size: 0.1
    }, {
      type: "elem",
      elem: s
    }]
  }, t), a.children[0].children[0].children[1].classes.push("svg-align")) : (a = ve.makeVList({
    positionType: "bottom",
    positionData: o.depth + 0.1 + s.height,
    children: [{
      type: "elem",
      elem: s
    }, {
      type: "kern",
      size: 0.1
    }, {
      type: "elem",
      elem: o
    }]
  }, t), a.children[0].children[0].children[0].classes.push("svg-align")), r) {
    var l = ve.makeSpan(["mord", n.isOver ? "mover" : "munder"], [a], t);
    n.isOver ? a = ve.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: l
      }, {
        type: "kern",
        size: 0.2
      }, {
        type: "elem",
        elem: r
      }]
    }, t) : a = ve.makeVList({
      positionType: "bottom",
      positionData: l.depth + 0.2 + r.height + r.depth,
      children: [{
        type: "elem",
        elem: r
      }, {
        type: "kern",
        size: 0.2
      }, {
        type: "elem",
        elem: l
      }]
    }, t);
  }
  return ve.makeSpan(["mord", n.isOver ? "mover" : "munder"], [a], t);
}, w$ = (e, t) => {
  var i = Da.mathMLnode(e.label);
  return new Ge.MathNode(e.isOver ? "mover" : "munder", [Si(e.base, t), i]);
};
rt({
  type: "horizBrace",
  names: ["\\overbrace", "\\underbrace"],
  props: {
    numArgs: 1
  },
  handler(e, t) {
    var {
      parser: i,
      funcName: r
    } = e;
    return {
      type: "horizBrace",
      mode: i.mode,
      label: r,
      isOver: /^\\over/.test(r),
      base: t[0]
    };
  },
  htmlBuilder: dD,
  mathmlBuilder: w$
});
rt({
  type: "href",
  names: ["\\href"],
  props: {
    numArgs: 2,
    argTypes: ["url", "original"],
    allowedInText: !0
  },
  handler: (e, t) => {
    var {
      parser: i
    } = e, r = t[1], n = Ft(t[0], "url").url;
    return i.settings.isTrusted({
      command: "\\href",
      url: n
    }) ? {
      type: "href",
      mode: i.mode,
      href: n,
      body: dr(r)
    } : i.formatUnsupportedCmd("\\href");
  },
  htmlBuilder: (e, t) => {
    var i = Ir(e.body, t, !1);
    return ve.makeAnchor(e.href, [], i, t);
  },
  mathmlBuilder: (e, t) => {
    var i = ql(e.body, t);
    return i instanceof Ko || (i = new Ko("mrow", [i])), i.setAttribute("href", e.href), i;
  }
});
rt({
  type: "href",
  names: ["\\url"],
  props: {
    numArgs: 1,
    argTypes: ["url"],
    allowedInText: !0
  },
  handler: (e, t) => {
    var {
      parser: i
    } = e, r = Ft(t[0], "url").url;
    if (!i.settings.isTrusted({
      command: "\\url",
      url: r
    }))
      return i.formatUnsupportedCmd("\\url");
    for (var n = [], o = 0; o < r.length; o++) {
      var s = r[o];
      s === "~" && (s = "\\textasciitilde"), n.push({
        type: "textord",
        mode: "text",
        text: s
      });
    }
    var a = {
      type: "text",
      mode: i.mode,
      font: "\\texttt",
      body: n
    };
    return {
      type: "href",
      mode: i.mode,
      href: r,
      body: dr(a)
    };
  }
});
rt({
  type: "hbox",
  names: ["\\hbox"],
  props: {
    numArgs: 1,
    argTypes: ["text"],
    allowedInText: !0,
    primitive: !0
  },
  handler(e, t) {
    var {
      parser: i
    } = e;
    return {
      type: "hbox",
      mode: i.mode,
      body: dr(t[0])
    };
  },
  htmlBuilder(e, t) {
    var i = Ir(e.body, t, !1);
    return ve.makeFragment(i);
  },
  mathmlBuilder(e, t) {
    return new Ge.MathNode("mrow", zn(e.body, t));
  }
});
rt({
  type: "html",
  names: ["\\htmlClass", "\\htmlId", "\\htmlStyle", "\\htmlData"],
  props: {
    numArgs: 2,
    argTypes: ["raw", "original"],
    allowedInText: !0
  },
  handler: (e, t) => {
    var {
      parser: i,
      funcName: r,
      token: n
    } = e, o = Ft(t[0], "raw").string, s = t[1];
    i.settings.strict && i.settings.reportNonstrict("htmlExtension", "HTML extension is disabled on strict mode");
    var a, l = {};
    switch (r) {
      case "\\htmlClass":
        l.class = o, a = {
          command: "\\htmlClass",
          class: o
        };
        break;
      case "\\htmlId":
        l.id = o, a = {
          command: "\\htmlId",
          id: o
        };
        break;
      case "\\htmlStyle":
        l.style = o, a = {
          command: "\\htmlStyle",
          style: o
        };
        break;
      case "\\htmlData": {
        for (var c = o.split(","), u = 0; u < c.length; u++) {
          var m = c[u].split("=");
          if (m.length !== 2)
            throw new We("Error parsing key-value for \\htmlData");
          l["data-" + m[0].trim()] = m[1].trim();
        }
        a = {
          command: "\\htmlData",
          attributes: l
        };
        break;
      }
      default:
        throw new Error("Unrecognized html command");
    }
    return i.settings.isTrusted(a) ? {
      type: "html",
      mode: i.mode,
      attributes: l,
      body: dr(s)
    } : i.formatUnsupportedCmd(r);
  },
  htmlBuilder: (e, t) => {
    var i = Ir(e.body, t, !1), r = ["enclosing"];
    e.attributes.class && r.push(...e.attributes.class.trim().split(/\s+/));
    var n = ve.makeSpan(r, i, t);
    for (var o in e.attributes)
      o !== "class" && e.attributes.hasOwnProperty(o) && n.setAttribute(o, e.attributes[o]);
    return n;
  },
  mathmlBuilder: (e, t) => ql(e.body, t)
});
rt({
  type: "htmlmathml",
  names: ["\\html@mathml"],
  props: {
    numArgs: 2,
    allowedInText: !0
  },
  handler: (e, t) => {
    var {
      parser: i
    } = e;
    return {
      type: "htmlmathml",
      mode: i.mode,
      html: dr(t[0]),
      mathml: dr(t[1])
    };
  },
  htmlBuilder: (e, t) => {
    var i = Ir(e.html, t, !1);
    return ve.makeFragment(i);
  },
  mathmlBuilder: (e, t) => ql(e.mathml, t)
});
var sE = function(t) {
  if (/^[-+]? *(\d+(\.\d*)?|\.\d+)$/.test(t))
    return {
      number: +t,
      unit: "bp"
    };
  var i = /([-+]?) *(\d+(?:\.\d*)?|\.\d+) *([a-z]{2})/.exec(t);
  if (!i)
    throw new We("Invalid size: '" + t + "' in \\includegraphics");
  var r = {
    number: +(i[1] + i[2]),
    // sign + magnitude, cast to number
    unit: i[3]
  };
  if (!N7(r))
    throw new We("Invalid unit: '" + r.unit + "' in \\includegraphics.");
  return r;
};
rt({
  type: "includegraphics",
  names: ["\\includegraphics"],
  props: {
    numArgs: 1,
    numOptionalArgs: 1,
    argTypes: ["raw", "url"],
    allowedInText: !1
  },
  handler: (e, t, i) => {
    var {
      parser: r
    } = e, n = {
      number: 0,
      unit: "em"
    }, o = {
      number: 0.9,
      unit: "em"
    }, s = {
      number: 0,
      unit: "em"
    }, a = "";
    if (i[0])
      for (var l = Ft(i[0], "raw").string, c = l.split(","), u = 0; u < c.length; u++) {
        var m = c[u].split("=");
        if (m.length === 2) {
          var g = m[1].trim();
          switch (m[0].trim()) {
            case "alt":
              a = g;
              break;
            case "width":
              n = sE(g);
              break;
            case "height":
              o = sE(g);
              break;
            case "totalheight":
              s = sE(g);
              break;
            default:
              throw new We("Invalid key: '" + m[0] + "' in \\includegraphics.");
          }
        }
      }
    var h = Ft(t[0], "url").url;
    return a === "" && (a = h, a = a.replace(/^.*[\\/]/, ""), a = a.substring(0, a.lastIndexOf("."))), r.settings.isTrusted({
      command: "\\includegraphics",
      url: h
    }) ? {
      type: "includegraphics",
      mode: r.mode,
      alt: a,
      width: n,
      height: o,
      totalheight: s,
      src: h
    } : r.formatUnsupportedCmd("\\includegraphics");
  },
  htmlBuilder: (e, t) => {
    var i = Hi(e.height, t), r = 0;
    e.totalheight.number > 0 && (r = Hi(e.totalheight, t) - i);
    var n = 0;
    e.width.number > 0 && (n = Hi(e.width, t));
    var o = {
      height: He(i + r)
    };
    n > 0 && (o.width = He(n)), r > 0 && (o.verticalAlign = He(-r));
    var s = new w_(e.src, e.alt, o);
    return s.height = i, s.depth = r, s;
  },
  mathmlBuilder: (e, t) => {
    var i = new Ge.MathNode("mglyph", []);
    i.setAttribute("alt", e.alt);
    var r = Hi(e.height, t), n = 0;
    if (e.totalheight.number > 0 && (n = Hi(e.totalheight, t) - r, i.setAttribute("valign", He(-n))), i.setAttribute("height", He(r + n)), e.width.number > 0) {
      var o = Hi(e.width, t);
      i.setAttribute("width", He(o));
    }
    return i.setAttribute("src", e.src), i;
  }
});
rt({
  type: "kern",
  names: ["\\kern", "\\mkern", "\\hskip", "\\mskip"],
  props: {
    numArgs: 1,
    argTypes: ["size"],
    primitive: !0,
    allowedInText: !0
  },
  handler(e, t) {
    var {
      parser: i,
      funcName: r
    } = e, n = Ft(t[0], "size");
    if (i.settings.strict) {
      var o = r[1] === "m", s = n.value.unit === "mu";
      o ? (s || i.settings.reportNonstrict("mathVsTextUnits", "LaTeX's " + r + " supports only mu units, " + ("not " + n.value.unit + " units")), i.mode !== "math" && i.settings.reportNonstrict("mathVsTextUnits", "LaTeX's " + r + " works only in math mode")) : s && i.settings.reportNonstrict("mathVsTextUnits", "LaTeX's " + r + " doesn't support mu units");
    }
    return {
      type: "kern",
      mode: i.mode,
      dimension: n.value
    };
  },
  htmlBuilder(e, t) {
    return ve.makeGlue(e.dimension, t);
  },
  mathmlBuilder(e, t) {
    var i = Hi(e.dimension, t);
    return new Ge.SpaceNode(i);
  }
});
rt({
  type: "lap",
  names: ["\\mathllap", "\\mathrlap", "\\mathclap"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler: (e, t) => {
    var {
      parser: i,
      funcName: r
    } = e, n = t[0];
    return {
      type: "lap",
      mode: i.mode,
      alignment: r.slice(5),
      body: n
    };
  },
  htmlBuilder: (e, t) => {
    var i;
    e.alignment === "clap" ? (i = ve.makeSpan([], [ii(e.body, t)]), i = ve.makeSpan(["inner"], [i], t)) : i = ve.makeSpan(["inner"], [ii(e.body, t)]);
    var r = ve.makeSpan(["fix"], []), n = ve.makeSpan([e.alignment], [i, r], t), o = ve.makeSpan(["strut"]);
    return o.style.height = He(n.height + n.depth), n.depth && (o.style.verticalAlign = He(-n.depth)), n.children.unshift(o), n = ve.makeSpan(["thinbox"], [n], t), ve.makeSpan(["mord", "vbox"], [n], t);
  },
  mathmlBuilder: (e, t) => {
    var i = new Ge.MathNode("mpadded", [Si(e.body, t)]);
    if (e.alignment !== "rlap") {
      var r = e.alignment === "llap" ? "-1" : "-0.5";
      i.setAttribute("lspace", r + "width");
    }
    return i.setAttribute("width", "0px"), i;
  }
});
rt({
  type: "styling",
  names: ["\\(", "$"],
  props: {
    numArgs: 0,
    allowedInText: !0,
    allowedInMath: !1
  },
  handler(e, t) {
    var {
      funcName: i,
      parser: r
    } = e, n = r.mode;
    r.switchMode("math");
    var o = i === "\\(" ? "\\)" : "$", s = r.parseExpression(!1, o);
    return r.expect(o), r.switchMode(n), {
      type: "styling",
      mode: r.mode,
      style: "text",
      body: s
    };
  }
});
rt({
  type: "text",
  // Doesn't matter what this is.
  names: ["\\)", "\\]"],
  props: {
    numArgs: 0,
    allowedInText: !0,
    allowedInMath: !1
  },
  handler(e, t) {
    throw new We("Mismatched " + e.funcName);
  }
});
var C4 = (e, t) => {
  switch (t.style.size) {
    case bt.DISPLAY.size:
      return e.display;
    case bt.TEXT.size:
      return e.text;
    case bt.SCRIPT.size:
      return e.script;
    case bt.SCRIPTSCRIPT.size:
      return e.scriptscript;
    default:
      return e.text;
  }
};
rt({
  type: "mathchoice",
  names: ["\\mathchoice"],
  props: {
    numArgs: 4,
    primitive: !0
  },
  handler: (e, t) => {
    var {
      parser: i
    } = e;
    return {
      type: "mathchoice",
      mode: i.mode,
      display: dr(t[0]),
      text: dr(t[1]),
      script: dr(t[2]),
      scriptscript: dr(t[3])
    };
  },
  htmlBuilder: (e, t) => {
    var i = C4(e, t), r = Ir(i, t, !1);
    return ve.makeFragment(r);
  },
  mathmlBuilder: (e, t) => {
    var i = C4(e, t);
    return ql(i, t);
  }
});
var mD = (e, t, i, r, n, o, s) => {
  e = ve.makeSpan([], [e]);
  var a = i && Rt.isCharacterBox(i), l, c;
  if (t) {
    var u = ii(t, r.havingStyle(n.sup()), r);
    c = {
      elem: u,
      kern: Math.max(r.fontMetrics().bigOpSpacing1, r.fontMetrics().bigOpSpacing3 - u.depth)
    };
  }
  if (i) {
    var m = ii(i, r.havingStyle(n.sub()), r);
    l = {
      elem: m,
      kern: Math.max(r.fontMetrics().bigOpSpacing2, r.fontMetrics().bigOpSpacing4 - m.height)
    };
  }
  var g;
  if (c && l) {
    var h = r.fontMetrics().bigOpSpacing5 + l.elem.height + l.elem.depth + l.kern + e.depth + s;
    g = ve.makeVList({
      positionType: "bottom",
      positionData: h,
      children: [{
        type: "kern",
        size: r.fontMetrics().bigOpSpacing5
      }, {
        type: "elem",
        elem: l.elem,
        marginLeft: He(-o)
      }, {
        type: "kern",
        size: l.kern
      }, {
        type: "elem",
        elem: e
      }, {
        type: "kern",
        size: c.kern
      }, {
        type: "elem",
        elem: c.elem,
        marginLeft: He(o)
      }, {
        type: "kern",
        size: r.fontMetrics().bigOpSpacing5
      }]
    }, r);
  } else if (l) {
    var A = e.height - s;
    g = ve.makeVList({
      positionType: "top",
      positionData: A,
      children: [{
        type: "kern",
        size: r.fontMetrics().bigOpSpacing5
      }, {
        type: "elem",
        elem: l.elem,
        marginLeft: He(-o)
      }, {
        type: "kern",
        size: l.kern
      }, {
        type: "elem",
        elem: e
      }]
    }, r);
  } else if (c) {
    var y = e.depth + s;
    g = ve.makeVList({
      positionType: "bottom",
      positionData: y,
      children: [{
        type: "elem",
        elem: e
      }, {
        type: "kern",
        size: c.kern
      }, {
        type: "elem",
        elem: c.elem,
        marginLeft: He(o)
      }, {
        type: "kern",
        size: r.fontMetrics().bigOpSpacing5
      }]
    }, r);
  } else
    return e;
  var E = [g];
  if (l && o !== 0 && !a) {
    var v = ve.makeSpan(["mspace"], [], r);
    v.style.marginRight = He(o), E.unshift(v);
  }
  return ve.makeSpan(["mop", "op-limits"], E, r);
}, gD = ["\\smallint"], Z0 = (e, t) => {
  var i, r, n = !1, o;
  e.type === "supsub" ? (i = e.sup, r = e.sub, o = Ft(e.base, "op"), n = !0) : o = Ft(e, "op");
  var s = t.style, a = !1;
  s.size === bt.DISPLAY.size && o.symbol && !Rt.contains(gD, o.name) && (a = !0);
  var l;
  if (o.symbol) {
    var c = a ? "Size2-Regular" : "Size1-Regular", u = "";
    if ((o.name === "\\oiint" || o.name === "\\oiiint") && (u = o.name.slice(1), o.name = u === "oiint" ? "\\iint" : "\\iiint"), l = ve.makeSymbol(o.name, c, "math", t, ["mop", "op-symbol", a ? "large-op" : "small-op"]), u.length > 0) {
      var m = l.italic, g = ve.staticSvg(u + "Size" + (a ? "2" : "1"), t);
      l = ve.makeVList({
        positionType: "individualShift",
        children: [{
          type: "elem",
          elem: l,
          shift: 0
        }, {
          type: "elem",
          elem: g,
          shift: a ? 0.08 : 0
        }]
      }, t), o.name = "\\" + u, l.classes.unshift("mop"), l.italic = m;
    }
  } else if (o.body) {
    var h = Ir(o.body, t, !0);
    h.length === 1 && h[0] instanceof Zo ? (l = h[0], l.classes[0] = "mop") : l = ve.makeSpan(["mop"], h, t);
  } else {
    for (var A = [], y = 1; y < o.name.length; y++)
      A.push(ve.mathsym(o.name[y], o.mode, t));
    l = ve.makeSpan(["mop"], A, t);
  }
  var E = 0, v = 0;
  return (l instanceof Zo || o.name === "\\oiint" || o.name === "\\oiiint") && !o.suppressBaseShift && (E = (l.height - l.depth) / 2 - t.fontMetrics().axisHeight, v = l.italic), n ? mD(l, i, r, t, s, v, E) : (E && (l.style.position = "relative", l.style.top = He(E)), l);
}, xg = (e, t) => {
  var i;
  if (e.symbol)
    i = new Ko("mo", [Jo(e.name, e.mode)]), Rt.contains(gD, e.name) && i.setAttribute("largeop", "false");
  else if (e.body)
    i = new Ko("mo", zn(e.body, t));
  else {
    i = new Ko("mi", [new vm(e.name.slice(1))]);
    var r = new Ko("mo", [Jo("⁡", "text")]);
    e.parentIsSupSub ? i = new Ko("mrow", [i, r]) : i = Y7([i, r]);
  }
  return i;
}, M$ = {
  "∏": "\\prod",
  "∐": "\\coprod",
  "∑": "\\sum",
  "⋀": "\\bigwedge",
  "⋁": "\\bigvee",
  "⋂": "\\bigcap",
  "⋃": "\\bigcup",
  "⨀": "\\bigodot",
  "⨁": "\\bigoplus",
  "⨂": "\\bigotimes",
  "⨄": "\\biguplus",
  "⨆": "\\bigsqcup"
};
rt({
  type: "op",
  names: ["\\coprod", "\\bigvee", "\\bigwedge", "\\biguplus", "\\bigcap", "\\bigcup", "\\intop", "\\prod", "\\sum", "\\bigotimes", "\\bigoplus", "\\bigodot", "\\bigsqcup", "\\smallint", "∏", "∐", "∑", "⋀", "⋁", "⋂", "⋃", "⨀", "⨁", "⨂", "⨄", "⨆"],
  props: {
    numArgs: 0
  },
  handler: (e, t) => {
    var {
      parser: i,
      funcName: r
    } = e, n = r;
    return n.length === 1 && (n = M$[n]), {
      type: "op",
      mode: i.mode,
      limits: !0,
      parentIsSupSub: !1,
      symbol: !0,
      name: n
    };
  },
  htmlBuilder: Z0,
  mathmlBuilder: xg
});
rt({
  type: "op",
  names: ["\\mathop"],
  props: {
    numArgs: 1,
    primitive: !0
  },
  handler: (e, t) => {
    var {
      parser: i
    } = e, r = t[0];
    return {
      type: "op",
      mode: i.mode,
      limits: !1,
      parentIsSupSub: !1,
      symbol: !1,
      body: dr(r)
    };
  },
  htmlBuilder: Z0,
  mathmlBuilder: xg
});
var N$ = {
  "∫": "\\int",
  "∬": "\\iint",
  "∭": "\\iiint",
  "∮": "\\oint",
  "∯": "\\oiint",
  "∰": "\\oiiint"
};
rt({
  type: "op",
  names: ["\\arcsin", "\\arccos", "\\arctan", "\\arctg", "\\arcctg", "\\arg", "\\ch", "\\cos", "\\cosec", "\\cosh", "\\cot", "\\cotg", "\\coth", "\\csc", "\\ctg", "\\cth", "\\deg", "\\dim", "\\exp", "\\hom", "\\ker", "\\lg", "\\ln", "\\log", "\\sec", "\\sin", "\\sinh", "\\sh", "\\tan", "\\tanh", "\\tg", "\\th"],
  props: {
    numArgs: 0
  },
  handler(e) {
    var {
      parser: t,
      funcName: i
    } = e;
    return {
      type: "op",
      mode: t.mode,
      limits: !1,
      parentIsSupSub: !1,
      symbol: !1,
      name: i
    };
  },
  htmlBuilder: Z0,
  mathmlBuilder: xg
});
rt({
  type: "op",
  names: ["\\det", "\\gcd", "\\inf", "\\lim", "\\max", "\\min", "\\Pr", "\\sup"],
  props: {
    numArgs: 0
  },
  handler(e) {
    var {
      parser: t,
      funcName: i
    } = e;
    return {
      type: "op",
      mode: t.mode,
      limits: !0,
      parentIsSupSub: !1,
      symbol: !1,
      name: i
    };
  },
  htmlBuilder: Z0,
  mathmlBuilder: xg
});
rt({
  type: "op",
  names: ["\\int", "\\iint", "\\iiint", "\\oint", "\\oiint", "\\oiiint", "∫", "∬", "∭", "∮", "∯", "∰"],
  props: {
    numArgs: 0
  },
  handler(e) {
    var {
      parser: t,
      funcName: i
    } = e, r = i;
    return r.length === 1 && (r = N$[r]), {
      type: "op",
      mode: t.mode,
      limits: !1,
      parentIsSupSub: !1,
      symbol: !0,
      name: r
    };
  },
  htmlBuilder: Z0,
  mathmlBuilder: xg
});
var hD = (e, t) => {
  var i, r, n = !1, o;
  e.type === "supsub" ? (i = e.sup, r = e.sub, o = Ft(e.base, "operatorname"), n = !0) : o = Ft(e, "operatorname");
  var s;
  if (o.body.length > 0) {
    for (var a = o.body.map((m) => {
      var g = m.text;
      return typeof g == "string" ? {
        type: "textord",
        mode: m.mode,
        text: g
      } : m;
    }), l = Ir(a, t.withFont("mathrm"), !0), c = 0; c < l.length; c++) {
      var u = l[c];
      u instanceof Zo && (u.text = u.text.replace(/\u2212/, "-").replace(/\u2217/, "*"));
    }
    s = ve.makeSpan(["mop"], l, t);
  } else
    s = ve.makeSpan(["mop"], [], t);
  return n ? mD(s, i, r, t, t.style, 0, 0) : s;
}, T$ = (e, t) => {
  for (var i = zn(e.body, t.withFont("mathrm")), r = !0, n = 0; n < i.length; n++) {
    var o = i[n];
    if (!(o instanceof Ge.SpaceNode))
      if (o instanceof Ge.MathNode)
        switch (o.type) {
          case "mi":
          case "mn":
          case "ms":
          case "mspace":
          case "mtext":
            break;
          case "mo": {
            var s = o.children[0];
            o.children.length === 1 && s instanceof Ge.TextNode ? s.text = s.text.replace(/\u2212/, "-").replace(/\u2217/, "*") : r = !1;
            break;
          }
          default:
            r = !1;
        }
      else
        r = !1;
  }
  if (r) {
    var a = i.map((u) => u.toText()).join("");
    i = [new Ge.TextNode(a)];
  }
  var l = new Ge.MathNode("mi", i);
  l.setAttribute("mathvariant", "normal");
  var c = new Ge.MathNode("mo", [Jo("⁡", "text")]);
  return e.parentIsSupSub ? new Ge.MathNode("mrow", [l, c]) : Ge.newDocumentFragment([l, c]);
};
rt({
  type: "operatorname",
  names: ["\\operatorname@", "\\operatornamewithlimits"],
  props: {
    numArgs: 1
  },
  handler: (e, t) => {
    var {
      parser: i,
      funcName: r
    } = e, n = t[0];
    return {
      type: "operatorname",
      mode: i.mode,
      body: dr(n),
      alwaysHandleSupSub: r === "\\operatornamewithlimits",
      limits: !1,
      parentIsSupSub: !1
    };
  },
  htmlBuilder: hD,
  mathmlBuilder: T$
});
G("\\operatorname", "\\@ifstar\\operatornamewithlimits\\operatorname@");
ru({
  type: "ordgroup",
  htmlBuilder(e, t) {
    return e.semisimple ? ve.makeFragment(Ir(e.body, t, !1)) : ve.makeSpan(["mord"], Ir(e.body, t, !0), t);
  },
  mathmlBuilder(e, t) {
    return ql(e.body, t, !0);
  }
});
rt({
  type: "overline",
  names: ["\\overline"],
  props: {
    numArgs: 1
  },
  handler(e, t) {
    var {
      parser: i
    } = e, r = t[0];
    return {
      type: "overline",
      mode: i.mode,
      body: r
    };
  },
  htmlBuilder(e, t) {
    var i = ii(e.body, t.havingCrampedStyle()), r = ve.makeLineSpan("overline-line", t), n = t.fontMetrics().defaultRuleThickness, o = ve.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: i
      }, {
        type: "kern",
        size: 3 * n
      }, {
        type: "elem",
        elem: r
      }, {
        type: "kern",
        size: n
      }]
    }, t);
    return ve.makeSpan(["mord", "overline"], [o], t);
  },
  mathmlBuilder(e, t) {
    var i = new Ge.MathNode("mo", [new Ge.TextNode("‾")]);
    i.setAttribute("stretchy", "true");
    var r = new Ge.MathNode("mover", [Si(e.body, t), i]);
    return r.setAttribute("accent", "true"), r;
  }
});
rt({
  type: "phantom",
  names: ["\\phantom"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler: (e, t) => {
    var {
      parser: i
    } = e, r = t[0];
    return {
      type: "phantom",
      mode: i.mode,
      body: dr(r)
    };
  },
  htmlBuilder: (e, t) => {
    var i = Ir(e.body, t.withPhantom(), !1);
    return ve.makeFragment(i);
  },
  mathmlBuilder: (e, t) => {
    var i = zn(e.body, t);
    return new Ge.MathNode("mphantom", i);
  }
});
rt({
  type: "hphantom",
  names: ["\\hphantom"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler: (e, t) => {
    var {
      parser: i
    } = e, r = t[0];
    return {
      type: "hphantom",
      mode: i.mode,
      body: r
    };
  },
  htmlBuilder: (e, t) => {
    var i = ve.makeSpan([], [ii(e.body, t.withPhantom())]);
    if (i.height = 0, i.depth = 0, i.children)
      for (var r = 0; r < i.children.length; r++)
        i.children[r].height = 0, i.children[r].depth = 0;
    return i = ve.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: i
      }]
    }, t), ve.makeSpan(["mord"], [i], t);
  },
  mathmlBuilder: (e, t) => {
    var i = zn(dr(e.body), t), r = new Ge.MathNode("mphantom", i), n = new Ge.MathNode("mpadded", [r]);
    return n.setAttribute("height", "0px"), n.setAttribute("depth", "0px"), n;
  }
});
rt({
  type: "vphantom",
  names: ["\\vphantom"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler: (e, t) => {
    var {
      parser: i
    } = e, r = t[0];
    return {
      type: "vphantom",
      mode: i.mode,
      body: r
    };
  },
  htmlBuilder: (e, t) => {
    var i = ve.makeSpan(["inner"], [ii(e.body, t.withPhantom())]), r = ve.makeSpan(["fix"], []);
    return ve.makeSpan(["mord", "rlap"], [i, r], t);
  },
  mathmlBuilder: (e, t) => {
    var i = zn(dr(e.body), t), r = new Ge.MathNode("mphantom", i), n = new Ge.MathNode("mpadded", [r]);
    return n.setAttribute("width", "0px"), n;
  }
});
rt({
  type: "raisebox",
  names: ["\\raisebox"],
  props: {
    numArgs: 2,
    argTypes: ["size", "hbox"],
    allowedInText: !0
  },
  handler(e, t) {
    var {
      parser: i
    } = e, r = Ft(t[0], "size").value, n = t[1];
    return {
      type: "raisebox",
      mode: i.mode,
      dy: r,
      body: n
    };
  },
  htmlBuilder(e, t) {
    var i = ii(e.body, t), r = Hi(e.dy, t);
    return ve.makeVList({
      positionType: "shift",
      positionData: -r,
      children: [{
        type: "elem",
        elem: i
      }]
    }, t);
  },
  mathmlBuilder(e, t) {
    var i = new Ge.MathNode("mpadded", [Si(e.body, t)]), r = e.dy.number + e.dy.unit;
    return i.setAttribute("voffset", r), i;
  }
});
rt({
  type: "internal",
  names: ["\\relax"],
  props: {
    numArgs: 0,
    allowedInText: !0
  },
  handler(e) {
    var {
      parser: t
    } = e;
    return {
      type: "internal",
      mode: t.mode
    };
  }
});
rt({
  type: "rule",
  names: ["\\rule"],
  props: {
    numArgs: 2,
    numOptionalArgs: 1,
    argTypes: ["size", "size", "size"]
  },
  handler(e, t, i) {
    var {
      parser: r
    } = e, n = i[0], o = Ft(t[0], "size"), s = Ft(t[1], "size");
    return {
      type: "rule",
      mode: r.mode,
      shift: n && Ft(n, "size").value,
      width: o.value,
      height: s.value
    };
  },
  htmlBuilder(e, t) {
    var i = ve.makeSpan(["mord", "rule"], [], t), r = Hi(e.width, t), n = Hi(e.height, t), o = e.shift ? Hi(e.shift, t) : 0;
    return i.style.borderRightWidth = He(r), i.style.borderTopWidth = He(n), i.style.bottom = He(o), i.width = r, i.height = n + o, i.depth = -o, i.maxFontSize = n * 1.125 * t.sizeMultiplier, i;
  },
  mathmlBuilder(e, t) {
    var i = Hi(e.width, t), r = Hi(e.height, t), n = e.shift ? Hi(e.shift, t) : 0, o = t.color && t.getColor() || "black", s = new Ge.MathNode("mspace");
    s.setAttribute("mathbackground", o), s.setAttribute("width", He(i)), s.setAttribute("height", He(r));
    var a = new Ge.MathNode("mpadded", [s]);
    return n >= 0 ? a.setAttribute("height", He(n)) : (a.setAttribute("height", He(n)), a.setAttribute("depth", He(-n))), a.setAttribute("voffset", He(n)), a;
  }
});
function pD(e, t, i) {
  for (var r = Ir(e, t, !1), n = t.sizeMultiplier / i.sizeMultiplier, o = 0; o < r.length; o++) {
    var s = r[o].classes.indexOf("sizing");
    s < 0 ? Array.prototype.push.apply(r[o].classes, t.sizingClasses(i)) : r[o].classes[s + 1] === "reset-size" + t.size && (r[o].classes[s + 1] = "reset-size" + i.size), r[o].height *= n, r[o].depth *= n;
  }
  return ve.makeFragment(r);
}
var x4 = ["\\tiny", "\\sixptsize", "\\scriptsize", "\\footnotesize", "\\small", "\\normalsize", "\\large", "\\Large", "\\LARGE", "\\huge", "\\Huge"], B$ = (e, t) => {
  var i = t.havingSize(e.size);
  return pD(e.body, i, t);
};
rt({
  type: "sizing",
  names: x4,
  props: {
    numArgs: 0,
    allowedInText: !0
  },
  handler: (e, t) => {
    var {
      breakOnTokenText: i,
      funcName: r,
      parser: n
    } = e, o = n.parseExpression(!1, i);
    return {
      type: "sizing",
      mode: n.mode,
      // Figure out what size to use based on the list of functions above
      size: x4.indexOf(r) + 1,
      body: o
    };
  },
  htmlBuilder: B$,
  mathmlBuilder: (e, t) => {
    var i = t.havingSize(e.size), r = zn(e.body, i), n = new Ge.MathNode("mstyle", r);
    return n.setAttribute("mathsize", He(i.sizeMultiplier)), n;
  }
});
rt({
  type: "smash",
  names: ["\\smash"],
  props: {
    numArgs: 1,
    numOptionalArgs: 1,
    allowedInText: !0
  },
  handler: (e, t, i) => {
    var {
      parser: r
    } = e, n = !1, o = !1, s = i[0] && Ft(i[0], "ordgroup");
    if (s)
      for (var a = "", l = 0; l < s.body.length; ++l) {
        var c = s.body[l];
        if (a = c.text, a === "t")
          n = !0;
        else if (a === "b")
          o = !0;
        else {
          n = !1, o = !1;
          break;
        }
      }
    else
      n = !0, o = !0;
    var u = t[0];
    return {
      type: "smash",
      mode: r.mode,
      body: u,
      smashHeight: n,
      smashDepth: o
    };
  },
  htmlBuilder: (e, t) => {
    var i = ve.makeSpan([], [ii(e.body, t)]);
    if (!e.smashHeight && !e.smashDepth)
      return i;
    if (e.smashHeight && (i.height = 0, i.children))
      for (var r = 0; r < i.children.length; r++)
        i.children[r].height = 0;
    if (e.smashDepth && (i.depth = 0, i.children))
      for (var n = 0; n < i.children.length; n++)
        i.children[n].depth = 0;
    var o = ve.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: i
      }]
    }, t);
    return ve.makeSpan(["mord"], [o], t);
  },
  mathmlBuilder: (e, t) => {
    var i = new Ge.MathNode("mpadded", [Si(e.body, t)]);
    return e.smashHeight && i.setAttribute("height", "0px"), e.smashDepth && i.setAttribute("depth", "0px"), i;
  }
});
rt({
  type: "sqrt",
  names: ["\\sqrt"],
  props: {
    numArgs: 1,
    numOptionalArgs: 1
  },
  handler(e, t, i) {
    var {
      parser: r
    } = e, n = i[0], o = t[0];
    return {
      type: "sqrt",
      mode: r.mode,
      body: o,
      index: n
    };
  },
  htmlBuilder(e, t) {
    var i = ii(e.body, t.havingCrampedStyle());
    i.height === 0 && (i.height = t.fontMetrics().xHeight), i = ve.wrapFragment(i, t);
    var r = t.fontMetrics(), n = r.defaultRuleThickness, o = n;
    t.style.id < bt.TEXT.id && (o = t.fontMetrics().xHeight);
    var s = n + o / 4, a = i.height + i.depth + s + n, {
      span: l,
      ruleWidth: c,
      advanceWidth: u
    } = wa.sqrtImage(a, t), m = l.height - c;
    m > i.height + i.depth + s && (s = (s + m - i.height - i.depth) / 2);
    var g = l.height - i.height - s - c;
    i.style.paddingLeft = He(u);
    var h = ve.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: i,
        wrapperClasses: ["svg-align"]
      }, {
        type: "kern",
        size: -(i.height + g)
      }, {
        type: "elem",
        elem: l
      }, {
        type: "kern",
        size: c
      }]
    }, t);
    if (e.index) {
      var A = t.havingStyle(bt.SCRIPTSCRIPT), y = ii(e.index, A, t), E = 0.6 * (h.height - h.depth), v = ve.makeVList({
        positionType: "shift",
        positionData: -E,
        children: [{
          type: "elem",
          elem: y
        }]
      }, t), C = ve.makeSpan(["root"], [v]);
      return ve.makeSpan(["mord", "sqrt"], [C, h], t);
    } else
      return ve.makeSpan(["mord", "sqrt"], [h], t);
  },
  mathmlBuilder(e, t) {
    var {
      body: i,
      index: r
    } = e;
    return r ? new Ge.MathNode("mroot", [Si(i, t), Si(r, t)]) : new Ge.MathNode("msqrt", [Si(i, t)]);
  }
});
var I4 = {
  display: bt.DISPLAY,
  text: bt.TEXT,
  script: bt.SCRIPT,
  scriptscript: bt.SCRIPTSCRIPT
};
rt({
  type: "styling",
  names: ["\\displaystyle", "\\textstyle", "\\scriptstyle", "\\scriptscriptstyle"],
  props: {
    numArgs: 0,
    allowedInText: !0,
    primitive: !0
  },
  handler(e, t) {
    var {
      breakOnTokenText: i,
      funcName: r,
      parser: n
    } = e, o = n.parseExpression(!0, i), s = r.slice(1, r.length - 5);
    return {
      type: "styling",
      mode: n.mode,
      // Figure out what style to use by pulling out the style from
      // the function name
      style: s,
      body: o
    };
  },
  htmlBuilder(e, t) {
    var i = I4[e.style], r = t.havingStyle(i).withFont("");
    return pD(e.body, r, t);
  },
  mathmlBuilder(e, t) {
    var i = I4[e.style], r = t.havingStyle(i), n = zn(e.body, r), o = new Ge.MathNode("mstyle", n), s = {
      display: ["0", "true"],
      text: ["0", "false"],
      script: ["1", "false"],
      scriptscript: ["2", "false"]
    }, a = s[e.style];
    return o.setAttribute("scriptlevel", a[0]), o.setAttribute("displaystyle", a[1]), o;
  }
});
var D$ = function(t, i) {
  var r = t.base;
  if (r)
    if (r.type === "op") {
      var n = r.limits && (i.style.size === bt.DISPLAY.size || r.alwaysHandleSupSub);
      return n ? Z0 : null;
    } else if (r.type === "operatorname") {
      var o = r.alwaysHandleSupSub && (i.style.size === bt.DISPLAY.size || r.limits);
      return o ? hD : null;
    } else {
      if (r.type === "accent")
        return Rt.isCharacterBox(r.base) ? P2 : null;
      if (r.type === "horizBrace") {
        var s = !t.sub;
        return s === r.isOver ? dD : null;
      } else
        return null;
    }
  else
    return null;
};
ru({
  type: "supsub",
  htmlBuilder(e, t) {
    var i = D$(e, t);
    if (i)
      return i(e, t);
    var {
      base: r,
      sup: n,
      sub: o
    } = e, s = ii(r, t), a, l, c = t.fontMetrics(), u = 0, m = 0, g = r && Rt.isCharacterBox(r);
    if (n) {
      var h = t.havingStyle(t.style.sup());
      a = ii(n, h, t), g || (u = s.height - h.fontMetrics().supDrop * h.sizeMultiplier / t.sizeMultiplier);
    }
    if (o) {
      var A = t.havingStyle(t.style.sub());
      l = ii(o, A, t), g || (m = s.depth + A.fontMetrics().subDrop * A.sizeMultiplier / t.sizeMultiplier);
    }
    var y;
    t.style === bt.DISPLAY ? y = c.sup1 : t.style.cramped ? y = c.sup3 : y = c.sup2;
    var E = t.sizeMultiplier, v = He(0.5 / c.ptPerEm / E), C = null;
    if (l) {
      var x = e.base && e.base.type === "op" && e.base.name && (e.base.name === "\\oiint" || e.base.name === "\\oiiint");
      (s instanceof Zo || x) && (C = He(-s.italic));
    }
    var S;
    if (a && l) {
      u = Math.max(u, y, a.depth + 0.25 * c.xHeight), m = Math.max(m, c.sub2);
      var R = c.defaultRuleThickness, w = 4 * R;
      if (u - a.depth - (l.height - m) < w) {
        m = w - (u - a.depth) + l.height;
        var T = 0.8 * c.xHeight - (u - a.depth);
        T > 0 && (u += T, m -= T);
      }
      var N = [{
        type: "elem",
        elem: l,
        shift: m,
        marginRight: v,
        marginLeft: C
      }, {
        type: "elem",
        elem: a,
        shift: -u,
        marginRight: v
      }];
      S = ve.makeVList({
        positionType: "individualShift",
        children: N
      }, t);
    } else if (l) {
      m = Math.max(m, c.sub1, l.height - 0.8 * c.xHeight);
      var D = [{
        type: "elem",
        elem: l,
        marginLeft: C,
        marginRight: v
      }];
      S = ve.makeVList({
        positionType: "shift",
        positionData: m,
        children: D
      }, t);
    } else if (a)
      u = Math.max(u, y, a.depth + 0.25 * c.xHeight), S = ve.makeVList({
        positionType: "shift",
        positionData: -u,
        children: [{
          type: "elem",
          elem: a,
          marginRight: v
        }]
      }, t);
    else
      throw new Error("supsub must have either sup or sub.");
    var O = Lb(s, "right") || "mord";
    return ve.makeSpan([O], [s, ve.makeSpan(["msupsub"], [S])], t);
  },
  mathmlBuilder(e, t) {
    var i = !1, r, n;
    e.base && e.base.type === "horizBrace" && (n = !!e.sup, n === e.base.isOver && (i = !0, r = e.base.isOver)), e.base && (e.base.type === "op" || e.base.type === "operatorname") && (e.base.parentIsSupSub = !0);
    var o = [Si(e.base, t)];
    e.sub && o.push(Si(e.sub, t)), e.sup && o.push(Si(e.sup, t));
    var s;
    if (i)
      s = r ? "mover" : "munder";
    else if (e.sub)
      if (e.sup) {
        var c = e.base;
        c && c.type === "op" && c.limits && t.style === bt.DISPLAY || c && c.type === "operatorname" && c.alwaysHandleSupSub && (t.style === bt.DISPLAY || c.limits) ? s = "munderover" : s = "msubsup";
      } else {
        var l = e.base;
        l && l.type === "op" && l.limits && (t.style === bt.DISPLAY || l.alwaysHandleSupSub) || l && l.type === "operatorname" && l.alwaysHandleSupSub && (l.limits || t.style === bt.DISPLAY) ? s = "munder" : s = "msub";
      }
    else {
      var a = e.base;
      a && a.type === "op" && a.limits && (t.style === bt.DISPLAY || a.alwaysHandleSupSub) || a && a.type === "operatorname" && a.alwaysHandleSupSub && (a.limits || t.style === bt.DISPLAY) ? s = "mover" : s = "msup";
    }
    return new Ge.MathNode(s, o);
  }
});
ru({
  type: "atom",
  htmlBuilder(e, t) {
    return ve.mathsym(e.text, e.mode, t, ["m" + e.family]);
  },
  mathmlBuilder(e, t) {
    var i = new Ge.MathNode("mo", [Jo(e.text, e.mode)]);
    if (e.family === "bin") {
      var r = Z2(e, t);
      r === "bold-italic" && i.setAttribute("mathvariant", r);
    } else
      e.family === "punct" ? i.setAttribute("separator", "true") : (e.family === "open" || e.family === "close") && i.setAttribute("stretchy", "false");
    return i;
  }
});
var fD = {
  mi: "italic",
  mn: "normal",
  mtext: "normal"
};
ru({
  type: "mathord",
  htmlBuilder(e, t) {
    return ve.makeOrd(e, t, "mathord");
  },
  mathmlBuilder(e, t) {
    var i = new Ge.MathNode("mi", [Jo(e.text, e.mode, t)]), r = Z2(e, t) || "italic";
    return r !== fD[i.type] && i.setAttribute("mathvariant", r), i;
  }
});
ru({
  type: "textord",
  htmlBuilder(e, t) {
    return ve.makeOrd(e, t, "textord");
  },
  mathmlBuilder(e, t) {
    var i = Jo(e.text, e.mode, t), r = Z2(e, t) || "normal", n;
    return e.mode === "text" ? n = new Ge.MathNode("mtext", [i]) : /[0-9]/.test(e.text) ? n = new Ge.MathNode("mn", [i]) : e.text === "\\prime" ? n = new Ge.MathNode("mo", [i]) : n = new Ge.MathNode("mi", [i]), r !== fD[n.type] && n.setAttribute("mathvariant", r), n;
  }
});
var aE = {
  "\\nobreak": "nobreak",
  "\\allowbreak": "allowbreak"
}, lE = {
  " ": {},
  "\\ ": {},
  "~": {
    className: "nobreak"
  },
  "\\space": {},
  "\\nobreakspace": {
    className: "nobreak"
  }
};
ru({
  type: "spacing",
  htmlBuilder(e, t) {
    if (lE.hasOwnProperty(e.text)) {
      var i = lE[e.text].className || "";
      if (e.mode === "text") {
        var r = ve.makeOrd(e, t, "textord");
        return r.classes.push(i), r;
      } else
        return ve.makeSpan(["mspace", i], [ve.mathsym(e.text, e.mode, t)], t);
    } else {
      if (aE.hasOwnProperty(e.text))
        return ve.makeSpan(["mspace", aE[e.text]], [], t);
      throw new We('Unknown type of space "' + e.text + '"');
    }
  },
  mathmlBuilder(e, t) {
    var i;
    if (lE.hasOwnProperty(e.text))
      i = new Ge.MathNode("mtext", [new Ge.TextNode(" ")]);
    else {
      if (aE.hasOwnProperty(e.text))
        return new Ge.MathNode("mspace");
      throw new We('Unknown type of space "' + e.text + '"');
    }
    return i;
  }
});
var S4 = () => {
  var e = new Ge.MathNode("mtd", []);
  return e.setAttribute("width", "50%"), e;
};
ru({
  type: "tag",
  mathmlBuilder(e, t) {
    var i = new Ge.MathNode("mtable", [new Ge.MathNode("mtr", [S4(), new Ge.MathNode("mtd", [ql(e.body, t)]), S4(), new Ge.MathNode("mtd", [ql(e.tag, t)])])]);
    return i.setAttribute("width", "100%"), i;
  }
});
var R4 = {
  "\\text": void 0,
  "\\textrm": "textrm",
  "\\textsf": "textsf",
  "\\texttt": "texttt",
  "\\textnormal": "textrm"
}, k4 = {
  "\\textbf": "textbf",
  "\\textmd": "textmd"
}, O$ = {
  "\\textit": "textit",
  "\\textup": "textup"
}, w4 = (e, t) => {
  var i = e.font;
  return i ? R4[i] ? t.withTextFontFamily(R4[i]) : k4[i] ? t.withTextFontWeight(k4[i]) : t.withTextFontShape(O$[i]) : t;
};
rt({
  type: "text",
  names: [
    // Font families
    "\\text",
    "\\textrm",
    "\\textsf",
    "\\texttt",
    "\\textnormal",
    // Font weights
    "\\textbf",
    "\\textmd",
    // Font Shapes
    "\\textit",
    "\\textup"
  ],
  props: {
    numArgs: 1,
    argTypes: ["text"],
    allowedInArgument: !0,
    allowedInText: !0
  },
  handler(e, t) {
    var {
      parser: i,
      funcName: r
    } = e, n = t[0];
    return {
      type: "text",
      mode: i.mode,
      body: dr(n),
      font: r
    };
  },
  htmlBuilder(e, t) {
    var i = w4(e, t), r = Ir(e.body, i, !0);
    return ve.makeSpan(["mord", "text"], r, i);
  },
  mathmlBuilder(e, t) {
    var i = w4(e, t);
    return ql(e.body, i);
  }
});
rt({
  type: "underline",
  names: ["\\underline"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler(e, t) {
    var {
      parser: i
    } = e;
    return {
      type: "underline",
      mode: i.mode,
      body: t[0]
    };
  },
  htmlBuilder(e, t) {
    var i = ii(e.body, t), r = ve.makeLineSpan("underline-line", t), n = t.fontMetrics().defaultRuleThickness, o = ve.makeVList({
      positionType: "top",
      positionData: i.height,
      children: [{
        type: "kern",
        size: n
      }, {
        type: "elem",
        elem: r
      }, {
        type: "kern",
        size: 3 * n
      }, {
        type: "elem",
        elem: i
      }]
    }, t);
    return ve.makeSpan(["mord", "underline"], [o], t);
  },
  mathmlBuilder(e, t) {
    var i = new Ge.MathNode("mo", [new Ge.TextNode("‾")]);
    i.setAttribute("stretchy", "true");
    var r = new Ge.MathNode("munder", [Si(e.body, t), i]);
    return r.setAttribute("accentunder", "true"), r;
  }
});
rt({
  type: "vcenter",
  names: ["\\vcenter"],
  props: {
    numArgs: 1,
    argTypes: ["original"],
    // In LaTeX, \vcenter can act only on a box.
    allowedInText: !1
  },
  handler(e, t) {
    var {
      parser: i
    } = e;
    return {
      type: "vcenter",
      mode: i.mode,
      body: t[0]
    };
  },
  htmlBuilder(e, t) {
    var i = ii(e.body, t), r = t.fontMetrics().axisHeight, n = 0.5 * (i.height - r - (i.depth + r));
    return ve.makeVList({
      positionType: "shift",
      positionData: n,
      children: [{
        type: "elem",
        elem: i
      }]
    }, t);
  },
  mathmlBuilder(e, t) {
    return new Ge.MathNode("mpadded", [Si(e.body, t)], ["vcenter"]);
  }
});
rt({
  type: "verb",
  names: ["\\verb"],
  props: {
    numArgs: 0,
    allowedInText: !0
  },
  handler(e, t, i) {
    throw new We("\\verb ended by end of line instead of matching delimiter");
  },
  htmlBuilder(e, t) {
    for (var i = M4(e), r = [], n = t.havingStyle(t.style.text()), o = 0; o < i.length; o++) {
      var s = i[o];
      s === "~" && (s = "\\textasciitilde"), r.push(ve.makeSymbol(s, "Typewriter-Regular", e.mode, n, ["mord", "texttt"]));
    }
    return ve.makeSpan(["mord", "text"].concat(n.sizingClasses(t)), ve.tryCombineChars(r), n);
  },
  mathmlBuilder(e, t) {
    var i = new Ge.TextNode(M4(e)), r = new Ge.MathNode("mtext", [i]);
    return r.setAttribute("mathvariant", "monospace"), r;
  }
});
var M4 = (e) => e.body.replace(/ /g, e.star ? "␣" : " "), El = L7, AD = `[ \r
	]`, F$ = "\\\\[a-zA-Z@]+", V$ = "\\\\[^\uD800-\uDFFF]", q$ = "(" + F$ + ")" + AD + "*", j$ = `\\\\(
|[ \r	]+
?)[ \r	]*`, Gb = "[̀-ͯ]", L$ = new RegExp(Gb + "+$"), K$ = "(" + AD + "+)|" + // whitespace
(j$ + "|") + // \whitespace
"([!-\\[\\]-‧‪-퟿豈-￿]" + // single codepoint
(Gb + "*") + // ...plus accents
"|[\uD800-\uDBFF][\uDC00-\uDFFF]" + // surrogate pair
(Gb + "*") + // ...plus accents
"|\\\\verb\\*([^]).*?\\4|\\\\verb([^*a-zA-Z]).*?\\5" + // \verb unstarred
("|" + q$) + // \macroName + spaces
("|" + V$ + ")");
class N4 {
  // Category codes. The lexer only supports comment characters (14) for now.
  // MacroExpander additionally distinguishes active (13).
  constructor(t, i) {
    this.input = void 0, this.settings = void 0, this.tokenRegex = void 0, this.catcodes = void 0, this.input = t, this.settings = i, this.tokenRegex = new RegExp(K$, "g"), this.catcodes = {
      "%": 14,
      // comment character
      "~": 13
      // active character
    };
  }
  setCatcode(t, i) {
    this.catcodes[t] = i;
  }
  /**
   * This function lexes a single token.
   */
  lex() {
    var t = this.input, i = this.tokenRegex.lastIndex;
    if (i === t.length)
      return new js("EOF", new uo(this, i, i));
    var r = this.tokenRegex.exec(t);
    if (r === null || r.index !== i)
      throw new We("Unexpected character: '" + t[i] + "'", new js(t[i], new uo(this, i, i + 1)));
    var n = r[6] || r[3] || (r[2] ? "\\ " : " ");
    if (this.catcodes[n] === 14) {
      var o = t.indexOf(`
`, this.tokenRegex.lastIndex);
      return o === -1 ? (this.tokenRegex.lastIndex = t.length, this.settings.reportNonstrict("commentAtEnd", "% comment has no terminating newline; LaTeX would fail because of commenting the end of math mode (e.g. $)")) : this.tokenRegex.lastIndex = o + 1, this.lex();
    }
    return new js(n, new uo(this, i, this.tokenRegex.lastIndex));
  }
}
class Y$ {
  /**
   * Both arguments are optional.  The first argument is an object of
   * built-in mappings which never change.  The second argument is an object
   * of initial (global-level) mappings, which will constantly change
   * according to any global/top-level `set`s done.
   */
  constructor(t, i) {
    t === void 0 && (t = {}), i === void 0 && (i = {}), this.current = void 0, this.builtins = void 0, this.undefStack = void 0, this.current = i, this.builtins = t, this.undefStack = [];
  }
  /**
   * Start a new nested group, affecting future local `set`s.
   */
  beginGroup() {
    this.undefStack.push({});
  }
  /**
   * End current nested group, restoring values before the group began.
   */
  endGroup() {
    if (this.undefStack.length === 0)
      throw new We("Unbalanced namespace destruction: attempt to pop global namespace; please report this as a bug");
    var t = this.undefStack.pop();
    for (var i in t)
      t.hasOwnProperty(i) && (t[i] == null ? delete this.current[i] : this.current[i] = t[i]);
  }
  /**
   * Ends all currently nested groups (if any), restoring values before the
   * groups began.  Useful in case of an error in the middle of parsing.
   */
  endGroups() {
    for (; this.undefStack.length > 0; )
      this.endGroup();
  }
  /**
   * Detect whether `name` has a definition.  Equivalent to
   * `get(name) != null`.
   */
  has(t) {
    return this.current.hasOwnProperty(t) || this.builtins.hasOwnProperty(t);
  }
  /**
   * Get the current value of a name, or `undefined` if there is no value.
   *
   * Note: Do not use `if (namespace.get(...))` to detect whether a macro
   * is defined, as the definition may be the empty string which evaluates
   * to `false` in JavaScript.  Use `if (namespace.get(...) != null)` or
   * `if (namespace.has(...))`.
   */
  get(t) {
    return this.current.hasOwnProperty(t) ? this.current[t] : this.builtins[t];
  }
  /**
   * Set the current value of a name, and optionally set it globally too.
   * Local set() sets the current value and (when appropriate) adds an undo
   * operation to the undo stack.  Global set() may change the undo
   * operation at every level, so takes time linear in their number.
   * A value of undefined means to delete existing definitions.
   */
  set(t, i, r) {
    if (r === void 0 && (r = !1), r) {
      for (var n = 0; n < this.undefStack.length; n++)
        delete this.undefStack[n][t];
      this.undefStack.length > 0 && (this.undefStack[this.undefStack.length - 1][t] = i);
    } else {
      var o = this.undefStack[this.undefStack.length - 1];
      o && !o.hasOwnProperty(t) && (o[t] = this.current[t]);
    }
    i == null ? delete this.current[t] : this.current[t] = i;
  }
}
var U$ = sD;
G("\\noexpand", function(e) {
  var t = e.popToken();
  return e.isExpandable(t.text) && (t.noexpand = !0, t.treatAsRelax = !0), {
    tokens: [t],
    numArgs: 0
  };
});
G("\\expandafter", function(e) {
  var t = e.popToken();
  return e.expandOnce(!0), {
    tokens: [t],
    numArgs: 0
  };
});
G("\\@firstoftwo", function(e) {
  var t = e.consumeArgs(2);
  return {
    tokens: t[0],
    numArgs: 0
  };
});
G("\\@secondoftwo", function(e) {
  var t = e.consumeArgs(2);
  return {
    tokens: t[1],
    numArgs: 0
  };
});
G("\\@ifnextchar", function(e) {
  var t = e.consumeArgs(3);
  e.consumeSpaces();
  var i = e.future();
  return t[0].length === 1 && t[0][0].text === i.text ? {
    tokens: t[1],
    numArgs: 0
  } : {
    tokens: t[2],
    numArgs: 0
  };
});
G("\\@ifstar", "\\@ifnextchar *{\\@firstoftwo{#1}}");
G("\\TextOrMath", function(e) {
  var t = e.consumeArgs(2);
  return e.mode === "text" ? {
    tokens: t[0],
    numArgs: 0
  } : {
    tokens: t[1],
    numArgs: 0
  };
});
var T4 = {
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  a: 10,
  A: 10,
  b: 11,
  B: 11,
  c: 12,
  C: 12,
  d: 13,
  D: 13,
  e: 14,
  E: 14,
  f: 15,
  F: 15
};
G("\\char", function(e) {
  var t = e.popToken(), i, r = "";
  if (t.text === "'")
    i = 8, t = e.popToken();
  else if (t.text === '"')
    i = 16, t = e.popToken();
  else if (t.text === "`")
    if (t = e.popToken(), t.text[0] === "\\")
      r = t.text.charCodeAt(1);
    else {
      if (t.text === "EOF")
        throw new We("\\char` missing argument");
      r = t.text.charCodeAt(0);
    }
  else
    i = 10;
  if (i) {
    if (r = T4[t.text], r == null || r >= i)
      throw new We("Invalid base-" + i + " digit " + t.text);
    for (var n; (n = T4[e.future().text]) != null && n < i; )
      r *= i, r += n, e.popToken();
  }
  return "\\@char{" + r + "}";
});
var ix = (e, t, i) => {
  var r = e.consumeArg().tokens;
  if (r.length !== 1)
    throw new We("\\newcommand's first argument must be a macro name");
  var n = r[0].text, o = e.isDefined(n);
  if (o && !t)
    throw new We("\\newcommand{" + n + "} attempting to redefine " + (n + "; use \\renewcommand"));
  if (!o && !i)
    throw new We("\\renewcommand{" + n + "} when command " + n + " does not yet exist; use \\newcommand");
  var s = 0;
  if (r = e.consumeArg().tokens, r.length === 1 && r[0].text === "[") {
    for (var a = "", l = e.expandNextToken(); l.text !== "]" && l.text !== "EOF"; )
      a += l.text, l = e.expandNextToken();
    if (!a.match(/^\s*[0-9]+\s*$/))
      throw new We("Invalid number of arguments: " + a);
    s = parseInt(a), r = e.consumeArg().tokens;
  }
  return e.macros.set(n, {
    tokens: r,
    numArgs: s
  }), "";
};
G("\\newcommand", (e) => ix(e, !1, !0));
G("\\renewcommand", (e) => ix(e, !0, !1));
G("\\providecommand", (e) => ix(e, !0, !0));
G("\\message", (e) => {
  var t = e.consumeArgs(1)[0];
  return console.log(t.reverse().map((i) => i.text).join("")), "";
});
G("\\errmessage", (e) => {
  var t = e.consumeArgs(1)[0];
  return console.error(t.reverse().map((i) => i.text).join("")), "";
});
G("\\show", (e) => {
  var t = e.popToken(), i = t.text;
  return console.log(t, e.macros.get(i), El[i], Mi.math[i], Mi.text[i]), "";
});
G("\\bgroup", "{");
G("\\egroup", "}");
G("~", "\\nobreakspace");
G("\\lq", "`");
G("\\rq", "'");
G("\\aa", "\\r a");
G("\\AA", "\\r A");
G("\\textcopyright", "\\html@mathml{\\textcircled{c}}{\\char`©}");
G("\\copyright", "\\TextOrMath{\\textcopyright}{\\text{\\textcopyright}}");
G("\\textregistered", "\\html@mathml{\\textcircled{\\scriptsize R}}{\\char`®}");
G("ℬ", "\\mathscr{B}");
G("ℰ", "\\mathscr{E}");
G("ℱ", "\\mathscr{F}");
G("ℋ", "\\mathscr{H}");
G("ℐ", "\\mathscr{I}");
G("ℒ", "\\mathscr{L}");
G("ℳ", "\\mathscr{M}");
G("ℛ", "\\mathscr{R}");
G("ℭ", "\\mathfrak{C}");
G("ℌ", "\\mathfrak{H}");
G("ℨ", "\\mathfrak{Z}");
G("\\Bbbk", "\\Bbb{k}");
G("·", "\\cdotp");
G("\\llap", "\\mathllap{\\textrm{#1}}");
G("\\rlap", "\\mathrlap{\\textrm{#1}}");
G("\\clap", "\\mathclap{\\textrm{#1}}");
G("\\mathstrut", "\\vphantom{(}");
G("\\underbar", "\\underline{\\text{#1}}");
G("\\not", '\\html@mathml{\\mathrel{\\mathrlap\\@not}}{\\char"338}');
G("\\neq", "\\html@mathml{\\mathrel{\\not=}}{\\mathrel{\\char`≠}}");
G("\\ne", "\\neq");
G("≠", "\\neq");
G("\\notin", "\\html@mathml{\\mathrel{{\\in}\\mathllap{/\\mskip1mu}}}{\\mathrel{\\char`∉}}");
G("∉", "\\notin");
G("≘", "\\html@mathml{\\mathrel{=\\kern{-1em}\\raisebox{0.4em}{$\\scriptsize\\frown$}}}{\\mathrel{\\char`≘}}");
G("≙", "\\html@mathml{\\stackrel{\\tiny\\wedge}{=}}{\\mathrel{\\char`≘}}");
G("≚", "\\html@mathml{\\stackrel{\\tiny\\vee}{=}}{\\mathrel{\\char`≚}}");
G("≛", "\\html@mathml{\\stackrel{\\scriptsize\\star}{=}}{\\mathrel{\\char`≛}}");
G("≝", "\\html@mathml{\\stackrel{\\tiny\\mathrm{def}}{=}}{\\mathrel{\\char`≝}}");
G("≞", "\\html@mathml{\\stackrel{\\tiny\\mathrm{m}}{=}}{\\mathrel{\\char`≞}}");
G("≟", "\\html@mathml{\\stackrel{\\tiny?}{=}}{\\mathrel{\\char`≟}}");
G("⟂", "\\perp");
G("‼", "\\mathclose{!\\mkern-0.8mu!}");
G("∌", "\\notni");
G("⌜", "\\ulcorner");
G("⌝", "\\urcorner");
G("⌞", "\\llcorner");
G("⌟", "\\lrcorner");
G("©", "\\copyright");
G("®", "\\textregistered");
G("️", "\\textregistered");
G("\\ulcorner", '\\html@mathml{\\@ulcorner}{\\mathop{\\char"231c}}');
G("\\urcorner", '\\html@mathml{\\@urcorner}{\\mathop{\\char"231d}}');
G("\\llcorner", '\\html@mathml{\\@llcorner}{\\mathop{\\char"231e}}');
G("\\lrcorner", '\\html@mathml{\\@lrcorner}{\\mathop{\\char"231f}}');
G("\\vdots", "\\mathord{\\varvdots\\rule{0pt}{15pt}}");
G("⋮", "\\vdots");
G("\\varGamma", "\\mathit{\\Gamma}");
G("\\varDelta", "\\mathit{\\Delta}");
G("\\varTheta", "\\mathit{\\Theta}");
G("\\varLambda", "\\mathit{\\Lambda}");
G("\\varXi", "\\mathit{\\Xi}");
G("\\varPi", "\\mathit{\\Pi}");
G("\\varSigma", "\\mathit{\\Sigma}");
G("\\varUpsilon", "\\mathit{\\Upsilon}");
G("\\varPhi", "\\mathit{\\Phi}");
G("\\varPsi", "\\mathit{\\Psi}");
G("\\varOmega", "\\mathit{\\Omega}");
G("\\substack", "\\begin{subarray}{c}#1\\end{subarray}");
G("\\colon", "\\nobreak\\mskip2mu\\mathpunct{}\\mathchoice{\\mkern-3mu}{\\mkern-3mu}{}{}{:}\\mskip6mu\\relax");
G("\\boxed", "\\fbox{$\\displaystyle{#1}$}");
G("\\iff", "\\DOTSB\\;\\Longleftrightarrow\\;");
G("\\implies", "\\DOTSB\\;\\Longrightarrow\\;");
G("\\impliedby", "\\DOTSB\\;\\Longleftarrow\\;");
var B4 = {
  ",": "\\dotsc",
  "\\not": "\\dotsb",
  // \keybin@ checks for the following:
  "+": "\\dotsb",
  "=": "\\dotsb",
  "<": "\\dotsb",
  ">": "\\dotsb",
  "-": "\\dotsb",
  "*": "\\dotsb",
  ":": "\\dotsb",
  // Symbols whose definition starts with \DOTSB:
  "\\DOTSB": "\\dotsb",
  "\\coprod": "\\dotsb",
  "\\bigvee": "\\dotsb",
  "\\bigwedge": "\\dotsb",
  "\\biguplus": "\\dotsb",
  "\\bigcap": "\\dotsb",
  "\\bigcup": "\\dotsb",
  "\\prod": "\\dotsb",
  "\\sum": "\\dotsb",
  "\\bigotimes": "\\dotsb",
  "\\bigoplus": "\\dotsb",
  "\\bigodot": "\\dotsb",
  "\\bigsqcup": "\\dotsb",
  "\\And": "\\dotsb",
  "\\longrightarrow": "\\dotsb",
  "\\Longrightarrow": "\\dotsb",
  "\\longleftarrow": "\\dotsb",
  "\\Longleftarrow": "\\dotsb",
  "\\longleftrightarrow": "\\dotsb",
  "\\Longleftrightarrow": "\\dotsb",
  "\\mapsto": "\\dotsb",
  "\\longmapsto": "\\dotsb",
  "\\hookrightarrow": "\\dotsb",
  "\\doteq": "\\dotsb",
  // Symbols whose definition starts with \mathbin:
  "\\mathbin": "\\dotsb",
  // Symbols whose definition starts with \mathrel:
  "\\mathrel": "\\dotsb",
  "\\relbar": "\\dotsb",
  "\\Relbar": "\\dotsb",
  "\\xrightarrow": "\\dotsb",
  "\\xleftarrow": "\\dotsb",
  // Symbols whose definition starts with \DOTSI:
  "\\DOTSI": "\\dotsi",
  "\\int": "\\dotsi",
  "\\oint": "\\dotsi",
  "\\iint": "\\dotsi",
  "\\iiint": "\\dotsi",
  "\\iiiint": "\\dotsi",
  "\\idotsint": "\\dotsi",
  // Symbols whose definition starts with \DOTSX:
  "\\DOTSX": "\\dotsx"
};
G("\\dots", function(e) {
  var t = "\\dotso", i = e.expandAfterFuture().text;
  return i in B4 ? t = B4[i] : (i.slice(0, 4) === "\\not" || i in Mi.math && Rt.contains(["bin", "rel"], Mi.math[i].group)) && (t = "\\dotsb"), t;
});
var rx = {
  // \rightdelim@ checks for the following:
  ")": !0,
  "]": !0,
  "\\rbrack": !0,
  "\\}": !0,
  "\\rbrace": !0,
  "\\rangle": !0,
  "\\rceil": !0,
  "\\rfloor": !0,
  "\\rgroup": !0,
  "\\rmoustache": !0,
  "\\right": !0,
  "\\bigr": !0,
  "\\biggr": !0,
  "\\Bigr": !0,
  "\\Biggr": !0,
  // \extra@ also tests for the following:
  $: !0,
  // \extrap@ checks for the following:
  ";": !0,
  ".": !0,
  ",": !0
};
G("\\dotso", function(e) {
  var t = e.future().text;
  return t in rx ? "\\ldots\\," : "\\ldots";
});
G("\\dotsc", function(e) {
  var t = e.future().text;
  return t in rx && t !== "," ? "\\ldots\\," : "\\ldots";
});
G("\\cdots", function(e) {
  var t = e.future().text;
  return t in rx ? "\\@cdots\\," : "\\@cdots";
});
G("\\dotsb", "\\cdots");
G("\\dotsm", "\\cdots");
G("\\dotsi", "\\!\\cdots");
G("\\dotsx", "\\ldots\\,");
G("\\DOTSI", "\\relax");
G("\\DOTSB", "\\relax");
G("\\DOTSX", "\\relax");
G("\\tmspace", "\\TextOrMath{\\kern#1#3}{\\mskip#1#2}\\relax");
G("\\,", "\\tmspace+{3mu}{.1667em}");
G("\\thinspace", "\\,");
G("\\>", "\\mskip{4mu}");
G("\\:", "\\tmspace+{4mu}{.2222em}");
G("\\medspace", "\\:");
G("\\;", "\\tmspace+{5mu}{.2777em}");
G("\\thickspace", "\\;");
G("\\!", "\\tmspace-{3mu}{.1667em}");
G("\\negthinspace", "\\!");
G("\\negmedspace", "\\tmspace-{4mu}{.2222em}");
G("\\negthickspace", "\\tmspace-{5mu}{.277em}");
G("\\enspace", "\\kern.5em ");
G("\\enskip", "\\hskip.5em\\relax");
G("\\quad", "\\hskip1em\\relax");
G("\\qquad", "\\hskip2em\\relax");
G("\\tag", "\\@ifstar\\tag@literal\\tag@paren");
G("\\tag@paren", "\\tag@literal{({#1})}");
G("\\tag@literal", (e) => {
  if (e.macros.get("\\df@tag"))
    throw new We("Multiple \\tag");
  return "\\gdef\\df@tag{\\text{#1}}";
});
G("\\bmod", "\\mathchoice{\\mskip1mu}{\\mskip1mu}{\\mskip5mu}{\\mskip5mu}\\mathbin{\\rm mod}\\mathchoice{\\mskip1mu}{\\mskip1mu}{\\mskip5mu}{\\mskip5mu}");
G("\\pod", "\\allowbreak\\mathchoice{\\mkern18mu}{\\mkern8mu}{\\mkern8mu}{\\mkern8mu}(#1)");
G("\\pmod", "\\pod{{\\rm mod}\\mkern6mu#1}");
G("\\mod", "\\allowbreak\\mathchoice{\\mkern18mu}{\\mkern12mu}{\\mkern12mu}{\\mkern12mu}{\\rm mod}\\,\\,#1");
G("\\newline", "\\\\\\relax");
G("\\TeX", "\\textrm{\\html@mathml{T\\kern-.1667em\\raisebox{-.5ex}{E}\\kern-.125emX}{TeX}}");
var yD = He(Vs["Main-Regular"]["T".charCodeAt(0)][1] - 0.7 * Vs["Main-Regular"]["A".charCodeAt(0)][1]);
G("\\LaTeX", "\\textrm{\\html@mathml{" + ("L\\kern-.36em\\raisebox{" + yD + "}{\\scriptstyle A}") + "\\kern-.15em\\TeX}{LaTeX}}");
G("\\KaTeX", "\\textrm{\\html@mathml{" + ("K\\kern-.17em\\raisebox{" + yD + "}{\\scriptstyle A}") + "\\kern-.15em\\TeX}{KaTeX}}");
G("\\hspace", "\\@ifstar\\@hspacer\\@hspace");
G("\\@hspace", "\\hskip #1\\relax");
G("\\@hspacer", "\\rule{0pt}{0pt}\\hskip #1\\relax");
G("\\ordinarycolon", ":");
G("\\vcentcolon", "\\mathrel{\\mathop\\ordinarycolon}");
G("\\dblcolon", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-.9mu}\\vcentcolon}}{\\mathop{\\char"2237}}');
G("\\coloneqq", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}=}}{\\mathop{\\char"2254}}');
G("\\Coloneqq", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}=}}{\\mathop{\\char"2237\\char"3d}}');
G("\\coloneq", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}\\mathrel{-}}}{\\mathop{\\char"3a\\char"2212}}');
G("\\Coloneq", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}\\mathrel{-}}}{\\mathop{\\char"2237\\char"2212}}');
G("\\eqqcolon", '\\html@mathml{\\mathrel{=\\mathrel{\\mkern-1.2mu}\\vcentcolon}}{\\mathop{\\char"2255}}');
G("\\Eqqcolon", '\\html@mathml{\\mathrel{=\\mathrel{\\mkern-1.2mu}\\dblcolon}}{\\mathop{\\char"3d\\char"2237}}');
G("\\eqcolon", '\\html@mathml{\\mathrel{\\mathrel{-}\\mathrel{\\mkern-1.2mu}\\vcentcolon}}{\\mathop{\\char"2239}}');
G("\\Eqcolon", '\\html@mathml{\\mathrel{\\mathrel{-}\\mathrel{\\mkern-1.2mu}\\dblcolon}}{\\mathop{\\char"2212\\char"2237}}');
G("\\colonapprox", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}\\approx}}{\\mathop{\\char"3a\\char"2248}}');
G("\\Colonapprox", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}\\approx}}{\\mathop{\\char"2237\\char"2248}}');
G("\\colonsim", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}\\sim}}{\\mathop{\\char"3a\\char"223c}}');
G("\\Colonsim", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}\\sim}}{\\mathop{\\char"2237\\char"223c}}');
G("∷", "\\dblcolon");
G("∹", "\\eqcolon");
G("≔", "\\coloneqq");
G("≕", "\\eqqcolon");
G("⩴", "\\Coloneqq");
G("\\ratio", "\\vcentcolon");
G("\\coloncolon", "\\dblcolon");
G("\\colonequals", "\\coloneqq");
G("\\coloncolonequals", "\\Coloneqq");
G("\\equalscolon", "\\eqqcolon");
G("\\equalscoloncolon", "\\Eqqcolon");
G("\\colonminus", "\\coloneq");
G("\\coloncolonminus", "\\Coloneq");
G("\\minuscolon", "\\eqcolon");
G("\\minuscoloncolon", "\\Eqcolon");
G("\\coloncolonapprox", "\\Colonapprox");
G("\\coloncolonsim", "\\Colonsim");
G("\\simcolon", "\\mathrel{\\sim\\mathrel{\\mkern-1.2mu}\\vcentcolon}");
G("\\simcoloncolon", "\\mathrel{\\sim\\mathrel{\\mkern-1.2mu}\\dblcolon}");
G("\\approxcolon", "\\mathrel{\\approx\\mathrel{\\mkern-1.2mu}\\vcentcolon}");
G("\\approxcoloncolon", "\\mathrel{\\approx\\mathrel{\\mkern-1.2mu}\\dblcolon}");
G("\\notni", "\\html@mathml{\\not\\ni}{\\mathrel{\\char`∌}}");
G("\\limsup", "\\DOTSB\\operatorname*{lim\\,sup}");
G("\\liminf", "\\DOTSB\\operatorname*{lim\\,inf}");
G("\\injlim", "\\DOTSB\\operatorname*{inj\\,lim}");
G("\\projlim", "\\DOTSB\\operatorname*{proj\\,lim}");
G("\\varlimsup", "\\DOTSB\\operatorname*{\\overline{lim}}");
G("\\varliminf", "\\DOTSB\\operatorname*{\\underline{lim}}");
G("\\varinjlim", "\\DOTSB\\operatorname*{\\underrightarrow{lim}}");
G("\\varprojlim", "\\DOTSB\\operatorname*{\\underleftarrow{lim}}");
G("\\gvertneqq", "\\html@mathml{\\@gvertneqq}{≩}");
G("\\lvertneqq", "\\html@mathml{\\@lvertneqq}{≨}");
G("\\ngeqq", "\\html@mathml{\\@ngeqq}{≱}");
G("\\ngeqslant", "\\html@mathml{\\@ngeqslant}{≱}");
G("\\nleqq", "\\html@mathml{\\@nleqq}{≰}");
G("\\nleqslant", "\\html@mathml{\\@nleqslant}{≰}");
G("\\nshortmid", "\\html@mathml{\\@nshortmid}{∤}");
G("\\nshortparallel", "\\html@mathml{\\@nshortparallel}{∦}");
G("\\nsubseteqq", "\\html@mathml{\\@nsubseteqq}{⊈}");
G("\\nsupseteqq", "\\html@mathml{\\@nsupseteqq}{⊉}");
G("\\varsubsetneq", "\\html@mathml{\\@varsubsetneq}{⊊}");
G("\\varsubsetneqq", "\\html@mathml{\\@varsubsetneqq}{⫋}");
G("\\varsupsetneq", "\\html@mathml{\\@varsupsetneq}{⊋}");
G("\\varsupsetneqq", "\\html@mathml{\\@varsupsetneqq}{⫌}");
G("\\imath", "\\html@mathml{\\@imath}{ı}");
G("\\jmath", "\\html@mathml{\\@jmath}{ȷ}");
G("\\llbracket", "\\html@mathml{\\mathopen{[\\mkern-3.2mu[}}{\\mathopen{\\char`⟦}}");
G("\\rrbracket", "\\html@mathml{\\mathclose{]\\mkern-3.2mu]}}{\\mathclose{\\char`⟧}}");
G("⟦", "\\llbracket");
G("⟧", "\\rrbracket");
G("\\lBrace", "\\html@mathml{\\mathopen{\\{\\mkern-3.2mu[}}{\\mathopen{\\char`⦃}}");
G("\\rBrace", "\\html@mathml{\\mathclose{]\\mkern-3.2mu\\}}}{\\mathclose{\\char`⦄}}");
G("⦃", "\\lBrace");
G("⦄", "\\rBrace");
G("\\minuso", "\\mathbin{\\html@mathml{{\\mathrlap{\\mathchoice{\\kern{0.145em}}{\\kern{0.145em}}{\\kern{0.1015em}}{\\kern{0.0725em}}\\circ}{-}}}{\\char`⦵}}");
G("⦵", "\\minuso");
G("\\darr", "\\downarrow");
G("\\dArr", "\\Downarrow");
G("\\Darr", "\\Downarrow");
G("\\lang", "\\langle");
G("\\rang", "\\rangle");
G("\\uarr", "\\uparrow");
G("\\uArr", "\\Uparrow");
G("\\Uarr", "\\Uparrow");
G("\\N", "\\mathbb{N}");
G("\\R", "\\mathbb{R}");
G("\\Z", "\\mathbb{Z}");
G("\\alef", "\\aleph");
G("\\alefsym", "\\aleph");
G("\\Alpha", "\\mathrm{A}");
G("\\Beta", "\\mathrm{B}");
G("\\bull", "\\bullet");
G("\\Chi", "\\mathrm{X}");
G("\\clubs", "\\clubsuit");
G("\\cnums", "\\mathbb{C}");
G("\\Complex", "\\mathbb{C}");
G("\\Dagger", "\\ddagger");
G("\\diamonds", "\\diamondsuit");
G("\\empty", "\\emptyset");
G("\\Epsilon", "\\mathrm{E}");
G("\\Eta", "\\mathrm{H}");
G("\\exist", "\\exists");
G("\\harr", "\\leftrightarrow");
G("\\hArr", "\\Leftrightarrow");
G("\\Harr", "\\Leftrightarrow");
G("\\hearts", "\\heartsuit");
G("\\image", "\\Im");
G("\\infin", "\\infty");
G("\\Iota", "\\mathrm{I}");
G("\\isin", "\\in");
G("\\Kappa", "\\mathrm{K}");
G("\\larr", "\\leftarrow");
G("\\lArr", "\\Leftarrow");
G("\\Larr", "\\Leftarrow");
G("\\lrarr", "\\leftrightarrow");
G("\\lrArr", "\\Leftrightarrow");
G("\\Lrarr", "\\Leftrightarrow");
G("\\Mu", "\\mathrm{M}");
G("\\natnums", "\\mathbb{N}");
G("\\Nu", "\\mathrm{N}");
G("\\Omicron", "\\mathrm{O}");
G("\\plusmn", "\\pm");
G("\\rarr", "\\rightarrow");
G("\\rArr", "\\Rightarrow");
G("\\Rarr", "\\Rightarrow");
G("\\real", "\\Re");
G("\\reals", "\\mathbb{R}");
G("\\Reals", "\\mathbb{R}");
G("\\Rho", "\\mathrm{P}");
G("\\sdot", "\\cdot");
G("\\sect", "\\S");
G("\\spades", "\\spadesuit");
G("\\sub", "\\subset");
G("\\sube", "\\subseteq");
G("\\supe", "\\supseteq");
G("\\Tau", "\\mathrm{T}");
G("\\thetasym", "\\vartheta");
G("\\weierp", "\\wp");
G("\\Zeta", "\\mathrm{Z}");
G("\\argmin", "\\DOTSB\\operatorname*{arg\\,min}");
G("\\argmax", "\\DOTSB\\operatorname*{arg\\,max}");
G("\\plim", "\\DOTSB\\mathop{\\operatorname{plim}}\\limits");
G("\\bra", "\\mathinner{\\langle{#1}|}");
G("\\ket", "\\mathinner{|{#1}\\rangle}");
G("\\braket", "\\mathinner{\\langle{#1}\\rangle}");
G("\\Bra", "\\left\\langle#1\\right|");
G("\\Ket", "\\left|#1\\right\\rangle");
var ED = (e) => (t) => {
  var i = t.consumeArg().tokens, r = t.consumeArg().tokens, n = t.consumeArg().tokens, o = t.consumeArg().tokens, s = t.macros.get("|"), a = t.macros.get("\\|");
  t.macros.beginGroup();
  var l = (m) => (g) => {
    e && (g.macros.set("|", s), n.length && g.macros.set("\\|", a));
    var h = m;
    if (!m && n.length) {
      var A = g.future();
      A.text === "|" && (g.popToken(), h = !0);
    }
    return {
      tokens: h ? n : r,
      numArgs: 0
    };
  };
  t.macros.set("|", l(!1)), n.length && t.macros.set("\\|", l(!0));
  var c = t.consumeArg().tokens, u = t.expandTokens([
    ...o,
    ...c,
    ...i
    // reversed
  ]);
  return t.macros.endGroup(), {
    tokens: u.reverse(),
    numArgs: 0
  };
};
G("\\bra@ket", ED(!1));
G("\\bra@set", ED(!0));
G("\\Braket", "\\bra@ket{\\left\\langle}{\\,\\middle\\vert\\,}{\\,\\middle\\vert\\,}{\\right\\rangle}");
G("\\Set", "\\bra@set{\\left\\{\\:}{\\;\\middle\\vert\\;}{\\;\\middle\\Vert\\;}{\\:\\right\\}}");
G("\\set", "\\bra@set{\\{\\,}{\\mid}{}{\\,\\}}");
G("\\angln", "{\\angl n}");
G("\\blue", "\\textcolor{##6495ed}{#1}");
G("\\orange", "\\textcolor{##ffa500}{#1}");
G("\\pink", "\\textcolor{##ff00af}{#1}");
G("\\red", "\\textcolor{##df0030}{#1}");
G("\\green", "\\textcolor{##28ae7b}{#1}");
G("\\gray", "\\textcolor{gray}{#1}");
G("\\purple", "\\textcolor{##9d38bd}{#1}");
G("\\blueA", "\\textcolor{##ccfaff}{#1}");
G("\\blueB", "\\textcolor{##80f6ff}{#1}");
G("\\blueC", "\\textcolor{##63d9ea}{#1}");
G("\\blueD", "\\textcolor{##11accd}{#1}");
G("\\blueE", "\\textcolor{##0c7f99}{#1}");
G("\\tealA", "\\textcolor{##94fff5}{#1}");
G("\\tealB", "\\textcolor{##26edd5}{#1}");
G("\\tealC", "\\textcolor{##01d1c1}{#1}");
G("\\tealD", "\\textcolor{##01a995}{#1}");
G("\\tealE", "\\textcolor{##208170}{#1}");
G("\\greenA", "\\textcolor{##b6ffb0}{#1}");
G("\\greenB", "\\textcolor{##8af281}{#1}");
G("\\greenC", "\\textcolor{##74cf70}{#1}");
G("\\greenD", "\\textcolor{##1fab54}{#1}");
G("\\greenE", "\\textcolor{##0d923f}{#1}");
G("\\goldA", "\\textcolor{##ffd0a9}{#1}");
G("\\goldB", "\\textcolor{##ffbb71}{#1}");
G("\\goldC", "\\textcolor{##ff9c39}{#1}");
G("\\goldD", "\\textcolor{##e07d10}{#1}");
G("\\goldE", "\\textcolor{##a75a05}{#1}");
G("\\redA", "\\textcolor{##fca9a9}{#1}");
G("\\redB", "\\textcolor{##ff8482}{#1}");
G("\\redC", "\\textcolor{##f9685d}{#1}");
G("\\redD", "\\textcolor{##e84d39}{#1}");
G("\\redE", "\\textcolor{##bc2612}{#1}");
G("\\maroonA", "\\textcolor{##ffbde0}{#1}");
G("\\maroonB", "\\textcolor{##ff92c6}{#1}");
G("\\maroonC", "\\textcolor{##ed5fa6}{#1}");
G("\\maroonD", "\\textcolor{##ca337c}{#1}");
G("\\maroonE", "\\textcolor{##9e034e}{#1}");
G("\\purpleA", "\\textcolor{##ddd7ff}{#1}");
G("\\purpleB", "\\textcolor{##c6b9fc}{#1}");
G("\\purpleC", "\\textcolor{##aa87ff}{#1}");
G("\\purpleD", "\\textcolor{##7854ab}{#1}");
G("\\purpleE", "\\textcolor{##543b78}{#1}");
G("\\mintA", "\\textcolor{##f5f9e8}{#1}");
G("\\mintB", "\\textcolor{##edf2df}{#1}");
G("\\mintC", "\\textcolor{##e0e5cc}{#1}");
G("\\grayA", "\\textcolor{##f6f7f7}{#1}");
G("\\grayB", "\\textcolor{##f0f1f2}{#1}");
G("\\grayC", "\\textcolor{##e3e5e6}{#1}");
G("\\grayD", "\\textcolor{##d6d8da}{#1}");
G("\\grayE", "\\textcolor{##babec2}{#1}");
G("\\grayF", "\\textcolor{##888d93}{#1}");
G("\\grayG", "\\textcolor{##626569}{#1}");
G("\\grayH", "\\textcolor{##3b3e40}{#1}");
G("\\grayI", "\\textcolor{##21242c}{#1}");
G("\\kaBlue", "\\textcolor{##314453}{#1}");
G("\\kaGreen", "\\textcolor{##71B307}{#1}");
var vD = {
  "^": !0,
  // Parser.js
  _: !0,
  // Parser.js
  "\\limits": !0,
  // Parser.js
  "\\nolimits": !0
  // Parser.js
};
class G$ {
  constructor(t, i, r) {
    this.settings = void 0, this.expansionCount = void 0, this.lexer = void 0, this.macros = void 0, this.stack = void 0, this.mode = void 0, this.settings = i, this.expansionCount = 0, this.feed(t), this.macros = new Y$(U$, i.macros), this.mode = r, this.stack = [];
  }
  /**
   * Feed a new input string to the same MacroExpander
   * (with existing macros etc.).
   */
  feed(t) {
    this.lexer = new N4(t, this.settings);
  }
  /**
   * Switches between "text" and "math" modes.
   */
  switchMode(t) {
    this.mode = t;
  }
  /**
   * Start a new group nesting within all namespaces.
   */
  beginGroup() {
    this.macros.beginGroup();
  }
  /**
   * End current group nesting within all namespaces.
   */
  endGroup() {
    this.macros.endGroup();
  }
  /**
   * Ends all currently nested groups (if any), restoring values before the
   * groups began.  Useful in case of an error in the middle of parsing.
   */
  endGroups() {
    this.macros.endGroups();
  }
  /**
   * Returns the topmost token on the stack, without expanding it.
   * Similar in behavior to TeX's `\futurelet`.
   */
  future() {
    return this.stack.length === 0 && this.pushToken(this.lexer.lex()), this.stack[this.stack.length - 1];
  }
  /**
   * Remove and return the next unexpanded token.
   */
  popToken() {
    return this.future(), this.stack.pop();
  }
  /**
   * Add a given token to the token stack.  In particular, this get be used
   * to put back a token returned from one of the other methods.
   */
  pushToken(t) {
    this.stack.push(t);
  }
  /**
   * Append an array of tokens to the token stack.
   */
  pushTokens(t) {
    this.stack.push(...t);
  }
  /**
   * Find an macro argument without expanding tokens and append the array of
   * tokens to the token stack. Uses Token as a container for the result.
   */
  scanArgument(t) {
    var i, r, n;
    if (t) {
      if (this.consumeSpaces(), this.future().text !== "[")
        return null;
      i = this.popToken(), {
        tokens: n,
        end: r
      } = this.consumeArg(["]"]);
    } else
      ({
        tokens: n,
        start: i,
        end: r
      } = this.consumeArg());
    return this.pushToken(new js("EOF", r.loc)), this.pushTokens(n), i.range(r, "");
  }
  /**
   * Consume all following space tokens, without expansion.
   */
  consumeSpaces() {
    for (; ; ) {
      var t = this.future();
      if (t.text === " ")
        this.stack.pop();
      else
        break;
    }
  }
  /**
   * Consume an argument from the token stream, and return the resulting array
   * of tokens and start/end token.
   */
  consumeArg(t) {
    var i = [], r = t && t.length > 0;
    r || this.consumeSpaces();
    var n = this.future(), o, s = 0, a = 0;
    do {
      if (o = this.popToken(), i.push(o), o.text === "{")
        ++s;
      else if (o.text === "}") {
        if (--s, s === -1)
          throw new We("Extra }", o);
      } else if (o.text === "EOF")
        throw new We("Unexpected end of input in a macro argument, expected '" + (t && r ? t[a] : "}") + "'", o);
      if (t && r)
        if ((s === 0 || s === 1 && t[a] === "{") && o.text === t[a]) {
          if (++a, a === t.length) {
            i.splice(-a, a);
            break;
          }
        } else
          a = 0;
    } while (s !== 0 || r);
    return n.text === "{" && i[i.length - 1].text === "}" && (i.pop(), i.shift()), i.reverse(), {
      tokens: i,
      start: n,
      end: o
    };
  }
  /**
   * Consume the specified number of (delimited) arguments from the token
   * stream and return the resulting array of arguments.
   */
  consumeArgs(t, i) {
    if (i) {
      if (i.length !== t + 1)
        throw new We("The length of delimiters doesn't match the number of args!");
      for (var r = i[0], n = 0; n < r.length; n++) {
        var o = this.popToken();
        if (r[n] !== o.text)
          throw new We("Use of the macro doesn't match its definition", o);
      }
    }
    for (var s = [], a = 0; a < t; a++)
      s.push(this.consumeArg(i && i[a + 1]).tokens);
    return s;
  }
  /**
   * Expand the next token only once if possible.
   *
   * If the token is expanded, the resulting tokens will be pushed onto
   * the stack in reverse order, and the number of such tokens will be
   * returned.  This number might be zero or positive.
   *
   * If not, the return value is `false`, and the next token remains at the
   * top of the stack.
   *
   * In either case, the next token will be on the top of the stack,
   * or the stack will be empty (in case of empty expansion
   * and no other tokens).
   *
   * Used to implement `expandAfterFuture` and `expandNextToken`.
   *
   * If expandableOnly, only expandable tokens are expanded and
   * an undefined control sequence results in an error.
   */
  expandOnce(t) {
    var i = this.popToken(), r = i.text, n = i.noexpand ? null : this._getExpansion(r);
    if (n == null || t && n.unexpandable) {
      if (t && n == null && r[0] === "\\" && !this.isDefined(r))
        throw new We("Undefined control sequence: " + r);
      return this.pushToken(i), !1;
    }
    if (this.expansionCount++, this.expansionCount > this.settings.maxExpand)
      throw new We("Too many expansions: infinite loop or need to increase maxExpand setting");
    var o = n.tokens, s = this.consumeArgs(n.numArgs, n.delimiters);
    if (n.numArgs) {
      o = o.slice();
      for (var a = o.length - 1; a >= 0; --a) {
        var l = o[a];
        if (l.text === "#") {
          if (a === 0)
            throw new We("Incomplete placeholder at end of macro body", l);
          if (l = o[--a], l.text === "#")
            o.splice(a + 1, 1);
          else if (/^[1-9]$/.test(l.text))
            o.splice(a, 2, ...s[+l.text - 1]);
          else
            throw new We("Not a valid argument number", l);
        }
      }
    }
    return this.pushTokens(o), o.length;
  }
  /**
   * Expand the next token only once (if possible), and return the resulting
   * top token on the stack (without removing anything from the stack).
   * Similar in behavior to TeX's `\expandafter\futurelet`.
   * Equivalent to expandOnce() followed by future().
   */
  expandAfterFuture() {
    return this.expandOnce(), this.future();
  }
  /**
   * Recursively expand first token, then return first non-expandable token.
   */
  expandNextToken() {
    for (; ; )
      if (this.expandOnce() === !1) {
        var t = this.stack.pop();
        return t.treatAsRelax && (t.text = "\\relax"), t;
      }
    throw new Error();
  }
  /**
   * Fully expand the given macro name and return the resulting list of
   * tokens, or return `undefined` if no such macro is defined.
   */
  expandMacro(t) {
    return this.macros.has(t) ? this.expandTokens([new js(t)]) : void 0;
  }
  /**
   * Fully expand the given token stream and return the resulting list of
   * tokens.  Note that the input tokens are in reverse order, but the
   * output tokens are in forward order.
   */
  expandTokens(t) {
    var i = [], r = this.stack.length;
    for (this.pushTokens(t); this.stack.length > r; )
      if (this.expandOnce(!0) === !1) {
        var n = this.stack.pop();
        n.treatAsRelax && (n.noexpand = !1, n.treatAsRelax = !1), i.push(n);
      }
    return i;
  }
  /**
   * Fully expand the given macro name and return the result as a string,
   * or return `undefined` if no such macro is defined.
   */
  expandMacroAsText(t) {
    var i = this.expandMacro(t);
    return i && i.map((r) => r.text).join("");
  }
  /**
   * Returns the expanded macro as a reversed array of tokens and a macro
   * argument count.  Or returns `null` if no such macro.
   */
  _getExpansion(t) {
    var i = this.macros.get(t);
    if (i == null)
      return i;
    if (t.length === 1) {
      var r = this.lexer.catcodes[t];
      if (r != null && r !== 13)
        return;
    }
    var n = typeof i == "function" ? i(this) : i;
    if (typeof n == "string") {
      var o = 0;
      if (n.indexOf("#") !== -1)
        for (var s = n.replace(/##/g, ""); s.indexOf("#" + (o + 1)) !== -1; )
          ++o;
      for (var a = new N4(n, this.settings), l = [], c = a.lex(); c.text !== "EOF"; )
        l.push(c), c = a.lex();
      l.reverse();
      var u = {
        tokens: l,
        numArgs: o
      };
      return u;
    }
    return n;
  }
  /**
   * Determine whether a command is currently "defined" (has some
   * functionality), meaning that it's a macro (in the current group),
   * a function, a symbol, or one of the special commands listed in
   * `implicitCommands`.
   */
  isDefined(t) {
    return this.macros.has(t) || El.hasOwnProperty(t) || Mi.math.hasOwnProperty(t) || Mi.text.hasOwnProperty(t) || vD.hasOwnProperty(t);
  }
  /**
   * Determine whether a command is expandable.
   */
  isExpandable(t) {
    var i = this.macros.get(t);
    return i != null ? typeof i == "string" || typeof i == "function" || !i.unexpandable : El.hasOwnProperty(t) && !El[t].primitive;
  }
}
var D4 = /^[₊₋₌₍₎₀₁₂₃₄₅₆₇₈₉ₐₑₕᵢⱼₖₗₘₙₒₚᵣₛₜᵤᵥₓᵦᵧᵨᵩᵪ]/, up = Object.freeze({
  "₊": "+",
  "₋": "-",
  "₌": "=",
  "₍": "(",
  "₎": ")",
  "₀": "0",
  "₁": "1",
  "₂": "2",
  "₃": "3",
  "₄": "4",
  "₅": "5",
  "₆": "6",
  "₇": "7",
  "₈": "8",
  "₉": "9",
  "ₐ": "a",
  "ₑ": "e",
  "ₕ": "h",
  "ᵢ": "i",
  "ⱼ": "j",
  "ₖ": "k",
  "ₗ": "l",
  "ₘ": "m",
  "ₙ": "n",
  "ₒ": "o",
  "ₚ": "p",
  "ᵣ": "r",
  "ₛ": "s",
  "ₜ": "t",
  "ᵤ": "u",
  "ᵥ": "v",
  "ₓ": "x",
  "ᵦ": "β",
  "ᵧ": "γ",
  "ᵨ": "ρ",
  "ᵩ": "ϕ",
  "ᵪ": "χ",
  "⁺": "+",
  "⁻": "-",
  "⁼": "=",
  "⁽": "(",
  "⁾": ")",
  "⁰": "0",
  "¹": "1",
  "²": "2",
  "³": "3",
  "⁴": "4",
  "⁵": "5",
  "⁶": "6",
  "⁷": "7",
  "⁸": "8",
  "⁹": "9",
  "ᴬ": "A",
  "ᴮ": "B",
  "ᴰ": "D",
  "ᴱ": "E",
  "ᴳ": "G",
  "ᴴ": "H",
  "ᴵ": "I",
  "ᴶ": "J",
  "ᴷ": "K",
  "ᴸ": "L",
  "ᴹ": "M",
  "ᴺ": "N",
  "ᴼ": "O",
  "ᴾ": "P",
  "ᴿ": "R",
  "ᵀ": "T",
  "ᵁ": "U",
  "ⱽ": "V",
  "ᵂ": "W",
  "ᵃ": "a",
  "ᵇ": "b",
  "ᶜ": "c",
  "ᵈ": "d",
  "ᵉ": "e",
  "ᶠ": "f",
  "ᵍ": "g",
  ʰ: "h",
  "ⁱ": "i",
  ʲ: "j",
  "ᵏ": "k",
  ˡ: "l",
  "ᵐ": "m",
  ⁿ: "n",
  "ᵒ": "o",
  "ᵖ": "p",
  ʳ: "r",
  ˢ: "s",
  "ᵗ": "t",
  "ᵘ": "u",
  "ᵛ": "v",
  ʷ: "w",
  ˣ: "x",
  ʸ: "y",
  "ᶻ": "z",
  "ᵝ": "β",
  "ᵞ": "γ",
  "ᵟ": "δ",
  "ᵠ": "ϕ",
  "ᵡ": "χ",
  "ᶿ": "θ"
}), cE = {
  "́": {
    text: "\\'",
    math: "\\acute"
  },
  "̀": {
    text: "\\`",
    math: "\\grave"
  },
  "̈": {
    text: '\\"',
    math: "\\ddot"
  },
  "̃": {
    text: "\\~",
    math: "\\tilde"
  },
  "̄": {
    text: "\\=",
    math: "\\bar"
  },
  "̆": {
    text: "\\u",
    math: "\\breve"
  },
  "̌": {
    text: "\\v",
    math: "\\check"
  },
  "̂": {
    text: "\\^",
    math: "\\hat"
  },
  "̇": {
    text: "\\.",
    math: "\\dot"
  },
  "̊": {
    text: "\\r",
    math: "\\mathring"
  },
  "̋": {
    text: "\\H"
  },
  "̧": {
    text: "\\c"
  }
}, O4 = {
  á: "á",
  à: "à",
  ä: "ä",
  ǟ: "ǟ",
  ã: "ã",
  ā: "ā",
  ă: "ă",
  ắ: "ắ",
  ằ: "ằ",
  ẵ: "ẵ",
  ǎ: "ǎ",
  â: "â",
  ấ: "ấ",
  ầ: "ầ",
  ẫ: "ẫ",
  ȧ: "ȧ",
  ǡ: "ǡ",
  å: "å",
  ǻ: "ǻ",
  ḃ: "ḃ",
  ć: "ć",
  ḉ: "ḉ",
  č: "č",
  ĉ: "ĉ",
  ċ: "ċ",
  ç: "ç",
  ď: "ď",
  ḋ: "ḋ",
  ḑ: "ḑ",
  é: "é",
  è: "è",
  ë: "ë",
  ẽ: "ẽ",
  ē: "ē",
  ḗ: "ḗ",
  ḕ: "ḕ",
  ĕ: "ĕ",
  ḝ: "ḝ",
  ě: "ě",
  ê: "ê",
  ế: "ế",
  ề: "ề",
  ễ: "ễ",
  ė: "ė",
  ȩ: "ȩ",
  ḟ: "ḟ",
  ǵ: "ǵ",
  ḡ: "ḡ",
  ğ: "ğ",
  ǧ: "ǧ",
  ĝ: "ĝ",
  ġ: "ġ",
  ģ: "ģ",
  ḧ: "ḧ",
  ȟ: "ȟ",
  ĥ: "ĥ",
  ḣ: "ḣ",
  ḩ: "ḩ",
  í: "í",
  ì: "ì",
  ï: "ï",
  ḯ: "ḯ",
  ĩ: "ĩ",
  ī: "ī",
  ĭ: "ĭ",
  ǐ: "ǐ",
  î: "î",
  ǰ: "ǰ",
  ĵ: "ĵ",
  ḱ: "ḱ",
  ǩ: "ǩ",
  ķ: "ķ",
  ĺ: "ĺ",
  ľ: "ľ",
  ļ: "ļ",
  ḿ: "ḿ",
  ṁ: "ṁ",
  ń: "ń",
  ǹ: "ǹ",
  ñ: "ñ",
  ň: "ň",
  ṅ: "ṅ",
  ņ: "ņ",
  ó: "ó",
  ò: "ò",
  ö: "ö",
  ȫ: "ȫ",
  õ: "õ",
  ṍ: "ṍ",
  ṏ: "ṏ",
  ȭ: "ȭ",
  ō: "ō",
  ṓ: "ṓ",
  ṑ: "ṑ",
  ŏ: "ŏ",
  ǒ: "ǒ",
  ô: "ô",
  ố: "ố",
  ồ: "ồ",
  ỗ: "ỗ",
  ȯ: "ȯ",
  ȱ: "ȱ",
  ő: "ő",
  ṕ: "ṕ",
  ṗ: "ṗ",
  ŕ: "ŕ",
  ř: "ř",
  ṙ: "ṙ",
  ŗ: "ŗ",
  ś: "ś",
  ṥ: "ṥ",
  š: "š",
  ṧ: "ṧ",
  ŝ: "ŝ",
  ṡ: "ṡ",
  ş: "ş",
  ẗ: "ẗ",
  ť: "ť",
  ṫ: "ṫ",
  ţ: "ţ",
  ú: "ú",
  ù: "ù",
  ü: "ü",
  ǘ: "ǘ",
  ǜ: "ǜ",
  ǖ: "ǖ",
  ǚ: "ǚ",
  ũ: "ũ",
  ṹ: "ṹ",
  ū: "ū",
  ṻ: "ṻ",
  ŭ: "ŭ",
  ǔ: "ǔ",
  û: "û",
  ů: "ů",
  ű: "ű",
  ṽ: "ṽ",
  ẃ: "ẃ",
  ẁ: "ẁ",
  ẅ: "ẅ",
  ŵ: "ŵ",
  ẇ: "ẇ",
  ẘ: "ẘ",
  ẍ: "ẍ",
  ẋ: "ẋ",
  ý: "ý",
  ỳ: "ỳ",
  ÿ: "ÿ",
  ỹ: "ỹ",
  ȳ: "ȳ",
  ŷ: "ŷ",
  ẏ: "ẏ",
  ẙ: "ẙ",
  ź: "ź",
  ž: "ž",
  ẑ: "ẑ",
  ż: "ż",
  Á: "Á",
  À: "À",
  Ä: "Ä",
  Ǟ: "Ǟ",
  Ã: "Ã",
  Ā: "Ā",
  Ă: "Ă",
  Ắ: "Ắ",
  Ằ: "Ằ",
  Ẵ: "Ẵ",
  Ǎ: "Ǎ",
  Â: "Â",
  Ấ: "Ấ",
  Ầ: "Ầ",
  Ẫ: "Ẫ",
  Ȧ: "Ȧ",
  Ǡ: "Ǡ",
  Å: "Å",
  Ǻ: "Ǻ",
  Ḃ: "Ḃ",
  Ć: "Ć",
  Ḉ: "Ḉ",
  Č: "Č",
  Ĉ: "Ĉ",
  Ċ: "Ċ",
  Ç: "Ç",
  Ď: "Ď",
  Ḋ: "Ḋ",
  Ḑ: "Ḑ",
  É: "É",
  È: "È",
  Ë: "Ë",
  Ẽ: "Ẽ",
  Ē: "Ē",
  Ḗ: "Ḗ",
  Ḕ: "Ḕ",
  Ĕ: "Ĕ",
  Ḝ: "Ḝ",
  Ě: "Ě",
  Ê: "Ê",
  Ế: "Ế",
  Ề: "Ề",
  Ễ: "Ễ",
  Ė: "Ė",
  Ȩ: "Ȩ",
  Ḟ: "Ḟ",
  Ǵ: "Ǵ",
  Ḡ: "Ḡ",
  Ğ: "Ğ",
  Ǧ: "Ǧ",
  Ĝ: "Ĝ",
  Ġ: "Ġ",
  Ģ: "Ģ",
  Ḧ: "Ḧ",
  Ȟ: "Ȟ",
  Ĥ: "Ĥ",
  Ḣ: "Ḣ",
  Ḩ: "Ḩ",
  Í: "Í",
  Ì: "Ì",
  Ï: "Ï",
  Ḯ: "Ḯ",
  Ĩ: "Ĩ",
  Ī: "Ī",
  Ĭ: "Ĭ",
  Ǐ: "Ǐ",
  Î: "Î",
  İ: "İ",
  Ĵ: "Ĵ",
  Ḱ: "Ḱ",
  Ǩ: "Ǩ",
  Ķ: "Ķ",
  Ĺ: "Ĺ",
  Ľ: "Ľ",
  Ļ: "Ļ",
  Ḿ: "Ḿ",
  Ṁ: "Ṁ",
  Ń: "Ń",
  Ǹ: "Ǹ",
  Ñ: "Ñ",
  Ň: "Ň",
  Ṅ: "Ṅ",
  Ņ: "Ņ",
  Ó: "Ó",
  Ò: "Ò",
  Ö: "Ö",
  Ȫ: "Ȫ",
  Õ: "Õ",
  Ṍ: "Ṍ",
  Ṏ: "Ṏ",
  Ȭ: "Ȭ",
  Ō: "Ō",
  Ṓ: "Ṓ",
  Ṑ: "Ṑ",
  Ŏ: "Ŏ",
  Ǒ: "Ǒ",
  Ô: "Ô",
  Ố: "Ố",
  Ồ: "Ồ",
  Ỗ: "Ỗ",
  Ȯ: "Ȯ",
  Ȱ: "Ȱ",
  Ő: "Ő",
  Ṕ: "Ṕ",
  Ṗ: "Ṗ",
  Ŕ: "Ŕ",
  Ř: "Ř",
  Ṙ: "Ṙ",
  Ŗ: "Ŗ",
  Ś: "Ś",
  Ṥ: "Ṥ",
  Š: "Š",
  Ṧ: "Ṧ",
  Ŝ: "Ŝ",
  Ṡ: "Ṡ",
  Ş: "Ş",
  Ť: "Ť",
  Ṫ: "Ṫ",
  Ţ: "Ţ",
  Ú: "Ú",
  Ù: "Ù",
  Ü: "Ü",
  Ǘ: "Ǘ",
  Ǜ: "Ǜ",
  Ǖ: "Ǖ",
  Ǚ: "Ǚ",
  Ũ: "Ũ",
  Ṹ: "Ṹ",
  Ū: "Ū",
  Ṻ: "Ṻ",
  Ŭ: "Ŭ",
  Ǔ: "Ǔ",
  Û: "Û",
  Ů: "Ů",
  Ű: "Ű",
  Ṽ: "Ṽ",
  Ẃ: "Ẃ",
  Ẁ: "Ẁ",
  Ẅ: "Ẅ",
  Ŵ: "Ŵ",
  Ẇ: "Ẇ",
  Ẍ: "Ẍ",
  Ẋ: "Ẋ",
  Ý: "Ý",
  Ỳ: "Ỳ",
  Ÿ: "Ÿ",
  Ỹ: "Ỹ",
  Ȳ: "Ȳ",
  Ŷ: "Ŷ",
  Ẏ: "Ẏ",
  Ź: "Ź",
  Ž: "Ž",
  Ẑ: "Ẑ",
  Ż: "Ż",
  ά: "ά",
  ὰ: "ὰ",
  ᾱ: "ᾱ",
  ᾰ: "ᾰ",
  έ: "έ",
  ὲ: "ὲ",
  ή: "ή",
  ὴ: "ὴ",
  ί: "ί",
  ὶ: "ὶ",
  ϊ: "ϊ",
  ΐ: "ΐ",
  ῒ: "ῒ",
  ῑ: "ῑ",
  ῐ: "ῐ",
  ό: "ό",
  ὸ: "ὸ",
  ύ: "ύ",
  ὺ: "ὺ",
  ϋ: "ϋ",
  ΰ: "ΰ",
  ῢ: "ῢ",
  ῡ: "ῡ",
  ῠ: "ῠ",
  ώ: "ώ",
  ὼ: "ὼ",
  Ύ: "Ύ",
  Ὺ: "Ὺ",
  Ϋ: "Ϋ",
  Ῡ: "Ῡ",
  Ῠ: "Ῠ",
  Ώ: "Ώ",
  Ὼ: "Ὼ"
};
class Jm {
  constructor(t, i) {
    this.mode = void 0, this.gullet = void 0, this.settings = void 0, this.leftrightDepth = void 0, this.nextToken = void 0, this.mode = "math", this.gullet = new G$(t, i, this.mode), this.settings = i, this.leftrightDepth = 0;
  }
  /**
   * Checks a result to make sure it has the right type, and throws an
   * appropriate error otherwise.
   */
  expect(t, i) {
    if (i === void 0 && (i = !0), this.fetch().text !== t)
      throw new We("Expected '" + t + "', got '" + this.fetch().text + "'", this.fetch());
    i && this.consume();
  }
  /**
   * Discards the current lookahead token, considering it consumed.
   */
  consume() {
    this.nextToken = null;
  }
  /**
   * Return the current lookahead token, or if there isn't one (at the
   * beginning, or if the previous lookahead token was consume()d),
   * fetch the next token as the new lookahead token and return it.
   */
  fetch() {
    return this.nextToken == null && (this.nextToken = this.gullet.expandNextToken()), this.nextToken;
  }
  /**
   * Switches between "text" and "math" modes.
   */
  switchMode(t) {
    this.mode = t, this.gullet.switchMode(t);
  }
  /**
   * Main parsing function, which parses an entire input.
   */
  parse() {
    this.settings.globalGroup || this.gullet.beginGroup(), this.settings.colorIsTextColor && this.gullet.macros.set("\\color", "\\textcolor");
    try {
      var t = this.parseExpression(!1);
      return this.expect("EOF"), this.settings.globalGroup || this.gullet.endGroup(), t;
    } finally {
      this.gullet.endGroups();
    }
  }
  /**
   * Fully parse a separate sequence of tokens as a separate job.
   * Tokens should be specified in reverse order, as in a MacroDefinition.
   */
  subparse(t) {
    var i = this.nextToken;
    this.consume(), this.gullet.pushToken(new js("}")), this.gullet.pushTokens(t);
    var r = this.parseExpression(!1);
    return this.expect("}"), this.nextToken = i, r;
  }
  /**
   * Parses an "expression", which is a list of atoms.
   *
   * `breakOnInfix`: Should the parsing stop when we hit infix nodes? This
   *                 happens when functions have higher precedence han infix
   *                 nodes in implicit parses.
   *
   * `breakOnTokenText`: The text of the token that the expression should end
   *                     with, or `null` if something else should end the
   *                     expression.
   */
  parseExpression(t, i) {
    for (var r = []; ; ) {
      this.mode === "math" && this.consumeSpaces();
      var n = this.fetch();
      if (Jm.endOfExpression.indexOf(n.text) !== -1 || i && n.text === i || t && El[n.text] && El[n.text].infix)
        break;
      var o = this.parseAtom(i);
      if (o) {
        if (o.type === "internal")
          continue;
      } else
        break;
      r.push(o);
    }
    return this.mode === "text" && this.formLigatures(r), this.handleInfixNodes(r);
  }
  /**
   * Rewrites infix operators such as \over with corresponding commands such
   * as \frac.
   *
   * There can only be one infix operator per group.  If there's more than one
   * then the expression is ambiguous.  This can be resolved by adding {}.
   */
  handleInfixNodes(t) {
    for (var i = -1, r, n = 0; n < t.length; n++)
      if (t[n].type === "infix") {
        if (i !== -1)
          throw new We("only one infix operator per group", t[n].token);
        i = n, r = t[n].replaceWith;
      }
    if (i !== -1 && r) {
      var o, s, a = t.slice(0, i), l = t.slice(i + 1);
      a.length === 1 && a[0].type === "ordgroup" ? o = a[0] : o = {
        type: "ordgroup",
        mode: this.mode,
        body: a
      }, l.length === 1 && l[0].type === "ordgroup" ? s = l[0] : s = {
        type: "ordgroup",
        mode: this.mode,
        body: l
      };
      var c;
      return r === "\\\\abovefrac" ? c = this.callFunction(r, [o, t[i], s], []) : c = this.callFunction(r, [o, s], []), [c];
    } else
      return t;
  }
  /**
   * Handle a subscript or superscript with nice errors.
   */
  handleSupSubscript(t) {
    var i = this.fetch(), r = i.text;
    this.consume(), this.consumeSpaces();
    var n = this.parseGroup(t);
    if (!n)
      throw new We("Expected group after '" + r + "'", i);
    return n;
  }
  /**
   * Converts the textual input of an unsupported command into a text node
   * contained within a color node whose color is determined by errorColor
   */
  formatUnsupportedCmd(t) {
    for (var i = [], r = 0; r < t.length; r++)
      i.push({
        type: "textord",
        mode: "text",
        text: t[r]
      });
    var n = {
      type: "text",
      mode: this.mode,
      body: i
    }, o = {
      type: "color",
      mode: this.mode,
      color: this.settings.errorColor,
      body: [n]
    };
    return o;
  }
  /**
   * Parses a group with optional super/subscripts.
   */
  parseAtom(t) {
    var i = this.parseGroup("atom", t);
    if (this.mode === "text")
      return i;
    for (var r, n; ; ) {
      this.consumeSpaces();
      var o = this.fetch();
      if (o.text === "\\limits" || o.text === "\\nolimits") {
        if (i && i.type === "op") {
          var s = o.text === "\\limits";
          i.limits = s, i.alwaysHandleSupSub = !0;
        } else if (i && i.type === "operatorname")
          i.alwaysHandleSupSub && (i.limits = o.text === "\\limits");
        else
          throw new We("Limit controls must follow a math operator", o);
        this.consume();
      } else if (o.text === "^") {
        if (r)
          throw new We("Double superscript", o);
        r = this.handleSupSubscript("superscript");
      } else if (o.text === "_") {
        if (n)
          throw new We("Double subscript", o);
        n = this.handleSupSubscript("subscript");
      } else if (o.text === "'") {
        if (r)
          throw new We("Double superscript", o);
        var a = {
          type: "textord",
          mode: this.mode,
          text: "\\prime"
        }, l = [a];
        for (this.consume(); this.fetch().text === "'"; )
          l.push(a), this.consume();
        this.fetch().text === "^" && l.push(this.handleSupSubscript("superscript")), r = {
          type: "ordgroup",
          mode: this.mode,
          body: l
        };
      } else if (up[o.text]) {
        var c = up[o.text], u = D4.test(o.text);
        for (this.consume(); ; ) {
          var m = this.fetch().text;
          if (!up[m] || D4.test(m) !== u)
            break;
          this.consume(), c += up[m];
        }
        var g = new Jm(c, this.settings).parse();
        u ? n = {
          type: "ordgroup",
          mode: "math",
          body: g
        } : r = {
          type: "ordgroup",
          mode: "math",
          body: g
        };
      } else
        break;
    }
    return r || n ? {
      type: "supsub",
      mode: this.mode,
      base: i,
      sup: r,
      sub: n
    } : i;
  }
  /**
   * Parses an entire function, including its base and all of its arguments.
   */
  parseFunction(t, i) {
    var r = this.fetch(), n = r.text, o = El[n];
    if (!o)
      return null;
    if (this.consume(), i && i !== "atom" && !o.allowedInArgument)
      throw new We("Got function '" + n + "' with no arguments" + (i ? " as " + i : ""), r);
    if (this.mode === "text" && !o.allowedInText)
      throw new We("Can't use function '" + n + "' in text mode", r);
    if (this.mode === "math" && o.allowedInMath === !1)
      throw new We("Can't use function '" + n + "' in math mode", r);
    var {
      args: s,
      optArgs: a
    } = this.parseArguments(n, o);
    return this.callFunction(n, s, a, r, t);
  }
  /**
   * Call a function handler with a suitable context and arguments.
   */
  callFunction(t, i, r, n, o) {
    var s = {
      funcName: t,
      parser: this,
      token: n,
      breakOnTokenText: o
    }, a = El[t];
    if (a && a.handler)
      return a.handler(s, i, r);
    throw new We("No function handler for " + t);
  }
  /**
   * Parses the arguments of a function or environment
   */
  parseArguments(t, i) {
    var r = i.numArgs + i.numOptionalArgs;
    if (r === 0)
      return {
        args: [],
        optArgs: []
      };
    for (var n = [], o = [], s = 0; s < r; s++) {
      var a = i.argTypes && i.argTypes[s], l = s < i.numOptionalArgs;
      (i.primitive && a == null || // \sqrt expands into primitive if optional argument doesn't exist
      i.type === "sqrt" && s === 1 && o[0] == null) && (a = "primitive");
      var c = this.parseGroupOfType("argument to '" + t + "'", a, l);
      if (l)
        o.push(c);
      else if (c != null)
        n.push(c);
      else
        throw new We("Null argument, please report this as a bug");
    }
    return {
      args: n,
      optArgs: o
    };
  }
  /**
   * Parses a group when the mode is changing.
   */
  parseGroupOfType(t, i, r) {
    switch (i) {
      case "color":
        return this.parseColorGroup(r);
      case "size":
        return this.parseSizeGroup(r);
      case "url":
        return this.parseUrlGroup(r);
      case "math":
      case "text":
        return this.parseArgumentGroup(r, i);
      case "hbox": {
        var n = this.parseArgumentGroup(r, "text");
        return n != null ? {
          type: "styling",
          mode: n.mode,
          body: [n],
          style: "text"
          // simulate \textstyle
        } : null;
      }
      case "raw": {
        var o = this.parseStringGroup("raw", r);
        return o != null ? {
          type: "raw",
          mode: "text",
          string: o.text
        } : null;
      }
      case "primitive": {
        if (r)
          throw new We("A primitive argument cannot be optional");
        var s = this.parseGroup(t);
        if (s == null)
          throw new We("Expected group as " + t, this.fetch());
        return s;
      }
      case "original":
      case null:
      case void 0:
        return this.parseArgumentGroup(r);
      default:
        throw new We("Unknown group type as " + t, this.fetch());
    }
  }
  /**
   * Discard any space tokens, fetching the next non-space token.
   */
  consumeSpaces() {
    for (; this.fetch().text === " "; )
      this.consume();
  }
  /**
   * Parses a group, essentially returning the string formed by the
   * brace-enclosed tokens plus some position information.
   */
  parseStringGroup(t, i) {
    var r = this.gullet.scanArgument(i);
    if (r == null)
      return null;
    for (var n = "", o; (o = this.fetch()).text !== "EOF"; )
      n += o.text, this.consume();
    return this.consume(), r.text = n, r;
  }
  /**
   * Parses a regex-delimited group: the largest sequence of tokens
   * whose concatenated strings match `regex`. Returns the string
   * formed by the tokens plus some position information.
   */
  parseRegexGroup(t, i) {
    for (var r = this.fetch(), n = r, o = "", s; (s = this.fetch()).text !== "EOF" && t.test(o + s.text); )
      n = s, o += n.text, this.consume();
    if (o === "")
      throw new We("Invalid " + i + ": '" + r.text + "'", r);
    return r.range(n, o);
  }
  /**
   * Parses a color description.
   */
  parseColorGroup(t) {
    var i = this.parseStringGroup("color", t);
    if (i == null)
      return null;
    var r = /^(#[a-f0-9]{3}|#?[a-f0-9]{6}|[a-z]+)$/i.exec(i.text);
    if (!r)
      throw new We("Invalid color: '" + i.text + "'", i);
    var n = r[0];
    return /^[0-9a-f]{6}$/i.test(n) && (n = "#" + n), {
      type: "color-token",
      mode: this.mode,
      color: n
    };
  }
  /**
   * Parses a size specification, consisting of magnitude and unit.
   */
  parseSizeGroup(t) {
    var i, r = !1;
    if (this.gullet.consumeSpaces(), !t && this.gullet.future().text !== "{" ? i = this.parseRegexGroup(/^[-+]? *(?:$|\d+|\d+\.\d*|\.\d*) *[a-z]{0,2} *$/, "size") : i = this.parseStringGroup("size", t), !i)
      return null;
    !t && i.text.length === 0 && (i.text = "0pt", r = !0);
    var n = /([-+]?) *(\d+(?:\.\d*)?|\.\d+) *([a-z]{2})/.exec(i.text);
    if (!n)
      throw new We("Invalid size: '" + i.text + "'", i);
    var o = {
      number: +(n[1] + n[2]),
      // sign + magnitude, cast to number
      unit: n[3]
    };
    if (!N7(o))
      throw new We("Invalid unit: '" + o.unit + "'", i);
    return {
      type: "size",
      mode: this.mode,
      value: o,
      isBlank: r
    };
  }
  /**
   * Parses an URL, checking escaped letters and allowed protocols,
   * and setting the catcode of % as an active character (as in \hyperref).
   */
  parseUrlGroup(t) {
    this.gullet.lexer.setCatcode("%", 13), this.gullet.lexer.setCatcode("~", 12);
    var i = this.parseStringGroup("url", t);
    if (this.gullet.lexer.setCatcode("%", 14), this.gullet.lexer.setCatcode("~", 13), i == null)
      return null;
    var r = i.text.replace(/\\([#$%&~_^{}])/g, "$1");
    return {
      type: "url",
      mode: this.mode,
      url: r
    };
  }
  /**
   * Parses an argument with the mode specified.
   */
  parseArgumentGroup(t, i) {
    var r = this.gullet.scanArgument(t);
    if (r == null)
      return null;
    var n = this.mode;
    i && this.switchMode(i), this.gullet.beginGroup();
    var o = this.parseExpression(!1, "EOF");
    this.expect("EOF"), this.gullet.endGroup();
    var s = {
      type: "ordgroup",
      mode: this.mode,
      loc: r.loc,
      body: o
    };
    return i && this.switchMode(n), s;
  }
  /**
   * Parses an ordinary group, which is either a single nucleus (like "x")
   * or an expression in braces (like "{x+y}") or an implicit group, a group
   * that starts at the current position, and ends right before a higher explicit
   * group ends, or at EOF.
   */
  parseGroup(t, i) {
    var r = this.fetch(), n = r.text, o;
    if (n === "{" || n === "\\begingroup") {
      this.consume();
      var s = n === "{" ? "}" : "\\endgroup";
      this.gullet.beginGroup();
      var a = this.parseExpression(!1, s), l = this.fetch();
      this.expect(s), this.gullet.endGroup(), o = {
        type: "ordgroup",
        mode: this.mode,
        loc: uo.range(r, l),
        body: a,
        // A group formed by \begingroup...\endgroup is a semi-simple group
        // which doesn't affect spacing in math mode, i.e., is transparent.
        // https://tex.stackexchange.com/questions/1930/when-should-one-
        // use-begingroup-instead-of-bgroup
        semisimple: n === "\\begingroup" || void 0
      };
    } else if (o = this.parseFunction(i, t) || this.parseSymbol(), o == null && n[0] === "\\" && !vD.hasOwnProperty(n)) {
      if (this.settings.throwOnError)
        throw new We("Undefined control sequence: " + n, r);
      o = this.formatUnsupportedCmd(n), this.consume();
    }
    return o;
  }
  /**
   * Form ligature-like combinations of characters for text mode.
   * This includes inputs like "--", "---", "``" and "''".
   * The result will simply replace multiple textord nodes with a single
   * character in each value by a single textord node having multiple
   * characters in its value.  The representation is still ASCII source.
   * The group will be modified in place.
   */
  formLigatures(t) {
    for (var i = t.length - 1, r = 0; r < i; ++r) {
      var n = t[r], o = n.text;
      o === "-" && t[r + 1].text === "-" && (r + 1 < i && t[r + 2].text === "-" ? (t.splice(r, 3, {
        type: "textord",
        mode: "text",
        loc: uo.range(n, t[r + 2]),
        text: "---"
      }), i -= 2) : (t.splice(r, 2, {
        type: "textord",
        mode: "text",
        loc: uo.range(n, t[r + 1]),
        text: "--"
      }), i -= 1)), (o === "'" || o === "`") && t[r + 1].text === o && (t.splice(r, 2, {
        type: "textord",
        mode: "text",
        loc: uo.range(n, t[r + 1]),
        text: o + o
      }), i -= 1);
    }
  }
  /**
   * Parse a single symbol out of the string. Here, we handle single character
   * symbols and special functions like \verb.
   */
  parseSymbol() {
    var t = this.fetch(), i = t.text;
    if (/^\\verb[^a-zA-Z]/.test(i)) {
      this.consume();
      var r = i.slice(5), n = r.charAt(0) === "*";
      if (n && (r = r.slice(1)), r.length < 2 || r.charAt(0) !== r.slice(-1))
        throw new We(`\\verb assertion failed --
                    please report what input caused this bug`);
      return r = r.slice(1, -1), {
        type: "verb",
        mode: "text",
        body: r,
        star: n
      };
    }
    O4.hasOwnProperty(i[0]) && !Mi[this.mode][i[0]] && (this.settings.strict && this.mode === "math" && this.settings.reportNonstrict("unicodeTextInMathMode", 'Accented Unicode text character "' + i[0] + '" used in math mode', t), i = O4[i[0]] + i.slice(1));
    var o = L$.exec(i);
    o && (i = i.substring(0, o.index), i === "i" ? i = "ı" : i === "j" && (i = "ȷ"));
    var s;
    if (Mi[this.mode][i]) {
      this.settings.strict && this.mode === "math" && jb.indexOf(i) >= 0 && this.settings.reportNonstrict("unicodeTextInMathMode", 'Latin-1/Unicode text character "' + i[0] + '" used in math mode', t);
      var a = Mi[this.mode][i].group, l = uo.range(t), c;
      if (T_.hasOwnProperty(a)) {
        var u = a;
        c = {
          type: "atom",
          mode: this.mode,
          family: u,
          loc: l,
          text: i
        };
      } else
        c = {
          type: a,
          mode: this.mode,
          loc: l,
          text: i
        };
      s = c;
    } else if (i.charCodeAt(0) >= 128)
      this.settings.strict && (M7(i.charCodeAt(0)) ? this.mode === "math" && this.settings.reportNonstrict("unicodeTextInMathMode", 'Unicode text character "' + i[0] + '" used in math mode', t) : this.settings.reportNonstrict("unknownSymbol", 'Unrecognized Unicode character "' + i[0] + '"' + (" (" + i.charCodeAt(0) + ")"), t)), s = {
        type: "textord",
        mode: "text",
        loc: uo.range(t),
        text: i
      };
    else
      return null;
    if (this.consume(), o)
      for (var m = 0; m < o[0].length; m++) {
        var g = o[0][m];
        if (!cE[g])
          throw new We("Unknown accent ' " + g + "'", t);
        var h = cE[g][this.mode] || cE[g].text;
        if (!h)
          throw new We("Accent " + g + " unsupported in " + this.mode + " mode", t);
        s = {
          type: "accent",
          mode: this.mode,
          loc: uo.range(t),
          label: h,
          isStretchy: !1,
          isShifty: !0,
          // $FlowFixMe
          base: s
        };
      }
    return s;
  }
}
Jm.endOfExpression = ["}", "\\endgroup", "\\end", "\\right", "&"];
var nx = function(t, i) {
  if (!(typeof t == "string" || t instanceof String))
    throw new TypeError("KaTeX can only parse string typed expression");
  var r = new Jm(t, i);
  delete r.gullet.macros.current["\\df@tag"];
  var n = r.parse();
  if (delete r.gullet.macros.current["\\current@color"], delete r.gullet.macros.current["\\color"], r.gullet.macros.get("\\df@tag")) {
    if (!i.displayMode)
      throw new We("\\tag works only in display equations");
    n = [{
      type: "tag",
      mode: "text",
      body: n,
      tag: r.subparse([new js("\\df@tag")])
    }];
  }
  return n;
}, bD = function(t, i, r) {
  i.textContent = "";
  var n = ox(t, r).toNode();
  i.appendChild(n);
};
typeof document != "undefined" && document.compatMode !== "CSS1Compat" && (typeof console != "undefined" && console.warn("Warning: KaTeX doesn't work in quirks mode. Make sure your website has a suitable doctype."), bD = function() {
  throw new We("KaTeX doesn't work in quirks mode.");
});
var Q$ = function(t, i) {
  var r = ox(t, i).toMarkup();
  return r;
}, W$ = function(t, i) {
  var r = new K2(i);
  return nx(t, r);
}, CD = function(t, i, r) {
  if (r.throwOnError || !(t instanceof We))
    throw t;
  var n = ve.makeSpan(["katex-error"], [new Zo(i)]);
  return n.setAttribute("title", t.toString()), n.setAttribute("style", "color:" + r.errorColor), n;
}, ox = function(t, i) {
  var r = new K2(i);
  try {
    var n = nx(t, r);
    return e$(n, t, r);
  } catch (o) {
    return CD(o, t, r);
  }
}, Z$ = function(t, i) {
  var r = new K2(i);
  try {
    var n = nx(t, r);
    return t$(n, t, r);
  } catch (o) {
    return CD(o, t, r);
  }
}, xD = {
  /**
   * Current KaTeX version
   */
  version: "0.16.9",
  /**
   * Renders the given LaTeX into an HTML+MathML combination, and adds
   * it as a child to the specified DOM node.
   */
  render: bD,
  /**
   * Renders the given LaTeX into an HTML+MathML combination string,
   * for sending to the client.
   */
  renderToString: Q$,
  /**
   * KaTeX error, usually during parsing.
   */
  ParseError: We,
  /**
   * The shema of Settings
   */
  SETTINGS_SCHEMA: Up,
  /**
   * Parses the given LaTeX into KaTeX's internal parse tree structure,
   * without rendering to HTML or MathML.
   *
   * NOTE: This method is not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */
  __parse: W$,
  /**
   * Renders the given LaTeX into an HTML+MathML internal DOM tree
   * representation, without flattening that representation to a string.
   *
   * NOTE: This method is not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */
  __renderToDomTree: ox,
  /**
   * Renders the given LaTeX into an HTML internal DOM tree representation,
   * without MathML and without flattening that representation to a string.
   *
   * NOTE: This method is not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */
  __renderToHTMLTree: Z$,
  /**
   * extends internal font metrics object with a new object
   * each key in the new object represents a font name
  */
  __setFontMetrics: I_,
  /**
   * adds a new symbol to builtin symbols table
   */
  __defineSymbol: k,
  /**
   * adds a new function to builtin function list,
   * which directly produce parse tree elements
   * and have their own html/mathml builders
   */
  __defineFunction: rt,
  /**
   * adds a new macro to builtin macro list
   */
  __defineMacro: G,
  /**
   * Expose the dom tree node types, which can be useful for type checking nodes.
   *
   * NOTE: This method is not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */
  __domTree: {
    Span: Cg,
    Anchor: G2,
    SymbolNode: Zo,
    SvgNode: Ta,
    PathNode: Vl,
    LineNode: qb
  }
};
const J$ = ft.lazy(() => import("./EquationComponent-cecb4991.js"));
function F4(e) {
  let t = e.getAttribute("data-lexical-equation");
  const i = e.getAttribute("data-lexical-inline") === "true";
  return t = atob(t || ""), t ? { node: kf(t, i) } : null;
}
class Gl extends L.DecoratorNode {
  constructor(i, r, n) {
    super(n);
    Ze(this, "__equation");
    Ze(this, "__inline");
    this.__equation = i, this.__inline = r != null ? r : !1;
  }
  static getType() {
    return "equation";
  }
  static clone(i) {
    return new Gl(i.__equation, i.__inline, i.__key);
  }
  static importJSON(i) {
    return kf(i.equation, i.inline);
  }
  exportJSON() {
    return {
      equation: this.getEquation(),
      inline: this.__inline,
      type: "equation",
      version: 1
    };
  }
  createDOM(i) {
    const r = Wt(this.__inline ? "span" : "div");
    return r.className = "editor-equation", r;
  }
  exportDOM() {
    const i = Wt(this.__inline ? "span" : "div"), r = btoa(this.__equation);
    return i.setAttribute("data-lexical-equation", r), i.setAttribute("data-lexical-inline", `${this.__inline}`), xD.render(this.__equation, i, {
      displayMode: !this.__inline,
      // true === block display //
      errorColor: "#cc0000",
      output: "html",
      strict: "warn",
      throwOnError: !1,
      trust: !1
    }), { element: i };
  }
  static importDOM() {
    return {
      div: (i) => i.hasAttribute("data-lexical-equation") ? {
        conversion: F4,
        priority: 2
      } : null,
      span: (i) => i.hasAttribute("data-lexical-equation") ? {
        conversion: F4,
        priority: 1
      } : null
    };
  }
  updateDOM(i) {
    return this.__inline !== i.__inline;
  }
  getTextContent() {
    return this.__equation;
  }
  getEquation() {
    return this.__equation;
  }
  setEquation(i) {
    const r = this.getWritable();
    r.__equation = i;
  }
  decorate() {
    return /* @__PURE__ */ f(Ll, { fallback: null, children: /* @__PURE__ */ f(J$, { equation: this.__equation, inline: this.__inline, nodeKey: this.__key }) });
  }
}
function kf(e = "", t = !1) {
  const i = new Gl(e, t);
  return L.$applyNodeReplacement(i);
}
function P$(e) {
  return e instanceof Gl;
}
var ID = {}, sx = {}, SD = X;
let V4 = [["Cat", "rgb(125, 50, 0)"], ["Dog", "rgb(100, 0, 0)"], ["Rabbit", "rgb(150, 0, 0)"], ["Frog", "rgb(200, 0, 0)"], ["Fox", "rgb(200, 75, 0)"], ["Hedgehog", "rgb(0, 75, 0)"], ["Pigeon", "rgb(0, 125, 0)"], ["Squirrel", "rgb(75, 100, 0)"], ["Bear", "rgb(125, 100, 0)"], ["Tiger", "rgb(0, 0, 150)"], ["Leopard", "rgb(0, 0, 200)"], ["Zebra", "rgb(0, 0, 250)"], ["Wolf", "rgb(0, 100, 150)"], ["Owl", "rgb(0, 100, 100)"], ["Gull", "rgb(100, 0, 100)"], ["Squid", "rgb(150, 0, 150)"]], q4 = V4[Math.floor(Math.random() * V4.length)], RD = SD.createContext({
  clientID: 0,
  color: q4[1],
  isCollabActive: !1,
  name: q4[0],
  yjsDocMap: /* @__PURE__ */ new Map()
});
sx.CollaborationContext = RD;
sx.useCollaborationContext = function(e, t) {
  let i = SD.useContext(RD);
  return e != null && (i.name = e), t != null && (i.color = t), i;
};
const z$ = sx;
var H$ = z$, X$ = H$, uE = nt, Ou = X;
function _$(e) {
  let t = new URLSearchParams();
  t.append("code", e);
  for (let i = 1; i < arguments.length; i++)
    t.append("v", arguments[i]);
  throw Error(`Minified Lexical error #${e}; visit https://lexical.dev/docs/error?${t} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
}
ID.LexicalNestedComposer = function({ initialEditor: e, children: t, initialNodes: i, initialTheme: r, skipCollabChecks: n }) {
  let o = Ou.useRef(!1), s = Ou.useContext(uE.LexicalComposerContext);
  s == null && _$(9);
  let [a, { getTheme: l }] = s, c = Ou.useMemo(() => {
    var h = r || l() || void 0;
    const A = uE.createLexicalComposerContext(s, h);
    if (h !== void 0 && (e._config.theme = h), e._parentEditor = a, i)
      for (var y of i)
        h = y.getType(), e._nodes.set(h, { klass: y, replace: null, replaceWithKlass: null, transforms: /* @__PURE__ */ new Set() });
    else {
      y = e._nodes = new Map(a._nodes);
      for (const [
        E,
        v
      ] of y)
        e._nodes.set(E, { klass: v.klass, replace: v.replace, replaceWithKlass: v.replaceWithKlass, transforms: /* @__PURE__ */ new Set() });
    }
    return e._config.namespace = a._config.namespace, e._editable = a._editable, [e, A];
  }, []), { isCollabActive: u, yjsDocMap: m } = X$.useCollaborationContext(), g = n || o.current || m.has(e.getKey());
  return Ou.useEffect(() => {
    g && (o.current = !0);
  }, [g]), Ou.useEffect(() => a.registerEditableListener((h) => {
    e.setEditable(h);
  }), [e, a]), Ou.createElement(uE.LexicalComposerContext.Provider, { value: c }, !u || g ? t : null);
};
const $$ = ID;
var kD = $$;
const j4 = /* @__PURE__ */ new Map([
  [":)", ["emoji happysmile", "🙂"]],
  [":D", ["emoji veryhappysmile", "😀"]],
  [":(", ["emoji unhappysmile", "🙁"]],
  ["<3", ["emoji heart", "❤"]],
  ["🙂", ["emoji happysmile", "🙂"]],
  ["😀", ["emoji veryhappysmile", "😀"]],
  ["🙁", ["emoji unhappysmile", "🙁"]],
  ["❤", ["emoji heart", "❤"]]
]);
function eee(e) {
  const t = e.getTextContent();
  for (let i = 0; i < t.length; i++) {
    const r = j4.get(t[i]) || j4.get(t.slice(i, i + 2));
    if (r !== void 0) {
      const [n, o] = r;
      let s;
      i === 0 ? [s] = e.splitText(i + 2) : [, s] = e.splitText(i, i + 2);
      const a = k7(n, o);
      return s.replace(a), a;
    }
  }
  return null;
}
function tee(e) {
  let t = e;
  for (; t !== null; ) {
    if (!t.isSimpleText())
      return;
    t = eee(t);
  }
}
function iee(e) {
  be(() => {
    if (!e.hasNodes([Q0]))
      throw new Error("EmojisPlugin: EmojiNode not registered on editor");
    return e.registerNodeTransform(L.TextNode, tee);
  }, [e]);
}
function ree() {
  const [e] = nt.useLexicalComposerContext();
  return iee(e), null;
}
var wD = {}, Fu = Ii, nee = nt, oee = it, Vu = L, see = X;
wD.LinkPlugin = function({ validateUrl: e }) {
  let [t] = nee.useLexicalComposerContext();
  return see.useEffect(() => {
    if (!t.hasNodes([Fu.LinkNode]))
      throw Error("LinkPlugin: LinkNode not registered on editor");
    return oee.mergeRegister(t.registerCommand(Fu.TOGGLE_LINK_COMMAND, (i) => {
      if (i === null)
        return Fu.toggleLink(i), !0;
      if (typeof i == "string")
        return e === void 0 || e(i) ? (Fu.toggleLink(i), !0) : !1;
      let { url: r, target: n, rel: o, title: s } = i;
      return Fu.toggleLink(r, { rel: o, target: n, title: s }), !0;
    }, Vu.COMMAND_PRIORITY_LOW), e !== void 0 ? t.registerCommand(
      Vu.PASTE_COMMAND,
      (i) => {
        let r = Vu.$getSelection();
        if (!Vu.$isRangeSelection(r) || r.isCollapsed() || !(i instanceof ClipboardEvent) || i.clipboardData == null)
          return !1;
        let n = i.clipboardData.getData("text");
        return e(n) ? r.getNodes().some((o) => Vu.$isElementNode(o)) ? !1 : (t.dispatchCommand(Fu.TOGGLE_LINK_COMMAND, n), i.preventDefault(), !0) : !1;
      },
      Vu.COMMAND_PRIORITY_LOW
    ) : () => {
    });
  }, [t, e]), null;
};
const aee = wD;
var lee = aee;
const cee = /* @__PURE__ */ new Set(["http:", "https:", "mailto:", "sms:", "tel:"]);
function S1(e) {
  try {
    const t = new URL(e);
    if (!cee.has(t.protocol))
      return "about:blank";
  } catch (t) {
    return e;
  }
  return e;
}
const uee = new RegExp(
  /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)/
);
function dee(e) {
  return e === "https://" || uee.test(e);
}
function A0() {
  return /* @__PURE__ */ f(lee.LinkPlugin, { validateUrl: dee });
}
var Ql = {}, wf = nt, ir = L, Vi = X, L4 = it, mee = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined" ? Vi.useLayoutEffect : Vi.useEffect;
let gee = class {
  constructor(t) {
    this.key = t, this.ref = { current: null }, this.setRefElement = this.setRefElement.bind(this);
  }
  setRefElement(t) {
    this.ref = { current: t };
  }
}, K4 = (e) => {
  const t = document.getElementById("typeahead-menu");
  if (t) {
    var i = t.getBoundingClientRect();
    i.top + i.height > window.innerHeight && t.scrollIntoView({ block: "center" }), 0 > i.top && t.scrollIntoView({ block: "center" }), e.scrollIntoView({ block: "nearest" });
  }
};
function hee(e) {
  var t = ir.$getSelection();
  if (!ir.$isRangeSelection(t) || !t.isCollapsed())
    return null;
  var i = t.anchor;
  if (i.type !== "text" || (t = i.getNode(), !t.isSimpleText()))
    return null;
  i = i.offset;
  let r = t.getTextContent().slice(0, i);
  var n = e.matchingString;
  e = e.replaceableString.length;
  for (let s = e; s <= n.length; s++)
    r.substr(-s) === n.substr(0, s) && (e = s);
  if (e = i - e, 0 > e)
    return null;
  let o;
  return e === 0 ? [o] = t.splitText(i) : [, o] = t.splitText(e, i), o;
}
function pee(e, t) {
  let i = getComputedStyle(e), r = i.position === "absolute";
  if (t = t ? /(auto|scroll|hidden)/ : /(auto|scroll)/, i.position === "fixed")
    return document.body;
  for (; e = e.parentElement; )
    if (i = getComputedStyle(e), (!r || i.position !== "static") && t.test(i.overflow + i.overflowY + i.overflowX))
      return e;
  return document.body;
}
function Y4(e, t) {
  return e = e.getBoundingClientRect(), t = t.getBoundingClientRect(), e.top > t.top && e.top < t.bottom;
}
function fee(e, t, i, r) {
  let [n] = wf.useLexicalComposerContext();
  Vi.useEffect(() => {
    if (t != null && e != null) {
      let o = n.getRootElement(), s = o != null ? pee(o, !1) : document.body, a = !1, l = Y4(t, s), c = function() {
        a || (window.requestAnimationFrame(function() {
          i(), a = !1;
        }), a = !0);
        const m = Y4(t, s);
        m !== l && (l = m, r != null && r(m));
      }, u = new ResizeObserver(i);
      return window.addEventListener("resize", i), document.addEventListener("scroll", c, { capture: !0, passive: !0 }), u.observe(t), () => {
        u.unobserve(t), window.removeEventListener("resize", i), document.removeEventListener(
          "scroll",
          c
        );
      };
    }
  }, [t, n, r, i, e]);
}
let U4 = ir.createCommand("SCROLL_TYPEAHEAD_OPTION_INTO_VIEW_COMMAND");
function Aee({ close: e, editor: t, anchorElementRef: i, resolution: r, options: n, menuRenderFn: o, onSelectOption: s, shouldSplitNodeWithQuery: a = !1 }) {
  let [l, c] = Vi.useState(null);
  Vi.useEffect(() => {
    c(0);
  }, [r.match && r.match.matchingString]);
  let u = Vi.useCallback((h) => {
    t.update(() => {
      const A = r.match != null && a ? hee(r.match) : null;
      s(h, A, e, r.match ? r.match.matchingString : "");
    });
  }, [t, a, r.match, s, e]), m = Vi.useCallback((h) => {
    const A = t.getRootElement();
    A !== null && (A.setAttribute("aria-activedescendant", "typeahead-item-" + h), c(h));
  }, [t]);
  Vi.useEffect(() => () => {
    let h = t.getRootElement();
    h !== null && h.removeAttribute("aria-activedescendant");
  }, [t]), mee(() => {
    n === null ? c(null) : l === null && m(0);
  }, [n, l, m]), Vi.useEffect(() => L4.mergeRegister(t.registerCommand(U4, ({ option: h }) => h.ref && h.ref.current != null ? (K4(h.ref.current), !0) : !1, ir.COMMAND_PRIORITY_LOW)), [t, m]), Vi.useEffect(() => L4.mergeRegister(t.registerCommand(ir.KEY_ARROW_DOWN_COMMAND, (h) => {
    if (n !== null && n.length && l !== null) {
      let A = l !== n.length - 1 ? l + 1 : 0;
      m(A);
      let y = n[A];
      y.ref != null && y.ref.current && t.dispatchCommand(U4, { index: A, option: y }), h.preventDefault(), h.stopImmediatePropagation();
    }
    return !0;
  }, ir.COMMAND_PRIORITY_LOW), t.registerCommand(ir.KEY_ARROW_UP_COMMAND, (h) => {
    if (n !== null && n.length && l !== null) {
      var A = l !== 0 ? l - 1 : n.length - 1;
      m(A), A = n[A], A.ref != null && A.ref.current && K4(A.ref.current), h.preventDefault(), h.stopImmediatePropagation();
    }
    return !0;
  }, ir.COMMAND_PRIORITY_LOW), t.registerCommand(ir.KEY_ESCAPE_COMMAND, (h) => (h.preventDefault(), h.stopImmediatePropagation(), e(), !0), ir.COMMAND_PRIORITY_LOW), t.registerCommand(ir.KEY_TAB_COMMAND, (h) => n === null || l === null || n[l] == null ? !1 : (h.preventDefault(), h.stopImmediatePropagation(), u(n[l]), !0), ir.COMMAND_PRIORITY_LOW), t.registerCommand(ir.KEY_ENTER_COMMAND, (h) => n === null || l === null || n[l] == null ? !1 : (h !== null && (h.preventDefault(), h.stopImmediatePropagation()), u(n[l]), !0), ir.COMMAND_PRIORITY_LOW)), [u, e, t, n, l, m]);
  let g = Vi.useMemo(() => ({ options: n, selectOptionAndCleanUp: u, selectedIndex: l, setHighlightedIndex: c }), [u, l, n]);
  return o(i, g, r.match ? r.match.matchingString : "");
}
function yee(e, t, i) {
  let [r] = wf.useLexicalComposerContext(), n = Vi.useRef(document.createElement("div")), o = Vi.useCallback(() => {
    const a = r.getRootElement(), l = n.current;
    var c = l.firstChild;
    if (a !== null && e !== null) {
      const { left: m, top: g, width: h, height: A } = e.getRect();
      if (l.style.top = `${g + window.pageYOffset}px`, l.style.left = `${m + window.pageXOffset}px`, l.style.height = `${A}px`, l.style.width = `${h}px`, c !== null) {
        var u = c.getBoundingClientRect();
        c = u.height, u = u.width;
        const y = a.getBoundingClientRect();
        m + u > y.right && (l.style.left = `${y.right - u + window.pageXOffset}px`), (g + c > window.innerHeight || g + c > y.bottom) && g - y.top > c && (l.style.top = `${g - c + window.pageYOffset - (A + 10)}px`);
      }
      l.isConnected || (i != null && (l.className = i), l.setAttribute("aria-label", "Typeahead menu"), l.setAttribute("id", "typeahead-menu"), l.setAttribute("role", "listbox"), l.style.display = "block", l.style.position = "absolute", document.body.append(l)), n.current = l, a.setAttribute("aria-controls", "typeahead-menu");
    }
  }, [r, e, i]);
  Vi.useEffect(() => {
    let a = r.getRootElement();
    if (e !== null)
      return o(), () => {
        a !== null && a.removeAttribute("aria-controls");
        let l = n.current;
        l !== null && l.isConnected && l.remove();
      };
  }, [r, o, e]);
  let s = Vi.useCallback((a) => {
    e !== null && (a || t(null));
  }, [e, t]);
  return fee(e, n.current, o, s), n;
}
function Eee(e, t) {
  var i = window.getSelection();
  if (i === null || !i.isCollapsed)
    return !1;
  let r = i.anchorNode;
  if (i = i.anchorOffset, r == null || i == null)
    return !1;
  try {
    t.setStart(r, e), t.setEnd(r, i);
  } catch (n) {
    return !1;
  }
  return !0;
}
function vee(e) {
  let t = null;
  return e.getEditorState().read(() => {
    var i = ir.$getSelection();
    if (ir.$isRangeSelection(i)) {
      var r = i.anchor;
      r.type !== "text" ? t = null : (i = r.getNode(), i.isSimpleText() ? (r = r.offset, t = i.getTextContent().slice(0, r)) : t = null);
    }
  }), t;
}
function bee(e, t) {
  return t !== 0 ? !1 : e.getEditorState().read(() => {
    var i = ir.$getSelection();
    return ir.$isRangeSelection(i) ? (i = i.anchor.getNode().getPreviousSibling(), ir.$isTextNode(i) && i.isTextEntity()) : !1;
  });
}
function Cee(e) {
  Vi.startTransition ? Vi.startTransition(e) : e();
}
function MD(e, t) {
  let i = getComputedStyle(e), r = i.position === "absolute";
  if (t = t ? /(auto|scroll|hidden)/ : /(auto|scroll)/, i.position === "fixed")
    return document.body;
  for (; e = e.parentElement; )
    if (i = getComputedStyle(e), (!r || i.position !== "static") && t.test(i.overflow + i.overflowY + i.overflowX))
      return e;
  return document.body;
}
function G4(e, t) {
  return e = e.getBoundingClientRect(), t = t.getBoundingClientRect(), e.top > t.top && e.top < t.bottom;
}
let xee = ir.createCommand("SCROLL_TYPEAHEAD_OPTION_INTO_VIEW_COMMAND");
Ql.LexicalTypeaheadMenuPlugin = function({ options: e, onQueryChange: t, onSelectOption: i, onOpen: r, onClose: n, menuRenderFn: o, triggerFn: s, anchorClassName: a }) {
  let [l] = wf.useLexicalComposerContext(), [c, u] = Vi.useState(null);
  a = yee(c, u, a);
  let m = Vi.useCallback(() => {
    u(null), n != null && c !== null && n();
  }, [n, c]), g = Vi.useCallback((h) => {
    u(h), r != null && c === null && r(h);
  }, [r, c]);
  return Vi.useEffect(() => {
    let h = l.registerUpdateListener(() => {
      l.getEditorState().read(() => {
        const A = document.createRange(), y = ir.$getSelection(), E = vee(l);
        if (ir.$isRangeSelection(y) && y.isCollapsed() && E !== null && A !== null) {
          var v = s(E, l);
          t(v ? v.matchingString : null), v === null || bee(l, v.leadOffset) || Eee(v.leadOffset, A) === null ? m() : Cee(() => g({ getRect: () => A.getBoundingClientRect(), match: v }));
        } else
          m();
      });
    });
    return () => {
      h();
    };
  }, [l, s, t, c, m, g]), c === null || l === null ? null : Vi.createElement(Aee, { close: m, resolution: c, editor: l, anchorElementRef: a, options: e, menuRenderFn: o, shouldSplitNodeWithQuery: !0, onSelectOption: i });
};
Ql.MenuOption = gee;
Ql.PUNCTUATION = `\\.,\\+\\*\\?\\$\\@\\|#{}\\(\\)\\^\\-\\[\\]\\\\/!%'"~=<>_:;`;
Ql.SCROLL_TYPEAHEAD_OPTION_INTO_VIEW_COMMAND = xee;
Ql.getScrollParent = MD;
Ql.useBasicTypeaheadTriggerMatch = function(e, { minLength: t = 1, maxLength: i = 75 }) {
  return Vi.useCallback((r) => {
    if (r = new RegExp("(^|\\s|\\()([" + e + "]((?:[^" + (e + `\\.,\\+\\*\\?\\$\\@\\|#{}\\(\\)\\^\\-\\[\\]\\\\/!%'"~=<>_:;\\s]){0,`) + i + "}))$").exec(r), r !== null) {
      let n = r[1], o = r[3];
      if (o.length >= t)
        return { leadOffset: r.index + n.length, matchingString: o, replaceableString: r[2] };
    }
    return null;
  }, [i, t, e]);
};
Ql.useDynamicPositioning = function(e, t, i, r) {
  let [n] = wf.useLexicalComposerContext();
  Vi.useEffect(() => {
    if (t != null && e != null) {
      let o = n.getRootElement(), s = o != null ? MD(o, !1) : document.body, a = !1, l = G4(t, s), c = function() {
        a || (window.requestAnimationFrame(function() {
          i(), a = !1;
        }), a = !0);
        const m = G4(t, s);
        m !== l && (l = m, r != null && r(m));
      }, u = new ResizeObserver(i);
      return window.addEventListener("resize", i), document.addEventListener("scroll", c, { capture: !0, passive: !0 }), u.observe(t), () => {
        u.unobserve(t), window.removeEventListener(
          "resize",
          i
        ), document.removeEventListener("scroll", c);
      };
    }
  }, [t, n, r, i, e]);
};
const Iee = Ql;
var y0 = Iee;
function See(e) {
  const t = e.textContent;
  return t !== null ? {
    node: ax(t)
  } : null;
}
const Ree = "background-color: rgba(24, 119, 232, 0.2)";
class Ig extends L.TextNode {
  constructor(i, r, n) {
    super(r != null ? r : i, n);
    Ze(this, "__mention");
    this.__mention = i;
  }
  static getType() {
    return "mention";
  }
  static clone(i) {
    return new Ig(i.__mention, i.__text, i.__key);
  }
  static importJSON(i) {
    const r = ax(i.mentionName);
    return r.setTextContent(i.text), r.setFormat(i.format), r.setDetail(i.detail), r.setMode(i.mode), r.setStyle(i.style), r;
  }
  exportJSON() {
    return ee(q({}, super.exportJSON()), {
      mentionName: this.__mention,
      type: "mention",
      version: 1
    });
  }
  createDOM(i) {
    const r = super.createDOM(i);
    return r.style.cssText = Ree, r.className = "mention", r;
  }
  exportDOM() {
    const i = Wt("span");
    return i.setAttribute("data-lexical-mention", "true"), i.textContent = this.__text, { element: i };
  }
  static importDOM() {
    return {
      span: (i) => i.hasAttribute("data-lexical-mention") ? {
        conversion: See,
        priority: 1
      } : null
    };
  }
  isTextEntity() {
    return !0;
  }
  canInsertTextBefore() {
    return !1;
  }
  canInsertTextAfter() {
    return !1;
  }
}
function ax(e) {
  const t = new Ig(e);
  return t.setMode("segmented").toggleDirectionless(), L.$applyNodeReplacement(t);
}
const ND = `\\.,\\+\\*\\?\\$\\@\\|#{}\\(\\)\\^\\-\\[\\]\\\\/!%'"~=<>_:;`, kee = "\\b[A-Z][^\\s" + ND + "]", wee = {
  NAME: kee,
  PUNCTUATION: ND
}, TD = wee.PUNCTUATION, lx = ["@"].join(""), BD = "[^" + lx + TD + "\\s]", Mee = "(?:\\.[ |$]| |[" + TD + "]|)", Nee = 75, Tee = new RegExp(
  "(^|\\s|\\()([" + lx + "]((?:" + BD + Mee + "){0," + Nee + "}))$"
), Bee = 50, Dee = new RegExp(
  "(^|\\s|\\()([" + lx + "]((?:" + BD + "){0," + Bee + "}))$"
), Oee = 5, dE = /* @__PURE__ */ new Map(), Fee = [
  "Aayla Secura",
  "Adi Gallia",
  "Admiral Dodd Rancit",
  "Admiral Firmus Piett",
  "Admiral Gial Ackbar",
  "Admiral Ozzel",
  "Admiral Raddus",
  "Admiral Terrinald Screed",
  "Admiral Trench",
  "Admiral U.O. Statura",
  "Agen Kolar",
  "Agent Kallus",
  "Aiolin and Morit Astarte",
  "Aks Moe",
  "Almec",
  "Alton Kastle",
  "Amee",
  "AP-5",
  "Armitage Hux",
  "Artoo",
  "Arvel Crynyd",
  "Asajj Ventress",
  "Aurra Sing",
  "AZI-3",
  "Bala-Tik",
  "Barada",
  "Bargwill Tomder",
  "Baron Papanoida",
  "Barriss Offee",
  "Baze Malbus",
  "Bazine Netal",
  "BB-8",
  "BB-9E",
  "Ben Quadinaros",
  "Berch Teller",
  "Beru Lars",
  "Bib Fortuna",
  "Biggs Darklighter",
  "Black Krrsantan",
  "Bo-Katan Kryze",
  "Boba Fett",
  "Bobbajo",
  "Bodhi Rook",
  "Borvo the Hutt",
  "Boss Nass",
  "Bossk",
  "Breha Antilles-Organa",
  "Bren Derlin",
  "Brendol Hux",
  "BT-1",
  "C-3PO",
  "C1-10P",
  "Cad Bane",
  "Caluan Ematt",
  "Captain Gregor",
  "Captain Phasma",
  "Captain Quarsh Panaka",
  "Captain Rex",
  "Carlist Rieekan",
  "Casca Panzoro",
  "Cassian Andor",
  "Cassio Tagge",
  "Cham Syndulla",
  "Che Amanwe Papanoida",
  "Chewbacca",
  "Chi Eekway Papanoida",
  "Chief Chirpa",
  "Chirrut Îmwe",
  "Ciena Ree",
  "Cin Drallig",
  "Clegg Holdfast",
  "Cliegg Lars",
  "Coleman Kcaj",
  "Coleman Trebor",
  "Colonel Kaplan",
  "Commander Bly",
  "Commander Cody (CC-2224)",
  "Commander Fil (CC-3714)",
  "Commander Fox",
  "Commander Gree",
  "Commander Jet",
  "Commander Wolffe",
  "Conan Antonio Motti",
  "Conder Kyl",
  "Constable Zuvio",
  "Cordé",
  "Cpatain Typho",
  "Crix Madine",
  "Cut Lawquane",
  "Dak Ralter",
  "Dapp",
  "Darth Bane",
  "Darth Maul",
  "Darth Tyranus",
  "Daultay Dofine",
  "Del Meeko",
  "Delian Mors",
  "Dengar",
  "Depa Billaba",
  "Derek Klivian",
  "Dexter Jettster",
  "Dineé Ellberger",
  "DJ",
  "Doctor Aphra",
  "Doctor Evazan",
  "Dogma",
  "Dormé",
  "Dr. Cylo",
  "Droidbait",
  "Droopy McCool",
  "Dryden Vos",
  "Dud Bolt",
  "Ebe E. Endocott",
  "Echuu Shen-Jon",
  "Eeth Koth",
  "Eighth Brother",
  "Eirtaé",
  "Eli Vanto",
  "Ellé",
  "Ello Asty",
  "Embo",
  "Eneb Ray",
  "Enfys Nest",
  "EV-9D9",
  "Evaan Verlaine",
  "Even Piell",
  "Ezra Bridger",
  "Faro Argyus",
  "Feral",
  "Fifth Brother",
  "Finis Valorum",
  "Finn",
  "Fives",
  "FN-1824",
  "FN-2003",
  "Fodesinbeed Annodue",
  "Fulcrum",
  "FX-7",
  "GA-97",
  "Galen Erso",
  "Gallius Rax",
  'Garazeb "Zeb" Orrelios',
  "Gardulla the Hutt",
  "Garrick Versio",
  "Garven Dreis",
  "Gavyn Sykes",
  "Gideon Hask",
  "Gizor Dellso",
  "Gonk droid",
  "Grand Inquisitor",
  "Greeata Jendowanian",
  "Greedo",
  "Greer Sonnel",
  "Grievous",
  "Grummgar",
  "Gungi",
  "Hammerhead",
  "Han Solo",
  "Harter Kalonia",
  "Has Obbit",
  "Hera Syndulla",
  "Hevy",
  "Hondo Ohnaka",
  "Huyang",
  "Iden Versio",
  "IG-88",
  "Ima-Gun Di",
  "Inquisitors",
  "Inspector Thanoth",
  "Jabba",
  "Jacen Syndulla",
  "Jan Dodonna",
  "Jango Fett",
  "Janus Greejatus",
  "Jar Jar Binks",
  "Jas Emari",
  "Jaxxon",
  "Jek Tono Porkins",
  "Jeremoch Colton",
  "Jira",
  "Jobal Naberrie",
  "Jocasta Nu",
  "Joclad Danva",
  "Joh Yowza",
  "Jom Barell",
  "Joph Seastriker",
  "Jova Tarkin",
  "Jubnuk",
  "Jyn Erso",
  "K-2SO",
  "Kanan Jarrus",
  "Karbin",
  "Karina the Great",
  "Kes Dameron",
  "Ketsu Onyo",
  "Ki-Adi-Mundi",
  "King Katuunko",
  "Kit Fisto",
  "Kitster Banai",
  "Klaatu",
  "Klik-Klak",
  "Korr Sella",
  "Kylo Ren",
  "L3-37",
  "Lama Su",
  "Lando Calrissian",
  "Lanever Villecham",
  "Leia Organa",
  "Letta Turmond",
  "Lieutenant Kaydel Ko Connix",
  "Lieutenant Thire",
  "Lobot",
  "Logray",
  "Lok Durd",
  "Longo Two-Guns",
  "Lor San Tekka",
  "Lorth Needa",
  "Lott Dod",
  "Luke Skywalker",
  "Lumat",
  "Luminara Unduli",
  "Lux Bonteri",
  "Lyn Me",
  "Lyra Erso",
  "Mace Windu",
  "Malakili",
  "Mama the Hutt",
  "Mars Guo",
  "Mas Amedda",
  "Mawhonic",
  "Max Rebo",
  "Maximilian Veers",
  "Maz Kanata",
  "ME-8D9",
  "Meena Tills",
  "Mercurial Swift",
  "Mina Bonteri",
  "Miraj Scintel",
  "Mister Bones",
  "Mod Terrik",
  "Moden Canady",
  "Mon Mothma",
  "Moradmin Bast",
  "Moralo Eval",
  "Morley",
  "Mother Talzin",
  "Nahdar Vebb",
  "Nahdonnis Praji",
  "Nien Nunb",
  "Niima the Hutt",
  "Nines",
  "Norra Wexley",
  "Nute Gunray",
  "Nuvo Vindi",
  "Obi-Wan Kenobi",
  "Odd Ball",
  "Ody Mandrell",
  "Omi",
  "Onaconda Farr",
  "Oola",
  "OOM-9",
  "Oppo Rancisis",
  "Orn Free Taa",
  "Oro Dassyne",
  "Orrimarko",
  "Osi Sobeck",
  "Owen Lars",
  "Pablo-Jill",
  "Padmé Amidala",
  "Pagetti Rook",
  "Paige Tico",
  "Paploo",
  "Petty Officer Thanisson",
  "Pharl McQuarrie",
  "Plo Koon",
  "Po Nudo",
  "Poe Dameron",
  "Poggle the Lesser",
  "Pong Krell",
  "Pooja Naberrie",
  "PZ-4CO",
  "Quarrie",
  "Quay Tolsite",
  "Queen Apailana",
  "Queen Jamillia",
  "Queen Neeyutnee",
  "Qui-Gon Jinn",
  "Quiggold",
  "Quinlan Vos",
  "R2-D2",
  "R2-KT",
  "R3-S6",
  "R4-P17",
  "R5-D4",
  "RA-7",
  "Rabé",
  "Rako Hardeen",
  "Ransolm Casterfo",
  "Rappertunie",
  "Ratts Tyerell",
  "Raymus Antilles",
  "Ree-Yees",
  "Reeve Panzoro",
  "Rey",
  "Ric Olié",
  "Riff Tamson",
  "Riley",
  "Rinnriyin Di",
  "Rio Durant",
  "Rogue Squadron",
  "Romba",
  "Roos Tarpals",
  "Rose Tico",
  "Rotta the Hutt",
  "Rukh",
  "Rune Haako",
  "Rush Clovis",
  "Ruwee Naberrie",
  "Ryoo Naberrie",
  "Sabé",
  "Sabine Wren",
  "Saché",
  "Saelt-Marae",
  "Saesee Tiin",
  "Salacious B. Crumb",
  "San Hill",
  "Sana Starros",
  "Sarco Plank",
  "Sarkli",
  "Satine Kryze",
  "Savage Opress",
  "Sebulba",
  "Senator Organa",
  "Sergeant Kreel",
  "Seventh Sister",
  "Shaak Ti",
  "Shara Bey",
  "Shmi Skywalker",
  "Shu Mai",
  "Sidon Ithano",
  "Sifo-Dyas",
  "Sim Aloo",
  "Siniir Rath Velus",
  "Sio Bibble",
  "Sixth Brother",
  "Slowen Lo",
  "Sly Moore",
  "Snaggletooth",
  "Snap Wexley",
  "Snoke",
  "Sola Naberrie",
  "Sora Bulq",
  "Strono Tuggs",
  "Sy Snootles",
  "Tallissan Lintra",
  "Tarfful",
  "Tasu Leech",
  "Taun We",
  "TC-14",
  "Tee Watt Kaa",
  "Teebo",
  "Teedo",
  "Teemto Pagalies",
  "Temiri Blagg",
  "Tessek",
  "Tey How",
  "Thane Kyrell",
  "The Bendu",
  "The Smuggler",
  "Thrawn",
  "Tiaan Jerjerrod",
  "Tion Medon",
  "Tobias Beckett",
  "Tulon Voidgazer",
  "Tup",
  "U9-C4",
  "Unkar Plutt",
  "Val Beckett",
  "Vanden Willard",
  "Vice Admiral Amilyn Holdo",
  "Vober Dand",
  "WAC-47",
  "Wag Too",
  "Wald",
  "Walrus Man",
  "Warok",
  "Wat Tambor",
  "Watto",
  "Wedge Antilles",
  "Wes Janson",
  "Wicket W. Warrick",
  "Wilhuff Tarkin",
  "Wollivan",
  "Wuher",
  "Wullf Yularen",
  "Xamuel Lennox",
  "Yaddle",
  "Yarael Poof",
  "Yoda",
  "Zam Wesell",
  "Zev Senesca",
  "Ziro the Hutt",
  "Zuckuss"
], Vee = {
  search(e, t) {
    setTimeout(() => {
      const i = Fee.filter((r) => r.toLowerCase().includes(e.toLowerCase()));
      t(i);
    }, 500);
  }
};
function qee(e) {
  const [t, i] = se([]);
  return be(() => {
    const r = dE.get(e);
    if (e == null) {
      i([]);
      return;
    }
    if (r !== null) {
      if (r !== void 0) {
        i(r);
        return;
      }
      dE.set(e, null), Vee.search(e, (n) => {
        dE.set(e, n), i(n);
      });
    }
  }, [e]), t;
}
function jee(e, t) {
  let i = Tee.exec(e);
  if (i === null && (i = Dee.exec(e)), i !== null) {
    const r = i[1], n = i[3];
    if (n.length >= t)
      return {
        leadOffset: i.index + r.length,
        matchingString: n,
        replaceableString: i[2]
      };
  }
  return null;
}
function Lee(e) {
  return jee(e, 1);
}
class Kee extends y0.MenuOption {
  constructor(i, r) {
    super(i);
    Ze(this, "name");
    Ze(this, "picture");
    this.name = i, this.picture = r;
  }
}
function Yee({
  index: e,
  isSelected: t,
  onClick: i,
  onMouseEnter: r,
  option: n
}) {
  let o = "item";
  return t && (o += " selected"), /* @__PURE__ */ V(
    "li",
    {
      tabIndex: -1,
      className: o,
      ref: n.setRefElement,
      role: "option",
      "aria-selected": t,
      id: "typeahead-item-" + e,
      onMouseEnter: r,
      onClick: i,
      children: [
        n.picture,
        /* @__PURE__ */ f("span", { className: "text", children: n.name })
      ]
    },
    n.key
  );
}
function Qb() {
  const [e, t] = nt.useLexicalComposerContext(), [i, r] = se(null), n = qee(i), o = y0.useBasicTypeaheadTriggerMatch("/", {
    minLength: 0
  }), s = we(
    () => n.map((c) => new Kee(c, /* @__PURE__ */ f("i", { className: "icon user" }))).slice(0, Oee),
    [n]
  ), a = ye(
    (c, u, m) => {
      e.update(() => {
        const g = ax(c.name);
        u && u.replace(g), g.select(), m();
      });
    },
    [e]
  ), l = ye(
    (c) => o(c, e) !== null ? null : Lee(c),
    [o, e]
  );
  return /* @__PURE__ */ f(
    y0.LexicalTypeaheadMenuPlugin,
    {
      onQueryChange: r,
      onSelectOption: a,
      triggerFn: l,
      options: s,
      menuRenderFn: (c, { selectedIndex: u, selectOptionAndCleanUp: m, setHighlightedIndex: g }) => {
        var h;
        return c.current && n.length ? mg.createPortal(
          /* @__PURE__ */ f(
            "div",
            {
              className: me("typeahead-popover mentions-menu", (h = t.getTheme()) == null ? void 0 : h.typeaheadPopover),
              children: /* @__PURE__ */ f("ul", { children: s.map((A, y) => /* @__PURE__ */ f(
                Yee,
                {
                  index: y,
                  isSelected: u === y,
                  onClick: () => {
                    g(y), m(A);
                  },
                  onMouseEnter: () => {
                    g(y);
                  },
                  option: A
                },
                A.key
              )) })
            }
          ),
          c.current
        ) : null;
      }
    }
  );
}
var DD = {}, nu = {}, Sa = L, dp = it;
let cx = class OD extends Sa.ElementNode {
  static getType() {
    return "mark";
  }
  static clone(t) {
    return new OD(Array.from(t.__ids), t.__key);
  }
  static importDOM() {
    return null;
  }
  static importJSON(t) {
    let i = R1(t.ids);
    return i.setFormat(t.format), i.setIndent(t.indent), i.setDirection(t.direction), i;
  }
  exportJSON() {
    return ee(q({}, super.exportJSON()), { ids: this.getIDs(), type: "mark", version: 1 });
  }
  constructor(t, i) {
    super(i), this.__ids = t || [];
  }
  createDOM(t) {
    let i = document.createElement("mark");
    return dp.addClassNamesToElement(i, t.theme.mark), 1 < this.__ids.length && dp.addClassNamesToElement(i, t.theme.markOverlap), i;
  }
  updateDOM(t, i, r) {
    t = t.__ids.length;
    let n = this.__ids.length;
    return r = r.theme.markOverlap, t !== n && (t === 1 ? n === 2 && dp.addClassNamesToElement(i, r) : n === 1 && dp.removeClassNamesFromElement(i, r)), !1;
  }
  hasID(t) {
    let i = this.getIDs();
    for (let r = 0; r < i.length; r++)
      if (t === i[r])
        return !0;
    return !1;
  }
  getIDs() {
    let t = this.getLatest();
    return Tc(t) ? t.__ids : [];
  }
  addID(t) {
    var i = this.getWritable();
    if (Tc(i)) {
      let r = i.__ids;
      for (i.__ids = r, i = 0; i < r.length; i++)
        if (t === r[i])
          return;
      r.push(t);
    }
  }
  deleteID(t) {
    var i = this.getWritable();
    if (Tc(i)) {
      let r = i.__ids;
      for (i.__ids = r, i = 0; i < r.length; i++)
        if (t === r[i]) {
          r.splice(i, 1);
          break;
        }
    }
  }
  insertNewAfter(t, i = !0) {
    return t = this.getParentOrThrow().insertNewAfter(t, i), Sa.$isElementNode(t) ? (i = R1(this.__ids), t.append(i), i) : null;
  }
  canInsertTextBefore() {
    return !1;
  }
  canInsertTextAfter() {
    return !1;
  }
  canBeEmpty() {
    return !1;
  }
  isInline() {
    return !0;
  }
  extractWithChild(t, i, r) {
    if (!Sa.$isRangeSelection(i) || r === "html")
      return !1;
    let n = i.anchor, o = i.focus;
    return t = n.getNode(), r = o.getNode(), i = i.isBackward() ? n.offset - o.offset : o.offset - n.offset, this.isParentOf(t) && this.isParentOf(r) && this.getTextContent().length === i;
  }
  excludeFromCopy(t) {
    return t !== "clone";
  }
};
function R1(e) {
  return Sa.$applyNodeReplacement(new cx(e));
}
function Tc(e) {
  return e instanceof cx;
}
nu.$createMarkNode = R1;
nu.$getMarkIDs = function(e, t) {
  for (; e !== null; ) {
    if (Tc(e))
      return e.getIDs();
    if (Sa.$isTextNode(e) && t === e.getTextContentSize()) {
      let i = e.getNextSibling();
      if (Tc(i))
        return i.getIDs();
    }
    e = e.getParent();
  }
  return null;
};
nu.$isMarkNode = Tc;
nu.$unwrapMarkNode = function(e) {
  let t = e.getChildren(), i = null;
  for (let r = 0; r < t.length; r++) {
    let n = t[r];
    i === null ? e.insertBefore(n) : i.insertAfter(n), i = n;
  }
  e.remove();
};
nu.$wrapSelectionInMarkNode = function(e, t, i, r) {
  let n = e.getNodes();
  var o = e.anchor.offset, s = e.focus.offset;
  e = n.length;
  let a = t ? s : o;
  o = t ? o : s;
  let l, c;
  for (s = 0; s < e; s++) {
    var u = n[s];
    if (Sa.$isElementNode(c) && c.isParentOf(u))
      continue;
    var m = s === 0;
    let h = s === e - 1;
    var g = null;
    if (Sa.$isTextNode(u)) {
      g = u.getTextContentSize();
      let A = m ? a : 0, y = h ? o : g;
      if (A === 0 && y === 0)
        continue;
      u = u.splitText(A, y), g = 1 < u.length && (u.length === 3 || m && !h || y === g) ? u[1] : u[0];
    } else {
      if (Tc(u))
        continue;
      Sa.$isElementNode(u) && u.isInline() && (g = u);
    }
    g !== null ? g && g.is(l) || (m = g.getParent(), m != null && m.is(l) || (c = void 0), l = m, c === void 0 && (c = (r || R1)([i]), g.insertBefore(c)), c.append(g)) : c = l = void 0;
  }
  Sa.$isElementNode(c) && (t ? c.selectStart() : c.selectEnd());
};
nu.MarkNode = cx;
const Uee = nu;
var FD = Uee, Gee = BB, Qee = Ii, Wee = FD, Zee = it, Bs = L, ui = X;
let VD = Object.freeze({ "	": "\\t", "\n": "\\n" }), Q4 = new RegExp(Object.keys(VD).join("|"), "g"), Ds = Object.freeze({ ancestorHasNextSibling: "|", ancestorIsLastChild: " ", hasNextSibling: "├", isLastChild: "└", selectedChar: "^", selectedLine: ">" });
function Jee(e) {
  let [t, i] = ui.useState([]);
  return ui.useEffect(() => {
    let r = /* @__PURE__ */ new Set();
    for (let [n] of e._commands)
      r.add(e.registerCommand(n, (o) => (i((s) => (s = [...s], s.push({ payload: o, type: n.type ? n.type : "UNKNOWN" }), 10 < s.length && s.shift(), s)), !1), Bs.COMMAND_PRIORITY_HIGH));
    return () => r.forEach((n) => n());
  }, [e]), ui.useMemo(() => t, [t]);
}
function Pee(e) {
  let t = "";
  var i = jD(e);
  t += `: range ${i !== "" ? `{ ${i} }` : ""} ${e.style !== "" ? `{ style: ${e.style} } ` : ""}`, i = e.anchor, e = e.focus;
  let r = i.offset, n = e.offset;
  return t += `
  ├ anchor { key: ${i.key}, offset: ${r === null ? "null" : r}, type: ${i.type} }`, t += `
  └ focus { key: ${e.key}, offset: ${n === null ? "null" : n}, type: ${e.type} }`;
}
function mE(e, t, i) {
  let r = e.getEditorState(), n = e._config, o = e._compositionKey, s = e._editable;
  if (i) {
    let l = "";
    return r.read(() => {
      var c = Gee.$generateHtmlFromNodes(e);
      let u = document.createElement("div");
      u.innerHTML = c.trim(), l = LD(u, 0).innerHTML;
    }), l;
  }
  let a = ` root
`;
  if (i = r.read(() => {
    const l = Bs.$getSelection();
    return qD(Bs.$getRoot(), (c, u) => {
      const m = `(${c.getKey()})`, g = c.getType() || "", h = c.isSelected(), A = Wee.$isMarkNode(c) ? ` id: [ ${c.getIDs().join(", ")} ] ` : "";
      var y = a, E = h ? Ds.selectedLine : " ", v = u.join(" ");
      if (Bs.$isTextNode(c)) {
        var C = c.getTextContent(), x = C.length === 0 ? "(empty)" : `"${W4(C)}"`;
        C = [jD(c), _ee(c), $ee(c)].filter(Boolean).join(", "), C = [x, C.length !== 0 ? `{ ${C} }` : null].filter(Boolean).join(" ").trim();
      } else if (Qee.$isLinkNode(c)) {
        C = c.getURL(), C = C.length === 0 ? "(empty)" : `"${W4(C)}"`, x = c.getTarget(), x != null && (x = "target: " + x);
        var S = Boolean, R = c.getRel();
        R != null && (R = "rel: " + R);
        let w = c.getTitle();
        w != null && (w = "title: " + w), x = [x, R, w].filter(S).join(", "), C = [C, x.length !== 0 ? `{ ${x} }` : null].filter(Boolean).join(" ").trim();
      } else
        C = "";
      a = y + `${E} ${v} ${m} ${g} ${A} ${C}
`, a += ete({ indent: u, isSelected: h, node: c, nodeKeyDisplay: m, selection: l, typeDisplay: g });
    }), l === null ? ": null" : Bs.$isRangeSelection(l) ? Pee(l) : Bs.DEPRECATED_$isGridSelection(l) ? `: grid
  └ { grid: ${l.gridKey}, anchorCell: ${l.anchor.key}, focusCell: ${l.focus.key} }` : `: node
  └ [${Array.from(l._nodes).join(", ")}]`;
  }), a += `
 selection` + i, a += `

 commands:`, t.length)
    for (let { type: l, payload: c } of t)
      a += `
  └ { type: ${l}, payload: ${c instanceof Event ? c.constructor.name : c} }`;
  else
    a += `
  └ None dispatched.`;
  return a += `

 editor:`, a += `
  └ namespace ${n.namespace}`, o !== null && (a += `
  └ compositionKey ${o}`), a += `
  └ editable ${String(s)}`;
}
function qD(e, t, i = []) {
  e = e.getChildren();
  let r = e.length;
  e.forEach((n, o) => {
    t(n, i.concat(o === r - 1 ? Ds.isLastChild : Ds.hasNextSibling)), Bs.$isElementNode(n) && qD(n, t, i.concat(o === r - 1 ? Ds.ancestorIsLastChild : Ds.ancestorHasNextSibling));
  });
}
function W4(e) {
  return Object.entries(VD).reduce((t, [i, r]) => t.replace(new RegExp(i, "g"), String(r)), e);
}
let zee = [(e) => e.hasFormat("bold") && "Bold", (e) => e.hasFormat("code") && "Code", (e) => e.hasFormat("italic") && "Italic", (e) => e.hasFormat("strikethrough") && "Strikethrough", (e) => e.hasFormat("subscript") && "Subscript", (e) => e.hasFormat("superscript") && "Superscript", (e) => e.hasFormat("underline") && "Underline"], Hee = [(e) => e.isDirectionless() && "Directionless", (e) => e.isUnmergeable() && "Unmergeable"], Xee = [(e) => e.isToken() && "Token", (e) => e.isSegmented() && "Segmented"];
function _ee(e) {
  let t = Hee.map((i) => i(e)).filter(Boolean).join(", ").toLocaleLowerCase();
  return t !== "" && (t = "detail: " + t), t;
}
function $ee(e) {
  let t = Xee.map((i) => i(e)).filter(Boolean).join(", ").toLocaleLowerCase();
  return t !== "" && (t = "mode: " + t), t;
}
function jD(e) {
  let t = zee.map((i) => i(e)).filter(Boolean).join(", ").toLocaleLowerCase();
  return t !== "" && (t = "format: " + t), t;
}
function ete({ indent: e, isSelected: t, node: i, nodeKeyDisplay: r, selection: n, typeDisplay: o }) {
  if (!Bs.$isTextNode(i) || !Bs.$isRangeSelection(n) || !t || Bs.$isElementNode(i))
    return "";
  t = n.anchor;
  var s = n.focus;
  if (i.getTextContent() === "" || t.getNode() === n.focus.getNode() && t.offset === s.offset)
    return "";
  s = n.anchor;
  let a = n.focus, l = i.getTextContent(), c = l.length;
  if (t = n = -1, s.type === "text" && a.type === "text") {
    let g = s.getNode(), h = a.getNode();
    g === h && i === g && s.offset !== a.offset ? [n, t] = s.offset < a.offset ? [s.offset, a.offset] : [
      a.offset,
      s.offset
    ] : i === g ? [n, t] = g.isBefore(h) ? [s.offset, c] : [0, s.offset] : i === h ? [n, t] = h.isBefore(g) ? [a.offset, c] : [0, a.offset] : [n, t] = [0, c];
  }
  i = (l.slice(0, n).match(Q4) || []).length, s = (l.slice(n, t).match(Q4) || []).length;
  let [u, m] = [n + i, t + i + s];
  return u === m ? "" : (i = e[e.length - 1] === Ds.hasNextSibling ? Ds.ancestorHasNextSibling : Ds.ancestorIsLastChild, e = [...e.slice(0, e.length - 1), i], i = Array(u + 1).fill(" "), n = Array(m - u).fill(Ds.selectedChar), r = Array(r.length + (o.length + 3)).fill(" "), [Ds.selectedLine, e.join(" "), [...r, ...i, ...n].join("")].join(" ") + `
`);
}
function LD(e, t) {
  let i = Array(t++ + 1).join("  "), r = Array(t - 1).join("  "), n;
  for (let o = 0; o < e.children.length; o++)
    n = document.createTextNode(`
` + i), e.insertBefore(n, e.children[o]), LD(e.children[o], t), e.lastElementChild === e.children[o] && (n = document.createTextNode(`
` + r), e.appendChild(n));
  return e;
}
DD.TreeView = function({ treeTypeButtonClassName: e, timeTravelButtonClassName: t, timeTravelPanelSliderClassName: i, timeTravelPanelButtonClassName: r, viewClassName: n, timeTravelPanelClassName: o, editor: s }) {
  let [a, l] = ui.useState([]), [c, u] = ui.useState(""), [m, g] = ui.useState(!1), [h, A] = ui.useState(!1), y = ui.useRef(0), E = ui.useRef(null), v = ui.useRef(null), [C, x] = ui.useState(!1), [S, R] = ui.useState(!1), [w, T] = ui.useState(!1), N = ui.useRef(null), D = Jee(s), O = ui.useCallback((Y) => {
    const P = mE(s, D, h);
    u(P), m || l((z) => [...z, [Date.now(), Y]]);
  }, [
    D,
    s,
    m,
    h
  ]);
  ui.useEffect(() => {
    let Y = s.getEditorState();
    !w && 1e3 > Y._nodeMap.size && u(mE(s, D, h));
  }, [D, s, w, h]), ui.useEffect(() => Zee.mergeRegister(s.registerUpdateListener(({ editorState: Y }) => {
    !w && 1e3 < Y._nodeMap.size && (N.current = Y, R(!0), !w) || O(Y);
  }), s.registerEditableListener(() => {
    let Y = mE(s, D, h);
    u(Y);
  })), [D, s, h, S, O, w]);
  let F = a.length;
  return ui.useEffect(() => {
    if (C) {
      let Y, P = () => {
        const z = y.current;
        z === F - 1 ? x(!1) : Y = setTimeout(() => {
          y.current++;
          const W = y.current, H = v.current;
          H !== null && (H.value = String(W)), s.setEditorState(a[W][1]), P();
        }, a[z + 1][0] - a[z][0]);
      };
      return P(), () => {
        clearTimeout(Y);
      };
    }
  }, [a, C, s, F]), ui.useEffect(() => {
    let Y = E.current;
    if (Y !== null)
      return Y.__lexicalEditor = s, () => {
        Y.__lexicalEditor = null;
      };
  }, [s]), ui.createElement("div", { className: n }, !w && S ? ui.createElement("div", { style: { padding: 20 } }, ui.createElement("span", { style: { marginRight: 20 } }, "Detected large EditorState, this can impact debugging performance."), ui.createElement("button", { onClick: () => {
    T(!0);
    let Y = N.current;
    Y !== null && (N.current = null, O(Y));
  }, style: {
    background: "transparent",
    border: "1px solid white",
    color: "white",
    cursor: "pointer",
    padding: 5
  } }, "Show full tree")) : null, w ? null : ui.createElement("button", { onClick: () => A(!h), className: e, type: "button" }, h ? "Tree" : "Export DOM"), !m && (w || !S) && 2 < F && ui.createElement("button", { onClick: () => {
    let Y = s.getRootElement();
    Y !== null && (Y.contentEditable = "false", y.current = F - 1, g(!0));
  }, className: t, type: "button" }, "Time Travel"), (w || !S) && ui.createElement("pre", { ref: E }, c), m && (w || !S) && ui.createElement("div", { className: o }, ui.createElement("button", {
    className: r,
    onClick: () => {
      y.current === F - 1 && (y.current = 1), x(!C);
    },
    type: "button"
  }, C ? "Pause" : "Play"), ui.createElement("input", { className: i, ref: v, onChange: (Y) => {
    Y = Number(Y.target.value);
    let P = a[Y];
    P && (y.current = Y, s.setEditorState(P[1]));
  }, type: "range", min: "1", max: F - 1 }), ui.createElement("button", { className: r, onClick: () => {
    var Y = s.getRootElement();
    if (Y !== null) {
      Y.contentEditable = "true", Y = a.length - 1, s.setEditorState(a[Y][1]);
      let P = v.current;
      P !== null && (P.value = String(Y)), g(!1), x(!1);
    }
  }, type: "button" }, "Exit")));
};
const tte = DD;
var ite = tte;
function KD() {
  var i;
  const [e, t] = nt.useLexicalComposerContext();
  return /* @__PURE__ */ f(
    ite.TreeView,
    {
      viewClassName: me("tree-view-output", (i = t.getTheme()) == null ? void 0 : i.treeViewOutput),
      treeTypeButtonClassName: "debug-treetype-button",
      timeTravelPanelClassName: "debug-timetravel-panel",
      timeTravelButtonClassName: "debug-timetravel-button",
      timeTravelPanelSliderClassName: "debug-timetravel-panel-slider",
      timeTravelPanelButtonClassName: "debug-timetravel-panel-button",
      editor: e
    }
  );
}
const rte = "_root_g1qmr_1", nte = {
  root: rte
};
var YD = {}, ote = nt, Cm = X;
function Wb() {
  return Wb = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = arguments[t], r;
      for (r in i)
        Object.prototype.hasOwnProperty.call(i, r) && (e[r] = i[r]);
    }
    return e;
  }, Wb.apply(this, arguments);
}
var ste = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined" ? Cm.useLayoutEffect : Cm.useEffect;
YD.ContentEditable = function(x) {
  var S = x, { ariaActiveDescendant: e, ariaAutoComplete: t, ariaControls: i, ariaDescribedBy: r, ariaExpanded: n, ariaLabel: o, ariaLabelledBy: s, ariaMultiline: a, ariaOwns: l, ariaRequired: c, autoCapitalize: u, className: m, id: g, role: h = "textbox", spellCheck: A = !0, style: y, tabIndex: E, "data-testid": v } = S, C = Fe(S, ["ariaActiveDescendant", "ariaAutoComplete", "ariaControls", "ariaDescribedBy", "ariaExpanded", "ariaLabel", "ariaLabelledBy", "ariaMultiline", "ariaOwns", "ariaRequired", "autoCapitalize", "className", "id", "role", "spellCheck", "style", "tabIndex", "data-testid"]);
  let [R] = ote.useLexicalComposerContext(), [w, T] = Cm.useState(!1), N = Cm.useCallback((D) => {
    R.setRootElement(D);
  }, [R]);
  return ste(() => (T(R.isEditable()), R.registerEditableListener((D) => {
    T(D);
  })), [R]), Cm.createElement(
    "div",
    Wb({}, C, { "aria-activedescendant": w ? e : void 0, "aria-autocomplete": w ? t : "none", "aria-controls": w ? i : void 0, "aria-describedby": r, "aria-expanded": w && h === "combobox" ? !!n : void 0, "aria-label": o, "aria-labelledby": s, "aria-multiline": a, "aria-owns": w ? l : void 0, "aria-readonly": w ? void 0 : !0, "aria-required": c, autoCapitalize: u, className: m, contentEditable: w, "data-testid": v, id: g, ref: N, role: h, spellCheck: A, style: y, tabIndex: E })
  );
};
const ate = YD;
var lte = ate;
function kl({ className: e }) {
  return /* @__PURE__ */ f(lte.ContentEditable, { className: e || nte.root });
}
const cte = "_contentEditable_1xlla_1", ute = "_placeholder_1xlla_18", dte = "_imageControlWrapperResizing_1xlla_32", Zb = {
  contentEditable: cte,
  placeholder: ute,
  imageControlWrapperResizing: dte
};
function gE(e, t, i) {
  return Math.min(Math.max(e, t), i);
}
const bi = {
  east: 1,
  north: 8,
  south: 2,
  west: 4
};
function mte({
  onResizeStart: e,
  onResizeEnd: t,
  buttonRef: i,
  imageRef: r,
  maxWidth: n,
  editor: o,
  showCaption: s,
  setShowCaption: a,
  captionsEnabled: l
}) {
  const c = Ne(null), u = Ne({
    priority: "",
    value: "default"
  }), m = Ne({
    currentHeight: 0,
    currentWidth: 0,
    direction: 0,
    isResizing: !1,
    ratio: 0,
    startHeight: 0,
    startWidth: 0,
    startX: 0,
    startY: 0
  }), g = o.getRootElement(), h = n || (g !== null ? g.getBoundingClientRect().width - 20 : 100), A = g !== null ? g.getBoundingClientRect().height - 20 : 100, y = 100, E = 100, v = (w) => {
    const T = w === bi.east || w === bi.west, N = w === bi.north || w === bi.south, D = w & bi.north && w & bi.west || w & bi.south && w & bi.east, O = T ? "ew" : N ? "ns" : D ? "nwse" : "nesw";
    g !== null && g.style.setProperty("cursor", `${O}-resize`, "important"), document.body !== null && (document.body.style.setProperty("cursor", `${O}-resize`, "important"), u.current.value = document.body.style.getPropertyValue("-webkit-user-select"), u.current.priority = document.body.style.getPropertyPriority("-webkit-user-select"), document.body.style.setProperty("-webkit-user-select", "none", "important"));
  }, C = () => {
    g !== null && g.style.setProperty("cursor", "text"), document.body !== null && (document.body.style.setProperty("cursor", "default"), document.body.style.setProperty("-webkit-user-select", u.current.value, u.current.priority));
  }, x = (w, T) => {
    if (!o.isEditable())
      return;
    const N = r.current, D = c.current;
    if (N !== null && D !== null) {
      w.preventDefault();
      const { width: O, height: F } = N.getBoundingClientRect(), Y = m.current;
      Y.startWidth = O, Y.startHeight = F, Y.ratio = O / F, Y.currentWidth = O, Y.currentHeight = F, Y.startX = w.clientX, Y.startY = w.clientY, Y.isResizing = !0, Y.direction = T, v(T), e(), D.classList.add(Zb.imageControlWrapperResizing), N.style.height = `${F}px`, N.style.width = `${O}px`, document.addEventListener("pointermove", S), document.addEventListener("pointerup", R);
    }
  }, S = (w) => {
    const T = r.current, N = m.current, D = N.direction & (bi.east | bi.west), O = N.direction & (bi.south | bi.north);
    if (T !== null && N.isResizing)
      if (D && O) {
        let F = Math.floor(N.startX - w.clientX);
        F = N.direction & bi.east ? -F : F;
        const Y = gE(N.startWidth + F, y, h), P = Y / N.ratio;
        T.style.width = `${Y}px`, T.style.height = `${P}px`, N.currentHeight = P, N.currentWidth = Y;
      } else if (O) {
        let F = Math.floor(N.startY - w.clientY);
        F = N.direction & bi.south ? -F : F;
        const Y = gE(N.startHeight + F, E, A);
        T.style.height = `${Y}px`, N.currentHeight = Y;
      } else {
        let F = Math.floor(N.startX - w.clientX);
        F = N.direction & bi.east ? -F : F;
        const Y = gE(N.startWidth + F, y, h);
        T.style.width = `${Y}px`, N.currentWidth = Y;
      }
  }, R = () => {
    const w = r.current, T = m.current, N = c.current;
    if (w !== null && N !== null && T.isResizing) {
      const D = T.currentWidth, O = T.currentHeight;
      T.startWidth = 0, T.startHeight = 0, T.ratio = 0, T.startX = 0, T.startY = 0, T.currentWidth = 0, T.currentHeight = 0, T.isResizing = !1, N.classList.remove("image-control-wrapper--resizing"), C(), t(D, O), document.removeEventListener("pointermove", S), document.removeEventListener("pointerup", R);
    }
  };
  return /* @__PURE__ */ V("div", { ref: c, children: [
    !s && l && /* @__PURE__ */ f(
      "button",
      {
        className: "image-caption-button",
        ref: i,
        onClick: () => {
          a(!s);
        },
        children: "Add Caption"
      }
    ),
    /* @__PURE__ */ f(
      "div",
      {
        className: "image-resizer image-resizer-n",
        onPointerDown: (w) => {
          x(w, bi.north);
        }
      }
    ),
    /* @__PURE__ */ f(
      "div",
      {
        className: "image-resizer image-resizer-ne",
        onPointerDown: (w) => {
          x(w, bi.north | bi.east);
        }
      }
    ),
    /* @__PURE__ */ f(
      "div",
      {
        className: "image-resizer image-resizer-e",
        onPointerDown: (w) => {
          x(w, bi.east);
        }
      }
    ),
    /* @__PURE__ */ f(
      "div",
      {
        className: "image-resizer image-resizer-se",
        onPointerDown: (w) => {
          x(w, bi.south | bi.east);
        }
      }
    ),
    /* @__PURE__ */ f(
      "div",
      {
        className: "image-resizer image-resizer-s",
        onPointerDown: (w) => {
          x(w, bi.south);
        }
      }
    ),
    /* @__PURE__ */ f(
      "div",
      {
        className: "image-resizer image-resizer-sw",
        onPointerDown: (w) => {
          x(w, bi.south | bi.west);
        }
      }
    ),
    /* @__PURE__ */ f(
      "div",
      {
        className: "image-resizer image-resizer-w",
        onPointerDown: (w) => {
          x(w, bi.west);
        }
      }
    ),
    /* @__PURE__ */ f(
      "div",
      {
        className: "image-resizer image-resizer-nw",
        onPointerDown: (w) => {
          x(w, bi.north | bi.west);
        }
      }
    )
  ] });
}
const gte = "_root_1082r_1", hte = {
  root: gte
};
function Mf({ children: e, className: t }) {
  return /* @__PURE__ */ f("div", { className: t || hte.root, children: e });
}
const Z4 = L.createCommand("RIGHT_CLICK_IMAGE_COMMAND");
function pte({
  altText: e,
  className: t,
  imageRef: i,
  src: r,
  width: n,
  height: o,
  maxWidth: s
}) {
  return /* @__PURE__ */ f(
    "img",
    {
      className: t || void 0,
      src: r,
      alt: e,
      ref: i,
      style: {
        height: o,
        maxWidth: s,
        width: n
      },
      draggable: "false"
    }
  );
}
function fte({
  src: e,
  altText: t,
  nodeKey: i,
  width: r,
  height: n,
  maxWidth: o,
  resizable: s,
  showCaption: a,
  caption: l,
  captionsEnabled: c
}) {
  const u = Ne(null), m = Ne(null), [g, h, A] = vg.useLexicalNodeSelection(i), [y, E] = se(!1), [v] = nt.useLexicalComposerContext(), [C, x] = se(null), S = Ne(null), R = ye(
    (Q) => {
      if (g && L.$isNodeSelection(L.$getSelection())) {
        Q.preventDefault();
        const le = L.$getNodeByKey(i);
        xm(le) && le.remove();
      }
      return !1;
    },
    [g, i]
  ), w = ye(
    (Q) => {
      const $ = L.$getSelection(), le = m.current;
      if (g && L.$isNodeSelection($) && $.getNodes().length === 1) {
        if (a)
          return L.$setSelection(null), Q.preventDefault(), l.focus(), !0;
        if (le !== null && le !== document.activeElement)
          return Q.preventDefault(), le.focus(), !0;
      }
      return !1;
    },
    [l, g, a]
  ), T = ye(
    (Q) => S.current === l || m.current === Q.target ? (L.$setSelection(null), v.update(() => {
      h(!0);
      const $ = v.getRootElement();
      $ !== null && $.focus();
    }), !0) : !1,
    [l, v, h]
  ), N = ye(
    (Q) => {
      const $ = Q;
      return y ? !0 : $.target === u.current ? ($.shiftKey ? h(!g) : (A(), h(!0)), !0) : !1;
    },
    [y, g, h, A]
  ), D = ye(
    (Q) => {
      v.getEditorState().read(() => {
        const $ = L.$getSelection();
        Q.target.tagName === "IMG" && L.$isRangeSelection($) && $.getNodes().length === 1 && v.dispatchCommand(Z4, Q);
      });
    },
    [v]
  );
  be(() => {
    let Q = !0;
    const $ = v.getRootElement(), le = it.mergeRegister(
      v.registerUpdateListener(({ editorState: he }) => {
        Q && x(he.read(() => L.$getSelection()));
      }),
      v.registerCommand(
        L.SELECTION_CHANGE_COMMAND,
        (he, oe) => (S.current = oe, !1),
        L.COMMAND_PRIORITY_LOW
      ),
      v.registerCommand(L.CLICK_COMMAND, N, L.COMMAND_PRIORITY_LOW),
      v.registerCommand(Z4, N, L.COMMAND_PRIORITY_LOW),
      v.registerCommand(
        L.DRAGSTART_COMMAND,
        (he) => he.target === u.current ? (he.preventDefault(), !0) : !1,
        L.COMMAND_PRIORITY_LOW
      ),
      v.registerCommand(L.KEY_DELETE_COMMAND, R, L.COMMAND_PRIORITY_LOW),
      v.registerCommand(L.KEY_BACKSPACE_COMMAND, R, L.COMMAND_PRIORITY_LOW),
      v.registerCommand(L.KEY_ENTER_COMMAND, w, L.COMMAND_PRIORITY_LOW),
      v.registerCommand(L.KEY_ESCAPE_COMMAND, T, L.COMMAND_PRIORITY_LOW)
    );
    return $ == null || $.addEventListener("contextmenu", D), () => {
      Q = !1, le(), $ == null || $.removeEventListener("contextmenu", D);
    };
  }, [
    A,
    v,
    y,
    g,
    i,
    R,
    w,
    T,
    N,
    D,
    h
  ]);
  const O = () => {
    v.update(() => {
      const Q = L.$getNodeByKey(i);
      xm(Q) && Q.setShowCaption(!0);
    });
  }, F = (Q, $) => {
    setTimeout(() => {
      E(!1);
    }, 200), v.update(() => {
      const le = L.$getNodeByKey(i);
      xm(le) && le.setWidthAndHeight(Q, $);
    });
  }, Y = () => {
    E(!0);
  }, { historyState: P } = L2(), {
    settings: { showNestedEditorTreeView: z }
  } = j2(), W = g && L.$isNodeSelection(C) && !y, H = g || y;
  return /* @__PURE__ */ f(Ll, { fallback: null, children: /* @__PURE__ */ V(gt, { children: [
    /* @__PURE__ */ f("div", { draggable: W, children: /* @__PURE__ */ f(
      pte,
      {
        className: H ? `focused ${L.$isNodeSelection(C) ? "draggable" : ""}` : null,
        src: e,
        altText: t,
        imageRef: u,
        width: r,
        height: n,
        maxWidth: o
      }
    ) }),
    a && /* @__PURE__ */ f("div", { className: "image-caption-container", children: /* @__PURE__ */ V(kD.LexicalNestedComposer, { initialEditor: l, children: [
      /* @__PURE__ */ f(Ym.AutoFocusPlugin, {}),
      /* @__PURE__ */ f(Qb, {}),
      /* @__PURE__ */ f(A0, {}),
      /* @__PURE__ */ f(ree, {}),
      /* @__PURE__ */ f(fB.HashtagPlugin, {}),
      /* @__PURE__ */ f(Mc.HistoryPlugin, { externalHistoryState: P }),
      /* @__PURE__ */ f(
        p0.RichTextPlugin,
        {
          contentEditable: /* @__PURE__ */ f(kl, { className: Zb.contentEditable }),
          placeholder: /* @__PURE__ */ f(Mf, { className: Zb.placeholder, children: "Enter a caption..." }),
          ErrorBoundary: xl
        }
      ),
      z === !0 ? /* @__PURE__ */ f(KD, {}) : null
    ] }) }),
    s && L.$isNodeSelection(C) && H && /* @__PURE__ */ f(
      mte,
      {
        showCaption: a,
        setShowCaption: O,
        editor: v,
        buttonRef: m,
        imageRef: u,
        maxWidth: o,
        onResizeStart: Y,
        onResizeEnd: F,
        captionsEnabled: c
      }
    )
  ] }) });
}
function Ate(e) {
  if (e instanceof HTMLImageElement) {
    const { alt: t, src: i, width: r, height: n } = e;
    return { node: Nf({ altText: t, height: n, src: i, width: r }) };
  }
  return null;
}
class Wl extends L.DecoratorNode {
  constructor(i, r, n, o, s, a, l, c, u) {
    super(u);
    Ze(this, "__src");
    Ze(this, "__altText");
    Ze(this, "__width");
    Ze(this, "__height");
    Ze(this, "__maxWidth");
    Ze(this, "__showCaption");
    Ze(this, "__caption");
    // Captions cannot yet be used within editor cells
    Ze(this, "__captionsEnabled");
    this.__src = i, this.__altText = r, this.__maxWidth = n, this.__width = o || "inherit", this.__height = s || "inherit", this.__showCaption = a || !1, this.__caption = l || L.createEditor(), this.__captionsEnabled = c || c === void 0;
  }
  static getType() {
    return "image";
  }
  static clone(i) {
    return new Wl(
      i.__src,
      i.__altText,
      i.__maxWidth,
      i.__width,
      i.__height,
      i.__showCaption,
      i.__caption,
      i.__captionsEnabled,
      i.__key
    );
  }
  static importJSON(i) {
    const { altText: r, height: n, width: o, maxWidth: s, caption: a, src: l, showCaption: c } = i, u = Nf({
      altText: r,
      height: n,
      maxWidth: s,
      showCaption: c,
      src: l,
      width: o
    }), m = u.__caption, g = m.parseEditorState(a.editorState);
    return g.isEmpty() || m.setEditorState(g), u;
  }
  exportDOM() {
    const i = Wt("img");
    return i.setAttribute("src", this.__src), i.setAttribute("alt", this.__altText), i.setAttribute("width", this.__width.toString()), i.setAttribute("height", this.__height.toString()), { element: i };
  }
  static importDOM() {
    return {
      img: (i) => ({
        conversion: Ate,
        priority: 0
      })
    };
  }
  exportJSON() {
    return {
      altText: this.getAltText(),
      caption: this.__caption.toJSON(),
      height: this.__height === "inherit" ? 0 : this.__height,
      maxWidth: this.__maxWidth,
      showCaption: this.__showCaption,
      src: this.getSrc(),
      type: "image",
      version: 1,
      width: this.__width === "inherit" ? 0 : this.__width
    };
  }
  setWidthAndHeight(i, r) {
    const n = this.getWritable();
    n.__width = i, n.__height = r;
  }
  setShowCaption(i) {
    const r = this.getWritable();
    r.__showCaption = i;
  }
  // View
  createDOM(i) {
    const r = Wt("span"), o = i.theme.image;
    return o !== void 0 && (r.className = o), r;
  }
  updateDOM() {
    return !1;
  }
  getSrc() {
    return this.__src;
  }
  getAltText() {
    return this.__altText;
  }
  decorate() {
    return /* @__PURE__ */ f(Ll, { fallback: null, children: /* @__PURE__ */ f(
      fte,
      {
        src: this.__src,
        altText: this.__altText,
        width: this.__width,
        height: this.__height,
        maxWidth: this.__maxWidth,
        nodeKey: this.getKey(),
        showCaption: this.__showCaption,
        caption: this.__caption,
        captionsEnabled: this.__captionsEnabled,
        resizable: !0
      }
    ) });
  }
}
function Nf({
  altText: e,
  height: t,
  maxWidth: i = 500,
  captionsEnabled: r,
  src: n,
  width: o,
  showCaption: s,
  caption: a,
  key: l
}) {
  return L.$applyNodeReplacement(
    new Wl(n, e, i, o, t, s, a, r, l)
  );
}
function xm(e) {
  return e instanceof Wl;
}
const yte = [
  Jr.HeadingNode,
  zi.ListNode,
  zi.ListItemNode,
  Jr.QuoteNode,
  nn.CodeNode,
  A2.HashtagNode,
  nn.CodeHighlightNode,
  Ii.AutoLinkNode,
  Ii.LinkNode,
  Wl,
  Ig,
  Q0,
  Gl,
  G0
  // KeywordNode
], UD = yte;
var Sg = {}, ux = {}, dx = nt, yn = L, qi = X, J4 = it, Ete = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined" ? qi.useLayoutEffect : qi.useEffect;
let vte = class {
  constructor(t) {
    this.key = t, this.ref = { current: null }, this.setRefElement = this.setRefElement.bind(this);
  }
  setRefElement(t) {
    this.ref = { current: t };
  }
}, P4 = (e) => {
  const t = document.getElementById("typeahead-menu");
  if (t) {
    var i = t.getBoundingClientRect();
    i.top + i.height > window.innerHeight && t.scrollIntoView({ block: "center" }), 0 > i.top && t.scrollIntoView({ block: "center" }), e.scrollIntoView({ block: "nearest" });
  }
};
function bte(e) {
  var t = yn.$getSelection();
  if (!yn.$isRangeSelection(t) || !t.isCollapsed())
    return null;
  var i = t.anchor;
  if (i.type !== "text" || (t = i.getNode(), !t.isSimpleText()))
    return null;
  i = i.offset;
  let r = t.getTextContent().slice(0, i);
  var n = e.matchingString;
  e = e.replaceableString.length;
  for (let s = e; s <= n.length; s++)
    r.substr(-s) === n.substr(0, s) && (e = s);
  if (e = i - e, 0 > e)
    return null;
  let o;
  return e === 0 ? [o] = t.splitText(i) : [, o] = t.splitText(e, i), o;
}
function Cte(e, t) {
  let i = getComputedStyle(e), r = i.position === "absolute";
  if (t = t ? /(auto|scroll|hidden)/ : /(auto|scroll)/, i.position === "fixed")
    return document.body;
  for (; e = e.parentElement; )
    if (i = getComputedStyle(e), (!r || i.position !== "static") && t.test(i.overflow + i.overflowY + i.overflowX))
      return e;
  return document.body;
}
function z4(e, t) {
  return e = e.getBoundingClientRect(), t = t.getBoundingClientRect(), e.top > t.top && e.top < t.bottom;
}
function xte(e, t, i, r) {
  let [n] = dx.useLexicalComposerContext();
  qi.useEffect(() => {
    if (t != null && e != null) {
      let o = n.getRootElement(), s = o != null ? Cte(o, !1) : document.body, a = !1, l = z4(t, s), c = function() {
        a || (window.requestAnimationFrame(function() {
          i(), a = !1;
        }), a = !0);
        const m = z4(t, s);
        m !== l && (l = m, r != null && r(m));
      }, u = new ResizeObserver(i);
      return window.addEventListener("resize", i), document.addEventListener("scroll", c, { capture: !0, passive: !0 }), u.observe(t), () => {
        u.unobserve(t), window.removeEventListener("resize", i), document.removeEventListener(
          "scroll",
          c
        );
      };
    }
  }, [t, n, r, i, e]);
}
let H4 = yn.createCommand("SCROLL_TYPEAHEAD_OPTION_INTO_VIEW_COMMAND");
function Ite({ close: e, editor: t, anchorElementRef: i, resolution: r, options: n, menuRenderFn: o, onSelectOption: s, shouldSplitNodeWithQuery: a = !1 }) {
  let [l, c] = qi.useState(null);
  qi.useEffect(() => {
    c(0);
  }, [r.match && r.match.matchingString]);
  let u = qi.useCallback((h) => {
    t.update(() => {
      const A = r.match != null && a ? bte(r.match) : null;
      s(h, A, e, r.match ? r.match.matchingString : "");
    });
  }, [t, a, r.match, s, e]), m = qi.useCallback((h) => {
    const A = t.getRootElement();
    A !== null && (A.setAttribute("aria-activedescendant", "typeahead-item-" + h), c(h));
  }, [t]);
  qi.useEffect(() => () => {
    let h = t.getRootElement();
    h !== null && h.removeAttribute("aria-activedescendant");
  }, [t]), Ete(() => {
    n === null ? c(null) : l === null && m(0);
  }, [n, l, m]), qi.useEffect(() => J4.mergeRegister(t.registerCommand(H4, ({ option: h }) => h.ref && h.ref.current != null ? (P4(h.ref.current), !0) : !1, yn.COMMAND_PRIORITY_LOW)), [t, m]), qi.useEffect(() => J4.mergeRegister(t.registerCommand(yn.KEY_ARROW_DOWN_COMMAND, (h) => {
    if (n !== null && n.length && l !== null) {
      let A = l !== n.length - 1 ? l + 1 : 0;
      m(A);
      let y = n[A];
      y.ref != null && y.ref.current && t.dispatchCommand(H4, { index: A, option: y }), h.preventDefault(), h.stopImmediatePropagation();
    }
    return !0;
  }, yn.COMMAND_PRIORITY_LOW), t.registerCommand(yn.KEY_ARROW_UP_COMMAND, (h) => {
    if (n !== null && n.length && l !== null) {
      var A = l !== 0 ? l - 1 : n.length - 1;
      m(A), A = n[A], A.ref != null && A.ref.current && P4(A.ref.current), h.preventDefault(), h.stopImmediatePropagation();
    }
    return !0;
  }, yn.COMMAND_PRIORITY_LOW), t.registerCommand(yn.KEY_ESCAPE_COMMAND, (h) => (h.preventDefault(), h.stopImmediatePropagation(), e(), !0), yn.COMMAND_PRIORITY_LOW), t.registerCommand(yn.KEY_TAB_COMMAND, (h) => n === null || l === null || n[l] == null ? !1 : (h.preventDefault(), h.stopImmediatePropagation(), u(n[l]), !0), yn.COMMAND_PRIORITY_LOW), t.registerCommand(yn.KEY_ENTER_COMMAND, (h) => n === null || l === null || n[l] == null ? !1 : (h !== null && (h.preventDefault(), h.stopImmediatePropagation()), u(n[l]), !0), yn.COMMAND_PRIORITY_LOW)), [u, e, t, n, l, m]);
  let g = qi.useMemo(() => ({ options: n, selectOptionAndCleanUp: u, selectedIndex: l, setHighlightedIndex: c }), [u, l, n]);
  return o(i, g, r.match ? r.match.matchingString : "");
}
function Ste(e, t, i) {
  let [r] = dx.useLexicalComposerContext(), n = qi.useRef(document.createElement("div")), o = qi.useCallback(() => {
    const a = r.getRootElement(), l = n.current;
    var c = l.firstChild;
    if (a !== null && e !== null) {
      const { left: m, top: g, width: h, height: A } = e.getRect();
      if (l.style.top = `${g + window.pageYOffset}px`, l.style.left = `${m + window.pageXOffset}px`, l.style.height = `${A}px`, l.style.width = `${h}px`, c !== null) {
        var u = c.getBoundingClientRect();
        c = u.height, u = u.width;
        const y = a.getBoundingClientRect();
        m + u > y.right && (l.style.left = `${y.right - u + window.pageXOffset}px`), (g + c > window.innerHeight || g + c > y.bottom) && g - y.top > c && (l.style.top = `${g - c + window.pageYOffset - (A + 10)}px`);
      }
      l.isConnected || (i != null && (l.className = i), l.setAttribute("aria-label", "Typeahead menu"), l.setAttribute("id", "typeahead-menu"), l.setAttribute("role", "listbox"), l.style.display = "block", l.style.position = "absolute", document.body.append(l)), n.current = l, a.setAttribute("aria-controls", "typeahead-menu");
    }
  }, [r, e, i]);
  qi.useEffect(() => {
    let a = r.getRootElement();
    if (e !== null)
      return o(), () => {
        a !== null && a.removeAttribute("aria-controls");
        let l = n.current;
        l !== null && l.isConnected && l.remove();
      };
  }, [r, o, e]);
  let s = qi.useCallback((a) => {
    e !== null && (a || t(null));
  }, [e, t]);
  return xte(e, n.current, o, s), n;
}
function Rte(e) {
  qi.startTransition ? qi.startTransition(e) : e();
}
ux.LexicalNodeMenuPlugin = function({ options: e, nodeKey: t, onClose: i, onOpen: r, onSelectOption: n, menuRenderFn: o, anchorClassName: s }) {
  let [a] = dx.useLexicalComposerContext(), [l, c] = qi.useState(null);
  s = Ste(l, c, s);
  let u = qi.useCallback(() => {
    c(null), i != null && l !== null && i();
  }, [i, l]), m = qi.useCallback((h) => {
    c(h), r != null && l === null && r(h);
  }, [r, l]), g = qi.useCallback(() => {
    t ? a.update(() => {
      const h = yn.$getNodeByKey(t), A = a.getElementByKey(t);
      h != null && A != null && l == null && Rte(() => m({ getRect: () => A.getBoundingClientRect() }));
    }) : t == null && l != null && u();
  }, [u, a, t, m, l]);
  return qi.useEffect(() => {
    g();
  }, [g, t]), qi.useEffect(() => {
    if (t != null)
      return a.registerUpdateListener(({ dirtyElements: h }) => {
        h.get(t) && g();
      });
  }, [a, g, t]), l === null || a === null ? null : qi.createElement(Ite, { close: u, resolution: l, editor: a, anchorElementRef: s, options: e, menuRenderFn: o, onSelectOption: n });
};
ux.MenuOption = vte;
const kte = ux;
var wte = kte, Md = Ii, Mte = nt, GD = wte, Nte = it, tm = L, bs = X;
let QD = tm.createCommand("INSERT_EMBED_COMMAND"), Tte = class extends GD.MenuOption {
  constructor(t, i) {
    super(t), this.title = t, this.onSelect = i.onSelect.bind(this);
  }
};
Sg.AutoEmbedOption = Tte;
Sg.INSERT_EMBED_COMMAND = QD;
Sg.LexicalAutoEmbedPlugin = function({ embedConfigs: e, onOpenEmbedModalForConfig: t, getMenuOptions: i, menuRenderFn: r }) {
  let [n] = Mte.useLexicalComposerContext(), [o, s] = bs.useState(null), [a, l] = bs.useState(null), c = bs.useCallback(() => {
    s(null), l(null);
  }, []), u = bs.useCallback((A) => {
    n.getEditorState().read(() => Lt(this, null, function* () {
      const y = tm.$getNodeByKey(A);
      if (Md.$isLinkNode(y))
        for (let E = 0; E < e.length; E++) {
          const v = e[E];
          (yield Promise.resolve(v.parseUrl(y.__url))) != null && (l(v), s(y.getKey()));
        }
    }));
  }, [n, e]);
  bs.useEffect(() => {
    let A = (y, {
      updateTags: E,
      dirtyLeaves: v
    }) => {
      for (const [C, x] of y)
        x === "created" && E.has("paste") && 3 >= v.size ? u(C) : C === o && c();
    };
    return Nte.mergeRegister(...[Md.LinkNode, Md.AutoLinkNode].map((y) => n.registerMutationListener(y, (...E) => A(...E))));
  }, [u, n, e, o, c]), bs.useEffect(() => n.registerCommand(QD, (A) => {
    let y = e.find(({ type: E }) => E === A);
    return y ? (t(y), !0) : !1;
  }, tm.COMMAND_PRIORITY_EDITOR), [n, e, t]);
  let m = bs.useCallback(() => Lt(this, null, function* () {
    if (a != null && o != null) {
      const A = n.getEditorState().read(() => {
        const y = tm.$getNodeByKey(o);
        return Md.$isLinkNode(y) ? y : null;
      });
      if (Md.$isLinkNode(A)) {
        const y = yield Promise.resolve(a.parseUrl(A.__url));
        y != null && n.update(() => {
          tm.$getSelection() || A.selectEnd(), a.insertNode(n, y), A.isAttached() && A.remove();
        });
      }
    }
  }), [a, n, o]), g = bs.useMemo(() => a != null && o != null ? i(a, m, c) : [], [a, m, i, o, c]), h = bs.useCallback((A, y, E) => {
    n.update(() => {
      A.onSelect(y), E();
    });
  }, [n]);
  return o != null ? bs.createElement(GD.LexicalNodeMenuPlugin, { nodeKey: o, onClose: c, onSelectOption: h, options: g, menuRenderFn: r }) : null;
};
Sg.URL_MATCHER = /((https?:\/\/(www\.)?)|(www\.))[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;
const Bte = Sg;
var l0 = Bte;
const Dte = "_overlay_1420a_1", Ote = "_modal_1420a_16", Fte = "_title_1420a_28", Vte = "_closeButton_1420a_34", qte = "_content_1420a_51", Nd = {
  overlay: Dte,
  modal: Ote,
  title: Fte,
  closeButton: Vte,
  content: qte
};
function jte({
  onClose: e,
  children: t,
  title: i,
  closeOnClickOutside: r
}) {
  const n = Ne(null);
  return be(() => {
    n.current !== null && n.current.focus();
  }, []), be(() => {
    let o = null;
    const s = (c) => {
      c.keyCode === 27 && e();
    }, a = (c) => {
      const u = c.target;
      n.current !== null && !n.current.contains(u) && r && e();
    }, l = n.current;
    return l !== null && (o = l.parentElement, o !== null && o.addEventListener("click", a)), window.addEventListener("keydown", s), () => {
      window.removeEventListener("keydown", s), o !== null && (o == null || o.removeEventListener("click", a));
    };
  }, [r, e]), /* @__PURE__ */ f("div", { className: me(Nd.overlay, "maxroll-rte-modal"), role: "dialog", children: /* @__PURE__ */ V("div", { className: Nd.modal, tabIndex: -1, ref: n, children: [
    /* @__PURE__ */ f("h2", { className: Nd.title, children: i }),
    /* @__PURE__ */ f("button", { className: Nd.closeButton, "aria-label": "Close modal", type: "button", onClick: e, children: "X" }),
    /* @__PURE__ */ f("div", { className: Nd.content, children: t })
  ] }) });
}
function Lte({
  onClose: e,
  children: t,
  title: i,
  closeOnClickOutside: r = !1
}) {
  return ps(
    /* @__PURE__ */ f(jte, { onClose: e, title: i, closeOnClickOutside: r, children: t }),
    document.body
  );
}
function Rg() {
  const [e, t] = se(null), i = ye(() => {
    t(null);
  }, []), r = we(() => {
    if (e === null)
      return null;
    const { title: o, content: s, closeOnClickOutside: a } = e;
    return /* @__PURE__ */ f(Lte, { onClose: i, title: o, closeOnClickOutside: a, children: s });
  }, [e, i]), n = ye(
    (o, s, a = !1) => {
      t({
        closeOnClickOutside: a,
        content: s(i),
        title: o
      });
    },
    [i]
  );
  return [r, n];
}
const Kte = "_root_gqotg_1", Yte = "_small_gqotg_16", Ute = "_disabled_gqotg_23", hE = {
  root: Kte,
  small: Yte,
  disabled: Ute
};
function fo({
  "data-test-id": e,
  children: t,
  className: i,
  onClick: r,
  disabled: n,
  small: o,
  title: s
}) {
  return /* @__PURE__ */ f(
    "button",
    ee(q({
      disabled: n,
      className: me(hE.root, n && hE.disabled, o && hE.small, i),
      onClick: r,
      title: s,
      "aria-label": s
    }, e && { "data-test-id": e }), {
      children: t
    })
  );
}
const Gte = "_dialogActions_6omel_1", Qte = "_dialogButtonsList_6omel_8", WD = {
  dialogActions: Gte,
  dialogButtonsList: Qte
};
function Wte({ children: e }) {
  return /* @__PURE__ */ f("div", { className: WD.dialogButtonsList, children: e });
}
function Zl({ "data-test-id": e, children: t }) {
  return /* @__PURE__ */ f("div", { className: WD.dialogActions, "data-test-id": e, children: t });
}
var ZD = {}, mx = {}, Zte = L;
let JD = class extends Zte.DecoratorNode {
  constructor(t, i) {
    super(i), this.__format = t || "";
  }
  exportJSON() {
    return { format: this.__format || "", type: "decorator-block", version: 1 };
  }
  createDOM() {
    return document.createElement("div");
  }
  updateDOM() {
    return !1;
  }
  setFormat(t) {
    this.getWritable().__format = t;
  }
  isInline() {
    return !1;
  }
};
mx.$isDecoratorBlockNode = function(e) {
  return e instanceof JD;
};
mx.DecoratorBlockNode = JD;
const Jte = mx;
var Tf = Jte, Pte = nt, X4 = Tf, zte = vg, _4 = it, _r = L, mp = X;
ZD.BlockWithAlignableContents = function({ children: e, format: t, nodeKey: i, className: r }) {
  let [n] = Pte.useLexicalComposerContext(), [o, s, a] = zte.useLexicalNodeSelection(i), l = mp.useRef(null), c = mp.useCallback((u) => (o && _r.$isNodeSelection(_r.$getSelection()) && (u.preventDefault(), u = _r.$getNodeByKey(i), _r.$isDecoratorNode(u) && u.remove()), !1), [o, i]);
  return mp.useEffect(() => _4.mergeRegister(n.registerCommand(_r.FORMAT_ELEMENT_COMMAND, (u) => {
    if (o) {
      var m = _r.$getSelection();
      if (_r.$isNodeSelection(m)) {
        var g = _r.$getNodeByKey(i);
        X4.$isDecoratorBlockNode(g) && g.setFormat(u);
      } else if (_r.$isRangeSelection(m)) {
        m = m.getNodes();
        for (g of m)
          X4.$isDecoratorBlockNode(g) ? g.setFormat(u) : _4.$getNearestBlockElementAncestorOrThrow(g).setFormat(u);
      }
      return !0;
    }
    return !1;
  }, _r.COMMAND_PRIORITY_LOW), n.registerCommand(_r.CLICK_COMMAND, (u) => u.target === l.current ? (u.preventDefault(), u.shiftKey || a(), s(!o), !0) : !1, _r.COMMAND_PRIORITY_LOW), n.registerCommand(_r.KEY_DELETE_COMMAND, c, _r.COMMAND_PRIORITY_LOW), n.registerCommand(_r.KEY_BACKSPACE_COMMAND, c, _r.COMMAND_PRIORITY_LOW)), [a, n, o, i, c, s]), mp.createElement(
    "div",
    { className: [r.base, o ? r.focus : null].filter(Boolean).join(" "), ref: l, style: { textAlign: t || void 0 } },
    e
  );
};
const Hte = ZD;
var PD = Hte;
const Xte = "https://platform.twitter.com/widgets.js";
function _te(e) {
  const t = e.getAttribute("data-lexical-tweet-id");
  return t ? { node: Bf(t) } : null;
}
let $4 = !0;
function $te({
  className: e,
  format: t,
  loadingComponent: i,
  nodeKey: r,
  onError: n,
  onLoad: o,
  tweetID: s
}) {
  const a = Ne(null), l = Ne(""), [c, u] = se(!1), m = ye(() => Lt(this, null, function* () {
    try {
      yield window.twttr.widgets.createTweet(s, a.current), u(!1), $4 = !1, o && o();
    } catch (g) {
      n && n(String(g));
    }
  }), [n, o, s]);
  return be(() => {
    var g;
    if (s !== l.current) {
      if (u(!0), $4) {
        const h = Wt("script");
        h.src = Xte, h.async = !0, (g = document.body) == null || g.appendChild(h), h.onload = m, n && (h.onerror = n);
      } else
        m();
      l && (l.current = s);
    }
  }, [m, n, s]), /* @__PURE__ */ V(PD.BlockWithAlignableContents, { className: e, format: t, nodeKey: r, children: [
    c ? i : null,
    /* @__PURE__ */ f("div", { style: { display: "inline-block", width: "550px" }, ref: a })
  ] });
}
class ou extends Tf.DecoratorBlockNode {
  constructor(i, r, n) {
    super(r, n);
    Ze(this, "__id");
    this.__id = i;
  }
  static getType() {
    return "tweet";
  }
  static clone(i) {
    return new ou(i.__id, i.__format, i.__key);
  }
  static importJSON(i) {
    const r = Bf(i.id);
    return r.setFormat(i.format), r;
  }
  exportJSON() {
    return ee(q({}, super.exportJSON()), {
      id: this.getId(),
      type: "tweet",
      version: 1
    });
  }
  static importDOM() {
    return {
      div: (i) => i.hasAttribute("data-lexical-tweet-id") ? {
        conversion: _te,
        priority: 2
      } : null
    };
  }
  exportDOM() {
    const i = Wt("div");
    i.setAttribute("data-lexical-tweet-id", this.__id);
    const r = document.createTextNode(this.getTextContent());
    return i.append(r), { element: i };
  }
  getId() {
    return this.__id;
  }
  getTextContent(i, r) {
    return `https://x.com/i/web/status/${this.__id}`;
  }
  decorate(i, r) {
    const n = r.theme.embedBlock || {}, o = {
      base: n.base || "",
      focus: n.focus || ""
    };
    return /* @__PURE__ */ f(
      $te,
      {
        className: o,
        format: this.__format,
        loadingComponent: "Loading...",
        nodeKey: this.getKey(),
        tweetID: this.__id
      }
    );
  }
}
function Bf(e) {
  return new ou(e);
}
function eie(e) {
  return e instanceof ou;
}
const zD = L.createCommand("INSERT_TWEET_COMMAND");
function HD() {
  const [e] = nt.useLexicalComposerContext();
  return be(() => {
    if (!e.hasNodes([ou]))
      throw new Error("TwitterPlugin: TweetNode not registered on editor");
    return e.registerCommand(
      zD,
      (t) => {
        const i = Bf(t);
        return it.$insertNodeToNearestRoot(i), !0;
      },
      L.COMMAND_PRIORITY_EDITOR
    );
  }, [e]), null;
}
function tie({ className: e, format: t, nodeKey: i, videoID: r }) {
  return /* @__PURE__ */ f(PD.BlockWithAlignableContents, { className: e, format: t, nodeKey: i, children: /* @__PURE__ */ f(
    "iframe",
    {
      width: "560",
      height: "315",
      src: `https://www.youtube-nocookie.com/embed/${r}`,
      frameBorder: "0",
      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      allowFullScreen: !0,
      title: "YouTube video"
    }
  ) });
}
function iie(e) {
  const t = e.getAttribute("data-lexical-youtube");
  return t ? { node: gx(t) } : null;
}
class kg extends Tf.DecoratorBlockNode {
  constructor(i, r, n) {
    super(r, n);
    Ze(this, "__id");
    this.__id = i;
  }
  static getType() {
    return "youtube";
  }
  static clone(i) {
    return new kg(i.__id, i.__format, i.__key);
  }
  static importJSON(i) {
    const r = gx(i.videoID);
    return r.setFormat(i.format), r;
  }
  exportJSON() {
    return ee(q({}, super.exportJSON()), {
      type: "youtube",
      version: 1,
      videoID: this.__id
    });
  }
  exportDOM() {
    const i = Wt("iframe");
    return i.setAttribute("data-lexical-youtube", this.__id), i.setAttribute("width", "560"), i.setAttribute("height", "315"), i.setAttribute("src", `https://www.youtube-nocookie.com/embed/${this.__id}`), i.setAttribute("frameborder", "0"), i.setAttribute(
      "allow",
      "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    ), i.setAttribute("allowfullscreen", "true"), i.setAttribute("title", "YouTube video"), { element: i };
  }
  static importDOM() {
    return {
      iframe: (i) => i.hasAttribute("data-lexical-youtube") ? {
        conversion: iie,
        priority: 1
      } : null
    };
  }
  updateDOM() {
    return !1;
  }
  getId() {
    return this.__id;
  }
  getTextContent(i, r) {
    return `https://www.youtube.com/watch?v=${this.__id}`;
  }
  decorate(i, r) {
    const n = r.theme.embedBlock || {}, o = {
      base: n.base || "",
      focus: n.focus || ""
    };
    return /* @__PURE__ */ f(tie, { className: o, format: this.__format, nodeKey: this.getKey(), videoID: this.__id });
  }
}
function gx(e) {
  return new kg(e);
}
const XD = L.createCommand("INSERT_YOUTUBE_COMMAND");
function _D() {
  const [e] = nt.useLexicalComposerContext();
  return be(() => {
    if (!e.hasNodes([kg]))
      throw new Error("YouTubePlugin: YouTubeNode not registered on editor");
    return e.registerCommand(
      XD,
      (t) => {
        const i = gx(t);
        return it.$insertNodeToNearestRoot(i), !0;
      },
      L.COMMAND_PRIORITY_EDITOR
    );
  }, [e]), null;
}
const rie = {
  contentName: "Youtube Video",
  exampleUrl: "https://www.youtube.com/watch?v=jNQXAC9IVRw",
  // Icon for display.
  icon: /* @__PURE__ */ f("i", { className: "icon youtube" }),
  insertNode: (e, t) => {
    e.dispatchCommand(XD, t.id);
  },
  keywords: ["youtube", "video"],
  // Determine if a given URL is a match and return url data.
  parseUrl: (e) => Lt(void 0, null, function* () {
    const t = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/.exec(e), i = t && (t == null ? void 0 : t[2].length) === 11 ? t[2] : null;
    return i != null ? {
      id: i,
      url: e
    } : null;
  }),
  type: "youtube-video"
}, nie = {
  // e.g. Tweet or Google Map.
  contentName: "Tweet",
  exampleUrl: "https://twitter.com/jack/status/20",
  // Icon for display.
  icon: /* @__PURE__ */ f("i", { className: "icon tweet" }),
  // Create the Lexical embed node from the url data.
  insertNode: (e, t) => {
    e.dispatchCommand(zD, t.id);
  },
  // For extra searching.
  keywords: ["tweet", "twitter"],
  // Determine if a given URL is a match and return url data.
  parseUrl: (e) => {
    const t = /^https:\/\/(twitter|x)\.com\/(#!\/)?(\w+)\/status(es)*\/(\d+)/.exec(e);
    return t != null ? {
      id: t[5],
      url: t[1]
    } : null;
  },
  type: "tweet"
}, hx = [nie, rie];
function oie({
  index: e,
  isSelected: t,
  onClick: i,
  onMouseEnter: r,
  option: n
}) {
  let o = "item";
  return t && (o += " selected"), /* @__PURE__ */ f(
    "li",
    {
      tabIndex: -1,
      className: o,
      ref: n.setRefElement,
      role: "option",
      "aria-selected": t,
      id: "typeahead-item-" + e,
      onMouseEnter: r,
      onClick: i,
      children: /* @__PURE__ */ f("span", { className: "text", children: n.title })
    },
    n.key
  );
}
function sie({
  options: e,
  selectedItemIndex: t,
  onOptionClick: i,
  onOptionMouseEnter: r
}) {
  var o;
  const [, n] = nt.useLexicalComposerContext();
  return /* @__PURE__ */ f("div", { className: me("typeahead-popover", (o = n.getTheme()) == null ? void 0 : o.typeaheadPopover), children: /* @__PURE__ */ f("ul", { children: e.map((s, a) => /* @__PURE__ */ f(
    oie,
    {
      index: a,
      isSelected: t === a,
      onClick: () => i(s, a),
      onMouseEnter: () => r(a),
      option: s
    },
    s.key
  )) }) });
}
const aie = (e, t) => {
  let i;
  return (r) => {
    window.clearTimeout(i), i = window.setTimeout(() => {
      e(r);
    }, t);
  };
};
function lie({
  embedConfig: e,
  onClose: t
}) {
  const [i, r] = se(""), [n] = nt.useLexicalComposerContext(), [o, s] = se(null), a = we(
    () => aie((c) => {
      const u = l0.URL_MATCHER.exec(c);
      e != null && c != null && u != null ? Promise.resolve(e.parseUrl(c)).then((m) => {
        s(m);
      }) : o != null && s(null);
    }, 200),
    [e, o]
  ), l = () => {
    o != null && (e.insertNode(n, o), t());
  };
  return /* @__PURE__ */ V("div", { style: { width: "600px" }, children: [
    /* @__PURE__ */ f("div", { className: "Input__wrapper", children: /* @__PURE__ */ f(
      "input",
      {
        type: "text",
        className: "Input__input",
        placeholder: e.exampleUrl,
        value: i,
        "data-test-id": `${e.type}-embed-modal-url`,
        onChange: (c) => {
          const { value: u } = c.target;
          r(u), a(u);
        }
      }
    ) }),
    /* @__PURE__ */ f(Zl, { children: /* @__PURE__ */ f(fo, { disabled: !o, onClick: l, "data-test-id": `${e.type}-embed-modal-submit-btn`, children: "Embed" }) })
  ] });
}
function $D() {
  const [, e] = nt.useLexicalComposerContext(), [t, i] = Rg(), r = (o) => {
    i(`Embed ${o.contentName}`, (s) => /* @__PURE__ */ f(lie, { embedConfig: o, onClose: s }));
  }, n = (o, s, a) => [
    new l0.AutoEmbedOption("Dismiss", {
      onSelect: a
    }),
    new l0.AutoEmbedOption(`Embed ${o.contentName}`, {
      onSelect: s
    })
  ];
  return /* @__PURE__ */ V(gt, { children: [
    t,
    /* @__PURE__ */ f(
      l0.LexicalAutoEmbedPlugin,
      {
        embedConfigs: hx,
        onOpenEmbedModalForConfig: r,
        getMenuOptions: n,
        menuRenderFn: (o, { selectedIndex: s, options: a, selectOptionAndCleanUp: l, setHighlightedIndex: c }) => {
          var u;
          return o.current ? mg.createPortal(
            /* @__PURE__ */ f(
              "div",
              {
                className: me(
                  "typeahead-popover auto-embed-menu",
                  (u = e.getTheme()) == null ? void 0 : u.typeaheadPopover
                ),
                style: {
                  marginLeft: o.current.style.width,
                  width: 200
                },
                children: /* @__PURE__ */ f(
                  sie,
                  {
                    options: a,
                    selectedItemIndex: s,
                    onOptionClick: (m, g) => {
                      c(g), l(m);
                    },
                    onOptionMouseEnter: (m) => {
                      c(m);
                    }
                  }
                )
              }
            ),
            o.current
          ) : null;
        }
      }
    )
  ] });
}
var px = {}, ac = Ii, cie = nt, uie = it, Ma = L, die = X;
function mie(e) {
  let t = new URLSearchParams();
  t.append("code", e);
  for (let i = 1; i < arguments.length; i++)
    t.append("v", arguments[i]);
  throw Error(`Minified Lexical error #${e}; visit https://lexical.dev/docs/error?${t} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
}
function e8(e, t) {
  for (let i = 0; i < t.length; i++) {
    let r = t[i](e);
    if (r)
      return r;
  }
  return null;
}
let yc = /[.,;\s]/;
function t8(e) {
  e = e.getPreviousSibling(), Ma.$isElementNode(e) && (e = e.getLastDescendant());
  var t;
  return !(t = e === null || Ma.$isLineBreakNode(e)) && (t = Ma.$isTextNode(e)) && (e = e.getTextContent(), t = yc.test(e[e.length - 1])), t;
}
function i8(e) {
  return e = e.getNextSibling(), Ma.$isElementNode(e) && (e = e.getFirstDescendant()), e === null || Ma.$isLineBreakNode(e) || Ma.$isTextNode(e) && yc.test(e.getTextContent()[0]);
}
function pE(e, t, i) {
  var r = e.getChildren();
  let n = r.length;
  for (let o = 0; o < n; o++) {
    let s = r[o];
    if (!Ma.$isTextNode(s) || !s.isSimpleText()) {
      Qp(e), i(null, e.getURL());
      return;
    }
  }
  r = e.getTextContent(), t = e8(r, t), t === null || t.text !== r ? (Qp(e), i(null, e.getURL())) : t8(e) && i8(e) ? (r = e.getURL(), r !== t.url && (e.setURL(t.url), i(t.url, r)), t.attributes && (r = e.getRel(), r !== t.attributes.rel && (e.setRel(t.attributes.rel || null), i(t.attributes.rel || null, r)), r = e.getTarget(), r !== t.attributes.target && (e.setTarget(t.attributes.target || null), i(t.attributes.target || null, r)))) : (Qp(e), i(null, e.getURL()));
}
function Qp(e) {
  let t = e.getChildren();
  var i = t.length;
  for (--i; 0 <= i; i--)
    e.insertAfter(t[i]);
  return e.remove(), t.map((r) => r.getLatest());
}
function gie(e, t, i) {
  die.useEffect(() => {
    e.hasNodes([ac.AutoLinkNode]) || mie(77);
    let r = (n, o) => {
      i && i(n, o);
    };
    return uie.mergeRegister(e.registerNodeTransform(Ma.TextNode, (n) => {
      var o = n.getParentOrThrow(), s = n.getPreviousSibling();
      if (ac.$isAutoLinkNode(o))
        pE(o, t, r);
      else if (!ac.$isLinkNode(o)) {
        if (n.isSimpleText() && (yc.test(n.getTextContent()[0]) || !ac.$isAutoLinkNode(s))) {
          s = o = n.getTextContent();
          let h = 0, A = n;
          for (var a; (a = e8(s, t)) && a !== null; ) {
            let y = a.index, E = a.length, v = y + E;
            var l = h + y, c = h + v, u = o, m = n;
            if ((0 < l ? yc.test(u[l - 1]) : t8(m)) && (c < u.length ? yc.test(u[c]) : i8(m))) {
              var g = void 0;
              h + y === 0 ? [g, A] = A.splitText(h + E) : [, g, A] = A.splitText(h + y, h + y + E), l = ac.$createAutoLinkNode(a.url, a.attributes), c = Ma.$createTextNode(a.text), c.setFormat(g.getFormat()), c.setDetail(g.getDetail()), l.append(c), g.replace(l), i && i(a.url, null), h = 0;
            } else
              h += v;
            s = s.substring(v);
          }
        }
        o = n.getPreviousSibling(), a = n.getNextSibling(), g = n.getTextContent(), ac.$isAutoLinkNode(o) && !yc.test(g[0]) && (o.append(n), pE(o, t, r), n = o.getURL(), i && i(null, n)), ac.$isAutoLinkNode(a) && !yc.test(g[g.length - 1]) && (Qp(a), pE(a, t, r), n = a.getURL(), i && i(null, n));
      }
    }));
  }, [e, t, i]);
}
px.AutoLinkPlugin = function({ matchers: e, onChange: t }) {
  let [i] = cie.useLexicalComposerContext();
  return gie(i, e, t), null;
};
px.createLinkMatcherWithRegExp = function(e, t = (i) => i) {
  return (i) => {
    let r = e.exec(i);
    return r === null ? null : { index: r.index, length: r[0].length, text: r[0], url: t(i) };
  };
};
const hie = px;
var Jb = hie;
const pie = /((https?:\/\/(www\.)?)|(www\.))[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/, fie = /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/, Aie = [
  Jb.createLinkMatcherWithRegExp(pie, (e) => e.startsWith("http") ? e : `https://${e}`),
  Jb.createLinkMatcherWithRegExp(fie, (e) => `mailto:${e}`)
];
function yie() {
  return /* @__PURE__ */ f(Jb.AutoLinkPlugin, { matchers: Aie });
}
function r8() {
  const [e] = nt.useLexicalComposerContext();
  return be(() => nn.registerCodeHighlighting(e), [e]), null;
}
const Eie = "_container_11ame_1", vie = "_title_11ame_8", bie = "_content_11ame_39", Cie = "_collapsed_11ame_43", fx = {
  container: Eie,
  title: vie,
  content: bie,
  collapsed: Cie
};
function xie(e) {
  const t = e.open !== void 0 ? e.open : !0;
  return {
    node: Ax(t)
  };
}
class Gc extends L.ElementNode {
  constructor(i, r) {
    super(r);
    Ze(this, "__open");
    this.__open = i;
  }
  static getType() {
    return "collapsible-container";
  }
  static clone(i) {
    return new Gc(i.__open, i.__key);
  }
  createDOM(i, r) {
    const n = Wt("details");
    return n.classList.add(fx.container), n.open = this.__open, n.addEventListener("toggle", () => {
      r.getEditorState().read(() => this.getOpen()) !== n.open && r.update(() => this.toggleOpen());
    }), n;
  }
  updateDOM(i, r) {
    return i.__open !== this.__open && (r.open = this.__open), !1;
  }
  static importDOM() {
    return {
      details: (i) => ({
        conversion: xie,
        priority: 1
      })
    };
  }
  static importJSON(i) {
    return Ax(i.open);
  }
  exportDOM() {
    const i = Wt("details");
    return i.setAttribute("open", this.__open.toString()), { element: i };
  }
  exportJSON() {
    return ee(q({}, super.exportJSON()), {
      open: this.__open,
      type: "collapsible-container",
      version: 1
    });
  }
  setOpen(i) {
    const r = this.getWritable();
    r.__open = i;
  }
  getOpen() {
    return this.getLatest().__open;
  }
  toggleOpen() {
    this.setOpen(!this.getOpen());
  }
}
function Ax(e) {
  return new Gc(e);
}
function fa(e) {
  return e instanceof Gc;
}
function Iie(e) {
  return {
    node: yx()
  };
}
class Qc extends L.ElementNode {
  static getType() {
    return "collapsible-content";
  }
  static clone(t) {
    return new Qc(t.__key);
  }
  createDOM(t) {
    const i = Wt("div");
    return i.classList.add(fx.content), i;
  }
  updateDOM(t, i) {
    return !1;
  }
  static importDOM() {
    return {
      div: (t) => t.hasAttribute("data-lexical-collapsible-content") ? {
        conversion: Iie,
        priority: 2
      } : null
    };
  }
  exportDOM() {
    const t = Wt("div");
    return t.setAttribute("data-lexical-collapsible-content", "true"), { element: t };
  }
  static importJSON(t) {
    return yx();
  }
  isShadowRoot() {
    return !0;
  }
  exportJSON() {
    return ee(q({}, super.exportJSON()), {
      type: "collapsible-content",
      version: 1
    });
  }
}
function yx() {
  return new Qc();
}
function n8(e) {
  return e instanceof Qc;
}
function Sie(e) {
  return {
    node: Ex()
  };
}
class Wc extends L.ElementNode {
  static getType() {
    return "collapsible-title";
  }
  static clone(t) {
    return new Wc(t.__key);
  }
  createDOM(t, i) {
    const r = Wt("summary");
    return r.classList.add(fx.title), r;
  }
  updateDOM(t, i) {
    return !1;
  }
  static importDOM() {
    return {
      summary: (t) => ({
        conversion: Sie,
        priority: 1
      })
    };
  }
  static importJSON(t) {
    return Ex();
  }
  exportDOM() {
    return { element: Wt("summary") };
  }
  exportJSON() {
    return ee(q({}, super.exportJSON()), {
      type: "collapsible-title",
      version: 1
    });
  }
  collapseAtStart(t) {
    return this.getParentOrThrow().insertBefore(this), !0;
  }
  insertNewAfter(t, i = !0) {
    const r = this.getParentOrThrow();
    if (!fa(r))
      throw new Error("CollapsibleTitleNode expects to be child of CollapsibleContainerNode");
    if (r.getOpen()) {
      const n = this.getNextSibling();
      if (!n8(n))
        throw new Error("CollapsibleTitleNode expects to have CollapsibleContentNode sibling");
      const o = n.getFirstChild();
      if (L.$isElementNode(o))
        return o;
      {
        const s = L.$createParagraphNode();
        return n.append(s), s;
      }
    } else {
      const n = L.$createParagraphNode();
      return r.insertAfter(n, i), n;
    }
  }
}
function Ex() {
  return new Wc();
}
function ew(e) {
  return e instanceof Wc;
}
const vx = L.createCommand();
L.createCommand();
function o8() {
  const [e] = nt.useLexicalComposerContext();
  return be(() => {
    if (!e.hasNodes([Gc, Wc, Qc]))
      throw new Error(
        "CollapsiblePlugin: CollapsibleContainerNode, CollapsibleTitleNode, or CollapsibleContentNode not registered on editor"
      );
    const t = () => {
      var n;
      const r = L.$getSelection();
      if (L.$isRangeSelection(r) && r.isCollapsed() && r.anchor.offset === 0) {
        const o = it.$findMatchingParent(r.anchor.getNode(), fa);
        if (fa(o)) {
          const s = o.getParent();
          s !== null && s.getFirstChild() === o && r.anchor.key === ((n = o.getFirstDescendant()) == null ? void 0 : n.getKey()) && o.insertBefore(L.$createParagraphNode());
        }
      }
      return !1;
    }, i = () => {
      const r = L.$getSelection();
      if (L.$isRangeSelection(r) && r.isCollapsed()) {
        const n = it.$findMatchingParent(r.anchor.getNode(), fa);
        if (fa(n)) {
          const o = n.getParent();
          if (o !== null && o.getLastChild() === n) {
            const s = n.getLastDescendant();
            s !== null && r.anchor.key === s.getKey() && r.anchor.offset === s.getTextContentSize() && n.insertAfter(L.$createParagraphNode());
          }
        }
      }
      return !1;
    };
    return it.mergeRegister(
      // Structure enforcing transformers for each node type. In case nesting structure is not
      // "Container > Title + Content" it'll unwrap nodes and convert it back
      // to regular content.
      e.registerNodeTransform(Qc, (r) => {
        const n = r.getParent();
        if (!fa(n)) {
          const o = r.getChildren();
          for (const s of o)
            r.insertBefore(s);
          r.remove();
        }
      }),
      e.registerNodeTransform(Wc, (r) => {
        const n = r.getParent();
        if (!fa(n)) {
          r.replace(L.$createParagraphNode().append(...r.getChildren()));
          return;
        }
      }),
      e.registerNodeTransform(Gc, (r) => {
        const n = r.getChildren();
        if (n.length !== 2 || !ew(n[0]) || !n8(n[1])) {
          for (const o of n)
            r.insertBefore(o);
          r.remove();
        }
      }),
      // This handles the case when container is collapsed and we delete its previous sibling
      // into it, it would cause collapsed content deleted (since it's display: none, and selection
      // swallows it when deletes single char). Instead we expand container, which is although
      // not perfect, but avoids bigger problem
      e.registerCommand(
        L.DELETE_CHARACTER_COMMAND,
        () => {
          const r = L.$getSelection();
          if (!L.$isRangeSelection(r) || !r.isCollapsed() || r.anchor.offset !== 0)
            return !1;
          const o = r.anchor.getNode().getTopLevelElement();
          if (o === null)
            return !1;
          const s = o.getPreviousSibling();
          return !fa(s) || s.getOpen() ? !1 : (s.setOpen(!0), !0);
        },
        L.COMMAND_PRIORITY_LOW
      ),
      // When collapsible is the last child pressing down/right arrow will insert paragraph
      // below it to allow adding more content. It's similar what $insertBlockNode
      // (mainly for decorators), except it'll always be possible to continue adding
      // new content even if trailing paragraph is accidentally deleted
      e.registerCommand(L.KEY_ARROW_DOWN_COMMAND, i, L.COMMAND_PRIORITY_LOW),
      e.registerCommand(L.KEY_ARROW_RIGHT_COMMAND, i, L.COMMAND_PRIORITY_LOW),
      // When collapsible is the first child pressing up/left arrow will insert paragraph
      // above it to allow adding more content. It's similar what $insertBlockNode
      // (mainly for decorators), except it'll always be possible to continue adding
      // new content even if leading paragraph is accidentally deleted
      e.registerCommand(L.KEY_ARROW_UP_COMMAND, t, L.COMMAND_PRIORITY_LOW),
      e.registerCommand(L.KEY_ARROW_LEFT_COMMAND, t, L.COMMAND_PRIORITY_LOW),
      // Handling CMD+Enter to toggle collapsible element collapsed state
      e.registerCommand(
        L.INSERT_PARAGRAPH_COMMAND,
        () => {
          var n;
          const r = (n = e._window) == null ? void 0 : n.event;
          if (r && (r.ctrlKey || r.metaKey) && r.key === "Enter") {
            const o = L.$getPreviousSelection();
            if (L.$isRangeSelection(o) && o.isCollapsed()) {
              const s = it.$findMatchingParent(
                o.anchor.getNode(),
                (a) => L.$isElementNode(a) && !a.isInline()
              );
              if (ew(s)) {
                const a = s.getParent();
                if (fa(a))
                  return a.toggleOpen(), L.$setSelection(o.clone()), !0;
              }
            }
          }
          return !1;
        },
        L.COMMAND_PRIORITY_LOW
      ),
      e.registerCommand(
        vx,
        () => (e.update(() => {
          const r = Ex();
          it.$insertNodeToNearestRoot(
            Ax(!0).append(
              r,
              yx().append(L.$createParagraphNode())
            )
          ), r.select();
        }), !0),
        L.COMMAND_PRIORITY_LOW
      )
    );
  }, [e]), null;
}
const s8 = "data:image/gif;base64,R0lGODlh4AEOAfecAOObTfm1Y9yVStaRRfmzXtqTRYtaOuukVIpNK0gjDYRKJuWjW8uEO+ulWoRTNYlWOe2yZ3ZIJ+yrY3REK3RDJcN7NMJ5LtOLPlwyHcN9Qv7RjNqjaYZYN+enZqloNmpLM+2qXLmZdoVcQvGucvGrVvzCdd2ZS/SzY5djOnhHMoI+IaJdKPOtW8qHRvS0a3Y7GdWSS+6oVfq9c+u1eMR8OsiDO/KtYnlUOVoxDop1WGY5JKNdMkkpFGUrCsZ9ONONQ4hmSKd6V7aKZUc0G2QuEvClV2pUOseLVdezi7pzLd2bU5NeQah0S3pLMoltUqiDXGY1GbBuQrN8VfGeVLp1OIRKKtONSvrIhntGKnpkSahiHoVZO+SdUolGGntKLOO+oicNAY1xTvq7bGo7JXVLMtacZuGXS+ehTntFJuOdWkUdCrNtNj43Iv7Ul4RVOlk5IzgiDWU6JMmoheWhU5JMG1hEKqRsRsekenY+I6uRblcrFqNdHLeTa7yCSZdVKOOeYdamd+iiT7aFWTYeEb6BPdiXVmwyC/KuafrjuLNsK4JGKpl2V4ROM5hoR3ZJK4pVNjkmFNWrhZVtUotZNmpbQpJNJZRaONGGPfjKldiRPohIJJiGZ/vEezMcCx0KAJBPMTMZBui3iFYzGVotGvHszpiCXaplKHlDGvWyXcabd5lVGjAPAnhcQ8edgqiXdqqHZuaqXS0XBi4hDT0yHMiVaTcYBz1GK0UvIEc5I1MeBlNMM1UqFVkpC2AfAmdnTGpFK3BCGnNtUnc4C3dRLniDXXnKm3uJaHyuiH1JJoM+FYhHDouNboxSKZJiN5KdgpN8YpOrjJiXdplxTZmhfJrMpJzLpaZ+Yaqhe6xxPK2xkq69orLTsbadgrbJqrd4Rrmmhryie7zkwr2SW8iTasqTWMqyks2hW83ivc7QsNCPT9KqctLlxdW9o9a5ltfCm9jewdyZSN2iWeetdeqeUurDk+u8jeyzXuzewe7RrfDBevO4XvS6dvXCe/a5afvXp/785iH/C05FVFNDQVBFMi4wAwEAAAAh+QQEBAD/ACwAAAAA4AEOAYcdCwAoDQEtFwYuIQ0yDgEzHAs2GAY2HhE4IQ06KBU9Mhw9NyI9RCxFHQlHNBtHOiRIJAxKKBNUKxVUSzNVHgVWMxlXKxZYKQtYMQ5YRCtZW0FaLRpaOSNcMh1hHwFjNSJlKwtnNRloOyZpMQ5pVTppW0NqOyVqQRxqRCpqSzNqUS1scVZuWjdvgl9zblN0QyV0RCt1SzJ2OAx2Oxl2PiN2SCd3iml4SjR4W0N5Qxp5RzF5SSl5VDh5kW55zp16SzJ6US56ZEh7RSV7Rip7Six8on18soqAPyKBPQ6CRiqDPhaDRCSDTjOESiaESiuEUzWFVTqFXEKGWDeHWTmIRxCIZkiIgl6JRhqJVjmJbVKKTSuKVTWKdVeKfGKLTSWLWjqLYTyMUSqNcU6OoX6PkXOSTBuSTSOSXkGT0KeUWziUq4mWbVKXVSiXfWKXnIOYYzqYaEeZVRqZd1aZh2iack2cglydYiueYR+gxqCiXCmjXRyjXTKkbEenc0uneVanfWKoYh6oaDaog1ypZSiph2apl3arkG+roX6sr4+tcjmtnYOub0SzbCqzbTazfFazvaO0zKu2ima3eUW3hVq3k2u5mXa5qIW6cy26dTe6j1u6o3u648K8gkm838C+gT3BeS7CfkLDezXEezbEfTrGi1XGm3bGnoHGpHvHkmnIgzvIlWnIqIXKh0bKkljLhDvM4b3NvaLN07TO3cLRhjzRj1HRtpPTiz7TjUPTjkrUq4XU5cbVkkvWkD/WkUTWnGXXp3fXrHTXsovYl1bak0bapGjbwprclkrdmEfdmUvdmlPeoVrinmHjmUzjm03jnVPknlrloVPlo1vmoU7mp2bmqV3nrHXook/ot4fpxJTqnlPq3cPrpFTrpVrrtXjr0q7sq2PssV7tqlztsmbt683uqFXvwH/wu4nxn1PxpVbxq1bxrnLyrWLyrmrzrVv0s2P0tGv0uHf1sV31u3T2wXn34rj4ypX5s175uGn6vXP6yIb7xHv716b8wnX90Yz905f+/OcI/wALCBx4oOCBCB+ibNnDME8eM2UgRoSopOLEiRWPaNzIsaPHJR9pzBDpUYmZIyclnjwSAsSIlxdG0EiipaaXMBGv5JChZM8iSY0WBR0q6qdQUEiFNtxT5iHEO3YGDUqEyZMrXMmUPYPGbZvXc+i+diUnNuxYsdaQHVOblmw4t2/jynUXThw4uu7e5b1rd6/fdd/e4RtMGB87wIHBzVvMTzFfx3T5SZ5MWZ9ly30z/817T6+8zp8l32NMGl7h0J4F67X7ObPcaLCz7mJ1y9VV2p56IdMarVeoW1mdCW82vLjxbGMRpzaXr7nz59D7WZber7r16uWuW8dWTly37M+7f/9nHj26v/PW0dfD7nw8+fLk8cX//u47QYP4Ey50yPAixowmqbRSSAQWmNFIB4KUEkUardSSSxCOZFMcKs3Ak09GNYLJURl2qOFST1Eo1VSecIIVb7GVZZaKcKGVFlvSWNPijHNpltpmOJ4G2mGrKUbZY35VJuRlktmIY5CpnSakaag11tqTNyb2TVywrTXbLb3QduVabtUG43HBgZmccoTBR+R0aFIXHXdq6kNdOd+tCac5g5mXnnp4atecae/1KV94l9Fn3wCE4lcQQkykwQYbDQkoEYABSmSgRgiWtFGlCGLa4EkmbaQFpSDEdEFMM+EE0aJe6HRhIBwOpeGroAT/VZRSID4UB1QkagnbWWDxSiOLMQbLJVev/arckUZmFpqORhbJmT2N2cPXkGdilmyOoDVJrZLOZhslXlNSk6JWstGyi5XnEmvMLOlyBaYxxB03Jo9lRucne+XZq6Z0c+67Z5z53pnnwNj1GbBzp1Xj3TwJNOwwfg6IoIWijDrkX05lAHhRSJl2PBJJIHvscUYZd0rRpyyNqrJMTZjqsqpXYHiUhrF2GOusjYDY1KJQUcVKmCn6CuzQwn5pbI1AIhuPjXVitqOyP2K7bbXXSl3a1E5726Q4T4cb7rhhbrkbONBgKdxZ74rZVWLaHpymv3A/12Y5aWZ3tZ3W7YOe3gOj/wcwvtDdK083CzPssAKIN/wAByYkyrPFF5csOYMdIRhCppdnLrLIL2F6U4Vm1ESpyqNenoPLqGq0qlBD2fyThq9/+JCtIpJobtBDr6j7isL2HmyxM1atNGf1FqbZ3ZBFexfWlwnfGfGqcatkPtIzu2NXKIKtlthmu9v9V2mrvTZgfLrttp5xz0k3oIwdrB7ffa93nj5xps8+Y3bFmfjhCzywOA5YoBh/Ilcyi0jqUhbKXOYg9JIGOvCBDhSV5wKEktChrCUUWNkMroA6nFRkdbGriqyKUjNYNcoMtJsKJk6EO6HlDnzx8h1bjoY04TXraq2BWtSS5iPmdcdI7bBatv+mRzXpRe9rwhBbErdkmybiJivhWBe83BW+GMZwXvUy02Xk5ibwWKcc2OhHGPmlPi8+hztdxFv8CJYP+lRHflpEGOGmAQ/qJWABh+rfHRd3g5owBYW0+w+kDpgRBorKkBA6pCJXpshKZayCGRHdCEhHKiF0UCdKGEFP+OChDcGqkzq71a1WSIut7MqFu3ORDH33uzG1aGk1VFpdCiekG54JSPPoYbWoZkOtRa94RTTiamLDRCem4pgi9AQmLnFMs71FN0AL2xSteMVT0utP7Dsfe9BXsPXVbTFmVOP71lidavyNm+ybIx2bcwA8ulOPixNBBR/nqAKajHIeyCQlPbD/z376k1QNRNDnMrYgjagsg5XECeoyCYKesMqTJbyZq0rICP6kkJS7mgYqU0k0ZniUmm0hFvBiOTxY/vKkOrwlD32Iv17uqHrAJBKTeqRRreDCS7hR5jIvwdNkOpEt4hpWFUFKxV2RL4tydF/ctknG9t1PqeSEIxmBkR312G8w36kGMbzDzjzC0wERmwlTBhg5i5CMQfzk5wbSaoF/unVlNdiJSyQEyQpZiK0YwEAOOLjQIyChoQwJYet+Igqfyo6sedAQvGp6yhdylKjVLKq4aBhEWc4yL5NRB9ey9phd8tAdLF3MZ6WEJG6FB5iEGSYxi8kKqzTziTdN126iOVTI/8rrMEz6pjfbxFQ3odMy4dwT9bSJPjytBzpaPaf5BqfVwuVjf+/s3wI4cIQALsUpFTorBQ2a1lC11btvzWs/QwAEJ9DAAyxbgqQGBJJJUqABKntBy/r6V4fGKqKdFOFh9bAzRoBCGKZs4Yx69diPGjgbkc0dSZ93rKQZb7POAgaEPevg0NKUtGQ6aWhTexhuALhcW4qtbs714RSVOHtpQ5dQiWrUIQK3fPpaKjedGh1wlmcx3DyujtNJDXPWTYvwINxW5eEc/0l3j9Kl7sToWc9BUu4D6EXkBsQbEwhSGbyle8ITaNA5jqSkQdxtAHyzrNDU+TWfMhsszSgKlMM2xf8nSFmGnAXsWN55lBcH7h1lF1xS6E1jwjnUJb+shdnlWdg1lUWahilzP/nMFInElCZtJwviE2OvONOEl5VsK1IX13EezMGxjKfz2zm9DXDEPa6+wqMOYgyZMQYT7ou9QwwiF9nIiDtyAjrQIJ1h9z+cImSUQ/UgBm6g2DCJICVnkCgdPMhT8zxQqBBKKr4KqCLoZVSGSDhYbr+KERV1iGLnjLaz1dnOzOAFnvPsUQWPNNHXg3eD/wxovWjFucN1Fi53SWEgZnjRW/wms7zGWIITvLHlwpJsiyoc2Wp6GJu2bV1geupRO0dPVLU4cQMH5JoWjkmxluM0Xj0dxuFautL/pYFCGvXryZmsU6AKAZQXOFcFIhsmh5zk5ZrN5YaeNdhhHrNey+sFCj2qvigU7JoLO9H9+ve/5C73uV10DFuse8VHS6WiGdxgv0w2MA8Wl2C2OGimOZXfHMbwvwEeR33QCUrf4tG8V8u97T3zK1J8OMT3bjTJLqsysvZXMdaX4y92g6rNkSqqyb5qjjPn7YYZuavp3WofCzzykrd1c0qggQlMgAGgZ0Dn+6fyRYUyu2bFZyZH8oEEul6BU+6AzGWvc5vrAArm1XmpUmLWGYBAzGOWyenom08zdPvbTIdVrPYQbj0wM+ouNHediVP1q7P43WaRd9cveyxrDlyXaRRt/0rR/n21HxXuNDYThzUbd7nLnZi40VUSr/IW6W9P719KcDR++eJP4823hfdGcDIexCVq9hNyoRZkrgZgI9eAYJdbCWgaDphb8IADJeB5CzABGrCBoydWOlNPIIhAwqdAJvAxltN6vkd7JJg5OuBsU5ZelAMqEEBtpjNQDIJ0e1BCyScri1BYbbZMDuF8o9Ar0MdwU9dwWWJ9XnFgG5V9fFZDlDZxYddjoeFbzdNjgEZ+s4Zoancjp+E2kDcYRxR3kHYlr+VwK3R35XZ/fNd3nWZaBzNG3mAdc0gwgzd4FYc+4GSAB1hj8CAOxAA0DvhxA7dVH/cOLhAEF8iBGiB6E//AOExQMWP1a5GyXjFocyMIMihIEibQeitIgp2YUJzSe6NCgxtkg5wiAw3FBq8zKzWTfLAIhOCGFARWi8hxhDBUfUq4hMQxYELzhFCIIijFNrYWfrnUWcxTforGfkmSfo0Gcu3Xfb1hhmc4W/OHDPVXFkHFhm7ofYXxdlAlMPEzgFWleHqoXIvXcR92YgDGGhR4PS0WLonIeZ3HgY6YAX0kiagCOpY4itimKSZ4giz4ejPQet6Fgh8wg7uHEqQ4gxq0Ax1EBQzFE2r2irCyg4EwFT8jL7gYfbq4abm4Fe3AUa6EGNrnFTVSVMPojpOBMMc4LThEZPhTGRfmNUflhZL/0XaQx4zv936rBVsO92HHlAwjaW7FQn3diEVweHHFNU4DQzeLMUYBSI562Gin1WrsWC6DyJN2UXD09g2cx3mex4idhwI6AEiQc23+ESkxJzKmw3oC2RJyOXvfZTpTdgESMiGYxGXvBQERIIpGlyp+xRNJx4OfpF8XGWdGSWcdiYS2YSVUV4u/CBjoYJIn+XXZ+IbtF1MXFpNtQ5MG14X1ET3L9Wg9GZrTCJTRRA3IoEzOsA6SdZTiMz5sx5TaUYfnoTe6uQ/0YFXAgIdSKY5vxB2Ipx1sEjgw9nbsEGDac2+kpVotBJYpgIGfJ3qgNwEeeHqV6ChtqREkGJCdGJcy/ycSGIRQLyBzZEZIQeeQp2iDEqkExSczFtl0heWDt8OcRqhnRzgMVveY7aZKUreYwDgj0DBb2+CF3DcaLbmFWeiZtYSa7ud+TXNj/Rdkp4mfS/REgmhiVRGbI5WfYnF+bROAe7Ob8HMexIkNwclGTWVG6fgv89FqGDqbB7eh3GBk/hN6/QN62dlyBKQSIkiQ4MmJm2iCGzGXNYCeENBQNKGX7QV8M3hsw7ePTXBmSGB8GGlCiamY+AmirTR9d+af/wmgsukricZ9H2qUfkaMNEZoLDl2h3g3YgihyRIaQGaaJjklGGqG7VKGrOlfUpemHpqgUJKHd6I33gA/u6kexf8ZVezRqNoBRqL2L3Eyp+3opzYKaSj2DGDVqSiXchpxQiDYZN35liFzqqh6BH7wB46wqn6wBkBgAhjwl3kZbDQxSWJWOjU4UO1VfKwzUbFYn1zapWTamPwppl/KIgFakkgjm/FyWRfWjLdEb6XhHZ5GLTU5byl1p6mhqWdjU2KDcCTGFb0AqGo4fdpIjC4mTk7pD4mam+iBDcAgnCy6h3ryeGm0k48WYCaJaZN2aZPmqSeHOBvQa9oZgpeYqgqLqmeQC9jgDRBbD7nwqkQgl5Y0IaKzVsBXSUIgBHuJSeh1BMzXdPSJFCxErMUaUo4VI9V3Ffp3i8sKs2Z6pplphND/Q6gKCppveq1ySmiYuRlSQjg5+Yw82ZxLpEQoohZaci7U4ArmmpRNWCNs15T+0Jt68wq6WYd8I6/zCq9RpQ9UBWr3Sh/YxCSCMiUf5pOSJqBrixx/WQECa3KtlyinN6pAeqTkubALW13YoA3a4A30QA/mUAp+gAUWaxOImwQjsLEXIHsChUkf5KsPBaxIIax9GrMqSxaZ61gti6wAihyUibnM+hr5uabPeXb0w5Li95mMd4U/C7RQQ7RFa0qVBpSyVRtnqBWpAAihUKAj9rLKqpT8Z6hea6LFSzdy6Kj8Aqn/Qj1+EnnWWlOXam+0K2lGGzayl70oMAEp0L3y5Dj6//ijpMoSQ6q3HwEH3qAN9KAN40AP3rAKhMADuoexkuSQutqeCgUSq2d8v/ptW4qymisjvri5HdUMx+q5MsucoRugAkq6Scl1aDphw6VD6DcPOYt2oal2Xwlj+Wahs+uvrPVayORaDucJepAKSLhwCIeZ6XqTw0u1xbubViuvYxTD9YqOi0Ef74EZzaWnuyCSDEa7QUlb9yeUsmeWPDAFcLAGSwwHaSBAaYkxUsydB0KQGqEDk7IRfbAP6hu47juxP3AB8IW/iDsDfamrltQHjiAJDLERMiADXoAhF+lTw+qRBJwOexbAvtuf7MKRtyizdgbAInV3bNhpC4zHp7tDvv9EiDg0ra/rk+pKkxLoGnRHjc10ybi7tGGDCXGAwgoXlI7VWKKJTbYZP4t6Hocnh6f8lHSzMMgJjTGqMNLLtGq7FQ9nvSS2dx8GtzsnBU3cxIoCxXYbgpSyOVm8EY5QtV3cm2DMnvSLMr+XQbuaBnzwR4PJMmlWshuJnyQpwN08uryYhEPpx4C8UfbXQtxooDQ7mRMKNVzHuthKNo8cmtoSdl25jSGWU6pJxMEhFbfRhlAbqFDIf+9Br05JwwKzyuhBqZOaMBQYapoly1pZyyDctroMYOJFXkSgZQH0xGdwXXvAkFNMzMVspMesv6rKm/TQvsxMCE6wMn50KqITiiX/SBIsk0AuEbIjW7Kj8F8lVs7eHNSIXKbM6rt7NwvjzISCbMf5mQx1N6js/GA3646gtRo967pi9xfWVG9wd8+R5tTpfEpeWSWy5c9KVMhQPbPLCHKlTE71E1V+Q47+p6/q8NBiKKPRsET7R9FgfcuSFltJxAwZnQMvQM1wwEmcRDGANMxUvHoF+dgbgcWTUhN8oNJevA+/MAlSoHNN8MSsgtgefQaiPdpLoIoRFLLaNrmJebICKpmUNah4Ec5Z0kx8x7ZKTaBeen9W97uDHH20mXZj2CzEE89ZTckZxabBbdybKozSuMcs5Ap3wAi/m84BHbyPzH4cbNDlVA35ANfX//FD1hqBsOzQER2IV/IMPAKwFt3XAC1FLZFXhP0Gatyqie1HDnFP4vtIVQzZRnoG1RXS1TXann0GydybXuwNpRAJWBDf8t0HDr4IiM0Hv9zEn9IxDWR8kzuy9Ukbs/nNIznUNavOsITPtoBMthCmQoU9WDfATa207MLbtt3AR8Q2wzN2V40PLFyjWx2NqHncg0hwLp7UyYAJvEvdfk3Ovb3CNhnRMEav5pBciae8HlzXMhkaU07lM1XesuFM3vrX7I1/J3ICSKoFhw3aUPxHOWFAF8OQ/1hz/X0Gi0DfBN6qpDAJpOALv3ANJroPg1u4T/AGgC7frPLZAu7RAYQyaf8QCIvyxnCs2rNYWD7d4UIN4uvsPSJOJfeXCp/wCSfe3n/MbgVcoEg5YrsNTTEuJqohmsJz4/K849G5fRpMpzqO1FXxPbvgz9No5EnZ4qLs4+zA1unTgABIos47eX9H5UyO5cr+DjV1rLQ8o17+UXp90eV1noRdAxwt2ntgE5O4ICN9t9eMbBsB545gCrkwsXxQCsFwDet+De5uDie6D8GACnQABgMe6G+QB4bu0UzQ7y3DQawC6IJZmJMLCmbz07cdvJR+yEY9Niy8PbbB6en2ybct6S1O6jD+ubcF67FeWqThyD+rqV/Z8coNoXsMhGkYaVJBlLqOlLw+m71OR1j/vls5bOzDPpUKuE7AHRhcGSXNrivoXNFDrGnTbu/ldfRS8AUCzu39QUHD7MZ/NVcCxQfl/u65QPXXwB2Pt/Xysx65MAn4HvaM8sRssBBbkLg3YdiKTqUabvCg/vbudpJFeX8xQmm6vemiMPEUz9q1xXDcmIQZ3/fckKckXzXEHfI1G/Noipk/TsmzvVMrFE22AAiMIPRGLuophnVKTnkWnFk57wtgdyZXdRhagacj3/jpbcuffL22XC59/eWYJgZGf/ROUBNnjyofmN9mBSoNBTLpngvvfg2lwAeRwBx8zvXGFQxg/wVRYe/NHxVhYAdJjxOK8u84MehjhTGsoskG/5p/QE0jcm+ZS+jpmc7p6kbbw+D2Ywr3mY/x083+qC7rqj5+mdXql8VY3Cyo4iKMXwkQyQTeSjUK00FXvaJxiyZw4ShAoRYiM0bR4kVnGTUKxLix1y6LG5+NJEly2jd271SuPClspDiV8OTJnJdPn02cOKcpIwZTZsqWKNehZEjUaMNdBFPhcliyqceKIKNyfJrxDRisT4hsddI1iRawbMyY2WPmiJIyStCmHdu27Vm1M0CMoHH2jKNr5nKZKpXLUZpIwXLlNVfYXD3E/hTXC/Y3qx0wkMNItjO5chjMTa54YRPIcyCxofdIYkXLJUVl0qBZU93a9bZssNExnJ2u3f9t3OGGuuPdeyhDjMeCe7q0lNcn5MOUE2R2Lnbzqc1ErqY+/OOt68qhT5fOveh38NS+iddtFOZ5n/P4reenkvxCohPlw69eP/V9/PdxsSqIMKFy8qhK5pJBXAlnouASVLC76KryTiOj3BvJJaFiokm9C2lSJ5mTWIrPJBCPQpC5YbhzkCqpGtwuIzpahAMOrF5MY8YtjgBrjzzKcmvHHeOCay4QZqiLj2AKQ2WRN/qYEZUjHRnsMCgTQ6waQa6KDAwW7IAsq8wwC82LzSz7srNAQDHNKftek23N3HZr0004f7tIODpVs4U44xhhRBTsDNIOKhVRSzA7Xgj98zlEGWT/xsHwGjUPPUjZa0+ck94b78MHV+sImfySIsi/6xwST8BdBhkEF+AWJFVVBU9bkVFMT3vUwp+6UcfWoFCaaTw0e+3VU+xMPDFFYiuabpJIJvFDEEeYbdaPPvgQawmxcGSLxzLcQutHueaiQQtUoHTkCBmWaMKRUhYJQYhw94Eyr8XqAWaSLyDTUjLLvBQtszD3zYMR0s6EME3qEGXzzXsSVnhh3sojas7sKHLlkuKEAyQiUcwcBpRRFiUpUFbpNDRUQBWFNURH34QUHN4mpZRXR+cTtlX++jOOQ/pGZIqaXvTQA6SSgw65zldnNvrRWV+GuUKYfU1UJGAPFXDmYhsk/ylZSrCOJOutHYGDDWq1HUutbMvu8SwgvT3iDFPEPcJbVHLh44IRSInymmq6iXfeN7SMDF9976j2sxwHaeTwg/xzNVPW2AQPN4bxkVwfSSWPkxpNoy70zk/2XBSQODDmONjtlgN50JFNL7r0QB9M2WGlWV7ZUhFlplrimm1OCGd2HEZqP6mmYSUORow2WWpjoWPq+EVZD1kYY02KOSjpm3ba+YtInHr746t2kGuuCcF62TTCwrGsbc0+20ckkAASCXAJu+avGZTYY7BJNvPlsCmBqSafxFSDE/eKAxAsIzgEaqlMnCDN6PjzQOAt7inkKNiapFcbOC1scpSzyXo8VP+pqXDOE/1BTseGAbo4lDBj2ltUxAbiPZFdxxapY17rXPc635FHdr6hXe1ulz2ljPCBnGJagCK4H2F8AxQpnM/psKco0g1tVU9kXH6qQr1hTZFY/6lhFmFYFTmEcQ1ikFFWDBgmHdlIfXHJlo3Y574gyWAGaXhSYfyShiMsIi+/IM3/AJiPbgCDGN34owBBQ0AFJoKBDCRFaU7zyGJFsEG0sWAlv5NBDW6wcitpWFR6MUKKXUxPe3rGLVCoQoNwTGPGIFHqXDkLWP6HhVS04dNyNr0eKu2WjUJQDWVYkIKAxFIS+p0jHbkMArGCV7RkpupQ5KroOLFYQtMP9z52uhf/RjKWX9wUEJmyvOjEBgc8iAEMUHDOE6RzXULqF1lyxKO1bCsucnQfPdkgPzsiyW75KAw8cqKPQBIDGOUgKDH4s8gRJhShjoQkNGMYLKlRsnGWpA3CepPJTS7sQBn5CHFGSTFGsMIZpqSCHj4RRD+10nQqfeUMXbqclx7KmU605S5llsuNvgQ+WKyPNzvqCqAWShlFXCawIMpQU4n0mn+Kpsha2MI7RZFoMpXmU+vkPS0+EXoea+pKPxlUKaLumzD8AAcqcFYMpFWtdKPCZgp3OI4dDknn01Eb29o+etovb/LjYyKm0c+8aIhSrRCGLwRKDMJCr5Gt4EQmSgPBsYIs/6YsRQ0FKeo4TGY2YR7MJDFZmUpVkpIVecjWnlQJ2mCytJUsBWtqNzdZps7UmgPjaQVtikvaZFVzshzqB3tpVJKcabR5uMVSq2rVRY2CizNlblexI1XJclO6UNXcdYApVIhN15WlQysEIuDdtQYpDmTK2Glpcdq4gqIRdb3rWvKwCMMuYxl5W0Yjp1GNSu2koVIhLNAEZpH+Pte/DqWuV7Vn2cti9nILxqjlFDYeq+7Hc6BAYSNQi9rHPnebq20tUIP62pfC1qs0leCJqHNbFP92VdVdDSd9CCxXcWwkoy2ecbFHVZgq16khvHE0KevcLQoYeLPcagiHTKjrfiS7Q//TZmwl4F0IpDUE6zSg4R67So2hQmDoVS9px7sHCx8zvvL1RWHNvF/TAFcZim3y5gpsZGaA2MDNsA2CL6uyBdd5hw1WWGzYbJBBIIcRPjNt7kKRUg57GLIgjmowhcNoWLp5zljdL2qsmJ8U06fEKwZWb9XDEk2zWVbPUKVzRlGGGleax8jVTipd+CcTsnrSzYXzkYVs6zbj+qtJXrJ2f9y8KU+5CVLACh/6MAn7jvqaZpKvSTa0DC5/s6ETmjant8tqSRtKeZCWc3PqnOBL5hmDFNxzZ4Gy7EGbymd6aARKy6tjDcfyw5BWNK/jLO8Nz9pqVCFsv89sZkxnupe6fWH/RnTVsABVc8AzTqV8G1GGTzSb4LFV3gpHvLyOgYIZpbb1cmmta9WGPLKzbrTHr+3TDPdp49qZUZIkgWzCxpcYt4XQMpzTbHXcfMaz9cioCbzdmFp1hveON45nkeN81wbceBY3uWEXuXOP9Lzr1VMefHZoB6L31iX/sBC57mii41vEJ0+zaVpBin772+eiQpnttDht3Wg0t9YeSHGYbQzQgUK/HAXym48DbwOfY2PNizVME62d2EZ264sXueJ/yevq/rjNsRawMNBe5jUfNr/gsW2zZ2PzZ/fOllOBZBQz59OxG93wSS9wvDcMboMz/U05zGFKXCx6y4vCwhnr3B5W/3je85p30fNO8nWXYhwlh7342R7ZEc2O9sZC3+wyp75AZt6QSyu82rG3PTER9OdbJ25nFI6D3qm9allvjvfJZXzGTaiU8BMd5O1nfP0v7lJgutb+LMadhgE/i1vaic3rIYniFTc5h96ROKsqMk+Kqpl5qITIhv4buoditHe7P3orrtwowO6QvaZzFKDYjWbjMt0LswgSvsXruuVzLQjUnXlzJed7PoQijcWKuc3bvKp4JJ7jHaIClMjzFFPpmBnLu6JCvxG7N97TOCxTCsEzIY1xwhxztdWrv9wROyvcP9dbvhBrqZZKuqOQHdorj28bQ5hxDjN8GtQDq1TxJaDaNv/Y8jvl0zE3VL96OwZego0O9MDLsbMTe7plujASVCXSwATIKo1fysLje0GLKJSTSkJFnMKtg75FipZFcAQajC/62rzrAzjt2zT48C3jgjFbI5BAG8HQuQUIkzU4TK4SaiH365OMMzUdyzhY3Bg+UUIsrEMrfMFc/Los7MVDhLeUEsPZO8Bx+w0xvEM87KksPClvm6jjcUA8pCG/azT4KxGpQ8SJObpxuzM9nL3O46VbsLv94LLDoStFGr4fvEKScUVHFDtwkrElHDJVapZFuMc+kAQaVIVByht/zMSZ28TMowrM07z8EsDv66/+o4VgDMKd2bjxwkYGPELqSiWLy7H/jflFYdwmRFM/wVu5jVOueoOsREylkGzC5cg6beSTXYRH+ju8YCHDb9zAbuRDC4Iid+MFNekeSWMNfZOzDIQ1/+M9Z6TJNPHDD+Q8m/oNVig0ElwvsSgtTmCFqUy5dbTKyKpIkbzFWVgl5fDKQoyKesTHaGkRP+AEVDCsX8AVvLmVTMSvG4xLuBRAgbS86+ivqvwp/ki34toJVviEU7Qx9oszcIozR5TCa4RHldww92tCk5S0kSQ+lswYVnxF5jAT/JO39YvMzOTFfGtJWIqTmQRHDuzGjYjD5LhJnuQin6xA18xAsAvGbTwpO5u7FhtNo7ypRjEIlixH9FqvOGir/wXKy6TYtEhaOP5yR818rQgDufOyR0rERziIlmZBNrX0R3OQCbaEy390S388D7rMplY4xEJJuVRIN0xoClz4BPsprp9THUNkpb9UoYyEIJFcTlu8T/3Uz5XrzZCst+LbT5N8RSckUM3sTc4ETXasQpHEzWLMTaXjwDkUhVa0Tex5Kcu6P+WEzW3KxhnSz6Icw2WUDQfNKd0EvWVYB2agGCwzR9CgAhkgr88gRIZaOzQRNccbSmcCyye8TFCATny8Chgxtmh5uZjrTltBUiX1TrhErNJjrFsgzis7T8FJz4GkhYcjLgmMLK80MAptRYvMz/2MpQvLna90P8oUhZD8z//8M779/E82RVMHmk2sg0U3TVDJvE+xU64SJc3arMkRFZlZUKFnfA1vOjrXeE2o+sxfPKoDrVCjzEMG4yFjtM2cAb2mRNDfpDrSkiP1CR1TQZxF00H54sS105ysEzzfNBNQuBNWfSxH6INAIFIhnVVaNVJ+NKwltZXsbMsk3c6A/De99BT7JBCTEphSZYSS2hnT2DZcrEjT4hNbzMgxfVRA5E/KnNYVmsw2HdPDDFMxZdB3RCk8xdP6nFMPE814sAd2nck/Lc1AJTpC5cPV1MlpTDzsosMtvEJ5JaHURMbb6ENiXFd3tdQzVFHE/E098YxOLZfNuIK7Mhs2eCvE0cf/3Ck7TlRAFGEKrbtGlYS+uXoRWhVZ6rTOXF3LX0BZX8WbwOrVX8WvYLW8/nIsxzJPTxAl93QKQLAfYyjVwaxGKt3Wa/XWCzvQMMVWat3Gbr2wNB1ap63TnFRQAF1ObyVYq6XUds1aCH1XicJJOi1UNtydDPUxDgUxPUXUoSyhigFYOSHRgX3QSrWe71hPTf1STjUVNoBRKkgDwkmL9kqfT32rGQ0zV8PYZNA5uxQ+Vs1PWI2WliNZIl0WR9gaVeDHlL1c7OyGPWJZXtXcJBWkmJ1ZKM1L4rgYT/gIEPEFCkOCPaAQu1zTxjwGWMJZogVQoXVaxpxM1CxaD7vdp71W//p0tzsd1OEl08IV0KuFHN/A2q3lWtV8tEFtRJOpV3u91wYs25aUw8y0W9pcmrf9Xub10/C42NA6CIrNW0+9R1LQxxeF2PZ53/Z5WMD91Iml2N3jGGTNrfiMM+oCWTqwEpKtTkdAu8qt3JT1hb643FzYK15dWZX1R0ECXcXKBLzkhak01tMNOGjLAyVohPP7uKC909/91llEr/X71r/rXQG1SBJuYRLeU6il2uIVWuMtCM1a3vAFVHh9XhVuJugdurGtwM7UxbQ9tEUl3i8NUe5T3j5VxqGA0/kcJau7ukHTWzaQhLTLVNKKyryCXy9+2E8tG1AlNMUBmpoCOASO1f8zeFw6mFysKQU4ZpICnmPMXeAnGYxqWOC8wdw8huDQHU/HMtaQChFT7GA0AUsNA6k6VeGtZFqsw13OHNARZmEXruQYZuSptdZHPkxU4lOtxWFQFt8Em44zfcPpPeLqLRnsbckKFV5IXeIcLthknFuL4011W7c9eTi9HYSpFDWqPIj2NRs2+lu/jVhjHq/QWTeTYlHTiw34gFl7XOMXWRZKiGMmoVw5nmPLrWNu7mY+jmCB6jfHClWl2imEXCJDfjapg0JGFLQVrl1KtmRMnuR3tuTE4d4ZhmdHtmesC2V/plQdviyv3VfkYRA5sw0fzEh688xYKqESUY4kdOeeNdH/3ZA7uGXbWUYUFbXPEpxin9m9QSsXwzFc07iyxEGcqvOyLyuc4Ixfv0VmZU4LmP6XXJZWjyGzX0CFZzFLQmCSOO4aranmas5my4Vjb/4Fw9pmgcpjcJ65xB2hjAWRU0vnoEBldy7JanVl3QlEdE1YeuZnkL7nTW5EGObnsY7o8wSlQwNlhonl5hVobPvh1VG+VI5GhjZXVNpS41VkS22ZPtOzScXoZyjDb4BTW/ZowlXWkiJEGzUq+4w2Qxs0mJ5pj9YDMb7sMSbEgiBgJhHgZ3mWPwjt0A5q0iZq00Zgo07t62zquvQ3aIhLTEiLQMjEhVBV6wrex1Y0XEszQak2/3oMKkPbZ67m6hYW600u60YWbk4+Kbtj0bZ+sLZW14B+XpyETLRNVFTWwDVsQdmV4V2cVwm0SL5+YtRYh82ynE9OypQpR5S6Zc3mGC/znNuBQe8px5Nm0fsGqZS27LK5q+AsAy3B4mT57GUJo2UR7WT5A2SJBPFZcNLG5jiG41P4hVOo8DgG51LQvMNy7YAMyGpohUAQTmIAKP0aRZv+4O2J6oNMwIPEOadAM2HoUeCjx1V91eH2D+Ne2nhObuNubrUtDiD/5+jW2ummqC4qFPmjXrHlhgu9a7xeP4bjXj1BhqKChnYwtxvew/Dwy1Gwb/Ml44PS5TyQ1gviuyVjJv9EybWOE28UaunNeAPRNjaS5enqZHBBIIQ7j/MDb/DSzuaUlfAJP4XKpWADVoW0SzuBAgq/ZIP6SYP9gQcQSpEh6hBQFBG57E7bY9JMd0tO33RP7/TwTMBbMbXnA75Gyu2qRHUdx+cfV2T8Jg4h/+e3Vk1mRLxuU/IZitfs1lck9kxXM8P5FDTTDbVs2A1NGvJQnp6mzRjgHPPHytJAy1mlPM1N2WFlzDSPyB3zndVYHSORneYCp2Y8x3MCD/cCx3M7L21rzpo8H6E6oGB4P7t4D0hKQawQh1EzkIT/6Ya9w9H5AnWNHQmZ44gyi7nqazb5uq/u9CfDaHiHf3iId/j/W4GHlVUHXbpSNJvS04ro/LYwV7e7WJd1gIU9at8xuRYrazxluqbDec5TiQz2UBDkiRaJKz92B8PyuFVRhLXTmCfjjCC/4nBda99JBQPfwN5AnQp4cY4EP/D2Fxkjc59cySVws4z6qZ96CGd3MyInHqCDdy/gQ9dwXyAFO8gBewoXcwjPgi91L0dpz3D7u1W3GX37+61BG/x3mYh4ftp7KUGMd6mHv48Xwf+necAVdsAvFv9gGs+d8i1BjwJ5tkZ26S7yWncu7ALaSJtrO2V5suZWRkzh4pJFu+XLNakslskoWrn5hBHsoSjiKc5WZf0ZlBFRXZ+oixb5o/+QDm8F/0pgFhf5fXMXbXMHfgM38D6IenSHY2X5X64/JxV4fjAQhEww9EO/vIJfhCUYgfd5A1/41TVjLGP9kvaiJ72VgfKnJ/RP/y6WWL4lUvXlbASmvgPuR5Rl6jw+rPrvY8992f0HiG4CBZqDB69gQXUK1U1r6OuhsIgSaZFixUoSRoyYMN3r6O4jO48iQZJsZ/JkOHQqyW1j2fKltGYymR0zNuwmzpw0d+7sxesn0Fm3ZjqbecyWq6RCkSp19cmpqKiieE2dSnXUKGbntmKVygiQnlDNuJEt2ksZNXf81rId2REfXLjv1tElW3ddtqWsvOrRwwgURVF6yjAS9q3hYbsuF/8zbhzvMeR0kU+WrHw3pV3Emon5apVJUB86okf7KW3aEWjTo1eTluPatCBCsiNVKlXJTxUpKVSg6O1bBQsxdTIRLz6JkyRSrUA50iLDA3QQIGbYaUUM2PJEge5QySHjO/jvSqiQL3/FfPkZSsBLj+5euvgZSZpoqe/lfpg0+vfzD8TH/3989LGIgAUGCOCACWJ0HHLIEdeKKhBy1lA1FS400IUZVugQRBF5RgtJbol4GYkrNdYSUSnytCJNQOnkE1NLsXhTUzFCVaNUV0V11TBbPQNKV1GBVVhi0CSDDJLQiBNXW+A4GdJbIiV2mU24+BQKll/5ZeUogxAGyjPPfKP/UkMmSubYmWlOhtKabZZo4l2bdfYZbnCs0dprsKlmJ5+s9SmaH4TUVhshckwRQ28ZKDoBChn0BhwPdBg3CYMY9eHcBdBpeoEMZdxhRxjdnSDDCd5dEQeqg6jayEaAWXRRRhphEsgetbJRRhnrfQffriPId8QSpuYwrHrFCnEsssMGqyywxDJ77BXLDksFfefhFwa2bOyHYKycKEcRRL5sOM0vFBJkkIXdjLiuZWwqxpiKM74ob042DpXilZ88ZW9TVlX1045Y9UjWMEFqCQgvZUVjZJJpdaQPxB05TNdcUJbIDjdW0tiVqnlcMhQmfYkV5jJhYmYmmmq6q/LKLbec/9lhnEU4SWl/6qmaa3f+qTOfVeT2hc9iCBebHLkh2igHSSu9KKSCUPK0cpQet8hz0GVqdaYjaD1dqWHcwUgirVq0Cy0S+XKk2ROVfRGQojRCq625IjH31vH1SmqxM4Q3Q6nx5Y3333Y7q16pzE7bXbDRXqttrbRql5EjgCkHkbkWVjwXk+yW9DK88da0oovzhh7UvT3dMguW+y6l7745Bhnwjj4WLNUnWoqSDckLo40WOGytJTGbJIpJccZDnc4XIJjgIkwjhOHiY5Eop8yymy5bf/GUMtPJ2s045yw0HD6HH/QU5fNwfgrn8wCG0bvtlrQDD8Q/fwUZkBCcIFIzGP85H7rerTUGAog3T3libGXbnZFyR40F5q4oyjiSxgLDNo3Qig300VvdeJXBvXGwg3r7IAeJ5TfDNWs94ymWtQ6nuPqk4VZscNwiJNEH1CDnclHKnObehDIH4qtKovthvQQ2I9TpKxU4cgoRaee6HJ1jGudoG/I+MRaF6Y5371hLPiIWPcyQCCTOYEWVoKKlv+yiS8kTBu5MxkXqsbGN9qieG7uYPVVECDR46t73eNaznz1BfUAAQm+S5igUdKA39yOk/OKXAAdEIH4cYBQY6BAb/clwEfuxz3wGR61BFJBsD/wkihLIw5h4ziwRjOCrYLUdM9wnWqZiT906CEtZ/m//gx40oa7+hkL1pBBYvbzWtW6Iw7jkkHMuGaVRgPii0ZHOJ6YUSuqMuDokOoUZr6PdVaBnjLaBbYy92GIV0fKwtiwMZpqh2FyCKCSwhMJKl/gL7rYyJWPS841xPJM9r/fGu4REezUDFB5LUzQ9jo+PfvxjDdzXgQowdJAx4EAiEyBRBFB0kRwATiQlSUNHEChB/3lDC/Njh5GGzVufAyUpU1pKz8GopWRDpSo3Ajc7oCpX6EmP3QBHy161R4O3DNwIe0mDXU5LhVcwyDB9V0wdwgSZ9PrcMpnJlNPtwnTYnGbrbnfNqyaMLFAUkpZSQZaSlROUDlNq9t41vLl8cXnu/1xn8o7yseWp8U35rCcc86rPfiqEQ6qgWWsC9Yc8eW98hv1CH/940Bj8MQWKauhFSYBIRQ6gAJW1KEbZN8PS8E9AqBEQDAtoUrOq1BqlPW2SWFovmFYklan0RNhm1c1BaKdjtv3USHHrpTx8qre4qul5yJMDxOGUbjvVpRIS50pN5mAezoUYdKOrVH7s867GbKpNUms6Za52Y0i5SYuS+K8jflWJtAPTVnABxbd500fQoCIPP/I7KqkVY+s45S3aBhaEHcUVZxkenPQpYOu68Z4a+sVDKJEaQM2mUITNYxV4FoUoLNZ9jD1fCZAmP/tlIKIDAMBlF/mA9OFgwqpREP8NOQHSRDSIOFVtGFqwi9oZ97C7VHXp2Kj6KiC9dsdt47GPfyxkbsq0cbfiLa5OqGS6GXdvzBVW4U7wXOlS+YYEvm4oVQs6G9siiHoJ742whFVqlte8U2liNr7K3iFlRY3wdeA3brjGeYakeKYE0iWG5NK6BvjKAm7jPdl4YDoqWKDDMYRsDJ1HnWWh0VmYMA78aOFJZzgFIthwCUjg4cqCeADxS0EJShyFO5WmoxtNxAtNClUYS+OYMqaxU5PpUi7fuNaz5tJ3c+xWtL2YtTCaoJrZy9th/7bYSZ7bsE6AuL7hDTxUzmKVRwRHtYpyy9ylanhp9GUwpy6rT4Fdmc3/Owy80ETNY7xdGhP45vdeEXjgJF4q6Mql2onsu+9915/xGmg/C1oh16gQoSNh6EoUWhA5W3SE19BoSENa0ki76KQhGtlNC6DTmL0fFuBgoI1b0gve+mRNSAvrkcd61U+ltU5OnvLs8trGEQQyzA32TlbVDmzEBu5NnQVdaPM82iOZ9rpVjnJ7e1mdRQR3UsBtZiaWxdzDFgUa4Rx0ZyxJLvQ9DF22aVV6c5KqC2Mqv/Nd4LCzzN8VAkYp6JjoOgiqEALFE6MdzfBIV3hpSXPfBBzFqAk8YKICqPjfFfAAR6kPaB7d+EgzAfLUxvi0uIvX42P9asmrnEUll5fQWY7f/5zo2tZDLqDYPDHz3H6qH6Y/fRZN73Prgl3GJgdvVK069NkdPZpbXbqZMVZur4CNzVqRejSiB+co2XeLeLFImMLoti2dLhkwCx7roU+mPu+b7PgMiToSgmC1Ew3RDl70nRyt8IbT/QaRLr9ClSaCiPN9AQcIwAEsa1kFQDx9QMi4xvmQ/wNxgjMSQZLJkZzjjdLkNZW6ZZnlEaABPtV2ad7rZR54Rd7mUUWPcYI0pYI/oJ4GQtt0UZe7MdXlrRrs0Zo1GY+2eV7t2d7t4V5UMEPWlVfvrQqYINAaVVu7FR8VNZ0xJF9+gdXHCEVRzJn16RugDSHr+ds15AKC2UbBef+fg4EPhIUf+UEB+qGfY9nd3T1W38Xf38lfAghSb9yf4emfgQRCIije4jWMdkXeFP0eG75huuXgicwhHDZVDU4eT0QEA0JgBLqhH0IQAELVrPFCBm6g6nEgWn2gEJoIMl1b0c0e6oSZuEUiCyqRC36DMJjbV4DNvmTX12VG8tkEN1hdShxJXXndM9gExzDCDzrfIlKPERZhLJbdMmRfEv4CExKcE85BHn1P0IDPFJ6fDpgf+j0WRCVSByQSI3FaiGFWGPbR/pXhGXrGA63hGpqWq2FjPNWhHFKbN37jDlFbCCYgvZyDA5JjHY5jSxWiIR6idLlF67leA/bh7J0gVa3/4HmJVyVGBZrtXlSw11d4TFY4E58ViTCcBTrJ4fGVjir6oH/d2yuKHfVVXyzaojkkoW1kpC56Xx7VgWv8otypz/mRXzEujQScpCNRXEU5gPr1BjSSoTRax/9d4wFqY+csoB3CBDjSIU+GIxyiI1DuoR9uI1EqYDUe5emxYz7Uw1K643Qp4h0qTI39UJfV2kCazhNlxesk3T7i3jtJhXtZ0yra1iUIEZJgXVqV2yViotS9IF0dpHr54L3gm14NIUXOYjsgoRKagimggiPooi7yomtwgRwIJkgaDYaNpGLSnYXBj/yg5DLG30RJlAS0JGNJwRv0icY5TivMpMjlpE2G/6Zo+iRdpkk4pgNo3uRPrhRrBiVRuBdspuMoKWU7ImIiPsmaqKYI8kK2CaIJgpfA8Gab4WNXug0L9iMMrtlfjAIq0llivBQzkNXw0UV+7WAqNqTbsOLz2FVdEuH1VN9JIOE1mAIuDpZsGIIlEJxgusYcGKbclZ+ozZ1i3s8hWdoxKmMExF8DGMABNFIjWSYP5IedZCaBvsE0emYQQmROytNiMKiDkia+SU9PguM4tqaFJqCPxCZpVhttMqUh+pw4bM48SaWs1eOVpBdvuohWrmhVpOA+luVX0o57JeeqLKd/0RX2CU8E/Z4rumXU+eMnJA+6yZFEFml3xtE1XOQ1oP+CbfzBhP1BJaQnohWmR1Zp+C2cSE5YbmzpYp4ffYqA0jzABjymZEJAfoqY+l3mE2gWHBRoGgTCaB0lUXbjaWZoaEKohEbohOYg5A2lbPppWI6mnWooTgahBrKjhzrllMmDPLRLVPLQbs4ec/JmCdKEVhHnixqnprIKmOjeVm3iqlgFXT1fnaWijkWdZmwTQ8ZlkAop7hCpd8YqPkkGXk6DLSohk0YChY1alO4i21lpSCbme3YpDmQa3YGp3Z1pA0yUfy7U3T3jF+jHgIIUSVFOw+jkng5qtmLrtqYmaPYpoIYroYZmG46rt6KIIRZih+ZDQiBViL4rA8VrvJqFb0r/lb02kz+GW6ZqKu9FhXS+zszNFqci36vyk30ZQySWjphwxVVqjH7FVWmC50R+p8RSBjpdJC4yaSnAgUvKQa/KBi9aKWE+WhDcj6j5TBCkbImdn8rO529gIUM1a9Ks34X9wPpMKxhEa85KgrWeK54Kap22WrcOLeX9qVGWVqByo7mCZj9gA7tiAzZk4D5MbQYypdWyaxapC7ymFWYs0FSaqDOJJZCKJaa6aFfKjswJLCtKBRgFYY4Cj6XKCFGapcMuH3/dYcXmW3XhZdkpaS5obJOqjxyswilUQiEIXJVywbC2bBCQbMrOXRW4rLF+6W9c4UnWHwncgJriLBgwDs9C/8ScDq3o3unSjq7P+uxrGi3Qni5MOG3WPsQ11APVzm5TKimGbO0CaUZZlOiv5Zrv5pqXdQXZ7qsSwWiMnhfa9qvabsSuOYNd/JypJqwb3sJT7GC+stN2cmfeDtje8i1IJGku9KUv7KXARRjhagL6huxHLlzLoqzjamnkoixJVhqozWekwQCYWljN3p/4tGnO5mz/nY2b/Wydoqbpwks2ri63si4DC63qhi4Bb0Pq9cOSUoqEmIPs0m49YMPtigMw5O6TCF+k3qNe/K5VAsylViLNqfDSJS/vMcIeLC8rhOJaQS+u9WHspCJgdIXI9Kis3mX3BnFFYh/4hi9fkmcwrP9ClBpx4U7pyAqNygZNypKs+z4u+bAs/YYasYqk5nYxEdjsFHButAZwyWhrAYuuAT+ooCpwA7dxAZ4r5Lkx1DYldjwIKkQCHf1C1O4DPVCt03JwOXiwOJxTmTCMA/buNJkwcy6yjuzrCnvFI5utdQ6v2grsx9Bw8L1tRyzDNl3l7+XwxnDdUMTj9gqxKZuyG1VIkpoDE/NlLgTDNdSCLAdDLZQCRw6U4r6vFFfxLr/vsZKY/AYjhVXY/xYzZpKxnuapaR7wGjswGzMzHE8RAcdxGz/XUpqDZ+BxJCgHKkxOLmBwBhcixHzwdZALOXstINYEIidsjeTYpFJg2f6j8R7/XSS76FxmpQ8CZDeJDQ8iwyhqMiYCGXDmsKtgBTut5ZyNnYGdMkMvtIUk4V6WwhHLMtTOshIj7mAOZsnW7xRbcS+zL8vWL/tyKZdSYcPZLBhjpkoD8IQE3xkr8zJPTxrf5EzXNDS7sWyaa+ousE9a81J2g18yR9QwKSlscx7HbjhnYDcAA1OPSxr6EAm3M78wMgvL1MzVjjx35Qz6YyXX6Fe6Isuhk0hkw+xEINui6OxsCYP+MK02tFujsp+90SpDdBJLNHkWA17jNS1fNMjOAdFUQQrkZwUAcy/3snwS40gzXElPWGIp1kpLgUojM97CdBHGNE+SbgTfNE4zYgI7/zMDMypBYPAvMIcjkAINabM233Ee7/HsCgSC+Z9n4toR/S6ZxfM8ZzXt1PN5PU/ycdNs0ZYltxk3pDNAmyPdgmV6PawUNVFElvJbv3Uqz/VeH/Er57Usn29ggiwOBHaZooCwFraWil/kKiYXQ+5JO/aaQrZKT4IqtLTCUHZls9EzW7Zm4zQEl8WG3jdPk4PlHMQG/9VGOcI264/U5I/iMTVr+wMHV0OHqI1szzYJx7M8swrNPbJui9vA4HNXm+E+K08VvVgTlYRxd4WQqeUqznDEKnR3MvRzX9/1qYMj+O0rzzgt43Us13V2t2cQEFKoZUAFIEAE1N9hgmT4tcH4rf8sFxce0DAcSjv2/97fGwiCeyezTMc3fc93fW/2fmf2li/Guy7ERVYDKcgQZ1FK/mwUgVswJehxgv8bMcjk2gSZNPnuBXpljFY4hRsvnrNgD2oF7YFqV3MiiqeETqAlxmSiVlrT2l7vljS3ird493oEXEdfeM41K9/4jVe0XoevglUpL2LYHBhuG0QuxjUuFK5Go61BG6y6wmFpkp8PFGDBkkdrH9UAeqt3JLH3lFe5lVe2Al/5ZGd56Qq7TX45mJuDLwBWgpT5aXDCJDl7cWhskrY2g3dGj3WenPNrVt+5Pl+1TOG2mVWnn8tzoHe4K/ToM1Ed3G7ME/lFVLBqqw7/+pNU+WRAusXuraRD973XoqUnqTessnVDdCWs3UCNmiVctyGwp0cKB/g1mpHHnWKXz6zP+vg09q1DNh1INpVvbxtho00DO8jTqZZ3OZfzurEjxDUk++FtVvdM0rNLDZOuMlPuQz0s9ZwkhwVaRGfSApGB+553e4df+NLx2LjrC6B79WwJTNdmWzbUhY+s6CbGXJAuN3yvOKWfMjzG4j6dg3jC8jV4A9iHfUXXAl8DK6nVRnqqr8i2+viIX6sndjDPev8Oc83i+vlIUntPyMmYfK+HfN+X/Mi/NOArM9api3N1A1P+wrKXGuOzvJ4EuJorRynELs3TfIV8yLd0JpBQ//i3d37nA33Qt4oKYniL1BxwJ0+gY8kOlqrD/lfXOux2cJKQTX08XQZlV4+jWsZIzFfu6xXmXPpFhj0sBMMGj33hEs3BzQF6BqbaI5z7yh30m7eWngH1iw/dH9T/WoEnZIImgIPezzvH8+3f+z2Wo/GElr9pnTxBnB4lcFzjL37Lo0YkCJzA/eUvvHI4czAumvaYA0SgRJIkNTKY6GDChIwGNWzIyOCliJgkjqIY6iImi65Y4XLmjNUniCNJkgSkhxFGUMzOrWMXrtktmbZ6HdvWDuYwj6wcfgL102KelNlaFkW3jls6pUtxhgPnNF5UqfZcuqt61WpWrVTx8et6b/9rWLFb1akzd+0atmL1vHkz9cdU3FOnKAmyW4eOGDGEKBmq9JeQHMF18A7WqxdMlShRsjRuXOVxlsWKJ09e0/jymSg/iMQA8pmHFB5B9tbJlEmTJmBPqbFm+hr2a6qxZ9emfVup7dvWePf2Ta5365tJhzOVdhz50t/AizNX7nx5cN6sxb3rdr1cPX/7zE3q8x18eD/iwY/34wj9n/Tr0ZMilsvcPvn1rv1StehgwYH7FS50OHGkjFQSECOOOGIJFJFKWhAiPQBRaaWWkNLJwFuaIY6ZnRgSCihR8tBDlAhfOqop53CbqjasUhzLK7BWxGmssco6K5izsGkrEs3W+IP/sB4L2/GvIAmZYzAiBTsMscQYg6wyyyhbksk1GIMjs808Ay20LAk7LRNgiBGOmuNOzO3FF2UzU7cxYxPzuencfNPE6dpckzh0motTzjnZfKo667DTTr5uHCEvPD76uMxQQtczbz1JzoskElR+Scsf+qqhhRT9+MNvU4H+ewjAARvxSaRPSB3lQFxuEaUkQBhs8EFcfjpHwnaS6cWWVFL95puPQvqPVVYdjLBWp0gsEVkyUVSRWbHA+irGZWOcEa1rainGG2z+qEyFz+AgTC9BClmF3EqGNAxdJIPIkrQmK5MsSs2mRDSz0K7EMggwrLCCjNNSA0cZMNU8E01ldTu4/+Ax4dQzTmOVyhPiiOvEk+E5+RSnnIzhyQdQ+X4ZNNGQ+UA05DVGNvk7RstjdBJO1otk0motRQUU/GzG5GZPG/I0VIkmKrWiECsM9tUFhwWKJV4nxFVXC12KRhiLHBRqj1H3cNBppCYeWNqEm31WrBLDhlEraq1NK1tKsmAiBhEwwAAFIEoTl9xaTDG3jXTliOzJ0frGAfDAAX/y3Sc14+Fe0BITw4pMxuBytS9dG7NMgpe1/EyDT1wYYjrtrBj04iSm+OHS+8R4Y+0qnY+UPgSiQ+REUTYUDtpHJjR2ldcjRVIbzalGFVIcIShnngH8OaOKlC9wlo4wKvrVUWSNcP+ZEaGeaZePeHUGE4c+rPqTDz8R5pllljHqWK67FrvZ9rmKtv0Zg8mlxra8qURKFSRAAIETVKiCMH5Zhd3MdS4k8U0xQVAgk+AlOMERTjHwygxlEoc4FlyQcf46xGkiJzDMFcxrCMvcB5XludCdsHQoNKHn+CQPF3KsY4GaxOveUCjwoAyHVIKdDnd4u9wVylOLmMQvqtENG+XCF5lyhM6MhzwnJu8SGwEKQxjkKqOFSFWgyJpTnEEhC0UDjMJoxPe+N8Y45EFo1Tgf+kinvvS5D45kg19WZkRE+NivFnXgQQbehoJwCfBa5DKEkQ4Trwgu8JAKdOADBwfBJtkLS0D/AAML9tK4Q6RGE5kA2ORIGEI0fVKEacIc1964QhWaMoVy6tMLVbedSuXjYwgpmQ9tV0tb3hKXIguEoRzFu5ihxT7EK17xkvdEoQkLeq1KyUqm55E6eTF7yRAGLrxHRjaUoRE/Md851vi5bSSnYbfRGvviKMexmVMs1PoF/dBSjFoYggcV8KNpCoHJVZRikIYwxJEQiEh/JnKRjHTXYgRnQUiyQJKE6RcmTxMwTl5Oc6EskycniiI3XpRhowtn5zj3MF7BoyswbKWlTsEJOCSCh7SkkkptScNartRktcslLx2BilLIrD6oyJTNiEkRhRRTIwpK5oJ+4hGh0YobL8lQ/0dUJU1QOIQN1jRDNstXVaRKJznRoRw5uVpOdKazjmnBFrZWEQQU1MESlvhLWldhCB5loQt545si/fZPfwquBAGla0EPiq/FWaEO9cRkJnshOYeBsqLrS+xiI+q1rY4TlRuVrCkd6idWurJS2GmF697wBpTK9KUpDS0cOjtTQ+1BlzUkLWppCh9z0MccSfzJIjRlkJ46EVQRYZBuIbKSDrHkqsbIIlMT8aGpUU0JcdBIVdeYVd9cyLmdS1ZVSulVdH61bEbMBTCCcS1YeJcLVSjEtdZ6zyH9oTFylQy7cECCujbyrnwNKEF1gAMa9LVbWmIcYcYwWGU8rhXTeEccGf+r2AIfGKMJPmVkG2aTj4J0HiJ9JYSBwQmEqDaHIwPthlVaWpiu9JZpALFmaHcG1gqRd661kS9oxlMXIyQ/PvUPb6vYkGMKjRnm69VSmzaKhsShDFJFyUo+Qj5asUQavMgQL5TMEpto1UTehCxWDotdKzdLfr+Yy/zIdYg5zEETdmOrIPPGo7zljQQcSEHg3MvI+OI1r/O9AQ7mnIIY2PmgONALYLc02EyeRsDMauxiCV1oT3bysVJh8KI3mr1V8oNj/ZA0xyCsD1+4LhFgMK2GP7zaTnN6xBhmLWtJC2LUnoGmNqUUd4A3vOH1B9YkobGsidqhWVVvxyGhxS7MeMb/qP46yBjZNUtoQRQnLxnZx4ZydZl9ZUFXOSpKqwp21nkKLhdikIEdcyH4uZgzt2GfPHDvuEvQZrsuktx6pfMN2O0ZPLPrMHzub2qAkZpWBHjABjb0vvkNUc0Nuqv/XjCjoUO+Fsoj0pOGB3bm0Y1WFHcRIf70hz0s01CXusQmRvWpSSxiVJOYwzVdNX3m14pXp2GXsZ5xgGiMRt/e2BhJMR8rOEGKTAEZyL9WghJiNexjHwPoyf55M6A7uik3G9rWhQqzZtSN+dXby3UILxfAjMkvdyEyg1uDPgla7hSYe3B7LSgJvB7n0UDSzu/OMxfYDlhDXJLe9L53N6rTb7u7/+juAPd3wB2rYAYrAxkBK0uEJ50PfbxQYw4PhGc9/vGLTxzyfHA8qiW/h45rhuOXx3jFDRWpkdOHxSDjVBNVvnKjjmpUISrfS2r+cDuEwQuwN8M1y6CEPRR119hjMk12r5OhG5uNR5dybJae9KMXX9oPxk43vDQXQbCdNG2YQz6zXeY5SFAORAoo2MO+/RtwP0vvTvu4/db2OZChv5eEumq6VI265x3+CD603S3qdzfOA/CCD2nhGd5w/5Ni8WyH8kCt0ypu8krtADur8SxP4zSvAREQAjtPUkbqd3Rq9Eov1kAlagxiD0il2NRhGTzB5gIhDHKu9q7gBLPJ1nqsef9aEFeCruiia7K2hgaN7/g8SNosS7uCYS60T5G+DQilDwjrRd0USezKrs7SzaDS7krYi8/q4HEGCxHU6s/qjk/uDmzep6KyUP72Tu/0TZQSre+UA/8qC8I4Rh+KqP8aDpYkwQ4kb/McEALnEAIT0AEv7wEb7wu+oA45zw9SLD7k4yzsY6duiz90i0M28GqWqdjMxxMszA5yDvZyYOfKwAwGIUSiyFROpWl27/di0OiGrwYdxgaRb3JORwevAxvmRxO4TTLIToEcQ660rg3+QBGu7hWLUK9I4OsCx6AsiAkjCXEgQ+rOb/owCRHqrd4a6v2wEO/ib/6gEQwVDdHG0HT/8s//Iq0ciOE6KO3wvvE+FDACCZAOGw8B9ZC08lAP02APFbAd2fEcy5Hy0KN3tIMeuCOnCpGYmOhDtEhqemsllmEXaI4TXi/2vCAOKFEhg0wgOFFoZOITgc+5RHEUK5IUkc4UUXHhNMadeNAHLyjOXIDqoI8WFcHMJEMXva+9kpD8gPH71C5fCINf6gD9kBHquKSy1ocLt/AZV6Qnn4L+pnGOulAox1Ac8g910FAektLwmlJjMkG1DHDx5PAdqdIq1/EdszIrq0AcIy/iHME96oce7nFmXi0hRu97/HGMVHAloma2cM4LFPIEZIASUXAQUu8hIdLJgkt0vqkvZ9Ai/+tke6qrNaqj+AYMMTdSLRazraxADBSp7FxAoRwjcITQELBu7MyOzTYzztaMF8Vt3MZP7UZjX76sRxxn3lQjk2ouJ3lSC7mCH17zJ11zNhPrCoty374QN6nR0bCRDcshKb9ROBsOGDIh0you8+KxHdPxDjEPK02MDeSlHbdAK7eyHGeqpkzhGrxhH8ZyHyxlpw5xEKIKE2ihZsBHi8zzJwqyCeKyCShRBkaALlEw2JgKeyLyL0ORIv8yME0xIxNzlVRxMe3GFddlXVhgXUQS64SQNEbyMjKTM9msBGJAQkETcUTT3ciNBESyGMlAoSgBNTBpDAohwFqzNsAmNmejRf9W1B5YtDZlMyh380WlcTefghWS4Sj1jw2ZUh+c0v+qocKkUjmfkw/Z0UidE0mP1Dmrk0mbFB5xaTxMJjvjYyzv0RxoJuXsIBLRyDzxcgUj8QrkMj7lMwdKkA0SgamMAT8lctn0U7L60z+XDkURbzEH1G6IxAWMcF1KQEH7FK6mLk8jtBfJzoL4akJXMkO/bvwsFK5oshDOrxDQr542yN7azzBTtEVPVEVX1Cs61VPvAVNnVP5ClRpv0yejRRpnU1SjIhV2oToC5ksyZhqmIWP6oUd9FGOA9NJoSBzX8RyTtAGtM0mpcw+LFQuM1UmZVPN+iB7hgx7GYRy4wxHCQEv/SZANRLB7puhqNKIRgIwKKHEuQUBcZ0AISjAQ0lRN15RN95M/4dRdo00jXehZsnEx/cGdYqGtvixP9zUk85RvuqDrKrQEREAEFFVDyy2vvm8leVH8DBZBgyCA0g/usK1fJhXQdvQpUpRUW/RTO9ZTW2QnNfVUU3UoNTVUN3ZkYbQ28a4jHKqy1KgbblXhvpH5voQYZqgrp/JXg5XEFuMOjxUPlRRoiTVZnRRJBfCHUAEbnpUesKF1ECKqOOE8KSIPLJFqThA+xVVry/RM0XQghyHZakIi91IivclN+e4GKTIHAVRef7MfFjMW3KkYEAERHnUOHJML9jVP40pBHwPd/9oLYZEQ/AQXQ80NQd1uYv0sE+opRLsEY0wVHE52Tj12ODsVKEs2cl1EY1H2clNWZT+330IWdKPiHloWYGBVHLykVmf28AxTGVSBGFQBErvy44CVOYMWd4EVWXeXd4tWSf2Q03jpFLABWvehFFxnqnate04iuVxFD6gAenNgTMX1AkBgPqMKTQ3EFW4MVVzQycAWP2PQIp+NOLRmVt9obdnWOlyoGIBBLbiTHrwhbh9BETwUsPYFf+OKb/U3CwJ1FwH3M/kKz7yucGGxkiYVGadQRP1sNSIsY2HzNSn3Yyu3RR74J0XXVMEicjdYUzsXg+eogkdXhHuSZT0hmmC1Nf+y8VaFM0dfVxnujbOm0h159ndzV3dNbGh7V4eN1nY5jAAn4RrGEhtQIRDi4FxrRg/gkiGgN3qnd1wp0de8VIq6twVd0BMzJCJ9T4t/jxuKDEOIok7OJ/nSF2yuIxXd933HMhbiFhHGgAzIwAbIYF/kOH8VlG/hDI9BM840EwkL+HAJYVKnUIHZKu4wyUuAYUc1FoI5mGMlmIJdlHNVdFNvM4QtWIOnZXQ3FmXxjpMlN2RdRNekCYW5McIeOXLy7zRmd4Zr+Gir8oZpeIeJVjRkOYeVlSrp0BF+QRBniHiuCXppz1uZmIktcfbuEmecp6mgCQaDjsmEjuh+7gW3t0D/NFEUrJj3wNfJtknHcK1XAq0s1lZev/k6asSd6EEbdGGNYwES2hiOe8AG3rkF4vmdNWAFVqALbMB/92qPA5eP+7iA/2cvEJiQi2Eu0qre0ko1lDEb3QFkQbWSYXMeJviRWfg2L1eTUSdTX9OiM9gqIlmRMxqiM1mSIfiTweIRW3aUVXg4TzdgMqEXUtmkaBeWl9SWaxcei3aWc5qWa5mHrRLjSoE7c0ESbu6Xq8l7AHKo05R8RPmZmzqLn/p7Z4JVfuy4isYD7VO4dm2pt3lWu9qr2UENq4GcY+FZz/kV1BkP1EAN3Nmd6XkF5Nmt37qeI3Sf+ZmfC3cCRLNB304K/y1hkA0aGJIxkyjhFBC5lDt2Xj+1oyeYdR+Zo+EHkh+YUxu6Jz+akVEUpEcagjd3pB26k036pPMPhQ97oQEmwO7tpF3mwla5p1nZprGSp3c6lnf4leVQaa/UwgLBmJMamb92q5nrt73YqZd5uMl2bId7Fp5nJE5iapLYanGualhOI5wnPbVamgKPfIhBlO2ou7BFG7RhHNAZEiAhrcfAnVdAA9JbA+LZreXZBQJXT4Ogru3aYNMur/M6rwIa7gh5CgnafQm6oKOOEgxbpSdXsbXiY23VVie6olmEsi3XUzMXsQ2zGUl6TjGbszPbcjOaCzG8dHXFhEVbciaYNQAPGf92IRNSW5VZu0hr+nZnOrZlW6dn27Vt+KbhgBN84RdszuaW2heYWubCCBqEXLiLvLih2qn9Usm/OMcoZBNForlxTsp9rYyOOiUOkSBtTlKuJRbk9xV0Acx1YRMgQa3hOJ7RG67XG571VpHYPHDfO3AnoAQ0gOxSIK/tfFAJA+4Q4REKmrxscgqhzjTeIzgd+cELXGYnOjYj+pI5etElOHIZncRB2LNDmlQXPVMP3bMbGrE9AcSZ+ksaOMJZuhV6wdNP/dQXgcWXE1lhvLZne8Zj/VhlPIdtvEhLK4l6XMe9mrmY3Mh/HcmNW9g/AvjCuHyOzMmkWlSMumqp2rh+7FP/7nIR/IB+7McbzDrMx7y8z1uebSCuz3xvRTLc9Zbc0fuu6bzc8Js0sG2/UyMZayHQ59bdBR0vKuGQI5q0JXrUkxJjGFvRH1osDB3fHTnfDu5UMV3TEZ5TM93QPRvEQzxMqGE1LnUeStzEUd3T9yOGWbm1WZ2mhRbWaT3kY5xJUYwUhMEXflzIafDXrSrJQXHY27Vsff24Z36pv5Ygp5iKWaFCCJIgUgxb5BfbwRxaxVuti4DbW4CeW+CtW6ALxL2e+/Tpx/3pp37O0X2+4Uqg6Rah6VaBh7f5nK8OwEAQYPc9EJ3BI52D38Hf9X3fN3rACF7gGd3RKXfTDdzuF37T/z/24T3hOASvhVgalQfy1O/ADvajs6IT5Dseh0ee5B3/8Y+U5KMK5X7eZlcejFje5YHd2GIeOWB+yTdf9G0ejHsd80V/lGPXFwq7u9pCG9ZYFmI/zHUhvMV7vNO6nd076u/Znsmgnt1g6qu+nuU46tG7+BX0/N643fn73Q86wDNJ6j6jBnIACALBF2LWRxk8NgO/3yU60iG9oiP6+91e/Aeegq1Qshnaw/fe+x997vke1Ue5xE+cF1p1IEu98D1BS8GgWgEijcCBXwgWPHgGocKEDBsKxKIQ4hSJUihWvLglo8WNETl2FMjmzSJJnFr5mhYtJbeV21i6bEkOpkxr0v+a1bRJE6fObDxn+vzZMyg0oUSfGVWJdGhSZdSUojwJ7Fotb95iWX0lS5fWrVrHbX21CRIeRGOK9ChShAwZN256uDHCdu0KIyvqGunh1kiXui74urBiRS2ZQoQPGbaEGBGixIoX16qlKbImQ0FYqDiBAcMJKZmqzdPXL3S+0fr4mT79+Z47cO9ai2MNDvVn1qZjz7sn215t1fNii5NdOnjq4cKLr+YXL7k75MtP40b9HLj06dT5pfKE3ZMwcUxfK9t1Pfv1Xch6eUp0flCg9Xbah2lv8KN8h/Tla7yPH6P+/Ac92s/IRkiJLEKKMMSgtNRLQMF0k1I7PViUgy05EyH/hUdJWOGFGDrIlFNPERNVMVRpg1VWJp7I1YlYQYIIHmoc4qIaMhoBVw8t4IWjW2y15RcZXay1I2FsKUIYYkYaqdgqStai5CORUYZZZghoRgcwn5GGZXWubSmOOu8M91qY4DRFzZe5qeYacFkWx8+apEGHG5q1ScfbnMBFV910rISn3YFMEdOKeOORB1567ann3ntgxNdfo4wWBMdCjzY6EX/7Xerffxal8V5Ie6DHioFOjapghQxayBOE5+S0zU4Lmorqhq9i2OGfIFYTDDZU0UOiLFehCOyKkIhF1hjGGmuWDS2scGOOZOgIV1s2rKDjjm4o4oZa1xKpiCWLeevt/7dKnvLIuJMF4QAECag7ZRi+lAMvaG8SRy+XYZqJb5i10nbma/JcGVw/8grMZsFs1imnnXg6l2fDsu0pHlOZmFQodr0cU5551w1yR8eHBujepJhmqimllo5McsocdcrpeiSJmtSsMjfIKlEQxnoqzhPqzHOCHO4LTIi70kOPr8Ga2InRsYg11ovHPqtsC8tSi6yxPZCRlg1u4RXttYtxWxiRjWmSpCWQQfYIIsUoaWQhQWDArgEGQJADJ8BgE/C88jS3Nz5+x3lvNf7etvc3Y3aITHf9Do6aaI4bDHm/0wG+sMMNcwIxdkz1ksl3vPDSCqHJJKPxJRx73DHIIb8hsv/JKpd88uuyuw6Soi7DHHOpq+q+s803y9o7UL8DT/zPt+aqa9ElXvWricM+/0jTxqqFV7M54iVjsmbdZUON1ioW5JBedxuuZIg5CZm5i7ldQdxzYwCGKvG6+S/l9d8fuL2wjVle4n4XXLnROI5gbNJbnqKzsMpNznLB2RMrMIceYeyic57DWP8qhglEuSdAYVDUouwAhjAsSoSxQxnsSmhCFM6uICFJg3rQ0woEhYNMr0IH74pXs5q0CmfD42Gsfpc4mkHoVnfzBtHoMQ7lLe0Rj/gV9PCQtmNZzVlaQwteikAjNdCoB3fBIl7IEC3pWeta2+LWYhqzGCdZ4hFrYxL/2wgTBATIUW4NgMAIEqEKK3VjfsTZY98K16X8CdJLrYmGBBP3G8sN8HGQ+2MCEcYwBkoyOIEixZ4YoR3RfeeCFTOU6jrIMjuQ8CEjpJ0pT6jCFKZShZwSiMv2FZOZ3VCHsPKhLXGIQwsKsUHHExEST2QVJgoTetFrkYzG8CxjFUKKx6KREcyivWRxrWsyKpa1CjOksZVNXMCohbgQQxguuO99QCjJgUoRtC51g5D3egruDHcvLv2vkKQLYiLp1TgBhsYfi8wHPIRTv3g+8kz/m6TDLDmxiYXOJJnQ3CYxJp5EnI6DoBzIGyrawUWhcqOrRNkTPqqRKKwwPx1sDwxh/ymzWNJwlyzdIS4j5NIe3kyXQgRRropRtKLpQomPUMMwl9iJTjxRMXgoqlFlhAY0ePF6OdIa9thyTLZcLVtAMuNhDnNGxpgPnIVoQwTmJkd1XWAzggidQg+5uQ7RwoF7ooUEp+GZfP1znvjwkiHRek/I6ZOfjDQHwOaprzLhaaCRNCh1SNHQVlhJH8Awq8UWegwIcgITEqWoZRMVBiCA9JSq5GhnP1sp0ALoDeopCUpVuiDUvvSWwZtZSxvUP5bq5EDmSN4vvVKiYaVtmJAIqoqWuMSxuOiZ0rQeU4FkTanaYC1qwRaRXkQ+w4ztqpL5Wle7kC46glUzYKDDZCeLHv8+XQI732UFQkPVnS/5ca50VU1TCEWevNJrr3ylH5xWyq/C0tWwDVOoZ/bBT0BBsKHkLTB2EGUGUCpYwZrVLGc9O1LRkuwIDGGCpbQw2vUUKBkyTKlqXyvLWrIWiEF86INOco19EA0ruP3KEnn7vE0A8xXQW0xZcGRcpmqNDI2JC7UEM8boWnXIVz0MYebQBbhpN6yZyQEVnhyHMkg5ylQurebWili3Ggiu8CAke+dKT/C0NRryzRt9seRXvwKUnhaCDZ34G7nioBMbAK4zNoghiMkSWLKS/RiVvWAGKucgB0AY9A42K+EHJ3rR+knIydgAINtJokAd/rBqLR3i1bb/9rWbC+JrdbIdOh9Rp+Mo9U6FxTzoPTFGx4Ta9dBSoxtRS2tuiCJVffQjtcxBEYPhFnSLDOwiHxm7cyy2HDVjaCdTQQZOVjYVOgbDtkJszAjicpe/7B1csHU7+JqvPte037p6567x7ZIC4dywa2CDaHUGMDYqASrM8Rm8h4ryFQDdQSrkwAvJFgKiFc1oCVs4whRWme0CMelK/2SGl1ZKph8O8dgGceIn/oU5VPyKopnaxSxCBCSaJ4thga/Vry7CsaL6rLr4CLnYWnmu1zIHthjiuYf4tWHCJuzCFIIMSF7XAIx97M0EAnX2fnaVEcWIRlBW6UvHBChwATMuq9eu/3d9oNPRW+Yskaa2flNze1ezEoxdjCnnRnd1cqViANPDzpmQwh3iTd6GsidA917woTMKqUgBvKMBh0KEEY3hgWOqlSblxEnwu3BMvxTiEYdtPYdCcZv4Ihe21YVXTI3bpZHF41b5yrDEyExjHRPlgFnujxRh3Taovgurn8MceO6G1w9m9oUZjDJrbxjBuL7nPxcA0DVjh4mxNYOXKP7SNZiH0yE/D0x/+palzs73soKybUWJ4NZbL3x4Pdxgr4km8/u3cJv9NJRvd9rrzIlBhwE9mJuYoTgFaPiwJxF0oL/enQADIvy773znv0cFD1KBR3gapnCpRROK52GzpCGZtv9JP3MzJ7ErpSaBEogVsWBjbPFxz5NbTFNNY0EWx1RzyPQsVuB6rFdGhkAIrad6PPd6XbV7zTV7c2AIPDdzO3dkurZ7vDdHvRd0bzAJluRW2sZWDuR0oVB8jPBCynd0mBQqbqUS6gBX7DANEuQJlzAg7WcS6rROW4h9X/Z160AmupRexIFA4xccFmd+akc02NB26ucJCdVQkrAIohQSfNAHkpBnckgHrEMEQzADIQCI+bd3g+h/f1dhlmJRCPd8qcVwtZKAChhxjvheJjY6lfhDBnINu2J5E3h5RcMibNEiYqGBJSIsunWBgoFrK7d7KNgGrKh6cqB6f/AHrseKMsj/ioKxc7L3ervIgjloBS5AAkAHVnI0Aj5IMfUUKrcwhE83Cs04Hs4ICo2wB1MmZcmXdOPxVmTSFJfEhKblJ9CnheuEG2CGJmB3OBKXXpBkP2XnMKgADP7QbqO2hpnwBjuwb3eIOXnWBxfVQqxDEPY4AgEJAgPZZPtXiAfpHwG4EQCIH/3oQoEQKuM2E4iHgA13QxeZaRSHVpbIIVGhiVvBiV6heY0xTEy0NC8WVXhhBThmA4BRgqrniyn4irJIkzWJgreIijyHg734kq7nAhOwgzxIRxeQBj94SMOAlFAnhMs4feExZrggCsQ3UXqgHt3YhGqVHldoWs8nhYIThVHI/w7ytBrKIX0XY0+JpI5+oxtwFgmnUA/xqGJHBGDAIAgXdXcf5Y/412+DdgIyAIgXAJgUAJh1pH8Q9ncIGXD9mAi0UICP2Ii8Y0MVCYkOeEhatpEc6QxbpitUkSK4lXmm6HElaVQfKC1OZZo3AhipOZOx+Ady4Ad+wJo2aZO1WIs5+IK7l5pBwAFBWQDGFgFbsGFBCF/DeTFLKZWDcHXSZnVICAhLmAjjZRLfQW/QZl7PV23XGZbZqT/nyElKARvraHaI9Y7wGJdxKZfmYAp9EAU0wJ4vQAMfYALwKQLyiQLz+ZeZEQHqUkcNQAAXUJiE6DqICREMSaAJaZAScTsKR/+RkBmZqJUOGMmAjihBlWRe52Ugb+UnNkUVVUGKHbqBpshEumWKcbFc2iKCSEaCKLqas9gGr9maLuqiKSijhBAJNEmjN2qbrseCrMej6MKbQkk3hleJSZmUymgMREoeDsQxRUeVyTmh02c6qYM6cCeHH3OFG2YrJ/GN1geG67CdnuMKrmBB6XgcgyV+WjJZkXBx5Ek02sArREMV2PAHZ9CeISAB+VlHEsABe8qnfHqn+ik3BEAADRACOhBah9p/COloDLmoh4mgIkFpPuOgpTKpDQqhEZqlrUAKJMGp7acKvgCqoTp5ucKhJbIJp4qqQaVqP6UitpYtx7JzO/qSLPr/oq/pmjAqizFaozXqCLzKq4QgCME6B7Cpgq3HBSqQXb7Xm8vam2MlCb4wpETKDLcgrdEKMcxJjcyHCZYZhNfKnKijfHZAZXFgB+x3lZf5VpX4hPD0XhqTCmMHDd8plvYTSWn5Xb/wlmr4pnDqDftgCo5mAnjKn+9TAX3aAQWrn3U0lHNjAiKFqI4qoBphYY3qqK40aYeXO5WqsQxnqZcqM7VyIMKACojVqZ0anaJ6CqcwFRzaW0LVsmiwCWjANJCwRiUJciMpI7qXg7QKo7B4q7jqor06CZHgq47wB7v6q8I6qzyqejjQPnIjlMxKN4sArUfKDFc7raGCtVY7pEeZ/znGBwph21bCWZyVGB6VxUHUWI3UaV7yppzaRh5tViZh6K5iepZjibdbkpYE5QhyyAmloG76OmpUYQovGgUbMLADuy75GQHpIrDCWEchELGTW6AD6neX21kPaVqNybEb27Gfu6AfWysTqqmbWrImG5159Auk2jypmlSQgAZQBEWgabNGM3I6y7SwSJNr4LO9C7RCC6yTALxEW7TBKgi6a6yrlwUo8FXKypt0JAN9cIxbm7VcG62ahL3TulbQ6K2eYAvRuUkTSllTyaTM95xFSF5ju5HrKn3iMXbyGk/yGn7giQ9+6weTcDeCa0T7QBXBYAqVEAlrwAMSEKjMKrUQ0P8AB3AAcZOnmdGwABqgfeewDlu5FFvBJMM6MMS5ntu5lOrBobtSSEG6pNC3p2uymaAKpXAKq8uZSJOqqCqKzwMLJelxm5c22HJrMdmzLsq7P3u/Rhu8QyvEQ0y0wJurPVusx7qbP1psc5MDVHtIoKZL1dqd13ukSTp8URplHTNeV7kMoVpJkkBZdLe2L4S+RoqUeLU/ZVmF24pIc8twgwSecuK37WdxRjS4G3oNuWAKKHi4CCyoULtkCkzIDbwBhepvlIu5D8vIi+wRmDuxdGrBqkRanxKpGUtDL9HBD9oOnLzJHms8I0yynDoSfWDKfovCK0yq3qANvYI0J6JqkDD/wzR8Lbamo7JHGCkoBz28y6b8u0FrtEJrtMRLxMWLxG3ABTy6vE+rrM3czFNbtRBCvdOcOMZgIdk7nGyFhExKrkp3lQdyjJvKCGRMrlWZnGgcW3AMG9LAC6kAtiWWydo4r5SzHJ06IH1QVjdVDMUgFcHAx4rQmlFwA7sZyAX8zIWMwAUrAiiAl2+gdxGsyAspUgVHoJPsyCrjKRq2iB/8yaDLwRGKZSRrtHq4CL5cyhOjsivbylwhYy5Wir11krEAC7M801/DgjoHrD7bwzvdBz6sq8JbxMVMvEF8xMSKzF2QBU3LvONkwHRUNyYxU9SMjtZbrV6rjLYwHkfYnFRp/40ahjncKgymO5WAkHTF94xo/Dk2cTjkkDFt/K4YI6lcmrflWM+kPCAgdAZrwAe825o7vQbr+QEEXNACMNjLmtB3Cp814AT+6NB+wAeTwgMRTcGR7GiTDcmSLMmQfNEk5UqKKNcd/cmdLNqgHcIIqBThC4SOYLolbL94yAlDa3Ei0sotliIuTUyz/CtWMcNgQxgAnNO8a8rAHdx8DcyyOMRAfNzDW9S2+oqsxwUDDMjP+8xPjZlSLNUSR9Xae8XESZxsJcZNh75A6LUZtNXlXNbvfB12K6HD4NZhCs8Jwq5566XuYM+VxQR9+AKBKJ+R/QMwENiJW9hQe9iHbALu+f8EpEVafICHm9pKpCSgE7zZEy3hEX65hkrhj6aYkSqFmhzHo+3hH87hmLo5pZtlJBzMrl3CQE0JlGdEs71xuoCqKKJqNh2abGTj0VUJOf7bdCDcwe3LxZ3cQQ7UxrvcfrDTzl0FItC8Bh21TvyswpAqOXHdUz7F1mvVw4muwvm1ZwxZyqjFZYycYGsx8aWN5nHerNALEkoqHR7f1PfdeSkEOXCfgkngHLDkAc5kiB2Iit0pLuOpqJAILZSoJmTBlW3RImXhm125is4fnkIgvgCF7NrBks7mIA7aq4XaDyTkwTzkKy7bLs7SQZU0KSJyY1RGZmQKqa7jwDrcP26rrs7/6cFatJserMH8mj29yz2czCnAzAlMyE09N9EL5VFd5ZFH7N3J3RpZmVfOvWTb1l/eMVRJ1tnRxbwwuu2MhOMFrxyZFJS+EuDFqYnAh3z5l3UkmPuZuAnNuIh9sPQpBE3Q5zB0sr5ACvw46JhScJYN4YzO7/2OQn1uyVHI4ZbepQQPEyC8aWo1Qee16UMu66sg25i3FWHBqkozLDi8IzDXBrbH279thyb98UArCPgcvMjt8Cdv6zzMu0idBVngtNEtyM48lCfwrJB37DZh7Ddvxdi77Nl81W9btj6v1eNKdNP+OVhpOkyYvZJIKs5AfQNy15wS54A4Ah5w7uiO7gqd/wEGm9hDAO/xbq7pKmB0CNEPfrkMke+a7e/+LoAZ/ayBVakFb/CXbto10Wmlm6aq/YOIFQkINcQrzsraQIETL7MyG8tM5GsZ34szhxi+3aJ2qNeu/uPCG+uVP+TCjPKv7tdcUAUxwNQyr6x19MRQLRRULlsydc3IbtWZw73FmYxv+/o/X4V6QPRHp+3FmfSYNCiaZEtHeh3fPVmk1UF8WfX6KZgEqxl9yAP26J6BuG/w7vbbFitUWFFl38iUPeGLjOj7XnAUrdmJ/v2LbrmBd3AaPvCVTvfSUPc1NXHgwfB6HwmoAP9Cm8K54spacaowHrOxW5IA4cYNIjeKFBUUSP/G0J82bQwpqmVqoZ81FenwwdjHz0aOHR1N8igI5EeSH0WS1JjSD8Y1bSpy4fGggAGaB2bexHmzQYhAvoQ5A9qMmTShRY1mO5pU6VJjTZ3i6nWL1ahQVTF9wmp1VlSuXW25AuvpalVWyYTRmoqJ0SC2cdzGAQSI0dVUdRPNxZuqKzKzfJVF67vrliS7ahO9scMmTJMhNEKAuBAZxAjKL5w8+QIGDpjFRDznYKyYzR7SiwiDujXM7DPAgL/RGqQ4zRYptW1PwZ1bNxMsvaNE4f1bOBTixYHfMB58uI7kxYPzZt6cNnTn033TLg2K9bRw7bp/9x5ePPjx28idR58emnn/a0TX/3X/9yxaVqRIfUQViRSo/KQi/UdFlVKC8cabWF6RRZZNFlwQDR/QQAOPRyZ8RA2EBBKoITcUaggiUxRhyCIRQ1LJkZD+KKmkk1TkSCUR16gigwhyqkkAm2wcAMed+GiFmKCYAjLIoYY8pki+VBMsSaqswuqSrEbZKkkkuQoLrLX0wHKusn5CJq1LrrwDSzGdNIytQcis76uoAlNSkqvcNMyONzqbgbIRTgAtDMzegEMlODb7QjbZSNujEUNBQW0XoLh5LxpquGMlMT1vk26355Q74rdLhUPOuOE+3bRSUavrLdTZSqNlmW/IY7XV8tSDlb324oPPvSPR2o8///z8+88+VEgJ0JRcijkwFkgYZNBBHx6UEBJjHyGIjC6mbahag1aBRaI/XsyIo5FOAjckE8cdlyNOWuyj23RfyqKECmikCUd5dZqBR9aEJBLfvvI98lYpv2qSTDRTg8pIg9UM6xJAqGAYCSXKaCRNgtv8Mq4ws4wNELjOHAsTsCaGqi5EMYHzLsQWyyGHEEDjcxGVJOFEkj5kNg0xxALB2VAtEcUFqR8ZfTRoUmazblRKr1MuVOA+ZTqKTEkN1eiiqSs6jdEKleQn7lzlOh2v0wNnvVhltZVW+eZrxT5g/VPbvwDfFpZYSObeBEK7l8UbwrllmZsgN7r4uw03GFIE2/9VQuRWpXDLLZfExkkssQ92o0hhAwRqxDzHeWfasceyDdb3PX33CnkWUQIWWJQokeQ3KpFf1xiJyWSQIY5APGYFZCXtwstiLN/CeGeJdxml5DglvSJlOxJxBOZMMok5eulJdvOujt9EFKlzljln++1XdXQaYhyp+mipR43iD0VgbPqM86N+v/zerr59O6C7xn9sssvmH6j5fuUPKPRjH/1E4lfAKkXcijE3SECobniD4LIihIdmVShDHSpcREwRIvdZpCOEAIkgHDdCdDWPD4xL10rWtQYpqOBd8KrJjQYAgHmFAA6eC10OVUMkXvRQTQhjUupUlxp+GWUYrgNiKhr/kYc4MCwPZ0pTlVwhJX8lDExNBF5cQgGy05QMZ8gbDSegB7Pp5W561Itex6CkNe8xih3cAB/4qkEMScgPafH71BpMoQ1TrOEGnQKVp4wGP8wU0pCHhM6p6re1dTTSkfmjhqz0tz+zmQ1tqPiIfzLpiP7ALRi1WODc7KasCPrACGiw0EAm5LfAXSsi26rIGUZUrkl8i3GPI6FH1JUulrgQApu7nABoaBMZErNz9+pfDn+0r4kxA2FR2koQyTTEHRYRdKSL4pJ0B7CBcUUZ/kqNlXznxCzV5Seng1P1cKaYOzDveWXkxOs8IU96QilrbXwjOtixzzg+qhrd+EUf7IhH/1L1Zo/a+AMgmRYdHUQHag79ASERacfZ3M4XjEQHHDUKSfBQUnsf/RytLtmfSGQyQPrx5CcfQcEG3q2URoCphYzgBgkhQhEKcaW2YnmGjJyQJCBcHC5LmMI/pOSERW3Ri6KAgWBmDkfDLCYx69UKLulwdF6JZlZPh7qsEJFIPjNiv8CpKLQ9ZXd6kSJae+GXb+6uYr/bGPYaQcZFGCo2bEjEPHeRNjP29WPZLN1UEDYURp1DHW/M5yNX9c9rRIJo5oPs+YQDi3/Agn2cSo5DoaDZh070jqLSgiIDURbxMVKxr2rVJJO5Hrb6jz73ySQBA4TAlE6IgqOEEN5guiw8WP/IBhgSyLUMh7jEsSioG9kl5E541OUyV3LAsZyNNqc5mwwTqlK9ITLDatWwPnOIWDFdeAOmlSIuky+2EmtguJSk+RgJm4Kly8fG6iW4wgV3I1PnE0Fhn1S99r0F22t7AbwoR/LTwI8kBjHSVsfLDNSzxXlaHg2ijX8oAgcXXk4g3cdZhhJ0U1bbAv0WQdrTho2jql1ta826H9jWspa+4CQngyWsVSDCxoh4RIRynFsIqcEHaohQKmcaXMNpa1sdZIm3PtKrxW1kDUleQ1KXW0KkPnmnH2hAvKQ73erKMAAEIEDnuANW7lrTh0/aaldNh2ZqfhWkV10vFc2KTcPIBXf/Y3XKyGIDMezp+Yv7nU+gAyxg9lZ1X/Zbh2H3edhFL0MwMTvMpLRAtcgasmlHUI4p/qENTltYoYFMZGcp/eAHTxoLo0nD7farKoyeGMVLCWmA69NiF8Ptbb5IoCl0fS2D4NhCFqLgrwXSWzesYAUFgUWydT0RJHdLRSFs8pP5EGUVGpUl0pY2Ra4NhxtEd8vTBTcxA3BM0ZW5dbfgarrVnagieZS1cDZrvOUsGCtNM3f/yh1YR4Zf47FlrlQVho/ONnAVrwaZ90qsog/7DGMgai1vMYMXFmNqUk/008M5gqb/sWmdgnqzxdmwqEddaaiB+GraaXX+TCzJSLp7VrEu/1h9QJEiBC7DF78oxc11vXNFVKJwBwEuhmZqhB4EHXCIUPYGSyqintLSxdAul7V3KfVsT9vqVeABB7KsZXAL87rFJLcygSSVJambzWwu2JBcDm/WyRvPIBss2Zc0Mly5jN9uYssesqa1gfe9UeErLfe4c+BvOAO/pMFSGZw4cYpX/Ak8sHRwjoDp4fxBG+PY+Ka9AYs/XLo6EGVCh0fu+DsmIQyK0XuqVJVYV786xVWErcuaByxHCOsXuZjjzkvBEPWpbw5kAL4bejBkMgzf+EQngyIekfSJwIgP7sPIs5kcrhI9eSVVZ/q0RXQGrAOhAlv/dtfFPUNjHsCGOOQumf8TZhW8fKn9ZhcFatwsFHeXN71ub/vB3LuXLlVJ7mXnmEaIv0MBBbvCGpu7KC65l4ALvAZ0QFabD1ZYIiYCnjJwC4nDQMYbPTziPt7QuMz7h3HgvIUiFdEzQdJzPC24mhGbhoVrvZZbu2Qaq1zhpZmZhB7JhRzUuQ3KBZPgPd5riGmxgSE0vh4YwhWYg8JJukooKW37k4pYBIa4JR8MIaO6vp6iA255wioQAy7kARR4IacSvy4DOwp4gT7widfDF/Fyv/azGPeDP1tYq/l7uTocHWcyMx/CKj3kQ4D5mLlTmCYShbkyDbubQNJAOZsTPPtxQH4aPPFhE7W4A9GAOAv/tERLzMBJa7ypuRRC0pQ2oDAQ3DhtUAQX+A1AcqjjEDkURME0wIiLSjlwiAdx6CjXez2A64q+mplA0IgbvLmL+ifcg7ENoiWXeAkXQMYVIEIiTD7DyRZTYEIU2Sln80FMcgRCUK6L0MZtfJGdCoIv/L6mCr9wG7eoihcIOMM03K41lAquAhMt+oS5SLfwkkM6XC01zL98PKI+/CF+/Iq0iiZMYCIkOBTTwC8DnCtFXERGHDxGW7gILEAzYYNKjDhMrEjRyEQNZEXKaxpFCEVRJMV2ubBP6xSq4TBWdDxXzCthWJXxmMXUYrn6g7ndMSN1SoQ+cLEc1Mlc0DUYa5zJ/6mCZDQ2ZbSBLiADNzCFZNMgRWhCOXhC6DsqFLnGAEEqdJGDGtTCLowlL9yscBTDcQTL8tMJIcgadbQ/ppC7JlmLK2HLN+Sq1bFHO5TLO7ymPvyruDuz1/mrUbgSKuiiAty3CZwrR1DI7WC1FnRIR0sLA6RASmQiSrxIjIwDjdxERELFSgEkHPBIURzFhMKwj8ss6jhJlCw1+iEFWOQaGFRN9Ci3mZyvmuyDnJmZHnGEXFiGHDSFYPkIlpg2rrywEliBEggCZKQWiFBKXfvBacy2KaxKKdPGp9yMKviUGIABE/i+X/pKcRxHL/syY0JHNGwNfFymtESdtYTDs8sqXv+IS5dTj7Fzirr8x/jcS3qUT4A8nYcbwEVAJz/DmkQsTAhUxMVsy8e8wAKFzMhkvIxsgieozE6Umt9wAUTgzI0zBRz4owxbxQ0kTUM6uR7pp5cEG7EZm1r5HLLCN11UJxtEhdu8zRy8BmJEkauLzpHkARKwURt1AS7ggkKwBFAKBp4shZKSRujsFqm8RiN1MiKNzg78OOqsgRDoAAmAAOwUADADM3gZw3BrADNEQ0OLy+5as3VLhXnsw/Wcy6+pP33kIayaz7vUKvtcErzQT0SxuwI0FIP0z4VkuMPLO8R7zAMFVBWMuNO7SE001AazuBMsyU/BARegLM5EqM/ELND/ZKiS3FDSS7VEOM0PdbXWPK+3u7e+ois+kIRawiTbs80etEaMkCXuW44UgNUUmABYzQI54NFa+FFdw6QhVdKqNC6N0Eov5ErMoM5YzYDrzM6wVFZzpAkuNUszNaLTqbe3ZMNP+Bj1BB21i8E6TFM1nTM4rU/7DFe7sNN9K1dz7S9zHcS1OMQn8lPHDNRCTVAFPdQGzVDiwDAc6IKPzLxxqNBTXBrnUFRLJVYNNVjswBlSMC2YdL37e68/jB7T+Aj+sDkdtM3cRAmeYtI/ilUUQIEMmNUgmAPDwU1tMZHnI1KfMi4V2koaLVaPjdUopdIrBUtl3U4u21Ia8INnvaqz/wOv9NTDaOqhe2RNFOtWby2ScRVXgPQuKUKjOy3EuwvML2lXd92D0ci70QjUeCXUea3XBnOC0DhYQcpXUITUzhvJSd0sRb3UxyvNTPVQTgWblfNU10Siv5oKOo0t+8A1XLPGFIE+9+kNjvVYEeAAj8WBLCAEXcPVndtVlA1cdZFCFulNyCOBwv0ADtDcCnAAKcUcrutOm81SeGkACYABwvTSnv0uoBXafhza/jFaWxQKpN1Hf1Ra+bRdK9IZqC3IAqyr3V0LQgleP31XeO3a483AyVRer6XMgj3YVMzXzQTJOUiBbxSkJFDFURNNIEhUlDw51IzF+1lNT22rh+UZuv+7j7a5NQGxxnOhAz7hDDDADe4t3GPtAMS11SLT1XIJ3D9JrpCIpRqtnM2NACktYM6FIZoV3WRl1gOYUiIoy/Qi2tnFy2ZqOz7M1ph8MzSNXTCFz9ytYLz81lsA3hJe1xLeXeEdXuI13hZmXnr92rBFVActKHz9jbLl142LhTkYzs8cPYMNve6NqCH2LKsZLfCV2/F9N7sNVbljMV95m/XtDyd8A/mVNCCogfo9XFpd3B8F0r9l1f7132rDJfeBVQIu4F9CAAg4XA5wgPHbsgZOYHIsJgq4ACbgBJ69qjKdQ9p1Mw2OXf1ZU2+13aQ1ZD6uy2EoFBRmZJ1ZZEIpDUj/tlpJ4VoYtuQM5N4ZBmLQzFcMU9wc/gdvIIQengILDVjIC83tzeQZXmWTnKjTy9RS7a9H/A7AU+L7a4UyPV/0XRsppoQmDGMr9gL6xeIXKFyY5QFb3cn93c0zwDRX9N/ok9yVcFXD5QALcIAHmJFtXuNsBlk3luNwXuAww4nS3YJJ0GN2xGD+82NuBeT24OCGZWc8rF39y9ZExucigeQU5l1+LuF9lmRKxsgXvmSvZQzPaGXt5WSyzdcsSB9Q3mHLvTCFJljn3d62HQ0+2OdZY0BbVs2/O5t/iSe/wgX0jeJWiGJgDmY9GWZihllknoIuLlmqbObpiOZpgyWcpogO/7TmzpUAn+ZmB06AB9hcmTBHYsqRyxFH6oKhKp0Xc0bn1MXHPdymerZqbX3neJ6kjOJq9LLnq77nsBZr0FkivHhk4P1dhKzagH4i1INMgiboJsDA0DhohJbhE3yo6WSOC8sC6e3XYuBhH3Zl5iBit1VlIb5o60i1U4lM4a0Pvgs0giM0vgpVXKGFAxKGk34bla5i2yDml33pGOABxRWWYHDc3ZNGwf2CaPagKEOc37DODUhjbp7SBLDtoV6A3FYABRBLpg5nMqTZAyjHebnjqNYhEF7ndnYPdw7ksRkKPx5rsXbPSD7rsi5EwcyZ7O5Ttka1t4brjEweIaDr8U5ovP+m1E7hWKb5ZM70hkpwaFM+ZcQubPo17PoW2MhTJIxcgsbu07yKp7aJ7LJKmzHClf3arxX1iZP+5SQV5s/O4gdXAeqEvChLICDVNSF1StV+QivzoNR2msz96dte4xEXcdvW7RL/7ZwYPzhmVgk4Z3V8M5i7XaBV7qOA56K98Q62FT2k5xovs7kolEWGWuFdJ0Nha+7u7oH+7vFm8ibfgbq2a+29zA674ej9yHHAclGe6Iq23Poe4iifbykP4iK2mkE1VP2mArhIjJzxhJjh28lmMV5GcM3ODxPJcM5wcAiPcI/l3sT9g1w7bd6DXFniRp0+soYy3AK27domJhSPAN7/XoBGF3ESp3QVJ+ctG+7hvokLAIPTJNEYj1b6FHVEfl1szeDl7h7mVvWjNXUfh7UlTgpJXqd9rqsjt/XF9m7kfeErkGte94I8cXIwNz3QW9vQPMVPwzBQxLyNw3LL6nL5dvBo93Ix51DG1kRALYPkfYs1vwv/ZgUxguLLfvME92XOxvMnx2LQgPDP5l4K17395dUo2PAXEXQciO00rnSxFPETR/GkVvF8F+ctm9I3QD9Wn3FEzsNTX3Ucf+d3g27pTj+AtnWNvvXireS49nW5zpOUmWsoF2+P11DkuAEauExVLNta8AYs3zh6IARUtsxpZ/cvl/nEDnMG1RNFElRd/19eyNx5nCEjYElwn1gGBA969mXfklqXUkn3B8fipS9WVJYDOTAgaLzwiXDCzCh0izh0EC/dftd33iamSD8AsVdqgDd7BRY/DKCDTwd1NmXd5Dazs0T1uc/xhWePfHa7LzWvIJnkird1rXVhXV/y0Nh4YAf5w6d29ObYC00aTxZZS0h5fzV2mA/imbd8l098mxctJT/eSTTe5fl5lE4woZ+ji/qFBOxbvxUQkKhcBkX311/3GqDvKtgISgjSSHBcQQcULsxC7XsRcMxmodb34Zf0AfD6sif+zAlnDCB4ti/RcBXhuB9kubf7umd1/FP4uoX1+xMKv791XM/1gu51J//P+GA//I837+r4jadp/Cpv6D+ABT6K75dH5cuPecqv+d7Ib0wLLYBIE0YLwTBvAgXi00cSp0ykWqlC5WsisYoUKy7z9euiL1QbI0bM5KgPnDdgpjwBUkPljpYqVayMyWMmGDl//pTKqTPSTT8lT4IpWXLNmaJRotAw0SEChKYHEDyNWmCAVKhVqV7NqvWpgAIBDnz12pXqWAQnErVSptbZtmxtpWU71osXXVd2Z9m6NWyvMbnM/vrlC3gw4cLHpB22pngxucaOGUN7C3dys8p9AwvObDiyZMueA3/ek2c0GzaiRac5jXqPwNKtC8Ie6GU2bdm2ndxuons37964ecf/DK5jOJPixolDucEEKfPjxo9Cj37G0J/k1lPSxK4du5Mf3r+D5148ivLw4regT1NUoBb1WwYtSsSpYSRSHC3i/6V///5lGzeWQhFIIvn0E3Y5BIegcCwBwUNNN0USSSmUUMjTTUNN8QaGRp2Bww0fXNAUBFIZUOJUJ6K4lYpWpWgiASaSWBZZEOTAyVqcufXZXHnxOBdom/2oY5CUUZaOkZC99VhlnQk5mGabMblkZE1aptoeZliZGmqpmVZal7GZAWZutd22gxcuASeEmkSsOQSbbQqHFHLOXUfeUXSWB91yeuqZ3XnihReooIPSSRB7afBR1B6OMOoIKjmpwl9//5JqNKmkv5Tyn0QDikSHSUAxuOCCDT5RRR9+9BRhhX6QBEcVQLn6BRSzHiUCiCK6mGuLK/K6YlcvtvhriTVkciORltGVrF5PGsbsZ4VNlpi0SCoZpbVUXjZkjkVei0xoWZomEGvhelluuWSiO+ZvsjGYprvvvunmEeXNSee8ci6ng4c33DmedH3WmdJ1gLJJsHPg1Vuocegp5Kh+1eQCjMSSBqjfRRZXeinGFqPSCoGegmGHFAOFqiCapI6M0hlroMqoqoKwKkassIJanK0SNJCzrrmGJSNWPycQNIu9SgWssDKWSGOxxjK5o7NBPp0tlNpSi6SUx06J7dNsXc111v/PVmbulYZqKbaXA50tZrpPzMZ2E263C2e8c+9Gt7xM0EBcnv0GTCff/noIsJ/nzRSq4YcTat7C6Z3haMSPQ35pRRtrTKlHH4nESR92HHQSyaIyuJ2sUdjUsumevpo6UK9KUfgGTOm889FPAeDzz7cPnXuMRgc7OwRApKVMtVJCDWSzxk97bPJHYt118854q3X0zlPvNdhhYp829umpXZravukG9+e//Sa3+efDcLfe6+ubp944kKecnTbrfSffgxtscOL7J9yeoY5E7lKQolTlCjggSdQhESYRWcpOdrjWQXB0DTsdHVg3uNG17kM4k93sftUz3BFNdzBC0dFsdwH/YjGtW8cr3pO21rzEMM9q1XvhCqk2wxdur3uvGRMPz0QmlbytTHFDn93m9gIUJAh0ePJT4uxkP+bMb2/44x8V47YwQzEsEvp5XAElpx9TbFFjkJoEGU/VOZGRCnECkwIGYSUUOsCxVYAqHExikgIUwG6EIjzRB0O4x95xUEYYsEMKqfE1sEUtMMrCjLOUNxgZ0jCS0pvaIbs2vWb4L5M93CT42gaEMsALbieDFxGTaMqCNXGJ8KuVh5ISnXkt7k+FQ2UVaYkwVBIklnS43Cp6+bicSApiX8xYGLk4xjLK8SQMfKDAaObMKrwxVmyKQQ3uiMRriiADKOhABUakxz9+/9B2fhxaIMmiRxXY6HmVdFLUlNUjRj5JhZC5IT1raMN6ekaTWPxebNblybaB8p+hLBgpHVhKJdbSYPbj172aE8vneEd/arTloHCZS4b1IVO5CMY1HocNbHQ0gBQTKaZUgUxPLTOCJEOZwFLnKmgGJSgz+4IFj5g+bG6zAhjYqVNkB0KufLNXPyVnCTtoIgyAIS3DWyc7fdSsHr3TaYLhljzxKUkWSs2GKkQGesTUVX7CJqBXoMLafEhQ8p0MTQc9JVspmlD64Y1PR7gfrdYo0Vq6VWECKwklclGKkZTEEae4BmE3WlguGjAnEYIZyMBgEJVClo0nieZMY6rSl+AUif8Z0CnscFVOEk6lj+MEpFFLi9QUKsaQTIWnk/Jyl6iydjJJqqpVEYlVF672WWDdLUB760N1DVStRWwrcan51lAlLIp969tx8+rcWH7BDxPCQt6IkBI4lCKkEYNYgHIiWJ1UQhWVGO9izWjZkQ3Ec6BSmUw31MYMGte4mUViCDhgX55u8LMl4p04R2vO0kLFdxewg1KpmltmLAueeHltsmILmGrRtrbSa2FWJcwM3mKYCp+kDVnHF1zhFteIIX4uXullM+MUTpZ3tW6Jw5MEvZqKQn74Qg1OgCA+/CIYv3wUKhzBE0f5eLFkZGxjnSlZoLTRskZGXDVtOl/NatO+SOz/JlP0y0dg+Yqo+gUwAk5ryKV2ay8JViSDF5k8BC8vwle1J4Wbehnr0RPDcqbNhnNg1oKCeK0jBh37WmxiiMJ4xRMlcXdYbNcnYAEOhFAsrFBFCfD2uCeNYpQghgwzzVWWgUd+ppGx0EDDzfemKBDBk+drXwfkEag+3R1pS+tqPSrtRo4BBySbOua6lPnMyAINjqI0VWjZls0VZiGci53Pfh5BoPzc8GzszGzg4tkle542n/0sKBWLbjuDJvQtU2JoRENzEn2g8RNMx2PvMupUp4uZp+D4KSV3WnXvjSCTTXlNGFjTycYtXOBIQM0U3DcCQOUvwQP86oMDuClJrciX/xveayG5M+IMRp6Z12zh2yaSknEW04s7juw5RzvPajIZtfcc35MzOZUpnhWgB7ZEbg8Xrd/OkKe8zTJVoeJl6Y6ju0H27nh/amZG8TQGD2RQlCMd38O5aQyyc5QsVAHqr4IfDkjAgSoDq+Ae3DLCZZczMESK4Q6/llShKvG/0LDiM2zwxTEu7Aob22vJ/qHHl5CuTuI95CIvecmtze+Va7uuzLU2zMMjHTg4OucTKi+rTtVzOIoB3g5y5rvdS+9tM+jPgkrB30m3Bqh/PvSgh98dr27w/QqgZ6hXfdeLurMGYKAPEpvG2MceLTGbHbZXZbvFwdb7S74d+BL+OGzsXv93mfMG2h/WDd+bz/Skk1jz7hN8ywXd7cLbkr3U7MOjx/hjSbfqjZEHOqcNlGIgho6lEFw5+6nufvcTJepZEL3o5R8EHgBc4Fxv/cEb8CIIYIAW0R5n1B43dEbZZQZu3R7vbZWu2RPyBJsDWtjxIV8F5l3yeZgFOt8G2lSfOZeJnV/1TVHLEZ4HTtPMnQQPmEAVPJoikNf3tczjFRmSAUH5uVTNpJ9KHFoEsdfqyNu/PJ3qpM78cYHoFWEVUF3+6Z/Wud7+GVXO+MEvDGDDFSD0sJYCbgti4J4ERmAEOlXbBV8XUuAFkmEZViAHFpe+PR/0VRQIEkrgBJ4I3hIbXh//HYKbrACBolHI4hEC+LGbq8iMD4JBEIABCyAZAwWiZeWg+m3aM8kM/alO/NmfEAYhERbhJUpdEBCi1TnA6TUhE/Kf/0FAGITdFBrgN6hWFk4PFwLbYiALAx6Y8E2G2oFhFwrfLRrDGDqbGfKiBooYGrKVGtoh0tELMY5gHFqfCdbhG7KXHq4K+MlBNGJIIo7f6jTI/UmdgXjOIjKiI/Ic5EHiEIpjJVqi/BVhHVhBIIqBJlbdNqGaJwbS/iWNzmxBpQgPFZ6iW0SDFcKd8cSdVKmT1kQcLdZiPwafLq5JLypkyJEccTVkjUFkRArjGtLhMKpcCZag9g2FqlhI6Ujj/yNWI1BYARiM5EmMZBDYASGuEnxxYze6ERxJYzTGJP2F4zhmIhJa4hzUATpeIhIm4Wb1lIvETjwm3IucwOVQg9hlxDmY4j7yoy3SEyzGIpoNpFQy1T+GodYs5Fb6YpoAYzCK2kTeUZ+dn0VOH7YtY/Qp47U1IxywjB/OJEjWhBikI81YAamwwEzkJUsyIg9SovzNpEzGZTiG3iQOoSbiJGKaI0+O4/1ZEzd5kygOZevpDOyFwSQIAzFUgzhwpjqowzI05TPEne/Bma/pGjTgolws2GtpXEFC5bBhEkJy5Vb+Ygd+pU1VV6lRpDHOUnNFVDJm5N54GmWxzDeCozjKzP84sgBMMCdMOMjk2SVIPmI0Sicd7CTPXadxVqdcGmbqKKZ3ysw5YqI5+iQS3oz+eVY8+t//VSYFjEAYLMJDpAXtbaZnLqVoZiF+jmYDtiLY5IUopAKA5gVWtiaBGuRt/YVszqaCxpxt3iZumkBYRihO7aZZ7g9LteQHFuNaviFMEWfoAeJxwtsmwsQJ7JSN7VQNVudOwkyLuuiLZmc0siiRgeN2EmZjTp0LIOc5Xmc51h8O2IqICKnX8U57wt4FjACCwOdCgEKTbuZ9gqZ+qhlcNIYkwdlcfMIlZClePJgBXqkwGOR+ZuUKnc+CMij44OZDAuOEsmmbSiiFEuNYuuH/nKYfh1qonSoOTQ3dBUnWzLCfCpjoTgkqfqmAGDxaC6qKJlBCHxICdQgCo/bhjLKoRwpmjdooeapjYiJnEKwopM7kHxQm/tUXzkQmkRppiCApCKjqDORNsokGQ9BCrGamaKIiOnjpLsjibLVFlfan18xClmrpXUiJl6riA5bmVIZhocUcLybkmR6UmjokEuWAjQkjm96UrbQptn4Aqd1bRfbmy2FkuP6mynhHZlFrGtlYutoYBwwqACJAUwiqCgTBogVDMdSCJuBrvo7XvhqCo7bopMpoHVhnpVIndW5nd8pfTfxleMrMjPprG0DsTL5KTqVaZRppzlDAkabqqiap/xIcwce2R0LExyg0aaxWktcQq66eQ6/e6q+GgoDCkK7qp7GibCxmnGEsa7PqrLPqnW0iyLmuqZtea7a+zgYY7YQqh5zSKZ6KKxXtC1uiBBG0K6oKKjfplKDCDqphgLsKqaC+6wNkQV/ZazH0kr7qa7/2679O6toSLEyKgcEmJ8LG1KZiangGbNtW6lHEALte7DxibNca7QiEgOCy6scarm6EyWgAwiDAByZgAivgQuSCqVPS6jnYajikbLESK+69U9fYquXOrOSG6e+53SomCJ513M6O4fGprvkA7W0KLdGCiAWgKrxu6zUlrdKmZdPy7kPRVwjUbggEKtU2CH4FDf+g4tfWAqADKG8GsEAd1MJH2WvZmq0mFML1Lirbxijewi130m3cGubBRqO6+QH3hp6o8tTFAu4GCC7hFu7hGl/2cA7jlgZC2O98yGeUoiI77C/tLUMySGnoRhzaDWvm5siwTVV+Ek/pwuYwOGTrQnAES3BwvG7Jdau5jpq2bis31e7fHm2F3umGzqFaMi3UthQcTMEMoOoIkMrwatPWEmpeUiwGMC8Np68DOO8caEIteMP0WsIPV2/2Ripjbe/2WmqI7mjdkmf3DmZxviWlOjF5LMWQdm2IHO22qmqrwu9YjRWZmIuXMC5CPK7kRqlnfmaU6qcw4CeY6kXnFjDofi7/YUxuK/LnmB4DcSXBBOexHqtPbTooB95btmqw1dLukPqtlIFw75Iwh1qHCaOvkEbACXDevwUNJGOACmgTc26WDWttJ0JAJzpAoerwKvhw9VrvokIqzLDtwBKs90bijiLx28Kt+Qbm3V7IxAJvB8PrBVwx4dLA4WrxbnCxmQQU2mhPl+xBQpRsk4LCrKIxAP/vLrTxrdVsABPw6OJTViUghelZg8KJyfSsvIDlH5Pzm8KAtrZpwHEWJPMM7N3unKZPvtwALPGutyrjvnzsE0kx1XLTlDkvYm4W83IAD8hBFWwyTMhwBjwAqjG0AjS083JBITzC2AJxRR8C9qbtEGuv/9taqkzZKEeDdC2br0KwMqsIphzNcy7zcy8LbzBvcfyWFdp0Vblkycgy80VEs6zqNDQzJVMuA+jeZzNj8zWHYSJ1Mx+bSTj7cTkztYTmjblqq9FKNVN0lsVKpgTcLu6iHA2QnggvrVuBtVnKSd44FKK5igrWl/BeUwUwbw5nASZXgDYtp+kd7zr6m0I/tAMstF4/QA4jAkVbNHlhtL+qLStrp2EjdknHkcDCJN463mODKEk48WSzjDQB7wjsFDeldUu36vuqLrs0K9mwxpV8iWqAcSM8LuSqtk6TceUS633CcTIM9SMV6xXadi5uoDe3RN0gtThLZFNTk4NyawYPcv/R4ozyVrXFvsj/6RSpIR2QPu1Xj/AJhrVbcTV4zAtXczW+0IQ01RghRwBDX7Je3h9QVvK7cgBMyPUEZEB75/VDy+shjO29AvG+8mtGDzHB2rKkai9/b3Rjx6jjNTFJCHj5UlAKbzYWt7Rnu/QefzOrFu66uMcOhRVpmIEeILP9Om5qTy6t1upS+nSIF6gdE1tvH7XOXoGJh+VSy9dvv2lxgzdVs7NyLzcADjd1A6l0t2F1V2R1zRIOzJWPC6d1RS3FCnR63zVi1kEJBNwJ0KXVtTcm3x8DvDdDf/IDPK98U/Qh5Ov1njLaRup+8zeMkrnaqjKLqpscQPaas3lxrlv/y/RhBUnBORttZxcug58PhM/AZnM2QZhGe7hHJh2zl8TBaaM2h6NxokPpzBrrNiNoAp64bu+dEJyJirO4b7s4ccP4Olu5jJMq4AolBqg1vbRSjuu4PVe3qZP6V0vBWZ8zDKyBIcgBwOmU80YjlP9zHQSBemcAp5LAXjt0CbhACbA3sBu7iODwvJIyfbtg9WI0IehkmbuoRq/tmZs5wBb4p36jgZ/0mz9qo7ZMh9iMnd95Z7/AyJ07nw9u+3I2yHKPoLvGFxN6oetBvY/GoZcsmE6Dff6viBM1iUOlpUt6ijOfUrvJip/4i8O41iYvJK8vZEamjeuuclz3qVN3CJN1/3WRh5DPqZ7wMgw8XdU1911rbZdxAU76m055ctA49EKzNwkUe8vztUMnAEP3eiH8MH3XN74+eyp/+4tSu7TvJCcQ8cAK7NEz9mKXTrafTioHGUeWFx6SO57/slqre/uy76r+srtPuHvEuzHLRqGLfR6YQRmMxquiNjM3szXPsW1RczZPVaQLvMFfOsIH8tBu+jpLQKeDOlVfMZXN4weLAHSTngh4NapfPI/LM0Ppy8HcIVJYa9WR/N6H95FHeQngHyYrQM2z9wSwgAYwAHtrQOfLvF5vfulDtCGQMiL88EWD+ev3IXXgt88LvdAz/e2rubf7GISAu85VgoSAX0rsef+7m7vVb3bVqiovJ39Lv9i7HwqF1wYyl0ZAiT0Y7wGAYv/ax4UAvxku5HQ8TaWCQOtB8bbIlb/Ap6EaQnVasytnsfVxezr8U75x6/1+2Ti2AjnHl/B07z9A6LgxUGDBHwd/RIFT5cmZNThQcOCQIgWPOXOCSHRQIUOQOlxQOEBBAsdFHBkmTFBRwkWJBQpgKphgY0XKDA825nQQE2YGLoZgFStmqVBRQ0eRIqUUaWkkQk0zCZJaZyrVqVWpZsVah1NWOXL6+BE7luxYqY6cEvozCe1Tp5Uo/UFVChVTP3C+EKERgu8Mv337bsAw2ALhwhcQgxCc+AONI4+1eEkyOXL/5TCXMbPRvIezmTyazYQ2c2T05kaNPoHCxezcs9W0shlrzTrbOVaqj+Vutlsab2e/fesexkyYEOPHkQ9Rrnc58xrJnUPf0YR6dCfSnzfXHh3Gi+zdv4M30V1EefMSF1eQsF59BPfr38eXb1j9AQP3G3zQPx5HfxE4CAoQogBjKNDAAxFCUMEFCTRIwCrOiAKH/TbIKQsuuIBIBZR4CEIFB+JLwQouNCBhQwZ4SkBFBjSwiYSUcMoppgcOSGCjLgqxpJZaViHKKLjeClKttJ6KSqutsLoqyanYUlLJJs9yi6m0plyLElT+kMuULR3Jso8zmHAMsBEMK3MwMhNL84IR//hi0zHknLBMTss820O0O0OzszPOPttDlFFAAcW2QAkNVB11Am1tNtoYjY24R2UjDrtJw6vU0umqy1RTSre71NPxzgOVrw3Q66A9ENmLbzH5WC3VPfzWE5WGG0AdCKJZcXWQwQR53VWH/nSNwkGFIhShwp1yQi8FlngIaScIQLQx2QxYaLHFFHtCcYISuJ3g2RUjoLHGCVzAcA4dg+pRkaPgSqopt546Ul55naw3SicnUUsqKqWsEq4//i1Fy7nm6vIuvGBQkz0zz1QsMQkcHrMv5bR4wuItMK4sDc3S4NNONjgjLTSR8SyjjD0Y+bNQUK4BZRlQEF2mNZmfqdnmmv8bhdQYY97s2WfwOPUU06GZ25Q7oI9G2jvxlkaBaVFHVU/qqVFtVTBWVTVVggbug9W8vWgNENcBdS3b117NbtBWCSU0VrAKRgriJIlIkruKkBAIl1oWUrKRXCtauElbDTSoKaZtXXBhpQxsxKGlGndiKXFCCtlxR6LgArKppY7KxJBMPNf33iHtfdJIJicBnfQhqxRyyrky35JgLGcP8i69QmC4TDJHVax3NiX2a+mK49RiYz3TgOPjNI5g/rHOPKvzs+jzQI3QaxDFntBsBFV00WRw1hnSn39OulNPJSPa6KA/bZ88qE2NmuqF6a+/QvjmO+wCrgm4T4LybtAfYNH/wD9kSxvaDqi2/hxBbQRhWxUmpJ8OdMRDEeHARlIwB0OA5CYiwYEVroWsmYCQcIKDkYpsVLgV2IAL3ipBF1YAkxodgAMluBCG5KCjoWwpcz1MSuhIl4k5qG5fqzPd6IoYOiq9bnNX2pwirDQXLg2MLlaiixNvJz+t0ad3a9KixDDAF+VggTLJ65jx+IC85+0pTx/rU588Y72VtexmM6NZzoADPj2ST2nsq9R1irY+QA7SfE3royEN+bVQUWiLh5ma/eqnKgq8x5EQ6Fr/IqCfFCjyVg30ZALVNqtOmu2BEgogqDggrWg54CbkSpxNVilDmfBtWy064UsOFzlbeguF/72M3AUzABTLwUJdRcncIQrBuXj1i3TKfJ0moAlNZwoiEjmaJhOdeIpfnIIuVRwYD+tSii09k4c96lElCMEQGHygQKUS1ZnWGYKD8AUKLxgTAIEWITOewRGc2djzFrGIfrLxY3mi3p34FNBFbG8ZDXXZMmjhi4hGtI41Kw4iD3k+ThGSox3VKEYz6rREyoqRpHJVJVOV0khCywL5ayn/+lcjU5WnBAA04NlwisBODlBYYhOIhB5STwFeMFw2UkFGZHLUlryogzMqISsLRwYreAuX5LIBCXCygJS8EpcoRECNIKAialWhDaWAhTeEYgm1RlMTlNCcM40UFbmqpRLiBP+GNoOhzbZu7hTBeCtTcnGKzf0iGLkwbGG7uaXDBnYueV0XYE1RiVUUtrDmNEQbqnCUiKhnCn+w52C+UAW++AEKIaABIdZgzzatwQ+qpQEcULGIxzQPSx3bwxn20KUuCaygINsT8uqEJ4/JMVC0IEVDhYHc5LomucldGh8FMryPdooygqzudEN6SJGS9J0lfSQkwYs1l76qf5jUJLf2ctOcgpK9aSPW2jCbAfWw8kIuaCq1NGhfZD2ABSzUgFOtUBOq1jKrB3hJCdxQE26J66sNRlYJ5HChcwnlcshka12hwswmGpab0pTsKt66CmzkoomlKCxf/epWUwzFEabIazj/EevivEZWsTKGS423pKNVZOGCF6hCJURrKjjIoTyREC0NlrJZ07r1Lybwgyn48CZ+OgJMzWvxIjrWJeRt+Y1uFE1v2+ixhaqmuBR9hi/QfFGQQle66COC0ayLXfdtl7smKKkEH9nI8K5UknyGaQJIRdOwUWS97bUVrTrpmAEB6EEOoZV7SpIFHniLWpSO1gD2RhJa2qSpKGQJt0rAy14mAEW4XMALu+ASX65yrCdpQ1CKgdZzXrjE8KImJTjsxL1qIsVM4fWJUcxYFZN4KSbOxR9cXArIBlbGPDJEjXkk2UoowhTU3tLlUrCeKCjbzh8Ysn4isYYN6MCtMQjjuLkt/0ZHYGkvVsZyxXLbz+c5YhHB5TKfvpxvfZdMTyg7TSPKTIo158qP1KVYnOWc3ZDW+c56znNh0rNnlL7tAW+LwAzLCy2RErrQhiYIAR0TwFEGq1ju2VZF5DaBC+5XlQ+4iQpW0JIP7WQABobcgUtEOJe8JKs41yqz+sZKvskyWS64iA53GE1d19rXiE3mKcxZCWAAo4eVDXGu3WpYt9b1xLm4hrLtyuzFcr1HO6qrta1NWUW4LQpLiYJ+vm2CcFuACOUe1Rfgshd50hsVYXoMvRkYmXXvoXm55UNwEf9l4IK5ZHgSGck2E7KBK/yjHrV8win/NPg1/KQOt7jEJ261q//9OZMdAKAKOo7ABi46bL8SJYEeuNkHRCELoDZ6EHjC33KxACfUcoEN5jBVmGT108R3QYL/m9UStcTUHZmDgJuKrAEMnwXlqsMhLOdYWte6rx0OBo92xM1a7HWyUPdh+RlrbCCZmMYpFmeyTRx+yfJostqvdrWpbUy2/+ErxmJtkcUtBpgiCs5NDpjMzvgpDahsBKwMDp5HC/ggtpjnttgoehQPuCLDjewkCRqvA0uGzUCw4K7r8jBvznQAbDaP8zwv4j4v4jJppapmI+7HpOqja8LqfzYu9T6pIAiI0EQggUoJglIAglaOA4wu1FBC94aO5hTg+AwhCKjqwJivqyb/oAvIYMF6DnJQiFwkZ0SCoNRQ6Fn+5iPmoBJiTSi2b+k4rPugSf60b8bcL+vwCuycbv5ArPxi58Uoa/zKTxPqbxUMYV3mIAuC4AlL4A+yrQPE4A+qgLQUUQ5ML9z2jg6IjFTEghAew9scIQnuYraoTNGsDPBwy3gycN/0TU+ihwM/8MsiA/JKQwv4KARFcARJsJBM8H0YTgW1ZgUhrhffpgV9EdBUSgJ6byMsyQYhIIychuN2sON26tAcqPWYIPaIqqgQwAg9hKmir+dEKOeoSgu1sJZibgV2jsHAZfrIZRBnruZUhAllopWEqRZkzQ/fLw/Fjuoqwemcjdd6JK+q/06c/NHYOMzp8HDYQAwO1crsJEtHMGKTRMIQJKINcCCTGhEG1kC04i6dMIAIUKu1JtGzwK21+KC1mof/fOYIumQRmIDwkiBkOBAVvWwDq+ugSoYUHc/xJi/zjibOatEWLSVXFCkou22miLIoH+4oUeoFhxF/mDKTjPEYYaUCGmMZmfGTmsXjciW6AogJuPJX2qYaWe0BNKA/EmcJBywI7KuVQC0KweXUko9wXIAMrjAL21KsTGRDpI8dfWlvClEoRiz9wi6w1vDXxI/E2NDqKMH82DAfKSvXAFIR/jEfyy4hNeEiak8M5iAFZsiGKiTVNoKsOsAiLBISQ2DufiCdHP+xEdsObBgxBNYAFc5gVgBvtlrxyh4P32QyN/GtFCkjN5mHTkDjTkjjaXKyzYxTOnjSJzOPznJRF0sFKX0RGIFRvOJDJ+ADGS1gIqqyGbkTQLIS5GxlVtbm7arxPyRi97ZqDshABbRFLAsBEQInW0qADNygC0QNJ7rADcpR91qCLbGlJ2pp5nZicaRPRQajEDXhGtCK/gBSMBmLME8h6fiwDjns17IuIDE0Dl2s7MwJczgorCAANPvnQuzD6CruQuDmD6ZADCARBVBLnhBxDcRNRlfzA6KgNflJWPgpyiBjOFEytnrTJoVLOFuyMvRkJkVjTkamMjLxuZbzOJEzOd//TDmVs1aa0zmh8xdbajqV8vOok5Jq8JJi5fSuUgcdBChh700cqAou0iFrqCFNpOcmIPhWYEMoTUBnaAHKpSz309QUwD70tCWupanAkB1/rgWsoA4+pFAdzAFYACQs4vuuQez6cfzaECH9EA4ztDBLYf7eLyAL0lOlLQgyywB5oMH8B0MSgADaQCJFpA0uCDQ5gEX/T+7EQJ4i4QYqkrR4IFe9LbYUAjYZ6A94VAdaMfAGjxbxxEiR1CV5E97uREmPVRbXrPKUVUpLMLqA8kqxVEuztBe79Bdl0Evl4wYX5s/yg50IYjtTj9EYzad6UDx1NaggAj2sUYYQgFyqLy3d/9FPKU1yQm0BDMxP5RMJb4knag4dX6nTLg0DMIizCKH+GrSvNPUgzamy/vBSOVVU8RBdIuvGAHENCiELVKQkDGEC8tUBBGBlU6AQaIT/uiAL2mDtIkBWeUAO+M+0NigEcCBXb5asBsLIXuvYsgRIj6ASeBQyIuQxzqAUZOtIpTVqn1VOhvOfqDYyrLQ4MSpKl2BTmLQnqVTzcjEFjRLPvPVsZzBt1XbPwmqSWOrzYIoASi8HEeQ/KoI/fhAU8TZtfjBYaO/tWCu1yoPlZkSpxlG/AOyqpEUDuoAmyHECwDD3UkLTgi5FvooEEicbkSoGT+CowIAqMqHDuGnqCnOxKP81Qx30YicUxOaP/swOitgUJOVAMwVgAooCZVtiZQWAAwpB5eaAca4xM0OUEKQmXgDQRg2BVrLEs27AV7Okp573RmPzTUaSjBjIFDaReJDUMqyWJa92e7XXetNAfFHQnsxXazfqWrE1W8v3BKFmkRjpOX+x89a2fu13vF4lf0AkbpNRk6ryGceGgAZIV9jVIAQ4Qm5UEdagVXEgRrgQJVqgP6vv+QgVYP20BBThEeaygxjAhGQic7ul08IQc1uihqiCbyqCRQ1B2qSpU6WN2e5KdDvswzpVseDw/cxpQ+uKQ49CEUSrcbJAZdeAdhNgZklgABKn5moXIknAEC7OACL/IGZrthJn1RJalBJEq0ZFNrXaTlhMsjwC92inl2mFlYFqy3rVl3vl5J9kkmp9FBabZ7ZkZbvQl2vTGGypdDw2iVvh1520CG291FvDNTqDMX/NNVa0hrzMayqZUTxFCU3BEytF7r0Ikawk8oJYQIM2TU7pNApxIk8hJ3Nj7mBlInIcN+bWEl9HLQF8wsNceYZ3OJbtr4fyEJwmi4ZtuFJZ9yiILANytoYyJACiuARWNgAQDGVtF/ceIGYPwCMaDAK4AFZlFW7QqTyeEHlpRWTfrotvwBRikz9U9AjOGEyYYC3IKAKLlRbBlyuj9o7Fl4xABZHiuY6hA87U2aMy6mjG/7aPuxWQ/RltXxB/vxSRrwY7TW8ZR64Hw+Y/IjmUpLH1+uOB/iCCQK2VkEWVF2BDSOJxuZHnPDolSghySw1FUigIMASEtVGEMJdy2AqWY1nFcBhjaQ2XiQKH65FD1YoS5AAMIoIiCsAARKALWnWi7eMAQq2YFcAlAKB2hRqGVPZFuqYAUCAjOqRULhKMt3l2bRSzfjCowlnROtEsuoQJRjISDOaey2hOyFlIv/fxjvWfmmeeqRWjJuMk77h48Fjh5hh+yRbP5Jd+AfqfuVSlqJMG16OovcZKfVCRBqJWCCRvQQkHELim4GNWn4+pCBdAbY+F+rSjtWpbYEla7utFRP9CgxL1IjRo2i6spTtMFeixrnCYsLSpH10aw0rB2mrMQ5tFvo6RvAogXHCivGJqqQMgAGoOAJB7+lR2ZVUkqivbr5mzbxGtsXlQWGrF73Clp2ZLB9b6MYy1ru+ajNr6jcPEJtkZu+X6fOkZre96BCvPgPZ5KpvTsHdRXO1bsLcUTAN5oEXPt6FYIhh7j8lmbxtbuvNWugXCbn/qK3WCBZCJC8igDgas0k6tP1WiXFJNA0a650rNlZYKRk5IlZp4rUi8xGVYdF27m1w7xU88h11Yte9vrdBppx8NVaHykoy7uO2juJG7x33cx3X8p5m7AfR7P5zm9OaZVvCJk0ClSdP/W1u/G7x7lL1/k8ohY07KW0zo2UnVlLq6Fq9JEJ+1A1feJBd1gELcl5/NVrDpV7/vd5D9zM3t1cYRw3/Nc8k3yUTwHLIHDcoNopR4jG4kpw5SjkNmToQnQC4FVaQfQFsojYXsi3G5QBtXwqRT2w9NXMZRnMUTy7Zhu8VhWa3OqRD4Dwo+BES5RshRVXdZPcd5/NVhndWFHNUPGcCN3DzSXFR8EMr1uMsHwru/k8wZqCDaG7yzfFqvK/ACD73L98nXW0rz2jhvZZ7H9szjVxfpG78FG85Dryn7+8aJ/H+MHL0WmuMa+cw3ydrv1kEARCH4r6YAXILRcgnDsPl0TnI8/1lyqcoFpi1xotmaMF3T65G1E4vTDf7ECR7EeLle/TuqHR7HCSDWJd7VnZvIUZ2Lbp2vrTTA/Xw83JeBhB3KvZvYrby6vpZ8lX22aFOO1Xu97Zq921qdbzG+M17N15wGb17bdb7bxSs6wT1d9RiAfnCP0x3XiR7B3SsKDBCzPGQiRECE9lQbUWLqOW1yl6qjRZsErCBHLkzgZ42FT/ymxR7Fx56FDYEO6jVMH37tKX7iY33t88ZcG4AC5rfmhTLo+dyAy73jneMEzaaujx2t0TjwkV3lDb/MnT0nmb3Yv5a9oSPY6yzBrb3mr92k/FojKi7nd146A5u/v4v0Dlrohf9+j82T4/I23d3XgCNaZBUBMhuyGvN1RH5iDgbV0DHb5bYFhuy00v+dxDt0tQn+tcO+FLbJpjvd+4gCtYhwf1ad7SE+4t3+7VU97uWekuje8m891/cCsvHJ7/u2+/U+n/2+bIwd5pV1fJO9fJ1cy+WZjjMK5OvZns1/zENu2mne5isf+7H/r93przff55dSzgGig4UIDQwQINBAwgYRDEWkaAgx4sOGD1NUvAGDBI4bOKJEWVNpVS1TheZk6ZjBwYMJE1iI4RJERUoHGWQ62LDhwQMODlLMsWQoaCFFhzQZtbTK0tFKS08ZDem0VFSpVKX+qroKq9SkWSkRknMyRQf/CBAOGESA9qzatQcFBHgLN+7bAgbM2iWLl6AEvQr74vz7IXBEiTBMTNThECNDjDoYKy4MOUZkxEcaW06C+TKTzJwxa+nMGcsRLKQ5Hzl9xATqDzRav3jtGrbs2bB1oAbtuYnuz7xz93aCm0gN4a0pxzaBHHlqwYIRD2YOPfBCDtGrS7d+nTrg7X+7+90bYaD48HwrmP9L0CDC8NQpXlwM36JDETgMJ4bh2KOcraaSBuWBgUosWOECCySoYCBPDkSgkk4OlZCFIlw1RWGFTk24FVNTabVhVhkaAlYM2pHFlgAlnihXinWtaNcB5ZV3nnfWOUfjc5TN59hlOU6mY4+c//kYWnCgiSbaasqxdhxtSkKWZHGY3XYbcL9NKeQQVhJnGGU3Jlcdl9A9Vx1g2I2ZnYxmjmcmeWqiCWMFD+xlVlsJtRdYSxNRRJFlNDymIw83VEFIf4JmNUdMPKlgaAU1BRHTCSfUVIUYhBiioYUZPjVVVEhp2iGHpvD36R9rROEneHSdamKqqrqlYopxoXrXXQms+d2Z040JkWJ49pllllr6uiOQtlWpmZBalLZaakYe2ZoIM6CwZLSPRTmksUvsFhyPvzbLrJdgkhndrdmBG6at3tWK7ni0rnlTWXK6qN113+YqX7AeRSLoh1+xcEKA/nJQhyZz1GFFHYZwinDCVf9ZegpXHoLasIckMQVifeAVtNYAq7LKsasqsohxQRQUtC4GJqcr44x6xtcYsIvFZluw+DkpbMyVBWktlaYt2yRtyUWrnGuM5ayzlMTOTLO3Xyo9b5lOkwv1dedOTfXFebGLtXpzMbhTRHQeVhGwljUGxUeDYuiVFQmqAIYVmWiCIaeaqMJwp5le6DDeeX/KlKhhVYDxxmq16rGKscaaUOIlo5zy0jYmidi0jvlanHI123zzzTYT7dttqp32ec/PAs3kcZudTm3RnRvNOnGlt9wyt9xGTefTHdheJ+1lVs34d+vi5WJCszaY3qsHUDcB8l/nyaXQmkUR6N6aekUpU3X/wy0V9ndzeH3E3ldCyB/6kWqxuyiuWvirB7VYEOKKv9h7447PW9/Luta/p/2/xj5sY5lffroA4gZZT/Kc6BylJASSLjapO40Ae3OG00RwC6NxYLYmYyOm6Y474tpguTg4Mt6pywIbUBwFBvI+gmQtTnCB1/IGg0F7SQFQuZDe9xR2FE5RAm7AqIqnTgGMHWrPYcHAUCS+IoaNJIYHGylhnLTmKgCkz3ggk5UFXGSBEzZAiyUUYYy2E4IwMqdZzfFWjfS3LcM4j1eaAyDnMJOGnRlwSz9boOiE8MYK6nGPOruSldaYxqaRS34d9KDUpONFEiaSXe/DItdU+ES4zOl2/y+EliXvo60nwIESNUzKVbaniR4CcYg3JAbd6BaVT/pQYVwpYkmq4KdY+kkjGymBCAjCwihKcZe8NFyLzILC3ylymOc6GU6MKab5aTBXveKfGlcWO0C20Y0PBM0Z0hBHOSZrjgkEGgOJ88bP6JGCqBOgH18Hn9ktc0xeZGchmeOBdm4gnmZKCK1GGExIBg+SKlxTLuvCHu3U5GvyQaNkmOiHUtSQKqpMmCid8lCIgnKiPQQGhgohqimIaC8cSAETmZiFvzmxLR2LSy+lyDGE/PIuJNMnF9kkTzHKVJkarJEz+XdTN+q0Ste0lgGV9dNuChWPA0RdBX/TU3L20XWwS/+SIAeJuw9KzVzyJKZVccKeguCTnywFpj//aQCymEegDKkkTjlCwxr+4pNqlWjCsEc3UwJRFaoARisiWsqoUK8OVRAB4NASgY5uRJYoUBAUp6g+E7EPly19XxcfO7ITVtWYNF3nGWkUuaYCcKdt5Gkeg/pNogohB9GawWhDWy3VHXWpOe3WOg0JVaoiUraSVWRt0SNMdWm1n4y1i9VIpDWA3oSsMHwP2aCwybaq9ZOhHCJe3bqhh671hoLgQhI/eksE6IUDJUAJdYrXFsTKRaWKbSxveUvMly6SkDKlQWXnkxwaVQaTm91psXJGpAL6JpsRhNJPryDa05aWNlUqmmr/QYNB174Xtu4kJG1vSzUI/6W2WeNqY4M3KxKBVbsKEWjycnfJi/gJJMsFVS0q2kMeQvdu0m3r3ATBVx5YkolREEtH4cuTwIk3vO9aqeJKyBetosmL9OTdTMeo4NfODrP1ta//asaZM1QzdUzI5pMwF+Ashxa1xqLSFsT5Gz4ytXRPVbLuYitVIi8yIZJN4XkZ21uAcvWwgO1al0J8UCz4wZNXmS6fRwIMYBQDlGwtNKEc4Qc6VAEMQAiBvzzakY3I568lTR95V+q+3F71weYCwdOSPDqmObXJpHZylEmD6vzq15o4uxaAT7sE0spawLTOshzBfNTRKJW150QnRNS5/+Azo3l3IBRhmyec3jcrW2QttSJwBTcrOxOXZX/i5HKvPcrnSvQXq+A2nyPhB1hCC7vmQYFHNUKCER2WcJH8JZzNu7jHylbIsgXj0sgIbObFF5ql7uyPOPvAa6L6WGH2L2+kHGYAKzwHV2i4F3SzcGxdC9eqPXDrhJPGfJs52BuPaqeNveku0jvIW+UtszMNvLR0TLvD9bB7LAOF/Vwb28plq1o7WYojKtpPYowBD8AgaYs8ZEEqtzSP1dK+fSp7mOoloYSLfaZwRdWyGq+jqTd39WoeC5tJjWNpxGlwB5pBC3vonMPLEIa0P3ztatcCG8Zu4M8eDWZJpjrHO07svP93p+khx8nTFwdvl2YasMNLQNFROoDhOSgDyAsbfjiS0LXmQvKnOHGgvX1znIN70RvRqAlwQh/CfjeXiH3iyZmN3pIjezwh9LuMimwuqNXUtaZ7ZmY36++59++++0W4l7d+BDYEn8pUQjvbH/72sSd/+clve9zn/u+Y4S+Dd0cydJzzWqmWydNQnyxM5Q0/wSd9/Gmpc1o0NpcCRHvaefp5JHJRxMn3WSQWhb+LYwyEGmRphjIed/8FAl4m1UstVEUkE3j5tEUw9XS2wn31JnuzZ0b5Azm7l3UXBGVR5nu/1xthZ0G8cXzHFwfOB3cj2HxxV3C6tzJ4B4E4hiQtqIL/etd9ttV36zVh9pRCBrhF7nMWYlUWhqcxK8cg7Pd4PJBcwWCEwVAMglYMwQAMTFgKjgAHX5B/szYcUmCFsTQRF1AiU3QqGMZPqYcmx0YeM8gd3Ad7IFR9daSGyKEr9OIQgHSBFbgZuecZZXc6CJdNdliHp1F2HPiBf+gFIQiIgTiIFoeCdUdTzIF9MCRqi7hOyTQdDeh9V/V3rscm/nR6BaiJaKEAneiDHKN+XFM7kREF2FQHmXB5UZEJMNYHcDCF/gcEP8do+edoKrRuAthLPpY4u/giIUQeTydhHgBhUxVT1md3j9Mz9EUzcph1Aud1GohUcLdHUSKCyEeChTiCeh6odU6gahN3Qcm4cWckEUjWMteXfQ6mZpW4aRSGW/aEVZjYVVVURYpHdGhhPIE1intyA3dIB37AioqWdoz2GidQhbE4i4WFARBwdDumWC3ybhxliSgkhsfmHWcIiRZpke/UiBu5hr82gcwIfdGXBKTRU/u1jdDYGwEBACH5BAQEAP8ALAAAAADgAQ4BAAj/ADvJGjio4KBVtdSMYvTA0o5Ee3bQmViJIp1kGC1WVMGxo8ePIEMqEqmpJMeNJk2+gNKDl8uWp0pWpKigyylhyfx4iLJmDQ2fGXgGjUIjaNA1O5KuWKHKT1M/SxNhw0aoRjoT8bikaXCgq9ciX8PGGBs2kAl4aM2SJQGirVtYbyWcYDG3rgu79vBC2CtXjIy/gA8Jlpu3BCfDhfXl3ZtPn+HHhyNH7se3st4Agu/2K+G38z5+gEN/3kx6H2nNqAfHXaD1bIvXsGvIhpeVNYMLWFvrLrR1t9YpXG0I1ywj1JXjyJMrX868uQbk+ZR/nhHd+fM22LNj2s59O/J6oZPX/2MOXvI+eer2ETTIXiFDqEpnyp+IMaN8kvhFdlzJ36PNLhedpNJKL7kEDDLMJEiTJiupYAlPEEY4lIQQxgfVhVFJ1cdrSrDmIVdirRViWWcBcAZcIqYY12J2nXYZaqLJoBphpVF2GWQ4mseZZS+26EJjnsU4mpCm/ZjakYR52KFrAzR5FYcoCnCbb71R2VpwwxEng3NcMvdccl8+Rw8/1CkHHnVleqndmtxp9yV4433HyXJbmjeDPBCo1157OrynlEQaUZTTRfPp90J+h3KU6KL9+SegCiihYUhLBR6oIDNPdYFTFztEKJRQRvlEVIUWPtWUKYlUBQNvUc4BHFgjxv+q1hkl0hriam/1qCtxoQQ2Y2GQ8aXYsI7lqKNfPO5aY4zGDukrajMgKQGISpaI1qrYugoCFz/80GG1vpnhG7WZlTZnl+gi5x2dadJ5xWfLXddmdv6wmd0VvRqH7nh1RncndZCwd8stBfEwSp+WYLjDHoHmVN+gke7XKKMT92fxxfbJVAmkKU1aIBExXepUSZt2SuGnn/5E6lIzOQWVKVRlSy61sNZsM1m2mpizrXGpyOLPypYr5Iz54Ggj0Ds2a16yWfq4LJFQD+1ikh1Qu6QSuVmLVVsCWCGAtuBaeSWWQteZrnVhkpdPu+f6y8+7ampXr71u7hOn2u6SKVfRAc//AsksA/+Nyxu/OJAwhvPRpyikC4LUHxQWg2zISpNGTjkRLB2a8X+Ns5RLAi9ZGihHOJnsqcoph4pUqQpvyCrNN8d+s6s71/6Wz24FPSyNo012dNV55gg0sEovzbTTRjKrfNRFTg3Xtx+mgTWTT3arLQzeWq2bzl9vD3buI5jd3Llpxz0+mdWxi7bcdLMJb/nnl7fPBuFfQXDggOdPuOGIBypogDTZjzBagrkCEtCACExgAhf1KABFymOVCpnIODI5qHgKQkP5Cep+AhGWmSoiVGjB62AnO9nVjnu2w9WKdKcXeMWIL3ApGo6AZBkgFe8wd6JR0IK0POY96y5Vm56T/7qGLexdQDax2docrEc7saFQZ98bzl/OdzYwwW9t6YPbcdgWr+20j271SNO6rjgn+eHpR/YTHBvYoMb9KQxQ9wnQwza2sfoc8I54VODH8MjA0ZlkUgoBHeYkmCkKJsN0R5FQBlA3qtV5cCYwg1LVSFjCmz3xibWJIu50eDyqodFoNsrKXIx1vMd86VjSAt+RmAW3MqJyaNOSXiGGeInbILEGVMglIZKQBFWtinYFwGS4hBnFQwCmimqyYpjGhEXmTAdd8/oidt4FiH1o4F5XhA76OiCPMvVNjWscWJ8q4rKk+DEjGHFcHntBqT1+7J04gFwBExXHlEjKJQkQpOgu9f+fCkbBGxjsSSIDCiFHPnINkuwNJSvplRNCMYUqVKWuOLm8HBLPeDqUoY5Q2cmmaSlGcAtPSEUDw6xgKza7zCUvVRrCW/6SK7UaZveu5r2vZOaY2gTN26CpLnWdMovIDJO86CbUtXVzqMdZ190icyf6TeebbMyfOPHwif757yQOIydH2MnOURChnfAMKzwjQIFJTY5jDfxjgQxEyEj1Iic7aWRP5KrSRppiKR5cSga8NsnoLfRVJCLmiZqoyRXSxaPD4SRjnuU7YWmUqZa56EaD1VGP8hCnkgmp/DQTRJOeFKVVQaLXrJct6BFWptMTbHDCh9ktcvGK5RPqc9r10yr/DpVNPp1t1aIzxjEeR36f2S28BhbO4oZTEVXF68ISB8CM1fGrBOQqdHEAVuqK9SVQaEIV8ACTlKBkQLxQg0LYOkGS9UAYSWkkUYxSAbpy8K553QENrPCH+vr1r4C1mYnExV+HFtamhk0NYQ47yubtDYcQ2EAMDfPTHTn2ho2t7EfNNVlUjiCWnr3WZzn0UrDRNJOn1Rp/RVxTLAGmPMDN7frg1yXxaRGa3ektNbkJVDPh6zjFOQ+Nz2Xcv9miuHhwkHKZ21yNbFW6erRukt/5Agc4gLsgSytaCfS50LV1I8k4rwUvmMG6shS+TIHKIrdiX/wydB5oTosZgjkrWclO/zgEvgxiObtYBE+rA5shn06T9dgKG7gtdZHohBmc01deGMNzMClvPmzaapW20aglcYkPPEUX7tS2KtZsUJ1DjzGN6bfswtOOQ1GPUus5py5Az1GPg7812uLHfQvynxYWZoZhuT6EkmNX9cjrr4q1ChygYJQZR0eVADK81N1nALMsjEqkjqBeLiiYV+CTEd7XzZZccyZG3GZs20zQgZ6ocBu74EtP5mdJ87OdBwznOCMreZDJm7PEcGhPtgV4fb3v9J6U2rAR8d9dU+0C8CyakNI20yqWbTMRzoml7lRfPKWTBBRMcNb+ZammBoyo83yYD/wCF68OOaxnQVWHzLpQ6P/MqhyzPE/+yDNzL5+ckhE4BoYwgiXD1hhWV/K58eIAJ+XFyFudjbK5tleD0e5gRCyQgTJfm7DeNtG2tf1EFS00zogFN6I/CRjgufCnNeyzn4Go2DnD+9SFftdowsf2VP6qs7Ms4kkDG0yAA5yYN91Sr+BFavPJ9u9qBypsX3w2h+PLovjODBeBa9H3ceIGH9CFyEWuixSI4BN/ms99IKVyiamg5YN8uehFP0/IYYEhUDa9zv/zAnz6/FBBZ7YKRIWyonhZlz1ReqqsrT2oY5tWBcgEbgTulvyyYGZm1/qHuE724J3awbyD8LrtXbaPxvt8P2x7ud7uISPOJrVH1Lf/a0gsaQ+dvbV+7y1SjSp47GeRxaaOE7+C2wEFdyjxzj+xr4BHHcAYAPKSZwuSpwsDWHOYZyGbt2yK43kYczGjJ3pjEIEGmHr0xHkP0wPiJUg9oGy3VjIFZXTr5WWL5EipQl9O53soKCvaNnxp4XvHd3UBhhnh1m7CkWiJFgAvFH161hh8IXag1C9/QX1z1jyPhTewtH10hmje11KlJRuxQn4xBXUSMG/FAWO3hVtf8i8JJ1vMpGKftlSEp3aHsAFKQIYfQnEWl4Net3ZhAARGMIC64AsCKIATkFwnR2TfVUcYEWXcFWR+GGQR+DguBwU68ICAaCAjETFbFV5V9nMI/zJBewhXijRXIChQuXRXJahQaRZ1CwVMLEgbNdNEt4NmyBeD7EaDNtgWJKUafiF2YVc8OBWEb2d2Z9clGScj2ud2MGUFr1EUttSEDMA12gJnwFR+3zNuOTZF6SdN8pIP6bGFXJg+9AA/n3Zj7DKGjHZ/1SeLGGYZbfiGBBiHc1h5N3CA5lRPRrZsDeiHgRiILjeIEmhAh8gLQbZ65pWB+nRlNjFAzRZXogIUFXB0/yiCJqiJnNiJUldLahZixqdQAZY7YoAZhpWKqph9xnR9CAYX+Sd9+yeERrIXP2JKg6eGNEg1z+N9sPFo8XBEP4BouJJoUXiMqnh+LvZ3bDI3bv8yW82EVICHRdOYNmBojd8BHtiYjWTWF3ehfZ1FNazACuAYh74QgORojmGGh3m4H6H3h4IIj5fjctiFB2OAAeEFe3kYZJSSCwYCBQ6kIHJUQf54OgOJdLkEJQYZCA3lbSSUkFPSglJIjDD4gjMpkXkJRdXXNM3CI4ZGYdPnkSAJb9BocH8WSzPSfbzIYR8GCyuZBC25LdDzkpO2WnfBSo9JLzhJN85YjRrwkzbJTOkDlNKxdyMVACcoS2NTdi6JYUaQmwEYcgOIBghQCUNmlcy1h3yole5olpDDlRFIBLuAli/XnKqniGdpZbFXOW9pe5bIUqLiDSJUlwfpZno5dQ//tYkNUIN/iXWCiXw2OIzScpGHuRjF44OHQXYP+WCOh3aryH3RgzWV6TWQ9i27JAAv+Bue+XQQKZpb+JOkuaDZsZNXmJPMJEbTJCfaVGryB0T/eZn41yrRgwuDUweT92q6IGt3mIcBpI5bqZWHoqIsCpYF5AhgCZ2++ZvFNhIYmE/5qABB91bJQImUGJDZaXt7VZDk2W14SXfBt5eD1Xvm6Z2lOIOj+FCo4Dxl83z2eVmt+J71uUpo95pFop/72S3+SaBwh5kB6hZkWqAUCZrw1jt69qD1Eqel2aDOmA8KSlRglz7YdHHapH+4KEsuqaFY0nupOASGCnIhxwavxgbj/5R5iUNs55SVLTqpjcIEUhAEi4CpkgB5nkOWEUMEGegSXuWpNNF6yaAJb/mjQbpI3emkKfid4SmlVpNvhApg6IkrtVKeMmh2mbVu5sJxokluWwot5naNX6oapEib+5ZQJxlwmJlLJiCM/4VtSPluX2eTpCmnczpNWMQ+eMqa68d3qDYkh3CUyHo1M0Wm/uYhPHCouiBVgLMLBggfj+Q/j8qA/UEB+ooGlLqiitAK+BCwX/AFkfAKjeAAOIdcVUVOCCApOPqVaMA5pDNAk7MTqhoqSDekrvqdJsQ9CpmrTAorfwAcn/mkUZpJNvBuvNqrLJJuT4ORYiiZtmmf+Nl/x/9Kq8p6LRzmaDubCbwkNghpq9soGdiqraVZmmPyjMxYVK25Ls+kTf/yL0tJnzmroUB7qKIwBLtgqFk7qr/pqMyFjviqlfxKtouzH5YQCv6ACGuLCO6QCkEABBSQbMilVQ0Lqj3HVqcQExLLj6iaqqtaFEQKOzxjlypSuOCJFrXEgsk6q/V1Z/nWl2qaQiqrSkpzpVRYhBilkTPbg/cJmYjHFVXrff0Zd+lgSz2bCIlgjDAotDZSi0VrtNraoOrgDjeJp1hEHeWzd3bzWxp3YRdGm1kCd7NktUbJBW+QvKJAiL/QvGRwetplh1Vpr/e6jv1qtksQCqRwD/eACGxbsA//gHOeSqOKYAh5y1Z1qyATWzp2kDJxyaqLtrEcO5hE9H1F2rq1Oq39BrK/QzbEwlF5ZiPRopi9upi2iWd11jZMdbNKaLoo6VK3ZBW1wgBaoJngB7LUCm7o96AM2gZsS6fX1ME5mYViBLV8qk2DIRjCi4qjm40khgHJ27xb0AjSUMM07BDSOxMqZ68WGIkr+ocp4Hl/6BGNQA+IQApH/L2vgLCIuLDqG5bilZYv8CBSEAV2UFUT6yAfmDq+SF9jM7+3crJJ6gOXwGb8lb+AeZdfPIrCWEQteIomS1mUxqUIem6cK1HluYaXWxnPwxoO3C0RjLpJRFNUsAdJMH4Bh8Gd/zhw7ga8bppwt7ugahfCRouFgVdjQ5IvrjQCZ0S8k9nCjGZ3XdO12TUMHAAEKJDKCePELENH9BEorqyHKWoo2GvESOy9+AC+SqYxlfCbNoqWu5BzD3LFf/QC/XiduNfF8mt1bNHM51mMY2zG4oLGg/mqjiaeKJvGTyrHyUPHBcdRd3wCVMu5IXmEJbWsgOxSTWhaWMMahUwFoqzIi2yKj5xbkXwv6EHJIrynCwdqZ/JM+fLPotZvKaw9iRyF8TzK1jUGZPUIDeEQOGxVueZcWrW+FYMoH+EBRpzESmwAOKAQhtDL5RWWzAuIZ6UCFEtAkrjFuqSxy8zMzkxCLByeSv96xtScvymoYU6CuGgq0+L8GKnBjY1JwAU8F+H8yTpokVSDrrzhxkd5x82KmRAhwU3CugwVUUltz9I0A+pwp8wYoWiCY7y7dhdHrnzBn1xAI521GwfN1KI8cxRwyjRsqY0gERJNvRWdxRPDCB3B1/ihCUXsvYKdy0LQCOKLee27E3awBIzd2CLA2AySQOz0AsBpOqs6uASabZukX/pbIrUUkNy2xukatL7n2Sw5ALJ6055Bi4hJ1OdCb0fdpOTczbpYpiB21HA3WktyV58IhY2LvyiCf6HpeBzMrd3kRUsbs9FyobRtzgsgM+cKym791ssbT8DAAXaAqXTtAQt7jjv/7Edy1JXY+wmQDSlLsNg7cN7ZjQmCjcsF2wwHwgHN0AhWTNf1vdhzfcNnS7Hsa7EWO5d0+dIxDRaooM0o6Jc0XcZUJ9pVV80hprO40WGBdeCVqxeKRYSXu3wmqeFuF1lbF9zUZxvp/EstUMFtzbqaJIX3JdzX+qBXoGpaTVT8sBf/MjSc/KVpeGj86Z+Qu677e8F2BwxCPuReYAA3fMPdDUffXb3EWZx+6NDZXcXnfalHIAVHMA60EAnsHaf4gAly8AqW4GTzTd9T0b743dg4bADky90b44H/DZB0adNXYqTOfKtkEdpRqrgMwHR11+e/3eBiUdqIfNryfL8UCdts/8qYr5vhuH2bG+rhIR7pftwCvCTBtfHOGebbn3ng5od/3VTO5vZTG7ABTcuTRYUeU5jJUZuUOe7IHbDjmF21QJ7QATcMtk5WDQ3RdZ3kEsF5r3xVskxzT84EQpAKkRAKUrAE40BqoXDszB6wcloPfCANzSDf1T7fKGAKqkzeBhDmTgZsvowCUZDKKZFeRmeZ8VtixjfgWAeY+6VEPa2XoL2CeL6JgJ7Tps2SC1mrDR5ocOyRrj2fPa6m+AY+kk42G441uKS6NcDOSaAFLeDHmq7uNbXpnX5TD2dwFHdpgJc2UhvWA8wjSJgak96qPq4bTi1iiazKHGDrNsftq9w/kP+K18YmqQ4iBanA7MiO8xba8+OxHXEaCnyAAvLtAdd+7VCR5t5OvswwzGyuMSbDhOmOWnReM3Ze4LsYk9ZyRAE5Wgp+0CQrcA++9bRU70VadTL776e4qwFfUgRf8Fg98CFemStl8q3B8Jjp21pf8WC/xmeIwBY31q/uVAv8mHgSD4RPn5BLNEkI6/CurOHS1LOernW99On7m6zcyrn2ymLb5IuyA+Pg7KUGCJZqHF3eaZjw8zEm7USPDUf/+gmy9Fiso8yg2N4NKZ3i0tlo76nN7iWJF9A83QOASxYw4mLKRLKu7iJmDkbUJBGeyHzf71C9pUMoPHLf0wY5MwYK4nv/UfIZixsD187PjSrC/+7pKlgTr+IsruP3N8DfLHGjnicfWfAD9+iQW7+x7sK0fv5cABAoBBp4hMDgJ0YHD/rZ4afSQxV0ItJ5SLFipWQqNCYz1HHjJymR6oVqBSiSFEtCIokcORJTPUyY/MV8KajZpJs5Ve1kptMSM6BAu2hiiG3HUYcPd2TIcKSQEqhcos6ROs9q1UBZpzTgSsIri69gQYhFdcKGWbRU4a1l23ZABQtJfgCA6+PHXbxmtlYV0JevWsBq3V7IVHhAAcRX/+oF0HjqgQWRuXboOtayhMtnMUNA288zJ9AlxHCGVTpzGsWSVVNlHa+169WuB7SoUZsK/427Jqh2gAojcg1TFVTrJl7cuGPkyf0+Th5Y8uYRZik/7XCIswvs+7Rvl8Ev33be1WX02xw7/PPJ05/mjTyVuXsYy+UzlhrEvrRG+e3gb/RzIdKNLBLwIoo26ogIIl7AQwVLWvkiFECiQIEJgYQYh4kgAAmlJZraoCkUcXJqZgURfUoqqC5OGepEpVZYo6mnUMPqtdZSK+JGssrqTLO0coTMBMSCLOyMM95KQi4z4rKgBSvwyo2v+Y6TUkjDDkssteay3I2yyrj0cjMer7tONDJJ+9JL82iUDTY2YYuPttuYjA8q06SKDxYlktCChvaimlLKxYD8E7730pssqurEHP8TPPAkgC278tJMszf2+gwUyjmjXE6qV4TwNAghrJFC1PsQOqihiyaaqCKNMMrowAQZlGLDUMb5xJBTELCDFikUFAKmmFySKSZ5QizxJlWQBUpZoYai46idVpCWKStilJErNSHTdtscAxjt2/G+7fEytaw0dy24kNQzEdycnEsxIQc1jspzD4NXy0KvQtPQ08C0R8wyzcws0tguhe/N2hKudss6C2nSNyVM2aMGS+XFF7kgAb34sd/mPPM6eaKDIGTKzlNU0mtTJu7hdw0mtK9MNVbCUz5qtnkcmim86MSMJBrQomQwUgFWYRRcYpyWeo1VEHmkMISXWV96aYZQOkT/wlgTg1IlqBEZOsqD27xhamwY07G24G1Z6zIzb7PrLrSAwwShXHOd9CERdffYwwK7GJBTU8Dlq3JwtuzdGNCU11Zcbn8hJfjxQl8u/C7bqJCTX/XeLIQ3vSF2T0uL4w1c5mtjTvNj86zDdkaVAyfM8JcvhVnTa2nu9FP7grDDv5+D/plAiQzsQRiPmNBwpHF2aLWMWhHo4oiqr7hiBkDkkT6mfI4QSIs9hmFGb4f2uMkUsPug7YgjqJVT/fXOXi3txcWyru1w4YYbu7Qcnf0CvwnxP1117SQJfbuEk8xwQNFl7FzmqNvrCBcll+HrffHr1440UyfMFUw5s0tH//7H/6Td4K88MDOb2TpgBT8kYnMRHJ1jDNjC0M2HdVjRYFVWpzLZcXA2BbwS6TClQwSmRhJDzA8QtsABJCYEGSqySFJ+VyCMBO9VxOvB8FSAtJaEAiWasIP1itUHeQDrJRvYwAyuN4MWmAJZehtRM7DxQTnFqH1zZFkQGVMZ+OUxR/MD19vsFy5v6Q9mDEgX+fB2pPgkQoB18QENHPm3BkZSkvzzmwN5CLoWzlBxFBwYuTJYMT+tjEoJq00B4iEBkakOT1BZ38L+QIOJgdKOmWxMJWEoqFvKMHaRk1GW5gjEHfqNlj98kwIXxpgbJPMXywQGFJoJhY4IYyi+k9YKeAKRAv+1KiMaoSLxhPGJP9BqJCPIwCeg1xKqXU8D+yBjyKS3gfT5740f/OCc5HjP/YnOfZbRI472GEiAjoZMfxQXtmDAvyMdkgp4SyRF2AWnRp7PgJaUJAPrVkm7uWWWs/OhJvsZgwpiEHJtAmYw+3eBFaISLZljWQlNqMgWqGejM9WUMHNJqRjiUpf43OVTDti+kiosp6Es5gLtGAcMiGIIu+AFDpr6VFx1QRnP+loUbmPVr7GoZyniyKsqwTxxFisKYN0Qo2agP3O0k4HkcBj6zPfWONoTp7N8YcZsyM+PMk5u9Bto/UTIFYcREi4QbZIiVfHQviW2BumYJEUH9zqMIob/h/rMpLU2ViM9Pm6TpSNqUd1FJ8dhpk9F/YMZQGgFiVlBpje1YyYYYFfWlvSnGJsPaWnaQs8WhpQx0+igJFmtIIqCqTxIAC+K+1QcSJMhhxQbjMg2Nqz6QZvJmOpQxkoykqWvOthdbczkao7erNWzxvFpEOuKwCDiNa//5JE/wSIavvpVOjgt7ACtkIRFjq2RcSolZAsYWcKYz78Alux/HdjbYXo0W59kcA51usB/FZRLqAGqjB5WWmkJYC8bvK15Ixpb2T7JvCFuKQm9S+KLCrW3J37wb2e3iwTE+Li4Akau/PDG9DUJfReOUQnJtobwSWsNL5JTGf5w5NLyNLy6/xnvXM0gm6KO+F1SLoBdTPvZ3YRlvXp1L9viW9A09GU9QNbCkfbwLP1GtAJCZdKAHUsI1570wJSkc5XySbvP0UeCDUZPDTtrW5UCVLSjlWsaJPqHNKpwK0DtsOAu0UjKIrApx6RyvVDs4hLbdrwpVvGmI33n8wqgih5RwE3e+ARBmBBRFvaNDf6waCQfWcfs+6Wslfxnyop4ME86zKNNKekEUm6yVsERHuHH5S6bxst9JM8hADtmvUks2upLc39pQ2c5mxTb/QW2gedsTBZbVs977jPKetpZ0HoGO4OGcqHnUQhqoSYDe1ChrRtdUyuDOt/ABne/L53pAgOcxZwu5f+uLT2lxlrJDziZUB/EwVYyRhxNmF20l0YA61uL22F5nukDh93iN2dAwx4OuLcBoOViZxbZIK1gZ8QAyLNYOAMKTQT3+DZrpsTJXf3tr25rEOeTcrvAGP22v8PNcU0mblIZB1SiJHzDJrNyzQtT5BqQfO/a/jffdZxypUcZ8H/vPOFGz+1uPX3ws082XoVgayGMTEbKwH2zaouUs9nduiUXk4Ulr+XHpTxZNWdd7Abu8pb/mez4CVp1V6l2IsrnY8JK1M1A3+22DUd5otf17DP93FRkmjKmL1nJkwltL+l7F/EK9rSmoAOfBIn12e23SiLPqA8OSHuBV7lvZJ/o4Hv/H2pJVr7k/sV0MH1/pucgX71jefWgb3RkqOO6xNH/+2ut8vXbKnbr6NU2AbkgljzelcsrX9z8VPdqK9CAyNV2aTzFBkmK8jzoQp8T5glcfOCGfk0cQ83VbSj6jEuDkjG/8yOmumoBPaGBHrMmHxAtEJM93EsgpjCtD/uBCPQ9DMxAb9vA33OX7kuxDEw4Dlw+ZSNBlgM/5Xu+e+G+4Rs3Dosz+qCXtkAglKJBrRO5A5qCwQs8bjG27/Oy9grC5aM7uTmymbOv50rCsJG8Nps8oHtCOxs61fO2TGsl4HKpewqPDYiMLYQKI0u+DujCz+vCqNinxnFAAxwv4AiOqkgj/1XIAGcLs4ELKr6xPQKywLywsnyDNJHbPdnrQA/MNq3jQPgDRDqrJ8tjGUO0mxHkJx95xMKLRB/coAFbEiK5xBeEQa3wt1p6LMjat3kYvkerw0s4uZQzvD2SxBvCHP2pgPWDqJwbsiEjn/eTvOBrQv7BMhuEQCokISZkkh1DH4iTO+76wgEkmeqAPmVMxmU8D7gTGPVoN81hrNehxppbg2PygZ2Aw70AphXTvUcSxcwbsHahFj6ULNsbktuTQkL8Q7UDPN9TvakjxBCsveODRHyMOVU8xbTBmE+Ei0wwRUykRGHaRE70xDrbvU5kxDWzRJRbRchgr3xkPojspPuauv/0e641kBiKOKxahCTxQhhAFLxKUqxIOh+x8QYpEAQpEBthpIUyCJmzwq4R2C6ZpMnoiI5Q0EmezMntKhlkJMMem0YnETDb4B4m4Y3028Zny6WMrEP12cD5G8RxNMckAUfXWkdhu0Op5EPtc0KtI8WprEqyjMdGmkgdEULw48cT7Ed/pCTZc0uCJIwfAbWviz+vJLlHE6y4yIS2dMvCU0u1rMi1mbl26SCN9ABrmqoVcMlWMgfwkkPpm8O+oMqPwzkEFBurwhAmUMlUG4cyqJ6b3MkZuEmZJM0RIM2wSk3UnMmbZMahJErE3DlCsDlVgwELoINYSsNca6Q6RIwM2Lb/sSzJ3XLHKgNO+/tKy/RKrtxK55RH4SS64aRHRiwgiUxLtGTLSbyX42Qk3QCLgXzL16Eb3nOsq7TAdNzFsHTItbyRxojI6yQAfCRMfqkLzPwx1ksRVbCDhcKGeSo4cQMlO5kTHvNFPMSLwMIL6IqC/WhQzuwDKUAf0JSHMjrN0hzNsFJNWmHN1iQZiWsrEJ3NX0RP7kmEFlg1MnOlKyxPJWnO6dS+r8RKPzxPGFVOXiQbyulD6CSlm0PHF62z5czRsCyLsMBOI5XP+fzL8HvLFhXI8BRPFzQ4eABSvNTE7oTK33xIVCQ/pSuCiSOy+7wqD1DMLiian5m2JYwr9/nC/zWVzJbCvRxlCrFpUP1w0M7EkAwAzQkNow0JmQz90z81TYkzsrZjKxH9Rf8p0aS0sERIhhVQUeAiO0LCG698zvljpMBTTh+9URvdy0qtNk7lUe+01B8t1ZI8UlRNUu1cUuQYxR6VSyiN0slBSPPkyitbz76UxKp4RCTt1cEkzD9wtj98ykJyvPzsiOqSKmVtomoypCWktjbFuzelNgj1T4HQDxTwgPzYzJWUAj1tJ5OoHkAdVwih0JAhI0CIuDIgB5hkq2CcTWqcVKS0IVlrVFNQURaUwATUUTUjJX8V1VBlToWkUU9dT3711H71TUwFWPn7V1MlziBNVV+1IFX9Cv9WdSG+RKm6DAx/LEiQ8jp0SUQbHSV5HCBTnES0nFh9HMIugTeMjMVZHFNjVQYzJR8nmiqa3aoB8ZqqkkWrwtECvTrgIqxqvVajtdNu/dZxCFemhRCWIFenZVpA0NOaEQT/9IDOfDhy2LH1qc0yO9H+Q7KZc1QDNM8LuMZyNFiHbUhHClhehEK3RVgInFuFXdi6ncfofNEaRc+9vLYakFiVrViWhVWEsq/LmlKf+07ylEH7g0GuLDjMa9L2TNmzCNyV9ST0yMgmiUUzEzJpOwVpApv0YdDFfAFpygjUVVad3dloEzJZDMdoZbv0oZD+sISjbdCVpNqpTQXeTddUKIP/3w3N6omEkmiFViAJ4jVeqcWZUJGGmxiGJeKACdHarXU/RW0TsV2BZPAAoR2kd0SMhQoOiE3YGjiShWJY3EhfR9K9TaVbUHVfuXVfuxXLrWTbHR1LG9U+y91fwb3YcilYu+JYD/s5J62+wTHVm+s7NSPFVRy/+LxcgrkWV6tA38Qb8AmOjcxZOsCxHfMGMtsaDU5dEV5dVaiunTjhaDNfjLwnmJSCBh2IZmgEzhQE3QVN3h2HG7ZhHeZd4+XhVsDhHu5ddeAD550EZPiFGqOACFhiFHg4WqjePlgoj0ypsEW0ErY6pVwPDwwm8lkzfw2bLx4g/mpbMm5bv5VfcCRf/7qdXza+W/tdzvFFX3kM2MDVhzr+VZZj1RphRzsDnScsYANOXIjdwCw1qbr9wV3lkQDIR8vdRxsoAgFgzlkEH4+kghKWJlPwhndtEs3Ehoc4YSmiLpwV5VEuZcYE5RR+KB3bWqutXYKI4ZW0EKoF4hzGGRyWZRy+kB32YV6+gydQJmZS4mWC3jBANa2NYnpbVDQxQu01hWDNYkU0jElFpDmW4/K9DRV2Y/W9X/lV4zZuUWw+X7utPG72Zm3u5jrmX7L4KP8FEscaz0z02I8N5MalUr6sAIjh2wq2gAIAz5MNKMoVwvgxtJeNC2mJFtG1ZMbEMTqazf6MWWkLMonW4P9RRmWLprdDehEMcWUDkOFczmWaAWnbsR1vxeFurZlZ5uEQ4INfXqY6EK5fqINlmulhaAZUe2Jy+KAYqbsOgKXtfWaiGpxsPuO1DeOhVkL2i9tuXuqFDedxJk5zZupvrgA7nliAXmQ8zmOvaGdBQUjiCE8pBOQHK0u9RRIuQE9GotQpiEPGMAtxsbsHhmBs2YqY61s4qbkLthwELOFkDlA5ZBnJK+PaOGPuQWEUblaLNuGFo9PaleEbxp1uJRXIJhVrqOzKHofKzhmcWWmWXgQgcGnhSipRqAPSlulhuAFpsJBChYG2q2Low6+fnsn2INkjWSwh9VvcHlEr+aX4gDz/qRbsnHvfc8ZUp/Zih43fqAZn4nZq+bxqig3cVeVqxJ1V3yI8FRRPyC1J+qXKLAWAt2jbhKKCk0O/dIM5AlRkiqUg3CRqvHYRM87PvfEcWcK/FVO/8M7m+77G1k0KWKZdacgdAM+dUTlpyg5wy85smllpHg4CEYhp0V6q0C5t0w4DcagZyDRU6mDGuAOyLlgBJdjJ7kJMw23oQotNNtFwFFdGJVhRwMZRF0+HDmYSpC5jKkjJyinq3x7udPmf2h4g5/5x6FZS6TY4dZxLYWI+I2fHOD5EvkGOsYmLQ/qB60aNLztvK78g9U5b9TvopZBx/NJNbNynxT06O+E/3i6p/4OCxZTMHf/+7yHCkAMnaQOf89x5BZFm8Jl+6SHYcz7nc9IeBiB4AguvXhh/RmY8Aj+gWT8gh3rYh3MFKjiZC6dTJdQ5RgLsSUw/v0znEZHxUrv79BS3t02G8dwmBDEebFJl2NqunCFT4fAuXwsC8iAX8osFnFxEOHOR5yRPzuMG4L3IOSivOdtDw3mQgCp/ayAf6PElM/eGcVgC85apIbBGjjymOPqsdgEFUZy5j/3QnW4P8FApcPxYhEWAczYf9zp/BUm4gTGgaaXqc0iAhD7/gGFIbeoVxnYKSm9AANPVBG/wIqFkixIqo0ZBvkFVAkJNeGNceJzUSXHKokaHeP+JRydakYFGx0numjATH8pSv1v8Dmf8rg1Z//GsHnKQfcsWFOBdlOaMHcttY7x9vkYr2DDieC8/grmXM2+sRsELOk+Iqrlmt+JnwWfx284nVdJOCmieDkPgPYJRsVNJMPdROfBzj3qrv3pJWAIReAA34PqO3gIHXyYj+ICk4vN4hwM4mIU9r4N6F/R7h7hHX1cP0ATTfYFFr5qf3IDIHPgYQUnwDptOrnH/dDz/FHwbn7RhNLKefHiJVyd1EiOrEZYO0QDskR7QuNCRQUYHJNAW73iQN3UxTgIgR3bFm9x+2uPqhq18rbMVvL3shupzrFRI+z4dBHYL3pNivxcQyPn/+3Eb+RI0i9RD8NabcMzN1qNiY5tnrRjIwqvquHbg8iCjJ7ZaJnDzcv/vOX96IsJ6/gACI7oBR2iCCZhppNqF0B77N7iFWzh79ld7ti9mrRUHhytUvWc7JmCGbhIGFKCF7wCIGQI3xCtUI0kiUwpV0VHWxSHEiMkcCqMo7CLGZBUfPqy0w8+OkHaiSDliklyZlB02AGoJSJ7Lly3lwZxJc6BAeaF2zqi388qVevuA7iuaM5RRoxBoHlrpdGWhqOmmtjDZIgONDN6ocKXiIsAhsF/HkhVrlgXaImlBqD0Qwy3cOXLPAKhrRgBeE/D2FribiS/gvH8zXWJQ2Mw8Lort/xYoXMPwBceQJ/uo7IMwZsdTppjJajnhHgsAJEhIYxpvAxsuOLEuIUMM2deyZTdlq/p2mh+6f3xescdUhqgtTNExZaXDPOSp37ZlHvc5CbSopkenvva6DeknrGe3TfopLT6Cgkgrb568tSDqpaRvL6kR/PfwgQAxYJ/Djfwf9r8ZwiOBKDwMwd8tBUICRyeyxCILJEPU8UEYTzwhDoWC9NHHSeSY1AcKwvTwIS89AIMCSjBpiI0HDJ2S0UYTufiiRRNlZAiIH/Zy44eGXISHJgj4+AmQlghpiQceoDASkiN5UyRJTDjZ5HpPOikFlYIcgWGGGtKSUkqAqHTTUTmNMP8mmUyBl5JUJ5kFG5trutkdnM0t59xcjPnVV2B54rlnY5FBZqdfhj3mZwWPWUBZZYQlatllbWFVaAWgJVIAaZspkdcCh8jWWj/fhTXbWG3BaYMZLQxgBW+VSRqcFUn85oNpHXxHZ3S01ioqd7lip+t2u37HkjnikXeeHeep196w5oUhX31b4KcftPxh4J+AcRjxAS4GKrggg/4ZkcWyE4534YUmjefHCyDiyIswqqCYokMrAlNRuwytUGRX+a6hb5ELMdQQRjnq6OGOivR4CsKnaKJCFyqg8bDDyHRkcMMIH1yxjwdnrAAzHHfsx8dDHomCkExuhWWWXD4FZphlylP/FsxtwnbbqNfJ+Vydd925M5964unnJXjaKRmih1qW2aJJ/1AEcgJkZbSre1wSq6V6KZGpDK2x9pWnby5XmwSCXVWopKjSsAcdayD2x5y2Oncr3LzWKrd3ldb86wYajqcselEeq1588pXX7LPDQMtKtP1V+0Ed2R64LRgLOvjBDQZEWKEgFnqjOTPCJJBLiKGLTuPAwJyiym+J7HsVVVFFhWaaMAg3Nlf9+gawRgSn+wLvu18EhY6+92668LsTP7y8yRecMMYWY0xHJdGDTDKTRZ4sRQYnfbkByzHL/P1Zd98cF6BW+8xzz30eltedhUE6mWNGK8po0o2yPcWjFVgQ/zWs9zewmAnigTWtvcZuXbtbAP6AqrvQDjRUkN0aXmUp5dgsbhZ8iz4uqEEMzq1uowJWePYGnyn17W/Jog995uOs/CTuWoijBIEcpIvGseFxCvKE5B70LSAsAnOZ01wUukA6IohoiDg4YvAUhg1CVIUcsltMrPyXqQVcjYqxW+DYtrIvhaygY7wbIhjDODDdsah3v2PRGdEoDOJVjCNtdJ4b3Sg9kFjiXkd60uZKkgHvgQp84rPN+HJWPvQREjN9AZpudBYo+hGqaIxU2hTYZoX87U8LWkiCFSZoRavF4wRZIwrXFvC1WY3yEPNIpNkq+SqnKaQCa6PgzTZINwJ00P+Cs7xb3kLINxOa8D3MSuF8WKgfacVhDB+A4S+S+YYH6cJxCoIcHCZ3TFZIQ1w/HFcULLExjilAYsc7HeqY+EQBngaKVKsiOdEZlbzIDlVmy2KRQMYRhK0xjWM848DEqMYwfjGNCduRGQHasDW2MY5w7FH0NhYbULnGj+GrYCAHSchCXoBPh7GCIvfivkURTVD0e6T98Jc/1VlyUmo5Z0GquBqtnUCULjXgAcWWv5KaDTiFSEysAAlRXcmSlra85RRotpRciiNZkuBlCRchOF8STphGuMEHirnMN8RhhnXQxbWMsMxszeKZ3GrQG/bzVGpGSXNUklKx4KPNYSjsN0v/rMGpUppOQZqTruYTGxbzupUobJGL/2oYRBAmEYLWM3nzKiw+w6jGgC72BfMcnkEP2jCGbqqhYrAszHYaUbpINH2e/dlF2dcn/RWqowww2kdTmwlLUVKVwEmOJucKi8tyipRBDWppPJWbdqZKlZf5QRJcmRiYanZXtTxuT+UWFjKpg6gSKg9SlRolZTFVBNZFnFPFup8ZTrUOU+VqV73aIFwscz/5ORJ08ZhHK41nJCtoxiWZiCVzyJazdrWvXfB711Pxt79NfOdVyNUVLhK4pJY8MIJ/gzZ7MVgigSXsQBfbWMdqhMLMQ57C+OEaAnIYsw+FKM7y29nPorLEoW0f/yMb6cjUJsoGCiwAJfdV0gzENsSkoQ3Y2tY1LpT4UQ6EAW9+sDYPIte4yT1yB33alDKpIzzCku4rovwK9Ci1FEplanWvi938YDeqUu2P4raqrUEg6D8OCqt2mzHCKJ1MHFsiRx+wAV8mwnWcc8WvfvMs4hFbNK+72U32WCfoABvKUIMWdKCfxq94gqzR0Itji9BYYYJ+s9IJ6zCmPQwWI2+Wz+kLGl5C++dEovh9phqURxXN4qxksmkjlZQpRGOaOsGC1qJczczipGPVAFkx71SlqUi9a+0Ul9NINvZ0XOYlJw8rCFKecpWjPTgnSMIJzXohtl9IBmJ+V0AFolaZvf891fJSjgM8JOGUrPRmb6BgBVQwxzj3gk5a63nP9va0z0atb3f6+dT85i3AZ8dvQseYpCG5XfQenfCGuMjSGCHeRbSWacy2CaghxjdF+3zi0aJWaan2zKppzJnOkNa1sc7kXObk0pTj+qG7XmCoH0XTBQ5Xp8RWMs5x9dMMFrnnc1P2sp+8iFeEIA/Qlva0mVofxG3ZDVzG9hiirtWpfrtA/2lQtabKn2QOw3JoVZK6pYCC4rQgnfCgL55xqvZ6sx3j6DNkn0W73/StM+D9PjTtFL2/kkeqwAz+a7yYp4HBEx4oGsh0xXtlbPLpd6KffjypGRjyFU++OyTXX18vaQH/lC+m1stZORckgGMXwxI3htltb1dpqpobOefIlmWSed5z1YwpFJFoiZONrp48uEL3V14WdaktfC0/PdtkQOYxvXwLxRnIzGamajKj/4uuo/frJ4mgHwgh18Dcd+331rNbvi9+xyuyrm6Xu2gBvu/1/xrzwe3KuwqshcLTf+KJ/+P/Lj539ENe46Dd+0ed2set2qGYgYvx2Ejtzw5YkqzNGyCBXmqMXv6NUuSlEmj8ySjdnOu9HuzF3uwt2QjsBO6lgni8Qik8m5UNjrTRx/ARH+K4YJdRgjHJ4Lgxnxo8H/Rp1/QZjpqVR7GgCBMcwbm4S7zJ29XIW9q1nfjZGBMq/6H3PWFnXQr/TaH/oV/d/VuwEdxj0Bn9dSGm9QMYKh7+6R/5+d/Gqc+oAeD7TJ6qqeFx/E9vKWBC3EsiBAcnvdQELkbLWV5O2UYiJYYFxtfqyYXNGRctcYfOdeCxaUft2d4IliAKSgjwLUIKAlO1XVcTvCAMYtvx3QAlwNBVRRVVFYh3FdP0aaIwUZ8PJok3cAjZwRvaSeFdJSEU1uLaQQcuXpx95SEv5mH5AdD5kRj71EXV4FTd7d+odeHgccIyfmEYiiGI2ZUwghao9Qk1piEbEiDfkZYBwqGPyWErNQpq5CIU4RjofQeQjdMkZUVClJYA4GHrVccizqMGLZkIPv+i0UnZJuzj71Hi77WgJi7dJsagDnpZVE1TCmSidS0BQy6d4XDAyIwQisSZH6iC9pkd9+kFLdKbLZKjjgWSR4YkFP4iSZakSeqMpXRkSp0PPBBeGyhjM7LUM0KjzfliGU5jiR0SoMVPx4HUR+3LNsJKJCEgDexd5tXhb2lkTW6S6I0JU4KNsEmeHDLAExWiIW6gIvrU7NVjT+xEJKQCWPJB0UmZ0aUg8JllGLCgtTUdCmVBtmmitsHQJxrBXH6idaGQCATOe0zCQ/Zg4IxEM1ikEtAXvAFGfYkkXSCmSC5lLIEkGY7fSUYmST5hOaVdnrjkS3ohUchkPjwjYz4mTvL/V9Ak5SEJpUhpYxvSDwACpWXc1mmqCkK0I1IKG2OmIwiYUmWaHlWexqlVUgGyHk/JI1YW21Ye4iw14u2B5bM9QT5aWQ6ESylswj+mpVtyGV66JXZuARDcQHUa3zRhGwv6knjKhwN4AURKZCOgyNg9UCzKIkcq5q0EAnx+ps/14mNC5kkCImSq3Wb0p392pF1kpoBqZod5JnGxBWiGZhUihmqdVmo+aMexZmXg1mvu3Q6sCmneWo6xhQkMYjmlgae4UzkF4uaBKHEKJz0WZ3EiZ1im4AnyXllGm4sui/BhF3a2ZTNkp44WX9SNwQuuZbUt1Xg63XmqFWA2AzYcQRHe/5lI/qeTuo1rQilIxud87qctWukTPimA2hdmtgE9wORm9tF21Fo0SqNODsaZVtSp2GGaklz+OGg2qgoNSCj9uGZqyWY7qmkAEdkB8lt+aSgXsJqvpZJvvqMBnSg9DqdxfmAI+sRXjoMQSANf8hAK8mN0Suc/6ih9gAu4aGdbfmq2zaBa3uVCMqSQ3oeapRD1YIjrbN975qKWxmqsNqZ9OqZHYumW5qqs3qIuDmhm0sOXEmhnFgVN6ppNImObqincWSNqBuUafsZqvh9WmAZn0E9sclGe0qb4pCPNmShpOE0NyOI6VlIdhp7dxMAtqSgHzqMLsKiwQNUHZEF0VqqlPv8njcLljd5ojnoqqEIdNa0lqZaqqWaZX1IPiRREe74qrFIplf4nwz6slNrqreoqxdrbrs6nMvpq4dVDUGgYsS6FPcBCyD6g5wlSYLBfTl4jrKzsm7IYncopa6qhyFWr3snmhaLWkNUM10jeH7omjF0Ab5IoDGTguiYqii6qoh4iiwqBEFiDJHjB9FVTlPFBc6KltW1qvrqlAWhtMDQLdX7tqOIrkd5HXsZHWpGnkdqBlcDOrJFTSG5QxEKsfMat3CpmxZrf3RLjxeZisH7pl/oDIviDgGIC4QKFUHgsyI4smS4uh8pFvqGsslrjXRxNs0oro7wf5kLrhEpSzeJpnpb/XVV60qfMDFFG5WYE2aCm0ioN24kmrQYiLeweLSO2q1dCKtMGwQ1AQdRGGTjcQT6aYKZuqgtxp76GQaoSTnhS2zNcIiZqmcDqZVpZohCgBJqgicJKbH/WbcPOLZSeAa1wb5VupMLi7d1ib8q5hQYA6xXMwJbMAOEKLvwWrk8QxQwkLuMyrskCBuT2FxomzeVV7jYCZcy2Zn/+b3DZbDvSAEaFrtcA2YmdRmkNqo/9xhv+kaKq6+tWR+zunD3aHljartM6Qn6EAR/IgQmDQ9FhKo3WqHbRhyeqmfHuq9ae5QoKZMBa4lExy3zARxCMA5dsSRmglMRqL/gWMRF/b9yG/6/dFvH46m3ama9bqK8GzIA6UAhKAALHYgL8Ci7hiomZkBL+Iuv+ItJozg9qZq77QY3m1inNkpbNXujn2qaGlkXYjBoUXcJvOrBlpM7VWDAGx2MGG+cGv27tRUJKfHArtAK0SQI4tIMjn7DvPadSOcHU1QF3Uien7qsLJ28Nb6fzlup4nu0OOxsQs23nLWyUdiD4JjESM/FiQvESL/GeVWk+BAXhVnGFUMg4pIJOtAHgcvGX1nJz2e/9rqT5+JdkjHFHaWO0WqsAW25lrM08vBoCyyboSuEcCFWoCIC/oWSiIIY77fFrFe0fB7Ign7Ps3lyjPmpLJLI7gyUSfIEjI/+BHKAw8A6ddGZBHfDAIPBAvH6tdrKC5Xyq8DFVCxI0CoXyDpet1Fox9bYtIdKqIq7ybW2vK1+0Kw8xKysxE89ylW7mFSCB3pjLEdguLajDTmhx/ObDQKgDLDSXS3ueMesFMpsWGe/kAP7kM6txUUZoAHqzG1fzMz8RpmgzWJSuIkWwaeiGqoRGAeCWH7NrzaAzVbvup/BES3wlWLZCJMxzO3wBPcxzPZdllC0CEPzCLiRALfTzKQ5DFqTq8dYHJxc0qILqeGIZQ1afIPABvFnv+Ur0RJPAKh/xYGc0Rx923joxKscFS9cyUZDDNTGtENjuXp/0TmxxF7c0TUCFe3L/K07DD2gvs8tGK52iMYthFATDplBbswAV9XK1Cc0KWcwpcH9mT2UwIFRH9c6lMzRWtW/Lbgc7ola7czyDtTw/8lj/rjUAQYCIQn9EU1hVzu/RR1yPqnXfMA/dNV43Qw8yZ3PdAUsoBzxudGATNnmftyzvYs2tdxEotkfvrVs0NktzLCAIYZVEtmRP70mjtC8Hrj8ERU24qvo9SmirmGi7rITu9AA/qB2ermq3Ixdt0d5xnhy7CepV49Hop8wlwk0dEGMWJ+z+tojzdlPswz0mJ3F/tXEj91iWdQ6wQjI5wfJ251zXR45ed6fWtdcK3xIwVUOmUCmUMEyrA0yI98pp/285mzd65yLJprd6LzZ81ypjJ8VQhEIZ3Pd9+1BklwGR0wNmh4KJtKrAjU2BMzWZ57QaCrAPmHZPl3ZPovblJQI4CjV75p9tMs1ymdKvYVSGT1KqtGMfIiqJm/M5jzhwk4lX3l4i315X18OKs/jtSieQhkA5lAM3xKjVYu1dOkFAajrTuSWOPm/ZAoF3q4M7nPrtcY+RL6zRwm1huzp9wnJzGDaUt7JGw81SCMRPyENRpZuEjIc1Bbu48AEWq7TgCgVBONFUWMWZDxqAwamzai6e6ovMvuzPgrM4k5TqaHsrBZcAcWiF48bkOg3+7B3P3vaksM2BAjKh+/abGPrsNv+q7TkiVyNBKKg4PrSDTziy77p4P3IDJNfrvWoZkL4lvrJCjt8wdgf5HaCwWPZuc7kt3SY5rFM0kgO2Ei+5rGM8uoJsUfhEPVw5Wp3VeuB3sO8yL9cD/OJDPcBEGWgI3sV8zVI7aU87aUMoo7DPg692rHn754WaodZG1cAY/sRXcIyUFtCAuRqrVQqniBPApgWyZVX1oTfivN/eThg3sD56v8/oUREdNxTdM1xq8JJqvhq8poqtwjfDCUbZJvz6hKj6t583b5e33XP8fGr8xi82c0DAjcnGQJyVlJQQL+G3ZKdCsWtxF3vJlXjDlfyXVSgatUv4FlU+nV9utFfGJC3/ErfzPBWEq8rxL55XDVZgxask2m0nfXIw/du0u7tTtUNlkOwfp7zzRCgYN1izPO7XQ9dHW5S5QtiXNT6bJdZ27dmjPcIPpHUlJCryENlfatwThEu1ejpXfIrG+ivrvfbnot97vFHc8sijW3SxB5YzrRCOQy/jw7HLQ0pkyYZo0aI9s/xDuGw2s8yaGlFbwCXR/7UCRCKBWhLRyGBmio1DhxrAGPADooA5ICgqcWjFypo9K9YYzPDRghYLEhUWsWESJQsSKldSRKXyRMwAMmfWLEmTQE6bM0vIELMTZlCdCmVCgDAjVNKkX+p9wYfvy5dISNpVVcfn1ZNS0sJIexUC/1yqEHleLXr2zNpZs05EtM3ylhVcVjfiGqErNy5cujeG7fW7962THNFcfbtzWN0GxbAkMI7REnJkyZF1Qs45GXNmzY8PBOK80nPozg1Goyz9WTSJ1KhZr1bdGnRkxkf3Ib1ypQ0mPnaY9Pb9u3cQ4cOlCC8uRIgU5IIEHRkHKCkmf/4w0QsFqNAR7VE8dMTmDTx37jTWlDcvUCN69FTYt3dfAX4S+D4YtPgBQMAPC+oTaRHJvz9T4LsvoYW4yK++AkwgjTQzMEonQPk++gi9eRK6kCXWHrPHJZyAIgpED2sSoyefPhQKxaJGkEcppph6KhJrhBNiLLK0KmUracCSo/8VG81aK4euBAumrrzwKhIwJP8i46+4wsAxjxDKqaoqetqRp4PFXGLtJcwu+3KyyzZrCcwxY3MNTQbVhO21NtncUrI0z/SMQ6NcqG0G3NqgThzegPszOOJkLI7Q5Zgj9IgNWJSuuuvKEA/SSM0brzxTuktvvffek3C+GiLKbz8ARd2joAnTuAlB+ghsLI0HNeJoQh8CPIjBm1LyUsQQdd11xJ9O/DKmFGOagcWlXHyqlSXakkTZrnC88SseuSFrE7QWkQRbtrLQ1sgj52pSSb+Y9AuIHL76Zkp23IGqSnnUwbIDx3AtM8yV6L13XnzNlHNNNvn1F2A3BeZwhn7yKTj/FEbbCAVQaYBz2M8geBPUOOUOJbQ5cZ5LuNEyxskgUpAlPc9SS8/TFOX4VH1QVvUIGnUjKuyzYooCizgQogQnagxBUzaydD6fR6o53gxvzfdXYXP1tcwunVZ6RaVadCrZtvgC5pdhmnk2SjnKiaRHsn7kNrBus6CLyLNvsAvcJfsa12rB8rgmXXXbkZaWvN81Cs4U67Ws6cAFN3Oz1f49+nDTThs48Q05PLjg6vacTh1AeeMKcz/taMRPSYgLtDeMmQs9UY7rqQeQVI4Y+bxLXc9Uvk1jn31A+xhI4uXcYV6hAis+SsPmBjG65D5WW311BZPJixnDfo8GfOnAeU06/9jphUVKqamiwocbZm/4BYcEcBDlF0leyaMVr78eq9pryfbWyLvUtottt/d6m9yzCuOGRx6vIUscTxCHOcyxAXkh7WkvGVwCobdABu6rcX1jXMAiOCcy5cNgeZKcwmiBAoh17oMglMTmSGg50BGKdL0pHW6SAggpZEAKrPPADk5mnvbMDocqUxUDZEUqUYlqBx/xXauCZ4Lh0Ywi8WqBz5KXvI6sQBWmQMgfGOK8fClNV7eyHhYVWL0UjSB76dteOawBhCbEIQEJ+AUHShGtr33DRmnJllu+hSSzJWlt36qfuJjUR/mZpVp52IQrCBlHrYhDHEWToAMfaC9gMfJv+v+C4CRfU0FKruZxGdRTbqTjjxn04Tuc05xvRkhCzpXylCFU5Sh/o7lERUJqkXBODGdIQ/HU0D25zCF9agCSCP0QPaGywEF8h5FTscohPjBmvNJAhSY2MRE7iJkQa1ZNxH1mkX4LihZ5tUUvdjNq8hBLK9rhlHaUZRiiIN8i+AAWKU1rEUAoV5DkWUd7soIS+KwjXupHvyXRr48puMs8A6kWZ1wjLGExxwAX08hHPpSREOWiJAlX0UtSEDNyslNt+LHJyWFCHYKwgwdSqUpsjRKVmSshSlcKKc6BJwPjSAUsTxeJMqxOhrjU6XtaEB9gApOYQixEA0qSHZ1ZpBDIe6b/H+gQxHRkAF7WPM2/JlpVq34zRXiKROqmUs67beIXddjCV9zJDW7IEa2CccIY4mAXfLrVjmfz1h776YiA+jEvQVpGtQ7KP3C44w6AvQZDFYmiBkoUsYh15CMXS1GLPi+jE+SSZLmUmnhI4E4c1cAGqVOPGYTUg9gI7UpLStpGhHa0pjQtaXkjnuJsrClJuSkMJ7VT2xqEPSUj2U+H2aoJTfEkrcoZDAphkVoutRJNJeYf/jCF5p6BM9CV7nQxmU1uarObVx0WUsDW1ahEhRtxQV85zGpW8qbFGoRE7ytYMYZ8vjWf+UzBB+6ZFyPIl658uSu5nrSJZRCGf1MScLrA/4HIhmo3sQlmoIId+1hbFS5gFy3NZTOrWYVdISkzIMd3Qrna1Z4ylKoEsShZ6+EoSCF90aGHLI/wEdZxWKfkqZRu+VND5WFkQkg0kEVmVlxnbuRn/aEDHQryXKlSFyFIruCDvYngLt4JjIAAhNe8qq5vBMmv5aXWMwKjFkkQUhJIokQKxlzm+rZNjwDFX1wACeBsvHnAX0OCOhRKjsIyGM95znMkK8pkCE/WwZZdUIVLcJvNcpKjIRVth0mcStWOGNKpBfEORKksUVKa0tzJdGthezrPzra2MLbtQHi7Wxr4LlY0KxrOZrZELaiCqc9Mhio6omrm1gw/Z4BHJnjNa/9d55q62DxJcK877MY4GaswgfIMtnqY/vkvLVEqb/e2JRhWCEagas0D2d5K5rjaN7///ED9npQHwkzjG9koh7rXvb6EXmOhs1Ganuld78beG5LDDvS+GWfEnWXW0IfO08H4QYveNAMbJq70KRfuwYYz/OGmXMLmLE3CTTPBOTRtlOpiGB5Rf3y3OuXPDoJ4ENwaxNbC9VQhMgBFWPtB1nuAz1DTQURg+xrnSQb2RCqr72Jv86rHFrqyV/RZKTu7RmWRm7TPmpazOF0Ear12mPMSriLZsa5Z9yMQ2mjuaEwD7AiN85TkkJjBGnAmyLZ3F9fuUHznW8L8jkE84EFh2nD/IuAYRhiGN4wCkjY60pxzOMRPaQnCTzrip5344hnf6CjAVjpMsekRRBqp3rxu1CEvcqxQzqA/oHp1L08uFFUw64LUHHgOyjnOM/FrJS/OikaTYN+yK+8OqYhYRz+MIN33FrXozxW/R4uMXFFGwQDh28nfi5nVPG7n+3Nbpdjrf91cN3dc3x1TSkzBOKSPt7cd/Iutl9u162DyjwkC8SDgRvF+6CtwlOD7eNTgFV//wzOc/vdv/BIwzX9lGd7SAhD/RisIhGBjnqKzUqfjXAfzXOeGkkDzrOAPfGmYaGUEPs8++sAUmIEDk8sDZ60C02F4eo0ES9D1ThD2gueaZo/2/7CrToau6Fik2cai9/RJrZ5BMHDwBoGPG87C2pTPn+5Ln94rjwDqA7Lm+e4rGHCE+ggjG74BCsEhCtXhYLaPb7wPC7Ow3qgn/MgP7hoM0IAODC1DCcwBs/ZBBtpvsxAmFPAuH/guCgzPtOyv8OhwAAdQDv0vAC2BDwOw//TwDlUoFUJhOjipHlIhOZiAATMvtwSChkyuAoLp1KhoAlsg9DrQA+kgGZKh5DiPhz6xBFsPBS2EFG8mDFdwBf2MBW8vBqcMbPKg98aMvuBCrbDFbHJQjuKK+YRQzNLs+ZIwvvKJGPbq3KTwGo5xbsThGMEhMdCu+7QQoqDxQ8CPwcTv+/8SaM8QyAsbKf3qrsIMDf4IDhyPwBL+zg7ykOLskA7RUQD/T/H6cA/hsR3tr/FATBDKAJY6CR/qAQk47vJATuSciOXWgIZKRQJvpg8SEgWYqgO7QAUqYRMfUYeGCRRN8PUsyYpqxeeAbhXtZCHCCQnAhgbp6dtwUQe/RTBscQiDERiLkAhZ4RdbMguepRSKEaFu8n+qRYDyQBlpoYCuUBqjUR+Aggu78BoXzCjHDxvZbjPST/3uztCg8v1uI/e8AQXojw8lzv/esQ65sh2/Uh7D0gDe0QDYMf88qAAFYRCdAgFPZxxeSGRyyhF5p5kwZeYwkBBAiSE5EBmAwS+7YMj/lKcjeIl4FET1RhEjMzIVVfEFO8Qjly0UQjIkgw9ISlL4uKwWexEmvc0IWnIW50sWY3IW+errjtE0T1MZzQEcwu4YCcjuglIamWYoppEakdI2l3I26c0as9FvduYp0bD98CQ4p1LvDE60Hg4s6VE5GU8s9fD/yhI6oxM6yVIdQ0gKDnA6ECEBP8bybonk6DIDomkwD4LlJmQF+PIUlOEUgEEY0hMwYeXkIsLX8KOSDOfIUFExFXMj4eQKz3DZsAcprg+OXqFaSNIy1aJsejG+RPMIYXJBf7EOIrQO6GswvI41T1PdssEdNPT6yoHOBsgMnxE2c6IE9KFESVQ2aTM3/1d0RG/TRYuSKaHxKJNNwYrnKaFSKomTH/Ck785y/+oPCJpTOt3ROfvwE4YUSU9rLLuS8E7sN2RkppwCEbTTH9wyLr1TIMOzPFBOBCdkIRWADpChC/zSENoTMIes1o4oPxxE5y7SFN80BfNTTjvy2KDMTvHEOq7vMKalWnCQSILRBpfwLJIPv2Rx+YARvkJTQiOUEnwhSGgSSlgT+ya1HPJBHVxTRIOSaU40AErEVzhVRVk0G0W0qmDUVJPSUzjkNwnuDIeTOHOv8jzoKv9u/5qhLMlSHttCSPXwSJHUV3e14hzPSV+LnKRUOzFBlm7J75yIQsaT87BBFdRTPdcTCv/KFA3AFOYyQATZlFsBgBTdtILidE77hVRpgtDywTqsZDK1jDLZ4r3Sxvd+cFtWElDrdSXHLRh14QN0QRfeABcYVRj3ihiIQfqozzTB4c3UQRvUIRvoDFPLFQtB1VMnlmJTNFRb9FRxM2O38GJzhRB+oE5W1U5clSrxxF1iyO+uch3Hcjqf81dbNh4fwEhflmaLNB1Zi1DSBx8QgRQQAaSYoA+/cw18xwMmBFO0VBOnVRgMoQeslQOL9kG61VtFA1zvc1yvNvZYsR+29lzTlUrIKwp70MtyIBicIBjO9mz99GzNFi5e0l7rNV/31QgpwQlq0jQvNOy+rjSPURyiAZH/QBRiY7NiS4RwQZUo2W4odyJxowdjD3djOdZxPQQiLgsWBs0oFIVkS9ZdNmChpEFlSUplw5I6lTNJi3RmZbZmU9fSLs5hhmNipCASMIFnEeGTZvU8ZcYbzMPlSiZa3XNpmbZpXwBMYSVqB6BbRTHX6m66rDZOOVIj/ax5aK9O7/QbvbYqpiRsnWGv1EJQL3NeyUa+6FV84+ts84lfdaFRc+C/0KUauuHN3jcbTFMZ9RaRwI4wADdwO9VEN5Vi3dB/PZVxO5ZrBRhxCVhUITdya2Jm1K8Mi2YDgBMc3ZBYsoSA+ACUQhcAqRNYkzNmXfYRUPeDQ1h1OVhYWQkJ/KFn//HBOLOVaPtj1ppoyJQWeJvWENLzaWXmE3nJByjyAgrTIr9156a2eR2zN53H9qbXYEzkTq03XbQBe7nBGS7Te9EWbcfXis3XF9CWfNf3zbQhfqEhb8GOD/QWb9/tMPIkf3uFJ/r3fyk2Vxo3gRc3gUMkjtVYwSx2gO3YBRT4Y10zHhqqoyJYgim4gMiBHC6YVjsYV+NxDxfZg6VThDlghDc48EiIFuhhSumhg5hhBQQhPKFIGZpKyEI5lGe4B3jBWt+zVHSYlYknQUwQeaVWlts0iA8k9UqRmQoLBj8SOEfgP4mF2SbVbtjBrJxBe58hiqWYy96ibKv46qgYmhuVmf/LN4uDIRu8+AmvIRqIcZu5mRhPUwqfEPuokDbKtUTUmEQK1w01oI0BOIAD2HDfuY71eJ4/lZ7v+WN/wByQCpDbGe+ckoAM2ZCPU4Nh1maD9KBTF5IXWpIn+UerMwgAYWcxgRy9IfRiOIpAmZQ3caMDszssutXkUz5VLxTn8+a4NWcmcod8+AIM0zDT4NaYS6ZZ5SNrOhxjEJiRIBSi4vrQ4fq0QRuM+enOYnu5bBmMAZ+qGZqXem2hOQfOwhjQ1hiW4ZqzAYwHFqunmpu32dzCTpyhUMDStWDyGJ3zmI0zlxN6wkQxSI7h2Z33t63jmqwT2J4Vt60/NZ7veUTysqX/LeIp4wWC/xeg1W9bFVLwKJllS9dl+Q+E+RCEGzqSITuyGRqxmVQaLtmTtoOpQhnmmOiZMqXVioufkeqkabmWT5uk9QN3gIzGAIR2TE4EY1u0Zzpearu276QDsCSnqQL70MGniRmKi5p7l3AZfCG+hpts15Zs96psixttjfpsjcGYnxCMBTarB/ao/6uM33cKE+Nd4q+u09mdMUgc/Zedb6ONs/Axo2eAORVU2TqJ51qv8Ti84ZonbMKd67tXPnblGHgxAjut2ZqB9zkhWyAhgRZ0FdmgF3uDKXuyHfyxX5aEM3gcZCt3Z+hSQjpq/RqmO5yZOpy0Zxm1gZjEkyyZ/yCQ1IAsivYA1oYM1nSLp5ZLtAvBj7PEthvDu3nbHX6bHYDaqqNYe4P896h5yM+ie4Ph64wBq89WYItbuqHhG5K8WoIBu7N7q/fWNOP3NJFRHL6bvH2CjdM5Jkr0KMxbRwM8v41CU7m2RAFYrdm8f0dUvvG6rodSYt+6V9wbnfMyn/0bsME8rbfWHgbcHH6gwA884RK8wYl0sR0Zwh8c0h3adDH4OlVHO2Sbxj38w0Gc0zsdIbgV10b8tLkAlyfCllH6diwgVJioxSvB5Ubvs20olwpctg0ZH3nbt7thSrShx7WhmI1ZqLV7+ob9LIAd2I9BqrVayaX7m7W8qIkxjP9rkiexfMv/R5uzosvLO8zTPIn/F739Gb69aL3toc3P+u7ifNzLGkXp/M3b3M7LfXDhvWJ7qc/9nP0EfcAhgs/zksMobtF/1dEfOdIlm+AjXNJZFoMfjxa0w2No28Mb5NQj/pZFneKrlhQ/nCJCndVSumU8G4ajCNZY2z90JxGwoTy8QS2rAh9826e7oRtY3uV9/AmNHYxp3uanOqp9QcmHfdgBDI4KignxNtrvVoyd8Gv+hxkHLpDB3Z3vXZ2ZHs89BAK2nerRPI3ZXbzLfY1PtN23Xs8rVgzovY9zedwrl4FhQOxhjBDEY2Y7+N8F/tELfuDjXqHLMWPIoeEf3oj/PV3i+16IS9zi1+TiTX00SJ3EW8WoDNx2auC1cdh23KM7mCDlV57lW77y3wEdukFdgNoZfBwaPj+of/wYlj26qbwJeX4ZtOx8skInX0Ec5sYYwxhvCcnoyQuhvFvboX6AH/Pp0Tze2fusCZe8wT3dzRrrtb7d5V35qV7sCWFB/rg/kensk4nDTOY4d/Xg6X7u5X77675X/cDupSBRNn3vCX8BzH9qKz7wJ2zwD/8iOx3+L8vUlYDUn5LQGf4OqGLlMX/zAQKdwHfv0HUzqC2hQmjQtDF05syYMV/BKlZctgljtI0ZX0XbtDGPSCGvnpQ8KS5Pymt8zE17CTPPtZgz/2uWAweOzxNB6vLx4wQ0qNCh+/qJMQohaVKfJZo6fQq1qT6lJ6pC2Mc06lCjP4kGnWrPKtKjZMsefcpVH1qtZ9k+vUAoLiF4STfUVVII74UfLQbA+NuCUJJE2EyZQnG4WTM/llA0fmwgMmTJlCUvuVw5M4dHmzt7/gya8wPRpDWPPo06M2MUUbxlOFKmTIfZC2o3uI17zoHdunv7/g1gnvDgw88YPw68eO7lXJord/48jXDptqv/tr4hu3ZASNrhwycQYbeD7NARFK8w4cOHE4NJlHgM47OOrurbH3nyFUmT/EuKE1fKfxv9l8dG0RRo4H3Z4HTNE9j00RNTV0zoFf9aLoylFFT5nNDUUlGZlSGHXLmVVYVSgSXWhTKs2NaJJQRA4osxstWXXOnUlZQ5MNQgF499ARaXYc0YZooqq02GpGlKYpZaaEo6OQmUT07Z2CeNPXgEOXZZxxxvXn6ZXHHERRdmmWSaeR2XaVYXz2zZqaMOEt99d0547HRD0DvbGDSeeg49dAx878EXn0bc3PcKSJuIZE0ejfbXqCAkkSTFpI4e+MQyHCGYYB7ffHONK6UM0wwf+dDjE4UmsoghVWlhhRQssso6ootjlbjqikOp+hWGZtna4ozCQlWjXLVpuUEhcCUR14958UXkkIkxdmSSVGrG5LWlbStlk95W+S3/adRiqaWaXYKJ7pnIjYmmuue2i2ab8rr5pjr0uIMPIufoK1Cf2hC0jb/aZLOeM8u8dwxECScMkcEh2bcoovqdJIUU1lRqsRAYT7yTSMtcquhHndYXDDDANNMTqryWGCxZrqq4YazywtNmrS56KJQGQGnA8665dvhryzA6pZZawwrbR7E1tJmOlkDW8APNevFI5ApW78EMtYptrW2T2YbLbbdhi911leM+2EIhs76bbtvurguv22/HvSYs9bpDD53v6FsQQgkVdFDAC/1ZcMEfQaSpfR911FF+kgoSxKSST84xSNFkKh/jEUeTBQ443CBOqisDDSursL7sQsxUzVzz/4dF9YMrz7LrvOrPpAtt89G1l5B0YFTMlexf8QAmPDzG+66FtMlrvRjXZT8/9pRkg029lWZb4oEH3qQzr7ly0z03+N/HW7dtdqU85znqnzdeNukFLvg21XTTEDTVuE84Rgc3XB/j1vwPwIsJMHKQ01gBKceHBHbsIyfRnOU2wYoh4OAUpYiQylY2ohGN4HSou5AEVmeCv4Agd7ALFidmh8LR2c5CLDSh7lZVI9+lTUdO+4vUnjaYwxQpazysVpSgB8ToTU+I1bOEuKyHGCx1r0skaJusAiG+KI4PblI0TpvgpA53uGNf97gHKfJ0jvEwRCHxS0jA+lQNajiEYB/R3/8muHEoR5UkCAHMTxAwhscn9OFxBuyjH+VYEgfmIQcfGAIceICDUtkDV11hCgdD1MFDeFCSNpBAbYR3la+UblcpnJAKe7XJFrrwhVqpUF+yRIU1bK94NtTR8Xy0hsPsoXk8VMxqGDPEXHZNl0QsIrisxBjC9MEc85oi26gYvmTSLYRwMwH5NjADLeYLEV8EY0HY2BBt7IlPZgxYNqixHjd2BI4h2A8dz/kEdFYsjzt53MYQCCkALiJRHcmBIeEAB14AoxTmwKJdZgDQgE4yeIUgZpvkMYNWqagsldSLEmCRO595spOfXNHLdHU7UmqUE1nqaNrIAVJyOItpA+BRXAr/M6Qe+oEZtrTESh3AyyD2MqZFLGL2HrREJ8YABDvtKRTX9lNjVhGZ7DKOM4tqVCjCzV55y9c6zlFNMDoEIgkxiJ4EBs6HJE5T8nEFOc2pzrBmrJ18nFxZKTdHenYkGPjsRD4/t5P/gDQv2plZ02oUUrVRZYMu9KBDH4rRUk60DZ1kpEUtydOqiHKUG61QR2EzA1SFNGmu/IGOekQFWRrJSFlbzEt7SFOZzjS0YPslS62Wve1twHs+ba1rhwrbuB11tsExnlGPGo/ITnN9T+3tU6dKVTyF4yB+gwZMNsK/+pCznBUbIOTuuM47ClBSeyzrWf1YwLQGYT6beEYW3OrW/wRMsBnYKG/SXOOjwPiod3jl3mw0WLp6sAqxgHmoYis0WIo2sitFoS+tWtbYFx5BUvZqgz/aoI7/nHfB5z2pB6zmWdB+FhnDqMIPt4Dh0YqWtNWb3md3kFr3AlWnvXmtUE8MHTTZdl0rrm2LjWOOUHwHEffQVzV9q6eBUXUbfQtYwOb3kGwsSMhw/NRNKBXdPrrzuUtuMh//c12LoZOeYTCCLK6MT/FOUBmb7fJmtWCY393VCuloQZb0usE0h/Ioh+jA1GYY0fzObkL1uIKu7Dzf3OjGQ0ILcIxSkQp5YOLAhE4wExgsl/OiFGuqUEYXVOroU0iawhzWsKVh2uEM5/8StOTF6WpHbOJQo3jUy6StqW97W2hiAhHUJIWr1/Hq3r5DPc5ISDhufVVtDmx+Qh7ygsoB7FRIeZ2QI7ax09nk6jp5yUie8iJKkQVcYBkUbU2AySRtskhrmw570B56yxxDMuv1vWpm0QjarAT1Qq11QcHKzibKK/muSN55lg4mP8hYP1cICXljNasPfAVzlIIQCkZ0HwpTJCM5mhnbjrSkSbVh6V3aDZimuLcsnumxdRbEqnXzb0QNclKLvNQuNnV28gbVL6r8Hjhex1TfN54yJqTXvwa2HFLxv2NXzIDHZgJZf77sss5Rnd2lBA6ojfQs4+C0XnY0l79MJFUOJpX/qXyNe/+g5qzPphDgFrMzU1cieF9BvqEACr0DG4BKgmB4tmW3vofFb0LL3R/0EMeQ0IZobERY0pzNGqWr5ZhKT1xsFS+8pjO+Leux9O5po03IExvykR8TXqdOMaqPyp30sbzlUgXuGBUyv5n32sg2DwEAh12xcUSKnUwWhGvQGXRmD5uOzyAkD9qKe/EyY49Jo0EOEwH88j64akUi/gqk/tE/KP+DWb8kmave+KXEd/qwOrvpGjqHEN67hW8nSoHljgh/sFoDfeA7CuKStCMc3AMRXg37b2oHacgfBSytMMQjLvjTMALxg3+Mtx3/eGkSgJMnedBReSWHgIKmeWDE/3m01jBC9j4DsyDXgBM3EUd1FHQlEV0+d3BAF3tLFlavAAR1kADThnTi1QxxdQRkxhfhpl5UB3zE12VW43V5URuUdBc7UhjMIlf/JFDlFlBoN19ttnbaRzP/5TpG83bfN3f+VnfIYDKqgA2SUnB2EHidxgRZqIWBB4VQQARQgAY3gH/5h3H8V1Pbgj12EAXlAmo8NYAkdmJuQx3WgYDOgRd2SEUzAB4DwYA4Fg65th69difawA6j51VyYIGAlHOyRylDl4XpdGg+53MfKCkUo06LYAS3Z4JKt3sgxYKfqG4+QgO+p26uEUuVQAep6Ac0mErOQhuvmA6ZlQg2Ui7yQP9uWvc6C3VYRFiEtIWEICIj+pYK9gJ+4ueEdgeFzDCFvAc5erd4lmFLkmYIX8gLnvOFFTeGZEg9gpeG2wOAb1hi4Mg2BHhJD2V5d4iOeAgc3YEPvKU+f3hrt+Zj/sIQNIc/hUhk3xBs3JBAOkES44BdZvVck/iIkVhsBGRs2RVWzyYJv4B7SVcLuucNtICOLQiKMZQBGSlmq2QFvrcGH2k1qwhmYeYs5jg8hLCDeEdXt4hQbXaLOJh2OCgrxyM88YAKKRI0fiYOqZA3BmaM/jZ+CdYMCqAAzhMZzJCMEaCUkgaGXmiNCQCVUEkBu7SN2nhx2hhMD/KNe7YckCeOX9n/NiaZjmOpjmXZJnLyHeahPvPIY2xZVfZIc4SYDTa3jwokOZUikM2GTpJYkNC1gX05e9vFkDhQgg95ghTABDUkAAVAPKAIirKoPRn5I8+XAbGUcIwWZsxSLuaQNDkUmdwjG7SBUK/IfJR0bimSI9rHF4y5AGGBkzAyFQH2H4AwaIQGlED5BZEgBQ+gAnigCGjwAl4YnC/wC8X5C8LplKKwC1FZC82ZC1NZlVbJS4W3f9UZnd/CGt7IWl35eG4Ilq/FNHnBdXNFluKpjmYwBeipfNzhDmr5VMO1DcMln/OoaxI4ZHSJn62gn62gelKgeheDl/8YoGBlMYB5Tga6kI/I/5CYaJhXFgsPqgYv4AGKuZgVypjiZgZcByRaoHCpeHw04CyUCXx7AHWmkGjrdzUhdmbEJBuF8GmkWZoD1YsMwCP35pq6GFFH4xpHEAq1eWC3+W/4kApL4JvHyQtRqWVxgAFvoKReqJy3pwaF2Zy1oE/XKZ2Gh6VlqKUiYJ1WahmtEZpbyRveWQRgQqZliqZjeqaR5xvjOWYfZZ5zKKdTQKd0unyRoDctF48BA5/02WsWOJf5GQn6aQ3jYKj+6Z+TYqgCGZh7eUdixZd2QEfxFwTyJwlhUGUNOghutQoROqHmmaEC8BoZ+onPAiSDQaIeyorc46Zdl0MkugcjKZJ+MP+DKumiBSWexTOHa4NY2QcXNXqEifWaOblYLPJ6ZYAJPgqkc9IKksCleLCcUeqciKScS1qtUCqtajCtULClV3p4Q9Sl1cml4Wpp/reGYVodTWSm3Zmma/pxorYArbpggmBmcZoG5qkcU7B8gCBjM+aH8hiP8jgeCEFkgYqfg6qf49AK/8OfFpMKk5MlAvmoldqXfbkIFauFW3ipQGAEbwCR4LWpEZlIsBGqJcuYJZurFuoXJlUBFuCykjmZZWZDNHNZKDl8q9hoXkaiIRYY7BWzNcmrRcgXzXIBRxVJw0qsZ+ENj1gGdUZo0+Rv3xEJJeGsY5AL2jqlSKoHQ8ADXcv/nFO6rWI4GRfmrd2apeRKruNqhtjTcWKqpu7arnH7nZcUGyLVs6/HkfY6p6H6B60QCV+ADyx3Y/G4DgAbn245MEUGR+wQbAi7n62wTqo3DpUyYOMwYJPiTnu5hZOKoBTrufG3sWSgnJsIsiKLAuRZshlgsgKQshXqUBhqqqFINcxSkzTUNEubGIzWoUaCfD0SbkCLG254kixbtK35Qa4ZoyGSk2WBtzxBDz55m3PyBfo5SKywnKuAvR9bmFJabVDpORPgpWWrpWdrtldZWt0oYlyypuvLAnD7nfK6tHgbv84SG3OYodSRnn8QCoBLEDf2r/IpsDPnDNwwwNxQDozL/7j7KQWQ21wNHKCXq2Q7MbEZywQXS8Gey7mUCrpcKgqQQLoQir1qQAR+QKGue7+r+1dk2ZgYmQha8HSxSrvkkAYdULee6DsPlopchlrA9zs0WpLoKKxhEQ/ZR7xfh7xBnLwKxbzNSwuhUA8/GX7SO6imJwIOCbZXXLqbGpXVCIZecH/WIr7lS75ibIaNoIbYABtu+7auJbdtzKZtOp4tUDHxG4l4m3xkqZ7K98Re5Gqxtg5sGZ97Oh4E7AzzAUeN2wrssJ+Tq3ORW2yPXImPKgkUK3+fK6mbq8EWLH830MEfjHQhPLKgisL21hwVacqs+7qNSTV74HQ6bKL0y6Jx7P8Na+AHLwxmUwesrGSOx2sPs7Iss7gXwRq0I9RBDJV28ssEjfAE4/C3X+DMzuy4g1S1t5e9H1u6UUqtxWlh0ChxYWy+pIG2ajta1nNTGYCu3Mm+aNq+6prOb6yhxYbM8YtesFG/pCwd5lwG/OoPpMDHvjVcaZRGgfzPtCYfh6zI06vAADrBjcx6BVrBkwy6kqDBl0zRzxYFZizRottWD/rJm9ipp+CNJywmKDvKJmzSKzy0gjGisTqS2rORrJqrlXmZLM3DPryaM8uVM+k7zAI1fuE9s9JBMRkAO2qKV9gIEE3JG8vB1FzNn3yCWtvFz4jRTAAuTiK23hw2aavVZCz/Glfyf9/YzutcBKigzmL9xmcAVHgBUh04xxnbGm+9SvaKnvrKzO5AY7FWTfJjP980P35qMM+wEQbMDoP9uAs7QJ/L0Mh2kBSM1JSchRJdqRIt2Y2wBCnQyR3N0R5tbRNpzwZY0qdm0qcsszK7ssViih9JdfMsPHY7GF9G06kNNbksL7pxPD28bimmvsQMk5SEXqdNfwiglFAwBsMZB03ACjdABmMApc3Z1E/ttdWqlJuhGKmVNFSdNVg9vuLM1eKsAtx9huj7XmEt3mt81mqtfm3t1uX11q1xZq2bF7Twt378nv/MEMeQMNRwuMA1H4acyIqcyNT7PxJd0ZBdMZLo/8CL7difm+ATfdQczKmYHbKZ7ZzAENLnaeF1aGpG6Lozq8sVOdov6JE1eKozrQowzMM83dNLlAlxMRjNQpa5jcQScLe4a0tE6aTeuwvCjQHXi8XOvQt6sKTXhgwbN8+0YOTe4FJGhN3fXL5c6uRdqrbanXjkrD3jhs5mjeVZXt5wfLuul4V4q95wvaMryEpNwxP44L+FK4/QkDDFwObUMD9ptB7c8AyLO9j+TagXM9mXcakTbeCQGJiTPMGNvQiTXcGXgdy7ALYSHuGlG5EgLRvPUbKTfoAY7kzuTZOoPJbuLUOTaVDptiwcytKv7bvFOzMrPpJzYXIwjliyopGmqP93iwGFFOCUV5sLR/q1Eam1uyBByDlpRBklpqBK9Xqr5PBgzzg9T87kazu+jJACUi4C0F49flDO4R28Za12XjnWWr7ltH1X6J3eYr5HZN6YsCEnLBew8QhOxZAw9gPnAL0egL24zozn8uSsmMHn+X7JCXrBjx3ZFBvRoXucjS7hma3ZFG6Dkm7pF77wGY6OKdu6FinxftGYqlkDr6qzLQxmceHTxrHihCDsVLCaePzT8pxKsY6UTEkER2rr2RqlXHycSloHThrV28yKO2qesdECHnDdSy7lW53d0S6uQs/kZhNiYK3tYs3t5O3OMIBK8lzgF/x69PpYVX8ESEBj6e7/Y9RQDOzO7vatDWlEOBBRZImM0Pup5/mO7xg91Z1bqRgs6JMK0X1e2aPb44z+wZtNkUjF8A1fVGN5QxyuyjRaAUU88S44+Bjv2qk+F3tBozFoAT6sqy9uh7+T2ouW8jfu8i9/jU3g+Usp5MB+NmLWNGKZLH3wWVQZ9Pq3f0Tv5Nr98/vX3eEqAioA9ORL5ebc6tye7Uk/3ukyW2V2Xl9e3W2tcwr2WABJD6SAD+MB0Fzf9dHv5vbd7tDARnBUwHf+uPtx75jR/SjA9hdcyQ/N9tEe7Usg6IWO6F54940OBrLgCSBcuiO7WiPN9/effZVeyhqusgDxowWDChYMFkRY/4HBjwIDYDhkeIHgREI1fLSwUkjjQCqJTGnZo0qkyCQVTRJKYipRSioYGZqAGU8JlzQzYT6k4S2nTmzYUDRj1iXCCyhEeB3tYRTKiyocDDSC6pTRMC/IFCFgltWSB65UaLikuUCs2A3xsPnRKnWLWrZtHbiBG/eBXBFx696du8SAXEasmuDFO3Vq4Ed9C7t9e7iwpa1RjqTpENkGCxCVLVNGlflykc0xYHkGHUj05wNzRp8ZbQ4GuT6texJiwqS1FNq1pQg5klucIEGzdbtDhK9bNeLUqBVDnrzYMWPHnEODli06N27PqLPD3kp7K2vW9H7XK0nSd6jlpcU+L028NP8g7euqGLUrvo4xQNanwJAATi3++0F1AnCQWASUpUACB/yvvx4sIaeMsACAMEIJJ6TQpgfNqFCAmx7SMCKLkgAxxIMWgqihEilCKaQ9TPkqoz9W44glkFRRZsWVUErpI5W8cuklmzaiyCsqvOnpp6zQAMYQpU5RgJFJnrQjSvQaaYaxJ7NCq6s1eMwoJtLGkoAcDyq5EjEz+QKMsDRF0EtNulQwTDA50UxMsTrtZIyrjCTgs4HONMPsz9BKM820LwsVDTWZlIBxNiJdk8023mrDrTfajuBtHOCEG64445SDxjlRj3GmVFOto+6LL7YTorvxwIMViCrNi9I89+4aIz//NfhTYxf68IgjPl6HDbBYBI9Flj9eJnlMrAzneRbRZzHc0MRqJUJIRBAtuqBEDuEBt9sgtVCm3GQq8UOnHr81SQuPRHL3XRV3DJFEDl0iiMgaeOIKBbSEEoZJxqSM1NHYokChSK4W3pJLGGqC1s8vJdjgCH/xpPPMvDYG7K8158qYFRFUeM/NjO/E2ModovBGoz4FhTlmaWf2UrV0WjD4YElrwxTTSX8WIhVMEHEnm2y00ca4T5UblVRTT3XmulW3c7VNNsG7mlZabxU5112//poHscH2r9gDDUwW2V6ZdTBiRd2G2+1oM7TWWoq0rfeSEqkFN1yK8g0pmR56MaQL/z88UFcgh/y2CMeVZhxJFZAm3xbfjHYakicjgxLqcN9+dlTfR4kUsvQMMpriD8gktgyWyDYQxEqNUW4rTcNcFfljvuKMS7CS56Q9+MXy1LPtzSYLVOZBlyf0bdNiYi30SHe2zWegpbCmFXyIps7obDwlDjronHaGfGeWKZW6VsrZLgRrxLN6zfa0Lu+uGyj5QAf9BCQbDkj274//CHQ2AHmCgGpbVrMuRJO5MdCBdKNWtzIxQXER5CDauogE+bbBh1RwIBZZA1rKJbktWSFGFukbPFRjsw955CM0ihxJaiBBGGGuIz1By78SJg5HtWYg3vCha0pnOm5paApHfFnrKP/2uiBw7GSz45hhWnGPVowndybbHe+wKDyUCeYTjcFGISSTROQlz4ydKc2hmue8RQkkdI+iXhxtMw7t+WNV6qNONbQhPuiUilTNOR/5nvGMqKlPO694H9Z09xT3cE1k+dPBLfTTK/7xb2y1mKQAB2istKltQQpsYNzmxjcK6s2UFbxg3rq1wQde614mjJHDbta4klSEginUiAkUVwN5BQ5eFpBgGkw3pDVwJYeIyw3OgujDk7gEiF/hVhEj9gcylnGJoQAEE6K4MS4+sU2vuMc9XmE7+z1xTikwZzed9AiVbakMhxhjNZXHvEG1UiY24+EbpyfHOEYCH/iIxHbykIf/ELgiD+iLxjKMcb5lNJRUx1iGIKOBKvW5yglrEpnIHBmXG9zgAx/9BQYwIEk1kJSSPNBkSgcBiU0e0KWY7AEzBGG8VoYSWnSj4UROeQkLGmQlI2rIKKvlyodt5JWwjKaHvtVGnITohfMqITFHd8MsEUI3s+zRB7Wa1a12CYlTsCbyIDBWCMzArBZTJ8o6as66sOMf7HjGFbd4MnQCL61d/OIXHSNGavoJnjE7Iz1phhoVxuNmyjQYP/nZilDg4wsBTQU3ujPZ7gwyGJY1RkOX8YxgBGOzgwTtMwZqjWdYcU3AQicZVPsL1oY0WHF47RtuMVuSrnR/KGWpSg3U0mQN/8KACGRbTW1KrZqaiKd3+1sqgQouURaXsEP9Vofq5q0OnmSGRBVIBeRFB+6a4plTLeYKDndVcpT3ZoeFpeLOe9SHwG0Ek4FnfF9WlkIcgQmNwEpa3USykfEue/f4RxWzYD8R1HVk/HWDge264LvCJa963atk/grYwDKvuYY67zItBUfaRIplHcaeNaSgnUh8AZvaGQdlKyuey3b2spolhjFcHNocSAK0FyVwakH6Bh6LVBQ//vEQ4jME2ortFpX8X26VrFveDggMTVYQM0A5XKFS0AdXvmBPe5rlCRL3whCUbpinG12/yWhbZH6YcX2QEu7mpHT8+kjLcjln6C4VYv8Wclnq/Brf9/7VsK5hzJF8Zye1emyRIuDGPb4AYHbg2HboLDBds5jOLD6YeHJ+LxLtQWE0Wniwhr3ZG4EIREkBUTYHEzFtGKsqyI6jVUGA9SJY7IQat7jGOXBxri1La1rLNQU6hqQOgmzksU2S2CWtrW2TvGRmM3kVv/Xtk1dxoLVNWais5KAJlbvtLQO1yxL6NJjrvLg620wij6vlutTLQBNmwN3vztwNVdIyB9GXzjW594PunIbUHYIzYJUvvnXyQh1mhcFrRfjJ2MRfbpDiH/94RzlI6+i6QJp3Ck5w7xpszgcXL56c9vRpwr1CxD6BSCAutc6CYIfuSCESJQ7/xWPH4WoR22E9sx7wRTuL61z3XOd1ySgr8EeJR+ZKtsdG+n4AeGRKKtvpzd6tS8Hw5AOqwRCTmKlwqYwhiHSb219fpZfDLe4xlx2XKexgTncJza6KTnTh9W46NGLvRc1k35LpK975xOcRqK6+GXChH0QyQnQJuimE1i+cPoGXZ3zB4f8gxT0iXtpHa1HjqT04FO2U15VlQB7UnDDIQz5yDvmwJ5ACcWxgrfLavNzEJ06FEDps81cROKM9x/2AM/pr3utgx7go8iWXzeyvtfTpUI/6SwkEbWU94ght2/qE1HzBeP30p2APaoTW6LwKPRe64z47mtmV1BM2rGHghXsi/+T+hzLU++7uf53e4x8Zo8J98NzFf+ENnxaDq7XidImfX2u4hyPAt3IF+9m9/UowzNu4u8qTI5CHz5OneQq5m6i7RpEek0M11SMY1QuaelCVxwqomZO9lVMP00o4I8gCohuwXPMF3RM6IwCpOugxXDg6SRKbJbutlFo6YmGyZuskKBsWHGgGjBisawuXVEI3kHAqsAs7CuG+KCS78AsXb7mlK2SchdCpFuquN+OX8KKCufO798u7+aM/9vu78BI8dAmJGEIX7sKS/Do8xEuM/SIZwwgPtyrAh6MiR8MDcuK9SMu8BqQdxBGj0KswNWoeP5HC5yGsUDOY9FC92dtA2f8YB5irh3potVerlUa4Gr/4C9Uygo6ihBcUGVOMQRn8qB67QWIbAuTTJABqqeIzPmc7oN+KBWlLEJiahD6gs0bEKWxpwuqLFyf0ESgExmTENiq8QhpqRg8iP14SL2XgCSFhGXnznNUZw756p8josxGQwL/jCB1xw38RifyDwziUw7dYx7cIxI1BsHUyjGcAsD2EPG6gOMKQNHZ0AKrgR0JcjChpGUSEGUNRxLF7Hg7pmZPrCdY7OdYbh1AAwUwcQU5Uj6iINH/8qGFQRaHzyFQcug+gwRpMOln8wQBCyZSsRSHkDyfLxd6qNpraOmH0qSUkRgxaLrFLxkRRRiokpVL/qqCghMYt1KnwokapUohq9IAV2IHTEUNtlLBvfJFxXBjxOkd4MUf900p1bEc6XAKLGwy9WCcCc4Z63ENxuiIVgBPC+ASwTDiApEO9QpxuFL2DPELoUqbYYJgO5EApuY1UiDkTg6xUm5K9qDje40iOlMGhA8lHUsWRBL4cHL6TVCmVtExOYsljgTKrC67oE4DjSqV4cZdi5LJT+rYj5L4KlL5ljKCh1EKhzITXlE2q3INq3AnMKaYSekrV4c1tdLfcNCarzKHh3Mp0fMN0bJKuPLzDE8T/O8ywPEVneLwCJIUqgjTbu7xJ+0d/3E4HbIx0+LhEVE3vUyG0g0Qc+omE/+GKDmSZKLkNQHi9UECxmquftdDI1qIKkFrMj2TBGMwfHgs+WKRMzCTQXQQQzQxC5vMkSzBCrQtGLPOpryvNW0JGkbPQC53CbDulpJoh1yRKojQ/LySdhnG33RzDI/hN+9sBP2BK8RLO4oRRrpRD5Ty4xRtLu/ALVtDDs4yrBPwd7QzFfuROuCwMZgAjugyrTRu9sTPP8/SAZjAFKJ0VqNDLDvxAwWwFOqJPKjHM+xwG/HSEjVQtUmRBVRTJVjTJAb1MA03QBD0bXNTFA+VMX3SWCiXPz/S60iRKCrXTetq+P73Tusk2oJQIbNlTQz3UaPIB0Xm3ayTRd1s/eKMBGv+Aux2w1BZ9UeLUVE2IURnFiuV0AGYYUnnMuBtNgTaJwcazR1IoB7y4Tn0E0u6U1bT6zvDstDRSxL4J1FfqA2LylyrJIcZQTytthUjQxCyduffByCfRyPz8hcQU0zFtAqK7gSyA1jfQhRtU0wJl05ds028FV160NjuNkNhMCKCazZ3iU3BbRAxdUgkxu5/0UESl13SVTaTkEcArpu+SVEr1CGMyhUu91ODc1IJlBpHgnINFzipg2P0DHgMjjFflz2dAB3u8hwN8pB+tUQ7gzlEl0lq1VVwV2XrCM+xypiFZSmA1Uv4bGNUz1hObLCm4yC710i8F09USxVHM2Y/K1qP/W0luBdpOElo3VT5x3TdyLdfjUlrYfMZ1hZA/XVJAhdd4tZtCtdqrtdemNaUQBc4oCFFHNb9KDViBvVRNNVh1NM6tFDSH3djmBLqg24R3sNhNUMG3jNXtDNJZ1dvegTAlCNnNABMmrcK1a1SvtRJP1Qs7oA2JbLVUW1anqNmbDVMx3UgzpcE6ILJX1K1u5dZp81bPHdpwDd21odOb6skOUTunFbO6uVCpDTkLa02qNS5npF2mNc/F4dqu1V3g/FeB9Ygd+F2mHBOzJc60xRLjddjkZNgmyDy3Bbpf0z1V3UN8WAS5ss8FY145ydtBZLDh8YMdKouQ1TuJoZkLfKUO/3U32mjP4bWEIxEYklFcxpLPVKA57OFSyK2K/A3TCJBcyjXTGaRBIjNJzg3alvzc0B3dBI7Jo0Va2V1dQWVXqG3dCa6nBx7UpkU7DP4+E9jdDtZdS30cshVhTW1fT5VR41XeFG5YlLlDBnRV/hQZ6S1AfBinK7rb7MVhvN1b4THSrkimj4PK8ZWWmHAlZypcKfCJw9UEJlEEtVTcl9uOFAux+23WyX1WaI1WK9bPX7jczB1gBBbdAwZdMEYWBVWQIhSjmXRg2UUNPSPfdiWBC41jOF6jDM6+2B3cO/bJPRYAgWUYD/7jsQXh8Bph4vVUw1EAOEzk5P3Ujl3e7p0T7P9khYuyBrMkQHQoBRak2R3G4Rz22B2+ku9FAUFOHDEEYm2sux/hVYw4nWSSAnd70s05hWRgChWIgoiE4nGgjZb7CY7V3/0F5v7N4sekQRwQsrLZxQTmJDIW46FdPrQxUCIoQuhrYOyywjV2njT6t9fdZtXE5tM8O9Yk4nEG3kAGTku9Ri0pZxEWWGEdTpU93hnVShWm50e2ZxdmsEhzXicYQOp0h00AAh+dVU8+p0/mXg4w0s3ZSh+WOzFSDQd5yjlbryMQCBQ9HV2WgjLIAL2MZU7l1C9yOWwChFSojapxx2B+1mcFBmHGzy0uZgFOqTA2m2dehTG26SAE401KACj/QIEGsbsvk1d1TV02juA5NmoL5WaetONvFmdx8+MO9tpKDU4QZmdMPdtD9uh6tuetroqDzk4Cc4JNsOSHOweMfV5O7mSCVuuTXrD0/ISs7gKPzpIW7QmXaGiNMAeInugMK9E/OOIqVdzcCOmAymiMXjn8/WWVTmn+BWacbS0AHjbJROachgQhg2kDVsmbnukCLpadbgSfBuqkXdpoNE2iTs2jpmAJdkSmbmokBIB13kvYpmrZrmpRttSr3j+t1m2uZkDLK2g8AMu35Qa5JUBSIAUazlG7RTi1duSOXSvuTWgllsM1vEo4pJfWMC8xzO7HSF9465ncGIfnmzkoNtaX/0M59kBslM7P9Xbsx3bvOjBm/ZBsaM5pIQPQWchMAt5sm65FUejpNA5toExU2h1UtCvq1Ebw5lljCPbMCRlYYzImhEFnw63qCsdtrG6SztltFc5fU9U4fZZYSKvWGP4C6nwrt31u5WbuFd9eu7K0Fy9e6kZYKA3Y9dSJ75a7ws4A9huHQqCFH2+/9gOEIZeHlx3B1OPSjvplqoiAKo7c98bcV7yt+abvIFS2+/7ZAi3aooUCaQBtoBbwdNVgBs8E78vm00hqqV1qMr+JBnfwCq/wqa7tC8/tFNbwDW8S/VXLFj4nuIDeXwPuHIPbckCHe3g8tLzegRZS5u3w335ugv9GDHeG8at2w5W5Rrlrvx4XwyEP8iFHsVQY8iF/uZkzbDsQy0Vnb43kWI1Tcpv9KGAI4J0WoMz14s1NPmUrMvzO8m0NWv7p8var0zqe3azFQtZuRNROc+4z9tOdGziH80AjWKvMK7XFcDu/c6vYcP1lhTvU2FLl9m6HC5GhtU2QA3yAPDlYi0RX9LRecn5c67YGj/x6a7QdzhVl0Za96E4HdkDodH4vA3//A4D/9zKg32yaFBM0zPTW9idJd0a6FWJ+6VeU+AQgsljXdVtntsy9+OPjeFvE7CAEBibIM5oZ9tksdj4OZzM/bWSPWghZdjeXkDl/9rKlcxOm52vXbT3/R5JGx2d5vM4UUDyMS/crCmt26ENYvRN2b/d3h25hnfdpl/dhZZk+EIfy6nF9L4usd78gF/JQF/J/D/WRdrUpthqF90eRmYT5uTn4UXJYj/hZhwNaly2JH1AkYwOogzo1EFDKBgZB8Ft+E/aSJ/DWRvkyL/PnauM5TvxkX8011+NqbvbaXtF2Phw6l+uErXZOxfYMR4PN1/mdX/ImAO58Du4Fs967AIKBKqdC02HBqGK2HgwnuQq9zSuxrH0wonrwxvp+B/gOAIQij4Svv8SyCH7eDHuxv41XkNn7NXvuVPtYmyy2H4Yujm8Bui1a19y9bzYB1f781swIyLoFEu2r/yV8Nl/GtznNxU/wu7TglEdalacQmr/UPKF8e695m892z9f/zt9/gEAjEEuTgowOIjyYQsRCESpEuElh0MGDG24uQsyoMSNFixc7WjQo0sswkiNNOjiZcGLCT5aW2FliyY6UmuTKlFG3ARDPnj1x/szpUx5PnEaDAiL6J+nPmjWZoDAglUNFkBwKboHZSFqQrq+E8MnTNQwQVnXqDEmLA84QOG7dzkorFxLduoPu4pVlN+9evXz/0u30Nq/gVbEM3z2smIcDQfHSLJgybzLlTJYvF8hswgznzvA+g/YcGsBoz2dOZzqTOnWg1q5fH4g9hzJt0rZFb8Zd+jQX27Nr3/8ObrvSDpd+jPsprvx48ePOn1eKLp1ZdAXWqV/HXmV7SWQkr3v/rij8+PIDz6OXuDIiRoeM8GBl2X7+RvlW16vMz1I9/o8fZS4hRSo9EeXTTwYiSGCCOQm1VIKppOIUVM1QNZWFWUkFBFdeWRPEVl+FkEce0YTBihHDnDUXW23RpaJfgMH4YoyDzUgYYorhOAhjN0VWBHClAalbkJqh1hlrvCGJJAmwMSlckkkKGeSTv1Hp5G3RLYelcZYkBx102oGJQJjgcVemeelZRx6aazrCH38K0eemf/TVN+d9+KGkn31u7unSAzIJGAlPgibI04AICjXUgka1whNRREEooCD/HkZ1oYaNXLrVIl1x6CGmIgABxCvg5JFDFqcOg4tcKrYYWF81vuoqjbDamGMsicWSgCW0PNZjb8LlFmWwoREZ5ZRFftbksctWaWWxwzYL3I9XNhedcdc6hy12Y3LLbUoKiRcum+JGUG646skJ53vvcXRnQwxBhJCdHtE70rfn3ptneXoi5CeghAIMsKEHApKogkwRbLA8RIUSCYTjPNUIhRaGupWmnb7C6VgMlXSDE6eWErIvwKS4alw8zBLrXzLS2nJhL994a467oICTEg3INq2wQ/IsJZTJtrakslYuuzO0ROt8pbXaYveImE13m2bUZTotdZpqtjku1uZynbVJ/xKFtN+e8TESb7v9fZuv2vyyLbbTUjXCR6FzFzXwgwXTYrejoTSMtxCTSjMxhZlKY8emGHeYuKdTtXnWMEYYgRYOZ5XMIotvgfKy5i7bOOusmdsqsyygw4HDCub0WnRwzw6rGWZAPntsZ6ojfTSyPZsWre7BMf1JmFVDPTUzyHBrZnfkap1e18t7jTa6+HGsHitnTz/vvG0jj2+4LT0iFRNCDOiwoIIeSvdOOiEFFPqJ8s2331IsIrHgFjNRP6c18aF4h5JIEmpVH/wCA6KoAzBwsCrK1cGAl/tcrWrEMgZ+LnQS1Aswapa6oa2Odbe5AAc76LoPFot2GKyds45mLP8RAmtpT1uh8MZEPGYoYxjFu9rxsmfD8DAvh9hTl/TKBhE8wAcP1FOX83ZoxBUipBFBCB8S+sY3egjMQKlQHxUhhJOH7WRhkXBfKsICuEo1g34aS1xYxgExxfFPYjcoyS/a+IYBJlAuk4sjDxIAQb+IjnOEqQWM+Dg60E1QdKfoA+pgMcINghCRl2CAB1+XSBRCElmya50AcEfCo7Ewk5oUnirS1EkwYY2GobyhDktpRIOwgk8+rF4Thui8tZ1SP9z7U9wcVpPCLZEeX6jH+KQ4oF/+Mm8bEOYVd+LEgv3tlhSi0FbspzGwmFFxTEijGtkzDDdSThRyFIUCUXbHPIL/E5wP3Bw53RLIP5JuGIS8YNKMZhlGwrORICRSzup5yZ/hE1iVfOQJfdPOTQJ0k10Y6LaGN0Or1XCUyTNl81S5w1QSsYd3uh64Yqk9tL1tiUJ4BBBJMglpDKgeIu2bT/J2ByviDYsGc9/76ie/TI0xCBkDn/6o2S42thGbCOSmNusYK0DCLHN6LCfmgGpUW8GBGelAHZPsmUHWdbAG8XTkI50ayXs+lZ8+82ftAupVJI4phi4UpUIX6jWGEqShp4SoKulF0bRZ9KI1xKgBguBFAyADGOayg9yaKFKB3WGYgAhmodpnKFpEbJlhwGVM7Zoxado0XgX5xTUBSNk6/IJk/zvtqR2LelTSEXVl44xgzD6rl2YwVXWV4cwPWjvPqVKVkrPbHVbz6U6tBuuqJvDd0xTB26+ykKAvHCtZSYnW454VXQ7NU9j4NdGJxnWuzpWXARoxKjlstDtQoIDHwLdFTPCSUBDSW4IKdNgvLhMFG+KU/aQgBP15aitLuGllf2GEnFIWv5p9Y1pkZVpxAvi/5DynOfkIjHUOrVmvBU0mYLtVYnHVtrq9rSVrOxwEqKBfwAXrtoRLJjUVN6HIHbFaK7rck0B0bWl7a3PtFV3joaS6NAmcIzggMQrotQpVCQIg6gFeJCDBfIXCiThc+pKoXCymM4VsTABUla994HiPw/+vZavM386WlsANFPA5P5uAU/CoqU7dJ2bk6eASOnLCtdNgVits4d1u2GpflTOdjas8EiP3xGQ4iXJb/Fw7vZhtMO6I//KEYyhsF9EVtGuPMQFeuiEoUoIoXHrFuF6ZJlMKiUujk9fWuLNWec+hDuAbVDUIw6A6y37sMqu5bE5RWNCQMbDq7Rq5yHfKs2gDiC1tjwRJ1rpZtm/mHRLrTOc4GxvGZcUzifUM5Y5NF6P1CrRc7ZWVl1aTIkGY1DByPAkUMBofbaBHeMcXxZYGTrFJbuz9JGHk+c7pXKKeN7TpDbkP3LvUu8ByqoOKo1YDHLRfvskGZF3PMWfGzGUGWoT/UePBhiNy2EabuJBqK6Z9YTzZmuitxpNtZ2Yz26Js7dOfYUnt7HkE3hHwmExTIYeXd5HG5qpgKshtc3OL92GAM1ylC3fpbd+y3Tzv9JOfTe8p73mNSb/BiaZ3KhPp4ix1XLWq+x3wQPLRjrxohjrkYUiDzxpnvlLkrnGr64ef/UizRXPFKS5sC2fYTB0/dgs9vrU7g/y4fZbuKVk87ZM7N0OPQPQwqmtXlwNZDiEIAgcKiAMoNOMJ3vUrkHui8ye4FAg9/3lj3T10oufr6KK3N9Mt4oTTl+VU9y11ga3u789yOXRqSEATnnC+r4dd7AomltnT7uteM5ztu0Gh20uY/6SMzz35yv943st1ihxOYO+jn75+3Op37ElfT+maT1prLAm5tQO7heu2Xln+BMm3AsiVH2wyff6pMC7W54c7v9Dd//6zXaXFZIDo35duEVacXg4IIOo93Q38Qlv8V9XFnpfpijB1wNc9oGTo3m+83T7pxu68Du08mJF8kMRllfDpBvKB2HYs34ctH941H47NXH7lV/dlH/Ud3d+t2J9pHwy+oLVxxBjo4AsEEBmEQf5sgXYRkLlUyCIw0UmlQsZQGvxVjPzNH/3Fj/1VzHyB3pMp3RqlEr1cIb04XRYE4CIMYACiXuRwlmfx0RmiYRpK0Bkixuw14E48IO79wRxOIP9WBR/EZSBt1RqDlRkHhRDEGV/x7QxByF0JGqKxoSBaPd8K5pBeUUBmBVH02eAkohhcuY3JGd0NvuC8iMAYEIEAPV75lcX/ERAoJgAG7JkkXNdgddH+SIzmVYyGxN+m0CItWsz7vcSF6KJ/FEQXVg8vppIvTs/phcymhCFZpN7q+ZQanqEdUR3sqeHsRYADFhwsPCAddoAEQsavBOId7h5maKBlOFwfspkeciMIVqBsKZsJHuI6htjyOGIKquA8xiN+SaIm2qA1XeIM1iA+9l286OAblN8VdgxZ3Bep+WDLPUyIjMUrMuFizWJEImN1yc+f7OJFVshGbIQwemEsdiT/RNIiRFbMFqAKAHGTM6pB1jGjAjbj7G1d3iwMBFzjIdAkNm7jOe5ebgHfH+YkaeDamVmYtHwgOuLGDbHjmZDLUSplIsojPUKiDkYfVErEGPgjJfpZEclbVfojdUVPvQVQKG5B/ODUMGjIqCzkphWOR4qkSIYRLKYXhsBlXFqIk2lkRsAiqAyjRz6dWgpgMRqjSBagJ05d1vHbSt4IYbrkKYAbwXXAwoTCCNgkHQolTlImwtnONy6SVElVAVQmZQJiO6Wj0dhZcZHmITIlidXjPD6lPU6AVFKlVoreyFUiP/KdVWoiD21EqKyeAfEUN9Vbm9yAEYbAcHbRe3lKLCJj/yw2Q0lCGwdkAVzepeBYSnRmxOnNl15iZ3aC5CZ8xSaA4VoOIETowChoXXmuZEsipkvywgtsHApEgTccQQZYQWRKZh2uFsRZZmfORgFkZhJYwGYCAGhe4GdSoCBW3GiK4FIqKFKWEsgtolNGpRtFqIS6pm3Gx1ZiooX+Y12SQRy8JtMBUNOZ3iKACIQsHlpuxRQ+53JmBXPeAItCZ4v6j+A1oUPyjxMsQRppp0c+JHJuJ3e+gnfW4l9yDKItozO2oUqmpBuqJy/0QA8oWoZFhx28p3zazEz6CM4QKJXkzNo1XIMlgin4JwcFKK0J4k4GGyUZZWmyaZu+I4Q6qGqq4P9qUihUeqgO4OmHUqIkXmGG9iNs1mCK4eUj+uArGGDStVEBCSRlleVMcUMroJGO3uVeBgOL/p/1UWd1gcpIpqiP3uinfioBimrFPGdyiuQilMJXiMgzoFEUGiSpTd2SLukqyCqT5oKT4uonEoEhJIMK+GqG7UCwYgMVwKcVwMDN3KQSIGuyamPuSYaX9oaW7hoD/Cc8ccbBCShuRKs5DqVoIuiyrYmbomBqjhicdtSE2mlAvtEu8MIoLGqfUcJr3mMrpQB83GboZaKGZh9uQsRX/sIW6COpuSsGUCUAYloItELCKmH/YCcWdgwl/N9z/qKMeuSndCqoYmzGhqpaKqf/qYJnqu7PkA7pKMbBvqFnrdpqu+qBru7qC7Dnr/oWlnSJKXgAsVJBCxhrIejsNl6jBILABGrjtt4kDETVrZUptmbrPgktmhqoGXwreiSouDLoeSRqU0YlEK1muuZpybKrHbkkweop2Ohf24xtVk4Wn5XYQ7FSh3rMFermnVIWiT6WNaiqcQJmGFgqlYVoxHrqWt4iNXGFLX6qhwguxnLsXYLnWoospwxpQ5aFDq4syqasyq5slAIRzA4UQUUHzT4HzXpAzWaAfKZDOsxhTY5ATdbn0kIGmbkWT/JsHVpg7EIr01JYZjxtgpoV85FrnKJrQG7tnZKnk3rt14Jt2M5r/9q6WD/mK9rGlUY4wSK4AaIx6igunf/IIqt+p/WS5BqRTG/yFL4NY0Q27hOy2+Hwj8hq7MUmLjKuL/nWIuM+w8gyBBSYLMrmQgJQrqJZ7q+6bOZu3LZ4CXO4Z5XibBnMJGTO4c4m6+omXOvmBpfap+ySkGfiDpuBxu3mbgRsHNSeptUSqpxqLfDyVHnSKmESbJS9oGyaGKCeLeApRBc2wqFy7S6IQo3hpUUIbME+L8Nu7xqhxVy0xQFF2fUWY3ca8RGj0Vg8YRQWblpKpBP73KmiKvq+7+KORaTegOPlKv7mL8vu4OWeSeaegv9Ox3NwCXME6w68J87i7BEscAIncP/ZsfGx+hPQ0oYEx+5kEqXZZXDuDhTuTm33yakgo2YIp6tAuisN75t5pqE04inYHJ0QCRErPIS9li3z6ms+4uADOIKuctN2gSi+yaIRgOK/gmF9QY4oYBlc2FEQp0UdGEEYuMI30PI3XEMI3PJwuoKI8DISgywVMzEUS4P4LlYpDLNfGrM0+CXnla81qGKrfkpBGGn+Dqz+nisYl4cYo0EXZPMKcckZV0saqzHotoDoKrCyjm46j+5mMOsfSKAE9pN+7nGxiKNmNGi5KtQYg2sH3yNTsmYQhfC60nAdrQUjN/IueOjeLp0QoYsKs/Dyflxb/UmheSgoiwAZtpEReKf/DKMwZ71yHb3IyazIycSFLmwCOJSDO7hDOSgeOLg0cbqCLiPx+TEx+gbuFOO0yBYjMq/XFEMhfDVz/d2YF1vzF4MxNkOtyyq1QHizGQdrAB/HGniDfM7xEagzHb+uBLyuBJ7z7MpzxCWSBqVGHxPyPkstWd9z7xoyKI5weZqnrLYhQreg11Cy9FkyJpcY8ur18n7LpqrRoXnoG8UR+BZgWvjU8L5aygAxSa/KB2RBHrQDPqz0y700TIdILz9W/Or0+9JfyDwBTnd2aIt2Y80t4pSv/ShhqACR/u7vNSs1N2vCQCj1bL+sN3/ztfyWdKjCbkf15ybCGgB3HxQwZPSs/ztHZtBScO3Ws9ulNQYvVHGVtQcHNFtH7mEngHXXajO6qz1ScncvxEPvaV7vNUtQb3V1qEB/byiHyiYAAR3xgBFkwQHOwlnoAiVQwg8rtslAwivLskpPdi1zQ0zLNFh0p08b82gbMU0j+Gh79miT9oOzGxTOFx7Qb2svNXrQo/6yLK/WtrbkNlQ7B2+vgOfebBsrMH3CMQMXX5qFpmegNVm3qQ1d7Ywn11l9sFr7LnqfZB1ZN49fN0EPZi3gb0IDUV1PJf+Bd40r+ZInb9hQ9Bg88w3oWx2wwimfRRsBAXv/wg/DN1qwMiUEgy9EDmOrSpkHcR04wSZcQ0qzNC1b9v+Ae+eCn9+SiXYRy3mDl4Jpa5o06TniELgzq5xr0/a5zjZrb7iuumx5dI9MMA2Ii7gqrABvi6l8ymca6OzpSkbqTkbTXuZQvrgfP6hZ8/Mg0ziOb20ic9MQDPSPs7pbozq/8cAJx2t3B2OSR1cLB96nVO6mmsiVg6gA8bgX5hu/mdN80/d947fJMDaVz/I3tDmAu/QuY7ZxznSChzYT3Lmczy2d9zmm0S3+0K0RQ4xYHrUKJvrluqyGV/ihI7qviolF+sttf8lx0IEfPLq9j/g4h246VHqmI7el165Xl1Coz2N0O7eoM3nC9zMI5zieVrj3qoUBxXqPX3c1X5kJg+3/9AQRxC6EQ+O1wod3k1/EhLum0ykjysjRlduXfZtkSUfdy0edL7w8Y5P5K4M5ZJdDNkD7gPfye83U31R7tgu9z3/7niuO0XPKTGka0Pu8WNCtcUrBUBd1oWv44+FAruoq1ic6dV3LVARP5464vUcHb8vsClQADYRu6G6jAjdtOG7Gpx98aUq3qTs8wXrvqvM4Z+H9LdzCq8P6dp8r2BhvJivvhrpBin7AG4FvDrB3HA1QledA4tfBMFT5Jsj8yxuBL8g8G7CBLLABJRBDMESdstM8JKB5NLgDOky2gLN+z3uROGA2guO55A39V+y5z7uX0VO77TP900NTElpDcY5D//tZghekO9UjWtZf/fIzP7t2MeHFWRkTR7VI/3QI6xpUayEg93wWH9MmdVoFMow/bfSNuo1X7VoLEHUr8t7nffvnPW+qckqW8KLqoGzGq63jPw5qiHgKNkAM4SEKyKIcQIz8qvPmQxYjbwQKrFOKGCUjujDaighH1ixdlDB+xFiHzayIJW8NgmRy07dy7NiVK+eKZgibfPi80pkzjxCfPp8ELTVUKFGdT4QEVXp0KdOf1qwJgipFCtMgOwUlBfo0KdSk48CmkjKO6hJGeF5AUasWR1u3b3nF1QNXLpG1aNGc8lIFQV9mn/xWAgzYzw7Dgv0kRrx4BeI9pnb4kJyBcv9lMxnSYMZshnOaeZ87cxE9GkDp0Gbw5lWEB8tqNK5Vx977Gtls2bAV1LadmzdtR7+BTwg+nALxXxGKJx+znLkO5xjWipI+ffqugaOuD9S+PTt07INqrVJj3TnrFGQ+nFd/Az3xJu/Xw5c/n358+6zoi9AvYgx269rfCPADSrJwaLqB4EhgCFwYxKUOkXTRCA6TNGIDIwt98eVCk1ZCSSVIdAkmhxxcycYdd2T65iabeuKpxReXGkqcpboKiiusbNwpqq2kOorHG38KMgSgWkllnFbGsmYcqBoxC4q66IoSyrjsqlKttJDjixEH/gpssMEOW4yxHcSkw8wd1lhDsin/KPvDhj8K8cyz00AjjU4T8CwtuRdSa61P33YDNNDeCNVt0Cz9FA5R95RDrtHmnnvOO+oO5I6HW+b6zzpNu/NPjfDGG8U5+0itz9RT20MVVfz2609UUX5hRb+F6jBCVicQOokhkBoMcagIbbEFowx14bDWYBzakEBdVMIQ2RxaeikmFVfEydoXZ0TqlWyb6slHHMEF8lusgiz3p3GSumlJqIw0Ugh0cXqFCUsiYGvKKKvsgUq3orsrub0eCewwww770mCCC1uhsUoURpOGNqcYYQo4KQ5t4ovlPE1jvWL7M1BGD8VNt0JFThRkRVH+91FIJZ2U0pf963RTXiwdxWbr/z4FNQEBU6Ck1J+BTlXVoM/b8r39yFgOOlkvClAUXD54xpUcmhal1lJ4XRBEYioCqdghhJ0Fko4eRHYZYor1xZhgSurw6lJG3ERamYysqdqeYMzxR6xa3Fvcv4W8NsgioyoyrCON9ArxVIYMAohhgHH6Zun4tZcXy63MXK3izlptic8tAcyOgg3+kmHHFEbM4coq+2PiOOWkOHbSMjbtz5TNM1l3QQ3tXUtNfi9590UZffQ8liXVYXKXyasu0+dr5iGBmTfNWbxQR/0gd6GH5p5o7/Ez9Yb99NtS6VvQ/2+IB0MsUCGSTNrIo4tCpP/rDksaScMNU2rW7Q9IMow8yP9EWnIAh02ucUA+XENwePNWHrQFJGvdLV0/uUO8tuKuCd6BcYYb0pKKFAnDLe4nNulgCC/4iscpBD2SG4MX7PXCzeFBVA+gQL9kmBrQDYYJo/tE6FTwiShEQQpkGtPpBPMYxiRMTZYxg+ygOLs0wC5OjcLdFYdHPJIpInjBs83JiGe8lSGPeZJbHvXQmEac5UJmCbBeLQaSPfZ4j47ds2PQ3EA+/TANIpdaUHo+sD5bIatqWpuFLSjhC1wIK0Rn+1r+kPXIEGUIJWLrCEdWspI6sMIJLXEHPlBErWskkIIzgpG5XmFCOcgBCUgw4JAG1w5YllCEG2xlJHBZyyK1Ipf/uhRhK3wSAl4KsxyRIKABX7EIIPTkF5S7wRNuaLMtNAIKeAiCAaqZzGauRRpBcASW7DAOOwQxiGTZoR3GQhWyMIxM7WQnwpCoAjOpbnUZsII901GGKMopTlW0IhZTlkXebZGgvAOjca5IRpeV0XlqROP00ogpnIXnemrgWaqOU0eN3rE92yuVCCQhgqKx4hlOiEOD6hCMTThhIRLJwiamEQz4mYSkFaEQGyixjGBchEGTbBBKguGMDFkEF5k0qtaMMCJolQMdJyrHAaFKygOKY0ZURaVPVslBqN7BldcKgTHlILhUdNVacgjFCc8qhVZ8wYO/ZGU7ikRMAxZzrlnN/6pMTCrNEADBO41YhHOEwFcsDImGdpmAMKNJgSAgSQVo+cQ6B6PWce5gLO2EpxEHljrFLCYZ7ySYB1iHz0Lok7SFuB1ABapFLhZ0tQYN42tRS8aWzfaM0HOoQyGqRoqKB1NjAOT30DNHjtrHo/XJY0h1ID1WqNAICREk/KQ3IYs01yLB+kiFLOmRLAz1fke9RdhsodKdFvWo0hvCgJyAnxx840Sg7Co4SOkiqwoOq2T1KhLA0aKv2hcnXK0lTnBZ1q4Os792vSU3bHLXVyIwwW9NxQf0KgSl+RWw1DxsCBzhnSYQ1rBKkoIKqskIyP5wHBnYQRAtIU4kXjazKy7Ti/8964E0eUO0RxAjalO7qNayVng5BmhGZUtbhj7PtrjdRcw4NTn0jU1n06vDcTK6UeD+jDXhUxVI+UMei8jKIQ26FP4WSRJdEKNAj5TFINCX5u9umX9qdpBGJslTsUHNCNk15Es92dQFKzC+DQQwflWp1TuEtb/taGW1cpnC/U6wq4DA77uO5FZDQ5VudGsFgjHNDQJyYwyYWmZglUdhKAhBEjhwxJDcsBYDEHZUVJHCJ/ikAhX7pbKAQVMU2HlEzO4aTDD29TwLI+PT4tjHIfPijokN24QyZwJBftWQidzQSt0WyemL2SqwnSDoxOE4CZHylOPjsym3yjm34CR+OLn/iSzoyggqpYRE2r2MZZTikSUhkIYgKVTs3mKSzHLbS0HyPqQOoSN/zAIxSnGNAmq1z372byr8eyJ3gOMOE/8zxRHNSl8+mg9j/eWjO4jfsW664k8lIAK5cWlhusIanA6QCJjUH0n8dQykHoUjksJX6UhDCCEAMRSWYI2gLyHWUhjnasMZhcb+kExMV52vjfh0MXkpMMAG9rCTnWNk8/iLWQ/OC38B9mY7e3nQLjK1kZzk7vRxt9quZpS/De7fEs0N59FjQ7JwUgdlIRpZeGS75UzwWRBjGpvAd5oTGaFK5nQZWfuph7SboTAgS5Hrm7PgPwK3MJQiBJ8M5VbF6vGQ/3OwHPTACVzz8FXSK7Djq8ylMA+d4AHrkg+sRKGl4QqOY7oCwXk4SB4QkgdXOcFx1mgCFGYOHRUSoQnyKjUOxhCERQihsXhAJyOMjhZGBHbpXGTCrEsnJncu8ddTr7pgrN6n3Hkdi8LjetdVdtAoOzt5CzW7tGubnUthR6LckZwbQQWO4qjb4q4A5a4JyKc/0kcgVoKQ6Ae6wCa72CfxsAvNxqZDEo/yFK9/OOLyMKTwFA+TBI8jhKUOeKAO8gBF2gGUBI3hYO+pbO+AXuL0Lkj36krAYO+VcumWDEj0As2AeBAc2OupEugl1A2AbiEOhO8WrIEVjqwgxgC5kg8Ylv+PDFQoCJaDEaxBEl6hsaLPGqzP+FiD+3AjnUqn6czP6cKv/HwNeDThxlgjDm+j2HasDgtK/kAGeRTK/u7vyPKP2rojeg6EI3QGOqBs7grQyg4wVfAgj/Cjj7iDQQYpGIZKIsCmfb6m38xMzcIGFxIpGIzBGN7NA8EMQwLPzjBpQmrFVlLQHejBlU4I4nLv9fZr9ToOFmNv0fzrBXcwruhqRXDxF9nrGyBImTbhFX4BPAbhA5wgJZ7BCUcBCp/pF6awCgMrCG4A6JpQCFKgwqxJDGXt6FYLAVRAstYwDQ0GHdXRDavuDbGO/RLFDt/vUJQNofSQZSbFhfgQ//jRyKr/bTsEQjqiqxC5De6EywAX8XgQEFfORzqapkBYASOy4BrorQQdJBoo8pEQaRmcwRgeCX2C4RjYBn0mabwqyQM7wrqaSyNrBQITRCAmEhy+gB5e0a1wEdB2seJqENByEZdkMBJkb5dAjhY7rtJgUKsW4QZIYnpe6g3EA1fA46U8jeaMrxoFCxmTb+ZEgPp0IAWE7gWWYBxgbSvFcRw/YSyWoA3PcS2pDh3ZcdjWbw4PSh6PbeuK7Z+6MQ7pT3mebR9r6y/9MDAjilMs5Tpoxo0qKgm7EhERsjFHKgWwrBuTkBJKirp+ShfkrcvE7CNT4hZAkRK95rtC4qfQjLs405Am/0QVCYQiCikVJ2QIOCk9nqAeVFAWRejQKA4WYzAGJ80mcNOYgjIHgzM4n2pEWC4PWOECQQEUhsAgVOIZnpEyrQEioFAHZq6bskkSuhIrsfCaboAbdWAJWiGkuLARykkSqs8sz3Ic0DAd15AtA4OL0hH9AuMd4VEu51FL4M/HmA1S8nIPcagP+/HIMCUgnwYQo2t69A8xr+eiDHI4DjIhjasgkCZAIPAk6me75Kzg1CwT1SZDJATN0kwl9Mdr2mzOzkwVQbHONiIBOsQt6qAtcE7jbFP0Bu3QWulGg1GrcjQnf7M3Y1D24Mb3YHIRouEDXnM5QQEFU8IapqaTOG0XgP9gOnfhBhZhC5eDD/jKDbjxmWDuPLhvsaZCLILIGspyS2BNBcQT1wwGxQTDTdmxLeU0PuVU7P4JDl+LLvNzP10Ld/wzyOrPLwFzUBFU7RRUML+DorDnELnHZxqRFdBCQsUOMm8FCPBAErjBCboREg3JJD5iuzTw8gYhRNamJITlMylxE1GCkernRC8w8qYra6ZnJUQBGIZhfK6UFgTNJ9+KB3l1N301WBln9nCPCIXuGZDxDaiGI1CQG5hlWc/sDVzhQTahDpj1FW5ADaYUIuKg5WjO98IzD7oRKsBwK8f1K2HO+LbPPOPQDqwBMMrp1doUxcgJXt1TPee0CsiJ6D7/xwvRoj/xNP7wU08Jtk+zKOz+8x4jRcgCJFD9g1AhNu2kZ40+pVMwhUEbVC0Ycz3QInzwID1kpbiCZgwgtRE1dblUCFnXjSSTxQi4xggQiRgc6ac+cRSBChq0YRki5GssUsxcNlVpBTVBBFQvghI2bxgeJFY2r/VooeOESZjUwa6ktgWfSvZ2dJVgMPe+YWuLKfXkgD/Qh5MgQQ0WAUmf8xuYBVk6IRZiYSIYIg94IDwgQZmklEoxQAS+YTrHYK/CdTm4UDtTYK+8UhLyshGEIGDIsDXC0obGUF7Hkl7b1GDQNF/p9Ica63LPAmABNmD9pGDr8nPxMKA0F1AdVlDz/6//0C7tDpMwZWaiss3JCnLuIBVSiUshO0rcSMVRqywycUUEoHMUjSDhKMEi4wczdYp/GEREm4XyiKXeFg/hiFZW7Sx5m5OBjrEn4IviBK3AHs4FQW9rGScHIa4Ha7Q3aQJcfwE6+8NoP0A8nsEI2LZtoYFZdCEaKq+kZIEyU3FEeADmIoUb9NYVtlRcrZMb+GO5RKoV+GM5ttKGxOkR8mhLzEmIUsEs7BVzu+89IxdfvYRfyelfc0gvbfVOBfZP3pJQ+qJg+TSMFJZ040AfBfRhleyMUFdiWbcwz4hBcyt2tYdku/GHu5ESXgh31QOQ7BSIH5VVHscJVEhAksXyUP9SuqiLWB5vVTNRE1e1QsoGbpClzFoKQ0nKa1uQ9WIRrUSI9b43q4RpmMZXwVLO9yz1DdijFgZBWaGzCeN2EEBCFsAADGZBkTzBE1IqMwkOgOiYI2JlFEK2YRkyDhgSpPAgPJ+xK0NKC1OtY73zKlwNG4MuKagiTeUzg88ClAfjg+uVg3cM1jzYX0EYyDh3oDxXhUNXL1u4POgvhiM2lx8qt7aDUnQ4VN6uh4tYe4g57HxrY4E4ZElFP5wgIfpIVIZip5A3uxCpZlXKFzRi36z4I/YHAot3Jd+GKOLGbrZKe1WpaX+QR+8gavcM9AINhVQkmdiD7V5SZ0YU28BAJQL/uY/5eJ8Ljo8JcTlfcjpe+Dl6OIfUw4d/2FETtmiKS/vyyAAeIQUuVwXOg5zOQ5UnN5QHA00LFk2JTk0395VLOJZNeoVNxpgVNmFtuXRxWYYHtYYRdZcLM46gAwAJ8k/Tw7cmVTiM2Hb/86M0VXusI2xpgiiuGH4AT390KjTZYN+0OEN8gX56qlhe9LxKRAi5VqvLeYzbBeJ0FZ292q74LNNS7tKKESFM8JADWklBoY/xGTzweZ/puq75ua0PVaJauiDHLguPZ6RtV4RFGDYo2qGDiKJFWZRT+ILhVR6/RE1FANZGl6QFimAXmy98p8eGp5Zd2KVpOGL1mlDbyB99/9l6FrU/dzppfouns5BkIzUvRZZS98Ok+I26EK4ZmkYkFuSRNGneQJNnM9EjMrO5rplWPtUJSISrt3a5u/ppY7FpdVVdmnasMa7B3jiZVggHXHS727rt5ppt4Tq8xTt+11YZt7tT9voef/iIAzsuk82iC7v7LFqxORpf67BzNpqVW5myKxuFQfe/BYqzBTxATRembSa0P1uXb7iXlcy098+Wh5nZUGaYdxoPCMSjGoJSubAJ+6gOJu9YnrhT08wUpXp/TtJTlYUmJm/zagJ8Ram5zTm6y1irZDwWu1qNhyS9AChB3yjb3Jq8xzvIybu8VWI8jHx1XyW9l+OgW7vJOf/WvQMqtgv7ou1OvvH7pHEjPRE7hEk41lz5X2C7c7GcLruOylFmwAHVZviSLxGcUBFcoto8zke7ptvojcYje1CbUdebp/MSmdtDP6ZvC/OOIfpo70rB70bCuB/EQfQHNElTBJ8sDHjvGxKIucv5G7YXaltwxjk9fK27WpALEhOErUl9t75byIWcyM/7vANz2wp6spm8Y4+4p1HryeEbUrX8lMfRo01a/Sq6r2+Iv8Ucyy/7DmfDzBUFzffSs1tGVNpcwUGbwVu3Ukz7cgrymPN8p4X4p9ebmMNNP1IJwQ79ITZiIhAuGrBm0Rl9JZPwDbj5tx/k3hKOuekd02F80N7/eZ3HF6z1fdOfdq7yS56byXXdurvj+tRRPZ99vGJXfdVnWsmzfYiFmNahPMqR3cK1PLLNx5R3HaPvm9dhIzX0e7+FfXf0NIUBPDgyNy6VnbP7Mh+TB4bLDtqe/Q8XnMGp3XpsenRjndlSG4i/fQkwlW5oAgjCZ33iHeCqpiXhh1sZIhqIEaYwcpTO+pVu3JzNmXz53as73QZZRJlaaCAPueADsLzBO+HvWhnBo+EF8XlivsknW+xmF9nbO6AMGzKrrBEby7APe0t0XRHqLpUbO+S9vD+C/fD3hLJzh9jnEej9FOJbnmF7a4a9w2mYHdrPjnpwfnLeCBKeDWFHhdu2/33JI/7nKfpW9v2VkBOpWJO6kHYI2uIkjllq7P0oL/3qr56sN13GDWhqv54/Bh6ny57slRThUb3glfEW2B7t3h7W+7zPuZzi7d7xEXDvqzyjQf7jP37wR56WjdlWgeE4Cr/kCwrlG1/9/jryId9hGVZ5yu3zRaXZMd+GBxO9B/J1d74r9Z/bdAEg4nyIM+aDwYEpfhVMaJBhEyCvWkmUQzHEkyxGRNUZhhEHjjq/smSJUAekkSylXrkCdw2cyzvfXsqcSfOOzZs45aTaqZNnRYoVX4UBcgOYqARwaintxBTUqqWxokpdBaYqVatYqUIdpKar11s8EoQdu6usnlFo0/+m1cGWYFu3YwrGnUs34dyEDhfi3ZtQBV+/eP4CBsxIBGFFiBkh9ss48ScVkPFInkyZrlGFCilozrw5bmXKaEIvVjC6UmkEqEer9sIai2u9gQPbpfuWdu3bb0e1XYuh7S0dum8Hx41hOG+zZ9UmPxsWuVmy0KPzUKpVzS3db7LH0QXXtl2HDfeKgDhxIjg+T5oZqYMDV/shdUpd21Sqfp4QNfPrx/lS50/+qQAl0U4xWRPGDW8MIVZSSyUlS1NTRZjVhE9xZaFXGIpVVnPOjdLDcbzhJtdd3y0UF18o4iWba3v5JViLIvTlogpuRFajYquh9lhkPH7mY2ecAfmZjDn/kqbJaUXmyOIEJZZo25PE7dbblMAZ99ZvUWZZ5ZTFLeelch06J52GY4mi4HRTDQKWdm6xSRsZkqVIxpwPuCFJeQKyJE4pw5TEUSnigFMOOOrEdNN+iNYEYH8C9pRKHs8s4gQrCTLo1IOXSkjhplpVeGGGXoUpqlpQbKnlmySe+Bdlq/YlJyuxxQYrZIYZllBhKSSZWI8/eqZZqb4GGSxoS+qK5K5VGLtknCvOBqWWVEYLIpdYnpoldmCOKiaHG264YIZlgsUVVmpqNxB3BA0kl5NzouiGCBE1SqhLfOSRxxPX8BFoojMVWqg5h94BsH7/NaoTepJKIgkrrAyEZqYQ/2vKaVYNgvotmdp+SWq0Ij5roonfuVpQbCk2KzKRKh5Ga184MvIJjrz2OqyQnf0YWqwrKnukzsu66qzHtKE1hpVbYssxldbOJbTR2faS7dPIqVGW1F9hqGZYYIHVVadPJTAcZumC3ZacKdzAAUSRyJtTfoXO+1Kg6gysHx9s5wTUweiVMqlCNzDssIURc+3J4LEQvingXnEVlnVaSw3149gSMfRuQHt3Ml8mh3zyYS8u9lBjccLsmMvJxizzKT++ULPNTLLIc2qwmwZ7zxMQ66tklQvHFtMhdhkl70YXXTTkYOaSMVlUh8VV1lh7xfXV2YkiNlxga95E2Tc0wkfaef8uGnDbAYsDvsACl7Hov3bbJCAfkpod4w0NMczwLYM0ReHg+Ftl+POAK97VLv/z1igcl7FsiUhyuUPVzDDXFxPNyGczytyt/DIrZOHqZRgU3WciwzrNoG51tgudzmbnGMTITkmvceBncvc14E0LOMIZRbWINi2oOY14AsyhxZo3pq11CnpTmh5ChtiuIm4hCDxJBSDS572XqGN8N6HF2rynPv7ca2EK2cUbfkEnVjhhUkaIAy4eVjj9VSV/aIxQ/z71PwIG0I3G6xARnlYlBCbQcidaV7P2GJeGke2PE2TMjVpGugwiy3QdvBkIEyka11lwZyRU1vVad7I7/m54wqP/IQx3R0ccelJUbuRW83aINa1BpUJD0Ej03IQqR1DyemjjXtpu8sR+NfFQtdzJEpPYxHttIgdkSBCZxiC/vvmxUkyZUBr3N7j6rZGUA9zFdTqUizhGs5O761jlZhMyVbVKPKHLFQNLNklxDlKEoivSjhBJLEV6cIOqa+cIX4es1uHuZ7izpO6ySa0Ygsl3nwwo5DB2sTZe6GrMQ8oplSIWXKyyLSChHt+6uAQhpG2XS+TeLXOJEykCSIk4QQK99EYUEcDqYtmRn29OqcyJeYqN0Dwe8aAwx949yY7bbGADJVisb5aMp4qZjOgK2cjRGTKopuPVBxlZ1Ecq4jGRdGo9/+25Qn0m7VRL46QLJdfJG+7Cq9b8p+NCCUBvSS1rMK2a8pz5Qx6o8qHmqt5E7RQCjWYUo4QalPc4CqCMzjIEV4Qf3/zmJnUhU3Au5R/izmpWUWorrNjcpGRpk09g5ZRkgMysZsuJIzcM1WUxgqquiGojDeJsqZSJZ1OlKlrWGmmqPRuRVa9K2xbys4YCfZo1CdpDHh40Oj5s65raFFe5Xu8BQaCIX+/qDncIiq9T7MkS/VqvVzyhEc1oWCqlZ8wifqAOpkTsxJqyRv81Ly3TvOYnveqhmnKVcrZRgSU1pxefivOPD4TMfTkbyM4qZjwZPGqPjPrILiiiCwZGMGJUt/+aojJrta6NKmypOjJ8zpa212LaJreq29yWlUzJk6by1srG+l3MflZZ3nDhatyHbE+Wd4gERtXh3DuUo2Dqg7FNhCAEaThgGEAWrCg8wkVK9G0gh71KYqWyWFKWkoAFzO1kbWtZyNzxcvo1mYvktGVzpuBl4sxcYDT41MJYIsBgVg2PCmlIBSPYzZA8VpznrAIJS3XCr9lpZTF84e5QWVqRG54NPRxAAJ41xAa1mnnJBAlLlfFBkNhudkoiUXPe6aIxnq4carnp7qXtxrMUwhPa5wiabqS7XJyTw8i45Ke8NHGLs06oQjU1yHrYgPCdL26YxRZyQhCov77vA8f52fH/LAHNbT5wU3WEwTjTwUjMiLa0mT3tattZziik3Z77zG3bBA+GGnbvrZ1j6zCNtdCK7kp5Iz1iBhEO0rhwKKUjmup2IRekslQHqGUMCH5HAgl/FfVQtiASDkygOKmGn6oJQr8ythoqO1TrudMbtQGyF0wXB5NWJ7tNKOFTp7niXJhrJWzQvW+/KEfMfi2I7JbDDs51huTLZG5ta/uh5jUvnY7uTEg8wyk2VjVst3NzW0y6MOMDLbe5t4W8dFutQWdydJp4cAt5s1Iv8PJ3v0Vqk60D/KLoIUo5h7GFsmNm4V1i68O7FnF0Ly6Hg26axulY01xbtbKzEXPKyyaZ0CLG/zAr8nvL8MtZZh+bzS5/LZ0hKbvGV+LxkHc8zmNHwtbyzJV5xsLQaUOJzRNdw4JWyw3juNu0KH1UbxSguhVtoUZbyrwKcr0aqX51rGsPEKH4dz3oAXDe/xsQFsEukIHBGQeU3eyqLo5CqaNMZnpqOhYrfYijPNNPKk2bHc9jXYId5pLTSMuwAnzJfd3TMn/i8JA5P+XXH+eYM97mkn+2JiIvefanxv3XVnlr9Dx0C3Obw8HhXkiHdGhha6VXPGMSa6BSXluRFJE2CxCIKSmGUJXWd0uAAk/AB080XbSQN0zQCF6wVEFGdgQnZEeBFK4mXmlEXibWOGT1YdSnLRu2Ma6R9TU3hX0LBHJhNgZZlnK1EnjiBCssgwcNEyMiV3j/dWYzR2D2Z3+nQX/V9mxSCIWTR1TJhgywpX+Yxy5B53neVhtZpVXjNoZQ1nRPx1AN6CBJAYGpFIFOkWJYY4PFwgwoIA1MEAR4KA3NYHyTUBTA8IcjaAAGt2rMxzVKdjj944LTNzUwuHSmV4MBxXHbVjmTOCx5ZCN613crN3Lfx4nlV3Lnd3jJ1oSTtzMqEBAAIfkEBAQA/wAsAAAAAOABDgGHHgsAJQ0ALBUFLRkILiEMNBkGNBsLNyINOBoHOR4QOScTPEUqPTMbPjgiRR0IRzQbSCMNSDkjSSkUSS8gUR8IVCsVVEwzViwWVzQZWCkLWDkjWEQpWWtMWi4aWjEOW1xCXDIdXUEeYR8BZC4SZSsKZTkkZjUZZjkkaVtDakQqakszalQ6azILazslbkIacm1Sc5ZzdEMldEQrdT4jdUszdjgLdjsZdkgneEcyeEkqeFxCeGE9eUMZeVIteVQ5eWRIeXxieksyeoxueqmEe0Ule0Yre0orgT4Ngj4hgz4Xg04yhEomhEorhFM1hFU5hUYRhVo7hVxChkgmhlg3h4JeiGZIiJV5iUYZiVY5iW1SiXxjiYZqik0rilU1inVYi1o2i1o6i3FNjFIqjJyCkKiKkkwckk0kkpF0k15Bk2IxlFw4lJ2ElX1ilm1SlqF+l1Yol2M6mFYbmGlHmIZmmXdXm4NcnHFNnWEencehol0col0oo10ypG1HpX5hp2Iep3pXqHRLqINcqWUoqWg2qZl3qohlqpJrrHE7rKJ6ra2QrnAtrrqjr45xsG5CsJ2CsoxWs2wqs201s3xVtNW1tnlGtoVatoplt97AuJNruKN6uZl2uaWEunMtunU3u4NJveDBvoE8wnkuw3s0w31CxHw6xn04xpx3x4tVx56Bx6N6yIM7yJZpyKeEyodGypZsy4Q7y5NYzpFMzuK80Yc80beU0tGu0uXE04s+041D045S1I1K1KuF1L6i1ZJL1cWa1pFF15xm16Z3161017OL2ZE/2ZdX2pNF2qNp25hJ3JVK3KFZ3ZlL3ZtT4phK4p5h45tN451S5aNb5p5X5qFT5qld5qx256dm6KFO6LeH6sWT66RU66Va67V47Ktj7LJe7LuK7MF+7apc7bJn7qhV7tOu8KVX8N7E8Z5U8atW8a5y8q1i8q1p861b9LNj9LRr9Lp19bFd9sJ498qV9+3Q+Lpr+bNe+bVj+r1z+smG+8V7/MJ1/Nam/OO4/tGM/tOX//zlCP8ADQgcSKAgAgcecnxRo6ehnjIQzUREQjFJGYsTK2rcyLFjxxkdzSC5CJGiyBkmRmTwsHKECyNixMSRGfOKjZtmGkXSGYlUz52NSPkcxTPSnqMNJb6JM1OQop+eYhWTRlWb1WlXs2rdirUrsq/XsHobN5as2XBox7Zbq46tOHre3MJ9K3fdvbv08K5rSzeeX3364AlWG9gb4MOIE7ujW7dx3nd+H+P9C3lyZb2LGc91263ztmigl/WK1ar0q9O3SnstNWsZNGavY0tLVrUq7XNVPWe+i693Pt/AgwuX14/4cODy8mX7i+8bPsjc3i1vPtyf9eLXsxvffu+b9N7On4P//31PvHhu1cRxM8hewYH3GBQiTRqx/sUkGJWe9Mi//83//2mklEUmSQGSSiutZMMVNdnHA06DNEJJURJW6JOEolyIlH5NOdWTKqrl1tWIZ41DollbgeUaNSWy2CJfccmVl2OaWZYZjGtRRphfcSXmI3l3aUbjbpJZ9uNlRT7GjZA3pvUZbKLhQtovVJIGjYvIvKKLV7JN1SVVzeSG42S/HXdceNUVpyZw3IzHZmVpaiendsVddqZwlC2JXnvv9QlBfAu94dBD9pWEX34SfQTgoSAp2uiiARooxX2TJmogCyQkqCAPDDa4xKUWRVjhTxaWytN8gjK1VENPhQjak7iV/yPrZ1zVGtY1KoZVlpO8pjUmkzEy1pd3mOlmmI6FBZvjkUA2OaQ90CZJmZFIJrnYZrvx5eKrykCp4lfIiAWNlLBx22WYs9mWFTt8FUmemfD2tiZ3a9qJXHS+oSnvnPvwe51336Cpb5lv+qXnO+4lrPADGITQw6qDFrqRfY5CavHFF1+h8UgYFYiSpgp+WtNSG9fAoKhERXihUKSmvNOGqzLlYSuwlPsqrbPm3KKtt+a684vKAiusjM8VK05a0yYbNLNA8ni00GxJSy2x1NoIGZFNmstlt8yMJpW45MKq7pey0drZXtcSrHa8ae4bHJz6LtdmPuXFeV2//vrTXMBmDv8cnl/CqJePAhIsTDjDKjTRBcSEFnofgZZudJNLNqhU+eUjsDA55ZCmZMKiBdY36aUrQZDggvrVRJHJb1Co01BAvW6hUfTp5xQlX4u4lc489/yM77r2CvSznD2ddtEGG3900kEvz1zT0A9NfLW8kVm11Wl7FprN53o9pZfRUKn772SXLa5ukq3NNnLzHgf3vX5RZ7d1eOeNfLx/0130MelAdvjhDAjgAzaQOMY1jmKHQtRGRJApyzXQgRCMIKYy18BIjc5QF8QUBTRlg4eN7A1iWF2oJiS7URGFZaNwWVJqpwdIdIJm1ojhzWrFO1uRD3jiAlqvBtMYHJ2tejbyhjL/qCG4aTXvWM+DHt3eATXHGAk414siE/fypK5VyXtemwWITCOlKvZCazdElxjNx6IfVm997HPbmvCEnungyTzzs9+/8NW+4eTvHelxR3kE+D8BaiAElYLYHjhkqENh8FAPTKQiF5mplijSgpEbHRE0uMGQleEOnqIICfAzqqCsjCcUeplDIKKq2+WCezijYQ1jhUMuBU+HvhrSEalXmKf16EfFu6USm7Yk6fGQaE/cpRSnSA0o6YKLIAJFMjvBTFUw84WuilL5xhjGE32mLWcUzsDapkY1xu9eweFbHPmFHeKg5x11HA7B0BPDyvARgH4ciaBGKbGKUEojRzhCI0HG/89++tNzJNBc6AYkSQRV0gMviQlNEiXQnJSQJ0JJoexUSM+mjOKUzpBhKje6SllVk5q+4+jwepjLzgDRMsFKIt2ax7QlLtGXPowaLclknpMWq5hWlJJplPlMTvRUmVv8Irdu0z3ahAmk1mzXu9z0m23Kq5trVBO+nvo2NMqxXv1zjt62Q5y4FY2dbcTHA/hI1gDygAsGdFwCS2IpBjJQJW9loD/nmiAT3GCSATVJx0SyMSRQ8nRnJRlaDZSETTrUky0Dyid3Qjv65EEQF2WGRnXXURse9aM3XNcOf0lSljotSSnFpWeF+dJenm161dIfTZEXpMxsL0rITGZQdXrM0f94S2y28VYYkUoipa7tO1aNar3Aob6aupFt5fwXvfBojX0Rh6vyoxpz3+KcshZEgAw461EuWTu17lWTcXXgQVlCV352UAkzyOtAE3WSv25KoQStgQhMJipQLvaZiBXEKOPQkMg6g7K7qyxuLtsMn6kSLbxj12k7C6NiVSuGwnheP16qvMC09DAwLV720tfUN+qDaunQHtekiUXbojI2riFjUY2aYvCpmCx6pKmEkSvcehFMTcqx4zehWuP2HW2qxqHq24LEP8j0ZqxlXYAAQTLP7tYngQpEQngjSN4qU9DKIDsvXj830I241yUeTJ1fN4mEPcwudkFBLH4hgao9pHD/KpMVqYA9WuA6G6OaBzbbZkvqw820s1ndKLJKlabLQbuUmLZUsKKxxuGlRq+1VBxbV0bsYq2Z+MQodk0yNs3iaY7ILlHkcbzat2MPQzGN0BV1b9gpOO/IL1/hIRZYjSzWCTQAu0o+XAsm1Wa13nM/moQg5iaYOYAiKJEtCQIYmFC5ERhSnh778ufgOyD5jvDMJ7wvM9k8qJ7AOc5yRgcreWdnAvcswLCMJZ992c68UJiIv3Vaj5xnaEAnOpfRupq94n3om2pPo8baaGhKvKLXahpcnD44ZsUS46nRuMd1AnKPnYq/5hx31UzknzWicxlxstG070rBBsa6gJKXfMlK/2AIqgiJH5KIriIuKXazAeo5mh+bJTVXghPQK/P1VqRyFEDIe2ciWPzMFwmxy5B9YbcTUZzKIRmqjUiT2rtm3IIY5s5suHW2aLT5mc+vanhr//zbCtfbR4iOqdcZrQ91DhnS2HKWDydbjFx8z8S4RbgxrqhwVzI81KJeDsQjHuEbS/XVcOSxc2IdTu8cTeMmbTetWYvoyfugByHYgMlLbgEl71oNKh8ky13eMS//xyUt4NzMa25z1stA5x9ziccyYlCh25XafNUnfRm79J+umdt5CMVF/0v8vFtTlWHJ0tXrfBWtc1R7e46W2tkSdnsE0aSHgeK9zx69gE9f7DPWMf+S+nePtaONL5HGSt1p6y0tWfN3tk1430+sx1gbmfHcTK5wARdc4qqaTXzjHNIxXUMkQzEkOAN4FwEDHVREfngBBTuwAp1XchzwARbQeZ+3cqJHEvnRctCmSTeRXhjzOS6wesVGginRAq8Xe6jDMRwIdEEHWLh3ETVQg0kgKrx3Qk23g2k2H1FXfGB0fFW3d8sHFs0nhOG2YJyxWdzSDifVYNnHWqF1Yb4RJN7XLovRP+BXXGzSHBxXfjcShj7ENcckW7jQfmc4dfL3LX4HGls4eWk0L3OyRnIjOKm2fxIHHvmiY191DJUGcDMVYn6IgHokB1UggRTIAQvwAQtgAS3/oDhNtoGOw1YZwSiNsmsgASAAgoKeMzk5x4IX9GwweFA4sVBSgEj4YWY8eF8RlWYeIgpbUnzjlmdqaHWtYWC3EivsMotc13VLGDQIJhbXh31wGA9mxzR2MnbRx3alpk3dMYznF41okVMgAk1hk1Mm8hrXtItgwoa52FvBVFzboX/0MyeAAw7LkQ2DVyf+p471Ak5sJENcsz0yBH5TtBhl1CSGKIEfoIgVaHIb4ANYEImjN4k/p3oYk4kt0GwsmHoIYlcOmQGNwldelgExaEmp8wRJYG1ltoMpg0Jrtmb+pTUlQosp8hVahIs3BH0AtmjqxoT02A1Fgn4OqDbGeIyA/7EsSfNu0Pd9Ygcv0qWF0CKNLEmNWmIl3PMLyhSMVtErmVZwSXU9okaO1sEPckIe/reOEYeOdZQNcfOV5WcNdVdpNiN52QJwtvQDOrACirgAHPCPFpgCAkmQ1YYolAJsl6OCIbiQCsmJwxZzN5cCMWACpnN7oTgpH+MApvNeuIcfAqWKjBWSvvdMNPNi2WiSAgd/Kcl8r9WSutiLizYXesaUf/cY0dhoLzWFzBNM9BBiV7gWvUQkbcc2CgiGRFmUWUQuf6gMzoQLpDl1bXgWe1E13OSO9NMv9aMdEZaVVGljefhGReNxQSIiMQQl36aErsUtGqUCKnCBE7h5jhhI2/9VkAR1SAiZkJuYcylhkRs0mOvpEoeJmOu5mCshMplUWJoDmavYMiBZmQDWOyapme53Zzm0klu3jG0xmuFTcDIVjTXJS6rphEmDmg34ktKzbx6mb7cZK0NVhseEaSwCCpyADAlaLsIThJq1LA4Ih2vkD8aJnDCanP5AXMzZnFvFf+OIY/DTHdTheH4oDXR3W69ygE9DkqARAX+keZvHebdHlxnha5LDl5oopX05pRThkBcAkSlRmPYZOVtKioFFbWOWipHpkUpHmdYIosH5jT9zhCg5oL+TmSU6bpRloSc6j0Rkmr/ibjaJkzs5aNlpp8cYLxpKlEA4cOwXhKAhorT/MY0piiIkMkNokTbhaKP1c6nKGWF5kx0TRqM1Oh4fVjAgJpaSFaRCOqQidmK2Nlbf2QAnN21NVp6F8hAfWFhWqpC4mqsBwgd/UAh/AAh/QAdTkAKdGEiWYiAxWJhcZqwaI1+sU6b7iUJvRpZIeJkBWmeowZlbR6e8aKeSCiWlWaFrF4UrFSOrGY72pmfrxqdvNKpFaqrt5yqpKlTK4FNQWa0Hmm9b2GN3E6PlOEfCYKlXCQ50tEa8saOFShVE6kVegkpBKBtIFrF+NAEgMBK95jgPkQcvp0lXqquXSAQeCxKuQA7yQA77QA7DYAl2MAXFOlguawPJmmxEsDEl46w3/zgI+plYKOSfKGqtPnutb4p1zpcV4CZp6fabLRYNWLingGquOTlT5IphPbmuX5ih94ib6bJ+fDePuZli9hoOlnmgTUmMychj/3q2Vxmw2CGj5nhOxilV0FEmC8iAzCUmrpm1Cbebp0oVSIYBDPO3FFsCTGYGETOJjqMRJJirIIsTi4urV8oEqMAP5GAO/GAO5GAKfSAH7mkDiyMRLxuznEOziJRXOet7ERVZ2shRr1SSPwucArp8ZLR1Ukd1Tsk9wTMj4soWTfsWySM19YaPFnpvhOhhB5OqsVF3XzElqhF/yEQbykAMTzF/+CpnObKvwtWvMXqydKKpVzVcbeJjcf+7N4ChhXfrJdKIt3tbVFDSMCHQMIIplyrQKFigBkrhZIbrpXsZsor7sUiwC5VLuZa7C5YQBetZip4rBcwGussKX6dYOc8KrWiaQq1AVKqLfJjZfHsHIinGrbNblMF5p9IbU9votE2Tj1Lru46Wk1NLk8aCgMIUm7jJvKhhhtUIVF8EG7PgB5BAYvcqtiOMuxx2vWibvf8iDC/KtnSSDwT7qc/BcdJ5TgcodefHsMiblLqlcH/0vj4gB21gB14sB50bq092v5FzqwrpHwbyBsPAD/PAxpKbDZgABsdmrIM1AwrMubzaCEdBWI8ZSvgVUR9qPj+7unNWu6/baeOTuqv/1MHb0sh6Z4SKBppIY29iNxdQm8Lv6q1mVB5Vk2g4ZUzKS8OxdY1U0QlxMKJ7542KfKDY+ZNQNcTHaR3ZwL2xjMRwy6Kyxg0B8zeOlx7VecPRiL5VfFvDPMwN4749MAVwAMbMXL/j6XKOQ1CIe6s4UDHyu8ZtzA/anLJqMMcuW8cqUUl6KQVqwAc4ywXB9qx+3ExvFrts2rptmjPcuBpaBCLdmMgGWsHVysOQHMnUe31Gc8lKtCvY6aibjD2ZjKhZZIaXBqLMYMqdgJL87LBJeIVBrEabug/4QMu1PIeeClw96nBzG8XIaw2ckVt5a8VrOBoegAEtrWVdAAagN9Pz/yR6LYdB+lGrjnmrzNYfiNkF2KDN2cwP3EyYf0LO9AtCXKAEpHMCjnspE8RAFmHOENxMsTi74sa68QzPCXqZtljPZzi0eee6QohisYB14nM+v9kiM7lhTIKa3Vd9WeOGB12oCU1pWot34Eaq9AoJcaAKj7yGnvl8K2y9Aqs38WDEGc2pvRtrxCJdCP3LwJx+wtzQCldiVhYDXcDFcgCsfIAGgsQh8lQokWTGG8HUpy1JarDG2tzatIAJmqsggiIqfPDZaHDbWBAFuo0FzEZsAfVWaGVmvUcJI4nV78y6/ky7u/gMnJYarJF1WpG08RycB3d1QtvDchp2AS2GMgLXgP/2wyWKqpUcdyz5yXgq3tSnft8TPmxWhJetkt1Kveizb3Lktt27lS6sxNhDPZGWcFOM0tZZzAlXW6ns0i99VnYgCQoOCHoc2nZ5v3w8c/nLZEiA2xSBBrbNELU9DJTb2vvAzXcVE53N4BVS27XN2bXdBSI0OZhys1RtptEkyLmI3P7sqPk8GFaBrTNcboKsraxL3dJk3b8g1mU9qV/H3d3Nu4bWDjfjktpJpEieyeUdLAvmGbBlz1TRCjoc2IINDfFdK0/ewlUrxHpTDfyD0XOI3+7gxONHviuqhXwdNsb7lO+90pzmAu0bAiVoBOXM2bcd3ISbKA9eT+mcuJFSzgv/juEKbgmnMAqu4Aq78A0wapUCLAcCuczLrBMmjuG43enojNSDtJH0hYOqCMiIPLTHPSs1bnAMF4w6niGpHNZiRGc+btx+J9FCXutuSkaiKcKtrORLHuYeTNcFrS1XeOy//Ao+FU2iEHzqXeenXuSWCYgYarCCppU4dgyCZhlu7uYJm9elOrtXPMzQzmlT0APo/hIwEdM0HdzPfNM3zXJ83HOlKAeVAOnY4ApoIAnY0O/DMAz9HjAxCsd/kAZQgOnLjLMzvfCLw9RLzWvmTL8tV7qloQsqYsWpXiKRjONexKBe/aawbovRjr5hG1K4nutEvnDGDuWvuWFLPuVzjt7I/z7z4T0a2/YKQ+QVnJAHrQC25b7Bzmc+airscZuV5CEO2l6wZQJx7LTtTATDdIE2br4XXLO8D8vqdr7ScAB6AskEOsfuoDdYG2ISZPyCEr6XXSAJkA7w2CAJfBAMuxz3znGp3wDbaXD3eL/1DA9CMf3Nk7LpgkW4pT7B5E7nGS/Pv5je8Hevi38LpZAhE7yZsS5pPS51lBbk7Dfrr/KUsauuPtndTbtDnUHRU/siaHnXZXjz9/oL7Y310qvyi2+E0l7XGloM206jqob0yiBogWqAvz76WGT5lA/KWd9izaw4COz1aJXU7k6e3uWY6nUT+x7pu7wLbr8LJatVfFOyz/8lD9+g7wuf94GyEH3f8D8dIecc+GZ2UZZ964ev6hv/i4Z/2c4UCme44wTOSpzv/roFEL8E4iI20FgzaAnPLVT4zGHCZQrDTaTYbdtFixk1quPYTtxHd+/0xSNZkh5HjBulrVxpDWM0bdRkzpxGE+ZNlcqQtVLVyaeqVsyiuewltJUgThEhKmXadOnTh8mkCoVasyHObulCag1J1BpIkWHf4SNbluw7a8eUgV2ncajLmXBz9iL4i+pdllCn7o3I9yEcOYC7KCFcmMthxHv0mDGDxHGZJGUkM2b8GLINzCRGOHYsadc3bKhMiUbDZ9cwbKDlqZbXel/rb5rgdElT23b/7TdidL9Rk1u3lCtXxAwiTty3mT0+cy13evXaw+fXxpWjzs46uuvZO273eBHZwe/hkT0n1jMUrmelOJXS1b6uc7/R5UM1eKsgeIQMo1bVafOlyo24cwckcUwaCSUA81LwJgajU8aqB2WKkJlfXgGqJwuLmpCZYmBSxY9OGmxuxPz2i48/CK3KqKu2YBLqK67ECgs0seS6By23GpRrLvc0dBEvqIopakgKT3wGEDqS5EOOJZtUY7DdFKMMCcgko5KyyqhMIokabNAMMyTUAGa1XUYpjQ8sJHEFEEBQSW21b1xrbbVVZvvittt4s+3J354QTkrK9NhjkFGC6hBIq+aD/2666gS059HuIq3Iur7wE4i8UDhZr5lMz3NvFoIaqhQhEkcVz777LtVPPxMpdPA/WBkNcMV4vKHHQElz1FHEaZzaUCchhQSqE6CIpClYmDgBkdciS9XLVCBbXfQtuBTcaCtutMo2Rms6ZOslanddkK73FESUPiKNtGRdSSTpo4924WWTT8YWuzIyfLFsbDLHWNCMBDAB2YVONDYL05VVkGCBjzfhjNMf2OrMszYx8sztuCrjeGMxjQVVbjlnFpwvJpJLxi5SSG+9UeWUJ53uVIOuwcUnTtBTFhL2CMpQVEuhFQ/mVIOWdugUWQI3VgRnZXnABDM6F9jofu4rFqovJP/W0FiF1VCQPLB+1tmvwQ7vaat8VJpAAr1Ku1qRxzWqR6XMdXvqdE9cFxO873aFXUDoxfjeybDEt19/Cz/4TUkU3kwSbCoxgQSGVaNRzmxgCWzi3QK9eFDOI6GEFNA/Zu5QiYo22WTtUr4xH9ZHOjDpiZYht75beNLULkjiyMPTnMFbSfaepRY+aPDKHZrEtpGe9VoWm2abWaOG58k8ULDWtUj3ut0YvbycjY9UY97zy0ixqYp1x+dbQin57n2uD8Wwx09mwbvZLeQP/P9AM/PjIgtcMo5ZiTNJGAHAWHAEJAhMNajgw2Nc8Y2E2WAUqYnTN6pxDGyUhRuwOMQdcOP/wTTcQYQhLI4nWnGKQqWQJ3DTRfRI1yBGJep0K2rLSVTWOhzaMGnYq53VNHU7ZuQuDzgrFC4y1EK6+eVS0kPVe4wXv+awT3ku8wYNmxauc7mvahfiyXiG0jwXGQRkuhgifMB3PCXuTH5rZOPY4GO6BaXvKqTTos7sAkV0rdFoSWpDFfwIBigEkjBECM7/rmQlQ/KrXzUoXJceuEBJmKkRn6lGLkaRjof1w4IYNAsHRQhCEB5ClJ6gxAmRNcbfsRA/zjldK2XlqJXhMIc6DGOFRPFDEEECiEIkYuhIYUQkhu99w6Qa7UB1n2OesXxkO18zqeiyrLWPiT28UFGycj1y/50Qa6PYXbWU2Ua/qBGc49wLHUdkzhdK85QOqdvsjlm3ZpVqSDH7pg/sKYMUpCAELjBBP/sJpitxLg+B29JlFMmlRtbADM4AjeQk0YgJwuYerMFHtoqBwZLAgpQ+UYQoR0lKU65TGrn45jDzczRXos5RqnNdS3W4vu+YR5fr0aVUeJnC0AHTiXYkXk9RZaFjvrOk4GSmuKZ4xYpAD2hbVGM4wFjLFUbEUMXgRBxa4ZVvDjWNoNIqOb3aFJF+LVitmp0wjXihePosjybliwZA4AG4ViADc43rAf1UBo95zieNiATnLmZQP3XpCIM9whsYSkFsVLIRwKBRatBSjXRcUP9IsJgQLCxLtVMsp2rapNo6D7UXVZr1ITFMaaMatdJHuTSWtFxJe0rxWtslJRc3nR7oMPQKY/40aMXUbTXNWhf3dNVZrIKjDJ3pH++EFbQGaepToeq19jhjtnrAhUXGKtyh4ha7wVxjUL7aTj2Cdbm5LZYWx5NWqdBOtAjRhVwrIAEI0LWuCs0NUiBaREvidBR8hYRi/BfYQg4iF5CNbDqkOwpnXBAu0vXsTjrbYN6Cl40+9R1pS5s62J1WdUtj7XJvp4vc4RW2r70lF3ka1FbstrdApbD4mhG8ZRJXilgx6o/QmUR6VpGW1QpWuqAxOjJSV53fnUXvYLzd9Lr4usD/K2uTQyvhJJO3vFKDMo7Z2gz3xneu/+RBE96gCBPqolCabQ/IRrocnPZ1c4TCLzDc/GZkwbnHTpYwD7k7zhaftLQqFVCGdeyRDXc4yZEYoi47pl9f+nbFTbwPFx0dNGoy+qtEY6WK2CZHqH0WwvPsrFN3fCy/tHbM1jgKJG7svuyyh73xKVRWo3zlO9M5Gfjt0ZNjDdxIgxfWS8V1MAvIAhN0uTYffbA6Q3bsY7cov7Tu8Qub3dolL1V2KS7pTsOn6jM2sXcoXkh1LmLc6GBYO96eSUUCzTSiaFZZgtJDHoaoQhJfLaoorqa2I21i9uZa0mKctLSkCKRMc+jUJ/qW/9NSCc9lS8MapIiDqY+NXjzDNnjEDKatvVrWUfxW47ceLzLxzWt+d1y979ETHA7hiUdk9s2YNl+C/9OihzdY5kNedZ6Fe1ZjZPwcLxYtvZNJ7m+XTDqvFPe4y72dGEFqHdAGMVJCwTU9bKq2tp23o6tp9XtPGecs3rfIQ33qljPzxqdk8F2AlJWVYZPTRLIdSaWRu0g8/Ls8J7GlgluKbGe81r1er9ctvvGQc/zeFOe7rLeeM1VflrJqOQZcGl9jbXRb4eiLOc1rnpAfmei39nmxUHsm6SKnaufFO3HouZodC4+26H5OqobRDfOR7ncUoZsprVMo7y4OPutYvw/dH//d9Sc/G+BPSwuynQEMaHv2os4Oe0cgJaI5F3OeHQ2mIMpACm/OPd4qbk/nvc9zWxf+1aXPOeDFT3jdj/z8G+c6cBf8+HAhl+jHnVvHtcurbBdEFMRgZ0/z7/Ht8z6d0r+6AxWMSD0VWT3Wowis6LPkyhT98pwxI7P94qzc66HdS79TASpRaL/Q0im46YuZQ5YdMTDKK761SItcAAbK85blGTIQHIhOQAq3C7JS+LZou7kCdC2NC0Axi0GdkrjCIz87eq1rQ7H16zVqKq+BuEAkVD+d2bZjeiYqtDDrCBlYWRUY/K1iKZpq2z+G8L/LCxr2qLvRMyvE48CgQD2h6zb/BVxAccGmD0M0/fqcX7JAn7K33lqi8CixHRzCeSMzVCLBtWA8FiQwbUlEyFrEbWHERbSGR2y8R4S9uzA8nYGEZYm9dkOwY9O+UDBCKTSyzus+vUvDNATE0mOxMgRFDEzCE+M9J0RFIgQVVpy/oiuHejA6oDtAoUOXw8Otl1EUutkZ8gC8YpSy+zhDNKw7T8EOoNMPZ3zDXQw6o5mVWVsPbYrASOir4uiEMFsO0PvFWKSy7RsxVbK9zFqFQnGF5WMoRXxHR3wHCiqwxHIse8SkxLogYTiGfVQ8ZWg8QzwzQVRCRQCRbVoMToQ24RKSnPPD8vM5iATB2tLDvts2IXzI/3gbRdJ7wlfsQNP7yFlMxSAcyWgsyVyEB11kQ16cxrLpP3urmaETRpf8OZfsO/2DtFO0O5/LFP57xleRxvXxyWrMERCrGTTTxgBiMzyMMHc6P6ogs7PyQAGcHqqMpHaJJAQLBnvMR0XcFsfKlnqsR3xErNSArGAIBjd7hEoIhL4hDpRTvIFcyp7gGlVYPksaqKvauaU4siSbvQ70yCP8yPYzPXNMMd1bRVVDzFsoQ1okMb9ETFaMSAtxSMGUzIjcusMzOpTcTO5IyZVEwF6JimW8nV4UxvWKPF6bSZy0DzOMMhIrMp4cOqBTPaDMsBqTC/X4paNMs0HIjbsqJRTirP/zgsFmgzI1NL0oezGcogTmvEqrXDmuXMSwJEvqbCjqjKxdOMtgeAQ6mA0e+E4eUAM5iKTMiksenB6uqZlOFAXdQbAc5Esxg0DGFEysI0xzbEyLZLTI3E/6LEdxPM7J5E8A/T3LjEzONMkDvUUrXNDkqrnJ3BTSGpomakljbMJwnM9gos/Y1EXa1DBpRKnzKbEyo0NuDDCOksDqKbY4Mrvoq8FPIczlur1GaBI+mFHnnD01AQa01FHphKzq/NHPCNLsZIVUsAQo6IEe2Kd+coEcaAIwYBNgUDy51BQReoXKYs+uUcjx08kiI6L/HFA1ZMYdBElhgrecC7359M+GhDf/ibO67YvK+hxMw6xMcUxQO0WZk/TMPQtN8LMQIKLGqDnGCUVNJjM/oLjQi3St7esUYzAtSunQ2oQm40KQmdHNZfOlbeSaK2CkvwKg9PwJZiPBYIlSozm4WrO9OpxRGm0S/HHOU0AYN9NOWdVOH8UGSrJH0cjVXLWEMLiBfAoBYGXSfGpSQHhVCpy3GaxSZ4OEK8jSkUKyV/ghqoPTOLWa1xyxa13CNPVPMQXFcuxWqrNWEaVWOcW6/YzC2TurO83TdQ1KlnQl0eyhT7yFZ4hQsuqhiCBUv6PTUMS2wPxLCHRDb5OIomNXOOSVY/vDx8xU4ygDu0IkP7mrjhEUXdIr/+YUzkFkviUTs1LEUb4aBCY5k1W9ylVAGFmFVVg9SzeD1VxdWZQdjUKQA30a1g3Yp18FARlAAzWBy80CBbgjBeazPiEz1QqNVqToWHDlImz8RPnMVtZM03/91mstQLyT2qSlnvy8LTAFU47dzxtsV85UOj39TATsU0ZdFGmx0JPyOwAUKqe9P/vslP1TSVu0DoM9WAZUH++YVr9kWIoV2i5Bjt70TQDLl/8RXIrdxm20Q9sSRMwLmSRbtlZgTvFcVT5oVXgp2Zfd3L1BGFPgXISRBEvwXF4NAn0C1g2YWZpVgSAAg5LNrPJEz3drOcjVgyQYWoY0v/DARC+FTHPF2v959dp/JUDfzVarPV7kHdO31Vo3LbKtBSqwvdu7JVt4pVDYnNcSQdtKucm1tTKPSz/WXEyJc4i43dAEdNRIfdeh3Dr0pNK/1VT6KiXmHNzgICzCMtxCKiTNYbeoU1zR6ZBzUDbN2q9BEE80OODScE7QRZi8qZ/QlQTRyFGEQQW8QZg+8IGbBVYMQN2aZV0cCII/sATYhV1KIDQ/qMu3MJqjuF273FJco9K/xE/jXY/gZV6qTDRsxcjk3WEejmFVtNbnFdcAlWESi16xnV4GZdB4va1VklDuDUYrQ8JyJWLuIeKAbZGFcED0bddo0tt0VVT3dTek6K8n4NSTm6zJVbP/yggs+90SNzZc3dEYAIpjMa49UJkqaXCz/VoSBE7gPhAN0tWb+glheLmfd7GEPnCFQ16F0WUEmO3V093gDtjgCNCAmk1d1rWDSkCYEZ5BGtwR5Bsp23W46LtQp3PTn5jXqwFebJ06cp26qe3hHU5lP/RhKr7aWN5hg5XeI+bQPU0U33Pbg+BT6OjD04PiYcSttp3iaG3GI4y3eeUIggW0Xu5MO0UakuGIhoxKTx4o3dGrPCCsO+iE2MWsE5VjyqjfLRGsiC2kNs4YOtadXGrcFVyFGe3jBEYFNWkXRq6fdSkEQ8bcQi5k0R3d0YhgXwXWB8CAhWboCXhot6rkFBjP/5IVYRK2nveTrjdIgrhLtz4FQF0KVxxGZU1h5ZFGZarNZVmG5lpuaQIV6VsG2B7e5bBdKV/+5XilsLS9SXqNnS/Uz62V19h8hq69pR+qLnUYypdivVyxTQaU5sPziXaLYzZjz99UuRZNY03xXyGKZ3aLA3FuZ6+eDKqu2ObE59IYaHcpZL4RaLcW6LtJBVNghAumWQ1Y6IeWgAdQgL1u6IkO4dGFS8pqx/dTBcgQBJe7Lly73mr93VTGRjqkwzBd6R5mWlqmbMxm6b+k5pqu5gMVWOoAt9LMafXaaeRE5mReZgB9Wj9MJWgOaWl41ITgiFvxbGvejndN6rjt6ncrlP+qeoLZHb4RXaEbTsM084N4puOv9mZ0noxBoVEEvtyrJGi1FmgkeWvsjoISAFbWrVm97msFSAADgIDv9gEmqQSLFmwhSewEYziOhsTse1FpHUmqLG7eI5JTQmP7zjjJnlpQfUyV1myTDuKVblpp9YkjTnDbzo6aUN+12rye1LzA7Gmfzr9i4WlmflC8E7V4qz3Z/iIOu23bdqY7rNRujjqcsj4Rcztp0l2O68uRvmxcgjp5rq/x1B/plhfszh8loYPrRhI76KMDtidBigEMiCtMvuu8PgAmHwAC4GsMMO8QRm8qN6HBPsS0uKBDgAzDigfJ+jFOuy2BezaEMzNLO0H/FMzq4Uba+s7Gon5MHAUdxmXcv6welGZemQbYA7djmsIQQNOHk9ywBXfw0dYqSZPw8K1X1DbmRQvqAAXgWetwPxCEWQi6+fG0EH89zsbbvUXXEwed+OwYYrl0pRoeSluKgTtHv2xO/GmSNuDxtw7oHg9yWhdyJwgCJO2BX9UyuFIBFLhrvg5vJ3dyKPf1V0+5Krfyi3o8FVSD7zSDU/iGxyrlFE1BrkBzNIfHd1wHRISRa68hcIeRr0AQ4yNVDjdMU7JvV1Z3PNfsx/bfkqbhP9v0Qafbd5Vw8NM4RJdBA6xwBz1UDB/iwTTDnYutTOHdF/md2b6h1WKakKhm5Yk9/242YRRHM45pRnExzWkBUfozOOiZrFOIl1dvgzbI8R1nkloP8ioApCmwpxVAUhXQJ/gi74VGARWYgPAW9mEngIXegB6Agylfy+a0cvhuPHtujO+khGqoKMYTOIOwdpEwQYWbvOILSORrx1DOepczQUS0Tq//erD3erBsqAITB0dM8yLxxzmbbHd/9x96++p5nZdScDjEaTQ6TdLmaTMK5oLoz9VuTO6JPaM2NEq39Etvh9WZpYdPu3AnccOMt3aj9Fw4B13YgxV/3OodGdmsW6bufLdQiwcueVff8T8QfZRH+ZVveVy/Jw+W+b5+AAuwgAZgAJ0XAGJ/AInegWOn8v+hX7zi4yApwIzwhIU4UbCALDb97tu9Wn7F9aiOYv6LXUd29P2uD3t8qKA4IYs5WQ3YgA2K2n6IMQvWaURxNzhqJ24gPtE+Xw9QMFgdev96J/S7z/fs0nvi6tMM91b6bCHqAIhWpQaGggQpTx5R09SFi8YM2TJl3uzpq5jvIr13Ge9x3LiR4baGILtt+1VKFy6CkQ7qiTQql65QccqQKibNmsiQ43Zqu+bzJ9CfOesRZQfvKNKkSkcabUoS57FjsCpRtWOVDtY/WrUW0oq1DdiwcsZicdLERw+0KtaqTaFBw4MKGiyoiMBAAYEBegXoZRBBgwofUOg8KhwIkKfEnk7/FYt6SpIYGyxIsLCRZhW3zO+ESYXVipMiQaLflCn95DTq1Khr8HhS4zXsJKyT0C5NWs2gQXwQn3oMCxjwqMGGE+dcrRq25Niq7UqOfPlxYc+/Kf92kXo869Q1K9eoWRx4qFCB24QJsxV6Sq0ose/k3h58jxnj06/vtBz+/Dx78p8Gzf8zASYzYDMFQmQMggYSqCAxDc7yIC4G/iegMRC+4uArGYaiITEEdeihh+eIOApBBSHEyTNPOQTRQhlhVJE74MnXEXwqgrSONLjomBIppICG0Eu6jCJIGXnoApVO+4nYH5P7LfUkSFAuldN4wB22m1VbaZmVVWN5SVZZaLWV/wKZbPmwgQoWbICmmnYpAMBeAygQF5ppDRYIVZUgxp4kraziyimDSEZCBoXyAMdvjsVCiSJxuAZbbEesJukVqkkK6WSUESoCoZPBNoMUXJgxqqhqmApHbqjqhiUge/L5qid5soeYJJXEamslvcGyK6/B+XrMcZkF+52wwYpnTXDl8XpKffPR06x9TOnXJJMUMngttglqa2GCExbIoygX3vKghhuWONCHFpKCS34k9ijKSgixm2REykjk4otPxUdjjPeNdBJKKvkBJEyinHgTTklO6yQ6DTv8MMT+SikxTypGBQwmhXWZpZZdffVlFW1UEQXJZgWxAg0puwXYWi2jgP9Cmmu6GWdec6KJMhRhcByrq78BIsVknApdQxyHADLIG6e9xsNspenRkntRt+dS1LmF9jRppcGmaWWe2vB1qGHzQIQUSJhd9tlkXyF22KIu8Tbcccstxm23pXEqHHmvyqeuvQZnTTXAGjtssce1A+2M0Urb1MLVWpttt5AjOC662ZaoboblNhhKh+mSO2+O57L0ykIOrVhvN/jm82x46vRLn76uH05gwKGYmNCOkJQBiS4IJ8ww8BEL//DETiU1lMWrVLWxV1w2L5bIJYspJsprvbVBCTLH3OYEDdRsAAF4PfBXnT3knWWrrTYCyGNmaFoo/B542vVkPDitiHsZmmf/kzM2kafsrtIztT1gTWtHeE3XPtU1yTCwfp/6GgQj6AIJUnCCFWxNpdA2ttOEilRvMJXVrAYrXf1tcNVAnHwUx5Ci+Eth/RHQ4yKnrRnSkHKzkGEzwGUuzL1iQ+k6F7lOkh8hvet2oWCG6U7HIvBcBCP9okbsDhdFHKFkQOBiCSd614mnzWJJLhweGO8TxjEiT1/IkkrGAOElwtQhEFnpg1fAEjI5Sm961CuTzK6nx+7dJQE1u8v4bhYYH3gpfeqjhK14wLXKjCBT8qtMa+6AP/Qo6yHS8F0So4GsS1YSJegRyAALSJv5kZKUCjwlplCZyqUxLYJPKFtqIEibWWZw/222HJXdcnNIvnkiRr5MHIxU2ELGAeiFMTwQDZM5rgTZUELfItcOg5g5IILoQZwrhzPO0YwiGrF3msyk/1KHj3Hq44lQTBhJjLcOhlSRiKWIlyBE0YtWiEYhIkKnGMkIpYaxsHhTckqVlHcljrnxjV7JghwQSkcd1FFMDLXeHu3yF7tIAC9+nJMEyIcmMtlpLFox5PoAQZq2vW1sC7xC0UARi5UisaWcfKm9iglTSyJznjv65CgYRcBRzXKVqUygT4NqylRKcJQRZOXXToNB1cCSpKK6jUY6IlV+1SOYwmyc445JO8ktk5mfs4mCyoWuaZqLmtUUooiS4a6CcGJg8f/8JjhbKg6LYMRGIcHnOmcXISuKwnZu3VE8vYmwnQyzsMLrpz79uU5k/UZjXcKTx7j0sbCMjGQPRQtDLwvRiPKxohfNKJ02Wqa06AykrJKEIQcBhy6IYQmvlOQhVMrSmNKWpgGSqbdiuoyt2rSdKIHJ1FYymqxVapZLVVork8saSDFwawh0YFC/RlRZ1rK6tbRBcZc6I7paxFmsY8riIGZMrXL1pttKyY4Y1MO+Zo6HZrVdNLEpjbWu5Ed+UIiK+hPTidDVnHAtY0l6VyGB3XdAoAGdwoyX2AVTLIxSFAdn/pSxr3CloJK1ikIra1k7ZlYHMEOZ9t7Sve55tqLjw8D/9crEUUJ61GhWS1+tasUH1d4Nf4lZ6W9oG5Qd7/a2Pfbxj2v6C/PuD6c4dY/VRKNkJc/kDk1+MpSbbJpYmnQ2yGVudI17weRukAcceVETw9zfqw4zJLklb3kdNLnKnReI7iXIe3vkzXO4k61YbMUlM1nMmKYQwHddJzMoWTt4yesZ6P1PghmMWMTy08GLbvQ6oxMMV2Ci0l4phCEiS4csTJayWdhwhwUTah9Uj0x7LDEEMnqB8bWATGrBQcq+8CUav5gqq4BFI2q8mNn6T8dZBTKwf5JmIpvXyCQy9lqLiOxju0tqVctN3WYyZVpeCstYtmCXWYPtGoi522D27qPL/zzeNCszvcVus5vbO81knytcvetGDukLTz3Y0z/UwO1to+EOfjkJr+qY50MQ5K6D8G5y+UaeYg0LaUaH+7CRjo4pVmFpPDEi03WY7FeyoPGNj0zUo74sqUudpuuRuKIdeMsJWv3xtJxvLHl7+W6o4ok0FC0W9kKmr/PN4507E820M/e5ie3bTxJd0ObxrScFfWSpgWYlBNRDlG0z7S5TfZXkvLq3u0vmfI47yOSeHNAh1OayjrXscWbvuspBxXYTPLBejEbFcEsRjizuz+yMUDE8SWjcVTHRDfanwh2+cIenIzPDibgmMo1pxWe802NZaIcb+gMOh7xldYELyqdHMv80cL6OIbPay+8GiEAkRhFLuIMnalsvnrO+9cLuOex5G3Zze13IPc57wMtjRaQnfdl9he+BeyTcpyHkya7Nbpf7Mc7lK7/5WS9nw3NCL58r8+ddBTvA9vpDtK8bzsput7vTaoxkz/uaE4J73IuZOrovNkn6Cl2OdEQQgqEnz/iJUlOiH3hFs1B4hXfOpJlC4lWc4s1B42VchnVc5G3YyEyex6HMy1SPyNFAZkVBhn2JybScy91NGvBB6dHNIeTYzbFIsLmeCeLbmVFf7J1fsK2gVh0d78Vg78lf1AQfKITGvClZ8+2g830buNWIn+0HsNWU5KhXuQEd9yWhNH0f2tn/zkuw0zaphEEoGefoHPrdm57NXTq03xUmjI5w0hXlAe9Qkt8pmP7t3xlGnztkxnIEoCYMIAEa4FcgYMh82mVt3sho2Mdplgq8DENpWB5Cj5eAActtYOiJ3iHcwRMoQurpFgmeYAnumP3JHbWgYM+x4CSKnwtu4oLI3pD5FpDBIO8thiqUoil6girwoCp2W589mLgVUxEeIdjVUNg1oRJ6X1+5RFnBF1rNl7y1HSSMgoTsV/oNiOvcAxCa2Z9tw4WAIY8QHIQgGsIxThoSkzUKXjWu4XIgXqVV3BwUoGRdnBdwnAL+wMh8WgNa1uTtwDo+IFuQzMYJIlg83lgUoiFy/6CqlEEPgILqEeGPSaLOBeRteRFBAo8LoWD6HeRLOZM2cWInMggoXqL9raCQrdSONJ8/8ODzWVXrIE/jqKAshqQOgZ/ZnV0RNQOOxNu7DJ+SCeMjJmSO2MRHKOMyqlUvOKPw3RcZluHgVSP/JdYWcsMucCOmYUWmWdxXzIEcetpl1WE5miMUsKNUTqUOrIUfclz0cB7IDGJUqoGXVAEHHgbNqZTqQWIlniVaKqRaYhVbpiBIOqRE6pwmtmBFZqRdriIr/mB4HeRbnhexzeKOmOS7dN8u2qL91ZntwJMT9gKC2Jv0KdExkoRLjURK8A9f2VkrJIP9TSM2Khqk9aQa/v8fNgigKxRCWHxjHLJBOJJjO5qjU8JjOoKBHmZWyvwhOuJh582RWIABFMjmyOCNaolBCCrDb/yG10mikqRlQS6nQTYnW7blJdElXE5ngXhRMxQkJgLIIyLDXSpfNuDlt3kD9Lmi9BXj11WfwCVIKYzIWkGTLb4n8PGijzjhkqjk77FkMEajNIIXNNjk9P1H+wkRTmKmTJbn8YBm/6FhgnbmwhWeUFKaJfRBFdBAyCyeISxlG9Fha4aBa6aja+ZMIOYmA94mbsKjWPwBWWhlV3LgHaSBzcVUjr2kYypncvrEczrnjeYofrildApkj0pIfQYIc6Ll6z1Dd6piD3JXPEz/BHlyXdfZHi1yCw2dg2AyoZW+0/fVJ2LW1xR2grjc5E3cSPstw05uJqD1goA+00AYRBWG1z/55E+moWgK1B9Egat5wTcWQp5i6KbZocdNZYe+Zojq5m2S6OaJjFaGBYoiKm9OwRc8Kgc2omXa1hXCpI7iKKauJY0+6Y92apEOJHMOqSX2w5EiqfLl5Xe9onYGGWCi5zYBZilsE5XiInxeKTfJpzOsHdvVE5uW4i9ERDiAF0ikF01pEkj46n+s2ZrmZ7D+HYMqaE822hmuYWYMZYzRAUfpjIUW5VKGgR22I85IpVMCYiCChWpCHh7ioSDyAaM2KqSmwSAwhr2IoK9R/8ul3mum4utZBpv4LWSQAtm/IqeoZiJCToMqfqepktOYdaSBKqO3QKlfDtgtlNtAsBuc6aKVRoK5rMTF9sgo1Oeudml+RqPdiWlvgSkmqZUq6B4NQuNgceY/PSs1Iijg5Z82jmaERmgQtEBa0IEhaAIrwKGe9uk5OuDNVJ6H5iEclKtqnquhoiOinuiiciVmOaqL0mu92qu+bm2+biqnNmR2/it2muDAKqeplmoPggOxMOw5PWYMzV6rfiKsDsSskiQn8KLGxqfexufHphX5calBYKxLluyYSulmmgTenYdAYNFNQmuc5gecCt7/VQOl0WkbzIBg0AEr7MJQBu2FEv+tt47MBjxACKyAOYqat/ZmGHQlVkJPVoaMiR7qiVKtndANHHgCpRFn1lrqwwypw5Rt14rXjCqnpwaskBas613q8HpnNqgtPvgDP+yD9NqlPHznd8YD9rYO27YtLFZkV30v0KUnnBVIxVYprYJGYs6nLmYTnXFT4Ips/uAZgOYV7IQOskpj+xpDsgYmFSKRm8ps5IZbNrKhKxSwKaACAsMRGtABLfACLWyu54qjF1DBONaFBGDACmzcn4Ko6rYuVmpYocquIKKByaSFGMhaJdxajO4u1wqFjQZvjcaw1wrspvoo8srlDPdE8+LDdwrDKggDwk5vRmbD9RLx2noD9yb/8arWFPgGHfZ1jvnW6t4aJshKIeDmhpzFJDSsX58hw1e5VBRqpoHNnxjOy/8+LsX0kxr7pDhUqwEjMBzDsQM78AOnAjga4ApgAAQcgASkQB3+wNKybuh6MNRqMGxCrTyCCaydRQ+c8GLcGgu7cO/CMCWTbQ5fMv6KLZHi8AzzMDiMkzAUxp+YQjV8pxAPMXdww/ZKBBIv8YEsk7hIaRMvUxQKZt423a3mj/ri4pKQn8h2qZcuZGSmqjJIrID1WPhdZlsVGE9GKwCvMTTD6eG8Q3J0LioE4DA48DfwAhEPAwQPYIaGwehaVB/7AFQOMjoHYggH4iFfoDyS8CI3ge3i/wnWDu8Lj5Ekg5EXCe8957M/tzDx+kc5cPImwxDwNkk/OK88cMNUPMKupDAwCAM2+MM+8EP0orLaCgPb/o4rPzG3fKksv9nZCa583rIuV6wY13Jivi/8yi9NDfN3FUN7eUvm7O8nuez7LUycCnA0S7NoYoM1w/EwbHM3e3PQZgI4ngkGK/WamK6i0lHSpmtUS/U7kwwSxLM8gwEfpHA9Vyol6xM//+4/X3Ilk/XXEjRafvIng7JhnIIlvPVbu4J0mLIQ4wM3SIdxGIeKjCAT81BIKyth0irHpm8uYul83mrlXFLd2lng7sH7eumkauaDvQ40fDH5CmjSLXMnSDYaPv9zT3/2AFcz58YxKmTzHA+DUb8h43nBh9GBJsyBFnjrU4/jbQbqU6ojbqdricLzInfU6FXaDxMjjerzgvXzWId1WWPy2GoyDXutWvOwXR9DnjwGXL/1I2ACKWODKV/0Qt/1sEQFX+/WDHafX9NgnA12fA42SR829zWm/TL2FbPpZitRmDZLNBCR9vGIJekdTjdrw6IxaAe45LIhUAd1cnAzEWeDAw8lUoKuJtTx554r6Kpj0UbeAuo2htdRDhgBhzdBFfx2V391cYv1cSc3cucwqM4wWuvoJ7fxO3jyKvBJnlS3dYuyRGeD9F508w4HeHdSb6kbkH9SFK/pO6k3367/tJX2jt+u9C/DL+gsyApR9gzW8k1mNsFxtn97ps1uuYBH82dKaypzLucWuDZz82mbQoSGcxWwASM4AitsQsXpabeiI1Sao51XpYWvI4bjAMnwuZ1GgRLoAOZ2uKz9AaZJ3N9gYb6O+ImTOECbuFlDJyVqqjaAB3ewdYzhSVtvunVj91DLgxBnQ+AoirIIuSn6qpS+RGC/F+DW13pPsYek9Pw1uZOXjnhrJk7Qb/xln1rd7cm+08CQDqZeI81yeZf79E83x1Bv8xzLA4JDuIVhxRsCrTcq5dDS9rf+YZ5T4Lb/Oaz1NrgPehAEQc4YeqUhtXC08qIz+onfc6M/eqRT/3q891t4cIN2uMKsjB5kafqM9/tbm8JEg7r07ngxLAuyqdtNWSza3XKRMzZbETZi42KQ2C+tNzlkK+OCnIPs3N0n5RCb9h6hZRFe4WjNHrviDPBPK8cck4MDk4NpQ/sbtblqM4K108Gc43ae7yHOj5qf9zyhk0wfVBxSV1q6Dzu7E7e7Q7rSyzC8B2+9U7N26AmMHcaWcEWax1hcyzVd70N0511vGJvSgdLfFnZ6u3rTaexgM6F8kkjkLGvFA/PKYrz2hQR89E+x0R96APtb5fR/F7vJF0W0ZGOkVQdRbzM5uHwcMzhk9aklbMJRFyWXYDudZ1ZrViUFcjufb3vmf/8753O+E1Toz2bC0GNCjt0bgH/50YP1f8d70jdz09O7pXvHNwiDJ5jW1Ov7tXZFjdtaMAR89S40ZzyGeqj60TWbs9Ug2j98fJu9jzD8lQoYiZjI20Nj/akI2L3sJQmawdCbqbcV77g+Nv49NDvLZw/e4BM+sx8+KkhoG2yJOEr7AaNCnEuW5O/8nXcYzGg+uIM7ngMEjSA+fFTJUscQJk2IMBl6hElZxHHoKFa0eJEdRo0bOXb0eFFbSJEjSU4safJcOZUrw7F0uQ3lyZcxTYrzRk0ct3fxdGaTh00SH0BDAXkiSvRPUklKly7t09TVqqi7vu2T588ftmDATlU69RX/FqxRoxp1MnuWbCS1a9lCcvuWLVpOouierauqVd5kzXCFgvsXrh8/kOgmS7lOnTRjuBgzhtYSpq5WyXJ10qNn7tixb59BVpcRdGiM8Ei3M22vHmrVn1m3Tv1a9T199FafLn0bNzt3u7lh+/YbuDl5ktBEMT6jxw46dZgHMsRqF3RNjPosZ9Mmi0HtOrj/6L7DO0HuK3ygKE/juw6B69nLYC/eeJs5jBhmSvhwlcSbH0lbrOfxP/4E9OiaAisyUCaaFESwo2lmYhBCCG2yaaee8MEqmKM0REqpDpmCqrqnpAqmmmz2OfGnYY5Z5au0yjqrrBjjagswu+6q68bCdNmr/y/AfIQkD8JIGSUZZxDrRrHGdnQQyWcWqywPzDQbhRPBSmEGJs+07Mi2Ll37srbYZAtTNC+97A24b3jhhRxe+jBOhxYq8CCEHqpwjr5h9JyukOu8wA5O7wRNr6D0yFOBhkPRO088gt57Twft5puOIYceikWZ/TgKUEBOA/R0wFAjHHXBUjfK0iVSQVr1JmEo5AafC6/yJ5UNbbUDVw+TeqqpXps6ZZVgsLnKqm92AcbFQ5SNkVkY1RIEWmj/msvGau9ybJkef/wrysxyOWydc/iaBS9cmjksyVGiFXKzIM1FVTSXcjOTTDBZE3PMevez9zPefNtlGN+qyubNKFTowP8BCDBIwYuEoJOOOj+zC5RQigdtFNEVUMgY0Uc9XjTSLLyYj5BMTL7vkUcy9QbU/lp+raJPR5vZP9hqFjXCAxOUkCKeTQWJZ55z0oloYq2qRKhb/8CV6aZ1bYpXXyupZMRvrvrNFUkoaWSQGJNVtq11ZzyLE7X8OvvaxugaDEi32OY2D1HyGgXcyBgrV5puEoNGF1EEu6xrUSLJI45Oisl7y5nKnJffxsXUl/Ez0/kXFVSGYZMcVNrwIQUJKmA4oedYsQ87Ov40iFDxzCN00PAUTZRj2D9m7weRRyYZkfpQjmVfmrmk6FObhQf+5ZZx1plVeFf1OXnmnb/mJgp5+s3/6KNvTVqopvmQY3vsni7q16mbssQVqqj/ppqsYwxq2faj7Roua6klO+2+/Hp727blHkuac450hm9KegxipNEKIF0GcFVyV/8Sh5LFPbBLKnFcvSBHL9ukY3LViI7l2OQLWrDBByHAgHISUjJUVMcLVYiC7VKogg2AjDyr644MU8c5j6lndhkLmXVwZzL7WEplvbtZ8YpHvOEZMVTGa9Dzloe8JTpRQVCMXk54shNiYYVWRmFa9o7Cvey1AXth7KIYidKUUUiifOfDBjC0tjVmgQ1+YyNbteZXCjvOrW35w18oiESkZhhJb0nSS2eaRIpoJfCAkNAF4pQnL5e1JHJH/3QcBCs4LwxqJRiVQ4Wa1qSJLKRgB4XwoQn7cBA29Ml0T6HBBFownhV0TIY0NFQMZTkeR4EMlrW73Rx6eDKHgAIUK2OZJCOJxOERkZiiah7zntjMjzBTehaqXjZWMUbtbQ+bYMwmGL14zS3eag9JK5/5sNairqkBfnGslhytNRbB4S9/buFjLiSzI2sEMl2O6V8xBhelBOohDgtkYCOjSMnGGRShFuzSJdc4zqrwohYf3MEcWEELR1y0co5gg0EKgcpTzkGFrtSYDHHAOpHWcHY2LIjtrEMIl44SiI/g3RSHeUzhIRNmjDOmToeoTEcuk4lSBJoUoxmrK2JxGLA4BP8c7HAIb8pBm9sM41O9GUauJU1raQTOVtj3RrM5a45ftdFm4vkjP45lSZ/Jpz4NiEC3AlQPpMgFAKMx0JNA05GTPKhCKcnQDQIsG7TwoCEatolN0EejtguUpBjBiECprqQmteWhugPDk5KHUaZkAy8L8VIf/jBlKRNmTW1azNLi9LQ+/R1oGLRMxT1zqOhYGW+seFR/4EMrj+DDIODg1Gz+tpvAxaZwiWvVq3JNEuQjJya78kavgo2d7hyctMoqT7Rq5lz/q+cgLXOHtwK0DJEg0uH2aRIEnTdnNSlTXhNqmvZesBqT20UmLbfBw/6ph2zQAktFZp7NmdKktawsSWn/CTtbQoogVeAhZz0LUyDCgrSpvemEKSxhJarWd84sqIDSWyCWVai2WMyKTo6hW2UxNarARUNwWaziFpNxuOEUp8CsZqxitLF9z2Xns6hbXfFSZkp1A7JeoPQGI7u1DOFdZHn7h6BzobfDLNFra6Rs2tCACYPx3YopRueIhtBBlx9trEa1sFkzmzlkqGvdLL0TS8vicFGUTQ9+edlDw8L0EXV4hCdUpo8IVxjQgbZwTh+50ySyRsMYFqp+QGxULOK2QkodBFWLC1UWWxrTw5UDOje9Yu55OpydXvGM02TjU7hRx+o8i9i29SxI7GEP+5tSkYzUv+0Wo60BPTIkyvCE/8LtaK7kPS8xiE1sJyEjyuh6rQQDuVcrsybLlKNvxLKQ5jJfW2Jnpk8frj2x1KHAzQdeHYIf1R3bMdizdx5laD3hiUz5eV6Clve8521oe9sr0Q5UNDqQPVsrOrof+KgQPoRhlN5e+tOjdvGnFw7qbqIh1DFW+B4U3gip+OZqa2xuqqEbtrF5PNZTost4rbHPVgwpF6owsq6P3OvBjDfYzZB5gYxNjGvY/MlRprJa2evsnWtpoVmuhlaiw6cUulKxIttvpFYosjNzu9rf3thIT1rSRYGbUQUOGZ3P0MtEYNSXek4Zpv5Mb7OffdA8feC9m7dv8/a7qP24bayItpOC9/824pnW+94x7Wm+M9zh23M4xf0+XDSar1hagUUltpbO47pF1R93NbTo5s4hkRyAlYnFqY0shpb3Orwkz5bMF1P6YtPcQDlPUAN7nri96s296uANBuerFS5PZ6MqpDp3WJh745S022u+rApkCcPIEl89Uwe3f72AbV42OHe5MxlDxA6KIJYd+2jXvtqT+WzYHrrQyYuI9Iwa8CqePx7C6AQcQh34v78/4X5XA+AhXv8V21/+ehdnGk9UrGBgQmu2p+Mk7+Peoo9wBOX85xzy4tQEIaCWwAw8zwyuIAl+Da2UpNgyUANR7xnSa9lYz/XWDuhgDzGEboNMwcv0y9tmaIf/9KvMok6xZgnriE+H5MyWlm/5kE/5wqzM0C36pA+mmkO0sm/7ilDCesr7knC1kIjt0CEevAHZ9GbgjKrusgFWBI6N5q/h6K/TuhD+7m/+wBD/xDAM8c8LuQeNUqEqUOQnTGHPrsrxBhCsFCFaDnBw+Gi80sEZOqHdDqHzPI8CAzHkRO4VyMUQN5ADdQ4EF1EE16t3XoWhtKJyqKNPjm5QSuoFREY+XDAGZSkHle9QcJA7rE6GkE8HedAFt6CHfnD6CKE5xA7CiNBm4C02jPAIm9DQtm+10m40lAEZrGFM9IEKhQFWppAnVoG3skkLN40PytALnbEMoZEMp1ENohH//+BgGhMOV5TLJ/ovG7gK1QiQLWAtrgooFGBNSOZqG3CtFSghDf7wClzABijQDELOWsplA/sNylbvAwnKH0PQM2ZvcgTGvrbtOpYuCrAusvgr6thM+Upq6jhGIbHusmQoE3tQ2zyLFXPHIYTw+vZlFieMFm0x0LAvF88uwnZRCUNjZcZPJ+IhVvLBHYYuJvPBJuMBfTwBG98PDLuwGn1SG3cSKH9yxbCgGo8SDHYyKZOyCpCyKemPqf6AaoRFHsjBKvfBWFxh41KNDumwHKlEWuTmcOipHQcBHuOxBnjgCiJwD8QrR8jFGEgP5/YxJfqxoP7REZttBEswEoFjGKDjzv9ScL8a8js6sXVewCGTbwZbSRRxsAVqEBW1YA2o4Azc4AeVAQg5Ms+Yg88egaZggzbgjRZnYyRnI/tGssJQk7RScqcoCCVP8jXZAUvEwSVhMiZf8iZzEwsNTig1jRqfciiREhuXkvCocSmPUzitke8Mj//6jxywppq48jIMByzdAuVwbSzcEQKlQC3lcR4F0S0vT4BUD73q0i5/Bl7SkxEhiQT9JU0EixYA886oLQsQU5cyUel4bwVv0JX4UxRvUAcpUumcT88MYSNZ0RBeUc9GKyRBMyRVM9AgNLVk0Ygqqd5gcyXZgeyooTZtkopsUzcrpJp2UvCKM/6u0RqBkzj/i4MMjRI5X3RFz3A5Da8PLq4qycEc/C8610JZHBAzUi4S2vI6+2Yz1nItbQBJayAtpSDJ3oAP64lHao4uFRE98VI9AfI0doMexsSoUuRhuuyiIgbb9mtMq80wbclQGlNNl68Elu8HXoBAzexAD3Qzm2OmQnNLH5Q09zQ1SNNC7UFCedG0XDNCn60I8WI/VgYmwcEacLMmb5MbhOEUgtJEszEKlJNF5eApmbJFkRJGPxVUq4DhxAiMDm8N+YEfsJKNAAF+EIg61YIQh8Qsn+AJuDNJWQBJJVARYI70epU8k+08+XE995JCdgMnf8In2kSwEiERWIFZL2oyx1Rao+4F/zJR+PxzPNjUIsfDAj4A3GpHWnvwDBDhEeYUCBNUCGfqw1ZTNAEVUPcUXts1UHFjXuc1kgiVJMlEX80EUW+iNu8JRB+1iqpBGEpsqUoUKtXgUj/1N+0PDFwUYkFVYkP1xbrHDqTSFVJhGPaBH3L0GyY1DXrrDQSBOgfR1QwpELuzBkiAZVmASUeWV4/tMTpwSoXVSm92WCekqHyCZz0oPllhERahky7qDML12or2TS+yWrNVB+yTaXHQApAPTrUACERxao8W28bVXFkxZdKVNj4sTx10S+OVbHNKFlGDQv8UX/NVbPd1X/vVX22iYK/QJgX2HQr2GI5BqUSW4koUU/83TUUbllNZ1FMj9mEn9kWnEbiWJoxWARvIYR7mQR5coRGQ0nC4pmzAK1oCilZ5YGVbFldf9hCIbDx9tVepVCby8udwNhx0Nk//zRcCqxYiihcWgVmF1naJ1mjHFAiwzWmbts2+NXhFsXe1wD7dtHjHtOvY4KK2NhOEIfpe8SGesE/xFE/JNkRz015rUTVpkV0B7UjW1ha/lnzdtjZuwd0iQn11tm7tVm4PZ1WTEUUzdX4Hlyit0XAPtwvyV3/3d2Kz8ZuEy3H5YR74YReIY2TbDSwJpwwQKA46V0lbVgRIYEnZ0iwsz47E8xDzkWY7uIPN00pXFyD1sj1BrButcnb/Iypo16R212Ayi3Z3rSBcqxUI4LR44bRaczhpk7eGcfBqY9hAnVf66vT6yBds5RV7tZdPvcE0X6OJSQtC63V7xfdxpph7yxdPwyQWQAFT1DdTjqEbhNFud8Ia8rYYgEEqtoapeAtT27hT7Tc5EXcK5vh/67cn/04SdoEcUDUY4EAMBoFIFMjXHBiCPxd0vxMzwvOOClGDNzgDTReSeQSSZxYaKhkm7OqS1xFJ7okEOTma3oF6auEqU7gWFqGUJyGiHGENzqAyYXgLXNmFX7gysY2Hi3YLarh3e9eGdRkxkTdcU1ELziCIDxR6cwd60bUOnpeJj5h8kTiJlZiJqTdQ/7t3mNqVXtG2bRUKNe11m833imMDH5lBnCMCjANWe2lTfRdPLABhOPGXcJsSjuOYcOW4f7+AjunZje84KPnAFbKBHya3awzIyHxN1zg3yTq3SeNgZMWr3UjX9JbEVzk4komNXELBojNjkWdBop+MrhhJb0oOkDiZGNHERGaXHGQBpWthElCZpYN2DKwApsdglYWApnNZhnsXBoZApmmap1/6pjmAA16gpjkACIAaqL31W3k4TntwmIUYEdwAIRBhmbFYbE3zmc3vnD/zNK+X0Kh6NfnqibMZNZrYmr/ZrB0UmDZvnDs0e9E5IsJi8/pQKeV5npHTJ+EZn++5CQx3r//rWWLzWUblYBWsEii25oEHmdW68oLnpovH0rEj2YMTMbI9uPTeiXD8qcemZZ6IBNjoibw6WhrUt2CJsaT5AaVPWxZYeqVReRHIIKZjeQyEoHeJ+gWCuraJGghke6hr2Kg5gKZhALhnu7dz+NpUUVrrjJcs01xN5uueOpkRgRjj4ZmdWbrbF6uzt7q1+nG+9gnhNXqo26vL1zb81Jq7uZnf1ay5unzxAi/6ja2zWhlg4a23eIu1iI3p2q4T1yl9kp7917/9mn/x2ziZsRJ8A1kaz1s8O+aELZ3X2sGXAcIhe7IjW1wmu6LLxm3+5rILOqAi70kVvLNhIViEAWBmF7X/UXq1U3ulS5kMhOC1XZimYxsGivoDFuADOODGLcDGLYADuhWoc3sIcjrIgfvHdTl5U7HOxtQ6lNupuy53ovl1kziLPxS7oVm7dbY0otyqs9s0sLc2oJh666E035VPzTtMtvu88RSY0lq0y3lsuVx9kSGuG7rxzmnABbeuC5d/+9qe+XzPAVzAA10NAMEV9BYsxhIYQLrW6moaHtzBmUzCfVWyKbzRRYKyf+HC7weuOFyhWQ6RDBCYHkIYsqEWTlzFV/oTUnwSXDvGg7a1YTvIc/nHe9uoaVqnx2AIhlzIhwAIeD1recm4j7v56kCYl7sV64AKyDUTqhv9yta9urvZ/69biaV7Xa+cNJi9bJ8Zy4+4T5d5NMfaXeNVzNG7zNVby7eUvRGVQ2frQyfEi+t7zZWl8dpZz+MZz/McwPVa3/M9wPW8YZkRWOA6b8GYyRjd4Csd4UPbkiec4Wt24UGYSUhCZtUGww9o1zjduzIeDixhFyDqxFP9ElBdtSfh1V2cDFzdpXFdpm9dp1t+p2NbpmP+5XG618fguI072M9MFXGnqQ+U2B1i2at82ou1Haa72Zc43s6dbKVHyrcdzced3Me93Kv3epW+bBmZi9fak6nIJuIc3kc3x+5b0PHdnfPaz8+e3/9c7fV30CmB8eS75LQ+k+d+rROe0iu84e1e7//3vi7vvgMlmbFPjg9VYbHbkc9MYRhMBMVBfhLwQORXWsVbO8bXAOVb+9VvnQxcW+Y3X+Vj/MVvmUBxPsldENlVkZVZsblbERGooDkQARywXYynvYqIXhzeHPb9zMtxg/aNHnsFbvarvehrqtzJ20/FvOmn+81v4RXW/BddkgTj3BflvCwV+8RC1vqj8WHxut7Jvt733fvT/r/BX2KNDJ225hSK4Z4+O+EhQ+IfvkDcv5L93u/viu/bv+Dv/+CZAY2PARsAYpivWrVkyfp0KeEkhQwXXlq0ZozEMRDJLKo4MSMZjUMkdrQyUYjEMxK1mIw45gyhMyznuHxZZwuVl4T/aiK6iTNTTkNn6tR59AhcvHxEixrVhzQevaXimIrr9nSo1KHtkk61qg+e1nZPqzLFehRsWKpcnX5NWs/e0qxq2Ypti3Tt27etQNkFheypsq7KivWKdStwLGSD64JShPjQIEFwvjROo+YxmMmUK1u+jAYzlstTOHf53MRx582hQZsm7Rm1atGf36gZRMnTqWLWlEW7rQ33ttzTduvuDfzZNWjCixs/d3w47+DMlztHTrx5cWm+qf8Grrv2sWHZBhY0aAthw4QEF17EqDG9xzEf2WsECX+MTJIltTi6j3+No54wYW5RSYgbOQ14kyFUzDTTI8KMxSBaZkV1FVlxvaVW/1kQitVghlttmBVS3swFYochzmXYXXrpBdhdqqz4Fy6tKIaYIINAlsYbYogmWWqaRbajjj6WthqQQQ6po42vxZbLMbVdVx120j0ZXXLKSQlllVbiZhs10tmm5DHYkANmLebYQqZ4CuHR0HkXbTRSRh21p9578W0Bw5wCOpLIJonkeZ9+/L00n0024XmTTgX+6VMaQQmVjVD4MCjXgxA2JVdX3lBzaaQOXojVoxka5emmlZ61FlxwjYghhnWVuOQxfc1ymF2tuEjYLYfFmIaMd9zoGo+Q/ThkZjwKC+xopwlJZLFBqnFaZLC1AkuWTY4z7XPWTgldttNQeWW3zVXrZP+WXVbzDZjk2GLOPGWOx9BDaqIkkkhxzjsRSyDB8B98Vqikp5578nlffy/xSyChhhLi0oFh9NBDHQs6Guo970js4MTuXCwON5ZarJSlfTGzrVxEfcVpPv2YbPLJn0JK8qiavoxqqkWtqkonqtA22KssDkbYXzUrcocgQQfNa69qGA1F0sou/QWyxzKdrI9GtraHYp6AzCS412K7LXLLcevt19NxrW2342YDJj/mjLkuHm47tNAkeLwrkRDxxtdmRvbKOd+c+57x77/9OuInI4iyhF/BByMsExU7uBDCDl5m8+g3EVPMMebvbEypxR5ribXIbHUeIT79nI76ymHBjJX/6DHLDNasKXZSzKux2M7zMrX+zNiuRNuINI9Q9xi1sU4fj3zxTwNv5GK0S5v1t1uTTX3Y1kfpLZeTg0lm9+El5DaaCslNt3zxypv3vHvbbbffbvxLCy145ln4SoYYMkchiK9Bf8GJ1GSgmIRhByEIQQ8UBLHLZe5lGONcAzP1sWVg6i0TmwrqLpg61Y2IdRx8XVhW5YlO2AwWObMdyHSXIt69IWhxiEPRgsca4z1NecOToQ1rmBqjVe15S9La9KoHxOsJEWzR0Z4w0MYPfsjiXOoyk9vIgKZJ1EJNi0gESrQgEiCgTz52yht87KZFv90EfpsoY54CtJKW9MReg1Jc/+J8UocB+uAGNzgEJh7mqAVOTGMP5KMDH7iOQN6mFyBrSoQwlxTTYTCDLHPdhDroQdgZ5RTQouQhKBEtEubuhH5Z0a1+J4YW3qhGMBTeDXGIylNuJgqspOHycqWY2fTQh9SqpS2D+MMhdg2XU4rgtmp3jCNyDzzdOxMeNmKRuJ3HiijJGxC4mJF8acFvVmCf+wInP4D5SSUAwg9JcKKfAhFCJ2XcRE1c4oUs/GCOLlBUtIJZjXjqESq1qR0wrfFHjJVqHYMMXes6pchFoi6PrduYIx950EimipIMfQQw/OIX2ZRwd3cRmmtC6cKLknKGqnRlKm+YPI+epnmIuV30rv91S9DpMpcsxd5xCNNLrAUTbd8h5vcugYch6BSKVESP+cAIhDA+U18miZc0hUCFu4HkfXtaBC32NLg0tjFxBhPnVA8lwHUWsAeKegQJMylTV/VFk6vKmZJIp0enMOMv/pSkQD1VuaNsrjaZgqRCJYmVU1SCkl7CBzeOAQtPCDZ3s7PLIVi4Qoy+kFc9GKXSHsvRZom0o5SdLJE0uhjZnNRaKa0lL1daJWSQTXeiLe0vu/QNtNk0PN9zm047oiZmTmSa0/xiUIMKEjpZUyZZRGq+4oMI+MUvm/jhSTepilxB2aSMmqhJVlVgAg94oJ3PEuwoPMmiFQ1WdrJjhjX4mFb/zEFlrWydIMXCEtC3HlJiJ+qNN7zyT0TeVZKWsMQqjrgPfvhDGLB4hHWta5hLHqZGd4jDFQ78wiWIYQkMY0JlH/xRCFu2WcBz1iGgdVYtdRY7G5Yeh1v62SCalrTGUUYw8ZENghgEbgsJ32uH4LY1oYe2R73tUHnbvhz/57cscQNTA8cK5tYEcfabKp/CqdxBNRedXiCgdCUwXR4gtoV5qLKVZSRC7naXNt9Nh5c3N8/a+AwXyDjGxdCbXgyi+BsVLCiWJPjehM4Xr8EIRrn2gWc8C8O/AP6vdRVD4DIgmMpieAIPDn3oyEo4pIt2gqMn/GAzmAYOAgbGLFFanQ6n/9TDINYlibFn4gXJgxwFqUWLw+fi186tishkU32qWc2gvuC2dfNt+6opkr0ddxPyE/L98MeT+yW5YMM25znp0GQVPOABEFAAlBGN6CNI29CGdiFikMTQ687qnvj8sh6j4TO7mNSQV4GrueMqX8/thsSYIhVC55yq1OY3iXnGxyoC4Qk++1mwimFhtQV9YGgf2AihYRZkY8joRkNYCZCW2tQojUl8btaWGtY0pmkJWpd+OqzZSLGp44bqVO90Iz6Fpm6RKoQXvIADH7hxUG/N428i4k7lLGdz7+eSQuQv2FedeZLzp9w5JHsDEjiA0SHggqI9wcABXzqhdYVlEUo9y//3/LK3vYyiEo07c+dec2o9lVZ1jBeFZY5zfOHdIGH4Is941u8+srEKyAgYwLGghCIC7XTfFY1Gk/mVwhP+90cLvuGX/YJrYCMJS0/c4iG+eMaHo7uYnnBy3RmI3EL+4he3Oj0vl7XKP4+CWa+cA7OubY9l3nNE/FrnPgmET/BHE2ETKMnCxnkVlM3so0OABWnApHVJAQkZBZ8TIoyR0KBufD08axS54HYgsb6ktf4ML7WT5x65Ed50s5crYv+labWCdrwiBb95pje9PZHo6somhIsh5R0oDehL8gEQdpBDGprQYK5GOPA2ZDjhi9crzyJW4UCAnFVxB/hhjodxK7X/cZxkYt+VWr5ACxeRCItwTK1GBpm3eZynchzAciv3AijwAaEngiWIWxmBE8O2eoXgenAER7D3grJnVTahEi8xdEUnAEZndCbwBV5FVi6iZQEmCsUHdXqgB6IUB8o3QvYUDc8nSPVUFyUVC+8kT1WIfdeXfRVCLREEZ++lFPElZ+JHFKkwDGzXdknED9nwCEtwaHHAB7LhX0BxCJIxf3XYCHxgfwt2AzYwAn3oAj6wf/w3eIP4f6/kLBGHgBTHGwW4iAmogNaSiGZjG5KHPaglgVX0L2SwJ8cUETs1chMxBFskax/IciVoiihgAaFnEioxBvehgizoei3YerNIi3WA/z8qIYOCAoM3iIM6uHtiIFHNpwvDqGWkUFalkGUlIkJHCHArNHxblmFQeCtzR4VddnVgho2SwhX9BFNZYirbF4ZieEejVn7zlkRqCAeHtgSUwGeVEAhzWGEjZQSQI10kkAH1yIOBKIiEWIjBYmGIOHGRaIDlQJCM12lbwkklNnndxg0CkU2ytYHuwR4fEYpjUCf74nmnOIKoaAEq0JGquAaGQ3sAZAixaJK1KIsxaC8y+GswcXu5p4MFgABHZwSJB1HEiJNjdowlwnwRVXx7cIRBGXWFwYSANY0ipFkP1W3WWA2C5ITaOHY98wtlB1/uFn4OlQ3+UI5oeI57BgcKRv+HC9ZgRKCOMcCHZ3mPGdBsEOAAEhAD+zgFgAiX/EiXgMdRh3dhEieQBsmXGIeA0NMtWFNE+CQM8TQMuxBkQ6YfV1QSz4RUE1k3Y4BbJgGCJGiZIqgDmJkFbNAHjOCZn7mC7miSf0CaJgkUJ2mLcDQwNSgwdPADEQABMhmTvkgENkkcyYCbuXmTOWkYxldW3AV8wVdlVJYYSzhWn7R8SaKXehmNTwlIlyKVgeFeXdEy4Qg7+RYM5HiGaoOG5PANqCAJaDADMxAEZGkCLXAC55me6nme0YUBT8aWMzmTNlCXc3lwC1ef+aloaJBZXJYdiogOmTaQAGqQbwZRDuhLkSf/HJMoDbUjcfEEoYiJCZ7ZH5w5Hxf6RXWCL+xDmT+gmSuwTiHKSlXQBnTQmbDombA4mqMpCaVpmoGgoicJE7DYH2FAdLNpADkqm+0ULVGim9HJVjhJCn7AdGWQhMQnO83XmxZFnCWlCvxmUVWjCOL2TpYmVg94G/TknN1HXq+wM95oIVa5XiAiWKfwJVq5nd1JDvKACm0wnjIQXWrJlhXQASegASWAp3cKAhUQnw4gnzMJATJgn4Nql6lEaa2geAFZkATKqAX6MV/FUBOFoAjqDJXaZXaGDbsQDKaACa6HbH3AmekUBqOKY6Vaa0gFBF6gcisAoj/gqq5aBSQqB3Jg/6IsWF8pWl8r6qKAQJotKgmVYAm+6qIxqpoV6hMEhKM6uqNwAFbN4Kw/agzRSkic9BdDyKRGqoQ9aU8kNH2IgVjH1zuCRpydEIwPdaCEwYRZqqXh8DG2IiuiNZ1hemZi+m6YExuUAAzyoK9pqqbgGQVB0AJq+adtWacgoKd7WnR9OrD5qI9z6X9DUqj+eCTjppeNyIi+0agZG4mP+lV+NoXp6kvi8nzxlKl1tqnBSpqfimxh8HlAUHrsc2sw67KrqgOvGqtZgLP1Zwcwequ4Kpq7yqv4tqu+mqsvKqMpqbLKpqxLK5sjwKwJ+qzSCq27OZXXRQpDiKSjgCRJGqQ9Y/9YiJFYNmKkB5ZR1wZC20WU06qu46Uzd3EL8Kql+cRA4LgW95p48maO3Gkuw9AHf9AGURCwA+unEkC4GEC4CRufgsuwDYtDEft/ECdLl6axk7uX4VIM2bZvswGym2upJIuYqeAK9+apdrCy6mSzKleqQhCKWWQSTRaiOoCzXvCpO9urhVBfrnC7P9urQeurvNurwqqrs8iCKvupWQCTA8C0gEoCPVg7U1IcUgtTU0t20KukNNObNjOVICNWuWBJi/F+BdZCeQcbSOm23OWAaws6xIBdU4m+UCGvLlOd9GC3j5AKeMsP5nK/YDIMqMCpfaADAhsAA+uLCSu4EECnGPD/lvfZNITKwPv4j/7ZvhcrwexAuRs7VoHFb/c6d9ByoB/jwfBELtVwmJvKqe7Iq/VXBUmzAyvMwq6qchsKAxdZTVqgcja7mSorrMCau7equ0B7wr4LvEHct0hLvDrQi8ibvA6QAWJQCVAbtQ0IxQf6DMNYvco4nFUGCZzAwdGwvdVrd4NgBs04NImRXVR8vgTIF9DwC55kM114KWgct50zr9Vpt4IFDNxBDubAlXhGDoeJCozgvyfgpwEcwH+qowkAqHN6j+dJcJ2RwgjXwJahn5NMyZI1sZZasROsyZu8lyr1VZWgwY2Qwff6sVeqPQ/lZfFksqGbq6X7yCvcA6zK/6o7MGvW9Ddn0DivCrsq25kt2re3ugo8XLQ9/MNALMTESqwq+wMpoADJSwBLu8RX06DO6rw+unFRTLUtUiKQwHTiq8XCaGnbyr12J7bYKnxazLWftq4q9TNaDLcRrKUVok/ybA8aTAl3GAiusAvfwAu80HGH+bmg+rcaEJs5KJuGfMiDewHTRUc4kiMK7LiVrDx26bgWFrmZTLmLSsGO2rGScM8fDQj3PH+VVqVi1SWWhg3xlAoni7J+W3/3B8sMowKyTMsvwKG/JROmu8ucOcS2agm9LMy5qrvFTNRDO6zHnLImmgUqcAEFbdBJvMRN/EvV/KzWDMVTLL3aDITdSv+k4BoJycjBYMW9y0icfpDFolDGU6m2may+t6IK2Rsu7fu+DXSvGtwYaICHfuvSJfq3/0rQgzyTAUDIT92WcwoCjPwZd12HcDA1kSzREf3YziKAGM3JG23ZGs14ENUKvwrSJ3yHMIJtYNUXllZnquwKx4C7Jqyzr5x/sZwCHlnTMCtNWmC6JGq7oOmzQh2sw0zMdlDUxvy7uzqan+oDIOCnCI3ECa0E0kzVT/y8V+3c09u1VUsrgsHGxXdJYB2kUcik4yp1aQ1nGkZa08cigAnPW1rPWgvSjM0FOXBo6YmnLRAE/4oDLUDAMvnUB23AB6yeBEcjVmNJNaJojg2x+Pf/sP534JHNBYkNlF/NZU9Y2ZdNwWIn4R12uSTE2UQNIyMdG3tV0g+llNUQuqwcCKudwjvQ2inQA6+dAhsAojbNoTMsqiXat6hwop3pComH40F9mjAqrDqb1/T320a9qyaq1DNw3AftzEosBZg0zVWtkFE+YtA93T1DXmvVwR9LM1NHdZr9M1echMKHtaHwroCJDO0sbgxq3hq2zmKn3h8Nj+1NBO2pyOp530qeyIX7nozcWLAkYLOB4fFI4JFNGglO6JuhQxdmaZQNx42O2RXuiBCFwR6t4SNtNWVa0psKDKuc2iVu4nGZf6/dAxvQ4rAN4zid0zl7oo4Amjneoq4e/8RCvbtBLuS1TtSxSORG/gdVUAKI7MzJLZMUwANO/uRSbuxUrjvZbOVYnuXKjgvIaIy0cuVrTNZXfM7l+wq/AD3qO3zUN6nWAc/h8OYwAhl6OANxSgF+mu53nud6vud87mBy99VhbU+HdSON1kqHjjxIkO8QiwOE1+CnsJwRjsYTDukbZq6U5AkhXen0N3f5BuggftrAMOK4K9Ao3Bhz1NobYECv7eKhZ8syruqMwL990L+w3tM5bKtCS5q07ttAPuRCnNTIFgRJ/uvAXpvNe+wa19wv9e0JuezTq+xaptXT/eVg7gdJP3zuXGZt+4xqm+w6Hz3j/tWNEcbm2Yfprv/16q7EixzfedqeMdDQodR7ZgvO9uQJQgPJEP3Yg9fvycLvhi73+nlRCy7Zo7Do9LTJFX7wFo7ho8zwtv7RoKxXma7pmv7TOgsHj5ziDMPxHp+KrnrTjUPbNO4IJn+7KZ/DKo/rSf0HdcgHdADzgR/cRW7kgGvzN6+8fNCjU73zPf/6Vh30Wu2l2OVJ1E371a3NVyucVDZlZm0X1s07I2TGDQjut0m+5ApoNvLe6K7EXD9d8q0E5SkDYp8CNqCOXAA8O6Rtw2gd2lsMntDYgpgZb1+X5u9o/67+CP7vbR8kQIkkmEzwjl7Z2NGx/CZ/Ik36guXRAOHp0SNXwI4ZDHb/cJUrS5IA2ZET8QuUHhUtprgRwsVGjCt2/HghZMtINlpMZmmDso8jU6hQSXrZR5LMPzVt3gzkUOdDPnza9IQYESggnA9rtjlKh82fKi06JIAqwMAAqlITWC0wlYINObCKSYMW9tm1sWXNnl2WFq1YtmzVIuv19peuWa9UhcKbV5TdWbqMzY0191ZdvndVjfL7tdViToMEPY4TOY4fP5wOX24MSXOnxXGLwf0KllnYuMY6cT5N6ZCiNGLMGJkxw8SIDBAykKA9YgaTJk0iVpnSO8dwJktcq9mTXBEpxIlFR4NurdihN9UnOqGIHYv27d25c48C3nt48uK/l1diHgf2//Tee79338W7GvlqGjVCbK1bOP7b+vP3hh0B9xuwwHEORPCaBKcZLTBPHjwEkAglpFA1hyip5JFTKoFloYQKCqaghngKA7jgLuqBoxsq6siHj6rwgqSSvECpxj5QcWQmU/rgcaahigqkkJl0qmmooIwkCkibIGqDjTZomMABBKaSCqupCKhKKxPkWAi6ttb6kiwxwwQzGTP/Ko2Ywe7SixM3Q+FLsDTVLAwUSO7II49BOMsltF5aEeU0RSibDE88lxP0sccs62yutD77DBfGRqFUUMdaW4IIG2YjwQYejKsPSYnks0655E6jdLG2vNwPFkGsi8+84GT1LdbybrVVif/1tNu1PV/Pgy/Y+riYD7lGdHFGP//+AxCeAA2EVpsEqWFQWsUcBGVCQDypsNtHBOrQlINSScWVEFcZCCgwoGD3RBZXxOgGFVTowaOPPiJJixpTSulGl1yhKSWfhLIjSZuELGTEIoH6iacfKVyYpz/4jUKDqKy8GMssDXBgBDW8UobMMkUeWS40S1vzTZXxivNMuNBcE7NXj6C5jDcoaS6XRm8Bxc5BDb1DM8gK3YxRSUvr7BXVcF46Ejisu4KHGj5F7kcMd3poED4GgWNPrzdjrhlkn1s2umNOgeO68XKldW3wcIWbu167m1vutn8llb5TKelTWWbb+TtBAaclnNr/kGM55UHFt/WW8asXWuWYVMYVEZNKeErb3XfllXcjiyqyl8YXXogCRhj79ZfHHttAg3U0Wo8Ip4QRnpjJgpGkA2KDjWI4JR0kkHJKjK/cmOMLuvAEmOfOGZPkkss8GWbC8iraaFyif/nly2QuIwkSRGDhCjMiSTUw8wPbPrM7JWOfMso0u6zR1JizFLk3ohbf8QwFWrzp+1QT1PwYw7xkLesc0qGGso5RiS+IYV2zulsEb9UHRrAubnbDmxPmlkFhYRBvakDD/4rht8BFy1nMQpDhrHW4WCiuf5LgluOuNgpJmMtcuwAGDkWUk6A8UHPvitfnfFCRe7noB1VA4m/o/8AIV5jCEk8sEuxACAeC4aQoAxNVTyK2xZ80SQcnCJ7wiEeVjJGxY0tIXsic9zw2xmwwdHoF9VR2mb+IrRloyZ4b7RIJPTxhajYj32K2pwpH5ZEx6vMD+9gHCUIerRik+F/TBlGd+1XnEPxzYSYFCUCmoaoUn1yMM5hXDlKWkpT7gU41gsFACKKnlR1kW3gcYQ5eWPCCdZMVLmEJLF15RzmHyAUJCWRCFBYuhWo0X/8sJMOrSeIUIPpQDg/SEEocyYcowqYQjagDbrIriUpkohMtIRNrjopgSCHSkhq2Tj78oZ09+V8WfZKFFkRpjFYqXlTOyCEvjaxabHQZ9ggzUP+7yJFljbxjQt2Sx+glzZM7YxOjEAoaZiCtoOvLUxyeUCg4jS0S+EnNfV5FyUF44hQn3aTitudQQB0GNaoa5TrWcUCZqsOmBDpGNbAhDEnU55U/3eXbeNMHc8wDFXCLgi55FSsOMtWp9XEMJQwiTFMSc3DFXGGDEOfCCy2zEURyZkGA0cSximhxo/ohcbTJriJ2s3TfbFLCdhhFoVCRikm8XVG62DAs8qt27nynwyhmz+EV1owJyAAalScagBLweWqCLEEJatCOEuMsjsVj9kDTJ86m6UyCpOP5SrNQSbnpZxnNE/xA2smPXkoQJg0MSpM2W77Q9mi6GMUdRUlTmt7/lEDi4IZOV0GfoEKwuOwJz3pQMQ9zsMGtSXXlr+am1Kfe7Q1deENUR0hVq0ZLQQtCpleUWSEL6eSkZAWGKlExV8ylgbjZtEgrTeTN0oEBr4B4IkOgWDsppm2KVdRrF7FYJHf6CCfrFJjF8FklBhs2sZLwU2MB+peYHRROdZJjIy3bvDXKJVIBRRpDz4eZVyTGZHQJFKEkI4j5QRKAjsmuzjgrXtH65bYmDrFuk1VTHvNYPwrJEBqI5dPqtu1WjJjlPxahgyzArVfJTSoHm2rc49LHksea6jBLaFXwkiW8iRvvhRg3Ckug1xk4dAa6MtReH7JnrfaFa4kk8jrYEaXM/wwJWF2n6EMA30TA/PrqTXyCtYVRrJ5XKV4+72k8JtRQNMyTcMkG0yZKF7TSakoLpP/Z4RMLNMd5RCQoMF3R0nw4UOsbX6A4WT++QcrVrvZMqSMc4QOWY6Y9rqkzKgooGLuml0QO1hCP254ooMIcx6Zlk5H6a/DgQJdTLjKRjdVqVHKXy8b8Mpivpj/GwXAU0ETFmWu4ocuV8729FLaLIvLnIymxYU+03IjM3Wb7rluL6hxY7RAsiYYJemCsK0EYOabPRR9AY1fap580/byFK9SOuKj0pS+94Q5zuNMixl5gDKm+nt34tqLBbaVA6mLVOOa1BimG8l7doJWPhmxgEf+lMGWKQNyeNjJmcOCQhz3EZfuKEfP4xz9o6YgtKLs8vXI2FjaIdGgDFZbEuvJ2d3xtrFqc5bDQNnkp5O1vI2QXu8BGmmHxCIcdYt1IpPes5KyU3PX1nDXJELx9dHb70vuubhdVv4CElH+7TjYCJzgZEx2AjWWgCVJdntUnTGFSRNzxeulLHTc9+cUzNOMUxTj6bjvI8umsxfT76GP4NtWDqNH0ZFPg1HecDtavo4A6o5SiIrNRm/la5ztHz6/I0wZeBP0f82AuL/qAq11BObnpoe6wq8uFU52igNam+jRUaPpiYB3rysRQeWEIzTPvooZqFki79dyudsUO33UdtFH/4o4JctI97euqAhXd7lf6+3VifWinvpNbAcBDxf+DPziEo4BGU7mKgx6I+6RTuxPTqh7HizyHozzF2zQQszzNqkALlBTOS0BLmR/WCj3ygbnQeI6US5YsSz0FYj3R4LXk0IObs5kXxDnbuz35EJYgQAJXeh1iK4+f8z3f4wVGeC7ocjINohvlo0EP6o4hMxbnS8Etwypq6TLqqz5ti6F4YhxLcAZUCLuv0yGGIBKBqb96gys/K6d+I5L9cj/3UhvyAwN2C0OkqD9+aRInwQENAB4E6L//C8AAxCcJuAFAoLW3WLxZMCihaUAHfMDL4jAJzCwMvMDIgsRIHKTpmZkA/5qfD9QDzihBXXu9E0Ql1ku9KYQkPWjBGIRBF3RBGcw5aJuB8kCCGyS29siC3uvBoDMHRzC64oMuKXs63jDCDLIPvoG+J4SOKGyLKQQzCtkardmWDIEJVVKlr2siMTMSBDsn89M3vDPDPkAXIaEDc3o/MaQ/Onsr1mEdZ0PHdKSXLwIeCBCj/4PHRVuwKfFDQFQjRjxAOTLEyriTyoi4llHERRRItWgek3FESYzEyCoMyeIjjbpED1SUUdjEEORE/Wi9JtS1xKkUUqyOyChFVDzFSjJF26tB5EICYLwVHGADc6hFW8TFnkPCIJCuGlzFXkzCN9gavsk1aHkWYoxAl//7E1h4kEC4D7uaEIHIoXA7s39BlyFhp767RmyMGCy6N5lAwx4KRzYkx3I8OjByRwqwjf+TgAu4w3ekx8MCwKzowyUAhNIDE0bMwDhCJH6ky6KBvEQMyIHER4fjy4fTozh5o8CcxMl6jCtYNVR5MVLMjzSryOeTKVDMyFFYjT1hQTP4SI6kpJGEQVUElZqEjxs8vvYAzSgYTR1YA5ZsSXMAwm6ayaRzzab7xQ+KqpzSsp70yRWiPEhpoRjyL/e6JA2BoWjchXT4PoXZNzjMRtu5Ij1DJ7jbLzZjw+hEu61MyaeAiuCREuwcy+s0OLMsI3lUS6yAACJAPMZ6S9IqLbz/qJ71nCPAHLXzFMgua0TJo0/pWchGIqT71E/u+TyR+0BKkbqJFNCNDD3MNNDMRFDN5MzO3KXdg0XyKM3weAFHALqWRIUm00VdpJvXZMXYJJXsAqZhvE3F083FeJA0wBM1/E1JwIbh5MKxIjdySqfmVE5s7BeqHLAzPD/qjE76uhUdWA8fACPutAqBu8N4nJLvBM/wFJ7xbDWg3Eu/pKzHq6zIgsDJWxBjVLz6VCj7lCz8/EswLQxLpJ/V+k8ARaDXgxTJPA0WJEXZw7nLTFAF7cgy6EySjC9fBM31OElXDE0JfYFFaEmhY4Pi09Bn40UPLRbtqk3vkhZrwc3c1B4I/2mNODiONLgkSeBC9SorIgk0dKJR25HKQvOJECoY2QkwiOhRH/1RIHU2e9LOs/S/eHTH7kTStMSYP8ypn8zHvfhHDHPPK/2nLB0TYpVU7MHALz2MMB3M/cSMkWu81qoUAP2MaYUk9XHTN7WfOeVWOl3Q4qgIZkuPCI1QYusmLaDFHpyHJSO+o3MqmYRXmozNKcIyEVWhe71H9NzNbEHRHniCKTAOOHiQ4UQF9dohrAms87O3n/A3HFWSP3gETGgJcmE/WyoiVnUrZ3OKCbAnfQojBYhHkEW4eMTVBsND8gQZAxSblNnA/dSj9yzWR/2umUUHmsU2PJKTh/NLZhVTl/+NyzElU/yQVkphmmnFxGzdA0iozG5l2pH8VjwNFtIcV9C8waolj27SAXRNTUf4AW7KUPdgOnnN03m9rq6BBYts1HuFQl6Vi31dDTzZqIBFSmfYwl1YL4CZUUKzxrcrEr76EVQNBIllhcFNBU0ohDAgvx3YJqzlphaoQ469VbEE2cmlXFsVPCVNNLX0AF0NRLjYUoV0z6NJyMijON2SWZpF3dSVz8tDVsH8UmUtMUyTE9L9wNbiwPsAPUvkI1NB2gNtWtvbzDsdyUwhXl9sgleMLmCRUKxdydScAxoIwuRtTeOFj3gVVyTMm5JShmoQh+5N27JZ288VjJ6ZzEoSHzj/wK/ISQhUwKH10tHdIcOotIO2y51AsAMeMpj6rV/BtVty2RG2Ulwf8IhWxAEUQIF5UQE75NiOpdVZrVyRxRLMLVl6nIFGWIXOzcudZd0Nzh7VPd2aNdYQJovWfcTRNeHAvMDaVWHbZeFf4l0+UpTk2NbfdY3a8zUbxmFi4YKx/cxENddd4SY2SFffqwXnqoLnikk3Q7cetkkpIxbkaIVd5S7wjdR/YqGgNFFKhRX09bqvq4YmegmEhd9Cu0bZiTceMrA6oINAqIPA9V+Ktd8iAh16aYETOIF5KQENUGAGbmAHfuDInWDNJQI+SFn4/CcOpkBkFVYDklkQFuEPthad/z0ZSYaZhKzkSDRItWjhr1lhyjxaN+3dBE3QG75T4wheU97hVBYi2NRBxj1X1OzBIq4v6ZXJ0FxiXbHe92DlYQFRvnE+KfZEta0W6sPixUjGS/FNnGmJnAoGaXQFQksS+BU/AAsnYciEa96vIKEdQ3jjwo1jxQWdOc5jPdbjBebjPo5gAnhgPmTSjZlHBEgsezTPDH6GREZkRTYLSNbnR/5gSlZky7pkC/TcTDZINz1aThapT96MpO3dGYYaUoZoVJZoiK6I4tVTqfXhVm2yPhjioPMFL7CXHr1ldMvlkQ5Xk46VskWO5jsprwhmVpHCzWoUCJlMRYiQ5HHRYIjGZ/8GqzEm47uLnSUyha/zBWGwZlMwXEwwhNlZak0YXE2A6m/ODoyganKegD0+Z0BOZ5Jd0kB20gI05LKYXY/LWRIeaA/eZ2MSYbP+Z4E+a0Ek6Bj+pRVO6IMGZVDOzG1d0NeYaIvmaymw6JM2gpIe19wzPg2NAkaAZR+cgybL2JK03sGObF1mYiUGxrTBue4xA0tF0T0xKRI8HFdzyxI1ZjC7pAgJNA9JCLu1IUIzsIa9q7tbY1bABl/wBXCw7UQAh6PG5mtGBEQgF0QwBESogyPq2hXYgA3AgBBYbnNeYAbQakVj564OZAPwgCYgCCilZy8lDEvmUi4ti7R2ZLTu54T/KmG37ktBxMe5/sCocgyRemHXumsWdGg67WvxuW+/HuzAbqpXRL4gNdRbOYPF/r1a4FrWrOUlTjeShlfJXnDKRun3UOkP/RSqsSRFWQ3Y8oqUVZ4Nl60wcz72Xe2D7Wm4M/G2kz/5w69UsO0Wd3HfhvHfzoTBFW5CqAMgGJ0fsADmfoAe93FzRmeTbWfppm4iR6wv4CftPkBmlSy2fmvyhnJ9Jg0nR+9IQ4vdfQxTgW/H4N359vLroiTs2uv8Bmz9NvP97tNf2dNb0lDTHGLgIwcgDII/hfD/bvD/PukHj/BgUUPO7MjZE5876GzEPKmUQ7nrM6kXeqbV9uL15WmD/3lf/oIIu5KDQtgFWnDx227x345YQpDx36aFTZBxQ6CCHE/uH+/xBIBc6IZgIXd1qSC86jZyAURysFbv5mE8n0Xhtl5k8ebn051yf8bn9LZyL98DkWqEY99yLjd2+h5lHR7zM5d2cAXXkoayk0THKEtJ5n3zeaCF+bJsyp7syF5lPYe2PldF4AVJknJvXwazlt6Q82qinMahEFmlSNdRokxxKvoDTMD0bHhxYcCDTx/uTzd44haCAOZxVPfjP56KWBdywoP4Ih/ygjM85wtE9ITd7vbuSa6j0s3LX5fyeqZyYg/rWy+LZld5Y392dY924sXvaUfz/ZbsViRNqYVQqf9NOqVjjwJmXCGuhaICujh3kSQWjjuveaSHbMKGD+Li5ZxzjcyM+lQkqaLtEJQrK69Lh00lcXwfkoGwX4Lx92wgh1qwbXLwBUTwhYGv8Rp/hDpwAzd4+zOwAiFIA8X9gA2IAB8/gLBseEB+9cAX/FmXgDQoZDKhsDAl3ZI3+UUU+ZEneXum5EW28mlQeUtieWen4ZeXeWonAv528MKG0D7dRTo/Pub1AkZABXL4vaOic1223gVHesKec6Zv+j0DWFW0VAdKUOQQPZOCHNKDxtUOhhYd/nO5d7ACq3F6IrAnu4IxBWz4BnIgB4Cvhd225rhHBDc4Ayrw/hunAiEgHbz/R+4Q0PtUh4A/BtkG+Ht3HvyKx9WRNR44eIRjYFvQ5fhdr3K3HmGAaCbwGsGCBg+OK5hQG8NpDqExFGgM2cSKFi0OfPZQ48aOGpeBDPlRz5s9JU+aTKlypZqUJ9+YiSlTDE2aS2zixHlzJ08iUnr+ZOLTCNGhQqPMiKIUCVIcSp+icYJDCVWlVXU8VYo1Sx9a5lhZbSJ2LNkgPsYSFWt2bY+0bMterSp3ypeWXYTWzJtm76C+kjydWgVrFWFgho8hTow4mLNgjqulw7ZrlzNgwVy5+qt58x9JhT5bwvTI0uhKjzoHCu3LFzl+/vCszoQIDx43MGC4ofKCyo4dHFZ8/7AgPMQDBhKOQ0iuYDlzAs0VNIggXUICA9avC8g+QACA7d6xEyjwfbx48tZNwIF1jFnHiBVnvYoPn9gvXBgzJpOofz9Fgvj9I4SOgAsR+FBDB310X3/8ieQRRw8mGKFGK72UUksW2vUSTDPFtBOHOuEFVFE/3TCiiUIZlYOKK86AwwxIMMXUU061OJVcSszoRFZZtcFIH2GdVVaQar1VpJE3HklWF2DYNdZeLQHiiSePBHaYYoo9tliWWUKGjZfVOIYZZ3+h9ldoZ5JWmmmB/FFIJsL4wo8s4PgCjmzggCPMaIgYAgNvvX0QggULEFfccwdUd6hzzE0g3XSJgheeAP/VmVdpeZYa4IEd6hlYDoDvzUefgiLlNyqDyPiH6jXEBNhqgQhCJOGCp0IYq4Ow1rqhSV2gxNJJLen6IRcgikjsicWGiGKKyzrVLFVTTRWWjFE8i+OO11YhFVzbEtlWEEJ5myS31TJRFpNyqMFHlKYRtiVjWVqp5WXvWvbYLpDt4iVlmGU2ZplqkgZLmmiqiUgqiNSJh8G14OnGbJk80tsOPeywQaHGGYcopBtzXF2jjlJ3HceSknypySejnOmmynT6qagvm0rrrP8hSLOrB+JaK6mlzqxzrbfqrCGwe2RY9Eu8bggisUuLtUS4Ip5YhLJOs1i1izLiGC201r6YlA7/1WJ7rbZDjtvtkWsdRTa5YDsphxySmOJYvva6e4wrct+9WCqIYXaZlfjiaxi/ZHpGeB8EI46J4oqfVofjj7jhxiOIgFOL5Ihg/icHOwQawgIYM3pox5B+3Ohyi46MOnjapdx6C4AUE43sLT8Ts8y2o3pfzarm/Oo5PgO9s/A/B++gSWaowcWuw/LavIY5Mc8hUB6Wa+xOzE4d9VBWx+ii1tpSK23W4+v4tbVZvTW22maf3T646Su55Nt3T+au/fbm7Zi8fltWLzZg+q1f/iqcaQYmMMSNxhCGGA0VqOCnOlDhEbqhguNe0IMPYDAEHFjA5wzFHEWlzmOga47qNGbC/5KxLoWts04KPMEy2qWqZ7eT4X5imBGXKURAvduhz2QGvN/xcCTDQl5MMlTE5ClviMKiHtOYmCztUU1q2dse9pIyFRkhQWtTeRFSsJLFr1GLbWsBUtnYhzb3odEtc3EbIOp3L7o5Jm5xg+Pe7FevvnVpX5g5xQDNlLhTDIw0olETA6mQhh24QGIUU6QLLNCDEITAAyMEIaRIFkIQlhCFmLKUER6xHlvlbIai7A/MeHcQVrHqZkHsIc98+EOgPQR5SFRi85JIy6TlpQxUs0kcpvfEX0IxmCWKwTCLWTWwiUtt0QofM5kpRvCZMY1nnKZbmNc2S8htF6mImzbpZoo52v8xf/QSBjmHQc4ApslwfeiDZ1zRh1XA7UzwbCfBJNE4O9gBDugKAxwm1pYV+EAFAk2BxTDgweaI54SWXGgmQ7hCFa7wAGlYxQuLN8qQ1KeUFIkZzmp3w46+EiQ2HGkrXUk8VkavlkfEJfSI1UugWI9c2uMeFa1mzJtKk21YyZoVmxXGuaxPmWrM6VDfRy4sIBUQmOBmNrt5vzqKc2/tshtiqvG/MBGGNOo00+Gq9E5A0jOrWmUTIPB5CHzqMwxQCJIKeiBQixW0OMhRqHM0KbLTkdChm4RoyiQABU5tA4aywl1GQ6Ug3YH0o6sM6WBNatGg0dKakZ0s03TZA13i5Ar/yBImTWuK088SFUdZdMpSfJo1Z5IRftQMVzRXi5ejigUNf+CmviTzjWyYs47ugioe9beKcwqjfvwCa5kIR5rDaTWrqziTHwlI1nymNVtTCOhACRpX6ixHOQql1F3r2lC9ooyvrfNAGgALUpIS9hahUu9hJ+IqCS2WlY2dGUfjS1nJLjGlTsTsZqOYFtDatLMALmr7glSjLp6WKd/7adlC61oCV2tJWHAbJrQpCXzaYbbZkMc3huFhp8YtbyIuTGEcc9VtuoK5W6XnVy3xTuOC9TMXfm4+MVwFOEz3nymwrkE9iN3TrQ6ilfyuXfe6yQeU94XUOO98S0of+chHo4jF/xmTQxnf4dGQZ7C81X27rF9dxuEJl+WvGHjQX//OtIqeHTCBt7bar9GoKeoLqo7m3No7D5UGEGYbGGZrCSzUqAdToIMphpGN23o4juSUatyOwejexpFfYy3uOsPKzhQLpl8q9kxZO2OHs7qtCtJlq1uvi13tPjRSRA6ykYNsMvJ6UrDobe+TVRFlWi+Iyo+Vb5OdnGUaPtbLwlbiEnpJ5piimbMCZnOAiarnrVFLz+p7FoMbjMbW7hm2fVYcHcBgBBeAuwh2qLCXOgxcRzv6btsMUzYjnVV2Ulozqzgc3OJZ7+WuiUw0tvGN1Zrjs6xgoKberni7C15L8bXg4vEAKP8qWmUJ2UdB8LG1YX+t2F1fudeEtZl8h4gEjw9bv05DNtRMZGbNMrvZKV9LoFfrZpbDeYzkqzPNueXgbJ9xjW5KBSbk4C0TEFMOjCj0N/aB6Ejjjd3t/ua7CVhveoZGue4Ua77J1Oka6/PGOF7rxNi6Y4ISVK6VVDhDx47ws0fUBY9ghimtDCr2blS9t66Ixi/O2LtfFHd49yixP848vw9blyh3YrKBaaJlr3nlzy7Ky9/ceNWiTUcyxzOe9yxF+FVBXXzwNl2mEAMbuMAIndfwoYfB272tm45Mn7RnKt36SYtp3umselnVxcZ9rjX3pK6uwCMwV/KQ3btoTzjZEXD/ALU73O1vh5nc4yOqGT4/lHQnqfSx7OuL8lojQake9wEP8r6jfPAkL7zJVZ5yxef02aQ2WxkpX+AHfyt7ZqFLFdqQvBJNNwYeADroK+CC+eVL6SlapDnVZTAdPLkevMlTWKUYAnFG7cHBIUTX1tVFatEA772VBjSKdQRA8XkH8YWXB15KcvBALCSfQyyZRywfezUf3CmfC4oUKK0KfYzUKlkc9mUfhGzfsCTL9+0gsY2fsh3e+RGhDBjhijyey11b+9mcNC0e/BnJWqFBVITakKAG4zHJH1QYh0lGObmRcGGGi1UavMFbc2mVPQkSV1ld7Z2VPlVh7mVLFezAvz1h/8DZYQZShwMYHwhCFB+qUAeSXQmeYPAUVsQxHw2+IHspH/W9oPXVnWPJytT84C8RXiWeWZolXhGiHxQu4eTR3PxNm/txYpuBolWkQBO8TWiwwiqagiWgy7eAGw/IQSocmgA2VaQpjjtx2jqtk4sdF790FXMVgiSgRu0BQgSGGhzsBRzqHqntFA18TVttxQ/ogMCFTKr9ISBiI9llQHqwTAo2xOxsxPLp3UkZAwziSikxIg7moCM6FiV63yT6UhCWXLLdgJlpoiYmIczV4fsxoSiO4j4GiVJEhQmYAI7IQR9owjd9GCYAgucZJHqMBtFJxhdq0+qVYbzB0y+e4RkSo/8xYp0b8pPuNSPAQcsFQqMKTGMWUKMOoEA1aiB3+WEIzuQe7iEEYAAlIAY48qQ4Ck85mmP0PRzHPaLbtaM7Cg88KuUlMuUUmR+z4eNnERObCWT61ZwnNuHTHOFJusU+Mt5AkpYTdI0RDlqFeVgh4NMjAd0X4BObFAIrlN5kXOTqiWGZHBca6tvTcRpI8oHbuKEy6tN0/RvA7R5h+gBW6EAWZIEWeAFL/oCoseQKxOTw6aEDdCACiKBNJlRyTMFvWYM1JF9g+SRSEuU4XkQMEmJpniawHSVQWp/3SVFTyuYl5mMRhttUbiVX9qMSJhM0WVtAPqFRJSGDzUgL7JhB9kD/GChOtpxFCITbjrVFClQBI+wCLxwdK7ZiXbbJdu4iMZahR/KljYVaGPgbM44aYhomem5FG9ABHcxBYyomeQaUBv6YZu4hIFYmTRacA+BkJZATNXymOIZDNyQWOwKNUO5a3JFj9Mng3t0gaSKDU6aIPC7lbNrjPdZmVGroTeFmblLTbp6FP4ZiVlYeb7qW+czICBiUQR2kDzDnWkFSjOLk/p2iey6kXF4kI/hIMVJavD2g7ZUVMmIdP1GgeaLnGKmnHD6mF7gnfMInZFKjCoDA7xlfflqpfl7mCOqhB1TCVSlZgIpmmLYmYyEoe4ASfb0MCzKog6rggyLl5VVoMMUp/21mYoZ26J3iqW6q356CKFU84zOVaJ6ZaFVeBVKcACSdokn+ExSQ51ux6NdBI1d8hiZ4GCq0oo7yaKZqanhi2JCO59bFoaiJTZIqRaiKahi0Z3vGJ5RGaQmUQAdUwJXm56VkqR6mDH9CQCdVlTCIQ4D66mge5ZZNWSLOHWreHRC1qWv6EJzuoJzukoU26xDmaT7e5rQap/e0SFuB6LZ24jRhG7cG5yjGlikuklulAAbsXwnUn1qZK6SehahKYSHQQo5uqjF6mua1QV8Cab7eXjKOJ2QCLLwKbMCK6mMGbKqmqpMqqVLMwAnAqpXO6gpBLK7aQLp45mdCRjo4w69KQ//HeuxQNug6CmvzlYLz2V1pfmzIsqPMSKgQTuic1qlU2uaGQuoR1uy1Gue16im4dqvMkeKgAi1Q7cgFGuQDrCiNGiZ0yqfAgQAI+MDOocKO/gF7elqnUu3U8qvtZW2/+uu/AqxiDizBiu26ygGTzkEhzIHjkOfarqsctsDDVmZy2Cfr2GoBTCwFZMAIGEFJ8EElnMIpFINlcGzKpizKguxJwUcoKK6tIeJ5AZHhFm5RilLLvmy0Vu7luiyG2imHfl3Odq7ngq7O7uxuTgWcJYWCjQ0yAWfQCuS0SCGjPhJ0BhT+UQzX5d7NQqc08mJ7Wq26/MG+8uvW9i7XomrZsuf/8bLn2Cov2H4twipQIKSt8x5vtL2q3MrkpMhqleIq3uatitpAEmgW0TQCJYxC4JovmHoKNDSIDIrpgWgZ4ooCJ0ACJ4TCLKSSrkmuyprmyupH5sIs+Rke525uteIpMYUu6GpARIqu9ygqnwYaglWLs/EsoXprVihtHUBBos5uAqPrBiRnGzAn7rqI7CJvqFkte/alp00tIKzw8J4w75Yw8rIt89LwwbYtebbn2T7vOl0tD4NwEFRvHmqvTd4t93avio4AC3yv3/FtJHTCKLRCK+RH5IIS4R4IshqrT8bH4trvQKRv+3bs9dldaropfzylmlHu/1oNAc+s5nYozhrw/wE77AXk7QUg5wSf0emOFgWvLh8bybScq/+V5HE2bQfX7g+LcM0OJPJW7XZmJLy5cL4i7CTDcAwn7wxD5njK5w3j8NQ6jiOn6nbaQQhrgNwW8fbibXLQsUGygPd2DYzMxBvkwR0Iwvw+sRTnQi6bqRWHqTOEcexYcTLoQgtGXA6FKRZDoqzx7374Lxrbo1NeKBFYK5vhbgHH8XHmrKsWcnKkctMusIfuqQ60yJFGcOoKKh6Ha29qhVKgpNu+q9u6ao0ygv2tn0lCKu+5KFcsFSrwoo+4E2jcZSOHsgq3pydTsiXDJ7+tbXRxMg4f7+6CcpuwAe9Sy9vGatxqbypXwP9GH7ECLzGMgG9QxARJvEQt+8UTA27sfOY6dEM6sPTGBigwE24xlIqaftQxi2YyLyKEzgziOfP21ZQa4yYbD/A1X3M2czAdX3TcXkACX6u2pjPXiHPLATGhgjM68+ZUm8VTcIUTGGSihrBKiqqUavM6UxfvfS5pcZNcWmpb77PiyNimFrT0VrIMJ/Qos63VzvBeDzREQ3QMi3MqYzQ3zyisdoBHvzJIi/QtPc9J9IUTSzEwrLRL+zIvm2kuG+L02QpOIzOWhWxnWx/uxOxokzaclnZRw7ERIrAGJDXcUsDEOvVA7WZScNEX3ZzUYPXoVvDQqvY2gzXA0WcHs7ZApeT/Yd6hQGlzcvsAoVUnL1RqW7s1XL9eXP9B9E70QScsI79wXRtvHaCq2va1I/t1eP+wCSh1BmxvHRv2CDjsV78y6MH3E/DARwvL0azE+EoxFOdCZfvyYXgsTRtiMXMEZ3+sLrtjgqIprp32T0uzfwH1UGzogp8xnspxe3fwRs8VBNgnfx72N7OcszAwW/RUHyNhV7IW6e5UzOlIVAAxR2OAcQKcWCsmWb/4ctNBwLmrChSUBhqtBLC2dFjACmQBIdBCkc/rJqwiki+kJijQDn/GJzvO1XG3qm43hoE3JUM5lEe0X6vwX9Pzt5h3HXd0RLrye3cN6LUyK9M3TBhRsNw3/xTD+fkCQ8diti7U+S738u/8Ti6cw34bOMq2Jq5JhISTtoNrKIkQ+oRbc4UXMroiB6ptON7GdjhrtVOY7jhXZYlrJVGks6a/xYu4yJ+ijwIbN2tbwCm+53wKFDVaDHJsQJTq+I8XRwS0+qxbgA4UQiIY+ZFvwpIv5NAxOWjEdZRjt9UWe1tmOfQ+jrK7ZbNrKkFnGLTjU7boHxKTuXubOXxfe5qX+WshTYUcj0voCmRHMWYDbrkbuC+D5u/wd7tLw/tCbt7JzLQqeiYCcMnVZm668VGvdqNLEmEDvCljJvZWQAKjZG5iBVV/jYKxbrh0+sMDMRjp6Yq7zVrFQHILt/8ESCNiSumjI8oDbICO6zhc/fgGAHl0GIcGCLkm+EItOHeSywYhLLmOOrmyF3tf27xBO/vOu6WWk5V4c3nQs7Ao+xxSIzZ8n3n/WfvSJzEJ8F9QJE9JDM3xMPFMiO8eKELWO/ET94IueCzH8jey/nepNOgy/1qi+3QUiR/aJ/rnHnBrY7jHP7rAD7Ed57jX9FTC67aJS2vff+Ufv0jCq3iOgAE8u/pwU9dWeHdwY4CLogBcnTqrO8rkT8esrwAdEPlq0EKvK/nMN/mTF3TasonPD7uz0wHPo35qkFXpC73QeyfRGyp7N2y2b/v+2X7TH7Erw3JKqVTUB8vvl4RJP7H/fn+9NZyDu1Ox2YsxfbF94q29MVlu8+v7ohu9v8e9KmP/3Ht8lRb8jim8bsYcieP2VYer14hzqIM6krL4CcxAj/wIa2OAB7snTIb8D7ynQKGrkEumXEUAQKB4gQLFhggMEB6c8OCBggMKHmz4MScTLVqsNmUkRCgTx46GQBYSGYhkSZMjT56skxIly0KS/sT8IxJmnz41ccqMidOSpZpt0GBhMoNo0RkmkCbt4IFp06UZnkIlwRSpDaJMmAjtEpSLmjdfwYYNG4csWT1nI41SOypXW2fpqjlzdk6uNLrSmuXVu5dvMmN++z4THHgZ4GREECcuonhxY8aPjeSAfGVy/2SsliFLlqH5xmbPn0F3Dt2CdGmkGjA8uJC6ggTXrz28huC6A+rWDhAUQAABQ4oWOlTgEC5cB/Dhx4MkVy6ZBvPlzaFHf37cOI4Z1qNEId5kefYqQVb/zlIlygrUKlaoMMgQYpUwxc0zlPAQomsNGywQtLA+ofyGDCOw4AVDMrooowM30YQjRkJqyUEHV6IjQpMecakklEbyyaacbOpQpgd76qkPEf8IqiilUBzBqRWlanEqFa9CQomtaNzDqxu9CkuMHcky4ywzzBJkkLRIYUutYuqyS0m8iiHsrycNG0zKKQOrzLHMsMTMyiUuy/LK0UTjTEwZSivzhDPPXIq1C/9ka3O2NmsrwbYDcnOANw3OxKE65PacTrrG/vTTMuyu09M64a6boTrumvCONDJLSAG+9FizTzX8NgiOIPUAxJSgAPPbTyH/FiI1hBWAMMSiRDDSSEEGYW0wQwhZsvClRwyxVRKRLNnwphF/9ZCmXXm1xBVG+nDFQ0DQGCqpF59lsYKmXJzKRauu60qoN7rodsdvwQUSSBt1FFdcG4tci61z7sqFybailKaVeKGp114qC9vLyy/3DVNLLv/td0ww/Y3BYN88M1POOFdbSrWGY4MTzoUqxU23O9Ecrk/kpnMu0I+TU/Q4kY3bWDkngkIZKBzOW8EHCavYYM2XvVABg0z/dfCCDR0y3U8gFEZt4AMhXhCVVPbYU0AiVWvx5aIFGVEQk416arDqYk1aiSStA5H1QpKunpURYnnisKawsbaJkWPZrmRlG6JVUVpqq6XAWqlMiHFGLvjGKty/z9LDXHGRALJwG/eIRPEj2Z3L3WTOaUYXXeyanN57Mcf3MIE5H5MHgBMDnd/QSC+YYEgRLpNhiBuGTeI3XV/T4t0cmCBS0oBDgWMdFE30UI4FBR5k3q/bU7vtgkKDdxBsk0CDKtjw4jv1NFDhh/jkU0GLgVbYjz8GCCCAgQU+8Ll8DYLuzyEGNhCCEIsscpXqqWMVu2tdeU3bfrR9QtZXECvBPxH1/ypZyZIEKkzhCpjIIQonatED5ya3DECLKthSDLi8tbe++egre+DgHpDgwXGRq4NoIZJazrEWeRVjFCl03F3yUozGMclJzcjSDKTQuSyJjocD8+EPT6cwNDGPiM3DQMSmRZvWLFFiS1TTfOo0rds1Bzi/4V11FGUy4YEseIbCYXF+pyjvNLADzqNYRFr2g+tVDHadWsH1RBW+hDRAIfkZyKge0gCHyHEFWdDZGVjBC0G6ShP0gxX/8IeJ/CkSa/pDZACJRcCwhagmx4oasEyBQFdsUlkLNNHdIhhKucGoKtjKSqP6NqMQ8g0sXhGhjZBQuBCCcHBlKEPi0rUWd63DGf+jSJIMlxTMGi4DMkYpnQ57iMxjmu5gzRQiCJRSG9Y5UYnVpCacHIYbbWKMKFdE1KGqeJUtdjF4vBtOoYhHnTG2gIgPkFRxZFY9H+TsO/7JVPfWkx8qDAQ/C9gPBwYyRxQAAY4bgMjP1mdHPxLIIoOUmiGjhglDgq1CI8FVSBjJq4yGiKMdfeQiPWoJTVhyFWtjkAKTtckRbZKSaghCCaR1xBXByClIwduzLIgYGvXtlWa4keHMEMuuIO5cgvuRHhZ3l3Scg5eMm+FTaZg5vSjGmF0aHRAfk0yt6pCZzUTdEKPZTjWV0ZrXbKISyTo7O9muBdYB43YepUUukvOlizL/pxe1I0ZHkeY+OvhOPCNQPS8Qwgs+yGcf8ckeC+xTPxaoox4NkIAIDPQFW9CCYynbkPVpYKA60xkryDFIU0jNEaQtpCFBclGNgkSiV2ttiA7JoJDO9rU9GSmJVLpJTSpwtyvNpCVL1IMQrIm4MzVuilCULaEmTw3NJWFzZzk4oh71g7hUl1zY4hYm/VKYmTPmMq+6rx7m0DpWDW9XsfpMaKapiGJ94jSvmQEJyJcCb6KmWu0Up27+pq1enOs4uWjORBmngXoqjl/HeDw8oc9SDMGP9dRIPVKBj337yU/5HKsQiCDEIALCsGMlC1mHRAA9MluBqhpqoNJG1LSslVVt/ydJvxZnlMWTHO1rf6vJG6/NFajYhY4ziQrZFjLHP06FJgrx10jRwDYeME0FkdIEdvY3uYt5FBKYGxRJ8CF5sdwDTCTRUxFysLrmQlcj1PW4udyFu/YCZr28SlXfnXdgVgUdefFMZ/QyM3XqPQHDbENE+A6aiWXlTevmM7vd6NfAbv0vXaXjA+KgU2Qja2AseZfgAxfkNQyxnvcgXNANczg9G/CngKwAhA/QkY6LVbVCyPeCFyyA1XukT0J3UFlW1CK0KkZEJoDd4pdgQrUwLoQmgM2KXSwbI6dtrSlogWTZGosVO8YEs7EtZAT6uNo/xoQpjHxSBGYk2xgpBB2ywP+gFMh0CoHwDVOgUIUzlegEMjj3u/PWhj8cxSp8cEUjYollBRK1EZJQIExG4UESVnfhgpNldPcQilIcKbtIsjgw6gIvJMUZvOnlFw/tbF6s7hlMz/wzoEFAaJXTd74tx2ZaFU0Bth6KKAB+tKCAQzxvIqfSYnybX6PH4MBmYQ41o5hE5kCIoo0KBZbN8PiaDgSjTVbqc5wACsag6vOtz9by+QG6002Lpjk02GXfKI5Z2xNmHzkVbfd22neRjV3UFtyseLayb8xtS3B7pHXP5DCehuxWBRIV5MZ7gizSBjVFQRNyOI0c6FBvS1RhBDIoZAxUlLdvp+BFf0AFH6wiowX/auuAYf6yKxROwun6SOHjMpdQA4e4xE3uSBcHhlu+m3tlXhDkQhV5x0kuGpODlb0rN36hyzqB1sVcir9Bge9uDumQhTGMxtNYG4DyZwnoIMnAMQh6Fsz1TTUWU3Gk8Ae4VxANh5jV5ROaFl7ddaSh53o0YENDQ9ts06Kd/4Rn7UOjTcYsYu5eS9neThOW7e7mzsdIau0AT//w7mkSBEFQoaFQQQeWgvEsgZ1GAPs0z/EsTxPIBCmMYLTgJm92gt/QYMu6wKcKThKaxUa27INGqPVkz/XKpXBqSfaGhEhO4QdPQfd2L6u6pPd+D/iCSIiGCE84sAnbS6ao6b3iC/kK/62MnkjRFi11giP6bI46xIm/9ESc7kpPyOMobEd3Nk3oNMvBOkxAfoADjEaO6KhULuwD7DB9Ws3C1Ej9EiI9EEJ8/CMMkq4imgYCne3ZEBHahiHv2s7t7A4kUmEAE5HZJArcFrHvhmEBL3G0HDB+ENBAJLC0Cg+BBOkiyKgKJMoJzgR6SGPyQIAGUpGIwODy/gwJYAIV0CD0+gD09uaAXmkGWY+oWK8GIY6Wxgwsakm6bpDjkPCHQq4Ij5Cr5KzPhm9hnnCspPD4ptCsnEj5FM15eiMFtpALpa/S3qp4qmhRsmN50CdnCOLrtuAHgsZ6qGAF5vCNqKDonm4hPiD+Av8E66qujmRt1TZMQLSgICyAU9BoPv6jjwRxE1JsAssuE1oL7jLx7+DHF5DtEhmqEQFw7b6NEkOy2zjy2hZxE5ZNAkEx8JCttByh2RyBnUAgCmyiDdjJA1vAFWHREsAg5UzADowFCVYRBmEw9LbM9/ytEbgAy2RvlZTRzDxIlshllg4HqFgpGb9CCLWyGR0jh/IsGrkSiIYPG68xG1UuG5OPYpZILSGATgTgYpoPNMjxM6bj+b7pHEeGDBMMwhjsec6gaNbjjXaAPw7gAV7ADeYADllNaAJqMT8g1RDyjGpNfNDvemTtjtavP3aACtBtCzKBHAqR7Y4M7T7REYEN8CT/KvCwjSKJjCTtzhJb8xITsBIjsduULdoILxNu0+5WTHoYQTv6oAVsB3qg56UgL2+SzAOCIBBwsgX+gA0sQSiRQN+i4CixbBcxjW8MDvS4AnF0cBhxEIREiCq/UyqxMqikAKi2ciux6hmhESzDMmFOxM9QrizNkiyd6D6RTy2tEIp0Y9FeURznMtLgimMKxdGyCFHWSehcoz2uB5++5yAKMiJWQD/oKAEwFLJajSBkjQNWbSFEzOreCDEtgNbyKCHE51QM6sSchhZCK9najrRqEyM38hIvYiRntBKNLAEtEdu8bRcCUPBs9CJAkRU8AiLnwDhshxFKYAJ2xnmKM/uO/9MEdDLJ9s0ElOAP2oARhNI5+8AWv1RGTMEmAy6WtrNMzYBvhDEZxfMYo3Lh0PMqrTJNg4oZ2bM9u/LOvHIo4DP4QEMJzYQsYco+8VOK9NPQWsMb22RO6oR2wlFAB3R3vLCKCiwM8zI7VACm2kQgL1N35vAg3ggwTc0O3a/WQLQBMsyOgMAfUXTUKNT8KGzDIKIwLaAH+ogQ5a7bgm1GgZTtLhIBU6EjK4IjebRYLyIledMiduzwBrBIQUJ66sAQVGCPSkALFuJJOwB6OuBlWgAnk6zyeLIPlMAEoAcNNpA0bGIGqDOWPi/g9sYW/y0XZ2nMlhJOu4CWeEpGvKIF9f+1XuX0X5fyTgU2T/n0K90zYDwuzgCV+AgVNQLtUKWQLRGNGzvtYdqyUblpHCWNC/ukiqyjd4AHZKMg+4wIIb/uB/ZjQObAscrPDTJBCPYRBc5gDQKyVF5gCF5AIFcVaEx1MpXmwcrHnrAHiiBiaSoiG5S1EY/1V2e0aVcyNms0antUaonsJOMHJpN03WbDjzTgLV8gCxJAALi2Arg2BcTVWynvZYLAA6nTEg6lD3IRDVwhbk2BF33PTONVPLtCB/V2XFrQR/a2KwQXX68ygwq3bwa2qvD0PQ22T5vxUT72qxiWvUzAYQWtUDHXLJXPUijW0JhviiIVwO4qHTUGOEb/1vvKKGdqptTy6Qzi0XtAJWlGbFV39kNRder0KAJeQNX2sWcpbAEgjArqMQRM1NZmIwR2YAduABWzIf/azkB6VTdRMzcjMGkj0Wo18UYNUEgThHsRcBN0xhDowBB8wD8R4AHQbT6i5/m0oA80AAJoUk6wD916gxHItBBwIEqV5zdPwFyBog3aFQ3a1V25YgW3TBid0stkiV8Hl06/U3DpdIMkeCkDNnHt9OP2lHEJVs88rhqtcSkst3Iv11Azlz+3sXPdhIm+EU80NnTPCQy/6Xf4BCgObMGOxsEsE8Mi4NY+lekIyv1G7UIla9VIFXdblY9kzR6TBnzsa7hiwwem/5bwovgkO1FprdgROVE2j/UTD4Sh0M0QsoAhoMcQLCABUmMAdEMFzmCH2WAN/IgNYlICWLECXsYmkDMLsJQR9KRExDUKeBIJ+GAXOgQV2iCW+qCQZQTL5BXLUAEG5RW61IA8IzlfIbhf61UHJ9hvfO/KLriTifBgNdhxf2hhiY9yBzWESziV+1PmSHiJWBl2KmCtTBg3AuAtM7aFacD5wKmbYvhAEUWL3grButUR2oBl1NDqPiB5LxNlWxX9Xg1VOYB2+enpFhNU7DAy1UeO3BCOhrYhwDEHdmCMYdQUhGFHH7DcttfHjrWKbVNIfwwiA7DooNNmambEGMSx6hmNNf+AEGRmDrrWjAtBB+C3EBz22CIvBew3j62jQ9oKbr3URGIiK/6YT2FCOxi5KAs4kzV6ozE5gxI5lWJJYTyZ5BrXCEF5cUfDg/9sCQlVGyH2hFUYAurrlWP6LQGUhTU2UeIKd4gjnQpUePqLOGh4RBZKHl3DAjhgMCvTHjfzL6m5H1m1AThgDRbhsqo5aDaAshASP2SXfVDAC/hpB+CACnbgZiRFEKNmWYOsEbE4nQ0vi7HXNSEyWf2PQGIGIXJmAg6ADlaAPuC4jHfXAN4yAs4gqwmhIXJDCyhPW5mnCjYhOBFa8fz4Jg/5N3BxBtLVOqiTCSZ6KCJ6KATYkTEtlh7/eaMNt6Ml+KNTqW+wQPc4eaTnbIMz+KTxtHSosZT1a6U/uKVbOYk6gJVjOQp/27eDWwphGa36MzcEIL9wegvNiSCKp62uSLq7EHiyI/v86I05ZQWSbjC5ug8ti59ONXf3SHc71WiuOurU6EEJk+sk9AGoABEMYQ5EAtm+LRVWAdgYEYsnUkarrcgQyMi4LZCSVtroAD+CbrJ2ZgAUgA3K+C1XYA0sIAAs4Ax4Vgu84AAmwi0hQGfI1n1tRwWQLFLs93nctgS2FI+5TzsIOVHkVsv+YKdCuwUNDpHLNOCiwLT9hl+5AqRXu7VRu0yMyQVge4dAOZS5ipQn9+QE1Qoz/9dh8pO4hXtzjZsKgxu5y+hzp+g3gFrntiiog/qX9RLoogBP3jGeWrW8zUe8c/eq8/ADPLR3E0KhZK3+RsU1SCxnjtQQBa/vMkm/M1EYPHKcD6/v/nvbdlMj0C0F7mnEdIa+UQCKuid8AECqGwAABmADPAsIHqAAzOM/E6AEMJAG8HjBpGcVVZFbZ9KhcYCGsy/TVkYnLIHL5ECBegX0bvzSPtqSdbwLZISCfR3Yf5wLUGfIizy2SzqTd12Up1EJWQa3c7s+x0r5VBkbnYgCqjzbYzp2mgdDL+bQQJfKiEPIdzlyIdeLwpwMs6CKjm6wUNaIC/LCZG1nqRnWNpQDOP8gsayOIUIlU7ZgDupAeAN+EJNNItk6x/Ib2dZaGAS9nfu7JRF98BKkmDkFihr0YuYQjQUgADAUADye4wfg4w2AiW06skzeecDRcrdQQMG8hsFQwEhDlZQLC4A8O7wllmS4TBtICX6d5n8cy3gecRm451kb6MndguvsyC9D2Zm9MW5bpU2Zt6G8UIG72rXd5aycYcyXuR8Fcr1+3NuKuuFKd9LdYzH1TM7oxAwhH+vAHkOg/PJc/QzyIEXFzeewQ/s9douW3/dc4gld4X8rv2OUIgX/4E0T8EfxQArPf/5q65Xb5Dc+8mt54z++8gPA8iefwx+iiZlwiEQa5j82rqL/27WLYihKf7QJxV2D3ffeNeiJnvV5Hctk5LVpv8iVHsmbPqWVvJR3W+qn/cmjXD+vnqYf5gqVm+tL4/nIXVO8XtzH/ZyIA3kcZQLuaXcZq8MUM0DGe7Hg7w6vusPCW5/Y4AWoJ3jHt+Ap0OD1G+ELP+FXQbf+3PDLbvCQDN18AKbsxNtB/fE1HiAEBDAggCCAgQcDKFw4gGABBA4dQJg4sYPFEhownmjBsaNHHB5b4AA5Y+TIGSVNFpHB5CRKljCRIDlJE4fMmTiZcJmp5KaSKDy79GRyUyZQJFGi2JQZMobTp1CjSn2ZsoiUq1h1at26lUhXI15ziB0Lk2TTkBvT/3bQeBFEW7dw41qc22EC3Qp4897Vu7cv378SAgOWIPFhgokZ0+rQ0UIHSRWNTzo22VRlyRmLk7bp00dHxgcqsuzYsOKH6Q0PGChQ3aD1hNYcXqB4QduChQiuUUewsOL2gxeOCHn54WWOoUzIN7FanlyTJuWpkEefbup5qlXYqbtyXp16JlbSmQcv1IYxBsKFI0I0XLDhgIUJ48tvH5Gifb4a0+av/NixSJAmMSZDVSvVRJZNNOF0VBc8NbhTT2gMhUZRWiFF4YVRVUbVVBtehlVJWX0loohhXZbgWSjqt9FaKsrlokV2+SXjjDTOJdiNOD5A10TrIeDARR+pAOAJQv9ChgJHNP3Xn4CL0ZDUH4ywUd4GGqigmwYWEPdDb7ZR6WWXWPK2ZW+trWbmA6TNoVxzm4TH3ZrNaSenKdRpF2d3b2oSSBg+WIleeg70KGh7DME3H32I3kfYXy2qiKRIKDXWoYFlVQqgZTnx5NJRPg2lxFBGgSpiUSjdhCKHqIK4UokjtkrigQQmmWKjjb74mVt2YVTXXLrW6Ctge+WoaAW3BroeBCDkB9lHIh0ZEmSXKsnRZJoxsiYbW2og2AEb1CGEF4bMQSZqvHWJG5YroACEbCFQmeULxsEpL3jg5VknnXNuh2++4YHHCHlKncejYcb6KGihCAuUMMGHSYQjRYz/0nqSR86idORklmZMVqyrfmqZSkApJdOnQXEalFCiltrhylC1wEOqJaoqhcyu1gxWWEtRitbOtKr1lq0xxnhCjL8WDexggGlgEQWBDiRRsmktW4KQJXSEArTQIknD1dNOm1kbjAxDCyrOiYYCau2KSVtvaLN9bgTnrUDIJoTMYffcya1Z753M3WvdvvgGA/jg1P2LLQ0pgIDeoAYfDFHChTpEUAIGNDwsjoxCrdGQkFbV9coqfVwpUhzXhJRSJxllYcoWLugxyRsyJfujNtAO84CTWlVhS0g8GJTNN4vFk4mzesSizz3H1SuLthq96/POY56XYBdUn5exBQWWWArc/+8H6bNmOcvkSI610be/jOiQ2gM7UDFcuitYGQKa60+wwQ4rgCteJonECWcq9HLTvfpGuAICcDqG+EPAtEUYxrGHUBBU2MLoQ7kKHkZ61ssckIoXJK1FhlKi01gQRqKp0L1EZDnBAVA85aBPcWEnLNMP7mqHqu5NBUFEqdkLewc8Vs2QKpzjGa2Ol59k/ax5fTFiEp1HI6RBTDAMnIhADEOsz0zNAlWTWkeK1Cxphc4HVSjEvpgTCPy1qzSjaVcITCO/NRLHEHgT4J34xjcCDnCM+BIPebKFFwio54+IgtwE/2i5wGBQgxt0FKQes8hFUgZxLwFhx0JYFaB8sSgiy/8kUli4SZOpLIY2rCH3bkczruxQdT2cYbQmJsTkEXF5R7TVEFcUSybuhQLTk56wGpioXOUHiyUAJoq+CLIwosKOeoLCCuanIx2FoA6IqEMdqFAHTPhvOnOU4x3/t016ka1NmpiDF3wQRQc+xD3oFGTk0kPIwkzgkBm8ywhMsCLvaSiIQ7pMrIBYIBESaGRf9OSFLiQhUoFSlKNM6KNWRbMWhoiHqZQkK1s5Sxblai21jCXyWqRE5r2IaTPCpUgrcrnLpcaPCqvcO7fHEZYu66UeDKj5dmHH6ExzBy7YQA/CEIbjjM07/rumULHZzQMu56h7i5KUPIPSB0ouguqMXEH/ClaYqjoMMfFEpEft6cHvTUxASZKoRIdHVhWOTEEgcR1mUJIUCqHQoKCkpwuiMldSZmqSOtzdQyfJz0hy0J6vhOUJttpRJbpysEmEpdGwmss/XVVYlGNIAlZ6tqoJU4sLLVLokiJGpIJHGACEo2it+R1tYjOo2JHOvkx7vjqhjw5tiG2TtOXU2kZ1YVYt5H1GerR4zvOIirxnSfxjFrFKsnSYwaEKEaQDVJ6OrKESKFwP6teE2hVEDtXrg3x3Vt7103MT/etgi9hSxJp3L+P9mXnVgliM0oWWNcLl0ubrxBsx7YKHWek7sbcQh3HVpeLTWoCaYEzPGtWbQz3td4QB/9pUHCMTDS7gKvqlN6TS1JrkyYITuOeDxZyNl09F2KEGWbncQiwBHZAvxBhVPfnKk6KnouRjSmfCEIbQYw0ymesWBFHpUvfHds2hp7grZJKd0sje/W5fIwVj+BJWlu2tpZNtmWIX+8XFvH3YogKDX+1tK7IKUWmuXKrQRgqYfHLAhIEP3LcITwe0EI5zJiYcHTrjEahsFpu/6FCFDielTzLws2MmUEEJing+84msBRftzl2BtAJWrtFvgyvXGBdXxiXE8aaUG0mActomIbMQZjB5ui5MKFOz+yTLrutV3ZUSyS584XZnXWQle+4/TdacYJHo3iWml8o0Eil9VXy9LP+fWLdeZlpKG1ZFlmrEWctq0oCh8Idg0LTN2HYwnuH8nQmD1s4G7JdRnQMwGigtWU7y8/uGRpiUHnrEEJycBR8LaQhMQNiR/lWlxYtPZunsxmVVbujuaiCf9E6tP2kr6+Ba3JfdgNW5q3V3R+Y7WUc0Jd/LdfKiLOUnnxfYc8l3sInd2JGW1LEI6K9/rUjmR3E4QAWm6YW1zW3VgpbbDXYzAI8hOMDlHM6YMEQh5tDnckogBR5OejkNfdswy7thltOtfPdLX1+/ZZ6UZrKlI/mYVZqQUwr/NDGJaUlU6tjIBG3rdDEUM1Yn+eC/ozUM5Z5DH8JkZRr/OK81ml6OL5H/iY/2y70hneJdZlm3FzQkO9sjkTH/V6GISzca1ExTawvu2m9msACpE+FvX4dwZKwDT//cgj9JoEqzxQiXm07iEle1AolfVIqL9ttJv6XJMW61kihpyZ5Ihutjz/RZUxdq2FlooCiLEETZrmqHO3/VsdNuphhkcem/6odazzt5jbjeKP+a7yD/FclxGaNHa9k+UXfAO+1baPpoj+XKgjzifNAEsMl8Fz3f+SbgXHMHi/vNEHZ5mBd0hsAnD5cCPaADVZACvkQ1usJft2UQTpc9JRZ7ufQ0s1d18kQXttcCWJd1uOdI/nZca0V/vtd7xJRpPZFcmNJCSpEUEXJqBsdD/yhzfEvBdm0HfXbHQtSHMtu1fNllayxhO9q3cYFVUd8Xfh0gAr6Cb40FWVeVfhXEfo/TS2OWGC03f1jwB8eEf9qGeangCwf2c3fEYNcWdIHAZzswGh5weimARoC2LPtVhRH4dIxmgU4UcjUyXvUEgn81O15HYwH1KRxjImQXfM4lMhCyiAyCBo44UCUTMlHABcqHFUlgcC9jAzNzBZoYfaUicTnRg8t3cdVlFn64cahohB7FREwoftMzePV2flAohegHgVO1GisFf2Q2Qml2f5UHQGIYhjfHZhb2WdGhJ3IAaPTXJxiAARvwhsvoJ3PIdFI1EBV4jY9Fb/b1F3uYSP+nmCLQJ4I5M3YDx1YyUUyZRkIAh2PZ5YgRknzPBYk3cWpYgAVXYIn3uAT3mI8hQnd7BXfIZ30kWF1F+HiUBoLvdRff53fBdku9JXumF4vkd4dW9UQHIDlOh4sZ4SVWwkUBYgemUHmWFwyaZ1T5Z2HDQEZp2Gc9YAIYUDWCBo1CsnQRmJHYmF+7lIG81Ufd2H0hCI7Qx0pmwSSoEzojUo5G+Trs+FwqYY+TWI97YGrVN5WQaHE1yI9isARZqZVZ+QZdaQY+CJZU2WM22ENJZkIFqUiYlYrwxYdJWHs0IgJWFniC55CCYWwPc1+51SOUoxpcdpGRc3pwgyWfkVBayIX/vrgLKTkMwpCY9xdaewIGUDCZzPiS6RaH55YArDdFjVOREck0O5mBGrgjHdh3R8hBoBOIM+YfLHhWwNcSsBabxqcpBKcS0xcqaiCVQpGbOxSWDwVRFmcGVyGcX1mcXdkFXikGyTmVY1l9tzlx37VKPzmdbmmELcUrfxeXpBlSwzZ+sHd+UQd17GRBX0YA5mmTV7iLTaAGnSWSXmiGiYkJatgDoyR59QloLslLm8kweqmN8ER4vbWBPvmNW9cRXsd7IqNCjKGCKvF2sikqn5ZjDVoUvOmDvtmcllhxxLmhxsmhsuahHSprajCKQjaKJGiKaUmdSMARK9oRGOWBDJmQ/7XXig0Zct7JFytFfk/YR3s5nvXxl6txnhmZnlEjeWqGDfgnNmKTDYyZkqYgCXIABvR5gDeQgFNAmXHokov3bjZZkbwVmnoBpnvYXgTKb8AniDojas3VXA2qO971oJ6mlCvqH2XXjrwJnHfKnB9KohC1oWXwpyEKosGpp8B5cQyFomUqQxXzX6fJUUS0RHAJl3rYhHa5o0/Yoz7Kl2eiGoC5bO8nQ5BSj3IQCGrGYA32CH+wkjczVz3QqvQnmfRJJRiQAbZIjVLleidHctdDZU6WqEDpMpGST2LHe5zWKjIzEkqJrDkzm+RzjkV5cO6ISheqp/7YOyAKqNjKlcwpqHoYKpDCd2vUGa5sOWXYiV7xJSMgJXJ3eaPFFp4UyTgHUD+cWgCSZUgN+JpwAAipCgh2YAdw8AVX2pKs6qpYegOz2lSbWa+MRm88OZcNWyM0CiSt6Kso0qK4dimPhJSaJHDPqlxDFoQlNHyjllylsiDROiHTmrLUKhMBAQAh+QQEBAD/ACwAAAAA4AEOAYceCwAmDQEsFgYuIg40Gws2GQg5HxA5Iww7KBU9Mhs9OCM9SC5ELyBFHQhIIw1INBtIOSNKKRRTSzNUKxVWLBZXHwVXNBlYKQtYRClZOiNaLhpbXERcMQ5cMh1eYkpjHwFlLAtlOCRlOSRnNRloMA5pVDpqQhxqRCpqSzNqW0NrOyVrUS10QyV0RCt0blN1PiR1SjJ2OAx2Ohl2SCd3W0N4RzJ4SSl4gl94j3B5Qxt5fGJ6VDl6ZEl7RSV7Rip7Six7SzJ7noF7oIN8US6CPiGCPw6CTjODPheDRSaESiaESiqEUzWEVTmFWTuFXEKGWDeHZkiISxaIbVKJRhqJVjmJck6JdliJg12Jl3iKTSuKVjWKfGKKh2iLTSWLUimLWjaLWjqQnoKQoX6RjnGSTBySTSSTX0GTYzKUXDiUfWKUqouVypyWbVKWh2eXViiXYzqXglyXlneYd1eZVRuZYh+ZaUecckydvaGdzKSiXRyiXSiiXTKibUelfWGmdEuneVanmHeoYh6ob0qpZSipaDapg1qph2aqelWqr5GrcjurkG6soXqvnoGvzaywiE+yfFWyvKOzbCqzbTS15ca2i2a4ekW4hlq5k2u5mXa6dCy6dTi6pYW7g0m7onu8gjvCeS7DezTDfULEfTrFn4LGfTbGm3bGpHrHjFbHkWnHlWjIhDvIqITKhkbKk1nKtJDLhDvMlEvNpFrPqXHPvKLPz7DRhzzSjlHTiz7TjUrUjUPUrIXVxJjWkUXWkkvWs4vW5LvW5cbXnGXXpXbXuJTX3cLYl1fZkT7ak0Xao2nclUrcoVrdmUvdmlPhl0rinmHjm03jvqLkm0vknVLlo1vl3cLmnlfmoVTmqV3mrHTnp2booU7pt4jqxZLrpFTrpVrrtXfsq2PsvIzs063tqlztsmfuqVXusF3uwX/xn1XxpVfxq1bxrnLyrVvyrWPyrWny7dD0s2P1sVz2uGv2wnj3vHT3ypT5s175tWP6yIb647f7xXv716b8wnX91Jf+0Yz+/OUI/wAJCBxA8EDBAxdMfHGjp2FDMhAjkjlCEeKRMhjLENnIsaPHjyCRUHwBcopJjRg5Zukhg4NLEBdIyDg5p4sXm11yVCQkSZAgSaFC7REqKChQn0H3KFWKUU9NhoN6emKFi9m0atK8Ye1mrZxWrl+9gk0nVpvZrsvSnhU7ju21tnDJyQUHr65cefHs3t27l57fv+0C251HmB+/vOYS4zUsj7Hhx5AN89VL+d5iwo0zR94MOLNnvJZDZ6Mb9yqzZLhg5aL6StUrXmnfSnP9zJrarVmT5bbarPZWwZbX+cWnrzjx48iTK/dXDzlz5YWT+/1GmHg44/ieM+/HvXvz7+CPX/+/jo98efPE6aXH9w2b+4PwEUaYsdChU4kZKVbErzGkf5AkiSTDgAR2dNJFKHE0AgkXNNjgCD3ghN8RMRRRxlCa/CQJUEAJFYpPQO3R01J7ZMQQHYNEpclUVV01VlgvkhXjWmelpZZbOJammF7zVDbZXX91JthchR1mzmFGHnkkZ5v96KM7UGrGZJBUdvYZXuuIZhdcpqHWS2rHqAabVW0d8xpau0mj21bF4PYbaVI+Bt2cy2mX3Z3SnZPcNsPRgx6e33knaHjiDUdnnpjJ9Y1BCDTqqHwW0FffQ/xZpN9EKQG4UYEfzbQpSQOyVGCAlx5IxEoCwuQgCJ7eJJGAFu7/gVRSQYXCoVFHSULihSY21GGLLs4oI4zComnjjVzmyM6QTjY7GJXBwbmkZEkmtuNm2BXn11zM+nhlnFNCa2WWWEJJmmymKXOsl8ieNiaaacabW1jA9XnovXbmC6i91nGznnWAaifoPoN2Z52h+NrrHnWPNvzAAyYM8cSJDk1o6X6ZdjTqxhx33LFIJp16KqpIjOCgg61KmBOFMjC04YYiShWzh0XZSuJ9c8zhayJUtdkVscMGLTRYNK6rrI7SeussZ+WSVqRki107bbbYbcut0n2Bq+3WVTr2bdPopmvbaeraqFqwt8QmtrxuvhkYuXLiq+/c5dmpD3XbQHcOderV/7lddwQXbPA3eSecZzbYEOZwAow/kMEMEqNBMc4WXXxpfxovqDkJnA/Y+ecEbu55556GXLlIqLbUwKozqZwpqxeG8siHttpa809FbfjTUk31CpQtZAI9NFtDF11jVtYenbSz3nYN9tOSST011Vy3x7yWUFNZfXrOj3vPuWSrK774abWiWs8/r7Y2277NO5ZgQVItd8B0H6ynePb7/TfggQvOnJ93+s5yyEMevyBOPYxrVAIb5ziJuUFnlIrIqSayEUxZRGMfAAHnNsjBDnrwgy7hFBIylZERIiEGDnJAg1rnKldtpEIMqYQgMOShW4UIVzDDGcU0QZXRBEt4QCTa8f/aR6NkKQtrPlKMcJw3l7dAr0dKSt4TqWe164VGa/HrU7iu5EN3gQk2YMSFa8Y4RrXl4hjsU5MaiYimq9AFXPOjX/24dz86VUeO/vMfn/pGKDtO54D4eMDiGoeBH9jkgRGckH4uAhINakCDkMxgJFVFyZNZ8iUQUgl+TFiyC6xOhTHJQQu9UJMXUkQquZuhzWplq1zpiilP0dnvitHFIBYLXtHIJRt58zMgxqVbSdwRFrHkxCkm71rY4loVkXjFrv1ri8sER9m+tBoyqmJF2NREJjyxTVGckUzHSiMv2ebGt/ErjnKkn57wpjc+6i9QeRxc4vZ3L21Zj28LzOfDItX/BfvcJyMSpGBFDHQEDWbwkghNqCU3JxNGWtChLLnkgEg5SiJU6JS5u2GHXrbRl5EoZ7KsRJuc8SZbAnGNutzlWoyINGZWxpn0aOL0tNW8ZCrTelaEW5z21C8/jStsqWHNGLOZiW7y0DVn/FL6biMv1PRGpb30hjnl9y91plNffJuTv+ZXj3iGpz3q8U7A8KctbCBDLtd5WD4HwEBRTg6grxroBPuTwbqq6pEKzasKZcKCF5Burv3BnOoqgDK3VjQGGSRCrmrHoYxqsxLYfKUOf+WMWpq0eER8qvGiytKWInGq2fNaE415zJlSMabkGtI4mofF9RTwpnNRRpeCKlRW/5QxqWJSKlPXN07N7nazoKUiOgW21fJQR51UrSMe89gc610nPOF5bXFw2re16vMESyClfSolUARl7KB3De9LxqtXCBnBrxoMEEA9YrIKfDKUXXjKdzG6Sp7ojqhEXUrOGhIUdFTDspfF7FPRuFnOqsOzy9tSTfsCtbeQY4o9gqJpTxtN1QJzp8n16XVQ20XerImaIN4tb8X3lXit68NpdGNrEWbVfLn4UH/y23L7+D9FuXOs4+HeOs563EDqcwELVIESJucUysV1rhwB7yTJy2Txnsy8500vYE/XyQa8Vwb0GeXKPhADIohIlUHREA5B8ViPFrlD6PAhgAM8rFwSmP/AbVRejI5ZmV/Wi8MP3ho5ziolf3DNWqCBcJMm49lAa2+A+hjPMsXGaDc22ocg9hn72EXplK7xh+3onv6u+uI7znFriD5PdLE6GrT2lKz/ou5xLKBWxi3g1QlgqwiUIDl//jM/lxOsJEX3yM6FsMnA/sETqIDeVk1QJQVN4YMMKyGKwG5mMKsVR8m8oVZGwj5BIWk22nZL/wrYGG+2tIF9aedgBrPU0Np2nql3tcQIGnqELvfXWNxOIZ3r3mqWJoC9iNtl8LbSACdnpg+NGU7TLV/KRTh6iosdPMW4nXs+oPbMgx48Z5UfK1gBBiTw6o7D2rxQSaQE9wNRBWnu5Lz/Tvl4TaY5IGRXCSdHslzbS9hl38QNzS5ol2kYomrbsMy6ujYZ9JBtbXN73Jhdatp8S0Q5H3EwdVltMH9mGT3DydM0lem7lWmuBEfpW1j3o/fK1bSu15LfSj2bENUUpoD/lsRRyiLCivviumtHFj1GOFXprneK/0s4+VbUEt25YTxnw507GIIJNu5xji/gBDZAZMXgajnvdoRVfh2QClgV85Sz/JEn94ERoizlClbekzXHvOtMUgQul8HnHNoomWcP9EDkIQ+RKDpJj+6+bqMJ3GiEs4g7S69lXdj4SSxn1aN5zkQhc+sNxveFMzP4hmunaoDRKeBTKy10FYMXt+WN/2sYzZUTBz+cbFytFocTDr4bvH5gdT9yz+F+vo8nxwczKzJkG3hFFb7wV0MlZ8ADQ8B4G/BqGyABEgB52iVy3PVQJgcqoTOBoeN5L7B5I6ACL3Bem6d6IjNz7nVlzIZrF/VlkOVz1HaC+eUrpBAK3rZ7QIN0MVgbqLF0a1J+7cNmyFcvx4cj4nJ11eFnxRGA0EdH0rc8g7du1sdTVUIu3Gd2pOFF13RUwJIM45cjv9d2bxdVrbVp+6NH9mQc8NRpPSZ/MPZH48N/6NY95iJbfCMP62AHVcADHHeAjYcBK+AFtbZdF/SAguUxOmECFLh5GLgghGiIF8hy6pUxJiEDhP9Vc/ClZSxDEdAGez9XZjPjgi/IezI4g2ZigyoVYBbGgy0VNsvHfE8jhHIRC0ASLkxzhEhYffpQP4kGgE/Ydao1NtVERmcjhW2BPCx1YvIiFqfYfAGzVV9YMP+Dd3WEjC/mL/fjjACDatIhF5KWLmv4Nfr2RnMBBlBQAgpYh42XhyFHeRY0chdkUXwFiJp3iKODiAwSSi3QXimDOSsxWHsFcoeFeZmIKyqIXz7XC8HDib5HLDRYC6C4dv8VGJc1isRUbjGijVASdlDEihP2bg95bwu2hLOIffY2imdHW1QBRuGjDEj1izKYWUUTF5o2Y/zzkoOzTvdjd/+zTvlif/j/VzcG9F+SNlJqGCXa1390MQQ0UAIbcJQe92qFdHNQYY7eRWVJto4dg4gViHLt5QAZOI8TEBOoQ0KbQgEhaHMtZClc5mXTFlmXmE3ow3tlUZAG+Ynnp5DDU1JS5XXEVyNS9xnMQpES5m6RoSSCBoXyRoQJs2Hbd4TT0EVfQhtg0mgnOQ7IEoxxhmnB9RcuCZP9Iyjx92JipYp6YjDUmD9e0ya0lJjrU2rxZhr5tnGs6XgdhwGC2Cs4xx9TNnKf0o4SmIGDqJu6mYhguTq6CZYygRMy54jvpXpZMJuYg1hHYF+E8I+yh02sdI3rU2BuyXYICXy5JJeksYlARIqdRWJ5/1l2X5dMSvREjYGRsEgZ20dvdtOEgllis2Vbjflo15QMy6ImRyOX73NnsniZ/UMwAipW7JSMAuNneDOTdpKTGlY31wElIxWSJelgb/NobwEBGKoACuBxGooBkSJ5IlebT2ly7JibG3ObvXkCV0kSKVFCKzEBq5N6ORAh62VKzclRZ1ltswdZoQA8bGmd19kM1aSdBqmDhcaQDtaWVEeezcRuRKIZ07JiWbKeP2KZeIIo1PGEZ0c+tKU24LBtJalN/iZEJoV05Rk/APqSmbmM5+BVzzEPu1Cg74kofvGgOxY8UdhbeAo+j9ZqGZpPIfACTeGAfviHuBkqfbUxuQkqRv/wB5RwCZB6CYYABVqZEF1ZQsSGejJ6qSvTEjLxZTjKWNIpCtlGTkWkpEFag2eynUUKDkHjJkOjkVFHPJGpl/4ZN8XhYBi5GTqGpIOZNRkmGffUhm3jYV8UobOlW0UFTr0nmWZ6JSx2oGo6oGuKD3i3P2vameyhoNyBHBTHRDDIp3rqPiPWFX6qVhGAAPskqLtijg9IooqaqCQhr6IigURQCuKQr/k6DJcgB2BQiMnpoitBWFa2bOoFKwX1AWZpidI5qj30o6fKnyelqgnJna96dMWXiwq5pBlZjEGYq35ZGG/YhdFHoXByi1mlN2DFfWCqRqSZFkPqpWjHG8sKmSj/hmndxpJweGjSOq0BqpmyYKD+g6DcWih81H5/lKXhiotYUZIDiUsTeq6OYwEZULXqxYfcZWSXF6+IWq+f4hG6sA/5QA1juw+6YAh1wAKaM2Wo8gHH2ZsnAStlqQc5ioKP5aMQG7GoOrFCipC1cIOcRZdF2olGNDbtA57AYQ/mqatQNEyndaRIyJHTgVPiina8iFu7uJa3EAiZIIyE21nAaqWcyT/UmpnngHduajfuEUA1WaBheJhNu5Dfg5IvO6Hpgn5WUbWRAnkSk3jDNnpEFlDcVZxc67WM+rUbQQW6MLZkmw/iwK91QI+AlZxK4FcFGxNQxhM4lyo74Zx2O515/7tSe1uQz0CxgPsbsOqqM9isJlsOnsuxvkqYVpcohBG6qcg9eNG+etF/F0dH0SShX2Rb1jRULGJGuOd2n0uZYLeEyaim+QA4x4WZyhiGYzWyBCSspRa7gmmsAjmunku1eAgDO1AHdlDCJCw5DHEhsGR5fgivInS8//EFvpAP75APNJwP/AoF7UUC1NvD1QsC16ubWcAHlfAIfLC96uhlGtIhPMrEVQireju+EZksB+m3NyuxSce+URVwsrWDGZuXojVVZNeSXGea5falFDpMqcnBtTXAQ1oVYToHnUuSuOuWvyq6AVMwApqZ10q62Xp9SvimhBMkSJt9ikkmcMiQsf8bPh7sRV5CtVTLu29QB2BQySiMSCtcqJU3iDD8H0eABttgwzZcw/z6BgzSADwcsCXkA45IWL0pA1qAwixDOkNhX9AZFHB8aVK8y1N8YLRrvlrsX7pcuJMZuGbTdgmss5AhxmNMsllXTssjFtkInzIlG98HYrsIJrU7Ypogx1r4vnbskBjWs4JDMH0swZ0JjdRRXIpGyAQUDtZzyKipyIuMu+anW1TrEhEjbJZMyWiwh0yBMWzLiJzcEUbgBDGMBGgwwzf8wL5ACWAQj6mMc27wz9vbtaL3OUt2o7YckKSKt1DMy3PpbXaGg5/YGt+kWQTpy21WzEAVJmnzLsmsfmH/bKv2G5jEaGHQHHfpVs3WvAywcM0wyxv59tI0mweqEGJOtdTB/MVHOM5CC7Tc4KaDI3jVUcjOY5hTum3vwrT1PNSMrNTUtHIRQ8Il7AdHfMklMgcI8pS0KSDFm9A9/AYMLcpmewnRq89ZgAZ8QAg+4RP+bAaC7c/vGEktA6ovs6Nr2XtRTDz5ydLN6qtVjNLnp9Illn7rSyNcegsxPXzrm5g2zaRniqZlXJc6bbKnSJ4+nYaUiW9X0aXTwAspAor3LG7eibOtnYSeNoaaSThdlbrGdU/+C3iTC59cnRqyu6Xho1scTGlfks8cIIhKQMJ/gNZ9DaIk1MImRCF/hdFU/8DXgmAGSgzYfCAIj3AK4fDAdv3QaZtlZm3dh0DeJ3zCl8rdrBIzzqnYIN2sjY18xByZVKyqpPC3QhqXJH3Fn01iZjHUnB0mjW2xon0940xTO82nFY6LPu3a7avhi4lUsaEKnFvb4IzFFnqyeJwdvN0e8xTVoEkYC/MXAFjcur19JEWSlXu7zc3Uzq2igtjjTzDJ8x2wmazJF+Sp3b2BZuATj4AKRiwIqDAKqBAMqCAMwpA3e0wwZxvYk5wI9mXR//zlsTxsJnTdsCIr3kuquEydlt3fXhwPlw24yTPZAx58Kd17urHmtw21ZtPgMl3MQ7Skvyqr0PqKF75mQkml2/+ImK8tCt0EuJrAuYYr4inm0pgWeP3Lust4eJi+HYFyfXxmwe25RKG+fWin3I3sdkvduzbQV0MW5hZtEyWiFKb3UJUC1xzUtWaw5LqwDduACrnO6+0H7O3XP897CX7w5f58Biis7GCuBaM3ZDjh12ltIvmd5vsNsU/HkMbnFeX7YUo61K3xCf02YMgjzLZtqrvRdsBHxxsbim0OkpG7Ytto2nmaG4EndYh+6NeAnUWVCawgW+STCUi975J+7uJU4l7BuHNXVvuXd+9ncR/JF+0ZLWWz2OVKNswt6W/A7C+XXV/w5bKZH+c4vFNQ2KEyxFMu7Ea86/UQ7MH+2+BBCcn//vEbr+wVLTlhvtcr4SrgPeSZmMtNRYPnztLv7sUoVe4nxuji3rcp/U1vDlV6jp1hxO4HPundSe9UCnXhMu+lsci4TXxoXOiLrk1FFdRrc22wQPAFP+kj7tJvZNz8J5Nhp7rbxmNVdOgYrm8hdvEum/GeyxszTzIjFMsUzTst6ta4VuSQVCB8gArCvg3CUN6+8B0vD09dtQ0y/+XMDvJM+fEdnwSwTgiGjxIY4qO2q5JsXvSiYdKVzeDXtPSUfaxfbfBBr+58fr4HP276Ls6t2CRIY+i4PZlhQ6EYH+7alNTgJJDT8ApRMaY6bs/iBP3FmtvtCaafbsF0kg0Nv7Nb/13U+r7oFj+ufe/I7mKsWQHklEy9OO/DhW96GLNe/THLf5UFjwDspbDkj4AGh1AK/A8Q2wTWC0ewXj+EBCm9cXPGoUMvbiKemRgxYpQpOaaUQbPHo0eJbghVClXMJDOU0rRZY7nSZTSVLtPNZFfTZryb7XTCy1luJS+gy4QeE6qMl6pPn3ItI5WJ1FKoyZ5Vo9psKMyXMX9eJQr01tegXdFpnYqVrDKW06xl88a27Ti44OLmJFdXnl168/Ty0+tO7l/AVamqTVs4Zkq0iRWjZaXKsSZRjmGhhIuyF+NAmgxz5azSqtSynjuHRly0MNudddlStrvu3t28+s7txZf3W/+2YnLz6nRLeFrvwG9VeuVVujThlEMvjz7s589zQXyiT6+TxXoZkXqwHzlCxvt38N+RcCdRHoSMF0T46AoXTpiZ7mioUEL1pcupgQYP7ju4zRLDh77QoiOJIIIIuy4w2sgN7bBjcA+SbDHJGcQ2k+lCdWii6zUOedpQLmmkMqarEZcp55iklGrmk0hUhGop0kTsjLHOiLPxs7PIuuo04XosZy7AgsSLr92AA9IbwSxsybTkksPlqMdYCYq1a4x6kqVMMkOOSeZkjNFLLr8k7bfATBNyHTS/UXNN1ZjJBq+/fKNQLSO3vHFL4/DsBUwwVaLkT0r6EHTQRx4RxIzrHiT/gozuGCWi0fAeJa88GWKQIQtKwoEmHFReqOC89SyR4QI+tumvPW4SIqgVAA+siI6QXk1wjgf1sHUQSUIpScI5k0TOsJY0TK3D3WDz8MhrZLRxRE0yyWSpLFuUcqlaYKyKxC45W9bGHM36Uk4fw0W2tXjkIfKu4N5aLbfNaAwTlicbi1KV4siU06QrlxkkD1a6zRZHMXcEWOAxBwtxuSPJVQ211d70K046ffU3mXinxFO0JvfUOFtUOr7kY5ADpUSQixxEkDtGw0NwuyNGiIFSS80oBdVHsgDhPPxEBUGQbwxyD5uD+mslkQBjtQjWBwlJROlcIdOVFF2l5HVCibsB/9ZqrDc0lkjZzsWpzI3B+uqVFImKZI48kgqFWrH4dPuYyZTbNqqB6yaYLCTFVfdMu+BBN90eK8x4x7jjfcwTT2AE3LIrccsjkMuuDe1tu8PStvImddz46irrBBfiqjGuUbI8wyxKWbcFIxQ6O6SrQ74kYjd5UZVZTtnRSs0jAYlQBnIvlD2I2AOZcIJhCL9TsUGmZ39WBRDpM6BnGrJTqq9eQqkrfhI0qiPmPOtuPty6a/LpeQ1srw53tsVnmTl7DrWflppxsFBfNhZ42a6fbm8DNv17AAKpbwvrHLIkNji45W9eS2GXbsCGvanpIRJuGhzm3vYKy1FOg6LzF7gk1v+bA55EdMra3wj/xzhs4UgwUHBCC5vQhCHEkAU5QM9GFiQR2omnUdzhIQ9fZp4YlAEVqGqPMID3CFNtwxnBMBU++qM8bOTFH98YmtKih6vpIY4T1xMhvuxXMe55D3xjzNqwxlc+r/3tWo+JRCAi8cYWFYMX75MW1CKjq3ztD1tzExsG9WetZ2zwhDHx4PeuYY5DAs6ABkPgHh1DOjc9LDVp0Z6UliiKtIFQkHc7BiQ3qcHNcbCLpevWKEX4RShZrIIm3GPqUNACFYRABB2wwAhsyQFKaWRRSbuVR3TonR4WQZiWCqIzBEJEQw3RieGgBzPboxdkFGN5asLNKThxTWz/ZjN7pqwb3fIYLDKGU1hm5BDXYlMs3iTrKM1yFihAIYn20dGOtbjjU/54Tz72sVrU2ucnM1ew7hVyLYj8UTp/pLeLyU1uj5QMmdzxNxANpTEaa1wb+yU5f5KQf1/M6L+MQ8owBoyPnvSotrb3NlpOIAIrdcAFXIrL3d1wJCSJGkkkQYiPaIeHChrmRpgokDSdQhLTBCoU34S/VnRxal6E4DZR6DY9nnQqCD1oGYd1VZyYiy9bM9bDqkGxfTbGKRSTZy7qydB7Vote+RzbI0eUi6i2raOmXAwhE9OjAuI1b6sMW/qkogwHGlQtXpwfvihkq1z0yoIa7GdHOepYuX5m/3Pce+pI12rSf80NTBqgAEtfClMT5ABtiXBa1CRUU9RKQqcK+s4eEpEb5TlDebZgRTCiadvbMnUZhVuOxk5CUameknL4lEpVxWnVrN6jJ0CyxxnRKRfgsuKNupLn09x5XcRNS5/b5W5jt9vKVlYwGCZJannpeleGOSOvYmRkI+90SHSKcbKMwxdiFbvYbtLzFqDEL1hT+NjoghGMwpWRLcDb1stKhbe8xayNgqvSz4a2BxPJFQSZWlim0jYUqs3iNsf74fMSuJP18y/ADrxRq0TFnnAlMU3EGZMNjdO4ySXWc6uCPdXmoY1o04P8sAuZtKI1f7dIHFrXGpbvhtd0Tf8qLxebHOKG1VWxILUfYBWmSfqaBEl4pArwJjgnyDaDyE9psFVK0k2NojmDQBlyJQUM4GUJGc5QbTN4XYaeJbzBDyRxBBeRgeW/qtdg6l0XhkN83gsqWbKL5mdkTMziINcrQy7OGlbGiVVKM5erXUUSWHf8aWnJq7TahbSRjbFWI6M1xWpl9Vul2tenSqgV1rPmrFlh61b8WS7YMOo6CG2vN413XdzkzG84HVHkeDE5kcHFJSXY3v5iC2ooLvGrrb09MvO3YmsjbrXhXGrS1Xlb3/6jVaLD5+rhVtfpLaRB00VsviY0zQvd76PrDW5jjIXRrW71cX0C40svd1zkHNb/jeHIon1VeKI25TaLUY1gehXZrXI2M7/jCusC7+nW2sxmunnNpjSF3GG+Tm9sP4qYNz13XSHKMHCZTaGzaQbMHT21Ow9s71V3+9p9fbMjdc5zv7rV25pdc6SXshphW5ndihxL0+fS9Cnz9aTy1iiMRkztTubcnqTAOb4xqJJJ502cWRW4AWcsSa9ShbZNEwWLZpo9sZq21Ns1tapJpNanvMKPP3fwnqpHU8CjOxW2/biathFykCP+4yCsq26M1d6WU9QT0qov/Fb+ya7M07/eLEnDT+r5Tq6456M3692J683TL5DNbSY10b3e2KUr0uyKjDorIT1IredC367OYMWv/751s+7+nvP8uk0onRXxlb0ynyt4RG+aWrlr+I5wb2v1J45WV0eDKHgH/u0D7GbaWrMSfpDO+A+x50JtMdeyIJ5sdQFy+Cs+TcFmmCSjDn4FZkkUv9WOKC6PeXrqPuLCoxcxutQLsrCyOL6LM7urvgVkQD/SO91TPmQ5O6eLiwuENnorvWrZK5EismMQPt5Ts+0LQKjZN4jTL2l4ukqztJ2gwEXyDQFajQ1zJ9S6QYaLvu6yPrtbqLwjvgPUroUTv/GTDvKbjvMrFEuwhPV7BNsSBsOLwmaaQimkpjfhtZGrPQjqO1XYlzMrBuCxvJnTNjMrmxI0KyHkwOGbKAFsPf+jexqL27ufY0NTe70ENMA0LL6wg0E+FDusWZKyOEMT3K9/y4rJOTVCtBrTK7pFNKtps7cfJJtPaAYkMT7OibGAY0EeMaB32j9cwEGc6iXqoT48bD0nETXiEz03Y0M0xDElZB0zQMJXfARU0IUlgkJsOLxjOqZ14EXDOzwsRBP6U7cpC79KgqPIAcP+a4cxjCz7aTsbtMM4bMU8VEOwODOtmzaHc7gAzDxBnEbuW7E6TLK4Ajd5WS576ENLzDR2BMTNk8T2yRBDPMTLUsRGlCg9AsFWkyxwa4qkyLc9/EMXxMRJWscA+gtcgKdduUEOo5UoGIQIyR78UY7I67mM+cT/SNTGBNq26DMzDSsUJAxJJUSFQnEGXXg/bGAPXdxFltxF5REGKEQGmLwt3KpIqRErL6SgT3yckviqymI0GfHHaJRG7qs7OsS3q1NDOExKIGy4NvS6ppRAoqS7p+xAsrvKdGy+PnyxQDpDoQTIQhST+vk3nyMK7esjCFybnAvHf1xBgxxIgqTATYwLQqtBw0ktnJqDjZgDPsOm7QGpLNMtA8u9adPIfZO7zjsFVAgFQ2GD6GADxxSERxCUQhmFUTBJmMxMKGxJzuRFmPSY6rEE9Qu/C9u2LKGDSJiMOQEFMsikn1Q0R7Q5pZRA2qxNvbPNcLTDpwk9RLQj3/SxVOw+/9wcyuHETePcQbX6GqzMkOV8wXacMR+hR3h8BZjACf9JSoEEr7NES1cTQMIUSkp8S7jMiazUSj+cy79Qm7v0sVC8HSvCogjBHrWrPZbDl34ZzLWcw6OUPpJ8xemgzI6xRVQYBV2gRV0oBY85yZZ8v21g0JRsUGFAUEN5A/noCPQbL+mDu9NsH0ErBklozaMjN/9iEZsjwNwszrO6TTRcUXHsx4x0SuAUxxa9PvCUFxSdSlY8yvJsTkwzSOjkSnw0w/NkCW2plv55LHJ0OFXsTRNsS2Y8vupUTvKUUrk0GHRAyKRYzzu6qfa0FBtSkKRhu478LRAbtJnbwlW8yYl6Ev8Nc4ZC6YNCgUxBgNNHsMyOQdA7pUWPiVACrcU+5VMELQXLJNBRKAQwkCEbmLAzqAMm7JimYgVO0ISEuyiDA1GM+rl3qqPYvFGG+s2ibDVtBFXf7MYX3dQYRUXahEZHQ0Ma/dSjbEo6jIzm3FFardIfzc7tbKdEVMQP3NVEEwrr472i9EpJxK4rHSeAy8RaFSyEcodqgEYtbRYs2hcy8FLwYK3W6qUOkx8LS7r7868bzFG5m8w3fQ5yHYX+LNc+sNM/uVN3fVc8DdQB7YMdOAF7tdcZyFct8ANDUMzrkb59GQRKnRNcGIQj0INmU7uq+yNkRNXbfNj4EUrsCk4TdMr/3gzOZrCutfExU9XYFL1N7FJSo7TNUS3MjtW7WcXKF0zH57xVC1k1XS2Yy0HEqXLHRhxHUjVMkU0RUDgGnSAjGOyQgoxBwMDIjaUut0u4vIyCIHIDQZBUisiInoKU2rGVj2AaUQC8T8SwYrxLr2VMxpxFOO2DeR3b1XlFQPkYeH3XAS0Fer1XuL3XJrADWgwG64HUsxFYdhkMZTzYqam2fHyFNoqEVKNYpOhUw61NVi1MT8Wjoy3Z4EzRs5rYoTRVVkvcFF3cjFxWleXc8/xc43LHQTTL63yrtQrLIjXdO0xAxs02tnSWWgg7t1S+lP3ZGKyGOGEFpTCcTAU1QsgD/6YNopFojErIsZSZWqndKaldGYf0jltpGqfBz0HLOIrhFWxo21mcTEGRzMkkSbMl10Dpg7QdX48R1LfFAPQ9AQyIWxSYWyakNUnV29+YXj042PnEF+9Ln2ghznri2cNFXAB2WCBk0dCDXAM+YN9MYIh1VcyFWMl9UVntXAnOypblStFVUWyxWeVQQXnEioVV3ev7VBex3BRxSxjrUedUx+U71nbIWG6zroDlsWZxgymwFPi5tfLS3X2RiI0IJmHyYZUpgvDIA7ThMfahF6mBul9Dh5QMBj0t1+w9hLHVXimGYvE1BCx+hPEVVHSFgiEILQyoJfQd4xJ4JSawA/qYtf+/O4XlMFNWAF5JwN3fOr31KVFVBWCnONxRe2AbhWAEfuA/VlWnodwBXuAGBuRTfYXa9VwfteALlsMWO0QQNuFA5McjY1LFhbi2fJIELhtkswmhVb4OYce/yMBkWFVo3DEjbju91AiIzGGNs6lEIGIGwY7mxYgf/lJGEWJsLWJfHq0j1jBKZOI0UaI+VVdyJZTV2V7neI7V+ZNA5WJDqNcwriULQN8MSF8zZoNGpTUcphoapOFM6FD60ac6duAAfiR2Uh9EBtkYHbNAjueJPWc7RtE7alJ8nlx9xq5QptV+bmRH1mBhrbde1UOBBkecva541FwSncALJBbliktbFQ7/amw74x2tp9HL1tSEpVIG+4zNZgnpwVXaXtJoXgZTX6blX34ceKoj0xKIjllm6JjiZXbMmb7pPwCUQJ1mGLjXB/hpoIYAoc4Ae4WCnF5C0RQ8YQvnI4hjknOSPjrnWE1n9WknPk7kds7qTp5nq15nBdZkrd5nQp7Yf85Ks0bhCp4YERloVark6qNkt04lEE7o6fQM6yLROIqo8OwqtDZPhNKv2IxhCYqQs4mCGxahl1i9imbRhWNDVablxylplfZlntrowdaVJ0ZmZ5bpI3wOOfBsOa0DFnLMQYGCWBqBbK4loE6Alfppot4Boy4EpHaEvrQF+ssGTWAUQggG81kX/0Hk2a91qz6Wl1LjlaWqXuwZboYO61Mda0GmauZ+buceZHfyEOv2m7JeTtCF0nk8sSUrQYM+nQ2+ZLA2TrWZKqNFuDeK3coork3Tyn+evRaevlSO7E944QbJDIRJDNHwbsqRo+FGVZGGo1sh4l9yLVqkU2fW7JkO7dYJbRZ6ghia8BaqgQ5Y33zNZgb4aQRAAALo8AgQ6hMYgtheQj9whKVRvz9TntzeCFiAJt/WuMn7OnlDDLoqOXYj5/sVrq01nEpCzHBtO42lqf+Fbj4GWf9V6EHu6kwQWifPboAO3e7WPlQi6MR+R1+VZAxOwYcV1SylCnSIu/XpsRVcuZ3QKv9zefL41htwmM3TvOy1c14VASeBvhuVcJdSOjkFA/AmJXCOQHDK5GwF/2zyqwMHN/QI3wFFh9sMUKkLP4EyzoAN5/ADIABLf4BsRoESL4QTp20+q8kzCCIyOIXaqAuFzZ9rmgxwUBM1wnFXHzn5m79gjHWRexhh9Itb/zWCNUZbuFsF6mOJa2x0lm6nqWMmt2o1T3btDshwsj0qNz1v0SgJVOstH/ZMHkQwv+s3Sptk8MDZPSd0guhQ1qu3kFFRyLEe67wPRZs5p/OXNcR22xuqIvc1Qq1X7IM5venv/YNDf/DRlnBFR9RZ8qwIwIBIX+0BsPRLx3RNj23ZdgQUT/H/9eOELtClRJCF2pgt8iocK6OHXDdTENv4J6tJcHaLYFzJZiIilV95Ikr5Zyoqd5h1o5KLaBKKpDKl4BbkJQ/pAT9n7L4LZV/ztG5BDwbK3jP6thrmK9+t4zTk4tS9LkvlbSfz9h5mvzGnYsn6Y5N3EEHl3h3sZgvDQSAzAJpH5LNAiR64nlDiJaJFBt93Oeh3yESUFwr4gH8lFKjmlgpxEcj7Dk+AhE94ARgAvocBRTf0zi7CPbPbN6AhS/ECR+iZYEwMNDXalr58Ls3LQQgJWpEgplGaHLQeVFjqK1zJgnh5fHgm/fAZ/Tj9gggaVWme5uma+EuvOQYrYWdnkZ68/zwGet//feD366FnJaNPNCb1F2tk4Mt11WwXyk8zYcboeKzv7fe2P2H5KtuEJ548s0xgdwqi80L0t0pEpEUmf/O/buY8/7z6MFSgBM0m9AWfe8hkAzOgfxeqAfxfdEWnAf4HCBQdIhCEgCFFBgYJEAxoKOAhggcYTqBAsaOOnYx+Nibq2IqTlxwxQJCIccbSN2wqsSkr1krTIDp63JCpGaUITpw3b+KUEeMn0JEkSAb1OcUmTTR8+FRqaukUVFSoggVLNbUYsqzCtm5d2TWl121ix44FC5aeWbTfxK5Lm+3tOnfO5rq0ZfcUq7yimjbV5PeevMDwAAsuTNgd4HbxFv8zZuc4HeRukidrqxztcrLMmo9xxrzsc+fQxkbXKl2rmbTUz1Y3y3XrFexbpGO/+kTKNO7bpXWjQ2crlChQtiMFmhNpmeJp00Bbu0aOn77o0AU/R2udurdxjhW3q+b6NynhmWZGClUMV6hBZI4r167ufTn48efLpw+/Mf77+bfvN+ffOTgBwiVMKVL1cSCCf8jBhoINslGHGQ9K6ASFNNAAxA47ULRhCjSUIIIFEBRUggQiOvQQAAJEZFBFS7yBEUcddeRIIlEMBcIFIORwUlbBnFJJIurdVFQMR+10JFJH5iQDSR84+WSTP/mkRBdZWKmFF1m6oQUaWyq1xxuEhEn/CCGCmHnmRoeo6QiQfjzy5lOcxCmnnE9FlQpVVK2UFp8rDdgjVnVBdcphhhlKXWLcPZZdfZSpxhqkm3nGnGii4RZpa67pltumue0WXqfZSQOceJ8QF0gtoirHnHPzQCcdOW8Vih2jij6TF3qgnioJrpGQoQcp1bSnqn3FNtpof8n+p6yAf1ZFSYKGGOLgghJaC0WFFV7ooQohZJBBRSWIK4JAEECAQokKQfQQAQdINNEKQzRRhUYxdvTiEBdUsG+O6+1B000l/RRFTXkMQqZfpIqCK67A9SUJxDN1MUVPRAlckgxEILFxDyIVicSUL4icQ8ckb3yUySlXuXISLbNs/9NRVSaFBs1okEkIX3IOGmie2XQFV59gDTZ0YfwcmqitixLrKKaTZlop1J29FpukmdZmG22xgbo1p6zwBg46zQRXaiCoptbeo8oESI909CAGIDmJJlbr25vtZqrBvP5WdibJCLu0scfqhyyzhS/b7FtclQJtH5QwXi3k1j5I4QvabluRt99OhIEE4aogAQYJmbjuASuCu0IJQ7xoB40yhrmUFyNd4IC+HNxIVA5eyDSIXwwzU0w1PLfkUp6C5uoXITMBjLKUTI7QPFDP+1SU9D5VP73HIUOPvQndk0yykijH7EWXW968VM6ohAJVnl7taajRgsVvj9yKKn3/fGk3Hf911bzIJjXVqnY34Qwwa1wDjtZu8zexjQ1vgehbNv5WjpYcIxZqC0zbBuMeuiXHPdz5Di52c6oHnkcSBstFb9AWOMGxcHAufI/hDvcnAi2ucZiA1rQiJzk2VMgIRqAQhrbVIYqAS3Oaq0iJ0nWihpgOXhmCkR0SAaEx8eENWbJek4hCsIPhyiW/+6LaIoi2MYIxhL/Ri8OQF5OJTe92F3MjkeIoxzk2Lwfe49gUTkaxI4ivj3ksAyC9tAcyCQJIh3CKnIqGwUUysn72YyHT9tcaSqHmaaTxH2em9h1IaYqABkygbrgGit3kAmzVUJh4+FZKMTZneC0BB9syeI1hebD/WYKRRi40o5fxnHBUMQnW2WrVwhfC0HDFJOayGhOrAHmlQNLCxA2lpUM2SIGa1bSchX5ooWxuKHQGMeK3zMWAJTLkARIB14Z2AIV6veheq7OiDUgmJYLRQW+wAKP+8qnPL27GjGbUiyDEtDzwyfGNF4seHW8UvYMWSZ7Wyxj2IMpHeaJMon18GU3KwMhXvepojsQf4PTXP0paMpP/M+kmK9lJTxbwFcYQJda4JqrjmWqEwFxgK78IS1kCiG4cBIdmzqMrVSbDVOaR4DCRacxjKtWFAopVM2t4iWgWgpqQc0I1rdlDy9Vgm9yqiDg1F1aFlJOJBfnWhuLVBCi+qK2r//PDG86gJZt1hBOwuCs+m2MZSu5Vn5TCpD/vwoqHqXEmc4AZkm7iUIdub6EGpWMbI/rQjP1xohrLQR4xu0fw5XGjHJ1OR9320Uc2SqQq5Z/dRlMp05hRpVfDWteuBtMDoiOCqITYrqRhSjIyoznwCK0GaVnLwHgHF1YLT0yA1ZpMLAyp/FEW/ZoKXaYms7rK3BMNL/FMaeWwClaoFoW0is3xeigF4xIrAyagELKWrr1n7UAH4KVWtrr1rXE9A5kqgSsLtsQyeu0rgAPstNSCMJe4OCPDVMGJBXsCt5HoyMEiXLbk7m53GT0shhO7xyEtybKQtegRXuDhxcpAsZ9tG/+KQXuY6D43acSS5IBRC1jO8Ma1DYwtbMam4x2DyhbuyIzCcEuem/43p7/zj6toBbi6sUKXXnMgKYBs3BTiT7pWvrJ1q+sObGxDJdnlriIM0YbIWcG7Wa0CtrZJ3myKCwXmzZw4zUkQ9xbEAnYuYvfitU6MuBUM9U1EJU7hReC5ssj+FTCiJTnjAjM6wWh09I4hLWkdqzF5ErswzDo8sCNsuickrmORYpDiUat4tC3eYCRjPNKSLlpTBj5uTDsVSlR6ksfMiCADxxaJXX3Cb4Y2sjJ8K1oXczCEvwshqWJyHLtM2adOjcypo41lLG+Zy12WiuO224YxQ25BZpZCmtX/aaE1X+7N6F1vBEo35/dOxAROfAO9MjLFM9w3ro5gRSsiCLzP6DPR/n7Uqvl30oE3OoSs9R2z+xnYwDosjcKptMEMi2FAelix3zNBY0mAj41z3B/68PioDVO4Fwv4tAL/jmpRmtJjFHBsLQcFrUulY2ek8LbEuXkurdFb+xg5PvProHAVs0m7kMpgoEj4ZK7MYmkzfdpOrTaXC4QKBGm725BDMw8yNG5shdurbOYWOEXkgHLKuSBpXUGeXcRnePv5C/S+ryOwErxC9/ffkfq1aWHM6pSjNOB+V3gmD9yLf+qlFsBBI6X9AnNROFji9JyYxS/ucX9QPjqT53iKh730/2inmqR773urXZ3zlT48OC+vdelLj4va9sbmengge8g4ywnq/DPmuA6xBVTc4uai6LzbpLOX2nSnX7naYnFmg9rAXW7LAQ7O/3bXaQAFcEff61oPF+jCSZD33vnsaffz2uPKA/DT267I2Hfd+W33u0PKr+7fX8pV6plg9vXvCj+2yQPvz4Kf8bYJa7AJ7U5yUR4BXh7IhZypEVvt6Z2MMZqlFNhsLUzvRWDq7VgKgcfD7Zqy9Rpm6NXsvVg2FIru/Y2A9IIqqMZKPVBs7JyVCR/xUdfTGZ8uoILjQI7yiZnzLUgOmlnWaR3XVZ/1WYgKmBfmYA5aoUtaZQgMLGG8nP+AvIABtszb271dIjQZoRXa+kFK2LTfo6QQ3n0h+6WNF9IfwMmfGZ5hJfET4AVWGtIccCCYPyGeKsyhJ6hCAd5h5SGgyDGdodnfya2cA1Jgj20Nj1VgKKRQMgSZBr6ebbRh/vDWTonWki1HzhEdcBCHJuCKczGdPbxgC24eMhkfNjxCtlnVH4AZDu4g1vkgD1Bf9GWL1w0hEZbA1/Wg1jUBEA2BLjrhE95X251BE0xhJcidGqofom1hgI2ho/BcSNHeoS0jtJFcGTIgGvphJYUN8NQWXRQjL4DGXd3CXeFhHmJe5iWgi01jA4KeAzaaIBaiIfKYLbAeTTXeromCpAj/k6poxiLl41Mloq8N3gTuGnM1G6p1IigeZJW9oLLox2F0WbYZglU5DjSFGQ562yryAEaCmytmZCtiU1fNYob8oEiuk0ju4gzYQC++3fhN4RvY1b4Z4zPGpEySITRG4yQGzk12HjpWIzWioRjSHE6Vof4tgzjiYTnuIWlJYzX+IcGtYzu6Y+pJAihIJWzJoyIuYnmEAiYFnTNmRnbExaroVgfBxkt2kkC6VDAp5PCpJQwuRlyIBYFI5B9gVRoogiusAiYAQpg9H9ZhpF9u3UiKpNdhTgpMnyue2Q5hi0k+4RPQwBT+In5Z4ReWVk1Whk1WJk5epmY2IzJOo97FGGia/2EKjaYyGhlJ9UNRdhw5lpqSFWQfpqM6Rs2sPSVUVqDqpYM7hM3W0GNW4hULdpApAR8/cgczzCHAPdlZ/ibx9YdNsmUMtsU2zKBU3NBcQoFd3qUp5CUc8OD0/SUrGibWlaRXqUBXgSdiQgh6YkQuniRKNuYSvCdk0tvvhSVmWuYjMqN9QlJSbSZ+RoZnvt+A8eT8lWZqkGZQ/pcxoqaCLugdWl6KKVNSPqKiwaaM5VqOxdo7ZmjqrV7rXaVARgJscQaV2Q8lSiYY9WNzBQ+QIReIrlJBumBzDt90SRdgrMXxlcIo5OjU9cEoDIOP4iUmbOe3ldmHTESbqZNFBiZXSf+feIlkeqLneioBfL7nY+LXweTbgSZd/pDmluYnf36plvZnmOokgHah+3XmgHKpmqaafxEgg9YDnMLpOKIYrSigowQc361j382mwsiWhiZeVMKc3+Sm/2FliwKf/YylJp5ogJySPaqowdUUiA5qLdnHjELGQjondQ2GjerCDOIojt7lMECDqOKlIjzfFXjbCpiTm+3ARDDpYeIihIRXuFHfuEGhe1JIhDwpGLynlO6A233BE8TnG2SiCtXnmiZrsu7nmCIrmZYpF3YgmpqpsjqrZBTlm86pq8zDN7Tm4XRljOlpU5pUa4CKhRLinwYqVZYeItKag33oHBKkorxNiVb/orDISnGeIP4lmwre64tqqoxearJAJ1zqQo6Ogi6MajiQqi/cJVVJSxtUwao6gAWUgHeVQMUqKXgySJNuFRBViBnsano+wRNmCbC+HRTKZyL0wrECjpi+LMyCqcyGVBhO62oU6GUQKE3mbBdW62RWHjdsXD/sA9ESrZyqJj6sRbcuk+711AcGmzeGnrjuaXjEHLqma6BOJdaghm946IdSpYlqx9sgxj2AjehdY2+81C3sq9ecyqMmZFvG7XPhJifih0G25eYZX3QeLMLqAjT87Y9mp3aBGRzQQAaoWwk4Hw9QhGIOK7ZAoZkxSBqAV0lmS8juEJT6kMk6bsjWjBsE/9r5RaOXdmnMbubolq61Piu08qzO5pPP1mfQ+gM3cIMsyAI3DG3RKmjsbhw3CA3TPu1/zB4nSe3UvlqUnSvW2ibEGNW6Lt7OOSopUOW7nqUVUuqsdEekTlkw6QbbMp7RoUaE3i1zOh1CCuzmBcZaeGrfjgXgNqzgTkshiBkUYEBEjN0DGOb4iWR4Ru7kUm6t6urj7qrkmAHJ6iJj1gwCgy5nki7qMisDO+Pppm4EV2aW9ttMvu4y8m7SpoIj4MlW1EPuymnvKu05kIMs/C7wzhIKLgMsXNL/aFLxbgptKl7zKp7MYeghCkuumYqkRsIgZWX1iuWheAMusZaK6iZarv9obSgbCoWv3D7x+S6dFJcv3pJwdHrqNvzt34ZD4N5QDi6IqxZRuq0ArMrB9PnvGSdmrFpuyKaxhNCMrxrwsHIJFdSxUgjaAjewHkswH/cxBbfuTKblzHbD7ArtKD6F46SCMIQDnO5DPhhtWZQwCqfwXwFW1hxcIPYey9EmD2et9L7jMWwhTWXCIv4wiGbiSwox2UqiCQZQapgr7z2ZKgXftFFxi7EYLtvypr7lWPjCNozqFrevwWJC/Opg1q1AFWzb4oakd8lBVXmb/iLmGhtmAGPurMaxHNOxHSvwIHezfr7sBDerN/sxBdcsH3dcPXxDKzyFVNzJIjdy7nKr0Jz/sNiqcPoR2Cdh8gvj2NVizXDUcOmta/MelQ430IdG2PKismToI9nGRWLcSo2thqCmBrNdTb82Ktx+4qJEcS53NBRDqLVl8d+KgxZDw8L+aJg9MzS3wSbcZUV+lzNDMy7+oEbW9EYqKeZG6Q9kszb7QSsEQ8tm5jjDh0yK6TMO9WQ2azQ8MDTybJoa2gJvK8fJwjq/ySlkWyLXri/jroKWcO3+jHPcs90U3iXD8MHxqdVm4FQCtG1GWvCgg9d+7fJyaFBxB6J4hysX1aPGMi9BkBNr9C3brUfr8sASrFiQ9D5AgziQdPuawuM0H2QrAiDc5SLcIPPZQXjONK1qbGAK/7CCrF2vZjNPc4kgTEVQC7UD6+fohvMek3NnJquZPrU4h6lZbMPGCQOcILIlOM5uT5UHz24Ij7CX6dugHZvB5bOnyNqfJjRzd7LW0jAoc+0E8rBcn6WxUmI3ToNdz02uVO/YEBjOSUaAZDSNDrZ5n/dS6e3CJnbfNqwvZGcxL0j8PlNeTqSYvfT+cjaF/KD0AWaEuPHkhPZoT6nbWQIyfCBqeyJlFnVr4yM5H7UEy/bM1nY6B4NT6DZvc/Bu97YsbLUjE204dBlV81dxH7esYTIoYa1U4tY/L94nP/eGpmGyVXfEzDXaZLfYOrRcMFDORcN3S9kchnelDrkLoreRF//5lpGFOOSDL/xBHZBitn2xMxvCVEHTDWkXt112X3KkeG7d1mn2ZrdxGxfwTou2D81xIRx4gjunfbY5azf4bLt2nGNwZkJVYIT4KBrSmmx4/GI4lFuF34ZwSgCKYCGeJucFitcmIbI4o2ftn3Jo1/awoX6tvhKxpGx3cXEvLhhVZhw3TJgNkQP2kUdX/aA33pL6nR+2OKxCmnEdZse0M0/VKsA3d1ldkgomEFoff7e6mFMImS+hAf8qY6Z5BK05W745nCe7nKcumC5TW6BFiKeCnu+5I/S5tWebJRTCbi+ybX94hQsKXjwawslhW9ewg9UUukPMJbI1IapUKtE4pSP/x0wZm7DQ6+8AR/BE76HuEs5hNHlv6qh3dKkTdmGz76rXgRKeAHkOQRVUO5XP+qzvZXdZXWb/Za7ruuVmfB0rYbD70GgT+78C7Dcru4MvO7IjdZyvTbdCOzacQpq8/B+sicyjIm+ToiKLhdEm7Tf4SLiHexdZotUiD0DDe3OveFtrpVaihu/BO9/4BcuWoHAmB2poCnAw4qELR9nYI72G/KkHvMDLjdejOi+rui7wkIZsnwk0wTOtgiu8dzTBOsVvucVffNZdPBNwPMejZMfzNMjPdqaOLySdfGrPOeELPuEPsrOvPAmnAsw3/pvEPOTH/ENm+FZ0+z7UQ4j7CBrt/8wZSUIlwDh0r/j0jr5AH33V4rvS440G0jjsqcLTQz2itisDGV3DYH3fsB7Xd715J+rXIyXBu+XYK7Y4DIMhQAHGjh0yw8FUubfBpvTVWVNNzz2XB6FX8Tc3BRGGZL/eb3/2u2cdGEIpjMMEi/zglz9TmzzKHz4MJb483y43WAKauInjR37kH8gjoML943/+4zzuAkQ4bMJaoTp1ymCoSpIWMpT0EGJEiYMGSZQESlNGjRg5dlSYK5k0XJ8ilTR58mSgSBhxoQPnDhy6ZCBZgZTmDabMlqEk6dHD8CMoiqRujjPKTh1Sb0mVNkUaDx7Ue1KnVqXazmrWqfy4asV6Ff+sParftm3ztQ1aWmiM2KgIscNKH0aMRrlyNUpRn7xp2PSV8tdJYCiAeeyAwgMxYsI0GMNg/Phx4MY7KNcAUvkyjBmbbWjWTPkJGDaGSmUrd5ppatXmULOWulpsbNirade2rS0pbnW6eaPu7Rt48N20uxX/LTw3cnLL5X2b57xev33CDvHxcx179j/buXd/xP07JVTfv6NKhY1b9H37uGELlvBhJUEQG863+JAiykz7N/bvLyqUmpoRiST9TFKpJAQ/SgemmHDJ5ZUIQ3rJmWpssZAQn4BSKJM8BnmFmaWOYjAd5Z56KqoUv1qRRRWraq4rr1wLC6x1yvIFx2HUciX/jRqkUGSVUegaZZQ+5JDCCb8GEwwyyBJ78rAnm2xSsskcwyyzFjY7YYjPQFsiSUtKE9G2Gct8rTaxzlzztuF6Oy44a+CcUzXjgKPTROacKys66ZCpTrtABRXEO/IeocTQQ1uRRZj0+qnHLFR4ko8QQgThkNJK78vvvo4u+iQjjwScqcBIEDTQVJUADMWlnJ6BUMJeXELHQlx40jCo/Foi06k1Xfy1RRRjqypGGc1xccSrygrHLLXUUgQKIIcRchO8pDjyL2wnm1JKxXhA8i8kuZ0SSyw9OwFdzjrDLEnSkLkGXjahMhPNYe2VTV5628QTOV6Fw43fEu3sNzU4maPH/zl6HF2vHlQG9aMONrLrSxCKvTNyO0MStcSSQw4tRZfoINWFIIXmI7SShurLkFOLMIrIU1A5oglCU1MyMJCcNamJVQZdvSXCW3Z1R6eefKpIIw9BmTBZf2cTNqtgpfbKWGCBJevGYXScRWtGDNnELmqF7MNIvcpuK4QUxn0sSm+7peFKbksw99x01fXysjoEES8W0/T19cx78x28zuQCHpFg4gZOnHF4D0ZY5PXYs8S6ROyo3DqK+dC8Yswv91hQ8hwx1LxgdAkHUoGCOYVQQi21L5FKW+50I5ltB7CWAEkpFdWUVOJ5QKyWEgnWoaup5taj98BP6aLacbrX6K2mcf/qqqmf2kazSA6bSEAMAaRaIeNIg3xw5eBLLyRRsNJJt92HbP3H4rYSb83sZqF+wyImrRVl4v27Xk8T3LxSQ8AAGvCAhDPYvgp3OIIt8FjPkWDkpDMd7MTOc5nToOY497mIZRA732ndd05hOmZtYyCSStnK9rA8TblMIra7Hc9IkareGShANTHe8WxFipY443nOCAVFlMe8SFwIegIL3AClNzVhPfF6LcpeOLTWNfEZIi7fo0sfwlUlxowmL/BzjNrY5j5xrQ1+9MPMCUbQRrvhjQn7K91LAMhEO14vgXXMlwOdxkclNs5wpzEYjOaBOgqypxSOeEMiFplBzn3wchv/1KDeOgdCzGVIEAgJBnqWVYqDPOIMoXwh7TTyKVOKShM2u6GBbGGrmlSDQsQb1fGEeDQ3/CRVczji8YaXRAE2EZhQdOIwXaSwcECDG9DYxbQ24TUrPPNaiqDLXMrGly9GMw1NKkEKSvC2b72Nm2RUIwrqR042iuCNcDTDHyiBKEv4T494RKA87yhPBd5TkIfzY5wiiDDoUPBR32jFBSVpyUkaFJKbM6jrUGaeZW0DGat7RMpOJgnYrTCG/mEJRjS0SpSIohk93OFMHvRK5BlNeYOYAxn0sLQK8bKXAJNpcZoWTGKySJg2VRFZ6iGOfIiDFstcxVyg9S0pbIF8YzAS//mYWj4aLCYx3EKMC1zQNjFeyTLjrAy63JjOzHwxY6PrXzypV0+znhWfaQ1kA/8IyN/Ewn/rQBg98FHXR90Vhd+gHAYtl1BI+pWSlOwrYEG4B4M+AiGleGgKTbZC+VQ0dqQEkNE8+tFWropp4Agp8IrBjFS6YQ4+uaUeyHAEhtwEpnKa6WohmFOf6ZSeUmyOc8Sxj3xQo7a0GGozpVDVLyLVqdiUS1+s2T4eqM233XIBZMTJPhjMzUtcRadXv5okMIq1b1lhylm52915qhW8bhVvPuM6V7pS0B8COYcsHIHBSCrUDAcl7OYGO18+vM5zhr1vhlrIh0egQhinEwezCP9iC4VUig8aiSwpKVvZ/HzosqQIkPN4yLNiwKJDK03pEeaws852NrWsFXFwnic9Ja7otTet3nIK6dN3vPgd4oDEXLwW3KM6lTFbkIJcltoGqHrTm2qrgXO7SRnomjMDGRgBdSnDmMCcz52caEU25GE9714ZreGFIgMByWU3lWMZ5ZXref1xV32UxTkDbSQf4mvfOrzhr5CE85zp3ObKmaGFc7bOHszQ5z33V5MCRiZBTqEJ1y04EaWMyOxQNZFBfKKHM0vtZVlRjCFqeLSRmAOHPfxhXj4DN8swxqiNEY2QmJq1JE5xiaTG6lV/tyoNivU8zlxbGL8jqIjYhK4B4VT/qt5Yx4BR21KxaFUgRzWN2yqykZmNTmczGTRPNkSUWXGN6Q2QaljWdh5h7Vovd1leggyznsiMV3/igxzthbN84RvnD+rZ3XGOLxqsM297s5ndDRUwpFIoKb6+UGWbErgNTxuKjiCxQpS2NGgZPtrSBgJAnhYJqk09am1Q/OLRoFOJS9xWjr+a2whc0TlozY3a/gLlwCBGrhExC972Vlx/AW5xu2jsY0+puUKmwZG3mi63PFtL9XvydUfHibhuG+nbLmDIbfptLaPGf/BksT7s6o8zJ0yCloB3m7mO766/O95hZ7Of0dBnsvPZsG221CLfcIjEbiNyEE0F5eD871He/x2GNmQVK3Z3kQmbRoisOAUrMuQFw5fhlqUlA6QrLQ2KH4PUkS91qUfs8ej58igq5jhM1oGPXYgj5aH/BS2IsfJZzHh8wg7XzIN9RpyTUedry7n8eu7sJLvFnLmf21OrMBiMFX2s5JhHWbGd9Nh2m+nH/xu4CScPZcD1JYQsMz7mWleSzwMZnHBvxL7ebnp3X+zff7PZyV/28vt5/O7eG8hQxzC5U+5yeM+7oyFs8IdwpLPrCHwrKkGHw3cB8crgCI6gpXJIh4AGASXP4ihvGVBtcSwPAiPwiehIamzk80RvEhqBFiYBGF6MGCCB1/jiL6pK5ljP9dIIurZpm9CI9v/iZ8jgRgW4KQSeTQXOhZyGYPeSxPfCanSya0ay7V6A0Ph+KfmUjnCI8DbKi66s79wk6PqyT7/Azuu67+u+r87Sz/zOLwv7jM+00PywkJJS4XTSg2EGomNeSP4GDuIsDT9WwqX0L2UI7/8UbwoGcA82alUkLGiEJvI0bsRaSwJrCuScQtZsBB+4IR9+gRpUDuUysBE48B0+EAQZYXyYSsdMEKqYSwU3cfbW5kpy7+fQSQZ17wZzUA4Cg9hGxxEuwQd/pfjugR+G0AiJbxaRsAhXYzmKAkaYEOvOjAkdxs74bOzuDQq8MP3AcAvxLBmNcQuXUQoLQTwEjGHaY+4yJQ3/F80nQkGIeqIkWCLhOEEO6cD/ADAHBrC0XOg/PkEV+JDU/PAPHxDzECcQKRApClGuDhH0Qk/lJsERH7ERIAEgeY0Sm8oSj6q3GGO5HmMFjawE4ocF4QZudK4GQzEGa5AUoeuahg4OCoEjR8dxhk8IY1EIZfEWSzLLbLEkmQKeoG+urM4JrY8Jn2OvwM7ezs8m3wwMbpIZdzIntxAZj5E7UgEV0CIfforA3mOiDm1TspENdUUbkUch+m8OoyAGYqAOAfAnbkcPF9Ad3xEev1LV4jFZmGM5HAUD+REt+REP1uAO2hL15iIOlIogkaq3qEpuzKkTX2/nhGwURUDJKjIG/y9y9xDjFHngSDayIy1BFsjyWOxBJEUyHiATMkmSMkdS+VDSrArGcZSwrnrx+qiuM7Nv+7hvGHnyGMevJ5fR/KgADbQgNVfzNZuRJt8rhIYyHNbjpwYMGxICshbMJ5bmVvxuwnJIKg2vHHOgKmXgKt1AOHEHJBjQK2mlraYTLOcRevQkPRIR5RoBD9IyLddSDcIgDO4AEcQzLiuRfHRAPbfALvNSEx9SIVMgMGdwBmWQBixS95rsmwrzMBNTMZ0jKk5DLCTTXoplQB2TFmctCDPz+BYUy7arFmGhb+CFynZx6mCSF3fTDwjhCr0wNYuR/JAxNpuRNcHANXsSRVP0zf9A9Cct6b/GsLbcjzoSraJU6icMjD6CgkNI6yplwEdJoCqToA4LsKRObUCONDqrU0lpKomcJhfL8hz6QTsbMQO9My25MwwQgRZoARLCYAy+9EuRaj11oD3h00zDSQZFsSLvcxTxUj997zAOUw4SMxa+gTEb8zUekyseExahYjId1DIDVV8AlVArs1A9gReOJeqEb/iQIWEwlOr8SUPXbd2m0DR7EkQ/NDC08ERLNEVHFDad4A1yshj9qnL+QGJe9DaLMh/qQTQ5lGWYE0d3xv46gkePsypJAARGAAmw8rSMFEm7MjpRa0mL1V9EhCwXUz2K0gN/wUqttBHUABEaofT/ZmEM1jNMx5RMyxRN9/JMvRUF1HR95HMvx5Uh3/RbfIz32uB8CmEj63Q5zAEkY5FeHXNP7xVf+VRQH/T4qmxfuetPCzUr1nEz4wobKhQ0rc8l/YlRToFDf1InLxVUO/VTPbViL7ZET9ORMob98uEd8iEcUoFDRxUNZLUSlgdAjmY/eDQK6jBXd1U5EY8QJgzUatZmhTWfqNNYjzWmdPYozoFRyZBVPRAtu/NZiWES7kANIIEDieEOcEBbwVQ9qWq53PNM21QCyGn21hQj3aYK1LUK2hUxHQFe49U18hVt0zZgjWVeqSYW5dXK/jVB5zZQtQIWVAGeQsRxHDVhYfLM/5YjopBBzdaszkhUNXFSRD/V7DCWcUN1RE2VoSrmEBrlxabjZPmLZ5aHR0MrEFaqZYvgZXc1SN3gDCThACHvOUOKKy1uWOFREF+3Z5E1G9aL5EyuKDGQLdfAO+/gSssTEmaBGGYBEbZgTHHAPMnUA9zTat9Ta930LptrqpDkfIxKbFWxbKcObv1UbSOV1gz0B68iRtY2bvtUbhG0QCdTfAU2JIEmzJSBGaDvQu2Ke+00cAWX7uqAvxI3YhXXQ8uucf+XVHcysNjNEnTBY0FW625JyjTBJxQvZ0qrCKgyBnZ1Vz8ABEaXOfNQDwFkg/ewD4NVWIm1SWvq42KXQmTBFf92oRF2gfS2s2iFAAeEQHefNQOVVlrv4B8RIQig1gV0AAeudWp9i2rBqVu9tYgRMiGtioxiEHqh6ZngYPXiAg7mlGwXU/gG9UC3N1+HJX0X1F/NdyvwtMq+d0XKF1AJFIwDVSRVAVHh6n0XtW9jkhzqNxYKQvvqTTUPF1NRk4/7F4D/+HHB793iq1GKUhfegDlTRqVWinPz4HNBN3QveApYClc62JJrIQE/GISDFfKAFVhVK8SkMxsAb5Qp9CVkYRfOYZkagTvXMndzVwhkmB/fgR+58x8hQWnFk2kBUg10IHl1IAh0wDyvtYeJd1uHOJyqNgWUGXpJ0KgScueYuH3/npiaXYCap9hdq9hsh+9euViLuzdfs5duIygyxZic07dF9rWLs6JeFZR8tcIT1hEW3thglzAmGxVe6hgWYAEcGSmP/XiPAdpiB5piCRpj9ZgKwW4ofyoYZpYVQKtlG5mRJ5pzOaUmBu9BekGjj9STOVqTH4+jMXl3CoQ/QMGDaQYXjrSz3Lh+RxkbfGGZIKGVXfmVc7ct0bL0kjYMhGCneVo82xJLofYGcMB4h5kLwPRLt5VM13OIy7SYb4wEV69qF1IxwvaJfWx6r/kKzuAKyLZsATR7v5iQ7hVSubcrsNic4badiaWfyLkxxfra0vdPA1Zf35mt63oq2PgVeMHT/94FG5bQrKss6vSZZ7RvZPtYRQFaoAE5NBrbRB2boAU4RLmPEm6TGwpNKkNLU/5Dnvd5o+lZ4jY5hGVqtB8PVkjCQ1LbQxpNOMGxGPqmfgMshTcBl2vatnn3DgCyltuyp2PZt8cTPGGYqIMgCIYZC7wUTIlaW5d7qcUUuGBu9Y6Lqqn3qg9TBKsbDq7gXct2Xru5ysAZnO85sLlZX94aJM27ew+0re0VrlUEjSPTu6OiXr03jPU0i2ExfMOXVvc56vzaM8/bfQkbHMFxQ0vznxf7/Bi7oBc8si32wLfwEdAjGDhhhdbxICQutaZBwwOcGdrX8T4cpGVCtDOOWEucWP9V11MSJA8oWsNWnJKlLLYZxRQ6wRTKsy1v26YzECB3XGl3mLh9m6dvPJeJmsh/+LiPPC6RfAyQWz2RGkwtkWoNUrrJyJqhiQvOB32uvPWkeIo30qsZVW3FGrzjeLzf9ovf2q3hWx66ApzRO5zN1my9GSzs23zXeivQeE/xO79jUa/3esM1/HFoTbADfJ8p3NApamQN138V20MbHLIZXMH5dyf9IBUiSpOCIRhoiZQBj8OjDtQ83cRBvLRHHZRFWTo/bbP4bqRRasXFMRFgHBkYRRhkfBEWwcZZuabX8g5kmHcnYcdxOQyGO4Z/nKdzFw+Cmri9FMmXPQ7Mk9mR+8n/rxy6n+m4oveqj7rL24BdsZyaubrLPYFsx/zN11y+xX1h9WHc6Unc21yLgYWuy7m+2bub9ZTe2RxB8ZW9+zwXPL1CHycX4epu9doTDO3V54NkFX1TJV1Tyc/RH93hIb3BFzegPZQPEOLSX4rTY8p9tQHUN1zUP17EST3UR17TgcjUK6x4WMG1YzwWLuESFsERwmAuEKE7jV3Xdx2oAfLG1QDIhT3I1YAtWZk7c9nZlb3oi57IiXu5e9ggqZ0Gfu2ZuACppF7Lnzu7rTpsu3x0JHTd35zW+umb1xzf6WWMxb7duz6903qt81vewTi+91zP9RxfBR5EsmFR7zSf3Tfg/xWMrw7ecRUewRkX4g36sRuesUs2wQavf5wh00M5XkD5Zkke5Ev7AU08dk/d8Rk/tgNXKIVyFbXdSOaCpm1+13ld53lbPIkdhoF+9YFe6FkZ2MNT9o9+DIo72INd6Y85yonXCoY46sPUErUby7H6MHsv67s63D+zzM+bvAN9+dHWK8Q87Mk6sNE7T+f7u+Gezbd4+vdU1XdmGUoZcEu5w+u4fe+W4BEtlBb97wFZ4g2f8ON/8CO9NctuZitBk+z+z78S8gHCmkBpAwlGO4jQoEJtDBWicwix2kOJFJ1VrGbRWbBsyDp6RJYqZCpLjhzBOZlmSxAhd1riWcPSJUs1kP8g3VETJmcYITxx4AjiUo1PHGpc4mlUsyUkRDh1YiGa0+eYIDh06HCBNasLHVa4WsEqpSuXNmTHyimL1oqctWyrwKkCBo6jWNzm4fOnLy+/vXz5yoP3l5w5wXbn9TVX2LDiw4PvBTY8uK/eyYsrU57X+HE8fpsBO/YrmbPkz6FJh+7LSpUqTZqWgcs2TfA0Zr1ypVbNKzes1YkiERpEiM4Z4V7QGH8Dxnjy5cybK3dOBbqW6dGlU79eHbv27NatuzHupxKrYh1nm5/mrVy39QXbu4+YsKF89vAjXsSYEX9+j7FEtjpFUkkobaESTywZKERRd0DCU0s6JbgTT2H4ZNT/Gms0hYVOGjqVIYc+TRgEFkFYpZULXHi1FYFenUjgWWi1oQggipSllhxVVGFHFTRcMdc5dd112WiaCRaZZIhBhplpezmW2V+WBfkkPkHaEw88R24mGmhUZgnYaUsuqaSXe+HGGiuwxfJaMbtlkglu49XG22/ADULcd8ch112eenL3RHN98rndn4HuiZ0bdkpSySnFnDfQOOmh916kz0g6X6WRTkTpfRm1k1EwtvwH4COiHnJSW2px8RSCBsKU4E0GDtXhSkEUhQctk7wkRq66ioFDh1Dt6mGqVaV4w1hcdHVDsVfcIBaBxr4oIyBxtFGjjW7xsMIbcFxyTrdAQikP/z3iPrYOkeR8E65igQ2mnnqVDZmuZFJCedm8kw3JZb5i7ssvardpYqYyvRQTSzGqlamKbrVpMicddA5naHFnPEcon2ZUPGjGGm/cXRZofEdIIokqAxujj57caLv0XWppy5m+jBE4+gmDCioAhipIznbsfCMUVWR1g0+qsoSHhDtFJZXQOvR6RyNOW4jIhbli+FSvvvpqdYZVBT2UsiReYayzxk47RrTRkmWtWmHpaMIJbzjCTdz2Sjlu3XavS+TdsikzkDJd6oXvZXj5Mzi94DIJZpiixdsvaP3etpoqJH+qpm0JJ7NM5smkponDdDpMhxddGDpx6X5+0QTHF2PMMf+ggqqe53dZeAycyLZAavLKuu/+XkLpxFcfy8KX7IzNOB+CfM7IIeezEzTQ4IIHSwv906ozIT1U9kMB5XTUiHjPlILeUx0srDig+uyJWaUfR/uAMCLt+/DLiLbaa0uxggUczODIN3J7e7cAjssd5kIXkvZ2Db655m+Ae0xlCAfBwhnuSX4xzWdI8xd7ZKlxjbsNK8okMMrVZmC0ydxuVvM5h0VsdM8xHete6LrWvc5jMnSdcUh3hpCN5zW4UxnK6PM73k0KU8AbIswidR6O6Ecjx/ODzupQByg8bwdUfF4JSiABD6Qoew0y2oSwwAXtaS8ntPqeGrznNFrQwmmNwAP/UzaEtDHIEYx0lCMXtPKs9sFvfnyMX/3sd6P8RcAEZ5DF/+YmQL0RpoAFHEwIrXGkBjJuMhGM4AQbpyTGKU6D+uLgbU7BsEpUrhUlhAUzQoiLVxwMOIaiwxxWiMMWom6Gr7MhDGuJy1zacpfcsRPIPGFK4v0wZcN0mRCP6LJrcKQjavIUeVrBiVE5kQ1QXE4Vq3jFbG4gBR7wQFW2h6Cd9OqbYvyQhdZgRpwUpRFqVCNSvscI8mntKWBEX9iwwgMrjEWPjMDEHt03oxepxQX3e4IJODDIM1jCkIhUJCMfKhgmEZBJs8kcySgoLnlVMoLespfj+hWvSXJwpKm5me1E/1jCU2buXwzTg0thCbGIXWdiurxlDWuaMSfw0paHSsRckJE7IA7Thwk0plGHl8SPfASa0txZNZ8whBWgQKpTxQAKRCABDGg1q9LjWvWEIBVn0bGcULnQ+M6IiDbWpCbpVGf7tMY+O47lKilIET8Xgdf4+VGgPWseCvTnAA48wRGyEEZhsYFYdJ3LXEps5imRwcgLpmtdKfUbv4C0UQjmxaN6KeBkP6q4kY4UVDdDhpr+wwlYmFJz//JES0MXOi/U6QyyXQJUi4PTneo2hrm17W51i0MdLkqYRC1uUQdz1GMesahKBUkwLhFNJ05Tp7c9gXWvq9UMaBcCENDqAraJA/9vepMq31TRHKsmRjFADZ13+J4Z4alOt3JIrgSiL13rqgNUxe+tZCtbQNH2FkDW4QSA3V8dLBESUiq4YI6tnAdXCxvEabJuBKwsOESq0cziJTGKVGY7sPRR0YpYMqFqBTLu8o3TcgKYqm2xaz2x4hS+cnSwFF0ShoDb1Om4tzblsY9/W6jahkwTpCQu74R6XGK+h4jKVXICmWnaBJNkmlFMDhWj2rYRdEAE2+1ydyXw3a560ydc48oW7CjHnIRRjOgEX/jiuSE1wDkq/VWzHdt3x+jxwK7xqyNZ0vyiAFvhRjYiMIE5YGAnurYSLxYZaxYtnvGc4k2LKteExbWNAcr/bITBxLBeNPwtcCXwuE6qIGhH3K9T1Awb3NiHq/ExkpK82BMHW7FrPye6KNDYxqNLQg5sgONZ/rjHw+YtkKejHJkax3YbgVRxg/jDZx+5yUhuF9/481zoVsKJiXgqjmeQgyybAANbtoB2yX3uLG6zmzoYc7LebZVToSoMckxvm9MZhznnJJ6MGAOH4Ahn+G1BK2JJM38Butc/DvpaOzg0oklgghzo+pUUr3gegAMwSduipJTLxmIJKMAKpxI3sYkSZjfKWUlaqSB+Cy2qRSsMXXAjH/lwtauFIeto2nrRK+6NK12p64l3IQoSD3e4jfAFmhZ76Uw/dnZoSAWoT6cM/8uOtJGFqg5pJ9nJ0+Y6c5/skZCUhMpW/vZ1x9227KK7yxhY97rbLT2fdDN6KYDeme0IVrCaU87q7Hf7mBK++fp7Q3sMg8AJLlb3iSGvfdzrwnngM7iUQLsPb1vRcxCDzMcg3EHHeMY96No3xcbjllakwTzIDI9j+oF3kaC9wuHQRx0jc+XozKVf3q9wtJrmNa95PZDhCFrn3NY9f8PPhR70ouu6BzfGU9NP93zfGtvpFisD7QQxspJpvbgM2X7Xj/z1pYIqeYmAAnKubIOzZ9kC46Y829vudi26GwdZ8cDz9pz4ck5tV/k+o77pDXBoxQiIMD8DR1ApkRJpplcDyP8Im8B4gKBwkQd5O0BuD4BoMzAxwfFSrxQFFWcoc+IbkiCCrDGCodBxpFd6gVFRHxR6lVY3J4dZukcP+AB7IcdDrEUyt4d7E7QKM2dz+9B7v3cGM0AHIqNz0eRaPzcHQvdKxLE8b+Bt0Td9Uih11Pd0LbQHhPAIw7V13ueF1QZ+kDRqHhZ2scZtT1hd4CZuGbB+5vZ+GwAB8Ud3c2dFdWeH9cUr6bV/GsJvOvFWOUGA7jWA8MQUziI2CphvD9hHZIMSPUNQUkSBD2CBFvAFLLZxLCgKn8AmbMIaIEgnIJgHHyiCVucMEWZp5VIyqfRo40EyiZVRmVY36AKLNigzqJT/OdfAQGCyg/RiSP3wg71Xc7HgBSYwOkYICyRxa7GVQ0PWbdLFB8jxA2oYbNAnhT+GdE8nfUygjVZYhR+ThYIQMEE1VF3odd+nMsSzTGHXH1MGhXBRdlE1A9a1hu1nVV1mXW7HTd2kj/ZXh3ZYd2ADRvpHRoYXT28EgGT0PWulkEtBgGHwFQgII4m4CIuniAlnFgPVMzoyeZOIAW+TCiKECyN3iaBHgiLoGw3jgW3CcTEzUYLhTCQIY8Hkiqcoi4lEYRWmQBYFSbmogztoCrvgi64GjDRXD7EwhOGmhePnCImQCKXTjM4IjSxwUCRwgRhIbNWYjVOYlT4GdeCRfaP2/4XlaI4nAxtlaZYfkQqxMGU8o3RmF49SmWXoNgJrJwIqYF0ZcFV2WCL3x5f3d4BjpYdoBXjhE4gJuVa0MAs1kZjwBJFlIT+LB1D8ZUdoIWg60jw0sJGTCAYIBpIh6ZkPBnqhWQkaaH1NGIIrqR+wsRu9YYwmRnooSJM0eZMf5igCgYM7iUEOtIt7QQm9aHO8x3v7IAtNOQQ5oFDB51N2QJxeIH02Bm5ahmgXEFgXMAJDcJXbiJVbyY3X2I1Vx4Vi6UPdtx5h+UM8dJakhwymsI6H4FTOh35v+ZZxyYZyeV0loAL+WHdY0ZdOAImQBwUmAgfoJZDuRaCGqZi0AAnEQP8LxJCYiQkJDpiAjBiZByehfGWZkAd5V6Q/FkhIhYAKo8RpIfpgmUiioWCClQMKJbmBc+B5LcaFsMAJrGmMn1KKsYmKLdmSErVyDBELx7BaaPJhmqGLu+gIl9BqvwicvjcSX8CcvFacRscCLQCXMqBl0CmdDoClBeAAKsCN2amVXWoxy2YmMkOOtUme6TCO5XmeHIFYNCN2S/lUUPWe8ChuaXd2dTlVMICfdcWXTsAG/BkWUERoYLNmZJUhiLBW7lUTacROCzoLC8qgkDALrrAJY5AGZSMtKREjFFqhgfYVGMoDdViBFmCBaMCZlYM5CrNxqjqSrzUIj7aql9iJoUj/cQ4zgiCZjMJlC822pmaJo55hJY60UrdArLfYJEK6g9GEDEcqlMBJDTQHDeHQB2bwAtX6AtCpAdmqZda1rSGQrREArlmqpQ1QnV7qpdypnVaYHTrEq+V5pmX6bK+BWKVYo4YVDM9FEo8gCGgop/AIbOoXj3kKAwMrpUCgp/4YqqEKqNTEsA3LBmeRf1XDNWIQNbvATo3aTsRADJCwoO2EmA7ab2cGofoUoJKJZnIFYCdxA3S3AthCYBAQAQeApYI1F2qSqrngozjrmTerMKpEJ0s4ca+acQ7GaL7RhKFYhJDGlJ9TO6kVkuShEc0GVGT4GkEarDdIrLixDEB6rLqJ/2o6hw1B2axJ6mqjIAhOUK0dkKUNwLbZql1c5n5YKq4FQLcO0APCZq5fmq57y7d9qwUX8wZa+J1kaaZZh6bvWri1iZ4WIQylaFiNiwpNtTN4MgRzCp/16a/pN7BXRgM1cH/N4zNQJKgMO7pr8SJjlSyLt6iN+gutq7Ea67HtlJghq1+T2QadirIChRIuu1Xc9QAIILOB5QU1a7M5a7w6+7SLgqofZLS06lKIQkLFe0Kb+IlMu4FBq0Op5VgoZWGjV7W2WWvEyjeOskjAmkGZZGqfNSqnsA31UA9j+6zPKg7iMArUhLZqy7Z1C64WCAHmRgETEK75W7dsSwJ5a8B+6/90aCBcV5emJ5O4hvvAhEuvjotY27AN+KqvZHcGlvuvl/tt0QiPVOQ8n8uf/Fm6dfAHJ/ywJLtPupIhV5Ara1ATGfu6r6tGk9CxiAkJDsnCx1Isp/siYQMHZrG7KzBukhiuMqulF5ADfvCRxaA5zcCzs3ezUcyzrWWiWfxgIVpCqVG0P2soQEsGY+wGQpvFMVlS46GzBOG96iEwxnAwWuthV2u1EaWbIaWLjCYqltC+v0m24uALmNAHfcAGKuAAdIvIBiC34RrABpDI+luu1EWNB4zAlVxsChwyimKW7vqFEUy4VOsMkIsNofxckyZN3eaebimw8fjBISzCJQzLodv/sIIwyw7bw3+YKzfQIWuQRpBaw7C7Rgo6C7OACAQSFmHDwiabu556AylwUEgMvAdAAJCcCCaWUlKMzVWMOde8zdxcSqHpWpx4OQLjTJ/SiSdZcROnhYiyilusUmJIvm58DHGMs3PMLlVrvpMlWZqhx5XwCKkgc0DIe9Qgv4CsC6MgyE6gtgHwyNPs0AIM0dKpZTNgW1BAydjZdJbMt6uDbGjAB0k5wQ3cyZ5MvjWajo+LwRncnubXHAbrA9X6r5U7pyY8urLcsH+A09T0RDyzwkM8Ni8MwzC8CK7Auq77yxr7qAhazM3i0y2MVxQJmco8IC6wAhgAzUr80FtazcGg/xDZ3M1fbcXdbBBQ3M0jyYKBsISvhHGsuEzFkGCmnAh6MMbYGwkwqbXRq1LxXJu8EL7JcA3toteRtc8DRA/3ICr9vFDbML82N7/QAA3DcNCGkAYKPQF0y9CILAAP7cjT3LbsV5c/IH0uNMkYvWN6W9qug64a/TqS7DpZKLghTdKxLdvkWy5tOsodQTOnDJW1XAf92sro98pmwNs3/bDJs9NO1dOEuiwAGdT6xU5GDQwE/ctqtJiWuiJEHC0VWZEo0cwYYAKSiNWavaVvoGDZnBDmLQ1gHdZV/M0tZhtsgtZirNaRRkrOdK9qUrQcqNZ1rZKsoKrGis8extezxgunNP+GPdS1Ooo4/bxtUPgHNVMKozAKB40JCK0IhHy/h9zQG77Inm2V4BGneHvRp23aqh2mmAzSm8zJD1wl7ODiLz6eeu0NZqkLKF0KEK7bVIbTO47T3hbcgmJ+tJwzPM6wO67TfHDkDrszKrvcygI2WxMHa+DL0U3lNSypNRGyXDE22U2AD6h4jGepcNDdVp0A4S3NnF3Amozeaz4p6+3mZW0LIlpS4XySIGjXrKAoz4TfmQDGgRAI/O0mqrSz4yusxAqTuUHoPdTGdTwkDN7gSoCukgzLMKABbHvZAYDpma3piszI7PdrS/CEghB8zifiI17ifnuN0yeK1cySs+3qMl7/lvPauPaK430wKj0uXTyu63/A0lAYRSwNBqFr67su6sWN68eN3DZiIwS1Fanb5FjgClMODNP+yw5aiC1iCAjXgGAORkFMmVVgxOBt5g8tWNrb1eet3m+e7qzKxT0750V755Qmq3xOq/v9aLSmGiSX6JlD5/qeO5CCzwpu2FnMlMvZA1JppVsmpXU5t5v+yDNrbiPQNhIDha15CKRu6iSO2qltW9dYA9UR6aq+6rv6vYQLwbAO47OdEcJgwRBeM48w7DmzlE6068M+yLme7MKNwjWv60Mu5D+/02eAEtpSBe9W9PCmCK4A3VVew4vJwy2ygPKjV2EuxEOMEnDgAln1/7vjvukXEAWcwNUFYcVtru60V/Y42O6VBaL/woJDu7zJaHH8Lc7j/NfMtRpzr5MGruj2jM8ET4LIMTsIT5UV0Nn/K8AP3+GebXnAtoyJguf3XQkfc1OSrvGkbfmojo2n3kvHMWTFMK8O/Oopf+Dn+bihoAu1HvM+T/PIY/Oo0AeUMCo2n9M3jdOyP+zUlDxHjuSz/7BX8AY3gk/XkixHPwYcu/S//E7xNHAE0ngLyIhNDWBEzAMVyPVnrqVfr7zzke5k/+bc781nr/btrYoch9e5cffxfXHp3yZtgu+zJ4YCowqR8Odtgtd6z8af7CgEP5pN+TEAgaSHjBEjLjSogP+wgYOFBRY6mEAhYsQHFjoUZGHjRxIvbs68SaSJ1SlbrYohQ9ZKkscnLV2+hMmEipMmM2XWvInT5k6eS2L67AmUSo2hOY0e1SIUTRamaPY85RQsGzhvVcuNw8ouq1auW7tem0o1rFhnZYWFEqbr0aM+a/8Iguvn7Z9HcA+xddunLSVLev3OZdN2Lt28feLOPcxG7uAqdqo8/uiCh2QXHlxUccGF0a5fv6gBA01MtOhZkBAx2nJ5SxpGgFy7HtOmDSDZhmTDkR1b9+0qKVY8YHjAoXABxB1eyPGo2HJrz7Q5hx5d+rLn1KtPl8ZM+3buy5ItB9+9V7FcrMyrMl9ePS7/9rB4qf/eSxUoSYPm3McfaJD+QZlUjadOGWPmiyQSkdgLsLvmpmHQKgYrCUWTkOr7qKMcCiKhAg0f4hCii04AUYQQMdKoI6dCSoQT87hLiZVBOvopxqB0QqonmmYUqkYdd2TKiJmackoPQio5aSyvjvwqSSPLCgsbbIIJRhdnHhGmMEH0WizLu/DCay++DvlLkLr+COyPMAc77BDFEqNLMTgguwIzHujwYAgeUuChCs0goSWfX8QB5rPRiCkNkTBSWy2NMeJwrQ3bcpuN0UVeo/S2K1wo4TfgjON0uORMqgY7UUcldUHxAER1vPPQk1Ak9FZU9b310nOvvVfo0+++/zx0zUM//+DzJJMCf4VPweyOPTZCCCFMhJAz3OjiQoJAOAiigy7gIIYcNALjCSA2miHcgTjy6CkDI1zxWAaVUYYTaCuUEcd4b6TXx3rl9TFffHMMCsikghTTliUdVLLgsJh8cipstkkLFVSozEvMK9McrEu2BHPL4ovHnBjjigVZk+K5HLHDsSrAgAKMN5qgYTI7r5gNEVrEoUbQ0WihpTQ1DnVBh0QVfdQQ2wyRdFKjjY7tTclWwGBT4YwrjgBP/QC1VGSvTtBY7rD2Lj6vy7v1E7HHBmW+V+CTFexa1g7Wv1BYAe88Ce3Dbw7+PDEb72HP/U/Wrk/lZVlmm33jWf8lBjIIWxBIVEKLN+oouY6VG+eIqTLKHWRIUd7GZTtT19Xk3S+63XdH0++9kV99U1/ddNX1/fdEIgdG0px4kDzYSYV1d7KsR0ZRK+OOtaTrr4z1wosSQyy+EvmK0RR5MTkYixwKKOo4+SOYz4BDkU1coaVmm0ebpTTUtvD559oUYZ/SRTqBH2lFZLt0A00jeLrT/BsYgQ/mrrOa1rjWjAEe42/xURsoyJaJsd2qPF+TlQMJtCu7SeJtwRAYecyjCWHRLT/9YWCB+OO2YoXnPQ4UXCUkQThoCQQjOeiCU1TGB4rxoXAyDNJT9rBCV9niO9VwkDXAkg2VjO5fNCrd6ej/hTrUEYF1rnudUHrEkxzC7WC1w2JWsoGS3TlDGE8qhcO8GIxHfMkt0duSYNS4xsJszEzP+xib4Kim6lnvZFXAjSO6972ZDWpQtDBNa8KQNNa07zWYaE38JnWJRVgKN1bgwf32NxxKDucCb/hfAAe4ye0Q8IDJMGAv0ra2EJZSbA5EEChDGcG82acIrzxCGVJEK/IYcD7Bohsd9hOJXOkKhAx81SjPtqxWsdBC20KCUxaTsbUIzg+EgOaEJCEsDm4uFMVAR3aCOESwtOINQEIiFJW4RCYywYk3IgrsZpJOcUbRcWig4SmkIpYsYjF3vBMGlBzGTOd5LI0jY6Mb58i8/4GikY7UgxzkGlOISzDye6vAmfj+CMjTJNKijNiEayyqSEU08pFxskJIU9A04CSgU1FDqQFIQIhWIINBmoQpsrymylWy0pQhJMXZVunJrh3jFhJklStj8AEQxHIPEKJl1/JWyl7eJwq+BGEw05NCFTrLcFPoghfeoCIVOYKrX+VqqwbnKmteM5tlySY9scIgYXjTC/OC61Ho1YdR9IGc91odO5Poztd5hA9DKpJa22Ewr9xzKvksi8McFgpUmJF4A/0nYSALWZAd4jCVlSOZAFMyOazpD5QA3ioeuguciSN8fywNJBiBCNWOwrWihe0mZBs/9sXBkdu7QQlIOkmpSf8tAAEwgNT4hwaSvDSmnByVLX+63OWOzZRl+ylPozFdCDJ3VaEjw1OF1MNg4a1vy4jFAVmhtw7WLbsVhC6CxFpMaEIrCmcALFg3aJ6vVlOFtyyrWdOKjsGmoyruIIuTKLGUvbaTJqOgBjTsShOiPFEmejVwgfVlLoEJtp5X0WLuspEwfe7TEsx8bGQJyjESy8XEcYxLikOGps76oUyPFRomVuEKGssWfDjzjEQJBQlIlG8WNB6GL3QB5NlOSo+PfORjHsOD3O6Wt70FrnArQNxMAnC6psoacmfaDOXq1LrOxamXqVvAWkFwvrT0IYGq2bf3fFKVE6SgdgNBLGasl1n/7XWDHg7UilNwdVV/BnTeUJlWABN6sGpd2DYscUQJK5Ea/xiFFO7qYAjnVZ18nVEWwHC5IcnTSBe2HVW4uEUudvgUqOhzGQka4jkST8UlMzENI7dZuIRMMbeedck0y9CGIhKRM65xJ1xB2j6+I1CkIUbOfPzjIAvZFUWeH5KT/IYr3MBlJHXaAArQW98KFyFakGeojgtTY5S73EBtLpgNlF7patnNPtxOKmslVVp991RmKy9URaKJwSkLz53mcyv+7B5Az8pWqdwvgBW+cHI03ElVIl2j5UrOUbyDGgtGJ6WRYumitJNfOOw0wkCdYW5KJbHBcNipHxEKEBs0srF+/3WuZS7rWtua5rLG9fSE1gdKyNjZQwZ2jXu8C0C9w+j/MLZoJCoOaDQ9yLt4dmyP5ohCPJIHZ5CMbiuSbQGklNvHcUO4x93uAja3FmRD9wI/sbZQjlnc7n43TWta5ghyEJjuES/YMtFLMuR53yocqx70TJKShIfusfKbCX8IRP4y3PHTWE6fCVEHKkxR4hOn6yYePYtJO6HSTPj8jziOaaU0BZrX/HSo6zlqUkNJnyov45dcbdnhcczFN4d1QnW/e9zHHOe6L1mMMVGKIXODG1CPOpF5jDOjAwPpFpcoNUrLdGj4eLSmkMUmsk+bN0UGU5Lcn9dRihAiKOftY0Y/uf95+lO1LzBsamc72bFmZey03f49NaCAVsnBEdpb3rbYoL27j6pKoRXaDyIxPMU7lSqDDiByhv5yvHYoi/Fqlnd5q0uLK9NhBKSjhneItJaZNCMIvaPAQNIrPZbQHCYRi9u5sFJjEtdDuVOwhFBwLOhhNZibOd6rg0TgPZD5PR3UQTkALSB7uiCLLZ+jsUagBWBIOmKYBCekhScsjfIxLXHYhSussWeDuk7YQu67o0h6AJN6MvGTsvI7hfNLP/pLQ+lSpfaDP1J4w1zwpM9RQ+tYw/urKTykOzXzLnl7oOyQwwC0oL+bm9MzCddjl0RMRBZZxBd0wE+bilABwLmZg6f/upyOsDxGizCe6IN3+AekmwWMYgNJYzAmGsESNEF1AphKOAXaYcFXVL0taj0YRDWSoIRQSDUUw0Fay8EfBMLdwzXdqzlYowtM8IUgq75mMwVf+7UrVEKcoYU7gISdUYM7UANEwMZrRISnw5krxMLk20JMsA05YRox1Db9+bpzJD8E3KQ6vENQCkA3lMexkcM57IZ7LAd3TL+/ASBz08O4U6V5qzvO2Zz24Dc7M8DBK5KUaMRHfEQNg0gmURZeMi9LvMQpykSg2IGNHKeZYINZ+MSQfAcFWyK9ajCN67hUzBF1Mr3ZObSRAwcXPDmUQwVcVLUxoT2Yy0kc7EFhfBzI//lJPrA5ofTBX7SDu7iEYzy+pxMtQNi5jhq2YduFRjCUMAiCIMABIQiDreTK1doEbBy2H9sELLzC2TKFTcAEPcKM38iftty2dOw6AgCuFxAEW0DDd0wu5VKgsdmbvZnHWmg7t8PHBdFHNzNMgMzDLmM79tsc9ooQ+hjEqjKXa5IK5kCrUIlEFYxIJiGPzakPPahIp8ouTMwq0owRjnQw1fG8TgzJkKSGTSBFELwrfRFB0fsWoMjI3FzJyjM9PiASJyk0wkK0ajC5srBFW/ywu5ALFAEJP6gEnpQ1yOFBowTKoAzCocw10Co+42s2IZufUWSNZJyFqkQfHMjKq6RGbf/ERmyUrdYisthqSkMQqQwIDreES69zABbwH+Mau+kaEL7kpb3xlWFxQzGjv+tA0MI0zHJzM390UAc1m7TTBFcCvAJsr8E7ucvUzA3TndyJG1HYuzwTzRHtu0ss0Yu8QJXUkZaZBU9szU/chDSQTXY6RSDwOBN8JxpCveBcPbCYBpSgxeO0yed8Th4snGhKhGfqvdxj0p900sihTpmTTjMhvmMsQuRbBfYZRUMYBisMRUbYyvO8Sq3cmfU0UzO1qNOQutZIgy2QghLAn+DitnOk07iUU+EyAZZyKbirP8ZkqgHtIAaKw1toM+lI0OfIRwU9TPyDUOZ6ULZJu/ESwCL/KCZigkzBO6oi0dCHVLh1ELVi6LMISUg3qBvBE00TJdXSVFXKoc1WTUnUlCs2IIYX/cR3cAU2QKcarc3blBHdxLTJq8sHtDAMIzl2ITXwCLjjTLUi/Qg6+IgjVVKf7EkgtM4ebDHMCj5DQEIrLcIhE8cthQZaeDZGWBSurMY7QNd0RVf2XE+LGgOMeq3Zsq02jSQEeEu3rFM7tdMIGAFM2prj0jt1EyFf8RX3QyVQujLCPNSFVdQGJVRIZbtg+rJIZQUBjAJLxdj2uiBH3FBP9dTOpMT9uA9UTVWSRdETZVUvYNUh0Eh7QcWcoIkxmFVafQdGoIHWOcmXvVFM0zSo/wgs4TTWHy0LGMQgZa0Er2JWOqADE3lWkKjWX7whO3jaKAWMQrCESzAFbv05XcC+4VOEkMKE6mNTc63GRmgEPEjXbDyNinLXRbkoNm1TGaXPO+WUfBW//HwDsbNDQx0VPy0lAfXLtVtMB+VbREVQYh3MhkU/n5pYVHJUinUg/ssDUMDYg+ShQeRYRyw8f7tQUxXRzy1Zkw3dVVXZfHFVlDSKBuMBmaXVf5iF2PQ8U9TZls2J2S2Knk0ETxvWWGwQtgoG4nw9W2Q5pH3OZ4mCHFhalXXWppUcKNU9I63O5rXO6xFG4oGDq83aYcBCITvLhhIa5eksQAhFvXCNraxGPP842zVA1/Q0lEQKA/ddlI5y1zaVTzil23S025RCgH61BAYMIC57v3mEvwe1x8Q13ANG4ASGILmrqcZFNwcGKs+8XGXh3Mjc2KKNPM7VoTzbYNAdXZMlTdI1TdolYSVqmRRAhNZ9B0UAQZM0yVdVUZ6lAtlpqd0t1m6ayaIVUk4gJuOlgygA4h5g2qh9nOnsReeNXt2bHs3qLDgQNm/8BmU0Mjho4iYey0SSX4wylPSsRi4G0/f94ovSKEZ4lDSQgrm9X/xVYwJwAP4VoFLxKTgsUIr1x4RN4EQ1XDy+Yyv7xwaGYIk1u2CK4IlEyAkWnEkU1cslBEzdD0z14EdGVRD/FuHSBQqW9QnbzYkT5gGQpNXXlc3UvF0G29US5itU1Koh4aKG81HezcxWdr1kJQmu8qoK9IIgPt4gbolnrV6orVbqTagqXuKk9MZvXAVEUoQjA2av5TmhGYM+GKRFwYIw2OL05Erb2soxJmNDits31YA09mYo01eVyts3VmAAJqUGEty1UefHjb80NGAE1uN45mMCZtRz++OzgdjB/bJcKBv2UmQKpmDIvNzMERJGLmhIhhZJXlWUJV1LdmhM5khNlgJObk1blbSb1ThXHeWHJuWONgPelJ3U06JtEtqhjbySEN6u8oRmWdofDuJtgekUJWInnVrJeVrG6B6sHWbt/60xp7RaaRPCjPKLuN1mK8gNRrnma4ZmpF5q2ohf+QRDB7DXOfXmcI6aNs7b31VYftxq/1xnfUabR2VQO8bjspbnPd7qxHRYds7ntn5YxSyPafqEf6ZrRU7IDY4EvHZkhP5gVa1EiyzdhtbojpYJTZboFn1RD7wTKIDVjB5sXn3sJYBsnigXSTgJVX7JG/4vBzQ8lF5WCPED0DwmmDaBESBth24CXU4oI9ZB65nS6bleTJAFbzSFXeDC7p0UJPsL1/CLUfRt3w6p1diNpR5uprZmSHlTBpDThljj+7TT/tFb9XNU9iBcBk7MPDbr7EZrA7ZuuaMuPxbrtxbv7uaFaP+y63++MwOEJnP5zA3uYA8O4fgWYaxSWcFm2cNRUdmUzYmm1dfME4yOkY0W8EuG6NoFElRO5ZekHVc2NcIDK5ZW2lp+aROQFnFx6JqWXt3zZc5inyem7SteJPZ5pO9VhD741s7C1euRghX3bTmgXy6AFOJeFBgfbhjfghSAgDhl429u7uemsrss3OhQ6yEf8gZEXIU96yN/5+ogcvCmZwau4+5m7x2yaypX74HO6yzPa73m64tE2eSNAvmunMq575UdvdahCf1umS2gaJEEhMm4unCSbFEe8Mmu8zq3nBNJEQgJLEg8GI49aQAMVfpqFmchzeM97UT/iCjN8FkbQu3/3WnbzqhYEPE8ekq9QHHgZvEWx/S47QP6oXEbx41QTxQrQAGu43Hnvmr+1WrpbnLyvj94Jhjs1oZEnXX/4u5Xh/Xu/m487Clz0SEesvLTM+8d0mv3fu+lsMBILs0wn+8xX1WOlvYHs/MGqwEQpAFJYwNooFVxaAMeaGxq95EXcAIiuPNzt/PKYx0c+tzTUxHL9FBHRIVAP49YZq+naCFxoXDS3pYpjTUkTihf/qxV2IWljPTZkt+qE/Gdw/Tfpl7fBqihFkJLEXWYgZngDikXmFsEkOpU/7q7ZXUgN/J+dPKwbvKRH0xcV/KVv3Um7+Mo93XDLMwsH/ZiXyFBsHks/0d2fFf2vhZz0oX2MRcIcMHvjSjBknyik3SCPni0ihaHrwV3WCVhyL7Nqp92dMfN0fmmhe6Cpc0criIJPrNMoj3plE7vNxgEZY9pVR0dEcvJ6I1aQ5jtK/TSXZAFWWiEspwURWIkLc10YFRiyALqNyH8i1cyGth4bvP4HreAcSbnebZnsH7ymNcm7bb8Jc91Xfdu+VM/9m7vK7f5Y995nu95Zn/2oEf9oid61X9sGk0npaeJNKAFkfzEX4DNFk53jtxVo7f6q9d9U64Qy4H2z9UVC8bFQ0REz/5sE0tSG9Llw7jahkqFhuIz2Wt+JXucQpCFY7TCnIG6XdjGs+wEjf/KPvi5hJ8G+I8OfMG/XiRLhIu/lMO33yfrcW0D+azupDV0+a/OKYB4JXCgqlvGjiFMeFBhsmbRnmmL2G0iRYkWL1bMWLEhx4UMlyXs+HAkxJLSIoI0eRLlnpZ7JL0kJDPmTJc1beJ02dINzzI+vQDtInQo0aJJjiJNauOHkqZOmQIxInUqVSdGrDqxWkNrVhpdt9D6J/bdv3fiFHllonbHkrZu2UalGnfukLdy71alomXvm75Z/gblSWdOFMKCecasVInVqcbFHrPi1JgT5cqWLjvCjCoV51TCPpcK3ZkzJUd+7NTp2/dPKl/cxO2KHRvRotq2FS2KVbuTIkdwULP/SS18eHA7f44jP6R8eaHMheBAr+LiDHUeUKpUKZHhAHcD3gl8By9+vHgB5MWPSNRKGTOVJFF2rCWfYMGBBj2GFOlRZTmNEvsD6J9/Dn1UIEfvIeieNe4tw1JOD87EB4QPHtYTYIEZpZSGG3IIFV5YvXBVVFtldVVWJHq1xSxkiSXWLFKwVaJdM9ZFl403ivihW3x9EdheFs7hBR1AFQYkYoQoVplklrSCimOdIQOlMJyJJposo4l2iSWHJKKaHZdsI444/cgW221tKJLmJbc991sdULwZZx3FBZccc4cY0pxz0LV5RhU3nDHddTxggEB3BSAa3nnmJUoAo+Q5kIMf/6k8lhKD8c1H33z34adffgQqiJGoAq60oKUGehrqpae6N6Grr+7xk5FGBXUhUVMshWuHSPTAK1IeSkVEVyYKKxUNKII4Ylc0pLHJLr+wSI0hMa5FI1441kgXXDruiIa3aLiFYZAVGvbTHIk15hgy61IajDDBuMvuZ1dmOSWlWJKG2WlfuibmPrDJVhtugKTJZiHBwXmdnKidZuedD+9p3BtVVGcdDys88Gijii6q8XkN5FBJMNO0V6pJDR1kkKabogqqSCMlNGqA6shMKnyptixqgpeaOuG3FB7p005lxCorhkcD9tSuvSrdtIc1mOgEEUQYa4SwyVLNlbHLSsGDHP+YQPPOO6PIaC22T2drNrc7pgZGrUgP6cYbg7yRiEyJKHYKvHuvO6/f765bCrtYZokvaVrq68eWpfgCGze7wGZKJ5PvdomWvqF2nZer1enwI59DzBzDcPRFcaAlPHCAx4duvPoAjz4a6SMjm3xzQpna1ynOnyK0c800/z7g7rz7XvuqJg2t05EU/iy00bQi7fTSvlLvA9NPLTXi1Vone9XUJOa4rFcKjyIO2dVaaxfaZ7M/I496JdEWuEJRlwgfguTdJN/xztu33/7DS3D3ohJoCjeaA1LCcqUxzWkuIQvI5WMXrljFBCXHm0vkCTjCgdNwPJecSjxsOQ0bYV94ECj/jKmOO65rFKM8tjoGvGE9JDPVRTpSH07ljHis2qHO/jMzm9EwJS3rXYKCaDweLkgPeiBaS4jgEzTIDSdQrFDRnPg86CHlbRrS1YZydb3qZQ9qNZga97AiomGZMS1q6UpX+tAHvaBPbWlrn460tcb38agOeGOSJSyHCsD9DZCClEXfABgvzgQDX4lE4CVawaRGNikVjyxNAx8ojscNwxemkIXkMOimKswJlMQxzh/yVEoPPoyU+5rYn6SzAwiocIUdg53rOkAIz8wwIxBRCA5xBjMkAjMaxuhh8HR5PGHmjJjHVAkTi6a8Zw7titLMIjWl18Vfoc162WPaNmGwlatJ/2WMXnmB1LRiNa6gMWpspJYct0XHdzqlW2AYTgIT+BlsBHKQn+Gf/6YUpb6FJpH2Clzh6HXAJimwj42sJyUMURpKTE4WuliFBXmDuVHSqWEhFOEIldPR49TpDXaAA6EyBrvXOYpjLmxhShMVgj/AK5c11N3LXMbDT/3SUtrYzzCLuSAj6iynwVQVDYFKw6IhpiexcgkUp0g0C00Ti1q0Jjan101tZk9qxSrnVkhUrPCFqFoySiM727k+b6IVrddaqzzr8IhV3FMXcZVrIOGVT0IOcn//RKTh7hXJvybwcJdhKEMth4mEPkeDiv0onkCXHMZCFjjRQZ3qaGmeAagUUf8BYClnEaWC2TmjGsIbnk1LK9TTwudmPjVqUG+qU6L+NLY88wkRktc8bwHGqVCVavSmij0vWvWq2xTWVonl1a7mJXxQY+NY2+mWs84RWPBsyl6ooMdL6GIbdP3Mdvf5v7v2z154lde9FtkuwyFUsAl9qEMLe1gFHmyxjN0oSEn4UTnUd3RvWEEKL4vSlZpns44ScGfBU4NQvEu0srWda3N4IOIpM8I1hC1qh2q8BWP4GbVt4l/mZyu57ba3vu0QVX47XG5CBasoTvHUjjW1rGmlWOQMq7LwkhZyxjHHZn2nGLHVVjtwt7tCBq8wNonX8A6Or6MxKCMPOEn2QlmB723/aHP2xYb50hc59j3OCI1z3yGYNJb+lWUBCNxSj312XQqO8A7b7OZkzpQkwJMwhSts4QsblScedsNeOtznPdvqKHMY0q+KMoRqCiWbVWWxins1g0ezANKSFu47y2osHGOFuXHR8VqjC91PU+XPdYCoKeRapSIfmcjzEhzfBNjXWCgZgY6k1CQd+dDBSnkzVOYolh3L6y4zLNiM7ZwcnOAAFv63wMousANOcIhYXMMaAYqzaWvKS5pCWJdEzHBqifrak5EWVNw2mU4Dbe6fnJso16NDFKJwaERTldHAZcqKJ21vSld6W9Sa8XGTy+m25BvUTjPRPAWBilJnV7vaXTWR/43MP1YnMhamwBesO1NxSPqx1gm19WBnvRlUUFLLvT7ElhwrCGAL++TCFvkfglODCSB72TLvrOzYwx42EyjbKMN2tkc7bjpTO9zF+3mD0m30EQslB0Fx99LeLe951zvq98a3O3G0g2MxAUXILW7Wa+zvgLNPuncpuDB8QdfQZLceC7/rIQm5yVNH6eJyl3WT+lh3SS50sB23O2lMicrQbQnlKb/f4Ft+COBI7dhn1uzMZQ6emt+c6C7jxbbhozKWwVl4QO82598M4TvP9uiidzpvSez0p+NbuFOnOo9rjPWyNfffVW+9WhWdXDOM2heXcNsT5kkJX0BjGwrPp+BYbf98z1CKXrC+eF+bdHctOR9xlEivepWDX/qaxrElX+XgCV94lRfHCSqIwCwXb/6YjxnyQPclMm+hKZ7r1OedH/e3wW1tz68fIqPff+lJT++/KJrqCeDq3RvtMcWx9NhdvN7XgV3Y1R5bwdGXUAIYqNgZvBU3YKDZnZ28BNTElddoMF/0VRz17V0J8t1olAav/V0hOIz3uWD3eV9GpcYJKF7jMd4NLht3zIAj2Jzk7dLw4E4v6RwQDd384Z+DVV6d/SD/Gd27AYUTZgjULdqJDWAVEuCIPGDYYV2OeJ3s7ZgDZovY3d6kHFYdDIEJoCE5FQImbEPwCR/D7RUcjuBBYRz/YPFR3tndZVAfCoKOKjmMnvwa+MGgfOXXnEABDMAcDtogCy1bBHiBDP3QaA1REPbSm+Fc/V3iaVXbJnpbEDFhE8JbrfjfUVjhFTqaKS5FpD0aFoJhwHnhF95IFvpYW63hJRzCG/ReDozACczAG5Bca2CgdgkOvfxNaHhg8qHg8y2U9FlOupwgpRxj4qxglQneC6KcNYbfIaJADVZWC5nZN55fzDkAHcBC5F0i5dHU+z0Y/rVWERrhOnretmFiJ5bEXzjRVNxjPIle6SWaFKKe1JUiKoKaLNrIFr7ivxmgwN1IE8DJH1CgCeyAGbKADOxiEkRaHTAONwTfdklO8aEa//JZXB3a4fPh2kMZTsh5mUZlGffp0ffJ1wtCQRMMAQZYAPotoiK2Dnd8AbSZo8/tHA5d3g311M6AxH6044G44xHC41JW2DvqX/UgQdJE5SeG4tM1hUCeIlYKZAK2Yr69YkISJHT1XtvI5FqcwAhUJEWagEhZQqllIBwamQGFpGDVnQmmyx5yBmUAmx+Q3CmFHJdJTJe8JEuGUgyWiAlwAOvg5IAtZg4mSgScAU+eY8oEJWUaRBFeG2YmoRKCXmdypjbo41Q2DVUi3YpNoRdpZWqmGFeyz+ytDQOCpUKeFUPG5FjO4BOMGgY9AbD4ojDUw2+aXTH2lR9FX63ZJR1u3/98lZwl+B1MLlZLKtYoPWQHRIADcGNjYmeAMRuicIAf9KTNYIoQ5gI6dps5FiWnTNgPGuU8dp7OKaVnkkS8UQ8/9p/p/aNqbmULdOUs6tumfaVrdqWJ2ZFemEEL7KJbQZSplQIl+MFDouEIgAEbukY4BKe9EI6T6SFJrldfJSfg7ZrISchzzsmI0slwyMgIVOd12qTMgaM4OsAI8KAyRFvNqOckJqVlZiJ7MphTLhM72pl8zmdV1mdwZSUBqiJ+6ucqsmZYMikDeuF+xmKjoY1avMlZxsiXlAIFaRKDLgFacsAIICgmSNQ2ZBK9GCOVKFD1SV9JBhYfMtBpZB+bLmf/IRLHakinGVwHGJgTimbWigpAi2YnC0EmJEbigglR5rUjehrTD9qZJm5mo74npD5EkPqjkFoqkRYpkhopLx6pNjVpWu0Ak1raqMqRqLLikg5oVlBBknIqFBRCqWFCnJwhGu7AGdiBKLFhBmpgRU3Zx0mZ3tkaXkoSA4EQc7Cpr5HQnRZmnkIBD5Qlp57lBKjoisYcoCpbA1gnIZRjtI0DOoSWNywq+ynhgqynRZinjh4qeX6mEd0fJ+6QNX3RpSpNaTZdKuaApm6qKnIqqoJqvxLkf5rNp30qf2aFRKqACHTAl55AE7TcEKyAw2LAg1qABSDmCOzAH0xOJpVpR07Z/6/a5TNyxik4R/YtB5u2FzVG57LGZG2WTahyqpdObA02QE6WGc0yomMiCraKjM11KzhkQ8+CaxAhZVIekVEa6o7yXC/5YI8yZdNyhIpNj7xK7Wmm5r1uqtV2atYOrL+6IixG6dbKBTqtqgZ46b6WpUyuAAtQbHV+acQyJBusYam5giaFhnv9KscRJ4aOLAsuJ8gR1vZpECgxa+/BRVpBa7RObOLGbIpa58zmrONCbqKYWaBi6w+sRzaoWWg5w88qmEwxbZ0Zrbky6jpaptKuK7t+nrueCpBSKuvC2/9Rrdbia6em4eG2wAuwKteGauGaan967al+bfCmKhEcLC9enf/L8uLD4leomkDE8iKtRiQb4Nfv0a2UyeX1GtScam+b/i0LooZqsOxuHhqk2W7EOi/CJmwG8GLEpi/6XkDkRm6gakzjOgAYtOW6YEM2rEP+ai7nrhmeKWF/HCoAv9btCOWjEnACO+17um6lTi0XxW6kmYCmTvC9qQDW6qvtmirYAqinCW+PcXBUwIWmOWzaIqbi7kCzuqzDGm9ZzcAOGIIvbGzd5q2vcgaTaW+xVgKb+m09eS91nEHakO8EH24GJGzzFi8KKLES8643jVMIpOjjMmKLxi/kgkAWvIEl8A02bAPm7m//fuv/TgQ9hiuCHC1lHvBDlPG4JsgCH2EAnmb/A8dxBM+uBWdwEt/uBRfvBTOx7jaxH3cwlIbwLKqqCiNuB5yAESdvCeymyzYBG2hjIicuw46CxmbSKGDyH1WJR2bJI/DlRnGvrw5Wgz7h+M4AEpctIivyxDpvv47wK2cjIr4vtlZA/E5uo8Avd16ADNCPJmxJKITC5gpz/wZtMSfwSsyZTXGbMchHJjjzJ1wmMo+xQ1SDuyqwG0MqHMtx1Dqwo1VwHdfuHbMq7ubxHpsz16LACg+yIOsu8PKrvqVRwrQw2pptniJv+dIAGygC8EEDNGAyJutC8b0dDfdhl31yKPdw4AWx1ZrwWT5oOB9uH79yWjCr9KaBG4Uf82qA/8yyUC5j60fX8gWINAmQtAwcwYvtAf6Egi08BjEH7dDWDhECsPs9MzQPpTGvhDUDcNBFKqhIqVUC9a4wHaaCc9aKMx+b8x57qQjwMTq7c2wKLDv72GFSLBQUm+HC7MQurCGysO0erBPA7ShAg8Zq10T9c902JzYetHsp9PjWLkRrsFodL3NlhcJYdHLIAdzmtcvRQAhQ50cDthRLMS2L9EiTNAnIwAu8WDNJwmIwBi6UjBifxDQYc2VXM3/8by4UxCeQQkEcBI1e9gJfc0+/a1Bvc+vawL1CMEAW9SkftQQ7dFInrLRSQMK2sFOD8BZCNW6vMztpBdku7CsfMlOncP9dQ0EJ9PESH2wNqEA+90Elj3VZnzUquBFgpiR0Et5xtBeVtY1rf7PxKulEjw9DMlee4qlF63V1q/d6QzIQ+LW0wi/kBnZhTwDZIjYIIPaLWZHQKNEg+LcmaMJjs3RLuzTQooO3eis1d25oV2bvCEiCMzgnjnbqOqppC6hVcjMdy65W2u5ry/Z7S2tIX4AqJ/fufnAge3Bvv/O/zckOEPd1MC8vuiolXDVadYUSN3dSh/UwjPV075ogYlR2l2zLmaEph1GNUAuzKvl1SEGTL2txJMd6a7eUZ1B7o6h8z3fj1rd9e6lJv5iX7zcV+fd/L4ZjSAMxu4PPurRkh2cSWnb/aGOz/JH2tt1n1IERUVfqhqdmh5MzbH+4Edf2LNcyYasveINwjyHgikv1obfzXbAmXbdAbe/iOim3JKevVyS6Cih3CjS3PjOOj6t3DNbN5giiCJlh181RkidMwtDJXqO3q0d5dfvwI7iRKdk6ezOBCmy0Aww6YPO6SHP5Uiu2fn85UZCLUt1NY6/0gOvvMC94SzP4eEo7ZhezMev0hHMi8bA2FcLrtmu4niMpn8f2KpMtbTfuYAN37jb6ovO2igNBebs3is42Is+1RicuUwe3E6dACtQACnD6cjuBemOCMYZ6iUoniYo64R6awlOH4GoQrO/19U05C1K5wPcBlTHU/8VjvCKoNxvsJkXOspbTt1+jpVoSu2KDuZcb+6wEDZI8NjATuDPElGhBhrRPuxq/+ZqxdNNi+5xHg7f/tGnneVWBe2v/ebkvLuMqJrZKuqEbLu6O01e981NTfdU7rNXfUa4L+40HtxWkwSFmAAaggKtaAfLuu1csMb9LwUUXDCb4ncHLCQcFuYmqKu7ZdcTvNRwcniHovW9QPCC2AcXfOsVvvBtRN3VrfJ5gUOGjxhIYKONOAAkgfZf3eWJb/lKXtOXfI279CFTlhErD/JnLvMzXPC6Q54KDQ+eiw87DuTTAdM8P0Q4B/ez742pDXdGHu4ej77w/QIqG/NJzZ6Hrp/9yY7o4IToWJnqiW32Kq3jBmkGMtwDaJ/L057X0LzGgVycG3HgJ7PvaX7QbEUzBm2gJTUyQQ/J5o7/0VkHEg9TfF4LiO5SauH1v+PDJ2v+uIf7hX3wPJz5AUBJoyNCfP1CGjFB4QYMGEgoVqngxkaIMiRAfZsQ4UUkWLR/dhNwzcmQZkiVNSqq0MhSrUy5tnXoZk1k1Z+ic3ayGDqfOntWS4QrajGi0Z0el8Wym1GjRZcaeNj02NWpVqlFZ9LCxdYYPrVy/gg3r9cfYr0nEbkWStizZrm/dwog7V27aFhJPTMx7UYTChhQmBHYQgfBgww0MFFC8OEIHFSjqDnlBg8b/ZI5AMNfQvDnzZhqRQbcNPVoy6R2dMxsBUwdKEzAIR2RoKJv2CciUP2d40Hh3YxQpIP+mIUXKljTH+yQ3yIZ5nTfO30CRPn069ObX5TDPnn15coLfC4VXdIk8wfID0ZM/n95QqT6UUPVxPxBTfFSU3g8Ebwe2Cr8RLarIIow04gCEhQrkyCM0RAqJiDI8ehDCCfUQiZALI1FJk5ZsKSandnL68KcRd3IKqaSkStHEq1S0ikWzYGRLxhijEAutG2eEK0cdxcrrLh/54os2CwQrzEgHDkDSsMUWmyADH+Wi6LMpR6vhM85QM61KLbPskgo2nLiLCSfIREG2ByywTboS/zAogQc22oDizAdQsCKNzyB4MgXihkNOue2cq0661554rTUosNPOIPEWBc878BzRL1JFJr0k0korZQ89+eTDBL5NP92P0T+cM+IFhwCsKISN/jKQBMAyqqCCAxVSEA0qPFow1wZDapCMOYDVYxBJNOTQpmNDDCZEZFc8sdlnh1qmRRejidFauq5tC8cdecS22xZyBDLIIQMr0twjDTOSscCghOFKK98FIl4vTxONS3u7rKteL8kE44QLVGADv9zSfNOKHTB4MgMe4oQsAwyG64uBiRnYUwoX7PQzO+lYc41MhE4L+eNEvXtUEfPoO1nSSwi6dDyXWS7EUkozDbWU+/9QuS+9UTB5L79NxSsouVI1ExAjCjLiAFalmb7gQKddDdDWW7UYqWpesQ4pWGGFLZamnLDBZtljgYK2WaismlbtbL3dcVutcsDx7bbpBvfbrMQdV2Ii+eYtXXQLo+0CJAVI0gKFPLPSMsqw1GzefO/FF/LUKF/CCTaAUHpVeaEoweGE0WzsgAdw24EGNnszoLA8H34TueOsqGK6JkSu3XQytfPTu54BwcT334FXbzzhX1bZeE3TWy+5UuqjZBT8br6kFOSpJxXXipp2NXukm24I6qdpJUL8BW/dY0E3yveiVwrXX59rDFsyduxjzV6RRWe1yX9ttvmncW5u7xbAu+H/RW//6VtvzgU43giOcAUYjGMes5mJVGZx+nrc5CLXOAxixnJmMINXyKSCDKSgdGZCoG9OkLDbnY5iedoAD1LgQosxR3ZViE7ISnCaFIrAR5db3vFONjxMbGIUm/CdEZnXPOIZYmZBJN56bHYenHVqetN7z/SgiLLkgYcSj/gDGpBwNAOCr2kVKBdDHELGh9hKV+hro/rYh7VfTQhCJAFF/OTnoaKUrX74Q1FT/uiUrPSPkEoYyxT+txZ8CdBu3IJS3vrilzMdUIGAK1ffGtgAduElcZVh3AYzGEou4W5QMBDhw9rUBkVUwYQYOAEUGvYAV9LgOLmRgAR+g4IWnmCF/zzwpQ5tA7rAvTINrphFERmRzCMSBHhJPGLwzpOpmj1ReML7Yc44xamcVe9nKtNZNw/hnFMVaHtQO+P3zMkQWklEQnTMQhfeCUd31hEl82TfHoh1x1DQryaAHAo6XBKtQA50f4UEoP8MedC6hQtvBCxgByBKycAl8EgMuGRDENOkzWkwOBz1qChB6jjcMeGUGkDgDtxEGc/NUpiEeSUMVwqBBEwMATWVJSqFs1K+nXAwKGDYJox5TGUOtZlF/V0sFjE8pVKTqZ8iTxHdEz1PbRF54HwUfuSDilHEx3pEWEg6wVpGEKhTjRAZ5Fl2Fc9duc8kDhqJhOqZh66ppCUAxf8jQHfijH2aiKB9HUpYKmLQubyNsIRsZLvOmli7QfKh5AIMRSdayVZl1IEaWFUEfZo4zX40pPfaVw3G1C8YdIAwE7PAw3Z4GzPpxki70Y0M3SSB3czUhag7LUpBlyQGJCYCiaGT6/oA1FkMA6qMQCZRmWfETiixmuqZKnObqx5U+E6rW9WZc6mHvJ5hk4rb5OrQPjgCqBGmnOX1XhoTZJGyWC6tb8wCScpABPNJSL7mo+Mcu4bHlrjDrvPrJ4r4SdBiNEMGgA3sYBdqr8ImUqGHtUtDGxvRVoXOXCYlL2Qv/JdMOqAheLngBUHJ2RBjqV8fHJJPW5NaN9lpBRbQLcT/pGBbCaTgClZopSxJKFMEPOAAMIYhBlTn0xhyeIR8SgMmdDELaBC3uENUrlGbm9QoY3e60qsPcx8BXStLVyDR7TLPsgof+1Q5ej+rQxNawDfzdu9p5zUQq3JwGdWoFb7pk+/4zFcSlFSoQmTgs0p+4o516HWvewRwgPFHFLhRZNGXSTBb5MZgBT8aLA5ebITV/BeeTviiRdIkkR87Acoi5rLBudK7QDzizvKLTDpELZvIdQI5xCmmapKtTHksgS244Me4hoAACpeA0fnYBTHcgA5ooGObloA4sZMDI5a8Cl0c14jKTO5yrSzlqS4CqVMmM3QZ8W0thyqKlPAUp57H/7zo5Wzd5mb3N9EMukwTaYwA88/SWJWRF8xZfB4s3x74UGeSiM++bT0Jn0dCVzwOuiV6ZBaiHd7PZBzY0RVPsCIjnVCNb9ywkVEshB8qSQnPu9Mlx/AleztqJzlUxKtWdWemVOIynSBPPE1Y63x5SwzMdrYDkKXOU7ABndNUAbS9dQmEfsvdqo7oEcjTzjFghU6sYhi7WHK1kevtS2h7Ec9tJlRNQd0tF/G6zk23esCubqmOYtrPc94q3G5unh3RFHDvRCFYyUnBPearfDEVwJbAAlZ5RWr+/qAZwglf+T4iFIKos8HzfBI62hGPHfKQsi4PcWnUZMAfp/TdMB56jv9/3tI6euSPMO1YTpvc5H9Do6cLEIAAVBaCwAFOy1++JXdxdF8jpYx0MFdaWb4J1hIwHUxvLewESACGsr2lC7iwhRK08Ng32ICvda2D6ze9prrtMbPTAIhhiGMXQiXik72s7ejWXRe+cIX7mWx2ts+dPFqddpcv0X79t7+K0+a/L9Rt2jxlPAJw/+yuIKAAEBThXxqCCgrhLpTmCepgVQ5iBGCgICBQIdjgD8bpBeoAFQRBfORrFB6hVBDPi7yoFB4hz+rI4FqwreJLBCGPQ2CiFZQF8/QoBzvP8yyuwbRl9ICQ9EqPBRgL01aP5I7wXDTAjFBOwxBD9mjPwzBr9+T/4rOo8OVOB/c8gzlqoC/qRA5QBwJ0LU6Sr00UARCkQOlkqgSib/pmavmiT+hwLeh8bWI8AAeKzQNSQLa6L0n8kHSsQAeKgxF2QRzIz+6WKxG7bv16x7ne7wCXq+2sjO2g4eyeyv2USBe2Id1GYROdBwDVo+1Mwf3ODu7gDhNNERGHwRWkIKKcABPkxCGYY1UogQ1IoAU85QQiSgWkByMeQRdCcCKooPHMp2p+0fGI4BFQIfLo6eDo6Rkn5EEOblhYgiYsDweDgQclqJEuTvQyTitEr+N65LAcKsJULwnREbJCzQkNAAqJbFVSYApdDnImSAtNB0wyAEloqTVoQAJQ/0mWeEy3PGfGek3p3rD7NmAPSSj5gq2FFsAOjYMHlG10dmPY3MRzpG64DlERsa25OnIS40/sRtG6SoHt+M/s3E+qTpI8iOsTHREASwH+5s4VTnEVyMO44A4nlWwUaIC0nOB5TqUD6oANaLEONAAXMSEDgSAX1wgFKcII4gOMskAQvOiD9gDxJMEFXVDyGqS+Cs6eGmRYiKUaZUIbe/DzOC4IxXEIL00v9GZIzjEd0fGB1JEdmaQxeKhdrBALHaceQUq08hGihAP5lM3olG4F9NAF1NCmio4BnC8hPaDY6nBiZuzois0g22T6BkC3Zoth2mARCvEREXHsnqqZVhF4av/yJGNS/9SuJFdyNZUIFX3hJdkvJaWHJqnOJp8JqqqOuJxANl7REH5TKOVAIWrxFu+DCVAlOCciBIxgebKgwIgABPstC7LsrfZgBZ+x4PbMJOprfNpJntTqvvALfS7ELIWQLLxRLX9wLcmxgC5L5FYlLtdRLpPQoizKwvTzAu4SL/VyHu1xS0QrN4rD9uzEBXiuTXTgChA0YTAA+uIAC5LPDrWvMUdoC3Bg+4puxvSQ6CCmDRRz6GZq52gLAvbkCj6T6sqPJhNRFhJx7KYOJmPUmHaB/eau7QSwAFXTNj9RF5AMFKkLJmVyRkeRyc5wqHSTEe7NCYZGhOrgD4zTFi//kBLAgN78wNy8SgUQb0ulsw/qADz5oBRCcCTMAL7e675YME2ZEZ7ah03FkwzgCU7pi9HolCPqtBvZM0/R88GKphwjaVX+QuRGzj5ZrwknAD+V8LGYxHBqDwY6Svc+6nEelbP65XJ2IC9Jy4VoDeo8ZwUYMgE80wOcb0PlsDEHQNfCQFQXk+m6j0NTwAUWtEF3jiJHlMZqzAoUoRBXVBGp7EdrMxJ3ARNkoSV9FUh9x/9o8jbjzySRzBVQEyYfkUVrlEh7RwGJY5VSoA9OCQq81BC6cBZF4DhbwBBmkQNUwDu8Khkf4TmDkUn5YHzeySkZRM/iiDvr1Z7cNF/f1E3v/7Rf3cLzZuQb13PS9rShUM8tQw5QB3VhkbBQDTWyGmM/N8w/JxVSuTFAPyq0ECYfma60VGogSbREaWvnXHVCiW7HdC4yJfMhE2Mz39DnmK8NrmAPD7JmZUmXMEARps4VyG9aXXTsZNPubNP9lBU2j1VIZxL+WNNXf2ckfXVap7XrjEk4UScExkA3+iDZFqYPauBgRmAoD0c4j5JUONACSYUSsjQ5krEP+g0ViFIEH6Qqy5TgmrEF7XW+ovMr22tf7algBSsI9dQ939NP51NhDZdh3SxxCTXDzAVRMekuD+c/ea8KIxVjRcqUzGXHHoaESAhWh+zobmBmSRYyk67pHP9TDmfMBXBg13DNZg0zpipS+XiOTjyVB3R2F7iBycJO3ZjsEaXWWX+0aG0TNmMy3faPFI/WNMMuWqcuWE/mCmBJEaZPMURACizqThoDUTpgB+TgBbLDbI3yOZnUCEaAW82AErpQBbzIe9dVfKgTtOLJAalTGqlgD+Bq8sBynoxgb/lXrfz1fxdqYAM3PduScA8XcRFYcR32YSUrddYlcuXRcrVQgy6nc1bFN2DoBDCGTWasDeIghhxU1wBBB4CMYjZgDBiBhJvOBVLV114I2Uy2Zmfqli5yARwUMUO2Dy3AdhfBF3JXd3NzFH20aIU4/3oXSHOUaFeTZ4LYJLGuE2D/Mmo7QWfhoARMoDeqAA4yYPaIox2LwyeL8wSyFlzJ1QK9dRZp6BK6sAa81ANLkAh+8m1l0FSUURDO1EzXym7pyM7gqH/HMxrR018J9l8FOBx9MDQK2IAjonB3ceTyRIEhmfUc98IAh8ImlgLyEkAl+PeIw1FD4EJ5AAP8EftQ9DKdL4d3q2KKzZQp5iEpBgEEAFTzcELr8A3F0FZndgFc2Q+7b4cRBgUKgRs2Moj5b0aZlpiBGACD+JiHFniPCHhdQRF8KU6Es7cGINiIo7eOAzKMIx+59Umuw4xbEQi89XLUl0zQNwScwG2dQBDedxSCEV77DQWjMY8hJDzPVH///3ifxxMJotNuANhvCVlgB/igEEuRP3nkaiOBIzkJGffkXE8wnrBwUKhiQWMvJzhj5QB3tJa1eE5zV+Ai93BCGdMgX7hDGdNU5zDoOLiWaxZiXMBTUbmX++YJjNgmhZhIkdkkV1HamMwAU5J4l3lIbxMOqkARzqC3GEYRJIAiga0AUEARIMAAws84tjkCvtkCuLeMT4ASoKB80ZcJspZrnQB9vXerlodts8BLRVA1Dg+OVdAk6jdC4ouf7fqu8ZqABHpP1VMtNm5/C9qRDDhh/5Q+G3qBF7gwPo0u/6JlZ0+TIMg2qiQeKYiTLKNxKAhLHiMeFWc4woQNNgEfTaiFdv9jAdxklUN3+lr32KRvhl84+kLUdRWAhoHDIF1X13aNpU2ARGfLBFagCbLYEejORmsTWUVR2ph4p0/xiI9WWp0VEPqgOBYwA8DwAARAAs6wqW3sqTOAqSGgDTg2A9pgBxwgq8UYE8JYmsG6C71DS7P2BYbms9fVAT/IVNR1bs2ABHFlv/PWrutXQj7oQaSynx8Ejvt7QbK0HA12r/u6PfOUPRkKBRCakQ+YofNzcVnPjOiygSfLsSFbHm+jHi97Mj6pcfwyUkMoORAFDV9rBW5AMV3c+iBgBRiGC0S1MZmv2FR6A8IAEUhYlxvzIfkQpoutpT96x1YslG31UlcMDib/sUVb9LiJOxKR+4iKWUbnD6hwuiaPVE527HJ2ywqaejPbYBNSgAB47ZpjOQ7aBBACMgJiB6uL00leEbxPABMmsKwnArSJ8hXDRG33PGuNgEr3bS0MIjrhugSvB7CJALDj99EhPdIFfNGdQFfEh+UWnMEbPC3/+pDp4mAn/HD3BnEvHLFNfcM5/MIJ57FXDrG2EV628cQ5StZFypPApEBly8XHQOhQeQzzMMhNdTNNVA/10CBdeUNpDNmKvLY/urRzLUV7h1dL8kWjXEahrMpdE0eTG7l1dwDTIGFkdnPvpHDA8KlLIAwk4LrjQCK/2woOgJasO0nsBKsNIaJQoGd4/0i9oYASnFTfBX0UMKcyzAAVPqiL3JpM9PsE4xlu7VtC2gs87dfA6XriJd0jFFzTGe3BGz6wL/ZfBzv1GplhS51QD1tiNTyBLpy1IDeyLzqC4lEFKOj2PC6zOZujRkoKovtJTnsFXNoPZ3vGOrd0W7kxUTZ1VVVkXRv6eC3oeECmz2TGBnHqzm93qX4SpccUhKGYpR3J0m6IUrEmWXS5NloXHbWmog45UiACCodNBAAAAiABPEAB3D4DFtQ4eMxzCCDvCwADoIACuLc2YoeHUmw4urCCQ8B7R0pKDuI58QMF27kPUBBzGJ4K4JW/87bA+dvAFx3S6St+4RhhMV3TAf+3v+GV4z0eXEK9cFVfUBla0zB8LiH6wmgjkxyIITJZwiU89IPDLyvjUYEjgj27MhL6UF1gEawgg116+ZAuISE07oGd6JfP6G27ZpEu11FYlcZAZqOd6qF82m+mNb3//1JR2pEo7Xa3Zw5GwiuSAAiDMUz1qRND9qCw7d3eZfU+3tnfcPBSYRQGIE4IfKECxo4aKmjQKFij4QsaRBy+MGKEIBAlFCtONMOxBpGIHxt+DJmFSkkiJVMS4fjRjMqXK1NSWdlSBUEZNlno3MmzJ08fE3sIBUoUIxKjMJMgLfqjqY2hM6JKJXozp9UQWLNq3dohq4avXcGK/cpgrNkIZCf/oJ1wlq1btXDjRphLl0KGDhrmNijA14GFETZRBHZYI8XgwzAOh5BIuLETJykQhngQoYSiNi7gtFmhAAIGCRskfOaRIoPnFDpcbPDcGYKCBZ1hJwDtQnWJEq5FIziQwPUDy502CR++anjw46YwlVrOvNSl5qair5IlfXpy58pHYdq0XbshOVAOZojAt7x5AegDCACgPn0A9u/hy29/3oF9+2zv2twvIvHVglhJdhMNDS1UlVVVaRQUSB6RxGBMJ5nR0oMoOTihS05AiOCBPnXo01FMLWVUhSKCOOJTIbag4or/tcjVi1iFJVZZZrUFFo025lgXXDvGFdZc5vm1FYAS/wkGAwpIOrRhY0k2VOBjUrDBhmkYoJACDzxcYdtpJWDgW28JDCABF1yoJppvuUkw2xVl3qbDFi6IVqVCVcgByHHG5YkcdNjFolwqz0EXXHXZlSLcKN6lEd4JajVgnwH1nefepPPRh94ABAS5F3526QfjVU4OxiRCTAZl4EgLRtQYRSNlEZKENEXohKsWZlhhhhWxqtOSCXroq4klBqvUsE4ZheKxTLkowrLKwljjszlCO9ZaOL4l17U9/kWBXuXZ52lBRk6U2KhWFgYqqU4qpBAbiihCw10WrCBFaStgyYOXYKLJAAOgbeBvbWe2lu+ZD7iwCCBWRNnGnXsat12hg/9eBx11zEUXKMTXSYfdd1AIRt59e0laHqWVVnrppQek7Cina4E1JLOSCSTgqOLSzJipDHqks84TspqhrUZIeFJMr06I6tEcbmjCr0VZBOzTwkad7FQsDsTfy59yJePWN0rr9dfZYhv2th8HqcFWRiIZ2NqGCYYYQQYe+aSdf0jBwwkZoGDaA55laVuXnwUuZ5opXKkm32Hy9kCVbejpeMPdEcpnxpRXXtzDmHCsN7crRypyfKCXfLKmKrNsl8sBvkwqgujS7PSKyOa8qpM83xp0rCjZCmvuQyONdNJMU51qisS6mqvUxk7dIbPNZt2VV2aVFUJeNU7f9Yw3VqujWDv/jo0XXCHzZVfqMBtpGJEMEam2uA8dCaUhjGwCSBsdjwckBlrWGce9ny1+2wr4WpwEsnQFem0ASzdY2OP0hDHJLUcYiHpg5SZ3OUAUAjybe5TnwkcpkoWuPQCI1H3qYjrUbWVma2vd6m6mENgJb1UkIYyqfHY7VP2sJceL0O9wwsPlBU94L4AK8ZRAIhpCDVjIcopUmnc150GPazJigPX2NRbpPct61wPb2LIFLw1eCi3kg1lCmkiuuLlPXexyhStGAQhFgOduApyTFe5FMIJBYC4W+A3DDnanReDpcsiBnAMlOLHJLac4GvtOFQ6SRweIzHPn+aClRgcpSK2se957/96nrGYRm5nrkyxU4uxmOEMnzYREK7GVDYFmklaCpCqvVFqvfvg6IUbNeMhLogtZxLwm+tKJUMzL9IYZI2JiUStn+9r2xIbJbVEvfAEwwFrEeLXILGZtiiGQY4DABkQiahWZ44FvVsCme/0PgIjjWwYwwIMqKDA4iAikPKUjyIhpbJAV8yY4MyeHOuitkY4MUsogKUlJZuqglawkyzI5FsBcDYWpqxrtbuZJuZGSdqWsCEo0ersG3RBXH9HhDnsYS1hahJO8quVQjphLESnvZljrJTC3hkXsNTRGyTxbMaWozGUyU2x3DCh9wHgXtf2zP0hdTLhqNqodQKEQ+QSnIv8WCUB2liCPn3HnCrZaLzbtcZ5gBas+HUjWQ64RE/2UAiO9ONDPeRB0BYBrekg3Qmky1GUmfGiLMCoqitYsKDBs0EUnKpLjqZImNryQKk0qS5L+6odTYCkuJyusi7yUML+U6ROd9byb6jSvnM2pZ79Sge1x6gKopctC6bKvfQn1ixPwTEyZZ9Rwye22YHjqNw1VQarmUZ0mgEMn5rew54T1uMitzlgnGMFwdkm1CD3o6N5a0EnStXN3bShorYLCFva1QCrUpqpUCsNalVejqgSpg065QyKktLE+hB0SggisyEoWJhxF4i4xy0Tm0VRGxBxtMbEiRa0NM689xZaCsTX/wu5R5rUCsOu3kJQ3mTbpbQZ5wmNKoYvlXkKRtzmDOyN31uTak7nzXK6KMfFhKS3EAo+UFAirK0kOdu7GDV7wFUegU6xB9KTfberORtnUjG50ZzgUiXo3apL2As8iKn0dSuVb35WytIgspUpQ2MfLzPpXkwbOqfVqeswehzaZZU4w9VIbFzZzLseIAxJcpQkvzbpNfbeF3UWc8AcOr/gSbfSjiTPWCYpd7Dh+EqvkxspPKDhaXfajpHSpW924WnpTOG4wp3xqZjDHdCI2MZCUCQuRAcGQqQ8K7EWP/JBUHnlWvUMVfRkbZV/hhJO2tHLxjvISVrHKQZcFtYD6O2AB/38PdSYEbbJHq+ZrlXYCFdC0XjQozda6NqFDNbPVtr1tITfBEKbosIrvabkTJ7dihTa3dHzhzXYp0gnmU0gI2GppStM4uji2K36e/WyzlLbfXwHBdrXSw5uosHVBzihhA6vqhefweBvlde8ES/En0xrKj531fXuNZZUkCwZaVhKxzxzMmhr7wGn+2gc4DXC5SPtjMHctpuP6ngZQsc7lc9v69jsEp15C3OMmK8Uolm4/UefopSC6oMi97lUoohCLOojU1bWDhXCQxqL7IL4zDfCW+1tan/bxsBPu7YmGxOwyNGUOY1jEh7tyvkcr6Ufeq/GL70QGV45axPfu0pDDdP/knk45sgeP5jE3u0Ze596CF2rJuuqbtSGzlKM6pZ87Ayjnem6CHPzsTQhGh+hDj066K0ed0Ydb6Exvo2/BmCSn2s1ADGjAjN2TdRDWu1sIvWSj2nx4bRP81kNa3V6FXOQhM9zhDclI29suk4zQ6nfuvYmThyLlWud640tp8vJFCXKMA57kx1Z2j8Xc+7Ek3pkLfvbLpd14GgEJUpKPLc6XVdSd67nndTiEn/3seemEfhOhV3qDEoAoRnQf1gZwIAc7IAJ5kTJooS5XsgMlgDcfg3WVlns4Fnu6V1oOEG3WcnJjRgJhpywiR1EHd3zIR2QhkVj5BXd8JxPNx15nF3f/wCZEPeFYO1FlvPaClEVEfPdSoPZ9nIVT4TdwomVyvdd1bHF+i9comqZvlsQjCABdfDFUcyFb30JNMpNhPrcKHQZBYNh/R3d0pgd64YZ0zCEM/3cZVRAeVfcu+vYXEYhF8Dd7WBdd0QVdjucXH+g1xcZjvjeCHGKCgyE7C5chyVdKikhkasd2brd3EZcUvkODded9TJN3Q5OJHBdsQCaEwGRMn2V4KFd+5ddm/UZCk+eEdiVNrLiK9AZbruEpE9ZtPbcEdfBznKeG/ecKu+AK1LFGvliA+SRunZA5F/QEWyUzj6EC9ec29hN5d5gp9JFQ1Kh7j6cWTOhZTuRlLmJw/ymEYbOzcH+FgkOWajpDK7/WSm+HjkzWa7VTOyYya7dmUtena5ooIr+2fdxniZ74if74h4RXik3ITHvYgBoUMo93kPHXWvCCAc/DbXKzBH/ghWoIdMIQjMCobv5HkRVpMRdkB4skgSbgFifwhtpEfxVogdNYjdWYY334NaJ4ICEQfarzSxYXhOOYgqcGb0cmjgrXcMonEy6BBpLIfK7kaztoX0cQWUdgZfI4FEqJfUnJg323S53IjZr1jzN1YIfHbyy3WruHSQnZeC0JMnU4jVSEhesEkU1xi17IkV84hnKpXG8JdM5xjEtTklW3AnghM/8jAkF1lgUFSWXZflu0hP+kBYJztyGCCF/eiHDeaIgZ9RBGUGqDlXyE9ZNrt14cQZQxSInGo46/xpTDEllRMCxZ0AWq6QVJgZqYKJWnNnJY6UsEsY1/iFMC5zW5iXjbA3AlBJZhuYdkaZhyNikDgACdYQE4V1ut55a6UJEXyW5fGJedp0Yd5hyUkFYzMJJ2YRDq4pfjIZh3aIW4d42/mZgw2ZizeZOjZn1PWWqWFZ+VmV+GdTwYlTP4KXFMtgeduQcwWJSo8p/2pRRksJqsaaBlkKBucKALiqAOuok9mDzx6FeyOZvqCX4C+ZVrNkLqV1dm+aHlqVDXthvrAR+7sS8N2YwMUXWC4GfP+ZzU8Q3/sjCdL+oL7GaMbBAeTVB1O5BHXcGjFNZINKeStzdzlwQya+GBDlAt/LZyfbhyNUlsT8Y6o0ahaEcE8Fks8TkSPEmDD5dqGrVq7UgFLgGD/Nlr92g8e4ASD7qaDfqmrAmnqZmgD0qVr9k0/FWhFzqCGNpT/fZvGlAB2diHwLmkPGKkLFmN+UKic4acatlLK0IFj9Bh21CjNmqj0XmdpWAJdqBhQ7ATVbcoeslIasGoKil5XBd7PLJ7G1pCfthj0ec6sfpj38gzr5OZ5OUzV7oUieh8qqKPyiemkVim64imAMqDdNqmDJqszKqsEbqDm2ksiqGn3ZhZtcmnY4aEKpeh/7z3TAOJqImaKScKJoljnN7ie5HKLpk6DJV6qdZxCX4ABlmQjGlTdTsqdRR4ddFYnkc6F4KqYxPQAD41illBk+9FofwIjue1M+KVgrx6jrIzWJHYIL3agmbAn57JO8Yqic/XKqtZoB8bsiDbrM4KocIyg8qzntialXsKkAGnm9nodf8KsHzYhAfJkiF6nI6qAKZqhQWWFbAzK7ZICc9haI7gB0grrzmQl7U4dZ86Apxjb41qmBuIft0KbaQ1qKGINbOKsNXKj2hHjhPakz7QUkg5sWObKxVLpqIZiRsrEwtKgyIbp3PrrCTbpnfKVzhJrXo1rQWLFcD3j2CHnubXlVwG+VPrF642Fl2LWq62xxZYaBWGlX9IWweW66lPqxNNe6/cCWF2aFAhiqQeaIpa+5LbZbDnIhk2ExHcpboGZ4JiSxRiO5/GZ59kG6D0eSud+Z9vK6AmsQdn+hEBAQAh+QQEBAD/ACwAAAAA4AEOAYcdCwAnDQEtFgYuIg4yDwE0Gws2GAc3HRE5Iw06KRU9Mhs9Si4+NyJELyFFHQpHMxtIIw1IOCRKKBRPTDNSHwdUKxVXLBZXNBlYKQtYSzNZOiNZQypaLhpaMQ5cMh1lKwllOSRmNhlmOSRmalBnUS9oMQ5pRCppSzNpVDppW0Nph2VqOyVsQhxsUS9wblN0QyV0RCt1SzJ1jGx2OAx2Oxl2PiR2SCd3a1N4SSp4W0R5SDN5VDl6Qhp6SzN6X1B6ZEl7RSZ7Rip7Sit7US58o4SAPyGDPhSESiaESiqETTKEUzWFVTmFXEOGSCaGWTqHZUmHfGKIlniJRhmJSBCJVjmJWTaJbFKJhmiKTSuKVTWKdViLUiqLWjqLgl2MYT2NcU6RnIOSTBySTSOSXkCToX2Tw56UWziVknOWbVGWfWKWqouXViiXZ0aXd1eXhmiYYzqYglyZVRubcUycYiycbUuczqeev6CiXCiiXRyjXDKkbUimc0umfWGmonynYh6neFaoaDeog1upZSmphmWplHWtcTuthk+wbkOwvaOxnYOxro6xxJyzbCqzbTazfFazza22ime3eEW3hVi5kmy6dTi6g0q6mXa7cy2828O9onu+gT7CeS7DezTDfULEfDrEnoLGfTnGnHbHi1THo3vIgzvIk2nIl2nJqITJvKPKh0bK3cPLhDvL0rLMk1nOkUrOp3HQt5PQ4r3Rhz3R5cjTiz7TjEPTjUrTjlLTxJrVkkvVrIXWkUXWnGbWs4vXmkvXpnfZkT7Zllbak0Xao2nboU7clUrdmlPdoVnemUzhl0vjmVXjm03jnVrjnmLknVPlo1vmoVTmqVzmrHXmupLnoU7npmXnv6Lot4fpnlLqxJbrpFTrpVrrtXjr3MTsq2PtqVztsl7tsmfuqFXuwH3u0qzxplfyq1byrWLyrmryrnLyvYXy7NDzrVv0smP0tGv1sV31unb2uWr3w3z3ypX4++X5s175tWP6u2z6vXP6yIb7wXT7xXv716b747f+0Yz+1JcI/wALCByAoCACAQUr4OBiZs6dh3fCSBQz0YhFixQpFtnIsaPHjyA90gCJsYiYjliKhPhAwQKGDyVqBMGScYtEKTiNNDnE81Annp4a/fzZyCfRRnmSxsm4Jo5DQYUKkUqVy9izbVi1ZS2ndWtXal/DgvWFjBjYaOLApV2Ltq1ab2/byZ1Lt25dfHjzotsLF1y4cfoCxwUnOLBhefsSK14ML5xjd3Yju9OLN19expfhaaYcb3Lne57Pie5b7WrZXK5S71ItbFlWYbJaW3VGu7aysrZtf9tNN7PlfL+DAx9O3F9x48L3IR/Hrbhlbs2Hw3OO/J/169irSweuDjHx7tsVb/+Wxk0fQYPoE9pQ0lQp04xhLp58fzKkfZE1RsrMr3//xon0bSQCBS0RGMJINNVkEw0z6ARIT0IVxZOEnRzFk1IPLbWUIBwyoglVZJmGTVhclUjiidCghRtuu7H1lluP+SXZjJ5lhg9fvBF2GGGD+XUYZoxBFmOPvdW42ZFA/njkZ0yGNhpcIp5WFVlTpviNMbbswmKKuXWpW45GKrYcdWRqZ+aYmlE3XXngUTdPdnBmJ12bdIa3nTR/yZNeAhIkgIAED4QwRBUNQRQRgDfphFFN+PGn36OOQioppBxlZNJ/KamEQYEwyXSETaAeIQWDOkFoalCeWAihe+21BxWIVrX/KKKJtNYqDpfUmJXriii6SCSNQz5WmWLp4Jinkj4m25mSSQb7zpD2CAnatEsyW+21TTpJWpQrSlkWXL7UEmJWXrrWpaxwhblYmeyeiaY80Hl3Z53H+YMdP/jGad1v9JIJ3njk6ennwAoUHCgJgz4FEaIAXqSTRo3GJPGjFFN8IIMrYbyRoiZpNB9Hm27aqRChrvHpqA2KAchQQKUa1IRDHbWwhhtKlRozV+Xs1c624jrWz7qG9SK6YM74azo23mgssjLKqI9jzDbr7LNFUpv0sL9ZW622OneNM5ZUZunKt9CspkzXy5ibdjFrn1s01mK2K7ea8X5nZ5n35quvcdGN/2m3nfpwM0yeBvdJ8AMbtJCwUxk2rNHDi9YHcgmUw1Q5B5RjbvnmK3EO00se1fdeEpoSKDILn4Jqcn0pmwrU6z4BVVRRrGbEISVUec1zzyYC7TvQu+fYV9OdGZ3usDuGM7iPTBO/bJKYTe28kVYHnrV4yB6mF13PgI1a2GHTQhWsr8nmc9vJdDsbl23tBffc8A+3XN1/Ayavm3nv/U8+9Jv5d5CDm84DDlc4xLHHVYdimMPi47GNseRzLtmcBDXHEgo8UGQYiOAH+jMf0WWqdKaLiRRAJZEFGWGDSTnV7GJHIZllqHF48NDY2oKz4PFOLOj7HVt8VbTpReZJVwsWs/98GDV5EUt60RJN9a4FvecE0TFRElsqpkJFKl4Cd7gjH5XOV64u5kyJ77ub3Nwlnb6hKTpGlF919Cenur1Jjf+TjjQGB5wBJsBgeAxU6lrFsJM4bFEd+ZwFITjICxYSgyE8Xef28x5MbaQEITsdD1Rnk5ygMA8tyyQLURUhQLCqZuSz4Q17l8Of+YyHRPMh95x1tcYMSWvOKyLTkDiXJV5GjE+EYve+N74qauKKlAAmKSiRKrPhaktns0361HdKGIXRO4lZDhmnyTc01u9++GPjG+c3nX1t85rlmeOx7IjHAr4AVIbq4x8r8sgLfsAlg0RkPOcpz5jkZ4MoaeQjI/n/EtRRMlEbFIMeXFeUVEWIEyukXTqdkrvS6G6UtRpRKc/SzB2i0nhUAyNiKLNRXcLylbKMHmmAZcs4cmdJQoqiFGXhyyr2Enw1LOVtlsnMLvIGNFGLHzX9ZtK5aVN+0AmYN+fBrsQIrhrjNNgAylkwEyRooe/5Y8cml8h3EjKSV+WnyEhWA8r5h1FNCGtXTSfJPULshBbBJCVgFomEsnWtjOBQ46Byi2Csb0RdOxHv0Gc+tVU0lT38IRCNJCyjejRqsQzpLJ9ExJLGkTNQOsZsvMdLKW6RS5ONKbkwi6VS1hRXSEUa3JCkHGmOUTv96ym73sjaN2bDOeLEpknHE0Dv/3TgAeRkqj/lOjNEQa5h7YSgVS/3uXdq0JCnIxnp8ImpBjaBQSGDAAYOBIR/oiygan0rJ4PJ3bYi5YV3wF0wHPrQXvWMpug1l3kvGljGDrZ4hVWa04x4xBgptr7QCiz1nglUo7oyspLNrIBBS17vDZiz6vvsrnSmLszolIzZMKNq+8XTfLw2jrGV7WMb84w81RG35FzAAgy2gqdC1bfxeVh9JJg54kKycsJ98UsgKAQuLNeeHXMudKWbQQ/4s2Qbo4CD3lrQ7Xa3EXF9oVDGS14a6nWU2EgfMNLr1/UCFqOCncxvOhNa2QomsU3Ery7ftl/+hkdpoNkWedfM5q7x8v/A0DAw2+asYNA6VsMVpiZzxlFU1RbnwsAB9J0GV40jdYfC3HFHhoGzgQ1EwGAiVsCIFSCCA2IoDI2zFOSmOjkRCIgGBwp1xkYdAgq2mHI1XkJXmRvWjz2XBsgVYQmdi10VZvLIcOWQU5bcjF47OXh47dXaprzMW6Ut2FZOJZa5dxUtIyalx1KOmJ/XxMwES79l9pdiugNZ9107XU9S6c0ui2Dw0bnOaMk2nnfqTW7Ky39+9lcc3TGMenujWHgqVr8A1uXp5GMIQyDBBSYg4oIvYAIgIBmGEsjOTWvagfzplKgnLmrNURwGSSCdB0CXKR1D0gEY9KeGNB1QWx8U10j/TnIMO8HkZiJbs+sdNk2NrV6IskN4N1820aoHRC9DMb73la97wRgadVVYakVP+tBNg5rxVWkVu9gZbWRzbnR/wzPAMbO92s1uvv1CwvDOc54PTSfN6JLQULq3vk/K7WI5FEle+AEJSEDwBYxgAnVPnE0MlQf6OG7THuGApwcP6sIbnuKZE/VMajAgC3iK0yvelANA3oEfj/y5aFUZzFDOed56oq66+6uV45y22Mxc9KIcupNyzlj2ocPaPafv0wZz3y27faSsT7rRw952s1utWEqPLC+pqCWr5GIqmy2ft6x+jqQlB472aq3+/BFhawaajKnlff2g0+a3kxal1aht/17k8IUUkKDgIxAx3vW+hqT03e8M9NjDmfvISR0e8YX3saAYz/FWi6SCkcQDyhUqFgETpQJXcOVdnJdyeSBDyZRXqBdzpUcLbfMVNScrQnNldtFDu1FDckEZsVdaRxQN0SZLSYN7ZNZgRdV7wOdtfGEswjdFLnVuyNc9VpJzpLd8yOR6VyM326Q3cZIN1QcY3zRN2UccgkY34cAMdmWD3cMLoaVv3eZ9fPEFXpACEzAC6WdweGcDCPR+iRJ/86FiEOcfkXKG94d4IxMCBtJq8jcqHGA6lIcglLQRM1BrEzI7C5hrS/aAEGhKo2eBsEGBxZZ8NlciuVdLKIiBWuE+2//jiIaxHT9XgloTJEs3Grp3JNrWe0IHg2rGhGJDfORWC5ogDN7gejgoiDvIg86HN3EChHICL0RYhNgHdkhoUt2haJ31NbyIVMcDGi3Yfd4Qd+aHAll4cAfXhXvXW31kKTdRhmZoMWlYOflXQdR1AZsiKEjQcSP0XBVEeZU3KP9UBHfYINlVUOgoFEYWTA3lchQViMmXPlDXV/HIiMiGiDjHbDgHWrXUiVgXTVtGPJX4UYtYNUZSVOB3iQBGJU43LuuzCpeADOegDWRjj+6IimXmb9DHWtcBi7G4Z2oUJ9XhRtpHdmy3F+vjUH7oiy4IGcKoOCeQAQZXcMq4jAz3W37/F0hehYbSmH/3F4AvwIbT5YY4IVZjRVbUZVYaYTlG4FbreHLsWBUeqCLvWJVWuTsTOI/pg0OHiI/tZZGs6I/PNIna8332Y4lZgXstWSN9BoIwOJU22HQNGXrDJJFXgopg+VfN14obOVT54pHXIYuzuEYfKYsXZiZ1siaKeSO9yC0p+YujEXqP9mh4N5MI54ViwIzNqE8QR3g82ZNmWGrTZQImgI0g5ykeJ3k8Rl3jeEIolFBFlo4GVUwwd5UUaZt7lZX0KEr36BWJmEStF4/9uDT/iD32VZZMBE1Ch2325Wzw1lH/1XqNSVk3E3rRYAw1iJd5WVFAF0aEmT9/GYuv/8BnWzd9z/F1tMhnibkmidZ9vDhgn/iYz9AA9OloDDBpd3QwmXlpYdiMnCYSnhmNaLgfY+AIf/AHeoCgASeUdEhrPLaaP3YyPFCAOpGOneQTnDCbFcJyX4Kb8IhDu7AKWlkbvNmbvglu+tiBQdNswPheOBU38FUj3SlLnoiizbkZswUwOOJr72l84lIlBZZZVxSBUqeX6pZNf5mksMg/3PBaHak//qUPayRGnChfU3mKMwVnXER6OUOfIPalIEZd7sdwm8mZzEUpHyGg+1EK1jAP5CCEpxAIbDAEGVNdYAVrBDJ5PUaHOCETBbhBD5KHejgUxFQhttCEf+ihH6qbp/8XUWlnotopF+awnTfYouWAicUZkL9YGDZyltcDbcwpLfiQo773qD06Z6yRknLWPUKxpb/GmzfVJHDzndahpIA5Dq+QDa8oks9BnmaCoycZTm73gDuapVpqrJmFjYACpoFyAZVGEfxZpsBVf2r6adX6H5/AD/2wDttKDqOAoEEpQgkioR8HjhfzEX9aBGrVSRpaqIbqhzS3qBI4iCMKr1wBl/WonfvoquzANaL6I1nXnf9KbevyZcpWo0gDTqU6Zu9ZWQ3psFrECJfAdFtCqSdaNRrpLuCppPsynuWZPx9ZHofpblIarLeXTG8Jirv4JciapRrwsi9LmjJLmjqQBND/WjvSelYqYa1o2igooQv90A39MLT8oAuBwAWiSQNYkAVgVa48RocNMa7lqK4qFDMuc6j2Kq+QqqK6aXodaqIW2xX7qiu8QnQ2Wg/MY4ntAFnJKYKaGli394sZa7IMa6zD51IiKoO0ORuk4AeUIGcVG7axqoIaa6vaWqvWwRy6CoSAuXX7cIRk9y+9l29YilfBGJfk5pg6CLOkuQNPwAZoALpjYAZZ0HeambOBhKYCapQcpK69ELRCuw7kYLRK8GJKO66tVq57WgNZsAeOEAl6YDJ2OGSCio4byqFZq6jJdnP3OmwsBXVfixUPmJvRu1mfpZA5sljU8hjhRLBS40wI/9tgnEG5Tkidenu+54u1ZkEMlOC3yGA2NfWqeqUshEurG4sdvYALH/tTgukcmlE3ZccNj9qEL2i9PjpgdrW5MWsCniu6olu6+/l+KgZ/DaQTqssROnAfHKEH07Ct3NoPszsIShAyM6CUKSGa2ehpTdC7BupJw2uOeUgUx8tygfuh+YoVqXib8vi84lK9JApsREoMMKWv84s8AxujTHKWsrcPXPaVaSe+C7uQ5pu3D1slAxZXnDCIVVfDqad6wBqSuwqEQqVN++NudlMtZfdzCXw2oKq5ArbFc4aNztq5DFHHo2sGEbw6Odtw9pfBRUA6GlwEHDy0hFy0IlxBJUxJTP8LBEm7Amb4auVogCmkh8ZLw8mLm5PqlXmVwzpMr/Xam4V4Q/yag6thTDdoc9R2xKKayjS6c20st+M7JDT0ZrRcQ9ZZFd6QCxyilXAcxGmJgvsFxmH8D4IDHPfbRkEVD/2FLdyWi253WcVabr1cda1xAdY8x0sAunSwB8E7pjjbn84oOYe3uiGBu4NMyCDcC5CAtBxnBoGqBw+sBDtgx0gAYyyGBZM8qFfrhy+HyZmcl6nItZ7staGMFXO2tTdMyqVsygQmSttrtkJyo2ZpnL8snSyZkd9WvgH2mG0sWaWMM67gB4Kw0NOM0HjJYC8ohcK8N+TxJiALJ71KP81saCr/PR4qqb7h5sYJhqokfc2h5gS+a6AIesftB4ZiuJkvfK6UwgR3/B+kWygJCgnZgM7pvM4vcE6Ews3Ay81c7cCgWwWG1yB3eEmTnAcaqr616c//vNZBzDa18Lyf/HIFjZWu+r5vLT4OmdBh8dAQDZlJ3Mo4bNFftJYRrZbCaNggfdcz5Aye4L7mtsU+bJ0o7YKjen0uDdNCddnmmczxcg2T271bg5K30VCRqdOXBcdxLGqo8wbwDM9JYWJ5MMETzJnBhaZMfQi/ywZj4BOOUAqlAAlQqAtuqq0g7K2SMAaD8gas3do80dq6/dxe4AU2UV1Ri1ZUi1BJkaEbitY29Y5r/52IlZtD9ujJoCBl3G3Al7yl3gIMz5vX/cyd/ljYZ3ukxjF7LBmfk22jGQ0jiH0lxzdMEesHq0DKO11lwva1ahkv2ITZhXYmfrlN8EBoUtiC+oZvvmfTpWFgpsqlkzXNU0JnAGcDqONPT10oERzbHZRj8KeTOOYpu93bv2C0bOAInl3j1zANi/sP5MAP83ANpfAHyh3kQl7iJb4ENhsqrF3dDrKu6kjDoGesOmRR/yypnDzXd2neoLAJWZwMP3rQyFbQ7w2I4SM+hGjgXBmpBSlEfx0Yn/qo+J3faT6Jab5LU3RFpDBnphFXroC5OihTYc7P1vmL8hZbp9We4udKFP9O2Yme4WLDsvwMuB6ODNFtY9uYcVRAurrNtBgiwUfdSOJ8Of2RBzB+40a7B7pgDeqA4zXu0jzuproACdA95A4RtWtQx6GSOqztSXrcfk1uyS17bGb+3RkF3sq3g1ie5T/aw6f3617E4VJC5gz95+KNvcAs0UCyo4FNLhw959weg8Nk52+s51de4M1e7uyzycJyxvU2DJC7fd7XiWoGgynlPe14rJDe52Uh5FVwMpUetTQxpvKB1ByDMRInEwmq6jj+Cwf/JtaA46l+2W8k4w0x6XNAKFtg8Rh/658yB1Gh6x1k1tvN7Aau1uDNbAomZVmexcGA7FL0gBIl8rVBtuv/De3R/vLdrYFxPiTl0TwVDWDl9Yk0tGYMWwx6G5Ua3bcRSeDkXu5+7jY36G1LUg1MFibq6e6EBu/3Pd+iAYqNfstvHOm1oe+Vjruw/TiO4+lJPTFZ4Ainfg268AufAOuS8PY23uM4PlQSr9wVP+v7fvEVD8Ea/yBjajtG8eRMv5Vn4ZWs58Vyween/b6psgniEvnmTY8w7+wzT9KW30XBjvOh+qKGkWb7Ktmkrzsq8t94SzZ2KwieYNpL71lVd/lWEnwBxr0Tzp7QKfW1Fc3o/omVpapwhu9rfFdy0NWxXuIUrCidnmMXMTEG/ws4HgqHgEm6LQk/vgeh0B0O/7E9/+4IE0/xfv/3DqHp0z2hRd0qD7Eyvm7upiTsw17ymKr0VXe1yYBQWV7/d23zYH/aWgwQtGoB2yXMYDKECLEtY5iw4UNoEbdNpPjNYrSL3jJq5BjO4z19IUO267jx2UmUKVVGJHaspUuYMH3lWuXJZipXBSWeRJbL1zNfl/zI4umsJzKjR5U6hJiUqbKFT5saLcnR2NWTHd2lg8et61eww5593FqNIrOVaNMqKzjwJ0u4auMuLUYXKlVJefk44qv3zx42ZraIEZNnzeEwicMYUUzYcZHFRmiUoEzDcpZS16xZc1TkAw0kekr9sdxJ3TzUp7P945da0hvYc6rI3jKb9v9sxGuk7N59GI9vRo063Qoml+pcatqUJzdXzjk76NFJ2gN5b/r1c9nRneNZt61Og5wuXaqlTOgmUKCSDa97l+1Bu/FnEvz+Xar7+8flVsTI36RWkayL7r+1kJNvPpxSIYUUW+pay6efchFkqKIObO+h+y7MMD61OroqF7Sq4morrzziyKxqyCrwQfcadAs/rNCC8UMIOTzJkklyhKSUHHmExJFDDsPiMMPEkKwxJB8rYskZKPusiDxCmWazTmqg4AMkJPlljw4+cOQ0MKW5BjXXYvNCNtoGi0PNOdYApM02BQGkETqDo8STBolzr0DmlutTuumqwyfA6rQb0CXv6hP/SDzyzMODkfTU60S9FuHTMFG6FK1vQ06jWss/UDEiy7rtsiOQTwt9wkkTUu4EEUWrgKrRmGpS8UOQtz5MldMXL+0UKeMgTEnEqlAMsVTjkg1W10R1mjHGCndlSUdIqh0kEL7+emOwIXNbMknHwmXyg8pKwEIUzaZRx5E8ipjBDDEleUGKzPJJ7Rdp7PXHH25aiY1IIeFsc85OIpn04AQTzrO4Pf286E+IAaVO0EH3sXgk7CY6qq2aFmSUk7oYCQMP9CYVppOn3LJ0PkxZFog+RafC0Ff9kFvRJVixm+5UFpn1DsGOXX21rLNmSpC4Wu9g5NmUac60V6ejdmomaG9O/ytWqqCdseVFqWb2w7lcXhnYrNsw+4snAvNiCSWGQOIIHnq7IzckGXPsyCOb1PvdX9TxW91SgjzkGnV+qUQUXVLLp/BhCEeNm9cEhvNNVisXJZhWiuMF81kX/pnhncRxePTnAC2V4osvjodU6GRti5LxgpN9k2BsETkOSCNNr8GEVt5UU45f/v1XsmEM/fjuGC5OVEN35nnZpzn2GCdai+WpFurzrMYTkqNt2kKjsIf6e6lbhrZ4ZauWkWmfuZZllfLaXwoursd2aAf8TdBf/xD67z9uuRUJMd8yUgETg7fP6C0PYlKHuq4hDXbVq3CO0xc3hiEWr+QDgqwqRAc7qP8JQ1RChCDUk+aUtxTxee5CDyPdckTXnOadDnWqGxTruvO+2MlOEOqpxe1ypzuT9c4gKaxPTsT2vo7BDDxMsZ+NauYp12UOdDkrSehYGLboJZF6YyGaVa5ytNrdohnBYAQeOmEWqJTve+8BxfjM90Y4qvGEYGNf8WpXv5x0LFdOnJqqhsi7S5lAAxe4gAQqgIEuJbIEAIzD3OYkHJuIxzBzuxveJNMkI+ShGX9rYDMKtkm/ceOBJbIg52KSOSNWwheqTKUR56gnPJpPOc9p4QthGEOdzbCGNnRdq6a3w2T0sJElOxkQVUZEZAIPfkiEmfCa2ESZPREqOBFFNS93DCr/9mclV6TfxjSVoKycTiPJ28UW7zjGCaVifVEjn3fex8Q4qpGdXpMfPHelzAXRrHPR+yPNCGlIREIgoF2K22EIZrJVHcxgsGsEJQ94JMIUghcpkkY6pFErUVBUo6BDpdHouU8/XgqWQuxnSYHFTVtaEZcrpVhLp4MWFzUIFJBqkCAa+UMgtjGmwWOmM/O4qHw2M5nPlE80aTRCa2oOVtq8GhbFtlMIbaWLGpNfGItzi3R6L572dCMgueq7rsazRl4lq1g1NT2w2kd+wGvZITEg0ESyQK5HmEMhDkdN4oCzGZ402S0U6sjDQHI4vJjoXscYjM2Z8GuuBOlahZFGTEG2/6RCfREtazlL0wGqdO/gLHW249KtROWOPdyheNZU2pzubqc9lcVPhbfMBQnkiM4kqSzfAz7OLdRg1yzsUpm6k3UuNqRDW91UtYoVW7DHk0qTpz4TotqvbjVRPDRrSaE61Po9lSAeIwg/q4vdYiiSBUOYzRvsysqYzMiwDVNG7Q52Tau+Ur4++ynV1PoQmAWTiLV1S2uTKRHLXnalA9qIdEBrqva2V5h4eBSDd4iyg92krynU4mthW2H7sja/0sVtXiPxl0PsYbclNKyxYhKN9Dr2IKIq7nbS8jmY3KQ4ngjD0oLL4d4hjL/V5eEyy8q160L4urEkaTO56022xhK8yf8g0htEfDhTEFYsU15vUdDinBKbWFjKSOwcFTxfr8UMyfCkhX4Hwkw8UhjNARbwgBH8n+yQqlDISvBMlRacuUk4whKO6YWRGFSgBlq2Zq7whsfKYeLYF0gh1kOIQzzYZlSUGyYyy0tS/DU6ZmXOWKuqMVLhqvY29BJotCqOzazT+qEsmD0GJNT2+92TEXqoQ541Wv3o0/umedaZ4zU2q0Hl3yLPt7QMLvsqe9yebLe1DBHzjnXXVWSu+VApXQhm3fzmlJpOqkSrMyTRU8YIE2fPLhqOhTXs52W6DN3vtO5wc905UXRi0Y2e05wO0YlSSHrSsJpyp6eokU2Pk5z7/DT/nq5qU06QesfPxB6qjxlMhFCXuuHJcbst3meJWxe81w00oDeeZI6zO5xmAbb1sh0qLFvZ34NGdrKBkW5mvxusqnX1MTE8bYcxZLOZNRXPKKIz7kxTzzYRrIfDTe5o55O7hZ5toWttRFonOq/VnLceAmPvQziiFISVdNd/jWn1AXxQdL7xkIVicGbYLg5nPOzC7ddwh0f7uRXvr07jzu6Q9znWL5f1x13r9KH6F+RnPnct4GzyAhMY5S2vO4MMNLPtKsTMJl2P4Ffd00sR/s8dA5WfdN5ZnisepT+P4Rg7MZ49Dz31Qk4QT5UOePgo+9l4z3vUYxpveQOp0Y02A9bv/w1lfe+b1DERizJQ9Nl0cJpZZhcEpBhmq7WP8/luh8/sa/1HtyBUtbsrfN5r8kdJ+Tnw2O+4x1/L0+t3TfNEET2BTXTLxLM5wGXXPCfKXLSZyVq0Feev4Ddf8/pTLZwTnWrLiNDrudEDMJNQMOFIrtUjOjrRM71Lv/p6mpKxPx+rvdbbwOQCo2qStz0IQat7kzHYPT34A74YBgbyiq67qAtCEQxyQX5DLqm7rpw4D1s4LOgDhbYbKaIKj0hRMwrbncqru8rbPgpcP6AKv5fLQNpLuvJbNyjkwClkpp0DPSxsP8WzNsw6rpfBIfRYBgJMjvxTtuKhPGYTPMoiwvARQv/dEcPWwQZi+5MD1MJaqqIeooSE2TM6cShAQBgOnDoPWzKyER9O4D6a4zjtE0IPlDcQbDQ2GMHd4wt5yzd8aUEWlEFpuERJ+4V+6zJBhKpWaT51OixQYLBSTDAimy5jUkIpDLRiYjUm5Dvosj5aCD9bLDxdPMRX3MXu+z/Dg78stMMt7EL5wy/Z24RGaQ4yLEPhacZ+GrSeSLc1hLliCMCgeSxsW6eLEMbmKUaqUqkTmSmDc8AI68MDerAPXBjogSXKKzXv0D6Hmzy9U5gMTJhWyD2rowN+3L1IzDq+4BFe8EROzERMbMFfA8VQXMeGmxBPiBG/Gqatebu84sVE/D//KUytITIZM4w9SWlCJMRFjPTFJPq2KOzFc7M7IZSYYaxD+BMwz3O5mlBGx2PGaDJDP4m9DdMwM0SzNty89AhDBAxHLnRJcFSpEDGPSyjH1KsTPJiCKbgD3boT9jgntWi7FoHHGpxAt0i0unNFH8PHDxyNfUQDE+yLgBRIgsQXwhmlSTtISZOyUjuaDeQEhEvFUJPIiXy70/uhk4G7ddOinALCYpK1WTzMNvpI61NJwGzMmQxDsETJkRxJb2xJe2hJFpK/s6CfjVRGobRJmaE4naOGMZNG2cM1WDTMoPxMNvs8lsTMBURK6VvKujzHN7kDKZiBqKSkwBKOhapKqOgy/7QQzimSLOxjPeT0s4TCqz0UBb4wwRPsi1L4hFCgTkssyLbUBbc8SE+Uy4XcQ4RzvLa7nfjZSjRMLs/cvtlDt9QCoiIMQsWMxcFsz/UMN0QsSYvExozczyE8GMusByy8TNg0RgKNyboAw5o0UGQUOeXwLoq7sOP0SZD8M2UMRsVzzSsc0NiUw81SBh3zqwj7tttcDN18KLkhkuarE6qcMBKrsvWCx9VDunsUSwW5hdHoi0ZDwb0ISOvsUSm7xLYUE+0EUl3YRCO9IMLiHGsCT1R8FcPCqqjMwdtaxVWInfuEzwsMGo0cyQmNMPkMQsCkTzEN049xuI4JzKVDUzJdhf//bNOj1EwsWpTxAIbRhMYFhZ8+cbZkE7/IZEXdoUkO1UwtBNBv9DmV8Ib1wJM9RL07G9EZ4AG64Q1LagwUfRPf+00O9DLIUjAFocIO/NSkEshsOcEdpc5PQEuBDIXp/IUi1YUhvcQhZSDCEZMjJSxeW1JNKCNgGj50mgJGECPjfDjpuZUrxaE01VIxHcxYfM9kBdNkBUqL9CUMXFM0Pdb6hE83FVBiTMCcY4nnapWltJT8k8kEdUbKUr/ILLPL+9NwjcMMfVcNHT1Sm9aCc8pGnRvJmII/XKgBsiR/DZdwQVFHmp1IQRoXda9oc5HLAVGqu9FsSUs+UNXRsM7pFMj/61xLT3TVTWTVjY3VTZTLdawEXaWEnzCxtMNNQHilWssh9rTWaG1WkBTJI4TZZq1ZWztJwXxZmq0JQm1Tbd3WywqbLu2u+bnTcuUn+pBMLX2sa6RQk9TMUhnUn33TDsGym4C7HLoDBqOTp5QMN8FVT3iTSvLXEp3UJHEwrXUwwQLOYmuRxKqmYODRbNkLut3RuXWEHamWVH2F6gwFjNXYv8VYkP1AgnHSLLOFpwSEF+27/rLSlk1PadVZCUzUK3XWWIxZm01PyOXFzWVM/LxWZAXdP+1Z0i1doBPUoPXWCaWtbvKmdLuILEpapZ1JomAjduWEQIUKo7y2zOzdciiG/6s9GF1V27CNg3wVhEi41YSiE0BYk8YgW8aAygOSXultJOu93hRV1BWTw1gxLCmz2Lq9W7TUur2gFr3tkSjr28BVX8EdXFeAL/VJBeNVXHRQRfIjPDv53OnZX9jp3EjKXAAOYM7136ut1tC93ZrN1tOl2pMT2nPdXsjrGgAzVyOTTEZpDzKtUKyBjhZDQN713dKp31pQ1ElRxglJXKk8vQNau+yJR9sUtTw4Yee9XueNXuqlYRy+KTuBTKrQqCPVhYGsTrvVUb7gg2tx2B8xYmtZ4ortWyeuTl6A4va9oFYwhV5DrMIqLPmVAvoltVtIuvxNqKFL0zJd0Qc8YwEG4P/+XWOd7dQDrtksHWA5VuCpZeDWnJrSlEYKxlPQRCF2O81jXUINDrU/DQ72a1BnmIhN0yyXXDxsuM/xSNvfEF7F+FVNzatPfUCqRD3YYbDGwF5H8uQapmHH1ZMfJRxdUNXwJWLxXWUdHQRrUeJUfWKJ9Vu+PeVXqOJbzZwXRJEtFoRI86JmuUXUo8ILc2NktjVzFDIPpU80TuNo3WQ5/l9opuZpPsRNbofVMV1trWM77lY71Th1dcYkSmSLIGdzQ8kLVsVCJplkaB2FiLNF/mAQtohzKMKGlGR1PL3dVK7Ha9qLM8965WQrNWE8uxVPvuGovKm15ZFfuFFXLuK5nYT/uQ1BVr4WJkbfWl7ivBCF9N2cW2UlYOMFSoBKxVWH5FM4VVFm21MVqcuVMeKOGYSi21I1NJZHNPY2M7bmNsZInkbgMtVcgvYsoi5qo47X1DVXmTzDCD3k1iXMB51doWSLdt6hmNwGbaaYqNUOcbLDYRnCTmawPHCVSTHeR+Hjf+YjO8rK6XsqMc6hhIbK6DWMR0tiIn7lIr4WHd1rOTAbvlbiasFbHqnOSQiFvRiDtTkTOQihHgnpVujlrwOE3mgFlPYImPIoUNOoEzExzj6+EfnsEUmRvYra0U4Rma7fgw3O4KrBM05m13Zj0QVqEdVcTYAdcD1q3Pbmb96/Mhyz/z2GHwd5apAcImMlpsAMw6goYYPunnA0vqw+sKMmbf8YJ7Ae3nCNyH5eIc9zCu5mrwLkj6rtPJUjV3A94cUgjLGO5b+OaL5Gg79w77/Oa7xl4sCIAbdpAfx+A0OABEuQ2HyUIlpBUknQDUitBG7QIC8eLeLqCmTp7N4qORe8qOTrOtDmilC6cJTGcA238FBKB7d08L2aL1pL5tQi6DVWUdocj9zO7UJlxgIFZ2ScLAeVNnSOaqm+EOU24bNubi7aJR+XqjnLmOn2UMAMa5ryUNw86+B+8WhCid11M57ZP/SMwEeD6LuNbx316z+Ab8B474uGZTDf8ifAbzIv8yfYb/9TqOVblctDOIImkQI9GIbFkcE5enCrCsSQNRhMjbeFxSvv3Su35HAN13Ay8ZtCVw1rGPTFWfQOn3AZNJZq+JDaBOoTZ6jaPsQWk7Mgdwfd7sYGhvEZR1r1S+RwhkWcVVMOHWHPDA5UTAmy8QaQoCHQmufE+0tzDGubELeRARndBW8Yz114vbYFbvGMuMrEms5qWe8sX2+zzPK+7kc6eOXz/ZEvaJsN2B9sx+8z5+80bwVrglteqATd0JsjiIS+icuvG2hdjdQkoV535w30nqSxDjE6ybpPslEpy85R0nfN0PApwfBEJxOBryBGv/AK5zesxOR4W2ZLRz0Vz3RN7+D/TkddBc0U3xb1ZeNtxoXWmB1a4HaORF11BqMdYUYKbZYHlFcdIP9xASW97GCjgvMEobiDP8wr8twmJi/KOvzgeG0dhKeoKKboZXdlLTdLo4f2SGSDtFF6s4FlHAmEar92qc8Aqj8Bq7d6JviDxs6LEZIEUZDsJiGXRXIEFfxYV8hVP5DrR31U6L2kKdgbuBd7uU8gvGkCuxeM3osND/o9g/kDg+H6jvZorrdYXf5ew0dSxOe6TuRwFgSLB/KGR08wVBJjPe9ZiGdxoP313v7BybJCzlzdUwfkZwN5Vf82hBYGBGuJk6oY1RG7A6MiEZapSNLVRsCeYLBL5v4tig/2/yfnLHve1mLxiE1UVb1oer2m2/c++qSH9rR5AiZwAuh3AudvA70ec/zeAELygEGq+qtHAfcGfBHS80jYAidBJHIpd65v3imIGx548+oN5QmJ/9uU/37N17mfe8uoAbuX1CMAiCNABBLEYvDIloRZ1mRZqJAhxDUSzQDKs0bQm4pv5misCOgQSJCRJIlq1YoXypTVVkprmc4lTGnDqqkMxstevHftct7DGa+nT3fofJ4ryu5oOaTmvmlr6tQZ1GVSpyarCuyqsKxWtXLtKutrLapSs3LatGkVWLRozwID5dZtW7hvkyVVtrbsJkZ4/Mhi9uwvNGPIBD9zh09fvn36ev96a7xTKGSjkosWs1W51ts7ey9ZTqW5kS3A25iKW1raaVKlqVWb1snatVLY32STRup4JW6Xv36VCsRnEHDgf4YT/4PmOHI2yZkwX+J8B/QWMaBDN0FC+oYNFyJo6D7B+wnpXwwFkmRe0sg9et5soYHhw3sIGGbw4FHi/n0eYeJ8vuSpUyqWCRYMgQXecmBJqQAIEiMWrWFEGEbMMCGF+dFA34UYZkghDSx4WF+HIYr44YUhSggiiiBK0cSKLbK44kR5VCRSJCMlWBIvJ83U0jU9puMjNzwJCdRPRBKF02Sv1RaVWE0O1tVWXpGlVjFiYUaKWVSuctaWXV711pdxgUL/l1/CvGXWJpspI1pgA1ZjWGKKCXVbkqkNtdM2ndlylyB+3AHKLco0slcqa7J5GqKtKRnba7Qx6ihTSd7G0m67hRIcpnC0MRwfwyWnHKhsNPdcdNiZkF0FF0jXwgYRPNBqA7FyF0EG1z3xhRyOnOdIjSC9YR9+8An7wYRT8EcJKQEGWtWahjbj118zNZPjgAfu2UmvjQyqWRwrbojfhMQGmx+HGpb4bbnpqmuift62aES7YrAor0QxyliRjSbZhFI1u0FWJMBALXYkko8q+lSbT24VpcJS7oJVVrSApdVYZOEl111pnZklx2QqkwyAF6sJLWDEuAlnnEWRTOdoRc1p/5eebl3ymbJ9euJxy7UdvKii9UC6lM8/72zbZC71a2kpkAxCiCXBberppsktNyp1pbLa3XavooCCdq7KyoACYWfXwg+35mpeJMPpoZ4ZBoEIbruCIOtKlcawSTLef7l5TLXWHhgytv+BJNEU507IQoXkrrs44+kaLoWK5tbnLuTwFlGEvE0cZAbnHX10SMCLiT76wATXyRrCTkK5usMRT8zsZRmrNbvsZ2I85lEfb6yXH4zU0nKbfBPmzT2IydkY8Mm/eac3VeVy2X+8c1YMJ3KHhY3OQ/O8vfZCL8qyTEeHMj5wk5g/SNRQS23Fcc3l8P50pW4dnnapXrAB117Lmv8A//zjv4MXQLUHXfFqbWvbSNuw0CL+yK0kwjNZyZolQSYlzGQNu0xW/KasSvSqT3OQSLe8Jbm3JW5x4wKX4hgnoXVZroUtfJeL5LUi0tFwdPUwUsG2lzorsa51D/uh62pxvYp1iRMa4xISbYcmWXAJZ2diBBRtlrzgDe8wx0PeoXImFGYI6G9m4R2gbOGf0CTPe9xzVNDQeEaiPYYl4eBGS3gTikkszRJNQ1/U6LA+NDxhDO6r2nTCI8j5aeABhvyf/sKGgAEwMgEPCA90bsUGtR3QgIVAIEcKYSNfcBKCbSoHNbDRpFB60oIXrFsGUylEPSkoWZqgBCy1hRH+0LL/lrRMyH66FUIpTKGXvXTc4YpVrBWeSIWZe2HlVFQ5yNVQTjXE4elQt8OF9dCHQVzlx2J3MbAYkXZK/CYwcteJ/5SlEXnxk++elcXh4aR0LKPTy8IimCudky/ISMVZDBXNNfLTYOAwIxvT0ZiYyJGOkCAEIQbhhjbgiqF7dB/8IhqDQVqHkIecX6z610hGao06ThBgJdk2o0okqEAPnCYpRTnKlA6Gh9dkpStaGdOZuvKVrbTpKy/hn1jmlKexjGKfgApCGe5nmSciprqO2iEpjDBF8niqYqIqValCE6CjQSnsqgnErb50K0Xs5lfA+s2xuqUudiEnJ2R5hzx0wlnR/wjMW6n4DSsyBot2nZNXxjkzPPgOg6vZZ/f6adXAHqWNMNmN+cyXUN9oyqHse+wXrPBHiVrNOrU6Af4w252teY1/jAQAR7UGSQCC9JJ6uGRGKkEgag2olCxV6UpjyzCtvnSVtr2tTHOrJw3yVqa9ip621Oqgoh71csXVEHIdB9Xl+mOqznTnYK+qOtpas6tTWqLGvEnWsozTrIDzxLYEwYibqRSu0IgrmwAmGdxESmVdvBZ4N4NN1ABWjfU1Yxrtu7M36sZSSlMscDTVUDlEtsBfmOz7fkBZzWJNA5bFLP0e4NnPCoCjtfrfEIbwUQILELWREMUweLG3T8q2xFQh8f8pq0Rd3K74YSnm7fOs9d0ZAxdNjehEcC1CXKOSMJj+aG6cfgxk5xYvv3jiGVZT3GLrismISdTudt/SiaHoTq/xvQMUOTHBJaF4J4dZ71Ud4w4uopKehOoMyQR7X8LmF2iE/etLZMKL8RmUaYttbBcca7YDMyfBTujzglEFHghf2FWMrPBGXzU26Wh4I6F6Ax1SC+IyEaiCr710eQOD6U3LlrqdXp3CCvSk98o4cIGiMaoBJ9wPgtCXEZqCkH+8jyET2Yb6NWvqQF0xDFYXYrf96pOhjNaxehetQJUbs8yL3ggS78tg1uI9YXclvfRVQNl7VJv9qeY3B1Y3piCfb+z/jL7GRs3ABQZ0JP0sUczOqsHZycB3GHBoRIe2O9axQYYDCGk2OHojoBlGa4fXUk5nOrYE17SyLT3wEic5m6hUMuwKvrAAAUhAzTK1bxXk01jGWtazjlOteXJrXE93yVw9ucTOEmzbhXXYF3t5XW6h6ihm2eEJl24VnX3Vv2AxQGUSYvR6pyx9bruf3E6jm3sGG6Fw4xoFDQRDl3ZnTQnY3E9QN4IjioIVuFtWWIv3vBPNHXubQAiNDqC++x0JUQec4QV/e6YRJve5I5yCdG+46mye1YlvxeLY8PsEHR7jGOs2ph0/PMifW9XZSFPhszW5D5nYzShTnrtrAuV300pz/2Rl8+Y4t5vO04u8VfhiJdrM8ip5vr2lR/fo2WbzQJvOG0jQsaFwUCjVc29urCvYz9BJAQreJ8gMNDhWhfTaRhfpyHZnp+z5RnvaM0IJB7b94HC/fqLoe/ftT5Hkjk+23ie498c7r/OBF38nB7RVVyCe1rS2ocj3mWSI89rXrcvuy7cZ5RtfrLvVOOtbrNp4lR9clQYWJQw6fJnoncMzpB6ZYUZejJfPlZG2vZ7RuV7SZVsb9cgv6Epv5IobBFjuwcFCGVjvJditnGC6Vc0gdUciGZJGDUDYGBLzrQC+ZZhCQN8HSd/zVN9rgRL2BGEQeh8QFqH2GeFfISGXcd/3of9fxIUfbI3f9Z3f3ZxS+8VayC3etaEU5FVXywGb/u1f/7UVOjwLyISMLNFcxe2C3bzVtTmDtbkXVDBe86CFBNET6g0GFiUhBvJhBlogIP5hfr3Ej/zCfxnHH6AP0wSYCDbUgVGHgqWgClaN8BGSCLggDcbgIkkADbobDNwgDj5EAH3QjT3PzYUSySlh3M3dFrZi9r2iKuKdFD5hsgGexGUTEk4hBUnFFSbGPLwf6YRD/J3ONJFfr2XVmNBY/i2jy+2UzEiZEH5XGuZBlq2h6knKZZwfFuVCsggePs2MBF5jHxadIAZiOW6g0yXNpTxBIg7CKZyCHU2dnkHi1UliRCn/GHT4APDlQHiAACZ2lvI5EifeT4NBUihqWBUk5A5mEiedYiwO4UOiYmocISxWZETK4i66HfjpIkTmIkopwz+EpEhmQy9SlTAOY+OxVBe2jijRGBgyozOaEyg441ygA+bN3OY1ERtqEZjZ4hyqDJaU3s+lXM254gUepSCyWRpBBgeWglOGgkMNAizAQiZUJSHo3gmioCRe3QqqYArowPAdn4QtEgwOJEFy3b3h4EF6wRx4QRXUCyXkQhZR5EU+pGnQpUUy4d1pJEf2ZUf+5V6Kkkj24pAl3jicpPxx4THaX1t8CVlJXjO6XGQ+45gIFADKTCNQY2aint8VVk/aVt0A/w/1kN5QbolOTc+ajWMFmuM5auCP9Mj4hAI8oo8lTCVVZsJVVl3Z4ONu7iZX7gA+eoHvVSKDGRr/lKUh3U8/GqRahqJCwqUvOORESuR0Vid12mVe1qV04Z1fdmdKQSR4CmGayV2skaQ/mGf7JV5kvNOyVVD9MRlocgVcnGHlweRO3WdeQOOzZF4aquHQ/STz4NWVoJJoduPHdIbmCV1hpKZqrubIYdvSvaYuWIou9MKE9gIu2GYm0JFu9hEK+qY91mNXUpRmcaKJmiVBZtZE4UAPNKdCIGRCvMGHzWV11uh12ihe5iiO6iVfeidHaid4AgZ69sg/kEM/8MNg/mKQqf8DPMARYgrjsi2hS7EYlU4JfSZjfdonM5ZVXezO5lHjW8ThZCAJAFJMseUVJYDR5ZHjYDmoOQIiUzodb3zCO8KCNViDhlYlHpnbqgQfiG5lVsLPRJHouwkaQfbjiiZqEiSEi8ZoIYgCjdbojt6oju4okFYk9jmkj/7opf4YSXLDKwzDOMwDkpZqSC4pHDUdlOLGMURp3cFnlZpJ+d1OlHEMLOWnrZqTtijRxXnpNO7Uf7bMndSVNgFeWR0o0KWpgjJog3qmBhrZmyoK03Hghb7jNNwpnlqonkJdnjHUD2hAB2hA8AEfcGpBCnqoiFrNiPYp8d3bCqAAWH5iizonoyr/gb2+5VsWQqTeZXZqj6VWql5e6nld5KZ95Cpe6pCaAnl82y/kg0iaaj4AiZNKy0z8k6u6FFxIjMZWaVudITawXJZiJuWJp69uHv8RSFYsKDRV2RCx7Ki10l5xxhBKhh82K7TebLT+4bQ6XYVWqJ3e6VTCoyUs1p1ZwQlIAATgzxdsHdmY67n5pp+NVoj+Zp8GEiA1J4zeq6POISv667/ujMBy3xJuZ8Aiinhe56ZSKl2OqsPOAze0wq58mzSMKjnww5H+w6eOg962hDBKgxse4K7lFYCEFYtZY8jiqq2mlSd8UeLq58c+Ec1p5nhxns25zHreZMf2apndBaH4BbMW/x3O5qw57izPXqvpZkPQbutBIdTSjuUF/EAX/MB1lOu5/mmCxQ+g9lEAXa2iYi293qsXHMK+gq3aei2/fi3y9ivAAqYR6uJGXipzjQPcTgLcTi/t/cI1kCTE7gMcDcMvhEOo8i17Bdw1yYWVFi6tgiz/4afInqaN0eSxVhlmmiwUnaze7KTlEusaws58Iqtp9g5dfC6EDnDoim5rJmDTZa/pYus05OkdLQ0kuMEOWADSIoAE7ECe7UDZpSDa2a6IMsFj6S664iPvzqvZ+S4OjuL/uaHZGi/xunDxJq/ydq1HEqzzMu/2ca/eJoY0wO15GJR5mM+3Ze/D/qKc7gjFPv+Q+tkWloYRbjlxk1XerkaPEq1vGEqQlZ3msWXZGDFFNjLe5Q4os8yF/26J0K2pALtpARew6w3Fa/bItZIDA2dDA+vChjJWCR7tqUjAAGjAE2hK2ZhgB6dgCDPHCO+ucF5tCWfYCWOtWxoCC8/wC8MwDcewJF9ypjav9eFwje7t3s5DB45E3P5X0gTxK2hvP9ztNByxtPRNjK3hmDRmWtATPYnhTHKx+05xOUnm4PbqLW9e5JpFXMbVZagskWzDWQ1R/54eX1VJGhMw661x6LammyGwOsDxNMyDNWgztmqo02hKdKBBGsiuCeSAI+oZup4zckDUbu7uIlOHCYOiI0v/QiQr79EdLz5jslHqc9lSoERm8tieBn8FicPmAy/UCAHtyg8v9Cv0Ah2b6irvxjGwljG0gi2IQhiB7BPXMlnpqhW7L3h9U+O6BRb/cv0C8+QWCjIHXP7aZDJ3rOVZCwT6SWXelZtC85hKswFD60tgc93eqTZzMyzYMbeWW9kQwmw61u11KCEjR9SZqyELpzuXyjvHM4vO8zDY8z0bryXzcz9/tT+HrSv2bZPysHkM0HAo9EJDwg+3QkPXLZKSg9vKhL7oi2VUHF4/8TjxspR9dC7rMmUurkarlEmjdH+i5kqL6ZG99MdOrvNcCzj+zjM7K2VHs06LLk/3dByTw1Cb/y4uTMNsGoJDPfXSVGgiTEIIPvW5STWoOLVDRTVrA9L7JLIJM7JtN3IV5Bs97xxeBs1WTzLAwnBAS3JXy3A/I2YCXzMvoId6pEdxSMIfLDR5DIIp68K1miqo5khJoBpMqRpfz69Hh3cA3rLiJq7H6o4WA7PkcibyjIU8eSYyY4aAgAKWtRV8pRUeaBnNGkXNqrHp4CxQsLE0WzMc1y0kJKIlvOMoWELVKUcbAIedJcIpLNZCORafgej6FLJUR2K6cfgix8BV27YXaBgkrIRF2mxKXnJ/Ly9Ys7iLv6KYJTAcmYJ61HjaPHdxBMchBrFbZ69ca7M6yNl3dUaCSGNwgf/Xrt5neB92fib5SJNxSxZ2MAOVTk1gYqfebXhj9VhPLTfzOwnwf+e0axwJdEUrgL+xNfBDNvCBcyAH1DGWFrTB7ZlPgk/CIirUnj4thkOWZOUuIrdzIjsBPFs1iGP1Pv/hbyf6iqf4Vxe3V1dqOMR4k3IDSfJCjV96caA1jusK7fkGW5dEqGZzXAf5tMhcxW23SATXkWueqqc3/eJq5XXX47q6YffO3Czolb83ZbSkzIERxZUTsn35olt2DoW5ZATF4hG7sgvFNfv4msv2rXj6IJiP0CpNI6r2hW94U9cut6PrIP/Zh4c4PLPBbkN6s07kuVPyV+fzi5t79iH3pMP/A0lmA3Rjur1n+qYTEFtz+m4Q6ai3RClgtCioeqoXfKv/FCC8OkiXd+PK01nV+ubZOnllOSu14Urbt0XIjarVtzMcun8XTLE/BsHA35Ete8mPuWYv8CBocAfYzxfMeYIr+AMLRxrUfM17q5/3ebf/6c73WQnLa/zYq9lBaj2nu6If/T87+nArPYsTFlnLQ9P94j9cgyTQgSHYO0jce77v+74ndClgbzZA9Jz5yucY/MEftslu3K3COnd1gjAcaD1BPDpxQsVhD5Ulw4BeDwMStgfx3zgFFRnRoaRCs7GLucgXT5mfvMmP+aQrsBxDAj9KmKrkCtP4rNCK4M1jO59p/3vPd/4h/2a4B/3QR4PFHr1sCHibIjpXtzDZ6ijTZ+d3mi01/JOQNF3bIukvYD2mE5gBrY3abP1ZF5Aj4AjYa3MPi4IjELzZqzpG4Evar72uPrltndMWA/Pc+5/KsCwtOHPzEIgn9H1Iq6k45kyiEP4+GX7hL/7JM7vTma4cW0IOsMAGeEEbJFTMW6i2Yr5qE1ghA8SPJwMFEixocEdBJwQZDmSyAyIKiDEoVrTYA2IWScOigTP38Z04kCFJ1is58mRKkylRtnT5EqRIkNRkzqx5sxxOmjttauvp86NOoUGJgounb9zRcfnm/XP679UeqXrkTLValQ7VrFul/vHqtf+rI7GSRI0VW+qXOnVNr/0qJepQ3EOdIskt1AivIEB4+fKl9LcRp7+C8Qo23KlWYlCbGDV2/BiyHzyMUlVWlvPcOWzLFCfelpnZrU6X7pRunDeOoFTMnn1m5xozzNfv2tW2Zztz7tm7deO+7Ru4ypUlb3O7dvwarGnkrH360SJQplPSE8HKNGkQIUKD0nRvg+a7FfFfxhsUePBHDibmnyR08r6hQ/XzJ160j7GKoY4e+Qun3XI4AAMc0D/hZPsJQZ6GSnDBBmVSsCePkNInHKSYeoqfeSTZ4y45CuEKxBBDvMoqryL5aixR0EJuGrccoQswu/bq67QYB7sxsMIMW0X/McYg+9ExySizBbHYtgnNFll4ZA00T/IoDUpGnkytGCa/gc3Il3r7rTfeumQnOAILHI5Ld4xL7jhrcLHuiy4ywWW6OL17Arzx0IiPTvG8QA8h+uZLL72H1ovPz/sMHWIIQzjqT0sx/3MUUgMPjJBBmhi88tJMRYJwKE4/CqfCCeW5EENd/thqL61UXVXEVlnVI66pAMlDj0540YVFXXgpq669ZqWVRr9sDMywwRY7lhNGJgMSSD82SYzIZKx8hrPKbLnsSGVIg9K0KG/B9sicgMqy0TC/PNdLc9UlLp1cletFkUkIOcW6ROj9ZDs+7JTPT0IBPa9Q99xDLyGH3qPv/9D7lNBvv0nHFDDSiB11WFNyg1LQ06IcbPAYoyaskNSn5nnFEEA8fEOO71x9NUSUWabKLlgPGWvFaWy+xpQNU51Rx2CHvYTYHT0B+g5mjUasGLqq9Aa0YqCtUhllbGmEW27DuIMSZFhrDVMHGU0X3bDBFptd4s6cppe0rXNjkjg/SQRufa2YMw0rdDhh4D//BVQ8QCfKW++DIcpB4L8TvqgKOTbqmCWIH31Y4sgpplRjL3GqGPNMiSEGVFFDdmoabnL+8C6XXxaxQ1ixOh3m1u1ypJRbQw99mFJe7NWuuX7GEWhPfM9REKOZ7SSYWpTWmukjOwuG+U4Eqbq0MMKgzP+YrX0a93pOsez6S+7HxpRsyNH57ey0p3MDDkIUgZuQgazwwYe5xUtjkCfw9iGFifT2lz6J/AaYcAE0XEQO14IT4KAFQ0jc4kAlPsk90HEEmhzlLJc5Cl6Qcpvr3D3wMarPqYUbOivEG0gHIjao6oSseoPpWGUy1sFsDCucWSlCcRy1oK0UkYBR7uhil90BJnjCAxpkPHELIi3mWpiJ2vJcQYnnQW8Kccga86y3Eysu44oZ+94WvSe+b+AGbOWrV93SQAi4JYIQc3qfetqAPrsJUCKA4xP84Li/gA3QUHhTmOJasSjfoOSBgYTgBCtXQdlo8XIYfNAiNbhBC/lDZMf/4cYwSoaVFF5SK5hEIVVchskTftJkbKDVJWk1ylmNgSpnuYY15qEOm+mKLqnyoc9iJMQh+kw0vgMF8ZjRtGhdixTPW8MwuxXFKUYNmVkEBmeyiEjdkCt80RzbBrMBC2taUxF100Ib+HDGRHinboQTzyDq5x6J+I9PN3gfQvJnR0ENsI46qM8K9EiReu5gD4aQRDAaCEZB/lOQ5SLkMw/pTEV2qpFmeuRTlmIcebTiLqnL5CU9ebpPXjSUmuQkVUypuifBCnays8ZIcdaJF80yosEC0oyE14gj6rIW4Foi0ihBTJveQQpSwNq3qJhMLC5zmdTQGhabub0uQpM3sSlb/3DA5yVuwIMp2SDHmtTkhvFAAZza3OZW3fcFv/1Nb17tkwDdiUc4niB/J1CrCdi6VopkJJ+VcEU1vgRQu95VoABCVwY3dtCeJBQeC/VHPp66FHmEcISmYwMqWXZRx6LssRPNgxkWG0PLXjaGepisVjarhxeVYpVNsUZbfsGrlJ62L7NSqUqDSDxdbqKI32oGkmg6zDjc1rZGkKJlqjdUYQA1GcAQ7m99W1SkHnc3SpVmbb7INFAVNhtSJUc/yMEKXBCCq1CYXzgHQr/uXPVfad1bQdT5vxy0E3BgjQHh1nu39q61rWxFXBskoU9+1hWv+Y1UBCUFNgn6FcAaA2wHIf8JyX147rCSKB0dzEDZyD4YwhHWA2YpnFkGY7R1YknLPMjBD36QVsEo9dVqeZeX57n2d4bBxmxDI9dIzAG3uBVDTneaJBsPF8c43klQiWrQo/7YkOFTqHGi2+F+rKMb1kWjdm+AVTJ+J35acIN2wMme8c6xf/2KZwLfaxH4xtciEHlCIPRpiPu6Y12R0+/jHDjQvAZ4oBTyBePc8ch8HLawo0KKNBQM2Yku9s8SdnBlCV3ZBh+6wolm7JMY61m0LMfD88BhiEU5YkuT+DEodswuL4OOZlirELbdQhNyWuo80IUUqeaRqoVLixxLC9Y93gxygVzr5eYGqtGVaj/6EQv/JFsXFYoAwxWirFU9sRF93rXylQFIVj1+1axe/nJ82/rWHXjBK/XtYz+3RKY1c4nN4Q4Qf8UNUEW2+WtJ0WBg7VzYPHuQkooVdKFXSFl705veiNa3ovc94Y3mExJpyYbIWgQXGWGaRpJxbRAZAdtvaUYTlXixqHlQahrzDrasfnVRfUxro3q8qeMjcoeNjORuJBkVKV/fd8sTnnV+Bw5WXeeymX3W9AzuvHE8p7TVCgKft3UDYMY5mcvMC+em+a7gdhSFJobuNRfS6Xo9xpwVug+m6GMY0vDggfUMD1McopN+NnS+yc5vLpgd7ZjlJGRdJolJ1NDDHc5GW1rhiLhc/3ouCS+Na6kWvMAg03iVeN4WbFvxIph6RkNctY5lzfHjfhx7kE8eQUOOa3gM3MO8Pnk3fq2IlKf8m+Hc6ui/AHPy0LzmcNw5evVnQBTcs+c/p7Zb0RnzovtR6Uy/DdN1r3Rv+97cbQb+8PdL7nKXm3PRoPpTrX5gkF39zvAWodjRPnZ+W1/fVDh79rfvhXtXuNBhoaEuOExd5lyjGbzooYj7XuMaxTYYSgu19MQAhJzOgAaGT42xQKEkVxN31rJIXLBhAAsw8gwweyTPeybvS9JBHnaN12ZhFuhhAmcBE9TA8z4vEQZBC1quA0lvIAomPVgv9bas9XaOgL4s6DSArf9WgAXvqWDgIBBk0MykgRsqpD987x52j4OI7/d8MJC+5vh+MAijTggfZa7CYd1EpXO2juv07BckIewWa5TU7gm6D/vybd8orPu6cAstDN9WJ5VgB1fKrxvOLxRy6OB+BQ8igUhmxHe+pTJiKQ6mwPB4gAXwT//mgBKs5cZiLQAd7wAthnsGUQGBLB0SMR/44cjWYR0mkB4i0QLtQA0QARVUAfTcAKucjOXC48oiYvWaLYDEi71QEAXtyQQ0QBVlj/Z0LgZpUJ+yroF0j/d40B5qkUJ6DwhzkUx08dueLgeDMZAqgRjUjXH2bBjarfnwbJLs7pQIDRDSruyyELO0zwv/r9ELwU+jxnD8II3XMkT9ZESY+nBoiAXF6NDiaGAGSoAdK04MUgMxeKq4AlEQDTFcFvAe8/EQPy4zjKP8HPERI1ESLxAMEAETVIEVMHF9zqA7rmD0XC68cu6c0OkT4ynnUvD1KMIFT2AVWZGe0Gk+5obMiE4WPeY3eLEHc1FUJsQWgTD4jpAIXfIdfFHNdPAkgY8UfMEopk4W46EJoe8Jb1AaaodDZGgavy8bx2BQ0s4am/I9sPELvc8LHixWMgwtRurIwHEP5mAO2JAczVFYSOMI7NAO1fED2PEICE8Q+vBaALHxjAsB7VEu9ZEAyWV7ErFd1oIRG3EdJFECD7IM/8BADTAhIVnBMIMtERgy2RyyA2/gOcxrIncgBcwLUNBJMlMAvUwx9mSPFdXKjkRyJBXlBmkyJVfSNFkS6VaCNGGyJmUy3Ggy6VpSro5hKDdHGhqI+YCS6+JhkoaBkk4pGhnrsqgxhpggKrHPKbcvOZeTOc/OOA1tlFblVLIt4ObhyPrhF7aSK/FgDcjR76SkaICmDssS/87yLGcgLfXCD50m1oZLqN4yLueygigvSxjw6BLRBqeh/PjSESkwEg9SDYigIAkTIQ1TyRazC6DMBUTRFP3EQQloIjMzIjjS5zqyFdHLIEQSFksyVFqyNE/zCXvQNWOSRCVkCEdUzVZTB/99URNcgXM2J/mYxrB0E8980zdboShXqAql8Tmlkfu6sDmLEyq1EWZOZVUkoRf4YR36IRsmYYSGaQ7zgGpo7HmkhzzNEwPO0h3XYC+Qpf+QaPE2Dj4R6S73iq708UzvMz8hkNf6UyAl8RHUQDDtQBUQMhYOExEUQREYUgWkzCEdcwQxUz0EdRT/hFAD5qxQsUI7c61eT2/gR35mkCRv0CR90lI/9AkzdSV3MDWFkTZ20SRU1FxUlBc/VVSB41LLxB5Sbc5glCOybut0E1RulBd2xSo66wuJUymZMkh7VUiTktEs64VMYR6W9B9KAcbWoDKopg5vK3qmAFp5YB2xVEv/o6i1hGZH/O//Xs0tu3VME5AuWawaZitNGfAXpCG6cKHDYiEW+FIC/RMT4lRADbJODdS68vSbrsAFruBPF5RBC/VBAxYFMnPaXrAVPVNQu2pu2mhDAwsHU/VDQVRTOygl1yVVP/UmMfYHTZRTOzVUY5IWP7ZiVfViO1biXNRVOyY3NbU3j2EYmKcV6k6zNmuyEu04eRUql8BXfZVIK8vfVogNIOEaGHEaDIFLdYg7owgPlnY80xH/oPVqWms9AZA9X8092xNrf2sVvHRrF+8PjUgekUlcy9UjJqkXqgkX2LXXJJBt3zReA3RA69VeLXFPz0AGuuAK+tQx/fW8DPVQ/wW29XBOUWPPBBwVFdsJUucnUmGxFW7zYUsWU59wsCYWHzrWYyEWNkkUzUh2+GrR23TRckMXczuWFli1t0rSCYPyZYkhZuXKtOoN0cZuSNEuZ5WzwbKgV3HXOWdX0cLvFzzsF+qippqVS4HkRtazp3rLGXzKW4kKa50X1rQWFBqDaSVjWS4BtrJXaGwBbJN3bKVBF3phTdKWXcuXAiGRAt+WCIiAXus15YDtEfL0DKIgb2VgbyMyUHMufwE2MtvJgIAOzFwPJBN3q7rDEPAWFjtiNDt0ZCN3GWkUNZFudHlPQkjTUm3jgjO3HpBCZImQUz+4gW9xg42CSzTBdFvDZf/pit0yFVSmLmZdAYZf92eT8ldxFhuVoAqaU3d31hp31Ud99hWiC6IOgZjWki1jmD2VlzVOd4mZt3nhs1vp0Xh8JEiqN8aitkYKQ4csI2Z5YSjPluTKdxYesW3T9wLXdzDrFCFRAREQwTAfARcWQU/5tAsW9H7xV3/3lxRVjwTgK+gaVXAJeLuerAvKzL6iISkk1mGVAsEKbHIndhZJGFUvlSUjeIM3dXMveFQ9tIM5WIRxsZNvsZI/WYRNOCep7swckIXDYXV9wRUkDpYlzmSikndpGUifcndz+Ox0WYd5+YbTDmhlaBKGUhTKwg97CoWTuYmpRYmdeDOW91vrsS7/AzB6p5gxYKsxnPVqZKyIeUbDxJfkyIFtx5mcCVIwMeHk1riN17mNWSFO+VQG7FcL7Bh/J/NQCfWeM3L2GvRPPHBhG1IGC7nMXkGRUbKCEeyBKfdiwWSSQdSRHNonczBkDdoWKTqUQ/gmRzkeUs2Ec2Fcg4EjHHeFWxhGX9mEY0QqntGWa7mGa9eXe1lneRiYgzkSdqWYQZonlfl6ltmnnNkt6VGatQGaAxE07tGnUA1Z2g9Kbqqm6UVdE1KMyXmcMSEwBbN9DbSN9bSNH8EwEUFOo8B+9/aO/2UERsAHRuBQ6agyM3IFQ/FRFVYLODGrbK/MfMGwFJqSH3pi8Zpz/32DgyTWYwp6JzV2gjkYJVXykkX2sI8isEGUo095XMt1gZWvpGUZpUsHdle6ln95l3F5hz8bpnkW0YwzG4+WLGIWmaGBaxJwqFvbtZ8YqIM6PjVjbFlMHncFbIU3ojbibNVVnNNZjaVajb1aMMEgIbuhQLtaT+1AEbY6fveUX7UgrMXajqm7rNUJCsorUPs4AxB2MsdLnQZ5rh0yoAVan4oxdSEZNxE7vQU7k/26oA3bvTE4gxFblNlbktlbJfc7vrf2L1Yjsh1XhT966ljXpFHrlLjyRzfbpXMZtGM6tGW6wW13Lm6awFUbw7smwzH8taE4mrWHqKuIp5c5J2rb6P9O3EZ/obd9O6qDu5wPkrgHdJyVW9jktLm3Osbn9wroN28XFKuaTF9/fBMXFDNfr7v7eIB/wDEVV67Hm2ELGRYzQevaG5Mfl5EVGqLpe3PjW2Kjz5K5xHMrWb7vW771+5MLellNmDYHnMCR2JVjGGjuQi8UnEsnXMId3LPx/MH3/M57eZgabC8kbttcdsM1PFxj+8Nle6fFlsT10cQf3TetCRcMU4zr9CBd/C8xIcatGqr/0p2fW05tfJ1DnQzIYH4Zkl9PnV93HNX/tMi7ewKOfGCVXKyvqsmzirwR2PZkkKAhOETHHDevvMwVuWRXOKEp967VG2PHHL/JnMuffUL/0jwnlbBjVncOWS2GU4Fonogrt2CHM5uz7VzPx53Py73PmZNL70IUcLrQ55K1ER3eFX2aB1CmpmVryPV7wVc5qqm6yvcg/x3T6zR+i1tOEeERuNpAEfLgmZvUvzoKHt7UTR3iIV4GIJ5f9xYzJ8DIJ5Jv9jauN5FfFxOccv30DtgQFGeYgdLL+TrYQ0Wjue2vd1OTjf1Cjr2gu65jSzWCxfw0hR3ao13aqwFmp44U+I9731wTwFPBu53wsmANpFLco/6lyX3qIdzqz90pn7543TC13f3d4x3sY/vrG33E7x3Sz3V8yTcW/r0OAH6q43URSr3URZ2dobqrEYESHf7h/yve4sG64uMZrMF6Qcu6yK/bXw2/MT8+5BdT5EEe5h4f2yQhumy+5xd5c5/L2CuXpAk980GYYpdxsCb3kW8ekz3UzGO+8n8e6JdVFMYVZVuha5HXFVZhW+bADxQ8Dgjvz6G+6s2dtKW+s/Mch4ff9/H897FR652+KxthNjui3b1+7Dlc+qef+quf7HUa0vF9GEbBqd947dse/P/90tf+4OM+1EPdq+2Ane20XuM3T/O+7yf+7yneBa77uwffrKv747HbyQDCzZmBbgYJTIMQoZY2cBo6bOHFELds2fJZlAcPY0Z8HDt2dAcynEiQGzOKjHYsJTFj3u7p2wfzJcmS/v9q2rQZM6fOcTpluvwJNKjPoUSLyjS6L5UopZQiBXvaKqWrqVOR+bq6ilSjOVzxzImzZovYN2+yVDnLJa2TtWjNUnmrNu4YuXTjsrXbVoneszvuLoELOLDgum/XmNlyuCsgTVdRQtMGeZs4yZErYyt32XLmx5s5Z15GLbRoz6RLd35WjZnqZqtZu242LHY1Xr9e4VqEmxUrTI/q1MH0G5PwWcSF13mkSA2Y5cqbK0cEHdFu3apU6X7E6hEi582jkPH+PYoMGS7Km5eh5Yr5G+yvXNFSHsoVggfpJ3zfhWGbhfm9sBhSyCsVXSRPPh4diGBII3EDTzojPegYS/H0VNL/SzHdhCGFGiKlj1AecngUiDEppdQljaQSjChRPbVLVcZYlQopmlwiCFdfgSWWjWGZURZhbg3mY5B5DUnkj38dCWSShO1I1hyFoKgSZZNJSeVpmlnZ2WimYVlaa162xotrsYUZZiaKwIJbb76tGdxwswj3SJzJdcddc9HFGSd12cWJ2yJ2KPcdGWqMJ4N4453n3g3qsWfeoi6kJxB99gnEEH747feFFy1ANApFPBmoUYUzNdhgOKVCqOCDUvnSkoUIuorhTRuKCOKHIdJ664gkUtKIU638ymJjMMo4Y1fG5miYF4gV2VeRQuIFrV1D+DUts0heq2SSYRnm5JMpOXbl/5TRiBuuluZm6Qw2oJm2UpdfpkZmvGPOG9srZvaBG5tsCodJLLHAGV13ZzBH8HKI2BGdHQj75iegzhlKaMTskeeefIwqenF89U3qBkLvwcFffpi2wYQJNngxiTQMcmOqqKnKlpo3Mj+Y6kzupPZiSu6E+qpFGP6TIUag+tSyrUbjOquGojii4tLA+rKUK+2+GKMmVtN47BY4KvvVsn5Zm+1ezxr5NdjYhp0tt4IsFhVq4IZLbtxbcvnZ3O6qhhmY8sZmSt+v9G2KvYGq4ae+bbqJiHbbJVfwcoUSbIcicwLqnXdEeBdx5ipkrnHF67Hnw6OQnjGfx5JW3EXqIPOHRv8bO5hchSGBxxulbN/eEnUuT8VGMzq+C+V7zrq3GuLQPv8ctIU8sdx7rR32jPSsTosyjMrS/JpKJZVchVXVVheiI45xHMGVWOabXzbZ6Udrdvvunz32j1wB4i3MVcqN/9vlortuuv179q13wSZegGvFJH41iQQq0BCDEFThygBBfQ2nX9D5U+MG4jgwXE4NClPEdupkQe5gTnMyuEIJ8ZMxH/ggBSlQlHsIwjHTOUR1C8FUCzwQAha8wRA81B5VfEiiIAoxGNVb0Ks+gjPdXaVoL1EHrI4XKwItjycdEsm3vkESoxwxeknTx9JK8Yt8/IMf+XiFJLTHGKsBUY3gu1H/GKYQBrGIz3xHGEK1+AK/9cVPbO/LI9r0KD+1HWJ7MYNb/vRHN7ttaWoBlMxryFQK7CXwjJKABCUNQYZANERQRCgDByPoG34BBzqMAwNBTDmfx4Hhcc6JnAcb1hyFfVI5MqAlGQqVStRBoTwrTEEGNJCB9mxsIPI5SEIakh+RYapkHWimDRCjNj/gYZpe8UohekWiqC2Fd6Oq0Km8QTWl5OIZG3GiOswJxaBJMUTgiJDO7PG8o3ERVhoKxS+ukQ1+8KMfZDRFD7OHRqvxsFg1Gh8cz7cFKYiFBzywYx//+NCIQjRtWMgDj9hmO80ccqOK7GjtPgovXvRNRY44Yw9P/8pAHs7QhMxRmMJCyS/o0CkNUZjPcrwjH1XGUhF/WkSdPmlB8Qj1cS9EHehYGAEWFnNjpitdG64wQ2Sy7nXN7AALrsrQKWRVq3CEY42waQvcDTFMKnOQWUWVmrDKSGrEAxWB0vnWoRGtndBgJBPnmau89qQX09gnP/XJj16YFI0BRWMb12DQMCSWoYwFwh0BucfIPhayfqys+g5jlmQdYpBEdIz+OGrI/d3toyoZ0yNJWtI/9DAQDJSDIRgih0rB4YXeUQMROrmm6CSMTjWFAhhY+rjxGExyk/sOoIhAp1parnJRwCAMPSaf6J7udE6lIQ1HdsOqXhUsceiqEbwLR/+wrK1XTfFeecPKkmqcNR0lCV4uvHcLCXkkrvQ9pzerSNeVNAaLQMGrXjeEz34IGLD6FOz8BlrYw74xjohtqPnmgBayKIuyEq2wZS/sLPnxKA+NAAT1ClmZcYE2tCF2m4k9mxLbxUYqvCBimEQRCUeodg+vfW1sb8yG1n1hpZW7LXL1FTDK+bamhRJuTXHKHOIWF4KDoqVOwXNTSRGEEITAoOlI99z7dGzL+unyF77wgw1c4AFWHcI/Z2QiRqh5zWouaDW/2og2068T24TNzNYLTmNMRY1sZe/K4mpfbuTjGved6zP0u9/++ve/IfpFPgksYAFnwxAM3cJiTlqJa3b/TW3061Yh5PBpNqzlmZO1sKlPLVFukcUpIC7xiO/n6hN7dja0btcwVtRiqGhPxnqgg68zBWw2PMELTBj2D778AxdsrshRuO0nfeNS3vrWhBE7snsIpohEJEINr4QlxB73p6A2d2CRmnLH+PBbmjI1hvqx1Oq+8DoJjFmHkuhbsGKE73zzihGAkHON7sBdxI5XRbtzm1mlkdZU8IoS4kyNn0l1X/sWxSX5tcp+wTGhRXcxJ44msF8jPWkbVLoQsmuFJGAMPrHQbw+bZfke5NCjIbwghznkI4Uva3NUT/R9WJDfyoloxW/A+tWwRonR1Rsz20EFWEzHniNi/Adf55jY/1Sv+g6O/YO+oAAFyV62DHwcQZfKcjlDvgEJTUl2KG97284RbnA52KcPDmTbUSaEut3w2xh2jHTqPqbIkmlDFozZqmyABNNxVwy1ClHfnYiEVuLcYUF0V7FxGC/Dq5J0maHEFZq4JsO3R1Y8Q7zQ8aB4O04vdIsrMRp31fisTIFPSEean5Muy39IftI99GjDEsasyGluAe1Gln3NwmMVSj38nWNYw2/gLMJPTHShF/3EK67+0qkiyaad8eU3fsOwNUXsZml9/Fvf+ghGsLnNgX3sHFTODbyjqBEa2aapHJga6H7TIhuZp4qLDuO0DYBUhmV2l3dXtmXktmXy4WULof8FVvAEJzBmZEYDYxBJT6NEYaV4i0dnGkgJBYVY3AVnnoB4KTYbKbJwJtJwtCZ6ZtU8pYd64XBoqtcupydPGicJoyBGgDV7kUYOZlQIY1EWXDFhMudYIsdQMxcCVYUBSwgBENABQnBzelRqDrV8Vbh8c5Et9BMVmnd00hd9VcJIiMZi2Kd9u7Z9LEcWmcIWdmRHm7IpO1B+5UcCc2h+6acCzhZUBINLQ8aHJxRdZkdb+MdctVQGi4Ad2LEnpERcAKhtqESAAzhdMnRMrMOADihmZEZ4FYh4iYeBF4h4n6hwkHd5YlU1ceZmlTdeVgMlUkFQYFVwCIdnSHdnNYN6+kX/FcTAejQITzUYPZV0DWOkgztIe2ZUBf9RR0h4Vcn4AkiIQx4QfEzoANHoAE+YfMSnc9eYBGeDWXAxZ2HihV/4jbN2DE1Hjk5zSWaoPdzHBru3A23ohnQ4hyZzAiewAfVIAhOAjyiAfnbYSRpUMO0RXdL1W3/YOWdACHpYW4boLwsZC7rBCv6HCJKDCABIU7/FBzHEd32XEJVYicmGAhEob/RmgZxIkp7YiaUYcHfQCJ5AZ6QYiowwTR9oedqUaf82Z6toP/ASM7NYM6n3XllBC1aBGvWAcfdAlEapaBsXItpTCjmog93QD1C5DvxkDaUwBkVQA1lZARTAlUsYAhoA/wJhCZbOuJVNKI0GEI0cAIXVGIVWmCQ5pz5XyGGH8GGtNn3iyBk6qWtleHLoyEOXxEMuF1vsaANzyALxuAGHmZgmY4/16Jj4OAEtpALK5mO3pX6/lUKMQh4Xo0LJ5kID80rMUQcMSZq6gQrQAQsehAqpmQhVVh8HqEmwKZvIhHXJlnUpoAENIAEI0IQ6ZAguIgzBWQsYKJwtEl/3FlZxlliKtTYseRVQgZKCIE3TZHmHBYKXYDUE92KkdWLn4Dve+Q36RSykIDXH0E5FqSC8qEVPd4PzAIwfF2ndQA7k8AmihpVl6QAEgJYVMHhjqQH8aZZnKY01YI0Z1pYHCj9wqf+gWcgjkVCXeBOOoGV9JneOhhBjkQB1gRl1gjmYUxd+m2IyyViPgjeiJTpvERABj3l++ziZlql+Z8AeLXR+ofM5ndlLLOQDkKIGt6EwcbKQxDEd/sIKuPCQp4kmp4AKiuCaBkkQBjGbsokptnl1OUCPKMqbvNkBW/CbwlOcXXqBwfmcnPiSbaaSlOCcxwmKpUim4uVGkzc/JEeT2AOcQikZXFhXw7lWw4mL6JlFukiDWiQUF9qewMhPAgaV82kNn8AHfIAGTOABZ7mfEiCpkzqpkCqgIbAW37egm+qW64Mk2dipODcYeuB8dslROjmhgKmhHKqOOSZ16xhzbXhVjun/mP55iRfgmBH4mDLKone4OedHHiwkrMI6AqGDo52ZA8OaHorgo/9CmsXRkA3pkKeJCqspOa1ZZQL4mk/KZVH6jrn5AAgwAGjphGYWpsmgeomnrusaLO36Xnh6ko23gfBFpylSioDQppPHnDPJZ0P0FN0pMyvhPavAVufJk+kpTz+BoRg6qPo0YANGDtbQC5+gqGhQAxVwAPqJlgfAsdIYoAIqjc50FqLGlqFaWaCKspwaqmZAqp3gjaYqYlSCYikxUmfEWjPGoWjQax3qoVZHhCIXoiL6n19JoiyQmGB5q8CUAZEJrJNphys6AsMqtTb6A8iarPPYQlfgQWryCM9a/x3ROq3VmqRnEoB9AAZUZhCSwq0NmHXxCJIdWwC9uQcr4j/oKoMWZ7fn+iLsKpQsonh0tm9ewQijOAyowYqaYKGaNgfe5ST8xiuqKE6r1xp3FoO0MJ5CyYUHOxJB4YJBwZ67JiDuyYNUaQ2J+gl256i7ubECUACr67oQEKnOhAN6wY4li6Bok7ImGyQr96DQd0ioGkmUNGMburM6u6E6a2xjoKnHR4TKKLSXOKsmIGb/mbQZgAJLq49Om34zGqNS20JUC75Xa736KAML4xtdSxzpC6QOaZq44L6LmAl9IL8AKL+kI4BO2q35kXW3qrrj2rq8yQJz+6/9k7d9S8Bcav/ASuSuYuoJMNlV4kW4LjaGCid5+lp55JWnkpsz0mentYBm5JleMcvBBuunSBkSRrmwGPpygRAKfFW6LwwLE5sIjIoGPQACsGsAGuu6q+uxwbcCMCA2TRKXt0vEb6mybsl7rCaL0ycu8xJJlmSzqtUGOKazVfx9V8wEayirz4u0uOrF02urjjmP1mu9K/qrK9pLyarG4Vu1xZbFakyPE7CPhEI4X7sO3QCtXzut7huR8JsI1xq/fWAJVFa/r+mtY3al4sqx/wsBLOAtylDAeCvJBzzJk7zAGWgi03mdj9s0wJJrMFbB4sVmo2ickpu5h/aSIDyD4jjCJWx697BrKoz/r8qrB1G3qK1zy09Apc6Ynzqcwzr8sT68jFkgYTkWCXSwjdi4oFlcNsw8xGdzxIOhar2yhUv8u2MCOFGcy79mxVbszNSyxSRwVRdAc7V6tGGMtBswxuVnxgswmcWqQjqwxuHrgG1sbOJbjwuwABMgXAo5C+ugvgvJvqa5CLBwCqm5iNmm0IyYrbCZH9f7AOGqyDvshG8gCjlTt5W8LhrN0elqksY5nicoip7neAQHncVSedTpB2rGkhmsp3vqNj+JguKUXqXRhSWsiyl8zGSxBUIAA1kJ1CJQA/KcAzVww738y6z7uhUgb7L7TJpFctu3I8rsqd+sfH6Uuww6l2ES/3Qi3MoI9zd9Awl/sKgz1s20jNZWPX5sKHItoIz+Oatfmc5ync5Yy85Qe36ROc854MZWi8X3DIe/NAH6zM/jMZoBPQt5MgvsS6RD6r5JatAGfQqTfQqKcNDZNsgGYRCylQKCZ5YT/b9oWQJrcNEZ3dGnjdoezbdh+q4AdTXlNYr2mhUwSU0pLQiDSyycwAk0bWICm2axPbNejUXgSdzyKss98ns5tJXCzAFbmdQUPanNnUPLKATQNGeVoCK8IApvMNXRfKBF4MZuDN5qnaBik9Xe3XMXdSK84CAy+9W09sSp1aoeKmxpzcxs2I753byHKbRyXbT9bbSL6YZ3vaLfq/9C4Y3gbtyoyTts9Xy9+bzP7txJ1PG1eGLhe9y+YmutMXwmq8nhdoe/lHK9/bvDG5ulUELJKa7iqa23qy087ipEC0fTfhu43CW4bAa5uhMajsF5v43i9Tq5UpK5gySv18TTyd3cXankSB2p0d1MYEkD1I0E1v0k2hkmNSkWRVzV3zze5P3Mumve00yXp2yww+0NYK3dUTzf9N2oPZsWVLgXbO3WzgvlAR6id86Y8jjg5rfXf628fp68DijougyHW4ePC3B+E46I/tIbFn7h0+rY7hvDkz7pZ3IKrRniaQBvF5DIJb6fR0AKAbTioJHAo27aCFwMe6uuL/7RVOGv8WX/ko8HcDG50iydZgSbXr5t6y3y4hDqu46k00ZuewyVhF0Jsl05b2JJzjj0w471YHNW0lDhYpEQFmJTfGAOGAl+3oNR3tt+sultBh2WCi8boWYO3zLGa686dfSN1vVdNnIOtEELj3pO73rOhuxs4Af+BN181ljogG0+6Pdd6HK8omBgB4iIJ8eh8IrTvo/Q2JL+2Gci8ZKtba7ZMfvxkZ1uAP67uieO0Y8xNaYulCKf0aeu2q29eMDp6qnQIrzePR046zau0tjJ8tzzeCw9471+YqthDMbNKzpyBMReAky45BQQfMP8s8uIVXVE5deU84Z7aylH1YAB3tkY3lh41d6O/2GJMZcPWu5cKFJnqO5pve5lb3VabAM+nfRvKKtuWJjviN9r/QMG7sZjwO93j/fIC9i8Wh7egfDacb5pYoiG6PCLMKQO/76STumTzZozzGUPGK6wC9qvewSE5Bkjb/IkX/KQnPmwDgxTAZRaodsmsgm7TbClnIGykG+Rq1YwL53TFF63TfOWezWyT8p6y/OcbwuOl8KKm1BAzYTNVAIlINQ9t+5mgQRqX0dqM5ekzPkndgv4+uW668xdjvVefiRafy3aTzarVpdfT2uxsX3gk4blD6uu6mutWhdyjt/t7/76Hfdyr8bfl/f1r/f1fcU1+n6KsBsAgWqRGjJqFC1CiP/w0aNFj1iNW4RLYkRcihShUgQro0WOiQi5SZNGS4oIEhBAQGAgpYABLFWq5BEp2DNn2GpSW5YTmk6ePX3iBGrsZ85iyZAVRQoMGCmmpC49hbqpaS1hu6zaykU11SqulKAy8oQ1WDBRWyM1YoRHbRy2fvxc0hRXE1RBguC6SnVV6F6hWLc2ihT4LKA3c8RgAUKjRIfFPI4kwUKFzR7KlQu/yZJlzeY1dfMA8ppK5tibO2l6q5aqMJcqrJ283gGbyhImsmnfxp279u7bRXhnno079vDcSWoXR77EuHLgwM2YAX2rGupv1a1bH1ZtGC9RlAu9AaRH/GQ65cVX/uNI/fj/y17cA9/S+v18JcyVDx+SnDjv2mj8nwfQPAH/YKNAK/x74kD/2tCiwQahgAIMRFARiKCC1LAjoYYY0pAhXBbJCESORlQkkUz6+AhCK1C4wKSUXizgJRlpiISXYUobCscc+eLxp6SquooWpqKKaiogjwqSq7/SimMKKeL47BYpn2llK7PSWqstRuhSyy64lNTKFzHxMssTMwUjzLAtjqChTSTMCNCRSNQL7I89CsGTMD0BYQQ0M/MiTRtBT5tOu0owC842/RZNlL/dxjjut/qWg6wHRidNrrlEnYPukE6MKfS6dqgDB7UbKzkkz8rE85Qy9V6VJFbv6GivVszmc8/A/ydcw/W9XRP01QlgFxSQ2ACLNTBZBtsI6YounoWCj0Qo/MSjgsjowyINt43oIG9JTKTETMa1FiQtftjARRljZHfGQlphJt4d56XXqB+PBFKWroiEysiqkByTzKaewsMIIz74wAgx8ujESlfG9GVIgt2iOEstt/ySTIcj8UQwSvJUUwqR4ZyzkljlrKQTj1f+GDBOXv7TFmVm3qbm6wrdzpE1NL2050fR4GM33yTtuWhMM+U0umdCvZnUashCFU+PYaX6ZFlXtfWyLyZ7Q44CdQU2bLHH/vVrAu1EWw87/0PWvzHYUHBZOECiOyQTPUrkjDNQ7MOgg7gVsaMR+/CI8P8TUdQ7JC12eOAkGNeV0YEQAIFXXnpN07FegMPMd19+paLl33s3V3LgO5xM+EmXrVwFL4iV0pdLt5pkq3YvAQUUZpcbSZOzzUwGPmXRhB/+rI+PpyQumFOhuRmbnT/n+emk+eUQnolO7rjiIv2km0980AH8/iDb1Dgd7KPU6KPXh2znzyiRzunoy6EO51uIjxX4svYvZX+rgTfEnb7THq95rQ0FNE/XyvMEsCXraw4026rkQBn/rA1oxnIgsYCmOJHwgQ+E8KAH3aA3vvntb4soYQpVyDdCfKRuI2kcStrlEhqqpARsqFzmLoe5Hd1LK6ETkuf41TrR2cuIpHPYkur/ApgkeiVjECMGwMp0CUHUzklawl0wOrG6wXhmM4WoxP6GJ8Ykso5jKYsLmGhGPzayMXo4u0b1ruca9W2KCVboXjcgET7tQWpR5CNfHdl3tOcQRhQzYdobmfY0sjSyFY+E5CEjyT//pUyA7fmOHAoBBwR20m1bM5vZQPlAZI2Hgmw7FhrepkENxi2EGwTJ3s6ArRXWUoUkTNwLWfS4l7TElwIggOTykEOb7DAomivKD8EUxFVsYoj6EgYy8eUXsThSSn6Ri7/GxKOqNHNiWdrSp4LRiI6pbIu8q0tnwgjJvBCvjEmkZhaV4UZ6ngMd4UBNOKTBDV1Igo52BCijHGUN/3qgwgo+EB/2ync+QKZPkOX7oqcQKb9FMrIvkLTmJDX6SEuqqhBb6+QpPTnSUpa0WBJEJQZZuVICdZBZaRhE4vRGSzLsjQyGuBa2CjJLvckyl7EcSbp4eYAZEtWGZmgFLyyHTGkCUV+ggGrpPOfMp0D1XzrsIRTFNLOx+NB1SVIjX4IEVSpazE9oWR1a83CHSFCySl+Fa1xfd9U2psOu98QrPrXDHfWYITJIy55uEmUFPnyCHutIBEJ94EftnY8KOmAo9iyFPoe2ZpDoi+ghRFHRpkXjNNzsKrwyqlG8RM2j3/moJlBKUpOGtKRpO1YqM8jSDS6og26IaU9nqjec7v82pzV1A3AT56wuWEGov4Qcch3wAaQGqphMxaoRnzrVqTiFqlQlor0yZxqA8aSrxZDS6DanlzHNpU/hzMqPrhk7JoUhDFvshCd2h87oiDa0Yk0vUkBbGujl9a73bIYx8PIxNf21jgrdTR670Y3E+kCVjkJfbXwTyMo+FFNYiOgh+0vR63D3vjy65ljs28jSzgVkE9xkbFm74tYCyE5qS8+r0sY2Za2SlXyQmwjnBodBzE2mN41CFLpwBhn4eMg/JW4XSAIj5dYQmMvdQiV6BN0eUsWb13XmkCR23exSeaugnaZ+x3sVp2AJLKHLbzWVIaX4nhe+Z0xVI+7QCA2TRqn/PfouXwIsr3glMnrpKJQW5WuY2q0JMW+CKPsQzL3DLvgTioPwZJkwtMYapwgVvuxlI4PhQgamGYDmcIc/SxM+c3W/WSFLiTWhqsKweoKrZXGLUXkePhxCxuuZsbJUqVLb2gnHLw1E3czVBSAL2RAySHKyoZWCDTB5qMhVCQSA4Ai+PJfKPckXlrWd5W2j2SjWBndTuzvmcadXqpyzBZgaNhazpMqcxtNTJ0R7IxvRe9TZ4eyG/XtNTvTpDptx0hQMPfBMKzqwTIDEOuix8AV7Dw2Lxd6l00dhwBYcOX7tjGarsc9Qi3rUHz81iYs3wKyFNNcSlG3K0YCequFaPDRu/9uNXzrzHQfbyM9CtpCFLIMzQCvJ51ryAJ5d1HZhQAoyedq1fWTll33O6dx+GVW0y0Oqh/smX8YXucOc5oA1sUxm0l183yxfPtnlFvW+kZ6Zge98m8p+Ykfnv907dysS3MA8I04SJH1wVCzc74dFRdAiLTRAStjwFkd80trKcc56XHrPm3IUv6sxQ6w6a61+9QRPnnlYp9xVML612mQrype7+A8HRNvpA7F6Tqr+WYZ41o6jgGxo0d5BE3A20XVv9NEs1ZjYDuJ1MTZ8jG07y1LPUdW9XO6tkzdg5xb7FuXu7ne3bK0Mk86e+7x9PzsP1NpvsxfFUGi6z93ud8d0Dv9is2ja8MEaCv87PaxBiF3lgAmSnnhDGYrpxFM2M59xBF4Atflhh45zPKqTPPxSNTzxnS2YgwcsDM7rvFgbEFdpOVybtVI6G7ZJvQ7swGWBvZrzOWf5OaBLgNyDtqJyicnRsGOKpqaSBSzbEoqZwac7PuTDqmNavqybJtjxwR9kpumShXSTsybpGJaJs3+jM+1jQu+bnv/aM2yKu7orP9o5jDWJg/PrP4ObjcVKhG6IP4YTvMYavCKYsLzbwkzrtBqRBvkpQMfzLHGQQ886BuUrtzL5jgJbkzmQjwhcLfAoDwUCRAT6KA6MsVcpBVixNQsipQysoPTwwEhcmz/oghD/3Jov8LkHgYJlQZcT9CWj+sQUdAkI8IA3kIQ7+73nsoorm5gaNDPjUxK6ArdBmUMd3EEgxEWn0kWpiipKWKspMJ7qs77P+JQ9M0Z9u6sAs5K4a0C5c8YrhEbzG7jHWJM0XJ/acDBUgL/4s4Y0wB71ozTfkLjJssaCK6Ql9DM4jENatMM7bLfvYAtqHBkIVKDRq0fWskBHgARIcIRPqBpbSxWYUznQk0Rf80BMfIO5uUQH0cRzyYAYAkWiCkV2abJSbMFUJIrYEb5WfIshAh1omrpiYkeg0EGrwzYxKyIfPLddDELogyomSR6XOaPwc7fNasJAAz+yY8brW5hm7Mlo/4TG86PGctSNbAzDhVOEJ1C/+yNDw+Mj/kMCokwUYpyozlrHq8RKHnLHr4PHeAyD/KjG1qiVBGoxlouxfZwE9fBHRSy9gXzESPQgSVy59ICDhBylA8HLvESBkojIvkzBTyTFLJAE5/q9bmo64/NIb4OdnhjJxiTJkVy6lEQiIWzJZXLJXkwLM+EieOMiRDpGdoO761NC0fRJgAPK05zGoaS4/mNKbNQCVThKcmiDpdyeSzM8iTs8/5PK9xEFAXRD6aGGrFzHKNqJBAySWmAd0ehKoayC+CCgArrHCsxHfSyFSUjEqrEgFSu9guROuTQgzMhLveTLifRL3YuRC6gCKf9DQM2hLqjbMqfgisUMSaqTw8d0TFvMSMnMz8pcScusLl5EnjMRULSKvnUbiwLdSc8gTc54RtNsQNQcGS1cTXI0OPtjAoRKAzCMP8SCsEjhI3GcUKnEjec4R3gxQOEEOeM8TmVSmUKoIgZ9UILLlbIkyFipzgs8D0d8uUgkSA9cxIPMNQX6grz8AWZLgFEsz/KkIckRTFQszKXQshvsT11Uip+4z+C8UvzcOumCncv0z/+kTKtCC7gjJwKtvujrt/PyNwVd0NI8DAf1ya8cuKCMysyo0zQ8DsVKhG30u25wAwvdAUvhDzMcGr0LVMQASxHVnv8DDd/sOGhA0fVc0R//ekcv6p3UtAEhaA0aPcRY2Uer8SCXU7EXA71S7c6CnEAiPYHGocgkdTIn6wDBJCYY7MX4hKYfykVZtE/HrMUs3c8t7Rz+9NJbpdRlRCsCDdBW8RTAONbry4MtEc02dVMIZU4JRbzIMp+lRCgr2NMwtIYVoc3eCMfcnJRErRQR/SKbzCuniVRSK87xssxU2J+z6JM9WY1p5AEeqALpzCQXQ8vqBFh+FNVRVZu5hK0OhLEf5VFXibUD2QENUBdXBcVXParB9L16YUkgTKYfzDrG7NUr/VjHtJcq7dh8ydVcDKt40opjRYs4Y9lzalaGeZ+1WlNpjVEsxNmcPQLU3LSo//TZC6PQCr0/PnKwbo0/VLgBQFWUEFUCnxUCcwVac6SwjDPRtmvXmjgKJFJZNrM+PNEDwsA4GT1ECepAPkhEgAXYgW1L9GCVRTTVlvJORzBYhC0PDjwgBImBC3gRGWrVoTMAWE3PyMNYpypZLtXPXW3M+gxZc8hSYMWXk4Vc8RIT+mJZZm1Zl1WrmZUzmh3Nad2Z1KTTncUweWwCpzXdoOW/+7hQbNRTPl04WDgopXwPNMQUS7Fd1C24c/U/9wmPdapavbLaOsQzjYknMUITly2MBoQTSAhYtARV5jVb5m3e9Xgt7izY2JrEhT3Ysyk9DXpYvzVPig1M9XxXcXNcyf/NWp7gVSxlX8ZdXMjcnJEdM47tQflESZS8Psp9n8rVE/6d2WgltJvFWdGVU2kk3SsMgtPVXd2l3ftYrHAtWtddB9gdjvrTzfuo3fygUE0t10Ai16kFj86oC0+RJM/MNzwDzbiipOqLM1v5g1L4hVAoBRmm4RuV3ua1YeodVbrdXoYl1e2Vk+vdvGJhlicwAVYF3/Bdl1itBCfFT62UXPKSuvNFXJBtX/e9z/MtXJINyfRlvqxVK3Q6hP3d32bd3PwF4LUi0c8V4MeQAp0NXdJ92iFQ4Ezb4DMkWivouw1NygbOXdztYEqpATy+OAg8zU6R14cR3mNIO1BBxckr3kT/Nl6U+do9KY9TpOEarmG0nd645N619VHYAmWUy1FaK1UhztFl8Q/G+VsUVGKiY9ImxpEX1NL6nVSskMyOrWIrXt9B2U/DPVwvFuYn9uL8lbMkjLNUcdYx/l80jtY1huOeReADLt1qRgJrxuY5NlSo/eDIak3F0mMJhoU2kN2hZdrbDeRApd1Jq7RMwYwBfuO5e0A+SZ62kuQRu5FrIiMx2p8/EIzKKJkb3uRX0OSCLoVBCNK1fdtUEWWCHRAdXei6ZZAcgNiIldhXJioLaC6xSr79JNaPVswvPopdDtkrtuIv5uJhVmnoaubPeJ9kdmlljuk0ttnRZU7RpWY5zmYF/77T+iBX2qwBcBzabTVav5vgxRGOP+4BbQ7RoB5ap0ZnQkreaXRQ95oCKCnjlAkv4ZUS/rln/2kF5u1NgCXoUuAFGo7hgTbo6wzEVYogs1SPhnZL7RxlW0vlgzoBT0xijAZFDniDUiDMKlPJKQ1pWx5mkuZl+E1plNZVpVsGl4ZsZgbgM4ZsmlZjAd4Mac7pzb5mnmbqy2Ln/WssiFvdLzTqw0os9KHdDdbgzz7UvIMsycKUNbjXOc1C8pNnBh1hqSmLkgkj35WkGUa7XyDu4i5rU5DhVzDuUCDuTKZhR9iDAiHR6HzbSZzrk/I886Bb/wg6V45IiiVPyaGDpNoLYv9GksEm7MXe4uR738QOCi127Byx7MqW6fmu6czWDM0+NM7W6c4+XSBw7YkDaqHG4Ke0v0ToB/hTONmEym2+XaYOnwffATzWgUFW7dmubdu+7Qctgs0gvzno3cDgn+Em8bI+buQWbrRO6xWvYehmA165FfKgNbUNkLd5m+zOwGNhRFXyARCw6L0G73aBABbYg8C2xWBNby5eb2qoUvZW3PbOYsZ+wSLCyMO27yt/5rVq4/3W7/7eac9+jM+etOUYGqheDnMuSvsbhExABVYAw3WYBD928A6W8DmHrNi2UKYE5OlmjYF70Af0SUGAk3VLqqQabuNGdOJG8Rlm7lc4a4L/PutF32R+9BoSZQ2tiRNc+2GIxvGy/CT1Q2IgD3KXICrJMQQjd0H0BmkqDmZa9lgshnXEBor1Xuwqt1Ist++fzAM65VmcFkov9+8EBvM7t83CC23IqIH9249H+YEfOJBTSPBTWKhBqvPWvvNrN59kD+rXDuQ+fA46dsD83sN59hRzwiil2ifiHgZ1X3d2/wUbMYV3h/fjpneCjuGzjvTnfrFLh/Ebn/GxVTFScujrfrD709saSuJRp8gKUIJTXOSTRPJVb/VWX4Ymx08slnXF1jr5tfWV1vJd50ksR81e//Vg529hN3kAV3mVv3OiOUM0V/Zl540n4ANY+J4Lp/Zq/19qbMf2caxzqf72LMAkWzOZs20Gd6ceeaceEt+OpjeFed9kSUdxe4/06Y1u+uB37bZe7SS9OHGt0bvQE4DYlUD4V1Z4ja6c4Uz1LiXcwhXmw631izdp9yYKiu94j3/mnsz7kN/1n8zsS4vjLufyMLfmlf/vOTb8BLZwM5Qwp0ZzD60wCAOWS9F5CK/2HNh2nv/spLnkUyRr5W6GT0D6dnd3e19up6/heV90GD79E5eEfUcU5+SCQaxRhL1xf+d0CZRx0iv4GPDx7xb1GQLvUrwztV97wl1pu09+Jrf4jJf7Wp7ylbZD8+aJKwR5kMewLM9+v8J+mw78Ay55wj98lP9/2sRXfBygtMJreZgX2g6tODp32p1vec2PcJ6P2kvHoUTX/9K3EYD4JXAgr1fDDBbkpTDUQlMOH0IcKLChQ0iO9tB5w2XjliwcNerZ82ckSZIh9bAJOQYlmpN0XL6E+TIlzZpPltgA4aECBAM+BQhAMEBo0AJGjwJNilTp0KYGQuwZdmwqtarYlmHFCmwrV2FekYENK/ZrMmBZxVZFmzat2bNWzcHVJnfu2qt13SY7O5YsXrfQ/gIG3FdMnjxYiphBXNjMYsN5iijGQriIZDGWKzc5clkz545KOh5GIlpIEM1ATqMeDaO06tSuSeeoUUQHEyY6ijDBbZt2kt49lOz/+L0jh/AkuWsjX2JbeXDgvp/j/D0ENnHeOq5Lv74ce3bSnj97NEMHkq7y0gSWl6j+V0GJUg0SfN9QIcWI6htavIhSI+jwIE8eUpJMNLG0kk0zEdhSSlyw8YSDG9W2QwgYYEAUAUBZOABTS3G4oYZIQSVVNIHRpVVXfOW111ltobhiW3WxaFc5JcZlV1933ZiiWlmR2GOOWS2GRZBmYJHEY4UVCZlhlfW2GZNJbtHZaM95d0SVr2HJmmsvkIZDl0ngNttsuWm3XXPQLdFbhMuxmaZzb6LZnZxz9lAdd3I69514bJCXnp9+rncfQqEg1N5B9UH0kKAOSdIoRiBV4ZGe/zT9EeBJlca03xibctrpgnvS1JKDD74Z3Ao8OfCTqh+y2uGGShWllANQmUIVjSuqqCOKuy4TY1i+4shjjbf+6MyPvBbrY7DIiKEYZYg1m9iSji2JWbVPQinllNteqWWW3n4Lm2y62VZDhNbdeSZxx7WZHJzvvvmlvHSmS+WZTfon3iiACvRJoP9KtG97Dv3CUKIHC3TNNQWXUkqjkjyq0RxecAQcxZSaRAemCBroaXIVm4HcqMm1YILJJ3fQU4arxtrqAa/C2qpPtE41YonHksXriXuxCGywxP4cdLDI7ih0X84WiaQYYwiJ7RpOg6at1FNzG668Vtswb5z0CgGvdf/utuum2KXSqRrXZaPJoCOE8lswfAAbxBB8psxdXyuvTHJ3rXH3Up4p+WGUERuQRgrhxRgJiCDHgxvuhOPTQR55ySiUbLIGl2Muwcsxswyzq53HHKKtQONKtIk7F5Nzi2/ZKKzRyfZletGvA4kYZEwX2ZuSWUDdO9XTmRZ51a1ljXXxxyOvNdpkMxf21mreS7byzk2PZ9pUbMRneX33/cs02UyT3r8FESqfwQe38hAx6b+9cMEPR3zx4/MfLlLGijs4OONuBldy1iZX7mSWuwABC/gACagMdJz7nAKLwioWROUZElRW7GTHFVqgTnVgYZ1gbkQ72OVKdiDMCmaSVC3/IvkOW1KLWvCs1MJudcl4yZuh8s5mPf5ZJ3peY171bHjDtKVEYCWZxDXmMQ/xrSduSqRbRBCWt7hxIx/d+xvEBKcRihUOi9nD2Ejwp78Gza85JMiJAC9gAsxlDoEQUOMDIrCTB6xMZp5joByFAsHRURBGGnTRKvqIwQyiKI+uG2HQQijCQf7oMIwpYQpZ6EhHulAKrxHe1cAVQxpi0kua9OHZasObse1Qh5y01/Kuhz0+jeIPQmDBabLwBEno4nvf695Eyre3hDQkfQ/RZUR64T4qGkJTWmycFrkoh8UhZ3/NscEYB2jAA7JRZQls4+XgKJRrNnCOCmzVCyKBR9KV/05Xv/LjH3ehwUCKI53q/CA7xenO05VldrADk+2k1UgVOul3+qxaJvvpz9KM8jcwUJeZQAk9g1LvXpELqCnfJAdITCIQbKgCD1jAyiWsTWEKO0/ADkU3jxbEErvkJcGy0b2IGiKYhHMcMbeYqcAdaH8bOVMzz1jANeI0VR0qAAIbYE1sxlGbQs0QDyrxTXDGsxbnpAU5AZkrDnaQkCPU2SEFySNnSYsy+MJnth65zxpeUob/5FIMeujD3dRLlKBUKEPrBdDnOccLDx1FKP4QqZyEIAhc+APbZFnL8hEqsOw5WN56eZ5QoNQQK2XpMF2quAMxiFQsFWNZbcoBVKmqc/8+AapTsum5oSIAAjxwhbIE6ZVy+gIsWyEnaivoM9PKk0c4O6eJnorIHI3BdljILQrvmU+vvjC4lRzuWP/Z1rOGMrnB6dpx7wTXlEhUCTiQ6xBWQNaQaQ98vzSU28jHxIpMorB0S49DglmIxcpvmDG1yU3yB7Y1CScHOUCBBnSa2aRcaIFy5ByshBq6KvjCZnS52VpOuzNzYrCpr4XnVwq5utu61pAGrmA7qVFPyiTGt1yVZJQ6LFx+EjesxTVuQNOqXOWalZOruaFcJ9qlu4YgxjSggQWEsIdSxFId4euXLQOLPl4GLKLxu6J6vfCg9bIXjO0V2chGZYUnpOAEl9P/3H37+1n/8nezr3rAG1pxVALDs5xiJqeOXNsVCJdZqg9OnQVN97quZgbOVPPwVz8cYtSMOM9uBSu91Orn5h5XOZGtDRinw6UnHNOiXUvJJLwHPlpKhLDiZdv7qojexr0B0aBCsv6OzCkHierJoYbyfCNgTStnOdWozq9mM9QBL9RqnUg18JhP9KIftdbBC3awbXsd219XRc4b5hZww1DnO+t5xJV9a1l7sEmGIvSgfyal2QDtUOnaoMV/gERg6+oFQ1fUC+Qx4qN5TFjwCja8liayXK94k0xH9rFJHpynO90gK4xa1O2VMhzxq+p/AzyOdnwDMb68DWXcjNYInnBs/wWzcGHw+p2zVXNVRxhnYV98znTGuD5FjOdk09BkybM2XHFocraSPMXZg0EHQmDkbQdWF6OI6LdL0HIbBGK8s5R5JnrOxMKGN+iEUrdK08vuYsZU3vde+tKb/GQtaCENUH+yg4IzZQYGPOtxDIE3Cy7gCc7o4A5fasOj+nCo6hHYbCma2n2NM7dkPO4cT5IUNm53F4JYrCBHHllXHAS/l5iyOox2KFMcaItVve87YANfY5nKjOA123IYSc79qkSRYl7oDSP6MY++vwaBPkFKd2/Hms7kp0c9DVK3wg1+UPWSJbDKrG71qrWJABYYQkRfFzvvKSxxD/5FtbemIFcijv86iv/e7XCXu52Jffdj493jew+5ohX992Zjv8/Zl5PzTq4uau858ATdlLNrYN0YK0EOlgiEE6Zjsur3bweB2JcvewELniM26OEdOuAg1fRMM53oPZaCzJvTGSDUtcHU6duT7YAJUFmV0d7sZd0aFZVU1MwEIRwzYEPYUdxdmN1WbBBs/Z7Ctd3bjaA7+QrzDQ+x6dNvddz0FZfIySDgbV/KER7KORcNOlsO1mB3jM1ErUCMFZAJLN5NDEH7ORMEtBwrfcFIWAL9nUIUihRE6R8VjcR/fEEWZiGSESBMhFoXhp4BHmAbqJ4bkKEC3kTJTNkD/oQEetaqGQAEHMFHiUj/NdhhM6DDOZzDBmKgsUgV8ZlTCEZV2iWVrS0c7Ayi77mdz6ygCtaZ3XGY3sGg3+WE9VXfDFpXD4rfdpScyYWfJvIg2iAHy10OAMXfEVIXXrWcGV3UywUCIYzC/WVCFeqfRcgBFh5TLupiprQB4nSRgnxhMB6gGKJeGZ4h1TVHA+4EBL5hqqXKC0gCfNihNHhDOqRDM2BjNvahH3IjIn6gICZiml0QmZUgmtWWz5zgizQi9H0Y3kWinU3iDPWdJXLJC2CiDoIicsGViuVjP2qHdIyiJj2OM9nAFgaQALVAcJBKG1gCLMhi/unfw6SU/fTiL1YkGpiERbLE6DUd1VGd/+uB5Ec6mRuYYQJ+JEgSRxBqAGZpmX0xIwQ6gGjJlSjwwnlIw0ZxgzbqpIy0zuzMWjjCiCwIJSkQ5a4BXzeGo69QVTh5hSWtoyNCJWpIkiTm2TzW41XaIwzMICWeAD/akCf6oJ2Q0rN9YlmmTW38QP8I4U4QEBFSllt+wXJZlgmoHyxMw0Pmn8MEXaMEQl86Ah8AZkkIiEb2IhgSIAEywb2JYUg6WeqV4UnKF1rGxmXpVEy+JExaJgV8wAcAAWPoQSUYVSk0g/vc4U5yYE+2Dk+epjKUGSCuwibAZh+lCGomn18AIm0xJYo45VPy5tRQZTxi5VXe4/lZl8j5o/Y5F//4jWUoil9xqMl7/cAZmaIpDocT7FsDZqWiJaQVDMInRCH+bV4tDoJfBqZgmmfiBONh4tt6Oll7iuQYfqF7Jl7K5NRlumRmUkh+lgAN1B1j5EEnOEIn3EIw6KQdrmYGIiUfbsOBtiaCBp8sbAIjXMImyOaA9V5t2uaySJxShtBufkv0pUZUviOyAWdwFmd2nuj7EWeMnSig3Yad1MBymqVX0skPShcRkmF1iRFBtpgRDucKRCZf7RxEimdgjqdFlOd5/gFGLmlMHOYYLKAB3gDrMeYwyicyusupsKEb/kRmxqRm6ucHxNh+GgFkIMYhHEInqOmAamBpsqaDtumCciD/gyaoBJkTKMAmhXqFgl5oT7LZn94WUEqY6XgoDIFo873jiB6qiQLnj6boigphBXgACFDncfpgdhQUjVrqV55LB9RYGsplpLblcIxKDCAkdp4ook2Cd/oN/6EbFSJpki5pRd4PMKZnlBJjrr4nMaJBFqbhGvLUfXrpl1IAmG6mzZGpmWLYGhRGIzgrJQioLUgrnLZpnFrrjFBridSCH4GCUO6phdImoDZonSZlxWWF8axjiMYd1oDo/5SocD7qilLqvFoAhXypBYRAV2plpXYSdsTojGoqwKbJJ5ULEYLq6+2EdSHaIEzUKfaPlO2rAMHAE/DBqvLcJ4RCInQbkcqq/2DmYpOqpzDuaq4SGq7Cp+qdoYKUC6pkZpfm1BpJKr5ywJjGmLKa6WVYBrMKQrNGQs8OKJti4zXmoR66qQZmazDcwrZ6q1LBKe/1qbiOK5hh6Dv1zPUhW2ukq7qehqJmSXAmm6Pa44qq6JTZq5fi6wroa9puqlgKXsCuLZ4kB0b2wE4M1OslJMnYFAiMItrqQLzOKw7M3132jXeGAsYW6Xgq6S/yoq3mm8mS7JWCWqidIR8UZso+mcmwpNnmZ73O7JiOy+dyGM4u0tOQrs46a892QgbiodDuZLUSqDG8KQmSK4NCrU9q6KDmytViLXEtapdMJQ/0LqPGo9+KAL3qxP9lseywrlEpbqq5/Ku5sG3zui3ckqqPimp1LkcLXAACtSWlJqOpUM4JjC3mGCx5WIMsauwTWgIshteRlkQbSNSsKg7jqifkOm5jNuYXUu7+wq+RBqbU2cYb5dTmcu5+0uyMgW5maBXOim7pNkYePGu0YuPrtm42Iq20KtW0quYGs+aA1u7sEiKH9oyKFGoJoytpTGXweu3wRmzYFu8LsyXn8kTZZhYFGmc+Ru9tvOj0buoNNQcTWAGYrOSkcoBbxh/CipwVpAGonoB86UD4SqfxlqIWEEIsoa/6rm9EIS4c9GVfaoxhbmTj3u8Yp6f80qr/ovEWy8FNnFHKEHDneq7/zcqxss5Y3I0us1LLYjRCz6apBAOtBV8wBhdD03oDnf6hCZ6ZhDllnqkw8P7mI2sSvJqfvB5vDM+wGrnkhdwrpapts61LSv7jnrUtD88LDhMaqirsr0rZExBCXAIQSGrvqLIeFOdt5lDTDrhBH9jf/Z1C5mlxFwPzLgrzGm+hr+rqevYqMvdq/3ZsSaQxYCIuGovKCxSwDLNozX4uAsuGNs8YNstG7twxHhPGAzdrs6bCzwYyOtsCgmrjHoYdIMPuB0etIrYZMnwcVfamoUJynjmq8SIv975sfWaWpPIt9m0zbcAod/wrKV/tpcItvSFh8dZyG5FqWorvM3HvCYRv//huABq5URuBtAk8gRs4JCwoQvoSwni6ATBP5DADYzGHHjEX80wvcwJS3jMnqZHGqv9CwiD09E9HMxf0Lc16rjdn81F384QY8DdPydP4Zzgz8B2U8+mqaVX/sYFWKzwj6NTScz03ZYmGiyPvM4nhANjKqyVfckCHVmayGkFjn3wtdFwzJ0MP1yg1bBX4KAFR0wZMp3xd7k0ZLH1xsg9EmalVE0hDkwJoQAq0QR+cgkmvL0kOwkqvtE0bQuW+BE1rNk3b9Kx6NjDjdKwCNZKOdmlHs0kwzSR3LlJvMzcnNbIe62bWcZz5B++gEOkqTemOc7MyglWnguoWKMJRcOyOa/86oqCvjTW7inVyRzJXOncLqyhxonVaU0g0CYV1b5Zbl5W50EaM5jDA4mMPn9V89kAbQIIV8JsZjbQW0Bdf/4AZquFi5ygIGLZI/0BhIzZiJ0BPLbYbZIIspvRkr3QgwO8ewAFmrzGC5+KBp+xnOzNo6/SRSrhP/2XFVqxpwypQV7gao0FuTDJr51WIE3U1f4CxYvNW9QaRTIsD63bOPvAeC6jq5iE2XoM2bjVXJ1WOd3VeMHfwNjJzjxUl60QlXzJA41Q0SYDMIlCX3hyQXodsxIadfLd4UzkoChob4EC99gAySucOcDQBIcAJuAGUUU5HHzZ/Z0AGoAB+57d+7/f/CVgBLGZCgA+4F3sxGTJ4LzL4nh84hPt5F084hQfCaDsChlu4T5f2XiL6osdqh1OBmap2UZvfWoqpmJJ4bJ94ihMJVDcNi7s4ZRBGBK/pgPLCcIerceP4WKxwj/vucv84kEvyWf8zdR85khM0sF4IhfytE6+Ldix0ldM13AaxdDexRXe0pIK0EoovCQxHmQ+xTz3ABkzABETAtKPAtJuaArR5Ym+A6+UyIRBCnYN2ShE4F7P0n0N4oDN6hmM4UIfnhbO7hmf4hR+6XeXWpB/wa9sc8hLwBxTwZoqANhvHIvmHU0O1Ay9JzsaBVPN2t4oCtRL3hq7ZqevIcl/l7uou/5akcMaHy6o3d6zDMBFP903Zeq3L7E0x+aSeX2w8+Yv+enaMcrB30qcNO/Out4TsdQ5YQQ50dLGPuZR1dAaMwA2gAGJHAAq4wLVn+7b31AOggBZMArindGX3ObpbPWgLerxneKNofdd7PWCWAr27O72jBBLUALIWtQHvuxv3u7+3/bhsFek+SYs/MAPbvVRTwoSCwh9H/HEPsjnGDqyzKzyS6Mf/E/EWryU/AMkbea2bPOOn/Av/YwrUQApMucy3VWJa72FvAAJGmXT+AHuvpGErMZmfQJpvgLYrwH4rANJHGX1he7JLADRd9wZw8RPO3C9P9oQHeDQPukUQuiQcqf94Av9Pc73XI3/yW8LYw6q94/uYsr2n9nuYUv9qw70K6gmz7rbC272Lmy4n+HEqrClxv+48v923XP8i91Pv+rjHGbThUyLIw3Dijzzj80TjRxPy/nOXqjxArKixIsfAHDoQJlS4kGGMHg4hPmw4EYdEixKZZGSyooKEjg9AbhDZ4sdBDRdQQlCp8kKGEyNRTNgAckACBTdDTkCRwqWGCCCBNjgwNEGKJ1rSEFJ0iikhp4QmQR0EadIgQlOxQspKlWvXSVUhGfI6lizZUKXI8imrle3ZT6VK8ZHLhkqQgRjw5tW7l2+HvCU+hChBg3ANIIexJMmyOHHiPFge55G8JrL/GMuWJ4spcvlOmDyUPHUSPbpZaWWnUad2tppZa9avlxVLNvtwbdt2DQu5rXs3795HgAcX3huGXePFkdtQbmJ5cufMBUYXMX06Bw/XUabsuN3jdg7dwYNvYP26BAcEDDhwYOE6wRoFc8SfuINixIr2L+bXrz/jmI3fK2ipJBRQOiG++Fq4AAGWNmihhZkeaNCFLniKYIEIGkyhQgwz0DCmBxI4YLyXGlCgwaN++EIpXHqB5RRLYIQRqq9o3IotG9kCS8e1auTRRx/hogouPuKSa48xkAjBgr78avKvJfNSkj3BqAyhMCQUY8wxytZQzIzMHitiMzEeI9PMzjzLg5HQ/0gz7TQ3VYsTttWQoe223PAkTs89feuTz+YAdei5QE2QjrrqyiMv0SXHAzA877jrTlH10FOvgul0SCG3+ejbz1P8QA21of7oA+E6kn54cCaRfiAEjh8gjDBFnlBiYIMfVEhVJg4z+AnEBCa4QQstbkDhJx+g8MFXkAz8wlk4JoGFxV4SkRGqGWnsMVsexdLWW7S+/XHbtuA6i0ZHJjEXRq3+QFLKDrKDN14n8aKyycGqtNLKzZjIcrHJAC7CDIElEzMyMO9Ak8zPRhMNTjkhhtiwPCn28ziL/RxO4z8vvm/Qj18YyFBT28Nu0XkhnZTRSCV1lNL12quvU1Flptnm/P80OtAEkTzwCCgJNHCwJF1HCgqBARbYSeldcWLApvFcMioFDpeliVn6NPjBEmmlbeorS2bEFtuydhx3XHDNzhbtbc31KpS32v4EbrVgdOttSNp4AodCTZ7XXkUFw2Bf8qqceMx/swQ4TIC/xAxNxRf+rJFOJm8YNV7cfBjiYCruvONAjcNSdN42Ht100FH3M+TVoRv5UJL7Rjnl2Vmm/eX0YBYo05pv5v3T/ZZgAg0rDvThIZ98DpqEk0iQ+sOgbhJp1Q5duOEHXxmw1fpdFwjWh15LBOpoBKxu4Qs3MsElGxYzidF9982eKtux0x2lffvZVterub9m6m38ufI/AAr/8GvuY0qLXkQINBykX32zgZIgCAPB7IAjIVDCXai0Ah0Yzl8CG4Mj6DKGPCApD44wIcLOFDkzhYGFLJzMIQ7RJszNUHOpCYYyVncn53Dsc6ZrzOmawEOQAQo6yRkZ4GKnHUfRbnbrocDsxmMeA1QKAuTRYO+wmMXeKWaBhtnBE9yQg54xqwtXgBWHUHADN4QxVg/AlQogJJMrnGEE2EvB9rIXPhmAYQQymYlNxkc+oDhLC4SQ1vqacj+orIt+aetfL37RIkiOwiu66MVbyMWUAFoSkrCIpCWoIjdLjkIXboHFJWPkv1N0kilMqdYgwLaDlOxgEC+Q0hLYYKV2WRBv/xW0Eh0ccZcajKEUepiYGYo5wi8dwoQmjMvBFhZNgK3wMpchGAwpEQnQiKIVN7whDZnBixvm0HM9xNg5h5MEMYkJS0LcYUXIWcTobNBUr0uiytjDRNtV4IlMPAB6qOiBK0bkBFr03UEtIjwr6EADHkGDG54QEw1sQEMZgJBNUECsAU2AWbrCyQAiYL0RaKhqTytRsCxavWL9KkSAlEDzhpUiReCCHOtbiiJxui5HqvJ+mZhkAXUxjRdl6xOW1Okq1zUKF0EiFKiEkS5eREoXVeupSi3l/aJ6QFgQooJMsMQTIMiGP0wHErnUQVVsaR0YpGsFgKnBH3RhzHU+czMljP+rGT5YCmimUJp7reaYqsklbEYiFYW9xWHFeYt4vtOdvykdEBs7RNa5Don3xOdlAQQlAPVTn+ehItBMVVCDIhQ5v7OP8DaiEgOhSqJGE6T0SDCCkZKAoy29iU04GoE79vEnJg1f+LznAove9gHLa6n0inuGTMyUHCy6qSLrV0CiWvV96XLq2zqp01KsspSP1OklYQkLdY0yE9x9y9YO+ItUvqhapxSqGDHgVUhI0ANiBcEKBkEHDsDgbfTlQBJCMV98/WESwSRMEhxxiMbkga4CS/CYIIewaVoGsGXCQmC5xCXJabMT5WTsh83pw3ZCNrIgc109UWxZ2eXzsi3jbMr/SkSeBngEAlMkAEtCAAIHjdZ3ztliRug5UR8U60BWyIBJJeQCY2WoerkCSh4zwFsM7baOvw0Wb4Elk+pZtEG1hZ6AyuhTXKACFb1QBFVzGpVFirmn5iWl3bJrwEnGaKpfE+okkJouPF+1RbjAn4uU6uc+QMWViXDRmU8QIPmKsb5jxa9+cQCjHkBQvkKYYCAIrE7CPFgxWEDXZMxwCMVlxnFlMnUe6mrhC/8wsC1sIZcWG2sQk9M2kA0iiUvsYwlKh6EMTXEDEKViFmPWnwGK4hIzW2Mbp0etJhAtj02LUMU8ISM8IZ5PKOoGLQxXVtZbXm9JcIU+nOF5JRpylZ92/wM+8uRCP8mtbUdgxpF6yLUd7YKzrAKL9Z0yzdt6hVNbqT77ARyqQ70bJ9ULI08mFZV5pvPAI4lK9lEXKq+EZRqsMAiSPWEuHLHvozsQg6+MQV5yoEoSrOQFSXChrBMrJjuxwIZkEozUjsPMzcMEmVXvHAsC4/kWqgn0W19Y1h5GZ8aGPmJc57o48zwx7EpWWUVNneqZJc+jHvWdY9dKip+9QBFjwJxo16e0PpZZzkjmM4wSCwW05bbRTMQTnWD5t3kEqUiHPLUSEaUm0bNVvPvgggvdNpBx19UOYEEOxY/5Ff22BFIz8cmt4cK6WT3g3So/ysqnsuHXhTygo+rn9v8x/ippSBUI+FCQNDS00Wj4QwxC4Poc5zfkgZC9QP+Q6V8OAgm5ZycI8ZQFEyo4CagOWGVUuMLiq5rnhws6zylc9KYbHZ5HT/rSmd50ej4dxY2KurCtrk8Yz3hlTTyaAHD3dbFDOz9ld399gHwS7uQkQx56d247tLzuSW0CgxcKUWyFo6JsBM7Ny4jLpJSGBPyP8PoORKJsWLamprLBfijwfhDozUZP9JwKlTyPz/7sAi+JAsWL86QK0EbvFBYpEL7qJSSAABrADXwiDU5gPb7g9fIm9tpAoPDGA2IgvxxtB/4ADXhPl/ggCAiMnRKBDvIEwRLMDNSJ1Szs+bbE+XT/bgp/7gqJTvqoL8Rs7frQadaeowZOwHWCDOpSzAzjpeoCRA3Db+uwrmU6YtlwjDmejcfAjmbeDyFQawUaSgKgBkN+QMlgihBuYCYuRCcGrRBtont8QAagQO9+qxH1Tif2SLgOsGkUAKR0ggRoKwJsi2mM5gJQYEWyAZGwSgMJ7ql0YfPm7PE48ANPid/aR/NgRBEkTqoyoQ9eYRK+AFYuIEVMQNmyRiiIZz3GIAeBcAVkzwTK6r8ggQleLwQ4bgzmSyDkogb0wBGe8OWKQAd6zsFmjmCkMDJortNMrdOwMB2zUAu38GK8UMSw75xCxjfw5OnG8AwtS/7SMPymDg5r/2c7yA/r5AUkVMLGWOK+6tCgYADs8iQPGWJ4CqJnNMAKTG+1sC3K6Ki1NkC2jMtpDmACoCAKZGBDSkS2IDF7dismDFABFpAl5+4HKGQTfaXwNqAXaSnxsmHOOHADo2qSzKtFSJCUehL0Oq/O9uwEA2EqtOYJfiU91EgDAuAArOAJ/gmMvoMJVo8Zd2AZaa8HBmEr0QAE0IAOvKrXgO+DxuA9+ECucoNfHCEUFOwx6sLCxqQuKcwK0TEvt0Avr9Bz2pEL4fEd41GyrkhkuA8fwY8NrcMfx48xqwhEWAIk4KUgAaqK7mvsfkcMQWw+UKRURAt5xCekVKrcGFBETiolZ/+y7mqiQzZRJlbyEoOlC1Tg26xmfKpoefziC06BRYaSzWaRKHHRzZoqBHlSBHvzFLViFLpAJIjFDWaw8IYlRNIgDaxt9STAKsWSInPQBBSIB7+S42CgXXZgEhjKq8gSDeCyCMxznajwhPBqS9QxPnvuCeWzMSbG6abvc8zJ+row+xjCUO7RMBGzb3JsHxWTH8VPIFdiJQaSMtEDtO5QITXTId+PPlBLB/6AOk+it9QuJGKregiwEz9q7gQwWGRg3nIrj1RUJuzvNYkrtlKFE0kAeiDgAeCFE7eyfozTN92MOFnJJ/mtR7NKFk3QEqAlExwEDlCgJmCSEDYAAR5kAND/7wQIAUSSYljSIBFMheNOYgnaIAitZAeZYL6ooF3agD6eERt7QS7UogiLgBu7kQoYQ2DgsvggA+bS0ecWbOfksj7XkR0BNQi60D43o9NIhwvB8DAP8/sS8+oWkzHXsMVobFItZQ3Hw7NwxzLpEA8TciLuEyEM4yB2Rw+BTL6Oog1SwA+Lq+10S6Qe8AzOKI9S4AoeMY+6xwUUQREKUUV5dcq2LEUvMaPMaCeq50EiQKBygOOs4n0osOBwcZRY6fLS64BaCQRXMRFWCRYSAZZOQQuoTSyd9AK2LUQyAJaO7BELAP0i4Ax6BQaHQgOcEwK4NEAujqysAATGVPWuERo3/0guGigbu9Ff1ykb/eWZ7BQdqZDVzFEx4nQz6rIK+TIxRkZkAtWxAhNPYe4LE3X65OnppE4iF/NARRZSSVYgPeBYuy6gNhUiOpXsNIggCmKD8KTXFKJU80Y7wScFzuAK2o4n4kiN8OikDLAmUGCOlIxpoMzdJqRYUBR8gpVZzqAP4OBLl7XNLKHxBMhZLa8CWylrm9Vr+e2mTmEQUoQQckCKkMU8xrUAEiANFOHIrCddBWADYHAUHwB3MO46V886vCoru3NM+RANEuFevWoj1jI6qBFJ4LQI9KAU6kIxTAhJMpbn8rJPNU0yik9PITZiH4PXKpbWAFMwH0tjwxBAFf/1UPTxntwQQUc2Qc3jDa9O2SolQASiZe2jUweqdnN3VJJ1Izjue3wAQVpTRY8LRIfMaWHTNYnVZ7Ene5IspgiQJIFCQgop8p6rfermf+TMWdNMbopUOI2za0BpKs80QLTNJ2bVBwrgAdA1KlEADCZgbskNJKAgDRDAB9wgkCiyAuZ1v0BJIHjRAwBXLFNPBHIg9XTgEzZCINZzLvxDTp/pg4BP0yiYL5kPMuRSc+fTPjM3gxkWPz/3T0R3gw+VdKuPY093QBm16ryPDVuYdV03605C/hx0Dp1tZZ8NhxeyoAziZXM3BRgiZ5ggBcgjBthOJPLIanKCym6gj2qrJW//QkNkyzWbN4pDtENudkLaIMx6qou7WHs5zye713/QTG6qypVcJW8SpEbbDv0mcjqp8/9iQgACIAAUYGoAYG7rF+Puto1xxwSY4OvAaoaHZ0vFKAfOlCBMbzrQQD27yCDaBRqbKS504IPY9PW6sWEntwrFIGJ/6GEreGE/ONZAWAtD52JDeTBTB1QXMoXtCTFfWGRbF59K9g1TV3aZLccY0ume7WXHcPtEBog3ZWYyRSP4sDwiQAsSQdvuLY6QWLcqSidC8iSd17cwxCS5zET+yCb+iG5v6sywlYy5tqfshlmFUozJ+PGear3MOL/U+AJe9/z8EP1Mc8bkNioLAAD0/5me9xmQ/slS2PYAHhO0JkoDDiVCYVYhQvU+DWMjGrpf6uKhH7cbZfYJ4/SHDNVy0VEzvEST9XKUQ1iIAlNhVVn6XPmVrSiWFXPrZrnqYPel9RGXNbVQruiXW9mmfZiVdZeVF0Kiq415hEWN2GgmYkslnfYndPZXnRf/OGpWhzWoszlD4qML2ue5rteLy9kSTCGrvXZHy7haqGoQMG4IgrEpp2h8lu2e63it2Xqt97mt6fmsF3QNUcx08RMhX3Ygeu09GFpkMvmvZVaT2RNPLbeTGVYvN/miFcMb1amUQ1pQTxmyR3h0heikUXqFPxaGW7qlYVo75HBKDhqFC2oM9f+6drdPUxDCtBNCI740LH1Ct6yAWItleqAHykTqjkjTVzQAt00EffLmjrrgKe4nV3sKW7G6nO0Ga8GYnccZjcfaVBY0Xf9ZutOajq0brt96ralboKObJVisrhV1+2iWrzeovDloYhqCnSpasQv1G/Mykw87YydXvTN5shw7UPuTg0m4pPvEsl9ZhRs1s2I5xqiO/Dj7HyM1DitzpgtKgxqcph1cIDQFQBvCPXqXDwgRiA16B76NBALxJOOIQ1xz7qIZE58m287MKXLxuK22jCsQuUNBuWH8uMWa2hINMolCprcboLAbrtEPPXL8aCh1dnQZvHUXhMc7r/GEh42OotX/W6EV+7DjOzHge8oH+8o9975NuYcKtb0n+3ROOLD7OrSfTkBRN9gC3IUPPIb/0bMNknZp+h4fXMfk/MgLCrUVQrRY2ylqnAXVrlW6YGmXZ3q4DImZbLbdrUPKNhGI+6pZ/IsFqAJ/QcZf/OAqkBe7CJ7ROqB3/MfTusd9XK5zfK7hMIOM3M592LFFi68nFAzLOyGqnD7hO8oxmp08GMvXyb4n67FHOLFHOMzxpCDM/HX+u9jRnEAVBdjUKrOhLtnXvLPjRabhvM7xms6r/ZdzeodXOyP+4BOmig+2raDjjiTKiGhsxUF020OdYmq3OGqH+xQc/dGbW24m/WvpfbnJ//gqbHImKPP8zrq6Px3U6/if4nooAJrUGbNk+PC+JpaXV51mgfkvYX3Wk4CxY/2jZZ3WK17Mx1wgeKDjeV3pSFq/kWCT9ZPVec3YT3eFm308RABwqMPlX56Fn738ENz83rw9aNqgT91QSpszD1ic2cVp0+jDZRSe2yhCOPEGyuvMcjXesVreK50CI73qyXgQiMdBNB3gOx3gfVy7p5vvuJslvNvmv7vIFz7bO5bJfXl38XwzK5qnFeKjPTqVYS5M/trMQT6etJzLY529Z93X2wl09x5TiP2ILhvZgU3ZlT3mERPAa76JZHhJCJ6KOKSgLSq0ViDz5Ty1d7e06MMKzv84gXxxt8+HiF3Cwwd9opYeDlQc6seZxbfW3iN99uUGbxboQeJwQbre069bu7+ex4Fc7B0gIE122Crr8LPccyE+Ou5T2Cn01aV/sec+yuXbohEb1/t6+4uu73Oj5L/813kj7hPCv1++2Jf9nszw/K2o/dc/8r2j7BH8Z2SXnmu0oDW/QUAg830ZIHSsWHEihkGBB3vsePIn1Cldnx4mIgTnCwoNDzZseMCRBJwzX0J2GdSnT6aTKEelXJnyFUuVME/BDEUzpkyZNUNR/GICIwQEQA0ELUB0gICjRI8GWMq0aVMCUKMKPUDVgVUJWLNW2MrVAoevXsGGGOuhLIiBaNP/EkyLEK2OtjVq5IhbBKHdtzXe6i3CV6/fJG+T9K0LWDBhw4Tz6ODLmK5jugNf0IgsubJkE5hfwHhco4njJp5BIxHNF0sR06RHg+6sWkiQ168JOh4oUK1tEbhzi8294qsIscDNcjjLoQFx3L5/D0f+m7lwsF2hh+UKoetP6tW1ZuWI1YBSoRIiiD9LPsNxt5Rlw/jLhEtDiDhV7tzBokMHFi28TJpp0uXLTCb995J/KcVnU3yWhALJIGmgwYQJFSQ1lXdIGfWUUhdmKFVVVV3loQUcTRddcMHxdtuJehF0F16c5fXXYjDutRhhfx12GGCl4VgYYi1C5qNlQG6mnpAt/6ZmpGFYIHlkjOs1+WNtJ5qoW3PPLUciCFViqZyUul2ZpXQjiqidddpdFx533CW1FFXGaaCReVimsBZtLBbUZEJLsLEffDZZMgkcXQRqyIAEEirgoTPVdBNMC/LBh4M+nAACBAIMVSGFamqo6aUdevihmGF6OSWXtjGpoosw0jWjqi62qqpfNhZ2I2E56pikYKk21uOuQfaq2WewLSnskam55mRerkJJqm1WfimqqKNSSdxwXxlH4rWgkkkmUGZuxxFVGBZwppsgwCkpekM6qdcSXOjJJ3yFJvpKgKPEWxOiiWZi74HxDfKHFfQtlEMOkkpgqVThEgWAUxqCO6GnVv9RAAEFoIIp4m7nLXvbubXZ1eperfKIV419jSwjXiWfprLKtyrGY4uR6crrk5ytBsTNrYmWGq5J1qpzsMcii2yUJjabnJe+UUvtlksvh2XT2EZtsbbYZSVxd1lVdabBVh2woQPUvnnWBmzZ+fGdO1TRhkOLtg3TL/n6l6+++ppCd05zy40TLr1A9KccT7DxxA4GFTQwwQZjiiHDC28KVaddezpmqF9RfCVZ0Y6lcakeozxjqiebajKsuNpIq5I7pq4rY6vO7Hp6OLOGc87EJnErrTaqm6uyREtpNHJIK2dlA0crLTXwFlteOZjKT75t5Ad4q5XXX4d4wQVkY0ae9un/oq2fLnweOJPe/M293915F2ggg18MAeEFBhH+gxWDt9CbBN8tznjjAFBPAIcA/BDWpEZAzPkuOZsr1alGVyMZJQt0g3nRymSVusLkwWW2kpnrNtgrm3nwdj47HctyBpugxQUuvZuS0bAlLeB1aUtPK2DUPjA1ql1NcpLD2lWm5781ZYdc2dveWjiWkCE4YW3g+8Qvkmigt6XvJC55hRSnGEW4xY1RFGkDfTqglRMMTGD1w0gP9+cU/gUQgFSx2uQoRjEayhCBGtPc5qB0whOO7nQNRNWLmDQyEUZwRy7Lw61ktTpgxY6Dk7FM7RY5yEWW0IQp9N1AOFCDoxWthU5z/2EMSeRGAirPk1SjzlauwoHI6bBMDssfAiQgHHIJcYhoW8h7mGhFJ6oEFuSrohRbkkubTIJ9IfnBRrplAh8Q7FxYyxQZmZLKCnWoAQIkJdW+0smmZS6SCaRNXLrHxz3i6o54dGCsvllBCjKmkS9bXWg6g8gOMrJn8BzhOZvQzVWhEJvOaZYk9wm1N4KylMsLpVauFiE1cs2UH0qAQodCocdFr02udCX3MLOuMUCClipJIi7qdcUmclSXGa3lL9vghRaYdCE7wAj23FSQgk2MQstkZtfQWBVoCjBCBL0Y5ZJGyUxmE5/c7JgdPccyb3qzLuGM1Y2SgEEcDQadPEPqPP9/lsiqWlWRNJDCZ95pO3lm8JGQ5B1QxyrJFQrvjZ+soUCdV9AdnvGgWUtcpsQ1LiBOlHt2SoJFMbpEXeCSoxs1UC+nCD6/jTQkhLueBkzKhEipyH4ekGtUHBeAotA0gKyUAEHTGpxqgoUGlvTpT8eKF23WU4KkSy1qZxXC1DW1MbbLw2leu67UFLIyPOjRB48ku59BlZyjAatYyTpafmbOnzXk7NTYaDmDjhJsOfQQURK30IPJtAHjASJL8RqYWfb1u6/AxUblJkW3PeS8OIGEg4z4xfctVn6Ec6lVJkvZy2qtlDsEG0B3eq0uFa+4sOPNNtUi1JGp6KiBMeppJej/1R2N4YIYxKA6Z9tUQh5JCsSa3Tt969UOk/BOASauiDW2tBhSCblqzayKRVk15yYTekFR6PRguiYGYDe729VeXvcK3iRK8a+jGK/cCptEPwUCcFsMwUkHRgLMoKAnEbiAZCn7NfvelK38Fa3TfBTiE3E5kkIdajdpVNsdGfWPOirzUpnKZqYKUpCoa4wYbLcjDNv5CHgWg523wGd0wjMMeQ70n2k3rAd+ecTDBXBZr+RZzio3xZC+MisROtNncucnDluYURJgYxz35Ml53QEaJkHkJday1KiGib/oILjEegUzXzwmlhqgUP1R+X+UdoBNE6pWTiZNxAP2cqJRtKq5/9CsRjmoIMiAq6Nw2opnsX2zm8sZz9OgRtqm0fOc+wzobmt72+Dm9rfFLWhCo27MdZwTPoUqxGGTVWqehTR/R8ninLY41zB+GASwq4DqNm66HNFujrvrEFT3zeDgO+wS4kcFJvSgPCiFcoRoHNMq5zqupSQefvXrT+aMOIXB1qZaQl7HBuJFZJ+roLNPzjqkKgnba4ZzI0vjYXJ7ewtxuDm516BtLITb54POsIfD+vFXFv2F1PpAvOE9b21B1ytlmt4A8V1pcXGa37UWwL9l7GnyrIsOoejFNMB3jWv0AhYH75uC/qAHJ7jPBplRQnviW7j7Ke7WE4Jct5oXUOholv+FGFP0bYowct4Nt2OrGtJcPoes1qnu8aqFUemiCu02U/u3IFxZaca9824HmvPhBjTQfx7nCSIBgq5CdG7uSfJ3n/WfsF9r85prUMwGpeoOq64CbLzppqyyAhE9S23Z0JDyml0XrzBFKSYhCTlUoYRvV8jcDfK0+dracXq/sgX4Hp3MvrH1wB5wgekYGcTDruTolkt7+LJ4BjMpqi7v48lj+2AL2t/PdJY5akzP7TyPW+edB3qk11qmJ1xC4m4JhIAmooC8QUCd9GgA5Wj01n3L83TQdYFtlW9Vl3dpdHX9ZiHXlV2rtx4WhAaOEAgo+Ads5wUsqASWwV4LRziTZBXDTEFf2IdZzhVKfmcVNWRNAgZ+2AR+d/QXpzJy6aYeTFIXDsc6i8EERXUyJUNULIcytjMGYwBIsoV/LWN5pSeANweAAthn5SYadHZuHwZWXQZmKLKAgvdCZ+VZSweBOth3+8VWaqSBB0NTncZ7cxU9xdEmcedgaMAGrEaIb+AEiGgsOLCIiWgQ26dM15chNEVplCOB/DUqy8EXRwc7UGJgBUYnRJUuoCNOb+GE7Ldmkjd587dyF3R5Wpg6SQJhWCBIRRAQACH5BAQEAP8ALAAAAADgAQ4Bhx4KACcNASwXBi8iCzMbCzUeETYYBzgiDTknFTwzHD04Ij1ILUIvIEUeCUgjDUg0G0g4JEkpFFNLM1QrFVUfBlcsFlgpC1hEKlkxDlkzG1k5I1otGWI1ImUrCmUuEmU6JGZoTmc2GWlBHWlbQ2o8JWo+KGpEKmpLM2pRLmpUOWwyDG9VM3JsUnRDJXREK3VKMnY3C3Y7GXY+I3ZIJ3hJKnhcQnlCG3lVOXmMaXpJMnpLM3pRLXpjR3tEJXtGKntJK3y3iH2ieoA/IYE/DoI+FoJHKoNOMoRFJIRKJoRKKoRTNYRVOoZYN4ZZOoZcQohmSIlGGYlHEIlWOYl9YopNK4pVNYptUop0WItZNYtaOothPYxMJYxSKoyhfI1xTo2PcJFeQJJMG5JNI5RbOJRtUpTFmJV9YpaxjJdWKJdoR5hjOph2V5lVG5mGZ5pyTZuBXpxiK53Po6JcKaJdHKNdMqRsRqV9Yad6V6etkahiHqh1S6loNqmCXKmHZaplKaqXdqtwL6uRbqvEnaxxOqyhfa6xk7JuRLJ+YLKJVrLSrbNsKrNtNbR8VbSdgrWKZrd5RreGWbeTbLinhrmZdbnivLp0Lbp1OLuje7yCSr3mwb6BPsB+VcJ6LsN7NcN+Q8R8OsWegsZ9OMacdseKVsekesiDOsiSaciWacjhvcmohcqHRsuEO8uSWc6RS8+8otDSs9GHPdG2lNHdwtHnyNOKPtONQ9ONStOOU9Orc9WSS9WshNaRRdacZdazi9emd9iWVtmRP9mZSdqTRdqjatrCm9uhTtyVSt2aU92iWN6ZS+GXSuG+ouObTeOeYuSdU+WhU+WjW+agTuapW+atdeedV+enZuihTui4iOjAfOncxOrFlOukVOulWuu1eOyrY+y7i+zTru2qW+2xXu2yZ+6oVe7sz/CeVfGlV/GucfKrVvKuYvKuavOtW/SyY/S0a/WxXPW6dfa5a/fDevfKlfmzXvm1Y/m7bPq9c/rCdPrIhvrYpvvFe/zjuP3RjP3Ul/785Qj/ABEcEIggwYCBDhyE2KEFjR85EMNInCiRiEWKYsQI2cixo8ePMkKK9Bij5MeKGoWk3OjBgkuXIUJuQcOl5kwbNmAIobPHkCFPPhd9WiQ0KFCgRHnSycim6ZyHfiqpanXMWTVo5p5x28p1W1dyXsOCHRtWa7FkZ62RDbeWbbh2b+HKnUt3XF149/bpzetOnbe/dsXhG4yPnuDDdgkrlre3MV/AdevRtYeXL1/Hlhffo1y5bzzPkkF/NYu2arDTp7FySzZVa1dmzmDLnm3WLeTP8L7la7y7d798v4P7Bj5cuPHd3Yoj/5Y3n27iwf1Jn66POvXgzJVr34tN3jRc4wYT/xyPcMIHhjQhysGY0aJ7IkzbgzQZkkh9+iPz6++4BT7TjSm19FIHKvRwxEw1NYUEFDDoxFNQREX401FFbWLJIkqtpyEbUFnSGjVXuSZWOiO6VZaIKEZDm20sthiZaIHF+Fdle3kGWXeLxWiYYJrx5piOL4bGWWaXYaZZZ7hxBto6kEnjZGzImGZaLqmxZUwtxqhGGpRSrsjVbc1tJ+Z2xxFH43Dw5NNNZcpZ52Z1bjL33Jh6mekdeIyRl8CeD/RpAhNjpBcRe+2FcdF/85UUE32MNuroSBepJN9NQgg4oAw7JKgpgw729AhRPnkiKlFIQZgUHetJlB4ggJRyS1Vajv8m64kpqmjrrWC90xZZfgEZ5F1hPsYkYJqJ806Mhb3To4962eirXEpuhiSR1E6bJJLDxqpll6hR6RaVXG45W2lexuVZsHRqd9y6yKU55jdzRvemm9fdAy906TKGTzfjrJlPnwUFXNADF6AAqKCpshfpoSux1JIHKoQQ8cMUTzyxohJXTN9NKWVUxMeVUiAyTIduyikUD/4kYYQULmKhJRlu6BQgHsIK4qw404rrziqSuKuLvf4KLGbOulOssYgltqyRRQttNJLMFcl0tUVjxe2UVO3SCpZbH/NtlrWO66WIV7XzdJhojsnudv4q17a6/VgHJ73StSsvvtq4zW94wAH/PDCfBBuM8KCIGlqRpPJVSuDijDfegUuOV0yxSf0VLp+ACWEQ0wwI2gTFeymbOiqppI6OaqoaRtVaiDnnrNatyvD8+s/nAO30ZFTbNYzSPx6L+2LMyvPZs0GfG63UwU9NWWBWH0NlLVNxPVUpHpZi/Sqrh0NuuGLHPvaXTBqd79rsHodXvGmTKS/d133Tdt3z4Cu/vtPU767ff/f5wJ8IE5q4fxpp2OJGBrnHDeiACKTA4jYAsY2pBHEPlAHmSMY5TdXEIp2CkMqMAqoNniphTVHEJ2zhNdZlpXW7eh3sZve9EpmreL8CE9Nk1KNnLc1I9SNe8Y6Hrub4cB9Ry4yN/6DxC+dpbXrUq4QSl8hE62mNK2DjnvemuKIUEQtd7aoT+bYYHO+4a36MUR/7pjOPetUPOPCLTt7ctjt0uCt/fOJTBg7kEPUsBSPvMVzDLILADRAwgQnMHEwktrH4dIwlFmjAyDyAkwRRhAgNIgIdTFWUSrZsKB90ikM88Spt1Q6Fa7FG92RDFlJ+0me2g6EqoVWjs20GWcFDVnhuSLTw/eqV1eoNEBsTRGz9hYinQSL2rnchTVTvel2zWfOkSEWxoehJfpFWvM6kNvmVKTfbQR/cypjGMqIxbvHbG77I165utLFO+osj4CBgoDqqh1Dv8Y9HIqdAAwLynhbYXMb4U/+oLYDMgJljZKbY4LkFwaAD8PEUB0nHUFDFjENyqNnNTAjKU3pllKZkoQtTGZkXCSsvg6GhFmuENFYmT1/C0qGQjGev5szJRyn9Jdaet7Xo0UJrz+uWMpfJzO351IpvcSPy0qe+cQonjGDUpVLbpEZvxu+bavrONORBTju5T3dp0k061cmnCroTdY9cGKIUJznGYQCfCSyBEZQgQUYCiI4kmaDmGmkyIRw0oaIqVSc4uFcPKiIiT4moJ6gxUcJW1IUYzSiKLGrRVXaUlcvzDEmRppjfMMaGJ22ljB7ryjONdKmalenVsgQuKWmrKp3kqbh0+tOdYaUarpTTZrRZVKP/9iNvg3EbUeGGN73l8Bq1bVe/2kgcCGgAYHtawJ4GkADOoUoMdoSnoQC4knqWlWJnza52sfs4EighC0Ug5FsDKMBEBpSuY72rGIJCB6S4VyiYhO+pZsbJZtj3sIz9pCiVAYxmxuaEG80viyLzQmj15Ta7eSVlUWrZwog0s4TZbNDYscNpfRa08MKlTF97Wm2VLUQ0LWJPWSuM1oYLGjM6n16CyNv53a1u3lljVUGbTfnNiV9tpFF22IYOrOryBCY4rgIUsIAiK4C5OaDCV0E4EQBSlyNmZSQHIJYxKlvqulReKxXaKhM67hFzCdmcTQqq3pStjKGdSDMmTwfR+t63/8NAFfB+++tf2NBOwLax5YELDC3WDUnBu7twSGEJvOQNkaMrPZuYehlZPcvow7/8UpRCbNoR07nEozQsihVtpG2Wz3zdGd+idUNq58yD1Bne2zBy7EZ03AuM8BgW3+rkhBRI4NZFznWRXaDkhzIZJQyDsuIq5bCMGVtyFRikxLwrhSRwGYKHjMHjFEnBMV9OJ9B9Wajgu1eXYXKvigg3RISS2jc/Kc6uY0aJL63REQEY0Y6lcF1eu44f9viKRCsppyF86CatsjO5ZVvumuboSANTesYo4tZUSy4Sm3jTmXl1i19M8aiGsaoyfpeNgXPVagwDGbv7JWypuZuo3XvkNP96wg1QYOtc41oCzH5uwgwZqen+T8pttTLGjs1zY8dkrTmPwZYl9VZp/7FANrBg5RoEg/VCCClF2StQ0hyhvwq23Kdtd4BPJIybVvG/7paVv+OtSijNKLRnv/hkeWekZdlj7P+O9b7XRi2CF1ymz0OmiHfhKiu9Bi1XWvfDRfTn2a7YtrddHzi7WU7Emy+4vrnxK1cdJUijvDKyPXDZhtSNNag8BUUGwQJEv+skBIrNhlSYk4X97Proc587X/bOZ5CDEjysyylxj9GpDZNM1VW9G3Tvt0kndQmFYrAAFle47mxRdfOd3TozUWEFXGFd8ZnCZu+sntHVj0ETmpaNeTT/n4tG8qMeXoh2lzXej6j3KWEiirICvOBlR/iI7xKp2sh4dOZ2HXB68Ysc92lvUybPIXF20mMiVnmVt3nWcmDI4CQy4gVeYGukp2swlwQ1gXr/4T+rZx9u5REioCg2sCgh6HM7N1cuQAK3BzIB9DlHsHsvIWZKB0kq0HR7MHUsQ3zyVRQiFArJp2nKB3ZbVxb8hT1T9HcoFGnX93ZKGDRkUw/oh28jVRgQSCNUgzyaBz4V1mpYBGuMln4GZ0SqMEzR0yWlkAx+Bz5bkVjPlHaG91nGsUZjREb9sCbJ4XjGYYdGlTe0FYDMwSSwAmKBCBhC1WhEZHne4AU8kAKiBwIV/3hrajU4qUddKJF7RPCBrCeCI0iCxoYx2UUCKRgCCSF0StaCByJtCcF76OUxGxFJ0CU6pTMU3XZJm/CD2qJ1QzgWXQcLvHiEWUFKfoFnpxSMZZdn0gciZiMtoRE+JNcsVXiFS9NvY8dSF0aAlnFy6mdwB4dEXLNT1mMVbXiMdfaE2leN4PAbxJA380IvahJqFJdGljWAiWdjGXaA66CAgjiIjpaFDwhpKfCPoicBLrcAEqABP5CBhFOJeJReOPcosyd7DVRlYRYSoohQB6JkLmggu6eKvmcyB+UgRiF8USd1apY9ixU2udh8u9iL8CeELfJu70Z2L0mOCrZ9andZz//YgACXbxyVGOdSjZH3hdmoje5nhDtlNReCYuEojuiGb5jnadIBJ3DCD/0XjzLGjkflL/rHcXPCYgn2SkdZaSi2edkCZ7cmkLrmciZwkO6Uev4zVpUie66ngprIidJmEhITgyWggoOEgZQCBQbSEiKTOSLgVWTWIK+4MkfRbbOYV96ChCjpDMz3dyuZcGhxWNMHbzNJk9jIjDdJhcYSDxG2k0PljE3ob9QIlPZ4bxTGOq4phmUYltIQDDXjFy65mU2JS+X3jtRRHVLJf/iAC9igeHSYRvLYRRgGL7oxebHxYYR1NRNFlNoCAX1yAQpwa0OWnR9AR+/klpNoiZFEAg7/OZ4isVZg8F1rtXKd+DF/+YLTtkiUY218NAROp5g6+An46QmbkFqvEUrRl5Jz5kS3+RXE2J8Een3Yx5RacXeeWVmmyTv8Mpqk+ZXMA4G3sY94kU2+pI3bMlOPGYYPmAtSgYS4iW4stZu/cY5x85tRSTf5IJz716JVaTeLJxzxknnComllKZayGZZbtU59EhOS+JaT2Ir0oU/7oZH48YJjIAq60AupEKWO4AZNMANzdZGs6J6DOZE4kXQXhBOPowJON0k6GIuO6ZL0l0K5SBq0YJQDGp3S6Um2k3X1Z3c/tA/dNw45KTxs51m945qO1aCwtqGSNlo51aGooRWtIEJ+/5dR+GUu16J266KiLeqb/Ccd7siiM+ocelgmA2hyXGib4DgXa8ijDLd8EZCq6aQ/yYYpGaGBREoRibKkSfqCHVEHy8APuqqr3zAJnid7GFk5Wsp7V9oCMZCRikOfdQCLstis+Il1uDg7/jmEXAI92AOE5sChzYetMQk0kZmME2aTIyVLjRapnDGFcmeMDPo0g4oXdiidM2VTpaVwsQkNpdAqzbM9JXqgzPiTWsSb8wKc3TGH/fd/d9N4HOeu7+oNz4mMclGqgwedhMWqGnABGVCYe1kCiKMU3vmW86QftGofSXoH4JAN/GCy/AAOpHAHTRACV1pQgZmKYbYoL7ggtv/6MGKwBzqrmN+Wny35qP85K0U4TN6jo926rUFbojtVjBX2I2c3PNNgrjckGfDGgDSmsNgIsVhzPWRorWPYfsVwr2fIGonalGJXfZQBlItnqSw6N1MVsFiJDcf5lTu2S3+4N1shYrbEU4G3U4ZaFRarAWt5A02gck4ABufZbG3ZsW75sUlaqxzxMSR7suVQDim7sjuQXaQIs4KpiklXB3uQBjRhq9hGpqQTknmFfNwardO6pkMbClhyYgbaJJC5lKLVcP8VrkBTQ0pTrhNaJ3+qhUOZdnZSIzkEoq9CU1xLhsNUPfMabmO7C4OXhGAySwyGp7zJtpZKDMJ5qXPYLBn/ih2pZi8vla7185zKMCMPC0y4azMOB3gZILh/sgRpoAd1kAZgQAeIK3MJQ4ne2RGPYiCnaKsc0WWSqw+Wyw+Wq7J3kASa2zmUogJbelYlMQaMcMF1MLqUY7qy6BMlqZ/8CbSTKY67mGY/+xpGy7DYClQpwlq5S6pHW2i967u/y5PTGDRW60OdsTcVakTBJExOJK+HeojCkAdzcIbdOL2tg5qFBrCV6pv7AKNP7L0wBr4jFTXXgHlvqGrs67Ci2sUSK3+sFb8XS3vomQUNUQVV8KrP5b+Ne3P4YcBGMB+RO7koS5W6wAdFYEBNN2ZKFl4aU54a/JEWabr3KSr8iZIj/2y7xBgb/GULvBgK/lW7+8rCbJpMtit2aWua12KTNRx+9Hahp0manUG77Bti9Sq7SgkruWDERii9fauvZstRWvxNY8R/5mTLVEyH9AOAstVLOHpvjpwlMnKqlvm3PqxdOIGe+KsG+cu/Ldhk0mWkAUzHIKEH+rCrusrASmBAXooGahC6Y9BsO6ADZzwGPVCD0jZABAJdk2TIxYTIQniSI8yUuBl4kQzLlomt+7yUQbslR+R1/ryUSoK25KqbsXTDokqWAwevLuwaIsc6laYKeaAIOHXMGP2m1Asmu0mw3aCOBAtj7+ouuZE74wuIPrxpDo3MGP08GfCJLZAFenAHNP9tvzL3XAoJT/BRwA3pQFQgBYj7VmpME+PMCP6gzZfbB1kgXuG8rPZ7v/hbv24w1aJ7lxZDIJIEz2ZKQqubkgmqoGp4Ufh8fKrgfEWLqBr9z1MCDDcl0JZ8bnVq0NUrtcCLk1tRjJAWqgTHofio0tnoyGP4mKVQ0fosxv3c1WHHrzdCTdzkomdEnHFrP+fTS6HagCiNUyptzBnd0jl1JSZYBVJt04Hiznf0SERqpBezpEDt1Evh1E89CqbgC0e9zVQpCnyABZmiBU391FDtzM08zkF9IIFCg03nE/Ccnx+C2NLaWF9Nws0pbyQC2PlMDZuttY6q1tX6fG5Nz/OsJcv/KMrgTdf5ltkFGivhPbzaiIhh+LVGSUSV4Ae0cBacXd1p3WFAU2/2AlWKJ1VObJxXIdlYy4Vyx1KX3Y1MydLzbZkzgBMyOAa/vcak3YIM07gccVBYvTFgUAcX7KQ+sQm+oAu+UD+6cA3fEJW+eQ2ncAe+7cyDsOLO/OK4jZ5jdr/DfRFa7bOdNI5eDd2N7ExhWMKcsAqPXNjgiL7djd3dYq3bHZnPkBZ+/RbgHd6RasNaKIhKuUoKDXcgyndKpAmP6d5+EAxNnuA6botb4mF5zdh5KFVUhYfQEWusFuD7eHewecJBWFpkbhq6DXQH+V0OPs4IidOUiDiTUuE4Sx9g/3AIpgAKI64LhsAII66ckl5GKqoNvtAHbuDiagAHmw7oaMwENaEEfowG96uzF5SYOovje1fmAcbjkQYXbHqZ0ud8sKBmV8JJGX2qK3znSd7WZWvmKwTRPWlD/ko05g2v6o3eET12p7xEfcdhFG3Rp9xMuX7kUiSnWribu+FxI3e9LoYc3I7f5oveBVfnxgzGlPbQVQHjWjbUwD0TSyHo0+XGO43aDSQSYODh8LIM32AKGl7ip3Yv6sh/voAIL87pnL7nCf/pNlHONtHUe5AeNn6D8pzjlfZ1ARZD1r1axnB8QU5CsEvkRn7tsivfhu3rsGztJH+auqvQqTlZVW7lkP/Gr6FsoabsPGPo7O4bJYNdCUZO7WU+Yip/7KS8DpQXtX66HazTamW57M2wStSdC+3N69md7tX+236Z9T8drKjCEbHKkFYdEoxA4pJ+CE3K7wEP8E5VRpauB7p98A0BB6GeHlgwun68szjNxiBs8fzs463u6pEx5ibGXyXZ8SMU0Jf58870dSeP8hHbWmqo5YGajDUENBSF7fYNTRIt9flJ1l/OysU07UDPhtmtxEQ/4HAOK99H0nKSYOHursjeDNla3lHPNVEUxsP8vr/uDL29v0D9+3+8uC5I73tk4fRRB74AL6awn/4+BrCNCI5A9mWk9mzvC26/8HWf/VyA8KD/PmZR4KUxo/d7n4Aqf90tL5OXTd9c3gkgXwkhn8SKT/pm3esXjWkAJv+ZXLUmNZosDxDVoA2kRtDgwWfFFCJj2NBgsFWlLH2K2CrXsYECj93CGKySol0DlW0caSxZSZTOUjJj2XJlwV8qZc5MmNHbOnc4x2l0dtMnTnj2gg4lOq7nTaE3YfIsiLCpSlu0pJ6s6ZIm1IsmtR6jOvIpo0Ng74wlWyfNmCpbxNBBI8YtFLhiiIQR8tauXCIxYKjgG0PIGFPfBB8SEkNtHVF6bHA59W3eY8GPJU/TowUOHC1YsMDhgvmyZs1cRCOxUTqMHDlh3M6RM/HWpqdXqz7bVpt2/zrc4dSx213P92977YT3Jo4zHMmttYIltNXJuTBlnOZw8iTM03XoT5NbPbm8azDwu8QLmzpemTmvV79Hm+2U23v4P+X/xFe//nClur3Fp+mU68KG/ospl1YkKkWVrFSShqcEW/EDkItmWu+ljtTLbisMLVTQpvcqnE8nENExTqNmcsqJKe1S1I5A5S6UbTYBs9ouPdocccSUQ2xkZBRHNgGrjrREa+utI+JS7a65CsuLLw888KsOXxy7hhEPKOiAilF8ScOCEEyBTJtvptHGn8kwUcOzM4UcTcjL0GiTDdQWUUROOSnahCMV27OGHD73rC033oAT6h5CC01qHf12O/9Oq/EapegjYcxRZA5FnKuuOhpn7C48TjmVqjzyWtRwQj1v4+/U/D40MR78UuUPIxhjlJVFVQxcRVSBchWJRYxUobTClYIVtiXzhiW1q1gxcvVDXUncKT/1ZJXwpKhEjRbYWTWdyZRIup2kWz7CAisNKpBQa0gjVUuXyLwKY5KvLTbRRcpNhOigAzV8mSYNGJAILJ/HupnmGsnmmQaSMy1rk83NLtvjkYkGwUST67DDzhaO8GwmNvhMte3jc0IuDrh9Sjb5nt9G3M/TiFp2bk7l5mCj0lpCCaXFAUsqVlPoNv0UVGtHXa9U2p7aGNVExXl2VUWThjbPbMMr8ECKEcz/6MT9BqKVo2pKmdlDY8NWZmdtw14RbBWddSprmLCNmtFag5bWbU1z/sqONfImI40nwMjib3PjQlfdudQ1PK4l34WBjigFC5MRuRi55hpWHp4G4ICH8QXgfvo5+E03P4MDEE0AIR0TVlJP3SKMjbmlda04ovFUkP0EGUTfDD355EN3I7ZmSz4SvtKbjZl0Zk5ouRnTC1uEneyegSlQeqCDFnvoovv0GOmOlfb+twX147DjZJNzdOKKlvtwV9Zbp8aSOVRh8PpjrXu+7E3pv/ZFjtueO+ftiCd9b+NO/qK3ldg4oQY5WOALZmACF8hAL6UxzZDcgiTERUGD7dpLBxc3/znHfYMXhqADKxwjsG44hnPd0Fw35AGwgw1ChmfaQw0lVjVEWGRAOwzg/Qb0lNoFET6408mgdrePQZloZeFZRfCGNydPvE9mlHqOzWx2v0ZlUYvUE2D6sqi/YzkDPT1Zm3u+5z3xIa18PVQe1SK0PqwgKGO/qMYvJmWLh0xLfzVjXkpkhz8DZggmmdqf/+zGM7gx8VaBFKQeQwU9r3yAA5PcQCUxcMlLqsA0qpGDDRfBltTI7HAbTNxehmAIEDpuhIZoRj6+AQ/BEAUew0gdMjSnudWNYmK75CXqakkS5PzxkVgkI/mE+KeRpYxkvDMU1kgSkY+8rFLm8MQcokBFK/9mszpbrB43qeZFUGWIkWHkXxnDd0Y+nTONa+SVcn62SGgQ8Thao1WMmnGLB2nMkeM03wABiT9i/mePAKwbQbfoRn5yKmrOu99ILOkAC0A0ohbIpOAeBrGKVYwTw0uNBukyBBi0SwysHNg0RGQKQ2SppCbVHEaGgQzWrQ48PPyFTKWiw//pjKEHzI4xjxmokclTUEYUCvg6FDc+VuoXocgDnJKn0UcVz1E/4ybr3slFWOwUkQotYEv8BzX2qPOc21sQO9spQPEoRJ7zU+gvnocaje1Rp3xE0Nh0ulW85jWRbMwrFl0GvbMuVKsYqqREKRoCxFYQo6rQZUwLgrGMfgL/fqgxHBpq6Ale6Aodbv0FL46R2ZfSdGu7EG2MvugdcQ5zsD3NzU9FFtSmJY0eQ03icKjxOq2EgnidaCo2oUoRBLnzqlQd7oFuhdVw3pWnqb3WLTwbE4dEV6zSICtBchrYo7AqOCNiX4LiOKBf3VNaeqXmFZV7XpTsta7ptast0Ltc1QJWvdRDqKesCt9ErtYkE+WSDXbAhDGowRB6QN1zS/uUUfBQFY/wJGPnyFnx0lSwOG2vXh/5u/gKdyquzZ5sR8Ybpw0nd7VF1Bhz6wdKHY+KkX1UcGsR3L8S97ifOpD0FKLarF4Yv3Tz4y1yiTaEzLPDQtYjAZ+hDqapQ1cq/5HwQOx020WwwRJsxdCOdWbe94rKfP1cbpbxWy0s7vWg9T2rfPOr3yJRYQyDIDAkUscL0C65nP5pRYIlfOCzdUrHe2Zvhm2s3BcLF8utJXTtQPzaD4e4OCQuMWc/MSlIy8w5t/jtxTRM4xlj+ps1ZllWc8xFkwRUoPnj7ChMferOKsuc/pkQnq/WO/IFU3YMaVnGUPwJKjMX0Fi2cvP8rOU+Axqtu9avnzdd5i3y9dI7PbWpPTuMOjZLzmZc51eZfEhSj4q+tHhvsNH6aWK72ECROnTIXFucQ8dWrMTpHaI29rpsSqeTn2gOZCMrXKTW+tibNq5F2utpgIM6w7DL1v+CMfoIO0NYuv4JkJFh9Z4k68aQ2G2j1WyRGk/kWq/ZrDCYA/1x5lW12B0PlXkr9muRT7XfKUc2l5ddC11BW9rSpl330llWOvOVjPssObex8kUTGxvYql1epst9bnQfvdrdWys1lOEJ6lzHORv9xCaq87q4Wdrjmua6pzn9b1hoE9xbF3XsGHHwsyM84Z+ddnSvizb6cBdGo2WRE6HLVDnI793e7mF0rCjs1Yob3FKNXsgzzGvkfnqni9/2yj8+XJYXN9DjG0jSnbZO7dXOuqbFsXI+VsCeY9h5fH98zXxd+r+H4jzqFqLlXb90RR8N6laEqo8cbHDg3rf0XW9Zcrv/6OmnMn73uI0dvCGmBxkS+BG+fHM1TPoshLwdugJpesF1n4vJWrya8XO3MHVuV47zepsoRz10Tm5e4QfcihUPePpVvu/eU/X6WhR8+wGVbqVfXuKZ538eRY/p7OG5sPM59OA2shG9nlu/cOM4c8i/2cC/14O98ekNgZg9FousRQieOsk6cbMqyQOVG3ukqIuxlyu9rfOxtGMws6gD5Ds7Z9MXFKoGmQutO4OuzsqVccAaaBEt3QsuSMOj29o+veM8vhsbjkvAQJOqogM5rys61ROVJ3SnbVrCKGQ/gOvAJCQ6fuu66ZGx9Gu/rIJAMRxDc+u//puJrYOmkDC3rgq9/wYMuj9DwNCzDsLrPI7bP80zlQh0wPbYDyUrkd3whAy8FBbLQMqyrMU6QanxQH9CLbDLpgEUPg7EQsayuuNbQTW4rDY7hVtqoefLlVuypY1phhnEQVAcRQjDrfvywI/wg1Jom06AE5i7LQvDOkuxmCdMvSUEBvSzGLoiRCO0n5e7ouURxl0cvmHcQhJUP0rkvUiEBTJ8B2mMLUTjwzP8v7CjOmCwnTbkRXhKCJ+hnt/ppl0sQPK4FOBLHmZQuge8P6DaQ59Cmk5QKuOrGEPsqNOoGherQc7CLmyxN7EbLF90MUuzOh8ZMBbcg0ysIRZ8BOV7M5OKSIlEh2ZgKVOUyP9TpAYD68fRQpAmmhRL0Bjsk0X/KcIrG0F0bMJljDF+y0VifMJgVEnUs5nyQg/Vq0Ji5LqpuxmZ/EDgKzmcvMJonMah5LDPe0RbWb096cZP65OEAsNvq7i5Cr+NIrejEyOWqMZ3NCo+JCs/PIZKoI7WKcQaaotrohheorDYcBse/KP6q8NzBEi0GktCvERMTANMTEi1MwV98cSVEpGIhMEYnIZQ5EhVNDWCBJ48AAkGqYTTqAWnszCrizeKyEVvdEZlTJ+b9DsjzEmWzDc+0qbyOsLQ7L2dTMLPdMa4FDQqhEZ3JMrXtEYzjLVxlIiw5LbMY8ptdEovy7SobCPVi6P/dKzKoyhDExOj2FQmB6SuPowPVaAZurTAe4wCG4gCyzKd63QNOZojjUTFifshjny8qyM7GJtCyMKYg1RIvFzPFWzITTQFUhTMazCpyaFPwhRMiYQz/Sy1uEFMq5II1njFaNsIP7BOPDIoPhtNlLTAnlRJsatMv2tN8KPKv3pQCw3IAXSZqkTN+OtQD3XCmawV2JwtoiTRVpFN4/Sp2oym3eQTY/HGFmUPYRsbyBM0qgK/AaS6qoRAa/AqrTTRaJzNr9St8cPAe0QD6qzODFIN1qCDQRwwi3kwjRlF7wxPgKQ3Y/xFdGwOU2OEu8zL9hQLbuHLvpwXXRgYXTjT+vzL/2s4077cSP9sH48EhAB9o14pUMZE0MPTUahT0Aq1FQ29UGKMUM6stz8V1JvUpvOjzKijDgdNzUOVipd8VCDFDSDlyiD9qaJZ0Ur4Rhn91E+F0QCc0Z4DQxBNK29kVFrQyiETQ0ztylZtjtyDKjl5kAdB0pDiJMJZFzhBjTi5rIi5Djt7sGvLFNcxyP680pM7NS9dT/bUA2glixwZU17wBTc1KTNNU3RoUxRa02vdzx97Mf8sheOpBOhaCl+JgkWwQTGj0aerFSh6OlU91HnVRVH1TA69otJEVH6lzEeFxED9U53MRiu61BI1WB69nWOaO4LdMFBlpE8Z1XAcPKgEyv+fYYbL1FB1ZL2m8DB4VNGsdM5J41Jp+tVb1YuznCE2gAuQyouWrawL8lXK8gMnnZNBTNb+gcXDDDV4Q8GzAxK04Bs3GIs+AIsxFQVTQFr4JFP8dNP55NYUmpxrJUxwjdMFo1M/CMkOodJ0XdeSfLwKm0fiiY4Irded1MYMRVRN49esc8J+PVsKtdC0fVsLRVi7JcMUFbI8nNDgux6sWkdyAD1eNEDMdMmWYYmM1dHk8Z3iTM6PVdhWZYaRtcc5QTFK+SRchQEpQ0xMGASaDYMN6iCXHV2W9SiYnaI8+NVJqw6jiTApLbUubdYq0Ay8HIujpdYx9QVRsNY0dVPfnYb/XgBepwXewGypXOLcT3LFmJAzt1pZS9hIlJtHPpVXuqVXf91Me3Xb6t1efZ1b721JtaXMux1fFI1H26DR+BPHF73Yo+w0RXpGEQRO4kTfs11cdXgKeHxcCdyF1Z09W50im13ZkPID5ksdQUzejiLdlh0C0mXSXXVgOOnVW7uY1qVSC+aFLj2Lv6ndSEBaUbiRHLER3NXdvtxdXQCFMk3hFL7PlzpeXbq1YJi5dwNdXNs7HEvU3ao0RoVbQc23C9Vh7eVeHgbYfLVeQN3e8VVOvK25vUXfxHNEq0CunYviw4PUgMUKgtXRKT4yEXvVTEUmY7pfHxZb1M3aRxPgzQ3X/1q5Dvj530M03coipQ26JjaoYzu248XMYc/rWMAUkWZIWtnlYG5xBDso5LE4BDuwERG+XQ824RT24BV+UwxWnV1iBRmWQUugYeezYRyrhMWsokTt17Ac4h/Wxco8ZSBGZX6NGFL+VyO2FbM9W4NVYlrO24UtH4HLMd08ri3GxsazYi12OvndKJphm+JkNI+1PCbmDcnlSStSMadiY9ClogaZKaxb40dhZdOhE25O4Mpq0je+4whGjducPEAcRRz5kWhFZGkt5KLtA0VWZNw92kauZ1GAMxUORVNQnVSLs5jLZHWFPmQYmzTcrejE0FKeRFxMZVVm6IYW1Ik422x05f+A3WGLtplRlixa3miONUpty7BdLoUYBT3ftGJM21FhjjcoOkpuGLGiOlH9xb8sbUXUdY1qomORfjjmFM5V9LiODB5btdXKHer/teMNGudOgiJP2ARqZed2fmpFNuQ7iGeqTtpTsGd7LmF9nuSa6upSzJVB0KBB+MTuCs3nuCtzVMS0qpDnuq3v1FItvUC5ZmiMiiq7pr1XplvF3UlWVk6O9mJbBtlQXa7kwsaczs2JfSTrfTxtxEqzbkVzlTivKCJDgS3AZmLTk1Uy9i1BtKaZsRqR2FS9mpvIVOsXY1Sa9myXzSAnZQRukWq9WeepFosQfmp3DmF5vmqstmrd5cT/vrzqU/gxUQRFVoCD6vSDYZhPtirNh6PSBnRu6Ka+Pp5uGUYP675uWnzda1boub63V8ZmvcbovR5vvy7vyw5slsYwPQNBw/ZUKvZCk6YxdXwslV7MVYUPqkAy3dGuiHtV7pnVl/HVDHSrTwglmlkIxDabPLHuVcszWsFoSFtZUkIDQyDkO3CDvdkbFoRq2Lbtd4Znef4Wq25k3tZqOAvuOkMEhehETOaC42aFfBAYgdhIxwqREjuac7hkU6RuHu/jopAlIA8Ksna+P9QV2DBMKz1P7gZvUmZlYh7ljDYQ857yhI2PaxTtPhO4LL+qkH3vTKtoD81RY2hA14mq4+mE/15Giv2u7NpKGTy0crLV7Hls0qV+HwMPTqJ5WB9d5iFCt/xAbyyH1zZ+EAJDZAzP8EPn8A7PGw+n6twmcUe2VlwAbn5W8RmkpT2gIBvAhMuRcRrnCNDiLu3mSDsbVn5WuIrMlYgMIVZv9ciAoXmQElcPk8mBpVda0/yI7q8d4yGOJg108rCc8iI670JrYsHtNTu0HqT8ZYSWyUHayTkJr51GzpwoFN6pdjbPiXWCFiyl3AA98kyWsj0WbD0Pq2R+PZiucjrzMR7hkbFAdDJ4d9sui9iWbWkFC3ie7RvBahK2Vlq66khohRxaCFwyExvoIDQYBReScRKZRA0sy96SWf9fvQs7Lku28KSDMzWrHsX5FJFYmvVXf3VYD6GCIRMy4RxXgqWhmG7AZJDwXHJDkKxfDx5NwJ3tMm/jqHJAL3dkT2z2rY2JrTGKbtDi6RDxjnZX9L/Ks/aSeek118E+F2MYC3Bqvie2AInnfnNuRLrYQndlRiOwT6NThDMLP/QMn3dpNfv1rHe0f3R6Bu7dVVpWmORfCm7j3ot7sQHAEMxJZjB10aCQUuDR9SDCVxzDzwvBCbCGhFLb69JmG4V9XtoTn3z99IVqjU8YlM81nUj7VHkgB5G2225sjmjaanOh0nljP/anfKRt87Ywp9fBNWWlzOJyBVxwzG93OCKmSSL/lNH2qJf6x5Y0POGt6Whco9Qexx3fnE8j/hMHd5S2E4+Ed0f0C0d7vYH3eGf7diZkEBcFEc/32+5+Snf81FEMvqCoe1kc5OWMKCD8GPCotojg0Jn/+B8ckHqXe8n/vvCLxQAILlvECCxoEA3ChHDUMNyzcM8gh3UiMlQDcWLEQXowPerI0eOokCJ5kRxmchpKlOi6qby2kmW1mCabkbxl81a9nDp38uTJ7ifQc0KHcttm9OgzZ0qZKUvmVNhTqE2lTqUKFRjWVaFoWa2qlRMsrmHDgi0LLNRWtGfXhlJm7i3aTpwsVcozJ48wbz+hHevbN1w8fPsG4xun97A7e4oT/6s7/HOdOnO2VBmb/EmuorufbCnzJIdNJVvQioYrTe406tREVwdt/dg17HSqU4szTVpmNV6iIkG6s8YNmeDAfRO/Y8c38DTClS9PznyN8T6OHE2qztuRbytPanB/Ap0PouqQxo/HBOmRHxUd1lto70AFEiQ25sNQAcNGlDBs0DhcJHfzZAGGpAqBBapiCXqDfBYGFFHU9yCEMcw3oYQVxnCfhRRq2CCFUMTHIYgTMjjQhyQSNFBCdFzkkSch/fIiTTSl1JJLNarUDmOL6bhYT43FZhtSS1U1JJFE7nIkkkiONRVTlcEyl1lPajVlXGepFVeVQjFTC5aVZJbHKtSQlv+UX8foJVg+gxnmGJttQiYZZ1z+54dmNllylypvjTmbbLT1+WNs9ADq55+12XYYbrvxgZxwxR1XnHPNCQeGck9Yypxxf0xCym5mbKfDCyeIOqqoN7gRXiSshPSRHntwEQN7sba3Xn34ATKIJQbmsiuMzfBVjZjUlCTsi3Z60hGudCLEIBERYqgetNE+W+uGFGJo7bPVbhiih92aiJCKKxrCSIujnEJSM77MOE2O9+z4LmQ8CeVjoUG+1WSRwXRl5FVJjsUVk05iOdbAq1h5ZcFtaSlMl3Xlwclfo/Gl71/uDJZmPG2W5ma8nQl8mcOKePLLJ3QqLDGQ1hT6zsotD/r/MsuDIraSbqdM91ujxhVnhnGSVupFpU4IzcQSRDdhKXSBONJGcCiIqgHUGpRA6gpPgEceeR1NtIWFD3qwHn5sPBwSxTAGezbKEpfp100G5krXIosgJJ+z0NZ9N94P2mCfs3tny22zFQJOBOHengiuRIYo7pG7gTUOb2E9zhubvfjme3m/WGW+ZMByQkkwlVIWbNZceUnWWZd2VWIm2sWU6c09hLl7WNqH4pjTL7V8zMmXYJH8sDHBAukyzOkIajzyxCtPPKIpmcQbo9+twTOkdvgcNBhDgyrDDqGa0D3S3N3wdNRQQwC1BCjsYPXVWevx/iBaGIRft2H4MQiBxUa8/1Tr/JP5v18qs6v8CYhACVrWh+iHN79FiG94k5YD+3atwA0hQ4Sz4AULZ7hvbaEwjxMMCD/II53Qy3Z/CpLrLEexqHTFXy7knFc+BzrSDexzZTlZUxpmFzClDYDIgMY4QmgPH0mjdjNbBzUI5AzLyGWHbbGFIkKjJ0Ilb3lVvOIVj2dFLMYLMjFByTBshp3hTE860ntU9IKjHUsJTQc1yIH4vGeCDJigjnZMAajMdz4G7PF8KOAB0N7HIvi9Lw1jUINCcKUJsr3Oh/4DYDSYEkkWsjBOAmwbR+CWkf4kZD+e3M/gGhQFa2FrgRKk4IUilMFVQkFCraSfK6EQQtnNcv+EXSzh8Co3SRXui1/C0N3mYLi7TkwJdFTq0n9kaA5vUINhcYkbnXi4TLWl8IdAdJea1mTEmQkwh3G5iyJ0hxbR+AqXMeNi8bSoznRm8ZYvmUYYr/Ob6PThUcGhnnC0k082uvGNcPRnHaOWgYGSSgN8PCgEEqAABVzgj1p4qBsEyYiJSLQhuCKQqsxGTUhKkqNO2SVIN7c5XbVCVyCD29sqoUloAiKKLL0fnVo6B0/CgVn5od/gKngfU2YLgxqSB1BnSUsh+sScuUQhL30p0sypxZLDLOYxS5GwZEoJGHqyxUldGlPR6Ol/RfSLNHAUOY5tDEfemMwSmcgJcELliXr/MuoWXxPXdp7TijNz3m7GWEal1RNnaWQO9oQmgxoMtgQywOP4nDbHgUptBCcwHx8RINkBJKCheIRoGgRJ0UIixDy3qAkyNJoUpHYUpKb1X+de6MKSsrYWJHWtSUvx2tbCVqqakK0BWwoIOChLDr7t5IhsqlNnnXJa9wmq7PoxVKIKap1H7WpSlbpUkQqTFsis6lSvm8xbDOVYlwGZskTGXa/apppizRhZ48UN1xbrQE0EHlrFpLF0wrWuc7Uv877IEnXlFTltmEQg7NAHv+IMaM9ho9C4MzXDlsCxN6gBHkfgWD069qAJmOwAKOvHBx8toncgJEXr8IiM6m9/o1VZ/2lRy6QUC0m63Zwue50q4wA5lYX6GyCNS+rdHfNYbr6NqRjkIATh5oda9CFumvbRD+UShsmyy0nkMuZcXJLWxV5pq1hgLEDrUvVKM/xuDbc7TXN4AsxRjOlmWren/51XvcxEWWOcEaZmqnUO4QyQ8Iw6ZXbi977MW8eMWCKKQU+nnn34Q4AJnJx9IviNcYSwY6l2ggmbr8ILvXABMq1hy3JYOSIOMUXJlhteqLjULLbGqU0dXUqu9sWrdrWVy0ZjT7SVx7YmZpmz2ttPEnmUS16ykp28XA8WlXLQfXXwlAowLf9SdF32cpifTcwx81hFaB7vidfcTKXY8jbeFiCdCf/UiczcmTN5Nuee+eznPq/MG+8UNKENzVemLXqf+UwwHEElPvGVQGpSK0H6ROXHEVzg0prOsGQvEPBORxTUExmFaE2c6kfei+KqtniLWT3xMWUc2ZhL9os5Q+scFpDWO7atJlCqW5n+uuX5cPlyi21Uj1LSxVnuys2bLe2COVu7/8E2mc1MbvGaw8Qpq1jjaGdEJaZVTibLn3xNCKh0q5vdVi/rO/lrHXkbusBe12dw8L3vfS/4AuVzLKUJHtkMCwAAAqBsQ+vYPaJ5ug6ZxYio12bqY/O979lWii6rvPG/03zFIK9Mkej8IqXeoinQbXzIaWugKbm88sMWVLdnXnj/jWfOhTgXZ23/E9Vxatc/0vbENG+R63G/dC6nA7y2+ccjjisdh+LknciYThqYUb3qdI1r1uM9Hb7O2+trAHvY2zi0BDsa0o/t99lFlb49ZhoAbn/7A84Xd/UpAbN3j59nzTZ4FJO//IG3l72eS3iksEbwp028mAzv4qJDV1jKgHwAV+jCylt+qPQYYVlR2Yl53OeBXgHCluf4XHZRlQ2lGVysHusN3ch9lLeNCcXkiNqU1XpRhpiolUtxIJwFShX13rqN4NUhj7uhxDWcginIk3QgWoAxzRUcX4EhTfKNHfMJTYNBmNlxgPaVjwRIwB6xHRFmnwmYndx1n6dllkWo/8GILV7/+B2KdRVRMAMVXmH7sV/sqZ/6pRrmEKBbGB4W9l3+ZU7L9Z+wCcY7ZJ7m/U+sNRscas4BLuDOKaDojcw0bUKXvFTuARPsaeDE1MI1AUvFeNExyJaQeI5Lmdt8iaDvnSAkXhGgrcQKtuCiAMcLxuAMeoFfgd0a4SC+9ZOCPd8PMlYfXZjbIRwCGGHcJSEWPFRFWMQTqk3FjaHKZKEt4uKa6SIvol/5sZgYqlDFheGK0Z9bnE4uRmGK8V//Xd4tTc4JGQWyMdsBituX2WEomF4yNSAeEuLq8aHIbAUjmhAzgVtRbBtibGCy5Y5rYUbunRtsNBcJPmIJPgYl6v9CC2JH+LRBDL6BP9IgDYYPKOKg+KDdqEDWKWKaKiZc+SShEdCdIVUE/ryIFOZiNPoiL+ZSa+xiFWLk+wFjMBLj6w2jSCajFPqPP6RkP2iDP4ADMzrjmrShG3IeNcqhNwVdtNXhSY0bT/Kk6VHbN7LUBxrMruxeCZWj7gTLi9SeA27ZXOQB0dUXPU7lXE3iN0wDedxBFhwNIHXdP/6GP3LiDY4dGxHkKI5KQj4Ahh0ApilUQ7YADcwdLMIiHEwkxfGJSU7hLa7GGGbhRXLh+YXkxY0fi/FlXj6SSjLjPLRczJlVfSFVTX7elYUCTtKhTvLONmKJnujhHmrVB/phABL/UdNRBbeVY1PuztgoA5vUI1VGIl3d4yHcwXTYoNX8AT/+41cG5HaIzyeK3b7lgBxZmkGt3QEUZ3EqFB+95dwZDV3WZSugTV/2okX+pWFKp0e6H6p54fiRJMYd5vq1HEsmZv9hQwjFJCAeFS8Bk1p4jDg+0VKhRWVaJpg9W9xkI5agnq/EJ9yoyJmJY1Fyg488o8BIRdRBA1Yl5aytlchAhVS2pgm6phWZ1Tdcgy+YAiNEQiSQgRasgaFxCqLhZhu8wSZqB2/qU1ly2Ng532NBVgRomgEY5ypOwA8u2HIy50JYxCjkJ0dmZJ9MkXVS549e5y9qp3ae5JB6py/+Gkuy/6Q+NKl4LmY+aEM+kCc+dANjzFcRWaD+tdqV2eRUqIV+5iR9aiM3zgXq0V8NeWZ9EpBSuFtjYOAS+WeynaNW7EIHtiPv2BllNqiDnpN9+em6SSiF2sygrcH6HFokXEIqXIJX0psXfGKJnqhZqihaasAEuGhxRkD2MdYd/cDccQFzasFD5CiwAIsWBml0+uip4qWQruqRvqqRDmaqIWmQQKk2dAMuYENK6gM/POnLSWk3YANMmGeWFiuZbKl6epMy3Jx7khzPyWdmZqbIqNR9ns1OesmZudR6Qh5g5AgJIaC5XZU4hpvTzQHELBOfPuI6zWMkxkxiXMNVVuigTcIdIP/NoS0qgNVTWG4iD/RrdwASpE4qvx1k9h1AizoAwmrqjNLoQ4Iq0TisqBoCqUInquoljwKpxWKsq65fq3ZnYMJqxm7sSi6pzfBCsDKpk6rkYrIEPBFrqRrKV6VQJRkge9ZsHD4RtM6JtFLrMz2bnnyjZ/qBIqjItv5nu+QEM8kJaAaduencZWhG1PWpCMoj1QKq1V6tu97joJGCL+gCKQyYd0xCLOArb9QgwO5mifqrpOagigqhQP3gBHAqjYbKDiiB3b7iXEosxV4sq/at3/ZoR+6lqwLm33YsyGZnR1XsSv5qGCGC4yZqrqKsk94qy7KLNr1ssbIalyyrM7VnlTj/E8OALrQpYBSVnn+QqWb+rK4J5VBCoZmog5QtBjs007Z+qVsFyDeFU9RK7WtUre+yK9a+K7xqndemwilAhy7EQi/EwiUA2L6eLQ/g0aTVwG6yUaOxbaRJWkFFzQd0KqjcLd7m7cTuKF8KbuGeL+D2aMhWrOGub/sWI6oC1cv1QzeoCiSwQqGxIC70guTqA5OBUcte7g/J7JY+a9H2S1uMbpr2JJQ0cDKh7h1O0eplq5r+JLCMo7dGBur44bLKxeGV67lCI+/+LgkH7/JABiUOqi+QwqKmwjWkwvIqby946PM+6hXUQKX5K/Wa6PWS3RGi6NgtGKnQ7feC71zW5fgO/24Jqmr6zob7sm/HOrHHTrExpph1kuf85gMvOC7WTMd46C+8zkPKTukK44K6qIthDPDiXdLIcYXn1i7OpgUdnq627pw2amOZhSvQRhF/upQ2sg6ShBVPuAMz5TFVrOe2da6d5Qm6puvUljAkA2/wwsM9du0KpwIML4MMLy8N5+YbRC8EREBD7WYKMFoPnyUQ8+b3+hMr060Ri29M1A7fLrH51jL6KnGrBm77YqcuD26wWuk3vNwwdPF45C+Gpoov9O/LucRMzITr4tjtYQkCy3HOmt7p9mR9ZuMdQ7Aex0UFZ6uZArLROg7SepMlxQXkKaK5Bo8jP7IJu2skG0qEZv8tJQ+vLtzzoGWyJhMDJzdvP4aoFaSABhisBgCs04SP9SZ0gpXKKavybxbxwzJBTY0BGsyiLLOmFdmyxt5yL+NyaiCuR/NdYfolUozDL1PyPKygR3TxdXDxF7Mwk/JDr04oGJVYe41clcgpE5lcTpJpODpw6fpkmVYrnJQZtn6ztuaCxPBKEd0O0hZ1Uq7e6+XunrbzUfrI72J1PJdwhCItvL7wPRfvPV/DMpS1Jnso8dnmDVzAwT7ADcxg9Cp0QvNw9N7AKbeRvvlTEdfoQkQsOV00SWM04Go0RxNuSD8xFCO2nxgGJZLxeRiHSxOzF19NC+rCMqSsP9yqGZOYsez/WK0pLQQusH3Wp1Cyns72LDezV9F5M1L3ca5Q05EkhbdCtciFs7GgxTo3sl/KFW9r9Vb/NtZOMjpMKFiHdS+UtTZ8gyZ7bb7e5oCdwKa2qFufbdhdrw3iTL+uLfUWjUPvdd0azY2OmI4+F5DKhnO5jPkO9ixv9GEfhfoqNvm292IzNjwQ9yhozfu8DyPsN2Tv9yHcDNaIgi58A0v2ambDk/2SzU4PiTXOJ2ZAMOtCE2Zg431S5mrjHgWDo0qRUziMphU6ZjN5toImMOqMuG5jkQj7tsypOHBLMssgbQrDay9cw/Iq9zLYeD//8xpE7x/t+BGqD8CardBYCtgJOYpy/5gbLZ8TCIERAGcRH7F4x7JRZiFXzxV8lzd7G3Yu70mWdzRezkx917cv3Ldm5bej9Ld0THb+JrMY+y9N88J951qOcea10gU2C2WE6+w1Z3OZJmXQZTigC+2Gv24gxjaAEnIHlhnq6ClnGvU6l5NVszgJ9W6PVHqLy7M8EnKMz7hydzqOz3Ak6GtYPpgVtIEkSALYXjd2PxSRNwrPhJ34KN8SJLmSN7mTf7eNRrnSBbZgY7mvv4x8o2phu7eXj1ZMvsQ3iPljl7l+67fO8Pd/T3Yxm4LJXkObp/Q0/MKqbMJNvIhRr9Seo4WER/i0QrBOMgxcYDhUBrqgE5Mx0I6+gP/mm6iuJywCo5f40FZ1pL/pivM7Cb/LpcMzjAcrvN54p1+2S+4zqC/KV1rBFdwr8zb3qwOHXBe5icb6kXN3KN66p4aqFugBK4x3r4+8n8W3yQf7sId0odB3PbNkNyCCRnyYs8/8hzkKtKd5Fw84gTfphMaITaxK3ChO0IP7uJN70ZdMtN5n6P75urM7uY0rvCMg6yDRveghmkEgVAriidNXv0u6U9cDc/kuphvK1a5DfX81WSP8jc+DWSsvozK8h5lBIFTHqQNY8R0fQre63iu0xiv58nE8Xx8SyPOClFM5yR8+r6f8lSv+xdZGEMUDMM+vLzC7mZ/5s9v8f2/Cf2//vrmwOa+6eRhtgtAvzugPfekbfbijlJ1nZlh4U9M7vZ6ejI8cw5EQpetszP2pHh1oxgQ/OrFLXfB2vdfvxON8fW8LvIoj+1cjPD5uyv4uPMNz4gvSvd3fzL4+KqtXvHUPud///a2PT9F8KqqYcbGeMOKff8qTd58QtpZnOcsD85I1qShQPiF9Xx3IvIeh+ebv/34DBKZRp3Rd0zZP3zddvEYxMmRoT8SHEBdNrHjRzyJFGy9WsuTxY0iRnUiWWgXLljBhnTjmacmR08uSysypswkt2S5aJ3clg7YO5y1bluQUVSSSjZxVx6BxC/cUKjmp6ahCfXcVaz2t7bba9Mru/yvYr1vtlaXHFW3arGrZcoXXDe41udoSiiID5k2fSHodIeLj5s2aPqJANZo0yVEgxXb6MF7z2EtkHpMpT9Zi+QnlJk4yc+6c+a6THKNv6FhipPSOGzUCKyY4Tpy0qrPP0l57G3du3LarZuU9e2pVa8OJbzN+HHjwYsmpDo8dFbny5MWbS4cd7y28g/386fM3z5Qe8XXIjyefxk0dMnfOl7/zHj4j+YfmM+o731RB7/O+TTPV0CKKOsIoI41gAomlkTgpqSSUalmlEkVckkmmOfwoyRZqamrnqWB04mlDao4JRUKjMGJDkVyccQq6c1r0TSzdwpoxRrK6krGtHNeJS/8XXZZZBpxlIiFDhxW00OIGLVp7TK/CQBHlj8YWM+M9yCS77EgesKzssxp4sOIzMMQMTbQTSFsNzR2UzAuRSHDB5bnfapsTxzp5o5NOOZmTjs8XWQyuOqmoazE6QfcM1Drs8Mkun++68+cbSMxrj9L0yGjvUvfY21S8+OTrdCBefCnom1J92QRVOgK0ZBCNIhqwo5EUXDCUk1RRhSUKdS2qE1tu7ckbDjt0MMNgq1GGqKJMlJANS37R0E8XD7WTxmprxBNbHdNCZxq4Ri0VHG0mIRIFFETAQIQVvGAzkFRSieXJQBwzow3IrPSCy3xrWC1fz54gk7N9zXzBtDSTbC3/EETglE3PbKm1s+E8sZr20ELF2tO5Pi0GlGJAMx5n0ZAbddQ7X/RotdVKLc30UpbVS6/SScf7tDxDTJmG1Gt6ZMiiV32GNVYFEaz1pAgL3FUmT3xFCdphQaSmmmZuWURZNIzyIylnm/4z2msf9hrsp7QduytuvSWVLlDIzQADByww4Ql6I7mkF3jj7cPee698YkvK0PSSSye8DNjfMgku+O/J2GzzkoXjjPhrh7/umPKuwcJ4UI01x/xjcUIGWZ6RSf6GFUQGUQPm1GN+eXVLW29vojrk2yS/a5Yx9VRG9ijq56BFEnpoEktEmkKhHlTFmD+LyWXpZzVUxY+qpb+Q/6mmlN8Y8hqlDdvaHOvc1myce7Rdm17W2OECti9I4d8m33UXsXn1BrNLvwVOXN/BCRf8cIP3VVwxl4hEJIrhuOxJLnIwQmDlOLa5i1Uscw6EIKLSUQxkKEpk3BldNyJxsj2oAXWtQ8/LMqWy18XsIeSZDy/mYqr/OOQhFwlJDH0HkuANT1cGesmvSJIh6z3DQzxJ3i88Mb2ihCEMi0Deip5hDiYWB4qds8oDqdg9KyKQbGfT2e2CFIgbsC1uAQQF/BaDN72FSV+X+V9qVpA//e2vSAPz37re8IdLCPCOw6iGOBaYwD5KrDeTg1HlwjJBCTZwc8QpxnUySDL+wAUTp/9LmcpGWElMWRKTq1vdGFRlCEaY4mbfeOQ0GALDR6zqdzUMydE40kodthJ5paiESVQEFWcY41cZgp4R2QCFZt2iek2L4jCbiEhrTfGKCaSRO872plgQgxjaSIUVTmCFSUjiMI0ojBnBRL/68YBflfmf/f7HvnGSMwfnLI0c/2aFxwSCEHe8owX3eCPb/PF7WMQnA/nZT2P+s2KLZGToRAep7JyCD60K4SUrmUmHYiqE6AHDJilFB1UdonaidOEmTkmeiZwSZasEmitzqENPbAJXljDJirzRlGPkckTRsxrv9oBEpQDTeSIqDk2AoYycENOYVtxeMonaFm+9aVR1g+b/G6zpCruBAl5Uohe9yEC/E6jznG7EH1aLRLDUmKB/iXtnPMl6R1bUsy1gw+da93nAiflzOhkD6FwzZ8ELMjIfosvrW/LaikimYaEMFexD0fNBwAJ2d3VQFWInqlgQjqE9i5WPKLq1jFGG52Q9Q9mrBsTKV3Y2ekfxKYOA1dKX4spXp2NDUmaKBl9ST6e39Olse2qN2jIjGrPNLfaG2tuick8tyERLXJDaC/jFrxFO1aaTGmGHqkqVqmC9H1ape4MUjOC6I+DqC7Abx/5dlV90hKc8SXEJhPLCHd7T53rZ29bsyemYhoQrxugJMkXpNR9wye8wEAEHNQziPITF5IAb/+rQStKBsWBYbHksmlhPgvIa4PjORsezWQuPtIY6VJVQPiGSYj3vVqzYJWut5lpfOgunxlCxT3vaYhcDdWMt9W2wfDtjogrXvtnpRt3KGz/GLDeq3UxnN6+gGCLVoLvj1C7gmOylJCP5uk1OgQ66+12wSvdLgmlDWc2KiLOuQ73tFfOY76Qbtz5OvvNtIDLsmuN9iG4fcIFH6OSBDNMB+LCUHFOeJ7rnAh92TJCtg5gIXehCD7qxgnYPKHWBEAlrwxcI/WvvKI1hDXMCpR1GEDD3SMRbPQIOSLSp1WzqCaWlBNUPcvGqdbtbV/P2JjauiY2BKyyrXAc2cZGLLsorL/+mrscwhnFuVf2lXSvopZxRpm6yobzsfa1zYFM+gQk0oAEXeOkKeRkveXHhZbSGmczhdu+4a61mf8aDzXdtZJxDJpc4dxvPfw4wn+ktaD/X+7GcNLShEWxviKqwdo+CFM4ApFhKW1ikLZGDEm+h6aP0CmrHssQoWhFqLlx8CxnXuBJNTTQHwUKIL7YtjLfHtRoTimvlvpixcJ1e/eqM13esF5Gj1Ab5mYHIhWv2kp09XWZLm7snALq001eCJIGmDdvmNivOCg9cjwVPZsnnnKQu9bNcndx+FCQhFVhF29Azg/2Is37lsai9ngLUhqU3gfcNaLfvWd/8jnvbEz0GQ1P/yhHDMIijtaEzhOL5VR6ttIYZXsQSqfRZ6GCFJTCBCYujgQtQkLzk0bCHjjOIEyD/uMhJDmvLpXyo8RXb0xmJjYNcIxbGFeAVWGCFGrjTnVPFeeylCnsw9dx+0r6usnfPxsNFe9pYjoy2uSxPSCgMF914uj2xbnUbPV9yzm8+IMt85q1b/2vjqC82FiV2fIyjG3Tea+i6AQlJrh2w97b72/G9fvfLHf50T/+8AasHR5yCFL1ACD8S4ndETOrCQMsPluZqlCjibqHxAAHjIM8GYoAIKE9VEoRWaIUWWK3znKi3QK/kNDD0hMsDWc7NtOP0iMG4osQKWMAJWKD1yICq/1yPyGSPqgin53rvyazLBq3LTIYu2l7vCrItL5KOvBqHFI5PYcAPzI7Qnpzv++phCadvzJgP+8QNYqLQzLQP7DII/MRv/PIBF/QgohrKz94v/sRwDOlu38iwz9CPPe7PF74BHPhvPyKt4ECK8VAmtKjnEzIiIz5BFXjB0yIJ8jQOChyQEEutwzyuAjnvAj0P5UAv1mRtmVwOg+Di9LSBBFNBgHCu9b6km2ZPcLCN9jwRq8wJnMBJ2v5myqBNFXWQYP6lB30QCIvPL/zi26Dv6qQPR+xh6mzx+qTQzKiw695hkaThCulMZN5sr/aqG3ihv9AP0M7w7czwDO1OCqixGv+nkQydcYQ2xREOI8LekP/4Qw7pcLNkSiCI4uGQ5w8dT9SOYBBjQAVgwAEp7xBTjbZwaxF5awM5kB9PrkaQ8B4msRItkQQlwSBnTwV5cApYsKpQEBRf8fbIyed4jsrAa/eEDiMzMugw0hVfsQ38ogsGiBDmJhJm0duWzxa/b1HeoQk9xy140WGwoxd30Re1TjeC4YLYTO/aLQuRMRnlQc5O4XRA6N+k8UjQsAyvUSnFZCkNbe7g7qHcgw2/kR+qsu94AaTs0Go+7SJOTRUeIaVMbPJCIB7nUQwW7tRW7B7xcVAiKMb60eQ+7wPJIiDnbFG4Lx9OL0igyRXwwA7MYCH/T5AHwQQwZ4/IBFMieW7JaLC7rmsjR8DoMlL3wutfpioQQvIjv8Ak30ANNEFhuO8l6WEJP8csQsY0ZbIla9Imb4T5VJM1nbA1rwJ5YKMY9cjsxO4nvYW//gt1ejMas8Aog5PQmrIaixM4jxM5kzM55a083CBT7qAb9Q8csqEcEoIVDM6/tnIUWAUsO64iOqyX3rEBYaADPCAGkOAsLU9p7hEDaSIf3VJa4FI+51Ir7LIudSy/DgIhXsGp+rIQGuELCnMTVdAKFnIKVjAily0VF3Mxm23oSqAxJTPKQCPbAogQ2kQzPzJhOBMONKEYQJOP4uH5ymIlT9NEz0JEYdI1//mIJvVpJVuUF1OTHmbTCpFBHJRvHHBBC/PqzRYFZ/SoGdNP7X4TOYVzGo1zOI2TOJXTGtsuZuKjGyOsHPgBPPJNO3+nwVhFDsYSHlWgPFXABqiAkxBPLYGp1d6TEeVyPkMPzO5TUbAh/LAhLw8CHPjTP/2zuaYgMAuUTwtUE10PyRw0Qi8SFaNMQksAUQ91QmnPjsjqD75AMdrEL+AABeDgQ+2LRZvQRDe17EjzFlX0U7FFRmE0NskMF0FVNGujFFrBRu3KNqtBUXCTR8vuR4FUkogS0YxUV5t0SZWUSX8VDedNPFZGPEzBDfnvVLCT4rQyKWQKicbTS79UHjNOVf94iGgQ8cVuiy1JTvS4h2sijkVozCvQwU1JVL+iiU7rVBb8Ew/aFQ8CVE/jFQZ7MCGdjEED9V4F9VATVUIXlVENMp4UowsQIWD7CwUAgRXgBCXpkjSPcR9ONDRhMkVhs1SfMFtG1UXBbfp0cVXtip5kA3R80vuUT4+GwQ9FLFctiih3dVd91WVfFlin8c9WZoR8ARyvgRFCDWGhB2tEjVmiAGgbsDwtgAIsoDwf0GoW4RCvtVYocPOy9Uy3FTkwkGob0SnAVcaiJmsBslyzQ8cOghjAoU5fgWzZFUDhVV5VUE8HNPfyVV9HoCIJJiMloATWp18p0wcbdST1VoD+wC//KhUR1M1TGZZTjfE01WJiURQ3MJZiNVbMQkZxo09iJ/ZFV5VV061V3UFkZZVkMZfpQK03kbJIWTZJYXYzTPdXnWB03U8bQ0gUtAFZJQkTKiE8o6BZkShooVUeYQACH6LjVA14gSERh9cC11IljtdWnrZMVSynqhZcm0FrtdYmuEUSvVbOKNESXwEcZIF7ZSER3PVdvwBeVZB845V8HXLn8hW7BnVuT4Bu6TYj8XVwOjEWG5VgyWoWARcZcAGDSnNETbNHA/hhB1c3VLIdUlNENTVxHTdHVLIlFfhTS7PqJPh/nY+WcDLdbNNhB5g22YzpSieSIuIpqZF0xxB1Tzhm/0c4DfhGG93AEb6BSrGy8WrXQorCQnpptWoYEL7zpJ7Fh40XiIMYH+8RQozGJSbEhlRqaWEqxXSqGVwEerWWeufsG6w3O/RSbLuXe/FUfLv4QEEAjAm09b5YfhVTfdc3IxP1yfKFfumFD8YLniLVUd9gBQ5WE04h/Pr3cPU4gwR4gAmYTmBjLQYXNSk3i7qCcQ04VSd3gSu4PruCli7XRutpg78vajzYrxCh8R5BhEVXZo0UhUM5hXn17thPDe4gwrQBs+SgWbuSaJj4h0UltpgCt6J2W22ZmGTLV4w4D27Yl3NYh9Mxl3AKanjhiY95j7glmaV4LsSWH8phFqJZmv+/Fw/O4Atw4JpVEIzDGIxxAAjO1xTXV5zLGLv4NX69RF4Lc17d+A/amWBDUm8DYQ20QAS0wMvIblMpGIBl1fv8WCYXNmL12JBZs0QRl3IfmKAnuHFHM4I9R4Er94L3d5K7xWFhw2RZYXkEIpM5OXRHeXU9WjmZQKRDugpK2qRP2qSZkimX9JOfUQ8oq5Q6juKI+XmPwQ+DCadn+ZZ3WpGGSVCeqIlyQtVCQSSGZw6AuVmrpkC6U6Y/DZYZAv8KAppeIRuyYRag+R+iORMEoV3FFwdwgJu5+Ytb73zBeJzPGq2xCwX9tDDzNOlsDq7feqoGNmEuVF7cgAfSRQ+azj7/8/mh99mfPRWgq7cuITaB/fo5ApolHblh9VmRRdNTC9pETcJyo0aPWo40TdaDN5mzT8ZKSRmkY/Z0UZq0S1uUjaB0dVV2huGDjdmYozd6gfqWdJqWZRuX0bSYrgeoWYwkYkKmjmjUWquGrya0XIU75WNUoGk6rVqamzsRuBoPgACsw7p8WcB8yfeszXoEtHucyVpP2zpPw1teFCPpfI1d4njmagCs7G8aZvWP/9h/Q9CPAzu+x5WwC1eC8XuwH5m/89uxU3U0GZpEG9uhU2qJoncaMLtGT0sTGlwTWqWj8k2Fj9QoSdrCRxvDTdu0Vdd0sXEPIOE/BuKJc/pqZ/mH/2ybp50oxS9QtqHFeWeZWLjSVegAhzyLpDLC/vIPmlChqqkzmqFZmmWBEqj5DM5gus/3iw90bcuauuuVrK37u+klQL/AMMwg2OK4nWsurokvnpiKB1AgA1DAhafhIAzXn//ZoSsZvx/bvu+bvgHYzJcwRCnWsRG7sZnQvwvXJBDvkqshwZe50zDXr0RqsyT8KFM7tC/8tEkatTlcTBq9Vx2dSdFgTBkhVKQGp3U7t4OatlF8xaOoxAvlxYUptlwcen34F4xH1VOdeVi91T8YxHV8bLn3qptbq7U4EXK9Xa25mr+gyH29msta2Ie9MNH2uw0DD5Bd2QHWMHxNShhnJP9Z7wbOJcwVhj/cO7BBJrHl+73z+L2lDgmHq1Pne80NF6Al278B3CXtPM85NaW0Ror7nM1and5NYofvfXdGGLQTfdE1fKT/XZQR/cIFDSxfu8VPfNM53dNn+9Ph8zgOPuE1BJmptqblvdQtPmpOQVRsR2zJltajOauBXItHXshfAbrBt8jPgAW+WW3Nd23ldcrFdwrEF9kLAXxtHudT4T+vPMvn+MvTBwPQxQ3akEexHb4LOkRDdIND9swBUtzJvXCN/kUFGcANu9yvfs3fvQ8t2gqZh7IjOdUfHN/zHfIO3dAHvt/9HeA3XNLTftL1bRAKHuMRfmofHuEbHuLrPuL/997UJf7ET/3i815ETHYYnOkNrdrjP765MyETRr7xvZfIfR0IJl/YgWAKivzy1/YMZn7mZT5eqVybcN7mY6EQSB9eJOH0g43LCKENUgDMMeABgj4NeKHojX7Ap15EB6rd7hyDHraQ3XxkpB6w/TiC2/328XzN0xzr8UHrM33QlZiJxX6H4eC3L+7s0R77s3/tt5/73f7tKx2j6V7vx5/v8Z7kBJ/iA9/voWb9xX/TLbvwOX65ZeEVRt7WuZfxGV/Xdz2bAYKFQIEgBgo8M2XKmTMscCic8uWhwi9fzjTCg7GQRo2SYhXyWEiSyJGXSpqM9AbFhQcYMDiIcMOUNm35/2ra3Hcvp714+OrVw9eT57ih4sQBPRp0HDJpxaB5c6czKlR43agCtdkvK86tSOVx/YqU3k6xY3eGPdquq9q1aNmqemvJ0q1qv3IdQ9ZKk95SrfoGy9XXEiA/cAoX5oIYzRg1i7VkeQy5SeTJlCszsXy5SubNnDV3lgI6tGjMY0aDLq2Yzh5Dj1g5ff2M27bZtGvbvu0sNzNrus3t7g2cN+7cw6kZjx0c2nHYypsTRw5d+bBhunppA/fqVbly2VB5nyVLVqbxlMpTSpTovMYzQHC4J9hQIA4W7Ru6x0Gx/ZcgEB1WhLhQRhsNKFIsHYVEkkkKIoJCAgkc4ACEMyBCk/9WN0kl1VDxEDWNhvCgNdRSIkozFVdQjWPVVVhlZSFYLq71k1lnJcXWUdjUiOM+b8FlCy+39IVXX37ddUxglRBmGBxssMHFYVg49iRppklJpWdWfobllFpKZhlqVIyBxh6rYfILc8WdWVtyaq7Jpm/RvblcnG2+WQ11M4GDHTjbdYfKK+GFl4ggeCy0UBkLAWHfe/LhAERE7LmH0HwsUOTeF/flZykLjWwqoEYghYTgSKkkuGCDLkFogQiIXDNPqzWliGGsHHoIz6zDMFVXNTmBBSs+K7II7Is5zigjUDHmeKONw+L0449x1TUkYHb9RW0pmgxWGBtOpgZlt1leWeX/t1yCK+6WTpxrrmWKfVnYmGWaiaY08qIpHHT1zqkmvfjOWWcv+vyL5yvZlOMdeomIN14icRBKKBBAnMHowxWdUcagDLv3sEDtQfqFw5ZaOgUOhDZyBh4XDYggRyKFqqBIhHyxwgUYDGAAhCLo4UtN33zzIc+yFrvhrB6uQzRRyhlzV4kfSuXVPr8Ge2HTywI9tbBV49OsKoIJyQq00fZlrV6GabtkYttGGW66aZfLNrlql2ZlamK2Vk048EYTr756p3nv3vv+llyddoLDD3ezEDxLdoIWkh55CTeucKAoC0L5Rmd0/B5+9F2eEEWU4hfRFyZndJEkHKnM8kiCiKRg/xtvXBBhzQ7cTMo111BVVa+4F11370JryHvQRx+j666xqghs8sIm6xPVODp/dY6jNPtIa9N3fUtTTWEP17VjK8lkame3vXb55J+/JdyayT3I9L07N+9t5MQ/v99w9m2/vXgD7ib/gP/Pi2n4wl/8KBx4ECeLV2zEYI4bD3ge6MBXoKdygxoURCLSOdB5boMcpIjJTrYp04mQEIRAEAlJZRJEfKENKIgdqrAQCV90oxkB7FA1OoTD93GPSHUbmtJygo51DK9MKfLZPfLRsxX5Q3nCCtrQYESsYSXraqMwxfRq6CNWYOIt2gPMKvbiPfCFj0lacFJi0Ia+t6VRCWwcl//b3Gi+9bGva3W7n2zqJ7/84c+Od+zj/fZ3r/8JMhkAnMY1iIGngW1nkeERFOUohx7zkAeCEkwEw9gTH4EkpHOecx1FzOC5C1IkhKQcyQdPiMqSuOyEXXDd6yAUIQeogAl86Nr1moXLXO6Ii3N5Sop+CEQh3gVIvnyREpeIzBZJ7UNGmxf0ohi9YW3CFKbwhTaWOA1WjGKL3BRS2PSCrbKxIQpmS8wWkLADJKBxjXFk5xvfqSWzMWYQWxzRm/KIx3zq8W/60x4gA9m/gDLjL4DDBav0wQ/CHW6RCExPJONQHocaDD1xiMOg7qMoTX7SDBwFpUddaYeOhs51fyilSVH/iVJUBmKlb3iDFi5AMwgZIFVNUoOYbroIQAxCMHHpaTd35BoULa1nGAoiXbhWtyJe6JhMVEuI/PmOYz0zmviYojFPIcN5AMwfvoBE9bipF7BuMZzjjMIYuQCFtM7ABulsIxzVCE93ynVt3KoDmW5FP33qda/7xOcf/wnYQT5DsHcZxjUIx49sKPJwjP3TA2fhOPSUwVAOe9jGMMqCy+Ghkx3tbEg5GtLPkpSkmzopCUs6iZSeNhArbCkPHhBT2YVABTaIQRTSSoTb6jYMYZCDH+a2S6C+C3hBhIcRmXlUoCZVLa9yGhOb61RcFYOg4ZDqVKlao29otYBbxcVXxRrW/7Fmiw07sAE5EQOFtdZ2vVzw1lzV9t64vpVc5lTMatx3N77qt698/CtAf6MMwgIugN8Ax8AG9sBFdkcQDFwoZMdjqC5IOAiWCsLlJjbKD4I2tBzucEgP8eE+rHTEJV1tif8gYRKf9guBcCXMInCAmtHMARiYAVpxq9sh6HjHTNJpXLa4za9ykRfDKFpxf4kOGuZFLq0gnlCT+LSbWDUsRpvutJwiFOxSVRvc/VdC9aGNSAwCDphAhFi3KJjx3hatSwqDec/oGMbEV75zhmv6NAOmMcyNFXjN6379rMe86bOf/xUwkQhsYEX+4x/beaACF+jAxvaJghtZHEZKuWEP2//hDpzW9KYdIeJQt7jFK2xxG0jM2i60FqQpcSEsRaCFnfIUSXOoda19S+vf4nTWTP4FkYsL7CB2qC7WskQ9b6hU594kakM1SzuKgqtdEDQtWqbqMubxZS8XcB6ngAMSwhRebmLrxkmq6R7mmQY5t1V97ayzu93qtsbQ89eA/rNf741v/6opwMERcDN0kUiGMvKBkhtUGeLQuAd7JzsMd4XDERSIRrCaDB3udB06rWlQg1jjoz11HzzO2k+ucNWu8wKMYzzjVNGTe9v0hMtf7vK4YIsw2qI12RbxVePQMKnITvIwtHitSmjCfUP5ZT6M6DPonuXZ0qXWUp5MNbJUmyv/Bd5qAa+uj1NgobZsAISZtWhm79V8p/QchB7OPmbE9EAEIWjBDt4NdzvfGc/qs6ld++xHu9k77/nmu9/1DZy68BvARAKgLpaR6IUuktGIk1yhDl7RihpMgq7wlAk9W3FGnJ3Tm7fDxTduhz4cghEa37gnP97xNowcBy1taWtX4OpXuyESWZSWLW4fXLhUr6ezpjlvx/7y7NHbd0W61k7rWaaeu+PIuuuVE4tiZaRpD+rGawt2ueILxAPs6oXjB7fHUF4b7AESpzCzIxCRdvvWQQ3pVndtZ9sSD8Tg7XGHd/3nG09wLea+T6+3//Xed3/nf/2lG7r0I4NHSMBhWIin/1jdIXCLxmiz4HiTVTGTRTElMzqcUlqmtmkUF1pk0HkhyGmQAHqHcH7ndwckKGKIEGqo54Ksxnot5QUwhXIop3JVZIBZk3s72D2K0GZkg2s453K58nQ/pzU+BmS+1js4lDu780Qn8mxMN1hIc2VGAT3XZTVIUU1aZXXdl1Bd5W3fhnZ6kG5c0FZFYATppF7vZwFt2IYvoQI60G73R2f2905GwG6NYVN04w1+9n/4BIDnEICDWIDElnvCdxxd5AwBtAzLoFjh0R0ONnCyECiPZDBxIAgRthAk8Qcj5mkWB4qdpoIbV3onaIp84AgpKHqt11KsF4Ot2EI1KGMqZwpZ5P81uGd7uhRzPpU9zuJyi6AacoAGS1JrwYeIeIEJgoGEQIJXRFMVRsVzwBOF0zg80VJdQmFdWChNMrF93Md92kAKiKAFa6WGa8h2MoCObDdbIRB/b9gA7zg7dliHdDiPcicaerYIo4B3gbh3/CiI/iiA+/UczUAkXgNzn/AWt2CLBUlkh4QnjgWRj/UdifAKkhRRE3RKG7iKFXdxhlAHHbl5mqd5ozh6pGeSomd+qKiCLMgHrddaLCCDNQBbsihbaUBNvThQt2cMuJiLWZNmaBCEQ+iTPwmEujZkgYEtOpWQw7eEzdiH0rh8UjhYYLMK0vYaRbMh2rgsmmdNXeiN/9L/C3zABGw1A+xoAREQfxzAASZgArOVAWYZS/BYk/SIf/JIl6exf3cFL38IiAEJkAEJP8ZBPd8lZNhDZIc2QIjkJ39CCQhjHpDDQAVzMNkBDsTgCqOygS3maR9pCJznkZ1nZiNpCiW5kqXJgoyAiqzoSl7AijwQizRZMyGgBvqIk1S4kzzZk7jXCX5QVrdVcwhZm0cojD+oa72nJO3yLF2DDD4iOPakd0+hDk/5lNP1FtZSC8EgItHZPGURFFRVPTLhD92YDdz3L8twCE5gBCXAARQQl++4Ae+pAfH5lhMQlzUjOw0wAUnARk8wh3UJX3aZhngIoHOXPu7SDO/jd3+p/6D9SIh1oU0kSJiEqZzTQWSkEAuKGR6V9JjpgXATJSgT9Qqu0IiNeJmg0Ags1ZIi2JGgeHYjmZIkCKMweoouCoqY13o8IAIuZJ+y0wFoQJsJaJvCkJuCd4tflFO+FYTJ6aAG+QnKCJRPCqXEeXxJqE1/ES08JBvSGSRftBe7kJ1QCKZZBk1n8VWiwCpaRTiJllh4EmZkQAZOUAKxEwBzCo9o+ZYR8AAwVp9ymSr+CUfosgR+KqhyNaCFehr8h6AL6pf/yKB7s6RBJpLVowdm91XaRKGkkAqI9wrg4FgbOlGQsx54UDkO53AGYqKTwJFu4JkgKYI0GqMwuk0miZooyf95GLcGV9AGuOpaKHAqsSUA9okBPuojQHqbQTottkkkuVgLO2iMwlWIcCEmw/mDvzcHwBV8hyh9V9mHsvEXXMoXd3GNUDmNU0Ft3Gmu32Wm4fkv46lYX7YMp2oHcPqO9imXsISn9kqv8Fhj/Tmo/XpnAmqoAHtnnDkXB6qoB5sO/MiXelMk15OMmiepk7pTelBm5IdViZlIjNlAE1UelZQIKDMqJgqvHXgHqroGqhqCm5eyrvqqJyirMTqCNXqrV4CrI7ASNPmrssMFd1V4xkqsRFokPlsX1KCDwdWkv2UJVamESuYsZDcYw/h7vUV2PmWdvISlWooMxdelSSOdRgP/bR4idea6E4SZrghFnuVpqqlYAxvwjnRaADtKk+0ZfzMgh2CQbpgRqP/pr3trGgFLoAaaqAjbR4LLoAPZLLEaqWOoshSLCDGEC72wqZEIQZkQHo+THpXkJx8rCKVqqib6gWvAeSjLmSsLmqj5oq/6shAas5x2sjNLszTbILC5oxawBTxraD8bpD1LpAbYPcJoVr95Pc1piw/ru78LfHohJFd2tVUGGJXgvKoArtr6nEUxrthYFj7xXS16CteGJ3gyomlrBlagA+sZADVTvjuas/lqpyRAt5khZ/yat3wrGgIboGkIBqBRv4Y6d3SgZ6pAZIFbG4S7oMixd9ABGNNT/7GJG7GSWmaT8LjXITAIJJEQNHl/EqKkKqK9YKIb56ahyKKLu7pmFrMti7oiuaqtO7O3ygOwg3Lpm74OgASMALS3q7sExW9Ciqw6WbQyB7W8FZTB66BZNAqC8YPVqgil8LzXeax2Ib0hkgvFJnTY6ZzOJK7usJ1WvCHZS4bsp4qOQE0lyJ8pwAEnZ5/nawAvHEvr277o5gZ5eJfxC8dxjL8BCqj6uyXs4wkGC8B4JJ3skKACnDcN+yOPEKNaTLGEbGaicHh4klgT7MiV9EgfQaokusEgBroeXKshmcmb3JKpq7owurpn5wYmm8Je8Jro66uzowfDSsO468oISIUGKP9tWmOcOYWE1YNU0JJmvMkGeeDLfpDEtMBLVRg/Txx03zp9dFJd0InFUYjFWswYP0ADPkCO6ZgD51ID6knGZWzG92mnb+l27cXGXvW+9Si/8mu/dWzH8bZ/dMCHezy98dzHgIwmw/Qjb8GykeqiidwLxLCpjebICeZolmYyBhILulDJn2arJszQi4sILQq6Dy3CD52CDB3KrNrBbnoFT8ADvXrGLkwANUMB4keEBejKJn3SQYusyaDDQ4pLu8R7vMg12iSctlZzwPy8Vau09jRdvIfM8DPF2jmu0fmwybhTaqB2MbCObegBa6nN89rN6uuG68hWbGR3rHE9jIAG4vz/xvkXT3goBOv81ezzzoLrx/LcqPqCe5BawqdLgpMQC9fBqQw1uY35WNlReSojsgltBx44q6Hc0B/MByAsqbIK2Cyq0aO80afsqyEd0nBYB6fQsyid0pVt2bm40rfoRT8m07mIxD5YxEjrvEnLRVf7F84LzKUtItHLHEK9zN5gbLs3ZkidhmzohnDInnDbnnialudoY4ixh9aDS+m3TnrbNnV8v+qs3AI7x3LM3GPdzo8wfGh91tVN3Yuq1ranCoyw3Qnc1jAqCheaaJILHplQiRSZoXhdeSKx16IAYoxwyas7wiRY0ZzcohQdkvhNsff9wRmNwikAATVIMyBdk8pp/8CX3coIrry7u8TJqzXC1eCfzcs2nQeKIHTHzMTRhtpHbI1ALYCyTXa0vXbwx558yqcVMJ8pDs5k+W3mdnxA4ms+knZ2ec7oidyAip4Cmtx9C9Y5ni6Gihr868695Dtfe93zzKgLeyaEpJveDQmj4LJR7sUWikjeIcEQNll4ECjq7XDsvdegJ4ohVpKpWJoejAkoO8opqgeDbd+bLMqJvQZPwMKOTecD7tjxOD2ERqwJzueXrd1Vuay4yZO0QC1GIq3E+MsVLnTQO0zCbOEWrtqTvZe5EdODcG60rY4ecJYlDo8UMLcvwJYt0JbnWNXrgpykXdIN623t5W4+LsfL3f/czv3cXm1/qCE3qhBUSH7k2knPxQFga424sfrksApqVYRVF7qpjaVwcTBZmEg5GOxwIWuio4nJnzajKmirbjAIoPvmZ77fa76qpPvmiW0FAN7CBB5b+MkFo7Dafe7ug+SzQlqd39QJxQbouYmtQ0lzNk2MkA7oRjoYi568TgfUycrZ1XPpW/1+KnDbtz1/P3AZacCf0lzNLW4Yy3h7pj0MmOAkrR7WeRvWOw7rse7qJA/H+QtPYTJ+yafrdkON1n2wgAdA9wxUwg7lWV3s1JSp/ryY5Z0wzO7sm3uZF1qip1p6nxfmY670MLvmbvAIaE7RUO/mhM2ZEu+mT/ACHCD/4Oh+5x5QBWTSb7c7hYH17oIn71zaU6MdF6GgxLNMldb52QK/w4rgy7WG6KId93TvY8NM8I2+C7R88Oe26rbddiy+GB+JsuVcX0n6CJHe2r/wCFvtXjX+3Dhu4yUfqNectzkw650v1odf1rt+3fyliNIyPdx981Y0mjfvCFBOTYlJDN7RQBAVeWUgKJx7oSEbCUdfsgtt7SfJ9IQN9cKf5iA87ncbpwhQ51z/2BbwA2DvHK0ceJQd9jcc77AQCpyg/Wpf73AvbUEqzN56JMQ5hLwwlT3Im3Vfa49O9+uf2t5f6LbHpSA+20lNW+nEfmkwutCc8ADhBxCcPQUXWSql/6pVrmPOqHGDBlFaNYrDBnHBgpHJRo4dl3yUAlLkyJAknZx0YkRlyZE5WLps+VLJTJoma5Yco2aQIVXNKEoMF1QdO6JCjR4ll1SpNGvbnj11ClXq02JUG97COkorpFGOIHn9GparKbK6YhFLlIhSHEpr48QpAwTIGUGCCqU6ezYVqEmO+tgBfEfwHTeDGQU+DNbw4MJ61uiBTFiy4518EFGODLmOm81uyJBJyeFBAdIDCJg+XVr16QYWfiAaFvGhQ9rMbN+2ijt37YbKfP++LUz4LuK1aMGCxUl5peXMEx4vbkz68OMJE1byw2bIdhhQ9iBcaIthsGCqSlnC7ifPHP/26tmzYbNe0Xznxu0rVIXek6VH/eH8R4MLKGzYAaP+MIEEQUYwOfDAnSx5MMKDOlGoN6mAqoiVPTTyqEObPgTJic9QSgkMmUAkaaWbVmQRp5wM+uUnDL0pCql3xEGKqaWW2q3HYsiT7pettgqrq63IGoUsUfAqJC213npLLrnKqOuuvPbi6y/CyOiss8EQc0Sww8ZkRLPMODuTD83QdMyzNN50E87QHDjAgDpRW00APVOz0wEbHuFlNt4G1c3H4JJBNNHfqIOuuFWao2+554abrtLyqrMOO+1U6KADIsKgA7xVjANSOPw0YQ6Q+d7TDr725nsOv1/06w/CQfYAEFT/OCxBhEEFMVHFV0+EpbXYUI4VT9AcKZrGF1bUaLEJaVkaqUSbTiIDlFhAI7Fbm2BCMVoQNRqjIEBlpDFddYfKcUcdlTKU0N6ExGpBsbwyxRFTjlTSrFhSESSRt8qAK665CC7jyn/5iqSPNbjksrPPGlus4snMbBNNNzWG0zM1Op44DSdKyKABPvE8Oc8+RdAjUHkLhTleRSlV5j7oHj2vOUknrfRQIG8+lRP1whBDjoOCrq/UeRfST1NXo3DVj0l/mbVBWwsKEI1BgG2Fa2C/BtY66zQhu+xPeJ5tXXWZbdYUaKeFO25xr3XClXJc4dZba2M6ke+55a4i8HIHaQVd/7XbVdfdqGR+maF67wWrYSSVXLKXuuoqI3PNz9D8rUL0wrKvLeN800uLGct4TY1H53hj0kMeeQM6TUa59j1vX7kOl1+OpnfGfV6UUeSGJx5SRTpBHjnhgANeaeqYxk+8rMQLhTlRSQWS6qvES3U9V9ljrqdZP0GoVqwDBARBVljptetTHzVP7Ojlr8WYh9jFf91pxunmmmkYCZyHwhUuO2QjG6DQW4nA9RKXLLBvc9MB4KqAhsGxwnD5QxyOFJcU31Xld4ii3pAgh6QkncKEovAFLgpxl0IIgnOa61wiBEEM0JGiLw4LmZw2A6fTYSx1rgPi6+SELdDkQHa0U9meUv9GmgD0yQN02B3vYjZFn9kMfqPCYs5SpZzkMa9xzrOU9rQ3HkfZ7D7hWZp9que0qBnLfFjzgyUWsr71hacVWrEj9oIUHeIgyhx/HMo6BJm/cfBvGOu7QwAhOMAQWcEMoPhHNvKWwCXkYIEqsuQDF8miF23tFj/BYAY3CK8PVvGOwboXJJR0QlaSIhUsXOEKz4AHWrbwcv+KRS9AkYpJ8OENbvqYDuG0mcyg7jFBRKZnvPCmJ2ihmc+sgYhSIjs7VXM1KsNma7YwCu1JsXlUZEYZR6WznF2HnKGoUG3+6M2Z7dFSNAOjcbQ4KnfmIjrncQ/R2ODGW+HKD3gcox3jmb3/3mQvbeYYJDoSWg1kCIlBuNJCFZCgIk0y8iSuWIYrslGORsBEb5W0qN8kKFIKfmcTMQLl4Q43SlJ2UDeKakhxiGSvIrHSpq604SV0KglC9LSnkvjcDHGJpTD9cpnNDGZSQXZMpi4VZDl8pjOjeQOq3gAFL9DBC2rwAmpa85rYxJ2etMmKKILTrFVMzjl3pkVJRYed7fzmO+FZT/TI53j1i6lbk2GeuooBQlY7iD8BGpuGetCw87IQNRJ7P4Sma6EOHQgc2ICRiVZWkdSqFkVNUrd/dFYWf7iCtxqIyZaMtqKMvOyLHvHJhAJSlCwtZRqhdyB76cuEpuDFTXnZl0D8/8G3v/UtUGNxFyxlSU1u+Jgzs6BcpW7sTEJ86hCreoIVXNW6GdBAdrNLJwM00U7eVWLKvJoaB2CgCtyUzVnVW7PjqNW9bV3eehEL14HONY3zbBT16Cm9EJKPfH+1lUAq5BNkHLKwB1YWujDU2EES2Bb7ySfU4EPZTYbUCZDsbDmy4QpX2GGSe9OsaUVa4ZtQISd0+A4vLmgjxC2upS7lTTsV4ivNfKWEosDxMHKLYxM27C8/bkOQ2/AHSeClhjfkw8eWGVGRMbe5TRWmiboV1a1e4AER4O7stMxdPoG3y2A9WWsqwIX1ISO9MJYve9tLzi1aT63H8eJbYUbf+spVrv/zy6J/z7YJQ0xoPxAWLNV8QtiGQKPQD/nJoBN9Dp94Q6HNoFefFyGHABEtChNt1RYonIQWkRbEmMVWNjo7ag034sMpEXGKRkziwJmYCxRcBCMandLXLji2MjYOjSETlhPywhc85vEp/BKYh73B2G/orSQWtpdJIDm5zF1utJfbsS41WblVPcl0q0oyLnc3rN/99rfBvJryKoGb3YRpmtXYnDysqt2KePd7+xizxam7zmS0J76dh6k8/1c9cdzPI/z7iEX485+zETSCFZ3SRCcasv+mNHvE8DTtIGGyXOB0xlmNokZoeNSd3XDeUi2SVId445fFSEF6otBQ1vpdtwb/4Wz7s2tVUi6FKWRlw8ZUbJ4nu8g8RfIbtCB0aOck2sKU7g6UvoMSmMDpTz+BCUbA7XB7+3Zetvq4v0zeDRhhtWZWZ5rZizyh0Qfe2ElPpN4sHEE1xe1yjisYY85HuoeH38P7M3bCMITyGWLgEEKx0WwB6Sgi+icsf+z0qhfxCRet8fqc+MUpa1mTWxhbrvg4qTuM6kuC2NOVF1cEVyIEIwhBCCZCMU9mXSOXvxjNdLZnsAA8817169e+2DFZvJKZZfY+yMFtRMN6q6WiuwglTR5iSpwuAg08oPnOnwAEIJAB6I/mNN4FQNWzL4Dth9d2qBlvaTCAhDug+/XnDycw/9IKqXiXXe3nVB4VXT/nt8MehOrHf/71n/9+y2/S2vEz/hBAOAqVGHEZAjM8hVJASMOKgLMEiJuwOXC8opm4SqvAxtu0TWMR0KsWMxC1zIukRuiWzlM1DqwwKUO9TlKxFROliQA7HTEUmKKaU9K1GrMxmxOF3NK9MsmYN+k9wfgtvwgED3uYqIqoyzo+FCQRFygBK8OAK8MyKIwAKew27cu+7gO/cMvC8ZqdCdgBPSCr2OINTGG/9LCr94MvYGCeequ/+Yuz4IHD+wOaOWwU/Ou/cfq/MJg9BwysUPEEA1y4QPSJBgS8iGM8NKC0ClTERWTEyqI8DSQxlLCCP/jAzP97BTOYKhI0rU00wU06PcFBsZNiwRq5EBc0RZmJpxkTQNrqD0a4sWDLl91rk2fzvcCwRSI8KqkKCSXkxWyzKhPQgCfEAAeYwghAAGM8xmREACbSQtTIPmZsxusbt3IDQ7BDP0NZP+Nhs+NJQ/WLMzZ8u3Rww7izM/6Tnyyiw7uDn1UplgD0s2GZDQRkQEJ8QEOkA0NkRAtsRDHQNE2TPIx7xJObiZMYgREoIBDkqKkKl5LrNNFrSDA4vZRwtXL5upXSoKNIr1PcDfu7D1SxGtoqIZzbQR58NuVqps8wA8AAsiIsPkryxRdwugsIxiuTQgRIAGOsyWW8Ou7bk+57xmj/FK8lIsau+7rDOiz024U1ei8uIjvlwL83nAq3mz9wjEP7WhR1xMpzvKJ+K7hVXEWCC0BPOLdI+7NPUITAo7R7VEt81Me27Ee3fMuA7ESTIxEWsBsQ7LBM9DyQYEiHnMuSKL2U+MTAMRfWskiNLMUYzLe6i5+PbMUEsS1gk0U9KEnmOkme47lcvDZQI5GterqZpMnQvMljFM1kNA0AQE09ucJnHICfBEotLIAu/MIwlD+qNI43QxatVB41pDcXC0fX4yCXsko4zMp01M2tvI4Jacd3HJZNcM68ow+0TEsIzJoAScTq5MfJe7XtJJq4BEhIJK0RQ7WpsgLMyzyOsgK9/yxBkAK9v1wJEmm1ChrFFotK4WTMMsIPrfAVV+SKrlilfCHJyowmZ/LBIrSCA6UyaMMsS8oq6voA0CxGZFTGZZxQBZAA6ctC1wSAZWTN7wNK1SivGSjKa4QZeXJK4kHR3dw/3iwUcGypUbLP4fyN4kRHGrVDrlTOwDqIr5S0TuhDPwi8SZPO68TOfVRE7vxH7QRPv2RSujmJK3gFEDygqVLIviytJmXPLAVMJ4hIwEQfQ7AgxGs9xbxP/FQIraCpG1QSxdiht8mIjaiqp3qCA5UqLVBIkssqBmXCmITQKDyACk3Gm7RQCRiBC/VQ19RJD53GZWwNEaXNo/zN+jOjOf9klBVdQ99sCnGM1E21TUslTqy00aeMPfygBR01VVPdDx0NlfkwuLME0iEt0ljNzrfszu9U0omaCY1ryM/zxWgyA/P8uGwIBCoVrfbM0/AUz9MbTCnQiBQTJIpwh8SRjWml1o2UjvzCs1MZklFQkK7wC31JEM2wNozbCIxTOpCIqgS9tqo61qhrugfVLuobRjqxyQkFVAiQgHxVgARQgNr5qn/VOnLzwmr8nd0wo+eJL0/9Rt/U1IaFraisyoSt1DpUwxWl2HJcVSE91YOQNFNdVekcUrWszjGQVe+0VSi4VSrQOF3NUiytFicoSEeqRFIjBB54AputUr6RASMQTF3/xdKsYoJl5VkFis9QvIVAYbhFiwgamVajzKsKCaEzih482tYkYdM3+ZhyNdel49o69VqchQMeYFeYdFd4nUkMeMIts1d+DdR9ZQDpc1uAlVuVSU3vI42hfAGCTbc2jDGELUcZbVGG5VSHxVRylENPpZn940i03NjG7UrpnDRXhdWSPdl+rFXL6ke59Nm5JNapYgEzWAYQ/Cyxvdlp8Ust3dmtOtbVrQmH5NKIJD0vFYNO+o7VCsOkXdpqPbNjwAo0itqoxaN9GRJ86QrNeLat5drklaobENvlPcKxXb54zYAnzMk7+dO1rde4ddu33VcK9V48+V65tdvYpEZWSCw//0Kz3LDKuQLcxIwKxRlcwW2exOXN+q1fOvsR+zuIIO3Dj1XVx91fkJ1OIi1SkzXZAclczN1clfjZFfFFEklPD/y4cviHhGTevSQtPWXdDW5dXwzPlMMVC1SPrbFdpFVaBEus3t0ePKofqqWjEjISbxWMzcjack3eGUhe1YVTbONhqkIBkqHCtC1G6yVi08Det81e0gjfaxrNuZ1bajQ/SK2/q0TRumNfeOog+ZXK+JXfUrniiJU7+ks3xk09jQ1gAH5cMh5SkqVcR3Tjyn3jIsg4OWbgymvgTMqkk7CD0M08fgAtnG3g8axjDs5gS1JWDDa6ADkCy/VHgeCPqa0jMf+SZBVm4UoO3skB17CY4XFFXhy+Kk8+1x4e26m6qgedgAglxuol4iMeTQZYxrhN4tVIANWg0PGNxhDVWxJFK+PUo/Z1X/l92Jb64vaFyrPi3zJG5jQWYJAlwDaG4zheZGj+AU4zZDomLdPjUp4lwY+gUgnuY0loXr7cwA2eZkIeZE5ckUTmzomSrFeLQKM5mvyko9yaHqqVZ62YHEwetk1uMji9YVDm2ioV5V+EV1S2VyLmsvD1XlcmTYYuALZVjX514rkNrwhwAVdEMLMyx+JU2L0N3BclXGBenGHGX10GJzU+5lCBXJRWSzZ2aUVO2QSW5pm2ZjxGVg8G2mzL463/8lVgreByAIc2UM9dzVVCZtdCJik2VlLsRFlQqUCBAISd4Jp6duGqzWfdi5xNft6iJhCuBeiBhl6nEw0q9NNV/leTAdTvlWhafmW2ptvSqFtoFD8lwATzPd+wo+Ia1euOHk6+Belg5iAwJmaxw41lNuzDHmBnjmk3Rlmarulz9jSJxOmWdYluvkvNayaiZk+j5myb5iQ1UGftpFzIQ0St4ViQ1IrcUu3/TBJvlUVm8mevXrqvDuWBJlsO2C61vV6zdusldugknuUlnmhFregx44q7xuuNTtGLJWn2ApLeFGmRFuzBhrvCRuy1NATEpkAChuPFdmxrpuPwLufxZpHU/x3akSPIaCKDSXCFV6DgfwhqbCtB0SNnDa5vdK4W0H5T7pRVt9QVqb5k1daxAf81fdbkLYm2oqaB8cbhBs9h2/7MCvBTLiNG3u5tCxduJb5wgLXbJrqmCkgD9ELFG91r5m7uYo7UkJZuw8Xi9K1u21jL617mCqQDGvduW/3O755j8ZZjH/BxH49djzq9bea8j5CBXiWiP1iGcuCoEfPs+77vIhep0MYI7NxOtZS0PnsE5zxaAh/wZhmGmxNJE1IlsdBqBfdqB8/h2g7rEHBzteVCDM/wOa9XOh9uWyaADFCD24XY4FA/+jHxOivpheVi6T5xFH9xh9jue1z0wz6xRf8Uglk1YJXF8STQ8Wjm8R9/7EEmvSHnPPweWr3JlmWYhMxq0tUl72P9dPvWYZcNibdh51Z7NXNxTufELV/7cjAXc1z3cljssatN8DSn7QcX6NuWVy0brziXc+y18w2naA//8DQ4BWvs84kNdBZHcUIvdKcITvU9dJOOO4dg9HsUgns8sXNXy3Iv4EqL9BundEuH90vX9HmndwbVZi7NZjz9iAYSTJcUkTVwcjRHdVbXU51udVc3umnbDEPYhH25dVDArWbAvTCn+Irn9Rys+By8LXzZZ8rcagZXc+UNZZyGSVNGdmsKv5Qf7pX3V4DFwn8NAWmndmG29m8vaRaNUd3/gN/6pEpsB3cxxo2igVV0f/SXVup2f/dJT/od17QecGOnf/pMp/fYjd2UIE8ht2khGGp/P+pdlW1U31n7FvvTFRyRUYOaQ6Hb04W1l/hdn3hep/ibMyEdw/jbYoVIOHDYjm2QX/PNDGsTCAEJr8Jkl8azZvmHbmsNP/wttNsWaJmZn+KJtTP7G3TmURrf+Wu/TnREJ5TfaXQ6GAN1N3c2Bv0jXfrTzziZZvqon3qpr/exlwL8Lnh853oPnu/NTnWgzaojzwHVZdBVJ+TAeRNTWPviF3Ndvz2Jx/WJl3uRxIVfyz1hU4zR+fjcP1cBEgmq2lPqG3xwe83FD+7FD9iU//GTx4d82rD5yqcvpLSNzNd8wub8Fzc90K/x0C8ako10+0/67IRpgKAiRmASLgW3IExI8GDBH0h6+CgCMeJEiQ4tUsyoMYcQITk+glySQ6QTkiBHyihpJKURlSNdLol5w2RLHTVpOrSp82MNlCd/At2pZKiUKmrSMBKla+lSX0ydNvPFy2lTqEqdkpI6bOuprl67OoKE6I6bNE/MZkk7dIdQJm7VamkSF65cHTNemMig18EBA37/AhYg+O/gwQUOIz5sOPEAxo4RPIaMWLDiyZMNOxCBiBeyztaebXPGTPRoZaZPo06drPTq1q5fw/4sm/Xo0LLJzaadOxpv3apjv//eTVq4bjBj6HRETme5kDFUjqMR6HzgwurWDTJ8iD27dowXK3oPv9Gjx5c8R54H2REmevQlnZiXSVSkEZvyheYE2jP+fvxs17aERVFZMPKUgVRBpcs0CXKmlVVZecWLV4iMxYceZc1F13xvpfVEhxma5SF9JuS1F1989ZViY4Et1uJllEUGWQKSJUZjZI8Ztlhmm3lmG2jD/RZkkMIQWWQwRxp5GnGthYbbkr7V9iOUSVIJ5XBSYllac2A016UYzT0H5nPUXVemQttx191D4LE5ngsbcRSUeyG1x1ENQtwJn0ou8SQfTX/6Z99+/ckZaFs3jZGGKU2J0qgvpiz66FX/WDGYFS4SbpUpWJGENdaFaGkhYl0cvheqWSGCKCJbb4awgYknHhCBrCqymKNfL7p4o4264morAb8K5sAOPPbo45NVwgYMlcsa2duTxD1rJW3IGlOtbsZGy4xxYlZR3XQLdWvmdmiqWW4S36Gbbpt33WUDu+/Caaihfr6kJ557+glofTrhWeid/cmQHnz1WRTggHdE2ss1C1/DKIIKQhXVoxPjculXnFZIFlppaAiXcaeCAXJJxpVqF6t6ZSDCAyufKOuswNaaq8wyr0grzDbfHPNfGGTBSrFZAqkatUjSUrSyzBbpLNBRZqu0tMkKqZrTTycnxELRiZs1uVubu6q6//FWBK/XYucn77zx1VfDe/1uON/Z56ldaJ1xFkGw3d1KgdRTokSi1Dzf6NLwgQxOVfEpFm/qaVmgfijiWSGDfKrIJPNJIsqXs+zyy73CTDOuODuWs86+GpaBolhiG7RruyTJmrKwwG4060YeraSP50A79dO6Qz207UsDX6YRWnNtLhIIsWV8Q+V+7SbZz7/5tqFqw5dSSmvTC2DbXstNJ3p3BlXw3WAgrIse7ikaOOAGCh6xKBIenrjikZf6OOSRS07/yGuRWGLK/m8AAivTgAA1h7OZfe5WNRPdAhlIuhaFQA+cARrwVmctCxatFBqU3eyQdZvU7Y53Iuxd1EJ4Lf/iaU1NWwtD8rrWPBq8cGzQg570uDc3tbHketlzGw/TdsPq9SRgP2FJf+62r4OZ4g5NyMldmFCgb0BxYU2BH6QghQiMUSiLn6IfF++Hv8mVDC8tsJwIPqCB/mmAA2lc4xoLSIAAjM6BnksRi+RImDreSgQShMaPQLgkamVwg7UjIdOcVEETlpCQiQxaBVHoyOJtYQYuPFcMZWjJGdKwez94wducwBJEgVJ7R9TPT8AnJxkIkT32ccsT+NAoR6RhkzYIgRDqsKj2SWoUWdwlLy20uC5Kjgz5AybJALTJ/o0RmSdQpgku4EwNXKBEoQMWHPFox2vG8YGZ2WMfzeHHaSH/bYOC9N0gP9i0EU7pgoqUGjppQ5BwjemRx1OeQtC1vBbGEJP6zKTZ/DUTj9Cnh4fyz8D8aSegAPRQrHRDHyYBy7UJgQyHMAUoKvrKTj1CD5iokCYo9KnFHeWLIrUf5Ur1Fhkyk0ScXCZLW3qCFLDUjAzYnF/gWM1sWjOnOL1VZh7xs2+6LpziLCc4PXjOdgInNeRM6iFLcxyrWY0KUZWIPMc1z0nmM2z73Gr0NAnDle4ErCYb5SpFacywBjE9IykBnXoSxOsltCE6WSgZlDBGyB3CDhO1KKTCcoc3bFQPgOXDRtXAhzf88nH5EyZju1gyDdkNXilV6UtTcIOVwnQE/5qNqRvvuFOdPrAw2hQWJH4K1CJx8HWBJGpRWUuco7UzN0hKpO+YurupciuFWaMnVp3H1d96VayBihtZBaov76mnoCcJWEreSiiFMm5AeuVrX8XCh0EgFruaOIoWjgJSYg6zpPk67guj59JlXnYm1FObZjd7gQ1wTjA3Da1nRWtfnQrLZ908Le1Sm9pjqVZZ10JkIbNF20WaME1XleeCe0tJfJYXuFztZ1iFO9Adqle5AQ0uculWqJh0aEsSnShFLRqWPtwBEn8VrB6w613uckxEVvAQyRoLxu2Z9azpsrCg0ku9s8w4yE9g7wkE+Fn6HvmOKdoBK4ZRDENyI8pSxv9Sf2thZaQ9LcC6m41rkUrgdXpZS0dQcD3FlyZIOjirvpVwMslW4WPa8GzjHWV9VGnQj7CEw6tcGwmccIiK6sLEnVIxWQp9IcTCOMYlZRxjTYrhHDOBwiv1sY+fIGQyBPkKQq6BNAlzX/nad771RXKKtKBfaYQDN1NOXZU7aNSlaZm/vflda22bZQQvkszLM7OuG4zmB0eYzZhU5puLnV5jX/g+nryJebo3qIM+98NDcUJd+2wWR/D1ECe2UIrfMIjvxoW7WbDfeyw9MvG6Rb06btsS29229eoAX/Uzd6Y1bQYzbPqynRU1kj/tbwi6wcmdQfWqV13r2bKTd7IrsGz/Ea7wLocZzLju9Zh3y1uKrynYXxV2mzveVR5zMs4gf3QoI6tn9Zz83CHTa4kbse2/rhjRGPJCYudtc3SP6qQbypCGyH1zc1PbQ/Su972noOlNo4CAfDFAAJpuK5sm2ZohQMSlBk7wglPZ1rSGtdFMky3YDgniX5a4IisunotjPM0a53jHReDxj8Nd0mjFMNvcU7m5qbWUyN4J9epFbTtYtBGT0CvhzWDosth40x768c9z7uhUmQryxKQ35Stf7yus4d5HR7ozK1NT0PYbMA0wgAXUkClkVIOPBZ+y1hP+RyIxfNZh13IHx666AyeS12hP++4zvpExzsBdkgX+b9uO/0zzxl3uA+U7TGSSd2eDhK17n8lcVY4wUEAKFHklfMzX0NhLU74k6x0/9Svt83ArVqSJHyamLQ90HswY/lbYvObbr2nxl2CNL2sAv6MeK778wOFsRep5Q+o1AzU0AwHe3pcd1a0F2MIBR2wdHO4li+5pBO/1Xm8NH7wIX/EZ39u9SfId28glWw2NSA5In3AJUQkoFwlWX43lVV5xSuF1n/253/uxl1vRi7qhn7m9WGKlwS8h3hCunw0q3pAxnvxh3r31Qf05Tg7m39IVQANIYZJR4RXagGEN4IKgQxcaoAGq3pUg4ALGnmzMVlONhmpxwjgxjQQyUlFRoMMpg4JdIP8G0qHvrV3wEd8G8uEH+iHygVwgmuAR4UQpCZFw3UlKpKAgCkqdjcyIuRyKwVyheZ8XHOGQ4WAOwlTcZBjjAVlZIJb3USIRusEofh8pGuERxh/8DV3m9UETOmGm1RUKbsCswAroid4VOoAF9IAaPMIojEKDJOAXpp4YGpxqeJNonJa0WIMarqEGwZ6BbV0FLdWBAZu6qF3BZOCa6WE3sp0fSl8JMJMIMuJ5bBjaVNigpJVYcdoinkS0Tc8jYloM2sEp5pv4kV8NjIA4kkg0vZSl1RVjieIbECRBUkhBFuSKDaRCkkXioSL43SArfuIavGIgWGQbVOL3zZgMcAAGVAD/TYGWLlKABYykBXhADMTAERyHIRjCJrjkGA7jAWJdaoyhMt4OUBkjLXCCIijCM3qdrEWgMZIh2a1ODOGhBW7jUaqLSn1jH5JAMvFjVEplOU7fCRaX8uUZULjj8pFESUhOPTbaE0KhelkWe+UfGw3QDVhBIAjeJPyBW8IlXFrkQWYMtzEkRYJiJTakQNJcX0ak+8miK15kE9oj/mUASHrWFfrFFZJkSXbAY6qACqSk1dDBIhiCJ3jCLfxCTRZgMRpDTVJDMjoD7uwXM/oI7FRCapZCNJLmMeKaUE5gHKoZNgIbUkrSVdWh13Sg2zUlq0wlVErlU14OBzylhcEUObZV/2TBI/SZkn4EzHL2SZ4E3SNSJz6qzXmhURoVkOZEQAacwBVMQiwsQyykAqDJ5VtySnoe1npOInuaol4SIURa4g0G5nzOnyv+FV/iZfvhhQZMQBXGys7oImM2pgcY6IFOZkeIwXL4gWVawjht5mjIJGh6kwK6pk2GoZXFDuz8zk2O4WtKYxyehlHumm1mIzd64x72oVP+ZnAKZ6sUqKss4jJFD3S+WbTZ6HJ1mHq0owt60r2QjN+BVWUpkxpp52HWInc6gMucERk0Qiosw3iW5yWgZ1zKpSSu5xrc5ZY+pF+2IvjVp1+KIpbqleFp6Zny5wkc5tKdyOiJJEn+50e6yv9JxgCddoSCDkR0RIccNGiDWsIvqoJmbuaEIqCFguYxUKho2MIDsmaTzCSCAeU6Bcm6kGh4mJ3xdCPz9CaLHp9wSmWruMp/vilxohdVvtlWetV+pNIhpuqN/txZyqg4IqkzPUDLoKWScicH1MAaSEIsuAJ5UulbXsKwnqcjvKJ7nukovmdfBpOpXN59CiSalqK06pVE4ee1oumQqel/LuaAUmFJVsCcdqSBJmgPQMHxhEG66um6ygEa8OkeWCZmbsItyOQ62OsXJuqHIiqRQGAhPSqkimE6zV6VTEQHzmYdXurZFR9vbipwkoAZPSzEIimcequMqqALjOCdBQUn7h3/nhlicyYnxzqiSqhRqFZAM1mOLbZpd5oRjW5n5uTqWvYqMcQCsdosXKbnYNLgXUqrmALklwYmteLlQu5lsrZnPTJhJV5WLb6pBcRpuIorLdkpKkHEuaoku7JrnjJoZf7pvP4CZ0wooQ6qvmpo7WFoa4YhiMbewNbWJfmW2VGqUkIYiqaosLmop0qsyYqqm7qpX7BsqUpfxupEf0DnOtoEPLJgnEQbq6ZjW5UbR24ABYgkylCWf4YrAjDAS0HAGi3Te80Ud2ZONPEAIfhqKvTCsJIC6lrpYB4rzGEptfps7EYrtbrnltqumRJtPWqMCzysgT7t76pRnaIk1VLtmljt/xEc70J8y54y73Jc5iZg5i147QGCLQJyRtkuaoSeLdaZg2a6HmwKLGoslcHOkFLGLd2uC8Nuaji66OXIaQQ0Jt8CBvz+T6lSGOOeHE88Z/7Gm8DYXf5FrkdOgAnAlKxoABLClH+WwPydgC2ewHXS6spI8AQ/wAXUQBuQLs0C6yTcbLG2bnuKIioOYSjSrtHW7rGSKQirMNFmZKSRgN6GqwcQZ0cO752Wq+8pj3McR7csB5+669buAdc+r/c2w/X+gmZmr/aG4Uxq7/cOJcJVI2rU7duaLxWfb8PWbXG2L6i+L64CaLfGqnEaIt7xbxnLS3WiEqkuEwH5ZwpY4gigQP/SRbAD84B7ERAFT3ACPIAJ8EAfQCnNpm4HW6mxfnCWhjBCIrKWIuvR/hUKc98j5y4j86wwGQfvgioNt8rU3nDy4mZFTNWYQAcdLOgPS0eeuquDPgJmqnKg2gIRJ6A5gOE6JGNMgpPtiehpkO/vuS30VLHw9TL66vIGbnHJTkAXY8DKtqmbBktmfADgptzJ4S/cidz0hUzJEDPKrIxKaSLowpQEiGMKPFMB4bEe67EbX8IfA6uwtuXqFjJ7FuRYDFZdsmc7kykktPMKT3IdTKuhKSTH/EAak+tT1jDxJmiJFixH0pLZocEO77B1MIcYsAG7MuggLIIqByMtxyT1iib/NUToLSsVlv3GFF/gQW/cFZN0HkpzSXcVp/om3urfBMCsFyczGNevqZqx4G6cTQ9uvXDE9WDaCBTQBbjxFfCAM73UFbQBD+TFylxwG4zABQiQBKRAHUsAVJMzOa/MjFRwDbAlMbxCzT6pJIj1IM/gPJv1WaP1YTmC6zryPVdrtbKw0TYkI1+IFPTADBN0Xhev76GS8CIoDBQ03hRFKceTKWPtDwcxvMorvRJqRusrR9/aR8shbZm0SJdvm1gtFnMVMkXsB1zy78q0rSYpTTPlc/1LNJOxTqt2OgZdR5ZAtXKaUcNfDXjuylhBUoOzUWuu5mRWbo8zOccKBEiAF2Bw/+mK9XGTdVmPhUXO5Xq2dVqrNaGhMCOksCQLrbIysl95nz/rNfGe9PBm8oFCJoLasMEw9GGvK0Iw7yj76WIf8Utq9KHiHmtNHDCb6y6vS2b/sn2ntDC79DVPbJwu6YArqYyO9mLWdKvyqCJG32rDWVXWyyzGag7OMcxqQG/DsdIdBlZDtVT7NlaD+ASnQHEb91jfbM7+AXNfkYo3N2FBN2Fh6bZVt3XHtXWnGAqvtfc5hw8ItNQeNEpKLYKKt9N2gGPW8HMUU2FzwfKid3r7sIOyJBKPLdmGrxyG6BzmcmVneX7r4X7zdwj6d1TOMBuZSDFz5zHjajETcxUygMWaKv8O5WjHbpKcu2ol418JaJY+FvAEW/ATpIBeTPUVTEEKMMDmSjULFDVWSwAIPHWIj7MFt4Gvlm4qcPCJM3ckpDjGsPhzczohvxzhzfgjL3J2N3If2PO2yeAh1IFdZ7KP93h4D3mRE3kAj/cNI3k8wZNBGDZi+7C6mvKC7sEnCLsnbEK+qpPaUo2WFx8e6reX87gY2e0wu2+Ay3SSao6a78X8hrFmaawOKh+dg1zgBl1drTEbe0EgJPUzCTVx88AACXUb4LYzVbUECNCMYO4V4AA4V7UCjPPLQMCIm+6kW3qVojgi4Hh0H7xz88FaJ7x2T6LDu64klzrCg7qxVhdZnIv/X8O6APtujMq6SXbABow3uX4y8Yiyu/56yrP3u1Z0ZkJ293qv9x77gJEhZGP5lqMLziOs8Tp7MH+jtGMOTAsw/MZ0mkPt3iI4Xt+0g4M74e5PR7b554ouD/DACujbM1m4Pnp40tW7VvO7oVc1OItziEPGBVyBRc7slAoyprN9znq6p1M83L/iqcs9qFP3i5s1qs+9tul9X0VCfo6BJXf8rBN5jM66Y8b6Xl/Ec+S6dIhyD5OyyvOpr78rsbfyKku5zNM8+P7kd1OqztPmifo8tIM5S2/xtK+MgBt9gWO7f/btLs7w0ss+VT5uABl6HHfzP14W18uIu0c1CowA1dN7/1Y7k2bRe9inQKNLRqHPFAJcOAtYAQuYwSXQLM2aeKZfukW6vdzX/cJz/7aBPyFP/FkzgnV9v8U7Qt9M1PpfPIYkQZ0aPscTfvyDvJDTEvAVhGATRA8vB0CgoSOGDh0hYhASVCgnYUI5ijh98rTJ3CaKzZqZq6iRmjllHDuGVPZx5MhbJnvISLlSJUsfP2bAlBmTZs2ZL5HYzFlk5U2bLoAG/TlUaFASR5F+4LCUaQanTydEiDphg9SpV7FaraChaoMCBhqEpbr0RY4TZc2mNVtDbVu0buHqkPs2rlsnd++WYGqCxxUvPE5cCJziSqA2KB4khkDYSgoIiQW/wZFCgv8ECBckUH6cgPOIKSxAW9ZgxUwNBo81nOjr5U2gS8RgX5I9O9Kk2rcjOeqzW3dv34j6AOcjHPhv3nZ674Y0nHnz44yS8/5tSjf13JGs+76jJ8uMEE4xhBc/3oOFCuXNp99g3sP39iFixMdphP6WMfep3C+IJj/Bgwz3C1COAQkacBFPJrKoGXQsMicjapr5RaQJSSKJmpJcyhCnlHbokCiddgpRRJ40xAmtD1E0KqmkmoKKqqzWi1FGGLU6L8awwBKLLLrQYquuuX4Ekscg7cJrhBM4EAwFDSA77YEUWLCCB8Au0CAzxDYbYAAUQDvSMgU4Ow2BMStLoYbQLhuBSTD/FZNgyhW4/AO2WGIh5I9L7qwtz+sC4TO34ow7TjrjegOUj+cG/U1RR3ID5TZTHGW0OlNsM4W6Pu54QgkR3IuRPPfKC1VU90BtT6X6iqiiCiHAACNAKmClQohZHWIIIQAJBHARQ3i1yNeMLpIwwgmJvXCkEltyCYqabCBqxGeTGHHDFGmgtoSiVlSqRa6g4pbGGWl0oMaocDTgqwJSO4vIdYVkd8giyTByycSkIhMzzKakUrHEEjiAs8rSBAHNMDtz7LITRkh4MzEP8FexLVt7bU48/3BNNtv8zNhP3whdtONEJb1O0UpBEcXkQ0ouOeRJTsHY5En6+OsFTk3oVEb3/9hb6j1S3TsqWVWTGANWOlrVbwxWBRyowFsHzNXWAnk1ZJMEf7mFF4x4EbZYCatONodkwabWJ5mgPYLEacUeG1tss912AxfBxerbq8SVu6tzwRrrWh6v9dHdv4f0UXAnyIg3hxue8OsEJwW74g3KMDOThTas+FKxyVkAcwE3v5jCcghA+IKFBTRfYATRLbNsTC3H3BeFxP9IZc5U8CTkYpc17jNk3SV9+XaOcRv05N5Tfjk7k3V5uTbaMZ6kEd9TSaUX5huJOd4WfcDZBBneXkKvEJRwgWeg4GvBBiPAMCKGVKtg5L7385PakP0WSnrphhL6ryCJEkxwWAgd5CCMnP8kQ14zYNrKZjYFLhBtaUvRtSDYtre57UV2i1sFaEQBGFWFAV4JQI6ksre31ECE7wKcCdPio1Md7i7XM4EGakC5I72QMPoKUww/QxnSXUBgI1BdZ7rkw8cAjGAMCM0IutSv1TnMX1OK0hsIMSdiUA93udsYoyYhvenpInm24Z30Wray6IlMi1zkoigYBQozqhGNouBi86JHijjGsRFzpN0NwOOEPoive2k4yh2aEAIXxOx7giQDI7gnSDBEwo+nOoQhhlYFqZliE4egpNIGkkmm4Qp/SgtDGITwNP7sYVeGQNAmbpHKW2wiQrxYW9iQ1ZMGJjBaDGxgUaz1ygiyqEX/3/EW3Cp4wblVkAE3KtdXQngWJPltLSg8oQn7driv5aBwOdBAASLQl3wF5nMN+1fkWODDC5AuTK2rTGYEZrkCFLF0oTsMv+zVr8SgQDNeuIQgpCiJ2ykPd7r7YhydJ5su4kZ6qfCTGweaxV64bHqOcOPJEIrQhi4ver3YYh1LVkc6ESMQeqnAE0TxhKN4IA1rOIoj0uABF6AxkSqNBClsgIHv6EEXdZCPEA7hvoOMgRGgmB8YNmEKSAqoIUnDpH/wl1SBNM0PdDjQ1BBkvgOu0Hy4RBEtbXnLV6Jol12V4ATByq1fjmuYZY1RB/EmlrdF8EjPdOZbi0TCt0HABEic/1LCHIOAB9gLSlVCpxcS9kM2ASxgn/ncYtKp18ws9jFcSswACDaAC/DgDa2RYiyouE+NmfE6zZuobThLUIu28RS+SB4WuejQhd4GoFp8WRwxG1B9znajgXgBV5zA0pmatAQxq0ALTMbHDBjBUS2QaQvuwKgelE+otKIDJQ0xK6DO7372q99CYqXUpH5SDPorSFWt+pLwXhWrsaqlVtX2IRF6tZBue0qLhBnfYXawmHO9m7nylgEIqguubn0BW/ZGQhaqpAZGKjAMzXCFGZKGBVaCDOawBCYWdAEPX7jAvzY3hSmMgJxuagQLPndOMLFOAl/4Al4xA5kLO+wBlK1sG/8asVHMUu93GOvTaC9GR1wwT6Fj9CyOazPaRjVUenCELZCnR4okz0afFXOUYXTmhNzgkQMlPakXMDCDKb8HpI4wLvj4oAdHqE8lQj0VFRhhiu861ZNHrdXRNJnJIigtVkr7j3YbAt6t7hm9PShvVquV3kALZVYy2Juh2eteD/wSrPIN5qPnOy4H4DdHXCkhf/tLJFySUAYAlmanjRTBNRmxDSxYkl8Ju+IH9DAFrT4nERcWui6B4IdL/GZmcNCFLhhMib1+Ul+O1AZigAMcsMks7pTMPIvKjhiyiW2PeQzaNbJMyKo16BtZm+TpxZYUU1TykitWmhsE4i5m4JYe10D/Br1YOQQodemYJ7iG3XgHzFlwd3yaW586CDWS91EIdgsUyv6YdyCpMq/Bt5DdPCf8IIWGJZ9j+eezTVzQ41VJCRHdVff2ktGODmZ9xwVyrJwGPJOmtLg+sD0TZDoo7BIhgD2tFrx4tF6PQUCZWu2lfS0sxWUSIgO+IibGXUZg4QznuZQI2TChYDJE5Iy/WJcAJh0gBW3oUyyKTYwdk0KzRb7EGyfRi2aHXdnJWyj05EhkIBdUoT/m+vQkQbtUaIMUd+I6uQNzzQiURgN2KEEERmOHNNjBmuz27QwwRQan9FbeX5PBIZXgiDu0hJE/M8Qjd9ofTyY1kv2uM50PrvDQ/zMc4lONuMTP2+dBh/driRb1xjsOzBmJXOSRJuYDMPDYhoFQv5dmOV1a7pYDMnPm3GKclc4EAii9QXRgujAP/3Bi56MzNOscLJqsxIIPC5adkOUhPQHmTalf+JsPSA0UtQGbrd892WnnethXy+3pkd15L10o26HNxbK7/esVvVMvAmENpkTeUKBhJq3vHsMMTsABAs8FrqdwnOLwYmby6g3eSMAOJs8N9ogEisDMHA6n+K3h8EdoEOIgNK/zRk/ORk/0zqb0YglEyAb1xKviHijjEm1bfEnRYg/SeDAqion2IoC+poJeTI73Um7lfo/12gLjOM0tXCgqRqMxoARyIv/jxABGML7gcchvnUCgEVCH5wyL51gAB2iNnLovTNDpSMSJnvZldRzgdZ7gDWQHHK5hjmbMomYDx+RP7lar7ZItyOjEtaQNjrTuNWgDip7gAiKgid7gAnaPMDooXhjQCe6AA24gA3nLEazApcDADrxn8KSs9XJKBjpRfYzAFMAAbGYlzaLLBLWLfoTGIGJxzkgQBWtxBWMFgh5OF/XM4vzsF2Uw9SqO0y7ucGxQ4zhOB3dQRnaQrJyxXuqlbpyiXihNg46wXTykv9ZGwKaphIyxhZwASfSiwJBkYf4FB96AB3SOTcrpNNIwnR4jHiMLsWjN6diRTfwlMyoLB8hvr1j/xwBF4AZE4AFMwBGIQRvUzuzOzhCdLXn+UMjgD3mYh+2U7GUCMceaLRBS4XFY4wYOg3UEwAEo65oMwAqsoAACgDSiIg71yxPdIBMbqQ8uUfEKpwYsUPBIQI9S8RRT8WdSZRN8oQ5gUVZKsLtYJT+EhieS0uBAD+Fw8eB20fR6EQZFZFkWaPTUZi4+xNBaz/X2gpcsLSyX8W160OPCRSrqRtJOLl2SsCwIzC2ZkBvVAtQKLF4oywmWog13TjCCqDLacXOusOj4kQEkwAyLaHPwyjIMk1+UbgWUb0nscdKC0NJQwA3sT47aD8faj+2WTRAjEv8Cscec5yJhxjW0YAXa/2AEmmgkCcAAQ9IvxsQMFPAEHIdJ4nApCifdBImRhksm49AE1mAJxs3QDqkOKBEU1I0KKm/iYiWoQC9/iPIpB04ppXMFpzIqXTAGy2tDhNHiyGwuj/F7Xi8ZxRKYxvJFas+solFc0rLkzOWDUG6/2nIJZ6b1unLAhKAE6hIvUSY4p6Qf7+UB3CSI2mAy4EkCpuAMpC9gvgAP8KAMF1Nz0pD7iggEKusx4QQxci/LdoA1DmV5ckzbvO3bNrMzKTLJBHHGoA0UMCvBeGCyAuECMMALCnAAYugPToAApk4ABMAE/oBJ2iDBHAdHRbIPcGsN7gAmLdHLlkDw7uC/HMEJZP/ADkAhp/pTBk7Rpr4GVdhHFCApOrFyzUIPP6rTOn0GbHixBVTuOnEpq4SRRLCSBi3OK9uLPHWmKerLvszSGc8yLS1oTNbyGukJLTAN+Ah1vYiELcAxB+ygNMzgw4aIBbIQnbBEMNDR1MQksBZGr1gAD86gHjusHzPjC8gQVM0xAXLvYBrLMLzAJHfDNQCKZWS1RJcNRe3IZNTIVu1IElSU7VgjRifgK1IAWBsDAQRAAmBMAhDAc3hUACAgRiGgDRxRR21rAliyJSeBtwIQfMasBMzgEPwuFHvrEIwR8qTgEHaSJ3LK4IxgXatTBesMBcv0FmUl4+IjTdlU9ZjTKUP/jzspLpfoVDz3IhkbLfby1Czlaz03iFtMDj71RpkKdUiUyffkMy708y5YiAwS5gm8ZEDV6elKLB3r8TTuUQFeLWGUzx7JD0qmBAfu6ueezmEax+6yKFZ952Y3kxTWr7UcEnnOzo7ukHkqaxKeoMVilAB4NIa+QsHOxQwelABAo1mjdTH64AF4dO+K9lozAKTWIDUiYRPFlQwaQfFyIEoZrxjRtV3TFafIVboeSQqWkl/HFCm59CmlgF3jlifOVE3ztW/9dV8B903/tc8C9iu15XAJtmBnryr2tCzNQ2HJiiuKML/WFAkxTRzv8z7ls2JlDi8IR9004APc5HFOtYju/6WH4NEczVECekjE7vFJWAMwVgAHaJSeQKBVh9Z2mGxWXwtnc3afckzuAkqNaraifKwNtMAECJJGdZRymCSGWACbFLBZJaARJCAASmwEOAM2KWv3HMBxrNVI1wpmlOIPFC8Uqwwnc6AR7oJ9yQcMQCF9cqpoUqVKW2V+C21fx9QpbzFv55Y66WNvBZhv/ZbQAtfg4DROu7MG26aBEferLuhgPc6+Indu0BIaoZBhTy4+K3dz57I+jRHj4KIGhCBjxXHq+o4Q0pF0H2Axcw6dtk9CS/ZfUNbpUkyvdI8H7sROdjd4ZeP9cDWIuQ5XPTOghjfuUqYRMOp4DSMRp3H3Vv9MR69AwxQMAr6iBK43AAAgAbT3gxA0C6/AalutNRtGNYbLifVLZj7gL2BoDaxJJy3RcAhvb9SWUa3UFMiAVazUXQ84BQ/ubuUWgdmVaMzLXrGzgDMkGAcXYB24kR84cfV0giXZgp3R0qjRCHcJYrvSgw+tG/dGSktIXrAY8GLoDbwgEL7g1J6kHl0tUzWsHg/LZAWUB0hV+cIpcp5PSVAzx3r4h39YiIEZiDFTV3v5eYw53MJx5SBgcnevNZsVb565NQFAi5uVmvVqidxQGkMIKjr4KMLREoVvk0u49cY5fVYofbZ0nPM3gVEFkONWOuH0nfW2F/FVBJoFkf/WTa//sl/llHwc+Z8fWQfPSnE5SL7S00ayAnKdcYN7L5Prc5kiaGYiegkL7C11oC7JwA6sIHQF1DEdMzQiJ8KEjtRy6OdWt4YsIwWy8EXNhDVgDER9mJeDeaaB2SFv9YirR6PlahFPDr+a+YOimZqFepqHGqiBOkfyZlwaenvIwqETDTwvjgOmyvHUOZ2Vkjnd+Y/po24POJ35doAJGJ/zuY+7Wl8LF6ADGr7UmnEJOr7S86AVukaIMFDlE6Ihuq7TNITjknCqR65+LaTfxAzj8UsWi/rEqWRx+El22MmK+et++bFrmqZnele9iHKeoBwlUywobbOD+oOIuqireYPFAoMR/3rxpLpmXM8+P7gb9fqAjJGqSji2yTqQ2RkqZXtWqBrRDFmsHy5VTJAn4HmRt3KT0VpgHRiS11qCI3iS+/QZA/UsHBq6U5tzR6jcqscMLvsCRCD3HIYFAvAvRlbEOBpMEAaJfg4yoGRIZ2u9Z0umSwuyJbtlgHlWIZtVBXLqTM6DerqzeRS0h5qMkSktBVypwSrlDJe9iNuTERW2p6ktcNvBAReQBblfbTu3ozqsYQms/Xa2a1u4a4IYc/vAi9u47RRcOKC+TnzjlNutBzqh/RRumNm0nXq6Mdf3EIdwNJJ2YoaErCQqXgeJglSVvy/FhggzrOAPKMcvsnCH2Tumff95Z+HbtCR7iCWyvflAZjKAp38aqTkbv/zbqMH8atlzzCu4wJuCxGeck0F4ol9btb3mbKx6wuO5w5ly4mZFqj9Qw9FUrPVZzhX4X6cqW45RxA+XxO300EucuT1uwMfCPek6dK8F0h1aAtgchNuihWKMeoK0chRjBbYJ/C7j+drESqygyXtZn96vl4X5vXHVF4TY1YPZjiTvCbI7y5uZs4/Jy8NcqA3gqHU9wEm7LM1c0L1qkzOXYtt8BpN92T+Nw7m6wvO8hOt52vvWJ+n8z6WFgZdi0Ak9GQ0d0TmumFR8xdnaccsK96jCanv9alEc0lPHMrBYPNMcXh4qeppMIM3/DzW1MEPnBTX48lfbW9WFOdVxQTbWr+CHGNYT/oyE+HjTza/Zs8slfte/vMuB/cWFfdibmsbnXReZ3bUbvC3a+dmdnbUv/OT1HMNVvuQBWHCzktq73XB76dvBveYVra3N/YIxmAgrqGGBmuS6Pc2p+7/uog/cKFZ3HEv6/UlM+U1I46UbG7IFPqbXb7LZCKCSHr8tvsu/vOstfrQVurRNnAN2JuiLXYTb3KnfapzhguT7GFVu25r2vNrxOe6vvZZcngbPGixtvu/7HucxSNHjGhp1b90rTSw5fuiJ/glyPFbxJB1RIDwI8nXwRE90V6ajfuCnPuHhG6BMxjDEzR8n/56/KR60r3azcUSzGT3jh/09Gjk855SqQj6cZf9HnB1WJDzadRvPD1nlYWmdRXCf797Dc7u1aZ7vz9zvwd3MVZz1y+pxB3+uhdorigmCwvKEETz4OkQ43eDobzo33kALtCB3Db78YdqxO1/zOV/qf1nWe8MuZ2Zyo9mZQ7vreR3XVT/16wb61YP1AYKDQA4xBpYwSCKhjIMLSyzM4RCiRIklIC6UMdFiDoo5hAjZ6LHjxyIgSZo8idIIFZQeW8oQQvCizBYza9K8OdOiy5ZHSG7p+TNlkqFEhfo4qtEmQoJMExrc8PQp1IFRq1q9KnBqVqgbJnT1WgGsWK8OJkSwYP82bdm1bCM8cMuAQQEDAeoGKOCWqgSBewUyjGgiMAoXLwrv0KEkSx9SulI5JsUY16XJlAlJrnyZ8uRTmyWLgvwZtGjMkB+XNi1qkp01Tm60rlEjhYYHBwzYFoA7t267AHj7vmu7QXDhxIs3aLt2rPKwX5tjXarwb0WL00tSd/iw+sSHG7untG60yEopUk7uVBrSptLoNXl6DCq+aHyW8n8gsY+fsHqZTqH334qVVs9dpRUDAGqAIFfOLdjcWckhhxxeByAA4Vy31YVXXAj+1Zd0DgWmn2EoLKGYab5ccplnkmWG4mikTDIZLzB25mKNLsbSi2mOrHHHGmS05lAKsNX/YEIEFu6G22+9LWlXbrdZOJeEDhznloMUJMfcclky6IEHA3lpFXti1gSYTk7IUAN1HIEXEnhuhmcEHSqZdN5FOtW5X54vzfcefCv9CWigcP4QYpkNielfgAcOSOBWCj7KZXMUNKjcpGY9qFaVBTRn4HFQ0gVcAxpmkKAGgfX3IU2GzWDYDW5E0lhjop0264qaicaKipecwpmNNj6mGmsvcCDYDTrU8ARsw3IApZK+Mbnkk1FOOyVylF6pJVpjdbklqQKG8J9f4Xq4Z0YUVRSRud6ZO9K67Q4Kxhj01YlnvXriVC5QfQrK76CEurAeuQ0x+u2iigoYacIKXzsWhA4S/ydhhnF19SlwBpT1gLezbWhqdCCyCrJrb0CWY60qnjxrr5QhAyMuLp8Is6+URSJskWmdUFhrVlgRG4LEOQvtb04OFzGVDmcqqaWUNsfto1gdCvWhHFyn0ZrucoRR1uteDa+8Qv1Jb9b29nDvTfrG16cQ/c659n1IgQxYqh6iOi7BdkOK98J6Z4u00Q1sMJeDgndKccXBwUXqBd5ecOoHHw82mGtPOPKYLy9DhjLmvmYOGWcnhgZsJH346MUTH5wVHFSv4WyCzz8DDbSTxRV9pbV9T1C7c0pv2bTTidI9ptxldsQu1xmN9K6/89Ehp/L0zkt22dHveTZ8ajv/HQ1HBf9Mrt3eL2SV3o7unbftmF7qN7XCfYU6XU9enNcFipfK+OOrSh6ZrJpjjgtqJmvOK1z06jP6S00gfKQs1+zgLcwJzAiIlIH2JQlUsGvStALnN6OZpXa22x3fuuU7DoAJXL+jW060hp03bW2FLEwevNgmlOYJqiUiOc/YbICvIiAPKH7qYduypx/uQUdq34POwciHxKVhKVNHm8CmpOSpCVXJAYYTwITeAgEEzU9xjbOfFO4gigJebkVj3J8ZQdc/XXxmEqJDoAlCQCoTuAaCHxNhBF5nQWdZsQAWU5/tNkAlQP6xfJbyIAgNRsK6MaQp2bGJ8VgIyRY+kjwyDI/XBOX/HffcEF9m0ySffPhDlhQqamMqoSnDJK4jItGQgFRilRr2yggZSZBUFA61NFUbCjqJgYnTYhc/lgQwUE4XliOmrEpGxv+Vppi4KBnNtNCELKyugXOMDc5INSVdCk2bFzROBqfUldz9TYmHTKJWRhiVRJZQeJGE5LtW+E4XxjBe8YoT9ObTr5548ghQ0CcO/QnQfeoQlDrcl78ABjXhAY+Rp1xkKh3aqLytEm/mu10s3fI340Axl22h0IUsNoAEZEx+vexiq8gQxvzF6nKpcFlLM6eLHKkxEm1cggjgmDNj1S8F15xNNpO0TYthSFpSQt3Dmog0cypMhOj8QEODxx90/6GrnVSFp/HwSZ56jueS5qGhoMpD0LCKNSihLGt+EKrQhT51bhBla1MiqlSKflCcDsNgFG1py6K+xaMEAGpIH5BFjm2ocYRygh3CaMzEOqYXaZQpYxz7otG5IVk7uCkGMpDTG/A0MBAw0kf1OFSLaZQ4Rqoo+3S3tLgCqKnrhCo7t+NOFcqWeFZFSfPAQIUxXLKScOJXGH7CBSQEF7hsEC5x0SCG4baNrNVzW36AGESppso/CXWrx6g7N7hKlGmoTa0rJaXEjLZvtHmt5RX3igC/7lGk9DsV63KALEiolJmKrW8b03AYBeqgdZgd0ql8qk3Qgio4dk2fBi9Ky4y2kv9h213wUsO0UNfKraqxha48r9o8OUlBhpTEqkB9+9sthJgLxQ2xiY/7p+SCGJ/1md7V0Bqdh1bXuhF2iIxPOb4N9E6irPxgtsoiyAUfuGgaJTD8NJVe9bI3sL4sU4mucY1m9gJHU75GlU/kCDvg9zAtINYLEoizzXKgtHysYB6f5E1wng+c2EpLOIOc0R5zZccPZm1rJZy1VM32qgWtYW3vqVsYqoSrLAabe1aiNhSfuMTDRW6jiUsFFXOhClugtA8DCr1RppWhN6axpzdNoAY72LuiTq2lNrXmo+aSqH0lgBThgoD0DsCCCBhpk9OlhDSAkTHT+IaVCxgJRmRha3L/fAJldeq6z1aQqGlGX5vdHGRSc5fH1OZdwe6MZxjDlsL3ZNOFsarV5QqKt2n7yYkbzYZzK3rdj86nc8/2tulMt9OI2vSna4yd8MVVS9K+FpAxhWoHFbibRpZiXBIQ6zIPFXEdm3AwdY0ISNDUEYhwgxrSsGWtGauagYmgspfdaj8eR5zk7C4gCwneUsvZkFHBN1Qp0kg0VfUkJXkn8b4NJ93ilsOCLuuKh6vuKESBxJV2tIqPjnTlykfpZIOuve8NdWwf5K1S2Xep+V3yKZK34J/KpYREqgCRNgs3VBrs8BLzBDeo/eIYl2YT9nuT/HZcgmY+c4G/Wb5oy/Urk2Jll4513DSlsdLOUWcrd/S85+wZ4V0251rydM5zQou7kilW96OHzu6kB6rdgJrBuy1MxLYyFOozNnxbYbJahcm536gdZ4Om+HqjqS9KP+W6xBCecFqbRVwAUwna2d52aEKzsnFvXe0/LuALZqhabTHkEp+Nu5Rv9++jFl+9SZ+U9NQ8k7PVYSblScMd+lk8gS40VtdG+UhTISAAIfkEBAQA/wAsAAAAAOABDgGHHgsAJg0ALBcGLiIMMg4ANBwLNh4RNxkHOCINOCcVOiMTPTMbPjgiPkswQi8gRB4KRzQbRzkkSCMNSSkUU0szVSsVVh8GVysWWCgLWTkjWUQqWi4aWjEOWjMbXFpCYzYiZB8AZC4SZSsKZTokZzYZZ1xDajslakQqakwzaz0pa1M5bDILbkIaclg3cmtRdEQldT4kdUQrdUsydjgMdjsZdkgnd0kqeEkzeFEteUIaeVQ5eVtCekszemRJeo9ue0Qle0Yre0krfH1hfamCgD8jgT8Ogj4XgkYpgk4zg0QlhEomhEoqhFM1hFU6hVk7hVxChlg3h2VIiUYZiUgSiVY5iWxSik0rilU1inRYin1ii1Iqi1k1i1o6jEwkjHFOkWI3kZBwkkwckk0jkl5Ak1w4lKJ8lK+LlW1Rl1Uol3ximFUbmGM6mGhGmHZXmYJdmYVmmnJMn8Ofolwoo10co10yo2xGpn1ip3VKqGIeqHpXqWUpqWg2qamJqoJdqodlqpd1q5Fvq6N6rHI6rXEvsLOWsm1Dsn9gsp2Cs2wqs201s31WtLuftoVZtoplttCxt3lGt5NruZBbuZl2uaaFunMsunU4u6N7vIJJvoE9vt3BwX5Ywnkuw3s0w35Cw41mxX06xn04xpx2xp6Bx4pVx5Zqx6R5yIM7yaiFyodGy4Q7y5NYzd7CzpFMz7yiz86w0Yc80baU0oo90o5S0p50041D041K1OPH1ZJL1atz1pFF1pxm1qZ31qyE17KL2JdW2MOb2ZE+2ZlK2aNq2eG+2pNF3JVK3KFO3ZpT3aJY3plM4ZdK45tN455h5J1T5L6g5aFT5aNb5qFO5qlc5qx25rqU555X56dm597E6KJP6LeH6sOU66RU66Va67V37LFe7apc7atj7bJn7qhV7tKs7+vP8J5V8KVX8atW8a5y8q1i8q5p861b9LJj9LRr9LyF9bFd97lq97t198N998qW+bNe+bVj+rts+sBv+siG+tim+uO4+8Jz+8V7/dGM/dSX/v3mCP8AFQhEkKCgwQ4ntpBBI6dhmIcQIxqJ+NAIkYsYMdKAwXFjx48gQ3q8aJFIxYliTGLEwLLljB9atKjpEpNmjpdW6BTayRNUpZ88d/r8lIiOUTkQG+pZOqiSrFvVuEmNOlWc1W1Xs2p9hjUaV6/JwGL19m1r1W/swKVdy7ZtOLfx+MW1N/et2nD38uq1e49sXrx65QoeLLcdX7dw6cZTPHef48eNFzOebLhyvcrgpEHTfKyzZ6i3QgfjCu5YLlrLNn9tlpp169erpd41HBef7X78bOfOjfu279++f/HuR7y3PHnagMvrdrz57+L+okvPJ30edNvMgRtXvvweLlzZDYr/LwhhBI+YDJVSlGiRYkaNHuPLn0//Y/uJKsXoT3lRREuWLMBEE3r8vSSGTj3tlIhQnfzkE1CJIOIQUg8xNQgqT1F11lgbduVhbGItE5YxpGlV1okovnMYYolBVpddagX2V199+SUjYThixuJailEWmYtASvaiZZipZuRXowVTjGijqZUMaiDCJqIyUpaYjjq01abbdtxp56Vz3YEpppjPVUfdmWZGh4+WyiXX5nG4SJOXPOItYGcC5WmAwxbpObQee+5pZBENK3i0QgiIHppoovQpGh9JUoRhEn9HVErofyLgJBOBSRhRxER7BCUqhKMWNeEc+jWUCIadHflhh2ZF/xlia7FeddeJO+4Y5GK3AjYYjHi9cyOOhK2oq4+QEfvjjz0W+ZkvIyrJJCvUQrnON0+26hqSU0a7LYdXZrnbl14WVy5xyOGWHblkXjddmu+qm5257DbXTTi4NHfnvniWt2dMc6j356Dt7Qfpogj7tyhLCJOQMKM0FHwfpRdhKgIJOQxocKczzHBggg+S+mAhRJlK4YEz6eEUtJrBWuur2MwaM4gmmmiXirm2dS1dxfKKlq+C+UXW0G8Nqyw6wB4r5LK1Mb0r0tZEzVpoGNJi9dWmZJ11JVo3yQ0xuXxbjWfdUlkluO001uW5vtGLrpvH3Xscl2CeC+/d/mAXj7u3wf+9pb1Rz+kABPvaSTgENaAn8MCDRiQoCAojasEFmFZuuUsMRzypfvlZYal/D0gAYKQE1kRoER+X2mDIJDu41OJqyMG1LM1I7fLLH5Z9Noc1p5gzi04n/VjQRHtTY2DKCnavsTtfliWyyTOtIzSfVY0KKKa4TslP2zvI6lRhi6377lbGyKZu47JtN73M+d3u3+biHa+ay+NTXfzuAy4MOrXxS97heuqTnxiHH4pBDnKTa4kFFhg6TInucplD1EgMFqn3YKCBAEocp2zSMSIgKCisax2pECEhP6FqVRmynYbMwcLbZUVKZuOWV3p3LVw173c8ClradEi0HAGLRsmKHvP/bogl6LEpMmtiVmakZhqqpUJrW+MeJqbYNdHU7msj2hbZxierzYTriMRSX5l6g651sW9tfJMf/qbBRvtVp17eCVz/Blc4w7GAJgL8k6RQghLOhQCBDlxgIP8DwRS8AAYS3JzBOMcR0D1QUxqTAsdQ90EGKYgTIfRJCU24h06kcIUulM1WuCgWmKWohb7D4RdfxEMbjYlozptT9AoDtXDVEGexbBYSZ+kzFVYPQ08EZiqeYsVnaQt8WjSbtEgZG80UUW25MaMY04iuudHtNtJcH3Gsw81urukt8+Ibd+5ljXb45n+GY4AdaaKHPNLBPY3bmOQUBkFC1pMlL0ACEA6l/7kubC4/jRTk6ACmhpn8IAdGKFTqHlEqoSyodRFSj1IewQqqqNCUuGMmbF5VQ1Sm0pYdBR5dzNdKWcqjN8crGjxMKsSkgbRFu0TfuIa0ROq5Blo4XWaSSoRMJblKhjpVJvm8KC6Z1s1t2tymPHCBVJk6dX3etM5v7gWe9EV1qlQtpzu26o46MqAB6STd604Gz5Mw0giQS9QBEcWBtrqVkG/tQFzzqc9MXcSfKgGow1jSwABtUJIJ/VQlH8qJBWHSsIXdCQlPtTJmOPanGI2VRjcaWY++FIeGkaNg7AGs9JV0h7ykpUttmMMdqm1tW+Uslq60IQ251khMhFYtTnPMZP9GC2xCJd8qm3a+abbNXPmr11Gb6k2sCgMZbwmTcLvBRmuAKQMZONwCGgBWw8HEKCgboFnjyZ95Piyu4AWvXPHJhCYQIZGTSm+npIAoDHIAY5HkHFoF2yBLFnZ1iU3EYY8SBlXVgmUXpVllkQSMAsewHGK7HWs/Or0dSa2ISezs0Q4TxJYWL6S7XZpnnbo0Ha12tVEL8a1kw0TRUKu23FpSMYN6tmfytrdIjbE4qzrN4fbNNtTYKjZ3zFxh+Di5ctPxOEMsTRSkIAIRACt1qavOIwhQuxKpyMYsEoJLEeoDe82yw9i65Q24Va4Oi0F5j3CpgvHnJA5zr1/jO0kjGEX/Qfq95GExWV+TBQyFjw1wF102pVgY+MCs4Z1lB01E5zE4LaohaS+BZpx9FA+0oV30oV182qfuRomq9bAtQVziak1LfNlSMW69JbPNMCa1MJaxqs3lHWsK12/bybFuhDzr5R33x3ZpI61xvGj+oW8HKtAABSiw5CVTAAhXcOd6+mjmlVT52VfesrSnrWVp0/W86N1PSgA7A766RIOcQuih3OxQw8b5koitxGJl58moWOO1e3ahiPwM6AR3KB2ELvShqwJh0Wr2pNUU3vB4WcsRX/Z5PNswh4eUaU1zmitKCiarOmO1ZvaUSn+u91ekwY7JhHGMq2ZfvgBOXN9kk0uw//4br5BLvR+HeC5CjgdzMrs/0y6mCioINrEb4IFhN0BPyeavHvsoqSlD7rxXjg+1lx7maMNAnyZAb37wk4M0SyB0mbpjfKdAqEINts76BTuEmNIJBMO71APuyrwznvYN4VuUC+44POhB2rV8jagd3vSGf7jSXfnd4AdH+GOWy3CHj7iJUJw44i1+orKNmnxFhfFv3XU//C3n5KoOp9t2jVWZvxsZoIetVm3+IhE3HOcUUIEHPFDsnyP7QEoha9G1TXSMgKA+AcIYSDay9KhLMAaGpJwJ7npmbvP1keCuifHJDec4x5nO6UYs7c6O9oxuo8+vEHXuBG32B1s27iuNO/9IYeuj3Xq2Rio1mr0GLulefVjwhG/4+zldU2jFImuXyNp/fxlKsOiU8V9ULJynVNChRvKieVIlTsvhG2qCD26SgJw3UqCnLaGHd0iTd4n2fj3QAh6gAjzXc8RGARnwdAwBe9qmR3skX1RWMfWBMS5IKLwnQSbgexhAAoakZUlgBRQkSZKDQfD1VzchAswXIc53X4llhIilCd0XaPEGgKMENsOkcUy4YKC0b0VCWm7XLHo3eCjVQ36nfo4GI5MWeeyCgfR3eJ8hcTnFf+lAK3B3cZTVMleiYUk1P/MjL8MRcnpTY7QmGZ/nWsfkfgWXgSLGgT3Xej93Atd1FLI3e7T/d1Zp1R8dkUiGAoMvyE9dhk/BZwE/yB9UZ3UP1InKx3XjhgbNF33mJkXYY3bUV0qs2HZPcn9/9oqs6CQKtm+nVBYbZz7yR4bEk35fWGGZVVM/o3e++CVmSIW+5ESKJ3rZkwu2KGiNV30c0ncxxYBKxU3SoQ94ow3tM3kFeEbgOFXuIE295AtHgmKCqA5n8W4hhgLChojUBXR5hIL7cR8s6IJNZ4n8eIlNN4Mh8EAdcQEPIAIkaBPrdVDHJzqiiAYxIW4dY4oPlYqq+AkWSWcAJmAv1Ha5U2BR6Ia0SIVVmG+G1ju7GEvzB2kz5YUdtn4sVRiAt44XyDNluDxXqGeI/1c1PtUyRvKM09h/TiguM3dSJEeA74Imd6gN3+FGlVd5eoOADthbu1aObdgq9aeOphdbrhIBGoBkrYdkI6iDjGiPJ4gGGgExw4d7vDcf76F7NxB1CxQxnrMxNcACC1mDdVk6WgCRHnOKz/eXDOVJn7RnM8SRPRVMO9VaI7mYt4RLQ4Mi10ciqfFFDtcYrBYOLAcZ8CA3wlgsMblpRCJ5POaHq1UVgMiMUJFo6eiTulg+1oc2GsaF1HSUd4gbI4eUtYkcl1eU1TSVnJlafyhKY2NMVumOyPRa0pWcg/ODY0mWJ0hlaikSu4cReRAKsxAKnoCdZ9AEPLBlORhJB0UDd/9ZKBkTbh1jkBJJhKooZxa5f5A1M695Dh5lmlTyCqsYh4wJb2/omJBZFbSCksb4kvwQNcAYfjISU44hhmMIaUg1FzPnLDZFnJ/Gk8mAU5qxPU2SRff2nrIBU64WjtExDiGKJriplCRngGXUDQ/YgPCzVcw1lIYxnAT6dje1JBqajqDGAdJVAYRTAT5aZezEX0Rnj/AhnQd1pEaKEZrgDOPQpE0aCnnABjEgQUswl3ilkFcXiroHWEpgKLdHBiDEUNLnPe2mZ/AZn/N5FWv3kVO4oYrJmP2Jo6QBoAHqQwWKFzAqoDAphzKZa6JJS5I2nM/iafs3qNXiGSS0UzcKlLD/+Tx5SHm0eSa4uVQAh6K1xpt7uGsvamvFeRnTSJxMaFvaAgE/CmZYhmUcMSlC55xGx5aPUqT2cRGecA36UKvkoA+9AAhnUAP+QQNVaqVHepfv1U9KwG2leIrQN2ftiWJniqYvs6apoHEhSaP06YQdFZkysw6GBn7HSGEp5TR2uqB8cT4vZpNX6VPMqIbpyqa5gAeUkCQ2ip8DVoxzN5SPCqkkmq+2WalqpCbJITebF2SX2lzsKKgGV6NrGCWkxhpyNQKKqANOwAVjMLE6mCpQpkf7IQewWh9t+R7EFwq0eqvcSA2QwAZZ9p3AmgOOlDk5yAZksBDF2nUT0Xwi4z2g/8GhzSqfuHOtVoF9wQQbxtmmmUGL9rafz7CwV+QWLFSnPGSN3roY9upZw0ivZ3gXveWgg9iTJiZMiRdMP6GToGcK7vppi7qzVAt/6IKv+Tqp3bBNuFmb3giwXPKbJveiWnmwEPd/Bqt9txVmPPAEY1AHglsHY8BffSJlGAsRG/uqHtu4ZHYFs2CrtaoPJBsF85SDyYaQKhs6feWrdaAImnAHMLsRBoKsZCqYzJqzzmoV1+p/9nmfIKmfabq30giHGjp++yl3v8KL9eq01+iZcKe0pjdhWUs9W3s9XRsL1aKTiiq27ypqSNt2MmlSZOS2kYqUSpkcb/u2vXlyqBYXMf/neWwkqFEBoaCaYkElGg1rSE0gsVQwsQvxss3Jqmf1goz7nfjbuGQwDfpADrd6q5VLAliHuVPmH4Kkez8Api9rBV13MSYRKuZmX+1WtKqrs5U1tK1bn/cHuxScn00oFSQCvUIbpx3KUlaboKEZJBNmhcNbrnYLIxF6GljDvMRZga1CCWrwvBWntxrJUcXYwoThNvKTD/gAHtqor04JJ9nENN9bS02EjuZrTMUgqtCrvm2FMf8isS4bv4fLqnlFMBzruBnhT1uwC5M7uSRrsg+kBJm7wJ5zSDYgA0FwHkdQZaTrHwdEAwwxkXzsSc0YqhVswSScu2qqwdiTfd3Sioz/Kish7GcnZq1ZCBm8G5qCV2F7GrxTa4G6NFqcYahWRFQBlpGDkMOPl1vy6qaYvEOYp0bMxZSWenkC28Qw2sRv4VizdQw/TKGgmr46FRpfFiBscAfCzFB14JDp8U6k45xFurEYQQXvYaUOOQZmfMb5kMYv0KsKUQehEqVs0M1R0M3dDAdk0MAKAzl9+WYQTKaDScGCnG/HabQ+e8g1CoiAxmeMLC0yXGCuaM/OtBe7VZmbuQ9Ru5Le1xYiNqOFZ9C6bMOgLJKIl5q3ICFRWMrxesqo3M/eKmQg+kZGvNFNmUTkVK4yB7WzDLWdhsuIttBbtMtk+8s2EMx5IMzaHL9C/zcxRMqClPgREyu443wFCrwTeaAInpANk3ur+ZCrcGADGfOyMr0TgwvOX7DFW9ApGcMxx2q6qKvIs4thjwmHcRrPxLB2U0zP9fymQIXPjly223eSI3W2AA1kehqjP/xwcmh4nMyTznTQ51pF1JMKS8HLItzBpkSIvRK1s0mVk1eb6hInm0rSD4q1jl2wU4MaxLhxEgrYK5Z7uZcT4IxdFosUQ4qCB4OWJRG4mqAJs2AIgZudntDas5AN2TAPkpoP44DUUBDVa7AGg7sHZCDVEXvbY1asCmyWmgOmEExCGHmzqRsz7czVPJu3Y826rbkkG7wJqHHL8cqK2a3VZx1xaf8du0R7kiU5GylJyZYcYXyKt160jsI7YnqNhrRQMqZws8iACe7qukK13YA8nGu9i3CH0FYFHN8BlR9dRjU3J1Bjrlmy4KslWzsspxP4GRWN2cmgAzhQlzUwxwrxshRrsXRgZgX0iGDsKI/yuZogCrDtCXSwpO6QY1tFDdTATWdCslGK22vA218gB1/A4QrBBDFx4QQCwTBbdBAcKsuasKAWyM5NhQt7LdBtNZj03UIV3vt9z6FWLd/dDIWc5HPqYOy94IZ9ye99JGPe3p8J39mzPfNtJL4g0eib31LI5SOc3unHHVGzP771TS9HU1/+fsZ7NTeKYhK+YqRmNjv+BT7/XhPyC7MleLFl6TgkQdpEUAeewAswnmOGUAiiMA+XrmPdxE1pbOO5PeqH7tOInuj/QhOCy9sOmRRGntVnM1QkyZ80GmoduSRDkX3xjVufTL5y3t35DOhlK+dnXuzG8pKZnMuB+JnSnd50zhnI2z3Woi2DoAexEJmBne1yrqiCfcJKpAsEGjd/qhvvduCqNeYI/XBOlJqi+uaEjrRSrZdowOjp8ej2jo/nacccseKXDuO8ILixLdvO4OnU0U3Z4AlSXerGPO+mfuoP+RDGvQclmBQkQ0zLXeW1u+QKPT63RQy5Xg7x/QmADiWP1e7bLmrB/ni+bltuZ+wOhuzUiiJ3//tTeF3zY56TNovLEQoNrPDXMdzx+j1ZuEXs5cPg+KLzMxnmMVca5l7ZotehTL7uKi3o7x7YrEHqfIIemTuX9b5tBOOIU0YE+T4SmmDpvDALrB24s8ALlv7iMG4dBd8PB5/wO27MC8zoo8jGcoDjCy+Ro7DSv67kGq+02M5iY4NfyrA6M1xvSAtDjYzyKR/rzNSOLr+OML+fOImzEMfQNgXldAa2EYqO9Z2otmvKQh/0F9/QpdkZ4D6uIy097vhM7UjzTu/d4SNDQDXoa8jtYwO6Tf3UhNv3E4+4y6aCY38R0gzjs1AIRODTaMAIjeCyjADbnJ4c2lAdoV73dc/w0f88E+ZZIUgR/kb+9xb6wf7dmM6zrToD32gNr1GU+Mi9+IKq7UAP9CMvw3E++ReNhZYPEPsExrMH7ptBaQetHYRWzWFDiM8kTjS27FhFZBkvVmTV0VSlT6lqJduYMKGvW7caVsJjiqIymM1izpRp0eZNnMVo7swp0+TChTWBGkQXrl3RbgSPGjX6cCnCiBcfSp3qsxgtVLR0VqX6cmNKsDNRCq3WyCwjtGnR1iEjxi0dt2GMyDVSN8xdvHiJ1J2xwu8KGlY0UXPmbpYVCxZorJnViAaGNdnm4ZunrZtkf5WzkdrzxfMXNKHViNayxTRpLVNGy2HdOlEn2GN9+Yy4jaL/bdy51+2u19veb+DA2aUjrrD4slzBlOeKlVz5R0qpmr2aM2cTqE6vsBKbepXYd+8kxY9fnny7efTKyvVkT7Y2N/gQjcefzxTefaX1f+7n6lX515SywsQUAlOiL6iLwLLmmEHUcKkrnhJsLyedtopwQogqdIooDjuE6qKDjorPvf668+48q8hLsUIWWyQRElJglPEsRvJo66248hKDCLr00ouGvv5abBbCqJmFDBEwoIGRbEZ5bI9pKsOHmmlwoayfeZqEgww5PkPDs9CmwEENzwYR5ExM0AQJtpBqkeVNCHWTc07efLNzIH7yzA8qg8RDL5ZUAoVOOlCqu247ULRa/xE8F8tzlDlgzotU0QtVxOm29w7EjT9v7GunNw87jGpFS80TcEACZwNHxBETVPAWPeZAhVT2KoUJRQobxVDBhzQdiplfN4QvToe+ku1YXEuFEFldafPj2TyizQMOaj3rIokucIxrrhx13KsuI4L0i4Y7siHMnWkUQUMKNIjUpa1I3LkSnyq7mawfd1QRhDXRuIz1izQHvOQSVTrqqGA4w0p4NhKxyW0iOoeTODg9K8ZPneIaOpFASjr2OLplClUDkUSxwo7RW1FWeWVIm5tUK+cmtBRTiDXd9CT5OvU0Y5tH9e9RjwgUOiWiWJXGVTdZOUYaVuZAZOlia21WPZu0o/90aqynbpgshjNq1ViwW5Qt6ayUndlPhSWsKgq2dXBbBxtqeGHuHKRgl7TRuJUrL27BFXfcRrKR1x0qGUGjjiizEUYXe+fFRZhp5KFMHn3NjDVWM9WMJJKFmSU7LBXpo1O3OiemuGI9hTsOJUA/RuT1TWDaZI4w5LguUezapDQ93nt/2epkZR6P5prFwbl4Tk16Rz/jTXo47EcBHdrAVUVNMKs3k7amEzkS8VnqSl8pWawWWW4UdAtLVP9n6MtvUfqYVfyPVrBgVrlYFE4YIYMOSOh/Aw70r253cw0dDNgaOehINX4b1wykMIrByWsao9jDKBqHLnzEQ4LdWBwyIHf/FISNYmAjHBgqBFYwZs1kJJJy0egiVrriqCM4pxuI6obFHOysaXaJgEkiRoOH2+VOiIz6k+9Y8Tv4IdFWZtsa8W6WvPn0jH0tCtrQkKEzozGjGhtDVjVYUomogY98KgzeCkeSMvO5L2trnN/5qGhGUwUqjW2U33fKaBP+TUCPe+QABvw4wNC8hk2d0ASbNpEIPezBgHiZQhEc6UB2QbAb00DHNJjxCEEwbpKUXMjiFoTC/6BElKDMnsEMFsqxoJGFJ/oO8lwIwxjG8k4U25M3JIKo1sWOGIignXWE+EsWJtF+RYSfHGEGvJWh8WyXcmI0XPlEKCbEme0jpqIS8pQP/7EuaUjTog8/oUWGjdGNLUqUMtV4xnESMZXpPOcc0WZHSQnKFOijp7LgucoKbWCPfAwgkNCQSEEWspBwUsZATfaJ1yVwbz9MxCiA5UlrjMKhHdRICk9Jx7GZCiOuemc8hxmpZDTvlbiBZSwZUr1Zqm44GltOJw6JHV7W7pchyR32cGlMl3lUeiKp5h2zlqKNTlMjtvHaM6U4RfTBTFU7+wk3u4a9bsqBFmEUZ9ZOZk6sZpWVV2Nn/YzYuzfqdHrR411HdeqiC1RAj/2LW2nWUAeCkbKUXZvNekrZiX3toRKPQIVEF6YLcB6Lm2btqDm/GtaW4ZI7ImXsC2Vp0oMsz/90MwTVFuvHie51rDp6yA5NPYvTYoI2tPLM6T2R2U4mbrRrQR2qEzOFG+hxdJvNgIYMsTkUmQjWsrHZImueylGtkvGqwSWuTrLDVdSa9rDJumdiSUtWsEL3tKBjwdyQ8IU75AEtoyAFYFu7vofG55NQTZBuzUtNSBX3ZUoULvCwctrGPm8Z5TBHZEtaX57ZN6W/wVg6okYLH24WD07TnSHXdFNh5nS0Y5VdgkGazNiK0kCsbS2FX1vh866zGtWrpYkkDLU3hcQhnRiZLD6Zq+IOF44rRqdhP9rVrfa0tERsrnPHulygKXfGI3lEj/3qC4gC5cK9OmqGMRqMqNCxxsj/MeYY1+tcVSJRO4ICxjZ2g1/5SuS+kOVU6VQaFFnglWSUuNxrajFIIdoUwQJaMGkfjMOh7XjF4TkYKHVr4Yq2Vsg+C2xsabsq/n4ot0AT5SdAAicfPq3PMCbnVV8MCmWMb8k6Tucwj6tgB1Nax0ID7Smbc9E0KnaVUattNE96VP4kWbCs/F5HtTNo4MWEvuacshzbW+vnXlnXz9syl09NH9tCdouG9mzHPEu2Qaq5zWwmbYHmd9A47zisPw7hKD1ZYWFAI9u/4jYnuc0M7+55KPfhWdS0OcyUCFIqid4wVbvaiWIAUxkvZhS8lYu7Sds732vOdI3FymkpY9qrvsO1/3unKrr5nIN58UW1h5Mqxyzj5GXrifJW1vNmO9ZaZct+9a4Z3mtfH68hobqhIA0MG2qbsE3Kfm9WOD7djDcb5hoVEAlHeDBP5jzI1qgkJ33ec6BPMh71Eve4iyJo2XraI2SuhCyKhYgweG/RVXURbK5zq5Lh+ztZt2NniVFwR9NC0v52ecHNbumz7jTaVA44vW0sPpcnSuFzp3vdf+1xhkfcrFQ2Hq1SZrVZT9rFkco11pf95/pmGcv9lVjInYc8DpVDi50gWWfRDJseg2RNsWHx2wH+6TbCGXed7rwIM+/jm+vicY8zSrY5uUmhoyv2SYkg7IM+FG8L2aLn8XQiH/+EEqiDMbDJZdGZbzdvrV967CUTe8u1wnzLGzyeZh+99NOuYE7LXLRy/lPZRW13vNs34YnPu95tzIlXzBe2uQJe4IFxK9APfrRVazMnOKGecq9/8SC/uys7VIsgOrPLY4kCQjmWGziekja16TrsOL5V+hwT6rHsyq4RQovuUr162SRcoCQO7DnBqT0QtD2i+zZzk7BS6r6EUokR04Oomzqqu6sggj73Sr6uE7uTMZlI+zpKAzvqg7uzm76YkydUUTsq874D5DfFCj/J4j/yc6H1Ew8ivA7EGzQVgR/1q7jFmrSXaZOakLIAhI8rUzxdY0KG4DX9qAVBEsCT+5dGQoP/AxMhregc6Cqr8ZiUmWqyreqrgcmuM7kDOOhDClSFGLlAnduFaRAcREzED5QgwmnEbKgXQ6QkyAEswDJBU7pEASEzzgKxVNisEhy8mXApB7y0r+M6ebvD5xOfUgxC6iuwHkTCVsw+ItS+0ELC6lOUMaQHMgy/Joyvm7BDj6myuZMa+IEtwbsKPEQiLvw7IbS/WTmOWYua/cvFJeRFozoIAES/pBnAWLGbqLu5viIo2koRKpTDjGITIiy9cOwxRaqDO9iDOoDHCaTA7JKo7jLESHxEfVREEEzEKolEfKwSSvSEgiHIalO2SuAlTKArUzAU+pkjUIjBcjiZW4zFW6TI/4rEPloEO0i7wwZbM2CCto1kNjcjBlJktpLSxV3sxfL7xVy6Omfquwi5J2MUvH4zO/prRpjMP7IQv2psPJ/8GsiDBmKzqWRLBKSEC0dywzPRK0EIiR+TDSIrwYUpFk1gxWDiPImSQDaog678SnmcRx/zBNWbBbOchX/8R17gR36ERHycxLMkSE1IC4naHI84lQGjhFyoBopiiSm4P0uESPuLQdgoBzsUn4pExejLyPqjxZmayDusKVmUzFm0SMtsvlrjP6DMxfJjyUUJlOhojpicJvYDPNsgo43bvpsaOxsUlCACw14cx2ncTM7Mu0w5MDWkKaRMSjVopCnIlrxgDf+nLEp46xyuCC9wwkITErV1LAR4ZIM1kMeuFEtFYASyPEvszE5e2E7u3M4q2c5Z4IV/xM7x9ARDqM5puYNLiIT1JJigGbBN3LZhu4tOcME0isgxi8yLJEzFZMzK7E/9BNAAFcmRdEwZLDiVTFAFXVBr7Ez5Cgbp6RjRNL/ngDjjAcWPtL6CY8ZfkkLIukJqpE3aRLiKkJMizE1OUKSkVEpI2hFvbMO7+KcCcspCyLxwlKhi6Rq7OkeT4bGk2UqvJAMh/Up3nMDqbIR7zE5SCAUmVVInbdInNU/0DNLpVIT1vEtMgLpNvIhOkoVEMAJZWTR/8w78dMZSFFCd7E8ftMz/z2rTNA1QNzVTtaNMA0VTmmJQPIUsz3TClzjT0Kwy0gxUZ4o5/CtNgdM4JLQIwpOn44NGaITNlLwvVEOImhJA+0vKzGJBupgCgFJKu/Ebb+wWuBDOA3JKk0NH7UnOubpRIGWLKzCNKtUuQyDIJh1EW5VLsqxV8zRLXb1VgpRSPxwDYbUCHMABKOCCNdgulRuEAXsQBOktMJ2VjMq3HfoEyLzDAMw+NdWdjCTJOIVTcNVWOd3PcM0dxAzQPE3X4mjQOfGPl3wwMSrGG6K1tlPN3OHQBpRQ+opGjJnNoBTRScVGM7W63YRPvdJUB+qe9jyTBAJVB3KkT7ULBQpO1kgo/5MTx0UTpRhRBFd9VejMrmfpVUgwi5E1T5I9WRoxWU+YkV+dEUbYEiZAAh7Qn+qqrhZI1hFi1vh8VmZAwyKQquE7K5N8Kc+61nIdonIl0KNdWnBVWqYtV3VN1z1tV5rJUPgqlcNcLCrEwld0WpkQvYhsVNFhPF/T0/wSHcQziDRFpOoYDd7MAQcahBv1CEXiF4e92yKY2Bj9oc2q2NBM1U4CLLPsWDKATjjQrpVF2SOlkfO0g8ZV3Fk9WZY1CxvZAhyorg/I3AyoWRZoATdgT51dyFLrlW4CUxObVuXymHt92m2lU9dl3QCNwcF0xgLBtdaFXVAgDjvZ3aid2od5UP8dVEBBJYmsbZUoS8CXgzaYREYhCsZ9VT/dJTeAlVQpKsMiNLSE6iXOQgUWbMO4CiGVw6TLGY3aYSTffNG7gNiFIt/a0d6K1UrvUr1CIFw2OAPEZdzGRU9DcFxFcFz/5d/HddyTVdlpgYLL9Z8N4B8F1oDq+oI+uAQ0WSrd61k6MAI68AVLsqxNS6hvvTzXJLakxd2nlV1nPLDJbMY3xV3eXWFQMVsHLRHpAilDNc2JOF6NLNDrABmZONfZBYXnhd4v+9faRDgShb4UZQ2+XZPuVYNDO5a7MiHN202LLbO6Pd/1RWIkVg323ayLVQWOJdIJ/F9pGWMxJmMz7t/9Rdn/zekDNihWufmfDoCABWYBDuiBEpKFSlwabhuFdUEDDH7W1AWi2lU5yfTgYivkyyPkDl5kHWLkHm5kTtPGRQZXEn7kwWRhTB7iF3aYRdG0n1nU9wNeQvXCtePh9DMH5i1TD60vm0gHyirbn+y/xVtNMtPeEu7NEpuwPPMqo2QzX85EBOrbAkLiLbZip6mDtTjjNlDmMh5j+zVjAVZcPzTgN+4AtYIAOc5m/mmBuMpjD7IG11uIS8BlX0AX3TMj0Dw0ZIsJdTzBBLGsHH1iRZ7nNjVke7bkRobkZntkjqHdDsVnfM7kFnZh36VQ4hU8iRMmUa7XE86pQbEKA+MlRDi4/xsKkVd+rIE+WyIuO4Lt25WDOk5tOh0NVOILm+tJtnt+nezlGwdOZml55iJlZmcmY/vNrjY4A2qRlj74gh1w4+qy5n1aKwjoIxzwgkaoNiALZ3C+BO81ZzDbGHUWueftM1IDitsDlqPjWapc1VL6Mb8SENMzZL6650lG4X8G6ICOXoHW003mZJJOzQlNaFAGVLd2yQI5zI+QxXiCyWHLVw7uj2BTii8znc3smW+IN+UdX064SlSgBFzW4ZrRiNRqIvByuFS+VKREZmf2Spx+Zple5vSMls7u7ChwAh6Q2SYwbbgpVsxlgTzC5qDGZhRoac5BoW+WRFVgQRqQgkfoQP+NkeelWYqs7rZO4jbbCjqkQO7jTgqk4Dnldu7cw72H4uqU+2Vv3ed+RuuO2c0cTkiQWOuM1uSWfMj3iWuyorIrlOu7vkwebDc/1SxFm1f48A1+oKylGGyPQ6lqWE5LJUACG7ZegmyqrWtmImJI5RNZluryKkhg5ez6DW1lvunRzunOZoPSXm39OYH8ESC2YmDYngADUAARx+YO0PD7LUjB9aRxrpsc2ANhoBeBRJqU+ONg66TjdOK/it9ws+oO7EcfB8EM+nFGnL1Nempv/i+weFPNm13V9e4l/27wJuiC9opBNR/RdEmsLFT1nsECtd0rLDZeAto+mZ93wA+Lkd7/i9boG7LdACMZp6M8mVLBISPwuj7wEMXoThHi4g5cszzPm56W0ZZwmsZpQJ9wYX0CLlBtGTjtDYdjOdYASM8ABmCABBgASx9xOdYBoz4Le0xxfZELv+gCRoicIl+cg6yFl5TiPVDpTr2cYDYgFXXOGlUEv5KossTqyImgIB+ce+n1eamMLNF1YJ+HzPD1IL+93GOYczPr5o1iM9E8TP6Upwhvdv1dFCvp8sjaWkkwRj3XVDgU7B5HKM7hvCyGMdcQQDvz+05zO18Qbr3U6hBpX+CeMIidqRxvx4rlSNV3XZPuxpBS+51wz7YD0C70Cq/fM2ib1F5tFXib/NEf2H50/w2IgAWo9BAXAEuX7dkGWWWtbV24AzEIEhGYgS0Y9VIHvvHtTd+EWJZ/JAfqC5iP+QYaF4nVgi8hA3jsseq0x1ztLkE0S08P+vBaHLTMR/GkJF1n7kp6ROYmCKEziuiOZ0tEuSdPhN2Vdqxn4WrXuypXrzFtMncDTdHiT8ekaBskd6ephdVBd3tQd08R7EA7w22E93hPmkRLvz3bZOPZRX63JfBbPE5SPYAX+DZIA9D+Xwk/eNJ+greBGxRQgcd3+PyheGyeeIq3eEvH+Ed//FhdY84xHCBJkiQh+Uu4wMZG2JiH25bvG739VJH3CxCI/dgf+b5g8SOwAtzP/X4RUv/e95fohHXgb0d3nN/hL37nfARGiCu55HlBTPFw6HGlT+6sRofppqjsQQW1jvJ13fonvHZ3krGtjRTajUJwv0HEBAatq6+zv47LeQWhVI7aIgiLseqLkd768C+jpPtNRMPqAIhO1bhBK7hNHEJsCs8xbOjw4bqI7yZSlFjxoreEGjWCszbNmrCQpPrkyXPmJEo7beyoTNOyzckoMWc+ecJjxw4ZOk+cUFFCp08VKDQQJQphQYIBApYOSMAgQwYUOKOsuZOH0SVGWO/QEIEBBIawGFZIkbNGzZQcLFawTasGDRo9eipx+tTp7ihUevXevVspEWA9cNFIMTLjMFvEbGn//FDrWG1hx5FhQG6sJPLlwlIyK7G8ufIPLaJFvxWDhsxgMntWF3r0KC9sX7pmf0Tn0fZtdNm68a5tTR1we8KHE69nnB3ydBYlmmvu8OCzgdGXUVcW7Lr17NqJFevO/Tv4V+JpKStX3TqwVHVBjVfvXjz7+PLnl1OOiv2m/JvmzNm0jOB0x1yHjDTh7MMPPvzsA09HDbaTHITcKAdcOujdwtcmiPCHCCq+oKJhIrKYZ9BGEJl4IooYZaQiR7/9JpInfpSE0kks2VjSSyiNQeMYNeV0A1AopDAkBUVFNZSRRyWllFJORRCVDjixAcdVjFz1SB1diQCWWGIltlgYcqxm/9devnR3TDUCqilbmmvu5VchctEBVxhTTKEYnlp++SVjiNEwQw6HSQaon4IW+iegg+agGWabdWFaaqy15pomo3iSFymzzVLbNLtlcxw8xYkK6nETOleiRs2ctyp4rW6Xi6u5tAeehaDol0p7m7w3H6/xSdedfBrigQgxJBa05m/xIIhgOA1+46yz5lCIXDEdXmgrJcJSUsstlczBoarGPpsiuQ3RcyJG5Y57G4wz0ugSvCutpBKNPPr4I5AyDAnVkxk8aaRRSDVpAMEO/KtTE1NaVZJrd5AhBZ9rcSACmGrMxQrGa1YnHcckauxmLbDBGZhoiO55cp6HFroyyywr6v9WEowaITNmkMKFmmprrNYwVnmN+jOppi4XEXRFs/pqrEiTByt38C396nry7aprevMBk5/TzVTYbbB4eP2KsQESWOCyC0Yr4bpomxryhfdxQonXcnxinYZzd5y2uuaqe27eDzX40S6zjORuFVi4ZGMaMMV7xo722nQDTjJE7lMKUFmuQQdHHaXBUQMnNYEDUVGAAsIKM6xISWtcQWdnLASaAw4WV3JJxrIZE67YuEej+8dnts32XqP8tQfrkSXacssoK7+noGsd73qf0fdp/MxEVE9EF9c7+qgVo4lxD/gLij9++KE+KDRzaKMa4O7JuI+d0rHSEst3syL9Nta56ur/Xq/7v7IJMLRmHmV0zWucuNt0kHG7b8CjbOfD27oitDRZuE1b5MFWeTg2rqH1rVx866BEOIULwTWCXin5A+IUp7h6VcFHN4mSDiT3E8qNwHJPioDmIMA5BTSlKaAzWAaGRDrJfYFKDFsY6uqwhiUOJi6DwATtzKSm3K2qfRm0Ihbhx7ZbeAd4emlYYOQgxjCgxU5mPCPNaKAZxNyJZcx73qEQdTzDaM96RqDM9CQDMymEz4HkK9/5psXBUxkti1qUX3gmWD/2cGeATTNF1PQHn/7dqi71MU9fsKUtX5wtOsciUAOZRaECqQ1a6jDHhVQVMmwZEFigKEYpB/lBWc7y/1y1vCWL0NWR2owwRixJiR0OkUJ5waRwNJlK5JIJpJzwxCj+yqGSECBNA4DOckIaIg6YIBMkukYrjIjTEgVBqdqNjX0LyWIVt2NIpiUSY+580xeHB5hszbOeYxrEXASxGhDJSS4WK42iAio95M2RjgZ9naLGVzY/AjJog0yVOY+GyHYuLRb2q1UlJzk1SmILFJesVkf5qYdU4A5AnxybgRTEoE7Gshrisc4qM8Sfue1FOhvkIC5x6kFy5XJCvAzF4F6SBkAIE17GTFwLjVm4eykTJ04VCpL4BU0I8HCa1TzSNXnCBC4orA5GzMo3v5AI2qliNgo8a0TPic61ShQY7P+k6DvhKde5ztWL83sTFL+ITzm8hT9w8SsZZVYEg+KJT4NFqPOOt9DF/rE46FMfRNP6PqTFT5EW7YRl54e//GkUVxmt5K2UkQ5mgDSkctoWAqWRu3Q41hqkNOXWuqgemY60bTa9aU9puTeI1FKXu5wGLwIXCkCksLhYUGoxlRqFpzKVuUGBqjOhKU0JXDUFKoihTnBgg5tw9QxetcolXAMXQciirFKcIu8km86N8a6LE30rfO+6l0fa1Vrc4qJ7U6lfjEGSEpiApDzr2c8x1omwhlFZyxJUtn4wdnwOxe24CrnOylrogq66qGY7arWNcpSRpxSQX96GCG0JBE2eDBv/7uyh0k5Cq1pp4pbbZnrX/8RStza+cU556zcGdkpwQD2FJFryBj8Q2Q9uSK4XDJfUJLfQqc11Mgx3MEMVVK5fOLwcVLQKOR81oXtQcEJX7wBWwexhFOf9GI3VOiK2sre92pHoZN87WTi7yoqHhCtm8ZrJ/iUiQ3SQU2m2V5lB96PQhV4wY8334AiZlH3qlHNm5dy/XXU2WFFbTzU+vOdE/Fku4Epto5MBjXaI74GQBUc7uKGXF2dYxkursU51TMiH7ra3emvWR3ghih9Dosi+fgOSgx2T5SIzCsZ+suQmR2UinQCr2LwuMntEhi47oYhwqMNrhGca8p4ZzeG6Irip/7PmNrtZvd+Os+/WW2503zm/6b6vu2GKl05Uas92CXBgAM2fORi63w12MD1MDdtQ07ndrnrleBY5Y+v879K98iyv+nxvTA9w08KSW4lLSnBRG2g4yml0g4JBUlbHuLYdui0tbQnClZsrx7bJhq6B2msbEZm4wE6usJu85ZocuwdQ/vlPhDg6qUCZyzxnw7G3ygUyKCwSjyCeHsx83l9pXNxqtTrWx63mEzea6+auescUwlZaxZvdFY5Vea1TDlmAuL7v/C8k4e7vQ/+7oRW5adcDlLTKvgLSCu8whz97q0uWw+L8fKXWX/vJYEgoHsLpiLieNb9jwdhWw8JVLcIFYf8cEy19LLc1bwOum2n4eObzIiogbJ7cIyP52ETneQ96DvRlDpF00Ia90WuCdKRThQy9rwojyGxms667pFk/PtgLub7lKx/kEp7w7cz+aArDm8bM0Hra75zZfnOfwfJg6KI9v3HK+j3SCqeFrQDfYYd/1PCeLjEXuZ42NaHa8ZJXlbOO8QlaUB79msSsqMGab4EercnarTEEAQacO7hDcHnCzBnbSqAekbGekgXbct1eUvkc0G1gVu1Az+Ue7PEeG3zB78HBWaBBJciGLqCXm62ZebggDBZNDM4a852aDTrf1b0ZmxXc9OkgDLJgm2HHW3Vf932fStkdo3Xe+O1d+U3/lPqtX58BBij0WeadEgUFy4i9n0DEX+QBCBc+yEnlnyncAqv534j5V+aRSAGqXAJyngcRoG40oIx4QZTIhOEUGQUeGQUel89hoB3+3JM91RB5YJOBYI/oyJRMyRItUT6ZV5ukV7i84NZNogxKogwq4Y7RYA0SBEOIXbj1oA5+og+SmyWWYtitFxEmCN2Bn4EkodB4nfTB1dkhkr09YUjdYkcJhBW635/pCgAKECbeX4dAHv2dj0uNHHVwiyZtCycJ4AF+3jMiYDRKY+iNnidUCR22gAZWgerpoeLcXJJJmR8uVQb6SNKZYzI9QSFGm+4hYiJ6wQjqjDipwjEQX/I5/8cL1uDWaeIm9iMOSlgAieIoqp0jqRvymeIMSpY/cJ82LKRDeh8rNstjRZbZudV7JRwtEkP6aaTDqZ/Epd9GXtIVpp+AjRgo5BnjwRo4PAN+hZ2LcIMvnGS4sJ0ZjlgsAOPmhR4bBuMaHmAbHqA1WkUkwIF26QA5TuAEemNyiaOTxR4h9lw5muNSzV4TVGWPQKBXeVciLqJX0U5IgISJVV1zLMRDlKI/3iCq8GRZXuLz7SAkkqLumOIVIWRCtk+4PKQ/IEgqGmFDSWROLmET1ll5eFQt2uJmfWSvvKC9lSQi7E8a1hiFuM/TmFiExUIKzmQt3EWGjFixTGRPrtxPhv8mRQQljtiACTiBN6aeasrLHmogUz5X7CnXBy4ZUvkItLEjVmqlbo7gPAoDm5wUqPFjJ9alcBISWZ5l802HJ7qlQR4fcdLlcyqnoTVkQ+Ll3B0I+PCGX7IUYGpkYFoHIxFQYRpmJUUhSOajvdHTGTYmSqIJbH3Y75zJM4Qc5qmSMtIW4rnhTtZay4mmyynLNFxjSTQCF4xANvVBkZ0CkHUjH25jThCF7UVFkp2EB6Ijcg2bTURZCCbid11bPAKfCorEJwWnca4l4SEnWxZncrblQKpSFv3gWy5nJEJnimpQP+RDP1Qnju7l9/WGdm5nhJGS0VQkwhGQd4ankYpnAJH/Z0fWhXn6V0aVw/UVHhYypkx+oamsFDSUFheaVHh6iGbBzbBUoWfqJ3/6Z06FygKOhCHkQa9FAQ54IBwclyX8ApBJguqVIx1mAOhIhQroUGw6gVGeozoil+xFiRMcm0y8o4du5ZREgnn5pjWEJQLx44maqIrWqKaWqKZikV0yJ4xS4jlF56Zug6HJQzc0ZD7kgz445DxMp4L1KJBCEHSwG6ygZJGeJH29EnqcJ5M26RQi5klqgpRSKbYwpsTZF8cFkvnA5GXBCqWiH/8JiHyJ6QE542cO4NDsZLr4p7LoWiOEKyRIQpDFZuxZwjjAQilYQpAdmRdA4HGpAAcMAASo/8AFooAdIupV/qGhMlmizqaxMaqjAl9ZfSWlehKKQhSmXtLCJmypfqqotiWpQqxzPuxBUKc8CEMklEI24MM8rCrILqTH9iguoKpECoPircjiQc1d0Fc79aquIhwUNili6gddzAexYlKIIet60GRKQojHpQnmTat9Ih6wwAeIpIJr/eWpoClOcastQa0BjqY7kB4pjGsokKvWQsJK9II2wIK6LqiRUWAPoABVSYAGEGKgSsm+HhuG+ivAKuo7StsXWFskkMIIhQQySKrX1SA0PsdxMt8+WuyKciqNxqiMRizzfV+h4YIqRALk4i0u6OiqvqrJmqxEbmc5OdrBhedG5v/qIhmrR0rhXzhchmgYSOassTJmL0rcuRXEgzhWMjxrutWFFrHSt3Qm05rp00btRfiu1EptNzBgA5Jr1pKr1/YCLFDDL/wC8yooniLokLmBDpwtdaUtoU5l3G5voMot49REtS1dEZVC3o4QWnVhpjps4Prj+v4j4RZupx6kDxpuijIug5GCpUBC5EIC3lIujmqDNpAsLoTDALsIyh6Lrcps1RwpkuYZYfoKFArrSdYsJXwWeprWGbau7V6ffAKtls7XeeiqmlTrTNEY7+7utgKvCu8nNR7gtxbvjynoKTCvM9BwL8hw9NYcFqBAB2jAUBwF6dAhvGqvIfYACTol7rn/7Qcq3RZMCbtaAvnq7eaeZcNWseIOLlpyovoC7sQi3/wSLuMG8DSMgjftb7hKrvOG7ELyRkjgAuCA5VnFGe3GbMyC54zJ7MxKXBQi5keClq8oJgav53pyAtthEixNiKLt4v75zpeC6X3Uje5+nFrmZAqXygpfcvDq5Du8cHDNgijIsAwvrzMsr/Kuaw4TWRUIhRcQ17sSGzzOKYYCoixzb9LFabV5gR66QSBEwu0csMqmbwe171j2IxZrcdFg4vuKXRdTbMU+LF8mCC5gRRlP891Cghv77xrnGunF8Xm1DXfUsZG2B656pM2Wc+mC5EdKcOaZhyYsYwYPcn48ZpfG/+7jTep9KFI8F+3/GBBOnnDvYrIlY7ImjyYnBxcon4LyUoNCP+8Nsys4nsFU+EHYRi9SOY5zbaC5aug5YpcOFFEf6CHkRsJXKh4w/237CjNKb7E+NnP83mMWJ0RvoOo8uAObUrO4hnQ1l4LXrmqr5sMCBo7enpk3v5LUzIp8jaelhVQ9oTNJkm5GrfMVqqcgI0KnUeGvQGuBkArJTRBdVNi95e7Slqk/TwhAB3S3JqCawlzgxFwoL3QNfy0sgOtHF9MORCBCH8IfoFBSvi0HNqVrup6gRhl2QQEu6+Euj2veknRJs5yakUtKq3QyR/ZjL583hANvLCA+7MJQihmCUv+zZ4frulKDGletb5qVmYyk/3lnZsqX/yH1FJ6uzT4p6RbCawMrXuisO0/1GXa1ao3w7TRLsy4D8HgI/riXXXia1og155X179rSPQh0aOqGWhu0riV0DY/DW4PtDffaCp0e9NocKld0IApiCwg2EvehYCNMoroBIERCICyCnZbvFKuoSU+2FUO2ZON3+j63ZQ/vmm6FVQgljnhTZ4drgffvx1YuNXSDLqiCg19hZu7Zalfe6L72UsM2SVZpr6xzU09165rkMK5knI0ahAh3y1YL3BDy77zN5TFscT5WwJk1c8f4jLdwt/r3dAeX1zoDdmO3Nvg4NSgo11IgkWktXiP/pQk1WZNF2W3CELT9dVNBFRG5gXvjQvNeeWIvEN6ZtAEOJ2Prd2Snr30LJ64BaNWSQoCnOcOcTpUoglYYuJt7wqaIduWSdoNnEry5WGFK8Gbm9m7PE1Pbdga182bq9jvnj8ewU+NRC7DE1LfkWQXhgX+cTVr+M4TUOI3zN3RDtzp0bI4rLyyMg6g7Ay+ArUJv91wnWTBtLXEhOY1MZXo/VwyVt5S5ppPjALRBGy4TVSBMQiD8eq9bAqSW04v/7Vp++SSH+RWDOYrAdJlfNm9AgppP+5oP+IDCOSPI+S50bILP9DT4QjtXSqWkHaF3QiHs8dvQdrDusZXy8ZN25IRj/1Khv7OhpwIrjNqzKJBFLutYrrgYjRWGiCn/obClXzqna3rAIeFZN7dxXPane+2ozxzWmp7iuOknH3lxJXmh2nqud3yTc/yzESJ7p14ZgAEY5HVIZwqxcznL+9ZiK/vLvy9lA3dMe/o3UXsSVTuOtPlnI/jHzoNCN3h5SZ0mnPu7o7s9ISt7vjvq8kqxUKmhezh7hniziNyMwa6IL423PHomQTK2DrSMQ23YKzyNY3qn7MYNl3pCf6wz2EFVwsFyHfGUuAGCSgIOd+MKETF6mzdHN/mta9cgwmsuH9nJH7bk2uCZtrziyzyzj3la0nw8XPZCZkPD3EFr4LzO7zxJGP/4Nb65tif4qq7ppRS9pLSG0QMGuyu9PZ3zzTb9SdIb1Ed9PRmQTCqe1eNKAH4cTHmLHPhXiInRtSZ7wYcf+iDyRAASwpt9cjg8qFs3drs9rgM+C6CAR/sBFE90eLeeOvY1evt9rAeJH+qhyQM7sEOuLyf+QCu+8MO8w8b8fptPN4CPjk6D5U97mmO+5repm+u//gPEJU+7slGbd5Bat1maOhVy+BBiIokTJerRk+gioombKHGq9NEjyJAeU5lCRawYrUoaWeJBxLElIjlzOtIiVi4dOnXcmqE0abMZN3DVfNVChVHOy0cf6YRBVCvoum9TqYqzevVdVq1b2XXl6jX/ndR6YemRHWsPLVqwX72xPQu2W9xuvejSpeZM2zhAT1CwYDFBAocTOtz0gXTqFKxDgOw0TlMFcpUdTyhPLrHjhmXNN0pwxrxDRejPonHIQKGidI8eXrC0eRNoEqFfs3HNDhQJV1tjbcX25noOePCywn8TN35cKvDhyINjxYoNenRzV6U7r04devPp27hvx+5d+3Xi8ODJ6yYPHz5/+diHuvP+Dps68OHUZ3PmzHz9bPL092+oMUUEHPARRgwchRReDJrHnWxm8USTiCSkaI+MWOroo0RGkmgkkko6SSVKXJJJIzxGjImmTzpBCaedeLollhhziWoqoyxKipKJZqLE/5dqhKrKOuTWGpJI38x6C0m3ihxSLgdL2YWXXvAap5czcNBAgiwzIAwS2E6RRBI7XHussig0A+2zNC8707LLVLBMhzhDQ6E00VjD4o3XYpsEF0JkwwWXSJDhjdDegFyOuUKLS5TRRsULsrvvwnsU0kkrtVQ5eOK6Bz311vNnHk/g029U+/LbD9U89PtvQAMZ8e+OgRTMpkFaddEkwgl1rJDCDH0FSUNgOfkpRo5OjAnZFEGksUabUmGF2VpEnGlHjNSQIxUfrXHu0ESVNBLcI8X9Nkkm5eJll1BCSQwvZ2CBxIkTJhDMDUD+AHMSP84Qc9/H8DuTs4A9sOzNztYk2P9NOec0DbU6o4iiNT0n4WNiQiyxBNDbkMlN0XARXW64kEUe+WOPS3YU0/DAkzTlSzG9Lru2OOX0vH4+Za8bRgRJVT5UT60Dv6Dny0/VVEsV8CEBEywoIV5wzfUhXqXuVdhgqx7WJFBytBDZrldEZUVtm5UxGJy2RYXatGVyCpUet/3xUnIXNdksuu0mssl01U2sFXdFaUNeHPoo5WJLEGMsjcT9UFzMJ1LAjM4bTvPssszQnIwzg+dcmOGGVYA4YnvBGL2MQG7rMhLcBu247pNJft311407GeWW4a6UUpdt107mmWu2+eZZ4is1vvuAPv5noE9NHtXmSSVVk4FEYTr/m2kWUmQPNNCgg+pfHaIIWAxVVJHErrvm/mtQoBL7GRh/WsbHYz6ZI2056JhJjafYvz3Iu+uezn9kmcqSCGguJ62rLrBQICR6cII2TOJwEFxM4/aFhSowTjKYK4GbznQwzGwQNKHZYOcmtzkdgK4NFowYGCJhutvAhmPhYJ3s5PYVGjKKdrXbHe9itkMe/rCHwRnUzDjlqZvNQyGXEMQadrYG+yDPeVGUYhQhMp9C4Gp6tXIQrnTlq+95L0Pi05pFLmS+Mn5CFkZRnzKgAY6hHCMXH0ojHJFSPzlIQQ2PkEX8+BcpP3YrXAD83yADWEC46CQuvQBUAhXYC0u0IQqA/0DMJMDkhjtdbjKQSRwW2NRJyV3ukyYUZQnnpBpT9qAwYHAhbDAGKN3MMFM3JFksZ0fDHN5Sh8zJXXJWpssgiuce4ThPp4AHqgbhQhWXYOIye9bM5TXTecyD5hTnQ4c6jOGKsnIHgxx0q4ZExIvdE2P5KlJGipRRjViLVoyW9QmZ0C9tRmBbj/iIk+5EIzrw2yUg7ybIcRXSLMKMS/VC0YjDTPIQYEphG/BFSX2pUJORgcwTKthJNlkOhJk7DSlHeUIzQSwKPnCDKgNRm18ACqVteRssZWlLl8oyl40y1C99GFOYqfQ85TGiMd0hj0Ap04lPhKI0pynFol4TVdhU6v81szmLadyFQbPQBYSW8kWr+spqYeTaOc2pEU6kc41tHBvYimKt7dnvfmGYZ1GOEZRyPCOf0GGjPulaKQHyE6B5FWgiJWFQMPXVDw99WGDtZa/FJQ6xiY0YmVYzmcpgkjRo4ugJSuiw1UB0sSMFROkudjpVDMoaMmTpS0lbWtPGdKa+3KdN89mWTe1jp+mJCz50UQlm+syZudUtFNkwht7OhwxLxSZwietbh1gxegTZJjevN6GdCYJqXZ2IdEkE1q/SqBlFISsr1qa9s6JBnpVoG1vdms+5nhefddVdWA51V7zqtSvtkIv1CFcKSAS2DynMIMQSu8nI9FexT3CBKS//+kHJjlBzKeDoZVuzUEsWBsIjjXDqPisNqhgSdqfV8Nxkyi1w+fKHqLXUbsJRnnjAFniyNY95IgHdJuJ2t76N8YzHYE3fCtchwq2xNedjiIEsKKpTzVU1pRY1jHDValsrJ/qK0RCSrG9bcMTESTCBP+9uTwpTwNYe49dWZQDjy9gAc5jpqt7VvhevGAaXfJtEUPseNoWPpagK/ZXBy0jUvxlkkwgzGsrJctSjDk7hgFE5YBeQ1HSRIIUuQOvGu20Y0riEKYd5KWJLY8cYQyQPim2Gj/miJ1C3Faozb0xjUyO11L6lw1JR7TxFLM0Z+UCI9ZLp4j0YObq5nloaOwSV/7eBbRSsEIQaiH1lLeBRQ3MkM0rA3Gxnl9nMgpR2L91bFULqtc3ZQFcj+pBfFRI4k5rMwrd3oOcLThRhfhblCFHggdNooC8DY3AK38AYxnzbC4UR6SoxFpcY1rAsGQ6macsVaYNzmKYddlSm98rpfmhjmJ3yqc5EferfprqZTsT4jVedao9/vNWKaMQspDQO9hwkULgiMvc0cmtdL5kOnSjHUbY2LF+E1hrAVmaxjy0Gn4dBDuKVRSeIPj5avMLZSUdvtKltz6ajOZCsc6M64jHMnm47vxDGj57D/d88S1TPGC0lu0e5UXjvwAVZSMMfVkkxCf4hTxHW7GxOiov5iv9WzQI/eMBjl9et1HKWIZYppcND4pl5yjwRlzgulHnrjF9ctxuPfBQuHtwbW/7yIId8qVclq3mwR9bUeBD2uHeR+dha1xbpRFnLp75q6OQjoxi2d3suhS4APVgk2QQoeI/0pI+Z6WfuY6WhHvULC/TEPU2PkwIrYf+yyQV4Riy515QZy0lWcpkLGClL4AJ7+clPsfFTKSw2sc6WLhKlIwS7DGdfu+M973y34cBJRn/5F/zvc9v7DQWvlcGzBa6GiJj4QS74IT0kLh5IoYk0bvMaEOS4APNqrLciUNUybwwg8AIpUPN4yzBmIRs+L/S2SBHeA9ei60bQ6Chu5CV8zRf/LsEFswcNrqDnjIAGxQBHPAJDdq/3fi/ahA9IPIx/rs34pk6+qi4elK9WeKGv7G36qiD6MsjQnvCC/IXQOqkzMkNzPsP6Jift1i6hDoEPysAM+MAMOMuF4M4MS4rfAgEQFM3upgH+5u/+6MH+6HD/7vClZkjSKI0Pz0GGGO7w+oEfNAUBPe08pqHFXswBP24CNTADH9ECLY8KNBADHbHVHq8/tCkf9OHkHISqumgQKoSMho6c0AiOUCHYZk8LrKALkoAGXpEI1OoGdRDpfO/Zls4Hh+8HdfHprA3+jDD5ekobhrEXDocxJqjOnBAypHDAIiYyLApgDiyEUKDc7CCh/7zQDEinDEZHlUpHleLuDczQDAtDIIRBoNqBSMrF/tYRD/sQ8O4QhwBO/8IBEAOREA8QH9Mj1NaAARcxEjfvASExAiexEgvyH2cMepbG5DYx9EavqlBPBUkxI0wxjfToEb6gFZNAI2EABlbgFbNse4rOFr8M+HAxrnKRF1OSvVbSF9ERHYMRJvHhLmDhS47RMcYNz8RN3MYtCgvscrJQc6rgCw9hdHxACMoAKbdRG9EQDLJupNgQ/SKBMTDBDVRBGODQJZeE/oiod3iD4MqiDuWxHd1RLOdxN5ABEA0w8QYQHxNPGJSoPvoRIBvRERmREiUREgkyLw8yt0alx0ZOQf8+Tx840Rkc5CHrCA2EzuWIriKXwrZm8Ac4cgVC4BVvLzG/phZYhMze6iSrgzP36Y92USV1kSzSAhiPEAm3aRhpkpKOUbEgatx4cvqqEBpBw01uMzOEcijNIAuEYAjMIBvLkA/WkA0hDAzSEDYwoTQwIRK6Mg7Pgoiic+A4pcTwT+/msCxhBx70MA+zs4CghR53Y5iCCRfYEh/lQgFvC/Po8iD/0T0fUS8LMj7l8z2nqRCKJhM90OQGMx8QsRDWQA8AVA4SkxVoruicTEWyJ8tygAhecTIpcwm0Zw9WrxiWzSQ78zNzJyVHUyVL0zRjMh+HsRUUyKEAzIK6cBmZEe3/aPOUWLSTvFBM1G50spEowXA4b/RGA2F0/CAQ3MB0FsE2ImE5ccMbZkZm7PBDpXMflpQ60/E6u9M7rXMsvVLvYkE30LI6ZSgQ1VItUUoYIoEfw9QSDZJM33MvJZEg07RMz3Q9m+m4jsc/PGFdxoEc9GEedKEOtgcGxcsxiQ4pJsLnGFRQQ4BQKzMkjcIk2ShDE25Re/EHV0o0p40lBeklT7OnrE4Y3WVEWyGh1E6xsqAL084FNkhU78xFe3JFy22ivDChwCBxVEk4xxBHKYaVTMf8SEqBCCcS3GA5jYErs5Q86iFJmXQQizWYjlVKsRP/RstJk5VKnXU7nzVYpzVZ/2PhLLFUtBSPSwdRhgBFGFThDvYgTMVVTOtyTdl0PtFUTSGQMugzXdlTxqYoDzyBGvKhTnnhEW5NeyxSR4DuRohtCgZVBAYWQlnx1kDEWTDTQjcTJYew2phhf25nXIoQJi2VaUbUFVphEQiBD9LAVWOTJ6Nwg0oAVKWwCoSgVCXqCUE2cb7QGkeHVdnORt2uVl0IF3r0KS3BYm6DV1kAEwIB74w0voaVWLlUaIc2LJUV/6g1/qD1K5eWaQtuvNASLc1RmLb1APehW4XhW71pXO+SLttVbMF2INN1Xc0WXSOw4/YDP1JlFuZhMOdBZ+znEoTNIsDrWixiCvZ2CmbgQf9BAAQwQAReUUJFgvd0jxaBYSRL8iTrykeoDeeIEGKnbqUgdnIhdSV1wlI3t1Y0dTY0dhG+ELGEQEajMFQvyFNBtsHADsCuEXEQJ2YlSHbNr3DY0FUBof0SrQVYAAeM4Q21dCuFddOKdluJ1TSfdlqnE8OS1WmRVFqVVh3LxSQyjXpXxzy7VBqEgWpJodbglU3NNG3h02zPlnzZtOPilbeaiRTqVR964RHo9igANm/VgG+LwG8f9EFpQBaDBWwY8xVQoRYD+PducWHjaHGZjWHL6zMt93KZ4W0cmAjRYXMPUXMH6i5cAYNHdGM59hDWDmSNUghEapNIN3W58Q1wcif/P7aDO9gxWtgO7E1mwXB2Kal217CzhJR3caMbohZJhrd4fxhZp/V5eThqm7RZo1f+2DGIlVaJiTgtkGTKqndjLIxYzzMctBctVUGLVYHinIhczfV72zV8y5eMyzeMJc+ZGKEX2GMX3kOJ6Hdv4WkO5HdvV/GsoGspgk3ZcHHpCBh+ClhxD9ecEPcTahFR54qBIdgaGjgn1IHqJPg0IXmvzoMa+iaDNRh0adYHDsEHwEAIXPUagRM4VYkoi3KTXjULRmeFrTFAAMSVXZnb2nAoafeGV0lmbxaHc4AVvKE8k1d5s/LwsFYQ1ZJJifiImRZYkfaYlzgslRgs7ZBKmRk6/4+3h9+Haq33h3d4ewtU53iFDb4YTc90bMdYXcvYnMsWfDdOEXhB1kjBBe+o2LhGJLZLFhjNnhmNnnrij/eZnxMY2vqZGFLBWOiHoAtabS6k6PR4jrSFkR9ZLioYkdqsFVzBGYZhFVrBETZ1YzfWRjtaVg9BVsFgk1nWY1W4RhnHMWAZv1oFQCDhr2q4S2rW3lrIDbTALwSll335aE+MeAXRp7O2mIP1ObdTqKeZK40YmZ12OoMXSZ9YmoW3qYWXaNHCmtsK55LPaMMTGbS4QCPBBV8QjMk5bZ2AXWVwC87ZrMsXCdD2jCewDjzQP7+IMbksn73MroPCqsvrn/15r/8xNH5SQqBxsHwKWq2ITY7l2X8ZIjMVmq75iIHtbhgxeBxcYRUcAUgxGLPDb1Y5eJRNGGXxhO1Ce6VR+pVj2aAMSuS47bRXu0vuJbRDO+4uxg8aiAXWgBWu8rWId6qFeZiLNqkbGS58WDqLtEiVVC0U5ZffgTqDmLmR9aml2biZtH9vIX6sNrepUxqymJunzCRcMD7IVqzRlazPuqzJO7jSmnzNWwbFeS/FuAFVR4/v+YEfGK/vWq/r+58b169hBq7uCaDdB2xKhLB/Lp6rhbrECAVRURVKAaooexgweGMpG4Mtezg/Gkd505PdwAdW6LXtDb9aGUBwJbVZGrVHnLX/CauwdhUcTccNaPsLcAOIifnEdFqY0UO3n9hDgbnEbvyog/lDkduoo7q5h3zTjJpT6DCopTOwwdOqz3HGr5hqt5u7P+IRwjWs15StxXe80XvL07uMtRzMz3UPGKEorNKeI7ae2igA9dm+8/tC99u/4zzN+cgnDpf3vudf7eiwb8RE9tyJQkFKMPjBXWGjXcERIJwQPlqUQTobRToLfECEc3e1u43SU5rEXcVAGgFXPOHEJ90wCuOwRqr5GogDvqAPdMHT2rJ4nxx4idfGoxvHg7tSjVXGjzw6V32on7mpYZ3XaTzJo9MUxKttFtlqI/cPr7lAuTsUlx26yrWcsby8/8OcvLuc2rkcCq7dy639y9WbDGLwEQSinqMMzdd8ztMLv7mjB+Fczte93LuMMy23R9Kofw80ocmKyj7ETx2CEQjiFybboldhESz70CubwiucY0c5C4bgG/dtEnL1vkq8D97D0lka0zPd4lX74j+c0uWuMEh9B05d1YHYHrQ5aGEL13m61rNyaGc9xp1bLXubSZ0TqpHa1ne7129+H4J9eokdDs0xu6vXGKAl2Zl92b8A84we6aUdraNd27O92s/2Ape+y2PQ2xUh2PAZr9Vc63mC3Lv+3PP7reaqUVeG3b2+3RMZ7d9d7aEhzXUhjXShFKTEouce4DfWEQ5dY29U0f/DUJRJh+0QoyYxfkBY5dIr/kAyHkEyfuMjzIJUoAMEAw7WN+RTHqm71ce19rpT/pFV3sd/Wkmvl+aDHOdHn9elW+ePQYZwTnulvG4LdOgHgYlgP0C9K+mfnenPW+qfvul335zH+fbTGn2CDee6nuvNvuwX1cySn7+Nn/nPnqEft/idnxngvuRMju432u4p/KM5eygRDfCXEOIpXeIpvfBXm9NfDUImXSoXn/FVAwUgYF6gADe0YfJpfeCSudWXe4eHFy0Agh8/ewQLtjvYrdu9hQL59WsIkWHEiN7uebv4LiPDjQsNcvwIMuS+kST5pTJVqdIta8d0WWOJCpPMmaz/atZMOUiPzi9qtKBBw5OMUKFOuBg9SiXpFaVMkTp9ugVqVChLq1K12jSr0jFapW4BClbQo1EtoXEzi3ab2mdrsbl925ZtM7jlltm9i5du3bl89fqtFhew4MF1X54ljFjuYGYuhfGiNm7csGvXVlnORCjzos2tCJnhQ4gPaNGiA/05hHrSqVCSIDV6zSi27Dx3YtNW9EiRn9mwG+EepciTIeCjhMPugxy5m+XLe7RQoYEDBxx9cGnDhx1fvIbbPS4MBz58OI4K4YFHJi09OHjcDaIrr7Bhv4cTJdZvX7GjeZEF+fu/31BMn6iEni8GsoJSJaaYYlMwN+Wkxxd4yKGH/08/fTFUhl5htWGHU3HY1YchcjXiiGEJQlaBiq0oTmAsupgXXTHOKONeML6YWI46LibMNN1oo01kkllmi2WLxKFZkq240llmpPFxGmqnrOZab7LZVhsjd2SpyG268QaccGFqcuVstTG33HMZQMCBBCzAgYs72WHXXZ3s6TeeeODJs1F4KppFEEUHsRefQ/MdSh+dfC4KIJ53/sdfe5GWtI8slhIojE0HokJLTcg4iCCEFKIxB08WYogqqh6WyKqIILp6FROytkqrVWTsIcgnqqCnnou+pnfjXzbSWGNfwa5o7GFp7YisSz72EqQ++kxGZJGOZGbGZpo5skqTmqEGpf9qVFZpiGxW2qbbHZfk8ZuWZcY2CnCKhFmumW2ceYcbUWgQAQQS/MvCF9bNk52dBnun557b+fknOvbUl1CdAiFKsaITMUqpdxr3N2nGHmccb0wE3uJpgw4eAypKEUpYak9qqJGqqrAWNfOqNL96c6w67xxiEzYTJUaGuCaCyjGGLXts0nYNG03TTj9dbLJRT82s1Msy82yQ+VBbbZGbmZGtZq044m1ooU05JWusWcm2vV5uyS5y786rW7xzI5cvcl6sOQECfq8g8HXZyXkwQgYnjPh5KBv9sMX6yVcxxfd9VN/GHH+McccRWRoT0buWfLIxKS+IiU5znP7yqRcCVXP/6z+/znPPtUoF1oW4stIj0oG16DTvvsMl9dJMC0+10sVXzZdhuujyWGT6DFlk9KtcCzZnrazCZCveTnJ22qGQ0vZrVR5HG9z4xv2ucXWvX/6WcDC3t9/yc/BFJNkQ3A3hhQ+aeP/gTcOSA6ljO46T2JwiV8COXU5zjcKcxziHCs+pYoKgE91NZJITmGEodVrYYFBchzPY5SyEsfMZCZNCoifQ6idAwdUlfHG0tvyOLjM0HvCgdrypEctYixsMjQTDvPsNaVrS49oiRKOt63VLe4QQhWrE5cS1Wck4rgEf+eRWPiymzzdXUh8W0dQHL7BAfn/bQiTiBMA0vicea1QH/zgCGDr06CkhbYQPHA20Ro8ximL+6GOiJpenejzKgSRZYAMJyR1PxIsUPcqUKmLyQtFZcCalM93LeqI61n0FhCfkZAk/CcpOug4sGMpJ0WK4u9+p8lc4ymErkZWMWOIwLz3sy4xkCZhdQIYcvOSlLSpTxGuJ7XrZawUU0SaK71HRXK8hhTM94Rozma8Pl1gXl9jXpWxyMW5w6CZzIjAAMrqJC4ygIAUNlCkDLQ6CnPKUevhXuPdA40CMI+Sc/IgoQCruIoEqpCHZiMiATmSRP/JHN0jxSAXVJBIvZEU1qymIQWyQgy77iU+UgNEOjnCjsuNoKDU6q4+GdHZY6aDtxP9CFlT6ZZUsZeXwXmnDWUoSl7Sc6TNkicvmUcYW5Chi9CpzRNAMU3vIjGIyoXkcRUJzqUx915asqS51ZXOqVKVqHpijtzaJEwMk2MLQcoOTlDx0rA+F5K6sEbGD2QmO7mxH5kqSHQTq06aD8tg/J3fIi81Cl33Uh0EZOlZTPJSSlTSVTy55USkoFqM48KhjHyvSyJZ0pCakLGQ3iaFCjAWGvZJhSzvr0tBaLaYypWlNTWuX5U0jMtfo5T966dPNjAaJRC1qFJfZzKbqVprmc0O+1lXV4HLzXm1IU9/IeAAJiIAFzJ1CGJzrXMT2RA+5ukTIOBUyOdIxj4f71E1OacD/PcrVcYVSnCTzc1eBZiyvQJJWPvLxvG5EAqWADWzpJHrJHET3uV1YbA7+a4NQkrSjkhXlgF31BRdyVne8u4jvgAXhz4p2wrAs7Q4vXA3mOYMyvYStT12xiM/wQcSigIWJYVHUZepGt0wl12x8W004XMK3WhTucLvpTS+gALnJxQAHWLDYIgh5yDPQ734jWlaRWddShuGuO9b6KZExCD2Fwhjk5vRWPHlDLsFIBjfYkV71itkh7n3ve/uxiy1Vwr4PFdXLcpA66C42o1TBkIA9WeA8G7h1mmTdHjarUgm3CFi9UxaFU0la1NbytDVlDLSG1OGe+lSYTxLNiVGczFmo/zipTH3mprfkWzWLpZvusqr5ztAGVOdYBxmQ3wHCCTCvujkM+aU1qdQwKuoiOawKxSNa69hGmCSoaHKUR1qvjB39ZZlhcfxGXccMbfnAF77Pcy8u2NBBlCbZzXDG5AfXAO5wF0UHdyawns99YKtYoSpC+bMqAi3oeB/a0PSmd4Wfpuh857QXkXHFMHzatel9DYl8ODEyURO+2OR2t1h0H3BDjQmHT3PidVA1qqOAAn8hV7kBKyfJaEE6TvAaJ6bLdclJNQixyoIxLK/jGw0kskFwSrt75I6cqnw4jKSn2QeJNqXyKhCtTVta7s3GF5iLBplbt8347UKCIyqIOkjdff/g1kENXsCCAF926+juemUNrEkFw/vBZI+wZ9dijrOH1t51eSm+Gc1l1DImG5CB3mUygfe8uyITjhCmiAlh8GS2xg924Cb6mJnwPkh8xtN0F8XLZ/EzsAHjFfgXj7kKh0ick3O1aGfnIfkIXuNKJ3S45HSJ1k50vuQ96Hh5qFKuqf+l1cn74983ds5zBv4c6A2BlpnfS3RpXfu/OZCDxyPBUMXbbg1wiLrUwa2Fq9MgBD8mQQ3KzXWvW3bPotTorQqR0jfWW97jT3v5z8/2e89SMHDPy9yd4e/L9D3vfOdW/R0RByQN08SCf03hzSd17CJVh8cbWOI+MgaAcNMl7gP/gBb3BCegVTyGAD8GB+/GeZ+HgdilgQICep2QCHsgB/uFctT1CdilC2VhGK9XXdaFDLnza7MHUMdme7d3eyeTC11mDOi1QADlcxAxC9nwe8GnD+SQD7vACGugBDnwBWpWG3VgWBclK0twBEHAAitAfT7mY8p1fdmHZ9qHfeYGInRwO2M3aOSHfmd4hjAVPHiRb8sDhNCDd9wyf3x3f9eif4ugPbU1eIZAG5PHBn8IiFMXgArIW92UgI/XgA6YApWnAMgFa5jnCSdIT51HiZW4gZ2AiQpFbDFHereGaySYeirCCiSndLvSGC8oe4izH7Z3U3EkOmBmOQfDeyThCUIE/3xC+DzaYIRfgANQ2Is/IH1YJ4wkQIzEKB1Z+ADJiAFIIEJe6IxgqBV+9ggumBY0aIZoeI1Ks04GMk8+BHfdWGLOIBn0F4d9Z47niH/Wk4e8kEyN8H9+OAZsYBSBGIiGZ48JGGq1YYgMaIiqxhUmcAESYACvRpAFyVVrEInqVAwLuZCd8nGWcoEeqBNJpyCa+HkDggh6YHo6YUol41CiAnu14GtNRpJNJh6CxA7iF0sOyQqveJIoGWaS8jHB8Ya3iIv+0AuQcHTSRwLH2AHFaAJBOQLG2AEYYHnJSJAdwIxc+IzQuH1fx33tNhaoZHbZaH5XeRbrgI2itY1duWhfuf84ewUZXEOOdGh/5Xgt17KOaQMIhSePN/OWzEePhud4h5iIgoiXkjcGN7ABlleQBfCX4zQKksiQhUkMh0mJkyggiVBrp0MJJThzn0cJGbmRJEhJGfSJmvg5wsCZwvAn74Q4uEc6DgmaMBmTkxJ6szAPfUVtREcOz1OEOnZ1WiWQydgBGYCbuXmbjIiUBtlVzdiUwTk737dyVWmNVomVx5mVgoYj2wiREwSWcbdos/Bo/xY95IiOeIc9aZmH/NeOdqCXXxcFZECPgniP/LiP6dmPkSd5fImUA5mM4RSYIUAGg6mQhnmDiCmS9/lxAzIhlakgCrkpmDCZmIk6pYKZqeP/QpFpTqJYS2Y3STKRCjdYmvCkex8ReqNgi60ZfJHRC4YgeTDQl6/2AARgmxPAJrvJm72JlA+wAU/5hTEKlSO1bktpozB6YFLpEoOxnD2qnMZZhsjJSvQEHIFVMtzYF2D5g0NURHkXB3JIf0zCGb9gYoC3GoT3h+NpQir0BfT4hxN3Y+q5njgGiBfnniw6kGkqAGt6ACYqAvXJn/iJn3HanydRgpl4pxoIkduYiYkgByzEX881XZaZZA1iMsegFseZDAhipzMnfqpomv7RH2DFCLuwmsB3DUQXGc7Ajnx4BovYpqGaXArQNyhaqmiKlFzFjFrKlDLqlDc6WV1xo1yq/xVrQF2DSZVb+aNBCqTpdyMGMkFjFXXVdKTReTKqoEus1WHW0nf5N3/c4gp9txmXljaHgKVvuaVjwKpzSWr3EqagRlxkGgXj6gVnUAUPGJBoqqaAyaavxgFoUE49JKfzWph0qpgcOCA4MWVGszwwhxNiqJFvFl1fpa8SGgue0kMRJg0OEnIiWZL+8ziW0yWhBwmWyqHutansaK1P8AElaqIfy66A6ZfwmaohAANb2KWtqrIzSlmwiqMvOyJ1MIa5KqS7SkPMGXfB+lBMiFKmKKBeSQq8wFocJmmWgX9xYAbO6gjRKkyZQa2CB560ejO0Go9fCgdX5a3tM6ZXVa7kGv8F5PYEX3sCrdabf7muIbuM9vmVOFivsWSvbuucltg5eHBJOhGgy9OZmwJReyAGckYhOZFyBkuaD5oO4ndTsTBsKwEoj6pzGLGKj2uaYJUbjBC0lyokm4ppbRkFoGq2nTuq/1IBGxCUdSZuXeiql+WyWQGzqVurC8oYurqrsWuVSQqsO8uzSGafjPGzx0oKY8lTPOVLRhsHQzAESau0eBgasGClmGatbcCqHlW1VkumXfu8OBAEPEBuO6C92SsD2LuIfQOyZxuy7SoBShBJa6tvOGVabbufEVkJiPAyR0ZdJoi3kphQgjAHz+VcdkugC8KSJCM6aCEeC0sL+noLKKj/sI0bSJA7KGAlarXxPUbVjpIQtTJAth8LsuHrNxYAusSIsrb6hxoinCwrq8zIuiS8ulkBsJ0wkrLrwi/cUjqkt7YLgBmKtwK6p6rQu63VU8FbJJkwvMRbvPmHJNqiGr9QCt7ZvM8btlIRBWXqBSm7vSdAxUVpxRVAxVmcxRkwtiNrouLbrmxavvFqrGyovmcMt+u0kheIgaRYcoALVvSrC/dLIS8zIRn5mP57sAjbNNYYZfnqv4iKNAkMi/wDk5K7JV+gBSbMFDfQxE+AvSNKAB8bAGH8uab6kyYQYBlSB7ixB2Tgfaf7qiicwqQsO1IZfoxrnI0Lw2rHlSjzXVDF/7NRVRxzPMebR0GR8AvA+7vXCcRCTLxEfIeagWIoZq1RWxTjOa5IAbZGQa5c6hw4AB1tcqqWZ6qnSqrHJapfDMZhjAE5cAeeSbvoi8blzJDNEDqJ+ZAN+V3YNXIqFy/0VEkHmpmT2bAHK8jKcgsokccTGsAq8ooVmpKF60bpgMiCgCFWQAQiGgIfsAEX0NApcAMp8AEWsM2BKbITELrFeHUm5UKbNQp8G8qlvLKjbMopvHzgJwwFzatBmhGtLKQ5GzKXoCU1HHpghVDmFM8ho8tDGLzkGMRD4APBnC36Z2lQdAhpcK7jpsyP7ATN3NQ60ALSrAIogAIdUM1e7Llb3f/N5MsC4FfGytB+ZkzWYk2vbRu3iwnIvTY6lPCf+5uZBFqRNdFlyzK3eVzXONKjA/2ooBdR0DeFQRkCHNzBD62ul6zRu+nBHd1CPVu7Ik0UJ13Skq26JC07J4IiTfbCLw3T88ZlNlGkWvIINTysY8HTp71Iu2ydP8x3SCvEQz3USFs9sxUIT5TUYbu9zsHUVa0CUC3VVI0DVaxxG+zFrja+xw3G8tmumCeJ6pe+z13WZ+2Vm2ITeaopBnKYJ5GR9IzHeTzX+YwyKoMIbJ3X/1yNhnsW+Rp6nwzKScCTWEjYIwu6ia3YmQxgGVVKKLWfkngJfwpSlE3ZKXTClR2rA97/UVYQFnrAwpqtnKzs4C7sFlUZNQ85VlPlPpqF4eWE2jwdCdpAls1KxEMNzEQ926IxCZZgGlGrvU+w4txr1Vbt4tKsAcKNzRIYsja+1ZUMxoKJpGE91j8e3Wj9kBsot4Z6gy3JsG6dv5V5x4iwr94l3o/Jkos2yGkhVuvN3go9fT0Z3y3qopmsxSfA0TkQBBfV2GsWis2wPCFtUaIMlSrEyCnk1CYN4CFVo37mbsygysfJ2Z3tyscCy0VK06Y22lFF06jdLrGh2tMD4vk34kJdvGADNqVxGpWu1Lk9xVY9th+Qxb0d3ME949FR4zhuyciN3O2q3D1WP585zkDu6kHe/2X5ibgNa93/y6ieJ+sxR5n0HNcsGeV67IrgjXsoc+U4YVj/xeVGSdhY+AJa99SfzlzXm1FyYKtDE8jCjgyqINJ13kkCbqNSa+ClHO62QpwM3tIPju7nfpUWtlCCPuiEPrlkQjfyEhs0/QvT4grCrO+SLsSSDjZlAPBgAAZt+QaXXgK8rem6mZtUbNWhXpQQMNykHsbKneqAmaYXPwClrlxmBEOt/uoWBt2FOeshV7DAnusgN/KEtaecuOR1qwf9HOUZKROHOs79ichNp+XTh4UrQAM9vwQo9Hx2BoUW8rf8m+Y8ggqa5ObQu6pwPuclXODjvn0pXZw+mu5aifUQ7v9K/RkTdBPvtlFN6zMb706p9z4Mm6Hv++7vxesDZQAGbi/wYLAcWHCuL77pCl/fGoCb/ALxEC8/FZ/xgX/cqN65pS74PaYF52tLzv3xNkXW62yncv2YBYrXR/6QKY8S/ykHqMdkoqPdBUq3dFvPoN/kJp/G+IoTWB4h0YfsRdZY4UZquXHh7B1upLfCRx8XO9ffS0/CTv/0vz+rUo/SmyR2uZr1x+/nGLZO7jzvd+P8YG8bv9BTk1AGpmE2oFE9/w7wZuAD3e8DYPD9btD9buACz4ECeo/VEH8BbML+6t/37w8BCUDxgD/4nes3bJrcNz4dit/4ABHtWbOBBA0uO3b/EKGyZMUc5oIITGIsUxUpXcR4MdXGWMQefoRYUSSiOUWMmAxD5xEqVqNksQoWE5WpQYhsqlGDR8/OOTnn7NRIqeLElhxRVXqE9JIgpl++4FSSI4eWNXceMVJ0KelWrky9JtoTNijLhtXKnYXGLa00a20fodkCRa4TunWbULmbV+9evnif/N0B+K/fvnmRHC7MJDFfHIrnxq26slpbcWq/XcaceZ1mztgqexZYMPRohbdqnXaZdZQirK1dN2LdCDbWPIpq1x6n75elP5Z8/w5kxkygMmXAHD9uHIwP5sxduCgRHYUGDRwgOJiQPTv26929dx8QXrwA8uXNH0CfPn14//TiDbw/X0C+fAlBFPlCJpr0QoX89fsviyEBQYqIopEywmgoiQj8yMCRSioCBBBmkAINQWYiy7QCU0EKo518wglEnTCpCEOyOtxqkC920kKKCqvCSisZV5oxRRQ7BCXHTmQxC63P2PKmLWtwIaUOqux6LMnF+vorDVEAEWwwLghjDInBEMPSMS235JJLMsSShTLLOuNss85C+3E/NRvSMLXVXIsNTjlpsyqScfLZLRDgJNETDOWQ8+G4QJsjFLoWKKiuu+0U0G7RBMBbINLx4puU0vXcwxRTARCY7wAJcngEv/8AJLVU/gIc0CMDO3KQJgQ1emXBj1KVqVWL1DipQv89KsEQE6FMgSkmYWutxMOecEX2J0pagqkaX1L0tSk01NBCjgsjWU1GVC7ZtkStuvWVxE90HJcYH8nErK0i47qCSneXtJLKJ+y4hhw7onw3yyeyjDffLv/VkqqwOpkMHIMPRjfhNNcEbdQ234wz4jlZ64O2iu0chxc+S/ENED8+fuO4N9zAQggXsgj0DUKZi84DRDVQ9AFHJYAAgewexVnSSuOztLz2OAUaPk3jqy/UhBgetT+GGZRIpFgdRNCUTRQUVmk2CywQ3E62Ps2X03y9iNcMq05IQ4oo0SlEnPD4VVQUk2KKRQtZKqqob03s1SinMVQGLXXKUScdcwQPHOH/abIhhYx2kfR3ySmlbOUfZ87A90p+L8ccYC11+BeugZkREmGFFd4m6aUfcjO1iVe3zRBPZhnHmVNEoV0SSEDuY+Q2sHChCi+ewwIL5kx2wQfoXEY0Zk61M+DmBJ6H/nkGnt+Z554xDRp7oTuloQ5RBRrQdFOxMXWipl/Re6NN1k8wR48EtBrVYds0DT/7X3Iob7rHJvuYr4tF27Fysqut3agScdODhTDhElUwq258o8X+uhYRB/bNbwgr3MHCgYvD7QIOVtAcvJjUpGtcQxSVs1yVVJg5EbZrWl/iVegINzrSna4/ZXOTxFjXOh7OIhux40XtZAOy3e2uCj1AYhKf/yME4j3HA8j7zvKcFz34UJF6AgCA9Xx2Pfpsb3vlEdoDVkAGVeTHhuNbU6o4wr71oU8kbIQVRNB4qv7Jr2zvY5rZyJWKZs0vghy6SYjkYC2kfCJFYSFgAxVZwWA1UkNea8Yjj3YudGQwg/mJxCUYUYcvgDCELSRMG1ohishd44goBCULP6kkyNBBEEaToZnKJMs0SWNhZySI116iOjhpkocVu40hWFMIRZCCF9RwBjWC+KQh1saIUUgi5wKDRA8Y73iIokCkIjUBKTLKmxKwYjgNkMUAaLFTl8qeAtLZqS/Wx3vGgCf8cDlHYpwtR3Bs4xvZ6L739Sh+dLQjHvPox/8IBnBEcvQjm8b1oTAUsiuI5FUZ8yOq+dXRn5PskSUDV8l0WKMaM6lJArUwUn0tbpWPk1cervGPErYiDadEpSpTCcovhUUTBcsgDWtZOp4uDXwBQk0OWfeI21glmLPoBTKVWTtD2MGpRfSCU1qgAqo2RgfUfOITETU9bU7Rm1Z8jxWnB58scvGc2mvnF+HzqXeKz63lqyeH8IlPqeHzaRbs6T8DmlC+8vVs7aMf3/L3Pxt1KKQXwo8wkKHYicbzIGu5aI9CBzjRyaKAclAbtUjqSZN2VpqOSaG8zrDSf/yjFaO0A0xTeAMRyvSkLvRcIcIUy1nW8K2OvdouNbHbrOj/sKi/rQNrjonMXtDOE011ah7aAAep6qAFjUGBDKrqxOhgs6vpBKc4xYmdL5oVrV5UaxhZ0NafMsSneo1rXYMy1zbuM1YOKRVa4LrXgdY3grQgiq0KGFQDGjaRuvBoQnTRWH+OSYY4RRgznLW1RAwyRFOAcBgkvNksebakKJUSYURRWg6T4xouVe0KZ/raxY0UDa4MFW1ru1MW45a+Qd3WLy12hzzQ2DY1xnExs6HUZYZCmMg1Il2gO2TnZlUFiGpAVxeA3a9qF3oMgHIEHMCeLX53neDtLgHew9bvmbe89ESIrNzoIbTZxMwZ4YR7BWqQvIL5xX1lEEFXlbccgcUm//2F206MNuCj9VmyB76kkLzWiUKAxcESDpEWNKtZCiuGs/8KLZb+coMzOOMf5ODwpUF8pX0dhrUjXmXnWhkqjhpYpy0+40u0RtSk9HaTRsWxUYOrCVHwOIieOG5ylcvcqRJZutGVjnWXbGV1hpV6xjY2lLeqsyteuYtNLraV58PlLs+zNMC4JxzLTOb1ppl9Q/FPm2/rMDir6r5YQ7d+tTZICBf2kHMTMJ8hi2CNBljVhGbohKeFaH7jisIgfDSJ37WDQ9Qr06V1xb1Q2K+9uDbUAW/XHmKYU1pWHF3idnEyCsKmURA6KTQuhKxFDvJY73bHxKUdcpG7617joAY4iP9uzH8t7GGj1cnIfk+UdX5dZ0M72j8/axhNQN4vz3EhTdM2Sdi2dJ0gYp9qNvq4AVrHWp3b6unem94+QRKTcMWhhp5WJXyhrskouByga8tGSz3oDvFk3/oWw9vjPndFd2GzSmj05qzawidUoRWYPrhpKRfpfjnc8FwiAhHGUFNiol10p7aMWdJox6J8ZeSXF3kfQqHUbNx65btmgxN44PIT2ID0Mgc2zK7Tc5+3/sk7jzJ3cR4e1wM96LRnFAe0cIlqI+2GUGMfSWyiE+KfOZ9U4498G7Z85s+XVmpk1dOiP/30ufETRyGJhA1oIz2/xOxoB3/oFAxSQ4s0sy+ku4n/6Z4su+e9MSTtUqf3sq/BpOHvgSfHIQLThBt8mv7yP7yHs5LFGwMrUJzFSzExmaEgsS3JI7c7qhUZ8QrMu4NXyrw82DyUCwVca51d67TTQ71foyrV4yYmq70pm73Xc4DYk5Taq73bmzYJkIAOgAJG6L2oCzO5Srr2cS/pk5U5Oodbar7nW7OrmTN1q74kBKQPeZvCAouIKrvwUzBdYrCdcDvzWz+5y8L1g7v3WwL4g7RI+78miZzAc6n9a60AfC3FizjZcrzHSxdTizzxCSiYEImm2IOqsEAag4OR60May8Cl8rHPCz3OkQHTQ0TTC8HpUD1iu7kURDbZ066gya5K/+w5dppBKOA9Myq607En9vq2HvzBcGszIRxCIpwVWkHCI6Q+JWw7PDugRHAol5A3KqzCD0kgK0S/XYQLLUy/X/w39zupMSShwLsG/cswhgvA0VPDJ2BDvCi0UXjDcGBAIInDeYusa6sfI5TAFVGRNQDHqqiDP7y8RvAhakAcUmgmDzRE0rOB0oNHEYwuFgAPR8S9sBqr5slHFFxBn/OqF7S9oJPBGcQBG9y4mDivHOQQ9fo2JaSIUSTFnjJFVCsvgUqoVXTIrNO6OoNFWdyvHQHJrXvCXCTJQZIbXtxC9evF9puCu2s/YVTGTks8YhSMQwC8TDvDSUtGVWLGnvTJT/96xhJDMQCDwwZ8QAoaljvEBEFwinBcEadgLkFwg5HzhKRCx1ngwNsoxCBwx0RcxBHMgNW7xJ97RHXiKunhR+ixRIB0RBnkABwwmk70ROvTSB/Mr7uKyFL8DObTSzqCSDw6n4zESCTsyK+7rJHcCUSig8U0STlYg15EyZSUzLpzSSXwwsv0NEnjNBjIi7/wu5ssLXIghCPyP2cEQL34STUsKSLgLM+RRmqETcjLxtxCSrsRl0poytzMTeaiypPjBVxrBDu4sSkZPUWcR+OUR0aEAOuQtnu8ubTEuWH7RxMMSIF0yxq8wYRkRbs0n+7sCHnSj75sGIokn6OzSFW8y1b/3E7vvDqPHMkn9IqQi0XELD9d3Ik1OMnIRIOXVD+7W7SWrEyYBEqa3IEqWATQvLQTKlA09D/UTM3MVE1nbE0yqApVULFrlMO02KvpC4mN+JZoyc1ehIxBeKU+qMA7QKqrzEpn2oKujMd4TM7oCssSvETnPLZILEuArE4Y9BSCvA9OREiEOEWG6FAOBUwxO08hlcjxRDXyJNIkRVL2lFIjzaPye8/5lEX6rE/FdKX7dDD97M8wHSn+ZMmXhFDMYVCG4zTPLMNMO8YQW63MeVBHcwxm3JwxCEqA+5I9u9AMnTe/lKAilcCakJaRern2+4I7sJgU5QWsnI0aYwMX7Uqv/xwyGbWO7KrRHMVRTX1BHqWPDrCP7OTL8nxSVjG3H+zOJGUznhoc8pzINrNIVCWQKD1SJI2zW+hSV7pS+LzSXVFMRGDMYB0kMBVTMjXW9kuCL1wCzFRWgOEBxgCMk/k70My/aBLDLplTw3vGCR2YlWAFxaKtyRITcmMFUz03D9UKr2CuuHARFpAKqigmDmRU4LwxXnu5e3W5rmzH4hzB6wAndILEgOVUHa3RTQmjCoBLiQIGHKTNWo1VKCWNORRPFltSUn3Yi5VViKWvZAhWQzO0QrvSLi0/OgBWkhVWxyTWMbWCY+0CF8E7/kzWZs1XrnS4MWStabI/Y5wEF0hTEf/L1hDSzAqLODJAPxJ9JQbKD2E4MALzM/8JVG/hlnQ90U6KCnfdAjaI19dJUWrYwEfNgzWAgkkV231VAZg7gQzggIGUAPX4megEK7fdx+2i0bUs2IPFzj4DT3I7VYzV2Lyt2CAcVYqF1b4l3PDJOCK0CcaURZDdVcQ02ZM92ZRlWZZ92SOwXJqVWTtlRgD0v9Kcph74zIMjh1Nog0mLF5782dS9sCN5TJV12QEiUbq5n9lt2vppE7xhhUFlSnCMC4ljBK31BFE4ps6jV0glg7H1tc9qx+lI238FWIF1W+gl2B0tJ4P1mUzcRFSxob3lTnOtLy/72/AN3Ir93sLNW+f/c1z59FjFhdz2FVaihcxipVy7i9nKVdb7xVyZ2oHTNYzP7QH7Iy3AIwdYSIOeddC7eNYzVYy9C0DOOsCVdF1Em5afIFRu2SXaveAHYqBM8qU5UUdSCIVZEGFeGF5H/bE7CD1Dxdzk3dzlPVu1ZVvpHdgcHUjqTQBKwd6mpSf1TEL8Kl81EV/BJV9ULLepY1iCWMz1FdmOFVYubeIvWczJtN8pXtkqpuJlvdwsltktUTzT3L9P89zPbdPQNKE4xdYzXWHDOGNVemArVskHA1DY7VYLdiA3YYnUwRYQ1gUQ1mMR7uOtbdTiXdd9JeRnRcO/qKpDnNG5fd5kk+G33bLp/2Wn2zPYDWADl8i4NApMuqy+jO1bIGZSIR5c8z3fhCwVJm7isCiEJHbfEzuxKD4xF5JfN77i+sU7W8ZfBebiL+bMzWSt0gzd0BzgwUtD1TVmL8lNWo7f85PgnkhMplgJpbBgVSCFPabmah7hXdBmXcAFYSgFP56Fw1HRdZSquVDema0c51JODugAf8UyGnVkfXxkSQ7IKlsrEvAeUeWP9JQ+o5BSIiZS3xPlIDZPvi3lIz4V91Vok2xfMaCDyFTmWpboiQaC/A04L/7l/tPo/hvDaTqEVnCFccC0YzREny1kFp5TM3aMA6RaMWW0yGzJtTlaC1Ysbt5mpfXmmwZnEf/+Zp6utc4zYawYZFbiHHbxTN8ZvKqijgxY6g4ArwfY1HmeYWeLYes9gO6RKDo0tx72XlI2XFB+VfEtaIA+aPSyo2ZY6LRmTKKF37ebZYqGay3G3MvV3AX24l7W6AMGDKROAz+4v1O41ipZ4Qf9ybz+WZaWZZfeRZP0CqTlZpyG7MjOaWPa6Z7m6eFNx0dN4SRxiriIAjY4g9AW7SBT56U2bXiOXkieakmeDzASumJi2v/gZ+40aLIu6/El6LG2basZUlN5ZciF4ieGZWAk7rfGZfw9brlW7oq+nL+AgQZF4OaOkgIVhXE4IaCt68L+5R0ggoz+QP5j4wcOAjF9ZWj/3i1a3OM9ngacXm+dxmkR9ubHtuz57mkS3rGgXlck+WwvAG04aAPl0rW+phyqOlumLj3qqJkr21GppmdP7ZRPMUitXs+9JZvdfr5S3kvcHuUivm1SlbplGNaiXWgK3cWINnG8YwLkXu7k5sr6Ze4XZ+7+de5Jw2vU7GICDYwzUDi9a+GT9knDZq0U2F8g1+WAQezcvIo81lrJbu/4zuldkG+eFoY/Tm+b7mNtvu/f1Oxyvosv4G///m+QaSYBJ82zPVsNYMSwnOQFZ3CypFuq7hkIZyzT2equ/mojprqFlcu8DGXxxPMLF2iz5o9XfqH3JfG2LvETR1b7DVDljgoV/4fxSJf0w1C80uzu6IZuAsUXu8Z0zNFuQ95fzlQ8UUfjOaVQLqgD2cC1ndbmaWhyV4fvWI9yycbm9K7sJ1/vHesFKD8u29jsuQDtorKDIWoEPgnOp1KBE1BqNH8ZSURB6W1zSmy9oXlnuJzzIaVVC6+os/4yiNTw3v7zDh/VhGRNV35o1nxoEYXo4lb0Rof0H5hreJf0isbXjb4cIT9Nw67xTQ9sOf10GOjlFOBoIj/gLQk9FG3UhG/vVpd1+G5y93bymm74+N5AXM9yKN9yow72PNC1Y+f4DfQDSTgFQCDNHiiB6UhzSYT2aG/ws7LqCYACaSQwh/FkbbfwigTfb//38O0la95WUr1Kd5REdMlt91qm9BWX96RXenqPgXofvef2NO7e7p4F4/+zEu7mtNVVIR/PboDPaCKva/gbg+AiYRK+bFaP9WyGcve2bKWl8olneKDGeBP92s72ch3n+I8JzjE3Ij+YnZfqayzYATRXTpVfeZb3OQePD92LhKTV6o21eVXtdj3X+Z93s08ed3BHCDRQvMUkAjpA9/hd2cQueqO/uxafdHxF+tTPzJmc8Usf+Lye8ZvVyazvdGf9dEoPDHsHe1On0Doghc4r+2loVKRSe4bfZrZ3+4av9Vlv9R1rb9jgQ938w2FvKmIHsihwgs9Og93x+wI++ZNXvRn/fXZjyyLEf/NpTydL4YAvyOrHj/xth7OEVD5rE/RU1F6fB/rPL3eAsEJEjBWCV6wcLKhwIcOGSh5qgShR4ZElFS9iDJIRCMeOHmt8/Ljjxo0nJU+aRJLiBpEnJmE8gVmyZUmXMZswwakzJ5KdPXNq5PFTJ4+UME6uJKlUKNOmSCzypDJG0SxeVk/NqppV69ZdXr+CxSVWmLBSwkhl1ZVWrdlSaMN+DRVJ0Z26X+6yOdMmjyE/dhr1Dex3LxsnOlQg3lElTRUVJxJTOPEYhYMElg0IAIB5M+fOnhV8Bi0awWjSBU6jTq36wAEOa1Qhg7btGe3ay27jzp2sGG9lxH77/w4ODDjx4sGER0uOTXlw38vFPY+ue/n06rqPI++9O7f02batkxk4MCF5h+bPR3wYVP16qBst/oi/PiTI+vRZxpwJ86hRl0phmnSTTUf15J8OUfk3VFROMfgTSQEu1eBTQSwoFRuNiHIVL9lkY1VV04AFIlxljQUWWWaRSNZbKYZFCiN1wXEXF3nxxRdgft0IWB6EsRFFFAfKgIIMGUAwQQYZrITCDjt4kMFloRmgmWZQlmZalVdaOQBrAmzZZQESsHCHLrF5V6Z0ug1n3HbHpdmmcW5yx1xwZ1JXp3Vxytlcdnve2edtApUXKHrupVdoFzikB9JE8BHaXlD22TAfpP+TUiphg0BimimCPnG64HxCyfTgfzeFaumECrKRBym9sKohNdpQ06GGIorYlVdq4bqWriPG5cmLd6zhYxSp1vhXjoLxdcYYPdq0g2QndMABBEcihlgKlUGpGpfZqmZAlt1+u624XkoQBCPCkPmdumjCyW4q78YCp5rd0WmnMnnie2+9a86LnZ54rqtuS4OSMehEUxi66KI4RCqppDk8WqnEE5tasYKdXqxpUy7BIBOBSo3EUsUZ8bRsH7yEEmMUX9QBCS+wxkrNrLxuhWJXJ9rK4ldz5QEsy2zUUZcdigwd2LE7KrvsGAkKqQEH0iKpgWQOPDDBZ9perSW4W4c7rtf/407ABGzp1mZmvrn0O9wra8cr77z76puvnHDnqWbac87tZzJjGNzQUwl3EbjgCWu0sMOHU5y4xCNfCmSCB1YYOVAMtnTUxyQRGLKlSv2EkEstQ8KGfBp9oSo147zaKs0m6pwzzTwDCzSNRQemie2G2D70jko/LqRk0R4ZQQdFVs2Zl1wjH67yx3/tJQdQjK2c2XTyqR0xbMPbtt3+Sj+93t8n92/144O/5ngFnd83VIOz3z577yOuuPyLB3Uq4xZLrjGC+EGIuYCb229TcICEXO7AhBywgAQsoAJfNhQzWWUlQ1hZneteV5fY5SVoithgX3zlq9wNLWlLk0pTnsUC/6kFbwIVoNoDPMO85iUvhjAU17bCNgqymcN7dUOb3eBlilS0i3zN0CGf8iY3dlnvbtwz4p3UZzBEQXFhUogi/OIXsYbNT36bY1j9GKS/yDHFUxPaz1KIALLLRQh/TpiRqkrRiMJAoQYKhMkZFOGyeeTDGb2YIMooOCJegKhWu4AEI34Fh6AdslgcNMQH7RBCEfYuSM8S0gg+cCQiUU2Fm5kh8l64NU9yqXnPi173iCgcWvTwh9oTn7/SFDcdpumIRyQfLZcYMOs4sW/uG9wUC1fFKoIEYlkcZhcpF6RiqjF/nnpJGvHTzC1eTidfqGNhXsCEas6xI2xYlTNSpyE/gv/TRYWEUQYVabTAJKswI7SfDUzIMGul4JJE0uQmCRBKe95Thp/kJAxdg0NT5uZ6qxRoLLIXy+oQ9KDUO6gtyzc+JbLyexRJH0MwkktEJQqYjOLi6Ig5sRdgMaTQ5OIWxYixyQklJc48yYPQeMw0ujSMw+ICpmxAghB8AFRzTFUoHBgrD4HTK0C9lTgviMhEmhNZhagDJB300klWy3cpmKo8rdYlfIIyn/zcKvM4IIh/AhQ42hsrvIDTp4EyUXxp/V4tGxpRvQ3sPBe56C5/udEretSjW2SQDJAZRmWCUVRlfCZfCeuUNa4MCkBL7BNU5QllvYAGkZKK6VD3UwoOVZD/HjTqBRV5tL7oJWmRZBhUfSdJFJQABSupZAZWqAAJ1BOrV9XqbGXbPNqyxjQcgANYTSnWtg1UoXdC60KDKMu3Irets5xORRVGV7naVaR5/ShIq2vdkZL0pY0DbMYy90xnGTa8Mh0hge7QB1G8ShShKCAV5DjHkz1QdSACaofAMtRC0oWzQiskYPDLQXKKtrBchOoNooraA09ynlnF7YJvy7wDsKAP6DJG2cLaw1YysTZqE+4Q7ZXc6ygXoR92aKOcW2JCAc7EJ5budCll3RdfV8B99WsyT8oTzLnUjCvVbmEr0iAurMwEHahBTs7gMli8ShuhyAMXXvC0E0TBRrvI/wbMVAfIocJlFPjV737/W6P8KqupTMABkB6VXSGl9phLkgGT1uy71orGtnJ2MFdza5oTRGLCva0Gnzt8yiQK0V6rtHD48IZEsy53xIoWXxIY1WgVPze6wGwxdWEcYxmfmcc1zlj/ItQS8GpavBHCSTWz+4Q0iAIWp/ADs6qrg58lshcwk1lVZgYWcea3Dns4apd7tt8zMDXM61xQmVXwTu06KzEqWBKze+DsHThGwbSl7Zxxy2DS4EAVepYGt7nh7W+badEA+w6Hb4nhuOEmoWpNtEMV/WiL3vXEKE4xpCdNaUixwNIwDvWMS8hvBtnExuykiY5xDOp/ixonQWbYJf9T0Ng2/IjNL41WAidAgguVgsrdlJWts7LlQ8oOqb42KrCDLeZN1dS0PBBSgdUMbR30oAoyn3kVnO0Yelb7wdPmJJjyjC5vdNsaQQf3ENftp3JMT6C/KaWfQfzn35a73eIuNL+C825JY13eWbdipVns4sjqOwZiFzXCM5a/T+dHpc5KisjIblieYPN3I2C5YQ4UBRQAT4UdYK1iNGgVb2JZLjoCMMh5XfijAo0Liq87TyCH0kz3NVPLjrnM32B5LMjcRzUf0jyt2kJ76tzazGuhCM4lFqGjnhmqX/23m97u4mKne64XHzAMGi9Dz17q55661kf3nt7ftZdc73qL853/b3c+a+yY9vemOc1SIqyEY/wru0cAOCAgTFUxUhUS5XUAPBPWRHeGyBDg1bvewRO+8CBfv+yGzXhlNuXYGmu25rHglzQQBvOZt7nY4dylz2cVubBGCz1ADtyBKqCFMIQDOjAg66Gen/VZ7hmdoOHe9xSUKg1a+bjeukDUiAHf1tWbegifFR2fHNWHZITd16WgCSCf8jEf9Vlfx/zPUqSd/+CY23UEO22KgZwW8OydDnjB3cldTvnHE4RWHblMh0iQx71Iz5Sc4bVfFI7Q4r2f/mQXmWmKwj1bzNXfXgDCF74BxAVh/W2eJVkNAaJh6Alg1UgAB+QAGtxBJIyCtoFI/+o9YATiIW1UINNBxwTm3gVywib80Ct5hwZu4KGJWyvdBwgy4vuMIF6p4Ami4NjhWwtO1YtdYiZOIsKVnU+AiuZMSDMRCPS5GQ6WFGNtHrREiypKDQ4Ii0koibJoYoEY2XqpF1b4yiNlEPsFy0w9gYxI0xoFI5lBQTEeG8oFo03U3ytmXhtYnh984V4Eocydwf7dwAZcQAVggARwI2zpnJ0RoAVsYxuKwArQgBSIwR48giZ0giyMyZgIXR6akg7RDQfGwiZQAj6CwtrgBqHtobklIit9YCPC29YR373pmyay4EIuJAzu1XYZVvSFlwsmnE2wGTXe3dxp3/bBnI84gf8qZpMwRhmGnEJJyoXutAH7eQEVGmMxuuRLiqQwVqHjxWRNMuNNUqMX6AU0fmE06iQ1pmTEqWI36hwApqE4biMGlGMImGMSoCMdJEIhaIIsUKUDfkMOVYN2dJg8YmUh/mNW0sIr6KMgLl1XeqWiHeLZaGXVUd2/cB3W+d7hjKC91YcwbWIJgt1BYiJDKiRrYeMcSYYpCiZK8EdLxdRgZop/XNIO2METKNthQAsESEsswoFQsiBNDksD2eKN9EFKHlJitcAVYiFm1mQWyqQTMNbn4CQz9khO/mRK8uRgIE3+FUaQKJhRHiXpPQBSYkA2LuUKNKUREMFA0AFURmUnIKf/L2zlMSwnV6YD0u1Lhd0GKuzjPiqU2UDnHx6dPQLa7nEPdljRQP6eowXBXG6UXUqifeDlCiYk+PFlJQnZTWkjUuIU293AJmoaKDoVg9jnqNxnqSAmMu3EGVxjBcydkgAJCmiA3u1dYlwkZCLoTcKBjRyNTn5BxGGh/E0eTAac46Xm4l0oXgjLYg2La07ja55oinqhIyFNiwalYmrjAIKjbnajb/4lU0rWcOooQfAoGsiBHgBpJQhCJaBCkfZGHjKDWWZnc7ZeWGJPLC2pmUTgiKWl023P+LAYQfqeI2qEMMXl161nJGLRXe5lZA2hX/qmBYSjgR6oQ4JK9TXOjnmM/0q5qdthqBFaCwpEAeZtnzO2gQ48RpDAHLORoU56phhaaN0Z22QISWiOpt11aExmkIoGC4nmxRFiamUa6qaqaGix6F586qdKo1BuQG6qKRtmY6qSgCXVp47uqOCggRrE6qzGKpDuwXHOoSz0GTNMgzqAg6/ymeoxKXMqp91spZRmJ1V257Ce5YghGkMpQ3nWgHlmqVx+aZeKoC9VYnpuq152DEi950Ky6l8SZRpm4yUGaDPR6X2WYtstH0WKlxYuiUmw6gm4YsTlKd7t3bSogI8MqoSmaMQdBmmdkAZoKKSK5CsC2S4eEqfuosNmqjQeqsROKMWCqqhirB34qV40Af+0lGuNJiXwfMAc5ei3vmqP0mrKxipUQmUn2I47OiDr7apyZqUvKGtYrmWfZWeyFuuHJZ2+tJWxvmW8EW14Dh96sifx9aW4XhI2zmcamusHBCq8Um1EpsTV/ucZpathBVw8NW2DPqbTTEvTIujkCQsX4qS1oNDaYuEWFmqmGmrFrt/c0u3Eyi3ddqYbmJfEdmaLKpLGSmOovmj/OW3I9uaNkqzJbmldoWzK/qhxTqUsRK5yrh48qp7N1kLm4mxV6mw8xmOy+mGVVt2VXum0Dq22nu4UqS5dImR7huu4Fu7TQi3otSGSqNzW/odg4e4pdu0GNNxhRBv3YUEPQBX+CaH/xAWhg5biCUyLtDzN2LZtp+LfjmCsxdLtHUys3rpo9lZs3/aB935vsYTq3/ItSoIcoMpnyN7U+tIAC7rq6OSAFDil/F7do11BwaABGeBvjz6ucSYCcian5arezSorc3ZukiKdzPas7kGrd2JpUCAtJF7rBEtaJIapmLaT64Zr7GojN57q7NpZ1NxuysmYTGiOfsqpBCNmpK5coB7G2urpG/SAgb2w2GpANfJf06CQtBQJD/Mr5WGenzoSjnBm+BqxEcOB9l5sjbjB9zaxE0PxEx/xFI9vqPqFIpEvOTGMfLJv4rZvycoHlzolGCvEQfgoHZwxGqejyrYsABdpO07l/+QGqx3eYR6yJQPvyd3oZepaK7aqcNIC8uvCpw+ukCbVKAjLKJvWKWFpTgwUG14t8r/ZxBReYpHs6/C4sLBQht7pnWopW2QsKD1ZxgQsAASQhpFEgRsEwir35BdKwitLQiO4sixTcRPb8i1LcRQfcS5T8RRjcRYDsx/kV5NFFhd78RfXL3maLDLrGEIUZ/5Cc+OigUKkcZAK6Se4LOfekMwmsLBO6bJSXTQ0MOlG1B7Dr9HGR/zaB+tWKyCX6Qbn3dMkpSHTMzcaT+3iZ4Q0Mt05nH8OpmjSWKhdX4e2VpFowIYabMwBQhRcEgTEMENTy+RRQAQ8iWWU8pNkgCsGQv9JqtorT8IhwDIsQ8JIX7Eum/RJ93JKk+9Kfy+O/C3RbFk6jcF9MuWqHnMyX8Qy17TUkrEzC8rKsjGt6i8icML/uqwm6EI32yE3N8MCW2lyjLMD57G0UnBVt7MYs3NI7ZteLi3samMh1/MhM6jnHQA+j7B48UflkDAnIo6bDojvIqGzLGYTt4AqQkAPhGENs5kKYFKRUIALvDBFW/RFF0lhT0sPAAIsKHZJgjRIh3Qsk7QcyuH3zgURu0Ek8LJKT/FnVbH4lnQRC/NmA8bgYt8y93Q6m+z61vRq42jHrI/+7q9Qa0FQV/OtckI2a0I56OrqIbUC5+zT+YZxpdtT+4b/VRu3dL2Hl6Ju62p1/5kQPEeLZBbyPIf1BTQtWRsJC7Lcd6kZU1gOCkdyJKvmB1xA9vlIaq1tX2PbFt4cKRu2YR80BUz0YBN2KRu0CrzBJLTCL3R0SFvCY/NkJPRkbFq2Zn92Sn/2l/UyaC84g9cBFahExyQuai/zuOLUalsACIgAUiKzT8P2FuzvFqhsyq6xGPQvHQDw7fiCAH9zdwq3BQrHcct4W1PrH2tXc7szuDItF391Dz9vdU/3dSeyIi/FSOwzyID3u4Y3wHUts2Ufs0WbYYOtggKhzJUAJsk3YlBAAkBABESAfMs3Rdd3D3dyFPiBfreCSf73mq85Sf9B/ysPuIAXeEtv9oHTuYK/NJ3zF3/peZ+39NEwmYSD8beq9mqrapom5W+SQDN7TsHcL4gnDBsPBBoYQRhYuomv7FIlJ+e2uItHHbvNuHKb7kcZ5Dm7mtfluISLq00X9HS7uljTszYS8v9ZN7pu95Erea4HqEuEmSx67UG/ASC4gYJSSypjAWXYbhoAArRFBgVoOWEPgAeAgQuA+Xu/9yiXQH7zt6qpOZu/+Uh/uxy6+Z8TsZ8fS2ib+zkVkoE3+LkDRi6egQm0L0/Le3wypY0eOm8m+gVouE0z+t+YBxurMY9eeqUTRP8SdTt2OjivFbq5Zah3XalPMCW2M3sK8tf6eP+PgzWQj3V0dwmbtulSWMvukvyDKM2vd16/2ly0teLGZ0DMtRlfQ/sCcDmYO7sKTHSXWzvxTABe/4F+8zebW0IgQALRF/24k3SDm/ucm7uNNP26Kz2f50gjeEIuGgKwtNe8Y3gI5Du/h4C+J/qGL2U2hTGhTHNBrCwRPPOsoiymy4GJz8Hj4ipvGCndM7zogtioQ3wE93FWVzyOU/w7Sy2a/iXwOK/GuzriaxIhw5Y9VQ2SJElqrUS7rvWSr/D1MeiRoBD3zbDY1miXa/5Bu8DozzeXM4DN2zzOh7JumTJpaIALBPEfKPYvMPbRg7vtR/YX0nIfEBIRc7bvu7u6y/n/1Es9ZRt/8Jd01Y80IeUBNnH91+P7BoAAfYq92Cvl9Ss6M0OFiAfK2gO1NA/8pV+6HBi15tJszRLrmuB93lO42Cmuqc/4cic34NN//bt/X8IuIcczBzsAQFSYIJDgQIMXNiQUeIChhAoZRqRAcSPGRIoXMfLIuBEIR48yQHokkhHJjScnKX6AeKIHFi8qUJxAoSLKmzcqOgiEkGGHkB0UIkSg0MKNkBIagjbwUMIF0KAMIrio0mNHBgcOSmDp4UCBgwxDq2BxA8bSL7O9LAWSpBYQJLdv4QLy04juXLt38dbNW7dRnrt6GdENDNguYbeGDofyJMpTY8V089ShYiJE/2WFl0UgxFB5M+fMHDyTED36R8eSV6ykTk2HTGvWRNDERkMHNmsxdG7LyR0mjBxEiTppKseMeHFfx4slr7acebPmzpdFTyb9RWnr12NgD7Kduw0lpq8fWWL9e3nz47VX76ievff277O/kJnCRH37KlVefpiT//6C+w/6zyGCFJLgAQIaQkgiFHYI6SONHnQQwgkjDAklk4hI4QmTTmqQPg16UEGDESPoAAIUxNIqJoh2CPGpBQagwIUZj2oAggVwhCqBBCJYKqsqjuKphAh27MqrH6lyo5ezSvnjj7QkkaQtKQ8zTC6+9upjsLkiMUxLLAn70jC+qkTMTLqiJAUuO//YeOJD/TSLUyHQOrNstDtFM42K08hIbQzWXEuNCNxmk202QuVIlLdEf/sEFE00Oc44WYx7DrpLpZsuh01hgA+7TbtzD7xQ0TvvvBrS81RUVdmb776I8Iu1v1kJrDXOg3ANcCEEGUpowQoplBBYYDvFSMMOz+iQIg1MNHKCnUZkMIoQkXoWxyIXGHGoEkSkACkdc/R2xBI8oMADIhnA1kgSIejhyVPOglKtKJ1cM64rwcy3y8LI5LdMfft967HGzuRLMUkWCwXhNjyEEzM7QbszYjxJKLZU1NC44k80BoUNNo4/vk1kREdelFHgOumklpWJk9TlZ47BVJlMLe605lT/USVVZ+5MFc/nnXMedVVWT5Cv01dlvYxWh2+1NVenDWSo15Uw4nbYYIWNMDuMNhxpQ4pOmqrFHqIAslmhWlJBKBnFburFbF3wISlzfQDj3HBdsBvdDDwQ6+6rBggcgcF3RBsLQGAx65dT5qWXysfjQjNyya/8N2CAMafSD4VFESXKzj0X+GDQT/HcjzN4oA8/O+/sjOLKKKbB5tM8BtSK1lwrZGPbSs6NjkSB5y1k4AtRGZXjVXkZ5phlJjo+nIMWtWclulhC0J+hf9557eNT3XtZk2b6MgeahnpAqKWeOiKLrsa6fQmJ2NDNrzmcKiUVbOp2xLBcvBECCt7wByyg/8BbNyoBGNxwFLwZpYAMWIpTctQ3o7jggUUKXI4WgCIh5A0SivuFvBwHuchVjnKlMKEJNUemMs1FYVUKxSxeSIqBCax0LZQE40RnCUiEonQ99OEN/fAmE9jgA6LZTAzydIIQmIAJlOnAaCSSxCWMwQqyu10eqHg71RQCUrjxIsm8KLLdGCo2RhCDoX63B0E84hLHu4XLKrU97mVvenXEntDwKEejfe974UtIBpwWSEEKskRcORCvDKCgmbAva4105CM3IhGTbOQJyfqAgfAnNv3570Y8gslMuOWtBuZoANkyF7nKRSQDYOsqrfSAEN7QFMEVDgKl1ABMjtKCsvzCFf+/wEXpJvG5EIqwSpuzhA95wYsmxeUUvPjXDU8Bl2Ymc5qjo2YzD6bMx6FwmqWDBTDh5QxntCE/NXnBaJzABtFgcYmRcWI7GwGD0YwhFOrslBUMoTstFsITs4CUP8NYMt7p5jYhE9QZZaMahMZGjWqsBPJGEdHZTZSicwRaeOxYquixaj1y5CP4/Cg+/5TvAud7mkLIt4EJHJJXD4kiI933vq05ckMpGElGKrmhgXxFWiES0VMmwCOhEBBtTBElKXHUAKB4ywMzoiC4HKCUpQRFBRQ8qgaWcq0cIQACJRhLIBSXOGDSy4aTm0sPoZSWGk7phtSIpuRC0QtnviWZj5P/ayPiakO5QhMtn+vhXkkXTHi1ohV+kEFOniAJdYqGDeRMgR/GEIIbuIUEdJpsKFgAGhPkgRd3qFinIEUF2JBBEbMoxBU98cVDjUy1trGNQROaMYWekTcmS6MeLYozJeQgo3fcKKk8Sp+jIQ2kStPPTkYq0vLtVKUPSWlzV8oQBE2AaouEpGmu+0gY7KBTKIkf2JS1oiqkgVs7SBFQDafAcY1Fb/4bERjc5gBzZSELqbzKKYOCrbw1xVtKhQpQuIojCnjBDQU+ROII+8Oy3usUbh1mKbTp17tKU67LhERd0aRNbNIVnHvd4V+bdIhDdE7EgOgcIM4AyAokNp4JaWxE/yC7gRco7JwJQQJjlFgxvyhCnp3yRCGIEOQxdLE2mjjtGAe6UIVyjFCy1cKTZ0tbKU+5orntKEd7mwSNXjRUv+1eDITLx49CZHUqXppyoaurWj2XfClVcfq46lKZwDS7Mf2IzbjbIouF7UJ6bvMOYqm/W47Sk2DwwVHY5SMIMiADQsiCVQEMIwsOQKpNLbAL3obBWxI4SZMYxzh6icK0puktsOirhI/pzDRVmNQ3lOtc43rquEZzw6jmhalD/EEI05peb5gKZMNCkCi0hQeMdSyKZewWJPCHxUQkAQ76cIdGoIcI+bwnPklBKNICGclkJJQWyxhlhIp7ytW7Hm6tHP+9LG85j+geLnHHHNIzo7mkJl0zm1HaSTh3gEUxqbOd7ZznYoFNkhy6gUpSmt8INIhbMIk0VIXyv1P+rZXgmjiNprrKUko6qRTwwaHRVUquDq6UDUDBs7AwiUm04tO6FjVZdx2lV5tFh9/8MFpt2M1s9hWvgJV1zNHS15WXYuhpmdZhqeuHFqVBxU+wgztJ0FgakKAR9lR2xM5gB0jggLGN4ELVP5vaew6KFEd2zbfL7dpBybZPqMHYGckN99mqxlPDpYjN0o1RKfDM3Fo+N5eHBp8wDz7exZU3vUl6bwE9NydRk9oR5zzTf2cX7xjq7k05tCEzt9kr5nKqC9yAaVP/jsgHoUfKxMn18P8+9ZRggG+mMWhLRYccg5qOVhvKMo5fyJpe1Rxr4tRic0n09efKxCZfe+9zHfrVm6X4plrGocMCoxgCDglqBNLQoDSkgLrjNecHznDsKEjWD3lIcTvrMO2KZR3aeSiWJ9gwdivcwcjxu0LHwHjGIL8mtrhp+9vnLgDlTgzwrsokL+/Sw++yDPBAgmgIr/AMb97QDN8Ub/EOwn8cL0E+4FcmD34OUEMoqbu45gyqAAXMjCZ+gkbW6w/Ua0TcoAx84OEA6BDqC71cwAxET8CyAtNspPbSZeOGyqqgZSicwloKhyjeYEl0Dy2axBIAy5fSQvl2aK+K/y/VosnVKsz42mr5jsnmYOGYcMHAXkIDJqAHboJwDiAD3oBI0uDkOiAK3K8NxgD8HCvGeKAP2MAO5EkH2MSwdCwODQsGkKDqbCbIkICfjgy2YIsM7E8AxQAABTASqa0AKdFYEHDdFDABr2wTsUMiHhACw8eIzAzxlOsqBslaqi8VM/AAdiryZOrLtkYiauYiikWS+OywWERF2OVGZAS+uoUBCI0rsIKCfITiYI8pHqgBetAHc+SWQC+BOAkNraUFoGBE8uAXlpBzcK3Cgo/4nMn5/sotXM0KZc7UrqkcBeuGdA0W/sANBAjQVEACBKcmMkBqaIIrtMIh4LAD+PAEwv+vYiAhxSZrDNgJDp9A/UygL2AgD5FAEOFvooKsEELhtD6mIkEmfpxMNTDG7SQxAK9HUAzw7kKSE92DtzCRAQNvpj4RFCNw3pAr8RDvaQxCzeSxpTqAAyuCzhxpPmDKQ7gLBD0iWcwrCsgMFW1PBZDxp5ixgZrK0e4G9v5r4hat9jbOGVvgqHBE3yCATjigBnoOrZ4PsJywhqAQXohuSZKPHMeRHFfu+bjQC9xlK1rACzTADTRAAKRGAsRiAgLgAKbFAAQg2MowD27SDtJJ/J5N6f7xDNoEEA7LBrCIiQzh/qigngoRPa5AE0yLNnDDIsvIYzoyNCWxEhEw7+qo76z/5+/YLSW5RyRfhSUPTwKZRs3g5Fks0CDOp/FY6gHkzBVxYPIkabuCs7voQ8+2S36SJQXOgAYZ7gRQkUQ8j4KkAhoxyAPqRvTmSwg+ziiYkQFsRCpVT9PcwAdeogV6YBe3UgNwwAlcog+E6YS+CcJcjgq9UZlYbfjiUyxtDhxdDRbKb4C84A9MkC5LCS5vAi8RAC8hIJYKgADEgoDSgOkGEyJIsA3qUJ34kAfMCYt0QP0OMllw7wwcsg4uMzWxTXdoQ/86czVAc+44EhJFEyRJcyQv8SR9iyQd8N1gE4rKjBRh8hRlciaZa1dsst908gA9ULgiaeCKE2yS5Qa0Liza/7FaNOBBZcQF1MZcxkKB7ssFuLPiKIAPCMFuppKTGmC/knEZNc08W0CpLq0FfhMO3PGGXs7W0PIsg+6vttHn8vQL17Lo2uIQfmJwVAAQkIIoA8cMwQAFDKCW8DIACpUNBUgs/oD7zGnF/AIxD9IksKgN77AJlJMXzEQU3M8KIIFEfYYjyQ7IDLFjFMpjsshPNDJGPXIJ6qPuZrRGM/Fi7mg1UfLLXhPeDC82fbRAEIImhRQ3dSWlVgpBpmsD1se6gDPMCG7gOKKSNKJslu4nXJBMg9H1jMIYYw/1Qmkqlwr0MC6U/CfANC1AdYit3nPVtFGZdmFPKwzEOAeZ4NNPl//ESeYUJgisWQQABf6gHnvAAx6gANTwEBg1C1TgUSMADJDiDe5SAdRQB8rQD/hjc9qgaACBKDdVOZ9OIhqBu55OI0wg/UrCEOIPPQyBx5DgdhpBE+LH/lqUVmN0T6pIUObwE3MVyzDxI3nVV7usVW413oSVWBOC8RhPM5rWR3OFN582up51JSLPFRnJ34TrJ1OCPiKkQ04i+3iqRZSSKm1pWzBuqbzzv6ACGD0v9XaRR8CiwMiFKq6SBbTllqZvXk6oCT+Hh97T97jp5cZqxMZq15rPD9TiPNvFLhEAfyKAV5xulYBE47KADzxAAGZEAPoyAgAhAiC3IdqgCjCV2Sb/gWJP4GNJIGSXU0R3ABLchGWPZgy8bhDHQBBLQ2VHSxF0J4uCzBB3FkZndXiHdyQ0cgxu93YpcXn3aHuCFnuIlgFXMmljpSWX9riwl96mds2UtaQuoM0govrgbCAqxlWwVmsnwmtd82qwdUWsIirKIIG4lJPCpQXqNgvINCn01+Ka6iiAohndq4DqMhBczx0DNa1ErW8Bl3MYWOdGDeZozXADy3HcQAeooiarlFE7wNeswgOyDy/bIHP7sgQOgQICAICGJALEogAAbXBYcS9rorJuUhIIM3XPYHVbbDndpEM35GNTgp42pC9wBwlol2WfIP2U93d/d1ZvNlWJl+6e/zh4M4R5m5cF9AijbPRG6QjMgpV6qxdWlLZYS1FAyLh7xydh8/ImzXeNgTUlftITh/Naj+5NKgAFCszAtuJb9EcIe0Q7U69t3+ZcfYAYBS2AXRCBEfmYdEiBGbiR4VMLuTBwPUflPEcuynMmyHAnpLEeDWDAUuTkCqAAvAUwA2ABzqUvKQB/fa2WVGAHAgeTeoAf6ZLM4PIEMmAqPsC8DqsJsm8EbgB1kMAwPbEJODT96IIU3K+IX7ZUW/UJYLVVVRM2YvZVfyZ45Weas+hoq/hndVVovTk1tZjLppd6IdC4xLhYgzRZDyJ8S2p8rZaNvbZowqwEBq8BH6RFKml0P//EGc3w0PTYf/+XRxKg0R6tXIFRwM4VvrwFXR2ule8YEAIhohN51GTIkd/TkQW3TnVIxKREn0dgIUQODQXnUUPZgkj6UQEgAPqSc1W6UaMrzhTA+viNupQofOW5nmUAJ3/Y7kpCSXmACxpSEJ2g7ZS4qIsaNYy3V6dZaJe4IWP2d9d3m6UaaPluV60anMPZy7i4i8kZpLwa4fIDrJvLnGfzR481nZE1A1txni0Cjt1aQ4bTWinpJCyZPk6EWpDSbr9F04LilIZCBQOak9ilByaBgAPISRAYFxKZcCu6sUfHooEOxELI13TAll86pkc6cB41AVi6s1X6s0E7tD/7pDH/WwJScaTAGFZyWptXG557uqfDLFdvypmJGJqd2radOLc1Mqih2qipeKqpOouxOno3cZy7elir1yvk7bmSW05q02nLWp2dexUd4p0XRJ5d8xMrJGwlgbIJiKh4kSiwlAhFKXwjbm3qtmzrl8Aoub3TERcUW62OSYYW2bFjiJHxm3MsYYE7umHkEbPhLLNPerRFW7RJe5WkGzT4Q4ate5y5uGuHmVotaiNGosJbNakxXKlxW0Yvs6i1Gbi5GYuH+6pHPKuLm6u7ekcPLz/+qMXP+XuzN8FNpD9qsmrRF559dqvvx0IqyQ8o+XSucl0bF5bINHyXgoDY5fYGOa+nE7Ep/zkQ0nHUoCS+wbAUHDu/8xuZOjoKKrv6VhHO0mfAPdvAR3uVEjamZdxWbFq1tRmnJZxJS8ISt/juuiapb1vDv1lnfVuJl4jwQDy4yQM1dfubiRtYUfyLxUzFkdt6nxalxriM11k3azzOrDZaXkoDCC8mJHwjdMCCl9Mst7x/ooUpqEWP95oX/+cNQEiRo3yxFXlwsfy+s5x03soNnhSQLjvAdR2lx5zAxTxBzFjNE4JHyYzNp7drkb000+0iahZ47fzOM1ya9ZyKP2CK39zdRBzPB/3ONSJ7tvrQEf24F91XxFq5i93ctTe60Xort5JIERTdR8C6rdbYN51rdODTJ/8h5gTofas09FoZTk9OsP9nLt2x1Q3+1eWbcNUq1mdhF2oImYLJkqPABCUdzHf9UZ2VzH89wNOcrMOd3v3cEiP8A99Dzis8I6A52mnHqVXV7Ty8x5SY2v9cSbPdZ6qnRbd95QvduMV93JHbAVjSxVl8e6F7uSyQP/SNpV16zeO9nhu8tdWXx/MgX9dq4sWLcTG99ADePPc24Rfe6yc6vhWbkce+4SEbrVCs0y1bpMO87TGeAHxd40MZzM/c+mhT2If949vcwe9swgEO877LmVVe5aE45nW02mP7w6+45kuc0E28jQ8f3PXe5/P+q5m+R4l+rKPbe6U7akkbWvaZWWz/me/leHNwLuLHkN05INUDoUvk4km+XuERfvZfruxhnZGN78S23AR3ZNfdvtc1vswRNC+jRlnv3uMnn/RrcccnHEnl+loh8qmlP6il2OWVOLZ/O8SpWMtSvokdv8TbLfJ73ufN3eeR+3pfvOgh3e5RkWpHmzeZXvRX4umNRlRAIp1mjdahpA96ACBwsGjhxk2gg7gSWlrIsJQlXA0jOpxIUWJFirx4idq4sZGdM1V2lIiA4IBJAShPFkgZACWAli5bypw5k8DKByYl4Nyps6cEDBWCAr1AtOiGo0hJKP3AdClTE1BTRJVKVeoNGFdhVE1xteuLGD/Aer2R9cYOIkTI/6Zdi/Us2rdI4spFgtZKWrtv827VSpXvV7+A/wYGovVIEsOI7VrpsqRx4seQ6R4ZC3bw3qlRn2rezDlD56dHP4sendSo6dNGfU5QzXoChNUGCMi0aWBCBg0nSJzwfPvyid/AxeIYzuVOKI2nSiVPvhCSc+eRGEp/KBFSKVIMsVe0DpF6Q+bLlS93bmjME5BPdkjFybL9ypgCXsqnWfOmfZ4+LfQUOpS/6RClJeUUZgT6xpVXhVWm4IJu7eAWVmgdeJZbdD0BwxOSSVYXFVdYcUVeIMIQoYiWhVWiYAtCeFhkii3GoouREQYEZRAaOOBnAjbFG2k5ktZUaAECiRRqqf9V8MBQQE3AAWsI9JSAaw5MYMB7stmkUwe9jbDjllv9ZsOXw+nQRB7ihVdRd94pRF10Fml30ZvfhTdeIx6dMQYSVjkowwZTqtQeffMBCpN9fR6JX2v+JUpkj50VeJlaXEXKQ4qUVgrpiCRWiNaEd4EoV4iYhprgiZWmuKKnL8KoqmOO0RiYo1DRkJmPtNbK1I5CMhXkrov+lOhqrSnQJLCw6XRSSsNieRuXTwUnHJhiNoIccwphRB2a3WF7rZtwpnlteH/4EYUOM4o5KRLp6elAn3/GF+i79RUqL6JJ+qqoogAG+OONWsJqoFWumsggESlYKGJZJO5A16hwxdXpXB3/aigqYBOTWqPAKp5KxKobpvqYwQFvtRmB+5bMLK2h8cjroixbQJS9F+wnc200X1DbBlFesC67stWs7LJYaqCUszV4GaYOcIh3nHK7NC0emg9p6xB3214XitVvMtccJG9g0QMKHbymGw9inmcn2DtXKSi8L6HU87w3H5pzzEW2bJRSjHLmrwmhApxpWn6PahWml0Jq8FkaWphhXGSQQcSdH44BKomY8r3ixRZjHKPHqm7cOcgL93VZs7P2qyNvQNpa8sqsH+VA63bT7SuxOO1s85RK6kzzTlXmBEHYP3NJtAxfQhEFmRk5zXQp1SYEUbbMT0SK89NTtDRGWgPiRxtt/0RBwpIHXImCnnrmxueUarMtKEo7wU3vA669HHtQQuatt2iwesUV4AiHSGP/CMrY4iAmOVRN7oAao5ysKMawBL7Ic5yTGKQCOLr7me5kqoOdBjdYt6LMjnZMklLtdvcyYfHMd78LHm5G4CyjEc8JXJAWL2ahvOU171vWsx4upqedjJhpeyApG7n2gyUVqCsDCeDZ2to2mz45UV4748ntcFJC2R1pfrsqWen+ZSCCkSVwKRgRWSjjlbSMUS1ZCSNcOnWXDt0JRJAzj8MQ6MCKaU5gCeSYHg0zQMWFDDAk41cGRZOvlemKgywbkgdd9hNGyg+Eh+JJFE2oxAEgYAGvAf+aBm6jmxZCK2nKa5pCqjWJG1rLeToEFxCjYIMR6MaIX/sAblBgPg2kDT7rG1RsaDOvSDryioa6IhYT2QEACRIqxwRkVdByRv6xJSteXMsY1wg4aZLFQhYqYBs55CHINcxF3FyVhwyYQBr8IAcLTKc5M7aiPbpzcWZMj4jOwkULXvCeLLQnjg6JyH4SCWYAzR0k3TcsJ/kJWZiEwCYXOsvhmQV5ydlFRCVqyuZVFJWhgEQe4BAFNqSHeMBDASxVcAMV7AaJ7Mpl73gJN9zhp4OGAmHMXEZMIhXSnoHsouDMmCA0qgVDALsmT/8nzU2xsZsRG6fjUCXOuYBIY0mQQh3/8QhVVr3zgdDEnI30abquiqyCOOqRP2taJJr+BH4yI1bMYkpQnySxJPCxJCYZGrTguDAKMozoREd5Q4v6EDmSaAQcuJAbrjSBXLv5jUlFmgKcGQuX9FnpE11qKEY2Uj+/FKZmAUrW1iVzbzoN6hkBOCqfDnW0XwQqM+9yJzqYp3FJpcLkPLSqiGlMDO20KmMOs9ve9ja3nIsRyEr0Va6Cdqv7zBU/x1q/DtLtuVVEa/vkZYHdqeY1IqQSQiOwyWU11FlMYIN1/lrD6PmVvIH1wx3Y4FHzfSAGYhKJSE0atseqdDY2Yem8ROiayq5VPwJ95DA9a0xj4vO4VnlUM6Np/8bRFnWoDVaLNbMiT4ORAamtpa2GQaXh2LpIDCAOsYgZowUQO8a3KNbtVWP0uAsRrJ7GBWs+vSqyQS6XuTCFbrAeSUXrNmmyxFpAEuOa0AhwN0vgHZMkkkdeWCjkF72Aci+mPDXBOkGIOjABUUZQPpFmALuQXZ9kKSu3s/IYZvIT5oANaT8EK3OZCfYpahtmlrR89LQRhuY0HxYxyLmRmxfm0MYguEa5tGjEJFZDokuM6EZrWAy2rSo8IaPVN7uZdJfOKWdwvGbOPveD0TVAdXmSk/1C6TUpRckAiuxdWjbULGw4DpWTh4spZyQbgIXEGraA2FeOi3iK1QHaYJO+yP8WWyW+LBYkFyldD3ZWkTe92wcMbEFLWyZSg5vn4Jrp4LXI83EOU62eDzRnCErOjeDusLphlBd1hyHFKFa0o+fdVBVLUC6iRW6mYYzpqqBsV9FW5PwCTPCAKomt03UrkHWC6iHPZ9UQOHJ3ResEiNaaGr+QcvJCsdEmBGE4RfsN+YTtamL/ydh+6iWiaCc/AS/yuTRdWSH/01ycFujNWa2ceij3KYfhW4J5gWaeCVcWybwWYvVOOl7gsmjGyPvdXZD3YkSMhg4xeurrVvrHHiwVehZ33/rm96ZhF/NO92oDBu+vAyxLZkLBtSQ0Y4AD5O5whNqGS2eEIRsY4Rwekof/e2xYgmAQK4Mo/Ho3qHZbsVG+8DJ/UKaefnbAizJzadvcLwSymBqzjdppZuhhoC9tGUW/zcbFEYJat7oen55oqLOe3lfPutY3Z+1+1/PruOeL7cfOabPX7UpWbLYJlW2sx5aaZgmgO/oG5RokU/wL7IWD9HfNhS9EgbBFe6GYXF1MnSw+zMhSOWvMamb/Rp6sNw7S5Km9+9DC2TJE1ZDP99ygopr2p6M1GIbVTQQ6KF324hRvAhh7iLYYVocGJjZ7k8ZMYgd2ucdvVJF+vTdMaLZWZ6ZwsDFZb0dJUyJ3ygcf8HNkU/FxOqAFZBB9u8YGX7CCK8gEUMAEH1c0HWB8t98HKG5HQiv3exbobGW3KCAgVmPVfrX3ZgRDdGiEFZ03dNKkf/DUFXMkRnWGIa+FeocGgFZoBa+XhVFHgI2GgAWogECXRkPogA8ohBHIe/5UdnNzds4VXRYoXbURQtNlEk6UfB8YE+GTQiNYgk6Agmuggix4ZTDIAksyXSu1RACggSEYJcLnacAyasC3ZkA4c5WXRbf3fgeyU2EERvvTYA3WhNA0R0+IZ5s3OFLoTVfoboHmhY8WEAAh+QQEBAD/ACwAAAAA4AEOAYceCwAnDQAsFwYuIQwyDwEzGws2GQc3HhE4Ig05JhQ8Mhs9OCE9SS1DHxBFHgpHLyBHNBtIIw1IOSNJKBRTSjJVKxVWMQ1XKAtXKxZXRCtZOSNaLhpaMxtaWkNiNSJlOiVmLQtnNRloMA9pSzNpXENqOyVqQytqVDprPSlsQRxscFhybVN0Xzx1PiV1RCZ1RCt1SSZ1SzJ2Oxl2SSt3OAx4STJ4US54VDl5Qht5W0J5ZUl6Rip6SzN7RCV7SCZ7SSt7iGt+on1/qIGAPyKCPhSCRiqESiaESiqETjOEUzaEVTqFWTuFXEOGWDeHRRCISSSIZUmJRhmJbFKJdViKTSuKVTaKVjqKck2LWTWLWjqLhmiMUiqOj3OQYTiSTBuSTSaSfGOTX0CTrIqUTzGUWjeUbVKVm4OXVSiXYzmXh2iXoX6YaEeYlHaZVBuZdleaglyccUyeyqKhx6KiXCijXRyjXTKkfWGlbUWndUqoYh6oe1epaDaph2Wpl3aqZSmqglyrkW2tcjytoneusI+wbkOwnIKxvaKzbCuzbTWzfVW00bG1hVq2imW3eUe3jVm3k2u5mXa5qIW6dCy6dTi6pHq8gkm948K/gT3Cei7Cf1XCjGXDfUPEezXFfDrFnoHGnHbGpHnHfTnHilXHlmrIgzvIqIXKh0bLhDvLk1jNkk3NvKLN5cbOpm3P4b7Qhz3Q1LTRtpLSiz7TjUrTjlLTnnPUjUPVkkvWkUXWpXfWsovW3cHXnGbXq4XYkT/YpGrYxJvZllbak0XamUraoVDclUrdmlPdoljemUzhl0vim0njm03jnmHknVLknVrlo1vmoU7moVPmqV3mrHXmupLnp2bntojooU/pnlPqxJfq3cLrpFTrpVrrtHjtqlztq2PtsFztsmjt0aruqFXxn1fxpVjyq1byrWPyrmryrnLysFfzrVv0tGv1sVz1smP1uXf1vIT27M/3uWv3ypX5s175tWP5xX36u2z6vXP6yIb616b7wXT7xXv847j90oz91Jf//eYI/wATCByoIAEECyZsYDlzxs+cOV4iSpRIhMiXi2MyDqlYcYiIjSJCyBi5sYXJkyRRqlQZpaXLLxsvgrxAkyYIGU8wMrzohAbOMYSCCkXUqRMiokE3KTWKqI5TiG2iPvQTyNQsYM2cbdvKVRs5r2DDihsr9plZaGePKVNLtms3t97MsYvbrq7du9/sgtu7V98+v/cCr6PLF7C+eHn1ffO7GJzhv5AjMx4sF+/cu+4EaxYsGd9jz5vtDc48+lxcrahTFxM2jLVr1m+d3TLFrCtaZmtxI8utGy1XwqL34RtOvLjxfsKRK19+vN5w5NKcG3furlrz4v6ya8/Hffv26+ClE//nxs0XN+kEC6rPoHBhw4cT43PUqbGjRxAh84fQn7+F/pQjiSTSSS0NEZGBMpUEQk02IagTFTmN9IRTQ01SoVIWBmVhU099AVVDe0ySympZwfVVWSiGldaKZ8Vm4luE5WXZjHytE5hkgVED3GOJySjjY59RJ1iMNMZjZGjDbQYkkkfaOORpvRlzG4nCpGLllVKaA00twfimGm9gXoMbXKZxFt5xzD2nZj9pOhfdmeJhx6Z3dHrn2XnysAlnceTthZ56gELAnkIMOQRVfAda5IVFGXFUEX6QRpqfpJRW+pGEETpY0kwMfpTTg0+ANOFQGiJFiFFMZcghfFFJRdSIqdn/luKsLNYKljouvkhkkT7eCCRl0QS7ZK99BdnZX+gAy2uTTRoLWJJMagasbrZUe5W1s52iLSnb3gJNbN4GO2WUaoXp5VZl+ronmm2Ch2dz74I3p3fd1XnncNq1O1095b05HASBrpcCoe8dGh9PFjE6hqNE2BRppwtWCrGkmCoK08Wh+neBAw47iFGmNHhRx4VIqXpqyatC9GGItOkY64kwy9qWNTTbOm6Kue5a47K+hnZasZH5uLOzOJbGs5ObEdcztPeApqSRUK5Wi1WmcGu1JJNcovXW3MK2zS1d3kyluVH+lm6c++6Z5rzU+WtcvPLamy/b/OI5d5554oMNn+T5/0KN2wAHDHAIMGxRKKsHIzzRwpJyzODjNTkOeacCXvopgppq7IDjIh1h+OcFdjQyqUhtUupRJx81VasPNQKryzLHTKvNYreF6+0uVtbNsngdiSxkUAMnJGPEEl00X5fpjllwSRfX9DtFS/uz1LJUvy23k2CNtdbbd42VuGGTC+ZuZJOZGdr8Jnemnsyxj9ze6A8HN7vz2om3+9Lkjy/7eaddnd/nudEDBLeAgxDMUIlDWEV0wqmITU5yDILg4waUn5jwhCIK2hjnevAp0BUhCj6xCOpOhzrTFcWERzkEHSAyBleJ4nslip3sZvca3qgIZ2ZT3s50WBjAJMtXfBHWsP+EBrRj8WiHProdPZDGPPVBj09PPF+yTIMa6lmvatejWiymNhsrYWVMXBEftcpFvrLl8IfQ+l389LWm+91rTeti193w5kZpmKeNbtxXnxzzRHwMMGAFhEDhCuYURG3EYgy8j8Mmx8hGXqAEP5jBfiyHMQNZUgYObNCn2pApHOBHZEJpBAmXkiqmrO4icziEVWL4shm68kTJiKUsaSeWcuhKh8kr0pOENLRjEdExxnuW0XDHQ+apKzzSo6IzxoatZn4RjFIa25fEKEtilLF86PLdseIIR/elj5vX6R8d8zgeAOKRnErr1/meGDjBIWQMTznlBRMFkwUuTJEhwQAGMun/SEZ+JAlIeEFITBIhnlwSkxvrmBE+Z7hQ9cQnQBFlCVFWslTBZ4Wp3MQsYNfKV87qmrNsEYpwF7Ni1kVYu1seZc4Rj3pMZi+JQRvx5rFEYBpRjcPUWV1+qM11kUaZ06RSNKEpLrRgqxhBZaY1q0RGbJ5tnetcXzfdh5xvdtN/eOSmO8ABwKjK6W19ooZX21kQBjAgkCkw3OoMNpEFLoqBlNrApCxA17rWdUH63KcIKsABmrgAoD/YT8Uu9lZFRqAmnYuIBxvmk5GlaoRFmeiGVEcHkalyo8ugBitxKMPbBKMXXQKpMjhbUmLyrjJ60ZExgfUs9gGvVzc9HpFghNrV/95oTz+lIpQ4Ki7eRs2ZJBLbUodbw/KZw5g4Utva6vdGqVrnqtOBH7zi0lXyeFWc0NuqHflYHBNk4KwLMKtZFbCAQU4Fnmw9UOJmAqkheIA/k9xrfPGaV7ly4J9NOIJ/KLmomEShB5jcnEI7mKAQfuFUozwKJyKrYMpW1g+dwKxvxURamcUyFrsBLVhyU8vS/sy0M0opanvrjec9KRotlekvgylFZenUaEhzov9aDOMy6dbG01vNtbwIDNhAUy1HBS1xbRWXpXlVjlRNsp6s65wky3iNxJlGdvs4Hu1Sw28A5AuTwWpl1VL5BCOgAAXE24HxDpIMhkLcPBFkMQXdBP8klYuzgN47Sb3G+QcALUF+Ktnf/yJUwBbwFIFdYuALcYKiRFlwCg11CBFt9mYVLgsxtihaG77ywyDGS7By2Q4Ss9RpynJWL1nsQ0y/mIlPVp+JacysGtsYfFfksbVkNcZqhdSpn05j3JTM6+GwIjp7W+76sCtdeCXrysbw28+kYSMqZzd4XpYimMdM5jFTIK0ZKVjiElhPNwNooBRMgZznrGcB4bkFcsVUhPq8Hw3SpHMePBB+RDjCFFb00IledB0i/OjaUbjCa6F0pf996RPhMsQxIrFthSdjmMqo2bGF6o3pUg4c87SncGK1q128TKZi8RTV+6ItSPHMpH5WyE3/PVeRk3bkXjM3yVtGMvvIg0dn683ZP9VslrSibDS2OEc/o7EOpm3WMps1AxnIdiE9tOa2thnOHvCI1P0j7jkH6OrjNncJ9DqED26yIyHQ4AYXGm8Q3uTApMt3g/GdvTo0OhPjiHsMaQnwgAt8Nxse7YtuqUPR0FbTXkK1SmWsmIdrc0lDNLXFUS1j197r2RvHsTeolcVVkqhqwph8bXJW65Sr/OLVccdX3chcuS3ZblOlGzeCTTefmgapflONaksjmGPDbpgsOAEFOsD7o4v5zB2aZ+KezlhPDci94ha3C6w+7gA9EgXLt3MRIHTIRNEE0PAuOw3OXqpDY+hUqFp7/6Lh3u/WQLrudufSNQneWYOji5jQ/ju4viWXZK78mH8pnmIOE0BRc9ykjKc+zLFqT5JamIYa1fJxIQdDx9A1WgJGtuQi2BR4OxUYUyZzeFMvprc38UJ6MId6+ZI2OLdVWYFUJRhcOmJjTQJUyxYXudcBY2Z0DPB7EHJewrdtLdFn89Z1m3IpV/eDzNdufiVQG8AxLUBg9oFQCfVIOEBgBcZ99rZ2pcRgC0Z+cld+NRNpG/ZZ2rJUtHYrMgMlBqc8frd3FMg8O3JbVVV4MfUrpGEs/3dqLTdjoiF58qdzPTY13oOCWiEMDqgNbGEi/mY+LIdk91MnGnh6oneIc3R60P+lR842GCQCO3yYgnb4aC4zbdQmXjSYEcHHbTfIXshnbkAIhOBWZ0MYdn4FIQlySfqEfU3IUAoEhSWkFIi2YLgYCnK3i14iUloISxnWhWXUfrzIdyNmhpungqahgmpYVd+waUBjU4gXNIpXW8zoF+EBeXHIWx5nFa7hJVliC5JACl4RDYHIeTOjciJWiALIJqyXJ92hgYmID+QRbBloevQIgks2HUd2GB3HStKUGgmHiVpBARKwieIlARqQEIejZqD4hKdYihIJICexAamoitlXSX92WBcgaLL4X/PmBY12MmynYFOoUdakcr24kr6Yjnl3YcKIDF+YFWJIkPIHeLn/IlIVaIAxpmrQeHj994ZBEn9/t3hz6DzZNUUT11tVBFwAaYKpMI6xoXfISFRn9HOpRy/1Eg724hzgwCZcKY9zZFWqx48ESIIm+Fslt1k1aZUAkwESEDjjBQGQxBCf+JAfA3XfRhIlQJF+iQRrgAdwsAaECQU8gG58RVCV9AOeFAGAxgEpEIt5ORI3QQRReG/3hpJW2ZKcSVpnwYWuMIwy1JY2qUQnVVRv0VQpFTwV91Sqtg/gYAzR2GrTCBmn6WlE0pPuklssKFxHJXslVwtS2Q2WhoyoaTbN0oxUpZXxOI/8EmzNKTcx13qQ2GJbkYxAhRtriYVEFTjeeRCJiRHx/4SD81RgfpkSALZ8JnGeLRAGvIAN0xCf0+AJerAGPJBu0ycTGeMCYscxAyWZGbN9Zzc6GqJo35c1RXEV3NmZLklDWxSaHBaGpFmad5iT5kd/dThxAUgdm2YYvsMNQDk8QIebkfc81blHbalU3uhj/+hFWnEJEOYVXkiMfJec2KhkYhmdIfhrYImId7NlPyp6I6iUeJhNailyKDhGZmQBg9NXTjogSrd0eKlYCsKe6LkSKFEEd4AN/NClXYoNjwAHSLBnrNhJC4J9xxeLRmB2A5p2tmiSoVA9EPiLWeiZyKCHILeZxag7NJo7JzWICFeBcDibs0k0ZXiTRjmHmoGilP/ITFaiRc2kgD02DKSQB6dgjkPWp2C4kxjXRvnCHaAandzhHKxQD9iQHTk6N3eij6t6gZCnlMH1aieIpD+mVMHFAZAJfQlRA7y6A0gQpXXQKlOKMFaansbKg+ippVwKD8wKD2DqBi+gSfppBAB2pgI2IL+qEQHapvUmfgmKgg3KoHXaYS+Jp7VgRqM5oXq6aZhqFqoZqIKKI0J0GMEDTMgVJ8hSjTxZJuhTexw3Jd1YeQpoNS5aDJJgqVsCNp6nqbjiJLrpqT4qqv5QDzzKnPMIHTTneHUjpFXWZf84kJ0XkE01sh7wAS9wA1lQmHdACHWQbegVrMKKl1VarJuCrDz/OH2JEA78wKw7Gw6fAAdb51fZ1op7BYs+EAaNkAiEUB8hRAQEehSklGgrOqfkSjPhSq6341mgea4nOJMfNpMqKYHFhZ26RSbzkHgFWKj+h6h2uHKewTS8qXktai0fZzUEi0Vyan6p4BB5qrALG2nW+LDLGbH5Uh74YLHOGXpwI0UxB3lqCbLUM6nSNLJHFQIlywNWEAaEiQZOoXR2WU9v9ZA9+Jde53UEQiA4mw8766Xy8LMlIGAy4LJjQK0+ULRjF1F3cE9NSwVPS4UnxLVUe0MtWXBfkbVau0VxKprFGLxgG7bu6rcXeoyy0oaAQVN18VI9RGqIgRqE0baMt6hB/6SWjzqwThlc0RQLK6R+0Pu36apTR1k/iVgvhku4qlo33JVOLTZlOYeHWCGrTSm5tkpc2EJXluurVUAGCNyywHqDi9N0U3elmzJ9NnuzH8QIqgsPXeqsrptQPyGLtQsC9zUSM8CYJCGg7TUEFDJKJ6Sg/UanHSa96dct6HqdzDtD53e86junxgsXS+Sh9Ye9tCeUN6WvcvGTHwq+4UvDHueUE1akznAKbaBKkzZk7DtSFVpkW9aO8CuWpXq49Jsd8mMe9ytx+ZuUR6os/yvA56vGw4WrnZOygbmynHs4dZAwD1lYDEO6E0zBrPgI+YDBrAsKeuADBGwEXcC5crwGWf8AUCh7yIuMSZMSKVEAT3sQIpKFktv5krbjfhEothC4w8HoCqGQvJkKjDXcvDh8d5tnnB1agBmKRDYKh9CIWiyYhpFXxC06VDsHucOlWZNAB5JAxQP3iyS6DtMJv/ajP6UnnXsUQK2avz+0v1mhsCmImroMZLQauUEmXwODBnqgtEGhyHQ8BxZDngqESX/ZdWEAFPdEBZ6IZiuLC6rrpfmADYKcBJGJA10QCIIpFImssuJcwpDMrZY8flM7w1jbyQoto8oLIwwNmqSctwTnVKjMG7PBRd/ovLHzyqtZr0MTyyLKtjUZuB6dxL51eyCbgMBrsAhraxkmzKdMobQ8xl7/fDcTa0eLiMxjaWVMdg/NrF0gCnrKlIfEwK7gIz4uDcBETVzgVjhxvLlDW0iXFLrkeR//oZiaSwiZkAlZrbRbrQm0QAvVoLrzXM8/2wVb4Mj8LMf/7MiOvAU/gcBmJ0Irm0JVqJldO9EJbVoWSka01a7ZIsM5/JQNXdFAFtjqV5yaDIGHuo7h+9GHJx75x70jdtIzrTOKV80tuEyiPI4SHZWqZFQCDNN6/ZIybczKqXp35KlswxzlEW1A/dNTFLfNkIdyas3XLDXFNdqvAQP57AN4hsBhsAdR/RR2zG2XBGdXbRJImwmaUA28EM/QPd3VYB3bwR244Ahw4Nac293d/50Fwp1fN5DWnhNRaGBQlGxvSiELmZDJN7zJmXYZSnyOZJEbeogJfZu3eDff6FqrlHvRqsySCL2vBD54RpavZ9SWRLyMJq2v/0gK2eNoy8TZwLzbpC1G/yayL2PEJgpW5kQ/4yQ/XBUNQbl4DE6klIEb1sOiwhXA/00laL0FZJfWCSy7iFPOobtmyn0pBEUImvCe8RndiVDd7xCfRT4N9ygP9rzd393kb+0ehMJQlbwHc/xWFEIU653NZjSucafQnHabWnuOFq0t+L0bEf1ZtXGCw9zihw3gKBe8GI5imbbgMCbEI2pqspdDmW3ZSTxpp6A9pBAuE84MnFDhHffSA/8X5yG7ksWsmyT44VBmHOfQc9K82SbO2ZgXiFveebP24rhxyLJ4wDaubeXsMTr+KDzedXfgCfIZn5pwB5mA5HgjZfAoD6OKD6PA5E7OEDFO3lA+44h83heUSllz0HmN4Vbr5fEN5p6+Fn9e5sEwyrG232vu33rr5m8eoYut2Hp+apD9LAheoVY50nBBYrNcVCOXNZ7N4st0sJe66BdOTb08iL7RvdKsFT30vvSoc33Rm7Gi2TkG4GxOLksd78yABm9d3u4si58rfDiOxzt+s7Ee5LwQ3WEwCtWN5PE5TqP6Drnu1nMA6p8T48L9OTiAA21AIQi8Ex6CCK7Dwu4NRtr/zsnKHqgBR7lf09mccKcLhtHqd4XILu9TjO0Km+FkI+bmLtJyeETd/iXlfkN5zpTja7eWFywM2Gi20JSVRrlbP+8aPi6WWBpFahpBXcbPnCX3HvW8jNHjordtz9sXjgdUjvCb290PAk82q14fkyiHtNyEAOSZwLKJUAdroAmvzghELg9FfqraYc+BwN1tgNZR8dZn0OsZkxMKvBPEjtcyv+nnUvPSK9Ki7ebUcmg7Lwvdg6ddv/r/TWl+m5JBP+A5k/QAyPR4TsMLSvC5bQoIauywhlTCeQgmCO84f/QGz75fO4knHsQ/pV1IdYlJRdhDv9Kx/xpJzb6MsAjanwjc/7/9jy/jDN9nOR6KRJAfIUQGo3Cq00AI2IoHtIAGIcMK42TdeeLxeAD5oM5JNsDyoAMQUXC0aTPH4EFEjUzNYtiMWTFoESU+m6jN4kVy6jTOa0evo0d7IUF+NNfNW0mTx4jZutUyVkuVpzgd4oQs2CE6kkJtCraJJ7Jr42yuDDaUqEqkwpQuTeXSKUxlD6VGnYp0asVtWbVG4yrO5FewJ8+BWxfy3tmxYU+mdNjWmduqKo1BTNrSFCm8p27RlfjWIUuIpnLGBUq4LlWjiRUvtsoXbsNma6mJpZzW8rLIl+Fe3cyXqN5jcz2PpnvU9ErO1x6tZsRaE6NFetAcieLlzP/tL7ltDxmy23dvL7yJ0BBRXEYRPLzkyeN1R8QFEVto4SJzAceo5fLeceOGL/s7WnjQjMfShSBuI222mL+NkI4fRPEncerkUxZkul2x7s9YbiNJs/QRcMB4UArrmc96eamWl0iRhCZlgjGIJp5CYbCwv047bKlhllJwwaeKQmxEEknsy6+t9EtxKwBF0ujAtVDMsEOJSFOqqbxIuQ+iGP0iaqG3JmlDkoowNIyxqIpSEskNSZtRqrcmi1JKKqnMbKzOMNTQMwZr4fBLG4EBbMvUXFsENj3SXIMMI2pr7zzb4pTTt+CGA4G44r7QZBp5pqlmkTFowAGPanAJJDpW3tH/zh1pcOmun37Am6SLLuZog9JKMc0DjUvgq+SSTz/FcaH7lhTTsRVT7W/VFs+q59V9YhWQpLWKSdBBTOh7MFeb6HAiJwvtM5VMD4sNEUSnCitxWf6axUjFymiFcUUow2Rp1ByBrMwZb9661ktgqCkGJ1JkZHJE06IC8dwml0UtSyhlhKvbJ0k7dcNbZIKqXcO+JTOoZtwoYw0owsiiCSWSQOIHH2qTUzc5iYgTuDaGEw7P4tCgxU8/eclkjDFEqaZQQlB51DtufDkZH18uGc/SCTkNBNRQm2IoFTFxzhncUt99SFWsWEWp1QFlldXFkmiUJRZccYKPQmUwoaMg+nay/5qnno817dgGkV1X2SOd3M9ZaPXrccqz4WXqx1RkuiQvHrf1Nmue4dvLR3aR7HLfLYm16V6fUyMMcIDBJrzvW/nmVyrA/22rBhNQ+EByDUKwXAQZcHDCTYLqsBTiiGuzmIg7S6dhD2neUV31XfYIhBaUufMOn3rW8cUYlbtL2ZRGAvH995lDrURnW+9tfG/Fn1Ve+f/MGen5AAk0ax0DbWJ6V+w3YSaUqYG92mqeuVaS67vy+nDvvA0fESsa5ZWxbLSp5cz4m791BS+duSKL+lptvQvIU1FDMH4gBt745bf7hW9YiEtfA61VPMbUb3wMwksv2gUmxPgLfUuSygY28P+ACXAghBewAAlDoLkntEc+9OldfDz3OYKMTlCZcwLqRqY7UexBZKtjFHeoIQ1xGa8ZqLBZEUfVNkcQT4hb22AwLsSMrSyPeWCRFtGi97yMKOV/5UMEqbqXq/qEEXylQt75mmjGCmoNgY1hlmNE4z4VwRGOdFlizm5GKlsMIxr845+UIAiuv9xHgGcgkgEdOJQEMjCCGuqZAxfoREXeDJETNB++kneYMyoGAxPg5AhFaJzOuU4hwppFJjLhE1QSAhGfG52bGrELIP5QGrNoBCpkOZnbKe1URqyjESvRvj8mpoxNlGIx1TK05lkxQH3037Vm0glZcI8gNKnF98b4lK7/ZRNE+qqkGc+Hmkcuzo1vhAg55xI/cVXJXHTcRTNu15CbEREw26CVlYJ5LwBKYjD1iqRp0rjIvNEtoBoUqOL6VkZuWtBYBr3nMBe4SU+mAAZGWA+naiZB/Jjyjj6RWkHyEJ9NiAIYu/CFH/HTy28p8XBKURDOdBlOSDq0KFE0pn+SiUwWOU+ZzEzKTPyQq+5R05rBQl4CjerNrnXTet4UJkM59MclmhOdkpHSWNAxGateFZfvpB9kAIQlrogGTEHKZxtOkc57ApSSrmDkQJm4EoYskoyZDBEjZZpQSzo1QTIliuVccIQsrOEOeKilKEYRwOIJ0S1CQdEswljEXka1/6FPfIhTFQoTYk5yb2w9ak2tQRGL3BSnqUpLgdAiErB+xg/vcVpOMnEfVIoRtptNqDaZVtsOLdVrE1ygHYl4L2BKNZ3gkAY6jHvc43JHudtBh+qSW1KSknSkAcSqac92T9HwDprOsMVqTWHIfhrFQgoU6CTtmtmmrvWudF3qsZS617rmla/IcB0hannY6KozjlCMUkbGcd3IsnOc/WJverHJWQNz9qi10Eb1VjVF0b5IVcmMB9LoJSafxme1P41th/FI2wUnNVsLyq1tP3TeUuFMxZDFHXRdLEvlyk53PKQxjYuLi63SgqSHxW9JY0kNrkL1qfQRpGDoYAu0phWB1/8sKEznq0jxrfeJvD3w23S0UBzF963rna6YSKpf+E1YfmG650XCdlujfO0aSfqmSxKZXhHr5SWsevCaIxLh0U6LipYBq2OrVp8VhvS1jvXwbI0q59tyc8SXdaKiF8w2MvKuEkkUXhJt6eMbF1fTMV5ujWl8wxv7AhfTIfWoCduFLVDUdaJg9S55mbOZALATBTnGhQ/4ViY7dLzD3ImUqTxXE4cYwTGFc6L/eawsH5TXmxXzqsL87K2cea/8lTZb7UxsDhb7zZo9NF4lXFM8f/tAd46WgRzSiS52mMiDZkhsgQ1iRxubxB6K95uRN9tKCw8V0R31prmD6RsGXOADH9n/qEtd6kesYaISZXh5CtvqFNvPbm3RZx5q/aTw5trX3IZ3TLG2bGEHm7e7tq353Lxx8oXcFeK2qYRZTmcxV7tLejEzgUm8ZviCjcoJHG9h4K1oZLy85lSMsJ5PJOEe+TlYHT5lKudjnw9Hvd72rouxwWfvSEu6d76j2aQd8XVU8JgV/GaFpnmRumqgfeBn50XbDf6JUcAd7qXQQxIid/e7z8AGaLC0ESP9oEMg2SFCCny31MpEjpIcxDKtEFEVr2Apq1zlO9/i1NNoW4LaD/LdFjo7Wq5nsNSZpnHBZgWHXqI3M9ah12b0hxDNYJzPvNs1Ef3pw+3yccdLLULxsLon/6Fhz01ilFEHOW7B5Pqq3U/xT7lL77buu60TNk2x+UMjvh53Vrzd4G7HBS8K3n3ukxrumsD+J+yABA+EIAMm4ED7P7B+ieKh736/C7nKOYtDeIGAQVQyrv+8+RBrNAqqpqXrNZHTtZC7ugCsJgJ8PJkAo5LDvCjruASCuc/DPdAzumtjM6ujPbZAvdTjQEYTwdZTMAuRipPjplxhMHOruag4pioSOv5IOjCqEN/zA9wgpJDaovJKtmHKK7dRQPhiNVH4lDtAAzgQDzTYgyQMhCaUv0UIu4ODuynUPvGjhbkbP0b4BE/gAx6gHPfTADEUw8jpgvnLOqcRPFvZsAc6L/9dccDZM0A5HK9NUL4D/LnZs8NuazQD7AkBVMFFC0RSWYhgs7yVuynPS0RkUkSb8gpHfERI3MDPCEIPzAp3EcDCSS+OS5zyebcO1J7RAq0XJLoY1EBqyymlgy3f8xwv2JxVazeVIg2X6ic7XD5KugtW650j9B04WEJeJKw3+ANHWA0qxEK5Gz/sizvyW0ZmXEZIkLssSL8xhAARCkMxtIEz8aUHBJY/YsO/OB5NDIUaRKM47AWS6zUFlDcGBEDlS0fOAp86HMB4XDpzdDSdQLQRw0d93EfZm73muT0MbMRmqxEOxBVMsDb/uMTzMbOFWhKm+sNrSgaIFEcI/K86Qwz/SGwHUtxIFRlFVLxHfOuwVfoCV7Qv5xsl/GAsh1DJb3wIeDIKd+NBSFsIU/KJIxwPwRIsPJi+2MhC8kPG1mBGLQxKogxK7IOEK0gB96PGanwADYAAaly/YCyi/6m4SSgnzJCFOYiCwvvGuEKxZyKyd7THfIRAtnJHyQsWtcxDOpxHjvLDOcyR5PtEfpw8PDwFgFxEGTQm0rstkKSIhFRIhESQLeNEpOos6zm0N7wGA/Ev3cvLPLO9rQiFLvKSBnQ6F3ICGnCCM8BBj3qap7MPSVIsuMCMrJwFjpPJ2SpCXSSPnITCoPSERChKTbCDRLAD28RNNNHN3SzKR+BCN4gB/6WcRqjsJKj8JCyYNGyxSlmAC8EgAkxYM3C0q7Ckw8skS0qsQcdLS7YcKu/8TuycS7k0xH1ky1rkCMjsPJqKRIaUSL/kFVEUzMHUNt3izjlbiVoEo0r8No/EvVKMzBkkBrFUxacDvj3YSkFxmM2ZExU6hBUapddiN9QMF9M0zaq4I24aRCJMhJssj5w8k580JdyczdYQ0ds80elL0ekzymeEg7ubxqcsTk6iRgsQARuYtOFpG8IjIKzEjFOYptPUrJ2TmhVUtzgcT4oEz+3Ui7hUUid9UvFE0jysRfP0R/S8Uiz1iJuqPS5tT/fMFfi0RPkMBkekz4n0Gs5LzCStyP/GVIfCucCvYEQAFdPHrEoK4qjfCz5W1EzOzEHRaSWJiZP2eKFVAqnh28HRjJevlNAN7VCcxAM+iM1EuE3bpNTcTJNLVVGeLMqkDCETWL+nFCEISABSJdXj3Luv86L30BYLDYVWrIkg5av6oxC3tBqzHE8IvNWzJE9AbEso/dWwbJA1Haoq7U5bzVJkxSL15EuCfE+aayOJ/MMyZSI0tU85q6z8BCPGpBcu3ciiY1Y3hcfEA76nIYjNHBIjPFDbAFR2DVQGbY+PAjxDLTK36KpcPEIPDQM4EEY+GFF/nVTczNR9TVE32EmBESyBSRMYoEaozIATGIHiHNVSNdUMsIH/JRBGVPgUqEEr05yE2tAe6TwVXXtDX1VLXcUVYI23lBWj/1vZczTZ8JTSXh2qZK3ZyGTPYiJM5Du2MU2Gaa26NtvDKsXW7IRPbtVLb0Xa0AMLcnPTnvBVcp0D18k/Pj2Dh6Ol+JiaVmxXdg2dOAmqCdEJ0aRQhwCy6NKEIySYgdVUgLXUES2DgsVUOIDbnLQCHtiBGLABvb2Bp4yAhn1YCYBKBSBVASgABFAAqDSBG1gDYdQ3dcIMRJCYTLDQnJs5Bx3Q8vFO/URZeGTSzlVZlw3dlpVHW21HSjzdlAUQm40wnM1ZnV3AwMmgb/qsiDDTnU3Ae8S50mVTgKGn/1Ta/zlNFR6kyNYqCPmoGBpA19+CNUAzCDiJEz7dHOltxa2d3q/tns+Emh0hOxSV232NW0ztXtwc2LnVg7kdGEq5Ab2bAbwrIVK1AAjIAArIgMAl3MIdgAT42y5g3L7zMnvyWLNKMviioMsF1gfh3JZlWSRFx5UNTQUmWQjOi3ucWQpe4AQGT5JY3VIEV/apT6YiSI7rhZ8VptcbWtPViYIkXghJmsLQKesC3uBdWnPYnivjooPwqEkwBUmQ3o+KxVwcV0xwUKe54YNgpQVdUILA3utFCFqdhV3QhLY1X/MdLCnW1NxsQoJRk4GBghtQ3y7OW/ZrP/gVXPml38HF3wG43/+oHIHFlT8i/K0vS6fI9QJTiKUZQRafKtLM3ePrvASdmOAK5mM+NlJCfmDNJdmnu2DRjeBD5gQseuQN7lLJ1Nkok8/5XIzDNMQGDNPLDOKfqgUWBgrnmR4thblInrCnha0MCypoMoU9sI0eRqmQhDpa3qLfe97OKWLnfV7OROI6mJkTPd8kLN+19V4tplu6NZiE8WI2ftgRGAH5jVjEFVw0ruZT7WL+fWMiimNUeGU6ZhTK9TgHgZpBlElCrGUe7Cq2KWTfa2R2BjR4duDx3OMG3lxG/jNIzudldd1m3bn7RJedtSAv9eDbNcSKvAaGSFIHzQNOsMipKIvTKmW9lJb/gRze39swqZ3HrRySZz2nviywa9mZ3xvpAk3kiy7e6q0NMgjm76VbNbGDtXVpZE5mJmACHvjiZ85bZ37YMg7c+kVc+zXc42zmLNCDEiXCHhuk5K0E5ZKSo1iap5upAPNKrKSqx81Kew3JLRo0VHqt5ntnli1peaZnQ7bgN/xjkx5pXXFhfT5lSQZh2f01EEw0gabTNCvhYrVcTogFFEw8T45OpxZliCblGFTWmJMzLqo41mo3qp24Ds4bcxqnlcKoPzxpz7kDlp5puA3Yt9Xsuq3pL8bpnH5m+U2BMo5map7Y/JWA9dNpweJXsGM1kmqEOgmE1NGqxvmfcOEzuTHN/yrZn6xCLuHen+oKbq3SL6uqUOM5pXiqSSIs5z72XLO+YP0E07CsbvqAnrb+x7ceaBE8CjVLM+Sr67nGa149z3N7ww3bC1vzXVd57xcuC8POSG6FWpww3psREv2TBC9xFmgF1wmzEv240A19abXdbM723pnW1y22adH+1E8F1dI+bZ8m3MNdbdbOu8DC7EXA0WzMoc2RAdShHSBqJ1cTJOPOigr9L9Pssunit/zybRg7Lk+rcRtnLuYa7hlPGf7zLcomXSv7M+zWlezJlQLVbqSJ5L30bvm6rGh1z/PRl5kiTNmtLdA1714bBy3f5IXuBGpDjYyoMPiOaDKnaK1ACf/HulOfwu8hmjWOvhtuaV0ql8jeleH0XPIKfeLblGk3SPDxHV/PbvDQ1ttnHsPKEcOeRm0EqOYZJcOcvoH9fYNQiY1K8J0twAHiiIJGuO0csyMXVzq/FiOSFuIHIWnng7pW47dYkh0b9xNFyQ7t+I5XX5RZh/XZcYceOi4wgyqyLl2xNnVAQ3Lt1siA7G4Ca8gml3KlgOvx/hB7XlLSnQq/9sZQhqKOGHMxv6IXNpv+OedO8ORVFSmt3O8WXk/ajc9zt8A7909z+6EdG4U9n2k/D9hAV2bQvukcOAFmjnAxlGbBtfBF5yT3y+m9fc3qUwjxwPQ7oYEtEJkYM9sizFr/GFLQlJaY6CUOjJeBjG+lOJmQwbK+KJRtkmqU1Cmugss0R/G3TAu4ReETbJidW6/x4SYuezrxrVYI4WuhkRb27Y5hJj8+tcpkOKdzKLfyQI7Dwpn2VXVMq6Cn95aewT4tF8mpbRBQVdaVxW63qelKcy+HdBc9/0RWGFZPrDLbUahNPNhiBMdNMGh7QFd7uq3pex90ZyZOf5fYgBfc9hvtvaUUYt7JQDCC4gABwmf4ReC3jN0DNrGYBOVax8d4wo98yS/8GaIokLn8OiCDXx4s++r8ST1JwjrJzx/9TFhGbX5x6YLxZcA0Guc0Ha95H7ePseB5SL5Zgfx5THayw9S5/y9dwYLOT9ANumVQOjDNg8GodrmAaFhBC6u6IssgOtpa88FYiTR0aElWd5cT+zun+hx7DQ5F5gR3+7efadDOAfMPbRbYafm1e2le9LzngNYG44my2C64Ap0EfMEnIf0HASoAiD2B9px5EoUGQoROvLQ5M8cPRESdOE2qaFGiwD2HIJ5puDAhiJAgFRo8GGUIEZQqhxRpSaXIlyMvSxqsOTMmlTFbdJLhSQZNTzIE6xCtc+dooEZKRTFFhWrXLmq+pFKTho7b1axasUqjGo0e2Hhi7YUlO+9s2G/pzKlr63YbXHJytdGFZlcZXmR6ifHt6zfY3sCAexEmHMqVK8F7Y/+dwoQJMeNTkh8jPmz5cuVOs+ZuuowpIrK5cI8JK1bM27p7+vaxJov6XLuyYeOyrV2rFjBZoShKguhH86xJdOhobkZbnOhyypczb/52Odqzzp9TT47aK61RjPToKePdDZ8+dsa7+T7++3coTNbnaN+ex432J2LMN5HhvgYJ+vdPQJAAwgQT5GcCffHBZ0MSTXSxIBx4OIgHFTRcMCGFICAkkggi4MCQRkuZ0tlmuQHTjIglivihUgNpNIdHUTgBUoYJyZiQDAjJgMONOeK4I489+qijjx8ZtFJNDp0BVEaEKLVJU1A5ictU0lQz5ZTvVGMPOmORZdaWaYGlVnXN1XX/V16K/XXmYGkWBtltZlZGWWaTuUIRm3FOJos344xTy26OfUbHIb1cY9xoppmG2mr41KOaN9S8Bts6tdEmqSm2WDpZb4AyWctGkoR43HShzuWWdKKGeSpyeTZqlS+7aLJdd+XZAQgkdoBxXhm3eicFr96x5x6wBt4w3wjFGpsfsg8EiOwHKMTgHntZdJHggl1c0aCDaMiAYUgTirThGXtsmsosIxJ6rnHLOLquoSaSi2KKGwHlxUEwxnhvjDnSiKONM+7rLw0ppGCjwDyelBKOL6Z0sBEufsGQkQ4VJdCSTTGlCTCxycZol9F5Kalcz41ZpplpJmMyyrGkyaZfi/Fm/6dkMcNsZ2jj6KUbnRv9Nii67X7FmqL3gHNdN0WD/ChsyFRKzIe8DRcoMcL5gRu6plqtXKlraU1q1lfDteo50kA5inbdkQcIILaCgd7avfb6K9zBCmvsCMwiSwGx0K4XhnpATasgUNg6yFPD/Gq4UBu/LW0oXj2n67jPpAnzriyUmyKKUkPRu2HAMAL8uYQWgi7hhf7+eKNKOSK8MOsoLUQTxA8HRdSWqq12uz61d3x0mCOTjObJwaccjMors1xmZH7a+Ricnu0mZ81Ke7YRcTXH5YzPiAYdqaqgfq0xOX41naninB5SnPdXdx3q+ly3X92jYmcHK3njpS1rr227rf+e3nHHF+x8iHUfEzSLBHpDzxoSeIUr+K1aa3gQd+7gty04LFznW5zknkEmnjGDgxrsYJmGkcFboKlclYKXijQSMYcpzAmcC9iO/jU6C2HIdDUimI5weKPWEUkGH+Ecw1yEuyEOcXez6V76Nvg7wgivZCszHmIAgzxSOEZmM3Pey55nPenxRmeBSo7vnBEb3HHvOJPSGDMWNz7fJMYU5wtNo/SEqjm+T310NFpW5PeJPdrPfvcrT68AuT//+e9//yMB3YplwByoBwpuUyAcEhjJSNqABX5LCgT3gCSKnbA0SvygB38XQlBK7omWImHlmHJCFKGoIhmJiB/CRZRY+qb/lizqCMTo9UMXxhCGN6QR60a3uh0CKUhOICIydfcx3i0njKJ0oinbNJjISPNmb2renKyIRTpdJo6dyVktQ3GNOF6PTM74me1gY7SvndEbs6AazijytMpRhBjnbKcdrZNPdvBzn6hh1dhK8Qm08cF+acBVIAXpq/6tRwr+04F7CiRARjq0kRZF4CQbeMlALOIRlZBYJcglIhGK8JODCt4on/nBUqIympV76SpXuRRSNK0SnbHpJhoRs5hK5iKSuMiKcBk7hmwumAsTZr9Ot6MhAq01RQQfM0XmTGguxqVQrCbxMIXN5W2Tm7XgzGUQEU5Z6Klq5oQLloSmTnbec63V/xzf05hWKUJ17452rSN08MocSHGjGlDa4x7T5kc+pOGg3wGD/hZqyLfJrbERdRZF+Ret9Uhykhl14AOz9TByGQMqkSMlaBsn2pQm46TQZGJprArT1VquTTB1lwlPaTmb+hSoHPGILn8ow90CrKmL8u1TxQLVqJYztCMEnmoZg9Ws+mmrjclmV1/2VT3FMxRizQN23+jB4oLQHGmNDdHa2YxTiG831OtkB73nsa35c5/5HBqrAlu/8BTioG8AJP7SEzdHWlSy64HoQyNr0SUoyApQqGx5JsnABKJhIAORmFN88VmTlna0pDXuM5Gr2pa1K7Wy9TDjWNpS2cK0aZm46f9ExGrbh9yyRULipQyB+1sZ5269cyxUhjW84axiFbrK06acJiJkbnKTGnpCcYpnqd2TlhN7IGRGajjGlnaeAxihGNFLzQsomEZDvVxrr3vZ65ysQcqvuCBbQXsVHvHcF79tngKcvQPR+OwPonbeL3sqylBGEpi/a5BVgiXI4AS+IRAsSspIGWfaCy+60Y5+MqNzzGELh1LSOu7LO1mbCXrqppPBycSJkaziV3aEDkItyD76kerfqnrGrVkmmKjTZe5S9dI9Ph5zowvkIUuEyLM4x5FF7cVNRM8utD5UOkFGV7a0iRk8lhonOunlL0+HuGF+b6SqIbZHbOcKdJaVfdv/fN83y3lY/3ubDvqrbiZUtFfQaiTf/BxJWeEBkgxu8LwCkYrOTpjS1vj3o51Z6e2O6dikgTTBB16yhQumXA0XH6bNpbRy3XTTMdXpJTJukYwDrR8e/ziNa2zj3n2y1k88DGqteZuVP5uKWcRMkF+exc0Am4spHrYsQnMo7jp5G1EGL1uvk0aIUxEimpkrPqlNZmtfW8xO9647on7mjvJhDfABsBveQNg0j5vcUJjPnbG+bnWrGZCTbah3IEnvQTPY0H7QN78VjXCBiybhdC843o+d9yQiXOeWDkyIc65hh3OwrBM/EWst93GP16PVrQauloaGqp7/fXg8Xi7LV85V/yJHt9ec/3WwwzrsTe+lrevsMmAQxb3uUoq8xslyby5I1mn3E2t5tWvTn761rOCCfnCwwbMWeAWtF5SwXRcknQ9pwGLxd4EDRjvb0N1Qeae9O2xvYLhCKuGd953Shgc4+L/PMzDuvfzmJz+Ou8/w9a+/rO7noMRFPOJbLL7+IR/5OpVdcpNnPuVW1TXnPQ+ReR5FEJuRjdf0DFtn2Ex6zdrpTc5prB7rtUUamcLrXUoX0VTqJV3t3R7ueaDuKV0H8lO2+dUocMcfuAHwsQCgPUIkQAK3ad2bqUe66UDdaMCxZAALXIu3LYF/Ud+utJu62VuCdcH1dcEcXIIjAMP2Pf9OwIXf+0HhoNRdFKIfXYgJ32VhpOUYpOnFopnJdlWhWalU/ZVhyNWY5NXVAyoR/10V5mkezAUgAAbgOExZp92citVBPW1aA+bfPbVJ0jyZpBzDYdzFSznGIfzUp+SfCI7gB1qNXi1dtkmDJiQCCt5ACtgAf70BJcCCQPXBH00BDfJXBgTICDDSCFiAJnqHgZBdEDpffwlYr9hbAh2Y3yhhhO3C3I2fFIohFU6hFQZjFp7fVG2hvwHeEzLg+/liMeJFGWKDqjHe/X1DGqKGVLGhrV2eNrrhHG4TAdJh2FjZN+FhpwgZ1TDiW+TG7L1eBwGdZEgcPcmTIjpgyDRiJFL/xz3m4+5FHSUuwh/8AbctAfAd2BU8wi94IiVQArfBmXoI3wlwQAEUgAnUIAfcAP8MpLWMnUa6IoMRZLVUCx4soS6SiBMSYxUKo/thYT6hZKo04zE+4Uva3TIy4yf5QxnepFPdjnABHcmRSTZa1Zo82210Y3TJYTPU3Dh2gljVgYpdEMotG9LARbMJoh0+pbORUGOUozLQXu7ZYwg6IvtcBT5MHSM4wiPAYKx4Byhgwy+UwiemTZwB0ghAwAEUAASMwAIhCLwtUEZu5Cjy2fQFZrx9JIEhWqt4Vkm2JEsC3Eyy5Do5pkli2C4ao8KNVmPSpEnZ5E1qpqIEDRntZKz5/yHlyd9giNOVKQ3xWFNVoVaoEeWQ5Yx5NVeR6UlrPk9TluMmNBseIc1VTuWy8QnVnIiWeYo2MB1Y6uNXss9xak2UvcO2odlZwqBbfgIs/MI0wEIuTCdBFV8OcABd/sddsoBFUlYQPt8P3tnY7c1kGQiDmGVUMGFimmQzKaYcQSZ92icxSmZMVmb4gd9WXiZm8iLjfZw/QCNnduZnwlc1iqaTkeZppSZWodxu1KY3yuEAfsbMlRWF3qZYPY/gtSNUcY9cYVAd5olVZpl1YdeVcaVXPuJXImdzmll0QsIelUIuTMN1Wid2vuV2quBdAp8GcACBjCcC+ZdjAQt6np0SLP8pk8YHFhihKIzCYXKfsV3hfSrHv2EpcjCmlqrklX7ploZpZJoUTFqmTPbnmY4pXYCcPOQDP+SDZsapZy4KVygomNCj7/xFL5xmMJwmygGn5lmThM7hN14obHpVWSUgh3oo43DNThbDh/hmolKNoP7JF7HoctZji7IX/mFb1PECLwAWYEWCjeKodV5ndoICDG5dGkgB8xEWQzoSRilWgCGpId3q3NwA8AEOHLjnlFLp3nVplnoNfqrpMN5dmtrdfipjgOZdPVgnNyQkPrjpm8apPOADNmADndbpgq7hM6AJNaGmSyUGaj2laxoqb8jcbmiobXIobr4UaSBNl0DDiEr/UboAam82DWhgqotuaqfannLGKKiC6idMp42qgqmi6ltyR9tYpBtEAixQQh8IAiCEm0IdKa6e25xlrK4mCEb26lOwwmE2YXF5abGCqbGW7GKm7Jku638Wa7b2AzdoB8awgjRgqz/AqU1eaz1wRc+Cw1R066w9WV+w3JX9qbhuYxyOQ1H+lIUeqmeAmvuJXqfgZm6SiKV8xc9tiTvha2A8z6C8E6YMxykAoxr2q6TUxsit7dKBIKmkhnPiwsDWqCeUQsJOgyrAwnWqakHhDxSARye6ZQwa1q6cXURFFNjd6uHmaoEQKRSEpCNE7lPwW94Rq8l6KZqK6eWiLOeyLLIG/9zm4t2i9AM2+AJTRC63iWw1QCOc6iw2VMPPwte6DM3Qukm4DqqEBmUcEmoVjZqhOi03uV9rumsi0kmI9IXWRsqj9qlV7slu2FOllmOJauqpLKckqi3b/qv1jpGVyK33uiWo4ihbnip2ZmfFZh2ghYfgFh/hFq5D5cCBNFZ8nICtHm7jNi67TQFAquojiOyUqqzlCmt9CrCVZq4Bl1Pnem6V/iKaLutidqbMuorkmuWrSCk3xKzrKgo3sIIxAC04sMoBLprg1ck2beOemmbTYkSH/u7TTm27DlvVSsQF2pO8iiifXO2ggG3YDiWGcsLL8qu/Zq8Qb28/xYaVmNnADv8sLIQDEzNxtu5traQl8U3s+h4U1wXhndFH/CJuxjYW/uav+iYkK4Ss/y6wMF7bAGuuGhNwEhWN56oxMCbrF6JUHBfwGnemtvajP6JuWVLdHuEC67ouVkRJVYQwCBXtUPapIpem7u5u59XWa/baCsscu76wF+HcvWat5IGm9OBwJzOg2KYoJgQD9aJtEA9xEeNVEfdV936v3k6DE+NtOGDDji4koNEoj7Lvxf6K4nax/AaQuTlpGQAkLvuvMXMwMXYlG38plyawM8Px5+an96kpVkSdouAC5ljiHpflq3CzJtACL1hn68KpPGgbLUgFlsEjDzMviFTV0bIJ71qXCh//aqF+Xs2EWgxXLVN2aKUY2eSQUPIubztz0VdF785Mr3GeMva2qPYGbNT5VRLjqBMXAi5r5xXrQUVDAijCqq4UbiEtUjDnADBzLDCf4g10gdYJgqra7DEj8z2tsTIvsx0P6zPXNDNP80wzcLK2sc++QzlXojZvMzdzcyL0MS1MSZu2rpVIg2c5HOJJKBfZXK71iWy2q3XFZvEqZRZdhFGWC9OaVz4vqmawyymJwxi5IyvZ3DWM6G7kAXEitCmjssfow1p8DIySICt7Ly+8cjjwQy6UAbvh1wLBgazQCqhSdI8qVK+sAC8fCP2G9PyaNBd/8fClgUonJCWwQmajwjCI/+ww4GlMB7BNn6wCG+sPFyt8WfM7YLODaDMKBjX9/CM3Uyc2jHM5b7BTxFbTEPTR8jZVVzUWqXDxTvJvv6YAeuFXi3JYV220vbRfJG8cMU1uSrdbB4PDUXUerGhCM7Rc2xisETF4XQWVKLHeMjEvhIFjA18K7CB4MELBIiRapll5ht1ki/SzvIe5FQvjjnS6TUFhoY0jCAIFa7Zng3ZoXy5Ni7ZMk3bmMjhqp7Zq04IltvZrV3hQc8cekw0v4Og4m3NusxKIWFzOdcY1VTVGyDPxEuCJS3I9I0MmJPdyexFTRpsmR4MytBQ0KBu8ZkIPz0JtYpcFbjc+DtdCD9d6if/cd3d3CUJ0NeRCec+yCgKpBVSAkLLgG7ggfBfffG8sfvdyY5X0Y4e5flOUf49b5FIst4mQSyvmgSu4m4/2Gzs4SvIVOhxxNVTigxCChVf4eGhzH1MdOGPwLIuNU3TGicWWzcGm00qyVgs3c/Nzh9azZ4RGKJxYjOuz7EVg0XzYUboViGwCbg5vdZcyqZdykp/6XCP5lxj5cYZ3VlBJk+NtbasCJDBB3fTHBGQi4NqoQGk5rdoqIsEH/YL0/+g3mHfs/Zq0rPq3Ggi4IKj0MX92aLY5tbcxnOt0gh+rnKdKtkWdO1TJKBDCHby2nu+5a+sBUW+zr9a2UjP1Lvj4ppX/C6i5a0VkYIp3CnFL+nGv6JFd+iXXk6bbOKez1QKCeuJU+hplN1yX+pdpjF2j+sfopKqn8vU6/DpwBUTXKMLiqCeoIAdEgAWYwBXwQXSCgpajr57ddw0kUpdjLGTjdwCNuSO9QWFd9mWLbGaXMZubcrV/YE7LZ+hu+89z+1ZYST5MQyaIu9InwtJTeATtuWwLdcGubpuW85QwNVNY+jzXVorvczky+olbaLx/tb//O9IFYqB2+vd1wiwJWWd0yuydLchU/MMXuaOihcSjut2HaF5nR92Kb97agQ6kgCpatnS+YKsilv2gvHwkkmQvbsvjb7LzN68YPqk+O7RHOz1u/6py9vyNLXic27HQq/HQNKc1wykvTLgelLvZtPZRQP2Fb7M2Z8IobDgs84PVY3MmTIyKKYlt3XsXRbq+YwY+l/0ln32jGMPkxIw9CW9wsNhrDocBstPn332S7/2X6GRdU/yjZK/yXnxe/3EuICzCdnyxpMF0QgL4LqQUzBd31m/jhzQAJe6xU74bsAHmizGB739JAYQ4geXUETR4cF5ChQUTInT4EGJEhhPJDbR4EWPGg9Y0VtRm8KNHjh1JXgTXbl08fdzq4XPpLx+uRHrw1LRp805NODtv0vSpZ2ZQoTMZaaIlbZo8edOq0crUiFBUqVOjIrKKqI6fQ1e3ckKE6f/qJLGdOJU1a9ZULWKmvG51+xYunUOd2CIbdw7vNmXBXJ1ydUuYs3N6bZk6NAdxWD905pi6Nq6iOYrdJlNOJxllZnqbMXf2/DmzPc4L2bWbSLq0Zs3cWHPDBQpXrly/YNWG9UgHFEilKO3u40ZKmSlMauRgclwKE+HJjTd3ToJHjhPGp1OXPh37jRsjYpw4YcM7iylutKTpIwh9ekqsBq0XNAz+Zfnz6aMuLfF+/fwG7ePfWDIkAAUUacACU2KJpZdgkmcUnHh68ME7ysjpwZ/0sMPCRDJ5SihNeGFKqWl4GYVDqqTiCq6w2lJxrBZDISWtWkKRxC2wUnyLMU5k2cT/rmUwg2atvgDbxhtzqAFmksUSu2qONg4hppkipSTSMiqr1C810LTcUjXTvFRntC7FbO01VkZhBRTZYKMEEOAA6Y0S3uwIbgo6g1POTuaes45P66qTTrvtwhuUhdymKM889dBEE71h0PzmsmGwnHS//ir1jzT/CCyQ004zGkk+UEFViSV9WlIKpnyqSYTCVl2lcMI1IiyDpld5qgkoPIbKhBYQq+FFpqek2qSqrPY4lkWrvGrRRUkwQevFG6U9zA+6eATmsR/5EtJKJJVcUslJmomyyE0rO7dLdLmcaF370gWnNdccceSRenvrg483rsgNkPN6K4QPLsAYmOCCCb6z/88+qyM0O4bD06HQFd5ANFFKBomjN1bmhU9SSj2u1NJLMdVUIk9HEhWylM01GdRvVDI1wQUXZMXBB2MVztVYKZTVVltxCuOODWn5EBumpnFqw6yUVswqqMRK9qtm/SJLqxqZjouuWWIklzJhZPSLmXGXMYwxxBKjw4vGelxZ3dO+bBvuuEGL510yzUSz3nz13Ve8NPQ+2E4wMBR8YIQTbtjPG0i4btDGI15hBUTZQC+SSGAZZFFWhkGPFUg9/xj0kEEWneTS2Tb5dE/B0edlU/tB1Z+lGuRZQtpbpd3222uP0GdXCZlpaKOb0kTYqZ4mFmrFjre2ExSdv3EOHZnZ5P/FHo0cZltTsAUGGLK/RcwLL+YSO3WP8PsssvTldrvdMdeJt0xQHvmD/r0BpRNwKJyrE38wklNBYSO4DuO4450CNu6AOoBcGhJFOUH8AjaDaA/nNva50GWJdBnUYENM9x8PSgRlH0Qdyl62ulPJTCnccEQgdsfC3O2OZ7zrXQt7lhMJ/Y5X1XiH0ZBWPOMpj1kqop5XqjatFHEiE9Mri1oE0w0gySgts+Beks5gNrM5wUlSJF+AuNjFjqyvfWF8F93ixZpc4K1+VzCccQLHPz01h073gw4BG3ZAAyIwgTqoUwMl+AtBSJA93MAceubliPhY8ILu2uDoNNhBdIEQdSL//JSkTmJCBcUOH6zRWCXWgAYX8kRWoRQlDG9Iw1HWcA2EAFoYVhmVRGhCh+/Y4dFI5MOmnSh5VDPiW7iSFR4NMS1NjAYzCuMXKRrGilVcjBMao8XHPBNIz5DmNKERzWl+UDIGmZL6wJgu9r0NM/Eqmpnm9QZzLuc4+wtc4ZITxz4VZ4CM6w4e52nHiB3qDZNTD+XYkzGNFTIViKSU6LypSINm0JEJ9RQkQ0hJMrbkkkVzBz5YUQlk4e6UGSUlRkXJSqDdTKNZuUMdcEg0WTKFFiRy2g9ZCMQkFVFaz0PEL8kCo2J0S2tRnEQV28BTP9QhCszchDPDBs29HDUZyqDm/zW9WBBueuZKUf0mBqk6t3ggKJPSkJ8jzGlO/73xOf1jJ1ils7ju5KA4BqTjHe05HUPhMw1qUMM+MTdB9LxhXgEV6EAJelC/LnJ0CqWPRUIYyXKgLBous+QlXYKgFSILlBvt6GQpW9mR5sSjnbxDZi9bB569MnjYCMc7gCWKRbCKpbeU6Wqdt4lxUM9ZWaNSM3KaClvs4Qw95Ska2oBFSQyVe+NCxnCJW9ykIvVkXyyX6ZYrRsuMiTWyzORrIAEIPlzXDoXLzf7Y2MY1JixxDqNAAe25XTVegYFs0Ocf2Qun3hTSEYnd61+rWl/6Ajaw+X3kYCUp2P8c0lSue92AIf+ayRWiAQ07sezOLLtgza4Swg8eJUmBVsqgfaIaSZFHPsapiRVCBVm4RNaIWfuWTkxxLGCjxoq7lxZO6nYLVSTDF4Qqiu0Ztxc4zjFyk1s+K3XTuVmq5FVj9itg3csObMjuV4OzAik4uZ0qCA470wleP7XVgOPlzuKMo0DIqbE86t1nxgTBKHM6AhXgkC8i79tmN+v3IRyE85zTIU3++ncjDg3wSzJZYJf44sAO7mSEI9xgQmeWsx4lw0g5a+GgGSUp+eBw0aRBoppUpaUkLrFVqrYh2HZFFiv2Rm0DkdsYm5rGZ5hpFDMRI7XkGNaw5rE1jsrNbv3Y1k7E9ZakOiX/z8RLukVTE5uSDLCDMXlgUu4flLnc7MORAI8IfOt4qC05Me/TgYREsy9EbcG/su7N4dYvfhFKkGdc8Fx3DpVDF9uPfSTIJY2t6CdrV9lEHxrfiFY0Gfbdb31vlpVw+N0riSZpDg8PxEsLsUsVEz1P8zLURZpFI0Rh0TOcegtP0PgTVE09YL6oL0KK9XGXqlRo7rq/vVa53PByknu4A6tFEzYseIOvQkzOYFIAgwqS7T+e7/zJkMvBCuRYVug0u3FadiuUKcZAp197zO5ZT+a4zWb6gjtM4iY3f+hsX5GBDs/wWd3L4h1dP/9ZlbursL3z/W9/v53fWXj7oAs9SkYE/y8c/AiHsIknlWMVa+EN14ostEatwd+UGhW3OMajgIOgRkHVMz0LtEZu3JOd3Mco1/XK0VclX+Pl5ROd5VL2DgtVlOJyhTA24XZuMNfvXAVSjj0Ah744okMb97nHfeMWGFc29EvMcoW6etwLp8xV8nNZV75iva71csfZ+eju+te/AWDXuQReZ/8zKj7pdu/PHe78HoO/4w7+e3dUV6clGjb0vndckCgRCc90WAIRrpwafhKEL0b3oMLbUxsBB2RABqKA43wpWijP8kju8gpL80CiAR/QqSqjkmBO9IJNtLDB9EyvPczADFSvEAxGBYCgYESQYLjg52Bv9oQOYnSPBf9JgOm4YPj2qV+Ir/hAgcwc4VFWDOuWj242A+t2kG52MPqmr/nmbOuKkPqsr8DaLd5kSRpQC+DYju7MjwrLT+6u0ArCr+406kJyaMP4Qe9U5TVOK7WqBjGGCkWAa+LSArcy7ggAUAAFkAC/wABBrhdiIRiK6+SWamWa6tZwDQI7j11CgwKlKylEq/RMTxXaAwY9EAYFBgwgEQZF8BE58BF/jueAAHJuz8s2cQU6wPacrBHPQ/UkqHJOkQbhBIIgKBLWhBJwkBVYA/lGQzRoUSFYBwh7cAiJcBePEAknZZiMYbHqgQmb8B3QwSkwK5Targq10AqxMAujcfya0XZqJSf/iKLgwFDSaAm15k9J0LDTWI3iGmEObAAOXUAAQ0AOw6cOPI7w8hAeiavH+HAeM88PAZFtpCQlHir0LFC0fmERI0EVBvIDG9ESJxEhzaASOZAhLREIuEATPdETNVELVGC8IqcPTLFyVO8ULQcVOxIUSoE31qSubFAQ5uURfEEWh2whcHEeAswlwU0Ie/EXa9ImaTJk1ExSYBIcfEH7yk6TUCvg9O0Zr5Aa4Q4ak1IpjfLfLEwq0i8RPuFD8k4bj0YUAO8bJ24r2MLF8o8cAdAHwjIdRWAATy3/gisBMY8B1fIe8dFKuGib4rIzgtAe+lGWZC4cwgEgLccQVOEVVMEM/yLxICcRCB6yMAvTDIIAIgtTBYRg9jqAATogcjbxMClRcv6oNjRSM0/RFAeB5niDFWvwveiHFXySJXMRJmPSJZkPNWYSJwsqM/jqMmoRS8SkJWeTB0ljGHRSGAOM236yHiiQ2zSh/pSxdjxrCpPTGYuSOaVxKZ+T3yQMZ2olVoDi7qYh7+BBDAEODcxGe2ikEkwBxJrGD86g8cRSBEBAPcuy42zsxoqKLeuxLVHHLX9sLmuxLu0SL8PhFV7BEAxBEQBUEcyAIheyMkMwIlMQFBV0QSezMCdmYsTsFGHBEDSyECwUkELzI4vvEdJjfuAAzYRx7HSxB1PTRPfBRHPT+f9gU0Vf8ibfTBcVyzUzg5KMYTcTawJ/UpN8IaU46VjiLpWiU9+UczmdEzqP1EiJcrMEjkIuhFbcoAt5IR/gQe9oAbe6U9UqTvCqJnwCMADVE0xxIMb2gOKOCUrOdNZq7bDWMh+zKdcisD4/D/T2sR9ZYj/7sz//8xUUQRcGdPYYkjATtEFTcPaAQAgMNQiC4DAjpzy0YHI80zY6ciMj4Y8s5nIMwQY1MlNN0rq66g+gtBJwcEbxMz9PFEVXs0VXlEWVb1RZlTZdlVRTlRb1imPW7FT9DEVPYjh9ARVYBcKElO6ssBmZsjmrIEmxwFj3TRqrcJR4Rw8wLByodFVGKkv/r1JJwudau5QGwPQCupUGOC7yPq4vgEnk4lEB1TQ+33Rd4nIZVEZOQ69O7zIv8xJPDaE/dQFf/VQFYFAMDMEM/pMDK1NghUAIElMMGFIx30AFMfI8IHVSqyvbKscG93KCJqj48OWcrqALumAP3iDNRhQ1W+dWR5YnbfM2VxVlrSrrWlVWs+RVY3U1c1F7bBQ+qq4Yg1MWfcEYdmEXejUnWEhYgZU5nRFJkTVZizYaWWkMptH7RClCnpUqsaERZiwQtDS3sEhJnEBrnYAGtrVbwxTyjEVcQQ5G7BAPKy8B0fQY0vIaTO4jtggy2pV82jUvvMFH9LFUC5EldggRWwFP//uTT/PVEgzBMf9VEQ43QP9TDA5WCA62IRnScQNTCxiTEvulFVPvXiBBczfXgQaBNzayUi1GdO+lTQoFPHAABi6BFVTTFvGTZF83JllSRUl0jFLWZBNiRl8yVk8WZnsXd393M07Btmp1Z8luZFOCR3VWilCh4qIQwYh2WJW1WI00GpfgWJmWCjEqVhihGiRNGkYqPHFLa3sKbcJna7fWCNjxp3BoqMz0HYkBfmWtuORXx+J3XClP5M721fJQuHpEbv9X1O5iTuGVAjMMEfPuXvFVgXXBEgbXDEKwXw/XEvh0ghUXYCv0cQHVMM1Jn1RPJEm3X+xFcx2oNywWFS3Vvf9K9ztSgIXpABVYN2RP1N1gl3ZbtoY544Z5d3d1uHVpEzV/Nx12+IdtqlZz9HjVTGdtlHlFoXn3wJOIlFihF2mpl4qrGHrLIAxA6rOqoUrH0TzVV0m+ZSzCk4lRIbiWoWfVFj7dtm3bOE3XeLi+RhLygDHoGEesJsX+otXeUYsAWNQGuIC5ISnmNRtWYYERl4IduGAjGJH/k2ADtiEJVjFh0KvUwBHmCj08QZPfK2+uS4Q71yRTUVN7Q2FNwAJO2QJsoBJWly7pAYZL9VTdTZZn+IhnMWVb+YZ3uEtY1pWF+DZ/GAhjFz+J2BlsNLFMFYnhg3ldTPHwIMGCNooVLZr/pXeKrfh6lfYoC01K36FXEUGZQG1r1oJ4bXQXbmpu2Rad33gPY+EUnIVa6LiOGaMNyneeweWWWq3VuIeo6PaPpQEpDniBA1qBV8EQIvc/AzRxI/mBI9IxBYZiMDmTPUH1NrcoPDlvODeT7Spia1AQ3qALOACVLSAF0CCgXO5E6dKSUPR19oGWX5dUbNk2U7R3CTiXISWYfRCHXzkX8zY/e9mnebouyzYwjFkHXy5XdVWZbSs8l9qinhmapbian7MJjJWqq9qqrYBpj2P8hiB7oYDu7uBMkEYNzziAxYZmz9qcrUmdz1Wd3xZuj0otQo4rn0aeyXee7XpJwEJqhFqp/0dhkPkzgSnYkC0hXwEWcuXgP/31cflVYNjA6XyPg22uX7DrtOinoi9bhN0L2zb7rt4gA0JaBEiaNUy1ZE11pWEXF1kzL/aRTkkbqFPUpj1nJnUap+vSZWIyiEVDp0sbFy+BmIFhxfwZZHmzxZiahS4BD5z4qamZua15qqU6qplgabPao7Q6e3/nTJiYZ9G4rIvZrdMajsNbvNOVHvWCvM27jXeknWmEva+IMWgsnuM7nrfiDhxhNn7hbw1ZgltBEQh7FRKaQIGgITE4gx0xvfRpsq0Lu+yAsk8LvjD7Yjl7Bk+ys1MgAhAgAiwgArAgJZsQoo6Ybm7btFEbVd3Htf/zlsSTT5hr+7Vte7dxExdPXB9IYRJgxLv/GPmiIYmNQakv4WlayseV+3mn17mj+6qPHMmZYAiWNgy4OgzGT7qr90jJtIzJmqjR27urSa3H26jamo29yIvOOW77Nx5r69PYOyzQnFlw0PQAuz8JW4L7e4IP1xDkYHEDHAYT218NwQM58DxC+M87ecEv5Loq27IXoSgQvSgwGtscQRAmWxB+j14YaAQu3NKbAAexgaU9/Ij1QUaHkcRvFT9bDpBlHMVduodjnFRffLdNvbdrPKBwPJk5JjBajMZ9O9OGnMiNnNef29d9fbqh3Lqrm5WKXPzIVEPM+H+1vIuY3dmf3cv/F7C83xLM99DaAdisydzy0BoVWGE26HWwG7i/x13cFQGxATYiBfzmMhgSJVtzGeHQh6Ky5V3R633R80Y9uKpN9P0N2gQQuCoDIMDSI8AGcJDTP7xkbdm1RxvVzYG1H35k4y3UW9rTY5s1Wf2kZdrVA8zHfVswbFZ5oWhrbIvGSQxLZWxjd73XpfzXk7zlrcDJlZzJm9u5x4CkcEiKWOzZsxzae56Nf/68q/273XrMrz3bdf6t3ToYeVS0+KEVCjncG1jqxX2Cz91fGTODJZdgzmMkqwu+MkQobGLe7f2yLXoGy8miPdXCMRzDUwAPWEG6Dv5UUVrNjNhEuUFkZfrh//dx0/t+4ileJmO71VWd8DW+8FEbRs7SbpF6R2qcrwtDLMwQS7vg4s4g5VXe2KP65a9aq5Gg2KM8q6G8aJn8WCju6OfT590W6KV92oee6Jvd6E9fzN2ampyBR3MBgaE+6hGZ9829zgH1EcEgMIefCxi8ED4YEjzMEQa9foICKoMC3sk+0f/g3/udgdqEgerHUzV8ABDAAAzAAtCAFYpG7gk4dnO8tHO8SID64WFOpTf9tEcc1Vd88Ddexm+VLcQCuM+48QFiEqlYtwoalOTHD5qECttsediFjEQsFLNYvGglI0aNGzs2+VgxJMgqI0uaZDImY0okKJmESemSo8yOE//J7AnUaFYzZ9GgbfupDai4oESL+jxq9JrSpdaYKnvW1ClSqUmrMk26E2jWqVC7GjPGCls4frrKll1lKa0iS4rapmWryJDcQWa4cAEDxm7du2AK+S0FGNIjRoQJL9KDOHGixX8OIz4MeZGowoX5NLb8xtGbzZw3X7kSwYAABAYcWMDyqBo2fKzr6XPn+p692fFq06sdDZxucK+5vf6tm+dXY95qx5Zte53x1qz7Oe+3L7r06fugU/8N/PZt7LRnc/8OHvt16rJMkZpkixqwVDptmTdlUJh7U5MQMZyD/4xDNAsj1vRIUoAADjjTSQaaVCBLTAyBEkwJFjjGGTbdBN//cEINZVWGGkbFoVcbevghVVuNyBOIQfnCyi/hjJXNWWip1VaMaa3S1lxm7MWFGXnllaNfhXhSyidCauJIZI0xduRhjeChByNIRlbkYYNFWSRnmnW2GQuhjUZaBTD8wc07zB3nTnfg7RaNPrqpWWZwPQ3H23W2+eZac8/dad14em53ppnh/QmoeNLNUh56X7F3aHzDDNNLLJdcsgdDXdCRRxsOSTiHf/8RyOmDB34qkqeiPvjfTYGYAkyJXG14YYgdPvXqqrKayMysJNY6K4pikVUWPGi9qEgcwrr1Sitt/TJIITfapcVdbKRhVx9/BTbKlJIRNpmRjDH52B+NJFlJ/2REFokZkp254YYOJ5DGZQQWpIAHLvK0Blu9yN2Lb3Lc8LYbOmi+WUwxxZHZJp332Innc2PWGd1y1PkZqKARS3wdofShhwqixbBny6LynfdoIAlNGpGEDmW6KaidqizgyiyPytFLKtWUkqmiUOONqqy6GmvPItr6M9BBw9qTL9Jgww+vv/5qibBOt1XsK4YMQhcbVkPb7I3STuvJkIYtQhm5RyrmWLjegivu12P/gWUZJ3DAbmkRRJDCH7hUg4+97+Dbpr79/g24m+sJjE499FJspz+KK0xm4xN7x+fjiOs5nSiE1mc5ohp77OijkFZK8kNtaOofRC+7jPrpSSixev/qBK5kU0KVpKrzzkLzfDvuuO7Ou1SwLopiNeHAQzzxS7MlrBhiDBvj1JH08WzWVvv4I5BCfjIuZGFrmxi3eMDxBpNmP6ltuOG3PcIEcSMwN7ysVFONNPIrV/A59uPcDO3EBf73nOoNvozC6a1eY0oY4xz3mnmsSXIMnBzl9mG5CK4nY+ZJhceGkYpTeO5zk6KDpS5VMok8xHSuKyHMEKQ6mMGuJhRKFf6MgqEY9kSGudMG0X5XQ931zlZPwRk3dpWNIC4NLckTQhDEMAg5yGEuVXPW9J4XiShaz2vYyhaRrqgt7wXiDZWoBLfGRj7ynQ9db7iCCbbUrnfBYRQo2kX/xtyonl0sQ44boyDHZmG0fgGHb8pJVKr0JqjELW5xCyMTbnJGv/BsJ3IObKSeLDcKbkDHFxmrhKE0B7JHLeSDlhqhyUb4BBKmcJQva13LSNkpiCzkVAKrHQxnSMMc6nCWXsGhLXtHjaOFQxf88JWv3tK0OBgxCEJYnrCoNggxWG16lJBikKY4GCxKUxPV+hq3vOhF8HkxfJXg4mK+ST7vIQZdZrQAGuVGtybgoYvvaUQo3lnBdsbTFJbzRXH2ZS8++msZdZQFcQ7WODEZ7k6DLCR3wGGhbzDyN/NoIMUcycZ3KC4f3NiFI9jZOXZusD+T8oHotuCQJ0RBpB49QqiW/3DKE6JypSpNaYQkJJGbpMKesKxKTWPZFVrK0me37OlTjgHUWlHjHdNYkYuYJqxhGnF5SESmGpYpLcDAIjBUTEQVr0jNamVPSd/r6jpxgohAaBOc4gMn2/QAPj2k4Q1nJM362PcuHBxBP5ei1BnyU4c61Ccn8ySUD2vjLwHKpl77XE8F/6mPvMlGscxJmEH7BjDidMM2Dn2gZaejmnzwIx+c5UaUwqVBjWoUdG1wghNAelqRjrQHcp0BS1+ruofcwJQtlckKJWQqYMixVTJMR29jSCudDo2HPt3h73YhPKO2gmnBFKYRhak8OSBTEE9lgyCaCYupguJ62COSZbAVzf+sVitbjelq+OAAB7CGDyfdQ2tZzZrWzWhgfQJIowhwgAPTmpYGROivf71AB5vRszzvQRRN7RfYfPqrjiD7470E2ljrPDY7wblgbhZa2YlRR7NJ2yxncXG2IomWnSLroGlBmt/V5tcHNjBpRGALYwTZ4COzpS1Ka9uylEwoJ6286W9j6WPdCZcrxS3uUHcZNbgEy2lCcG4clNdUp0Yxu9ndrmAEQxg7fBO8hammYcq6XpycV71fFSd83cu2K5iTvnJ7l+g86IU4x1m/ccaPqSaxJHfuFWNzXMZfBVum/2VQIOWxp94KOeGDKvSCwvBJQzP80MtqlrOU3iwr8DApnGj/9KKfq5QR6hzSOJOQdCaMsYxlO2NTi3CFC8nJC4MMayDzdta2My6Rbc27gOHQF8ktVlucBmznQhnKVKMuMqmcCysPpklkC1t4vRsZPIAVfODboliv7dX2uncN6ELr29z6VrrBYJ0RrA8n6nMI+6g7r364630ixRBClycrfw7s/+hzHlT9mWELA6iCkdOOgAOsY45eLKQdOZ0VcbbDHZYGGlqraUek4qKB4A9d+XOTVXp1DRZpcapPimNTp3rGJFc1C3GCile7UtZAozXuVk7cIvNOGrko6i9+YYhgJ8+5TS7msNVwbGRbuUraJh9W1eYt9L6BP5CaNnqzLU4mcXuc/0z4wDnX5y4bVGIUb7TYJmrx9U2EvRPoTvd96PrBObQQgH/OGSVTYe4KoWhNvqn7v6eTL3N8Y+CNdkbAD45w6Yhl4RzuMC/ggF8coCFcqPhsxUdnqu9dmz9I+EELWhCC+7q21Ko+0MdjrOOJtFDlP2a5y8lx+iHL3Mi6DMfN5TI1QzD1yWJY6hHVoMxkIlEVsPgFlYO07HGuYfhr8N61tsfVyYf5CtIW65izLfwykDN94K7+3E4jmYwRavsElqf3xb7nOXywzrKTt27xhz+4m5vxAculNO6Z4LvfK+CCC2rfFQp4hBe10gzfbC7+0AVGAANn8FlFsgekFhJbwFohwP8BGwACGPCAIfADnCdyJWdKqGZyoSdTO5EzpWd6qfdKIfhKO6FrMfdTtXSCQcVr+3dzsFBshfBzyuNzamBsTwV0hsB7VbZdWYZWHCcRxPd0WwY21iR1aCBt/DFmzwd93tNtN6AB6hM39VUacKV1Xcd983aF3fd9FmN2CYFXdmZ+7aceF3MTeFZPBxZ/9qZHlEV/fEdwF5Z/D6QPd8N//ccP2DAKi4AGn6YpCmgDicdiM+ACISADmRcCFwCBiOgAiyiBFChyIPF5NhZyrHNboudqHehysQaCIsiJuqY/tVOCKShz1DANYoEszXRd1LVMVqNMNuiKT9VUOZhsnhB86BX/KkBoZmOzcdQ2bdi2hObVbVKQPlA4ANV3AKWBAUiQCG7UHsTgjMjgjFnodWIXb2GnhdSYEGiXbpijMeoXKZpmYOgnjojUP8mhDgNHELewKJPFhhBzcJE0UQuXNPDQYfkwDaOABwKYeIZoiCaAAiUAkA3YgIq4iAWZTo74iChEiZLoUgsJIZZoOaSHIZrogahXDpuYFHR0R594FLlmfz4VPNOgIrCAitLSB3wACIAALdWlF6wIi1QjdLRoGbZoEmgABcOXi91yhPwBB0YoVk8HlL8ofdKXA3DDZgUwhQbgJXjwRtD4jLIQjR3DfYNDhpwEYOk2YNyHbtqYEOBoCpb0/26PIgpwdGBzN470pxxteCgaNBDreGH4547eETGPNhuLQAvyQGmF13/5AAsACAMpcIhrNjcN+AEaUJiGuQEQaJBJ6QAm0HksVWOgwpCT6ZApI1O7NUMUiRSaiZE/0U8Z1EUb6UK+QIKh+JEfCRbSkFm/8EwniZLf1RnNIpstaQZBxwu80DWD0ZMglwW4+EVotos+iV6+2VVBqXRuUwFRKBrh5gKEoAlu9JRRWR7BIJUANB/UOH5O0Ab4IRDWOR9beXbx1m4nIztZuQtsZJ0JlRvFwZ5vAnYDUSGOBpezQZdy2UDfcjR1yHCc9QsAOFtwMzdJWQETIJCIqT6LaZAcwP8DN/aYCUmZoxRTMiWRFcmZFJqREURioflGNGWaHeqJX7GC2IANqgB8lpEGmMEZQKAFb6AFUzCbevEXU4WbufkHn0ERkXkRxAlmG3deQImTULeLRIkBW1KMSYmUSVkCe0BHTsmk9ked0Tk4zugKIHNukrB+1jiVd2RJIoMf22mV5LcHkoBRWTmdijIMmbl3awmfUClZvqVAb5oO9BmXgLIkjiBJirOfSbMi/2cHdlAGNbABDXCMx3h9g0mgB8qYCTqBCMmgDvqgLDUh+vZqFtmZ3SCCnFlH35RnX6WhuqU/Hvqhc/dDIjqLjNCnKDoFqSoFOsCqOuCieJEXWuMX1yP/k34KBR0XicSZVme1bcVpnEDqq1DghMR4pEWKdSKwB6jgR036jJ7YrM5anVR5jeBHdp1QC84YR4blTpFyV3QlZydzpRu0pn0nHJbagUDFlgRxpnu3G2hZjnPaHXmmCbwweJuVNNmwWXsKJH6KAg1AAP/6r8XKPgeKoNcngbM1fIw6iZJYeRrxqCsVU87pZxN6qeZqsZqZU0WRMclHCHfgsXlWCRKUKh/6Fah5pvsCP9hQDbgZfHxATp8BBax6AzK7AqmqArDKBScJCdZDJGUQszcqiV2Ai0UHdUC5bdFXfMMprAB6dcZarBcQAmigrKAKpcDgpFcbldJ5jfXxQVjp/1dyxIzlFlbiR2f4gQZiKq7q6jH0ppaG9SixsK7kuGjsyq7taLe18S3fJC942mHZsCLToF19WpSCaqSFS6hzY7AosAOU2Ie82aA4KhMPK7mjUgd3cIn4Yw7jQKkWerGda6GEkmcd67GjK7qEwGMamZ5RChZxQlQrCwpX1KfRF7OzdQInkAO3mwMroLuwCgZ2AAjW06c+SGMLyjo3dqthkLRmxoS/6qO+OXw3kAIBaoyD6rTuIrUj66HMirXQGq1YqJX2UVpypnYYs6HZSkHpRgf6dVdWmrby8aHt2YGGhbbqeBRoSrcK5a53aw8g67F2eZspC7i3ua/86gH+GrBSKP+w6DSYH+ACC0o6jWtqjSrBCumQk2vBAnITmaATmKu5nOu5e+fBPYEK2FS6JSx5OTG1npq650d3AoUL1RS7L9sF6mK7IxADJIC7t6u7Ndu7v4s9aBUTq0NyC0q8xjt12sa8v4qLRBkDHICoRuq0TnsBBMhouKK9V+y+z6rF0vge6Oal2+kHIuNO5qnC9LEHnJQH2/i26Rit5ZobX3Ex5reZ9sue+ZuWacm//OEfSTucL5sDLfCEDnDACNwuiDughAgDLsaTO7lCj1u8osISKXXBD6pjeUUIGowzetfBm/vBnfyBmWkMI5wIJrxxH7sYTVnG2pdy7oeyK0sLg1Eu6DL/uycwxDFQAzicw7s7BX26bD5bvJFJu7/8EVBwBUecGOjiq8gcrMNHzMzsAkMqyIYbxUdqGlsQkVQriturzUElrWV6re/ZCVS6V2JMaBG0ll7spQF2CGnrCmDHpsRBmvLLvpujM3Ssd3d8x/wbCBJSBJfnzx7wjw37j088yAJ6yIaYyBQReZZTCWjQyBE8wRQ8yRM9M5a8wfdzkSFssee40bEGxyRMuiFNuo2gwWErrcoqqq38wmITvGUww7PlcTb8xygwArisw1IgfS3NBMJcxJJ4vEPZbZ6hzEI9lDDrEkwcqNFMvQnM1BegjNhra1i8zbr2pFpb1W3czV0sEHGH/0kgUylpl8bsW6XwYUHryhODZqVWSs8W4saTdc9vbQ55THk+UIgekJiIKAIBmZzSnACGTJgp8JcltWMhq6wj7NCiJMywFcQSvbApVDMWncmc7KaT7ckc/ckizNCjLNInXMIRpAkZ89kShCK4cDf7stLaQ3VLENO2fMM2jAI5jMOsitNu8LwRLcS3vQQ/uwYwK8ufsdu/fZPB3cw+S5R/zLTSTMjVO8XX7JHZ7NxTvc1X/azeubXjStWOghBfDcZhLdanoDEAQx/buNbq2RNya7HjXHGH3c+GeAENUKjunaCHPKAWUKCAyWJGQAW4BY5fuwuNcNiOa9uns9gB3tiTW//JGbwL72c/GV3ZG80OmnzZZ01PS7LZlutenJ19hIKhKP0+80PaX9Y9HAfT/sjaMfCPJ27TrbqqQQzMt73arHO8EhzMrg3YJmDLN1DDtEziDcjXTB3FTm2Xzd2kzw3d2AzdUtl9WriR7pHFt3AK2a3d6mx27Eu/zrAx4e21WVyCbS0UJIjeB0gR+igCD9jeiLuYG8DA/rjjiCzYD3FnZK1rpIkKFYfYBd4SA64gDRvJeM6wC+sgoiehkW3Zc9vgmPjJ0AC6FI4TId1eIJt9k7Hhu8AKpE1z1eALecir1BYRq13itvyPsK3iP5vYN8YDpf7iqs0CNcwCLWYCBurXBur/Vu4Nzcid3NNczUGevdCwelVsslHNpFmYrvCZrt7sKGTqvqDJCV6Yduk8zxzz5Grs3ZtjYW5sxRezrWesgPiVeWVu5nhdAptneYEt7nyIMpoG57vjDG60B3VO4Cl05zLREntewbjtsBkRyRd84Jcr2YPO7/jryTalraRsymZ1yhh6fKLARrggP9Lw4WUznKjO6SWu6jkcszLL4i3e6YJow0Oc6qt+RhNAsNK7iIc7qCNP60dJyE49O6qy67p+mi1f7dJdEFMqzlXKCd79zUxuEMUu7PEpv+oGZ12LlfBZdvN7R+7L8lH6nltaYhKyj4iI12MuA0VAEsRXOj+A354E/4Y4ce5aIRwNze7uHhPxPvaRK+/1Puo7ffaSbPYBEno7dtGG3u+YSOh1z3L91EWMbnwEDzaWIxld1PeTLj+knYfhUpxYMOIRv/E3/Me3K9zC3RG3iuMvUAMa79qXv/EZ4MTdLvJL7fkn7+OM2ZxQDfMoWPpXTGBsyb5pffM4Hx87n67Z3ZVfp5Gp0EVWmhBgnRBpfR9Dz8bRKh/dh2fD3/ROLwM0AAKal98107/bpsf+kSnxxo1v6PU44wv+zfbtrpADXvZjT/Zo/6D3ztg5duCZgJlzj0h2/+8j+DFMP9Kmy/fl800IT+m8wPDZ8z21rfi2bMMAMSJHDoEDpRyccv+lzEIoTBo6fBhDogmKJjJclCCBw0UOECZ4jIBA5MgDJQucNGkgJUmULQe4VBkzAg48s4pBw6lM506ePXM+O+ZTaM9gyIgdNWqr1lJSmCQ9hfqU1ClXt5AKw2qV6VRSh9o4IeLEyxxEomymQqvV1KRDbem0gevHLdw2cttKujRVltJZafU2Ygs4UCA0Z7BsAStDxpYucPA8BpxIsmRCdyzvQTQY82ZEnUKZ2ttM9DbSpalR24WnyuEmSqy0hh07iWzXtW2/hphbt0Pct2fzYIIkuHAkxXv/Rp5c+eoxZOrcmSRqtOlu6qq3u249+/bq4rR9Lw30p9LIlcsnIjRZfSL/RprWS26Pi9d8WqMY/Zm8pkuWJUls/P9hIgFRGKEGg8BAUAsE3WBQoYak0I0gAlH4wIOOPMIwpAQ23LAlDVeCKaYQR4QpghACQeWm8Yb6aUUVh0oqxqV6KWorp6KCSi8ar+LRxlMukeQrGkAAISyyQNtLqWL4aootu/zIgy668qAyD7yowhJJWziZpDzMCvsqCirmuEOPSs5Es7y1vNRssC49A42Za8ahjjppUmPtONr29I243piww47geGtOzz6N8/O1RJdjtDfnNrPJG0nr5E67ctjpzjtNwXOmxWFwAu08yN4jVTI7JtNkFPnoc28RyuDYrzUAZ6VIooFuXTAN/13t0DUhhCB88FYKNSDWAgwzJInDEkEUkdmTBHiWRJVMRCPST8XDlkVtg+JWxhqrojEWcUO58a4cxd0xRm/HzZItL8Iioq5J/oIzyayYBNKtt8CSkg4rmUILGGAEmzcQKLs4w4stDGtElDTRDDXiLgVrct565aSTNHPsPE2aUe7Ik8/ZRO4zt1LCKWTQMIYz1L/ahnBoCJgRbbRm28hoDrNNgDlNY0s3/rnSTTuNxtPx1mxk1FFLLTVVWubjpT5XX421iVlptRW4HKbglQ9d0+C11zd8/VVYYh/Y4CMF1Fa2bbdBhDtEaOemm+5pQehCOhe73XbbHrfK0pUfy83xs/90Ybx3RiTJzXGTnY9Zq3B7X/TLlKaq3DeuvAIWrWCC/UCYYdBQMQXi0hdH/XTLudJyTnImBRr2jqsZBY2QSR655NuYyMGTbMIRlDfdk1OZZpaHr7nQR6XrWfaghc6UU+mJ7tQsUdVbeupSGakPavvw00MPOPSjDeustwbDDkC+9vrrN9wn2+yPPhJpgrelJTHuuvG/Gwu9swVg3xAnI8F9JnCDI5yOsBJAomiFR2cRGATPgiUDakkrnzLGp4TBLklQqV9X2ovnCnYw54wuLWhZXeosGEIs2YtO5jhHDGMnKXBwQxo2xIUejNey3CGvN3bIBjw8UYbdxMxPPADOoZD/uEObHadQX3hUdJZxjik673mYel7RqIcT0mAsgmliGqnCN0b2eAJqvHBPJgKVCP2szI21WeLVDpQr99Xxfe9z0EBQ8IAG9PF++ntJIAEJyP0VUiUX2IIpMsjAvfHNb8FAVwG5xDoE3sgphjOKAB15LwlCzoGK+2QK9YKVCFbOSf2yy8QCYzAoNQwVrzyhVWJpL07yhZRymqEMYUjFjvlCFIsAGRV6yMNh7o4/DnFDITwBj2ykrIhMVEIcoenD5BWKEDs7jS6tCL3obZGLPwGG9dCEhzOZKYxkDF8mPmHG+WRCjaeyw/jcSIaV2eYG97QVRNIXtjp+TUHvU9AUeEcC/w/w0SR/VJYgBWnIZqWEoSTigP9epEmKQtJHl5xkRi3pFCRVdIA9AmmPuOQWvFzQlhM8pcK88CZVsvIQlUiRwBZ5wm7ZpFuiWdJNfSZDdPSUl+GsRJcMs7AmFrM/fBrINLKhCmYWAljPVBTNplnUaj7qmlOsoja5ObTwdJFb2UJhI16FHrGK1UyQEd9j0hq+7s3HE2o01R2IOM834vM/N9DnPhNkRy70lQ27SshANGDQkiBUkAB4aEsI4KzEhigEeZOpRx9p0Y1WlisbxeRXXSfZkD7Qs0eJ3F0UKMul5NRhnmlLWVnqUrMIzBeRpZyKFvlNORlDi83j6caa0ZdTDv+VqEeYKu6OekyHwOIfx9VFIXj1VOFR0zgG2uEWqMoc1jyHEJHKJuwutVWuEk2DXx0GLB8WGcqMFa1qZesZPeGJNYZPnmFgyBrIt7uFMEh9bFifghTU1/epAaC9EqxB/XhQQgaysc1qrCEj+j9G7u0aH3WFZSXMJYxSJTRCaeQCG9jZmtbob+yKpApRZ73VBkYuityFL167SBbL9rbNu61WlwHUTiCiDnPIXBsWtmNhTne4wwMEPI7LzGw0c67NHRQTi4PE4/l4OcK0aop5qV3uvm56GQ7rect7Xi4T4lRPc2sa4ypP+c5VnsRFZqD40IdCsNmf+90vG+TcKwjtkbD/BAYkYgeg5/0VWESGJLAFILvJZGjyweuicAejYiUcYZSjpZUTT4zGWW9xmMOAo2BnAoPaTQfVSXKxxU120eLpUA+3p9YtaD/dL5XuWMdG6LGTjVobJqjiuLf+BzxUYQfmwjGJvo7qr2X9ZGs2Yhc3pHKVu9vIsFbCMV1W67Mf4wb0ZuKMaIRrPC1T5jJPW75QQEO378tmN//T3Frgr9ggRNAH3DnPiOXzgR0aLXr3ubALniiljaLRclnJ3+YqXIVr5EVrTLrBH+0sLT1sy1uAmJI1xnEUnECxlmLmpa5dcalRLbueCSy0OE7YW6TUah7/lqp4pSYQhYzrf+y614s6/1Swh5076RZqD3eQjk+TncVuGryWZ5I2tIXOnvlMw63upNr4HGNf9yrdMWp+BCTaXG5zp/vNYFiBDgJsWIVCK95zixuz5F0SEyWhEi2mKFEq2cEqKfrfOXJ0Zgl+cLqry+4LB2Uo1fLwdnUwMSUW6h7mcAYpLsMX3sRqNnVOjSWZpUlQokvIJf8FksOl5D3G/LB14zuWH3fXSGZyk6XKqP/YrPRSzdl1s7pzZWM5rJrh8lpjj3N1Fp0Xb4VnWhdiKqjzgQ9k9D0gpD71Psj5r3OGc64SknWCtJvrYB+7nxMbEgv4wNhoF+Chr0GjjZqLSk95e9xbmEmMgQdb0tM3ov/BdUBQOhxcn+HS4MNC8c9BaQ8onnH+l/FCxfd0xqe1P1abvMGDosq7PJMLrlmjNYfgvM7zBN5pMtFLwAkkttewrlnALZ7rua76rg7MirwAkjYJBGd7g0AIumgrk9qrhmqIGnc6FcqgNnRij/boPamjhEiIBHI7vqs7N6zTOq0jgeYzKHebt7mJt7CTPgTrkAiwgBSoiQ4stLrTiaVItEWDCkZjtEsqIHTBMPMruCv7QgYitHXZQvcLsQM6IBsLkxJzHM1ILZvQv46Tw12YBcfBDBwLQMubPMpLmALksVczjCcArsxTwKKCCKbqvGwIHiRLMmkavUecLuNQnuuSMtb/445lc72uCLf92ER5crZPRMEy0QQzWsGoEbNECBSmUzNUpMH7iLobxEFKcDM1UAO/Sr5bXL51az4840Wvgz5eTCj+IREmhIE7iCzxKAoo1L6daLgmqay4sywujEIAAsOhCUNPuTseKbRwKcNuNEM0/JHMgDxVUq0ueZNNEIVRi8P/ywTHgTg8PBgC1MM95MN6dLUDREBIBDZjgkAwQESWUwUIHA4la0TlcER9rKabw8AM/IbW864N+0CDKQxO3EQTdAyLdLYUTARSnAYWfKtsKwM98LL2Uh/1gQQ7gIT2uEFBWMk+SINafLM3WIGqKz4uUD6tc74hTIB2W4CMUICu/1OoAUtCQNuQkDCBalHGaUScccEEZxQ/BCpDu9usqXwGL8TE74DIw7kKbvRG9vvGvhNHNuw0d5SgWWhHd7xDHLsxP7ixG6PHPvTDuLRHkhOmQSTECUyyW8kBIOo8XQCDW+EN6CrIGoDEg5S1STS2jbvEF/OmrEyFSyAM0DEMirQdNAiEEvS2kEyEpynF28M9VNRM3lOfVmyPVxQE4QMEQNjBdNMCIACC/2qzQjCDPsgvMIAQnyQwBdBNn1yAYETCP8IfZSFGFFmkXpDCKXQ4LfxKbkxGn+iqarxG9NvGdPGwabQorvTK5fxKsdS0yEBHd0JLcbyLtiRPtkwYeSw5uP+cy/UUxHy8S9MLPYE0g2xgOV3TRWnax4PUz8KcpknMOXCwRErhwAY6obyYSIShTIqEDNVYAz3gHtu7PRd0QXSCp9J8BAtNTUBwhJesTdacyf9iszabzeWCEArwiNzkyRTVTWB8m2AcO+o7ypgaBuM8TkxrIeYEl6RgTvKjLSu7MmsEUmTEu4XT0TMEx/XLThADDcALy2sSK04Ly/Ksg7aYUsFDT7jEUns8QAN0z/dEuV8TyPjMukJYuVsTIikwENAbyP1cMoScwOYQnewC0AAd0L0xpUtAA9CpzIWxAatRUKfbTF7oTF6Y0EDxspFExRksTamLutTcwZeEVP3Sgaz/m8k0YMnYLASbXLcRONGDUlEV7U2uS8KwuwAYQMp8k8IQ29EZWVWtpMofDVLonM4hnVUcjSRbBbFWBaUm5dUuuSa24IwobUsbc8s5mMjzRNYs/QIq0NIteAK6xEc3jaOBBEyBLIQgwjV4cKqXk1Y2JT2ELDZUODw53aY6wTJxecwzwdPKRFCiSlD4IidV6UxakFD0CM1EJU1IWC9KAAVcEAQO1RV0+6s3o9Q4Oz4fJAFO7VQO2clPDdUWfT5hRIkKcIE9kNG6075mpM5sTIaNrc4etcpYFdkV8diQ0tWT/SwHSqVg7VVeHVYpDcDBwxllVc9lbc9nxcebtUsvPaL4/xQOgbRW+sS1ZmI+oO1ZwvRWNmWCIYC5m2GNETyTFBlXhkS8h4w0TyKFsMoLzdhTI/gPHPCBsO3T12jQoivFt9IENYsnkcy90WQEfd3XX/gFWVQDlrTJgUU3gp3UsSEbIMyAO3MbnjyAnPwj+/FNuZEWByjVUz1OZrxOWq3OkuVRWf3CkQVDyDVZySXSe+GwYSVWzmDZYK3StWRLKXWOmVXWnK1LneVTnW1TN43AIpICFSBTljOygQA9g0xalwGu01uimJvZL7E/qG2tjUu8SSslWUgTyHwM23kCHAgTsE0BsC0OnDNbj3SPFyyTMco9d1qn9coFuZ3bS/3X5BMEWv9kyVqcAkql1CDsABNd0Zdg2BU13IdtGyIsLIkNESZMgTW4WEeqSgbSu0/C3M0F2eeEzpD1wums1QLWxgfm2IGrUhvrVdGd4Bv7XNOF06HCUtZd3cvz4J19Xf7MSzAFWikwhDIdMqeqVv50xKQdxN9FPdboWjE5Tz8YjDOJk1LLINhSkb5IC4ephD8wQTzYg9ABkOk1AuptUBXsyNsbhQndXnR6J7iFhWn4BX+QW1lM37tVkPOVM7td3/YNQgo4G4hl2BO1351kUYklygiYAThIkcZFClxVVc1tzp1I4D1WYCHlXDzOYwimqAvODEIoZGH9XCs1XfI8A5nNUhCGtRD/jmTXpYIisOQR7tloYrIk8tkTvtZsXaq/xF0X3s9Shl3m6Foew9kbTiXH2eGc6mEgNqEzKWL9aOQ93UTLlAxa4Mgwuw9UtANEfUFlSkkzumLxndtBGIT0rVswtsU0GOOsc1+MiN+RiN9qnl/hFMrDdWOUGM45pmPsTFJWxVxJ62PL7eNKszQe5dzJnTt2VgbypGBCFl5xHN17ZuRiTVZV/mBJ9ucYxuT8PNrhSFPcrTUV/ofbHeVuDZDdPeWRSeX0HLmxaORCdhzOoUNZLh1HGOIhBh/8GGJHSBWRHoVRSLHrZZUXZFsK9V5SDAdkFt9ldmZIXV/XJOMToAAzFtxk/0Hjno7YegNKmTABnEtKMRTncWbVCHbnc65cdFZqA1bKqKZjZpjnRTZkz5XnRT7d1FXdf3bdSwZrsCbhgWBaYUsiwFwmM4UH4Floh76ahsangJbrRNlqiZ48lYqLisbhPSgriPklszCLkU4xViDs7insp1mVec2E7CVJMlrUUoCFXHjpQfiFeiDsQYgDZhbYsVkBFZDmhM1p3vTpwprfNd7moZw+HkgEnvE56zxqpIbqQF7qpkZn6VTnck67vlnkl91trUZW1O3qSRbu4Q7r4p5rTR4UghiITWYZpDWIQlCFIFq5UoiI24Dh3vVdl4lrCVyOurbru55HL4g8nXElk/8W1/owacM+bPWWD840uvkY6e7l3tH8hDMKB26ghF+IAzEg32ZOviuYVPcdAWo2bWDE5jYGTvzhM4eqALMbtdaeTjPsBXBp1XWWamqs7cu18AeG8AzT497GZw1uDkfmameFZK/+auNWceOBmRZY2qUFDugSzBNGEOimT0U06y/VXbh+a2naZBkG3og+DFcj8SIPNxQxixRT8jtRMVw46adpclpYbydP7M5MlQnFnvBRyVzg8l8IB1gQhDjA7y6O1P/67BPAadEW1dG+Xz9DAHsDEQzIgrNrTD9+7VvFbUHOYwyPTj7GyqeWSrrzcJ9wSxD37Q32reAm7kVndBXfAeP/Jh6Ywd0W+HFqBVrcLQNICAfgqfQd59249g9TdmhUxplBBO6FqdLKcCfAPu8oVzEmd3Upl/UpR2zEFtQnNsV3Aub12PIux4Z+uMHxZcn1gUm+bU0WQPYB/9tO/cmgZHMW/WmYOMKTaHBxbe1vCZwd0dwo1LB2vvAuzHCj3txAN7gO94kRrwN0T/fe5uBlHYNm7ed4N/GwbfQY7gHgundLLm6xfi5Jd3FJf13nXsBLz/QyKGvd9XQfZzJK52SB38cXD466Dt4wsIwnXXV3anJpOA1Zb/JY93iOB/n2vnXvSZUwKk3IhmxsyIdfeAV+0G9uyGz0/VcWuAItWAEBh99n/2dz+l3CZAFqA/szmLAA/61zx8XV2Ab0pHfOcEc4b8++3HbkdFf3dYfTU4d3eefnebf3fad3rvd6w5QZCHRxYmLEZ9Jx5E54hV8igkDaUvZ3P2kjtfJe9KYFjYeaj8f7vA/5wjbbu7ePVmFpV/xeLucGVvByZJbpZVYDZL/pnD9wnXf2bObmBLObEJDj2bpGbkFZpXdVx/XjC98u2u5zj5JtjB10nRgDmV331d9qq1d0rf9g49jZro/kR/9628f93G/74GgBSieIwVxTGTZ7tD/uOOJx42f7tt9PlhmD2aCnO1AVKucFJqePGzK8vW9vKsd77A/5W2dBJ9eEVvzoXf/PV695g0tl+Vb4hWVeZi5ggQ74bGR3/J6UfNJu9jXnadSGcycUGIDQBm0gQWXPkvUKllCYQoTEkEFs6HBixIcUGVZMdtBgxo3iyn20JnCkSI8mOTLbiNIiS40oC5Yk+XKmwTFj5tjMeYbMTp51dgLVaZMK0aJHthxFqtSoUhtGjvoo8gNqVKk9rGLNevXFjq5ea/AI24IJWbItwIpFojZsWCVu35JFUjZulSR277bFm5ftEb5gc5xFu3bw4CGEsWRZc4cRr8aOeUmjFZkWZVyWL1fG7Gsz5V2cPWceBTqz5WqmG4/SxGj1otaJ8OiJbcdOotZ8+LzJ/YYFEECUBrH/4sJFkBogLFisOE6CBQUKEhYcgH5g+gDqCa5bx55dO3frBgog+C6+uoDx5cGfRx/BBR5jME9iXNhx/jH6Le2vlB8zZEia8P/j599J771Xn1A3HXjgFkMt1aCDDyZF1VdTfdVXVVt5heGEFLY11hBMGDZXXm/tBRddTBB2A1566eVXiYC56CKMKB4WRhh3jPIYL7Q4xmOPmgGJy2idEUmkaKSVdpplqrFWm5NOyvbHbX+84Uhux+WmxRVavGHcCR0o9+UJGTzX3XbRnUkeeWaaqZ55b6qpXgrtuUdgfQFehGeeEQHo0n5/9imgnoISmhJKCSKqFIOLQvhUhE88upaF/xluyKGlF1bKg2Ev1gBjjG5x2ikPKJ7YhIorkniqpSp2CKJgn+aAxFiH2ZRYIj7qiKSuQRrZ2ZGe/cpKZqZVA9mSTLr2ZJRQ/mHllbuxcIVyylFwHJhjOvfAdGxKx+Z2AnjbJpzpoVfuenTaqZKf8d0pUbt7suRuoev2V9K8BQ4qYLoFJspoo0w56GikA1cq8KUFIzxqYKSCGJdfNJb4aaoTs/jpXqMO9qqMfA1Gho2M4PoYLZ78yCuvwB4p7JApJ1nssaI4kqyyUtJMs266RTsttWE299wC0g3QbZpDh2tueOWOS656NixSpzP75ncffQtRHa+8gQIq071Rwyv11v8zfeFvUXWNDXDABBuMtlYHY9p2wi18GJjcrQoGMcWlkoiq3quyGJjGrc4tVcdW3JgjL9Mg3hixOh6OGq8qf7ZykZctvmNqTcosG7PN5nbJzW9ccaXOJxw3ApkJ/AwddAB4FyfRrx+NtNLpzW4BFo74AvVMEl09US+uxBJ81cNDdJDW9F5j79eEdu318seEbbb0/y7laPUXSsj2DNq7vT0MUbnwPfje880Wq+ZLLFfDdGG898R/W4x+jPBb4ZaNdpTCCyOwwYEHJIhjA3Euc9yOLLcrzlhGciqjHGYul7nYzIwPzHIDBSl4BcXYqCzLGYHpNOBBCExAXLKDHXq0M0L/2s1udggIAR5EMwzjEeR4XPPa74B3CuHdoiFVK55JZIg15SFvXe+S1xB5+DxlRG96SmQKpKznxCamzWDk494UKSS+Kl6xivGTX1tiNRazsE9vqapB/bYIvzOmT33+g8QawmcDu8CBMfLIRwBNIw2RHVBYCVzZkDAjDW68DGZOgg0Em5UIOzACShWkYP/gsIYyQBIKGuTgB0EYAROeUIVHE2EmU6jJObHCaTD0YUaIqJAbohKHVrsaSEgZxCPmy3nLW6LZ7kLL62Eve1TE4vh4mUUtmjF+XmTYi/IGl1fZDY3BfNXg9MCHR+ihjSmQATW7YIdPHE6AlnOcj0ymGZTp//EyjnHgAwvJmtkYUjaMjKQjIymFuFDyg5eMXdJQSM8R3rOe+lxPIERZr0DpcJWpBJ4s7+NKWMKHhgHt3Q9popZbQrQpUJRoFJ2yS1/2MgW/7N4y5yc3Vx3GfcbsqKeWWT+GhUEPnwDFJ+CQhKmEIARnWQw2wxFAxpXMm7uKzDjJObMIThAPjWwnO92ZgxxwkJIhbMCb9KnJTr7Jk67jpz9JQsqF5hAjNkxl8/STNa4htKsFvZPuVhJRWk40rRXt5UU36lY3shWuypxfMEWaTFDNNa/KLMsaYtNGG6whCzCQKdzUsoYc1dFlJNumThv7snJuLpGt4Z9QifrIdUaSLP/nO4FSl0odAkg1tLITrT3Ps55UVPWgD1FlVoM3UCEKsRY7BBRHGDqvIpYyllgzIhLP2iinUC+XuowrRzEq17eS76V6NaNdD1M3M5a0o118pCSn0gSYYqAELShBTJHQV08IcBp4dGyQIgNIyqgGsk+abM382k4MXtadktTsUZHa2c+CVjz5LS1pR/tU8URgC45IrWpryFrXBu+VBjGwV/3T4IYOypQYISuFISw4JqoVbdc721rbitzjfhiYy93idcVoTLyOmK55bcJcMJgWCCphuyggSxmuOQ151JGbOibvsWL2U3OmMzaUha8kiTzfuWg2qSb44AH262T+9heFUAb/sBFQQeB0tZbBVHtwgVi7W9vStnlg1e2Y2yWVMWRYwwPjcBSHa0XiGhfEcU6xSZV74lCpmM6COQtKyWBnCj6icZ74hB0Ca5WZHu4d2swpr3a8JJ82opA/pmxljYzkS6OIdDFQ8gck4NmogjrKTtUvAibQhVC6JxpWvSrxWjvhARHklAn+MpkrfNtX13olBllbm9XMZkfhoMNwDjGx4epGExxXulwEnN3u1r48Q3vFLUbBBmYMBTcEGhawmMYv9BeG7VogBDzQwyNABkDx4pTHtEDW5n4s5CFjEAoeuzSLWbVZzuIb32TigALo+WT+jhrg37EAHlD9tJEcXIarxK2C/wcia4XQGsy55e2tJZxrX/ca4xsW9rCLXWxkcyXky940yWOwWTSu78R3jraeazArGrHPfNcuxbYhEc1vy/QG15ZNoHGcuFwBiaW+OpKPf1xOeKMhsPLOQhjtYu97k2AER9V0UjUAAXoG4N9aFzWpI8DCzaT6aaoee/KON1aKm33WZZX4arkc1lzzSUIZ1/gTvTD3Sc3Z48bee/hAnkWWX0xGTR9RqFDc8rREV32BRcuSPTDjZ7phCXvx+2A5kIVHgFfRuXCZOHOhmdSA3qftrg0h311p6i6d6ZK/69OlfgNN1/eoOph6B0NYnq0HXMoAdoABbCessJN9G8IXvqEqrv8vh7M91hPHqtuP2GCGN+/u0p++cN2s9ytqtON9l1uyAc/nkY9o5Yb3/l79ZjcbxUC7nXY8sumLImpXIP7h5oC4+0puYv08p6Hff+bcDe/AEpnqrd77PB2rwF4OQIEUKGACXhAUcBYH2F6ofYeTBdzuoQEuTAY1RIMGCh8HDl/xGZ+hpB3aYZlDaNlsvR3c4RavUQj1qZmjWBTeaR/f0WANhg9hUR7IoQDj6VXieUqsmIiyAV6M+I3g2c/7uYAHxABZcBDJHdmSVYAGNN4LJMHOIVIp1BG6WYbQfcL+iR57DRK8WZbSdUEZLsEZjtEbFeAayt4UpMEUYNaRvd6+8R7/qUmgCu3eBeAAHljZZnjDH3HgMgjiODRDIYJg2SEiCcYQSRhUCZogghFU8sHS2YkZx1Uf9W2ch9ngh2Xf9nniB3iiy4nc4QFhiogf+f2FxuxgWhDhiHiMipiA68Ui/XGACdwABd1A49HfKoaF/d1BHGXTTXFTFz6CT2UOpZ0eABbZkdVbidmZGsrPGuoAA7pBGlijBS2gAkISE4wABDIV70WAHVLg7e0XODrABYhAD5BBJYgGNQBiIA6iISLiByKfRRziKOna2rkWKXAVbN3j8eGLxSlUngwXx7lgDMogFWlUJ17fx4ViDpZcRM6Vs+HZROrZEHxIGPHVO6Ufv9Ui/y1y0OzdAFLtICTl4ipqFwx81+Zp4cisFDFiDuktAjK+V9LFWxkyY8U8o701Y+wtYwKmASD0wW2AwRRkIzvlYvwt1SXNkwSaozleQFRq1BagQSPAzCwMIjzKIz2W1UHty+9gwiFIAj+q3T/lo62t3fLhWvSxYAsW5EFKkSY25CfqoPrZJQrgJbLdpcjlIsnxYrSNXxkd3nK5ShHqHPrpXCRNIdWVnBx+gOPhIMglAbat1OYN4xe+Bk3apDKa4RKk3qmsYTOiIaYV2TRSI7YBQrkBwmxoIxxYEBMmoQU0pVMawFNG5W2KQG7SwFOMASE0glWKAjDsQjHA4zh4A/FV2P+qKacixlrwSIJY3pAwPAN/FBhapqUKEsNbHox2bqclTtEmgucU5WBK1mVe3iUIYEC1/SVYNGHiFV7goeLffJ8o0mfGFFNSSl2h9aUDJiX9QYAJINkUwkBdatQSkFs2OcagpZdkDdIvOih1mWGEjuaEUigLUGgGbeRPMqAUxJeUrOYiqVMknaQ30lMd1uZTnuNtRmVuxhQ17eYQhE0dIMIkdMImmMIsYKUzBGIxpMRWJhxXgiCPLiI0EEMt3NBY4tAocSWZOaJAQt+dXIp3wqWUUkp45h1dmmeWcld63mZeMp57NuZg6tWMMZ7feIh9Poz93IDV1eJ+jugEQGAttl//ksXigNYlB7lFGTDCYjWGgjYJbZjeL37mhRKqZ0oo02XQIzHdhmYjo8pXBU0Ja6LTOknSA34aikJlBKhoi7YoNWEkRoYNUPjBqNKojcoCagGDkBaiBw7fjt6jjm5DfcgWJPaCkgJpvlznWjpp8RQXlR6khlSKlQprlm7fXULmBsgfOKYnKL7KeqYinblnrLDcfDrr3zhdde1gpjmhtGTALOqAlPBn65VcE6Zf+1HQYpWCJzACIgHqu92khM7eEljoGXaBhkZokdUrBjVgUcnXFfgrUYFoiEKqwFZqN24Apiqrii6rB3Qq3HwqpETBE3iBqJ4BTlQsqQInjgKDBgri/zkcp1b6qCHKqg3JlnTCWiKqpXUGZMoOJELMYPcAm6++bLAOK5Zq6bEyLLLepm2qJ7n+5VjsVdDG5xkFDqxsZEfaokmW3NRJIcMu4esZYJ1ykHnygBTgD831KaG1a4hSl6Km3k+OoSNdUNL9KyQBLL+6JoiqbcCqkwRRSTXOhgUlZTieY90qLJdyajo67MNGrMQGhcVW7MRe7B7sQcYiQ8eC7Faqqi3MKgoi3JLKwqDkKssSkZwlZMdFEbDG5cyKXM3arF3mbAhwqaYirNflZXRJ68lZpJiSopripQf5ZwW05+yNQAhtAOxCAAcUILkqWXsuIbbRHCyo66RGqm5gFv8coi1mwUHZdq3ZJu/aUlDbLkv0Sm9sRK8dFGVROqAJxFSy3m1MQSZ57i1W+K30/K2oEq5vBqfGekY8CqIg8iiONm5WqeoHEuL9IsMs4Mk8ruzC7SpEcC7mai53em7n1qyx4iyXyt8FmCMBmOMDsJ+ogOmz5lWsoG6zTnDRllz5lEVHLmu3xuLsVqoHhSTo2JfO0S4lzSIJL1nSAkIpqEK6FgIkCOVq1HDxTuryrm3YDpXyOi/bBtn0CjH1Vi/Xbi8Efi+nEtbDWkXfBlvfNhGMIgrg1kEVEwLh/ub64mj7wq/8enGqhqyr4mqT8s7/NsTbvNkAE7AaB7AB5115Zmn/zipwepIuOOYXaPHewuKlpvCgttKVHyOTqAhtfQ7hqIhIudqifcHuCEjBG9qX1L1TPDGytChyB8GuBCzyt0aCtqVrJEQCJNBwKA9lakYqlUSJ8lYa9ELvskSq2w7xIVXv1g5xGPAAd3UvLTbsdnnqVvTaLluPTljsTwgzgsxBMRczIdzoFzPuqWosj2bl/bqvPMbvGFPu/7axALMxNtPsNvtSyN2sHMepUjIwpjowgEFwBI8YIIPfXFVrIWeo5K0wB7ApBPtkLlpd7npj+y3HPmeAc2QLJt+zBpBAI8PCLxg0JSA0KGOeQjN0uQXx27qm8T70RLey21r0KxOvEE8q/yvfHHZ1b27usi+zILiBtKcuSF30yxkk0d8S7h485yT8ZjI7Mzx+bMiKLCVWs1gphLBq8+XG7ABf6fXB8euCs1JaUh0jtR3jcRQy64BusDqvM51tCusyQRmsD2A8JgjlbgboGyS7wRWw6QT8pwKOidTxM5lAgAIANCZrNQTkABj4Ricn9AyDckOrZntJdG7YDEWXsjNddF/LMixLmmALNjoBtqFtKcOG9PhqhS6z6EeLdEorCFC0weC6dKnKtAdGczQnTywxnxmvFk/3dBpfolxWKc2O5zcXdbIype0mNVMutZxKZh9D9dByCEgRskUBZgfjJRMgEhRAYS1uyRXYQP8/MzIfELcJ5C4jp4EOrPUJTIFI9jNap3V1q/Vyv0EfFHQMfzJdr5RdT4lFVzRg4zVulHcpJxIiHdJqbG1fp7d6k9u6uvI5GRpGOqwuMzaG4Pcti8AGlHRKwqgUh4Fk/21li6oxz6hMAwMhIq77RsRN57SYwctoU3hp+3RQb6KXqrYH4K44t/aH2y6yakAFfOPA5Ry5sq5EuogGixjKkUUYeEB2IeB8dVDVeWQE3KIUQK3pLFlb/2e1cFZzOMd1+7hWSx0gaBsng7J327VqOnnMxMx4k3fNpPc5WTksy7eVswZ7S9Z8s/IzvTctZ4gv32BI87d/nzkIqDmAh8iA80T/Trw5ZS9Igc+BgSM4J2xCJmRCjjJ4n4NxhD+fP85HhRO6zGI4Lw01UcNu7FqAbLr2Uorz7Y74bGqqnKa4iscA22TwRB4hN5on6TBtWzu6FJocqG/aPWNytQj5dPdM6hB5dZeaWwfldndyutp1ajq5k9+wlI83YbP3eqNTlsO3eHMOmNsGlWv5anxCZta3dnmqEt+yf89xf6OnmuMmXn4qnHtMnPvLgeOEgQuuMVexjZpqMxPin0e4gtkHUBd6NlOpaH9nooMizuKzOB+1hz+6iPsn3dbmOa/nBNe2ba8KprcKkikmCnTrCUCBI3ukcBul1UHyG3ZQtUT3kF/3CqgA/wk0h1q/emtDAFenQUELr1x/ckI/ea7fdXiT95Zz+bBDCYMK+7EjuyHJfLNwuWoyyWwElrNDO4uKOLX3t87erbWveWGJjaIoyoEnUWV7ARG0gdN/wTHPqKnib7rDUrtbLgt656FXaWojMIfrbDjje4iTfaSHWwRORwOwn5eiRcAHvMATvJnSmI0o+tUxt7RQEiSfgFLC6VvrAJisunWjDglkPOBTd1t/GgScAB/AsCpwcsk3tCA8guTvepZH+cwbO8trPssjUrLXfMy3V+azBjkVmmC5ADV9NAZY+xwrcLUPvZpvQGSvWdJTMYKAe6gGbjHTgR/guY2m6qkqODWXGf+7czNy4Z3cjTTXZ7iMgW4Ciz2cjj2cNgCJT3/Z73uJr30f/8UOLgyLb08hQ+tcxDj0w+50m/r1L6UEcBCQazxaow7Hr7qYtLoCPPrRQDcYpEEhiLxcLzlAAHok6JFAgwL5MFKYkGHDhQ8hKkwUkZEdho4g/tG4aCPHjg81KdT0aeKnUSErwgmDxEUIDBhAwHy5YebMCzdxxswJgmcIGT9d9BB6BEnRLUeRnhkzZs4cpkq/RJX6VGobL22actq0KZMsr9eAIQs7VqwysMzQmj2rlm1ZZEPhxvUhd25dujvsEjWytwjfu3jtBg0smHDhF4dLoFCcmLEHx485RJYsuUL/ZckQXk7IrJmz5cgNQDd4MNqx4hqnc5xukYNJ0dQ8Xp+W/YNHbduzcefGG0O3baNMgNdAsUED8Rs6rrAYsfyEDuQnOEyAMF3DCBInMmQ4QUKFFhIZJISn0EFFBwoLso+/Dj4BggkUTkhoL2EEcihg+sCC9etXKUqUCgqwDwEDpMihjBKxKCIF7ZhoQY4ognCjhDBS0KSKLBzpJJRUasEDmWp6iSebRNypRBFCQPEnoIxKiowXl1qqDqdinErGObDKw8Y5EOEqrGXGWYYsstKCZq0i2zJLLLlaAMzJv2Z4Ukq9/OqryimjNCxLLQ1rzITFPggTMpoo86yCB840EwM0/9OsLILOyASNAAJAI8403vDM87Y9+YyyTz17C/Q24IBTTIMPbkhuhPQ4qK8PPnRgr7oppjAvPAgYAMI78yjITgIGFligvQTIW4HSHMIjAYwVHjhgvvooveINQfiDJZL/+iCIwF0PNLDXCIENVqKLhA0JEg0fQSmRMlqbQUwyaULxRJikHbGnFFX0CYcdksCiWyq+hVHcGm2kqqmmpMqqx1nY/bGZd8uCV9553WILSizvpY3Kfa3s1y8ut8SXSzC9fJY4aMtUM8TOGHbTs9DodOCCQ5cDFM/YBP0z4419IxQ41pZjjzPpTMihOSgi1cDTUBVQAIEBJGChA5lZ6LRllv8TUKDTTknQ4TsNOhht1PmqG2E6HSgpZT//cB3QaQKLjVrYAqWmGiWTjhVppKyP/QSST1K64csPEZ7YJWktkCnFaNfO1id9wa1xxnHJjRHdL9A9N6pzm+pxq6/GAgZIIYmst5hjEH8r38X9vJJff/WVMmCBB0aM4MbGTLjszRvufGEH5jSgzjAr7hNkjlFPXQnZmChDio91uAE66aiTneJEdVhUg0tdhmC889TrjgScdV5hhfMkyGDmFYIWeuic52NBh1n3+8XW/7D/OkCuebXae4O0/l4h8SkCO9mQ0FfIE00s1N5rT7yuqNnMJ2t7JrIha1tbwp6Im26567a3p/D/jUZXSVcdELGudqGCgbtwIL0Oh5awMKlJFaTc5PLir/5BbjAX7CBiuiSmgtFvc5wzocNQWBM5he5NYQoUClIXwxi2jlnLyYEb0lCzyGgHDDncHQRsmAZAxOdSGdCUFtiTnRUAgVOgao4KkDeaB0yBC+VB3vPcA4EIZOAKU3gDF0pRq+tlb3tlJN8Zy5dGM5LvfRfymiZK0kb4eaIQX6MjINzAhOGMqSWRSVEJXAKTJvkRWyty4Yq45b8ajWEldajb3ZxyN3NBpSpnmJEf9pDJRohigYIbHLwmaEFRevCDkXuc4zAouVLi6U6Xu1z+DlU/MmFGYdDyXMNUeAADhK4A/xMgncVk6CdgBrM2rWvNBiLwgR6aDDvb0d10XDaCKfjsBpaKWc3YMx/jdcCaxAvVA35XquP1bj4uS4B2nCO9NPAnHNYjo/u4d0Y5mm+NVBMIPQvCClC8byDhk+NA9gmJewa0FAUtaB3reFA7mCCWQQlkBVLQRx4shiX6O80fZfCDLBShBRktAhr+d4dEJOIOMjKp3vQ2SUrayIBK6ZvfONnAZrBrlIdRJSlPuUFUrvKmAPPQT0f4LBKW8ISaS6FmNsCmCbxplxGzU+mGGVWpErMGhBIOyU7msyhCE5rpocA22XMzse5sO9xs3s2kKMVSfSes2pEP0TKAgAx8sQ/8sf/eQeEHT+11z45K40UucuGfMhaUe4z4xF8LVIpq8AIXoECsYT3BC4PyAmuSxZpjv2bZgtqKjkqz1Q0kswZGwGBtWVhDmPQQBsek9gNkKoEe+NDHFIRhFGtAJEn9V4eRZCITo0iE3CT5yB2xNCn9q6QlM5lAQkyipj31KQwal1MOmpKUzwWqK4U61KIurJaeiw4tl9pU0dkJhlCl6nn3ZFVDSTM5PZPCCn6YnuZcwWjZIQEQlsgC3ulMPfY1FRjOGipuQrE96dHC8eCz1QxYwD0WyABy6Fq9wN7qVvGrZ0H82sakgaKMf+VwgT6hnwI99hEhLoVhLVtizQJWsBv2KyT/DErHQgAiEp+VDBRAAYU/3icxkNoACjwR2w24BMilSIGK9MALPHQ0o5rAwwbDkAhaEGIpvUXESQFIleEGsLhHMeCXKdlcMadylXzR6U4jZ125gEk42M0uLItjVFt296gKg9N3xXsACFDMvFPVGHpRgzKUZXV39UkDgndmvHF29Q1q8M6ngAfWm5HHDOVJHjiv2B6YbVOdkfIdNLOoHVm9YQp8KEU42snZgMYzQC827NdoHFiDHDaw3NssgApC4kcAFsXbSzGL7ThhztbRVni84YCYEB0MMOHEe1wDHnzCiDBMzGsxCIFjeFDtyLhAD4/Qwws86uS+MBKOYxgCUzTB/4lzP+VGNGI3l7tMpS5HZd0bVLNN8d3TKp2Z3/1KM23yfdPUeKjNbgYTnBEmZ6Ii884oxMzDkaqB8L5sly38pTABnW9BxYY1Vv1hUlsFAVWxdWdo5d3vnNm8rX5TAiooj8vP6io9i/WcSzw0eLiKAJcNwME6XIF+ftHO/mz4P6PYKyREjL0YYzafwObaZlcNWDfyWmkCDbbXbAWLfdbYscWOFRRMIJ3XXQEKM2FCskC7gTW4YbVr+PHXeEDks2tCon+AAyOoEO47eLQIE6lRI/bAZXfDu7hLiRtSjmCjDdL7CWPGjeMzKF00/5vM1jX4mycT50Aq3ExK/YzDIO458P9GIM/J/FKf/5x6P6sGN8Eh2wOKg1TtXGc9K78m8OBDgm6mVcBBE6fL30pzsTJgZjZr2cuOT07rNAcQsMBGO1f9ToNSgsVL2/WJYbz0yv41F9vnWq0fe3WkV/0RYaTEgCgxhdi/6U1u2E4ZLAOFBpVhOGt3jLQ3UINkqdYxaweEs2ZL2h7BtkKgCKSN78hgFKjMbm4E3upmkaoA8cbt8KhgKirwzCqnzXDqLxyHCqaL8u7NNC4PzhBOlrZrzhquzmjnMiiu4jTj9FYvqmAQmO6E41JDCpilBHaHONzqiagJCNgAiZJHiQRBDTwNVL6KC5iI9ySgh1SO0lhlNIRv5xb/gAFmr2bGigIsIOd07gSo5xewodbcZ+k06xe+RutUTPvKr/ukTsXQ8Az9ow3tiLPG6ItKgb5sQFZygPTcQ89yyATA4AM0Q/7kL+7KQA/uD/54QH5Kww4O8QcS4+4WccmaDA34rggIQQHXzQE5sW5ahAJBUSrGraZaCS8gL/Ik7wNBsPJ2g81GsARNkPPojPNGpha/a+JEx+JmUPX+rLxeCIZeYzWMKQf2iL1OwDpKruVuzqucY6sOgAKA0IrOyqz2qwOmiVO8KflahgG2AwjeQIdA5XmWygSuALreABbywXraCNi07j+orj9KjA6jr/v8yg25TwyTbg45DBaESBCk/+f/GGwCWIAP4qqpHiANdmehkkn+yFHH7O+1FNERF8oDmMARR+va9ODb3OAPdoMR9s6CqAAPxI3wiKtGItDwviUUVdLMOAryTvFJOrDfVHEVCYMlKogYr+sVS/DaNG8WuesnLSP0QA+8ooMPnSoEdjEG86RJWG81CM4XCa6qWoOGOu70fijnRA4IpKebaG40dmbALM15aG47eAYbpxCtpAcctZH0FMACUiBtOKAMMmwO2xEfu4/6mAb87hLG7tIuN8uyagz8AIrU+iB3vnGuTKAFWcANIEAA5kSaJuAAwGAP1Y7tbkAj2a4EGIH+KjIM7CDZDvHsJkozNRLvmsQjQf+yL0RyAaei3hRPJVFyJWXTAx0qBBknJmVyJiuPFHUSFntS4WjpBFXQYdjvzjAjzyAqKVcP36ASBYLxhYYACsogBnIAENLgmbSIq6ZDiZyDeYgIrcjDmqxxVXSvA0Blv0KlLL9DPs5SAToAv9ISOtLGZbYwomyABWQFEOYJFixrL/lzn+ryP/Ox6mhNH6kvQGFhQKbgBKQAIBe0ABhUmhKzBWWlMQUAOXQJBytD/hrlM90gM/ngtDrTdTzAdSrS2l4gEfTICj6zBazgEz7SX8agt0oK3obgzD4xNmdzNsfsJfElFR+nNvytp2pgCILRFd2MBH1TOIEyBTejOJeqOCX/g/1YqAL4DPVosDlzsjeaxGMEDRLyiFKMZjuVQzu0kme0gAv0i6u6A7+kqFNUQBUMQQWk8JuQJz1dbj3CsStTYIlWoGYWUwdI6z7f4A3u6Z3osusISvteTGka60C7Dg0btdhorA+OUYtOoA84AAHoSwAggFLSgAIccwAc81OhoAAEQAoCkYvsQOI4tEQPsVVbwBEpcqEOEQUmUzRDgAlgtHVg1EU1wbaGIDVnVBMciSR31NyS9QIxsEd9lC72TYNoE3JskiYtqLy2tDc1T7sWjkntrHOc9E14yUphEEuHCRiZMiqhEjZmw5hQQDpvCFJwbgUE4Q3Mg622cwWCEDsu/0VlVo4CwKDSuMn4xGMINSVPE2zBhG8LtzADBIEgAOFhJTZ75gkU/jOMJosM9cOvAlQvbyXp+oDDDDMNJi5TF6xTB+AG0oANJE4DKC4ARqAPWsUO0gBU+yDsXvUy+WAiabUi31Uiq+oA3YAXGsQOSAJYYxRyEpDKhpVZJ9BpdTQUiyBqpZY2XbFLAi5rP5AlgZRKrPVJdPLgMI9bZ6mE2KRbG2A4bVFNtAg5t005l7IpNRAnTUBuhUNIV7RQbggMToP2eGblju/BaC8shw89OsUKx8OK7jQ8cgZOtWCapIdfQW06UmAxHxZAo69ig60/J0yyyDDGNjZjc0EVBMo/cv+HVbVoesJLAExWIEdAlzKADQpBPqZAVEuVZZuwIDUghyLgVT+AD8A0TAaQIv8PBSxioW5IjzLSJuHADvpC2oR0CBoEJRnht5YiDJo2e8MAe6lWWaF2KaJz3Yxi3XhgKRKjNinqWaFVWnMzSL+WOcMWMsb2YPCHJs42RNDWfvOXYeok4tav4nKxUU5vgHmjdEpRBAnYF1mnS72UGD0geXKgZglWO1sm9xTN5Q6XYFkucaFoZXSGPftL5AqV1LqoUGkseyj2n+xo+wgLc1HYsT43xiIhZHPIOqcDQt8gA2CWZB0zACLYVY5HlxIAPygAALijh+eKPni4l6apAl41Lin/ARFNYHjPTjHKIHirU3npz0PCAO+Q4ABbMiNX1ApwS1nPbROHtWm992k90GnTODp19BNFkDfvjQPbVzffdwSDao/JNuHul6j+uDICuU2idG3j7AJWiE6SM4GxFYHTVwNnkClzg1AM5Wzxo1C1AAh2B+eQJ3IlgJuccHGrMBw5eZuKT2f4tYKP5nJfuJUJSnPfJ8MyF9ZcLBLwKqD4gOymB1WkZ1QENwAgIA3eIFUmUwAkswMCAABYd3YBQALYYHiacApIJQ1epv3AwIkJctu8TTE2k3itGBJW9AA/QbW4eJx3oNy2FzjYh5FEEnvT2CaHtTXOjSVylEfDFwIXCUnh/7eOjwAu7rhrWVGY9JgnRegx5pdbB7lb8bdJHc4W109cncotGRldB/hqLTpdWcdjTAb23Gt6vlF3vgo7PLhl/JTk0vOklbGKtsN4duYKR42VXfk/9OmVYRlzAfNrUPhWCoHCHiWPsGM+j/GcXreas8MxHyxWgsaYzwMAmDoBdEACAqAAADYNHlc+tqMPI6A+GgXsQourX4ciM9NdW2A6eYC1ujS1dqDbRAIOonMiJuLJKuiMmeCd6ZklzE17zXi61Dg2a+Cur7WCzhd9XxI32Xfy8nig+figEfpD2KSxvdVsb6lsIHq8yEsEDbii9Zk3JBmGagMYgcMipOAxRO0Y0/9pBBjACkmZ5XzQOTilrZKHLHVmCiKhZr0IeGM6pgNKjmhhnlaYY8mQlnPlDaDgGG+R4m4YekjVmJNbuXUpqntYAJjauVE1qnMmMgsgi9rjTTJPhCZ6NE/nXRVDj4CqKKKyKKyAKa1gJeCZB974jN/Zvev6je1ajt/7NNrbWdVXrwt7v/NYs3MysQF8SRNuwF/vsdW2Fv23KAFYYt4Ws0XwOhZjObq7s9u1dQrhM0kABWYPPHoOCLrgmTZ5CNPjtf80ladQO2SXpylsxVF4preujYzOa3abpjFrP2W4IJjFBsJu4tiyBZ/7x5M5uoNcyOckyJlb5nRJdLJbuxOOu7H/raLpNrN1Ayh6NI3lOXvPmLzNm57nmcuz/L7BfLzn2AW+RLC1dn0B2n0DGrD3eJACXEnrd6hgEZCVDanCNbIpwygDGLMlHLNVxqI18G4DrSJ32thGIAWys2UW8w2WKIc9paWBB5WfSKT9y4v6YMXxisWxx8WJrqZn3D8Oa45uWaByebhHQMF9fACMe7qBHLqN/NWLnJeQPDQQPAUJ2qALJn0P2G59qmmlJK7jOXzhe9jz+hPh+b5bQATSOFvxu7n2WybdmF/W/L8x59ad/JXgnH4JXEmTSqFRkJBvKTjrvPSSR48zO5JZhzXKINboyA2S4z4blrSvwDtWJsG4al5l/5eqqTpXML3fZZoSOJ3GZdzodpsWQP3g11GwrFMKxCb2WjDVU73Vo5rIpZuXHIDWax3cQ+RQdBDXc13KBd0pd91JJjnY5dnLuVzLU36eN/HKw5zNxzwoyrzZ7fifU9G5rgspAVxbs73n0aSPy1bcD9xJKwMBLH7PVIbjs4O7Hbxi1vViWic/8ArHw24Ldzk+x3QL23ILmYNeM33FVzj7wB6n/33rXNwkTMLgLQvrRN1revoGOJypIH65W13io/vHLx508n7vib7btR3Ozl3mCw6Sef3MV5G98da+sxflK8gmWwN8X35Y92ef1TXmDf/ZoV3N04yOqZ0xfsLjsb3nRf9fwJnU8yLbkIv+uWcu6ZVew1v/l0ZeT5gAP5buVqRgOTggA5bgT5deekB6vgw1Yv/joGw5p1ssexDe7JV/xpm/7Q8Kj0xd4no84pXb7q2/4hec7+tsoZv8j9r8omOf8gFG8YO9SOlaNlSevN17ryM/rjMq5uHfWTE/zfWi8Pf5zat99PV/9MsWIDYInMBBoEEMBzdAIIghAsMJECNKtLBwIQIBBAIIOMBQg0cTHz+INIGipMkXJ1/EMMHjRksmUPRAKkXzE6hSkPhcYZEBQooUFiieAATojVFAgigpXbrUJihITZ/enCqVEiuqWLPy8sS1K1Q7UmJocOjAgNmLZzH/ql27VqPbt3DXliU7t6HdCngR6k2Y0IPfvycDC67RAgVhFDlKEl6skqXjGZAj74jxg3ENJC0v52iJGckQzC08f/4smskQmENSq1ZdeEgIEa1jy3Yxu3aRHqNv49Zt5MgT37+LUBEOfDjv45MbJ1fZ2mQJwM89tAgBvbr169izQzfoka/3gw/2OrQ7XmL5ihDNuuUIwWMGku8zhBT8WLlmmI+2ftK/lM+bLjC0NwILbyTF1IFVQRXVTAlmpVRVDtLCC382MeJGGZttgJZaaanXVlwBACDiiCB2aJYDZN3lwF157fUddTBGJyN9NBZm2I2W2SfZcjuS9hJjqXkG2pCh/6k2xmmr2aZkbEAuuRtywRUnJXFQTsljaDjaOOOWMXap3ZdgAvbiQt+JZ2Z5eNGlZkQWJZDRWxxpAN98IzlHUn2UUbbEEm7sV1NWfRSFlCMGIvgghFcd2qChikbICy2fPAJWGRjmkIMGFpnIFkYkhuhpiRmZ2MCoc9WV5gVmbiDCi9htqeVgWJo0xI1ZXqnjDkXmeNlnNZhGmJCEpcaEaEES20KSTqKkbLJKVkmllcY9i1xlttZY54x/CZRtmNxaN+a3Lp7KorjmrVnRAeiy1VFIcqJAZ0o72qAEn37++aeiVyWqr75V8Rtho1jRJPBTmjCSCBzDlgTTZhCkW8CHEP93CqrD6ZJqMZrk6oUqq2J6aS28QCaWZa243cpcsEzywCRpxf4qLBKmHYksa8zGWnNrzkar887OUlvtq1zKCCN32xbdLZgKgdtimRmbuyZZ5Y6qLkHuvXvtnTo2kQUfU/GXy035IvpgogCDLXbZUgmcy9c5IbxnGKAhxoSlHkyQLogS5w3nWRU7bfG4G2scrrZfBv0cfYcdJrLNJvMoJJa6yvY4sEKaFoaPM9+s+crSdu45tD7/LNjRRhNNeulKM7306nmNl6aafCdQbnqbul717Vfr2kQZfj4qNij5hr1vhKMA/7tWVLUNxQ0faKvSwpSKrOHdcOktYu0Uc6R9uaz/ixt4X14WbvhstaoMObNNNnm+yywDi+QYcB/ZWeab2ywD50/mFkWUPH9u5XK1odHpSoc0wvnFgKlTnXcugDHyVOBiEESTxUIVqlHhBXfvwhNkmCCTR+ECF/cymwiNRzZ8kTBsEFKbUojyBiiAJAIIGI+8XHKDuYnlgQ/D26ckJpcI+hAhDQBcqgYnkFW1ajoh0JJr3CWd6qSkCIaJHBR1s77c6EZ9mRnS5Cw3rM70j4r0K9JqwEjGZvWsc198lu5QNjrDxag7BDxdAhU4xDqiKogocqAF9/jDiNyNAGeBSHswiDU81RAKjLgJCIH3QeE5UoSPPKFTqFITg1EKCsuz/0AMx/OBEdjwhXbzkA5BBci++ZCPGrOgHcNlRPG5cVbuguUUXyVFxTQLR1PM4maaJZoxwGx+0vKlL6lEs2OVMYwlux8OcPaE/fUmjdAsTmiIZLM2ekwkA/wSx+a4SjuuSJV6bMgpL2a3BPwxkIOE4wfeU8gRqGSGZcjPCRv5tav8wir3hKQ+kzehShZlJ5Gp4QkK0i7H9CSUbxrl3kppyu2V6m/fXBEQu4mBVrbSldaxE32qGLkoQk5XVHRZjqxIUiQIE1on/eIYo5Q5ZSbTmCvln/9mOprzBXB82TwaN+lIUQamCpV+HOceZfdHjZxlIRhkZyE5AwdI0BMUsAAeN//mGUl9ftB3ObHQhRLGAYIMaDPuNMEJ5EO7iL3lTQ9jaCkfSs4gkgePDqSoERF4RJw2caO2/GgtZ8k5Nt5GZSP9FeVOM6wwdHGwn0vpX4vgzMYu05mPlcH+ItsbMTqTpjQ1zfkWB7QYudGuGWUiEoXmgYuCb6cK9OnqXPfWqMFOe7JLT1GNigCkyieD9dkaIxd5Var6i7f97Gek9LAGGtIQJAVx5wmWe0MYipKUFMyeQ1ubx++59Ux1PAgIwOdEO4X2cCWBJawCu0bymvczIgPsrrQIM8MKM6UxpYJiT7q/xso0OPbFbDQxi6X0dha0OPWugJ0TR7oiELXfS+XSqgv/NaE6FEVrOqdRFZDOqin1MTdYQ36A28gTKgWFaxNuVi+kBJQkV6DMdUl3cJhQ6Kq1LA8ODx9LJc4aX5ei2+zux8DrKqClpHx7FWl5hzxGzAjTCkieb87k60XR5Hc4X2BycKK8BSpXWcr71e/i1Lfj7/Z4wN6VI9EQ3NO4TuSB4hxnuthEVHTBSXYSuG0G9aThRtq5w/n6BTeCW0kSL0/FeGEJit3pEee22MUMdXAf4aqXGw9urkSk613v2mVrdfS8RBZpSM07pPd62qSg1tmS6Wvl35T6yqdONZSxfN9WV4mN/w3wl69GazDrlMxlnmg4XzdBUmkPxg+LbZsGUDsJ/xjbPSBZahKaOqEQfy0X99TzL6bdT0lRinkhiMGeVCwnS50AuQqY7SjbEki24hGcjm60uiP9ne3uxWjjq3QJgEbLTJP3o1cUMqwB27IkpzTUnwb4TL1g5Tag2ggEP7jBz6DqVbM6y4v9K2dtXWtZX8vLAkYdanm6SnT/zbWl6tDH/fjHAcAZdyAJ62U0XA1n5wIbv8AGNlqOC0v+GbDzdsnNR3DbhpkV0eaGsJknesfAocrd7E4IpJGOcfD6mN4/3ih5I55vfYMGc7U0pvmM5F6AK1l+inXW/qJM8DYsPOFVRnszUd3wh0NcNvKmeNx5TPECQ1pVSWclRR3NaJBHkP8jzoXxecJNvQkLcs7yWsQjdkvCRxgsC6HLIiaP29UNKXQ9Hgp638uTYKPjeFUiYLpB7q7jGhUG1huV5ZI0zXqrW9Gvi+U3voV1moC7ndVKxm8bxp5wsz/T7AtPu9oLntJT6zffT//srOVOd+bbneM8RTrSUylR6vs98M6VrkMesAAKS7gAJ6eTZLpwh0WY/w94gMMaugCFLrhkg8a1IVnRcvnolpucq9115+Vq4KFxx4imlUSpN16olxKqF1hNVnWCtYDBwnrIB1iicR+n0XUCZ3sW6HBTVnbCx3umxnDB13a3B2oz5RkFaHHNN3fOR1r9xxfTB325ZmPX92DApn3/CeB95kRs17MRh5c78kJ+6rd+7qc17VdD28ZtOHQW9ZdWDdVgrPWCGtOCpBeAB3RNpQd1VrgkKHCADbheDCg/l+GAVxdk+DOBtYdlFchkxReCG2hww9d7Hphqb4iBajg5VHJTy3eCKDhplaZx2uWCOIZdrsVrDpYW2ZcuFNZ9hJdDRkU18+EDP4AFZLB+ayCJXVCJRVgZ1BF4P7c3NHhmTshu7taCU1hEUqgqdUVpN4Uyh+FRvDRS7KWAw+SArJF1zNRFvhQ/c2iGISgcbWhqwNeGcch2VgaCz3RGyYeHeZiCGaeCfOiHn3hjGANygId9fBM76HKIxnaDU0NQSeSITkmABZI4iWgQhDDgAiHwOh5CQYf2KRvRUNP1EHmnaxsjiqxUiv03ik33dFyGS8YUXnk1eyC1WLH4V5oVJA64hTjTRajxGWn4dQ73aScVEAAh+QQEBAD/ACwAAAAA4AEOAYceCgAmDQEtFwcvIQszGws2HRE3GQc3Igw6JxQ9Mhs9Ryw+OCJELyBFHgpGHg1HMxtIIw1IOSRJKBRQSjJVKxVWKxZXKAtXMg5YRCpYSzRZOSNaLhlaMxtaW0JjLhNjNiJkHgFlOiRlPShmNRppLQpqOyVqRCpqSzNqVDpqW0JrPSlrQRxvdFlxbVJyWzd0QyZ0RCp0gF11PiR1SSx1SjJ1US52Nwt2Oxl3VTl4SDJ5Qhx5SCd5XEJ5ZEl6Rit6SzN6j297RCZ7SSt8Uzp8ooOAPyGCPhSCRiqDRSSDTjOESiaESiqEUzWEVTqFWTuFXEKGWDeIZUiIbVKJRhqJRxCJdVmJfGKKTSuKVDWKVjmLWTaLWjqMTCWMUiqMYT2McU2MkXOMnoKPoX6SSxySTSOSqYqTX0GUWziUZESVbVKXViiXfGOYYzuYhWiZVRuZaUeZdlebgl2cYiucbEqccUydwZ6fyaWiXByiXCijXTKkbUilfWKmc0uneVeoYR6paDephmaplnaqZSmqelWrglyrkG+ronqtcTutvaKubkWur5Cwf2GynYKy0LGzbCuzbTWzfVa2hVq2imW3eUW5kmy5mXa5qIa6dTi7dC27gkm73sG8o3q+gD2+kV2+4MPBeS7CflHDezXDfUTEezfEfTrGnoHGpHjHilXHlmjIgzvImnXJqIXKh0bKlGzLhDzLklrNpW/OkU3PvKPQhz7QtpTQ48bR0LLTiz7TjEPTjUrTjlPVkkvVq4XWkUXWpnjXm2TXsovX3sLYllbYwpzZkT7ak0Xbo2nclUrdmlPemUzeoVrhl0rinmHjm03knVLko1vkvqHlu5XmnlfmoVPmqV3mrHXnp2booU7ot4fo3sPrpFTrtXfrxJXspVrsq2PtqlztsmjuqFXvsF/v0qzxn1bxpVfyq1byrWLyrWryrnLzrVvzsFf0tGv0vIT1smP17c/2sVz3uWr3u3X3ypX5s175tWP5xX36u2z6yIb62Kb7wnT7xXv90Yz91Jf+5Lf//OYI/wARCBSYAMEDDidqsFGjRpDDMRAjShxjpIjEIhgzyth4o6PHjyBDvhgJMiMXjGRQWszowYJLCyRuTOlCkyGZk0ZsWEzEU9SjRz5HAR0qdOjPPEghulnq8FCmXsikdZtKtapVbVjDZb221dk0rl+ThdW6jtrVqufSenPHtl7bt/DWivsmV9++u/fy5rUGjhq4eHcDuxWnj7BhdvLsBl68WB67v3AjuwUcT69lvJgzX3bMmXNfb1Wfif6qrHTUWLtQo/b7LXVU0lK9yl4WezZatXoD49vNu7dvfsCDC//Ne9s2xbrvcrPH3N5y5sP7SZeeb7r16v12b9ud3Xc74sW3ef9LzFsCwfMYTnTxwhCP+4kTjVC8qLGIhw8jWuq/vz+/f/8f/SeTSfBdcQVG+7kUUxA12YSTTmrwJKFPP1E4ySgXBnXUe0y54dAlrJh21ohdgWXiiSiyRtZtcqkj2WMwQqbWX4159hmNNc51GFvkJZdjOuK9+FZlm/Xoo2ZFWvaYNaMdswsyTp7mJCtU4mLlaqAVUwxsXM7WjG21TYVbj/zoBt6ZvUUXHnRsHtkcPtwIdx12102Hj2Nxdoemdncax5di+BQkqKAaJKRFexwWWJGiGnkAQkuPPprgowp6QEKC+1064Ew3peQpS/opOGCnNWEE4R8STvgTURVOsmGiTIH/KExpo5FDIokoXiNWrl+VRdevwLYoZGS/UqbZjX4ZuU9lOg7GI3JuOibjsM92Zq082tV4rZKgMQllaldSmcq4nFyCCSfk3hKLV1nuYlaXXr4GJlqIKevdnmcOx9x2+Dr3HHdyUkdnndkdB3C/2EprDJmDNrxCDQ3CGl9FFnWKEQgYY2wBpRtX0PFLIIcM8qUwbaoSSgYeYV9LDYiKRKkWU8yFqkMl4lOGFRr10B1LeeiIrLAxaevQt5Zo4q7wZuWiOcE2TW1cY2qrMF84CtZss3lFu1iMT9drrW/2bmtZWlJW6crZ5mKi9troto1la0/C+yVt8c4rJjqc3dvmXfoe/+z3cPzqvTd4BBdesHF/4+snOIEH2nACCxwEMaJ5FAjRovJFhKCjGDvAMaUOvNSyyKR3ZOmoBSKx+egWjLCCDlw0SJOp8v3hU081557zqxz+/LYyWhFdTtHBz2388UbreNaM1ApbrdfLMvsZtNFfDb2bd1Y/LW6R1buZ1tcCyZdZ35qdrlDon63ulXE3Ke/7SMdv9915g01ecPkmztu/gg9OuOHX6RO/7KS/bMmjGta433ceB7kHPMAENHFPokiluZXcBFQZ89jnSMdBkI3AB0fIj04IRMGUWGpkr5NdF2Zig5hcIQ82wx1QXMUqV1FIgj3DwydyMSuhwWZ4xCve8f/kxyulqQOIQORe1yBjl72QZ2rGsgdwmmO93IBPWjei1rV8pLd22GgqpgEXD81WJai0T0Szig356sZGIoapLspqogL7pSZ+LKdx/XsO/w42jz4S0I/4Q2A1+Ii/Pn6nOAqbIwMjd4EZdAGHSKlcpyhiksxdcHP60ZijQtXB0iUhCTI4XcUsdslQiu4CC4LZg1woQwuNAkOisGHaNtShn6VxjSsKohCPR4wiGpFpLFpa84T1RcEwK1luqmLYpMY1pw3pe2Y6JGa+uEYpxe2a8nrXXErjmluCUW5RIqLxakW1+iXmnNHEVx3tgccp7u+deyxT4gzpNz8Nko7fmVo0HUj/kMg1EIISfE9SJjbKlGGyP/0h3QVQCZOFvuQGn8yBCC3oKUqqzgYggMBLUvlIN8xuCi2s3apG+hOeGOWVvOPZJ0jhzaQJD4lGxEoztEQbJ/kypsFU4lucVxe2wLF6yExmYd6yTGYKi6fe28yerNUtbY7mqVBljVTLh02oWjMZ4awp8n44ni1mpoCEVBM7AaUv7PlmOfJcjlq7KMjj2Kt/S0JMb/YRAcgp4K53hdwKOioHh0hSURYtJUIHe4H8OJShhIVoFkDpAY+o7iQV1MGlHBC6ksFOlSAFQe1iaNLdzRJ9tLyDIKj0xhO9tGhzU9dWv4RTmMJUp8dkHl18Ciy5/wI1qHMtDGuq9SZt4SWuwpQtjLy6VBuhQ7hNTS6wmqSaqoYJq1mN7mqlgjd0frVNYq0jAREHHuW8k03ZjedcEWiMPxnnvOBF5OK62lsMRACv8F3ABPpK37/Cx5LzScnFGnuflQ32P5cKcGEF9IPFvkCUozyZZEPGUZgVAaMV0R1Q0ufZVfmBZ6PVBbtqddPWdoWm40xRLkmE3NgiFytrydoX3UFWeeoDeHK5ntSMqdwSE6l+CGMqt2LM46ZitbnQxdKGvSJd6YZ4KtDDVvbSSxztAo677pSiPPHX23tFQ5pYNqC3ynujati2ONmLB5PKa927oGACE4AvXvdKOctdjv9RAbaP6fDDH9fZWUAIdR0IGatZlcTOojeYLOtSKLuLxsQIDsGQzUBbw1n61ZZD5nCHSbQMLfWypsMz3ohzGty0SK+209KmbVfc4t/u9sbUSzUWncm941yvgGIzbjN5LJopqW81ytiFK3rh1G8W2Y1qrG4+cdxkJ4sVylSeIgGHYZfs7iaew07HmKc97SRbi7xkZuqZ09yBu3YAzTWYXJvvm9/INlYkHOnIClwXIDzfGQZCOLAo/1yfBQ+a0H++ZE4Q3dndMTptobAwhp4LThEnzxlOusWlWasVhruW08LdC6h9Shr2khpaLlamqo8kcaQeN0ZuJVOyjaRjrs26XeL/AhFpy+YuSl8VukcenrXVqV076WmseXL2FLmbc+DsEdrSksZrmGEWLvMFSOFDlsnR8e0OsIAF8J0AQCNJBvu6ObL7Pne6t65uds/Z63WGt2Ehmu+MgJRlI7tsTVgoWZ2gaqSL/qy5bpa2WJbWaJM2GvuOLJulEU+2Lup4cHHpaVJbcR8ZZ83Giau9u8F25kv1oqw/TvnkQomMKw/juOiy4eWGBebALkd1OyP5YtscgMHhhsGMvV199NznzM6y7KUNP6giPemgoS7VPn7mDvi+29+WehIqF0mrX12/FdGsSM7t9XQDeCOG1frYGVT2KQShIxZogPZb1pFCr7LqcR+p/yheGXBYEsXuBHeph/Fe6VlYqdJ9BxPZuHrE1xZL8J6v+Dl2/Dy+LebU0JIkP1JjjydyXVRyJ5Z7VFVG2WQWroAJvKaATVNNoUc/T6RkYeVzhTMwPocN2zAMAHN6cnJH29BzcfJseZQYCCQbViUau3d74hMa4zM+vqcAvjcB3QZuQ3ATAzVJloMyGYExgcYS7TZnXyd9J9Q6IxF91EdvL2NKKKR2HwVSLQR+JlUUskRhcycKdCM8XHVwOEVwVuJ+Dpdpnfdwy8M8g8Ei9Md/o+d/NIZMqCZHi6cWLLJ09RJ5k0eA1FA2DNiCypAKl7Al3bArE+hr84Nk1oaBGVgn2P/Bgaq3HT0ngu5kHK+XVmziRbLnGEPnQw34gnHVgmBkDWiGZmomfJ3Sg8cXWX22MqYiEkWobtD3EnrGhEuQMlNgfUoQaC6hfZZVEzATaDEBQ/1mfjSEUrCkYV7YJXhXIiM2G2OIC2Xoa2iYhhNHW/lXcSc3XAYoZoqngjgCTVtjh8mFh8Q2cpK3asplVbb2fvoHVYKYDPMXRMx4f4xXcwJTHY/4R4iDenYSiQMUHLEHXqWnZEEXFT4mJW9EeQSHFmlWV6Z4V+4lbsa3irRzaMsHi1x3BFhwBqC0ZxJli7iYi9fXi6PzQUoAjLMTUvzWaOI3fsl4dx3GFeZgcLtEDOr/g2kkFkQel43xsz08dnjN4Y3hyEQhV2a99RmsxjUGCGYJ42qVl5C10QtAFmzVFIiYkIi9FhrvWHjEFVb9MA7jkI9juY9lYonAYZYcuHMBWYkl6B3hI3S6p4CnESZEd1xE11JyyQzI4E8O5E8YwAEfNG6riHUaqREksZEYgQWLoAq8oAqloAqSMAefNFG4mJIpmR/b5xLshpn0NlHEqDswmT6xBAp6iUu7lHeIqCXqo5WOx5PXuJWGSCyBJ2OJF46xhpRWozw2dntncm3kuJcKKUbt42uu0YdqU3vr54z0Ann4qI/QqZbbAAtSpJYB1IFQ9o/IFm0hJ4Ef5z5plE1E/yeX4WmXfikB/DRgR8CDqliYr7hvjlVJ1yeLspgRZsALYpmf0KAKfWAGKtCZI6k6mnlvnkmSmVURoRl+45chC8pDaiREK0KTEWpaEgpTqeV+0hh/D3paXHmGOQVO3UCbXqliQzmiREIj92hqvNmbTallSGd55akLqMGAoFdG1wRpMPeFW5mGc9iichKd/WALZHk4aemPU6QPvvCWT6aJ6vWidBmcwimeUTorOikVdSWY+IGlKMmeEoNfJVRviqk6YFpvZhAN/nCm7/AO41AKe/AEN6CEBuKESDCgGqWe1/dY71kEoSl+q8KgIbKhxTOhgQqhm7aaGFqlsNmQxBNGJv9SeDaWajpyTp/GeDkiah7HRAcobaEIRlc1o+liPqQQCuPSPq4gCIOIcFmlo3/3TD76o9EpnbDADUI6pNcpQM0WZftCkAd0Xn3hTR1HnhpWl1GqVfEiAiJgKE6wBYsVp5SDBz7opQXCdfEpn1tnEkXwBthwpv6QpvmwCoAABfuRb7Gzi3TKmYqVB2bgkWJ6KS3pbw0ak4CKmhVKofNaf8apcGcjPx26qKpqFr4CerOJjdcIqSYqPT06OEEXmzPim065h+ApRucTsaN6RpjgBxDoGqnalbLpeNx4jgFDq/loD7BAC/kInbW6L9vJTgU5XsgSnjGymsQ6nuQ5RFGyAib/UGBoMAd6sLPpahPt6Z55GqZiyhH1oTJzEA1pmqb+wA28QAhM8FDMOq47UK7sdgY2AwmJoAZLYDoykaAK2qDHwKFd4Sv1ypxoeKGtKZNiu4z9ukbg8pNQ6kx0OFvc0qO6uZs9tqnlxIi4N2ZCB7Hicms2+rYi8gzJULGDSJw5+kNguJQe+7Elax2+4AvzMDBASkAoi0dPiQ8eyKSaGINUigy0NqxRQrrBGl0coAM7cItn0Lo926w+aJHwWRIqo2D1VrvXirTvgKbj0LTg2jIkIK6X1IuWdVk9u18utKetMmFc6KBq26hkW6hGZIcy1X7ux1Ixh4j8Wo9hRAxUeUaH/7g8ckRUhnewPnIPBKi3XcVdJTeDzEWce5c0a2QajuAHqZBwAPuT/dorr5lizlmkADSd1Rm5J3scSQqXvGpOUCQMMioNDMmODGxTLHi6DRxOu6CeTJAFrpsUxPezPxgz6Fa0Q1u76/lJubutu+sPvRsJWxCuG7wQWLC1ehYEEBME5xZgJCCEVae8WLigRBOv0Su9Qux31cuaoeq8iMq9Lse/tBJk64M0iTq+JppFvLV4S6KwoIh76jucVbWOD0sNsVC/u5ah+fuJibqwMJhelCgdIqsPAOyPvEqdS5bAUPmU6nh5zhC3sxG6XKxVqFtYOrAFOssHhJy1xSdJKAG08P/5ivURwzGMMp/EEFZrptt6pivsBStgA3vFBjtbyDwxBzn7Bl8gymiwtTh8KTr8dnwqCpmnqGb7K1DzK9xLvWhLChkarOM5NEm8xEejK5amcOArqPtKLHg4LeY7jv6aty6YxW7oxYU7g6P7Y5mXCg7xJDwEf9icvUUTVUEpHowISG/MTvcEuSfrZShax+AYa+hQa2OEYlcJFn1cxoR7wXqmBXQwCPjMB3/gkYgySQVVQqz4KLR7BWbQyR5Z0J2cCK2w0NygrWfaD77Awhm8HvfsyYRMymyABunqBY9sEQfCknuKKuTHylK6tji1opy3VUSMqmMYqtlsK3fZLrsMhr7/7MTAXIGKKrA7lbesSj1hxiR8uMw8vY3hC80JOQtu0z6IK89GxsRnXI6PS2UIJGXkzI9d5hkvmtUweMUszUNSiUZBFs/znBoAegakjK5nkIoVeXVmF2fx+QRmAAmgsNBZO9eTO7keiA2VC53RwJ8Z/decjCqAfdBaAAUT/chWi8hdq8oibXe7opxOfdKdZq8zJcH5h1Vo07wkrZN0OY3qBz9UedMikppsFKI67SyRaszHfFs1xs09CYrkGNTcFKrnAr4V6wrxks0Z68rq17/n3F3lNc7G1hvTmW1YrdWUlw5OhHKqBYi5/Wu/Fm+E9sIGQphA618IthE2wwu8EA3A/wAJbOALV+aB0TDeIYsNLMzRg53RckDYHWnYEx2nCJ3WnJLYrZILxSAMMVva6+cr96cWddPZmB2qLEUOm813CC6/8gK/33tTrvnasdzTSIm+H7qQyDXUSkdr4AJwLTcb9ctrqEqzi6uhbfTgezvh01ZlzuZF4MBldrFeRg3beElVxwDWLMioGAvdoLcQk2PYG6zWA5U5/+yDoKJ1G4EFiSDe5R0NvpAIg4AN0ZAP0KCJfjQwEb3e9XUo7n0osxM79s3P9W07tny6dqPNO2pjq1nEQUZ++B2qpom/6cffvWzT3lvnwCbnEHepJhdHOv3VQh3UXtwtSjngWyilpeoINf/+3E0t57s9yzEmxb2qDIxjJCNH3Ea3auOZ6dD8wNJMxtMFjTnO1HPDBlwetZJsIGkd5G/2gyzRQkae5EsO5a0Q19HgR+1Q3vMADSELDJ3gBQtB6upd2DThyA6iBKtLE2+3z8UOQ62M55G9lBG+0yIOjbTd5gN34FO53yUeFr9c5+ty559+5umL4QRbbX4ug9yc7lIFuCr3JJ4oGofuPro9758+7Z8tVYYxVCKSYkepq32S4lOj6Zr+wIUILs3NqLX3cmXcJcCukg6f6sg3SqxOOwKNEWbQCuVdCqDQmIOQBafgC61wwLUOztUxD98d7Owh7MAI5lPIBX2l7O3dHk7/ESLlydvPjtLQTnHybCu4QOCm+Qk/0365QNLZ/tIlDl3eHtpQwSv23rZFPdQBiJdsWFrv7NyFm2sRe5zeUrrIcNucKuqN3vSfB9m0chvPHGP9HpeiUS/rbJcN+e6sqXAknvA0ruOkYdEJDcNqHbvHh0EecQWgsOSzXgTvjQqSsB4YPw/fgeslPw++kAm/HvNy8EiSH/PASJIe5bMNMWFkbvOSDTWs2ueXHepCN5q5QA6fYL+aTfQz68fTXqPdrvTitPAmLu55O7eyTfV0T/dU+almjMeGKwh38KdySe/G//q0T/tlz02zubdXLT3e4r/vbvMLHr8gCup2zyWRsP3c/y8J2z8IPJ6KN0ExQw7C8Kl8MpAHqgAN7A8KNyDQgwALfDACNpAJeZLrJWgn28DCkQ8QcuR0EdjFoBqEAgu6QSjI4cNJonLpoigM2cVp2jRuvJaRY7dyIc+NdFeyXrx78vStTHnPpLpvMEc6S7bLZjFcOWuyCoUJk65lj+58GiVRFCmJ5MgtYzqxaU2oUaX2olrV6tOlTJth1LrV41eQ1J6B3RjTrFhvaMGtRdlyZtqwcKWNpeuR691YF6vy5JTKby5ncdHqdWot1h08gGne9YrV8eKnx7pulWxxqlTGlecKhrvWs9zN3tC9nQtZmuXJXG/qzGzXtGScN2FDDT2W0v9t3Lgh/THIJSGZMcGNAA8+Zrjx4kWMGCHRnMSII4mwQYOGDRQSDx66tNqWaMSKSPjmiW+3bRu3ef34bev0R+F7+AoPzZ80n1MmvjxZTaxosTRZAMsyRyaTWlJpHwQTPIkdkmKaJqqcXJnFr1SI+imoOxwpyiiJlskqtcsus4qYEXHR6kMQGwvQNbLQclEtthiU8awX6/qvtdWoyu+vuRrsxhplCCvMlQyREes1zFKcjMRilHQySc1MA6vGG6nE0TKLULOoFwmbhBLH2K6K8r9uCDGzDzj4oOMNNs4waIrgECIuueOKE0655Zx7bjtsymvHl0kMkg4bVOT4wxj0xtv/xhhfEsVnm0wU0iI+gQ7pC79YMt1SU/6ipM3Gj8IBkMAGF0wpQQXdKikmqCL06VWfRGkmF0cQI+oopEhZMkwxY2GS1whLNNHD0hp7kkUVV6xRnFIZpLEzIG3ESEtOfXV1P/9E81GZvawd65KhbgQzsyiJ6XI2dCP7MsTUqsTI3Rs101JddINdF8xeP11MmiiecGIIHGiYYWAdCoYzODzmTM5O5JDL04bmbNCj0WiiKc+YRNQ4xU9YjGlHPH4eZbQaex6t5pT54PuDPkzxC/LleSfSySl9Q11RJFJHM3AlVA2ckTJfK3zVEaJlFcWR4DRcBteiYntqZmCF1fFcXo1F/zLJfbGGeesXP9N51dG87mxrvbCsVr+8lNE27COR0bHasQRxw5Ww8Lo3XZyoxntvvvtOcdzZYhYGsMBz9Otuco+B2suapdHgAw4ep+CCCyLWgQo4G8pjczw6V3jh5ZiL2IY/SPaznV/m8/j0A/UxzxhljFlr0VdOiQU/3O9jBVNO7W51cae9OsvmUJttdmeWfF6VpluEhlXDpZDOkOkNO6y3eaml/uvXW57c+2r+9tO0dotgB7Iaa9ZOZ332VWLfvPdnt6YaBoEUBnbYz7aJmhhHa7tb5unCMA5hRbQS570wdY9eXmLNAmHTQAf6TYIR7NTU+tK3/SUuaimSQAcn9/9BCzwnCJhTw8oecYlcgeIoJySa5zBnnNAtZwyHsMbp2GMp9K0PffizX9p8aDa32URT4rtJkIoopGABT3jDIx7OjHc85bnPJTPZSZd4ckIVfoIhGqJeUZomM+yFkXvWEuP2Nsi4CGotU7nD3St4SD/4xTGOrFNJeeQhR/PsI47W8AX+XpElta2jQP4bS44wIr4BJoYZ8ZogunCFxnoh8IEQpOD1zlhJxRmOQo1kl72+50EPcmAFo+yCCe2DtoqoUJVFOSFiGIKwlYHiF7OUHZBsxwxakm1wQuzdlQC4rqglkUkCElXdBJMz45lFkAVC3hTFYriijcIPWxTFKr04Cqj/CbOM2xTjJGcBSU42Rhe4i0g5M9EJVPyij77Y4cjgd7ry9Ol08oSnHRe1TvypDUaeYeS79rMfaZAiQwIsVjifhk1MTlCJmBxW9qpGOJpFjUKHE5Gv7uZJcC7DApV7gRBqAAU0sIEP5yRffwrzH1CY9GjRlAj5Zlm+zAguTN4KYkYZ+DtKgpGbJGqiMeNCKqA+i5nNZNaDePmQT9TKDRqyZq5mlkQr7hR7egsTUhpq0CDW5xBq4upII3HOSETCdq3oGDv7dFa0ppWeaX3dOvEZpFqez4CEqcnLeOQMoTgiWzFL6IS+6UDrYfCSgg3mQm9a2Gul4rBkDF5FtQnOK4DU/6vodOP9XlaXxm3mRkS8CCB9dzWcYlRMOEXs9fx6Wuw1Y0DFZG2LfBRUoZpFRso7xyJT6YjN4bZzJ8xFU0nx2KlKVUKbZCBww5kllCVCD8pdbnO7OglISIKs6+QF+s7KC7VmFxvWXacqYOHdshqjdiOb6w9bhULL1AoT/QynU89IuMBaL5uGBew3n1rGvL1XmxN1aPfy5c2oAs92Yy1fXAdzs/SRRlx3IRvN2Bva4oqpIyLq5tMiZEUrekgmTNyXE1/74WNCkW2nycUoWMhCQWBzlUwj4oW5ieGJUvS8v7Uq8ASMmXEmwj1bFWlXB8GHQUDiFK2Yri+86wteIDnJ1f9YMjaWjF0mu9XI3j2yKjpBiDm0SQ9iLan2YmVbuY2CGeUNp7mw6d9MDtbC+12sN+crXDRfdc1m5m9/rcJXnQLXgCHm8zH7/GC6pjkwSgFt1WZV4Qlb8rR4Q22jNbLhJiYTxEzsGtsIGdBrZjqlEyEHi/P8z+AGd7gZDm2NqfrmO1NEhWpiU4/1sCavSpfIs6b1rLsr5SS7lcqqILIpNkEJL9RgBy/4zg68sFWS6u8WmEjxIW0FF9T0tXleLIaujHvVx9K4tGyGqn0XfUZdLUPUdfavKzJV7v8CWKo/Xa2HKe1nQscbXhDuEkikNJV6H3pxiT6sqCH54nq3OyQ2mzT/bN/9020h42iZrp4qx4kro3y626MOML5z5V7Etrgyqn51mzw+BzQtQuS1JnnJS75rlK8CFXHwwihHaQKYf5QNyWZsLFJBQOQipoCFDLRNtXLNv+a320PHRcSB621uIx3GSJ/Zb5nk9Kne6uncrLkh99Jo1DpR4AaHNLxby8gSuSIU3xx4oYtuIkILS7VAAxbFJUPiiY8a3h3mesF9mhFo1daWJq4ei7uIwg5JPCfn9ndOFedUxI9R8Bs/xVc77oUeD0ISsibybSo/+SFffvKosHznPU/rVRBiB4/DQOlhDvMV1IAO6Dw34TFRpNKIwg132HnPJejppLe92ksrOtRf/yzuuI/b7Vg/OsW3N/yaazzjjob01pvv/NZGH1lpxl5PurdaswfczV4yquLHDRnhWz8wCqY7Ml9id9fK9hydljrEmSaUznXOvRpvfdiDNS/gXxzjy++UqiHBhzbpAsijgz7YvFaYPARMwJETOQVMQM/bPErgNUBwgRUovciRHAtcASiIg9b7J07wAz9IBZgSqLmxLduzqVGQuu4xteq7MG2zKtxjOt8DPhIhvt5LPEebwbObthjjwcKruG4CuNN6vnarOyYqO+IBv+AiClz4CKv5uWFJuzVrjGvrPYgKP6LQsK4rv1IxwrhIP7lIwaTwOxPbHDIYDkFQoQEzqb0BI/9Iwr8VBDpUG7qKqJ3/YwMm8AKQ2wNAQEAG3IPomjxAHMQC/ENBDEQHlDVJeIJRukBHzMAVYINO6MAP9IOfMKBQmL0mNEFBiyDr870X5EHEozFS1AmEKsUajDtsWsWlMz5UzJWlcboYm8Xj249aBDU4Mz56gIegOgkvRELpMyYqnDYLKQYkVBJzQbvTsKRkmLAgjDvmwcImVDBRWaIP40VsfK27q4sXYT8OcT++S5jMiQiH6w8GMypAUzTfm8PhajFdQIVXCKtWA7LoIkRIGMQ+FLmQ28cg48d7dEBVqIRCGIIQwIALeJwHSMiEdMRI/Kpz44RaScOteQQqoD080y//C2HBOBw+1JJDjVzHjfRIV9S/kaw2FqQQTOiL8GtFjhRCudtFoPLF8+O6YPw6yqiiYtRCfsM3smMVRWuVAJs6jKPBUctIpZgJeVs7g5NJmKRGBPOGY/iyh6OeVhLHMXCIlXEIwNM4eDkNEvOsr+wtiUg6DyxL8Rmw/+PHNKHHPgBESbDHPlATteRHCKwEU6CEL6gBDKhADbgAhfRLBoiAyPmOmXvIWuEEsBSEioQoBwIeE9OQlWw0VhTJV7RBV/Qrhru4GyTDyaTFxPJMH2xJyaS4mCxNmqzJsHDC/MvJ1npCoXONn8wbpBNKuSPKiyvGoKqSpWxKIuyptLBCVXs//xQTxzqxk/jTShTayk27JUBaJOd0zmgLPrMsS1VrvLbsqrVMk7aESzjozrnUTra8DYF0gb0sT8pRyITsoAfggPWEArHCj0uwlLQBkl/QBTyggjzQBRRRM6TgIpKcEFKkNgD9z5IUzaLszM4cScrMzDMLzQJdQst0RabkTdPsTWBMQgYSGsVSyiekjFSEzTl7oEajzVM70E+Yxi0cNGW6xpnUurb5ipmYP1ypykdwiISxgeLEHB0tTuDgnNx6hESIzxRiw6+MGVz0Nko8S+uUyzlo0jTwTu5EE/CU0jUJqX4BmCjwTh5YT74sPfREgAIA04XkAByIg7CCT03hIVa4z/8/uEgbSyrIDBYCHVA6ZVArfFCSHDsFzVM+vU3QLNA/ZcXIpBAKLdQWhb7UTFSOGEYN5alFdU37etRto1PuGVF9Gy4xJApy8B+cIZMVlTRtJKYpyY/NjM/4q1FxxFFDOQSHcAM42dHhCB2F8Zzj/FHecr+TAj83BKN/WsO0dNInnUs+BMQnLdbudFI0gIImELaBGZiA6UvKwQDyxIAvDdMw7SBpZQMzYT3mxJ81NYJHMFJhaooUjNM6TVA7FVTNvMw91VOUZNA+NUk/JTexK0ZarJB6RdfE60ze7FdDtdBtlNTD84ssTJGdDCOBTSD/SkYDRcVLfddRWAak7LNP/cX/R7u79TO1GX2I3RIKKsBRN7CU2uEEVpWTGDpZlH3VVyoOxABBDWGhsXSwZZxZk6IIO/wxAjRWKN1OKn2DYkVWf/mBgGnW0+OAC0CA9dSADEABak1PMLXWpD0BPRSrTsCPSbyf+zmFM2xTTryknoiVc9XXzBTFUpzTA83XPv1EeE3XHnRQgt1TShXba/JXuj1N1ExYjvQehB0QSFUsEgU4MYwwhkPR0LC7ATlUgIXRZPgivtAtV3rZ+8TRNPyjkYXPFnqlV01ZGWKYF5o9hKlVsFUMr3zO06AlIouEuATW7lyD73xSNPhZK90CgAmYoT0B2zVI9XyA0ssAp31aAUDa//U0AReY2itzSAK7DipIhDFbJLZT2E+wxPbL1wFdW7OtXrhNW7Wl3kx7lVqU3vaTuujVXrGbqAn9V/S7WxCdOu5JllIjhvTdPoY1UADNwqUgW9z8zfGb0Iq1WHi70/7snMdNTlfVgaVyxzV6P45VgzvgXM6FVc/1XFd6XJZqzmihT1RA3WMNVjgYVj7U2Z9Ngye40tkVWtslYRRgWvZUSC9NAN8VABdGWqUdXjP9KnIastTZWvoBO9mEUybckbG9zeTE3n29XiEuYvElYrnNyCMu37o1OPSdvvX90PeN347QCAo7l5AEXCasX1F83p+AiZkliSlCXP49ph0suqTyHP9qQhmWRSQgkhk+PSE4PSETUoMdddWKjGA9juDZQwws6pRZgse31NkN3gPW7eAPBmHXDVraDZgSPmFIbtqEXOEWfuFJxoEBpEcaFp9AAdcaSgtdNUV7LcshHslqMrpTJuUjTlu0nd4jZkJ3ReJG/dpM1dPspeVQaEomJuPEldSdhDBkZFj3rUbXNKNlEz7J3OL6zZU5HoVN7YZZaca2UJWCq4derhsY8wkAxoNHUCWkqUiE0iXq29X+OxtWQNVa5Vit3GZXumM/1pBXuDwq5WBDLuREXmR/eQKhNeHTe+QT3t3dVcgWvtYIEF4ngDxtDbJM+LGwyhgdOJSLsR9vClz/JCLnXQVL0n0p5JpOD6ReXK2miOg7I5ble71lDbW+SwBbDR2kXSZjRQ1GSA1RSA21hJXNhX3QJaTfWWHmNNYrKpKMoRpjUH2Lg/tNWSzXWv0ncKlIpbmsjOikdJmWN+boO9WPlNZmAL4TcKU1DA5Wej7kewbhfOaBfeZnEVBa08uACQDoCYgAFh5oGJbWIdiCTEZdeqyPLpgCNlgdaNsUXPCJ+axg0h3djB6N+Imf5U2wIs2amm1sx56IVAZHc9rKk4zlkvZeXM7sq+6JvmDpls7NTu2pp76GNnvN0Va3njztpyAuYjjRcyU+PU27TFWvWcAsIwlqoRbj3E5cnhDL/6891ZYiwaVCzGZUzQ5tF3j5ka6ct0xq3IhMDEbhPECQ0jUohA5eA+zG7mKVAnwea30ma9o9gbNma/J2axYeAPQW08DUgBLWQ7b0sYE4A1SwIzJrvflBbLlKbMFOsHRghsPOof9unztiH3SIo3SwpwDXofWBzl1CLr8GNaoOW4hV2+ep8JTEBM/+7GvG0GG8pA6PX2O0YmPZ4VTE6agLZ3Gb7TBT0beLiWYSalNB3Jc+W3RuKfukpv3h8A6l2KHOu5dGkpxYHyu7jdUtBOvO7iddg+3m7if1bh548kaOZIMUTLeuct1l4fMWU+B9HOH9KPeOS+gCMj7gDSVIBNMBB/817Q8emisHL+fqXMOxcin9vm8Br6ePsfPxyHM9fxR4OnA6gh9+2jPbfshZZFALiRVEvxQMz/BddlHsq2Jirmk1C9FFg2JhTkbwbViEyor51WZHmMavDKRTSZXZoq1Le5YSc5WrthVZ0YVR2CJlFBBIT7RkYa3dnEmXPkLD9m8mu7zuzMd6TnLt5m4mv1IoB2/a5QEpn3Ir/9Kn1fJJ7mdM9lkC9DE1uYEbyAQ5MqCRBbyq3GM+Xlnj7FH3cAjlwqI2GrLKqqW1mid6ehRuuHN55/N2iAY9v/c8p3cBl5H0yac3VkPJvupoSs7yHWP9nTTRPu4yq1RHfQ0QPy3XPmb/+T0G2T70ZwNlzRCN1kGQKDL1iyUkVVaqyT0N6WGFZ1bUWffNW+9xJx4zw14fXiiFXQOE6u7DI1dy7sZ5KcjSJnfyY0f2f7ZAhGz2LEda9eRyZp12an8uNcnrMzgFJLunwYFIBd5RHL16zb16rdeT0dH64oysMziDlWku6AorBpSEOG88LoPztCeyXGIy7rKuuD8rPIKfASdw/mbwswlinyh4gz/4DY90qDa05VMg06hBd43fjIxQp6t4C3HZ8eO54maHUd8HVXnxEWuQmuKLnrCV8OmcEz3Kd0t5W195dQD8tdnfgXt5uI95KhPEfBz2nG9ynt/5nx/rKIdk8TYB/9LTAGc/AOA/evYuYRrA5H5ZeueiAy3AdjUgqUwo2SkoGKzvXAhm59/AXKsHARIAAe7n/q7H9uhXAvEf/8gqfyxwE/SfFPUPe/Zff7HPg+Qf+zGf7EsQMvu32rc3nwKHowQHCGvVrP0y9kyZsIS7dt2r57AhxIgP3VFUZ/FiuIwatXHs2OzjtZDLRh4rZrJkspQqVZ4k5vIWzFSuTDoDOTKmTJy3Prnq6XPULFI/fxbzRo4crlCflmISdMdRrm/dqNVEOY3aPXn7tu5jB84bWK8SK06liO7cMVYmWY1q6+jOnU+5dOVyClUaXqob9/I15xfjRbKB6TkULO4w4MTnFv+nG4iNly9VkikVAmS58p40mqukWbMmTRQpm5/wKE36dJQePXCwZo3i9QkTGmZHqP1AAoICECTc5oDBBI3gP4TUgLIFzRs+yvUwP/RHzQ0LJKYooX5jBAkbNqi46S7I0aNLolipnUvX/Kn0pzJNEv/ouZoxY4zQ157d/ojrN3Tw1+9ffxAyBLhff/1Zd2ARCSrIH4LUXeEgGVxI2IUaZ8ghxx9/KNfeJKCo90pBzDDjWDWNlbgNiilWJBGLDRH2ImJhSdWXRzbZdBJJOOrYEi496pTjTTAxNYtLQClFlJFJFgnUOUiJ0haUfsDlylVTVaWSNezow5U+X8nIGJhlnXX/lnlzRflUKGZOWZOVeoX0F5xxyqkYnXUmVg6eeI6ZDjbVRFZKJZJgdhkchYpWaKGhaZaaaU+ExqgTq7U2KWwi0EYbAw/Q9oEIKsTGw3DDNeFFFMk1p6FzbHRBwgUXZEdCfjrI50iH6ZmXUE0JTfVLXrwqtBB5oIjS3nt55NFdfTfYt+yr+Nmwwn/KQlugdvxNWy222U5rIBUONghhfBVaaOx7iXDo4SsghmiMY1mK1WKLhd05FV9V2mjVjkCitBaPafaob1BMLWnkUMSQYrBQA0cljbBQurXmQREjkxJC3sTDpTxeWjNjmGKeJU2ZQn0CHpppvXXJxHnROKedLbs8/6+ee7YD2WSXVVaZoV9wtrOiUkQxqaOpQWoapZVmENsJs3VKgwopnAAqa6cNMepxyM1BB3NYs7G1fdlBO2smaimUcl5lm41Qyr+aNx7boxR7rIRTSLss3drltyy00Na9N9/2bVtgENYBzu2C4IqrBh5slJsIH5OYK9GWEXXp4oou73UlSC7lm5LmPP7Lb8L59qQUTziVzhPqIiNspEtHJfRklCcfczbaFWvFjz1dgUUNx70vRpbYST38lI/f4aLyyiwrD0+czC//cswmPlZzZoBUEqhlOSN6qGg/o2Da0I2WBjTSSBMtPmpBN8GEcaRafXXWerAhd7dcyOGHIJzEMv+2MhKz+T8AMbeSfR1vbbpoWCIyhDgKCc5a18KWsvrGt1c161l/o1a0okUf+hSucBCa0BVCqJXIkbCEY/ndYvIEmBrdSyQAG6DnPnewmYgudT4ZXVCQJDKHtaUoRjFT7IzXJv+lzB0Y05hedue7bpgnLWxpypRMhglW1GRjfXkeFrMIvcCMCUWRaYUkMqOZQbUBUWaEQ/e8ZxqfhQ8HbZxa+b73KPCxkY1okJr7rPa+ORxCVRdyDif0t7/aXSWALrSRAGG4jALmIkhmChZ7AOmUcHWnOwukpBvql8n6TaFb3XqWrHRQQbqJ0m/a4psMONigASGhlYFzJRJKiDETxqP/loah1wrtlUhFvjCGTqRhAR05JNPtxBVLGQoPoUQM1xUDdsPLnzSMMsRC9g8cJVyMFYf4pWYE74lQvAtbqOgxjayjnOZ03ha1qE4uSi8yYezDzxzVhuzFoZ6FqifPJFUa1aSRn0J7Y2ya1rOgcW9RdzQDQqu2tT32MUPs2d8gCalLkRwyJRXlZeeWMcN/nScWwfJo2EJ6rkCOlFjuaY/bzAUekuEPD4hzqXw82cmZbjBB25GgfZJV0/+wUgeynOXkJnJLXP5lohfFaEZh8rl+EQlfOUQdMXWSzKmSo0kaddh37OLDsxUyJbyLXMfatM1uikyrTkRGElV4zrWiM53r/3zZmNqBDVWEMYxeKI6j+kDPe9ozUfrsQR3/KViAPm2g6TPDZvR40IQqVnFsCFtCQCRRox7yqBZt4VJ92QuIetQn4fxoZ8vzUdB2FKKi/SixMpRVBV4yQjGlKU61lcEbABUfQD1hW3PJQsxuTrONdGRmhcSU0v0kdcadaluqSo6rBvE7owAJV6dBNmsGtXfjRIvYnKgUp/jreB1BIVvDC163ire8dWoMn1QBCUgAog+g0lkU4GCzvfp1fPtUjT/9Kdj0oU9oh93jYo8jYC8sdGuZAFFEJ0tZRDJYurztrW83CyyIpo2AFK4wXVDiUQmbtmGQ3OElijVJl8LUtfPZKf995qYtruCuxbe1pbxattt7Qdi3NwkdAZ9qQ6AU03TI7WGemOuW1aKMq25CmzbeNVQuZheIb8mfeb7bO/PmlrxvPS96W7Fey9z1C3HwciGuh5ky1teN+kwBHQer5kUdts0Jhd8d2zfgPMohExJFMmVdV1mKdhW6VVmuvkYCaEVKeIBk63Og8UVoC3f0tKP9rFBgF57wjNiSrqXpTHG3D35oOneePiKMYpTCowR5xonuJb+C29SWOAyHPJbqj1MHCise0JkidgST9CxliV6Mckoca8qcTLx/SdnKozY2lasMJ63MNRLsbS+pdNaHVdBiFZvA3pe/INjX/KZST4Ov0PL/+Kjt+dfNCNUM/AjshC2sW85aILCdFXxZPzeY3vY25J9JbVlD5xnRvDw1STJc2jIRvOAHTErbSHHSEDtnpSvlNMQ/LXGwhtpLKTw2vgGOaqUC6WCec/UxCdbjoIQn1gvDS8KLBZ7kCtpeR2YTjLEZMTE5CS+/DMXJylOlJSYb2VdWNkWYTVfKUCJQPIBvJaJRbVNsojLghu8JboOB752gVW6MZ7n/Se6sP4qgcH5DgNnt7jofOuN89vOMa9QRXa+93/hOnqkfnOhgZ/isjizJb680cLw7GpKsgHjEOf1ioQpGhW2S+742vuocydBHOg65MpMUa2WSgxlHSTlLWU7q/7S+3BxZqeWM8rI7jQoD0GZqCpTzPmWg/7z1PbcIn2ZG9KJXQq+FWsU4aAEMazdde1XoAQZyYwL8coADLujBXWtQbvfFd+tqLpWi6JCosLcPjlqALL/rjfZ6t7373qfR94kq/n1rv+Uan7vZT81hjgM+4hOn5ZINH3fF23iRjvfx43uo/8k7TBe0dmZKkQytiAJN7NrhLcQ5uMjM0VxSLMNU3NzKiY34vQzr+VwFAh2z+QIloMJkmAK1WRstcAM07J61BYJlzNOX8cBtHMADKN8XuMDVRU24RRt8PV1geR26YY1BiZ1xdIFxsEYXYN8uvQna6ZsRHuH/HGGbwJ11wf/dgvHW+UVhEhqh2dBYvvQDFmah+w3eVyib/JEfhOEYcN2fjhXTkSBXwEwV5DkgOiwXALrNarFNy/Hclcgcm8iI/bEJsKTCyOCaOPGcBbre67VVBkqGIXogMChdNIggCV4bZlRGFJgAbrDg1A2Wtl0iqfCTDWLimuXg1ajbD0IBXvVgvDmYAHnfRyhh+KkiE06gK6Ling2a+f3ZLN6bLM4hK1Yh+bUfL3KhxdGhqdVY/XVcDuUfD/VYMpXcVPmf6/AQpa0UkO2CM1zX6PXIAUYTNuVCrinE6DjXHwYiOCIbs/nJn6wCCEIDOupeIw5KIcBBCiiNBvRGDbhg9HGiuD3/n351nSfGWSjiFRB2grwVWy6W2kDSy8614vitIvkNYfk5YPoNpCrGIsRxAy92Gqj9IswYJFLVX4T5CIhNnhnyHwE2ozM6HK61BQGiVTeMSZgkA7EBkMyxxezkCsJ9Av6kwuxcoOVQIBaF2iA6hFxBBi/w3lAuIi0MAzCoI9ONGRrhwNPg019J2/T5F/LxQCZeZT4SVPQFWBIUBxN4pVeW4kQhJER+IVm+4ljWS/bZIluy3duVZUTqkhZyGkW238TF3HhhhEZWlG8BU6oBDJEUozHyH+QlUzRdXjIK4DGRxM6FlZlYRRVZVVvgCgTepEoCoiBm5k8akVz5yVCaY1Ki/6NRcoPulSBf4RccVALvmWBfTWUUeAH6WKX73Bd/2RH1zWNXEkfURIKCraJZwuVZysleEqFanl1bFmEt6hpyQuRBomJdtt9c2pZ02pLFYWQTbqQw6ghQkITDvOEZEqZbYIJhVh45eKdJThEBDhI1SiYwfYSI/NB2ggwQQZFcuOIgaiZ+EkYGCiUvJOVRLqJRhiAw9J4ZcYb1VJslMIIJZk9iqY8MwmDU4FdVDk3X3SZuAo1YpuVvbmhwdqjbzR9yHqdxEqdbAqf32QM32AM/5EM/+AOLZqF0xmjuWOc3kEX3LVozsZr98QjAbKd3gidhikJeHBCUPKNJiuE0opBYGP/FZ82kvjWgfHqkXVAJZt4nOPqkTnJRUPLnf4rgOOQeae5eoLTmHuxBmCEooZRpg0oNpZwPasigm/EgccypcLwBQHIeh3qonuapQhKhiConoKbiEzIniXofp0WGiuaDi2phXdoWN6BIPECqVGDkjcJQkfBIed6fjjrM6vCfMiKXeFKV5QmZkTpcD03MTAadqsLn4uXFVRHjNy1MXuZnW2Gprd5qy2jJlvZnCH4pOo6DCCKlKbwT1uhVZVwPoIwZg47GaUCoakzKD5zPhKaPu7EPHNGpE9DBneKpXwgkn+5pt4Jrn44r21HhiJaria4dRerDJnQCLPiCL1Dki2LhPIj/YJ+oSHX+2stZKseBWI6uRUpqjuRFGqhOnniWXKg6DF6Up6SdJzSmpELwjpJVxM05KcikCU2yzTclaTgORpXhKvNgqVphYD2kyGPw6iICa2T052e+E1/RnpiRESB8xqLY0fnAEQ98T4TG5vlE67Xi5gwIh7YaRFq9ibgeLbkGp4YmLYm2ZbieJV3CAio4WyRwoC9gAzZg4bzaVsZIKrvoq5vw68j9646S4QwN7EeGZ6x9KlWR2huaZBwKKapiI4wpYFp4HGOKYU32IZXOqusZBsjGmMg+z4qYLMsmIjeMQyUgVrZJn/TZk/UwXcxmj5pu3c1eLtBgLrT6bKgErefG/5dkEK1vIqTyGO1GFCrSLiHToq65BmqDeWiLbUMrqAcqUAYHqkK8au3WbgO7DAQ4fC1YEK3YBgVz/avH+YhJnO1I7N9UIWwyqi30JpfbBpHDoiRl5qSq2m0xEeNMnocxyY7famZeCm7gZmnhGm5oJq4kTE3y4aaXEQIhqKY5lmBdeUbOdI/PuKnm7izmdq7/eu4QlIrV4lmHCufTCifrJnDqru6g+umfKjBHxKgxvALVvsIGTm3VVsK7Zi2Lsuijwmvv+i5BoM0ASVWnepwYpq0KR+9JOmP0Kuz0wmGpUprbCKk1OMNvSWz2wmfAMpfewY5zceyVAm7FEV75kuz5pv9IUibil5bCE0TrChTfBbhg5FKbI55ggd4gz55Zm+4va/wvAE8NHwiKZDVnK74VBIPfAjMwoZ5rumoEiqBoO1QD1dYxGc8eKuRuB/eDCD7qQIQICU+YR67O8r4q8p5tcq0wVtVw84Yq2wqp2zYs3B6pMNwwsFQT4V1sei4vk/xWM+GcH2BCMYhex1aOx5Jv4LLMeImF9Oxef0JD7sHBEJjABRzAAawADqRBZSDiKtxM5TLrFqOPz7qGzqLZ5XIu0HqubqJBoXRC1RLwGa+T6arxGrOx08KiAwtqusZxO8xDO2CwHUcCGY+zJLQCLCTiPCiqB6OIMfjK9YbWRuEtARL/7AkbLK4Z6QvH2kgi5pBNsqlK40EsxChb0w4vEt4Kj3dVJingRfj+nCk/tE9SDsjmKiuToyqswiIOAzQsLi1fAAZ4QRwgqzmOqZr2U7PilzHDaf+iWTHb1+YqM0y7kfQNAiScwmV6K34+LevqtAGjJTVbM1CnMV80BrPNzCkkAiTwwZZRLU2P8yJQrdVGgzp78ECkS2SF1ifPc3mWrSK7MCM3hQyXpD47JMPOsCPkgQAq42EqQwFOKug9w1WlpMLRCknY2l1UFcZp0fieMl+jcsia70OnSDkibrW54xSH9LWpZu3Jl2eI0e/ZF5rlgPVNDc92cebq7Cx/sXBs9jzm/7Jm9MF6vUI20WrpVrNPs/Ebj240o1dRt4LjKAdNx/Z6zfZTCwr8spc584JU7/Ec/0K62Aok9ch4nETCAWk/1/AjP3J3Drcb9rM/rxxPXCZLqKRXNAnDbLJNQpmHAHFcsGFDqzJEh3fl4JZf93Vge4UX8fIS00Ih9IAJpCbvWYK12e8a0NdrDAFmszR+8+/NUh0x7zdm/8B9c7ZwOArYwUFTi3Za5XRpR3ODnzZqf6tq9/QXfkXsdaaWLQdsy/Z6gfZtO3VN53bivugHT21wm4mHaNSPNrJZr5zzsm1hyiHD9uFzm+o3svUljxV2u4Eftg0mEA9e57V9mrd4eyzlkP93eRcxSxruyq53YeNAIMQ3IyQotD0Bfde3FIzP02z5ftNmf7eGfuf3SxO4TB8KbJ9CQVRpOG5eZkI405q2nrL2hWPDKzDOht+5h+f5UjN1/Eb1HkeDL/zCdgvc64jCi794SeKzcrsFGu4zENe4jTPjV3CONdYoOzygNmrUk7WFh4FvzBww4Sb5Xgvu5xlxkZs6ODC5oHjg/K5CGUX59SRoPhlz82H5s+aA03wKZXt5zga40xTNmJePcNR6oSh1TV8maYcXg0s4nP80m682el94vR61nQ8Cnus5tofzh8PrbrNobx/Qemx3ApWcoR/6M5q12i46p0Ip7IQypKP1qSr/0V+WBTOVp5TgAUpKcpDLX6ifur9/HsX9u3ijd59IbSdcT6BgRmiEmZgZSj5ZJf6Cxq5TNq1DdkqHuZhvLpcDcEEV+yDUyuol+7K7ebM7e5yzslakcz7wQlLHdrVfe7bDr2XUscyXs27X64v2iaCDwriP+7nTsJGitUkmt7pHWllD+krdJHlQN1UAbCNh46AZOlyEB3ffNc2l03ij+iqvSFCJetaft+EaImXMrF/Fwc0w5ZXbL/dIqMXrb2Rb/H/3OmwIR/kc3RmBNmz7H2CPPBpT+JuX/E5TuJZws8rPgy9Yu4a/PJzB/Ic3vrPBdiu0gm5Ldb1iw84zTrkznOaH//VZD/3mIzdIlrW7Q7qUlA72ikNA+wRNtCGgjQKJOa9LhQKyHxtPFjmRa72/Kynhxd42kCa8Dmv2aNtqAJaBlpEVsJEVNPaV5y/bu73cQzawk/mndDaxN/aZn8KQj+zeKzvfA76UFaTJ98UIFXXhzwMqKL4OLr76Jz6Hc/g70bYqdHO9ytXs2rn9+/wzkouphhjOAcSlUQNHPQpF8BNBUcdy4QrlCI8jiRMpUvSTcCE5cujQdZuWzGGqW8eoeTsnzRkriHgiPnLJEg8uZyhPqutm8xtOnevMwVPnDmg9oUN3nisa1ChSpTqXgvPZFOk2qVKxRQNmqlKhNnHiVJHSo/8HihRgpcCx4jXs2Cg8qqxxu0ZKXB5z6datmwIvD7F5afDIkaJv4CE0VPjVi2NuXDhbGafpAwmyMI9Hn1bmeRkzPcuZOVPuvLlnaNGjw5XWdu106smkTbdG/dp1OdmzWce2jTpcvHvyeLfDN69f8HzYIPExrufQGz10ljNvPge68ufHqTt/PAg7ZOynWqniBa1dNGzMQIFKdD7RJfQu2bdnL/Ch+oEGXWJU6BCToIr7LWLMaLIjZ4q5ZRZXdjnNJGFUgkm/l9xwRBeaTLpptZxqwwkqz5hKisMOM/zwqamqioYbqzbRiquuvgIrMcXQousEttKA66u87MJhLxtv/MH/xh9oECsHGoLkobDEophxsTa00mqxPSA7xRoKNfxMs86EonLKpy7csjbVbvuSSzDFjI2d3Xr7Tbh8+kGluumik+5NOOOELjk32zwOlO/CA6+U8sp7JI9A83CvvfkKLYi+TwxSSNE7+HtUkE9YyWUhyTbKCSQCe0lGI2aEuUQQBgfN444Hc5HGG2YqtLA1LD3sULZXZZ21ysp0g2qq3ka8qhLGUnyRxR5cdKsKuuJa8S68gFwWhR/5gpFHwIQM8i/DeDiyrSYL2TYQQJrsI5FTLC1qNFczI8rcWkELk1x2d7ItNNjGhHfe3HrrjZ80+8Gmk0Sc+9dNOecUGODqwMUu/5E89HgyzxGjIa+8QF2a5FD13qt4PvtEafTRl/aTidJJUU1wF5FiORAlXRwUdYyIIpRw1VbLRRfWWGm9GUQQc8VnRGyAAcaSQIQGg7EWgjVWirOqYMSrY5OV9rATpGbW2ah5NAxqHqu9NtutuN12qz3Exu4VVmfeTN20r0Sb7XTbdVfmmOud213YdEvnTDSF48aXftlgwznACX4zYMEHv3O99SBrRc/wqvnFz8RdSu9QQuEjxdAGKWqPv0o3PnVkbXrR9GRkkFlQVDzGoAKPjFB6XaN5s6QM5590/vBuqezhucQSaVllFUOEF3qrYo1GVti42mga2a2HwLrZqYF0Nv/GGKUVzFrEkH5rK6KVDHvsScRdB93R0r7s/Cr1cTv9dd2H+212Y6eNfvltKxN/34QLbh5s7DEmE4dITsEGRrABEpBwBPSXGdYjsfKUwn/iicbj/kQ5il2QcheLj0Ig0rGJsGcipNCFLjAHMgqdjkAio1SoUsc6TIwQduRYRuxe04wayit+s9NhzmwVFHn8pne+i8YwZEELWiiCEWEIBNGUFpcWHGtFcHki8pIFPWblCDA2Upb0cLQ9X33RV9fJhDCcwr72re19bWufGeFnPxwiqH5dEhNHzPRDvfWDZ1KhRAAPCDDlGA6Qy/kbG+pUQDkx8A2ITIQZGKgwPTiyPCP/6h82KEix9VjMchv0GKE+yDmJjIIhBRHZCTM1KQWxkCVqgIkRWvey19lQI7C04Qxv6CXaACiONpvQLmvHS1pto0T5GMcwxwEN4MliHLYYhiKYmcTiKU1pyQOL0dSSlixq8YrR20v1rpdNIykPjOHsA1fGWBI2npFm6FTnDs8Zvzfmso24kVn+9Me/3+zOHv1KTiEPd8hE/muQaPinPxWJSEY25zwHPQ8oUME4EgFnPK2YxEQlZzlAaQ6EncxoqB4xQswJhCSkZIXnVOmGkqaSleKDnYCW0dJZvvQaLqUhPOtXkxxqqJdOAaYwx+EPfwSDiMOwxVBtgQhmIpERYPAe/7GgyII0yEVYYXneXaY6PRx5k4vXFMs329I9JXkPRV4jBCE4wQpllNF8tbrVOtna1jSyT4dybGNnLpQ/feQLr9uwh17xAYtMEDKQgjyoQAVLWOYEVqCGhdNg/zBYRipUkchJBCQcOo9xTNIXrShOA//A2c5uVKOgjdDG4BPSBE3qZH/ogklLegY3UIEMjwBFQ8gRIZm2lBgvzW0tbUnTWxolZuy0XVN2+g7jGneoQq2FLRrRCEQ8twyMSOpSmdoW6x7PmtjU6hb5wt2s6kUtcFGa18AgtECIgXhh40McMlFOWak1ffdw63zp+9abynWu+B1ZmfSxj93hcXd65cZvfP9BCMAuVrCFHWhiA7pgBjv2wYzMw2MZW2HkDII72LCsMPtnjFdEoqKfFbFFQeuIhZAWEyI81WlZ8Yq/mpQLYyCDKmMsiImKi1K41RQxctvjmA6It76Vm9mInNMN6XSY2TBuNrJBVKJqgrnPZWYZyqtUrUATmtNsgbK4rF0vSw/MXSbLWbw6NPOmlyt0IKt7X1VfN79ZuHHNb345dY67+RevuxswPv8XQD7wU7EKjvCgHTxoCp/hsRM+9GAT/BiHCpPDvFCFixP2B4mNmMQbPXF9MIIMa6QDGeJ7xSHUMOMunHoKMR7DH0RRnlYPJCQ83rGsawnLmQpZNEVm1c12rdP/agg4yUwWti08sdxaNIK5dpByEpW6VCsQi8xPPIuYqa0j754gA2HWUde6xy0love8X+RDezNhjPeqba1wVrd9h7sUt82Zrl1yhk7tyI+98vWe9xx1ICEsaEJv4d+LFrjAFd3vgUIGgtyAdP9KodlKYzrTnSSHeT4Iyk9/aqSWLnWpU93xRZGWUQWSNY+bQfIgDxnl5JIS7XptlE9/Wq9JDsbMaV4Lm99cE811riLKEAalhuHZZMayFVowbWpveSxGUzo1s6htHU1zvF4t75m7Vbw4AA7DZOQlfDUj366rL93pXHe72d1Dsa/RXWqM92VMZxLd8Bkc+OazPPomWYP2/xvRhg74wPnedwY3+qDYkYQvSETM/vHiwxgU4OJZzfjNkdBBKQ6pLigqh42fWgdF8DirDxJyUBbDpbd94zRSXnpd45RDUfo1MOfhD1vU/Oaxt3nOda7snocB6M32eRvAYAUgEJ0Fwf9KB7bcguAf//jGB34HMtB8amsZ6s9e6tSpXjw4/IvNuFsf17u+vu2PvexqF3/4bddOzlij7f2du/rxMfe+8vGRCPX7/PWed0Zm4f72p//d24RwXgzTH4gJGzKrE4oD4gRIIlRp0zgKpKSB8kbK8lBNCTLvBjRvxiKi82BtQEwOpk6ut0wPBFOOQ6iCRN5hHGDP5hpBEzShFv88odhUUAWZ6/ZyzwrAQAyarfeCLgeFjgWAIPiAwAePT6l8kPkyAC86gMtYZEWSRvqkbmimzvquT83W6xWqQfWWwuu4bq3C7kq+jx68EPzYJgxLw/zsSxnOiq/8S3fyjQ23AXI66wz0wKDkcP/qcNGyIAnOAAv0EA/zD+Doj04QytEIjxt8CtIGEBXgz/EYkIQGZVFO5QFZIREkEAkyjwRsoONa5uM2ELdeaqZG7wND0JxEMfXijgRPUNhkr9iObQV1rrla0blwD/lwEAd/7+d8D/mAMAaIAAhwLwxYgPmQMC+WDvqKrgm9Z/rKKwq/gBkJKRJ+wQrLCAtvRR+y0Br/yQcMx+/rwnAb28f70K6d3M1KqOEM324f3DBv8o039OjPGqzC/tAO/a4PES0P728P73Ee50+y9vE8BkESUGEVogEAfWoeHsezFHCFTAzWQkYUSG3GJrACR8ADKnDzKiX0OhAjxeTWQpEjO/LITlG5YG8FaU8Fac8OysAOZO+5EIERjq8NfK7ZgNAHgzAXebEXdREYg1HLlm7pvkLouqf3eE8oUYR5vOBvuAIVopGOiGKt1K+/dqP71iEbu/EL0YcbzY5KdMMqsdLNuBBtnKIcnxIcPo0N7a39pgIWJIEPAKnv4DEeD+0KnsAM8BHg6nIL5hH/9E/g+JEf02AOHmMR/1ShKsbhHQKQXyrtpMQHVARipBYTAldnCoLAEiWyAmssXMRF9GRIM1UDFD2SFEFwLM3NF6RCIJPp9WjOBUdyJEuyuXquEWSP5hphynzuF4HRNpHQ+GQSCImAF2Mg+JCQ+I7vLJyqJ5nwGJExnGjkK77g6tgLFmCB3pyCGoXCKavzKb9RC7UxDONBDLGRK7nTK5nSK6cyQ84QDemtLP1LH9zQGDwsgA7sn97SLudz4OgSL+8zL/3Q757DLx1jYRbhH7EhH4xrHn5BDiPwDBQzUjCHAQ8hVKiAAm/ABi5xIrvgDBpvtpZhtGRqM+unI2HmM1lFBMdyPX9NIH3qp2pONf9XM+dS8CRR8hVX8eaKyhd5kQh6cCZ5U0dttDdzchaHTjmtqwmFUqm+ijF6z2mM0gvioBNKYj2lEzzryDqntBqrcRrDMzuV4uzEIUub8inIsyupE0ubghzNsyTkTh2ftD1h4Rf2rbESq+D0si3dkj7zcw/9ED/nM0/tL1Agy1/688Kgow9aIRr8oTB5ARI0ThBO4RRAiLVYCDIndEJBAAQuUQeuQA0668RaDRc6dSE69SIzM4Y2Mpc44rdajpdmypygUyrmoRAN9bhmb0VXc/ZkUAxu9fZcE9mYSxZWcgZ5E/d6Dgx4UzdpMgaAEEiT1S2oa1l3TyjhAkZcoAuYFDr/rZQntpBKsxU7tTRKyecqcUccwFBcx5Qqu3FcxdMdYsFMz8pJ8Uw91TM0zZPS3vQN4LA+6dQO7fMu93Rf8bMOA8Y/jUMV5qEwueHF/oBRQYXjVOlBqYAKJJUELEBiSWAEUs1COc/zPG/kOHAmMrJDPfBLVCVVRNYjXo4a1pMQh+m43kFW7cBl7WBWmesV62AGcdUQygAReo7ncLbnetZnfbEXbXImZ5IFeo8Fhk5IfzIZk7NY9AIDVmAF5KBJWZVL6a0ptXX9rHQ8uxVdu9ZLufBruzUru5BcxXQ6z/YLr1EoSsc8RdNd2w+f4lUZXoFu9ckd+RBf71Wg7BRPkyAP//WVX/PyPv/Vn/SAUH0KGyqt1R5UxlbJYR8WYjHRYi/0xj61pT6nU2eNE0M1VDfQFT4XdDd2cy9yVFWFZHdJKoCBiHrKUJXsH1LzZe2gJFnQFZvrRX1RDHoxd3fXBnEXd2/PBm9SaHcTCHoX2pSVSImlSIHOV4xOBaB2BVyAE1gVO6ESW6c0a8USKKAUf6Ai7KrWa6sSPKcxvthqW8HOesN2PEWi7dhV7t51PeWVbkeq8gJKTudU4PgWT/s1cPv3fhftcIBhmIxhskBBEB6XtUrFpBbY8j6rckcIgiWDcyeYgjuXtPwAgzG44jCBgzMQdGlLGCTDdEc4SkYTmABwyf+UrAU1wWWJoA5k9zVnz/ZwFXd791Z3EyZrlAhqdlhtVDdtOLqk65mQdweDjmn1QgVq4AIuwAXkoNx05+3S12qxN3unk3vN7myvuGu9k3yr91y9+Du3VorHmH3NNO6mVG7nl1FPIRPa0X739/7ksk7nuAn0s2/x828BF2/1FxAFaRAEmBtc7BIuj9NEqDFRK4QTOYRH+JUmuGNtrdY2s5GJwRU4GCIUGJMzOYM/CeQmqlIU+TlVN5mSiclwroWBVeeGyrlytnhxzwdzV3d193eD9VeLFwyIVyZxT7p2OamSdUi5JzkZg+gOYwWWWHqbFBy2T0qjOJmp2CyrGErBVxr/x9c61fc6yRWMtdZs68ELlTmbvTN9w1m+ympd0fNdx9JMY4Hc6Hef3lhO6Th/7bEe51KP/Zdf/3f+JoFQ+8aTGXWUGtk829d0VgqgHxkjD7p0JVnWQDchGrqDMBm23KBUVOcC3+PGfgE6h4GURZKFTxlnn6uoiorngLB3hZaGo8tnaxZYXVk3bbLnkoiXq8srgBmYqcumiQWJl/gCorYTqlVbt9cc1fOZ4beap1mapRMbs7WZ0RiosXgbv/GaxdOLl/lsxdl6y7g9r/Be4rdM5/aQOeEQ2gs53BkN4Nms5dme8bie85Oei8CO5ZjvFqYV2vQVfsGuCfoZSE+v9zqg/wfarxHaoAGbM/GasBVkQCyZo2BigRMYJhiV8ITq9YiNuUbyZVe6DlZSyoDuaIcVR0l6loO3eGU5DIr155SIEZAIqYQYed/CiH/yewChMXpABS4AAmobAlYgEqp1r5S6TKTSOoeaqLV3fJcyf4KaqKeYqc1Ji7f5mr1ZfKlZe6O6uZe5rNQ1SrQab+QhjdW5rASC8QYpTvf4rM26f6EAcM0bvbUgve/Pre+UwuSyveH5b1htfu8adsqUM5NhoJfhDGHqrwU7sAebrwV8r08olkopcxtzMR9aP14BOlXXyWo3dhthhl+YZl/YF2vw+Fr6s08ad4HwpE/7qFYBqRoDSf/Ei6ZTHJiJUrZp+wBefAQIQbftgbfZwVud+ae5tnupEWt7XByclEu1mbm5WUyV2lql8sZ7/ClhzTxfLh2Ukl3P8GRSAawZT4DkYJDEm7y3XK378LzTG8zNu63fGq7h2C71UFNxzFMIe8BrDcDfvGM9k8DZvFMC+mQiWBfasyqKqIgwO3b/nGZ9dmetIMOLNZc9/GdHG4fR66gUgc9XgRZUe6ZPXMVVHEXApkYe4MUNAAI8YBBQARjgNrijO0qXetRrfMf5i4rFUsmDnDvDFdbRVr6EPG2n29aVXB/g4xlG9smvW8oH+s6p/LstLcvtj8uPvby9PMyX/W/l2K3NwK3/4Xut+xXNFyrPo8Q8Y2Ov3Xzb4dygUyPOu33O6ZzNs1oa7poQ+VzKngvQ/zxXk8iVP5y0f053bRi0ja8MGv2o+LyIJL2JKt211+DSfeUrZnvTDeAC2AAV9kzURz3V6a06t8G4izrVeeO3h9r7qrPhj/yor7ZKPx7XQ746S4vXsZ0hTWYXTqa9HBSVEBTN/0ZJ6XjZkX3mlb3mbx4LnF2Om4Dn+ffMS21Q0sOsUqXAtZ3bxT3APXbckd41wv1jX2ldo74afkYWSBypPtrC68CFXxa6aNmVa3Hebzkme7dYbxWzn4vfq161xUtIU7ztVxy23SIsNEACDt4CXCAS/Gfj/4873XTKnEtU4q94N/YhnKH44vPl1PEJ44Vca229yHNc5N9V2EWY8hVcJEYi5dWZ5Rs4AoH+DLDc50Mf52ne5kcfD+3z2e/QzPFWDapdpVbKNI5e9mXJ25ceZMldwM1dz6e+FEqBl6XLhXWUZnf4snO2Zl0Z+HrwlnGUFpsfiBGhEfhcmdJeFvxdeYwYmGca+8WG4FOA7ut+0yWgBv54HvZ+q6cbPM8Y5MfS13fdzvj+7/Msz7AX8YN7yIk8qLk58vf/cwHiEitryHQJK8gqFaZUrGLtQsjqkqCJE+VY7NIFz5mNWjp62eIEJJSRJD2KPIkyS8qSKlm2dAkziUwsWP/MFLH5xIyZmS9XYlGzEeifQw2lUTuKNJzSa0ybans6DWrUqc6kVm1m9SrWrFq5biXHNewzqszKWvtlzZfaVaVKMQrUBu6aMHTL2LVbF2/duiz6tvgbIwYQMCysgDmMODFdRYwVIbJja5gsWcEiT5b1ds+aNVU6W9kMps3m0Z9Lk9Ys2kqUFBguQDgA2wCEFXp8ccOHe5+83bzj9Y4nTh9wcMSJ/2ZXXJnyqOD05dZtfBtv5/yqW+dnL7v27bq7exeubx34deLBmz+PPr1659/ZJxQoTZhD+bkaPkxWcFcsVxIrWpTjBkZsWMSRSSEdGJNPCi6YYII67ZTTgzz15FP/FxypMRRRByUl1VIeOkXWhyF+RVVXJYqFookhGmUWWmqp0lYhgMCFmhV0EXEjjjjqtRddfgHWF2FgDGaYFUAM1oYYi5XxmC1O2hJMlMFchtlbjJw2WmZXYsklZ6u19lpsEHAQxS+35dbOb2qaV1ybbhKH1FXN7fPcmnRe10+e1XHX3nrn1ZMeoH4OSug+711Cn0PKPaRoMr0c+t8dkWJE4EdyGOggg5rS1GCnnH5KYagpFRhUHkMNxKGIqp6YoopykthqrGKh1SKMldy6x4y5avbZkb7+umOwYRwGxGd/HWtFYYWVZiMYdTGGCCJPRulkNpFZJotbVsYhWiGBfGsl/65djqbZaiZoEJtsY3rRyZm47Zbmmr7x9qZ00iHX5lEFKXcPndvZCx5ueF63z23TFcrmvAkjzPB3upwyySP2NdooRJxc7MekAQLlRUYCYuopTJuCHHIToJ4saqdAlZphLKl2uKqsYLkKK81egdjqhrSW5Ytbi+wKdBpV+CXYkUQYXUawQIhBrLLHIpusX5/R9Va0k0kJZWXUUmmJlYZ8Da4hXXud2bheogCmAAaoewG72W2DTdzT0ftm3XXjC6d8ynijsHToCYynnnuuZ5x6Ch/ecJ+KOwzxJKfE8krkjy+a3y0MYXzHxhhReqkamzMBeskij0y66DmlvODHGwmi4f9YL8c81es4y+zqzbIiw+IvO8coSdBCp/F0C78CqyMQbbBwWGl9SRE8slSXwYhj0tZCvZTZVGbLOFSy1fUmX3u/CWNvjb3tuFX0gPYD6cLWNiCwVGOMMdXA3yb9BOmtzCvKyd+mvPcgRzlkWANx5wGc4AjmHb8JJ19zMlzi2LO4CErOF/CLXCYu5rL87OdinDiExjR3kc+RzHQkLCHqTpi6j7GOKNaQnYdeCLuZsYp2NDxRVVwXn1rB6Ge5gkMaHvQEHjRveEcSw6/+EjVmtSAFTGxiCqYWPelZz3pZcxLXuiY+LFqCMauIHvm2VYXTdIYH55LA+tZFiE5ATnKS05v/QSCXkDgqqn/+w9eiFFWNg/HJgAf013bYpK+9GY6AEIxgIQ3ZnVeoAht54oYFJ+E4ODqEgxcDEIDGMAUugHBzSuikCVH4yVCaDJQU+s8hWNjCbsDMhatspSprOMNYzi53wqCVInnYBx+iIQpBxIEvnZgCIAGhaEcMnhRUs0RgZiADHfhLGBqDiCm+A2tPkgUiZNGYLWJREdvIoja51zVAeAkOpPmS+tL1mjEpQQ5DcYQ7H4GJd57yEvS8oBwnxzd6ze04EFGUwgKGpoHtCR+Gy9ty1tFABz6QYbbJh0P7sQ1KXDAS9qwoJSelBM1xcgedFELoRkdKUYruoygbqUco/5Uh/aXydd9QVQxlCctZ1uyGLdKd7iAGiT3k8gu85IFPfwlMFDSzL4IJzI+W2IOfPoF5PnXiCTQQgQg001mMocwUndSIal6zMbRQRFe7qs2wgpV8nPGMZ3hQg7Sh0wIXGIEO3ppJKsiVCm6ga4BWeEFJTqyF6JhfOv6apnjJgzj0YYjLEurH5yCwTn9yB2Fxh5+jLBSRCMuHPyyLWV9kIg6Z6MRELXpBjAZIk1zoKFyDcIURghRBIg1ZDUpC0pCKSoWtWylVYNjSl75yt7x1ZW9lWbua2lSROd3pD3/qyxnUgAYnQIFzn+vcowaviS4AZlN9eoJlRlWqLAjD9KI0zf9a2AIR0MqmebOJiG56Fay0GCtcOiOF+PI0fWFa6wV0UNq5GmG/NujvXDF0KntGZBKkiGQtmfHXBAN2sPfbxeUYIsg9Kjaxf2ysvvAT2eBMdsP68IeHH+pQWHiQD58tsQctUle6YiSumRThR1oLY5f8ILY0HqWNSUlbVOLQt7kth25hJkMeA3emSLFlK1BxCkgoWQ96OC5ymbvc5kp5ysFkwVCf5lQmPvm62d3uVL0ajGlOk7yBgB4joFeG86rZq+tlDFjfC9+k4gADDzDj+tjXtnm6Mw94mIgb7tpnilCknfCciEAaQisFK/p+h8rEYXmjQHsMFE1vC5Rj9VUxcWj/mMOU9c5DP3zZfMCCDTtg58VMjOIxcK5zA9IDG+gwoBe/VrUxrnWNZVsSjkhsZ0Lu8Y9j9tsh2/BVY6lgK0CB7EH0gQ9M3uUQkjtlE0gZA9mlcg/+wkRsPzkHyH12DmhARjJml9otCIQislYZRJzZWYf5VhiqZl7waTGs4ISzFH7ZGgTceW0HaCsbHC05OZJi4KIoeH/8E2hBeK7PphKIQVjE1wS3ECH0dDi/Iv0dgA1yOPrqBYYly+lDGhLEHi65qL2A3y78obNqpOgpK3XKREyC2TRnw0eE8AK3epTWpYPxjG8NdFzreuW8Zqmvg/1bpPs4yBwSNrGN3IqfJaLZ/2gASZSljfWsSzsD1l7iX+RMXV96+9tK5TIzyy2LcUQmGIqQy2YCAYawtb3tYBMf3cUWvnnbGwNQrfO+xUSbNiaqPoRHdkIgWfGKvxMPfx7DnwOM6A15Y6UFeWdeVerXzGt88//r/KUx/XHyhLzT+iB5yT/MCzZ0YQU6kAPLW86HP3Ss1W+ofaw5mvO2XoAEbn1xz21tUhgX6FTGmDwrj95rpc8M6cOepet8wQxfHHsRU3c1hK6udROsIPvN9SX6ginnbvv+dOQPYvifyAjKQKNKMupWXMgGtvjLf/7i23udz/n3MQVef4N/o8D/L3DIJhFqwHiOx3B41SjFdz8dNP9PF8N/R9FXC7YNdHQcjmWB1OAoGRhZ/0RIo8cNn1Zy74B6kaB6rUdzNHdzMrFcSxAEb7UCI+ABbCWDEGABI8AE4wd8ORh0QscGK6c/4JB0yAdsS6d8ShdIRyhLZ4Fg8JNs1Vd7I4F9WLd91UaF3edT6BN+vYQS5QdEQdRTUlAI7TUZYyMaZZgr8Dd/XyMGaRh/qdEZrYF/+TcbbHAKxiA5x4CH+pELeUh4hTdw7zQKk3N4f1gRjWdojhN5dhgRGUIUiRhxA8RAxjEvyMFxGFgMcHQLyYAUgTIenMZIIHh6lwUNvkAIqseCK8hRL6hzMFACIgCDr8hWDSCLs2iDEPL/ezqIi6JyBkORCXtjW0EIjEJIhC5VIvmxHMe4InxVFjYFCosACVO3SzsRhdlHbdEmdlfYAx/RU0DEjd1oBkITBVIAB+m3fm7RfpuhK+ODhoagJGDDNGvoLWBzGG4YBeiib3/HbxBgA+yiO3m4DHwIkG9kEO+hcJLSZ/VkHwLYH433eKzjCi4TCxfkCOzkkAC3PwoYP8+wUhFHiQukaYtiOYbFHPQgiR04WbDwgaAYiuMQDZSAci+wAy/oGmzFARoQAipwkyFgkxwwk7Moi7JRAjd2i7lIlCrRg4lQh79YhLjVW8L4W/IROZKEPzhkFqm0jEfWjE7obDiAczPAfVpn/4U4kFReEI5lyUtA9EPe+DtruQerUI5lY4aAMCPhEn+dsIZKIgbxCHdxMY9m2Bk4oD52ho+yQQJnEAn9CJCX2IeEp0EbNJEpZlfuFIhuNEkH92cGmXh+5gYU6XB4hIxUmVuaRh5JcYkc9JAZpmm+QZLhUR4Mw4GRwAt54lChaHLjgAposFwwaAE+KQEUUJO/aZMUkE4+OYsUMAOsVZRCeUI7KFIbcQiQoAtK6ZRMOYzB2FsBd3mTA3FVWVOvkGzLZn0bMXbKRY1Yd41mSZbpGY1p2Wxr6Z5C02RpIAmrQAulICNAg58zQgng4iyFsIZx1wbOwpehwS1lWIbAYwL3eP9nA0AA/EaYZ9CLB6GBiQmQGqSHhOgf7lRwAimQccQJe2aQm3lJKiYpGjoxgkiZkbU3oxknxOAKl+NxBzWJq2mSG/c/k0AJn2hZtCmKpuBDXmACu+mgbNObHPAAPemT+TgbQ5mcyemctXV81tmUQ/gM8mFil7cz9pNKuoOV1BeeJzFjURaT2pd1ryWWZslTabqW32gG8emm8ZkGzcZDhdAWlZCfdyqXhdAJ5xgHfFqgfwqocVAFgFlf+6Y2+YgFhymh/0ihFApZiYkLi2lwAHgfyzFJL5dqKWaIj/CcCAmjmBijqdJxnypAqSl69HCqordAjUVAM9cJOnpZ/iCCH8b/DbygCjykAoKppA7Qm706nMTJVi+wWspJrC5RfklAfhMSfDyBrMoqdD6IYMxADugwpdR5dNP5QvlzQZBUfTIHSQ2hChQEP0sofaowfV76BimBirgHkzApbbOGnl9ge2s6B3Fqr/XannK6bLtCCbi0r//aB3OaU3lKsOJECG1wsAkbqOT0BScQhwpaAA0qsWtjAVwQoY/qjxOqsRhbqf3nh4QoKQvhiL/gndx6SgRIBphEV4fYQaZpOZnmOi3lDdrgKIOYiRD4kaaamiU5o57XkROFCtswD+OwkuNgtKPoM/XoAEN6qBMbseqSTr1ZAsdpEqTCc55yE09QUptSrC3h/6yylVpPqlLRanzVaa3XKqWNQ3MxdwjMNglKBgrVwAu8gA1zWw1Hdq6LMAcSUhLrmpt/C69nKa/riQbzWnv4irh6ALDLpmT+Cp6L27iR0DsFm7BySQiXi7mZy7BwoLSxwaCf27QOagE7MAm/wLEbi2HGiLH5kbod2oeLqKmPF4i5YFO1G5WZ8Aieo7IiuhAuWzGlKrMG9aLxxAkZlCosurM9Ww8dSYmZ4LaRgJJGK70sCQ3rZ6s/IwUiwABMuzahq6S+eZM7V7VX27VN2qwyYYuo87Vhe5SgEJ3UOq1Seq2iaQ7YShARsbZM1q3eemRy2wrR91fH9p1MdpZ967c7gP+Kzxavhnu4bNrAhxunU7evkSvB+ssHkPszkaBsmcvBHXy5cPDBm/tUhgq6Tju6pfuozoBhTdEMqHu6qKuHkkoK8ZQ5hoiAgme6VupBmpoxxItBxDAfoYez+sIfxKsoscMhOWuBeLO8lLi8JIa7rSa5knArbtGvcgmOOGlGahMA3huxvwq+HAUSR8kHsUa+XNsE6YtrN7a+5au+7JsIu/ZXCHYOy3e28zuzTqmtz5i/FvyM7tsKFBQ//ntkzqiV0ShrCSymZroFgrtLDOzAiOvAAUvBlAyec2DBdPC4iyu5kuvBnxwHO+VDPMABEFvCp0yxK+A4i9rCrezKrevCsRz/w4sZqUVcaLfcgPaRoh+KYpnjB37gCL47MceAxMqgHwohsjf7mTEbvEvszI41c7F3CF5QAx31bU/wbcjaS08VJl78vUW6ih1Bxi53xsnZxipxzsz5KauDlHQMv/V7x0qMvE6piNEcc5isuINgeIEMCgg2t3jbjEtGdet5IIu8goE7uIT7wA+SuJYc0I5rXJmsvw4Nyh68uOTkQwk6pKjstECZCP3YFan7yrJM0o16H/1HSS0LTxsaxI75y4YIzD78YLhwjKNKvCKrosv8SufA0z3t094wUS+nBZ0kA7BIkzKAkyPAq0/LtMXpmzU5tWLMTqcUSaiQCSFUzm6s1VuN/85dnc5eHSoWwmd5UHDubLbq0Mw/jcdMiRDOu78TjWxzK9dzXchSl0uYrNAyNmskcZaF69fsCcGH22T57IyLEHUBW8H4LNiIi8Ea3MEbfNH7itGAScIdPbFzqD/xMdKbLdKdXdImnbEBVMsCd2gt7dI1vLKSKdOZmNMF8aEmmsI6bXw97WN5LBAvd3s5B4MgwKszyKvEaUY0+NS/OQImgHsodUqPYxC6MwlYDWNaK5THutXK+tWhwsY1Mdal21dqrRRo7d1pDd7W2tZ9zGRwO9elAApyjQ11vcmBbXtbMGtRxhJp6t6K3aZvmgiWbNgBfcnNlq+Z/K8XvMECLuBvC//ZF6zJGJ1LOFDKls3Rlz0Cf/CAnM3Cnr3Cnw3Dl6i680EMQKxX9xTElWM5jvDSNowJn3AxOE2VyOxOp5mANV22M8si8XHbQo0RLVgCMfjbO86bG+DjO/mbZOpJYt0ye3hgJJsIHJPVXM3k6KzNzDpbW3trQsFn7bzda43l2BoVETlzbNu+yIbevJDecxs3vPAL/N3f9Xqv722sfU3ffy3J+JzfGWzYdC7Riv2mm3zgGzxR+vzBzgvCi8sZGFCoD+7NHkCHkFWMFU7hFt7oKszZresQIfl/tDzpL8rhIUnDMP3SMQ1hhdUfpd2xij7jpW6lFXdiN34DuimkwFqD7Tr/pttX3KzXSUPXiJG6IWNBsn/gOUvuKdLthRMijTqRtddd3da9zrb+vu+c5c2erdp6QWyLz/ocyLYq1+l9t+yd5pgc0bDm5rwE2HAe5/pa2OldCoXt3xGcuHTA7idI4ASubCR2uTQH6O0eB+yO0VGwxdyrNobeAIheh7Ht6APv6Iwe6YrZ4S96OT4s6pPu8AxB6S1NkIFWw5dpog8GiD8MszjUyoWHeNNsijh+AzM5g6/uAyPhbFCwrqm1cCtUTxuvkafQObYG7NCdrLYoEzfxc09u7G38bMXKzu5Ltr6Ws93t7M/O5SbrxxR1ZKUQfa2ADYT80PmcBpHd7ewu7pC8/+6EvQhtgd5Tf+ftLvbwTvYB7u5u7e75fgKm7OAcrY9nkJTN58oGf+F0X4yMivf+6KHIjMwCMQoQ73EI/yiU/tpGrNkPU3AkLggV78smenCC0LuAH9qDF6mIx60Douq6yXs3gNRHoBKZbMabEymE1pnExhxn3uu5WPM3z/Pq7PrCHvS0wlu0Pc9HLxWTZM/0HgmngLfWTrelYKuHDdFW/6+6hLjhfq+6T+fp3QptIXXwOdhhP/ZlT+/37rZti+A0h++DygHca+jeewFdEKF2v9lascLkb+GCf4kuyhA3vRAnLvkUukEL7wcphgcLsdy68Cj2pBAAIcjPHYIEBTkSJP/HoKBDnFI9vMVqVzKKuXBJJCVx0qVMGw/JYdOlyxQdNkjYCNLlzBuWeiC9HNSRzxw2H9nIOZgTYUaJyJxJ6xaUmlBvyCapwbLFCRSmWZY2gcokatOpUJ9cxeo061YzWpM+SZIEbFiyZc2elVo1rdOvKs+c+TPpFNBvde2qg3dX716i4bT9vTatYsdDiQobfnmqVatSqnwxZlbtcStQixYl6tPHZWbOnQl9HgQ6zWjSc0yXnhna8upFixmXAlU5URo9tDVzTp1b85zbdHr3zqSbDiffdIyT5gBBgAHmB5oPIABdenTqzS0oyaRMcGCK3Lt/bwY+vPfxP8UfQ18svfr/YhEfYoIfHz7EXvXXV4zlCuJ7N1SMmDQij7gkimUin3rRjxP4BPKDwYLcKGggR+bDqEKJLuHII5y66E8HD9VgQ7WXJhmxIxIPQ/ERFScMRZSefuprKG+sqeaXRNyiyiu1qtqKR6zS6BEsIYsooismalhriCSLHGvHpJKEkim4Cptrxr7OwWsdvvLaErDtkMlvo0kwI/El117zhRc1XVsts9n28CzO3o47zYyWTNNjM5dYaw0UNi/LE089cSuOjzgKFW4QOHQLLo7C6ISDNBwueK7S6ZbD9FIILsBOGO3IK8+8L0M9r7xl7jvVFfbqc+8T+eRLhRhZ06to1fr2428K/xtAOGkKPDiqsMBa83tvwoEKogLCCDGhzyJdnsXQI5tEIkmNATti5RRsWcEW24YULCzaZn2iK0Yaq7EGlZCUcjLHdnXU6ok9aNkjyK6wKjJKfdFyd18srnjrj7g8tdLcLA/WMuG7vByVWzHJNPPMViRLs7FW+MxTTkIjpbPOOwU1NLNFShm5sdYutswwkAnNhBA6HjVuN0SFm5mPRjmO1ATlMrW0Op6ruy67T0ElutSiT6V1vPZmUfUWYhJ8db5RnE5a6WEvslBBPLZmyEWM4qOvogO/xvBYCP2DcMIXaTQqw8I2VGMMORrqRNtMNMI7lW4d4htcntY22Ep0q4nkDP+VnoI3cSezUvIJRrKRpV6xjDSScX+bKDLfd59ki3OA3RKYFaCsKbhL04ViGMxXHBYzMVUkbiXNyVBuczONc+vYYzvxvG2RyniJjRfGar8TN88OieNQR3GneSaYYU4NZxcecO7n6n3GfrkGrpvE06NJBf97pNdLENdUXHWVxRabNtpqWyfaJdhnnSXWIWb1u0hY8ArUb8EHDeLJs4QhpmhNa26ZWF2Y7pY1Brbqb+opVzmwVDBwnGNw2MAGH7SwwawozkeVC9IaxvEOWUihR5PT3OVQyC/PpYUsUxEJiAYUGQqeDmEMw6EyhGG3jSRGMa5pTJrOVJnYpOx2gzBUanL/p7tAiWxkoDBZY0iWMtq0JDSYuaLNUgO9QIGsZodY4nGiYIKeZc+MmYLACg7hPfGFz43jsxXT1oc/qKFPavZ5o/uqZiBPCQNVzsJf/vinqonoUFhMc0X6HqSGX2GIWeLC0Ib+kK0CDZJ/9CPQIeGXyUJeCR2fnKAF0eULUxDCC/ry4OKuMrknpOFx2ShEkFb5QlpaJQe1VGG/Ovcvaw2MdL8MpQ39MsyhjIoZv1hdbJTpJ9cIEXaokARMjohE3H3MYytrzcle9xqUqaw2tnEiTGbSkRDVzItNjFk1RxOFGligjM4pwBl/1oAbrLGNeXzjrJ42Cn62KBSIlKMd54ie/1CNSo+l+uP77lO/nTiEj5uMHynKtrWzuYGA0UrI3F6xUY760aMKfWituvMMooDSpJ+UhkeDw4ZTplKVHdwKI6Ahi2yQsCsmPKFabonLneZSl50LWCIkAswaCnNhqdvhMpkJu20uRhJPNeJuWNa8c5pmdxmTxJksZjEqdtF4IptE8sJYVeOgU53G8YLO3hlPefosjXzwXvvwGT5ZObCf/uxnQNHHvlOJyq9zTahCRQqmiCBEQg+BH0RTahFRqIiiwHpYTuRCLo/6pLKDpWxKh+bJdJj0GfG7xB/gFkOfvnSVV1nFP/7xjmwwYg2y3BwLZVta0F1CFzS00g2NmkOP2v9NF0vV6uygGtVpdlFQZBWZVpVbmctUMWNuElFwlAjGsrLBmnSaCVmN007lwLNSbG0rdd4a13sCFj12FWgo9orXveICgn8tL0IHi8fAvucS45JfLk5x29+Kgp8XdawgRNFHY2jHwAcWDIKLSVIGExWUQRlgYxMyBgpDiLQtxLCPUrmId6iWhLJgRCCAlFNcRqXEsc2lSnxJVN1yqcU51GxvmfkL5TaVEqcY7hWzGLI5XZeslgmuFImHzZdgkTPSzW51fcw8s1o1OWsFb5TNaIEV0IG85TVorepax/Q+Ir3rZdp7v4RDuf5VsPOlL5oFWT6JusjNoNAFJDXEkNv+4pj/1kBwjMklI6L2Gc+/5SdCyDDo/iSLC9QSyb8y7FIdMekqslBtpP+RjVK8lsQ67elsaes5AXWvs0XdLepEhUxkwpnGx3wdKWd3sWhKU8fUZLKPP8YHzPhuMVvdpiTgZBjUxMnVszHMVa2b5FhzUYxqhbKUzRhPCbxAD1cmBpb1uE87GqtBxvryXtlTUGnLddtoDuyqAjnuQHPNywUsYE5Ed0yg7Pmz7R5dBWeE0l8eM84BjltFCX1oNxyaWpo2LSuxsodsSNrDkbt0u5QE8E0HFRTG+HQwX8wXpGrWzhencexgp61IuPrVOzbukruIGcqoAte5zgxqngsnjzsvT8LO/12sfayz7iZ72eB1wHiHJp7vkYfadvQDJiRkLPWt11V8hS93lM7z+H7bPvrcMn23DFA6OuIO//kPuqWVkEfUmd1sxC3pPs0OlCITWgHWNyPzXeEKI3oJJ45Sk8gipJi+o8MGR7jlqpJphm+ac1M6BYsVNnFRjxlGzPA6qm3sGkq0uuW/VjJLhi3yk5VCTVulBMuJbRqNiTPyIZd5kif/hhVYoOZA866yrcfsNLLhykVLemDqWm3DXlvoRTc6RPoae6X3nmhHc7q4nTZ84j/dgeSWsH+y7sitc23AX8fznR386cU2Ft9qx/6++6190l7B+33X6RMcfRUpyOLukrZp4/80rHezIKnvP/DXlIQqeMLHyJgx/sXDH/7MVrzC8Y//ONC7EzQQNszwEzW5vG0iFNArLgEMo1hLskk5vZtTve8qgJzzAC0Qmm7jji2jvQkhOhAsuv2Yld2DERwisyyTLzgSPqorvhckN73yA+W7qOYTsDqzuDsjB89CPBcJLa45m+wTwrXbN7f7viQ5wtLaijWwBYNTrWyoF7pTP7njKfg7kit8v7nrnE4jmPqziwUrvL8iMI5ChTJ0KmjqOACktc0bvQGctdZAQF6wmG7aPK8CK+JywAesQ7QaAhGAAAQQL+9avUHEuU3Bgu7hwO3Qq/QRwagBM/cSM98LjGGSxEn/TMHw0CcWhDr3IMFYaRbzMZ+J6rcadCQV2QhT00FrIIevY6yNYBAgHMIYKsJBM0JZ/L4kZAJcFIuwkDusyAEpJDgn/AdZSLjO0bS3y8JaCqpXoD+KMxiSyizLurhXyDgzpAQ0fLzQuy7rgrk9sTxsQECu2rHrerXa8SbnErmxYidkw54K/JlBNMTseCNyqMRjQK9s+7JZyERuo0RL7Ed/rEdNDD7iY7N9ijoHIkioMayugSxpebP9qqz+EoU5yygBgcVYRAojpEV+q8Vb1EXOaRcm+UUe4IHHOb8ntLRf1EIqLAsrPAv3cz8XYrhlbEZnDMMsG0My7ARJwDHH+6pi/6MJ6moJAtydq7KMOAQek1lAcrxDz7MqO+nGNrQmNOjDJ2tHdxzE5WArDOyCDbSauVrERxw3F6ya7fhHgDzL1PG5M2vBsezE4QNFNmuzQDvFUXDI2HCRZfKvFREti/TLvsRIIsw3W+RIf/PIj+TFlxQLzRm/FlCEgkO/EiJJ9sM0+LPMhbvM0lJG+bMzULMhBhNDyrLGjeJJn4S1JnNAbhxKqOQ8xohDpTxNySNAIoOudYLK2yRKbowCotxNyfuCPpzAS8HKrNzKeHy9evQOaivIsYRBSDRBFEzL6FTLTdzHUznI5YzL7BxLrSvFi/JBvkSIvxRPisJIwjTPjkRMgP8bSZWczB5ogVJwwndghCggSfWDu53iO8yMu6sogiQgEpY0HBkKPHkLtQU7EAPLSZ38P5DLQ1nLzaIkOQS8NeYSPdl8w5+Uzdv0gg3l0A4lwN38gnWEgAawOfAizihDgBG9ADaASHKJtudUQfdoTuo8sxOUzhu9xPuozjjSJ+acuhnFmiAFz+50G7rkS4t8hPHcmsA8zybdPsNUAvhLz15kT19Uvx6wAvMzOFjqgfakUkyDCiEQ0zGVycwJixRaNC1gJE8j0Da1SdD8lO6ISFJ7KhxLw6UcNmMTyuNSTda0tZP7jAhkqT7lHTy9F9jyUBDdTRwYAQog0RIlTkLcFC//8ErkzLKD3NFMjUTA+EccvVFMrFEepdFR3VFIvIghNUVTNAxUTVKd8EuukaSMzD4opdVatVVkNIsUuiUqFBIv5YE00FJJa60upcyxwE/LJFOYzMzMIcn/RNMncYs3kAtqhLh5q6EGg1M9i0YF3ck7hbVBVc10jDw//dPXmKLdSFSWYkpek7ys6M+piEkcYIoZOAETwABKKSNCxErVG1EOYFE7wycvEchQDdVpgM7eWwe0xFGl0VRRLUFS1dRaEZiJpVhWnViua9WKfNVYvFUl6NiOZSGWbAKVrFKsID9I29L59NKRzc9lxcLMlAomkQFmXczNrK2GsC2PIik/64tt/30GgPUjjrqxBaUmcPVQa9rTDCVXy+MFZkjASMiudN3QC/2mEesRHEASrKUBJKFXnaGArxXEdzzRsWU9f21RN0odHX1BtmTBkVLYhNWSSYTbTj3YgVWzTF3LFawIJD1Svj3SjO1LJc2D7FPTJvXYj63VfzkCgBM/Y3VckzUhJjQ41lLZ+kw4mMXc+5wtELkJWWSIwkCgTuIzoYhGHTLdWNBJ0vTWqL2JDp2ZczJaPz0Fpl0TlKGDQZXa2awi27yXZs2Beu3aei0BexUBDniy4BTbSMWUAJDU1tuonVPLvMXUtWVbplPY68VewLBbLUMzUH1OvSUox2rVuFjVVR3f8f9FUsFl0sNl37dD3CNAAvh13zMlCzPdRf68315cQpT1sEmrXCttyczVTwHuO9BR0yk4tGrpt8+FLDgTIAKb0x3i1tVVV9FSzUh4qk5AsrK63d60kzz44MV4zdcJVNzlUB442t0B0dMCXuENAQ0gXuOVYeoJ20oh2+lwx+KsMlQ4TnoUWIb1QDoCKOoVLEn0VLrN0XALvrIELPCxSPMVEMeK4sAVXL88gyUNUMNt3/nd4vi9xcWVXzCuJfHjRSE5VjNuHBQGVg/rMMrFKRYmYGSV4wEGU5t9i7dINPZd4HwzNy+LjboRltNF3QleXZsBDUIY2tdpvBy7XULVg90ZGaT/5Cq0yt0HtVqwUAEX1oBNluFNfgAJAGVQruHkJeXlYF593coXmIT+4z0f7sCEFGIiZuJvy95arlvrVGLwbeK/+stWTYQpruIqBhHCPc8uNmYuFuNkni37zd8wxQqSBNaTfIdxiCXLpeOXxeYf8IE4vmY7LlxZHcyzMQK5IYM+doj96ih0vjHVPeTQ6NbGG01YGM1udZlrQgPeEGFwfNp69lAUllqr/QEVKF5O5uRPNuhQRuhRLuWFXt5T1soLhIAdiASgNTyi+VEXlOUl7kDr7ce5PeLkJFgmtlQV5OVWFc9fFpBgFpD11eJjdmn6TeZt1lySlcIgieb+TT/KzNxk/53jnu5mJLzjCyNMwdQ+RsIJgckQBOJhds7gpo5neTZDWIBqNOy4CtWD2OEFDNJnIevgDu0BDvVgArRMTd4ABjDoBEjRtFZrUP5khRZOUt7XQoSBVc4sV15Lg/RRUm3bilhLhL2GhLXlJN7E76DlXcanKkZplV7poNbiPHbfl0bmmJbs/tTV9ZTCY90pyGUEWZCFEZq0PVABFr7fbPbpsMDsMKXpzbnjLJZFORjMwS3nIpwb0EWgjZpq245na7xtGpvq0RxaSHC5SEiTaCBu4k5AQBCrEN3QyVxhI/ld4S1osxZltaZuBPhkDqBhZXvrhmbodnQAIZhoeEs69uDEQP/Sa8w6jxJ0WySO24/u3sEaacMWFcVWX8ZmbfQ8zAR2aS+ebJlWZjQebdROzEybwlaSgjSYl5oqBHkV8AanY23GbBko7TPG5tXG48+RVZHoZbzsiE7AOF8wBhCX6t7O7RJHBakuQ3km8TKMJj5QjcXQ6mgABjk0hUpInuQOUeX+UDOAcIGObume7upO6weIgE3GgOyO6+3ubgOI6PDO1lG56IzeH13m6Ep07+0NvvjuNvpW0sE0HO973/2G7P4O4zFt2dHe1R0p8GfebEAQWQfvaf/mgTTH7DP35vj9ZhkSKqV6uAILcT8XcUBHcRN/6mokdDR0vAjN6hln2uTJvBz/1/ENpc/f9fHoDvIUhQ4hT4Ai53S1Fs4kJ1smZ4LAg1O7xmUSpNG9fm8TZPX19ujABh/1VvUq57Yy4/KAYaTWzu8tbmmP3YExJ/Nt/nU5d0n8JVkKb9ytWFQD12nFFNMhkGmWlXAJH3DTviU7nxwLz5M9nzFjiB1sSAds+PMa8fNfAHFzXzXdPnQUh+oV920MTkPHkNBVKKVC2IRCOJQDX/ZZogERGGgNOOg//ENmA0RNl2609nQcVvIlBxotIPWKBmJZnjaNbnVpUxhYD0301vLxbh/sS+nY9ssigO0szvVdN2ahjuwo3WZf9wH+dl//NvMggHl+geORBfDHNdnQ/75c0o5zXqxzTHZ2LdwgO4EEa6SYNJEMUGjaPi8w2fnzQFdxdV93Q5d6D4cmp4J3IIOq00ieTXCZfL9aSifoS4en6mYrTSf4TzfRUl57NLoAKKBG0JTE9djRWedeXQZpjLdE88ryZdh4iCeV2C5n2AbhwX0S2A5z/N71mFd5l4d5YYf8yJd8mAXwlm2SmsYXJ+FmOf7Pa6/z02ahlTgF2VETp38MXkgHUEiHcxdx0zd9/lv3E696oYUmxcAxOwWylPsCMbKufed3E/gASzd7FGW2QBz+tF/48Fr7FY17s5zOhLL7WS4zPdL7RKx4Wgd88Bn8PBD57v94gLnvXnfsxf9n/MaX+bcr//Qf9smv3y/1fMzZVSvMqWZ/9peF2SLhAZ1///0HfYBIIhALQTN8WvFKmLBaNV+8sCHklc4hRV/GKlrMqAoVrF+oPnIE2TGkyFcgT5r8KEnlKUkrF7V0KQkSITo2v3jJ+WTnkx88mfyAoUKEBg0MJCCFgODA0qYDCkB9ulSqU6hVo2IVoHUrV61ZuRoIe4HNK2PPpqG9pq2ZM7XL2B6Lm+zt3Lp27+Itpjev275w2fYNp1Zw2r9+r+H1y1eu4cJtHTd2bEZNnjNmiky+okYzls0FOXcJDfqKEtKha0wprXq16SWuWSMJIkS26h2zbd/G7SM37xwCMe//DDrQdxPfxIP2/JlDOfPhQJ8/nx3dp/Hjw6sLF2h9YEEzkCgqbKhwPEZVFC+iN7ZxZMqSKN2/pwTylaSYMWnOxE+oTxqcaKIAmBwPQxAY1FBGHYXUVVkxWFVTDzbYFQESRuUVgxCswEdZ1EB2mGF0LQaiXHuRSKKHdw2WImEnsojMh3mZGJmHHRpWRBGV3XjjaJp5tqOPP4oGW29DEkmbbkcWKUNwyxnX03JFPMmck0ksWRx0P1x3ZXbI+aakjdsxuduWWDrXnSSlKIRmQqD8siZGb8ISp0YjoUQnfO11khKelKx0X36E/LkfHIP+J0WAyhkoQoIKQhjhglg9+tSE/5NSWGGlWkGwQyTCnEUjjSOGqBcxo5ZYV4wrzohqi6siFmqIMr6IVxGd2ZjHrD0CGSRsuu4qZJJiGgkski/A8OtyO2FG5XADQjkgdsola2UT0mpZoHRk2shTDjJg12123B5BJndZGIQQNudGA0002DykEJxzymnML3KSxJGdHeVZVnzzyYeKTPXJpN9+ffDXn8GHLnlgURwsGumkDTpMFaUUUjxxWBDg0IlZnkIGKqmM3UXqLaV+zJiqsLKa8oskx4jyp3WRhlmOBOUKpG28+nrtazsL27OxMwy75LZDe2udks5iRpyAVzJdbdPVIT1l0dqVqaweiyTUyimgLFJKuv/r8oLmeea9q5FIHrkHS1lq1yvfniad8lFLkdAtMMEFv3Ewws4qjCCjEjtqFaQRUxxAxRaK5cWGHa71cskhizyyqCzP1bjlKmN+ooiUg+zyp7PWHCSvrYnexQ6p7WC6bqzV8DNuKwyrG+w1zN460LdfO6buBfJO7dLTQufk0kNLvTuXT4BrvBBVo0HJKoRQTQcgqgDDzbrRuOuQKdrD+5FFG3kUZ0mw9FuSxnru+WfdNA0yMB82sfGF/AD+t+QJRBX1wN8W8/8wU/87DHGH61/iUKGMtHBMMS1rFalc4UDJcQ4wKspcq1ikQBjR5XF2yZyIzkC6D4aONV1AHRdKiDP/1yXJdrabnQ5WqMKgEemFKuwd1ah1pSlpp1lQGhrVlBcm3Ymph0AxCJ/moIUVMuEg51IXMJoIp+11zzx10tfa3qaSkLiNJQEDRH7eFwf+sCF+bxBj3g6Fg/stLAIKCgsbCdhG//3PjQMc4ArIcsA7qiyDLHugKzT4qglWsILFWFXlGBhIDCIyMS/zUAgbKULTjeGEy0OhDG1Tu0rGDndAzN0mt4TDpykrlFNylhCPpwIe7LCTY2qCGdDQB+epYhBMaOEIRlADM7QCTdzoBzeAAZ6EwGtO7+HXSNRGp/LB7SXqq9vdMuE++N3EYP0Jzv1MkL81tnGOApSjhLQpKQwd/+IXeByn4zjHRwgW8kOnOlmsLLg5EBmSZO+E5yEfs6rQ0ewKTBhd6VLnzyPVJqCvySRBX+dCSxZUlZzkkvGaBjxtHW9qDFWo7rjTyj0UUScvqKWSDEIIXoxjHtZbRfaC2Qq0ic8kdMITS/nVJz8xsyZ8kOn7omnTaToLBdXUAAWQks2fAjWoBOymN1cQB3EikJ3qnBxTb5GKp87iY/U01V5SpUgKxtNVf0RRO/eSz4E4cmePlOQkeUbJhKLVZxQ10LNAWUMZfMknzfph0VAp0YYO8QlzoIMXdrACHGxBCCvgaAls2TxTVC9dJS2PnfTEHkpsgj7IlFsn+JSn9WGWYP/vG0RN4Se/vUoTpwMqEBo38AChbpOo3lRtpVaQCXJe7oKigmDkHjgqlDUVtwv0XFa1Ok+u0rO3MAsrcXNm1hQeNJMsxKQm12qtu9LwhsHpicxQibwm1dWuNKCoEPU6Ro1udAR6Rd5gb/lKxFoPbE+k10ka21JkdoJu8cVsTDNR00OQsYx5S8NFeTKg/57xfqhl7WoLPCkMvRaPShXkbGkbOZOtbFTolKBssSpc3261q/CcFYdBKNYPK8GfJDRuiEMMlLP6tbnEMuiKU5zJ7S50hs516LS8hLzrTneid4XxjLfgBDT4OIz7lUTYKLEHNMj4DZTARnrZxdh96YttLpX/LCpgCij8sG+mnfVsft+wNwDjIMDbTaNPCWxgA/9vBRo7oKrK6eBSEVIvUcVFOin8F67msasVviqG7/LBcPXKwyYcK1kFStDlmkB2Ln5dolvs6GJB2rkMJeXuHtqc5HQrlTvusRN+jOQRmECv06MFLUhKi0rQ4YwjuAAHmnCmhHwNmN9TTzHb6z3KJvOyy8wsJLR8X75+Vyd7kxaYh6DTY2OApxL4qZkH3Ow2YmxxHEqqmynH22SMTHJx5nOGgTvVbmv4LbcNNInJLckS14a5i1YxWln46EdL+owUvXSNeeIlTdeVrjyeN0/Ii5woAIIRtFDX89LAgxVc4K9f+OKr/9Mr61vXGsq6tjKv22dfm+AX2MHWCbmIHeaPg/y/KRg5CpKtFGafuSuGWznFLCAHpCp42ov87bURo8GZ31bDNw83z+nZ52KUG8RCN/fQh9TodSuaxbQ79NEjHW8sQbdqNrS3vouWvH1v2tJSGwoO4FCJglNThRynA6x7+T0pnhTiU04mfSuuh84KOe5h5DgN6/7xAR0qQDpV9gFSbmAIGGAscbrjtAvfjZnzvJx11hwxvp1bCNf8530GdGyCLmhzi/i4aUXouxXdaNh13uk+7CSlxTX1WSYHrlX3Ft+gjvWoU0loCjtBFPoj7xqUltUc0P0buPiQkfpCiuvZ3toD1v/2QUyifcqHu8b9w3EoQP+GvRM5DwwlhUFVIfsACvP9KgD4Cg0Y5WxkObQhoAaOEN7wh5fG+hPP28L0oqqIp2ptJxx590veLkW3PLkzzzrSJAkLgd6iXRLTrVijNV1zPd0q2Z3wUF3xZJqSLKAn/UQJDIUJiNndDYg16Z41hcAM4EDtnRe7OFHwxYkpxEeuHd8z/Rr8iNHcPV/0SRfvaCCAWMEatAEgwIH1WR8P7N2qfd8bNYD4VYwQ6oDGWIQ1mIU3MGETth/72VMU1tzl7NZjpFPONZBtyZ+FRVj+6dFb8Ab/YV7QHVpBudsAomHnDWCiXaDordXrnV6B7FCybFr/l9Rh1CHKCdDewc2eCOIABlAAB3gg1+lVfwCKKXwNNDQR8YFPv1iW8amPr21ZHBxCHNDBIfgHDMZgp2mdx/FAD1gfHOSgDmJfD5qRBzhAKl4M+A1Q+TUABFiAEvBBJnCENYDDNqQDQzQhM0BhLz6hFW6h5yzeMGJbFkJV/BGjFNqZO8GZ5LmFoaEbNIZh/0njr7Ch7KQhsbRQ7GQjAsJbo70ejN3ec7meHa5S6o1S1F1dOLIjcoxWv1FTCJCZCIDZDMjjKQEIpJ2YExACQsSaCaadS/2LS2QZZ7XgCzqf820iJzIkPH5i3l3fKBZCGxBKaBlcUGyAKr5iEIbfKm6k/wV4wAp0ARscAiRU1hLaYkoywy4yITm4pDRMIReOylN9wic8VeMBEv7NH/01YwQhSeVFI1CKYQn5n7FsY3kZIAHaI+cRizc2pQm0YQK2Y3Ydi0CQErgIjTlah3at3gI65EWWVlSGoN4NiMEdyO6BGgiiASCYGgmWAgo2okv4y9wEikHOASaK0SHgpdx5Wf3knV+OF0QKpiFyUSEY5h6sgUVKwQbyHSxypFBt5EeCJEjagA6M5B8kwiScgi5syEqmJDo4ITBKoS9S4QYFBpvNJCaoZihoG6p0ik4qXk8mkp9Vo+aVFRmiEFOG3m7q5lN6I1H4JhveY6KJ4zhOZRGoQP93fQuYaGXpSRo7wiNxpMEaREE1bR8NCCftGVxPcEBaZucHstKZKBYwbcQjQiIzMV80CdlN9SX91M9/6BdgDmZoEUxhIiZ94tRGXUCZQWZkSuZkkkCA3gAVpMZmYCYosEIubCb7qaRojub6QWgCVZBTreZTUZj6OWjn3B8WeuEyGItQ7l9R1mZS8mZvlqhQROUFyuMGsChhYZ0eGkdyPotdWcmz1OFV3iF0wSNPfUB/uOO2EAVSsCgGHopYQuUgbkHvUY8TrUJ5ugTF0cSWYRw0Sel+uSd8Yml8QiQP6tf8ECZiImZ9Jib2cR8gPuYreqR/TiaAjgAJ3MCbos5m4MH/HzgCnWomZ+KpMHAKaZLmOfzinsZcXDjQKMzZIFEbn4rbMuRCFebknUWQb01jsPRMiE5qNW7eiSrlo1mgim6qiiobLFZAd4oAjE4ljlKHjkqUjeVovrkjK9FAUaiAHlLfBxxFqNLjdPUEqcIocXKfT3idmjSpKgyk8RVklbInNIWWlebNssbnNCmr3njp3UirKFIr9tkeB/YUmvrnf4Zqi9YSR71AatwAEpiQnFJGZdjpKIiCKOQpL3pmaP7pY7ymoOKC/UXhL2aozwmjhkLObErqpQZLUAYswGJqUqYocG4qrNZSqAJeZIKkBb6oc94hBELNqk5lpcGjWZ7SdEZB/woAJw2sQSGkAXbKKoEc265+53L8aqnBZSuYp3my4E1IaUWClkXWLLParDQRirXaxKBMq5iGLM8ayhDw1LZyq7d+K7jaCLmWq2iYq5zmwZwe6LpyJoPm4jmAprsiqossatd27YVG6EvSnL7uZDHOZon8a+yA6EBFatqiG8EWrKYebMJ2J4/2lAVo60d658VKbCnNqLd4iY5NYA117Kl+wOHS43b64E4tzAZgAPehAOQe6eQSYhoUwiqQWti8JSMMnypUAp8Aig5qVs+O7ugea87a1M76bMH87Opaa+v27JhGQXEAIUg6wJpO5pDeI6ipHpwGQWoAr1A+LRlE7bnmQf9m3qk4KaHyMqjWtoWe0uuigq3lvCQ5jC3kle31ZhXBjqiIvi2KxW1vdirdHm7d3m22DmHe3u6o6iqr0lWNwl6X9O3gtqoKtGiLMgA9jtxOHNzCwOpYhpyYpWwGZAAGVsEeCBzLktRbMvDngi4XwW61uu7q0gF/WGIFsy6h/OzdiG4Eu66gvO7d8JcXDIF+4m63iqrS9u7aVt7StsYZFO/TousjrCuCLihS6Wnz6qnXSi+fvmQvaq9VdaFscqi4uS3AUl7bAuURq5XTNbH4oijC4s/96k9S8KcQMsCQtu92yaHFum8QXawCYux1Iu4pOYsGnFIKSIEVVCcG6GEUUOf/4uqh9e0dAS9MskXAwpxAFQQC5soCSVkCIwiy8DkwBHPwwIDwBGfwBYewtCLyfixC65auz+ogKVLyHmzwG2SBDywsi3Zr0qqw6n0vXJFyKYOGB8kwus7p8abrDUPvK7erDr9kS24tt+1ZIhWxiDBxQdnmLsNt+Mrt+CIuFVtxw2qrEGpxOcLYTsioja7e/IaxGN+VQ/Lhfx1I/prA9fVAmSYbHusPCvRAOMsxBmSABthxHh9FHvdAyA4cy24CIAdrIUPwPINwIv9sHDiTIx9y6NIzJvuzJG/wI/9z6BLM7PpVJ6fwm65w7Lzp4Ta0KXOGZXhQZaAyGVj0Zlw0K19C/w3bcILGcoNWby1v6G/lMgZx74eC6MCCLzDPLd2yqP6cbzEfMxZDLNbhGzni9NRA8xvq9E6I1lC8dDobBYw+5GIyTFKgMVTKauSmQDkbhTfrT1RjgBRcriVkbpO+cyB/biE/cCX3s0DvB8Pt81cDAvuI6SR/sD53cB+Q9V5hQRAgdCgrtJEodGF5wF3jdUi68GhMdD5l9F8br0ZvdNU27y5qrfNy0PU+Hs2ZIRL38kn/cnBy6jB7ckw75mUbsypCRSraaqRxpSrZ1Wd7sTTPm49Kp1lWADbDcXWicfUBghQo2wOgwA2ytjmrMQuU3AMkWwLwtv4gQG9HAO2N2qltQv9xb/Vx80kh8HNZxwFBIvIXhTVZP3IkfHVA16fygTV2l7Vz97MmD4UMbGopz7Wj3cAHlDdeH25em7cpW8ZnHAFlDG98B/Yj0HcNyys6uGQuMgOCArH2+vd/J0Nj+wwvq3RkG7hvkm8aHbUEsBpmOzg2XUxnR/NoTziw8O3RBAcD5AAOroEPHi4NVJ+Hm5YE8AB16pRSq5pQM3UGlNwEYABwR3WMa0DXWXXmbkIgVIJxI3cgyIRhHqZyi/V2E3R2L7dZ77M+a3eRzwRzFyZ3u4Q/m8Emi/d4wxUoo/eVewAI3LWWzzXoSLRlZHRFy7cM03dm6oINe2Y6ILbYdmjPMcb/gf/kEXfvE0eawUp2YZVvZVs2+so0Cntf+gae4yo1phXBTqejMvO0V/o00Y6qb4Q44464KlKfh6vRA+QxOU+Abk+ATmVAjMM4jKNAHBiCH69CIGu1jvN4cqu6j9snkYducxe5dY/1dAvMFmHUsMol6H7XEciAXlf5eSctlgt7qHI5e3/Gl7e306YyHuDBRYd5fSMomwAqm3OtYuPWhQU4nMf5nK80pn5ngut5IGYrgxczUmdxnmc2g5dxch4c60ngOiY6/crveBFI2P3XNisbw7R2/9LeAfdANz9u9nV6VG96U0fAAnw6TCNFwG+CLDg8IOs4qhuCIUgCxRdCnlx8/3RLd5DHuiTsAZNHsj/Ts5ML9JLj+hb5Cx9MRq9beScPe5Z3q5azqdJ+lV/TTHyLuRtYtBFE0rPTMNW+BbUDOKyEiLbLObfTeW/E7WRT9kuLe0yPe7n7OYueXISXMZM4J7PsdIVzvevxhGmfJQPwwERKwQ/ucWKa6QNkMxuf7Dlb+lO0AAu0AAFnuqfvp2//9lRbgiKQesTveCFYPJ9YfCeQNeGP/JVdd5J/fN3U5ZD/ycnj+kkpk5fNBrCTQIPj9dSHu/fNvK+/Nz7Bd+jDt7OTfrMzuyPYJH/DpC6MLeuPtP4ZvUpL4yjHPoraPtObr/k2uJBa8flyNu/rOaCvr/+RNie8x3vXnyNYnnu+y+pOpMAJBPf9KDwEzPgZkZyLezpvu/j2t7huR/XdJ8D/rPPlktofG/fEI3ePX3xXm7x0X9nIk/wWQf78D6vLLoIyrYT981US6ABAjNhgAUQFDwcPFhyocAMIhgghHrwhg+KRJRevMMnYZSNHNXnI5BGphkxJkyfHuFGJh+UoUaB0xcw1U6Y0Xc5wLtPZLGdPn8mABgWq40VRo0GO7kiqlKkQp0h3XGyqBCNVi1KhLvUxlatWE0lFUFRRgmzZD2c3oOVAYS1btxYevDVYQYIDCXTvum3rwIBdg2dV5BA8WLCMHIYJJ6bxg/Hixo8dR5Y8GXL/jieWn2TOoYFBWg0nePA4IQJ0aBQmOEOI+yAChgyuT6Do0aIKigisW3fQPWHBBN8oUGS4fYC4BgwIEDzIkEJKjy+BLA2Tvon6pkCFKBmiRKjQdUrfsUsSLz48IPOE0Kcnbz7Sevbt2Y8H1J6+fPv3Cy1qJb7V/v7/v1tEDzSWEMiuh9Ia6CAL5kKIwYgQmkjCIKiCQouOsDjjoyJGAukkkkICESWWBHlElJukIYecmoRBkaefYHxRxmSI8uqprrLKEaqnqrKqRx1vxNFGsMYq0iy1kGzrArmYrCsvvJ58y66+/DrLshMGu+zKLIdQrLIvwfQSMi0Fy0yzsc7ioYrm/2ILCwUpzEtBg7U+k6I2DG6L4E0WUgiutd9uU+ABBCZgIY4WejiBtRbaSGFQ3JxbM45CaJnOFOu+M0RT8PJzDz/71ENPPEjwE1U9UOO7r9RF5NtPEgBdJWQOM8QqIUEIFVwQwgdJiEggopa4EEMNMxTRJA+LCJHEZVcyEaZXhGFGGBVTRMbaaq+NccaghgRSyCB/DBerrb4Ft1sYyDXyyCSVHCiuufCCd64o/ZJ3SgMEqHI0xGjgQQbRuhQzzIEpm0HgxMwcbDQaRHiXLj3tZBNPDPxkLYEBBih0NuB4uziBBZAr4LcUNtYzBd4KSDk5Efp0geI4pLNU000z3a48Vf9x9jTnnesbL8CfgeYvaFbDo0SV8tK4TK1cmeYVV4EijBCjDDfKwwyrNUzWJA479BCkr/FQNg9nQSnb7LKprTZtbLcdyttz08Xxqrm5EJfccg1GF25112W33bc6SxDeeuNlgHAo8aUyrcAODrhggiEXOODM7DRTtDmdlIA114yTrQccXrP40Y9fG7kDPjteQPU+81wuhQ7yVF3l5BK44AAMGG1jlWHGGebS6qqrhFOeUx2vE+I/HXrn71B5NWigVYm+lOltTnoswQ9q18GooYa611+NSgIL8a/Q8GoPr+Baa67FFht9Zck2e8Vob5JWRfqzzfbtiuLGm0ck7Dau/vn/71x861uC5oQ9JrlLXvOq1+EUdC8q3cVNj7PgBSMnOS09IQ1sCs0a4KCo1miAOW1IFGxkUwUrCCd2PTjUxDDQgTbEgIULUMDprAA71bWGBTmMHcZCdoDVZOALjKpEpaYzM5oJb3jgUR7ykse85bWKP9ETnhWtaLRKSG96pdgiI4QHwsv5LSI3AIxanlYj/pmvfFfbkEiKwLWRtC9sJWHJh+w4NrO9pGz1wxYzrHEt+u1tgIX0Ed0AeMi53Y2QS/kK/2p1wDklSS8NtOQlBwJBuvAlX4qrIAZBGcrGOY6DT7geD9pQhTHuCXSxQ4EVTBicibmABS1IHaFqqZsOpG6H/7Q73etaUMsJBPFjj3LBoezUBlrYImbBC8QXmRjNJ/rseVT8VNHAAwspbpOLR9OizainilWMkxHTK+c4vWjKW43gBd37VVlkAJjtHaQo7JxQsrKWNa7pIRFYO5bX3DfHPFgEjwIdWyIQ2kf8/WKQXoGkIRn5P0Um8pAEzNtFHWrAvpERew7DpCUfGKXO1CVlE9QAWUSZUnI1ToNJ+4DhUgCHKJjGNaILmXJ+04KTuUZQxfRY6XajQwYMlahEnUAKatmC4QyAdMchXXAS4AJDKIIWvfOdM6W5TZvdB5rBw6Y0fXYpJ/7uUllkHjqxOE4tkpWc5kQnOaOAmpPmDWpfEf+IRtI0g4gkgVb2DNYR+DegjFitfGbTg0EFGlCLDHSgeCSD1gL6h0Ow4hSZOMVlG7k/c0l0ogLcLEaborcZ1KowGj0jRxeowIcF7qMiRVxJU1aBELjpNFhiqUpvS5ghJGwgnZvN5zhmU4q5zDVI1WnofNob4fhmOT0U6lB1qcPdfO42R0WZT4V4zDhMNWa08GpWmxjWcfKCFsDghVjHCoxtSqIS542mL8xrXnRqcbziPFopyOvFLb6Vv28tZyVwwIE5vYESer0rGj5ggj5EIcGLgIOtsseqFfzqDK1Ag4SuIKDxjS8P+mFVK0ABNq917SSLneOHytcRx8qBDWz4gxz//pBZzXLWKlPo7GcLCVrR6s20kpykgH/8MAa2Vl6Gy8tdRjpkkgqgk2z5pG1xm0HRavAyKRgLLE9Twh7UNDdxiEMNF5ACMIjhy6rDk574lCcSsgAMu2HuUUGmsgew+bjBPTMQw8yoGGw3Or1Ta1ezCghwmmIVVqSOL9D7HV9wwxTQM682FQ2MRrfXvIBQhaQz5V5TyFd4lpAvLcYJanMGAg5wsMQqAsyWL5jiC1B7w4NVAAgGq+A719sADNo7YXb2gRd8COwg0qcGM0DCF4kobCvAFqIVg42gA9WaiqFdtxKPoW4yjuhmA1jRa0M0ozDo8WzPiMAgA1m1vf1oBF2r/2TMLbnJi4NylKXMUg5WTgWh4QxrXHjcN3PZY7TUqSyr+5peJiepqCMqbJmqAOa2AAyG6MHAmQrEo7qA4socx8VFDWgmhmcV5vWO8J6J6UyLPJvlbV6knRiNVUii49FEK6eNFmrvXsc7caWACdoQCBzkJQpHE0Fa5gBrWctWeAy769HauevtwMCerUhEHAsb4jgO++kiVlb5OBSiI6BPJFSL9te7YGOxW3vbUbnx2ReZ4yDt+DAaNSBql5bAcs/dgWxJcuaCzG5PmqBN8L5obr00bx6cxchGHm7LKpZczuFUN44q6uP/9MtgPhe7GdNY4ouJ5wtcLANeLsTubMENSf+TtdMjDx5aNx08Trsc5pTehOlbPnJVMELSM9/EzFe+5ZPunDgnkMIaouCWJ2xnCAdJg9CfcGvhDd74tebACmogK0kUiCIWnkjdBmHh8akBEsY26LM11NjFbt0iWTA/hsgHdmkrgbRkl1u2yx5/ts9/tJE87f3Fnf+/JYi1Q27t3TNnNWwHAhKnLy6ANL7C7xQwNMpk1j5AyOaEYv4tpmLA8aqrB8DgUARlZBAFdgqgqCYPupAqDFjgh5KL85hrlwYFiHqqmM7MBJ4DiUSN9IwG1Lbo0xiNEjBtE/iL9fKrBkVu0wrNvLpK1GpvEwDBEFbhC2oATnCAOCYIAlQpCqT/QPj2oNTG4tV2bda2wwwAIw32YBEMzAsAQQskgVYm4gyvj0NAoZ/K5/uy5mvOYOoIS/wa6/zU7+vYDyzaj1+4De0A0bPWTsd47Ns2atwEAu7oDl7epRELJwA1Zy+gcO/4znEALzLQBZQYp0xC4/gupzOoEDgQBajioM0wQFBuCAzAQKkyrwPCgARhp2MiYBQfjzZ06jZOUPFoieJ0QwFWgN9Iakm84Au+gBJ4ZxiIsNNazvUoTTuS0b1G74o+jaxmsOOG0PZ4EBqGUDsKwQVcqAaEsVEIkEoeoFFOYA04gwOi4ArXgGGOb9fSQPlKDTCusBDqbw4igQkkYQ4qYh/X/zAJEqEN1+cKHEvrSoJYqoZu8lAPl2BvHir+4C8iB5EQd8zt+Ab/FNHc6K7/3AIA6SUANy8uxpESscTKACbKMlG3LFExqNCUDoOE7uTMLAYDvKwHOuAEbukEgSoEIU92TGY3FK4Fc/GG9qzMMo+YLgAnl4QOgEH0Cq065MsarQMYvOv2Vk4Ib2/SmPEZQY0qk7G8yGmLaEGmAmE2vuwCmJAAH6AHCmEFCpAD2oAz2tEB1LEPYNAL31EE9vEDfgAQwHAznsDBxBAehYAPBvMIrA8JKgILEsHpSIJD8AmyHquNoM7ZjgAP0S8zxeUioK8PK/Ih/5DGtI2zJrLbLBLcMP+So+QucDhS3YgMEkUSAmTzSQYwcehyE/0ONwlDN8ukN58A+NREClQAA9ZCdGayA7wRuJxK8XTjNnAoh5aDlxTPumQpF4vpl2rgNVpwSZBjSSZsBXrgBp/S9bBSU6jSPJ/SCHcwvy6NGgkNLLOx0ALBhIqROKsAT+LABcoxAyZRTR4gcXyvLuCAB+gyCuCAA37ALvNyLwPTDPbAlMBw+IzOHwnsB0ogCRIT6gCoMY0NMglyMrUOMtnoDjUTMxfSNOkvNAMR/kKLIgOjSArREFMzEfNOcFqTyOruyDJHNjevR/WOgh5pMd6tYOaPN1808CwjaWKKEfYAB0jm3mZS4Tb/hpa8TDh8Ssx8CLpoowzKgBV3SOG+9Kj4BKqsk5ZiQKcQheLeJSldgBjRo6sMTeVuLxrh8ysv5TyB8NTKyzqkkirlM/dMwHZwoBCO4wuO4wRo6MswhskQ4PceIAAMQE2YLAqsgC4M9PkeFA72oMEYbPjUJA1KoNQCk2FoQNYudBGwwDCcriI0lAwgQRX6KeumjUPmcA47wjKzQCEZMv02wjNjNEVVlKLWTyJdtEjh6SLVZUZpdBE10v/m5ZI+cjajJJMKUF8ScEhTElhJdSzajsrMgHKADw4CoQpZI6a+bBczQOGOaRV9w8x68fFccRV3aQJQsboSQEzPdKdqymNc/xA5j+OYCqGIyHBSDo0GlZEI84s6EHb0mnK86FQ9FXY8V6EsO68NVnAApIozDFUA5syFMIDJQLYco4AABECFcLIKNlUC1vEsjm8eY61TxXBlH1RCR+AJVGFW0qAS9EBVd5ZVq+JVn64kRNSOps5DO2Ju8FBXS1R8jAKlvM0wEAM0g3VF007++uc0TwtNUnPcarRZmdWjQAouGERaedSjGuBsU2ZzrvVaNdHbFOZIuZUwiqABO/ELeCAUSycGaIjfkKNQ4qDxaqgnlyu6pJN00HTP0jRdQxLPlOOYlEhTTu+KDO1Or9FhHfZO1TM9HRb3LCEOZipgBdRix/GY/nNjMf8WZSPgAw8gAFg3AwLhP9fAL1UoEEwAAla2AoagD65wLBzsAwKz3tgReCGUF1jFw3h2jdKn/JxufCCzaIvWVrNgoHKVsBZywzTTaX0VbnZEWCOyV3nkMaw2SNdFRoMsI5t1qL7WXuKFAnTUL6IkHdmtXmA0b9h2E18Ubt+27XiTMSxHOOeKOXhgX7GrmKSUlnZpl+pVAYRSTPWtcDHgC2bIZSCY4lxmOVyoO5SoOiB3E2Dh0FDh9F5uGvvrrcqL9qqRFmStEuKydONgUFxoBQUABQoBpvhTACag4VJXCjKAdQMgAgIBTwg1ZV7Wdje1wUqhiAPWd8Uw1hZhU0e1BJr/uAkOAx+LIDDTII7iqInn9jIXARRydYsH8mhN9GiVlox51SKylw8/01u4t0eGVVerFm/s71jf7v641mtZ60ZZM30NIlp3dC7WTYJUg52+opDZdlu5NZHbZH73927PZE6IqgrmkzZ0L3YS4Ib6pLisIAy2jJfa9WMU7pfmtalSF6cGxQUaDoNVuWCrAxZc+Xi0iTpijouiktBs2b+m59S8qFLAUoyiQOckAHWR4xw/9hz/E1JRCTmqoANUxgoYYYeRKmQtVoY1wACBrwJu13ePmCwoAVQddIr9st7OMNZANZ7MoBXGp5tVAIujeOo07IzNuIy/OJ4Xyeu8l5HXGFi3//fs3rifccw0w2Kj+kZrfyzuNgB9mbXcOPJG2beho/URE0SQGWS2+GZh7BeRFRlLjjTwMkM0YoMtzLUFusNlqou4tNMF2WynUqeneAPNDgVwF29zluM5Ivf0OriDW/mmc3qLxOlyAe13zsmtUNhUnWRAEcA5FnUtUYBj2yAOOCMFrIAH8uU+AaCqU+CZASACTOheVeioRTcuYhebi/hCK2GJ1XllPyBnQbUJCsGU2rrtzvkJiqCJv9UM+Go/vlV30TAJFsl7k5evryJX/xqO69l6LQKf0xhuqJawBbE0ZXSgZ3Tu0II1DXqh8dhZ1xc24SWQR5JHRwA1LbrvNlq0F/9G3jJDU/13937r31qDpIVogJMqk6WzuuKgAl1jUlogNpxjUroDeGp6pzvBEFz59VxZpycXK38HmnB5XO3EykQAtoCDUHpgUQVgTpgMd1RomY+ZM3g4qiIAUjsvA62gmkMDySSAOXwXVL+wr1zqiQPTJZOmlMSiQZNAdz9sZx20ePsAi8G4av2bsf+7r4sAsdW4wPeZQjazswb7nwuJjgUasgvaoJn1pc7XRovMNZ+1fVtrEhvAyTKatBGbcS66MjoxP1bpc4YrcUcnAkIy4HJD31YcuxSgDRTBElY5cnW6potbuHf6Uj4Yi2i5vv7sOmTKyiLRSWDLY0IGZEEWUoP/iIedvKqdnGQZdaiIA8nz4qQWx8EjiUx+4CQp4jJqhWkr4kwww/wOY5H6O8ABfMEFPI0JPJ8PPMEJso0D3KH018Hv79vYhfDMV/8SGkcf0bwbaCQNEDD4LrQ/vKLjljcdeQ8YIT8kBpLxDQzO9IXANAL/5E94kUxdEDj4jDpO7bdxWsdLXZs6GBVQwbjLar/ICtHkU6ZGg31hi5MYtaSgXMpzfdd5HVKZvNZ1tC0K+jQVGZ8b3V88c8C3+CHZvK/5ep7/Wvz4e9qxOM7jBn8B69rsvHt7pDIAWs8fPLInu8+b9f76j6E3Un3/GAIlEWQ93EhAPAOKRN6LPW5VkoM+/y/WcWA08OReD8WF/lZ0opPLFKBzmhpRgqkUn0nUGd4SbJqVhxuoMaW4I/7VDQ319tFus3MtCpDKEe7XmazXRZ5Kaj22QFL/9pzYDSjPCyPPlz3N07y/W97ZaZ7micVWq/0D+FvnPSCx+QdGkx3B6Xyxw3eOwz3cyX3czU0tGEAF3MVv0P2yBZ1JRPIt1TYstDygh1PrV97e992R04BShtxzT2BJIgA7Ke41INmSOYcHoGODfVtiHf7VOZjUTQHVKb7iQfjPZOoTDb3jcR3km3zkQbZa/aI7132zlRXcrZ1/8nf+4ugwCkPm5bbmLd/NWZXaq93n3VZq53ywhx6w///bWJG+9JW+z09L3MR97qLeWf14Wqm18CMxArH+pLi+3rGVSzionII60nWPhDy3gtOeOC9AAdgU4EOdlRseKue+xy3elvP++cd+QMu+NgH/+gff17U/5HkY5Kfk+90X9pc+5bk8z4m987tVzlseN6+i8pv98jc/85W98cXX84V+27kdsP2Q9H8OIEKUGEiw4IeDCBMqXIiQQUOGEB0e3ECxosWLFR5QqMCRI4OOHSVwdCCyZEmNGw8YEMCygQSJIjSoUKFBZkwTM3POpAGjp0+ePIc0MbNH1Speq0qtqlQIThQXFx5gwHAhKoY4cVz0cPEFTKBOhsJuGku2rNmzpsb/wiqbtq3btW/dNsVhgioElSvz6iXAsm/fACwBCx5MuKUBlyQTJwZZEiNEgzp1ysiZQwXQyjkyW8as+eflzZ2LHBmdubTpzKRTq149WrToyTJeH5Sts3JO2LVloI7NO0jr31yUIFlCvLhx1qw9+6R5cwTkx9ChU4zOUKLjj44xMh65HYLJ73dXAi5QgOPBEzWnNhcROfdpKE/MSEqqqn7bplupPljhokacTWCJxdYmcJFV4FtoqTUWfXE1yBQhbUiBAgfhDbAXX35lWNiGgY23F2LeSUDSdiReFF17uUVmG2gsKjeDi6+ddhpySdAInGs49pbjcrfxiJuPOt54xXBD/xJp5HHJnQakTs4J9Bx1UD4Gk3QPYYTSdhx0FxJjIXap0ZfieShBTTitdxOKMP4w1BxG0cfgWE198UUchRSS4J0H5omnW5YoiCAlkgDiFA8omCDihRduqOhgGRqWl3cWKLaldiBNdyKaKk5mG2eYtZimbjOuFqqNRZa6421FoLrpj6iy6pOQpAJnqo0+LInbk7hCZOmUUTL3mKXAUrqRsBWMuJGIXR7QZYhfitghS2OSadOZ57GX6Yu1wsdHm0iZktSbd4ZL4J7kvvVmoGkkIdQThGrwAF6NPhsAAPPWuyiiKzlAnmKSiiSsBwAHHPClmFLWKWWb7aTbTkqC2tnDu/9FHOtos57qam8/1npxxhPPWqrHSW6c63PBUmlpr7r+q3KJJllAwbLhwfySvmG2hFJ6MU2L6WVqOuEFId666cs2DcJiNIFHHz0ugZQg7aeDbtHyLTBS0xcJIXTQ4cUQP/FA6AbkJUoYvWQv6iFf+8o885XZCTwwypDxZtncnTYMlKcOSxyxCjF2LGuNv1nMd6uagrrxchoHeWRwf3/seMi2jiwQB00mRJF1J8N9EOYTrVzpsBs0pmVHLruMbLLkgUdzhi5RjvPrZcaO7exDREEJUsCk5UvRSev5tIG/m/tW1WMJyrUJO9TARM9P/YBehWOXLT2Hjubb73clZqd53O3/7T03aJwubFtvqklseMKVdVxjFsi9piOqo5HP8fyKN47kxHYnfitOlZu5UOaW01zoLHc5zxkwe6I7lswQwEBkfeR0YVqJv14HO9nxjAlO6IO3cgc1PfnOaeM6kNCCxidDYK0HJ1jByy5gAhys6wlSYFdMROSh6N2remkD0fUS2LbtLYR7CoOYEDXFmfNxKlRByoFoJKYa9p3BiTbKUaqmKMX3WfEFvsFiFhdHsSsArot+A5zD9ic5g0SpJmcs2QHXyLIKgEBL/FKMiBo4x9X5BTEUwJnrdIYTnikvCho8iil2NzwODrJ3fFqa7vL0LQYBSlByqgGFlAWBDWDAay48/wF63BU2s1FPL3GM40iM9Tnt9QpFQFQY31Z1RPO5UkZKhOX4ikiqL9qvfVQkXy4zdsUtcvFxYATZFw92sTJOzmRpZGMPEVjKfhUrlKeDoCgh6CjvSIUDGIhABS3IvNt1a5G7C6fSjIbIcobQKN98UBqi4AQXeo1CE9Rku+ZYM08yyno6lJTpnlms7JlIc5OpVioPVzjx6U1im1miafrWt4UyFIxPFOb6bBk4KVYUY76s35GCectaliZF7OmfMX1IwJIuU5mlHJ2x+DXKOtJsMfS0Y0sQ8CX1bFOTPekZHA4pTqId0hJEk5oHzUlIq0miD4OKnTtNwAGcFGpyMrXnh/9yCE1SkrKUAcMIwHxYsIIpdG5f/ahpgijLhcbyrEz8TRawYIY8RDSMF43rcKx4gyDUVaMdBaYwC9pVkY7Uh1tV40k7d8A3gsSwk7oqS3OYw7VFdaYJoKBAMsBNNQGNF+Lk4Dd5agmjFRWcpqAaB5GKhtJ6jal5xMAJhEKoTYYOAfX8pKPCRlVo7tON/vwnAAVKxg+IrK+bUiLdZAm+Vx70owwdFRbY+kQzOPGtcIXVRn0zBR1M97rRhVzk/mpMX3k3ZSYVLEqZyaV+ttQk0GxsTOMVWZu614JMeIM3MesL+taXaOIcpH1FK9q0AMopMBAIDViL0xYWaioUWZ1Up1r/W9sqNrdvY8hWB9pb4KZINKD5qkLLyuENm1W5R3CrW9fKVnVVLK/SZVxwusDiFgtHxceBsV5hJUYiOm+73PPrQFGJyvAScLDKJCVi3bjDqjL2pd/p5NkS8ABtaoCyfAwKFOYw33D2VL+0sDIvgPFNQb3BtJKsgExQgEmelGmSsb1hAw5DACMz4Kog0CfAsBph8M7Gtzv+bUFUlSrweTh/H+bwcUclGnWReLlenHEwyTBjGbv40ZB2XKIdnWK1xo+vKNJxd3nMW+4S1sfKHPKQufPgN4eyADGj7UuanADYPstCTH4dlMsUFDpUYstazrUvaMHlozAFqU1ooc+OR7kB/7eWqWCS1w3ZfBgjT5Mjo96n24A1YehUuFWYilGPwFrcQcPyz4IO92gOfegkQHfSE8OCrBjN7na7O9LvRrekFV0+sfoopJ7GFadRJt7xdiTa0C41TPuF5CPfpYHvcnWGmOzkCkp5W/yNODCwMYxh7M7LW3vRCkbgThw8lcwTMgmGFgxKJNvWvChPbKWySrCC6BnbvJzJLlf15+F6G62A6zCGlQhucyM6D4ADeojfKnR3R9HoXahuF9zghqQ3nelOH4MakE51ed9vmOLbd57zzfXwts3fbRzdM019alXHDEywJc+SG54z5OU0vpLw7MSBwQ1DSkJryqvB7GZAYGIn2/+eZ8Ong52Zcjrrdrd3VojLFy/zxhdOuFm3TKqES8sMK3TDOcf5bjzc87RSrNyJJre8i65oRlNB6qhn+hRWLOPURz04U4e31a+ubWJu+tq373q/wZ5SlfITWc8suHfWbHAGGN/VZSMPw7epphqgYRCR6ESgpA+hL9Ola6xtHmqJr+xlC37gWyodhFXmHMTj+fyMj7lXe8m3ycdm8z/gvPxj5e3kXt7niLYlus+daNKDUTRusHpLx3pc0HQDKIAGmIDxNm+zRyu4t3VaB4F/tXu8Z3jBB0fOZj20lS8NRFOtpmQ2Yx06IwTJwwZvoAcoyAZbowXwAQV5hwNb4XeHkmb/svV9hJcRGAEpFmgiJfNDLXctMLci7Ud5kzdoT3BWFIV1DoV1kmdcZ6VQojdRs8d/Vgd0jAZG7HZ6LrZ6BkiALhZ7LdZuQ9KA9yM4Ebh1P8QknaZ7FViB4CdNqcZsGziHDKdwgnEYqTWCS6AFKjgHX6aCK+gFK5hJI/Ay3Nd9hXEhDRYp49eI/9Q/1iaBepY+scRt6cN5Toh5SaiET9iJe6OJUBSK4zaFXuR//uduAZh0r5eKrqeAYviFYDhpiEZ7qXFvkniGuZcQ3wVAbQht5GVVv6c6itFAwziHqrYAyPiBauchTeY6WhRfJviHgJh3L1AC8LRm8eJ9bJZPy7KDpNoxauL1gxI4Pn2mSgQFecZ1hJrYRPNXbzz3baEihfIYerNIj1cgdKSHj12EegMIdbDXhV3Yj4wGhq84hmRYi5jGaQ+Iiwyphnb2dSg1Z2EXEkVWdhrIYK2WjMr4LBPUJDsAH304jTuwcRcwfHsBeIG3gWcHfDzERp9mZ8d0izDnPu6HjkQEG+kDVpwIYrW4iTfXiVAIeoVmj4tmj24VTECXBwEBACH5BAUEAP8ALAAAAADgAQ4Bhx4LACUNACwWBi4iDTMbDDcaCDceEDkiDTkoFDsyGztJLT04IkUeCEcjDUg0G0g5I0kpFEkvIFIxD1JMM1MeBFQrFVY0GlcnC1gsF1hDKlk6I1lkR1ouGlwyHWMuE2QeAWU5JGc2GmktCmlEKmpLM2pUOWs7JWtbQ21CHHM+JXNuUnOBXHREJnVEK3VKMnY4DHY7GHZhPnaQb3dJKXhbQ3lJM3lRLXlUOXl8YnpCG3pLM3pkSHtFJXtGK3tJKnuhfXymg4I+E4NGJoRJJoRKKoRTNYRVOoVNMoZFD4ZYN4ZZO4ZcQohKJohmSYhsUolGGol8Y4pNLIpVNYpWOYp1WItSKotZNotaOotyTYuRcYyhfY6ti5JMHJJNJZNPMJNeQJOCXZRaOJSoiZVtUpZVKZZmRZZ9YpdiMJeHaJeegphjOZh2V5lVG5mWdZtpRZvOppxtS5xxTZ5gHqJdM6LLp6NdHaNdKKNtSKNyTaZ4VaZ9YqaYeKdiHqllKaloNqmGZqmifKqCW6qPcKt1Sqt6VK1yO62xj6+dgrDFm7DPrbFuRLKHUrK9o7NsK7NtNbN9Vbd5RreLZ7emhbiFWLp0Lbp1OLqSbLqZdbuDSbyjer2BPb7jwsF6LsF+U8N7NcN9Q8R8OsWbdcakeceLVch/OciDOsiXaMiohMmSasmrkMqHRsqSWcuEO86RTM7Sss7dw8/luNClb9GGPdHoytK2ktLFmNOLPtONUtSNQ9SNStSSS9WmeNWrhdaRRdabZdiRPtizi9mWVtqTRdqjatyVSt2aU96YR96ZTN6hWuGXSuKeYuObTeSdU+WjW+ahU+apXOa6k+edV+emZuesdOihTui3h+ulWuu1eOvFlOvcw+ykVOyrY+2pVe2qXO2yaO3Rq+3w1O6wXvGfVvGlVvGmWvKrVvKtYvKtavKuc/OtW/S0a/S8hPWyY/awV/axXPb85Pe5ave7dffDfPjKlfmzXvm1Y/q7bPrAb/rYpvvCdPvFe/vJhvvktv3RjP3UlwAAAAj/ABEITEDQwYMRSayQ6eOooR0uQbiweSgxiMUnXbxoFHKRowchIWDA8OBBpEmTIU+qXMkxIkaITITI9Pjhw4WbIlC8zFiFTMwcLyLeUUSUaKWjSCEdLaS0oZ85dihOjOqnkSZdxZxF22ptXNevXrlpE0t2rFZqaNOePXtsWdqycMmZm0uXnTq7d/Pi7baN7zZ1+QLHG2xP719v9+TpE3zvWeNw8OghLix4seV9+wgb3utub2R4hENXtkxadOi8mvNKa4YsK+vXrbMG09WKNrGu24ipYgabq2zeyYALN3sYMGHMyJPrU658Xr/kz51HT35NMWZsy61rZ47Zn/fv4MN//8/cXTp35fEyX1u/fWBBBxZG2FBYtdHTLhJ58uwYZKNMlCQFGKBNAYogYAgBpoQgSSZhJNNLDv4EQ0033YQCDzH15JOESHDhh1EgMpWUUUg5ApVUdUxVCSttNeMXcWCFBaNZatVoo1bPhBMXWHV55qM3nBlX2mBAFolYaToaWc+Sol2G5GZ2dSZllJ9RFhp5pWHJmGmGsUZMMbaFSZsqrOBCppnH4Kabb1v9NtybPM5l5Xl0TgednehVh5w8zymG3XXbJScePt8RCp566+wzXp3ZKXbNMHpaV9CkDiDUE0MOuaTffjt18R9JBIY6IEkVVmjgqRaO2mBETOSX4X8U4v8kUoYT9fQEUC908WGII/bqVB9RoWhHQ1i9NqOMMcJ1ozEtstXijnGm8+O0L7IzmmVGSjPZk0lSeZyTjaZWl19TVmnlYENqyeW5qsU25pllslLKvJQgVWaxfeXyZW9tugmnscWhy+jA0+GJ2XqRohdoc9EVKl542LBX3sR0DjaNtukhR+l7M5BxBqb3ueoqf/i1BKpNKBNY6sost2wgDBzF1KnMKXRgUwOyDrGprS+IkOscvJKYlCNKefKrsFbVBrA4yTadrI3MLosjtNVSe9i4dm2JbbaJaZdYjpB5e23GpylZ7o/sCoyluusCmeNstZE5bylI1Wt3vfPWtm9uxb7/+VtwgLs1HG5yqh3uwgQzvDZ3fv65cMMPOye5dxaXZ57BWl58ZHIbL7BAfD1VVchTmpas6cwWDRhqy6y7nFJOQczEKc0exGphhBreimsUQAvd0NBNgbJUsGwUX0cfoPT9zNROH6us4NAvS7Vc0l5tdV9+gSbYtkRivzlpZlMJbrqbkVu92NrPqS7bmmHvZdzwzn3U3HmjeYtr3fTrd7OBRz/4X98an3UwpziDSUxh23lcwSA2OcmpZxrpWRRzHOeoiyUMMwUZAKVYIIWFfChkIjPdRTaSOgJhQGU3QWHrWMaCHrCAJB2RyexAYrsLXMhWtHpCzyLSu08EbWglekpU/4xXB0fshnnTQ9bTote/G01vNd4LXxStJ66tuW1zfdJH+NInwESJC2vmQw0Xz5MxRLUPNmCyn5nU6C9n4a8r+2uLHOfIDP7BCIACw9YFCWgwPmaRThQE1AIbeLkHQpBhl0ugNzBmOA0mQIMKcGQILjU60oWwCxcp3acOhAFSedJAEjBVKFsWAh8UoQcBkp0IZ4IgCpgqBznIHc9210MSiQiIPnTIECdixPu9bXlIVKIw2fKLqAmjiTRKIvWwxhlmQgldhVGSk57zGGl2MXPlc2baDMccaHZvNcLxV1tm88YXkXNfbNIfHdf5r6mhZmwKvBPF8KQnPiZunoV0jjzQsf+aQ8YzT4v0Z6MKooAFKCCS8BkCfUZHkZI5lGRekAmqOFk7Uo3Sohj1wEVNeYSRlFKVnvJUEGp2E5xJICcY0lAVJBQUJvTOd7gMIvGG9Ym9ATOYw5xRWopJRyc6T4nnux4VA0aeaDIyO1kMG/oE6M0pBrVHYuQm49ZxRnD+sjdQtGpW4WabNrrxS2Bl57/OIaTFSOyf8lxgn6qBVn04znEFnCpy1jMMXzBSqnuqYD+5WdC+HlQBErCAzs4wukI09KEP7c9MgjCqkpiAQQdaUEYj24MpdDSVMoTQJl1ZIZ3IUmYWschLgQjT4e2yD0fEamt8+lNi8vSYbswpspzJJLv/hJEzYONiPK7YteUkdZGFM1y6zEpWp0I1qnjt5hezaVz31XFNXW3WV8NKXSYyj6zehOYe09ontT7Hn939o1vX1w+47uNPjmOrFw05DBdBUB3vTRTj1gNcLCLnr/gt6IU+Zh8QIvYirmoJY0cK2QIv6LEJesGCLHDgFhjBCD4IUApAGrvQsjCWK02sz54w2t/F1GhHacQQ7eAJ5RmLtUlEizBkYQv/CU6Z0XpqZG57tdeYwx5b4m1gyrOYbgWXqdyK4jLRV9aKsQ0doEGyGIvLZOceQ0zn7EU6nQHd6DbRf10BDPvi6l3I2WkXA7SnZbAh5n2wlTrq4edW+wnBPXYP/7gYG9IE5vzXDSggAxmI5ccYekkRWoSEjHWsCQZtYJUcOLINvuyGZRe7B42kQjhD6WcxucMgdNjDQAyiiJPGG36huLWupaNXgAPjZd52xjTOX2vwuNzehuuKWcsuPInb3OMmObnKreKSm4y9NMarFPoiZ5ngyLw5VheZ7rwSrrvM7O/2lrt2ugaZ5UFm8WLJvF68mC/w18+7tm15kAoMYJRMZzube87zCYPovNBn/OQnhqlzrEWEkIIJDxolIDD0gliQ75TUgN8fkLRI+WMgBphUAjf8bOp8dumYapqmNW3np5NJI7esuMWBqzio+RKWp8rJtqnGEXZbXZksVhO5sv8eUpc8vuRlb3m5vO71k+W1onv9Bth96XRZnivWsQrJ5c3uMnuqjc+CHXCQ2DAvQPX3mvbiUclVRQbGzDaBDVjdzgdFNyVN1G53l87CJWnQSEZab5SUXUFot1C9QXA7ImTIQam7gMFNmnA24PBWG264J4T3Cb6DuEQRn/JaJv68ZeiGxWHVOFfKIVuv0BbVT70jzIv8aqVuM+WLMSqNd61k7pIn25Mfl1XfVb914jznY6meqqlcXZ9zSb5Ff5ihxIMookuQnteohXfrJN/dSmM2ni7G1JHrvqxGcQNVt/oEso7nhPT3sH2OoUfkbRITMPbsaL/3yzxKqnwj2IaqjND/o11JdxSoFIci+ZlRMM3+3wXPl4sfvPzfIltiIj7j/5NWa9PR8ZC/6Ka8MRmUcVzwlFvn0jWYZ0Wbx3lqY0BUBXOih3ozdy9d1RuqQAm4wHE49RouFkwjhy4PCG2RQyiz5x0Rsx7V1kC05yh8AjnolV5Hlxn5onP+klVLZlXRYHzWoC1WpwBYx3wIATQNwW7uVoQhBHfbxyBlp28hURIHUjOSZUOE1kkf4XYOxREkRX4XIHB3lzpB0WG55Ah/B3h9B384uHOEN0yHN2zBQWzxp3oU13/eE3kuYk7XlU3vhFT71C2JcXnqo4CEM1RRNTCgF3PF5yVwQ4FvZCx0Qwzs/wBj86dz2fNz6QF781Rts0eCJWiCQzeCEtSJDbM45wWCmbNabliDUMRrNLhmdJZfc2YpQjgHpdN1AxcEHxBaLMGE2bd2HKB2COZKE0aE4ldwc4dwGKZwebd+ZOhhe8d38Cd4rEV/rZUMZmJzkph/zaOB1oNb/xc9wUWAwnVyOZaAQRaI4OhyD/hmdLFmHPgueuNpfXEUabJ6S1N4HnhjVWI4+eQwmqiJ4IEd0uZlkbNW9RSKtRAog9F7Mpgbi+hVOShk8LiDq1FQnjMBBvUACRUFHmQisxh9tYiLK7ESKUB2HkFvQvAFKPlgKPlvkiUEG8EFtCN3Wngh8/FZlSaE7P+3d7/Dd0rRCcHwhvb4PCnGc9b4hkDphs4jZCDHIxwodYUDckwWQGbFh/cwgOSoJXC2gIM4VaGhZIfoaVBWbG5SL/MoXd2IlPX4jcpmOSrYj275HbVQHbrnHZm4gghziVQlX/qUkNpVTvTokGc4ZcqwGhgZAQbxHiXhUqIjiyLTkQHmESOpEiNpkmVXmVgoE0vQCbywmZsZCnmwBJc1YVZoOjzQSsXYIK2yUniXjKXld/MTeCeWhtI4m2ZhDLZwf22Iltm4f2G0c+6CFk95jnoojnuIcs9WjpMoiLhWiNewjvwiG2FpgcpDluFgimm5m8kJX6TIXfzoHd/QnYsRCy3/2J20d4IFSTnpmCcIQ1/cdhcWCJjqNGXwUQHzyWCd5JJesJi0uDMeYRE1YxL01mjzVpmz8h9HkAr4wA8Kyg/f4JlfAIXHSDOlKZOcFRIYAku6IxI1YWke1n6uqS8PCYCyOXGGV40Yd43CxH/I0k7m+JfyRyWPF45ho2tcMpxalJW1ViRlhGZlo4PQmYhnojc/WpS90AiUkCaJt4FUU4dq2YACWSgkCAt1STm51w9v+TCGNE+Vs14Ws5598ZPu5Z7qlKTviWzRoAEcAALe1wJlpxFQURXQt5/TR6AiMVIGapL+iZpLwAsKmg1++g28oAdL0EoRGpNaqIQ6I343+UN+/yeGn5BaS0SbQTmNF1eUKLp4cKh4SSkl0+WU3AiO4KOjNCpr6oKjxxUwODZfCJMt7Rhlv1Y/clNzfcMKfHCkJSpqSpqWI6edDXg5/PgN39mdESOesjelziYxuLdee7KqM8gMohdO54Q/gROtf2MClXUFZZCtaqARboopcWqE4CpgIClgsmNvQSF9XwAN/AAO7JoN+BCoSeBJoymhMmlwYVcFajAUYRBRdSpaHbqMzhh/kiqNaCipqxccJopOl4qdLAo2OvKbZvmpc5g1oWocVpmHUhmqTHqqqJpr9AVnrQo/r0o/r4oVYOoJtWplZsmw5pgXnSeC5MkPh7IL12Cl5P9plzF4MHdpiQ+oOe8zFpAXsnZEraZHDNYqBSg5FIrwpm7qEHLamHkqmY02E+ZarieprtmgoODwrpMQr5yVmjxxoRR6AQwWS3gACYSgCBuSfhnBqH23dwobTAZbatRTcQnrPxK4cZEoliompKaYqWnpavaQIxZrLoW7lhW7scwVX+nZpWrmZO4oL7CqN9EpG5RQRCq7srkaY3MBdTtqOd3Zj/JAs4rilps4Huv5uXy5uurhe9oGJsvAF6gmtHG7Tud0P1/yURrJrdz6pkJ0hF1nYSqxWFb7H3Y6E+nKD9kADsv7rn+wBKYymgqhMy/USZ1EkzCzr9MXcOr3r6/Zdyz/OrfQQn/jUpu2yWKkAKK5KbAvtpsLu2rn+1p/e5Z1aIDixg3cw4BjRD4Tu42B+HpeCbKIGCZBamJ8a7l1UGK9sMDHtrlLE4GeKzC+6omjyydXerqGpGXqyR6ri2T9dE4Q+VVEi7v9Q11p2kKWBRVLm5++K4zh+sJRuyqTWbwgJQR3gLUL+q6RUAaEyjthQFhusK1SQAQ2cAMJYQVWMAQI0jMiUBM1IQI+vLQdqghvq77pJJRDeSx0oQ23Wqm4QKaEg7f1t7dPxsBKQ7D1i5Z9OGMCyMbKqRhMlaPGF8EQiIPiBKYhPMDAASy7gSY958BMuY5Q57mCQnsMWl6k+6QY/7yQAuW4jtzBo4cVz9qp7EStJBwMjpUEd0AIaTsId7CvC8G0I9SRieWFwwsz+OkfqeymbkAIfLqgDAoMOzwDCVcUnjwUcOAGuRwHu5wEObDEp8K9QIOT7rd3qQWNytQO3aKb5oOIXvzF0JObOYdMkUrGtnGbfePAyeaegqic+eg1Pday3GxjqLq4zmWd/es275M3rkGrjWDG0wrGLPvAUKWPT/ociazIEJPBkKxk/swuX8pVzgAZABgbP3psllxlCGJ+ZXDLuuwH3TpET4sRYCdvlpm0ePAFGqG0VIwKqMAL0EAoOSzLcXDE+XrLeIDL2irEV3AFK5VS7HaTnyzFO/95JuE7PVPCqQersBy3epUKt7caf0xjptU8XQuMzWKsqZIYtIa4jRgLztwMVV/pv5thquBWa8ujCzR3FehUCbXaxQiNf0dZsPTcsZ63T8PQgqBrpWzd1nTlDRy8qv4811ZCVu/zC60QuwVt0KwX1n5ttBfCA0Xww4QNyqHswpj0wjC5WE2shLPiBV+QB53w0ZEwB4/AmZuZKNAQ0poIDacQCGpwBqGtBk/xFKPd0paVBDWJQ2Ggr0xwEcRspLLaNw5JsMrsDmThYyra1+2L2/ZHc8F2ROvbL2Kt1H9TxrVhqcadf3OhuM4knCrn3M6pg3JsPcZVXOuMN1LWaccgYqX/4Mx/fdMNCzBElVa+l9Ywix7SEG5dOddR6d6qNibFtNfWedDhPUc2kAOrXdi8eyJep9iljCrVFwV38NGbCQ2oMAeosNkMzuDzMHvYAAyo8MmifdoVHtqpPcQZlqj46toO4ruO2sd/nIY5vZTxPUc7h7BmYszUWFNWDI3izdtHjc3bTcbtNN3V/XHVMWuHGEW+Qd3WneN7QWVkYjenxxYiVuPrFM9YFkeaq1raAtdI5jWP0hpuxke71V7xZYjnMHxdEhv3Z+P2fd9ydH5Iy98eI8qaBeAmEyBk5wWuXA0MHqh3wAsPrk+JIjkkmHQ7jNoXLtoKAeioveEa8iFQ8d8q//yoJjviSQ0Xuu2/X7VTcrTinLAbZagvmD7UTi5xxlZMNG5MaGnjgSzkUg7O4TzqzQrk/3dVrP6VlI430soa7nwbx83kZrrpom6Dh3sxTsk9vJflTtk9OTiYWqXr2A1W9xLpd5y5I+4xhP7sburCM3OEbY5SMuEGIC3ncj7hhMBW0DAPm92W4I4NO/znfl4FRWDmL/0Spe3f+EEVLk5OMY7Gj17vj5jVPdfiwpOBuMAJCmw/MB5HfTvpyf1asIXrjc6wU2RNgGiOghmRUN7qY0I3pfecsy7jtn7r4QTGNYKKXBPQwU6JLEg2jzsZAkzs7GgOw47vSB1by47sYS1/GP/u7Ia9uz5x6PzRkV8XaC/jkp2w2bzQCY8g9K0dCqigmXI+7s4B4eX+52eA7hoS6OcHS6Hj7vAu3LW9t3KoVFssRffe6WvyXKTA4sKDgfou1g288Z1e8DOu5B349mMNuc4tqjnWXDv48Da+ano/c68J8OAk78Xg1Vif8YTPRIz+x1/5G1FExz2q5aCBesqQTpH/8Fo9L0PrkGCf+W+yCJ08CJx8yxvCu5Q27VAbWtvnkoqQ7bzgBbobCagQUT//7c4h+yZI0hauUk8v6KGvO84+YjTlk2Aa8C+a22djuKx6lmJym2LPCUYkDiibNGv4jGS+5J5u8KCu9nA/3qwHnXX/xTVcYvcQj/1jDi9HAc31KNCBzweDT/2FLxzGxOQQK1YFbVPeHMDGnrfC3y9sT8niDxDEBA4kyMzZQYSRFC60FGnRoDNVmJChWDEIFy4XL2LEuFGIkCBBPoggCcPLI2jf1qES8uECjDu7JsG4cKfaPJzrpt30l3OSHzVnhEaUWFGinKFDyfRh6sfRU0qVVN0KVrXY1WZZEW7lqs1at3Hl0pljV1YdPHvx8q1di7bsWLBkmx0j2GtqL2G4SEVV9cmTHT6eQH3K5TdXMnHJFC8uaKwxXcetfk2mjNcyY8yZj3XlbPDqwFWrkA0b9sy0N9Te7qVNu811XNiuo2mljezz/2bbdCXvbsWK79SDr2vrkhzMmi6muGbf1gzZOWaDeR8va858McKCX2kLf819u3Cs4aGP340X+/Pc1J5fnr5ce8OFgRwSUiPxSRejXUJy5H9f/5OQQhrpBRFgmGMXaBJEZQ4YRCBikmpmEmGQm/bZB5tdprkwJ1MKSeoMOZASEcQznCoEEkxQ7GvFu6iySrztvOKMm6/gMusstNiyUJ+23pKLRt3skoWVUoospRK+guGkjjoEK0yvw8RJLJrDHqtrPVvKY0+Y66yrzrbOtLqqlVHKDC2Y0k5LbU3UYovNvfOs05JIIzUpRTnX1IHtIOJ2y0oVJl+MrjpCqcNFOkPXa/8PvfbgjLE2g7RbDjdKqXwR0YGgNI86RtNTdMtKI20mDlKbaOIKVJMgggf/8uvII448CgIkkkoKAiVo1klwFD+YUGOXeXYZxA9TcuonnmlikcfCY1cBKkQ2PjRRkxTPdLFPgarM5VoYH51RLLnIcos1HsvlkbV6fhxTryKjasRdUqhbssnB/LI3M223xPay3iqzLMtCGw3TM7swWeRgg0cZjU023exOGkhvKy7TFTWRyk7zHobY0m1386UZUNigBE5FAyZ4SC6tNLnkTgmGMTwxbxMUX6qkw+vOlEv29FNMQ/WMBKBHEBqFEIrOodWK2OgP1oxC+ijAkrpAJddcdfr/CSULd6pwR9J2WXafaVZJ0cMSTzyRWkw89kXQSyl+zFsZaYwb3HDFJVfHttRKlx3TIDvS3XffBaWqRpRuhDB7SVGcMMwO5ffxOYn01/FEV97MZ5dbGXvzVkYrjeGG81Q3Nzm1rPjOzkUHr88WJy7ck40tZVnl6CSnvWeVQR1o0pdbnl2xfN3uF+DfK43MZsoFdc+CDpiXoILnbUUCo6agesoPwOxYumkCX3Dal3jWET+eYSApBPzxx79GnmuSXbjrqnpj8S7UPWabOcfzx3Ruufmv0ca62S1HeUOXPfZmDmswQyDtWty7ktGJJXHhcIkTzOKAl78sZVCD//oFzmzH/8Hb4c53mTPfIEyIIhUprDTXUEf7XPhCdMRQGuiA2DRiB6bchGY3LXrGjdqkFdYBJ35U6gMbWBG74jVHOigrVPByF8InXok4UUTev4y0KZbtTHjJG8/zIPDFBjzvJUeL1tnq5SK/OGIwT9FerAJ0EWLJ0Ia+QNEw5EgaHA5xYqQrRufixxv7eYliG/QXNfrnv0M6LIACLKDe6tEasASJOKDgCwTrIMF6UVBxHcuLLVBGSBB68oqTq6ISHXNKzJFQEWYz4YkeYcK0hSYWpLHhC6sBQ2TFUJcuxGNVznQV1clGYuzpoxCTowyXUfFKQ5JFypzoRFPqTpmQ0980p8hMnP/xDJU8q6YIk9EAcD7PaPc5W9pa56JgdEKd6rTXkpJmh6dMBY+fI9Nt1qZH0/nxftkC5HraVkVQIiaRiPzfIgFoo3Q10pEIVOC6BPeJImJSk5lE3ictCkpRflBIhMSXN3tnFbENqxB3IKkfSNrKQVTLFLOkZfvS91KdqI99LlxYnnJ5w3/ikHHSAFQfiIHMZE4zGZqKZlEBas1QJnWKHQUoNm0hyX3lzEpHFSHzWECEJKDKDYRYxC//aRz3dEJQFORWVe6px31uURfDnGpUn9lJDWp0GQONG0LCYtCDHvSR41poJPnZiOy50w6J0yQGnWq7uHaQTh4c5CdFiLwRKsb/l2MzqRsse1LMBqKrK51lhm752c/CVKa4bKEMIfZVgeRQKlnxBBt8ikShRkajXHwrU2lLxW5yMLdUteIVoZpUbmK0Z1ZQQ0onEQlZ+gKPEcOKtzZW1vvx8aPLJF5UbdtJUtwWrhclHrjoyr+8hjc2NyrgORhKOMACJr0TvMVEG5tR23kQvkWiJjN3u9tOgXQU5itDUC6LWTxw9bih6CwvPAtaBOvqGgm+5TR2WUNrnFVLEnOSAgvXCJJZ7oJO4i3lOozf6xpWxPel6nzrK82l6nbE2volhOFGG/BK6Ya8i252aOycw3gyZ9Xt0o6fRNTGHXaxXILLnmQUKbyKFyxa/2ETJM27sTRWMHAVRBxhOakp7iq2TnXa1EY3OVtSHo92vnylZbX63wAf1xKcLfAuMuTmWvJiJ7wABi7d3LVaQky5Eu4ncfgym14UsRIxiy2UvrziEX+YxE1lBZaFu1vGUWaxjZ4kKSdXOkTn71GKNPJ3JXVjQWo6gXHCMRMVyFFOiXm7H6yLkK941093RcmztmszxBXA2UR5op8Qa3sTdyj6JXbSw9ZxU6nsWKr2eV9/nESZw3CF/sIhzcgNxUpRQWBst9nNbq4Ggm5JZwNv+8553rNZ/8hBTfSBEn7sKSlGbVTqVvDRHyYMsDPN6IzaO8u5za4w4tVbSsg335SmtP+y+blvDfbvoAV1WKwdnuEt9jvWqf6MvQG93UNFk04cTpSkXe0VsUwcybOum6eDydBofEKNu/aLWK18ZX0HW8vFJqaXiY1vmlOTKmVy9rPLEOCGVFvoprg20Ycu9Gp3NtvbJrC45zkMostSh8DuF2A98SI+GPHdSWy1vO891BEbpt733pajXY1weztzwyYW9g5JmWIRf9wd3iU53TtN16DqWzACzfDJ6n3xbp7sgh+vXVyHzYwi15U6IE8yXh/e8PZyIpOEjTJUVHTObtIp3/ka5rEPHfbNK/Zf9UTFKAiBhy9M4Qs/X3O14aOQa78eFQoZetGPbnukz5LozW7lIyb/UaYdHumYp77kJ4BqFSkmvy9ej7mQsfzr5mea7fPNruZz7u9+H+rQXJ7+vJM6/Ubbfe7iT7zdTU5qQxNJ8ogXeao1xbslpiwxhWw+pQ0lbC6TQ11Hnius615+GLO1uIgGuYAgz6MgR5iDaHGti8G80XM7gvModvE84Rqym2uR0OA5PDipPIiPP/hAEJSP+GAI2Ss63MO9U7CEPLiCKrABFwyDn/s9+RG+wCiG0yIFpVGFG8Mt5ju7LIO+xTms6KO+s9s+0Ks+7Ls57iOTCPS4ZuotHxwSumsHKiQ/AJSUsPA0PlkgUZK89Qs5isOSKJkSH+MSQMu+jFu1bFJDL5S8/1zwv/5ZPDhsvCuUtW6AGATai8ERB8qjJKbQHiSAp6nAQEFSNYJArVw4O+ljkYuaijJBrvnQgzyYREqURAELQfnQLA8EQRKkthNsAhsYGhYYRRsorhlMtzo4nEmphBzcwTIcPD3ksPorwiCsxSHEPyX8Mlu0QLFDwsXiCyK8E+sLvgi0KFU4uyocP3pQxv/LQjhUPPfrwqiwhU/rMb95QinpqKfiFGR7wvSTOC6cNC8kQAQaQM+QsWasQ1F5FAvqBD5EwPTKCDJwhMsDvuiSLvFAxO5rqhnMoPkxkwyMxEqsxEzkKs16pYG0RN/rRIZIwTVYggwQmogURRdQg2bri/8LKwWwIhyM0EHZeUUpgheCo0VXezlfjMJdHLZa1Lx60cWV3LJgHLgrGkbwm7QDEi8fucJnxEL0k0ZW4LtBCcONMiRtEEp+A7P56rhfHEdx+JHHw0klg0YsNIdjQJIW6cMELKKQgKc+KBGmqASKqqduATU4qRmZW8R/pJ/94jmElDY8WANSqcQ/MMiBhMuElEQ9+EASzARLUAISyAANAEwNCJqguYEvEDCRMiugKhytyzuq2ouHarSUVMkhOUDKRCzru8wta0nO7MzBUEk74TDNjELSXEmEmrubzMmo3Mk4ZIx2mcb+A5IwvL/wOzLqgkKMGsa1W0o80T/fLMrYtEL/1VRHO6QS2PS1dnqXZ+Ge/qCepeDKhwI+6XyRjwEq6/xIvTPC+fkxDByFa7NEt3RLuczLShyDuLRLSnwE8tzLS1iDGSAa5glM+SRMJcCD+Pile4oojwyyoxqSyHxJl8QmyxTG0VyR0dzMw5qo5fPMqBDNyURQXjxQOnGH1FxGsmDGZiSoaFS/gAPK2bzGbQTO21RDzLw52lzKeMG1cyS51GTN2KyRZOAye1GjrGQjQLwIi0CC6QEQHsWIiggD7DGRabEXFoGuSQkiQ0tLtbwFMzmu0yMV8YTL9SzP86zShLSES8jSULiEQLiBiNSA+IwAMZ1PoIlBGRQNc+uDQKQK/8G7L04QnG8ETSprQwB90AitUzz1zMX5TCljIHuLRc3sTJaMU5hETQs9VEQtOfNz0XP8BfXwpDflhBBVj1SjVBAlSqMkpcw0PN2M00hNBqcciykRQKhczccrDMlc0Df9Q3WbA+3xHngyH+xRGh31nv1AGv7AD/ywA1d1VeWEBObDHLMcVrUcxDIpvUAAT/McSEIgT0o0T2iVtmgtgyVYAmmTDy11T8EEUy+KADAdUxAgASOIQbFxxPx8gtf6J377z80c0D3NU3iVUwjVU0qaUz61TO3j0HndV3p9yQpN1OHUSWdsvxNdQ0s9WBB1VNlEJSd0DCV0taujEgFtw96cjf89YdGA1cK4yEw/XC8+sFHvkaBY6otZdaPueSOU9Q+lyVU+aNmP/c8qma5r2bkMXIVIjNa7nES4nFaerdYlOAIbUIIdMBW4BBoLQAHBdAClFVOmfYDBrAFoO0gUQdNWqIM1lYZLOUp2jVd7pVcDXdDt5FdxrNeu7dN+DVCuldezLRJDBdh/FdglQyRLhS/6+1DseqqFLTUw21Qh+0Lqi9SmHNV0xNBQ/Z9ay0NPyFdPSK9LYsBKUNOQrYSalZ8TcQqK4NEdrdWUzVx5XFnPZZKWjc6NVAYZQiZlOCvlij1lXQM9MIPx3FloJVo46K/Uq9YjSAEacEHdtQELCCMLSNr/pU0ABBjeAYAApx0BGjDPZnslSEBTq7WDYLChYZqcxRWcdy3b68Xetd1e7jVb7yVbCgRbsc3e7mXbt83Y35zKgZXKRxWuLtlQ29k6+HXCh8WmaZy/yqxXB/LNy7EbOjRVMPwf7EtEPcwew1k5NZ0eRzinYGARWS0EVk2a5qRVzdXR6fnclQVdqACFQ1HMJztdPFJdPTBP1y3hD9RZ2I3d1atd262BGqCBEpiBv8wAL3qeEYhhC1Ba4jUAASheMb1hUwkE40ohNlhTGhKP5rO68iXf7f3atF1iPkUS7R1JJlZb8J1iIzkgLQ5YFX1KaBTDQkJYh92gvMWMEt1HaezQ/8TIX8kTHBlrqG7AETnmNMfztOdDEsBQGnrpC3nsA03Qp6ydweUD1kpYpTVCEhq90Vx1LUbOYww2HK6sNxfZM6NrNhLGSxMmzxQ2FSf4gk722RugAdw9ARcgzN49AOMdzAnQYeEd3h5GgB8O5foMsFY6kSImA1MgHyTKTi+UudNhRGZSUk4q1jrpw0OG4rMFS3etYiv+3rK93xuJ5vNd1McLSkPcLkZ5r9jMVIG7TE/VSPyVMsDgBHJsKGdgpGlGX/WlSirGYw2e0YyQg9XCoTjZF0Aqjpn1taxkVVa1un12ZM3lD9dSBEywNlNQiDy4ZExm3RJ+yGgdA04GZR0IZf8XuAFxLQGMJoFTTuVVbuUDGIAeBukxBRrDjMuSKgT9wGWwgS3sUmYPuzK6QCvFoBII+2BlmLExIdYf68VfNmaWO2ZlJl/xxeJ+NduAk2Ip3mKlvlAAZl+7HaTdicaZMwZS0+aZq18ORQx5icX0+gQZS62xKK8KvTXVXOdI8iD9ZWQ3hKCI8uP+rerfyi+2EeRgqx9VdefLxVxyWoVY2L0RHgMzEARBWOiG7uSHhmhQpoHctehSJukTOAEQAFNYfoASeIAI2OGQNoAEOF6gIa4NXKUTCQOKyGVkea6/4mBgQiA9czHTXW3zerBdim3WrmkXO6tJOV0ao9n94jV2Yif/J+bpVB3fdv1eeGnQo6aEpU5nuHXquVW1YuPmDyrjtaNfyeM+IsxGVU0vchYmYLobdHltASprs47TBDQcXmsvrfzYjGlNMeaUgXmxiLnOrMXIeJxH0RAFLJ0P1x1sM+jvnd1kJ0DsxGbsjG7sG8ZoyNYAy46Av7RskH5wAiheMk2CnwNtCLYsMniE9akG077GzZDt2bbY1jYOrCXdObIhabCjPDsHB8sl0XpxtSCtByu3EQfhs6qLc2sviEVqoy5uHw/q5FZu1jyk9h5RqfIb+u2/2ZzqmORb9RMHZCJgwXiXVATKtfoK7xbrcWlRhZMNtJ7ywOo1R1Dr9WZvUlvH/4FqPI35YPCA8ijfIbGqBmDo62oLwcFuXTMg4RRGbFMZcMVWbIwWzImcgMEsAcCcgI7GbB7maJJugspCqTuoAjXIZZ2Q3py2iqw4PrPsaV5TOUNeJRRap+n04BZ3KZiah/FB9Q3BCVZX9VNfB1Vv9X2IcRB/mEt3Ymf+ceP+G00I74QyICHXQrhOvsciUYU9jyTPqOqeyWBU8nvVbhHfnbLAGwJypPJK3+6IUcV1ZzWiEogSmf3sDEwd98NlxuFUzZOjY9V+MANDOk7k7zWgAtgNcD738z8HdFIeAfnc90MndAV3AAjPbAeQz4rWKlq+A5MCCj/wmlI/rd7g9oj63P/tgQELttU3ahVdBQxQ9z0z8QU2cymtYbAFQwfQWjAFS3VZT/msqXRkaXk2welzqzIELGQer4Qgn2ZGJfciJ3ZiT8r2zjdjaHJmt0kpoaD1skH5xXJql+Nqn2OH2em0Dowoaa0mGTki11iM/d//c41amoZ2d713zwP/lvd4l10Bv/dq/fNQznfgXXC3d/CPhvDhHfhwbYEXRLPKerZBiIVa8iVKiKijOdnNTdmT7Z5aEYEPSPzELwlbHYKJoAiFL66T8j3Kr/zl7W0ZbDaALLrUxaNkIbcZ6nrSknHT+uAcX1BqWa2bD3a8G/Zt+h3qNbVKZfIuHFtaJMDEkLK/r/L/1fkpW1MLczmL1KD1vmI4iZ0kME9FwkBvkbmKN8b6Tsv6wd1JXZKzr7+E+IB3iH5oej/7iVbstFf7jN73t2daCDCAuH/wuR9Mobn7//KvoPCBO6B87GGCo0EBi99R1+pn/gcIPwL7kCn45GCQFwpFMGzIEAUMHkIk5qhIUSKRKBo3VpFypCPIgiK9kLFSck4YNSlV+lEj8I6iQi9jDoJkU9UqU6aC+eopTZk0dOeEEi1a9CfSYjyL2avX9ClUp0PZUTVnNV25rNa2ctOq7SszZ2GXkU1m9qwwY8eIqW2b9i3cX7ZksWL1qyxauaU80Z1b9y8nwHtL+SX1F5c4ctE+/3lqTOlxHT6quIplq7SZunz6Nm/e5tlb5qhUE3e7ai4YqVyqQVWCXKfRp8WN2PRBLK1019y6d4/r7dsr1uD1hLuTaho38uS/g39GV23arl2hpkeqXv0PmjVjsGzn7t0JeBo3xtNYYl48+RLqSYDQ4N59BAfx5R+obx8BfgjuR/C3ceOKGmXA5AZLKkUU0UINIUFbH460VsknON2y1ISWBbPKhK2oogqEDvphh0EHLTSiQghaBJGJKap4IosttogEQjEy0cWMM4p0xkB+2GRTJ52g8qNP0wgZ1DVFOmekUFKJds899BhXlXLL6TYWXlXGdSWWuLxlmCx3WTkXJ2Eexv8Xl3uJWWZffUWTGGOOueZJWGBRicwzoHEmDzyghaMnlMeZZllarL25GkGgrNkMb4lqVVw7izrKKHGQRspblOQwJ1Q11fAiHXV/XCeIHmZox92oTTgxKnrlnddEqundQEIJ78H3wHz33QdBBO/1918TcPgqYBkr5XDBBQ1BxIUclGCyoYa6BHNZNMpE28xP0F6WYYYRtunIhyEm5BBDJIYLEYovkGvuiOWiay5EJZLbrkUwigjDvBUdVCONJJGBEko02TQKwDn15NMwwyx5sJN9MkeZnJXNuZZbEQOa15VoomWWLY41VphgHaMZ5l1btelmH68RgyhXSq1FJ5P97IP/J2h1JuenOlepFkwu287Wh6G3zNbIyShTo+ijkhY9qdELV3q0VURlOt0lkeSxhqdRZzeqdqWCx+p4XLN6nnipwjr2CLLGh18BBqDdAK4W7LcrgG78CiyAVcB7ULLLtqIynX0f+jei1vLt7M05a6sttygxAaO6KDiUroIkSj655O2am4O7B9a7ub0yCpFvFzfmKFNM8ZjOZD5QoZ6wwkoD17CVF0scsZa1b5nmxLiwEmZgY3rM2sZlGkYKaYYD38jOtlGGzDF+tyxPZzJT9tlWxzFrPPKv4URKg7nEKT3RWTU6PtLkl+960ug35xwvP0pdRq96CILGH1nb/x0WO6S3/4OpX7ca9g1OcAJYmY1WEMhPA+rTNg3wB27A8hWAIggHlXTED8rS0FL85rChzYmDK4sdxnTHFsNtiDEyIcgZvOUizLGQcpVLkEPOhbnMrWhFCklIQoQQBB1GZCJD8CEQfXg6zRBxdUZsnWekBDsQyi5LTsQdxXbXuzSlSXjAGx4WE0MW3R2vEXywQ2yqFTgNhuN5qUviM6ZXveFYBVAl9IQX68AXYTgGcLsxH9POlz498tE0TpsGKqqThyuQylP1W0N2rkaFrelPPfxjpNfABkAajO1t77GAAzSAq7aBoIE1cAEoAdQruhFSbi6BEMCcpUGxsLKD1CjLK5kIl7yoxv8s2dJECSlRCNfIIYVyIEgv7dBLNhBzJMWMkbwqsi7LlegJCFoXiZ7ZzB3yMIcpCqIQi8gZIx7RT69j2MNm18Qn3s52IaTLmaooiyme6YrBI95pksFFQWWPEkFTI/P6hrozolGNTYunliakO07EsWeBaV4/8ZhH9B2tN3vs46VqVrN1VGMYUntfr7iDBvphxwwdxVojS0ADSPrvf6k6QQpgZYIBsods7THBrkD5Sf+MEoIRVMkdMIGhDAqulbGs0k+DGrvUyPNKN2NWCd+4rJuUYqk7eiouo7qjXT6oQQ06gxyqwIWt3ouryHwBEij3uMw5s4YmuhNa91nGJj3pfEv/lKU45bKluFgsLxqbozrZSSZ3Ai8aAO1i9ni2FTtyI5/6PGOf/NlGVQCqTSWTDM4Yi7KlLbSyln3ocVjnR4palBCeUoISArGGkRqyo4dcZP4cyb9HOmG1Xyup2MY2SVX9jzwyTULc4BdBk6hhEKPg6Sp9ClShfhCEtuvSE1shF6TegrnNEqhzCSfd5yLVqVT1UI5ABCIaeXVeOMQhDWEQ3gOlNa3dROJVwAnXWc5uriMsKhSFUZh0+m6dUuSrO/0aDXkOj6CBrUTzCGtYpdjpKQld42KVshrWfNERqtHSV2YWDoVilo/iWw5E1UeVI8Xion8oQww8tZ1LnMJqehAt/2pXGzbWkpRVKm4VrFT1ha2t6jy7HQ9NvxCslFjhpr4tWHBhOdwhE3mcRu6FXJ+L5Omu7FnvbVZxIYYtJVNXqW+shEyQh7yBaDdEXy1r5tblss2MeZvnRa/rhHvk3DmxzbXrr8fyit+9JuMc+zUeHP/rPQFvkGWmSyyCEzxCDlEiMqAQ4bQkPOFFU7jC37xshpvGWUG+Lw+W8OgpaCEJE5fqxap1bf9CLcmwkWCkWzs1JOG34yLkWMc83m0hdBpk4oqjyLQGYa1l96UlT8yVVGJzr9dcOCo3y8pJBWwchellfHG1zOU1c1vVp971ullLRHUjcuFLCvrCuS/bhnNj+P8ajNsczjCJE+ZB+dxnePy5n9RKojqYYRdmEG4vPzuMWLriDkhLu6GN/jdEh8JZU1gnFHnIqB6gkYoSgwpVrH3V2FTgYlH3T5LncYGpSarqjevWPEYoAm5DPoUrJCGFatDEIqx161vnWqgehJ0dfR1lX6tZlk7WtXGxfVzG2rK55f45Lq+bZV2OuejOLmKeon2c32jx1+wd587Nqe1yBo/bVWznXa/Y9JF5qGSwic1Z8j1tZlDFwIo9zWToveB781zskQb4wvx9Ybj/e6LrgI4l8s5wjx5C4Qsv8SJZ3IRYWSDGJRhBCUilaiVQvDuqaq15Xvs1jn/B4yK/sclRvrf/fLpcyGR568t9w8HRq7vm3wMn6KmNc2C7V9f7PdSTdRF1KupOHy67ve2PfuZ+vxVjwq52UW8HbqtjPevhZo047LzfK3KrnmA3y2SRM6cnjVH6825GZM3Nhwvec9+6waOTLOV93st97uanu6TQYbroEDwUp8g0MFJBi/nz4v0Gv1/+MoAAB4h0ByOQgAaEWv6AVuSZCiJth6gtwX983AJK0Bh0HMhdXo8lgQ1UwRmgHOd5HixpEQd2oE+JXsOEoAiinj+Nna2tnuo92efVmge+3q7xGq/5w+3h3rOtjtIdmNP9HvBNnV4MX9Z5G+/clYMcXxjV2sjkmfMVzulJ3zI4/8s2GBjg2AycvN7awcb1Kdr4uZVDpRdloZ8XQoo9UNTTTAf8fQMtQIPC1d8pHAJ2iNYhTYAE1EcGYAEY7IAmJZ6pMB4B9k/WiAqNWZzHcZwpSaBHlBxu9RIuZaAGkt4ItpzbRVj4QCJllSAkmt4JXmJZQJjrteAisp4MziANmpfZeZMJ+t7vIZfUZQk69Zfx+SActSJrSIsRulPzIU9fQV8/JZHakV3NTJ9VNENdXMag5Vm6deHchV+jGeP5feFCqYMY1p8a8kKmfAMapqEoRA2oeAoY3IAmKVAMaAd77ADJCaAAakeoIGCNNZ6APGCvEGIhllwKJaJwNSLTVeLoKf9RJOIjCdojI8pcJ3aiI/6jB3Ji6n0eKOae7m2GDZIiCaZgmwXfOXEMK8IiRRofaSwGLTofY+xZoFFPMQRUyiTaYiHGLm4IZBRjlDCjPqokSzKK+lEUKkAj/EGDGSqcpk1HNgqCIGBBCQBgBmCSC9Ch/pAjUW4HOkKe5LGjq81NsLCaO55BBWrCUjxiPerjQFolVlKiojyiJWKiC/rjVYYlP5reJ4JiQqZO0kkUQ04b6z1dtckZEVakXPZVrrFiLWpZhIRdRyYRovniNkQDLlQCSWrbSfbCuyljSz4U+CVmcbykpkAjMFRjNc7fNVqCG4JB/iUeFfhfqZVjHORPUbb/WFIe5QPpFqsRQQW+IzyygVSmUfRVJWyKpSRq5WxyRXCAIFWunJAFJJU0HZHxpmzK5jyaZVme5SiuZe+9pXwZVZdwSQ9e3VzOJfQBZn/dJV7mJULBm/VcT4X4lWfIW2pQ4Txt36Gt0ffxG3oyZjM6JmRK5mTGX9RcpteQ2Px4ptY0nmhWHB/OzdxQYGp+xEeEnAW25j7GJgcZ6IFmZW0+Gj0WJM0tIgtuIEFGqHA2oljMYHHOw8ts6Ia2m1ri4JS84OwtZyo+J7i5YkUOYfGRgizmjBBqWSOICUjuJTtgHxfNqC42Riau3fal3dsRR3qqZ9xFijM+Y2S6JzYonMKF/8IfoBiKUU0m/F3UTI2o3OdIxQB+JuBoruMDyo1/BiiYnqYcEGg+KuiCJqganSlsLuFY6macQGg/rmBv0FqFNmgt3B4/8AM+fKKGvgw2vEyReGguRomIkihRHerswSWKrmjWqeiZbB3zWecQBtSzlEbZqSV4ZhvgcNGd8ej2nQwpZhiG/aijRZozZoo0VuM8fAOrJillWiZmZk2TCoIkLBw2ZqMfomM64ueLRZ5R/opN2YAPVOB/JkFH2MCYFkMaMaiZMquzqmmz8kbnvWmc8qaEVqucXmSDgpPLxEIsYMOehuue9uk+/CmS8EmluGYOGqqW8NeIsuuJxiXvOKrx2f9imKhobIiDtHCdpFohtiDUpSbdM/QCvk3nMhhGz43nF5WCdyImkIrfMiaNZi1mqUqsVByJZJrh+52hTcKq/fwBNpKYJORklepqeQyllkrertbU4pHcsGZEmFYBIiqrnETrSo4PmkKrzm6rhapptVqr6CUDcCJoI/bDNcTCIliCtwLDPPiDuDZtkj6HkaDroKaRiBYGp5Ko1kokHVlRvdbrENLr8UEqyVjnxvScd6ZlLx5swa6Jz9nVXjSY96BRFgYpRE0s3lasaQTsNbjnN4SCrwRCdcSn/cQByF4C4iKuTppWybaYp82WyhZgOzYBBX3pyxbrmLbCstosVg7Ns+7/LOhuZej+LIWuXOnips72AzZcgykswiRMgk7EQt+u6tMWyT5cQ1DoCVKAjyIOml/c6LUdF7x6rbyK7fHIpdCyCbJJqo7yTZ2wm9raqLZM57eRRfY1xsKShnbabR+xkfd+r94qDN+KIRpSox5Enh6WEiIFgshWJsmGyjl2Gm0xHv8Ugf6c7PzO7+RCoLD278s6ZREswioMw+Zy7ucecJsasOimac0RpJvmbM3S45ghLcC0biS03y5AA+2Oq4YWScEMye6qq5TBa9cial8Mb7z6oPGGW9hapPJ+G4yarYPcgo06IZ8IrDMQLPG0XPM2IY8CzaiSH6lWBfjmbfgGrN1p/4pknm8KQBwKjIASrIFnkdirmhj8wq+VDmX98o+rAOLKWt5p9i8A+0cgrIK6KjACoy4EF9Ya0+bohqgDX+u0ymkbJ8qf7sMurMLrAox1VAeQZDC4Ou2ePkd0fPA0bAOQjbDsYa1zWkxeAm8Kk0ILx+iDVHJ0fkIn1CUMx3AM9zDhIMr35gn2GQZ2JoOO5hqPcsIybCFD9VukFTEsHzESH8ljVuMpNEEKsAAmSQAUUwEaUPGrgsrViErj/qHKxoAeQm6vgjF5KIH/DqsORPMR/EcgANnOpjGD1nHoKrDOrmC2qjHpybE27wb0AOoouC4673HBXXAsRObTRu0uDIlhMf/ZGzUymihqJIftJNMiC+Ortrywf1mVQF9nGCkYQonGKF+bKXvyeNoTK6dnnxixpEg0RevRLF8DNKIh/ZlBDVhAAlnADayB3lEmw4lY4f6q496AqN3vij1ubfnHM0vzsCaBG+QdnWCzF2az52bFOLtxuhZoQxKWtJpuT++G7b6MLzxCTaSzdQiuIP1IdICruKIhdAwMhSzysWERpxJvPnsIQTnGPr/iCv+zOGwyJ3PyQVXLkj1vWlrDWrAG2FVvp2qfoUDsEItvRef1K19036aqktKCIJzAT46AExzuIVBmToIUAqIaUk7cUNJvMyszjOFYTMvUTMeB0h5ymdIdNhf/NTe/sWcTbWjnhpH46SjUxFI/guASgmq/LqU1KVRrcO3ugi9giG0fm9bGNSTL6/FhnYPYoj+P9di+8FnDqB3YK80a9CrvCQ7Da2AYITHozA6vZWXFsmJadxFf1kVrdGTS3yFQUlCuIa3uHdYc5crir0qDGpZGdktLkjTblkzPgHzPlA4kgUibAgFvNmd3Nk6n2U/z7GgTLX8TBUWtwzAoNWqzNoK39iN4WGvrwY+k6lRXVG3f9ijcqLUV1c99LVhjl0BgV54JypwRIQsyRnEbty0WdA0jGctI1Ede2yeUTCxiz6dqbysXDXZTdI7jtUWPb7nOn/zZ5C3fQCDcZK0u/1z9JPnUQF7/5e/jqXdJdXF7UzZly1R/zHc0L4Gl+QQCJ2ZWJuNnD7WAgzaZ16ZjwuSC54GCr/mCB8KJGVJrKy0vJCkHYwNtY8gklBu2lFs/W/I+o/UrRipFJkMmD8+Ja9nCNm/MjLAzWOpglZuh8Xn2Lh1tEumO47WSiAaPW/pF6wOdW6P8ITkVCIKmvd8aRo2sNhwaDB55SDao5WF6SzlLw3c0W7YntYBla/l05Hf5CenN9rp/M3CZb7N+N2sScxhqKwIh4AFrq/maO/uJeVZTuzk770Jk6mnTtk/AbDvO+Nzx6jMx9msnH++Ik3K+mvWhH7ei86VcLfcvlvWbRf864nBCjVN3M176RGf67m06GC4ak8zun/oDNvzdwh2Cx0pCrZ7CTjISDWCNpziBrK9YHqp3bQnQbJFafDfQrde3pYWCL3gDqXp5f984aEufgZbpsFOK02SKhqICTDx7gjc7tM+8a1M7tbezbA8yIKFCc/1WJ8SEVwe90FvnHNgrvoY11pU4Eh56QR3auNkMVoPqu8dGJ3ACg0C6YInkr2MFvud7wDoF0lm3Z3h9wCYpNtRCLYArq4a6wZ9jYR8CwjccFYzWlaY3IpGaqzv2bDU5DQzQZJealW/8TGn5BeM3yd+1YgJ7sKN8yoe5V4yznZQ21C64sucBTcw8zD87tb//biCodpMCMqvqPM///BwAvelX8tA3QtEDd+rzto5i57ZtH9M3vWShEVZDGGVksilHxgybuPaQnV0f/t6KPdnru6brNRgyydmjvSu4QuhrLBv6IWnl5E6WChQw9qhJPMWXh0i5yktXOShpfExl+X1jyEP7OvoLMeOvP7GrcRpTQ2iYzjo07Z5CA4IzO/7jwYDo/8sDBJ47eQgSMhjoIMJJCwtGQrULWsRv89btQvVJUUaNjipt5PixEUiQnjxxBPWRZEqVpFjmSkaKEp+QM2nS5GOH06dPuKJ1C/cTWS9ZrIgSY7ZNXNJOnxrZsWPyZJ06lIL1NJcOqTWsW32W48qV/11YsVfJljULtl5aemvVjvXmFm7at/n64YN115Wrb3u/uaJ1SJAZKk52NHEy2MwfNIUR6/mj+LDgJZNpFK582XLmyyVo3PDMubPn0J5ruDA9IgQI1S1Oe25CMNKkVWfJtbPt9fba3Lu3uuvtGzhu3rWHCx/3lZu248qXJ2f+3HlX6c2dQY9O/XrzctRwc+/uPXu5eOPH75vnD196XoPYD3T/Hk4cNwLh02ef8OAi/QwfPXqI7Txsqrmok40MZIqjOfoQCaUGO6pkpZWCgampmiycaSqdWGFGnLKKEaoUWXpB5i1tPqzEKaf8+IiNOkCpSqvpYkwOud9ouxFHs9rSMf8ut2KZRh5/7oJlFlg2SWRIVxBhBDA0oFjisMj0gIIwGk6AMjHHxhCsSsy8bEKz0cTkTAcXLquhs9JIIEG11EZ400zX1vhjodme+Sk44/QsLk/d/OQT0D0FDY9QGbEDr9DvFC0U0ezIK+889PCZZ5X26rt0vvgwtU+ggg66r7//1hl1mov6MzCjjxRkEEIHS6IE1ghVOanCC0XiRCZSciEqqXOucoaYX0LkCahoVKlQxQRbVKUYabKqUbo+gdsxRxt5vBbb3uDxZpddahkSHHBmOfKuJc01pA0oqIxS3XYpq8wJM+SVl7DDwvxys3z1pSGFE0o7wV82OxgYzjVFey3/EDpNcZbQQAH9E0+HoR2U4kUT5cq6RjPOTuOLvXvUPPREBuaRQjbVNFOU71BZU5NXfrnTguwLFZpRq+GFl6U2UnAOVlv9GaVXY1UJFwptvTBXlz5JhkOymAGRWeeKYSrFZO1goxFmGTaU69yq/RrabLO9h+xaarFrlnDFfWMTWMTYAhElmUxj3SjZVbdLGqS0914v9z3zBhL8Da3f0NgkIYI2Cz54zkAWGubOiK2VVnLKIa7c8swnrrg7zqX2+NDtBu1YPJBDFnmeXQZZ0Q2XU34dPtjlm112TQnJCOZQQ+ElImh4UUbnVX1+0EGTfk5JpwWPRlrXondaZmthirZl/8RoqkKx6hS5IMORW6yaETvteAOb/MnZGnsubL4Fd5a0x00EEbjz8gswvHfQG8x4p5TMsMje/ft+ADxYaAKWJjQJTAMZKBiZ5NQQyL2lWpcbnwQ1V8E+ic9zGWRUdEi3wQ5Swx4hhBTq/EERUywiDq5TA+1Y1kLYuc6Fm8pIJ3DGC5v9jkAGIp5HWDU0UPxQebDq4YVusStQRC0rx4BaK4JRxD70gQxR5BkbkOAi7/VEK0nR4sYctbnyfbFH8gAQP4bUPjOGq32MSEQi5peKJq3LS3uzWwD3hSaACXBMBLyMCUyAwDfBSTQ3KMwY8gAGx63igWMxDgUnaEGJaQ6DGv/0osU+KEmOJUcdIhzhyK4xIJOpAYa1E2WmVsjCGLpHEW7omRu+0LOl0LBmFLnZKHRmMh0ODypRWR7zmvjD58XoQ7MiSi+h+MSqbS9rMOoJh5KyDA45E5rcIZ3TqDlJMPLIG9eoBTb4wQ9wEMmMZ3wHONbIRle8QkmGOETd+FYZ/rVzX3ccIB71yK/OmMBfCkzgAgNpmDU0zk7qKMsiGVlQg0LMoBW7oCU7BzqGWsxXmYyHeepSwn508hq7wIQfQHmHUMKuDLAr5UjnE9JTivQOX/gC7voDy4jcsFKQ4MgtcakiIe6yVszyJRJ90stZ6aIVjrhaFKsWBC50r4nKjCb/NZYqTaZuMZJRvabY0iePId0lnJvQ6ibMeCQ6qPEVr5jbvOrGGBVcZglnlScA1+o3O24mBfi0Jx8VtyaDcYYzWMACGBq3iGFMQ6ADbeRBp4VQwxJWUI+0HI0o2cGHiq4d4InoJvuxD3mIcR+xWF0h1FDKk5oUtKRkZWhJq9KUrtSkqEXtHFqpiFBBBEAUsQgtZWrLjxSCVX4IIk5X1IicTAh5TOupT51IVONywaiVcMnTosk0YTgXuk91rnWI06tqdk075YNgkL6ViLaBs31b3Wo537CFLSAJfoc4BN3kxU57nVWtbZUvW9eKV3meQHEguGsJQJPXvfZ1NoENi3AO/1tgxBr4wI4030Ihe5vHQvQ6Es2HPk5n2Wp0ch/XqNQnX/Y605YWxCEerWhHXOI7sHYOKfXoIGA5j73IdhidKBkPRaJbCw2RJjvRCYSap4ysAFUVQT0DG6JYZCpWERJXtF50jdFkJz/ZyU7d4o2qa03zmcUb98CwXe7yhrtwNbxapcMbyJyIcQEBCOcNKyOYBJj9seu98Z3vHekYwDnTQHB4tqsf11RAy9zgMP80pOP+KmBHbos31ELwohWs2EZb7MGU3Ma2ykNRy1720teYBGdNGdIPi1hTnRXxh0ndylKn2MOo/I+LJ+W7E6aSdQmKdW9xbJMX7RhWv3SWKjDRiv9jtSiKXGCCsJHAvaUobSe4mN4vmE2NZkdZutSdslS5hhTybbmbQ/KueLdK5jK3j8znpcMa2XwIJ5G1XThoJ8DyPN8601Nwp0HgXfGFP0ErJBjOguCC/6RozDG6sAlN7KML2lAGR5pG8Kg0RS97jUtbeBQfHfWpJ+5plV4c4yhmLcZNy1oVl9I/sN3LpK7hi1VsOiPCWxFuWV48WxtLaCQxiq9mRcshC5sJQ3jCzruwIg39fCjUY/bQoR3taZPj6NQGX9iw7PC6dFNcXWabVrsq5jeY+R2zSIR54cZmJqHh3OkW+x3JHs8r+c1KANOB4cwUsNXYdZ5/jtI/FTKKQiv/MuAA/7feE0xwvBc8wgN/KPQoTeHKygPDD7fsMBbB0RKr9vGgFfXky3CFEHMc85nXvIkJsjsApQcfrka5yls+E9xaqA+3htUTfes9aRhLuYWoQpGJnYMnVMHnuGbJ7oVO9GgbPenYbaiMJo0jbsXCqtnWNpmpnvVxhTcRbENj9N8mBkaINQ1ZaK/Y21X2O8pZX+/2/mb2bFf58m3udNePL/S99/O9H/7uV3T8++7ovBdYofYfXTMkTGHEX2OiFC8ePMkPVga1SmrzwqDyJC8BNS8MHtABN8/ETOoRHAIYWG0vfCcWFkKmPGrWGMSYdEyoWO+XbgEjFOEMZi8Fcw4G/2Dg9lTEl2KwJXwP+ESHi5buksBnRsoCHXgwFoahFnbBXKJvE7zN2zbhHcYprMJpjcwo6+hgC9LMzBgh+6AgC7RPXXCgXcBv/LrQzryw/EggA9gtjuplMATtn/QjoCpoR9pw/viu/hoNDgfr/t7QcorBGebC8PKhqgRwGiLutDBOtBqQEAtRpaYAAhMx806rw3In5KBh5PiB5FDhhGas5S4RikSQBHfCp2SqCobgE3WuBV1w2J6Cx34o6J7t92qwOkIHB6mj/aRjG2YRHZShFvVtGrrFXBBhjZgv+o4QCZ2PCcfNCbWKEbouLxgBDdKAGbUQB7BQBbjw+3YgGtXqfv+qMRq9r8/sKoEUqN0w4wzD8d4OKRZ3Qy3uAf7Q0Q4Rjf7mUP7q8B3hMR7lsYKQgUSybML0IR6AxNIe7sL+cGVQzQARcPOaIAIP0gsQMREV8gsS8hAtD/MmsD78AxWAARK76cVmyxJbzpiUC0Ggoog0BAVzjgVbUARI8fZMQiek57miS8pY0RWD7zlmUSv07fVu0seUwR6H4QcNYQiN8AinLgnDKazIzbuy6hit7/oYAV2qUAtloPvSLu3gCxursiq9L2AmYAL0C+7WCs4CjQrUDxMmIZHSkdLUES3XUS3XUf/o0R0TrR3d8oLsER/1sQ8tjVRKrmQEstQO0i8nwwH/GVIhAdMhr0ARJRB3CMKj+kMPKNEi06ObBGQDbUu3WsQjZ+rnIGHHHpAkecAkX4AHoqALRhNCOkEclqupmGYVX/IGX9EabNImlyknZ3MnY4EWfhIomW/qwCysxOwXzcvMxEXMxCANrm8Jk/IKrzALVcAZm9M5mbNdoJEL+WvPvI8K8Abs7CYsw9Fxeq346I9swlM8x1Ph1NE22DEu09Pv0jMtzXMe/24t984bmuEeyeOv9tAPc9EX2IPyRswQLW4BAxPjBpNADbNAIXIRZahTGpN3vgEjoWEyz+AM/IAM5CDJEGQpaOVBgu0JfMD2YMADQlQIRPMpOPE0VVM1twgm/6XNNWcSNmPTeoKB/XxhRn8wE24UN4Py6qhuCV8BfpIyCqUwq6DQJ9mI3AzBJ4kzC2QAKrNgBWRgBbSPSZMTSp80OZ00G8uuj8oOSiIDDaZEDw5BD7STSwip7kjEDclTTdUUPONTPQNOctyULdKSDtPUTtO0HeDhPOeTLgUsAC3N/65BPxkvpQpQAf8SQQfUQA8z8w7UUQmTURP0UhoiEnbhG7IhG0JvEDqLQsngQmcCe0wRinbuQ0MgRE9yRMPADzjRe5IBNVHUFTumRZFuB19U33zBemgUFeyuiU5uEQABWA1hzNjGCK3uKMmNzaoPzdCM+Xh0E5LVEJTS65BTBv+yQAuudEmt9Qd+gEm7tUq/Txvz7G7mJezqRhzNdBDWD9HodE3z0V3ZdCzQ807l9D3l1D3bdF7PcR2foU9pET/97/94chhMwRQgAZT6M1IBE1EXVVEV9VEP9CEFk5UgsBE5JT4moRrwIRv4ARomAZQqNMkggfXqAJmeCLmQIAheQGVFQAQuAFVnb1U1ZFeULdlmUBVdkpmWSYv0rVemzMd8xSYFFldXgWhpyVcXYhH+oA2uUAvEIDfLrJzEalrfZlmZdQvKjEfLyeu4bguaVlutFWyZFs20gFuZdAU2YAO0Em3jK96+LzLUhVznRQXGNdDiwJDUlV3LU5PeFWApTDz/ewTg8hVf/Q1P3VReBXdf6RMP2+9f/fYteHInN8xQ/RNBE9UQGfZhMTdzE3ZiP61iVcYSuEkSTUENQHYVsAe5LJPIUHZlW/YCLuADVPYFQ+LnIoQkiEJEfA9noQlndXZnc1JoifYWipaW+GM/kpavojQLxC03vUqsfjQpq/Zqi/VIspa8kPRatZVsmTH7ytZbZSBtFWAC0vYEptNt3xZu0xd9y1Re/ildW+EZ0LE99XZv+xbTLmvC/BRw9y1i9tV/D/d87nVd6UGAA3iAyZOAw1NfF9geq6JP3bVvH7eBi7a2ODVAD5VzFzZiN5eDI7VzL24gJzASgAEfOJYQQGks/ym02IDtyFA2ZVUWJUezZzRzJZXNVWeWJYlOd5nMuZAN6HKhVR1YV02OeMcShSxlEcCgEPhKr5zgKc3raY3yebdWeoGynNaIR5fwSLiWGb2WbMv2bFfgbBWAjNW2fDeA7KyTTNUXLLFzDN7YbgNBEzQBGdo1k/SQb+3Xcc+Sf+WR0uZ0XgsYgBfYLAm5kPNWhA44LXVhcR/4fvcYcuyxiFPugzXYcjfYUSEQEZWggwm0MDmTEEmLECxVUx/hWFKXhaVidS2zEDSz10ZBeE1OqZiruWrZlm3ZiG5K5mp4eIuYAxdBE454IFZopPSqGnGgapdVN6d1a4N0WaH4F3+UCP+3zbvgBwqJ8weYEQi++Huf9GzRdgOiUQvNF16qcVzpxY0jA47jYD9IJH/3NpHH034Pz2/fGYL4954Li37Tci76GU8OF4IEV4HTQpAJmWzyFJAJOoTmNDx5QnH5ry7peVsiGRmEN8h4DdYu2GE3GpM1t5M/mqM/eRFDKxbQYxhmRQ6ALfd26qLxUIhnVCd9d3dveTWXqbmMSEOSqoh6uXj1oz04y/Emr7POIAaUoBo34Em3tWqNkJmrz5nRbHrH7YqT8hipWJuV+muV2nvB1znVBSvpbG7FDg0EYQ/U683YNxyBmY7tOJ7Ls57pWY/J4577OBwUma3ZGnEHWqELeq//ETqB2/Wv0TJqFFff+FaCK9rXxpK2cGdFEBJiOXpRIfWjN7kIDlSkIVsCK9IiNmqOYZmRZdOlG1i0Q5u0Z5qma1pFbTqmY1qne/qIOUtCrUC2ryAG1KDOYgBgwFmMu5VZyayqmxmqn1rcrtiaxwxIsTmbvzgNxrZqu/VJq7ValfOrKyN9zYBu1Au7zXpdyvQM14A91lof31lN8Tiuy3uA+/iu9Vqew3tb8tmg9zq94TtP43tNS+Gz6XIbAFAd8PewERsTNKGVS3N1htqSPdrApSAJDDTBF5zBKRvBG/zBPXmDMdswPa0QFoESiZZGewInH7o6mmu0j6G0T/vDUXsm/2UTeJ1FJ3laxnx6qGPABmJcxmd8vzJgAkoAbZk0meGGGcUgSZlRBpJZmaH2iqX6muGGi8UguJ25SnEgutEAGm/cbeEWytsAWK88uyXB3Lr7jevWfQfBF6rh0vJYvPsPgiX6kfXavSXMzA17vdmbHf9Yzuc3vev8zflWuUikX+8ZHbdhghMbwDGRwBP2wAvd0CPcCBwc0SF8CT75sh18wjnVPzwbV5+pxC9dxIGFpu0xNUncxDs8xQfWtTVzqFMwBlBgxlEABfRp1d8kAzRgARQAnL93WXtcm3VcyIfcyNnsDdToin3zuJV1q520OalAzqgRbvXAyq0cy7N7D74Unf+7fJ3lgyBQgR/NW67vvJ75237lGi7aPM3Jpi7jus/jdaETGb7bul3Fm921PbwhJN/2HILo8s/nmBIEXUIHnVEfcLIjm9H/HeAVvNEV8tEV1tDnw5R5FbQxndM/vOEd3tObydI//XtUfBpKxeR0xlLyHcZtQNU//tVD3gJE3gFKXtaR2luFHAfohm6AAJmdXKuBACiDnRi5jfrMa5vRrEplIHvBwH7KzksBIw3Ua2mXFhCYMTAEY/ukvW7X2T8AkMzh3NDYITy33d29XX+rHtu1vtsD+nDtHOyjPo/hnU97kCYlmYkYOe3nmCPzPbYP89DjnoMD/t9F+ggacuA7GWb/v3sVFr4VOaimI37iTdxFQ11oZQwSOmyoZfzjV10DLADyI7/kTV4CHICMc/y5cT37lhsIssDlnTvIdf0Xex2K1Wy8xixauW65oRtsbV05qTJ9jb7owRYMrDVd3Ni9mv7LVwFIxB7r+dzNr15/ybtxpf6tBZDOzz3s173d2VuPh2UWH2gYOtEW7Dvtfe30JvSJ3j6KFlLuv3/R6Z7uE7IwDR4wJdvfu9/nvJM++fXvWZPwpUvwWfF7eFIaanSxcavUGV/VAUKCBoEWJBg8aPBBwgkKNjjcIEMGDhxAgKTJAiUNEIpAInqU8SMkkC1v6CRCZDKRSpWMTjJitEVMzJkx/0NqaXPokKGch9KggQI0aNAsaLIYJQpmBZijSqkEdTrGSVSpccbAsYonzyNf8fTl8/q1a9h49sp6O4v2bLxr99reS7stLjt4Y82qu8vWrdd+fPuBlQd4rD6/fP/aPUy3XtnDeus6ftz4r2R9pSq1GvasGDLMqjRR0gRaVStdpD038iOnj2oyrFmreR3GypXZtKdIsV07t24luHcn6X37t/DhxIsfWeIFOfDlvmM79wNpdLPpzrhZp3Yde3Xt3Ld7Z7YMfHjxzsZ/595tujRl69cPez9s1SRIg+4Mgn3Dhn4U/FFI8G+BBv5lQCCBBWUggQIMNfRQRBuBFFEaaUzkEf8OH4FU0UglpZTIJpu4RFOIEoqhBSA7SWLIiTkBhUaLQrGY1EQrrJCFDEdhBBUVU+m441RrZPXIKmxNJlaRbYUDl1ryXMMWk2dtplk3dz2G15B79VVYLYGFdWWXjjG2WGNijklmZER+pYojqkxHGjKlgWbLaMeQ1oppqq3WmmvONcccn34aB2igyx2R3BKG9slbcWG4Bh1oUD6TXaTdTXoeeeZdSil17bHHHnzyYVJfIfjpZ0N/GaDwwEAaqCpQgQU+oECssTpkoYUgCSXjRB3V6mCGWmyBEkor0SHTTIYUG1MaMaWYYk4q/mSGGTiqQC21SqFxbVFtbAutGTl+2+P/j1ihsk65hhlpJDxJJvZWWo8iE9e5TqrrTWBYYnlmvum6FWaZZOorWL5pWhafdKPFOadmB5uW2hlnyMFGxA47vKdsf14saMYaE4roFxx3bEUVizJaiSa6wAtppZKurHKmLVuj6aa+zDzfIqH68VoRpPJ3KoABrgr0zwT9l8GsDUmE9ERB4VCtCjJGtIJHP4CkRdVitMTIschunaxMiLwE9kuSHALti05PdBRO2wLCtiDcersjj+FSlceP5Jq7z75gHpnWvElSx4w06gyWN2SA3Ys4wAGHxW6//i4OeeSSdVbIZdK5eTCUxIzmGWoNy/GwnhVbHBzGpm+MOsiqk34b/xmv9aEmyilr4x3Ltr9cnqXfbSqzLzXffIcaSew8As8FpboqCgUKveoIBU4A/YzSS7QBUNSesMMJJ8iI64UjpojsiMp2PT7WjLjCSCqpuJLKIVBIJdTa2+Ikxh5s3w/I/GDsD65Vc/uvBz2YqysDFAs6DpiYdSnQXQprBl3OVKR9YMkf9zrXuRyXj709TnL/AtgoNFEIgl0GcwbbXJ0wUYmHQWyFbBDZw0bHOt8o6nQ0TN3qYogbPfXBZLK7He2uM7sfugxT3YlZ73z3CPqEqgxMnE1+SsUC5yHoZwIi0ICAJsUSQO8h0uviRKRCg+xpT2m4Ylr1cJAF8alRJmp8Sf8iXOES9rmCfamYkBPiVz+d8CQNJhrb/W7Cvxy9z1twG8P7DOmjTlRjGghER7mahECZoWxdeUEgWeKCOXhFcEtWmiAFP1k4yNCrcfzC4AbNpDgiraIzmFjFKooxH8tpjpWgUWGeRKan1tywhojqZaAOVYTS+XKYznEd7HgYRB8qkxpEVFnK3DOzaH4wVPbxA87wMzz9FE95CHKVFIsHzhKQQJwToNUGpHfOpuhIKk4I4zrZ2c4TTEB72zNDT0jEtZm0pEOveMUb55iNV2SDfYKAUbQk5Cxm8eR+bXBRINdAyGgVckcT3QoqoskpSQaDc6M5meCU1DgDsmMbbiqGdKb/tKW2HA5xoCzMlgyzrlKakoOpVNwoVhGLJU2iFYvARCtJeMLQqAZiVShqC114S5EJ04ZMbSowl7pLqIbMdROrXJSos8xkClEcunOmeqAZzflQ0z5uaGIZaPNEF0CRm80L5zhnIM64loBWXpyRCuCJ17zSQHsTGOf2JLQT8IHNa4zop2EFOkdXCDQVjCioHnqCBj7ukY+SZahD96fOH0ULkXh9n6Gs0okgqSKWPv2gaGh52p1GCaX7uuSTbiGnbWwyYJ6s4EsZB7OvnrKDNVVcLKoxD3xgIxY99WlpORoaELKwCk+oAhtCV9ToBtOp1G3qcYwwvOrKsKrRCcamlJnV/90ZETNgnRkqRjEJQow1eFdhYhNyk1ZwuvWt9I2BDWIQgxLsYL/tPCc8/QfgAH9hDF841AnGqQJ7hm3BLTmsYQE6x/YdIgs5YQRCL4yT/JXIsvZrERrualCJDvKQYARBCgjVGjtEzA4svpMjShad04rGux+9JAILiA5McrQYsiWSBH+cuB/v60luKs8zFGM4mvZWX9jwBz744Q9sIKO4xgWNT5OLM6IigQtHjW5zh+CDGShVu2TO2BFuUGbmUNVhIcRpe7YKxDjDec5who+dwXpR+ag3K2Rtr1nNCkwd1GAGpFKrWotnA3EmGr/4VUITsABpaj2aiX5uL4ALjGlDhf8xjGZIw/kK22B+emgWDhZoNr6Rvp9UtqEXmd+2buLqnIzNj3BzyohFXGtD1YADJs4BEn4NbCS84AVb7gKLYdyKm8r4FjxmpFpuPECSbrQyM67XbVcqZJde0LXXMekxpjOX3Sp5yfl4MpTxgY9rWKK4Qa2yT1ETumJ3gQn09rW9c2ADXg4zzdPt98f8jV2mJseFjaKxVuUMs/Bah3fPIK+nTDGJ342V0pau9FmdKOgwu2C+iVY0oycNaZAHuOIjJ3CmNe2ENqwPffwsNakdHOE9ACUnI7qRUWAd61nPuqGCjKjcwHhgE0TABK3j8hOOHuxik8GayC6Z0z8x45k1cur/dyFhaC7DSE5me+vXdguRqUEnHod73KhUKbn5cW608+MaNisElatMOdCxAelGpbt0rXBxfSeK39Xtdw3ZrIhRfBfhhKezEJ/ZcN55KuLp1QoeLN5nAFfFz9mNr6E7vugYXGEHm8eCe6VC8chLfuSZ3jQUDPES9DkYHO8Ax8sNG1BGkA0KkSXbhGzUapujwX687z3PofKUWq9zrxmIAAdqMIgqV+LFzGe6I6x5Jxc/X/rKZo+zqb6eOj39Mkq6NlhCqTd6haM8YXeguMkNMHSb+8nC/UOpzuB24/IUhA5jbi7Z/Br2XjzffO8/wP8PgHtHTExncLWzcIVneD8EKe+R/3jTgGeBkET1IYGhV1b24Xh6sAgQyGd5xxv54YEfiF+PdgUhV3J5EHn2gRUlWGCPtl8q0AaIkFiKNQvg4HrvYIPv8HIB9Qqy9zYs8mqt1gY3YRTy03se1i1HOGJUIEYGYgE3MAmm8EqwJYWsRIUhBH19sHR4smKwoybMFg3RsB5/M22nYRneNQxZtySQ1Frhlx7ktznfdmTnR3b6on5qp3bYsAhQVAVuJx8fhEL1B3+FIIETVwVhBgMs4AP+x3f8538j4xz2AQm+8GYIqHALqHjR9B4Sd4KbSAgBFAkRFwl/sGeUt3ea1wScVxuPBmkj12d3kIJjoAev+CMBNBUeuP8DVGAIidVPs2CDrIeDNJiDr+AK9yRiDTWErnaM3NJQRnhZzVhr9LQqDlABTgiFUSiF10iFogEKkPAJ2+h0y6diRrd0L/YJnXBTBrcppEEJIQQaOLUZ11clRqKGU6IYX0dCcCiH6CcYdWiHaIcNlnAGvjYEcXBTGZiBouJC+QcbIZMD/BECHnABEMkCGiNVimhd+xZwUhUGjSKJbZhwlPiRcIZJ0ORw8IEKnziKk6eSrfgIoBiKL5lefqYG7+VonzVpnbeKrNiKrsiTJhh5o0iTm5ZgL7GLvEhqR4mUrjBQtHAsPDchRaEtvoeMHraMzHhQEtUGnqU9JBCNECABNrD/CKYwMxtFltg4hTKGltpYCVpobC12TJfTHmNIhibzSpN0QPPiN8+WQOJ3j99WHTKVj+OGblDWj2jnD6KwCGdQiGrweAr5G0QAmUegcSwAAy/wkBdgEBfQABTgAYyIQxVpkaEZgMmxkYEnFyGJmuOQmkA0ie3hgGcYTefVkikZB4K4gT1JCKD4hJZgCpaAkreZf6Mncqzok5vIk1jheJe2X/hFLadXWIa1CUc5ag+GPjmBEYSUEXtAWUCoP/ojCFaJayK2BAfGlQoBAQfwlYOAU2T5hiaUC+95lmp5J6Bglt7YCCzGGmzAhcimOX/Iha00GpjBSNd3mjFVjyOVGcZw/zC/0AsoA5iBKTnBNZj9mA1QBg27cB8zgG+Q2ZAmgIge2gIeagIP6QEFgZkUwAApygAhgGZ6J5ov2hvW9ITS4JEgWXgklR7S8JrQVI2/yWeDeJtA0pIvKZa82ZsoSZsXWJwUB0A/epzH6ZMqWBVKwGjY44LPGVC9SGrR+WCM1RNA4RMHlVD543sL1WHgiYRNcAIaYHwKgQAH0ADpuZ7t6Z7w6Z5kGXdbaAfkGJ/gGI76mRqW0VHvpkJtBpd3Rl5yoZfiN35zYgtXt1ojhWQQajjA4GQTWpj88A2ikAdFgAIzUDwnigGjKiAmBgKsIgGbqaIpWgAs6qIwihvXNZqgmf+RwKEG0OFmNaqrq6mAUrIpOzqWfRiB9ZGcTgqkWuGSRlqkn8h4BvkHk/CstPmKxtqkKfik7cWT7zWTzLk9jJANrueLNpiUc5Q1kLVQPKFQa6NHKpITe2CV39ktKkADIxoB9fqmBVAADWACd5BndCoMvUAnuGCnCSOFoHCfc1dsdbCnZYiNdoKFgMqF0beFbTZjmsEZ3lVkX5UOcJGgQVUKDFodSCKyDypuYrILEjqhFcoPFfoN+AAMnVoqo7qZ+eqVqtIBQXOeKioA+cqqiPiqZdaisyq0tbpLbdZDvLqrqskpYBiGr+k7BalEPqmkjkesUwuBEVekWXukkWCkXBv/CUuak1VhgrSJm2NrnMFzkyHoNIXVeq3Hize4peQ6Nll5rpJFWWvTLDo3NvDqYW5zCILgWPPaledpADwbAvw6M/4KsP/qr8FAsG9yGvfZYiUzY9cYsJ2xlrYEqAjLZanxloNqucSQMH45foinoNTGCqK7gPWyl27RDknmL5Fwsvxoh+r3sp6nBCGgqvhKs17ZphWQs6sqvCFABD8Lq7QagESLaaXjBm7nUVhlox9pDtPbtNCEXpporBpYtXs2trOJtVoLvr65bupFgdZatsgptdh6gquoAmoABtZiCK9wg6xHajY4na6wE2Fqt2LKneuqc3vAt33Lt96ypmx6rwTA/7srirjsmQyN68AMzLgCa6fZCHVUaLEFo31ZxkLiSAaBSrnbt2ykCykim6CsACcC66AjSw/t8LolW0oZyAsSSpgri3YtCw2o8FhjcAQYULgJvKrnGbzCu5mYSXTGe7z/hpEa8wVzEHgdyR7Um7QIV6BNSzOhNazGmnyPwL17psWKoMVf/MUXFb7LGopxEJwV56Toa7ZpHKSehwVgEGkJFr9w+4uvp1j4mz9KoT/7k4z3kwl5C8CXFZ4EfGDFN7MInMAicAclNB6j68gP7MhlCZ8yto0Pe0ypa4ZjyUrLl2Wcq5/M9xlXlzkZC25oMR2sVArVpqirrMKkpEH2AAlhOf+7taupNswLp3AIsWgCDYCvAVAAvsy7PSzMP4wBIeCzV8CBn3mRyiuAy5zEs7qRuJpR5MBVSCvFIymJsSCbYnWsw3rFZnvFYDykY9yjGQgbV3GtS9q9bLySZTWT7xzHYDDHOFjHMFcLiNBQ2QKVRBiE+JMJc/sHPwEuOUID+WHAcIrIwfwBYRCFDezQfnkpjvvIE/249VkZD/trXPC5vnDBwdoZDyuOgZpcmdMmV2XKJUwJn9GgGiu9JIwWowTT9AhCySe72IANLfsN0JDT0AAM7SOKXyB0rPrLO0vUPqyiXmnMYkYb2KTMztzMREscSKwcsSrVTw3VGUmaTBwdT6z/DEyrmgl4gCOpo/EhrOHsvQYZzl6cm2DsxYOw1q6UtXDdmwbZzrD4o+l713htm+vbNFEzz0j5YP2EPoZAhIFQe/jjz35cle10i2AEdFx50AcQzApNBnMa0RStMJgtupEsyZzjsBEDqOxouY6buJkL2p6b0pR7WiArwjmaoE9XsYgn2waKGOoAGvfxGlqhB177t6EQQLG4AynQAYQ71EWd0Ly8mRXAay2QiOccPEydZk9lHNI91bJ61VU9tKWT1YrwCegIxXFWuteso9NQxc3qzeb9xW2tCECi1l2sXkMaluRM1+zMxqOI1218xmDgaNSSBXTwtlpqWC9xLDtBpsoI/wj/jHqxgNj4853Dt2nitFda1JUILczHXdkSfdkPrdkbrrgLCrBqGUKp7Xx8eo5kyTCbyweXnMqpzKCLW8oktHyU+7yoiXiSauPTa+MaiDPEkwInVgM2eQPCfcjAbNy9G6cBAqJS8DrQkV45M2bR/cxWPSgZad3Z3W9eMAdZHjvncEDUbM0knHCYRN5ljd6Md1NW7N5ureZmfbWMp7Wr4JvOet/rPOf0zZOu6MZYwJwqAAiuEK5GSWpwlDUlUiJq48dfIwqxgAii8M8L/ns78FYGAtnHE7yTndAXEAWjwNFdxeGd/sgBG3aSjKe05Bkg3FGlkdIbjNqcsOKewOImXf9SpqHSKw0vm8FMs/3d3z3TsAFmPX6qGMCZvTaiu2vpxIzkIGoDBGeoUOgHrvPkR3zd2B3tyatm0dzEXP7V0RvmcfGa17tTPrVT13vmab294rzWZ92sJxmW6F2sJmjXU0vnbSyIeb55zBm/sPDfbttPJ1E/VpNh95Mip4AItXDPecvgLaLn3RSNg+uVFF7s+Zrpm57hzITZRebpF5/ZC0rJoUzSjuoZqp7ikavSsb2A6hi5H5vZ7wK9uZ7tghhC9ccDQiDcl4miys0BxG7sNXuzSR3z9GZMMQZbvrBKakAGUS7lwEHd017dVF7lVg7VXgD1Wu4IBpe04e3aGysXTnv/5uB+5t7+ide73mkt9mfNrKgA3+xO3+0e77XZzm4AaduaX2CACPxAgzcIt+QKPoCwYQD/x4t+Cga/4AjfBJRur9LY8A5f4byL6U/4hbkz8Y38bY9M8ZA/+RjvyC1+6p2x2m0C6hfNB6f9yY0Q4yp9VSYl63RZ0qQcM9Xc+HOCQi+vmKA688CeojVv7ByA+zufPB86BNEViJTLnvGRuU1NkUt/1b0k1U2v9Msf9dYueNjuDSxcDuHtDmB+9TJzjeHe9ck27mKffFm85ujOrJ2AgXHerGq/zhaI/niw12xfFa8RcvjV57BQ9/l+lCyBCIjd6H7MNgBhKBOgPQXbEBSE/wYNlR0OGhx4CEGiRIgHClzESEAjRgpCIPlqxszZMpIlTR5DmRIlNZYtVZ4c6fKlMZrEdAnrdTOnrVI9farCpbMV0KGsiBZDybNUoz512DytY4fP1D6UKpXK2YpYT6aNrg69iVRsNJEhyYpUWQlToUJ9zlipIgRGCA8SLlBg8DBvXgweRrgA3ILF4BAoBg+JS4aMH7ZfbwU7O8xXq0KKq0hJYiTzZs6dPWuesgT06NCkRR85Ivp0atZFXJM2/RozbM5ewty+zfjxOd7WunEDzs1b8N/Ftw2X1ltasFujnLdaBTb6dOePBikaRCj7du7ZrS+aFD6Q+EedyH/Xjj0PHv/27d3feb/+PXw1ceCDUaNGyY4TYBDxgwUccN4h8J0B39lkE1cSQaRBRAyBUBIJCTqIIAvbaAOMLLIAQyEw+JOgIr0qsigjEw3gyCOQzoKpxZlchDEZm2ak0SalfOKEq6t+2qlHoG7MaSxVPrGqKTmOhIoPr37SxJGuHAMLJWSmHEvGXILCZS223nqLh7nouivMu/wiArP84LLBhzRzSCy3qtg6ikWzRvGDDLhowzNPPVXjs7U+V9PMT0EHlY0223LDbjdzyhmHuHDSeTRS446jVBprkJJuKOpQQaW667pbhDtIviPvj/DMe0QPQsBDTzv53Hs11vjggM8+W+OoD4v//WLor5ZZBDzwwHdmITYRYxl0EMIIL7TwQg89jCGDEUmc9sSNUlRkxRhjpFKmbWsE90arxrWKRx93MmqpIpeEjLnmPimEEqqQPFJJco30ascew3L3yiGBGhWSLbv0EgYRLjh4Lh4QC8ONWu84887LFOvDj4qdjPMssywd5S07PysNZCX2DNk02/okdLSUC2WZtNsOZeyj5CSlueZFK62UyiilhK7TULsTNWhSxUO1VVdlnfXhpAtx+Fb7sAADCyz4Q6OWAMGZxcACiX1lQWMbrCVssJdttmxA0Ego6hJCLLFtt6018QIY/FhFzm3RWgnvF2MM95d01SWXEnNxEqqo/3SZYgMJJLqww5HH+gWLJ6aoeqoqI+utSpOlfPKRSXgrAZ3pMxSTK4fCFkYUu1Y/Ff0Mtyq23DG8tfGtdmmGwQS3kkUm+c+Q+fS9tZZXHr740HDTTZmZaXZ00ptzjinvbn2ZLLyAP7UOe6NZjSRVVY1+VT2kx5BvjffIp7VpppvGtb4dVBCkFmANBBbrV449tkEGwxbbkGYHAkQmBIgQhWBhbW9DINwyQgEY3KFu3oLg3SL4IsJVECfpalLgBGeUX1jQg39TFxJeEIQPvIBxjvjEc9KilHXBjl5JsteSiDLDIYWOLa+LyxNy8AQrMOY7oxoSEAXWGCLma1wcLAtZGv9lu+TgTmJX4N1somiaJZjhC8Bbgm1QA6jX3AA1wtOT8XZnppitqHnOQ6NxghO96AVjMtG53nWy5x3w5eE73wNf0vSIvj3eKhBYcF8TwCAJftTPfg16wxYUqUgtAGILiERELRDhilooKxOGQMQlBQhAD2EhAw5J4LVQJEoBXEtu2arSBE3CRgnKyJVYgmW6OKHBWWKlgxRMSi9AyIpK1ImEIhghGTb4IyTSKCigk9flEgdDJdnyKMwR2BDdQjomME6Ikwii9TCxzW2CTnONaZInenIljT3PedPwxSDuNMWR9Q40VUyFJa6IxeAFyjQ12CI+8QTGQR1qDoxRxfLSCKn/gTbPJXiD3DaHxio6BgJoD0Xa+PqoNPY5DZC6AgMtCgmgrzFyCz/QAiO1MNKQPvJBhpBkg0SByUxkUiAEjJq0QjnTUW6kAQ184Oxa+S2cvNJKfmMFUH9RS1rasiYn6ZssaNhLqcjwMTUsV1BphKljgiKD9FJcVBoxzmI0URreDJ3rnnKGQmACjtuk4b+6udZvehOJZBEozpqITjes05131UM2siGIfaJMB2D0K/HEiBk7hYExzYirOQuqxjWycjLuGkUc43g0iIoPPpadj3vGwMfMps+iTcuP1P5Ai2zw4xuuMIQYRgpS1gKhtauFrRgglMlMXrK2A1mEIP6whgPS/7Sm1yplcB8SAjXkVJXH5WkFdymuwI2zF8mtybmC8tRcQG5IUeWgUIR0E15aZSpRqZxVgNIusG5JDopBIXXS+i/27nJwShSHYis1jWtUoxqrsCs79VuDJaQiG98YA39Pk8XA2tMIOuCiPvMZRpbZBr1l7WpiKUXQgjqjsW187HSsE7CfURai6ZHoRDl7Ps9WNA5rkFoZsCCIb5zWfyOVQWt/AISPfnTGHyVpG0gqkAdpMhYvzdBCeutbUpLypsVN5U6h20FZ5si9zVVqT1n5LbG4qxjU1S4spTvDpKpLKkkyYjRt+DqzRqdwkYslmqWbRHM+Dx3Hoa9kTKGfwd6VT/9jEIReU0HPBC/YwH7+a50FpTvDQqIVXlUshRXtDsZeeCw6W4U2o/nh+KgHO5elaIk7m2lOaxoOkWhxKg6RBh0DQQaLfEOqF2lj1mohCyOtEEFe6j+CoCEQCxlBtRQI3CIzgLijYBFy9wYjJivVquJENgiJWkssrXLKSIU2v7IcpH1x1xPJ3KC0qX0lptoBKk9Ry7FvWDHoPA5yaz4qVaWHM960uzdXHkpl6CxYO4vmEtlwxTfekY0xYFHAgFbwnwXOYEMdKlESXmyjHT09dym0w+yhLMQjGr5OJ23Ensb4iS9BC1pICEM6FsMWUj3yVbs2ticvG26hJdMRDaDXu97/iAe+MAptCXunF2wysnW+c2bbIkjOfna6xSJ0XIIrKarw7sWK6a/qioTb3baDmEP3JnM/NpXtWvejN8ZueLwb6RY7b5uiQO9653Xf2UiFGZzA5z4fOFABB3SdXXaEB3cCJDhbdMJrx8bpgWWtD1UaZtdz6YtX/FWcBW3FbRWKjv9BtwaR7cjfkNpFtvrkHzdbkBUSA7b5VrgmCm4pOxAGYNs8RuIwSbGXvXqeE9Xn6Q46lYtudNoPiRSDYy/TG/4JIpVi0mAvBHNWZCmtTy8kz9gYXLlO/FsowklN4UL0nyJ2ud91DPomENpdcQg99OnffQUU3AfLz9nYJnkIV2Pe/y/87Clxt5vbsc+lN41p+iuefCH+QuI5LR9LnMISqtIDyCOIkCNAAry8V3M1DNmQCtmDTvIkXcsIz3O5URq9Sag5mjC9aDO21Suq1osyV0qiDMybdPOg6CrBoosl3js2cQKiTsiFgPmctmgcVRi+dukWOTk+5NsGxJoZ5SC+z/E2qJC+6ZsYxCC/evu3JTgEYSEQcEg71Qi4gZPC6iu48is0X5gGH9Q7hYs9lPCU62ALE5u/+iu8EsO/jHsYV4mES4gEAEQbD1nAjzu5H1jABNyQBMSQZ2GIIZPA0PPDmLsCCzQLlsBA6UkuHGmhGHoS1suRWwK6gyLEEVQlopuJff/JpRL8m6qyvXkpF4EZs4upG2XAQeXbOrnyKmiCui6YviF8iuijprggO3dagjGghQKxRVfQg7WjAYJbMPETtCOEizLKQrxjNC7kwilrv6H4mbrKjzJoRsWDRv2rFYpDw4tblT8AQD0wHzPgRirwRm5EgzuENQR8tQWMQ81zQBJIgJn6vOCawHc0JSl4hHYRQTbym9XjxK5YRNZzxBB8REhcMhPcFyYbyM5Zrk0MgoRMSLCKwdehOeURRX9ENHfjjceqIej7tlVUxSHcyMSoprH7IinarwGzt2xgwuzrvtMQP5X0RZYpEyq0woaBMC0sxposDoNav0pURi05Ey7xNGr/jEYxBMpqnEY7UhUU2ywnUEpv/EYPyZANAQNXC0cOgUoFREchs4A+bJs/FCUMOAJMuMBhC7p7nKXAUcR9dL0PlBHUA8i2ND3aM0Gfk8u5NEhjcy8+SJwXACZxEzdvi7rd0BgenMh4eDOLhDqNtIzE7EhX/MgiBEmRhEkBm8VUOEkCwUXJ7LO2+yI1cY00AcbBKrSHRD+c3LtBfDa/48nLsALcyD9aGcpOYx9nDMpMM8ratM2kxM3N2sY1wEYwCIQ2WATgDMfh1LyrxDUIIDIEckd4zIsomMcpyUC86SCi0kcNQkvO6ceSoJ2WyEm3jMTZsxHV4yC6pMuDRMS8FAFI/1DBqbOY84uM21EedHiziowsInmdLyNCxfQCVdRPMqimV3zMuBMj/kqNO0sFWywQcDgEPptCBQu0zozMkNSi0BxNYyxNneIZ1KwTj9mM+nAa2HQYPwAt2SyD2SxKO7KOPDAV7bgVFUsxWpGaNTADFTUVbOzNW3PKDtFDDfkQmYK53yoyI/PKQWgF75xEo+DADkzLZvtH7nTSJ93OIyVB5RpP8wQS97o975I+hgQFJ0EhgUkhiBTTs3gX+7zPOZAKxczPxuwCj3TTNoXTAJXQQiHQXUwBLuITKKBMBH2HbzCDXYRCPxO4XuTMX2wwmFEEGqzQRku+oBMKhcKVJDBC1f98CxKdTUuFmIqiqFjBo05N0fQhUUu1zWscj1vzzQ5B1VRNVSqYgHU0AAj80ZdrAAmwASK1uSglCbJkREa8PbUEQSgF1u6EoBPsskycy3Gy0ibz0nwJN/X0UrWiQSvrBBW0TzRtKmtNU4pRDMScmDj1Vsb01pc8whvA0wIlUP6iASjIBj7NhgUFVO9bAgeVVwil13r9RURZhUUtxYXrllzaydR8U5/UVBD10Loa0S+QP/hQQ09tlUx1xtbEVIlb2FIdD1XtkBW4WG/cAQ1AgOQE0h+VgBywVeTylgviuSy1S6WSBaFiUqAjTWHF1dS7JQvyqSs11iq9ESbB0hUEU0//bFbem9b17FIvdSFsxdb+RFqPBNc3BUnVlNMBNVfVoIFDWFcExcVdfNcGdbu/elAItYEB9aJBQ5QImzDmsR1GZaVM2cmBSYwc+NoihCJpLLGDdZgrgtgT9R7v6Z5OzVTWxNSKGlWKXdVUVQEViBqGYDmPfRvmFBFaJVK2bFJWYtmUVVnyJMiWDcGYDdb1k9yZlbJKrNxkzVmcNc/ycj5HgBMuvTbUtdYztQNrtdbETNpvpV2mFVdBS4EFu9N3ndqqtUVa6D6s/TMHHQ2uNd6uLR7PFCMkG8aytdBGHcFMQatQyQ+PqSYb0KFJXc1KrVuKKti6vdtpLA88CgVUMJq+//XbiJVYo/mj9o1RqEkx+OVDUdLKXpvVWu3XYO3cyr1cYj3Bsli/duBORmGJANbcn/JfwiHP8Zxcy1UzBmZPLz3dCZZg1pWKf8Jgo/W22bVdNqiCpV3apr1dMSLJeJVaGnCCPUVQWmCIetpaljxe5A1be6VhCVWD4GtevNtX6NUbmogctVoL682h7PWShSmT2xjYDzXYL5iDuzVKTkEF/4Ni8aAPQlPf9b3GhtrGRThcNcCPJpAaNNhYBOrYjw2l5aypWS2CkY3c/U1guPxVAF6iOSbgxqpjOj7gN45Ly+3fPk6qnKjgQBbkiyHkDNZgxRidpGVT213kSXXkkHw73f81YX06YSegWgQFB2hQO96d5EGN4RoOSX2aYT8LRt0IRVPcQR68SdPUSdTUEotJZI/coVl2W/PrXml8xvpoTYXtBGjghV+GYk751J5sGIiVTSzO4sCVUaR83xglAcU1Y65M4woggkUwrjiGXGijy5rV4xnZTjxmlDsWYFwV55zs5hP03HSe0kpkDEGO4PY02kJ23bDj4Ea2548UAjYd4eHJXTw1YalN4ZN0Qijg3e871830Ws6U4YX+zBtu57KqGzeCSORQZfjEUGTw4fUqIsUcgiI2HcMwrBQFMffI5V0mBD3oBF7w5V+WYgBsj4dF4vBVZocaDzqKA4e66d18Gqn/iZYSQWPGZUdpvl9rxlBhw0QtO2c5htkBvuMALolzTmoQhGObcAQMdudA/id4dl2jfRmkxeevvud8FmsiGGuEFtBIpuQTRuEltEVwQLsWBp5Am+E08aK6/uRRRt5z5aKJyQ/ZJSs4iQ4qSQ5xGNOuYjjrqk8iguVXpGU2GITwiITuYagWzWWFjWKVhoZqAGbzfZUltluZpqyTDu3bNJ/1iJqnUYIRcACX+zygjuYgvRZaNauizubv/CA+jmooNeDd/mZcjWpKFEvwtGoKzmovbU+mMOTkjt2uhgtGNkKwfm7oJuvpRo0emNO4K+ECxdoU9t0mrAVBWDswsmu8nte7/z4w66Y3QsNnHRqrzGlBc8M6hpPeIPo9WK5eptEE77AEU+BvU5Bs8Ig/XRbwR7jszGbponFYz5ZpieXbibOV8jntA/rp+pVmCpSAJCDqNo5EBT5IyxVI2ttcO+btPP7t4FayZSju4U5x5WZxQ65nWY5u6S5rs6bxUDawTr7TI9hd0bBkYRkQJwxeKMTrIb/rT47Xf6vTluGSgN1WJIm+xkFdq5qhKoOs53i/Kw8V7omOWODy/l6F/pZspilt+oCPAmfpVOAFVOgeovSswB1tBz+xMW8CjoVH14btCu9KJKPtkr1cyuVfdV5nbA7xcu5tcy5xE9/zVcrgCYZnWEbuFv/HYC943SXnaOceOxm/dOrWdPQWVIbW6xOexUtO0HalgU9Ha3od7641b3xi9b02k4hh8sRgxUmH8rLaJvWKrGya3lP58ljg7y73dVMI9v32b1ZZRkxLaQP/5ZRGFfZ42FveVDcfbT8isfUwIAhYzlKi8I14R21HkVn1g0m4ZlUSzw7f5kA3ukFXdxL/8P+tx+NadEN2Pnl/nTkwv+W2d8e09Bjn934ngtzN3RrH7ty10yS3J9XIsx8fkG/IA4MW0FU/coc/7+o+8ioMDRFOTHqm3fa+GFvn9efgb2Tw8i4X9pEH8y/f7/+GlVDAhnnI7JUu36Oc2zZ/85oPsfiQUSX/yMpsj1Ve83lvR5EQINL8bcs+Xy4/PnSmFmBCD3E+7+YTb2NIl/pIf/F973ci3vSsD3g1ackF00zMNINDSAVsWFcFBdSHv2sfmHh8AnhWd/tTJ+ViDoNYT0x7T9P9rIK/vnWQp57pEHZgF3mTH3liJ3yUn2wHAgZggHlUyEY2X1/xsfkPPR8ZzTWfr3O4wfMgFfoLHMty//OkL0T9XXd2L3H2O/Gpb3FtxfvVd9MYh8Ws7+iyln2xBvjat25OR40ZHrBdTI2V5GQUNoNL+Aa008yEpmu3R/5Sf/tJTuu8Pp4yeMWutozhVgvzcA7JGAZ0yn7s534u93XvH/ZgD//C/y98lOfs7PC/zZb5Em1zZBZpBndNie0jpNz5Cs98nofH1maBQag5gNDmbOCygsmM2UrIaqHCXw6FQTR28BixihYvUjQ4cSO1jh4JeizHLSRJgSA1SoyIMWVGgyeZwXyJsqXLOTZv4swZxqaXnmS6+KwSZSgTIkKPIkV6xOiQpk6fQhUidSnVFFOrzuih1UiRIze+1qix5MjYsFy9mhU7dgnbtmNO/WlrhEZatF3t6khr9evesHr9ksWbN7CUnWGkDD38k4yaQYU6QY4MOdawypYv+6JMGRllU51jmQotejRp0assnT49CdWj1p1Q7Tolm3WeO1/gxMldezehPIQUtf/uLZw38Tu7dRvHjUf3mjU3GhAQIH069ejVrUs3gN269uzRCzQYMSkYspcnITZ8qJLjyvYzP7IvKXL+OJP2789c794jTZfw3/sHkxc3DThHgYYRqNhiSiEV1VM2NOigDxIKkYJVV2nFg4YZZkjYV2UtRZdgH4Yol1xlLJGCiF952BWLVA0Wo1h91UAjYC22+IWOc9wBiWOQoRJkZsqgg44yvFw2zZCY7ZIZaJ6BplloT5Zm2miWWLIaKnq8BlsooZwCGZe1KUecmcH9tlxxayZXpptjgFDAdQNcV6d3dm4XnQQ+YFKeefklpB5L8Q1aKICHytfRSPP9F+Chhjb6H37/iBZkYIJ2MMaTggtyWlSEVUDYFINMkbqhqadieCGHq27loqtmsRWYDmedRZeJt+JF66syAgaWXyqCCOKNMhIWhm2PwHZKbMPwYuQu1SDJC5K7NOlkk9Ra9tlpVJbGbZXfChnkl53o4Vu5d5Rp7h9nHtfmGGq2G6+aueHmXAV44stdAHniu+cilf2Jkn79EWwooY8ek+iiC0fqKMIHxxRxwwWdh2lQF2968adHPfgpjKVSOKFRFi7VgqqoskpsinWpDCKwatHAloq76uoir4OVtfKvwgLWKlWFTaHjI7FNy0s11QQJbSdGT8vsNNhe9llnnoWWiWjebptalVqLK+2W/2jCO9y6wzlWdpvzhs0mcvU2EWe+eHbH73f8SlDFv34GvB97Bu9dcKMpKRzwxH/77bDhCPtkh6U9ZdzpxiI/NepdIFOO8hEnp5x5EmqFOHOtMgKLK1lyuUpzVxMSW3KKwY41M8vDFutGJNJSS7u0yqACrTKdZAs1s1BLKeWUVGKNpZWRIM+1uEG2dnbYgYCd5rHOo019u8rB0cRzcs5Jp9xvwy3BGeM1M6lMhffd38AWDR54+wQTrndLgiOO8U9T2K/x4/tXTgTkI1sucyjLCurCoqKX8exFYkHLWg64lgfWrHQ2kxFY9kKDvVjwcrDLVWB0dIdk2c52R2oW8H5Xwv+rZU15KvwW13gBQhc2713oepe6oEe25eDGDTp8U9p6SK8yjEF7IIAO+Ir4vbl5QA2rwBv98sO3jaxvP4MTyfuqmDAnQuxwEntP/vRHlC9yzGOhklCo/ldAAZ4RjSmzFWAaeJYYCStmHoKgBBVog5vNynULRAtgbMTBn13hC4QAUwhpt7Sl1S6RigxeJqJEtdEUb4XL85JseBGJQeAwXcJB03DatEPrUe+HOdSeDUagAQscoHveM+IR54aCQAAMJObD4hNTIqgoNrEkVoxfLeVHsS0+CijCBKMXicm/BvEAVGnsnxoJyAJnQvNGF3qZH/EYq2u2BVYvqlnq4HjBy3n/ro3V/BggvQAHPUgLGuqEljqZVjTgwTN4ndnWkyK5Cq35IjW+8JrXaIM9Tdrwhv8EZfVm+E9SmvKUEUDAKr3XUO5BlJXfCc/ddPlL/mQEl1BMj37WMxCGVXGXh3MPLmdZDMIN05iSO6anlBkyZjZzgNFsgTjJYhWd2bFXFlpZYDwXQdN183Kr0ylRi4q6u3gQTKGQTCfW2c4QLlIUlPmSZ6wGJX2CyxSLQM0kKbk86f1zkwLN5ECrdz0ZAhGhFqiAAyCg0AQ49KES7RcLKmoe+9CSbwyRRaA06j4tApaXUOxlYA+lUlKJMYwsfekyRSbTmUI2snicLBx/atkRscx1/8LSbDWXmYTPKqEMeTiFJYoAgxx8tgx/MBo2nvpOakkVW1ASHgpZyFUrTfVLuyDXucLqG04WVJTMqQ0NDRpEEyW0AcqFAALaylC5svJOdmoAn5iYS8IqpBQc9SVIRSrS9JEUI99NBmJXutjFpqqx6o0sCpzZ3mje0aiUpWAbL1tHa9qIRgeUb1BvINpLouiOOWBBEv4Qi6OtE6pR1QyV8mnbbzGYtLRRBCg5Cb3g+pa4bDtuNk3pXOUegKEiHnEr5+qdC9yAfBbFKEaf+Avt7vWW6LvueLFbMI/WuLw/2/F5GQtTxz42yDN475CfCdn5xne+n9vmTyfbuQXG7ICd3f8giZYAh0hINRJX0FAIPICCG+AhWdiYBzaAQbtKLkueD+aaVdXMPLBmWKxnLWtzyHrczoGgA2tlLp9D/FA/Q9fE1fGXdd/XHpXslRWCAhCOFyXYjlxxcODVaBYBC0Vj8jjTOm6pS328XtQZGbJEZm+ok+wCJJv6jHa8L1AFo8dpfvObp+ZvZYE4ttT6oMshIMttLAGMb7TWzAt2M7hQc4nZRvhLY5rhbTQJ3DnTmaw6AmeeMcBnEPtZThHVV4nnKgElLPEljmaxLWXsEBgnBH3owQX7mjgoQ5ObJuHlLjALtmlMd7rHMPXfp09FasnStLGoVjKTWV3ZGsEKWDPbKcn/aI0VrljZNvFVQl70bIIUdFkHa/B1a6Eh7Nf+jqoPHp4iRSOmNjXbOL99drQzKcN33dmAC2UAA+aWbW3jPNAmjtt0xFfoccdbPX09914nQrihW7rRSa/0jWv5MJrcO+r9E+O++w3wUWcF6wAfuKrhOPGDG/x1fTSLHh1eayAG8go3GPKugagDGISAwOe8xCmcCnJvFQ+SJZ/EyY+VcpWPaawDDaKdYc7hC3IAAjXP+c7rtC/HP37QZ9iMLIG+UaI/ZLtP7+vSJVJjG6u785duKeWkru/08juN/37sCNwb8FC/ntaz7vrXDR52Wdl0vxf8Zgpmb3bCNEHtRWjMuyxR/8lyUZyANght3Tv+tEU+MquNfNYuqHrJGOrQg4BfueBHmUMdedDwJqpRBNiaym03Hv1vO4DPfy5YXCB9fXnrBecnxrdHE/bpoX86GElPIf8/gah8iqepnpDN1HtpnZG1XuxxXaqtWsFZlli8HcNh0IrUiBz53ti9zoc0gRC13Rj4Gi1ICy+IgiB4oAWEQBmEAtEkWJppy7dMX+1QFd/1FtqhC3DIWScZVPalFfi5Rfh1YPCxBV2QgCkREXVEnqCxkgVslfvNX/5JWv3hn+hxxBTuX/4BjqeZHv8Q4Op5YdaN2mktIAPKXgYqWQSJCGYZ1e71nhmeIWgJ0axdAQieAv8t1AI2wIX2rNUIzCEYBILxtVawyZZueQtVlVxo8B0Ogd8nqQtwGZcN+uCtnAjhBeEOfEURSoAEDABDVUcSqt8nFlEOkI+fPEN3WWFhxcS6RdoTAs7RLRoqttgV7p8W/s/pVZ3rwd7V4eIuXlwulqED+kpl2ZcEeogFIhzCNdzOoBqtTFseLeASCMIpHMIaDKGppd3mhGBrYQtVcWMsWM1UDSLyJOIO7hD3OeJBdSCK4AoEuUUHxswlxkAJyGMJOMD51cknLp6JocAgUF4p+qM/0hgsggS7eZ67PYTRZVTm4ZhAyiLTTYQZAWDqTd1EMhYvfmEChiHsjaEG5oUbHmP/MEKgffUeBvXRyuyeMf7iNqGIhSSUBoCAC2BBEM1jEWbAntlkEWzcJQCDIFZflk1JbMGW9U3ChdlGUZbjypWLDnofJDYjV5BIzJAOWMjjJc6kBjAXKOLL+nmHBRRCLP0jQOZSvTnKpCgdKyqk5oUUKw5WQ2YELQpYvvUfRUrkRU7IF/LiGCaj8jVgwJUkzmzTTcnKjJTkwsmaR+plX85Kh7XeS57A2jUmVMYjCuyZZHZAe4XWGPyhO3mNKEwfUMIWlowjuiyisz1CUvbGQdlgOkalU4bTWEjla96AJUpltV0AiN2jnOTjbYJHzjVAEjDYVwJnQMZH5UGaShgkFCXa/0EypFqyJcH834YEIET6WBcOWKgR2XUWGTThJRiyAHZu50aa4VTypWGqDudUkMxIYGfRxUjuF3mSZxHciguYwDsW4UuSwA1QgRm0jcW5ZBvCpHIY2E7yJAkeIvKcJiTeoFiZ5vWgnY6sZpX5hTF+3YfApq/cZ1h4ALbtJs7lpm5u6AXwQI8skTR4wzSUKImSaDSo6IpaA4uuKKXgh0BUWnEKHbrZQiuK5XKuZXNuxKfBZXROp9X9W0YO6QhcZy8+08Ut5mIa5qxd6NrNGkhaIIxAnOv4UVkQ5lD94mHWmmLmmUtGgAbE5g4glEvCpM7IYR5wXLB9XJaB5oX1IBDpxv8mLaiG8aCDXiMaapNr1l7pVBnEKQHpGCHNaWg+4iOhEmptvsAQNMYiLNFloGikRqo4tGiOBg4svlgpaEIpUIKiQcSK6WheTZrTRYUZBRB0uiWQqWp3cmd2tqovJqmrWuesIqkpKWmTRikFJZDYjQ6UcSRJcp1HSqITsMWXgoAJ1CcJDKH2fMVK6pkHoKBlXpmZedwIioIpIM/Y/FAZqIHh/VZSJuVSqiOeghZI6mpdjGkSxEC5BmolUqKc3llyKR6IGeqdLF6iUkBtKuppMYGx+EgrjEK4KYOkbkPBlk9/bNF94NUqktsvUEIjNAK6JSxzouK8WWyh9BtUCFgApar/kFVnrO5ikXankbLkkpKssfonruYRStqFBaEpR6Jp2amsfHVYzDTHBc0nsxppf9qsB5osCryXEmwcmikbUX5f8MkpaepB9ixit44rhAKVazIjHaUd0sLrhhke4bXOKSHqhnpt1+arvl4AtHqACPArUOwEcFSCKrAteURDik6si7bo3B7sSdntRyxKpj6sxMZo3YrqWJ7PqGKhkFYnLXqKdK4qrSpu1skqrJZsrSpp5BqrtXHAsRZhMF5oyqYkH/FqHxUmMM7sHKVI+dWATCqcCZSfnrmVWgRfjYyhydpAExiY9RnogapB1cbkcJkL0+Zp77LrksXmsOKuavZg7jaH/x/mwRoIhx6YQbi2rup27b1Gb9iObfXq2gvwawAKk+L0QSFUwtpCRi5UBEwM7Nsqg/lSKvrK7SqOREXwFdJd6ovuKEKCatOB3kNy7AA5Rf4SruOGbAJapOs+ruQaK9fSXOXeqjymLMt2Lma9rAGpxZRt7ov07JeaxTvSRQHTALGeGluc2us+IxaoaSgIQrYaKCUKbSBdLW+8S1PCofD9Lge2q/CmI7cWb+4abw2B6w4zLzXGTJ4RkfQiathSLgaQbZfxqxAEgfZu72JwL8R6Aih8QtuyaKSewzmkr4vebSlSBP158UN8xPrKr19R4cUajMfyb6nuLxr7WwCLLDIK8P/FoeyXshW9HvCxymzo/mLriEjvrecfb2nnQmbPnsCxNsHNJqvsOkcGMKlsKrA8xqQf/sEk127y8i4WzPBR/hAMu0qe/uk1CmFb6Eg6LqXx/lCd6XC58LAqN+/SCpEBg61yEbER6xqSaggTJ0VQNHH3UtgUuy2JFgk5SEP5Skwz2G0x6EIywx9BjiXdjvH8Au553C9JJe6qbuwap3E1x1TjXiSyErAcFzAHiLO+xrKX+efntgAb0WwZriewBjJ5xqexnsBx0cAJYCKYKtST2kAJ3NEO5Cclm/Akk0kHBlJMOi1qvpEPuAgo324N4zC8OoETYO0po3Kd2VAgCDRGZzT/D0eCHmw0KxdrHc9yEXvZscYde95yAKr0SuvP9t6EH4DvLfgC7gzsTJcvebitiiqz+IrvRcltfeg0NCMsxcpbFF2EARbugKlxNiM1N7NqN9PUN9PxOIu0He8mAyBw5nYufzHwr5DdBerxzNos+YlzmFqlC5TACNDnPS9mRDvyhxwvGmg0JWM008YkQSOoDgnLHUFcnDo0RWdtRQcC8l50YRc2XW90Ryu2RwM0K4M0WRtx9dJyLSOxhZxqEl9FFxUITKutL8s0TqvvLYg2T/e03J6vM/9tGQs1NEtWG+vvXDK1/2YIyRoZAC+uVE81W1V1hz5eA5ySfdrzHtMsHytj/89w6db5HlewbhDFsVj8MAicwDyjARakdeuVACIbaQbQwB9M9xogNl23sLsSL0FT3EKP5l3jsClXNCrr8Fy7N0YHdGMvtiUwdnwztkcfgmMztwmQrfVStmWLIao6BdyJ4dnmz+IcSKb4QR9ALBXjNE6PtmhX8TBT6mmL8TE7pOBSmkWw8WHG9odr88fKNsjiNlXb5LV1LYdCQJjapxvuHmWps5XOSFfvpdgF7/ghK1uQgAbU5CkdcjzOY4+jYD1qQAeuARoQNnhTInlX4mqqsLda8nqDgWCPzXfPN0CbMPIYT5bXt2IHtGOHgh7Q9yXV9xoEWHfq2mQTOIAPkIUccf+BS4X9GEhLcwEbPPHDfu/3TrGDD2yKWviFh+pqCzoxIHdSF27GLnX/3vaI4yUBP2sdQ7odp3h2rLgGaDVHDlyKyPgxSjCmO9xcHF4Gp24+X64LkGlEj0BbtZWYumN+HrlcC/TNunWgznA1ciBALa9hH7aVl3CWa/mW/zpo9rqvY0mXRwIqaLmYb8myJyWZn6YR9AB/j21lDxhmm8qaw90Rm/OFIAXjNE6ncAoZdK8jgC8Vn3afozsxW3iGp7YZQ4RdRhZsT4WQbjOjK+7JgnNuQ7oESPqk4xwtj6cGrqdfmGFeGndY0x7J4GxZxNwSNK8TkMCoNwGSyycj0wDFV1v/BjiBIKBBdHdg83K8GVDByA8yEdIkI/ezkQ82Xfd6CQvCriN2yxM7sNN8zc98RyO7r4v5ziu7Cb+3bbC5ZcddgCdp3IVAnqW5tm87tyeGZoc7p/TBE3O2+P5yn5/Dugc1uw/6qHZ419N7vYfsXQ5wvpu4qldAA/B7vy+X+eEmVrd4eM6ePkvgi6NkBjrg3YNu2QFq5VqZW39pCeyAPSvUAYxA8wb+5Va3pQO+Ezz8rNtzcNPkA5j9df/BJVyCy0+yIFh+Jmw+lmC+JeyB54s+8si8zZt+sAt7zus8lin7uNy8z+OBjnAI0QM4ZZe00mPAB3iA7i+9UQSNtzNG/iyG/52Hux1ALLl79i9n8TO7u9avhNd3eMeCfey9alRLddnrNgSkPYqvvTiLcxCDR1bn6pai88G/c66SpK2wRRAZK8zQxeBfWwU8qWzWpANYAAnMM7FaYj0XMkBoIHHChAYNESAkbHDggIMRVNBIOpXqkqBLlyRmApQpkyWPgiyG9Fhxj6WSI1GmnJSSZUs9kWDGjIQKJk09Lz3K1LlTzyM4X8IQSQEjxFCiR0Mk9bCUA1OnGDh8wEBBhIiiQ4lImbI1KBkvX8FWCdvFq1c7Z8mmJTOnzxxHn+B+uhUsWl27xZYdI5Y32d6+fv8K+8uXsF7Dhw3PUMxiMQ/HjR9D9tGD8v9ky0SGYHasmbMQz5Elh27BGLRoxiOGmlCtumlr1xVgN5AgW2HthBwMHlxYgLfsDiBMuBBeowYN4sORH1+SYvlx58mfR5eOnEaKI9WXEDeyZMmY7WOc1Ah+ojgVJyUsOHAg8IaT8OydoKFCwuBAJ1CcHEQYAQTBDA/2Q4Ah2tbLYIc1JKHlG1d4yYijBy+y6CIIJxzppItayhDDlkLJaaeYbPpQxA/xAEoIpZIi6qkVmZIqqgtYJO0IrcaqUawb1yorRy7SCoLHsxwJEq5cxFGmSLwAG0xJaghzhpknoSxMymNKq9LKyyrDMjMtO8vSS9NGu5K0MVcrE7gzI3gNttn/YrPNNqhau4CB3hio4EwSoCsBOhqMm06HPP0M9LnmlOvOO+NWQwgEiKgw7r8RmjBjPgjSs+AESU/IVFP9IjDAAP0MCnBAASVQr0AsEqRF1VQcfHCkDSncMENTNKzVI5pA/NAmXEeUCaeZIsnjpyIUCwEqNuFU81gY4VwKxqqWgsG6KKjFrFocmcDRLDtsZIPHtNACkhS56porsFyUBIzJKKdsl8oxsYRXzC+57PIzevEFM0zIUDMzUTSVva3NN2tLNjY6cVttID3ztE7QP6GD+GHomIvuOyNAUDRjRfHk8wb6ciu1tv40JQ9AURfY7+QEWE6o5ZZdvhSNPSaqhZZW/0mqcMILZbXVZ5RA4rUmXT3sFVhUaELaJmGTQAEFZg1eUSoXl40RK85mxBasMHL0Itxv1fKWLG/ZqKOPt4bMRRW5zL1LSreddPeveenOt95q77VbX3n57tdfZStdE1mCBxYYzt16+w04F8jbc2KJIX88Oocp14478TjgD4SBdqhuBM4d1c1UgUb4r4QdVIBChZUjeGCDEzh1YIJM/xv1ZEpPcC/1TFS1WaOKgNe5Z5YwpHX444//dWije1X6kVtnopUQQsqQgoWpqAYc6u1FgPHZaKWNTGttvWbLDrHDTv9bcdm+RZwj4b6rmbjZlbtuvk2zV/+899W7/75H4y8Bgv/gNwU0mOACJ7iCIfA3FaDAnBJ3Jzw5LnKAilgFL6gc6/TJOdzJDuYiQAL3hC4DkALJeUZHA9WV4AG5SZ0KYNe6CcxwZQ1RwQrAAEPT4QdUGTidecAws95RpEKxEp7PRHHEligtFHroEPOM5kSP4ORXQntiHoAyFKlNhXvf8+KKruKYItCIWlbYGli4pSOwnYWNbRxbIzzRPmXMcY50sSO74ocYwtzPf/Tan/76CMAAkik1AkwY4BIIlTQpsHACE9gDeRPBCWYQg5SUXAdTMx0P9mlzBHSZyzRwg87tQE/rGQinBJSAE8CQdqwTkAEiMMPZ6VADJ5iAylIWS9plAFX/3/iG7ySxsyNyREMdMl6HlOiSQ3RCaJZYSdGeCc1oWkKKqHCiFGUyoQ7poQziIaABVySBp3wPRSuS1rWu5TWusUWN4CofWc4HT3ABqRJw6UTb5JdHPCIGNFfjo5W2FNA/BlKQhCzkAA+pPQYykqGGOxwE51QnCVrykhOrmOU0WBwPjpA7fUoPAhRySoHkjpSuTGUGZujDTKlgdS97wAlwQIJYzk5TuPQULDvVkBhAJEG/ZFURjWiSYgoPmbC6hPF4VTSlLpWpTmwmiIo4EWpi0ZuvYZEHxOmUcobAKtGSV9a4FoY5hNVGX0ljG9G6Rrb4QUjm8sVbi0FHffLTn3Ul/6j4BJpXe/3zf/AiQQr+itCEItICBzRsIx9osIUsJAAR3JwLKldRyVLOOpHtoBM+2B0z0KCFB5kAFfYABZAtTAVZ2AHrSoADMJxgAbecAA6ywFqWtRYHOFDBLVM2ARWgwZYnu+krYdYenv4SmDjrSDI7lMSiahNpRUUJrp4KxaIl15jVfQl1J3KKQ2BEu9T8wggGm9WtlumqHkCKamBgLTSOVUdldSda0aKWeQZJSGm7Yz7tGAwWhA9/fPWSXvkXr70VFLAHFSzACntYBS8UAw5dU4N5IwDHTpLCFJ1sdbRTHOUMyj016ECazMDbUtbSUaxjVCsdcLrbpqxlMN3ABv9o2DoWt0y3tnzhLYE72wMYCIhO2IPNbJbdYCI3qNRVYii2W02i0SqbTO2QVHElVQkpN7vaPcQhWKVdPYCXgOh1mrEK+LesNuu84VPvV8jqXjeqM41mbad828vWQkCCzqNYhVvzS+C7DhTAAr5rXwd4JkGHGZwLNjRUEuvQRSYkwhJugOYmWGELT1o8lT6OwzR5uU5pgKMmsylI1zPDVeqpdjlGAA0n8DoagnTGM9YtFGIKoAQ0ZHYLOKlMHwAGQACiFrAobpGBauQnV7m7KYHyc3nBCw+J4hRUfmIkLjKR5UpVm6K4mXarfOVm/6E6FvjcDIqglAtIKynE+s1yOgD/p8d6OWupEYIaTLQ1RXTiEexls5vb7DU4a23f2jrbnDGhilFMQhV67us/s/WEPs/r0gUVjoEPXOh0H5riDW6TsiAayfVMlNIdz/DEPAjCUGJ2lCs2lexGHerUsrS3s00ZC1OmgQ2oFgcyluEqNyBrUeMAdirNAAJmCwFa71TXpwByLTKyEZ4Nc0LJBsbTV9UzXkDDuR55OkpOAXWnIzPryZa21WmBXWJnOcvAE8QNElyGSLQAzFcoQ1GwCBxhFQQqJsjDH76MgiugQg3upp68kUZvVHTC3vd+p77b61509ghHcgjrGQzu34XndcAHt3ygB515iSdy4go1tKI6z9jG//rm2zaQtMelw0nsBMoIGu2oCeLjqN1CIaUohSkWYG7rzwKiDTtw7X9mLtsWywAHMMZtjF85gAmYtgQlA1CpQU30ILbBEK7wqSRoZkRTxCrZZGc2MLY9EmBAI/xgBwb0vA52ZJ5f/Mq29s2ifbOok10PazgdRm5wmyac4u3pLsMaVEMQmgADTOAUBOGbPGAEQuEUrgfueGEQ3A0VFCFbouALHqET7gAomMne2CnfFG/x0oLfbkThwEbhIs/y/Gzy/AsFBwnixOybNKewwCz0Kq6hbBA20k09RE8AaKOETg/1nGMoPEc8OGhQCuVQ/oo+9qME0IClSgClas9UBuDUnv8w1arwZGSNZTzFxVgOt7QQuHBr5gwhC7wQ6HQsxWIgBgwEEHzp+igkqNIP66zNAMWP/GDlFKAB/MRPuS5CD7OuiM6Pd77O6+BPUpoAIjKmATjt7PRPFPCuKeAgD4CD2wiw2diu3DqkAVmAEKjJ3YLFMyqQ3rZGAt0M387qA0EwFXmEBEnwBFnwblQwBQnKBDzHBTPvm2DQgBLM8zzPwXyRkRqNIcSp9EpvsoTQ0jIpCC3m9T6sThDiUxZGU56QxU7Gh2ZIAWhq1XIKp3LrAawwU2BMC1uNZWaoC7NQC6cwAUrlAQ5kBdrA6IKMDyHkQZ6Oyq6NI8LO6rau2lSFD/3/sA/dLxCb7vvmcBGs7Q/Q4BLMgD5KRQMWS4TWYADFaQkqQgf8bwwm8QsI0COO4Ey+ACT2ywNuIBDwYO3CJxK+IAhA8XnkzQ9CMJ7kCRXB6iuEoKwo8Ca3xBX7CxZNcPKUsfL6pTiCA/M0zzU2r+IW7QZ1UNF0MBhJrxiBcDgA62M2SHK6o9twgz9ciJVKACJW7D9c5x3B4Ph8SLVaTsZuD7dSKw2KbxxnC7eg8HVqhxwnYB1PTgK6kneAbBdiYR7xUbmGCOnmECC9zh/zMBDfzx6VLdmKitiYDRB0zRJKhwZ4i9EKYCEcwDwOJO3qDyNDIBIzkgNSACaWoIDG4CU8/wwGlOAPrAAlT/K7PiMMMHC9Cg8VxwKdQNEmsYUzcsCgXlFvVJDPLOM3bTHiivIokfPBGko9lpNARIYhIsk3iuIHO45yhrDAfvIIu80gVIiUSAnVZm8avTEGViD3Zi0CcIAtTe7mco7FDGD5oOAsz1Acdw6GViClHqBUvlAd03CndsGXaqEvIaQwpS0TrkEw4e8S6hH8FDMOx4/Zuu77EhQj8jEVgggMJOAhwMsBIqUEdoNU0OBjzCBjOqAJ/kDtXKADQNMELGEMRDJYPNPuTtOb8mASbCAS4CA1+C69PmMQSPEDQ1AmaxIsagA31QsnhUIngTM4Y3EWK40ojzM5Cf9Le5JSKQeGOT8KOnlQEdeNOh+mwJijCC0t9cCDk2BPPKXQAV4oBsQzHVMJ1GRpldbTLV+nTicAG11uPhNAAVJrtR5AAXRsP0toNmJAL/myQQdTQcNOFOwwMesxiQoT/CyCEKMuVaRMEPjvBs5upwwCDGyAITj0DzKg0RwADf5jIRUxUkbgJxZlDX4DJTen/rYMBJZAVmmUEFrg7nrABITANYMgCKYFD2bzNvstSLNmJmdkSIv0SJlVvXyzBXcVO3+TSevFzy7vSRVmKAPrFhFMStVEA2pwKZvTFyGoN6ZzOLx0MZIDTK9zklSDTLmjTAnoLmlM1FhK1c5xT1sp1Wr/i+dIwAvdcoZebNXy9C25chr1czbUcRhPJxAGEkJ9hxeQDiDxMSAltEFVRf1qJstUBSGbwEAOUAKw4Jb8FA1IADoPYDMlTABEyAEaoFFkozs4wAUWcgwAUEZLlJv0oDRPcwnWbhIl8Q70oNL4zt1AURF+lFi7AEnR6Vid1guWNRWblb+UFAX7jGmj9s+YoziJ8pDAdQa9lcGQ0pEWgk18sdEowE6+DSotCU+mEluJQ1v9BDyY4xAE0GNAaXZ8aLe8Ewx6DyzV41JMC1BlSAXSgBFwAGBdrbU2AHXks2B3agVUwAZigJZK5YfA4FUGFFLz8Pvib1Hhr8r6kTBDYXRN//dm/mANBMFkLYAhNPU/cG8AujIDxlJLDyA+IKCxdsAJCEAAdgAKKCVSRBOLTjM0a9VQWrVWU4ObeHVnraNohaCyVvIBi5UEpfY2jzU3n/ZGjrVq64ZaAWk4WTAFOglKozRseTFcEatsbwNLEUeS2NaSsHMg4rZ+k3A63IM7zOAQVxcsl0/E2BRwT6ANwADG/gMbaShlPOW12DIcCTeXDnj2YIjU/kNPZ0gdSysLLrQNHNYvne1i/7BiBRFCGbRS+7FmKJQiQOIUqAAhcBc6S2APWve2AkBNd8BUV1YAajiHeIMKREuETBUCymBWbXYNJDEFnLdWa0BVd1aJaTUUxv/gC+BAAp/3DiprWijwedhrabmYaaGWSL8YFLXXSJ/WWg7qjKF1WnlSOGXxf7TVTJLQfEMGfZVTfa2UfRfqfRuisNa2jx/ugtA4jo9xw8pjOSKlCUQpgPe2DKdwCndAclXgdQCVG6lRlqzQgBW3tZqP5rgyYUkF5YqOIzbCg+8QhK+NQKVt6ijVlGlhD2jm7CZgBJqQACAgPlqXN2IADRbCUyWsK9HgAWDpAHQ4AGK4U9BAUiBCEGRKeTFgJFNXNZjXZ5lDD5xgy3wWY+4gFW5CD05BEo+AiiuLJo+gJpO2i70YjG2kJqO3aatljNCpTAJZjf2oM/BGjLGmI7PzSsz/F0rneEr9OXPS9wbx2KGasXfnBAflFirZtWLeNTiyM/VooAk6CmQEwjyU0KVcKgMaF4ZUDS7HcQFeJ5ITeBw/q1F8CAywAIZgKA0jE0JGmZRdZQGJLVIdc+xWBRiuTNvOo39bFwvWQOhuWOh6+ZcR4DwWuA324Ocmd2UjoA3+4wAXAgQYUVWHl/8yklaHFvZuojjOzu6GVjxmdAo64QuWFYk7IWojYQLF2Z7DuHvDAouhVlnDGVm/2AvYbXyldSeFk63v2Un3mVuT4ms7b5GMkrANuzUW6bAPi2wZ2+IOW48hQIL8ONK8aWsvbSgx26E1rFBELnBd2af9FAvVg6ae/xCmsiBxszC1WUy3dMgLtXEui27Xdg2m33D7MkFAxS79PLi7sA3LUmFVDuELPEcQTqCoW1iYmXBUSeCXV5YyBcQJJkDCEAAKDCG6V6l3BSDXHoAE2iCnIoCaa3nLcGMMtBk4DgEjvyCrx+AS0PvsagBHU+Mjt4Ob7sWJxnlGhvW+2/q++XooxDlZ41p7ddNfwDSe+2iv7Zm/+XsW/3rQtDKw/znCszKgG7uRGiz0yhWh/WZbKUs1COKNJc2yXGCTPCY37sOn9+C2/qPGbA9gL6X4Rlq0VclvudKWlDA3fmjKaPu4YloUbFvYZLoegw3bsu3KyvRDYbYrgSt2S5UKDv/iUmiAlmkYAIg5DTIAAJaPtTQA1iDgd4UuIcxADzhAVRenm6EZI2d0UYJ7c9wbVsXjC0KBrEURKL7Cmr5iDM7anvm6ru0anaO2z+M6jOd6wQs8r4mzf/6IaQOs4cRkwxv8fHNQwhFb0g8ISx2bcA4Iki6TWdYtONx2YczkSd32XZFxUOIVISlahEpOkQE2TWFKU8JRtMeTpVBKBVx5lOJDEF56x3u8I0wBt4H8yQh0AR+k2XKamgcC3TigXFFqx0pgAFYWpSSMl2ANunPqlqgcAFQJmA1ggPfgmB2STz4povsjRmHPM70DqyttszZnDIrDeR2GvrfZiaw4vWMiDzr/Us/1fJzhut/13W74B42H4lqXdPIQvEqkkmsbnI4nndIVO4/JlUAAOnMs86AtwCAym9Rp8Y279H7tNzki+g/Y2z9A3fZoCYIBV4ZGaoLhUlDXQwUy4pVJ2bhu+7h+PNg/WDGbLUE7s9ueseLLFdpzeOgbi1QMoLECAOmznZYRgKlxjJYDJHMEjXwFzZus/uN/8q79aSvetXvX+d/vBdAppyax2N/B/jM0vtDTWJ4N3l7Kuo1HA7Ie3ZAKDQEZ3uEXu7Fp49Ew7n3V1tNpMbC2NQkF+V09fkxFqTtKYnWzIwMKK2Y0OIjK0wGwcaa8kSxHreVtz6dHOelaJYlwu9gf/6Qvbx7Yc57YP/iElMAEHCjogzEYsz32k172Z7/2bb93XwkzI8plb2Neu4zqQ/2gGD1bhbDDVwPt396uribAo1c8lJXsA/2t9T0BPSMBHT2N0z4ZC17Rz96v5x6wCU0XJ26R7N4oERD0Gt5KL93CJb4pLNPRHlzQCCKOb1Hw4XY4PCY+hIyaAxggJEjIEKMgFjAxJjxw8IDEiRILH2iQ2JDKHigqqFBBs6djpo8gJZ0SGbIkSFEnV51cibJlqJanRFmK9GdMDBsjLEBowKCAz59ACQgNKqCo0QBIkxZVOtQAz51Qo1bgQLWD1atVQWhNYaKr169fSYCoYaIGWbNoz/9yTUFWiNu0XIWwlTt3rlsvZu+m8LK3rVwvgAP3oCvEQ+EgbssGWcu4cQsXX9lKrju4Mg8iPjIz0fv2LmbORz5brmyW8dbTqFOr1oq1tWvWVCNkBcEBhOyquHPr3j21t+8KUn8D72nUQATZYzVoncA6g9jnW8mWJeGCuosb12vQWLJEz6lUMT8KQmhhYQkVBWOUKJFB4fH3DtqPOPFnJMn7JlmujPWRv8tM/sUi4H+XwISSIDVhl4FOPB1AVFNDHSVhUgBQiNRRxPXEQHDCzbbah5FN15V0aE1H4lqdtZXWX0f0FVpoeaUII2WC1YBXYp0p5sFiHkTWgmMsAPljXKP/FTnEkUiCpmSOOaoIGWRd9RgiWCBqFQFsV2FJW21bcqmla7xhcFuHYpbZWwPDkYlbgxc6hdxpzGkwgVinPVfaCNk9mWcZgsTkpySXOCGWnBmp51xBJQiUAQoE7aBRfflFKqko/uln4KV/IrgGDS5Y1aCDD0Yo6lIBCGXhqUX9pOGqHGKwW5VheSVdWCfC5aRjK042l60xzvhir50JZpdhJiBGbLFTDqksnstSZmSS0Hom42ctGkkakaZRCRustHX5ZZZehmvVt2GO6eq56KbbYasODOfThRt2INFq0I1F54h6PpZdE2NE4qeflwRCxQ0oSMDoggOBITAYDIMBCCCT/0ZsKYEBYvpvgQnSxmaqoxY3Iaoft6lqgxuyq66HXiZblsp36qqrnjTsmq9k0pIG7Fuh0egZX3YRJqViXS3mcq0jCOnss9FGUfOv0+rbLJSsaYuah1G/Ou62tVE9NbhYhnny1749FdxOAkH1bqlo9taccqpB9zROOnA3xksU/4FQogLZEAMYIUFMoMR/n1RppSddHN5MZjixQ6cInB1qyKiCLHJTrD6lpppXc7vyZLO6nAKnbOVZ63Uyl+Yr02bhhZdd1ea1+uo4vqXYYnQZzeyImwf5GJOdJd3776yj3oPnUkst7rbIg7m15mB67aq5uqWd5gUUiC02Q9gT1+ZOEv/NGfVy9Jo4Q2Zxf+EvLygBLF7DDC/SH+ATXzqxIRbHZEkof+Sxhk2cLvg45JFjyv+CUjLLUQBsJ+sWtzp3Is6JSDtEglIEr3U0Xv2KZnw5nY14Zyy6cAAGIZKLBG33NB44i1rQUpoKpYW6F4lmSDHLVvGMxzWrJS95KVsNbqDHGx5+7YBlst712hWBT5GqZG9Szr20ssQT3G582UkCFiIBDPShBH2Gix8gBgQ/usnvfQb6DkpmIrAlqAh0OzFAyAAYwMkR0CnWmx7YPGDDEPwMViWKFQO5EkNs4cpJMapg8ISwurgwjYM+g4HQcDfC1g3PMSD04+8micIV/q5agiT/3gyj5K2uvYpcN7TN8prHAR9eTo7Tq54qKweBIqbRKR5rZebAx8TUsMA6ULxBEuAQCl5Y8Yso4aLghlkglQDomMCUXy1SQQsr1qQMSoimEc6ynf4BpY0VwiaGYKnGDRXQZHREVzjpqMAQhPJDDWRk7kq0x88BsjKww+QEHWkkwLguMBnsGWFkqDI/CsmElPQdC1W3wuC1rHP8pOHxroayGn4LlF3ioSkRKD3gnCttQvwU91ypveJIbyIgZZtIxaI70ekyEL78zi5E8UthIpNwyJTf4JJJIE0pIScduCV25GbGFGjgldrMpoU8FqqMks15WSFnOae2SVm9U3zvXBE9/23ml9LRLFd9ISRBXehCuSQGMcny6glJCKSAVtKSl3whBZWllqZ6RVxw3ZIoz1k1r5ESqT+8ALoqalSNImBsP/Hoe0JK2Drh0gaI3aUlVBrMxjZWmDAFkCn6c7+Z1m+MiLupp9K2U2ma0TYdDaoA3wjHvraqjszDI5VmdSt2urNWU+VVBW8mu77YM1j5lB1YEzNBz5nwnwDVp1k3g9bbLml4pkOoW8mVtYeCiEu66RJep5uu6lX3oqsUGzeRKKbSmgptH50XSIuGpxExK4q8bKl6H8tFy7LXsSt9CcAyy6+ckMwC8+HOoGSzsaB2bGSl1S7ZGGBdBOKGk5pbro8OOv9Pq7IzqoGU2VU3yNUX1cirgqkd7ySJYQ1H8sNHy8Fwi4vWYMnOdAlVcA6z1twqXamu0qWujH+I3Tia1rsc7W+qZFnYnNSyOuc9KUvjO+Qir3QX14gF/drLZEqxF4svmYlN4LadEfCYvJDpQBpJJdpSjaxyTqmxRV31AQNTJUp3VPBySbRHFLt2ZXDZ1Y3cHMHcznOrt90LW/CZYd4Rxs/7BHFwL0PoEQ+0xDK6qpq/ksPUfu/FM460mTGgSuxO777aZZWbKlDaIx6glQxZkJzYhuUg34BPR7ZiqnfhS0Ss1NVNfi+RQ0HG/TWBYOMiAXf6Bx2g+tfL260cq65b4En/R3fRbm2zP1fkOtmWjtkte3aJboTPL3wBnxHGc80UE1CuiPgJIk5BuMf9bXAX2tDTahpjlOvodn9oodCV9POMXeB6Cydtwe7JpgPMTQn9lSIhrZep49DLVbNa1QNqb0tPUUUnAyMTllgEHLgjTbFMxV6cggzCdsJGN3ITlp8SNpoqbexjI7ufyV7nnSBcuny2FsJS3XNaALMEPBeSd33uDGKEsPPh6lygZyUuopsmz9yd3N3v7lZ0ly5viqoru0EUcL5BzhOORqhCA0DAArpHWLdFUQ8Hb7jBjzygWoQ9pQ3XFBaSMIPo6BfLN9h4aNtY1AAHx5tAHDkQS37mlKUZ/+WAX3dYewtzaBueLHM+/Ov2jG0v1NxGc47dWxov+WB1gQhVUGHmN8/5KnDh8oce+nFz5uCjp7xObm2u6mMMV0nv/Uxhc1W8LFpROH482G5yJSyFmnWAL0jg523CH84+9oMnechoj3gcxsCvm2Rpp9ixjpbP5t8v8zsqGIW99o2N4Eb/XZ0oAtI6wU94B7r58IV/sOIhz2d7XvhG+syqcQND3MtrvvMZxr/QR8//RKfY9Is2K6pxZjCmdE0HNq+3dyVzaaCWRu7yKcH2HlqnRkT1V11HXkGGamK3ahtodpi1fNGnS0qgAz5WAttRAs2xZdUHbNeHfae1V3ynNQG4YP9OdX5GY3iKxmyJh347qIMtR3MV1n7uN2IEdXlGeIRI+HlJqH/5J3qH5mDsBoAqEx3uFlcHWHKzh0ou6Fchd3sSqEYDQCpa53sjlSdqQEXYUEW1kIbVAAzYwIYrJXHQhFhwxynR5xAW12/a5FHWZ2OudFSn9DXh9D1NVTv/t24rN3jjN08WZCsth36NaDpFKBiUaGFa1X4jhoSep4ScxwabWH+aeH+gSGKHlEeHuGZIZy+wwmKsmBsmsBtlRm9Ot3031oW2Z3fH0TgUiHW953s/dh1lEAgF54Zt+HBjFAdsR4dBdmt3uFnUt4df9k1pkn1jhjmx+EmEGHjKlU7RVlv/xNNWPNMrwCJVXpU6MkdIdHZ45XiOlGeJW6VV8Hgj6DhJXfB5T2CPnHiP+cgESkgGoXiESWJ/abVhfiSFm1M8AohsLWaAV/h0YCM9fLWFrwSB+kZ1SFRE37VjoSZS0ZFYcUAIgRAJZHQHboAFasB2piaCCvJTodVxECJyQcRfFRWDDaU5bUVW7UQkYvVm5hd+5NhssrN43vg6yaVoPdiOXCWE7reU8tgZ+Hgk+5iPnhiV/yiKnFdJiRZtpycruJOKXdlULbYb49SQJwOIlIYmaJlpE6lpEfiFV1cUVTdeHWkDZ6AGdukGdmkFmXcFI5hYO/UjISABOgaN+RZHgXiY/2MpV6vxfwzUVlp5k4aYjo/oR72yF3OWeJNnI1yReILETpepbZU4f6EZGnzmGVQplU/Zj/vIhFaJlZm0Fqq1SVE4hcnxXHXVimT5kGqSfddzfVQXFF64dbooIQRwZXO5fHhZBnmZBEmwnEZQAjjBaQ9Cd7dHMnqHmJMmXUsVeIIHZwUJfqMzOt15kxmkbj1IGICxmZUZW+qnIu9YYewXmpc4efKYf6fJBlOJj1OZef5Yj/2JlIgmjjtpkA9kS4FXhQeWm2amgLQ3jXZXQPz2kmCYe8JJgdsUH+akOzygBnCQnMp5koiFE3bka0xBndVpmNhpZgVoeuLZW2SlaC5Kepw+iTMRtkGI53LhmDMuJ5ky43juaGGg2YT0eVv4tJ9P6XlI8Imd14+YaJVCipUq4kEHanSzeXJVuhVhCYt4dY1kJosNmjY5xpYV2YcTahwJIIHDKVjjggIsMARF0JzWFgbMGZ2CCSrEWX0fh30LSJMIdE7flyxsBqg5SRmE+jK+xTM5aIk/SW2IdzTxNFuhEafwCaTUxpSUOqSBERAAIfkEBAQA/wAsAAAAAOABDgGHHQsBJg0ALBUFLRkILiMPMxsLNxoHOB4QOCIMOSgUPDMbPEgtPjgiQy8hRR0JSCMNSDMbSDgkSSkUUkszVB4GVSsVVjQaVycLVywWWDAOWGhJWTojWUQqWi4aW1tCXDIdYzYiZR4BZTokZT0oZisKZy8QZzYZaUQraVU6akszaltDazsla1o4bD0pbUEccG9TdD4ldEMmdUQqdUoydjcNdjsZdkkqdo9vdz4ld6F8eEkmeEkzeFEueGtTeHxieVQ6eVtDeWRJeksze0Ibe0Qme0Yqe0krfKuGfV5RgD8jgT4UgV5QgkYqhEorhE4zhFM1hFU6hUkmhVk7hlg3hlxEh0UQiEcaiEgkiGZIiIZpiWtSiXZYiXxiik0rilY5inFNi1Iri1Y1i1o7j6J8kJV2kk0ckk0lkk8xkl5BlFo3lGE1lG1SlKqKlZ2Cl1Yol2hHl31imGM5mHdXmIFcmIZnmVQbmmlGm3FMnsqjol0nol0zo10dpG1IpH1ipcSdp3NLqGEeqHhWqWQpqWg2qYJaqYZmqZR0qaN7q3pVq7OVrXE6r52CsG5DsnxVsoVRsr2is2wrs201tcurt3lFt4VYt4tnunQtunU4upJsupl1uqaFu4NJu6N6vYE8vd/Cv+DDwXouwn5Rw3s1w31ExIAvxXw6xnw4xpt1x4pVx6R5yJdoyKmFyYM5yodGypVryta3y4Q8y5JazpFMzsObz8+v0KZx0LaT0L2j0YY+0Yo+0d3C041K041T0+K81IxD1JJL1auF1pBF1qZ315tl17KL1+fL2ZZW2pNG2qNo3JVK3ZpT3plM3qFZ4ZdL45tN455i5J1T5aNb5qFT5qlc5qx15rmS551X56Zm6KFO6LaH6tzC66RU68SV6/DU7KVa7LR47NKt7apc7atj7bJo7qlV7rFe8Z5V8aVX8qtW8q1j8q1q8q5z861b9LRr9LyF9bJj9rFd97p198qV+LNe+Llo+bVj+dil+eO2+rts+vzl+8V7+8iG/MFv/MJ1/dGM/dSXCP8AEygQOJDDCR5h0ujJw9BNmYd1zEh8qETJRIlJMmrUSKOGiRUeQYZ0QfKjx5NDSqLEccWKy5dJHsZkgoNECAoXctLQAeaiw5YVlehhRLQU0aKMRkVKurSU0oV6Ik5kKAjSpVbGpFnzxrWrOa9gt5ETSxab2bPO0C5LO7atW7Dp4r6bS7ddXbnlxOW1q69vv3iAxwnWK/ivX3qDBddbjA+fX8OP+9pNfBfeXsR8+QGG3G9fZM6bQ29GHFhwtNPQmKFWrWxt1mWyfq3tuks2bWutcadNvTs1XHXtNnseTrz4cH/Hj//bJw+5c+Lf+hon3pebdOvO/2m3x7379u/Ns0X/97e8eXHz1AELK0x8oHsIFjj8SEiVIUSpEINe3KgxRIn/JAAIYEc0/PfRgSYQ6JGBHsEE00Q01UACTg/oNEQUPe2XkUVDhcLUh0YVFeJSkUBi3x4R1QFIVZvYhlpYZcUoo1pa0TiNWW+Fo+OO7OBV2Y+WDSacYfEkdg17h1HGWGOffTbZk0H+SJpooDlJJZGlmaaVbFzCllUrvuQC5pi/nJaOly/ypuaaav7G5HRwwpndnMwhp9546XHzDTfW+aUceeB5B95y7uBZ3p/phSYYnp4R9N4GNtBXlX0Q+WTpGRuFoKl/AXbaaQYCegrqfxeESgJKD5qRkao0TVihhRlq/9iRGUMhBaKITZEIlUQoqlhVbGnKeA6Mb9FolmvG5vhblFLStVdhVUKJZJKE1fVmk55l6Syz1k6p2ZCfZQtaY+RqyQyXYY4JCyvsXiJKJ/CyW5uZXAbLZm9twjXkdJ3J+VydAP8LGL/YShdwc4MmTOg342n3L3qJjoMMNQMPR8B7ClhgQQxgKFRfpReVUZHIEmHaXwebUjhhTiy37PLLCZ5aAxEtrQpyzSvrRFKsP2VEYK1HhWjUKEJ/CFUe+DEUCVZb2Uvs0zQim6yyXXHbrI96fUulkuNWi9e12JYLpNXkal1wPOJuTdiNscWmLiuWxC333PK6GI2L926Jb75VA/9XcaJoHyz4cxA7x6id6Q1nHXZzKoxwec0x3HDhD6e93t99MfDeAvAd5LEglII88sgln4yyyi+nrnpOCJpEOkY1t0qBAyybcCHPXVxRw6wdBr000aJEEvzvJR6doq+jZOU01DNGnczeaFE97PQ7Xu1s1oZl9tdk0yBpJ2Zcn02tknmRHR24caYdHHA7nsvl27C4a5S8YoZpDLBNQ9NM3rntJvXeZgoO5gzDMH8NzmECO1ziqhOZgyWMPOZBD8UUWDnqUOMaE+uXO6TjHox5blKhu5mqSAa7JHAKJxhA3epWmIGdGcglM9GQ7l42K9zNsCJAU0qucjU0phgvInv4nW//XsQjqKGDemLx3zGmFj3p9ehqXtPRXLR1mCIxA1pOelZdxCeZsVWvW2YzmBihk6XVuA9d6QpGl/pnxtzY617/y9uL3iEa9QUOUYN7HAL1QcEFXgePejxUBLN1wckNLlt9umAGjXOxi3GuIDxwiBpAhzQRsoqEJjPhfzqAshOycIUca4IJArSqmMhQQq9i3e1iBcNTJSGHRuEhiYimK9AdT4jL+woSd+kWJUIPR8LSyxOF+cUfRfGJjRES2so4DjF+T4tT4iL5jglG9BFsYKXBIBv7t805ahNNynjjmp7nGnLuL39kCeCQCmhNAzZOYAFb4HnSxyfPMI46GDzSHe8Y/yeG6XOM+lCA5hTwyIzxZJKUtKTINAIhnwmIk5tEGSdBRVGXVTQDpQplDEZZyth1NCep3JkNd7eTMwzCd0QRnkpjqdISrQh5ydOlV2okLJk27xi5WCJOmZhOXhLza9yjZlCbKZrEALQf5APb2aY5zGoSFaD8YuaRjkTEG1lVm1PlyvuUh07UlNOcYP2lOsHVx0O+E1D7qEVZp9Mng93zPG/dhz8nto7AAGaD1/TnU4tDUM4t4JEbA0N91IDJiejnlKYCQUQ3udiLYuChHHsCE1zHhJaU0CUlgNkq91ORneSwKLPk4fCggrzaXKOrNG0e1HAqpmPtzYlFpB5Qh2rM7v9pL5n/BKiStCc+3P60mE/iLVQBpy3aHjOrqPlF276E2q+G9Zx5y22hNni+PZnVgWdlZwXZykDiJLJOi2NcoRQ5McpoF3ASW+Rn/srev07AIB37mKUsYpERXvY/NYFsCRQ7qtaNEqMfMVAMECIECZVgZpalCExY9irb2TAonk0paFc6v3cNLxL1MUUo3CjOJvo0Rqx1bRJt+uFlyQV8wKXLi67lWwHq419J5cxSjVTMEwcXc/Ako6LqeuMo6iW5agxya5QbTg57aafPFWs6ymZPfr61cXrMbgG5QaeoGqxyixtuodI7MeQSdYB6La8AJQeYCbBXAwt4b2AnOUk31Pf/ZvQ1JasywqAVHNjOBvavnv3LMRvY+c4JLiEqVSZSVtK5I71ryrtmeeELU+VdMu3wa1W7pfqJNZhk6ZFssYbi4451fNN6cRerFU0rRWaoXJntjd+0XeoWtcfSouoZ18UK+w0ZFkV+YzLWGMd0RoO31B3jWQHlOMNpcLs5rvI8A9ZFZLBGNfmcKo/VVg5ow9rMGkCze+UT34QqFCJyzkgIVjIzHJR7JCbZcwtaZwQi/BcksYNhRUgV0s1iBMIxIRFKFy1LElllw7qUI09vylqdQhdfJd50U5eUYh3VCIvF1cyVkWpeszE5WtRc+JNEs10rwZp9xEwumOi3RjBBw+Fm/0K5c3s9xNvi+IDF3uOWqTzsh62VT3HF5zeLjFW/qU1i0Nbr2rKdbfa+13NuoAoJFVpfjoz7wOc2t9RHMgQFvXtBAt5oZg/chASPjt6vmhV+gDJvoUhYeBbWYYUb7RTUUhqYTkxiMyyt0xGzxYgKH6Zva/xwcbz6xJBBHD+gefErnfq3qr7xlbf7d5A7/rRaVS6tTc5NU/gC0ypnecuXzGJ+Yldh3BkUHxlGc/BUWU/WRWt4pqNAK3aT58CJ/bTZd3IvE4boaM79BFLwBEn95Ns3O7Two46SdO/5vx8YsAgADIPKWhYmNAAp7UBlbwX/LKWN3uHwkmIKXD7D7QN/+//c03hwviV8WFg7cd8yrxXsFZceEk9PtRVTNouHJotXTbHPX14nUxt3bTsXZGPyepDWDkMUWzSlZKk2baHxeaDnHYJiJwVUJw8EQaP3YnSiW2D2TZDHJtIme5ORP5D3YxhUdO31XhyQIYJAWAsVMgolfFB3bsWXIAUySglifP+VUVqnE10XaEDBMihUQ1LREw5lEf42YStFYU7BC1xFYuInPXb3C7hQa3UHYk7YU3yXfuvHNrlxDgw4W/H3Pc52GfZneOOzhSC4ccJWHNPFY48HgFb1PgOYaynnC5ZweXFxdwiYgOa3ZAz4clC2HYIyiP6gJ+tBgcVGSKSnegBTT6j/lygd+GPcBHs+phtudw3tdYLclnSh82YiZEobYkLDF4Mo0RHpFnV2BlIisG7IRzMaYm7SVyEfwRNjV4RucHbBoxS6iHZpB3DfB35wVyxxpz/kNxszgndoqIV7WHuxh2JqKGqjBi1aM43tRHGI1y1PsobEJXtw2EZoZIwoB22tcIcOp4fMk1p9Uy4N6IDeAQ73YA/vSIiPGHMydz4ZOFzYFBisgVyW2E38yGH86FcM4F4MEB9N4DEsuHQuWCkbQYrkNjMPuRKVhQZp4AXzQQVOAAMrkEKnkjuwg1kXQDvTZxIYYmhQd4snhYS6mItEEwobZn4eJowyKSO7NoU5hXDI/xhM6TcXy6iHYkNqStUXhKeOZnh4tud4zxhVriY53Zg/udE2agRtcfhwcOMLeXiAy4h5fmhXfxOIzQGB4ACWDsNHGCiIiSg5iFiIE2hB1TUZ4eRl/cg3OweQ3wd5ECBQd4mXLWQE3fZ7LgF8oSiKERmYMhh1fCAM1VANwAAMp1AJdkAF+YVgHhk7saiDGBIF0BcgQnGEt7J2o+CLThOMTSSawpgWBXdwT6NpyJiF7TeV7ZcZeQhUhuEc/YAM7seV9bcv6pN/UkQY65CGWraUF0SC3jhkkjcbU1kv2BA8ZSJ3fYd5z+mbuIlXaYlA3RGWYqkd3FALGBh6hIhAVIaWjP9Ilmx5J/70ltfzi6/XRnHplHcpAfBJUQ4mSbb0lwv5iWVHmPqZElFXWUVQCfB4DwIKDsTgmE/AUSUpaJW5MRfSoFZAUq40FNr3O2rXkk3YFqSZoRoahWKCazDZVbt0iVvIfsiSNYuReBgnjatWePJnWy7KaWPGf5vhhrSXXPdDZGSCPzeao1oRN82pnNHJPFNVD3/oedZplmIJgd9QC8Q2KKFXj0ZKSNRpOb95QV0YVLrxGlranpPolOmmfC7gipxIKfYJmKFIIMK3nxJJE6gADtpwD2+qDdWQCXdgA1uXoJfpbpVJkvGGbyalb7S0kvLDNCDaSxs6k2FRcLiwRFj/mZO5NKIJCI6VsYBbFBm2BZsrGpTU0j1CJZ0yap7mMmQ7Cj/rki7sUjfhJAtWEQzEKDVVJaSe6mLL9oDZmVbdmZ0IJHiGNBxkhl6SyISVmKXreU5b+lUD5gVvkKxx8AYV6QZn8DFlaqZKMHX9ORPu9qDk1hJCUAlwqg3d0A33MKdr4AIsYwWG1m45I4s10AVqwAd8oAdpQHY4lJITOqiECowZaqjDaJodenkfeo4fmhfd0xbOpRq9GZuxVQ9do6KZak2b2qmeukBSZaOSN3KnOnkYazetsCK+MH5f9ZzQ+aLA6XnViaQQ6A/CIAygV4Gj13qbMV3UqR6y5iVYQ7HD/7o/YUVkxxBZy2oH7gqvnLgrnhitIXOm2ZoEmcQSqBI7XeAKAtoN3hqup3AHg3Y7P3GZGDV91AcGd9AIjcAIelCESHt2orWEAKlaR4Sowaia0+M//SqXt3GFVviqbcGFQAqpseUYRKJM75ebS8WpPgaAslpFbUmcxkmqOQqVW3oarBBEtlaw6AhbOxmjUxqI37mkdZKkuSqB4klGvZqPRTKXW4GlalKswoqzN4q6++NgZ9C6ruusP6RgwKcq+Fat/PF80+qKlXUK3XoPUCsPUxsDIXkB9tYTO0h9NBNZJtMRNhFhuEihn3mhIQuFaYu3/Nqv5QeMANuornWc4LiHbv+iNYD3k5gaRkaZVcqoT1fClKYxs0f2jWcrTqTguEhmcK6alWj4DNI2nexoempVekgqei27lk02ndhUpad1o5TKns6QZEfGhGDFJbbDlxXZs7uyEB+pYJciaEd7ux2Vp0xwBq4Aj1D7pttZp7BSwXHQrLmDEFKQEE1QgwWyKZqCtAuRUoxmttkLndXLtlqpaddbqhCsP1thU9B1fnxIIxV7v/i7DVOkGU5lY4oXNteYnvvbeDRmo12Kvv+onJZQB6LwvpAbuXRrxJS6f13ZpKaHuWr8nbRZSPZYVAacTQkMLDX6egrMTTmbuskwi3HwB177B0TRurE7u/cWFFznwUj/m7SLXMF8MAzuKKACWg2uUKc7EweKoAiCvMk+q6ydLAY1QSD/oSk08KcSWrZ4E5M/7MPLk3mKSoXmVMRti5rbaxbnshZq1Frfq7av2WJSjKKa2mzoC3JdEavBZcX5J5WexoVCrBp2CAg3yWuqi5OYBqJR9CQwh0DUIAxlSY+cO0EzSqMx+mq6URvP04E18mx6vHIQvGtr5Md8gAibDLRBa1hy9oKITEoe3DsUeRSTEAqu4AqICY/c8Y5zGghi8MLLuslE8QednKxYsMIV6Z+t6zOIRq8nxYuw4K9JPL1NVUT3goC4PHlzF8uyTMQBOxaqYcvdq6ia55wg6su1VU1//7vAcdFzXpOGNNa+R4mlbHOxrMq4v1K607zDTwi3HwiIaLWku8qynjGcfyjOaSjOukF5cdul7izNWZ2zJBEpCcGsLFzPhgxuDhUgIDB1YxsKi+khgbCYKSseiVkNJwsMfXAHaiDRmDwId43XCT0FvZchJfmu8RoUJoXDcQPLOBt+WPjR5QPEDWyOBOvOJF0bu+CUXYHS1MyH6lxOb/vSIY0XZ/yGwGwlgNuU3pS+O53aKsa4cOOjHHYJgHAJRF3Unm3E6xm+nzoN6nVdvHrFxTXVx/yLlI2cN8vODlxO7eYELqzCr0vPNnOfc5bPApYRaKDWwJCYq8AHoRDX7pCY3f/9lV950CrM13tdwX7914CdklHhE/4mCnPoS8aYr27B2De9Db5EomFiCqCQPLvA3ybNpfhq3J0Ndx2N1Dbdqc8Yf5LBm4bbNMMsuMuc07+aC51gFVfxbHdjCdAMZLT93+B326+6v3FMcaqx27xdJGI2sRJO1WKs2Vh93KZLxIANw2Et1qC4wfelmfCWBI8c14npIacg1/JQDat3sidc3kiO5DA8mbmTBj+LwZUioe8tVpmdI9djNZEXR5yt3/y9hMNt2Ubt4s6Vyx8r5lXO4BAL3AquD/iAsKbt4CMYjmhe2sQpefJTa95oIrkgdx3u4fzj5x09VlzZc9WlZU89gr7/ddJfUZdHYsXea+brXL9jvCZLzuSvy4kkM7TzdaY6zhIi7OOKSRTXjTBETuqhN+SYoAhJ3jGs3uqVjpm0kslQPhVCJBtUPnAJC01Xrjdl3sBcPgrmYIcaRtlRCeACxxq4jFNQiWTOc+vFjLdVTH9k5dMNLqLoaEbJfGsZ+5ZmtLGQkAxa1ecdDj3u3OtyNFZ2EYd824CB42qE/puyZsZb+BWjSty8/uJaPc0oTd41/qx+2YKiE91lnciNENcu6bVn8MiuoNbZUOqBNOSqwO9ucNeuPvGAbZ96bTx5cBVWLWmq7MNsK1SIYbe8hhtTaAnALuylQNkd36ri7ksCWD+6/+zZxw4j/xjaKrq3RVTtHXYum43hZxQvMy+VxCjUluCUKwfjs22/8K15XAyQntqWihJt2aS9zXWaf/4/W830YS7Pm+z1NZ4HrauQ32bRB8Z1aHDdob4qZ9AIroAGPA4M7iAPG5SY4L0PqmDX5d3qex/WLwERlaQ00Qus+aLYeYeNzCLSI/2462IVxmAKG+/exXi65i7gZD7SNH/frfzst/GBOb89oL2FHx7p0pzfpHD6dnNVrXoaGi7blP/y5K70lc83TCydUl2jJnqVo5+9ks2oWc8bW38MSdZVlVD8mKAKxU8JiNDv9hVD9+l0NDBuGdEIwADxZ0DKaBDQV3ABYP+gsnM/XaTuDsPwB0jurEMYSfFl8WOa0Rbu5aZbmh+vcUuyPckUJcSE+XQXJq5dCisCEJZGDfQ1sJk5a9aSLWTYcNlDiBB/BZOVy+KxXAsvOuMIreNHkA+ljUxY0ttJlNFUKmOpDBmycddizqTHz2a7d+J0hkvZc6VJZhGFViTKqtNRX79c7kw50ek1ZZDqmDIpNGQzh1ivOj2m1arXryQb+pRZ1qxZlunWmbvWtCpYuMYwJu3qMa7Ylln1Ak1YyW8lQoAJ/UkT5YoZN4kRLy7T2LEZJY2TTFZSmUYIGknOuKrWmRojHCWSNMrmKkqJONTcyZPnjppq1q2HEVZTO7H/GjB1bKsBJOjoJOADUbUiXnyXXOQtsU0j13z5c+jberJTWw8nPuz6tG/vh/16Tp4PKf6CZdS8KEuWfJkbtcd9qVF06ZbUO7SuxKQbNeq/G9Yj358ClCuWoF5ihiYEmeIJJabow8u+8Yg7rzyXvtuJJa6WEccYQfJY77/+QvxovLDq888/ANtKSEWTWHQwLxMdkg/EE2GMsaqS1tARCzFqCwOMww5TbLHIiHysMsoswywzRrLprDNXGOkijWHcAaaRQWLJZp/YXvuGS9kUEUSNOurIww334vjNkU3ajOVNXgaMk6s5w3IuOjybo646db7DZ7t9uPPuuvC4YiU9SBJV/7QV9twDxJSB4CtlRqzmsvRSTC3SNCOKNqJxq4jyFEtAooaThZmXElRwVbVcfBDGCI26xDylpJEJpwU9MvS4a3zpzRoX4xI2LlzmG/bGY5UDEUevTEKIxuTAsnTO44qDttYa96P0oBdT8PYEcF0QdwgrymUMsSKLfMyxJGm4LDPSnnQnG170YES1efFtLVBqYPomnkCHmWQQMQUhWJFLZj3KEaLyinbX+xgS9U7pKj5nT/Byyim77jr2eNByppEIFkQVTTTOSxw1BSNJJZXv5UxJ5LSoTfnDFtlPlyVJoTZ73mS4VFXNmNWfbMSv0/KQUurWPi/UiDg5WUoZEpeWjf/x6mIjxnprnI1WNlm9qtUWFq3nyhbisXS24AMM2s7gbRIyMzcOgtGL5O5Bzjy3Cr4tc1duVLac1zVUsvxy8HgA/ncdZIxJtS25ivP551JPLTC5h2G2lKOLKbb4c4z5FN27jwetqWldLUqYlEMt4RkQM1smaNL7dnm55phxxx1sE0PSmSVUBkbYzceFXlVACHe1lummWcQQ6udZKmUqxxPqOvmsieU97Ju3r1RGY8vOXXVWws+wRLRvhEAC9iWAmwRyy8ij7khDCYUX+9Gz+8wyy7DMMj0EbnGEuwQvvDQTAznuYZirXAMt5zVt5UdznPPc5zyip3SETnTUOZ3pPAj/nufNJT35U1n9IHVCmOlOczUrz0ZmRiJpdeV6HfmJLAb2h0ngkE2oIJDxjncto01keeOwULCiFkKFWGIPoqgeBCEkrex5j2tgO98Lg/E9TMVwfKyrIqe+gr3j9K59bzPBuNQwPMlBLU48y1+kItGhMs3vbpPgxTPseMc5DaMlelwgEh0WlKPhR5BYDEaxVNgVPVXwPxZbkAYbmUHrRNKDIAOkU0Y4EPdMxYQnhI/YfGHIQwqRheMTH/i05rWW2BBhfMAhDhFWPB8yp2h/ZKDjqhOP5tUwQyPBH3GewaGpGHGK4tkUIa/GvQkic4XjSaYxc8dF8V3kfGDc1vfWZoMn//QoDjjkIYGUEy2g3A8h5NFffKilRz6mk5ZB5ErqIGTF/Wjxk6O8SCIvhicKOhKSGHvkLTsIMnJUchdTSxTs8iCKTUYqhaA8JAv1E0pnmi1bqQxeK1nJh1XyMFUHVBXk1ukwufhrHSNVB1pqSZJWzApDedgDLjz6xWPOs5oylJEpPUlTeTJzmTJc2bZ2KkpokjJ5QsXpMdRgB0RQopvDYKqBgjKqnbGlRSdxCObeEtKr2mim0SRqphhaTOooMp/7JGtYp9NPSVJSIfgDBUshwdL3mDNSKFSeQ283IWPZNYt7RZ/DKsqIi2IUqUlV6puY6iWOMgWPTE2IOstCUpPWSf+rCasjNEzhnl3oZK05RaYpomg7vjbkpjul5iFXRhX5jCKiXi3fT6tY2mXy0HFOPYssfWJBV2XVqlbJaiC/tztsEPNSDCWkTA3JxYzYk2Jj1WdZc8WgjfmpVdYbBSisix6DQaJ+xNmuJ+3aQvDitXbFohUoQ0un7gnFGG8a2DbtENjANmKHtTAQYhd3QPvKpF/6hexLo6YUAJNHu1WLRB2o5t9hftKz8HTtT1foTOM6dMEyzZ1XWUe2uhbztcKN8ARVAt1+Pvest+1t5uaDPCgWy3o245YzbBbe4rIQucdQrgVB3NwQ49a5mjVGKUAxV4Se0H5z6q7tvhpevLbQfOT/K2+DN4zTAVHiD++lMnyn/If50pe/902ca7hM0vtGNoQys+HJGlvgA2+Ws+CzbkMd3GEnH7mQG+lpnc1HSvHCWcOv1XOHH6ncHP+5c4NG8bWQ9iGqGlqmK+4URloc3IeSF5Tu7HD5WOcMs6YkuMzFcaZtG1WyMoUXpvhxQrtbZCPfVcIstlTSzGNeVe+ZzE/hIZbs4F4rYzmpqqBvr73kpG8AG3EDzMZ999u4/zrwrVSznlQiASwTHwuorT10nyttSHNaW9ucPGEzZpeUnrY6wq/edvp0qkKGokPd62a3p91dYxLTqNotZJa8Fw0iFnMk0l8V7bgvDIqDZFDTm67Y/44NLuKdBbq6QQbyXPGWMOAYJ9V0Kg6Mn3I0XHB7wsPV9qzhVNE4pCENb6jyHZLaCL+ogte+/vW/hB3swREbl8dOduWU6Jvq+cLZw0CwMTNHalHIWejfnefGy51x405YyAUJd9GXmWQk08zN2yZvu9cND6u/W5E2tvem0LMe6uTst7hoMU35o28vinvSlfI3NAU+cE4fXOsJt21bNlTONnLyjfybH+UkTi1qkVaL3Ob3vCtuEamrcb2ooEQjbj3yKie1D5VwxSksn4peC0Pzm9/8N1pebGN7Cdk1525v0iwXZzfjl2tmc5uP3GSGuozpCu241zfu2fgQvumnjf1cXP8Ne+BP/dqHJw7WNZh14zeyglvveuvarGlhLXqcbO9KctG+b00tGBq7ai3Qye7uZQ2603Nf5FlHXepQcLu6b+yfGQbhd8DTUhaBh+FHkON7cj+90hVRMl3i9CYp0yaTMzlKKITKszxMyITLq4VT4DzOAwZgUA3N87z8ojkGIopOWLZWaKJWgJ1nW73MWa3r6r7Yez3yWjAUPDrbU7qigxSnQ8Hdu73fw7CoI7r+s8FJmbTk20EeJD9C47qOEKERxDR2kA6QYLSseZbVuj5ZY7JkUIikK4/rCrgfLL/miiQftEIRs641Sqi9q4MqKIP3S6M1wiozdKJoe0H9I77s+7v/+YMTPngDMSA5ybs8TKC8v1A5PVw5B+xDP9QvA2GsxSukmyugy+nAKvhA1nMIU0gUFryw/DPBR7S214NBS+S9Y5irTMw9Bcs4S5yxGgy+G1w1jevBeRi/KkxFuKsU1hlBC7oKsDLC3IE05LKiEyyfIGzDVgQFXPhBuLsxuUM45kIJoIuTvJOUL6wM98ub7FIYgsgjaLujcMKqO2K7bLM2NiQbJfu7SmC8iwqEQCiEPASMvxjHAzzHBfTDzdsomuOj4SAoy1m9SSgTJpKsvfIi1YEE14M6fpwQGFTBGQxIhXIZF+SkbOzHUBw+UMrBKGwZUzzFh/TBeBsR52MFKnwV/4pMLnTIxRfKBVoUPrfDP1mZwrf7xUwLRk+jO+j6hfRIo7mylzfSAzcAIMkIw8Q4k2YMjvvpJfyBRsaSxtVjNCODsYN0KKIoQL+QL3BcykaYvD54SskrR3PEhHPsw1MYhj9sKqb6v6k5DvoYNXp8humLoGJqhlwgNUe8RcJDOqAbwUvEPTVMSN2TENnJPd27S398wbdky4AslmskyN+LSMFEuInEi+ybQnwiOCYkQopcTCFEN7YUrd9DzJJcPrRCSej7MFmSQtByo73DG5nsm/Yrl76xSfm5SZzMm4eDOOGIP2N4kWXoMInbRjZ8Q/ZChKWUgwFkSslzSqiUypSjyv/KG849VLk+1MqthB6g7LEwHAU7WkJpwgUNXEF/1DjrtES+DC+67MvqxEvvvM4WREjuRDLADEyIPE/0rIe5g7dUJDiL2MVHU8yM1MggjDFWrEW1676xO4/nK6mE0Lor3LF4a6RlCDJwm6sOkSOZ9J/IiATgyBsw/B/LMJcgORczQU23igTZSYqvORrvysZPWirBCAQduQMdWUqnLAREEMemRFFyFMepVAXKq0pX2Dzi1EM4+Uk8ioTmrEZr3CtQSEu1bEv+dEu8nD29JL7uXNLvvE74+LftbNK8XMscrFLwSk8s7UGrG9BXfEzr8x2OrKdzqM+YOYZalETO9IghJcn/DflPzIzIEXvFoGvBvUvNhIlQKxCEDWQvMVEMBpVQQFVGc1kXRzG9OTKOddqs+5u4PVW5FjVRSEXRFRXHPmhR3oTKSVVR4LzDBLTDU0hK+epGlQsprXxOSFCClnpOjBsuRNlLKW2ZJA3PgyxPJnVSW4XVJKXVWn3VQ8nSN2VPIIQ0iAKVWCRTtrs0kTxT2xOIYy1SXhQ4zkHJoTk+YCXGOU2phOmNTOo7qYgfRViqWkuYu+EfQQ1U0XSMMOSb9uufBPWNTnrNaOy5AHtDRwXHSNVNOXBRTLVX3bxUFe1N4DyFVVgFTCBRHoECL0ADk9PD2bqGn2TJMDQgH+W49wSE/5Ykz11luLpsGV7tWI69VfBsyPHM2Cb1VSycVom0GJ1Ru0uRTyZsLehYVWS1QRlTD+kIzyDVLqlapCIaP5SN0/AwCiNDS7gyEw1tj77xDdusHM9kRr6zUHQtzXNdV3Y1mNWJD5YoHjFjKlcQDEjtV33d16+91LCF0U7NhEJYgx+YgW9pgRkAAoWlBIZVp3qJ2H75ynFbNgP9WJDVWFsdSF3lW5Ll26u9WlyNUlpVmMEtJ3802Z9lEK4L1k2zCEgT1maRT9ypGFg8y45sxaGDz21IVkeEBnUYy+iih8dFRYTTiU00smzlO99IvzwIQ4vdwG+Sk6HdWNYU19c1TcdIE/+c9NN1zVCV8kq04FqVg8oSxVc5gAOxZd7l5Vd/LUcFTNu1HQHsDZcWcFsxwDKqtKpdmN06MCDGAUHu00dqQ1yMdbVIATzAO0bdxdbANciG69uPVV/7NVK/ZdxyOl1IOln0VEXmszfLxQaw2txNuZODIKSZfc/sfD0uvFlPJNpHgdaFEId/AqjLdC7QQYko/ML5gY/0A8Mlst0CeZCbaqBaYqs6bdcEPZh2TYwyKc3fPahOmj9kGFXlXYOnrNR+/Vd+Xd6vLdH3+uHgTEBMkIIUWJsNaOIm/hZv6V65DR6NugZUEF9ZoECogBUpJAX/S+GbAiegvCOzUMKDIDLiM7X/ja2fY6xfjlVcV11c/n1S/aljhQFgPKbWlJXFT2GwiJlcllVg+xTJoZvgoGO0Ou4NqjiHl3qHSULdUIuu9TyJdLAsbUTG1BSOURiExlDatNgZmAqwj8pa3J3NA5UccY3hPz1XSHAEXkteEg0E553ltKVU6P0CXBZikjvYXQ7HSlDAVEhbcXFiYgYXKP6CwGi8n9lKEt4ECUQwJGUQFxljFTELMLvma+av410s8O1mUn1NKrafNj61FkJcOJaV7pzjVs3Ao7iu9HBcAJ7kwjTWmFHM/PTIdeMs2xvSmk0Kqkqp6zK99Wjk6+gykPFfSK5MQRuo7UwZowUOXtA5Ei4g/5EgieVCEc1VSS4NELxFmfV72qTdBPqSUR/uYZMmhFsu0VzeZTSgApd+grX9AZfGguatBDpQYmKGgAjYaZ7eaXD5AQJkE78zl0sQhn34Bp24QNu9lf76sLKg5rMYqdcgY/y6ZteYF4MGPXfIai9bB8TpasYpX2jzZhVm2sP7WMPlXXFt1YtlnU7A4zwWUAHO6MZ0sdDSt/ykoLIzy7P04mSFUggmm39uy7d6lJ2t6NMpHemSLgD1BpnC5NjZycuKnfuwlU9LTI0OMVbZsdo67Mihy8L2jV7r2j74YZOe5XzFVyLeZSw42JeOaR6I7dhe27YBlybWafbh6QaIAA44Af+ZzlddC45yGYI40BIvc1jzpUYEQ2OeZGPJGTLoriPktK+vHpxAWY15uW7WsG7unpdq6O7s7jKkRqCzoFuznky0Zuv04F2Ejmt5HmBizTfWEtOK1rcLazXAjkTgYo8gC1KB9uC6IIeasAlBIZ2bSGjUoWSz2kZxdY8Bs4ZQwElYsMLngG9Gyhif/dWLESbDkkAEjOWTruVCmAPV1gKVlsMlmGkggO3Ytu0NqAAIsIDeTgEOwO31aYAEQAAF2PHelumlDI5JiAPDIG5ViLmpbhxsNT04UuU4Gk2pHdRzkcmDYQSINiyVEymYM3Jhu27vFhzr9vLYCPPt5vLEGakyTxD/2kqlHpvNkVRrdn7rtHJvubZwYp2i/TbWB4ZE+ERThDCH2bMuvYW+JyyHAS9wIjpwDb6xAm1ovRWnyTbEX5wYYNRj40PZwXS3nYhqYfjw1C4EQxjx0kZt3VzpHXFtmGZxHkCBb3lx95Fxb7HxBFCAAygAWtdp36ZpOrQoIYefQcDKqebTPSDNIfgbcpHaQP2bvyEBZV92Zo8buQGSKZHyQXivHAIOpbSfwnIFOKm8IStOV2iqGvX1CeyXcWdH6v4ybC5vdwSqdv4NuJZzhZ5nsSgquDBgj4SwYj0aGZzgWk1TgSPSQLfgAC/07cCVf3nkDSerVJPCm4tdb3M2RFO+/+io1gw3RQ2n5OZ5DRv91H/tg0UAdThI7RLXZddG9RT4AVVPeRvnAFWv8fUhgFmH+VhvAA4QgtaeQ5PLIYLRgQu4ABqIA/kaGL0hdrkplyaHK6RPTdT8U3dZ9hB4emUn+itggi4YbqrvAqzPepHb+h8ROSnneq6X8seLwykHLCov++CQr6WaLXO3Lwqc6p1wKmbwpkc+aEvf4zqndwPetBgTWomRzH3sa8/NcxJcZIUAeNODBkF/iGkg+O5AkMVW9NjL2T0YsGYAhdhR/IGzTOQTP0qP55MUNAxaFammBgj88B7+9FBv3pE38R1JcZeWaRaHYhVo+Ri3dRTYaVmXef8BgHlbP3kpmAL3OvtBUAMX6Hl3qYEaKIGml5vKrxtnFBv37UniUGty7ZtkZ37mV37u737vJ5fvp4zJmHocsHrxH3/wH3bRNAwzCBL27+TaQHvgyPYrb/uY4LJDr3sEl+R4BwhvArcRhIbNnLOECpMda+Yw18FlEB02g2hRosVcGjVSpKhRFEhWG0mJJImrpKmTKlWSxJbOWrOUpUBCAgQIlC9pA6VJXOZzGj99QoWOE1fOaNF3StWlQ8q0acVdv1qxomkT0qiKkOpE+mWQILmDYceSZWf23Fl0aeGxNTtP7VG4b+W2XQsXLblwa5leo+Y3GzBhrk5h6lPocCE4itf/MJbjuLGWyFioUAby4zJmITNSjOBwQoUKzhtGR/gcgYECBQRWs0694QRmLHf4/KGtiA+YEiR276ZRw8UQN1g3ySrOy9jxYTCfMe/L3Boy5MqQ86JKldHMSJHyuCljxspv375LiC9vIvxv4EPWs0fvvoZ49b7Xl29f5X779lb27zcDxnt3aQwSBx+3TXJgK6jEIl10yDiIDD4RSjihhPVYuFRTduEFVkFfLaRQRh5xdEyII27EkUEihlRVLiax+KJMMb7oEkwxggKKIIBgpROP2DDTEzPj9DMUUdMYqZdTAz2l1FQMXXdJTTpKZckekOQUDZZlaVkXl3Rp6GVcYIo5/1aGAjXV1zqBCUZYJYUgYkhhisHR2GOMvcHYZJZVFptlKYg2GqAcTLDBoB4MqhprAKzm2ggoXKbGnbTxEQelUQxRnxV1CEJccT8qg+Wny4k66nSlUtfkKKNUd90kgwgS4BVVwFceDeSdB5wLtAJHK6+9mpfrfPkJO6x+/Hl3BbL/ucGdHnG4etsgilDIz7QXYljmhthy+GFHHU30bUMkXvTQiSiSS9KKK7m4rikrxmiOODD5EiMkUYqyzE6g/gQUkf0UdSTASjb1lFReUQVSjjchlyMsX+W75ZgRS+zlxHidJc46RWXj1ykdZ9JmJYYkthidkOGZ52V7ZoaCChwEOv9aoYIeiugArCGQwGiw8cCDFLLZcQelQauhQ39qKNJJK56GCmqPETXNo6k/9VSwL06umiojikQL637BDusr2LyJHR+mutJX9m/sda1218Ym24Wl/VI7pL8VWnvxlxs6zW23QIIr7ojYlOtVisGclC5LKx1u443vqiMvvVFa+TDUP85N1L8BI5kkNAk6aZWUy9DkMJJ3Qdxl3qZLjHrqSWb8zZquFHaYISLTUecWjkl2smV86qmnn5xF8PLwMB9qs80QvObnzl78/IYaYhA4G6QGKrivp0/v7eH2PnnvbVRUe471Jge26uqry3K3R4Bc+xfFd26zDSz9XgsLNq/E6k//hNpy0z03PQJ4LbdkS28d4tZEHOKjBAouXOJ64LnMJa52IQ5G7GKcTKDxkoqkiiZRAkTDKOejH/FrKO3InOY4Jz7QWYIhljBFMrJklNbljXWqmwsOV2fDzb0OdmxyUx/gdJjH5A53kcHT71QGPCCE5gSBOg0EGlA8KCZqURKwQM428yg7CE16R3PEghiUPe11TyFl5BYMRSSuVRnHONYxHxxbgSA40tF8UNKa1gRRL/Sx71jy44+sZkUrEvjKPftbj//+Z7e7te6AfHtI30r0QBMNTkUVhNHiKOguCjYDKrvooCj2eJUYbutI2SsK5mYoQ4E9rmrNuJol7IWRhpSu/5ZhouEOb6hDAraOKd/IBmBkR4jHVOJjIyPiYr7AOz4tYU9L/BOgoihNKiLvZhIYXgt0xjPpQYqbBFLQMJSjLzI27ZFmlNqHXBkVSFINVVIZXxvjKT42HqeebYSFLJBWvvLF8o7aiVaO2ncs79wHf7OiT/3yk0gTUkuAS8KWthyZzoo0cIEOhKAEKxnBS14Qg+7qJOQoWC+bhI57ldsXAG3Jype0wmAHg5JNWurKleLyS7nUJU5z+ZaBxeOX1BBmIZTJmCHO4TGOSeYyK0MZlMUmNE2MJhSlmYBqJuCKWdSiFHomBiykgZuNUEU4jTFGdDoNIWY9J1olas5IXrRJBv+z56msVjBjvJJBbpXnPa3zRlb5U5QB7U78+JOfXgHLH/7ol/8cyki0RPQcZ2QrLf8WLnNpdF6alJFIFIeuy350g5/U5AdfiE4yGWmMAYxQY1VJInlJpSpXkSlI83LTis02pzmsIQ556o6fNqIRQZWNMukwTDrcrqhIjUyffqBUlC0RNCl4KlSjeLPpWjOKIMimDGxghG1SSnpeXdA1xDrWx25PreZESN8K11YHSidFJ22rer+HHPZK5FQyxateiZNZfPLznwmrEmAtBUj86OOwhl1oSgeYWu55JL2z7En4TBThEmEQFha+sEc3ycnHcVCkotyRAq2hOQ9FQykSUuX/KpnSUtbOi0o3MZeZ9nLbmua0xjOe7VLW4Y5soCIQhkEDFBwDhDX0wTHHNCIWLqOCIEymyUpUchNFM8UISIC61bXu8rTbvKxGLwzeRNp4zXjWMo6ZnKQSs4jVyhD5mnQ5a3XwmuNMkbjeVa53tede89uJPR+tn3i0xIENjGBGQrSWaoZsgwcnWUp+hLOOzqSGNQnSmERuj1g5jqhkm6+f2E0vKWapeCcYJXxWDSw0PrWNU226G+sWGG3qQyPWQAXDLEELiBnZcOWgTOb2jMl5skwQMPNMaA6vytN9wLGxeN0TaPkJU3i2d70cvaMtjSdoJm+by1vKbXM7290+M5zD/10qhxwn0ZD8EHrZWWe8kloWhg30YRPb6b0YmrzqDtx68z1JDGe43x6kYNI8W+magCJVa4bXiK0NlJ6e8GEZmlfhXqojUssQ1RZXtY1Z7csdu8K3mJBDkGeHiVUY88jKZLJlVHDyXaO8d3xyLjRJUwHlVVkCVl12dpst7S5HD1JgDrO2g57pMpt6J1r6dtGPfug3i7vp3Sozm79nuLwG491WH/QJFSxCqCG6oiXyelvL5W/MXjYSNNmkNThsWQ/rsXEz1Um93XviTJcpjay1MMEprlINsbqAGB9T33O68Wyw6RSF+Jlh+rAKW5D8Y8Y9ect9DVwnB7vyS/xB8JgtPP/OQJPZK/C8zp0tbS+DIXotBLq2zboteKWZ20o3usNjb0DH0j6tDGa600Os+t1DfYEJga/Vrx5vhs7bYhc7tGTVGGF973vsj46040LqwRwR3ODNQHiheUK4CI1TtXafJSnyfiUZ2/bv5le1xnVM+D50bBWVeF4fqsH4H+q6yS1nAQsib/9ePznzLl+ZDWAe5uVc6I3es7mB6cnCGIkFAzbg7CHdA76e7EEgtuFeQvQenPGeBpqX7QVf8Mkbai3Y0pnbRZwIRq2WM4gdv0HfTPibdkSfC4HWh7WLqmBfmZzJdOyCBnVf3X3flIRSvYSQLQXe+Z1f4GncO/TUjgHDYKz/ghOSnCFogi3InxNmQv1J3hfgnwvkH5NBipNRHhA4Ewo8FxKU4RcqkZZtl+hBGxuWnnAoINMUnQOy3gNuYARK4ARunQMyHUzYXojp3rVdYJrZIQailT38Q4F94PARn2KlThkxn4TlmwquYAuy4NmBROO4y1lxlqUFofXt4MAsSTQ0iXul2Qz9giisWA4eTL2cnioVoRGy2k4RoS7l2BIGRvsRg/xNIRWmwirMwcoxRhCkABbh3xdU3hUeo1b1n3Ltzu6coWZE4xNsGekdYHdcAuEk3R2SBR3C3jbi4TfWHjfe3rURXSG6WSASIiFmGze82yEe4rsl0usU2vHV3kRN/1YDMRoJTiKkWSInZiIMll0nDkdWKJDrPFzVkKIpGsVnLQcsjdKRXFyN/R0tHuFOqR9gBMYTVgNHciTjPWGbPN4xnsA1pQCTEWMKCNUZVsb9ocAROdlL3olSOVvzgIHo2WQ1vmGWaKM6qqM3gmM43mEFoqMfeps59iQF8kg7/oMHwts+uANRMFzDvaIekuAJJiTzUZrzQZ/ZuUsrrohZrd30WVpIlJuIhSKGKMO8wNhZWoN1OKRlydLe1VYs0iVFXqQSaqRGciQ4eOQTllwhiAwWEOPNpCTIFeOuiQH/LdVLskxMLhdlQA+QUcY0OgE13mQYqA8cgiMDBqVYqEVnAv9lHiIdmZ2jtwkdUgrl6iWiPdzDPcCjIiqhVIoiVY6TVV7lJE2WSsSEVm6lo71gpF2f9OHIQGJFKdwXKD7UBl3Y28GLMbTLnLWWi7miTUkk+s0idmbnqTHFjmXkXlbDLYDDLfglYdhO7QQCEEAAsiGABQSBrp3AFq4kFjjjFYLhMqIBfuZnV1VmE2AmZpaBlQSJZ5pOaOZUgbregB4oaq6eOTrMgqamgnKIPvhBLegDOLwjUzIlN3ADVD7lN8zmNdSmp1nbQgTDvuECbp4oDGWQb1aiKXRlKMWojEIneoESjtwoWR5n1PCUYmEEW7plKkbcSUwnvtCjXV5nl2jnLpH/ny1y5Hd2pEfOH2DSQRZiAGlIgEtuQcqEoWxsFWNqwVHViXxGpn5OpmWeqX/i5M8lKGiKJk7xJJyyaZtVZVKOGSBCKLdxQy04giNgQi1kgzxgqGHJw45BpU8lRZKMqG3qZkIqDormJqSyqI3+44q8IIxe4oqEQo22YHHCqKqM2zSY2GkFEE8wZ1sFaYSFX5UIoXWemna+qpLa1ixyp5M+aV9CKRQeUxY+lzKhgAUYpv3J5BmWjO6gzH2WqWR6QU1epjUqAkS4aZuiQ4TSHh5Oq5zWabSKI7YW5R5a6zb4wzeoAp9SQiyoQioIA6C+I2weqsZkjoOUFolKnYqiqOIw/2o/Ot+lwqi+bpKmilh1sN1AliU0tBdSNKJaXli6WZYOIoTEKYzf1aUswqrEVqRbXAtGQinGRmkqxMlRJdmQcQInJMaX3kGxDqtKslye4GeXkunKKuZ2Lat/CsJmQutEeqvNXisEjqMg1il5Xath1QImkKsqBO3Qmmu6CupT+gUy+MU3IGqIxqu9rmW9Su0EqcvzXSooYC1ouehlCac5dJB2DKQeeSIvCMSahaq1CNAosojXtsuVUM2LTpzxzSXEgsnESqzdKhitYmxf3qot/G0VOoJRCVUUzl9xDS7vfCHKOlmvqSzLRoqy7gyzTgEPmN4mFCm8SGtQvmm2dqO23v8szsapRDVoH5omHYLuNrSjPqgCKlCC61bC0FaC64KVMOjiP2DoxjgIutYC00ZH1KxZ1ezX1O5m8N6rQLaL2YXt2eUrC25i3Haq8gZcDianYpHIp05WkG5q3IKCM8xtq7IOl7wFtdytRcLq3vLlhaJvrW5sUf2MHBDCcEmhJmSC7STGyYwpTC6mygqrTMqky8LsGvJAHajB5R7JZ3YuLBKo5kogAoeu6G6r6XrrT37DU67uuL4uyGQwJgyDMHDDIb6mPGyoT1GDg8TVKlrHcQ6vZrXoi95opYrUjPJr2yIvjkKv9BpMiWWd2mJEGnVYDJ1L3D5rq2YIoYUv+VIsk1r/LDB15K32wSI44fzpqjLBCZxwghPWbyCIKf5OxuKabP/6r+T2J8wODQgFyQF7bgIjMOr+pIbo4QNDMBy/MQW7gzxQQ2/dsezCrga/7mBwZKCC8G6RcAnblS/oVeI8avGS3dUib/K2cCNHDvT1KyhB71cWXJq1F9pW71pirw9mh8PSozbK6hGPclyUr8VmzBIzcTX0QTO9L1HNBjFlgizPssjZ7/0yV7CmbBfDJH5CLn8GIJpSLg+AwZrOXhqrMc1urgPnrGqW1RoTxId2aMfVBh77Vm+5CQbzce1WQ2vCY+7GgoLgmSGvaCKPXSYC5/ZWMgz3W/CKGNhS8tia3fVN/8P0ctpUdg7xtnC4mENcCoIp2GBqiTIpH8X4HrFApy0q8201rIET7Mk2kewdEEIlVKEs35pwCVcW37Ll3Z9ydWFWNRPLcjEY65xmPAoPsEAcFHBENvAxI7NLP2w9ujEzPzODsik3vk6hUgI1I8Id9zQiYDPIXHMxbXM3H+I3K4ghF7KqrMoxTKqjeWXY5mjyovPYle3XOnKnxnMq6qBRaN9MZV14NfVSj0LedVAHSQlVumoR321BN6JBG/Ep/0UqgwMxwAEU7MAJZAAEmED+RXQhZAIw/C393hpiZLQWL9VW6Z/lfYH+zicvZ1UYM2vlUoIZt3TNvvT5jeYbb/YyB/+ljikhYDQCI4j2H/gYT5v2HcOaRAd1bw0GunowPHLoMIBzKIRCCo/Pvzp140BC1mKq8gbhvj6y1kKncDIyPLedjiLk25WJQ4z1VjTOJH9yQB80hgz0qLq1dT9FDz3pKgNBC2QAe25hRMPJ4hGDLQBmmJLM/XJpVimj5U3BRkNmy5rpy0qjNHYCeK20Ze83TDsiZ/+3Z9I0mTBcdwoDae80ap+2aat2Hqv2ajchN78jYNB2bYvzO/82EAJhVG84OjPv86UKQhj3cRO3arnVWcZLjRxDdQACgGKW3CZqTNeigln3PJxWW+MtXMc1MAGDR4LnIizBd2eAYQbmE36k48H/gWEjWS7b53sHgZfK90wKc2TbNyGAVWXz95Fetn8DeDKzcSgvMJifTlhEc6HSsTAgeGn7WJonOJvv8YPzeKDagwg/gyu07nHUdiP/NodPdcA+Mg3/OWfRUkxYmo5k9YvVIMHUWYzJS0ysj1nPhJQAdH/n7VpLrGIBkADROEKfUHcusS3cAuP1QTY9wV/PMidEcWEr+e5EXkfnSXyzOpQHcH3vAK1jhhgQQi28a0sjMZZ3NpfbtAQT+I7drjy4wk6nOZoHwpqz+Wqz9ptXQ5zLeTCFQtZEyz9deylY6oa/Cll2JfMO99cyLHHCc45ytXIj8iDW03bkAUFCehmjMY0p/6emYzqO3xKXPMVp/VJHBoYuUiErA0EUbixgg+xwnewWy3fLQXbvvLew/d/OZMas1/pkW7m91+2S8veva3bGC7hLyCYd3241oIKkjHZtjPxsSAqzt/nr9vRgLHEIA1OdV/s/ZU2277nNS3ULf7jBpTO5T9xqJcnnfHWN1kSz6KumBFxaZ5y83yClE3SNY/fT2/uMb3o0Q+nfXv15o8EcLJ4m/KUhGJcc3I5k+M6vcSkW8hrZ/05m3LV9R7zEf0EhUPxdImneYrxNY7aX332ECvs+3K5RH7jJQ3TJBz7Kpzz8+jRP/2kIv7xgUHvWPD7ky7zNQ0nNz+hwkzPPHzdBHv8DY3kWc9KIN0wHTLH7VOdBlYjV005601d6Elc36/NSjgsJp9PxhnLzvv+lYVhx16/CIoiMrhHZMXm370SeGYo0wztVGCa/w7d9GMdAGvLMHcDu0ko9jtV9vVN/lnMux2+/BJcF3/v9IZ754I+/pAj+85w84Re+giv7aaPCMOh7Rw5DbeN55F+7HmB7nn87QM5EPwMEJIEDCRaEZGpUwmbW0jWc5sxXLli+lkW7dg3ar0h5OAryuLHOnlLNLoo755BdSpPhVLJ06bDeO5kwabas2RDeTJ05d5bj+VNnPKH6uMmTB86eUW63qhFbpclQHzlbDGl6ugjOFi5agCyZugb/TiE5XbuqIHs2SFq1QdSo/QGExVu0cukKmWEXr40Ye1PcTYFFTiVVyEr6RHcYsU2gORMvnvcYcuTDkik3tnwZMznN2DZ3PnmZc2LRo0WH1lzas2nNQ4Xu+/f6tTtKf/gool0btx0+unnf6f37du7dtAMFZ7S7Uahh2Zi7AwYsVPRQG/VU1xMJe/ZIokpd2t49O/eDoMh3N4XLlKWPBtlDAoTQVymK5lZGOyaRojKL1lp59N8xj5BGsYah+j7z5iXFbrrpMwYdxAnCnhyLqZ1v9HENqQzB4QapW1bJRKw1ADMkE0OiomMLEbHgCgmwxCIrBRTMQguLtL64cS25UKDr/6yu/HrLL71O4Kuvu8S4A5PBxlmSMcwmfLKyKKV0LLMqU/NMsSu1VO1ALK30krV9XIPNHnuocUQ44IZbM0023XzzNj10YyQ6V4CpBs/nojvuOuwY0Q5Q7EQRlLztLDnUvPQAYQ+U7Ap6j5f7zqtopWUimsgY/ZS55D8A6yhDkFYyLQzBUk3dxskHFVyVVSgjbKeeb2Sd5SgNwaGFQ3BusSUqFYPQggs6hA0xRRW1ONZXuJSlccUeVpQCRh57BJKHvO6SYchsbeiLhSMLUWUwfgxzldwpzT33py/VZfW0LRPjsksvEYN3szDHhM2oWhyJw7Y0ffsN4H/VFHjg49Y8Tv+556pxh7lnpDvOz0H9FJTiRg8KDyFQ1nP00I4fFaWZZMzbBRpTJRU1GWNkoS4kAMuoIxKSh2GI5nPMIRDVbUq2+VRV4/VZVQl7igfDXu65R5uk76HlFlq00XURQ6bqoatjg81KRDi0/moJZJGYi9kcf4hL2mV/2IHabavF1gQXiJyBhRW/pYSwcctF127K8KZy3b4TBA01vwG/0l5/8JWHYVXQ5FdgNgcO+HE4d0NjTTkZCSQ65qpBPBtgYtkT4tBDJ3Q8RBVtL1CCQAmFl4TkM8bkS1HepFP/6qjCjZFG9Wbnm0uGxpnghe/95waLbxV5cis0/J5eikm6m6S1aTr/aV1oSQSrrbyWQ2vtuwbrRK2P/TpH8tcSW0cZ61o/yBNEaFvbHaX4gpBKHFGFybz31n///tNNtUmCC9xh6HW8ARZQHRVqjeFgow9ZfSMWjhiEIiboL8hdEINtApic0HCd5ITiTkrJU+saIbrRpc5iGzMIxQbiEdd1B2Wxa4WoVrYHjrgBh4PIA+62EymcEShkwxOiEHNmKpQYMHlBExo/wNG8YnQDitHTBtNuIb1X3OIRiyAD1rZXLLNYrRBi4eL5yIi+9I2NfWnbVrbgp7a3AGYOjrjfNPhXR3PZEY93C+BjJtNHPgJwj4MroADdpcAFHk5M3BDG4uKQQUe+4ZF2/6DcJHlDSdxw8HJ1wpNREoeKEp4wdS0kCAo5dpAXckdUBcLILmaoMh3iEJYB4iEqMvVD4AURl7jExvCKaLyGIDGJTRKaSpakD3A4rxtPhGLSaPEISWgjH8ycRRbJUCyqOUsrKMoKEpy1tW2WEZxpQaOPlJXGs80gW+5rY7XGpoY4EmKOefSf3ui5P0De8Z5/PCAh1wWrQ/5DTA60kD6QMQl+KeINg4gkJDHIUEs6tJJomCQmKWmw2oCQGJvbUFM8lxzaUBCkIFUhKVO3iehkbFI1a52oJPgpM8SyCrgbhQ+BmMtc3AenQyQeMI1YqmAG8lUV4lAxipGPfEQxes18hP82lvkKptkialm5ptW0Jqwupsh8YFOLCnYUBLN0dZzSAhIK+uK+D2xgBCfglly+IAd4yrFueqynXOeZT30C9af81CuTBjomMckqoPEYBkIR2siITu6hEH2kRCnHQcYyFrEddKybkhPCMskDT4ss7ARDqkPOhjJQHyFQolghKnFcZKW8UAQsX9ral/UwUrFlpexumkud+s6nPeXp335qyGMS9ahGTaYuJOFMXURRF71wKvakZk2rAQtFz2VRVs1WtupaF213OadZz7oCtfplR219pyPiSte6zvW86SWXXgnpz35cyHAX4kZf9wHBPxj2sIrVL2QtmQaHUvKxAfbvYyP/W2DkNMJOHLrsN2rxOZHy6yOdJelAIgUeU/LiGQlsxSQ8GaAygMEMV7DCy0A1iRfOdGSXagZ+dNlL3MZLt1ni7YxnXMyjOPGoUDyq9R6RiFc8URtEdWozs5eiLTgLyWNkEdi+Ss6zNHlHM1ofENpnArS2MUbUEu9bZXFa86IXzGHmG17tStd5ARLNAOTHmuFbX/oGFhV2UCjAJLmmN6ThSA51rIAFfOcB8/nPEj1DYukcCFecohqXTQoEKTEJHR5Uwt6RsH8scdKCmNZhHF4tiHFohSEoYcQePCVKcUGR2rbYxTcz4G5jXOOXyBepyoSikHv8YyEP+RWSwB4ZssAF/19bU3vXdAtZoKy+JxP7umhDY5HMygG0xi+s4n1nYV4l5shQ6Mvq1fZcy2zPdxXzvf5w85v/qlk79ze/AZYkoMXAbncDerLDkShyvlULBScFs7XAhCMc/dFIU9B2ioiUd9aD4WcYY0+D4DSIiVCDEYMqD9/hTopxYVtevljVq241jf9GR4+Pa0kcugdSu5FjISfCx8m9tXKJ3AZhdY+qx+rBzMVZFptDWVlSLidYqdzzsjr7rM/mlvy6qgYxzAHpcpRFeeeKj2tjG+pRtza3u51tekTJMlOPyf/aBQ9lgDugNg7oXxP3hwoOuMCBVvfa/wvgdr/7z4NWd50t6NZK2P8bKfe4bDb03WgThrQTot0FdS6sjNahoj+sHXENGP/wOuiBtPKJyDFQzbNUbxzzLpFX18f1cZ98YxbHLDnJ83HylK+c5ddrA69/rZVf05zmMoKyzoMg1jP63Od92YAFeL+BoS87Lr9Swx2Q/k5m5E95Tr+61JevdeerxOpaz7q226WfdSywH4Ade2CzQY1YTI6ilMSzn+9M/nXD3c9vV3+75U4FL6BB7mdof9sjhwjBhPBoZbIHMfoOeAqqARD2ABJYiTq8g4Y2rMMYLgo+rQZKwOFILA8SIjp2Iacqz/Iw7gIz71Q8LhpcTPM8jyX46huGSseiaMesB+Uk4Xms58f/rIfHtIjXtqh7fG3mtIJqvorntCqskG0Gcu/nds/Z1IroUGDY5me84uj4kO9JlG/NmLD5lu8Jn04Kp3DbqtCPnm/MmCEJWWMcwm37xs37diPezm/83o781I7t1k8N348N23DQ5k+i9ozA3gQR6ucU7qRM8k+RJKizAmQAWyFiZmiGNC0NFHAI9qIEHFDEXmoQZiq2KsICM/DyJFEDtcTzSIWvhOq3dGzHnoiodI0NPGHWkosWWI64HoENVk8Gf63XfIAGvQoHY/HYcu724AZuyMp9gC4Is+yNzudGik+OHKHLlBAyxKUemhAZk9EJmS8KsTD6qNAZoXGY9OYhrsGQ/8TuCx9IGDQr0M5PDtcP/dbwscSRHN+t0P6FODBBGBLtaPRukeJADSbID2VhEyjoEgARpExK4RYPBxiPBEiABoZA/iJuplAteDCQEhFy4+hjAxXS88rLxuyBqJ4ox2ZtuFSvFCfy1miBI4srEVbv5VqRFY9MFmWx5oyN9nbEFn8QrThACGfEF7cs6YIxCaERH/qBHpTxvXQSCptRGplxGl3FJ3/SJufBGIESKSEDIyxiHZbEGtts+x6IML6PcfBszsKxz8wPz8qR/bqSK+Gt/CDHN9zKDquhHblhX4zO6ASOdhRB0mwoO8rA0w6xAf+RBEyACOSvEVknUyzuIHPmL//dZRINhDAb0ogwkRqWZAT94R4+4RM00hM1ssfYoBSZ6taKSxKGDBSFhQxYzxVb8QabjLpqrvZyTvaiDBd/zn1SwCXBai2+IAheoAeK7xdpkkmOUup0cid3ExmfEDeJMimDEjgNYyjlqRmLU+qWko746gsvRFYIAxmGIYJqw7DEDyu/krHI0Q23cysBDQvmDqJ84w+KwzcQIRWa6B64QRUKK3ccDOBexnZiigHt8h8ZTy/vMSJQTBBLjcUMEiF/CPMwkT6eIcMQc0lqgR+2sRZmIfScaCIfc7gk8yNV0DJpzZmKy6mKaxF6DSQ/0xVDMxZxcC24SkR9jqvKagJYkzX/U/Q0X/PIZvMLmqutuAz5epJCbjIZL0RHd7Q3M3E4g1M4g3PNFgM3i/Q3j/NGg1NTSuLNdFQqoVM6J0EMwS/u4A4c3W0Nw2AKvFJLubM72xAeuzE8G0c3KoEY8q8WwrQT6NEjXCo+Y4oGaMAuKeACADLUJmjUSA0++PPU/PK2ADTjCpRAqU0dSsJQa2EcEJXBGFTBnKcYHhMyR3EyMzO5IrQjnelCc+0jUzELbsBTb6DX0oKrXmBUYU82TRUWiy01UXQCWtPY1GIOkswHDiG6ZjIWpuFIbTQnkZFHe3UnffQZqw1IpS4nchU5H8NIkRRWok757GNJxaEdmtOBEnUq/2MBXOpxgvjFO6/USrVzO7+1Db3UHPerkgiBGP4hPSnB6ExstXCnZfZAPuE0Tuf10xiRTlinlXLK1FgsP/wUl4KBtgQxZQYWiAgUZ55hQAe1bmoBURuWQZlGuXrBMT0BMokqyFAwER7BqZRpIpXLIzOWUosrFUG110ATVVH113yAVENU9lTTVY0NyXpAK0oW6ZqLNvnt+HpUV8FtN6HSV5UPWJdoZ5V1WIfWKIsUOJlxGZO0WZ8V7AJLVsZBC5khFmSharE1sqqUz9xvHLuVS6Xga8FVXLkVkr6TXO1ADlTBHu5hHxoNFdrVXffApeYWLvfybWnJGKSzL23JX/1ziP9WymPGI2NOLCEwLG+HYWYQFxkYlnGpYUH9YMiUyxMmF1Ij00I1liNVTiMz1CPZQGOtBxRXj1NvwBV9wFNd0VNLFjRvAERxMMtWdOiaTGZpVlhoNiqM7J3WFFe70Al1FkfZzFd91UeJMSiGdniJVmiZ1ieSVQqNdmmflx+WdAuFN1Gn1mpn6G3/JGvPkFu/9CvFNmzBV3zT8A3MtnwrCROK4kw2QQ3gUxDs8R5JQX7zVW8PN3FraW//1Hf093dqylIAsWMmToC94x6lYwIR11oHoxaYIRVmYRX8IDN/jHIpVyMjlMcwNYJxjQVzDTNRLmMhGDNRkQxugPVIltdANQb/s4BUNYBET3NVdU9GvoaqqmpYarj4ZHQO7sAtO4F3ebIJMxFHd1SIqZd4i3dXfbcnnbBGkdIYmxiJeZJpnbh3dXJ3lrOHddQptfBqTUofIUah0qA6rvN7x1dsnYCMw5dbzZCh6CYbFKcT3pgerVZ651hT6rhg+Van8rh/AbVUgEi2JPDEpMNwVYYXElgVMkEVDuEQauEQGDQzJ3iCIfNimwmLMLOZMhNDWQ4zJQEP/ADl2GBTNzULOnMMSLkzSXiEfYCFW7VVPcCFX1n2ZvdqbLgz6YD1kE6buOcOaNKHeZJnfVbc9KFncRLqEmgn3Is1fPl3d1NIofeJo/gYo1mZ/5cZGTGNKZlTmLOYajeB3954h6U0TMO5Ox8r/sbYe9ttS9NZnd9wndv5jL13HM23kWIBGap2VASVjnZJGvaZn5fBn/t5j2+JfwWaj/fDoA96UPuSkKuWoa21kGnJFRIYkQ+BEzgBZCkVkil4czUzhDEVgzdW5U6xxz55U9vAU0e4DY7gBnKApUfYUzVgAhaglV05LmAZJsXL9V7OEGpZWGz2K8TrDyaBvJJ5mJkZmYF3+4SZeoHyqItaN5WamJ8Xmnv5d4+Yqp+6qK3ZGo/XernYmy2hs9RynLNT0MbWW8XXndP6nbmWK9UUoul5GJRzaudan7Xwn+1Yjwk6oOsaof/l2mkTWm8HI6IHm7APLUkOW5ETYZo4eXLxwBM6eXI1MsgyF0M92pk8OJMjVuUmGDNTMaVFF7Rz4KUXgLQ9YAI8QANSm4VZgKZhUi1k9gW0AumywJbJwEQK4bZT5CvEk3FUgWiCF6qd2amzb7iX1YiJ+mdzNLiRVnnF5aqfG7qHeSSWsimpja61cBPeuBPCWpzhuazJmKzRWK3HO1zJu7y1E4cUoRGEsYo7sBofgq/pOq/nG6D5ua9pxiLiGkoVt6ELGxUK+7CTRJEbmZM72cCLK7I3urgW26M9OAUzuAVDOqQ9QWQ9uw0s3KRvQLU3XDZV4AVWW1RdOzZldmZL1rb/D6ENcht3dztMY6GvgFtnP8+9enWgituYjXvGYRypf5aJn5k3oxurg3u6MaK6l9LwZAFglw7JvRng5DEMcKg7vfu7z5rKzdvK1Rlss5yt0RmNrdLEUIEwADSf+bquy9zM9/rM95gDDVUZ9Ju/31xv/9uT5PzQEAzBAlzAFdnAH3vPNZoUOxpTHTwVHxwzKTiSk6uzQbuUSVnDN5x1g4B1T3XEb1AD0kI2Z5u2OdNEBjyqbgSov7NaTEANUMEdAkvHcfw2k9FCotbGUZ2o48vUlZvHodkoj5aabx3Ih1vId8FQpZaQ9/N6l5zg/qN9iz3Kz3mtxfvKs7xLl/28uzyH//C0ag+aS9Lcvuubvjvwry8CSrndfhMY3BHPfiqB3Pug3ClBjgrBEcLIEBxBkcfADwxc3iWBgkmRkjta0DcVlC2b3x+BwiczFY9gDFhatD+10VXbU1+AdGdO0kW8Bz5zlG15pzd907VG+LxKL1wyAzKgCxyhxpPbqJeYdy3kh/OnqYE21XfSr4J5uX22V505iXFd1oNcx/XhHhV2lViBgNcUyX8Byd+yU2BJrLey2ZO9yp3d6MP72YneKvG0veFbn61d6qV+jvN7v988b8El3Ofco9a7DsOoft7KEYpvtuH9wOc9su0d3x28pFfvopWK3z95ZE264D/1w1Nbw1l34f97INJjdtIfnmZPPGreveK3KQgzQAIuIPERIANiQBGoodRjXeZLHlaAOGqldq63uuXjQTF/GyphHaphfLmPuBxyneZ13anx0z4MVxZ0vrSC3ed1vlMA8FOGHtmZ3uiRXvd33yuh3MtjSJ/hWzBdbOqdteqvPs4Z+lrFHd3lSKiLA/rrMPrJnvpHmQ06+QjQnnIzNNDZXu5B+6L7faQB/vo92+DPn2RV+OFV9mRvpMQ3fcBN5MSjiwVc4AHuHwHwP//rtAkAIta+eAP1EewXLyE+hQzpLWwHcVw8iQb5jbt4jZnGaNEgGqyIDyM/ix/9mTzpr6TKlSAfunQIcyHCkTT/a9qsiHNmToQ7L10ydm1XK2XKZLU6+osoUaOdFAl6qkbNHqlgoqa5ijWMGC9cu3rdCjbr17Bkp5g9izat2rFsu1JpOxarGz2DFHUaOi1vXmx8+/Ilt81vYMHSChvmuDExUWSLGat6HAsVJcmTKzea9CdzZjucO9/5vOZLHDWiraqZMyfLjRysj7jGAxuPpNmSaD16lCi3bk1t2iRis6i38ES3ixfXbVySJ0+S/Ix5vjrHDehZVKue0+OLDx/Zt2TfzqV69UOHyNCpfh715yAoLEhAAD++gQf0L9hA5W5fwYb8+4v8j5E4eyV20Eff7KSPfiidxJJKIyH4kk0u3aQT/4QVWljSKJcMFZky0/xiVFLMJBViU4DsUUceKLpRhxlSiVUWXDHOuFaNNt4oY45a7YiVIHFAsmFihwE25GBGHokkYsgwpswwxjjpZGSRWeYIJZtU2UiVmvEB2htYxIFFmG9RIaYaQJgZhJlxpJbaDdG5xkZseDB3XCKL2BmccHkK1xtxyeHmx29+GvfbEW4Kx0Zv4qkGHhdb+LBFpI5OGh56bGYxxxaZssACBxnIZ0Co8tE3BCXuMHSQfxGtCuA3rQqokSweFgjSgQmVtCCDDc4kU4USTtgrhcI+eCFPxbZSV4eyGmPUUkux0klTUk3VIotzXQsjjjRuq6O2T3jbbf9cV80liF0b7UVkuuom6c2R0HCUEZTyPgkZZVVO0khm+W7JB5ijjZbWmAID8QPBUpgVxAtuusmaD0fIOWedv/FJsXBckOHbn7hNnGgbR3hs6HYarOYbG7+Zt2ijlEpKKRwua6reF18A4YIFoIoKKqmUCEMNNeL07Oqp6zAUr1IaCciqREqzavQ17UBoq4In/UO1Sbvy6lGwwG5dLLFeI3h1gqhsqOwmy4oIYrTRKvKitWC8LdcZPIbLbd3g3k333F7N9SMkZp+L7rqBCY6uOYfJG2W9UlqJ7778bukvwGcVTDnBlhtM+Q+cKrwaw6/Bttxxe1ZMesa36ZbbI3gk2rH/azdw58NqH995cnrVOarypCyjJqnMc4AZBA8bfApqzvM94AIhiDuZUfPWPMNsiM0a4+HPrmbNH6xFUe90qrbSOnXVukIY4NK/do3+R8SGjWAsw7ja4SZ3kVhUK2qb2GL++rv99rcHQ4E3vQVwgARcS1bgFhW78AIxgWsg4bbhPAYuT3FTwszjPgO5f0XlYDzooBBm8AMPUk6EIaScCjSgAc615mFyOt3EKnYxisVwERIblJ8MZajXOYx1G8tNG263MkhpoQdc6EF3ehepL6AGNdn5QQbeU7woPiADcbiS2eQXClQgRYtI6eIWmaG0/mQvVsvKGtiklisMYeRoFzmf/9Z8haGvnVF9wJCHPeQhDEw44n7Ss5/a2EatMgiSf2+LQv/+h8gCKnKRedMb3+oyiQVmhF0PZGAEoTcMV2RSFfbK0mUuyCXPvEFyHnSBDTqYghTEIJWnRCUPWPBKWKJglrMc2cI+hxuTEad0Fitd6nqIOtZlATzTuY1tHnGLjS2iUlnonRGf+cyVRUoO1NSUEuPQKfpIEWcOoMAQwJAHqTwlRSpSEZB8oqGjcLGMEDkQRISGqnVkJHrNMuOtEoTGNKrPQBDJC4HeOCxhzVGOCKKaPe5YCyzd64pYlF8nfJQ/KwyykIYkghF0wANGalSAZsmo/zYal0cyYhRAceDg0P9x0nYBJiM+ewbPgJFHTT6GSoh43I9EOUoNTqGDLuhpDH5qyhNwQKhDLepQXWDUVLJgYW96WMfakEtFkYEL2/nYD/nkuj4hB3UTcw0OieMJXeiCFrco6y00sQjbOQqaQUCCClRgRCTqjppMbGunFJAA+RBgADg7XgaGANjAKqEKhC1siiA5inV+0WlAGxpB4DmRedqPFXixJz7zmRL9GGgna4yVNJAG0PQN1FijvYdpD8oNVWBJFnu0X0OltSKJVkuiEhWsDhJpt7NsEKS8zRu2khXBSq7rGcTt2TNkqkkrESJfgbApZ9KQ0+huxYMYPUHNjnpUCwxPu9zdrnc5MIH/CdhSdg7Dg1VlmIWptmE6PmjDDnujQ60ix2St+9jH/LAcsYqVFvylhS00YQi1GtGuCYMrpOY6V5mp4QV2dU8UuTlFIrxNkGUorIUHWS50HmUSGl7W0YYGYqLNE1rRkpVEvncgqV1WsxZalWeXkReYiHbGo0WQae9hDxx/AxOKsMtCXwtIN4BBtkKWKA+u0IVDikFyuQVLb2sUQhx9FLfbQuBVIBkLp1kypcNtnnGRq0fl1jSUkHtutjjI055aoGYm8FR33/zdDRh1AQsYr+fOi7Grhid2OmxvdXpzBEgNZ6ut643JHhFW/eoXHPw96zJX1tZIv/WILHMUXedwA+yg/4ZTDn6wX6t4P59EYtRPGQRUSn3OUZO6LpSVRZafEeIQX2REfvSJUfICtF2xmCTfG8lFypGXZdAvHPUILY0DOtCDHvS03MiEGjIqiE7cS4ubGERU8mcavsWhX52ZrkefvNEf7Ki3cit3GurSiJIykMvqwvU1fBbT5C4XlGRGg71nRF2fxvkDcOaAnP8N8KKiUAOuk12grXqx9gaaC6vB3VXdC57tyNeFiUqEbBJdDEUv2r9o/aEzoTnplb2MZUr8Qnc4DQFPx8cFf6iEq1+uRV4kduYaMvU4UV1Oco2apNzzcvlo/dANlTFoBkGxsYxOtHeEo13CFlGMkX3sOOZk2f85vvE/MMGDnoJBgRXssRqqUpfMMCKDaWgCUE/ZyCaDG4Bsn3IjzR12VARXuOTwss9kSol5b6ZLb+D2vZ3shMDvNN/X1W7hA+7vgAPclByoMwr57LBDYQx3SCjipHJXRCRoAAmVj2Gf/jSnjIte47pg9CMWgdb0fLzAnUcwHS5dcpNzigMpVzny7lAv6tFTKBtOLLREDfxIjBPDO+c5L3oeQftZAp2uZmMYiX4rpD9E6Us3TNOPBnU4St1Cy76x1TERBx18s4qxqJJk2IaVbj838DiAgQlMgIELmOCbal87uKLcdo5qy9znBu41qq9SANhuLJUReKd3fNd3Cfh3XCH/eJNzUTZgXSfQb4pHgSMQcHQ2cLe0QzG0BJnHeZcHO9vBeR7gAW7VAxgzMbchCbqwHJ+Qcd0weoqmDYx2C3YCYAg2YJNGRJNyaS7jg5niHSincvDBcpXwYsfHe0noRepUCl40CsNnBuUECRkWScuyJPPUFD1WYrJwhRgRNF94PebzEulQfSTidOWQfcGyfffEE8rmfVb3DZQgOZ/hGRRFXRdVA++XAXt4AX0YYVQGePYniG4nI1eGCu8zd4Rjd5tUfmOGgAooXQPzFSXEU0TFeBYoZ5YYgZvISrPkeK+zMNtxA7ezBKXIeR84YKc4giQYXhPwAlmQJ7XRgmLlgqIX/4NiNYNkhVZpBWnsEWmO8no+WAjp8YNJpAIpYDNDeHsdEj3H4Iy8lwxI6ITAl1j0VHOkFltzsXxbGCvyY3MKVEaM9XNIA2Ix4WJkFAzPCEbvYI5ulD5QZ1Bv2A03Vg3CUAhvEAUPeEo1cHZAtQL/+H7w54fd1E0ZYAT1N4gJGRd84H8CyG56AW/UkEmU0VxdomD2loCh4SV/JzCA90H7yImcCEKdyEqXQ4IZSHChaIqquAMrOYKq+FbhFQEEIF7TwQaySIsrKHrdkA8Z54JjBQ6ld1Z4YgiU54vdAUTDGGDDGIzVNEQoQHtDOB8mEAeH2IzR+IxImJUgchTL1yJ7oP8iiDWNlwCFYAkIQGIUDvVQUqGFzacRXUiAWiaGMAFssZIL0JILSQFsq8I1aShQdtR9pqUNpjWP9kAMlBAG1SWQFcCY/GaBLbACGwACw1Mf3SQqDvAB4qaQmzlunRl4C9gVWOY8DhmAdedlE5l3YwYmCvglOMWaGLmR93aHrfSRM0CSKCADnVgwb5UCJ4lCBwceLimcS9CSb/VWQMB5qfRvExABrlhMt8GCryB6+ZAPMFgMP6kNtKAN2flfuxhga0VEwUiMdKCUw+iUWoAFBBOVesVX7SkqVGSVuveMW7kL6th0vqB8KmJYYdmE8nl8sCBqNxeWdfEj13ZYQueWS2L/NIDDDmT4a3sJdHh5hvDAl8VmbO44IYAZmG8IDtxQCFKQdfBnmQTZmI7ZASeqTSMqKifgUWbCmXBBiPkXowG0gHVRWUtHmivlbphEkXR4kbDJGRXZXNQ0SqCxd4FIiZQ4kra5pCV5kiR4A7/pAxoQnOh5imQyJsPJeZBpgcy5AAywABNQTLQhVjzZDdZ5nS8IDuCQnWVlJ0RJBoYgp5M3nn3AlOfZYLX3YAJwmRkABpTgJErRDPNJn/SDlby3fFN4c5FgfNLoqPk5fCuyP1RoNn00PdHYNHtZl01HCvMDYzHGjnzpazKGocCSCtxANYR5D4O5qgdlC5WwHicARQ5w/5kSUAEN0AERgKIpepndZAE28KKAOHiDKDfiwgeRlIiliaPNg5qQowilcRVBqi+e5EnTWlMVmVNX0XZKyq2pRDAzAFdP+ngRV3laugRnsJI70JLFyUrgJZN4tQDt5Sdliqa1KHr99QqzoK+3YAuJ0J3eKad1OnKRYlcpsJ7s6Z59+qeBOqiHipUN64xG87BmiJ8VK3Pp1EUImhiR4Y2mtj8UdqDohEWw4EWYOiR6YZedmo6f5aBJs5ekahF96RI7g6pvuKo41qGn4AqV0AdLAAK0CrRB6wDvQbS8ejxTNH/CmnYv2oBLy4DF2pBadg5TS7UNKiBFk0UcZm1VNAd75P8Td6BQVAKoNEWt2CqJb7Gk3JqkKJBCLwA7qtgHobEEaDC3f/d3cqOu37oDx7gBzRkBCvCldVZe9loMMEi4Y0ULiGtWs2An/+qdAounRQUBevpge/WeV/A3gtp0ziBsnLu58jmxmrt7GUuWgqCN8/OWUTI2Wit81kJYBzoI26g2d+lhDEp99TO7ztdP5PhrFiqz2FMltVCzN9uqa1oNxHAKmhC3LUAfAhAAfXUA0Su9tTpF8cePGQWaCMm0TRsuMwq1oaBu5iC1ZKis85S10hZqYXslk7E4WtS+YjZ2+mIHVjowa2u/mgNXCYOeGjm3oRFKdNsvcyucQoC2TNq3zTn/AWH6pR7wMLMoei5or/tlG7dAVpKwr2iFwYegej3YO0BwwJQ7vQVguSJ8uZn7Lp7buZ8LuiksuktRn0kYImQ5qVxHL8SVOPbjFC1SBYIElnYxu3fJwiwbIMEGoNv4qeiCNJpaoVszNDAhPy13qqi6pnbUocervHHrwUArKs4LvUdrq++Hdul3ZsGKN07wFmYso2nsvf2HF89gOG9ctcs6ScyilujbWpXqvnksJXvMC5RhQdZakWKSpGd7OW0lM8jJv/67BmZbb1xSil5AwN/aAgfMnK1IZ+01izxpi2mKr/2lr8g0CxicweK5RLwThH9rqyo3wpc5BJPAsCgMyycc/8SimxQsvHvSqHyKqj87V4XM+CTRk8P6AwgP9cNceYbEhjS0JmpDUT1I7Mwtqw7RbKHTDBGbkBmjEQjL1QiVwM2oZ6dYvAM/ewBc/LxcDGH1gQFg/C3/8r9KRsZqPGVoDM/eS4hwxwhyN5rli7LWAMytNbuW2kd87D6L8weNc63UhK1lcjBYKiaiESYLJjNhosiBsAT+GwhrcKxkhtEXvYCSTMlh2ooe4DBhVQzVaaZoirj89Qi2YcH76rjksZSlfJ4oEAGzGsI3nbC3p3uxzNPL0NOzbMsUS7EkG3yrxsszh4TRgz9mCZbnRGIWe4azljbbeBTVc7J6kcTSHKpazf+OFhQHFNV+7aeu6FqKk9y8oVLOfHrOjanOWlEXipAl/aJ/80zXSpsj81ysXkHP9NwjPCfNAqLPKgUN90m78wPQZ+M+zKJ7qnsZjV2tQ0qkDR2bEi3ZkbIeGE1mGc0H2HqsG43Rj9x2LPrBlkyCbBBW1kmdJd2TGfcKra3SE9zSmqCvNohW3ynTcOAdJ1DTNi2VomICf7DTPy3cQM3CobvChoqEXORQ1PhFTBF0kpoiy9ep092EZ2h9rJCoosDMQrJl0OzdDqq1AHNRAHmiJ8qlK1ABKtrFQ2ur6exThpRAIxVJHCtk7rx2HamZbXfGZ8y9/O2Ze+2ZV8aoQCFP5Jv/o0wHsYeN3PTjn4pN0GU7pBcd2V6SkY942TJzB0uw2RndXBHe4fHL0V7CdppjsO4a0qUdVtXZk6sdg65NGxU826FsC/9KHgLLBR7cAKnc2yQ8lff8yrLs00FO3EI+5EG94BLr4Er4e1uE2J3glSvS1FNI1UjRzMqc3bWbqaXZsnE8DeH9dQ+Yhx1AAWNOAYz5HkI7ou3NXQF5UUnm1oyKConNLNY21xp1tv+T33gtz9wL4G4nN3QBSbAmzcoqOHxR3LGsEbYcqG+5FNRm0BBOCETKd5M+6YsMth7eXCC+4dj62bL5Qd5aYAPnAS9wBJ5wptSZ2md6r7QxG2Q1Cy3t/9IvDdNM+Xo4jtMIm7DzQQOMEL7WN9yca+hEXuS0vMKge8sx3EXpONR3aQknIsxSvsx5qRgBagnbvaDd/X+Czc/Q4OVvE1glkN5kTuZpXt6TaaIiAFRurnO2ttNR8tVC9s513XZ8/t99DrUjReAGTneEwe9/cTiLbTR9fH5liyUebqSSXumSLqQgHuFjN3YNvwYL+EEoAASR4rZuIoqJULho2pPW2Qt0wuoh79LI5K+PQOMBW+sbAEU8vsq53qd2kNhALuzBPuS+DuQ2f+ibu5VLCNUKTti/Z7pfeZbObsTLksuCUO1Vfe3bru3b3rmY4XVfB1h6OJBjTqIdsAJMCv+SYIxRcLPu1X18PWcMk+A2gjgmeW3GeSvv9K7Xaw+1dBHn48vlD7TvA3LtDW5FkH6tF/0HdGXwH77ImL7ZHq7pgO93+005MuMDQIQxtHCmqu6TsNEckj/5lD8Lrv7JMW6DnDDrLmPrXczyoe+rVckkN//rQU7zmivLOJ/gWXmXJPt7pEDVeUmoyn4UeEnlS1FzN/fss+/k0P5FRH7CTu+wrPvu4hfmfqj8JZD1BDxKaIZRFmUGb7PuzEc9J+w86Gffa5/GiP+ZZ7vn/t20bE/+fC3gJIU0c99u619JPa0YJbK+YqbNe9/h9P/32YzpzRUKhf/hABGIzxo+aAx6gfL/Q2GQL3OyPHzYRtK9bt160XqFRyObHEeOsNEYUqSfWZJmnUSZkpMmloYKwdmiAoKEBwgKGLCZ8+bOATxxlkiDalg0aM6MYlt2VKm0pUWdNn0aNWmzX1SPXcUKi5SoS5a8fu20NRfWYGXN5tLKKqwgSJBY8bJmLRYvXqO6QgIkaM/eOnnb3mXL1iusVmanPqXrq7BiRZMuKRqkBgwYIjFMlCCRucZmJk7S8AH9Z2AcMWlKT3aTOvCgS6UKHyYa+1qsQZPDTMEtRTdC3r0T/ga+GwqVg8SNO0lCJTmVM1SAO4H+/Mn029SlW1d4vXcaPayFilPnLZx4cuPNny9XXv36//VM3UtVxkx+UlmtNk2i1MhR/vyE/P8HsBBE/gukQAMZMfBABEMRCEFGHjSwDzTWKM65hBj64oseXuiBizZo6Uabix4Zo8SOTmQjxZH8YPERkmY5xJZENJHxEBtZ4sQQQ2DiAAKdfPKJACFxIvICN2QxJj6okFoSvvegOiwZKasiC62twPpKLMKqrAotL9WyJI8yqigjj0hGoSvJxOpjBa+8+FpNrzcH07IVNXdphTD7XHPsschS6yKKzTjjLjT9Dp1ENNAUIS0ytgZhrbXXnLpGtkpnq80233LjVLvghGvOOAtFjW7TUj2tDjtVVW0Ooe4ehMsc9GZlLz31bJ0m1//ynoyLVyV/se++TfY7dEBjAWykkEqQFejABCMMBcFnCzS0wt2AwEKKILbtMBFaiulllkRMPNGjIzTySEU8QGLRxkNyfPeQGXNsySU6guixph+B7KlfIg0wUqhemyTYSSinIqtKMLPMkpWxEob4S7X0ooGGEGiwwkw0F4sP2D2/klOvOkYeOeSvFsszZcYecwxSyQK1YggwWBsQP5tvZhkynXfmyq5dBpaVvFwrpYYSyVLtNOnrRhVO1DeWEJW5TZlGdVWrr27ujEIVQSUa8HJ951Z4cCWbVmzaMzjK+hyxudia3367D7eP7cPBBKUNJFo+DIy2wYEotFZbIBRiAQv/W+4JV5MSTTyXXXQ/AinFEg8Zw113V8Ic3pfk+GEDmn5M4ICdhuTXAaC6jq3gtAluxqgpu/RFYa5AbhhitbNyOK0wy7BYCSXKcGux3Ku6k02vAuOLZJIBGUyxNNPsEzLJSE7tQWE3sU+/YK/PmWXXvv9Z1kvZEXocopGZxLSplWYf1TWAAWYNJHY4TmoLT7UOfyfuxxpp/LWG1CSsIQ6h1cqA5DvgNhS4wAX+Kiprcxux5pasCU5LWnKDUN7qJjcG4c1voRHD0zrFAxJq4XC00ATlFuc4kUgOD+mS3OQqZ7mV2MhedNBCCnwEOtH1kF/+AsomhuIr1RFRKVNqneti/7dEJpaCYaCAolhud7smpsxPeRBMK1CBCrSsxTWG+RWbOnGX5C0veGk6n2NaNggxlakxW7xPsFSWsjh2Yk9jxOPGehW0dPTRj328xjqyIYw/nMZ/h6zap95wC22sAmqk4l8iS6W/9lntNgCMBFzGh0BOlk1sBmygVHi1trbhB26nPJZ++MagDU7LlRik1gefpgY1gEoha7AFLWxhIzqQYXErkhxHgrlCOhhihpbjJRzoAAcs9IiHz/SXAIoEBjulzohFfFISI1YKU3RTeN2EYu3KAhttTpEsSELn84DlsbDUaZ1qYso7r/QmM7ZGnd6DjMi4tsX6zNGfegKoVuzovP/WBfIcB/2jQQP5DYYSUlOmsmTTJOqcRYRIQpBEg2ciScnBUbJ/HnXDo+JDQFqhw6QJ1BU5zhbKg/0KFcKqYCpd+QdVNoKVBWJQ35y1oJu68g4/bRRpsPCGNRTCFrZYhbKKKa8VpigHK4QqVHtZzMphAhOHWOYytfCDHf4Lmv/ylwOMJEQlYbOI5cQdOE2hmLXqTpxSYt3tEPM6utD1LO90XsrguQzYCRQvynvUXS5xnyuqwTtzQSfK8oqWfia2scTrVXjCJtmEUoMayKiFKv7wUIh6imq9KSo48nELqC0ha1QwrdaiQz/8ZUcIHo2op7jjnZEW0JMlRSjazBFXY0D/0BE0TRRNhYuI4RZ3WvrxIN9cGVPiEoSoEyLqTyuB1BtSlQw3uK4voxpVX86BDN6VoY6yugV8fc6rXyXdTozUiCRd06xMUqLE1DpftkYxirjAiihbak6E2Y6vVJJSnsLEFlJM6nVX6W1XsNjGMjQ4evlki53gWTwA+3ev8eHjH9Wx4Q0/Qy57YlQtjVBJRHr2B32gBThukY9u9KG0j+TN/ZSzv9XC9qMRVZ93NklSlHYytyzdb2+3F1xF7U2mipopc5ulXCWHxlAGqsQqTrE5OVTZyhDJwhzA290xbLmXJVrmGByR1ZdoFQUW0Im+0AukA1SACX8Yonv3W874Xomb//P1plvvG7skyjlKf85vfw/8XykJuU1yssSWBh1G+0RiwRrL2aPQeWEHVrqsQLsUhzXdYTw5Og8v0xRnJek+0YboFi5+sRdCVarlJCcJNbbxja2jWgAKcMe49fGPgZy2dTpGNIpAcrAHJGxUFnu5xUoutZ5MtwJVOUPPHmqGrKzlrH5Xu2D2ZXernVVmckDN+wJ3NEknARn8IRZAey+dy2kl+7Ybz+3mM2+bQk5BW3jR/5WYYv2pzlD4DJ+e5lqSrjHE+WSztpbysEITKp66RMLTdbBCg+tgm0A1YdYl/pTSiLPifORDG7e4RVJTPZzTKuez0NnBa10ra1ZdMqSDQP/drT+J6wKujtAv9fWvfyoaY++02I3Am5IXVNNXJqsPP12Dc5+79J9Sm9o7+q6WwQyRbGeZ22de8w/TW4AHlDvOfs4mfK3C7nCW/S90ene80w1o/iLY3vXmksru7O9+00WNa2SLrT1McCVZ01LjyTSHE94Muzxc4oe/AsVFLWqJenYJcNBGxyUfokWMnMaR3OhrnaNyll+cOm6IwyR+IfMe63rXTlonHBMV4jjYwfVHNu6xUzl0oHNQybBvNtN1v/P90IEQvldqVqk+VTpkYQtWJ28EJHDecIcbANJss9cvffq4fsnstDu7u/dcMOqzHe6BPuKgI5ZvXPhbZJD+t5v/MknwvWP6GV+Df+D3XvhHUw/xEp9MFBaPccdbaBUVkbyOayT5STntQLnMg7XO87ytMQbSo7nz6L5KS6xN+LWgar1lKzIMXK7YU5AKkpsPXBZlc73di64nCxBl6T1qgwiHeIgOWSYg8Jysa75o6jpGUIXpW7tjKL/rC5MBCyy0mx1RcBgEQ7fuEzvv+764YyLDwB3yYytIgDjf8Z30kxM0eQb22yNkeD/4E7ziuYTzUw0zEMMxRDzFM8NYSyTUggPRCsCO64ZVkJ+MYxocSMACVMD+CaBYULhcG5uTgkAjPMIJpEALpKXXc7KdO0RiI64GUZDkghDam5vRGME3CKHd/+PAMes9THS6G2iIFtyCT9Shb5NB6AMSCogBOzi31YGvsCO7cHqTOREMIMwztXOKXVtF2FjFQAQ/o/iSXvQSLsmdgNpBvKgCJbgYGvg3CLsETeqVLcy0hYqHdQgPQ2MjLCqZNtIaQNFGMuTGM+Q/EkOtJViEyGtDj6s8qIEtBKxDzus81aIZZeCxB6w5oQkyISMl1nM5CzTEROS5D+rHJQPIB0m2SKTE4pjEEVw2ATEW4PO9ORizOZA2aruBHmCImFC+0PGh5pvBHnoAEYA5HDSrVgSF7MM+WfxF7lupXFRJJPQvJ8QvXHhJXxTGuSNG3wmB6BEsSWu/hHvGLiw8h/+rv9TYRtToxqLMv4pDwxuDmnEsx9GKw4xjgsybsd9gxzu8ONqKP3mcx1uUQHS6HtEANYorRETkx98iy73ZG4J4FoIwMqILQRDKsc9gun8kEObSMme7yy+YyCB4gTk4AQXAyFEkxdJZAVT0sBwUSVfUPnh7GCJMyceETJVioO4Dv1xgkiZ0SZl0Sa4Awzqoo+5xDAnbyfZLDPp7NDERym20P6I0StZEym+kDhJalXBkyjbUBmaSsaq0Md2MTc5bOUuqtQY0n8kqqZSaTCIqOLyCoDFiFMqwDR7QlAskyzsANurMwAdBy7JkMgpaxII0DUuUPWYjkGnLEDXAEDV4AQ3/QbNnysitYzOONIE46Jq1cwazsLPFtK9ZbMwlkczI9M+wiy9CC0TNLDCZ1JJg1BLOPDuWwUk0sYtQgIvi6Tf604PTrFDVHMoxdM0N1dAuOIPXtMrp+IFwtIWmtIWtwqiTS4JXq8PfvEOtCb2u4UKtlI1rUk5SYhtHoKWROUrotA3pBLYgRcTp5Mdm6QMOOtJjkcQcm8vwVEiZkoM/uMumM081yJAgYAGdcM/23NL2fIDTScV0a0UwIVOYDEYzvauoOM7/ZFNd3M+HwQYCPVM5nVO1mLue6QonatDBGoV+89NIE4QK1QtBhZRATc0Mbc0Ga00Q7c2rmc2FQAI4oIVy/9SGTIAabBmck6OfjlLHpMwfWpstRoi5rJwVr9lKVhTE64mjRuFRMIg4/YvO0RDS6qxOJ0MQtlylSugpgXiu0hjLJhXPngtIKtUyK/0CFuiq0UmvLhU39frSoGgvMa1TNPXFJtrFNW3T98BWXtTBNxU7OpWvzOwiav2YB3O4uyu8nLTQ0zTUDEXUDuVQeO1Ri7vDcIQayKPUQkCCjtpNlGvRf72a5ADVGLUsUi3VeCQPVJ1AUiIs6UHN/IuZKPBRw8pAoLLYJeBHaQkFV+iDSgjB5nqu75ROhISyJ729Zsu9KBWNpNOQE5BBLh3M0RGdZxUYNa0+zWxMy8xZ/4KGU//1w2y1RW+9zPrE2aKt1iXckiU6V4dj2ugxV6YlVEerUELF0HhN1EVlVEf1KCrY1McjxwCkBTjA1E7dPP5JSt60DqnJxo/cQ4QtoPHxu5sTRIa9j5152IgdgrwNg7Y0y+q8QDTgA4x9sg90hVNwBVZa2YIkQUTcTpOdvTsQQZWVUipNgQzQyMCE2fdss66Tz2iV1p3Nr7HQxXI6Tt1Kyf4sXdS9TJ39L6QQXcuMU9DNWV8MP9ix3QBqWqZdWt2FhO4gVN8V1At1V6tlzVeVV1jNWoBVFUjdV3wNwG4AB32FsU5F2+pt1P+htZfjJ4EbTlI1VWuqtHPSK7pdI4cFFLz/lU/+kCBgC72RDToGqYTCTdLELcFDfIPJPa66nKmdiyWUdTYgsFwtfVmtm1nOFYo/W8nabcmr+FZv7TPdMl3V3db+TAbXBV11q0yihd23Ez/dxV3e9eBBDVSqdRQsmp53JUrkVWEzTLwVRt5+dVF73dfanDxa0NdMDQ6upTHY4k0XrbGNMo04KNQ3mgvhlD9TvZS4ldvHiqNGa1iHvSRa2g9VoGJMIBb6NYiELNwtlpuDrN9EDE/ZI7ZpazYsSIEBztxmPQCxagFU9NyQzIoF3k+encwIjkw7pmC+ct3VHTsB7WN5Q0Lf9eAPJuTuGGGqfbQ/4Y4MhZkWduFGdmSL/5PkSfbUU3GOsYWaQvhaN6wG3MRUHDA5621RIHA1OizbRApi1QwsLVITLQyagem7pJAPdWJi8q3A1iMWq6piTIgFK77iSYSQjd1iw2UQ6DpI/uXAMA42yW06/k26KuscNG5PAPChmD2AUwzTz8VZbXJgx2xTCT7d1N2112Vgvurmcr632g3fZXC0B9ld3H2VQiVh4D3NqkXKSNa/R87ne6bkfoZhTr3k0jKETWYxcDAEFA3lHbZeUAblqWzo/XG1WAviODjfV+XRHwxNCH2egpvlNdGij5aFHFXV4DIlflKFWsisKq7i/ABLRkADnAKGaoAfw01SYz5LZd7Af6xY//+1MjOW5mrWXI6MAUTIZqXYrVw02m3u4znmT3B26gnGYHMWtARGYKr+syFmBOAFSnn+XXo+5AtdZG3c0H0ma33G5854LbSGYYUelUtFgoEGQBbLBxve1+nV4Tn84RUN5YZ+Na4FZTsEqbDeUKEELDM5142ZtI6hC8Tip5HmDziK315W6SqWbI9VBZYGXJxyhZgGBsPlWIHA2Cjl3yjN6WlBZisj0rQ8RGhePn9h1hm05gLmAUco6rN5YKUA12qN6qn+z6cWZyCTXauIXasG5HmTWqzm6iGm5+WeWtAT7Hg167LuDH6e7upOQK2N4X3tA45jsRA50U3dAYFVaN9UueT/CO/zRg5SVg6GHjVf5Q4WJuz7ezSdwR5+su/GhqBeHob9nmwqRun+pmL1pYSCyJv4hZ/OdoVlYRAnC+NI3N/I5UekK+MzVuOgJmBqzkgMeAJK+DqCSepeHG493k+uPAag9e1TDdASh92hbZ0Vp0/90uoYl/Gpna0Kfe6xZmHp1vEdR+se5+GNuutTxhY4uIVumDxtMIRN1etLBthXox9TNrm/fnJ/rZqJdrmKi28wWE0zQM2+eBSauQ9KuG//ZoZYSGn/RnMAtyoJEogz4IMoqwaZ7uyP5VX+xb07L1J/TO1n9mmwatY/r/BS7AD5dOVtxe0P123epjMXD2cTN/QN/9ZZpr7tFzdu5p5xS7fx4Y1ussbbV5XkyrBuUC+CHh91elUVIW/RgAYCOFgEGmFDW4iaV6NDKifvIA9vWX9y9W4t02q5VDbDocxGLidDwxIWk54LzPrvk072NKdiyW52NT/cZtnYA5dfRkxI/YU91TaUId1z+1WOC/Bz9wR06KNmaYrtQa/tlcztDe4zRZ9jRjfq3zZxXgxx24HTBCbuJsH0fW9uFI7kHOfxgCf1Uh94HhZlVW/ePqiGjzOIXB/vhw9vIGgBHKDDjhocOpzylNP4645i0rjyoTQsrXHnutuEWNjv87kslEaGky5zM0/2MwfwuWj2yF5zPx1mBP9A0P9Qy2fB9p16sn0ULm1P7YJAAxwAdwMw96Qfd6XHcKAeHdMhdDkL15O8VpaMU3pD50Y/cahucYgJRHwHO17hd+YWw2Dn5+MF+CYQ+Hw2goJve7fXTRxWx5WLGipYg1ZfA/bevHUUgksm5f35+4j/aypogY2H+AW8JFcRSiF+Iz/1Uy1EdsuK/GHILGRXeQD37P7WZV7e/MMtXGr/bAoKjZ33D/X1+dTm1WHVc4ulRCGoACJh+qVns+cLahDggxuM29XVbUn/Y6tHwnjXeqBV4AYucXoL+6p2Dz1Y2zMw4X5Xfk3v0E2nbokVdeq3/re/fuwn+LfnqAPsYfWue+eIQ+r/9VfDFwKMl3spZy3zN//fsPJFwY9+83zKH4ZQyIb7p/+TF4b8R3aAGCawFkFVsWoZTJgQk8FMCh82ciUxFLCKp1wF4pMx0Jo1fDQiIiRyZMg/Gz/aQfnxD8iUGVOqNMnyDs03b6jM+GAggACePnsOCAp0qNACRosiPaBUqYk/AplB2yYVG1VnyY5hzaVVa7OqXb+CbcYV67Jcy8JaPev1alpnXslRhRt3Kl1pb9d+NWsW7V21Ufu2DezWrp7CZ84UNmzYDePGjsGY6SIZ8mTKUS5Xrmzk8mbOnj93Dr1ZB5EipkU7eaJaSGqcqV//gM2aChUcQHYkoa17Cc7asVu7/5YtfAdx4jhs48C9A2eS1MWfC0+dxiYfVKoIIhOmndp2Yc+yUezuXfww7NdlXUdosODDWO4fugpVSeJFVxWBSWy0MibIQI3+k3QSTAPSNJNMBRrIR0c1YRGHGDk5MNRPRFGYVFBKWYjhAy44ggxUVdVl1ViDjYgWX4D5JRhbg9UlF2B2wTiYjHiV9eJdIf41I2CI8ajHYY8BaVlkmWFmWZFGNpEkaKQtKZoNp0EZJWtTrkbbcLLllpuVW2apW3RXUimEa9AR55qVZIYpnRfT8WGfdve9OQx+2YCXzXjk3bnedcxw8h58fzaEySIS4Ucofvj9xx8aKwUYYIIEIihgTf+TUmcTFk/YkEGEElbYKVBHgYphUht2+CGOKqJKFlh6objXiqnOBdc5sdpIo4wnYqOqjjHyWqtbPv4YbBrDMkYsZUMieaSyySrppLPPShktmmI6cduVt9Gm5XJA7GambGd6m2ZxtTU3Jm7JTZsmj28g4oqdFb0JJ0XgiXdnnOmt16cqzACqCkOBuhfKRBedcigwoeinhx1oLLpfHyE1+hKlE3O0oMQLMogFFreN8MEDnoIcsoUXIvCAEaVO06utfrkaFle55srqVjG/6is6tNrcKl566Zqiyjnu2haywoJh7LHMLosk0qg1Ke2TpT09mrTYgrnaD8jVxpuV3PYWHBT/Xw9nLpXWFnfcc7mlS9xrajLcCJxvv/s2ntqVp54qffLpJ6B6B4xoeIXGp+CiDHvEqH8RPxoTR4dTvKDG2Z5ggQQPYGCA5Zf3RMDIIm9+eQVNoPwzjS2T7nLLNdLss+g452wjy6fjGvTqfgU7ZO1H4w4ZD6B9Nlmzv0MbvNMxOP0btWKH6bVutmV93JZgVz32lOPaVuZzyKu9dmWLuin33xXVrR1B4mdnUCoGHeKevnb7q9B7fN9H6ET6LVy/ww8DWNLFFMskqR2Ob20GkZMc5TZAQFF1DikVOoAAQNVAUWXAC5WASspqVTpd7eUuYzFL6lR3qg/KzlcrU0vPPDiV/xAKbWgqzB0LkXYFIgHvaU1jEtSkZsOoEc8IaZueuGajnOVsq2vg+hb2nGMtyC3HbNraoZLWxqaC0akaUpTifcDjpnqJb3ypkEUtDsEMWXAib/ri27/aRxE3IaxQiWLYogp3OABRIn+Jg5R/JtWRBqHhawJswQAn50cLGDACCUAg5z7lQEM68AN22NfsNAi7t/BsKxsUS1nIwrrWiVB1ZNlLiUqIwp8J7XYrZCFmdOBC3sVQeDQcHmlwKIMn9TB7sSwTc4BIrjO1JnpXKhdygPhDJprGiQyrhEXig7Ap0kluWDSPFvVWC361x5n2kVP8MCIxNjosf3HU3xwbB8DYnP8gnCAwoB8HWbLJQaABCggVAhKIOXcexQEr4IOHorE6nbWMZlohBSk6ScmwtCiTn3QdCQuaF0+CaKBqeSEMwfCahp4SlTNU5Sor6sqLtnIGs+Th7qRHtt7ApmtfMlP10LVRjqZLmHdgyB1gOQUs/OEU1ZAHN6gIL3ilIqdZdMUzBaKn9vxLmnQTnzUFJ4ZhUWdxcsTf/iBFnTtqDJzhPOAD2qkho1Q1AZOzKiFB9s4MYW5DMTWVrCqIT75IkhWSPChCXYQzEzpSgyNE68syKFAaMSEKh4FoZnanuyJZIaJ5HWwqKWrRw2JUah1F6WJ7GK5wHQ96VwOC85gHJmBy1In/qglEJQrxhwcRzwVGWCkwkEmMm2YxtXvaG8BigQkt0o1giVoDG5HqkjcuVWL8kYNKaOsaPorggJfjKjuX8tVCHjK5DyQVWS95q3/SlZ/89OeKsOJcncUOrq/ryszsalDtwgobfG0iKY9mSsBO1LCJvSEORZtRHDJ2NNNrrPWmN0TJek1MlcUsEzVKXh1OIcDsykRO/7A7EZTABDFgV0WkyI3TKlMYp3imeXy6LzKuR4v0qUQjHsYHNOzVtreFmBx7uxHG3aFivcmJx6oa1hcPt7jHnTHnQMVcCrrIrbaC3Vak68+5WhBVInzkd3324yDjta+qIe+SlQaZwAq2sOxF/yyV3bveqMU3yx4dabXCBrkiajnMY6NCij17KQe1wAQKps0a3MYNcDwYtfWqz3VYC9vYImyNIV5TUnHL1EcxDsU02Rg4W7yTGsO4gQtUNI0RWRSTbaKeZZ00YLobSVZM17up6hlBFQpkscjMdEUOL1q7wuTxNvS8YFB1etVb5Rq+N4eyhq+Y6atlLnfZCV1KjUn5W+vZsPkNPCBeGIatZgWvYM2FSIVp5azhnwqVINzRjis4XBKGeaFKbEqxnwWNoBS35H9Q1c0PyEnjczM63eqG57ofAIZYpKy5OvbKWtNqb4LWe6CaFijqRu3vDn46yadGddKiLGVYI/zKsaayr/9vbTVcg5NrqSHbrysO7Jsc9SZPAoEM8BgDECh4wKkgxhQhXK/z1Pkhd1aP/hY2rO2NmJu6bRykoKqFmxN6BBAgrlcP3W7lItdyJoO3vN+alaMHo9771lElZ5ZJDt4Vuv7e5AX/LRhOqiUXBP/vsnon0YMnPOwKX/isG27rLX/tB/kVjrYobnYxA0cMq1EDTYhpkT6sobFSeEMlajrFeLHnpxkGvIVn+4aXKynjkQoE/hTVW4zZsQ9wwDvOb361A6675+gGenJLpgaim3Xe9M7KWvWp0KSPqNNQV71gAk5k12c9LFz/+sC7Tnuwj529VtbB7medQ/9aHO1jAw61WlP/PSGYlAk7BL7FvyYGjXdgwXwvWEVWAYxMyEEKAzTBDwhc2pITNfApX/lCZuKgvQZ429msI28nVriaL2jyHdmCzYOAAhQY0Kqe2jz/F52BOYBe6OFb0iGUvqXe7LzK6p1VeLGe1WkSzdze7NWewbma7+VeaMVAOGWgBdIa83ngByaPaoQLERnP29WaSGnc78FUJtiCLTyYIdBW5JzAD3Dba5FcTaXW+UzY4O2Uv6zR+RVb0YTB80FKuDlepRBOg9iE49wc/cHBHWELxxBQ50xI5m3eujXFU4SeAAYcePUK0sHIqZgI02Xd66GIA46hA2ZQBLKhBEbgeg0B2SVW72Gg/2hp4CuB4PUwVsSJy30Zzx/6kglaHJllG2u80gzKgSasQiEQ2g+kQEft3Zlhwg3iIFHxlE5l0UVYG0uoQSE2GRE2TBFOjOAgoaU8jilW3hpwgRxUXhA0YgqcgIv13yz+XAfEwZ5MQzlwYRd6Wl3oCggJGb3lG15EHdZ92qq4TK4wTRvanu+84dPQ4QW2lxzeIR7q0PJVXGz4YS4FXzdylBekYJqp2QeMgCvmnUbB4lRlgAWYgARgAA3Ox/edlk7R405xWBy5XIA5lEM9XyeKGEy03xGaIiqeosbwBs7Jgfw9Ic7FhiNGjixGSKLRYrs9gBSkxzXgWC5S2of0ItDgSP8weGFgQB3V5VvNeFrsRZLUtV7VUcUyMqMbikarvVrYRWMd2iQHomMeemOuPdxlYeMg/sbyiNMMOuL9qV0QSMGwWYCmkCOyESEiVMLIldY8jtybsAc+AuE+iiAQDovimZiCvN8SEk4SFmRZaswdfZM2FtoHYMAFOMBbRqREWiE7CR2H1AJ3XIMuauReNtIIeaQvWlIDVlKmHSAmnWFcnYUnEZnWuSTwvCTu0SROstLGVeMGWqZk5mRmOiR/AeJJeaNm7pDzCeUM6EY6hlMKYAErsthQ4uFZlhmz+V3cSJgmIsIddOIn8kD6+WNXVspuQZ4pkuUpuuJwImVDauPjSEH/UhrncjZkBcClXP4co8HlBdRAHGzCQXgINeTldsYbWVnDd4In0ISQGPYld0lXpp1kMYqFMMKe7DVmTD4mTEYmZkYJNd4ka1pjNYLmfqrdLDVZZ36mTmIjbWDbbaSjASFoCkiBKxbaCPCAxjxNQ9oAFhACbMZZNXnW+UHiVg7hUQVbb47igtSPWRKaQZrocgZYcqYocypncrpGi1VVjEKkz32V0E3nBZSADsTBH0zCdXpIdnLnM2DkdpqDN9jTX/6lkZ5QdsVILpwnel5XMD5dJaVhjZihMqpXs5RGfEKLe3lpTUrmfV4mcFUmmWogfz5HaEaP2wWor+3GDzBkCiQo/5liSyNCKCA1pZrZwBTIwSTaFMFUwmdNwYauqIfyGYiO4ljexCnmkYk6KnKyqHEWqlp+KE4AVwfI6IzC2HPeaAYkWBwOISP0KHoYgzEIqZCqQzqoKkZGhXbRhZISY6WRAiRYApQCIxqCkkq6yq6OTuydRbQ8Y7BWIH1GCwfeJx/BQLKa6QgwK8idKZruZJsKqJqCC5nBwRKcptbAogWEk9pFVXCdpguEqwiISR9kQjGdAiHYJqEWaraBoihODHCy2aNuTA84aouyqKE+n4syjGuy4h0hHwFp6qY+5wUYLI6SQMJ+KpSlwSCIaii0Ai+YKqoeqTIk6asqKaxql5Oep/8CbqR4JmZIgux6UmmR8ZhXvKdhPaY0siwHIuuyrgDMsmVbkmO38tAjCuIeUs9PXmM2AlsLVEAFtMDNqcC27BGmTo6DeivHPOsGdusaYAKB5ZS6OoiKWm27xgGiUkrWEuSZnSW91uuCXq1o7oYaFCTkrYHkqe1/ENrMvmWM2WjBUk4H0CwGJNix1YAVQJkZ5EHDOmwkXMIoRKzElmp4nqo15GWRFukzKC7QHKmS/oIvwELpzYjGGm4zmGTsfKGqIBQHmSFjil3Khh1hDSuxhqmYOu3LxmyzktPBBi0f4Sy0niBK9RJuWAvW8KzDRdY4cVwQccsOsG45xuBRxm46puP/UTJe1BaCum7BbqKobiphgTTVFyBh9Hot2J4ov5ZlKVaKxTDe4jCVagJBx8Ro3N5oVQVt3eJtDSTrEOgtQ0VGY+TB/NLqJSiC4BIueG5nqqoD416uxT6uxSIdSH5F4wbUd2Ju5hawYFYddVGpZ4SuKpGuTM6k6c6h6sos786sc8ooBXQAx8FuC6TptI6wcZQNto5JrxkHm3ajEXVLR4xvCyBB2mJrttJB9j3rxhhvt5rjHFDtbVDvF+jrpUTiKcKfWCIxHjHqvJ7l893r9oqb1tbR2n6v2i6v2q5BDHPwdHaqwX4w3uppErDv+5KxY8yvGf+tqOYvqq7DOgyp/3Kk/wCX6i7QMR2zRXhmrAEn8B4r8K3WzDGsxUhSVwQDaw1NMAW37GS2FwazZrOO4wa7pdx68DgVryCai2/IcBKlae0iX86OGRLolwbLsBYgAbdsK4ICEgQoqIHywPEepBAXZwqwQBB/LS1/QfslqqVwLYmCohMvMRQj8aBJb0LKxMMY8zFb8RWvbRbXRltWFQV4cPrSrJo5shKNMXrFbzYDyfzqgSIwAuAOLuEW7uGOswBLbB0Xrv6Cpx7zcR8n1HMp8CSFrK4Scj1vqbCOnQVfVDVmMN36sx+Vr/mSYwyzMgkbh/PYV0nRRgmrsEGHJhrwRpr5c56iI7accjhxAPXaX/9/AoFRmjIL7DALqB0tE7MPL04UJ/GIyise7R31mi0vL2FNEDO3VXFNK3Nn4bTazofkdZZOL28MSrTrrqPdUnPMIlscjjEOXME9Y8b7Do2xoHEk8MHf4i8qrDGrzvE5B6YBs3OVpqeJAHIHhXWRKbI9q+yUFas+u+whrq4IOPJEO3NAW85PoC/HFbRDZwvH1NK5ROEPUZa0ctRuHIezZjIShHAQ3LDxogD9cQwHyDJjl/IOY7Riu6IPF8IN47JLQ7Etr3TW1jJnc5scBFoy+/Ty5vRp90G19XQfrDYySx5tOUFQryMJsCUYK+ttTzAZH8c1ixJUM8Zi0O/9Wod7ZLX/Vl914sJxkeYIAjMgGaahA4N1WTMc6SIcIqO1dI8pW7e1Bv9z0gI0p9pYBWwAs1aymCEHH5VJ9ViLCAMR8zg0f3WLboiwKQ/QeKdmLJ9yIFHOKkc2RnPAfwN4gG8Aat7yT9uc9cY0Lac09c40TfxrR1Tx5F3xaVeCIWACTlt4TqdrtbE2xNwja+N0Z3XYMoMWgt3tF4srBiY1U3OGGLPviyu1sBiNKNUB3wa3/dpvxFb1OL8xOXM1c4/ayJpISjYwzFgFdlcgdU93fpbuWstsd//Rd4P3cDVAzcJSfzUPEo0wupy3J6cUIdIGbwAvBkQAnjp27AIBQwZtOgHS/T2i/1G6uX/Xt2OzOZw+eNaCdhALM0nLtEknJEnctGmH+KDPx4UPemqDOKIT+qLvdKKLRAqawGyHMYxDDW4v9W7jwLHlqNlUBtHczjZHdSngL+YeLsXqr/8q98geI+oIsleTxZLLoQQruZaqdT5nt+pyN5QD9BZPuY1+seze7rb0UvM0tJcL6BkIpbVqgQqMUwQILx1ggQwuNiP+9zpO+/jKqSwjpZxWOyoTEATgKc4Ggdn2cEmb+5+bNKC39oRTeIhnuKEXgqGHOIh3VroSOr0TOofHu6DXJhoYR8zCeMBjeqXvtqbf7aYfR6d7OqibMTffOP6eepH2b1e7esVb/IqYdf91C8+sN3mta3c/67qUi/wW+7qDkrBhZwnz/LXtAuh8ofV7HychjhMVxKkBrfIpT44WQDvT5rc7DnhHjzeClvm3p7Lk2LwUWDYdYPZlT166q7shQH3UZoKFRz0mvDujYz3WK7qih7hELHoc3buHFaIMCPzAC/wjd8CJl8AFhED0xWxzJMmaQLVvU0aQmDHg7vjhpmpyp3o7DzmTVjysy7rGd3wil+nH5zqUS/PI+3z+DRcGgPAMhmbZ9BqYYRlggxOBokGmIyvXdHQfrXlVbYAjcg1IEz24C/0GREADuCPrZ2o6nVMGOPYXxPsiTPjti8S+G/ohSH3vX728Ky+h//7/TjM6a2OEalebauO08md9T7MEaJX92dcA2vszbUN+CFCAwrYv2wgh3R+NwxdGHsRvjT88xK6xMZhDOk9dAcLzPM9zImfpISO54SP+pY4TXIN76Ef5/lc5QGwQWOGBAwMHH1gw0aLFDodAHEaUuAMiDotUqOCYuFEIxxkeQXbsiBENyTVLgDD8geKHli1ANkCAIDAFFiwpOaD4IgeOiggxN+jUErOBzKACicqUsDRhgqURahoytMqWJkOZsGaSejVrV05YD1XCepUrJrOV0KZVi/YqW0No+6g9VSnu2bR17a7Vq7aPq0KN7DhhAmNFDcIxDJtQvLhDYxIhHJNwjEFy/+WFGrt4CbOZM+czn82AzqNntBvTeUCbqVNGSZ3RkWCPGrXLmLVnt2sna+Zsd2/dv33zhiYNW3HhwZcl5x2jSHMbOoxEdz5denXo1Ac3b7Ide3fvzMGHf359vPgYDNGDGKGefWP3CgkujS+fvvz3FwoivNBhvUqKEhuKCCIqhNBIpJAORFDBAh8qaQk0dmDogw+KCoIOOIJI4YT1foADQwsksCCoNXrSkCYOfpLpAAVG0FDDFJVC4CkFlOJAC01syXEVq8byykev8irkrUqG3ItIIwtZ65S+8nLFLyShdNIvvwJBIw3mamBMy/vckwyy/UqILEzDpuMuszPRPKO0Nf9TC0211UhbM5JSZuPFHGt44aUZ2vhEzrjjAA0UON3KI+K7Qq1D1FAzo2iU0UMVhVSGSNMrbIX2uCQIA6Xq67S++w46iD/0UoDov4wIjAizBBdk9SNXFSQpIxAmrFVEF4EAAoX+kqoRhRRQUEGFFHp1KgEGioIxAk6NzUCpmbSgY6pZuKnqqx+v7TErTIrMS6q0MkmyyW7l6gMvI+eKMki0pKwEsDfEKHDLEiTDwLEvu6QMTMskUww8RsEIGDTQ4lSzNDcRNs2MPFwbTRA6Q8nTl4kltsbPP4cjTlDlfIsUUkcX9S47kB/12GTzFD2s0vbUyxTE+TyFmT57JyTIgAD/HAiRvRRCShXWV38GOuieZcWohfdGUAGJDINiydReRTxKIKV76AGFZItK2gOsofJgAhURyABFo1AIYgubDLHllmpu2ZFHbH8cF61wt5Ub3XbVzRuvdrGCC14bTMBvv/3wzTSDMPc9HPEx/V1U4IE/S0MPNQ1OOOHR9nizYVFky+22ZzxXRvSMSS99496oQ/njQ0seeXXVU59U9vNUtpRlW7lcVtMKDC8IZt5rzs+gnBvoL9ZWkU9e1iUqRUKLmzbk4ASdDKEDJrK34EIFFDeYQAUutkDh66I8GGH8BAhQQKgbXuA++6tlimACs7PPYtpZrD0E7ri5xUTcvuViN77E/+VcUCKEASsxpUbsLYF2QcQdvGARWoWJgl16DOIuUJnEUYZxNGjc4yBHGtK06XJuwtzBRsO5OnkONxYTjgtNxzFBhWx2NLThDXHYOtclKoexg92kLmW7203QZbsryu5+57tPUWB4+lGP7H6QPKFJ8TlT3IjPiuaQFq2nAs+CShBsshIUuWhZy0IAAuYnLPGZ0VgHWJH8JqCBpW1tAuPjWtPEx4JDcAMc1dqRVrKSLf7ZzS4APEu3TiGlKU0JXLEwkgAZSRdGJjJIEDoa7u6zOGctroKMW4xh0jQwEY5wcqIsZeVOmMrYhCJieQrdMJBhGxjGcDgcqyEPf+ixR5GMO/+47GEuZ1eplRGxiEYs5u6UaJ8OMCVUORuV0ExFRWlWh1XLOwlGlna0+rToRWXL0NhkogBjwSgnVPPJGxswPyQsy3tK8wnW0DdOp+hEWmoDh7Wylc+67bOQ/ByXk8y1JL2tKy2qKOhBA8jPPqwhipdkTJceai8tTfSTIUOT5KyUBsiFkE2jRA1qQoO5QaySF8OIRW1g2UJmjI6WxgDm66yzyx0eyJcnQ9kJJDjMIRLzZUg8JhKdqcxl2uxmCHnmNJHKEQItFQcmWUKBcgWHLWzoJxywkPWkV84egA9+RnkBF9oHx+/5YGvJ8oAPkLAAZFUoC0gYXwTiGdf4pSB7dND/BC1ooSNO6O9amhjkX8UiNyY9kqCQTCQlXbGKw87tsKk4RSBXgQmpOmGICqGov+blydpFYWAZ3WgIQ2rCVFruTa9hxCUmcQlUnBSlLIVhblyqsl/WNKY6nClMfYiy2umUp++RCfCASzOfCpW4jVlKMwuQkCcm1YrNBYnPdpCEh1zzklQoRPiIVc7tgRMCLJAqEsTHvSBYbVniTIA6PeA1rBHgjcfyAHiptk65Pot+z6ODLfA6i1S4jRN+/SsnDOrPfy7CSWaZJGHPEmAlnUKxU1psJvy7I/4uQhOK3REV2BPEDU1Up4pzD2bJNLLIbTQJlIvcwj56YjVNLsUKe1PC/9QgCEWcdhKtoA1rTQpb2b6UPL/kJRN+TFseWySnvN1pb4ObZCUP91NDPa4AoKzcoODKRS5y7tCuPJGmRnci2MRwzoCghVwFi7vhpJFYgyCsOpr3WObdWnrT+1Z0Ys17W3WreRWw5jPOJAUy6cEhDpGKPuq3v5pYBCABiy0JN7ifkW20o83iWGHsl9GRXgUwFAtZTS960X7VhBwYSqsN2eAHWkKMCKZQXcV82CFZupQQNEpkJng2DRltxK35sOIVk1LFohSY5awAhmCXgdhwcoOMFbGJTaDCxqjY8S2HXFvpXIHaQRayTVsdIWEaGZPw+em3mexk4Rl1i9PjmQ2sjP9l5BnII6bKFUlw4J5SgZHeXT1zO6XntBfs245rTa9ZkQC+fqcXvBNwr9fIWkfvGbzNePbuHA6BI2pV44/6LItXHJuJWtQiR8QgBv7+eJZMAKMa6RJ5NYghcmB4/NIen8vIL23hubT8sRqnNKf5e90klVoxb6gE4EQkhjeop0pEH/qHA9GHU8cgDa54Q2KYAJiLOomVrgjFKXtNSpAqjIS/Ds2wq+0GapdB63mINm5/bO2z17Ah6Nm2ho/cgPeAm+5N9jZ+ihple4063cxFUIAEpKoHYbNUdJhqTrZAhiBwoI45sXO/X0DhHrz1J2j9Wpsn4AOyekCtcDwfeznggyz/BMud3GMjjVhwgznMIQtj4MQs7nkLWyAaSKrgRMY1znIJ39wrtkB53VaBcgW7PNIUFwswELtyBq8801RxfswprImFaqgQmviBpt6wii+IYEJvkIN6KnH0JV1yAzt4rAsUEoNAAOMPh2GC04GcmUC4ghFnQEMoXIF1E+//syBMk6NIi7SeDdquzYbSTu0kxabcDu4c6si6je4yRZliBlQKIMoKwgLMLcvUbUFaAAkAJNuWh4zKaAN24gXCi/EYr4zQR7vUjPJUcAXRyp3KqgHiakVQRH184BDIgAU6r82O5Yw44AU0ICcMgRbA4Qjxqa9wL9JuT7/MovcgLRVQLgqX/8/4zIIYotD4Lq33Hmv3IKwqrEWq0IBENuACIe76QoQKUqEQLsn71qMQqKACVuCxIuQyzs9fEAETEIEIyAT+tuP+QuEMkiAJ9ID+KEf/so7EAibsABDsEoYR186mDhABC/CHdovbHBACl2wCPcXb8qOZQoTvNHADqQlo2G0jmspoBCKZuqud1KjfkEXhvobx4my94GkW523ftkaeaOTedHEC1KoX2UwYvyd7cKRaCA3jauH2UsHlmNH5mjArVs4ZpTFHcI8aTwELYe7lYE6xbCHjCsGxCsGu2PC3RuCMDICuMEQ+qMAseM4NVyD85JAO2aMdM0EH/IUQ/qASnKAP+f/AIoCsEVzhM5Lg/hCx/xDy17oAABVyIRfxIaNgAAkQ7aZtErFNAYuMATNxgpBCEzdRApOIPjglVJxIFP2uuaLpirwsQjoSKcqmaoIlC0ZPJhovCzRhB2nSezTPB2DxrHiyKLyHDMhAA9aqKIQxGBmPBZQSRRCARhrvzFQwCDNBbarlG5dRCZvRsZoxR0AuK68Q07Qx46YR+XIv07pxKlNOGreQGF6PEyDuEFjAquQgCCAAHfPjeVwCeKwL1BjC+xYCDvkjXOKw58xFCAhTCsLvMhJzEIkgDVCBD6zE/hJyMgfmCRryMtHEIaltImHAUDhzdWTKti4S2t6uAYfoJ1r/ZgNW7QE9sad+6og85QI55RNLEopGERVN0TYRpCCp4CRYEgPfp2xO0LtGb80Qbwh7MX2QoA3aoOCMUp3kjAFEzzmF8fLSxylTjwXGy2tScBhRz2q+gBP4iBsmTSufUSvJ8uMYTAu/MeZqruWoUfdazhuTsBm1YhXmYBwzwLtOwFl24voQwgAgoBCGBQ5GgHewAA6VzgTIMB6X4AN2YBzXQNTkIOl4oOd+LvyITENH5g9cIRBKzAkoc0RFFCJN9P8AMBJzySJDsxJJszQxESlMoCVZ0yPDLTYhwFmYqZmO6jZxUzdzU6lSkbo0JFdMz8xYIAteIM307DqFMZ3q6L0S/44GqXSt0kcD4MxrgvFJ8WwBUm8m12oYgbA/H8AF0qYrmdAWkC8VklGv2NMbzZLk5hMTsrE9p/AL2XJHkkT7VIBAvUtE5sAF0AcCeoANQyUANoAOYsJAEwILAuEETgIESOQv7QBCF2pB9/LnFsJC72APNYJDZS0QQsEOBpEgGfNU3YQgS7Qyt2NVM/NEGbIJVFQSK5JFXRSHYFQjN7JGbVQCk+lXgYs2DWA/AM9HrYjttEgiUiIlRCKqokoLiMWLqrPOllTNntQVG2ABzuoGRq8WuWatFI47wxRZxikCtpMFXIAFzMy8QsQF0pUH5oBOzdOxSC5P49RavhET3FOvRv+uPa1FX/21bVpO+vgSCAohJr7ga+ZAXekgBezSbCAAygSAropiHSugNy1VBho0MdsRDfoAw9YgEJZAU+PxUX1OVp/A6TqThuZPD04VVUusVP8PNFoVVkXUMmNVM7tgVlmnVm31tjAyI2M0E73NRoupyX7VHGMEFD+g3PquioDmBIL0VWwzQNwuVwSkJJxgDRYBQ6oGnFDQqqqVBbageigPBUTvJ4tiAQLuEdqA8761KD1AF9eIS79zDm5AKceLAyxAbBAP4jZtXrkBTrGCTTMNn/w1LJVvK7GiPV/P+Li2YS3gjFDAEFDkC1hgAMiWA+aAA9gryr6ADiLWAJznAAL/IC8lwLr+Egju4PtaoBIeVAgaoTcndA1OohBmgFJhwAn4cXdPgVQ9c2T6AnhhVmZVdWY3A3lrFkU1UyJn9Wdbh6aCVmhzdVeNdsmOlimA1ShepomcaQMy8GmdC4raDvD8Q1Wy9ppsdwnkwBB+ACi+wGyVUl2XBQVk0mrG5ynhaTm5AEvXDFxj8XtuIM2A5X/XdSZuUI8uZPWkpXBx7yvmtRnBktCyshv3Cwvn84Ix2BqpYvbe4tOWJVqerHJBJGEBQAG+wEI8V2IDYECxwHTJMAKipQxVV1K9z3U5VulIJEIxQuk2oB0hyA4w4elS9h9HJlQHkjEX8oiPVzDiT3mh/xhWzQM9njc0m1c0XbR6eWWITJNXhetoe3UCg6eJhjX9TNKKpJZq0zhZrRZBUIIiQO0HxovMrCoux9W9quYXq7QHszVc38uAVdAVs2ALYJJ+naUpsXP1AI2vvoKRIfiBb26/BveCCVeDPc5xOThHpGIV3Fd6rCe5ZhgdLUScpioACIBsyWADCqAuJXYCDAGueOJs4MAQWuABEpQmkm5CXxcNQKAdO/Bjla4doaAF7gAY4GL8eNeI40/Wmu5KXlbEnJh5m1hnXbWaz4SKR62KsQN6lxm3FlCIeCs9aHRC5G7uiqmcXQadP3KTtjfJGsB7KaAxSKVqi1VV5nmeI+S5HP8kVaLGQhbvBu02FjXABLFUXBlgS8FVjtrHgKsze3rAS1cvzcZLDVRPWpTwogEMK2wvgjEtFYSB5TA45jq6wloODLWRSPh0HJlyJyQAARKUlQWgT2kQWglAACaADBbBcydPYiPAchOVAwriBODwAmr4dVfhUV93KEZ2Boh5HBsCdlugMKPDQr3gd6fj1mIWDcYPZqH5ZqP5M746OwTReF11ENEgZsvXeSNRxLg5AdkOnNtDQrZ4ix/wiI7prsGtnYtrqJjWac9YJc63fLUNsPX5ByRERCSAczMBfOZg8ZRFJuQoLlnAB8ggCwCZAWCxzrjzBvUMgY8lfhv5ka8SozP/OoJLGz1Nm/eiL+b0ahHErAVQAA4TYCdYuU89l3MtQGIDzo20YAIGYAASgAtyGgD27bcFIALIAAI8wHIPAgKk6mJ9uJePWj0yYejQABNydw2quyHcFwc09GhOFgdmN1RX4awLUupkja0fJZoF43iV2JrP2krMOgnuWa1xVWQaJdi6eb+xGJe0WIvlGa8FvO7WWYz5mkf9RRTvuco0hLAbvJ5VcqkMO+jAJ3QbtoxYYKGVckszL+EuW34wuwfIIAZbMFpv5eEgWH8cmbSZcaMduAvRc02Z0IEpLOf6wLXFjKjELAFU4AvOiAAswGqO2/Bi4nuCAJQnAACUHAXaIMk5/4AMXoBGsicBkEB0mwIOCgG6q2v8krqXNVW7eVkIMCEjXGFWVkANIeRdNEpEQ+FjPXa8b4u/nzisM3O/x9r+CvJl39q+P1PO29qtAbw0y7m3UNNlkEydr1fcDFzu4JlYyw2w226wH7y+8bnLetgQsKAjw0w75zgpATqcVuR7TNAEXZCdqKaOVEAqXmK8pIUr9Ge0WTyfVGEZT4HWXdyBaY4ZbQ7mDM1cmCdp1qMM3egAGA+NfNu4GQ/KbISxR6ABfhtFlPyEfUIAEKByq4cL4CpXZEQmWgIEWkKuT4IwIrU38xlDVmAHGGprM2JSnKBK2r0R2AVEPdZdwk9We9bPvf8a35lYz1+03/ucZPT7z68t0DNsrivL0OUO0Y3LtxJ9iRa90Z+oyij9myc9n9utN6sHJ/AoKTs9FtmpjEC8nfC333xQJlKdkyFstR851jF6tCO41hvLo2VO5gwhEHwTBGjQjch42H/cuH2+AqGMvdzIlAOg6AUg2oEbfZIrRYa9U8B3VBgwIwUDwv2DiqGAQYDsZgGSJKbex+J8zkPUVJ957BeQz8+ORautv/17BTZMBHS14K3Xi49JnRFd4RdeuGBzAhGdjHVGwUml4ik+rafo3QpBK65L4w85AlbvC15ggFMwq6amjDTb3n5CJ+yHpCss87Gy5W9v4zautOU15l//fl6lorGJRViRa9iJHgBY2OiR3vVh3+iDflh5XnufBT5kVMMusewJG5sBpMhkDTOCH+tFJpqz3omVGKyDf/mXP63NvoesWOAP5b+rt1biHskYXsDtvsCLayCejPah3mknvcEnYMErHWgwXkeqB3OJxVnm10IS1hyFBSk+XioNT5Y3GfM1v+JEGyA4CeRUq2CqgbUIGjR4MNOpgxBTrcqEqRAhLDxSWMgg4YEDAyBDHhBwYGQBkQJSAhjAcmWAlzANxCxJs6NHmx0rYNjZoeeHDSCCCl1BtGiLo0iP7pCBdGkLp0uhMp1aBMfSJEmc4MAaNSqTr1KFgC2idezYM2id/6jdWoOt2yQhsMKgGqMuXbt3q+I12+RrlL+AA3fpS5iv3sNSiwaNIaIx0qGQR0iG/LOyZaE+M2em3LNBZ82feYLWmZO06dNAO38UKSGC68mPgU6ATTvxjNtifwChsiaTLU2rFmWy+IXDRg5BvrBYvpzD6wYJGnjmwCHFHODYsw/UtH1ixIQKCYofL5Dh94jeC8nBeMK5TQTwUZKcXyBAffoqBQDYD9N+S5I1OYBTaaVtxllkRiWloFNPPcWgVXlBBQRWQHRlRG4YGobYV1uptZZcb4G4VQlKLBhhXh0SoeKKhgnm14uDxbihDDMqmKBisSF4IGaXWebZjjwGNdqQRP+eRuCAmnmUEkkP/AhUC09OFqVkKVTZIG5YCqEbFX14t8qXwwHRXnVzKFcdc8YBtVwQc9BhyCEDebfdnOeVB15Cd4ZX55d8TlQIHWv8cIIF79Ek36FL9peooomG9NGjH1FgJGo+6TiUjZjOcGVSYZ14VYoWkhUqqCyG6CGIIobo1lwnsHrXphDSOKOoMLp4Ra0a1vigYzdauhiQO/rkJGTD8ljksagdqaxOhCq5ZElOwiZbbZzSlSUVaHTZ50SGyCGmce1BkEEGLNBR5hdtZgInneyS11C76Okp0bx8nsLdm4FggUKziPa7KKMAMwoSpAJWQIGkkzJrII69YopDU7v/Otipp2WNSmuGFpeaVqocG5WEx3uhSGqsLdqKa8laisyqCSwz7CuwQUYJs7TGIkvpzachjCQEHfEc30sFtHaZZFNS2+rR12KLCTBgyllJmSwYl8EJPFzX0Lrw4glv1nuiV+9wcKwXBAcdyfQsov/yF/C/Zzsq4E0S2PwBy5Va2rDD1U5MsqxGjGyxWldlrDGHHavqVrWxqrw3rYWZLCPKuk7l8MswLzz0zEIW28GPoVXgGc4JS6rs2z3z7HOjBUdANM1GI30tFHycwnSdhxDSJrqGbK37eBG52ztCvM9OESGB3KFFEIJuIEFIjba9ttqKGtr2SQGWhjCydNt998M2/3LfVN628S04WSkuDjnhhYcIwuGZKj74yTJufAZWj+eKosstKwas5pdTznrMo/lcwgZoMNMcDG6lk47pSjITARVLSq1rVZZ48AMxEIJeGPwdncBzCPAAz3cg/OB3iPGl2VVEDnHQym10M6gHUI8lMIxJ2qAHsBe+UEDV21xpSECkEvjEh3PLnvZAtiu9eaVDf0sZEqVSlYlBbn6GS9/DPuaqxEnOfU+snxbt9ypM8Qp/Q5Ob/2YmNwLmzIAPMBjcSAed1pzuJDOJ22uAUrQFUc0GGMNCJUooDPN0zU4hfNcG/wiRWdjiN5zo1huwIAYpSKFvMtANC11othkq6pJsu/8htBC4LDEGEXM3qqJSumfETx0milZEjCkZd6pTSdF77LsiLLEIvy3Kr5YY6+LddNQjT/avcmUEnQGHWcA0rvGYA5Ie0EpSATo605lIcx2WfiAH2c2uXqnwYwd7ty4/3gkT3iSkQArxBYzkj4KOxMLxNGUBBloSkzXUJKQG1EkigfKTu1yZHVOZylKar5+hMkxaPoTKWM5yLvykJS5tictT6jKfwaoZaFT3y8z5MpihK6Yx1YhMTrZxNZUEiRufWcdN4RGdFpSIML7Ux4PM4jzm0RpMAdk1bCaSDil0AU4+IMktUUFMhArpJeEpMNbMs6PYo4wQxwjRfZbSn+Mrlfj/+BIjVxbUcN9zKC1T5DhczY+hZrGiF78IxiCZwJmjoVxSMZokAl6Pozg5Khul0wFI3YdJCDAdSYtmrQpmi4/AaGk2F0LYbtKUkCv9GnGwgDx+pbE6jNwB0d7zzrW1Ta5sJJ0wLadUoZRAf0PE20GfmkQIoSp8SfSQVV950KsmdEXmW2j8wIIW+rUyfJIr6xfvWdGhADGtbEWWzorZk4LBdaPMPGoDHFgSkC5TjiStjZVk5VfZYTCwwiCGYF862HDaKabXfAg5f5oRSSqsMVZSnjufF8+UNBezpNEsAUHD1KYiSLSv9dQ/ozqxHXzILzJyLVaVImDYmqpWZkDwbU+W/5UjRkyf+Yswb3kL3OCaMVlmlG+hCCYdNq53PtGBQHSpZKXpVjAQ1r2mYGsxO8J2jbDCq0jxIluZFOzmW+l9Yybbq8kARcq4CBPdW0XD2dDiL5SwzCdS8hsqi00oK1Bm8loq5iEvbKzAsVxl+dpiYLeE9Va4zMpXv0rVKMdqrLvcbX2JIjNg0dfCQ4qb9YZrk7dK6r11pYChmHuA96xGhvAR8QaoU9I7akmP2O0jdrVLwoK8lLsFWTExGN3oVBDCeFJA3iSbGUlJpkAyOoEPe1Gy5/eWRM8OQHWqbzJkT67ZvmgW7YMAqsQmb4UKpHWwaq2MBitfWcBLPjD6DIpQFv91VbYMTkysYc1s/xUZgHDOMJ2FvNw7Y7Z6rXHuf0I8x0FPyUoUvEMmmLbolrrY0Yom96TBZBEU2mBQVPP0CKqEgnAZjHmVpY9ISn2APNc5Umcs7rGASLmDNru1wSZ2yC42llDhGqoBrXKvff1rLKtq2FweQpePXUsy2xZ9FRPrso988DT3hIfBinZbg0xcYuoMyJ8z9WoCpMAEGMolBAgxUOZIHWlKAcXq1m66hW6Ql6r7IE/7Qgp/kJG4xdvTVVKes0YNNJDO3McfQdIBt77ZZ+sI4U0Fe/f2O6u9JdGfVpmyWrCVloGG3H0J/7iZOWZsMHPc7rR94plHruaSQ6n/pBRWeYYFTmc03rvPb7u64h24QALE0L2C9vbqTPxzay56FekWBjWI8dKWJl0MJ8108ixg4wqNKdSVZK9/AARfThpXYQMH7n2TvD3RIhnhOJhQk89ua77s/vcporiH3P5ful8V5LW0VVVni/eynMy/b3+w36df314KCc7Xs/MwWU7cNkLnI9W2q6lLZ/MP51yB0CTxbbCACGFwg9HcqMak4//+hly6kXiUTKcxwnQbR71s+QZobvNjp0FXF1YkAGRkRCF2cQcyt5cUT7YqucZwXUEFsQJ8AMVrxKdaDGZ8c0c/cod3dpdgMWIGJMh8W3Q+0sd31PcrzSZRsXcBgicp/0J2QC63GoeHQzo4ft6nTCyhc+kHbl6ACA+RCsRAf/KHdIEAeuU1FaXHf1H3AQAYgKs3gMikdQMUAgO3VBK2Pkr2gPgVhn6jZRcyKxgTfeTDX/7VIWngaxz4hl+GKlE0giJYh3RYgmCAh2BFVbrXISz4h4CYI6DlZtHWajphiJNCOjhEV1gnc4vnRgpgcwOgNkEDienXaU4QB4hACZz4NIQQB2+gBkwYej71U2lycwFIavOEiBs1QKARAlrodboFhoiTcAtoi6QEIW/3IdAXWyqYhhIYIR4ycXDYOGaBLRTCFVYhF85nd1Zgh3eohyeoh2C2YFxkcLSoT4DogiyYcv+/FW2xaDMFclw7WAGIt0b8do4153ioIzTfFnqgaAegKIpT4FeP5FOC0gImsBP4RnWXxUkH2HX0xYUKmI1ieJBWtESA42W5FHHX+HakAgVuuIHGyHBJYIFR1oxngJHPCI0eKY0gmYL2g41h14IvmIDXdyyIWCSttmovJyya1W+qRjDpaCg2xwDl9x9MwjNTIitqcAd3EI9xQI9TQJQZ0UJWl3o8xm8AKZBEdixmNXsliTcTwoK4d3EROT5i8YsYSFtW9obFyDhMwJEXCX2upBYd6ZEfiRZukIchuYdlMUUraJAmeZIwmJJ4OSQIE45qtHKE55LmyEyBGZiNKHM1yQC50pGTbSNoLaMDOiAGdgCUkTmU9UhBNrCPztKPaTM9jtiUTokznEFwUilhtYc3c4mQ5SMWY2iGXMlft8Z2xRiWfGiBprSRzZiWanmHbTeNt4SCtSJyI6eNgTicuiV4T3kzLUlMdWWOhAlw57h46YiY0qmYz9UTJnA0TVCUXkCMPKADmElJmmlZMMSUMXkax3lRUUmaJMeNCHmQytYgW8aQaUeB9FmfkeNQa/eVslmRcTg/VOCf9GOBAQEAIfkEBAQA/wAsAAAAAOABDgGHHQoAJQ0BLBUFLyMNMxwLNxoINx4ROCENOiYTPDMaPTgiPUkuRR4JRy4hSCMNSDQaSDkjSSkUVEozVSsVVTMZVh8FVicLVjAOVysWWEQqWTkkWi4ZWllCWmZNXDIcZR4AZSsKZTkkZjUaZjkkZk9AZy0RaUo0aVItaVU6aVlDajslakQrazINbFUwbkEccGxTdEMmdEQqdT4ldUoydXtjdjgMdjsYd0kqeEkzeFtDeVQ5eZBuekIbekszemRJe0Qme0Yqe0kqe1IufKF+faSCgD8hgT4Vg04zhEkmhEoqhFM1hFU6hkglhlg3hlk7hlxCiGZJiH1iiUcZiWxSikkRik0rilY5inFOinVYipZ2i1Eqi1Y1i1o7jE4xjGI9kE8xkI9wkZyCkkwckk0kkl9AlFo4lKJ9lW1SlauMlcKcln1il1YomGhHmIZomVQbmWM6mXZXmYJcmnJNmsylnWIsn7qhoFgPol0nol0yo1wbpG1HpW9Mpn1ip3RKp3pXqGIdqWUpqWg2qYdmqZd2qoJbqqJ6qryjrHI7rI9vrMKer7KQsJ2Csn1Wss2us2sqs201tYpmtoVZt3lGuKiGuZNsuZl2unQtunU4uqN6vINKvN7BvpJevuDDv4E9wnouw31CxHs2xXw6xZt1xp2BxqV5x4tVx5Jqx5VqyKiFyYEvyYM4yodGyt3Cy4Q7y5JYzdS0zpFMzr6j0Ic80baT0oo9041K045S06xz0+C+0+bJ1I1D1KuG1ZJL1pFF1ptl1qd41tzC15hN17KL18Sb2ZZW2pNG26Ro3JZK3ZlL3ZpT3aFa4ZdL4p1h45tN5J1S5J1a5aNb5qFT5qld56FO56dm56x16KJP6LeH6N3D6p1U6sWV66RU66Va67V47Ktj7LBf7NSu7ahV7apc7bJo7ryK7+vP8Z5W8aVX8a5y8qtW8q1j8q5q861b9LRr9bJj9rFd97lq97p198N998qV+bNe+bVj+cBw+rts+siG+tim+8Jz+8R7+/zl/OS3/dGN/dSXCP8AEwgcqOFEkzJrAikEtEaMw4cQI34pQrEiRRE2MmrMqGKjR40wXHisKKUkE4dFxjCxaKGlSx48tMicKYaiESNfAkmS9OgTT556fD4aOpTnIzxI8zhUmueOI1Wqgimbyq2q1atYw2m1xnWa16/NwCIL6/Xb1rPnxLFTq25tW3dw47aTG9db3H149d2LN3ecX7/2AsvTa48evHd/68Hbqy+vY7z48PHtS7ey4sWT+RKO91iy5s+MQWP2Sw2a6dOox0rlFawXr2dWXUdLTTbsMWe1cWfbZvVtO82QIwsfTnz4vOPG/Skv3k1e8c77/DlP/q969XzXs2eX103b8+98PaP/qzZuuvCBAzPcOIh0YUM7EmumTKnSYpEPJfKL0M/fBguM/wG4n0j+CajRSiZJtFIJLr2EBE0NyVcDTnoEpUdRPX3SU4YcHpWUG27cIaJTl7Qy1mxZpZWiirx1JdaLJ0qD1oxs+WZZZXb99phefyUmWF6IWUZYcMI5RlliN14WWng77kNOk6KBRtpsqyVj5ZWsuQZLLavoAltbstGmW27LjIlajp99p2ZywiEHXnNrFsmmdtlhR+c83EG2XJyRTUaNjkWiJ1BBSpQBiEJDRRjfTSqpNFFF+H0QKQiUgoBBfpdaWml+m/Kn6YEmkVRfEflV4FIJNkhRBYT13eTUTj9d/9jTTh1eQtSHY4AYYiidrIJiiysCSyOMJ774q1ssImtjkjmiOZiUSP4IpJCNEQnlkcyOtiRneD3JrZFR+lmaaVby0iWXunTZyrrsstvLl8iE+auZ9ObWm47f8rlnm/vyuyec4Hln3px3FownX97t2e9w3vJFDXn54pPAAAgQpEEQDSHKUEQPUVRTo49SlGmpDZZs8skXpGwBqjKE2qh8CIpQMkY/PPhyFRR9gBMesxql4YZE2frzh7qG+NSWqAkbrFZrAUumvS7SyNa9yzLr7JB+TlmtY0HStbW14GKb7bZQOtZwlH5NlaW67Fritq1vC72ulWodw9q8T5ept5lUM/+mb2RuEszmswETPvBy1hl8nHV4kge4dfsGjo+3pHEbKMXoibAeHYgGoihE8308KqmRXmrqyaejPLN/lGYk+s0rycBg6v/FxOqCFO5Bq88a/pTh0CIW7cZTn0iVtNTJZkUs1F8hn2yzVvu2GTyEU2ZMeTsieVfZYWtvVtdKkk3ck32e/ZlddbfGNlRQCV3i+1Cda3xVxdabN9T3RgydmpL7u5zAAwNbAAmmOOUczHEKW5ic+HKL65mHfIJawAMosDnOJWpRNcHJzUiHn9Sp7oMqWxlMCtQyBMFuQRZgwOlQZTMQzaQINfhPToZyIZ7wKmih2JBRkhI8MbzKFr+SkfP/ksei+zXviEpTy/PGRq3MTOt62CNSYcwSrf19K2vQG1uanmM5801JbWtLF9vkVyUwxoh+arOfEXVzJkBxb3CCS+AA/0bA7bjJTRCbDuT8tcBqQPE5CZCgoAySEJ14Lj4ooQ/IRLaBDeDHdJAE4ewapLkewEA/iswVo2K2uhbejHVj4Bmtgua7T+QQbokaUVN6spvjzcgcsCSi07yyN2MlkYjoqxGO6mKjrF3RR2ATmxu5h0UhalF/zznbOrwxLixV6ZlXgpeMzIgbMeFGNXbbmzb5dpryXJFwAIPjHRO4nHAu8JzFIacBFzdOyZSmGuQTTjy/M45b5Ag6E5PgAgTp/wKZWPCQiPSYIi9SOk5h6qAtaWQIF6oyzTUhCCwAgetM2CoU0k4kt4PhhEKpu1FKIoc6MSWGEuWI4P2wlUJE4i1lGRZa0GKbZFkpLnW5y2M+URrSCo73MPNGvIhNWb0UDZ/IERpmGpUqSIXNvM5UGtXY4m5qbI1UswlTbl7NcOZUYBzLKQ8AanVgXhXn44rUDT86EJn+4lblwIaPAShAAfoc1BY4pzEjSMSudgVdRTzFV/1QwK8CUqjMUiaCQimhQKIy4V5n5tCGKOomkuJoKYsiUhymkil3AAVUyRW1pbK0RcvQkm3wN0QVVe0wvEwtamtkpHpKI4rRkQ6PqthTIP9BL5en/cw84Xi+t9wWt8A9qlORVj8UYZOqVbXqZR5T1jz5b6uIi8wtDscn/jlpcgzrIzOh2Nzmvmk8gPnOPse7zwe4gHP/pENA5zPQ+2CSZSIYAX8GRN/AXmBAFBhBEJqghBhEdKMn0aRFLGUqB4jQZjSxCaPwsIeR4vCUQLtsZotnTZWidKW0dKktW8nSqZn2tDRdVlXW8UtgSnGKJq7tXoJbNRLPZYt8Qpswf9vMMN7NS65Ero6Taxp1LGl/Wx3nHsv3XOpS93/YzZM2AEiOJsfDrO/808O6y0Xw/hGr+yAvBzgggQyoB7220tXNOnZCUiEWsaiqb2DVTN8YCKH/vzJjQegStFhKYhRCe3WVUTD0s6GAYkMQHhGvypTSs2wYw1QSLfMQPVMQt/gqblzxVfeE4m/wVMXFBGpQI6bAJotHxjNmJpbGWCUTragZU90xaS8dT06rM7pD/teRyWk4sAJucmFN8pONMZXrRflPTHJSw6bkDRnvkwPj7TIh05tXRL7OIh+RgbSnTSCMoJnNNLNkRFmo2FBFVIUG5rZMRmcEnRVBlJP9nZ/X7YiSDhqWhe6sZxEdWpcWo5YxXZqmQ0yZEGPl0lj80XJmS0WAY+2b+5A0izeN1iqDGlvCVR/75jbq15xJiaNVdSvZ6GMYP7COBpN1V+cUW5GL1Tm7/6VcM5nKXVBPE+LL7IDMO5DsLxvqEEfh2F07lrP8mJkj1K72RtQs7Tb7t3WJ9XYKL5rRcteAo0EDNCggjMqg1YIYSp3loS18lZbKQhdUBS3HkSVTfitGRrwsdMehBRe0Vpps4mutb39LGXTAmLdsd7Hec0k/1sgifl2qHyyiUjemBcnQUl10j/HVcFgbMOT/ak7CXv2/6SJZOnB8UqvRIY2kPoNu79R7ZvrypYXPfAESOLbN6+rsuw6YZdKOtkYMxOaV0WywGVmVShLEOg/KedxfGB0L8eA7QPPufTi8+sbVyPVbJlqMYRc7b8i+0n2vFu0e/hXjsYVMfVDR0nCPu/9P5053u7/Y1fvSfN4XrlRzqSvwWTfNKi5RjLYcK/tUUjxbwjXrddoJOwD4f+XUHf6DOJBjOAaYa7i2QHzheWYiZaJnPZ/3a7i1ADJHXsqmBe2Rc6+jc/QBKT6HSdT2EWo2e4MlQiswAi3xey/jbSBQAQygQhL1ZniWMzvzYBwCYTfEKxQWf/M2G82XRNlQbxR3G1pHRD7ob+SHf/dXVOoAgd33dtsSGD8mdwtXd+dnOYXTW0soavLnflsyP0sVP/Z3f0zIdW8RJSBXJ3UigJNzC3BigJADOd7RQHqUfjH2ZKDHWdEUentXhtLkDebgheS1T112MV9wcxzYehtkgz//lxEsc2bXBhL7cSohcYI2oHu7VxKsE4MqdAE1sB4O0RAPYoNQ12Ck9FHIZ0qsmIR4I2+lBVrFAH35hkYXBm9J+GHI0m9nuBtth0UutjWytQ/2ZBZUuCSM9zVPZH0ReHcOB15tMS5emBroAn9JQzfJoAr05w4ronY/6BbB6Iz80obXIYDaoQ1w+DiQNx1xiIcoFxnkACfKtId8iHXV5IfRmIvS6A3JFlchIAPBxzNHQR8u1HrQJnsHiZAllASyowJuJjuCFWCJJAU/IDMwGG53lmBS4B8TYkhAoyFT1xNTx4rFA0Q++IPONyzP926E1nXOgIRl92i9+ForJkzC+Cw9/+JNPBUYzQEPPdkkxGZ2WdhwXkR605h15RKGYbJyJ0IMJaKPS+NK+ydUa1iO/wAO+YCVc+gZk7eOkpGOjncNWvhp58NrpWeLfXiWRxl/K1deD2AxKcEzDRYheeUxLchzN2EEkXggCTlCQFdCeyAKggkJhMkGR4ADl5KJY7aRNrB0p0MgJiETNRNDHblnvfNngPY7PeiSsNiZKrmSYGdV/4ZxMamEnIkiwbhMDEck46AM4HeMsJlT2UNFVJNbjfcZ5sd37fd5FWdx1Jgl0dALbhMN6iCaUflv2nJ3ckgnAUiO3XALCWOVBdMnzfV4XHVi3eUwoOdbvBlN9/gluzmBJ//5VhMUARPkASW0gXjAiItpE3tpHwcZe7m3EkcgClh5n+QwCn5ABhBpO7DDAhf5iQQymYzJOh0pK1L3Z5fZiszQoKfpmRA6S7P4d6F5i7g4k9+YDt+ndUh1fme3aXpCcNpSHjr5Y8M4frVpm27HhdK4m8OlaM9HRtCwCu1GTWN3nH2ThXGkDddxn1cZgHaCjt2gHP9njkPmXQsTD7uFm+DVRqpZj96JlDw2geeZgg65kAIJUDo3ZvXhc2cGnyNUoLEXO1+wC/3QD9jQD+UADqjAB/zZOpoYmRYJbqAIE6EyQv91brLiM5k5kr5ioRF6hPQ2oRR3oxw2iNRXLxe3oa//iJrA6GPho4wmNqkexzX7+GiAoT9F+UXdKVVjREZi5C7Gowp/YAlJWVxSiTxoMpRV+aM+upXdQY5GGnntSGRKyjBE9WJpA3pGeU32aDxSOqVlggOHSQZewAYIEXwBeUHs+TIDFp9gKp/2UQZmqqZoCg7CAAlcMFgskGD02Zh02jpCsAbJuioc2ZE9EVIPxorKxzeBinhBuA1eR6HbRJrVdGrcZIZmIRb1A3PLoozetz3RQpWxZakpuoTmx4BP1g3tQB4Rd6qf2i7rYitft1mXUKqpZoQZ2o2XYX5M0qqy+g/oSA7W2ZxbeZ0Op36TU0x92Ku+Gn0uqk1PtTdJsAVk/1AhFYIHAYkUOXQHzeqsecmXQvutYLoSbHAN5VAOZ6q02coFBPZ7jsVJMWgqPlcGfRAJjKAHwTetlvkTI5khy8doYjuoLlWoYweVD6qv05SxVEGcaadLaHdwa8cY3Jcm12JUV4i3UciyvSmx7bIloJpGyWAJeUB/6aJxYrt4qvmEwbhb4yirQdpA/lCks0ppVOYPTKYZnkY+LGtxemdNUfqyM6tqANkFiWgoOhtKSMETd8mljRi0Qxut9mG012CtSYut2sogDAC1L8SQE2BgCXVnfeA5C/JfULeuPPgJrgiL3viZieqr6cKSommogoqSXgGjqFmGyBObq4paA2u30f9hheWnt4BiPgxLGkwZRqAKTXtoPMEACHkQFYeLuIxWIxAIbARbsuXohnAIuXcyfn4xR9lpvjUGREvYqaEruqG1wAx8DLmHEKjbHur5s+RGKu85u7GTWDhztNaqpvlwDbm7gi1UrhXJETRYkRMSQ5yCH+fGYAgKN8n7q4A6RPHWFbrYNNBLoRXakmn7WSiJTfZWi4maFdwbjjtlcECJtwiruPxnPQ+bJcCZvWupDJv1B3/wUqFJv2P7hPC2mneov3TYDdfATiFrHdQJh+FkD9nZxAWslniTXAuMdaMbWqObEU0gB32wB3qsBxKMKxSsYPAFphMRMhShrAixB+Rwpor/nA+7EMKh+AaIgrPIygVsUMmWrAX7sW2bcoNRBz8lqagRClQaakvcGZzxEqovFcdZlxb1qjzWqxr2Ji+J67YKF1SL66GgUWuPunfdZMswF2Viori3TBUTijTc0AoYy7YNrH9Ks6g24rHzRMZzKLlz6JUQY3cry6S5XJa8eTe0mX+Cp8yqhlwYcceMkLVzubOpS8GtAllAZxFfgLNloKeHvBOlYAqJrMj9wMibYJhv9gZ43AdxkMd7bMnHOslhygQqLGcMFggv7Kft6q6ltW+yGFOlfMqiqson2crVC86wHMvfeaFhe68fOmI15TXnh4A+pZZP6qR/mJPB9XJ5S8Vd/1IiXUIVoJDMULXMPOZ8autb0Py4ZlxWcQh5A7dWowdeHuuxtYwbSmkVSZU3qjbHUGw3NEPJlowU6kyXP+ue+TEhY5oSO3HOeswIozAKpmAKv3ANbD0PQIqOgoCsnAPQCgHJdu0FXJDX/GWzLwRQYJ2l62qSUrrFFN13QiwOoDl1dDyzG41vHc2vnhrEIS19yqVpoYbLCIeiLObMmMp+nk3TbiO/ySAjvOBu5HJciCvRI22oSuxiSZZAz1kelNc/DsvUSn3btt2k3fx1jRq64rxjz3QDQYAxEFyuCbHOKMGeCrbQsFcEZGDWu8DWWTsKTdbW1e3W7JStfHysd805EP/8BmXA1zWrBH293SYE2BmSxT3dWVKTWjh8XBw6oZ6gWctgSstsi44d34Ib2ZLNcat9o3lLfpgtmwnX2ropngb+tgHe0uoTN+5LLiVVDKeN2jzNfGokleSLTK5VDSSnQA6Dv750yxG4uOVSsfl34h491b9tJTMhE2UA3sat1a3ruuTmpYBJ3W2tn3xg3STbZIsTuZEA3tzt3Zyz13gt3iesBVzgHi8jIiFl3xbOzN8DPgVXFx69tqOVLvP9VINW1TGreCn+ov0d5cZpeEusogCbj5d6jfd74DL95sBlJX/3NqbGh8jsCGtU4VEOs57F0nZXLdr5WrfJMMvkmplBgYP/2ObDnAyuYSKo6tsrDt9msgW9a8gBmRBczYjQVinzGZg8nrWMQA7gcBw+zqNuDeReUORFTq6sTgc0SOkyIQSqUkgK8TmFVJJzjOKH1t6HZ2lvi02mjFxz7glcPnXVKNgvm+cZd8qNjr18uEYce+Z0h8Rq7uaszeZwfr+ftyXtkwrWaMqdd7GXICYUruf2w+egXHoeuqtSlsvwyIBUkZuMy5YsTXZh9MaQruLojhst3u+N0up4mUkBfxN5Wsg4fg1prZ94gM8HX+rYbR3DEOSpPvGpruQuTgfGPdyzTuQAH1LITuY2fMMb6us7ZdjiHJLFA9HFvHzC6kyoLVr39ujJ/05ao+nZTZQXK6aL2J5juu6A2+633/6FpnGxrVDA+g7HSG/h6t6ro929aeJFXyIuIo3hiL3bJt7z4Xz0i3YIlSzJMS7jzdZsPEduKpx7jBDdCH+6L24KjGC1okCyeOLjjHMNmWDXRe4FGqiBnBO148aYo+hYq2TTH//KSUTlflHSI18X5W6E87flttBuED1/ZhLz4zzOsawlsrFh0A4sa26/0z6FJB7nPhisUcq+g5e8oZlUnRfFEV5jM+/yRlT5+87afZjhS337Ue+yo7/7SXm4y5Pvlb/RkUCYw1/8WvvvySr2GLTcC31u+NxkjFAC5nb2eyBnkWDqKwv3x9ENpf9Q6xHsWKw+rhroBlpQkAkBv4JmSoy9vPULjgNOtwqewzDf+PRdUsTDJV0+hDyt9ZcPEL2KCSTYzNlBhAYVImO4MBpCaBG5TTRHTRxFit40XnQ3zqNHePf03WunjuPJis9USkyosuHLYARh8dK16tLNVcdWXmSZjCavZN5qufnTy2WylgmXLWXqcOHAY1GbMrU1dWm2pkelSjRp8SO6dWDBblwZNiy1pEjTwoyZU6BTtmp9SqVLFyLGbKb0UqIUya+eL0yYrCE8xnARMWKMJGbcWEoRI0Y+1KhRokYRPbuukbv2qUiFEl9M/dIDwkYpcvhUk6vWTfW8ed1KBXpThg7/4duFtWi5fftQoN/BcYb6VNxWVblq8W6zxty5c3YmpdfrSFLfPuzZSXaczrxuK1XhwYOyBIrmozx3PBk3Xkwr1LpxY8qkD98qXPwIUy7fiffk15C640gljVYy8L2XZpppvPAuaQWojSKEZr5aKnxGKDccSU6p+Dp0qCb77hNxqmfi68miibySEKOwUrrqPmJi7PAnt55KTr4Q4bvLRT/g6HEPOWrbbTDCAjtsscUcUwxJyCYzzQjRNtPmGlMAw2yzUsagw5fUYGOtmi5jmy233nx7Q7hOMtmkFDYrdLMqqJCTccfn6qxzOupKCime7PocaTvplKGwQUscMbTQVsyx/8URokD5pCbiiKvQvhzj/Kk+TAday8OGHnpOJRcPZEkaUjPiTsAVMYroRrpoXKVB8XQJhlQ9yfLp1VdtieiSDFnldMSlQLTrV5o4HFFUZE8k0BysSPR1RlxxtMvYSq9SVggdgtD2Bhh48FaKxHQzTElyI4vMSRDw0Iwzzn6RBA9GOKvGF19cgw2fa6gxxl58XfmtTDqAGy4TNWeV8eBg5qrWU57sdDg6jU7d8zo//wT0m28EpYnQQxEtkdE8HH00UklltVTYkwmiRaCVW4ZqZWA5ncapZEVluNT/UE31oWddZTDNhCO09Va33JyQUVVQ7DlmqkJZWETkmJ42LY03RP/wIGIv7SXaqn+V62WUs0qKAg/IJtsyG3igAlzcAMHjjrfvcEOxwxhbO7LLapgsEDDZJccX4KjxO57UUotnXmX27aYbY1wpBadMBiZYQYMR/i5sHR/WHGI8O7fO4s/zpGhrVYa7xBGnPwEkMdSLI1mWaE2WPWWGWsb1Qcplt3H3l2b2nWrlbFYIZ+KLV3Vpn3EPOuIWV42xaIWp4QXp0b2OGXOqFgYqe62ltp77+aDVGhbYOynoe4Vbxd6qByaIgOwL4k+bdYFdt/8RQ/GX++61847sETB1gxyH89cnWhOPkozFK3OpWtUcd5wHLohyCZuTS8DGsgsa5Bzh4KDmmMP/OZ0xb2Khs06tSiSTVz0idSBDHaTsp7zZoSxTIIKdyzIFvmPYMC4OYUYPY+TDBirjZvyxU09w5KbbzUQZzFtR+uSUK+n9oShouZr3SCeLaj3tese61IzQF77xXVEV5/siGNdnFQe8z30sYIELkOC2QwzsTc+7XyBWN7fGpEcS9KqGRaoBwR4C0XIQnGDP6KOWqGEthraz4TQ22MFH/u5mIDwJJU2SJxJebEIUtEUrWqe6cI0shZFaZA1NiSlG6lBWqlwGzLTIQ+TQ60AMEeIQlWVLatVuY+BxyxKZqLRBIhJ3z/hEr7RiIy0OhJeXw2GzsjipZtKulKxkizSTOEMw/x7xjFMhmxuxdSZJtOl5CBNVJyFYnPw56E2+WEnjKoi8SmUzjPIMFg1T2cjoQPJTCLFkCHOGSRKahGe3MhQgQHHHP4jydUWzJy/vKUaHmpGayexdiY7jC1PI8p21xGVPBprLcSbRl7XqivO2R0G14ER6lhCDhi5iRatcMYbWxGEGT7qMqNE0g+vDJo1iJb5sOjGMuqvLG9gghz745YHsFJ6oqDiWEuXKFeSkajmFylOg0gd3VrnnKbORT4fdxZ+BMtVJABqgkjBLRp/wRNzgliH2vJChNTFlXd1S15/q8qGupCgi21QKU0SwTbU0hvFqdkyEHGyO1EAgSb1hoGAS1P9pzDgGox5hRIrap2SVepSFluG0mj6Te9NUpj17OsO8DvWGzCwl9xxXWNguEGfJeqSttHJbjoZvltUsLV10+BRV0jVHXa1hM8Cqz0miinO1Rck/0WqWQHaydQW9gwrjCrk30dWhdsVraol7wYnGpRSMIO8nyiuJcJbih7GV7WGpOkjGggWB7VXkE33qiFq4ZHWXmIiMRAteUuq0GKCFzyc+u9Om5HSn3w3uTGMonjGetnusJa3RCpsqwxIxRfzB7VXvkkvhYkWGmvod9zY72u9O5LgaVm4/kYuzzlGRmCIjDv5cRwypXnOuOtbudour11QEGa/IsGF4pTJe9O4BvcL/yYkr2KsiKMv4vbj1Y2PpG0wFpfASEFrF6kLR35heTxY07q3THmwyAj+qlZBaszRJy929VrhlEC6yXQs54R6fcsQdfMc7MlxWFhcRQWDDokep9aqp/HZmCw5w9ogLu6Cs+KPb6OdYX6ziGPeQrS8kWWcrtOQc7ziJPv5xgsYs5FjxtcFhdAXB9PBqPQgsjpKIxFQVd0CxKLDKufZjH/V1YV5f+GtdpNGC8vfDVuTBDa2QsRdDSx6XmRnNrf2smW9cT+2CN8+pDEX54ixnOqvMtLmjKe623e2aHLfPlmxuuzX8UamIu9vGrR6HiOrMEP0uuAySlUFKi9cgu0c6yB1e/6VdHOhfUjYUn+z0/W5yk3CKOrs6huHloB1kUBRX3t9WkKuBQ5vagLwPtGYTO1uTr8WlPNfXUHnLW7PyX3et2GH0JCDwi+y5JQrEzyTlo63dyp9LytO1kPaqzw1na3O8oeG+HZxPS4sHQf3osmBuOji4XKy7u2EaxvacM07vZvFOWGr9tytFvG+vNqPsP/MELTD9boNnfesPi7Iu1sPpOtq8uhEXZ3ZpHrtEKuzUPTd6nFfBJknE+uMgBw6QRk5yJ58cLClneeUtb3mX+9qdhMzdcW5XKIMGJao5r6+zbwr1uw9Y6qlDvddVz3qhE37chO427E1ZstXHzs4KLV3AW/9P6rvmbppN9zbs1i33Fl/ag/X1uifajll7S/2r+M73mtGOeveofe0McgZZ6/1V5Z5q4O2mE1lMEorUV/t+b2VdxB/V95uqNvC+HTyZUel6Hi8Z5CFvfB+UjF6/OAU+OjnMI0ADvDyVo6JBQiIkOh07AARYcB5QIL1B47nyyDifqyGhc6ENXDpuWzrbazjc88BoqT0ISwVuSzWOQzoTrKvjs7oXRL6qm8F98jcxcr7niySoKS6yawqXWTQV3L4HUaTmgzaBG7+HybrjU67R6Y+cQb/iUL+8W4O1AY73I6QOiywt/DfZ2zip2q5c8bjaKIOjYoP+87+kAiy9+IVq+AX/NmyNXWjDlzvAAky5wpoLznOLw0shKVIFYkALX1gUO1i2CrTA9ci9Fiy+1AEtEWQ9RFwlEES3RGzBSUS6+lNBTMxE4CO+HjPBGKSHT5TBuVM+4MK4tlsGSBK7K1JFmAHCVBJC+qu/1EPCsPsg5BM/resonrhAN+G04LiDtckQ4cAuLASio4Cs92ozT5M4Hgu1kTMq2zgqx4M18iIvUbhGN8xGN4RDOqw8l1ucmHOykPI8myioyUKkO1qFHkSw2TmoC6xEDZRERKRE/Ju6AatEemy47rpEWAnBfeTEqLMzFvwyrAPFJRRF/xhF4EK98nA7isiPHJI+77icH/y2Iasn/7ZzPlSkxYIDq7h7QYQzCbvDPYf7F7m5DLZhDMKAIyu8wnH6ofUyRkEaunHTM4BcBYLZvzLggjJ0PD74Sb0YhVMIymssSm3cxjeMw5e7hTc0hlugBsSBLVnKsk5gqeqyEJgERgikLAXTNqAzlIDExxN8HRojy6SLthAUy0ZUJn5TxLGMx02MS7gkPlILRVxUQuUjolLEQaOowRKLyFacyPhQtVOrM9frun58PlysRSW8y1xcFVvqwE27ifyxIyqkjJTkn8ZoG5Z8OMlpsvXCCqywnG0LtVN6lSU7KitYTTI4qp8EyqLcC74YStr0haO8TW10St1kQzeUyqmcCUuAG/9LsBADWYU8MAKXor7Z+8qEyolGVEt6PDpKXETUy0eM67SMe05+vDjpJLW29Dbo9MSDNEi7pEG4E03tO7WGHB6Q+sEN0r6o+Dbf87nsg5TrxEGwQwmGucVQ1KeGOYgNyzbUpMyC0p/LpII1MElwuRuUXNBx0Y23ilCbsx9zsrD3YEDnzBWp20OcfLWd5Ek/gE1TEEq9YARIOFFIkM2hNEo3FAVtdFGmjNHbdMpfsE16gaD9AgqmCiTjpILL4squCxFacL7W+Znf406znM4ktafYC8+M1M7sPMTo/E4jfcvyWdIkJU8tHU+5M0+9jEhUs6I5YxgUM0zgm0uMlEXzIIv/q5vBxnRMheSnxwJD8qCuNdC74/QWNziEPTwdwlhQKsBM/mESc0kSldSSO/gDcxSZ47Aav+KkN0E8IPlQMghRRiDR13xNFN3UFFXR2PzUW1hRjMLN3gzE45i1GFEaTZsbDVFAr/zKIs3I7YTSf5zHe4TSiytLXc3VKEU1pnPSt4TOKt1S7iBWWvRSHRyo0vI9EfnLDSVTrqozXx3I+lRTxXzPj/yn5Hu7nVAHZ8BAF6IuojAoXglUKgCEcIoRxDPJIyHUQi1UchGDQTSM9IAbO2o7ozkQfUkGpnrJ8ZpU18xUgTVRoPQLQeBUTr1GUf3U2BxVGLVRU22ypwKiYqIC/1AwxlhkGU84lLHU1Vn1WDKbzlv1R5B9zl3lVUd5Rzrt1WDtWFwdVmOFU0lDVk/xnbWrvt45zO97RSJ7xIH0w6iSxRYSKA2S2Wyl2ZcC1xoDhPRgVeuaGx7YU9BUECRbMrcpDDzSzGBMjEHdWjz6WriZ0PZoJ2bQPHrBqGocWLUl2INtW0JwWxNF2NkcyrkVBYzCxtys0cCytZiTsVBg1UCyoHFLBY41QZNNzJLFUsNV3Jc93Fx1kGmt0nyEXMdF2ROMWaNFWr9MT8OESEYCO2RqPcAszCDUQOfTBZWozjoFS6LVCXU4q6M91hUTySZFD2Ub13A6BMYwqKnCw+RBr//yOB1DAY4Cvdr98drdHVewVd7qUiHQlKWXE4Xxes09+BEgsVTyek2CxV5LpV4/kFu+QFGGfdGMyiiNWpWYu4QqbK+hKtxOBFZ9nEcRfF/HxTvspNzHHY7IdVmWPVn/TVkATgXMFZ0u9c/NVdb6BDLPHdNkRcwMhLPTJcKUNcfp24oRCpDwY0JA44ntosym3Tt0qkLzgcla8l0OPeGiIcdTRSi5qVcJjdCv1cy2wQlbwCjz+skzqN4c5t61tdTq5WFNRVGlEl++GN+9MN+lYi/AWd/5kjkQuYlTFFC/U+E5IobpC80fwik4ITr7Ndku7mIA1l86g0sxRlwcJI8zTmP/NPbMdxxg6ijghDxgIOxZng1d10tF+Fyz+TzSRHxfVMwG+6zTkNlI7YOG6gidDJbdDQZMKHRAe2WP44SroIFWXZowTkoOxXK4FzKdm7Ajt7EbcDEXtgFA6s1hU/YRHO7eUoaDHeZhHjZYIi7KShiFSkAESNDU8nWyxmmcfQ0EtQEEYxigmBsUI8wGGUPPUHGqs8g1Zu5bZpHJY+Q8Ku6kqeU9+wHeyWQ7umzZMlbjMFbZ63QQTBrncYZjmkXg2oFP97TjWKnZ0N1juCzdwRM4ap7gPnQR160He8ikBIqYch5Fbn3f4EyPQHAa6aKCBwRaXGKaSWvoo9iod4pPLlYh//TYn6wlwx+eRqTyEVSGA0F42x7haFY+5Y1WZVWOZVJYBJUWhDN4Ah94gtZEqjU5W2Og6SzRU9RgDWNgIDrKCa/QtcBdoECKMnTAvF1jZrFoLARSaqROwPiaw9YwVWme6jbJUNPUZjbOXyJFFCjOaksoZ9EJa3OOJDm+ClpQZ7OzWSDjJUeCt/QMOCF0usL8Kinc2D+wA08A3aAZIey4mEN+LkWe06hrZIJ2kBlzWggpa4f+s4R7TP7Q4k+DuHcBDsDiA8cjaVYOaVTW7JHeaMzO7BD9aJSu5TaAAh3QARIwARNQARxYAiiwxlPgW1c4BUlYkiqQhGrAFz/6TR19av+wkEmqnupHUVea7iGoBgu/SW7OmIflfo17wRfmTu6inrzMA+odfWiqfFL8/WZECV7TEWBi/edtvbS/xLaUOWtn5UIeTG9N3N/uMmi12jQiTQ/3EMxowBiRoJi+vmBASSCuML8D42L0AxkVUjjDQB2dcMLmkGP/xJjyjDEIh8H/BCKbNoW/AJKeFOnubQORJmkPb2meROVYxoRKYOUcWG0NSHESCIHVVm0o6IO9sLVW0wIeqIwaWINSCCBwpFgBRyf8sVMJdWG5Md648eRHQK8bm+2z3UYBkhLlJpzmju7CmXK/8ZLn9od/eA3OWOqWK4lhHkcMbZOu9uo2BmszH2//xeatMbXjtcsPAV09935vnWCWUbLrO6C6l+qUb8jvitGT/QbsnKGi9+OYPGidjxGDhFKOOPUgCW/0B4/w2WUuFdHNoSQEjc5wS+3ozg4SKDhl1YRpJ8AWJ3BNFE1pVs4WFQiBFF/1VV/tJZADv1CTWiuFPqhxELh1KImEN5yXc1qdQfWfdwV2vLFxNmIj//EfyNASwjjD8vqr2XYcvThbJDbf4uYjF1XKXT9ubVc5eeBypJ50xRJzXEmTToijTtCTM8/c5Zs03rLBRYtWiErwhYRnyVXL+la/+R7kAukdj9DvPwEJfh6/7rDq1S10dcQxuXmEjWTTvIQOB390Lh3r/6rrit+u6VO4ZR/B8JIOac7e9JZmg07vdFBfgmyZgZJ3gitA5Sto8RVQ9RSHAJiHeRVv7epVE4LJBBov9lsPjVlnBJCDWsoQVOS93bkheq7tn6D/gFtXeqYPesgYDKgfl934gp2kequPxmgEuazXg9bEAw+NNVg7hFdLMlADwHCadb7d9uO2w93m7Uspof5Od0VO8x1Su5k569/aNnZWWm6OZ28DM/TDQcsSOLf2Bn8fCQAJqJKaDsDUMpCJ4sFXcANudMqHeM7B3MnfoOloe4zC+Mvu8EwHaVO+gpQPeZAnA5g+7R4o+Rk4AddvfRMom5aP/ZhvANuvfQ1YAR14bf9CiHVGkIKdB4EKYAAHAIEfEAwbCHpjD0a9sy4UxlBJWNqrbVcbRxdjTxvs95bsTxsZePrj//7HQH7BGH8kIH/vf4xvcdAqWP8hedCAmTUkd3YlN7l9eUpco25cOyvFF++ZBQhu2wZOK9jsIMJjxRYio2UQGUSIDpcxpDXRoqyMx5xR7EgrFKiQGlOpKgmypCyRJzOmBLXsnDlnq0568gQoz59Q0QTuVBjs57h2+vbh2xcvKDVv69oxredUnTeBUKfqqlo15CVHOF0eA7X1GVip4caShZnu7De0ateqpdcWrdu3csuqVZrUmLFToiD5keP3rxo/fAT35SMIDuIpV87/MGYM5fGTHDom46hcecWKDBQiPLhAIUOGEyg0NCht+nQIEk+g9GmdSVIZGyBqsABh4fYF2yxk73YD6NClmatq8SKWjFnYu8h9HTduC5bwTyAfOcJjXYwUI9p3c59NuzZ4ETbGy3ZB3jwPHjXOs2e/Hn16+DyopKef/f58LWL0r6Hjv38gAbr2WimuuOILgr5Us2BSC97zIIQRQkjPU3FNZRaGBPWUUEQcNmORRyBSBCKJJInIkUdYocSSia2suBIoKWXkklm1qGjTTTRCs2M0HSrzzT1EFcWUXUVeaOQ63AynkIshaQXIJ889WRyPYtGF4TtZsqPllnO9ZeGXaXlZ/5ddt9yiF1+AEWYYH4G5mRgbjTkGGWV1VoaCCXmusBlnm4kmAQSlKaCAAYUWqoEKOTwhhyR9RNJoGdmRF95uVLjhW3CwGGhcWJ16+mlzvPRC3HDSmSoJdWuMwcR263336qvmveeqrO65eiuutd4aX328+ippfvcxMeyqa2xRBrLAAdcoI45KIqE+ElY47ZFd0vWQhz55FOI0F41IIkYnPsMkTSw22SKMKn0USjHneEORqU5q5QlHVfYY0Y9DFRWtcjsaKdVTzyxpo5N/5OHIVX8g3OmVYzr8MMRjFmmmXqdEEgdiGbMpSJtwdAynnIqtJhnJPcyQJwko1ElanxSIxv8yoQgYasCgGuhAhl+utaZHF8ciIZ9vwC3Jqb1hxZRNvUkrc28yCFkl3UJLmqrHI//pZ5963/mKa3evguc1pbWmR6t6W//KHn691kdsFWy3PWw8Q8kdtz11202ttXmXhS3fHfn999/ehntiiuqae25LN8YIUrsxEXeSI5EfvBFPVUKUr5BGFSmNlQA/VczALlryZKajr3Jc53rnzaXqEZ8Fputp2VUNXmgSgvHGh32ccchzjkyyZCnriZkJk52g2QPJixaozIYKUGgDiM6wxGN76KzHG9mvYWnQkgy89KdIi49Q0n1zuNDRVon6XHSNAgcI/KpeKv/8buiHxH325S//qX1cc112riYVwPeo7WxS+AH+iFUEuBFlbg6kEATdIcHWZUhD5ptI30RUkVFFzUUaCZyKEIeucimOcUrJxuPk9aRWdC4cS/vJcYTSQKTcJXVLUYc5qmIc4VDnK5+whCx24rkusS5Mqyti7GAnJiMihXYV44tgONYGjumOdyDz3e8k0wMtziAEGgBNaPBkAtAESngNkNnzBpDG0migeF6Ik/Wupz2hQSdU4Cua+fKYLSaFKGpRKxUgX3MJVLmvE4YcpPseQUhFvi9AjvyNwejgm+1RoZL6y58A/Rcrs3FyPDL4pBQy10AH3m2CdqGgBfUIOBBucIPs0mHhDDdCk5Qw/4TuQqEu4hW5KYkDj5wDX1DmdkOxJGcq2+LhlI4xE8r1spmopGASjYhEL0EFHeNw4l4gQcVtSjEx3lQMOLMYmZIFL09fBCMYxyiBlAFqUAJ4p6ESAIE2TuaNeoij9RypqaZd7o58UyX59hi4Y6qPgxwEJHQQWopSFUihz3koqRLavkM+EpLxox929NcqTcqHbO0R5SiFGUFTdumUe8vjRQqiQcG1soOw/BZJQog4c9USK7pIXy4hZ7DIsXBDPfllc5Qit2E6UyxQYUgyUmiJnZLqJTZ8WLWmCVVpTpN1TKGdKGzHzW5iQTG886rIgDdOsaZAjKD5IlpJ80UStLN5M/+TJz2FQL175vMQ+pHEgfzp0x7tFaAduuAqtWVQENUxog+F4frW9z3nMHaHB63jQk21Cu+ZapABugNm+4NRN+yPgADM5Hv8IVqQkrJueEOlHh1yIgyCC1wwLWjUYirLw9GkljfFoVJt8iRHqCIYP8VjP+ERLSKd0KhUIQ65RreVpj6Vqq2T6lSdi8Sr1s5i2tyqGrIL1sSAdQrj3KKiyJmCcmomrYE6zaBiNgC3PkB6J1NCGdhA18s+YqF67WvfjhbQ/RokfYH97080qK1QlU+wAyZwhxAbYIiSCqHRCQVlB2nZQ1T0P/Nb1QL3JwV/ZI7DpC0ldCsoUF1sa6AtPbH/ttK1ONqS0LbmwC0PdbvCWoyvc+UTR5AedCTjymQjSZ1JVuzAWxFdKcRwwRJZjBxNaVpzQb/IKiWui4htYoy7WLByOCMDXnECD09nRWvyOFMat663zC3DjFztOV+8Eg2/+eVvjfsb5znTOcEH/mtAxwfgO/OZwYYFHR/9HKVTVVbCloVkRTnsYXl8GMRVFbGekSppgrp00rC9iuJawuKa2vTFuKTJLrfyiY6IryyWg4Zw42ZMfzWTGi/F9LyI3DDpQnPJS6aHNa9xDV9AeU1T7ibGFoPlLJMVCuJVmTnBjN4HzMzMYfYA8W5wMzhiDw99KFCb4RxpbefZzRasnIjx/4xfmJSa23tepXH89pyWIo1oz0HRnyXaCnmXStGiXXRIHR1VZ/b13CtFcUufVtuBqxgUj6hJCW2Bw0+raJe8HTWVkFZUHiED1ROqnDM2xy6wJNdgmfLtWB6t5KLa+ta53sWTtQmHx9zu122w8lcXE1YciJVOORiv8bx81tMk7wAE8DnQW+ZeaauZDcmCOIK5rd+l17ncQvy2hkwN1Ki38KQFvvq5s77Kpts54By8970ZnW99o9an/pYIwL2OadnKtOAEP3hIbOFp0IFacoDwBNLrxWOOPyPVR9X7cUOFafjFiMSzpjVbDh9dxHMJHbquhnX78kZhU9mKw9ZieI3tg//vHlvnpDmvWx0gs2d/0QVoFkL25EsGZJWBzUkftzViz3Soz57qim8Y7StoFqwLVOvnpvPS9xvgO4M97I2+OFRwD1gTp13tAic4pwf+cBU5dUQNd/iQkZsNceyYJ1TSMcMuNO96sU8Vo8v+4ZU4coepH0zqZ7LjId+svjThMcKeYpUtH05jq0xR9t88WR3bGH3RmPmc6B3gmZ0e6qXeGx2dLaBO09WenB0NBZaa7d2e8oHbBaaSuXXgtsGZU1WgBPpV8Rnf2AnXaenN8lkapf2bK3kQi0Bf4pQQ3IUQMcxdbcnY3TEOcUjcjkWFTxQX4CXfxnEcwSwV+inZ+93aErr/H1Q53jU8WWvcDupRYQ7EAbDlX1cxhg8Yj/8RmxNMRgAKT2Yom5hFgOh1hgiEQLQFQZox4LEEQiaAXLeJoB3eIR5u4OFVnR5yoAdy3UuQz5yFYB6KoLcVxL1pA9gdH/Lt21noF/O1YPO51IPJIPQpTg2OWvrUnd1Nn+Fxw74JhPbdGBFyBbyJzg72wo4sXsnRWhMy0VH8QimsyWRgIeVNkSDgny1uYRf2nw8QWwCS08mYgApE21lhRlphRgwsI9E1QfZwwRscS38YEvgUBAU+oqdhozZuo+51IwaSHB/6oSoxXR2SWgRaYCE+3SH+gz8oYgkyYoWU3Yg5n/MNzoxY/+IlchoxLNy6IBz28RTSvdi+/VjEDeEymJBHAJnCtEIzKF4RvSLjQeR0hcnJQZEgQAIUCAEcTJnHoAIpuBwWcpfm+SI4AWMw5hzKkNUwMiNLytWxeAEXvORdnY46ZmNMcKNNFqI3fiM49uHuydkf6tk55lk6GmLu7UQJsqMJhhSRENcS2dg8qlZBSaWkYcRBHiQ+Rl8mGtwldNrRSN8/xl0PCuQNDZMyzZvhOYNAcgPdBaJCKORCVl0rRiRcSOQRUQg6xAM5QJ42QUKU2R9iVMIseOSv6Y7M+V/O/eL//SJMAuBYHdvIrIZ3CeMNVKZlNgFm+owzrkEnwIJeZSBOXv/jQISm7OEkaFpdH+rRUK7mjRVlahKEPPhDPsymUhrfvtDNUdDQU05ctlilH11aK1nlK+UjwkVf9OkXJ4bl0FBOWRIXQY7iLeVSWnYQErrEhdAldr6OE46UdkokFEKeKfhlVgkCYKKCNgzmJFSCymHB5mleRqYkAGae/XmBYz7myXyhZEamlpmMXPVnZsqkG3TmZ+ZkNpqmgR7oae7ka54juckeg9YkULpmanZDNyhiPvTDbCZiUeADORwFhermbjYTxUmiRpBYidrjVfQjVhJnLVEHV1pCLSEnVuigw4klDIHiU6AgEHrQWIYF4xjhVaxQ3yXf+jFhd3JndmpJXl7/AzaZgijsgkfuBSLswjCgZyVUgna152L4wAn4STnpgMzRSWMiJjlBhpjq53/653/SgRBwpmdyToIWKIKOZpyi5oLeKZ4CnzgS5Qi+5jBgwiaYiYXSJjtqgyJ2qDx8KIjyJrYEJ0uk6KUJJ1auKHFu5VbW1CfIqD+GpY1+X1mCH7nokIwGolIxFY6yX5HSJZKq6pJWwy5klSiMwpOSgzAIAyrU6izYKipUQl/I3BbqQAY4wAOYAGR8Rg74hZk2ZrLyH5pG5hI4QUxGqxJM639qZoBmApze3k3OaeKpRWnWqYLmqbhCaO6Vo532oTycySZkwiYE6i0Iw6DSJj58qKJW/8O/AJVgoejh/NvarRiLtmjDYar46NI/7lJX0qSPKUVT6NiOuohbmgMPOg4PxWWtJelDIimX2AN32uVUMAWtPhmsjsIu1KqhxgKt5iph3g7GBFuX/twKKKYGXACYLmuyhozN2Qm0OgEUSCu19ixMTiMzhWvsceu3Eu1ZFK3Rnuu4jqu2Ia1P+oO6tqvUUsIp/AI5zMOFyuuQ0A7t3ELXTh3auZS+ji2kGidWACQmFmeM+qhOFayLImzELSw8fM6MPCxCksp05IRTFReSWezFjpTGbizHdmw7kIPh/gLixqqsiuwsVOksnCwpkIJ6csyUYcFoiN4BDOtiiMbNNCBMTv8eYHoMH/gOZeSsFUirtL7hf2oBHXim025r0Q4ttx7otzqo0Ibj7YZjhO4pa+apNsiDL0htJAjv8M4qvBLqPCSqmXitbr5QvurrcI4tpULfwcEddVgvp6ktSJQawV4v9knYM+xoxins3IJfTpHauoCQbvWWuziixNyl4Mav/EakBHlsFIKs4oqsoRoqykbu5F4kee5JmDnAy15B6YLusjZGzNVTs+6s0aWpz2rBIbhu7sput8aO0oJrBeepIPbpIHYwnoaD2PkCuw6vCfeleFLCLxwvoRpqN5gJXhhDYyXW4KAL2cqI2RpccV7qjCZcpkps3rpt5Bys+CYD95Wv+aL/BENgBS7By3R4QuNcp9/K79zKDuDO799alf2ucJQy7uNqQyyYrK5iAkjCAbAWMLB6QAtokQMjK81eXudWj5ka3c5ipppqwRbg8RxWiWh6qwXPZQYnrQYvLSG/7mt2Q2x2QylIwgmbcJT5JSP4pZPuwtXOZj/MgwvXzgzTGww+6uAM5+LUVA3yFilbqtkGonTUhBDX6APuyPrsRP1WMTScZSwlpLzoRPclnsil4PyaFhY/ZRabkq6NLDETcxhfLTk4LpSuJ2OcDBQIwiCoZ83CERbN5/6d6XyewerR8RNMa3+2KbVGwg3SabgC8tE6aEEkniHvZE9uMOzhLiHjHoVy/2jwTiEj3LMJGwYKO/KsYq28RmHwNpSDvchU9mMO0uAo67BCd+VC11T1Sccq12gRKsPwwXL5wtiPpjLS0d36yqmRBjPgBu5Ixa8r1gMUDrMwXAPJ7q/Jnmf/pon9eZUgTMJgXulhxBzNWrOZymecxLTqdfM39yyjjDM7m7PD/PHstnMgD3I5++QGx43hdoMp7Aw+VzU+X2QkV7Vfjqw2ZG0+zIMTGUhkARJaFpT0qa32uqjBrnX15vAPQ6zBRTThbe8JoZ0RkxQt49L0QVzeQvG99m1J/3IEkZ1g4439onQs5Co4LDY47C/k7sXtAIYaQPOtpueUvRzIuKeW5jSaVv9PY6weUN+xRgYqHxc140UTUl9wU8ezU7vzIC+p4RrDLOLTmtyzYGj1PvulL1ByV//DV2sD7SwygTjY8/WwPx63Cq11Qz+xPiJNKsv1XGcq97kyB901UwCxLfzQQhLa+oZvU1MkL5N0Wgx2YYM0bJ/sNexvY1+DyYqxrTLzFHjMlC1ClP4aTkNGe3J2fkfm6n12aLuhmsrBgSSFaZ/2kqUzKzK1gpNzBQsyWTjeUTzebOPTHth2bd/2Ped2lEWu1f5zQEfHusXLE7uoQpPyi3rvw5kyc5eQJh4hdDMxgc9yYo1vknREpmr3XgfxS7jvrEGFYYe3FQeuxpKdSFuxkY//9FOcdEqvNDgIAwr7L0eu3F8gwpVWeWHetO8sZhduuXs2cEmCNlADuFBXbVQANscmOJqb+YKvuVJ/N4LGzYdebTUwS4XPn2DU+YVbNSQM7+3wuaD2NiYHd0M9xw95b/WqNVujuHIvd44zsahCNHTvoCau2oDFuFpWVh7gQUh07463b8WW1I8L9pDfjS+Pd3lPy3nj6uMu9iicwVz9hcxNeSUs7nxXXmYzqxfEcX2SKU87xup5s5q+kSkoiFxG13Ya9ae7trgqu4Ei9R/Dua758y80Cm3PH57nOYbvOZ8TwrZb7aDOA5OKNdU4kqFf74kruve69UlAjV4rTKS7xKiZ/1SgEWKLk44uHczpqLnEhPrFHvmoEzYWG/Z5FzM5sPoZ0JwOnIAQKLwXZAwiRG59b9V9R0aXx2fNISZ/g7kQuKHpxuQetOtd6zuqHvuR2mWaNzizszlPQrhe+vM8+AKFx7zMxxG2bzshVHgpmIK3YzK4kzCqkHu5B73QB30ooO3A2UhMFL27vzjSXciPfdBawnVmbbp0fEVYJLtZmBKQHzmSAzzXU3FZ6ppKGzM4YEOrX8ZmmF7DE8JM4+oo2DdivEk1x6fFF1sDR+YRbPwdcwHOu8K/1FoEqar7nTnWo7zKp7zy6WXLs+NsksNUz3zO0JXkS/6Fv0af53MJV60igv+7LN7zD/08dfw86OPB0MOo6RunwO3Wu0fJ9i0FTITqRkDFuKxCIGAWZlXvHVzKJ7b5XRIuSTni72t98A+/Fscy4Yq9k+pvLIBDLPDBE6gAn0TACTzzw98qysL9Fs59eAHglhdb3YcXzn5zHDPKtf1IgzwXqH89SFvV+ps8xKzz4fMkgl/wNOAmPjC+b5ODtcd85AOEHoFsBhYs2AehwISEEPrxEymSq1/XyFUkt8sXI0mSAj2StOfRI5Ah8eAJefLkpZCgVlry5BImKJm6aFpydBMnTpY5Hd1x9KnWqmXmzKnz9szZsVZLi0E7yu3Zqp53qALqeMeNI17PvBkV57X/61d2YsmWBXsWbVp379h+W9sWbtixcd/WrXcXXd5ru3aJGsVXm7ZYo56ooOBggg44gipVQjULVSVEggTBsXwG8xQoOZ5w9uwDdGjRnkmT1nEadQ/VQli39nIFtpw+m4zdGndbLdxwdN3ypgv3N710w4cL1028N3Lly5db2/2cOXTn04lTP1ddOnbt4axbj/edHL5/4/PlmycqYULZBgmuLyjbffz08wUG0hPJ1C6KFfmW0viJo0dKGhAllQzc6cCXDHQplKVUCYWnCCX8KSihsgkrm2Zq6sUZaJBKJpSqqgoEkDzy0IorucwqC7q5jMIrLRdz880uGmus6zt0KOKL/8dYtIHsDBWEnGKQxhqLrI3LMoNisyeaLO2zKDlDATUoU0stiCtPY1I2QgjJhDbbqJkRuOCMs/HMMtNU87i2onsTzuye64677eLcjk7icgzPH/LGIyeSQwxSr71C4ZPD0EIFlU8h+vbQiBHALBoF0gH1KBDTAhGMqcGlVLIKJp5O4gmoVRpMpqixkpKFqQ9rEdAqEbFy4xJbUoSKxQtblJFXr64js1ey0LzRrnWMBW8/HoWJBTI+SFDhjEUgOxKTypSEQzMfqrRSytB08CEFbqfUcrUtX5MjjnQJ2SQTX4wZU8VhzVyTXnnrXfPOfPW1c99+h8sxHvH8HM+YQDtalP+9RBNuVNE+DN1jUIgf1YiZUSyiiJn/UPKopUwT5FQmUG3SaWNSs7GlU6TCKoamlolBeSpZ3aDiDqBUxnWb64jSNZqcfd41Xl+DBdbeGY/tZkdRTPlLmFmEQQURJh1DhepFrEZEDWwpyzrrGagcl9vRcvhaXCxnOHu1zXzAAgt1v1z3XXjNmrfoe+2+O7k43WSuTTn5nS5Pf7XLER+B/bwmnlsyQfi9hRd+A9FFFY5YYhIbhZSieSzKeKNLBd2IY49TkunTCU0HBKhiSG9qZZqWsvXVNeiQWQxaayGmw5t/zp33nnf/Ffi5ggd27rqLNbaaanbsi+m+FsFajUWqRpL/7WyxnaLtqEkAe8pwux17WyvJrTK2ONqOYzIvNwnm3WqUKV7e5PA2vu/6Bb8ff7/tvAee7/Yx/B/4QFo3KIGQN7yBcZODnKEWSJAGKrA9CglEGfQwIDxcTj/z0NxeROEfjkjQQKILochM54iX6GQZxOiUhZ5yDJSZ6mWAkN0MZ0izWuHuQ71LSgqbMY0e+i5DwdOZ0IgIPyPSbWjIWx6PIjMZrp2BMVYbBfSql4MrdAZ7WdPM9rr3vS6Cj2zgW8L4UJNFt1FiE5tQX9xwQ7/5vfGNysGXHN9kv/z5K0/98x8AC1e4bpRCUIeA3AMhyAZCDjJRiUIkGRR1wcpBDFIZ/9xgNVzxnwAFEpMlK9FNRhiqkeHEJKWayTE6ZJRk8KJCxOAIDWV3BykYoWa3y+EOeUjKYtTyhz/MThGPmEQk+tIoydvRXvgiGS1q5nxWW0QbENG26iGTSdibghfFxj0UkGAG4ivXlcyorkJgAo1ecpc02sgrOJ6TjuiMYx3tiKfA3S+PAOMj0uSBj1Nkgg4ITKAhE8nAA/aTkQ4M6EAGSoYL/rOCjKygQBgBCV9cwzwa3IspPJiQQB7sECTpiAk12dFH3O4Tq0PVV5BSilXYApBukN0YWLqGmYkBdbA7pQtZdkub0gKXudyZEHPVS58ObWjKS9ZFRiEKY2ILNN863/8Tn8k1QWQRmt4SV7i4SNXtVWmb21yb+ZjJzCKBEyISYaNY1Hkme5R1TWf9pR3Zms47Cs47eqxnn/whj25oo4/yuIUgEYjQCBa0UIc8ZGAZ+c/CHtag/BxoQgnS0PwEpjya+8U9OTI7jGr0sqLLCeqiQjpQnPRWMFylSlvKUinEEqUovWnLappTnU6Dp7EVXk+H19ZgwUuoFQnMMJyHNSyozXugOd9vOcMkNXSVa8StZnC/+LXUpOCqqHHultqG3EF8ExOkgEgabbNWtH7Xu8WZo3jDe6a/vXVw7dhjn+q5x/aeog8T9Ks/uUBBw97XC4oFLGLLwN/+/vewBNXvbJb/RpHy5IMc3biFGj1nOVCJcGSwsopQQmqTS5wKXpI4KUdIW7tXSiErGhal6xyEU1qYGJdBVLFsaTtboOUNmLXVi27B8aOnSca3yoWmFuEAPiuegWtq4IMasrVc5kLXqmJUspaolMWuXleKmNiuROBBLPBeubz3Ii949YYm8rJTvf/LKz3F3F5XSG6w+yUsfv3b5jYzVg+JBehDRCEMchzYPJMFpIMzmVE/dxJWrVBh6Sxx0jGpMBNSWYMWFo2ED9cuECGVdKdWyFrXAnGnmcYZi1sMVF6iRUcWmQc4wMHbqg0CeloMjTSfWeQpJBe4ngnukck2XR/bmnxCRgSqeT2J/+yqLxLG6EY576VWLRtby1jOsvzU2eXw1jHMZSZzXfP6i8Up1p9sTiwXsO3mNn+hsFYA8Lb5O2fH/kIbB9agMHxRUT+/+88anbAvPiHhR4QCh7bYiCTKwGh/28AIIB6DTy4cipes7sQo5uGKf7dpTnf6xS4uHvLyEo+LgaMfpYaMr5U5iCS9AORiWyqRn2mlqtaaSikPn3RZHi6l6nrXUOY4JdYFCVOc4hfJO1ax4Yjsevl8nW7dMpuWDWN1Gh3G3Ih2H29T5jEbI74Cto9+yV1uQ3ob6/Ulg7jf3O2HSQwiE8F4PjKuDQW7O7N+jpUkVEgiUNnshfz2txaQAHCAC/+c4JRWRcIvzXBNP5zTDV+RESm+JxpnfBixUATHO35MkBd5q2qIQqu/ODaqfgvXZMRq+F7Nh5h33NfpU58rhp0XYvMcL/Q4K9CVTXTXv37Zbi16dLzh3mHPNa9MN4UBrZ51Rmrd94gFN9fHPfxxez2Cj3RsBsl+4GuQwhTX7vPaYQYq0L6QERU07Q94YIMS1MAGTBD4vSVt6YX7XfAOj6369fcccr7fLfA/S8UtbvGKkDrjr5jF4tEQho6DAQwmDwtC7vFeIKpC7tZI4OS0JYy0JAFv7TS46LjaoA2UifEGwUsEwWHkIBKqAWCsrMpU7y5E0NhYr/Vgr6xMcLxQMOj/8qYr+Keemq6PqE2ABujM5Is9gC/4drD4xM0Ht874dPD4Fms+HgIi6izd+iHjEOwXbvDdSmQNOgFmyE+UgOIQGg0JuM8FROD7ikD8Bq5BVAsZ+g791O/v0q/9dkkalC5oXgQvkOVi5kEJweEVXmHxFu//ArANJs8AnwnkogABwaWqbq3yIvCaUI7JcMAEimsCZc7XJgHV0gUOvIA13uChhi0E6UWPNtEeOtEThaMTzUoFT/DKRvGcQPBulOF9wmwcbmG98soeBmjB7uvqeHDrbNEHg/AHd1EIh/DrJGYPLGNdxE4J+0FzbjCfZIgORMyETAVCyO8K6a7uZMD7WKAL/7/gC0JJpsiwDNnPG9EQHOVP/oylHuhPnmgM48qBDl/BEPAwDMwgDCYvCgIwCmiABqJADexRHmkANFLgBZLMe2atuVoObK7JBA6yyY7r8x7xEZMECoRgC12ABxjBA9FhBC8SI0nQE/WBI1cvFDPR9UqQFDOS2UaSJE+SLYCOGlaxjTgy9/xo2N7FF+KLkfBAzXARsZ6AF3cyF4GvF4dwvyLGIYxQFCCqHDJOFOQrEFQq0ULI3uRO/LqvGkGABWSACbLxEE5qG23ptWCr/c4Q8IZo/RxuHN9QnixOokitHMoBG3ChDg1hEd4xC8IADOzRLu/xLu8RDP6RABXQLwWyi/9UruUOMeUEM5kskCELgQIh8gIQwwUCgRk+8CRhcCM70jIv8yNNURPbAiRRERRFEDRRUhTPSSRZrzPxRRVxqxucTtoUTCbPLM7+KzaBEieBkCd78ja7gDZ77+v8YD0Y4RTuTB336oBmB0zUbmZOZCnF4MN4wBqp0gKqsgpkJytLhbXMjxvHEmc+LSxxpQ13DmD2KDDSDRzWMhfO0y3bUS7zkj3vkgBB7i8VkJoYkDDrcxHHRrjYphGtJjExoRCa6QQa0zHXoBTMMSMpszIxs8w+kQVRTzRDUzRNkNmQ7SMd9CJLEyONLTWd4l06kTX3IUdW0l3uqT4O6hZ5cCdPNDf/cXMLbtMnfzLAJudQIoXsjDESirMpoRDSsIIKerQGnrMCPiBIwe8qTaLgKM2z9q7EWivFGE6HnOK8vvH9oLQszRFZ8AEd17Ic0JMVGqEdFeEd7bIDaKAD/lEBO2BM7fE94zNc/jEwx6Uw65MRqwsAZY4/+9N8XEBAL4AFmEAPIvM7+CdDBTVBF3RB39AuNBNCMbI3RHIzJzMTMTStMvMuKHVQQXL1QFMVN3Qc9AEW2ysm38UVXmbPGMsLis82a/NFV5RVVfTNuASgCCI4lVAYrrA6l5MKsoJHe5QKwO9HfTX8WAoP9g2GrjPhjpVJL62Wago7bYobdUdEcUtawbP+/+gpMF4BHIABG7ChHPjhPDmhSw2hDsLUHtHUXM9VH8m0TM00IEkg5KwKXOhTToVrAsEAykCPISMjuxTzCi7gAQ4AMUAg/ApUMgk1NAvVUDHTMxf1QU9zNCv1bhw1Ux9VUjPVYCcTVTgV9/pIH0pvU0e1kj5IVVGVZHuwVV3UVXfT3CAqH/bqOMegR93AREzkpWpHVzuCWFMrtWZppjSEK5U1pyrE4EQFZF6HtWBnZ3GIGZZ2aaeVFenv/kgNGKa2W/nBW79VXIlAa8sVTV8AXdW0TOsRPqmKAwKRbO3zmvITH+31m+70TvvTP+PACxoTYBsTBKRAEtZBgALVYPsWYf/FjAYts5yS4zbooXAbNQQ9klIVl2ER9zNTEhQXV61MsEIf9mIj1xMzNjU7NWHbYRw+FhZCN9E+yFRT1s1gFGVPtkVdFBtNlzcfRhiMkbLyIFcf7GOub1R9gRh0VyaXlht9KJe6UsVwqSZuwg6O1w7+QHmTd3n/QCcSpFiTVmmbtvCstdSyFRy4NRes1mqxtg6+tw6IgGvRdAE4IE1BLl3fswNIYF0RUE5RADQMcD+t5g43rmrgFmtagG7tNjrvgBnC4wMRVHINNXAVltgmNHEL1S0sdSMReHIxVyMT9HH752AZ2G8FOHM9ZHOXDkRvQ1RFd3Q7R75KNkVdVydNVnX/lcAKVHh1efKEU1cHB2wiqiFQPkcrezaXNDjfZopnaSl4gXd4gbgMM4SHaMGzQmV5kVdml3hmR4QKyy96QdZdXJHUqhgX0NNbuXdLNYGLubgO0EB8xdQuX8AedyAK4tEu65Efx/hdkQzJ5HdtHfEO5/gOfW3x/LMyWsAB6naPg1QMCDY8FXb1OvUeFpTaOpdB10IuDrRQG1hxKxNHGJlxS/CRM3OSJRiDLZkjNRe39qgTWygY2KUpO6ETLqo4Sfi/Sjhl60s3U7kJXhmWY9kJZLmFWTR1XxehaOMUXKEUdjdaNRiYewaHx1AZzi8YflaIk/mHldlJd4iIb+qElLGJ/5mYmqk5Vjgp0fDjFmaB1Nryis+Te7f3anMBXL9VE7xUXMeVXIlALuVyB9rzncG2TR+PTq9LEb5JESAjEW5BERLBn28hERhyXxXzBBJgABCgjx0ABLSA9KoVRBWUIz03zCozYdtLcBk1kvn2oRuZoxG1M0tzcjG5o0d6oyF6K1aykz9wDVURFjyFlP3s2k4ZdVN1pmeZVWnZpnG6lmHYhIUwK6V4ejFtd4B4DJnZmYsaqY06mdNPh4KXpoKCxDpqQmCClNOIFLYZW7fVm9tSnLH4W82Zi1lBE9L5e9HArNHgi9Egnu0ynndgB7z2XMmYBnYAAOt0Eui4nxWBn28BoP8XjxTy2j8J+gIOOqEtwAYiBYBLWrEv2CUterENOKMlurEf+28beIElNYJJulIdGaI7uyNrgUNT2nNRGnRfus8O6FRJ+IVVeVVvWqdf2wfHSLZZW+tg1D7AZFRXMndWuuGASKl/G7iHOIiHu6mf+anF0Baeuhdsyl26IfFIDVun9hWmFpy3Fz25FFyze6zJGnzD9x3FF65pQGuJwK3j2Wtf4J2xgK7rdBDuOqAXb//0uhD8Wr4DmhQGOg4CNKH7GATY4KE+FZElu7I7dsApWKIF3JMRebIfe4IvFGI1m6Q926RvZbRJ+5gv/Jg95QnlS3Zk2pU/HIZ32kVhm8RjO6f/T7y1Wfm/8mkjDA2le9u3gzupZXypfYbGVUx3dqqHn1QaaqMbxqOK2zJbqfurr5uctfucyToMvlcuxbdM03QHxlt8ybu83Xqu1xsMzGAQ/M+979rL+fme8RAP99U/wSC//3W/GcACuoASAgbAAzxSCxzOD5yDAVfBKzqRLVikOVrC+3yjhcIr8oIakhuVohgWcvSaZ6fDURvEG93RU5yVS1zSTRzFKR3SGc2yEKKXg1moeTvGiXrGQ/3GbbzhhJfTSZ24eZwaqkE85pBbtxUYptvIsZuLG8GLmZxcy5VryTjKtfYdo7zKr3wus6CuufyeA3oYwHzMC8G++ZnMv8nM//UXYKe9j12AIhObsvlWUDM6Fjux9HBDskuabxEccA/ZsRP2kCP6UiuZz/3c3T+bGJ7i0Jyx4LRSdD/FeaV50V750W350kUc4Cc94AX+36lTwzT30xNe4UV91E09uFF94XlcFfm61ftBS82TyGk9uxsBnXG9ncMgL6U8DM56CIQdDLCc2OFxLr28n4cBE/yZvv26bQN7oPm1BdCc2tXc2icC27P9csF9NT8SNzZUrgr29pyOvfBc6S86zvVczp8eomtlpUuK3m84ww8hViyLDvxtdvrd3/+d4MOehcfe0kN8hvrr4BW+TtYe4m9ceB2+4eE+1X1oJX9hIkbN4i+euv9Z4bqR/Jw7vrvf8awFXy6/+IvDgLzHdL3Le9jRWlzpeJ/x2q9voW0rv/LjwAdOoI8LoLAX+r8TXKNDP3GB3ts/2YM3lZxAf9s3cgbpKt3RHc4zOcLf3d1viFRfJnoxvKUvIdH/gA5UKp+6vtFTONLF3viPP5a1oIXLwCqyMmPlRO3rJO6nv+FtHO6RQRVzSw7zXku5mu/7/si1G/C7O525u//MGuTRdwiGwAwYH60boQ7f8vHfG9n/eY5rnuZpzgcOg9oBooBABhaklCKHMJ7ChQzvOWz4cJzEbvYkVpRILaOyjdAk4vu4D6K+kfv8mTxpMqRKeStbtrQH82HMmTT/a5K8iTOnTpWXLhHzBcvVRl5EkyEzyqtVp6V06ORp2tSNljVN6FS1uqUJl61cs2rt6hWsla9iyZo9i1ZJ2LFp2ZZtW2aN3KY+lX2DhndbOL17+frt6zfatMEbCRtudjix4sWMGyMW7AzyY7vdyM3Tlq8fNmzlOpfrx+qVaNG4Qptmpcl06tWmGxl6/RpNGNlhhgzZgds2Gtk7ZjcSnUu0a0WJiBNHpWhWcVSJbhV3jil6oenT43h5gOCA9u0EC2a6ljAeOfHkRULE2C69evQajT7zphCk+Y8o/9lPyXKnzf0y+ev/D+A+kjxSCjGuCDVUMAoitRRTTkEl1VRQabEW/1xvXYhhWxaq5RaHS3zYYYgilrGVXG8csgpHeVnDYouAvQijZIUd5ZiLNdp4440b3VJZPuBo5pln2JQ2GnCnHYkaK6+9oglshtAWRpREEIHbCzvothsRaKTRCCfBsdJImIkMo9xyxI2ZSHPDkHKLIopIR111PmSQnQPbDeSAC338QlE13aCj0HgNreNNoeyth2ii0rj3XkM70VffSS/hZFF//vk3aYA5tTTgKgfaEpQtjCpIS4OdPCiXG25QISFWJG6YYayyVgirhyPeWmJccwFiSYorxggssDPOmKNkOAZWbLG33EKOj5sF2RmRRbLypWqraeKak3VsC+WUteEGLv+W287RZbW/hTlMccURN8swb67pprttkhJnIZtYR0Gddw6kpy/U+OLvexkROnB7BrpXsEUKD7ooUo2WtymkJ90nX3z5OXQXfJZeqmnHme4jVDVAuZJJJ6EiBYuppzqlqqqtykVhXLXSOuvMNjuBa81b7Gryr8H+LE3QxiY7NLJGF53jZDsym1k/0Eb7pZHVepmktk9uCWVt3hIRRrha1oFGImFSm0vZuJybbZrrqqucc82lOQkmt8BZCL77DoCnCFtEEkkpfp988Kcp+71K4bUQgxeifZ6nUVHUpPeoxPdR/HF6Qhe6ceYefxygZf9c48smJZc8+OCmQkhFhDBTyHr/F7beTDPsGgrxeu05w7XrISginhE3RgMNrGLnEI0ssUo7dkzyjx21NGZAPm12kdGrljZsiuy2W5SLRJlFbVlcmZsZW46dCz9mZ0uu2uqqbRyamDT3Ztx0x+FDvnfnrcWJuj/iCK/8O9KTABZugIajDDwaIqjyAIoaKFMQ5CYlOUlxznINi8Y3xsExhmyOc5PyUT4+J7rRNUiESzkEhHjAA5etDoVCCALtZAfDGOJshjS8Hay8cCJJhKxQPgNe8JBmmN8JkXg0UgzzlsUscDzraeWIHnDMZq0wpQ0N10PDIqzIve5RCVxX2pLYqNXEXDRiDnW4XhrOOIc0nlF9Z4pO/5roJb/55cB+A6mjQAqCQipIQQx67GPqnsKrUEjCcAS0hb8WuDhHoSMjSSmgxjQIkghGclIUlFHQHrjBTEasHx7Uxi0IgaIQknB0qENhhKTAQhSyUGcyhN0LbVdDWMqqKbrzVe+E6MNcZuNYQ+yL8SBjPIclhnnKWFaPnge94HzxiVNDTbaIg73dXDGL3ePiEMJWrvOBjXvYA9uWoPkmNxEHTtIhZ93meD+B3JEFqkSlEd4JTz1KJRA9GSThPiEJexrSGANDJKAW4g2jFM5ksEiGRfKzEvqUhCUVswlGGqagS2pOkxx8SWYuqo17LYVvo+uo7qLCA3kywZ0tNCWHvP/QShum1FY6kCUryxAIeu6wh7oEYi9xSVNjLegoO00QT3+6tG4MAxzgYGJnNvOK1wzDSEhCzWvcdEUqTpOaOwADuLLAJSiOcQ5QiibWdnM9N0m1XmQdhFnphx11GkAAbM2b/gBxh/7h4Q50lQpd7+q//f3vEZfwlIGYQSh/KmSR0CDGQAnqwD4xtGKLdRRM5BERiCrvkRStKOc82A9OelIOQvBCLUcnOhM2BQkpXF2rSPQGNqB0pay0WUu/4tJY3pBEMdXhLXEKo8tBZni7valvjfjT4O5UuEeZ27KGCpohJVM4YztSk6QYm+txk3tV5WL4yKXN2cgmmooQHxWtKFX/8S2COmYoq1kRgQg15CA7BmivANw7kAsIoQ+CIyA+7wuKS8QUrnjlLyD5+gm/MmPAhvKnYQtnib7aciIIrRylDsgOofVUGu44YAYru6mmZTaz+bjFG1zAg7jkcxMky8RHTWRC/emhDyuWwxtI9AMYwOCVrVUpa0GE49jKdi201UMpbqvbmv7Wt0Hey7ASVFDB+XS4CDvuj3Cxmc3kwjNRm1YUxfRUsG2Pmt+zKhfNkNUpbzMMYOjeFatYCPB2N7zkbXMh0Hve9EYBnQSAb1u1I99InEJwRAGVffG7173eoWV25avhRPWThBnDsPpNcMn+OhGP6IcijJNwcCk8UQx//+yDG+70LTgb0jdkgsR949uLadliOaj6VTIWgatLIAIX7vjGtNbxhlyHWpkSuMhC5vWQb8oRA4WqFKPOBOCGdcRljQkcpRkSMJ5N5WdbGUnaehM3y1xN3HhZ22h4RdkaIZtBdC8M4x1vNKdjhnSX183nBcNZ25DeNqhBDSiIgJ0JcGcHREAIeuYzqP5di8Pad+CfeERdXQZXvgbwcCpi5FIS3BNjJ/pxg2UYJhcCjwq7o1DCleiFNb0PzHaak58EtWdZjPLVmkULJX31BSwAc5izgMa1rrmtYYVamNoWyL3+tc99yc8DibKjJC5osImJRHm8gpPNfvazoShtph7JEP/PzBqZsV3mHcTBqthOBCuGpAizltms5C73eMVX3nWrXexvBgO82+B2ece73vCtO55v0Ic9Hyx5fT4cwP/8vwALNMD/u2seCq1gv43KxHqVOD8VnbCFJWrjQ9FFLy5/lG/4hx4fDxCnR77heaAiEm9QAhJMj3oUynj1MlDBCFw+gZjbiSB6m7XNZ4f7m7sU1zqHRcF8B/yeCx/YGwEKRzMBykPIgRAbRZBPi3mLpUqt6WRrqvXB9NQtX33sWeB6VbEdNtF0N+5uHwS8xZ72QqRb/eJuv7uxvvX4xx8RWDABe9Va5+1cAAZ5BwoxllEMAGh5h8N3fWd5+nV4buA/oVD/SAXXaHCFcAnnVwpSMqJFB4mXDI+ngXYReZPHQ6SiCq1gdBekcfUAYZ2nKSIHepx0DZQABTewei8HAhvgaiGwAq73eq72chEwewzggwWQJ7LzBDZ2e7ZnMzm0T8GnhMP3c74mGK5wChylfHEgB59FOkLhfEn3D69AVERCLU5nfUVSLqeRfdQEf+SHbfEyflEwb22oBoiAbebnfu32bmgof3EQB2zYBlOgAXaXf/GlAj7mfwIYgAVIgH3nZ6HgCIfXRwpIT4InbAdoCYBAaE8BcSU0IYAgUwWyaEPRcIlTYBJBeQ1TKktBC73AgZhzgpyXaR7jQT/SaZ/BSeBACmcg/wQn4AIv94P6RgEhoAG++IseEHs9aEfyVYTHiCu2w3tuEQg+JipLCI1MiFtO+ISipFcuJmrNF2zFBBNDxWzNVn1Q1xrNtRpg2AixYAjddXVRogbbB3fwVwhxY35uSI9x947o9XZvF2/v6HZ4iIdap4d094d+aAEiIIh7V4gDaIh893/Jg2AQ2DJ0RSD/FjjEJoIICEio4hR/5AafNWx8NmF5wUMSVoohiIqgqDCax4ooWBPacBlElVmyyGGbpVo3oIu7GAEPMAEU0ADCmC89+INACISxZoQ1hoy65xZkECIw5YygKA7RKI1NKGEHUjKgpGrKp3xXQAdxUGwAcwo8wv8sS9WFRGI2TfRsqjEavyF16JiO21Nm8wYGUWCH8iZ37UaPbcgHbygIe0kI6NWX+MiXe0mX/rh1YHAFeRgFWCAB+DeQboWFAAiZC1mADTmZAacLSoGZDKiZhXSIlVcyCQYhhOYy+6MynBlwk/WUqUmKIagKJylR70CCJlgR9LCSnXcPouA5GtZp4KANo5CXfPAEIzB7eOKD+saDxxmUxcmLM6ZysUOERwlbSDkiK5YihGUO18lbw6OauRVh2xmVllZijIBye0Ce5ZlafYB8X/kL6wkeQwWOZgOf4jgtVoaO1saObhcGcDmYv4mX9AgH//mf8haYA0qghOmPh3mXHaD/AO6FAO+FN40JAoBQIMLEkJFZmcrjMBXad4CXcCaZgQAjbPmkV6nSiPSkcJ3gaCaJeb0lDg+lDI2kYAaliiVoKCRYE5rzEKN2DZ93UbMIDsKwC6NQCXDwBBjgg3fWXsoplMTJi0SZFc3pnNAJS1OKlLz3BSumQ4S1ayPpnV3KDrDppUJDfIFBFMQmnuUpCWjaYiakZ+x5De3yI0MSn3MaGlIkHNPClm9ydu84b3m5j7/Jn/N2Bnl5Bv9JCIeKqIcKCQWaqAZ6oFigBliABTQgAQnwoJd6qfFVBo+JoZ3qqRRKXAtpmQ+5KmKgKrziVyC6aCBqkRAoT46YoiajkMNS/6OpCaOyKpK1GpuSt4r9oR7IFwm/gBkwSVREpQ2zsAuLkF7BGZSM2ZjGuZOxJmsoBaVR+pzSaYRUqq24NoRfAFPZuKXYCZVh2p3fCRmhIp5nqqZ+MJ7LRwmi8AtACqecEZ+cQDVTZi6uMTZiYwh5qn1kpp98kF7pFah9WqgH6weG6geNupebQKCNunxUSIWqFqAvkAILiqRJ+qxbMKGRsTwfC7Kh+qmR+HergJGV+IipimisamKqIk90AECmUip9F1GXtHEc1wqX6DhBZrO72quDJZvtYGKppWdsggpHG6SjoLR8cAZPgAMbwABtxVYBgKRMGq0opBXnqQcvZq3Ymv9j17qtYWs7SjlXgwRY62AO6iCu5Mq2UVl5kZBP+ZSujEC3fcCu5dmm8UomoiGnZWOv9kqnSQUbefoaZ8c9fLqfgKq4CPuf5LmwiUqgi8qwiJqVESuxB7uYfuiHBNEFkfBXIQu6iCGyoQpwZTqqAQSa+3Wi+oSQJgaRfwC7C4iZh1aztnpgCSaCRGFBuvWJNJpxJkgoJZgJ2JgEZqGUZHCwSnmDwykQUqtW0EqDrle859mMcPtiMdO12Zpj3DqE3fu1NPRa3yu2bMG9y/itO6e2utq25cq+TOiQfsMI+ES380u/j0u3lbCeQCp9T/e313KvnCC4ZyJOZjdd9YiXgJr/vIP6m45Lt3zJN5HgwJI7oI16uRP7nxdbdwpAtWv1rFXQsR4ruqE7uiNsgCVcuodVQgBGuyB4snaggP7TK6yZu0ahW0mBuiK4jb1bo74bvOrgDvtjFTHmAjUYvTJQBD3wtMzbvPkGva4mY9NbW/ZkCpJQeq/itbLlveKrxVscFq4zvkfQrd76rXoQYAuUvuvbvmAaDmrcc+9rpvULx4gKCaYAr0AqPf2rCWnkv6mRfQMMJW8plwesuITKtAm8B3RrvxEsuRC8qJDwwJPLYodKsWcwBVNQqRqLN/dXZ23FuZLgCyAswqAayiNbFEzGZCSLwj0xwzulFJOoKi6cB38A/0AQp2CYp1smq7PEhDC5qr7e+VEv5kIopIMVUAEY4JMV0KxWm5O96AGsVwUopk8gmmLYy1pZzMUfEr5frM1jMVePeLY8dA6pmcZemjFeuruCwbMykjxvHMf028ilIArw+gvDsMd/q0Zz4L+vUJ9+XMCBLMiDXJ5nENB80MAM+8CLjNAQnKh2a7eXS8lQQGeYKtGcbAE/wAgBA8ohPMoZrdEdTcqnTJknE3CzCwuYtyAlnbOLmICnOsv51ROuWVjBoAr9E7MhqcNc+iuMN1qqpIOzZ6TIjJPGLNQ0SNQgBoOnJ2KbuLJAYULUfM27F8a3osVgvM1V2s1lvEhnvJ1qzP/VX7q+5xwjiRFw8hvHjszIi0rHbIIJioDPfzs2eXzPbY0u4vQmWNSPeqiHiDBefhqoyeu4BK247swI76yoETy5eDjJEK0DGDvRHPyHtJcJGK1TG83RQDUqGX3KJlw4M7vCmr2hikiJKMtfNc3KjVbLDXnZvPwMq+0w+jXNwdzTxKykMTcCN2jbtg1iLkA7uWNofsfaGbgKVuHU2quM3vsEReC9yP29PYDN2cxSHkLVRyDdtibGtGW2vxd8XZ0O5bzd3Clkk1EMQUHWkPDGpsAHdIze6K3Wk6AIbw3Xca1G+xo/8nh1iWnffboISru0CCzQAm2/dOubj1zQjWzWAr7/0AsLoImtAyugyY2NfxVtW79N2SE72ZXt0Ya42ZgZq7mLeQppebLQCiBe0ohmC4S3X6H9yrK72ZMou6Ri0+q8ob+8BqRlA7Et2/oGazIGW8G8ei10BLytT5GRF8WXCa6Sey6V3MZtzdvbrU8d3U/+3M7drd183b08zuLs1W0cTLxgkXQrv+kN5uodHZPgdWOzVfCdRmo5DLHgx3dNA5H65lMwXkorwYXs3wwM2AUtsO9s3gXuyIaNyA09yQAaA/aWfw7OxDbgYxmIPMAVyhauoeH94SGoyrRsih0+4peZ4apg2p/AOwemiAYHuykuyzGLojSNqp2dw6b74SIaUygV/8wswAIxJ+vSmhVs0GLNWbytElN8FeRCnqvEIAlUYZRdoeTde8RLvuRQDt1hu+zbm3NVbuVo/N1b/jeOTMeMYN5gHs9i7kZfdOZoLjbowuYDvAhuZ9+VzIb5vd+Dyrh4nufzW+Dz2+d/TtAKXb92O+j/CQV9mE6ZysQsEAgI8ugWDkSjvJCnSOkQl2CpcAmpEOKniOmXp/AaTol/NJEDBuorPuoJCMP+ZaIkrQsNlDIk7epRQeM1XgM2wARfobVenqandmpQkXC9TYDAvrsacQjDTdxbfOzPzuxiq9w6Zr7na0g+jNPkrN3VfhjIgIolDrfmTbfqLebdPubEEe5onv9G455UswBVbkmXU/AC88bui0Cofp2Xhxzv7UzgBe32cSzoiW0CaXU/iO4AAk/whKE8RITwCen3IO4JDA9xEC/ifv9TFG/xdgBPNSAGeEAgtPuiA9UT/fNfHc/SHz+ABFc4J7/TJNWMcQv6oX+NQEzTp73a0DgwrlDF2StLWew6Pw/0Qf+10R37u9frR7+EV94X3A00oCzhjAIq1z71YW71lfCulBCPxIHmaDQuW7+36fImdy2pU8AHozAL+23n5bn2ei7v9y7v9bv9d8tig64DL1f39/asNhDhFU40ff/34d3KgS/4uCvxIov4mfkIq1IDIPABAGHETaBLqwzqOhj/7NhCXgYvPQQEKI8binbsUKn4xxIoWQltffx4SOQhOiXdSBEzZs0hRplcvpQE0+XDkSNpFtR17JmzneLM+eTmTSi1atVclWnCRamTJU2ZPoXqVOqRJ0WeXMX6hM8oPlepegU7VWxTqk2tFjlSNu1YK0rctu2y5cvcQASfUQvKDqjPd+n89v0mDrDeveEMb0OcuBlPxskaO2ZYymCplqYsWx4lKrPmSpQ8DzKDRpEhNKXnpElDBDUa1afTlB79StEiMGqiRJmihk+lzFz58DkTnM0ZP79/MzreUrny5MtbQmJe3E+f4tT7yMGO/cSFAw66fzcQnsB48QLMj3dg440r/8ePp71HFn/xfPrR6t9nmB/h/v2qNv4HMBVZislvMVroi68XWhas5aBQ7rhDJUAe+cRBmkLJSSHIkvmolU46seQRiS6yqERHcPqoPbwkqckkMegQabKXHKRxpg9vvLGVBhnLizDBhiLql0iQWioqI4+My6qqrlISkXJiOSOrsN6iUq21rsQhrSzJqrJLLuXSAqm6SsELyMEC++vMMw9TrE33HiOmQ8lMKcUURi7DjLPOIOETkULMMKOQ0lhjjYjW0HhtDjQANUOR2WjDbQrievMNOOH2kA45TTfltNPoNp3OulCvy+6KHCgA74ACVmWVvPIEEC+99VTEDz5b37wVQf/9jqkwFAwdTMWTAAU8kCFb5VuGQA1riazGClNESJVghf0VFl40jFMZhRCC6I+KKNLoWWZ8YUYaaW6KiI6BDinFFWtrpNFDeaXFUd4UzVQn36HGwauba65hxAsvkWQrKyWvOgObckbJoeGwpowLSy+VtBKugauc6ws8CLJlqL3QBNnHj9l0M5ta4fyoXUbqrBNPzizrM+Y2wKDZjCEKNTS1IYhAdFFGw1hkkDawkHS3WYTJ7Dfh4DiuueY8dbrTUafOTg4/4IBiu1RVHcBV8s4DmwEWZrWv7FzPlg9XXYth8BNQ3v5VR2mp/a8jZdFee1dmGYN2WwIZ5C9wbLc1aG7/R7zNiMKCPEQ3ooEMAqnBeDuyW3AHM+ypR333RaeoboTZhI2LCyZdylH4wYYPEqS0mC2Jr3zi9dFbj0vMQz4hF980f+R9d5KDUuzkDYORjLJSIDHeZVFg9kwQ55+PY2aadxiC+p13wH6In7MwI/o4rpB0kVF22cW3PZaWrmk7P5WaaqoxhT9+7Py4YgUPvGuV6/y9DluEMkqhlfAEmLe2+QpucJsX3KilimLdx2y5QhZPCtQ3vd1NcpdwxIkYSMFrKSgUIoKQGyA0wjvEhCbpkkTKstVBBQnubywcHI82tw4a1hAv43LFJjJxCIHJhXZUal3prrIVVGCDH7FgHcRk/7dEJs6udmVYSQrLNLKQHUZkIyvZA3XFIclkongqcxmemkeIq3kPC7WpHvbUmMadBYpRWYjDC8CnhqNlBjrTIc7T7AQd6AjCU8iRn6hIZR09VK1qV4uBAyKwNUbybzywElsZIkGMngzwZGhjm4CmdUADyotuHLGbA02WN1LGKVmnrOCyomWJP7RyIxmC4YYMGMKUiIFFJ5zQJ9iTohUOboJpewy+bNg5asTpEyJxUZi8FDEhBvEqpytHNKG0OtY1USzWdCIQy1AXKU7Rioap4hWxqEX6aIuLxHOX8dQZRuaRUTpwgCcWooe96anRnm/EXhyjt4hZoGIUiFDa+UK1qf/j3LF9gSSkIPdQyPMxFDvDucEi9TfRVoXNogbwgBUyQUly4s2Sf9ukAj/Zybrp6G4d/ShklLXSVO7Kk3LbkQt3ZItjPsKmLJpJXThGyXLtZHgbUkbZoDFUot5lijQsE14kF4gI1ZIiWkACM304VWc2kw/l4Ac/yjGLoAUniRWD3TWxmc3aBWIVuROKyNa0pt9l8U3YctdLIvEcSIgxZu4slaTA9wK+qjEL9twB9+BoxjiIz5+Vkg6mokbX4mwKoY9N6EIbCk8oCAFV+8PsIx1pAFhldJJBTakoUbkgw3liWicqqQE/eVIelYyUjfllS5VFydHqhz8JfBZNI+crEzL/FRC67KlPhRtMoprLuGUaZjE7xNSJPBUltYwqVKWazdh9VSuxyGpWpbmIKTwMB7HbkljHStaproRdRPEmFsXZVrcK1ZzWSudclxOzPjHCoJT1KhT0m4IU+KCvawRs9K6wg8Kiop9Ba5pio1ZQUCk0sg+W33C8CoMJMCCzFHVkAF51ASVsFLQf7ShIP5nBEJGYxAsc6Slbi1KPRlC2LIVxBe2VQBP3ahU3sWlEKJS74a7YqPhKqlIb9IkM0tKpFZFukrVA3ak8LCuIMCJWs4sN7mYlvOIVbw/G+8Op6uG86e0dW9nb4w/DJxjvhUUX5TpX6BzvrngcDhmy4gMd+Jev/zQArD29F6hbHBagx1Ewp/roR3c6FsKHbuhko7QC/F04sxeFJIc9zGLRIiikwiqyRkx8YpGadkEqpnSLyVmg2rINcLCEMeVUHS23RcgIzy0hjtOFoeDWOnP9age/gITDGx+OlmtwbrChm+QgVGG6s1PiVXIwhVkYMbvahVIOqAlWLIdXy24RAnkxtk2OgVnM6gWemz5sTm3BN65rti8fI2FQOIuOSw7TAQqk7d88E7hmmOgzKhZBiQQHmqDGKTQjEI0dhxLc4A4lgw5U0OjzNLJrGLaoIqvw2TKH+li02GSJNe3KjacWgQ18T3tF/VpUuvTUMiXtqp/VajG82ggsqP/BLW/p2x3burW47hwNy/1BEIqwqcBWCdCHPXQlM1mIfADHs7O7sO4mG8tdsPaWl7kGMW3UY2EGd7jb62J0xlcmzzkodqDAlGvH2+xCaEHaW/CCHfQ1ejTDxDDyXQlAJ3axf5zagw9uyKVxYQYhsICjMfxwsPFP4lK0eIgxTjcSa5qVnDZtJ0E+ypBrUeQkj+0LU77qk8+rcA5x2+Fe/QHSg/6DG9sYcG19w3x1Lh7KdRsGfy10oNM+6FpwA1Rzr+ToXizby1yLlPgADKVnNXVfDeuWpFp2qYM1Y2To9tWzfty2bnF45i6efMNu8LGTHe0zAP/3TYAC8vdXjm3YJz//y7cZp2UK79oHJCHhmeiHDgfhY68s4Bku+M02PFay+iyP8ijSYjwAGZbVAhxRurwFnI9UO6XO27wIlAVNgqnP47mJcLlbchsvsyneWj1bWy6dcpyfq73a0z0TvL2gQwneMzpqGyJnU7poc5jqqq6oW4IssUGJ0QGpmwsyKCQy8bZwoj6te49x2xDs+yLlEKRRuZQeOrsYCL/wK78plCcwKIRJOJr1E4X2i5/GwrvGeqw4E8MxNDv7qbD947/Bi5XwAECOGrng8aBLO8BL+xXWqrwFHDMCYikzQ4bNo0DOUzV6kRsa87WJyIPFcRsNtDEQ1K2a8i0SWoMQKkEUVIkT/0wJ6do9FsymHay2hlkEKXu240O+ams+p7OYbeqmGsK66SsqPkyQd0FClzC0CIszpdhB8ZNCtTuBXZQ3H5CnQTCwLEya35isLmwwL4yEgRNDL2DGZmTGIFgBM1wkRULDNeQ/SGJDAwBAY6i4jyJAOow8Qew8ULtDa/gJvzDHdMyikknAGJsGU5PACQREefzDGVOtEqMQE6op3lpEmoq900sXPBihR6TEFLTEE8S9TIQqJii6JMA239MStcCK7yKBKMCu4huF7oK3ZFM+qGu+IkAL53siGJEEX7Ch9RpCInSvV4RFL1oFHeqimDDG+oOoJrjFHtjFG4DCnVQ7s2uYSf/JQvLZwsSaSWR0v1mUrPorkqSAih4IAQqIgKikRjW0xv7zGjZMj/9xQ0tqwG+sx3mUqfpok7HMQ9fqw3YsuXeMx68MRGKJQ8+zsV5LxAs5Jn3cR5sCIdQLSEmcRNwrSINMMoVsSIeEyBp8tyfoLjW4yGcrh0mgs2pSohy8SdkxzKcTk1VAL935ncJoRVfsoHdxSZWRSYGjRf1yQlyMRp6MQk7UivHRBmFYPzuBs6I8RvfTu+6zybO7SWmUSoeryt/crO/wHwDqxpGLRwhMtQxZhhU7B3VME+dMjLIcrU+bj2I5zus8Oc2rwIOQtXzUQLwETwgRQb2ExL4cTJW4RKL/Y0hNJMzxgh0cWJ2KXMyl4y6NnAoblEz3dEG44LZTKIp9cQfp0zqV1BVraSEZiUlJCCSvIpKk0BKd3MmdTE0TCL+n2ArYjE1Ao79iJMoODUNbnMy/i0YNeIASRYBG880LI7wV/b8IGM6trDTPzE53NBAaNZnoLMsxM8vaaiBksU5TO0vs7AUZCxzw5MBH4EBHDE9H0Mu8LE/zdC5jO09MVMjee8jZ+S4d/K7uSgHFLD6mm0iwyE/9HKuRtLogC1ABHVAjZMmWnBH4S8paBFEhKDYIndA7hUKsuFAM7Q3LCJg4KziHgqwIe4OHxNMRhcre5JoT3R8EAM7y+JqrdFQX/yUbFzNOB6TRUluIxcDR6kPHT21OsmSTGk3Ls1RLtYwxzfPRF/sb8HRVxRlPHSsy8hTIWoUi89Q9Ke29wBw2JJACX42u9vy9gbGKK7uy1aGzNniFL12EJ6AmK7vBK/FIa2K+B6VMshATggjNZDCTzgm3KepMlYJFGXHJT1DCOG1QB/0+Oz3UCl02IqqjPiVNH2QDhgLUQypKOf0BGBDREBhRDQDYRJWoSSXYSW3URw3OSYWBQHCXDRFAPcRUUy05O+zUUIVOUNXRdHzAZrBO+PhRPuxRS8U8VNIpV03Sks1LWt3LCHkDoLtVKJpSKmDBYF1Ph7RZYaXWssuKZ1UD4v9TOirDgsdUooYh0ysDrxx8Im5jqkiMEckgBm5EU48BqjZ1lpmIv4WSsyCCxq1Vza5lzTOAhMwQysyQzUJCCnodw3v1g3ptNzZAChmAWxGwn4ANWBNV1DUsWElVQ0j7PxXQA1fgRrUZQORsoB/N1HIUVXQ0R4y9WJClUbTkOlKToFLlOoGUhI0JhCPF3BxLWVr1XCjlPZrFxIWs2dK9WZydGNY8TGVLzPnUqidRg1Es0y3BwWi11o4Ui21qWaFDT/FEkYYdqmQgFzYlnqodTdI029ahU67VyeWNQnd1AijYDUoZRuBw27OVU2a0v9LM2iOI2xLYgLotUbu9W7x1VIT/hTj/a9H06APg5UrtFNJUlVhyFMvGrdj7rc6P7UrKjdzQoo9XxcvN9dwBtlWqM8EpBdbQHYMENt3TLcWNpMiGUUwpkzKgrbPKZKJqjTqk5RLc9aHdHV1YG0hu8oheMiXjjYmr1YN0tVbVZF7mQ5jd4A3N8NN5zVq0dcbtTbTuBYLvLYEKwIAJIN8TLd/fPN8UtUpJjYAb+CyHFcC1ZEvqXNUtQlxPZVz8NbMD+dHChSDKfUP30EsOFOBYJWDyfNk14FXeW0FiY+AGduA6zVkdrC6H4YP5jCZw6AoIzmANtl3bxUHa7eNtewMQHl3aeyqmFYmC8KJdiity/Tr5AVE4/w4CLWteSb7JpvBB6cgTP72aG1aK7FXbWvTeERCBUjblIC7ivDVf9NVGSI1U9cXKI2jiHutiKAZLTe3DBBFZ++Vlix3VZNHf/JWPyXtYwX2MMB5jMibguTBgSuS9BXbjNo5mIEiCra3mJloSsCjW2DmYq5iC01m6rcLNQJYdQDbnc7bBo9UmQj5Bvmxmpt1cE9LHG5sM+UphG7YY59Xn3QQi07Qa5xEjYoySIqFXf9YvCROOqlCBp9wAVHboqWSkIzaABnhUiUbfwvs/BmDi4fUxLRJSwp1i/gWmXiZpjZ3YCCLmkfZfUSrjljbjd0ZgXTU2af7VBKbma77pN8bp1P+tih5gEhmgweDz5kmIBWBwttTx6WulmD9m6qb2Y6ae1oEZZDAx4NszCUBoZr2U53tOoUh4SXtW4aSw5GG9GDkD1OKoK89Yn+nwZB9sUOx1xthZaA9oaFRmgAqgRvxR5QLwDoteZSTWrMDOn7sGglmO0SCN4lN74v5dzioG1ZI26eQMWZU2Zq7kCZdeZmbW7M1+Zpku3ZreV2nOaUkmbdQ9TLhdEtrd5jnLDUSYhWgaBRh+t+8CydVx6qa+bbIY06kur9EtCRjRKS97li8ibl3y6uNFXh42Ohy2mnSDmQRzt6cw66WU7quY64d2ALwuX4j2679mZVcWbFexABww7BD/O4b43dRaZuxd5lRfvuLL02VU3dhiNu8BwuyX5uz89uyYFm0kGG2dxun/xpLYyYHvokGgztIkwooz4KdKwGDW/Ap1puTcxu0/tkyYNbaXDW7qaAmnJZd0AnHidg4FRVempCoTp+605fB0u6+ETvGmZE0TuO4KO8O81m6+BmwjRtEc1yz1dQAl2ASo7eiudEvFZi2RZm+88VTIprz5PtwvtuwCLuClxYMz/sv9Ft39FgLQ7u8AH+1K/vIlMnAcCEmqIHOKUXCvulbv7Wl0pt3bfnNyLnMrONs6H4nlGBdT8AU933M+73Ovk0VZRF7J2qYUv17T5IJD12GmUY76Wtvs/0Xx3ITPHSzw624AVMZKC8vG/Olu7950rtlx8IZlVZG0wGUxeIRcJJ/sJKff+n1s6DTvyU7ps4Fv9n5pgbRyXIVmLOdv//b10K5mYPfym/7yMJdj8BLTMZdIBbeSEK3BCof2aI9zGVCLbKWrHCoK8qkGciEfciGXUzgFdwl3lVmFESckOVXxg05bt56sTVE3rB3nfXbeuJ1rRdX073a4gfX0vQ1vzvo/LyCT4lwb6lx1JF9vrnx1BmwxVj9sy9aYh69yXDdgzQY6/kbgtBh2Ybfp0gZzjpdtZE/wYo1zoQ7qBxeraCdnlJ/w6ooYOdMDRtB2X/iFXdj2X6j5X8hzb/8H9xxiGcpQQhInlXQX+lBm24FyrEOX9Hm/06cMWIi+96f/bn1fQ4rmcb61qAsgG0p78kwt+Hdc+AaSTihXb1cc8sS7D86ucoiHaYTMcouXaY4XdmLv+NDm17jXsptEizFHCwRfdpDnyHLu6Q6mcDd/nbOYc6ToA1PYhWvA0F3Q8/LJc5zHExDXPkEHeprcXszfuw11n+qIbmyDUBcQ/VKGAX+l6w1ogAagxoNNQx5H32rsd1ZRJDaghKAyl1A7+IPv+oZfclpv+JPueoVXG/2eeOJ3e14H8Dr9ddKee7qXewvPZtr+6QK/XZGXXTlXC5WH89t1ytRmeTpH/JkXf/H/HwVm2Pby//Yc2gT1nyvLH7jImj8P3VDimH+B4drRL2UKOGWGxm6AMFBAwMCCBAgeTHhgIUOFAh9GMOAA4sMCEy1irOgQIUeFFOS4UhZtJMmS05qhPLlsJbKULVnCREZr5jSaKovhPJbTGk+XMHsCDarSJ9GXRmMiJWpyKFOlLcd8iQpV6potUrVgzap1axWtSKAy6So2CdmyQcyeTat2LVsYN94CiRsj7hEcdp88wVHkLo4nRfzmqJsjMN7CRWT4PbJEMWMljHvgrWt3MuXKi/lazixjc97GVsqwYbRrV7VdzEozGzWKmS9fpl6bclVqU6TatjMxYtRnN289vnf7/wkufDhx4XuO/2YjRzlzL0JcrIDuQoSG6dQ9XNegvQEGBt47gt84oOF48hopnje/MbxDEX2UGZO2dD5TmitpJT1Jc3/O/imF+rRNOAMC6JSBRy2DH4L+/deUMw9CGKFPV1HIlYVeYThWWBui1eEPSLQV4lxwkSgXXZMh1lddKeYVmAxHvAhYi321GFljkHmW42Uqarajj5T5lWKOUe1hymij/ZIkM7+MYgozsJ0SG224UUlIJJL0lmVxW/Kx5XFnLNecF2w4d4N0K2RAnXVraqfBA9xNFAB7BtGpHgHp4VmenunN6ZADNzASn3wC0leUfQjWNJOiCvbH4DTn8ESgg/8FHlgpS4wi5WiDm1Y6VYUXXghihhyS6qGIIH5YoqqpuqUqZS8KqVdiQpJAwl579fVXZ5DZeGNmkv1YmbDDyppYD2V14RhoogmD5GpNmsIItK5Asslst91mpZa8FZdbl99y+aWYY5YJg3TnThedCiFEp90GDfA5Z0d72pnnnQfMS16fCEXgRCSCFkooUZhmuuiijTpKqKScTtqwpS8RzKBOAT/8qYVHhKqFFKOK2rGpZK0aMg8kujByyG+dIISrx6qlMss6vAzzjYV5tuvMwNp1WI8x8zzZrnYlyxgZekCyiyiQCBcJJUufUi22tVlpWxxxdEJ1HF4cEkfWU/dByNT/VoLtNXG7hUmu2U2g7bJb6rLddrshSNCA3AJd9JCcBeXrEHr16s33eh094EVI0FDsYIKaGiyLogj/pJLClBroMMM35beg5BVriCzGoPKwMcceg/7xyayqTbLJKEt38ss99yBz6zIT9rrQOv6I84w4s84yYrBm9leyoDl9nB9Kv+Y01FbiBnbVVndyyNZZN5/812FTv5z1V7xxtnOOlT5Xyq2O6P0KJqhLwgjbyd1A3QPdXaf7CNjb9/sJ7XtA4IMX3pTEKc2Uiir+L64YlJMJSxwHuco17mGWkxhOLmeSBWpOQ8nyihC0UkGNeS50GjzVWkwmhQ6qLoS5S8sIWZYX/8T0KjC0e8yLcsa7nbEsB3uxGdBqKLQ92KZaOqTE8cJmNahRrWqdkIPWDrGcrBFCDplQYvXEthvsaW9Maeuey6hoIhSQDwe12qL5zJc+9fVpfvI7T/04MqcLvAF/ChtUoXASMTf+738Rawp+mrIwwyEKj3hkYKbyqED/SHAsQcvKBbGSQY19boMcHN3pVNXIR66sZVXMXQt5xLPFYDKTNKsR7kpILMrUTDk7jBIPoQa9OFxheVGLxNTooDVUTk2VPyTiK4l4vShK0QkV5N4ke9nJwQAzmMHcopvsVkY60etvezomQdyjRklx444+CSCjaOE/ADawUpg6YDYdWJQ+Lv9QUwX0IwRLFciMJVKRphIhO8HHTk9+ki8r1NFfcAWjTuLzdYCxoQ1tRIZ/Dg9K1RLbG7L2hiBOT2xcI6IRuZaJr8lha8t5wxWggEsh5FKXyuLeRmG3hMKAFKQ5gMIUSooFk5Z0MF78Dp3COAB5uY9+ME3IBTIhksex8XH8o+Z+DDYxPAYwgZbyZjj5aFSh/vGcn7ugOg3ZVCsuEi4eTN333vlJX57IdjdznWI2qSIZwnB1nHmhsHTWVeUElJS56drVKApFJUpPiF1r6FyT6LWIujWKGB2pDsbUVycANrCCtShgCRtSvBgWsVNQA2MZewY1lBQKOTBfMfEWHpjO1Iz/mg2PC2x600jl9IHVTFxQtVlagX1zJUTVX1FZS84/vqRDSv3KBin41KiKbFXQMdNbduvO8IVVkqxT4VbnScN8zgCelTlMZxYDUD8wDWrBwSsUvcC1sB2CohE9YtkKWtHskWukfsWoc8yW2MMqlgv/XC+Z1ptelEahsZBFqQ8mu504YTa/l91vRzr7WQKFtj6kxc8c9+jTR9FHnKuF7WtV2+Bu5gRZ5nQqbQtJ4QvfFoSQtKrpwvfbSCo3d5057MxihVyewcpFkvGZXloIUrQO1DjXAy94sddKXI53klrIsXj9al71KoekzSGTRYkMpjMA9AyRncJ7UarkxiqZyXip/1UIwGjZzTJTppkVwiZE4mXQSpNyvTiqAhU1uQEiMLVDNfCDycmgDD81kBlmJAdL1mGRRWdEwcWqiDVp3Hh+8kUyBGtZE9Pc53pLxmXDcY4viFWZpY3RZjsypZlT6UtHOcqG9YFJM91YPpxUssBEQQYi0tIsnxrL4GGAFk7h5QDrFM3B+ClSJQQUONpRQhPL4xvTzOA61kRyCl4JnDWYTnUGYcN2vrMjq7o237oF2sDdM6Av2SvB/PW41e5BilJcbc+Q4QzFWbSkefnoKvqgvD8e03ePbGk4wDve18O0u9+b7ic4+cmODXVk63uCFTwAfjEdeKr5S6cg/OvVsL61r//PrFM3OlzNYj5txBUYbFnvurVN3bhsOc6WZXP4ztL+cHJLTm1Aa5JXmfSV7LY9AxnlLOZAot0/wTTdcZ1NZY0+9y4r+ON3W0/e0x03pYMurnpresn4zvdj5QvZ+g4GZhQwNcEzokxVG4QBNvgXwAa18GzUuuIMJ6AB55OfAY952AtWe2tj4nGmfizucqczbpn92zxPO8R6z+dH9x5DQZt4uTM/gnvJdGTDemGwPO/lSJdj3akJPfLhmjzRL630y+d7sW1ABCJSqoP6SvbfVe7O+lhqev3S6QJyuAXruy6fb3x9wW3s5mr7h80Cr5nN92k7ogRYDLa8PfjrHDlvi0//d5E/G+/KdznPot7y52v1xIBGjIt2B08/v1iy2f4oYVVW1UmWqQUnsG7SCCGI83M+/ZwXOriGLojJw3u6lmfy5ZcuZKXH+/xtiHdFhVyYHISAm5zewJWRd9hAkcRHNSggNTCgNzQg4TxDBJqDBFIghGScrYGZ7N2HNV2T4mhgxZHZHoFTiBRbCWqYOxEf6YzO8imfCphLyeVd65jcDDLfJUnfiq2ODLoQ9dUg95HYDIyPFq1LcsHM26xAYKnJCYjABVCADlxBHHBeJQyCFE4hFWICFaJfFubfXamB+/nB+0Xe/FmU/9nf/ZmhSWkhvGEeXqjABliAd9DNAFYdRjCA/wVsABLQQR+4gqsZwwI+IDQwIDNQYDRBIAYaojTRWq7ZXgeOGYKhljc9nMQlCtnxXmwtEuikigmKCLSNDMixyoYhX/IN4Vy4oNvQ4Cl+G9+Z297tTvX1oEjRyBNg0VwUYRCiCdv81dQx4S5GQAboABxQAiagwiwQIyoYozFeYRUOAiJUwtKAIby9Hxc6EXGIYRmml72dYUVBIySc3+GVlKbhQABOQASQY+kRHBx6xxvaYclghfPMRmv84QPGY8TFGiRakyV4Qj6mQjZBk8WBYLD1HsaFEwl6DPBJlSaSTgqSHJ2JYgvGwCg6pC2iYg/eYA3aE6G9Ihuyy+fVYtSRD/8FVEfKyEyp8aIDmCQ5esAJYMEwDkNLFuMkwOQkNONMOqP5tYFCeU038gFjDYe4FZ02OtkY0h82niFJwUEWdom+HR4bekA5NkTWQWU61qEdUiUIsIAN8EBXlEEgYMkqlIItgOUzrIM8JkNZmuUhhpmw5aMjYJMj1qMkit2l4N407dFZfBAHoconImQoLqSJqGAotlgpCuZgussGsIsLfhIJUKTf1eBE2mBhNOWfnJAJACCavEk5HuFI6mI5RsRJgiQUqEEhEKNLzkJMyuQi0CRSRuNRJs11QZ68XQ9QFmX/LZmRCZltml/6JeVR8t8/qUxkVgQ60iEcVkA6VuVVigD/chbBhqxBIABCIDzCIXyCV9ZCWFZghExgdsZaI2Yg4fSC4oRCW2YDpBBiJDZc4VRiAkXMJRpkJu7lJ3pYX37YfMLKZiAmYa5LAGpAd0yAYapAFimmFjGm7gTL3qlYDqZiym1AHYYkgIbAODKhBlAmEAZhU14mZzJEL6LAFQzCJMxCLMTCSx4jKmChbqKf+eEkF/Jmps0b0skmi97mFSyHGW5j+7EmqIHjfjolOvKocVJlf6pJcmLlcjLnGhjpHeDBc0LnJUwndUagIEIpAwJYdm7K60XDrKWdLmhp44xneRIiONXaA4EppsxlAWGie7YnmnrIVP1lm7bTCkYkfh6m/zhiAOkV5zrKgAlwm2IGaF+4TmNmxoEC6slxZDgeIRRsBnbkABYAoLuopCBMgaOmDBbp4oU6wGW+yYYuwmjCZGkiI01KITee6PtNzU2GYW/KKIyK4f3NaKq6G6XFX6x+i0+q4ZRFZo9KpUlCqGEG6ZASqecAa1UcKZISa1c6qSA64Fg6YCE+KbNiaXVuaQFh53ZeynmKKaLMUbYSEC0cX5vOnZrWXbfSZ54a6mDm5/nQKYS+IXEC6X32KVkplwoN6rwiqEgxJXekpOf9WwagCWdSwAlg0QlkQAZAQKUabAIkQAa8wCDMwiu8Qml6KkyCaqien9ispqzCphy4qsa+6P/GBlmLBl382dLQeSH7gRoUOMaDruud6uqP8mqvboavMoHnCCtUHOmwJmnOSkKT2sJ1MuuXXemzaqkucCmzfimYFu3sKRiBxQTTWqKbwsVdgitduKfUQu3Vyqdf0ieVySl2uGGd7miPKupd1AoOVhtgwCu9LqYmPcG68CecNMD4oEDUDezB5oDADmzeugmmImzfPkAGpEAcbCqnfqrEluioKtSphqwYguzIyirlPa7JziqTAaEdtqzLeq2a2GfMwkoGzawUBGuF4GySRud08iwxnGXqgiW0dtMgaqcEWqshphbTbtOYLgPWjs63Ti3uam3WomC5du3XqqtJfkdHMOj/f+oFvQqJvAaq2p4tzZzrYcIMv84tp5GahEpoG1wBwV5m3nov375JwkrAC7SBh0YsMhouxerfTe5kcLxmxoLsFRjR4p7quO0BxmLs/UKjjU4XGUid8O7idcDsD2yGmoLuAR8GkVIIzjLwkpauV8KjIK7u6qauN5yDBVNDdkIpBl7gP0KMQE6iUTCKuBLk1N6l1fJu7+ZdfLJw8Aqvvwqn8frnYqqQtzmv88Iit0kvmrSJCSjZZAEh+tSNwqZAwEoA94ZvEhOspn6oiB5jMqpvxVqs4kZeqb5v5BJdT2LxqXahcIALmfzmdTBhkIqADbigzI5MqSSwzH4KHghrGdws/1S4wZGWLpNS5x1b5yAyAwYL4uuOpz9606FYDqaQ8O6iKQoXZAqrMAsbH/JubvR6LdjCMK4aRATMsGOimJ8m7w3jMGIhma2S45tMnXbc4oaGXqll6AOQT97iLfj67ThqQA6oQROH6IieZhST6hXLG0SlaEL5MuRmsaJxCSOMKhyAsbmQsea2CiTl5RpjZRlvxqfAcc1ehZFqwRwf6VYqqR1XZ7OSZZReZ4P98QKV1rYWGIFdLVRdIiIvciEzZBaZa34CMIRiaNimB5D+1stpcq5wMojpIIk8L2HdxQ9XWQNI6KL6gAkcNBYMAhboqANowGL5QMEWLAq8QEIjsQJQtP9T/q0PlO9LDkIhpK+JJu4v93KKNtE0ArMfiJsWD/P5xZgTkYm58Oozc24CG/LmlsBNK/AELXAcAzXOPgIo2PEnROCDgDM4UynqNpxOhOA5ux1DgmKJNLNdVnU7vymcsiAkv0tXPwA9gzXx5qrp9acjbxtGKi8mAzSCys4TzDQGqEBLy2KbyDIWXK+b6ACkUmoIYBESI8BB9zUEZLQr+yKHjmbhoqYV8pDX9FDFbkI0boJJo7RKrzTllR/1II35iaoxW8GKcK5NozFa6HQJkPYG7LTmIss0q3ZQs7Ycj8Ed1HEeowM6XMNsbzDsNjXbzW5/TLXK5LQhq81VY7U7exj/+TzyuQrv1341PYu1VOKrU1rEBIxADLJYdfezPwc0kqGrCxbGKtetpQoTAPorAvwt937vKydx3wLuR9fyp1YCFCNC2EQhSUuxxVIPSld2fmN2JMC0DqWfbvgvAYO2zILMcSP3B2DAByi4VULzD1gFHD/4arf26L42sS6p6WI46nZpzzJ16macbtPlgoSQIgO3cA83cZOiC3f1isMwR6OkQWMHORaErk73ZARorFi3Wuv4gHKbJ8eiFpHAlN1tYYLkEd7t+HAao1L0wFovEg+swLpyev+rR5uvMCT2e1+hM0bhe1PCIEQ2qUpNQtU3ZRPHaur3fju20uyQf3fJHpBB/xUk6hkXMHzG+RKWNtgiOIM3+OZcBYS3cYXnrDWPgRgQ+qDLMR4MdYbfdgd/+FHUHm+jOHuaeKRrtXGbD1eb9nOH9ab7a2Gu60CYJHYgJmW8qyXt+Kmz9VrrTix+sl1sNw6oQecF8UFDFsCRMha0QQ6w8txybwIMQAKkAA309WAjbCijpAmowTAqezLCdxVmeXyPuZpH+32/NHEkWplTe32v+baLqikgjR6UARDI+TLL+fmIsWnXaZ1WgAWAwHEiZwQpFVUkaVC7NqAH+lBDK4SApVM3+qx58DdROl5a9aSfeFZTKPCeK77OsyQzvGdyJkp29adHt6jbuIoNWiXx+P91ezKdWqgHBDnU7bVCW2osJ/Sw963Aie8RHzEHxE2xRzkEXEEUdKhLQnEhME2zQzvnoai28zxkI+61f2Fmb/a1h420c/u2e7sOeTtLa9gznzu6I3i6qzuDkzaDLzO8WwhQu7GhLyc2DzqxFmsoTOcE53vsttkx9DaJAx+yBbxuGfhhJjeLGyynw/Cuxvj61ClECou2/TOq06uMRMbowfh/rnL1ivzDh692SMDcXnTLk7cCHHEHqPzkF+xDnHzAAW6SMyzNX2HnU+FjP7bO//zop7kUD9TpjzkfCP20G33rH321CBQrgXFy3vnTJ/jUl8AF5H67776eIydWWnXWW3P/klZzvRv/oTtCok+nhh+1h8uuAqV9uK697qp9m1p618K9p889w9M9xPPq1GXd4NtFn26y35v/88biCeWnD6tBycstaKqBDuiidiA0wQ7shtr1EYsvqV0+QHB48SIFCggIHqDAkuJBwwwofFzBEgcRpmEXUWHSOKjQpk2FBiES6RERIUGCIo2EVNIkpJQnUa5syQgSHz4ycd6MuRMnzpcrga40hdPUUKFFgfpho0TGBqdPMZSI6tQCiKlVsWYtYVVE1648fgRR0uTLmCpl0eJRu+bOHbNv4bpZ29btmDuBQn2qRYyvL2Z9+SYLHO1ZYcKGmyVetphxscUwwkKOAYTy/43Il4Nktqy5cmckSUCHFn0kiQzQpj1Lnrw5NevVJmSYVjGbNm2oITY0mECB9+6rGHRH1R3B927ix4UzUF5AQAEHDUKsgNwDR/Uc1Wdkp66de3fv2L+HBz8exxPzT3CQwBE9B4kMGuATNxGlzcL38H34MAihIQIUNF44QQIJ+EtggAMNRIgDEl4A0D0JACzQwIQigkIHHwQZBhxthsmoEo5ApERElYLyqSWegjqxxBVdYtHFF5HSaSikICkqxjPQU8GDHX/r0amtqgJSqhK8KvKHsc5KsoyyyphrjbjsssvJKKV8xJFH8lrFli0HE+yvLxFzRkzFyGRMNczQTDOs0f8oY0I0N9lcD7vW1KxztdhqyzM6p6ILrrg//RSut+Ic8DE55pwr1AMVTBDP0Ue3i5S8ScFbwtLzcDyPBB2PQ+AA4uAzIYf8THivAYR0m3DADCQoCIUOGPJUgVlbhaBVEnBVoYFdUz3gwAcyeOCADOLQSMOLJtFoo0pGVMnZF6GNVloXjQLKqGpXFNEUZhGBYynYBoVqKyKpsqDIc1kAgQWvLkuSySXVYvItPOz6Ykon63KjSrwk0RIwv/x6JuAwBWtMsDPtTDi1N+GMc847FXZtBkbxrFjPPUd4KuM/gRMUqkB9Uw4DRT12QLnmEl00BhPUEw8FSCmVFGbSLC3PPBz/SRj1jDNM4BVYH6LIgVWW84OCIJ8hSGEggx56AYw2CFxgVg5oiIIDBRRMIYoXCJTQVwQbouCEiAZBZZhXhhEmI5A44jakEeEmcVqg5J57xBqxPcrGva0VcVlRuFVKBx0X7WqqIi/g81yq1F2X3dja7CKteOX9oggn6ZWyLSmhfPJJQC7BkhG9SnHlX4KRKZgvhOmM2LOG4ywNNYhdl7hiOS/GWPFdnwJZXEMJJbnk5ZhTNLpGZ05e+ZifmGKK9UIgwab2Qp0i6FL50wCFNhaJAoUBbfUBwK4PhJAGDsBP+upZUX1BDYIKIlBWWYVNYHssJhokFnCQVZbZD90GNwEO/5CABYQRjQwIif8BbhSimFEDR6FACFbCf4OoREYqAocV4GYDe3LB4r5COB6NsIM2MOEJI1e5J1VucprTHL1g6LnOyZAOh7iEJPrlr4F1iRis82HrFsYwIQLxh0WMDWz0BC7dZWwETBSX734HFUEhBzlO2ZXJEJWyFSCPi0JYXszAOJ4lkKd5TxjBqXCwkFExTUIJAtYJTqC0FKxKfgmw4wDshz4OdIB8qNrVrAqUAhqA4QVtTECw8Ng0g6AgWcfqXwUX+D+PYOIUcAMcBSnoIVJIckQeEqAodrELS4YSFaUEnFBAKcpLXrCBmCTFK0GZSVNSEA7Pw410bjA4HrkABv9dYUp0jtDLEVZHRybsQRmCYEwmkGFJ9mImHvbACEbogUlziaG9sNm5JMVFClSqYSBsqKXScckVRqRdEV83xDcR0XbnpF3uMNbEDnbQiVEEno+ENzKPWTECxGtOBDSwRYF+MYwFJaN1zLMePo2qaNTrjx1ZBb5WLQ18CAGkBghEIIHQgAZd49Uej6YABi3IoygwiBvrl4I4xAEMF7lIIjaJCQsWYlkErOArQ6k2YeyUk5QQBjk2OUphwC2nRRWFBEspSlWmspU4TeokSgnVZHVLJCjoDRQQcQPDOYENIliBUhbFhzOIMAQ26aUJyWCKrhpzmu7SA41MwYjMzZWuK6T/nBa2mdfP4LWbYvCrWb4JTsGak51AhF3sCuvO1+DOYk10bDwzBh2NSZGylQUeFTnWG5OhzHgDJajMYja7MF6qOriCQxuuo7VB+IA/gVwp0wa0vZB4dFbuYwitOhCF87VWfbByowIGeQUJxNGjiLQoRCYChkK4tEN/cyUlKQFdvzmVkrDk6XR/qsrpkmMWlSwKKoYa3VGoDRLjPSVTSbFTVIh3Fultr1QxeAU4VsSqhToDKrq6IzZocAWIeAIGVBBBDm4gBqIgxQe96odd+AFyTKDEHhrGCF9QEw+MMAUM56pCFlZOr3z1sAzhgpbbKbadl3lY5EJTBMSWmMXvhCdk/8/IRMmS0LI1vidmOxauLBpAUZ7tImc+a1AxNo9nohLaHzFEEAHd6nsPtV99CJI+kvK2ARzQLUVPNT9PIaBVcBykGVjrZIsmzbYtiIOGXsE//1FSI5X0X3R3eotIUrC92G3veVMZXjhrVxTXWC94FzhLUipLp7MYhBpqeQY1aMBkGoDDIHRwAeJAgRSCINx+mygIMgC4gTHwCg6OuoLEwcAPlIgEELwqA7XCqQzStNwX0voIFWdzXm/ZMIc/jFdd73qvcCFsYtOpzhQDG525gx4Tke1YxdGY2fsM12WTU0XN7rjHPt5MkDujPE1pIFVZ1oB+4ldRiNqRt6xCXx0B+f/HBsRWkPCTH9jIfUgU7GAHc2RfvMEmNWLRVENqfnObtUWJWwxDzsZ66iwpAd7rasuoe75kKi9oaOw6tb2IEMYtBFGsNpwgbIxmzgmuoAYoJG4CWBXEEbqys+hAYuQyoGAPvPIEBWpVBEIgRB8gIbsfqBU1SbDwu/ZAYXnV+tYdBg2sZ83rhr3FTSMmsZ3mJOzDErvYjH0xdOq5I/gYztlQhHbYMNspsGPxn/KhGLZn1rJJnQd6U8QoRAgyEPlCdGg7IGSwmJwC36ZbAh3Yrfrs3oF7D559w4UVHBuCx3iTe1VjW+6GhNFmZZ1CWbeIvEaEgZHm1rkShYYlndWLyVn/XD7if+YzeA9eCIpgQkA6EHk/nVM8LECB9mGTeS11xIY9ZLrlH7KCVxSd8654gRBNYLkJHawH1FyurUXXsPPZZLmkK93Dw/41EKsj9ejrHMibwWWJkfjix44/N1lvto1z7HZ9Bs84jR77ZotXKGsLmf4FtdTOckC4b0+hPfn5Xque5qRmRbbCbEJQIAzQQA1IQN0gJAy45qKc5gEHT2ribQEmio+IC46Chdy27AFyYKUwQRs2pBtiSvIsb5MADRMyTyO0wfQGDZYULvQ6T21eafQywgZLsOIW7Gku4ATiIAMkDQriQAewCItQywTagNE8QAiFcGJUTgWODwdqYqzC/+oMsqqJ2CDnIGH3VCAJju8zVGwP1Epyps/WoO/V3IUM0WL7jM7pnu7ptE/Yuq/FFquxxA/Gtu780O/G2K9TnsP9HkDSiEc5Aur70K4ODepmoGBTGJH/HmIDHYKlXoCPIHHx7IhB4Icg0o3bDIB9EKBBlgYCKNASGa8F7O4HR/GOOLAFWiAQz4xDSHDNbqHg3ksFL8/PHE4G1Qv19gy8uOvPcLASTgK/dAARWDEOeCMOOA6PMEQDECUANABqHmDjJo3BVA7TVECsCEys+CA2noAbkykbLU0OLM00ttBiqsDCIGwN8+oM2bEdJUcN2/AsZuP6sC+YUCwO59CL2uns/P8xT2Qjd7BOnvJQD/fQUHzHD4/DZKRtEOWj/rwDEbGjC9dDtMQoU3bGPbrNyV6lBeSoBYyrAheEP0iganYLadjHVlZlykixAl9gB4aL4xbvAMitN4SgImax4BgobajLFjGBF1XwBjmPp9JrvWbwJ2ehBZ+qDeLAB1YgBwQhWKCA45RxGk/gUw7EB5ARUebjVIKmGrfRBOQADrzqwZaQD77RjBRN5qCnJmQgmkqjC3juNEKj1NYR14zu6ORRHsswSYQoSd6QDsMi6vRxxWoHNerxDuMJOmasIA8ys5xtitpP0gSxMncjPsjOOaKCUX4MjmAGZjZFjMqD/1QACoSxPWT/kjhqMo6Wxn02Lt4k4AXCwHsAiUGiIAzCIAcKZPDwyAI7ANwqkQMPaaV2IEACZAMpE45CjiKmqwRxKvJO0OBAr/TcK6aIcvToLKpGbxIy7tBEzVeKUSqvEiIk4AcPBGXc5wECgAAiAgEEwHnA8qtcj7+08Rt74BpxhA/kRKxkgAwYoQtkYAlEQfkaTMV8bkD1qi/3Ei/98h3zkh7dkOqyL9imTg4F0+oUs0/Gz/yerUMhkw8nUyEZUtpgj7N443i4wzM/kzaOjbEOqoxyYC0f7QpcSxnhbsk4oA0ICXvIzN7SjQQWwRA6qmvIzQItEEKa0gfoyMnsSDk5rjzjQL5a/0ArUUIjnBPgXsny3uvyFI66iir0qrNLJ2H03gYTsIA3pqANShQFBoECEkC4BOABrkArJaA57HQafYAA3vNMNSBNGU0Io2NnyLEKR8A+hVAG0JItRSCt2IAMFI0NTGMul89AXa0vpy4eHxRAk45mSAMeJSdCiQ0Mh61CSdX6WMxFA5JiXoyeyM8xH/NVP7T9FLLjnMKfOmugWNFRDHFiJrJXRcuMbAZnmnAi/g9JV6WNJAAMsADL6IfvSABWJpElx81+BiI/lrUDBATf4C0DdoBtQGLNZPG5qjM6X5AGQ8kGsVPhkioWQmK9cgCOUIsAEMBPvwYqPeUH11NrkhCPDv9kPU0AEbyyW/InBCLgG3FDB/wg43gvBNgyLbtR5tRywWxiFBisC86x53SOUTd1YzMVU89CQRu0U03VHg2rVOPSQA1TMO0QDze0VeMDViOTsrxuAgqlZhVyN4JDCRmAsypgAo5nV7mDIt1QaGcjNIkJO5bANGBU5EIlRucoOBXvkAxvILomfWiFSPtuEq128UBOWQtiTgXEM4+RIkBiFsG18iaPgQ7OqEzp4KBqFNTVBrkFFZ7HO4Ul5PpJK9cUYAu2TgVAAkQiA+bVb+N0EAgEEQjWAP41BxzAYMOKYldurOxTHB/2Cs1qPWyCNBBUxYpAmpKOYjc26VD2CQDUQeP/MXTVkHQ5ddZANTBZp+lE1WRTtvtUbGXDr2U3FOtsjHeeqHf5yU9mlmPCjmZ9AzMzkwHM5We/z8fUQwaMNlc400XlBKG2TUd4BwsGQY1aMTgPaUFMyn3ORwIoEN3o7lXOjfEQyVYMYgB8sCO+dVnM9mwpj4Hot35fEPNgUG3hdn9jQapwhFEQIQXm9UwdgAC2JwMEwAedsTns1QCwwAT0FAHUYBEkAAAa5E7BIGkA1gA6kWmnoBv1C3IRVXKv0ApJOJgudgSsMJgYgQyWbw9GQfq+wHM5Vw1ZV1NHFwc4tnQ31YV7uAhcmFdxqXXhUHZjd3bBryIzFHeV7YmC17Ke/xhEhxdnJ8tWAWygOBOLjTZ6YQN3pndS1MM8NoU2duUD60O5lDR7QBICpnR7H6Jq+MhWAIl8/+N8SGpoPOqNfICm3lcjlKGP0ZbNPi+oxIuCcurzmpOV9ncRBMGCZi8HRiZOZ88Dr8BTJBkF4rQ+uE16cqA5OioAACAADrCCMwAMbos+/EMNRKYB1IAPGuBQVUaEF4GEc2+WR0AK0SMKS1MUyOAIbIKZgJlimSmaerlTdXhCk5Z0DdQ0PhUHmrkImPmGJUd1Uxeaifia2+WwSBV1YVdhxniJW5YxB4zGoth3pSghp3h4QcV442+dNyiLcWmMGTExiYkiv9giR4XItP+xaeUuQJbMB9DHkAxAAq5M72hLASJqe+4uIna0VWIUBL+14Pj4bLFUvD5vfu03lH7hSp1qEWYTCn42Pjh4oAWXVc7zbxH4b/EH0QikObgtlAEgAQqpOUhAuTTZAEalE3WDBCSXCrEQWP93cqESqMsDLWdHcOySD+KqCKLJJqSpU0WLc6XamDXVmZ15h4F4dDcWWJeXZNWkMC20NSqyRcF5QydLD2eWd2FWMtcv7Eg0N+BPZHjjneFZVYv2sWAj/NKDeZ7g0fwLNxrABKbApMaGVNrIIRxiJX/zWBcPWIQFArBgEg5NJMpGqm6qbD+iuibJSr1rkDE6o9s2lGQK0Rz/aqRhz59O+qTXU09RZqTXE5SbA6ZbW15tJcv6qds2s3AAsh7H+otPzEXx0ap72RvZzoys+QmW2UCR25m7wKrJcHT5cqqT+9Uay4citEC3uZuNeB8tkqwz9JsJdolGiIPIOzc+Boorq5zb2q0hM64BqhBxlWLmuTa6uJ5Fi4vymQ9CAg6eYFMwitt+JkldJaLKLaHdjUmBRSEqO6qSRRbN9o/jN7MD2bMpvG0RmRKitL7gT145eLafUQBkG7ZDXMRJ3E7/icO3jMeuKLdZdWWPLU9aVIl/OzGxGx8rZpmRWaqX+Zk39XSxW8etmcaH9vq2e7tVtqyZeLzF+2M25jZm/8yK1rq93TohHfKW3iOvb7eJGuWuRyA0/ZE7MKUi4BYRSFOkfTA/dHQ/gKVVGFslVWohCDvkGhm+rDRZZimmJrrOMeEWXOEW3Cx/6RfQEU5wTgAzfWXHED3RQbzEYXvRG714POVmpU3JW7yJVpaeK3LLj3l2MJ3TpxpyrKO7j/m5kbm5oTuYgvzGdbzTu/qai9zIW4e3Lx3Jz0+8daPJl42eHhOd0e+tSei04y8PrfybwSXLu9yLRZP2jpKRo9Qp17ywSSVbH7E/avshygZEKlsj6Bx/9ZzPZ/GPN6HgPiJ+Z/HPBX2W/GAKvEAIDP3QFd3EP9zRGf21PVw5RtTXl//tlphYyOnZrpGd1UlMh7Na1FVsQgs++2r31BHemhm+4YVYNVpd1ivyZGtcm8F6DkEdMWeDSGi9iW5dd3ZH1+dJ3zHmyX89ZvkQZG722Y7XeISd5OmaRbv47Ibs0UZhESbIv+Jje5oyjgjbVCRNfSWiWHpywu2co2Oq4OL3bPP3qTZpv/VjR4ow3uG96uf96jnLIVc5VvN93x3rxfn9H6c34133t5FZh3nc1KW7LCBH1ds+1Yf4TiQ+qj39iC0e1sXavr1+71t25HU7vB2LMVn145c8yqVYVgElM8tu6xh/g7ZceXnb7KmjefgAgjJiqs5AB7bXI7kNo16LFbWyWJb/haIBPZOOHm11Mn+t1LrWFsNJ8wLcPfZ3zOrlHesfPevt3WZBlFU5nu97u4lObIuPNmjrMOHp/ph/u7kFHvlrWO1X3e0t5rrnftOX3+4/lpvV6Yaz7Z47ft9v45YGn+9J3iADZTjMm7LeGvFVsz8267UJsfHjydi5f7Hur7ySCpTi610H5SE0DiAGCcR0C5PBg6QSKkxocGFDhAZvFXyI6VTBW6gcjqqESFCbKzoyRChwoICAASdLnlzJkiWAADBjypRpsmVJBg4i5NyJoafPnxs8BB0adITRoyqS4kjKVEZTEziWNpUR1akJp1RnKF0Ro6vXIlGfRB1LFkcRsFXH/57F0SVtkS5wzZ7FSpeujbp481LNK5eJDL9//TIZXIVwksKGDyteDKSx4690m0pGirToiAYjiGoOwdkDZ8whQHemXLmz0BCbNatePaG1Ttc8X8t+QIF2zZgGGmDWoAFq79EkODM16pWr1x5OlpwRtSujQ0qUCHk5ccJLHEIQGWbXLmp79+8aGU4M7zw6nzNTcuhY8eC2zZY0Z8pPeZukfQb3K8h2DZT1acukkVaXClIRuFSBBqql1YKQ3WAWWXvt9aCCFPY1VxdvzRWYXnpJVdeBEYboIRIXDpYhYoVh+MWJSbyFIYtuFSfXZDRWJpplqRUlWmmj9Yjjf/7xJ+SQrv/p51NsOCGp20gunYQTb1AKF0JwnF3FlJXGBTGDEE044QcpzTn3HHTZZbdJmZSUSR53BA2jkJikcOQHFGI9YedVOtkH357z9UmffQYkKaiR+/VnKFEieKZogDVKdWBVTTlqYFYi9vDYjEdU+iBaUbUl14RwvajhqByG6BSIdKGKqomsMobiYiuKeoRiG7YIw6161TicUTtmhtqPRPlqFI7C9ngUsEESqex+Of2Uk3477bRkToHW92SU2Bp7JVTH6eCtIKiEuctFaxJE0HgGnendQ+GxydAs5UHihxxssLEEU+qph0GgfMYn00t+AlpttAQ/awGhFhia8KFAAsiorqf/BkfpqalS/JiERTxBqcabPvhiVWupGNcXFpZqsqoxpmphqyy/yliGIWc6a6WR6Vqaar8mO6yxxO6MWs5CJdsaa8sOWTBOgTKbp3sFRECbotia8JtxWd5AHZc6QEFJc80lRO7XFI2HLni3WNRuubM0JMgZTjh4q7c42PlECks5wG+TAOetN24wCTxw0rFh0KzgyuoMZKIlOExZzZNCmpfEKV+a1owicuoWWCW2RXJca5lcqq0Wh75qYK66LHKLM6ee+sQNYvUwj8UGu0EDOIOm+M/BAi100bwXuvBrSAOu07Q7MY3TbtmGkIGUVGepAxd7MNe1QxJ9fYsyEblbydjl/zrnnEEerafB0CMgl4PcdKowu3vy7e0vfcEPqvShQyYeJOKHH/u6gBGLzvqjl8pB5/xXllmxBWZsCZUCOUcqk5FoL6DznFNe1jIKikpjZ/nYzEJHIJu9bjOZQdbtjkI7XxluKLTbXX9kEzjBMYBwRxtYAwwguBkWDz99O97TksebKnGrW1D4Etd+sRCvYYR65iIXd6pHtjfFa23omUFt7JaTEGRNPVhqTaD8xEUDBKBaAhOU/BBGP0OFEGf5S9T+GBepxk0uQQBUC6dGVSG0aC5kLtochjRGhrdgcEN/4ZBgAIkVwGCMVBmsIKwWY6dEtiVDCTxkBye5RtgpboSWPP/jCYm2wk7qx0hHYmHBXCg/GtoQP9ZyGgWy1cNt/fB5bNja9IhoxOYw0XrUK6LZjvjEKGKNAoPrDQrUgxomnYSLAUOlGJPUk1ESjHDQrMAny1gUEC6qkkjp0FZUFiGQdfONECpgHPMYSbM08pFH+CMeEcmyQBbyB/Cc4MUsSE/VZaqPMNrUABG0K2z605Ks0aQKqamwUDoLmjFUJhiJdzfcEGCHUFreCiTKFW5BBZayZA4RN3pEjoLtbLgUhXngkAPqrOAEV1yBD68yPrt98TbIFIBDB1ZKg71wScJzACgJak2BXlONr2OjNuUZzrJICGSRy4pRXZRABVqoThmLm+r/FFkiW7WqqhfCqiI5d0E/4hGc/+xnWNdYTWsOFCgpPKhBCQetaJExSdD6G9JmSLvgwQcBCICAXpfHm4liyXlcIMQQbVm9X4yLiecC22E36hxBzAs9UBDfBS7Qm3x5S6XN9GIXWWKtav2NpoJqpsEMOjieIgp/QAOqPyODMqSO07XiVJBS1eKpuLClU1+wQm5fdDpSPWGBvZUVVUk0XBYNd1YaRC7mjEpJDzpXrGG9pLDMela1iraZ0BQtknJzw/gFCq94tZtmZdq3vO41aivdUg9iedhxLZaxt3Qi14RB3zjJi223uqj4emNSzLYHh+TdrN9Au8xBvVBwO+1Pgv2D/1rq/vS5bRwRUVE2246Js8IWPiBZFPjb3b5IY10AsYaQC9wFbtV0izxu6S5oz9UJFcIwPgo/H5YaXp01rTxdMEKP1FZpyfXHLAQvAQI8gATo9bwSaOUrmwAHjRr2yRjxqNcG27WR0qkHqrUsVPAkXpgi04v3CSPBcvrCt/rkA6YNiv0CismwatO1Sp3whY06uQnBlqkl5nDGshrVPHrYxGMwzJ+18KpAGxrF9RyVV/PpuBiLwNHQNQqVIu0z28muukApbabN/KTtEpjMOcEpSoiMV91AIAN8VbJXvOTkJ7+XsK6275yEYD5v/WpLYjHBCZY3xQDHVMzelZYL65rmYv+vJnGoHetUSgVb2VpuzmDxVJzleEi4BHLQCzRnxkA8VcXk+dDgDjehUSRul1WQxI60MOteDOkaTVrZDluNT4294+uaGYZB5u5nv1tqBQg5wOY9dUSbh+svXaO+9J3vNQ7eHOjswV5aUkrWmoCCisJtfA/o8q//RODYNCBaH6e3yO3n00zG2H8cnDaF0GI5y3mqQml5+ciwXeI9uwjPxiV3uQm9BjGM++fllgLQkYDiv5DYLNJGVbuXToIZE4esJpw3poGC5oLu+K0+VqbW8QNy2owEjOU18nmn9kqDC+MX5NAGORZe3+jYSwm0tpp+U6qVYg4Zb8nMj/ycudZiI7v/rGtucOBzp+xlVyyO5/vmp5brTdx6rFNyjJE480xiQH+7nYTxueY37wbNd57zmw+30BGdmKliit00Qn27nQ5Qwk/99djV6ccTyoAZ7tuzSaOr7Uld6uQZKDlyIMQuRRqJxzbBbSfF2sT3a0xfb5wkNd2xknBs7NbjD42FNzyzFT3iosb8twi80LTdWbJoVz7blKf5YhQt+tCP+/OfB/rOD106ycV59ZLhp9NZ38YP7gyNsJdmZIRvw3Y8yzRgf+M0ttdQ9KFKrSRxDvIG9TKBb9cl66F8yXGBHrA0ztcnNQFsLWR1hbNJJVAZJfh3AhVC+qNaMJZyMgA5SMVyRjdb/4y3XJizZ7fVMRNGQOnXg36mcywjdKDXeT03f+4nhFqAhENXf8pFR67jXOzGf06Rff9nQgwWgCLYY6SVUKd0E2L0N6a2gLyHPDKmJUcggRMogVzQJV7Qhhm4JS0VZh0YHwjITL7DSWlmhWcEdWoUUCRXeCdzVHHDbSpXQDcXbYxnZzU4F021BD2oQHn0gykSdIPhfmMQf5cIf0U4hJa4hEc3M2uhdPgnhZG2f/40OyqYGoN3PwpGUAjTLKC2dWFWh7khagxoSqrmIHrQB2hYL2/Ahm3jX13mZXPIcfHzTCNYXT7SM3yYRoS3WgbCFCMiMaZyIbHlci72FhNSYTMoOomNOHPfqH40Z4SZqISZ2HNagInvt45Ed26M4RgyR34tCDGk+DAzxjiXhIVTNzg7NThZ113/Rou1uCQJcItO00OP1hVtqIZkUAZbIAQ8kCgXMIx4l3dAFoJDg4WxY4IluDgmhz8oaI824zmLt4jqoW4xp21/hCGf8kimAiq6JY6ak1tNlUHjWG4BAQAh+QQEBAD/ACwAAAAA4AEOAYcdCQAnDQEsFgUvIAsxDwEzGQY0Gws3GQg5HhE5IQ06JRM9Mhs+OCI+RC1FHQlHIw1HMxpILyFIOSRJKBRRHghUKxVUSzNWMxlXKxZYKAtYWkNZMQ5ZOSNZRCpaLhlbY0tcMh1iHwJlKwplLhFlOSRmNhlmOSRpRCtpW0NqOyVqSzNqVTprMQ1rUC1sQRxuVDJxbVN0RCV0RCt0h2B1SjJ2Oxh2PiR3OAx3SSl4VDp4e2R5STN5W0J5ZEl6Qht6Rit6SzN6US56imd7RCV7SSt8sIeAPyGBPhKCTjODRSWESSaESiqEUzWEVTqFXEKGWDeGWTqHRhCISiaIZkiJRxmJTjKJVjmJdViKTSuKVDWKWTaKbFKLUiqLWjqLYT2McUyPknKSTBuSTSSSfGKTXkCTnISUWziVbVGVonyVr42Wg12XViiYYzqYaEeZVRuZdlaZh2eackyax52cYSydvqCgX0GjXRyjXSejXTOkbEalfWGnYR6ndEqneleoaDapZSmph2WpxZuqg12qmHaqo3qrsZCscjuskm2tvKSwb0KyfVWynYKzbCuzbTW2hVq2imW2zK+3eka4k1u4k2u5mXW6dC26dTe6poS7g0q7o3q+gTy+2MDBei7CjWbDezXDfULFfDrGm3XGpXjHfjnHgzrHi1XHlWrHnoHIqIXKh0bLhDvLol7Lp23Mk1jM07TOkUzO3MPQu6LQ4rvRhjzRtpLTiz7TjUrTjlLTnnXUjEPVkkvWkUXWq4XWw5jXkT7XpXfXs4vX5cvYllbYnGXZpGnak0XclUrcolrdmlPemUfemUzhl0vjm03jnWHknVLloVPlo1vmqV3nnlfnoU7nrHXnu5Look/op2bot4jo3cXqxJPrpFTrtHfspVrsq2PtqVXtqlvtsWnt06zusF7u69Hxn1bxpVfyqlbyrWPyrWryrnLzrVv0tGv0vIT1smP2sV33uWn3unX3ypX4xH35s175tWP5wG/516b55Ln5++b6u2z6yIf7xHv8wnT91Jf+0YwI/wAhSOBw4skaM3f8NPojJozDhg2NHJEoESJFiilGaNwooiOLjyA5gqxRImTHGj5SJhFj5GHFlUZYZKAwM4OIlFxyitGphMqNiXjyRBqaqNGnokaRWgJlSemdOxDtSP1j1JYzadegddvKtau5bV/Dgh17ldm0s2bRlrU29ty3tuDWyY2Lrq47dnfz6rVL9y6/v/3iCcbrrXA4e/MSJ7b3btxeeIIBS548GK/lx3r1Dd68j7LnzYFBw7ub9RgyZbqE6dq1+lXrVLVUwYZtDCs6ZLnWPtOqO+2y37q52o3cubjx48b/7VO+vLlz5syJI1c8vbm/69iza8/emdq8f9ifV/+PzC3cNeoLBJoAcjCoH6gP10AMM5F+SzwsKYbAwDGE/4412STggAN+tMGBNqEEExUMSmFREkPIRJOALgzBE08+AVXUho10uCFTRy3V1EJ4PCWGHQ/94cknt/DmYjlwiRXjbmrVaONVMnq1FV88YrbXYaGRV5lhiCkWmI+afWYkP5f1iJlmUEbZXWf9UPnZZpaVptprueRCypcgiqjJUrRp1Y0xVr1I41qoBQdXYeT9Vd2c4sljZ537cEOdc57Nud2f3OVJjZ7hQSeenIMRo2dx6V1AEBdmKLSQG/HNR59DFeUX036cdkrgp6AWWBILKDVoaYMkfYoTF5VK9JMRQW3/WNQnTCUSYpi1TgrfVFXBqKaOOQbbm29koTWjcHM5qSyRkhF3pHmKFhndaJgFpiRgTfr4WJTSxWMloqINqeVqs8kWZiXopqsJmGlGs1VqZZk2LHBturkjO4LRiaeh+/K56J4AawOweIBeZ2eh5X1XqL7tCHbNoOgJdIELTLAhKXyn2qdxREb4h8F//GEwYagkD5hSSQq21JKm+Un4AIUW6iRfyxreyuGHuXpY4lO7MsKiNL4Ce6ywxBYtrFvJIrvs0kAGKaR5zMq5mGOPXdtsttpaxq23Uo8nbmG8odmll2CW/WW5rsGL47unFV0vvXAHF/W3cepr6J385knnwHSC/6cd3tCVV95yC9MZD7Rc/8WAxBTPQZVCM+9kkX0rc9zxfx6PXHLJJeBARA0ilIDSqUdwDODLCVJxoemkxhqihx3mmjOJu66hojBAN1MajUcP7bbRQ8fItGFZh/usedIqfCTVeVm75GfZ9tVXPVrXbTiW6YAtTdu4scZll7ifJu9b3Ocetlnyvl1W3HJfg471zdrdb3gAR2dkL3z3q3+e0eLNMJPqoMbDuNaZxakHUo57D6Va9ZDSVQ4jG/HAxzayuZLVIAhNiFDnFhSRjZ1OQKu6kKt+4h4OvW5EJ+zQztzAq09gpRnmE1rwilWMGv6uWEKbS1j4Er0fNa162CJM0//sh7wiJslqAITa8IDoPH8d52tdGVb5xOcu7e1mimoySzLQxEX1DctMA+xW/OR3t4X9K29P5NOctOE/gfmLGNEiYMOuJzg58sOAG2hcAv2AqUpR7lIPApkEI+gBEYRMIwhKZMgW2TkrAAFlRuCg5UBXk5eRygeSm9xPSDirTsZORJ/00B94xsIVhS+GvZMhWMziPeD1Lmk6HA71fIg10rzPaUJsInOoxTzIIDFIxFva1qRDR3U0yX3ILE1XlFnFuECje7ZQmxS32EUvAs9M+Krbv/a3L36dUY3KU44b17gPgY1znN25BhwHpad2ds1+4npnA/CIA8clkFIrIR0gJ8n/kZKYwJ+jiqBHBErIGOTAkTaA5BIe6CApUHImqAthJpNwhBu0TiFOoRUKjWKU15koIak4ZQzZ4sresTI3JVXlDpU1y8a4Y3pFBJs3hKSPl8JJatPqpbOeRxkhMm2WoHmnULFnzKL2MJhW5F5rtrS2VdqwTdW0Ju9uulMy5k05C7MHK9i4L56i826KMec8vnq40iATat8El2AEGEapzXOeFNPCHi01UUwxVCIaAZ1e/5kqjfwToAA9pD+J0AQkJPSSEHIJqlwGs9VFxKKlu1koJ6tRS4zyKUah4q9uNNVjMaOGKK0NDme4UqT60EdgTMcRy7qjPeXUiEXiaWyx9VO//zCxq8YhavWOasXvha817uKdM6JK3Gsa853wIxh0uOo3M+rpq/sqD3OZg87iVHeO5YFjFZNZR7olCpk0tYAFGmABF7QAgQpk4EP8qJ8RJBQl7n0vSQA7X8DaNwaEzUjoYsYyBj2UAhG10AIt95EjuM4TtopdZVNIO5+1aKRr4ixpPxub2oh2tKmEZbJO21KbYpOmxJOOcpKoU9k2kba1NaqI0ehd3fI2GqeJJmzOpjZdqMIZ3kAljKFa3KK5K5t2bMf8DFYwv5UzYco11C65oeRyJua6aTTr+LhrPNb+GHsW0IB4T3De9jCEgZnKlKb2E1/42kC+Z5avfQdbX/zql/9UHETVfydUIcfi9SYJSQrs9LzgXFElpE2N8DUnTOHQpjRYGnYSL6Xn4Q9jD7zWgg5jtutLI+lpts4bjGGUptpOA3nFaKRpZajlaR49k1zsys0pvYRjVfomqu0bJqgBd7Ai0887ifnHdJWsnITt2slQrm5ZRSovKuvWrMfUAHk7YN4seJmuGbsrXvWKZjWbWXT1xXZAU4DfEiRooZPzLwte5gCaYJsIMmOVuA1cBw8huKOTpSygYQhhkkoYaaMdbjFmUQsLp8VeKuW0LBndaNt8uqbZa16kpzYOdzFmMYiJeKZ7atoeHffTcgp1w45tl4QnXEtkk000iZ2KUSAje53/nQuNYP3v3VA1uWWs9T1sbb9f87rXi2Kxc6AMwGKfDxlaienFoZbaZGpA2Q3gMha8jLGMRfvOGEHJteeb7Y1ouyQ24XYMvJ2BlIU7oZVMECYxRNEaQHYNe3b3uTaq0Xrn295vx6HYRH5hCNclaDnUcE0FHmE4RcnjncYpwx0jcYgb/jOm3jBQb8tiEAMeqS6CJt2B7qKsgIIUrW6qMzf/amM185bcQg6tZU7z7iCGuUUWmHQVxmKxBtk8mv05d1Vcl8oj+60W4MAOZmYip7dKZRQpc17NTHyqw9e99YXZCbhOqqU/iKIaAXC588hfDJmdk7BDcAqXEgkQ0Qp3URQ0/9zH/5byy33uhpbR2lSecoEPfPOcpxHoES7LI742Gj+UOKYpvmlFLx7IdARFMrVd28NFYyNNarIUz1B77Rd/gvZ5svZOzUV61zFzFvg31MAKY2UdqZcY3NALYDUec2QcScU2w3VKs4dybhcNuEcCNtAQO9N00EZX0xYCURd1xZeDZzYq5rZ13vYyF9RBiwVRdDZ2ImRRrfMhN3NCfUYvD4hh5Oc7hcZvLad+MMJ+mvcVFWdL8BdcaVEYHdYjK/YXDTcO9iBr+ndiz+J+pQZEeKJWRlWCMdQ9tAEvYBQvtlAJN+ZMZ/F54feE93Jx1vMcf3KBFmiIuvZctVZkiqGBrP93HcaBTgSEPVPmhb9lewxYgCjIFS34gjEYOb43URdhgwqCfFJ3imgmdWdWBW3QBa5IWBnEfGd2KhAiEyEgfV1XZ5GDBdCHZ2kXSmJCKz+zgnGHbzNEI2QTWgG3jFvYhZa4gGEohmpoD8eQf1W2fyQmU8J0XP8jgMykiVySGgRYPqmgh1zxhYQmPExEQLymHYdoiBcoKIRDc0tmD2wUHueUW3U0JJQ3gHiIReEHkPMkMS/IdH50kKJYUah4g5GUZkPgkA5JBqEADMBwCrzAC5MQB11ABHmlBM7HEuImfdOHbWR3ZzeAdmnXSbcijJvoeW4RhTAZd77Ab8qoIy4HSzP/pI2N5oVXdJP0p2i6lBhXhoZBBTCT5of+N0ReI4CaqFSt0UpBB012qAo+Y4INGFwYNhcHN2sTWIHv+JWQODg0B4lWknPLlS8As4+w148f15QASW9YVBaNkouqUyL40UehmEkKqYMXwZCquFBtUA3ZgA/3gA/4UA2h8AZQcFjV11ARcovTl0cVohKUiYSRhVHdx1FK4X0tiUPGyBYvCZqiiYVOhX5VuIyrZHeJxpMP2Dz+N1s493LUUmVGORpI+XiHoTVDhV3G5I9u+T1lYhqoBj6mQQoqcmrUdJXmd5u0x5WFCI/ioB29oIHu6JWBog11RGtTMoKKUUdER3mL9pux/5c77FOABOECdQaDK7ReMzhRe7mQfYmDfwmY1WCYhkkO8iAKggAFXNeYMPGDuEiSOFF213eSe7aS3vd9WQiFoRmTvgNadAdwCxqQE+qAT/gj5iCNJ0Y1EreOEwdPO9lxuIk8QvZEj/aNTjk2Ioc2l3d50sQIewAKMeZFNomVbIhxSWadh0iYX9kLH9hc7wgo8liid8KbRLpx4nJqtrF35BmXWkIvLeJvwuAFVKoFzsZ7JYKQWgpBl/SX8UmgXmcEeVCf90kO98AL+8kRS/CR/ymSICQFbNAGeWAGOTFCJ5kHKkQrs4Irw0iMePeZfSeFc3dj7fMudgeIyvkMPKYMPv+ZeBu2f2XYobkZgd9BcTcaTPZneky5Pt9jNmeTav4GDbsAoyHVSqGaqDcKgDmqo2B5HeHACkCKiNtBJUjmTVVFq2yVPgaXieQYe8twC3BTTXkwrGxAp/LxFHeppTQonxD5pWDal31ApuRgmGcqCFwgAkDIpg3FWGLHBYagCIowpzQDK0vIZy3amcuZrulINIOafrZBoSbVWeMonFB5k3whNPUwcQr3kx4alGSok8vSVkF0opbIJalWhzKWGggYDakwSqVqqm/DjIFYf7faldfBo0HKDb8wj7Iaj0vmTvqYMNwpj98pjon3j3EJHMAaVWbQsi7LdDKorKazkCnTkM7/GkkLZQTRig/TyrPigJFPsAHlxgLa6iAAmgH8MZmQkgUQYpKw4h4HKiLzNqGjCagZRppTKBsAaZVUG3eC5j2sMWWxdCx+gWJ/t1tboySEwYbItpUEe47AWYeBNq+Ulwt2wAgHSE0sh6qQJ5vsaLGseg96445B6ly12hlI6k40lV0gB3RtKXtKJZ7E5bJ1ULlY2nt+JIPA957N2pC82JeOWQVL0AfywLP2Wa1B+23tcRB1mhEbhARMgAMFZhL+cR94ELUgUqp+qq7GaIXCA7cQOgooBaw6JqFwgahoAaGs0Yc2GnCSOn9IgqPPw6QTW3tt67bHlFRPuVTV2LfI2S7G/1kJS7WopzphyMRpgvi3gEtkv8Bkz+mxOMdOc2Sk6UuwTNV/kOtFKaqwXNQH/huuWYqsGDNgB7m5MVFgnYuzout1bEq69kmtv7Cf6IlJcTqsFkwGGIzBUyCnbLBQJgEgBuoHeKp2ZKK7IlWMV9i7WKs0cqFv+2YusDaHbfKn8Cp+qOEa/WaHvHuhkLFou4Wp/Xo1APu4jvbDMeWbsTfEOeZbMFYJMeqUUrW7f3hWnmY96wuJrOC+hDur8au4T0NUWBJcS+WMggbF5BtVfJDGiTCndGqX8lE5MqspCOylK9Gy4loFduw6j4ALhfnA/sAK+xkEL+AFcsoHkWDIaUysHP/cilTatB55fXhWuSr0SWeTsqSFbziJjIyqNJoccrkRTctAw110qG6nRdSUt5v8p8jbUjDlw09SlLTlfs1LcC/mh0VHxLtACuiite4yqnh7RT1WnngHNPnGnCK7qvxDKFdsuPVbGSqGcEkqlXyoq2YczCzbimzsfCukMuw5g1w6fKuYBWRgyKYAwJ2AC6YwDLjwC7yADdXwldrACmpApcVqwYpcrC5rpUzwBPvsIOLsB0yrkGiXUTT2RffGu2WItTMsPYo6qJ7wyT8TysTsK+Uryl8LVRXWb/82zAYtFz4lolwI0v1KJdbrvTHUjCitxKVhDFS5y5vsLqqwB4ywydX/vLelvLX3EmJcyT/EUKlDdieMK4hxCHhGXHvSnL8/Z80sS7mXG7Oh2F4ngYqRcs7tjAt1oAjunNXVsNWLKA8/KwkaWc8cjM9zYKV0qs9ryhMWc8f5hJlSi4AG7ZIIzWjONEXsd8qqgGA39n0VrYmDZsN6q7zJydEdnRe0HNJAHMS9ScW8moX4u13n+9iPTS7pElI7tj2gcLcoG6w2PU0R+yuQBj+HYxpAkqP+0w5sdR7eKNLZuyUoldQXzb/WLD5MbayrK4TdPB99ORKqaAaKgAta3Ql10AlbXdzVcDAyF8+YUM/0jBCsW9Zmjdahu9bG2ta3uyIRbcmHhsmH3cIp/xvYea2HuCG8v8oiEl2AN9QbugreOdzXnv2ut+moxaOvmYgs53OHZEyA5QfZJVtyYmKyVOTEngDbs/3egx2ot4y92iWwRIpGQe2N8C3SjfvaNjxFsn3GuvGRtn3bwJfbz9cxvL2KitDOxh2uwH0w1SBkB2OBdhLBVArdLbu0OeE40l2nHhkp7wGKYnDd5n3CgH2aLOxSzAN5nIpFthDeLiSM5k2cTSrMPw5aYPtU6d15yinfhy29VvbYCB6VWx55PlecM1bQzSSOykCq4OCWnN3ZRc5FFY7gI1ps4eDF+XM4xOC4Wb6CJT3huyBF343h5Sm6gA4RbgySfQTHtFhR4P8MK8CNDRhpCqYwrOtM4sd9J9aZn4JA1l5Q1qwr4zlhpXVqKpAz6Dx+ichLtqs55ERe05jtCZyQGxoFoX3q105e06zR3st73gbetTp55RQby/ntp31ebPSqyyuqw1mxJdfgy7pQsGlenr9Tr1GsY0gMDUJ3jVn+XYStY3hngKca7MW1srh+Ffa84ZFTOh4uhBcR4lZgCsWtCFiQBXOaCOVsBp/gHSiO3C2+3MVK46vL73MwM5+uOjqOWXwN7HJdWlmD6v23v2pDKz6zDJnNCeR95BTu7J13xlEO5d3+7J+dQ7YMS5khGnlOt0ht4ftrNkl8Da59cqngBjNN4M1u8VL/7ueDNubGXhfPrCc/DGlyaMPozangQ9O5HtidDSOdcPQAnEkzA8eG/hLpDs6J0M7ywAtm8G1HXwUjkAUbW6TYgO8unumZrulyxekAD4q2c1mMsMu6W4ATvcO/q5U9nIaTdrI3vL214SWc8PCZHaMsUnIV/6szT/MZP/gyT+XGm99KjLZETPI/zvA4vC7r0iXC0VsyphWe4PJXQeoxL/MQq+pT3vGJH0CRHXRr+/OeX02obPKq/5RObvSP8PpsDYr1Yei47RMmcUGfwNW84AcbEQcZqAQZwAXEwPW/0PVALQn7zu/Pxu8YZQgj0hQsWqo+7vam3nFxDz2szDaCHRtf/xI7zuAJTyHxSs7kxBX4dY/XGa3xhW/K6V2j+K0jrD3yzcsm681jtR7mkB/50Ljw4QgQ3aRVcgNK2kFnCZMxW8bQYUOIESXmomhsoTKMGS1ufMhRocaMCRFCI3nN5MloJxGmQycQ4USYHi1W7AjS48eKu3TeHCmtzU8vXKQMXVNUzNEwVJIuZapUqY8bUVmIiIoHVzV57ah1MuNDSal2v9hQyUNtn7ys3EyeRcsNE5s5c7gUjVvXjyG8mjC94tvX1q2/gQMjE1aYsMhviRVvY9zY8TrI6NxNrlcvXj/M/DJj1teZHUtwOGuRIl2JkenTtph5OsoI1Kdcn2QPnlm7mP/t27l3UhxdK6dvnjFBOkT8zCXJnsgFplzuzflzyczBTX9+3HjIY4d1+U1FWu/3XYVRVifc3bywaLf+3El17aN2mTbjz6K5/SLumDiDEy+u/HDyl+ITzr5dVFElvPf2m2i34Mo5aAgbXJDQK6WQaurCC2uQaqobjOgDm2qqaQcbakoxw49hsiKmFbPY2ocaYqjh5qwX3/LDrrjuiuS7VF5ZJTvDDKONoyD/e+zIIyOTjLLPNtNsM88+iwbIAkmx5DQs/zDoFoLC0FI2MGP7TTcGy9QJuN7oI1PBmvjrD8Dr/JOTuuqao3PKOAm7rzzuzNOEtFzQe05K9woT074e09v/4w9b8BSyTflkMlA1/NYUsCNLJdJOpCB7chDSmCjVzTwEQY200gY3UHWEDikU4w5YY4XVDQyjsJUKqaQ64hNsRvS1FD8imdHXePZpx9h43ItRHWZXxOTPvHh8tsdXgCwStzF5WgzJJJf09rPK4OkMysuinC473q5U17XCOKHVtR7BfG0UUce0dzff0lQz01PZfLM4I+GUzk6C8+w3Xu8APUa6Ovmk9tFoarGDUUf71RTTWegdENWD8TN1I0MT5BgiS8+cdGOLb6P20gxUzaCGW9f4oxFDdpT3E5rxmDWpW3PtUIxPzJpRLWBZVKtZlaxVuhWmAROM2pWvfXTUexmi/25bx+Ls5luuu46yXHNbWuYvNGn+y10vPRnl5nl/y3hffM3U1xe60bxUt007BVjk97Q2buCC8WSGSvn6SvjAhcNRnDz4+kKO2msscYMRxO5GuTuNR9Z888vjJpnfkrcT889SOc4b2/o88mCEEmpQQuZozwPMUKdfY+QOWpuiK5VhYDRJnVZ6JKYZ8aTmzvHTER0yZbjzze1vbvvrWknq32Hy67ChgcjQK2FjhNY71Gb7Nbcnvbd886muGm8i+fY7u/elD9w6gw8GtNrfFSe08e2QeRy2g3zPEu5BCGA+Fqq1pYxzqUNVvcYWOnqtL3Qmu59NypQ822SLI0SYCxsSUf8KEM5OhIAh3kEKE8LuNCJWOvpECIk3jN5JTYbK+4uejGFAwi2Pdgua29yYgbWsFad6XLsT9ZiFvf1lhEt3OM2s2DM+UNjLQOazW06mmD6qNQ90Y+NUF4cTMDcJjH71Kxx3EgeuxTnHWgTCCLrIJw31FISAKGtgmup4R8EwED4PVFlFsDi2zG0xNnwk22gqiLqd4FGCmHBE04anLPh1sYQAOpsLizRJw1jNhCLznDL0+Dn1MbAYPXwbcLZhPSR10RyrHGIrh9ikr0VHO5aQVazmNb48pquUJjsUFU82Ex9OcIQY/KIX3zdGOblPiX45I6FUwj9dzNISiUrFH+SISTr/gnJtEgylNjt5R0BWcZCBJJsidUkKbl4QdX8s5/Dc2TBkAk5wlwTj1CgJkrrVApQXI2Q3vUlKX/wwMqwM4ilduaStBc5raPQGQnDWCLXdDg8QhWILc1lKhPFSX+y84i6FeUMcErOYYIRe/DZ5OsI1M42P26FfoqkLTXzpIJ+YWC7EphADZrOj57MiObnYz08CM5S86WMgZcNHo2YxYTz9Jhtp6MdDybOIUp0fcox5LVMGiJNqUkhQS8ZOpGL0islQzNUMZlCEHlSWU50eAW8BCorKRoW3rF2Yascbsfqyo78sagQ9KlTBDHOZL3VqwJQDuH/N8BjDy86y0vhMaNLQ/zRRnKkb7NAo4uV0gbFRW/k8G05C0mubTC0nYOG2NtT6NVBAHepO44YmcTpVo72ETTEYxtY6VXWM0BzlybTKwwP9kCG99apSg/sQUl7RGqg8zqc0qdZWjrFOaYWjJ+J6SzA1A2HZvSheN+paummEs5zo7F9zKTzByraYJRnPndqLTWnAUBjvVBw37LvSIg1TebR0jQlBYVnMZhM3qfWldz2bQNigVkzO++yBOVuMBC5DtRKGyFElrFo/KdjADHap3DbMG/NcDbq6RaZoehpQ+mUyI85zUGw31sN/7vVAQOzbiAk6UMFBryW5lcYnyFvRijqtuxk93B+7KmMtnldeQv+OWmMb+8hBsaS+zEojGql8XyqbZHgywrJaGIvVDhvudpYonuQu+1vLzUReBRbraCgM4Qdq+MIfPh99/HpnAot2zkiN8znvNze+YJG01NqwjXF8Y7Pudrj56qii/9lify66tVGMccI8YVPIENS5IkmroeOZ0IS6p3uVvBnNVMhEm60sl/jKsN1UrGbsjjaXgCnFzWy2o71Uq7HjmbJ9k1WueQAb2MTSijpI1GUsu/PLTH7qeGv6ki7dIrOa1RzmykuqvGYbwtuMMLYdbGcNI3nbAPwEhRE8ZyKPVsaBBiiHxc0bVMZb3oeeH42Ry2grcQLFjgYspPMpyiTTdsXfzbf/Pun9EbR2mknRObjf3JsOLnU2w/PSGe68lAiLNnlqffrNDMfbZiXLBtcYrxmuXejY+/7Cd/btFbFd/nIuxxxGys5hmPtUiUWRedrf24NqOLnFUfzYz+JWd7jHTecDI5nA6VJZnhFcZPGNDlAbZTebDbzdKc5b6w0nMcYMOVlfEHR7wBUuH/sp6YCPbrV9TVglZnzoaRAH0Z4uKHtRkgt4kVpep8bVGmomu9kN46QbJ6yKW6rt3dQVZ4nAQx4SwYeSmzyEP4Jh5YmhcpYPDUSbb3nnRyRzVshI2Ss6IQ05jrmcR7OE1YwCxUwIUkHGJjVty7b5RLvmBy/d6gTfpdOf/762ckT49lcU37WVTnQ2J58ey2c+dFzJrea65N5fd/s0xI5mk5UdlERdtHnPiaB/T7ES5MU0jp8h97nbWDoAAvUo2KV3MJ06dzrKy4407j//pYSk9AyrnAMLGLm6kRuBizhwPD5QBEdIQAVMwE4wBVMYBlb4BQnkBZU7Nm4AERnZPGrABl4QvQmMQAmcOVZYhVZwQFNoGhRKQU3AuUUpBfEgnlGwgyhohFerNluwLqEruuMbPt8jrtr7Qc4CsopCrTmLtdybOiRMwnebONRqPuupDHqbO+ijH2bIp3yrvkz7mKw6P9ZqHu/7vu4jvh9jBua7vueCrsmYqk+bDmMYP/+oKbWcsbgbiAKjAJ+ZMbVUu79JcpBJwiRmIzTaApP1iAs2+ImfMEDIO0AEfIQGfMAPlMDLe8QOJJEOrERIxIVIlEBRgMRQ6ERK6INDPMDJozVaqqkXzKx3ATMJsq7Zczre60FXRD5wm8Ug9L1Ys0UxjKKh20FeRDInnJ4o7LoEoZsr3AXrkz5IYbHGILuFIMbd66gwzMVlaLgzREPmIrGEejBSY8U7vBFamUOeuZWlAB+6uAs8nKYlG6YSwibTyjjOyhkCNMQC7AN6pEcGdEBc8MR87ER8lER/5MR9jMBNFAVPPAQ92AEayIEmcII2QMATdMErmZhy6wlh+K8ZHLz/kcmYMbM9WMRFHhyF4Fs3GZONtxFCjxxC2pvFjqQ9qPvBUXhCmIRChZvC6Jk+oTtGZfLBZWTGZOA97xqraDQQ8tI3rksIa6SMRFvD1bi0bYzIiZK/I7CVnQlHcXQKC6GLFaq48LmZ9CogexHEG9GCLjADL5iCn3gDe2REfAyFRuTHttTHgezEfZxLt4TLTjyEM3ACHkgBvuTLHWjITgghntO5dYTBpPgEdqwajTyNjzxJx8S9XlzJW3zM4iMfiqDMyFQ6hQNGKaSxIKpCYnTDPTEVZWQMr/NCkMO3KaqwXCQvZ6iHVSqHYDzKpKxNsTG+dRnEOIwCcGwEm1Gh3IlK/1yJSuIcziMwAuEcx4l5FVhhTOzSm4R4GtkIS7HsArM8Sz2YBH2cBEbkTu/8ThMMz0YcTwfUTu/UR0B4gylYARVQARKwgPY8gRSggTh4hAT0g8khzMIUhkpQCt6ZNtGpIkByTsykzKNrtcYcSceszFtiUKOTzJaE0Cb8RZmct848l5p0RvIbTVApzWQMLh9cQvGbhWiMKNfcMaOkza0jmCy0kyk6G7gaRNxBNWuCisnJNcCIBPlbA+MkTh/9UakMg9xRzolZD+esoUwSPEPhgzaoziewAuu0R0q4y+6sUvsEBCvNUi21Uu68yy/IAffkADEd0/h0AkW8ETI7xXXsz/8wQMxJMi28ItAELVCUVNDWpFMHzdOdckyo01NbrFBA7TTPpMm4c0Yt0sIt/FDUVMKfJD/GSJOg44TUuD5PS8NrZNHa5EjrihXL+hL8nMMvQcFaSwUdZbyppEqeKU5UxRBybM5RG6FOcIQ8cFIoPYPs9E490AMExFJevVJf/VVgXUQuJUi8pAH5HFNkFdMTyIFDNBslLUzDbFOT0KoxYcWoK1A/ZckjJD6T7NZ50dOhLL7ai9A+zdY8o9AVla4SA5ivKp02MVScxBQfZDvwypeIItFtMIZZlNT+ik2IAEaGS1eqshPiir/1sINOpag7sJUbhVUmkyt1uYtFkVGK/Ub/VV0KhF1O8OlUV52NSGADWjXLWwWEXO0DkhWEtDzZelxZRSjZRczOl61SSpiEOPACZI0AnI0AZFWBhWwDyMMfaUiaEvoeaVUjPSmfyYoibyUwS2DQpW3Mp51Mc61MlVxQW8xTE1WbhdtaQSXUgpq+eSVNO0LG6QNRX+BFSHVU0IxUSV0U2/oU1YCMWHI+EbPUeiPYSTHYjEU12VjYtAmp6HQY6bS2G7zBUkNYLxFSjq2lqxxSxU2EJh1L6zwDtHTZelRZXkVZlt1clpXZmf1EhWwB+ZSAnC1dnV1WMjjAFpovJYWka1APW0mF+3IrwEpaakmwBBOM1DJcixqbt/Jd/7PzWLZhwm5NNamd2lzEVrZl0KZt3ivk2kBFNK81JkS6DS48zeMi22Y8W3TqSUNVBfLzKHAjynIYt4halFnIQovYGiSyW860TYJSN3WRlevKnepLLJCZtZ8KvCBJoYhFDVP7XxkNzjBwPHlcWc41WcxF4HlM4JTVzkxIT9GVz7403QhAAJzlAJ7Nzge0PC0jntf1W2EpNu3ZIR9zzZNKjmdV02ZQhxa+MqRpBj7EyP79w+162KVtXuclMKw7XqYtvh1OWiG2kkBF1xad3rhL4n0irg6dm8+MRu/dQd47MvFhwUoQqIMwhqAVl/Z1vq1NtPeCqcs834z1TQC0OHYJo/+c3L/ESi/9gtGH0hm8YGD1pNzLLVmVrcc6tmN6tGNDLEuGbIPKXQEQuIAOOIH4tICcRQBGZuTTdYIGxMTKK0wZwQQx8ApD+IUX0bJHya4XzrIWDmUpSxqZg2FTPmVUTodSNmWtcKwXqsgwsas3xLp08+GCu8J8u0Lb9Q5OKGKBHdQnbuJE3d4QXd/rLdvwK7LUTCCBMNyhvJ2ey0ZjHhcoYSgutmbbbKheImNUA8BGAB/KKqnFUONjir6DkE10BrX2+hQaBiEEPEDKjed4vmNBOFm0lOc4wGfKnQIoaIIgIAJjFd0WAFNVgYBDtgD4JN0LbmQMfmQO7gQPtrxhSAT/KfAKMzCFz7uGSd6h/AFlaA3lVw6SSQbhDMQFGNaKl3s5ESGWlfaVEEHpzzO2K5M5oQ1p2iFeHc7pdZksntZpXwbUC61JJV7iuhHmUtI+ZE7mHHTJaYQja2vbPeCEpka4daDmzLhmWMoedd6xhvq9GJXIcuNPmdES1SPUNykrtRpltfZiHitMU3AEUJRHedaDe9bje9ZnfOZnfwaCgKbgDijkCdgACDBkC0ABhWbohtbgJqDHRpTomXMEHtWQJOADYrBA3/FKERpVONRpNA3gx/tseVGE1a08TGwWYkEWlzYWzjsWtGjtlxaRlmbtY2HtrEDtdoiHLoOkpgEx4r1F/512u6b96ZmU3nVtYvaR19wAyq0S33ANX6aG26ydWEw75lPi4ifhjKyOEpncaucoXGfe1G7WLtyhQWeY1uIWonNI7xWNyc385XFgDndyQEVgUrzWYzzuY7zeZzLQy9ANAvZE5PYU08Ee8A5YAdJlAAVAAAEYAEeOAJ61VbVshcp7bCzQkBGgiipQhF/gQBCRr1vAhNsh4J4B0qfQFROfwx81AqaYKB1BwFJopA6GoXyUZEi8hkuEEZPmMgrcQM4bmsxT7drGshG5jNymBjVirKVhtmn5beF2wqAOZkSNPTsy5rI9kO8dysiEbhOF5ul2k3EQl+vGbf3Bbu1GUa52av99nZdT28p2EdJUCFoe81rFWG8VxVD1vi1ieGs9luu6rtySvevrlOct0OvQjc+E/O8W4IABlwCE1gDSTfAFZ/AM5gEysNVSaEAXfOU1uAER6PQQ6HQPCQUJfGtTFQPeNPEfrZUelYpP9/RPf3UWaBUqSAIsOAq6oAuyPJE60PVQRERfT8THe2fQFu29ePFRZBr58uCYI3IxRzbRg6ybjheZvOYvns3zPiBiriPfwpigU5OqzczXLN9vNY2cg/NjxghvyAxksbIuDhw/sh1o1hIYbM64HViapHMjHu4jRuvpyEe41u+z7HOTtesv2OdBN3i93Ot/BvD4ZM8VSGgOQGj/hD5wBpd0BtBZSj+DA+yE2QjMW0iEI3D1EKAAB6CAJEhdMqiCCkd1pVgh50RHOBxgNzhO4ox1Drl516EQnc95V1mCIXgKWkeKoK/1oTACoi96lVcCq0SKW8dKXTfHSDB2EFL23vmdVe4yKCvzJr9zYP650czIZLZebXLuqiV7JdQYbR53K57qc4cGd1D3fiCU7N7u6dgfjmwiU4wjRgiUdBZnIOJ6wMd3wc9m58hH/ObzO65cQDf4fU740AXTANfg9nx40ZV4MVXki0/wBM9ZElBIjTdZF/+E+RaDC+/0Cyf5ki99nFcKAgXEkdjPaFfzATb1msd5C+cQyc79GpiQ/93Xfd9HTg3xfZ6X7L4DelqfdeQXClynv2EvdmRXtlLG6q1/cjLC9gnqP5ogGaHETQXVN1dE5zQHhWd+tk3jj7efh3WvMmwONVl6d9SQbmQAhXI/rL8P/EM7qDunc37ffy0DiEmC+sQpOOUMwjd9FuphqPDNl4hbEk50YpGHxRwaVajg4NFjxw4WRFqQYJKByQQKVkKI4FHjwTYLFdFUhOeGCBE1SuwsscHnhpw+hoaZYynVraTCljpjKu0ptGvXoEJdauyqLVuftnJt5BXPmiRUqNS4gZMF2rRozZZly6ItW7hy47rwcaMuXhdx7/qIMtZIDbJE/xIOY1gKFS5iFP+bYePHkKFIkjGVqmxZH+bMmtmh6+x5HWhwos2R3ma62zNn1lQza73sNexksWUXq217WS5ftn3NUuX7tmqtozwR/+17OKfeo2YlP458+fJyoHEX58SJkZ09o6Rzj+Za2bFo9ubtK98vXLT06seFHv25G1JluVIhx36nkq5U2PF3R/3tP4DnCDjgO+0RaGCBB9KjIIMHBrjeNawIRJBBCTnU0BgPQYTQRBxehBFGGm10AokdfCTBBSa1lNJKLa4I0g5NdNGGTDUpkogYf2kxxBJD2PVWYEqs8Vh8TlF1ZGpIsoYMk1jZplVWXSXixxpVEnaXW23V5RaXZq3VpV5q7cX/VhR8BXZEYD72lSZeQ7E5WGGLyWlGlY1tZs9m9biTIIKl+Znkkt85CdyguOW2W23K9VZbcPM9pyh0kUL6KHTcXfXcdXvcV0x/gLYGz3jknecNhO6h9hk6yBxKH3GVaPqHKsh8wgh/VJn6YIN95rrgrnw6WKBU1AiLiykDbWjhG2M0hKGGHTo7xYcghjjiiSquqGKLLrpEAkc7xEhGHnwsNFki5DpmhhJEDUnkK7o06Z+ngcZr5Gy3FZOKocKlIhlkX81h5WFjBTxWmW7e4BeWaLqllk5fjklmWRFLPHHEhLl5MZxiiYXnnXnqqauB8QpaL6GI6lbLyYkuehVsjlY3/6mklL48izTolJMUprTe90mnnkbjTj/8CI0nqaWux5nNu+SiqqOV2IefMcXVXGqvVYO8INZZ+5prsMJSY0ongBiLLIbMPnTFsx1G24SIIK7AkYkeYbtitgtMcDeMNLwNBRlnzFQTJo50Ukq5fvxR5R+QkbI0k8c0LrK8kIM3sr03Z3V5Uo6yqoklkfT7OehfGT56I4ffcbpiYSjhF8F+Gew6wgcr/DCYb2J8exI26B407x1/jKquklNOsslKo4yocYMe1xzMzVcHSqWpLpOzztotAy/k4WQ2D9JUn+qZM/Mx7ZvT2Xmi9PnXr3d1aFqTxv6v8W89vzr1U4NNKAKJrf+GQsou+z/ajlURtUmrgG3rVkhMdC0IZIsl20Lgt2gkLsCVwhSlwITnjIKJ/LirNalxnM9OMw0PjoyEIxxebkZRqJa1iz4udKFlkBLDF9InczSUEudyaAjHoK5OVXJDjgZGlth1yWEQu11gytK7JWbmd8ALmQhXMzziFe94h1LZyl7DG0o571HWed5w1Bc16LXqacRBEoAAFRXeaa9o3usM07BCilaZD3PlmBr88qhHAbnPaumwn7DA9gixCSJD/9MDHBAZwAAe5FkGfOSI4KZAa03gACq52wNVICIgyEiCfAhXIkoxjGG0IhKmswS9RhgVyN3xjiU04QmlqMXirVD/aS28JeYyx0Fd5tIqvsQlMLsCPX6JrnRgAZgQBfO6NmEsYUNjYhP39EQoliaWU6QiLW2ZwiuqDIzO+abMwDg1aXCljPthxHagocYoTk5754EHem7VDVJ1RnxyHM6rkLK0/uyRfv30I4P+CMhWDJKQDEEkITOUtkZ6qG0XWRtGUCBRjozkRClqyUe4RaIYyYgJnfRkuERpQSqFoRFFgqXkXGlNlAqPZNjUZlau4ssmzRQrNb0pMHd5w82VE3pe+eno/vCqHwaMKEcomJue+UyPOTF4ppHXS7OZsipesYtWBWNxPnG9O/a0erRKX5JMpcrGAY1obvyee1Rhi0bN0VV7/8BPfOb5vn/Ob1dW8yMgcfEISUgCEIcARCLLBsCFEtChED0gCvTGkY/E7QQc0OQBQfRQMoALlIqoYCtK8S8/nDSlsmRGNVkqMpV6UKWmDRRtSgabyKG2XuDpYDLaxcHX8jKXtl2VPkuhuRw6rRKGYMRj/tVD4f5DqUslWlPp+SeqXDOqUsViN8Mps56SEavLSAdXqacp6zCONQ9a52awJ9ZYqTNKxNmuPXFV1/mt9658BCiwwsGN+v0iFBKaxF8Bm9D9bYihEhmgYaEFLYca8G0k0OgKIjtZygqYwWew7CdI+YcorGGDj2upaFeq4RBGscPsZO1yP/zK5tartia25/9tL5fbFbtQMqDAoCX+UVzjcgxp02wPhu1FM+c+F2Xg9GbMpJtVZ6SjGdR5jldB0d2wqge88chMk58hGnqKr7xNe+vi1qpe+DrVvbySn6/2xA1sUKO+rMjEJPg6EDUglL8cWmTaNtKDyULSoW9DoGTpDC0aIcTBnrxsI4AIK5pemLUZRmmIE+3hRa8TrYtebWtdCukm8ZhlJsRpkzCHYlvIWMY0rvGNcUxabOarx1T0cZCBTF0gW4dnSVOOOV91viXjysnxgKM6owI+3zzlnvvJ8vq4LD8wv7e93/iyguQ7Zl7YVxRpLuRAoK1fOAhQgBWZ89sEPGds11ladwZCI/X/7GcO9c2T5TodOlsBwkLD8rSf3TCj493hKC/a0SKeNInx3TJJL8ndhpbPbG3paX7M+LiYmWbRQlxpqnJzqqj+8RdVXd3nNWLIr0ayzn59PNDWOj1kffJUbOUZKBlZjtf56j653Mf4bTlAYdbaytmjbGwwO38Tikiy9KvfasN5wHIeoM9hsu0Cp0Bv4RZ3n/OQdHMjzsLtYre7/Q1v1fRM0dSEF73FG+8R67vrrl1rhqWeY2Z0uuAGt/GN722vhTccul2U+MSxCr21Jm3iGZd1FuXpH6VBgzO5pvquyfsUl9EKangU9rCNHfPFh3nM1ah5Qb+AEZzrnNrNsnaIEtwD/6BvW9tD/xAQOJLgayP9wUmvbB6oxNlXOK4V+Sm0pWIv9nfLu+UDEqHVFU37Q8PS6743bdUZDcuymx2aadc6v1V4r1Jbse3Igzjc496qiJ+xlYQ/eZKzXIzw6F0aHPw74EcenV4T/g+G17uXE1/XY7Of/Yx/LzvigQ2a509sEMmBF/J/kMonq/89j6jmzRnpCSABilueGSCNLITS8VljpN4cUIa6gRBs9VundMfUrUbu3V7HOYjWVaDwcR1LdV2vhWArlWDtsRLxicrZJZdT1Yvy7dtzzVLK/BimRB9WUZ9Wccf13V3hZRnKSFn7KFfAXZhckRNYjY8qWIJQ1QpdJf+eyq0c48VfOzzeIziEF7hAC3hBD7RADrwB/51Nf2FbgrVNAWqbGfoXRFiEtpUeH5AbjThGuTzdMazCBJKQBsre7OFevaGf7Z0gBooQCPobvkld1OEhGm3dMxDfwJ3dHwFPB76UVjmfJD4c9N2g9FHc8xjD3k0f9mXfoQChNH1GHMWUd5FK+Aier22XJr5HeyGbEz7hy+2K4/FCFfIBm31BCbRARPBAEHhhYE0b/6ANtAzdt32bfzWYGVqIMDaYGjIYny3dGyYCH0Dguk2OCd0hP/2hNdyhNv6JN26gHvqhwvEeOf7bUxRiHh6iafgDO7bjwJnHk6GdcnXfCRWKNin/X/NNopBdoiX2IyfkoPeVUyeaH0FqgvaBB2iEot/lx29Y4zxdA5Rcj1VcGTod3q0gSMy9Ip9s5PtdjTpMIS3+TxzggAt4Ac6xmV/VH2AFo+QRYwuAxAp8RLgxo0U8Y7PQZDPaJLk1YEi5XgS+C4dho1Buo4BMw1AeZR92HJMhYjkeWjoeSQbK2z24Ywq2QzzWjzx6T2u1HW51ZcNR4j5+VSX0Y8WNJScCpBGaEw+apS2tokIijaw0pDKIUUB2l3m5FX/MI+JpJEfCXEcG4R+BZP0VBP/EQBDsH0rSAi1QAmOu5EQM3RZygAJ0wGHmQEvwwC7SAJ3pZH9NlrZRxDPO/4gEXZZPVqOGIWVRduMfomatqWZURuVY+aFTPqU4Lto94MNUKmJ57EM8zFcb0dNZ0dvk3EaleKVxblNvlMM+RlxZVodZ8qPUuBLGZdw5HYVs7YJqvKXfaY4tjWCltMYLPQ2R6WX6WY1fnudfto/8tQPkRdskfAEO4B9hHkIs0AIqoAKaAdb/dcADFAAHoIDkbdSAyQAyNuNCIaBNHoT+tUEc3pRpEmU3sqaETmhtVihT0qY1oaOFioI2yMNUfqg8hKhVWuV8+eZvBiegpBZM4daitGhbbtFVxZ1Yyl1zWhfHbYV1UCd1WielzRNnhJd8yOVW5UL13ZMn/JqPNmE/of8nk3ZkYFYD/Q1SX1ECIFRbKPRCNdjnYD6E5cWkARTABHTACkBLEISIZgKYGp4hTUrWGZRb0u1ZAzpCK1jQT66ba2ajRgolUt7pa/aphV6oOTZaOOIeX7UCK/zC/HkoiMoDiZpoPBnNcFJVi07qVz7c9AgZOvlUptodKGxq3NWGdJLRjmbcWMohdopG/EGZd8CobPQacZCioUDPdmWnnygpRhZIk8JTk66XNH2kYOLXXuEXJZwCsQ4rLWSpYt6nKITCIOjcG6wAA7FEBxwgQznBFqSpmqYptT5jg3WBSQrCI5jCKljQg4YVhebpoPJpOJ7rn9ZmU44Qa3aYJBAUX4H/DStUg6IuKvcIS7Cgx6NKoIpSIqXm4z3GaKbOKHTWaHVpmWp0xagmTlmyHvllZ1kd3Dfcy0EeGdilIiPkAj/ZaizyUa7qKnuk58fsA5TWnCBNgn0pJjC87LHGLC/cZ2MmlGNBFghcwAuICBoSkBkKHbXCKYPlH99460KwbP6swirYKRB+F7s+rbpCbQe6q3eJ2OwhGjjKq+DUa7DiAi7wwvwtqjbM1y8Qg9eU2VQ4jqRCysAi53KCUeF5hfR5KlYx7L381MPGLb5MLCiS7KpmLI7eAvmxilCl03vUKl/iahAqLuM60a62ojt8JKPij83hV7PdJ5RmbsrSbLMCVoB2/+FfXUGC6d/lXetjFtBhaevQZsQT8M0UHG2zLS3TmiueoivL7SmEtqaftqu8UV3VYugJ/ocjDC/xSmmwdkInhALYTiVusuPYli0xRC/ABpzbGoePXa/BcuqM1ujB+pSNZldvVeeoolLavt7P6KquHkMtAO4/tswnEKmrdCxoTAXILm5fNm6BoG+Tuhxg+ir9EYt9DeuwogIwQGksGPDL1pybCSAcXALNOqsAWWvqPpK4VQEStC7+ua4aPAKaievsJqXt3i43Sq29lTDvCqruuWbuZi1RXpCNFC/yIq8exDAuhO2iki0p/dItfVPbgiV0Hmmnbqre/rD0aeLNaGre6v+t4FrZqZaVND0D+lRV++aLrNqB4ZLnRerR/W5xye6v+zWe/zIbAJtCKBDrKRRw5tYnsgIDftpfQVwBQplxG5uNz+aZgn0enXkLJ2mEF8AEuDKm7IIQCIfwKw4y4iba1bFwCnNc8O6uCQOIXknGBBFvQ4RNDNPEILVsvopomfnkK+gWDbEtixIxDlZcpwYxOsWt3Kayqi2xcCRxdSqZVKDG8nEfPaQvQ9rTdWhVrOKTdnRHZxxyr/yO4zKpPbzDMT8u5EauVT6eGHutHB+r5mruy1Ip/0QEQg3CJdinNXtuGpputAAgD4xhgD3URuhxZZbpF7DZJCgtCGWdnu6lCBv/8jzT4wk7cu0psoB8zY1M0N8owv9gspQqQrh+bTUwLztyQ/T6JCi/byiPMidSH/UdrCqXpRCfZSYCZH2s5Voq2XgysS3DExSvb3x8gh2km77gU17KVSIHVDGH2nki1y0ns9Z0sciiqhRmLjSf8cxOszgc9AEj67JKAoWss18twiIQa+cySx1fKzHe8QHyIi8Ggd6U6c5egQBngtIuLTwnbkYScj2DzCPfM7zgc4QKM67QnCN4jrj4M0DbyLJsrfEKDqJ2aG4+b2ZFwk6t2FFMnERjHxCP71d5r6gCGaiOESzjLXfh0UjzXcmKxqXMxy2Mgvk4NI4WrkUWoVd/zEvf/y9Nz/RnK3OvzqIZzyzYBrU43EPm/rQzU+nYeGFWH4L+VGmG9Bc419mYEpg5TzVVj+7OCgIq9IJwA8N82UNXezVYh7Vym/W64jNzX938cQPhtHUewLV1v/VcGy8ZI+qi1hcNtYtPds5Ycu8qh28Q4y16n7IpE3bdeiz8EiQsm9/cMfag/AwcGUORgEJl9xSW1a7teXZn4y8yoy+o3TJ6usdbNjP+/IJpn/ZBpzaz6UH+ZEJ+EkQwHoKyIrXOOWZDObUBSVS3XUSM8LZVY+YkuKxilhkrBPIgp2dyvzhZ6zNaN7cjC0jYYoMjhMs/S6NbX0gfDO9AFC+4FvTyfig2NP8DKVlGZlnCTx1pk5d3RUf5YCdsJl4P4XJ0R8cVrrXlp7za0szK6QyTw55PZneZ/XJ2gDcugRd4Tds0R3rGLJo2zck5UD+CgS5oHPAPIGwzGzem/zTEm902MYJ4YhG6RoD4h9gADaCzfLLzIRCC5W61MKxSUpqsi8P4c9O4pmf6ptu4h8rDL1A3KOm4j//N32T3TAyvKdS1omrDkec16aC3rPcWUOGBYKNyYX/qPtnCQCZxHdGdKE7VOL3GZJ9SOdnHFc/VkqJ5Z3uDmoM2mx+4m+tJ/czfnJcZzT0evooDLfDBJpFkLn6rX7nsHDO1gHl4tyXWOKu7bpspOZsk/1z/8wbz1bxy9X/brhcvt+K1tD3zYafjrtSWRzv+wo30AY8fPCgVhKj3uHsW70wgLy+EaG7yM2TYuq0DFZPPuo5WNGHT7cLy8if0uq/PHbBPRxSfqslrxencx5R0qh24gfx+LEvPuHbC9JlDu2jXfLXPX4PTOYT3ARloRApswN2cwGEqC7m7NoYMIAV3G1RjhKK7++bBcbyrAYXXu9LeOywi26VzcR6dxlj/+9SCvYyL/Tm0g4x9KC70c8K3vcIvoKiX+nXbSPJiQ4gy6jB0wid8UssXTsa3PB5cPMRuryUAMScqLMkjsWDfXXF4rLPf9zbJhsfJhzGxfFkCESiEH8hq/6ey3/xbCrjXv2WJxnmDxwK3n4Ie8CIJVFKYOsEbMCbn1nYdN/26137mkXNkBQHu7+zm9QCbEYIDC3cvoMKKK+1jH3/oJ7/XH5ulb9n60TP0rzC7Sj9R3j073kM7dMLCuz3cv733M7zfFLwC2sgwgG3mMlszKMLeF0657L3oXPyTizeTT1/hP2erHftbqbL+9xaWAcSnT8ukmUN30FmxWqpUFXsGLpo0ZKn+3LH4h1GjRnfc3BnYrNy2cyNJQjS5DiW4dycPumuJEObLlCtpuqxpc9zNmTh5soP3k1tQYL9+nTrFq1qsauJO6XGigsOECSvOAJq06FJTPW+2VO06hf+HjR08eOwYSxYFDxg92L7gsSJH2hxA4JKdGzdHj7pzX9T9ogYOIVq9CBfuxQpxtFWrcjb+phMyPcmTKUe23PhyzZKbOXd+7Bn0tM+jQ5MUbc0zatWm98nz9/r1L0WG8tS2fRt3nNptcufpk+fM7T5nfvsuzsc40mrLl/MS+ClR9ER4qPuprhG7Je2etnPi7v17+FygPFXMeB59dkYVPdkSmMtYwZTJxpOqpSziM2SWKl683jEV+QwCjaUCZUonpp0OVAmzzBz0xqdwIqSGl1AmeSSUo2JRCphTtkiBBA9UwGoQSrC6ZKsUF9FjqzPKSguFseSyi0a4bNwLrxr3ilH/LcAIQaUXVwwjjBvEGHPsswcrW9LBJJlUksAopSRtpNU4E2nKzVZbrTXY7rlHHlNo6223MncLDjg0eQPOTDZt66O4OqJThE5FkJJnuXYUEWg6PNT7UztAwRs0vPXSO7QS7AwdqL74ulGJmV0WasiZSnXZyL87MHWDkQBBypIzbxQckNQFR20Qyp4mDIpCXFw16hSlOASEBxJUGAOVU0y8hJZLDgGEqze2GkOPFbd4sUYa2dKrRhr2SvbGvmBQQ5JDCMkkq6xYCSSTQIxMDMlUn0RV3CZpAhXdK63Uct2Q0q2ySy/loUaSMcfUjbd89SVzTTbjlFO426R7U5FTsKmm/x2EsRmmlNmm80O67LoLdFCJyUt0D0Q1NjRA90CBDxpIjWlUmZJJ6S9TjtwARRiJBAzpNP3axZLUUhO02dRyGVRVQm6w4QXooIFMajBKnsI1VxLhGKMru47tilimlZ2RrLbeyhGtqXOcUQ00riXEazTQkAQMrwlZTJLFjiFXMid1fjvVks6d+10q2aW57m+2VC1e2NrZRzba2DBkcHz5PZxNNItTs9/c6niczk8MzhMbakzh0xCNBhY0vYkN3TjR0M9jlDxPTRo5FYZsEeZSlNfASOU/PqoUZtUIspSZmGXGe0CYcP7dwLcltEnCg4HOEFZaOtSVaax0xYrpr5xw4v+KY3l4WurrtWbWaqzJUgFaadOaAQw1wDi/fMDUp1aS9o/Mye34HRyXbfojk5/u/PPWe38p123tH35LWJEiQTjCscFwZ9rXAvf1OD3UITgRdNxuHlfBCiaCTrigxlLkMUCGOSxigArU6NaTMdCJ7nOWWMZzPka7bljKPqnQRS4Y8bo13BB2VBBDI27RMtrprhy3y90QgfhCI4oKeKcKXs4gg0Se+ewXj+gDIKxiFF/9iivEKpHziMUiOFBxDGEUYxiPNb3p2WUt3LsaCnaElmjp5QUfYAtgyjeD9XXta98KV7nsNy564E9/gYRbIPtXSH70bR/t4EYiW2GveykQkpH/DA4EzzBJSJKhgbWx4OOmw0k6mQIXd3LNwjoBwhCKsISaAt2fzsM6FuZCPhEZ2ceEgYmK3BCXf3DDETTVsfhMQ4gEUUgwibg7myXxUUpcooJ60iBR9axVF3rEJEKxiBJRsXpg2YIYU0RGqF1Bi8Mi4/W2kMbuee+NKlBntNjYFxTAYAZ2RJ+1MlGIs3lLFEaqXx/9yE9+AnKQhCRJ2+5mt/7xLV6JjMci90EvA8ahcIbTFwJ5g8mKNpCSELQoAy26STNQ0DoE6wRSwIQnCl0uhJn7Q+YUhZFVohA9rvyODJ1xulREQoaW6IgbeCqG11GBl5/oIe6W4QujCtMXRT0q/zCL6a6aJROZMzGoMndmKm9QA6utypCJKPGrrVgPfD34ihibNqNtjjF6VUvW1rDmrKutk41ySQs8ASPP8wWCFngljCh6MQ9WhOOv+6SMPQT7k8L+c35xA+geC/quc031G/NIqM8YOg9uYIINhaMoRxl4yYm2YQoTDe3jMElaMnzUDBvFZJsU0QlcYMM1X9JGhVrhCOT0B2IasY5LWdlbjgmDPBoZBaWu6ozUvSIVhsClT5l7hDBwp4c9HKZRqXtUhxBzG0R0KlS5212qKvEyz5TQVTeIlOOJoqtYrN5dqHZW6SXLvdtbI47c+D0brVOty5qWHc0HhrP91TD4ZAVhD//bzyUROKDmEmiCCwkqyQbwH/uwx4MByI16+UGiF/0saFU7UY1yGMSpLa2IT0viNph4tRT8KB8wRFLZasNyjsAES3dbY9+yUlMECW5G2oOMa4QDGsdVbk/FAFQje4SF7zHqLKprXexmd7vmcGpKvPvU7y5Tierw2cGqUSELeXWcatTLV8ZKZrKUVWs8audb1uxGuM5VrGuZwRXWUtfzXSsQ+CwEt1YhiUwM2LCGNTBiCc3gxB5aJ5DtzIK1dMjWWJbCFSbGjHljHc5e+nGTBPGmR9xpEqPYtCNeoCJK8QtgaOM1Jf2FKWScWRu3dGOYkiFFeDuKlnljP5iYMReIfOT/HSa5dMMdbpOT8eQoH7vKyebdlbMclL8lbHnpRWs2rbcstYyVrOTM2ozaHD68rKCdKwgrW6oHg3L3gL9m49bX/Oy+xQS2wIIe9LwNzUw+jmvR+R4oo8/haH4Exd8V5kYjMexhBHaY0wjv8EenAGpPO1zhJ5Z4G6boWmx8CeM/+0XDdEPj3H68pb2sZSo75SjkzngObuDCyo2sw9cFWzzDpq6xH4JsK9+8QPxjNlWh+ezmoPdXSxP60sxpTnJjO63b5nabb2TfNzd9LV8wt5zN9zWwoaF8kqBj+9L2VwTTuzJfl4zYDwx2Rtf7SZxBtP0i+2iAVziRiaRGKSxtcOBA/1zhD8ek3qvw6S78vcSBn3hnkQMnDP1iKfjIeJHaV8DB0Rjy5kEuf2qNDFfe1A/LVQJQawBUn/oJ5jIvNs1p5kKcLxtUTsRy77T89mc/G73SXlqJwmhua5Pb9tNKK1i7LV++wNUCK7BA8ME9Vx3IGZz+vRbWwXCI8pVNEmO71mLIPhkEk52w2Ze32Q282H1zv+wLBj9jx9GPQ/YjHJGOu2QZb6aE633v0xO8xLsQYr4DHv/5nz/CE6gbQbiWF2ILHxRPG0ipgCBPtySvFTRB8lTnFp5DuXRoCJRgCGqABW7AuZirEV6J2IIJ2YxJypTtqVBP0SJij15ioVLw9RKmy/90JeiEbhHGqJzMaQbLyZvSaM3UzPfui42ID9w04J2QTwfACQ7OR2zQh46upX3Axs8yYbzi7ScmbOymMOyqr/rGb+2wcCS0sDKc5Px6Ju4i7MFYBRcK6MQg5uAmzu/gT/DY8LSsQP/gMA71j/8Mp/D4oOJE4dTEYQDB5Gc6ATkiryNKgeA28D0mL7lSjvNswAZYYARYwAikIBLXALqmK6lIb0ts7vROQgQ50QSj4QTrIUJUcP18rsuUZmmwogzKYIx0z9yorSvoDAfXTEbSLNxuJK6Qb+jU4AqEgI7Op7+g72u8huvchxuu0PqkUBmXUfuwkAuf0RmbafvGxfzsgRj/0u/RxFChWIXgVOz96M8N6fANnWAN5dAc55DE5I/whGM4pigUEI8P74EA6S6khuwPCDFQIFA7ME8CfcAfS8ARIXHl1mADpSuIMHFmNLETjYh3lO0TFSQFtSweVtAUhwIVCGEQkHAMymAIp20Ih/AVZZEt4ooklc6NbnFZjk8Hmq8QLmERyiAj+ysYzcdsrM7qLkQSrvEJe0IU9YEZqxEol/EmphEaM4MokZH7xO4oRdEyFgqwKkv9goIYptIR6s461rANwzG0Qksc5TC1zvEcvzIsxTHTRs3/8jDxFE9MzGAO2pIg8XGlRghiCqjI/PEfAVIEOo8LHm91fqmpYkYh/0vvZbhLqjxRJGpuBLFsFEmRIgsQGwrjioBRBzhSByrTMj/y+ODJMsVM6dYCBkqSJFeA6synECDBFU7TFRChELBObFjTbOypJdftJidhFXRSHWQiGYNywnSTGYkyGnnSGZFROKdxKW0i++jh+p5JspZTDM1PKqeS1dAwDTMLK7VyHKtzLLMgO9Gx/uBvX/DwDvHQFJaCHPABGxSBOglSEpJLt3iKPeYgCuIzCnzgBhwxA0QgL6XghgrSPYphZJTKyYqq2IooMW1OfxYy2YjHJ9XBJ/+GMf+GywojBsvgfCbzMitzDDbzAzRgQzPTM+ls2zyzMmFgQ+XoM+eoF8umEP9Qk0UDIQ3CJg3w7DAuoSVn9Gt6IRMkQRAcYRhYJUKMc0F/kh+C8vyUcfuQMvyYUkl9MyeKU96QNEmTcUmJc0nHDhQlJOCW0/yAbCqFgWE66SqpExyxkwzkjzv9bjvT9Ez3T18kSDfA0xTkoTy14cLmwBCQyzpuKAw6Qpfk8x/xMwTu8wKT4POgi4Vijsk6cED/8ocGE0Gp7CGv9MckFUEi0lIncgW5TBzEoRdakhXB4EI3k0RRgEMtoAE04PhMFCTZwjM10zJJVEQts2wQ4TRlQUgK4UVftDXNBg0KwVfzLM+ypZ5yVA0QyBEA7keB1CeXsUibVbKUcZ+YtEqlNTj/m9RJpRQ5e3JKl7IZj2FtJqwUvzAapnIxWMdhrvLuyDQr1/Q6xVJN37UrL21fOiHxtAGz7LRhVGZP+8NP6RNQ8XNQCxW6hI1gZyGGElVRiQlAJwU+FJZRYQYkIjZkJnZSK7ZSL5UU1YHLNPVWV5EyNbRENWD4TrUBJCBV5ehVVfIjhaAyZ0BV44mO0sA0ZQEWUvNF0ads0GdXrS4r8gxHsYUQ1CAI9vIXUpBKXSIKd1NLl3YegnJ4hjNKA+1a521qlbQKtVVqgxRrx27CrnQ3m3NIJcRbvbUVynbGpLM6x1QdBY87+64c4XU7/Y7TRouzHAEY5BEbpMOWjMw9eUo+//92T3FoLgmxLw1yiAT0ugLUYZGqPmAqdMBDdRjWP6PLh7x0GK6BYi1WIiOy9d5uY3tBG8ThNBEBETzWMjk0ZDWgAUxVdS3gZD8AQ2NXCEDVZRsgnm43nsoGEmbWRdEAd2n3do0wbGyyV7DFJYM2CIhgDSQBWZPVJ6dUaZ0VbKEVaYnSWre1GZU1W7HVCqc1a7cWe6M2aQlMKCfVWQlsbC3PbBtGcMQUTdtVXfHPbdsWbtXU77Yy4t70F76EFXQtAveV5MzDEHDquMq2FS4Xc3/odmqnmBaXgQ9XqUYBY+yAgivYgvfAhChmHw+Rcit3UlsPhEO4c5UjdLMhG2ABEv901UJ1AHVbWHUb4FRPlq7EqGyKgGVL9XfvDBGCQRYggUJxN3ddc1d3Vfm+xlezhRC8wB/z4BqMVmufmFmZ1t+UtmupFoqvWCiz93qzVyi3d2u1j4uP83uDlFm9Fiib9icSeBWQqxRuyn81iTq9QI7j113jtX7vGF4h7rNYAU/YV5X2EblmqGx1wVuJoXIPuXIhWJEftohMz2UUolBCB4MpuKcq2T9Gh4M72GWaAXM52ZOzKqtMTRxMOBjyIRgggXRX0YZTt1Q5NIblzDI9liNvWDNZdnZnNw1o9ZRnGYjRIJflAJjlIA1iNGyY7xD87GuEVWhdgA06wWfiAYvFOHr/HW16tbSLpTFre/NphbRqw/easTaMtfl5t5d6wbBIxfYY1ljGdE0T2tmA3Dd+8Vien2Ce7Rh/USwPSo0YGoYQW8aHMjd9LS+gBVqBS4ZRD5qRBZOBE5chKsF1Khmi+TSFJiZQ3Dh1MIEQM/rdXAEWTJgcTDkYNqF0V/EyS5RES/QyPVaFUzZ3gxgNgiQ1ffd3hxlYaxpYlw8jDwEwnC+P8okQgmADXEAQqEGRyJg3x3eaz9eatXYnnXdZ0Riqkfqosa969YGcozBbwZibs5qbebMabRNLnVKNJYWd29mdISqO33Y7T4x+wVI76Rmu6/mt5ddM13WOxRQTTMGAh+HW/z7xIfJjdwx6kWVmsAXbdh4YyvYmsAvb8uBj1hp6hCyipywYt3jrUF7t/2hhUzs6GD6aHEJ6E0Q6lUk6lnWgCGR5FXGVI2G5MrGOZdEnDYKkU2kXl9MAmG06z3zVV8Hma5wPMJDZeCfhBTaAA/qgaKEZuc83m6e5mqe6qcXLJ5Iajbf5jKN6jMdZnKV6q7vaq6uRUpMVsBExUJRLEw4ordlVruc6rtV7vdvbvaGArun3rqkzEhyhnw25IABbvwPbW4eov4kqZhL6sAe8URdbwF2GqOrjYkLvEB/7sROlLTNLDYDEFU44GC4cwy88tDecdFOZdNPgV0eatEtUCDhSpv+nRUUJIxCYr2y8BjZ321dBHDYJwZ5s8lfo6WuEO6jf4LiTu7qBkrp/PGylG/2cV0GJvBrHV6m/GXyRWru5u7uj3GIn9b8dAhFVigEPKMLVOr21wK3fG8y9vMvh+0wxKBVKwcf+e78NPMABnKna/M0L2hoOnM7z22VC0M7dnKABnKDNdcYwQQ0OgRZqFRYKvbMzvNA3XKRDu8M9nLRd9bQ9VghgwAJgwGt4hRbAZugAYRAw0iaT2XhB/dODjp6A+gKmQBKwwced+3rfIfuYFsmH1CkZtKmjt7mZG9bDObuhPMp7vVl/7DYlgnVswbElRbwNoSKGzIbmW76bfczD/Nn/UwuX5vIjJhYE+QfOsx2htV3Oub3OQfDJ5NzaoaFSBrpsL4SvCN3QEV3DNxwSRLvD6YCk12JDSzzSWZNlXdfFixfMqCi9SD0TMDITKOEihTXgQ50QqgVY2MfUT4APVF3Wl7zIsXki7YFVLN55dTNZgwLXwVapI+2cr/vJeZ3khZwfqPwBGeJgBbmdSc4tB7KOnV3mvxzaa57mzSiPpX1w+3rNCdzbDduwtT2xhd7nv73A7xxix92Y9KOQQWkP1X3dM1zR4910WbhDJxO1ZTqePgCPeMUFqegR/D3swd4qqoWaKGGrgDbhryLo1ofTX+ABiJsNoDLi0W/Xd/IYoxqd/9cGQo46yCMNwm79/KrZybW65H0d8fuhh65Bpjwhhgj55Bwag+eghl5+Dc5bzG9+5jPf5jvf8+ObzMVc5wf4FcYW3Iue6FOfzY2e9VtfzZmer00tdG31NHf33ddd0UXbY234QrOeI18WdrdIWMee+BVBD+iERXZ0mqYpQ1hh4Lnqxq0CDrQOWAShBRIg7rmAqMPVuZn6Can4CU0fFCte1ickaQE/8KVY/Zcai8vv8BO/7iOech3cn1keZdxS5W6Iy6Od8wHiicCBBAtmMYjQisKFDLs0dKglosQsa8xU9GMola5j0KI98zjtmzWRI0OaLIny5EllKlM6a/mSmcuZMv+n1YQpLWdMnTx3+sQpbRgrYOLE4TPqKqkrSJBgBXu6KSqiqYjKWC2jQ8fVq3SuCpmRFUYPsGgWXbpEKe0jPYAUrX3USc8kQHDddnI0KW/aUKzUqj10SBIgNXAIC2ox4MEGLb/ktXsMuV+8yZTtSa48OZxmdtzshfO82RtIZBw/8zt9OrNmy/Pm/XsNO3br2ahr28YMz3Ju3bx7X/4NPPjt4K9aCTueqzhp0q9SkdJUac4cN9Klc7ku3QsbNhO7H3wIMbx48N4Tmj8Phfz49VwsmsFoKRVHj6NJ2t92/z7QZEDx76dp003//URggRx9xBI0pHGjjVH4kENOMLJMKAv/U07BsglTU9HBYRlpdPUhVWlspcMHWVk1BhxgEHJWJoANVpdca7kll4ydxKXHKTp2EspffwkmSFuEIaZYEKw4BtljuOnDZJOXcQblZ95EmU6VonG0kWm1+YZabP58Cds+wwkXnJO7cUlmmmreVopyyLHEXHPOVedGndOFUVF15aG3Xp9+5sBnoOr9yZ578BlHn3/5KYrgfQc2+uiABQIoKYICXtoTgXDKJAwx3BT1IIT4UEiqhLJkCAlViIQ4VapVVYXVB7JqNWIZgxBy661rsQXjIzTCBaxdPCqCiynG2ggsXcqqEeQXFzyQwAYuOMJNkkkuyQ462oa2LZWhZXvN/zXIbFRamWeeto+XYMJG25Zmpsblu2vOO6ZkqBn3ZoLjNqdJv3/sMd2d2LU3x57pHTyonwYLmlAQDCe8EMHuSZcRuYkyivGiItV3UqQZ42TOx5ViWuAyJG/6EjGrNOYgPqNOqBSGsLgSFaqoaqjhqlthNcNVI+L64rJy2YXsjckaTSyxOyarrCNBCkKYFxtAq1gbpvxCDdbqbM01N9yIJu5xYnc0JZW5bU2ZO1cyJ006k4nJGm/pzg3bunBXBq9m4LgjL5py0wu4bcbJeRyW/PariSHS1ekGF3YWvMZ1ki+MMKGUP4w5xAoflKchlWAiDNkaj74opCN/JDKlp19q8v/JKR/ICiu9OJiNqTAvhTNTTdW8yVIijjhGVloJAcbOQMPxdB+7sqWIIjUKC+yNzed4itFHAyl0DlQrpgUmNw5jyjDiN3ON+HE6R/hx4UaZNm6aHaNL/KFzVi/d6r5Wv9r0RcO3b30HXr96GQcT/ZLEKg54OAJaghF2uBMVGoed6kyuPZbLnOYsiMHzGKpixLgY6UhnOksNCGOoC+HqSuY6TnVqZQ0aFT6CkY3azQwRrmoVDZuiOw0Vgg5pGFHxwADEstyqRWpJXh/04DxeuaV5RLtLXm4UiuaZAnpHE5oezsABBSQAWhlQAhsyEokwgkKMoCgj+j5xRvQJYzO4uZb/auDXnCy97Tb28xLc6qW3R43DNH4DYADTpDIC9kuNCbSE4qzjOCXgqXFBkIISrjMEImSwcpfLnMMmWUmJvCcRGglXNz75sQ+asD8zSd0oT7kcTrUuhao8hsqIMqFRRUiGSUkVJHCnITkEYpep6uFWalUIs7QILUUUBB+OiEQpSg9ZTpNEKYC0xCjioopMW9YUnnWABGRTWo0UwyK/uYY/wCeMBGxTKtqkPq+pUx1Kikxm9oW+jjhpjrOx49wAmcdnwGmP//PjH4WjjVWUU5AELachFxcGKjwQT5BUaCRx4AMmaKeCmGTYJZlw0SZI9CEY/Y5HMxlBQ0SiFMMAG348/yjKU5pypSxFpU/GxTpVwukYK5udy0IFIVrWMik1y2GqOESHQowoDYUoajCH6aIXIXOpSEwmE5v5TMFIIhRGM5YyrfcWXinrmonJpmJK4IOwKvQIZC1rFPCEh0bE55zmJOT8NEMNtLFTNWFzTr8WRM8u0Q1dtPEfk0yqDPmVzZ+Eddc9tCEJPnhvsQUl4CHdMNY6UQGiDhVrJKdgBopWFHMZ3WhDOprBDUZifihNqUtJGLKWntalq3xpa2eqshaGKhgQekrtYhaVW14ol7vsbQ/TsAirrGgQqHARJXY1vT4w0YlLRBpUvVfVKRoLq3BhHlO1p02vSms7d7DDNxMKXv/qpJURau2X5wxpiZFqJJ1z7drW6rrWTsaVMve8I1/h1ZvM6E+fgu1fYf97FGBI4osDLXAkHntWRYI3ko98wnYmqtnNBqqzGq2whLuTWYyQ1JOiM21pS6jaUII4QKyNCcpYyRKVxcIo2YjQU16sU6VYaLe41JAvgUgYOBBXFD0SUnKvehei4QWqUo3ujdo05OUx9QwnyGYBtMk9RyA5Pug9sFoP+q/uZnnLDcQIGju5PvdaaV+GJOBb6ddXPGJLW6N5BUv42cf/1stl99iHIC4LRgJKwrGIrI6ft5OHQLehDV1YgqEjfGH0UPiCIP1OhkVaCg5/GBweJmU5UltpR6H/UKavjWlra4qPGL541FCJhW5PzRTc9ba3aGi1ENQABh1norjHfYsym7tcKRJ5yE4zcrB+fMQ39OENXH0ylBczVXwhxxa3SOMnzrvlLa+BceL98i3UF2YOCyMVlSizcjy1zjaKu337xdJM3xHndPvxpvjQhhrEOocCtmLPiYPcF/lgiEAfM9+ENjQOSgBWIDCakgTH5KITTZ57X1vSoKR0wzMNcRGX0GMkPnGnOf1pYmjDZbUl9YtlRsNa6i4Qrlp1IFoNxOKdBRXFNUWy7EJFXDttsZKouVSfKeVO4HzmSxX2sN+AXWNv8QJaSLbYrt3spKPR2ku3KxoPCtmop9UT/5xUoyc5zO0qr7eDcWWj+87UpGyJfR0gKcYuLMbHealbTQ+iMzcwwQUiuIALhrD5kA0xUUAP+sH/rkEJNgD4DIygBJ5FtOEtenDQFj60mwQdwx0OeYmPOMQghJTHHmXxTXd6FdRoYYs7no+cxljkI1eVUa+icpa33FesD3KxFDFFmTcTEzyX6uxn7gjaL1nYxG4BtIQe5fAdfdlIV7qzzSi2BTJQDN0Vb3fJu15sHyfrfmDEILFtpeyX7VtgP5vamBG/s6Pdr2sHHLuPElBBsOGScfjioAUCUUk2Mv4pAPgIBJ8Bqgl+4AVHuOI5+lEV9Wi38HiRF3EbI3kZ40EIQv9xGHdxDrhKncIgHBch+RAMFpgPGZhTF0JjIrcUqiZUtsIitEBrk9A8RyM9R6ZzQXZ7tdeCivAJzaNYTDRsx0RsOYBNwLcYxGI+xlB8zMZsPrhedtUIWxZfxgcKRdh8jENeavVtreAciiNOkGYcJXV14hIuXDdYYhd248BfufActUAu/UOG5Gcu83J+bscKfKAFEIVRMeACcSiHcAiH9gdwGJB/FLA9D2ADh9d/FlY5gHIeiQeAATgogPgQjUdakxZKjEh5CoglrbAKsAU/macpD4gMq+Aa4vB5GeiJngghoediHzczShEzslAItiJMJNhjzGRkQvaCQZJ7tMdzNDj/gzJog2cwBSrwe8b2ZBsQBH0gfKsUhMVojEC4QN61SA10hEqnfNPGOHsAfYgDdRRTMYVDDB0EO1cYZmO3NodDCr7AH/yzhZ5RD+dYfvFCDm13fgEVB0wgh4CnGBUAAvVYfyaAj/WIh3uoXTvgf//4f4ZoQQNohQ9ngI14gAloE8cxOOKXSg9pYhBoDJ/GeeIgCy+GgS8merTFkaJ2O6c4IcFkK5fAik8UPVBULL7mNDunZ08TRk/FRPt2TH3AB3FQk2eAg1CWXds0BInQgxMJlMlxjHESfp6wfOGFJ9Z3bUGxbFbGQH/wONIhTsooXmvVkMomWD0hGmTnhW02SGIo/zqbQQ+8MZbpSJZpSGf3gArvGAQxII8OoF0XUI8cQJdyiQETQDVO5lWEB5CI2JeLhzkKRz4HSZiOiIApNTo2AT9QSG9uhpUQqXkPuTKfQiFQwYGX6RS3hDNTUVScWVSXYCsjWZLUxCPGgguvx1y0WHuCoJq2iIsy+XO6KANatJNC15OdMAwRGZS7yZvLBoZG2W1XhnzGKDaTeDhSiFCNYyfh5DmNRTjhVzglRB9eOC6q8JXzoTbwwE/0wJ3cqW5mwiRpmA1FIQ68wCtkkAK9CJcPgJcVEAERUI8Q0J6/t55wWQEpAJh/+YcByZ/96Z/nUQd58AmkNZiYZqAGiaBcmf+QCDJAz2RgoJMv/JF5EnpiB7QKsFSZwcA7ueVTnhmCoQlEg1AYyLNjxSUKJvlE02UKOpKS0hOLxrRUMFmDMmmTbxAHX+B7temLFFADhoAom0Kh/AGdQ/qQRIqMZxQJz2FI6/URYdMm6OUHkRNOSBlO1GilzxFHekSO3xiGYAY23ZKdYQqeY8oO4cluDnIP5XkKlHBFO4CXBACncLqH88mPDkABglcDPyAQfMd/frmfhah4hPifg/oQeBCgA1qACpqgn6SojVqYk2cpDap7LzmDbTKJkGlxQQpTB4ShE2KZvAMJuqRLVHFUwaWKrXYrsrZyqxc9Kno1PdKizpU8urf/VImQB69Zk7l6k1+QkzqqlzeQCI8JpMMqP0BprDBFlPHjbE8pXtC3HObDmGJkSNN2VkkpTsH5leLokC+xfQ63bUoajqTxpeO6R2LafWN6D+yWDUdRFNXAildkAhPwZHGql/XqVXY6AYIXcEjgHn74p/pJqIDKOYe6cORToIsKeY76De/wqJW3bfRGo/o2UAgUnUVqdoHFNjTFQhZ5KhvaU6XnKrTwmaeHK8NECySoej2WoqzAosVymrEqo0ZEk4oQsbpao8IGBScAAbVZm3fqBz9KrBOKqUA6pMeYjAlVrXfghNc2PtmYm812YN11Vmd1rYgTjo55seK6pVeSdZUQ/67cuj9hW67mSqa4UA3yoA1p267uqiNs4QS86Iv22rP4igEA14cSkQdmQGiNBrAB67eAaqh4MFoG2zZbeaCFmbANK3kPS0652gb5tm96JqzLUazmtqnZ2CAd67Efm0OuEAseOrKXEEwny4o8xmMpuqIr47Iv+7KyqlivC5s1a5OCZpO7ODW+uqNsALRCy7sWe6zHyGzW+YxMWLXmhE5HlwqKE40U0239IoZxBJ1k40lCuECewKTSqSDY+aVc+FdcqLfKZSNycQhXtAVOUH+/R68CILf65wH76hABmquZlUn/anB+ar9/+1nvkVaI+l5shriJy7ABrLAOy5AwaKsHPP9ogTZOljq5lYix8TOJkhg72kAhm7uhqZYUHmoWwVWyqHCytGa6PeaqsEpVOiIsOveSNItvNTuTNHmzN3qjJ5CXCGAANWyvGWAGJOVavcvDxGik8nNG6AWlV5ZebjV9R2sHSbwH0ti8nBCGyNek1Dku1Yul88Ex33CFVXKO56h9kESHMvADO+CP5bsDKRAB6lkA6Xuv7PlV7muothoJnRAJkDO/FuQETUAG9Hu/CKe/nDSYVXJpAExp+jO2glx5mgaFB8bCtJtvpWAKgzN8WOkmxRE7nboJn1ozpFiKnGkWg4AGKgIYZ0GCpdsjT2RzKdpcKvpruNrCuDijjktoObr/kzRsw74oAjlcsZzmwEMrkcj6w9tKuUi3rFQcfce5xMp4zOSFraMQfVZ8xMoMls+6jR4BptqnLRERxnZYt/hYxiCAl3C5vlvEnoBntwzGnDPItHPMt3ZcBXossPj7n+c8oOoQyP5ryAOsuKXDX6lAqbpKu7NbkwwMydN3lc1hqSxzkR6XyZrsuZ8ZXCmnqil7uqY8ZDZnI1FELLJqi7fayhvtc0CXReAct7X8q1xQsBBYcT3cyz/8wEVK0EFsnVgLT9BxzEp8rd3mxFWstfokvNAXhJAZlmDacBbhb3eoh3fqAXcJzvU5p3ZZzjggBZ1TdUw7DK1wSBTUt++8x/Bs/7+GMs9Wgs/kioBh/WEMimQqvMiwiU6QzNZXuWeSQA1FkdCktqGajAipuCIQraofHMKsZ0STWhexd2sy2tGxC8NekAMuIK96Octzi8M6LEIqLdm8/LstvW3iB7xnN4RAXAvQwazLqMzErC9TvMyVe3mQp23OQNSRZNRH7dpHXbd1KdvSEodQbWidI0YFSz6lEKUVUcda3c7B7QRGcMfEfceAyK/Indz5CYjELdyE+sYE2L8NZ8/nUMgCjM8EjHNo3cqGLQjOhGSD80zQWwqTKgmyhZEWGAyhKqqpdkt3XQZ6HWs65sF8Xco8Z4N8oAaa4Dwx6ytLRNgx6sIw/AWI7f8CtzvSuIuvXOAIuakTk41ikdnS4SeUdmWdMS2UFA69zwtTv5lldmLTTOy1bhZYShramy2kWtoRD34LUsraLDA1rw3bJgDGOUADJ4DjYTWHk3PT1tYT2zYdv73Hx53Hd1zkRO7cRL7VXO2ffYyoV0fW5XrPHgbEjXtMKTyzrXzW4T3e5V3eesYH5x1q5PCJFsjeRSCqO3TXeJ1y810YZlHfvDDRTvMFeMcG7XfnhX2CsOiayZXAsWyXaCy3JM2Tgyvhhx7hrcObFw6unuDoj64Kmc3oT/xt32qUeECVdSLijd5tPa4RwLziYiOEtsAGkZMEQ+B3JRACd8rqIUDjkjT/Be/3hvSHHRbh6cymleWjzlj9rwdn3EpO5MEO3EwO3XWQVkl6sNQt5da97NktcaNOQDHb58vF5bnnoF9eYKxgFKD3YnJQBN+O5kFlVCKpIjo2ovTtwXJ+uk6Dbw/m7gnswsq159KOi/0Gxj7wljPc2IS+o0lg6Cmt0ogetLvJ6JxgCQaP8OCK2Zgd6U9cCUv8BwP6g0/3lDVt080bbdb3xOIYzMErlL3tSD4A49tsAyVvBFUA7ze5twIxMFI5Tp9eE5+kbYlwHYjtzlsd7L8u7Duv3D1f3Ehw3PiriInK7FPeqAqZDLqA7Vguo7jHeizZkjNHi5gQB9pODi3mcboE/+7hruZFFd84NqK3wnIn+wsn2kx4HhEFY/Mp38IsqGRHpFFyt491irv8zthd5JO5LKH6hOgA38tCaXa/6dk4jfDx0fBZm/SaPekPD1lHEAYRT9WrsOE0bfFTiczMWNq+mUbcBUkuwAJ5igXyC78xqcjv7meefr06cYVT5Ns3j/PCfcc8wPM+jwTLbfu3v+S13xBDT/RFj93OTkIpzS/0vpJ+zWstCNiYEDWs4DISoqHPvwla/+0hoksfMrKlKkxjzwtyPr4yuPLdoXeDdkTV9WO6+LYkkH+MrZ46meB2X8Nd9O+JzveJ7sM+uAyAvwvCW/iEf+EA4auYsYEFCRYklf+QlKVKd6LcYMHiiJg/jVK9wigsGTKMtRQ23PNH5B43JUuGRMkoYa5cKy+mYjNHphQfVKhw8ZMokqKdPDH93BnJEB9DQoceZVTJEqhPtmw5kxa121Rz3q5dvdbKTxYtXa18BRu2yVgoZM1WcYJWLRknbZ1scdvWjNizdZHYvbtjbF66TPzyrVJlbk5DqZxdpQpu3DfGix0rbgx5neRtlS0zg4r52DTMA1MB5Rk6tCNApE2f7qNI0GrWfIKq+SIKnyzam2xvkpNbThHectLQAY6o0HDilwpdQo5KOS1eykM9Up3Hy3Sv1L20wY5d9aNHelL3iXOmLQ0QEx44OJA+wXr/9e3ZG3APXz4C+A8yLImkMTNmzvv5P/MPwP8C3GgZAw90iiWCXvpIKQeVqkWgAg+aUJdiIlRFoYX+CAMiidyoKBUNM9zFoI4SUmokO0qK4iQ7QtIEw4yEiWkON25aI6efFCnlp0+C+gw0TYYkkqGlVrpFqsQSw4qaUtrgqgsp+8KrrLrSQqutM05ZZAoe4lqryq8AE1Otv8xE08wcc7rFKsoig/MdOd+E87IB/7MQo55E4/M06FALzbU4MCFKEzXU6IUc2mTZjTdHH+UtDUmHE4644ZJLDpjmTjGlO/DYmC6IOaoDtdQ4+uDOuzfEA8KGFDioAD3z4qO1AFvnw5W+//kewCE/qe4ENlgB76QQQQZVUTBDTpZ90KWB8KxwoxNZumjDOypaikEjj5wRGW9PRBGlF1s8iRSWkmzmGj9kunGOonoM8tif5NWQSGelwqoqdPa1ihp/qXFkrimpJNistrJ06wxxyOkyroOtPDPKMck8U68yIw7sKzHEMENHafJ9c85zQp6sTjsJVEZa0FQbbTtAWyYKPEHiOMpQRGeDRA4hIHU0jZ6DQyRoSy9N7pRTNu3kzzhKta7p69roQ4/uWFUB1ghmdeC8Wgfgur1bBQBbvrDnu4/HqIRFO20EDUyQqVGS9QjFZkmcMNhoU15wxlv21ihPZYmMsKNu8X4lQ/9NQFrxpEaW4ntddt9tBV56Da/WpREVzEzfdPjlXB3PseFFkYELJp0sI9hya5F8shHP4Yf1snivjGGXnfaLMQ5rjTXbdJPkkUU2mbHLTiYQox737NOR71ie+buY+QjPEDZgQ5TRNITYuYjcJNXNN+/TKKTS4hYhfxDyiw7lueiYdto67FTN4YQTrDbvPAXu3/prAvQfO9f0MMCCr7yltmERcBkSEkhL3LbAWSiQWcxCVi4OVEC73c1C38JgnkqULMFVDiPRqhxDSGKSay3OECLJ0UUit7e2VUtG1BLcBl+SMqlsrnOd8xw1cPGkiJUOYleKyxn0II58xAIurntdmmz/t4Mlpgl3T+SK7gijC5CVLE6/ewydiFc8462MecsTBKGcJ7PnSS96cVADN2SRCTTsTDeB6F4cgUOpQoCvDGhYBB4PscdJpC99k/DU0to3uilM4VRv4MGrrmYe/DXyPfyDZP/8lx4K2CARrdCPATWJkAY2ZRSf9AQD/wbBBhojQCizIN5SmUq/LSQkKongZjZ4EGuZpCSNWFdF+NY3Fs7SlwYZYDCVZBUbFtNzzYhKKXq0Lq84sYe3a4sR9BALaq5uDG9xWOzOok0lcpMvQfhLDqAosRANo3fAQ6fvLLPFAFnoeDsSjXe+CJ7nQc+efFADqL6wT0loQxyEQMNv4DjQ/4Hq5jeS4h5C0YAGMIABDg/loyk6lapPDfKHheTBCuYHAUc6EleRBKkkx/aAFFxyGKjUJLF20ckRLdClDwxlKScooHKglIayVGVOTaTBCxLucK+sxEq+NcuhigiFuMQW386WyWL19KabgYa3kJkuHOYQmT9Cqu42xgWu3kViz/xhX5xwOifoIRv5IIc1kSi7btaOrd4cp1fTJEVLlKKKVsRiOrU4FQpqJmV62pHykkfG552qnjLZJ6gIIYteZIIQj4UjIRBaR4RW9o6SWmhmHQqHN3AWEN4BbUWdxgVw0sC0p6WfR7v2yJCKND2u3V8lL7nU/qRUpQqUG0whGNPdvv/NKTO1aW07o1NWNlWncXOWDGfoTmHs7ZO5zI8wpkpb/0gVqtHAbnavYkwbIvMWnwAFLrUahq12dQnOBKKVXuewM8QiH++lZiwWcU0wvXV29rUYXCtGMdxJ0RCtuGte9Ro8dg7XnT16GRj5QE+a1ZNmfvjCdBTbWFEQghKPBeggMntHMJShCGm4rIeF0MYON3QMV1hVeM6gYhUTMlQykJ/8TEACjh7Afqt1LY5hG1Kx/a+kABamcG2bjATmlhNJQXJvQ0lKzA35pgYmbnGdulNqwbClTfmuCNl00ulS17pRhcZUetek7l41vIy4li3JS17zYsHNX/WhwRx2irO+973/5IiFHuprpj3j5b72DWdcuTrFAA+YwAU28CskEaTBjvGeeTCsiqU3nahpSjmOlYQkDvFQTjfU0x0WgqSwhz1Pc3YL+ywkdbIzuiCEygUguECsZa011koSfzzGtUgfUIM8YDK4aisyTPfQECQXOylK9i1wT7lsIUNZyjyNciuvfOY0m1AkfgCFdPG1bTCHWTFjxkq6muFcal9rY2pul1bffF7+QvPPW3BvWu1cxIa5hYlN8GYT8Q1oP7d7LYZYnDDC4Q51FnxJFMQpQd4Jz9Y4z8EsljQb0CgJUdCCFqJgBSsooenPCuJQnYWDQ4UAhlFjr40jP9SJe4DRh7G6tDhw/0HMN8BR+9HaawLQlY5z/VGQ1qcEbCiFtp083NwiGajGRnZMJZQ5azC96c0G9pRB6MsY+vJyJDLqjY4QBaEcFV3N4LLQDxNmMh/zGsMgtyXwkOZz32G8LCpv3NndZn/L+b5tMSs55I3WbMh3PEnkszNp900gCBqKOfGDXc9p8L0ym3BdhOeCo8Nge0rasEdRgyAoriluYPw5mpbEalJ8BR2gmOSjzmzJdQAD1vfgS0AUZxBwAPNXb6DmrK31jnf+2h2vpwZAhyrU+9pOZTELzcNWytGTvGSlSxAzNXX60KUsrZW+0PrKxTrWwcsJhxzhBkZBYbanK91PNAmZ6WiH2f+bi1UU6g5EbtfqeLm6VTfMX+50ByvgM5YWuZxi7/POBj24N33bN9gZwAOsO8OLEjzwAx4ptMngnMYbPp0CLDG6J8KivKPIjgZDlV/ABm2ohl/AhT+iqKhZsVM7NdbTgRmYAZE7PRZsvYyKvdIKNNNSpFi7sRzMuUnqMd67ud0bqQ1gA0yAqrpRJeFjm+J7kKNTvt6KEGV7uiiMQuFBNGe7myLDOl9ooOujnOwbJbWjAhZgvxL6uqn6lxyyKnLLKviLvza8P/t7Q/xLQLJAommaNzvDsyOSHXsbD31DwDnkN3JiQIFbPMZLjAl8vFcACoBjAzNysEeDMEh7MO0wBV7/qAZ5CMERTBqKajFscr2M+gAYYMFRhMHWW4FTbIHTOq20QK1ZmxXV2kEe1L2vqRXXIingGz4k7A/kMr4HaZZjY7InvJOq2CIprC12kjIMYSkvjCBlZEbK0TKuMyFLEIqm4DJkwgVtawbwyjLHySU2dMO4C8f6a7NynLv8Sy8+4wF4u8M7G4Rs0q/aMcAEBMSwqAOTKkS8gozsokJETMQgYURTgbSH28AzOhVH8MBqUEhOmSjo+BTs4ENUPEUVnIHWM0VUVMVVZCIYgxUcfMX3oA9YjMUezB+S9MGwuUXDoKEC0UWiAyXdgslgbLLoW6fhGZmmu0lEk7piccYufEaf/7w6hji+T5hGEbHGsMuy7VvDa2m/cVQ3OIRK+jNHKThHdCyTLxkDWGjHItJDt4qdPwzEJyq8vkCTjrlH3snHveJHf5QhRdSESSsViYMaiDPIPIjEPFCETrBEheQFXNhEwXpIKYk9FaiaVHwBDVDBUGQ9FJBIw5Q9GtzIjfJIHQTJkLRMWSxJk+yakfo5Igy+uhEy6GMGLZy2Zbm6T1rGEgEuYrTJYjTGKDwgBAImg8DCn6zN0+zCJTOKRLgIbknK7fOEtVu7a2PKtXPD44zK5JzKqgy0fkML2vmSMqgzANSzv/u7+/pK7KTH7SQDwWATf0nLtTw4RGwlPWFEmRiVp/+RS0GimTYYikhDyA9cyL+MDkkMlcEkTPl5gRUIxQ/wTxjYz8bMSNMSp/zkgNTqqMq8zJHMscykxdUiqTnAhFVYBdA8RuIhTdvsyet7lgFhzZzEyZwUUZu0wtmkkA3dUA2NG+QynG0Br0hYoG1BquH0RuE0TuTEUfpjM+VUAjmcQTHhptT5P/iiL1a8TrAMjOzkr8Jj0u2sg0ZMBWIAmUIcT28LskSMoM84z67oKsSSOA2syzzQS4VUyIliGeiBSC8pi/jJyFNkTBTQgDdlzAB1zPzET8mkOcoUyQXFzD7VzFsMuiuNutTEENk0VAUBpilsTWsA0RAdUQz9JQNLoEn/RdFKpVQsZAmdMCFNFUprs9FPpVE8MIMcfco45IIdpYk261HmfILmLMC6eD0eGINYGFKu/JJY3Tf+G7wB3K8m9dV69M7vLCYqFU++SjgKjKBFM5St4FLZ69K4bM9o7YOELNNOcBlFQNMpudM2lVPG/AA6NUzCRMUc0CgZO9A83VM+VVce9FOuCQDOlNDPbElJfSETtdfZdNSafNTX1FdIvVfaPNSALdR/dQqAs7ZNxSVPxRYGrFG2I1Wq5NH5wxElmFiIJS3CA6vn/Eq3+BJ4G1I8K1I+1Fhe3chf7VVgNYuOyY9rHDhwK1bsUqnyBKy3FIn584HZ61IJA5XKwwRq/+UFM508KCkLyBxQ2csoxuwBNwVXO11FwjxQBL2fj1zXqaXadl0tIfRMC23Jf10b2uzaA/nQft3XsfVX4/pa2SSyK5w+gjjYtkUq8QJVUAVH5LTYul2zil3VVLXZuevDPdzDIG0LrKTVO8zDW91YJLABjF1SVmw3kmWrjGlEaoRRTJLSKUUMK2VLBnFLQkFP3bGJm5W9IeiqrpDLBdtLbBAFPzFBoSWC1h1QGJMBvbjVL5FTG8hP/RRXNsXT+olaqU3XqgXe3OMaBejMY11JXQTYXwpYe/VQsSVb5zWH/eDa5F0lK8ygYrnHhHXbtxUvuAXVucjRdavbvdXbm6jbVP9FgnM8He3Upr4NXBR0L8I1IlzlC8bNCyQ12ca9u9xpxFH1L2qcoY+Z0m670vIECkKRnlE51Ztl4AbWAqjJS1OQz59VXT64z9nD4PykAdvdyNn9EhU4Wg0WYaflgKvJUz21zN8N3nTtseF1AeDTWrbkpMCh4Uhl3uZ13nzN4ZPx2rPVWuutoGJJ2ETw1BmdUYaNW1EFR/99Q3aj2NbN2x5F1Sh2YiOQq/Stkntbr3Vcx/idt8JlXPxV3F+14vR1XCN9VVLxX/NlM3cBOCxjLqG7rszwG0b7iaOIia1iYHDqKj54BL/Ehb3syxKsqJeD3dkjzJKV3dmVXRuY0xGuGhL/gFr2aKSrWdAEVVcVpmThNQD7gOHjHdQUpRtEnV4cZk1GReUdJlEfvuFWHrK3ZcBEyN5P9d4k1p3B0Cr/FV83G1/SamIqdmI/1LfnTIsPvlV4m047y7P6GqtXRdwxHmP7JcCUHYzkrL/xuoOiHJwM6qJ3OgoivoMaGcLVAD2JGsHmQBrUgJ4LjjnDjIFD7uBF/mAQTgFIjmRY88ioVVDfXWFNxr0WBtRVOFYkvE1m5NDYvOH+UOXnXeVSNlvp849Y9tR7ROIkVmImLtXl5GWK9WVg9ugqjse/BVz+e99YSGa04oWu7DOvkub8FWP0AotqtmZ0W4MXMdhsUSa+6eag/zCNH1ENZRpBPzrnQEbn5vDL0xAkv8hg3IVdRZZde9sBjBThDnjaC+Dd9cDkFPZnBuhnBu0fXokEgXa82rpUgz7oYgFiU05lhm7oh74biA4W4aRoi7bl8NXoj8br84LiHwhm29FYfMsvedTip16E6dS7AAQTG9C/lnbmDt4Lx5bmNCZdXbY/Up0J/0K8nLCEomgKFWoFUxgGiRLtQBZB0hZBdAadQVYa6RhV1xVheHbspy5mED4tEa7qq769j4yArl5hWXHQAygbXxtrhM5QsxZGh05UtdZhtt5F6n1ruL4TupZuu97l6k6C6y7fvMZukL63P/vr7Gxf/vsS8jFpZf8+opC+Yqf+wzNubLYyS8qu7Mt+P/lmw8yeXKAeBlwghl/QodL274zz7+aY4M/7DtZd6hjTT6d2HUaubXO1an5WUN62TK7O6giPxZEKAkc4qegd64IeZbR16+eOYeZeVLJGbuiObukGVVNlcZDWayUQXe3e6xlXb5gebCPVYvYCBDpbHVah3/ROXDMG7LGKbQUvcmeS6UHL0cfZVBXK7yev3Gso7bMjbWLI79IGcKIW5J+VmvXRAkOG7QHlgcLj2DGPZwQ/1xOuTBSW8KmlzMzMgCcI1OH28IHtUBHH87Qh8X40cbNNbgMyXq1V8RzB6IyOWOt+cRlPdL7e6zIu4+7/ts6vjEfX2YJFoKbqDOz2RtwxV+wwPvIdKGNdTVLJFgwyaO0luGUlN0si/gn8Bjsr128plfX95m8qr/IrH2otR+ej5g7lMfAhWOoM1khcjchURPPU0kFKqnAIz+Q218wNkHN5hdQVPesJ+tpr/+HVXG5+/bUQ1/Nu34+67pgcIXdE72VzX3RFT3caH3VtWqK+/W7ZtjfQQm80Vuwax3cEfOyI6c7uFNWMWRcdUZ6m6AQob4Za52+Dj3VcN+0RbPiH3/WGBC1QCV1hL9rYM/MFNy2qxufJtPCPd/bVGt7glSRoBzIl6SvP2EIQt3YjdOUgvtA931pv/3YD8s5xxwPv/yzVNRAMjb7rdQd2Kp5xGH9xGgd1I0/Sab5xs5D39Rpsinn0tLj3fP90yTYCK65mvOyEUgBtWv+FV/9vsId1Wif7KY/1r/dvhu9LLP9LC/YC0tpji4fO+l3wRLoAqoYAV8Rq9/DnXGn2kH9QTwYwmC1bG87zKLNCqGPJbef2mad5YanCAdH5ce/5nf/5c193oA96Gt/8zj96K7767nZ3SWfvpl8rJD1SK/b0I2fsecRi1JkLqCFt0Olv//aXKa99s7f9EexvXC/73ddEigIVuI97uTdckg4iNZ0fjvd4kHf+Nu/7k+SaEcBFDk955x6utD58mNfhxnf8aMv2XFQbjv/BAiZu7RY/r8tP0vUfes8nes5ndAx26kdfbyzZJmfmQ+Q/3CWlf4CwIXDHDh5OCCJMqLBKQhtODhp5qMUMGz6TeGH8pXHjL2ocP24kFlLkr2G4TpoEqfJXKFOPHinq00ZLkJpDfNzEQUNnQ4kPHTYx+PDMm6JXpuQ4IaHDBQgVHiSAGtUA1apWEWDNqlXB1q5eB4DlOnXsgQQFzqJNy8JQq2PPtr2F62wus7rG7CbDe1cv32V99wKuO23w4Lx+BVs7l3gxY8KIHT/+KzkyZMpvI1fBs6aKGM4UN3MWY6YzZyxLuJxWoho1aymmXzNEcprgEiK2c95WPaR2bp6+ZRj/2RHcSHCFBw8WXJiwCcGgyZsff/gciGzm1aHTrs6DoA3h05cvRD7QScQsE8nkMYUto8eTK92TfF8SZHyVnSQ5ijkT9W2btv3X5JOAx+XgBFGAEHIJID100CBTTjklVVYCXPWVhReGJZaGZKVFoYcFPOACH8S4dZmJdBn2VzGBpajXine9GKNlfUHWGIo3VmZiiyzyOKOOP9oVmpCljQaakbCl1tpqSMaWWm+64fZkb78Nx51yzRWEHHbZIRedRMkF5RN11wFRnGzgZenQcjx0l11P2pVnnhUUKYJLRvLhmedIG7WHi0v58bEff0EMCiATSEhEhqID0pACCSVc0MIV/4fA0YMKK1xqQQsNNiVhhRN+6tWGFoZVqlkcWnXWBDhIQuKJQKooY6y+7BKjrI8plqOuu/qI42G3AiuXr7AORmRpQyLLpJL8udask89KGS2V01oZHpYIaekmtth5KZ11zgV1aJfZIioQuVde691P5Hk2ZxfpqeQRNfKC1Oee9JFU30Z/6tfFE7yxdmihiA5FBlGLenuCo09FxcEJDp5waQubMuWphwCA+mmGGIq6IVqnlpUqiE+0+iqxhQEWLIy1sNyyrbLCZU6uvNJsTa+TpahyOcPyXFeyyyYJtNDOQsmbm7tRq1OUU/7mgtK/jRm11FMXWDW4YiIq7rdkUs111//obsllFYr2EQov662HUTVp36nRvHreCxK/irQxhb//PpG31oZ2MUXdf9stnQwKQ4rBBBscDuEFEHPQFAQOiKyxqR5LTjnIpkb+YQZEYOKqycSu3COto89Seq0vwzyzsD7uWDPOwLLoel/KBj00FbfbXjS0PzD9dNK+4+D07/99faihVl8bndTh7m38mct7DXYOsSl3rKKKYPRIHHlwb8rZa7MNN32s6OtSJzFxfzcU60/Efvt6GxzHGXkcPJOWhHsAQqeIb+D44o1DCHJUIUDmPoQ5UnEscgUswAa8UApXdUNYNgIS7GilitJdcHSoexFivhGz1ckuhK/7VY9EGCT/Y9FuaLnTndF4N6alDS94SsNJDL9GPBtCb0zNE1cOcSi9NqGrNMx5CBla0oYYINE2XcBeNeQhD2CET3z2uQ9MAmW/u3khi1r0AuDY0Ibt9UEmBxNTxBYGwKag0X8QiAAbJUTAARowjgdUIB3rSMcGtuVzIKxMBS/oR5cpo3WBicseb2bIEeYMZ6D7SwobuaSh5WZ3LpwktWgoLeHV8IY+LB51xuU85H3SeeeKnrYoqa6tjS0oeXiJI+LwBCTWQARAeIT3mri2tklxX/dB30wookW/AfNvwiSKFbvonMERzmFnvAAImNI4xEWgcWIhQAACAEc52jGb2qxjCeKQR0J+//BzoeNRy/5Iq0COUJyRaZEJESm6Q87OkbVblhsItSTcIU2Sl6xhEmfoz9+hy1A7waHymNe8Tf5QetSrQlDI1glRhIIPNoFUd97wCI1oQx7YSFsu+QWoOHjRi3aT3xdLStJhkhRh0+NOGR3lqAZFjHEABCAbF3jNDuF0mzr9UIji4LlwAvVG47SVOc/pTngi9ajvvNUieSTPp9pTSkmQZAvzCbwaYtKS/YQaQjXJSVDu0KBdTWh4GDqnPITxiDH4V/BKkALeMaENk9ioRqMon5ZQEX15CGlIT0rSv/r1iu4aKDJbqjDDPkxihpVAGycAqjhic6c5jawBQ8SWaIATs/8yK+RQY4RBUhh1RisK7c1o1U6lqkyQ7oTqU4E21d1VtZIx1Co/yerVTYo1rJ+07Vi5ZLApaDIG+TMBCDKwAR/I9RcZ1cYtcakRU5iPlWEsJkr/yofrxkGMgHuf3ghb2O+WUbHivZQyOcDYCDyWspJd74d88MASeTC+nF0ZIMvpMpoVA5BJPcxpUUvC/x6VtUy657KsSlVTyrC2vsvqVYGD4NsKtGuebIIVdAuu3q50W9ZBFxH9pURRhpEJLhiBC/qWXbM5sRrAkNskpEtd+sE4sCYdpvp2Sx3v7kQFOFZsDjBFgx7zAAUGEfJOzFtTbKo3yZNd8shasQr4BhWEo7X/L+oOqV9eJYO0+0Wnf1Wr1EeCuXZivo1rHxncB9eWtltFIiYdzFtNsmldSGgTcrJmUFTauIWlHGuTvmSuA51ixacwRR+gYBMa8uF7bcMrTHiJ0hnL2Jg0eR6AdmxpwlptyD3YAqc73YMgo0AC02Sykg9Qajk+gFVQ1iPKplxfDvbsRlfGMoCVumVbT4bA0BrzU1kYWxjOVrZrVvObcWwu8mwHTAXVLYYxHJtwHcStQ1kERmgBDFSIQhBeQGL/mHDRjGQErzHR7qNhnFYac3GLtbFxhqPW4xsP9N2Zlginx3CFe3d6C59WAU1xSs1/A9xDAA/ZG0ndoVRL4smZnW+V/0tYWpbB07TrBLCWb+3lL/satrte4YF712CPs7nBa3bznnHrEDp/h0xhpdqDmy02aJcp2QbSwyl6cW1BzMSlRDgDLfHK6HMLs68mJbek2+ef7tZE3kpfKdOX/ukp5NveUpc6p0HNb8fedOCV3aZ6L8AGhS+c4TqL9Yk06LqKt1qDaD97rZfK5bfjJeMbnzvdNa7gYI885FvFMbxZ7pvt0BmIXVJ5KC9c7HQpVFyKEohLU+AESlDiDV6Q9+ByIL8w1ikUVfTrFtsgdMAKFumEYnfS7azD5s0bmIHL9xm2MHVP7/sEbrRpWQpu8MhtoA2rALtme89wRVp5RRO02QjVPv9ri3cZ7oeJpNzr3nxfA/vjeM87mw9L8nb3neXJZulPgGJ6UpZcIZjejkESP2cB7WC4hsMACToZuKQ4yvLE7MMkKPESoo+Ui1+A9Enfz7f/w8+ADAj7rF7VQZ3qddoY6AGCUIq9GWBSPMjsFRzkCBDB3d7HIJxIXMMGRoM3+B5nSUNTBR/bpZ0FYRDEwRryJd9fgNzzOR/R7BP1Sd8//ZPwvFUSxV/lyQCGsQmY9GCa+BmlCWHfkRxXMR73IUREJKHpSUTjvRVB6JhBeFqBbAHm0Z/m6YF27R8C8h9J+V+8RVgAYpG7qJTqceEYtR4CdtoCwsEgUMobeNr78dujYF3/BYaMHV5gWTzACIxIR8xLOAAiB3JgCBIiXYigZWzWMqwdH5EQy5CCOTkcjhAf2bmd8qmWC77WC2Ji76iZDNJgVllf9R3hpWGapW2fhqFis+0g4iUFS4XfyfmW4HjfYXXAo/BAFq5hGC0gFmrh6ukf1F2eF06ef0zM0XXX3agewnDhMh5MGhrgM7IeGzagURzgAy6MY1EgHlpg7R1cNtZARTjCe/nhHw7DIBbizkTQIkmilLHTrpggJ8Bj6fDX8CWVUA1Vl0nVJmpipYGcJwpbgoXiDTLeExKkDoIhEcKimlgJ4G0f6akiliSbQnYHm5iLcghg+unPw2TkChgIMe0i/y8KYxZ9QQ/8ohluWE1EDN9s0S8FXbk92jAdYDXGpElyWhsCwk3CIeuNEZuAADZChQRy4zbq4QNQgHGxgBJMRCJgQie0RTnOSzMI4iCa4yHZiC+cnSpUQlbGo/CBUz3SI64lUmDko4EZ2D6SWfT5YwvOIDINJEHGX0CSovQklI3xXSlm2EAUBMohIcHMWXOoFFFAYEq2IkdyWh8AQv2Fgv3pQTOuZGMO4wugZDEWo7phUf51IVHkJGY242Zu4Ux6pup1pEUdQovhpE4CpqM0llCqZjZmQFFmQAiIwAiwwA34wBpQhCF8wicwpTCUI1Sqg282QwgO0jnOheqIEMtwAv8jbKVfpOOrtJ0hseM9huVzjmV1ZqIL4oDurCVaIpgM3iBiGRZFmUBKxqVdht9DHiSYcAfgqecPVqRfOoFLOcFiAoHjGYSO2SJRPALkQV5prt7TbZGlQCZkOo0LOM1kOqZI/lUYGYUVMuiDGoX8bGFnfgHrfeZnGuZhUkoW2luEth5PSpNW3OEdsqYDEKVxGWUJzGYNHIERiAYe4EEjKGVu3gJvBqdwGmKOouNmJSKvpKMjjkKQyuOORtlz9srvVWKPWOeS6qNa3l0NiqJbhmfj6Q+KulUSueIqYp+ObQt6ih8rekdDrCeaCIcU7gBxgUDVnACRPUrjcMDMbegCUiP/F5HkL6mBgDpNLR6oZP5iMGpmUehiFgbqoELoG/BBUfiphALOhTLqGSzgJMhppMrpTj5KNlrqpVKAA6BoiqpoCbAocbioaKzBHZDqHcioJaBqKtToXdwoIUIljzbnOvZeLtjXKKSgIUankbLarBhpWJIlk14n9NXmr3JnsVKSP1qfE5pRa5ro4TyKQaqplk7PRKacl+7ZERpEQp5nc5wBeYznj9Xnj9kNar6pAirmpG6hpgnZgNZi//QPTL2AFDboTdIrIBCqpN4roKpBoWbmhPqrhcpkdUWqo+LiwALmdlwjpjZra24q+3Wqp4IqqHbGxI4qjJrqqZ7qJ9Tojb7q/wauQ6zmKHyh0+nQ6q2G3XMO5yEm6XQmQ7A1KRFYkrBOn7F+13cqa5u66VMQJWs6LH5KK7gihI+l5+FdGkX2ILami0Iah4DowRhgpArwABxuh465niD06wEOqGSOmLsiDlE6haR8gRqIrYaOJn/Gab3S670WaqECVqelIUxuIaK27Z8CKoQK6oHkJE8ya7OeaN+un3hCrEBE7GuJ6qga7uHGqB8kwoxubMdOJTJAQ8h21qqeI6wKpy30quSqLMumjGHQLLASq3Zu55PC5c0qk/7sT6Zi6pWuIrUCURRuKdFmn7utyQ+GKV5uC1B0q5r0ZAWwkX0mG8VwKaa8m4Okkf9jLUDXasi79sAhZAK2LUIoXMIpLEL1mm1/jiZO1q0gwAH3qoH2ym2izm2F1k3chq++bu/d4usbFCy6MgekPIBjNWz+OOyVjqfgDi7ROAvFjupoaIbFKi4o0OiqCkMItqqrCkONlizm2sLGVi7I+gXlRiI6wsrKik6COel18o7ofm4Ho5mbte7NvlTO6qz8ViDAaSoJkKft2i7Qltwp8mBzAJ6a4G62zq6yYeT6RZMKw66aKk4LWEr//GT8ekpUDDFXbAAQHwItxEIT0wK2Qe/18ie97iu+CoLVsi8Wi+8WLyj7pi+hbm8Yn6+kyo+hFc78yqZb3S/+sjE+5e/+cob/ZhxuxSZuAA+wLtgoxxLwHj+wNAziPAIfrXEu7PwKlF4VB2tw6BbNBxehk+Ig7t4s/aLRBByO6lLgwDkAMz2hxJhnJ8ulJ+9Ed4jyEoKpcZxcd2wBGQjHeNrikCVWgQACFHCKwyTFESuOLUfF4xAxBEgKIDCxE0Mx9V6C9U4x2l7xMVexFu9roo4x+iaz2tptNEszGAOXcKHxw9YAG+PvdXYGcWTzp9aOHIvzHB+uH2jsHq/qHXPsNRgwBSNw5lLif1UQgGUw6CpyPXvwyCWrSz2TDlOyCUvgGzVrCoxXecruDV9rXv6QtwqgE7qpm34aka1ABI7FGkFMxSwAhCjA/xptdPxGihpkAi2Ig80NM/ROLypI8YYacxU78zKztNXCNEw/c0wHqktDs6DetMFagQ9sbf8A7jdrs1XRUDZ7auBWgYuqsqJsRpEwNf+W6h8obsYKcG5+wjpb9c4c8OXWmq4M8jx37pNOyyYS6+jOYOlGMgYw01NUAP8cMabe4VqHlwsj9EHPtXdJJAyXqUOQX0f6BLmy0f/gJ9Tim+wZcQVwwAqQAEd3AAq0wHlpdEZr9AR0AAzAASo0cS9g2xNHsRS/BNp+r70eMzKP7Whfcfcic2j3wUxnV06zNuY5Ak6K0Std45UCNVBHSdHUtv12B3FYz1JXbFPzbzk3AlWrM/9w/qZv/qY7w/MKWuLM2jM+NzJYs+WU4uz+/PN1/3OJupFH8zAof3Jdfym8jUddhjd8kgHjOYECbgEdRkoPwCG/RcwUHMIbNDaE8MAWoMAGJEBGn4B7W0oHQDZHQ8iAW8AVgIFlu4LNafYw8+f1GvODlzZqS/iEUzhNV3iGVjiEX3HOFaje2TaxtuUIwKaIryhvo5CxkPPhTqwfwGgjtPhwU7VV/2ZyEydzX9x/efAi05bd6Xh057M+my7q/rVaKy9273Ja+2RZsB95lrd3g/d3b2sL664qsx9fs0ktUiG/dYoKwMEXBGYbgYVULDamGK+AD7iATzZIF4KCB3NJZ4L/g5Nti8n52WZ4nV+4gxomhtv5FeeHht4fSDGHhwtuNgt1iI8A/cJmopOYiY+NLwF3kRTuZojqOJNqjBK3AkPlVdtjzjScJfaqWg7Mc2cidP+4lDq0JP9tBhg5QFPy/zwTz37rcgitkz85ra9JXvYgeeB6wcS6uN7nMiUOL4+5QTyKY1v0RC+Fgxj7gEM2ZK8AZV+CKwDDE5d0m0txf/anJGSvhu95t0sqn/d5aPe5dLFSuf+5GVSYQHw4bgw6msomomMAbG4qULeLnMgJU5tHpNOxHG+GG4jBUycuKDBwAb8zxUnnreEzPx5yx/FOWkr3mQY56qJ1NLW6P696xfez/1QoeXcPb5Nbq3eLsii7514LiL7BN6h1awuk0QnkgMlDwGH3QJc/CMwfhQUwAEdbAAygAKcwe4C//GFPyi8vuLVfe4ttO7eHu7dTeGfT62vfpNNDPbib+5yXu0wctaMQ+lAzXuGguryjdWyCfRoLbr3/TGhIesVOuhyLQRiE6osGvMbWeJKSIAk5N7Al8t2TOlmbNZVKfASk+sWXMHandacQkIn2bMfb+rbWek+8Lit2GMS3aQVweZcHZn/D4YP4/QocxURbQOfz/AKAxWTrvOcDuJn/NYR0wKRcgtAzeIO7fvZSCn4cQmgjvdIvvbhHfe5P/ZzfB+SxEv0I+je7Vf8aS7LXf/2mHrrYmzg3s8bZ0zHF3gH/OvVTw3iNXoMCr0wCa3/Kbu4y/Liw4X3eHysj1+yp970/q7VHB76qC/7gP4VAH37iL/78wzANM6SAuHvv0rLVaDlAcLgAYcLABxBIWLCwIscKhQsgKojYQaFChxYkEJRYUGPBDj22wBmEqldJVJcIUVKZieUhlS4PSZJ0CJCgmjZvPsK5U5Akno50/typE2hRo0BtIi2qk2nToJ2gIo3TxgwTHCxGeMi6FYNWrxhEgM0wlmzYEWZr2FCrNsmPJViqwF0jFw+eKnXx3lmjV8zcvn/dBP6Lp9GnVIZtJTYmjDFjZ8ggP5b8bHL/ZWaTly0b4pYzjs2fgyghspmLaNCn37ZN3fl0jNavXbP2LFstjRS3ceMGsdtrhK8VgAcXPjz4hILABWJwcIAAAQcFSdxW0ZDGjupAcljXjv169+3ewX/nHn6HjR08zldx0sRJHSfleUdHwYMHxRz0VajoYBDCBQ4d8qOoAxRg2KIHjAiCwAINYEAQIwtgQEGFjBCYQAL9EoRwiy++GKkXV0pqaZCXYHqkxJp8SrEpoXJScaicWoQRRaWIWsopE6GahBI9OgnlFEVCgUqPPtpAwoYNyPrtq7DKalKEJ9HaqoS03IqrKiursssIvPqyCzAx6upyML0KM+yTcppJUxrH/26xbE1o3ozssswkW4w22EabTc/RVuvTTzxju3PPQWU4obbcdCOBNyUj8I24Chzt6lHjkNuNAuaae86DFPKrjiHyxhMvT1BDJdUG9NBTCz3t1nvvNg5M4GFDV0+4cIoRtyAho/96UOPAjChC4YoIHXSIgY0kIlCHMWDgQAILxoBjhYwI+ojDK9Q4hKSSaEGJxBNlQjHGpFoMd0WZfJpRxkfMvdHdd3EcMsggTaQ3KDKIMEHREhZVssmxuFpSBH6npNLKuLCYy668wDTiyzH1injMMttUM07HKrvYTWXsBHTUj1/7U2SPCS1ZT05xUwvRffflLVJIu2r00YEm5UhS4/+YO0BTlEktVdSfe/bZOlSHZq9VA3lQGUNHJ0CABJB66EHC/x6CgNoBFiDQIgQjkqjCRhf8AIWKEGwUIqsXElCNksQJkZKUvgVERxznhvfddlVMl+697e77EXv1sHfeHHV6Y4rsCE5cUiSRPMvxDHiTkl+sskoL4cu3rENzzfNyWEwvQZcYzLoYaSQRxNQcxrFr5GzdMjpJNnnPkUcuNFBBZe+sPBngWzm+fv2FWfiXb6Z05geWyxQ6Q6/7FOjngxaa0/PMMy+99Jw4A2n6UFC0owgsqJUDhqaQkCKzE1RQwIUIbPDY9z+IENj55EdfgQHwR/YjNeC4pJe2T9KSlcz/rUSTMBGK/AYvmiSQb3xTiQN1RLig0GtuDzRcDlKwG5Z9ZXKSS5wJJOeV27BlNXe5i+bu4rATnrBLC8tLxO7gpdER5nSoa4XqcKgm12HMdreL3ez4ZBrV/Al3ucud7zYIvOAdj4lNRJ7y/HOCTrUAetEDwseE1rzd7Y4918veGd5Dn2ihAH0quAIYYKCf8RGIfw0634XUoAMyLkAhMEBjA4AlAR2UQY5nWxAcxqCBjBzLAPnDX4aEpQY0/A+AlxjgAwk4kwXGJJILpBslRCEKTEKykgas298oOIlM/uIXp/BRBX1kylCo5JSXfCQrTzGIIVFPIPxyjeJswK8r6stI/xy0DpXMgy/SVIFI+NocGRSRTBSCaYYtDNPDHuaHP0jTD4bARCpe0QptMkaHbPJhD40YRHEOkZzl/OE3wbk7JLJsX8Rb3Dvh+SgKFK84TEsec3bGvCl6yor97E7SanM9VllnVjvYzQ70MIaG7MdaDnHWsTqALTWgQAMIWgEMPoCg+0FAWMRyEPrMhgIdiI1Aczzb2bBmgS+08QqocAWIuiXAl3CykzXF5El4AYxMGlBuBhQFLyjhypyawpM5BcZRhwpKU/LiFEwVpU5nGkCZNjWWjtRDrkBwmyno4QQEY090DJdVPbQBhFkxQR+4OgIT2MAMnSCrWohZByMYgQyaS/9mMnGhCBd+bnTNBAzCpPCXwHJBYXuppmFKsc0cojOcqKGdOYfYWMbGYGWJ0mASXbbEeDZROZWSGXCWkzOdVUCK+/RnFlE70BR072fZc0IKliMs7hlrkFejo4BKWrWu3W9BCtFARQX5NZBKwFkqRSOCUqrbAXUgayMqhCsayZKpCtCm88qkdFVyEk/qCBjV0CQqqwHVSZgiqaHghXf/Jl7zMhUVRz2FT6+L01P47yTztW8ONNgGUZChrG3ow1ofQYZNvTeDWrEBJidngz7w4r9sCcUZ5uowIOXBrqeoQ1/9urAvmeGvghXDYKkQzcNGgsSpOFQ6izhOFbOmdimerKH/VLbOlmVWs5vl7I2fyJzllfa0qRUVQKt4nlZ572lTiJrUHJK+Z61AQgwYEP2kxtyTViQjC4KBDprVqEF+AMtzDFvUqqzb3Wqof9xyG9xeWUFU/vS7FWwvKmCyXji72b0+HSordfqI9kbVqe7Fs3wBPV+YKJQ3U4Bzgc/wBn0dQsAHpoQMvLqIScSgcn2YhCJyqZZO9MEJc61DMqvgsE8nQrDP7OuFTXg5VcNFNIQFMYghtobJnvOxLXYxisFZWRljNjn+mVmNa/ZZrQikUfccLYB43OPUWk87p3oeqlqFKkA6ZAUhuYJCGLqCOE6LAcCCASEK4cYtj6GP3WYQGHSg/9uKVk0iDFADGpkcZQVRaKMq5R//MvG/EHkLuyxhxQBXKec/B5AWL/npUQHeXlr8YuCsxEbA1btnStCC4tJ1b8VTQhOFmhGQPLjAAzDgBAMatASJ1tdYBxwKJGhQ5I/2TxAEwYdHGEnTebAeEhTRiSyIWq+ZOzWGPQzYD7ua1UE3OtFPjGsX19rWt861Pim76xnri1G/tvHMXlZsmxmkAMpbnmmVHeQgrwdppU1OBHgAhiuYb31SthrWSspkB/0Wj+j7ALlhgFEN4LGQXkvus+yIhiyftGtWfkELZkALcSz+zP0OuMGhenCKx1S8Ci845P38VKdqnhI55TMqQtEt7f+KYt9w/kIPpMgBichqClvoDwicAAjDgdDkKUC5Dd7b6BScYZZp8QIgoBDg2yRBEWRdglrI4FZjas7nLRRTqld99KJLf+hSULrTgShE7Tf9nE+XessioCslKgnYOP4sRxIk2tHyLOxi/+X0fnyeLcDHeE178nwkhJF2P2ve65O7/r+m27TsQfJO77iG8CCCIvKOtggvfxgAjxBvRPKtbWKKulZBJS7Q8zBJ9CpOFNBLzrplp9isvjjvzzrv8rIrBJmqAnsBDjhEDQRhBZrGayYADtBjDEigILaK9yDNv8TqDH4QCH9QD4CgBHbPEYBA+FIACYSvM3JOEQALD1RIw6D/L9RWLfqKLjWI7i220PpmbemYDrKOD/u8z3ZkrJbQ8HfSsPzq6eqIw3hoJsd0rAJgJdncTzycZ1UKxf3Wg/4Ewln+owWihn58ZZDUBg2EACMagH3ap2waYBF1QAfA5tzAIKO6DQH9iBFbAAISwI/wyI+87RAoLkREcID8LZMq0M+6hbsAbZX27M02UKckD/QkLgXlKyWuoEO84AI2AAL4hwMEoOsCgAPgQCDGQAV0sA9oIA5eq/YeAQgVjAef5qo6IV9sDxBiQObmqgqacC2MAK3y4HLkqvpUCAtZzRzRsTS0cAxzjQzDkPsk6zp0zbJ4bfw25Z3s8eqE7fwopR/7/0MO188OfYw8cG1VwG47jiZp/nAKAumiPKraBiGNDBEGDqFZCO/b+KhsIkAD0E2QBnAGjmuQMNGPXgD/8o/KdgsiWoBDRHHx1MsERzDfQE8mnwr0Mm+oYDEWceryOvCmeoElgEFabLAD1KAFEiB/sAUCglEAzAg4FOo5GBL2uOoN9GBTnlEqY68Z9UDkbMMGdMIG8oAI1eKq5op3UsPSoNDTtqT6qu8K0/Ets/D6aO0d4dGIku77Lisfe63q8tGd2rA4kAfkhkcOd6z9mq06ljBpugP+finavog6xmftqEbJ7EgNPqAF3O6Qpuy3KAqj6k7LvgYBAgBCSKqiPhEBsf9GQUQKDCzzEhcAazZKJTdxA3jAAxfuuwau4nSSJkkPFVfxBH2k8jgwFVXQJVDBcCJSATjEFzsAfwQgACAgKQPAAEBCNDcEOKLyBIiQ937waSjhi0wg0WLPdsaKrbbyVCbhDcrSLK0jcMIRc+AyPtexC9cx6dyRLuvSZODPDPFSDfWSDa2OnvwxMP2xOESrMA/SVFSFd6rnVJgt/pLGtXJAe5KMUtLntqws7w4wEymqURJppMDmM6dsQShKzDDxBWbAjVrgNBdgA/DnIKKoBQThpq7LBP3s4DIBFlHBuxRuJt0rJyXuzeYrFrRr7TpkP3xFAIgyoppzKQXAF2GgkLD/xVmmdAK2CqwSjat2IMCk0gZCQsHWgwhhT/nqIBTkqgooAcIe9AfMI+fkKsJApxzdEh1RjQvjkoi+MMVUTGTyUz9jbB7ZqZ2o7j89gBcD9A3dEDAJ9A0PNEajZw8XM6BUJlWswwSaDaBQxUBk4Ax2hAfkTsnm5/QYRJEGLyNWQAj4yCM38grKoBAqkUUX8TQhpAcuUyQREFpYswdeII1msz9cQBC/ACdgaVivK6d4VOFyVBYnb/J2cjiBMhXfyyWGsmly4BCYa+3wRw1yUQIMgBOfMwBaYBA4MVpycQwOARmvNOTAEcCAcDxjjwez0ksZbEh+xDzcqizfgubYyhTe/7RO3VJOzdFhADYd81Qux1AMEfZgQcZP+RNQA1Vfws83BpVQATRR56n+AnNSGjU6BJKfFnM72E86pKOKZAVfQsIJxmARroDYViBXUfRAmAtC4GAG1m0RSeo0sUYH0kDwHJG5FnEBGoAjfUVCGJDwOiB+YjZbTq8H2CBbaBQ3DQ6WJE9ZOTA452tZr3Y4uyWmZE+WNrFXvJUAUKAYFUBXRdMCwGAQLKBsVWApJQAMMKIYoWMrKSBdbe8U0oosx/MatXTmrvGXZglNbY4teo+ufqQ8WmWuOg1h6EqFBFaYtnEb5zSFBJZxC5axEnb7Mrf7HFZfHtZzJzYfhSdRLRZR+/9xAjJg67huYzsWPDplP5ttelCGBIDGtbyUWbJnPnhl7VzzpGDAVzCK2xAgAC+xIkyyojJkIgtwWHR1Q18zAaEl4yTB8Z424P7taZEqvoQ00OSLWSsOEBzpQLJGDYBRRrn1OXlgDIZ3C9ZWAJRzESwAAPJuAKZTAooRBQ6BWyvkqirgS7OqDlCBq3APCMng0UiAU89gCRfhPZ4RN85g5nag+Bo0ESzM04YEX8vDCncg1NpDTjuNrpivrqzww8rRcf011Lzxcj9jc/FzYf20czkWdEG3UPtF2G6mYklXUVN3UTni7Iwtn6AOnFKlerRDdisVZLfoO3L3ZA9Kttxut1L/c8mubGx+lv9cs3jzLqPO51Ylaj60lYqoSEK8gH8OAW6ol0aJ1XpHCWozyUe59xRigUjfpn9W9goA4eOgc+2g0wWdpaPcN90AIADAVW1HE40gAlvKFg5msAb1wErTylIXIW/bVUwL+LWaIMB2YIHho4DxJZnq6pPx9pPJsjwwuHJRuIQjDF/MIHJNmdVE2ApVaPhSWIUVNsQ0t5z6lFBgOIZlOHQpFodzuLOOo0A9qyt++ALMzuyOWDtUgGdCdossVYlZJXsKDH22QJZ6AMsY6omfLIwVKZCu2FadLGywLRO5FXyYawCilxDY2fHcmZVYIZOCJAPVGOJq9JXsaxEA/61b5k8+euAAVtJby7ZJIwpbeLeQMCKQAWABmsV9x1aWcBAB6GMjJkBWYgUa9aX2wGgaEVehlvAM2lOdEKqTN41d+oCuhiSlaS6DSxlfJZeuhEmVHUaYRphxVdlyA+ULZ7kzbrmnc7lhd7mXTSBiJfaXg9kvE3VAifkPcQaKYjj1RjY64KOZc+N1aZeql3ma+9DsIkDbxgBbCOFXlswhBFFVB+SryciK3Q5B7ChCStQ+yiYQe2B6T/GdM+EC/e166/nxrBcn7/m7blFlkaZpmuPtOOo1g/E1A9l9h1c0v1WQFZqxu65bmauxccZQYeWyUgY+KjUFXAV6RqgJVnqDV/9ZVUT4l4jYCEgZCTZ4hCO3CjaYrhgXPjm405gPc/6Ullm4hX8oqKXOqGmY/G4YA5DadDGWmBkVnwQzhon2NlirU7qne3h5OngJQsnuqsSnyI6seS9kbMQZf+4Oy8SmtmpLZuVIZgfh2uINrM3Yrq/3AllhFeKZFUzBR+b7FPc6p964JWRPV4mNsAW5AI4yfyDbABQ6siE7wZ3UkChauChFDXWtd6SjeiwVUb7jLlPYVQ4lg5M4wpIGliMXX6wQchn3gyNMckNNltlUxQ3WsXz6HV0Yw337YfNyxoT7xov7qAUUuTG7qTWlDqVbBeajmanawjtb7MhuRF5LV1Qgyqj/6Atm4AXEOWbNDbhySyMvVCVH4hJEQp8v4ctB777xGrv0+q7le43rO77w+5RSKdBoYqNV736ao+8KaTof284RXMEVfLKVG0bhMLh5UagrS8JlmMiPHLXl0qUbU7W3Q3FdGrZbm5UB9sQF1qWNQMUxPTZ22sVfPAxjp8i/rz+BW7iJx4YP1bgfxYfvaXkC1dCle2qmG5p/LEwl7aoU8r/haGi5W0DI+z9MUpxVs1cIAcyJnd/uWrrg+xQnAa+T/b7tuxRnUs2D6qo0VSAGXGfqvO/mnH7vvNv1PMAtO2NT/XMFHVCzOtP3k0FF2pJZ2tkQ19FJiNFPmbZXjZRTmNJz/3vT9b3TA4vfnS63M8iWyv0M/bOGcRyY44lpNuu4i5kwPeIPEyJRNMBzibzCsRp2/yl7tEW7wEiNEgRq+OcL1voFsE3K7KNAhsUhAamdparY1fx67zq+jz3m5fnZ0VwEtXfOZA+DVlf9sl3bfz7Pv33OnSPc/3w4anzgO1ed2E8P5fGbKHW1A0pUFF3eY7umcdsbgenEnRsx7VPqZUP7bNnf+7SzZ/xPsyr8ILwelUjtczyYk/ovF0cj+Nw41L4DEmLio0Pve9nQcWPWNZ5Zd+SL/8M/tnsFMFN9Ej9DDP/L29vlWaK+HE/MpSuTnH2NcZ7N5Wvav8A2rB0gC4nPnf8Uz0d/6Im+z3kc6QVe6VfmMGX9iCX16z0DoCS1w39GtRnd6lvb3rP+3isHw5nePuOd08leDGkj+GFYrZT+spgmUPtFUHnN1BO+1FE99eMwZxj77sldqHeHul2/OujjDexL8ityP/xjpZp3yJmLFwcJWEMiRyG/8qV9zS+f/l++zQFNlphRP3AGIBIcEDjAgMGBBQQcVBiAQMOHDCNKROigokUKFTJq3IgBhIeOJUyAEGkihcmSJ1Oa3LGyJcsUO1jGtAGTJg0ZOG3iIGIDicyYM4MC9TmzihGgR2caWRrTKJkqRpfSnCqVak+rOrP+wKqkq9evUsBGDbukrFkiZ7f/5lR7VaVblHDjkhw5l0Rdux4/5o2QFy8Hv3P1fuTbsbBhjogPP8i4GPGExwgQCGgYOYLlv5g5WEC52YQKlC8/q7iJE6iTM3pOneKFSnWmQ296rPjb4kWHCxAufFEj+8ULL2oAHSJEKZPxS8iPK18uinkmVs+jN38OXdSv5tdbi2p9adAgQFtykIBMcWHCiRDTq08f8eJijBjgJzYcErBcly3zh64JU6bOoP/9lJRSQgk1YFJVJQiVE1Fh5SBpU5EGIVdDJLEVWBaSlWFaZxnFIVtrAfjWfXfJRVdfJ6aol1182eciioLNJ6NG8j2WAWTvPZbbjpJBhICOmKm02Weg/43mWYE3OaFkH9upxl1z4LXAwQUbXOBCC2oYRxxxznXZ5XTVTUcdmKGQ2aSTxR2iBw8nPHbem3BGBMBk69U5WZwIUaBnYx3ZmGNhI8SI4ogj5rSSUhEm2haAag21A1OPMnjUgI8WRSCCCWbqIFYQ8idgWwlSgeFZSWChoamnfshTiIZORSiJJcIoq4oeZfbiXXkJetiMNT4g3404NqYjeQ5R5kCLnlnQGV5EwiVaaUMx2MYkrGlHJiBxTPFbcMSxEmaYXo7pnLfikivdmdk1Sckkj7wR3mwTmIennHMCUK+dBBygEJyRubennrsGrKsHJI0Aq6spAeXSozagYNKirP82KlWlNkyKlKNIMaVxpUc1WPGmWD3c04QOQ1zhhqOmqnLHqkaM8KsmxpwrYbMye+KttA7c54w8A7tBjgn4qsCw8err42XK2sxss89CS1oTp4VSLXfWGpeml+CGa1zWXfaS3Jmt8VLmJH2QoeTZnz0gL3p3BnDv2+zlWxFFQvvLJ8AdhSBwoCvSGtfLJyksYEs9sSligJRexTCBF7PMKMtQaQoyVWxatbjJJ2eecqkoR97yqi6LDLPMH+Fas6xK46yzwD1j4CdjQKtdN9H9LpSvZciSsCzTnp3gu4RPO8Hk1GZa9y12XBd/vPLK90L8uoD0kccUP9gVEw88cFA02w//wW3v93Hv22/sE+AN+6977xqo6aOX9JJWLzHq8lCYWxq5pYkzDNX+Tkg+OfyWU0r/rtK5zanMc/eTmH/80z5CzUpngyKYzEy3Otaxbk82gt2w3BOvYVlmbkaT22VsdZu/wOR3hwJeEIIwhUdMDRfXSRfzxKS15c3QOqigBS1aQzbqrVBwp1GSCiIAQnx5L3wHqR0CMPi6+BQGfRXsW4oOBrMAEa4thjOQ/BDEMSRVKoGQa8r+GJYpMnIqQgyk0IU+JBYEmkUqYAxdfxp4EoJJMDAPRN3NpggCZOUqijSzYEeg6AAnBuuQP3odsYyFOxIGyXq/Gw3woBAHqb1Qhsgz/x65vGUu40lnkzYs3msE8QUo0KAEGfkd9pbkBCJtz23dA58RlWiRQ2IEb/ChwBINgxG9WZBvgxKJwajoqQUm6iU8YKCAMnYp+jmTfpFjyhinOcZJ+e9/lyMgEj5mzQKmykOQ2xiICERH0uUMgsH0WyCjyM4MPtGQt3SdsG4ZuyX+KJEd7JHcElkrRxrphJIM3vBYg8nssIIbngTluEIJNrFBiZSlJMEFZDcBDtBgCkpa5Wc+WKxYwhKJSVSiju75I4x08J25FOTe8EhM0SnzffVD4wK/SD/ELY6m4aQm5DwUzWtW7n9q5BDKcsrTomZzJgnjT/v4mE6WNvWc7Izqzv/6ZD55PpGetNsTCCtDy2LtMzeZ6UAHILmSgN5khS3MDi/UGkNgsMJrnEyoXBmaSVGwy11eyAH1QPCnE6wgBzn4jDz1dRAjPqRHtBxfLQupSK1SVaV6AaZkPVLOt7jqJzC96TOfqThtNo6zO3UjT8NZFTN2s2KmtRABWaYxDqFqtOCErQLjV9kJUpCpuC2dVHf72N4qBqt+Wqwuh6tLHH2QIG1LwAIgIIHmckACy+pA0yK5wmk51Hi/ICh2PdkLumZyrdmBHm9WeCW9ntKEohErc/Xp1famB7GJtRs+ichP4WLAl7/UGSqHWaIGAvClhVPhDy62WcUBaJsEliY1Y7v/v9YuOLXXDGprvZlTB3tFYodSam1xBqs73laKeeQtZOdZAZNmlZYgxMD4FDCvofFlM8oq4XR/FwQoDLStMcyuW70VQ28BQzsy1O6P7SoIUuY1CC7ADQlqgz0gSPI2r8SXV0OqxPguVpGGzHJ+B4bHYIqOUFmpX+NsitkCG/h6I7NfaBs8TXE+uJqlzdRQ4chGUrF2tHSeLUw33FJYmRPEIRaxO1VqYhPbU5fxXXHdQii+EZLQdyjcCQtdSNBKXxe7OXarjn/MaYdiy4c/RLKSaRBYI000MueRskMIW+UV0xfRjoViwCiA3/QBum99/rJ+ZspZAmOsQFDZrLA5NsY6/xh7wXR28IJ7ymCzvFanFJbtnePYqPe9j8/YZh+uoRrVQftWYHdr7GATTVIeoTq5jXSujCFN4yacwZKV1nGmcQiMevPC3kO+a7ZMicryHrk2teFrlFW9aiu/upC7RKn5ZK1lWwuGb/2lbJ8va23TgnbYGMsfToEtxmXrFM/NbjMCxYAqkj/7gN58bZ0/15Zsuy/XMLPjrWeus1pDNsspLbSJiYhBgy9mvSymE2VcrG7NQPovf9XrjS2NY3yjYmp3PTJgz2ulqZfad/RNNcH3eeXZXVme8YwPLhu+5ck+tT65RpRWMCVOjZdl2K3kLA+SEnfXZsHjcJbzyDtm8r6Txf/vgFd5tJk9YLSArvDyoy2YCdUsDS++gTQXtFRpJu5BVgSRi0WIi2m3NqJDd0jTBQIZUuN0S+vQ3g89A4OIEJIaa4s0o+HBbHCzyK2XZ6uXV2RlrHrz3qMz4iQCXDY7+zGG1V2zh0e88j0bbI3N/cwd318dpjl9vy+oDkuZvsYCHxbuc8H74CcLtOvczMe7xdoqeQnMHfhnYUrwIzaHrN4YPshvU+C4Kj54PnG/eQjk0zw64mi6s2QB1QWK8AvYgA28kIDVwIDVoGntglEiQmpWRxrPJTtCR3B0c2V8kXPeNmjr5Hu71V+L13IicymUQhSedXHKRxQ70D++FhU+ASn/hdcT/LNsJqdT1WcEYiBnS2FyogJ4Qhh+glcWFmZ4Rkh8LpdUb3FtL/eES1UXEBR/kkd2TWRo94cjsMZ/QdN/Q1MQR+Nij/Y7VjAFfeAI1IJ67OIIZcMETkOBPCCBK3ACFxh0hvVeBaBo+MR7vaVzPyKCInY6Emd+X9ZZzaSCprFxGNdFFhNOqNWIRHGD1JSD+9ODnlN9eOAxUhEGnEgFnNiDQ/h9RChtyndhlhNm5sdA+bGEMedUXVaFFoQ+H2hVubd/Xlce/bcA50YZ+yKAKbQTXdAGfDCM0tMGXXCMXeBkcKhRgUV7jOZeIKVoRAOIKOU61MhbJEiIAGVMFjeDpz1Fg2+nZxaSMSk4ZjFoBeiId2xWBU+BfVAxhJvoiZ04j363BvY4iqjiTUhoeB/zU+WEE03IhE4YF6rIfuzTZfFHhTHSS7oia/RkUntoi1wYX7iji7t4WI/xSDS2BMLYBsZojFAQkiIJWGiTAgJXRHfYHgbxhdN4jS6pW+6HjVP0eOhXE2r3iOVoA6u3iKUYbF9kMSqoWoW3BOmojtXUg3xXiSOHBwEBACH5BAQEAP8ALAAAAADgAQ4Bhx4NACcOAS0VBS0jDDMZBjQbCjcZBzkiDToeEDonEzszGz04Ij1FJ0UdCkcjDUc0G0g5I0koFEwvIE8eClQrFVRLMlYrF1Y0GVcoC1dEKlk5I1otGlpnSFsxDlwyHWAfAGU4JGU5JGYuDGc2GWllSWpCG2pEKmpLM2pUOWpbQ2s7JW9yV3JcOHU+JXVEJnVEK3VLM3VzVnY4DHY7GXZSLXdJKXhJM3hUOHhlSXiGZHlbQ3pCG3pLM3qJaXtFJntGKntJKntUO3ywjII+FoJGKoJONIQ/IYRJJoRKKoRTNoRVOYZYN4ZZO4ZcQ4hHEYhIJIhmSIlHGYlPMYlWOYlsUol1V4mIaYpNK4pWNYp8YoqWdotSKotaO4thPYtxTZJMG5KPcJNNI5RcOZRfQZSpiZWhfJZtUpaWd5dWKJd8YpecgphjOphoR5lVG5l2V5mBXZmHaJpxTJrHnZ1hK6HHnqJcKKNdHKNdMqVtR6V+Yqd6V6hiHqhoN6h1S6iXd6llKamHZamnh6qDXKqQbqxxO62jea6dgrG0lLG9orJtQrNsK7NtNLN9VLTRsbWFWbZ6R7aKZbeTa7eohriQW7mZdrmkebpzLbp1N7uCSbvfwLzhwr2BPsJ6LsJ/UcN7NcN9Q8V8OsWegsabdsakeMd9OMeKVceVasiDOsiohsm1lMqHRsqUa8qkbMuEO8uTWM29o86RTNCHPdDQrtDivdLewdOLPtOOUtPkxdSMQ9SNStTDm9WSS9aRRdebZdemd9eshdezjNiQPti4lNmWVtmjadqTRdyVSt2bU92hWd6ZTOGXS+ObTeOdWuOdYeSdUuWjW+ahU+apXOasdua5kua+oeegTue2h+ieUuihTuimZunFluncwurRquukVOulWuyrY+y0eO2oVe2qW+2wX+2yaPCmV/HszvKqVvKtYvKtavKtcvOtW/PkuvS0a/WyY/W8hvaxXfe5afe6dffJlfizXvi1Y/jFffm7bPnAb/nWpfrIhvvCc/vFe/3UmP7RjP/95gj/AP/UQdPmi0GCYRJGGWKkocKGHz5siDhhgsSKIjBo3MjRQceOM3zUGCEi5JOTD09GOTkjYwOPGn1smfmF5sIZMnKiwfMo0SWfPwkBDTp00Z2BdewYtKMIlC1mUL1J7Ua13FSrVbGG07r12jJlYL8Ww0b2a1avZ89904rOatu36NzJhTtubt148u7lTdeuHb+/e7N967uPn7/D/grfpccYrz19jyH/lQw4MN+16+heJqw3b97JkkNXttw2qrNjxoalXr2rtetnsGPDRo1atunTyXLrDmu2N1poWaMJ7gzaHjhwxkPrQ7y8uXPm0P0d1/ZcdOTrj6lj166PevR54CG//xtevfxzeceRFjzIfqXDlBk3TJz4AePH+/gxlEBSREVJk++ltFBHH5R0xEwIfiHSDjgNgcYiPgkV1ISgDPUJhEepxxQpuTx1W1pchdhVV7z5VhaII6rlFmaa2dXiWuTgpddb8owG42CFOWcPPjH26FhxhlkH2GY3FjkXZ57VaB5l75BW2m1QIvOhYLa1phpwuP2222oldvmbbEgqGRlySy75XWJklhkZPtdFpyN32nCnIziCSSOmmObViF47SSHUHnsNGSFgRPHJN19+93XAUQf7LeFDRgCiFEagLLlUEQYy7HAgglcYdJNOfEQoKoQ9XVLhTxdi2CdTl3QS5VUoxv/aWzC0cnlirLCy9WJfu8pYpJJOErcmj4v9iB2QNhopTot8CZujmk0GqxmVRVJLLTOsWWkblrZuOZaJWcbWY2F6GodndWemi2aa0RWnnZyHRQZnnO+edxwxxJBz3L7s2htYn38q9AVDkj4UkaETFQqpoooauijD8amQhKMtjdACEZROKuhNlmpkcYJodLpSgzI8WCqFpqZcFIQCtWFHHZx8MkyustKcIlVi1fJtibjqmiuzvco1FY6VXUY0ZPGy2eNizx77GLD3GK1sXJuF+Sxz/ibJ69ZcTz30bK5pe8y2uoXdLbhYAnf0aOc+p666ZMKr42FyM1evnPbgbVm+S+v/23ay2bQcsMYDbxzGHQ2RpAIIG1QccUmKR74wSQ1D7gIPSiTh338Yq+TeEzh1rJ+mWxRUuntD5ORgqBBOuDKqqSqy6iIyNzNl2rjfrHtZOtuKc882Z2ZkPbwu66Jd4jpbdWdYE3sXj02bm9ydTk7NdZKgYT2n1td3T3Xx3MLSoSpi87KLOKZJJVa2Z6NNNPVAoqtuP/Q3z6b8ebaJdZzyKjcPsNKgkpSsZSfsAS5wc5iDpwLmIEAFqkBGaFwLHie5CkKughYDQhKAMEHOSYpSAwIJ6RLCKY6VjHUWSlmFUqUy2SEFFK4S0e9ulTYZ/q4YveMNidRmwxX50HjHA6KR/3hImKJ9j1xBSozzxnUu6cGvejciXveYB61occ97XVuLalrTilN4UXy02UUrzmczb7UvXLBp1rnOFZ501e+Nb/SHNo6TN/y1Cxzc0V5oqFO3vRBjbAMU1/u4lxcqJTBkKyGhwDZmuAd6UIIWk1zFHCfJxSkOBjyg3Mc897kWtORSHhthCU34oFG1kHao8kTsktKUXNwud7CsGe9ymIwZnmYrwuth0Ii3LCEKLZBxIc4Uo7dENiHxmNMrDhRXNEwk6lE8hJxRFqcFGxx2cRNf9NDYcnEKMjpjaE8K35Z8A0wDAsaOh4GjOtUpPe+8TY7JcdN1+ghNdWTjj9tKntXA9/+MOfABkTU5ncAGqjEjfKAlDVJB4mZQApxEcpIIxaAmfbA5A32QUp98SUUslkiBskR1YSCVhEz5E1Wy7KS1S18saSjLsiijFrEwn26mYpZeYuY3MhyeNG0Kj5umLZie4aUanTkk4TwPep1RHtuk5svlISl756nnFb/HVAGqhnxdBCMgYQOLbobzhzjzki2JSK5yofON3KhfPtZJNzp2551JQ447EcO/t9KzkFsF29ioZU91eMavT8oQQQnqEEYyhKELRWxIHhpRh07yoSOwwOhc4AGPdY6THNPIpTJFg1Ga8IQjbd0pU3YyGF6JbCsFHqxyE4sx8uxLwbsGWJk1I57/+vSWOJomkpL2l7vEyJgGNGeydrk1s1aRe0C7FmpUkdUO5RVslzDGV21LU/cFx2r+cw5a6ccOtXKXfm9sJ3jYGl7xnim772ASXsl2Wr52LSp1MMpgB9tIhnBUsfjNL0Qj57hQNtSyVxAZJ1tSH1CKkiZbICXrTva6VIHCEqpMKWpTS5bdjZUXrY0pWFaLlrdoJSpf+yFVi9TLscpFt0UMUlF/a8x9mnW4UtFpcVO8pHItM8SxYS1WzRdI23xxuiXmMEurAlRzomud313rd9FKxziRN47U4dFc6VqefkkmG8+FSpbTOJjLmEawg5tvoOzLWP0utsz5JclG/wvgTj2E/0EE1mhMdtBZkMEZVCSFHSojnDJtznA2FB6ykK2pYdjC1sOHnq3weEldWPpKqEckZoyE02LsCfec1WOmU2n8TCvemL1maw2XwfaMYTx4ryoNMvrGet0TWzq9btuukumX1rXaetba8AUe0/lkrLn1mXpL09PIYZtw0gaNMTY2mMNM2AeaGc1m9uTFMGZJE1BWzYy66Ekoaqk1dxQLCSJZGPAQ2tKqsCegMO0rhWzhmukGpuTb8IdB3EN6U/d7jX7uo1skrHhNmsVKsxoyYUytER/HyFXWWl9hNOEwjm9mRtVrqSHc45+SeIcWd8uj/dok7bbRu2vlRq1vzeRdI5md1P/h1x2VFC9+HXy9o5b4sdEiwC8fhdmmW+SYE4pfaUcbsQ0ZAyMgAQlG5AESZmjCFVwwZzcHGHXdnvOBBybuRKCwwecmX6pZ/edzVLilYMFwF3n2s3rL9mcvulm4Rszvv/k24EzchzCh2lvrGZwzsM7fX6lW82NvMdQVf000dtEU3OE2to5e9NxZDh2QJ5nW3SV5PB1P8vL+2m7Sy9rBa47vKCEbSsue70B0npHDRntkN6EofjHGCGqIXOTzCEUe+jAFxW0qJUfI6KVIAufP3RnPRfnECh2cbq3LpqWCVpGFww5TDh0+RFH56tlpGryeqjrx8WB0FGlsRIBn39WL95f/3e/O8ez+dWs30rLfw7bj8j38SrkovFfIjviMdxmwnP445Ule+X7ketf8N2vslHna82vbYyeTVhvDwU/wt2XqxwyhN1/NZnqrN20zMDILcoE+x3r5wA4eaA7mQA2ioAeakxFEEGAANTKaZWAu0HupN0mHQ255VirCZ3xb124jknw5uD4ZhgvyNn2phmiGlmjXJ04dJkVBQ1T88H3e52LRU08Fl1z39zfRgn/KtX6ugVVd1Frmw1ytYCo+CH97YAm40YDPh4NEVmR+ZVy81oaPF4D1Yyf713/xog9N1kaQ8Wt5t3d95w1S84Cq0V4PuBo3NzCTgnOGZTkJhVGBUoGU/yIFjNCBHuiB3PALegAEEYOCApZ7K+gxnFVCuSdurBMqDiZaxednZaRaRLiDzLeF65Y+uTSENxhx0DBOW4VvsUgXAxd3TPh94Xcecjd+TFVE23N+xNZ3f8dFXuhFzLiMxTdTx2AJTLE+tnh80YCGd9c2brh/kTdr4PAL4wWHAliHPGJlw2ZcnoaM92ds6xcuJVKIEng4Ordzp2eBjciIV2AK+WAOH2gOlXiJmjUDmrhtoCM6FiUUfYAHYvBRmXIFd5Bnwyd8qFh/FNkzPOiKn1dd05cZsmhxPBQOUqJj0Ohbuah8a1N3YZJb+5Qn2Udd6BdFLzZVV5iMzqiF7fd+W/8lO05hNvRXkSJWZHS3jeAFh7nmDwIIh+FVhXlXT060h3uzRd/ETzLHJerHGvAYZqOHexSYOPdIkPdoj0QACfvIj/wYewBZETLwBAiBEhgTdYhVBAi5BgnWlsCXQnsmYauoS3ophBfpfO7YhxsJfR35de8mU9Vgf7FVD8i0adsnI0qoTMeYbO9FJU64J7yCjFnYjA93GiEZeICkk8l4NrNYfW2njSfXf7q2f0MZR3b4cqLRJC/nmgonGFDZeVPpO12SlX9iOBOYWFyJj8D5dFKwCh3Ij5RoiVIgAi8hApLCKT+wXxm4WBGlESVTSiikMqf4g6qolymSi1lCaH65Gob/pp1Y8SGDGZLWpFUfSZFyIXeWsVN1sY7YhSyRGWOXGYWVWVW0yT5dqC0Xd421KGrewAsCEYZn1JOq6F5IspRuSIepSXnk1Zr4J1WxKZtP6VzJJmTfaYZWeQfxSFgF5ZuH9YgniI9LhzFFQJwf6IHz4AskmBElgQZi8JBrwAY2Kgbg1gRc0AVjwAYLqUkZUSAQJKM0KlrnhqGjqVrz9nyx2JfhuWH2hqAaulLJQCu0VHGpKJnwuaXHM5+i0ReSyXcAymVqxBnTxHCD2Jn4qUXLhaSn8Adk2C0Hmlo4Bk7yyYZC+UbfGBmnyZqwGUA2hn8VKpMOxwy39ZdhhIWpUYi8/ykwupkSqaOI0vaIOHpZd4CjD0luvtCBkthdvgAJXMAgJ0hupJqQ5BYHNpqqPtopJCMDQZqWMigqfEY+SDqEwJNLHDl/M5WG6xBW1hRhYZcaWyelGtqZhdmftRRot0RWTMiYXcpEwrYmN9VlyBNxC3gkZ1otnDc1+6mZ3xSNewAK7vgUXUJ/5wmE+LmGbLSN4MAKZJKnA0gn6lqFgqqu+7Sf4wOEM6eocgoWVxkwWcmIQ3BBixh0Y2B1jICjicAIDMsIq/Cwv+B6JJdrjLCqYmCjCCsUfFCja4CjOwpuUhCyIvEQrro6o9g6NVirtqqkiKY+I8mXqdF8MROs5KklGf9ZrN4Cb+qprM9XW41Jrc+6JzG5hNP6n0wqn/rJrWu6asagChDWKnklja0wiORKs2dks1h7aDBpmsxBDu7Kp3B1GOgBqDLZF/ZKqGZjeIbHr7YSsB8KqZG6MIplBBfrsL1giWOwCr+wt9bQt9MwDeFoa9ZQdFDAozcaKhzrsR8LsgEmsmJgdT/KENbJOhFmoOZJp/eWb9QYlaVBjV84s8bwpFCated6mMeKrCOpthkZNC7Zi7EJmUsLmMKotLRbi8z1tD44prAgENK1oeVqrqQrnkdbLeUnJPgwQMfyNnlYJ7OZrinpZcnYcGwrp+pxEI3amwNLsIgldKUQsX9bsaL/8A5/K74dNw+VNwp6cLiJixAdm6NcwCmNO6rk5qHCibgo61z7irm6g6vWx3c3JKzl6bkmlRoc0iE4VAzGMH1iNZg5Kz6oe3jBm6wZGqYXF7Qvh0xRY6cwa2/XR4s45jUEfAm4+62A1ApwCnG/m8Kv5buieRZkak7IESPIwDdcq0fygC8LaBnNQLxO9SRNG4b72Y6+awvs46//er1aOQQFYiAa2AJ5+wt+Sw2+wBPgOA/jO16Byw3T4KKJy7GHNAfuuwSMC78ySghghhKkSKv5a7ruqIOLxiJBpFcS3CW44AkQRsSksJP4i7Wje7lGKFP9Cchz3MaE/MGZS5Ibp64E/4emfpxPsKSm1joOXCU+pzDCadO7b0qGg6fCc9rGnXyzU3ife8VE0GKHvcC8UhlzbOdTyKq6QlzE4um2jYrEjmSC0iYGkOC3ffsOq8ATfRse6RW44NWitNfFIIsFYIwGyZxAMwEE7rEFCbSx8KjMtEPEaxygaPN1PrMi/RvH2FyNTZvHBVx8uFDOBzyIK2yzDdyFtfLJ2Ty8hmxbzaQn/GS0jiy9kEwV6Pm52XQlQYxll/AHp3Cb4NzJ7gzKJJZXPvJqntaap6xGjFxs9uwVrezK4+oa5eq2iGhY2cvERsAI3usLpuCwCesIIq23wUwv4QgeeOvFyQyyRFqpJaQpX/8QzepBzY9QCjNzWjxLQyqSduPXDeusq6Rwx9w0s+MjM5ysqyx8uoJsoCrsu2fowYeMtMGVwRONz9/8ym26hWB4ePh6PuCKC2Nahpt71mhjtQd9szOnpTNGGC93T+TBjiT8SlVZ0QXd1N1yc/UVZoZ1ULZMt6Hwt7+QCBEkKGIw0gFWCtZADeEBuMPcooyQQHKJzMrMzMvMvqdD05r9Qp0wkVyHuYq3b3Hsvw53wKIWzq1kCzr5CeUskQCs1kvt1L2jswaN1rFE1Rr8s8iV1RZtrIXqcDXpTdZqu7CwTS/DC2s729A4KwjM3N/5eVuiyladtNDbyObZgHid10O9Ggn/4aGNJGZ/DaMm0QmQLQpX4BJE0AdTTBKMkNL/Yw0r/akdS9mWrczgFjIzcdl+ctl8oAgA3jpEDNpljY2j7ZiWxoRgFWq0xM9ELDtN4dqvfc6yDcvPLZLwVtu0lNZrndsFLmPZqrl1nb+n7cCvjU0onruTFmOlltRcNY3qDC7MLXb92uHgDFuxay3Uis7Ta9Yxe6Xc3cDvCN7hzUCMCKMEY95W7Ato8ElhsArW8AgjIAPvDczS8KDg8alfzN9bfkiUCzuYYJMDfiU7PdVuHKa9OHBLqOA3xX49yIx2vJMtU3wpi78UXuEMbuIZbs5A7ty4Xcj6K0hSWLRBRuL8qudw/55NaYQ8XW18oNAGmnzXtojW64znc1rjN+559BZ9TKvXFq5jXNjjvmErfB4WHzrLhtiISJ4I3rvFDLsFM8AHvvAOk5AQvQDfVy4NbSQNmNDlAmHTfyAh5OMKtkDsYx5qVRvbWYoipeksSwU+qC2zTzvCj+4ynHDi5FzqBhzt2h7Ie/7thknpNq6sEq0ZP3moXM3grYXi3VRLO46mSZ2vzLAIbSCuPD7jNBvqn47p+97cgP4lmt7vsPzarmVG5WPwE06IEujXO/cfH/2305BevtALiYAGmNC30uAKvcAu45EvYkIMmGDGXv7fGhvmmxDmx862pU6s+tt2CL6LCr7Plf8c4HAK4DLzCXtQ09Vcg+Ks79ze7d5OyWMH7hfO7+7cmarryFldhJ7u5qdg8jFVTvWJLePjXFo3DDqJZZKeLeLeimps9AL/1AZvixy69WHPn8049v0amlCtDP6NFI9KsjeROqqjE1CeXhFvDRTPB7cOTbC2JziML/dSCphgbjwv4fgbiBbO5yt/hmfOui+/eExI9UeNu3ZceCas84dP5xqWmUQf9OCu4bVt6eMO3B6OeKkY3OrurZR2n0EMeOSTDbmQFK5k9mDPJbZN+rof7bd/9q2x+wZa9czY+wjvgz4oMw85q8JH87++HolE94eFBrawy7BJ8Y9QQIAq18PwR6f/tdPJOOCfbfyIP+aJGqyi3+3fpHyP/8Zp11NSlFRa48N7vvw3P3oCzfMq5FoG/OY9CBCqcMHiNdBgrVitEgYr1hDhQ4PKjDWcSLHixGPJNGbkiGxjx2oeQUIj+czbSZTRuq1MaVLlNWcxQWbcVZNgq005BR7L9q3dz5/fejKjaXOXyWE7s7Vq8+coUYkXo06lKtXhwKo1s1q1eLUg160Vc0XsSrZsVKNjjZ5iixWs1o8fHZI6qAzUJ7x4SxHNlVfgJU6K6qD5UtjJECdh7iyy1UzdY2nNegmU3ItYr45JCW7mnHmYZrGdO2IMDXEhxIbYzq1mqRpmydbo1smmXXu2/7hxuOG5433P92/gsqFJtfVJkSfjfwr/8XsXcFu1pxUmFFgXl/TpZaWf5U565rKQcb+/dhm7/HmknotqdKiq7TCTQIMOXa+VWU9Vl1QRBdX0e9i3JDotwO62MgtAtbw6UMEE30qrL+hK+2pC8SQkha6GQBMIJWb2+swWEPESbLFFkOukk8Ysk6wZ9T50US4KvXstKhQJzAq7AcFjrRweyWsNJduC1G3I3OqJ50h5kgwuHJI+u2aX5BQRrI0vmAvRveeyO2g66v6qzjQtFQyzQPtarFA8mdKEbU02oZJJxvo4i09JcurMRqQXMUIKsMaGUaTK1uDqCkABu4xROzKjW//QQOsalRBRBhWN0MJDHaxrRTeJ4lBTqNzTC8TPMDtGVDedzNRJ9hQEb6eqnlxwoRu3xFG123q0VceVhNSVyNt6Q1I+oUpNbrA67DBWP71ExEvWLrX8EswxoUUwrdHqO1NNbM+TKb1T88TTFXBdyagnoCKj71tqM3ruQ+VA6XFaSy90FFJ6FU20wUjnJWWqfRNNCDlYJ5y3O+ts5bYlDoP9kFNUqy0o21VTLSghft2S6LVXc6RU2h1vbZPHXWvllddfgxKOL1CkVJlYZP1qWVIuY564LZm1oxm1R406ZrP10IT455GQwhRTbzsihtwk7eQ2zrWkhMWkXNpNh8XGbAT/60J5BXY0Y2YHhjRggz6xTmxcpsLX3n8jdJRVS6/D0DaET0aY4W7rK9vHN2Gk2NUDZ9wY1pjQbnZvuTf1MWSRh3wpV5Lh7jBLTyxZRMq7EmxOcBxjZutm0oIZXON8yxR00Gtj0haZgyWDDOmhzg316DqlAUfpO5nujCDJPXlKlWI/GQpUeK3CulF9iR/ceOQNwjBt0KtKnvmuZ8b57OuuCtnguekGz263jeFw+wqrl8lQqVy1mfxlLMr8vcQ9hqn963HLHmTb6DOuuec+vRJZzLt/SPMxrepz6DuUzqxVOpGcp3UqWWA2ZDc7cLwDgg+MzGUs2JPIVLB2eXrQhC7x/wfmdKp39wkeV9K2vOhNL3p02c7zoCev4fnPLvuioQs5AbAUqrCAW2JN/JiEPbyhhSGe2xyusAW+mfmNQRgbopiaVyjm3VAZ7YMNrhDnOPn9cE1EChZ/LFG5vDgnWcoSSCnQhrnNcc47c0ljtBoEKrV8qINBYyC5hJKOcj3wMe/gozr4+McJyo4Vl/GFBQcZLnDtTI4d3EwtNhEY3YnQDr5TotUKdUMWro+ILXQbCnM4thdSJ5NZq55FoCgrCGHtZjH85PmuA7+OadE8QRQTJl1zxDdNrBiVpBATVbidwHVNITfEBZCAaMXE+XBxHwtWsHAhuTJ6KowfFAwIL/EIVf+Y8Y0dxMkqCRK+YWJSlWbhTDkTmS6jwQ6DEFRSBPsISEBawxqPmWchfSENe4LDnqyIRB8IQQhMBDRcjJwYluxwHE71pw2UvEYnShgVUnzRE5qkqNgy2ckB+k+Y2xkeDT8hEVWi8FndY2VGOenCZNIvJbJkad5kRcwf5U1ihHMp6RTURGbx7aVskaJwjumaZNJDmS/RyDIRlrJTRAd/kyNMYRYR0GzCMY6f8YoavwK+Tt0lnKQUC7gIUgpE8iyRCXSJA2PHziTB84/x1OcD7fnWQv5ikJFwRByC4AIXsKALa+iDNhkpzT0ctE/8qdJHS3WvQkl0lB0FYLOyZlH/eZL/bMpjrGPHiTWQYvaxF60sRk1aM+ORQplAnFvENgnJYBgOiaaNBS946RUh/vJ/CtEpmGxJ2hkx7opFyuIyUYeek6DDGZGLpjTzwlTDPDWag2UYQW/XsNB0No6wMCMmqmtdqO4EGRaU3TphR0F3ylO84yUvPuG6CmL4YhTqHQUlIGHXG5zABPKlwRL46givLhewe0DoinLBCSdMshwSQdW9nnmcy4aysSyMoXQzuljKJriyMyzGlyAs4YpW73jMGm3cVCvAf+VuGbfBJYhbG6jYIuQibvRsK3wZRZhicXu67ZWvsNhbpNxSgVDSz5WWCsIwJIY52NTfi0xVNzMt0rIH/9lMQInsZCeDVVzbdaB5D5neB5JXy76Qp3kLiV5RhHkVYW4vP93AAhpkwAQhYPN88cqFvubXx9Rkjvck09A9DKEOnaBaiukVUQRHccEADGmhcQFZyYoSw4UO44VmuOjphDTCGh50K3sDSw+3FIkPyR1tWYNVvbVilwNmFE5PumEoilOc16DijHsY1N34JNZGZSaQkKrURk8OyIcRMpCt+Qgiw3FhzCDVuKimPRAlTxUBvcQ/+wDsZ0N5EmA1hSnA1QtXVNsUlsmnl70t1/OKeczjJnMkvIACE2TgAhpgd7vpywZry/kvILQSp5rRiToMQRHK6PMpuxO5QG8V0gyWtP8jYbhYRMOwk50VdKMZ/fCCQ9y4oGjxsikttlljmqUIu6VYwnniT4PaxKN2lfNUzEa1KXVSNYFxjB2HDdOpNNY1nnluaN2kLXrDGJWzCV6Iq2td51sGMkhMFIxeGDQQ6w514MPkrpmsqAJvaFOXqqSWjYl/Nj0OeNj6s6PtCEGAHeyYcEQktA3X9doz7ewls7jH/XZTtPcNNCiBuj3Abgi4m81jEISU5TylHtv7E3YYAicw5dDQXYVyFx54w90W2RYzlpXFkHzkId74hWuV4JpfFvO81EmNbxzHWtw0JJOqY5GPHMX1CqUHhwm402LS5SrN+auDxBuhjJ6BOF+pNFP/mTJdk2jphCE6lYLMa+QfXTFJV3rTE7GIRPgl6kdubs+bjPU1ZF/72fd69/ugh7Kfve1uLzP5RUHXVUBC/euPBCXOf+a6r/sBeZcA3tltgiB8vxSruC7gn8bvw2uDwrszPzO1nVs8hwMYcRK4y8s8slG4Jbu8BGS0R5NAVrJABgylB8S90Ms0FMOGChO41AO1JCI9iRki2tqkNoKWGEqflpu9Wnkfg6E5Dsw4D0SmnaOLH6M36FMO5HM+5aAS5EMM5SvCMAgDY0lCY2G641CsIqs+ECmFR/gnMRADNrhCLMQDPfg+LcyDPAiFUIA7MTM79TMFSKi2Mhwz9ls/QGg///ejhLnTgDWrPzqsQzoMAjPIg/2TwilMOoojtqlTqEsgwJwppViQnIDjPEXEQIlrMJ5rQEaMRCfkrMp7PczzlFPoQNFbKZc6odMbwU1TMS3qnJtSQUMxxY+rLVWKMU3xIRq0Qd3TPQj5vaBjmckpjB0IMGyirj5sKqMbOqIjQmEcRiJEOipZQiZ0OopTC4YBKzyoQiuswiz8vjxgBC90OzWkKzZcw23MA0iwxmpkP/eDggygP3OsPwVQgAi4QzM4wzHrhERYOt1Rkam7hMJwlw3yOJtBwIlbRH9UQEV0wEj0xAwkLucwSIRMyBUUyIH0x1bQxE38MFQclCOqCMBhkv/VSgYUrIWr+KzY2xdXETgRK5zRgrVYNCbh0iwRqcWmaDblKL6nchE+7EFfJEabLEbDKDpjbApk/KLpw7Y+YIMqXAIlmAIszMNrDENROBFv1MZu9EJwhEovDMc1dL9BEAS6sz86TMd0TAA6NAE2cMcT6UHmqsd7dB1DFBgELMg2isQJrMRDa8jLU8iEBIwssSy5BMg2gkiO+zAX5CQ9IUEVJLnwCI9S/EhiIrTb2rkT6jS5uQ8bM0neurEb3CzgK5ZjfKpHyDch051z8rH8oMkjNIycHMLSPAzS3EmeLJaAk8Ls44KinALZvMKkDMNrbEo2rEZr3ELe7M0trMoym7v/dFM3+uNKBBiA4/zKJqjG/fOnRNi/qcOURSiMR0BLrakwS+Cvg8MayDnIn6PLf5Q+Q0vARuuk7vxH8NRLvMxL8KzBVpulIII5jTTAkxtBNiLM8CGijlSw1lK0nsos4lKZ/RAuVJmNX9ktWTtJlJzFMBqRJeQDIhPCOgi8wJQqLAE+l2w6a1IZKcHMYTw6ZMTM1DxC6HtN2IxNNnCDPIg7qZxK9ftNqVRR3/TNoPxNq4SC4VSzEyhHCOjKBBCAAghSOmwCFUVDRoBO+FggUZnOL8CE+XgGmkhLasKksShP9AxI/IG6t8xSRdzS/PFO5IAcuzzPhpPE9EQOIYkl+IzP//Q5QdiyzxwxQeFJwf9ZwAFBCKzhhCl6klUMjD3QU+HQCnQoGSMJGff0wNwrh+pp0ClhGZ/LzP3gCVp6kOKqurCBkEbFzOajN03lNabjgyscyqJkAy+kq6msxlOlSt7cOjOIgxk1gxMdVTeAv3XMAFtFAVvt0QVQgAEAUiGtPxsgVUYwQ7BSEcw4Vse4Ez4wuuqUh3N5kIiaqEv1Pf1aLmEztqGBiTOKS4viUm8Vz6Ua0zMFI7a80u8kLtkTKsrEre/JyGqgF/kMxYtcCcFEjdlayMzhhGIasAu9oWoqJgLFCCOhk99wzw4jkmtwtEZTDtb8lD9pyac4mJqaLuiqWP9+qwllcchoZckjNNExoM0WhUpGiMoYbdU4aFU9MNlWHYP4crP5OoELWMcHiFlbrYAK8FFfRU51lAD8Q1ltwzZ6NCRpKIWmSgRpkCD68DiDbEa+iM6pwyPIiNrVcQynbYaTMBWp8ju/2tricpknA1POs8RuMtf07DRxPVQ1vUG/MS03vRjDnKnpMCLBdJZKWx+M8Tl/Dax9CVjvKYeSCY7ILNR1RVh5wdtF0NQeyw9ILarTGUHt+RmiuVisnVxcazZgO0o9CNnMTVWwg8pZVVmVbQLRvYGWXTM2i9l1lNkHyNVd7VXX/dWeFdafNVbLMBdMOD4+6AWkzcee+8M7clb/dUhW4VXSZJ2a4LUjqU3e5H0nyEBaPUJaqW2dC4rCrL0S6u3aCCNbupQox4RF0urLwoyYtq1PGEE5juy41cLTjRRb0DqhPa3AwKim9+0IX1ESgpUPQiVJImmG/6rSjXXUEGGZu6k9nMOqw7kPRN2VZiJejnCFXki/LvRClc0DpNTclD1Z0A3dJuABDoYB+kI34py/CEjHmm3d101OYIUClB3ZMaPdo7mMR3iCXNyCSYggDSIVnkGaqY1OI6teUHmdFFmn510rIi5iI56Hd0BiIp6ntpon5tWnoaDHHu5HcT3XKkbES0Db7+W48G1T7hDFeCVFnEFf1nIWO620/+TT//81lljIrYlYCd/gBznehznGX8DlQJQUDoXlzuGLyaRQjuPIhcPRtPgMLlhE0A4zpKnMYAm24M/N4JUdg9G9qxdAAUu+ZJg9xx692QU4TuTU2ZnVANJVYVcdVvRSkQrqhRiegaHzATzoBRueHd4tJ5wQV6CrRaVjvk0Fwuc7ESk7ZVSOIHkyYmLmo3k4ZiROZmRWZmQ2ZiUGJOWd5erC3n7MCbusOb5ECTj1YgMbTIaoyNlCTPbVHEwiIcrb2CkBVKJ644Gd4zqWj/v1DbmBm345yEa9C8JaqFbkRNSbJdtDZIAmMZ8gBlNYZEjuzVN95KPU4A22gdLFZIjG1U3m5P8f1VmvzLv5GmXaPNJrM9ZVlgERCOkfwANR6LJUhgVMmBIhTL4hBEbEcGmYFoGhC2mQDsYhMIIneIKkQ4Ps+6eR9WX+y7afbWG04zbL+IVfqCfzAi96kqDZQVomdup2eozYUZoXzkc56tqD9cv0lRivfov1/eYC/ktiQsW2HLSP6pE8jZwl7Nv0KKqfcGc6Jti5vuNErQ3KU4ZOcA4HVYQa4R3/WCBNY6l/xmZ1NWzEhkhy8AVTAMeDztw83NwLXlkVpgKTFd1JDgJLVgE5PAFc3dEdtVnR1tXkTADT3tXO9mAmwEJGOENqyzaiBemQxgDanoE4qDag9Kc5KAyYtsn/X9RJCeXtl55pGfgA4z5u4mblI8jpK5AC527uK0g6LBADnv7YZ+Q6UMWDRNBu7u7u7e5uaBtZYOPo6tLaMXPg2mVqG04apsag7RIJwc3msc7IRAHrOJXXNELFM4ZAeZkRvPVTNuZqn5DrJEGaul6S4MKjlARQwPC/pPCEpgBYBObEtJXMxH5FDN8NWeItfCpoSF5hCg5xhbZsEqcCKMhsh9YB+mq3mm1xHu1R047xi74/D66vvWID/WNhV4DHGRCB454AIG8AEbCv7LuCHehto2M+53sZKeza49JQITSCl/6AIUjuEZCBXMzyKm8BLjeCLv/yLicCo1tuMWduI8/p/zHPcjKHbjTYAul+c56+gzVQ8qwbb+sKF2JA7ypT7zqJb/kWTIp42+0hGFO7yNja70NE9MQkuD1lBkZN55iTqWeIa3eejz63a+T9Bn7BWxCyA321i97hN+EC31iy8MK+cFP/IZsjaGsM3RRFWcmW7JP1Alov8UnWAVxX8RVncbwT4eI8AIu+6HXrYA6eTWH9aSkMg9mubdqegA8IaWiv6V6Dpuk7ssjFYf/FUJWW8ioHRplObpcWaVYed3IH6XJXbi8/9x1Y93Mn86N796Nbd9Rc7iOUbg11vjvv6EFSCT/nSzJOFba1kUI3dLT4uDItV1WaomyAX8kJLEtw6/n2hv86oWN94Ad5/t1B1RXBtRysEQw2lojD3bdB3sRUL+xTN+xw0Lg7KugahdVXj+w8rOARb1UTv/VcV/EU0HXi7HVfnz9gD3bl1OwkCAIUxXHxHlk0GIJvv/Ie93Fol+mjg9A7pz57u7PHbVrQZNQ2l2F2f3qZ/nqZ7nFzZ2WaVvdzx/Kuj+lxj4K1nwG2Z3e4R3t2Z3t4r3ddHrKc6HdlKjFLIvT7lJFzXnT+VHTM6pHfy9s9aOOYot84rniLz70Fqo0ED9S7MdzA2gPfGbw/HflSXw1U93zbA33R//wKzw1W30Kuw9yUTeiZt3WbT3Fc33WeF/YH+PnUTd29m2QlKHb/oz/6KTRzInBusUf7pnCa/6MjNuX70EC8ve4LvMi6muz2bv92bw/3sld766/p6yf3Lm97uWf37397eX978l93Gjj/NtB7H5rv/CzAxHuizFO0g1/rkOoEPIKJPvV4kHSfkACIbt/a8dNnUB65b9G8LcymUBxEiO7SUVyGy5gyXqpIcbKkyI4dS7mMcfoD6pjAcedWsmzpct3LmPBgtqS30ubMnDdxyow4UBoxVoL06IljlI0ZN0QB5VHq1I0XKmakUqXSRAfWIFlhaNWB4sTXDBrGQnhg9qyDAgkiPBjrYayNJmzGXG1SJMkYNniI9nnE6O/fR2sGb/Gxw8mWOXwI/2GCNezY42uSy1GebFnyMsyZNSvDXOwz6GugR+ZSVUqVX0Kq+aBp3frLE9hHohiWMeO2DBG2d/O2LWJE7t++e/Mesht38eK3jTuRQdvJjujSp++IV+86OuzZK1NGx70bNM6Zk5EPbf78aI28MBaLRcr9xc6dcbn3ZB8+fvwc97+/z6kVR501o8wnBe7n0UeKdFZZMwwi82A29+xTED8IPeQTQ884lN11toyUEYAdfWTHSapYQkpnKtWkE4s0qdhiTzHCyBOND5FDDFCiQDLUUUk51dRTTk0V1ZBQbJUVklilkAJYJ4hF1llRamBCkyfEdZUZc41xlxJI4fFlIn1NUv+KK5g8QghhfyiyCZu7uPngg5fJKR6ddI6GYkbplWYan42Zeclqfa32h2uFhnFoGIsR+toXbTjxKHQ7FGcEpENUytxyxBG3HHXUWafddi6KmiF44Y13Knvo6bkqaPChV19/78E6K3+1+kdKOek004mBHCky4prfUdaQqQvFM6GFF5LaUHa6ftKZhxshCJIquwCYCzMR1SjjjKP2tG234KojTY478uhjHkylsa5SUkEFRVXw1tVVkjYs+RW+TUIpAb/8gpXkVXklhceWXXoJ5iNklokJmiY59jBkcRaLDcUV14mqxZwFExqe8aV6EZ8hizwyao8UaCavBcLSJ5stszn/KKF2GDrzc9DtZpxvuvFWgnLR2fYpqKF6S6ozGKeap3yvgqzex64mTV+t+clqK9X3KZMOZSkfCCwncy5kKnkaHishRcqS2mw6SBuzUYh/hLS0M2eHO/fQ3NK9Ik4UgQOOL6uYS9SP6gJZVVTwFm4kV0jOqwMPjCee75NTOvlvwPJCIbCP7wqsF5il9NILw60xJnHYExc956mo26k260ezWu3SbpL2MOwe2v6Y7LTrvjLbp/h3JqCLCM9HzIxierxtJUSnvHS7AR103Q5Wg6rrqr6+Xp5OIw3rrVHH2r19t+ZKWa/Cc43RZcSaGidBFZZtdobZ0be9r3u8HZ+GeIPb/+KLMvpvN4vGtTdfRAISBQSEU9LAFHW9K16Go4rjkGSVIyUJclQ6QZIgaLjNZc5LB/sSI1xRptbsYROOgUzpTKe6i7GwdUczGtNi9yb0oTB3pMFdDVnFnj3NbmS26BXwhifEO8iMhIz6wqOQCB2yQU9owlqdRaqnwynGohYeA1GIOlK1a/UufF78T3+wVg4CgWJre/hVsLKVPqJBxhvyeOM92rGdszHEO6bJ1p7q57BqpURU+7tb9P4IyAAOsBcGPORQ9LBABhLOKkSaoFdQIEGA0WtJN8gX5eQSr8r5KCmAO8oHE+YKQrShhBEjnQpXqMpVsrI8UpTP6TT2QlfSUv9VuLOh7T6TSx6W5mQGOpPvXLYJQqBxDnF8nhPHRxM1QvGVVLze0mjlvS1+0VbN0NU1+IPG88EyHHSM5TMIAsc5yk0hKBrQZ9iWINjFDUMADCQ8BQlAOQ5wFaY4oOAUyMgHHk6Dl5SkDoy0OEpuBQZNCqgGK2ckDgpJSx8cZaMu4YoHuRKVqWthxlr5xFJxNJbdBGcqYVjLkZL0hjvcpUnz1Ale8q5NLGNiE5VJtI6Ox5YuXM/Gnrk0avK0ml/sxPhWWkZQIOhXZ3wWDb0ZkY4+JjvjhAgzL1QazxTDQPa7BDvr+K1ByrSrO3nnH/UGFF+MohLmyicjH1mFRtZFkgv/neBACRpJDD6wcgFj6Cez9MFEbGIOX5iDCU+YQpRgNKMXzehGE7vUkHa0sc0kKWRdeNOk4ZGyroRY7sYZU6+ysaY5vSI0n9kxafq0pyeq5vjIaEajvudDk3HnM043kKdiJltzvCMznJHHkuwxM2CV5/+6BdbZDpCsZMXnG4ayyAZGZa1qxYGS3IoDeWVQoAQ1KAws1xVNYsmTeXXoYvAQM0KsrI2D1ahh06vYl3xzpo1NbHpF6llnTtayK8wt2MoD04k40Tvk7Cz1bCpD0LKqFt/rKYIXYbXUanObavIE3LS6WPxma5wUtq38WoGLypqGI0etYjuVqr+v0ii4XB1k/0IGWFYdHVAQi0yrWmN8g0hO15E1nuTitBuExlE3oArt5He1BKYwABazFkVvfNW7Xti2d8lJli+Uo2yew7ZSs3IUWjK/E+D6Fjg92WtPMA5ctdL6iszPqkyv6pegX7X2MxKeMArHliH83vYUNNwtmy/y5hPHSMS/BWSK9/aLFRfwDV5QSnIXCYcGxsG5/rwkQhOqlS4wIQhvrbThjBIVSwt00hsEclH0mpe8fEkxjUEGZs/rtcogdiUUczJ7/dxk8MD6yR617Cwli2skTwxZ+83yRm864GEPuFUbq2KCzazFS/yUmaQon4PZ3ObwDC23bvZvVPl7DFCo4nTpbNuaNv/szhELN7hgtVugp3HcQnuhC4ZzcT6d2y5HG4kFkoQ0FW4sUH1bLtPz7rGPNendwV1u1HnhqwgfJMJdUHR6a3y1lm1da1m/eeKOpbIKpfxR+64avkTz9a+BTVMux+7LorVi1RSs7GV7UeVWE2ODo60IMOIPy9heG7YGBE7/4jyH6nxwMsZdYkCaG7iA3ps11M3ioUCBBu4OaKIZOW96R9LeX0ESvy/X78sBOQ7w2u5bQa1XrtNlDSA8IZzctHGPQ7ztrna727sTd4uz3da33jXGW1j3OYEcaCIHcOs8FlpoTi3ZWwufy1GLNa39p6gOnraEhcYMGyY1tVDzeRnXSW3/bxnd3N7ksx8D+MZ3KJ2BXajBDShtgiC4YbnJRbRzoRtdGhyUSvzUurv73aOxp96uckFKQx3KBVL3YUwTbfhHHx5sJcM61k6e+9vtTuW8r52FdO9G3/3+dzt9dlXR7DLKpUbNxCOezQo+P8txlbVayVzl8wux0K5sLQ2/H8PeIMlJrL3bqwZd6OQuOugZnUrEw7iQ3i9EwlJAhfJMFw3cQOsp2us1kOxBl5NcgL5EAA0cDgtcjqXlHteNnY75XifNheWIAaWJAR6I0imd1/XBXQs6397Bl/TxGnrFoBtVCMjx1/bJErF9nw8aW/gdG9TYCvkhHvul31BZRsxFm9XA/xLaPKFucRHDRZVGdJv+qRO1QMOF1E25nRuJyZMOigs4GCAlNAXTKQ/rwQuioQIlDMICSWAlmYBZ0FUGOIAJfJ3tnSDubd3WiSBd+B4HmmAf6EHCoZp5QZ+wRN9LIKJLMCJH2aBjRV+rMdYM0uAjCos9ZGImWpmNMNmteV9+5MdnjNYoCmGyFeFpoR+C1AqaLSETfkIuURsy2VEwgZhHtVbR4NwnuMdVxcLX+F8AohjdhGHoFeA7DJq5xMEbdMEIZOChKZcwsGEbDoKhUdfXncADHAAGMmAGnACl3UAIXAmWcBcfBhwgzssSKEE6YtrwDaIpHB8KpRKtLVmfwaAjvv+gN7mgPkYiP3ZcDSbWQYyhZnUi/MRW4P1gFYVZ9wHhsZlWmR3IQ3pERKai+rWir7Qfs5XIm9TRRDDR/fWOLeaifUALnoGEJ/gWMH5hMglji+QNS6KDOrwDGSJgUQjCJEABlVhaTQoDMKCCJLThog1J7JlAWiTACWzajKle6m3SdFHaBE6XOZ6jOu7YVFZaOzqCK7DCMMAjKs0j3TWiPSriPvZj3UEiWVqi8m2UPwTkOKVYQXJU9exUKDpNQs5P+LXZs6WcRJpfEfIUUDWIKz7eSE7eRnak34WHFD7NfzwN1NQBteyZFwpgS86iZOrgGE7DNISCjsBbGc4FE6jhIFD/A09KIwIFjhegwAUcgFpYAFggjqc10DhCpexVUkDJnl1R5Yw1oFV+ZvEZnyFKzC+GpedBH3GO5Vfi41kmp3gs2TwYhDawpVsSpPrMVwxNzVzapVxCTVXp5UWioirupcsViGQwnohskxAxmy3cH3twpPYlg3beWYBcYWPWQddwVmRulUq65NARI+d1pEwqXYtFAiUM6AFRAjDw5GhKIzXCgRu+AWqyxQVQAAVkQG662wg60lXQS1fkpm1GZYbmZuPgJhToQSSwgolqZVdeYiIOJ1guonHeo4r6mQpR3GtFHFomXz9KgzbkA4/yaHPK5N5siJA6hEHWUnaKokL6YOGF/xn4dOcqEuHhFSGDBOav3IEQ5dwwTFU0GCbQdMMQ3tliyqd9nFEw1CgAhh6aTqZ+rimK0ZM+WMMvDBqLCWgooEJP2umBImgqlBVpMsVpTknh5KS/QUVSNAGGdiiHAhRWWNeHgiiILuobDMKAVkIlaCWKQgg9smhYwqhw0qinmuWN4miMhoMB+YI0JF0/9OiPkgurkstD+FwPLWlC4qWBJSmCDVWUUuStVqTWYCQaZaQazZA4PI/8XQvHLKZKQY0lkMjV/N19giE+UGZl0oSbqhtZsZgoDCieYmbSYeZoUmqLVYG9WRog+IEhLCjgNJR2PeWi4iZV2mZV3gAPcMXjLP9qFQBCAY3JJJwocK6opnYqp7boqIIqwaZlkq3XIRmQPfmCNfAoO+RDc1pDIQFFUNySDbHNXV7nxohZgvGlNmWkX04GlZonsGbDFQoEsX6ksbpJEuZJL5UEiVyDs0YmGLKptA6jOP3nionCPQ1ottopNYimtwLDtTZoNYJmndapH+RTkRzq00Floj6qOU6lvOpmhd7rIExC1lYqcAan3P3r/+RjwHoichasmY6lwdKa1hbQPR2SKPyCMFBDj/LoNBQSMTxGwkVLyMiqFc0Px45f5p3fr+oqrm5RJzRIOThp+6mJ+2mI/jHcE7rDGCGpRNLPmO5BMcDPmdos56pp55L/W7NYw3/GKc+aQrae7oF6a9AiaFkNhaHBXrn65LkuV9MaqlxREKRdl9WC6DNubSGwwr52rb96YT2K5diW7dkeZ8XhoyMgUvMqLCPkgT39Aqr66DxI7N0unN5uRC/Vat9WZ+GSGV8JLng+6URyrHhOLiks7itiCzb1XB9pWxCuDdDtFm+d5Nfm75+BCrTaxM0KYIq9KZyKgmauQtLWadxi5up6K6XyyKE9oKQqbaGxS+3eZgVdndRSEr1y6HRFKisUAgjzK6ZS3JmCLQmH7fLK6IsqL8GuqCI1Lww7QiekSydEb7qYLmY6LMTCaS+IEJmYRspg7C7WjrKyHBISleIO/+7hHWGtpC+vOB77rglS8dxoGIv8SiEohAQslqSC2B+27S/0hDGLROt1kLH/smma+ufoGtcBw63qKjADU8IknIs+TSqBCg6hSkVc7fG9ZfCRSO3lJBoIh/CJsoLXlrAJ/6vmfqpysjDyhsMgAoYk07ANJ6zpujE3+Chm9s0q8EoQs5T9GrHLqaIQKbHwQKS0Ge76RbH5OGYSShX2oMRATIRovOclmKT9unKK+JfAbhWXijE9APP/4mxHXqa6hYIvxCn1YvICa4M2sK7RGkUeUELSAiXTFgkfz14Q9PE2u6ujUk4HvwEcDPLv8qtWHvKzwlMi+98jOzLyRnL08oUkA/9GupjLX3jOKADtPGgyUHjyadyR3hbuKc8c+XpCKQvmKa8v4VKTyLJyldKnyghpLsayMn0ZUZXSUFlVFm7h8Poyf340m0arSA+z5yJd0pGuMqdu0HLDAiMoWZWmNFOznLrhNWPz7XbFvXFzBgMyFMTAG0wCOX9wpYpwCv9fMCIyjLSzUisvPMtzHsSzU/8FU0j1Kjy1Ablxj1KDxG7l7fxQ8JDveYqIQZeylZoPUe1lRBrumSXxGclcHTTuLKvn90qGd9TySHyCY0J0r4DEH4ibfS4V6BLjZvEvdoy0GWuf585yOwgknKa0GyswNxzgUvyNUfxIKBxonxKcHsdmBbX/605LrTfb66FJKiGXc/COcDobNVKjsNiu8PGKGOIqNV/sRVTXNlQjkt+88PTKrY++Q46QyZkoykGT9ViTdViX7xLbCoFk0+KWZzGBER/N0fyFJKvddV6rXIGMSNd4sf7O0/vYXEkbtv+a8edapkk39jI/diaLAht4mr05XRWIc+x+a7pQsO1mc2frdNRKraKqYaSScwhXAjIQNWSq9lHLGrWCnmu78xczODYwAm0PooRPeITXdrpI9d/8xW6rqjX0cCIoipWWdXGPL1mXtfkkNCmvL/qyn0Ozlspk7gBGwzGY4rURponwtfBk94h0G0d3t0eDNHjnBJeS9xmXt3nH/2RjnzScQjY1RIJdyKsJlEAHNCDWIjAqhEI0F8lN525O5+436zfYRYV8B/hQf7CJovZLHnh+KnhLLLiDIyeY9AGYZMmc7wWd03mEX/hT77k8MwIk4PM0vMOPBkUnfLihD4+hB+4ilLWJEzRaF5UWUQ3jrRkrv3Vr8biKPIObzHV1f8JHOKaiZDGo51yPp+SaA3kaC7mRq3oYipUBordjy60ouAE4eoCEOoAGZKCL2emVwzTAEZQl0WaXY3BoR22NxXe5BjWlUiqBp/qpD9J+GngXAuxSu/NKhEmdf8mX4DnndDsIWThfPHWYPHUn7PYCg06hJ0K6h8m6L/pwo/hAG/8hEg5hi5/4HukZOX1bLfQfQwyDJ+S1K7dyzEo0YPu4TEVukDs7MQ+ERMS4ZZID0vHNScd6ZOeBXYCABfALCDRBGhhCNRvCkKQBBNkAyQc7kpi8JQU7JmHwsFNgOMMBg5J5gA+4iTo8Gj87MU8rm1P7CfO8z4uYnEd4j2i7t2870R890WN7nO9FnHfCZcNxKKA7rxz6HZh41Zt1in/1WJtZvT/3XWtpp9OfUk3eogP8NpWSFeYPMCY8wgMb2zf825d0ir2RSZNu0iawMIC8DcihBNhAGoRCHlSzPq2LIUxzUzw5k6B8yi9+vmDwBv8T5LMAQsm3uYLwspdzOZ+zzdf/bM6/SJpP+zr/fDuHF9J7u+l3OyjVeaiZAbbjeVEkwhiw++E+vUz+gicb+tUjephs/XEzm6N7J+P6KhRj0RTDxIx7byypQvFcd8z0Nfyxc2orPNwnNqobpjostqD1TYkicNBSAxvWOgj8PeB7fJ0aflLUd8cfPuOkfAWl/LDP6+OzPO1xWnzHfOXLfDk7Rv/c/KoDBDyB9MYNNEgQYcKDCg+eI+gQIsOIEM+Fq2gRI0WNFzOW8/gRJEdsIkluxHMS5ck4KVeydKnyZcpEJ/WgnGkzUadOq6xNm/bOZzOdM2cuKnrUaNJLSz0xbeqUFCdFf6hOtXpVkaVFWq12UvYJ/xQpY868fROHrFitVqdwJTvm7BioOnPpUp1rZ1FbZmX5huzrF13IwB4HF15nGPHhhYsZL/zWDjI4ydJ8rTIlKlRmYdSEpULlxYSJNJkNlc6cJ00aGzqoNNHB2kzqNK9p166NAncQ3blz78Z9gveN117cwIHjp1DyQJUCLS/EitXzQsiiFbSe0KJE7RO3d29skHt48QLHbzTf0W839SPPs0dfsVQfQoRW1sdjhk1+mPpjshxzM5H/9ntppjtm0ukXnzizppNfhjrqEaSUmnCprR55CqsMs+JqK6tUGQYssZR5RpyzjuFFrVh2GebEReyoqw4+5vqiDlBs2QvH9a7Zkf/HHntMj7DEglRMSMbM+s6gyMhRUhprfnkylCcTfKUzVN4IgorMtDQkDSpaa401115zjYouxbRNBxTSVDO4Nt28QU0ciCtuEOUOkSS6O5WbBDpWqrsOUO8EHZTQQh8qD9H23lOvJEUXPUea+NYgZA37BuRPP0w1xY9TTgcUcIz/RA3QQJ06aaYnaqgBytQI50uEwgpj7bCqDm3VEKthcmnqk1zIKguuFFtZURW72kCjri9o/PCtX6F51kdlpF1m2h+BvLbIErXdth4k3SHySMgem6wnKbVMEBhU/BCkCkBKM41L2eSdN4t6zQTztjV/25dfGNoUDgc5q0itzuQqqUT/T4Oji44667LTDuKIDTU00e3MQ9LRR89zVB9iMJFvUks3zS9UTVXC79KTSh4DZZVRGlXlUlcJxRqgVp2mMkYghFVWCmmt1WcOf/5jE13D8mRYZ6HZRZVTbARxxmORldGJNvJisVlqta6W62ixzVaxIcHlluxvAQ33sSXVlswaURjJAxJIMEPlYHa9IC610lCjV1695cX3thT21Xdff/vVbbiBjUMuuYQVXtjPPwOVmKB4KJ8Y8/IE1Zw88DTeGHSO3nnHFEFeHdllk/PDr2Q8WF6Z9ZZFbf2O2V8ew0CUEOwpH26AytnVVyUcOsNbjb/KaKdWNOuZE51eURGpkZ1e/1k7ns5a62C0n7aYrqvN8WvAxi67IW/NTntcyX5ZJe64RaGEkkEGqcILHITz0l7ZvExhtdVem3d/aOoXcAr3G8MREHECIxjjDnYIxz0ucpKb3OUoWMHvcIdQGGRMoj4XOtDZwx7gmEQf1hAy+7CBDyTLlApZqDrXpW5lMbRd7UIVE0YwQhS8m8cOneSKGxZoDnwQ4qvs8gdCbOh4xyNa8rRyiaQBy2ilwMQfwlBFNFixil9QRK+wtqK01GJ7YfSe17D1HiGRD42OQduRmkSZylwGfvEDhBuoEDAU+I81+dsfAnWwGi8FMHApIBwBCXnAw8EmNgtk4MEQdrDkQIdPE/+04CQnKUnPcc58GOsgBzemD0/awxWUMmELSVnK1L1QhqESQypp2MqVoTJ1OEzQPHqXj99JESVDNNBUhphEn1XlRj1zInUgY4umxeeKx1JWFJhJo5wYE5qxkOawwijGrlmrjOIbXxq3ebY1UqZcvyCNHOdYvzUJLnH1KtMfy9QlQQLyNv0THCFfQ09D9gYK+FMk4yTRSMfxKYLWwQc+KEhQhljuoAbN3EIxmclLfu6hiPqkPsDhwxTCsIWpLCXsWKjRldGQlRzljx7kliBu9K4f2mibRV03hyAKj4i+RJ4tKkSVYZIoG7u4BCymeMUtVLGZzLwDKHQSoqg8L0XKaEv/98aIzWz+ZVtRlSo3y4Y2cPbESZiJhPzcQEcqxAAKaFqnDvKnxz/GE53zLKRa35TWfNrLOGfgZz8lsRzIPRI641CoJSmZ0L56p6EMjejFOre5h0w0hI4Y4kY92ljHhnSVqoSsRleCQ1GYtJY4swzIeglTmRoxebV64jN42lOf/nQHqY0Csi5k1KY4bS3WbOqOytEM2ta2HOl46lQ56c2xLSkbkalZON/HVeMU526Aqw0725kFQAqSNqvhX5rmWd15+gZObEonwY4z134aTGGTmMQm8irQQO31oH7963rL51CKmXE8g0IsOFjB2Yza7rEqlOwUJqtK/kaWDVyQbH5H/2rZBOWDHSitDC49G9OYUiWYWOFiTlXxMZf+FLWqfQJrocIJD5NCmt6r1kjcs1uonlibVK3qkiQzOhf7pG3xM65x4LBOMK1gubCx11ndKt0TUDetgvQXdIPsVrguzl2loWvjwBudN2xiErCQIF/VmxCCorfK7NUyQt0bti4zBrHviJTLSqgp/ZYwsmnObyr/q2YBu/nNlB0pSvRwmQRRA8G90ywkatLgI/IyRhEW7Y10hQlkYpiZO5DBDJqJrA7HFoza8xqJKX1bj9jWxJtc8RrBJVx5uHh0MKab/GhcantlgTY4Xu6OV6DqtMqzyECerqyNfGQwGEcNSl6yIysRnf9CbIIG5C0vcC05UGMb9NjdogeWt9zsLTvsy+n1hz9ASFH6hjI/F1VZf+G8Zv+ukr9tFre4ByzSlqXkbZDwxTROyg5323IU4/WzjIJYCprW6hHM+liF5/CFLdBAtSMQwQhU60xe9QpFTB0xpUniVNxiGsWZ5u2mI/NpULt4HtQQpyFIzd13pebUNvbSCvD3GhwXGeUpB451hzOv7jKuOTH/LngnwQIa0ACgxD5v5SwXj2T/fNk8F7qzNRhtwUaEvfNVn2JDpmbXlRvNToe6R8cN7nC/WcBVl/N9XKIHrwuipOxGcIK14QuWEtGlS3yETY9pzJ0mYg5bUG1qSyCDgRf/HA1XywUvxjJba/0I4hKP+KKm7M2eV/zioQaKMDYerzSAwQ9pKI0aQH7qU/8P1To4OZFT3vnrBqy5srn1yxnHQLz2+kolKAGUoWNsSf4c9rAfetCJbvT0Mrv2CZ3oZIjRi0eUGfjb/na3pe7mAA+/6lhIwtW5oHyrG3/r+/m6un3ybltiW4glRJYqpEi0XoGFKVNMtA9aUP4Z3N0HV6giHzpBaL//vcTecPjEB6+j8JWt4p/Wf+IVVCXkSP64KI9vyurySMAAW80A04oDSAABFzABUy4Gjoy7Ss0P6qQMBqEMCiEDmyz1SiDY+EQy1OZ8vuXw9sEETxAFU3CgZo8F/29P2UjQ9rgsvVqQ9iZJBl/wBfGB2j5JMnqPGEboooKP27qA+LDOCJGv+abA+bTu+ZivsU6mD74uDmqCEeSG3cwhwXyhpbSP/WDhEviAKRbB0SKkDcZvBs7v7hgNDcSgC93vmjyi0uLvWiIOMT6HDtkoMNChHtQh//aP/1RKFxjvuwyB8sCAAC3PXnCsXgKm1RDQjlKgEXsgBibRAVNOAh+PAklv9CYB8nitElKvA1YPBENQBHPwHk5RBflBFVPx8FzwBk0RB43uFWeQFrOMBoUO2apNHshBGrLBB0dICIuQCNcACo5PGI8QCZNQGZmPGclt6gTEUmrCPnBIGPIBC/8ZRPvyzt6O6IiUyVjGz+5EAAPGkeA2jA0RDhfSUR2nKdKUStKwQWviECQsTWwMQ2PosS/wUA/7cP/80JNGRxuEIRAD0TkIUQ3U4NYQUSEtbxIbsiFzIAdWICJXYAErkgMoEgEj8NbAoBBFLxMHgSPBYBI2ELxAUfWKpo3EBRZ7LgVX0SVdEhVjsRbTYSWzbElscSZtEfdW0BWVDSbJwQeRgRWwr1Kg7xiRESmTbxmbkSlDpc0ma4WiMgpNQRvcbR5MgVLqrVioaJmiRrUWTRwn4AM+4O5Wy9GO5qheqyk8jB2r6f2+p/4wojrmMBvmsi7vch/50R9fDByAISC1QRb/dEFP3mXyDpIj0+AgDdIgDfMgGRMhtUALeiAiLbIBL7IRWy0LODIxCZEwCVOuNLAMQhO8DmYQAE71SqALSqFJdlElV7IlV3EHX5IndbIma3MWafM262EncbM2QWgfepA6hsEVhlNnQuYOQOoZASwplxPOlJApn5MZk9PcVmglIIHd2GEeJmENtLGnnKBq6MI7vRMsx3EsRUAGnsAsLaTCQEwt0jLEksot35FrjGHvIC0+FS4eoYgvcAQv+QIvaTId+PDTBJRAQ0jMpgEctEFBTyowG/Mg9cRBFTNC34UM5IAMHFQNJDMHLBIiJbMiL9MKbo0wZY6uBnE0T5Q0Aa4D/0LRCYrGGkgRMkpQRmWTRlcR6BaiFW0zR31Or2ZxR2swFk+xW5CtJ2dPRk1RFcUlOIeTSe0rhcqNOY9yKad0Cal0+ap0So1yOleIEX4Bwabh9zDhY5ZJepbJCXbAO5XlitjQiPLtQ4yp77amqUSMTnHhaHDlw5CKmsYCmvjUtvbCF3sPL4MrQAuUD8kFHA4Uq3SBQV8hECYUQyO1MR/1ICVRCCRRQzmAARaw1TR0Qy9SMkMUMnOtNBxITzwDFVLBVE90NO9kEnCgBFZU9eZgEppkdD5tRnPVN3dw2nr1J1USbYz0SH/0RnPzFn1SR3VTWa+sJol02VgzONGiwrYxQP/ODDmHMUqTUVut1OquFEubEEoJLFN8gRvYwRccAZnStIjW1SgMzd6YFGv+NEd45C2rwV7l0Ue+qCn24EX61V/99Q+aCCretE/j1bbukkBD8FAR9UUDURu4QRYiFhEc1IEkVVIjUA0okgMqQFMpcwWE4FIv1UM1VFTPQA1M1YGoJBVWlmVP1XHuRE9I8w1iNRQ9EBNYocVwNSaLdaBgc9pqFAVLMViXNVddr2iJFReJVUh5Nmllb0eTDSiXtMIMTUw5K4WuFVylNEq59eq8dQm+9lubUVvPTIX6QBRUyveycj64Dxa8yG2ZoReyRm7nVWnqFV8nTVq0B7YwZCr4VZn/jgVg52JCvo9g3U9emyFuiYEyrgoYGjcVdEEWuIEWaAERKPVCHVQLMDQzL7MyOfZDO7QHRNZTPXVUHUhVD+EVXuEQVHVlTXfX9CRmHWkSrqRmQ3EOXGHddFZ3nbZnfVYVP0kFl7Y1S1F45eHYTpAlj7dYd45omxfoYo9ZnRd6l0RqN8F6rTd4si/qtpcJlbN7mxBsuTZ8nTNsobMJvu0J8UA1z/VdDRan3jdf3WJu3eJe61dO8TY/tUYuvSZvvyjhcIFDoqYN7KB6AhdooKK1woL7cHZBT0oXXiFiZYEWtoEWXuFyyWBiMfRyQZZzOVcSJZJ0PZVTewAyIbM5UjZ1/1MXEUy1ZV02diVBT+imEkrzAmo4VneAEXpBHW5Vd200JpN3VxGLRotXaGO0D1lReXUxaJf1WZu1eHkXepMYaskhGpb0eq/3VUBGa7N1W8fXi78YjJWACcjXfPfrfJGxUh7Bh+ytF3T4LuEXWuJYbumXjuMXLvIXf/EWI+QYb+tzLfh2KgD3LgwYibaCEKwXdxmVQSN4chtZFg6hMTF4hSf5gg+yki2ZDC71Qjc5MkUYVEu4DEw1hSF4lGHWlGE4EGLWORhJFyphhGq4Ax5gRbGgVnkYiZXWd4HWh4eXeF9zl48XaM0r6KIXiqM4eJVXN4O2LoNzPSllE5LiVY5xW/+7WHzD2JqvWXzPGI3V913buFng2P74uI7tF4/L+W7PWY97hG6Z4Ub0FS3VUoGNinDbloEllx1moZEp+BZowRwot5IxuBEyIRMaoREmuWJXWJIx2EI3+UJHFyMlE5RRmJRTGGb7qaL7iUQ9kddmFpZlVRB8wZZvmaB6GQWVWGdNWkh1zoh92TeluNpMukeF9YmNWYpr+njR4i3atrSemRu1t3bWUJqbsoyrGZvLd6iJeg0jhI2XOY7D+ZzHOY/NGZ2dOp3XGW9xpKkOV3E9qXfcTZ8n96tpoaAZ+kIRIaAbuaANmqwx+UI72ZM7dFRTOXW5YaJV905CoUQxOqM12pH/Uk+WY3kE1oAn9C+YU7oVkziE8EEyelc2ifeIX1KJWzqXJfuwiZmmbRqJWbFwd7obq2I7gXqLhZo5i5q0idq0sUAMlG8N+aAP3PSNqXqqxZmc4fGOY5uPYdu27RirowWrtVoaaMmrzaGfG3mfi/uRMxiTzVoWBpqSLxlzJVN0L1VjSzYDUXeUS5muDgGv9VrmUJTXZhdWHUC8MWALSqFmCFukefTwloSxd3exUfGXRdB4S5ofYhOlg7iwm1h6V/CydVmz97S0AK2IqKc5mTA6T7u0E/yotTk6QdtA8u2bcRudg5O2Kzy303mPZbuqrZrD1Vn+nqH3frtct2EbhJu4/4u7uBFag826uTlZCMAAZK3gxUu4B8igxiWxIkEZOVA3MK/bgQbRRLl7lXeNNAfhSh5gvHG4ZkYHeI/5Rtkbvo2NFJkHylt6pSEDBXnVVyObyxu7mIEYszNbs3WaaU6hs/mVKqSHe7cWfBEcm3VDwRecjLF0tcFQyhqmqc/ZIqjjti9cwzFcqv18w5+l9/zS3W4hrFEcxRuBDpy7QulgYi9UCBwUZDNWMh/TUxtwBUr2hEl5Zbe7MzuzAk3Pu/fkDbrgAsZ7BPBgyZm8yZd4iuUbvRWbeqP1MVB6pYO4V7dcl+3BvtM7ysNczFnabdt2Kewi7S5setbcfOUcOuMc2v+bfRnFoM4P+c7nMsMF/c+1ndunGi43XHEf9p4Vndz3WRNU/J9R1tEjVQsm3ZM5IDMhsxBM93FRlTABgdQ2Eg7kymRDkiRHMxImoRCMHAdSvQEaYNWXfPd2V72HdW2KmIqjlToGCniv/B50vR92PeNfvcu93OdmWthZWpdzusyfuV+TPe6WndndPLWNOtpf3tmxAKhX+xIw4S2wPdv3vFEYrtvjsOe9fdB5ZOIZdRa8WtHxWdEZ/Z8nfZPvpOkv9FE5mcYzlQE18gxO+E4+PRTI6bhKrdQ2ciNHEzkiYeCN/A28oAMOHuH5oGZ4iMkZfmd1V6WBVedsvb3nu4c9SeP/d73jhz3ug93vRZ5GSf6PpwLlTyvtgFra55zlsTR8bwDmI9/5qv3a51LPcz7bo9XCZ3vb81zCgT7Q65Y6ElTckd70Tx/pNaERyCALDpLpLdlUySCVnRuUbVwyHVJUlUzrt4Sr4AZuvh4kwR7y5KpgRt3ISa3gDeDgydsREjXx4B7vWXPup7/WT2TiZz3vq61XN57vgT3wv1/wB7/krTfN/7ZMTwu1G1/9JZ/9jTDlX8rQ8Fzn5ZD+Mb/zOb/P7T/o79duAQIbMnDauHGbhTAhrYSaFNJq1IiMmokUJwYiEyjjRYlntHj8qKWHxx4kY8SwYuWMIUmHUklyGSqUIUg0/wHZvAknJ5idYADx5DlIpZ+hRAf59HKhgVIMI+L4sgbuXVR56sBNbYf1WzqtXLuS+4o1rFWqVMkhOzvM1TGt/NrKc/t2n1t+/ur2u2vX31y5fO9ldRfvXl98gwUbJlx48N7Fi3fBqrUp8iY+c9qgsYz58po5WC5vwTIFNJfQpJOIPj06tWrUS1a3fg07tuzZrF3Tto17Dh9CmIY98xYt3DmBwrEVP448+dlqxJk7fw69ufRu1KdbXzZd2TXs3LV3/84dLStfBQ86VKgpvaZGsyAi4ljRokSNE3fmIEmyjP6Q+FOCWckSTJLIFElNNxl4k1E6TWKUUUI5OBQYbwDyBv8USRmwFBeQ+EJML9l4mI1XIWZzzDGPwaIWMiOCJdZh9uBjFVoo+hYXY3PlhaM+L+64l1/BAQdYYi4KqZiNfe2VViuSXaJIZZl9sYVlc3CGxmdXXIlbabdlWduWXtLwpZZdctlFlZrx0dtvwyFnnHJuQgNnnMvJSed11dlJ3Y93bscneH7+edZ4rNijCzfssHNLogstulAmjsoiCyKIvPJeffFZ2lFIVsSQwwonfYSSFfd5JFQlkkhCSYM1ObLqJJMIkmCCPQXV4FCT8HRrTm7gcCGGHWCBhyOlDDtsLrYci6xjqizL7LI0YkVWtNKW9UxaKEZDTo1w1ZijXUbKFRj/cCXCGRhiRBb5bbr8nLgkZWZaFoVlUZppJZZkeolvvvruK2a//qIhxm6q+CaOm2sa/GadCuO5p55qNrwwoBIjw0q2hR6qKKIMNZQJe43IQqmkhtS3kxold4RyqCaRQEIOKY/aUUZEmerHTXmwCivOr+ZMU4E3uQrHq6runJNNb9wQwQEYKlXCFlPu9sceUS8CNSeXPHI1JlqzSzC00b4DdlxkkZjktd9MK5c+2ujTbV3f+hjcnNgOaS66dqu7z2Na703IlJe14cS89W5xBOGF84v4vfki8RqYjps2ZuRZmrnbI6UQDBzCmjvMcOcM/xaxM31K7Gc0FJNnKMaKrt6I/6MQuR6ppIeYTPLJKaN0H8sorOAfzDIXAryqP/Osc/EIBs1gIRPmOsiERlOINIZLd1DCDtZHgb0T2m8v5SJXM3ss+GuFWFX508aIDLsDZ6Mtjzt2+zbc1BWzi4rZnot3/vzszb+78MYbJSgZLgo+KGABFZe4BLrmBlL4zOMUqIR8iSFgeLDciDKXnAwmzHNx0hwHIUa6P9VvPIVKnTnMsTpaNEQWjupYI14Ru0nN7ic7yYLteGKFKsSABChomX1Kdqrg1cR5OSNe8YxXoEEwyFVKhNUbbuVEXZlAetOrwbuytz0ZDGEIX7DMHwhxiWYt63vOakYzzHe+r5hojMtyxv/Z2vc+HbFNjtpKzFfGcRZe1M9++Otj/vhXCq35L3tQKmT2rmelLigSgRBM3AMbyUjQrKFyxLgg5w62uYWBcJOZDJ3oPhnC7qCIhIhiBwpPeIt/JCo9rXvdxzIBMtmZDAyzDBUNbZkDHLCABCfxjxoCUQlKpOomenBDMYsoiJ1hYmdItInQhta8KBrNQgSgogN+JQiseW9qdeimN785tW2K03ugKCP50Fg+sxxrb58wVoiiJcd4yrNH5npLPcaBRxPtEZ/l8uPdjnQkQGKib34j5ODmtRk2rAEK/FokJBH3SDA91F8TpCAsLNlJTrbJOnfK6CU9GcpkiPQ70bBHPg7/hShU3gKF6mldCzOxEFk0Qpa3tOUP74OSHaagZW/wAzBRNcxjClUPRmTVMo3KzGS6aqlLfB4RoeeAahqgmteMgyuuGj5jsbGdn2ASN8HZze7xpp0gMuM5qzKiYeTiFEwy51jcF5ewSauehsFn3EaqInF4TWx8pes/9zJWVwWSoGaaUkITWkE8xGENo3GBYyfaBIpOFHIRpKxlITnByrkCox/1qGc3iEGQgtIYIRWpigpyKFSi8B/mUE9LW7iokF2kZDYN1RtymkMdsgwHb+gpgIRpE0YQdbjCJS4mkInUZMLqqExVbhR7CyszmCCqUj2AA0pAiEmswlrcVWtWuwpe/yaJd5tRg5cd6kDOMg6jkisimy0G6r3eqKWSY3kr2oTEooKZbqQinVsf/Yo3NGT3qsok7Br6gOAEK5axSHDsCDpAPSBAtrKQdGADb3PZDCfwDgFLk1Y0+NkQd7SzoCyxiUsr0vHoI7UnNAdrV8nKRshBUq18hWxnS0sc4lJUVnjDDlkAZN4OYiUxGWZxh+oIRuzNqFpz7lGV29xJHNeJgiBihTSgNCoypQva7a6yvivGMDdrEXUIQ2a6uRsy+iZQWlnjJcA41vnSFyxjs0p+D1MuwKhRpF/Oaz+jhQ96ABhvBczuk/vA2NMctrEOZsoFMABpEUg4khRmgqUvPWF+Xf94oncQGGdBTGJQizhPnBMtik9rnpW2GMYyloMQ5DBjRLxQdjiuKS5Nkksg04AGOBgyKn5NIFgFUrg4I7axl5vNnE15ysVOtrLjAN04oCBp1bVuCbjci7R4l7TG0Gqy1DfeMOaCGcwYI3nP3M3vzcg3xFjjOAeWlvZKo713Dkues5JHXrQiFvu8p7/v7ddB94UNoln0roFQg4Q71sEjmMGDI+2AiCvFAxr2UmQvjulKazzjjXxkxTcu2cx6uLP6HbXJ2TSuE6s8hOPRxnlcmx5YC+HViIi17A6RkdrdlMebWhkKfg6FnlIC2MNsFSNowmThHrcPy1Z2UZmNTGj3Fin/WZ6q0q6JBUdk+9vc9rZjvr5WtjapDedVBDm9rgrx/uFvZf9iGH2jLDBOyezmZG+I2k1vewO8zco6xSke42eAh+vPAt+HYHzhiC4cvAYlaLjjG79wEDTcA5SHtMSV4qtMc3xfEl0CAzG86dBLtl9jcE2H4e0wu5ac5Ca3zpxSbmr+yn72fHYFOHThEJivx9UzJ4Psfo/znIMqVJ0yifF/fAMoVCESQ49JsFc1rKMnnemPUG4fki1lZB4X6rC6PnS90AXqVl1p2Nx618+PC6/zmX5pj9r2nEB2usNbfU0Kq/3F6dXKzF3c64Y7WvLqFXr2F+KQPpARGbVQDGfBT3sX/3DnMg+jIG0J93ASRwEXQHkjIHkhoIGVd3mYZwAUYAKaJ4IgJzmgp2Eidzk/wnonl0n5Bnh49Xqwt3K0h1cVUxfooXu8N3OwBnw4Nzu1ZEs6tDI4wDJeQIRuMGTBJAqGsISQcDOQIH1GR1SPcH1UuH3JBnXbl4VRBwUlMH7V9Stpolbo1230c376BHZWU3/nxYZ/QFb+t0bmtoZ+Q4eZYXbihlUn8oIyCCRdsV/65netsE9dEWjxsICC1oCHkQ+ooAemYQIbgAGYJ4kWYIEaYImQGAGZ6IGTOAIfN4KbR4Kh6Imj2CWd1gm2cEblYEblsHqh5Yqv2IojhhwysiyAtP9uMSiDo0WDslcx2tAP6OFSjiJzM/dqsGaMiEAfJJMFWRADuqU7RZgTQzEKROczrWIKNLEKq3AzN3NsVUiFVTiFenCF0ldlRFUTFhJVX5h5Yrh+ZuiO70h7YGduYVROYpQsa5YkXUU1a+cZXeSP3UNGBxiIemiGHeSHBagkm4CAABiAAsgigucX3AAMkOAGZtAEKkBt1hRxFUiJHNmBWsYUkzZ6nyiKsvF5p0GKKSkFIpeKLcmKsAiT3/CSsZgwV8U/j3CT8iWDu+gdfMYcs9eL/SALs+BCrWaMOth7ckAGSikRZaARI1NDxkeEu0UCXgAHwjSN1IiNPWMK2bgKnQD/ltwoXMGiZOOodGMpfd1ojlB1deqIAVuQgu2IHQXZjvXDX9p2hmU4ZuClj5agXuSWJNoUNWzHPfH3PUuikHrURnjVh3blZoFoWtjSkHb1kAAnkaJQIG4QBBJARda0NJq4FB24kTPgAkUALBVVgiNJkrShkv4Sep2WCJ3Qkhg1k5hUm+twm7hJk6RGYFqTYHAGZ5MAC/+Hi+ABjzBIMQThD5ACERBBB0eJlMSoH005nbUzhES4Sz1UBaYCbNMoCpjZM1z5nV6pjWcJjsZmnloIjsG1lm4wXepIRUfAjnR5nDxZInmJdmNWZl2UbpdzDCCydc2CNWv3foZ5mJCpmLAn/yII6ZcKqYCUCaGHKHgS+WuGkAcXOQGdqaEamo6jaQKMExqoSWkNhXEYty8W1pqtSUGfIJu3GZO56Ye6KaPHATrp4woDhWC7oVA5mk3LlCL3aZ95WYP44ItD+ULPCZ3EqKQ9IATTSZ3WOZXZyTK39RLdOQrfGQldeY3kSZ55kI3mqWB6wKNWeJ5HJlRwQE3wuTQ7YDlAym0iFKT4yXVy+D/wd4d/aUZ4GRn72EV2OlYDuYeRuaAmsgmW0KCDmHoRKoB+MQ2/EAqRkAeaGQKROFUCYKmXWm0d6qGlWVGJ5lCrOaIQlaKUBTCmSCPogKqNGYupunozqno0mRZJlmALpf9QiBVYPxqnu4gtuqAN2iALSAqdsLaUStqk+2GsKbMTOzSVU1kFQ2Gl43mNSUSe0Pqlr7J01IdgmGBM2fqNiVV9Q3VMm6mm0lMCjwCHuYqupLVt8qhVraCG5XUZf3CHnsBVfxmYY9d287pviqlHcKiC0UA/YueXw/mgNQo6k9kORmORTXACG6AUmFqpmdqBFdhwjFNRioUHnpqaJTkbJcqxiCN6Kll6K5lZiyCbVcGqMtmqKatfruqys2gtOKqjhBAHGUuzk8R0womXbhqPdMlm9tCruqALwHqUhzCMTcqkH/Gkw1cFRBilvBVM1IilBaKl00qtplAKSHetCXat3wj/pkPlBmlABTTQoQPgljOQCGsGHenKszz5devKr1uVduE2XpYTqO0nNWxYdoZKj/vmt7xQsHCib3ybmLgoNw2pAxenAyrgsA8LsRK7kRbYcFa0BVCjWX0zQRsLqh87WRcHMGGQCCZ7RlvxogXDsi/rqneSFlu7GziLBzRbs7whLFjVtnWJnIHyFGujCzg3Y0pJB0s5OxJBBiJBvGSgtJnSESjRtE97lagAE1NbIM3FpVxaCtf4tWEam4zgrWhJVDVbTE3QKxFbAOO7NDKAB/4nEGvLtuurfnbpZWNGTuI1f3ozGVKDGVJzh3zbt4jKoHy7PjFosIS4ARkoeZe3oVYX/7kW6HAFFAafITB2mxZ4YCaa65qgyCWcS8EYTBpVApvDgLIqC6Mg3LKo+yYx+41ssGA1q8IojMJ9YH5etrOBKh69qA2+ADwY4ZQjQxHGGxJK2wM8DBK3o6xECAcD4rxSuyo6o6WQkI3YGEimcGS/6b2Kxb3mOVxmgMXvaXVmS75UNAJpW5zPsb7sK6RAuq5iVI/qVQyBiK9ehL/6i6Ay6K7+S7ByE8CpOgF5bAGWN4nWNbGVqMAM7DSwyaLHEqDuAhqfUcGca6Kl0cgXvMijWnElezlbcbojvLKZDKtfxzcY68mfjLHyRbtwpxa1t7O4+xT6AAxXCjyF4JQ1wxM5kf8SIhHEQewfsuy0aWAIwOASqeB8q7AqYppcXAkJ1YuNYPrJ2Mu9Yfq94dvFCPDMX5wi6YuuO3lqy1DG97lt7YiA7Nq+eshW9nu/b3yg9CMnsMC3hxqZn3THeezOoTkBA2yBHAnIjvehVkJB6oaKeXqjVZLB+vLIpqnBAz2qmWWKLqmqMnrJmLzJeqNkUkzFw5XM1ZuHFT3K2pY+HUIMueuoQsQgRgNdKDF8tWzLcLC8OqDLq/y84JlkxUQZbCDMSAV9Wou9Y1rTYnrFFanF0PzMPI0hMrAG05wdgqu+M3jNcuptkOG3gbiv7Pq3/eoYBtjG4/zGf5eAeVSodyrDgHn/sO8cmpSncA5mAmPtAZDnA1hSqullyFydbWSmyKqZL48c0JKMkiDHA6Mo0CHaaXdgQaSrySRsurv5k47Rycl808FCLDNi0RU9Lh3CIQRhw0yUEztTkRVZBVVwH5k9Epoi0h5h0kdIBSndyzHhM1W2WIx1YOv5KtFK0xB92DeNxTRwIeM6PWgg1Nds1LmNzfiZfszC1L+NoASp1MPdr2joVfc7zopwgOxiqPO61Smnx5E2Ai9ABEsABQSXBItXPQlnJWei1vvM1SFSCpTx1pDMyB4L13Stknkt0LAZm+QmwiEM2Jtcew9900jW0sQinImt31iVbYKy0dIADNLACsEU/71FU9leoODLyinEm9mzHJW6RMSUkAoqTdpIh2ioTasR7WT5jZYTjdMhrmBYbJEjULY9Hc1fMJ9FXVq6bZxkiAsJ2aACq4Z+p0fv2NtM3dwDu7NzLM7JbahLwk1np1XajAwi4HgHFDArrLGDk9aVU8i24B3X4IfZgAlT8s/nLdeRZZpzzd7qTYodVsnx/dfCMd80qixkyrVVjJZJlrVMFX1JV73ZyCEB/gvW8Au+EK3ElOCKpEtS2imZ/eCznAVU4LRQW+F5TtpHVquK1MLOZpZR7NoJJqaJIKZTXJEY6tMo/sxvaUEuTlIKM+W5/bY4HohqmM4z3s04HgzDLbBfoP89bYAmqLhe2xYLYpe3emt2TaK3e9Cg/MdnLWCxmXWev7loZTLk5dROpMUnBzsixHDlWT7QDBsEHuvlFfflYL5pnhYi8q2o8HDmtRfnY2npVqzazXVESeajq1DnvnDn797EfK7gi6RrP6drHMAyHLACHIBTmrKsoS0K7+6oX3kzCKZQjm6rYOS9TobTr40HIh4HWKwEGpiRB6yhnn7buhp7o96TPeuOt241qA7Ht97qrK6YS43rTqBFWiRg+uyCkNHcua63ZEd25Mx/lYOeOfmbwMnzRN7ssEjgj+DPoYpA1h5BpXft653tKlmql9A1ZW7mCg3ugl17qnC9ll7uWHj/RE+mnkZF5xxy53h+pQYydfN+A7uG9hVQASiw9hywSyyDU8p70lDrfANvphruUBs+xWrJzOE4liQe8V1g4hbP6b7iA4yAviyO26LT8bx940ot8iNf3GUMiL/NJLD+AR+wRV/k2zb+go/hd1nN6zRP1fjLVjgJllaP+jd5NXQbbsvOzq66ItLgCthN9CUZWWYQqUaPcUtP0JEseivKWa8a9VCPcsnALg/d8Gx+fenu4csvLAGf5wKO5/HefREPfkGweGjPAmu/a/jOMg0ehM0I8M73y05o8HlfcLC78JKO6dcH8SQOBbJNAeJX+D3dABhw+Bm/+ADhTOBAY8oMHlxW/9AYLoa5HDqMdYqTJYoVObXCWExhQo4aFQYDWashw0+LFNWpo8jTJlUtWVJ8CWtjsl2wXG6quMdOmy88edpRVKrlo5tDh2JCeknp0pegWg6DyqzcOnRVrVrNJk2aKTFYpnxVElbsWLBkk5gd26RJHmqv0qiFC7dIkSZz60qZm/es3r13+/6li3avVzF3+BBt9k2xuKmMqZ4bF87x5MeUJWODdoymzaGOGD3q00cQ6M+lBXlGnVrP6tWhP0MS5Uv2L9q+VkWC5DnObihdugS5gYKGcBgnjBNHkYIDhxxvrDwHcwYMnDRu0gwSFUq79lV5WrPxHZ7wGvLkd59m9N3M7v/zrkOz713jgoMD9e0TGGAAPwIEAQTw748/C4x4pBepCMIsGWSq4SizBh2E8MGZDhqppQox8sSiiS4CScKOENKow5pqeqrEEXnh5ZSmVFQRRY9GPIazVij6Yyef7LAwRx13dInFFh26xptyEsOqSMW0kqaPNcrigsklnkTLryjVMoMac0KJK0sp69oyMMD4AjPML9Eo7LBhslkszcrWtKzNCElEKj335jRNNT10o9O7UrKjzRrabstNED14Cy+44YwrzoRDk2Oh0Rygg6OQSgqRjjrYstsuEu/6WE88wsTrgg02RBOUtUHpjOO730rogD5X9YN1vwJmDZDW/zZogZH/qBBksFcPfwXWoJBwIaVYY0kyVkMOO1zmzWs+hFYzaaOCsVqbRML2Whd3mRaqFFeicaeHeCRXWx0PEtLIItNB0hpT8ICySSe/nHfKJigxZ5u3tGzCCC/FHIxegAMWmEzDVEETzcbaZJhNISXkLE6kQpPYtThLbQ3V1XJbZbZfQlnlNs9O9aI3JgwdLuXiimu0ZRa8gDSQVCShrmZAbr7UO0HjWBJUecMT1VT12DMVPlZfva8+WWf9Lz8Bmv5vghYScUXaaIPFGkRlIorok2RJ6fHrimJh9tlmzeZVa19p+mizaj/a9tullJKJ2hMlssTbu+O+1m24uRUoTXbVJScb/2IOd8WRngnzSuApxcrSDUMMsfIVKnTQcmDNN+ecccOoJlJNNtV1+DIIIyYN1T4unlN112DruDZRRC6V0CZRHk7RlVVmAQccrHBOukNmlu5mnb0zRRRIdAbvZ6DFEzVV1tZjz43poRjOBRMwQDrpWG0FP8AGpMbDFQMTzPrs9BcK+2unjBV7Q2wfRP/XYLDRaO0J/X6Rbf9twolO9qCSuv3Nf90yIOCmhSBmhG5w6nhg4ZgBQELwYQ6M6xxgojQGtYgiX9v4By32lSUjcKmEJ/xXBlU4GDQYjCjpEB08JBMZGl6ldNFwFuowMbLUXQxjrUuVexwBu9rYJlCqKhTKdP+3O95B4TnB88MhdCGJ4hnPesdbTfOaZLJPPc8MJFuPF3gTHxBswFXd897SaFUrqI1PBXhYRTPStrYIrU8joMjQRcC1ITzCL35kYwj96mfH/fWvgP1jWzBUpKEKjYQgCFzggSD0DEpKBR1ESgwENSnHYajCJD7ZQihFiRcVdkledhmEOf7xD3OkYhBpuFyWbKCWFBJshVISzGDKZKbBjS6GDTOdgzQCwIpZTE6uew8elEmqSCRPdiKTkxaXQAMeqAxRTBwOC0IFPOj4IRWHMMQgpgOIQVnnioOSpvPUyYXolcxkwClOq5DWAFilUY37AQB/nLbGBrwxjsxI3xztFxH/PhbUoH8EZEHQVkdo3U9t/zsgRCMK0WHt7VxWY6gkcZgwjq5rcBP0ZI1Q0hNQhmGUpESpBs9iSlma4RWr/Mc2ZPqKQcSlhGopoQ1uyYNcrvBzmCDGL8XhDmCyKYc2mYRnKmYa0QBxmU/dmClgMxtovmdx01QZDZaY1UZB4Q1f/WqkwOmHcd6Mep3iYDrrFa+wmMCtJvDAfCJwxu8ByJ74eVpe9cpG/UQABGMoBScnCqyMhoigfFREYhW72IPqERfoWuggI6s+BBUSkS86ZE1Awi2LZsQl59NoNyrZQDl2VHAwLK0tSrKIkd6IpF846RVSOtswsTRgediGKmEaU0PE/7JfNwUuLlfouJ7uMrCLkWENheomBaEPTktV3c7eMzRmhoxPswvUMt+5l9xdk2UqW4IXwBqzQpB1EK90gxnGgNa0MklM1TSUB+ZK17re9Z5L22t++QOCOwRWkpSl40Aki6wNLdbAjIWJ+8hmkNCKVrJYG6SCLmvIuFU0bhi6aINJ68AiYbIZuVhta0sK2xHH9qTENeVK6WIDKrzCHLqFqTncgjkb3JSWtdypcFHsFTwUiKML82VymXs6HWJidUrdxBtY0p7q4WENRLtTM01hG9uswjS2Cw4QVvbWrQYHOFAQr83A4IdJVYqc6dViXBynZSVqgAL2ra9dw6dfW/knfP8H6MAcJrGgABPWQ7XAW04UqxNLDPAkjXXsRiJ0jvo9mJANtTC2Ij0sDHOtFRvGdMIiuEmQeu2TJrVRC3kialGD2qQmPjGYZGkvHaQhtzBeZSvVi9O6+MsuOh6uLQF2hTI9whUJA/INh/wmHSZTNF8lWhC1C1XYhazKVkbi7dj8AmpXe3deBnNYz0vmSVEKDtF5A6HeyS+5wPcG1QyBXO0JZ/DRud3vrk8J5oAJqxXD0X3myGEnYmBCKxbRCRVk/Rjd6Hvb72qUxlYrJh0SjFg6IqWFeGIyqUl1cFK1ShEpqTVe6lObuoWjPIKJa1vunsIlFbndbawNYVOS55q4m/v/SmGodqblKncy6cJhhGMUpwr2PA6bWEPPjU2I3RBdekOUcmxCtrxowzN71q62l2+wTThsW1JX93bN4tAbrpOb5FxO91zre1+yM83sZ3d3X0vQBXrz2aH29jP6AB1oQxf60Cfxd0GL5ZGABxMzBC/4Q5tb4bkXXuGTbnjinxJx01b8w55mLUpCvXHKj/Ljojx1yDWfahyXXC1pCAXKU86NWdPS9Lju6ctV3xU+HEYVBqr5kHNOR5vYBDQVDHrPk5zs6hn9NUl/9hFLz92nY3PqYRHjG7gtCUl8k/mUGid13Nn1uKBZLmBX99jLnnZZcb+N8i5gc/Gd0YYbVFn/nl/f/x0s8IH73dFwgzTDW+Sj+Ttc8YAkBeMNZzdPo8QwGfc4jus4Aby8ARQ5mGOrBKQSF0s5Vlo5crM1l5PA8VgEXwM2YXMTHOIzBLIJnyuPChKEPxg6niEaRuAY68IupmME6mkcLXPBFzS3L0s+7EgFXfgmG+y2MjCzcKsCd2IDKgDCLzqvPKgO7HErDXCz+WK3+/ge/IK37csPBxgBPdtA/wm8hOAaRNM7PXKsBVO/9XM/9AlDBkkgtZE/FlEkw7O/+juWqPAWoYC8/5NDORy1yus42DqpUQulnti8UAICzlM9u7i1VnupBrQcueASGuu8gGGzQNy1roDEg4G92MM5MP/UOWIihAuag/JYA2RLpjgwOqJpNtmwriNSpjHQCxispkZ8Eq57A0CohFTgBm7QBSmaIkmpFEvhweQzJzeAxVDQlLfQKje7AAmgACWUM7SDwu3zPimkwiqMO7lbJC6cCAzzozSsKMgaw79rP/cLwzKcEIQ7BTUUxyzcO2IBG6HohHU0idabQ7z7g/+zwwIksT1sA8xDNT/URyhZM+CgF7gwBBBKOXNYOczxixubQEckmEgkhOMqHNGpxGGjKKTYxC7YRBqoSA8sulAUjeTJDlKsqu8Qi6djRV1ipzCTFF2QhW+ShUMggzIIBOgDN7CiyfTyxckZQjMIgnQrRmRkQu//0y93A0oCcAAZWIO2Gz/A25o1PMNGGomyOZttdLBuFENLdK4KsyxJU0M2ZMoKmZt2jLw5pMN5LEB8NEs8xEMT2zziExhqSsW4wIFDgLVV2oaCxJwW6BdB5ByeUshcki2vMBhCOBPUekiIvDkNhEa3YQncmwM0oAFRykjz6D1C0APrso3ZCUk8mDUVOz6+NMlt+kVdUMlvqsHywsWZrBma7MEqyIObqQ43wAEUIMYH8MknzC+9uk18ys0nnMI9WxC4+0IIWbhs7J/iRAhuDKZyQE5vlMoPmTDDKkdy7MptgbwKDEuxnEM7PEuTqkd7PMs+lK21ZMsd0yme0gEqkMsG/9wGNQBCg5ylDMqpvNQ11FM1eUEDPnDIwvyxSorISpIoYgK6J7lHt6xIyXwy9kC6UbhM7LoyzTwl9woYMBMVQCAzW+SGmZEiSpEULYi+6qg6PwCE6ljN1cQcFIAr2qzNd8PNFWXR3WyaZFyjKXy9wQK8N9FK4tQacIQG00lOS6RK5lw/inpOwhvOG/0IsARL7BRLssy87dyCtHwCs9RHzUOC+fTMIJgtLTlPSZhL3vIdg7wx+sRLW6PP4SqMoCuFqoG9dtjPjUoT/9QfVwDQ8tjDHbDTUAIayYwDR/DIBTVFdGoe6ouLtGqnO6EEVKhB0ayEMshQLYDJMkhN6vCDSf+Vvvb0HRM9gQzoyQhA0QTwVNtURrxy0SYcVWdESiv0lfcrzrhpKB3t0VddTsj4UfebMDIc0lXF0QlB0v9LUiVl0inFPNiKgid9Uig9gigYVvHcAnNzywR8L7UoUSrg0gYUITDtF4QcGPlMSL34y15TCkyoG9Nq08KS06TYhExszGXdAWpa18fEU994Mj6NDarqjmNysujBV0Jdr0JtzUNNBWAQzbGSIuk4zUjFSRG9HEaRzdn01Llq2CUc1VCFFTuT2HhbA98Uv4wVMIaikOEER0SaSh4VWVmdVVh1zqy8VRqdqHb8nHf01cLQzsxDVvAk1ilNVirFWTy10pEzT8z/AUJUaMCYeou7pLWBGdOi1ZwyRanALAxQa71LaAlkmMQ3ldqqtVrNmFMLakyesNOu7drHpEwi+pOQadB8xdez0q6N8ddEnSKYBCcr0IINhVTy8gOE1QGFdbNOfdhPhVhRHcq8qicYNQBTTUyN5VjoxD8jTVlthNXLKNmR9bvF5btC0h/CatlE8NXsvIMW6orLw4ImjdLQNVbNi4I/zNnTrdLxJE8ag9Z76dIZs1Yyfa9Zuqny9At/0YGkrU86/QJk9d0WEkGoLZFpuVqAMojaOwp0RYMn8NquLQEVwEs8mKpn+lPNXDa0RVtBOFREBYYaRAVFLYSxglu5nQ7oCCcP/21PE0VCCOjUM+JUCVCAhqXNfQJV7WvGs/Oro8SopEyk6FRcyWWwWG1cAbbKq8TVWj04lW0W7LxOOSyTOoBZz8UL0BXdPpxZdbVZnF1F+OrLWbqLnm0CaYUx3aIGu+SSDKoxD95LvdxdOg3P7iQ1O9hEQoBacA2/XZFTTFTee9yCO12C8viM2KFeORka682i9bDe3YCN7tUG0XRiWaCUtx0z6KuUbjKELCDRhV1fZPxUh4Vf9mVfvq1fweUrfnoa/sinwX2B8qEW/kXcrUTD/6Xc4PTRAbZE6MzKqwkoCWHZl72DCN64fETdm8Vg1DVdIqhSRE5dXdvL3IVWaRXIGP+bMbVogfdsq1SkC9zN3fLc1id51yVBNXq8kQE6DLopETktVxpmTPKg4epKHmf7BT+5zEg4JkBdJqFBs40JBSZ2YhtUySimlDIgA5fUwSrOgjHLAii4VBXYYi/eW/n9YmM0xnWzXznjPn2iFR5wBDXd3z7z3xbx2MUFsOUk4Dq+Y2E5WQTeYz7OXMMwGM4tyxeW53k+VtK92UNW5HxWRUSuptXlzE2O1jSght1SpVTQyZbbktotgvjk5A3WqWvNi03eHPLIxzq8vHtszIx2R5M41yWrmB3ChFemKo/pk7GlZXulHjxYDT2ZnptBBWoQhl5W1F8OXyoO5uiYWyzG4rv/Vd8wrs0EoKcufl9pdlgy5iejFlzA7astwFiGqtymvL9wTmA6LmdzfjAAXudfUdII/lwyCVZBDs+wvmdDTmR9xucXXGSlHbnqq8FINoc8ML1nxeQWoGtorWsdwMt+iVZt1RwXxkfKe2fgzWjB3uh1XAVXMAU5tUxSpDIhtgZZxsxahipSwSJY/AVt4AbMjmknrkEodlsdLGYriAG4zYIViIHTjk1m1lS9RSOhftj4FeM78x4Y/VsEoAAsaOrCyjc4lmOsdqgatWOrtlH4m2rdFiiO8NWP61zQBeuyJuvnNuvoRkB/jOjqjgsgzINUGOh/wJK8ps+4niW61uTgquQI/1REiW7heDZAjRMpja7ANLUFA5Hvw5kNKvuFjpnXXqiNIhoFqSrb9TCVdTwzSPiFWcTszBZNWnyFX4bJRS1m6ViBY44BEtABHFiBu23molaa7nFmvn1mpF5CbMbmM+4AMfAvp3ZO6cxVlQVOW3XxFq/q4NY5ITXOrEbVJTU1em5ulNJn6JbuH+fnKw3TK63uFILL80yDV9gGVDCDvPYSXOuX8KY13DWC8gZTS27oR1zuLdDEAGTlRABzRkjTOJrvw9FvA2Hsxu4FZxPi2rAGrWBQlFamL6oT1mimA59F0ZQFPffsQmhbDj2DLEgB057wCk8B40jC1pYzMWb0KHR0GP9F6toucfPZwKtGkcSdNBafauD87cmK8QK2dBpXtCvUanc2qTuQAvUWa0IO61aP7gze51iXdd2lbjDx7siZnCb/YCyf637By7rOa7x86Cqvcr52ZC3visfscsO4PdLYE2ejbyQpc9mIdvse6fre71nGkzm/5ePJjUCBRWHQhnGfRVnY81loSUadBUQohEB4WxKgcN+B9xRY7Wme7XsH8aTRcEhXUVJ9URFYA0oH9f6VY4PD6oztdOCW8VDHYz3OKOOWAq5OdSkN3Qym57Nw7oxHAg0+a7QO8h94QSlR4c5r1pWKT3IzzxXOiyyfJbzWa2i9qUoOE77U2TM1D4p55TX/nx3baAZfMBxqp40zR3Og7wVpOPM0x/ZYHuKMmezWBPenn4RKGAVdGHcnngVaDN89lwQpOoQzmPB5T4FDr3d8J/t8d212U2o0prMSiAOB1+0D1nQKaVX1gfG3o+qBV1W7V+eN9XSGmngpMAJU/3tX13HC1/iO94EjSHzEX3yQd3yo4wGZt4ucSqEYXHmXP71Vi0AiFy6dEvYao2Rhd/m5YF1et3yUAuKQ+XkkMXqit3Y0P/rY53nXx3ZZluXMZLb0MMFv5/2keiXff8VKQIQnnoVXUIMK9YOvD/vlH/uyT8ZGN3sPT2p/P7sd6AO3Z3iQrfFNj3uHR87v73sUf/G9/x9n495cU2du1C38w2d/xed4WX/8x7d10+f8lWpdD858vVTaho5ygGhhQ0eLFk0KFmwysImOIg55BIEIhMhDLBaxrFkjyNevjhw/ruLYy9fIkR+l9SppkuRHlS1PerTG0ZQpR4704MmZkxFPnqsg5YEkdOgkQJOKvnnTJamVpIcQyQqUJQscOFlIpMiKYmuFDBceODggdixZBAXMlkWrdi3bBG3Pwo0rF66Asw5qYEqJDBpfbH2dLQucTNngYoILHzZWLTHjxoYF+40crHHkcJYjQ86MmTJiw54/E6b8F/DoZWOMhEF9ZfUW1k9aH3EtG8ns2hMp4s7tY/dt3r5/AP/nERx4wYoOFRpPLtHIweYDDepQyJBhEeQQjye5nt26je7PoQuczrz4Q4naaUtJcjGjo18yX8J/SSy+SPorf0nzJc3ae1aihArSB0468ZRHHj0RFclRgwgyyRtFCZJUF1CwgAIOcAySRQwp4BADDlqBeIJXEYSV1lxqDZDiWyuyWEBdJ85VFwU3TLKXjaVt5hhonBmzI2if5bjjZTkSWSSPifkYmmaB4QhYemE8CZuUU1IZm5W90XAllr9xuUMNX4IZpphjTrSdcsZlaaaaEa3JppvnacedQAsJV555d3oH55PHjTEGHiF5JMpJ9BFKaEq/ANqRTPwhuspPPfURh6T/AurRoE0JEnVphJW6ISkbE0LRRUQimnDCVqeeqgFYJZrYaouvwkjXi7MSUKutGGBRCjHP8NrkkUkiGYywvBD7o2eLdZNskEZy5uuvwB67pK9QUlulbVr2hu2WR3TJJZnffgundm/e2aa5SpxZ7pzdUYcQQQPZqS6eyY1RnZ+deOTRoIXOJx+/+amzKH+OQhrppAJqeumCmVq6qadeTLgEuqWakEGpN8Bg6gkVr+pqqyqq2FbIcrEVI60mR4CEI7v26qyO0BY2bLHGRjukZDW7zOyywcasGLDIAj3antZeSbS22yINrpdKu7D0mOXKOy65Up87tdTrfscdxlHXCXV6//b6mUe+7um7b3358Xt2SYrip06jkEB6MKUKY3qUppzixIbeoUpMg99/U6yxql+xyqoBh8ealluwlmyyrSPX6gCNN9rscmg0L1aMzLVs/rOylUurc9Chd1Z65p4fWZvRRe8WhbZHb8n0tyXIzvW8f79ZNbpumlsmc941p3Wetw+fbp+dhDLNNDM56p42jMKXjXysiKTS2hzJVPajN+l0cIR01303p5JC8SkXfW+tsfomgPBVx4YjnjjjjMt68uO1XrCGK5R/7jLqm7eCc53zUWVARzrRIRBmxkrgMlRnpS24bnWwi13tKhguMNnub2XKHQfXdCarHaQ7BiGP8IpHPP/l9EkPiLoDn/AACV8oL4Zme4mg/tWRgKGkEwAixCNy4r2E2Q1ACaOUwfYmKvSlL2MvMFUImki4EpUofvKbH+QcZ78TlYAQrOBf/3z1sx4JK4BiFKDpfBY0Ax4QaIM5EmJ4psA1ptGBRZvSBLOVNNo5DVx4JFMew5XBE3rNONLpXXl+1xB4FQFrSjQhI+nVBDZ0ohN4kMJwgMAFRjjvednTT9rKxrax6RBuAepeHPAWxASV4lIDKqIRkZjEJTKRY08kyxWn2Lhbuuh+tbzfATpAiP31pXJdvFmPdBSLUyAzgMNakpByxsA0vrF0zSSNtOQowTreUXZ7tKAfiadBEGb/B06HTOQgdSdCGyjyj+AUZNgoIYo81KsEJejACLhQylFMYx7P8+RLEAUfdeTHGm5jXiRZ+cOGCSWVqRwipR7GN1eSa2Ol8sospXgyFdGqihhN3C47mkVgRiOYwwwStGqRzGMuc3SnM+MzoYmknWEOZtC05jXtGCZuXbBpYaKdBsm0zZx2LagT+SYgtxbO6iC1nIREziAbaTWnGqdPZoDEf9iwnBHIMwmlfKE+l/dPfuZroCQhWE/05sNJfQ98DBNQpAZkVvNJDKJJTN/GQiABEjWgfgHoaIpmpVEr2m+XWeTiZdAIRlxozlgmVSbOXtZYkrJUpf5zo5D+l7nRJYOO/zV9HTYt2EdudrOo8RLXdOhUkehojaldSydUT8gcpqbQqi6oZxcoiVWsqsBLprCGPveZPbTNkGwdcdQOSXlQIAqxQGydVCvjSoPdjRNjEYkOXWVJor7ydaO55KhF+Tqru9QopOL1RmGL9BnEdg6lZDxgYlOqs8hKFqbRPGwZ28jMwdB0s50FrTZ16l//LrKRARbtQV5rBHhZx5DpEnBrGTkehrz2U0JVwQaw6gITdAADSIgDVfmjz3fIEKzZG25NuNeHjKD4uKdUJU+W6ym9nc+55qJudLZCXSbe9a5j0SV2ebzdjgK5ljQI73hFSqT2CjC962Vv597LRifXN8pSPv8Sb/TLOpxiuVsAzuln+YvBP/ptVLdTD3Woc2B6YUe11NFOgxl8Tj716aiheqQeFCSILuhUYmvow26pAeJ3iHiTZHXrW71XKeTexFIGhTFc19RUqgXhxltxoqoiEOQf9/jSmKbVd4dMWP/NjIzLfCyOisU5OIL6MS598pRXzZgrW/kKXKJNNrs8u/5umTduBnN2zlzmNGMn2NZhLSB3bZDTxtgEM3ABG+r8C2EIY7iCkK08RVCCjfRWeWOLydta/OIUqxiIyu0DIRz6UBmbqSFQOM6ab0DjGutAKyNCi/32aqvAahrIuNqikYsM2QFGK3Q2O6yw4utGydqX1Jd9lkz/F34YWsM61g7RjZdvvU155nrLA+a1eaDLrnKOUzoHlg46R9vmjZvQkcK5ALPZ8EJgoCLav4gEtUegYUeIwhTYo4a2gdFzREUCEJUyWPky8uK5CQITaU36uBcNsYjdQK5GNeq7UUuFq2M9K12RwI7xbe98e/1+HegCSEf67ybb1+DX8AvB1whqh8u34JhVO6sdGxiIZ0vieN9vxbdMsQsDXuMc7/hwDjmn0torqeJBPPBQPniHHBupYMvOC8oEBTdEQhjaQEUkBDSFZWO12QBahfKyHeKajO/pXjj6oVtvk6Z/+60ZgbrUpy5dGj+SCm5IA++nQoUai+i6ujTA17tr/3wfI38EfGaZvw1bTPg2a+1Hntlko4UzgLsas198Vt4j7v29U1zLt3aarf/798Aru/JFJartIT/y4bXbOc753a4fn3J05V5igFcBCGwACM4/FJjw1FFNASPwRwxp238ARafsjfmsntwQ0XK5GKM1IKhEDO01RAa6yXRZ3e9h3e71XtbFW/AJ3y7l1fGB3bXph40UmfMpyQtSUwxKX5MoHNwFxmT4hZItWfbZXWR9EWd9n27wncX1HfmlX8apn+Mp4XUU2HP82hNCh3PUH5gx2HQ8UhDY3AZYwBZ6wAtEHRNAXfplIT1p4RgYyAvxXLTlnNA51IRAzANu1SqNUuwVWv8rXeCEvFuksQDuWeGcXV2o6F4aDIIfDEJVVAHWUUjGtM8W5tUJIo4j0hvYIQ4F9IE0kMN8ZEMLuuB9pd0MdlF7uV315eCwqNcOphHdzVewwAb4saIQtiLeIeFOeQuupd8Rml8SOt5WDFh0OaF0EET8HQe7MBKx2d/9iQf/gUBuoZMKZAwYkk9EzBPGYRUP6E2n/J8a/oceMKARrR4cSsoblJIXlFsdyh4F3uE5opYFztl0mIEfumMgDiIhpgEirmNDUNgW4hIK6qMDbIGuYOI3ZCJAZqIzzSAMemK/jSKp7cV9hdEYUd9BIhCzVNb/JI0rvqJFxk4f/dR/iR8e2SL/+oEkLi5hLgqV/B3br6EJI42kaBnjmnkhhLGPBlyMGWhjCF2M30zjI7kctIXCGm6jOx4dOI4jONLhW3Wj6p2jOr6jH1bjH75jEwQihjCIgRwiIv5hdNyjWTRiWQwfCjaAA2DADGxBH2DC/mCifgRkCzLDWq5lORSkQUIkZDFQQ3JCMqma2Z1iXPagjmBD92GkXw6hf5XfLcriLS7bRyKE+omkEs3VSo7QL5bc4fEicpyZSrLkybFLnLWLBnBmZ3ahu/ENTpZKIsZkEyQPzIUCG3YjqHRjUkgIxCgFOcqmOyrlatrm5TXl3njBVUIBb/qhIADCVHaKVSIiOjEiXnXd/z5u5VdiQHOOwGsQAg/tzzA0Q0BWZ1q6JXm1pV7G5cDh4HuZVF2KZywU0yfCZV6eXcCtFGhU5EUGZkeKHxHWIsaFJP/Np30GTmMu4WMuhBWWXPyxC/1R4WWWh3X0YfkoRDLe5MWIiqRRiAdcgAc0kdigQoUuYBz4IWt2wRo83QU2oG725oeKKIgepTeawYmiqO6RaG9CpW/iZnAKZ4qm6HQsInJa1CPiaCNOAFg2p3OOgAzswBbcAR9IZym4gi2wZTakw5Kiw1oqyXZ2p/MxSyxYwh5YQl3epXZuJww+n8CJ4ny1JxFUmZawRpjGZyyOX+UpY26t6UeyKTMi4whIKP8zDo/jqRbwROFklpCxLeYUmtAjLWMTVIoOmApDTJpMYtgJJOLWYJwG6ECFUkLQRchtKmVSIqhs3ubRfaOmvpiMpiiH7qYH5t9SSgqMxmgemAHvGQhpVtpy5ujh6Chz7miPikCtWtsMRBAaiMGQJkIkqQKSJil1BuuwSt8mGtkyHJMnjGctQAZeAkaXQh9Clga0nk4Olo6Z/uWXtOKZcuutqSl+guRh3meNUgCi2gAKeEcKbNy63NhzoNOxKVgiNZ6fEmhryVa5vsDvESpDxCQXfiYUMCgK/J0bECIg8F5VUggObE2FMGyDqmMdbiqnoigIbioDdorFeqo3EudSuqH/G9SZpBoIqorsxbZjEGCY4XwlrMaqrPaoBYhAhcnprS5brupqHQwpr37CJyCpsFZnz0KpdqIRQmqOQ54akzjrDW6fM0nTwQVGtyKNmL5nEdbnuLYpflIaBTQnWFYYnVrmOEXe4c3rozkhvdargMWZgpbcCUTH7zVRxahtFaQBoZpARCHsai5sCWSAxVQIDeBAxBDlxOKNKQWux2rjtIEjySJu4qbobYpqiYZoU4YsVRauxx7scCaonIbFymaujrYszN7WzBpBQUTBF4xuGKDB6drszS7CJfRqJO2sz2KnOAzJMSQDF0EDweECecqdDI4UtEbrl4Ipl0Wt1J7p+YGk/9XGqYJqYdamLBf2n5ruogm9y2QWD9i+2VA5psnt2hVChBsAghnAQAi87fdizMUMIhXQwE1CgcK234fIk2fSU8N2LOEGZ/3a7/3W7/dMrmse7sVqo+Ka24qaKOASLu8Fbsj+L+KabBZu7o4yZ+d67uciBOi+RgVXy5Cirq4Saev+6lqm5TjI7njVbsvEIO5GFtCi8F6iZw/+iNJkydIMr9N6mfGeX/IuYoQybwMzJ9oOGGuFxy+SByJBHkxKIcodmxOuCzG2ZDvCCzJypglc5fpsTN7K5O1hzKRZV4YlQARocQbs4YMUQiRQAiFGahnHI/4KXevt76YUcMR2aqc67v8DJm7qTe4B2/H+MjGF8agDQ7CE3paFJWYLRNAgh24hswYGU8vNDqmvAmsz8KzPEusu5MIk/yp6rV11ZqfPSl+r8eB8FcNNdVaWTUQEyfAsclMgI68N+3EHrIoW79gJTsAGLCgMeC38vVktp20IeYcSX2/aCiPZ2otxauEwW4D66IDCUlQyz63cStREXUDhlAVYlsCFVMIopEKFYrMhaLMZmzGAHFoBbwobM9fuSaynVqzDiDM637GBrHMamwETvMAY9vEqA/JhUvCVhC7oFXLo6qoYSMGuZjDqrm4i9GrO7iztPvIw2AIlT3KPCOslZ2dEvyVC1xd3srCQVOQL+4b/rM1aRqOpKdcOKquynEJouWYYXm0urXyluTomchxx46UTL06YTL8LMDNhPCmvCnAIM1vI5ZXvaFYFDgQfy02x4bzPFjvAA2RAUqTCK7wCT2ZzGUt1pApd/obzVQ8dOcOxG1Ms/a4zOAuuVbezwyxBDdzjy5IhSSdjPetUFNzzBM8AVu3z10hBQN9BzSpy6v6BIrAuLCT0zi50Qz8yJkOyDFLrCl/0w4E0tjK2Yvbdt0I2ZLctDlP2HuvwyTTABrD0uZ6TPb70L4cH/CWEmx0bQXy2TQ9EnDEzM8otFXPmIY5gM1caiTzARFlXArhyAz9AB6SAG0hCU1PDNWezJBD3/1Sj8VX37zcmRSnxL/+uMThidVKoMVbb8VVXdaKpsYT1qwdY2x/vgD3DtZjqc0HYHFrLtSHvanrcdUBnMOm2ARrsdXReQs7St0G/bmEPJERfspNyMifG1KsN1RZ8iyjH8GKXcmRTjCpzIQW0MkqvbFww59ZKlEFkxQgVhz12h7r68n9uOPGMEDrVtE1boflQx+AseISaa08L7BMlNYpTsRdnwBY/wIwntQLIOG2HABUMQlM/tXD3ZFSL8SAE3VRWtXQ795FTt3Un+ZIveXItnZKLs6jMVlqDHnnL03jD9WG+7AdE8Fz/M0CvdxjsqumyN+qS+ZCurn0rNGFDcmFP9P951t3lHLaBdzSBZyudO7YF0XCcEjODn/RJO3is2uhK87AtV+9JwnQRE09NA3FlijgTf9y+mvgyC7VM9qZVnOyMZ8BujohSM2zeznioizptQwAKVIEf8PhTYzOQmzGRizWUM3k4S3esQzkQNcyT47oqxQEXCGA9Y3mWv6wNt8Afw6zo4sbXpPfpJnt7k/mZ/4Hqrq7rwq515vebw7ljfadj2JqdA2H4VdJHO20gS3byojgONzhtZy5KM3iOLaeEcohpQSaI77KhTyF4RCZqR3qfxDMINEFwoq8TmTocuAEKeKYOYHpMejHBX1cCeHEOVIhXKMCMR/yoR4Cm97YhvAL/NwT3cLtTx7e6q5uqkBssrOc6yZf8ySMIyjNMyappleuzXIMebiFjhQ1zXNvqB9SqLJPHFPD8spf5zzu7zfI1fQ92NujFlm4yX8p5DSp2YwOmR4P7KdtiKpf0M1M2oKO7ups0Z1qAA5vFnF64MCYEnWrgaVtmnjwmf+I7E74zCERA//lnM1MUjVNA31pIvMX4dYHFASj1i7+4jU88xVf8CZBAGhhCU0fbcBd3NRt3kIdx0EEIhABnVVP+5Jt8rmuKUViKEJ0852NK3vD6d0vw53Z3zRNzXC9vy+K8re78rvpza7w+0Af9eze7Xg90JSc0MyjGszJt2znZlwxmnd85/wURL4Kzj4KfOI77OYNnPW37Kw6rrAWgrSKFOGdjONn26dqzY4LScsbsdEOIiImjuBIVat/iQN5bPDJDgAacytZBwKhLPFhIAPvrOLSlgo9nsyhUsyRINUD4iUSJ4KBIghAKmvQGUEKHDR8+XDjRUUWFkypCkmhRI0eLDjtqFBkyz5giLVCKUKlyREuWHlxukDlTJgYRNW2+VGGEpxQsP4FuETqUaJ07aI6GQaOUaVOlixZx8kTqE7NmV6+VY9YpqzKvX8EaC9v1q7NlZ9H6oAGEbY0jbeGqjYuEbl0id/HK1fsiLl+3f/f6dREYpQsTKhAnbtkS5oULEShElgyZcv9ly5AdO3aAwEADBxY2ID4Bo0UQ0zZQpy5dWkfp1K9Jw+Axm7Zs27Vv486tu3YT3799nwBhQjiVNICohNCw/ASONGl0ZEZBZVAWFBmwo8CBA8UCBd8TQIhhhUQF7BDAP1AvgT2ECBBQvEGlS1j9VKgk5a9EkP/+gZQMMggQjDCCyMADB0SowIguGsnBBBPMCKQHKdRoFZHy0AMPMXhaSSXQOpCJMZo2uKlECj40MSeVEvPpihdhjFHGo2iswwganVKqDqbuUASUqjrhCiuvuCIrl7GuKYsstNLaYa25CIPLrremjFIwwLC80srBXkDMMMWGa0wm9TDTbDILLkszswn/GujMs9ASg601HWxY7TTUmuANNj136xMuP/H0zQzfwhTzBDjyqCLP0TRoLk8NInug0SqoYMHSCtBLD7wKSCABhevMy/Q779Zb7wZABpEklfok6W+/VwsaCJICB0HQ1oRoVQjVAnmtUFcJfa3wwTxWWYWRC03RyKQRbAItphFheglEFJstMUVrZyhMLxmFWgopHp8yAtwca1TEEk+CtEqZT9jVal1bkFzSrHmZfNJJKPHNS999t8yyXy61PEzgxJZbjsTHzrQMzYQro4lNAQRA4L0wP0UthTr3PM3OjAHl02NAlSgCOBBmKrjR0VLQYTvhIKUMYUmx49TT6zT97lPz/8z7NFPOwitVgQy0Q9QP++6DdT8/kJa11gBvRZCkBzEScNZgha3aV2KLVTpDk1p4FlqSnz3RWgtUfGmxxbTl9sVvkcIxKafc5tGoRdhNt0h18e4qb3qhqffefOeiUvC2Bv/B8IAR91dxgMFUrlAxp42cYTU3KxO0zgyI+M3hLraBzo0/7pjj0f0SvQgegDtpOAlACIKK7USbbrvo2pP05AouyA6HGGLAlFTzVkhhVAg4tc5gibXznXjteIcjVfqE0a+/pJnudddbrZ9E6v9G4S+S7ZV28L+RRCk/VvJD+aX8Wc1nn7+G+ogjDikQGxGIMbAtLP+W6hyuCRVEdBPUZP/rXly7ixQ2JIYxKFAKd2DEAzckt6TETUd3qJuQsDKkvfGtb0yKgr0AJ6XC8etfiVtcwBKDEjBpAFoHkxyZFKamM3kmc50RkQpQRicdho50PBRd6TwnmykA538tYKHrXpeCQh3KEHCgHXOoUIXyoCc7VoiB8KiovPRUgHfjwSIKrOi77wAtBpSqwhuGxg1t0KcQ3gPf0iL0qwkpiECyqgR+foGKPHYPElLrHkGmNpA8fu8/wDBkHtXHPjymz3yD5F4jDSkKM9CPZCoQgx5AYKIx5KF+GBDZcAY1HA2BLTR64ORixrAKNhSmCHnAA08UiIdiBclYR4HljcZllDrYQUf/F+wEvDKowWEMc4PJSMZcQJjMKo2QmYcz4TOxNLDGOY6Ua3Kh5BaWTRlKZgOQaZOb2COaHo6TnD7kWJ48R8QBKqd2ZAKaynRwneWcp1QDeIB2UsCpUIlKU+jpFAfyiTNSaWqfLKjEqrjBxja6MUDhG8n2xKdIVvzxVajgYyG1cVGMEtIUeoSkKCAhCvWBVKQW1aMjKWFSlQLDoqEkghkgQbLQmOEX/4MJGzDZAkjgTwUgRYxMbFC+EoTIBXr4RR8KYwRVnkQKY8BDKBLYiVXc4UZicFuNdKnLCvbIl8PshVW+Gsxj8C1ff8tSM9HqzBIybnHTpGY1IYfN9ozJctsE/xF7IvAwAnDGWaNpwWhMV07Bju5OefrNoOBJKLxSBmg50w53TkBP9YwxsphKAQlWwDss/i54vpNZZyergAGM9gDh2cw9cVCFQaSCG9xYFX4WmjRCQrSOETXIKHyh0duilBKHdOMoIlnIX3CUpZHwqHDL51tBJlel7YtEsUJRBBClEhAAHIEZ3ICSkligBQR5QbSK4FOi6uEgPhhBaYwlLt8EaQxG8I2xdNRAcsXtbeKqEVdLoYr85gJeX/3qWAEcOCvxK61rrUFsoNkl4bj1cXG9psseDENufoab7EHTNzVHARYSB7CBHaw5/dIavpzOc6XB7v90YBzo1O4EVQDDiv9zxzxEBZQB6klBFYKXRRJkoXeiSkEPckwqCJBADTm4DgMyIFrSlrZUN85CGgqhCzUq1GgOtXLU7BjJipp0FBYVpHKFKwyKapm5kfDFcPnjUZEql6XAba75UsrIJshkDAexwU3NgJjtdpcS0g1NnU85AhoIAg+QoB9KVNkCF/XBFFzI0yUZscA7iEG+9L1vjsjVtjnwgRCY0C8sXDEMYjzjGVhSJuAG94QCG1gwAlOwNBncGLg+uJtyndyZ6HpXDNvwiIDtsIc//MOMsWZQd+buc+LJzpTt01QujgFAfYdPLSYgBV7kgGcHOlAuAi8H5bGnA3x2gAykllLOkYQuZMH/xiozNHzt9oUuWPFlYKhbzPIGRn/W3OYv90fMvU1k+TyqKt8edKVvDsXBQ0ENVY5gk24Yg/+yq4KdbiCog3g4TMyQh0HQoCVdAAQTJq7oSOuFDUudQlPbuxRbUjqX9cURpmGu6U6rAhMGJvDNV43g27DVNtpi8Ao9wEIH09rWDMP1XPGq14hpWGC/BjaIQUyn0+ngNySTwI3jGc9Q9YxMB4CZzLiT5J2BBwE449SyRZX2BdSYARzIQbfFaM+t/yxlj2HB87iR7lS8Kra/bfdy96PHO7LKzQRps74Nf1KQHtSRJ/V3f9TM0jYf9I+vNakhDIHwhIeCk1AoiR7ujFNR/5qB4pBwQ55LmSEgnJcNhnbEK3E48sMhMBJ4cBFPqmpfcN230j1xOcy/0K0oNCWEqF4mztV6wgR3KdZBb2HR7wp9o9eVrnitoZtOxuGnb39PfdKYiH/Dg0qCILWz07p73NnYmLHgnynoTniGx+xq81iL3iFBt2v8M+CxIP8VeP9oNYUGxsMP5oM+dAG21g2Q/GMgcKt7Cs/fBg/NxAy4cgvg7q3LFq8+9kgDU2rv0uwCJQ8EvczNEC7OECkUDAHFOCmUMm70KC5RTqkJYJDjVMCUXqAPAKEnak8veEIPTM69GohDqoqCwgVH5MtFpEAp1OYIiOILgm8vzCow2EJGUv8t55ZP50hjNX6uwYaO6KTv6CAs+o7n+rzOMbSP+6BOT0AniASl6p4sCIBGxU6AeDIAyXDACqpA7JKsAqwgP0iAivzJCrRgsxbgx7RgBcRIn+JuABggBgbhikBF7MbOZsbjDawA7xTKD9Ztoj7QASevPvZDGCQQjy4QAoHrVQ4pFQ2vFEtqzZqr3wDBBFFBEzFPzMwgFEhvA5ogu2TQBDIuNCKB9GRwGFUg42RQ/CQOkzKOqRJNLVDiLnwQ9HKvvSqt5SZoCZFwCZ1Q+KJwwJDPCpVPNrTwr5ivHLdw/CCnC79w+sDQZeYqr8gwMjbM6YINiNDwNUwsOFCmYK4ODrL/YGaWR6DQY7QqAMcua7P8z3cQgLOCJ3iubQFIS8nkDmfGoxBiQO0my+uKpzyqgLVaC94IwmhgZaKKhsxAURT6rfAMyT8CbvJOaj707bU6UVVUaj5m0SDyoz78ADpSRQUaIEPYYxdFSQmwywWHsQVPLA9+YPRKoyTQa5WkkFheqSfci21uD5ey8QiTkOWyEhtV7dSkkHCOT9XA8S90ji9wCIf8asHOcYnSUR3XMWFCRNcWS2E04wD2aq8obB5fgB7TEDfskZUIKzjY6TPUQ9xWhv1YILISoGfYrlTW7yEbM9sWQAJwptpW4NrmrmYo8Yo2k+zsCf0ywMXOAKHUbQEJ/4ITK5A+LNCk2swm9SglI8nxHq8D9w4lUeoX7sMmD2pVxAzzAAQQnKe6LMAYVaCJuqkXQQC73OCUEkUXV3AFfSOmWgcXnSrRisD0tMRwpIARIsEkxAX37sAnsPIaxaUryRM9iYIKvVE1cG4Jb+4KtTALszAEtlDWTAYu47LCqE+b7DIyNiMv91It71HYYgMFMOacROZ12Ckz1oOMtqNTjGyMkgyMzqDHlucgEREiKxNTViALMMU8OGAFegD/ODP/9O9Tlk3JYGYguU5SvGC1tGGNGpATC2mifCs2u6zgdHQVSTEUvay3ZjEUZDKlDok3UcE3m8jhbuAEIqDF3iMPlv/UEAbBAyYACrLLA4gSKFsgUVpnEJpyk9Drf26xEzKE855SME9C0cRAlXpCCmAJTskzDG5PCZFwKdRzPfV0C2zuG8myCkcoHM3RHNsSHWfNC/eT6LzpP0vr+uSRQO3RQFttDSF1MLGrTlindahAOJzjihoFBwrhDbYOaOCgEHJA7MaIBc5ADUBUAn6nB/5RizhADYSAELVNtEaFjGaGBXKG4zKyUanNC94gErShtSqwP86syzTwSHn0R9NnkWAL8S5vNxHuFUJw72rREFIgAqoABSJGACQADoQDTDEDEFAgAnqxlHBxOAYhz46xGFUvCPoMBLamTmxQCrATGhmBqab/QCPe1CvVhtLEs4H+VW2yUlDVClAVtpl2oBtPCNbCpFCtLjRI5FCtSQzjkk3ShPrwMsPg5Ayx8IfGUcRUg5zacIB0ETpyJgNYDAzAwFMkMbTIbtwyK58Q0lUHCmKq7bI0kzJJxZ6QDKAE8Q9lNj0SoANogAUeAwdGgUZVc0dzKzZP0KIisCZf8ln3iDZbcqVeAQUzbxC0DvMgIABwDGICAALOQANSAA4ewE0U5UrToJJu8ZQoITk2KfTqFod2ygYSRYVa73Sc8i66VBSmQNH6VQ/+dWHTk07Pczxxr6kAlj0RdvZS7QnLUlAhdvwK9YYMVT8TtdYm4IXsCkC/dUBz/0hSX0DEUgYxlChBXXcwocN1kg1S8GoybSZCtyPJbHeLYmYj80kCFtJnQxSgOIADfFZTGJEFjCxmira0MOABOmCoSiAOarSjLBADKYqi4gzOSspqu+c1CeLyOPAloygNqCABAiAAUsAQKgAA+BCLzigBnGNRz8gCdCDQWgBNe0oYlXI5KeF/wms6H8WS3FRZHG2IRGFfr5NDBmhb/DQb3YsaIxdGJteBFfdyoUli36pz3xJRP9c/L6NycC1ANacBuCst/TI3AKt1G7hO1nKwis0Mmmh22+lBVVRC3+D9cnU8goxTekALtCBWKVOLZCafODNX7/ANjAwgfaYEaKALhP81QADOfJIrWbWXipsrJDMvPzRvR6FVpYomD6CjBbirCVKAM862PNK3IBGlCoA3ZSQmr5qD4i4OlPKsGFXQhcfYBswANZSyf/jWJGBqal5pDB6oI5jKT6kyPMmzvcCzYPMUTpfPgofvCCy3kpeJT4sv+QhVgyOWgz14TET5gyfHMDnWUTO1UjumMC5GLVHC19JynHbxf45jF9u1PchIRXknZ+6QPFCVU3Z5oBCABA4BETZ0oGpMeTBLs0IUVbdIMeuQBd4gh5O2CxgifLHXerEYtxCpm6k28f7o4LaXywDOWatDjG2KAjjDhhAgfdNXYt7522oInhNgc/oqhVQIkB//pWRdV1uYipUcDSV+4+Q42YIfWE7Bc4KNYJIVedUCtaA72ZMfhwurycKk75o8GDKed1EbhnaVbnNQmDRAtudaeZ0G6HVPenRmmepeJ+N+d8jOAEQFcoz80TMlS5gLMbMcsmeH+EM1q1NgNj1ICwAVwKDa6KhF8oqpGJJ0k1nTrJy99+D0A48K4lEgha92zZ3NtgDWeatLGJwgbDj0RzTABGMiFpDNuoUJyBz/uYRwjpEXFxvr1IAYmkow+UXuGoMTR6I3GK5IyWJDObAnY2P30mAuzFHPS5r6ci3XMk7SGqVxCKVTQ1A8R4xVAJ7cj3kzMj1uuFPq73cSEZiDWsga/1NEBdGK2K/HFIDtGID9hjWpOdEBZXupoQu6Zpu2o9o1qRYQ3ICGr690vymrvVqrvxW4XSZiVShO8Bmf0zqy5xNxSKg9feBfecIG4vo8pwQ9xYXnylEw0CqvL/iDCkdx+LqvKdqiMfqi0dvWQld0AdQuPRqVN8w+0zKkW6B1XfmkWwc1nDulX8OwfoOGG8Ufb8ZnCMpS2M8Kwghnj3cBRNt4j3fccKAOM2CaLRyNtAe2K+Fpbxu3PdzDn7UmMa9WvAAOH6MxMWy4A6CGiLvFvdpRwxC5l1u5+xkf/buulW+6cW+RI1lO9cW9gJy7tzMvwPtPG/qhVUOi2XKiw4R1RP8kvddRsNl7dEkYpMWarMWRhYVDMO27nH6jMfBqNAHExUS1RUNFZi5zaIlHyBj8d0Z0ZpQZU4C2xkrACjwwtrNXwz3ctj98m6HapFqlJFDABE48Lw39t1ecuDPHxbU6uN8kxq98xpMby/uboXPcuqM7Qe+iCf6V0w/60J7px8Nbr5970st7/MJpdSh2vaF8lKV8Hf8TdDFnQO0bv/OZsSO7uff7nIAjOcyw/KZ5wqkIzp3ZnlYADGw6ZrXt2K0IoHgnshgAyVhAWNHoVTiR7zb82gPvWMvHFPr826EaBdu1t53U0Q+9uFWc0RndTTSWTcRQxpm7vhm7uRcbx53J00n/7BtPwghEJnGvEi8SeaHZyufSxhmLfNTL0tR/rn8iXdXPu9VZ/dX3U4YMu8pDlzkgtpVROJYrXbITNLEyzuJYNsYY1PwEcndL+4oOEsKFt8D5UBKcyDmqPak3fD/w/Oa7Hc9zHtxlG+HG/VHu8tBH69zTfd1fnN1N+WDOmpVNfdggu7sBpi9Ctt/VNDUEvk54POBPh7pFneAxxusp2cgRfgpzvLz7pwI+mcnBvNXZnpTbcXTlm6yVSLnpfsEYvmRjOcmpbheXNAgYRWfeycV4NYs0GxCL2Ig5dCFtd8hK1dodfyRjmxMj39txvgJvm9u7uH0cjtDVGXO4+rcNvejT/x30Pd8zYp0m4D259Xu50Vo+d84svx75th7r9/10Ar7TsV7gVZ/Lj1xwFDovoL7ExpG+T/2Tn9xz2z75J74/rSkCEHueNphROMeVI731bXzvMw7zeFsJGpQycKA6vCC1IrF3NeDM/e8g2clVgSZoNHE3pYckbV7bJyrya37+/bzDLaoVF+8NShwgaoSgEMEBAgMIDxZYyFCAwwAPIUqcaAAiQocJETYwOMFBQYIWQm4YuQHESBAoVahssbKlDRstTsRkyfJlTJs/XujcWYMnDxg5gQbVYcQIzCZGdBRpYRQnzJdQlxJd2mKpESlFsFotytQET5pgmRIZS2THEbJPzv+qvYKkrdu1bNEGjUoTZssQeFWm3MtXb9+/KUlKGCy4sOHDiEUmBskYg8ePkClcIGzwIsIIGjKDkAkiRWbOe2XCPPGUNE4VRFvoaELFDCVUsAelaXKigoYHCSrg2P0GDI4MGR48yIACRYXjwSEAR5FFTZbnWeAM8hOokqTro2BXSjXKOitW3it9/x4evPnu6NOrh80evR4zUGhMLnggY0P7EfNPpIjR/sb/jzWmmGCA3WVgTach6FNQPjS4IIM5ccUVVUU4BVVRT8G01IVFaZWVhCBwtWBYEToo11toxYXiiRB+VRNNeRUo44we1JhZYjYaZlKOOPZY2EcCMgakBbf/KYQRZpolSVpKoIWml11Q2bCalE004UYowggTm2xemHBBcLqxwAIOYh73ZXIJELZcHtxdZwh72FkXp3rbmXfIeeKpR54vfIrip59wbvleEDDcxlFl+N2nH3+M+gcgfZEFOcJJJZUko10rcTaTajd12uKnoBKVGlJi0WVVhTA1VSqGHo7V1auZKkgiXLTWeqJWrjKV4KYwxnjgZjTyxeOOleZI7LDFosQjYT46NmCQIAUYmXCVSYSAmkmCYBtK2wLL2ZIWvljlGHmEYm57gNwQnAYnVPEGDqQVd8MJX0IAwQUnoKBDdGm8iV0o16EipyR05mkwnggjPEqfgWoHCBU6/9BLX6IDEKDoogA0yuijj0YaKWIF9lpXhrySHO6DoP4gIoZRNWXqhjapyupWK4volayrnpjWijvfumLKsBoY7NCWkrQjszZmK8GOTO9ldLPQQtsRpNJSG8FC1jaAbV7AmZCBrzcvqYJQYwM1rxJWltueuVyqO5zbk7EAx7s4eOHFG9OFJx536B1cXsF6+r2eL2sL3Lah9SXaH8aM77d4RgCG9HHUTzf9q0tjZ162yZ5eePLnGr58asuqOmVUUyAGvRPOOfvcs+s/f1qyX0IPbbmwyRaYrYzJQv2jsxNIPlIEwk9dtdUVZU3Ytl97aQLYmYNr9vRBjDtI4bG94cUNk/8SX0IFbxjsnXZ6ly+44IGjD+gvaw8CSBqz3Wbx45ZZ5njjGzN0EIAdGW9B8CBxFkE6UJgR4O5yB3oK60CnQLm0DkKliwrNUIWhmVGQRLBaHZRKBDtbtSp2QGgRr2pHO6ERKDBOI1DRbme7Y/muMALEQPEk5z/jJaBqE1sckrj2vOZBTzTSox4U9MAe9mWHfH5wgxe6EAc4TOJv5gNcesCzt8BJcT3s8VMetggfQg3mYvbD3/34oz/+mbEgABRJDJ9VuRkZSIGYs1CGGDgTznHwJqLLUAVRdxUp2CyDC3ygBwfpOqBhDoG8U5aycufCAzZthYvEHY8Ys5jGBC+NmPz/CIAOEgGr5dAiBvCI0pqkGbHJBIjUWwIXBGHEwvUNinu6ovhemT4rdkcXR8SluSCRBzOgKmLFkYCRFoW/jI2Rfpvsn/GmNkM2qtBGLETkyDynoJdt8FV0/BTLUjWWpdAGJzN7Vc0CCUFCdhCEJsIUpkRGQkdSapEFZGQLs1WsFzqzmcQjSA03QjXI/CeMGyklXnzopG/tJJVQgAT7XClLW8LSobbkGzB0AQwjcgk+SEnJDTaqgQQoynHG3E9IHaeQ/Z0xMswMYDNHIoI2WsqNl3sRzjaYTVOhrCo4zWk3+cjNpWRlDBLCoDixKchzrghXLBIhO0uou0iepJGHSSE0/4lmTwGulI01jMwmORmZRGltd59RgUANOr2e/EQPomilehgGUYgKjq0LGxwquIOKSLxPTAJRzVNaA0xhXuSYgCWjSfvpsUtmcnj3lCdMY9pAms4RjzFr4MoMqZpvcmgsSMlsVjxEqnH+kZtJNapoHThCafaFJU4tIFRPONXU0jO1viNg1GRoWHz681Bc7Vi1+vMYpfmwlGTVCQ1+Qq5QsK9PfDLiEW1pxfHEFT2xlCt67Lo9L13AMSNQymp0wFeJHUSkIw0sb3N7UuIddqUtFUx6W7vYX81unaazaYI8x8AKiWiO3fRpH6XQBKTSbKg6BXCDzPm6c35KBypJDSLnaf85SjFyMC5EDNKqSjmpZRWNmrxhx26Y4TB+5F5JykzXYhU2syZhDAqt6HHjitznRtfFzo3x4NIXCe11AQUTE+UNqiQlznzxr+IFpQBKSmTyFhaAafTdpJbc3kNmCr7khGyATccpyiZFj/EtSn+xIqH/enaoo+WZijqo1KUy2KmrdXDv7EnhewooySnVKm41zFUOe3SYQ+bwZL7GZ4J65c9/Hu4S4hCJXyS3xdJgMYtbHFcZR5c82umO+5R4443S6wC9NUFxUmAbv37XIkEG5WBNKoELI5aGHUHMel3KZOj9qklCJRGW6SJls9o6hLjOcjp3EkHUbZnLNZNQl1k22T3/EhhFwN5phC54zei189ktgKRiX+rONLfZzUKa3Az7mcyEQOrHeB5AmoajHD6LOC+AvvUSBJFWIyL30M5F7ncY7WJwNPq5heDljUsQaKUMhDhLyszEQo01rw5WmQjYJ5wH9AEfCcuATXYyaqaMIGJXU763zrXGN87xXvexSskeJ2iLbewwk5m0c4HjOk0bcaa6HLZsTjK2r1o8ytj8tnPeyLX+6en5YeSGwgErD0vcEzZAYtHvRrrSk+voKbJiEo6wMQtKMJnnaXpK87rRp8F7zPuMurzB23lKNwDAhodk1SCLZMt/BeWVO9Zljf1JxjvOcZTp8XRGGMMY7vDBrcQa/6clNzmrxhxaV7392WuHeK9ayGbBLFyGNB/S42mIc9zqvMhXAzfWMmaxcfu2Ruk2cRzaDe95vzvppkeuvan4hhsLeriwN2vsxXrdrQcgvPczeLeVqfBUk13mjo8qexXPcsaGxSU0LVXc5T53ujMfaCMvwhi0IoYPpk4sLclV4HUm5hQVHvoSR3zxz9x4HKH9nlaNc80/InY0Xj7Hde6kAjyKzB2+1oCBpkEXnph61cOb3kwnHq4waXPAbwYoe7FHAyVAA58UakI2P0bmfggXPKUWZ8BnGBeoXtH0cq+WQBRXIp9Ta8/XfM63IKizWdKnd1hxBWiAK+MUIiwxAxW3fXeCJ1ojQiIwRW2Jh3iTVH5mB3kbcH6RR3lyVnl1hnk7Ry3z51EVw1vDAVYHKHqRsHSIxmL29m5Q9wZ4ZYBRmIBUd10PEEaAtXl55ij8pDVmpExkt4b/o4aN11IbOH6rQ2JClXz4VVMlOIK79hSng4K44l8AZjMBAQAh+QQEBAD/ACwAAAAA4AEOAYceEgInDgIrFQUtIg4vGAY0HAo1GAc4Ig05KhQ8HRI8Mxw8NyJFHQdHJA1HMxtIOiRKKhRUKxVVHgRVLRlWJwtWSzRXRCpZKxRZLRlZOCRaMhxbMQ1cW0FdaElfPzBhPzBiHwFlg11nNhlnOiVpLgtpaUxqQypqSjNqVDpqW0NsQh10PiV1RSt1SjJ2Nwx2Oxh2RiZ2SSp4jm55SDR5VDl5W0N5ZEl5dVl6Qhp6SzN6US56bFJ7RiZ7Rip7SSt7fGJ8YT59nYN+oIV/TkCAPyGAT0CCPhOCTTSESSaESiqEUzaEVTqFW0OGWDeGWTqGl3iHSiiIRxmIZUiIdVmJRxGJVzmJbFKJhWmKVjaKfWOKnIKLUiqLWTaLWjqLj3GMcU2Oon2PYjuSTRmTTSSTXkGUXDmVZEOVbVKVnYOVqYuXYzuXh2mXv6KYViiYaEeYfWKYgl2YjXKYk3WZVRuZdleZyKibbEqccU2jXByjXSejXjKkbUilb0+lc0umfWKneVanlnaoYR6oaTeph2aqZSmqglyqnIOronqsj2+sxJqtcTuur5Gyza2zbCuzbTOzfVa2imW2u6K3eka3hlq4k2u4p4e5mnW6cy26dTe7o3q8g0u9gjy928HBeS7DfULDjWXEezXEfDrFj27GfTjGi1bGpHnHm3bHnoLIhDrIlmnJqIXJuqTKhkbKklrLhDvOkUzPtZPQqnPQ0LLRhj3Siz7SjlLTnXXUjEPUjUnUkD/UxZrU3cPVkkvVq4bWkUPWs4vXm2bXpXfY4bzY48fZllbak0bao2jclUrdmlPemUfemUzeoVrgnnPhl0rinWPjm03jvKHknVPlnljlolvlqlzmoVPmuZPnq3Xn3cPonk/ooU7opmbpt4jq0KvrpFTrsF7rtnjspVrsq2PtqVbtqlvtsWjwpljwp1fw7M7yq1byrWPyrmryrnLzrVvzx5X0u4X1sV31s2P2tmj3unX35Lj4s174wG/5u2z6wnP61qX7xHr7yIb91Jf+0Yz+/On///EI/wCjiBE4pqBBIgiNKFzxgiEJhA1FvJA4gmLFiSRIYLBoUQcMDBQouFiBBIrJhApLkpDAskHIhya3bBlIBQmOmzhG6pHEx5FPn54ceRoqdE/Qn3qS5rmES5rTatO8SZ2qrarVq1TDac06tVkuWr6eiX1m7mk0p2XVpUW7Nq1arW/VxZsrry65u2rpUosKlVq5e/PwBQYsl+7gfYj1Cf7G+K+9x4ojHxYsWfK6y+LiFsZcl93gw4j7iR4det67058Dc/a8OnNcZLxw0UK1iTbtV8qQRZUdTRzabe2Cm819rDhxrH37Zp58unRo0qTd8ZtOvbr1frrAgdMFvTt0d/bASf8fTR1faO6hwTtHvc2s0/bT2i8fXDChwfoQG0KUOJGhf/0AUoTRRSJspF+BFEhUUn0KNUjESgy0JNJNMs0hk0c4uTCSUUF16ElPPwklVCih+KSUUMf8xhVyLE611YvZWOULWM2MVVaMNbYFo47muKaZYfLgtdlc47g4zlypDdlZZKIpVk5jjkEmJWVUMukkZi8quSRrgenz3JelmZZka60BdxdsstnGypqxLbPbK6gg8xZcr511XG5XuZlcVPN9lhiYz413XT6EEnqdPbHYM56g3pEWy5/QoWelNeslNg987vEljWusITTQGEYctN+o//V3oKmmCsgQgiLA8NFLLyz/CKqDCG3QUoQb8CeTTAJlqCERgnQY4lBEjShiiXo0gmKmybWI1Y0rFonjVzTmCO1ZbvGorZBaZlmncksSpmSXTV7Z2JTopmblpT/2qGVnXHoJaKWfkbmZa5rGtuZtbeqmKZtz0olXV3e2KCRg6gJaHqPUFToodboo2ujE/cSyXcTd6TIeYuBxI29zg2G6lW4ky1fYpwWFit+oD6HqcqkCqopggq4iCEKsotIKIa4hUVjhTFHcpKFOPAUrSYjHijgiKCR6gi2zzTob7YrFzFbt05luu+2PnREppLR7toNw10NO1k9kT7oGGTjpJlwZlgK/6/a8lqqm2r34Aocpmvz2/6tpfMSQKOeOdUqL5+FhbzY2uektTJ51DjtcHaLyPn4ddPtoVznm8rrDMTfirceOpnuXHJ9rKNe3sqkt9zfSywM61LpEEFpkK80xMRjqCxdQECHPPu9qk9AZjeETiEcfBZSxTJc4VC0qQi311DCOdYsrsxRjbfVaq7i1kkV+nS9c4sot2dn4pG0YlerObW7eeF82T7ybAyrm/FzGpfffgOsLFm6mIx0vmLYpvuyPcNVAXOKCg6TFNedLD2tY5CQ3HXeAI1GWe1i5LgiOiVmpbp4L0zoCOD6sbeM+BwHVqFwHs1O5ECKl6t0FKKKBkOAuZ/m5Vc+CJ7ygZWRDPZGEh/+IQkSmLc0T0Csd1qYXvnNQb1pW055YrhWjbXnPW1/Ti3CaKBU9QaUw5RsXZUhzD7UtroztM5ul4OYjudXFNHRDDGruxkb+7YZvbMrNXgQIOEzEKWAI5GLUuAhG/IkJghEkVDcmSMGzxUJjEtTgaNgWnkY9JoQi1Nz9RKYWJboHhfeB4UNmVyoYuhBACCGDG86gylYqwVW2gkkod/cgl0hoAzgRnkyIpxOkCWJEyTtK054nvUFaBWxVIaQgceSVKNqIit3jCha7tcwEfhFIbqwS+tS3uCi5r252OWD8VsM4+22SNforIZr8xwsSwoYY7ZwGLi6BiswsMZB7NObBzgj/R+9AjpGM5EfmOpjIy8mRbfqwDmIiFrrSaE476CTGe8J5R9hgLXWpM6WpTAlDjaISIXzohTVGOlJVQMIOXeAdLpOQu4EghAc7Ax4Ph/cCDbVqD3zoCR+E9RNiCXEUxCrm1JiIQChi7xY5uuIVoSnNLKaTK3jaFDazWRk0FrJraSznGsU5TnLGcY7o7GQ+SUZWeOornnBZp99Q0Yg/3pN01Wyq/ObKOMf9k5H0mCA/dIHBu14uhOHZDuZCyDYwzQ+irGmPbvBmp4JFoyB5ACVKONrRyrbwpUd4RDewQY/O5sMdvRiEGXywElmKSiU63GEucYKR4iXLEXsIltKKCMyz/6yDqUYialMF2UzsuSKqSq0ij5i5QKcyxppk9eJUGYjNQ6LtXJSha1YNmzbjdlWrDjUkljxpVtzMKI/tJE6a8ihPULTVKX4L7hMFRhg/IfKf0ynUIgPqDouJBqB/HajmBqsPiIrOkOC4DHqlStHhRBWUoFJhSn5o2co2mAhHIMIfNttZdHT2FydVQSxJgsJQwZQlt9RP0HpFvJsBq2g/xcQRjwi9aOJWt1DtLQGlkiNnOAO30JRelsJ3XMeCS4vTfGPlwgOPq6aNn9jdqnWva9jMaXd0B3STWnGzr9vsq8p9I5mKf8sbib4Vn0YSI2jeG0n8Osy+fjXUofxrmgoedP+//92uNFIUH6uOrKwSRXDOWvfgPvsnwppFh6AFTQ8Mm0HDLHkBFtrAaNUhIaaqTYIa9qCGMuyytcCS7bCWN8wW3xjH66XewAhWtVncprHBtfFwcaRPTTVRvFLE1pCcOGpawwMwb+sT2ZCc5Pedrqt6GzPIzgnl0sWGnVZTk7K5DNxbNCIQzDZOUr+827hhNcmPM/MEH5VmNU9OMAjFZHbhPGyIKtasfikwct8JGz0ziM8fxayDYRjhzObDwoSmhzUocWgbxsrSpy3Q7yLdh0dIotJJ0M9IMv3LUHBoyylGonpDnQ4YV6841AoFUlF98YkLdUfWPHZ6mbvFWsOlqrr/tqpjvClsS/UXfsAO9iFnjtgAi2zKWO7bjETu5T2hIhDQjkaXpf1M4SYuzON0L5m7bajwSMfMBoWo00VXc5rjb3/ovpc6iaPnyrbswcObN2YfcW98d3bfZFiBDR/S6Nx9WEL84cEWcLqHNrCUhQw3WrGGKfGPV1uZfye1jDc+7U8P2OPrrrZad67cpyLwL7nuZtK/+dy9tDGdMs/qk41N5StHsed23KO/fn5eXBC9RmSl+DTdImStFjSSlINvI6tT83KD1ernPDdu4GfH47h7hfDu6EmIoEJ6x0QU+ehshfUtCjuonSUPAXjbE14gEYyABTzwQQ9c+MOVuAAKjBYE/05hy2lieZrV0AK1rZfZREDSGPWlHgXhjXPFaYPc71Cx3s5n9KySVxvXi2FkrXFt2uQci/Fr8WMyhdQ+o8MZvmFs2kNlwAVzY4VWm4AHTHFsjXV6T2NFUwFIwSY/Y/NAHPN69QVJ8KVB/XUN5cCC/XR7qdEc7JE2aiU+W5cbv4cSDLZRL5VKDjYGR1BvZGdhysd8fPAqMFEGSoFTZlAGXYAFTthKTdhaINB9IHAz4edLEdd3+Bdm6xdXXngtNWI1M0Z/v6EWxLVUL5Z4sPYVE3h/ciUl5BRGuwZgBYg2CKh1XFWHZKM++OJFgJiHDqhYaRJPynAJeBAnjgV/NqJjHv9obSLoehlUHrHAbZOoglfHZjHoGZoIVvujgfnUe1LWTu6mQhnxIDyIWWPghHrQg6uoFKpkCvTAWUVoDabwB6/0b27QBzjFEznFhHYQjG5gBsNIfa/zQ1gofuU3RLVgel0IeP6HTEVng9bjCs3DiMFlf6tmdKnXhv/zhjGWeFLRh+SoGWHlQB/kJILoeApoL1pEgfkEc2x0DJ43eoRACPOHbtiojVCDY5cnXQ/kZpdzQeZxiQZ1NtdgDC1IbPnDJZpER75Rg3fGhr6HYMS3Hz/0ZyRREnrQi3ywhHtgcJ4gCrZgC9aQfHnlWRiGizJRabGlCDBJaS4ZhVWgBFhgk7v/ZBA2MTSr+JIN50eCA0+gR21h+IX+Zz1TxGPCAX+m1gmgMH/8aGBEKZXsFoHONI1Q84blaBdFBiVmJA8P6VxrZHnweEVdZY68J4+YpwxN6UfNhgf4uG77uI/cGI5fBnPY9iXloJD14x2MghgtCAzbwJBzBZANeVuLJ4oWVZWlWCtWyGdbEIu20Au2kFOTKVIixQ0j9Q56FQyDIJMuKQhqQAgzGQZOuGgXwlLCQ3d2N2JbECyiGVtAiUTnx3FEmS1dmZvfopVLKWNOyQrFMQrYaHh02YX6Z5VXQ222eU0UdZZcY5jOlT4PuIeht2TweJ15wzeXsJ2KmByIeAndyIji/2l/VYRcpHabmddPH5MYe6mQhYVIoiFu7LkNfFkvIShdDhlR3aUMY0WRIccLBoEHkqUQ3bdRZfAHnzCZmtl8IXUa0EAp0PAO0jGhE8oNqfCRplmaatAGNNmSurSaHZkUqvOKx0KbqLecRaeG7aebQDYW4LiBQHWNMdoMTuM0zSCGVFmXGygWyHmVUYmiPwaJjbFkW+I28xM3+AKHcIWdS9pGhLgm20lPwClAiAgKOeplxQmkSNmIdRk38SJ5i7VffWlOxiBRhSlWexhWiWVjZjWlWyeXOJiDmPZnB5qZp8ENjxCSELqZEkqhDmOLKFVppcmhrMgFhmqoHxoTIQpwvf/CoSPiplfqn0VJclrUoj62gdcTo9ADVDFSo+SZpejnose5f0gVa0LlY6unh5RKVZbBpOgJePEoiGcSnGwVpWDBJ9ZEDbzwbK5wZ2Y1nhyopZcKpPdZJv6ykOTWZPcTpmSjapxUrHCTmPm3o9R6DBapYHP6Uo/QC++wmdbQC3lqCqeRD83hp2omHakwk3kQBuvKoe4KcIiaqG2gjCKKQopgom8lrEaXqv9oqRxIdDEqf8RyokMxbaBqm3fSo6Rqhvqaq5NqnZMXnWUEgjfXaooZiHqyR7HhPNcYFrhaVvfICxAIrAcrqsP6cf8YkZ6WcnLUsvbpJmeaKarmrGg6s7n/cT0eK6mIE6cWiZEbtQcm+a2fYHCQ4ISi0AskuafmSqHpaqjrmqGE2pKmOX0LsiBKKJr1uhRuCQxDaUw6+kW4uarGRVGnB4pzRiL0RKPXmA0Da2DBWq0Jq7BWWbIm+6om55xp5DX25HiKuSfJNYqA+F1bRl7KgV7xRHpdS7J0W7eLa0K9VyPFaofEljb3KVTvYbOYSrjhuYgAOqA++3Vj8Akk9QlbMBHgtwcXOgZAyw0UCqGEMqFNW2lRy66WVqi70pq9QhCRtbt5oLXQY5yt5i7vAmTjRA47qoHYkqlOGThtFbCcOhxIFGuKG7ek6kzSy7gnG7x3S6RjgpbZGTWB/winy9CGnVerBFRjZDm+x9Ye37lEBluc8NtMcdu44MuwXkpXa8pJAma5WWm4+4dnw8p1KoNDBNp9RLAHIkUpffAC0NcGkxAMZfAQolCCntOnbtYKikC7G9po0sfBjUYTjdq7IrwUQgQ9XaukybRb5vMY5chAIyNy/6u2TUOjjfCbPlWwzBSBb0u9pYazzpQ914u92Xt0sRpk3NTCSPq4VQG44rWfrwAntjG4Ist76luIvtEIYoAJVzq98Luw88vFX3xPehNzTSpU8CSeJiyU7AS3nGutXVfADLYFn9Ct3yoJDCwBJKAGwBAMeyASpMC6FaodboYPk1BppPmubefB8/96j7/UyBDXaWl8m7q1qgBYGe9zL0LXhqiQbE65vKAAl82Lw30HxmNYygq7yW7oxaQ8xEW8Y+nbr35og6M2reKrDBJ4y1AMlG7JrFHmP8DJvnmwcWy8ypmMs8S8yvYbPTQbZZerDqpWy9L2q9KMcT4axjuaYAaREg2iIRmJwN3arZ6QdhLxCNfADQuMBKngMRXEDcFwDfvgZpowmhvMwSIsz42sCfhMCs9jerWwz6UKeidssWAbtl1jyZbRh1phHP7DnVEqpdIQCrt7w5waa7xhzDpMzf9cNdUbRdV8zFxqMNVpQEm6vbIMzeS7c1g2m1P8j28CXhJ1C71LZ8fr0WP/aMxVSXTIG8TEzL/KGcZlG82FeKs3nbBkxXU9awRVWKCeQFLdygyiIAkykc7vkAqCQM4keEHBQIKTcMiMNpq968gwmc9PrMbQA8P8fNbYqH6DtEUrbND2GZG2TGUq9mxAFwhtJZifPAfQRiwzmtEXbdGlKrc+zNEd7dH+Gb5KnKo85sp/08YonXO2sdKD6L8u/dIY2HM0PZ7g9dOc3dl/faLkmSnJjF5gDMPkyy8zndMJizK74yBG8EO/8sfffBrXIAodWc76JTrG4J6ZEwtwApOMvAlhjc+1wSZqfNzhFdgxnNZg2H+UrEWV/DYQSdmdoCzWrSwaFzgCutd8DVTK/y2/gw3YGx3e/1PYmd2NXrucjH0m623SyWDW5d036YbQ62Tc6MUKTgHRWuy2xyxtFo3Gng1rTPndZY3M/HzGzni9yQ3U8J2pp8bDnQ1ZI+ra2xwFSz1HCUkKgiDbd/qQ7LCXEqWQGvsK+Ox5bLLJlX3cA97Dpdri26N6QtpVb8RP5VPFUey8zQgKBtE83d3X403Y4r1/qBzf5b1zK97ZmyuOOhvSrdyfqd2jVjbWwEHfyA0wZ9sUxIDFVkraOh3gGA3EAN7lDH7kXt6MaEzgBA7hyOnLQ67mnG1eJCLCKUPhUZAHnsAMlMkMH74N+twK28CC9CmYbFqVYw1AgMtzhf+eXoe34qZG3mBecaE20MXbLmJWL3YhdEXuvHltPD0esC0O5L51VORt4plO2NOr2kkeuAqk5GHD5Kg2zfAt338x2aTtxKoGXoQgBvjN5QLu5gMu6mjt35+tuP/tFTVt5god7BqN5qY97MnO5tHW4M1OHBLNNJGlQmKwyJKQRDbGDLrHtcQA7kNNvlX86tO+yo2e7uqeDJBOa0Ml6WLrf1Q1Nmh4HPAE5yUioKvY6T7u6KFej0TO0bas7j762TwHwAi/6qwOvn57gwwu5GvCrFSOc7Z171PKCoEwB7dQ715O7MCu7M4u7IJd2sH+8d/N7M3+3Vhm8NOe00MxOjf8Ezb/HMmHp+JUedIhj/No7demTPAEz+7tLo20LLzxTunZVOMw6ggjvLtH1On+/u8Av2zW6/MoD/JrxW6pvpgKn96NbfN3kujHCpH2xOtobVbNk99w2RS8bsq9rtlNGeQ7z/KCfT1kDt4VDfcsrsos/+kr/+zjPebKDE/GrcY1P9QO/+XvPfAXzYggL7DSe8pUnwvuso37WvREz730Hq1oovRL77v93OM7r+5Qn2xUH72D9+80UvX23sRen/UMj7EJD9DIHeLISrkV6PdnPddapte4wPHG3t98jfcnz/dPn8psj3GMH97RK5zM7/Z7LxsOjspz/8R6X5ZzJui1/uTum9pg/273Hm+Vjk/myg/s0UgwHXj5lA5m+6SqQqc8JvLVEt3d4z/6kE3/Xz76xu/FB4/wsw8QygQiq7bMoLaD06gtPLhNnMNtxoBNdCZtIjGL0iJiTCjRoTxw7MqN3EiQIC9cKFWmTImKUCNWHBuJIXRMnbRozXQe47nTZ7GfPYuNInrL6FGkxZIuZYqU1iyozTyNuiW16iidtzzpLBr1KFGrWIeKVdp0qauuK329MrvWLUpzccmFo1sX5128yITyTOotL8agT2dlI1y2b2GhtAxDTbvzLGNUkM9NlouX8OXK7TSr29y5s925futyJl36oTRcmBqBCsXa0WtMU2vV8kR7av/rxU5dfRWMNjJkr459/07bVq1ajK2IzVaZfKDCgtEXPqR+7aPI69i1i7RuDKJ369dCkjx4cvlR5ixTXno5G/XMmttw7g0aWDhRqsb1m4Wai6vVZrTaCaz8dBsLrLACM2643wx8S7AHgcoMtL/mo4+3aER7ZqD6INzwv8Ps660rxRDTDbhObhEts8tywswz00wLbUa7CporxpsqYqURR1rzkTXZ0rstyAWJY7C4nyAjsT/D1HMSuVZIkdI95TgyyaDpqJsnJC673BKcd8LcUkwywzPTIzQ9cu64s1TrkaMd53BEIwsvLAsoOzvR06glIXvsT98g9AqrrRgTEL/+auv/ilD87tuPTwZ5YzKXBpsCbcIKhXMr0HE6/VCvT3Nrhq4k8VQwGVQpBS6qnE480pVsPrPrU7lwhAdGWT2V7lLqbgqHmNZiY8XIYYsdUhIin2RpVWKDC8xIJCNkZVO3ppyElNpmS+UTiigKj7suxQtJH3z0IfNcdLl5x8zuvkvTGPPWdHJY9l6y8hZC5LzXzrdMHRBRSQ1NVNCB+xx00txqk4oqg5kFKzUAteIv0mIrdXApXjF1sdVcOlYVFdZy0TXUCyMbtc4nS/V4ZYFLdhgrjWnVyFaac90VOhrruuWSS0Kp2Mfb3HzpNWSnZUtZV4n1F7AAf+4z4YqNnc2Tax95/2Qqqz+BhJRUJmI3vGDAC0lddcEkO90wuWE3Fo+6ftcgeY1OasdAAkHFylDy0BflJvveC7+QJW54VYJ3E5xwrQqcBSiGAV7S8cX5HDC1tBQNy7cUo26ZYIw7zXjWUFnWM0XKNubQVMGeievUEglDmOWWOS6cQW9slrlWXGsG/SDPFeo1nB1jWxbkoB3RQ28x2hAE2aPd4+k8NimuSqeKUH5VcbXkNpoVa6+2+nvwr912/CjdligYs9NX/2yyxQv7fYnIb2XbKi9Srnm2fiYkkEteyQjYOYgBFHzT1NJ40SqijC5xQxrcwFB0G8RNikmAg5ySXoaopgEOUq/aoAM11/+53mFqHCQT3ehO5heSpWoxLWJdAVnmKtQFbHQDtN1Oalcz3e3uZqO5yShWsyynqQZ5VKDC8jQxrClZyUXQM0uAgmKe3qQIYPOS2tRmEz4s/uF7mqjatSCxLVO8j23vuwb62qc2sLlPjPBLhSnoVz63JedoUzJWvggRk+oR4xJiECABI2RAygFpSDK8ILQi6MGxSGVhCyvk4yjISIYdDnOGM+QhJ/g5CrGwhKRLx8g6pBSTrU5E/tnQxzwEuwbNR4YmxJ0obdhKGMXDVplU3Q57tychEY9er2kDH6mgPGQVrUrOydTzMmghHVHvPAzEXvYORRvaWM0TweSD1fhwzT//YDN8nxDFtsa4RnCKsRdotEXYwljOcqqiFG4shB3uEIY+SEJKn7iftYyltzyEIhp51KMR+shE46AOFKtZFAUtycyCOrKBCEqoQRHlUIRGNHCFtGQIRaihD20KZFLURidR+MmPZahOLmwaIlGJIE0diZOy2hgsczfLnCWEV5SrCkroFSyhCaKXOIjCHNqAz5dsAllJdA4wKpRHfm4MeoXCDxU1x5xjVVOb2NQmJKwqinK2MRXmHJ83SxHOMvYCnV21RRhPYQpLDEIKOmCrDuCpRWsxR0qbsCMmarHPPHbCn1sBaEAXxqOJQpRiDV2UJKX3QMEmVrGLpeT1HEs7i8Ys/3SM4dluOtrJFKaUFpZxGSlNWalUIU52KqWhjCzj0pfaTIcruhHQWlK8nOYhD1RwAU99ScSfyla2guBtMI81JI5UT7jDnZxTJSY1RVFNuVRlLly/6EY3BmOdYNRqWaN73bFml7rQ9QMTZnACE4QXvDVgwh4eEVfbGA8PdsVIt2pBiF/yFU9IU8pPBkoIUGyQsftN7MsgCUn+BhhIHLXgY191UdZqMoMbtSxmM5tRJrnSFyrTqMVOitKShgwtrPQVi0SaWlmGWLWrpRCQXusa2AxNp2OgAk97ymIixhi3fBzDGHS7W8AiS5C3YU5wk9qq6G1PudjCGrL20Nw/WPW50P+97vgo8WQoaxWrTLZuN58rCkuYwg9noAF4TWABMFvABCiYwRHcIL4pSUIRentTXpzx3vgmM4ZP8dt9cRlRxAbYYR58bCQFPGDGjsjAjk1wZD9q341mDiGLfvAKJUzhbJw0N4K2LF8YPENYddjDqAUxJltql535LJA8S7EeeBuIANqWEIpYcy9lHAUjxPq2/qxxjW/MS9nyqEf4SZYSBULF2cyVFNL0xDWP7E6pLpm7Udaakp39bGdb+YvRNgUkpDAED2RA29vO9gdWsAIa8IGbw74ab9s8XNTgwQh4uKsfEdY0Ukv0z41boH8b2+d5A1rfgtVvJR9raIxGh9EZrqz/v2g12dQ9Okle+exCfVOYKKK4E6NaHV1IMzNO5zBjtRzNMyoXLB7tD8eBaDFP83BEVhh5iC2ubaxd/nKXz5rGAbTxyHfN4yvlZE3L4fkWJXFNM7gB2X7gphuhHO1nF0Lpk1g6tJX8iGhnmcsjmMAEHnD1B3S72y04czeJLCwfCxcX6s7DMaqn2ZUFaKAzrLeS8i0bxRY4uRSlIGv2VPd9O7Rgeo87wFerjQA13CeNFpXORnkwDs5uTxDfcALbA7rcZVzE1BFhO077kANVrF546KWcYgNfFeBATpqoZ3pXnGqYpz71M2f9zHWb42mF3Rndogj4jo3saYvC6U9fejZ7/+97Lfoha5CAulUtAeUua3sC2cY61rvNBKLr3rfumX1GdDSHdUtDJBbinGEAa+J+Lzbv/cU3rw0q7/Gn36B0L/8oCv3+gQveYxzK7FoMx3GQvs6SKEoR4ynbiUbIg0s4oZ3ojMkDsQNEsLuQi4+7L84LIDzAL7rCARWggkBQBPyBpmJRs3xpPVl7tZiLOTEQQdeDwJ+Kt2zBCGZYQRZcQaoBuiNLMlHwA+GjwRokvkH4PeDbQeCDBKK7Ku6iAW57gAlIgOZzvjE7A6izJmFSweHyhNnKA+3zFZKKHPbYMfTDO/ULNPZjoHp7O7xrP8ICNAVsEYELrRfymIFDjMALqf+AO50Vajgp4rPGOxlmAsAIhBnUSIkplIcErIdOKx1PIxXcYKAAfEDZEhZ1Ez38opKTACKQS7FOOJ4bky2fOp6XG0FNtMQIpDlPpLEIrKzYqwUWnIgX3EEbTLIky0EczEHfo4NrgkUeVEWmM77js4Qv+DIw0wBtU4CrQwAEcABh1LYPgL5HqMEtIkWjmj14kQQWI4Rl2D7ua5OgWqAsBBosvMaHWiDHCbDikbebSz/NwUYNM5K7GzC/e8OCqMIIqw80rDSFmy/987fC2ZO4CCTHqxsaqpM+9MM/TC1BrLy5GApICRZOlC2goblG9DUoAiKn+S1mQh4T7MRKpLkPLEH/HBMmckPGVMwmV2RFHYRFkRzJHaQ2qdMBFQgzrPNFBCiAAVCAYHQAbZuBM0BG77maWuiaiJAPZ4wCQTCGLRG7J5kFUdSNqHmquRsknHMqb5S3iPKtaxSWQjQk8bs0uyvDM1zHOWMZAqQweDxDVHGU0Bq0iOuErTAHnqi7AOwfzMOTG7oHuIRLHPLHi1PA0zicqcC11wsa3GKvnDMPOGQJ2eCKnesx29jCzevET5SxXtotSfge4YtFHgTJ3hvJO7hMy8RMWbRFRJACXQwvC/jFYBwA0nTJYcyAITBG4fO52vAWY1AEWFMDYgjKs8seEytM3HREH1vB7Ng+pNK59HBI/6WEyKScO6iEyNjQMXIUQ6vEtNFJx0Orv0nrSjT0mK+sJYQzmYY7LOu8ytUxxEP0BM5AJs6Iy3mQS5qhS9PCmZzxMxS7taBRSJ/5S7BMoaM6rf+5K8Pcz2WKxFL7RBozr8g8AwJVQm0KvlcUSXcqUAZ1AykIAyeggSZwgi/ATCFcvjBTyQUozdIMRmJkAjIwxi2KJ67ZyVYQhNgkBTBhh9pUCddyhnVwl4qQ0RmtUXC5URzdju2ACGkcLnNAtxrdyeq7CO4hzt86SiT1QmjRQtbAShaSzrSLv0m7P09KEim6MO5UkpNhpNEJz1jhx/I8TzFVzxgNMTLVtI1jFMC5Mf8foY3Zoon+k6n6vB38XMAfbaXvuNMcuVO82AsXjURLLANrwkwCzSaR/MgEbVAGfdAloAEfiAHxgtQT2AAHoFRtO4EKqADR5FADKAAIkMkT8K7ysr1gAoZrmAhS2KkxkAT0mYeSgCKqwIh1EIktwY4gbUEenb2IEI8VXJd1YUGH+Bp2UJcxQZdhLVa0QRsuaRfeHNKKWMZ44c+HbM59c1IFU6HpBDwp7U5WmdMMw9L9k4x7pKBDbIRioMJXAolyIRdyQU9/dNf15CHOOK41dczW9ARH4KOF/DCB81b8W8C5LFMcwp08/QvBTDmmU1CSTEXhG8kKlQIrWFRGbStITUn/MBPGBqBUYZTJTN3QlhSA0kwADy3GIlgCN9AiJkSW8zlRJFCB2pJNcXlV6HFCId1DqKIj7jlMI70a4KofdFpBcElWdNmHtHEHd8gHo01afnAHoUWbWuUOGl2maW1OayW8wsu/2KnSsrg3styzL50NwClX95OPJZoZuGTXdh1TtYXXjBnPArE79fKpJnXT0SMIsg24NVzDCQlYvn2p3zmNN4uShNXMQ+1Ihy1QiCXQiZXQFvAyL5PJT63UYawAFNBUj+XQl4SAmZRQM9jMR+iDeAKfNiAB0q2tPQCGMDkTIl0PTGA19QrUxkyeWptdWOspl6s5W8stUzOvx5QNT+AW/29RG/Yp2nOxhuIlE3cw3nNJ2n1gXqI1Vl+FWnhpyFwqlqq1WoPD1slJQ+xEuPzaTkyTHl4jwKnoUn2Mhj1N17NF27Vd21mVJXm9uLdFsVCcCmfAV5pQEd+hJUbrX12RvL4F4Mib0VRQOsKFRT9YA0NV4MOVWBBl3MZtgbYCr4vV2JgEM8ttScwV2ayTYM6Vqt4NXWQpgxcgARAgXSR4BFtoH/tZsyFqOReA4ViLYRquYRsmASM44RM24dLt4ViDgi3AAiHWgzLQgz3orWp6TG56BFFgYidm4k8Yvm6aCKyaCBWuYq+ZPRYso/DIYnaJ3jF5WnCh0YD83ycNy+wFqf8Y+lYJGSlfmCTw7VqwqIywLVdcAJ2emIZ4OFuiJReSKIf2Vc/4BZ7pualDzKd7xQMB4jjKgz9tjSwEjORc8ahJ/obeYYgCNtSFDb43GIQGjtgzYFRRhWAyQwFTNmVd3NiNvdjLdUlX/tQMGC8Jxb3PPbafEwQ1MGEJ2OUkELeywhZWczUbfrXkkUgApbnOSz0QWGZm3mEc/jYkiGYgTgJqnuZpboMyGOJs3uZs/iluVoNsxmVuxmXeUoMjdl01M68jUwRqIjbx8WKxiVlwoYycUcfAdAs1lscJu1rvncNGoigGDBoA9FI+BdN17eM/HolAlgeIkBEhy8c89IQ3g4//O4YIBaRkjM5oQOwkSZaRSv5oz4mfwdXMBc5MxEXcByUv8nJUx/UyHTDlDA3NI9RgDr1g8frg0O0D17VlF9hlBvhpIujmlsUBGnaxABoa2EvSJMVXStQDGJvhGO7hZ36BaP62F7hqrLZqrd5qIuhqr67qoaZAsYY1F4sCaT7r2Q3ia1ZrbDa33tJIKaGIETvjwMznrayw6TGdN4bjLjxHyNpDuxvoUORX0zEIeTjockloWjVPPyRYt01LuBVbRZHby4NOjb7sjvZoWbkVkLZkaoiFTCZUWOxky4TFh1VcxU3plSYvL8tQXTzlytVQzIVJYJTJWA4vtgoDoQPdWlaD/7cmagoI7uAmXWfG4Z7inyakPvxkSKgiTuOpNai+aqmW7tLFauu+buzO7qJuOaLObq+uXfAua/E26twt4reea7p2R7s2DLFMIUvyZ8pqpC9dmMium0C4YzvVSmQQBzHtY1f9WxyxOLqERNcQOfaCwr2hJUjG7I3m6I1u8Mzu7HoGXNDWZAZ9g0RV0JOOWCZY7ZWO4JgO8Uy13AcQ2Zqu7Q6+aQpFNk0AXXNmtT4gYREg3Q044Qu48ZZbr03oGOV2s+X+tPmYGuAakiN2aiDG6un2Ye227htuchvu7iUPvdodayinciuHtVpDb+zd5/X2LFPyrPtgMGbx53JMoEihE/9gAc/BNuPyiMbDNhc/TmgA7xWBHUVDNvADAoUI1N/8LmMG//M/52xBjzzPoZHOIAmJ8OQDTmAMfwNH33BQVm3W/nC2ouAQJ8aZ3mAU50Uxw20ueKs+KIR0fvEjU4MgpkAXEAEp/yUjYot4+fFMKWw5UpSDTa5iO70pp+6oVvJdT/Ia9vXpvmErH/YXYDliD28th1IKo5Y/ytZQ4Wv2O0dAU5GbALDEzC8Fb4j1jXP2nHO6jJg7H2ym1ieMG42MBnR0xxUHH/R0hxE1Cm0lpINOzsFHl3dIV1wPn3QIvnRV7vcD2OAGiNwUl+VPv0xRP+fb02k1AO9i7plRlFNYtxD/WddrPnSMm91AZHkN3vqpWrPmp45uX3dyl3XyGEb17uZuGF7yohbv0ihjf52/uwZzrgSR1LHS8CVLxUJzfKyX/YnTmxk4/kZb8siSRqbzbZgX+pWTq9CTE3oIkG53qGd3qUd3LQEH6bIqknZ0RT/cxI30Ds93fYfpXRzGft9YVzbxgI/cS3Xc3N5tF9/pdcblLciD3joigYB46KjTiQ+VJdLnJsGInMXZIp0mVgsmN3FrS7S1S+T4OeC8itTE8Q5vGcNuliN57qbAZMdeu067KS0Zuys/tzPz8Y3RaABPkfshWzIInvAdoS/6bjcNo0AgiB7AxDG7jIt63IfwqQ90/zOF2m2BBHtfA5C0d1BO7Ui3gq+nAbBXflQWswwte2E8+9r+1AhYe7Z3K3MGXYX3bYU/56FqDrzPyidN7/S2NIVhCZtdCSFDUg3EeKz5kYxHuR0XqiJt3VMTOdhl/NsCb8sHCBcCXeBw0c6cOoThzpFb6C3as4jKiiWjaNFXs4sZc3HsuFGjxVkiZ4EcdWsUSlAoRa5E2awlzJQqZ3piZy6bp5yhQDlq1AgPUJUQpRFVOK2asmVKl4m7p2+ePHFSHW5rSDWhOmKscCE7tpXnpUBAUfFiRbaa1YPw1KZr6/bt2rhw59KtW2/u3bx21a7re+2asVSUINGBU2gQYsR0zv9YafzFMeTGNWhQnmz5cgoUmk+YsOA5g4PQoiE0OGCaNOoJGT5wbkG5dZcwbuzc6aNIDW5FunVrekVMaVLgaLMNJ9qMOPHjyZdLVD50+S3nHy16nYjr+q3sX7Vnr4XdO/jt4s1e3wq+rO9XrHqv14kp5/v4exzpqT/mvpj8Rvbz50/wBVZGOfRQcxNVBNJ0B5ZEEUkfsVRSTC2xhJJ7EdKkUk0JVdiTI4H4dMkoz11VXFdoQWXPPVNZVZWKLGqnVXZgiUXIVrRwdRVbeu21I4869uhjjn3NA04wRZpCiWGJDbLGG4tF9hhjjjGB2WWWVbZZaxV8JhpooTWg2mphrnb/Qg6VxcCCDkvIpgZtguD2phqCCFKIJiUiow2JxonIHJ/P9QlRRtIFOmiBBnaHIC/EHGPnoud992ijIEH66KHkuYcJhx/mQcimc4zR6RwNBShgoQkiuqCNpnbU4KAWSjihqxcKZdNLNF2SqYch6knVOAQayJRTUI3aooqsloWKjHM0ol4ud/aa449A9jhttHKpIySRpRQ5GGKILMmkk1A++RiVlk155WtYdqYBaGKGNoEJJ2iWwgw0kDmEmk4soQOaSnCx5pt7hHEbwXDUeWdwef65MMN6NszcoqUSKqifE1scMcYZJxrppOGZZ6lOl+okYFoD/npqsyinbKyDDAYa/yvMMYe4jjPmVJisTyY59xCveAonz1MpDovjS7w8dCyyhMyBxyYY+fZstdZaSy20VO9VDjhZG3mkkt+GO65kVEohRZXoXsnZZx6MibYHKZh77pRjj71vmrGNPRveX8h22yab/Cacwn9S/PDCNxm+a8WFEi7xxYZqvDHkjx9KnceelEceWyQvxLiqKnuEKoMyw3qzTLJ6cjjpP83oknMlH4UWcPHME/SoRRVrOVHaJdt0szxDvePUVuMlLZDBSx2POFlzE4wpXHetWJRTfP3Y3PPWILcNZFtZGWb2ehCvvFa6zYTccZdvxtz6xmY3nO2D+DfgEuG5+OKa2+874bbjT/8/5483/r80MpaRElXNZPM7mcpC8rkFKrBSoosZiEyHutJpKlc5UY7rDIiMppzoWq+zHYtCEZ3clScseLiEjXpXMuMJr4XEoxrW2PGO5TWPW10DF5SmFzbuYa96ZUNXllBwvfKRT26SkQJj0EdE2dwNYE5UhN/iRyL+UZEhVuwZFjVXFPzdz1eCQ+D//GeqPSHuGQvJHNT6l0AGSmpyoXvgTkhnOgoZZUMV9JB0joJGL05DdsKqClIg4sGsmGQhMEKWCd9XDGr8Lmp1uaIj3fJCFl4rhtzghipEMZg/vOEwgPBWIaanw3MJcYhWyJ4NxEbKs92LiJFRIvloo7fzNdH/iQCjUSukGMjEHRA5hDscMCHZxWEGk4vG5KMaLYYdAA5uV0PTIOOcJqmWjZGBo5uJIzqhTQjOkY6Gs2MFI6grRmaQkb9yCvI+WJSoqOMkRiMhInOWqhUCj0d4cqGOJgkX5PFThpjM5CA4+YXCJAZcThql2CIDt8nIzWytuV4Sk2i+ibrhbrOppS0B1oYoJqw4xzyHL0Mq0i36kpgmJelHrUhF6jCzpWREqTSeCc0wttFlnavUSUonq25eCETZlCBCwOkTTuUsZCyip6+Mxk4RVfImLoFnPAnRCZKcsZHfGJ4+I0m8rEoyL/7E5CYXI5vCkJWsj4HDYqS3Q82g8oja/0ulE1y5vXvZIEqwhFtcLUqbvaJPNupb37/C0IY2KGJjHk3pAd0y0mKaNEA1OyljVbo4lyaTYsCE6bBqt8tqsrEYxmqQNJtFEu7oFCwz2SZPf9rNCWIzUx/CEO6qypepdGWE6hQkVnBRSIggDVM/QWE0kOrC4WK1LVztqvJMEcpQfgEIQBjoY5ZUVrSilXpwrcwO6trDtjoXlROFK5mQuMN8/dUMZ+BDbdLbVzP8tQmBFSxhEzU/xO5vviBdLGTzG9nLIvOLg6Ns/Riroj1udlBrDF0DfeGRFJa2wXNE7TZ/2hOasFbCH+IQhgZ4xqY61qaMiqkHL8hbpCHLQygcR/9miavVqlGyq8NL7nL7QAcaqGCsZ0CMQasrvbcCQTM85K4Rn+tK6nGPyJWhKBlms5glrxew7g3sFvKgCF3S175Vbqx+Mctf/660mQFGjv0GfLj+LfizKUxVyx50TZlIeKfaVC2cT6uroLLZtYRQreVuNGAOI2U7XMFgX8wBI+ioJ2knnDOLVazoFl9tHVmzBtcEKgUY6IB6N8Rhc687L7amsq3WZSITxStpipKXlow57x9SPZswOBnKW9hCGKJ4ZSsrlr7CvHWWZ93lxlWxpPtViEwrtijq6Ay0CebOqh5kEle12bQT7kScW0sT5wj1zq8Vindw28+mIoMWyHJFd8z/GCDdboWEOU3kIke1YmEe18XuFl49gDZDgD5CoJQRryUqYYmChqtsJ7CACk6QylZ+mmxNzCGT5VrEiiLRvKhOrx362uonR9lvtDYKmO8r2Vzf06q+huzHey3yxZL84wSeqRhF4llkr2rlyVYzheTY09M+O5s1l9VxnFpnO0Mb24atpJCWmlNw2zYhRBlZbYeuukaIO9GLrifU2/0NS/Yi0oe5Q2XuUApYZMIS+16SdTttAxRswAGraa4FHNCChlJGNm1t+HnpwFwimjKieJP7HyIqhSrExl8U34IO1HCwi9+644ZPqeHmcvhhwrTxx+yl/EI+8l4bLtjIPLbLz6x5/5bDfM1xVMmteDLzN4O+2XGkdkp4niltnuc4QAea0MLhlW9nZ2fuVA564jkWEDu994meZF6kXtwXK6/qmhyM1xOjCmj0QhVdD+iOpYQCB5RG7QO1AQRiMEvXAMHt1kX41+hevvPSJtV5n6VfKQP4V/Or4kpZPK7hr99ae/zX9t/4mPGLf8xOXv+Wd1iapdnmuVHneZ5ORZu0NQKE4VxRpF5P6MGFRaAIKcp1bFA/wZ7RkZhtHd1Twci5BUVwqdu6ZdXxlKCKTd3suAMN1ZC2/MIvqIIquKALOh8oTZcNmEBpmEalwcGk0QCr8YuQmRqUMJz4IRl0mV9tNNn66QDgnf8JrA2e/P1aFCZe/FWh40Vhxj2e5Gmc72zZFkJTGWWc5fXKiHEM550hGhJdhNxM6ClgnSWgaTEgB8qItdlZNtVC0i0KCmKg0NGedHRgeOzE6jyECI4g8AXfIeKTkFxS89kCC8ogLFhDJL6gttBgkvBgBuTgAWiAd3FPE9yB3uSVwWUP+incEt0dxDHcDypB+yWBDzih4C0FOdXf/Z1cFaZDFnoh/XWhrtmaFv5iyRVOsJFTgURH7cEKaalZMsJKrTgYNsUhnj3bM8rhpQxVBLrW6eQhNZRDJaFTOnmbK0zgiKnEjVRHTnFKJ6RbIRpikBgXIr4jo8EQ1uwDDTli85z/Agz+AjRIIixQYtd93SAAAhzQgAZAwGpswJcIHFzp1ZB1X0MW4cKhoir2HSu+okX6AKzBD+LZTwvtInHcIhb64hdmEUlC3hX+UqCJ2bOUIeYdYwEqmObRHgTdyoXBYenhWcwRR824xzXaoVAcRbiJCh/CQ5+NBO7RURnm1O5xpDzyE1+wGDxGZTz2yDxK4tbcYy/oozXsYz863/MdxiB8AQrEC7l0RgX4mKiBIqsNUVzpy0LeWxG9DfmQwcKVIkWqXyvCYisg1RQSV8d5ZC9yXC0a0OKZZDAuDDuk5FEBknBg3rI95ksaoDPaHE1Co+nFIUx8E0r0pB06guVsQ23J/9frRUVUrJzOvIzPzd5mnpA6quRUtiNUSqVsmmAidiMj2oKRnAJubiVv8mMpPB91zRiZTAEiWIJAikvchV9cdpdbvqUpTZT5rGJ7OUETXqReGsMs0iIVqlhfNhLhkaRgVtlI7hfh5QM/9MM+DIkxrCdgYKeiUCBMjoc7vYpRhqN9fttkxsfquSFPYSZSzmFP1mFNwg96WGCKkGZURMN8jtAt3GE2PIpKiEUo8B6WxaZXXctswiOKZGht9tPszBBuZmUv8KYuROJWzuDX6Ri+lYJX7pthlJVEFSEP/dhbmU8TdN+N5ihett+Z9OiZqAEkYGd2aid3AmZ37mJ4BuZHjv+kSbZFyJkDN7iDeU7pOwDGX6wnMbRCgVJKTgydMkrmTFoYAsYZ6WRjNQaogE4gaMKn6yHoN6phooyCAv7ZG5lQdKyjVVnotmEoh8bbhvbp8M2WJVlD1Ykob6rgifLjLwxGcFJXQMZgKdjQH0Bfv3FXXnXaElwGRE4JFziXmXhqmvBLC/hoj4bBJKynkA7p0wGmk+4friEpSJakko5nqzZpF0JCKgTDL0jplJonNwBDKwSrlqYHs8jnSzojBSUgNs6czH2eZtIhmm4KOcbUmhboGSGogtqn7gQCKEBohHLrMQBbhZagU5aruZLrn/5ph6IrONBj1V3DiB5qbyrqYID/4kDdgSd53T8qhkD1W41mqpr8kKZCZ9t9Ko+KqnWWaiHEAnamKpG+5iMdqT3FahrN6sblokjuHyRMwsZOgimMqDt0A5X+KrAKKymc7Hgsm5+9YejZSpy5FoZNmM19Hs3WLHJsJk1GoICiY2xJRR4qA4o5ZQCRh3bwbAl9K41Q6B4tLbqeq9MGX7oCarXEkD4wYrzuozuoYDd0A6K+YFiBomFQwj9KKhxgmltdD9qm7UINLFwC7I4eLMKSqhP+QbCKw3q65qrCqt4+ki0maWBqTmFGIcd2rB907MdCQ6+qYDCULMrWAil0KdHqjrP1nGpFmJhaowJKY0/hZOmgHuZG/2sekONvBFpESBM5pZNqWo4nEFXI6MRv4cJRMe2rtoO5uunTNm3USm1UcuOgZuUlhawuNN+u7qNVTkKjFieLfmViwKhdeVcnCuz4zKjBhioKwK0JUBqp0sAdaEKd8K6q5i1d/GVH+u3fbidjHekfTEL6Em7HfoIo2AI35AM90IOvAsYnoKwkQK546KfMUiblQltnyuxN7gTndi5O3GzOfq7OHtpnpmSCnK6edMfqjkXrdkjohiuO9O2L3S6H4S7sqevUrWtckGa7XhImjajIwkJY0oG+eh2SBGchZEIjJt/ymlXBxY3a5vBcSS/1Vq/1gk+8+Kj29gH33i1T4O27gf/v+HqnxWasFIZkOtRb+tZbvbXv4H7CbvIqPRAvsObvx9QCfGBjzP5vAF+jyxJwfx5HTqCpAlNwA5MuTFbE4ZkjKIiFZ15KHohB0oKncAXJBXIwufopioCwCL8jiiiPCWOSeVoC3MBSWR2GDFed8oYS854t22qPJ07v9gAhJ/twwF0vpYEyLBJxb8SC92ZnPM6mEstuxRLIkTqx+b5yxyGhFJvf+g5u+1KCKmTtlFoDyaLsyUqCnIgxzAYwBIoxNJZefEgIAqMpAOPKnBZdBn7OcNxEoNSCBdMIT+Yx0+mPbM2uoNouIKPrIOeunwby7t5D1gzJ8sRryDIy3XCGCKj/wHOVLSSwKIpuEiXba/OKHUP589qaTSb7sKiSSfUGsQp8siiHqmFwbCsw7FXNIjpD7CrvLRQ7sf9ZdPzRMi0HVBW3L508wsZ+rDUkLsl6wh4c834Wc6ZAIFGxNM72p4Ww8QK7Yc/mVnxiRAguRAltCgS6R6cgGh+H2WiOc9D6sR8dqD2EsO4eT1SsswnHazeogh/UgDyjRo0ZRiTDAgxmwtVVl3htF0Brarlo8vQedNwq9EK3XUMPRq4eMVNPdFOzIwtptC+upKtirPhatKqhl19zdC2DZceqr0jv5pQqbhjLyR7MhzD3hCTMR2eqNGU22xjLWa3UCk0/8wNKFdI5/3AxFNo8HQQHdoq0NjY3S3MfiytSGzXtdjAgE7JcX+hTJ7LVdsOiWkELFKRpaID2DoLXdSVAqmgPzWiVjLXA0oDbOBQQHnS8qLUoHxm+FsJgHAwq02ZxqXISBypF2zUvtvLD1uor+/Vil594/zUtbywtV/H7MkNJ54MvAwZ8oJcgCHNjt7RPs/RkR1sBO2Bma7Y2n0fsakPmuV4DQhtpXxg3/w1es/Jqs7aexjaEjzDVQnWR8OYpzJgFbMAGqMAXBKTX/aZiOMFiOORAl7UOl7iPmbUOVK+6XO88r3XbifhhcG9vyGIIu9tcv+ZcgzN3C+ZbyLKTlreQj7eMmTdg1/8bH1BxYXMDNLyDedpvfB/zY7c0fVS5nPbvAGMK6OEczppYZr8WpLgOOFKVaOMEp5C2Si8NJujhd6PRbK6ja8d1hAOqhyLyCZMoI2e4CqxBi8qwJZBVPRsZWpr4+Bj3cSt3Wl8vwIFyEEO3GoTtGnBvKsD1nOd4pW93j4PcFBLeXvPVXhH5pw+5qIt6vcHvJc3Q8tRbTiT5Zg8zzIbCzN7xNC6zTPLEznJmAjtCBYoYtw0dmx+dT7fBSzvC0jRCNmqZ+RZXnD/4sjf4OBuyoylPb0YiNHTlG7AGHcCgt1jCKXDdGiiGb0Of9xC6iZu4QCt3a6yLc9eNXinJJJACpV//urzPeZG2uZFm+l5rA6iHuniHOr+PenknmSSU+ojO0Dv0AjA8wqrXhx5A9qvHrIVN7nvg563jOjZqxU7o2TSjQoPoiQkJu7ATVbGzAhkluyOlWIMze8pLOMsvojUgqqIyH1cjQg1ku7YjQiV0NSKswVk1ybdg8qbVQKEPfaGj+NmkC2WseEGrAMAteqP7oBFNKmKINLxvo/fOu6Vjd0XzeEjK3163xb7/u0Tizaj/O6k/AjDQNjMoPKbwgWO7vZQL8xpXdhtOPAFXvMVj2CHdtOwpGMdHjIKKPMgLQh4bQehq5El+p/nCuVCivMo3u2zP9u+eqIj2Yz8aAh0AQlfr/5u3hIu8aA9BIcIZWEb4lHu5pLiKA1G6Nz3TP/3CMUEnuftDXz3WZ72l1zuDS+yOhD0fJBnZ9zvvB/++j7dioxfa94LBvzfbu73bh3FPOLxvRTz/KnDeb/aEgvF/bnyNKAomeEjIf78YGH5sXaGXdfcwMT4SO/7K7ymqh6xV5iOkiv4bIAIgGIJXntop0cB4WUEWAMQbKzUIFjSYggaNFAgZLkzY8CEQFAkpKowxUYcJCxZUZPDI8cTEGlJIWpFyxk/KQitbGSv38hu8dDJpzqxX8yZOmjl56uz5E6hNnTaJFjXa7hxSpUuZzkyqzSnUcUenSo161U1WO1q5dt36df9PWDNhxXrlyocMmT16wupxy3aPpE/Aer17584dN2aiHnnyxIePo8CSMDkyfBjxpcKLCTVupPhxZMmIHWMiVitU5lC4pElTF67zLVeoWPG67ChP6jar2xCaI0aMI0+daXurdvtZ7ma7effOBrq2OeFNh382fhw5cabJmTOXJw+cXXfdqP9SdR07IDomp9AZhAiQJT9rBr0hX/7NdpNSsghkQvJgQZEKKyKcUV/k/IotUJww8b8jFQAMKaGS1ntDJZaWiQUmn4Jy8MEIJRyKKgqdulC5DDG0CioOOUznw5nKKiuttMw6cUS1UlQRrRTdIosPTx6pC5q8oGGGG78k6Uv/sMQW+/EwxyYbkshGGqsFGb8w2YwYz5CKhhdWRhmFM09UYy0PQVyjog1QZquNNt18SyabMZ0cDs001TyOHA3dnFCdeORcJzprpqOOulWuq6QSQAaZQiQbrOjOPPMGPYOONQpFpFDzDIxPPoUcmgEi+vbDD6P/OBLwv/wMPOOkRuFYCRKXjBMKzlRVtRDCmCrM6aifTq1wphCrotUpFHU90US0EOW1RLj2UEsNGMl6BFlurIGGWWi4QbYvwvaQbbDEjBTS2iIpIwRJKQtjMhrgoMzsFcyufA1LLj3hLMzeinHXzDLltc3JM9e8983lWG1nzn7L2cedfKiTBU9Y+OTT/xBA1qCPIfbam2KgkEoyj9FCp7ABY0gZ3phjhjDlr7+Q/RvwP4o+JcnQRFfSpJUGUV0V5pj3fbknXPO96tacbU6nq15N/HnYrHz2qkUShSZDj5+RXporFo+dcVloqLOGm16Q/Qs1NbRUhGstsc0WbNSOBAYzyKhkd5tpotyMFEHQ3WKMOVaDbYwlv4QSF1/0zoXvd5vpm0zfxFUTNHwLP7zNxDPctzk6wQmYnsi7EWYYWXRZxJBFEJZjoIwJGrTQHWoIuUBELRZd446HqNQ+iS7d76KRB/R0Yu7SowP3Qlg2lWaZfW+V8Z1qttm5mXc+Ctivkjdj6LF6Tivpn6Mvg//6YFV0fkRIUull2XzyyasXW/pSQ+uuse0ayK8hu1a20xIrbZt1xLmMFVIkmVtuuKOAIgox8vBLSgGcBS0IOMC+FTAXgmuGcH5jOAe6yXDFM4497PGN6DwucuhABzbQQQ9hJEJzIcTcGiBmg4bZTj0lKUgJUacx0qEgBQRSnX5eV5GRjUwHJjOQexKFu1H1YRKTaJmrgAKnCv4OiTLr3RJxpjMnUmV5R2PeFKkYtCoqDYvTyyIWr+i8PyDrFL0ImPe+FwxT2E8SgtAa+QSBvrCtzzBHcp+QSOOZbWCmfm7z3xyQ0D8/1g2ASpoSaUZjQMAFjjcNZKC9Hli4mz0SORT/BEcs7AEOWdBDgxrEhgcvJ0LNKUwgLSzIDkAHMUMJCnWri5RFINLK1dGwhvrByERkmIJHdad2d4DDqHQ3CZcVMYn1OGIwaUbE4RkzeMc8Hq1WdD3lPY+LVIym9LZYzSqSZSyAeYQoaETGfOjFGJPog/ncyD5tNWY25qIj2lghl/u9rY84+KNsBOmlTtizkAn0mwIXychG/hOSxYnHJKNjD4AJA5Mb3CDlPujJPvnpClmQQnxIeaiHWYGUkXII62hwQ4LkZ4axxA/IaIDKQ22nBrjc5S41sQlNUOMlz+nJMImZE5oSE5lLRGITjyeToxltmkEVqtKKUKLqHRWpSSUW/4xY1Jft2SkfkStjKlo6TnJurZxe+x/ZCoMtdtFPE26Dm/7kKc+4ZUlJSwLFPQl5yHj1U5GIA6hcn5IvcTAnFgyKji6mIwxNDmODHgShJxMGCFBilJSoQ2wpK/pKSLWgBveB4WRfCEsbRISyFLEPSCnCnUOR0Aa4+8Iufag7YxxRprJKbQUpWMSbzhS2q3pVTSVUq2X61IpTzO1QyWdU3laPCFVQajWr10Vj3YEPQTTFLyBHD+/pIhitCKId3FhdrUpijpXpVv1YgZqx6iAKOHDBC17gR7TSc5BUIuBb5xVX9xIOvtN44nwF2rhrEFQXuuiGBzEJ2L8KQxaMYIQsAv+MucwVNg5ZwKVnP8tC1HF0IRvd6EMmaylItU5StLSwSXv4Jxu0Zwek5aUmKFEOmr5WmKulYGtjm1raEk+nwJNxMn3SKzWqcS27/e1wh4qFLlBPuEf98ZB9e83jAkabn4iFNbwn1akG0bpa3SouxGYYSZQmSpiwnxrEEE95qkAEJHgBD/onN/RO6Rbv0lsiO1TXczQwOPGlF111Zis3h+Ou9n1JfgOGUMr9dxiBphyBC4w5hCWMhApW9KIVPKghYFSVCPmohCkdYQlf2CAmLNCGBTXaQpEHULgkVGknsQxwNEjF91jxqlfdYhdHCMUvFp6s4bRUHCtNitIMw66LPMX/4Ra1qEkN8rCJzOPmOQ1Gf9BeKZgbVam6IxZURZ+U/1c2tPqlFqRoZzsJEU8dkBnMJBCzWcfwP2zXIm/xeu+65dxuatAX3nmWn7zr1NwO9lfQDGUooWWxCDSEENFTYLTFGi26jFqawvGx9KUh5TlNO3zDFlXULhNsg0SP2ju6e0VMU81qj+Oj1avtF62PSXJismVoSYteVrToa12/vMfCJfbMi91roB25DzlHLqnyOp1ng6MViugtIcqwGkVY225pzeMYwssDp4tX3OPmX2vWhST26qa9cHZvnN0955zZOWd5xnNM643QhGYy32kn8C4KnIZFyCISAX/YG9ojqsQ6/xrhrsT0QiDucFsC4bIOzxh7CKUow3s4ohjPeBDF8VpVPx7k+oj8xx8/8t/FesaqNTnmc6JGplGv5caWgrF/XaIj+Bj1Mi/26knfayTn/A+w/+JKUhELd0SOHu5IhRpaw/swzMGl3UVvldPYhqbjgAfkFQEIpA43QpCrSVd/Cti9znU6yzfe9GXOBffRD9xnUoP+SDsnOKHv8sNdcwNehSESXHf3E3yxooPhpBHeQlQ6/O6KFfz+ObxSwyvqBnYg8Xood75oiDhOpiBP8haQASdvHirv1ZAo1nKKJ26K84IpAmXq1oIG5YDG5Zjnx2Au5nwr9WiuBFlvmlYOyZCLBf9bUNl6Iao6KBj6oAy0hPdYJqweQ4/MDDVg48vIiwRAgAIooLygoDUU4dz2Kd32KeuacK6UwzayT67k7SUKyqCc7ezQLu0CrfyE4fzQLxJkQRjWTw4Sj9ESL7ESqwTyLsLS0A3dkIU6h//wr6L+zw5JyArwkAATpGWeg8USUNUaUBAbEAJnygJdTUIuMMUUUfNUxQ9vArXqQRLWolg8j3m0yC2KDAU3kQTJINhOcMiagPVMsPV6BSxakAUh4RcwKR+sho2qLQe3hEsa4zWOT9xAQAglQALGywjdQjPSCxgHSTTWS/qccK7ebb6wDxnFziXAAR8Axt4yyR/8YaG6kAv/d6H8OGHtEsHtdEEM+439skD+biCiGO0GfiAA13DhUmAH0BHEzvEcFSweSygA1VD/7i//Cu8O12AAFS8ldkfVOI7yBLEf+kEfCpIBK48CLQ8RMRCZEDESM9CmMpDF/iLHlCb0bK64hO09SA8UuUAUQfIjQ7EMTi8tfIy3zuIUZ8TZ3EETfI9lFME16KY18sAHgTAIc1EXxy0KjA6fgvEnDQmB4IUolTA35kwbwgVMpGIZ5UoZlwEqodKC9qogv08Lh4H8spL81O780sDtGAHAGCESNOcJdoADUEAAy9H9rsAL5BEe3XHRfkDBZOAK6BIu27Ee31ANB8+U2uMOv+P//zCuUXRHrx6wEAFxEBPzMBmSMScyIh8RElfsG/5QIlkLEhtxIhORMm/CfnLMEpdmI5WKCYxN9YzKJDlyJEnxE2cuJY2rD0zh9ujhF+5HEK5MFl/DLXyQCsaLN3tzDJwPCbGs6oohzYizKI8TOQcIKJUzn9xKKcFEGdOGGqJyGaYSL/CCv8BP/LRSK9WOchjB39IvEfjN37ygAyqgBLzgCehSC9rzCd5TPdWTPSOKLumyHNlSLfEysfJSL++uL/cREeKAHy/u/f5gVFqmkgxTQZ/DxFhN8grSIA9yHwgRAStU5PoFAjfTMmMCtY6IAh8zM0MUREV0EeuhMzNxtzLSI/9L0xM1MTVV8yNXE8iCrDWvCRLGKBiuLKz8CDdnshZhozHQJ5BqARjIJvrkhZ+yTt2OkxamxEjwIBCiVEol454Uo63SDN3ypluQgUupkxooCRr7Kgu5kBPqwEzrICt34TsHDP280isXIREEjMDEcj3XsANKwB1lQE/11AtkIAji8wnwE1Dnsxz5cz8dDA7Xch8FdEAl7nZ6CUEVcEFZa9Uk1CAvtfso1ELjpDH9sLU6lEMpNeQ2dE5G9EI1lEQhL8VSDI0uUkVLkRNb1DRPUvVqNSRflFZztRM18gO3Qg0mgRu+h6rSqMye71u2raVKoxUu4zKMtEjTpkufsxhxwwn/lVRMXKETImNK8WAOoLRbezQQIgNIWqpchLNJGOQdrIGvJmcLtZIRzJQRtnIr59Tf3BQM3jQR4pTA2CANtEAG7PROA/YcZQAd+XRP4dNg91QuDRViGBYv+5ItATRAAbA7VMqH4EATJuHjFjAgG3TFFhAhQTZTE5JBO7XjKK9EP24yOZQhQy4yH9MyN9RlPa5V2+gzeTVWc5YEX5RnbZUUc7UjUZDXxsIY9GISpEVHywUYoJM6mZU2jhRK2sVapzZqk1LrpFUpy+SAlLNKL4EWvxVs6aZHxTX4NCGvwEFddYGhrDEr0fRM60DAyC/ACKxe7fVe04AN2CBfBYwbhYBg/xf2HEPgB/bUT9/TPddzPf1UcSOKYc8x/vRT4BQtDhRGQCHKsBgVDkTtpEgrYwtqEDPUQSMUUyeUdDm2EDnVQiV1IFcXVeGBIiNzEUUVED1VARdRR9Kot3K39FCTE2HUZ28VeINXeHs2NEdvaHltD0rtE0ihJZ5VOp9SKqNSGaQX66jVaqsXe6v2ereXe6nWatVsb/ZmNKrsXMK2W2uzJfIqvywHwIRhwAQsXt/1bcHScgIsEsaybu/2XuvATfm1f/30XsHgYPu1X90TDNqTcBP2BtYQcuXycR03ciN2ECpXDibXsCgXDkLrDzzLdGYvGLihdEl3Zjc2hBVzQTdVfv881YRDV1NReHZPlnVZF2lxd412VWdteBN7dnh3mHhDcTSdIFYfgXmRhGyYFhmtt3uzd3qzF4mT2ImbGIqtlX6yNIBCgTCwyqUmgRLyKhZ+QRfAYW/jFH4FDG7fFm7F8n7vF3PQwF4Plhtl4IAHGI7713/tFoHnWIATlmBLgJT4eNHgEIIjloLXoIID1LC+gw40mIN/5YtEAYQnVDoUdDM5jiAV03T9BXU9dvIIUZJYuIXjQTIdM4ZH2eMOoy08j8duWFdH0YdbmYdfGZZdWZaHrA2qZ0eEqEme9/qeGCqj2Ht/mZfpJZjBxBmKOfqYVUt3h4tjAbpUIYz3Vn7NGF7/0ziNNcduD7YOEsFM4Zhwg8BP7bWA0cCA/dVfE1hhAVcuzfEtI1iQMff/5MBPdkmRS+JXcqdUpKOEHfBUN5mTTZjjELBSV9gZGTBCKZRlQRmGaZeUP86UtaaWUxmHddZ3Y5mie3iWWY/qdFS+ntJDkDKYlfijfVmkR7r6mNaYjQEqjYFB8qoSdCERYiFfY1qazTgS9Db9xhKc81hP9ZZv8dacu7lwETcIhKBf9VQIyplw4TKdC/Vh47GdJ7ZyFeU74pmD3+OkYG8SbOE68xllBbKfPZljN3WgNxlTOXasQZYfQpZjRblUTzZ2FxofsIr3HrroeFfIJHqidbii9/qi/5Gqja4slzm6Kp74et+NsEk6pBMb6wZHaqMVpVV6mbk4pidbm2c6m/FXhOz4gP0Wjs9YLPnVf+P4YL15T4+6nIV6ce2SPgXZLZ36qQc5qie3PDptPayakWnvLiBZhPX5dMmOtyc1ECXv1ErWqycPIdUa5M66AQt6AT02oe/hreGagoQESyA6h/saaC+ar7dbu4E4eP1ay7o0GQe7e8m7lxUbsT0avakVrpr2sVn6EOL7EGLhECYbtPMWv98Ws3E6nAM4jgUYDGJ6jLlxf/HWK8e5vzm7cNnSPtVTUJmanduZggv5giuGtlXoJBi5c3N7t7uauP3QCg0TJqSSTvgZuv+LO/JGF0IVc8WZG+T2WXal28QdgwtY46jourtzXMf1mrvz2rtttZbh5q/LRbC517zVe72Z+MiBGaQXW5ipN6WNIRUWhKUpgRLkmxutGW/z+2311l6teZw327T9Ow0E/LP5tW5z2r8RGD799Qfgk7Xd8gxhu8LrHLS+AM/hg553Trk4fEJ/ezFT9zlO7XlJ/AFJ1rcrFUKRWx9C3FJFl5MVOsZlfJNp3MZXw653nMc1vcc7HSWrx2ZZpsg7Wr2XPMkRW8kPO4qnoWlXOhaW4RAGQb7l24771X/zO5wP/AnkgJsV15zjmIDztY7xdizz1sAL+D2DGmEB9T0LdaklvIL/YRu287y2P4XPC2HJ/lySgbu3Oa6gOM5L46dBNVWhH33RE9OSv1rSKb0BG2Ou5YZ8cDzTLXpGf3fTPX27/fr5XiF6j9jU2+yJUP3UBT6xkeFZbYGLrZxU4PkQ5ECc0cDhD7xfj1oIjJ2cdb1Pf73NyVx/39RNNYcN/M1/k51wAXWo2zMOtCAuFcwLGHXCFYb9pJ2Hqj3DUWIQgqjUomMfHB10Q+6fUfiupNcl1F3Ruy+tF/3c0/1z2d3EZ1w1nO+h5f3efZzT8d3qaxz00Lc6/b2wyRtE/p17z7vJB17Vm9ixDz4VlhUSCoGX4KDly5DZjZrij3ri9RTZM14GQqDk/+ETnN80zfveXgO1m9s8PsV55bOgLSnYEMSZcmV+PDwLw68a54FB5ztcdU/45zN/xKGSyJUbuNEa6Y+e0cn98ku/6U9fEPPnbXyvrkWy6qeeuxPi6vca09uoNPr9yKXw38W+68ue4Ie5S4s07VNh7dne/3bpwQef4v2UDRSc5PM+BKJf7+ky+ucYzeuWwHOajR+ezdVTC7w/zL9fLbOA8dFg8Ss45hs/th9/PUTH2r9o7UulMOfBClN4TpiRCgV9QafTaQGi3Dx9AwsStIcvYcJ+DBs63AfxoMSD5SrKu1gwo0KEHDd6/DgRX5s5I7e0UTOyjEmVXJp0eYkFpsuYNP9nVpGJM6dOmzx7uqThM2hLoTeJ1tyiRo0gRZqITXs6zltUalPTRdV2LivWqlS/Vfu6FaxYZVjJPhuLtmxasVKlnmULVZozYnSB2b1LidKkSX/60PkCGM4VGVNuGL5BWEYIGTKCBGEsJI1iGV4GJ1a8OMRizE/AoEkDOrRoNFpKmz7thbBpNHJOozFEOsuVKz9kx3kTJw4g3bl7+8Y96I1wK8RtSGFyXArxM38KQXq+LJYxY9eqV9yGHfsyuq+6v9ouLrxAjBozXkfW3anAkB8hOuQHv5+7iPtAzltX8Wm8e/w79v/vn33sJWRSgSPhcVKBQ+3EYINFGQVhhBI6eFT/hSYtRYp64WyoVlhccfjhWh2OSGKJbokI14ZzrXiXXaKkAuMnj8zYF2CA7YBjjjreoNlmiwkhBGaYhVCbYYn9cBiPlXnx2WiuPVlaZ1rARiVphlSZRW1Z+MalHF7mhshvg4w5XHHJJXcGc488N8krbWbYCi+1cOddd6zcWacz2JXH533a0YXnNgYJ6N57DA1o3nn6BShgowIWSNIcYUyKVBtbIKHggxRqyqkTE34KaoWhqqSUJBlqV5WH5mgVYlspirWMNrGa6KqIqb7K4TYt7vpijHw195eNQAxbQg3GpoBsCSVoNqSPmiWJJLTSGumFl5559oRjp2mrBWWmXQlu/7iGLGKIbLbZFgdrYIIZZm/BBVcmccidqVyafACryFL65qsIJv5ioknAm+CJp3rs3JfROwovjPCfeYrTJ0GFGnooogkpGut4FjtqMUkKWlpgFD5gmoQSlHZak6ejrgwUyyunrBRTraB6laqt3owirbXuzDOucmnHjDO2ANNrr3vReC9gYRhnHLLHOp0Csz0yixmSJeyg7NWHKYt1B15XgMLVs0VZGrfZPoEkZUy+9tqVi5BLLmmVzXZFl1/e3S6YawQ3hZnz0qu0GyjhQDjhVBw+hxiREuKvqQQTDIygB09eEMMNb/f4NBprNLGhGzf8p1n7dfQ5xwThQMUWYqiuIP8ShLvOg8kwHbepyrbfjnKoLuc+YRlL9cGKhjzjTLzPOg+PfK0ryhV0i588/yLSNbqRHFBAoYD9Cdo77fXUmWnmddbJis99Cl9XUEEJ3qJ29tndujZu/G7HPfeW6LLLJSCD+EZmsH4DboZJTapwhXOBAQ+IOMYB7E4ZEpgnPDGnyO2JcpNTGDjYUQ70vGJgqMDFMiDGJ/qIkD6Owk94tsMLspDjIqUzHUGioLjViUEHIovC63iAQ9nVjne466HudsdDUeXEd6bSU1xsVjzj1Sx5TGSiEVXUvOb1ikbSs0MAw2A9GmRPe1x0Gge65z3wha8D5UPWCZDFAbChzwMWQMH/Da5Amm25D35vi4Qd7yg/1pjLbnfr0hr+2L800etvybmiEgykukjFUHF5aCQhHumIf10ikpR8YJyENrlMZlJXgNJEBz34wYSNkIQtNOFT5KRCdQDIhQKy4eoudcNMlSEpOKHdgoD4Q9npsglbwGUQsXASPexBEsIrHjmWeLwmKtOJUATaXZjxCFFQsTl8sKIhrdcCLmrvA9ycwRnD1gEehTEEYywj1JC1Rjam7wbuawyU4njHVawiEvKMRLj0eK4/8lEOY/LS/gIpyEFKIYC2HFkThikJSSr0X5A8kCMfqYcDNYIpljQifjRpQkCF4l/dmc46RKmwiImUP/g5pTKO/5FKRokUUQWiZR6S8rs+7EFwVciBTX+5Qx/6EkK9FCKoZum7Yf7smKsy5jK/YtSjxuWJf3LeNJFmTTIURQcoMIFVuciCEVi1m2BL1g+uJsZimTMF3xwCWdPIzQxk4ARvfGccSXNHespzrvIkV7mEg5u86tOPdxPM3gTjPwBKFTlu0IEKXoAEU+0lYI97oGMlCdFHtiEPinwoBOdUl+xM7jzdkSScrHNBhI20Txf1iklTCJ5VSkS1A+JCqRQhU9jOlKZH6AEMRCACE+hApzvNpW93CVyigEwPgiiiKVlV1KQqdbnIs6h2evFMZkjTD4+gbjWvyARP6SAG3L2qdz+wgv8VdDFZYxwj1pxm1iGcwKwpSG9a2eiBM/4Afk0KzR05IU9OMIKuq6iEIW4jnNsIeK977aM/+QmHBAuLdoJVwgg0wIM+tIIUDbRTYx94p8c+kKGURZwYGknJgtFFs+dhhUIp7FFNziO0Hhntfo6JjJP6ohg0psboVolj1rpWDbO1JhZK1oMHY2ADRKaACJYwWN4qecm/lVBwDzkqoBa3mMplrpWbCzRn3oWKfvDDdaVahDBv97tb3aZ4vZk9LY4vfOg91rGGAGc4t5erbEzBfEuzCDbkORJs0HM8ZYFfWeyCv6v4rxXMlQW9ErjAX9JnghUsUIEadgMv2MOEL43KTM//qRYXzvDjIinZxC2uEZO804g9ih0T+4vURVTPBDFqkViX56IX8cqMP5mMr2Bk17xmLUEutd1g4/AFxMbtkCnQgAZIoAFHZrJOw5xTnDp52keoULVhJmVLUzm5y+wKEkFUZSybg0V6iqInpilIMGOzu2TO5pmziT01i0+sbjZWnO8t5zDDeZsf2EEWtJAGPsc1rpzgxC4OPmi6kus2iBbObKagz8osWg5wCBO8Ags4Qi4hBhowsqXjdElNixwXnN5wIyAZPDqZ3BGEONDiFNHBQHFS1fpyXCskmJ2ci2fnvea1rTfIwRl3RZU973VHbgsDq+LA2Ew/drIZYAADNAAG/85egtWbfPWsY/3JQoR27qRsXHCHe+xX1g+Jy82Mc0cTqjSFs01ZkFUT4Pa77vYmmq+3ZmPZQO87yK7fof13fas3rRyYbxrexoZIHLzgBRc0wmVBV3ve1eH2ozzEJ67PMZHJRkoTbABpIAIi4+Dj3KHTyFOIelVTdtQb3fScMszylosaD5AE2OtpXnsRR8eZu0c1rSlX65/nIugpDX6tjc4RIs99q0J2+tOhDnUI7Dba0q76D6cPZd+yhCa+K+7MxM7tsoM//MzVebnRbgsaeTnd2X073K2q1aS/f/7ZzOLe7893wf/9DGiqnv7Tqj4AZ0eMMAwFiHAHmHB09V8Nl/9oDfdHfoV5mgcHCxZp1VNklfY8pkdjG3gLqTdyG4Ugh2MERkASkXRZGrgJJzcHgcCCkwVilBRqLrhAIUcXMQYesfIU2UF06sCDPYhCwzcwqPUNPLeDPtcfDNAAE6BWS9h8ExABEAB9Ugd9EjAD1bd11NdbPoVtw9Q86vBE5JdURGVMOIh6uWaGN2h25qcrQwMjVZRk7jd/dNddwWZ/QHF/NMA0/ud3ZGAv/CdV6hZm2gM27HR4keB4BoiACThXC8iADQiBCUY3e4UI+rN5kvZ3fpcBTycCagAnKOWJHAiKn2h6qnZyD8VqJFd6o5hQgiB7i7N6iwRioVAwdUKLNhj/DUtFVCdUDXKCCkGXMbEWDz0IjKMjhRBgjEqIjMcIhVE4hSNwbVioddYHjdGYfdSmhTRBXA/kXD4IhjeTi+0Ajt/IFRpkYU2RHmSYMc6Ucy7yPGwHiHbnXdozh3S4W1mkMkAgQPmoj3/oh/znj3zYftyEPoWnBXlGgIh4gNiADQp4JQxneY54BZAIgdXiG5R4BV+gRRkZb29WAyeQidC3iTQYiiNpi6LIi7egYSl5gpglF+S4irEnamLgYTK4QJ42iyKHDHGxc9MgY8Q3dEQ4jPIQdQWQAEiYbE6ojM83hQwgARvQA1ZIjVE5jVJ5hdd4bcJETFkWHt0ojh/Slcqj/0EBQ1ECw1gjtnvrGAzTgRekMCOe8GV/B4d1N4/1WI/46ASFFAZfIEB4OVCC04d/+Y8BOZAlkAVpwAaHiJC7oJD8xYh79JAhIJEUyWiUCAdhEI/apE1q9XwkUAY3V5ImuYEn9Zmj+YEqSWqY8Ek56VFxQnMwORIiyEiV9C8cRDCoaIM/GR496YvpyHND6JvqMJRDWZTDmWzEuZRNyQLV9odUOZXNeYXPqCnXJp3AlI3SgEHYkStc+ZXbSRWnNGEBUwj5QpamYo6npnPXoJYuAgkzMltvqARxWX9UxV11mI99aZ/U45dWBJj5KUj2QgbHEWZodDVeEAkHmZgHhw2QV/9oDUl5DolXX/BolFE31bIb/jSJiEAHNsCEl+mRH9mMnFiDotkMIkqiokiarnd6KDkK/tIGsKlAEXRqKreKrzmTtHeatKl7qdSbp9SLlxCEOtmduBmcQyqcxnmUufWU3AdUUCmNzsmc1ch1v6QHROQJzHCdPRh+3KmlNYM5RxNbgnAHdwBbjHVzqGYdWiYje/Fly9kE9NgCbkqXdrmX+Mmf+rmfduCfdMqHf6kcXXM1MrAIBoqIC6mIhdYbjuiQWRKJk+klgOCoiDAI/NdxDuCEGsCEk6qUDLABnQkMNjiinwqqoVqipBljoElysPdIMRmbMzgnnGR6LKo4CXSjsnj/k6iVhtchDuiBCpPko7bqbWj4DUQ6pMQphUMWfyWzpNv3pE66rM8JpUThddlYpVeKpV7pjVrapZIgU7RES7Jlc2pZHdKRlmnZhr/Snu4JhyhAjzyxl4BRp25gp3gqr1+mp/z4j8QRLcoSAoY4qAm5kPLEoPnEcIgGoY6GN41KiX2DqUlpjA1AlEO6qSwpqm9Bsc9goqMqqqV3qh3oaaDgsZFFey+YUDdZg50Vg5B0o7TwOGWoQkdEigskdGh4g8EZAAEwpMd5ARigVZgySzGlrMwKtM7KddM5BkGVleygJ9rZleHItPDgtFOxHd+ZUH3wOwPFLxIGI04xHeMarmyY/6axda4wsW7zaY9yOinuGqbzmrZrW01tG6/8KFXwSi858qdskIiJyJAVKWANeHmL2kcXmrA1oJkN67AH8LBEqqlYcCq3WLGNa7EYC7mm+okbm3obtVALlaPEAHsIMnuQ5LG9mGEqG7NLhR4KRQsye5vCKpxG+YQ6G17I2n3DxJY/a5XN2qRMOrTPqrvZB2ZFi5XWobTW2rStQhcBE1tKwWPJK1PRNGEexbXjOjReKlNRlaxja4/1ibZsq73bq7Y0BbcMll1Z0wEh8ARsYHDoUIAKmZAAC7DiciUM+Gj79KiQagU0oJkIYLgHgL+He7MUsAUZwriOG7kCfLGlasCSq/9pKqdql7uSdMKilYWys0l8vopCPVpqIYqGqsu6rYukK4CsxIVQlyUJKXFLtxu0tru7KazCPasHEBQ0OsiD1zq8T/u03XlSFGa8YCo4igCvbWsqNwe9wYCewQBdtjBdfTG91Iufk1K2njKn2fsXaTs93Ou2VjRTAhRAfth+NSC+5LsIiJmI/ypPp2AIp1Bokjd5AntgcnAICPuoXma/Dbu//EvHTPm/IXoWZ0jAEwsWoxnApFrAn1m5HUurp/fAnMuCLHiapYZrLXtKKXiKtmqDw/p0HIxbMABkk1VzLAkMpCAIwwWtXnfCKFy7KrzCZADC04pB0hC8S0vDXConbAn/tnYwU7X8CH0wI2UaxLbQC0V8xElcy3LLrfl4lwSVxdtLB9Q0xVRsp3B7zAAqZ+bjNVfArwWIvnjLX6dAT2QcsIgqiW48v3CMAZSav+U8ADcrhXfcknv8uAKcM38Mz9HgiQccuR7IsbV5qii6q6nauYrMq4zsyLywahdchsvQuklpqQ92WDg0Bi64B2MJo53qyVwAMlVJykJrytNJE0TAwhC0yhuypTMcFa8sK90xCaaircG8B7h8NJMAPbwMvb1sxL8MzGL6ttx6n1AcpsqczEjMzN1br0scZk/zRVdwmAeKcGJMV6dgxguaG3gVYFzSxuCMoWcQxw5QnOZcx3Yc/zzrzMdf/c7xzM4ITHKzYNaugNZ4wrGUi8+Aonqq2s8K1Mi4B9ByolUioFZNp3Q8K2UmmHJD1cmYUNFZeLsZbdiHjW09G3ZfKLyufCuxvFg1vbwzshcxkgpDg9m9cApGzCaF8Aea8NNrC9Ta2xc8fS+SLcVVrKdvq29odEYywK/XrJDYgKCFOsZjHLB4xS6OysZtfAiHQAlvfBwZQM5zrNX8679t4tUlws5iPdYFDIqhC7r+YsG4Zs/SrdYlOzAqWFmd66OgS4q1F4Tv6QMnIH8LvV1QgCkO7deg1JJQJAm0e9HUuIejjNg1pdG7OwbKWVxdDdIhvaWlukGgrdIrff8vlE1hlw3TC86Gne3TqB3a2ptgph3hwtzDKo2nKqORZ+QFuiAMwyDbCEloq2DGTM3NhtBltwEulWAJvv3bL04JmTCJb2AFKUDcDUvHdexxZunOPe7jzi3PE/uplWvB/9wJR37kHWiSKgu6Rd4JEIRC3zlJiRzX351hkOy5qEBL5L1dONA6wbQUNcnjOtkKI7yk8y3KaY67GH3KMQHmtQDDjg3gu3hSxjvLKy0JCE4KMGLEprDLpiAKDu7ZEL62skXFg+4Xyzzai37M9doSGZlNNgAIsqC+6TuohFbiY8zNfjCJV9LiLJ4JLx7qgDDqjkrjNl7cRZnjq4uBnQrkYf3/3PU8kmdt5D6K5B6r5JN7a03uL4EQQ4xzJ3ehURZM5SG7yJjwSIl8CUl8MkhB0Zoc5o41JwH839nRCoIg34UdjfV9iblLlfd93w2t2EM15+NA0mIoYwJz5yyN4Hy+4H4O6IG+nuhGxYRO2ole0+/K6Biup4+uZlawCIpZ6ZWumCNO4iXO1O5r4qA+6qI+6m+wdzeuv6t+s5y5uLEO60Eu6yTJ5LVu5GhNY3gMik3eo3Mwgi6AOm3gfalYwUheisbOz7SHB1PLLzC1LxHsWCMqF2InHtdACihh32oOeNeL5jWR36QcZpXS33EO4F8pmr5g5wVORS7dK5mN2YAOCdTl/9m3PL3T++D2DswTiO8q3egXbuFnb+FKg3c0sAaroL4Er5gHtwqF2tQHT8YmjveqUAkMP+qhDtyAAPGobozGTfF2fPHM/eMYP7EzNvK76vG2btahaaq5AIQknwdRAAKZDwIkQAVz0N+0yPiV/8/Jjsg5TPP8gvqMjEo7n6U5NwlbbtHbTuPdXvRad/RPqtHivvQ7J9JV0funpe7aS0WkAB1Xv9le29lVlMxj3/URrr3Yrpdpn71mb+E9JtTWI+luP9vpu/1yT1ewAP7hD/57z+J6b/587/B//xcoIPGEv+qa2pmv3s4ZP/+yvtYcOwse6/K3PgoA4SpXM4IFDRrMhf9qlkCFCh2JweHiRZQ5eRSxwojpEiiFvpS94hVSZEaNhAIR0pQypcZNLVluxNSyWDRpNc3dvLkt57Zy13w+whK0ydAqRYkeVZJ0yVKmTZ0aZYKoGyIrTKxefapU61auR7J2/So0aBmyjjw546mTXDu2a8d9a+v2rdy51T5ilCSpj949e/NKmhT4UypbhQv3OmVLlChIjwo9dvxHch/KlS1f7lNIEWbKcO7cUfNFzegwpUmPdpNa9WrWrKU4oRF7iipZ2Gzb3pVbt25Z0Fb9XgVLlfBKwo3DEl6qkipVmZwfev4cEZ0dKR5MQJAg+4EBBbx//86AgggupGg+Q5/e7nr/9e3dv/9Y7Nb8Y/Xlj7rliT7+UZ38w/SPI1oOcm8m9HzJJcH9SGLJE/1qCYnBmDoSCRkLiYkQo4ZUcqklVCbkSD+CbMppnRLF6YkncILpQ6ywwOoCKxmhsgoRdKB5Y8YXXeSKR692hFGoNsYgK6+0UKQrybiWrGsZkEhRSZG/ABNsMGAMs+UULRWjJLDIvuTsszDF7MMzMis7zTQ1zSitNTvcZDO116yKbQ1YasNtN91W2WUVWfxcRZdIIkFukeWYK7S44YaLDjrp1pjChhOug6CA7cDDlAHxVpCklZrgAzVUUQnCZT4H89uvv/8AxI8+As87ECED74IQw1ptHcmV/4Z2xahCDC8slRZehSV2WGJoOnEdZdVJdkVuUtkjRhp/RCorHXV8oxt/VKnqWiCn/RYqH3vcgsi+PL0GySXhUbLdue6KUi8qq0yFMCyZKWyxxiCbrN8xL1NEys82O1PMNUkTDU6FWYOtTli6uQ2bXSTOTRaL+fzzN12QGxQWXRYhlLlKPhZOl1JOlg4QRBCBVNIMHIDgUkxn3rTTT0dVBmf2Ym2GvlId7C9o/YBeFSYRR8xGm6SXTm+mgZLJOWqpfwXWvgoRxBqkBXutGtUntfa6VPTMQYtZdZZFG21wuFmxRWrDtXZGMn5UBR1sEPE2SHCdersIuKn9sdwyBOk0Xf913a2L3cTfojXelOi98l7D9PWDX38nK5jMN0HL/A6C30zz4IXZjDZO02EDAoVBVummGz33tPjP2GX5eNBINq5kEeESMTQRRA1NeZA1PJPUggdkvlQAmjfdw1NYdYae1Pz6WwiUAIXGvuiFcEHam52jf97qqUWS72pfPryEkEY2YgXX8kFKz31ky067fp6IaQVKyrpIQu+/n0JEc7S1im7pyH/iAtwBFXiENgxOSsBIkdkOpzjEUYNxEeLQ46BEisGIAhge9ODkGOMYLzmmM/8CHecEQSY1fG5zCIPh6GQoBTYNBQiW8JMs9MSn38iuh34SVCI2lgjeLScTRTTZImL/AQvgqYxlxEOB8Sp1KeQtDweK8NSxwAc9U4Xoel4MRRjDqL3tvcp7THvG06CmNKmFSnxvdFquQNGIk6hPIBVaRh71eCGb0K9+7ADkOpwBoZLooQyCI9cWFhi3IvTCH+iAJDQilbceIbBaCexbuKAQlAY6UBPGmGAo16Wk+ODlcRrkoJVEyCXG7Oty/orWC1cTGlpuJjSKQE0MZznD0c0pNplonQ5/uIpI/MZ2xLQd72yHnN0dkYggK0URoQMIOayhEJ6hgfG4s80qzswAm8LizbY4qi5q74vZO6dHuse077ExGWoM3/jkGZ/3jY8kYWxfHnOWR+9Nw5/+PNIfBSmN/1o4yCRzEENFNlmuhSryRzpYZNwqgQ1//AMdqzBEHM5Ayf9F9Ct+C8pCW2gzUY4ScVHbIIc2mMrIgZCVkHAlmGD5wj2o5jSyzKXBZphT0/USdUD4ReugAY2MRaJ3RzUEUg21VJAx9RCJgM5SUzY86qDAAdz0pvKWx4AXNE+cbRwnQoJmzo2s75zpXCeJ0BhW+7xqVm+Fo9P22McjARRJaBtkQUsyJIQmFKEMBaxDPfqiQVAUHf+oKDqmUkCQNnawD8WkRz1JjLqW1KR0Yc8r8rfBDoZwMYoxRb32ZbmZ8sG0OO1pas2AU9bqlJeoLc1VHtYN3/xmEYZIgyFwq9vd5v8Wt749BBp8m4bbJnW306wmVT2DAg1w55tY1U4AEqDV5zqXAjHog/PY6E62KqgT6AOQWcMLRrS+Z7vcXWN61znPNpZPevCMoxmrEdDKpiivrNCIHvKwX7/2VQyBHUNDBTvgxy7hC7CAZEUR6w9sVCJHfoPw3yIL2QmHa7L1leBlk5RZzeavsy4VYZdK+MrT9sXENbWpLnkamjMsrLWqVdicEDHU2kZCt8JFgxZ0jOMnVFMLcuAxkKcZ3OCCAbnJhUOS6fAFEzQAut6c7nO/+c3r9mGPYWXafXS1qjp2uY7pY1V5n9fO88oXrLJy79MUtGY2Z81AdrXf/SxkUP3+la//Y/gvnvUcYD4LmMAwik2gYVSDN2DjsApOLCziQCfH+q/COXg03ybcwBXWoiaWraBcMuthK334gyAUMWlLK8sUiw7Gq2kxqkv8Wtcw4Q+qGOoqcofbN6AhDnGwta1v7QUf91oOPfY1GMAA5F4PT7lAuKpzoezN7lBZBZp4BT/PbF5QVa9o6wsEmLW9Pkec1T8LSet6zljmLcYXzW2mBbqxFtBADpSQeTFJHvrKV/7eeQxDAjBgj9A/QA/ho4I+ihQmiugF+2MqNWBKpPsNFoUbJYFFIimmF6fpcFhwPZy+0mJaIULRxpS0mElhqU3NU1KvZtWo3SkN/dALaAgno2+I/8MbZB7zW2dh1zf/ta97Pexe89rYxGuyspc99AZcUbvkRno773PtjZykE10WL3kZAs8xJx3p6uWZew+i5nRvz+tfL1ZA57ENYOSvkHioiELpvWe245vtAu6fQ/kNaIgOmglWqBvBFwyLjXaU7g1PeGS3QJY9QDugGnbXP/VZiw9+utP16ngJNXHCUaN85DBO9Wro0K/Mp5yGcVr5L1RhiCfKXAu1xjXMcY5zLwC7562H/RWykOThWeEEMRv6dKNLgCmHhwJGlzbWp73Wpf/nJMd/un+OH3Wh+cw94z6v1a8+bbiyuXpgL1bX0YIWDGnEEfGu99rF3/Z8Azgpc6+wAv+tYgUEF3zB2LBEoxn+d4BDmv4vKkvERTlxUv7zShj6rMHguE8YLVEbExU7GFMLuc0hsT/oPNX6PDaJwFc7BUsovZiTuQxUvdXTOZ1rPdmbvSwAwSmggSnKvW9qNiuyg2iTNumruo/YMqa7NrJyvueDPqV5FxckN3pyq57pOuwDQmHRq/zaryKsM7W7N7dTQiUsP31DP36ruxeJwqKIsCHIglXQu4riO4RjgkiLQgoDQ8B7EUrDIsORuIrbMHH7v8bzLDZMBZiahEEwQMyhjBcLndNZk5J7k8monMsBnc9LGAiUgj8whVOoHA3MwNlDg5nbQA6EvdfLAhkIwRC0Dt3/Y7aho64DGA9BOLpQuTprI6tQDJAaVI8bHLd0wMFxSEVVjL6mMTetq77r05VZpMXsowVBUB9cNEJCOMLxa0Lyezss8LP744ovjDAbiAOK0ru7kRFjnD8xfMawOKQ2IBwIMkPLUrx/Grc8WkPHa6nIGzES0xyFuUNpyUOT6xdIOMSV4ZcHlJMIBD1LsIRDREQNpLlG/DmfWwOfuwIvGEER/IEpuIIdqACh6z3ew0SEdDZODL5ZacXvERbrEUX++JAt+7pwM0VW1AZU1MiONMWsg68D4bqvq8Ug/D794kVd5MUlLBeWBLA5+EXzizti5AoZQThDODSCW4UsaEaiqDtn/5ww+6NJvaE088Awi3MLtchGNVyGemElyIPKAhRHyyDHclQTLjhH1eDDylmZzzIFdnTAFtu8sCSTzZND4VmytJyCM6hHe4y5RRRBY+tHOBjBGwjILLDLKahEg8wqA6Cug/SODQA+fdLBnaHF5qMesGuVi6wPWMnIMzoHj1zFxwTJV3wv7yrJIETJzdzMaUzCz4zJPoPJJkSCuEsCH/jJhhOsY/Q3Q1BGREOHSqgKhKu/oYxGaBwLatS/yuK/pFwPbuxGp2RDwQjHyku5GiILcwREdIwMSDCFXoCFlkuOLSlELUEMW1DHPtROsrSCtfTOtgRPuqQ9uvxHvMzLG6gABf9IyExkT4UsunBaBuFzwfPJzPfxmfu8T4zECcqcTMm8wcuExThas6mzRbDTg5M8UM70RZcsv4QCsNKE0PODKKAkRn/zGxuoARvASfdjMNnkwoYZSqFUODEcPFzcTbjINFUkTGNg0W+EStEKR6p0rarEw6vEyi7AvD9wzueMTmhoHXfoBuTohSEVvV8w0lKAw+2UDLFkUrF8A7bUTnoMz3+cgvO8gRI4nhRcT0tUyOd6tiySz/nEvrhCM/mCzP08043sz7rgzwCFGvlIo6z5QXVjM8600zoTv5YMTdEszT6LUNMUrNSc0PmrQn+zglXISQVrMMYKvNt0VNvMzTIovKP/9E1xWMp+spAWXcMPG4wSKgSQs8MVq1HkdIIcLQRKOIVfGCogdQdd6AZ3cAfpPNJClMckrRy25M7ubFK25IMo9VU6gIO1vIIvuIFgpdIdqA4T3FK/bE/u2EQWLExyU5CekR4y3TqHVCs0ZNM15VbKdFP1otNvHQgEvdMFJc1z9dMo+NM/pdCFs1BDnYJISNSKkoVF+1AgEVH7y1dIrSRPIoVaMMpyuCsksauCBc4WrZfNgjYC9NQ6bI02CZ0VetjQKYM5MVVTQA5dcNWN7QaN9dglqkBKOEs5NM7U2FXJ+FV6BNbPIB7vrNIbQNa9BEwt1dK/7FJNFAGGDAlqe8Fq/31TrhPXbx2b3kRT/yzaNM2soE2zaS3TNUrQck1OfJtGuIOCdX1QJFDXrIVQq31UCv3QGpgCRNW7esVQ2hS0dvWKfQ3DEa0kNhGEFhIEKVnYK6FUi+OjqlkphQ0Mh7XK2MJRUe3bv+2pLzBLS4BOj0Vcj21Vk2EOkR1Zkk3Lz4CT00rHrezDlU1Lwl0yl0XW9KTZmb1Zm3VPFVCDaAvTnZHWcM1PpW3MaugnolVTjpTd10XapP1Z1hXagkBQcq0zz3Q7z9zadA1erSXe4BVU25yBpuBCKQjbefUHWQAERosNG1LbtbXe601b9BOK0XA7daVGuf3XWqmrubqy/AHYf/9tWNAJnRtFCpILXAUchJPxmI2l38SNBedojsflvF2dXNNCWcv9XzEhXGL1TmStDg+QmUsU3S4dXZ093Wob0CCswdwtxW3tz9jt1v/kwaal4DO7U0MC4SEhC3QV3uE1Yaud0ON1VNZcv/aDTWHwULP9NxXWV62o3kgTrKhlqKylCHpTH/bBiCxi0YPFH/Nl2BIKmPVl31zS0RLyEr69Q9BjS8PVBSBFXIuZX1g4ovt1lMcdhMh1R1XrVSUVtbE0k88Y4O7s3AdYz89l4NEt3RYks/YonwgeljFtL1isYNed3T7O4Nrl4NuVzx5Ejw8OYShgQkQWRmFE5Kpt5BLWWkf/PuHSlFB+TVvaLAK8S9TD6gZDkF5Js+EU1tdRvuG1dcbkBF49XUKEwoMilJIgBlhi+D+M85LJ64Mk5qnMgIzAQNUXFa1HOK0oXi06iN9fgFWN7VhdkIWOHRldOAQ5kMdDEFnHhYN2jNz+FZP/ncOxFOAv0FUDTgEEduOafeNy1sQtMDzCnGORtOPMxOMO1s/aNdo2zV14fg9DnlpOqlpGluRHhoitJYI+jWQT1oGtLeVK9rfqnd4MBVtVeM0E6wY/+FpQLuWKzl7s3QodBrA8XbuUjNu/yNvNKs7H0OVJ6CwsCYaULkTQCq03pEM3cU5raJ3WcdVkFgZnHplEWBno/6hmsITcJduczmtSyqtcA+zmb7YCgsxSvuy9FNSqBf4OCmiCdF5nV2znO57T1e3g6JvnP9Zg3H3gew5h323CRRZeSO7ntC5og0ZN7YVGgLvQDJUK2ESHLaxCUq5NvNZrjKZQVH5Je+voPDgkI/zovGifwYASJ65l4nRKU0Bpx2bplv5lUIWEh8mHmZ5p2tGFm25mXYADQHjmU/VpMCY1of6MopapymsxNR6Cl2FqTIFqc4aAGPgkOZ7jqybQrLZn6uPqrvZt27VMatVjT+xdBnVCft43J1TrtA5otm7r53ZrhoOwS4brq9DQOzmsw2LGT35GUn7uvVbo1MxhwguDmP+UWhFGby6gtLygF71VbEqA75Nm6cnJF1/2uDqkhKAC0pmmX5peBEHRBTkAbWlmR7Qk7TDew2zW5gZ8aTQ+g6Ru7deG7b4s5+sqBNtWujp25zaTmuDmbZ6d3e3yY3quzEB2wfMOHHRN7tM03uZ28Rd/cRZ3bkiLbjCcXhtfaBqqUkR4GC30penubvCW7iVIXiFXCr82TbJO706K28IDjDUMhk+jZcS275amb3uBbF/uuCOWDEhgOf6maWWmnUzQ2FhYA0Qg8JE9Ywd/oZN9pdRWbV6tigxwMi6NbXN+Y6mubXH76nZWN0L+8OHrbY8ccUDOOkEW2p7FQSLh06p1O0f/NusVl/EWp3TnlvEeYIHvJtQiz+ualBEpeINVwAYcoeizPV4jv2i+zugR7mclVAMRbqG9YKmUvgbD2FROe7xW8GX6rm/Q2nXRAkfRduwqdgd6yAePTWaNzQQBd44Cv6YDN+0zIOo3Z3DK5VUmmJQ6B907x3NLQWcMN0zVTRBAZy/LjNZCb9MMR3StA/H1EEbQlHRIf/eFivdJr3RJxnQe+G59z3dNV/VQrm4ZOQM077tSp2Hw5vRUL3J/jyxWHzysbPKWQKXIofVaV+ng1PIXdcOV9nXC8Phf1xc4FHmYkscyJ/OOJSJlH3AnenZod3MAjgwynvZsftKNonNN2fZu/+/2CAgDSgD3yuRwcu9wWZm+dsfgyOzq+dztdSYSSFdr5K53e793qef3GWd4+et0HL+Wggdyha9khEf1sN/eG50Xn4+Fs0d7Wlf7tU9pTU3YjAd5Fi2FxoZ7jevUkS8hOUwyMjeZWNBYlWl2anZ5zpt5ai9qOnTSqqgUnM95nS9nDAiDjfv5qAl6UilxAvHwsMbIP/bET2xao39kFZc7qrd06N73GKh61Ff91W9rgA97oDxGAwpysKd9sfeK5PQEyekFi+d9W+h9tr94jdf1uofKWLCX4h/+VrAE46cETjPp53/vSaC9QZimaIbvlmfzM/HDbc4MyvhU7y+tJSvBxv9nVm6X7fIAJckEeqEXvkFm/3h+yGilPntup6iXSdK399NPfX7HAYCAoYNHDIIGDxbMoVAJjSNFljR0KHHgwooMJ0LMqHHIxogYLVYEGVLkyJILt0gsQ8YNH1G9ejG7ZmvmNZnMYNrMGWwnsJ49d7YKmkro0FSxisZKmhRp0aGWmjal1IrSpEmUqFKtqnUrnK6FIF3NdAgQokJwvqBl6Sbtn7Z96LyNK/cr3a9v7d6Rm3dvXhsmDhgILHgwgcKGBxxOrBhwAQpbSBlbRq2aN8qWnykrpnkz58zNMG8G3fkz6dCjSWtLLVozZtWVX8NuXc2za9XKatM+nWw3atmXq6H/DI4ECvHhxo8nSa58OXMfFBEmhC49unOSJkl67Phwu/aL3q+DDz8DPJbgZFTueWTr5U2atnTOdM8z2M/6UCMPPWqMqVGoTv9LJdVUU03SilVbYZWVVlfBEdZVZbmVFltwuIWXXBT2UYheX2GY4YZ8nUGDAwUQVqJiAiB24mIHbBBGK5JNFttqufFWY2k32qabbrjhWJuMPtrGo28z2ogjjZYVJ5ySyDFZHQtOQtmDc9LhIBB1VmJJnXhbYtTdRzp8FyaXY5pEHBZFjHHeHi5xw81789FkE5zzGTNfU/tBdZR/evo3oJ8CSnVggVUZSKigVj344CBfwWUHW3zVpaGF/xlqOFeHeukl4QkNGCZYACaqGGqnDbTY0zQ/BklkkUaulosvrtq4o4y9/VZrqrcJKeSqNK6KZJJbRLGkcE1GOeV0WT4HQ5VXMksmlGCK2VB2G32ZHUXOjpctmeWNcYSaLsHk3inMrEfunDuhm9R+fJpyX36p/ORfn4AGKCCihyJ4VVWJUrKohWGotVdbksZVKYd5TVoppn25YYYVZtQw4qcoBjaxqBeP2oAKd5g6Toy2qtrMqyPv6KrJJ5sWGpA54grykC/bqGvInsn667DCGjdlc8Yyu6zPAi0b3c/NKlTsEUYfDe200TLNNLbYmlmESit5cgo3L/Vy9Utah5vum//yzZQfnnrq526e8wpIlKEE6nvVKw8eMpWiB9/xKKUV3s2XInldunCmZgAuhRQtROBpAIdbjDHGB5DaB4yownwjyUeKfDItKMsKeeSs5rrbrTOXPCTOwwWLHEKmS5l6s8gCzbrryD4NUtNNOG1t7EWTWYZDU7eUNdfrtak12F7XSV+d8Korr/JNEfVnoPS+UmhQB/6ZyYNVEeyo9pISXNeFfnvY916BM1G+BpyiaDHioCqu2MYdn6o56Eaa7Aoq9l8++WmueSz/5zL/b1cpkxxrfGOzAxLLaMdqlgpe1zMt3Q471PrIBKPlpIloK4IYUYkeHvGSR6gBcHtYk++s0ab/cHVNKfNZytl6MpRSvGtemSBKvQi0lRsSiob/mdTeINUWTSRMYXfQxIfAd4a1CA4ihGOM4djXvsVs7HHx65/LCGhFV90vi5jLnP9yBcAv6uiKBfTV6BKoumKtDlkNTOMa04g7bM2ugmGqnQbJM5HzmAEsfEiaQcJQiKy5w4S/Ix6c+tOu5cXwP62YIb0C9QqrSA8ShZJkgGJYqEIQMS+CsMNcvJc9IxrxiORT4l+cSLFTPjExGtOEFGMjv8rRr35ahBXlaFMrKgawRmDcXBh7KRsmldGMaGSjA4n5JAjeznZxnKOYnrUlaY2pCtJ0A1go8Ycu+OAFKtiACJzwB0iY/+IXgbRGCtEFDHQhjylHgWF+ljEv5zWPekKhpA7xVK9JFewR3/Qk3kCkN3/WTZTlK994PjAC9JkSlU1UXAOiwMpW4rJWNNMRFjsxy17NbGX/86LMBOjLMYoOOcE8Xc7cmKXWJUtoxXTmG7e1zJdWq464I0LSNkiGP4iiXX3AZjZFoE0d2AGcgBSkComXHz4RpSeVBJBQ/DQoAyXIUJRECp/0NQl/VugR2MPeJwEaF0eFEESjbMEJTpCBDHAKoaZca6gawANIQDSiQ+qlLPH3Ks5lVHMgjdnmWDY/XxqQWDcT5gJXqqw2GvOYLIWjBL3DzAlmUKayo+BK9MmEpIVBCf8w8KkIlKWDMIjCGu4Y7dWKalQ8HTIq76zh8yDZ2gJ94qhKcQokvqKIHnZSq7r1Hohwewc1jE+EIVwJQRVS1rNCIK1sVShzRRUDSsT1lZzR3+XwNwtY5VIz1eWrXGfE0Vp6FLx4xQwwzYi6Ya4UsZ49KXtNoNj3alCZ3JGjY+Ub2ZbeLiUNC0N0uqBZEXBTAxsYMA7uQIlgkNaE5fRa2GyBSEWmDarTs1c1SRHbVLSLJqmtCqYwyb1IATFCXlXLF0Z52RoU1ATITS6JlpuiVI5KBQ91pctUo90tXteutowGzLao0dTs9bufEy+RZdObYA6WsIWliHp71uT3uhe+kl3/CEckQl/rTNmOXSBuRpLVWSc0AQcAhgHA+ACJWIg2kFjzGgwz3OZSsJN5cptnoCCJQ9fm1BTB0HO7aitEgVGKq1x1y1uAe4ceBixwgAMzRY6bAQew2MUwVtEBZBzd7sISx9ul5ctYtukfe5q7fZ2fkYu8YwQKdmdLXu+Th9bek0YZdlNe2nyvnGUuLcG/jHYO4NpCCT5fVQdtrJIbwgkNd7xjkDt5s/IqSeem3hlBedYwhjm8MH4OTJ8i7mGJtYfEJO6arCNYMRMlPWnCaMxxl+aRpqdLq07zuHL5AzWvRN2yjJo637thzkhVXVjDJqTVyop16whO1vsePOFk2k6X/6pcawzeGr8N74IJuFkFllACFhpXxS9KAQk3JKGB29zAESChNQWvGc5uZrazaxhJrQAx5gvCcHz2nApr+y1S2e7nb/cb1hIDbNGkNCi5zX3uFcVgEutmt7z192563zgXP653dkO2y1KzalWoVrW/z/jqgActpV8fuMFjrXD8nh3h0BzPw+nLcIirXbIMccLgTPBTGjDhm8buuCmuuYUGcpOaiPLdLwrfCzdPWxSVBMvLoy1zPDfYwZ/AufbyKeir8tzbYR1uEgHGaLMWfblGv1gDmvCKyHxMuoCFd7x/M7mr80bq2Xi6Fa/u+noTcGf9Pm/BXc3AgYQ9Buote9nTHv/34zfW1nCP+GQZArGSSGEQGqcE+Q7b2TKbwcAlPDziU6v4e4LF8R4W9LTjo3jMdzjbfvYzocXK+W97ngu7HncE1Hr0+xugRS9a+pDHy/psxMbrQZ29ERCn/d8BhhdvcN2vKJnXsRrAgZ3wCRzZGZzxIR/yKR/b3dfyoZ0FYuDcLVoLDBxnmYAfIEKINIQEqpjIsYDdqUAV/EEpZE03cN8pjIslPMX3VVht8SAO2dZulV98UAXP4Q0/oV9wcZ7nJVHnKZGwhV65OdHodUqniIAdGMWlPQ6+ISCPzYoArsyqyN5u1BXmbGEVidGNpFqSNOC/TeADPSAMEN8KyOHZrYD/2pWVB04WSDhcEzbhBd4a3Z3HCFyAgEXAII6Ae+EdWjSEBtjdgBWiI7KAE5yB3p3CS9igDepgD2qiD4ZY+AXhIbFf+1mev4RihADOcMUf7agi7Yidezni+ShXFOLfYECAHcRCOaBejEzGN6SeNLTeL/pfjc3eXaEGpsUK5lRXjgVZGd7eGW5GGq4hG76hG5IdHFbjNKqYlPmhBdoXH+4h8+GhtmiEGRzNkxxiCrrXCeAdEEjBEZGVT1njMdHAwJjgJWJiJm5itJEfn92g4p1fPxXh+pViXixaZq3iRVwLdSBiDJRVOlqABjjABkQaLTKALDaXiVTkFqQCOEQGLlLD/zaApC72oi+SZEkGI415F4wsw6iJYRbpGO0doBnSVTJAYzRCoEldYzwS3E7WoTaOR09uoziundv1YR8inE8m0xKAG5XRgCsSIiMeUd1FGTS5FxMI1Bn82uFdIj5qolXtY3z0o1b5gbYVofpNgh+YIFnygc/JX1smZHRE2R1CCwq0AA3QpQ6cQAU4JCxWZGAwQAP0ZcWM3l9SAFBZWEeWQ03URCuVZDg0JjB22jl0UdXVlUVdF0xC5tOpHkXVpEGU1KrdpELqJE/m5BzGZTYenzpuI2QVgVAG5WtG00DJ5mU92itOQDomUUMgYlQK37j5ZhHUoz2eQp6lQoLwy+RhRf/igSL7qWVZpuVAFqQqQgvPIBM0SctdWuc6mtUFUID9WSRGEiapUIAL4ABwadVhdiRIxoQzhKQ4PCZkgpo55NIX5gIqXMJ93g92AaBjNuNJyuQxcobO2CRohqZoYqMc8uQhmtUhjoC2ACVs2lHzRZA8xo7UzKYV0MHgaEAGmIC0TCUQaGcMQISKMaJBsV3e+YEhVOLGWWL3JUUOXhifhY0OpqW25c3AbKKN7hejseJbHtx0Zqe0SEEN2ECRFqngTKI7qtiAAaZ3yiJFSkB3SikJVAkStIEaCIIksIKF1YIvsqc6gKl7kqRm/kY68M9GraTr3c99WqbnpIZkQk7oxOT/XxXDGQ2oA5omfOEknkbZIVJgnxoUgyKooCJoHQ4BhGanjwIpOIZjSJQPGRxTkubAB6jjFzTlCj6kCeSmo32AtHDECcjhEERfJfQCNJiqVl7iTNyjcqYWc+qTD+3cJrZFKvao0uClrV7nbOpqO4bIEfkqHUziHyipRIbnk/pleFJAlE4pCTCrNlnplTqClnqCJ9RCl7LntWLre/qifG6rSf5fZfiCfWKCZd5CMWor1oHXezKdjjjgZwqou/Lp2LUrdBAcoQLqoAoqgxKigvZkp8olHiZqwD5To1JoUpKjII6AVRIUiqkYpD1lh9plEoHqCnTqp6bYDOSdJZwCLEDD/8ZVoi3YI1iaAiYup1jqKKCZJfs1TK1aJ3YGKSDu6kDxarAC6861BbAeLIAVYrE26bH+JbI+4gWQgCECmDZpUxQEy5XqQR7kQZZO69M6gyesZ7Z2q3xaLS4dw5DAxqu4JP5krWxcbReuHgJy5rHA69nKK4Eu0L3mazbm64pRAAZggIkaKsEyqt0aLBPgK8ZyBIq1wEOe1W76BcSi47+mmKG+ASKUqqmSE9bYoMginquKGMrq01geyKyyLHYypHUeqcwKzuf6qhVgqK/6i+WOZVryXBMIn5QmV8/+7Os2adAOotwarRwSAQ4g7RiMARHobhswrSMsbbROa7VWKzNQLf+Yhu2spGn8RAPJXJS5/mfW4oJ/Zia7vutB3KnaUuMx5Wmetu3bPmXPTsDcBqrhau5QYtmEImqjOoTCYqwf0IFx4R1cDK6KocAbWMIgNOWtrmMNnGb5AmWwWo0gWWINdp/krqW3cZLN9iA5fofAei7oiu7o/moF08Hp4igD81bDhByAuS6yEmbcyu0Ic1btvgAPIO3tqjBx9O4YLO0L68EIPS21fimYssM6iCnzQiYy8DAvjIwyTi8XJq/YSm8QU+9fSQfaou17ae/Ykeb36iuHjvDOwm4h8uv63u1isa83usGJoaBvcmg7SiVdkjHcolgKDNQMICgAn6Oo+kElolz/i/Zjnw2kV8VqbdmBA0vny0owBSfpH2vIGqDlBaOlvzyCIZuuh+lcpTiwB7MuqYjn7BKtvdruCZuwJesuFhCBHpRBC7/wHuiBIwgvDRMD1cbb8vIwjxHvdgVx1fLnK8ebDxfxEdMpTSax2ZqmcqTtno7mE7stvurs+I7wBx8r+Zov+nZgFuMteXTxkk5x/XnAXRJpUwozRFpzOs6vFdAmg5poWd3uQ1xwOBleymUYDtbxHyNMIp/l8+GdKoKoDcBsH1twzQ4CIZtFIe9TpPAgPuszXeyzsDrBZnFn7EbpM4uAvjprJcth7VLpCqtwJ3eL78LwROvBDFOrtZ4KD3cM/zGscvT4MEabsrf6H2ZeRng90BI38bxuby/3Kfg+c/217s8ORgL8JYea7zLjdDLr9E5fh8KOwEEHLjaXFRqLMQpsqFwiwhswLArw6hhfsTzSnZmBi+GRrCmcswLzQVn+1iqm4hI2dc1ecFiTYj+PtRH+cz9zVTXh8TZLsiRz1kEX6goggUKvQAk3NCavcHmch0Tzrh64MEUTgigLb/FeK0cbtkdzdA1zKyyLdCzTsjMuWdep9GTrqTRSIFxH8UsXYqQFpgFMDAPcZjreNE8jpRYrs7Zo83a04DkKDl3ar6ZmqGujQA1oM4kGLopm6KG+dsFa5SRSAsfJsTkbckDZsf8ohSC0KGHQPYo910VZk2I9c8hznyVaX550ayLmqvFBu3UJmzBBGK3OchYGgAAIXAB50/VD//XS/nUbtHB7B/a4zvCWdnQ0HG9InqvIjDRLEonY3bJkVzZlr/TeAjMYh2/rPnJf0jS6RcA54nRpm3ZO5zQIrqxuGxQK0N+GWgAEaCrewbOFj6+BQ0BoR6zENqTZ0R1baKwqqLgpCLekgDVWG7dBTmcXSAgSoUVYUwha98tXkMWOY4V1T/cmXreQ73MoksGIhvdbL/RhfbddCyJ5g8BCH/Rd866ZQPTUsLd7Z/kcZLlEv7ciPO3UXquYUy17koYnZAOap/l+vpszBij/s/g3SgP4fx8o22Z2gbduTMv0nvtliDM4hD44aUM48h1Ra3LHgp5PRJZowoGuiIT4+HbokKpY/y61UNN4wNgzWAh3o7gf+UiBrrXzlmXfi/NNpvPgc89NqvtLWQR5V5YuEOaLqw83B/90gHF3kxctZtf63P60djMrPNqucnBLmnT5lRd7e3u5KFu01NYwO7AnM5iDmd+3mmedm+Oy6gR7nBfov7W0U/b6hVdznou7nm82YPa5TQ+6op52wTqqO6pxXQKrFWxnGIc1CljAHQrypR41HSDCDmBqBtC2pbo2xA5UjW8P+4U1ce+orjG8/IlQqXcFWOv4ICCCj4dFWVx8/9u4OpETuVbl6KKcur/QuvVp05Qn+dwyonljwK/XdZKTwHg3K03RlF7TvCcf+837tV8LNnxPa7M7u7RXLbXn9yyLxjBp+5zT+S5fo64H7lOW+9OP+6M/c4uBtqCO9tlRpaCvu0L09gwIsxXAbw1YuE1r89jDogV0haSLNlqFuMOesV3+65GGrgSDNambWKiXmVjf895nsForynEeJ8UHvt9vfOEbvqsL66eT/K9v9yS3/K7PLbNKMnlT+cxPjTSZx5VvwbHnPAz37s7PsJdS7c8LfbWPV3+njpzzcmh274CDO56DeBW37vieFV8aQCT/ebZcfbrzPq5BDMJ6qtrbNv9ERiSpwD3diX2GA0ZyIQCkZbgD3HsKpMAdSj+RyjNapLYFazM7928YeAWPV7xzFzK/hL/gAz7gZwKcaaxxEj775y9yyuCy0bGmj2wmWhNPIah41+GRtzxAYMBAZMiMESMwHCSC8MIFhRiOrBAxIqIIgkeOuHGDhSMULHuwJNnikU+ZNlv0jBmj51FLPSlVqsQjM48jUJ5w5szJzJO0ZrWaBRV6jGhRo0KfJY3hYykPp0h6RJUKdarIqjCwPmUhtWnXrV+1gs264ivZg2cnalC7dkKEtm8bQHDbNq7cugLZMihggK/bgydazBCMIkdgw4cL01CcGHFjxo4fQ/4ambH/EiZmzhSZwYSz4RopPhPO8DaDhRM2bLQwYbqGFDo2HjiQbSHFlyk2LOQ+AZo3BxQoWlsRPjw0DSnHkQtXTNiJbTqFoFOSPh3SIOuIqmOnvp17d0qZSqn6FSt8KUvaIVESz93UelHSg/3qNT++qfTtxZf/rsr+Hz7/ySDLjwH/kwghIgrEiww/DLzAson4YOKgR85Aqwc/IFnCqj1s2YOqMj7hYyQs9ODjEVtaOsUTmGJqcaU8YLRJJ0/eYYYYn5CKZqijiNLRx7CuCtKqIL0qUiwjkSxrK7SYZGuDuaCE0q4pqXQgL70SYICChD6QzEvKwJwszDHJZIyMM8hg4o3M/1TL4Kw1AIFDihNKy+A0ONagQbbSUFhjkNR0Q2GHHVCQzdAHdojjhxQAA+444aQIrdFGgztOsR1s8/M6Szjt1NNOp9MOEO8y6Q68U1Hlb7tfrFFlVWt+se8TUeZLBT5r7DMl1k7l41S++U4JVhQ+BpxhIGJFEGgEP04ZAoSDzuglQIHO4OMgSMhI6BRIJFKLhfd4UMGpQqx5xKoqhsUoCZZOKYmMR3p5aaUX84ip3ntfknEnZ27sScdaAN4RmRyDApIprYgYUsgkuWLY4bGYRMvJiaOsuEq7SHNLrwD6OguwL8sEOeTBRt5siSKCK+IsvOSq4QxIaQDMzTbz8sAGK/9SQ6ECCxxAwOefE1DAt50pvfm2GmRWS66ZP3MNkUwOQWTUqVOthL9KPn066+0OaQW8Q6L+7jtdzJNu1O92FZtVVacTL21ae+H0O1zR9hRYXeUL9pRe3uvFjwBHWHCFZ4f4b4iEMCDjFAYFMuOPa5kY6OkGc9hWhYlg+ANcp7pIF6N3HwnQpEdeSglGe+dtsXRHHNEjlJxq8ST2nwK+0XaCo9HBK6oWVpish48EXkmFIp6IIZaRh0vj5S/GGHm+oHfrgy5JFsz660sWGXvtKbOMicyO57JRE3ZrLbUHRpPLyj3RRx+FEoAAYueeFah/Ng48MO230Oani0oLjDMF4QD/AhYFVAXWwAa2r3EKa59yoNzM9p1MeE1s3wEHeU51wKvFTW29gqDbSmErvIXQV+ZxjylKiLde6G2Fe/ObH85QrIMUwXDPSlx1jJU4a60gQxNYgSWadZYiUIJBmCtEHz6BBbJsYVhLPMIjRHGSNryLDKabV+mwWK/UwUQP+pIGv2wExhvl6ItlNNjBepcEIo2lYcILngnMUrzwjSZ9yrOY+prnPLxIAEsc05IGpvex7XFvkNkTU8hOdjIzpGl6dfoAceh0mkfdJn17Ao7OcgOcEFxhB7GpH204cAPYtC+Tn8lN+2qDAg1YUoCogQMBu6ELWKhCgZZoIKdOcUutPXA6/2Cr4HRiQTawlaKAsBBm2tz2Nvx4kJjI7BWwOmieX62whZDoBTRaeApR+AFlaPrPQRJHIGjR4VpmgMh5igDIEcSQWxNpQiGcQAk3LDFETiRDukhURXmxSCX83CdN6HWTfYXRdgUtY+7O6ESFLbSNb0wSHJV0gjhOVI50TJ7F7IhH5jUPLlnqi/gEub3FFNKQhJSMZRTTTZU18gOckdT0HGACOlgiTyZYpQMssANOYpJntBlUCnaWm6D+zJI2AE2e0JeCHdSAZz7rmQZQYJsQwGEQmdCFLGeZiVvykqvUEWEvY7GrsILHmOBpFdoOmFVe5adUZDWh24D4iwrmJ5kt5P8bELF5t1M8YkADEsXhHARDbq6TnCOAxBmgWp0KaWAFxCqiCOwAz8P+rp5TgaKIOFIELl7xn1ukl+ryBbsbOYOgB+VXQqeyAo8wVI1sbKhr3Qgxijapjhe1rfKstFE9zgVLHwWpSYFbUsgkkoaW0gydNFCX3MbFTo4CAnIrYIJDKWAACMApo3Y2P0/KxqmH4k1TR8NdBBTAuqzBZAmM2Y1uqBUQhuDqe3spHaiRhzxq7VUmZolWYrKNrldrZqzms8K42k3AAQbWCkURrADrjcEJHmwMV/BgOgByEIhtQYX9ML0iwBARMYBQIXjwHIMcYbKpNRFI8lkGk5gEdS4q3Yv/6GXFfjpCEjiphRhxvDvePYW1vovtj/8y27TM8bYZzdgdd9tR6P0xkME9JFOEi8iUdjNSKOsMBLKkvgfsRmfkQ81zeSZe+z0guzvrQAlucIMUPKC7Pl2z+36TXTEDjc40mMIaKrEK9RpQgw9cIKgk+NXvYLASu8LvrnRx12ca+m73/UWiQegrZLL1V3zWJgv1qjdoQEObC8rw9wg7kcNCBBFqGgJhh5iDaz3uDBlawRLk+Tsnau4PmcUii18kr36ajtf/TFjC2tDrGufkEzdGI8J23OPXLhu2EZV1l4RM22QVGaNH3ui1M+rR6PEppE6Oskm7yaaWnmENVqhTbE6Q/4U4AdVKFSDMK7/Q09nYwAtXAKpQS3CFH1RguxXQKaO2+4AUyAEO7KbzAYhqqClk4c6WgIV6ZYlAW/q5VIH+M3jIA2myItpVlFYrpV0FxGMKs5kEPoXDDby3SyvYwNk8BTZPYYhgvcwS3ytshSkyiBzQoUIvY0KHcx6gIwwWXXaQtWVNgdmXVDEmKnbxrnu9T36q5NegFYQgUNtaKDhxicz2usME+bGzGEjaE6OYHa2t0d0m2S5LZrLMuu3tb5/Uyi87dVukUGGkfcBKey+NoRBggTt/IQVDUwBtQoCbBSy+uv7Oginlvd0xl6AEodxB5WOD8PpZt2cHiGor7xyJWP9y2mqVcO/FLz5XQmu85B4/4C/sG6v9ZnCt0jT0gIGo4Fl+nOUunM+mXR4sRPTiZTfP1oZnAGFuploETBjW92JNYqNL5deqhaI+nc5ipr+ICLi2lz876yIoiB8Hx0a2sn3842YvKdplnzZezp52I9+l2kuDC1/8CIGZTYowcp87mFBmCFzKWBLABFyqNVQp4ObMfYwKkyRv88qLzJSKUB5w8RYAaBagAvKtBPgt4fjNu9gtBaxmFWShG1ahz1IPPOILVejrmLKKruRj9xYtb2DPrVJF0kIO97JploLP915O5faG0xJM+ExBnHgIsVJNTRZkM1wtWqoDEpLu1ZpoxCL/wizuiQwiogyGoJ/EjwtTh7P6qerGgESAjerMcOuQJNmoYvzYUNlQC3g+YLbkCP4sitqM7A7rr2JiowG0LS42oDTIRwf6z/8IEXsEMAA9gDSa5qfCTMyECpXghwNzI+Hsx37cDc1+YAc8wJMWTwPPzJM44MwML/CAarwEoLuCZlDUbRVWARpWwYBSUAU95RAw6KrI5lfKIzxkb+Piij900fZq7xczKAffytJ20G34zIAQARagQbCqqrBi7ecM4g0G5NWakEGYwkSYYgqjgq+k4ghEwVwuYrVQYl7YkMWsaMWkSCXIMCTGT13GkBzHwPzObw23rurwkR7fcP1kraKK/wdx6tAO8/CpokQC8NBQ+JAA+OIAtmT/dCfuChG4Xs16jItOaoAa92fhNPERAUgGZEBnZoM2vOAQriDyFmACS3HxOCALtKAE2qcTK68D+G0ALJADZMAL8EfOPqkSy0unGI6AdCGWdKGBoAY8dqmtwIPkwkqDcnH2cJCubBCawMMXI63QSmUZX/AUXjAr0wrmgmWWmMUSDCJwVKGI5Clw2ukMLKFCUm0GYMhA7IASIiJ0Xm1c/oqe+KDq4LEjzjH77CUkVIwjQsIMnY4d27AK61EN7XExtW4f+XEs45DsKgovECIg40/+8vAt7igB1A7LDkAhEa4B/pB8IDIiv43KIv+FUjYRp+hNzbTrkrRr825ADuwtJ2ESfyzQqTjAC2ISNy+wui7wNx/gzDRwNkuyAi1RqRiuNipBvWKpbFJQgUgO9UqIKmuQKUthrGxwmXCJg5zymUpP04qJB5nRVRDhDaTGzvxgAvTCBM6jnAIH6KSg5nKOCQEHLbHwsNKkCzjCFELnIw7r14bkCKiuCAzzQNtxHsfQQBF0MAnUQdXljNYwChgzH9XQoWIAot5IMqVtMivzMjGzIarttjjKM0GTISNgBErTNJ9Me6wMpu4C4RDvN3iKEqdLAnnKkzAwOPEnlGSA8vgtOC1wSAPP8TiwAnW0SGXDBkZQKPWDOjOOOof/sa36662a0jymFAUZTUtlsJgKTYPe4NRspgb0bwiwJAKO4yCkICKWgA5GjOjYhJsmo9YyIj0uawXIwE4pZAgSRjPIcS8Ps0UAs+kM80E74lAHNeuogkIrtHcwlB851B8/tDIndS3eb0QxdSBLVDYSciH1T0MNkUXB7RBzSHnKKzcor/JSgAOdqqf8zTXJ7BLdbX6AExTXLLtKIAiC4EiJlCcPr0cdUDh5UvOE6pWuqhsIzZdYkL5UIax2sT2g80pxSVqnFTttjytz6Uu1Uq0G4Q2qzAM+8xQTMgL0grkippAmMl1blCn40566YAb0UkDVJSL+dETasPtigkEza0H5/zUeBTQxF/Uet+5eHRMOJbP9aEtZPjR5QDRTHZZK6M9KOvWj/gIyBjEi13XESDUzGkktaNTxCI82XgkOGlECDaESbsCTYsPf0MAQbmATF29lrwANOmBI/W1Xg7RXLbDxLhFWbfUDxUtGQ+BpjpXQpnXjYtAXjzYXp3VpldZprZMq6So89WZAmIBOxoszJ5a86uIu3GTsVHQsJ8oin8xAjq6NFmJAxRAereIMVQwei8BB4xFu3dFP9bFCBTZeLxTIJLVvkccyRRQPBVJTN3ViHaJivc1IRnVjOfYsrOA1gIMC0S3fEq9Q5o1VebICssALFsU3M3BVczYBaFIGdlUmdf9WSD8pfzAxCzbylBRwScOgTw5BF/JhOlEvPFJBFpeWaVFIWnv3d6HVrayTB7elW60gh7aWvNxOeemPS8ZObCHzbB+1oTACXhVKbQOVDftUQSG0Xgl06/Y1DReKYMn36xwmMvuWUjtUnehwcNGuYqgNYiNWY0RXACg2bEWVkCZSANkkB5CmBX5jZafLAUpATmIySSkxA7MrBToXZoNmSHnU3YiTZ3S2VlXyB1g3dOmHU0XTAlSgZ1QADpgV9XI3FTAIeFE4hUlIhYMXS6f0PL0VRhcyXLUN/5ZsL8grSsD21dC3yaZ3XZftXxuzbQOW6rb3HefWUOfRbgEWb8fXfCH/NVLT9x/ZgshCVDPdYku0+GHlF2PqqH7vd0VFJmPXFSK/RzGK5e96RssOJTeAoHJjc0h9gwNWVjllYFHiWGcl2HN9lfFOsuDmuGQVwDNFUwV+IwzgQEpFyBRKmIVX2JEh+YVLTWY8s7d664b9yIazzHl22Hp/hwqp8Ie/LkLpdYid+EGRWEH7VYgltHzztlEL1pPlyHj8llIb1n23GH4xs2t52f7SZ2M4ZmnCNhANI+wsdivEWGSKAGd2jqaQw3JDEt/ggFBCaSRdcsw0t97o2Ga1IBLSoJMgOJw9sQO2uY9r8gq8YJpXdamw9gEMGQioSoJukPYemZFtAZLvGZ+b/1KDpKbcRGON+fCSMXnJOMZ+Z1iPznV6pFc1PPkxRzltIZrrGrPrxk9ADfSii6BPj7iJoSJ7iRiWo7gfd3iK1dd5AYlLcPm2DDJwr3ijetmiJpbJSNOYD4OYyVgyPjlUrWwFIOUNDuENgPYLAAEnAYhXyewG1Hk1VbecLzBLdgAN4oBQduZ0F6ADrgAOQoCcDQ85f5XNLOCVCA5PBsFs5jlab9CEUjif9dkURviez6Pcniu5knegDVoAAuCu8TqTtdb+2mKkx7J6PDmwRdm1sOd6f4eVEVtB/TSzDPQiWrmjPdqVofhIEJakK/Wkb9naWJqlV7qlu1ij9giYzXWmv/8kmXMaMMiiIIbrjEfABngupeIsqkIg8jjPutCZUCrPgcNZAj3AN0SRqeU4fkJgqrAaSJsKaGpVdmuJhDMokn0XrdWarVXYPRDheOnERE+UrvN6u7n7o3xZLfx6IXrYLGp6sJGETSkaMSk6vY/4ogkCXwlC6B77lCV7b8t2Bcabli37slO6pQX3IPkQYgMSu7UkyEjbMXL6tLstwVtUpfJOCgAxcvntuDEwAns7zbYaZjkRdTUwq6dajwuY4GKSZDlSBeAZDiZhuS+uhM+6np/7d/mjF+45xqv0Kv/EptoONBWyrjW5u7k7rz1Vh3cYfReawfXxyJfNetIIsTP6vbX/kC9Dgonv1onrO8mtd8Qqe6RrWWEB1337G8lKdALah1w3xgD8opNBlaFRu7wl6tmSWTCsLGa++KvXIPHkZ4AnT1V1Sptfcrdpsmdt0xKD833wJ/BGdg2oarmNlvbk2YQX2Z7XmsGY8vVY6DxeYzXkWrt3nMfx78d9fMngt5PJ+3eox8jN28oDO/2u4kHfG74RW3zpu8rPSLCzvJbBib+9/MsHd0u6OO0S0msN/MBN3dnYvMF3OjeUJgOAYKjxRA6AgMx66kjf58NthnNxc8N3GwWGWxQp2N0UUGQToazBZtFbHHcbGXgfHXipcpl40BL8g/AQ4tdp2IZ5HMjt2tN//7wvylXI0Ry/6/K0lTx4Jpt6qe/fo8KiNXqxf63JBbDVp9yVFVTW6fHKebjWp9ikcT3Xdf2/yZWjnMSSxTzYWUDszpbkJYribzqlkgPeVYA1gACRC85VY37OaDIF9K2BPUnDLTDEY3KqjpQ24kesVRxKkRJVctfFI11veveA2sPdr1Zp5j27N/3eAQDf8V3H3c4P+d1s/b0fi9z8Tt1R05uUmTyj7TbKS1l3Hr6+JZ7WRdrfz1XL1xelrdjLu3xwObPj8z5L/GevNTumP9WHI4n9MFSifBiZSzM4pOZ4HYmd34edPzhJNzgDydkT5UeQY1aowmwKsGaawVrRF2jRKf/Ba9B6Wl8c0iOdiF67BUYDh2u43uva6j2doD1q3/maDp9XpKFXsLGcT1F94BETI/49Qh27yR3+XxNGx2K97VE9Mi1e7iNmegBy+jPeDu9es3VZSqAk72+fLkB+ZhQ6kA6fyE1+bBG/MTjDDzr/DNokf+jI8UIggEv8JV01JmmVqGy2gCthEaQUIDJlijWQ4KFMrQgSTGWplEOGCyGamkix4kOLqjJOHPSFhgkNERoYGEmypICRAVAKCACgJcuXLmGyNJmggU0GNkPqxMATwwgRPn+uGPqBaNEVM5IOTaq06YylPVhEleqDqtOpUY9gZYp0qVatSLl+LUKECNmzUMb/mOXBtqrbtkjiyp1Lty7crVyNEt0rtK/fvyOK/szwgafQnogTK86wuHHiBBMiK46AQYJjyDcZSN4smQHJBpEJBx5twcQHwSeopjZtYq/qq0xrMKGD6NSpShyHFI4M4YAFOHLg7BCOwoLx48gtPHhgoUOJFMWVKzCOosSUNYAqVUo0cJHA798Nhhev0KH5i+hNqbLI3iEiOmeYnAApsoB9Avhprtwvs79//p/hJGBvOzXm1wpHDaWgUl2JFRZsr71lFV4UgrWghUectdZaZJk1xlcS3uWWXSTSVeGFTykoGGAj8MUii4Y5ZhhjBvpk440y8gTZZIjtWCBnQEbm2WcI/zhAWGkeiHYaaUuyhtoJp0n1QQtMUZkDDUzMZskvsMByyntW0FCckdSlcMUaJUhnJApsGseckcyhEEccU9R5JiB4aqfnQODF4mefAv25TCyU/HneeanEsp5t52WkUSmUcESHR0BldsClA2R636Yq8edfTACWNGBOOf2oGItTqphig149lVeEFE4oaxK0ggWihV0NtWGGZX1VVq8iBltXWsSWeGKKDLr44rIwkkbYjDRCG9RP0j6LY45BUpatqdpC0BlvCew3EmjPijYak0yyhuCDsF5ZxGyn9OLoKZYAsgYNGzjgAAIV2ABECv9Gt0FpGehr8HE2ZOJlJvPuqSd5Bv9FXImfrfAZ6HiHZsxow4gU0tFHkWEqssj5iWtASp7+h/JJNNU0aqnczviiawoiiKyDVULYbojHgjgUWa1CZVaHaK0Vg7DGJr1VrbHW3CKzUJ9Lmk9JXjuYzIVRG9iNp9kYLbZgA1mTTt6WbXBvnRYAZ7kES+2k21GyaiWWs/nRsEZnFKfCAyjAIZxpbP673MEWoPAFHNd95+jEey5a0CEQG3qQn4ZWrrF5DVuS23wEcnppySynrLLKAQpo+k0SwExBjizSLHeurrLb9M6032yrz0P0WsRYRW8ILNJKM510sk4XH/XxV2OttduDLWmutWFvO5mPZFtWdmZml30fyuT/st1kksy7SGVqc8+QJRN2y+t4JpTAAcTeDuiAgr75AuE3EGHk/8UgiDQk0HqACmCgKAc5iD0uPBa7nEM0Yq8wWWAC9RGV50Q3upeALj81sY/LNoiT3lgvJB88FY5a15VUpSpnstMZz1b4OqD9jmgciqHvdvU74BUreFhJIauapCzkLe+Hp2JM+Kx1tdHITEbUi171CvSym2RPJBYciZHKda62fQ8162LBlMp3Pkj04hePMs97wqADkGxgAyfoGyUKVa+DCDCB2jHPAcsTi0VEjI4E9NOj5iVHRLynBh+JoH4GScEKDlKKpFIdb3gkQpAwK4tIKcqqdKjC2rGQV0zZ/xVUNASWGHKyhrX6HQ5JpEPj9ZBZ0/Ka1BwDxGZxrYi7qRHYQhgBWjbRiUXSFwIQkDYDdE9JW0MXME9IvvLJL31hPFT7rCCFMxSifxnDmADpGM0/8Yli5rFcKb7ITcdJSgpAmA8vCRk6TWlqJv05WRTHxT0OJlJ1tOTJ6i5AT8QA5Yeta9Kq9tkgnPlzdgD12a92p6uinYWgBKWh8BY6yrkgRXh5waIPV0nRah1RNNPC5yrDRi0l1lJb8bze6Zw4gQcQKFQ5kZoVS6OCtxHTmFdygxf56BB5XS6Akksg5aq5xotBTqc7NYZDFNLNicAHnGKS374+d8FQDQAA5yTdTP/GNa6RYu+d8WSkPTX6NEi6LoWVfB0lj7ZCp2Rod7kbAlo/+UkZsgVYaYErKBkqF6wwjSo2S1BXo5bRVwbFolzNKCy5psqveTRIlolnB9/5zrNFcGW/dJ4w4bazJdxBPfIKhmZtukAFVjMVErmpHAe402oG1RSR+oNq86YaMS21lyoD1cqcipJweSaDIbklPLV6xgvc87dRM2VYxBrWf15yVkJTa0GHRrSEJnSudC3RFqILUONNFKPJ0+qyBBtMJsWoJ7HsKLaol1UIdotAV63PpbxVpHG2jDJUjG/4TGAlsupAB2T4gymCMS89rue0ps1YeXAazZ+WJ1GW+4QauLD/hAYrIWdY8khImlpB2c5WgqfDrUhTV7byNvK33M2nV51mXEsazb4oPhaw1JrWWxl0rQeVK3XjesNR4jWS1kWQCLYLPfFuLVpbU16QqTbYv2b3sN3ibQg1QzZLXWqDu7RJlJnKspTKd74tqq99zTDTzariF/5VBTWzedo/JUqnCDbPMgpiTYshmBKasIMb3LAFEbgABmR9MN2QirZCquypLlFJBgd9OvOCRpFLrOdWtaaBHQM3uAeSZK7CIsniBvS4rsIZhzh5ULQOlFZwnbGoTaSzU+6Vr0a+1lYLC0t8phrJWvUwBnbkzvRmcMoi7WX37ilELLfLCfrdbCzA3AtFTPk3wZRLc7LHLBCJ+JTN0J4EGXvbWzzr2QlI1YEKIhBVP/cnU4G2LQdrTdImn1e7jn70RPe6mn4m13bGTC6tUozpJPTTrCtG6NB8FxAAIfkEBAQA/wAsAAAAAOABDgGHHg8DJg4CLBcFLiMONBkIOCMNOSoUOh4ROzIbPTkiP0AqRR0HRS8hRzQbSCQMSDkjSyoUUTIOUU0zUx0EVCsVVicLVi0XV0QrWS4YWTokWUszWWtJWjMbXFw4YB8AZFIvZTYbZTojZoNcaFQ7aUszaVtDajskakQrbEEebGtTbjIKb21SdEQmdEQqdT4ldUkrdUszdZFtdzsYd2xTeEkmeUMaeUkzeVQ5eVxDeWRKekszeqJ8e0Ume0Yqe0ore1EufFM6fqiCgT4QgT4hgk40g0oqhEkmhFM2hFU6hV1Dhlg3hlk7h0UOh0oniEcXiGVIiHZZiJh3iVY2iVY5iWxSiXxjioZpi1Iqi1k1i1o6i3FNi4tyjGE9j6J9kU4lkk0Yk15Bk52Bk66KlFw4lWRElW1SlX1kloZpl1Ypl2M7l2hHl41ymHdXmVUbmZV3mcWammpGmoFem2xKm86mnGEtnHFLoV40olwcol0lpG1JpG5NpXNLp3lWp5d4qGEeqGk3qH1iqKN9qYJcqYZmqmUoqqaHq45xrHE7rMOcr52CsbaVsc+qs2wrs20ztHxVtopmt3pGt4VYt7yiuKeGuZNsupp1u3Mtu3U3u4NJvKN5vOK6vYE+vuLBv5BewXkuwX9Rw31ExHs1xXw6xZx1xqN5x304x4lWx5t3x56CyIM6yJdpyZNqyaeEybWSyodGy4Q7y5NZzN7CzZFNzryizuK90NCx0YY90adw0o1T04o+1IxD1I1J1ZJL1auG1cOc1dzD1pFE1pxn1rKL1uTF17mV2KJq2KV22ZE/2ZZW2pNF3JVK3ZpT3phH3plM3qFb4JdK4r6j45tN451i5J1T5Z5Z5aNb5qFO5qFT5qhb5qx15t3F6KNP6KZm6LeH6M2o6cWW6sF+66RU67R467uP7KVa7alW7alb7atj7bJo7rBf7+vO8KZZ8KdX8qtW8q1j8q1q8q5x861a9LNj9bJd9bdp9rp19siV9+S6+LNe+Lps+MFv+tel+8N3/MiG/dOY//3nCP8AZQgcKNAFQYMIDx4cQoQImCRgGoIpQ4aIQQwVVMho4qWjFydDhnzx4sLDhJMOKlQAMfCKSzQua8hUodHLHz2NcorK2QhUT52XQIka6krZNGpHyV1bGi5p021PoUYN1+4pu6vllGqNGu0ZsFyvbOnq2hXpVqfr0p5Vy9ZsWndw48WVF9ec3bvOmpW1m68vPbpy4f71y69w4X780BVDx1ifY7+QH9frexix5cKM72qe+66z4HeT61kebblbPdOT4anmdq51tddMYS+bzUvWV16zscmmXTuvK0u5XKPd7HbtVKp36aomLBqxv37+okOPTn2f9ev3vEW/Xh2c9+rct4P/l35anHl74kufJj0u9HL3ds16Jqewfsj7PXgkLHh/yiNUvaACYDenACJHFiXV9FJH+JWE0gIqVdASR0aAJJMMKnjA0B+Q5JQHJB36FNSIJBY1XGzHXSXViilm5eJxZIkVllEnFodVWy3i+BZnuvWIIlN0QcZjkJRV5lg6SKIjWWRMhlbZZZ356NpnnlVpXnPokeake6sJtxRtYNYmZm8+8kamM6kw8opueuW2lY4w7qXVZ4R1Y5l00E2X3nXeeHNPeOH1c8t32wE63nP9XCmOc88hmihp6p2m2pWtuTnYOvbhp+lGmYYkRS/3hCrqPqgYyAJNIBjhEYX4mfSgSgJV/yiThRdmuFEeeXj4064kljIUjVa1yOKwwgbLVYxhiWVWcTZWpZZT0J64Y2B4xdZmXuQQCRi12jppWV+sNQZfk4Y9CeWUm1nZmpXNQdrPOIhROh9r2IY5pitF3YaMmfjmm9tOqeiG277SGvfji3RuCWmjeh7KnXbcWQfOoN+IF/GhiHrrbmLtGsllNqtZeql9CIVUckgLaToGqKKqo443vTzyhAwqKbgqfhgtAKFKILDEA0iqcjSQrU3Y0QiuIv4kYomgFHwwscUi/COyySazbI1OR+t0cs9a43U0een1WpB1TUutwpitG5m4zJVrLmLgSknlvOeAvNzGH2dGL5sEt/8JjG39Bt5vKoQHPjAvlxCSiplawxl1wu+Nhuie411sKKERG5qeZYpKR16iiyIGTqTmdckNba3FjXLKJ5vc4MkVgsHKPerQXrs3xDySBQgR1rAgg7K6itJKsdqRBxhjxGQQTSEZnxOIPAlF1PTPNPu41FC/uRbVvo6FlJxXO9649do/5fe12fJIHF9FltutkKC1PdnGcKOrNtl00zMZvKShJinI9Dpd2HgzuMIly4DUO9M1XEEIP7xiGbuI4LXAJ74cQW5+C2uYxRzGHe/ww3KZS09hvNM5R8Vrf6ZBTHu6YRoA7o1g9yOHRjq1KVnVsAhDUIMwXEa7UO1jHLrj3QT/bAY8VfGgAhDaGfFUpQdHOMIOyVudEERihw4BpSdLk14ygEW+qF3vRi86ild0IaNSeK96YMPR1uK0Rr7pCzd72Zbj0teXcwnGPfgj0pbeVr8eTUld9muf2/LmJXt9pYBkBNwbFYitVPjBgciQ4Pko2EVjJYddGJScBkF4sUSBo3Ih3BNmSgepUaLNlHp7DRw/Y5eQzJA/N6zhfRgEh270cFTQoAQZhDhEjsCEVU1wUBKJJxAvkEEPebCD0FwpEKNBwmi5wkn0sIjG8H0RjCqyoBrRuMWw+IqblAynGisIo27+jYvTsiTCBPmXhLXTnafUUmr8GEO4BPCOGNwSY8yT/0o33stwE3QTbAToJkcSYiySBGc1vRis9anNWyncJAcj9o1bTFRz5FEUpMaBGv+V5114fKEE3/ka+8BSU0aMZS1FdUsgwoFmJ1GBEZL3S+D1LEM9O6kracLTmkBRmjzBoohA8YmFVlKbyEFq18iijGSU8YxGvRolyWnJ3dxGXwcrXxjNoT/3wbNKg+nqafRxJbzZb273vCAh6cY3vdwLjs7QzVnLBFc0+QE4Y2qqXqM6R60ONFyYtJPkKEdYcCjpotbZ3HMotZ4T6rM8+ZwnQcV0jbJhA2Wv1KksZwm8NNiSpX8ixirkUIOa+W4MY7jJTciA2iNIxLVZiCKGTEJb2v/KFIpVDKpQp1fU8V3TWdsEErWWOkZfhUIUNJIks/hKTq3Vy61Xratfs6pHsMJvbuTqmNv6idY3qfW63KWrQOs5L9r4qxrNsITiIrnX9jL3tzbCbibvRNj03CIb6OEgYU9ot/099rEsDOlkR1qtIWS2dZ4qwhRkCzyYoAG1exgHaEMljNH6oHi4+tAeNpzhDstBDbiKyOpcwFMP3PaZHJqm9Iha1LQ8Db7EEaOchisXGXfzuKGQIEKxJs5i7QUq54vuBA3Gxmz5Rb5xw67+3uOYjYVXfX8FpJT1Nte0grUuEASoKhu4i+8p9MttHGdx/uiZ0Ay2vovNxgcnh+YsQaf/MKxZjkffQ+fQBFiy36PsWph3YJUd0xF5EMlEOuwIU6ziFPYY1Z9+SIk9YAG2qvUwHFhLaeQhb8FSCMnNeDoE4xntaEBZsXN9q1XgWtbL6OOWXZjqVOMidMcLdTFTGxdcG9sLLLlgRqqJTOsku/PKXy3r2/JR5XXFZ8zGzoyyl13s9NUzPoe0xFAEKoo7MIKbffOKe8PZY61ZuczzZbOeEjOo6dDXc5t7cz36m7dJ1bnOeGbcbq6BoQx5IKclM+aHPtELAzWxF6swhsCNwcL8UpQUgEZtGhaOqz/8QeGxbW1DJq7gKHpambP8dK5CLT1rklq4ZlM1tVgdR8CYr7ie/0j5NPIKTlnPOlpdOxbJzQkWXXdbxjgnr5KHZN2yRhRK1UrXC+VzVuU0u9j95IUtLqHeS3gvrroJxR1CIdVtK9TL6/jxqKdKjrRqzG1QusUtmvycNaPn7Pa4k7rFzhrIdold8HY3vaALDIHmhsQmUQEINNKfffeCo6hA5t85ysKCG9w62hHGI+rAhYU7Pg0PRm3k6fDoBeHQJVPoiPFy9UsqfprpROmt1qcW5nTN4/RIAu7LK0uXeT/DuJ5o2jTMqG1lyN7lV//4zKOrL5sXefUgLzrPd86lyCaZXqeuJD3tt7coV1lMloi+08W2LEbgoRRmIRguwJz7qts6oAVL9v98+Ve/YsQ1cvRzzrmkEb+3S2Md7Bf/u8ubSOpbSwY92zssqxhwaKBnHKP1CQVHeByFdvYVCZP2eI2ncJHXeJVXeRTiEhyRYVDkEULQBnjgTL4iFKIHfB6oTqhHYzH0JR+IarCHXEKhC9tXe1hnay64dTana7x3TmIzLC8Yfsk2fDsnD2NVJHb0bcbRfHIzJ17yV3JlP1lGONKXCnXnelzmfd/HfaN3gx9nbIoCYPTkJIJVGma1GHQWF+93DtQgHGojd/NhXk9nLdGAWfiWQ44weNDgf8IAaKsAL/vwfwbYQfbQDQiogHRAeQz4aBJneRG4eRXIICOBB1j0CYxYa2r/SGqml4NyRFxcBF0rt2Ky1z17dXtUuHVReFU1J2SeeIPedXTCt2RMtl11YWWyYYQNpT2u+BrIB21kpITSxoS4MXe5oQuEoCbvh2pR+IEtN3OdeDWAdQ7j0k5QB1jlUhorNEoBFgzL0HbuZ4y/2HWAhGr194jTIBAmdjJvCA0c1QvkeAoHUocFuId5mB586IeT52BY8IeECEw2YTRQlIEeoYgsdo0x53HZE3IhmCQCmUerNkm+Rw24MBTGdYnHFUGgsAtCIYXCSIwyeAwzSINa44HjNVAOhXSMAW5oc3wO9WIkKVX1IiVZBnoGtJER9BqlYG3QIpGdKJMy6XHFJjYP/yUZV/hfwUCNXdKP8XWN18he2+iCQ7B3M2QQYxAMhPcJx4NMYwAHlPAIfBBwhreO0dGOjweIkdeANSWBNtQG9XiP+Gg0DQlD/lh6AIkPIjiQ6mOJ0JUWn3CCR1EKt9gVENll0QB/tUeTBplXF1l34DeY3adUpahz5CJHz0d6J0mCuxgm1BdtoJeGsugOSKFcTQeFfrkXXwZrNWmTSAhX2IhJ8/SR7pc6PwmFoyhGf5NrXxNQQ8MfAiiOvaAHJZEqV+AIqpAGMtUJi4KHdgickfBwkCePDvaOxukSI2EhF5iByoSBGRh6aMlrJAlGxEeQwjdAdNc08EeXPqEmriZqrP+5RZsZZIEpiqv3mcp3mKfYJFAWYyX5mJC5ibVhi0EhXXOCkN2EDFlHCG0gCppZnp9InlZHkavJXDrIbJV5hgFaiTK2guj5mnqhIUmZQ0y5h8aQBxkyASCwlLfABRKCCd2AJ91AcNPxf7BwCFvplckplr+jnIqoiNanNA+5gmnJUEmlano0SEcSiar0T+R5gqLAiDOqRREJTg9JoDH4l+51VbhokRFqoIUpcxw5hEQ4msCGPx3peoRpnv9UOJPZDHyhGazhFQ9Zo6fjn67QoAKKLJ5ZoG0KfssChEi4oCaZXEyabWISitrpNxlCNEMggOoYDHpgBCYhA3sgcIcQoiP/enakJB5a+YeU15XHyZV3QAeHkKkqiYmihqfr+UVIxqOSQZAkuKcpuGLSR6R34ECnSnt9+WpK2qSACYq4BqWhuKRwiqurGYvLN4sJuqWMOZizii9gepasx1ZmeqZdJg270EBdGqduGqu5KpHqOae8imxcanWHI6v1l6c0YWI0YQcER4CqcAjBdAW+OYc1QAew8JtpJw4C95uLlaItKnnyKKkOByL4YgqywIj+WlTY96rvhaM5yi3dIqqjKkf84k12yQgppyafIA2g4AdfwKpGqkUCu5/DGpi1mmuH5LF5Wq27ypgc2ZYhF3Ri1KdBpkgFtAkjMhbPBht5WRTbt6zV/3ZtbEqtAqssuyet07qZJhm01gqMP6tXEPqxuaayNjdFPWUHg0d42aAKz5QGt/ANgtIJPVkx5GF+oQMd4kCv+NqLvehwmhoUNKt9aImkcFqdoJpH8sOjYVVjBGSLj1S3oRCxE1uxWFSLZoSxQVp/57mxK3mRGbu2uTGyJPup0+WYTDqDB1Q4uViGwkGU+OKpEvufRFu03NdqZNSzPvuz3eqXwJhzmZurOma0OlY1EppXQvCnU9QIAxhg2fBEIvotpZQN5rcY/9OvmkqjmPC7wHu2aKun0TCXEFm4XLe4AMlzYtVkSyIkAlOfKTe90ac4jGiXesupChmwnWurtwq44P+rSIPbsZ8rq3CZbXbHjemruIsbsk6KSPmCDaZZXlkmQSaCkA/5ftYXsAOqs00qFuWruYVbtGAyn3A0wO4bqxHEt5PEsq07Ra/Lfu4mDsHgE+0qu/H6kbmbF8voDLBQv7iAC/5qOLYxvLaWiSjnVGPUuWoJgjoYgl3VvHhkckm4gah6vdb3BbslpNj3vTLSvZXruB3rw+RrvkbcpYfbmPIJc8qLsqW7ncRqOOc3v5NLuSt4OkKBCxL7hE8swJsIwKgbwEccxixXe0frpdwqxmj8t6q7xhA8RV/QNNyAuyCDu0TFtfQijQU8vNvKxwtcs6HbxbT3wwB8q2GGIiabyO//457Expd/3FTSUwpz6Z/Zi6rTG8S0OsShWH9VU8Q058lj/LPpOyYhHMLV84tZc639m1cHVMLyS1JVTJR1JbG+ghQT60Co7L99aZ4/HMoJ1V6/HMwIHMzgq8a+/L6Fs8bAAMFf4ExIIQ09OVl87Mezer7jmbrb6rPcW4uca5GFvJdUpU2KfEmLfF1eBsih4LA7gQeJaLaWbLZAXKudHIosi0CdLIOEDKVHXMY16Kl7DMn8+rulHM1CyCLri3OsJst7CrKvHLciZcCXeaTIcLOf4GLE68XFNSPKfMzYzNEaG88gPcywGtKtTHe8p85ENdB9k2dpi6dkLIrKZWsL7Lj8/0sWSZrPhKwsI/d7waeDDlXO0CtVQtFAYsvOU6e9OIbJ3GxAm5wL9fy4Gn1j86zPxnzA2/bP+AIiWs2vsAAL0RyfSYzQ5zurY8g2qSTTgFnDNOIJMPkO77e5w7zCvZzGHX26dr3Q1UzXQarC8fx6Iz3AIP24ghmYKW3CfqyZghuDsNqZobvU3LTNOJ3P2MTTy5vIkQiSR4ZllzijRb2qPQGRlvwr8QzVTU3aB0TVuCbYIPvReQ2nfExUHAYijMjVSpy4wTifqCO5Z23AgDlUBNMIOvzMn3DGZ7zLxu1qJM3aM63cIa1Xf13XfO3YZzrId83cow25eG0b+ozKNpqyMf9iNWLN2IZczNUk11QdyeD9qkv9VMmSyqQ7ziY7hDtomRHNCEFF1L3YsttrOOstz7Wo30zNwh9rz3Nt3XrdxyHsCpCwYQuOTE5UaB+cvkKIDHrM0uz1zwu6HLtt0hvbdC2Wt40Qk3HdXpTrauYduCF904mU3COd4oP8TcqaxcLspdf9vYoUXXf6v655FgHl3LV6zb8M5Jt8grK3wnLN3oRTPRVEQfANrOwJZbZ3yccVPVyd4LxV46lt2qa92gNO4B6L4oTbx7xhCluNTLgCaHsQ4XhMxXR8Ono8zRde1v214Qrd4ft7yiC+LDNuzJE81WC+4oAu3SwuxJq43jB+4ur/3eJd/qS51snaPbp17s0PJHPiPSOlutzAot6v17eHvntarnJi9t6VbdkwcqUOJSI2DDBEUcoJ/rI3nsmajOT3vJ1e7smvHrhjHcJabea8vgeYYBtdjcd2Vsd0HAxvvtJJfIxUpp3Zvdy/Yd+xB83U8JKY68gebcpmitxKbevS/clmFOgFjuV96+18+9wvDcni3t+dnOPeflxK3sVu1d5KkegHbug13c3d4+VLDs6jXjYiWCbD8XzpnNScqt+uDt2wvnS1PtjxDtUBLsRBvMklnNaRpOsP3utssGGCIAi/HglePXAgU3iK0hkutOZeaJolj9XbDjivkDi++H4TTbFU//d+xc3R+z2zsV7uunDT6K3tfi7o6s65MO7z3865zcDiB3SXOn/rrofaSjjpWbHK3Cym2vjRQH7ij8tNOl/urpZ8x0KE/t7k88armgEM0Ufgm5AmoKdb7lzdHy3rsz5rprrwYUzgt35OpFzKZH7xGK/xfBAJHq8Kgq8Kt/C0It9CpUPsip/43JC7fgxQg+OfwCHtE42B9z7idX/JrvDikd35rQz3kv7ifg33Wq7wRf96qF/oPN/D2OedQz/P2SrPT5+RTCrvVU9zrHb6Qc+zqcvpZZRj+54UTf6eY2+lZX+LLD89TJepMJGIhyDQVY7tLw2/jW3hyU/3pjrEt/7qwP/Orw+O5pP2YR/GYQwO+IBP+L0Qr4evKOyf+Irf+LTxwSyL88RqfQf1zAjJCBXbNNIPEKWeJSM4UNfBggYHgvJUyuFDXQwd2qL4quJFixgfgoo48eDFhQIjEtSYCmLJUh2fOVwpcCXCkQRPbmSZbCZIcuGu7YzW81guoCYbNtRZjqdPpM2UdrTVzCjSgrtgDlyoy6BLlMmo+fw40uJDgeverSObU2fPnmbjrWXb1u1btdbk7qyGzWjcc+FSMUqF0NVXUZcCX2qE5gsTxH8wmWKMixcyyGgjP6YstevUXUqXaV7K9CZmV7KCjj4Y2rTo041NOWKtZ49rOWViw5bzeg//a0GRKKladcqYsV7dhHfLJs74ceTJi3ML1hwyLNSnTZtsdIfQJVzStEvbxYiJH1DSyIKiGtX8+YWWJjL0DDgjSvftMc7/DB+wMppgo7Fcn5K/xPyw8u+998w6qjOghvIEmLLO4kyZ8j6y6JmnIjTPqqs8wvAnDgGLZh2D2gMrFKveMbHBaSTTyR0WW3RxnhddNGfGuNAqyi613FkmFL78IpCwQ/4gxAvEvqADEkw4Ci07ZIKJbDMoIUzRQggpi7Iyy/4y6T3LHtOSwC2/5DI11RyxbTba8qitDtd0e2S3UXoj5bfihkvOTuWyYa4Y56BzjEzRqsPDEleo2Y477/AA/2WdT8iL0FHQqpSokfzkA9O++uh7KSVLw7y0vwFH3FTJm0QFhaMBR5vQwQdHs0S9Y1CckplWO3yFmQqrjCqoR7m0dT4Lf1RQrBZltRGuGOVBFkcDU6SrLmhZ1AXWLEVxD0ghD3MCjUaC7FYwx8I1dJnmDtXuyc3GjfLJPyW8r0t3+wJKlui+BKY0xlyJpMwz04SND4AdeRPOOH2j0xjheqnTTuEWXi6b35rjzU9cVDOFoSH5guxQXPAQ4g5RUrTKUVTPA40Rakn9dOUAMQXWJpJaFhZUANcxtT+vQuUUwATBvOtAWnseKlZjH0Rw1Vw7i/lXX5nGSZl4Rwyr2KJptP+6LWWzhtEtvJx9NkdyXKG2WsEG61ZIIlXY9grDvEDDjm+RPJXecOtG90knm3QGG2euhNc0H1UVfMx56Q6tMUzMPJONfwMWeGA5I/fNYDq76UXhhS23U2E7I8674nwJa+O6jTn2GOStXtqQysyuQrkhVGVmWXaWS9qlVE9zl71Snq/FOWfbf56Lq1cUbKropIL+CenkdwUqxEudrol4TxXUKkayvAb76mS17vqor63m0a9JXwWy2yHTlsGJJth3vw0v7nh7fri/JQwSwRpdkkm8g+Hmf3VB5m/Sed6YppORv+DrcBdDkprgsKaAAQxykivYKoJxilM052AQ22AHIYb/OQ6Wi2IVIwwaIPEYc1HDFacLz2Rgxin0LIQQfmgIfHZ3Q5zFR0M26Z3uriUimfVQdlG7CfiGtzzqEOVGKmoeaZKmq6UdI0MvGxxFoOi7oUyDRWXZova4xz3vUe1qzQqfjphiGbO9ihEz7NYYDCOD9c2PSIgRQh3rOIQvECmPbpPj24T0h0NcQm6bSBLdBPg5dnkJcEis4qWkwxi5OfCBEZxgb3hTiTjByZKrOFgnPflJT5aLO6sAXWiclMIVfqyFn2AdDHflCT/wJXY4DKK1bKnD6AkEd7TkJRB9GbNdLnFWMlEPtYzIxAhlJC1yqVWHOOQ0Z/aMIkq81zRHVMMu/9Ylm9vb2ozCGMYvkjFaLVFZYF63xkGhrw109MIhkhQkw9DRjvN03/vyeE/45RMPdOAnIO8nndKdq0qGuxdBE6hAQDHQTA+EQ8DeVMHdUGKCEZ1YnIwRjIgZg3Ke4xOfOKlRC160XBL7BP8CeihQrBMPTBpmAZ/plzXKsmW33BJNwVI2m34Jd7cLFU91qjMs8tKmLSPitYS5DeKZj3nDayIjmUorKilTeoS7SA2RKs2HDGsszuIaN73ZzWWF04s08sipzLnPGVrnOocwjArUdh3ElfBt2qJnXZlQg7viNa9OwCc+38ZGSlnLpH6jW0EVScCEJm5xfBgEwQb2WIpesv+iEpPsKEB6iwpiEIO/KZhIR6qdkSIDgChVqWhTBz2XRsUS1wmFYAE01JoOFadCBOrsavvDALVWtzPdbW+tubPY6s5BrGKkvJJ33KMttalSLW7uBje0rQjtIa+jUPa0+NWwfhMf2xXjjdhSxnWohKc82qd14DcoULCVCWrj1v7iqk662hGOKpABfWtQA/uys6/65K95UYYkdO3NGXwSsDMIeq8RWgw3AAMEICD7iAYPzE2SjewmLVzZC1eQN5Qd6Sk/S1oh2EGL3GgpaXzEWtmmuJa+hS0ub0tbFff2tTKm8Q5puRXtRQOaUoQqMpOr3OW+tHbPXZBOpNva1TJCF8b/Ooc86PHk7zIra9jFnlfLCBEApVV+o0PvJdYpg9EdorADBFJ586mt+MpTv3S155nz6F/zERLBAS1wnTfzOeiQ8k2DiLCDG9xnCTY2ooNWxUQnm+EMv8mSnu0NLPT8Ye6EIjHSgAcAiffSg8BSPX+RSEc6XbzZ3rLGomaxi1dsVlKHOsXFtOWobavDowYrtZwBWq9yIRfrSkZ58pqqpwQHXSNfE52hoIa0HnNdKIOTytrd5va0WY2WeDowWuYyXz5RnTiKmV6ElQqqv3U2Npq5v/C7KzsRM+57MsHN1gnsJgxp59GClsMQjiCD/xwJQfNZEPre17773YkHB5zQEn3E/783OW/VfBYZjeBrIyi9VahwSFKNkOmXfhrj/OiPVAd18cUzzrvgttrbOI2zqkGOwxwPE2pCvtdTm6lM4S13Qlh1rolBXWQddwTJnohpMox97Hg8OR9DZ/ayu+rsGgGX54UxM3qlwnB1UwoY6TptVKVj1vv9851/EdR+udx0N7MZn2r972JOSunRXnDBsrG3vt3ub7gH2t8Cpzu+A3YbUxycspBkjIeDAXVCBKMela66xKF286ujWvEbR7X+MmM3yFfL4x9f/OIHY0vLY7zFk/dhyqnEch/v2onsGG7Et9TrmgcF2MTMKjpvPaMqIZvoQi96lcX5xWnQjOJmZi0J8f9wmEHJgtY9Lk/kjQ+dyTwnUIE8X/PTCHY079WvKAYdRjWosNbogQ3bb3uDBXbvfdubsYPAd79z8+/zPxbfr2Fom/Q+sdUknDt2qKOIuzF4EkMRmII9JOQTCflxOZT/GUACjLcASiSHQLWYaDxOa0CayLzLi0CTc8Dfyq3SaypMcznlKS6iOSbqmTlVSb3nKpGca71h+5Cc4AwnG7rBm70pq70xsjKaIa/4cTpcSC9tkTqqC71ZSZG72UEgDCArGULO+JM0UiM/sA6xK5I38ydHaIzeaLB/4T7w+zOAocJ6oyTymzt+Uz8+gAMuuAEgyAIwGAMycIQM4zsoDAZTQIP/OHIFeCCO/AsWcFmGAkwhAyxAE6k0PuxDP+zD//lDQdxDQrQ0vTEUv2sUjas8RqTABHwFBXSP3LnAZqqmeQk9S+SSZepBZmIk6amhXKopCtGOEYkp6ygFaOlBFhk8fmjFFvwm2uuucQKgnHAH4EEyLaMUVsIFWEoMEtEMpApGlxvGHZzFWqTFuDCUY0xFbmvA+0mrdWJCvIKfNMC71ZBC7cNC8WOw7WMTbbS37+tCB9szQCgDHDhHHDABG7CBcyzDhrIwxPk3WIiEP3ACvDqEYri/c/i/BhQteGBFPnw4tANEwtNDPlwOSnuYh/FD4aiHhnHIcYhIiYxIgBw8fbwT/30EoNLpv/4bFywxKEf0FM9TGud5Hh+Dpk1sIqryIREEtV1YB+0gp6FghNHxhABUxXpwRZ10QaF7Re9JRW66xcAoL138k9MBmdYRRqUkxpTzqu6xvSYbI2SENighoU1AQnJjwjxYsLsrA4BxjfHrRrHsxjr4RocChHD0wiRIxxAwgbbUABJwSxewgSngAjRstMZgDSRhjUjYAzq4LzowBeQoBgScOj0UKOUrqYpRRMVkTMZUsMbQm5Fajn8cjom8zIi0h3Gwh37ITM78zMzcTMx0yDs5jvtrwYD8n9CqG2cktqUkvs9LCNisJg7ERKxyGuPxtapyiewRNrXiBR3hxP+gy8mdrEjjdMFm46Kx4Aj8mC5BQS/IAIUhMRKOUEZmeU2mGiuje0ruhMFzmEp1MZyr3L0/sMbs60YpZBx9u0Ky9Eb01MZ8eyw/AwIXcMsMYID7JAENkMu5/IExuEu8jITEGVDWSAMjUBt8bBg9yT/lM0KGaL7CgBsJtYN9olA3/AI88oIMlSML9SMH4suS6rtyWQ7LxMzQ1EzO3EzNxMwVVVHP/EwY/czOvL/TtMjUbFBZoMRKjKENpE0TG0VOzEQNqamh6Tgira6VKB908oMlM5DYI4d32ElXnL3jRE6vup1ucwjy3CdRyI5GAb4SSc5tiLlhvAvlRJat4a63SAf/Nm1TsMquZaxKuskzUso+K6TCQRjLbtQCr2xPshy/+CS4crSBtrzP+8TPDEjUtmQBFsCChjIFCeu37LON+6KBSKAT49gT3/u9NLMreqIvO6IvtxICt/IAD1ABU3WrUYWjIWhVt3GjMciDalSTvQTRvMswDrsFj7I+Xh3ROskchcyT4iBNYkUOdMgGTIxN/TMZp6GQIK0mlvyKGirSaC02EGmUnVtS13RSYGRBKT1WdKhSF7xS5nROomyhVPqCkPnO78HOpWwHNO1OeX3TsBIrAZPM3uBKbnxPQWDPPZUNgA1YNYCg8YMsNhgB+zxUBlhYROUARdWBLLgNie23BnoN/0h4DSyQAQ/ggT34KFV4p+lEDFVl1TUTAjZzVTdr1TpSVVQ1VZc9VQ9g1blsH5o1gvZpVSIgAi9wR55NAzM0wz/w2VnNg6C1A581WqEtT6Kl1QFNEkJyBFBgjQWSPw0KVmLkUWVlVk18VsR7tfcAxdwBUplsCJo0kibFMSYizlbsB5+kUm8lOhaxVhmBFBM8xccTBfhRMu1o13YYU6U0U3gNXDWlV8Ed3DVtU8EVK8DFvQIrBpDSV26807Hk0+371zJ4AjBIgswlg4F1DUEDmCSIy7bET4Yt3QZ4gERtgSPgXAhqjYvtlzwwggpYABk4Aj1QAzqwWfwa2TiCM1drRP8a/L05IlVVTVX7klkeQN76dAGVbV4aYFQeqNlKfV7nddVKtV7dZZua5SPthVVYpR8nlJvXnM1lZVYfjSIea54kai2XGTKW6M0ZW6OaHEkBY0G2bUVwjUoT6clkO8ZiCRxcTELSucEhURTrrJHFDcbEXWDCZWDDVbZyiNcYnGAC9KiC28Y46Nc81dPLfQIqoNwP9uDMXUskuIEXOGEYQII+fQIc0E9FfQDTXVgIQICFTdQb4ALWnSTY7ZcxQFW3AgEfHtk8QjElaZSN/MGBEKDKQ5I2ahuVrS+WZVnlXV4qvi8ZAIErnq/jlVkuvt4u9mJ7tOJ6CmO80qt6cptnLV//NTZf9JVN1NqtXws5OXYPa0W1ALbbr2Gm+vXW+81f/V1BQvTfE8HSLKU4bXUML7sDS4CQcfJbBk7gR5bgYnlgCY5kSP6qQNxVrmSD8Nu+Dbbcyw1hER7lMQQCGGDUE0jlFDZlVXZhGC5dAziAWDYACLDhMRRhHWYTv0yDQ6gD1pUCjXXZCgBVI9E2cblJZE7mZWJNx1REJDFaw3jiKAZiVq3masZi+6Jm/EIBa67mUf3mVWXVLb4vMibnbbbi+lofJ/DAHsVaNl65rZU1sG3foNoI6xq5JVWydlUKbAjXtcVfdGBXPRSjGNkQLUkytbo1sVFkEuyavr1kS67kw5Xo/4g2U4H2poeZmO4Lv337ZMvl0xBGRxIuZRNO5UU16VSGy/1U2AFoaZeWZfw8ATHEYRzm0/YTWjhQ2tiFYlZlG0YwuwBT5pEsj+KDvMZ05iYu51JNVZdt2Shm2WEe2acu3qkeZ2tW6i8mWQ105zU+3zYmatZjX3peMVwgFsVbOm094KPaGz7Wh4AuMEzmTvzIDJ1DaBqCkCTDELVe3IpuYIqe6L7m62RpsuMAqU7Y6DjgZEEwg48GaVFGRzGM7JI26Rd22EQdAYR9ZQRwaQHobAKg5QyQ6cimaTa56UMgbTUZA5v1aXdaEqpDW7WGbU50ueMLl2aGBEBCm+GlJ+aV5v+q/u3irYAIEO6onmpxTuduTm4h0DWwbud3zsCvnhXpGusbopDltGNTxOOmVEF9KE64FmQwOocFvLkkHJ1CeQXqklvSC2z2/mvAbm+2CORVNI5ewKxbKDi76+TF/lfH9uBQpoJzlGzJJoHJtk8LOHALQN0L0IBXluUBCADP/uyYFnDS/mWcllCipQN/cm14a0rkSdbybZcsaUAG8ha06dAO5d48wisa6FR7LDe9iuLj3is6Illv9mZRrTWSfO7zNUnVsqKkhOd5lkSWzE04Jpbc87bsJhQcizUoebKdfGscAU9iiVuXMELCKG8mH5+zfW/4/nL37uunjEOI0Sz8jjv/T27sEH7syMbskj7lG8DsE05lhz1wBc/sheXsliYACc8ANx/tgQ30pAVapo3MvsljD5xtquDBrB0gxHLGUxkkSb8fE/cWwKr0mEKn0TGM6eQvPkq3Tk1nUgVx8tXaWYtukdE5I7WhUbNWB+WRJQ8L7aS1JpvSi4ZSpxTvKz/o1bJbnnIKKQNzLxdzvxb2N61Mzho0ctzv/WaDD/5vaB9pAYdz/ZRzF37h08VsBk+AlgYAb9fzCadwzKVpof1Zn3Un5IsMJ9dRH3PXRl+5SEGoR49HfXEFSSfxfEk8scEffieEfqpQFPf3tulUHedqNj51kNBrIYdj+ACiVt8q7I51/2UASjKlOih361tfxilfToMmb18nEboodmKHC2Mv+Xil7znBLILL7zPg4Gf/b1Kedjm/gNCu9ppf8Fe+gBLYdj2P8AOI6Vb+Af+saXIvel6GBFMI6u1mdGTaaoPvcdqsF4D6yEeXChGnembui1Rw2ssTpK4vjOtIK1J3bh6H9x9949ysQN56+PGI+HDjzbGqNXPg34DO+C+6lVQHtSVdpAgW+Yj2e5M3XGMvbI0ihUwQ1E5W88cmYciOc8ePyxNIVJyffIV9ALhkWD1/cFpGVHUk8FU2eiwg935SjG0LwkQHkeFC/aZnd+TqaszQFSDc8XCB/Vb5SKyf+hEn8VNxev+yN3WEP/tmaA8jN7XeqrF7ruvsvuuUjDnZXkG4tXuMtnqR4bosZ2jpF2yTD/zt+vswn2/iMPxMIsfKVXwPFukAn/aSpvnKfmGcV3AYjuWXfukavoCgH/qiZ5vQfxufRXpYAIhl16pNKzgwGkKDCRU+WxjOIUSGBRtSlMjsYsVkGjcujJgwo7JmIUeKLGlyJC5eyEzuaunypauXKWdaxEjy5kZgx3TuzNWTo0afuniK1PWqFNJQSpcmberUqSWmpaKW+vSOGqisSRsx6oqHECNPoCpSW2cWG9qDzgQuO1eP31t38s6dU0uO7rqrWc02NKqUUZs7l1wOLDev3WHE+BT/M07c+DE7yJInS15s+TLlxnLhdetmbFQl0KApCRLEpg7qOFpWs2adBMcN2LKRzI49gsSJDLp389b94ALwCwgGEC9e/AADBhwukABx4sWP2FymY6l+5br1K3T+YIK1suY2shEfkh9vXmL5jiDPp2+v/mPDsesrZqU/tv4z+aD4Tvv0/iRFI/2UE09C7fTMgEMV6IooDToo1VMRStgUNXpB1ZVXYJWikUHmnFUOQWqx9VZc77hzV1llbeZONBuWNdNRlhByByGvENZOOJFlVtmOPWK2o2U+xjPkit0Ic8pooZFm2mlsxHFaa1RI+UQOtclm5W3NAcfbA8l1+WUDCQx3/9yYCHip23MfQCedEm0egR2c120ny3cesedeeO2xE82H5fmJpzWB5rkNeTkWeiig4M2HkH980ueRfAmt8x9COAFFIKaZKrigLRNC6ClVEpo4qVZbZaihgip6uKp7zsgDVz6bpZiirPhRkx+DqchIoygtCQQikEIKy2OQwxKp2WbZfEYJaWw8EtogpqUG5ZRlTHkltliOUEKWXIIZ5gMGFCDucQeIe65yujH3XHQ3uNlmu3BWN2ed6N0pHqGROdRnYSj6q2++AQNrqF0EI3qwovPZGmmLFCHFHnwAaorpphNzehSoD2bMVahV5UVqqTICBhaG9zXTL6v+LhMSOSTKFf8irbW6OFGnSs0YSky8GGpssYwNzHPPQSMr7Ga3MGsIH1rE8Wy0T6aGWpRSZovDa9naBgMJ23rrZZjjkus1AWGLC0ED6qYZ75vvFhEvHdYRAgky5MwqKb4B34vwz//ibXDKeu8NccSNOjofqZQablOAFhdIFOMXY5yKxn9lfGHHHpsVMsdeeXVJr776rbJKzbgDa10KcSNrMjNPg5Rfu26oy69AOwb00D8KffuxtdOlCtLSovaIaU86Ta21UKx2Q9ayvbZ8bM1fiZsJJZiwG9cNfC22ueiSjWaaIwDxPbzxij8vHXvAUgzMAP/NJ797t/+5jurnHeL7Pw96/+ERvx7/MaPwqZ6/pRRXscZtqmYRikrlQgahUCGQKlZZhzQUmLkMNYJ1sEtL31BkEreUji2qYlFWLliQkKFqFwS5S7CMJbvZqZBH6EBHJ4BnmtgoLXjCG57xroU85S2PSs57XvKgR70GkA0C48KeAYxYxDBlIE3PaR4UxfcDGkSnOlyYE/pOyD6+CSpR7uMi/HAExjDKL1EAXBQaDTcpQQWQgAkSoOMeFznOfaqODOwYrSQ4QZLhLFWrOhEgWUUS0H0QZCDJVcligpf4tbCRs8OdI5GVjSUBr4pxKM0NccgGHTrvCZycmg1kwy0SbKl6SizAElPZRCeSoIpccFf4fEDFWWKH/w506A79vniw+pWRl4zkGxnXd8aHpLGYDVnjeeYDRzdySkE1k6NUEmhHyUEoj3rEEB9tFLo/HmuRK7PFNj34Mb78Lyi6ch3sFilGSLIwkrp7pNCIdbvdHU0QyPsBGYTnO01KaYc4qBYVmNfJ51ENN9D7zXKImMrkcCBd3DPoB5o3ndhER5azpOV10gC3mOlJl7/s5fz65EsMjtGM+DujMTsEOP0NkJktJZBQwLmhA4olFFyZ403pSE2dIsU/l6PcHpWSs5OtCC+BnMZLQtehUWHlf+sgYViYEcjcUdWdVX2nY9qZwqoma1mhKQMMluBJQ/TOSWbN4fG8l4Mp+fCHbv8FH/IguiUuWQChEeDActalprN5b6IVtehF1wTLNETCO6fz6EdHWtLEhvSLKx1m3SI7OP5IliXNvOxLexJTUPilKjidZgOXklOpFOSnW7nEHvk4VIEUdapIxZhQEnLUh71IKwzalSVssY2p8vaqVv2t7ExkJCSpAhWPCOsT2MCKSjTtrGitUmzW6skZtBWurxTo1bC2V4NirQXdPcEHtuuu7bKLTe76a2BdOR1MuMKwyATpOhULX2C2T4y67JBJn/Heyh6OXwzhz0ES95KYJojAL+0Ugm2U4M+K9o4V/MsdpyLUWTVlgkHtHElaO5eXNQO2PiEqh/3yopCEjEaeAPH/OH0rT6smpsUujuRhVsQZVIjmFGVAwhME0QpWRGsQZxDelKh7JU+ydchifStFwxrFqclGilNkV0QLil7opFeih4AELvErsC2LtMvz9fJ9tSxMk+YXIgB+rIAPbGA1b3bBc6zpTivsidDSmUKX+4SERRbUrnAudOksKj1MNKpcCBWcOlFZT2vLur8EJhWFVDFwtQrPFa84aEXqBY1PwQpULNcQmRDGkZjrY2pJt0qm9iSqUy3diVqpu2qlWg9jveS/8vW86P0AClgQWPCl4Q+HcIU4vwxm+S52y2JG7N/4cmb/gvGxIoKpM2W6ZjYrOFfQhApoG/jgODdIv0/Fs6mw/2nhPq9smxs+96A9fOgRd/tWr91FUvxAo2N8VNLsvDdW803peweaM5jmNCqIIQxWCHzgmWCu04wn3audWtWpfsIS4Jpkg0rUh6g+8nWbbGvBTjm9Tralr3VW7PgOO75cFjayia0qZW+R5cwO87IrhSBDGyXB0p72muXoZo1VcLSVq7MoRuug/XwbqHsezK3MPZd+99tDwFC3//7X2ZGVorSQjie+9/3irWNd6zLuTC/CzulxgNobAt80ws+6SS1kCbxUcriqWz1xWL+9SnV3K6ynLEUq812KbQI5sFF+9ZKP/OQpL+m+6NvyMUNMQNG2OeRx7hOdy3RCPYdznOu8bf8KUSOC10xtTmv750CjOx3XUAahIffhiTRIhC+ZiolN2NsVZh0zXL89jNENj7BnA9O9IDvZz452sg7CrGzIwQci4IAIjMDhRaY7bKp7TxpevIcSNe/GOf5kKj5H17O09d/pRfhGGv7whe/l3FS+RWNP1sz8g3bkby55yu/8QT0XeoO5zdO9fALc47awarGF56wI6W2YSMBWRrBOnaROvOFBKBTE7A0e7cWY7eBe7dneZRQgPPhb2P0eNAic8KGdqP1Y8d3ABRQAARgACTjftUwH3T0cxEVX3GXLK+ETrNUg1nRcrvGdro3PFYnf+EEaY5kc4pXfEAahL90N+63Rfgn/oEoMUPzN385d2xxNRcn4XJ5tnoSUludZIYYc3U11HoIMIAGe29NhDH0ohX1oxcj8mZdJYO3wWwVaoL0dCwZmoKBxhpH8ngcGn/CJxiAQ3xlowQUoXwqu4PH8k7VYXBI4H5Qoj9QwYm1EB3X41fZdIg10n/dpX/hxx6O9IRwS4fkZ4RGq3MvhTxLuTTF8x0rARGd5WLUZGP1RYYVdHgJpYdCFVhVWHX+E2/99YZ9JQ9KxDFoEWqwsHTagnoJxCLx5Auzkh4s04ImlGChK4Bxe4x26GDbiTjbK2AZ2BjiOwzh84AeCWqdFC/GxgQk6ALqUmiK2YCM+XJNYC/VJotzd/yB16B0PbqLeyQkhyEI1RGAoZsYoimIpfpmkEJ55hJmjFEMwtKJ3uGIUElqb0SLk2BFq/R8d4d/+OYVB+J+4jVs2PYMwIlVKgJgGBlqHHcWmgMKcmczMNaBuDWSlbWM33mQd2iQe9lvYjeM4QgM0+CQIksIInkHxPUFzcICaWE8GvCBAseA83lj1yZrG4WM+YiL3ZaImfh/boMEtSYOg0SQckuLOkKXgnWIvRRaySYp3tCWdwEjNxV8sUuRFvuSc2SVQ5aK2cSRq1dHD7MXqIEVI7pmGNEhJmuShxZgGnp6HtchLkhgJzRs1fohY6iROXiYFxuG57STTGYlPAiVoBv+l8DULkMkgWSHfBdxAqhXPIsYjqllLVN6drDWixFXiVaZXJnqc33kBGrjC6QikO5mlfRnkQRak+Z1fXjjkQyLDTLxlRcLiZnFbXdIZGC6Q/ZXKUxxTU3nhYA7mXjDVjaSDeBbga1kQvIVFVoAbG8qbKHxiNebN7W0mZmagPixGfc6hvnFmPtSDOISjOIojaI7j2ZGm0tQBxCVXJnTaJsFaGRDP2z1ocjWohEIo9MVjxFXcgUZcFtzTPmqlbsbLF1wBQLZWZRKnwMAncZricRpnEPrDN3jGQ7olXFobjcbiTu0ldYKhtmVeFQLmU3Fnd2JTjWQFWF7FMKpEjizdy8T/5VC4pAPyX4X5ASO4IXCSHFdx5nza3n0W4AVi6av0W3+GY4ACqDgSAynIEBzUAQ49wqYRZdrxgRnMIwzK44SSgSdpqGtai21mAZ/uaXft4171nfjIyYjKp1iWonBaaYoO4bGtKBKahT3sg6S6qDHEqClc6qXmTEzkSpPeVl/iKKgGKXWK1i4mxX38lKhO0FcI1TOEJWImJl3MBWPS3C60IXY6qZSGRJUOCYoiy07KRZbqQ31uaZZqo37GRZh2hj38ZFAGZfCdqQ05CTpSQoLSGPEBApw6aNWw4Jw6ZRnYKcRlwZ2Cqwu6S2Dp2g7yY3pdRxsUqqEeao8sarw2Fsqx/yitjN8pGENn7IM63AOlOmRh9d+mDmyTfmpGhiqOpqoW4mKEfCSQpuqqJpqsOAPjJGmIGcV9zIgf4IzAZoXIvAIEqtOjGuu7/uodbqmw4gOx0mF8WoZw8Sd/guM+LCumMasvHIkmDUIlHA217qwgZmtrzqnQTmWsPQG5uubRIo+6buJWThmh/masliy8RlpxFqG90hcvAY8prIKmfYM3TOqyfsYqYGrHCizHHKxGhsWcKWz+7V9HNohPbafCcsxXVNB3ImM0LA6K0YzAfsWQmu0l+K3sjezPaCOXmuyKGKuwLu5crKzUYibTxazMQoONNSiSZFrxZZKSKMm1Mom2Iv9txg2trIGBa4KunYIrEEBH03boFKHX0z7u1FKtvDoq4RLeI9yu1m6tMRiDMEyqN4QtLpAtIqXtL56KqNrlwr4tYD6sqPot3IZsB53hMybp6eEKrtrB0GkFr0Cv3gihHcIuIOHk4jIu4rKsYpYhzIpDzELDPgiDHlhoQD2Nmp5Bz7qpzzbXj8XmDL6daopu0ZKu0Tbi0dKm6rKuAVPR6wIr+Mau7A4nvdJuouqLI2ArIOCuDDkCs/xepPqrOHLDQ2LCIZDMIYxw8YYkyYSkTd2lzzGsqe4HuMnb8a6trd6trFqD3u5tMmBFI3yFHditx7bhvdbu9y7wEFPg+DrueBL/8fkq6X6qr+R2Q6QKAyAkQSi5HRcU6CWFxr/VEyZ1sf5KIv/m3f9WaIYCcACj7gGnsSx55flErRJ7XQPPLtaqqHHygR1PMAZPcI/l8db2AjREqj/M7GdAAgn7miEDIOgRLyjYol4qb3wwLzDKMFes6qaKzoo8hIGhDImNTMTm4qp+iMiOHzYoLh4WsSkfRsqqbClzE8m2MhM/cWcQgzdAwxTjAAhYAAU0UXJdElHumJvusdp9MRjLZgyWLhmbrtGi8dKqMZVdh8648RvHMfldbdUioR3vwTVncwXnsSPoQR6vAhQD8jhkQzCYAiEfciMUcub0MDv38AQFXYOcLSNL/5NtwR7brnMfyQfUooX0GhrBIIPHylvd3t8XbGwQo9B7snI099YSt2xDm+8rw7KRzDIr3BheRcBz7HIltAJH79jOYhLxxGlsBtS2QlfGuVUZx5q4CvDRki4SMHMBqysW0EEbJ/FCn3JO1h5BRnAG0fGw6UEeADU2azMFU7AjHDVSY7C+inMvjG0eoDNUk4w7a+QiNzI89yWEQNXc0m0+58xdvFA5HKDqKcM/Xy8P0+32HrT34jR+svVNu7Irv0Oy/udEf+AZ5EYDqKazeFpHe/SSEI8cjPTzySD/fg+2UOgYr7QZU/GfNrYOdKhM0zTUEslbqxjLwrGiPrBmVzPhpf+pZwu1N2vzHQv1aB/1KujrOCyrOA7yOaszO+/wuOnlIq+wdEbpVtPtlOKCAgZkjNkwXeawvywyDw/3DjeadgZTTys0RLt1fi53RPenPUQ3UMoyUFYCDDBHHxxcaFTrwXkua6iBazzl8zUcxK0VmxDtbOIpbax3LDk2MzcBG0OzAhcrfTs3O8kxZ2/2GwY1f/c3aP83gAO4I+huandwOWfFU7fzVMc2VdOzL942hrjEbq8KxR7DWKtU0A33WeNBQVuOWguxNQqkTTc3KXPmXH+D14ImMczCLEwCFdyAIfjyJFRr5h7o8RTz/lqo3XHBqcEalhyzhkrc9+iAxHGcey//M3ynASyANVzXt33jJANPpnhmdn4z0mf7N5aXQYDLAZb3t1L7ZzcceIJD9f3N9rYZbArb0Qk3ryTzWXnqM17kLYIBQ0O6AidruLwJgUGn34eb35Xu6p9rGEM/dDrUZ5gC8izXgi/4gqIv+iSsgSEQ3KZNgkcH1Nq5hhrcEzFDInnLJt75OHYNeSgJuXu30p+uLnRMxx4UA5OT+JO/ujRTuW8l6pX3N5ffepbjepfz9x8Adf8tdYE3df99QlAbMpa1NoNDWFbPbSSLG3PaFvssaVzaROBqLG/aAQ8LgRAwwljwOZndzxy7VoiL+KCvMmf2gz3MMi3cAy00OiI4eiEk/0IfzMKOzTinTYJIr0bSuEYrbfq2BlSpjfenU6Woy91jH/kLbGXTqnowtDqsP3yT02HhxjqVb9ln17qug3bGb7wdPDUZJHjHD/gngDk5918etDYhu6Qi71+QrnnLd06pmJCqKOMyigQn8+Zwf4EQtAHOeDtkhTuIBzqgz/cSgwO678M9JD27u7skzIIiTEIf9IEi1DvUk9WCehIJDmJ3uSCTBbzAa9yrGTxsSI+SlTq6amJupCvfMXwSaybEv719U7y8Yrytgzd/YzwY2L3e54Gd2sHH+33Hd7w3f8LYRXcHj23/ccVTP/XKH6zLmzCfASCGMUXcgI7q0UkqaKwd4P/8V9yBtjsgWR9migAQKiZ00Lv6u74QPYDDNyC9OvQrLay7oisC7T99H6xBIkxCm+Z7QPVvgzaNpjNZD0lXJII9twy8YcMGDLiA8pf9kaP9Cai9qXMBHAhCTU85c8O9cxuG3PcqfovRxYd/mua9Goh/+Oc9UJP/x6N/fws+lp22sho+a0OCHii+/ctzIkN4JD87HQGEK2TUzp2jNo2Xq1evZPG6hAciHi9eIt4R8oUQqE8Hp3XkGA3kM5HJRoY0CZLdunAqWbZ0+RJmzHgzabqredOmvHToCvJEJ+6bv3v3hqkbNuyeUUSSWklSVCiMGTNrElWtakgqlSdPgGxlM2j/UJkkN8iWxXEW7YyzWtmiBWIWbQmybuG6KOGCRFkYe/ee8PsXMAjAL36Q5aJGUCdnPuc1dozvcWTJkClXtjwZc+Zymjk/buf55mbQn0mT3ib6dLvU7eC0dv0adp7YamCDsX3bth0wssHo1pPHDnDhehw5MmVs3L590Mb1CrbqU/RPwA81sn79OiHtjLhn7/6dkSfv2gXiUnjpEkORBjvqSm++EZqJ8udLFHJH1CfzA0uWBEYSwP5CSukZmQwMDUFzEsyJwQYdFAdCCL/5Zqii1LmQFlpqqcWXWWqRpJAqoJiKKkNMBMSMMtjQIocbctBCxRXPgsstrdZia6u46qKx/6wRYLjLLr5sEHIwE1gIbLCynqiDj0hg2QnKzjK7jMoppYzyytG0RA01y0r7cjXVVqttN9p4ow1NMtRcs8w0cbtNNzh5C062OmVzZBVjekluH3vGGQcV6ewY9I9Cq9tuO+8U7U688UChBj7r0hOIHPZkmfShNubb1IuLGtEoul0C1IWkUnKxBcBjRj1pG5QOVPDVWBfEyadsjAFqQm+8oSUpDI8iasMNQTxDxCrWMNEQFKWKQ5A4ziiDRSpk1GuuG3HA0cax6KpWrhmp/dGGs/Lqq0gTQgAB3RMuQIHdv3x0kck9MOnkFnqwzNJKyvSpkt/KRMN3y1nB5Gzggdk80//NhMl8kzaGHbbtzDLt5GOVYPaExht7/OwGOkyqK1Q7Qz9G71DwTBZvu0dxQY9RUXYh6B1nFJLFY/qG+OLmL3Qewo5Po9OolKCFNlXVZFAtWqRWlXZVVlidbnpWB3v6KcIJa/GGKKKO2jrDDINVxI1ilz2RrRHBehZGGXNYO61rX8Q2Wx295bHHvIwkF0m/MhBsXQ78bmBdvwrjgo3C54VFn30B7pfxxi8rGOCoI58pNWtW+vJgNjXfnPOHx/D88zfTSNPO1vDU0x7l+vzG1kggoU7kkUte1BJHIUUv0fRgriYVTGimY9Occ0bjj/yAFmXooU9FOkCUnOfIwEqhnn7/6ppshdCXCf3Zh1euvT9qw1g0LGQLsZdNxAxtczDj7GWxTYKrtam4US2t1NJxhG2rncsFu/y3+y/m2tu5CAiCC/yNA+3KCw4I16wmdQId+1Kc4yjYuAk+LmCOKc3kOKhBMRnMc50TYehER8LehFB0pbNTJChBCu3dQznf4FgkXPGx2M0OO7LjDh5UhrvcHYQbDtlEDenTKScMQQg3u1l3QCGKT3kCilAkGvMEtDSmUS8lWJRaT1Tik1tACBzf4BVR1PGPo5jRe7EI3y8+FJVirY99WGkLDgrnPri1JVszyKPcvNWtueEPLyQI4LkyoK4B+g2REUjXB+aStiYlpl4S/0zHBClZQUtW8F8d1GTAwuQYhI3QhKEEJW6mUMIsiJJzclDlHljZpC8GZR8w9FM2VOG619kQlzoEGX4GAgmQXYdSyMAEJGqmsytMBIkykMERKdIzKD5RilNE2kmStjSYdASLWdwMNqQnEy5+kydfBMr2htKrMn6va78Q34Zm8ZSwiYgKVWCfHa81ohGlKFt4lN9WcsQ2Po7gXdzCQf9K4EdB6u2Qe1Po3iLQ0IZmoDCNLNwjfccTxV0wX5fUlyVhlcFNdpBLpHnYKElKShKWEqW3OWUJ3aTCVT7QGMQISjlnWUuP3VCX2kHDJYKBjIfo9FMvo0YTf3fMKzBTmSpQpv8R6gNN5VHxedas3OWwmU1tloOqT9siOLMBDl9IaIwWMoo6OFHWrWkDrepkI4faCTaxxXNZxIKCtFY0Imj1E6840KNb/PlHgO4PsP4LJEIXWliFOvQCjJRovAQxr3rdK3GQkaRkK6nRymD0o5l1HOTmgcKSdu5zKE2paEeLShG6lDiOeMQpuoE1dQylT924BSxcl0sbArWnP+UO8nAhzEsM8yFMFa4M0KXUZdYHecqrYlRXMtWsqqSqMXnuNqnbzelylTHhvAUpSLEI7qWTa2XVhPiOkla1slER6ZXEGsonT7iy133yrCs/52ejvvJVbgKtm4vsMtCClkCQhWUAIg3/+9ATFKYDi/0KJhr7pJ1EVrL4SNyEI0vhCF8Ss5i1rGYzusHKgHZ0oVzpStVEYpWa0jalHbGJUbym2LSSD01axcXKKcsZ+jJ2dAAqMlaWMo2Yh6iHQANSedA/FRxZqU2Yj89AIarlStW5z41G065rXStXgxtZ1vI74MFlL4LRq4hYBHi7Nt6yzmHMwzDveT/klHYmAr5SsQKx5FwsKNzPn/a97z9xENC5/bXPcimoCQ56WAIb9oAZSCyg4eXIxm7iSRiVIIUpTWkJX1onmd7wRjm8aQx6mDIh1pxpUbniE5tSxaE1dYsPpkJWMikxquhF9soZW9fpGNeEkM8lePyx/+Np5BKmwATwalBsY6sABEcGgQya2lsnU5O5UGbJlKP7kmpf9cpX3nKXuR0hqkkovb5YxCLMrAlzm3sOmpjDusf7izWrs52SmMW8nTIJOJOoznauH9v03DaBtgiwdMNBuO4CYBIIGNEKVdcHGE4jGKUN1hC84EUrXfEJX5ge+dC0pzfeaY5nZtSfDbkpvWBS0poa5Sk/jItd8xsYw9hJoxBG6i7kD2PsQT653mmvixcdHwJ3yMYusgo8UIEKJPmYdggaj5/c3A86PRzMtTYQsV316mp7y9nottbBuN1s6IMUSxEzuc+tbnWvm92xeDe8nSKJWmhj3rOoSpzzDc897v+5j/r9I1kCWtBwmcDgD8gAAwac8IN+4AUNn5GP3hYjB0Za0xbnx+QpTPmLZ1zj8tAwpz/u8Q5PqdSeLbHKTa5qFaf61CxO5SpVxNgYq+gRvcDaUMQx7DQUSj6Q4DkxGRGR67ThiMcmetE9gPSeEZWaxyhF06Ns9XVIw6ow0bKWr3e9LHvd66SYhHrHzW6zoz3t7taG99peCLePv6333gLd67w2PbIIz/c1KI/mz/f/Hl4Dg9d/YQ8vSMW6COBchK4mKtaKYdIaQ/IsTwEtD/M6zgEfMMI2r/Mwzl4w7TIk0DJIjfRYbANTbMVO7vQ6cKRYbw/Y4NVcLrV6gaY6YXT/gAcNfMcUSkZnMGJQdqbYjoz4JkAHjY/Jfi15flD5oCramsbLaMXKtK4YsgwJk7AYnkMVnlAVuEsVAmH7JGHdJGER2A38wm/81qzewiAMFAHe0u8M1sAN+qAP6G6u3G+v8A6g8Idu/KxuAizhFC3/BMngGMmPvMUrCDDmvG0eKiwB+2HyCJEBMw8CJQMROS8RM2rjKlDzJpDTWI0SuUAETS8EPxALMlEEWW6VXE0VhAKGVEHI0GAMXEHYImIGI+IimIAJagAHjU4Hiw+Jbub4mugHQyFooilogrBohNAk+AObrgi6uqhBpAEZpYf6mNAYmPA5YAEKKUEa0ZAKze8N/7aQE7YQzciLa4RFDMAwDMTg/NgJKszQ/CThG8PGCtRiBtox/nLA7/6Lr/aQ0QTtr3yEBACsDg/K4AgND1tkz2LED4NBHC7PJyat8grREBeSARvRISHxASsLIiPvIS1Dwy6KSvJBA1usE4ngxDQRBDcxJDFx1RzmE2/jTPaAEsYBtlQhDYhnXuJjBttAFV3xBpGM6IwLiSiiB5XBVJpseUpl6YBRQPrjZ3zwaETl2YAoGZuSGp4DKqNyFaDxETohEq4yMRyoDMNQDN7ACrUR7dJM/LZmERQhHcFQHN9uGD6kHN2gC5YCKqJgHd3RHf2pBPpq/v6MW/JHXEhAA/rvL/8FKB/z0B75Ms/2aa4cz0kK0iARMiENcXsY8hAr8hEnkiIzrcKy6zInEsIskOLyQSIxDRE/kisu0TRBciRTUzVL8mFcShC6IZa+YdggIQaHzBXvoCJ0xia/IOdwjZiOsrf04yOgjVWI0zhNAhefyQ9yp3ZKQTidEhl5bCpNwSqpkzqxEju10lmcJRzFURHAEs3I7bzUqo3AES0VYdw0ZBHEYAdiYAe+UwzScS7pcm3u8s/g0d/8qFvg4h750S/zr+D+szAN8zAbTyAbjDErjTEqzh8YkhAlsx6K8F4mFAEjsQEv1EJ1ojE50zEmbrJA00Mj8ALpgTVTb9REcCxWcwr/lEAkpcBFXxRGY7RFTwn1TGxQRu81HMEYvGEfuoGYHME2aRA7mpNkrBMaewoZkDQZhdEjjpP5qAp6OMLZklM7lnM5JeU5oRIZn/E6iwM7sfP1mKSOthMc4/Mat3DcFiFYuFFYzBMtxVE8NYE927MLrjG9oGI+69I+8VMeA03v+hMfAfM/8dDgAjQfD7VAvYKuFDMSjMHywKExH+wxH5RSGTJCJXSrOhRENxVDLVRBOfQxOpMCMe9DOxNDObBEQ68DUVNFW7VGcUM34iSFVGFCgqE4dIzJXmYgdpVXq2EZfrVJnwE6g7U4o66ajLVYo40pD0Iph6YjYKG3tnQ/rNMV/37US6/1BOug5R7OWdbPPN+gK8MyTbHQ7cKnLNERHHegC8L13LIwCGLAPYMgCOITT+fMCu6sQPML4FqkW/BQUPPQPwdzMAGPUAmUDcum9VQEkiBkAUu18hqUUhWyHiz1UjWtoxqEVCM0ATN2MjUzEBlxVD3VYS209EhyVUuWRlOWRWV0ZWe0ZV22VTdyK0TtEbpK2ExBFpR0WLHMV4HVGZh0OIM2WZUV6ghi6pAxZnZWy54ROqZTOoqDD14nTLO1Dh7OaqOlCmagCso0XNG07eKu7ZwCDKMgCnaga9MtFtx1B9YWXtU1ENygfOx1PvfULvv0/i4Ab/MWUdFiUAcWSP/ur1Df8P3gJmH3oLFuAUItzDEVsFINcWI71mKrJ/M4tWEjiGMr9wA9NHMpd2MpjSNF7DRV1lVflnRZVkVHL1VHJw/wpGmhcvp4lpuuQXZ/thl81kmPE8qGsClj93WX1hmd0RkqpmOqEluhlmpdI8XoS1GpwB1jgGyDIBzPlFzPFWzpra3GtguCYN3O9hqvcW3b01vlUm7nbA1XgD7vpzD/Un0vgG7nx+/+8h7PBX4P1S/lMZ6Yt/HYonATo6vGIXFDFEQVkmL/11489nIbFnMRuCEltUIzdnI/VfJM9nNRllVDsnQv2HQz+HRL8g/SYA+MNElnV4Qr52d/1nKIFXf/h1Z318EmmBAdXNh3f/dniwFaj/RmjRe1ThR+drht2NB84TVe5fUK0c7N2irevpBso+ANshBcu9eJ4/MbxddeRSAGxteK8/R83c+e8Pf+8G+h1Pce68mOCLdwWchRIxZyM81yBViBMVczLfeAJbaNCRhDP/OBO7fSJlh0Q9dkMdiPNRiD+7gDTXF19WNXebf5RviEFdkkkFWFi9Ypk9B3kXAJmxAaa5i2rjI6cLh0RG2P30Jf7dN82xGI5VVezzZsq1C9xPZ5l/js3qBOw7X7wLULajkKqhiIrSCX54xs4Wv9fLmKdVlumVceS8AO1/eYC1aM2w9hE/alYKEYxKFx/xeYMx9XjutBHxKUjt8YmxmXgB8WYi3VAkVWNDeUcydMjyn4IytYkP94dN95j03RDn6UUhA5dnN3kfPZihw5WZ8LOiVZhpsxGCwZk6tzmB5palujj98iosjFP98QoFJglIE4XsVxe5/C/LavEDZavWzZbF15e9W1e9tt3KLYluGViq2AbJ23l5PYpZ93bEd50OQxmQ8OfvdUK+TL7vBoUfe3UaUZjdMYEgMYgbu5qLnZqOW4HxpU8qZ5AclZZCXvchMHHEAXnjnxqt1Zq69a1T7nD/IgqBbjnpsLn8makctan12CGwa6KX+XGZnwCa1TkxmMk1WpYVT2B2jAB1hgr/9bwK/7T1AJNQU2YAOo2D3d00zngF432io42ikCoZbXtk7NjYm/kT2XON3GDRHmYLOzt20p+rPbVl234JZRWgQkmrA1oJgBtk8P9q3uqJl9WhWAYpst8yCNGrfr+KlvO44fNJwV2LeX2o1125ylWoK7mo/beUW3GgkAmbnZWWU/R56to57tGa3T+rqx+/leF2ndeqBvAa4p4Uux8nhR9wjymjCOJG8EaIASTrUJOwUoem3N9BsZ2yrAMBFYmWyzt07Jbns9u5a7cimeGJbbU77LtrRN+7QJm8Hhux0DbbXvsh3h6o2yOH8Lx5nh4JFgIRv6wX8d95y5uYC7WWMRca3/nQEb1hhySzxxGrdBmXoBwUEya7u48Vgf1tkDY1a5s/q5eTzlkm66dce6E7lozZpom5TqujsbkNFW1hq8LTka4zo7m6W8LdHKG1q9BUjLCagOj1kCGly05zU+wZGxsTccEcGkk3iJx00TZnlO1TWyvxHO1fV72VYEFrzBG/zLGVyi0fe/JNqHtVbfsji2M1wLmsV3+je3Q1zEI2TCGKOES3iqK5YetFmACXF7rvkbZjyoF9fGszmPoTvH+djHe9y5txq5x6BQaHMZDGKsibzIYx3KmHIZpaEZbV0VmjDKn7AqxRsrBSFbdZih0bt/9KaAFK7LvXzPNwC0Txl68TsM/9aPpcEQEWwZwb0yTdu8++QciKnYsJv9sDegAxhcAjrA3Jedz/ucDSVcTw/WwucK3u0Mw8tAoZllXr4Om7uBxBndxDUzQr1taSM9ggpx8rxM4xK0xX37xX/bmwm+jSl30ikNUtF5x3X8k0vd1DMeBK9gDHrzEFBRkl9d1ke+rGldCW2dyYX3FFZeeIkXajmZ3t3kytFbr7N8ywkJ55P9ASSA5/fc28P8XfcbblUaiLsTDIMeTjU7TTV7zA3ctD/b6WPgzqdeBMid59Nd3bO4oOCxz4s5Be43rnTambXgMOLgcL5oAVl83z9UxN9YShfDmtde7is1Mhf+fx9e7s95Y/+xGmYx/uI1HvADGbmBp1Cqm+QPf+Rht9Zv3RhavmJ6PcaKgzjm3a7XZCuWQC/Se5AK6ObPpfDqUAJ2PvQL+86lPoihl7TBUNqBeAbMU167s/vSdI26zyzDAKUZ/LDr/HkNvOo7QAES4Oo3QKJjQN3liT7vUqLvkt2NpQwHgRrRJ0US867IHtYcK5vHoZu7jN9H3Ce2TUIhXeCtWd/z3uHrHmIZ/qgj/tPl3u/bP/D7/v1jlA5u7+NzdsgTH/Fn93UrGRkBYlUwgasePQIEKJIjPgz1lHmoBuITMhOTIFFyIyOMFyc6ogCRIWSIkSM1mCBBQqTJkSJbPnggIYMEBRv/NogQESNnjB07dG5x42aL0BhCg4QJEyRGGKJHFUlyugjRoqmLamm6GlWM1p45efLsEmZrThE1O2yQcBZtirUz2FaBEmOF3LlQ6lqZ8XbNmj6J+vpNBOghlcFUwFjkgrhOHEy36nVzXC9yvneUKZsjh61a5szoznX2/Fke5cmSI2+GBWtZNXT8Wrt+DbsfP3+0affzJzt37timO+crrS+48NfDicMeMyW58izLmzt/zjy6dOgYsVSnfj27dinbuXtXYh17+PFY0ND5AwmXM8+aw7kv9z6+/Pnw5Wvmhj+bfv3GTq3y/19CBy3EEBsGylFGRYYdZpFGP3DkEUgSckBh/0smhLQSSy6pJJMEM9V0001d5bSCFULlZaJQW1Rh1FJKRQGjGE49FRWNtNRCS461LDIHIj6CFYVXRyE11k01HVkTW0q+1ZZbVegFFFB9APXXX2YMlkNFCqYRhxabdOJMMfvhx5401ASDTJq7yMJmauux5xs8cgIn3GfOtLleZLzteVttfsr2mHGuheYOPXQeWpyg/HhxxHfiOQppd49KSmmljUaKaabkWcdoGoekR2Z79I16WX30kcmfMfwBWJBBC71aYB0IUrTgRRU5+CCEHU1YoYUZoGTShhtqYBKxCpgVoog73bRiFU2uleKTQoWh4k9hPdWjjz5ShZUmOU6llf8YQeyAFFJJ6UQiUUQ1ya5ddpnoRl+KTFJIvXzde68hhlxJRZZaPqEFYnFwsUnBqB3Mi5qorekKmw3jiSqidNrJCzBt4idxbH3Wdltru+k5qDidqXbNar8lirKiwXnRRKeTvjxdzDBbmt0Pl9qsac6bLkeHp+khEyqp25hKdNH15Zeqqv39R8kjsCIUq6y0HgYEeE8sgRiuupKkYdcrpfRrCChxSGywMUnQQbI4dSWiXCWM8HaJJqIoFF54XUvjG07tje1Tisj4xhtamRvEFuPu5FMYM0y7RbttvfXkX/XSWwi+UpqBOeZQPJGlv/8ixgUON5z3B3qXWHJ66pi4snr/w7o8DDRopUn2WO2lsZfmw9S8k/Frftpm28fGTXbOaSWLlnLyIC/achM7z0wz9NHfTH3101c6Bhp/5AFq0EZ/vxmpSPPXy9KtQp1QQ3xIPXWDQHyudYRci3QhsPandNL9Ypd9tk04hYi4GJBlLW8roFz65bgmVSEMfNubA50SrnAFbnBcCcIM4rI4omxBXXV7HF6gMLd4Ta5KU9LLGU6oubp0TguEYeGWuPCDGtSgZU74AhNs2AbzaO906XlYw0yhntjpZ05zopPIRoYM1rnOMxLTjWxw40SVnYweFCOZOQylPJUxjwdGuMLzpHe9MFIKZ2IMI3LG4DNYeK9k4Guj/31S1Yvymc8gg1Bf1CCSNaol4VYYiZ/8LnSS+t1vkIHE39uI1QG0+C9ZAjTSBkR3gwKKbpI4QCAOsgStMMjrbw/k5N/EIDhFCE4sO0kBumZArWpBTpU/gZLlomTCaKWwhS4EWPusQ4OPyGCXKpCBCn6pghu2oXSX6KEPQQEJUOjOTESk3ezklLvTpSJhhZoin6KoxZCJJjPNqNjxsqgyLhphhmeUmTnPiU6sqXOdF2Hnc8hYM+tR74tiRCN6PhE7UbkRM22URvHGZIxeDOQ/rrLjHSdySy1l4WpV0wERbCA6G0i0BS6wASANeZIS5G8jEBok3OCWSBAZCYONY8skIf8a0UkyyCKUxMsaNFmIvckoXJ9ERATFtcHGYdCUhjvKBld5wlgGFUqxjBIKTYTCuih1cy1UaK4e1MU24LCGwsSDVQnRCNWpLqtZVWaazoSxZhIRP2ziYcPeJI7ZPcaJTxReyCaGmWV0k5rpSAc4jVPR74AunWDkaxmvA0956myw3LHn9kyxxn2G71T4EVNAe8GqARlUVhCJiGURSoYE8RFnD50oRz0Lg5S6QLQcRQkMRvDZD4D0SMlKUgpKsJZ+EWGltN0jbSdZhZjWq5Oi1NtNCTeuFaloSCdq1lBPGC2iHle5Qk3qUp2ayyt8ag/J/FRWsWo6RmAVq+bZLnet2t3/ruLTTOQdq5zIiotUaFWIc+rGx9yaTdJYpmRyZYYVsXhXfmQWDnDIGmH7CuC/Cva/l4LOGNCjxjIpVrGpkoZACSrZya6PfftVA2Y329kkDKGzHJ5oEixKSdJqLZIf7YBZFikCAqrUMFNbEItfXCuWlqCSI9zt3kZ503ARd0jU4jFQlSvL5sJyyLE00BkMVEstxRAFNfgSEE2hTCVGmXWpa8R3sZpDNGT5ql1d01fzWRkyFSOaXUZGMML6zOVJEThULJRm5upNbOAXZSdrjR7ywBwfsAAEL7CaX93ZzgADWsADLnShz1g6U5w5sfxc8DrGR76lRdig6psVZi3cYgUd/8YwDoFxZ0eLUoniykGkHsEHLrkCm8zgJmtZ6YsT9GoYw9h9VIjXU25NI6ksIseS0PFRCsFjYIcBRdISsiujhK9AKBtfx1Vqki18AxREoAZp6MSTYSflKEdZq6nD8lTDK96zUgOsqEJvlR925iE2c3gSm2KbS1WxXMjbvlec86DqXIRc8soEBQ60oP39b0l5ETyGJrBzzsg99TBaaOAbnzEGuor0UVoxB52VxS+LaQTpAX3ok8OsG3oRUj/1QQ7CJF2gMAMsgaGyLE4QHmEN649fMre1kMSOdkSVrFAwCDPF9VPEoFufSgupx032lAJBr3lNQun1ykQJj2wgZ2vB0v8xnHYeKLGweGudYVI+ppQ/AQorg5eqOdxuMWG3u3JTwxWXOARXf7ZoNKd17pKJk7uB4+bMxDsVrwDGm+5+dwlRoAKEn0AF+F3bgAN88YwntMH/a8/uFe/RjWY4O96IH6XNUSESrjRlK3txjcPqE+gjfcdf/L7FZwTkJQeYC1kI+5XLXg8r77Rl70z7Tts+xpd0Qy1+v4gb4fznYjjKuMIwhx75XBK6TYRxl7uXe1GuxvSqvtHPUIUrZS7qBroaDSJg9ScrTGHKKD/DcMEwUbSdEaFQv5qUuX6rSvUL8/euKPC06GXIYhNcFa+Z0z4+o0EodjcxbXYNe8d3fldvyAP/eCBReAsAgQRweNChR403MxXoZ4PmeBvYHGgkeZV3eZZHeY/GTElDEJxHaRPHBrgXdXvgguojIJ/AKgRBEFADaxiYgQVWSa/Hg4KRILqXeyyIe5yWe7XHe1agCL+nhDhSI39zFBK0fH5jLypybCekL8o2QkZ3dFEyCEnFfZgDCJjTfT9AIRVAbZHgJmpifgzDhuhXMWznbX5QZm6IfmEndvNHf3eAVWaVMO8ndnvoVWhSXmoXKnYngO8GH930Cuo1Tc1wH6LBgG2GAQ8IgZVIATqAg4ZhgYuXiRqIgxwIijyTTAo3giAogqGSDdKwKqsACwqBCQzxKoIgi7A4CHWU/4K0aBCm4AiR8Ag06Is1eBCBgWkvtFeg43qv14KCIYTLyIKzt3s+iANxEwZVkSOxYI05hwg9Mgc18hSc8AvfKIXAdmxbeIXWR2RWADlS5y7a94XCyAUnAH5mWG0Io4ZraI9w9jqncwc2JARCQH9z+H7qdYf1Z1XhBoeEoGU7dHa4kBpnliZjFiZvwhluVk1hVirOwAz52IjHE4nIM3gOMAERuAAEAIEVMFudGIqemJIFx5LLAQZ2wD35dIqmyE+oWAwDEQxP9glQtpO86JN0NHoNwYJQg3W+KIO/yDSdsBB5sD2UlQag85RR+XkWB3oP4RC4lwcaVwZZGXpcuZUsZ/8YMxYFwVeNTMgtnDAV1hgLksAJkvCNazkvfdFj0hcIQYGFyyZURNclS6WOPogll5QSHzkBKsAFQFSPGZkMiamY3nSPDQMKnoAHU5WH2nV/XxaQ3YaQW+ZdmckyegiIZ+WGlvlV+MFMoEGRF4mAG1lXA2gBrQmSlQibIaB4Kjmb2NGS01NOdmAHyeRP7kCTv9lPYpaTB/MfT0acqoAaTQMrzLgQAnKCR4mUyImCLigr1Nlf/FUHaTCVVKlxVwl6XtmVP8idEGFqsJWEOCJ8OeItaumNaumWvzALtTALcZkIyDZCQ1VCQHFUyeWFPMg5/8k50Qg2IEmSGFCYguhNFrP/mI2ZJnBWh+r3h2Z3CdjWh+R3kJzZXV4gmWVnkHRIoV81DeNWkwpmDbywiAWjmhPpGR8JAa8JmwswgX+2krTZby9zm7f5krs5Xt5TKo7Wo6rYWAgqiMeJnMipnELpnUMJCASBCidIgxCnCsqJCSg4iy9ondtplVl6e864peFZhNCoWikQCMH3e1JxFdX4lmqZprEwC/PpF1CShXq5n3PabG/xnyEmoAPqogsAAnSQhnCGmAxaoYDKhq/Tda6QgAnomF5GXnSICfEnf1N1Q/SnkGc3pa3jQ142miM6eXcibygqC1bEGS3aogfwoiWJeLW5iTQ6ozeqHLM1W5FHip0K/5y1+k9BKpo4aWYQp4tLCZ5CuIsy2JPFyYrRKaU+iazIiqVemqSgV3t41qUVJhgWAVJIqCNTsZ5ouqZv2aZPMTlBIUL0EgcrEAf8CX3NhWQo0RHqCjYhQaov6gFo8KeBOlf0eo9zFaIhWn71Vahd9wqQWmZpN2aoAXaYqWU41I//6HaMsLATuoiZ2k0iSiYGiJEmiqIpeg6mOpLwOokmwAM12qqs+niuiqM8o5vcU14S66M9SqKiMm4kE5ED24rTyZV4hnuxuIunsJPFGp2wUJTWBrRBS7PL2p1aenFc+qtdejWmpgEdMANigJ7aqqZTy63z6a11eQbhGhQiIEtySv+nSZUDF1AhF/ASHMAADfCuBKC2logFhomv9uWI0QCoc8uv+rqvhNqviKpekTmpw4RV6PZ/CIoLBSsKnNm3beCZfPg6miqqkGgn26CIqFMw1IQNJLm2JUkBIJFXqhqynXubutkIn7Bop7my8QAnleeyN6m6N4kMruirFVazQbmzQFSsRPqzRVmkUdo0SnmlzBqtoSd7wYtxtRegqxUDb0CW6km12wqfbToLlAOnWFuuVhAH0zu9Xdu1V3IDFIK23esABfC9pqq2lluSY+C2byu3JQq36Mu+cnu3gmoxeguhhLCPOMSh6odPuwqiaEJlhGC/9yu5rrN1yiCRl3G63cT/f+zXd6ohkpiruYVlT+VET567qhrIWYFFsgammzoKpLbaRpP3o4ulGTcZpDMbrMyIlbLbk4qWu8nZNLkLw7kbCYdAtFoJu0b4u1xaYbSCJSmwAWsRA4WQvFLLvN84C61wtdH7dFGAXESHvdg7AmYLAQYAvlVcxeNLvgtAmH+qvuvbxe0bt2CcoBWzdQ8rZaGgXfSrhwUJiMakcPwLh4xQdonLfpZgxgLMJnGmovonb5I7byXpAJmLASNRBERwYPbkgtkzcCM7YDJKwRmcHOaho4jVmyxbupaMeZnBuo+aTL66jIFxZ6O3wslqbblobS2cnEYqCHXQlNvZjBnXlTiM/53A23JR5xNRoAiLkK3Lu61WC71SYp9Bcb2yhHJ8SXQk0L1WPADKjMVrCwJwAEQV+8XqO81i/L7XjLcQqwvl569nV2VdNYqDWlYDucaUKU3yq7d6HD4IjDqSG8iCzGcu0DIHtj33ZAqHgAYT/Mh/VciQ3JKSXEwdDMKYTNC+SdCnErOtWF2ejJUbpwe++iqfEKwTTcpB67MXnZwKcQja6crVOYQ5PMshLdK2NXXFpUG4rMvZOgwrzbzyebV1WZdEVq7lKgLl6lI2fRfomH1Ghsxoq8xU3MzjW5J/cL7UXKLVbM1e7L7YjLd0WI8WesbtzIeWuX+WoMYEWccBvAmewP93fReq4YORAok6ENCa8dxFnUJMkLCLSfQHOqTP/iyycd0o/dySdA2r2OEFG0zUKVuKl3zQ4cMNfLzQV/qsoQzRD/3QEu26pPyTFt0JyknDrOx2Ik1hI82VO5zD0QEwyaVBUKutLN3S8vmtzCUU1pvTKXZA1KvTeskGPQ3Urx3UJFmJHrDXb2YNRq3UEZu+drvbvN3bSc3UoomPZzxlQXSZ2oWHiOsHcmjOF6ugogoMCTzIuyROkux24TwQrUsH+bzIjFzBcm2Bdg3X4rHBCWcmHvzBfy3C+sfJkNC7sZsQiK0HyETfiv0qBSMIl8rYyfqokc0+/k3ZIB3gGddHN4D/SRpkBUQhBp8N2szrpm+qn01sBVzLVOOaA+Q6zMxFBR/g0+C7zB++zEE91Arn27ud22H82ymuryV+4th8mGsowIvqhngMZwmc3Gu83GncCF29zRK5DLmwCS4gz/NsHm8XiAMR2Jfg1t69z+MNyaArugsHnKar3kUzwgo92DXLlbDI0Cn8NK84i/vtutlJWQAe4FquBpc94Fu6BCQHLD8sAjASBYXA4A2epi5dCNHntTOtBSKgVONarkQmJX1wBhuezLCttiGutgEg2/FK4ip+2y0O6ZO+4inu4gr6qbbwsDzuZXlL41unj/V7uOVMmeIW1tHlRYZVCvS9TIKo5N09/5soCd7yBHI581Ag6z4aDJOzasnzIMJV3k98DHbJRJ2tjMIovJzVCYuct9h7IIuH0CVTmbRrrubUDm0cdQHZDjdyswWK8Nn/YI12/gt4Xp/NdWRa0BZ+Hgc3MdODLmRmgANkO8WIHtSMLttbDKKUru/7XulL/QyXbqibztUD336KOsDoLG95PKh7G6kEWc6bkAsOkwpnLcmgi7+Lq7Jjhs+w/ok0WiucO9dOnmF3fXAnu6PADh++nvJUjvI17ghaDvNI6uWGLd9V6uwKQbNImp2TPe3VjnE+T8uGsRHZfgGqBTc5UK6tELXDoA7gLu7wKQnPG0vk2IVaYL1dUq6D4P8GhrD1R8UGJ7ThYjvv4CsAii7iELjFEMnva7/2AM+GXS3WniDVDkvGW7d/F4v3FsO6FhuhN87cCehFFd+hlCsq3CALbc3dnCvrs57BJO/42AHlvI7y7UD5KP9mb0js7h3z8n2zKcz5t2jz1knDkz111i7gpy/0HaHtRu+0VZCE1agNDd7g5J4I5ZgJTtcH+6La1cv7Z6Av12vM8Z4BpPraQB3b915tGFlf/c72zf/vCzrG6Rf3c0/wGB/9md7VVu0HHPqnSbQ6CYzceqjcabzdpVM69F3pKnsaacDxjO9veqSJ390dqyfyr0reugkKMlnQLL8OANFOYLxy5gpiC5f/8KBBhbhkYYK0J2IeihX1XNzDx5GejRgvduQIMuNIPiTrnEQJ52SaNFrIqIT5Us1MmnJqgql40+ZOmkt+kDhxIQOJEUU/lKByRlKtWrS0DYMaVeqsWZImJcKa6erWq2vifAX71dAgr2ChnKUCxUwODQ8aQChg4ACBAXPr0sWLdwGIP6uQLbtmLfDgaIUNH0YsmHBixs8cP1YWWfIuXbpEhUqVytJmRp03Y84FjNdo0pNzZUad2ZIfJzVkMPmC5g8kWLCc1ZZF+tWmzX7u/L7zR7jnS65A4aKWXPk65tUQciuGieUYIkimXMfuU4n1I925b/8OvnqS7OXJkx8fXr2N//NJbKT3Hl9+dfj1zRPxAka/HTvFpb3jxh1ymjMonQIPHGie5xZCcMDARoMIkony+CMnizYSySSPStpwpJwqXCklEWOSSSedKDIxJvRIuAAoHNCiYoYZCmFKKm2e+iXHHGuhqhVWWPGxFR9/3CqQPvo446szBhkrybCsSPIMKNhioEq47BIgSyy1JGCBBVRIIxhnAFussTLNbKyZySAzrTLKSoHTEzkZmVNOOUFhc81kRNstNdVYE0KFCjxQgQnZijMlN2RqU/OhTXgjrhFJM6NsmuUcdDDAbKIbo9P7xANVPVE/be+89MCwDtX16EtiCFbng3XVUekbYr/+kjsnV/9MG2SQ114ZMmw0CSXcA0Q7LvSwQ2U1TJbEluBgaURnSUyRJ2qtvSFbF8s4EqszrOjDF6dwlErHX5jiERqq1CVGyCG1ysTIOMgaqw+ynFzSkCPjYCuDKuOyC2Au8zpgr77GPDNhNBeWLM9n3IS4sjjtJO5ONxHTk89HU3uUETQCJVSI2BqBxLjUjlGUmdxyuaRlS0QxrplLdx1Q02w2/eOKLDwlVb5QRy3VOm4BecLU74y279XyYpV1Vvg65e8TXHXl1cCqFVzw14ZkMQWTQ74GWziUPJwwWTaUPfsia2Oq49lor4U7Rf2qtaloGG7IYRAg253FR0MKoQUqdaAiV0f/dGeBRl1vEu/RXVbgtZfJeim5l40lu+U3qH+3vItgvWT4A5liLFWsdIUVVjPNjHeB0zKIJ/aETjrtBO0x0oMN9hjdKQ0t5j/xIITk4xyyjLNHe9dt4912IXNXAQvU9JxsulmF55591g5opMkbxJte2Ai6aafH115p871Ao9PZXJHmP6rliQd+rBucZ36tGWzUOJfDBntsDpkdSdr2IK24uY1uB0Tg2tgwCGH4YnGLI8Yk1gC4wKmjcObK0VIY943EdZBvQnpcJioxwlGQsBKGcNLkwHcBBsjlAHLpnOf0spc8iAlhZGJYDlXXJjgdx00Tmx3taueYhOxQNEdEoiuO/+gQJjbxTZpRXipWdjLmOYc5z3ufrtBxM3hko3rWWxrTxmc0VAHCgpUIH/nEKAU2tjFWqvoUfV6VH/4UJ3oEsdr86pcg+91vIflLhYT4J5xD1KFsAGyWAgu4SEbODUUJfEQlWNHBB3qvD4Xwxo0EN7jCLWUWsUhXLaAhynURwxe+cNeQfiSMH42QSflKkhZGwEKBBUyGM1RBHv5yQx2mzpe/NOKeQBEnYloGiEIsRWhsdyZmOKyZv9xlNP+yuoghT4nXbB4WBQQgbW7xZt3ohiPgGMY1Xi9V5KECMf7hjTIAYXvmUyM5y/nO+qBPNo4QnRavhkd+7hN/kblmywbZv/8BLouAFmpkAhWKQEFIkpIPnMVVAlELCw7jgoabBY/SdUpvMOWUH/2gMEQ60l48bhCCWJKSqOTCWnJuYF7KpQ15abpeBlNixyFmTmFXJzkpc5moe6bDcDhNYJYGiXs6qi+ndkVuNjVXAOKiMVYhTizIc57lQye3tPGPSaQRPeKD5xrlGNZV5Sd9s7njHtXqTz82BKCJapkgwwYHYyHUrjC5a0L1mgdH9jVFDR0FkCq5uFq04kiKcIpFB1cuTsRCErFwrEZFecrDgbRdrUAlSU1qubCwJQIOAFjnRDuwLtEwmqVTKmqDWtPXYUanrxViT3X3U6AK1bZ6alRSnzma5gX/yB1OBS4324eLT0DiD2B041XHSB5UFHYW/9AG0bz6nfe4c6zxvC5ZZyWFs9ImrWwFr0KcsygmGse4YKOD2NJwXJaILa9r2yt84xu3MrBBK6YcbOK854Zw3eOi56rFIjghicdmlLIepSxIM4vKU/ZCpKywF77iIEsOXImltnRpaWVQw5kKBpgLUy3Gbupa2OoUmT41THNStw2Mtdime8otbkezoDsCqIs37iI3qGGczqABfU24QpDFqtwlZO88z7WgOmbRzjRqd8hPxi52xpAH/2Sxj/0Mr1vJ66iwpZcOX/7ydFACooMysgwLrcmZT6Q2+LKBEkCiJN+oElGsaFJH/42VxCLyzAkBL2IRvvAzSDc6WUT4otCIAAciQOijeI2FLOAjQYUJhuFbEqACNdiDbWRWU9baYqexBTWoK0PEFNe2mR4OZsNuq+rnZBHHwx1mI/DQBlqjzwlAxnVydU1k9SQBENpQxz/WWRVDUCFocASCk2NVhOwq26rdRY4+s4blLBfxL7gx2SaEo20wg5kLb4Pbe9E837GpeSdu3htE+2bKroRBEU35BYEJ/AZ6z8He9hYwIvS9b0WAtNAKPiUigESkRj96hS2ldMK9hOnTctqmx6SYZ2QXaouN+nZFZLGpaeviVa+WGdGLXo4XxWNCzLrWX0B5bH4s5F03O56o4v+eN4Q9c+iigsnTffIPcr5zVo1BOFKzMpav3NbBOGN0uNnYIXhzXDp8O33fFrOI3stmM1c9zRw5G4fOjG6R+mIcCxZSVsyQiKXwiMBiQHsQ1C6Ge+Nbz/tmBb/1/VFSwMsXVyGSkZAkCDbIErSTpjRp6RIBhg/V4WmSWMQlvvgguvbEML545EOc8cPLGKlHBC6sQyFrk5/c8ysHPbN5vlwwoCLYNBf2LMxgbPd8VYw6h/2yXQ7lp/n8D6b4brW1FpgbIh0i2uZ206sq5OmA267Gpy+5r14S5mf9Eem2LKMTEYaxY7YqiihEGMKQdrXX+95vfzu/J6EIRZBi363APlf/RKj3JUHhBpIG/GgFQOkIXAETmj58YzSmeMYvnuKyLTXJyz+Og7wCPCrdyRXN85jOQwOT8zHQg8Agy7XuED2W4zXvQKfnQj1h04ZEWAvycIFkG73Y0wHZm72ykjIqy6csYipfIbobuo3cSLpNWC/hGz7i8zbkszrlW76sa75I6joIort4GQQzGLu+KYTp077tSzvvazu507dMwD6BQwQp1LdAgJerqAQjKYvMuRIZCoBKKwC6cIAKMALaMDwQWwxr2z/O8IPFe8P++z8UIx3mCMDJcziPC6rZ6p3eiTVZe0AGDERbU7nQww8KtMARBJpE2KoNhC7VYw+kUcQTjLKd/5Gy9RGToBM6FxQv0kGYMZHBGTyEbrtB4oO6qOPBEtlBrCsJQHgEQ3gzkeIgB1qwExoLy2EFOgsDr6iCLWBCMQgCe6s3eoNC8SO/QKjC8jOSJOwWN3ASNhiBz7qlwKO/Isg0AVTDi9sTzOC/OCw5/6O41tm4TsTDPNTDPdwdT/O0b6y1QPy8CIRHCZTH+CBBnquV82BER/wHdUgEmHM97KrH+SjBgaTE7DKr/rANTeTE3Ss6RsE2R0m6MKODeaRIVNTBHeyJA2JFVzwFUug6r+Oodqk7FJKSMtAbVAAEIzQDr9A+tHsDthvGeguEl3wDI0GENzjGZVzGRsMcJzmLD//4uzFUOL2YP4IhvGv8MMZYQzb0NP7zjDf0jYohMZ0aR3KkvKs0x3NEKnU8ja4Es0Fsx3h8QHmkyAqcROwZj3Q6PdRTB29YC2fLlrMsyDB6OqVLSBYkOl4puk98yEdRulF0uhukgRoYzMHUOSywSJW4SOR7CTHzqxNxRSDsBvzyhn34BlMihl4gwliqL0DAipRUSTNYQkVAuyXsgjfogmXsgtXUydZ0zSNxxm/xSRQIygIIwwO4zdwkgDAUvEtDymy0ysI4ht2YEzn8PxKzOKXsxIIwHebEyucUMVVLhtzpwz7ZjQb0sbAcRLG8grAsS0RERIIUI1dRmvOoglrQxw7/vDnqoicRDEgTnEvsOatDMIVgUMiFnDZPjKa+/L2VCDMJdI0ANUydE77i00GXaBu9KhEE5QMmCSzMrKR98AaRPCGzSElAwNCT6ju1MEJf5K8PNZLUDITVJNERFVETHdEU/VCvkM1vmRJpFMNbiiHfTEPgzB3a4YwcDTWqrMrlFIirbIfmhM7otLzdqs6uzIVZA8uVawOyrDUnLcsJjE85KpXqsi4cwAEz0MANhIYPBKu4fE/4nNLyoA6o8a77zMu9PDobegiITLriCzKdE9DCpIEfKNACTUwDVcw8fYkn6NOTYBIgGYdZHKzMfBwJO6kMxVA+qC8ODc1vgU0udAMS/42CSrXU1fzQLsjU2GzRkrwAoYzRueAS3SwAwqPPGlXOTnSMVzhOP8kpJE2mHs244NyGH2WHWaXVy9MtPUxHrsyM7dxOKA2yQhzLKBU9OT3WNaqV+ohELMWBLfgFR1QHSWC9K+UO8pTLE5y9/DjI2UAGNE1TaxuTo2vT33sUTOA7OL2C1qDTAD3MwDzFEjEg/0yob8sIQ0AFkVIXDiLUzHQlQeC7RFVUDN26gkULzupUKLnUSl2DSWVYTbUChoUSK6iCXqRYKiCBCwtVz+kcU5WFDktVVR3O1LCYk7GF0IjVairAUrtVWq1VW8XVlrVKA9xVAzzSX1XSYI1HYvWCXP8zVmbzgTGlle1x1iqI1g2Mrun6R3oUU/G8QCCDGv5gn2zAS/z8o/Haz9yQQXOFiDoATC4AUMIMMrHVuThFTD11lqjj05oArL1hl+gzKUebl4AFhA0p2EY12CdRkoiNgoZl2E1t2ImNA4qtWIqdgWjc2MQ9yo+1UZG1Tk/rVZ+q2ZWtQx+13Mt12TyZXF292UDslGLdWbLsTpXz2VxLVrFaVhwgAvZg3dZrPRzog7WkOdVzVlNZ1oJsNqcV2uSaT9zTlPzkxAVRjnGNQd8zV0EYxa+dyB8Q2zoVW7I1xbeR3rWFzEoghn4FOH8VIYEF2K9Im7sF37tlgwV6kr7128D/Rd81mNj1JdwpGQEESLgBELxQXVxsvMPG4EqVpVzOTU4iwlyZBeCYxVwi3V/IiNzQ0Fl7ilLSZWBcw7UvcGAHLtugdc/yJIJ7bNageRFJkN2Zo12ixd2mVcThO1vvolpp862aoZlMIV6+rI1OMK9z9Zrp+E9ihWDRLdt4XUxooRYGHQSH+iiIAilW+tfu9V4CurpzO4nmy4i97dT0TdgJs4IZqNgS+FT5S1wZqt+QvV9LWVUk3VxnWlXaIhDxCmCY/d/g1NUi5V/dSWBD9NlbE1YjKF2gDVo7bjb0CEEs3ePWy2AspYJJaETU++B/xNYvnT3dHdOoRcMVBLkAUWGq/2FhGARFrYXI38MEr2W6iSTdOKU1whxQnXkWJJ5ecBMEWNwb7MVMVGolWxTYCUtQOPDTFPneJWY+utVb9tXl9S3cGZAA+N1YwZvfLebiF6NZo2pjhzHjZU4QNBbgl2VmD1vjojLSowJW0CVLOtbmbYbgW5NjOcZjgqTgsQrB62rP2g3kDk49Y8PSJstdChRnKxVhEzRTKrNLTXvkqn2OFn5Irf09gIWIr2GJblveJpXTOb2CjKCETmDoSGjoSBCEATIgcAPCIM5eEIIXygkLGPk2LaACWta6H2zQkQ4LJ95lwyVcKl6BK8bilgZVLa6BU72dLjZm/Z3mmybjM05jnf9WY5xm42Y6hs/F5mze5qI26nU96nA+RIGslabW4+yq3SR4gkRQZ/VsZyyVZ+qKZ3hW5FZxjxCuvZ3ZZOwMHkRBjjHJZ0hu4eK15K7BZHM9hDgouRx8wB/Y5uqQA1M4hVUYBVXwa75ehYWGaIlGxTjIBFq8zI06JcPK6H8dXwR1iVnu6CSuA0b1n+69ZVxWSbQYXLXwbLSQkcMF5mAW1Qwjw0s7mNTKXOrkwyPtytb2aVlVCGeG5p0W2dheNaGmDrPq2QhughtOOaMG56RW6nGWj/ZY1gxe3RVp53RG2lZYT0nU1q126t2FFaH+bW+2J+D5mkfhLWdAiLWmZGxz67f/9svg+0osSB8aUDky0IiOvAX4jm/A5utHgOiOYAmAJQVCFeLxQ6VuoRwmiejIhjqoQ1DKFmnMzuzuHV8jfOzPPtizCG1f1liXFmbPKcOYThkhfTFYzV8w5kPcLgzbpu1ozlWtvLxqfqb0GWrfLt0bJm6jLu739GoMficNfpFWUGcl89JITGSu3uoap5Xpno/o3W3tJsTRbYNvFB4lYhTxZmvzEgTzjgPATN5CcgSIThS9XgWpKgap8mswp2/BjuiW4AOP5O8HYoqraAWe1NC08WioK5rJRvAEJ2mAHWkmbnCPPosNBe3Q7oAGqIsYGsOWzossGdUu8ViQxTis/OKb/33cD5fcY6bcZ67tSyfx2xFx3CoMz5UCFwf1GB/ucJ5xtHzdQ9bq6mruWdhxm8Nq1/Vxa1Vkgixn15t1Nrr1NsJuHP68lAOO7oYIrsGN23jh8jZvGf7n+/vrZYdvvp7vvgbsR/Br+85yVbgFe6jMB7oHCfUFHhm/NndlWIZsOeeCA6/zPF/wdMfzxzZYPk+LHIB3K4YhQ0f0ej/0e7c0LoiEhsuhyHXVSAfxEEfx1XpmZy7xy2VtSi/gz+Wu3ibqUC+CUY/xO6Z44wbPVyFP1s3q1gVk02PLDnTWWP9x+ojnVmEPVBfId3ajXYdS7aQDzwMzQlK6CEmU+4Nh84bhnP9/4b8WEzFx9p/362BgdlWwb6KHaGMYVAkdLFoYYnCvUL5DCQKXbDmf5a1TdwXHenSXOo8+s7SQanhvi0KPUXy3d9Kqv31ndEf3d4APeGUSeHS8LUuXe57u6Z/e35U7RIdnNnkU9YnvgRm3eKiW7qxuldpNBPREPWi4udYl/K2GvYEMwa+W51zPdUvcbV6fyOzUfOwk6C8jpGExhZsXdtuwZJ7v+Z4H+mWf7zGf9vumhG7wh8WxB6WfrMnKwkpY95NwiXmlm6vHbAxRdziHbHdn5xyQd/mN0c65cLM/w9Hh8Ojs1ZJdHrdP5oFntfs1+INfbYXvuHiEeBeXeL+H/Pf/SFZDXlqRP5UkAGTM+oXTUwfpgifH947Hv3XHl3xyHitmg5pSFFaAQENHIMGBA7FgofPn0CFIDk1FWgULlrNgFW9VVHXrlsZiHi2CBHnqVDBVJkedTJkyUqQ9jlT1+ubNmy9v92jObJVpZyVDgtiUqSNUDdGhQY0idcln6c+me5QydcqUzVKkWspQyZo1Rw4NDQoMICAW7NiyYgWERav27FqxEbDIcnZtrrW6dqdFy/vsGN9Xfv+m+puLL2FlzA4jTqZ4cTS+ex9D1it5G+VwlS9jtqx5M7vNkhNDZmx4dDO9TU4TuYJadRHWRly/bi07Nu0iPWzfxp17N5HbOn4f/xmSpPfw4TaMA0Fig/gQIjiaJ8EhPTqVJGUSQVOnDlVx5N6RKE9+ZLx44OZtNF/OfL3z8uRTtx6PcAwYKbhZE7yCRj9/gwrT7NEQJqZ09BE3IG30UYIIFlOgSqsYIxFHD65k0iOrUOKIIJSMQgox3/jzjS8y+aJTJT0J8pNVcCQl1FNUuTiVjDPSOONVVlXH1QMGhEWWWWy1BaSQaDlQAR2dyEXXXZ8RZgtgTxYGGpOiORaZlZPlxVk7lW2ppZdZXkZlaKSRmddqXpy52mw8rKmbm7y96YOcc9L5np3unYeneOBFN50ZqGgDTRnLGVccodAx58JwiqrXqHreERdenv+ORjqFpfSliakXAtnR6R+QuPSJhCUZU2qEpTLYoIMTmXQRR6zCMqFKmcDaCa2d4AoLJbvuytKGxoxDTC8xCcPKroOkCFSLLVbFR4xQQSUItNJKC+2yymqFQwYQOLDAkN8GSUAAAXxbAAdpUKQkmEwO5iSUUT6DZWnzlkmvlPIumVmX5eib2bryjimmXfyhBp/BbdaGMJtw7uZbnXXeCcSj4UW8Z3QXtyedIaiYgbGhkK6XhKIuHIceco+i11vJFLfHXqWXaqqfp3Y0oiFEN7MajKmokppqrKk2uJFJPwutEYUn2coqrhzqqrSvEPZCijG9RPiIU9e+mDVVzTr7bB3/KVpbrbVZI4UtDiRYUK7aawPpAAp1pJuvZWO62y68915pL94APyb3l57hBXiYgwcssDUHp4l4wrSxgJoRCz/e8AsOM0xpyxX/oKcO3XF+cXTtFTeEcNGlN2nJLjCKHOpnW95666nNR58eGjryySfI6LyzqVTn3nuqDirI4M+U/Mzqg6/memuuQxPPq0oJYohs11jDWCPZcXgtlNhkT082jiVsy7baa5EbLgFvx12Nuuzevbfe9bqf95V/dya4v4Szb7iZiaupMORx/k9yAqTB5BymMsth7nJ8WpnnPueojwknUs4RDskaNTLVgex1LnuZ7CA0Kqplo1Qg1N2pdua7/wUJb2hFe1XTdqKKjDCPhctrHqsecaHjvWp7aQDQU6bFNa55b3s9zB4RcYQVbTHAW+IzHxPNAoJDpG99hQOG/uInP/jx7V/00wy+KJPFKb1vf/3zHwEdV8YBQq6CZ7xN49pYwDwtcIPm0VznLja6BzYqYow6DslC18fVoY5S0nmdoZxDnw6KkGojRBUJeWYMaTCIJAgCXg1VkQkWujBnuroV85JHvBYejXkt8V7WrPdDsD1le9ojZRHLBhQqjMACSlxiuJo4FrehK0lSlAwVe2nFX15RMXyrUr/s5zf8DVN/iiNjANGYxoUV0I0skObDTHfABBryOBi0YyFPdidFif/sOSnL43Iu6DpBoiybhwSDHlYxrGz0QhqN1FnuTEWqEtITeB3ZpwphJStaybCTtepVKE3iqzzsYYc7jBG1aOTDVX5tiNf6w7JYhKPw0dKWQyILLqMIuMKFsV52iRcYQ9rFxvStmMjUohdXGsxnoMl/zFzjNAlYU5velJo5xak1L9fTdBKKmw7EmAS/uajpGEeN6tnjOREYR5jZ4RPDemcjqzpJR+ozaCusFVeNBgtO0oqTlbQQhsqqCqt1DUAK1d5BUQlEVsJ1oi4aikWFAhQYcOtH4NJoW8p3SxZERH3rW9JLgbmY9oXxo/NzqdxOmkwsyhSANHUmG1tg2Z1i9o3/mWvqnHy62QkWMnURZKA37TRak6GMdOgRJ6HG+dOXEQeRIKyn7kZIW55FUoVFGx6SbhXWTDiDq2OdIdOOhlaFKvQQdeUDJtzqXInKNa4VTcNRypCEDGR0r3wtgANeEAmPKEmxjxUYYlDapPaJJnDiJen9HOve8Y4pspSdLE/rm1n60omzr7XYysDZnTlW7GOuHWdSHWVADSqQT5Yiw0umCkJF7i6EusudJEu1qt3202i+VV5AiQtK47YEuWtlaHNpp5TtdS+6LeLhdJ8wqAqwza98tWUFaPBdbIR3vfnT33kFg97yGjMy7X0vkYF5GtHJN7/4jeZ9m2xf/e4XdAKG/21q9BRBCmrTwK492YEt6FTYLZjBw+oGmR88jm68c7a4xSoK8zkhjmy1ExsBaFiHS9aCsiShImbxiX3VUOiyspXRJQOhLeri6y5gXOTLrnbbZmPwBjlwO3ZfX971Y/Xya72MLTJ80Zvk+S6ZTk4O9aTcFGWWUfBzGUygyNBTuj1iLJBQ7i+V69NONKMYWGcmcwkdaU+juVlVwcXk0GJovKRxxHk0pNBx91yUaaWooUIUinL5rGLlrrjQcEiDEm5AAXHJWFwxXrT4anxjwW5x0vCrdGD8cmn2ziXTmibypjud3sVFTrJLPsG+R/3kar4WjwkuWWrBjLk7ApVkqAPnrP8rWNSQgcERqAAEF2pgcTlhYQ+r2HU2TmFhU3n813AeeUmALSs5f5J5svDn8poWSqvVwdnLZW60a/5W6gEaunU1NKEP/QMTOGBIii5fuGf8rbecG93zNm8V++IJH78b3vJeOqervm7E4JvUWvc31zULg1lfE9XJYfjAzQMyLhO8nEwFu+vSkwRbr0IQagiOxVGgAhbUwUNoPrMwrHqqVvVsq8iLlfFuZeeCYijEMmco2Gqec2wTcdoVBUqhiYo2oYu70Yw2F1x0qXQc75I0vpTSMZ7k7tGTNPVA/tsXrW7vdSO5YWZUMuX6vfVRs/3rCH6OAyf28KdCKu2tRnvA097/0/rwoUMt+QENagCCCHBACWrgAyVi8g2++/3vJc/wPr96SVbdCs4vv6HVHKFnOoj4WdWSFiaiJd0Tj23yQakPxkgwOQg0uuibL8u5kh5pdVNJLrTbABITfK0L1Uldvb2elNzHp9ne5PAbk4GakxVfBYLW7w3cUGlZOlVQq23gB+4eO/XK3HXbz92dCfgAoSWfPbDgmTXSSFSYg5jcVxkbrgAbP6nEhdhQnokYF1jbn7HV+82VSwzhisjBESLhEyihA9lfCHBA0PnIuBld5q1F/3ne1IXeaNyNLwkgARagAf6f+7SU611dmcReM6Hh7XXdGgKcBR7KUrVWN2XgAQ1f/+poUx/lHoKlhq05iw+gAApkDhf8nPOBQCGCwKOBiD2MAwlJjQndYA3KSiQmCPTkIK6MUh7sUOwsFFs1Xom5lYoN0fRUV1H4IP0Zygi8QAaoYgREYVpo3hQGiRV+HuitVy/ZjS2WnhceQ2PRxWHowi2ylKTdzRgOWethEd7YxhnmmxpK4AOyoe7loQ2goJaFU2sV1fD915Qp3B+hjFIZnwWOjin2ADe6gCEaYo0xWPWByK4t0sdFYkHVysjN2cklXp7FnA9q4o1QCyS0RIo0V0TpHIvw2VspyxFWXgmKxwmYgEJuC7fM0lq4IizSEgZkAZLMYqTZortkZBeWwmAkoP+k4YUvAiNI4k96kWFhlZQYyR4zOuME5lQEeh0I/hQ6YZA1ZpNqqZbJnA2s2SQcDhg09tQfRQf9XY4a6cEg6EFwHKJqJAQlfAjfoRlVfdwjzkondcTOwKAOZggPZqImAuRDiY3YIMUhYI90JaESIuTXLeQq5tUBNFpE2lLRySUBUKRHYSHhbOQt6qXqBaNIemRf8iWTnOQVpeRhOOAzPSM0IeYzAqUbUqMHqpoCec4dyhpk8pE1LopMBmWkhGNvHKIcMAUqoEKxoIJPDOI0XRwfGEMLRqXuoMQ7QuJJTCKq1KOvmF8mHsQVlCIP2dw/ppIQCloSksESECfzKeQJcAD/BjikW75iLZFbdtVlMcTbXYZepe3lF57U3OAiYILRLvLivxAmSRrjYdpXYi7mS9YUTMZkNG7g2l2OyCxc6ayaN/6kZs5acYBBOX5mGQDCaArLsJDCI8wdISqnCyTfaJIZMbRmhKwCKRyNb8mmI56VbZrfUKAfwZSickVFJ34itY2l/I0iUWRBCTLkE0Jhc6Koomke55kCMkwndY7hdsookAUj4GxnjsWoeQ1mYJJh1tFeeZrnGr7k14kTfVqTTK5aBvaee5ZTgaldyhBfY56H6JAOfh6B1/Fnf0IDNEQNJcQcDMiAE4KAEiyFDZ3COFxfsRiDg45EgxaNJcEph8ym/4VNaIXqGT7ix3xY1IY6XqAByFVAnvwZJFqSqImeaIrGJaPJIi3C6EgdVhUB5tzwUgHWIulhJ2iYpHh+Jxih4TJWVpAKqXreV0/mif19o33+BvEVkgQZH09aYzlJ6U+12h1ZCqHewKshASDMAimwQbcJ4sItJTvZ2iP0goIKQzegQllJDUow6/OI0Mn52Z0KYp7uJoswRbSikotQVMwJJF1t24jxHCkKYqFyQAOwIqLCooqqDQYcSZIw6rvmqEm5l5bohS/hqHgaVo8JE6dloWHq23mCKsA6GUyKE2vliTdOY6OY6qmKnQ50IKluoJNy43LEKme1mnygJQuEwEIqp/9y2sD8FafGciwIqIA5fuaFWB/VjMSbyuYlzemE+iZyYcEPMKVXWmtUlFhAHoIWUBfPLpTMdqUPHlrPpSUEIue57l8TlU+irc0CVAAW3FhlwGu/8is1cCcVcWd3Rgm7OQnqzeu9CqYb+WiotSSQpid6XhawLpxMloCRoqrEsEyS4gkI7uTbntoSDOfRiunGLmQLAIESzp1ljSwGmOzf8ifKkiYMKl+HzCbv1CnYVBtC8EcgVuueml+0EWG2rVXQ4ilC+urnbtYLLOz9KWe3OC1Htc2KEp3+tc3TWqS7Tm3o4Su92ai9ImDhdKHdwNvsairVkqfAhmqT9S1MHmcgjYz/lo0u65wqTb4h3AbVASHK5jhmxOrXd7zddQ3vkxLKViRVcv6hegJBRAFCJbBC1IgmKvRaIoHcDjKFiIIuPpbisz1UQIor/Hbue4Ru/nqdqTYhQ6piQ7blLT0kilJhWXTLEUCIhIEeN5wDA5OD0vFuL/LlOtSoo2JnY+XPKzzd6V2w64EkZIytS35q2Q7sNGVv9trA6BKKCtMtlxWsNQ2SwdqtTLqtgfVR5wjcQuowCh6FcRIsEESgi4koG6jjfwLozhxr1aBVWlkKxtqvtt1sVATkE9sveehvM64nkaLiDdhfCXxdE7LlAnjLAGcUGYtxBZxsgxRDCIkDOjjwgVht/xxH8GKBSZDRKAazjyfo8dPxKEpWsKSCsKcCb8AK79mmLXq27dqmsPaqnfLOMBf/BqwxiqwdacUu8iMDlSGZIlFKIwN0LAOAclAtgVry29AarZjiQH86mCIVizC4shIDAhM3sRNnIhRHiyoZ2hPfwHxY8RVjMfPl7w0I8zBPRwzv8nAcrRgr8/iIzxlPwDMvpYAQCEi88QOvgzSsQzZrsxxHMOvlyx83Rhdawgb/ZTGGJB0b0/okQ6eKcDuPsPEW78IR7w4DKwmg8PLap6I48n7tcyVjcgsv1fUOynEEBTIr58amMEJPJgycwDDDQCEe9MJZhxkMAvk6mCu/8ikcS/9VcDLl2hrRapsUeyvnFq0vx2owf5YwI1UxI5WLUZ5BU8ByCvBeDbAyF8kzQ/PdOcFrLMRDIINhQNI6vMNQb7MWcbMce/PXMoM4M8I4O4Y5+3HvEhYzsLOoBe87lzA8x7M0Di8907P9kUByzLAMH2xQrQ57GhjvTew1DdgNg5N1rRZ/dkzf/i0yF29DKyEEQnQGmOpz2DND6wB/jsKYodnUoMQSy0FHd1vPgcESAu4RirT7wm9Jo7RDW3ZKj8Awf+71NpCLaQUSVk9BP3RMn65Ni7G4jfEsmfZN43QFVIAKwLYMIJlANIIo2M7t4AI2F/VRa0YcF3X9/N83a/A4k7P/d2aJNi/gBP+fIDM3IWf1XautyMLzDvOtKiL0JS/yFmPy2bDONtbwP2Nyc1wQO3E1RQICXIc1TFtAckKfSi8hFyO0CewkPUvB9GVCL0RllyK2HE4B4HJ2SLfvUFRxZWN2X1+2ZY9yDHe2Yx9FjcRyLLPBEyjH87n2alv4Mpu2a7t2yZYsycp2fNI2IdjB04GC7eDCiQc1NaQ4Nvv2NgP3VN8rR3YkBzODZ+y21fYxFpGkjVb1IP+oO083dHv1kLNlTPMtdiP5DAOSdOgzk/pzPvczOV2mKDe2DRw0oUzHcnjyev8vXjf0DeQAF49A34b1NsYzF2wIgIrmgx9R3F4v//019mODtlDYKmVj9oHjuXsz+NsNMYNvzYPz6YY6i3pf+Gmndoa7tiGW7Icj2WwPAafggafUtkOAAor/9Ipns27/dr5cYTP8Yt2MJElSw41Pw4lHdZA1N5Cr+qd+tZATOVs+MwSsNwqzcKNwNw379XNgmZJb8mrRZ3ooFfENSiCFeZNSgRlQgQaookKOABUYgiHUbZhnuQ4nMnTTwBNY9EjQTpuDR6r+t2PbskDiY0oTeGYj+IKD+xLeyChWV1AEOrLQDiDA+yDstzQq5zOv9kzbtIZ7ryGiTqMD/KNvih1sCqQ3wqSXOChMQ4o38FATdaMqCS9I/Kd37S8m4G9nev9UgzNM9TjZYvWqt/qriyl7k3aGx3et07DCPTl4ozUMb7IhDAoDTOOxh/kH9LUWPMGYM2QDkICEZ/kpS/c0CcKaVsJUzB1/f7tAi3ud5/m5c0FL7zmD38iNxEHVU4UZXH3Vv3vNxXIkzDuySI8eUF4LbEus2zQBWHiimyyjB3zAe4F97Ed+DLyklzgu3A6mL/BRL8Pe870yVHopaKHUuXhRK7zq3Q7tjmHHsyQWP7erU7fJkjwFTEBb2jQFhIA0orzzmoc+4/OUrryS9XokJ3kIZuZCejIoM8BxSDt8m2tysiVfn0DPHxFDW/sJsEGHgP1L/1ekdHacE+q4Erhls7T/0Mr5VUz9ul991gM62HN984N9vEebzdgQ8/fhaEt+hjtzohNuIcan6MQnycY2wKPGFBS83EN6pF9C3Uv8pVvEUQf1T9t9wgM+UI+6iuO93k8DBUuDZMw/QEQTOG3dwHAGBRrhoVChC4Y9FtKIOJEFxIoWX2C8KHFjxxYfQYY0MZJkiJEYUKaksBJCywULCMQk8HKlCRs3ccLIqeMmjp4ukjjUyXMoUR9Gke5MulTp0YxPoTYlwnMqGDJBOTBgYHKrTRJfb9wo8eQGiQwcLpxQ+8QMWRI4npTR4vOrWrU1uAiqBIhvGTBJgAS2AdgFUMCH/wImc/WIEsc/HkMOOzls/w64XJ5gxqyFc+c6n0F/ZjNaUGnTg1CnjnM6UurWrF074vNokCPatlHf5nO1RUqaExZUcDBcOEoQIAo7HLI8OXIMLjCoOF5YxvImCtFkH6M9e3c8dsD/EX/pEiZX53EhUy+NvbT0n56BmvZsV3pq7aWty7+O/33/z6iJZh356AMwvgIRSnAgijRisEGPOHpQQo9sEqmkkjhQiaWWIHjJw5gCiCm4EHACqyimgHLhxBVZbFEqF18sijCmklgsqAsHA2yEuka4Ia6y6rrBDEOe+IoDuzr7wa6vftAitd0QE+yyoBCrkospKAvMpyu1XMLHzOIKUzPPRBuNNNieTA01Q/9uS5M212iLU84255wTEL9+AKE44opLabrkAG1uCAw9KPS5QK9rQoopuNvOUe8gReMPSEypND313sPlk080Xa89/djTD9T/4JvPwIEQVDBBix4qwtUJIYwqwlgpBIkks9S6MAQNOez1Q5mApSkDknQqrMembAAKRqaYjXHZZ5uy8qaRcixr17QaOAEKKnwCEsgGLOhVW84OM3HKbrOsrEsfl+BiysiA4NJKMD2rlzPRVssXttbspIRNfwEGuJKB2cwtt4DlHGWVhE9ReJSB26yRDBb0FO6k6V4dYgqr7CCiOQ+GSPbPwo4DmQjksgCjByLyGIOIja2CY7ErsGgCDT3/tvNC5z3+yE68STnVVD782IMHnvbeIfo/avQr1cCCUE1V6gZhpdUpqKy22q7mdOU1XF+H+1VEmGR6biQTc1IRBxxShLZZt529+u2d4JLrMCAwzBDcs7J9yzLLTtCbOAgytEvdEuqqUK2M0nXh2HQnk2xMGzVTg0x889UXTTUP/jdgzwcmRXRWRM+kEoaFgfgRf08RppeAW++F9F5SX91hVijR42QT/irZBTmmAIoP2RzJgzmUVT4OhCT4gC5Dq2y6E7lV+JjK+tWVcEKhPIzZA7sxHslD5yu8AGPTT1YxZhVQ2P9EmviKVjpUpaGGj0CpoxYomWRaFap/B7MmqwDe/+Ujusrb1xA4HLB5iIEHIJuwvOI4GzyuJ3GTmwXhhsEXEUYx1ksCt6bFN7R8ZW1BigsbnnCBcBXuCYNgg1ky8JYese0sNYzh4nSCq8CZ5C1ZkpyNOmMvM/FBc5s7zSD81bkkIkxgpgtd6ES3OkpUohfjwB3siEGMU0xxFazoxRan6LpHjIJ0EINYHYbXA+H04E5GyIMeADMGnJHMBmO0gXHKgAowKA8OehjJI5JQgRBsMVmFsYHofFADifDhda8awyrElyg9rKJjdtgUeAjRCFGI4nycws87jAZK90ljlEszFf7wx6r/ZaxqVxtgrSyEq2uZRIQJ3JBLOvShDZHNgf8jKgldcCLBuQ1Tg8W04GXwtBXmoQKFO4xhGQZxhiLF8JmDmOZZbgCFttjwLDiQSwlmaUO1XKCWKzlSWpjkmM2IRi75QuOZOGdEOBlMikxsYunqGcZM1FMYxHhdE/35MEp08YsAqx0ptAiw1g20YXKAyBT4oDtAqGxQL4OOTbA3ARNgAAyoAMRGQyAXk1jTAiYYWAFJREgUVGSMgKxK9zy4KUZpjJLjw4MXvkMIS3ZSPfDY1NE25Z9SUeN++UvlKv3XSqW+spBcC+dZvDa4XIaNJgyggFVR0suZTMBsI1lb2waTQWIac6zRklgZ7qjMD4IwcD3cEVQjQIAMaJNbOzL/kgUO0CvC2bUuGXgAN8EVAcFKtSUxhIzl2jnEzK2Gnmz6V2PriUR7sikQTMxEK1Jnuls4cWBXHJjrWmFGKoJWoLTDZ2ZZkdDPfvEUZdyNHopHhOItBzm0XZ4eJkqBjSYhEY+4IwgsN1I16BZ7tEwCbXSgtkfMRmUvO0X1iiCFIvBhFVjamCPAg9PxDUFn32nEd8Hbvk4mDT9OC1Cq0rM/ZfCPag9N6qyWKkCRXIQEgTIgXG25krzq9aod6hVK4MrL4HRVmMoq64HFSlacWOVGOZnSCMjZK3DtzYSA86tetyLLDFwAwn+dcIcKEGIRjzgCaVmCHNjAl2iqOE2CcGwT/0U7WRlPFqFObIUvSOcL06nWi6YVKBlpV9DRNuxhtBsyF71IZFQsmTZbBAMgHLG74xgHDLgtA5X5skfg+tEFjyDDc1CThClDsxJIGAkZvJy7wkwBktH12CT1ELLtZJfO3Y0UTr+zSfaJlz2jDCoqEdQqVg5avvEtNA6desCUWJW/jWYJV/nrGwFz9ZdsSzCCMe0iYFawymi1gVympZYv+SQDHCrcl2D4pSpU4cIM4PAMVq2BC8hahQ14wIQNkOsQx3XEBRjsCb5UiUkM+3RmpGyMnxi6Psw4n4HgLOtuoWPNiu7GOy6d65IcxUx8sYxhbEW3y5hkM8qOiks29xf54v/kQXnAOBO1KMru9NEtCxcDMHAhG3ZlghQbQmS4JcJyk0WENgPmZdTFGcfsYOc6d0e7N8Vzni1hCU528nyAXq8yVEloABp6vh0HSX3vi1+v3XK/Ei65VsypkpdsldImASfaFBzzSwecbme1200iPKwy9MGFMLyhFs5whhuIkwqGqMJbNSDDEqhQhQjI9QNIgOsIGGDqvaZ6YDM01z6A9tvJfrbXi21PsSu0E0+8xWYRGu7QRpsU3k67E7Mt5NRiG9tHDp3rhnxuVKyC7w2baPKeXJgyIAElH/w028qAbxM8ggr1tqa8cRDv5PClBXrwrYrUbL3lQLllNu1uwu88Pjz/Pzyn4SXln+WT3vqkFyKCnhDHD+1xAyp65P29pVWDo9cBpxyqMAmAsG748Zlnevg5EooH8XStrLfkBE/4WwlPgM7AtQTrY7GMXR9g9RE7HQENmHWEtQ+uEc8VEIaYBDG84Ytvs2LYxJ6Esp247Ck6++v25CzcM9v1vKs2s3Xfv9plx/+M7InwLu5aZ++U7IuKRw30gMukJwSYBwLxLfGOxBCuDAgeTwcy4MmO645c4E6EJ+DCRyiUYwgAARV0B6fCA/RY0KZu6ju0q+FeMM/Ei33Qqz6QQeM2rtBgT/gSrWtq75YcDdL4K/d4jwJ4aSYIh4eKj/icUCmQ4IMGzwQY/22F0uIs1GKGaKjUJOzWbEgDrA9xbk3Xng7qas37OkACai38CosEqGA0im4WvCH91u/93g/slG2K6q8T+oCzym6gTCe1pm1gcGy1CJHa+K//rqjHLiuzKEHc7m52zG3JhAEBE9ASP2GPcGskqAAQUGLwKHDxnsDxYOCD5iozPooC6miPiAAQTqYIRhBQksUEUXDO7AAMwkO7MCkGFQ6THE4G8aARKk5+pGGVXsWVkLEHfbDjLqSrglAIHa0Io1G/BEy3DKcJZQ6DvuL4OC1HCGP53mJbkoBH1iYHzMAMRkBvakgLv68EYM0KcOAMH0ANP2DpypDDrCAOxLABfE0DuP/lwjbMm2aACqjgDM6PDu2Q2PAQ2SpB/pxtoCihspCsFTbrFlCr62ps2wKqn66N7kJrtGwMAPWQFMiN3IisEseoYQiKEmkn3fTo0+Qt8YiI3nQAEN6iedggLFwRA5CA8WrEy6aHy+yLeaqLwXQxuxROBpMypxZO4tjHPogm43RQGWNPJDTsvp4RGrVyGltCQ4BDJoYDC2EuG8kSWQzMrAju44CNIElNnAyhD6Cgw2oIB2KN1rzQHHNAAv5KHjOADL1vBeJgBmBtBG5tBLbFr8owWwRzIIEui3xB/dwP7u5vIWFsJDMB7R4TM0kn7vwpAMsI2xjR7sBN7lChAMOtNC3/cRK5DRpKEhUMgYhcUXhAsMsaDwd8qxWZB9h2Ug886k6AchUB5UYcoqPibAy4q5JWkAUXDvRU0Ge8o/S+a+JKyRipsirl62ywcvlQogpvCRpLzjulcZcmrSbKsjxnrkrQhUf8qtVqohxnIB67iTC9T/wIwAAkoATwcwTwUwEYIK8SwIHIUNcYID9vzcMSoD8PYAAOoPs47K06YBDQrxYgUyETIRGUrCEpszIvEzN1DDQ9tHQYMUTfDhLNrRJQE4xQ8xFVE+/IKAE9kxIn8blAkfJokyd30gxo9EblzQQ2ETgvqgyEshUdgTnKZ1Echc6Y886WE6eOM0l9ZlIYIlGk/7Q6rVMkYOAHaWlXACwrt7I7vXRwgEM8E1QJzQYKsbEsEWeDBuMN2ZIuqJD6GC3D1nFt8PMC+vPpBNRA59EdUyAFSkABxvTpwFADum9P61QruC9AQ6xQP0Cb+iC1ELJEK9QyG9LZ5M/rys7aLlP9SLJTA1EAU8fHRutFI7HILNHIxkjuAqq1XBRGvcgYYpR6TjARVER6Ai+kpMcGYlN6Cu+jPjB5ZEAFymAVBiVkIipkQoYIdOZIG0VJRQ9Jc5HheFFnXG8qqbQqQ275sIpLu/RLH83RHIgAQsSBrLG+cuhM0TVuvGnwWiBeVq0MQqAKGYAEhuTo1jME8BPWcqBAGf91BrZgBgi1+yQgBYIAYO+0+/j0T/tTKy5AXxWW+xRUUW1NAwZySFKrFhByElBhUjN0MjVVMpMtNM9v/TDSU42BtRrGJLOtNFF2Y6foRFmVJWEVVi8xRlGBNe9Ej2yUE12RRFyxFUUGo1SmjTzGIT7hZ/2NSB2pSI/USZu1OaGVF6W1Wq21Sq0WS7OUlnhlW1OuW4nwW7uVa1duXBdULMcyXdXGPHME1Hgo8aggHddx1eATUQmnCvoAHj9A1va0CgQzYBd2YPtWT8cwUe3TXwVzP/9TYmstB7ZlNOwW/dJvYyvUYynXMjerZFt02sJNI1d2dFrzdliLZm12yaBodCX/UURNl2XN7QLhlSfNQGQ8Da1KYo5wi3gm5slko42SKllhRjse5Vk/rwWXVLpEj1oF7Tp28GpfCWvN5jlEjlvF1muREJdYQkN8b1yXkAnP9kyVZdPO84PEbGHdNgks4yz0tkBdAgHacQVWYOn+Si8JN0ET4D7vk0AVNGIHIFG7b0H79F/5M35xjcOgwGCr4GK9QUIpNNnoj3Kt7UNPS3M3t3Qy90JPQXRjloKRLHU9t3M1eMkaTGSCdlqCllrsq2htIi2Tw2OQVVlfhlGY1WntYAjobDmiFReL13ipNnmv1VawNt80hEu51kurkKu+dnptDwPklRoDAHvNNl13wpAM/6k8e8cBuMJv6qrVBNfWJtYdD3VwEzVxGVY/l04N87dQBfZhFWAD+nSM+REBPmADLkDX6nN//THoEgEatCFyywju+rCJ/jAQz84iSUuCQZSQb0fJLJiCFXmRFzmCT3N0ocE1EyFZnDFrZ8+pRsa+EMU63ExagXc5oxV4rat8vEB7cniHZe9Ke/hitvSHudVLvRWWZRkJx5RMj4RHnFhtF+wvSGYr2LQcC3Jf6XYeB5NQoW4E3jEMZsCvDvRA79NP43hPZ8ANWK2ZE0ABADcFAJX7JGADrMBemS5+DeBOH2AsVi0MFAH9HhMj83AyVQFk0Q7sJviQGZmeGbnvNraeJf+Rgi3UZSXXo/5iWy0ZKy+5JDQ5hQNOaaVU9IgXKYU3Z1z4ho3AlKt1gJIRa65TRbD0OZz3SABsK155lkU6iJMYUVOilpWwxK5Rl51YMbjFMoAgmLGwIA0Bbu/ycOG3jVOgEAohDM73mhM2mp+uBKzgPdXwf3Oa+wBgAABXjRdzBb6PX82YYldt1dYgnWsBgRcyxgzZnuv5q8F6kUtXnonMRDdzY7MsfLsQrgragKoj0Q56FpmDkxfapoyzWZcUeHP4lOFreWWRJJgXpFy5lYO4a0f6a4mYpB3tw4KFipHDcNI0l8tyrQIDsJCQBIzuUKNai7VYffOzBDYAjb0YYg//gE/71E/5c6nvN2Kn2pt5ugM6+4sR9QFSoKjx8Rsw9ht0bIFBFp7fuau9uqwXGZ+JjLgldawxWEXPuv1eU3Yt4CsX4Pd+w0+6pqAfG7Dj2r6S9VUSxaaa1M4aJYZJWWXQgIWPl6/7WnkPmiRQgpU52oYGe7ALu7CLOGwV6L/SV1wFwNdOLYorSLJhbnsdzPAubEH9c0G/AgyvL2+5bz69b7MbFLVle0GbWS8VwLRBO6mtucHVED/T0IxBPEC77wNEAOgyoRb24Rsysv4GcZ5vJ54XWXSNW8n4zhJr3ESF+0Lv0NwmgedQiIYqYKuScGwEuq0vBK6zWyS2u67JR2Pw/1oF7xoMSNnJcZivH4KpMnqEV5mjO7qVnzekjfhb6xtcCYs+g+VIzgZxNPot0JUbyeoNg9akmTkc/+Ydm04N8TEQlNlO3xfDc/p/S2DPrxmbYyAMgmADBn3DrTl/Z60DxljDy1kN9TcCEuADrMAQEMobvgEcgLvFkRuRYbyC+059+q7UZzw1v3q590KkuBClgQUs84q6B9rIsRu7ZQ+hl3yhkfKG0YC8y5uUlbXKrVyHX6nWs1Nra2iwvxzMRXory5yxzxwLjeVcxUrAmxDOL+YtxtENzwBgA9IK3CAvc5piA6EPtBnEd1oS/HfDifo9FeDdFVSND/3dFf1/Gxyb+f80Det0UD/gAf7X1hh0beKgEnzhG1Rcgj+90yk4kcMarDU2Ri2U56wJPkHs1UHk4pUQ5VBuS/PtyLE2yRHFY6Yi1x1Jhqn8OEv55F3YvKf0vOma2JfxQe6LlS25vZE9vpm92Z392bNCOBobzb2C2gG8mMBXZGJIbsWYL6d5gMddAqKuwbnvtHF6tjWA3g90AJbaqTcAjq1e0Tl81voXHqN6wyndjfNCAlCgAyjB4A0ZySrht39b4Q+Z4R1eyfROEEnBmswC9yz+1cmWbB1o473cJEjG2A2fjljgrUt40EreooB9yo3XulyG5fd62JXqRBTHgCr55rXUyz1/hXK+vmv/7765kmyYWNpVROihxQeLheaUIujNym4IwytiO4DrvIvxFFFB3NUWc+m63ungPdG7ObQh3evntwQGuAOsPjH314wpPQco4RYi+LfNTu6Du+5Pl8fv0BCkiS4qvu8x3uKXuJcKe8po/fAzf/F3d8mXg6KC/f1bvv0pv/IZv2ox/9Yvuctr/vNzHiAoCBxIsKBBBwIRKlwIoUHDDBwgLCAQgMCBBRA4hDBhgkQLGCA/hhQ5sqRJGx1P2FjJsqXLlUCQICmTxEYSQGZIQHSIEIHDBj4fXNBQIkWKEkg1IDAQlAGDolVSOJVQdMaWGUcVaN2aoKtXBBI2dJCgdanZsz7B/0KxgjXHCrJAI0TwObcBih9c4nSilOkWKVWZMqkaTEpw4VGBRxFG7PdUY8eQI0tGdYoy5UqVWWnGbMjMExw6JTooQNoiRQGoA1Q8rVq16YsYDWKYvZFjbdsucuvO7XH3R9++UfZwIbzIkCEwjw8B48ULkSLPm0CXfnyKF+TIoxuhzn37dO/eeYT3Qf4FDRa/hwPHzd4EBo7vbccPQbv+7Pf381vQz//+BNkA6tfQgAwReJBFFWEE0QkMeuTgSA+SJKELJRC3kkopvaQhEDDVZEMZidC0Fg48NaDBByOgCFUJVEHhhhslOCVjBjOEcRVXTqVQiCRblKDAADh+BVYHK/8Y9RZaSEqQgxVrzIDiDHE4KddQP4ggCF+HJQaYYVpixmWWj00m5piWadYLK6MYQgUQJ0RU2psHmJZaa3TWudpFA8pGHwjtcaSbn34K18J6KBGRG3YrZUfcooZW51x330X6nHaQOlrpdOKpl6mmiVKYW4V/9nkbbe6N2t+e/eXHQKr9rcqqbAdQECueeK6aUX4TJfifRrw1GOFJwAYr7EtJlAETFciGqMEFJi4ZiJMojvWTBEzmsCyzQ0kA11cDXFDFVWJpK2RaXXXApBViRcsskuQmwFQHcQQSRRz0dhJIYo0FBsuXXC4G2JaMBSzwwJOZuVklg7CxJrOjyWnRAKf/RTwnABTb2ZpFsbmq32198nYhb4tyJKjHFhaXaKfYKWfDcopSKimlzVk63syRcqqphYSKiipu8dWHKn75bcSfxq8WLZvGB9j6X0a1Eg1RQqchBKivL/xq9YYlw1By1sTaBEYSLpThGQk4lD3CUCMc+cDaaGkABVZFnd0VUwms+xVZHWwgFlJl0T03kVYxKUKRKQ4FlAFzQRzBBR1oEW9i90IeSL63/LsY5AQfNtmZZJKC5sGGALKwm3E6PCdqElds8cURx6Ynx1N3NDLIss9Ou8cmv5Rdo4ga5/vLLtMsfM3DlVceDhR2mlLIffbsHqk9A43fzkZXP/TRBdWK0QLb/2fM30QYJ81rg+ZdLWFIvRH3a/LJbVh2EsUCksSCabNoOFOHM4V/toDzLZS44yKXklKwgW0FsHFuOMMKSvCBFYjgA9lC2wboFYjIYU5fmYhcJwSDJcMAjF9a0pznzvS5gh2mMzUJwQMaZrrUnW51MHwN914Hu6l9jGSza1+ndNiy3vlQZb9jFBBX9ijiGZFmxTMe2Gg3Mp2NSj5AE9rPUvU861XPVUSDlUBmVaAsQg02FrgN1cr3mzFq7Yxa41rtuNYS+MEPJRlgwPY+QC8tpEgCP8nj/jqQlBJUIYEx6ooBk7QBo0jrK2wrwNpQdAFFxqEz8+qDJPEVmApaEHK3mP9cY/wCQsb0CzEEQ4XBPEdKhD3Cjm0aDfha+EIYurJ13MPIroLmRJEFCo4jy2UuFdVDHgJxOYbi3e8mBZ0pOEpmw+tOEsl4O+bZ0lQ8c140pxdFVj3Pi1e8XoBk9cWEdBFp4HOdGMfoIJCVk1HpSx462WiTN8JnPwy4ABUkaQUXWWEo+DwRs+pnOKrUk0VsQ2TbUhAVAhbQXQ8Yi/6mRJVBUPKSF8RXJvtSuUAALHMiVExGM1MmVrTiFJQ4wxNSRB9WSgx1rVSdSu1UuljGMk8EqWHHdNkR5tHUlytLWcpWlhzlDJEIYEMeMS9F1B4g0Xg281Qza8mzKlbzPtSzotH/sFm9WGXRQHmKiH/CqaBxlnFr6FPfOtP5sbK20Y000UkGhuKWG9ALoAmdARQASi4DDMAAfgwD3LaFz6XgUUk2mgFVjGItbKGNXm6I6L04KdELMjYxmrsoJSVzOY5e5q0ncEhLTZpSV7L0Ti6d4TZlasv2ya6mOtQQ7k7Wsh3yNDfRqY5sdzNUSBX1qEidkG7SyFTnzWea9gmuU6WaTevFyptYhSk4ZSgQqjnXpiE756KSwiCznrVYiTAEaCLSrJE2MAdJyefhxiuUPh5lWQEVoLbQi4ASFCIQViASBS2ZmI/6QnKYY+xHHUs5Uvb3MP/laOjYkEK5lAZ1B5YT6165/9I7yXCGVPVZDddzy9xhLbU99enJeAiTYFqImD5F5m2HadTcigRnyNttb6VZqj1VcYpTJK6MVbVNbiZ3m9xj7oJq0yDblLM36ZSuOU/rEvhRARCoQGGbVLLdDHxXsIZbq3gDGs+4JuUsfiNX2hKRwUpQooIRzVJfKBrmxgYYoxslZejkFxoWchZBDG7w6R7cPS6O1quAYmPtrMtn1x4Hw35G2XMOlTKwudO2I96UzcqDw1BxbD7UJNWLnSrFnb2TPzGmZfQijD0KcBq5oFbufkpnkcVJeWo/Dit0yScclaT2fWxIxEcTwWatDugBOeiDAt/mpP8Z1rBrowpS5LZQKf/7cQ33moSylZ2J+/YFEZNtbLQdO+Y0i9C/aerM2FRoV1JDjCLfbuFnV8fK0EJ4tPap4Q1th04Mt9vdFn7thnmaU3pneCXcCV7NlLnoZZKMqS2Gj9Co+byCV3pjwg1upGf8quOGuiBLE82tJSInxGlkxw5ansZt+FWWVDdCSIEfkolB8kSItMkSYZwWcuA4BZJgvWtl4B2FYiIJNJDXIV+LISS5bGVfOxOK4CS0gf7Yx1abzGYmxX8NZkoCa23UbvY2Sjsr58/SOZb/KdAEXJcfD0SxTzmMd+7e3bsLh6yn9VatTVhWW0Qf8Yj9drQTIf1Og6d7epl+VaajyvDihrr/ixZwc6nXBpEMoFrjgxpyhIhMLJGjohUlNOX86tKA+lXlWr5m7084gOtMtKIPGZwE5HueGGaXPpNGP3rRH+r51V8bdE6Po2haWrpwU91OVXcwbLQnWqxCHNN8ak8T18jE1J6dw2I37U+RX5PdEdHtiTaxbuUOu+gZPOAFh97dgya9vEuP4Z9+uNYZIiOKo7QnOzb8RtL344/XlDiIJ5bYsCTKz03iDKGJAAq08LYORAspDIA/ecQBF1A2SxIYomcmpoeAp/dsqVdmikBmD3hmXoYwo6MQb3Z7DZZ7FVc6cuQ6N7YfuzJLs+F1eOdEzgRvN2VhKqaCO7Q7ZecSPgR9/9GXVOs0dy6Gd5F2fToIVXoHVVHlfVZUfjX2d6qEOBNnfhfzEBgHZA8Sf63mceuDVnxxJpwzCRa4XQU4V/k0AvbzAA7Ccmewcx20GQfDgGKWCSWEehJ1C4iAekF3C8zGWI3hC5vEGJQgCHXABTfQZuUWbhBTMXGygYRIMVPHVXhybg6wdRTAiAdhTTqjYlDogh7TQ38GVr3EWvc2Kc7XdjSIaDrQb+wGcC1WTQL3Hq4iRdrHdz/jNAjXd0V4VQSyiBKBOPgzca2DJ4UnRT2GIb3IIEPWEq72PvCjB48nDB2FJoOASmCIR0DhE2agJjhgBmOIGQuIhg2YhqenSYgwOThA9wZ9MTlxmI3Ulhhx8AQ/QDoZ6DClU4jumBoyBBsBWCtFaEU6s27/hjMuaG/7iHYx2GH82BIBAQAh+QQEBAD/ACwAAAAA4AEOAYceEAQmDgIsFgYuIw4vGAYzGQYzGwo2GAY3HxA4Igw4KRQ8Mxs9NyJDHQZHJAxHOSRIMxtKKhRLQitUKxVUMQ1VHQNWJwpXLhlXSzNXUTlYOiRZLRZZRCtaMhtcWUJcbUxkNhtoOyRpLwlpRCppVDhqSzNqXENqglxtYT9uQRtvUS9xbVJxjmpzPSR0RCZ0RSp1SSt1SzN1Vjt2PBZ3OQt4STN5Rip5XEJ5Y0h5e2J6Qhp6RiZ6Six6SzN7US58Uzt8pYR9UTSBPgyCTzWESyqEUzaEVTqFXEKGWDeGWTuIRxiITCaITzKIZkiIfGOJRg2JVTWKVjmKWTaKdViKh2qLbFKMUiqMWjuMYT6McU6NlHWSTRaTTiSUWziUXUCUoX6VbVKVq4mVw56WaUaXYzqXaEeXyqaYVSiYcU6Yd1iYfWKYgV2YhWiYl3maVRmbdFObnIGdYS2iXCaiXDGjXBylbEaleFWmfWGoYR6oaDeoc0qooX2oqYqpglyphmaplniqZSiqjnGquJarfVusnYKtcTytwp2ubkOusI+zbCuzbTOzflW0zKu1tZe2eki3hVi3i2a3vKK4p4e5dTm54cK6cy26mHW6o3m7kmu738G8dDO8gku+kV7BeS7DejXDfULDjWTEm3TFfDrFlWXGfDjGm3fHi1XHl2nHnoLHonnIp4bKgzjKh0jKklrLhUPMhDvNvKPOkEzP0LLQpnHRhj3R3MLStZTTiz3TjUrTjlLTnnLUjEPVkkvVnGfV6MvWjEXWkUTWq4XXp3fYkD/YxJjZllfZomnak0bclUrcmEfdmlPemUveoVrgl0vhmUfinWLjm03knVLknljkvaPlo1vlupXmoVPmqVznoE7nrHXn3MTook7opmbotofqs3jrpFTrpVrsxJXtqVvtq2PtsmjuqVXvsF/v7tHwpljw0avyq1byrWLyrXLyrmvzrVvzuof0tGv1sVz1s2P1uHb1wHL2yJb3uGj4s174u2z5vHP7wXP7yIb75bn8w3r905f+/OgI/wCVKNkhcKCQgURatBhYkIjDUum0aTvHj2K6YH2wgGhQwcIMK2dAclnicEmLDRYacLTAckYLIlLqLNJTxwuTkksOOjzEk+cnUZ5+KvoZlBWvaEitKf22ralTpuWeRlUHtapVq+vQaQWXtJnXY7tukRp7DGkxr9K2doWWdKtbtWvhLuU6NxmwYbHsJmM2N+vbqVyviRscz16/w/v62SM3Dp7jfIvlSWZMGR/ky5YRaz6sj3HgxlnbiW4Mbhw30Jnzcb48DzPl04KVyeZFO6yrV7hz363N+2haasBlU+OlyU2i3ctmJ1/e9vNfrGlDa5Uumt3ld9gT+9vOvbv37fy40/8Tto97eH7h04H/7u+wt/fZrGvfl131e+yt321u7Ri2Mh0FIVTSQUIoRBJJQnQB0TkUoYdeN5BgIUJKFdCwhBQjHehQCxN2xNIGILhkYEguESgCDTMIwcQcPbWoiE9BfeLbb3MBBphUUt0I3XN0sfXVbWOR8otZaL0VF480NndkXbPdkpddUkmH5GCCyaPaaqi5hlplqV23WWKHefbZOqNJWSWZj3nJWpmkxUbbWbXdhoucswVnJ3CxKccNMpUYh5xyzPmY5FU7mkbmM4hOZ92i183HnnfhiTeLN5BG6g96jyYG33uqacffp/zhN4+o7IwWnEEHBpjQQhq+1EUw6VD/1CA/F0U4A0sVwhTSGV1EcVNCIIRgIA9DQJHQiR12dKKyXMzBootBDRWkjMLVRaiOVGGrY19mrvXjtEQWaWSR2PCo1ZLWKpXcbmFBye2UNpJ5ZX/VaWnOlo+leeV8WMZGJXWljZnlmoy+Bpt/fAEKJ19ntukwM29Wm4ifEQeKjMVK0lXoVok+g6+ajpb3aHfhzDKLyCOPnJgwXJIK6qihutxfcLwokaKAI6WI0683RaFLRA6iV+sYKVBw4oVd5FHH0kz36kUZT0Mt9bHIIsts0s/25Im0RP1Ubbrahh2vus25g+SPtpH11dfjCsrUoG2nyxy7u7j7rnPXoqPvx45N/4Yml/rm9+VhVQbscJvRGVpwvoyz+fCdeCruuJt0CncLIHjcovDFnHfu9sZyDQrb3/W2xm97KY8nDD2PqpeypuTEx6nML8esH2SlmjbbzQf2miHSvD5N0yDdVBQ0rcFggoYPAK7IdItMSy091F04pOKGLiHLRB3POvtijF2TCzaO5marTjz/kl222dL5eLFYQTrzvvihi49U/VZtvu5dTpb1+dnpshLu+EYdvzWOHgg03eBMAxgGditx+CIdvQw2OsQ17HCmkg1QVmEUidHhONLwnAjX9r9yve1acFMUBhV4OtR1hx7eWF15HJWy7XjKGLGb3acWVbDaDVB3uyOI8/8GMZNeMW0RSASFLoIRjHpc6jzpUI8wIiSFKxjxedEjQxycZkUm+IpnXlxa9XJyNKW9iCffI8qQ0GUt84mNfdnyi/rkB8H2uW8YQepEu6jFxrh05Vz4+9r++NcuOubvXH4sW2QkSC/2GbBx3kggAhfoQIEhTpEFzCQGN1nJx7FiFZUI5S4YFpw+aUJ/I/RcHwOZpI45LE38GhwMBRNJxDgRdbe0oS7BRA5jMIMcL6sXD3vopdzRbBcl8cIilNiNUyxtiUxkYjem6UTX+SOK9ZiiHrSoRTFy85tV/CIYwWjGmvyuWWZ8URpdgQv7zZF8YUOfA+Vpx/+RCS7fCtIeSej/zn4iMmMYWwbdCkm/fyayLZpM6L8AxxhQ7Qcy6etkj2gUUU5K9KKbDCEvXqGJjk7iKKex3MQ8QTN+pvKgh/RWCi1Zuljuhy841MzpUBayefTSl7H7YQVHk7th6lSjd7FCGZCoC2o6cxHTzM40tXNLa5bsEeDEWtKC16stGgsk4/yVF3jiLCvkRCcs+l6McsG5QaE0R/E63zzv5cjglHCi74NfJzxRt1/w0XMGRctZUwoosAy0oGZ1W7UWalHCPhJw/HnoWyS6UsM51rGMjdxa/UMbUIZSE6OE3Csw94qSmpSO7hPsWU36R9GRTk364IxnfpnTSc50pv2IIU53GJoK/+60p5MTaN30AM1qOBEjeeBEOJwYjuwQdzvYVE/JMhLVLnATqxgKJ1Z3RpIzmLGrWwhQWNWIV0E+5a15a+thPxOud8Y1j0Oya3p/wd6L5ZWfo7VYbwja3ROOlqKQ1aRhCQhMxe6XSo3VlmD8ReCDvVJ3lfVoJUTRQchJY7OAAIZnPxtaEsbXf+40qwqFyTjBxIK1jqmlp17LS5iKhj9yFF2iIpjBuJIHO93YR8kOUYZTbOe4OL4myWaxiW9atQu8+jF0eaahZF53DlzIrpJZ5DWyvvPJJowy6ArjNxbbsWIBndYnQqi29rYzhGCm8EEDqhdC0q2sYxZtcy6I0f8+kv+FWAJYZAObUgebFnFpU3CDgeheaXTigzMqb4XFnOb63reOlVktxEAcuNWMytGt4UYvTtNhIGpYsgejEW+qwekpcmIUnNjiKISxRE4XN8fd2QePmxsHK2BIyNM9J04AoTTMyeEMW3CDG7abC0QdGp5ThiM9x+sYqkADy/LN45btKiS0pddbGCa0fHX71z9deNAnzK+2tx3B1M5Lp3MeH46iXFK2WRpIHuVgO5Pzy2MqgyuVwAMpfnOWQUu70Pc+ax0RxrkBnylwOhxmuyutvsAaPMz9q8Y7hKEHK+hAqFKwgzNjMmrjHle5v4Wqj5/76iDHGicNOcOtd6VrOQBCE17/QxiexA1sw4lXoQoNlyrVxey5RqNr7SWKk9OytmhLW4TV9qvPVWpve+L3sdxeYS3txW2wkbIpCfMuKmkzCT2PcrD3AuqXf0EHOsyb53rNt5qhfVL4jt2sCdtLgRONWNwyemZ2lvqget6u4uqiCxNKgQ7I8GmHW4ETMT4udpB7Y4ZvXApW3WKrRbIrkBREJ83CNa5NbvKxniXALf/LyyOTwEVW+cBIATq7N6ploZwcKHNSb9i9XHYKv+9JYsnLPkFb9HwHGOlRWWGjUSzn9MlN7lOHvVFwk+41YhrBqee5rr8O9p/T/uxCd77ZoX8xUrqZk67MYPMrPHU4vZ6d9Wim/xUopINCzOIUPvCIHQJP3KSSzBsaJwPiGT9/+pP8/rn2XiLEavnLYz5v96NCjPRtcaZfCNcbs9E1qPcJgGAcC+g1xkd3rSd6ZWYbeHGB/TOBtQdQK1dgSTeAlTZneZIuaTdtsneCn8RRVYdyX3ZRWtdgn7B8cOV6ZEZhtNBe0md7a2F9/uaBtnUnKbZ9NVh9deJ9toEM2HEKZFA0FLAEj0Bq45cCjkApN7ZwL3ZcwrAJeaB4QbZ499dqIkdrhWBGk+AIQCEjqUdW67Zz/weAmvdIhuFtD+V5teVulYUbsUB84PMMDJhrc6VeqPds7cR6YPFZ0VeB+5SIdbOB8vN8Z/93cEA4WWySL5/XZr8XfAOVG6Ckbi1IaXWYgMPXa8XgCX7SMQdIgz+Hg0OXgzrodHGHX9wAdlNnggvzfaOUVKaQBwBCBrMwYw/3CJRCXPuQDTgkMjJmeBwHhly4RWO4f5tgFLmAhmo4jWuIhkOnMW64MSAoh3PYN1fGG3p4WZ7QCdLChw34QTLCXQy2hoR4iK8XdJrYP7KXgdOmgZDIch/oOAboe+ZVggi4G3nBQSqoboiWYnESirkwDsowMYqADDOIihD5E4IIkaw4cxYTdRj5Nb9haRo4SP+Yc6/QTjA2RYVwBlMYfr3wjC9mQ7FlMoNXD8PoCLXWhVuYTo5wk47/AI2z4X9O9o7sOJFHl3kmtFh/82b7Aml0yBW22FH7d3LkmAiiUAzmKAQOqIDNtkbHJnR0UkjwOI+6gYH0aG0UGFCldY9zcXyFdVHlYGlz1FfzBZacuEaScyjHJCc/uSddR1KyWJFFd4NAaYgU6ZYdqT8aKYS0SIHzlYISNpIpGVwztFSnE0PMEFMoZgqTMIZjeJmamZN2qYbCUYudk4ZeNpHiAi/BllAC1CVxyHTHZFmh1JRQKSPmmGtcY5VXqZV4eITCd2a7KRZgSV8e2YiFuIq/9mRxV1HIyY9kh4goKCe56RuMxGc5t24h9ElwkpeGOYtlZoh+iZjvOJjfGZjg/5l8wWmCQieavhmSv9QNpdIKZYhDmxKfseNLEDNpiOJLZ/FJ+hmK+yl7PPmfziYkZIFHsxeApillarV5qLl7rEl6QaGHMYIoDJhk8mabYzWaFiiP6FlXZpaeGuokIPon3nmIwJdmHIh7yamcoWcN28mczvmcb6d9PrmIiEKek7BrrvCQ4wl03RmapCmezrajH8mj7VieLko3AilhzyA7xZCTsEGMk5mRCjONn/kMokiNCIlsRWhSikhQB3qaMCdBmCGHAyQPlJN6RFGb5ygHpbdBA4qh8ficHLobSQqiH/qVwCmBJEqWRNePhYk3KApgboWJdCqnVUJwPPeRwVE5pv/ECr4GpDRYpOw4oiP6o5X6lu4oqZcKjnXKbiF1pTu5pcVwgvKjigBqhJp6UnA6oH7plwYaOpdmJgIoq0W5GJahmrfaI2/CbIowV0CBZLlmodOiiHGamwgJogKJpx1qp3maqa1HmOpSi6DahoA6qIL5ljB6qJ5nrdQYaHOyZSHEkAmZnZRKpOtYruh6numKqV2Zqi2qroWapKMnqtxqnpa6ejPKrs72oq3qoTf4DXAEQK8apslplKwZZspgVwxpayXXpuCzoWmTrMqah8zaqWVWrM3qrEOIiaxgCh4rlfdpih1oZ5AzN8oRdNGBQJ+nFBCDYZ5ZLbjwoNJgpQ3oCc3/wGeQyqNdtq5ECq966qzt2qVA66Nwim4haZGBtpfXymw/y6Vz6ldfKYH9GrG6gRRBaF9g+nIpSkBJGa2mR3lgq4C2SaxUW7EU668Wyz8SO7XvOqSUCiiucJPs9LEgK7LHySSGyRsVeHmNkas9eLJE2ySk0Kui2Id6ibAUuadgsbM8G576OqlBm4kZ+rSPy67farHQqrRZ1mzYAA1oyE4W+aFQGz8/e4MY66oPhLUDq7Wm6WYTBHfVOY5OuX+VJ7ZmqGVFe7r++owSC3t2gbYTG3Ra6j6gCbc46RPL5LG9AHzWWpjaGXWUxnscGbgVo7BQObOjKIOxqJ0+l0q78KaS/9qO4gunipiv8Kis/Sqn7iq5RgujM2pfQ5ied7SnoTe+tLAKjLuvZSu/AQtgUsYWRMm6/aucLAV6yKCCCgabZ2i7EAixupueaxuWahvBreqzIoquO2kKmyCTz5NEdIuRr4i4g6QwMQq7S/uhZPUJ8YZZNUqKULkOvtaTGNxz8YOh8Cq06HmuOHzDuVuxAmq6GSi6PJzD+Ju251UWOhqc9xuBuMnEPHy/NaxXIFmsw4p7B+VGAmyJZ9mDbEYXTAlKK6hn0qif4ePAPgzBFExfZZvGkUu0T+Ius6HBHEwTHfwIrQCyDpRpUipIJDxwbDeCTSK5SMpZ2NuHgACu3heR6v/qFW66w+T7yEC8jkIMyYnIYFN7umXRo6UqtVQbiMRKFklsMfw7v+z0r6T8mz+sybgZj6lMCwObnW9IsGPTRlxcScRxehLbf2qowpx5rGZMxRE8nNSmT2zcxjb8JIDLChtMx1kkE3Q7WydmKDhEnzDbx3yRaHocdZVLp5jTkPepwlsQYY/atEPLyMRsl5NLtpV8yelMyemcm05yzkIiv49szvDcvu2sh9BgNiIsyrrJFObbvTaMsXcEvEVcxPssq0uSxQPMjxO1xcnpCpf1og5bhmZYhr4MsfH6wGh2Xgf9oEbMoc6pm91KqnEsx8wcNWUgExv8aVLJMqUSnyxTn6L/isfwmUOvgZGWC7rDN7jY6WuGHHaRqqkS/Yf5zM5HDST3jNRmu8ZQjMZOPdA9/NTnfM++Gg0GKZxavbirMAzLSYhA1aMTrKxhHcm5LCRWbE8NLSVZ/NB384lbw4IUvcCKsH81WQi9LJpD+s546rTtW9X2G7woONixkAsee7zNPAZLg0R23AqTZgwsI59QSp93PBs5JNmnQc0LM9jIWtgpiAfoGLIMKATXa6XkPLREAdhmjbYZmo6xdwz6lNRN3cmprNqtzF7oPNUf/c5P6crvVZ5P/dWmemz0LLmkW7+rDcUPmtBxA8BuwdCE4Xv+C15441EBScZdU9eSJxBykNdU/4qq2HrMMizFcrXbgs2vzOrZeUjYnr3MdEwGil0TaHBEjvAIdmzH8CnZpEafkJ3fmK3Zld2cZ6veq2BrUYm92UvaxVvO7qhsjfzA6P3XEgmBEG62rBzBtb2OA6qOtU3bdZrLooRPjog2uXFCPYth6c2+VRsNWvmHH21zqXsk0C1sa+nQruhYtyBKB7nAZwisT2Ah1tWxdHuqyQySJo1mqArMYj3WS320A87T7Y3Y8r3SVL7SemAHdvCMrTBqJhPZmC07Xi7T8CFpZxHg633PZz4x8iaKQJ1dIESNW02/36LjyV3hmkgWSk0WgdjkpwvYDi7hamTJsF3DD27enXxZXv/NPp074hfbbOdy4vo7yfFId2hcxH8ogPiDxQq6siq60P4S1zxN0WV4mQ2oZOF8vND42P63x8fWrTWd5BzNqcl9tor5nIatwY/AzNNT5fO92Jtw31seCiyTVOwp2ZsS5t7ADcRoMr4k4Fa9sOB6n+gw2m8e0KgN6oBY6H2u3BAa1XZe5+glz9nO7eMO7sNK25flDOaznMI5yvOLm3sxumwb1Vnp4XO1YAAb4849wMNmQPTU6RDtWNaNpiD+Ig2IawBiXXeN0Z1Z5nUbsh2z6giewSk817kt27rbnx5r30iURbtO5fT964+ACb3Q5e9RXJLdDcEwTWBOjGAO2XdM4KX/LJDxRjExLKFunl5qaL+Z2tvNMM+4S9Wr/cO2veffruQZvoBtWnPMFhbh3u1He+E6HsqkXOJRUbpLPukqrm40fOfjeNW0Gmb57mb9/u+a7tbHtwt0nueTINGaOZM2YyG6ZurdnAfqBCNd892rDvEgS/FmrNvg/tr7KfIz8d4fD/JMQ/gjD2oueR+yU+zxEQyRT2rLTvmkFvMyz7vF4YBs3jGKkPPgPcQovjWnV3NPb95Ef/oWH+GrPeHaDvWqz+PEHPSnf+hTT/XtzvWDwZ1L3Oidatxcz+JMnkd6FKgBH92bbvbVuuhBObg6DMYJLIa2Fveq8gTWLxCRJ3nOsv36/6dOZ2jYZ7G8Nm2Km03Eoc7ak7vUQp7rN0kTvK7SvC4T9o0J9M/4qWD5lT/5+L9E/Q0QwowNZNYq1kGEBzcVAuRGzqRc0p5NpChN0ZMniqJJQ9bx2C9aIIeJ/ChSWbRfnvDgqUSLFKmUL2XOXFWT5s2bu1yJ2vnK5y1XQH+69MmzKE6kSV/qVEoU6VCbNTtV6nQL2kZrWK9ubdY1WcmawLKO9fgV7E9nH6GGBaZT6NFOMDeejTo17rd14yReyytuLN5ygd35JTzYXLxxiOUpNizYsbrAW6mBozx4lydPQXF9EjXJs+dKihIBUjTnzGkdNHRYiZPn9BaMQlTLxqiEy/9t3LlPz8nTu9Bvz45YDc9VvNhxjsiTe8TVvK1b6NB9xoJKnLipTYu066nTvXsZ8OHD13nT5xEnTKfUl9KVSuB7+MKCCcsW3/774wmLLyRNOlevk/ai6KKM9vKKpJF+UaskBT0ZjSqjmopQQqJ6svDCtSo8asIMJfSQw6g6XAXCVYbRiisUlzHrLRMJS3FFtNRika3n1sIsra4snMmuYxL7BisfK3usMMaKbKywrPhCEkghMXxJkalEG60/02CjgYYtAHFky9/OUOJL2mhbAswvdTNzi9wAac23LT+5rjgBlyuuRs2cxPBNU/LcjjswvkPjO/IG0W4Q9EYxdD32ZnH/rz1G46tPl0fvm6UXg/IcbpNK6HAIojgrKiYRIbYQhRtSD0SwxueGIaW/pWL6UCkQaRLRThs3fBWzzmLFNadXmtNQqriOSZEsFOlqMbIXz4LxLRrrtJWWrZiyNbRXhNzqSGz9MnJbdI78a8kkxdFrxBI5exKQlVZyiMonrnzCjUKs26m3KsEMM8wZ7hWTTDfMlIM3gKH0rDnlAuSlo/wOVlg/t+QNylIuwbPDOzsqFlRQSErB5JJQOvZ4PfUoDVlRSUs25pTjKuXPv2IA9HQiXAAJ9ZNSTW1QKFRHJK3VW2GVydVfZ521Z5+LjsrXEI82a9hiR7JJLGSTddoqGZnN/9DGqpLTEddMPWkmL5Q6KmcxspEkklsjhwS3yYHNdRBdPBzSlA5AMPNSNYeEq7Q4VxzprDfc9J1NcHf5LfM2NOWW+9+dhzupYGYib9ng5xi29PJHFgHUYs7vgASU9NQ7tGOQRx+5Ufjmk4+++iLtRWTsgIslclJd9hSPd2lmZ7KrSArp95Km2jmsZ4nuOWnkdVXe6F2NFprGr06U+ulvp4fJWORnhEuuHG/qmpZuszpYGnfsMb9ss33sC/311V47MGndLk0OuheP15G7323J8ks5E821M5FJTLUhYJn4hTjE9UuBOxvYQQJUO4JI7nETzA/m+OSFPlnsc5jIGHtC9//BD5oOZIzqhcnu87rXHSw7mzCFcioCM5kpwRXZ2N1ybqaTtDRIE4mA0NZkYq6ecKh5xkve8n61POY5b0O3SFATqca0pVltG1FLFlEYZLUM7cJpMoHQXFzFtZWsQjAqGh/Zzsc+bJmRW0JK3xiflqu30W9uD+EJ/p6ggyy5CXLMoc5OuAQceqmJN7sh5GsMl7jXyFGBiFwkAzexMMldg3ZKimDKKPUJzXWncx/TGCQ8t0HQgVCEI+SkBzuGOvs8QyDPACKcXshKOuDxFeSooQ2hg4ygrIqHmXESEH3pyx/+Epi8ImZUhonEJA4RjiDyoROdKb1omeVoU6RisWI0tSL/4oxZdvGi98LoDMiEDRnWOAw+5nHOM7YvjepsY2LAVhleCHF+iqSj/9yAx4c4kFhk5KPDctmmVlqKFZ6JwyIXyDiEzg02tUmcQVcisBK1IkADgSBFUTioi3mOdJ/zHKH8YB5QclCkIx2l6Dg5OlS2TqW6mMgnQEEzVVLkE/fMCDfmUbMrKkgtpOgh0oIoTKD+MiJ6jImChlO8Vx1TiHD0G4c0ocxlMnNrOXTmE6WXU+pVs1itokvytCkUu5BCK27DTGjodqwJ8sWc+TBnOtWpRjQ6ho3k68tlfFXW0SyunsNJBGzckIhXTBCK/HTOwiw3J8Q2R0q9eVBjBfZYuBm0/4C1WVxPj2PRR2H0Dpv95CA461mPfjSkJCVtCEFXuhCyFIXteVRM2wO6T6AwppPYAh43QY5+tEMvj2NQjXhpWF8FlDOFTawLX1kqiVAwsUa9EECD+tygesJvnnFqVGnVGapWdbBdbdEUoSidrnrVWS7hEfmuQlazuqETVyWn+dj63ra2D65xpcyP5go2tkRFEZriwr9+O1A3vMs/ZITmdpUxPoRBM639LGzlEDYn/y0WXYucbENJM4lNuCJPqwXFIj77YdCClqMe5ejnzgOJE594tKYNnSlPp1pV6uKlsT0tCi+Cx0kY4x035QblGPQzAUGQIrvbsU1rWBF2JJkdO/9WcpN1+2R3KplUUN4tcoybXOMkrLiIFWh0pzvc8fZSFNHEplikRie2XGsu1rxmNrM4krjIBR0cQW+mHLIL+54oL+jsR5/hO1+3hu++bNQLhhULRrkpYrjF+EQMz6CJoCzjL96ltIFRVL258g7T9SUVcg8c3J7sML38hY0O8EjZM5BGb7rQbOdAHNoQZ848s6a1ilcsOtLWmCAy7sUiXLsI2G44D0pIgQ7mMIoiG8PKC6NuRJyc5Ik828k0jPYzlqzkblBbpUamYbfReU5wMxnbOya3uKXdZHHvGmZZvlQL57Q3fx5VM4R95omw+rTo7dNUzcKieLf5kq89oyvobQj/HcS4WxSVj61+/rMZ3fte+k6G0OMABqSZEqXI1s1NrHSN/nARoElXGhshv/S3BN2tbLUzyu6kJO8qsrBXfGZK/bqjqU39rjPUYRGs9nB5fO5qz3oy1rQm+tBBemsWH4rDoFAt6FraCu18ggxjsq23lb3sXGhGItNG7rqPy4rJfULLlCrGKMguW9V6e8nlZnvb3f52ttej7UlOtkrVzo1VTuSyZM9FFHOKIzLfOyRiGzmbf9aWpIU1e0f8RfiaIb/0VgIaLkowZezBcMzDQ7dt5fMZT27flYPDRqJRpMUZvd88Nj7TImc9yd331sbEFfbrY7leXP7pPmJqwgEudc53/95zMARf+GkA+kddTXw9FH/oJWb+BvNkYqXHmKWnLQawZ6wHK6RmBmfohTe8L2TlavmnwTnE/8ov4UACTP2+YdOWFjEcUBhktZDKRrnl/o5q3J/c969H/9/Bf7nTv/5Lh3LLPwHcBwT0hwREQAT8tmnzOwg8M+0RlgLbKa56izhzsyPSnTmDvLwCBDyDJwKzPIbbsT+Dr4Zjn4kbF6R5qpnzL5rJOt5bhZNoI2TJs8LLQZODDLSZr3WCvc9bQYmToD6qiYX4DffruYp5AyYUvjsgvlfjnJ8DOqPzpBGzQiwEpVaIvmewvl6zvg7TnDgYEyxxBNbxhk4jiKzzG9OQo//JIhw4FAE5nIE5lEM7zJfD6QI97AL2O4T3cylea5RHCYZuyLZCPERENMRDrL9umI9uO0S4K7dzert5iECq8gqbcTBtkrSrUpXFy8C6+MRpWgeBqzN14QnHW7NxugZ60AdXzDxaakVZjC/Pk7jQiyfmErUPVLT8iKFEgBq1aT1h5MEfNIwevIceJMbXSx8Jepy9MYjT2g4nHD4qXEImrJhAqcaM4iwrxBgP6yDUajpcg634MwUT4w4poMMl2Ln6YxQ9KY1Sc5cwEYE4xJcrkUc7lMMK2Md9zMfBIYIWIAKBHEguYAIm2EOEJIMx4A6KKb/yY0iIdD8/lMgkZKHLgcb/LdxCkZk/+suGpSmLjwA8CKyqNEsuTNyiw0s8DcweUhw4OBKev6KZVOydk8CtPmvA3KKlWJzFzluMk2uf8dJFOeKJ46CtjAgsJYmMGwwnpWzKZYy9ZFTGdZJKG5QrSfoWNUQh0NksapTCNFAD80C+JmxC8phCr1Q+jOmscdTIFyvH55O1TOKOJbCACtCBMng/7WjDO7qSOYwNnFOg+uENuOkPwpwnxLFHO6wAf8yXFmgBIWhMgBRIUxtIMBkTyyRIzLzMJbACzuzMzbzMgmSN1ogDMqCX9etD36gDSwzJFfm7VLGiyosmUQRF2gwJmEhJOZuzL4qjTfm8yOFEZrDJ/5vsM3K4yljUvIdDTiKBMmnQMFwqitD4QLE7MJlRL14IF6fMTqmkJqqcSmP0zpTrzmAEPfKkpIF4LSV8Qms8yzUYSzQQPok5S7PcpM1qvqQ7ndPCDoyKyDIgAhFQTNsAyMXEm8IUJoIxqgY7UHNxhP8ZpNugDX8c0BlozAml0GK7UJvLUNlgTMdkTGLzUBDVUBElglDZgQD9TMq0DdZcUZFkUe2KER/rnhCxmtpMPFAEON2KhjrrhIITq4q4yrRyL5ykJWNQq5VTztpDzhx1nFAzK00BLDp70l+IHOzkzvEUz6g8RmSESiwVT/dJSr6AIBlbhGuUzzQwPrF8TzXtyv+vdE9tRLqR2iASwjW4HJTkg0gmAAG6VMz/7Ms8cpN2y7IrM0lVXBhAFag/gkcvyRe+lFAOTQHVgNRIzdBHndDHrFQOvRIM3VRMFZMStZcWdVFRbaJlwaFCRcn8WskaPTz82lEpNa/6+s2JElI/K86W00l2EhckdZznlLkeHaqCo5qrtFL36VJj3ZYtRQxiTFZlNdaqRJJOY4f3GIWP+pP1VM/PalP3DA8wuNY3KAM3pcLTKq2jWw8Z8yDQgUv+9A4moMPFzJI8eCSEWLBOIdQKBC7EAjMuqRIuABNNbdTFlNB/3VBGLViDvUeETVhJrVQSLdEwOclQHVUmShVpMdX/Qn2WfnMzpIgG3UIHYCK9JxWrOfPNWW3FIZ0kI629wjij5vQpmQvZA1MJlljFq3zKY71ZqUQbnB20IAyMMG2H+hAZbbQYNQBLbV1TpF3PMg2+swQt9kCFTuIgNK0YP9DCqFVXJoRIds3QzUw1vRnUerVXA0PQLeuf4ACc0yBDRo1Qtm1bt2VbC6AACgjYg91QC21MUb1E18QZY7HYsMnYUCyippg83awz6dyIkR3WZmQGk61VW0VZlUNOXOoIedshdQGs06MDTSgjNtpZnM1SZvXcnwxPllupMAQ6bR2Eo3XPJpjGbmXTamQ6qIVaPwCDG2iCJggCFdhdHyiCK+gC//AAw26UQq39jqlTgjURDgT7C7FtXnDCRAnUqeWqE7Pd10IaUVMD2LeF27jtXgsQ2IEdnA+dgbyV2E28N4K5xJgDxaCZ0VWliYCjM1Okm6qYScW9iuBs3Fa01SABUzCVXOd8zvW1M+tEhrf5uCr1XJ0NTywNXQdWYJSTL6D1PvT8uRDjrKJd3Sx4z9YdPg/+YA2ywlKYXUuwhCe8gRDAgN3lgBFo4RHggSDw3fIQOmzFRkC54S6xyIiYJJIrsO3KwUwk2+n1J+cqP9IYTdMkTUOyjVDp194rtTeMDU0V0ZurW9qAWPOtKun9KhctJhG5UagSu47VUQ980pZgkvKUVf9z0F986F//JbQlhbkRGbUxu4zNRWMGBl0I1uMsddaySTJvEIhT8KTku+CirVY2aNMNXuQN7mDhqwJIDo8jwKAxWEg7qNqNQYVgoF1IvoES0ABQDmVQDgEX7gEv8FYbtlYc1rnzgJxN82EoAuLA21shpl6z9aMVkkhcTlTpwqSzBSRdjM4kRqhEyj7D+czypeWJTRWsQjABXlWMPaIw/poOnN+H8lFp8K77FR/a4Uk3thZO69gtvqvIcwUDzoyu6Fw+Bs88/tw9Zudx8L5AHlOzxOCvvINEnoJIbmRHFr5J7uRJNoIfGOgeGIIj6NaN6ZjNOoIY+OQQEGWIHuUX7mf/4Us+Nf0OeukNR5C/tHI9HIRlwJNlLM7i6CjpeDvpW0bp3HOYzvijwjxNRTiEZH5RvmUO4JFej4jm5zGar9mdj52Sa6ZZK2XeCRJONDwMlU0feGhZrdkJUZNSXNyLXC3WZn1nd75qeFY4zZtnuBSxDL5ka2Rkf+7gSA5osy6CgiZlUo5hMMjgKvBkUsYAiH4Auq7rUa6Bg25d8VBThUzIvvZDd3NekGYakdbNkQZJvdVExRY/fFXQrpjexj6s4MploJppZWbmkgbJ7WmeDnlfZaJmjzVcwkTnhNvmoqbFN7bFKJvcpl7fXx0omgXC7lxnq67qBW7g2dvqzDK6j+JG/0UW60cu69s1axkgaBdW6xgQ6IYmZROIaLuuawi4AFAebtzd60rua+xWyHgFu4IRxsL+bq6YMzUb7MNWGBYVrBhFbN6aE/Xmo8h2sMRaNMum5WbWIuagEKRinhp6vDLuUaMAztWTVWUYB9TuWV3VC6BYb76yXIOT3v9t5z6GcKyubajktkcJBRqetd7ugzbNZ+DeZ9w9ghsYcRIn8RhoTFDuAOR2gRYe8RJwaOiGAAZAABpXABmn6xIw63+W5N/F7jPQ7u125ZLbBsIu8vAm72SJWH5acvSGXixO8vJub5Bsi4+c72Um1WbOafyuFZ7eb9EmDc0lqgRWSgG3KYhrn/9w7ovmPDjc6ww7A0Gdwk7avm0Kn/Os3jNArg/1yPDe/qj2bM+wBnHhNnEXb+jilgGHVvGHTnENMAFHd3QPiPEZFwAaNwAbh4AQIHGBToIexwJPZw0pIE3s7g1eHW8j18EhT/WRBe9TD+keRnJLk/IGy8RteCIrx2xcv/JmiJ8wXqKiaR7E7cAdAWq4IUoAX5sybzjbY5K6KhGT9BUG3x8Enmo7r3Nrh2dAbsTX4nM/n1riS4N9Du4Qx2tPLvQXf4FHP25QnoDonu7mluu6rvEBmHdKp+tML/QY5vRPlwJ+H/XSDHJ6RQlVR3WCL/jCW3WE9+5Xf+WPhvUol3V+IvL/W8f1FdV1nfKeXv/1zw6fnyZ2EAS7tthBcBGWdfg2NTdJoHT21o726ZBzCb923F7WaudSM5pEgYjaPvf2oxX0QS93Q39xUD53RG9hDRgBDbhxUPYARz96ulYAG0cAAKB3Gy96E6iBE38BGIDhfYeCfvd3PtxokFt4hSdcg9ez8gQM+2JKHDx7kf9o8XZ4J497KVfyiqdpkt7NDMz4qOIavpeJYO94Yj+82GbGT2PFWm3JbKYrslGG6zHJJqXf4bJFmJ/8CLft2U7WCb5wnO/z1QV3ngdoQvf5RT/35gZ6585xR493ea/0qWfhhj73rCfofO/3rhd15U38hi/7sbff/5FLeGK9UgNf+4VfdegVWWgwfuh9+/NCEbGjGe6Z+IlPJoyHqrwXNP7mIimRgwfBFVNN7VilcnE4c0KNYHCoOC2yIegMc1Sk6tpOSsq/dp0sxJvH+UBA086naNAPfZ9PdFAGCAwhQmAooUEDBg4PEDww4VACRAYIEACoaCDARA0jNpaA4bGjj5A+rCCRQsYkyi5dzuRhlUvat5gy0dGUue0mTpw1c/Lc6fPmT53lhAadafQotKTRlDZryvQp1KakSEVN+gmaT6fHnG3tmmwY2LC/gHkV21Xs1LSe1rL1pKitWrhyO81tRrPZp7xqFfHlCyiRpqm7xi4DJ67m4ay4XP8hI5cP3jiYS2Guk1dZ2i2qyqQh4zX41apKifAEZmzYnbrU8VSvbs3a9WvWQ2XTru363u3ctnXj3h0PsrduwVKFsmTcUiA/ytekaf7GeRYwVaZTb3Lk+vUf2m9wr8G948HwGhMiJH/Qg0MPEScOoNhegYLwHD+qEDmSSMr8LAuxooy0J1EAzvaTTwQOCJSBd0l21GnYOFgVOlBFWJVTVFn41IR2aVXWV2aR9WFZHmY2VlwlzmXiWm+91QlfLLYVTU167QXYHIABJhhh1iRGE2rj+EgNZ4Mpc5lkGrZz2TKrvLKZMp59FtpflYiCi3878nalbQf6FltvWHq5JW/sZCP/XCmYmHmccn4w9xx00VEnnXXcybldd9+VoJ54eR6UUEJ3PvSARO8JqgAE8oFUn30ioUTSol201As3C06WoIAIzuYgpaplWuCmhj0ooVUZWqWUZhtqGBVVinEoIoiErfohLbHGiuKJothaK64w0iRjWn3ZeCOOW512GbGRNfnKYDpKWtk614ADjCdUbuYkK0pWggdp0Q5rJZhdZjkgmN1+OW6YYgpTXHJ2BHJJKGm2+dyb0kmXHZ1z2svdQHrmyaefeAYKwKALFKrRfDHY55GijTIahyOtRFplhgFWGiCnqVlq8beUKvsfqKZq1TGFTkX8aquskvzkrLSWhuuKbqWo/0nLaSHGK8y/jmZjsIX1WCyR1DYpMjpHxtiJtJ2RaC22UlLzI7fkZhyuuE5HHZu5mCyXxRrruttcdM9Z14S8VdBb5710mpCveA8cBGgEgD6QkNsMBMoeexAMPFDBhybMqBR8k1GHKcUszfHERXWKsZad/kd4UiNrpSBWn0ouYYYjm1zyLZijJevRKtcas8swi+5Wy9E8Iw3NNduM8yq4eMUjz80GiayQQCu4Fi/Tdt4Jtn8Bc41ltzUN9dM7T3088pa1YwwkfTifBdhZb+0m12C/GWe9ZXvnnQkG6al2BG23HTegdJuvtqEdyRCESIjiVxIS9xUBPxkNC86gxBQjfv84/xpvzLjjIKcUUU0OZJC7HAIJkzmUpcxzoGvLiiIowcCw5SowSZ2vMrgi13VlWEJj1mGWsYvSfEhXsoPGCLV1LFewkEW9WwVWgke85EmthjbkUmW8wTzn+WEMMsBBFtR1Nee06Xply472btAR76UtfBBgyELgY74pDoxgemOfC9yXqPe9728N09DiKnaxMWJKjPvb1KQKl8YyFjBCbjSc/w5Ios/QcYF1PIaQGIistPzCgRSEi4pahCuZmQ6Dq2MdB10njRzao5HKs8wKaSctdJwuQmkxVQsr4QY6JGIY2zIeKHUzQxre8HjMElM2QNE8NdWnCWvoAxueR0SvuQn/ewazly1/qMQflGB9PzQI2i4gvgdEYIrGdCLBNuJL+iAMi1tkHxb+xp/7Je6M1rzmNceouDCaEHICZCMaP+VNXYnqjgnM4xw5pySa+fFWL3vn6P6YFpicjleH9Ivo+lMMRfroSI+EjDyogcd1tq4pkJvKqRI5lURsgQ6ecMYnQynRUnqLoqIk5SmzsYhVvmEjWAii89Yk0lpSZ5ckkBMOrmNLh8RgiWYjyNrYFj5jJqCm8EFmMkHizGaGZH4+nV9PT5KHScTCWYnTJjbLmNT+cZNBcWyj4SRXFDCas6p2HIseG+g5eM4lkPB8oK44IyMN9mUONaIgTJy0tH86EpLQ/yKoaSrpCtwFSaG8a+gtZjLRHmHUohad2pHekUpINC8NHrkBGl4py5FSD3pKPCl3voY9ezmkTjFowZ2aaLdims8BN50ATpfI09GyD5o9Na0V4qBaV0CsYkvVnzXzx9SnRu6b4JzqbcFIVatelbfq3OOtUvfVCEKQq7WKkV7uSdYpRWoxOmvrP61xDLgiY1K5EIxkcrE7OnDSLrDb67j6+le/BnYe3dAFYa2GBhj8cApbm2VjvxNZ64ktiTGg7J2C6TYn1m2m4rsAwUJwRdKatsBBZQnDWls8cC14m2p0KoRxe9uoUjhCWe0thkcIjJQBN7jsDF082SJIr4aYkBO6lf9yl/uSui4SoNB1K1wng5e8/CK7nUkuJ0XR4tiBV7wVHa94yzucUhDZD+tzJXGS80r4ukm+N4jT147YgynrcjstCMHZNPtEJ/63iksUMGl5+tMxQxPBk9gMXxv82mxKdbYRnnCblZrb2kZugKJCx4VpN6IMa5WgHhZuiVUk4gnOJS/1nNFyfzUJ5rJ4xy9GzZ5LtZQ+kkK7k+5c0qrL4x77+MdApmF5BUtkVJDah0h4gypUgZwhFtHJ1plOSqVs3y/rF8DCtDWAwbzEATOztM8Mat8AYRq+IlXNZqQtnI+tbAOtMSje9c+z7yIYPf+W2tUOrp//PNwWCXqQcskLTZ7/MdZDnlUR5dZEf5qrSEe/eKALJBUfLz1WOZDmu8Sy971NicPWeNpL/R7lbQLLjncEY8ikToWa0hAIW6g6OWoiaax9mVLrTbZsVV4meHq5a1rDtAN4Y+YLQh7mKfPg1/JLbRxY6yNjs5zNbj52suUsZ9xW+Np7VGdWs73VCQqyq97+xMxQnGIa9UWfabX0N5jV7hbGqisymgwHcdxJfH+X6qb8d5ewrvWr89ufYiK4wVNdcOPYguGrrl6U7zVxWD95bLPeXvZQKgMS5A1RLd3IyAm8xTPsZ61Vb/maZfv3pTr4jTKHahujXZM83/yqoNG5z905aNGQuMTYLhGNYYSX/xTds9zlvsrDmoJ0cTw6Gkcby0v4SOlPXFcvmbY6p/d9pazTvva2v72/u057rwdnOGGfBsOrUQ2zI2dNcYo1DuZOAshKtvnYySXGNX7EObXU7sp3QQqyeLCS550IiiLJGVQuwzQD/owPdi3hC99UZjfb8I1/f+NRxrIQL3p0I7b8VtViwWgIvfMaxB03nJDRKEu7DZTqicKN7JOM5MXNkALsPWDUjB/uTSBuPNrW6d7t8d47nNfBFdzwCR/DpZpx9MEUkJRjqcCeAFGsVYfzUR+duNT0yRcJ+NpOjVb3bdESkIQbTEI/kV/5Bd7+FFuDkROynd+ycRj8WZvk0YWUMP/hJDQhFNrf/+HfJzyQ/gHdrjDg0JWVHLwF6wVg6HnGMjyXDIlVsPRRInzhhzmUd30QBA7ebFAgashhBdIhuUhg1rnY1xWcB3ogCFaDwV1Cws1S8nEABTgABJDA8dHXq6lUErjddqhPDEocJWpHfWTf9t3g91mBG2yC3/0gywkhHC4bbX3TUylYWrlEtbAQ4/kc5b1iE5KVolVe/YmYts1TFqrOFjYg6+0Yi+UO8IDQ7FTaVVRhArJTtvhivr3h7NUhHu7M7tGD7VngHVIgQO0hHwqH8G1j2YmgcShZLLFBFijRISZAByiiYzFi2s1X810fJNqJJLZdNM2PFrUP993/o8npIA8+Y+wBnij6o+CtX/7MHKeookGuIiu2UP1R3hPCokM+pHL9kTx92xUi1y7aCL3dyBceyS8mAwEKYB/1EV7w4gIiYI4pWD/KHjUqHQY6ozTqA0w+kh22pDOyFXCYl3DwYTAI3052YyCCY8KRQDkKQAKoANisHcQh0avFV0dA35RdUUnMIxZYoibiI/eRhBK4QSeRAz9SFCiCYkCG5cuhA3qZgikswkEmpDHCYkNCpC7aTJTM4kKhiBUWYxb+RdKQhiyORo7ZypAITV0Nxu/4XWAeTUaWZBVyl7aMoprRZFeypEvew0viQ0zaZDVO4DUGR+9l4zZuIx8mmZq4/wsOaMBQJgAHHOWThU3aISV8HZlTXp/BQJNUApXJ1eZ9LMGjcKU5XBRvfqVvAqERvhmlpEM4nNcptIJZJiQrbEJDFoJzPmclFIJbwuLNxKVcSuQSTqShAV1yXSSNCBtCndLpSMW76QhIkogicFcaliQgdJfpRNTwwKdKPiZk1iQ9VOZKXmYG3qRm7mRnTgM3AqKqFV8ahFQWCCUFJChnjQDyJeXa0RebpEF9QZ8L+lJUzqZtWuU95qAVnFkw7uan/SZAqt9YFkg11AOK+kM9DEcxIGdyTkIeDJV0AsaM7iVc4uUhSST94Qq4uZ538mUFKaNV7BmdiR56quflAWkaMf8Nt8hnYlhjvsXOi1EmftJnfc6k8gxcN2wpl/4nN46d1YSUmmCBCnjUGjTBCIRPL2kHSS3iUjLZOjri2MjmbFKlhlKZDXofJ3qiboJoiIpoy4mlcB5IzNWEKunCTtYDP6RDOmzgM7RCFcaopD5njdooRnZhROJfrnDnQv3oYdJYDxrGGO4ZWZgnOCTFkWLq5HEXlXiKk1bT8Fjmps1qI91nZTYjeDmmTXqDlm7pNgLoOwAoCILpYmVBSIDNH6TCH4hjT6lU2Dzom7ZmxTnrnD7iR82jnWboDuAjSfCpn/7pHAIqcJYoicbEICwCuhKWMFTDO6TDotbDO/TCIlDqpFb/qqXm5XWOziEwoC3OpVrASKfiqyyqzl9Myf654agS6Y6YYXua1bmlp3u66icxWHzqqpWCkjRWYH6C0MVaIyppJruGrPAJ67C2y5mOAXOMQfSsizcOYoRCT9otZWOxoJxSnBfQi7V+zVSa3A1uqxV4K7jKXtAGqlENKqw61SOcK7ragSOkqwem6Jb2Aic4wnPK6L1mZI5KYcvU5RV2qqfm2GLUGDi4ITMk7AI1yKOaJL2ZVQZt0kOhIjbFqq5y2pV+aw92LN4+Esj66jSkwzS8Qz2QbDeGKfWwSR+si9kt63LYAS05X/O1acw+rs5ewRVMbvzYI8LkXTOlFjPY7afh/x7AXeAQFm2EjatMKC3qzuvSblQpdEM4vG7gliW9yiLW/gXbJpoWGlfXei1g6KWlNiCljcWHDoUI3ZymiSoyuMXaYq1fuK1Bke7RNumHyiTH5mrdeq71PqOV6u3eAug0BK73vu40DAdHYY1i8RC7fCOrwUkLXqvkxun7WisZWK7d9ezmcu704qp+Cu3Qiisp+gTj2kEdBLAA60EBry4mzMK6buAGplLTHoKMQnBZ2ajo4K6mItqP9m60IKSQbpiebYy4QSzfrW3zbkEnMcn/zFY/0mr2Hob+QuPc7ureAu7fPm04AKgqFFbKkgFznMm6rNr0sG87Pii0wu91iA3Y3P/sPNKvyPUayWVu5pJEIRiDUQEZlvavb75q9KpDHQywFxfwGxjwADNuF48xKLSu8DWw1JpCpMaow57Vw1LQviJgc17wuPnuRdZIF4atX35S8TZdWKEOX9quHMBxQynCuqWw0crtrDay8GBv3spqV2pml9YDcQ6CF6gLcQxoSH0USJ0JmryXHaiBakqWPE4ctbagPCoxKzMxFMfmEzuxD0TTJswCOeTv/s6kj+kbxabfuIIBGIuxF5fxMOsBMevBobou4ArWM8wrBDvsch2C1vqKHS8UHmdwJWgXBw+v6XGOdaltIS9vIW+BCSeyIi+yFq8wJL8wDEsy9a5clnYvcb7/wc3KS4H2wcu+Erts8tmJaYGWMvI9YkBvh+UasRcgcUHz0isv9ELTMhX3aS5fMTvzL2yUg9RsMdF2sXTUQdh4MRqUAUh/dDETM1qeAt+qcRVKMF/MgQRDMB33BYhVs8D+7lu6DkIeL2pI14j0YjfDjDg7LN89QScCY/sBUFEzIwSuc/VGMkS/M1fOMPjewREMwVT/QDR99Ef3sAInbprg8yy1CSqHNUolASUatJxWritnYvUt9JORwSP0gi1H9ETLNbhWNGNi9IF0NEeLdEiH9F7z9TGX8Ubpwpj8LQPrwic4c0uvJTXTYj5ZS3Xe01/Yq80Y5K1AjNF8sGcQshvw/x0hk7OwIYY0VJKE2RmdFUgA3jVSu/D1xnAMP7VmgiyAYkITYNHHRY/CWYLvsYsoN8cdgAEpPyvyRdzEXZwRP187WjVZZyss10fdtdJHbQInQEpTuzZdSzQWgyWCBHZfg7RGJxYxY/VB14EXkHd5C7Yu6MKJWjK8oldiPzAEtzQt4sxC+sUWUvav9Ee1sAWVPAPTeDDtKCCCjbBnywE5n8GijfayyNinfMyD/C+Eq3MLOzUGwjYl++rrqoIdJEGagtYGjMAPNMcPdyNxBLE9AzQWBHTEvaBVt6+1GsGLszhzrzVHcIBz10dbo8EjSPdDK/V1/zj2Mlhv2nXFxq01gf90PYf0eXc3k5f3krN0HczBecd3w6j3iRLn3+pCK6Allct3/c03jtK0vUYJDLVevIGhdHlGgJuCubVnZ49wHriBEAi1oUlKkYQMqYxThPeya0AvI1N0I1t4cATrNhKnLfRQh3dAajrPJQTfkLksVqsmCw43pa84Ls3JcsfPdpSWdsB4c9P4c7umjvN4dWO3qVt3dn+rRa/6qvfmTYz3kmt0X8t6k8O6FzjKMcf6YG8poxLncLAx1XY5dIr5fVcqIBBVk9RiXAkgaMRCLmyCahF4gW/BnM9Bndu5x2R7s0EMae85ke+ylAr6PqCo+I7sNJTCD2xAB9QAGGiNmUiC2J3/XaQzIhLDGhIjQfJVeoWOtZxaqL9z+qffeArYeH1AVmr6dh9Id6kDOapjd6s//EWT0v6Yd603ecVTPMXfehfHehcvwin4J6PCazD0Ql6ga0tDuUpbJ7EngrEj+37/EZo5S9m+Arq1QiFw15vzHRcEdUM5Ak9zBiaZhTNciGkvqbdfk59LuETd8m72KTnwKuzCri2Yuy10VAncASowHLwf3HJcdS3BeEmpnb6rXSUqZSRqOsbhKY2H3EZYUZV58vMk/HRvbMMzfF1/7rf3NSsruZP3/d6rxK0DPkv/vXlr9JLvuiWHPMFJLdWifNVKKjb/iqS+BC7UMUL5RzFswiY4/3scdDYnWoEScCgXgDaN6QVWkcIwoL5ZSJoBiTa58rnSz6qzkIMwaCY9jLvUmzssHPoNqEHWiyDXs+DXuyYSib0uVbqM18vOsnj9qv1HzAcHEPzxW49Xb0LCU7cF0v2p132q/9U29D2S8734g//fC37gn3/g07p3m3EquG6vw2s2NHMb1yvk0zR1+s4++bQg7cJfAgQ5ZZ9itZoUx4oVN0sYKmnIZc6hTxMpUiRFahjGYRs5OvPYDGRIkOhIljR5cps6lCvLtXT50l1MmTNJrrNJE+c1nTqzkfNGb1+9cELThZt2dJotWLYCqSGEChYqqVP7oFmTBesbrE2alBgRI/9JlRtjyZY1iwNt2rIy2LY9coQtErc+YKiIcRcv3q9fOYzoa5ctlq1pCNvpU7XPplP26MVz/Pge5MiSJ1emfNlyZswqJcP0zLlzS8igSW8OzXlbGS+qV7fuwrr1mDFdXnu54tp2bd24eceu87tMHcOlgnWrlg55unfddJnS8ztOHunTCyVKVB2Q9eqVKhXyrj07q2K5NFnPrkgRQWrkxsUiuAnQmYRWHCrRUX9ORIsX+fPv+F8kaNARkCWSnikwpQQR3EmcBnM66UF5cJKQPZ/ouXCoeoJC7qilllKFED8IISQqVRoZsSnCuHrjsD6m6GovsWowy62zZEirhhnJqhH/hx/aYgswr/ISUsgRUuhAg79uxGEwrbRC7JFHWiGnMdM0uxLLLLUczTTRuvwSzNPUkY2M3nTj6rYzydyNNjbN/M234GTTw7BHQjGunnT44cefcLKZJUrqBL2uu+q8266S7OQARDxW0DsPPVGQ4YZSVxxxTr75iBCCU06XOCMiiT5Jz5P+Lspoo48CFDCaVlsdUJoFX1JwVnBQsxVXB3WFcMKbZrKpwp/mCSrDeo7isMMPCVHjjqekkiTFrW6sooo1WpSxhLHAukFHtbz91oS5avwRSBKCLHIvvjRA8quxVmzySRaj5IQZc6q0csst7803zH79xdcylXYjE7bZYGui/8zZ3GwzitwWxg1OOYGT2LBR8NSTn3T6FOYUTjZxpJDoqPtOO0MVZXS8RyFV75lcHLE0j0zpm6GFGWiYwSFQIyqVZ/8AVBWboIWGtcADZf3ms6Q/8zVCXoEVdthip8kzHW2OTcdDSeBwgusRUYH2jqvS4HZJJq31Awy4yLWxLHC73XbHtfWyK926R6AgSRKYHGyKvgs7+7CPebkws335PRxxML1curTEw1RYtjRpk3NhhB1muOHMzRyYN4qBM2wQO4kLB7k9+Rlqll4+XiNmkRE1Lzs3UHZU0UhdUWa892JOyKEdbP69PohI7RkjjYYZGvnkUYr1aKSVft7pmpoe5/9pdqyfJ59+iBXKWOS0SefYpGA50YkVplAjkBFD/CMQP8QWi6xqtdIW7rO+PQuscGn0kf9z7fYLgB3Amwr25je/rYEN7jsMi+h0KXvZwxwAc9wEKSgmCVbQMbeBHGsKpkHYlAlzmhMhw95UQjl5rk6YSEU3/IGxPYWDHoACGXYOJR2RyY4VqlPZJHjYKFa8ByFWoIvvXGAzEeCMIcLbj/GApjzkmWQky2MJraj4GQYxDYu70hWF4AG1fnhje6SjGlK0UcalJEUS5asC19DXvvYlMIFh69u74Mc/tt3PLHoTlx3JBRh1/bEvHMhbAQmDQMApsEWCi+Ai77EvwukjMo3/geSFHqkZw1mSQhj8lyY18zDLdVByuBnhKC9XSocV7ISp/A3o+gAJS8yCGKQzHZ+8AagaRic7MXODKcYTnzy8jCIuAyIXGjLEGYBABMhEohKD+QtnrsqJQSOa8ppXK1rlCptapJ42tdnFefxkOUHB01CSk5zvyUIbsoCFOiOxLK5Rywl+cOMczydPNryoWnV8Cx7vKDf9yS1b5kJXCcwFwHTpsW9sMKRC/4AJN8ozcIq8JAQbOUl9XBSjGW1kJCdaGYp+FKScvKBI4wFCk1rupChN01tIuNLMkbKlpuwNwSbWQKscBhMqJKfpiGFL10nHDbvU4S/34x1RjIqYSdxB/xGRuQEQ0IwIEJHDUXMxHmhOM5rT1Go1q2jFbRaImw6qkDeHFc4wUs2cZayFOj0Ei2WtAK5rhONV0jIFiBYybWjiJz/9yccfEVSgRcJAIAMZJK4cEI7pC0ROFwsJx0ZJMYzcKD4kqdGMXvaik60gSDu6yZFO8KQxNVgoN+fSl8IUtaLVjSrpxMAWcSIVxJglMTgRHdsiZHbSocghFLEoHva2IfdhqggskMwZRBVUmlDPVZMnza0+8bnRtSavrpjNsH6Vi/DIXlnDMU4xltN7ZdRGLTxUC2241QlVgKv50gBH+MFToWqgJ7Xgh5Z/9rOvfaTbfjGArsKaa1oJXahiHf/KPvY9dhNSugbhFomPilISs5jVbGX1FVILf/SzAMOwZKrU4cKxdKakVW0IT5vaJJhWxB6M05zQ0GI7uDgLZ5tFOEyXjlnMpnWg4uWoSBWfLciuOlsIng5sBgILVADJTyUCbUhVDGk8MyRQbiKroEGgaoK1NLey7pavm93tvqOs7+jud8Er3jLKIhKRgIV51bm1Kay3CedrwztfdIN8MguffGUbW+6b37kRyS7/1RtaEGtIAx/4oX7w2Mc4QSVGQhjSEZZ0diOppQvHo7OU2fCmMc3pS1/Jw7pJ8ahNiWJSmpjUMlXliylmmGCk4xzn4Icw+mBDHbcCPkAV8o/zs2v/+/yOuEiugHGZkJ85LNFUnejPz6rcbGe/qiTOjV6WIUQp6VGPeVzGLlmxx45whjNDHCqneM/hi1qkORK1YLMs3BlX+OKZvueTb3q5wk/9vc3Pf5UBoIkkUEFmy10GxDMbDGwJRD/UY/MSBoMZ82BJaw/ikx7rSD9NaYvLw9MZrnhlJqcwzqFJxaUdJRRKXHJUq5qmqpRYKvxhunA8YneFKAh23PCEJ8hODmdQgs1tbsRgC/uIQiBmfoaXbP4o22eoYvazRYI0V10Ty9jFtrWv3eV2aLfbYPb2cqpBzjKTO9boVrMsZKFudmshB+wt9LzZnmdv9XnP+wMoYOleLr/o/y3eAk9swQ/t2IjGwhhUquQkHR7xoOzD8P3IbD66yMmNY/zimn0ghfPlYQunmmEqJbWpTR4FkiOh858nNQdVrnJIBIMfsvZGra1Aho8Bwte8rjnPOSUC2x+5uEEX+hmKTpBTJTsjxUuVRzAyZWd/ohkE+YV/NMLckTz92dkmWnXXg93rfVPrYB7n183ri1j7As2NaMSaa8GPtbbZKYSYMxvVwAYqDLzO+A1XDP4J977yu+7+RqgB2U9wxf5hDwyuoQ4skVphFiItkibushAv4vwh4rYreyZOsiLv0Sbs0xwsk0wj0yqNMRzpo0zL4zDPYTgv9ErQ86QA9DgP5TqHTP9ajOUyZhai42MKQchuLqjoIKhqsFM6ZeeCamUmIhooAtqojOmK0AihKSQugjsgxTqIx1RewRVoQVJuAcqqCheqKlaYIQsp5UCs7equ5/p64mLSysy8r9zCTxDSTd3Kb7zYSRLe0J3aTw7fSc/uy/7Cpf4ALLD2EC/0zwQIrW/6z/38bwD3IAAvAdFeyxgizdEaMdIUzx8cUBITD3swUAIp8IEuTRMpy/IsjQM3MaQ0D/M27wRNsBRN0QSxQARjQzB6oR5OhxNkzhF0zgZPZlFy7hZ7KAqt0KqewRd9EfqO0PmEkeksYglxEBmTEQ+W8RaXsQm5A+l4hgp5oReXwcn/gHGbvhAMjYMbk4MfwC7WzmG80kwQ0pAR1nAN+YGtluINt6YN1o/O7AsP3+4Ox+IPd4QP+TCgyqW/Ai4Q2a8N3AgALeESENEQCfIPEmkTmIEevOiRLO8RDw/iGJABO+wSs3ECP9ESO3DwOPGyHKMTOUwjQdEeXuMIOm6lLEclcwPETiwFXxImY/IUZZImU9GT1uQ1HoGFusEUNiFkgAyYfsiHrhB3qjFWrhEpnw5WiFFoghGrlDIYkeEYdoFnltA8lDEHbxAZYecZoXAVqHAarSopKcV6niEbuoHrvCcc1zLWxrGdzLHs0BEdPaSd1C++2GiO7FGP9HIe61G/9DH//wLLH+Vt7xRLEhCyIA9Sgd5AD6TkESvJQgoP4iaRIsEs4hru4haJetjjITsSAR8TMh+tEz3z0lrKckSwJUmwJldzJllzFWXKEYThHXTBEYISC39xJ7bwKItSGJ9sKYexygakGUhiGKMt2lxFKpPTmahwIkrFOpKR57JSK+mAGZnxGZVLF53JCk1BF4qDalKPLf/h+xghEsQgDMSPEcguLs1uKdaKLtWnDQaR3soCBfSSPuWuzwJrsA5KD/FwLwuIjdpAfUYEDg1SawzRfVqw0UDzwiAs8SiSEhnvIi+RIxnUMyUuIzstEzkL0jiyJE1NpkbRNUeUREPPpFIzBGnDEf9OYRZMwUWLwRiuERykb0Z300aj8vlw1Cmb8imh0hqkyxpw50adLQk1oROg8TmhUwdvbtem82TMQz9AoRSOw4XY8vtqgTzNE93UEx3Dbx3Hhw8GVD5XwA77kj7NVN/46+4Ck1zqir0IjkDhUE615jAR0UVUsUxgC5wUL8I4NEIlMkIjMOM4UzIlruEezrIoDyJHMhRFNERVEwUjtUQn1SYxrxCkxBRGAUa5kHmqKEF4VEeNsLl2lFSD1FRPFVWH1OlSlTenchdeVRSMFHbwYFad0RmhdDoUQxiIoXSsNBzNLRMiIQyGNc1kIRPWag1loRwbgTyXNUyf1S6pAK7kkVr/z5Qv7REF9FMF+otuuDX/6jMt6Ah94nROy7UpssBH7KIQRiF7KjJRMdMRMwpQFU9YInTTGs/RQPMBKxRRERAkSdNDLWqSVDCmHFVSRY9SK/Vgb4Mm8TTFfulFe0FGXWIbsupTmzJUi3BVMVZjN1ZVWbVUP3Y3lTMZShYYThZlTTYWiHJlW4ETYGsoZAE8rVQ8/8EXsjQM4CDNjrUWMiEuZYER+KAcn5Vow/QdtUBa4eoE1guuzLRM/ZMEMqC/9pOwvLU/v0Xt0ucNVYFrt7ZcLSFBgwAGnioOGk173sFdFw/rFNBBA9VtIY9tPXIB0xZRJ7FDARZvOZJgDZZhITVh///Wb2NKImozFzjVUw/3VH+TY0V1cUPWY0EWch3XR7UwVSuWcnOTGYwhdWZhV4lBFvTEV89BPM8wEgRhWM0xE441dc3OEJyVD74ADmJXC452zqjAdhGIadOiL3c3W81lsALpdwWNfrwFKwQsTk0Eeb32DRHxnvbtSChACjahJ+YVAjeS0iJyXyEwe8cKX7HXbTtzIgM1ghYVXgOWMQIXxUawb9cXcNtXYVGQhKhDPKjucS/WfiOXY3uUcSW3fqMPf+/3fy9XgDd3V8OBV2dWdGNtdMvNF9IsZ3U2EihB3XiWEnxWWVu3dcPgdZHWdjl4aXPgBN5svUSYTNumhE3AA/98NwO29XdbWA+xtXgJ86GeQhJOhGttQRVsYfy4liCb924oAIiVYBHOknrfFR6uV27p1SGrl0+td20fDkL7tR/sdnspTG3NV2/fF30X1n272ETbRGd0CwsZBIBVwmL1t3HTmH/7N2T9N4CXAVUtV4B5gnNj6XPLbi0X2Pt8IRMYwXRjNw2NlYKPVT3Ts1kR4YFZwHbXC4VXAIQVGS9FWL3QooQ/IGoD7XdZ2HcB7B7flBD/73hrOHm7FmyyAAV+2AKC+BBk06ya2IjhFoIiM4m/qUKuIfA4c1+7l/HmFvEi0QHd1RuW+Jch0ZX/1QIPFbO0eIu9mJmNYG9bSoznuIz/p3mNv8GN1Xhys/mNKZeaSxZ/6VgYhCGYYwk5ys7c/gGdzXA8/XhYIbhn11M9U9dYyY4RmlWD35EFTkCfqeAEqACSucZ2/zEQ7esDLDkDUlhquXWFF9pc/pBaBPIPELEglZdrG4GUvfYPfJgDIsABOrq44qAnNIRur/jCJLASM4s95hjrinltcflBIzFCiaFtvxejGBWLO69gl9kUf6CZlflgQaULkmsS5lcnfhRxoUdyrxmb2VibI9ebyxiOL/ap5zicw/li7tjcvg+dRddme5adATk9V1eQU5dn1/P81soQwvQLNviB3zF24QBp5yq+LNkE6Lp3UeADmpaup3Va/wMSAPfgQMvVa7uWlA1xbFRAgDo6ATpaBM5AnPcBbU9abj2yfE2621B6HKRZ8JqYe3G5A3vZl305e/90tC/0ijPKp3W6p1vTfWMqjGVOmo96unwUgJe6mpsam6dajXVbjuk4mI2jnGqh3Bg4q4nbZ/8YCM6TEXyWuSmBnslOnoE2uoH2j8O0uqH1HTuYg6W1oEmgoAtan9fgBPIZgXLAvA/orw0RsAWbom34MDMaRjhasRk7DhYxH7TOiKvXwRrDpDu7llW6XV05X2f58CSRMr2Xpme5UC8qtVV7tR/8FMkgDshA5mJhPYyamlcVSG07jm9bf9E4Ki2Xw0XccsdhnP+JgVerxvyIe4/PmYG/enYNoZ5Tt55rvJ4x2BDMQMZbt8aH9XSX1XRzdnaHfHYVOZ9X4LtRYGn1+QQQ6P3c7w/8+tAMkb2rvECbVwMUQLEXuwE+OvAim4nDvKYZrr/x9b+1cFNLm8Ab0MAncSiwh09deW7l/DMvq8HZl4vznCZ5GsIndT4kPDqGemIP98qYesRv+9ATnbd7exa8AcXD4XPNz9wmndJb/GYNQci/QLkjwZBrHMeD3Md/XNPb+QuSm4NnN2dZwMi1YNWZfJ9tF3ZpFwCJ1sqtnCDr9J5wYKO1nMu5vLG/XMzNPF4bsZYxcjM7mxmoEXco5W05kSJDG9r/aZpeZznYqf3OHXy1EwJhARdzWk9kqoobNna6kNqaFB3RaXuNldpxOVecvW4tx0vdKp24b5ytxa50mxWDQ13fYx0OgIAF4EDVVZ3VizzgA37IIfnfh5zf1ZvWa73KBVCxfJgCIGDLFfvXxRlq/BtzBdjY/fuJGw/NC4IhLVRee3mK23ykt3esqv3h+tzlX9IHXh4KZEYGx7iou8p5KHZBavt/qczQfz6Nk11IYxtybXnhDDjSK71nK33Sz9CPN3gPBEEM0jANyxPHNXjfR13T39rHQV3gYZcFwiDsD/4LUB12f5zKrXtOEeEN3VuwEbLv4OiUJ36xDyAB7N4BGtsA/zGeLLmQG66xFVZ2KKmx+sgSDKu9qAW/XuBcitkcpg9ce3PZC8032Blcz69d5jM/qEElmqkvjrEM6El8Y9X9jC22qeFYmnHzcjXXllGc7FZ80itY9pue0slOEIhW/ISWD+w999narUk9Z18XDnKW1FV9WIt84FldkTUd08vxC26f7dXe7d3+4Q3MfebqRTCA4nu9y1U5wVqWF19U8L1yKDf1Cyv/pMtS6H8IdzZbzCfz5INCtOlW5THX/aX48vN/pzM/8wHCShcydQ456sVt3DVx4Mp9e4gOokR1DStGvLjNYUZrHLFtjPYRWkiQHkuanHgyZUeO1FpKe1lMmUxmNP9fIrT5rCZNYzxnzbJFTJYsfr6KFqWENKlRo0IZIeIDNSqfRlQjWaUq6CmfP1/afOETJkwbsHDKwoFqVktXFmzZfmGhtuvXPXS1Ispq96mkRqr6NoLVV5LgwYJREfoTKDEbNWkaT8HBAUIEBw4OWD5AgUIKK4ASFfo8KbTo0JscfVq1iZVq1a2KccvGLra3eflq0563r9/t2ON4KovlSrUycvRs78ZHu19uf8yZ7/OnfLny6fqqGyenkGVLe8h1W/f+PQoS8eTLmz+PPr2R9ezHJ3EPP778+fSlqK8PJT/5M/rnGDSFUHbaaTQRRRZhhNFIAypI0kcIogRhgwu61Ev/TBa2FlMvCN3EYU89eRMMULIUdc45RyVFyVJL1RIJXlBRFRWMf8HIx1lySVWjWWY5oZYWcL0Vl1xdiRWWi2DFSJhgVAWWZJKWIKbYYoyx8ZgGk1F2WQMJOCCCDl5u8YQSYoa5hRtyAFKIJqalttpquWQIm2zH3fbObtmp9oorrsEzp3H9QPcndILmRh2h4Nkp4Ezy8Pldo9VdgV8UXtxH6XuVRopppprqV95AA+XxX0ILHUhgqQyRaqpKCkYokUistjphSxVe2FqtFXaYk0we+vSTiCOq6AuKKfpiIrG1yOKUkY1IRRUsWKHlFV1nSaVjWVT4GCSRRA4Zxh6GGBLG/13K6rUXX5LYYm5hTAr25JOJ+SHlFIzJ0AGWCWTJZZcp7KsDDf7+S0OYdHjGppttfoLLm8+0w7CcdfapUCuqhZbwdrfZZmihhGbsZ8fwyHPqMsgsY7Ftjuqz6aXtWcpyyymrXETMMr9M6RxdFISwqKg+uDOsPjv4atA/D43TmxKDwprRGi6tS0678gqUIULVoqKwVBtblFCy5EXjVMtetWy1XkUblY5BZsttuC/ilZUh4oJ9FSxAyY2uLapEoopelxDmLrzxTlEFCVbeS7hlDmi2hBVmlgnmmAKf0Zlno02uSOWhxfSanLRpzhszwHlCcSy8MIPdxRqffmjq132c3f/Iii56Msoruwwz7bbPTrMP4+kOnxUz01yzF/6xonOBPPe8qtDKLx+r07mYYgrCCC8CPSjFMP1M00zz2mtQvy4l7LArIpsXjlUREknZVFjbo1frj83+2dyKIYYgbtvP9v3fXhWJs/3/L7cA1s1u5BIMlOLFmMA94EpbMhziCGKaQ1jOM5GrXGfOBAjIVTARF8Tgmt7EjZzIiTcNIwdNJkYa4TRsNskx1MPqxLHaqI47rHOJ60rmKEjdrnbAw10PeffD4NmsIAEqHvKMl6ojMm+JEpLVhRZxGigu4hGgqKKGQIE97ekiFVwUhq+qlhQzKMUo2tBa+Zi1LK/l6H09upb/G7XwPhaUhQVhCQsLvlW//ekxf99ihB7j1j8BEiNqBEwXuxTjGHndYHD2ciAFrPCI0hRsNaZBjStG0xkzZfIMi9OkB4VzKxGKajbY8c3nKocaOMGmOIcyXQtd6TGGuQMcNDlGMkTGERqGZ4c89GEvgwjM36HnU58oohKPycRkemRUzXMe9D6xpilSr3pYvCIWhXGKbG5RGHmzBSOmBr7wiY8psnAbjtBivvQRIn5seCMVnMAjeK4PLEFihB/3qMc87s+e/IyEH63iLLntDyjoIgyTAiGlBE4hBgtsYJYOwCVIciI1zzNYcC6ap9FUYoKabJwQyjQwUEkvYRYyxnZG/+m5WExCchR1TTbowcKY4sZjNF3dOlq3i+CMzhrmYCVyeAnUXwITC0Ccj++EaZ8edupmhwBQKY+HTGVKtYnboMkyNRSTZ0ITmlBEmlerWM1RgKIUYw1FF73oPaoJywxsZeuwitUUI5lvbemLBDvh6Ma8woENZQELXKaCrH3aE5965Gc/+VdOgRoCKOYypGGilEgMREABDi2AAy3gAyoWozW8IGnCPpswjIoWhZ/IoBzc4FGQftJNO0Gp50BjOVBmTqYQYxQsV8cQkeUJlAvpzhF+ax7g6lCovixuMDmFXKUu1T+OcKlCbhrV6EJ1qgy6XoWqJ0WuQpOaYLWiNkdhVv8u8iUo/ERRW9vKiHEK5X5nTOdW1mmtvOq1fXAQi1r6eM/BEpaw/7QKI/zXLKx8LW9PCcyT/JbARU62cJY1nAgyi6GsxqSzFBYdaFczuVjA5DQrPW0nO4mHyEmvpCb9TWgiVwjTKEyEnCNhCVlnWz7BeJbW6OxpVnGLW/ZWHsNVj3CD2mMgH3fITAgezl4C3elKF4lMVvIyebaSnWy2etGDona5i8XuZhMT4U1FuQxrT0qcF73pzVpgy2ejc6ZxR/Jt53z3+iNB3BO/cxZXuNqGZ/q1CG53IbCMmiSJAy6mMYJ7aIMdKNEIVxgYjM6poy/cYTqYSU0jriiHK+dhxmn/UnKWzNDzHJGmzqQ4aaIUlamfe9MXywk5i6JxMj6HYx2bwx01ELJxbY3rl/mACEVG6qaG0OthgioXxlyysZXs5J9JuRVe1aoppClFLUuby3tDxN4Mwc8xa9ueWluvXF+k5jXC2Z3txKsTyqKGvuLvW4rNSljAIog76w/P+dNLI/aG72rrO9CQZUwJJsDgQ0OUAj7QA4AsNLJGK3zhi9YEBxsHUpEmzdIOBwQePry4zkwS1Kadg6hJfb0QnvrUqS75jGftOUbjONY0mYANgpyeow45175eWRCEefOa6xzYMfePQZ7RDREm22dJ7Bmyhw4TlhijVsxOTSSfLk1qUm/a/5ao+h4u4a390U/b56WE1vbXNUK8t1qHga8T2inPtC8mEGP7A3zFLmD/5agrR6o3ve1OGKgIRu8GhBKC09AEDQTcAAQQgOEcoINCKDrhtmy84x0/YRSiNkyUn/Qk9HQhiptW05tOEzTzsPnO69S6CC+pS5g5KlQnChk5XTkwmNGADQxhUsRNqnJvvfPf5bzmvA527of5n1IfvegDOpXRkX6g05/+ukzfBBWh/uznTxusf7A61uuYla1rn8xfR1fY0Se2s7xdnjkof/nhme6yv138AgUMtOhOF7XVeyrnlIrY3a7+Q/b7MRAo3AAIX3iEF3szUAetUCHRwHiP53i/oP+AFfYKFZdpomc0pWdjK7VRoXdacdBBnJRxH2dhE/gmOzUTI6h8AtISyGBJK9cAFQACteMDMjBztedLu/cDv2eD5uFxp7Ew7IAOC3N8poJ6xieEPxhdyjeCtcIJE/V8kgRtkdRdkACFVOQHUbgGbeAHQhIWbBUGQLB9+uU25UIt4Ud2cABPObACJvADOLAC54d+XoEY0YI+ArV+OiIt51Rf9ad++Fd2UHJACEYlOLBgAgeAAkiAEQYNCdiAiDgTjIcLoiUKj8hhp3FhEygTFXhiGZiBEKdpGkRpI2VRbkJhxYdqKZVRq6AlmCVkMkdUQ8VzuMdLuneDrbhztAdsPlf/TE5jgkBIfEQ4hMg3IUfYfM4njNBXPVFYRU9HhWugjMqYLUDAhc7YhWBHLvAlhudWLfCEAyagjdu4AlXAhui3doexd9SYFnr4fnM4hnyojlHih2uQBTJAWf43iIRYgAgnErikiIy3iJXoOpl3YY54Y5AoW7lyNKIBeha3OJT3OCyVQmzSaaGoKDuGcpW4CpNQARbQJTdoe7fXMr5Hc7AYi7MobHOgg0I3fEXXi7roi0aYdBKGXdA3TVMHhV7VhH1gk8tIBeUWF87ojGGgfYzAVt8mhtbShmlXBdm4jR7wA0fpjU4ABmAAjvl3GIvhFXzVBlyBlfhHh3P4hlmJlTlJ/5Vh6Y6AxwHy+H+DqCUzQAajMGH3qI9u+Zb4KJf8mHAhGFoHE2mbhmNwMiuWFkGYNnlCIJibxkGgUZGjB5E1oXo45QobAAItAGy0uJExSB9H4JG6FpKZOXuyKDzDs4Odg5IOkZKjSZpF2JIwgYROF31NCApdNUWtOUV2IJtv0BjLyIxwBBc8uYVciF7sFYbwQ4ZGKZwrsAJpeAPbeAPd+JTgOCWBsIfwEgh3oAbSiVBXyYd9dRhwwHZlsZ1fyXZq8Qd8JZZ+Azgk0H+WZZYC2ACF2JbO4J5wOZfNAJ/7mI+IKFqAqZCbpoPWxSGbVQyNyHGppVqcdnnCsWgysZioxv8LkBlsnmJ7qsiRMDd7P+aKuNMDNKiZnCKZltmgXcAFnmmSpSmiFzGKKwkRuXKatNJ0MEmMxxiFswmjtGmbb+QjbMGTXRhvRoJuOiKcPZqNx3kDxqmcVTAlReqc0ZlQRjqF73KkhJBu6dadbGeVYyOWVZpITTAClZGe+EKABzif7/ml8Smmdblo//iIFrRJi8OJBao0IbRhj5hBnCdqbPqBHxiRi6kMvOYpZVAGDjqZSFBUlLmhlXk7GJqhIDmhRUZ7nmIQt3iSI5pkIopkypaiKvqSTAh1kPCarQmbMfqUWQCq8uJGcNEWPNmT9BMWQTJ35XZuPSpPVQCrP/pbxan/nE4JlUU6ndKpq0Wqq0vqq9GpnXcgftFZnVZYpW6WpINWJVuKlizYXCjqEWAqrfIZpmOqiKD1Czp1MCjEQR1UQZ1IYZgDE5fYgZIjGtpap7Jmgp8CKgVRBx76p4JaoUZAexRqc4Z6qB5ZrxxaZEMEQiUqmpB6KpFamqdJVZVKK1SEqVLEmjVpB3VAm58aqhNrfm1hozcqBj7ZFeDpPu9Uht+IjcQJq0ephkfAlBKLq7y6q7maBoPQqzcJhUxKrL0alsZ6rDM6lubJrINYAeyZdBkxrUFrrUObiNhKpsDhiJRzrgb6nxXlcJJWromwUZd3mLulYep6DZDTrk2VC4cw/xAQSpmbYq9jO6+ISh6cqR6eIlIhGrBB6LamQmOkebAGaxOl55KrWRo1qbeLMJtoILETy5TEuYblZ7EXS0diQKpB4rHmx7iCG7gjC7kju5yMsastK51gcAeYS7kw6rKdewcx+7LU2W/ImldrAJbLuKw7q54tcAheKiFuWVXVKrvUWp9vGXmUSIEWllGacKaU5lkhWJEhNnlR63mUhmOig6AE0ajQ0wumkAecBLbxGqEqQ7bAVoOymK9oq73E9K8C673JlyBzW7e5W1FPx4QRZBp7G6Nj4Leg2gTv+76CS5wfkAOFKwbOyAJb1xYbu7jmR7JJWbKRu5wSW7lPmbmfev+5uiqbnsvAnxudoYukpPtOaXB2VJJQgPOOFKClZ0l4HLy6h8CWP9sgQnuPKwG7Jky7Q0ufiUmfdPmBo5WuFiYK3Sqn36oInlC1jDZqrIFVm3BavgO2gTq981q913uv2Jtc24vEHXozB2FEKtm2URy3BUu3CHiE/jhlK/p0dmAaD6sHDtu37Mun8EvG8IsDHzC/OXAChVuqiNsW/WuGZ6iNaYicAozABiyxmpu5vWrACrzADDxFnyudlhC60pmk6CcvTikvqIsDDaW6BLCCXQqtIxy7QYvCJzy7BtuPtkuXIuOARnuXjYiulRg9GzW8IBZi33qY++mmzODD/BG9YVv/g/tatkt8xLaMy0rMqD8nS7w4sPHwy7NEsCyJsKXHdKKTmlCnB1/MzJw7m8s8xlggze8BpNUMpNv4ASewxoULjUCwxh57AlRAnNesjTWglDcwsgl0wHeMx5iLwH6sqxALbZ1bky/LtwVcpPICOInkGDJwno8cyXrguiVsEphM0AZNyQg9u/aZrbewcg9ttf/o0KC4aJsww6GnWpImYpVGgoUQB/AqvbXsQ7Rsr4lqXLl8yyLJr5vZiuyaMwC7mAbiDiCTksM8yXZrqWJVK7FwNNCjzPfszGH8lGMQZNcbpNZMAtiszdvMzUDAFmucA4BjhtZcgx6gjbDKsnuswH3c/87uHNT0/MfQhgmfC9TSWdYJXJtj2Rh+S2hlSTgePI/ouZ56IK6XrCoKjddzm8J7vYC0IAoT/dCdwLu8mydlCsPamnmfAIEYJ2mITRIL8VpxAMshLdK2Q9K9hK8obcuSudmS4h954KjfW5qtXMxYbDTNVz3DCG3MXBCzOcZDTctGXWsycNQlYNskgAEZ4AHZrM1s7NQssMYn8BhNIMdznIa2vZREmqtazdV2wM7yDN29qr6DANRVJMh30MCVSyX8XJvZGIjxGNfNKskibNd5Xd4vsdBfSmG04NCk4N5TWwk4Bt/HC8qB3bsF2pef1mGh91kgUYKvRQYCIYMfWdlma//gmq3LNzNsJBfMDAHMwvzgEG7TLUm+p43aVBY9SihFy+zFEDvG0TyoOScDNRADs20Ct10CEiABGcDbSw3chavNQ1qyx13VNYADZxe6mjvUXe2p2B3W9PwInaupmnrd88zAOp7WtcnW7+jW9wLegijXcz3Q523eVe46fM3XDCjYDyjY8D3fVsvQpTjYD1cmidBcz2NKpKUJV/7YFZEQjxDglD3ERVzEuLzS/HrnCJ7gIArTQRjhfy7hP1vhFUXoEpM0qa3aUATNiw7bY9AEEirbJT7iKG7bGZDbu93iwB3cvY3GUR2rTUDV75urD7zHHr7j7ezFtAnIQN6pU1QKfNv/6kD9xZeLx/H8tzjwbwBteAYQ0FOu1wlN5VaM5cPOiO3d5V6OB8dOCgwotI2WJ1X7cF5CAzpQ5giDu/bY5m5uQj78tXKua8Jl0nSe0np+mZ1tHtrLHwvO4BIO6A0+ipUKgoWO4aqpGon+zEJN1Ffw6B0p4jDwgpIeAyQQ8Chu1Zje4r296SL76dbcBI2RGITsx2BQEAjs3F+96jYZ5IMQ69Lk49R98R2PsrQJqiRAAU8O1+Hd61V81wktpiPM5lnegMZ+7F7e5SxH7IAN7Rf3BCJgARgpBIlDkhT9s1Iscl7b7d5OXBQq7u1hxOQOM5qd7kQkcsPM7hRR9e+OmvEO/1rPxPX1fr4bzuGsTZvRfO67k3Ml7u9or/YCz/a6/QFvv9Rx//ZmCLhg4AVHbcCQUHWkHrES79wS39oW//FBDgnY/erVbeQej911gN16fOv/9t2PTHgVQASLcNMrf9BWfvMN/WiO9ogzT/OdsHI3f0vD8Oz2rQh0sPMYKQL+sgVB3yZGNyqw0QvvevRID2SXDQaokLm/Ncvj/vtOL/ydLVIhF9PtfvW5SJBaT+hucr5fn75cvOh1AOJl3+8XmvZrj9wEb9Vw7/0t7umq/vfwi7kzOdYuO/Z8eupPKc+CD+RQRz2vGf/vn91/z84j/89vDdCIZ/kAIU1gNILYCkI7mP9wGUKGDR0+RNasmLKIv3ZdfIXx1kZPnTxWAhnS46qNw5xBlLgwGTBgGUm+ZPVqlaZEdLZwOSMHUKFPrHC5mqnJnThw6oYSLTpOKbds3UaRkdIlylSqVYtAsWoEiVauWLse8cIE7JAjZO9MgwUG7I2yY7sOgRu3bVyxdO3exXuV7ly9Vs/kyfPpGdOlR5EejpcY6brC3MANnJhL8mSfpiz73JRZ8+bNjvR8/gymzOgxTdxyDZLax+oerWGUiBFbBWzatTPc/pBbd+4VK6ZMeWPHDyRId4zbCT4IUijmxZHXIQ1d9Bswxj8jxz5I+/btj7z3gbRIvPhSi+6YNz5ej/b/Q9yxT5/eJISDAwjqFzBgP/9+AfoF9D+ggiUWGQwyhQ5EKcFmTrKIopQsssiljDAi5aOQEvmIlAmPSeahbVAqSaOfYpKpJxIn4yWWmIRiDJ0WX1yqqW5MkSorG7fC8SsdTyPrBx/v0OYcVKpYi8e8jkSyLLmyOpIvr87oYo5DciGsMMWuJApLGAUaLDIULzPFRM7G3Ay00KQjzUjV1uShzddkm6022lAggYTdeusth9+Ae2M44v5MD5TmnHsuzenqCA7R7IRzr7tN+oBUOVDGM2+88yht9D3k4pMhggTu208/UUP9Lz8LiHDEMQMRVFClViviEFYKJaSlRAvxEEnD/18Y9BDEFGOFdTKKvBz2V1dchJGxdshhlh1vvHknmEVqvLGvanckK6wijwADlX+0uWNbJt/qsdy7rrV2SXLVxcoKK6IMjMpltdTymnqX4tLLMMXsiczOJnEEYM/sOEQ66bwoQ002F44TTjjrrPODDHj7IAc890xDUkwsKaUUUARFJeRQCEUzOuhOXjTTOwj97rvwFinvvEktfS5lMKiDT40jNKBvVFJ/LtW+UwmciNVXj4YVWBJtFQUmW3MdiRSWUjK6Q6tdjcjBrIkt9tcU500WbGedFQaUOp5EF1u1vWiryECmOSctcdf1UUklk8Q773PbBcyRXhyTx0rEjDJsMf9Vib2sp8QxG9Mzxx83M01qUWOY4drexFwGFehE4YM8LcY445U37rh0VIIJ+eVCRyv55pQzrTT2RyO9lDyazVuPO9fvSKN3NaYboWefQQXaAACHPrzqVq1BOtZdmtYw+o6Y7gjqTjbitaEPt2/eQKqTVukYscdfNpteWgnz7LTTXZvdbEWG5Vudi6zBXPvp1jv/JvsqWDDBCS9cOQpXJWqcD31gClMCG2eHMpkJNCYrDVRyhCOGYc6CF1wTDjSHAw7iIAsf9B2j/GQ6VOgCdZjwznuiIxqUvU49jGIgDCOFO9ndrlHV4d3vfCcaE1xgeMXDD38+FSApmGJVyjuJQZb/5xCTvER604PiEy0UtQZRTYlXRBrzsAY+YMVqbF901jMI8glR5EEOOUHbFdi3RrWtay3T+BbctPEHttSxbvhzEhv1uMf99UVKUwJcsgJYry7pC4GscIS/NJNIyIGmEIUgDRnGoMYkULBymcOgClajOR/5AAuf/GRpQJgc7gzHdMFAJSoItcLdLeo6Lrzd6155HRpmCoc5VMPvqlACHwrvh0C8jwi68AhlHLFX2esVq4bBkQxVjybP1IQUcwUUYB0EHVjM4ha5CD4wssMxuSDjGd2AE3eVsy58bOPawOKtc5zjH7AIhBOmYJq5wcVu6MSn/tYIL//9b5CG40YxDRmT/30hkkx9YGQMY1iwBwJGkhGspCUvOVHWyAAHWwFlKNGAhjV0tJR/EhQqUzkp6qxwNLC04XZmaSaE5g47LmWPzXJYHZruEgINIB4whRjE+mygC0ZE4hIVxMwKTfFC1nPmSC5SzSteM6jZvFpKwviMFdVEnDchpznTqE91riUQ2vhHWM+hDbKqQi11zOM987lWvVWFn4Px573w9c1ioE9FYXqEAhe5CT1opq+OQ5QDSyZBiVJ0ojLAKCizAMox0PI7kHIO6UQaDFBYx6SiQWmjFrHSl670hZ0FretqKhpe4jSnOg1aEB0AAjLEomgK4l5sk1kQlsjEqBg6am6l2ZGlzv8Wm0JtntVcQROdXDWrxyUCE5Kr3HN6RS9rYquPwAALd4bVuu8M11q4Gt3tWqsLdSiYKf4WVwCKI3DJM6BdEWnQvfKEkQkVbGjyEMGHUrKw0K1ofi2ZUY1uFKaRKs6fSjdSyyLMwCf9r8pgCtpXJorBnNWUDn93hBI8wLSn3alOV9va1/rWwwqJ0BRx1YlElDi3SKVirBLyDRb/1sVQ5SIgxGnc49Z4ucxtbnfvWKSzXNe6YyXEWe9YLrU+l7tGxiOSqfXHVgSSXnIVY2TUq0j4/hWwgH0keKEjScLe18j6hW5iNfrQBHsHpMwxYeq0s9HRHLixZYadcCCcnDmvNDn/u6uOLsHAy1+iNsMbBupTPVyRWomYxCZGdKKNmuKsDaTFgn5xcNGYkxpTGrlL0OqR97gWVIDVx9aFRbg6aU8dI0nHbpUSK+BK3iupKsp1vSt7y/S4WWPZkQ6dJJcnWNhde/LL/G3CYhtLSo2dGWSn85hxIpiwAytKhtxJqZ0hHN8Gq1C0E+4zho1HAP6k1gHCDPRAgKvFhGDkVkfFlYnTjWJGG8ip23t3pAcdVS5autI2Niem+dgaTXMrfp8Wqy3Oqta0buXGpXZfr5kLL0c02cmDA2ghYX0ZKleZr2byTJZPxuUuK9zjEwT2Yv0LQ5AaW2TJHkQkv7vCzN6uziOX/zbMz2RttbTAU9rudmp1zm38bJiYWpv3MZ+XVHSvGw9HRzRInrihJBoNi4+Wd3Cvdm+q5/vgSA7zkcviBDgC/B9Cot+Oi4xjhLNVKlACTDGy8XCIz9WQen1v3B3XB/cKVuO5hsrkovJJMYO874rlMptnWPIzm66yBJPcysvQ8mhTOzQy14NoC/VS+NTcAhc+QAC0Xaqd85znPl9I1OcdlKInet1JV3r0eqs9qMu2HPBuvegfNPvZn8Fd9uYCpu9NBORiPTVe9n1Y5HJHJ3ga4HIL+93IXvbuKrdGgVl1UpQyQFenV71wX2DcP6Nx8M6X47qmJLD5O/6MjpLNke+omf9LPopTtL90unCOype9+GejR8EzZzCdX35+NIFlPpjfPM/jqQEUwBSIg5+jCHJruqCjBaNCOtzCrUWLGqbzkNjbBhd5PdizwEjrItqbunwDwXKyvRBcLtYoAn7LuhS8H7HDATgwPh8Dl3paQVNTwVOrCiiBF4cTpMYAHGqYCOtjnMbRPsCitkf6vrwjv/EDv/ITOcG7DshaP0xwv9IhDoIxDbZxM8ZTKcRzvPhKlMDiwssajRr4PwAMwJwjwCCiAGHaBGaIKqdjiEdbCduSwDosqusJEaYqiNaLtwzUwEd7DA7swEHkkBEUQXxDRH1bvhr0vbxomxUghOr6NOTbMVL/Yz4bjIsoiZKGIy8ehIzrw75Ze4QhvLVHarMjRMVUTEU0IANIGrk+4CiXMTk085jDa7MrXDZni7MtDC0Ho7w3AMPAOpRhFI2w4JlsO8M0FEAKIIM27BDXwxpohIZj4AjSWzQn8gSi0pXVY70NhDqj+ENv9MCpQaYHOUQcO8fcS8cSvLpGxB9LbJsiaQRJvK45IpJtaYEZ1LR9pAocBK/xIi9qEEjCkDKKa7iKYyTu27434zJIUsWHPEJXXANX1IOO0gxZ3JiPoUWNtAOVu4JgKw0t5EWDkTxfDMbAah2IIsMKqIBkVEYBhMmg2bA2VMAPky1txMaZqJWdDBGp4ckq/6rAFns3dfgQorzAoxTKb5TD2SNHehMuElTHddQ9JdA3RUwuFMRKdxyy+zmCG3CCf/s0bWADDupKhWnErGREG3w+QFo7f/JEIDSFvFIkBmoknijFLMNLSTJC73tIVsQ1V+wbvEQojJTCjWwOuoOowAtJF6od7gCv6SCYyXtMnElJNrsZemqTC2hJM+y8l/TMoGFGZ7TJPVTAavzJpWqi1ESmKmq0FfPDcAQg2FTKhiDEcZTK27QCqtS9TPuyuEDB3iSXeyoSNQBLH4OFsUSruxG+fUPLS7xBhpOX/7mGHnSM85k4BIq79tI+u8TL7uQ+V2zFiTzCxYKU9JudwXwUlv9qmcJ7v49JuVzDxdLQxfTAlEZBmfssRsu8rCxsgtjoAArgzM6MyQEd0AQwQNEczZvsyTysTdYcxziUzWsiHKQcSgmdTRBrSqc8BnTczQ7FNN7z0KpkR3ZEuBooS7Zggxe8ruMky7E7Qe5qzuZjgrUchbb0RALqBes8IMsYRYOstbrszjfzTozzL7/EAkhCKE5Q0iUFDyX1jkdpRc2AFDOjxY7hSOoAP/mcT+1ABfurJZojjfwUQ/nDzF7KPAHlvM9E06BhLQRN0CuixmVSzQal0ze0UAF6TQrV06S80zwliG3SUKgUVBDVTRG9ynyEC0S1wRNtQRUFNZ2xI32kwUn/pdS9gZfAyNFiIiAcLcgdlctFiMtRHMKM+84h3b6/sju/nNImbYXCRB/2a9UnzYzBI45UsFUrRaHiOMUxw6xnO7xSoM/nqMz9PLCxMDAlCYFeCoBldck1JdABbFOge9PsqVNecdDajNAMnNA8fc1AvNBprNZCHNQQJdRCJdHkykflK7W6IRI2KM4fawQiQStJrdQYlVF4iVKAMaJiMIYqKZ9MlQxPjctQDdVRtbUhPdgsayk0eKQlhdWHdb/2e9hHQYOLNLNbxdX4Q8L529KYiZ2RDFNDSZhgs6+IopwRSFacWlZmJR6WPVM1fVbP+zYOk1bXlMaomtNwxVbS3NNu/9VWn00KPl3KcF0ucl2CQjVXc0XXc1XUPtpKyhm1OlIDRw0rFo1UrbTX+qnXSkU1S4sDwHAF12oFZRgvgOVRHs2rghWP7LzLIeXOzMiy9xrMVoXYUbiEV4XYWWiFlpHVwsTYU6jCLeMvy0wZL02PBhusJugCkJRBJCvDM13ZyNW8l4XZmB2AzwtNN5xWcF2J1ISJOb3WctTDbDVKPO1Zoa1Q2qpWEizao3VdqoRdpf3QNhmCFkDUpt0uFuxKNZAFrws1F1VXrK1drc3araUKMogD24tdrPoLnrCMTj3bgRWPTzBYWuOruHOvgDmoJ3VY9svRiIXVWRBf8WVSKh1fYf/QW8DV2MFdvMf01WDdwo2rp3FZmB8YgQ5oyZWtj8kFFZet3DQt0GitSXKrGs81TdU7TZ21op/t020FWtS1QKJt3QmeXaOt4KUtQeJlPkb9Kt+F1NPII+PNStzdWk2MknKKXREMzEMgQshZW0aSVVlFyOzdXiUF34ilWyXN0fGV2PAVX29AX/IdhfVlLITZ0l2smcibJCO5L4dBQZ6hDwCG3NNyVsslAAegACtwUzjkXDldUKdJYAVe4Aam0NKF4DNW3TqNSgsG0daV3UNFVBLdWg2+H7bo4LC0BSe42hnM2tst3u7CQahEI4eag0J2qL9kW4TcK7jdjPVSUryV2PP/+V6JheQdPt/xfZYgFt9B2azEzEJiU5nD1U+opV2sdBiURWXYgOJto9xWrmIpDuA4cK1iekab5Z44PeCcBGMGFWMIPWMzRuNvXV02nmAdeN0LvsrazccMdlr7oeOtZIs2cFQgi8fgneM/Nt53oZZ8S15t7r48wFdwBoxxJudE/lEyEdtKDt8drtscdudRuORuCAcg1mQrHUVWhE+EYaHIDOXt0M+EQQI3cYGBRuUXIGhVNuiCRmUS4AANuIAIuDkq5t//teLM1dynyuVdDuOcFV3RjdDTDeahHWZkJlQiMOaSxmCTTmkNfuZ13TGvpC56/Idp2LOxaIEQNjWWxmau/8UKE4ZKctYyfDXhoY6DVjTqwPSXdFZq9MlUY7BkeN7kSb5bh90Eh0XfbsBqrK7nIYYUj9RnZ3Pf+xNTH0lohVZoDUhWtA6BtWZrDrANh97MZrXil6QAA+SEi7blW14mXd5ljg7XBSlHXwZm0k1dkabTlZ5KCq5gJVhmDHaNUoZsEVZBOyJOuJFEsBO7+rFmu9BpE83HzyY1E1XXG5hUqSiDbY7KSwVqcS5koibqR2Iky+CEWFBSZoBVdUYf8X3qSG5nvOWE9EQDTvhhYiAGeuiGekY5fP7I/kJcWZKOe+zKtHZoh6YACPjP64YADoCAB+DuC3gA755u7saA8R5vDf/o7u9GRj9Dw/pwgBHQg7Flhvgm4AGurZ3UZV7W0AcdN5Dmb3FcTUJUbGRu7B1QacR27KXdaXuF5h65qDyDBU9Li2fe7Lww0fohw66scAuPC9Dm6eWWihBFO9Z+PkP+oxV+3o/ZYUnu16Ze8RWXbxVn56gW4nZ20ov8YWE4bpHC1TW7ReauMx4fONLmJet+aIiubiPf7iTfbgYAb+528idHa/LGAPN+AAUQHrmO2foYgT6Q75u11ozGb0DNb23KGt/65QcW5o4GljZGaQMv5pWObBtAcGYu5Rdt5mp2myCJwQXPaQ2/AdCuH0XVcLIg4dJ+PjYnJ6Fu7UXvn0RaBO//7QX0jXRN7le81VFjaFUY3+305e2pflhPh9WqDmJbmKxaBPIiDknI66xixPAYWOsidwBfgmgHsHKIVoAFuHUGYAD7+O5d1/UI0HUnb+gpp3Jbj+j8uHX1TkMH2AGa7HIEwWVaCfMxB2xq/56oC2n/FsRBJGkMHnBv/2wCl/NxF2hyj+yzFF6umJvdhYVpCASCa2kKD/SyvOlEjfcMx4tB964oYPPXZqgr+4SPQfEU1wWCT/FWmIX4ZvEUZwbyneRJtu3bTt/uvW3bvmRhCAZdsOfVQXXCVXWcYRv/hGLTGpUE6Bljx3UrT3YEUHmVZ/lch/Ji95RYD5X0hskhYnYu/392F4v2CSEJObV2MQfUN/3ocBzgV4kVN1dscXfd1g33cjd32gXOc/9NvFh3db9MeORzzp73m+bwzq73r4euQr+ROTDigxT49jufgZdkUDD4t1f7ddb0sYVn3q7bWZhquqVt73XYVrjbS6ZCa+t4/mslFYruVzfDT1H8lb91xnf8l7fyYD/vX591BKh8m3/W1arqnb/JnvdrMu/iag96oTpzbRe9DEXHby9wpi/3pX36gYaBqBd3qjdl4FsT4bz6CR81S9Rgr8fwsNdwzfbj5pzwjzTtfnH7gl8784H75C94g3/+h5d+SFf7ta/767/h6wd1TvB0du6YIDZ1jh/8L/+8s005fFhv5cVX/5TP9fZn/MuFf/d/fAiodczvzASoa52/Bubhf4CIZg0awWXHgB1M6GxYMoYLDTaD+HAixYgWnRWUmHHjRGzbPoIEWU7kQI8mC5bkqHIikZYtW7x0aWMmTR87buKsAVMnTRc+e/LIGXRojyJGix4tqnTIj6ZBnjplWuMI1SNMjWB1SvUq165SvQ6BeWTn1BpmyZ41+3XpjbFLu3rp4uUQqmB1swnLi1cX315+TwEG1QuUYL+6nvU1rFgxs1OzBht73BjypVGWL3NqNSuz5cqtOH8OvdlwqdJ8S4EapHpMGdZYXLtG07rOGzB63tixnaZKixAaNED/iNDgAHEBxAckUKB8OfPlDJo/R45AOvXp1plHYJ7AAPfi3QmAL2A8PPkEFKw8MsbsGvuUKRsqRHaxovyV8+Hjv4/RvsaR/tGRFNJJAvJnHxE7yTSUUArmBFNvacHQ4IIMJlUhVG9dqBVYXG2lYVRqfWjVWmL1ZhVaapWFYoY9tODWhVaJKNdciwTTTTB44ZgYX4T1xaOOiwFpjGWRjSJZYKM11kqSfiVpWSyhjeIZZ5VJ9piVPd6RG2xbconGbbhp6YVvHQg3nHfjJZdmc8ot0GZ0a1YH53XaXfddeeLZWR4FWHCynp/WACjQe/nR11CB+hFa6IArBdgoo4camKCk/wxOCGGEl/6EqaY2XciDhZ6utaJOHXZFqoinboghhmN1qCKEMILY4k6mchjXjNUEk6tePw7m42J95RWZsEQKuViSm412SZO9/vUZZqAFdtlfp5mW2mqt2dpEl9jqhq0XR5BZ5ploqrkmA2/KGedy3dXZrp3boXnnuw3s2WdJ7X0zqEb7xsevff0qKmhIFTkKUjKLIpywvw1NWummD2uaqcQQq/rUUJ+uWKqGXmwoIsZg9fagq7GySlaLKJ5cMVO2DqIrjnv9SJivvOpYJJA2j7IsM6M9W2SUl0npbLTTUouaanaEuS1rsoHR7RhU9baBA1OPS266CpzLJtZXK6cunf/zjhcveWITVy+++Tq6H0cIAbwwfrc41HZHBBKMtt0Db6SwwvxO2DfFlOIkcQp/q8xp4RbfkKLHHjJuoVGLHyViiiNTbpaLlqsI+RC21jGILrr+qKPoNJM27JXEZvaYz9KyHtqTm2ECpeyroybz0UkrTVvT3poYLtV4nlmu8HC2qbXX0l39rvLIyUue2evdffe/bCdaKNzXXw+wQiZJr1L3Beq9KN8N+z14+RFPnH5Lhx+uOeYauw+V4/KrlfKIlst6YuJukdU453WAIlc26gYBg2XAvcBsdKYjluqINhnRQGswrQhaZoQGLcyUxna3qwO3Opi7JITFNxb4XQFIeJz/NGVHAVNzAPGKR7yvKYA761Ie8MhWQzvtSUmAip57pie3+jyEFkIcYvaol6iCGQqJBgsfE9fmN07pAIoQUx8VJUSUIaxvKVoUFVPs574vfqxjlQuV/qYiMp4kLlWbi8siTlEjAtooL3GM4wEN2ItgDctnRIPM6no2ND9yJjOx++ORBgGJ22nJg4rsoIlasAEKmCl43kEhC1c4vBfCUHhpYlfzOimvBoAADTo8m396uDYjKmoYt1gFK1v5C1Wicns7LOX3mmjLvQGRYeT720/MV8VfYiqMSrkiWySnFBjFT4yPk19TjHm/Up0IjTdoEdTUiEUmsLFGoNADB72ECWEQ/7AadASWHQ1opZ05xoI8wxkhOTHIQLoznpiI3Tt/tog23vNoTFOkthaJBBZFzQGSnGTZEmBJg2IyhV07Hidp6MmHEicFopwlLU0pkPv8ECKrdGURMyowAFUUJZC6JaSOsctNRXGKwAxcCnxJzC0Os3DRzFwzf8AxZcKPjCYCWSPdwqoQjiqmFWNZKRZRhBkgSAo0qkY9cAW6cuLRdEiaKuuiNTt4ZuYRWo3nI+YJCZllEJG12d0iFXkFo8wEBL4TKEFP+LsZcs1dMozTJhsKUU+CcqIUJaVFU7m2V7SSlXHz6Edribe6kbSkNzkp+lbqWIfBFKZogdWqGHfT+VUojf+h+ko0YbVTFaVxppm7ShkWccib6qClIHBBG9/4DnE+lS92dMyVUocZZl0VSpzoala36tuvAverG6TNbMraGi6dlUEj4EAH1tpWE9ZVrtKtzlwdetdOglIPo+RrLRFVvY12ghSuJGwuCyY+tT0qfEl0G2NV6tLzNVZ9Y5yvU0ZbU5wmJX6iHRk1LVWWn75vs5ajCgBLc4cxBKWlFEgBEsbQh1KEE7bmhOq0NGNVqwIXq7s9pG/zudXgqiafdtBd07xA1i5pq5+2kkJWYlqCF4sQus+NLnVpbFfr2vCGzcvudnmYNoUM9m3gHe96S0qQ7gYsb0o+7ylZ0l4VqNQm733/bKbm+9JLxYC+lrUm5GjVls9Sbr/1Q6OrauWFOxitCUlJgQZa6oMx6KGNTG2qN2I7i1RY6UjtlJ2zfqvVPvw5xH/u8O2yZBsOmti4XEqxir/VFhlA+ghVUHMJyLSdugIvhjXm5KY7XbUcQ7QBLdBuMfaqxIKwraMJGXIRSwrLgxy5sCM9tZHj014rxte9us5yZClkZS23OFWSQ1WYBSyrLvb0jCiTyoM4VhXbXKEmScACDEag2mvbIRXh8Aed7dyjPfc5wxseNLmR5uF7lns1uku0onnHT0YzmqwqsPSMPc28TOt4oHcKG7/xagNHMClf3KUbfFSd6iEKtshMRoiq/5d8kiQn1rvziQngdp1rXL8g4xpPH33FDOyoLDOnnJ1c5jp7smmCKOUALjNpEw1CpPrAYil4pFofaQEQkMEO34xwrvD87QtbsLeEHve5i27aQIeYuIc+MXIbreIOVqFpu5H67pqAgxJAANOfxnG+ud5vUN+pATVYRDFKTcqBoxqWRNxFqomM3ukRMb0PP2LE/Trxk07ZzVCGb66tzXFex1QsYZlmCwBv+Pk685gcCjCYm82q0LoqtLLaqf3GWBX3/WQEXuKYmx8nymDQeZw7Anoghw7oTRjd3KpPvdJb//R2K5Lqhh7rbqZQBRNUOus3BnvXvR6ArYcaBpv4E9rxdv/wjmIPbm8X6aLU7hCBERzitqye25rB9wWZD4p55zj3N374Y5L50UL9vuXBuFkToYry6B+RWPiH8vpBvmNbsXaDa+OHQNRFFWmG+U0GV4dZiBNsVctl8FaGkVu6sZ6gKWCWIE03FRfsKZrsqZ65qYEa2J7VyQDWZcfu8Z7vjU0HfpLwBVzxGcyqJd8JIoTD9VWryVqtyZ1HVB974d32Xdxj+Z3f8ZrGAR7KKduv1VeZkQr8TIVmSVP7nQWYjdz7XQ6Z+ZeZqVWLNA0m2MI02EIwVGEqYMIb/JOCLRgaWEIolIKu4FlgGGCHoV4fIM0m3MYaOsIaItIbChoHOWAZ1Ab/BOaOBFIgGtZe1NleFjwaBzyA7l3X1wHfB4Lgd4idIxQDN1CDqYUUDJogCv5QD9lNEClfrEGfC+IS3UFKxcGXL03Z9Xlf9wUe1FTT+P2a4B1T+hmh+K2fgxxh5ZkMyr3fyVQe4nEeWZwZJFiCKkxhz/UBgqnWalEgJOTFGHqVnyHd6Z3bBLqhGy6gljjNcZHVWLnePp0Y7UkgGqxBGlRg7XnjFFggDiQOvfVeIULU7x0imvjAI5jdwJVSk8XSwjCfNEgPwykckknf283jrEEDUABkQEaZKPoEDo7iKKpI4bUFWtxiyeHPV8AIiczfTpUMRQKVGdHisaEMNZVIR04e//w93rP9k+OkgSrgSlGZ2FiEQMgEwdK8Rlf1XFhxGKAdXeqJmDNCI06CiZaQmJd8iTZi49IwDe1lATbKRgUGQlL6ARtYoAXyIQZqoHWso74R4jkCTyiZAvGRoMRxpQoGCiS+Wqx9pSb+VVgCUV8hDMUJ5FpSWfcZ5EECXotIXuLYIrBhDqx4Eeb0FywCoRkNmEamxUJKExOSnOMxhZqxyA3WXBmAYRp0SuGNyUq6wBMigc6VBiqEwv3tFk36QTTCoTM+gjM2INKkwU/upGmSpk8a5WoyTVG2ptQhpVJ+Yx/yITkCh4xRZW7qZr7NwPCph1Y2CtqQ5UW04FiaZXG6YP8ksh0qeWUm/iNbEmRbntFBTmdNJCT89SDluKIpMl6H9FdYYGRgjlkt7g/8BdU0xV/9cCSI9E7NTcB7hkBRtErIjIkIUIAF3OdqFYG2II24gVihAejqFZ25LaMepqZoTqBqsqZrZkEhFGUWkMGDPmXUqYFs7qE4WiBVmEAIvGckeYc6EoeHDmJuOkARpIcxjINWbuVwOudYgiV66WMqsRrb6UeL2mg0QKcn6igwKaZkjiJL6uB4fqR5EulGehz+dIhPuchezkrJiZnJqOeoTNa0iclKRqbGjUDMSdqk6YSV2lzN+YRN2YGt+MEX8mIoYEKWcObR3EFnBqgCehgacib/gtIpmCyohEboa0johD5lhQbCHczmhWqo+AFHve3moR6ABUjBLGSDN0QGObAHI+LL2TinP2aii74ojMaoRgiReCUcrL3gkn1ljkqnW/bSxr1llsYnX9JimNHlsh0hT+zETCkpkjKbXALmRL7frQYVrw6hKj5TyylFllbTDWbZlrbne63kFWjj/V2mJQRXtGpmGQrXmsrptb7pZwLlajKogz5ohPLphHrjHfyBbBpauE7ahlpABXjocIgoot5QAzhAKJ0oo5KDMECqpKZoI9pjv97oRdWoj51XPlbqX4lXeK3CKxGnpWIi2kSnxTkWkFLnqsKYRr4YYQop5YUnyf0X/3v+6hE6E+HV4n6ppLFVXnkyXhmcFZhZ25iQSXxGnVVU2xOqwA/2QBPUYUuimf5lkJl+FWr0rFclo+lha9EarVjd6YN6a1EubcyiK4UmZbn+wbnyIdX1zgVgrbtqbbu+K1W664ItQRc4QgUZRr7qq78KDNoC7MLaKKZCYj0W7EJ0KsIm7MGo7doG7L8+LMSaKpZKLH0+SAn4qAc0JKxuLBO+aiySZ8r1av68SpHij0LOisggYRO2HDJdLdb+hubGZ1tQmt/hLBg0AQw84eZ27htggi9WoV086xcC7TyB4dAOmpseLYBia2nSnmm+ZlGCK7g+begCbxWQay8qJdUZb/+JqWSHHpRbwevUsGsFQK8I0EBLSAEZ1MEmmEIuKIm+MuIzAMg69Kvb3u2iiK+mNux7AFYlqK8nXKLAuWh5EdbdqGVb8m18Aa7fymrGWen+hsCGmgXkQh7KGuHkQM5dviIBC6kt7mpdCmaJYCwQxgWLMIVtTNNvrGRTrOTFRho55qDLcu7+/kAV9OIUVsMVYiYhuG7sqrDQTiug1a5qGO22rqaDHuWe/m7TRF3VgUEFnqmaUq3sie4PjEDWIsDyttWMyasDsGsDQC9+Sq/06oAShG0eHAIrWPEiei87rMMWb7E9WoTauuj3CqwKZuIusNL6dkL7gsMj4m0uEWzaYlz/HJNq37Lk/UIm/vIv/z4kf/ll4rIPx9osKuaPT53cdPoxx+qifX0LS+4wGHRpCFdBl2bwb5QABsZAj95gy2bwDaSBJZCwLdgCZkrCs2JmKdeOtFbrAtJugOIuNyYtg+6uDufwlhivaihl8eIu7gJqhgoxhxqxvnGtJeGnBUgvCBQzUgmBECwBE3DBHMxBFX9CNOOCQDxDNfurNfcrNoev3ZQv3AqEEIUX3R7D+Y7lV35CoHwCV4oxgOxtqfbd/QpuyMRzHkemj6LIxabMLO5qIPeaTFmnX+bv+8jqQtZlQCcye3JMc1VAKInu+5juy75nCWRgivXyJGeyJstAE/iB/y9OQ0ebsCmDNJqy8P3RboGysoK+ckobr1BmI26U6Rd2pv3lBmnOptUNsbj8ztbqtLs28TBvgFqJQAsgM0wssxQ38xxwwVFPgiNIs/YyiTZ3r/dK6jqvc3NGxMGKl8KCKnLGbd4OSDuDdUGeqo/WsUXvr+ZGAHxa6asGcP+kZz/74BWFlk/F6iBfZ17GIlA5MIHphOZK9KNZRe6ZbpZmwedSWga2WZtd9JgQaxUEQkdD9keHNOyyMCp35kwibR90YzeyZiGAazfSJg7DcjXeqW64aS7n7oFy6U3j9E5v7RI3Mdb+9BMKdW8QgTIrc1LrtjPngTPLARUfAlM39Sdkcf87nO02j+9JfOUrDdEvuIJWfzFyo4NU92s0S0NXLkpY7ygdYzI9W+nmvucEJHFaW/D//u8CD7R2dkpcS7CCvDXkTp7IimezCfRhcmkNxKxmHUEFSvJyyUAnB8LoEitVfO5iY3JbqIEnT0M6eLRdxCQp+ywqz+5JozS3vuaFWniG4yFqz144eng42rTUCLNOj/jUhHfp2rFtt4RRL/MZWIGLw/gZ8PYzR3ONWzM3cDEXJ/c258JFMPdz44LCIveQi/F8pLNXs7Mcz3ENjnWqAi7/grdst3YSz7Z5mwXu4Q8gwzV7X/KI0KVK/tQsuvWyJR5EpiR+H1hFw+xqV1tG+2H/CXCAy1aymonfJWuyBe/vix1BIJAwZIP0ZEc4cFnrte6kDF+4T472UCb6oUsd7a6Bgbp0Fhb6G8R0s6KBDMwcJI1QB8BAL9/nvEpNlYPAzbVIBNNnS6AWTFwWD3AQEzBBHeSBFURBGbh4XFDxImTvjWsxOxD5NWPzVTv3j5vdNlN1oFw1cZedV5sE/W53+jj7k3u3B0u58pL4BcSnBr83l/Nze7PFWRT0t8+1kRbprOo3FFZpl8r2dAyhU8DYid8nJGmABlO0neP5bwRivUsan0c2FQL6ZVa2SaseZyu67nJjN0aohmt4m34hz1a6N4JBIASDH6Q2tA5l6sKuJdhB/xDMnApAego4wJ4UwYnfAXhSOhgMQh24um23qREcyKhBwmWhoasf0lRk4cpAQRTw4iEogiIooi7kQjVjMb8K/TMYN69fd5AHO9InOzrsK9Nbs/gmO3ajA7PXr1g7+zzTM0SH99ZTTTC3WZRm7Jan4hVBKUbiqio2rgMnZLh3rOWIrgdbcLzDWM1ucKWV9wjcAJsj+O3B+d277EOHwH6jAmRPw4NDeOwKOmbfLmlqthsKPDcevMDvhuQb+lj1QSBQ/CC8wRrMk8O7tC1IOtNsdChUvKQDGhayRjC+7G6YBxpAQgiw6wUcGBFQcIsgTcsPAWaCAWS+gSq8gQR3ZlFkYf98YuFMXAVm+vYc1Pgn7Hw6X7FmPLUWAz3SP7fzR4Q0SPV0Tzd1e3F0Yzc0JLmSa/ezd/dZT3t4l0nXd+28fr2eF54GMy4qqjeWGR4tlmwCmz1kPppCNi5A1Khx5EiLGy1aCBzy4wiYIwJDRAwh8CHEESVk3KiSRoaGEh9lTAmkRkaJiBh/VFFp8uRHDS9hdoBZA0wgVNPSwbKlClXPUj9DAcU0dGgfo0ffpBmU1M4bPWjWOI0KFepUq2myMMW6VWvXolyz9rFkaeugoKGSoimDBlOwVIOajHkzFIzaNGPFpkLzA0aKMX0oOHiD6oiDCSH8PLzjJSIRL3aIIIwCinD/whaDIfVIeGfQiyGQ3kz8+XChl55dzqRe9OnTnNR5NuWRLftTsVy3n+W2fTtXbd7SdOtGl3u4cOLNkEdDvvwYc+SkoLmQPp36C+s2sO/gsT173+rfwVeXOD6EzA3mJ6SPoN5wA/fvDwiQH7/B+okgBebvoZ9/f//7AQzQsvxu4M+ggQxKSL+HFKwhwYH8Q2hBgrwgiC8HJ6rIJQ44uGCEqAosCaSOLigRgvViiKuJh1iKyUUNTnxAgxvUQMWWaYjZaadSeBJqrKL8OAqpPrR6qsiq1iCyECSvQrKpspgqBZOmjgoSDZvKkhKTuuwaJRS6sgITKrwweUstLMQaoYO5/9I4DzHF7kAoIcYQKuMOsvIDYzSBOBvBiC1FK6XCIH6wY7QuuqhjET0WTa2LRpnggotDDnHNNUpZy5S134jjJjd2gkOnuGiGY6e25JRb7lRoWI0uvOu06+5VGLyb9VXyynvpPPbWc6C+9uALNoAD6vPwov+QTfa6AGMA0CAN55QwP8sKQihEBQ9K6CAD+7OQoLq8hQhGGSFAD4KPRsBhxSbUPLFXw2R66aIbbiCBw3FldDHfEtO9q5p0cHSrx1QIvsRgTIK0kkionlqYyCSRumqqJx92WKmLscrLjzTWCORHssTK0o8t7ZprZEuIzGIsu/xwa42guCozixuOiuGwzP9CAAOUFjYQAQSEfgbjjpEWakGNQILcLA0/LSljgx5kbjYIsTDxggkm7AClDF0gY6ILSD65OlJF6yBCUq9fW2Q133bTjZ23nwE1uLlzU9W5VtFh1VZYweOu1lj3tg7oEchDb1de16vAVwTWQ4DxYOn71VhlCaQoWWYJlNAyCRl0sOiBCrLcwm4RDPHzCR2iqAoWy2M8Xg5LuheHKWjHAUZ+Z9zoiJnqNaHeF2+/3UQK0g3EFmLSCWengQ0OBemEI76q4umj7yriQSy+mKekfkwDy8GmIpMrqkdeeGW1MLGFLIOjSrIt0FKBBDSDBPWwzw3kHIKIpYQums07hnAZO1z/ZEtPe5gGROCCowzKDoOIQikc6BgILuRqj0KFA7twNUlxwVId9ISmPiE3t9EthNJITt6eQwoUQsdVgZPVCwHnQjnhKiKGUw/i3uW49DxuPSXy1XzqQx7KDfFCmKPIs+iFrQMhS04FUpC0Ani5bzEoBEdAGkleUi4OhARpN5gJDKqQGMLBiANNwIoX95W71d3rARAgV4xMFKOLiOR4yuOJJAr2o+cdZRND8iPEAAkxPQASDUuhmMX8ICWhqYJkMruL+da3saRgSSxGmQvBxoJJjUHMErYYCSOfl4YLXoczkZHTYyq0mDotZjEhaGBEmmZAO5VHBnYYQyAC2ALs6TIz/xLsmtgeozUNIqqDG+QCHV6TCEUoQhSkyJTb4PaO2uhmVaK6Wwxl6Le/ZZOG47EhDnu1wwjw8IY+dByx1NMSImKuiJhbon7eSTones6J1/JchCxHkYY4xET7rEIN7PUSEqyoJB0o1zgjMAU2rEReWQxnD9FFghJwCI4XeCMc3aUCHIjlRse7Ix4N9gcgCYmkJSUpIP9oSYw1UBKg+d4Y8EI1jsWUZOQTyxUvwZOxBOMPfmADwaAXCp7+tBQekxIjbUmQO4CCCYMrRQDvAIaIvMEPAowBx1IwAkiMgQJTQ1MROmDGQuWqT3UA4A4e+MurKXWCXvMCalxjzNTM9ZhzWP/mXZsJwmmKEDh3qw02s7lNbs6wcN+kwGEfmljXldOh4zxnAyqAv5NIDT/5XGfprHW6B8ETIg+pFkRAa08pDuGtD8Fdhla0oeHxCl30+t2JFJDYNz4AAwGd7UXhSIGDltF46ciJKvC4h4PJD3rFDRJKq4TcJDHqkN6LagOLOhgzwbRpa0Bq+bxnpkSCLH5EAipHEaaxowgVEn3QaSZ3QtymQJAxG3gMQu5Xk4kkpi5Z3aoBfTAGro5BMSGowJs2E8W2kkZsdUBF2ebwVtTMNa6SkoNcIXwpZ4IwOKdijTUDq00YBq4x3QSBYRH70AmQM7HhNJE532OfiIj2ssxqEBT/Wbwti2DLQUks3ekWNKFvpW50kyXoRE+sq3QFdIsrol0J1pMvEmhkChggF0x85wF8YbSHB6WABEYwhU7qBLjD3aNx1WvSIbWPkM2FbiAMpYr2XVcVG2uLJYxKpEQKw2Mu64MwghGknKLsp3Qeryc1ttNqFNUnnHGL1UpZgz7lDBMOelJoXHBfH/ShXznbD6UrMITFkFaVQ8BTacRmtkGAYg6RQttbi+lgVW/wwayWg2sAscwPTvMZw2mGqEQF2A1neG8eNmyJywlOxJUIPe4RQBDVSVn+xNiIleNWQQ4SOmizeFoyZuKyG1Kh1NXARTI4WiC86KIm+AHcuXrJDUZi/wIgbzHKU27jCv6wAim7m8q6NUwEimeLdOQouOGVH3HJDWYxDzxhDaQSKqbkMTm7zBJqHsyOUsFTlgrMzqrIc17ecmc/GyV9COMJJBoejPSCoiiLCEY3QGGWC94B4YzxQiAkkzVIS7qqPnjDWEuA6SGsXE9lmMguJRNqCR7C1BUstYM7WMy4PpjpSIe1rFlDzajrmtcy9HANV5t1YY9YxOJcbDmNjc7JYURb9yQitUOnxAdla54yXvtodVwXB+nKh4bBwUJxIKJ7yWBFWJejE5xQLwxQVAELcKMbDa+A2tpr8PeSgAQOvwB7S94BiYfAyyRhC53s5A9/uATSngfwMP+XNClkVu70goI9ouwUk0mKX3khMQuEve8Rc0ZZxBP23Yhjovbyu3hQfH/y+GGSKMLgUTCm1JSqTeC9PzPLAG0QiCaEtaohUENUf86z+k51EPhbBBl4FjTo+1LoRke10lMdYVYfE5l2nXCmqF71vg0IQ4TFumG1Hmxh31v/KA57eibiWRqkxWosgKItQaol7QQQ2iQDAQtwiRhwAEVHJX4gBN6o7hDLI/gu78wDodrooaAs7+yljRQgASzv8NpIAiRKopws8Qag8BYgAV7QBCEABaZgBRRqD5CHGM4r4EDPB42rYiCG4Maru/RMfoCP464rLx4B+P7NZfCsvJpQGIj/wi2ekAqn8AovoUysMPYEphu+BAmrapbOA6agT/qoj/uq4AIUjWcWI7IqoPkc6MMsgPkc6GmiQG28RuisJsFQzWtKDRAbbP04qBBbDekSQVPij292jZtMov4G5yU+DP/6T/+67hInAA4VJ3Jwp3Ik8NoShP6sxVoY0AA9p+wOELSgqAFFqzS8pYaCJ6KEjO/0LskwCiYggN1ygApWoAXl6CNyIAPaaAEebwWMsQVLsAQj4PGGUQUVamY6JvNyxAg7D2EULvSKq/aIkKTC0OBKCuRkrwjL5PWm8EsijhMSxvjAUR1PoeJeL5HAcByJr2CsMJMgCOSKoDxqAIKcb/qO/yBOLsCKauBmHARnzoMJGg0x9qI7dmkIhMZqyk9sSm0iz68QCXH9lu7VNHJSMEWw9kbDZiUGnghDWML+7i//LBETwY7/LjHs0EleMkTZCPBAok0VY2wVqw0CPxHbwgXr+qUJJGoEOsRDTCAQJEENygOOZsQJ5M3xtujImJG2Fg8ZDU8C4I0NjFHKiBEFqGANSCDyJCADZscYs4AKLuF4eDCkOq+nZu/LpDAI3/IbxUcuu6v3zgLO0BEch6IutwsJ8Wz3Zi8M/XL1Ii6PhMJL7lJKouoffS5nGMMh9REMBrKK6qQ8KuC/6MRODO4xvREiiSAi91AQ+9AQB9EQkc40k/9uDhaxEUGSwyCxsCYRJStxNmkT7DZR7ORFJnWTdCiinrDFNzPHspxoQDZHOHmSQqYlN9tltR7g7qag73DxIy5KBhWABKggB9SNBRmgGWGwKlFA3nDwAx6vtjKAKpNRBXHAGDXKD/RNFtLyEvYgEEQKEzyPTEJPPv2N4OTxY4IqP5uQKP4tQAFUQP8tkwZUQIevCk9hQYfCSwCUQQuNMyTTWmTCZvglV8LvPOBQstxkPCzgZz6TZ/7raUDgM0001Czl/AJxEEszI9NPNVeTNR2xJGGTEmUzJcPpMktkQ1PSJZFtJ9dJW8qO/q5ls2qMxgrEs7ZlJzUEdMCFIVSgXRb/Z0p76NxcCxcdK7aSMbaYUSyjLAW3NPG20/C8lPEgT0zFlAYlgAJiy7qkcd9AaS0/JpPm80DzUvT6AOQEZh79005JjkAB1U8FdVAP9EF9hLhSB1c85EbrcFd8xk0+rAUuU0fhMCFOVOgSTCLRjzSTzukaLEZllBFv5TW96SRvtDZRtTYbAIh+tLKGaMaqjdlC554c0EAqAie75UnXRSRDwBaTbMmIzHfy7gYGjwRjEAWL1Y3EEvAC71gTjwRuUBi300tPoBeNNU1nsPKIERjZIPP2jQd1ihDGQrjmdE7LJ2Ha0mMGNPQEFVDv1F3htV3jlUDNUUq0BC+T71Y51FQP/+c8HjU2/3UDIutwMvQgTVRFM9LVXBT9OsgjXQhUYTUATZLYKPZULRZHi6VYLNHYhiWIPOIRXVXZZMyz4GkAH+Sd2m4UK2Jkccw/ss1BYCAlfAp42OAP1GDeoCwHnSBZpVKhmrUqrZIXfdGNPoAKTMAXYRADtEALmvJMwzQZD2sBbJB2FMpb3RMVCCFrm2drm6dOC3Vd5XVew1ZsyTZefwTk9rMUtLa82qtiy4NgP+xRHxVSNVRHHRVgQUAILhWYJrJTnY6DGNY1ILZvHPZWrk4m+LViFfdibRNVP9BxOtZjR8ADWov+ECS0VBZBhBRlV9HacjKzpEh33jYg021DSv9gBYgVFyEgtkxgDdgAO9WtS78UTA2gOgHPBLSSO8P0BTPgAzzAGHOgKWPwBQ0PLFHABvHOBAhBFgCGywxGEkBqa732a6m3est2bLE3bA3VeShDShQO4VrJWGoUbw2qYOtWYP11V3hGCBJICJTAUlE0NTt1fl2jD+XPEU1SIsxjdL9pcRlXPQb2hgI4JTEwPuTjV1rCWtCus0Arn6yNJuGJXiyi7czucihQA9zjAiiQXoisGalMWUlAPXk2TJ3VAzygtkxA3higO7tzTF3YA5yABU7YabmUhrd1dTXgD2BBFWRBG2Rhh6E3eqW3XAnzQVfvbK03iZX4egOV5IQCCbv/tyd4apQWdXTJ11HnNn0HNoADmGcQ4r+EIAT01kTPRn5TTXA7CNUGtzULd5sOF0P79X/lGAMx0Rb9jz6qNDtH0dleddk0d1oMMFuqDe6+ZSAtinfUJTvpDSaK9fHSsynLM/IMz4VT0ISB1wNaeFo/wHfH9HdR13ZgMHZlsABm0HEe4HdnhxBuRBZwBLjis1y3EJaJGImX2EHptZaPGJfH8U+Bopd7Qn0CQaqqGGjiuJjjeIAn8We8+F9BdIyL7kVZlDQtco1B1XDzF47NzUbnWIBrUyXHyYBxMwRMAAFNtp76g3Mb2Eg1t8cqWIp6zCPCqHdohBCmIHja6HS78mgP/6+2qMDztEBam9EEAG8F3giG4SAHznRMJSAHNlkYZ5ABMADeTgAFGg8sEW94txMHr69biYF5d2Rr95JOh2uWy0SXTfqkv/Zj7lVcpURrN61XD4PY+BVg0/dw7Lamf6ZDW0AIBnYinFmDNihSVC0jhbphqY6NY5RwxOOarVimF7eptzlVV4slb+ixwpns1A2gyg6zBoIlGtiy6AlCpKVB5olypmh0GEoDast7qoCiUjDveFYCCm8F+IAPtOBoeRYHVXhMCw+GGXqGtzOhV3gAAIB3T+AENjkHyrIXCY+vQ5lZaadbmRdOuRakgc+yi88JiYJBOduWlRhfDbW8fuL5Hv90pA+1l/EIa1GGIMJPcfhPm3HamPs1/OwPUt3XfS+VC4QaIy2lqCMFRmMIqUM1PHxtmP03caOagJVbtswpAJzbdV4CaHB3QPSY7FBiq0PLspAIQmayNLYtjhgHoQYaryX5BIG2PKPMF23YsX/3d//aoWfwoYk3sFeAChChDY4WTc8zaQXaWtmgo32LGBChsjH7iJvnFEg6tB1UMD17e514EaAYbXk5bRHOJ6Sk3yTpd7gOcqRafc1XthHCw5XZX73YbIT6xAGXYXW7fmkFJIU7sDrs6t42NhUXqpO7w/ePYn10GSXiIMb5WnwHdFG2rGtsSY+IWghQnwwZ2ARqyeT/baIEOypriwMq2YS10pT5mpK30wM2eZNPwAO0XL/bqLZ8F6Ap2XHku/C8bQWsC3ko27ILPDF/BEJzec7nnLOL2F6R0JfrNQzPwsJT28LVIFGz1KpTDMeLOYtp24u9GH/CeKeFQLJCNCF025iK2jS5wAtY7ahfvNOV+prFd1Gd2n9h+8ZREqG8eVU7NqYnQpxBQropqyYxBEI8Nzi7ewIL4pDjKAW36JN9hwqYtksfzzobId580cpXAHZzdxg/4KATOgNygAVY4APCHE2dNSyf3Dxvi4VzMQs8bweJwfjgHMHJ/cD9fCw6u6S3V86JL4p/onsn/F59GdA3ZkVu55ys//rYiEVyEN2YP3x0CYtE80cydBtTIczUVo3Th5vDQH2mKRa5ZTviJV42w/vrFBdyD/i0rDtkRXbgH5DFqKWJehNZXKshWNsCz+2fIvp1580DqgAOjHZoMWAK2oBpdfcBcoAPYN5a36i+hbeTcwAIfFewM/naM8CTxbM8jx51k9Xa2e1liMEf7IhP+/xg6LxeF9zP4R3ey53PgcLCF6HQLJze04AgkGyHwHk+CCDt0anKKvam4ziL1VfEPcT+iNl98ydEUTyoEd7SOSi4PX3hpeON74/Gb9TGSb3f8+82SayNmjvjL7S6d5NA7InaUILt5snjSf5lx8MJ7sAJ0MXdOP8A2KdAn91IrYk+GT05eK2c1wV7TAGAAXKAoYe+2jGakpMdDsKA5629eK/s7qIUBdaAGKZ+3Nk9MbO+iOH9+P9cF3hk7C8I+lHmjGB6SvNd7YdF7due2JA58a9Y1CF10QnLlHYafsk4MoC67ws+Uqg58GGluBEXf/a3ikcd/Cde8YNNhx6K328IIDRciNDgQAABBxpEuKAhRImHEGHIiEExhokWNWpg1NjCRMaNGm+0GHlDpMgSHUFqzMiS5ZEjYKocqTFT48MHDBEgWMBTgQITTqasMGEiw4OjPn0y6Lm0KQYPK1YYlXCUAVUGO7E2ZeDhwwcPVxVsVcrUKoYVVHL/YEBalgJPtxAEUqCgIlAqYXcxhbpkqe+lU6f+Ah6ll7DfUIMRK17MuHGpx6iCoZpMuXIpP2CGhJjgoGDCz6APIhxNGvRCzqg3qJ6wusLq169bwB4puzbt27iJjGTCm4jv3r+5AB8Og8eO4saP21juIrlz5tCRN0cZorr169g7VF+9fWD3zQzDw/ZOfiDr8efTqy+f+jwCzgpPyzfvWfTChiPyR6zIEmXJjjYBmNKAIm10kUk3hNTSgjDNpAYhmWmAk05NxSXWURJkYMJQRRVVFoYbgsUTVEE5IZUHU22lolVdoVjVh2Nl8EFUHRoFF1w9USCBCj400cdhfOkVyiyI/wUZmGOJMZYkKEhCZhllwUwz2R1peDFEB52BFtqWonVJWkHzneeaa+iVyV1tqtFmHW5sYrRbcC0INxwTcv6m3HN4NqfnnXv26aaa2V3XgXbfhQceeoeyZ+Z65jWq6HoLvScpQZSeJhdBWt6nHwz7tbTRQxu5yVFHJg24oKgAupTRSzUFQggbL8k04U4NUcXBBzlk0WEOf1BhFE8gUgGHEyZURVUGVDQShhYerOisBBt+lSKMI56gBQs5EIUCFSf8uoCOKKCwBiec8JXXkOj+Ze6R7LbbpLuQOebkk1SKNFCWBm2Zr5f8Zhrfo4uCkOYGsgksHnbY3UYwbbrdZufDTP9gNKdv0uUZXcXP+bkboIEKeuhm3QEc8MhkOrpoe/J1Vul8lxp0kAPnbRpRgv05tKBH/+1WIE0br0TTggx6UUVGMVVRBSGBFMviFIRosQIHG8qw1lEkUEGFVFc9gKKHTemEgAdwhMHC1lk7m0EOVnNYFFVkMUWViwMskMUXbawh7hrj7mHuuummoi68gL/7WLyEz1tZIPXKhqm+pfHruGimhXkBmSXPZrDlIHPc5m9r5vYmxQ1jVOfDfFp8cekacwxCx5mDPDDBsJeX6Mi0nwwpapGqnHJcjdaXEMyry5wRUSztFiBHO5M00kMJ/mk8zQzKRLRMMFVRlAYkTqFCXFX/kQXU1US5+MCFLy6VIVheeQVWWCpKsEIVJeIwI9bs90QWByt8sff++/udypF8A6D/Big4eRmOMpbAzEzA47XG7etxD+yXaf4lMssFbzwIQ1ibhCC6jTEMYqCjmOhEiLrTaQxjLsiP8zpmMOsMSjux+xhDQla7GlbwdihbmeQWZxr8qJA6KMnIQ4D2p1KFymepColKWtKgH4AhEEPTwA+meAMJaYADEMhiWS7EgS5uaChTw1DZ2seVHGSrWWPZivvgMCxtRWUqYSEBDnCQhTXw7457I6AA2fW3AvLRgKFAHBgWeIGCNNAAiOTS4xbppd9RkFFmuqAGJ5mwNjHMYb8R/wIJe+amTZrOZ5pBYuooKcnVESp2MZzd7GzISkjiMEzvqcAjT6MTLbnGOp0iYvGa96kg2uwjoCLKEl3CKutgiCFNUIP1sgaBtgErLuHakBlzcKKsjfEqHpgmGo2FlJ1AxW62EtYappADvK3BLnrD4/72WDg9GpCAA9QFPFXxvwRmpgQtq2UiEQCAQwqgSwA4SEAZ2UhHujJgrSMldkRpyVGBEpMdHGHDSninEOrmosMcVQYL9cIWuu5y4kllbFppu5LS0jWRwp0OHYWvz+DEITbbD0iUB0xR1XSFQAPaSzCwFisuAHt/+IMa6EiFYmkxi9jkEE+B0kaeHstWY1xKi/9QBFUWjW98z5TAGtKpTjwa5hJEUlLgBmdAvMyTnvXsAxqQAAMs4cuQ+4wrQQcqwdKASXc7jKShKqm5jyyUTRwJkAcxGbEPkvCTy9mkZi5pSYWaspQD285HD/Y6GXKHpAddD0pPmrJJwTJLL0OAD20W08DW1K+opU0QT5LT6FExQVcsAfyEwgZJaM9YcqRqGMf3NScMS7dmk2oOsBWV4q5vt1C7G1e7SiT+hbWP7izgPAeI1kDaoQkvEEhL48rdudL1u6HVZy1hlkPWVE41l5NsQlWXwdMCdrCM/ZxDC8vJPB0WlJ5kLwsfC9kbvm6k/sXsK1ea0t2lByc8RKSmqgP/zCEKNogocfBGQvAfYLZWVS+5A4SsKMUbFNdoHsrQU9ZCPqzsBC3UzJa3rNI+DwDht08RZw00UAITwI8Ny21u/5x7x+ceyX9jne489YKZHoxgA1lSiJaW/M8mg1egUH7yaMRb4FciqrLtZfAvTeuQ+DbWc0TQpEUL25uKmvC+ifWUfgUVWfJ8Z7IXROUqBZzZOqvUwLJ8z8pwIqEsJgRylsIlqP7E5VBhBFQSfmhrM4yKoXLYxjjw4hSEQgIsWpObDxixhqBy3Kiy6FfZJEQk1OCEQLhqMl0FK4+bywxmgNXHP0ZXkPumx3H64MhJhivjEkmaKD9Zyl+S1HjzmlnbnCxshggz7U396jkPBpbQH+RNJyNGZsTOFDrOY+iaPZYmy4JUdiINsEnt/EqFbPbOkptVvsA0wwczOCLvvvbyiucpnVJRw/XicH4eLawpECUDTqUapkEEFPq1j20s0oKoCYEKQjgc1XnUcapX/dx6WrydsSYgJN6AAlzv+uOIXOSvgf0Zz+qZ2K706LEdm+wuh67Zgw2stHtG7YgFBAAh+QQEBAD/ACwAAAAA4AEOAYceDwIqDgItGAcuGQcuIg0uJhEyGQYzHAs0Ig01IxE2HhE3GQc6Iww6JxQ7Mxs8NyNDHQdGJAxIMxtIOSRJKhRJLyBLQitULBZXHQJXOSRYKAtYRCtYSzRYUTlZLRZaMhtaaEtcWkNkNhtpOyRpW0NqRCpqSzNqVDltQRxvMwpwa1JzPSV0RSZ0RSp0hV11SjN2PBd2SSt2kG52pHt4SjN4VTl4emN5Qhl5Ryp5US15XER5Y0l6RiV6Sit6SzR6s4l8Uzp8YD59xJV/X1CBPw2CTjSDUzaEVDqEXEOGSyeGWDeGWTuHRA6Hgl2ISBeIa1KJVjmJZkiKVTWKWTaKdFiKfGKLUiqMWjuMYT2NcU6NxZqQkHKQr4ySTRaSTyWTXkGUWziVbVGVnYKVon2WaEeXYzuXfGKYViiYcU2ZVRqZdlaZzKSahWecYi2cgl2iXDKjXByjXSakbUmmelemfWKoYR6oaTaobkupdUqpgl2pqIeqZSiqhmWql3erj3CronqtcjquxZqu066wnYKws5SxfmKxjFizayu0bTO0fVW1i2W24rq3eke3k2q3p4a4hVm4i2a4uqK5dTm5o3u6mXW7cy27g0q7k2u75cK8dDS8oWu9gT2938DBeS7BflHDezTDfUTDjWXFfDrFlWrFmnXGfDfGilfHnYHHo3rJhDvJpoXKgjbKh0jLhUPLkljMhDvNkkvNu6PN5LvOjmTPs5HPz7DRhj3RqnTSiz3TjUrTjVPTxZjT68vUjEPUnnLU3cPVkkvVq4bWkD/WkUTXm2fYmUrYpXbYt5XZllbZo2nak0bclUrdmlPdoU/doVfemUzgl0riv6Hjm03jnWLknVLlnljlo1vlq3fl28PmoU7moVPmqV3nnU7ntojook/op2bqtHfqwn3q8NTrpFTrpVrrx5fr/OLtqlvtq2PtsmfuqVXusV3uu4zv0qnwpljyq1byrWPyrXPyrmrzrVvz5Lj1sV31s2P2tmj3unX4s174ypX5u2z6wG76x4b7w3j8/OgI/wDLnLmRxMqZg2De2EnEMJg+ehAjtis3Kg+WGwSnlMHDseOdjx/JyBmJRiSYL1IKwiiYxAkMGBpSwDgjR6EdO5Jy5hTFsxcyatWAahM6jps3dUiPFk3KtOm7p+eiRh1KlCi8eVexFpX2bFkvW6tKdSq1jKtPo2jdqVUbNG3bt27jcu06t+vXVKmUlYVmte9WuFbv7ctKWLC9w4gTpzMsDxy4fZDx+Zvcr3LlyYu3fZNKGB25z1U9F1aMLvNm0ahRWzudWl5ra89abZo9jJntb8wywalEdy80vb+DCxMed2nov0L5Bl2rlrXrxpItS5eur3q/e8keU7fOvXt3cMm+Of+WTB5fvOfnz0tWX159KEYnGSaCNKu+sW7B2LWDuJ8/uEaGlKGRRjdxVKBIZAh4EkonpSTFgwWBUdNALslEk0046QRKK6zk8hNgVCll3IhOQWUiZ7DVNddnWB0GWl24hFXJJ8CdFRxR04AIIls8ymVbbzHGWGNxyPk4VFSMtZYYZ6QxFll5lEnnmmaviZbckUqOVmVqVHa5pTbAfJVJJq0UEyJsh9TBGzW+3ejmm0bqqKJfSkI53Z39gCdeONt55+dl8YTHnnnpoVfooO3F000oZSRyXzD5dSMpO/rtVx09lt2SR0lYKOjpgqAOaEQRpFoRoalSjGQHGAY54epBGWb/uGGZP15JZIm4nsjkVFS52VxWvXoVo1g0crWhLjciy6NyzMZpZG/CBjnkmVU5u2uWXGrJ2HiC2VnZPdlySe2WnZEb7pfF9DLbITM6Q+VyuexRRyop1irccM3mKydg+r71ImveXkbZZPg4Iyg4fVbm3Z3XALweenUeSiih3TxShiKTZsxOde1MRE/H1jWCRhufknwSQg1COOrKqJpakB13KHSQq67ahMjNPe1F7c7Z3JprPboCLXSwOv8b7LBj0bqhUcoq506OTPe775Vmpmu1tMBZa+uKq11brtfgJrmYk+UJbKXXL/ZlLooseul22FaGyconM5J5W9ewvSIvLmnD/zmk1EVuDThohKMGpZ3+POZuaeTh6bjZxOQ46NdKSpyeMXiUQQp3lG7MsT4gW7foqgKVHCqrSqTeMkus01TTGzPTfMYeOB/7oeBz9qw7iT8LnVWSybVJtFli0n2WKB4m63RbvjI99ZxXfzXM9NPinjvXeIO99lVjuzZx49+CWzjbvWI5ftvkZ6++uLbJti6ZtK7mbyp17AFMvbrj6zec1wcv/Nb+Qp/3JgaddGzDGbdJB7eidKeNTUdPmyHgVaqxmexNMIKGKo0vEmSMP1kHZBOpzqI+1SksoOyEGlmdy1iSEAwdJA2yY1eHkien/u2OdwL0nbY6w7z/VS1deEkam//EUiYPHYtfWeOf9YBEvSZKD3BLpMv6yIe20uzwSQObjFbClaJxTdF86puiaYb4ilSM6Yzx80xQfoKbStQvitzQnxKdR0foQbFay8GWARH4jK4tZoFZDCTBDjgNxj1MjfJLJNSck5pHKKEMtzAGKm6BMD+FcCLtqBjpSEYyK4jqZA9qQ8tcxbqCzO4mdoiDKtPAytkxokO3s94NfbZFr9UDbqPBJZuEx0v3HYJe6voEKJA1THXRcI1tmuObfuhEXDzxiXf0X+7OJ64qXhFxlEsfAnnGTWrVSpG66JBOxlRGWGojbmGi4DLSRC/8KfOd/eMlPOkkrqIZ7nD4fNg22TP/pakFEJFBKcMNLpY5PLhiUtXhTuj0MboSdvKhqHvhzEapEiY4wQuwkmgaVAkIWMYybd2cpVGYU0vSWHGH/YSW1dKZItnUjRqtqFsxZ2XE2+3vpklspjN1Ok8behF91LQm2QiGDxdVk1cA7OY3l2ovMcmUpQlUo9zY2AtWfiJYPdOfUeTY06hRD6c+PY47wXjScPCDW2glFG4oKI/BwGORspxaDqxgCEMMJAl4uIbCKuPADzLUFKWDKAoRYpDY0awLRLCoRFe5UUTY7m6J5FmuRLRFxXSLbBDjnmZftJcw1aZeQRxLNUDBrlLM6limRZby/gbWzvK0mV2FVlK/GFTt/132YUalIki7CMdm2GulsLgLseAHWfUhIxewLE0rrDo8u9yrtf36KnSbh8fdqk2Ph3LNh8TTT34x9bs/GugtNJEDDaAgr9+pZHdGsUlOsoqwEi1sq7qA0fpylF04uxmHkPVRMJ7JKZQNWmKwSFSxveZHnk2wc834S1C4oxT1K+2GclaWHrJWnn/T6U6faIsLQ7e6/qWtbQtYVAPrFqk8+61KNRxa4tJ2qsmlxic2+tk5cZUvH4ZRh3Mc3bDS8zOMZB8bu2th2ar4t3SN5BTMKweHcAc86g2ZgB4a34MUFiGipB0qb+bY086wiKrtLw6PJKIAQyUf2oLMnXCbTQQ3kf9D7gsLuzzx4Dp0YTc0JWJOa+Rh18JWGNLCGligaUcjRzOy56vtPTGbTW3qDrxMBPRdxDkbYabxpAA9LpxjXIk0HKKPvpVt/rya40HzOLZFA3EYC6mjzRbZ0H1eRhsOeguBJoEV+PhOePzBOVcAgpNXtjInOanlV5qCFZ4Ip7KXjdxmK1iKIeZdmc2c5kCaza3PAZabh8HgM9aty6M9xJ0b7GWa+lkvz8wwn1m8YVNP14ch7aLREO3Hze4QbU3Zpr5XHD1JwzmIeDETBrMtv/ZtOsZ76MKnkUOcG90YrFg7tcRnS/Fd5hGu7z53mAwBjnLcwhId/YbCrNMwBY68H8j/+LUoC0vsLefEEsb+icxlzl+fNBsaYP6fbsdM7cqOBnwFLrEud+nZVdRNyxIeLSjgQN+kTdi0PbHFVn0S8XX/uZkBL6L00j3xiqt61UK91qohHeng7tTseAk4MzANtx5umtnfYEUcPP3qhku86mFOpt4zftNY9tbiGN77sxOcnco4puMMOxigkLGJX7scEJCv9Ca+7PeZ05zqWuc6qFH8X2n7vEXVJvDhsA1al1YiTRGmHShytHT6kvvpPAHFc19rdQWbfeuZx710BY9hr8f7p2wTu6Ol2T4YYz7rcBY4iQle/Ceu0aOi2Gg7YbTMu2NN5ryvfjqxz8SJZ7/2sQbu/7qv4UDD4xM3yTDYZtLvCld0yBJfhvnbPWp57genmL85/rpHmmiek/Tz1yR65dF2u4QXkrcJMsV64qZwUAd7euYhz9RhmEd7CSYkaReBuhd+OeV7HBhtOXRiILVt4qd7F/hZGER6a3VcRXdMmhYUumE/a2V3dvdw1eduGneD2/d9DZd3Osh7N6eBXjF46OYY4tEwkfMN4aFvrtAM7qeCTviEynZ7G2Y1yMQsEFgW+JeB0ARU/mccAPiFmvUkAoiCC7Z1Z+QJaLiAcNCADpgzGPgK6KZTPzhpglaBg4Z3M9h7ZBdq+/Z7ijZ8RzaCeVGC98N2zGdxP7h2cbdfPyFuMP8IeG5Cg99ng1cYhz2Ig4R2ieBXiZa4UprobOxnMPWXgwkWXPfDJuFkcU44Pe22gWhBTPeHc2QBZ61YFrzShUvxf2AINrclhpEhPnxUiaLQZRuSJkywhqfFhpbmbLhXThZYi81Yh+jmjFO4Z0AIa6Lmh7DRf2A3Vp44eEGyU5phYu5UFjlIQdaQfMeVcJ8GNYI3aq0FaKa1Y6u1idNFK+CHiba3hWRBate4j31ojqMIkDIogpoHFkuzVbInCgrJDbN4h+6GK1xoPiW1i7zYi2yWaTJHWr90M3Z2jGzYhlpIjc84iNF4gdV4kilpj5qIjY8mUoUDfPQWjPxmhyZIju7/BIW1kguWpoB0F4N5GJT8Fhb0+I/714lziFNCqAy5p4U4xxcMCYSciI/eWJOsCAw1mS9OKYFR6VUT9hulAJEQqRf/J23/1RkWOWKM5mrIRFpwoEqMpXDJWIyxN5IoGY4qGY5ZZ4erUJJ4mI8uGZjZCJMzGVl7iJUEOY7YphqhdoM0pxMfIgnMBZQtuXevIET3cpBUx5IUOJUTyG6fKRZPiWOcuY93AVmQaJXORDxFuUxO2YCRyJA8kX9iCZETGThpkZa19Ifcs5aIpGlpgl/1A5ewJ5J5eZf+ppfICZp9CY2fuZRZqYd8OJ0dWD6H+Vvn5CSMaZBCSDd244LSV3BC/3mNCPmXTHk8s4eUI3mUnpmXuOeQUCeLmmmJb7gKqZaasVlG55aJccScp9lLtFmb5XROu5kUaME1unk2uShi94ZMnYBfHkmcG4KGc2lux+mXF0iUhIiYcqOhHrqStTeQ9ned1JlUJBqIS7g+BlYvq7iZ+8hlHkIMwIAId9YLUjWeBelaD+icxuSiXOchD0mLW1d7zxmaAiqf/Zh/ROqeAxqCNjaN+rkVGOiDUIqkZMEWsgeWJ+mhSHGLBjona/E1FUlSVPKlZNVozNBtYsFlEgYKngANdIZsjOCGTUmSdwlwzbmhZfihGjqlmieQOomYI2po+laV3rRvo4ideiSe3P/po8g1JnswTNUgozRaB7lQQTiqgZcZlsmJL44qgX7ao0IKqqGqnnQoXA0omnqmpD5Kn1tqi1EUoHCoFk+ZgVa4e6z4gFfqoLLXjHwKDQWKm7mYoF5amAIUZC7YpiG5enT2fDsxf+uJoXZajXYxLHyap6bKkjPEbIO6h4j6rYuTgilYhcyQDEcYhnvEqM0XrS8YckHBCpVaiPiZnn0WU0kjrVwZjZMmn6cqjQ8JlshznJxKqrA5sJ9Ke3TIkE5ag9LCcKx6TA+rpHqGPFnqdqP6q8F6FGD6hbrYscL6gYx5essKdRSajIwwp1kYrfhKkrtnF3jqoQbrqk1ZifGHbPT/563gtThJiKxIuFZJeK4OYxrpx51fFpqohzzo13rtSJlGuZHeSbD9yq9QO4tBerGkqrLUmKdUG5aySbW1up5S+G9px3/zuqe4oJXTyJ9Xm6sQmZCyWp4wu6tlCYkg22gZK1nB1zZq2hN1OWFsymU5gWzHZppYx7Vwu6O99LKbSo0yC7XMiGwMcbIx135LCFk92yU7e7mZq0DcMiWaa66ge7mM9LM/0YSPW0RwKFx29kvoOFpM94iZGrFBSJdbK6DTOrXleaFY64wGa7VV248uGi0CWxtaUbYL1pfS8Bf7aSNkVKrWume2KyM2qm0Liz7ECog3JEa5oayKezOw80L1/yN/lFeBhHuk1UN0shG3fdq4jutsJxu5kvsI8ku54QEwh3e/+Psc15C/+9u/+2sMAHwePfuz9Uu6zkC5Kli0Zmd2c5NwZyAJyMJq0ccE7Wi8gGmOPHGvh9thhuu7HFKwCWu1+SqwhlvCwzVc/Xme7MrBRCRMytA2zRVpyNs3QVil6MujqMq8W0qUYyG3wEKrCJqWuXW3Msk2Mzojqftvz+q9XoBYFrUQ0CqiNlmbNZJ3Tqu+SVzFIox7cnqyHtERlvAI7Rc5R+i/+NsPkkIx4NAN+GvGbgzAcBy6oSuKLSpO85d2n+DAa8JqKYdYFayPgAkKPWzCJhy9YtvCIczChv98uxvcyC1cnMGUvod8yJ2wDD1iR56Kl18asZSIw9aqZ8jEtmXEw0LEljvSsU0yxNgbYmrEYKg7yRy5SooFxfAnuInaqAcpxdyGxx9qqiwrqjDnxV/MEQxxbMZMxgCcDMawxmusMWwsKeT3xsvMxmYcxwSMDEOLwGFrtW6EZ4qYI31MwQKZlJkqyHWTw46coZSMkLrawdG7w5IcdfKsqrI4m3wbyfG8waJ5yZgsq8kLxJwsjm/rnxXbbPo8Fu3iagCdm7uIZjoEgoRZFFYisq88yTmRShSicIAguSh7bLdMrk/oFU6ITHUMy0K6gra7acE8zCAxEvJRzMccSXB8DQD/nDGO0Q0zndP7y8b5cXgBbM1yXLqmWLN4vC54FsHoGM6HUHPZuolgIWF9O8+8O9Uv284TNsKMbNJUXZeEXKGTloyjfMJXxc/9LI/2+RTzepU1QsVV2svvGsJiDawKvTWonEtimj7/fKbooAxIbNAWzcQzcwNd0Aa0IzMZYmw327qt218YN5D9aqHMqJwH18VfXBKWjQZgXMz0EQquMAqh4NmjINP3Qc00ndMz7RjBgNrRLM0DjM2UO9Qm+W9zF6lIzcfiJs4BncmtCpalNcgZrIzqHNZVDdzonNVbLdxdjarEndy/TcqVvLCuiTVojcn7KrXNyW6resOEjMTuoMoL/80UYOjQD71zINbKfd2hBjhOjofRNyATF2VK751RgMvRFOrRyyajFITfrLbfdezXM6TCw7vSlU0SCEISxCy/CC6/nx3aABwMxuDgpq3T0czTa5zajiHaAwy6tmG6NatydKfYrBcHFrXUNdzUmdgJ9dPVzS3VRS3WiHzV7mzcMY7czc3OqeriUc3iKDwi8QSlZzvdDFuUWjuWnYrIOna4DypaF0RSB1oi4T3etwl8wGA8x9dif5tKb4BY7t0SrpJYh2VKVYYhjzenFBpOs+DaZAw1kXN5xnKqfn27wmzgYUDgCFLgxIwHYazgo0AKtzBJEB7hEO7gkPK/19DT1SzhSP/Ifhz+fpIw24igC2m+33KXWJnQok4dgcFp4zW+6fe84pxe3Iscz3yr44/s4pr+4pwuTKuQYtR93Zucnu6Gr8PrDlqK5El+qW+VRxP0Yw9tWXcLVPTUCxpMaeMUnBF6Bk58URid7F7u5SwhO/RFX/H1lkgnYSdry6lYf0JxulpN2R5R5+BO5y6t53tOCubuC+ie7ure4A/e4JACKZH05xFu2jLafh0uLx3FRvw9DawAQ2lAI5a+ldKTx2qC6ql+8KZ+3Aq/8KRO4wkP3J5uPBrK6tHt6gsdif76qzvswnGEc7ae5JfM5HptS1DOhfNQJDC8uM2WwZAqL0gHO1pOBJ7/xtGsEu0W9RIWdVg6v/OI1fPSfhBwqRC1M6Gp2LolPpLxt9IJAu4nsfR2ngcK3gjlfu7qTvVUrwrtDu9xPEnzTu/1bu82O6eBO3M+G+Iyv3qhXKWN60bnXOo33uIQ79U5TtVajfB27/YJ79u/Cm09btZSB+RB7qOSvciipZCnnuRy/U8ZS/Il76VbRCe58QmK3PJp0kqql3BM4N6R2iHHxggZAvM3/xLunVhEgPNdLtgYkfPQbl8ZBTuqJ0zJhtQ7GaiwQLmPIMyXzfRyPgfkDtq+f+5Xv+5bD/y+wODFD7rzHjmvbcw22yGRvtiW4O+sgHH6+mbe2fZ3H3ttePfp/8zw2u/w2R/xEq/3M55EuOPjf3/x+dluQy7jMqKjyP2gv9TdAA163s34jU+RPbIsOQ4QmQ4NhFMwTUFJjOx0SZHCyRk7rUzpgkWRlSdQjBTuiXPGyUciIR3CINKQ5MgbKVN+7OKlC8uXMQ+mOdNxz6FPolhRRDatJ7Vq1JIlc9bT6CxXphLhkVOGzFOoUe/MoaoI0qVRWbVuzUrK69evxnyNJQuWa1dSQ4eKZZss6duJceMS81n3G91UMVnZpaYMV6+/gQP7fVWpTqdSiUGJ0qk4laTGjyUvplyZ8WXMmV9t5txZ82fQoTMj/oyYdGJEpjMpFqwMGjdpsWW/pi3s7/8q3MrUkdMGdPYz4IRzP7N9G/dxzoBtLfeMGDY0y4oRDRQ1TR4638yqzbvXHd73c+HFrwNPnru9eunLu2M/jnf7ee/fw6PGvNV9xtPrGDS4J2McJkLqIg5JdqoImGUsuigjgTg6wyUIW2IpQApvoBCkCWGSSab+UlttMQOLKkqtoZBRyhSmvohqxakKcfGqUM6S0Sy0aPTqrBtHKauttrKCS6656PpGrJ4sSYOJNFiJ5xvt+iKsNeVQqySnzShzTLQro8tyy+ZS8RJLLbkEc7ScVDsNs+T+oq23314rDpfhdnOvzdqYc+1N5NKEkjPTevEpzE8OqQMRZK4LKhfXyEH/zzv04hvv0UYjdRS+OSedbztkIstPEv34iwMnjAAUECdEm9QOQUTvW5BTTu1wlaM3anLwQVpdIulCJFuqSVaDJGzpyJlumnKnEElMiik5kpVKjaoKwQrGs56NcVoZY8xxRmx15HFHHyeKMUhiyMo0DQstAecaJk8dRjnAhKsEJ8SWw3IyercE9LMu6+VTzDH77dc+YdbMhs4n43yPYOKOu9O4PPVkd7PTMNVyuoFyaa+27brbBx9GJVXP0Y9BfofS+eCzjpxedMKvTP0OsulDUEQdsEBTswsu1VyIXdAyEFlRlZH7NprpV5uKNhrYXGWCyeXUgFRK2WWpwipHqxqZ/xbarKTVGlqus6WWq23FotppXcI125lNWDIXn3SZKWbddu/E7V3EcL73SswqwygjT6DrmydUV863Yc+iE9xf0VILTdXBEIam4OGAmtNm2YpbJWDICXd4X1B8CxOR/Tqh5jubv9uY447LQ8e88hi1tLeSY0+OsgaNbnrBI5GspJW3B26GcoJRBVx4YFwh3qJWb1J+oOkEgoxlB4dW2kKZIJJDI2ShJoNZF0/x3quqw996fBjL73qrr9OvUVuxx8rqEfiBNPsaV/YI0Apz2Umn7QTvRDVvAwkPFKka4IEqgp9q9G0anuCLT+KxpG+sbhoHO1T/7OazlfFMgxsE4L0Qcf83Td2nccHDk8GAVzmFZU5zdoqSY7jBHuiMhiCHeA1vfgOP06FuHx6T4HlSt55KPUpR9PESgqQjkA5lQmeH+BWpfvfENrEpOOpKUM1OZcUrIgMYjMMZ8bSoRZ+xKnnR81X1zqA9FYWhRVSDhIvywAc4WuVFcjSEIuYAxzzAL497NN/X+qg1bIWFGKOIXyHB5ZGUbMIY/QAH/26WM8z8JCh3aWAlJ+kO6zxQkw/sxiY9uaRNRlCUEqzL8HQBlC+aMpWI0gXP9qa3Dm5wdiP0XW0WBqfIWeOEsYGcClfIQob1oj0TE9RhRjfJNWkMH/5gJj92+EMeApGCsUOHMlR2HzH/7oFpn/AE8mSymmJAUZy1BI7jsqNLycFuiOhUJzIvqcuTrTJwrcjmrCJkBzRW5VlupEM/7+jPRACUKgMlKEETEdA5XiWOf/TjI6yGNW6d6ETxcwUhvaCSNhDjXJTMohFzcsoIcnKTnQRlSUWZyXiQNKXdIGkwrNPJa8Q0pCHV5DKXyQ6bjvSTmvzOTk9qF7y0kifd3NnwdHZUWrbpTcEUGMFwORx5rZBwDEsMfKIDOoS8EDuly2EzmwlNZfJwmuwBTzUYQyyWYRUhA9TiJ+Dwq0/4qShy8p0U22nX0lFTZKsTYl/5+tdL8eVtB7QEIAxrBzCcUXv+jCM/AcqHZhVU/7KTRSgdE6q+aeHxjci649TS4otQTLSQljAEID6CgnLdgpGOPJWqgqJJ/S1pGvRzoEaF5Iu6MDC3GDkbb3U7lmng1hcx3Sk7jIvT4yZXuctlbnM/iS7iejKCQaFLKpOq1BKqaZeZg5vmEvPLK0GDPma1TKfqsAy+VvAZ1sChV7/6zI7B94figR0QEwNJ5xGkIP7ZS6bq8BJjaoeuA8ZrXQ2s170mWMGtW/BfT3qot1hCwvBjCvcKKtCBQhbDA7XwZAXKT/FdTaEaRsNTsDAFJUQBDfrs2mgLK+EkmOQGU3AFONiBrrPJcxqzoAtSKPJKUCDiDnwjMoOm8oapfFDIR/8eMkYO6uSylY3HZDFGJo2LD+Xqw7j60DI7uvxlL3uZy2Mm85a33A8u9yPMYl4zcjW5sHKSMLvmjKpU7Vxnx3iCdOVNzX/hUAqTTZG993Cve3WYQ/lKc51lLUULKVbMT3UzgfYbEO9GSV9vEPjAm4aUyPLhwwaH7GNyCjUpOVpRQgaUwx7uMEBbrUZWUxbE44OsGp6ihBzkOtcpXjEfRfxkpsDPCjK+AR5IcS7iRrBEP45ZrJwdoTLiCkMhEUm1rR2SJFjhDIkFg4rw+aomd3PKw31gMILB0k4qF93NZbdy1axlNDs3to+7Ezn9t1Tj4CKKj7zzl/qdpYtZyUOC6oL/6MoaRXkUupnpUGZOE/06BsdNMmM8SIH+BKxUaOfSms50x4PYzgV/+jyiLjXJSe7XCZ5tFnqkShhc/nJmxbzDMrf1imN+h17PQQ6xnrXWak0GJOC6BCIgOmpLUIMlqHGODtUjsCVsWg1ooCE5MPY1OkmkpAQZaSWp9kioLRKThP3rIsFAQzBwdrSfndgr+Ei23W6FbHdbRcqaSt2d7om7H9TH3jJFaMsGCYkmRUc9pou4KAnddPnvkffGHJS2i2f7eNczDYthVYdppTK99bykO+E2CM1M9zK84YfWoaXsS0DoOQgnRmFiF2i48Y9XyuOa7nSoTX579QxY9yi/7coD/1phmMN81a5mlrJKfHybw3rndm8W1yhhFZ1HYQkvaMHQM/CBC0hAAh4QwdF1EIXI6nHCltA5U3oQ9ag75I6pxoODAiT2r5uRV/t5meo7YisKmaTsKUi7SURAkhUAwJVYAR4gQAJ8OyuQArhLQC9gQAdMQAXUtm3jtm3TNgWcwDbIQDAANw60A0kYMjygt/5ZvFsqQe1qqgSZPKr6N+SovM65Dhcsk07wM0BrD3QaQWdAB2dipn5YOFEavUNrFF0aj+/YohSEGPPiLzDSPFsQMEybPSj0q9orOdzrK1K7QpKhq0v7BqVYCuQLPpljrFX7QjI8PluruxaZI0oAHzvSOf8gAAITsD7s0z7t0wAJ2IASMIEa2J6D4oOmWwrsIb824L8IKEQN4AEGdAIYCDuTQBJne4OIwIgP2pucyRmiYrZXerRnSwJF1L/9Y0SzWzsDDEABhIFsIwJSTAK2C8CPYEVVbEVO7MQBXAlYfLu2g5AksCVdNEF6Y6FlQEHbYEF/Y8HtcAdpCCMpaZlOYCAblCIEycGN6UEf/CsgZJQhNJ3rqKZeOMLUKwi2YoXWyzhniEJv+B0sHBl0TMcqFDl2bMd1VEd4dI9zfBRRop+DwjmoAEMx9KeWk7kyLEOcaz6s+J6f04E4lEM6bIAIoMMJyIANyAEsyLk/xIN7pEg8SIL/s0M/qdtIqWvEijsqwEkld/oiU4EOwNEbjXCVWLGVRQRFRoSBUSTFtStFAURFmrxJlchJnYTJVTRFHmg7xgvKpTrC5HAN7LqSfPsuYVTKV5DHY5ShYtqdY7qY59A4huNBH3SGZNgfrhS9rqRG7zCreerGQ+AdYHCrgisVKDTHeVyweHRLdHTHt5xLunzCk/I9nDM+fTSDfuJLl+vH41Ox7am5f/zL9fuKvpQ+6ovD60vIBFhIhrSAE4hIgwI2iiS/gwID/tNIjfTISGQl47GikbS3OIMNCBuevcEIlawVWXRJ13zJk4hN2HTJG3AI2qTJmCRAEdxFXiyY68ITKok8/8gjnDPZF6fEL9XAqtV7J2c0x3TASmbiym0gCrAEImyEQZ3gxvwKHY+Cg7I0FXVgy/Bsy7qsS3aExyosT/LkjZOyR3xcEZjjSzoIg770x5fLx/tckaCDgiNIOhXpJxdxOcWMQw7IgAlwzARwAAVlSD3cnmC7zDygiop8BDRQRaNDrZx0RECwhAMRzaDYLhSsSgsyJQJikOShFVlsSf57TRZtUUZMv9vkSZoUysbrrrix0aQKxuIczsH5ruB0IUdBzkAxL9FpRtgRkSf6PGl0puncBid9UsBSlCHKRnmoRO18F/rLzkzwRkmSvfVUz3ecS7kEU/VUNtDyQr38y/isT/8whM8siAI4jVPpOwIfoL4RuFMaQIIvQAIdQDo/PUgD1b4GcAAGIIACWFA61MMrWLHlo0gKs0iLbAMUc4IcsJAboIma2NDQ9NAPBVFz2s17u6Ai2whXeRAMqU0XbdGODDuO5Ez/w0kAvDdQxTcTtJNZnRumFM5h7FG80SonyQwiFSYjZSd2es7Qmy4olUIqrQ+LuVL6+85WEBTRSacvDVP0FFMyzda5JCV0eZr3FEw1ZdM2zc/7vAL/PLE3pIHqu1M8Xdc8xEMSOAET2IDGrABCLVR8ZYAFfUheG0ym0AhA5CzEUgIJlFTDkrBNRdK76lRPBcZf7MUuepK/QCqMuAj/V3kVe9oVFD2tmow/abNJlZhNYptR3qzVWs3Rp/pRHuVVGVSMjPlV6RiIN9ivGmRYYkVSYwW9RkpW2COHH8ROC5IMLP3IZRCF1JCr2NFWpT3PpW1a8BiSayCGikyjJ1jTcFUDMyBXORXQOZ1TXINDxrw+dv0Aer2+DTiBeJ3XAx1UfC0At9VX7eOAFzACcH0KzoLUf3WKDDzYhL3ZaTJNEW1Yh6XRUBXVnwHYQEyIlFQIQFgex+1AjHXcNnCZyY0QtztVzBHBGh3KXkwTxXOXPllZlsWbF8QOa/JRTQwdgbnGdnLOHYzOKIXS+lIdwHASwYG0T2AGcIyrYmQd83Ba/wXDVuEd02uty9V5oDMFvjadz/rsJ63d2q71U6ST1zoN2+zDvjk0W7QlgQKdgMd8W0MNXwV9SB+Agjh1CjLgLOzBA8NyCkediC71W9kD3BDVRYwJXMLd3BvdRoo9Ko1gHAkb1QD+34rVmS8J4E1I4A+8A0R4xI6YCf092Qgeoc7F1VxttBaal14lHXfJj0OY2U/JhF+kVruEopyFXZ6Vj0WTB2a13S8ZWv8oWt5lrykcXrgEXqYdGeItObKC2kHKnnFlLPqcT67lWjmdPumtgVyLw7mV16EbgevDXrJtyAyI1xAIVAUNXy0e3xLoASVYVL2127v91zbQCFeoLqIYR//53SX6JafAbeNPJVw5nifCiljDBckuMiADGiAy2QTDmmBArmAKTtkdTZn7wjPS7WNffZwjSt1O2EYSXmOrfC/pxDQaxsacqaCVgWH8sLQa/l3gxWEd3mFr5Q5QMga8TNPm9Uv5rLmqNWIB7dPpBVsmjsPpdWKzpdeybUi0DQF7bYAEAF8FwNc77GKku4IwLoMxBoSmAAS5iN8CO6f6hWM3puY1KVlsHsGHdRuSlKcRLVwv6p3P/WYjpNWSNWfNXY4a/UVCLk5+wZuWTQzSoMrogEQQ9s5XWF0ant8nKgbPo2Qhml2+yk5d2iIkjEp2kcdPFmWGbmj2gC5iQJHyE77/VWZeIg4+jJ7TP11M68tDef3oWp7XXQ4B7rVXCgBmBDgAlR7mQc0APP3iEzsx971bV7GEHFPjhY1ma943wJ0choVj3szmbRY0LBLqazbKcdZmuJljpk7nCLbgeAYMzIPneC7OZgTWR8vSoVbo2Muiz4MvwAIKamSGRrtBDAoUrYbkhcbW28vChiblHF6wmPI9ND2+fcywrFWDqn3lva5aPk1ijs7DXB6BkH5XXabXDiDpA71XlibmYjZmc5XpbqO7ZDGsM64uTm3dad5paqbKnz5qnt5sohbc+wXtKRpqoSTB/M1cRoaSgjGTqqZq2I5ty4MhrG5gjuBStdSrm9W4/2k8OLF+2qIFBrMOI8NIg7Jsl6R16FC2YbiW6xJhOZoTw1Ye1+CDU1m+5RpwYpHOZYc87MPmAPFebMYO5u9VyGJ+6cgug8mmbDkABEO4aZ3uac72uE2j75420vrubEnOaTbG39MOcAEX56YeZ9eGhqia7XfuY9quWXcgJseNK1ZIJpTjqt8mVtrN5+JeBU5ZK+W+4VIWmWpl7rYGmU0SG6swBMBsFjbA2ha3T77ua+zO7iT+6F0ebHqNzMX+5fNOaX2lAO1zafVGZvctA3yi7GJR2Nng7/u2bybHb9P0aSknR//GcH52cs4O6tIW6kBe7QRXcA1m8PDaM8xjnhm6Cf+2qqEK/9BnRDTOC+71uBxTcbSP1PCSCdPnJvG4Ll4+vw6rYwtCgj6stTAXcYMXh3EZl9M+pfHtbnRblkPvzgAgZ8hBLW+U9vFJF/Lq8+L1JgNXoWxNTdgb8tQmh3L8duvY42oqz8KcTvUpj+Mt70UuL/A9geoGX3APie3efaWYPfOj3W3eNmtmaK+wPKcMb9bW+hImghdR0I3g7XOlfes8v1b0EClAh77mxaND12tuL+K93tNFT9d4FXcSyG61NdsdR29BxfTGTulJpwCy7eIYmHcj6HSpqGygEfXQNnUsH09+92xW/1IvDfhWx3LS1vJYp3Uv/3Iwl22WufXSfXD/1O0EM59Z6hChRAn2gobk0rNZ4WaMEXYbIcXnzZhKaA9xPR9lHJYHZLuF9rEaOJJPP5j5+qQCmbN5AZVxRg/3cX+BRe/uep3Ddz9pH1/pQj3pTNf0Hlh6mJY+E/u29zZjfZeNgp/yK1/1YSV4dIxCdRwrV7/6/RZt01b4WcVRW0cMxXF4eZ5456H4iLk8tjdz6gB5Cq9wVIHGrQLP7rDtztHkTT4MDO5d51b55qb29CR852b5lg8GVAAfmgdQmkf0N0106dv5GtiBGjdIAoVidN/xd89XtoXMOlT6Oi1fKGBvuZvsI6fIqafWfv93/dZ6V9/6gKd92Qf7jhN7WJ91/7/oTQlG5LVHDTGf7Q8pfiBlj6nezkeDmdVlsPQaLOLOe71HD5Rp9uwwoi8JnbIGcVDj88JH+cH3IWS7BnNr/OeLfMjP68nH+fU3Ysu/fEZP28L2bpN2zEKk9Cl2aUWFaf4HCDBksIARKOcgI1auXBVjKI2btmoSqVEcZ9EdRHfvvGXkuFGjx5AiL4IsafKkx48qUZLs2HIkxIcyocWcabMmTprQhNEc1kvZT55CgwItOjQoLltKXzEtJcop1E5PP2WK6rRqpkNSsV7luhVUR1Bip2JFdOis2apil7GNiA4e3HNy35KLWKwVrmcVme2V51fiU51sc/VqWqlOHa256v9qnOf48cqN+d5Njmz5cuR6milvrtz5M2jOKz2TjgfutLFgwW5RouTnNR0+smXPcZPl9m01uHc/iaJDh4/gJ2oA/238BAniykmQMOF8RIbo0SVkqDCdAvbsH7ZvKOH8RQ4gSsZfKW++4JuDcuwkZIismUy7LVfCrG9/Isv8mPXPv5/zv04ACiiYT8IQdaBRCRq1VFNWRYWIKBA6mJVXFVZSSVdgNTYWWRSmhZZTP+nC1lz3xEUXXcAUJmJbEqFYzTKBSaQiXobtkZgt1EDW2I6ZkbYfkD8KOeRnooVmpGjpnIYaKqQ08iRsfUg5m25R8GZlGL1pWVxyxu0AhJc1DAf/5pi/fQddCdNxVx11I0AnnXffgSfeEuNZWdBAeJZxhx13WOJeMXq51R9GL9WnEkz8KWoZoYW6WJM6kV404F4BUkpgTggqhaCCSDHY4IRbVfigqKNCJZZG03DD4VVouZpWYC2eOGtcMaayCl7ACMojYFJRNFiNVN1YxyfL8NgjZkIGueyRSP7obLOlmdbNak5SGZuUfeShW5W8Zfltb2YuF+YOXy73QpdABAfcCd51t0EGbsYpJ71y0nlFFARhka++6KmXiHvORDRooyOZ5M1H9rHk0qKKVnQwov5RWumlEGl6cYJJafwprqFmGOqFFoYcFU0ukvrhq7D+qutbJtrj/7LLdRWGK4sU1QpNiCsT1spUcMBxSCs60oostMwmS2S0Sfs45JLXsKYIH9yaoQYbr/nBhhu2eUsFuLiJSy7YyqELJtlnzjunD2WKibbYxO17p755fjF3n3Iw4goxAhNcsKMI+20wkA33zTfhEk+KX8WJc4Mx4xs3BeqEEcIKsoelYDiyVxpixOGFKX84FU0j6hXXyzCng441NDJVM1wz5gzjzjxT5fMhyhxbtNJGIx3a7rg7a6SJ0zrdSB5Rc60l1VR2u/WWX3vpW7lrH0c22c3VSz250itHXnkD8Rv33HgipEveeltTOOBGC74++v4NjhPi8R/+H0eLN37/47eSRf95V6WW5b+onFIyd7DKQ56TkCjeQxgSma50JpKZ/la3q179RGfBOkQa4NCJhxEtdx1UH+9650Gk4QMc3bjGJaBWmyc8jwpVy5rUuMatK2nvN9CLnvXMVT3src1exrlhDWvQL4F47zznUc/4krEN8zGmUYwKnKSg6LCIoY+K7ZsIw/JDP09xCn+Q69D/EAjG/v0vgFDpG+dQdsCneKKNhLGGA/1iOhhFkHXaUMbrYIfHnmWwFNMY2gd9J8hArmOQI4QM0/DBDmqlcIYmiNdwblM8GKIhN8yDXpnK5Zt9BbFtngSPnHTgGx6GR2zfgxv49DQ3hISCGN9Q4vmaKMsnSjH/irT82y2zeKgrGk6XvhzJigzkuAUFk2NfJCOp9kfGMmLujI5K4wHfsIe0eGIas6ARM+QCs33AjBx36dgrbLeXXvhqIqIrTCcwqEFoAJKQhnSnCOP5zs74RZHdaCS3HlkC4kiSkrqh5JVwCDZNTu955vpau74jSiBqr5RxQ2W/UkkGu7UyGbDcmy0Lpz5ccpRhv2QfSAfnqPfBr34c+dQwLwaVmSmzpWGUkBiZacZT1cQTZDkgyqgCillMAxlvhGMD5YiRPdKsUlC5CUvVmcDbwRNJ88TdZOR5SGj5pRuMNF4lc9AdfvaTkv5c3kENStCvIWGhm6weFnpoAiHyq6Ce/wTCnbz3vSOu8g5zgMQojGHRWM4yo1b0GwhzqcVd1tKvg/0oSU1qTFsQ8yelQCdLW1rAl44RppX9igDNCYp0GlCNIHLKH5mhIpa1zETcjJmtciaYMxIInZ1AzAaZ2tSnQjWqUo3WO6t61RliQZ9cnSQMtTbD22gyk2Id65fylS9TbtI3zlmoW9tmp4nKtU5GXOVE79qai2LUsIEVLGDBq8uQgvd9hxWJMYVZIMgSNXIFXOblnhJTU42qIzhrVU7RIs3PVlOPxtLmNl32zaLKRHaswMnOLAfbarRztkqzbQghHGEJ3xY0ug0GKaImtSj4Nl/Fg80kh5svHI4rCF8i6P+IUww97GGJa2sbMYuRwD18xXWuM+7eRNWQCEVcYhTf4KsTv1vYKRIupOFNLMTOW7/Fbiqy7pUsGEF0FpfS14wDXBV+cXoIaaqlv/51S4BNJA2WVnAnoOvJAnMh35/Z7kUnki0hKSznx8x5whR+ahwVqZpL1CbEQUhTKd3QJOJFDYYjRm5CjatJLKn4xGktV27yiQQYKyfF/aqx3Kx74xz3uZVL7Kt3hfzEjgJuvCQZ8l/Nm2qPoteYxDymTqH80mZCaL5VLsWVoallLrOxp/59j2PCfMfHsWgrwAJFUnEkjQbD+Wh1fja0+QHteebZqk+bJB+eZJsgRFIVqmiNlLT/RtxFR686W0WxltI9yudhScSjrLSKz4NpTc9YuWGITbYNUT4gzyXUoi5vkP9t2FITqpdLRikXYT3Ty36OQpWlslUGqOtdI/CPqBPtaCOS53sMe3XB5Oyxk72HXrio2Q6OowOnHW2V15aeuqUWa4pnCB5rouazoUQwjvHt1mCteeTegAQYIIG1movR6m7uEpprySxZuk5Fj3dcwzCQG8uYxmgoxGt6nFfu9ruQJhe4FVEt9lMTGbGHGkuNEg5OZFIFgJ2V8sIjBPGprGVzWdbylrXilGpeHOO6ckYh4wg7BiUV2cceC2x1wdSvOxvlKX+2tKMaeQif9s4td3wJrUqL/2tDqRGTQMUtjkEL0et851hNN3FLEHQGMGADxvU51I3uNaZTGkyxj3rVqZ7dHjfpFnq16EW77u/fjd27GQE7qg1ldpjUCO2Old2t3f52uCuz1nPPLEjujvc46F0UfO97gYphEdK1jszoXLAuJvszP1r8zYy/fANVTvl8cHPy8rcw5u3ZDda0pvOfR0U5HEM37ELpOQnxxNBulEAEsJ7QER2iiZJZTZqKTSClFccP2RsG5h55GMF06ZjnNclq+F7wbcPwId9lZJEJAhwvlZyqPV/zQV8YSd+sdc6rSN/1gU5GjAUNbt+WnUr7DV4FjQOt2E+IEIZSqVkB3QjQNNv74f/f4z0hIsmZtE0hP9gfFNrZ/L3MtGgea3welLRG6JFeAX7b1WBN1mjNCXwAA7Le0A2HW1UgBcbh80igdSFdERlBcNTb1RXPB/aeCH6a8AUibblTwqBgChrfCk5KIRYiKzRi7MCgTNEg5uQXTsVa9Fni3k2E9m2fD37DX2BTXsBHXdCFxdiC4YHCHvQR2ung+rFTEyaZFF7hytEfLVahLcLM/cVi8JjQItFCCA5aH4qe5vniKZgelWBNDQAddnxAdrRJiSFXWUng7TWdBf5G0kXj3MhYHm7jeFRSp/Uh6AEfLHldCSpLZxziIRLcFSHZ8TmiO1qCJNgBIgACJUqiZ7n/yjTVoGVxhaxxRQ5uFt55lgZloid+YuwMgyiSQ/mNBVCIQh2oYhKuEwu+oi25HObJoizeYhViJJ1FoS7u4iLtwi8OGimQgmoIoBhWC88VWtZ8CQq43m3UgOrJC1sh3RxCIzbmZDQigQ9coAaGB1D2gENF2oeBIyq4EiCW4zkOIjoS35GV3Qou4juYgkJQZSPCozzO4z3ao+fEgVemDGZxxT7KnTKVjE1ZTkAa0PrVHVzIw1CtF0IKzVuqGTTYFGJwXxtxjlfi2kRanCDC2RXGX4NhnkZW3ss4IWI6YT3pWbXcgreRQmoI4zFEwwASo+n5ExDs0w6oAbhFDQamG0Et/8FADdRO/lB01UBw5IBQruZ0dZUftMZjTkJe3cLpKCVTOmVTJl8VkZ2kjEQ/sMM1XNNVymNW0mNavooSgmWtjaV8YeL+oApAHueHrCWqtCU8zMhRkIij7ET6vdZXRuQeaMhE/uUHHaYuDubQFKZ5asZ6tmdiWmQ83EPmHYPvOaZ95pxVLRJlDqBq7FkeNIE3ogGkZUEe/IEjdKa7kduJCVSY2J5PGgcprU0MBCVrvk1w9cH/xaY42uZt5iZu3hJUgtrAtQOJtoM+dAMxYCVxFudWdiX3eQ4mwpSMmgpYVFN0SmfDyYhQveWt5AUDYWdhbNl36mUadILiqYqbkacgcv+k4N1OYGqke2LhewaYtfVnf5JeNFBmlvai6FnLcP2TG7wmGdJGglagaKZLg1ZamkaoD3jHagolnbjm541effqeJ+pNh3pknjpb8fEmefkpR8yCLwSDPpioiQYDMVClcRYno37IiiZnJaLi/wAkZ4UlX0LEjeLoXp7lke7oMwhTj7pioYxIJnjlV1pfVvTRe/yYiDYhk6In+dWifHaTnkbplFpnPfGnlQojO2Tplm4pf3ppgJ5hthkjHUgNuADRaDpP2JwmhVbo26CBG8zcJIze6O1CnY5gpNhZy+2pt6pgqyKiVCYCuYaCuRpDNxRqOSxSiuLBimqlo2olpJqFcs7/II3SHXeiJY6eBbFw6mK434D1KIM9EyKY6qnKawYd2Hgy4ZIKJqyiZy52ZEfaKuYNYH5OZjdk6S5Egz5wrK/q6iiwpDdmW9atpMjylrKqaVi9FYS27CdNKAsEZTcSa7Y5Qmx+Xp2S4yBGLJ6Z4zv1KaA+ZcLY1RwQbbk6Zq+aqNOYKyswwqLC6zy2wX4RZz6iao5WTtvF3fRJGde+ivMt24vcBajmCBoNi8EibBogwmLIj36U56s+bODp7K16JMXSGczEw8VmbMaWQ6GSaJa2g36WHpnOUM3KprbIho4da5kyqBue5poW1HCoptkMZXCF6R/UnIHWnJ3KLfxJ6bP1/6zlfSjQgmghEq1dmS4epK4vGMM1pOuJnsYstBEjrMe7ShOXxevkSOpYSojWek5AftbixMqxNEOBFJVj+BoqGuyp3kgXdIHasi0sNlWUfh3c2kOJ1O3E1q0cySe1VOYAcqy6quuvdqniSo0hmGSTyObgImuyjhVx7IBxpcsOsWkPSa791qS00izUPInm+l4zcG7n8qyEBfC3bsafGt/pJvAdIJGfMALAoGs/6MOJnlDsOi0YyOPtZjA1fYhdmoXuZq2l6qvv8qD3AQNDDmyKGMgmhNME6ULBmuoZnEHVwkHzZsKRIs4B0231Mpvnvm17bu8Wem80lGg0YNhJFuDMVf+uIsypsbLvcD0gCTBoDSWHunzNy7ppDpgAnNqbawLXtFpUbYba3AowAd+Wh4qr1C3wtzAwG5dr6/LtIgWnKViwNC1wwXqwJ3gwJVpt7m4i7qalJyDhU9gMKfpEqGJR8sLwqb5B88aBly1siJocKSopPGGvJf8wEFss6VlViQbDHcwN1mnbl04rzvmi+p5eb4hYuCzraY7JnCSUuETu2QRltGZBE1wocJ1vff5vGZPxIfnyGYNoGqvHMFMXG/9LK7kuO5yoXuWlJPBJwaKi7uYxNF9tpVpF3rVoQJaCjbIRaZUfma3MJyivqUotDTuvQkCv8skHB4FaXFDvyZXWJbP/p/ZmsgAWcTCkK4kGwxcUgTR+JoEWqyps3il/6dEp6/OoqZgwh1qt1fWYDRZnsdvsgL7QbBlmzczVJwD3MDBHbIUVcC0VMxochDFTF3XZwUAcRB0/sDL34jTk5QKnBzVD7Y3CSh+j5e1q89sdFSvQFBylsMe5jpB6ZQyXc/Om7Yiw7cOwM8UMTLgSop6CbvZeMhBfA0rqXDBw7D7TgTZOqJwoQRSQsrdZ5mt0i5WcdaM94AM2dL0kmnNwwCNtleRO9L6UwS1bzQsFlyHQJglKdUdz9F/jFlSHWkkfc0mTAUqrRxnYwRuAwQI7sKCyQ4nGcew+dp8sJ9RmNj9mxbzu/2s+igiH3LBbUkNDJsVoxaM5d4EVWEFqM0EXOPJ77IX8KE4OU6Tb7nB6ng4vqsYp7K2vnkIYqEsWS4AGiMAG5EBYF+hJYphroDJa5+QQRPdxSTG6jElb04vrzYvavE27zUZeY7Qr8HVfAzZ5l/cA+zVIW4ZJHzZ2rXdKvzcD70khtNIbmyhl+kIFz6483oEkxGN/a7ZO/3Fm4yNo9/cnBA0K/0rzvQcgpIHUtkEGOTiEMwERoHNsz7al2E+Gx0Rt2/ZU43Y76TaTlCTG9ipwo2aasB4KRJKYEuMBhoFZ1yFCS7eXwG8UFxdDv3L9XjdcH7dEq+xm3rIZDnltPMIlJP8lVZm3kpd3et+mez/5e8N3exPRMe+YL3AyibJrKIiF09rxu/5x1QZ4JTwtiPQUDK5tQZI2S/kUhLe5FUj4hBPBGUhCUscPpuwEnm+4qUGynw72xHp4iLcMOPyeoJpkPpNeI3DYB2jABZgAFoTpa/5fc2cBW8WkcxFdabIyiSGULNdLnLyL6yGHokFa5eovMYh3Ly+5qvvsVLU653qGYks5lMsNrQ8EShszSX+B3RTCoEo2ETsNVTpt3hXnf9OrgEvnNG1Crxi44SW4T9G5KzBCUcfwaju4FThBhbNHUsd2ax3FUOi5qXV4w3443HYdXFzDaaTDLawrcxdjxnapojf/uhlcbs3FJoEKF2/IZAZMdKUxxxDcODSmSw51ult/h6hLtHH5hgoEOdUocR4YOaqnemAzebeidwBPefhgPBGpUsbTTcbLga7nuq5bOaG2Az3Ytxy7K+1G7YAHeNe6ynvc6IFXUIqkgiU0ImNnkBXkQPM6QRtc+2tLQiCPiBdlJ7iHO+muT7mTO4rE7ZKEw29Si2oIsSqoQQZ4gAlQASWcwiB0vc06goZ5cdZo2BSDDUOXSxSffbqMjVsf/MEvfBRzjQrgBoDehpBHyUXLnN7E7cT78Bi7OuBLPMZH+cbXescffseDfMgzsJHnM4me/Lqi6BzTse02qssb57AjQ4rm/+iB1fxwrvZqO0EX5MANAL0MJ8QqOk5KCcXR43Akl6AYx3PXKdFp4EME92ovUn0w+IEOjAASUILNcr3wu8Yo06waaCP2qH2NA/xCUzFbu33aN4H0S/+FlnrWZAteT9LNAx7fr7oA9z23dj962xbiD375o8f5fwFKt/cCL/5BQPw1lMPjmyg7IKonePmXezZaxDzuAkQrZNbSodO1iZUlO17SWHF4A+INK07SvLHDCFTGT6JKdfK4CiQukcJIKoN2EqU3bipXunP5smW1cTNpqiP3TiVOmzthnuPpE+i8l/CEEjVaNCjSo+iYFsRXrh87fVO7BfM16lS3Y1u39lHzhP/OoFOqHInlQ+drFjU1TNSIsuNtFCpq/NBBogMvibx44fJV0Reu3hMkXgw+0RZxhxNw1brZwqbJFslsHvexfPlP5kmbOdc1lMdS6GbrSOczXQ916tOqV7d2/Rp2bNmwS7vG2fp27XesZ+uu/QU4GDLDiQsPTnz4cTDLmTdvflwO8OTE5VSf84iUMant6HVv1+3arESM7tgxDwj9eUCHJK0/9D49fDiHkCEDhSjOnvfsBX5DRyyh0NpwiMAcIrqhC4fMa4+jjT4KyRaRUppwpZgs7AnDm36qKbcNk1JqqKVAHLGpdMABp58Up9KHnaquGiuYGFVRxau5/BALRz6oeEL/rix2qEEHLIDkSy4zntgLScDw+qsvwQhL7DAOOFiMisi2GOOPMbbQjMsuueRss0YU4WNMQywpxjfeWuMnzd7scRPOONVsc7c656QTNizIcG5PPvuM4s/gnPPzueigqw5R67AjpZtyuPOuHPCIeYRS9MpQD71K1ovvvIp0sQ8/i+BjhRmZAmRkQC8IPBCGVpM44wz9EHGwQY4iLKlCCi+MKUMOPfQVWA9JDPFDYuW559gTUVQxUha7qUrGscqqa0czwsrRD2qtDUMtHne8Cwkjj0Ri3CHMVfLHJoFc17C2OlBMBSoou3JLLMfA0ssvJ9nFEVo6K/OzM/Gkjc19TjNY/87XEE7YtoEbvjNNNiHOZ7npAi1uz0Cbg2JQjpX7+FDqEsXjulF8afTR7iK9pT5L8LgUU0738xTUPfKbVZJckAEwNFYWmiiJoGO4QYRWXVU11lprlVDXXDHctVcNN8wp2KSkLtZYrEuMB5+un2J2RWfZifaUQeoyowpzbbwx27PRpuMsNuQWV15uvT0Xb3SdbPewveOV7Ep7s9RMj8LLIkSzQDa7JZBbUJmkDzHzOOszV0rzTWLXMucn84SRZdjh0O2cuE03L9YT5CuCQ0I5j113PfXULUYUDUUTgSQUY45phztxVD7GcUNI5jS+NvagWRJZEVleoJZ7HtAJA3mIKP+FomGI3qE4AGkQlFtNalonqnmVafyoNfQm/F+vrtolEddXKlmvT4yqxfqdjYadY6I1G+0j9arybdaiG7meQBe4BXCAeUuSXvJyAiDxTQc2AKCV6oWvwXHBcH84nAYJ0bjNEGJGk5CcIihlCVckYxt4KtjmDsY5g7FwYb2J4Qo1BzqG0bBzpINOxYyjuh5qrGM+hN0QYyed2VWndiQrGaMc1R0nQuUWprCUpYxnvDQAQhezSJ55OIKRU7VCIWfoQvR4kISIeKB6rupCRbanke+90WktSV9PZOKSOrJPfXh8n9bcBxSjxO8pXbMfi8JWv/2d7QkjwJu3qvUtHbSlR2r/QKC4dsDAIVgSk5bkGyQBB7h7ffJef8Ag4grHQc1wRnGOCxPAKofCbUhsczlElgtpWctZvnCGB6vhmkwjS9H90oa88SGgnoOFYRYziFeQwjI59rogym52IptDGO4whyWijB6+o4c+bqEQ81TRZl2gz0EWlBGNYASdbxCaGVewgqJpwHpB84L2zLkMlICPJXO04z7Np0fx9XOPfPTjLeXnNX8EUipUoZ8hQ8i/tJlLL2pjJCX5QqS33e1cmWTgA/cWpR0E7l5X6kPgCodBU+qBlCldnOImcYvMfMYPn5HpzvxTsHXQsIU0PCjndtpTW76phbPBpS+DGbpeMkxQqsuY/zGL2DpnNvOZQiRUoJA4nDvIwZpZzaohLhGMcmTTd+UYxTermIYrZpERiECnJ9JqEUlgRJ3rNOM74ZmCFcjzIqzQWa6gxpK+Ru2v/gSoNtTHR4J6rUWI7VqK7BdIcGhFRmUZBB14pEC8TLSAdytg/ypr2SRxlDDt2kEV+mA4MYCyD2IwaUkLl9LCsRRxkFOcZijnhjyIyRXOcIZTboo5W/LUp8H9rZtwqhuiusmoBAtdD5kqRCAiU6pQlS4RqdtUaWJVq1e97TX0AVZ63AINMLNizsj51vuIMT/lgZU82dkqDWAAA0ULmls98Slu2Pee+HwaQM3XIcHqkUR/BGT9nv/CDoQWVH7XeBZXyDKIyWI0oxKt24Qp3NnP4uWBQYDgYUZrGUeQEpRiMBwhMBgIxBGigx38Umw1oRk2fOalXIXFCWl5DxzeGLg+TZFwfwrUzwnVx3A6bul2WZvOsbCI0D1mUoU43eU4ubpLhg5yalflqtbuEddohzh81w2XXQpW5M0EzsQ4xvy8oczybFUK3gtfDNh1vlzMSC9aQedSRKgjHRkJrvTLK/6OiFgBFeiHBIxgQx9aWQuORiz8VbYHY9RJEkYghT2LyXR1lARPqMKWHDw4LQnOpCc2sYlR/NrZ/oHFXdJEizXhChPewinFxXGO/bFjW/P4x0Euso9hCGT/zwVVhqdJcnSJXWwoH9vYUz1iNK1KinZgI6xjTZUJpWges1LkzNcmAhPWzGY3w9euFIHVG2iV54+c+0Gv8B6fmxZHavgK0MMKtKA1tDVAFhjBJ8q3sh7bqHIsOhaSdWjaNDvRAGoagBa+ZEUXvkAmyau0maEXSE37h0CgVHEdHHVsvWQIVbN6FK7IbTr4oe8aH9bGtL61rXfs02PlWkRG1nUugR3k3vZ2yLdMmLGXquRkI5uZQJcqNJl95Ts0ohvcwUY5HjGgOJgQVWVeY34Y4oRtEyEFWW8zm7O+7TjjTCN6xrPYIcTuN5o9v9/bc7urcRLyvdsacb+jf6oxDXLU/72OJaK7f17ONUR3jd+BT3Q0eNeOWATcwQJ3WwCrwPgtVAGAFLW0ZzvrLTZgRuJy8wO+UNra1l4ccafO1xY8/geQh6lyrxzuyQ0W656yfCq1vnXXYL6U2s9c57c/KixJ0+uZ717WPi62z38e9OkaH/nJd7J1jSgdJOYBFY/qxsuw6AlEpMHqZo6Dtq/efas3RFSAuENG6nsS/Ooq7dJQf/rRf087e2Q/6L5zSXqhjPrrtc57tWd9qMF/vBN27vguWfyOawrQAA9Q8E4Em+ihFmoB8TKIf8QAbRqPAimQWirQkdTmLvJGwhrp8rpkbkQqM0rptTovcT6s49zA9D5uEv9c4RIMgcZKbvVy76ZqSfZsLfZmj/ZeLuZ+T+bsIfho0IVUSPeKEKhQpzmIKQqKjwmVT5mcUOiYb8rI4A58QR+woR2IIa8AQYy+L9vMCg6oTlY2Iv8+pT7s6//gjq/WkA3ZDv3uryMqoQ7CkA4PYQ73I/7wkEG6KOyaRw39D+8E8AB5kBAJMfCkwlGw4RfawQFBTAwkQwIxUBIfagiqZEf+AuEIjkcIjgIlSYDYJkzOJm48DEw4KPQ4Tg9ELzMsKF8u4QVjEBxmkJZ6L9b0beVURAd3sAcLQjVuT9Zi6bc4pzR8L+WOCvhuKQmXsAmXEQqO4PiaSQmeMRqhUMqI7gv/5CAU2IEe2MEUEuJ4pg5nxowM8Q8YALFU2s4c07D9+owN7egP32397C8O7XAO6dAe4QAMwVB58tAj9qwc/xEQ9y5ZBJIgTSQBk44RsYEefuHw9OARTysSN20SKVAFLEkFJCjyLmqSNI9yGoESPpISsmVyyMQjS9EkJQtMWixfuERMGsH0XIGrYA3XgpHkXK+nchAXb9DlCrFERATmhgrlgpH1eJEojRDllLH4mMzYphEamZIap+Apo2yqfugNEkE7wiOt0MOLZiwd1fEdvRIe17ENx1IN++oPc+H9zG1m8nGMtO8e86MO4u8TKqET3Igc0dD/ApIgA28rEnIhFTES/xwScKogIiEPI5/gMIfgL2wAbU7LweYmgOCmECSTckgyJF0RpjryI1MyTFTycUpxJbnK9MgkW0roFgxqJmlyhWRvp3BS9qSiH3RR94iSFg9LBmWR1mbRuHhNCGmI+JSymKBS6JySOKWxOH9OCsGgCrHSFE6o7YghENdHG5qBOp9h/b6SLN3ODf0KLAOrO/fv/uxsecbTZraPLduSCdoyH+FyH+dyDyWBDG0l/5pT5GiKFFSBFnahAWWBF8RBEbEhFgLTIQvTMKkAIyGvAkmx0wbhMaylLkSyMkkzWzwSM0myTHBnFFrNI1eNQ02vQ7lENF3yD9rGDUrTNFEzNYcy5f946hZvcSeL8nJ+kKBSNDd7zPVsrCZ/DCgNprme7LmAc2Oa8jiHlEiLlOeKqDpwhz6JAYXOUe7csSwBsP/CEjuvUzuzsx1rQg2fRkrT8DvtCS1Folbe4x7Xcz3rkT3xUE3LUz3MixGwQxX0sxZkgT+5zD9/AU8DEyIfcSMlQ0EF7jEbFG5INELHZEJxB2ASlatactVcUBOIYdUugSX/QFAhkyPJhFKSIRxaTriEK0dzVOV0MjZR9EVhlDdrlEZRdQiL8nNw8zeBNDij0khn9QmXwFaHj3WqcTkugj5p6kkBcCe4U1itlFix1Fir1Eu7VFmXNRuQ1TqBwc7ULRWmlVr/cwY+rzU0lIZByLM8zxP8LkE/BUFcF4ETOGFOxcEcuOw/GVJPzUDEFtTBCEGyHrFSKbMPBpUyL5SEEHVf9dUFldQVL+FfMzRgW5I0J8e23GBuHvQs1OB2ooKxODVFd3NFRVW4ctGmSINVDUoGO9VjLbaneAs3cQlWfS5Ih5NWU/ZWhbNWVxY5x49STIFJfzVYh5UmovRYr5NZyXJnadZZm7Vnf/ZZi+Eci7ZU0hE8w1QUurUiskcVymFO6XQRBIETIqFca8FcY2FOI4FrA5QQRCwSUkxAO81SBehaDrYQPON2+nVM1nZfYxZgKbRgCdZg+TVuEjYEG5YKsww2YVMH/13uREx1RllzVEmVNXfqczaWY1n0b8NhNRk3NQV3R/EBOXWVGVUWc4mzZIlNOdFpIOhOS9Hnn0LXZnm2dE33jkg3aFdXaLETOuXuHF/3V9+RztxDK/NgF/6SF/oTT3+hFrgWeINXeLl2EMJ2EEipQefGwQrBbCaTUNMWeqHXbRW1X+eWYENhbqu3MvFWYR00DJagDAzhNHEQYh03cn3RcA8N1yS3YGLRYlvOfM339TC2JnEuKFNuGTe3ZTOXfzO3Zcct/EjFZ6eGdVv3dC0EWVU3gQsYZ6mUWeVOIJOVdjeBgkPD47rDTv/BTrlsd+20d4eXa7+WXpugCmxAgjgNXv/NhmGjV3vX9nbgNmZdUIYddWD/tYVlqns5krJ8IAfw4Bb8FmTPN3Fv9NCGuPX2wVMJseRsknBjTwbDAYrnN4hHlqAq93L3t3+zmEijyjwYYa8G+IDNMkuLlYHL2IyrE2jTWErVeHZ/tY1hd0rtg/wSQhOCgU5lYYPNIV3RVY/1mIOr1gGD97RM2AYU8y9IK4XrghKgFxIm80Knl19hOG5dsYYpGXsveTJfOA+sSYAgMwpK4AbKgBiepTXTd3FPbmMH0ORiMXB1y5VJLolr8TZvECfbQcfct9Y21UVLznFz7yjzF0hZVki1mJid0ZiX6cmCjjm46HOlc3SfWYHDWJr/F/iMp9M62Xiav/KN29hoYSH/YnIX7rgWBCFq/bg/PVgRq9ZquRYit8AGQkAvFtMMHGwsHM0PsNdEG1mfx6ORXZhS/HlRLVlurzduTcFurYlyXgwtgKBosOARSBliXzNV0VdHObYg6M6Vt0Em5Vc2mVj2woZFYpOjS1mK13dyKfeKU7qYtbjYzmCZvGBXmRl0wVh0oTmasXmMG5iaqxmn1din12+bafos9coSTCY/w1kQ1iAQAoFqy/UXyhWqyzUSuOAHqvoHxEAGZEAMbKAiVaBB31Us6pkUHHmfAfp2GPmfJbmRQ45fL1nk3DoUCgGGtQoydSQGPEAEkmAONLV+/zCWio1YlpF4B3WrSV+Z1gR3pMEmB2/ZlFMVl/1BpbFYsleapZHTpWOavFJIqG36pnN2p3l6jXtatEdbgnt2Z+ojGX44XMV1DVp7DcQ1qSPBtbWAtqs6q3/gtrV6q21ABDtNrCeTFAQ6kw26rIt7rtsakwkarvuZUkBjk/PADDwxCj7gvVCgDEYhHgxMfU3upG20KLlmiGe6OmG5cAX7t1pTselhij92ojkHZSObsuMbypjDeKpvs/+rsx34s/cbtH+ajPl7We3zFnJ3Ie+YXKdWEGR7ttfAqqt6BmQAt636Sggz8RxhRoLhFIJ7rAsBezk8ridzFj6cudlKro8bUf+JG8VDgbgbwYaPOxE4WWHP4gUuIALgSQmwW7sZ2+W6WzftzSBZNbV1i2jJm0ZpWbFz8mJ3CpdrFCi75r3hW75XOpmfDIBleqadGb9vNpsBnLP7m7S5PCxT23H6wYkKnD93VxF5oVwT3LW5gKp/4M3h3M2PFyUvPIQyHEODG8RBXDw6PK5VvJEN+oVfGMUfAdAL+q3fNq1fHMY9MQMiAAIiQARu/BvAQ/AWNxYB28eJUgC/e6gKwhnqE4XY27yNHKRd82OJcqQnF7JlFcqjvLL3l8phxYtnNpoLC8vzG8y9/Mt7nadT2xd+WBac6Jz32Bz689h792rFNRJim9kjgdH/5NXC7Vys4/oUCmGsSSHEt33bA924JdkTPBxuIzmgK4fRzx3G0eLRIz0FpkB8r4HfbiG1C0JT+Y3TrSG38v0cO93TB5fedYsrYZnUm/jU/7Zw3Tdwf3yoSNXVXx3W5XtQxk9nxBvXK17XUXfXeb2Ar9lokVXMUSGc7xiPxWF39ZgX0tXkd7d3lf0XoP3wOmjaqb2eCZbbPeFFgr3mBV3nE8EU/Dm5wZ25g/7cGd0To5vGI10DjOA6TohJTxu1g/wbgtyVz3DGqn7G+J0A1feiAd6bYSGFSp3UC16hDvf1hpBldMvfDWqy1/7hadUhjKDtpeCy3wAPGGEW7I6mLR6w/y7es7tc4/8b8Evbmh2HcZh6DQ5c5XlX5Uk+8UtezcPWeCGQ2jXcrYM7xK8idzAf0Pl50XvexT/f3Elo6Kup0dcC0k8fBpSg7qmt68mx9V0f/2Lf6vku69UXH7YeHe9vNMA+fcV+5XCtlTP6HIjYaxo+7o307ZM/7jFbZq+cs+ltv3y9Z23CO/m+74uV4z2eGT5+F1jbtTEBE2C7qaeW/DmhqWG7tVerwmOe8uE627V9FnC+2wmd/jvfgne+8ymlbUscoQGi0J05BOlEyQAhYYQIGlCcaQPRjsQ9EykCmghIkkaNllqx+vjRFTBn3+TFw4ePHUp8/VSuXGkSnTVnwP9gecQ1bNu9fS9f+vvZL6g/fUSDFgWKFCi/pfvSrdvmjOYza+d2MmUK5YrWI1m3KvkKlusSsWO9TgmLNq3atWyNtH0rpSvaM3HBvLnLSBezb+T6jvurDnDgwe7eFfZ7OLFgb9qyOW7MODI1bpAnS16MObPmy9IeV+7sGbRox89KQzsNGtlk1Kmd3QpXjp6sRbQXrRG0RouQ3bx76979+8cPLmLEDOrz57iq5adIOb8UKjqpUIWmh3rua5Z1U4+4d/+eyNKj8ODLmy9fKH1BggPV0DHzQoLChQxR3LjvJL9+Jl3SdOHfnxcWaXQTSAaqdlKCK7nU007yfNOMTZtM2Av/MiXx5FNSQiG1YVIewiSTVMpMZQ+GP/FjVoplrcgiXCq6CJcVbsU1I4023ijXWjLaxeMdeU3DF2KaEUakkJt9dlmRSR7JJJKhPTmaaVJOyVqVUToDTjv0bMmLLLNhAiZuuo1J5m4/CCFcmsQdp0cfjjSnynPRzUkddrNo55x2d1LnHXnn/TleHuQxYkhBiRB06ECKvvdECRQsMF99+N2XQqUp3GBppvxRxAggHdlkoCQh6QWkgicx2OA5xQCTyiaVZLIJK9Sgkw44GXooVK4f3toUPCEyU9NUVVmF4oswknXWscrCVWOyOBqbo408vnGHrEEaqaRhim1LWWDdLtlk/7iAVeYtZ1BeiW6U6n5LWbtRhbOlOPLyYo459PICJieLCCIIJ2LmBrBuwmnBRZtwHtwcdJAsTOd11+V553YL94lHoIQK6qd4GmNcqHjrhceeogMZ9EEEkCrUUBJWPPSQfy7vp59/cQy4kag1w0qgatMkaCqIO82EjIQ4V5jMhUuFg6uuu57INE8/A72MlL7yhBYSclmNbIvQLgvjjjs2+6yzMUZrlx3VAolt2txmCy675IoL97lOprtuZ1a63W7Ru7TjJS+8iGPOP4HXa++88trrd+L4+huJILQ8HgzCvqTHMJ+F6Fkdnr5svmefGY8HcsZuWOKGoJZUjOjH64kcRv8Y8ZmsEKQoYOEpI7bfjAjuuWdEUe++/z5zHLZ7QipfpfJ8klO/frRRKrIWzU+tSP+E6tK8Ou308sFG5dTW3mfN9dfhgz0+2TyWXe21amvLdtztux833nPTbffd7aJWzTTG3BJIv4t4iQl6Be4fBCQg4Q4IOHsh7hexaKAqjnGMYEQOTpRTROUatqcMzulPtkPdoA4lKA+aDg+lE1nI7tC6MCDhdQk5WUJSYIWKfcpANAwVKDRyiBzuAQ48TEPwZBYHH87sE6Ag3iyAhEQkxiQmQGOFq4bWDNdI71bVa1qDsMdEqNUEFsWI4vfA90WtlW8uPpBRjcRHvrCx5Xxm+5H/+oa0vvfBb47zs8z96Fc3KtWvSjvrxi765b/aBPCAgiukIQWHr3p1qYENhNwEE2bBSM6Ccg4bhZwaxkGQ4aFinCRdJ/GABkDkAXXuSR17VOiDDFSAArBrJUNyYAhIjGqWuahhqGCFiENcRIc/7A8R8uPD3BWxiKYoXqmCFCRgSSKHGuFiFEuCPAWxox/XuyJKHPSrYfTCeVwkW7TAOMZw1qiMaVQj19BnijfGcW10bKe45IfHPNovf9XIGzu2VJtA5iuAiQOT4hT3C31xIhKRYGQsaMEcCV6OcoHyhCcoSUkMRuc8m+xgRTl50Yu44aIoNKGivrACD8TuZAw4GQVg/+mKUQRNJEFrabBeWiCPgOImHREFgRBxFx/+B0DBE2YR9aIzkhgPaK5ipqg+QgzjRbNnMCEWFq/5NGlos1WtCiM4xWjVMZKznOKsSxnk8CPlnWOs7Fwn3OToTrnFc612pKdlrqEl2XQJgPvM178AtoZ9rYGgayBEcQhaUEfCaXMQTY8nJIrYiVksUYniKEbRYIlQbnSTHu3oF1I50pJC6mQaQKkrRBS10I4Ipls0EDeJ+FO96MKhN5zZywIkRIocdSRRFCpNOqVDYXIxqdCMxzXi0VueLdGpT72HrxqzKqqa86pZ7SqztspV8BXBm9KSiCV4K5N5mBWtcOxuWs2l1v+1ivZKQJ3MNfQhr/TSA3CL2yfAeAOwNBWnOMcpqAMRCqdZHJZydADhQydKp8MW0xTR8ZwmHXvRUVb0dJKlg8g+GtJIaZakr8yDK4jBUtGOVsPb7HAtPbzMIepWNardZhFxGsSXxfZVFAqqKW7Xu9nqTKnIpDGthps8bPpKu1KpKnWdi1XnQtctZozusdgY1h1vd8lMbrKSwlvHtgJrNaElcWvwRw1iwBUb6T2gIuuKV7wKZ77zPU4jIUfBhTKUv/+9YIEJbB4Ey3l0aKjzRVuHwjCg8AtIGAEGMnuACZc0AiawRIZdOpINj7ZCpC3tJw4BB192YWY+VW3QmBfiFLv/TGac0gtIGKHDh1SapbxVoqlrjOMlkjW530PjOZkLa7XkYNZuyYGOXG3ksIHhCz7yxM4eFMdmcDdbTm4nW4FFDKkg2plTbjaVmVHbcOxiF7LocgLrJQ7F2RU3/FoDF76tBzEQYhD2FSycLsHf1KW7zQaO82PnTNnKvieFalACZmG32UDrW98eoIEcuhPFlyqaw9pktMCZt8Od8nQPsPKIpT19w1yqeMU2k7imB+RwZCQ7qMnQOI1n4pcbi/VXpWnuq00uXfLRmtb2fi5YLvvN6XqVWsRT4vqE3b5tEJusxY7fsVWDYZGIZIYZd3azu1iM1+wiEIH4X+KyfbgECrC9/4wD7LgHMe4zP7I5fljYe9jj30I89HOZxCgJTRkytKed3i8oGb7zrYC4EyDuEOi3HD4SIaRzeO8Gf2mJW2FTivSwP3WQbcYPHbSIV0Lwmw4e4xtv+FE93NJGN6/Is6vzyfwYyLGOecpnxPJm2XpsuZ75F2ynF3UOe+c9NzaUSxOVjgtdY+KRqcGtbPRbTPuP3Bak36499brihjj0te9yInhur/Ohv2kfSNg/tzFBKVjBco736k45hxTqwO1w37cA5B73k4KV2Xs/evnHi2jAl2L9mWBxwxnBTcnjPmo2zTTLXgugAEXelrQkP7SpwnNkhXKcJ2RgYWtDVnpyIXPRgv8XvgZc9dR6Ebh64RJPGjd7tDchtTcq8/d/2zBttfAvWgAw/tM3fhNAYvJtXDADMmADLWgcweBAB0MJXbd8X6cGcrAoiBI64cEIBEF7g2J9zYeDIaNnOOgecnCDqOQog9Z931cAThh+MYAGxZR3eqRHA4d+HNhopmVTMlV/HhE1+dNsL4ZDjydp+TczGcER8HdUMfVSHQiA2TWABNhcoZeAy7WAechn0+UFZXNYvyaBRRKAmBeA3wVPdEMTrvBi4nERapgRGoh4JOYK4NAPfENXghAIYRZmXEAwafIDMiADP1AFVfBXjBQ5x5Bm6qEGq4iED6YojbVg4tExm5QHkkX/WdLXivSmi2QQBVhTAiXThN43d05Ydzlwd6uSYVdoJVg4Jc+Wfh8GYuoncSvWCjP2DcSwcavlEbi0B2fwMvwhajFWMwXid3AocmCAh1zTeV1lh6AHFriWjs+ygHdRc0O1LaxXiPl4j4E4Lq83JUL3HQrWKXiwhvKHdEIXDlrye/1EGwGjGykoHDMgkaAoA2tiX7EQDaeAislXg9lXZylUWUFIi6AUQhuFBrVIQh+pkru4hy0wAiOgSm/XfXEXAN8HhcWoBv6njMuod1Y4Zcy4aDWUCovnH2i4B/BnadiYbNOgbE40jfwBTIRnVBSCd29ojugQj3SojuNUa+54h2+h/4cM+Aa2g138GHLatY8RGGWw9xkBFyFDR3uU9YjD03+fJUWW6CUAlJezcVcp6JeciImc8AuDGYMbmYr9tZJkgIRFWIRGSItuoAaRNVmUBZl1Vpm82IuZaTUv8IsaIJPBCH4AAH781gOQ1ZM7uUeouZMHB1MF0n4Jp3ArhpRABzTZqAvb+AYqJo7k+GFWuRdjxSPweHLrSJxdaZwu95Vq9AV+6ICEaJb6WFY+d2xCp4jjEUuns0mAIAcXUVEDRp00cQu6N238oldiwi/+8y+ZiFe00SWEaVCG6Rw0iJgpxIv0WZ929pHsMTqUdZIqWQZYAKB7CAQ1YAKcaQIweQF/Bv8pNWkAA3CToQmFN9lZZPAppyllz5aaqkklQdmbMSWNr8lDP7Sb8reUwOKUsElxDeeGtYR0MwERwrmVc4icCZicYSlzMNeHuYMgzimIPaqPSgadhuiPyFid1nlCjdhGF+OdsHBht+AITKeeDjkm6+mQudEv7VkLpohfMshfN6iZX/AEX3CfYzqEoGSZ2vmRWJAFWQCgQVADBOqSv/gBIjCnF9BCC9Cgeeqgwgih+1aMZWBobjlP4nWhq8maHeqh9ZcJjrg7uEQgMyUrkniigxdMUxl/NNQLiWAHKyM2nTqcWFOcYGlvPjCgpUqqCJhreaiq5kOPFqJ6+BiksRqd0rn/mq5gCEUal/FmXUq6pMhwC+UwnkxXpWUigg/JiVYqJgRFCJFACI2EMGvmpW26nFZTn2BKpomZpmzapicwa3LKSt/6rXeqp6OJAAlArhEKKR+QA4Cqkz4pTxWoob0pcFX2jF7Yfu73qEwKcYCHopwmW81DVangCnJAF576qTI6o16Jqp9no8oZF3eBCKnHo7C6TkHaVrRagXB5Hh00ixrjnVR4C3HlJedJsno1gvzSP90GMIRAfGaGMJCkipkZFtOqFb1Ys4qZrdoqrdt6AijgdvRBH8E4rvtmrsN4rt93ASXAroIqNe56bBkar8yohVMGEh22Cl1IVVV5afyKolIp/1vu13GAwDIGG6OhyrAtp7BGsLDltKpZ0bB6uJxvoKOv6qMUK6uuV4H66jkb8ycfW52jELJbIht6iS+Kk20LlG28gLLM2rJsMggHw1/pUWcAOqBfoQNWg7lmsaYruaaa6aZuWgI+G7QMsBBCO7R8erSkiQWByrSF6rpPe0eVB21h6JNTe6jRyJtUW4YTx0O9kz+6sKlkK4+Vy5XrCKqb17bEi7Zqq3LJu6rJe7xxO5a+hjZpKatoebdCGl6moU21p1hFqljl4R1wpgmOkJf/JECJe22EAzjZZnWDEG6Oexx+MIPyaQaV2Yufe7kDur/9GwVrSgUAvANZsAMFXMAkwP+tGzC6guZ9pkuuqZtvsxMrrQu7Ffy6GJqFPVlwVnu1OGELjFa1tpR+IdZ4MpM/32AKm1qwB8uwmevCx3u2y5u2p4ojaQtzmStz0wVz82gXSXaWOvejQZy92ptH2qSvAWmrskSd4MEnDKMI5Xu+iXNADKlPtcBAyupXxtEm8tt19Kse96utJ3ACn8u/S7ADb+q/AtyLKnDABNoBHGACE8CEDDzHEIy6EBwBEtyuFszHUsaT6NehHUxE6yfIHiavoOLB+tqau7RpbsUK3QijoipGZPHCMAzDznucslbDmJzDlwy3rXrC18uj9TDEE7iWRSwhHku+KQUJ4JvE3sEwqKD/CnIFdX6jSAE1fH+pB+E2X1sgBlvgy1rcxV/HBn7wHmBMudw6a2jMzGg8wM/MxmzsxibAAdW8AfJBxw58x0SLx3pMwadsheBMqMrIwZ/QCe53zoW8wet8WlhblRiGaRQRh8RgCW3AqVmpvJPcyZUMTjusyTJsw8jSyWaLjkiWTqMsxNhbyuyzNocoXqP1KX9bTNDByt9hq3+7MKgQG7T8N1O8CCy7ghI5BlsgA1tgAypAAiGQ0inNxk9QBfRrv8bMBmwwigQMuqFboC/AzMr8zAYcBCt9Am9szdXsAE9Yx9uM1Hacbx8QQ5E6u30M1X8MyOV8zq9i1encwQNnyAFL/0SLx3CiMBLZiHfzzAj2jM/5zBaWfDVZ48KcPMNv7dZk8bYPawc+/MMKnV2knNBO5tDbKyWg8h0WXWAUPWDmsTDBoCXpdS+Egy9r8AMuAAKRDQIsWNJVYANDMAQorQKXzcZVML/EfL9gvKY1wAGq9AESkAEoUALc2rMlAMdBsANNEAQgIMZBHdQbgNu5fc1Fm6flys1098BHTZMRyqDpKgWe0pP+GNVRq9VWm85VzUxWvQoeDJTCgAtcvQk7tHCwQirWyBezILYFXbZX9cL7rNYxzLwBLRZx/WM8XDa5gGqDSFZAitf1bcp9HRpSbWiCPTEV/cqP0MrWCR20ILi/N/8v9yIIaLKCoCgcxPfLNgDMVWDSNjCKZvDZMh3aAUzAcRyuEoDaQ43bY2zAKW3NFmDiJ27NEmDUe+rbwe3iLz7cwC0CSQAI1RgVyz3OUl3dhMx+0Z1Dz03d5Hzdgny1QUQElvJLcVA7gKFUKSwFK0yjaB1r/LxC553JcL3e7J3lN2yjZSMq8S3f873XQ4zfsQu13CtT48vKbxa+1ingtLALgyvF2hZfDd44i8us8uu4tPDZGR7AQcDhLT5oqO3aGbABIq4COSDUJu4AjW4B1dwBt13ULC7oMG7pDWyTEABDdpAKeiTOn/6uqnEa8rpoPP7c0C3d0y0MVbLqrD7kEyL/yIvHBCmAARhgKZM2iN9wDaYg3uM95ZWMuVYu5eo9vFvu1v5M13XtqpeX180u5vZdyqCOysgIC7LI36PQ34BiCLQgC4Obl3VlssDRL7JQC+UeC4D1vlkXC8fh539+AtisWS1OAR7+6B0A2yoAAot+4hNQ7yj9xhYw6ZS+zSZz6XjsATS+CS2q3BrqtGcODZC61SZ26qjeCVk9IqSh468uyK2VBjBw6z6E1781OU/ueQc47Gx93qAaBs1B5QJN7C/vti6vgAMNRnhhLc4O7Tkf7eDF8+/KoXAW4NheYLc6MXxrQUz37ftyV7mBJmdipVbsJVnaQASFdc36pOtuzDWt/+GkDe+o2+iHfsAdsO8oHukk4O+lbdRG+9sF/+KZnhCd1QYJX1s47vB1z6Ee9sHsR/E/ruo4YT+snlzUbd3XfWIjCqR8IfKMcNbEzs/Thblh0A7YcApIgNnCjuUwr+U53LboVJY4bw9jvvM9fy46fmn73R2KiEme4+aK8AfUxpcBYyYDMzDiLgjmPvVYTAhZ5wjsruFbH+gMrPYMsAFsTAKlDfAmDukqHdn+DvANEPxrj29sfwDouln2YQVyf+N0z9zLcJvKQNVUHd1Vfc4eLFVY5hitjvGDP/irsuodOnnadXm/1Q2+IAfCuxYnT8nRazVPEAsA8Q8bHSQFjxxEmP/QiMIiDRc+dMgQYkQoFL9QrJiRohUvYM7YYYTsGzp4JE2WnFfv3EqW6talbPky5jiXNG1608ZNZ06cPall2wlU2lCi0Iwqe5YUmStYppy6ghRK6iipTi85fZRVq6FJ9GQt0iLkx48ZYsee/SFE7Q8uXLSsIRRJbqRBcgkRouVI7yAzT/xSAfyExAYJERgcXmBAMQHGjBlsCKLixAYLFh5Y6NABRGbOmS0XAN1YtALSpU2fboD49AHWpAUECLAAQoQUKKxsKsZMd1KhPIMW9Q386NHewonmQq6sFyhboko5f778eadOhypRx24LlzCkxod/TyoMaO5mvH8uRb9sGUr/lPGuXevWbVSZKVLsQ1QCJP9+if0VIinCICQgweafaML4oqAh/NsoQPwebDDCBi+S8L4zwEAkpJFOsmcmlWDy8MOZbiLxt+BOHA8884BhipVHmHpqqqq2otEPWuhpJxAZZuCxrLXSUivIsLRoiwsx6KqrrkgIOWUQJ82owi8pn9hhssJUS2yA0RzgQAUVOqCsMsw0A2Ezzh5wIM3REGCztdXehFPLNxNjQAPbJCEPRe/25HPF8NTrRbrpoINOu0GxQ7SU7bojyqfiUvwzz6LUA49D9y71JZQ7wCjCo/sgBJVBAQV8woxYBDplwQUZjIjCCkMVNdaNMMSDlQ1DxFXE/xFrclTPRx9VUUVdhn3KkxhjpFGrOUiJhp5IZNjRRyGnnTastu5acq679BhEjC0WJGEIKUkwIQMKTFtMTjkl4OCEDiaQQAIxO3u3sjTVbDNfN+nkN85909V3MTutAMQZg301Ctg+FwZUUEIfXuWVVRC9LtFeKv1J4WA3rlQej0maZhZTGLnDDk4n/BRUHWR1aEBVBjmlwFjCEHdViQB09VWdU8aI5fvKkAMQXW7NFURdj+a1V+A0Jo5pStMjVuQYp4oKKxpJaWeXMVyQIa01vh6yWrXC+vpaLra1i1tvqyChbR2m5GCC1P59TTQJTrAy3njFtBfNex3QN2C6Bye8Nf+A1/2gBzySQWY3hp1+PDmIE/1kcsqjYzSomxJ+fE9K4/EYGVZEQeSNC8+wgmfVYf2Pv9Zjxib22PuyeWUBewYQ1tR3Xp3VlMEoAySRPo4J6XeKTrq8Eo2DFPKG1SPWxUSKDeVFq5OFJJh2UGnChRm4CCT8QAQBu/whzycyEvDvEmPbQbbYIkq3a27bXCwFMHxdDuJu4G///0+A4Ao3QALm7zB2WhzjVqQnjHWOG8rhjqEIRbHsHKpiiMpcxjToPM4xDHqg2EMc0tAFEnohCbtDYe9Yt0IAFaJA/0AVHWi3qtvhjCK8WyEO/SOFj9RqGkQzmvGQlzylMY9jTxtGcob/hRwXGcuJUqseJJI1vWhsD35j0IP4wlc+852vLekjRPvEYCQxrI1t5HJbCOoHr7n1S11/O8y94JUmy/itjQI0YAHzeDiARQCBriDGBh3oQGFI0IKIuGAiK7dIRdqiaYI00SC9o4wQwmGEJTShE064yRSqUD8+O0KCfBCGaLxQIOIQRzQGMSof5M6GN9RhLDUyS/xwila2OknxhLgrdfhmeZETlhIDxSLkgMKJT9SKKao2Mq34oh3RIMUfJjHNQBDiD3dxn1vu4hYijcVIZ4vEGMlYRvidEW8m2F/cMhCmChSmAncMXGPoyLc6Am5NeOSjuvSZT37KBgVlMEXjIDfQ/z1tx4LUQaR1FLrQRlJOPJEs4sI4CA0TpgF1XrBoRU24SVl+kmUFcaE4YDjSf4iDFmYYVQ1z5snd+aCjOsSQ8IA4xCDKhIiO6uBEnweMYRLTmMdE5oxoFAx2BKNJqrjFNKX5ByzqQQxOLVJbxsCFscyALUYKYxnJWYUq2CAE+1tnWMUq1nbGC575Ag0D5llPe+qxn1qqW1zfqi4GiKAMlhBoTo/INA0CamLYUWh1KsHQ6wQ2E4rEIEQjKslgYVSjF+UIRzupM49WVmUKOhVJRyqOWPiBSg7C3Updx0Ja5hBWtxxeLnmFvG2s9qZ8bV4weyq5n9aWEVPMyixG4Yv4GP8VFb+dRCOE6wfisoENVxzDGLbQI7JYVavjLGNXbTCEEGRAbmWF11jVGVazxtMxav1fW9361tjMFa7njYBd8XowvbbXiOfx66AIy9D5Xu6CD1UswjQ20cf2t6IOaelLLQsElzrkCS7ULEmxscrcvfSEBYalgEN1y5nusqY3/aXGuAMeCHZ4mK0AcYiNeVsSJ7OZRO2tb6PZCEPwIQ98MG6M3dAEGnNtBmO48VnKCF0x2MDHbWNjALM75HZad47d9e6axItP8+qzvHLd53n59YG75pVjQMEv8+ArselU7BB1sA6Yv1xfxE5HO/mF5GJ1ihRh+Ne/DwawhFmHhEGINMH/MMSGH1RaWjmbliGinCXwQPJD4ln4wq11rZojteHveDhQqVhUiFPBiBGTjNKJwLTViBoNfXQjGMHwBSlEzeIX50ENbFBDqgHjAhc0YQvRSu5YtKpVGdhABdQNQTtRg9138hrJTP7uWZssZYA9eQDGnmt627BePzXbvSZSziHrINg6iFnMhHWoxDK4PHcoLcNrfkab3bzRyJa7zwMusILqfGcYRoMOrXylLK2Qgwif+1OnswMuVXtoXn47coye7aMlDWJLiILSB0d4iUNhDHY0nB3HAPWoL6EIF5c61W7IQmBa3erkdhxaXZNBFcTwA1urMddw6l/KVd4AClxpTvec/1sAgT1smh+ONlNgtrNj+96hGAqwCr12tQuL7UVi7mmC9HfSwT1ucks2zn72c82ekNk7i4PB8OYzS6G+9VkB7w2S0Pe++d1vpS/6KBv+cKQhLeJNHFwOd7A0HkoMH4cXFdRUo7ip53DxjPc9Mqx2wRZw7K0dffwHPfaqGh8AJ10r4J2Oj3kcgY1WYY83fzXfV3pxDgsr77yBv1EPl6lNdMRme9tIL9E7NMdt/SLxT0zXqNM5wnV0R8SlNTMVu/8xMwXV0He0h7poPUUrYlTYJORwB3v6jehvPxTgZ0/72gc+uk0YnNJ4sAMi4L59TMen7nePYsXVoHdVRwELS0B/Df9qoAIbhBx+H/cxtLaQ+K+elTSP7zXkVy7zyVfe8pgvnBS4DeVpNjRDkUI6KPu6HG2LmDNjHtbDiW5TvdTLiV6qwM3hjZ3qjqYrt43KKNmDsBAEvoOAtwUxA1PSLHGgA7/wPZ2hN8pKtxHMiNP5CE8gBtAxvuRDh2oQO5awhjQbD0ZrtiQiQu2YPolphYIDO0m4Pu17u7dLhFFgB33otIYLBqoIP0zju8CIgk9SvxzAG/bjmi1gP2jxMRXYjK+yjDfBv/vbNf+jqyTjv/8DQJv7J86TKAM0KAUclAb0QyOMtAxqFAzrFQtcveZjFA87Ck7qrxPSpNgDQRlMiN5rpUH/QEGSigXaKYgVgMEX9EQ/E0GoSx2vgztC68Ec9MEfbD2OKcLokz4RswRKk4SgeTs7gEJjqEIrzJTwszg8QAOaMT8A+UIwBMMgCAISaD8f86oyMTk1bDwIMA1da8PHk7w5bBP08i5/ocN0QbYoYxNlcwWDeTYDPAo/PBQGxBxALKRAhKD8IsQITDQK7CvoE8Kk6MB7ZEQOfDpJJMESfIEhUAU7S0Heo6EWrLeJgJVQHEF8cwWiOcXlU0UGki1XNKhXZIWLxEhGAARLy763m4VuyMVdpIqK00JT+8VgXJkXUMkSMIGWPCcSKJNkZEY1AqsJMLLZQLlorEZrlMOe5EnL/7tGb+yjO+y8PHwUXPhDdVzHYVpKgGPHpXlHQ4THeEw04EC7esRHRnxEczM325PEVipBcYkEgdSsSKgZg9xHUOTHOBs+OWCEG0yHhyyaiDyRSAk3RSxCJLTIpsDIjOTI7EODRGC4KgQ/KcI0TCO/LEDJYWRJl3TJtolJNGxGzBgTHRgBI6NG/XPD/UuNJcMSn9RGm/tMwelGbEyBZStKnjtApFTKpqRHDiPC05NKqjyeqZRHRLzK8ODApttKR5S9JPjEEYQ3f0SCMKC6FBwEKjjL34szhXROhOQ6+/C6REitmZJL5KPL4ni+VszLvexLEctI7OtIOTAF7/M03aqeQv9Qz73bu1+kDwVhzMZ0zDRqRpqsDHVym3LBLs1suXMxDM4E0J8MTaDsl9LkRn9qAzw0yohSu7RLRNjES0o5xNqcQEepUNuUQKqsywdVhnzczUfsTY7qgeZUSOY8CFcyweNUMAazHbQk0dFKyBjlHeCBwve4FYe8zuzUzghNIu/sSyZyir7USECwRVvkrYYzBpFcT/b0RTI4P2NcCBpYSZUkRpc8Rvo0OXUasgwYAXKJm7K6v3Mhjf/kTDEN0P5zq9EMSqEUGKJkLwwkx56LTQ6tRx6t052gTQzV0wwlESJ6TaOQrEC1ghvQJHrTyoYYURG1t94TS3bLRPi8HVCBsBH/fc5Khc4GqxBSfIrqtJR9w87W0lEIZce140sQA9K+LBa3k7tQQLFuEMn0ZNKTPD9PnFIqrQHHrAH6bJt6sZctrS7MzL/IC1AxJdYz3ZfVEM09Is3FMFAEDUfHiVOcEtUzY7NE3M6N2VMK9QltzVM+lcrGElTf9M0QTVTgpFR6w4EYbB2JUFcBSVF2+wUWjVR2rbdztdR7RRlSNBnApLRwhMtk2JC4vNGRiEi6NDvuDLGA8ykXKRa/dMvd8r5ryBT1NMw5kDtZnVWXqtWNxZtc1dVcOzJfA9Y2NNZqLNaddA38YQ2VVdY8UtM1hbKhtINn1S9Fo8dRzc1rjdAJ5VYM/+1ZCqzKP6WocHXEQiVUorVXe3UQCmkwg+jH22ta/ShOUyHLkVow5Yxa36FVEVRahMRXOHOI4TsDEtqkNrBFhPPXgB1YDfrBDPwThZ3TJZLb6BHSEVu4fogPiaUKZdm7O3DP92RMjrXVL9QB+vxSvUkTXhtZyCPTzdRJmTNWfolZAlJTzEsvofGVmj2Oq1THzqVWOq1WvQKKnyXdPvXWoIW+4UBacdWkozXXeTPXrj1Ir8za4RSQE2Q3cUiVFq29F4WI4ORar/VK37UQr8skTdpKGsy+fuU8kSi+QIJeaHUchOVLYmreFilVv2TYWWA4XdxbvvXb98xYdBXcwS3c8//d1TDBFyHzNTAV1tRo3MeFX2F1I3RhWZet3PthVn6yE8xFPeRTrJtVu6R0TTtVxEG00Nks3dtExNdb3UEdVKONxHPlRKcNJdyx1NspFRUtqX/Yns+q3XoN3qTN4Kc9yOGzJQ+NLCfApD1Y3tpCjrxynN0QplN9iuwVUhchFmLg4VY1hu89zIt10vrY2vKdUtuZnzVa3zDtNTA92ZwsjSfev5bNJ22cOT6qkxvwXyAMYEerSAJuzdDdq19Z4Gxl4G9NXUQlWtd13XKNXdmd3RBeWgjrvSrgYFQaCN6VYxmN0hH24xhFYch6M7JlYY5wLBH6iAxhQlag2UCa2yX6TlT/3dRZgF4etuRkeA+JDTWruVj3rI/8KGIjVsnzJWUw+TU21D8KiF/IpV/5dVwCRY38JbZZZgAKyIGc0y8J3NwGBeMw1llRNcAy7tZfwspN4kRBPeYTSuY3TlcKLmETnl1SfgJLvLNYEEabgWZ6zeYQ/OOvzYgrEFt87K+MQp1LsiizNVsiZUKES8IcjkW8YgpnYJxkuOR6DrVrQLFQA+JEaNIh1ljBXQESWAFOHOiUlOaU1E8pVqs4WuWSTav3ZeVWpuVsHNMBbVZlYzbN3WUENMcGZMechdArI2MzVmAGhpQOG1pOWuZwJeiVJuHnlMHes0RUUjCCAKV+ZAhu1ulu/4ZpcA5ncb7Hi1Jecr4QF+5ISdhISzgWZCCGtKXnp4bq5zWGTIYPvU1PLZQDf9YBUbbMF5ifCtbjL7Qfw2grxGgrB1DoeHLohxYy07gnmAsgMoXGl5tl9BJAXF7Fpexojy5gAx5jhdlTki47DntgY15ml3ZmKaVjfEXUdj3Rt1mZQYiFKjIlgtxjx+bp51wVb5ZO+gDq3aTB0Dbboj7b27Iae47q1KbnJF3tTA4Gq1aW8PVnUR5lKg1oUkbiKrnVD4gAVZ5i1QDutY45tibuufHMOKRoWW6yurKCR3hTLoa+vW7Kj/ZrnRvH3jDdBDZpyAlUxFZpY47dgW7m8e7p3v+FUagdFb+QbJHKY6dtV6wbYWje6W3G184uA0H+bNFGZ5AwbWLYLR5mbWK4hQFX7QL3BUw+8Kl+7fc4cN2KbSelkBh4gYEegcakAXLZ2FZaASTYcFa61Q3gbYgO7pd16CUW8cULDbiGYouuYjeFbgHu6L7+5TG2bqi8QMEebKsE7wcWb2Ym78R+ZgKrPd9z1yEwg4BcsMuOiAVh7PneZo8iXuBx0iQIUR7qQI8IHrlT6qkgcNb28gAXcANPcABPcNZecCXF6tleyQo3AU6kATdH6Au/7RY1CMIljN52uRHXc8oT0ATwzOKWaBVX6z5/q/RKoOfe0C8G4zs9WBqvcRv/x3Gb3ZPvfl2CbogeLwJM//FNb/LG1mxGZVQ6OIVCiFqF3Gyclm8n32nbmVFPCWoeaoO7OrgXseQvt3WoHnNL/m/URvAyn2pNxsIHf1ICa4EKN3Zb3WoMR/YOR9EdWAIwRIELSOs9B81q5z8UX/HkzvZ+MnRACtUHqtaKxNlHt0tHv+5HscBhznGicGllPmaCTgJ4l/fxLnYeeGnaW+xJBHWnBTR6zex/z+wo72xYf8In2vVfT9Iu9/XWDvOFj2pSUHhbR3g0z4omBdw3P/ZRVnbFVuyUGhVjLAEQvxIzTfEqFnRrv3ZXRnkSp+s2RQPnlUgvpm5GD+m7JPcFDWw4/41Wdo/3eceBN0bUd//5dG1pFrD3ewflEjVvx65zD9faOA54bnZzVe86DHmETT5wBh9wrZd4hwfzS4Z4Xcf1rmdtvKv4rM5YClf7gu7qWk3JlnH6Eoh2s1rlNZnok4ditsb2Pud7s7bfy1sMxEABNIDeb9fAvrZuQXx0mo+tLNvunTcOxBZ6oe95oj96CTf6y898CRdyPg7Ft59jhsBmfYf6nAb4+a5vn76DQkCxaQC1iYd9r/9y1N4tUrhkhef6sr/qs0f7Tx7Repf7+Yxzwt0zKFU/uaeMU2bTujYgvHfrWA70lf97LDZ0xjH86va8xDf3PnH8dH9H1dSYoRd/H//HAZ/f/PPH/PRPf/7o9M7fY5YJQSbvfHUdXtS3/zj26S+4g1l4bYAINs0YwYK+rhlEiDChL2LJjDlMFlHixIcJrwVbKHFUqEceE80BiYZMGSxKcqB80WLFiBIqTbz0IfMFEB01jxRBonPnEpNAUKIImsMlhw0SGiRAQEDpgaYDDDwVIDWq06pLmVrNilQB1wJbk34FKxYrWQZmF5zNCnWt2Qs8HiX7Zk0bOWrj7NKVpmzvMGF+/T6DJngw4cKGDwMOfJgb47zZ9BZ+rO7d3cqWH0vDrHlzY87QkuAAHZqH6NI4VvBAzWJ06tUrXcdoHbvH7JkzjeC2nVsmzps5i/D/Dt57SG+cxIsXF478uHLgup/3hi7dOXAoV8B8wZ5oWrDuGg82ZCjeocHwFScWRJixIMdRHz3ikUPS5JTdMWHGbM7TR/b9KUugkAEKQWRRYBQnnMCBBAtuYNRWVEF4VYQSTmiVV12NFVZZWGmIoVpsQcAABTnA5Yxjl0HG1zKIKcZiYYmpKBiMew12omYxSuaNjjt2lplnPv6YImtDEikTCrW9liRsSDJJ3W5PTgecTU4iV6WVw93GHJXCPRdll/pVid0dhXS3XngYjWceeOX5coua5Fl0y3fsmfKeSCOVRJ8VtN2H4EskqOSboEfsFwRQIlzgwQdHlkAFG3ywQcUO/wgGMakJGRxFFoVTfdiphx1muGGon3bKlgZWwCVXXSje2KJhf83oIo6uzmrjjjQCyWpjiwHZq6+ZFSkbn0sCNduSxzbppW0pBbfCb0jwhuWz0loJppZbAuesdNo62eWUYfZ3hy/dqZleueey2SZBpMBJipvicfSeIZbENx99Jw2bn76DFkefTjUciqgGiUYg4glPUPHEpCQsrEOCCzpAVoWlauVhxKOKijHFEC6gwVvErBoyXq2+GmNiQcKKi8omy4jrjpOh6PLLQdJcM7DBqoSszq7dUKywyX6pbLdgJndtlc1hG7TQSz+b3ZindNeN1N2Qi6a6ZqZ57ijsvtv1uv8dvVdvntjVhy/Q+n6730lK4HvCUBIMPDAFBbclQQYbdNABpYCaUNQEFGw8MVqkXlj4xaBq7CFbi3McAQuMxGXribLGGhjJKa/MV+U1whyzzD3+anPoN+PM5M5E9mzs2Uozyxu30CYHJn/8Vktl7Ek/xy3rPyG905jBTC111MFLLV66Z3rtdXsdQeKRIXkAMvbYZee7b6C+qb1EDmv/FBQKcXugQcHjRzB3+XfvzbdRF3PM6cafPlA44YmnFXjjH88lsq670sprYasAEICY21yu9Ce6A47uV6YpnbFSl6/TIWt3TItS7X7TO9wNLYM+mJIEvRSuQlCtEPWSQyJGIbX/aBQPa6g41wqT9y6OuAKGYYueScrQhnuxzWzV25dNeNITgOXQbEH5wMCIKLcFze0CSGQQ3mBSFAfZj3EVm1/90jKWplwxims5lSlMZJnO8Qh0LZsVYgJoxs3VihyUAWMYUZbANiYwMAwskgMd6DMIro51uqNg7f5FtAreLmgr0IG2BokEQzrrkMqCltNOMYoviGYKNTTEKIBXDnasp4UEUQWb2uOL5XGkEY2Y1/PyMJIbli2VqrSPt3zoStxoD2CrGWIRCbZEu1Ugl7fM5d0Ap0X3VYWKwqTfL7cIBlMkIy/n2N/k+ufMlplRgCzjFV2W+UXL+E8wCLTZAkmDAxqg/w6PdjRdkvi0rHO2zjl7nGC0kgbI6Eiwh6ohJCJhpzTqfGFMhYAkC3p2AxgcCQ/GiMYlp2amFXLyk6C8RAxFOUpDuOIjasgTs6ygShwqzZVf0EkU/MOnAAVIA4j6wAYABFIB3U1ADerlEksVgAAMTopTHCYxFSfTtXCMi8nchuQkR7kXvSKoZyQgr9jITCB9bpsk+9lowImzOpJTdUoqZwerGrR39lGDu1Nks2xSyKrq5AuFgJoiyHCSfxLxBmgIySWi0Q59UO1qwVBovJqXB3mVcqI2NIlFUdJXf60SCNy7SQ9fGbuhmHSIIlDs3QBUAg605LGSXSlL//YgqLwUpv8LgClngTlTCdGUVDG9afs6dgVk2sqov5qmyVQWzcxxzkU9uqY2QucXpbpRMN1kalRNB1U8Xs+qwkXatNrJpeH6QDVFGOQgk9vcZjk1So0MxiXw4JOhLLYlV5ADJC4RjGMIT12ksKu88JAIQ8QHEDSkXkosKkl/wTeIg3WlH1unusR6z7ElEBBR+uvfkvYNQL287GZj2tnOfha0oR1tMaUCAQ2clhn5U62tgMpaYbz2ZHFM42wdkxmianObhdltOHkm1d8uKbJTRRJyJVgte1rpOPXtILd0N8+uHhdb/QFJFPiUQ9oslj8dfVowHEmK8SoiyXfNq9goat/t+Ut68cX/QkfhK6iZvEa/rtFyfrXsXyeC2U8wQdAIMAW4EGm2wAXO7E0XLNr6kba0aIFwF22kjmyAMcSY0dwAUxZADYsxRX2BbYcrLIw94za3c+ytVBm9YqoKd53RvWq3iPNHe1qVgxtkrjoJmdxPGwlMXwjDF0ItxJG2ADdkKIQitnbkUIZkDmsdCRnw5OQnR7kMBtI1leEL3ynJMiZe5vKw9Rtm/AAM2D1cdg1KYD4Gs7nNXfEUFaFdWgRzTATc3Slt4XgrPmfOz9J0VW0DDe4Vxdbch6amiPu36EY3GqqMerRqVmI9PQo3q8XFIFiVu+lNcxpaz9U0PsPanx9nd7G1HhNb/y/x6ksoAiR5mEO98JSF6ckXyv6aj619XWXe8S4G+Cn2yIv9EqLwMNk6GEJHd9Byjna02SO4wODSjO2qAMCz09a5nOPcc23PQlUUbiY0XRtuow+a3CNb+oqQnm6iZ6NyuJWVsEgsLBTzVmcqjmCL/e3i2d0ukGAFNZYLyVWWENKrfIwOEjjOVnIhOcndtWusZY0GQNC64+/ttZSjTOspszLZ/4kNTFyC7CcDTfDK5mgYHEUHMyQMYZIndbM9cGY135znmu855jm/uAgAfcJDx4uFkW76FnEG6k7nDMx8BeJ2L8bf7569OFMN6a53ENPLkYnRwu4tbQUXB/Q8pKfJvv/2sL4gyGrgQyNUEY1jlEkVcYe4kice67zrne/al7K9tK/D/4w5B2IO9uFBLvhL07fKYaBDIdgP+cgbSFI1aJAv0fJSNds/89Zu8MYcZwlXpNbQjZHpEZrSsR6KrJ4Apgi7iU42yRHtPVCJwRtsbN3tId6kBcpXuRimGU206B4God2XMBfxcZXxoVPTmBULBJn2LF+Z0AItGNncQYr1XR/2kUEU3CDH2cuuURnHYdzgHUlK+Ini5QcRAtGVGJYPhUvjzQEd+METPl6BqMFIdJTCJN/4GNjN3R/+6Z8UdWGn6BRPTZgXedsC9hm6PdMBehisoNvMqF6IAdqP8FmKyGH/1j0aBE7gLOFRsGFgH/ohjjHNYVlajhHisnia2uGb7bQdTsQGLH2BGdABKXxXkVEfH9DgFDahDebgJi5c3uXJJloZEIrcsaFEsg2h4P2QcaSfD71cK+LgKzKhE/rBH/jBFMJf4yUMPc0NV6RZFuKfL8ZZtH2hAUAADOABACrTXYghhTlgM76RjBTgUTng5WDOM0oDHjIV1u1MBd4hH97bH2ZaIYIdDcATcjEX2mmgpGHLfGCgdlEC9FGCXVniJWoiLC6cFNbaxVWZ9lXKf9yAsY1i+JWiERLWy20UzCEkKNpjDi4kLC4f8ymZGiQMJL7fEwDBCmTAB4RI/gEjg+3f/y/iVJz5n0N40TJKozPSoQHuDxs2Rut5DkqeoTU+BjZKoDhxY73J3jeCY4tJyyB+YEapY6hxWvB93XYd0mIpChElChJEYiVGnPVhog02ZD7yGkP6yx11mUu0juL148rVhPpNJalxYuNtYhhIJcwxpEMyHyWw5eNBIvwhQS4qJRZypP1tZDB95DCCCBaEQlwI3TKigwGZG2NEBlKpZDJ+28oUENPJCmRE3V+MG+qJjh0Clx7WHr1RVQju5GbyZNHwkThiICKWXSJWx6gdAaLMXFKOQE085DzSYz2OpT7y4Mf546Io1rwRnvhRSj+aBFguJFkCZ3AKp3AqJFjOJkSypf8ftB8dBCdP2ARK3WVMRadHUqfPQcAHkAFBfINfysVfWlP+MGZ4GiaHLd23JdVgXk7RnZHlKBVlduNlUqBl3qFq6ORmBmVGESKm4Rg67s4IrtN9Kkd2fJqK7cT6uSZURiX2TaVv9prMMdaDOlBXEkhv7qNxDmeCzhr2mSVwpmVYdigOymIf+AElRCFwTh7CPCf5bOR0VmcvfuScxcC2cWd30mhggmd5imcaLmaeMWAZqmeG9cJ5yiRN1qR7KgmxAWR+pCNnAugG8STYBeU5Dh91cKZ+UJ7AGdJXrh8k2p0tfiiDvqLLBcF19U1Gwg342KZW5hA/fuKubSiGdmmcytr/9WVil47ll1oo9jHfIMRjib6pLSqMV32A+agoXY7WRrooSIZIBKQAD0wBCQWddsZDjd7oUVWDXehoocFRHAbajWDYKlRCJ4gqALUhAqVbZZ4OQKEqTh7pTRJofabck0KXaBIf2pWgOTGpBI2gkB3kItZbD72liRonmO4AsJEZUoIPBSRKRgqFxjUkPo5EgtLptM5pncophr7pncZfPsrmn7LfKIjoDP5pwnCoc9lSobJodf7ig2FAu4pUEpSBerFCF5HkNFDqpeKrO+QrvjoTjnbbGzHTXojqIYRqKRispqZkjxopfC4sq3pZ8nHj4YHjIMqq+ZGd2gVcIiUii9ke/6x6YK86J0sM0p9WaCvGkm6K2X5lpPi0xflsgMqNqT1iohssH83OrBpYa87qLPs14c7WqRxgK3G6qbauXxMip2uOqxpAHuXtF8Ggq7pS54q6a7umAEAlgRe0gRzcgSd4wiwE3aXaKzxMqjyIrQEhw9n2yr4GIML6Kzd8aqgWLChAg77SrdomLBqWKr427GkUKQS1xMk5bM6oWGRFLFFWrOEKx68e0nPlZJVubNkxkoCyRBEUra22Hal9nLECTMk1rdNWUfmUAIG4wcSNrs2yFRRaYvUdqMRZ3+ou54G6X+zGbtBeKIcSbXCyH0RC4c02YbAK3MoSKt2gxV32Yi+GSP/cTO3AVG3VXi3WvsEbMAIocK0uUK8uhK298mvbqu2/0oznGGzcrsK6tWTdZi//4G1hEunVXWYFimz76hfhlhl/eezhzqp+EJ+T4l4G4qcHklpqriZzXiRNfKWxOlZJye8HIPCzfe7wZsAJYEET9MEkSDDqOhT1JacmVDBEwq5rcvAG9+zs2qmGQusIk2y2euuIItm1Ki37kWWzmRldrigEJOrwLmr5IK8GtKuiANQOE4EXOC8iPC8iiIL0ekL1EgMyHDHagky+Yq/+KGBPve2f4UJskS/58uv5ou/COhrfcnF8Ci78bh0YtwTwJkpLAN/8VqxooqN+so7jdvFz6cf/RinlB+yEV/LeS5ipstrNoCZwpnDFoabFUYBeDVCBH5zC872g9J3CIhuZBLNlPDplB5NuKXnwB9dsJoow9pEwCWcyzqKuGogSznoyifIuxBVIs71AzJnAzK3oB9AERg4vK9twC3jAg7nydYDGDmsscDhBf2QHGIzJmBCD1/blLDQE9iJzvnrnGpWnFetrLpRCL9jCNLdCNCqzM1MDSqYvw4qs4ELs+4IxGWPA8domOs0vxerq7ylSk+6QG/9eTmxUN6vEagrwTeQxgxzMCZCPHufSdFpRIDfKIBzDW5UD9DGyKiC0Ih8ZJKtuHkiyJLduRMdptNIuRXeynjZlIyun/536AXXFKR9Inymtle7GIxnQHAa0HeRBnkZeAKmZzwiowQqA3s/mMmq03xeohrjIR3awWnaMVz4p1Hm5AjGMbdiSbWDe69K5Q9nWLbgdbJCy5/ZKdWMKxqpy84qBMTiJcfzO8Um3cjmbs7d82hCg8X7qxBrnrx82KTz3qhPSwVG6sg5I5CrncaOwwQ5cnsHogN/ktRXtc0YOAR04Xzu0A/TBYEI38kJbcPU1tENDNOyqcEVbNJza4vKJEh9gIh9I8M2+Iynb4juqwsSt35HZIvNFgSv7wQtAAAXAdBiUjxkMwgis9gektgeM2gp4QBFQHN8iwSLjtEwI9lsDR3dZx/948cdPk424zIIuFDEyfENRP3dRby9TE0b1SvN154LlTPelNrU27y1m+q1LbDX89lJX2zCafbWKlXVap90us7M7++Hiws7lMh60pGaipHKgmtkLw3ADh9mgtlT57FIFNPATdHQ7EJRhI/YjL/T0NTYlPzaCRjZlTzbvAu3ceakUkvYKM7KdksIxnIJIowFbvul4MSUd1DJXfIEfzBwoI0HBjAAfnGYh+IBIrYBYOdcXUMIp/PYKhEEw7JNNF4KzGHdvq4KAUq4xhEIQ2wEyJfHZHnU10Ggy6w80WHdQAUN2ewLYUvlUY/GLbHNlrvLf0sB4o1RXe24MwxQ5k/l6uzn/dCUSHMtqaCYXlurn5eJ2AnuuWyybE/U13eASBbxsDZDZC99SA/Az3GQAU/YBLST4YSd2YkMcQzd2hEs470qr6Va2tWZ2CnNwC86pITtcgjJyI9BaKEcrKlyCGhwZTrQ4Jby6GsyNCMh4CciaDuMATrPEqvnBHYhscD+BkNMEiQrfIoeBI0rfGVjUGXiEKTCCHdgB5CSxMSczMsfDpE6DdUuvlqNtEztzd2OxLozYd4N3uY834aJ5mqv5/SnrooCTxCoN37x5cwncrerv46JTnAMib8TzfSMwf40ACTArobtcFDgIg2SAgT8BZcFEsdJfogc6BUwAgAvIEwh0LNRC/zQseINz/AU/uKVbsmiLcobW7KxVqyiHemiP8iO34GeTQiSSOgpPIRmMeoEoQkgjdBS2HYtj5+jGgMfIOHZeQhFkV/sy3FsLefuVefsR+RwQOSTMwdpQkiKQDc0f4x0seyg8O7RvrUMsN7VfezIzt+ZQ79x2OTzoazITxqXyCrkPC8OC81br+bkmkZpvVppdZwW+OTiF3B/WqiKJ5t7Hd5yzMa/+rhmvHHHE75jJdRUkiAnw0hBswaRgygIsyMHIX4LQ3wRMPC9tvsQHPGwP9PMteKSrumI3ttxV+gfToxvgwchrOuyLMkiTgiejgik1H86qPKuv+suXuAZPYVvavP8qNIIZ5HwUFsIgEBKpFciisAEQAH0i4EDRL1chkFqQrwALBzn7pRop+DoQKMLyNSIkMF+elFAZcMR7eb8VKLuyQ44ngMHzEjHX0n/9Byn1cnmXY3sTYypAQBOIbGBBHDwQ9ji4kGEMFg8dKoQ4keLDFRdblFjx4uIIjx8zhLzwYSSFkhQiQFC5UuWCBQFewoxQIYMJmzRw5tTpYydPnz9x6ujpYwWSokWLbASqcGhTp0eFHk2K5CeSKGS+WNXxkYQOEiNCht0gYYeZHV5JmAhbAWUDBgwEJDih42zXExvwipyQQYIEvSFHnIjCR9WudtFo0VK1mDEqx48pXWqkiHL/ZT6XMeeZo3nzHDWcNX8WLVqzm9CdPX8mRemzKj9Z0ERmowYVHzS0X0cOE2ZOI1KXNV2m7Tiyqkl8zCymY2Y5JVV0wtjG4kYjnyUaPMSgM4doRx+Fvnz/4jF6kUJhdGxv4YNUmBFHbPMhOpg2mRxKLuO/dKUIGF9zklDCiCICTGSUO7xI0Is3zngDlDsQAUVCTzzJRRdkpslQwwzlmcYdDzesRsQRCyoxoYYkWi/FFStqcaLAProoA7BA8oCkk1AyCSUIdmSJpQBgosmjFzhyisgjl0pyJ6mKMoopJZE0simphqKKJ6uwoguJrUZgi62Z9ppASBM4KIsKocRMQE0d/2nKqwO77gozTL7apFPMmqiY5JhyDjsGssYg802yySDBzJDMOkMUtEVJGw21zlwL45LnYHNMDdxay421zy4hZTNUJnNjkmCKc00zR57bjg9Kjnkt0teiaCQKEUjqYbLuPoDvovPI84OGJ+hAQj0g2hMBv8GQEIGMOcigBIsccvjtO0jA6M9TAvvDNpH/pFAwQTC+ZTBCCXWh0JMPp4lHXXniSTdEEuEdSBduUKxXxYhYvNdFjDqKkUYR2DpJ4Atm6tHHgxVImMcYo4TS4SS3+gmph5+UsmKcJuZJqaq2zOoiLJ8YAiyxQjJBhSe+yqArKtjwQwUx+/Jrhy22UGEsvP/sOouDvGD2MuafS6hB1D0RA7SxSVYbNDJCF81M0aebLm05z+ggzFVKh7v01d/U8IPrPFb7NFTHNCMlGEU+TbW5VucwLg/fvFZjiRZoXeIS6y5a1iPmet3ovOhYqIE1Y+W7Sln+5Mt1lPG+aI+FK64dEFsCDfxiQW8xVzCOzQ+ZkMJZNHTHE3XfjZcabpaZ98R9WW9d3/X8nTFGkQYm+AIFbE8Jd90DruBHHj34iGKHJxYqJ6O22nLj4S+2uGGiqvKhY489EraQYEcuuazX4gwpBDP8EIoDMU0+s4OeyafizLt4/tl9Nmt4wg9adtmlHMUWQxoy/ZcmlDLNDOU//0X/LWqzSdQp7uac+NCCNYQpm6kUmDbKuG04wDEVHRbjB8yYrRFsII5vnHO3LD0ObQjZTFaqZhTArUBV3OlBsYwgnyWooQUuzMMINPACagGhWWRYgRVCIQemTK5AobDcG7KiOQZ5qwsL2py4xuU5Cn2DdO8qSIVclC/XuUgjsOtX7Gh1o9rZbmAKSEnBekcwl7hkYcJ73huBErGNQeVjzXPeHY+EkTgqZXrJgsAHhhAyrZAgL3DSi1syMJsz1WBndmKAAyAZSTeRCS/oe9/PPlCTKPThGO3wpJ+QNir+Bap/lelUZEoZKgLmgQ+PaiVhKEGHTgHHT4qIoCjNdsHGkMqC/6wM4WUyWAgN/jKDvkEFA22JNqz0xj6yvF4hTqFCP3zsmetZHOEcwqwb9uCGGrCeZ4woAlsJcYgE+mHjCtGtIyJxiQ1yZ7ic6M43ICKKFSqdhjCEOntpcYst2giMwDgyMXogYLkzqO9uh7uTpFGNLLkAjOAIx4/pUUnLi+hFq5QUOiIFKlY6whCoV4EhvSCQW2LfJVMiAUoK5ixqSZOOGhCzOXHgpJa8pAQ00BcUBMEQkzjMLhLjCP19kBKhROVRizOKVK6SqUmDBAdzSRxWuuYRwPTUL1d1i8kcE4BkA9sFs1oo4ySzMKAi22QMhAYsKEJA92lEGUZABkhgpG0uhP8hH3YFnQ+YgA4r8EB0wviFO9BKEUIsAk+ux8dC3AFbSOzPGwi0RHG1E3OUbSLnMlEKzZqLQvGg0D5f18/X5TGg/yLoacc4EpWUZLWpFaOPRErRm0TUeELx6PLkiC/mUUyPTqLLUYDrk0DeYQhXCiREdSDIGpjAfZmcy12cuwOWmYG5fdGe+sYnJ5wRsmeQfB8KYoaCDrigEbugRzuAahyhIjWpuFyNUfsHQKgRkIPCVNpZp6pKpdpSq1VtBC+5ChytEoZUh+rU2cBmjMoEo8DvHRSCR6EEFEzYEHOIqyL+SYbnWJMM2PxAebJTiBd8IFgewIA3C+HXOUhYnCyM5kb/oLDYL1SrP5frFmTBAC4cwzNzCWriZRfUOVFI0ROrM3JoRcuRLy65RjayUUEPKjCFIhQDaaSJk7/0EuB9ALkXBe5El2RRPN7xt0qZKJegZ9w7oGc3PgFLmzb5BzYwNy8lMEEW+vCHLIzFLxvQgQZ10MgNzEVn7tvLFtiwg/PZ9KYSiEAGgsBJT7YDf0cl6ihJGV8NsvJQnO70oiDhts0EEICC4vR+x2pgUPVUwZ1e9ShI1V6rbrAbZo11LpXanikIaDMXPog4PcVhDwjLr8JK1ghEjGw/5nCuyPZhDyR3inR+AZqMtdzk2JljKTDosU6cLGXf8OM4eBuK5gLFkUGb/2Qz/7O0A0Vt7bY8ZeBt2bUqkckfZ4RRjmhpt/3ebZMmmuGMHfYIXwhDeDoC5QZsYH11KUFYgtDSDYhRpWyogsOz6wAdRVLjXenAzjjwcZhxnOR9gQtZHEEI+kUjvUVV75+MemlNMM2UUDugU+kbmTz416k1/81+/0eKUFDGObcwutAPlTRfanWrjvHFakZhjFc/YjJYuA2usJKRgw/bPdnpelyrh0MNYEBZ1FwzHo7A5Ts8k7FEhEK2uK3jb9f4WzxO0Ljr/m1up1vd9zLBuplMEtq5W8qqPckfzWj41k65JA1lo5Bk2zAx+5vyS0HemS+PZo7NWGQMvYBKJz7oiP8HgZF8bsvPULIXm8DJAn2BZEy9K9PtgiDjDigAxx9ZAAJovEwqkC4na0HpSqPKOJlGaiP+IMCaW8ZpBy4+zoHTaf8+VTKHMvDy30Z1A0cd6I1wRaF4PqhT5lr82FerQsIIA1pl5CM2uoj73X1isMC/xe5PwpLd7gWfzH2J3basZMPtie7OW9CNn0TLOwIPjAjPtRSK8T7vdlzrtFpCJtiCYRrGeCQvzCpPt4bin7rDt3rLokqKKmbETgKD0O7CJqRrfdQipQzNAvCCplaQCk4AfWCwTKqg9cTkAU4ABFQgTm4v9vxiAmBPMCzuZP6AfgxDMUrlg+CrqIqqD2aOMvz/QPmwz74Y7GguA/yWjwsrw/o8bQuXbxQgwQrNUFDKzwstwzPIQMJYIP2cDA5rJQ7jEDvs0A5NTATu0Ml+6IeIaGNybMYYRBDj6f8u5+4AcEH6LiK6aIsUMHgEagHf7QFr58RSi95wiCTOSMuAZ6T0TWI28BNpoLYy78wGjuBKSmPConzWZwPsDGeowA/0zPSsS7qGoHvwwky4K0wIbQda7wEkyQVoxgWCAARaz8+a4A980bssgARUoAnUABpjkRZqAajwZ72e8PgEqAq7sBu5sRunDxy173/IMRzTUA3R8RLM0RstI+tGjA7hkcvgMQXq0MnwkA5hoCOIYASIgAgC/wTbHkvvEhEODrEgvU0R+S4hK0LJ/EUBB8/zInCM6O0CLLHxemcCKVCkbCIwigQDJy8UP5Ff6Ki2qCSOQKq4isQjniv0htAkSEAW1WAH4sQkVs+lRq4BToBmfpAEFk0HiRD2IMnPduAZt8AYYRAE2Af3HGDQrgK7qEAVgq9+jkExsNHSZi6VzpDUuvAbxTAdr6/mHmEdDeEMydIrIUEsq++ZogAIMCaMxMgt49FG6PEew+jE8JBW6NEPG8vtBBHcDpEgn0hcEBGyChDJ+q4hPYIPE9PdoKwxLdIx/6giIxIlgAQmcIcmimS2MlAUQXIpIk9KOiY0iWLiGkp3vMu5av9A4lrS9l4v9ybgBD5OBnexNYESGI8x4kIgTn5RKZmRphztBDiJFtqhFqpRvdgLCiNDCieDK5mvObdSHKHTLL/SLKmzDMvSOhHoetCjI+Zw/eLSHj1gLm2kIsnTr+zPD5Pg/pIiIC9HMBOxCzZnAONJJAtT3f4uAeUxEiVxEh2TIhnwxCYSMmMiYUqiJuyMM8cMj/iISe6oCEBGS57l4RzNfQbtBFYKBXvyZ2BvL7JrAmjKBqqgCmyAAxKA5EigCaogBHTwTYLABV5mN3GPAHTv9SrAQuPHD2JhOIsmfwYhz5LvvpaqOpmzK69TSMHROs8xSavTvrCTC7fzLeGyHsH/c0orkh7h0jxNDD0Pa8YCMhHbyT2/rT4N8wDbLXje8soEjzH7czLZ1PEsk0fG5CZuwrY6M0H5qN+aBD3SLAvcgA1qgELjbM5uBmdUIBqbgM/ChAOoQCcRtQNUANFUlCaC8mRUIFI5jgT+oGZozzZt7y089S0qAJLM5AnyxDDQa/iOEyuLlB3BUUm78fuoE1bTMiuRtH+cCgqfKTu3s8nkUErF8zsxoB/zkFaIIHjS0w8F0kv5T7LEdBGV7D6XjMsicTGx7Mkajz/ZdCIDlIwaqjKDBDCI5EA/EkETNLcaNHmw5P1qgg381E2QkQbXYkJnRs6C4E1WlFJ10y0WTn12/xIG5eQmZ9T3bMD3fC9Sb++RhBAnSZVd1ecpPSkWmDAbtRENrXNIidQsXfVIM1ZWZXVVsdLBTiFkEUjaNGg8EtO0qJRKK9I8V8AuU4A7ncwfL+L+9BIA+a8QnUghdZbdoLW0UPZMwRPK2hRbt5VNcsclgOTxwNUTyTVBM3NJaGBcIeYqiEKNauA1ME7Q7GRCm5FQf3AsYBQoZzQEKnUuQsAY9VUBSA4YOc4CHnUMXGA3I+D2rItGe28DcHIQYiEaaoEegEqoejRVlXTTqJBwWRVJy7Bj0xFxIeH7FDdxr6/7yvLnho76LG0QRHYQ6IAv2u9nUxZY5Q8SF1OPinUfk//AdLs0WSNr73a2IViHIdstE0swTfczaK/1O8dIMo2WEtWoMuFUdjhSM5vWaXnrI0XzA2ZCnGpCS9JiLWgRZvy1GQl20di2RNnWNsXEAt6kUs/2AYLwAfz1TUJg0baX9kRuUmsQAdR3fb2rUMEnEgzjflClKgV3cD2WcasvFIDucQWIf2d1OpXUVm/VwTA3ZDV3/h4Rd+0ydKMU/t7Pr/bRWO9PZlfXPQfT21rXdccUMXmVWudvDuNwTbG18XTXPxWPjArGInXHAN7UJIBXM4V3eImXzLaELR8uuhZpS0K0BmVvLlA0CBD1BE5mUZuABLAXGHuvUm2TbGWAC16Gbc//Z7xkQAZsAEY/DkVV9AY5IPWwFyhJAESBRdIojX4vV1WX84wFKA0zFn/3iwzZGI0pFo7LD2SfamRJYWQLuEcBTXY7t4FxF3cfeGa50yNO1x9PNz31r7L8kjAz2BHxMz8FTz9Joktq94/7M94kcnezbEBdmGlleIaTRGqN6yr4LRb5IAVPtA+qgH3A9oubAAs61PVIgBB2QQ9sxicrIARQVImvlwNsYAtGFAah+Hyqd0YnQBh3wAd5kiejF2DVVgUUCVgcwVRBqYyRRo4JRY3nWPzaWI27eZsv4XEVV3G/GepWw45PAXMLGNA6T2Ec2I//WDL9KhNFF4fo8yL2kR8P/3lmveX/ssUAnZWDE5h2KzmErfWgLTmT3fkxAyYlfLcTueIF7EKUY2C5iHeOyhVLtEJ44nUI+iDRuCsGu8vkCmADVGBgPa5DozdG1faXbWBgNxUYEyYIZ7SkW+9NqmAMCIENqPd6afM1G9YEXjL40GsXJBab49hWuXmpy7lyzdmpE/ebk/r7pFpQzNmAz/k3zCBk1MJ21mgi//iP6dn9mIzJitVGUJdmEVlBCASeALqRLSJ2zZSg51okPlhoC3qEIxB4docSNxkmknYkllYFoySGjYSiD3vy0DUrojZeYapG0cIrQg6Xh1BOejM2a09N1pZO3gQEbGB8f5GmfToItf+XX3n4e1m6Tdziz/rAEdrhvFruqJN6Yrl5acjwtsePqXM7gJn6qtsrnYFbj9XgCTjC8dbIAEAVr51sLuG5nufage8Z//oQPf0wQdp6ANcTrl1nkEWgjxHYO4E2LpW7Wm23vEtY8RDKJNC0d5O2jWIkLT4ZlA/iokITS3PHZzx0ZcynUle09eYCpbMr5JyRme3kiMlWB5sxBGxADGQgBHxaph/8AT5ufI3xwUtUbEu0JkJCB3rKMKSy+DThmpX6qMivqQf4tp+6xFVctzulxCGDjklBqEoWCLqkR477xlvrdsOaDqnVuaM7Wj3AdE0XPa0bkY9Vu1nHZ72zxw1aHif/kbx3fGjZBPEweaG6lQIBI3gN28t6QsyWB7E55uA4wq4BY8PdYL9JQFQOtZLERJfht2Zwmaa2YBBqxlLb3AYI4bN3UMJt4Af0fLQtPJI6wAe5N008FCktVU0+VQI6ABppgU8ozfisMmkmdsUtHZUuHbdbvJyz+jHyBznWssZX2FNvvL0TL3fFGrrfz1gb8sf9ECOMPNaPfNaRvCKUXJI7+DvHO8qlfLUUZvHwGgJM/fNeeMvt1KI8MGr9LqI+SgcMjiqyJz3MwgQCSSbDl4iB2PXwomDHAvc4YAvEYAyoALTlRJlrzzZ/wM8rPMLVtjWDkmxf+qW5d9FIetEVFQuC/wDP+KQcboF/zPn4YDzFBd7S9Vd/T3zSffuchQrUW9AtblxhSp2Fvzq15NmPTzY/y9rV6ZNm+Zm6E/mtm9XWb71X6brJCyqv9Toic/ygdIR32RvLPTm+3UzmYazNYJdUbzGW06QBVOAPsJiVW0+07VbAyZaXI7yYzxYElL57Ifzov5dswf1FR1rjNm6nggB5P+zRjVrE/538EH7guxnFE97Fuz7XOl2D5OYdR/0A2D7iJd7U2Wgyo7SP69mehUfj73nIBVk9+5DWaz2uRx6SM3Hww7oCJREiU74S0RvYg93eYF5OxZXGP1mUv1wER7HNrOIJVkC1Q3VDJxQ2BZzbb/+y5Ca7zYfg4sjdso8eBsmW6Z3+eicgN5cZRjX0UxnAJDYgVo7uKh+MxMG+7IE/+O947BMebaLApdZe4pE7Lphf+QdAACwTuVei5T8XkP9FoPE+76Pb7//ei76ouxVQP/kYkk2e181/JEr41Kc8Ry5Z2LVMsP/J2C/azPJoMzcmYpzdSuhAc28RIExUGBhBgsGDFix0ILGDoQoqKmx0cEDxwQQJHGxs2SJx4IQQNswMEiOm40WLKFNaDAGC5USUFWOurMJRhcMdHCxIaHDwwocNOYJkUWOozyRKmpImJcV0adOnUKM+HRWVqtSrT9VgqbHhAoUIC8KKNUC2rICzaNP/BlhbVgEDCj4vaMDgoa7duiLy6s27YoSHEYADC+4b2Afhw4gPE0ncN0mSFUUg4+gxmXLly5hZZG7BeDDgD35D7xX92e9d0RXu3k2t+gPr1nFjy559AUJcsLVtF/wqewHbAAvggn5hgrjx4ysYSqaxnLhkyCNoHHc+XQd0w9Yl60DC3ceQQuCfPDFTRaDHDSc6ZODQpEnDDR12NPnTRP2EhB9pbql/8gFPG5EIoocK/amkkg02tKTCECEUKNNKD9lAgkIqsEHFCRugV0MURDVyFCpIgYiVVVSROCKJKEp1ClMiquLiipT4QUcWL2SQm1tj5agAcGr1mBZZEAQpF22t/wkGGmmeDfYCYMwd1mSTnUX5pGWb8VBllSUkqSVoGYx2Gl5/1ZVaYKvBZqaYdr1GJG223YbbV0KmRhAEv7XZZXTFEbdddM1Jt6Sf01F3nXF8aiddckiskKh3T3whnXhDmCHjhF1mwIYefeREQgg54SeBCn9soUJOGd7XAQc5WcRTAQWEUMWrNtiEn4EogWCDDLGqoOumqT4YEwUINHACG330wcexIToCoognknLLUrc8exWJ0k6F1SDMqoLtjECU8AFYOoZ7gI9rAfAbW2LhCJcGa+I1wp1axiuvZ8wd2hiUS94L6JVU8htlvEd6+ZeRpn0ApsFpnqlwuwy7CSecQf/GqWbE6HokmAnPWXfon8g9Fyh1H3vsg2Ejj9yoouQhYQKkpOrwkECeGoRSE2zsRwKGpTpQAK34uRSCTQ3S6t8DLN2KoK4qgNDpQBQ1EKxBHdSghh9Ifbhs1SE2y6zWTJlYLYuj3LLi2DHOoZUJNoLLwNrimtWjuXDDnRaOYe2mcGnwznuxkvcWCiVjfzs5pb+EI6a3XjaG+Zm7A5tWsGpqqrnw5JPz9jBYEt8551oRS3BkcXhirO/oeXIsOseh/9mXxiW3jsQTjJoxRJ46UMFgBjHLBPVJN2FYgUK9rqRTSiyBkHTQQq+kEYPxDUVCyyecULsbxFrd4rLaZg12Ml3/X/V1itFa2334W/Mxh8oieBVk28GOO4D75/4Wt9xt4dbmmo/Lm+/hSu4fuJOd2Vi/Coclw80rYEYamOL24oHIUe6BDXOYwyJAwc7Z5nc/cc2NeHRBekEHMqfrS55S55zllMB0x9GB67zDHdjxqVJdeoIf3HOqDFFEZhIY3gQ4EAScLMQGTRAVBzjFO+Dxjmgs2VXyUHKqizTAApfaArGKRcU/fMh62dKe+KD1vUuML2xbS9H4pOUGNJAhBiXYCfvc5j74nUVu84vj+9r4piHdDYYe/Bfg8ji6AIpsgISzjB7zRjDEuYtMCzSNAyGXpkVG8JFsulzEMmewCoYFOMJhetLp/Le/vhVmhCDT1+AMNQQX2sgjAxkCFeczhibI7Ib4OYEUJ2QQElyqCi7pz0dmhTwKxeoltQrazmLSgSY44piTOKYVr8jMLGrRWb7YIiqq1UWtRZMqedgKCi7XtjqxkSzyk+P85ki3CuLvYPL6l+rulbdR9s2d7wwIACH5BAQEAP8ALAAAAADgAQ4Bhx4PAioOAi0YBy4ZBy4jDjAPAjIZBjMcCzUiDTYeETgZBjgmEzoiDDwzGzw3Iz9kP0MdB0YkDEczG0g5JEkqFEtCK001J1UsFlVQOVcoC1c5JFgdAlhDK1hLNFhmSFktFVkyG1wxDlxaQ2Q2G2g7JGkvCWlUOWlbRGpEKmpLM2pQLm5BHHCfdnJhP3JrUnM9JXREJnVFKnVKM3WPbXY4C3Y8F3ZJK3dfUHhKNHhVOXlCGXlHKnlcRHljSXpGJXpKLHpMNHpRLXp6Y3uyiHvElXxTOoE/DIJONINTNoRUOoVZOoVcQoZMJ4ZPM4ZYN4hFD4hIF4lmSIlsU4pVNopWOYp0WIp8YotTKYtZNoxaO4xhPY1xTo3FmpCQcpGjfZJNFpJPJJKui5RbOJReQZSdgpVtUpZoR5djOphWKJhxTZh8YplVGpl2VpnMo5qCXZqFZ5xhLaJaMqNcHKNcJaRtSKR9YqZ6V6hpNqh1S6liHqmCXamGZamXd6moiKplKKpuSaujeqyQb6zGm61xO67TrrCzlLGdg7NrJrN9VbRsLLSNWLVtM7WLZbbiurd6RrenhriFWbiMZrijeri7orp2ObqTa7qZdbrmw7tzLbuCSrx0NL2CPL/fwMF5LsJ+UcN7NcN9Q8ONZMV7OMV7OsWVasWadcaKV8adgsijesmEO8mmhcqCNsqHRsuTWMyEO8y7os2RS83kus/PsNCGPdCOYdCzkdKLPdONSdOOUtOec9OpdNPry9SMQ9TFmNWQP9WSS9Wrh9aRRNebZ9ildti2lNjdw9mWVtmjatqTRtqYSdyVSt2ZS92aU96hWeCXSuCfcuC9ouKeY+ObTeSdUuSeWOWjW+ahTuahU+apXeardueeTuemZufbw+ijT+i2h+q0eOrv0+ukVOulWuv84+zCfOzGle2qW+2rY+2yaO27je6pVe6xXe/RqfCmWPGuc/KrVvKtY/KtavLkt/OtW/WxXfWzY/a4a/e6dfizXvi1Y/jIlfvHhvzDefz86P3Abv3Tlgj/AM+g0QHlypSDceL8cYQIUa5/8iJKZAetFCQxBINgOUMHj8c/ID2aoTOyZEkxYpjUeFEQDBQaMEtAEUPnjk2bi3KOogSK1S1m06gFFaot3FCjSJMqVcf0ndOn5qIqleZs6Lyr8LJKpaqMl1dRnT4hc/az6tF2aKO1M0u0Ldqib+G2pRp0mV2yX2eNZetW3NSiR69hw1bvnj2tWg/XW5yYsWN09gx/k8yv8r7Llyuf2zY4auPN1UIDFbw5nunTj9GVVs16NejOrlG/vrYs1Sbbv0aH1iTnkLK6d5MFN0sWsPG/ceMCf/sW8WrDljFj/reP+j/q6I6hk179und93693/9+X7pt2yJQlo3bHPr37eKEQbUTEiH4oWrSeeQOWjl1EiPKww443kehhxkYb3dFRTQqSdCBKWUToBEoGHcSEQXSkpFINNMyU0E2LOLLITj6VNVdgSzWVIlQsbkXbcKE5hRhSd7myClhidbUXV3IpdyKKQvm43HB57UgXcjQCWc1iirmW2mfrtededJaZFqOTs+nmGZTOYemaVLB5yZlwtmlii3BzYZIHJsD5UqObbhYX53F0KmlnkGo5SRl3VF5m3jaTSRfeoOBxl81570V52nvqEWiGQ94M482klILHDkQCepeLgVp0esanoIYKoRNIWNiEqaZ2JJBLULSk0CA5wf/ak0+6Aankiiq2uA49YPpFHFtoLSbYizreGBYveHmCC3HLqvXjkCcKORqRtlRrJJJ1AsnYa2JuyeWi6fHJLZai2UXaOVjJ1uW47HLWLVCwbKJJIjwt01m5h8iRCrHCofmrNf9mKzCPRx7XXFam7clnlaAF2qd05fCZmZWcqaeuou1JyV48BJ4BSaXphJyOpf8ImKk+joqq8qikonphEy+7NIWqCbFaUEKxjjirrTx34zOuufKK1dBaJflbz8V+onRZo+y47NHSIj0wtdZeOzW0Z7VbGtFePgkulfew621UtV459tm9ph2mbKL9woqx9Yp2FCt5+MFLuf72O2fAVxv/x3eQyfm15ZT3WOaPas00o5rD3BUqMXnubCNMNPEYVh7b7mKp8WnD4HFGKRGDF7Lo3538D4GDeAqHymhUCKFBMccOxhVoqHpH6622ioYfOu1csNQ/A92U0MQXL+xcR2ONV5lhTYNM08k7A0pVyv39rN9Ue6W91UYr//va5J7ttWKRQQe22lviPazgZqOvdmiZs3YYNvAyjwkmJco9d925OU/XnAAEjPW+9z9jDLAva7NY+RAHlM1MxnKPk1g64hGNPClwNlpTFDaEYYY76CJ0pCOd6S6VMta1blQUgl3sLiSzD90Od7nbXb1M5D3lBQ9oxitek1zUrzaZq35KMxM1/25BouV5gi9EedoBgfMrvQVje1BcYg3ZR0X3oatrTEqY+RiWvnHpb30xal8Yx0jG+I3JbfbTxCdoBUYDcoY3vqHftPLWRCkOSUd2ROC3zJG4Bn7NcobbR+EAKRmhaHFjWUIgNeKnlW1c5HPDQIUuvlGOkVWnUJcqmehCYcITIggLJ5zdFVYYs5skZA5r+MIaZOgIWrkReNgKFtrGJj/U5GNbQ8SjE4Fjv2mAIiw9kd6srKbEOhLsaLt8YhSjOEA7VtGLz8TiAgN5OCvysI1gBBg2v1i2ZiTDK2qkhJlw0z93VUNHi0xGvlahPjnRURvN/J07jSnPW4FPfQkkXKLSqf+xtFzPLeZsyxmCMAhFGAgPlZhUCMETnpStTiAPRUkoaUfRUTIhdxd9ws1QucqOxkEnpnjlP9cnjVjqao8aRI0Pd5nOt93vbi4dxRHH8ktkeOKIbSoLPY3pRCj6dKd3PKY9rShGriGsfObbYRd7hbQ+DqtWc4TXtIg4r5fSMHHuYgYu4mUMcWyDF6n8RDu1CVQ7zrOs9VQkv8CYucg8cHMWMyTmRtpUHQRBEaQYCBPwkA1L6qOSI2toKwYR0dVVFA6tS2xiLYpRI2hUlKhEwxrkMAed3eInas2m8GRJNPJB55Y73ONKc4OMtjFveqA4BL16EkyZFieJNDUSMnfa06r//RStQh2qip45vK1pLlFXdN82n0pWujiVSKRFo/1WUc4xgmarbPxqWMf6TtniFi+zzS5uYXkwLF4MKBaMR9RqCNVprOAMuiBFEDKwAr4y1E+UbCgpQPXQw050oh0VpSrnwLv+5mS1rszsDTfL2aMyaZCGM0xov2TA5LrtiTWyzWrbMYq6HQIsN/3lLwumS+ueNZlwsq0y9eLh7fasqEwpqp48S751hYmbxCKuVEH84LyIkye0guY5YXHZ6Ipisrfg4zGra+K6bG/IRSavwe6ptXP6Ubw/0i6SG2zAKygivVcIQXuH8d7ySOqSm7zDpw5rX8XurrIg0hmJSsTmpzVY/8BUHPCKDEy+h2nmYkWD11hG/Dbb3GjCFVblhVnru18xs8R7TjSfrcVoEiP6wwcsYxVVvOIWP+l92DTujN+kTB73+bTRnatQegzdrk4DE2uI41oDCM9H820Wju6wlJP8wxNLGn4AhXKUYSTr31D5Dq0gxzHOsAImsOIemETZMY7BD9J5Y7CIjba0px1tmzAkEyG9KS60vdVS91jRUDOpnJNiVNDekpoTU7C6fKVnNN7v3fA+Iig4OugNrzmY80TGbXu96Eb729W9TqutNRtNPLsY04GJavY8bWM/p6KconYeqfMXDWX44QuJkHFx4XRdQ8OatpAOOa3L+09dIw+5/P/W5ZX3oYtMDCITzL6MeMwzjMq8F9rUrjasZJWJnRnw58Zws/R8emQkihuH5YZHuBK8wBavFG6qjboaDRjoLwCTRGv2ijv3De5O13h7D2eziAHu4YHDeLhWPDjC+4hyr8OJ4Z8+EzP09Boqt/myo0alWGEr8o5XyxV7mzUyiyn4oo+ciYDbddsX77aYC5I9lpTOoSb5jczcoxUuN2Wab3ObNov0zZDmOhh3e/R1QWma/qgMo255FYk/8caqtTDvQNGOm9IbtYTGUb65TnS3F+nfou87yTXOXUrPcu0Kr22ncfP3UFsaNK7/dv1YIZRRAJnvfg9584U/5cLrNOSgL7z/PB2cTBq7PRvkuEw6VH+P9Reyj9qR3DGC3vP6+8T+5ExuOqXa4K7/HtyTVnpJ9y2ot3pNMmppVFUjUkHzJmj3hnVgoW8SKIGwVoFa13v9tn3JxXvcB0vDR3DGZ01MdVw0ViK+0HwkhlVNV3d2R3FD5EqoNgdBhn0dyFMnWDV913XeZ3g2mHLgtns+aH4Plg1E+A2TxxnLVi6tsGnfZGrC0QpQyHC+93l1NEwYeGQBKG4DuIUsZoBC1oRi9wkLeFOHoEprAIFoyAs9AXwWeIU3GHYaSIEoeGg1qGS1RnyicS+kJ4IaJ4RzyGOKgx5KhX1MIw0VRH/NkghAdkYBx326/2SBORiEQOg0hCeJE2iJOthTX9dj8Md2/UNl/VdjURV+m6h1PNIs2LcTy3OFcLGHJmVUBSY+B4ZUqIdLVNGCalZhcvAEZ5h7aUh0bRiMwJgKFZh/pPWHEJaJP8hrzHiHZBU8iaNNZLR2Z8d4Xxd29rIrz3dyDvZKb9Mst3BxGbcZkViOcTiJyuiDsWaOW8eD2DUKrZaOpSh9TsiE1ohy7TaF0vAVwdRqG1YVTaMNoyCMJwgsm2UN5FY0WyiLs1iAB7hprJAIEjkvdaNKJJJhv/ht2kOQbGiBzJeMPcaR8qh/zTgcJfmMIIh2ZESDfgiI2hhxTHhV8dI0DChZmjAUy/8IMHWobzeyjrJmikYClHikkSOZiWMnhwApCr4QkOxIlCRnj8qHXY82doCnYTuiivY2dCI5Da0XOFqokLCYdl24jbA1CorIX2jpgL6IdcNYlcSIjHPocB/nRD3plkfJgSa5kwonjSqJh1C5eIFIlp7YjZ8YdOKUYw0Ij4zoaz0ocnWJLP7njpeIlG6Ijm44l2ooPfCklMXBlEbpUzZiau2kXZQplYh2lwPJlP6IWlrJkcjCWXGGJKYHlnzoLebmdGWpiBOZlnGwlmzZlm8ZnG+IgsKJjXhUl8wVmncZfPioS3vJjH34geV1j08mmPlImF2xbav1c7yxBtRHjpZZjkv/s5ylCZmRWZnP85nACT2cGYHhSZlg93AlxW6I13WhGX2SWZ6hWUSGtpkDuZF2CXit6JXYYxRheaAIJzgoNSZa1QkT+V9oeZG+eXd54ZHBWZwBapx6YyPIaZfnCZLNOXikSGTH5VQyVqLPyX+ieSWCmEjXCaLHuAi8g1m3sAiqdDfbgGRFOVtqeCxvCJ+sOJkASpUf6nskBj3b556tWaRD2oaC032KNpfxyEw+1HtKiZUFuooW2nyw2T18iaBE06UreS5YdEartRM5ozM3VRUYmXVi940cKZcdupwdOqdFypgiCnSFuWkoKU8o2ol/OopSBT/hoz8teIUUOT2HeJa//yA5oyZ+5adnO3GlPHmkQIqBVhh3l3mZqdmpNiZMqvieRPlpAUmfUGqBRtGOQImfoKmkNrilxXgmXTleQRGLtFmbKVmoYigKGoaGOIVT2ummpfhvyfl3dspxksqhdfqfd/pg2XlZ3tZtenqST/lDgIprK1qiSfgugzmPUMQKlBB1mBV04qgM4BmEyOp/ShOnwBmMrbWGHpqemzqklFqp7NmenNmsbZlwIMelj3qMktmqz+OpZtE0RQSrHOoMQxObX7qQYZqgCEmmCho/zlNVvkpoGAkKIqKxFOqtcTmntpWPygqy8zqq0MUKN8Vm0xqoKnqtzbCtrZE5x4BrMFsxov82rR6rPWbZG4pacXSDcaVVQZh4nkEUp8zakfSaqWyoaKzZpEdqsLbwi/g6dPI6jA3XI1Bqr/NZQE5pZHTqkdOzmU47sj0pps9iq7f6sFkIgi9mli+FIzhGaGm6c5vQc1IIrUBKtnaKp1oKN3srh/H6raZwbYQbUlEYdDMrs4q7bKxRs4DCHkSIDoeChJQrf2YkszPbR4d7d28akZSVCN/JgKnkG0JLdpmoYT6KsKqrs3mhtE77uh9bjJ46ta7qme0qu3fTevWpfDeytT+5qkY6trYrvMi5SAcTNWjrsLOKFCbKW1fEDDd2pcjJq6klozWzSi93f3crfbWFuz7JF9n/uayP+YhwSpAl0hAM4RHXBgmKAAtL6LhFaITya4SKEb/zO7/xG0mRm4TL1r+UO7PzZ3cn27kzWYZyQAmNeojW9wSqNrTLCLfS+5+ri6Fq2KNuKsGwS7ywhsFR28EQLJD8+XuoFZ8bfCzsk7Vaa6rkC2ESB4mUibt1wcF62zxm+z3Kuy0Ly7BH4rzn8AvhlKG9ar02g3H4J3QjOqzCCI7HRERyOr5M+7ptRrgfMcXYBoWTc8X2K7/kQSn328VFOAz5O3nD4L9krLmHawooS8DBeXGp5r6HaAwLnHH/uqNMW7RgO7sT7HAynMcZnJpbioYRPLvwWsEVqrfmqrsojKpM/8G3vEeeH+eqfYucYdEJs1DDBZO8OaS2pHeHu/W8qWBVIUmq1ctRj3UH+Ge4enrEeBtFboazytXEGxmKGXx/9Ze+U6y+kGAKuqzLWNy/RcjFwPwNkRLGWfzF+kvG/Qt0m6vGZfK5brxIFWejDFwVSnRZ6SqPu0qphgzLQAyBJbLNhBy73ey9egG3oCqvUJvOVjmynTCfi5y12+cULHlowAe4HilAIVmnk6wNtxotJxWmrNfP15Q1VeSgzFq+fSYiNpEQX0AQcEC4rYSyyyIMQLd/sCWt3VjRspy09fqs+VyVrEvL6TsIt4zLDXHShisMurDSYgzMkyLMRKi/Lc0f/P9hzPpruclsDBS9zAjdc915YaiowF8wzRuNnklzYVcnyOLbxEWrlA0HxOJMzhIcwSWse4BcwfCKxz1Jw4iso8PJXNWzwnJHFspKpLIbqsVy1n4rDf28HJiMMJmMPj9jwwrqw/jz0aJsvX4gWQSxXzfBSvDqSp/nLPtXcYT9xi01cT1tshOMsiW9IA4yEnbgEQ1hCpEQCpUAhaSw2aXA0pLyDcAQ08c82sNMhDXdxWOM0/3L02isvZQQoZh1iNGsUXbTYESJrHTotk2tx9TLzby921LtoVG7x3qr1kottYCs1UF0kyqSyDfou0D4d5FMlWr9mva81QZdWi5G1wyJD5r/DLEE7RcRuUZ4Hb0580I6ABMtMTuusjsfEiIQ3RMYDY6HfcWyfaiKbZoafH+2HBJlIBJm8N+QjQfsW+AFntmkkAsrHdrDwOD66+BjXNqRMuGfbcxH2L+TE4WdCyt6F9TQ7Alz4FigK6r2qVrjCcFMzdseDNzBzcfKXdURaNzJrdXGvc/RmZfDCd2/i5mqe91r9j/E6beK2c8GeaCXtrwvJmO7NbDYmNDm7V8MDRM1AAWp1CodolG6A1mJ5UJpZsoay21blR/2fdhM6LpRjbL1N8X/bRJsLtkmzb6VwNkK3uCjPef6O8zAQNP7MSmhLdp+rh3HjB9hzmaDQFmV5eEV/xQNDYhxrnypOrWzbzvjvz3pkk7cw92jH9vb3izjyc3kKP7p67qu/Dp+iZawYa2qjra6xEscWA3jwJRnsrRkvXXDwkVcVaSpTq6AftBfe83XHQIGL8QqjjXsWF4Q683eZnZmXc4TEV0i9E2Fo4qwIs0QJN3m1u4gfzDZcC7nnW3n3j7aoZ3n4V7n5P7nwnAfuizR8fJCI76t0DxEu3iGc+zoYCd1gUzpnVrpkq6pMvzixX3vQg7q+m4sZWuHe1aX0I1kcSjVxKs0QF7jYdEOumagsO6KcS3Qs64t8EANk5rPFht7/CWRtzPUv+7lHJ5Kwp7exZ5RjTXUuWOGjzU7Zv/mX3GrLIjLbrkxwNrTZoPbc2rO5jRh7ZPNCJcd56XA7XPe7ZL07XlO59/+9KSdCxkehbtcuD9X30G3BkYg73w3r+s04zyx2/mu7/zu71N93GMP8Gkv8Gwf6m/pd8rqziv1joDn48L9755ZUyh+YQrrIxjf3XHtvOEtDet6WXArkflCWan2XyQv4o6wy+AaK+hNEFLOIUag3sR+5RpFEMVuhlqOljjjptOZp0EXdJZty9b+ICPh39vO2dyO9Ep/9Euf9N0u+yoN9X6eC/dh+pAv0Vef6IfICi4PCofIqqjpoEg98Giv/H5MqiSL9q7O/KCe1DiyrD3k3KZ+6lvHXNP/ffdBbsL7SMgQrFq5uxbhFtAh+BiZfJDMweRMvKuJ31GpRu1foN61o+6exlp6XeUqDxBGaAisMbCGjoI6niBUCOXLQzAOI66B+HAOmot+7mgaxQqXMZDURIZsRhIkrVamMv2hY8Zly5cvEf2pg4hRpEqkdO7kWcrnz1xAhwUlCrRnUFJEhSnNNVRpKFNRU0KSujTaVazCWFFcw2ob1mnIgtniRdZsWbGjOh3C9ElUx1Rw3VKiKzcuKLt51e7lq3eVq79+1c4STLjv4beJ5yruxLjxY46BZ6EVa03aZczLNGs2+9eWM3XtRGbOnNazM9OSAQNG2znwY23akOFl/NbP/yFQ0eLBG62MGrx8we0BN1fcePF665TTS86c+Lx3osVNp35cZLtzvFnB3b73thzwa8D7AeUozpOBX9BQ8gjr1/v3HrfTTeQH430wEx3ub8jf//6KAuRKvNsWWeQTR0D5iJmSGjymmQdTisoRmGIq48IyEKljwzpw6ulDEH/SySifQhFxRBNHJMqppobiSSqoYLTqKmO2MSYTrmBx5xySxDqLsrI+YWuxwtirizYk5UoSscFWK1IxvLrbzjAmq6ztSiw9A9Kya0hDjTPXkoluOi+/9IWwycB0cs0fy6KyMWSwWzKxQ/L4pMZ4epNGnOSGCw664wIFdFBCpbumOuu+4v9RNY40WcSP8MZLxMg5BDJijURScY/BsJRJBr67NqnLwEHuMDUOVFO9CD80oKjhCVhjtSijjAa0aMA5CmSvPZAeFEZClip0qQw6/tAQEZtKCcXDnnJytsSeUgRRWhWp3YkpbHeCMUaruqXkCx26ymbH3sZqM8hJ3Vozy01CnXOvJJdkM6550ZSSSnatfDdfKO2dzBfUuizTR7K0NHQahL0887SFqVTt3IIVG+3dOg+5BTvRvgynHj87dq7QQpsrFFFBs7vlTinpgzRS8hQEpdVLyXuPUz0/NRct+bZTqbwEE8x5O/MuspVAWovm6iEBbwXPVBgnLNZCmmr66ZRTlmX/9llnUcRpa66tXhZaa6MdEZgWUWERqaiokrCVbh/EZL9Mxj2nmpJsBpIX29rq6JacrXwt3vI8EfwjwuG7hWBRPFpXMCVT9vtxfg9TnKyAB0bNtTQPHng1gBuul/PWnIRTJE9suTIPOTqZBjg927HnHtiF8zi740TebWSSBZ1myu7mgvS+OQ6U71tYU/doMy4HHsvwww0nvBWQnOfbUY3YiqM+7Ekdtb5ch0a6vzUwuoMOR5AN1qUxzIjaE6qRimQP+Lv2+qatTZGf/qu7VvZr/lVc0WwABiVtaqvKUr7RCj8g5Apxuwc6vsIgu1UGb3prXgUP9zNQYdBTnhANWK6S/6cPPrBmFqxgysoCOO7sC14q7NeBhNeke1EueZUzU8Rk2LrSeO5yi3vYv9y0msbEJhrOQAz3LEY72XjqN69j4uzQYTsoPsc6upsOb/Z2srfQJ1IbyZkfkIabYCBvhmLsRjIsgzwl0kyNa4we39z4xuZFL3rzaYuBvmOr4uUHI+dL30s2RDWr1URD+CPkhm6iB6ogUpGQQNbWEHGi/clvWiRCik4GuK1j6KIVrVLIJrLBDwc2g27M8FQGIwMSEWZlNKv04Ad35I1XxlKWs9xNLbdhy7klTI67LFwvS/gzJAkOhShUHO/OYrnOYQ5gQtRlDkHnuYf18IeK8YV0iIgkO//KATe/qRmf8gE7foTTH05ETi2FI0UyHYpugprNDxtlRwLt7UaJGJAmjjdGzcywjPtEY+tYiah/ImydA/VgwuCoOEeZ6nd6dMj40DcsQ+qEQxPdgx0selGMYrSiGa1JTSJxrI92yCaS3MlHJUmiZSWSkdtiAkPOIAxYhpJmpRzMR25JS3dk46Zyu2kInyHLZ3jDG88galF1mtNb/jSW4LxHOmA3y5zWMpZSBSpWUomSXqrEjZ7wJTAnd0OFJVM1oKlZ5aapTEZ9zl6J4aYzBPeYUTwKPKpjXeteJ05xOrFP5JyiOmmXy5oC5p20WsTxfvEJORTPnmbsRmgamzx+Qpb/NAkbKMbGhM6S/VWzf8UGdQoaH6CVSgyoOp9LKMoIimp0ohxlLUaR1chGdigUNuHf1TaqSDykAZHVEqDaVJoJRrpqBTq4wiCOsY9viHCX8hHGTZuK1K9cJRfSVeVVaKHKomYXJUWlrlGhmg7whle84yVvec3rVKTG8qhTteUq5wjWHO7QX8tsZmYixjDV/E2a+HpLbETz1r3I9QtH5E0374rXvHqsiedEp183qxa+reKdcs0Ve0AyisRiKnHXcexjPSxZEPs1NCEjcYlxGbITK3eOHlkpS1rb0WPZAX4yfnGNOypIkW7IE/lzpEXTkAYtBBkLZ9DtSLWlkxYzsmdQ/yhBCYZ7BlN8Q8q+eiAv2bYUXExoZzzrWYL+UJ4/LOIP17Pj9YIV5jCXT5gyum7bxgU78uojHfqQM3j3EV4555nOe+bznvE8530E2s9+Bm9TY+oOH/XTrInWoeXk2xgt6TeaoFvrWziYp9nQZi3cS51lJwsdfyA4wbKLHV8rK0VlpJA+2QyeguYJK/IIlIofpjWtBfUnQn0s17vW9XJMzFksnySleLgoHdiA0WP7+Ni3LbaPbXxjQcaYxzjZ0I+DHAQY2EAF2F7Cj2Gbot++NhNXoEGTB0KHUiD3qDoNdmjPAAdUoYGhSPuef2JlqRJYSiDCPQgUmMBQNIw2zAo11v/gaEGUowLDGwqHpXiFel6IPxzQ5bBznv8c3qaaSdGMFutp6mtf/U6TmvvlIQcxhs1sfoGu1qRhMw6M4I4xdZwKBpSsn7MNnN3FhZx2BC6GOIpWdVpRuqt10UX8614jPem4q0Zfo2sVlMSYDRgydrKtvlpls+EPU6+x1DmkoYgiOX7WRgIKVqCBEQx3uECIQhUsatJwI2sleBhEDTIQgiYXtxTZgOVQQKKSQ1CEIQYxt7kNQhB8lzvfiTf3Bhz/eMeb+yAvqMG/LW/5gAv8acYquLg9r2ZkRT3LMSK9VEavEyxPt23NlW42JIjG1ydTvp/5+OzVhbn8TlrS/ZXTkhr/Ex5e1DU2/USHqGOXnSaW2tQPfmNcWa1NBVHjFl5UuW86Gyije7jDuYvO0nntfV+Hf/sHS9TTjzFsZWMIQ1dXw43T/2Oq69bbWt86a6mdtYpeSAk5iIHZK4B3CcC7tEsBHtgCi3otuPs8PGCCu2tAJsADnFCJoIkIhGiywVMIzFMPo8kVhUqV+siPe1O8EtiAEXw8J0uIyfM3haC8lmpBzGsCGLyCGJzBJsiPGpyCKQCDHBwtHhSDHdQjeIO3O3g3gisVU6GQBNG42OM4xPmX2vMUtco93UOTdqqp3dAG3+M0UeAwgSGlT3G5UAunQAMlB0I+mUu+5lgnc4KHw4qP/8XAhJUJngUBhcSKtdzRvvHDw1u7LFADP+bgwxIbMUC8Q88aulYwnwpRP657O6ybOvh7REikOhdbn68REdSygzIoAv4zOxAAAQn4RFCUAA5AAQLMkLcLN2KbOzSggQyAAAi4OxtgAhyswMJLDw2Ety77ssApD75xtY9YM9ogs1UBQREcwVocgVo0CMpbRhRMQVd5RhV8FSNoqX7rNwrkN4ZQIG30ARcEODBQwkVjwtSQoCSqoSkcuc/Rvbbqnbz5wES4mHSqLzAUwzH0h+vThSdCQz+5Nda5G9+pE+iLHi9KnZDIw8caRITsPj9cyIRsSCrKrK+gBcE5H0W8kEbkOv+ti79I3Eg7iBpmoRpLuEQpKIIUKEkO0IBQXIAGCMWTNIEokD87UCm5S8WZ8IEGvEm8K0FzgwI04KKc8SVWYiOzIhxgBAXRGi0KLIhiLLwTZEYYSAhkPAhlbEaqxMYLVLtsxMrJY0EWbMElZMJjasLKGD7MaJjbq7RzlMLTKLATUgwKIzDNCRhRKj56DKcyVA5suEtT65hqMCx2hMPxOB7Eqj7KCgc9FESHZEjFVEh8aEyHzEM+LESimgqKxJA6KIPUaj+r08hhccSNtEwZm5pqG0kZKEkUQDtQZACVXElQrAAVUAIzyKgWwwPgSkUxaDIAHMEGXLz8uIMk7KXCDKj/MiFLXjocrhImCikV/OA33JQ8c4tKwyM8FJRO6qzOFVA87JzKraw8H3iB7pQ9cCQYf6wpGnq0s0xHHoIrz/gLbWDLv3zLUWAmdZLHdTC+B7nHcrKdKoo5ZvDLuPi9lVksVuAej+DCw0xMQNQ1xkxQx1xQBH1Q40iqZ5DAravIilwtz6S6KGg7SHyoJfjQJPjQ9JkoKdhQHjAB00TN1GRN1fxE18wB0+pImjxACjGf7tRKZwSDM/iylDAJ4ewmRwsYXyJKlBs4eWOCWFFKplzSZIxOJm3SJz1BqtxOHQhHsJQhsUSLReMvhErL3RurfsSX51Md8ptPzZjLMEyw+7y+/81i0zXUUvf4T06TmZMBj1Wwvvk8UAd90D9s0MX0UwhNSBCaTEQclvSxTMzkkAzV0JfEkA19VBNdAhxYRhKIARwQ0RMFAv7bxJO0gJRsUdYUxQ6QgZckNlN9LRq1TTTANlb1gSETOOBakB81TPnEjMgiTuIsHEZrvl1MECOMN2ikxexcyigtVpyE0ilFiK/kOCo0x7B01vOcl8RITyJhqzDtCwqDvjLN0zOlS7wKJTZ1uv0cDumroNeY0+EhSAM9SLxEzD0N1D+F1+/bLJ2aULpLRIiySMxkAzWw0BJtVEeFzQ3dP02cVBI4WITVNlJcWBQ1gQ5AyQmggAZQTQSo2P9QnYBRdYKYMLYZpU0khDcskMEgJB9EiApj+JXm+rhaLSt8wtVSuhtzPZOtigqPALMihDdWWc7vQUEjgJX+CMELzM6rnFKbCc8s3aHEwVIzeY1oRU+mVU+JASFceM87ssNV8itRIiU0hblw7drq2Ec3Cgs6gsM4hMJJ4YVTc9d2fVe2bdt4lVeEnJvoKlQLvcx9XVRHfagtMIMSDVFMzYGCPVi0Q9hORDsN4AATyFSIXQCKJQDHdVzWHEUk0Fv1MVXatNxBOAMtwMVBSJAeLah1JUuXJUcrLUewPN2DAqaeoQ+6yEVfNSKCu1mFOgSFygM4CB+QBbgW5A/UhVloVVr/82xap/1SawUsbL2eXLHa0DXTecwrzgpXDiOO3SgLL2xLRwG+/hwdr1Xbt4Vb73VbQtmpbJDI3PJXi1ytfq1ISI3UKABc993UFEXJwvXEADxc0zxNC2Dcin3cx13JFxXYIJMJzDVVXIxV6PkVmrlaWuWw4WzZ8hzd3oXZ1PWqYHKZTOgZTcFgJGGF0lFdUakLI62VATFaf1xCH+qcpZUwqC054q1WtcAYscXWOb0T+QSoLtSMbUjTu9xekskTV7iY/rRegKRTGuY+7u1e8E1itgVUpJPQ2SrfzsTIzPTX9ZXU94XfksSB0kwBwTVcT0RNDhCBEziBh11N/u1fUbRU/ydQgh4UYMxVKPtB4MpSYP8SXTt+QrKC4NIlYRLq4wlO3T/24zh1D0KuWd8bBExYVmZF4aNNYRVeYWmFnKjFtGtqlAIJUFbIYyEyjsfK2qw9MFybNc3iG4Pi4LcAzIDkvSNW4nn9XlZ+ZeJgN0aCYtBctn7VTLyF1H8t2Pe935Js2Ibt4k49XMQlY0/V3wNI5gRY5pUEAVIMgiyI5gDe0Ul8mvFRhB4liYEKThy6Y28GDU3W4z1WZPgwiZct56JFZ7sBznRuZ+mxmbiQ2Qh+VvEET7N04SeJHFWWDbk4EOTFZE1uOlrtsKw1o7wMw30U17r64XIZ26V5I0RB4sWEZf+KTmK5EYZZpmVbrjYas1tHLNELAWn9y1T33eJR1IBf9uVRNMlhxoAx9lSJ3V9lXs3B/YE1nmYi27x79U1f0WZu/elvDupwrmOhfmCjdmcv3LhxTqOlPuebieDe1bgTZtYV7hdqxWf1bM+MkWFUCdCOYOo5/rDNOGgyxKW0ZZ0NK1eEQmWUQVuBFpSKduU/jOs/TSpSmE346+iL/GiADVge4OVePs0uRthRNc2H7YDDdmkMOGZkXmZQRbtsg2aczuk3vjI59mRuFuqg1uy4DFLPVjSVxeOj3gzSBRPD4WN7JhiphhjTwWp05C99/ozGjI3DyKaVGQVyRMzrY15YaF7//RylJVroXxglN/pP1AGjwwlX8aNruWbud5XebPC7RMq6iWq/artlvla/f23fvybpLU4BDBBsL27JkyxvDkBslCzjiW1sxpXYk1bjaNZc+dbpYjEFlPXpG25gzi66oR7ozs4+b15goO7C0Nbkpv5K2Ett1K1n2Xta1/4XJjkQF4YNa8rCipkrXqAhT/PvZjoHpkrDq725H14G4u4dd1ScPbGsJZ7ox2zuiqaqTLprRtIDZZtijMxuR43U7tbiE81UFBVvYh5mT52AISfyiF3vmVbJ1hTsHZBsnHaozcuEA4Yexirwza61TyPqOt5WAAdwG45HAbfVoj5wo1bwBb/S/9aObcbhF2eQ2iSxowu3EwVpnqMzTE42KLLexxAXcbdWa8Hinl2Jk4h2cUJPYiYW1N2YMl3QBbGjcWejKOzO5Sre8b9OXGBO6fE23FD8VPbeX4lN44W1AU2N7/mmbyk/YKXO7wDvci1fXg5/9QP98jyF9TAf8wNnZNSm5951cHy+6gf/6pNbkjKrmLYI27O2DtKGB+UDcxHH7VI2cQ0D9kKfdufeU6n6BqdAhZy4RH5tv0AgUYysAkcV6V2mdEpP3L8+gdLM9GOO6U9sXJlW5k+331C3aVJHHyhniZ6jctAOTjFf9Vbf8oA3UMgseFmfdVq38s8mc6hWZGji9V9/w/+Ij4Zgd0s4NyJ1ofNjJ+5NaSJz6HAQh7BnpxPok/ZWZnFqr3bGjAcpi+5FZ/RAOCTrfp9vj/RFJXcdP3d053F1TwHzhliUlNgIEHp4198IYIBPB/UstmknL/XKLZV9r5t+FyiAH/gw5/INt/OsN/iDT3hWX/jRXm1yFvvOeYs0h9qqzpLIUHutbgdPkGE47+q9IKItf8jqbbrbAflrBeepFWLoy2RuUvG5lmjB59NDV3nniCqXVwVLCMmaN6TH90xx31vKF2kQvWL31flNfFhNh9gL4HRPp4Chl9gL6MRnZlUnv/fxObNT5/cs93o8ZPUy3Xo+bE925XpXT/iwB3v/cRbHr65n1MDthSGis9fn0wkwCV97tqp45L/4+iBPTWa6aoDCYHjrwmx2IJYGcxUSXXHrwlfQw29xaif8Pmz5YQAGstH2Svj2GYsfj6b8ya/8kP5Qkr7i7rb0SzdsIS9yogeICBQkECyogQMKFTKC5FDiBAlELRIniolD5w4dPKZacWQ2TRrIcNS0kezWzuRJkiffqWyJ8mXKlSJnslQp8ybOmjlx0uxJ06WzkkFDfgRprOhQo0lJJrWFzClUXlKRjXpq9apVUVRFabXF9SvYTqPEhhW16KzYtJ0wmdXktu0oUDZBxQWb6OzdvG9B3VIWVJy5eoEHD772kZWrZCOR/46MB+/cyLFHqRnri3iV2Tx5EmltPO8z6Hei6Y0uje+06dSqV69Gndp1a9eySQv+9g0YsGG5S1kK5LsO8D3C37jZYvx4FeRllkfh4RxHDhMnGjp/biL69RTXeZjQjuIg+AsHDYonKB7EwYTaGT58SJFixouUPB2F5bGoT5gmgerc7z//TgHuZBNPLhkG4H9AKbXgUgw29SBWU0U4oVRVdaVVWWppyBVbGi7C4V4fguUZXWHhdeJdXEnoGWi1QVZNNckgZt8yv0xGzWPwLPZJVSPZeNlYiWj24TQrhRbbbKwpuWSSTDYZGzru3GObbrqg4ttvWAbyxh52sJFGFMexkf+cFMot8Rya1am5HXUybNddCiQgpAF6dNJpAZ7gaSCBBuqtx55D771HxxkZ0dfMfQciuOho2vSnjn4CShoggTEttqiCQjGYqaadNighqFNVRaGoKmZo4qlrbQjXXnWt5EldIKKoF48rViOYi7g+ZthlrARj40eA7arNWLz4aNllmBwiRx495nikk0xKO+2Tr1VrmpTeeLNblsHxYQgfXRZnXJjIlcucdWuqmSYP0EG3ZpzfzUmCevR6F++fC1EnaBbwnYFRRq0gmihgAFpa6cGTKixppAViaiCnjHk68VKhZmXxVaN6BRWGqaqa4YcnvjVyWJ7MVdesceDlh4hyVWb/42C65jpNMLVaFuywzqhYlKh0Ccmssc9CSxuS1EZbtNFITulNNlYyIi4bakitZZdgnmtumWWyu24P1E33LpvW+eknEGGL3RB7+0oUJr9jABzwwIpCyih/Oi18t8N5551gfhH7/XfGoDqDsS+gdpxqWyK2rJaIq7bq6kiwojzrrFzVB+yzMjt2zS+pYOarVB/lLNZkflmG2c+HBC300Em7jvTrT9KWbdOV6KHHl1knxyXUZGLNXHPcbdd1D8ET7/XWb95bdhFco6lvm+6xLcb0/VZUkRkBC4NowXP7tHdpeCcMfsN0f29+ShCPD3hUhTuFYeAWenUhx4ijJetYHnZI/zJZLkceK+X00jLT/eoa59CcPRKoI2b0KjF9wc80SuSMySArSGuQQyekwbrYtY6DHpTdbJbmDdvdbkxqKhOX3DAu5eRuOVoTHvKMx653qal50VnPemzonDNFz2sTicIP2zaG+GiPe91jVPhEUz4lJnFJlOIb+h4mRaLs7VKaah8W3cexwnXifV/ZWFnQcj9WBclx/CPLX04iuSAFUEgpiktkfIWNmOWjjnbUUc0850C/iOMwO1PKLUrUCc00KxobbAcIPzi0RFpLkUsDhu2+NCYVgCAhPDBOCVuoSXMVrwhmK97xkKdDG7bphtDjGtrY1JAfZs961jPDGGIZS0OFQv8Yx4DREXN5vkY5EW8IuwmnfEk+TzEMmDbJYhYz1sUuevFUQcJf/vQ3RjOOwiUAbCPLWnYsGtVDgXZUYB9nocc9HkicnTnW4HzGrAwi8pAdVGST4tlIosGOdQnUFiRxJ0lKaudcKizOl1bouxfGEJRALGWagofQhayHbTzEjirV1sogvmeWf7BDLYdxS11y9FG8bCJIf6kw9S3xblAk6TD/g8yVqgiMXyxL/vAyCjFeM6YjcxwcVSJIt7RRZHyJBgFv5c2hhnOcyGBM/hwU03WyyJ3vrCc9k4QaeUa1qvOsajxEGMk0cFUFCMlB8TCpwqiRdaxpIFMnkdcCg8rwhED/DGUpG/rWNKXNh2yDJRCFaAYvRYIUujjGRuWmS5B68KOOihRK17fLkSo2pSrdYjK/6NLDwRSAiSsjNM/Yv7qkUWeJO4vKTqSybBKpj78ooFCHCs6tfG5BXxGKZfJHyKO2s7ZPTZpVc0tVRkK1m+7A51Zz59V+cvV24jJr7tBavOERj63rOpNDS5nX5mjnkg9twUKDyFW8uvKVeL3oHiqBimHgMop2I2wvYWJYw1qjpCEVpjHJt76Wfm6lXPQFZWOlX8tOk5r7298f/8chAfZULIdiILBSq1pzyKi+TeGRy4JSIdk2y1FOte1tF6nbFk11HVL9MG893OHHPLIUkfCS/yS1MFywbsENWMrkmHwHSuxEp7nObc5bcayEhJaJDdRlcUKXcFCJcre77pGlGcrA10r4tbyLLWx6GyvS98q3yuU7LEnNuTFxalHLiNtvTTlDU7IsLn9frthnCZyI0PohDrGKRoxkhDkSf7OONXIFng3Ho9IddcLLUt2FM7xb2oz4qiIOIaFzi7Q641MVkcykihPCEDaoQhLdyp1BZwynTzq00zqujj+Ts8qHaoGtgWJlkd2jaiSzwQ63a3JHvQdlKl9ZfPCVcmL/9g4u2xe/5nQmmEM25g2VWbMjWkqJ1JyyN8oFRjU6rV9Ao1o/ek5CEMaF6eQiyGWJokiBFjSiR/8s7nGTu9wbHs2I76ktp4lLEb/5sR1UUekXD9S5J9jTV9caVt1ljbpdy7ELUzzkHSvB00G86xL6FahVw7LVrmaEIgIr2MLMmrBTdq+tZa1xxdYay1Ck7yqw+OXKWlZVPi05yjf0qTQrexHZfO2LkiHnZRjQt9+MkZYlpCyN0YUXyQZaU28iaGzVuejmNrc/jj7o09RZhLkhobsZYQlJ9EY4llAFMeQ99TecVQqZTk4PUEABBkhAIV1jsdbSDt0cXy3gc5Wuwb8Ly4Wvulx1kLp4YT3HWFec1reO8nod6zCPJ4jXeW4fmP075jaOPLN1ORSxBnwIvUye8pX/iicOiM7/Ods8HnHkdSAnr21YsVYUmmGn+J46VaPfUemtZ32IE41Apzst6oEAhCTG24taEKP3Wu9NjFkY9rEjYAEcYK7ab2zdqxmc1GuPO3cjcuRyYfTq4x1vMyS+94333e8Z937gq9jxkxq+2hO26YYYx6NPFPiMxW7cZnPKlJiqmc0rE31cNL9N1DpGV9LwebEE0iBVGC6UCMoAXTttjjlgGLgxXTfBnus5YNL5wwRCIB1F4JQsDTE4DZN1YO7pQjnwXgjyHipQXe8EXw9wQAQwQPGVnV2dkJBlWtw1HynpmKfNnapJn90xGSqogi7kBmA1w/YNYfctyX+c1/cx0ZOZ1xS9/8Th1Q8lRKEU3hT8sd/H9NQbbdbiVGFZaIPJkITPVJ791d8cYB6OxNyvFA7NfUb/nQRrTcXPiIInIIYBzpQccAYDDlYuXZUFRiDTUSAg+qHspZsC2UY6eEMvWEkJTp0HYp03jCBuaB0j/FMKdRUIrCALDkR11RCQsd0Mqh0PgVrwFFygRB9ESJ8TSEQaGBcPXh9gBRb3RVURxiKVUQsT3qLGKYg4zQhi8BQV6o/JrQUW7hyPKM7jzBSwPVjlLWPLcRvk7Aq0uY9iQApogKFXHBUoHMIXNEsglYg6+UG3JSEf9iGHjVsFBiI5YlW5ZZUGkqAiNiJu9J7vnQLVVd1wEP9HDohdCKAH8fGJJbkVqBEcDRrcc3Vawh0kECSkQjaPKqqQ1U2dKwYhEaqDLM6iRQIeLpoXL5oCHU5hAJlcM7ZZNl1e46CFI+hXsXGWTm1bM95fGT7j5kxQGvLfsABgheTBNnKWAc4BBvWF5gnIt8negrVeOWrOaQAiOhrluRHl6hVitmygIl6f9RFDOsjjtvyePf5T2H2VceSAnaDAvnyaKIolWZLldSEkwRUBQwTBDvyAW6aiWBkXRGrdXwnhRELVRebl36XUO3AkK2wELGRCJgwCYRZmS2JTmzFjfxljFPpM4j1YZgxjXrwkXTSGAg5O++CMG/pcAQ6gyqxRkPD/ZDWxSB4qyaGdZjraE+shJVOq5iCqY+fZwyFmXVReXzxS5WxGotad4A31QBUAQrjsAdidiyc6Tyg5TygG5Ayp5Vq+JUMehwq5Gx/04DvW5V3mJWzopRLeomfcYjkwjTBwxGDeAcsQ5mEGkEiOpMgwJjLGRUqqZDvQn2KGJFv03Ble5kzy32YiQ2fy5By0TF34Z7OJI9GlJodlTtMl5WsuZVHOTv/ZxgbqJnVqCzSkQ4VCg+9FYnBhGiblHiP2DvCIpY2NqA7t0HONEikpBFu+JUO0gBbE5e3J2240GTpcZ0Vq50WGAxJyX0Yq4T+wAzvow3cKw3hihJFK5mSm52Su/yd7TmHiSYZcwMp8IqmFDKgC8or50VZN+tzP/Od+MZVnUAOc8V1poiZRMegdJR0+sKZSXmCbriM7itAPRmJuyOOFVqiFzuOGiskbiNe8gSjwFE+pIScnFiQqjVJzumVdvWiL3U4gPALW1QJdWqesoek4oluh4SiPEuh2HqFfAQM0BGmQZkN4mkJh3sFZmCfloKob8aR6MukYNeYzgVmzRVBknmeSaoIE3eeWZmk7HYsmiKRojowfMAslHMU2kGmZmumbuqZSqumatmaDPmsfJlA73mbvHWI6lAM0dGuFymM+IVfUDEcgLOJwSBKHztigqpUosWu7LGcOJKoNAIpE/P+THsRoL+RrL3zgX8EiXi6dueHWuWEkgZYPIhwsI2wEKmxrkB4iKTjCHwzCv9yFqrKqSyamxTYpFd5PSg7FUo0hYv7nHMYFLghLjlhDl6XCLZzhYrCCy/mn/QXrBbHCpSgrNRIGszbrtDprBPLsggolhOJTVVpoOXCrPoTq0V5o1pkYWYkVk/nGh7oauobo2xHqQm1NirYJW6IADDQnXDbqveIedQrCX5WtjVrqzyrdv8Ye+FkKLW5qTRys1LoaIkRCLgBDOgSpPjANKXAkJbBqxqIqxlYsTbGRR4bMk34prrokHtonrxaV+RlINsJsHITWy67BIpRszaaem77psu7/bNqirbQ+4D3hBiJiKJ7qA5ACKTQIqYViKNMCFFexQXh9qG+gWB1MrXLZ2NdwYnYs5/No7bzagKQpRCqeAUA5JO6Jbdnqwt6J2KWK7s9Gr6Ym4RESUcTaAR5s7/b6lbYU7T7wLUdm75EObuDKFDLCKhcG25otbvuKnjbYpLf1arUVyZgawyhQrqte7hckguZu7vdNL86CboNai84+6846hpTgJiJSpZCurpB2a26SAnDM7irqgfWZK9TobqCmlbsGb7xerfDKQPEO7yqtIiXKpSIoAiBE3F952M0acOjO8LhFL8C+DqfCRBlkb8S2Wg/Hx8GaQjZsq+uKryMILhyU/6fFZqzhCtvirUqyTWlLjtYhaBt8/mSD1e+l4MLlzgEaoEFiJsIafAHmluyN2GysBeUBqTHAju4Bo6YhgmvvrS400GOkLq0lKEIKu9jV1UI9AuomtRXWpkvvuokIp5JCqKgih9oe22vZ1mgM07Akqy2mEvDAVi9K9McObzIdcDL2AjEk0ML3ui4w0IIpHLHgEu5ZnCSszpQYFS5Kuq/ludnISoZHUFwWh06wTK5/fjEYV+4XPEEZEkyYFtPEhcZPQovJMiAbT7IlP2iUNDCFUuXqEsMfjIGSPW3VUKIbKEIfA4MJVk3XLccm3YAg98AJNJcI/y6NbVoi5wvxuqgqiv+VCt1uN3vzC6/D9lGvIDozP2Nyev3BcmTEQBc09mJP9mYUEX+nRp0yxMpHqkYsK1NpGIEskl5eOl2xYGCpFleGzO6vq/IkGWfuGcfaTCgKBD3Z0GnYPz8zVj1o0FKlAwcpMJhBEiQBkt1VmHTzVEpi1YiJC/XbOc9YujwPDh11dsTJO6toEKiAPAuqQ2YJJSpCK+RzS/ezP1Oy9KLmShsh9mZPJxPRd4X1LAFM3eaCN+xDETc0KJAvxD40xwrbFR6jRV90itAHkMgRFgeDlgFrL/tyEs8BGZdxSXOUrqHxSezK50KvDbs0s65xHINrhQIpMNhBwh0BQ6lovWJwpIL/s6XpE3HeoDkT9XKVdlG7izsjNZxwAEKYndq4QKlF9W/Yazdb9VVjNW4zaEsPMHoFdCcP0SeD9ViDNaoSSqH8gSN4Qi3lLZBWZSl7glsbphQS5uEWWxgPo6ouKUn3oq5q7l7nGbBsgkiuwRWsQRLDwRg/QU6esRV5ii9QzBJyKm879gyrpiHSqbd2aynYdFNT0j5WUpiEV2dfiXCMs05D1w1UR4IbJ4lKBwy1c2qvWHa06NrYHe9cuEPqXc5udW5rtdGwLWPDsIh7tdzNEiyFNVlP1HBj71njrZAebW6YcnLDdRQidysnznXb9ZLSiMvCpGk9hflxsXmjN3kPeXr3/y/ktcRiPMjgNIiBuG18y3czv3GUUElUaquFnoJlN/UICMTx5cAWBMI355NxcKhADjWDa9q7ZrYpRfhSG+8LihWG384KCwwRdjieZzWIG9qIC6xomLhwt1KJ41WhDHr2WAQRHSxaq25ze0MuOHRys2rEhqwsazfL0Cz+tkoxK4NNVgZ6E/kVhDqRG4Ewk/SNuDeTO/mTS/l8t3pRujoyizhkf0PZkgJvmG63EkMgqNgFUMAHpECYQy3VVdqJ4Ri5DGqcFAGaK3g6NztcIXWbL49XtXYic1oVEEcjv5rz7nOe6zlXe3iIf3u4X/K4s4ZwA/qgU4+KnwFCG3ehx8csKf863q4uTW+DeKby+b5svu97dgPuJlBGL4rIA2FxKszHLxyxL4e6qB/5HfAFtklMk5MKUzg5q9cin3f1Gs/6fc/oKYCrJESBf6MAG+DeXDpaoybXcVAXCQDBsi84KKnz8MgADEm7drgznKwVzgePC/gmN9urtnO7uHu7zHT7De/2xYOYiaN7ThM6obM7kqk7khFKRiBZi5cDO8iD3pLqKUcsvo9WvmN3drPMUYShwP9CsiYr/m7CRtxBwpc3FEABHFzB278ktt1MyhqeFqn6xeVwJA/NlOPsHFW5bZDDN4TvVcpx1rGBvKjBIzQ+uEDqI+xBgJcQ7lRib7KLszN75oP/TbQbskK4cwuIQLO7wBaQPlBfu2wLx3Hdjp0HPdETvZ8L/VYbutLPEvVA/dOLgbtHvdR/ct3OOwSDJyQ8dOXiOxaap+jNMiYYAy2QvcDfpzEIZmDGPRiUdxBAgQ9cPxQMOSjUMl/4Wn1lJpPnGl+2rWr8fazrsxAOvlp/p9AifiDk4xLMpSHQ49ahfHKIi2/4GI0BRI4TPAgW7HHw4ECCCnmYcCjQYYqIDx32cHMRY8Y3GzXyAeTRUqA9ei4qytRsXUp6+Fi2dKnyZUyZM2nWtEnzXU6WOnmu9NkTJtCfMseYKXoUqVGjYpY2FfM0KdSjcZLSMWPVKB08iEKRAqaP/x07eez0pQMmzNOfP3fYth30dlEitnLpYrILl66fRMZogYobV68mVsyqxTuHyxErVnfWrLnyWEfkyFCuxBmUGNSoTppFbd5sC7Qv0c5Gk9bm7HRqbe1Ytw73Grbr2Dm71aY9G7c53fN4w/P9u3fw1sJ3n0N33B6/fcvLlTWbq9IpYtOp86kipY4hQ6e4GwrEBjz4HCpyREEYBbxIKQbZ32jv4vzAiRLJTzzhosrGLl3e7Of/xiOPvPiIQEkMPLCSkfTIhMFkghIqqJsknFBCCCOEEEMLh9rwpaiUcqopEKVCakQPscpKLTy0YqSUYdIJS54Yy8qGFlNSdAuuuSjBy/+uHuWC4w6+/NKLSEoG2yYeZhRbDA4mHmMiiCAk84EyNNiihDPPtBQlNNO8RE011WQbM7fbzCRTnTSLG4444IBi0zjk7vlGuX3SaS4db84qpRRg/KxFFVUsUQO7QLZ7hLs9pLhu0R5yKO9Rg8Bb7734LIVIoIYm6iAFDEzoQYiLuhhwPy8GHDDAAgE5EFEER2JEEZNguZDCfGy9tdZcKaSVw159zfWMKJgao0QRnRoR2WSPwqoorLR61o49SOkTrBjHKsebY9BiMEcceXTLDzmCNGbIIo3kS5hbQGEQDjSeZEKyGuSt0sq4suyssy6/9FJM2VZDs8yABV6zTd/gJPj/N8PmdIdOfZhzOE89/+TzEe/qWFSN7LTzTqSMCS2DUfQoXYLQJcy74eQeKHWPPYbsi4jTT/Pbjw9TAbH5oz5ULfBAVFyFNVZYWuE1Ql1/NbpComPSEOmWiv0QRPNIpILqqqsmluqnq3o2jWdT5Co6b8qBUcZedDnGJDzYArLbuvRaY1xKzF3k3HQxG+RdeCMbQd55H7PyXs5mQWbfMP9l7XBqAMbNtjMHftxNg8UxDmGF55zzYYghhiZPPyneI+NG86vDUJEUrMPjkThi9GPRV650IflersiFGfzD+eYBdd5dEt4NFMRsQVpN8FVZi/bn+JaQxxUmXO15vh7npcdn/3mWqjea6eybdslYZbMo9vunrp7ae63L6JrrrSCJpBIXYQRHnn/Y+ebsTLrFkUi4cSF37sGM+WVJcqMMZeI1Ar75DQxzuExmQMELwhUuNrVJ3OIoqKbGQS5gBaNc5XzDsMul4x6Zu5PD9MG5iZ3CYiVzz+g8ljEruG50qiuDCxuVsva47ASfwpREeCCE69judqcq0O4q5rsD9UIQugiUJCpRCTe8KhOt0AVKaHU96q0Def7Q4vK2GL3pefEmVtzer5S2vSx074xQC9YSwieVNiJrfOUjlhrRV0f1hW1sMYLftXRhI3ABqV3660tgRrGuBqrrbmBQZJQks4IQlKAENf8g4BcUyMBRPBCCqaGg4ibISYFd8HGTs6AoD8bBeEBvYamMWDrsNELndK47fAhdClaIskWNDmRLyCEPRDbDFrbOhu1pGUUiIgX/HLMLAiKDF8IQBiLurhCrEsSqWqVEA5mueLCgIhiV103lbRGcXUTlrcb5RXNe8ZxjVOdQhgWiNKIRa+ILn9XiKMd40jF9W7HDPmOFiq+IZY/60IUi3nIGQIbrC3tBTFwS4wlLOsIRpgBFHBbppBdc9JGQlKSTKnnIwoHJcBJEnL8i6MlNgnKTpCylKU/5vHvk6XIhfCkrNQdTiQEDhRargnt46h6T3fJjwsRO6F7HsmHGLof2scj/qUxlM5vpzJl9iGY0ASFVqhoompIQ3kdi5YZYBa0ZVMxiSsRoq3BukR9oTetay5nOc5b1Jg8qo1tvEs93KktYSxnWG+dZz/K90UQfyidJCFsJYAAUfuU4xhkqMwggzUGQjtCLIR2xiDhMVrIVvShGQ/ABA75AkYBTDEhJ+y+RnjSUqVXtSjXoxZh+MKYgVM4qPzidJWonqLw0quhaxyhbjm49RUUqUh0iu4pYQXfObGrNdufMQjx3qn2YJiC2St2zGYhAgeiCIvoTNCnKCYtkrd5Z1bpW86YVHeRoK/PWGcbk0RWdSturG+3JV/tO4b7yzC9glyXYrrFBRSpKgx4i/6GLf8gDHPDThWMNGshB4EKiiSikXxQJt7i4C14WrQEkM7CBDJRgBFW6A5ZMsb8wlTakmlwtax2H2lGq1JQu/SAIZVvj137Dg2KjjqBwW0Oj9hRjagDPC4d6y54K06g7pAioArS7mjXVmWGYahgEQeVoTvO5WqUmdrmqCAK9SmjHQAcXxUtOs5L3vMs5rz/UCz34vnkmZZ3rF9/rvO8dS795tet+nUBPP/95v+ZDEVb+q75hsCPB8qgFQRscWYai4QuRViBjwDBJeZWgwx7eQCSdJAbMHpKBtsBXvkqzLxR3EmBvavFuCrMmGLO2pTK+8axnzTA9EQMarwDUxlDn4//YrZCFb7DCsFl3ZCQnRHYtGAh+AKQdAvmnyTqD7lSpzTPsenlnimhiJVrx3TGLU4xoVs4/6qTm8zLMzW5uHlzXzW53wxne9jCWsOapVz73FdD5xjd/SYRPNf6BFOVIdDlawRY0zCGKnrhwpSXtB3dBAeJPoMHEMa3pTXNakZcVXOC29JnBhUZfp5ZGil/NYoSVHOWUU5gHX0rrVOYYxzG/EztyXYsiemfYvQ0uUD1G7CoQ2dgtO/ZB8pMqLwRRd7sbkCAKMU2mS5e6XCbQgLDdii2TQhHaTC8Xx8v1M6NVzeTeh9jrxNb1Ri7eE1KJFd89VnRqMby2ujN9tXDGPO//ed/6xq/esYDvfgv6KoG/SiS88Y8ElwMSgYziRCFtBIjPweGRfsLkKV5xSGrU8Qm0lyULCZpRf2IVoQ/5R0deelM78BaoN/3qTVoN10+j9ZPzpOI2iCTb237rLr9xzHn/DbGNjR2veEWWN2aI//yy57/M+QuDThCjvgDYrmt2EWXJn2RWFZpYrupznz5dVXEX21tmIilakXVsiLvM5Px2msc+9n+8//1mVzfa181NupYzi3JO+/Tujfe8873v9i4ABRAA/c9E+mvADitGvAEPrIQVTMGyJq/hGo/yJo4GJBAKHOOyrsSQlMETSK+0QFAEvST1VsFHJAz0Ou/jVA/1/1LPBQkDBo0B9mZvG2hP9nCP5XJw5dDNg2CuYcRCHopBFoav+LTjO8hADZbPhYbNEJTQt1YoCorqt1hHyNTAUK6p+voj2qjqyrJK+3YGDFll/Mrvu9oMzb4NetCQH9Rr3OKv/d5QzS7HMFTOJ7yoedJP/bgJlcYrvKwo7s4szvgQeuaOEOnt//wPABNxAAPNngQrF/SBG9ghF/5AMfAGA+UAEyGtMcIF8lAQ1CDsf/6HGqJBcWRwBlmP9GBD5FCRNHhhFkIPEzgREzmRSA7BbeoCSybMkhzoFGOQ9nCQB91BYYxDGOdwB9MLx8QmLNihGNhhCDdmmUpl+aZx+dbjBv+K7RqTMGR+7paqIDxc6AotISSwaSNAQuq0r7qqKwy/b1WaKOuOoYvMMP8AETnkJDnKbTnEjuzkb/7u0B/brevwj7zqDybAbf7air4Msf/+r88a0iEV8SGVYBEX8e/67UNC4UUIjl0mkG6wJBdHS5t8kTBooRdL8sREUIJMUhVNkgRNMBEOIQ9mUSYzsTEmsEjqwuNeMBl2MhRLERhvDyiBsfeIISxkgRu4YQhfoQ+WiSmp0Sl3atluwIfwI+doCPlA53QqQTvEcRxHIhASZFV0QfzEUgwP5KoIJPwAoYm4yh3bh07My6XIKw3rkRzqkh/IDS/10dzi8B7mEjiO4x//61Gc2koNB7Ie104P8bCcFJLuDJAhIxIyCVAyJ1O/7q4iKxIRXIRG1mKBQFIkfVIlQzPFVjElRfMaThM1U/MUf4FwRI8z8oImJU/SNnEm88AWe8QzGigVlkRoepIafJMUf1Eob40ZY+Eoi6EYJmEp/cMKuoAaeWuneGpRaMYIr5J0rtMr96B0vjISspJFtNJnylI8VeUKCwTbtI0PKuGrSGEf2FAe5XLMwEut9jIf8ZEfDxMm8PPr0LAwBdLsuig/ATMg9zMu8wvPHPMxI1NBKRMy66sixeAPcoFGPKHEZFAYhKHVbK/1YpAVO/QkRxNEVVMcUlOUTFMakKEFNeEv/wAD8iCrJmvyEmuyRWsRBbHkMkYt1HizxLotXfhkOmRBFowzwY5yEgqBDJaSDJzT56bSh7hx2Mqz+ACkhUSCHLOzO0sHaGBFS7ctVtbS6siSK7PtI7bryzBifWLlGOxyzcQNnOJTrfIy7NKqxu4TMP9xLtkU7riuvAYzJeQz3QxyEB00QSFyQQtVIr/nUA2UjSryDv4AEna0FS60Bl+PRFfSGi5VREsvHEgzRElu9jIVVEO1JJWBVHHBFRmoE2xxJmNTRmdyRm8RNq+EEiqLQSChT3qhFxohFmJhFxIMHI6zGJSSKZNUSZNQDagzmQyhEG4Ot6QUdajUO6+US4snS/+5jdtawR2tbtum5eqcCCNk6SKsdD35oRz29LzsUg3jU07YL05jak39sk5dKy7N9T7dc63e0+3UUDELVFD/ikENdSIBtu4C1u8W1b7ugEJLTFJjr6Q81GE5tVNP0VJF1UQp9kRZc0l2U2NhMRVSkPN0sTNglVU1UAwMSxYIgRAaoRFS1ih9FViDtUiR8EiLUFmj9PgyBpvSE5u6sw74hH2m9UyrtYmwlfy2dVq2jTt5ViM4QjtBpwzsgBTssj358l3HSj/vkV3dNc3kr0/9lF7XTB7ZcGvpdEDntS8XEkEJVWDXNlGzwGDf1r7QAEIRgW5LbFIrdWITJ2IrVlP51m//LbZiPQmkTNE3e7JwmYEnXZAVRkEWN7EyVKEXdjUWVJYTOIFlgZQTgFQWJoFzX6FIDYFzoSt0dWY/OCJ1sLN0UCcUSEckVjcUPKEOwCZot5RojfZoufRnlZa7whUrPWbwvqE52nVs31I/uzZrtXatqHZ55HP94tI+zw3ucm8v37XNBNM/GRFt/5Vtt7dtGzTQLAOiTkJDS+rFOsm0ShMV81Z9A5dSAZd9PzU0R/H17jY423f2/qey6OIt9IAofbVXf7UYOIFzBzh0CXh0lfW5dIYP/uM/cMsQUIdjWld1ZRcRejZ3i+dMa7dob/d2L5gRTod3mbYMhAUSdGG2WCmE/1BYTdGLheHVHqGX1qoWP9U1/+wz/urShMP2ePPUa832eR4zbQeVe4dYiBvT00bMf8oXlDB1fSV2b/sWikeuid1XNZl4YqcYVOeXfuF3NTfBi2sVFfTIV8FhHJCTjMuYG4ZUgA04dKNxBqxA2Hxo+lAop7Azdlc3dvM4Eio4FGCFWs8U63B3gzf4gkdidzui146ACfBAF/JEeM8VPu0wel6Y1mb4ctgMvPx0zKTW/cqOzdB1DTl5eteqTwHVtdIq74JYe4mYlbsXURnSjcD3FkxRpZYYfVfjiW85l7GYiq3YfHkZNG/Qfk0ScRFpNzNBEWohCGNhjMfBmc/4mQFYgP+B1HM5d5mEQAjgQ5vVYGa1A4Wu9BSe9Tr7+IIpOGgBudts12jJuW4/mLAIjGlRZwl8YAXOIGqZw05k6l77kp/JVpLnknjTsAa1RazCSZN1uD7hb59XOHmf15/xD5aLWG1bmaLH5+CeAomNYXxrOU1sGZh1+aOduJd9mYmhOKSDGaWHuYuXZFoid1dPVnKdeReKYRzAoVeRM4AJgYCNNEmFQASisui8+ZuNtg7Y2RO4gm7bGRLMeXavtSvUOXdfF2jeeSNkKAn45gxMwffatT3/04cB1JL72eyOI6zKuhlMeE9dGGvhj63frxfsdWyHVx6/+hsk2q4JFmArGiLlFqP/2eJI7tajA5t8ufhvT3qkHRakSTqlCXs1FcMUtAWJclWn20AQBKFyA7hyM7tyCSEMhsCzh4AMhkAInPMGRMAFSjdZt4M7+MSCr/OoY7eCjzqpkXqP6XaPg7aPa1eDh7YrlNoOlpqqPUYGQCAErsAOJFQ59Bl5+bmHCbOHAdOsy1p60csvP1mm4q+t3XCh41qGzRa97hq89Vq8AQ2j9eLBaLlEGWfVBnuXC/uwFTuxMbVDGdtiXY8vsNWEe+FkUVYQKLsN2gBl/7sNJuG/uYALPHsGEnwGhuCNPRubk6mbA2W1W7uouwJ1SsETsI6CGeF1aftM0Tmqn1rERfzD+Sla/0w3Coi7s7SAFrYalGXKHt5SLk0ZP3HML8e3GZIBJRh6nMrLLrNbobmboan3q/kBr8N7vJNce/m6Xi4DFzZavZX4k+CbymFQpN07vsMqirO8iolZy7scXY7BhGNEcidXZXWawAXcwD+bzUX7s0eFZioGUSS8FJ76wjE8jxO2wz1cqbP0UcnZFEZc0AEdVmK7gsGjqtVguDusBJyAFLLBG7p6nyu5yF2YDm1c5aA7x3ecyMVaTYFcL6k3lNe1Xp13opFcyVm5MgPw4DIasKO8fF0Myw27yrl8y99bpWFPW86mF6xlV216poN9Fyp3wAW8mTq7sz+7maxKO+Z8tVe7j/9Xm0IxfNqferb3uLdNoc9lN9trNxLSmdCv/cQJiw00IAIgAAKK2y17z8bFlrktfYbrdBgpGR2mKLplnF6vuw2zu5NDmcjFTLzw1B9OPdULvlBXHQv4OjEw9G472qNlndZxXeJLeuJNU37FXBd6ncyZ+X8TbBdkeqaD1HJRdrIJnIB3bc5P6BSKduUxHDq4Q88JXapnO8OlGtsDPdDZ55x3frZNHNFRBwTQPQIavYR572yGAeABHtPnEBuwgTVbgSfP+tLn/auPg6B7s3m/ttyAnKvBNnoBMxsoec0M/pXJXskf4ylkWaM5WsrXm71rfdbr29bde74p9rr0W3IRLMH/anrvP76MyxincbpyO7eaC4E7JBynnr2Jar7Op73l67y3lVrbgXvyI//mM/i2m7rnowXAokUKLkDoPwAJtoIULpRww0pSd/0Y7Pu+hYY3sR4HZW25ybqYhaYw8n2tyI0c3I/fR/ldfSOsdKPS78HsWTlKFhTtz54qnuIPHGHt03vFIL7iI77iHzZ+KfXoK5sQ2kBlhf3jZ/rvwd/7h71IizSrhNpn0p8UMhzD+aT9uYMWcqFGar5uP3zmz7RWeb7Eu7TQAQKRQIF/7BhUw4ZNCgoQFETIQMMJnkyZTJlihZEiRlgbOXrsCLIVs23n0Lk7eS+lypX+WsI7R83Yr2Qb/5tha8mSJb+d/3r67Lkv6M6hRPnZM3nUplJz8I7itKfSidSpVKsqsXo1C1atW7tivYKkKtiwXstOOSsWbJy1Z/6YikZSXDW56rq9s1u33d28evv6DQeYr91rhAtbMzy42+FpjAM7frw4seTI0hRbrkwZc2PNmZ155rxZs01dunr1IiSojeo2ly4Reg27USNCsmnb5kRIdZ/dZAz5NoRKVfBcpIqHMh7K0ynltGg9y5XrFPHjkQZCsmj9uvbt3LsLrFPHep2CbMBH0eAwgvoMK67AeX8n0SE/d+APShQf/yBKjvpr/MjRMSSplA5L6RRIzlPxvNTMTB81A1VORQnFj/9P+wBF4YRFobONUswsYxNSOBllFhUmnphViSqaNVYTLpLVIloyYrHijGLcuJYjuFATF12Q+QjkX0JOltmPgEX2I2hAElmkkqA9WRmIy3wWpUycSdmMLuT0Ik8sscjWSBu5EUFmmURwQSaaaJ7J5hBhkNEbIHz4JhwqpdxZCXKehHIKcrRI9ydxe1YHCSKmZOcdd3osyqgiiDAykEF4HGQHHQflcEFDDK23gg6eQgFqqE+I+kWpa9DHHyUggWRMNCi9KqFKC2LTYCq2asLKSBHGOlSGQvmqk1EpcUjrlFLWEyFONaKY4rLOpvUVjM9OgQZaON7xh45wwRTkXkN6+23/koiJyxm5TI4LJbrpVknluqB9w04s8sizi5et3avamWuuSeYQRAwBMMBv/vbIcMPlGQl1CPe553J9SrfnoYkiSnF3FB0kXqVl/EGeFAtpqt5DJXz6KQ0mn4wyDaPCsch+FbFy0UY61rQtrN7EmhRNm+C6Sq7YLLiShsBqSFSCCpoz14fJgPhzstM2C/XTLBYhrbQxSn3WWnd4wmOPiIELdtji0nru2GaXrW6T7rJr7No8hjgvOHLLvcs44+xyb22wqfbaami6GcZup5wCzODS5TJowp40rNxytOxJHKDJJbd4odk5Ynl/emSix0Sbc+7opIiEBx4iHJteEHh1LAFC/wQJQOA6BOwx4d57aKxhaqmkmjoHffmlmgklo2jSMvDO1QyrrEBX8yFGwuPKUTVIkWN0r/cElc7QOCuPNGNLLy09sv5gHTX55pt/rVvbdst++2e/j7aR8btNf7v2t6NNaFl+I4uXu+wCDruNox8CBCAAx0G3/+ENb5zAzWtqoQoIAmOCwIjOcbRzJ0+EJ1B8gk7jEnfBzF1OPJzTXKFE1zlJqbBSHCuDC2WQKQU45HURWIEWJuKf51HiPsXrIQ/pA8Qg+qF3ayGi8GAGl2256iTLI1aHdEa8Iy5DQOswSfV4RZTtuWRWSfse00pyvjBGa4xVI9+NziiGrYmEW4IJl/8bh5Q0IsFvjktSW/3Ydr888mgYwxAEmBrxpbrZrR+EJKQABTg3ud2NE/17xStqIcHCPSxxkFqc4RT2uMc9ozkXlFh2cDgQE6YwE5OaFClTJ6nxtNAMZRgDDizAkBmmJwRXwNx/VoXL4RFPPnKQw+162bte/vJ2iRCeJ3CBTJkkcUHZYCKxmqdDmllRQgjSYk6cUg9uIWObDrKJGL9JxquFRZwzKqM5raU1RwiDjW184xsn4z46yrN+iMFj2/JIpWh4Ix2n+SOYLnHIARqSgIUk4P/uVoxiyMKRj6TgJRMWqfAgohTKaRyeEEfR41TOkwQJJeZKicKQGqQMldLYeFz/uAQckGBTsJvhempZCUUwA0CtYNWqUvVDXs7hVLgbFe9aBorKJTOJPSoJTJbBEVTxBxZrZGbyUlJNa2ITWfNg3tIwYouZgJNZXNnqVIJAznKK1Szpa0VR4/mY7smPbGkF21rnOb+0Qcl+eswfj9LBji7VJm/3UiAD/erXBjZwEoRlqAQHNx1CPUqDzKGo4yq6nD09SrGZmwhIL4vZzJ5uYxwbwwti2BAaujQDQchEJUTSCpF000G3aK1rscqKUdgqqLIFxSgcMbwi7tSnp0qnbS0y1BD1qBU7VGpQWxWXVz1VVlI9yks8w4vZ2sKr1I0W1cKahLFml6tdPZEY6KAt/wYx5Z1GqiNb0QrXOdpRf/ZURl3f1jV9yAMc//MfA/maG7/xLTeEbcMk4FTYhk4QsZykrHVIYVHmKNhQHAVpfywLYRVq1oWb/UMrcfABkImWARx+SBDwkNoGKQ2ZV2WtiXNZ22TiYnGgWEQwcZc7YiqVZlmyaovz47KhbqOZzuyxc0U0VeZSlTA6s1V1y7dV7JJlu0xu8hG0iyO3INeo7XyreSWDXvKq1670nKt76XqL0LjqH3NDoALHgV+/pakN/wIYnN5siEkwNIKSZJiBSVcHiqqusRvFjuVCqVmRSrikBeGYhT37gQ2ATJYy5DBpTSuMEH/ZxNx8LS8sHVtM8P+ymEENc0yQ6byWDRHGvPPDfI6Yq1bJhBWOuA+qajLluMh61szcVZC5eI2rpuLISDYfWMPyayU7+ZxjTWN4cZ3lZFe5rcu2clzZC1/vKW3aePy0MhmTDXZwI5EELCBf9buaMLgZzoYohCMP+9A6MEKijF1cch5L0YiFcDsRDrRmS7oxF25sDEtYaUsL8DpGp6e0ipA0pSddaUuzlhUtI/UXereI2h5TxYsr7k5hDONXg+Q+wdT4UIWxzrMadUC1nmpTslksrdKIu7x+2pOvS2xhk5G7bvHEM06i5WZjWdk8Nxe0F3OsD0VaJqv2SDCWdm2hY6lBxyiNlxSJwEPSV4H/+OJbvsKA9ThN4hQCrnOf9qA6SllHg9UZVMUqa+9BSzh1+k5DFmCYgUYH/HUCSAABDjBwOliEJl6sNMITfnDnDXFURuDtITSRYqKDOtODx3gvi6nD+lwcDUDs9MdVjVwqem28QEM5G5e28pZ/89fAJrbpWS7WG9V8fTlv9nh7rvMt1/NDh1k6yIu+9wclndpLO8aWBEGbWAAWgVC/2yLrywnCErYQhYiznB1JuDpbohQJCzu7SbjRiZkys2oftKXsQOGEwF3uCMC73c9v/g/IwAx75/3f389axTvoEy4WZsZNHXHXJh3Uu5xP4zsORMPUW8WTaiomf+43EuEzcmq1/wyoB2WiN2ylJ4Ewd3pYMwZxUBDH03rnhTSvxxceCHtaRj8iZhOtMnQ1pRGbcEszsXtYQhqmAXxiQhuyEQsBJEg3eF+4UQhvAie+cW7EQAyGcwqBAB7rFnamg2fXN0IilELcd28rRFL6xgOtQ37md3foh3cXYAN6Bwt9B39f6EUH6FqroEs9JFsz0xEqZm230GKitlMCSGo+BXGpIjO4RGlCNxcgiA2hBy0Q2GtWcQSkV4Ez54A2kiNcg2xWhg2xp4chyIhH8nOdkVqt4CgaYYn/YXD3ZBOmIQv5xQWrMYOyoUDC1xqqgXVDwAIzIASr2BtzJn0JEwlHeBCp8x2RIv8QtgQ6JXRKaWcphUYHacAGvSiFRaABscRhcmcAd1d3y6gAWsiFXvh+nwF4f9eClIZizrMzn5Arv2BtiqdDoxaHoWIqkAc8qYCGrMKC0UZlheiHEeiOEziI8fhyqbcWe/IMrLeBatVOC+iIOtdlUpJalYhDwVOOahiGrfAN5RAv9tI3qQFupsgFAQMwM8ACQ7CKXRBnAiaE1BeLqtN2FsYxEsV9nUNKGpEGpBSMmZVvK2kGv8hKUcBvPEACVFiFWIiFECABH1Zw0AhmCKiJrYJH1vha0kU8uPN4iZBqO9YhJ4iNxAOOugMFA3hqmECHabha8GVU7NiONSKI8CiP7yj/VukUazziTh3YiGeJlvnocz+ZDKgVkCa5H3GZQ8BFYm3JdN/wD/NVg6MoG2oWkacIMCyQiqnYg8/XdYZjCdXnkazEWYbmmI5ZKRqhB+VBSk2oQm2HmSh1FTFAAjMJWshohVdod8xIWmlQUzxJVz3JltLWNkK5cZiQB1BZKnKwNaCghtEQcsyzePUnm+NIjqh2h0CpgHy4lVpJbF35lYAIlt61FuqTiGXJbCBYVWmZXvOjiZMoMaCEB3GZLf5Blx4xGgnpJePJkIA0G36DdemZnmIyCZyQUMXgSNAwOEGYbuABjAnxkS10WcCYCeWhCG5wkvgpoPfJmPwGkymVUigw/wJxF1qgWX6hyYzoBztb2H6oiU+auJrt4pqXhlWu4JThKJWqcptL+WmC53D4tx89g47gmYAlUS3VQpzFqSLImZw1ypyHuC0vwU4f6Ho8Op0/KjbVuTb3hJ2VqIuOkAaDQAdyqSN02SCp9YK90ImzkRtVKoN6o1+FIIP1lVALFZ9eR32jY59b8JL81kqY2ZJJagcoCaBKSqBvqgUHygNUIwN1KgOe+W8AZ5MQqox4t4yyQ6Fd6IWs6WWtqZpgiGmwRYb992IdFx/AGVwlanH3d3jGtKLdxBhncDtq8YAyyiwTSKM2Oo8RiEbNeWxqSZ2pKqRDahNMBQuOUiglVEr3Ef8fLtOkk8hUwoAKtSAIveqJnwiswOqJ4DaDXWpYG2k4R5gGB2qmZ1qmaSqMSfqmcKoFLZADVIMC2aoB2woC3Ro7Dsqn4Zp+QXAGO4klnVGog5qhPLmhHNpai/qNZlg8Etda8jc8T+moUTRbNMURd4AFMBqjnuqVokqwTiYGTZAjtsmPPqqqDbuBkAix6Ap0laFaqaWLJzQpbtqLtkSXIqEL5WAaqKFfwbov+cIFYSCsfbN85vZIGwkeHDmZyxqnM2ugz/qS03qfZ0CmO1utQRAE2to6FCC0LNWgATAAySiuezp3IWADcJAJFtpeUZuuiCqUwVl0dfg8moZ4opB4JCb/eL0UYyhKh0eUVY7woge7VQhqnGYBBBQ4sAXbqZQXB5TwFlQGnWbZPtRpV7K3XmxzmrmYObH6USakHa8KXLrwD3nlJbQhJjIIG1bquGICfLnBg1qHrHeymFFgFQa6BPzWVYxJoDQrui2gAqUbtCETMqDZaEebtAAQoaSpAmfwtCIWhv84pIc6aSNmJbmru6yJabWljVa5m7x0ovintcITafXhHgErsDMXqnD7qVWDIxEXa3frsP0YsX1be1HiEX4GqxNTuMBVKKSgC/MyL+QJWOk7dQD0GsuXdYKDrKdQhGOqBVdBNdvVufmbIsC4s/0rp9b6syqwAqe7aKq7ukmr/7QAB6haMLskqL22K7VT617V6H6Jmkuw9guM13ilhn+3Nwi3w7zgpL+FmFIv4rxvi8LLOaoIqzXqg489mqrXe2XnEsFT4hGSWR3e6x1+lhyKIAmo0D/gIHxDHEB2UzeCNEhRJ8TKxxuGECe/kZiBwAdEaJ8JEQUA3AI3kL9zysVFAJNbUAVhvLM94AJk3APWagIqUIype4wG7MYPqrSjibQMQAEowMBH58AQrMcSLI27K3/u6go9k1WXNn+ALLz8h68Y1zWmoLwhrMJNFjUjDMmS3Gtuu8I+m8KX/Mg36pw7SjZpCaShDHvPNrUfwR2dhMoScyjVAYvTN57/Q19QR/9f+NUIstAIryALy9cHPbgbBDPFUizFYccGMInG14oDXYzMZCzGUmDGZ5wDaGwCHSABDdDG1fzGEBrHVoi0DtEemxAMHrLHhBrOUutehkyG54zOgQzIFnzIbMibpgJfDAcGACvCamvPk6y2TZDPmczPmuyO/HYEAI0WGHiqDGvQMhx7TvLAhmrKlNixoeDQGGQKEAUJrawKXbKXiWRmrtEGWHeyWMcbb/ZmXcDLc0LF6nbSVmzMpZsCXDynx2zMPbCsZUzTZ6wCHYDTOF0BEnCMcHzN4JrA2ix3K9AC3nyuC42h4yzO0vCFHHoriKe1nZDOR0fVC9eht2J5qrZiFpf/NNtwDJlAz/V8z5RM1u/4vNrFz0sgIyvMnNiyIyIXw6Is1+jFXtkrwTd8yrA4iTGlHZOjMOUwLwCk0UZMCOImmILpBV2g2EJwAyLg2I99AzcgBVYAzOChBmBn2QhBpqTL0i+QAi9wAsecAnX6zFGwBc2cxWkczTrNARzA06JpzUIN1Ajsp0N9BYMgqLwXibvN20uNu33s1PAa1VQp1do4C1VdYsGwr+isaR1sgkXX1V5ttmCA1ssy1vr7cinluSa8z4981v3M1iWs1i5yI7WjRi/sgfSQ3geN0HuLNva0vbpWEX090fWdytcR0QkDDHkZywdUxPUibjPwAAP+ADNA/5GqGNkJruA3YAW+kdmXjRCafcWt3a3bygEsjeGlPQNlrNo3zdqtjdMO0Kdz/NOyXc1B7RAj0ASDkArgQ21KfUe/XWm2oEvF3Qn+Z+OC7HfS6As9js7Z2FMP5wfQo2p0YVTG8Adj4cjLed34rM/Z3eTZdb/gvckoEt6kei1vvbBzvd7snWXubdd3/TL2HZB7nd+Kxcq1EDewjFCELW5DYOAVCTC7bAgk3QVCsNiriOe/8eARHsY9oALTHDLTDOI33doqkMWJjgEYUAGN7uiNztoLwLo+feKVLuk9jeIGoMAQoOIs7uJHLVfjzLvAvePbROOzwLXFfXhTaeM9zk1g5v8LP06GfvAFJzMyD+cyeTFyrUAHBytzae3kZS3e3U3lxV7l3iW3dAvX651N6u3szO6wYB7jYKYRDk2JmHTm3VEJvaC4wpe+eDMmAUMEk+Crr7CyvkwnteAbROjnfx7o3/qgQgvi22oCLXDFpMvojt4AE1ABHWACjs3o1DzplH6T2WzwBbDpIwAGd2DUoB7qMO7bpR5dNW7jUj2V5+zqrg7rp37OQP4EJbABG1ACKvNwuq6Uw2AKaLS2jyzsat1KZR2B323s/izlLHcjasSPOvrsXM7zdH0ZP8/H39PQEo3KPazDihAItUCe9vU/l4A3JpsmgBQLXmruyjcJzYf1r+D/4O3OzGoM73BM6Pze0tbqAYb+6PuOASbgAicQzRMg8AMfmgZ/6Zm+zbLDBFvz6Q7f23rMgn8HW8Fd8Ra/6hgP69AY67LehmtgBCNP8n6AtyePCJ167JMM5U9WBqdgCDDv3TJf5TRvwjfP4rkpndC+8+0t7UiNod0bkEW/+okSCXPSP+UZJvplJp9ICOOpUFW/soVQC4WgClrPB1zvAjng2rF9hftOARdOxibwAI/+6IuexS6w6BUgmtUvoXMn93TvYU6b9xAf9HW5zoAv+ONf3IOMTxqf8env47alCWKrI/Og8yXRTM/wB2i78vAY5fmMA2qgbQBx6saNJUmWjDGo/yQhEoZHFhZ02FCiwYgTKya5iDFjRIQUxXy8M4hVtHMlzc07aXIdvJQtXaJ8eVJdOHE0tdm8mVOnNWnTev4EynOZM6JDh8KClQlSK1ORmDINRSoqJKpVqzIC1CtWrEaE2nAByyXMkCFEyJYlQgQsIUKyXr2dVKhQ3FpyVRUyVEdNFb59e6TQIIHBYAQGCg9ATJhDDxcnMFSADBnDAwyVPXhw/LgBAc6JDyc4ABp0BNGlTS84HRq0YQUJIoxYAWcTrGa1g17D7fP27qBFgRplplvZcOK8WIESNWqWcuPLO3U69Dz68+SrXPny3U1o9mREsX8Hj5TVL0+ecJ03lp7lev907bN5y0XHyXz69RdafAgxv/6CB6H140aN/vLDb6MC7zvQwCkU9AgMkBwxRiUJY4KJwphqwhCnnTbUcLvugANRvKqaMgWqqKCySilFFJFEnli84oIsFsw6i6y0biQijDDimqRHQ3rEq5C6HjEkLymORNKFHFIQjDDWPCtsgcUa66ACBxyooAMRPMAAMxEqq3KzzsZELTUnyzQztScheG2FKzT5kDc5hfttzjp9u4UXZJpTrjrmRqEOukCT0zM77bbz0Jrv4mRUuPQeZa8kd7JxxxtvSDnDPgQT5G9AhzwdMBBu+oGmjIM2VYhTVRdcNQsqPGJwQTSuQOMOR4SZMFL/CyucMEOcOjyUQztDPOopY0+cyqlIUlRqj17kkUcQFqadlkYbcbwRLB0NkWsSbuXCq0gjpSAoyccoIM3JJ8fUsjEOIstShcu4BHOCBpqMMt809zVNtdAK6DeEFYLYJDg6Ex32zoSLQ65PPx3uk7rpqivUUKG0w9PDRjcmzplI45mUUmFC+UPWVvHTNFWVE1pCilfA4eYUHED1NFabT4b1ZpDuMGUbkHcFeldgfwoWUYQzRvq8EpcuL1kSU0SEKkugkaeQGWaYNixst1ZL2zCCnAvIcPno4oYTeLgByROYxDcxzxKTwIQW3rU3Mi3rjUxMNPXtl19//wbcswxGuAJC/9uORnphO/fkE+JPHrZO4kMmZs7ioe/EDvGOiZP052iMaeoPOjpqglXTS8d55VcHrOOVU07ph1RyByJwI9LvY+KKBG/WSOcrzqBDJJ97pSdo4me63E7Nk35U6RKbpiV6ElFMMRd2eiED6yHWCouLrbv/Sqyv59oxLry66MIKHs7mwVx7P1vX7QZMUMFKCe6HN+8r792b78D/B+DbAkeBEAQBD8dID+KWp7iceCdPjoMc5AZFHVDsyXJFYyDmLOi54ywiDrMCQwhL56DTHUh1qCLQKbixQm7ATA04oF0Rase73a0qdVMQQ0gMd7zi8Qp5QUveAhO3ueI4b2mhMA8Slf/FFKhFAhjsQIUbsBYGQVRREDDiHvi69zXz9YEMcjEEGdBXBbOxjzE3qBK64Bc/AkygA1ViAP/kOEf+kcl/AWQjHt3WGgYMzgZ0EEYCLcYdQiasgYxzzuOqswhFNhJimIAkBSummyAqrJBJYxwlEjEHOazhCyLMHRhQp7tR3hCFBanDqPoxjpjppQww5EHNPqWfiwSBlDZEIQ0ncgbgjSRXxhNaJS8mRGL9wpjoOY4jygO9py0rRZGABjss8YYuFMKKVYTRV7S5zbDoqA1x+eIXvSjG9J2NfuY0QRrft0Yo1REBcqzb/tx5Rz3+K4/15GMGUECHVuDKaBlMmC9skcj/RUpnEYmQ2ASlI8kLUkNYAEWaHzj5SYqCMncjvGUpS5jLU5YBGuCIHYDAATNDkGtAsuyULnun0lg9qGc87OE7ZApMYRKFJ5kbIhHzpKcH3mKZP21mE4FRDm+cgg+AkAQgrCmJR4Dra+MLg/jGMgQdPXUSZNARGchpBfWtjX5vrNIbNRCYBajxTGctzL3yJ8/+4dOt9ozfml5zBkUI8pIKJCZBkyO5REyur3+NZCMn2NB2OHRDlrzroogCQsZa9KJNeKwpTYgRghiihSENKThOISCa0TCyR/gsSzmKBdLGwVYRgulMfegSX9XUpkhTbBF3OlufArVpTXHmVRABDGgA/+N1qmBqUpEKiDCM0wtVRe5ZwqBVrDZXq2MUgghSUCULVLe67xorZKx7v82gNUr3wt+99kfPt+7RvHE971zHYzCIHuxgeyoodPw6X8AeNLAKrdxDD2tIxBIlhP8FsGMxqlFcrsplmMUsOF4RCHK9gJYXuV0NRavSHP6hRMOL6UxWu2HWujaviOTpbEFRHmWWOEXNJMUw0uEN36LCxZKwRCUCwYcZ74Ga6OuCF1jgheMOgQVncS5zySAEIke3umXdbnavq2T7tZVMdNSbHeF63nsihsroZc1rZHO4u+JVgwQFLH3DDMm+4pc6kyysfg/ZZSEG2M20giyBCyxDA6cSwf+Y5YYhOivnimR0wqItra1emtofWqi1HnYgMhIN4hAfJxXJJPEynxmV91gKGC0uRYxXpAdOv8HTbgC1FLuAtWn5mKpCZm76hNAYEVigu/hLcqy5610pz7O8VwZYrnFN5blmgsuJJWxuhpKKvfJ1zHkQc5nNXKidpPlyiEbsm6UdWT9vlKN0xo8UAgHSO8cuzyl98KsUZEs+/xlVvzMthDBM0wsdOhwMjC2jZzHQ8Vzn0SX+A76jNiJvQCMd+mAxMHKRaRlzmtNseAPC+QLqq0lxxzwGspBVzeojm8bVsqbArGkNVydPGcu7XpeuQa4ALa+XY15+qC+KHeb5IjvZ95X/5LyDrWYMKi5OAYasKGklYHPbcCCG6HZIoVGH0Y6b3Ef3rEp1t7NBE5o9hXb3wuItb3rP29GboETWHZHvfCPCxEtR8YpXLHCCF9zgbEA7X9LAFxdI0Q055nEXhjCDUV8te0T2kgP2ZYHSqPF+G691x2898o9nOQRwWEpwTv7ahjZwoMb2q3xfrlCrK/o2Q3N20YCVvGIuY9o8H/Ccfb6EtE0i6ADSc38ijDpxi77nG51VhVuxbg7XHuo176/lw9Poqjs6EyWmhOi2jgdlEh8SubCU2H0rlWVFYg9nB3Xao7AFLQShB1ejuxfQh/25z4AMQ4juljCg977xfW/mL+s7/wW/Ls6sn/CFfz/JQ4CFTLRC8f39J7AEunLA8jWhlLeFmbOJmdK8X4k6jOk8o8C5OPu80HI9bMuIgaiCVzi9V5CCk0o6CTO61GEsnsEVpzseA4Qo3WuOeuu9R7s6Zcq64MEDFoya5FO+U2A+54M+6Zu+HIgC61OBFrgaHMM+IuvBVRO/jjO/jBMNs3I/AUpCjxs8+IuS+fO1+1ucAnS8xzOzK/yTyhPAzQuWwsq8Slo03fsvBmxAB7S2B6SzG1ADVbozbmAwgkipDTQQpAMCyWq9PvuIWrkVzzmePpQJwxK2D6M6FHS0ZMI64BMdFmRBUvg3sYOPUkiWs0u7vtCPHP8IgiVRARfAvvT5wVUzm1aruPJzjb5LlyVUQvJqQnYiPH06A1OQQjYjmjV7GCyEHKurOt27vAF8Nu0gwC/sENiKLZ0rQ9CrJQ1UFdKTAssKuldQAzgsCBzwrEusQzTkwDykA1CIBkrxw23AhhCshkDkiUDMqWAgxxPcP0JMwa0bhHVMRDw4Pn0AuLErOxp8PjuwwSjoARmSgX08J7lRASAUQg9wAS/Zku0ixdJwNQroO1OkJ4YcOVXctdfgmVdEuXBsIIqJID+pOlEIQKrDRUqiwmaTqW4YSV00SZwIw2Acxooyw9eDRmjUjxuAnWU0FWeUpYqgQ2OkRlhBA6Ybnm3/zJAOA0c6YRQSHMRCRMpCdITgY0d2pAVvgMcVe4bogURG2Dc70AM8cIM0uMH+2EcUAMsdpB95EUghmIHoIsiC3K4IKMVRBA2+U0jCQI22RMW6TEUn5LURaEWKtByjwD1bpBhbpDeBukULKsdy3MIf4kUqvD3FZDzFWhRhlMzHggIm+KSLasmdhMmCkEDT6zZwmITZ8cqblEMI3MmVuqg8rDBheAagNLRDe6+UPEzBNMGkNAVIU0deGoR3jMdnGLipwEpEwMqt5Ep8jCV9/EoVCEuxnBe0zDu7SQHAMMiFTIAilEvB8x/stEs+uqfDELm8nEi+PJrLOUFCmTrZNMyO/wHJXnRM9jxJLjSa88QozMTMyrwo+6RPzMxJnZwZUEkbCvzMkkKbPcPJ0rQIaXw9HBIDM7hG1jSJn+xGDAmmoTSKqZvNErS32qw3RzOFpWxK4AkFGBS4qCiPOhBOO2jB4tSCSvxKG4jO5Vyfs9kSGf0S6qoS9jkB63JLJBxFHn2162wrhwQg78JLwwvP2FSed+sJczxP9PzI13LP9iTJxYzS9/zFqWPA/LRMMMBPLY2IHwAtpKuhcHsI2lEDAG1DPaMdAi3QYmwIBJ1G/mypD7IwkaG9O223b6TQD0nPC93Q8RAPQH2e4+hQD21KRpTKXIjEE83KNODK6uudFo3O5P+UGxp1jMyAlyWTgbVRsrh8Sx9NP9R4tR9Vv+3Eo4Ys0sRQL7tKUgpt0j59Uli1vFik0lq1VSttzCvtUy+lzy7l1TCFUzndTFiCwwPrNmZcU9JsUzAV1jgd1g1U0DgYAx0qEdRyDwglngjVUySV1dkU1A11HqVhhedRx3zrGbFT1EUVzhRdUUtETkmV1ByIUUutjEy1Lg2QzuksKyQE1f7p19UQADW5MsBBRSu7srlyRUBsVZQcx1cNw0XTiSqdUom9VVz9iScVsPzUAcv01dxh1o+tw2CdCAd7RnD70nI506ArBgE9TmU9UGd905iFWZmd2YioNpA4g5CgVlxgzWz/GB5t5MPh0dNt7bwQO8xApa1vHdTbLD5EIAVgSL5skApPcCYTTVEVddd9fMkYmFR+tER0olHNqBtYk7WE/FdRNSu/89e+Cdh+6c6zStU9ioAagAP7E8/80xzCDEza3L1uvSCKLUnAtdiHdQZevU/79IFfBdPFBdkCedaVwknSI70z5TYEyzOT4oGZkcPGDVmG4NxmNRDVvAL7nBUd8rqlsdZr5cah1dNi4j1ApS1kMpbbxM2lbIWwg490rYoTbUFe4iXSeld4TU55lVcZxVTuuhJ0ybgkS1vlRVvqRJN/5U6AddsB2ri4JbnYsFv3mhMETMnIYVIt9NuPrNiJFVyL/2XYeDNcj8XPjtVPjzXQrYWhjYjJJVjDoAOH1INAMl3WznVc0LUd0xKD0a3MAv6v0vWDQVAm1K2NbQgkZtiGR7GN+4vdCj4m2rXN3zsi3BU43eVdFF3REIZT4dXarJ1Xc+oA5I3eskU/uoSAHiWN5p3LHRVYJiRYU41IiUxY7gXDo+RIjmRShyXfiS1fKUVfzvON9XVfjQVWxm2CmjVNyO2dcFNDNM2sfpAmhHDZ/p1ZJ+5izXXTcVNN0oKzNzNgBNYh5FgvQUogh0qP1xWPcOVQpq0/QI2enk2+YVDUFLlaEZbGPybhOkwB4h3QHnAMDpg1UHW1F95X5w3SRw5Vwf8DgLY9VcCDyIPVXgrt4ea4RfDtZMEc38QZppIk4iLOVfLEEyXe2MNN3FZmAlf24viV3zkciCq+s5EKkMzlXwD+XIfYWimeU8YqYzgzYIpag52bg55MYK1DiuZ54zi2TdtkipFhzWquZkrJBrLr0N1l13YNAhUY4UDex0Ie0K/SOEg+wrVFZ+gV0hvGYYONKx0mWh4Wx0G0hecIX0YL5cYr5VM+YlS2vPV9AS0d6Isa6BeY5V7eSXJWRgRTMDb9ZWBO6ImO6Jfc5YxwFdEd5p0b3Z3zpFk55o9Gg2SGA50FPkgbVzpWima2PwQ6BmuGaTz2hmz4zdxCBNExgzt00UD/RmgeQOj55cx81GXp9NTuSqvNiGG6XOf2U2ftlDJ3vs7pfT99OlJ6XjPCPEdPtg7r6FshzqlRNmXFPF/vXTT2LWgmfuWzTusmZmsofkCS5cxkvCw8Izo2hVyLlmgwrmiK7l/W0+iNZsmNVmY4GOmQHmydZccFZmDQaemXduzH7lk9HgZKmWkPXlcGjQJxE2eLlgEHwwEH0+WgzlwUCAwePerrPNvsLFV2ToAoGxNKhuoZrmEnjAAUqOr11NWN1OrC7Op9BpFWdc9+hk9d5VPDLWi1XmtgPe5YdmudPKmgDoRXgAZoYMNSkaH+gEO9Bua83utlfbAo5oiP+F3BJu/G/+LokVbmNFaRcY1pyHbva86FY8BmS9NdquhjV4FGsHyB5fTaEj4B0Pbpcj7OJQEBtT0rowZStGXqpmZwhmxIRp5tTL5tkKxnvd3tjsRqr/5qWAzrIrY5Jkbu913u5GZchQbv5uYPoG6ZIzGElwGQuvblvJZxztYIGr9rGxdjM+AlEMrP8ka3ks5ZBa4/arZmXSjy9z6GFENy+aYUYBCZGbTv0fndH+Da/e7ahB7tltVyzkynCxgM0/auBF9qdi7qBSC/p0ZzIq3egaWATMbt3NZtT87wCo3VDf9tvO1wX4Q2X1Big15r+D2Cg96BQSd05gbg0dxyglCDUyCp7ZbxGv+/8RvHcUcP4DsY4C6dzJ17EAVemiPXY5qWbE838iWP71KXbFCXHiUC4Uzx3BggAf3+aXPK3K316f7k8gH/5r8Dc0vmmzEP0ith2zR/cKm24Sxzcwp/Lwvfaq6ON4TRcA4H6zwfbtwrirQW9D+/dhKH30LndhOXU5o5qcoyKv6ddEnvbho/9772649YkPzEAiA3PqpQ8vgGdRczdfkO9Ze+9xTrJ1Gn98mmFD1mvqa4bFYHAhd99a9M+BKW3y3HQAIPgdS2ywVXbV8/c2H3mwiHn8E4doX9DURi9oEKj8W72DonpsQU7pCk9kQ562wP9JeH+f0W9G7n2hL3dkqHQLj/ZpmH74gtfvQa5+t0P/GVYhV2nwJFPN1QqOZ/z/emb/r2hsTHHvVTp/pQn0EkQlEpn4/PlvmEl3XibfgYf3iIj3i25HV9wfiKZ+3+SXtfv2SOF555RkmPfHY7h3a80nMpbS9pCHG1bvm13m9fbmWaN3TQBXfJfe6LlvTsFnqgb3zBVxBrLBFa8M1nCPiqd/rMv/f2Zs1S0HddwHyrB07e1XHgVfjORv1xZviKVr0eyEFLBMsCL3u4VUJ4bnu1d3uKx30Iryeq3l5kL/k5r3s6N/kh+ieUhzZq91i/9/OfBnwYIPydlv5YPnTStOvHdfwZz/6XhPyffnwIG4Mx8ASo/xW4ys8FUL/8za/6zz/y9gb90JfsgedmrSelg9fvK18bQXbWxA9/gFAi0AaKFRpAgKAgIQIDBAMeEnBoYCLEihUjXnSIMQHHjh4/LogYcuRGjSYPkATZEOUBii4pRlhxp1WzaTZvXsspDRlPX8F++nQmdCjRZcmKIk1qVOnObk2fLn3q9J26cFavTpVmLavUrVydNvUh9shYJkxevDiLlqxYGG3dviUod+6Pukju4p1ypMhevEH88g28hAeOvoZvFBmcZHFhxo4NN0b8+HHjwpYZXzacNjOQzp4hG84yZsyfUsCAPUM9LNuwXK1fu2Z9DDbtY8J02b49O5cw3bhxs/9WDZtUKEjGEenBo9wMcyd/68ZAIUP69OqcBSvOPlDuCukqOnDQsDClxJcZS7I8n16lA/Lu35tc+XG9+YkZUMysWY0aTp09/zMVoIADdgVWUt1UhdVXWhnIoFcOFijNDmZNuNZmaqEVV3Qb0qVDh3J9FuJngAkWGGiTOSbZEieGdt1klbkYI2ExnijaaGMgcopwq722Y22u/bgbkLqQMiRsrCH5GnGmHGfHcs1p4dxz05GQgnU8nCBDDp9p12VgKhQ0Ago9bBFFFT3kYEIHE7AZ3nj1qUdfnCqhB198d8qXkkXm3Zdff9r4txSABB41IE+FBsWUgk0l+tWiEUIYKVH/OlWoYYabXfohXJtqCp2ILJ44I2EtopiEiqXS2Bhlll3HqqutltgXFbOORocnpz1zZDY+Gumab73y5utuuyU53JLHIZcGc2cwK6Wn1mlZ2AmixrqYdlsGgQJCIYAApgpVBPLGG2ea0IK5Jnw33kZ7CiDnnPQR0N5IDdhZ73wKpMdunzTp1G+ghvrUaIABC5woUo82KJSjkkL6oMMOV/pshWxd2h1BHnJqA8YZT5gqiVOeCKu1KaJa8qqYtZrZEmu9SuOKN+JoGq/FBlszsDYLW+RvO/NcyXGK6JEJHss2i4WzU9IlopdRCpTF0QZty1AEE6QgxZloTttDlmpK0PWd/y2B7S68H8lrr0h4oi32QwXApIMjwuzn76NRFUVwwVFtZbfeBgMoN1YHI9yw4P9GXHinHCO+cdKfhigxECuDWurIJ5NqMuWwbtYy46HVmuNp3ngDTOi7psZjkKfzfIzOPKOSSynE/aws0aIZ/fTi2EpbrXMCjQrmCtyGoJDUDSmkAQcdoJvl1m7Sy267ao9dUtkLNI+A2WmH7bx9NmRyTNyBMywo3wrnrfDetuitqIJXAQ7ow4Mn/L4zhtO/g+KHW5x0XJs77tmKmVsugAK8nMg0Z0AXNaFzpwAd6E4jOgYyUDaouxnrXrekSGAwE4oQGhyYVbTa3aV/0IoMD5a2nf9saQt4GVjh8IRXPA6UC0vowkB49PS8G2rveWS7HvZ6CKeKUCAI3fse+KAivkGRjyg+WQUTZ4G+9I2PQeKYYhHDB7/4Sap++DvcxbLlRY7xzzMiBI3LTOYxAgJQcyg7oIkgc6My3AoYkHgSIkgBOmikw4G0aZ3r+Mi6nrWiFcdqkrKYhYYPOgGEY7RMCbMTBd7FCoW/U2HwXKiQhXSta8ezkpU48CYcghKHdKrTKK1nNnxlL5X6wgIk9ENFhP2LUHVrYhMJppRDeYUqVbTiFXk5Pw05DnH6m8v9OLTIMb5gZclc5sogR0IzRk5lBcQcWSDXzBfggAcsy12NSOO6MbD/pXZnsAMqRFeOdISuj3xUxY+I4zp3ViKeivAZ0ITWLDi04Aog3GcIRdjILl3rS2EaASURckmEWCChmZQAQtkkAVSGLQDtkij0IDofUpbShzlcG0VCoAVTuBIr2FhYLJGYFFvQ0hVPNGn7XrlLBrUvUljEyVC0yEWNcaqYwLwd4/xZGGxms4QI1N3LoEnAAjITqMn86YpmlEbO/SESiACnDjZWAxjgARX6OGcE99hH4mBQkBgcK9DoaU+mPWefTFMk4xw5miVE4ZGQxFaYJolQg2grr8YjgQZQ4MmEHkRdHQnlD6OX0cPmqaKFzQAr4YagkT6WpAkDmEpTGkW64W19/y+NaRLl57Ca7lSLissfToOgU2Mak387aFlTV+QyVWWzciiCLRv3wto0LhMHubUMUPuy1L2Mpg6qAEYlzOCc7hAUBmZwEinwuFVv9BFX8KznzzaoQTcM7YNp3R3T1srdWP3TS1/6y0BB8Dsx9RWhHPBOX/3q1/AcJL4KHaxL2AbRwiI2v4ot7EQg8IEstJKICRqw3BjF0qEs0bICCx8uHbbZznrWl0SxKWrBiLTTCrO2nektW376WthOTpqzXaOGm8phpg5mqUAV1VNHUwZSEJcNUfJiCcQUgyXYgRGW+BwxUFOKd2awSXoYMhuUdQftpjUI3V0y7b6LHfHyRWIFqf+rjcM0ZfZ2EsvrLch6Aysf87AtzBM1j34xmtj78vclHgWpgAlcYAND0SgJ7kQtfyLhA+9ywRG+szKUQeEMh5aYgI7BATW3Yg2LuIwgRjRkfhtbbGJTm7r9n4kXDdzg2mEMY0nkcWsgpjeGQken+OpYh3zdJ93zCkj7C9M82OozyJXJUBbjlbmD3Frj2juc3DW6tMTJrfH1AhRApZjxRdFiG7bMF01zDtcc0sgSUX5x/g9K65zZP8F5pb3krEz53Oc/B7qqgzZmrVNr2zAyeoCWPmqh0aLMpab4xK6St6yW1eF+plBM1qpjkSyIQSchIg1PGsSRm7XqtC55dlGCUqz/s9O4XEM84rrmNTdjWMKL58CTFGAImpFN5mUrW5UbtYh/6UAL70E75dI+H1CqXdkGdzvb2ualNWDOkz17u8/IAPdbMFzaiwmzwunWbaZcRWLMVLqpqjJVUMloQA7H25m9hVxv6b10WhV1IDb+dBno4KQ6YNDfjKgDkWU3CNkx2cmc1oIHmYP2osV6vNCKOF3orutoYYsv4Y3rDfge1y2p4CAd9/hL5iNKwop85B4vuWMhmxU3f5blBHv5zXG+Eyi+9LIQznlUeA5on1cY0D2Vt2utrsasjxhUrHX6pD2sTG269lWODo1i7NKc5eb4NGKXZ6m//qS3yzr4bGc7w5eM/5e8p2nu1LndF70YZbwjX+8ltFoV1FAHNVSB+tRnA5pIIGxjJ4DwzEZ84hVfn5iY/NmOj2zkJa83z75ZGU98omQfhOdtDyjcob/p/vu//BGyirsllQEdXTLVHlBJRmSo3hoxxm6dm7sRBgQ6mum5EXPgAEEFQRroQSQAAzT02HCNGtkxQu8RmZP8XvFpgVwxyxbAGgq2oPGtmrcEQa/N3V/0momAF1GNjGK4GBuQ3Q+WQfZtgbJYjdZoHEfYF/iJ3/gxIfmtTQYIkTGon8q5j8yxnPpY0fxVnmbxWRV6IecJhf71n+fl1Ljd1m+hoYYZIKTV3mydSqqwilNp0zINIP+k3VuJwZUSwABBJUYSlEEgOFAtEMOogdXY7UEJ+uAJuh1zxBXR3B7xAV/cNd/E3WDyXUn06SBAaWIeBqEIhkuRDSEoSgHfTcewDd4SomIqoiJHMRabtRnkGZEz8MK0dda1BU7LbeGD1dzmxeL9FUWg8V/QBeOUmRsAJtMJCCAFnlscRtrsWRo3KVpSRZ0ERmBtnZi1PJJuPQdc+aDMAMMp8N4hIiIoys4QLuI5RqLCodUkykXyqEAlYmIONM0mbmLDvdUYlEEjmokPBkI/BoIoEiH2SQFhiIcpFpuYHVvHNaETwsQI4AG/uNT6Lcwt2Vz52OIXMgr9wdJMcRuCvR//zYlhSApjxkDcNgGg6zkgoz2aMzHGG7JbAMaWpMmkUuVW7A2dEjSHlCXTjn3jvw3ZOJYjI6KjOQalPa6jrf2fDdhgPH4JmtAjJ+pjVOojI8KVVA7hkPXjIbJB9VmfQEYBEKCFBnDc+aGZEp7iQuJLTATYfoxUW+aERPaiLF3k3OCiFD2YngnF+XQkg4gkGfqfW9hdMRqjNh6QUmWHAT4jHFJTbjHmpAkgYT5dN73btgjbf4GdPIkjUBZlCg4lCwqld6GQ79wap7zjUm7JjO2dVZrBKA5la+bjZ7rYZzYiP1pCbV4f9gUhaw7kBRrUWCIbBJSlQpols1EAFoSCbWyD/1t+D1zSFBbeBGZh26MIDBdaJGVZGy9iJKD45XYiJaegBTEWnez1jqEVpmOSXoqoJKU50xyWEB3a5E1eWhIkF0F9wAeQQBLg479lpu+V42Z2plTSVV1BDWk5X95pTQ90V1S+Zn8GYYM6aNcB5IKqplRy5gbWJh+Ey/XlJvUNBmKkQHoB532F6IgGp7GtIkeBgBm0hmwkJ1u2aLRFJxjKFF1unlXw4vgk2HXGXIz2ZY/+5XfS3UmqZMu4Wzb9FsoU4AG9XjMS5pJe03uiG5fAFThVTEz+4X7aQZGRo2wuYplQaAoGaHpxy4Dmz1KaC2eiqWo+6JpGqLJk6ZpOKCN6qf+XrmaO9aMlZCiccugSmEBBcsSI/mmJnigO+dcO2AFIbcNstOg2xMM5OKpy8keMZid0Supkkc9d5ugn0BkT2ZlzRqoXAuMYjuQwckhBUElS/hQFyh4jsWFKRmMBphhTJRVjwp5Jwmc+HqAjdeL1vameUqg+KkELoGaahElBmZfFnObwxZqCoqOWZqnvPSu0PmsZTKuEfqacEiGXWg21BoIlgGOebitubuiWoMXGRYAlDc9KCKqgnqt9YsEgQILOzEaj0uuLfuq9us/feCqE6JKB7SgWZeqmBsWkxuWfiCqpIiyQWkgKQFqW9da8cdIBeShvGekyRunFdsY1OWZ54l3/unHiYZLAMZqJhkroKOpmVAYrxpXLQEkAC7XrmOZPwmErUbppIkqrtFrfzUZrtT7ozG7mnC6iHVwmnoqjuLbpVwZbZZpruqrrusIEcG5A1G5ACdAAE4jBIPwBK4BUb0TDonbt17ZD2IotvsYivurijHrhTzDRIWCCKIzCKOQi2RKI+5ghd5ZbqeJtWIbs3oaskA6pYmJslEqjM3Hsw23OYuRkHqaYeXGjg/7d4zoc8nXSCLRsBrQQQ5XmuaRpzbpB53quDxaZzn4dlgLhD4ouhDJotqauzy7o6GKQ6bbpm65IsC3t8JDocAYn1G6A7lJt1V7BHfxB8OICLeBC1/JH/9fWKzycg9xKYfPmK39QJ0dmpzYsUSewrcCO7dg+pyzdhI/abegpLKTpLcPy7d5G7N/Om+oFrtxpo4XI4TGtbx4SHQ6YwT9CIDc+bg6GJpgEVu1KxLlKAAxtwed27rOW1QiO3QHv508KrdCSrulC8OiWbq+mwZaqLlF2ptuhridmZbXeJskibf/abloGZxL+qdRY7gqpcO/WABSYRRzAcNZ6gicM7/CCrfGS7b1qb/bWn6PYaLVZr6Y60aXyMLYRSqgm7E7dLa6Jr96WL1/1Lfoyo/qur9JUU3uq6mpFi+G6jHF5H+PWQRkUQZUE1d8FqHtBcXwlhCk2bZ5ogAkMYf9tXmhWxlMd2/EdI/AC/+QCj2AE+3EFsynqqu7Rrm5ADm0l7IGzenCWmrGXcdztsisEvGwKr/AIXNVVmQUYgAEMx8EidPIigMIM17AwNC/cNC8Oo3JEst8XMq/bWlaN7nBz3t/3jipJhm+V9K0Tly9l2mcWC2nsjWcVI1p4cnHhnt5oUObIBDPDivAFaEvxXEBCgJx8mOsKwHEgnIIHOtAjqMIpGEIpeDMqyPE4vy5y8LE4QoIeOzDOUnDq0uw7F3KDgl0H92O07oElLDKeKksOSIdTkYDtdos2WQDUep/UdEvwZMCniQFZXHIygdNeQIEYjEEcvBVyKIfrmMJxnhz/16JyKj+qSz1vLMsiKMwiK7wt30BvSof0c2oeaCVxLQMmkJIvLj/xE6txNO8uBRxrNhWaFAszATqjUiLTTY4GMTddFPSp0nYNHKfA0kKzuZ4Z8Uj1txgCMbDDOX2gqIEgOJMzWaFzOmdmWKuzVgJyPA/hWZc1PKe1nYJzONezswJiIoPuH3Zz2XXrPePpElyAJCvBXEsBCCjABYyGuWoAG6jAfcy1F68FclBMadBBRXvCaJQCI+DjOyECDZ9cNnytO3B2o272POgwfyiv9lJbSZe0MoS2SLvPgeESEnuvd4LnqeayTfPyBezuiEZzFP+tpA3TT3/KBPo0ATYBNnao/xqEy4rsVQ4UmQzAl0KgQPX1wLANDwncwIcK1ko0DwC/EA8IFzSwAztoMwh2M1fvnn6C9R6fszrzrLNa8Fpz7nvTplwPmSRUQpFhHzkRAz7D9SDK9+vYsxJ8QA4EggycKwlgnyTXgSWgAEOAACMEQYqWwQtYph28xSmcgqZhk3DVATgtQSjUwV6Qgh0cgRi8DsyUBvHSMPK6wzOouGen9PGONn/gEi7cgmnXeJ+9OA7fImv/kmu/dN7K9myncW2P5YhKsnll2fkGt28XszFLMX7iKj7Obn3mdhFq01Oz8Uq88a4xz8s6NWG/sRTsgVVDQ3iP9+uQd3nn8XkzcJu7+f9c+6AetHdZbyl7w7U+Sygb1KazWngpVKvM6IHbkYIllPVkR8EhAja+jEEg/HOCF0FDaMAeZNyH3wcJ4Ij9WLpwYfgLlMEpbDhaRMKHH4Gf46eFc/gU0EEuhAInzwTXbnRnU8PyLq9HO+800LiN/wJq53gRrzalIgUtA7ktl2pN821tR/PtAmcBHLluR6yKYXHFNvmSSzv6TqmEU3llLjthCBV4XPe5Tk1BwtAMWTe9LBRhY1I098A91wI0vEJW93maq/mao7d626yd17u9F7AiUys5ITI/Fi02vyk2x1ODet141zdzDLybirOeW8LsFraCXwDYscHGRboe7oEZIMT/p6FFDVDrKYgxWmg4HewF2e3khy+BqXsGvy/0JiMHLeBBJ78NKdvwM6w4i4Oti1MDDc8wK9y484Zt1/689vZ6/r02TA/7lRF7NCu90hr5iIaZTndLYXDSUvF27zws/E67k2P9oWXTaPCm0qfx5L5xDpBJD2hcJnGAmEsBt4+9EYoHA1wS2pc75koBH9TCK8iCB545vKd5OO4x0Lh54K+zfcO50HaucuC70FaCKsj1OKNC56rCm8ZTgk8rvyf8Flw+IxDXHnQzbsIVo6do56JAQkv6BbzYDsynhL/A6DK06ZIFyVOBn+9kfeMFAnu9yTn2FEh0KDgCHdwB8KY48W40/83j/K2TdA0XL4y3A9gKvSwVvdHfMrEnbW+i6+0Wm3+Zr5Gy5xxCI5MHrtY/ueISXd/ywEAKtAUgT7lYX69pkgu8wQ1wO9xLABzLWAuAx/FUQP47FHz1L0Bo4KHmETF20GqpUniKYSmHqCA6tFSJ4h6LehhdxLgRox2PGN1gZONm5Ec8bNK4OVnSI0s2e1SVSmkJlZ6XqFCqIsnmVCWedsoE3VPKYiWbaSaifFnLqMI6T8sEMsSDhFIzIFDsSZLhBSM7L7i+eIEDR50yY+ocEQu1zpIXT2MckTk20MgYMIoEGmomCVpSY0ghEkNlTC48YJiAQYPG0TPBceJ4kjyZMv+oW5ZxGaMWbTNnz+04g958TZo1Z9NKo751mjUvHzZex4axgzZs27dx5569G0Vv375JBBdOAkRxC8UpXLgQIUIGCM+fF4hegDr1BBSOpwhOlepYHjhefJcRBEj58ebRpyernv169+/hx/8hn/6RI0vGnB2zhCrW8DKE00BADSS4gY0eeDjhBO0GTG4BBRgQYIEUeHABQRNU4EBDAo8DQYIKPDzuOA5M4AGmXg4iJqGFHopJookqykgjjmi0ySSQSDoKR5daKimmqFRhZAs2JgopyJx8SgqlSIhixJI9SKJpIiktYuipp2gyy6wovoJBqw0+wAERO9QSi4QjItmvreD/ymjLrCPgAmIuJPaICsAlGKGjlDHsQySSJjLKognA8LCviUOb8POPJhRbDLJF/viDEspW08yzS0NrR7TRUlMttdZwka22UXXjzdRTUe3NzACJw0q5DpVTrjkKnlsOulurky474f7rDrz65mtP2GGBLba98Mbybon1ltCPB/6+a9VBEQf0rQcrqkhwggcRWGBaCzbEQEEMU5hAgnM/HLBBDrHaQhJiykmxlJgWYnHKimKcsUZ9aQzJXxv1uLKkm3yKRKchUbEEyZsUlqqkiuxIOGBJYqL4yDoe0elKS5iq4+I0omBkjFaPGDOJ4MJM660ygnvqPje/ymFOIbWqCihL/5aVC2ZBxZAJ0Z8VZbTROIZ+dJSjJ6MGl222ccdp0DSlZlNOUZsms9acIVXrrUu9bYVUeWOVVeRkLdvBs29NuzoIkuPVOxzEM1ZuYueeWzyxcmaWv/3wlgI/t6gdMQULT9CwxCre4OMGc9GtYKAuXOBgAhJLPCGKwivYEN0PNz8XKxM5lrdee++lKN9/91WE331zVENgOxhBpS4rF+apzqHqrCiN2I2KWC83nNJjXhmDxxKYJ2MaKpfY7XDrgxGWMFksOupYq/oXohoLZtgsucoJraJg+awg9pABq+5fGOMUPgk19Ocm/iCFDsXiELrR++eQw2hRQJFs6UtBEw+mVf+DatSQhmZaIyqudQ1sqoKNA1cltgGZbTkUlNV1mMO25MhqOmzzD7KYdR7Y0I2EdTPhekAYHre8Z2/Ncst26qCwGwRIAxRKnBRMoK4UWCEQN0hBB8xFISm4IIed60AV/JZDyTGuc+g6Ww6ksIda9KIXCAEGiyJCMUlQ6XQTy0gkvghGiLEuYBZ5CZSe0pMYXqxjgThSJWQ3FFWMCSanqNKTgHekiKSxY1jq2PDgODyU8Ck8cHmLYPyiluwd0pDdg175lMCGGJAJCHogzgv2hJ89jcUn7nMfE/zEpyYQjWj0W0yjvvAFRz1qEf2zjCem4ZlzDLCASquaAhfIQAg2EDj/YpOWBSs4K1oNk5jJ6VAGE5BMCBRHONo54TNLKMJg3UY9yPLVWFj4N7cs04V+m+GAxqU5CzyoA3VxAQ47sMRzeasB7fRWuEyQzgowkZ5NLE4KthAIg8SLGBXLWBZfVDoxmk6gvSNjR2D3ETmusSgJWShPrgiRPirkeFcMmC50MTGJeQwYGuGYXpInJWIQlA37oUMo+OSnOowJZ1WJBN6uNJtNfi8uzdNDTcGCljaVwRMsY0IkCuVJ95UCEYzaD2TEgL9TDk2pc0hEHFrpiVtcjZaeQSA1PJFLre7SVOCJoC9pSLZYjXWDw0wAmKAzVmrZSpm1EtDbRIgssZAFm9Cc/+Yz4yIfa5rJLfwZy31ciAMLNBNuUkiiONHGAAmoAAUkisKFBPStdtIzc/GcZz07FwJ0aZZEitAFO8pBRVXUwmIJk9K9UJtagh60RnRExLxi2CJ7wW6jvLMDx8CovKZ01CIYrRJvGyrGOM7LG0SRSO9IcRZIOIE834uCzeZqh472Zk+PFEubqlcWsARlBN01gx1G8BY6rAdOZPrrKRY1qPqtd5RCW+967xdfVKoyEaLQBNKS5pisbrWB/a2rV7+KMliRlcBkTSYwjUMgB7V1VymQJtxU+F/4YFPC0Tzh2/AGQgj/hyzNGl+zfBgcB/fAmzlQAbp02IIWcOCeJHZduf/SVQEKnbOIk0tnB0RQ4yZ6znMhCIGMZ6BPdrCjFwmRxCPutcXTbtG0phVoSPagOtbCLnZByggpCooRK190eRCBBEYqcTzhDSPKGNHFbi2hOjjy1stOGq3sjlvl3jrhaytQBHjNwAgzmWGOMvXeHq7blgtodwRtAdMGllC9EhQ1vGP5w/r+6ok/iLK9SLU0UkfJ1FLKN5WXxq8n9ItL/vYXN8EBcAQvIJwPxGrABa4VgtUKqwgowDptg2CHn2XXCz9Yr9yxD9zAQ5Vg17UvQTmCsema4JDx4Q0qAMGGepNPPmxBnR3gQRfegDnDVagHQDTiGyCHgctidscREAgfUDT/5BUteUpSAqiTpyTl30l5XwpNnkdlBOYtQ8LdcXTSmcd8ESbdq8m+lbOZrxjIiAzjeA5JAxaY65H0MQLARI1L9z6Q6BeAAC04SPX10rLqDZTsCCNIEwqbYMe+eGxRlEbUe0fJ3kuTktOaRmp9jzYKVI2a1L86tQRdteoCu3qs16mg0cu6QQItZ22pFpCDFwSgZO2a17rOa7SSxZ3/VHhv4wvQBY5DgQVwIFsI+s6GHNuDDJFtsW94ww3CedkmttNy4k5nER3AOHfuXezdKpAkCiGIIqvIn0eGyD8Dqlq9hHF1rv03KTKS0Bo1Sc0OgTwj1EzQNJfZIVfGKEYdAomB/4teEfO6/MItHxHRgzk/5mXTCs8yAiCwLEy0J8ELR6YcMI3s9kApAx6WIHuFLuqv7/tZ/agw8/pper5goG8c5BD9OVia56Q+lakDHFaxDp37HiR60o8JgaZ/EEAmrLCF0b+qa0ZrWcS+QbEB1+pnV6sFj82B5op5LuaAa8QX8vYC2GmyGkcDcMwDRMDb9i4BCYABALADLITEDAFFZKHIVOGfKubdEg8Q9GK1ioLx/ASoYkshTivfnITewogiSK/01Iz0OA/zBk5iVOfyFEH04IwiUg/yQs8DgQIJYKO7fDC8/GPVGu15fknkiJAIa0DVSiBZVoUJhIpR2ivmMA0yMv+NUZZPqVTJlLRQB6oPbHQp+4CO+8RQOZSJDM1GmMKP1qTDg97K6txwWHJtWVYI9zRMbwxrcVxFcHIAslTgcLIFQzRg/zZnQDakRFzADbKNstKJxvSuDz1gxSpgAfluniZLBYTA7c7pXdKtnybiEZDMEj6R3ZRMA/ElXxgvt6psdGAEFTOPFV3wFb+IBVvx9GCxFAfKdG4RjGYwFn0vCXrwCH/wCJ9nrISuGI0xA44RTJ4nMZ7wUI5KCqkQqWoOlaRx0+JA1KwvG90mDInx+2LF+wpMGc+Q1ZCjgyAEO0wNWKLlDekmr3rlV+JmrsjLF5OgHvFDCrxKRFCgB1BC7dD/jkSqQCqkQHKMSQKsDYmKKHNIBFu6TSEpB0EkZ+8qYAawzUI8QCFboAsUoQfkTsbOyQ0gJyCniMhWJGFCURRXq/QWzxVJsBZLcCVdMiY9UOBOMBdl0iZvsgO9gi/sowhjZeOE8RiFrgRWjSg/wCg/QBxr4ANewAhIoAaMgAmK7+WocAyqETIUIwshY/qcb/pICTLuAhu9JhsfaK7A8OvIRv7GMOm+kTlg7TgwSA0NgA1JwMFkQDvipurYkVi6wzvm6jt8LT7sMWeYsA/vj8UULDlOgA+mTe1QAMVKxNsYp1swANyIyLIyR+8CsAGszUJAEhIr4BHFLQE50w/Vrgoe/0EWiGzwKnAU203zVDAQTJElcxImc/I2cRMndXE3bxNG6Ihv7sInmUnouksojXMohXAEiPJMnPAJ38vSiobmonMLu5As63IbUSY7VW0M1VIMk06Y1KpsxC8AyNPoBmssnGk87FIv95I91YIwjeUe9ybEWEz/0PBcNMTa/G9yzAUAJQAAAXQCHOzuFETcNDMB+dNxWsADMgQBSbOdsCND8BPdJJDITtIQkkzJcNEWYxJ3PNQocnM2T5E2dRMnW7FDN/SLDCESoIKQWmVsirMbkfM4i9EIVs0pmQBHf+YFlK8atVKVvjJId+4LdWk8mBCslEM413JJx/FsKqjVZk0uzf+zDU1sPduTPtxxheCqPogtPIKihbRAiYZpEPuQQfqw7uRp7vBTMjsTW4RgnCTyBLBFBC4LAzzgEEGTNBlQEhtAscbFBfRJNV+BtERQSjS0oEg0UUNUURm1RB01RiovhiQ1jByiDn4n9pBDSY+xBJCyGMUxKYGyBGw01UD1BZrzUGZOC0uJ5rCS+qzzVaXuq4YxU7tz+5i0goKpSbsvAarjwBpsQK2UPbMU/dBDHgHTLzcMS5/F6worYHKgIA0ynx6h2ebPcA4RESUTP12gCyBn3DDgBrj1BPSuASrABazABQ4wAT0AECDnIvPOnfa0TxXLAiIUW6rACh5hyEiyNV3/U/EctQNX0jZv0lFPlDfBqBXECGFNR2FFtARhc0OPy2M8oUVlNTtpNCmL8ZeMcjmFUUf/Svno5yqDVBqrs+ciyEyCkFeYqVVstRu7s6y6z4LUcjzHr4asRViJFQjOLyzX8dR6lh7hgztcCChJxO1W7Ok4wMVySO7ItQe6gA/CDYgU8pyIiGnHjiFPwEDf1QK2dgEJoAEsxEKEwAVmwAPWye8EUOxMwFzdzrCqQBWGDBpeoWLazV9TVGAXlUNtkvQetW9LNEXjLJAaoiGewnmCzmJjVCg3QBw59iiVs7uckgilMirt436gsUdZVTHEsmQLMx9VNjkHKyhb9mJvNa0c/2RXc6XWnu436Kp1c7YdkzXY3tM9KEwwwwcIFEwBcsCcIJIAs9WJ6E7GDFFcyZUSFfBrxcUERABdiZdPBfBd33V5u8ALZsB4+7SJmEM/O4ACTMAQoAEaZEEeigxDURJRUVBEddJh9ZZJ/LZ9G1XzNrQOQuEFJYIhDGFwq8fpfpBlafRThe7QgDE7nTJym1Iq5wpzpTFkr1GrNte/UO1zxUJ/SZc7bxVXx5FaHCR1I+BDCGs98xJnXTev5KM7+KPDUC6EBbMe7Q8EkLE3CJDbFkRqm6jaKotwtPZBtzbvklcEeNgBvjbv6pSHMQCIWwBdMeCGv9UE+u4AuiVADUQNuv+gEIYstAqhUMvXfPFWfd03RVN0fnXTi2NzfelXNgOq8+blfhtCL4jDl4bTU4lzcTGWODN2VZjSTGz0CIwgKpMl5hCjVb+SfkapgWFV6mIVrLITVmhVUyd4gvMPmOhV7ASgV5ujWvCSXIIVhGFXS1uXwnZ2HlXYF1HAOPCpxK6FWsm0B/BUndYWcbCNeM0FiM0VXYGYh6fXBaB3iDFgBnT5TfdOXBBxaTsA7+ZuASxATpFIDfigFtTNE1GyXzmUjLlYjCOBYS+Pfa05mrH5fCF2Q0OBIRa2FMi3fk8BQ1d0TX4SRo0RKEU3OZmSOLEzgp8yj/O4gA2lj1t1aGKOc3H/SVXemY2H0SdhpVYruBs1aOjc0oI5KJLJEzvOEwXI5S6B4KExuVgqzJrqBkyfxcQCsnxqiAcCUg1+SHNMYEgaEj/baV1roQ8ipyOP6O20dgEcAAOEgAyE4IiN94jf1WslkSLR9TK1jWnh1QHfoAo8syDUjW7bzZmzealvkRYJ6vSqeUOp2Yu/eanLGI3t1371ov3YCuzQMmM7dZH3dxtPVizkuXKn0QoPZTf0eZ/Pkn9ftAjhWqBddqBx9cAuAOmOCZJz5TqAUMQUBKKx1Aaq9MFIGG/o6lk4rEzarzboI6P3Y29OQPsogAeYDSJtTJ2elwAqYGyZFzMVkmuP1wKE/wByxraH8y6ZflinHeABJscDRPINHBR6+/Rri/lefah72UEeJrAXQtE1rXqb4bd0oBrLhJuqTce4izu4rxqcz7hOyuDsEvocjUNGZzSd1zlJ33pVcNRU5+pUD6VoMq2tHTj7gnKu4dq60/tW/bfVjA7pXoVep6NmG/qSJ1p2KUzYUKivUHiTWUiF9sOrwO6Rp6XuniVrf5dzFHyycOyIbTq1N3Nr50lc7tQAc9qHf/h5dXgGajqHcBjDYVpAAHB3+SBf5WFflRqbVeuplXu5uRm5zTi4cXC4xXlw8QiHiKPvIGTHIwQcrZt0Ayw53znAltCs8ThHKxdRLDcsGZjJnf8cbB5Y1VBmVtebrifYynXVDMtqwOYbQoIwPclCou/7v+4G67DOhCBbnQn8W5JWbBVExep0wuWUiKS2wR9R22hbh29giMGFh2e6C1w7zyeLtivAToWYtgMUXue1XAQCeFBEtA6VxmHEfFs8xlnc0s0Y01/cBjEwQ2+8CHJcx9vKAEidusfwYuP6CMu6CVm9uz02yZkx1pvcC588bAxZO9t5vVf2x0e310tXgzBoy6e71gY8He17ohebk+Uq1zr5PQDc67pLXTakB4wWQ0TADQDBDdJ0nkzgDSahF7p1a4N5ersga1/ZXERACAqhpkU7poVgCGraeiOcNO3UIoeYwen/XLQBNIMWawveQJmHrBeyKNKFW9MvHcvMeH4Vfn4zvcULHuGziEUYQQ0eK5R1nMeZOOMHwDrw+tTlONUiOICJcMhZvQn12MhjnXJlnbxTxZBVXeS3c8ozNTxXDcsHuq0KGjxljWbdSgPM5Nj1stlRyC/NcqLlkLsEbCAoXgbuELS31Q0g8VwK3YYVsAOmd9oOUETMpcKBiNCHAN7dNbUFXV3v1Fw5XIjT9Gz3/YjC1F2m2EXgbcUP/tJhpNItj+ERHu+T2+7bzSGQDLph7OIxXkojudRfrRv9V7uFPK5JvuRXndXBWyxWftaJVFX++vL3V+R/PKCZVJGZFBw1SOfB/+4bebVm63I9gb6E/rIvFXvM79Fv8nGUvykxKZEAALWV7W6JEt2dCn0RT+AGZFnDER0AeJiHDVAEfDj5x95rJ+D3yaDcBzBtp2UFwjQQQ2ALaiG04p64HR7i997uwd/7b3D8OZ0mTGuolyV3S13j2b/w19/wvQ8ZYyXxu5Hxg6Ohydrx9d8JRwAgmBhh0uRFE4IvBvpYGIOhw4cwIkqcSHHEi4skMmrM+OEDCRAeL3wUeQHESJAnS6pcSRJkx5csY8pcSUFlggsUINTcWdICTQUFAgRIEEEkiqNIbchYCqQpUxxQozJdguNi1Is8sBpc2vDpVak4lvBYUmbM2DJSXv9YWOuTQoO3EiQsaNDBBAYMLVy4sDshLty/Fe72tSDihpW9Iiw4COygsePHizF4EEEZ8t/LkU9QxsDhst8FDBg0CB0iBActgVDpkoRKEqlSul67LmWpNu3blXDD1t36Nu/XvoMLp/3IEiM2UWRwABEBqHMDBwRInz6AOvTqQZ3r5BlzxEuLMC1u3OhRI8bz6M2jN4LxiEH2VuPvUEp/vv369ylWFK++PP/wLxhlUkrfsfQRgeHNpKBKG+BU0nY7NcedgzY9R9SASaXglVNgSbUVVFkZ9EJWVXXY1YklXjWWWC+ocUodN5zwUVs5uRVXBROoQFleLgjRIwaedeBCF3z/WAHkWiII0QUZXQghRGKWWUbYZJU9hlljJ3TRZIx69WBCX3PxxIEKLUThhh65zdabbWmyqRtwcMb5mpzD1bnbKcYhlwMKODVnYXQGCCVUAtZNJ+h0ROm0oHeMfgeegOqlJ6KklEo6UEHo5afpppymNx6j5IF6IEkcdXRSqQumCpOqCzbXZ1EQrpSdoBRYoJGGuD5FgowjMiViiDKOpZWJKHy1oVRiUbWEIXWoIYUUzpJwowVjphDYDG54GdiQgLiB4wTfqlCFll0c+ZgQk7xCxgk4RvnYAx48ecO85l6ZmRBVsNsBtHstR6aZe9jGGmtp/pbbwajQqVtsCR88p53B/50i8W11bKFcjRAA+mehAAjQsaGHXqdArKqGauunKFfVXqUqU9qyyil2KnN+JDSE8s3+cVRqSgGeyqpLPwct66sSFm3jq7PqtFbNXvEgg1YfPu10e1CNuPLTWB/LVYdkUYUDWoYFAuNy4HbRBx8dcNCCCGlz8K0LfHThgtvfcpB2B5YtIMIMTfpYpbsPPCDEDD7e4IFeJ+Cd92UILGDCG3yI/UbAtbGmysAKs3lM5nHSRsrmDxf8cCkTl47K5ZZUXAQKGmQQ2sYaP5cdoQDUHjKiicaaQYIlnfrpeZFWml7Lw7Mc88zIe3pzqKD2PqrOvaeKoNDU12h9xhEYvfQF2P9np+jSTDN1QlVTc2XQCVkFS+INw2ptvtZLjJFWEWrAKMOzyS3Xg14qSPDtYHDR0pn69T8CvAUy7ZLMCVxAJXc5IAGESRLh5IWYdjkGNHPRQAd4sIXUWK43a7LNnVqzmtF1zoTB+RycGAacXIxwYnvQg56Y8zqRxe6GILOdDm9HKEIpincJOlDwlic8+axsUplKYtV+wMTkcSoFTAMeEXUGHioK0VS8I9D0WrKgBlXPetyDFfZ6ooGM+CRj3utJ+GpmnhKd52Xn4dUL3lcsOqoILGSBSrPYB6IqxGg5bvsMYMD1FhP06ARfApfdLLgYRoJrMk6CkgMdYJgm3aUH+NL/V9pMwMkquAFyHxzY6SA2nNBx7oQHi83nXkgx5LCuJmiEXXR6qLFDCWqHO/Rh7iYERCEOUXhDdGMUi2jESR3PiTar1BQZVUaNGGVnWQRa9aYpk6JQCGM5GeP3NLCWjqCxACOz0a2gCEWqydEqMOsVOt1nNawgSyxSKFEH2LIWKfAhW3jhjCAJ6b8NJg4vQnhDF/6ZNnDdRZ99CYwCGShJB9ZFMQuowBv6INBA8AEQkQPEwCwBwo4Wx04oDCEJWSgc0CmsN8hJDp/8JEvsEKCWtrwlLnMZHW2yypcpU94v2xjMJSLxaulsIjKPKMVl7syXpLIi9UJCTVZNKHsR2iUZgsP4zW0OcytzzOocn7ZVrhI1KShyH1TiOSN6WqAHFy1S3LawzxudYHItcOtEyyWYBHImgRYsjN8gI4IHPPCChXRDHx7xCI0SdqOIFSkp36RKkoZ0TsIYnS5YaActBGEF2JTl7FwKU5l61naF8hNUebkS3y3zjUoknjF/ejWeZhUHAQEAIfkEBAQA/wAsAAAAAOABDgGHHhADKQ4CLhcGLiQPMhkGMxwLNR8RNSEONSISOBoHOB8QOSsXOiEOOiMSOzMcPDciPy8hRTQlRh0GRiQMRzQcRzklSSoUTEIsTUYzVCwWVykLV0s2V05AWDokWEMqWTMbWi0VWjEOW1I8XFVCXkEeYR8AZDUbZ1pEaC0KaDokaUIdaUQqaVQ6aks0amNKcz0ldUQmdUUqdUoydW9VdjsXdkksdlY6dzcMeEo0eHxieUMaeUYqeVEueVtDekYmekkrekw0emNHeo5ue8SWfFM6fGE+fVI1fYxpfbCLgj4Ogk40g1M2hFU5hVk7hVxChksohk8zhlg3iEcYiGZIiUUPiVY5ilU2imE9imxSinVYi1Ipi1k2i1o7i4Zoi5R0jHFOj6yLkk0Xkk4lknxilF5BlVs4lW1Slo1yl2hHl4Fel4Zol8ujmFYpmGM6mJV4mJyCmVQbmXZWmaF+mnFNnWItoloyo1wco10lpH1ipW1Ipm5OpnpXqGk3qHRLqJh3qWIeqYJdqYZlqZBvqaJ8qmQprXE7rp2Dr66Ns2wss7yjtG0ytXxTtYhVtdKxt3lIt4tmt6mFuIRYuXU5uaZ7uph1u3Mtu4JKu5NrvHQ0vYA/vuLCwXc2wXkuwn5Rwo1mwo9ww3s1xHw6xH5Exnw3xpVqxpp0xp6Bx4pVx6V4yKeFyX86yYQ6ybSRyeG9yodHy4M7y5JZzZFM0Khx0Lyh0YY90dGx0ePG0os9045T055z1IxD1I1J1ZA/1ZJL1d3E1pFE1qyF1sOa15xm16V22JZW2KNq2LiV2pNG2rSK3JVK3JlJ3ZlM3ZpT3aFa4JdK4p5i45tN5J1S5Z5Y5aNb5alc5biR5qFT5qt256BO56Zm57WG6J9P6KJO6dzE6rR466RU66Va7alV7apb7atj7bJo7caX7rBa7tKr8KZY8KdX8a1y8erP8qtW8q1j8q5q861b9LRr9bFd9bNj9bl29byG+LNe+Lpr+MmV+OO5+bVj+bxz+seG+8J5/MFv/vzp///xCP8A20QalisXsFzXtFUrV+6cQ3wQ750rJ4tRmysXM5bZqHGLFo8flYgMueSjmDJ59PCpw0aMlCRPxKxUxIemJFGgXvVaxsyaz5/QgGKL9vOb0aPgkoZjh67pu6dQo4pTSpSnVZ/i5E0FuuyXK1WbOG1yFe2YLl3Qku2SJi0Z26ZsnQWVG7cu3LdVt3G9avYWLb9y6eIdbDcvXneI241TzLixY63y4EmerG+e5cuV92nWzA/e1qmLQy8mnE206dOoTU/7nJpas2bKvlZClOmWtdJEn0Xb9AeRW75WYwcePlyv8ePIDStPmu0wYnXQoXOeTv3aa8vUN9/brj07PXLZipX/xhz9sWPKltGQqkZPofv2Eh1O5O6NURqNF+ngx+jRin+TIwEYEx99rNTSSzGhZJMiN7mCVk9zRSgUUhTe9ZlUGEqVl1o8UcXVWWCJ9UpZojzIIV13FTdYcsttqMyLXvl1yzEqUshii06Z9xhoUFHmo2SWQZfZdPrgphSPn+W2Gm6tIQlaaUYyByVqPpmViSSIZDmja4NVYkclEMIIHHE1SkiYizh66FR05HE2ZJHNiUcOP3R6Z6ebiI1HHpNTmkdZHu/BR892882Hz3bePLJfG/oxyigbG/0n4KQn5VGIgWK49BIbhNgUioM7hTnUhGbauNSpR2YYGmSKffgbUlV1/wWiiCSW6AwuzoClCjGFldkrmhEGFyONxAoGK7DLqepkjqex+tyPb9LJ2JF9rlZYqstmq+Y4S6LGTIxXVlLbg6O9tQsiX4o6Jpml4nicr2kyy2Zl9FaG2GuhXXbnneFdtydzTlWb72SLLMQdQ4MefM6hh95TXyEYNfooSPxRTGmmCXI60x0Yb8opTqCGCVu7JJuKqqrORjZtlcWuO2tYxODyKS4yr5VMJ7ziJRfO7JY81JjDntVyi0S3i622qT0Lbb102ou0mtZCzSW2UUfZrWg7vYyJuOROvRM4uhDyxyrTIBtszz7HCq9hKer2zHmTJVY2hOCBp2+d+9rL1mJByv9NmpTNRoKMewgfLFHD3FXkqH76eQTpFmVo8XhLlMaU8cYcwxEGHBo7QnPOpI4aerLMHpmyn86qLSZwq4Ai7ibfhiVKroHt2uvQaOeeddBC42722cZKnW3SSj/LtLQrA55kUVIzX/WZU3P77S6tt751g19TI33MzJS2Sm+9bL+u7mi/6/vahJWO5Lc9PYle0/AfD93e7tjrN/TPTxlJKY/sDwwymjFcobajOIkxbnIAopzkLGc5j9XBQHfInMYaBDr8jY4bJkMZ6jY4t9WJaW5/mU0o1LIJ2uxKFZ0Ay87qIpddnE8v5OtL72QotBsBz4aHoZpolLdB49FrH05rkof/inZBkUEoar2wHoNa1zslbc+F0lAMJuBAiFfdMIa/wyL6/uahq/DQHm0Skv3i9LYxNgd6aSIKKRixBB3wARYKMZwAHQaIxUGOUSahg+Qet0fJSaGBCMoUS1qiuQhiYmYVbB6qMsgUeaksH/aAZCQfWbekbWV1XulQ7FpHGxL2ZhQoTKGueBYXF76QXaGSFe9m+Jdi4fB3zlOk1XqEOszQC5I7UuReRmdEYQUnFq7A0utM5MQnOiiK1kBEGP4QPmS17JTObKLu2oKrLe5Sh5WsW9yeVRelnUk5vaxKRVSgAR9EIoD08YYctcGIlUyMUwjkI4A2FQYESQGeYsuSPimY/0iTLZKRjYRbJI/Xj0laMimYzKQqlXhCZY5NhaLclRVPpEWK0hAwCpXmFaepJC5iE2C1rBcY46as5RExnOzbHTC/wtBY5GyWzdkJqOJECDiAqYMbrWiwNJo7Fl7xV8UcXjar9dL7+XR8vhwGI3SgARWc82D78MYw0Ikoixgwnpzro+SySsgHLhFkYA2ZFfEyNQz6E6CMkeQP3dQ0knpLTDECVfWupwp0qMKhJgSrClH5TIv6Eq4yCmxcodnTk55VqKZJzI9yadIWIVWlQWNpuFaxJR6eMYkOmukzzmUHsrlKp7qTKGg5SkSE5u9tz6vL21p1VJ3uAxY8QIEWGJEw+v/IQp1QbecBD9jVrTKuJoVwhHCF24niFvdmpkxuKpVkoX86t0K0pORa8RY/z6iGZbubqwi1hLNOKHOZoNRrJ0BEHGn69a8ZFWzvWklY0pJOlpYlHqvU19hrhgmywFxp9WpzE8q2rzVEAZELybKaVWiOFlx67GhpZ6sFgxaohi0LiljbWi1qIxeXYoQsoMqPa9y2tg6DBQT12NXfXupSmbCESz/HPWd0AobVnOHuTrSiWKI1utCKX3XdesnshitLvenUWFL43YfqVRUCbiEr+wpZGq4yk0l2cNo6mlobf5Sx2tplQjOa38zu91Pk4jFOBZxctkiCir8Y82irWV72lpf/yRTN4l8LW7REugMugllzVGXxYaryQzwJmY43RDxi/XTqxClOtEtfk7MKQoNnS1buEZ9rZeji2DEE3bFB24FdXvhlNkAOMm1efFc7gFe8o0SLciPNasiqt9VSTiMSZ11lHSJ2fUAZGXqhnF8Q7Xem5FjsZWUq1iRWsxJh8I2aY61kN8P5vLeKYXtRet/llhLaby7W7vI2j9cA2ht1g0Uwh0vuT6k4s9bm1UTlIlFVL7lGuryx+vwk0pGK1G+yUuJ2tcSWUp86lLpKtZNbLeMn/8XZr5b2+F5Z1krX+mnLiqar0S3ZkIFD2Nfui2ZjRmBXmBoTwGK2MzyN0WebHNsn/+crm5W87oo2Gcre0Aa4vw1o8TQaNoyWaX5pdlyKp1vCNVr1en3XWErPG8s4trf8Ni3histGXJ14hnc3d4chgyWi4S1Ru8lscFYHlrK/UAvXZ6TwOUdY1g+HeH0fC2Ww+2XFt7EbNy+bUuqdJRoxnakoDhxylMdQsCkPPMt5yvLzspnwg0f8llXaL2Y0etcrbrHjW0yzXnNZk3F+9MhLNPR3E8XoitSg6JVOeqWzVuyZVGJx/d1ZkGE960i+KHvHvmom2r7ksif5+QrvQeAY8ey0hi+1cAqsl9v+RdAYmHXLFSvI7q1mNhuFHTr7WWZHmfeCh7biJf/yaMvY+57Pdv/3icl97vdi55M/EYsBa14OkVLSXh9aVNBoadFn6OKKRUzpb3l6wGZpLLxhamh2ZLAHfiR3cAj4anYHdrdXbAmIe+1nctQ2ZTZGZcKnZYv3ZMugPRh3VDJFN7rxCmPRPczgUAQmcoMngryAfdl3XuFnfn4ldPBXcOymck1GfDA4fqc0cE7mDHiWK3tlOyokYHv1eTlyhPJmf0K1NPbGfHWHLtMnNgI4agFXhbqAE7n3gIKlE5Slgg2YXq8GgTz4bAoWPMAXfM5DbXCmUKsRGZuWJHX3gY8XTJhAYMRggrrhdyqXbW4XeBG4htt3IpdHcBJ1QjkVg5KGg9W2Sk2nURn/F2lIBjLsckJDqIVdE29sc3QltYRq9Yb9l0RQ+Ad1EIXTF0oRhWrJ9YBc+IVfx4onYom4x4It+Fg/40VpOGkV2FqLqH5FJWaKKIfr1wvXsxbS4HHJ1nJ76He3kBNkx2SwBojPKINgGHvUKDS6wmA7I1raJo1394u+JFidJn9p4XWRWIQ1WImRyAujcIVJRl/fZIRKqCG2xiOnM18+QYf7JIV3QIWvh4pE+Aqw6GUN2Iev6IWWOIaDqId0JjrAN4EO6US+uIv4xXHCNDv9pjmwIz3JuJGbJxZiGH8yRCxCd5DQGHbWGHvs6GtASImyuI2p2I0SJ0MA2Xw0SJPbiIDX/zgcYKEXQniAIaSC29AqzRUvSLeJwsNBXBILnhIW+iRkorB6UCk7WLhe6NaKA+mKYddsBmmQNIiQ2feQDGlfJKg2jtZLoNMnwbZD1iKREymCnWKHZ0Z9GsmR0OiRYeiVhNh5ehmNJ1mNQPiXf1mIJVlD3igsB2iT3/eIIklylFhXxuGYPFmOALmVxxBxx2Ic2MJB8ih89Jg8DAUyUhlKbMEzUcl5e7mKVrmVscgTvnaVH8mXs7hFuDiWOZd+zxcrtCknQ2Uktml8VIkJb9loUySXqhObsmKXYTh7yXmaqLmXIKmSKnSNVliIL9aSvUMzutBjj4WAuaGViFdwjImOj/+5k0iGk6u4jjoEVPFolGgIccvgOsMEmk9pXPQpXtj5nK7JleQndqp5e4uJl9H4V2D5e/gSGnKyN27jNsLgNlOiJ1AiHt7Ia0Jzn8D5lpelCOBFdwq5hqNQCZywnAE5dlrnZf9Ikll4cNMpneJJOzB2miAiCtpZbWLCnU2ReBOKmDxYhefIk9vgk6p5G5u5S+s5LZZZKgKDJLogQlWIavL5VabJjVRpnpVoSkb0Ml82meD5dRP6nMsleUfUnatxc0UFJWwyP9dgHQy6oAWBpmQ6PzaXfr4ZpSbIKyGIoZ3lNtapjPDJjCHap+w4on7qoq24ed4nmdHJYJTInFYCFpf/dIg0qpghqZPgKZ0r+ZjbkKJemBPJlzyokolDGqQOl56r8H9MCjILwiBeJYlQukqfpqJUOiY4KSJfuJgM6HOr2qWPR0YHeqYNOg68KlXecBnBCh2/yqsEUQxqiqzFMAz9oqyUd58+93aZxQk1RQh2uFmZc4IzFpsiiJyY2qfVeHVYaolPGpCqCagpKkoppHnWGKWt2agb5ZPV14MwVJ66d6I7eanoKKUeiUxI6FPLoiP1MLBBuhREuSyhYEKtWXFYMkhJQHWKdgr3ObEW9ZspaZLal6nhFV6vSXHoRrHw9xvcU6BtWqZhdLLtAazMShAetqzJqqwui6ywILOwULOW/2ern/YHVLQKL+Y2e0cFdxB11KSMHCqr/Xm0Armwf4qugZqa3+qq+yqZf5qSkvkUGDiOIydYP1ix5gWiJdpmKKqxYhFFnAqwSohLjtFcBnuwoPELItSukmWqDqsDQBuxIfN4i3irNFKcWXOl+glZJGqrA1ZsXuptZwqs2IEd7SEoi9u4jQsdLBu5x1oQsEAKpCAMsmC5lisMpDCzNlt5Oxe4rVOtkkCbxWgHSRC0Q/uKLgmloam0+cmFcRtwU4u0XsuvYfu0QTiOfWmojLq28RpYQWEUfNi1yomvtuOdP9mtY2tUbQOk9oe27PleTkKHUTq7qMoGSUC3dBBclvC9x/9FDAuqhqgndBsppf6pUiQqsRTXc6C7fi97uMLquPSrGfQ7rC1bEC/LubmguZXrCf5ruZ77uTeLbp4DhYqwaHjxs3eKtdk3uCWECHa5pLa7lbqrn+ZacUd7wRy8tLqytVf0dUFZo8W7t4h6l1IKthYsO5VZtqUSvdJbtkNkgcO3X4M7u0yJKXRLRYjmvaDyOeNrQX6VcY12n+grhpnFvkkMlR9Lpw8qv/gbrIFyv/cLrJi7oJfLv5pLuZfQP4zgxY/wv59LwEvsZcOJCBJ7RnHBwBbJtbTauh3qlCscuxrcwUfstBvMwdGpxx8MvHwrk7bBFH98gLTanMgLmSU6mWL/0bxykyLB05lZEQ/1WLAzHEuKkQxbE62SJUw0YSA6cANUEAZaFUGHRm7uG4xlSTR5WL6iC55l7CASe1wSS6fyCx3aoBn5G7nvscu8rBC5jKxbHMwFUQprxAiAEAd7MAd7YMyPcAn+O8bg22VXUq2zk6BsITP1ZK1NZ6MvGMdGm6L91YVzvLEqaqipecfjzMfq3MdyJq+CLH7geM6HrMKKvMig4INCWcmZCcOUbFqWPBXWs6WgycmdPEgvcQN0a09SsDmZIkgsYUhLSVxKDL9ObM2rO7G098qucArdtdGnoKbFCsXHyrlZfLi+3Msn/cuau9J8FrmecMz7oczN3Llj//y+KyUJomituGLR57K9fwBpevuff/BJ6zyu9UzOUym1FZzHvlvUelxEwiLOZjWvhJy1Vsmc1zi0MqJdi5yd+bwy8HhrRQl6VSM9fArBHXo9+VTQcPDJdOtH9fSw2xvKC31PDX3X8MQSXpUH5dZdQBzE1zyHLoTRsczRxVXYhb2gvxqzBJG5/7umwwAMv/o/MifZKZ3LAgzAnWu5LU3MjzAHUxAFPFADMDDaH5EGX+wJNavaO3dulnApYlMibMHTdfCwyvY5Vh2p/3kMpaawmIrUfhsKwh2adrzV6QzcyE3BTh1eh1jIK/jOMJaC2ijPFhtwyiu2o+Cv9ENhzAPJkv9MsN8tw07yXkm6jmit1vl0aAeiA9x7YjWl0NtLA3Rt15aD1/bdW6fqeiVC0XCqcxy9CAAe4BK9CBJL0vxbuf370s5MCi0d2dpwEGsq2ZF9DRIuuQmu2pq92ZlLCV0cB6K9AipAAiIu4isQBXMw05ktbjYbTHTAw0Jr0W2hCNubkSvHpbQAajmh3MnNswRI3ASIzkYttpK140Su40aevI4qvCB8kweX20H+ahq7JR2Zu2HxoWor3t4d3tPLI+QNM1qzNaEI0eutA3AQXP/tCBDkEvE933MN3wf9Rwp936R8aA2ycYFNMwAs4IugB3oO4IcdCYAO4J7QPyju4BVu4Yj/3tgXnufODOiNbsygPdojPukifgWAgOI0/bneZUiLlqaXdQczjqesjNWkeuRE3uPD7dRUvtxV6OOtntbADRy1+DOAHMjpEHI+et2saJX9yruvTq11xd1p+1yf+k9gHda7wachQhOkPIUMUghqTubBKc3CpQiE9ARUAMravu1r3u1x7hIMzVUtMedOeUzccwpejAd7rgfsvud97gjt3gfyHujOjAoTTszDbO/DTBD6XgrD/AkAz+gzDcbGfAWS/gEITwGUXuJzwAj4LsCMoOLkhgvCUNHWjAu1nWzPgKbcjHt3VepNfeqonuqqzuok/+uyk/KgZM85vrHt5aMjvBfO/62c1O20YxtgKD82ZLvKZGuPxq7lQB8aTkEh3F011HOe6B2FVPRAooChSYDQ+6hiZLzJmFLXdU0DCD3XWt/m2N4xDP314R5BS28TS6zneIAH7J72ah/vAY7p/v72cB/3cu/ZGE7oA7/g/YMGID7iIfABFkABIUABCl/pfTDTnFuzEY/YnuvpboPxoewIUPKIx3uF1CrBph7cBDjQJ7/5iuy3y2vy5Bz6Kg/rLe/ymAc8tT68ZoX68grI4myusG4zlP/q4POJ+OeLS1hS3a0tHgzr+qj0Y1FToLxMZj6zk3cWAilMBvLQCuT1gLT1LzHfYF9I1M/DDCLgao/26772Kf+R9ovg9nEP8J799uJf/nQ/6AAeCG5/CYAQ2nvvASQg+PI//yRQA1MACMGc6YovvowPEM9c1aFCxdEzddmiLUx2TNctWg9/7aKoCxQiRJxGqRLF0ePGUCFFvvq4CWRHlCNNlvxI0uWqky9ZzqRZc+VNnDlxvppozSc0oM6EKnPICyLMW9DCseO2LejToi55CTUaEelVq0ezatTo1FlKkJsU/ckozV07aQ2TRROXz55bee3iiqNrzi65unLn7kWLDtw3n0vr/iU8LtlMSWLv2GHMOGNHTGGSJIFTyVWsXsw0E+U8EaKlTKFXOUpMutBpQqgd8WHN+o4YKZMLSgkDh83/YtyLa++uvZjPIuCL9AwnrgdPcT1mkO+J9OjTJVKlokuPDr368+vUrTvHg+eR90jaAcWxsYLEBwrp1S9gPyE9iRVX0jAqJStXLlKw9J/i31/Y/2cClEbATLSgQgdFiJkHr2k2k8gzz0bBCBSXwLKJppQytLAlDmXqMCVXLrQJsrB02gmrp1IcqqqrgGKqKWxUjCqiGbGyEaIHSeJqG7++slARRP7YhK2+MiPSHn2SfIuvu/LS68l3ovSrsMGonMaiy0I0KbHcFtOoEzAVmawyTDBbphk0O8usKM4wczPLEEUB05VOKqJTFEmC7HJPQroUgzHb6iANuOI6WU455Yjb/wO87bBrFDrutnPukkm5W+Q74JyTbrwrzPsgBPUoYK89Bhag4LwWvgBEU+nwO8UTT/o7BUABswGwkNioKERBb7JRyMGKONuoEk6ytDNODStMVk5i6sQFl7SgjZaYYLXy8MNlsc32xxJVwuRbmESaKkYYyV3R2qTKNRcqFnFsN9wbs7JqR2nQ8ZGlP+xARJdxzmLozCiVFJjJgKE8C0rBGgSsyrqkUgXcPAHVF6Q576DsDkxWMfInGZdRc021nhWZooaoNZlabmMyEUiTwCRtOOGWK25R5ip9lFKbLQ2kOZ553vlSPBbpDjpUHpljCh7OC3U9Uk1F9Yo5VoX1Pvxibf+OP1oFLAZNXHWgghBYtOGnV4VBXpNEXU4WuWTNRj7ZZZFrTWhuug+utexn2x5ZwznhRGlOlLDMEHCVl3UE2TjT/bczZ9DdSKilOqZK3nevlSpHZetN68c+7RjS17Q2A0cvfkofGC/UmYRLL4atHExjinTkUuKMAEdEsonT5lhdj9dlHHLRGRJec4VDX9x4t/X+22U9DC0uUUW9uxnnnHWORGhAsg8ukKGxt5kSQJBu4VP0mB61vfdWsGGKOLLXtOr8rKb1mgC3hoUPHfJnwxKxyU4z5F7AixgDChDoDFjAux2wbgtkYAMbmEAIRlCCWoMb4UDkNwz2rmOVi4hTeHf/LmtNbl6W44m7jkIve80pLEGqzDHkYjyAxcV0M1RS6mQIDxyuTkqEmUbr5BLAEl7kW5jonJfARK1K2IEKcCBEKHahmd3BSINE+SDwFkI8173Qhwy724Di9iy4FYcMY5yDcZjjqOdwL1Jq1F4bs8dG7LlRjWj8AhBa4KkOdCACFmjaAfzIAPW0wAZNQEPUpEa158gKQPM7BRvyp4MnFKIY2uiVrUTnsVggZYC+8gY9akg/hDhQHZQcZd1I6SuEFFCU80gSPVzpylK+UpazhOU8aHlLemitfsTImjBC50u1KW5xDhEhiqoIwsuNcCO04Eq8lKkKZ0zpMCVi4R34NQ7C/7BNLgKj4ZJy+E1varF4C3PSlSiEpcR8q4iKkJNANvEaJjoRi9QAzAeP+ZOE7VCffTHYlPrZT10Kw2UxGw4Zo3Yp+HFHem6kWUMd+lCaacoU0hEEeWJgnjxmVFSjGkBH/WiBDHzAAzyIAtTyUDM0wipWsPjPfVpqCcmoQH+R6CQoBwisy0DrGr2q5Nay1gmB4uI/mwRqBcEIKzDJb5EAus9OnUo3XEZVqlOlZSejSrdjWBGTbOKgVofCEGvBLqzhamYyTwgSZ/jrXsOq5ueKpMG29IOG3cQhN8Epzgb5CkrREGtIuFTNJjpLFPAsS72wWRjeJdZcgRmdlBDmWIJBVv91B3vSAStYUC5wAQ2LclQcgxbR60FUtA/NmRmcYJ4UeCCjedwoAv7oUfecqgYkvcIUNls9q71qqffTAQpucAOvWWKSlNzar/TG0kWCETSHG1RzV+OIPIiiNX2qQ3Wte93q5kG7MBtoUofaUrFpoxq3vMc9XFleeqA3veZFb3nZ6973wle+85VlVr2KzBDeV4RlfQgJnflMF6IFTCXBSL72JU4NookcczUdOFl5OibltV+sO0wvKCJEjLSVWXiSzL4MO+F8Klax+WTdPk18Yi2iWC4J0RouwKSHMWZ2s97ZWXdsvCjujbaMe2hfQ8v44z0UMg5DNgMWmJAC8uXxjqr/bS1sXXuA9M22pCatGc+Qyh9PtJS3KOAyl3XQhkgIg5Kn9ClmRJEH6rJBC2umzRNoIxvK5Ioyk/ltnelM5zp7+be5eoIV2FAGQAO6DtttXidUih+q5QIYi97pmMcr3mpE2tGSDu+jJ70PTNPy0bAk5gar8q5xDbOYMXmm7P7roU74iyXqZMwopgRDzlADHqbDdIPxYlcI4xVhmBtigVsNLRdbzHNE0qvreBc5dTHssZKth4qX7U9on4WCzouxIW987Wv7+MdAJvKPbTtGIgCBCD1ggh1XAAINgFSkK2jBBjywR4561AAGcEB61k3SKZ90e5m6HpZhYQkt3KAEKChB/wnS/eVFNHUYwxCGfixRCEJIBrh5tjOcLX5xi9+gywXneMcH7mUYSMHNInezm6FwckHHeNDbJSh0Wx4cmMPcavz293dJIYyb/yfLwrDvirj6aVADBdaTawmLOqSRU38krehQ4ZYU82t+cmxjSKJr6nBN9SVRibLMgBNZfT0xaHXidmHgRDQPi9hkl8suTXmRYJyt4mYzO8Uo9os7dAkmPAjZxnEcLY+1TeQ+IMrbSwi3DAz/ghQkHskZUDd6RtruCjiAowKYt2tBeioPqI+kRojCZhcl80jIajUa1wAK0n16SDbPEzErAxxiqnHg6iD2tfkTZbB7+7EgorrwzPjGPf/O5YnTQPhPEP7wk/CCkif/CWJgvhiUsPw+Kx/6UGD+9ANNfTVnfwt04D4f2sCHPJAh/N7PQ6d7/vOk1KjnomYmqUv9fv8ufcBOZycLDyxNqStYrqWrdQ4nXNcHw7q5aCzKaocAihAMy5dWEwWU+YMwaKK16KEqYbsQo8C2ozt2iIe3y0AOxMBoe7UXKqCk8rsbI8EeE61u8zbBKySkKTzFUzzyuTwZVK0NiDwIYI/Ky8FT+RR2Y7cfoK2GornQogMV4DINMLgSkAAlLD0agL7i6zIU0J/b4L7SAByj2gUGpIhn6YhOYCsgQbPqYj480zgo7LLfisLiQzzkewEaMIH/NDy+JBi5kYtD2XCzO6vD43uCkHvD2PABkvvD6ju/jwE6Qly/YWq/pIsIpPMvmUirswCLLbE/Bpyn/0GT/eO/sUEdvaKsuzo7g3mQOElALxkgDvMcimAsHqrADnS7VdxAuZOsutPAVkyHWfQnuwsQUzAUvzMj5TBBiEpBYCwyFoyC8rioxYtBxpsAZby8CtAoeMvByttBFUCt/PnBzvO7mAsOLTA9gSO4Izy909s44PMasgCNLNGP46JELNIcZxAZwRoo7bKu6rPDMzSBMnxCNaQBNHxDfuzHfmTDf3wkPmTD5RNEEAK6GekJr2KRRRyrsGBED9kGf5k/jwCSzmmZ/3V8imYIhwWjIbKhJ1mzIf9zkpHMqdgRxVbzmFF4DQ+DorSrRZiMSViUSZq8wBNDJVIQDmEsshPssWzrtmD8AmF0giYgShfkAMTLo2S0gAlAn1Cxwcn7o8uDD2qsRi2gsj7ISq0kjYArQ3FMN9MzQ5HDGP5Ym+HJyLOUnHZ0MWdxRzkxjTDcjeLLMzO0MzK0S37Eyzqby3wsPhNwQ3/MxyfwOfxyF4fwCIn4qlGjEI1xSBIqK/dTq2OAxLFwjMt4tShSsI7sPxxSsOICMdCkC078iic6SVazTAtLIgi8ImSzwJp8zbhrxbiLTdp8TdfxFfzQyZ3stuMwg+7gxaAUyv+hNMpxCzdywwEcOIE7gsHyeUqoxMHXagCQUrIVgIEerMYt2Cyt3M6sbAM208Pl68s3XD7wO5yTccm0TBGvUEuTAaC9GZw+cI3bWDPZe0KvvM+6pLgk8C3Ym8sotEevBMx/JMypSMjE7C+rMMTJoZCGhEgH5Qiz2xwCs8hW45FUZKw0kTVMLB1y+EyQDE2S7MyH0AwEPU0haQhQyJdRuClUDDHZrM2ahNEYrU3XhLa8QKXcZEEh28ne7FGg3E0sYJ8iK0rjHCQWQM4TILcTWNIlo0EavIALYJrolM70EaTN+0E/7LMfIzRCa4OUC7R5hD5BK4RFmBX0zEzjWU8VUdP/jhmZET0WDMoE1eC+eezD+pxLu8RP3wI+MixDg4PCvexHAkU/9OMIiGAboOgv/oK/h0EMyIRQdFC1CW2rCG1RKbLEqvtQTdW6ktSdUCSWIgqi1ZRAcoJJGT3VF01VGEVVmpww3MxJHd1NH+1Jnuw2oUSDIG1BI7UB5FzOF0jSHlBOjHpSEXC3KIVOJ7O3zLtSZiUp7ttSLiUoMeKC7KOD6DocMwUmtGRNNu1WxWSXQZUIvzEzcgWN0zhX15BPMG0+yYCzN7M42KDHMdyzO53LyXiBnytMrqIcxVTURU1EEZETLVq1IiKLV1BHuuCYjcQ6Dt1UhyXAg8FC+/pU1Wyh/8MgFt1hGFXdWNuEzQ5k1ZvE0dVbQSD10d+01W/D1Vwt0sLz1RdMrYyKUijFAChtsikNqQ7wQV7lPGLUgittAy4ltGyEsT8rg/LEmpv6lQtNO29VS2/NV1BsCFAs1yxZLqt1rkFB1y/EE9IgkeaRri+UxymkU3atjSQIVxN6UwNVyP361wdlULi9iUr1CBJZp8LKyHDYyJ/A1BnSxJA8O5/YxBVT24fQEj0xxQAChSfaoo/l2I513Mad0X06IFiN1Vodsp8EUtuagpXd1eS8ozvigNUaXRtcmgaQN6mcSp2tLdatLS3IH6ANWn2bOeFQM/BD2qTdVhHrmKZ1WoOsFv8IcRMLg1MM6hvEMZwKSl46wVZJoJPZyQ2oLcRCLdCvYki3/ZCARUzJnNSLXFGE1dtK3Ey58lsugli0gKZooVgF3ITEXVwQlVxZBFnIhVz5dSyRjYTksNwiOw7+7bGd/ALODeDOZdkjvSPlJF3nlNKbVV3Dyzeg9dIroAPait1oRara1QIyzdZx0t17Us9v9So2/eDohdrhBRmT1EIU3hsrZBYX+4r2TGEMKjq0NUx9VYuoGJbrfcxu6ZalS6FJ3b1R5daEyb9muDUOfawL/T+JDZCoMFE4YQaNpd/6jd/HjVz4LaetWb383c3k4N/+TUFhzNXNPU7jVM7PNeDUEl3/Z5S880nWGUwBAx6kCI5VCN6CqwzaTDkF4Mg+SyhLWtlgdlzP3f3g3rWX3hXhKRrEBDvPF25kaGnHOommOhG1rSph4CVc6o3a6c3kts1hRLyWuN2JSoUGulWMi3yMM11a39HQI9Y1LDosklicT0VNniCeE5PiKr7iKa7NftkpnIuZks1cIsuCIDUDlR3j4txVJW2BE0BKNWYtPao3BQak6aROZdasWNWuo/HOkoJWmnMENnhAM2XRQEbTQl5TD/agcvZdRP6dRH7ndo7n3wWgEa7nTeZkU4NbVDveHQ5ltBrYCQXiJkLf3ilVkJQ6ZVjYVsarDxtcefoL0ySieAqW/yh2LFzO5Yve5RC8BobLSR7bYp+8Nt+01f8dUuJUZhtI0iRNzqRcY+dsSga20vVxgilgXf2dg0KAYArWLn7rgym0hAHaGg5e5XQu6qE25KYdZN8ROm5l6vSkZHYeVMKcYRpe24mFiGZ6VOztZ64mtrWKxD7pXpJxEY3dW9GZtYXmoYb+oYdunE8Na7EiQA/EQCrGaLvm2F62ldX7aJ60sTHAtjEY5mIWziBVUsM27EEybDiGWT1y6VB5PMOm6TGGGh0tBBWEVpZ7lT5oA5HbFZ8i53VW6nMWZKS2UGhratSuJ6bFUHNmbcw8ZHmWans2P03uZK3eaq72FvTtC4L9uv+yOEVSbZ3jQeusu9C1DpGNQUBJHNHGmmuQldG7zugXnTD7Ca3Lvba/Ds7/nQLETmbDBt0T+NUXWM5hbeyM0tkgILfJHmP91cpC0mZvXgQ+YD5CcAVtDZ6nVs9uHW2nLm0bfbULpMDVBuRxQjZaVO3Qju1vDTURIlRMdnCszm3c9mcTYcAp6ULK9G32Ze4WNe6SGYfTgWjWHMDJzNjh1RE9ad5J/G/pNrEa1WWNls3/Y7jQ4mvMvbHARhSSxoLhJMru/nGVRlI0Ht0elGn1Xu+izGb41uad7lI+lhZYGx6iJm3R3m91ZnFVXO0sP2iD1nKjjurYrm1BLFCgk/DCcdT/Cl+JCG06sE6NIHmMxCQSY0OeaCDut4IiKGGmxV2IEn1zTWroFr9lGH/FGIcsX/63NgI8NvpiwRbgHv/x9D5s5AxWcaP0JtXZXa1pJGfvbcNsFhy/6ArD34BydnxnckFwKvfy/r5y07ZlAB9iA69RVUZ1VU9TMJfnTP602X4XCjfzND8RZ0glbqmEN09xVYjz4Bbu4QWHGjIuPAdo0dnCcPFz2MHyjZ3iF8foVW1V/8sGWcjJGkeURR+ywM5xwh7sAUbpSF9mMlZSIQfvxPZxyT7yeKfpOYCej95iLy2k2LVd+x6qM31qWmf1Wk/1V7f2LZ/zhLVUBC/tL1fwft31/xF2TFDI6hNBc4jRCQs/397OMGqnaIOeQK67zM609Tx/HLBS1IixDMUpMbrG9lIddJiXTRzqlSx+hHBvHzbSbnQ3aXY3bO6G9ElfafCO43mX98SW4yR/7z1wbxVEg31HM6M9CPspnoCPooFXddds9YNH+I4lJ4aPdVbXL3aWooiX+On1EIu/eGriCmJJ87ltVPqzyAzDSK5HYojm8LQ8GB/OqvRVeRV9aJcv9Oh2XNqM8bPolYWrjhy7cTVKA8GOg57ncZNmgXZX73UX+u6G9x4Q4x7I/PXGd77m9zIgfajXLuRCkwxd/cx8bQH38gPn+tj3+q5//doP+9au8oc/e/+0N9Bn+vXcpj8ToYW4xwmPh+uV6ELT/qeF/4VqT2VxQvm/N1wDE3xBj9y6jm5UnU2LtuLpdgdvCH+OXnydUYNFh3zClnyh5Nz/hXQfz3z3J+BiPPKgH6TQt3emH32oL/2oB4g+lk4JK1isGUJlChdaa+gw3ENu6NJR3CbxYsWKGCduzOiR48eQIsF9IykNYsmIGFdCc2axJcyYMmfSdHnsJi+cOnfuvOWTFtBXqoYS3TTKKNKkRzkxbaoU01Ok0FJKK2pUEVZEWrdWkmpTXDt38sKSDUvy16q0yRieNHtSlNFo0nYt26XLlVBMiP78qaSrbdmJ7AbXK0zYMGLCihf/M26cOJ7jx44dw1Pn7fIwVJovCeqsRk0g0IEAAUoT58uUL2ZUs16N5XWP2LJnB6k92wYRJ7eJ4O7No8WKFjZS3yZOHA0ZJ2TQ6Nnj3Dny1Fe4RG+TZ6CsgrAQckfYkSpI8N8Hf3z5cmT49CzRi1eJ8mLN+C7nmpfvLKfOoHf39/ypX6hVS0U1YFdOQVVgUrTI9ZZVWTnIlVeiuFQWheOclZZaay3oDkfJECWXh/ulVQkhfIGSDFiBQTbZioax+GKLksl4GIw0koUZMLJsRgklnY0WiI+lnZZaa68ZCRtvxRlX3Gy66Zakb8LVtuRx0innxGrPQTcFF10qVwZybTBC/8pBwmSXEHfjpaQeeeuxl96bbIp0UnspwXenSvXpuedXL/WJ3zG09PcLoYD6ByCiDQ4oYFIGHvioV3Qq+iBXiBhF1y6dTFiZWGNx2g44y2D4yl1fofPMSbsc9VeqIq5Coh2EKPiOirTWaOutt864662W4ZgjKjw+EqQfPppWJLJHxnYCbVPa1puT0Tbx5HBLxmYctFVGl2UcW3LZZZhliOsImWd214xC1Kgpp5rtxtkmu3V6dN576rrJJ7514gtUfoLy9+9//wW4KIEIOqrUMQs60yCllSJFTDKaRjOOp/bkw+nF4rQ06i0a0ikNNHCp8hLEeI2oCBxwIMJLOLXimv8rzDHKDCOvkXH662bE+iEsace2NqRrqj0rm7W2RXstlz1MAS2yRWuLHNRzmKGH1NWBG24bjsCi2bmwKKMuNea0B5Z6FsH7rmPuylv2x2vXa3bb+eprZ30AG9qfwIkOTHCjkPaNsMIiX9Xwg3HR14s1ZFmMMTzvfBMox32CvGqquLjKyR9w/DFyii7PXHPMn4fuos3y4Mxzt5911plp3f7MWhZALw2ts84mfbRySnIrO3G43S5d1NxGR52X4Qq09blogi0eSmc7//y60MeJp9tvW8/2hHC/qf1EOfnrE96H6r33wXwbvMn5lE81eVKEF64KLugszKrijMvzuPjLLAj/si7qr3V55vxCErIJ5mWjO2DNRJdAWpGjgZcJFutcp5ox/EhIErwgsmKTpNrZTltcotLPTuOa3iXJScnBEhpWE7XpRGFaXRLXFb6whzGVS0fNONPX1Ca9HXZkhzykHvOmV6/mYS+I8dqG3bz3PVeNj3zt04r5+DYUVjFocO6DolE6oSlRuAJFFKsY4yYXOYcs7FIgkhBdhrIXO3BiU6AqoAHjiMDSiY1XC7SRpy4DjFIMS0hF6A2R0hAa1xHSZ7ETWhBswIIicHBKytLWcKZFpGRZiUkmVOHwvNRCF8YQDYB4BCU0o6MzyWJ5dFvTi7jnw+f9kHv3WuX15ubK7V1k/4lKtGXemhiKXUZxcL2c4nzYd5QH1YFSxcRKJ+JnOQ2BsXEZk99PgBmTD/kJcmqM1aze6Dk5zjFGeHzMHWl2GW1og4/OGZIHgjMc1fwoda0jJGumMDRFNutIR5pdtiYZtHj+znecvOSVmCDQf6ZmDp+cxChFOQmx5XCIcGoZLFOJSrVpb5Zoi1cRq7cnbhzqlgELii55KVL0oQ+L5UufUqZIRWGWlHDFJARSOvEMUP2PGZ1bnDNBxQtE/UIm1HRJMvt3FBNNiJtwNKquFIgYGe1qRt+cxzj5SEgedCCd65SakARpmnfyU55/ZIFwFsksRxKykkrzqgdRUyVqQelauP/bJFw76ZwxTQKhmrFrKcMmtokO8KGsjNlgdHhRvxJWo+Wx6J0+aqiQFsWJLf0lweCnMA+1lBCVsqzDDMc/xCXuizjNmDVJpT+XIMom9ykj+rAJGG0eFalJVepSwSnbcEKmMlAtpwVRcwGrBtI0pfmtBBtZGxaQgARhtd0I8RlJtKYVkhq0pLQGusmCOgeUCsVrXk1JxL4CNqKtROxgpQdeWW5UIordaS4ZWzCTQjalouiQUC97TGLGtBOnikYv8qs/sHwWtEIV7U0oOwrThkxwAXQja1372trCNrYOfrCtSPfNi0VVSFL7gg1UYFweFAGrFRykBFHDwRZYYAIeWKT/0Yx0JaNVq4NrdRo+m5SbaS3BCHHtJGkugd2Efg0he+Wrgrv73fAWdsgYnROeeOpR9YJiVQV7bHvdu9JOVPayDjrmw7LRPf3ut1Ofxe9/MMUJS4EZLtbEHBsn1togyxHCTXUznBn8zTjaw1d7fEQhv9CCEBT3qoIQlo9kR1Z5kuAADKAAiumJpLOmmNHD0WC0QHg7GfvGxpa2MY51XNdN19WGODRikSWaNiQ7L3qh/mF4KqrqeQUWPqTyz5IdG0UHRVnKdMKFyKyMWShCaBTxU4eWa9plCltMY6EtFV7IbBfUDhObWk4wm18W52lnzMH9KEy1s03np962nJfomW8x/xyc4DQhEHVNBaDVIDvYLY0CDDD0Ch4t7ya9dTdehW7uKN1C3PygBv7+TSe/IMidcXqUdvWxQ6MtZFoS2bVAPuL+ZNlqbowizJerdWWr7EvIwi+YqNW1MWF6FFHM1EJgLtVqnykqAIkZijgJEFEHCG2FY7uZ2qZ2xq6NbZ1frOee2raDbUvOYXybNDnuzGl6AwjNGAPddRXEITEYhBVk4N0T+ABYFznvZiXy3rVrK76pdZvf/JsHmJ7gnwtecBtql7sLF7VgtyvqUceSr4YFIkf1c/G/nfSJJIIQSqPYWImpEeSG56I0xHKWQvX0pmMRIzD7dweYpnFhBt5c29as4P+g+7zzON/5tXl+859rvuaVISc50W30g16iFD0KBChZYQxksMLpo+nWGD4TiKR/oMQMmIAFqhrWEn69687aOu3w7btKlx3ggRwE9DltV4TeEOF67ebbvRuzh9+9+/V6NRNH6rfx+93KfZciNaVBZVWY36WTX1UnFD+NujC+s53bLDDZH6ssEkVkJvrLRHCI5g1ghHkeGBlgnIXexfSD6CHgWEhbAYIR6hFdH4FS2jHd7GUgMKRCsLzeh8XB1IWACF5A1V1dB6SAlDCXk3Rd8iGfb1jSc/GGDDSf2XWSaUSfjkjfIRic9dVR9r1dD5XED0IUecWN93mEwEAKrXVFVpz/DxYZnqWgn3sNBdwQRfuBnMipQvx90ckBikP82H3wS6YQguZciuCMwhpxTmsR4P3JjAO+oRt2HgPOoel9Xh1WBj2kXge2Hh9qRipkYDlo4F3xiAeGxtRZFTphne+MkHAl3zxBi9YxywvSE781XwuxhiDVVTDUlTfIguztWPX54BCOIimi2ni5XfUwURM+yhU5zOGN2aKcIaN8iH2hw/rtGuDpWhbWolvQH/gww4YsHl6k0eRFIRdd3iYo01GhomvdIRw22ALSYQPa4R3e1uztSOvtTCihAjJ0owZu4CAinQQFRxDEgTbiARa4E+8cDQu24yPuxiQCgREAB3CQ3SLG/4Fv1dUhaOIkBMMaJJSOxEIpiSL2leJfzR1FlNopHqEQusIpDKMktCKl6AUUmt9TOEJSyGL/VWHhuaL78d8W9mJ+dUws3ES9/I/lbMLk3QEmaNExquT+BZPcsWHnMJgzkl4ExqE5RCMdPqBP/mQD2aRQ1la3kVPtud6m9SEwAOI3cuAkFJ3P5IZq6JjrBZoIqVgQYEEjJdo7vmBY0WNY/YYNNB8jbVUmdprs7aMsBMMOAuRAEmSLGCTNGSRDct92wQcsPKQlRCQfFIJEul8xXhb5RWRGDshLrl9HXlFlsdFQyFTJiWSGpIvjnJFdoEwxuiRcKEIdqNY0MCNN1iRR9v8XTm6TTVrMHDbgTjJYUPrgaJbmPOShHiKlwXHi7FWDbTblU+aWCO2BuaUCJLweHgTnumXlOyaSJOLGcdJj1oFl1tmjIgkHh13BVpUGDm7aIewjXtWVQF4fXNKWd84ZXSpk5tnlqX3DPeShMESCJNCBZfWlX/7lVpSIfOLiKtYaNSXmFcqXpTRm4nmZsZXkMEqmMKbWSr4kTMYKinSmZxIQUg0lULYmaEagNGpbakZohcTD6HVbIIIjQHJjbc7Cbd4mOPoBIFQN7v1IzrQTPq5jO1JicWoQWD0nc34l2UlJWaaB6lQnp13nKO3j1rxld0LjAn0neCKkd9XlRtzDOeD/wznswzDkpSM4gnv65XtWacjNZ3zWJ2EWJpeKFH/ip2L+HWa95C505s81BKGoRUmCA02BmWVuJktiJFyUSJqNp9zNnIWKJoRCoE6i5gPm6YM6qNDpYWYolDeGKKJ2Y276DCD82bAAGrjhQYhh5YsyCYzigFg6Z6bG6HJtlSCogRzo6KbJglrqyCVsB3cWJLXhEasSaWOQZ3kWmSeYyVLeg61qwzWkJ5XmgZVeKX2+D1a0jxRq4ciAaX5mRRZSU2CgS0cp6PwxwynMJxvQ5x1ozivsV0TMZDMGKmnODKDuKbcKav0MKjhuoLnWZjWcQ6JeI3BiorCk2ztJ6lU+ogu4/2gPHCc8nsBX7utyiiWKzYBZgqoOtiWp7mBd6dhBBOmqVig1LhhsMUbcxarmScQi9EFzRIKZ2OY5qGuu6qWU9uqVYSnhbNywUqEVHuuVjgJmdtGzvZEyNKtJzN8qlMi0BiZWVGsYKAJdAKOawSrQhSufdivD/mTQfuuF3sw4lStT3ubGputtsqtuPoIp+CFwntOkUuo8FR88Cgd0cuqmNicjZaWniuplrAFbTh+qpiodNaygxlmRhueCkocBdURz1K1zCAQpoF45nGc5eezHhiwf/KqWBivJxiKx/h18ZmkdaCFi0kVNviys2ZTGIMR60iwhvJRlsUEYqAxnRZypMf9o0YZuToru6AoptyKtHi4lojap0zqtus4eJegmIISSU1JCH13lPiEJCzoici7LvdITpmIqv4rlhiVa7GzVGVgndpqt2W4ijwVpkbKt267t28It3a1E3VJN9l4sKC0lPdyDbeaqJ3QCr7pnX7bn+Q7ulhIulE0h+6HsR9rXRsqcOfhihqSJK/BBzbIB/14uVqSMykCM5/osKlkongYg6dqhAZ+ul/mKNpjr6m5s076uiH7bafxW642oBV/tIzWLWGktlOCAvs4gpy5n8YIVI30BwOJo8k7CdbJCwQWDNyRCMHiiXSnshEnv9Oawq77qXAbZHGiv1PAqEQvxIswqOX3/bzXQgzCMr5RirvlqpiJgJOGq72MRruBYWeJiETr0X5nSr/3mRJpU7uXyb/8GbhhQARt17kMYmbZGKDM+bPUaLQOj7tMCogSXw9Tu8dRCJSFl8FG+3m5S6gcNDb6egAsY8r1Cpwhfaj06JwqHbRF0AQvroCd64hp4Ayvk4ChBrw5/8sL2cK64nWsJsYkWMSrnQXMgcTXcat+qpyNcx5QqAq9OsST87fpWMUk9heCiLPq+lxZJQsUlKNkw60+sKTHkL3ua8RlfLhXkLMvyrEl8h0rYKeg2aFzCsXcC7dF2ip2prm2qrgSnghkshxlIKtWEUG8upe2VqFoRMtdlbdYy/ws9MzJwyChY+WvYpsERUHIXXOAkwPAabDIMB/Qmd7La8jAomy6c/WA2XzNEuxZyqHLVCDFz5MFyYDQq4wEpXEMrf6+T5gKuxbL+XoeU4rL7rG/5we/IjkwwQwX9NJAxR2YzWMIyVyszs2car7EAL8h7UA9NROxnKlD0cnMdi8UDJ+pSSnApkIESKIGT4IAkp8bslisHCoJzsMZyeR08JnI846tU6+sI9+sji0Akl+Mk46gXRB8r/OMaHMJAkyoMczKQUq9Cly5Dty1Rq+oPk0fwTPREazRzZHRg96UenIIn5G05bCz49q0W6YH58mqU6nIusy9MeuSxYpl9vXRLEv+D/akLgEYmJsTKMqdMzaaxGktIT+dJvshEtkrsDwutbI+r3oporaqrKZRzD+DAC6TAB/BZvFH1JPzhUVqtVoe12PkuIPnuPNUzbyBy8Obz1+pzEcxAP1fyGugjJ2f3P3YadnnyQhd1eHvrXs82EEeNYA/2YAs2H1x0Kl/HJ5DT3t7qHj22LdcyyOpyZkoxSzPhZa1CyXip5Joc/WEItCICHCyzFsCBFui0DiSBGneRNHvuTATYn8iPRcH2UIuuUR9t0h5qN7ZubvN2b1fdB6RAD6wGVVblHARcJbXACfIu141Vc2tdlNizPZ91WqfBWkffIIBBDk7CPxosdvXg0B7/eV6Pt6uKMpJD1EP/NZSv0HIQNpi8N7l8Qi60MmPjqq5O9q7ispdX2RaDHOLg2pZyloUMaBfZ9P5qgZs7+DOvzGpPFoHVuZ1nuIZvuHl3a1BeBj944x+2sojigROUuAVkABGYQdoZAiSkwu0ly5D8BgrGIHN/dRCANSVKN7+i8HX7M4+7gY93Wnbr4z8GOUIjuZKnOnkn+RyDd4VWeZRLOdYMdntXORls7yqbgsZueS6k517yZRRfGX9vMZVmKSZ4tpkfiIQ7K/vEAiwUghkzOIM3OB2EgQ5sriQQxJyfFk90u+REXJ473AIXIBcmcJ9/eC6UQqAPOhZQVYm9gDma/wIlNHoqDII6ruhv3V4R3DPY1U4ie3VXPud02yuOdgGo+0GohroOclpafneq1qGqR7yTlzeTK5CUwxAZwPrFi0sd2Dpha3QdaHTdZvn35jGukoKXz/LHzteYi+muKRNhQtGyE7ha2PS0m/a0a4EUSMG0OqTlLBO345K/WDiB0Uu4H+S473mEkUXYnHt2uN4lBHoGGgIe2MBvtwAeMLoh8MgeD1IW6NMEAUkgaGW/2wbAf12m8xuO22jBmyXC+3iog4HaebepG3nESzzF573e87CsQ43GzzrGZ3ytU/mUf3xzdIKuLzaTsm42+HotYy5+tzylxEIz4ELMZ2EvtGx+Of+k/pq2FpjdtS84z9eBI6z5MZ7XLwbYyHy7NRPw88St0kPgF+2kA6E7lqvu7Dk6FnjAB5iBIUyt1jM6JaibngW3O8bBGRB6ctfGDJi9B9v4jTOn2OLop8qBIIQq9iu8Dr71GjRCh4Yiqt893of/3pM/+Re+x6f/1aA/+3c8+1s0RV8smWiD4jMpeo7v4xdTsP9lJgAEIoEC+bhqhgsTIYUKFUnaJS2bu3GuHMWyRAeOFo1awujwKAUkHUV5RJUMdVJVylG0WLakdcxZTJkyt9W0ma4mOp04eX7bGc7nT3ZAhxItKg5p0ndL2zVl+tQpVKlJyRUj5w2rtmpbtQHzagz/rDFThtRMmSLIkCm1hsiOifPFLIsWRab0sOvErg0sY7CY7dsjbhDBeQefsHEYMQ8Wh1vIdTwlSxc1Z/wM8iJIDtpBmzcfmjQIzOdDng/JWhMM62fVsppRc20Odj3Zs2PTtn0bd27du3nH8/0b+NDgR4UPr32cNxrlZMos58Ic+vPo06fXsV4Hup7sefKQ6Y5Gz54+fR7lArYVX/pz97QJ6/See56Ghejzqd8Qf/6BiO4QMohwIIY2wYWZiJJxyJVC4FhwIx4+8kgLkexzRBJMNrlwFE5WcmkmmmySJqeghAqxJ6NE5KZEE8FZkUWqhJoKxnGeeu2qefgph6utvNrR/xivDBHkLUHWWgsPM+Dq68g93jIyCyT5+guLGf4ijErDELuyCMToCmKGOCbTrDLOxBzEM9FIW42fYBpZo7TPWGONRuR6A27OOumspx/Z8rTTOOSIK243OW9rDo0ypPPOuUINrW5R6hp11Dvt9IgvvkUiKSWXa8pJTz162vMEvvvsG7VC/fZTyJKDEmJIIFEIzIYYiiiiQwseav1IhY94CIPW/kqtBMMNbxm2w5g+PFYnEk9cltlmW1Txp6hcVOpFF2v0Zp9s79m2mlQ++cSUHdcCskk82EprrB+9dGuPyfAIZAw14F23ySkHI+wEK6lEMoi+pNwrjYC/DHNMzkgbbf+1Sc5cQxZvZJFlNVjgFHTOPeXJh8/dLMY4Y4rZ0c3j2Dbm7dFDD02UuipKXhm6RL8Db9I5Yt4jkvKGqeYcTvFZDxn3IqlwVFLvI0ghNvyLVRJf8XOFwFgrSjCMjXDN1SMfpNiIkAqDVeklmIr9SVlnxV72T+KepbZaGdO2tkZ+tN3W065ysbSUVNYiC96+4o2XrXf3fhLJQPCQ92/A76Vy336xMHLJJQMWhDIwK7ukYINHK1O1NRJmGOLOW/O4n5E55tie0U3veDbRT58TUNR5Uz0e5wi9AlGTV7YC90a3YLnlR1+GebxKxbO5nJzxWQefbYNhzZJC6JBQVP6KviP/FmYQsm5ppnGRNUE2bnUQ1xtMeHDBVjF0pWuvjQ2b/bGhdf/9s9Gen36J5sHKxnL20R9urtQyJRd1o8QZ9oYFuzSpcIbrAQcMgyS9sYtfhyMMwNxSOEEI7oKBgJwfJEcw1YzpYJPQXMImIYvRPCxi1YvTxe60utK9EIYxfGELU1fD083QhVEBGW1C5jraPKdQioKU7aSjMt0ZUXdDbNlyKCUzmYmHbjczns5wVAxGiOp5WSTEgmLhHkXUoSEmEaMkTuEINkTtCVarmvhQgAIa6OAJIQljSdCnC/VBo33VQpYe4Wc2+f2RfvWzHzzuV8i3cYs9/gOGKSiRwcEFoYEO/3zglGaAF8Hki4L1CgziuvQuDGrwgqHkoCAaOTmClfKDIMScCFczCM0hDGKTkJgwPkcxPeEQY6HT5S5lSDpcvi5jOvQhbmCHJzrZDmVKfA4Sc9fMJCpziUwEXhygGIlT1M0Y99DZOc7hDVj0IWhahMPREjTHklCoQpY4hfM6Esc0wsAEIZCnG60mBqMhaBf5/Nqx8gg2ovgERAH1Zx/jF0iDOoWQNipk/uiByP51y0d9G9wYenCCwgxGkoCLlwEnaaRK3gUw99pLKCnxiFJSoqSXUGlKUdrIlr5UpWP64GpWGctYqkaln6MRC/Ohulz2lJf20EcviVrMHB6Vhj1Mqv8PTZZMsxDxdlHYnRGZyTvqSFM5TRTPVgEBiPKgYlPrQN56GNEGLT6Pi73ohDlNsjRH8MF7UrCaD94Yz3nS4An2zJr2krFPfvYTsANFEUEBGa21yWiQQ1XHUD2VP21VA5GKREUjCUjALORLghPMpEY1aS/E+CUOgVjpt0ZL2kecFrWeKC1MS8sZEr7WTZ9hxGxVGgvbUiNP5ODpbn/6wl26DbjB3aVue6sb0f2St3Yy6lEtVpuNzQ6ZiqJdVFVG1epaF7vPvOp2surE8YjniZcAK6fWcQ5Z0Mo+WrRtSQryni/ek0J1sKc7X1Bfu2rAjXCEb9OW4SGB/jWwhC3bQA//WmDEsnCxC1WojbTR0EPGzRuLTAUkBqiGAor0ohZ1geIQuBdJShAyoRWtADFFWlKYFrU1S62JWWzS2cpypbAloWtbahFYuCa3OU6ub38r3Gz5OKE7FvIwd2zLIdOmucfRLhmcoExnLhPKhrpulKdMZUhh1btZ7gMjxns8fMgCnGbNItPWqghRJA0OIGFIXN2ZxjZqoAQawO8NfKBXSZRke73Qpy5cYkf//jnAfJyRoA1aWKoklrH0MCS2sOUp4O4jK8MABismzEEL720GH800JEegL8BIEtRxCTEgWvq/AJbixCcWxolTrGLVvhrWr2ZEaWMc2xG+djOTEK8sYXHj/9CRI7fA/nVvgxrcH9/o2MAl7pFtiFyEMjfJRma2b/IkOiE62cpSfvK2uW3V6GKZO1qeAyC84WV8BOOKaC3EKcrYkDrYgQph4FXRxACSeOvgBm0sQQkkEGc3xtt7WUPJSjKkIYMLq8/O8DMeGQ7gfg74sIZukdoOnVhFL1rB2OIHox3WlVRQ+keV/RsCpUSlSobaSY0LrXgxpZZTn5oUtEz1KU5bM1evONazXiksVCoLWKzmpjN9LSxm62tgX+y4On6hseGmLSAve9pRRyoLg+1sZzd7ddfO9tat3O0qez3bTpXmy2ZWirDioxqRMCsc1h0LdqYZ4Hc4o7xBcoN8o/9g3/wuQRvtLoXyCZzggS/4wTWU8Dt+rVh9vWOy8hhQWKHjGQKNPOOzUdimWLyxC8VfxvEXDGSA3BBekIxkRD7yHESmgAVsHChJWWpUBBD2MA/gqknRa1DZPBKWwj3OH8Fzntc2xnLIta43Q7kPihf5s42FsHWJ22EXW7e6ZLrTqQ/cYSO4hfCQ+g0xxnzYLHf7vaXdFKDK9a6DHf1gN+t0Z5fMcCvnEcbg1DWcJxKKwJXu5Zt7vKmQBLvvu434Lmr+jo70yVX8zGt4QQEX8PAS788UL59SghOA5eAMDyYIxM+IQfI2cOJYpPI+ENESjfPwp228IRhOEEdATuTOgAX/WzCBXtCTBKfnKAES7MYGXU7SYi/VPgEXZC331Gn3cM/mVGrWfO/3TiwWaGwQGEFyjE/XVmrWjq7YiEq3mG/6tqXpko0frq8KuzD8uG+3qs7qvpBjzG86zE+q0vDr1LCZ0s8Mr6y79mAYzgF5iqEQHCH3FIT/FkTu8s/v5M17MgKM0qmO+AvAHhAREzHxhiVDpMcO/gAS94PwJvB8CrAQDzCgokETJS8i3GGhFksdsMILrwV/Igw1TPDzKG0F3YAVWfAFEwgtXO8GX0/SaDH2YO4TaA/3FgEPdc8XZ0sIoXDnTmwQLEL4BuGCGEH4knAzLsgPiNASSAF/dMkbprAa/6sO2K6Rf7CQG7VwC3HpwLDv2cKQCmdoCsfwyH4JyrQuZc6PDd8RHt3Q67wtmq4gD8wuecqoeeAuDB5xzQTkzvjKEDeRIAuy4RjOrw7xIGtifWaCz16hESHxEe2ADyfSIpVGErVmJd5DnzTQIyMv8iRikDoRBKviGkyyFLHiBE+QFQ6hFUkPct7ABV+RMgyBBm3w9V6vpWQP1VSN9lZNF2nOF4fyF2vuCHvvCGVKGQVBGQeBcpjwgqCxi0rxHKtS+h6N+ppOuGJIJNlmHIlNhobq+c5R+y5mFHlK6Yit/NrxiLggHt9yDd0SLt8QDtkvErSBPdot4MKoEDsyJqYBMP+tRzANkjCPBdCwATEVUjEBiiCPgSUGbwKlZ4soMv8uMhIn8A+25iQEsmlo6QM/sDWywSpKMiVXMhjOoRZmwSVbkDLegC3eADZF7wxk0jXPpQZnkbVYDNV+8giRUAi/yxGAc8t0b+Zo6/dOixknoSmR8YKW0A/SYIPkBRgbxip56RpnqG2AKwurbyvv5yzDcccKicd+bQq78zuR7paKqi3fEMrm0j3fM/2wbVEcYRi8yRIsxbZiRTADkz/7UxMPcyEbcjEdjjE5kEWsIRMPEiYeUiUqYSEmckEAMUIBLkIrcj80knvqSHvyk79S0hvK4TRRsxYSARJYsyZtEzZdszb/04IVWlTCJqulUgvnflLVau/3flA4hZMoXQ0YbW+25AAYGUFeLujSBAaDco/LZCG4rrM6w3L6vBHIFKssz7Msl67HrI88r1TZzhIb0xKG6HE92xM+23BM45Iue2c+YcE9TkHmPNNAC7QwA9QwB3SwBvS/DhRB83QD5zQCGzQ/JJIyK1RQJ/IfWSUjw+jOGqYUTxA1UVM1ZZL0WNEQEAZFJ5XSDsFF7eYJL+GTRIv3VEtNjZDocDQ4c5QXv2v3bI8UgvRHhQ8zmtMyAgYqHYkRYKHRorQ7sTH6mI87sRRXYYhKx/NXp1FLfZVLx1It26BQmmwt0bBMnzU+mdUM7cOa/9iNGNz0TfVUTreVIQFUQO3Uffa0MBP0Px2zQSWQAkEBWEwlIdgVPwrVOkxQJVeyFlDTF2qhFlazBWHTJQ0BNm2zBmdhFnBTpQSHq7zq5mANF2iv13bxVE21F4WQVWdNGZkwSP1gtpgScowUXsAjEpQUV3OVC4sVSsXS2LZySrEvyEx2WK3wZLVwuI6OHL90yc7QHckUWnO266SVZ5PoDoFQA0FzbBITRbjVaLlhIRkPXMV1aQ0ST/lUGSBQz/KsaajWI6k2Q3tQFjwPGZDhBPEVNbsBX4NBX2WTNlO0NjG1Rf/nf74FD5QkDqupWl/NCCU2R3U0YpFUKIO01Wpu1v8Ex12G9IKMhMucbsF+lSuP9WVNdsFgNmUfV6hcFnGr7SpLVlfLsVlvVkx1lnOnij2pbELwkE2FtlnqlDFNt2iPtmnHFbBWN1vJlRnyNHY38SOxFSSjoTOF4RpMMxhSE19/1xdaoRYaoWz3FW3Z4uMEtkXFYixUakmeyizMIDyGk+Zy7vaQFA+B8w6Fc2KNstWCMWMBF3AJp1D6QBaqwcF6VWQjV2Z3lbEmF3Ehd2Wl78GEi1i3UH9K1vvKER4+V3M713MB2Ezbkw2UNXSDFjCTonRPF3VTV3VZN2nJlYGZ1nWVVlsvmCA/U2g3GCS14gQboXd9txa6IXhLeET99Wz/0XZFZ4HSBpZtS8FgjaQJZvhkYOY9LAU5aW5vkTR48JZmJBaIwfdvuypw38UMmMAI2oAU0lfRkk3jfBVZIZdxzTNlr1J+5xcr1fcbN+5JtbALvXNmqet/BZiMx9hzvWd3nocPKgKBF7iB6fSBITjA5BiD28d1NVhcQ1IrPJhe8bWETVh4T1iFj/cQEsEU1pZ5Gem0npeG2bC7dlRiS7WHgTNIgVBv+zYIw5eIAxcLgOAFtuASbtXRLLeozFKKD1dKycE1dCqhGPeKG/eQkscbr7GLj60a27e3gM1/y5iXdZZWdsdoJKQiIOJp39iYJxiO6bgwLTiZ6/iYidZp+1No/1sjoEKxoXDkHFpBm7e5hEl4m/G1EUhUhc32EATWnF94kZ2DCICAnY1gCdIQeCAZGLdskul5OC25e4PYFwHBSONFcKZgBUxgCSLhGpjYchWKf1/ZlUGTmiOCildWcrUFH9xmou33ZbNyi/eXKwd4cwO4o3sZpOXSc6EnVRLYpFG3KJ4ZmePYmVXadVmaW193dj+wwXKmG7qBU7T5j3f6XsE5EcaZFd+gnFnYhds2hpVjhtu5nZspq3Tvh3/wiiZ5eykZqqtanyV2k404COIJBu6xwdSXScnylbHYO1eZmlvDRrx4FBu3G9t6SRcXrqM4ocz4o0Parj26UQpYQgxCRv9O2nQL6n2aWZlX2qVb+lsNu+H8U7FnGlu4CR+6YR1umqdtgacbAV9J1CVT9ERNQWA5m3k/wYgZeZ2VGgiqCmaeupKb527zFrXvc7ZaO4j52V0CwQxawAIswATawFaz5Va38Ja5OKgS+osVbEpF86zRWn/J+pC6MUoPen1jiKPrmtvu+q4NJeDuUIWK2aVThLALe7DtGLEP25iPdrEzuKBx5hwgW6wk25sp273/uBHCeTTAAG29wDU527NtEG9E+51lwL/dmUyVVTmoiWZQVapNFRiz97UX/Kq7iohpuwdA4LZDAAo+9qvd5omN1Ukzmn2Dtbhdoxd6zSrg9wq3RZb/tQnZnDtkpzC6RbrFqduurXtUXCUktRviCgqxoTnHv9uwkVbHHfjHg1yOGxovbVqs1nunIfu9beGyEwGzMztF2UJ5KU0tPGlJxg/A/xvA35F27hkQxkO1D7x5XJvM7zkT0qDMU5sRuEpe9sAGJkACJIDCF6FheJsqlS10EBqi97wLSTKxHvcgem0aIppks0WWT3w7V5xyn9tGXhzGH909y6CAy4Ba23jA3riwdlzIN727d3yVOR3Uk3Y/Z9cqijy9j3wdfKG9l5yyNSG+nZxEwWA0VNgQWIGFDzktKKFI+BtLkLi/1VDAt2rB63mS73Oqv7wP0JzMXXtic2942ty2/+NcA3iAzuvTQ6/iWlK5Chm6GEazz8ETi6sQRPTToRW9lhFdxctacqfY0fG63SFdHvEajdvL0o+Z0IaWxz3du0M936P5rItBGxz7piN71d071eE7nGEdDMQ5ypF3bRX5becALq4gS9IwMd4Z4995ur5gtQ+8EJDd2M18DpS9q+4TENJ8zcXDb+JgBeB8Aqa9InKh29/EKpph5rEdj/WTQz/Sz/98ikURMHd+HFB5iy9am9oarK1YlXGsldndo98d3h+9USp98soGpe/dRJ5Z1Pl937e+u6kZmvsLIQN0dh8GvW9asid7yV19eJ1c1i8Hhd0AYNdC13d94unCBvDi4v8zXuO7vJ6jmti3V2bCHMzB/OOZfdi5isBtIANcXgNUwB5r1fasNVQr/2qxdkM5NByJHpXNsjWm9rY4v+hLPNHjuvlWGSmElR+eXrob2fWjHnf43tcBeNKxZ5g/UOIAO7C7nuv9/Z+A/OuP1lsPYuaRoXhGGO3VntV9IZzl+2BgMzRWlC1KKbTvHu8JY/a3nHaAh9iLvRDSYA7oYw5Cfji93ORLXvfCw8qd4ANcHs5DQAdE4q0sIRPq30HrH/8dYRVkBf8BwpXAgbFOxWqWzR28hfoaznvoMKLCduKiEeul65YrZdPg8fsIsl9IkPtK3juJ0mTJkSIhkntJDWFMauP/GDrcEqUJk5xVeOr8ycUn0KBChxY9inRJUi1KrTTtudSpVJxTmVopgzVPH1fPuoL7+i2sWHRjyZo9Gy6tWm5sxbZ9C9catrnborm1Wzev3rJ35frFSxea4GWBCw8+7EzZscN0m12UJStYsHPdKnezhbmVZs2ZOzf6PCvRITCGDpk2bSi1akqC8OAZk+XLlCK0azvpgTs3ESO8eaL53Sf4HuHE5wQvVMiS8eSF5jAKrhw6oDSAnhMfrmd4nD1malhIMCF8+BAqdMDRAie9ejt36LD/Q6g9IeSZJFkySFAgsYQu1bmU+JB/8lSE0SoGbkRORAqSpJJJKa0Ekjcs9QPT/0zMEPZNgvZsuJNRSREFoocdjhhViUJZ9VRVJlJ1IlZl8MGHI6d4VRFfa90IFlo42thXj3v5CORfzcT1Y1wYGhaYYkoe6RgskElWCz61+ELlZptpgiWWnU3ZiGhvyAHGG6kdMiYkqhniWhxYzGZbm7rZwAKcvv2mXXbYFReccVsB0hx0fh6XCXXX1WknFiZMAJ54E2hAXnk6PKrDDTdQ8SgVkupARaZszGdffvntx59/ov4HIIEF1bdKMh3ZxBKEDb464UgVOkYYhgyRCJWIIe6KK68r/pqiiiweheJUQblYR3K4JJRNjuzouCO0Qf41bbXWDskWk0gyxm23S9bqWP8xkCFTzjnn1HJZlZs1giW7mrj7biO1dDmaHPZ+KWZprLCimhqvrRmEm2/uJqcNvF0BXHYK47nVcXo6x7DD0Q1a53ZGhIBoouM5GkamHkcqaciXUpEep54KhKp+0jA7KkSlmrqKJJIY2AtCGrbKoKshSdhSz/2NE9NFyXBkjTnk9Iq0rx86oTSwTg+bK7DIwtjJys3WGK2zWU9jbddeR0vktmKLnRhjCMmCDDJQTpmuZvG++/ZncsubyCD2uoF33n74AYkpfRvS2nZsBuyCwAXbYFsbwBHax3YMPzzodX0Aoh13d+phBubdWZAxeOCpYEQbyMEYX+ntsbfpevLNx6n/zJsoggjssW8iCi64CNOVOiyTuhDQzGRUn32p2gyTy/Too/NIx+/c84YNwWSR0IRRk3T11uv6dLBIa5/9ri7ykceyzPK4tbRfB6lj2NV2SzZg3pbNmLjDVGNMuei23cpncOv/2RqJ/J+Iz3gpb2cooAHxdqYzwCYLQZBNwAR2gsPpBDgPY5xxLhixDGowO2jA3AsyEB4CZGw8S5icJe6TCRSqQhShaCELR+E62ZVOdaZLnckMYrXcCWgiPKRVzFJ2EOLx7HjLy1kRfeYy57nEd9+6Hvae6MTuTYV7UswVsrQiPqxprXxcPJ8XfSQYarWPVu/jxWAWE79rSOZctZiS/7psob92xUuAa1iDAA9xNy8c8IBvEETe1NAFBgLMNhE8QSHllDgKOm44lMvTBoVTuUfqgQxVSAEIE+A5BmAyPCrIAyNgUZBTncxTwatE7OJzB/ash4aK6ETtbLesHI5vlssQCCZMmcKC2IxnSWzISnqJxOYxhCIWwUgsbgHFpSWzilEslrCa2SusxAh3V9ui+ciHzWtm04tjbF8ZudWMYXijfm2cUhvVxS7+tat/oklELURjNwIasAv0rOc86zmDGTxwn3HqJ+JoM5vffOGC2yloGhoHuYNK0pGQ00MeoGBJCUg0kxqDQR9AiVFY7kKjGiVlDF8nu9R1jGRhEIN8YP8nClfCslmzHF8sLCGz2OUSVLoL1RBjFcxe9u4rtdTIMn+qTGY+k4pC/Z6MnuGOamrTml1s6jaxKcZuZuubvDAj/AZTjGtUw1zn8EU3ynkld4kVbvNqxBpY8T/TyHOPfPwjPglnyB4UspC2CahsBmpQgzI0cgtj3F4vyIUPThSThD1Aojp5CVDWTHoY+d1GjbnRUbIQZS9UxOngkIQklLRkJhMIKPdDPN9dRGbzMeV9iEHN3bXsZ6xa0PN6V8xVBDVqs4UmULnnTKJ2rwxYZNk7lrojmoxFuEwtrlN5FFWpuk8vV21uNrSxVXxUpjPoTGeWsjS3/32GTGvVmyG8izf/euozCC4o71xZEMG62vWuX4hNGgRH0IYyVL7xnYPgogCDDFDUsPw9bCEwSivICvixvxgwZUGaUoFI4yKutGx7NrvZkyZHZTJpFoNj2lnb6VC1ovKtQlz7WthexLa0bZqJhZqi3A51xcaCyveq5lvgHlfGNEZuW7ClXCEtF37Sw4tWzWWZy6xjHZ5Jp3XDCsC04rG7bHVDPMVbOH/207xtGlwD2evezAm0vvblspfNAGYnrOCShS2AmftLnjZktJaNHVqbCQxnyLoCEyeV6Ss7ykJHOFg9qrOzgoUhND2bDqU4TC1LvVIMoHk4H8NkbY1qG8XbSlEJumWxpSltrGQd/5VZxJzxU2sM6uSy70KkLrWpa1YrJe34GvQ4h3SHjBlYZ4Z/8FrXvN6Z1nh2l54K5HV4AzkD9ApbBMSeMnr3uc8ZtHfZ9mWv4pqtZTBvWdrTXtOaZEDmMhPgzIa1AAna8EnGunnc5I6zm22JiFSONAzyoR1HbcdCU8aHz5yFHUEEPe+TymiliPZKaCkCcB4KHODWQLGkT1yi3ihFxSmudImtqJVOZLHTKwu1cbV48U+vD7UL/t27OX6RHn+r49HIajnwMeR1+CMzKsfM3OaWJTh2ScmpwVev7TnPL8FmDPk05AZ+DvRiF1vKhSuCC2ZwBGWzt008kGBOiDAFajPtNv8yqPoKDtU5bmv9zBMwgRP2/a1yL8bcb4ZsKBzsMY/ZARGgCIXKQg5vSeSblSiV+9zbnWANLxh3FzK0Uhet6IoYnMSET5HCm3J43TJ8xVmBcVIz7mnI/9biosYq7kjhCYMY5D6a/yzc3bzcrpAL5bCG9cpnLTc7ugsz5gSgat5QwDeMoQt6vHkBdw6bYI+AAxjo/QWCLvTdExvo5s3neGvDgvKswAMkaP4KWgD950OdYM+3JAizru2tm1miXr/oZ9k8drGHv8Bt/jy6517vmXHU/GeHXSpVaUP5sIGVjrjzx3vcY7AEXtGDL7z/E99wl9Zi1lMHdaAHMEYjkhd5f6f/gF1jNoCmeYuwCK4ggRNoEJcXcqYGGOGEDK6WcrZAZNSVenVUR41gC5rgCwGUZN+FL7A3e/U0e7Mne7mnTyfAe753ATkYdL43fD83AoZ0dFRWBDzQAipAAiFAARaQASHAhB/ghCDwASvwAinQASCghNiXfdonAFzndacVduI3fsdAfqkmdgMBUrfkdpT1KXoHd/HmYPJnUusWYZ01SraTEaGEahcyDUrVfwc3dZCGeADYh5mmaQhIcZHHRYFHeQ7Yd56QeadQgY4AHfV3WhiogdEjLsgQJbJ2ekW2BmAABkiABGBgR74QGrm2ZC54BjMYgzLYijynexvQARWAg78n/4s5iIu9R3y0IWXM13yKAoyKsoRXOFjbloUIsHUBwG1dBwVbcRBkCIZhOH6XKH7HFFke5UIUtnfPAG96RjrqJocRVnf15zp5RxDlV3FfMYiAiHC4Eog8AAXv6HADmCuYVmKaNnENiHGIuIjJlYGg1AmRSIkRV3/hhn89JgzDEAwnF4LU5XJmVUehKIpgkGTwVHOwZ3s5kAMz8IoLVIM3iAG0mIs6OJLAZ15Cx3xJOEKaxJLBqCjHuIVaqH3M6Izg94XNdZPUWExlB2f31n6qxB6V4HY0ZWGwdGBzl3abUlp1JzMoxJN6SBPryI4Pl3D2OI9XaZVWVICelICgJg5fuf+PWKOIYdmPhoFaoJR5AqkVWtEn90EKgHYR0VNq4jIZ+ACCnXFd7xKREimK/pNkqFFzCuSCY5ADWUCY7iVXPneDFcCYD/AAF/CYJQl8xOYCwgd0kNmS/ZWZWciZ2mcAZ6aMChCaNIlDtQSNQ0NVX3hq0ShnKENndxCOd9BKr3R5XYE7cIkLeaZuHjOHptWUd1h2UCmV7UicJ0JpTRePyImV/reVm3aI+hgtAQeWkwd5G9cYIQeJarmW4CM6k3OBB9l3alQLspYZ10WCdTQEE+mXaQVPZMKCspcD4mV8xqeYGMB7jNl7j+mYkmmSlWmZQEcBm8mSnUmgMjmTNHlMyyD/cjiJF6fpoA9ajXfomqgkh3WWdxzXFSAXd7tZUvFhWgdyjuvHDMMZaf/ncFlJj9AkTdOUO51GnTM2nS9KltwUNonBYNkpgWwpiXnAnTDiSWuWh+GyD+XgRniZJSQ4BEmanqNYR3/5P6TxnrO3kfo0n1EGko25nzkYmbY4mUDYg8NHAgGqmQVKpp9poMv4AUoQPtMDjXbBoBCaFzjJmj1phqAgbzW0OnWnH7C0H9hJWqqUfp2yho1VnCZKlUwTjw9HaX94otWTqCh6qPFISS+Wj9BJljJaljt2nbAUCY9QgQ61o2ypOG1AB8rynQrKpuVQDsEwJWF1nmugpEqKBENA/4KJQJFvcAgDFKVZUINFV4MtcIsRIKzCGpL8GXzFR5k/uHuz2AAzSaDFCJNmKpMIGqQjR4YWwS3W+qbSWIYGFlmvUFkYxpRomIZ8GnemBKiBOjOespz/94eMmqiMiqiPapXKaZwCuD30SlvxuCmaJksxqhYzGp2YmqmaWkwAGQmReIChyqOj2p2dp1HKIC77IBnBQGsQiZ6xmqQTCYq2Cgbc9Z7zxKuJSWUsEKz7SawiqYvBp6wnSZknGZLNaowDWqAye6bSqoVd9wPgFkTaOmo/C7Rwyprm11ES+lFoKKiohhEsRKFz2DrlKIhTOZXzqq/xCq/yiLWGmqL8WoC1g/9UYxmwYSu2lzp5YFuwc3EhnJqwCrswokqqzcEInIeH8lOxFjuCrwqra4AEsCqRoAiKuJqKsDeYGzlXLoulWYqDLNuyyjp8I0ClPleFY1qmNOuZOBuToAkeaZocbJpq3aQtBvs+Qiu0GdhxgTYQBkI7IPp2S/ua9FZvpwQ1UluiJHK10GSvA4ii9Zq7VVsFk0oGBYiPDEi2AKs1BHu2ZnmjOMq220k6BBkJEOskkVGxd4uxeAuKHPu32fslIturXmqDHDCsC5ClN6i4i2uZP3h0sYiZlyu5ZaYA79uZmmm5mCsBmjsjtEJGoBu02PpN+ruBqQaeSiturVmHAhwz86b/Hh16B5ZAB4sXqbKLqPJKlbl7u+0qFbsrqYuKqL7rrwlhvGNLvCE8vOfzuWmLsMvbtn8St2ureaQwDPNTt4lgRzLcpE0qwx4rkW8QJl+yw3kkBHrEcyQLhD0wi8NKAcTqg4vrn4x7vuirT5YppuxbuWZqs+5rs/NrZpcrARrwA/+lk/67v2DMv/pLbgMcWcDzChohEORXwMfUhoLmusTAwA4MwdUjwXe8r7wbtTuhx3lMtbx7Fb8rI48nLSJsyIdcnWLMqQaxtig8KDKyto8AC56QC7KgVZIhC6YhGrkKQOtJkX8riqMYyn97L0IgBG9VSDiAGzYorB8wrFzKxOYb/8tO7LKy6AADgMu5LL/wy8u9vEk4i8XGuIVb3MWw8MVhjMw5xlxyem5ojLor9MznKKFqGKJGCcdw4BiF0MCx23+UBAXejMfh/HR7DIC5+8fzCq/nzMGeFEvoILxGEw9lG88fjMhbUySVh53Km6MpLIknVIEJ64iSDBnzM06skAqQcBoJfRp+u8NI8AaimAOiKASjCIpeYMqojAMcAH0ZXcRGvLKyPMst23MfiV6yuMsn7ctbd8XBLMzE7H3HjM/JLMb9K26uSa4wNArPDJxsrManq7rL8saJBgvaTMdaK86S+q66qxTkjMH5urtTN6mSuqKOoCrvDM/1jNVLdc+jxv9gKyyQX83CXv28jviWBJ02qDAJCK3Wax2Y+HLRSBDRcG3KFg0GEy0E8dlzJ1CEGp0CJ6uyyeqfSxzS6KuY/xnFuozSwKzYiy2TIfAEXpy/My3Tk72tYujMMIRLnKDZnHAgGjGGPI0yP9R+dgaXhgYL24wV+Epi79q7eNzUWQvbfMy7tWuPVOvN39NKXWlN0jnPWS2w1rmpGdXI/QzW/1yBZI15Lwxd2gAMwFAKlHAmCXRA9TTX1W3K143dR1BecLLXHuDXItm4hB3L9mmfHGDeTdyD6zvFjM3eLK3FXLympVZ5ylzCZFwXuMDMPA3Nm21K/b3ZtHAL4WeTBRbNBoL/diQzHxZIE9lQDHPMzUZ9Ykk9wbHN1LKt1LQNqStaqb7d2/ScyJ4r3K5U3MYd1pLswmWt3M2NCs8tCJcgCC/+4h15BPQ040dgyhItBDOwkdddy97dArP444w5i7ZI2JUp2OeN5EkOkr53y4i9bU7e3ivd3u/tAxcF0zFN3xpoo/ldNne43/zt3/8d4DlJfgUOQ7B5AyiAApOyKTAhLo6Q2lvrf7wSzrX7ExSO5xYOFa+dwVE91aBiyDBBzx5uz8qloCE+4mGt6I6YkJUMDMzN3LKAeZTwCJfwCK6RJmrCbPlU4z+MBDmeAy5g43a9xD/ui0PeAbcYdN473h+d5Inb/5jNCuVRPqBTXgChyb4u3bNXTtmS7QwdZ9nSCOBg7t9s99/SiBiKcUxm/po6gAIlUAJrDpYJIQxE/cCFV+eUJOEXTjCN6o56TmnebLXn/KjStG+zFMIDQuhZHXpYLhihBIn6TOLz3qmkUAqVnAuPDl3NPQyTXumXnuma7kC0wenYLepCYF6mrHvoxXzMZ+o+aLJJXNgjkLjlbfHlfd75uQCznti07t70C9+lKdnujszNdcY7DTzEHuaancZWlSQmT+A/PWfpZilpjgKBdw3XQAptoNpTy9pOYAZoYgbantR8/u26pcGy/cdZqc6FSCO8Lc+ITHAZt9XeFOL6LO+LTv/J+D4//P7Clg7wexDwaGBtV4BIR6eRCo/wI63djHvqPw59wxbebl/xGN+luxezHN/xHn+moRnyHDfy1HKtyFx+XQ7gulA7Xr5CYG7sLN/yaPTyLp9qvKC6Rvs6JwU0j+cN2uAJcQ7hSEN1PYAHlWEKP8/tQLDU4J7nqm/05a7h6D71UM/hW6Q+3qTsjDzcBUnvFXgKW//Cyq1VX1/pa1sxc0D2s2H2TccC5IWs5ZXXsSgCztcBcV9Icv/qIemYiJvec6/xe7/eZSrFmAvfbhz4g1/yPFaG0DzNi7/Zje/4kF+jX0h+n70LIn7GAac70LUInn/tABGFicCBXAoeNOj/RCFCM7P8dcODZaESihQnDiRiZMlGiwg5dgQZsopIKE46mkRpRSWbMnX4OHqWzd04mu/EycNp8+ZOnjp99gQXTui3dESNcoO2DNtSa0ydJoUaC9YpqousXsV6yqqrqpGoehKWaxiwa9rMahuW69KjSI/2vN0zR+4Uuk008sB7QoSLGSNcjDhyhK8LwiNEHBbhocWGFC0W60UcGQOGCg8sWx4wwPJkzp0nJ75AYcEB0qVNEzCAIPVqBQ1UFzgNG7Vs2rADCKidQIOOPKeIMYsWXPhw4kiLH4eaXLlwZ72ONdflStV06tVHccKOSDt27LRu3WrubJtx8kyVKT2ffplz/+DMf79vB0++umv1c+VRmb+kR/797fpfyJR1/JkFjx4UIuMijBb8qMG7HAQpJQahqEhBkrSwgiWXRJEpvpo+BBGonz5EJygTj0LxKRWXm4oqR1zsJCsZ29rKE1LSqg+Ys4YhhS0a4ZoLQRuGrGGFFSIj7K8klYTMA8VYgFIvKSXbgLLLLssss806qyC0KytjIMvYEpiNNTPHRLNM3Na8TYLdCpGqPeSWoxO9Ou8MLzpR9rSuOu+uy4677rwLT7zyVrRTPTkNdW+m+by5phi18nhiP0sndJAgTQFMCQ+HuvnkBCEVtFAJky68NFP/LjyVQlfz4wPODj0UsdYRQzzxUP9d8UQPF664ijHYGWn0qq0bxzKrLLR6jIQRQJ6NS6456soIBxmudSzKKJdMkoUqF9sgW73ElayDCM7FbLTVIFggXXbdPfe1NOcdU83c2JxtNjd1sOS9ORHlFeBC89QT0E0MBuW6VxZOuBKHHx70OUZ3VZEXRQN2NBthplokDz4MgoKNVDFVdVMAP2HFFFYGnEWiUYEguaJXZcZr5pJjNpVkCzHMI48XcbX11qBTpFPg5Jzb5VdhHWF6q6u0WuQUtsCSdBj70FLLWWijDfI/mLE1Mi8obXBhyCWhzDbtA1sYN8rDOjA3gtHmllc1us2EIF567b2Xb3zz9ZvM3fpdtLj/RAPGc7zxkmG84OkOhjxyhR8PlLvpJFb8X/XKu5jRQp8hxhVJFCGEJTFOp6gMm3G+GcCVu5mlG9nHEHUhUk8ttdKaVdVid9ZZxVRDPlwRBmihh/6pROUzZ95ogpMGNsamh73qEbCQ3TFrrbnumkhrHQvbMR7GLoIFJttOm4Ue2CZ3Sr0qc+Duuuc/s37AA+/77/zxlWBfwg/3HOIEeDTHIUxyB2wYxC4XwKZQzFAWGyDjRncHOFQQdb3T3epI0joAGWJA/1hHNwwxBixgwVq2sxAZaPY73m2QhatryYukYTzk0XB5mnNe42IRvektrVlRW4SNYHEsHZklLaXwxPak/9W9amELbE4cUvnKRj60tc9sUsJikypjAfnRbzW4sd/+7qc/MpYxX25aAiOaUTgGRvBf3/kO5QTFie3QcY4GFBSh2phDN0KDgha0IAYxpB8NctCQeOiGPxQZQtkVKCWkqpAKgWfIFb4weBvCxaxsWMNcES1xdEKar4DVQ2FBrXo2kgX2sEaK7T0rSHX5WgygOEvyFWGKVcSl2rLoPg6MIG5ya40XxRTGMYrRjMdcE2kmEIIo/M89n4TmU6Dzpztu5w/bUYQCE3hHPeKwj89sDiBPN85KPUEMhSTkgyiJECfE7oP/gKc/1mEIM+QuZ5VMpwvxqbORBS+GnSheiOJxPP9OerKPOgTWnnqIlRmRohTIQkZahugjQPRhLnW5Al6+N0taBqFsRQBpLlkwvvVpa1uGYZthTgCuLbqmi8I0ZjGROdMyMdOZexxgA+kURzwiYhPa8WnltBk5y+liYgZ1Hh+TQU6mXhCd68TZgXowhlrE06r/gJ2B7LnPFsrMklwFCax8RjxNEtSsQ7mhTpXKuGlKR3pN08NCZYTKh45FohR1VhymdYWMeo+jHSUMSMs30iqqQKS8rFIvUWqYX9YtbzCNKU0le78J6KANsFgjG70JMObwIo7c+cM1gUpHoJa2jggsKgOL0jylOq+pTQ3ZUwc5SKgyAQcLMUQiFXnVEBr/IkEoxJ1shQtW4vKnJS8J6CaD5hOkrnU9oeQTXHu4UOs5VCw4kgWzItEHV7bBu329ixNl+dcoli+kRdBoelvQGHHxsksdoAzcGvvS+hGTNDKdLH5ns5vLZhaA31TrZ7nj09GG1rSmxcRQU7uc5ib1TkZ1xmtfm8HYUjifX1VID7AgoKvuFqsReeRIRDzc4qqqxKlqiR5OERP6tOOsynPxDWXswJ1KzMa/UqgjCuGxnjGNu9ytXliqdkQfWcKic/gueMM7XvHRMiOChTJejKQCFTipA0Y6qRbRha5fctFuXwYzZPcWWf0ms7L91WxOHzxHBFdCtA9DxB+qOblRLMw7/6yd02ppLDAbS/icTk2nhWv7ERRiwSEdjmcttKpCe9K2qycedH6Et+IW0wrGy710g3l1Y+i5dcexAnWPGSrEYx2RlYywRBrSkOSPAIG8s1ybYOsi2LzwgMokCB8We/nLLffapfSlb26CWeb86o+/sfAvgJHj2VUMOLTXhHa04azgy0HwqGrVNLY1dzE//7nCjob0o1FyoDHM4p3x/KApgHthEpv4a+GeWUsyFENilNXSyu1kWhHH6U7vqRCgRkOoRR01G9U1lTwqchoKwer0MnmjsC4vSL8w8S8EIcpDymXbuvyuLdOti+yqr32JTeZinjkWndtsclJ0DAFPe84vV/+Yta9NtBTpmTya/m+3teBUbw/3hbe13Qmoimh4tgxBt4N30qM64pUcF6D2vndB0UrjgfGbK6tg2uhAvfUdT6/U19UuquewcL5y5AdFcvWr1xfxIHxB1arOwsShPPce6Dpuv/Yyx4G99zCJPLJiKjMDLMAbzP435YZructhPqg/dfM4M4Z85iIfYEX1WecYAvTMBN3P1mVYw7nV7VUh4jKkPxWf71ZnpCck7zLIylGZxrc4OulNG+tQT66wRCYkYeR/08H3bRC4z+h63WKc2hKMkMt3BXn2WKpdI7J+u6oB0YUuXOELM6g49rMwA4+e4AXrPVcGuGgBvXk5779el5j/x0zywJs82WpNs8qJQhw9Lb5PjfdO/qOzx5pr2+ZTXx59q73a27kCNMBy4jkK2zzVAzqF2LBEOreiI6F1c6EUwjDVa7rjyqTXqxWZOBGemL1tAyCW6zes073e+72W+D3h+7oj+iEeo4Oyazi0+z7xajIiEaw08AM1oD438EHqU7UuiDvt476Vght0QT8FACZ2Mb+QA7mQ67thW780Saa/GTxZib9oKo7v4ARa4CY/qTY40r/9g7CZC8HV+j8A7D/zeJ7w+DM/MycElEPTg7QGrDtD8zCrWodDqCepgplWebRKSr1BRD2oYj16U4d2sDepmwZpoL0BJMECOsHe44Pf/9MQ4HuRFiwFqMkEJJNBDGK+5rvBa8FB9AoCVfODHfTBQRgEHjyDV+wCj8I+j3KMIxw/KWyNJnSpM3lCKIxC10CTKTymCViB4clCo2mgo2gr/GNGZosOOCLBNmQUR1zDakzDaiSgaHSGlThAOYStdrOk3/I8PJQn3uJDqSoVd/sqdaytSWOx2JO9eDxDcJLGSJSOVTDBSYwV7/I94Qmir0OFsOsDhrO1UES7E/qeHsA4I4A+HUxFOWBFVtRBH1SDvtCLuluvu5NC8+tFXEyNjvRFYBRG9sONyoKTY0RGxBPDlbSYloTEepxGarRGxWEHpKjJ/sNGafTGnYzDnnSVH/9YvkAMsVOxQ4UQukPLw4d4g3ULLgpsSkJkR6jcpwL8p+QCGmoYGqSqOnu0RxPEx9zTR0v8vZegGrDTGkbYsbLrqxrwAYNky4TEgRdYO3S0gSlIA0CQyDNIxVSkPr7MglyyRS8LJpH0yCQMyV9EzJGsF2ODgZM0vKKhmM5iSaMqw017SaiYSaO4STXMTMqzPJ4ETadawJeREGsBOoS8LaArIURKSkXqhjGgy3TUJwgpxNo8vUk6rj6wShBZRKBoRG0bQTL8heH8le/YoXzUx0ocS0cgBSEzS+Q7PrK7AlB0S9NciB6QS3RsginIAjUQhO90xYf0Th90g1jcAMRwkpb/asL1NMz6AsnEJEz4HEn9Mcn30yk7YQqZ87+lcMbLhEn/FA7OxMnNJNAB9SQC9MkElYILAk2gpMMKsYjUlCQ7rCdPQbR1cKTYvCevYiGgtE2lQ7Hc7ARkKwYPpAkOvMrflEl6tD3hdJyvBEutQ0HfK4R+cU6HOjWLkk7vmsFrcUvPK7S4c0hBAMJXfEXxbJLFMBfBbAAmBUYnjc/CbE/5jNIoFLb7KqMrRLbz2BX8XJHm2Up+e0n/xBzJC0ABtUluKFADzZWksLYGfYIkiMMFTdCKCMUFJAnTFAl0xALW7LB1qAXfossNBcTb/NAlCMVIE4nj2roXwawSjRR780AV/13R4ORK4TzOHdKK3Pu03iMEsnTOuxI7hePHLRAI6jxIPQUuMpi4uwyE8RwEigTPHAiMLuiL86ySwGRP15iAwexVX/XI9zyNX6XS+bRCFTBG+4RMFVHGrZzM/hxTAE1TNF1TNbVWFMm3qVOP54BTOoXTs8PT2XzKnLktiRi61hQhidDQnCnUQlWnRDUCeBVEQ20QLlDBnQuDfKXRp/kNE/XXEqXGwnmPUHLR4tTUftkhTu3UHVsxqwE74+OuVWM4lfgBJ3iBi7XOVUUDV6WEvYSEQ4jIhyzCWwUX+TI/CXhSKVVZAxDWYq1S+fy7ysqEwlNWzpqTSOQpO2tGz4rWAf+UP2yl1moNWvJ4026VAm/tSQdV2rRbIetk19KsJCD10w4ToQx7gQ2FUHc91K11EKflINbTAjo92jAoQDb41N3jikfVGI2pt2wQ2IH1laSBLk012ITlva5z1CGTFIcSuz4oBEBIMrW006sdSifY2Le4hElIBVSYhMb92I/dyx00qXBZAVvMRWDF3GCtH75zWfWrDWPjAcf00n/pUpzNWZ1F3TEEj541Q6AV2tfNSZlrUDntSdp9grbcgXK63XAFK0hat9xqTX8I1MI9kDpk2upsELnE2kPVj5Zog24swHwd2wI8W6b5ld8QBjlxxH79DbmdW02lW9wDS7CkCsyyD4f/DbtODVwUutqnPbo4wANBoARUYIX6TYXHDQZWANlUhAQvmIEh+RYr64DxI+Bg6h9i3UgolR8E7twGHjkCMEmaTUnnYUl8rDML3lmXlDlpZdNrhd0Ojgpuhd6kRdqk3V15Xd6QQE0JpZkTEpUemNrdGhCIQEe51Nobpk2upVfg8a4RPkDp1Vc2qCCXyCY+IZ7s3d73KF9RqtvcE18n1oojDov6OF++Rb45QL5S5asEEccQQwPDNQM8eARTAIZUMIYz1t9DYIX8hQRDcGOQFQxvAQ34UWDMhdKVTQ0GbuCXTUz9CgF+IdEvJV02dEYMNmTVhdYNDlP+c10PduTJ01YC/zrhtjThb83dSWZeQi0xujyD0IOnAcHQdTshHPZdi1WCGiRUG1ZeCNXTfQJbA4SDHx4ncRJiC/K96nVUpVEaF9nlJS48SQFmKqbih10EPNCDY04+NECDMlDmBGnmL/4tughj61EZYKjfWTAG/A2G/R2ENpaDI8A40LgALxGNYCtWwbFj+VlgXuVjmBUjZhLd/ZTnZUxdfHxWDVbkRR6Yn23kD87JRDkGCqnkgb5aBbxkikDhqJTNP/Q8TwFlq4IIOyTUdIxLhG5fFT7lVr5o0yTcHX5lHz5AkdEQCjKdfvzURi2E0YFiX96YZgDmlw7m+kCLSBELJPqEYkbmZ9bpnf9uZsRNhTJGY2zG5jZOhG2OVTdgxTOwSPMpmzmOH3Pe48sNSc4d1ivdnz/Gwnm+WZw9ZAzGZ9bVZ5TrzKGN3eaI0xOuXYKulIKuzoRWxw+9CKkagzXuBlBmGdtpZRxm5VaOy4VQ1RT22t/5aDqAZejtx7I1ndO5g1uOlaaxhCV2TpiWbEjFkbIgC1NQi0/wBGPOae/S6ZxeIrkYY6AuojMW6kP4WP2FSPIEZ23hi/JhDBKggHKO6pUl1peCage+ah+QIZvFM4KpZ3uezLDeZzVLxg4W2v1MFEreXR3AZOa+2otl67ZmPkMiytJzX4Xs0zMwBd2KaCJIR0As3lMe7+v/3ujxHly+1uHUKVWQDumSLmlQexGvmIrInuz7lmxhnmlT4O+bxoOOSeZnRuZjBhK4QJkzroZyOIdzmIVawAcGT2NuJk/umwHuC4JaBWenfuraTgCRrGOq5nApBBz/kWCtzsbTFe57Jm6wZuTjHmucSw60Vuu1nu7npm521OvsLjQL9YdPAO+F5tC1Qwk9XWVrudgDQWWvTU1DTYn23knF1oLD9q5P2xOqsG+Hxe/iy/KYVpb91mzp6WwBjyu4IPO3KAUEr4YFL4dZOId1YPBDSARWSISQ5csZoFXqc4HA4L63SU/aDvHVuO3MaOdBb+f8+eOZXSNBVsl7ZsniXnHi/9bCFz+8pJBx6L7k6JbD6c7dG5fK9Y4k2ykh7e5u31ryiVBV5d3oIjd1Cb2tjeZri80wJrfXstvdss0QDKHRHtOKY7nyLff1/FaHHbkGYMjsTsADzm6DnlHmniFztjj2Yj72TyjtbjiHajCGc3jwbQ6GWjDqkC1PI02DCqc+2A7glgrGzO1wA9Dj9sztqh5JeC7xeTZdRn/0elc2sobxp7D0Sq90TN903E1Vt3a3Q2XKIG3XUY4l8Ub16z5lVIb1vUb48warwWb2pmEEh+r1XHgG4vv1yBaGG8l4mc6eYsfpAJeWYvYRZ58aaibjBF9wbM/2YHjwWkDtQxjqN9BLN/+2VRaYgQzH1Vz18xC/4yn983Q3emHD6sIz8XlXcXvfVrHGqWWV9EmHbhtvX3//96wPeIGvV4WcTQkFLqfE6JCw4dPkaIVQdfWmiCNvX6/HiELciFlPsR96upiubBzZ+GHIe+z6dZDX2/xGCyOiac1+dgDvaQIPoiAS45W3Hkr4hFJYXFRY3DRmhVqohXOg+Uk4BG6fBTfuZkNwA4v0eQEODUKHz6FHzHY/98iC90RfeqZn8dhHOUeXJi+9xkfes9q38d2HAYDfgd73/eDneoYGbLiPWtJEIQ5V1eAy8rJveztV+1b/ax2edRUrY8zm+POtYrHQmI7PeL5PC0npciP/qmnCtyg9WHa5IPBAoBHGd3/Ndva5cLtDyHb9rXzLf2PUDn0mQU+AuODBA4UFBw4iTFgAQYOGCh4udCiRIcWKFhkohDhgYsaFBAR8DPnRAg9HzU6etKYy2sqWy47BjMkrJrSazm7izKlzp02eNF/2dLnzG9Gi4bghNYptqTKmNp1CXepj6g8eVHc8war1xVUYXrt+rSF2LJCqS4CcTWtVCdu2bonANXLWiRMldOnaxZEXL1u+e9vW7eHkxdu+hPX20ItYMWPGhx2XLfy2ShkyejoBq6YN2LXOwz6D9hw6F+lioE+bLq16NerPpq9pi70ZGOlPnvDsyT2nDZreenIv/3okfFEn28KPIx+ue4qNIlPO+DkE6RCrWsGkDzI0yU8X50VcsBAhfuDACgY7otfIMf1F9hvZi/QYMoSOQrBSJm15FKrM/jtn+tRUUAEKOJRQBiqVYFQLDugUWFVtFWFYE1JIloVmmaWWZHFFtiFcd30IImB1/WXXY4EV1hgOL5DI1mMqpogVExtyQYZlmG2WC22hXVNaj7n8yFprqQlTpJA8hiZbbLXZRlwfffTm22WPFOcJcp9UeYmWyAESiJe5fcEcC0F8kYUgkLACiSFyuNFmFzOENwJ4cW5Q5wYVFOSenusZ0N55GO0JqHwgxbcQfYUwg5+CB/6kE4CONuiUMv+NUlpgTQoiuGh+lkba4FoP7hADqKKSOlaFEFqoIWAecliYX4y1iOKqJca62IgwttVYrCziGuKqNl62I2s79ijakUQieyxsxg6jpDZBerKIbnmgUVlv0uJmpZV4UGncllQiB9xyidkQXhAzzBCEumTCGWd477LQggciEMRnoPb6ea+9hRIqQQglKQqOpisRmBOAj0baH8KVAqVfUZkO3GlQC45qKqqnWpzxhap2GCNaRGQ4a6t4yQrrZC2KjDIOJPba1osr9lorF1AAq6Owx7Jm5JCqJbtzarHdM9tnTU4b5RxHE6dlJ3iYwq232oL7SJe5BbKHGVfTJZgMLchLntf/K4DNQrnwhodBBH++p2++a987KL8h+ftDJMVM47DADvNXMMP/3dL3wXs/halOeEsceOHQVHzxDzqskLjGE27Ncce5mkxribCSqLLKNA62uce6vtzyjG3ZeKMpwKCu4zU7so6zz6/33Gw5QQtLynBPGo100rY5XZzTyXEbCbbjisg12GB38EHy5Jl7AtkX5Cmo2nuizbb0CbhNqPYCxH0K3XcfBb7gDRs808IJm0+L33771+j4k+a06eEMkn+p4vc3/jjG+m88ecchsyxmr4pVADPnIcV4rld6CV3LPpY5upBhEaXIjLOUhLrMcMZ1r2NNKVIji8/cg3afQYVxilaZ/zxcpnfB+wQesmSl4ESCSuLSw9HQACJyGQ95yoPeByhAtneVx3rTE+LasJe97W3PX1vwXt1UEj7xPZF+6Ttfg9K3CvVNcWHui1j86Dc/iTmOf/sbo/8a+L9W9aVyBWQVYejCIgMGEFdy5JUZJVM6NEgwNrSx3SV0RA/NaEZYzNoZ7Dz4QW3MLkcfLIUMcccbNNCQasIpTnBs87RwYYuGUbphWYxnPPJQYIdfq1MHKBC96w2RiG0z4tvg9oE23KeJTowiLRmlt6Cs74rs+9veuPjFX0bqfvfTQRjFGJYzfgwxXIHViRC4Rg5p7YCBeWNfElhHxbRRCYdZJugG2Bcy4P+BNnsogxW0wJvcFEM2gSQkKjbomp0hshyKLIXthAclKf0GW9uiZCWBF0MnmZCTevFkDgdCguSFcoc9PCUq9RSStPUJohJtDysrWgAk8stfsAwYNTpaS/nlrWA1SR8ndLlLwF3Kl4bLFDDtF0YVfIqMMkXmNlfmmMTEsXKs2mnmGCjHn6qImoN5IzftSDPh6EGbP9BCFKiChkdo4xxBUyQ7O8jOD54GGPuQ5wj5CIjcUOuc4uonJVb4NEAIr4XAqWG1BDpQHBAUeV4TiCkZCp+PDAAkE43oXlV5xFb265Wx/Gh+QBpSlFrRpH27ZeBUulIvAlOYkn0p/vLXoci18WX/JypqHWU1us8WsFZ5uSZQEcjNw/SARZx9i2WOgwYXqUAHJqDPHiYYT67uzKpWJWSStLEPbyxSaV/dDT6BI7VK9vN3/0zrWjcpIiaQa2w8iOvx5EoCu+4VsB7hK3e7m12LghewEzDBRmfJDXN4NL1cROxNXqHLVZSUfQbqCacKa1hJQTa/S+EFUyhrzDHuLzGEoaMyV0ZgM3qTVYOp5mgp5+DSQoZXJKLjgLHJWsuQQhulAMQVrOKVEPyLMrUF5DqvetXYGAMZPSLhlobLVt0NL1tXQk6MI6nJKZSueFyL3I57TF2CmLJ6CGllXiGqV716N8kUCa92A1tewtkXyu3N/2L5+nbF+C52vvSt1DYIVyD+alm/PCnmfz1c5lKd1oDKzGkD6Tgj0T7zVSpic5uxiZfMvqjCo4XgUzf8WrnIxSs0MEENohSJCc4OtyZuDdDK0VU+MsLFvHmkcXcHrqQp56uZxJ1znyvd6YoN1PFai6iRBz20YVS7St7uqrPH5FSPd6PqLSx6o5y3XPIysSYNc0+o/NjD8lrMOfGvmWUKYMx2DmaU86mtHmyyZ9oF2s60cFBFC6NlLtimZywqBGm4BMs24SwfJvTiCN2HYcxOqutsp4m9YcFHHzcNfLBhcYPzu0sud9NWo1anS8bjUIN6LT4m6HVP2eRCtZrVEVW4Rf8DcPAETAAGfSiSLAkbxcPiOovu3fVN7tvrXLY02PUDNk6IbexTWbZC0bZpMxeobZdfO40O/OzKHVyym/Mlm6u11VBXdFrNurkuvcnpV0xgARSIZbb/mgNac1GNRFIVNcXqkWwGac8aTlpK2LJ0P+2t6RneuK02CjeHdhzwsws81M8D8p9S/TYAYNQAbnd1w+eu1/GahBiz9uh5CcuSkWr8pCf9NaMGL5QuM7bjwvaJf4+N8gBzZcCcPS3MlT1nE+n0ZIFJtszReM2ikmuahmE5zEI79ijUyIYWisMl9sCD2MJ+C5DsIzJIrGJBqvgztRfkIiN9zzZcIetxqPS9aaz/b9zxu9/+Lhep1d78HwKxPBZwiEgcbveLyv36SdQ+rGswcY7SWsofz7hMbqF4jwtFvo21pUgXz3gyw//MpcKmalO74DTv3M6LIaDM4XhAoEqeUi2TahlYalle/v3KnckAEzBdbaVCZhhD0+gBGSwO5OyBLDxdiWEVaOxeBg0DPV2CPU0a8GUdCknSjMGQJXzdk3BalJCgp9lA88mg8zGf2JxAD6iddMWLB3zABEBEfFhfAlhfEHLfw2nXeKHBYFkc+k2ZLjghFvna+onfE2aZNIjfltUXUnTRY1ER4pxcsckfmuVPykleNNWfahEgUPWcrnROHHmWX1gTM5GLhKVW/1Gd4eTs3DdR4GylQBQw3SOcToqdjin4mRHUgAqQAIiRwLnpXiJdULN8xmb8CIv5XiG8YPAZTT5VTdcdh7QwAgsi34vh2OmhHqA5hykyX/MxH/MJRis2hyu6orz0oKAUYS26HRFiTxDinRKaV60x4UtQoRPChPotw4H83TEi4zDShGPVl8iJ3GSFYTTGABmyiAEK4B0amGPk2cvZFLRZm7Pp1AINVR12js6t1jn6D5/9QAqw4+iYASAGIgZdghk0gWwhogpsQZfEECpkIG7tnh4JQz2pYFhdwSjmjrgMh/EdFyhmovKVYgyiYgwWAQ1OJCuui2BMARaUiUZOAZlwZP9HEsEKTF8uVt+rmSRg4aIQbg9JfF8vMiOBCGMyjFwW2hoVnt/7BAhk/UIUIp4WeqGxgeEXTqMYksrP2Z8B2t9NVV7MwcjNNRhP9QqvnGNmjeP/PIZSPRtILmBk8BklaIYpCMLwmcHr3SMM+KFu7AEjyMIfyVMgCU0IVuIlHuTw4YZxxZu0MCQKJV/W1Yin8QCg8UBFvmJgEmYRxMVFZuQUDJ8aqEEWOCZHPqZWdoAPpqRK2qIRJtEuuuRLJl79bKGXESNnfmaVpc9oupRQktkAesUYDqVqppmtICCE5YobdiNisBmdNSUaHqVu1lRQRUYzMcHpvQA7EqfyEMElpML/I3QYYcYWWTanFpQbD0BVP+oRbSxkCzakjVHN8YEidrrgKBZkX5LdYUbkYBqBYL5iK65LRi6ml1RNHEQmfGokDnaABkhA3QXAfZ5kk1XmSKiAfaTE3u0dSPHa+QEFTWKK+tkaFupN4MHE/Jic44XKhJKhDETecGJbhrrcgVkehNHmgvHf5cjZTx1YHYKOHFlTcN5ZcYJABmRACrCnmITbQSEPiNmojV6BPrbTukWapuXOXGpnkL7YXlaLtUyaeILnKz4k6nVYk55iE6hnRybmlJZJHKiBIGDpl1yNlY6BY7pRCmQAZVamfu5nmY5EfZyC3mWDetXNgBKeMyJoTS7j/4Imnq5VoZjFnzQSpWtWKOVZo2w2m+h4jv85m7ORYwAaWBo2hk+dDD0OZ3G24/5N6XStwAcoIiKCGDFdAesJBwZZp9RMS5j0xpZCkhnY2JD+aAl+Z3iyqpReQbgZ5qu+qnk6qauSiaviqqhaaSBQQpbCJ25czUdiQWpNH2WykgT4ICpVlPXpZ0rq4r/0QSxlQ2es6TiwqcNYYbYm47bOpBQqBcR8a4NamWI9aEodDmpCY4WwZuNUGNdgKJ+ujAHGpodyWzZtnhwCqoVRpTYh5c4ZpaFC0Iy8K0ZOYwyaXZU2QaUqT9E156Z2KjKkDiUohyheTe6Yaqq6oKqK3SalHv+SsmoT4FjIFqSrjmyumuyUjmyZPAIl9KqWymewZo3PWaoP0mzN1ix+niSyagChsUG0UtxnWGu1Xqu2Em2XaSuDkg+U+eRnjo8WJlZJYRmcGg667umDGGVrvmsK9JioaG1vmh2MJCo3SdvL5dxf1IWEXZ7P9etuMlsyTehluS0C5didichwKk+YroBiDqvx8KFXEKYRfAEeUMIFJaeWuFjFkgGpKu6qJilfDt0dPW7ANu7JUi6VpmzJWu5G4gGW9qqvbilkumoLgKmLFqvN0qyZGhGySkAJsC4K0IAWEEIeOEKa/qw7PMPt3i466G7RWuHucivTGi1OttRMcELxjsL/8Y6CLnSc7x7O+aWrnlJo1XpS1i6T1mLW9aqIOLpRHZXo8m1e0P0m5gkG/vkm9sItZLAcnwlUcVoA6S7sCgxmWeIRhwFaIAwiCGpplGjk4tLj3Mrqx8rlxsqqAIts5RYw5YZJq4asri6wGTgNJRhC/u6v4u7t6JruzaKu6paA6k6ABriuDphTITiCJeACLuBu7qrDM6CD7baDwOAu8yJjDCsIO/xiT9owUThD3xgvltFC8MJw4kVDhObpuvJp5Inuux4xO2Lvn4ouAgkY6a1I6JmMzsXrAIJj/R1q6c3r+aYtAdGjbd5FCkTA8nRAdcFvdFFq3tpApRKGAxKixEow/8ySKrBMLsj+bwDT2wGrL+ZmLpXqb2IGawL3saj+sUZSDSUQ4ntSMLDOpyySbumSKZmOKcTpbPuWgAZgMgp8sBQ8gTnVgeyKQpoSA8U9gzqYsimv6Qvzrgz77u7SMBM+TO+yhC7ssCrY8vL+8O96JksMcS+3ZhNTL3EK8zBHqvkWIBdfm1962tl2nmn1nP3VH4nmK7cF7HCuDG6cbTsKRrxU10GFJ1kurBM4MCLjLyNP8B/v8QOJJ5Li8eXaSAMjLsZaLAMfzUbac4ziGAMnruY6jSBcwpcAa0AzMrkgFCRHMvao7rFSsupickN7sAnQQER3chJ0ch18Mh+McCdoNP/tnnCijLKaJsoqt3I6vPKCxjJL6K4TgoLxbtwN+/DhQYpMlhzVAtiFErG7Zm0SQ+roEqcxy2YAvYznVOM4zmE3Yeg4ki8yi8pPv9EetmgKOLCYcM0JWCg73q0iFqQNbGSgBa6WSCyo7pscC3LoQuRfkt2SMmnJAl8+s/WobqlYvjVcx0ENzXU9V6ld2/U9Iy7/OvDmuifLArRfB/TwCQIehInPjRo76ieypsD4fgAlgylDR/bO7gDq2WNE04CNdDIUVLRFWzRxaHRtGElHk7YqV2tJ3zAMp0O20jLyupfyLq8sizSDNsrzQq8YJrERN7FOD3MEuG8ZW++/IZCHuhz/Uv+piYaxiyxbG7Itbi71NGOOjbxAi75o6CWG6CaPi5aSdpvdrEpkAwb2y9pq1lTk1gB3C4SIx2LuI83zDIkLXaJlqA7pfN81Xtv3lnILIb7xJfhBIKQBQKfCYL9jIsun4HqJPztBmEqAEphBlzpqAoBAXdBsB5jBCyCh1UgLDAxaGy+CAF6GZpcBlczeI/xGbXA0tQotKlerO7SwDLewagNeMP6CKpwf7652uLbPTM+fbT9ej+d2MPc26XLwiwa3T+uKOCrbOGYbv/Kccx+1VJajkffPT5medFMeGPdA8ggzD3xBYU/Bjg0me8r1qIZsXBiswt7tQNSAHcMzXTdg/xrUNXxTzZy7d102V1wzXT0PqV6PeV3z6obVpf2mQhwA9CcYQ1nFuVcG+K+yrJ8LQoLjAB60QPtCNRYgq+CmwH1+QCDgwCuhAXHmxmo6ASEO1QswzQSWk5VQBpYoQRnkAin4xgiTQi7AgglLQ2eouIrbuCvfTRPKeMd1AtGONI4zjC+rq48DedYuj/sWa+pSepF/LYpK2L/u3NmubccIWLZlFo9J+duC7TZpjdCB5BRwy1iyI3o3OF1gtwdodVl1mA61gN4O8pnrkIJ38AeEDZsbzdQENr/7+78HesDXpZsTfMEbvFzPtT+DKmTaL6LnxiCiJetFYCCMaqPX9YYBwf/V9CD3OIEg9KAZpEIPQNym20AHSDqRk8EjlAWMMs2np5YZGAMeuKPMVwELAQEZkNDp5YHt8IFFA2iP3Icw6LoV3i5It7C15kQJ74JN0jjR5i6MH+OB7gRN/1cRE/MwXzWzS/JCg0AxR3tpPfGDaZbaGvGiymtRx61Sk6iGIlD/irNTp7k4Zw1BKdTMWkARxAFIkp1WOrK9Y4TOUoAKsMCmwjmd39tXf0viA7TX7QGXhDfCL2bhH02cQz7l//mce0ljIqefvzGYzPUEMVKwWvyAz+M/r0jyOAEegGkc+EEchCnJf4DVdD2hocFQErrNpxbTfMKC4UZllxVcTNCfPYH/HgDDJWiBGJjTKcyuI4iwSRSJraM4aZewtiq9TR6j7rI4r+fyluGCjhv78Rz7nl690mn96bKSw0kABIxxkcuRFCM59xag+4dO21rlc1N5Uga1o2a9izI2QKRo0aIHFhssPHywkOFDw4YebExhwULGxIErEiq0MCFBR48JJkwIQYJERECCUF4SZIqlKUMuWU6iNJPmpUc3Az3Co3MRIJ8/AwHdMzROUaJ75vRJQ9RoU6dEKaUKZGbPylJX0wRCBajozJ14mpq65BXNnLFGLxn7hCeVKTNO4FJNkYEqoBYiAxGhe0mGCRM0YLwQjIcwHieDCyvBQXhHlFJ7GntdYoRH/6RSj7hY2dLGUx9SebSU4UOqkyM+jlALU/1sNTFprp9le41rF21RonZ1ItYJnbTYvX/3Fh6NODRnxovTPu7sR2AfMZxDrzE9OnXr1bFLfyFDcIsU38GDd8gww0bzIT0GUK9eAkOB2wfikD8fRw/69/Erhit/v/ztL3ro4T//7MvPQBkOPLA/JxSrrz4y3hLMBPc6qPC97+oLIossgliBAg9AJCgQPwxqAcQQMTLvoxUZCGkkgr7Q6pxZaGzJxrYMqckmnL7KqaqggAyKKKGeKjIOrozcg6WupNrjklTUiKNJKS+Jg5Kp5qBKrEAoQeqLs5iskiWwyDREQDO+SHMkQP+Y0ACGoGIIAbA5p3LCsMEEIYzBqmJg4jEYmBDkSOiMwAkNzZzkDDPNculji9CsYKOTXDorrTRcYst0NttqQ8634IYLtbjlRlWOueZQ3eG561bNDrsVtOtuhfBoFW888lRE76P12HMPvgSBVeK/7fxzkEBhGUQWB2KDRVBVZ4GI1sBhhc0PLjKwZVBCgZzAAi4OKvQARkEtAtGGDW3YoAMKyrOggxNMXFdXFidg1zwKZMBCEFaqOWdGYABuqa2ZrvpEx56CzClhIIf0KSuHITZqqqOc0qpKi9MkC5WlqLRSUKoeuQyPK7sqOKor2WqSsKjInGMKQExYgU0NNHhiKB7/AvMLCMzsnOK7I8m482YgujSBiEfMCKSGknQq5dAqbrKCyzKgKOMxKCbToupTGi3Da0VOu83SUy7txBVcLv1UU1BjG9VtUpNJxtVW52Z1bljxlrVWEHC9N1cFAN81gfXaqzC+BA+XtkH6ACRWMG3razzAyOdjtlnFMZfWPsvna/BaNK+VkKBvw40gAnfRnYJDdUGkYIEGLHgd9nAnWvf0Ajxi4PWN7F2oIRvwMGQWf2k0pi0bTTZ5Rx4XRvhHIrOSOI2HozzSqCEvM0uqjLv0uKhUqgQzp0+ORCVPK8GPSmVITClsZKm0mgppJzDzC4Qfoo45BSbwAOIFsL6jh/4J/1AJjCGC01QQhUe8LAoqeJlZplCDJVxJCXpYFBmuppknaHARTnsCG0BYBxGOkA8iFFva1KYpUX2qOK9526nqZrcYxkpWMfBOrebynb61y2+6kkDufsiewmEocZfj3IMO46DDLLE7ADJi5qAFxWVNMVmLUwKDuvUWJEpIIxYwXYUyEIEKVaAFWIgDFuBlIvPs7kPsgh3rENI73nmxhw8JQvCKZ7zjlWKP7FPe8pg3FKEQKWINc58hH9GkMX2ve+uT32PKR4qhgM8nbQkKKlQ2sMII7xJsucxYRgaZF/DtBz7xXwosiBjBxEEQ9cGMAKdDiTkYLS9ZMkGWlmCXD/wAgf/0I8MOMKgH/WDNChsMGRnqIIYQKpOZyhQh2E5Ymkypwx3uQIc71uZCbbowbjCU4TfBGau8bUs8OrzVDv+Gnh8C7odBDIAERGKhKU7rWfNJ1rC6IyABdeeKzDri5aIYUO4UKEEACp1BsVCidVGoAys4QULjxQLVTa8IF1DI7k4QpbsAzl0R6VBC2BVSN97rdGIsoyFYMbxzsGKPBUveH5m3sOYNUkgMQxKZLPY++VEyfuijSSbTR0kpKZKnpgCG+6LSNFTc5Crge9qzfDKYS2BrZIdJmnxaBqheKu0KcZAZZfYwFxkgDQhooMQvpQaZBhHTmJ+gmmbK0EwQzrWZcCD/BDTFhqneWFM24xiHb4ajTdqkirAzHOerxJk3HNoPnXUMyWMfi6sggoRCAplPEev5rO0ECC6S86w+HfdE0QbLoHHprECSRi4LVSijhuhCDxDigQ/dUQ0zSFdJISICD31oAexiQRqCEAR1iZRdtqNABcIoRvfYKRXDC4Yej9dSlsCUeTgBZCdnStOfVGVMTwpKWpbKx6VgEhVXQQZ2UwGMXPBxK4Dg43eB0T62qKUwJ0sZU0txXidx5VBxWNR+CWOKJT5ilYUJjCw/YAMCtyAOVwAEDFoAMw3QDy1m2M4i5oCqKyrhCc8JJtZG6DWqLVOuznwmXsWmqXZkc5t0czEN/+9mtwsta7HnbCwP4bmRHPvudO0aHEhyjKF/NstyVcQP5AQKRUIV1H80bpwTM2TQK14LBwzBwVsMsjnDBTe2DaEASIIgqA3pVl4McB0dG2BmEIlgIqwTaQVKajoeukeiWglGOZ7L0ugSrLzl1dGV/mwTr2RXu4LESsiaGl/yVvJK+HXvUpUa6Uq2FxX6HR8w8lSwkAGjGp9sNMMYiDMFXgGVC65B/PqEYCYQOAVjAOD/Rokm+wXNL0jbYLQMiIO0shVbVfN11ZQJ7BLL1YSb2MTYOvEMacamNIU17LNpXKwam9PGGVDAQnZ8HheRR4fzAvIHwIPZYCULWAJS8pKlyP84a8Fln5wVjGD6SYT6gG6UIMBQQbwV2w3IcaQXwIgHghuE2hE3pP4GEUnYjJDhwvm4PSa4QwAuvHLg+blBrYny/ozxTxdakNu99I4uXoo8AeIRsrgEI3ziXVSYHOVPkuTKc2IZk2tlGJRoOcwZAXNEx3fTngYGUxuoAhVE1SyBcWAq1PqJKYCAfz8zjL3xMBgn0KwEdnoBCp7+nkQ1B2rCJGavvVYHEIdYhCYuuxjCkHa1px0RiDD2bVShirG92NmuOizeoLVYWtkbnXP2u0isbZ6+LdTH7BGjZQGaeMWP9t1MNOjj7gMhM9iTA8saiGkHXnBwH0TfLHBBF/yghhb/4FZcGkoDCxyQen9PxAUnaN2b5fzwDgBvEsFYx4wg4ceayCTkfQ50TLUbiR/1xOU4VRhQvCv8nJh85SdnBKIfjXKSl5fmfl45pHXe87EouhTDOG95XRaFysAMDUqbFRC2sh1VR90EQesB1AejBL7d7xFPoAEe0KA4K3SSqlcDu69FiAyISeygwMTMbtjUzg7sYIQIoQ7gbhOgLQKlY570jkIYosdubM7aIwOVqyEma4iIKMkSr/FGC6D0yfE+y9z4A0JMyz/M6bf8gETC5d+KQA1icAZOpPRCT0BykPX27c02wAYFTrYYLvaMUI5I4AsgQaVmgRX0jCb4TCbYJ0d4/w/QVEJheET6EsZ5EO3QngcoJoEnpk/TSM4mwgvSUq7RJkEWZGEND+0qIkH4ug/krs/6au4RWo5nRMkvbCkG9mDqmMDC7kcQU8BnCnEuaKb9Ys1L/tBohuImvE6DeK1qxG7EyK4SERDt4ICZ7KoOFjDE6g7d7u7Z/KlWOpA85g+dNrBdsu3vBs8DJUCIKARe8ENBNuuIhizddBE/SusW92nDgPFBQMfJfCwkekANpoDLWKf0kjGOROq3OGQILwDO2Ki3XscBPE/fNuAHi9CN5CjNJsAD1IAVJiGl8iwV2KcKfc/3fk8QrItHsnAReOQTyKtgICHTxocn3tEm8hCQ+v/xJp6PugDS0QTNzwryHVEu/IRuJPgmZqpsOxqSixAxFSWgBBjLfuoNBAAjZ+BtmCjx68ZOhH4txDLRxMJAAZuJ7sJJAokRXPaGbzCQFSUrA0qg71rRd3CyPD6wPcJN3Ohjcypn8URRBEWw8R5nQPgj8rQoBSBgJisgIzZAoiQiXkCK4HgntwKkdqYx9ayRjhruAqKy9URgK5vyGmVnANDSzIoguGZgDJbwX/RMCtsiHWeiCg9mH91xH7HwSRRtYB4BJb4rH5mKH3ViIAcpDvfxuphqMEFOMeFRJ3Ap6C4yFTGyISkzFRNx/lAAM1Px3V7g1gqQrXwN7OoAmZLJAE//s5k88exSUyUTy+7qRu9Wi/A4UyczEMdWcSH8xj108p3aic580gUpByjVTSh3kTuIhd0O4xaPZT4kjwd1yKTiI10ayqOk0Sq/cs0kKgumxxkbbhs1pBuzUSzNMvU+hCw3IAjO4Aw2RA3KMRjgki7Fwi51JC+Zyj4REgv1Ez/tEz8RUy//szB94vmejzEXMzEV0/kCVC+RogqeYyLt7SInszb5ZjNDIDMvMzw6LAWS4DNFcwBLUyRLshNPs0SDTQIjkJxkk0JvUyZbtF1uxZ0EIMiq0zswi9xU0DiJMt2SKNrsI0fXzSC+4/AGwow4hCohQkNQIggIDuCO1HbA8vO6/8AFthIsRcAFZgAHz0z1TsAN3GAMyLMCRCALvpQbS68t02BDyNQY8owc0xES6lIKZyIlUgJA33Ev7bQMC9ROC9O6fmIfYWEgDxQn9nR5FlRQ/dMn9ABNhMVWeLPaWDRSKXNC4K3DeK0SLzGZTFQTVXOEThRFsWOfqEVFVxQV+84mb/Mm+2ayDE/IXuAEGufIdHRHMwtzkLJYxu1aCMrysjIHbacDwmwHx3IaPeBKi4AEiAstf+u1tBIs4ewCrvEBpLUCWq8tzyAHWOcEwpQre6skNOQI1nJfauEc8MxNDQFOA+1g/JNP/7K62PUdA1VQ9/FQ33VP7ZVP1xUyvYUYwf+tXyGVQi0UQy1Thzp0Qy31UjP1AJ2pUz+VFGETn1xwsU7RQnboX3coN10RFWMyJAgnnsADVnd1IPipVkl2VhUHypYlZK3oyN7C3aiyd7ryPMOSy5CVCMtTdwYAX7aRzYpA4bg1Wk0HAoSWWsVSXcjyZ7nyAUhg4aYg91iBeNCxqaiQPhszX/VSEBjBHfPSagdVXr0WQRMTMROUMP1RJcZ20PDvMByiMic0FQMWM2tSM+0NBTYTI0sABTjMQz+S7MTgExfWDgzQmUB1hvQmPA7vJU31VCX1YjPWJnklJA738n5SZWkVV9+tchHEyEY2b+eJZbUILk6AB8tsjnzV31z/QBnHyDy98inVxQGiVE2Z1BqnlQNmAFsxQFoxQFtzAAenVXVdJy1z9nWw0j3hMz7RsS794PfGlj/9k2vH9l2ftzGjd3qldyYGU1CWM4dyqG0FljMvMm4jtG5BwCKTYIP0NlPPDiXRVwwGl3BJtQJPEUIrVnHpVzfn7BStbXDU49q+yLIOJxdLFnNJS3ISL0AY9fK6JUoWynZOahCyYN+sFEu5s7Zq9jtBzw14V1pHYAa89ASCdnbHIAdcgBtdVwTWMwecMfXSsjzdiATGYEOmwA+Y0BjcNF2VFz/N1k+hN2wLdXq71kDH9hS6tnr5jM/oESwMkVLZ1nvfNkP5DgTo/7Zu/QIR9fbWNHV9R0jYNNU1QbVz3zc8IrTH5Hdx6/dF51dGZ9R3YKWIglOATZZzc3UpMURfsGD0iJRMV8dmXZeDBwEZt5FYN4A7Z4BKe3cBNiAHxmAGRgBcghYDbrd309IFhOAIsDRLXS9pf/bMTO+FuVOGZ8R46FPjpPc+79S6tnaHw5YUSMFAV1kxVXmUh5iIZTnjDGbybGWMm7g2tzduTUCKv6NukyBmNLLDPBR9S5RvVzKZxemLqW3vEneMy5hF7bc9tu3GAIdXDMBdehJaEqeNdRSAAZhATOs7LIAALGAMBMFbesAlFy72rjG3JOp0x9J1jxZpN/gERqBoHf8ALaV1nzH5kTGAg+WgC0RAWoMXk3dnA9pSS8eARvzlX17Cj9BVeauWlME2ll35Jjxhozn6lT+ho8+WesfCYKqXpEfapAnGDNYWIxHRQuMWBWqyBGRaUln6LzTU/uwP3spOUw+QJJXZYS+Xmd3jcLc3A6B5fsk4J5XaKVe1YyvrfxHEm4+TKEPLOJdInedCJC6iPgZZjYJ2jhqut1iXBWwrhfkZkz8YAzigaMElZ/sZPQFaBI7gCIbVoClAojwgzRBAAHDndxlsPd/yX46H90qBakcZMEEuL2F5sWHZo03asSFbpE/6sSe7sk8morGgqKeYe8k4Q3Ho3Yb5BcpXDLD/pqdRsw5+eiVHdUUdFRXNSYwTt7NRFWOXuqn3VwGIupuluoC9eGUL+HNOi4HVORknyma/swjmGvWOKz2/4AjQtKDD+gFyN0s5YHYFOgd6F3dzYJKFALpzNuEouUo9mJ/DGnYiAEZe2D3HtQmP989kInkZO77lG6QrO7Ltm75HmqPrG6VJWpT5SDIIz5klFXzh9ok/W7TBY7SVoHxLO3CvWHBTW7UvZNo0m4op1qi5LbaRun5pW9vQKXD2Vzd7MnTB2TjDmVaLLIvYTUQMwcJSgAOcQBBafF3G6F26ALi8c49TahColFhTT667YJAZToNz4Fqru3c5gAMe2aD52QWQ/0AIuvqPp/GPXWef+bkGOTkL9oV4QFkdKXq+SxrM+5se/+i+8xu/x7yINY73uKIIeIAENIBGc8ghclm2ZVNFUSAFiDlvPZRhQTHCuXiZEXezBxYRYRupx/ioo1kDLzCMFCIWndpCLGsE3rjJ5O2N0U3eTKtb9AlWU7cD3DIL8DlcqByhsbELnFuf6dlnfxYBIiAH3mB3hbyfgfcBal3Jc7fIIYHH27nVv7stOeRcnpbLJyF5vTy+eW+/KdvMIZu6mH1HPlqVX2raJbqTwg/Odew3KZSz6zxCDbxWPFMwOjTcD5bYdpp9Af1hw51Ub4XaJtVU3R3eG33RZ3Ka73feY/9Rf2mUtVLWjQMY04Nys5RTQpSrLA1AAcoo4FQ9aZG1jd46d9nMkav8rIF2Gx9grQd5hG291rMbyY/ACxT5dg8aoV3dSq8tC3Jvho/XLqXXsCe7zJ99zGVe2c882qWd2qGwYLjCBlbgQuflADwC8DR8299dezcb3MX93TZUtHF6g5iJEn060IFaqI0ejLw9jCfyqCE0JmUbVfM3Jze2Y7UZQ1KAFgH+3/390gd+IjFwaMUodLM0uBIOkKecrEcYkD1vhI22nmf3kZPcBbYbyjt+8MXaIhDC1G/24M8bth5qEIq3HFgKFeSU5ZXdvyv/pO0785dd5gtmujw/TxRKV3D/lkUoa+jf3bMd9cDX/TMVnMM4jLSFDep9Ld3V/c7BSH6z3qjj/YkznN5V0UU3cBUdztFBPACyWY3D7eynuiiDNIKaebU4wIzAVFvVUwanfBpZ4AwS4RDOgHev//O+9JKHvAJmAAy8IMn9PgeQAAmOnPAhmUudewQk3p/VWgQgmI2A3sxg0BgeGiCAoZqEqtQlgwcnUUp4sCFChwgNRoT4yWAuiRgzatwo0ZTHVJT8CIozhYWHDxYYqDyQgEBLlzBbSrCQoaZNEDhz6tyZ00SKn0CDAn1BtOiLJE+QvlACJenSplDriKkDpY5VGFizat36g6vXokKFfgjq82fNDh14//a8ydZmiptv28rlObMuTQUKaNaMkCFtzQkBAieYOfZnCxyIE8tYrLgxEMePFS9lTLmyZchOnJjB0uNF2g4nsOAZcwLHmDFBWni4cCF0lxlFPFBwUAEDiy5dTM6mvWDABjeH/OQ4gYF1hQcPTgznUIE58gHJkQjh4By59eu8abd2MdzFjBEbwG/AYB2B+QboKZC4UuRKmmDnyiErqFDWJYUU82ckpf+Sp4r8ASjRRRwFWOBHn4w0BREroLSSTDFFGKFec+mEggk9lSVWWEMZ5SFRT3jYFFUjSiXGiV/V0JWKKfpQwwofcmjWjB/U6NZYOvEFVAZ8qdVjhWoB+deQeP/dBQGFN00ggQCCzWRYCodFGcNlj022A2RYUqklZptlFpRmnOGA1nFkHuBAF4O8ZhJrqznQ2wLZNdAaCyK4cIKdG2D3AHTXDQAAB0h0B56ehGaHgQtdgOHFCGTG+aYFDoSwQnsUWLCCIOUEYwx9nC7Un34HFmhgqBkReEkgZgDxlpIQFuCqhC8JJoBMSAYJwoU80ahhhzH2isNSRT0BVVNiDCsGiy4iu2KLXMEoY1B9aQjCjG+hNS0IPcbFVlzcaivkt3KlhOSRSS4ZWAB5RfCklFu225iVkE15ZZZO4NBDl5rVG4G6zkEKwb4UmCkCnSx4V4QIbb6ZHQVsPsDaCTP/jPHdBc8Veh0G1IlXKJ+GbuCdCxg3CvBuK8EZgqVfUCJLQfY1dIl9BFEkqoA0c2QqqaWAZBAeCzaYAauwzvqq0EQXPVOttl6b4bO8BvthiDEyJSyJxaKo7LLJXsksWEzr+ha1X2fb149Bfn3WjeACSVhddg057rnoOvkTB+xm6a68d1sGb2JkmFEvDnjg0QN1KZDr72wMU+zBwEXMMMMRRQQh28Ied+HGd7V5nIMXr+FZ3MbWYbAcB+QtbPoDj89g550nDIp4pXd1sIIRXwDyKX8FjTrzzbrbzDtGqehMCao8rMrqg0UXDQCTzBs9WNtAYqh0T11H/WuvUD8lbPbG/16tNdbgx+Chs0wXZr7X1prVlrdJC8l+2m5P8Jf8FPIlgbno0lTWYVDWnff/eNPSZDLjtxSYwRSBw8JpcIA4tIznYakziQgiliaKOexhluMccXjTmhwcIhGHyEHpLIYcDowuB9U5HW1GcAQhCEFQOSBNB2YjOxsEIQuBEER98JO7icgMVKUwFYGG2LsgboQgMTvVF2zQAgcFbWhQbN7ymmc0JdEPXLvK4rOKcj0RXe9XIYLCUra3Pe2FMWvh+174qrch6Z2vW9SSi/oq9D74pc2K4rriyO4Ht6NBqX/+Y5EAYbQYQhYygIhsV9+YIhrO4MEQWGgQWm5TwQke7IEUO/+CHLoQm4Yd6oG7QY4ALnCGQ7whC3gi4QMA5ULwjMBzoLtgBRBggRO8wQ9jwMIX4pBDJPpydwFaGc5+RwoiDohAAuGUIFBVEieyBHmxiqIUzzXFKkIPfmz8EGK0GaMkBOuMwhoj99JITryJj41tlFZQdASXubDPW3W0o078mEe74DFaG/hLS+I2E3X9cQX8S6QgBWol1cgLoABEjGYUuhm65ZI4HdhAI0lQmwtQFDkBI6UbXnNJ47hJO4Zy5cc0Rig+ccCFOcjBEbyjOoT1CToDiCm/gnAGQ5gCEpPAaacowcOZqWwhwhymMTcyjI6IhCSqORl6ngkraU4TAFCNqqz/YqKSK1LIjUvT4haJ0kUudhV7RxFnGMVoJa+UU3xoHV/5cFSWa6nPL/6M3jvjKU+1xY5+94zWT3pkLj7KT3aG0ZshD3rIwhq2sGWlEgHr5YTAte4EPZiC6i7apkZxMHGrdFwqj1Mcj3p2X9RxHOksZtLNrbRgqrMTxeCkuBuOoZc81WnwdmrE/eDuZcXEXW19l9si1raoj9hDqlaQEmg+0alSTS7crGlV97k1mz/ZpleBxdWvPs0oZFTjWdHIxaaF5Y0YCm/hoGW2s3WrrugV0rjwyjaaqOsv6OKn/gIrWMQmcnbTHey7LpOZzESJOYYJDeRWQ7FQmi5xjCvCER6KVEk2dbZRGJtBSklaqEOpTnEu0CCiWmg5QfgBpyCGhM4GshCcAdW3vU3xMY0ZVITowQoxwMkEmEpjCSWPecrNcTUhdE+klQ26vRrfV6ULoiJ/cykBAQAh+QQEBAD/ACwAAAAA4AEOAYceDgIsFgYuJREvGQYxGw4yFgYzGQYzGwo4Ig04KBU6Gwc6Mxw8NiI9LyJDHQdHJAxINBxIOiVKKhVRSjNUKxVWLhhXOiRXSzVYHQFYKAtYQytZLRZZMxtbMQ5caEhdWURkNhtoOyRpVTppW0VpZkpqRSpqSzNrX1BtQhxtYT5uMQpvb1RxgV1yPiVzjGl0WkN1RCZ1RSp1SSx1VTt2OxZ2SjN4US54dVh4iGl5Qxp5RyZ5Ryp5TDZ5ZEl6Six6TDR6XEN6e2N8Uzt8l3Z9UTR9pHuCPg6CTjSDUzWEVTqFXEKGSyiGWDeGWTqGlnmHRRGHTzOIRxeJZkeJdleJhmeKVTaKVjmKbVKKfGKLUiiLWTaLWjqLYT6LcU2LglyMonyRknSSTheSTiSTXkGTq4uUWzmUZEOUnIKWbVGWwZ2XYzuXaUeXfWKYViiYiGeZVRqZdlaZg1ybbEubcU2byKSdYiyhWjOiXSajXBykbUmmdEumfmKoaTaoelaolGupYR6pbkmpglyph2WpmXaqZSiscTqto3itrpCunYOwjnKxvKOy0rGzfVa0bCy0bTO0kFq1i2S1pnu3eke3hVq4jGa5dTm5qYW6mHW6o2+6pXu7cy27k2u73sK8dDO8gkq+4ca/gT7BeS7BflPBjnLDejXDfUTDjWTE3sLFfDrFmnPFnoHGfDjGilfHgzvHlWjHmnXHpHrJklvJp4XKgjbKh0jLhUTMgzvOkUvOvaLO0K/P47vQt5XQ48TRhzzRp3PSij3SjlPUjEPUjUnUnXLUq4XVkkvWkUXWnGjXkD7XpXXYw5rZllbZtIrak0XaomrclUrcmEfdmlPdoVremUvgl0rinmPjm0zjvqHknVLlnljlo1vlqV7mnU3moVPnoE7npmbnq3Xook7ot4bqxpfq28PrpFTrpVrrtHjtqVXtqVvtq2Pt0Kjusmjvu4vwpljxrnLyq1byrVvyrWPyrmr1sVz1s2P27dL3t2n3unT3ypX4s1755Lj6x4f8wnj9wG///OcI/wDVTBJHEBzBg/nyrVuYb1/CfL4CyVFDsWKZOhfbUMyipSPHLDaQLBFJUowYO4Dy8LHTZokRIyZXOppZqWYtYdOwddvJs6fPckCDCkVHNJ7Ro/SQHnWXLptOa89yQi3HLinRp8+C2VrFlVQzbMJKUeM2VhRZpkydqj3L1t3Tt2uxSs1p7Jddu1+nDhUKl61apPICCwZM+N48w4jfKcZ3bjG+fpD5Se43b5tldYMxB46rTXPmz57ThRb9rbPp0qMtS6tLSpPrVtHMaXNaOhghPKtmR3U6lmzvvsD9Bv/9N61xwYcXT14eWXJpZ+zOLRc3+aFk68wVo8bXjrH20MnDP//2XobSwfPtrK9zyBCiHosYLWos47E+yI/4l7TJA2glSzFPjHQSTTOVclMxsQ0H3F5FNUjYg5vxNJYxu/30lDC9dOVVNlqVUg6Gvi0TF3GcKThcMXXh1QyFJPJVonCEgZdaZoklxphh40UGmWGynUZaU7rp5KNsM4KG2ZA/puYNNKy51ggo0KiWoDa23DYLb7z9pmWLwb3IZXHVuIWWeDnqOFll0EVn5nLLJcQmP/hgluZ436Em53bI4ajGK+nl006f6rWnkHvxxWeRFm3MR19+90Fx30l89PcfgFFUegcfjkgiCS04SSWNXqCG6g2DQDoIYT2opjpblll5mmA0E2r/1dqGYYlVFoZmpeWUKJ3K9SVwc62YorB5dSncsUQemaRop+ZJJplmxqlasqH9heRlphF2rZ0zLoNiK6u4FgooUEqDmYhCooLHH8EEWeGE8PqKrIm/csYUnjfSeeNzl6kp3ZpvTleNM3PuS2Q2RQb2nR7EqHddoPus46YvhXRUaB2JasRRxox2nKhMk4Zh6aUGAmPylBZONdeoFh43ZlKgpXpYhGARy+TKsMraGi1gobKKVtTUipOu8RZdL843D2vz0fIuSO3LzcYMrY47LqskmNOumvW2B/cb4bedhP3aLQiauyowCGNTCR6NoPtuiEbHbWKxRi8YZpj3OjuzlP3q/wswc5C1w+2+laGG9d2eHdbHK740Tow44zgsuS/vVaQxxlxgjLl9jwqoH6S3/ZfoG5cWUsrJxrKcMoxQR6333pYljSDSTY4L1mvclBzWllH1LvfvsivNItCiNl03qU/LqHx4M5e5I49Xl2rhp+H0tLW1Qg756S2zgCs2VzcJea63aKtDDSFhaNIX8MCfSPfxL2K9LKzWpK0ZYpD9S2d3+tKW3I09ip+1lDUJV3hCDYAwxTki5zBBieMYlStURjSWBYy1pIIcqVQUsqDBDX7sDiAkXRsIMRNO9UVr1XNRyxgktRbqzV2zo4urwNUITZyuFE/yWe5ytwpq2IpV72NfsP+CNzylFY9eoOLaUrK1vNc9r2pG0t7qpucllMFqK+Ii14HK5iPyiUge50ufFYUIN96ZkYypkx/92OK1qkSnMX7DUWX8ZzABlkhrsXAFE0CQA0kkg4EJIcjkJAGfCl7MYxzs4Es8mDE8jLB0urNi7K6SQuSxUG/4wxH0mqgbFMXwkzrrRC3U9oc/2FBDBvqhb3rFSjIGT0XC6kUQjdc0FXbtllZbnmPiGEXpBYmKv6SfMGnHvXCNjYv+OxL5cDKwWoAQFSOiJRp9ww3iTfNoAXRa8tzITebdDWGws6OvhukLPT6gA4UAB3bg6DBnEFJzFtzYBzGWhTdUkHT1NEnGakj/oJqE7UBuw9oKLdk6mVHtid1Uku+KiKBQhgIn6loX+CLpSiF6cliwDEbQNDpLaaYRlyDVZSY1iZheonCKKhvmQi/aIe+J0oRbuxP5YJoNUki0NB69Jtw4qtOPajN5bQQPlqqFRKSJiBnOUEMH0KnOh3mnH+pxxns+hkGOVVWEmpOJpnyWSqHdBKCSPBglCXpJZxkGYAi9mgxTBK5atNVJHhKFI94QBtxMtKtxY+hCh7g0FckSL3+1ZkqnaceQbhM8Iy2pSbPpk085FhoqlR33aNFWco1Lo+AUTNaywqnOoqsRpHsGkMqoUzP+rLTt8+m2DJe2oQ4mmhV9Bj+SoYcc/2RhIOtMRjKkYx13wjOe88yq6bR4MlHwilfLhCiGLjpMW5J1KIBJLFr9QSfQ0I+loBAXP2vooZrioa45NNBEebrRvi5trSzFaEYDi9ojwkWJ2OKkzOYL33mNk4hsdSm4KISvzeDUW1/1LIfQp74e6VSVeZVlXvfqO7f11G7Yiwu6qlEZopF2sHydBpwo4YlY+OJhCTnHnKwDDkn4B6vCLcRwPdGKRzjWizAur3I7tdfnEtSFZz3oE28ksw+ltxVOImEjhNxdm4KXFCUTL0U7xVNiNblVelUvewWbU/j99KQxNazytOVLnxBTsmRraWVbwcyEshbAQMMVupz5hgIDUf+ICI6bghfcyth2lJZVnLCF7UwswDmVMtIgGDvydw5vmVjFiEY0i4lLthcH9EJMdnKkizVWGwvFdYGhro55iapOgi3ItyGyO0Sxij8cWclKBt9CM7rqGUv5LsKb8izrbNQrTy/LSqxKLpPU2Mj+OMydrSwXzfxfzgoYwCJaBV2v9Ob2wgsZGaI1g1E77diqFLbVfnaUs/NEETtW0ASbabDHPe4Ywha5y5V0lImjqwA6t6AxY1aq4hRHekPvKZTVrj/DS+rvpi/VqESFupthiyZzNN2xhnXB12vN82rb4aoFpvXcrWWgSum+P7YLp8bcaM0QjrWeDLZadueUTpCuu3z/vvCzo+3wlmc7aA+f9csfTucJ9RC/6S2zbgnGc0cX15Mw/rlngT08X/tGd06WNTLGEt8IUzwomMakdDVt768tt7OyEuWoSWEHkf3hruId78HTvPCxpznMFJpstMseS7K7fObujfjEsQXSSncZ40xSuMJpihnFKvO6uArGyarxLbQtA7SEaJc04X5hVZf38TR/e+QtCmWYP9loTKZm0vjKUkfDym05D/PnBw96tFMZ8m92e9kV/AtPtdvSS9zysgyaY07D0NhiM24nSllXsAc8wKpHuttNr/DumR1oLJe8y6+N4bBKfOJXaTpjjY5fWHc8oTTzFXPTdmwCG6PZNa95//KVT/6BC+tkcI+KCSctY0mHP72vMnroAW/umK97lmIZO9uX5iDYt5DLhTF1Vac1axU2pmRT/oYbAPd7CNdSgRV8q0dmlKV0etdw09Z5zFdrtTR37xZ91+NlnPdKKnIZfgdyowd0sVEbOtRM3+UIDpZ+cOZ4F1h+5gVL72d+7OdDkvZDM5hexSZ/DRgrlycXUaZRGZIbR7dDXOFDSyhmqoYWr+d00BVvoFEqSUJ7I/V3sYEia+NIvOeFmbKAXDV8HeKACyeBFThmNrhcEbh096d8Gghh3/Z8dAh+ladX4XA/JUWA9BdjTgEMNpGCpfBdG1IzMlcsymd8bvh2b3iHSf/HiEVIhmKxhJM4FkhIWpGIWcEUgkZkiE9GhGQoZnHGQ2RBiRp1WhzlMk9XVq6za0ElHvPFDhcHZKVkB7UIhqWge2IIfFqxdoG1X2qncUeIhgu3UG3IajgIgzWWgfVTh1gGLEB4M2ZDX76EXsnlRajAXQkSUZc4eTSYd4rYiMeXiRVYgwnXdmWYZj10cwZSRqiYjFqRMiGYfJ6YZrxjj8g3hluyhEeHiqoWbdygihIXdbHXZbj0f7EDZNvVCLZoB/ymi5LAVcKXj+GYhvtlFxdpgTpzjPAIf8oYhzgDgr2WgaN3bT5CbLcXiWBDQqijCb2XkjfIYMOIjPhYkzjoizT/SY5sNXw6uI46yEMTCWXpln+Kh219tXC8QZOgeJSo5IalWIrs+DOTOF7m8FqFRZAAiC3ik0tW2Q3G8D0awk+5eFzUMGq1sCld5WoWSWZquBUVKXrTkF/dM5dvqZMeCXEgKYcntIlyYZKvqGubdYKTxmQms3tP4jaIJwzmw2ct1xUMZ5OQqZY4+VdBOY5G6I9SyY/rSJXemIPTh2GPmCU8OVgD55YE53gBmYRflZkY2T1k9V5YmZVBYTYVByRfyW8AZ1yi4BbHZRObQnyqt5ZumZFFRxd0eZx1KZR2KXkk2VyDhSXxJ0l++Ze06XOh14CtIGSow2Z3AAznEpMzOAuX/1WO5JmTl2mG5hmKqndaU6lq3SiEOmkgewaasSQWYpKMkDaOm3lzAcmb4yWRvnhaVjmfWxmb87NCygJUCrmLY4lq/lSZoUiXrSmhNgh4w4mc+8dQlhmE2dacc8gTsKI13MIvz0EwswEd2JImCeV5faieQFYHiRcbAOZ95oN3M8dkPjOe5SmJ6YhwZziZBMdZLkqZm+mEYceER9p+Y6c78nmfNfeEbqGkpxeZjsePpFiKAXqGPTSgBuYXBlqQgckTVkMtt3lKvmcgYLlvlcBixKecaTehM5mc9HehGLqcZ4d1HPoufklOczg4b1QnJNpz4NYY4CAnJiqYOAFsq9eLtP/INuVzRQS2DDX6jY5oC+Lyi0CKqT+qjgZSfBw5pEf4DI6JDAD3k+xoqpLpowRHoHLGj1Eqpa3UhE8WlZmZFutIkRP6M1AXhUn0pbE3kNtiG2Z6pgaIePv0m0NHmKZnenVanEOEoRSqn7yYrGa3UiUZollzJyP6DYVKqHRCqOAQruH6DYJariVqnVenqII3bqHWCRMGiHTVNjhFfjk4DViko5vahJmajuIFp8e4r556oSvSqb83qp3Ko0EqXkexeMIioE2hMubnFIxKjqZ5dLg6nOOypQLJOr5qkHsZUguKIWqIpjPRBiLzBE/QZp7ApsnqLZx3schIO3EarTtIbsv/2oDod63RAG7c6q1Tky/ewT/eEa47V7TmGmiHii7iFng2i5Gg1WbM9IehIDLy6rI9GLFhMSu3+p+T2ZpYx7Xo2bWf6q+kOozuabBRebFMOLB/xap8BaUfYnmhWY/mKbA7RacasqV7Q6A70bEe63zQVQz/ZLNjxnX/kQMpywcru7gmRD4jZ7VuapN6OqdtKWuF11mskLlCB3woSD6ucAzSIK7i+hjd8SemKxmnyx2KYbraUbSN87mN0zg897mgm0efEgtBV5jryrT5ZmoxqhaEN7XpY3iRi5+JmqNIJktjiLYzm69gi7diu5rNG6ekyryZWaXSSrBu+3AZEiWvyr1t/1sz41dEWbp0ZHGeyBkKl9U680kkftt/t7YstXBM0jtmJXsHlFJXK7ZVrOBFtftoK5WzVquzaOZW0KuhhIu5avZzjou0fwpH3HG6Esw/E9y6oEswsfu5jDMMqUC7eWS7uBvCYWYyZJPAlNWuelZyL+GuHLKh8Nga3CVw0AutF4m3lDjDihi9OAxt1XvD+4m2y8u1GrK9cstyfIFe51nEycmoo7pKImvDSBaQFQaFdyRv71tpHGgU3QBkElh4hdsamGKLT0ADOUA6hACjYeybmvto2QC6wAtbfakT4pav1Lq7JrzGOctzo7vH54AeETzBEiwO4wq6HEy75aTBpvC5mP/wuR/cyCJ8C5mrwORGLiistGECiCt8jamKj7h3gI6Jw20ZxAW7wzp8wBP1wwHnw6P8n1xBxEknS5SEeTx8fEs8sahZn+lrQ2W5t9nXjLOHlZYEmw0CDTvzphcqNgRyESKjAoibTyITEw2JKWvKv7rDwCjjxsB7yb1zuT2ariZczbbbs+LsHEa7x+hxzgXRGMNQtIiswZvwCJMgCPC8CfRMz67gyLEQyfocyeRmYssWtcALDHeQyeiXp9VqiaEglk25yhR6nMl7yjRcygbcrM270KdsywztyuDYPWUpG/QpjHkRsNJKj+W1dnk7LlQcGq5nKl9KKsL8nS+1u/qFzGn/bLIqwMyKRMYoayn6xDFn7JD9VBPImscD801/qMl4ase0sM+SDAwXzMfgOruwG67pXNXn8Q6CbLTt3MGuAM+B0AdfTQn1vMibgM+cwtSQzK5n/CR3ZBsEzYMurH+llLEQDa2iFMpIlsqg3NB7bdKfXNd/zdA2PJv02bCKCA+IrXITWtIAm6VWKpfdo76SLVo0k9Ji6jr6QI3MUmny8EvZaq8x3VLfU0NrHcYmmwNkbFUatEgv4Tk9/do+ncaRAghDLcANfNTKaTKs0GHGtc+aewy7Jbp6fMiGvM7h+jjEAA6PQ9WCXBDJvXOMnEf0fMgSMQcUwQWFEAfw/Aj2fM/v/8zPZ43WoFDJRW3Ug/gSp+M2vGKEDzhjTMhPfh3Y8p2+gh3Rez3fel3f+c2ADGvYV5LYmGjMDCfRTZmUFa2+7dLZA2R38DYYMMNlU4iggpu8bIXMoVY6K3HazTxcJatPAMLarU0pLvHa+VTir80SaSzUCpzC6BfJjPDiMC4JkyDjmZvI60zIHizWYj3VxLDOz020xNDjQW7cN07c+dzOjzARTBASNiACQAAEXDDP7ZzPi6spkuwJhfAxo1TeXH7eYnA62myJ7A2ZoeDJu0jfX4y8DNjXAsvm+63fb97EzQe+sDxa9je+ZKup6bvN+M3Wc1QcvsTSBnrZvdy3UUrhBv9MILdBV2zT4TpdQSv7CJwiCZLCB/k7xiCe6Zqe2h7udT1d2jZxloZ3IUc+4y9O2zH+4r1d45EezzMu1rHLDELuurTuuq/gzpCg467wzoUQEijw68COAjbABXPA3a4AC9692y+uKczu4qE2SthMohxCV2EgCf9Ft8gIw9zl2HHe7f3q5vcNoN4+7ietIXeGxIftpHQ+ZdOr55GtyxIb39pO2d9rxZttGYL+4PauxUDFgdhgmoneGrb4hWyjKfj76GtKNrgbeIeW4ZWy6Tr9Ejod8YxkEs9s8XWFYgUicMVlCsp+6inRByHPCKhO23rA7JOQ8rmeCrCQDEK+wTDfOC3/n8G3ztX1rOuPEAddYAPAbgHB7vM2AATFzvI2r+wpoSkpr+xW7tQpyOWgSwvUzgo/OGPtnXUxbLbijrFqTu74bd/hzvXdrrW3LCHrXudA8dF43u7r+e67wbYnbUoJ7tG7EYv3vu/63mNLtKuBfuh1PRMEb8Y1YQeszZJwWXgRORMOb/GKtPia7hKK9MwZH/leSDIlY1ynzgh7kPkjf/ScP/IrP92vIAs1T/SjX/pEf/O5/vlJzvMooAGubwEcAAEQAPtAnwJdAAk2n+wkf/Iov9S+H+1OXwoAIgZS/w5AtKMJTddnvvVpDvZeL8NwzvxhL/bUX+Ai+XDpfvYJFo5y/6nDTFzMUFnuQ0YKmWWIVel3d2/3ml2bRMOeWuv36xL/MTzQL6Gyt7A9SDzR+4biogMQbQS+GShmYBQjCRVGCdOQ4ECCbxw2JFRRFCOMjABt3LiHI8c+IPswgkRp08lUKV+tVNly1EuWKk+a3DOpZCJMemyg0NATBQSgQSF08Mkkjp9Nj1y9OuZqEkZJUKN6osoKWNNq37Qe06YVmCSJYiR9e6cVmzVqzYKtVSuM7apQjULNLQW31qpeqPTutTXLb6u+gO0OJlwY71/EifsGMxyYb+PHkA2Tolw5sjFq3TSfRdsZmrFfvUL7hYbO9GbOaNuO/vV5rWjHggWHfvuXrv87d3UNN7rTSJi8eerOFnumrd495MnrxWPOjl7zdOqiL6cOHLq5bZqxR98uHftiWnsrkeL9Bs+dP3/s6F1WCk/CN41A3Somzf40z66RIWtF/xYoAGuZarxCCoyqEkkI5OOOiSZC70EIw6KotwFFAmSPkDhCY0OQbpoJpaVg+tCUEEkckSYMSxrFDy5MKKEnDjiIQKigLNCAgxJm6CKQQExKyZSnJNFjwCCtWoarrbLR5phlbiHkiRzeKIUdfNi5Dxu32HLrmbs6kWuwu8LU7bDYwiSsLjRLoWVNvMwsUzbJ4pRzTsvqHI+v1rhBLS0+9YNtFmTCOW3P/Fhb7U/F/tL/cjTLcEtrTLi8TK+W7vArbjp/qlSuOueqm87T5srJrjvuKm0zzDsrMq8iutRE5Y2E/tCEluKuDCe/z/Tzb9cs13QLmF+BFaYUR8qDsCJWK7KjEWPRK7bCj0JCQ1pAOOwjRRBLFPFEbkcUZKRrR1EFjhl+6oBGoBJYIAEJ2IVAAxN05NFHV4B8asipqPLEqliQPMaZbf51EkopnTnHyvu4BA2zRy1bTVgx03SzFjZLUUsUYJQ8MiuOU7OUuIkjhjQyiUvey2TJRr7zsTw97tNPRQUlFFfGSIM5UUX/hI2uzNyhRuXySFkGN208pke5TP3htFPolrau1FGhJjrMYvpK/zW9VeG6qK5GwjAivv4s9UbsXGlWK9cm62tybfyWiebt4dxCuWSR69payI4+ymPvvGvysFuaAhf8Jr9TBNdHIEo499wHIEBg3ccTQGByd3MEYkOSQAxySD3wrSqWjcFxZvRjaKkjB9QLcYafg7+B+2HQBjtLY9rZhnu412dXMqt3evf9d62Cl86s3N+G2NeKkafY1V6Vn/v5NCWZmOGZb7ZZ1Or7BO/Q2HCmbee5Ls0mzUg1wdoWUYnHD9N+2k96U6edLlU7Ur071eo7j11FTVGIhRVsitnqVgMsDa7KVjzd0U6BC0xgA2snN6tg5EJ6s9a19rCtwd2kJN8qCUm+lf8RRmDrWxjK3Cv2IIIYBcVd6aKcAFwIFAvE63LXUlG9NqeHQnQOI/zCCumc4QlYpW51rXOG2+ImN8oIg3fACw7HhPdE4THxd1OUYhWB58QolkV4WMSiFoO3ta1BkH/9UxN9lNcyl3EPMYEiYBrbErOadc97tSHT1EZmrFBwAzhFE1t0kuY+93UKfoNkznboN7zhQSOJXfKSpMyzLDVhKRTvMU8k6TeoAbZRk9DoDPYqVb9CyoNo16nf7iolMGCwYmsaquAeVMGSl2hwgz2yIAnBNa+njFAQlNjlSV6ZCDTIwAKLU2ELjbmAd+UoBVxQQxx6VC97jaRzOfTcvkI3ukr/IAR1WfBEMtqhxdsZLzy2oA84qEgWK/qOLOjMYu+qMQwumrOdvqsSPtpxT3tW6Zv35Oc++/lPgPKTij2MZ5LEST09vUwtiBLN2DapPZ3FTo6FYY0cg4ENUf4MUrw5j28S2Ucq/RGQ7xMkIUN5yFI5hzEVa2SxzoMeVIgiG8BAxR8oIjRTYnKTmeRp1EDZNH0A9WlDJWpR35nKi3SEQ3lI0S9n8sFd3lKqU6WqIC5xVVkwQxZ7+AFPYFRMF4b1AJSTAFFmAIQeMHMOPTKJvQ40B2riaxKgw0osCpEDFdAABTlQgyvO8c26Gi9tV/nXN5IBz6b0S1jtwRiQhKVKMEYW/0hgBFJd+9VD0cnTnO8AKD/umQ9+grYdou1nPkg72oAG1LOr7Qc+8dlEThqwbN+LmUPdmBcyvQZnc2SUXfSImzuqCg+r6Mp3nnFc7Yh0pJpKTj1NakjjDJViSGypcJNYDfdQpBdnEZ5Oe/rdsflUqM9pTlDHW1T0WodjGQMjIMYwBqZSwqm8hGp9qXrfWuLklb8Mpk++KjkAi/WFyMTRWW2g1nnNRIKFUAPf9MUKV4zOrllQQYUrzE2DybNjgxXW3YS0IEBUAhB8cIQdRrysExfEIGL42opdbBAolMEOJnZwVCJI13+BQxw7Di1qUSva05rWtKMVMpHXAWQhJ1nJQv9m7QHNpts1okVjL2vYGoe12zkmxpKMJYxLh9sN75DNPtu4x3Ldd7CDKRd+UhtqNMhZtVZUN2hqalI2n3AHShVXauDls2nO+2d4BBrQoRRqkrIy2TwoQQnxVUUiZllLSI8EDn2YFqUnLWlLX5qDicCQFGpgIw149UaQE/AAyJrMeNngwFJY61MoYRNPBAKH1MyhjRWbBRR0IAO77gAN1NBNHm9Wwv8psUC0qdeFJFvZec2rESz87ApjANoVRvYSrF2FNshY23zYyA5JBOF6iW4Ymx23OHS8WXODgxjE2LGOg61Zd/fTnuLQpz+drNCF0bahtsV3b8GD5SwThmNkLB//eV7aDKKl0T4hbR8/2tc6hpN0zXqWrvI0cXFmqYoUGMPuk6T0NrNA17t99jN5gSpoQg/a5CkvVXM2rEr3yoGG9MWQLe876WnBQQ5rzbQZpMDqK6wBDfBVdAhCECN4uehFjguwWAtAAALbSNVT54IeXN3Be80Brp2TqyfuqoIMgJ3XKijDJIZBjMMOwylefxLqnk2DZtNA2cpmsUHmHm0M5F3ve7cwslFnhCUwxNrXhkKMtd1gGu/NxDRO/EYav7eMdNvWc6U8vyxvCmDduxkfow33YqvwOOZ2ohQdvW8dtVHK2PTLGZ2ZNBju8Id3Sh3NdS5z9xjd4OwxbP/xC8Zf/4pn9pJCu9yd38hJXnKWozz55R2v8p0vtYFjRIQYuvRUqX9pneNc69tfgxSYIAQDx6AFQmjB0SlQAaDkyAQ9IXWpAVzWDcRw6qtuNdYnMU011DrWQ1IDXneNAQcIQGmrAqvTiDwoA69xu7cTvBW7gxkrFggksWcxmRkzNoWwML7LO2jzO70qPx0ov8HrwMEbQRIcvCgIvBJ0MRJ0MW2bsW2bMXzjvP3oPEPpJJdxk5wpPYBbhZ/hwYQLrqD5LezYk/t4PdhzDuGhvYnDjU2ZBl8JDVCYi4vDGvlwG2L5GpyiOOyRmUHRqS58PjBcOfNSuTAEpUOzl0fTPkpbQ6nKvv+d2xA31DkzaAIikIESeBGjA4EUOr9zeZcJ6IkZaT+nkwBC5ICkyxFVQzCSeIQbiit80YM2eAKxA0AH0Lu88oEWgLtpe4IsyAJkKYQxCkUrBBYrlKnI8rBiswMW87tpa0Vk80BY5MBqsza5WwK5k0VkMwIQfEVZhBKCaQESPBthHMZFkah94xPcgTPR8zc42UGByyigMRbx4aOEWZ8/gj15kj3rWELpaEL6+AzB8D2YKoXxIYWOEoYtFLkvRL4wFEMybEeTS0dPGiX1OsMQ6jk1rLnr0z447Ec49L6uusOjGyb0I8QHOMgaAUQGaDoCeLrIQT/5Q8RENIM8kL5A2L//Aomrt2oDGgi7/9s7XfPIvgsDPJAP5GmbjXGbjskKBpqamUIqVCyWChQDazu2Z5M2FQCBW8RFntzJXqQ2nwzKvXK7DizKExzG2SLG44qj/UDG1OCPubAyZ9TBNnGH4FCYwYDAB9mfnCLChUsa2FOaqCGzbgSVT0mOdFiTt2EUcSxJkCEEsJGyS+JCdoRHuxzD58PLMKRLMCSarQASfGQDfRxMNojDN3zDn2sCRaPDOlS6PTTIg2ychGQAx1mAsbpMqCvEiJSB+SuDNeCcBZsmyOMcx7PFW2S2kAy7ZhMIUCRFI3Ig2HQZfkObx0KqNCmWBTkIKNGrVrQwEMjJt4s7/2rbwOFMCJ/UyQrTw7jjRWDcgRj0k87jErzgj2FMqDdSDIa6n6ncH3S8yisrH5kcx5ZEDUEJqbB0DoARL0RKKeUYn1pYS/wxn/QgBFB4m044Dx5sIL6sy7t0x5TTSwB1x/0EQz0zLEbwx8KEw+vbxw3pggZt0MQUAi4AvxloTBexkYIkxHUhsAhQSEF8vxnZTBTYiQNrMK7jOgbTGyGRoDIoPCiAsQ9sNhRsA1A0knByStm0Qescm6ZMSpBZSogZow+Dy4f4u2nrgN5Uzd7cwNPEwJDsu570UWKMTrWYTi3JBojqvUVyDNyiSsjIBtgqjIzrjVAgR3kkT2vMlCO0kv+xVE/cUw6FiQbqmsJzdDNWqQ8+GtC87E8+DVAB3Ut6TKmm2AN/7McF5UcIBbouiFADs9AZiBfHxFB0CcRAbAAAezpkkgAbEci92qtE5BtHzL88cMQM+Qhty4ITjALWDDH6eM3iSigG2lFZxVEpLUYxQh5PaAWvk4TcFAgL3E3j3MkldbYlVU1LhDadDEql9Dwtuc4eVSjb2NLtJBkwsUpHCT0I5CiTPNNRSRgyWy42bdP1xI7cuwf3hM9wxCNwJIRZIT7+7NO7hEc//VO75A7DcgVLCzpDzT4GbVCf+zkHZdQ6VDVIrQEReIGC7QmF9VBBhDp2cRcLMLpORR3UsYH/LDBRUOWbUc1YyXO8UxXVfbEKJhGgudypWX3OWlWY17hVX7EKARmPXc3IjASxXtVNCWkxhzBBbQrWvDo2hfhAvUJZW3XWK81S0mMoHPRScoStHiwfZJmU4oDVsZQZkDPP2BtXNmuzAAIZ/LEuN7u4iyKVd4VXshW0eaVXeJQOCcPHnLsWNBBMQtW5oNNXRZUCIGhUgk1YSN1UUOsJEbiACahUhlwhVJs/VcuBiYyrAqHIneNYQIi8bQPFkM2YVy3ZcoDV1HgoWt28J5tBKm2eM1oeXNUXIonJCUyQjbObt8IbEiMxGcvNmUTVhui3fPtcpizatGDLykBaOqkT3/LO/5FZFm0NBWNIOMslT6vtByR0U4qzjl8Rp/Boy4sSDIwS27KN1+W7Xv9MuS3C155bUH38x4AdOoAV2EcVgb2FEQyV1BD9w0C8VAUIQATQzKQz3MPNgYtFvL1RA/7VWBUVhRHrRD6YK1dw1TzVT8zNjFlN4AU+Wdrtldrllf4wI9Ed3fAguIrBYFWqzdB92UrQyopYVmedUthgC6O9uC1lStHr3aUFrmicz3ZVkjOl2gSKuOXYBq3Ys7PUhq3l2jiTT7e8Mhn+FLRVvnmt1wDV3uzdCgnbiH2lvvAV3/INusVs1PO90PUdpg61gEmVnIbEzMmhX4m0WFXLgp2Igv7dWP8+EDoT5Tb/lYQWrYOqUEmSnWE9uVwGbuA8li2hFeGFIQ4Z/NHFCpbFKiOM4eAtIeGKsTJF/tzcdWSsjFbtXKm8SNrdeEZRurIx0cr5RJ8GWkdvJQuJw1rtKEs3w1MfplN2hTPxIWK0xcsjHlslhtfbG52neOKaK0zBlOJEBUgrdtQXUd8tViFket/JucwANMiIlcgZYCZn1gIy7l827l8Tha9Rbd0wyILWBJ06RtPZ3GNwltUcpbI+VspqBOSPIedBRtkHTuQ/5lwS9uMShlYtbZV/4904sWchzI0uWxYYzk+5VMfWK7NA8pSceprwyB1UGd6FQansnWVAjejtxV7/6RAdp/hewoSDBB3fXvblX75iFMriSk2XhYTfhxVjg31mZ14D/hVg/s0/ln5pmT4xPkBAOU5Jbua3b8bjcO5pzOVpzSVnspHSZERnoR5qBy5nP27keJ7n60RhLCuj7vFdqm5hLO0yToZa5HJoeXwdG36aygVrv6DGOKLTTvCV9Wm5hya0WJboPT3btlY+djCnZAASXNblfeToXkarjzYw9B3IYSZmFjq1YQ6BggW/lWbpnZNpxm5s+Krp/MuC+Lgskl0fnfZpk8VsoNZsHfXmccZsdlZqeUZKoqXBeq5qHoSyS0Zt4rrKkgFhGE7k6tVhr8SHq02kg9a9PENXUMAj/7RWa1pmPrce7riu14qu66xTUCjW6I2G0CugYoCl0L4GaZHuYskRY/WjUMVkpoA1Ua1jMMde6cNraTnGCmngpG6+bM7eKZ+xY/cmueP17PcGZ3g+as1r6matb0WOSv6mai9l7daWBz3ZKNiWlW+0bIEma/wgaOS4Pd3RWnTMjlSGS/pUyyFe6yImblkubg6fa4u2iUzbg6hi7kIFWLq12x6Qbr++W79O3+pGF03NbrSK7i1I7MPkuvCu8Zd2wZYuhFsY2XNGavXWJJ5a7/mmSz2Nb/hOR/q27/tejXjWnij3NylkYaqGaoexVoIDT1nhKAOX7UAVubWcBuBoHwd31//bm64jYiQKp5pLgujh3nAON250Qu5bhoNd2qU44Ee5pVu6VTQWNzC+DvSz0ttg5mJEL2wZAvTEpPEukGb/zXGVfq9t+/EgH3Kj6TNNb29O7/QB3c9PT3DjK/Ip82knT9ml9txnrVJJRuFO8O/IuPL+zk8XxuoxRRa9OEZRn7LuZK4FajO8SA0k0otJCRM0h3MNR/Z4fL7gELdXozRnynN+nQJqh4Nqf+4/J3QKHXQV5wFvP1j0vVD1FcgREPTybXQbb1x1lwOZfuaX9kxKl7GbPvDPE7PN/mkkv/fN9nTjhYc7vtx1DPhdD3XjbfJTr3dUz295zs5ZB3AxLbhG2t3/UeofW3/aL7nSeSyluNEGTRGOGkYO3FgpYS/rigAPLVT2hAtuuJ5oZp8HurYhXRpxueXzRU1Ubd92bhf0Cm1xpbtDSH0BoJ/xc3d0xV73vVnsSW/R8Y7cnB7zTed0UM93T/93qh8lgCdQrB948tR3PTb4zk31zXvWEkYUWXf4hq+MV8/y06v4jCt5K+VcM4SuqileUTpgJck94EIFdIybncnWSApzlA/8OSevZn/5k4h5QXADWav2Psd2x0/xmwd680VYHgj68PN5RDwBvh76tJpQlRa67eucw2x3HdeCU7WCbavParQP+K761pd6wLd6lDvTrNf6qy94HVVgWtXj/88De2poqH5j+EiBeJUp+4hP+8oYpWjMuIxLe6f8qflRWbvnLrzvQV6XKIMzyZ6xVgzP8GRn+cFv+YNJu1jKcz3f88Yf34Cl4m7ffBS/+coP9J5fdEVrdKFHdy74OdCnlqMHCDlmuGwhWFBLFSYIkWhR47AOKGkSo0GLJjFct4zlNrrryI0jRnTwQpL0WPIkyI4qV45k2TIlTJMfNdIESdIatZnccvLc2dMnNqA/eSJrVjSYUaRKqRXN2Sspsl5Sp86quuoqqVBYHWXtitWr105hxXoVtbLU16uN1q61wxYrtVI5zaWTV++u3bzaKBqrOu0vYGzu5snzCBewsWC1tv/eaYSqVja98Sa/1GeZMr3Mmitz7txyMzzQl0eTFh269Oe751Yna/0qEWxBfmQLigOnC+7cUq7w7q3kxYzgwoEQ71Gc+HAgPI4Hr2Hi+XIlvn8z/91kIPY52vvo6Z5HIPYm4heSb0iwTqCJF2vGlIkS5Uv4KnV6jt+eLv77It/fxOlfKIBDBXgUVAQmxdRSR1FFVVoNjkVWV5po9WBZJjXoCFtr/fHWVQh+pA5heOVlVzfPCNOKX4kFJRhhhq0iTDbLmEiLVGr9sSEqLLp0Wn2m9fijaaPxOKSPRd5DGDhJwrLkJbE5yZ1uaPQ25W7AJWcclshZ+QJ1yC3XHHTLSbn/W5fWmSmFEmagAUceUGoHXnjlEQFFQgrVcWdE6sm3X3v8+TnTjpz9qV9M7A0aIKICDmigUowWqCCDDlI4aYQSQggWoKKg9RWGGXraYVxziYjXkYWViOIsSwW1UjabyujfYlVVoskdeDQCo2SYGUkkkLz6+iuwwWp2JGutyQJLk7ANEpttUY5JpZfVSSvEDGf+9iWYJowABJrWpkkmuAPJMQd35cJ5kJxL0JmFeRDpaWife5ZUX6D1CmofoYV6c6hOK/YbozuKAvXUo78k6CFUC0YKllqUWnopw1hFFvCmnHqq4VqkyBXqNNqMWmqI5kBjS1YGC/MMTqyCuiJSVpFC/wged5CyzMSDCQlskcLumrOvPBPJTrGuJYuIJU3Wpt1uzl5xWxfGBZcllldMay21VTvHg7bSSf1b0tOhOUZBa5r7pkHopsuQQ4WAgsm7fOarb0j4/miv3G+75za//+odsN5COWpywVEp7DLhDk846cOY6lTxKpZenKHGJz8jl8d5lXp5OtYYbMtUxszl0YkvsnxyrLS+8ccqHwa6s886s47a60S+E/RrThrtBhxM55b7s7xJcWXUPWx9nLfTtsBlmdx2jdsa4kox7tjNl132nOoy1K4akqiHt9v2ylt33OB7f/fbeW+0t0wBs9p354An2Khig0tqMcSXJk4p5QAz/v/4xZEHtXE3LPexeJyqKp1LWYwOExRgkM5GtqLGSnKlK9dNkIKwu2DrfkascxAjGbWrDW/YIBvc8a4LvNPddIYjvKgV71vGUYJ4wMUb5AyPeGhawxWkl53taMch1DsbQ4hwHk+0jXvlE19lwpfEYJHviEbMV7/qJRjV9edv7jPZixZmwMKRZVP1+6JY7ueVn1yIf27pYoxOhCsBYm4jv9ii5ADGDYmlkUaKsdEbUvcNCVaQgj2LHSADWY/VsMZot+HSmvYgwhMyEoVOKw6agvdCF3arkspb2pp6Z0lKPg8NOFQTI7sQJyAG8TzuKuITkXgv7q1SleuLohO7BzdYjo//Pge04h0F5yCSSSqMXImYL4M5qZ/sj3+OOGNWNAUMUdwCKSwK0eVaZBQ49iuZc+EYVm7kGJvRjW4YFOQ3A6lBYonDFEfLHXS4BYfaQIl3tnEk8GwILU5eMpMn3FoNw9U1e2ZSejBUSBCrhwQbHAGgdipELFBpN1fuh14OnU8TF5pK8PkLULUkicICx7n4JSxWj5HUL0ORMYf1UoExigtjPHXGTmlFUydVUeVIhbmRXYVgi1vZS714o5lxszB99KYf/xjOzYwqg5M5Ej7OYc4TyqAEWTNhINr5zilQNYXCSYG0pvQsrlWSefzkDdi8pc9O9vNrBwmoQIPIroacUqGy/8xPr+L6Sj+9MqK1TOWqIKq+HVlUJhm1YhZrWtKGBRNDhivjV/rlxQyttBNtWWn+TATTo0aTMNy4o+iuiRVgnHRjH9VmKarRU6AGFZyvKyogibWJdnbhOU4V3jpPSMKqzvCRIiCoCLB6HBPSNnnf8ipwPVnJJFALoF3FoXBHWdCB+gC3zUUrF9CTULdipi7dLG0rkdjX6741c9rd7iwxspO/QsoW09TiYAsb0pBGKL1D2ZQxOwUzrnCFZi8tRsfqUlkSnTezKO0QNiQXusbtFIKjJS12TTtUo5IqqZsQBA+F4FSCPi+qtJlqbaFWAghogKBQ622GL7m8KElnTGYqbv8MXQg2fxp0TgTVwXNdTOHo6uERvnAGjrexF4kGlbur/J4Sfdzd9e31ojchb/t4WaNkpre9HJrU/hhGTLVcbKVsgWwp3CHav8RRvzK17IKM8l/PNnBTOz2wkIW6YKKuGbWpnZ04XiPVGZRAA06FKrMcKbwq9QAFCIBACZQHHNj6LnnIG6sMc7hJFHP1W2FF64ubG+M5GVcNevBEQnO84yGnucex7LR1H3o+mAjGrjbBaJgTszklC7bJ9NOKGA9blmo69srxHWmWLYsYi7CxVAjqEME2e9lStCylBvYpskPT6WGVxs3N/mY0GczmpMb5wbmLKhzobGcuBIJJsIlDbrL/hJse2AACCEhAhyN5W3BBUsSI/m3XDC0E68w7xfRmbqSbCmMZOFeI3J5ELG6s6XwlWK5BBrJcq8tpU9eVP3AsL6td/aBPxZqkJp1jSm9NiF+GVte7nli0x+yUAcul5IyL2cz4+FMLtrnl0R6VBqd9JHF4cDZR9cMmNgFuIsygD5dgxgdRmBsv9PkB5wa003IbyXlHMpIrbPqezxTvpWtJOfa2mowlrW9+/4DCQpxDHAIBcFccY3ucNqrBqYhwUOM1vA0ntX2QHHGJ+/Jxh4ty/dLyXiprnBDIpByI7uu504wqwDVtVMYEjBadaiWCbI+5s9m84Gi+/M0bRJaFIXEJ/28H4ue7OFaT7umFqqbAAkb/swVyG0+oL1o8UGvh1JyG9axvfcJdn7EaAhH2R5AdxwNv6MoLnnaDP97IRXZ7OB6u6o/KWqT0ZSnF785e/H30ZAtEi8b7t3ib7VjA0NAxZeUxXqyUHLQMJPnLUEcN0apc4aH+I1ItU3nJY9Af9rf//C2Pj3YAPRWU0DzObR4xMIMsEMM1fB7ojdA6HQ0XiEAHnJ7RpZ7qVU27MR3UbMnTUMvrsV60zN7taV3tbR3PiQdURVXOHUPvgZ8sCV/wEVnxidp30ZJEnc9i1KBHzUqE4ODEwRr08c/dZYVhMZkO6p1RXN+tdYp8OcZVmAWImP+KqpmMSGDG/wAbWqDc4l0hKjSCrXTcCz7baOSf/NGfPtwfGYKhGD5bUnGQLyBLzrXhkgwgMxwgAcpCstBGbcQBuUEAB2gAB0CABPzhhEGS08XeIFYLBVbg1HggCIZgDHAdCWbeCbpCpqkg8KEdC3IE8WXiE9XM8TEcStjRDRaWDgbhw7zFxWwI5EifxnAcMD1GEe4E9mWfY7kF6izhaEGDqjVTfoXasMVPFW6hppwcHmgMJ7LdUJnhGfrDGN6fFx5VBXkhOQEdk+RcAMIhM8wh6N3OHZJb6vUAuJmABXBYoE0dc1ygoA3HIdqQOYLJ1eQbI3JdtaxBbMUB72FCzsX/wiRW4iW2oCYW3KeB10KBIo0g4awQpCYYZA8eIQ8yzPRFTJdloULWmhY2BlqYRUxlDl8Ajo50ljOVwkRqAhY6EODBFUmSVrMh4zGWITTq32pg42u44TVegxwSw7FkgiFdWwPagBTEgT2CUNfoziYlYjqm45kMJe25o+3ZHs9BVRzMRs5hwiNAQj7qo7T5YxfCYPkA5BGxwi2wgifQgicUwsYVJEKSZRLa2nxtHMU9X0OiAjA5UwI5n0Im4RVepI79hftIA59I1sl4ZMwQQkjCzAPl1dkFH7NF3jM6Wxkyo66ww2GeIbOloThc4zRuwhsyQzvI5DXOYdA1S9fIBh3W/+E9sdsjEYGGlSYGxp4iYssHQgeMKeVO2gY9RqU9QuUjSAQl7iM/6uZuZpcnOtE5JIM0eKUkiCUfHKdYliVCMlZapmIr/lJbAtsUyiUSHqcZbSFaiIpe4KUdNYVf9aVgOgYW2gHKfU5hGublmKGXQeYyquR6hp9jsmeDtaRLXmYcymRmIuAHvQlvhZ0geFtsjOYg2pZuoSY6xlNqfkk7OleYuNaEKZ0JRaUfNKUfGAJU+sFUsuDNxJyG+szBMdQ/vsQ67MM6jENwhiVypujjLGdzquWK5uBitSJcLsZcqpR4Zqdd7kVfoEpR5EcdidQd2IEdaAwQNgJ5ok42bNp5Bv/e+8UnSrZf+Clje5ZKkCCmGErmZNLkGvpCTIpDZl5DO/DfANLhI8hWILBThRZNgI5miBmHDVTdtIAJBmLNnCooO9qAg+KWa/YAF5iQbeDObPpBVEICbiZmVRrqgvEmiLqgFP3YMZxDPqyDpOZDO3gQKwACILhFY1Unp7boWr7MelHfykBkjUrkjYpOjj4hFKqDSZyIYAYpKZLnG9wKYWJiSTYp+D3mSiKqiEjpMrZRqDmpriomOWWpscQkfo6DTM4kHereCQkCNcKGaC5SCQ3ooBVonAIHdExgOtXp7DXog3oYbO0ehVLooHJWbiqYmiXqulpi231a3XiC2AFcMoz/w6SCKTiYgihkKiAUp3V2aq14qmFN38A6mZS9It91KlueJUgG4y1EQxPexTbQ1BaZp+EFLKxW5+lUAn7VKo9FbORBabK957DCp5UOa7FS5gDKZD4sa4nm5y4QYCI4q3Y0ZSpsXh2eExsIKIEmnYHOqeo9x5bYqQcOB4O2o3F0gRf4p1PSo6BG5cOmq7q2HIe2q7ueZ6eFhHd0h9jFgirIpKS+7DAsk79iSNnK178qp/OB6su0bd5l52LJYqfQIkjO0WLgV6hJAy6u2i/soo52AsY2BtqGgcxU1K3eqnye7Gghm+I2qeIOEJZSZmbmA6WW6MvmJzHIGe+cKSYcSzbq/yzP/ixqrqO2Nqi3HqhwdB3q8ulOLu1szIYhlOtsJpTUVm3isqvVXm0UYi2hLFFLbC0gcAemBu8oeKk4XAOlVqq+nq1bqCiGOK8kAKHbVkp0BhYQuugRMlbjuQrNRGw4NNMb+QVNREMthCfGauobEG4wGC7v6qOwrpzI8urtmizkRuNmTm7Yvqwc7oLmbu4gwIKWwoLNNZImwekEpiYCb+sImC7Roq4DY1XSUOjrGsKExu6g2hg75Or8uhzuUi1W6uML7gfwDu/w9gEjBO8xDGA7JC/NHYOmNC95Qq/azrClMF/Cyq2G4Ig7uArequDe8uj4ZmGttIFgwnAYqC/77v+J41HloU6tm4Es/X4ZfcZk2FKqZqrsJUjVOgFwAp5TcEHLtcIplpBAGJduDWyL0KIxBTbwAz8NbLluhVpo7LqBzT0t2WmwE3uw7YbT7voICF/l7pKwIA8ypjKCKKTwClNumA6DvmZqihYCJDsCIDjC2bLtwCYkMGFv9n5KXNig36IDd6JIx1oEMGCI37UBKgfuE8wqLSTxu7IHE78fSY6saeCx/G5wgxnvfVJuif6fLz+YIJiwOz2CAPafFxdwo/Ws0onu0J5xt7bxGq9uBFOoHMsxFczG7m3CLbBNHutxN+vuB8eyCA/yHIzBd5DzOTPCKAyDl17Dy4KDM0hicU7/siQX56zQM3Sq7Q+mHw6fJWDKyEC2wvpqwzY4pt7eglXA1DJ45J2kcpCe8hOsMiqg677AC/JRotTS8m5+c8jaLxVLKiwc10+C3X8WYMzeJHIVGvKUowGTboIu8DM38+oCj9IubVNWcyRYwoRi8+7xnl5OkAd7s1ArKq72JjyMyzkntVKbsznbwRgIqR0M7yF7KeUmb75eatniMw1LZFr0Mw+eEWCaRUAL9E9n8EEb0MNShCmnskMTQhgYwRPcyihb9Pi6ck28BOIWtV7fcsmyGeNGEzjE4WSCKUivAUBFmkLgWSaYNOZBWKIZ2jouMzNjC0y/9OlWS7TsGVUtLRjE/3EkWKgvxG6F+ifUQgMunzZHGzU497E4hwbY5IE5j8tryzZSw3Zt82tUF7IpsHOkvrMLzzOmSrJyImTG9fOnbAyNcizEFvRdqip+0YL5vgFbpy9cu6JFeKx4VdR/yKAsA3JG9/XJjgicGeCXuvM6MIMgiAdBbdgeyoDwdF4Bgp7N6cY5yttx2JZLb0vpynQHSrO4bXYc0DFORwJ63zTTRiXNpPYeo3YTAxJrGxVTC4RtJ3Vsi0sZwDYfwHZsf0duEy8xtMO9XgM4aIoh72skm+XCRi/D1uiJs0UrLzQOQgZBW9cUivLkNHRDZ0FDv7URyAwDyRGQC4jAaKV38+pfx//vAAX2YIOtso6DKkwBnqIABfyZTi5gTTaJKMUbz0HH7xzo6JJxfvPACZwA1og5mfPAEZRxamaNuwF4U4LBgCuDaE/ooJqgNDgm5gQ1g+95Nz94a28GnEx4oD/1hKuJbV/4Oc92Uk91b0tqtREnCcswWdIti26yjNOCDr74jJdIMfBSM4ll+taBDdSBdNdBFkR0GDjGjwf5UDSDT7yiogCMXhW5oQqQRie5fiVJO8fssn5eepfbA0AAEFCoAF7CO6U0uER5oLGjG+P3tY65fgPHtpD5C5y5mbOxnDb7lAC4F/jBFwx4aBu4hFqYKxASleo5up927jZxH4thhBf6u6//WIaXAb0jOtjUu1InuiGPggHmbz4Epyt4QnGqwcbJMMak7VkmpzEB5kGTpf8w6eSAAiggNKlnQagTlI5HQQ4QbiVwpYy8CsK8j4EkSjGOTz8C9a2n/IjkupJb40xewhWUwAOaALRKqyzsQiIQRBzYNJQ4drbj6W0dMGZzCdFLu2WbuZXQqdIjsIjRFhwP+GfbI09igtPqXtc6w2qEN5+nJHjnbhSyeyxnxqDPtvQc+kDUO9rfO1Ov/WzHtiGzM4iTKOV2kFcGd4o2r3EfpMJniEWUL0HWwjOoIPlO/C0UQqij8qnrQMZHgRjwAbGdn4BB3C3B+lB0YqMao8ojuWQ4/2Zgb6bnXmPMWoIbiIAFlAAcqOklWEJ8X5s7sf5sTIFy6KnQmmOYG72Ylzllr3kYdw1V5Q4dezbUizbV13EceALvgUOeb73yd72hfj3Y+zlRqT14mL2FV7/037tTS3/2o/MepEK99rbcw3MsSIK/QrXB++BBnqJye6RBtvIe1cPgU/zFJ35EW7yOU3JIys9UIEysA0Q2d+UIFjR4ECG8gfEWpkP30GFEd/IoMrR4sSJGjRG3sfMojhnIkMSY7TIpaxAaIFcSWbJ0qaUslILiSJkxg4sUm1KmCPIJR4iIm0Jv9uhRtCiJF0CWNnX6gkfQqCegRhVy9elTnlO4wvHqxv+Pny+GyJY9FAmtoTh+HsV55CdQHLeTWDnzWA+vvrx79dLz+xdwX8GDCRc2TFgd4IeBGTd2rHjx479jxsihbJly5jKa1ZjpvJlz6DF2LmOWkwd16jyMKB0jNm7dvn3r1okD54qWJD5q+BTq/dtRo97CG2kiTtw48TqVlkUrFfx4p1rNEzv35KnQmyzbw2TJ8T2Hje3DS5UndX5VKPW92LdHRg1+/PgDuXGjn/B+fvyRN0rM2P+/je666xyQxLkGQZJM2kUmmKZgoyVEYHLwii66GIoLqVba6gqmbkrBKaNmEDErqEaoYaoWeKBqxamWWvFFE4hayqgebuiKKzd0LIv/R7TOwsSQsDBZqy25HrnuGHDm4YtJyQ57EsoonZySyir9Eq00z7TcEssuObMstcpU62OSTYY5MDbZ8rENN0b0AMS3OIHTJBTh4jTOt+LwYG4ZUTohBFDiptNGHWlyu66ON7rbzgbwvuvOjt4kkaSTStW71L33NK2PU/jyE6ih/SAaVVRzTD21OgEBXPWjAhEc5xoGZSJGlVoHEeRBPy5BBBFb4TDKQpuC3WqnYGs8FqkRZ6zKBBhbWOoEq6KlqiqnZhQKWBxzdKNHstLoli0/vFgrDk/m8iQWu5Zs8jF/pHw3yruk5M9Kxtyl8rLM1vAStND63Yw0fQOuTDPVDCaT/5JUmIFNNjXZZAVR4OS8MzpC3iikGGCeuyPQ4mhZ5htDK8ktuzDCaFQHFFR2dLs2IrUU00zf65RmTj8tFWeFcm5oVZ5V/YiffNZRZh1YaZWJ10QSceOrPSKUkCY4dJRrrbiornAKnXQi0SkQMeRBxhZryApGsYVgsUQab9x2R3B7BLKstcQdty10k7yHXXj13jtvwehl7G+N/rq3Si4N/+zfxDezgvHGQxv4yzUMPhgSU3xBs+F91oQllkk8ebMOiScO9OLmUGmEY+j4bK4SSWgpWTxHaaABhNmXiEIMMXpDhff0Vsl0vprts9m+m0/VWdRwkD+e+eZ97tm/itjx5/+coGGjDRdZVZlQECrY4KqHK9gY/1aa9vAKx/OdHh/9Dpl6f4Sjvh4q7JuaZXYqsMv+UKgR4j9WWzoCwyAIWJZvpQWBaSmSuKgWCLrc4ht4kxdf/HGvCfatMBKMkgXnFbh68a0vXNrC4RRHGcedcHEl7FKYTtPCObwQYakAB8MyV7R+HAM7oZtYngBVOo11rHfAEGItiAgKQngHZd9RGQhUYDvcXax15ilFMIIhH0+Fg3jGK97OuEgq502kP8+LngT7YT3aXGNoCZLJrbDwICzQCGvfg0MbdfKhHmBhfHhEHxwqxLUTzc8G9QubjPznIhfVj37YyhaOqOA9AlrigD7/SiACMeGHLpCLakey2wU1yEF6bKOCneSkXjQIQsGM8oOpDIwn9ZE4EvIrhShkHCwPty8XtrAPCEvYwmbTMNqc4xhHklPoQocHH5KCY5OS4qFoUYvseOd24FEBCDowzfDkzmVRnKIwrHhFLG4xVDerTzi7uLwvnlOMY1wSPgpUwXbA6oxnZMYapwaGN0rhBFvrY1dukCFCvk8JFZLj1uDHP4PaD0VWGdv+qtU/odRvkV95UNtcAiSLSnKSC8ykAzfJyen5JZQhDSneRipKDJaSlCjF4F88qMoovZKWsZSlLGOapVvCEIYOxIQviJa5fSjjHI/YDTF7GAZNsC442nxO/yUccR0jKuqaKcvBNK15zTYQAmPCGGI3hYdF432VnAnxajmjl06NrPMe5xhHGWF1PdrIk0G8kqsbbnAsAGqrjzvhCRq44j5qZUUp9Fto2P74gmi1qJBecygcc9RIxwqQV2g5YCQnKa5LMvBcRwLZgNB6D5F+FrT4MGneWHnK0a7UpSkVTGn1MkKYwnSmsf0XFGJqy8m9SQ+5zK1OdxEbe9hjNr5QQxaIGbowZNVPTTWPIyKlXD7kbglLUBEMaKeCDKigiToYDx+22RxvbnGs4BWvFkEVVvOeF51m/eSAClQgZcCTNrrIhXzlm4tFKOIsZzjDIc5ChRshC0SLbGNfCf8sPgCnLZEPtd+yZEQtQorgAg5dQfjGVWEdPfaRk9QwWbxwyQbChaOxAOWAShraMp4Yxf0Q7Wn3wlomqdTF643xBlXLGC6osKYj3IJseYxjLt0Up7jVQ5l8kY/M+cI3xb0Dn0oRKVFsrDvAgW50WzA7amYAy9l1GXc/hg2uliN44b0ieslqTjKnV50fYSdb4UlfXdA3F/ZVhCLIUGdF3HcQ9gxCXY+iWBKQAGsFDrT7/GgthAqSsF3z34ki7FClrO2xkeYWr34UiclW9gtxYIEXMGskTzziGCNecYk/m+KgpXjUKm0xi1FLRnrMuEmeTeU9fIzjHt8aCrRVnI7/tSX/yQH5hS/cxDj2Adyffs43b1jOLZ6cVDuY7AmpawO0o1BtJloXA9nGbg5axuVmNrMZvhP37zbV1SyWGXpoNmtiKELS6vGjH+PIh1vfXG8435e/h1iEfQ9xhkE0Enx+FsqgC1yjvy4aWvJLMGEdDa1F96/RILrBpi38WLA8stIbLssj5sAFTBYpxJcjsQVNDO9Tm9zkKk51q1muj3t5MpQgbTmUSilCXncJ1zPVdeN2LtOb1/LXQRd6IHyRuXFsgjcuQ9frgnOHJxhB2YR4du6iMDsaYBfb2b5uEyHFMfR8fdxfdw+5q8jNMHsZ7dZI+34ClO7yFipVHElMBNndXuvB/ybO63AzL+Z7ilMsAvBzBjy/7elYFtxgBR74s1EgPeArIB7xBqfWwxm8WBEcvM/+e/AEhPKBFKzgRhX23ugdOYiKbviiZOl0Azn6iHSdg9T1KPnJ85HyE8Oe1aZ8ce5P6mqZP4bXwVcCLHPOhB1XAfknTD5N+aUl1Agdl5tQRsPG4YkyKD0WUH561Ke9fSNcHetax8C2t+91sKenPZjynXus2Iwvq739wBOeQOhvs20QCu6oqv8XQ0Z3NbP5rfTO3nSBE3RhETjBvu5r33KBzs7AsRyrrw6PkRwPfCaMKk7A8x4uAx2KAy8P9GzEKAIL4vrn8xoPjy6MCsBggFyCBf8nKfXewsI67RFm0PV8IfbcxV08IqRoT95oz/Ziri9Qqfd2T9WEcJUCwwjp4edyzOeOj+eecPlyztYMZzc+A5eYoWHAIU6ug7m2T1E4htqe7vvAb3aeIAxSJzi6y+yegQ3bMP7KjaviMP7SIzlihj3cED7WMBr2cO32T/8Eov/6r1WAKd4CUAAJ8BMSsd4OEPAWcBH6zb9UUBIbieIGzBL3zEYi7wI38AM40eH8Rym4IvL4zPNEIAMVL/REzwskTVdaUOPIopK+oEgqDMSMZAalwS5UbnpGirMqCMWsh61q7wd1MQnbjbRYLOZyEAhFKQcHR+ZgzuVobQmnsQljy/j/rhEbo1Abs1H4ak00gi4V8sEe1uEYCmFSSsYM38CY1vEL1xGrksp1PkaIvMsPg0cOicfc1g7+5CMY6NAdUwdQLuXrLIV3isggu6seq0EhQ2YelMQh3ws23kwAE5ETKDIXKtLv/u4UGFAR7AkHcEAF+esLCm/AIA/0TnLiLnATO7ETA+vPTpLCAO7wFI8mQeQUD28VJc3iyOIsXHHDZLEIVJHTMMmBXK+dpmcXdTDmkNIXT+zUhNEHUWzFOKsYjZGkTgsHd3EZS+kuoLHGYk5LvLEanRAKubEsz5Isu1Esf2wS2qE2IEY3oA0NmSqKbIGIMsa76BHt9k8f0y4fz+3s/wJzH5vhF+oEdf4RMY2pY1QHZtBjq+aROhYyZJKhQIKGNmTD3ihSMzFSIytSERwQBybOCeYMEkMT8k7gz1RSJRWvJVsSNV/SBClxJmmSNmmyEnMSBVGwFV0x4ygp0zJtgd4iLNiCBndK5UKrFz1C5aISKodxGevOI9KBCN2N1EysxDhrcDyL5K5S5tSSGscSLcPTLLcxLbXgO5uPEZKhHcDhOnSjEgoSMvkQG7SB/uTTPvsSP/9SzPIzIesP/qjoPOgkOQ6THdvxH4FI/YJIY+bxGOxCrYQGMzNzMzFy3wCvIhfhDIYgNF3ABcgAv/TLCfwLJVEyNVcyAljyA15TNP8j7fBArzY9wBQ7cQWEkvRyc9LybZIUAYFkkQbjINP8YICG0xBo0BM2wSPGAfeQ09Wo592Y0/baQSqpUkqtkjpNjCmtdCqFcCuvMiem0AnBczzFU0zN0zu9MSw3AxAalBXWNBbSJRsalC/psxvmlD/zUzD10yAA8+0QQnjyMP3So6i+0GQElVAH1R0Zs0GLTGhigxzI4bd4gRcmlDP/rhFz4RDIgENBrwjI4FJB9CODIFP3bM8sEDU/gPNaEzU3LQWdAAy+INNm80Vb0gNuEzfBoJ5Gz/Rcoid7My3GAigfoQiARFd4hDjRRUmOE0tH7hejEtWQNUu1tEqbtUC0sin/UW1KdRBbn1Erbc4zzhNMw5Q8yVRcx5Vcy5X5/EVSTIFN4TRkEtKr9pFO8fRO93P++JS8/PM++lKr/pQOCZQd5VIur+oOIqVB3y1NeOG3yAFSJXVSE7FCyYBVg2BWz6DOyCBDTZMFPpJVnUBDNdQFQHVUQ/YjV1USv8C/ZjLxXhT0XAA3dfJWMc4SGIQOgIRXDUEW2SL1iHUT3uIRdlEZcBC0mLIrO2JZae84nfNap7NapRVom9VZOWk7o5GkqhFLxhRcr9Zqy5Nqz7QJdqwOyoAPHogVIjNO7bVO51Ve8bEgzq1s8zQb9FRO/dL9kIFfBbIOCXJS7GJhLrPY7EFh/xeWYSd18D7TCT52BVzACSiWY11gZTn0U4cAciNXcjs2cjc2cV3VcQ+PBVR2zyrOZesJZk8vEmo2SIL1EcoCFuAGFoizBsdBO6n1BpVxaaPyKPHBaaFVO5PUaZn0HGB3d7MyaUXKS781a7HWeLsWecvVhMrUZQBhUtiUIePVbOk1bb0hH/P1bOezvKb3evtTX6cBGsIXfHGRfH2Bp4jmMnXhUSN1My30QivSvih1zkCUYy1Xcj/WYyEXcSeXf4ugfi83Q+vXcVHxcB33c1/We8aiR1zRF2b2FdNCFtJiE4gzXWywgmDPWnmxI3qxaJ/2d/dCgzrLWZ0T97rSKdfqdv9NWIVDqUyJ93hfGIbNcvhmWGtTSFKedyFzJrweQm2rF0/f9l6BWHuHuHrb1nvJt1WUQYl1YR/erIkB90IbsWE3Us4+lH4rN4AzVL8CWH/vN3L3l2OvGIs9VnMrd1XryUbRuFswSuMUGBYri3VBbYSdFXgraIOVVVrfwXY/GGp1d1mbM0oxON5O2FqTEltfziNauExjmJEbOXlp+Eu3Q1zLIA8KARDGVhriViJ2WHk4uYfrVHqzl4jhdpRL+ZOJ2G2nIZPjNZPNV+SUWO+eWEI5gREXgQ4s9ACjeM6s2H4jV78qtmK3+HL7l5j9939DFYz/NywGiBXVeIF9Eo7fOBP/ppmag2QSAoEtbqHIaleQ6diQk5Np2amEZa1ag5daT2zeAFkXZ9d6oJIYD1lbFXmRtdaR69kJIVmer09SuEmTuZd6fbiIhXgvsTeVf9ifC3qVO+IclFgZ+m4AKdKWb9mWpVhwd1mYe3kIKLbO0iANgtligRliPxqYuZikNVTxDs9yQTTPJlGA0HiA1hj1EGhYMQGaI6EWHciCb68p/bhpQxgvRm3N3jn/Vrmcn/V19/iE0xmFf7doa++d61iD6Ln47JmqwxSfy9Nl9Hmf8c+LeLiTPRmsARpeSfmgwSygQzms5/QbHjLOlGEAEfETAI8O5pquKdrvdvkzxRiLf7nO/7S4pDcapPuamDOVQxOXZN1YBcHCDVTw32z14t7YFx74ooYVFn1ygq2G6Jg6doMXqFesXRNaK49ThQ+Zzdo5nVHtZzEYGNVZtLtS9txFque5eKs6hq86TLU6q+7veNIarBH6rA26rNHaeof7t+8PHPyhod16liE6ojuaDOqaExTBM0lTr/+3fuvsmPtXmKs7gDl0Vgvbclt1EDjVEAbIVl86aSDrmTXsEBxY9dabmmEiLiTnGFZbpzsbqo36/571s0F7j+FNv5Xyj9P5tH93qdlKs/GCHfK5PGnbwdPSts31+jbjHW8hGnSbrIKbt025lIO4oIlbuMc6lMd3iHHRvf+U2KFruRHleq43daMVIQ3wen4vGqONGXK5mH/pF2L/1397nHFBFoyDQAW32N9sWhJXkFdsVUhVN4EiG9PgO75/wgzmABKq58Cp5wa/eUrxOzp1O6FzkWmjNd4InMw128xJLcJd2FwfnM1vW2DNERgw/MO7WsOLe205HJXnPMT3HMRLfK0vZ4nfjJYnWq6b27npms7wCxE6FURLmse1OMeze3J3/H4314CtW79EMskFaFgRwbEFyI19kg5qGsrTAi7goEtBrUnpuDo/K2nXBda7/BYsHMw9WI+bet40R2iMzJ3PPMFjG9hnu82pOpayeqs3ubfPTM/7nM9Tuc6bfdn/1RYXzZehG7reblmiDZ2uObqjRz3fOBVEVRDTw3iwxzjS+TdVKZfIt5i/5MoB1ZuNdMQPpibU04J0Yfr05n2+fYAJiA5KATyon9antVx6oHPgPUI+pSG0zfwpdZ3ATy7BFx7NhX3YKz7Yly+rsQ9k5BTdnh3aydrjP37P6dOVSwIWFCHODJDFt53lt73O+Mti+23Ix/1/dxxibRyjH90Jbl4l93qL5QpHEeEMlPyRPv28H1uaJTvpLSGyw4JqgEAGbEAPHNQhP8LqqfL+Elrhsd7gj7rLMxkvI4iOkRrXydypf/FnfVGQ8djVLd7t3T7juWtsQ8bMvrqcRB7s8Z7Z//de77OXUIAJ0JUBv2B8xVu+5Tn6udPgUsFdjHN+ch2d5o8ZA1Fzrz0039q93ZOcsQlIXDBM3pNeR9k4pnlkaoBCZdQA1NhVXTxCSeiuXTNm1mMfiQ3+1nO3KRvSUGK/GP6e7Ht/wOetaAoc4Gc3B+/4tT+L4t9e+bGWwp03zuU82e++7+Fv+je8+rXBGVwZ0KtZ8AyfrhOf2xXfoxs/5y028h0/uz8WB/b6M8/i8oO+gOLGvzhdLpbeydHi/tGCshNILQAiDhs2U2yAQMHFk6tYDGk1ZLgsIrCJtyre8mTR4jd1HN/N84gvpMiR7D5KO5kxGsd+LFu6dMmvX76ZNP9rxrz50mXJbSe3lfQ30h+ToVqIGj2KdIvSpUWbJH0KNWmWqFSrWqmCtYxWPoBoZduorZxYdGTHlk3nDq3ZtGfXmu0WLi5cuXStebN7F9vYvNzm+v0LOHDfwXrxFv5aLTG4ZMmIgWNGzJLkQ4cU0bls+XKaNGQ2c/bM+csZJ6NLOzmN47TqM6xVk3YNO7bq1ENqryajKDciRJQp78I1mXKkS4OK+zmO3I1AQ8yHO3+eyRcm5se/NEfuR6AXOHCEyPiupZAnT5VAjR/fynyt9bTao3ffvmLPj0Hrh6S/U1rFX/LvAWXp338w8WOTTTgJiOB9PIV1Uj0BhmQVUxE6ReH/hEhIldWFGkKxoYVNYWhHGVxJAkxiDMJDlzluscViiyumWBaMfBn2lmAy2ngYYTkeZo5izjDWGGS7BNdbGkV6RgYZRXT2WRpfFFEEa6NRYZtsr7Um22iyBWEbl1WekSRriuwm3C6KDDnZZJkwtwl2xynnR3POSQedc9jFgZwXenaxHRo2lAAoCktMFcYbhh76xx2KEuJIeeW9B19Fx3wj0jmWtoMPpvbd46A2xXya3i3SsJNTgjfdRNOpB57zEqv5nTRNNA2K5GGFttaKa4e6ZvghrlppBQgjJXKk4osuonhsWzXiuJexzjIL7Y4qdrSYpb4wJotkzQlnyBdJfiua/5JQRhkalLVh6QRtrkmppZXuelmlbewqcsaYvf2GZpprPkdddm7EKedwvkg23XPHPaKdngl3wbAUIXDAAQodqIBCDhYb8cTFGWMcRRt3NApppPEtoxhIJj9IkjoopQeKLc+M6h+rpapK84GmClgPWLJ+6pODvkp4a9C5VnUEh7v+XEYbWwWrEljFPr2iWskqS/WNz16t7Iwp6hiYj9Vei+2+xXVrXbhhRvnkuEVslnZtqb3dJWrstuuuu/GSJiZvZA6JS99+S6btvgUbkhzAdSrzHJ1vKsy4F12kkIIUJkDcQQcVa6wCxZlvTkPGbzAqHnsiPzqRYpSevCk724BKev+sO/Ujc0s0y3RgTAmmvuCnsXbDztBXCd2r70cPNdXwwXv4qx18kGjiiVVDjbWNz0dPPY7U8HhiNWl98zVjCxH35r9gjE/+am2rDaW4d989N7qzneHlaXRbCaaYZyCiyCFm+n1m4JHA8j8AFix8xwlYJPxnMH/piQUKexzkbKABDjwgA5bTAh7qgEFFadBjeDAUoz74wUaVR4SVICEpSlG65p0OP5wySUTa46j2zIpUAtLUgFgSu1KRpIU8iZUPtSE8oAVxiEj7XfKWFwunQQ9Z06teE524rGhlQ1rZM9GPFjOM77VJEIEQxECoAMYw4mCMthmXC1wwLjKMxlzrS9f//RAxt/GtJgjzqxvecFOv3JwJF3vEl2QQhzgB2omAhqvTvhSHsMYxDHIT6EAEIfCACepgDudpGXpYJolHlbARjOKgJwmhQVAuinQpNNFHTnnKb6xMEzF8xEl84RMABaV2ObEUzlDWqR7qjoi8nFDxjFfEI0piUsRaIvWeCMVkUnGZU0TMRuZRsmFIcyGQqCYX+8AdOIBxCty8AQOH4AIqnRGNZ2RjOcHJvjMcggy7kZIc5Ra/dcGmNGLS4x791jdFZMuQh1wTcto0uDUJEoCCJNzCFsnIDkBSApHMAEIm0RCRwWc9jtokJy+4wYxitBEnREUpRFFKxOwkP8VgGcjk/+MMn4ADJDOzj05wx6Bd9hJ4vfwlMIe4NFGYzpg8RaZPlbmX7HWtmUQFi1HBUQ0sTtMVk2gqI/awh2yigZtX8KZVGciCcWqVnFttI2sOcb/WzA9+QShrus7aLi5JyZ74bOtvLIG4Oa3pWs/ZRMEEitfo6FWA01mc4xyYgggolKGRjCQH1MCKh3xKGBSJj+jWQ56KNoqTnTTUEwqFKE4+CqQk2+lOUnoRzYZOUisMSQ5t59Jz4PI+p+zRC3GlBCHStKY2vWkwt8K8kUoNqH7ZBtWmxlvoFXW4nk2qUpcKCUYod7lSvcIVegBdEpDgqlmtrge2Wl1yfok1cAyrWMGg1v+yjoZLdMQbavBWT7/lAhenwOeZ9GmJgcU1r3utL0Hje19Y6FegmDjOniAnghRcYLAIKOwE1eDKWERjsRJ5GYNBZYtQPbYUFP3oRe8QBo557mMnTWxEUtoRVcaCFo0CXXlIu5GVWspkJ/tJalOmy5nK1ipCIGJteWVbI2alDHlg2jPlsVvg/vS3PU0mg5hJ3BRv5IrSnCYrnIpNbKJhDVSWgpVngGXIeWDL13XBdbd8xuyec7vebaeWwtsu1pRVvPLDW244wd724oIcbs1XQfUrCzzTVc94ti+eUyHI7OgJugBeaAIiWeADJ/jBjGasox1b4U54FLISoTAqSqwoy2L/lsMnRrGISWzRk5YopSpm8Uh/wkLcqUwvMm61jnc1qBvn2Gi/O0JsdYzExLS2yET27ZB5XT1sxOrRJXJmko8xjKSmdJpZhHKU5VDlK2c5wFrmcpdZcN3qirmM6G3fIMAAP3diwaxrfs267KmI9tIZF7lYrzLMNJn56jUSzOArn/fMZ4H+uV9e4AKALwCBQws80Q8AQRkgquBhN9oYwVgssdejiUSN8oSOpkhjN3mozLKy0w2mRSZFCTpUMHZSKlTygnomjxaijoerdvXxZjprIgIrt0AGts2jJuRjHlnYjIWhpUFajVGX3IpNdkWzmStlaFtZCkoRApZtQG1rgxnM/9rObjql1M4rYUFLdFszedGKvzf37RRydrcy9hi4/BJUGfrFd77xvAmj67m/2oEcCiywgALrfe8d0ALCF/yMwCu8GYR/NMMfXIoTgrJQGJu4YyudeEcsHrOZhdQmJx/ykZF8Z/PhSYhTDnqVg54jLn/5bGm8KyLEfPU7HhHJoJnzXy+xmDdn4lhUOUWK/PznFEG2ChNT9GGIQhWiKD5UsdnjaDO9CU83gfOfLwJrr8ADK6i6tsvore9+AQzfTjOVToMFOZZ769zVI7vb3W5l5GIRf8tX4GSxi4HBIpBudzug9WvX/YqNmwKGQMD3LgAIYAAOMEFIQCLAMHiFJ3iOdv94jRYfpNAIlqVhhsJRnaB5kFdCi9dBnxNCoeYxHsQoJHKBHxYRnXdyP9Ypo1d6rqYrNlAULsh6SfBqxmMHwUJMtSd7QYaDNYJsDZFJP5hJFOZhneV70pQYojAMkVF8xgdVyWcGT7h8Ttd80Od8XMYC04dtW1Z923YuatQtrfFO40MlYBQEVMAaYhRGZbgbe4R+52d2aOd+krFP/RR/b/dngJYKl5B/8+YH/PdIAhiAe0eAfacHCZeACoiIDTh4F9cJF0V5EsdRI4iBl1ZZYvBJmZZxjpcRKUERC7gzKEd7KyiDo0iKM1aKUKF6xgODMUiDPJZbSuQsJ9dEu0V7Oxj/VMcQEU+mXEAoCUsIEUXYZNVgCs22hMeHTVC4FFKoen/yfIDifBcwARPAZdOnhdY3RqlRNmq0fWF4BmNYVt7EZumyZuSXG+zmhufHR/gCX2mSLe2odnaIf3kYd3elf2AwBT0gAoYGgAMwgAWoEA6XiAH5YIB3iO0RYavQiJNWYY+lEQ0GDLVQUXyAiZrGeJtGQrwnUSPzic4zg6JIRKkIkiHJijelPK9oi7OoFjWng7F3e7j4ZJmkB5IACMHSiyDFCj1oCsPIbKOwhKJwfHvghLcmgzZAlDVglM3ojCYAjR4gjdNFfVmIhVlFBeeUfe4jR+MWBCuglVpJbuM4bvhj/47o+G75BG/sqCZwRVDvmJbTAWiYAEB7iFeCJgJ4t4/8yI8FVgFZgBEE6YnX45eKyJcEyXkL93ALmR4VKEMLxiAv9IOSN3kVuWEhV1GSMGEDKSu+hmOnqJmbyZkwJ5IjeVO0liEhEiwqdJIrmZKoGQ+1d4RN1YsyyQgzWZM5CYymgITAsBDLVYwzWWVEAZJImZTBGWDR55Qr0ANa+ZRW9xrgtn3iCEbimJVbeQJc+Y3edAVYAJb41IZ9oz/ryI7uuJb6F1/0FZfEEXfN4QaPg3cMtXcDeJeDqJcW0Zd/SZ/QYJ8+FBGCl5+BSZiPhXGbpgmtwFjOhGyQB5MSKYGR2f+BhfAoomOZPNGRpxehHtkhqwiaMbcVjjBqtdhrHZqaaKGSp9kjx6CLr0mTsAlStKmTRTgKPPlUxwcIU/aEFVKU3xGczqcBSTmc0RddWzl9WzhGYVQ+4pdVXlCdN/Cj0/mUVmWdiKAK2pl+3HkI8CccgGOWh0QnBHNnzqGHxuEmVzCX/leXdnkAg2iAj1AR81mf98mmg6mf/FmQDddwBumIlwWgQigRNxh0jIhhGWanIBhDDspgnJeZFCqUEzo8n3mhGFqSwxKiKOmhqsmSt8gQUCaTekCTS0iitHkM1JSTpvCTUyajybiMNmqqOXqjIgB1UXecrQpdDKMnWPBFUxn/pOOTVUzqo0k6XTdwnDfgXGyACH1zDX1jdvpzpccKHQjET/6EHY/wJikgQf8HiGUaAO5ZpgUHBYWYpoPhlzniQ98KruHapoT5cCaVKBRZKJyGpySYDbjImJWAiekqmYJqmVixqJ2Jr/m6mYrKr/f6asACdI8KqZG6mgWLmlezqefRBzM5k32gXCo6ClmURS2ak08VmzE6qi9Yo6fqjKiaqs73AtHVA85lZbCKBl9UhjjgTThgpFYlnSLbq7hKVbsBf+qFT3GIrMp6QDrLL4PQJs6qHHHQAyXAnu1prdRqpoUorjxHn3kxrksLp+QKaRDHSpQFcqN0UpKIi5HniIAa/6iRIlOmZ6j6KpT9qq/2eqEhsjyOKqkEexYGe7DRQ6JOdamYGiy0GbES24MtanwYi4y+ubGBAigeq6OrGrJAEF3PpbjONWUDQRDdVKRXiKTSRbmJy02yigVUdZ27gS+4cA3D6kfashuD4D9jY0DL2rOEkx0K5AU2AEljWq0HUACyqwDYqgdeAbVrOiO5G7VxKrUNZ2keJVkJmZD0WmmN+Jgb5Sir8FhJU6i8JJTRK72laDRlm3otqKhoy4pCqbY+JrAs2baTaiwu6Wx2ywifmrcTS7EuCpRRNQbvq4ylCgPz27F3l6pPd7iv+qpKIAVTJaqPC7lc4LKVS8Aji7kHnP9NmSALxLALoIsvaGIciSDBBWS6FRwwcqKsdnUnAsEFKIBo03q0BIC0tssKgWkY3WoXT9u0PLe7aiquC+eQFgcqdEq8xauRM9y1ICiZiqc0zztE02u9ESqa2Gu2+mq2tQW/3YtCuhYWQga3T/yh4YuwDDEek+CwupmTEZu+0zQKe4B00Ga9gSu4KFC4qoe/iMu/JUuyjPu/mju5vQqzcfyrAMwdUyAIf9S5aNKl/uJFygEnYOAGgOwmfmAdp2tAblJ3rwvCtBvCtQsCS6Ctgrkjusu7J1zJL+zCksyXchoM65Ees2C8L5QejymvHzQJCCq2Z1sVQHyopBrERKzK/gr/BUe0xN9LNfQQxS0CxSfZDbn4kiYqLFncZHrLt8yVsfFrqhxLxs9nuFmGxmmsxv/buKKquHJMAoh7xmzcxldwx78xrJGRZxPsBtjkuH3sx/8SyIN8wYaMyALhumPKyCI8u0m7rZxnySjcpuF6zyl8yfwcrvsJ0A4ZkBl5ww95eRR5QccgCZmWyr7Dyg89xEUDyxNN0ddba0P8viLSFUm1y0/T0bn80bZ3Nb4MzKLAqcOsxS6qXE04ZbH1A04nxsnsjEV5xrcGzdGszQxTxwyjBlzg00vHfE7HBULQAz6d06KaCE/6G6qgCoggwVGVTV00zlLNRYEMJ3yMJ8jBfRTs/6VU/S8DIQUa8MGNPLtlPc8qEJ/7aclhsc9tPclv7dYs/M/92QvMK2GKOKdTqzsXF69h8A3AsNCyVnqtDNEXXdGqGMsuTdg5dYNOnJI7EdJSbCw743OzuaLHtb5967dlG9MbW6MpAJJDrRRA/YQySmXSDG2n3dM/7dMUQtr9OwbU3LiXwMD1pgotSgnGONVX3EVefc5/HMiA/NvF8dvaEbQ9IK21G8/ybNaOfHBq7Rdx/a3RzTVwbd37THj56XCebNfdDcr8YXh6/XgO+XF3wBPAUAhT0cOeWb1AbGuvTL2kWMTxfdgR7dKiKSK5xqG+FsU5g8uRzcuAV9nFd9Io3f+pBO7FC3vMMO0DMu18RKmqnw0EZjzaSweFqi2qc5DhvckFXdDTysfasB3bsZ3ad2zbTJ0IoRrVcRAILO7VVe3Hq1vcM37OX0QQJjDWi0wACdDctdt3Hkbd0i3k1z3ka2p4oAyBrBQKS+7dDIjXBwnlpNOujOl5rIDKiLq9hV3Y9c3l9t3eEu3lGVrL+w3SAC7ZUdRYumnSRvcjKJ3ZMDqqRvMDMg0eng3aqhfiIn7hsH3aqa3hf/7nhdAnGN7nPL3haGDi4ZziLM0dUhYIfVDVkf4v5ozVyqEwbhBG2lTjVEAQPWABOa4AzL3jPf4AKpAQJVjkuxvkqY7PRv6Xjnb/kEou60z+3Xi93VHOtR+zxLjoec7gCT293q7Gyu8N37oC010O5smu7PINxGMwy0nDFV5B5mUOxf995mg+w+eRWGw+zEVHscaYB397IZ5N7jRdY1iW5xdO6H7O7uHe7huu4IeOBgq+B6oQGT8J1VGm748e6f0u6TUuEJsO8Jg7AtLK46GO8KLuACJMgKYO5ESu6qzu1rorDNSQiHWNkKSw5FVbgbSODMaAyQyH8d8Nr28Qmb04Lezg60oT7MLu3jZd7PI93zKf7Pu6r0aTxI0Ki+mgOta+yz5/7VHktPuh7dwuTeLg7cVsjOL+0kSQzOZuoa6d7qk94vLu7u/Om8i3/7AWu7ANGyyA0L7DR3zGuO8nu+/8fk26HQeJFPB+rOnbEfDcgblXQJcJMHChfvCiXtYOQAPPLSsQ//f7bD0Tr9YCSXgjv/GhoFmzDsogH/Kd/MmRTwgZpgIYoAKXRRafJQnOK9jQ+zswD/o3j+xevuwY3cocUgbPrjwBS+ZAT+0geubVXRHavu0kivTFh0UtCu6b7exD2eBPD/VSb+EXfvUbru5OmHwxurDtm+BIt+9gj+9kr+/zfvZNlfb47uICwR1xr/1w31xTUPB5z/ALr/c9bnAPX93pL2yDT/jZXZ+cjIixnviMv+QNF/L3CfmRT7VvQAMAoQIDBhXpDH5D6P+qkBYmDKsgaZhE4sSIFS1S3ILxoRIlUDgqQQNHykeSGolARJlS5UqWUFyanHhE5syXHR+WwclHEqtqCBHGOwiUnlCiQQ0ONXr0YDmmTZ1iCxdVWrFbVT3RYmXq2NZh4oZ9HQaO2ChRZRmdRZMHjZkxbWPa8CED7twZQprc5bJlZF62a/z2bRu47V85Y9IalqN2Tto+exg5frwHsuTIjSn3OStZMhzMgDhjBh1aUGbLoz/HCYRadRzOqznDmRL7hYUECQ7cJpBb924HBRTodqCiDKtl0aB2O24N+XLl3pI3hz4t+nPp1Z9Ru84NezNh3YN9B/99VSjymsqbP7+qV7P/6OyhvYfPXfwsW7Xs0ypVqY0RIyoKqgMQIXBMUSOLmy5CMEGYNmKQBx6USOQaVdYqacEfWsKwwZdo0tAmmTwcY8MP27BDJ55+SqoopVRMER1zXnTxKRmlqs6qWFzhSpRhRAEHLFFGAZK0PgqjsAwPT6LrJIz44kIKwvxSqy8i80DsSSg948yzyybbcjIhAbkMkDyGPC000bpMzTU4WFPTCzbXvAII2nwTAAHb7rRzt918C2644qjTLtDpmBu00Pay2867/NQLrxdbzmtEk0jLo89R9w6NLz5LwaNFmPzyIyTSoAQEZ5IyDOxwQQU1qvAjVewhZ49WLcxQybdoFdEj/w6POPLAKnKSZBkUV2SRWKRahHFG5wi1rqobb+QKLLCCZISsPcRUTDC3WioJMCmnBLfKxMIdl7HGznpMFM2ERJfLa81UTEx4zaTXstWGfDPf12IzAQI9c8MzNwd6863ggYWL5U9AmTW0YUyl6y7RUoLJz9FNHYV0UvIYvZTGqKzJNFNk4PuzLGCAEeXkegIU0CtTU101ZivwYpCkPcj55xpZZ721Vp97BpojXocmekMSyyhERwCLXdpYZImNUVnqikt4GWi/6rGaaYNUd0gxq3Rrr7wyovmjvvaCcrFyryTSMLDZLu2yH7t2zDFK5EY3MnmxHLPves9MLe7XFtP3zf84IXiAtzsNDtgAgx2gwU/jGKbcOocvp2o7asbjHBVGLc54Y463+7j0kZ0LOVOFi6uG6pXlmecd2c/xKg+Zf1ZV6I+ukMWef2RBwy6ecSd+V117DXFo5LU42hFahmWHaaePfVrq5KaSJvuEneHemR6/IkaVIMkqq+6vD/P2bLxAcpKt9tNWO94no6RyfnlDaxcydvPO//6Q+B6XHv62v0AIsDSFWxNs4hSCf9UpYASDoOP4pAI+VG1hmMMgyCwnsc510IPpEd3IOlY6EmowddbJxp9UuLToCWgrejiV8YqXO5Kg4Qp7uMY/YvWCCtlKhkWbIa6Clqub6OR5sYMd9aT/t8RkWW9ZKIxWFKU1DCDRDS1pIZeV0keYLsBvbWt7m/38ljdInGUU+psE/xhhQEA8xn/xU4vf2DhAAsJhDvqyIxuwMJsG5ilxuJFgIBXggAxkwRPZe+IFCxWfRC7yUttZ1AclCUJLkU5QJcyU6bBzqD89o4XSiMVVJFGIOuCkDUQUIg0rwpFdkEMWuPiHPXYxvOMBsVdB/CHQaukrPiRNWE1jYjCj5sRGTk6KU6Qi1/TmNXFp8S/vU0P64Cg/Z9bPDAHEHyPKmK4zppGO19pbOOOlhzF5zYCeOCe65mgm1SQQDVhgQwskALA+AtKegOyAFg6JyMs10p8ZvA/GJvlB//RsrJKbfA4mUZdBRNGiE3yowx1IJAaKogqVuITJC9CQQ1jBahcnAKnwPjITENnklrmc4YdQOhGcAOJELHyaMA1CzOowJ3tc0Roye0QtLzHzi3B0ppV++tMwXimbkCgjUq0VCG8SsI17A6dn8gBVcxZQneQ0IFPZOTjCLeYKV5gTPRt3z4JJkJBt2OfkGLrWRHHHcx0Eoeg6V1CDWpIbT2Hrw6hBiDf0NQx/DYOBBHtRHxbWsBZSQu/+EUtyIMKxbLCLSFW60lzGBaMkPalLWurSngBTptKj6fWw0T2uZE1ao0gm/zoTx3ECNahenAM5sTiuosLtqNos4x4oUb7Vsv9REp2RDLZmy1qsFjed7MoqaGLbVTva8ATzVJwf//UbQT4gnzxRawb/6ciRdco+pIBrpMRLSfDSlWOXTKFC+6lXv7b3r1moKGEvixG7JAJni43lYhvbEaHpirL/HaIt/2tKpAWrsy2MaYKbSMxsaMPBCYkWMbxCDGnx9kvGla1rXwvUDFPzmtG07Vm2OYkRq/aq68TWG1tbXKtqNbkvNiecvGrHHoRgngF7IFmrCwK0rk6ReUUd6OIqXiKHosjlJS+ifoze7SrSvRV9r0UBfNjC9ox3vsMvfsmBi53R0r8wg8gSqKzLlZTUljnxJfQ8O73qEarJWouGFKshCmJQeBj/4jPFUr/0GTJVlajV7PBsv1UGa96vXWkssWqHFBoURzXQyz2nHn67zrNEWrlcbe5sblwb6dazutZtA3Gyu+T1mpCgknKEpIxM5CMjOT3fQWhC78rkUpsQO36FMnx17ZIliEG+GBozfdmQwywv1h6wQkSceHikzE7Z2V++qCl7+VI2fza0x3nwMRCSjO6JwmVfAZIp+PdiAcY2xo/+s4b/DOIxoivRisawcYObYtdiuICSHtKkXUzu5rpzCh+YJ3Qd0LixVhcBD4CBHk426prWeoPIEKjGQvGHIrNa4nKV6+lmfW2HW1LXFT1lfKX87BmeABH3LbZ+VbEXXi2PsCMn/zllD3S0POwTwcF8HdQ4jm0If+Mr3h6GnXck7krPa46Q5nAAh2ouDw+6nO5GdFJJPO54x/td9C5E1cnt4n33+dFSsLHAxQocHQeyAzAoxC0Yrl31/oI+dLV4I0L1B4qzmrx1ZfLON4heu+ba77z+tZgxqrsTKAGWKddyIopk0pg3fsAzywm1k2hto+zcwaTtnji0piMc5bmplmZ0lvqN7qUn/Ysfxp/URazNE2sdxWi41nCHa/U15tvP5e53c6/wAwsgro9/pG7ZrYuCpGHP1pe0K+beruojR6rudY+rB9djDOjYdON6//F72iDyv0PB174O/HxPgIXDIx5WkA1bs/9R6YP5hl9EzTvi5Ncs02s72Dg95/b3qAju3X7e9os+uqpLN79orj6TPeKCutV7N+NSOnnDlqg6QHubNAzTN69DupAoAbEbOwJoAOATvgxAAYWbir0jmRO6vuSgGFeTO7pbwRZsNYwbnZpiMMsrpvjoq78TOfdjiQshMweJLJDag1xAPPxKhB7aJR0EtpjzlZsgEQObP8qrP/tzIWT6is7rP9BgMX4TQGpSG9iyI9IbI6TCrTFsPTHKQkeLPQT8P0pzvdHrwjWwgMT5I07zNOHLAREsQbbjO7cDoReEOxhUDyV7ohl0IutpFvb4uO3DQZhzPB4MmhM4A5RLOVyIk/T/O8L2i7nMah5G+CX580QFI5SmKJQGcwZtwDxuG4acegUrRBdPuLfb47Mt1DA16KL/ccPZw4zRKLFt2hJmyjqjQjFRwLoIpL3ak8U39IsKGCQ+wbHpKjsQTDvjaziHgwq3GrLoiz5HmZjksylClBplOcTrgIZEXMReEzwROUdumbKPMDlJzLJYEZuW+xD1OxJHtEeJuMfI6sGWOJWW4ol5UDN5cAcAebA2k7ViMqZTPC1TYAVEy5tjhEhkrEVwmUjY87rHUCrVy4y7McbEKARgBL01eqoVmyrgWrSui0giKYGBiaANHICXLCuYNLsciMa147u8Ow5rXL67+5yebJSI/8HJb5SRgXQKeDDEE9o1coyCpMzBRowJZhMCkHoVYys2LqvEkXJKTCQzhkAaR4gFAZm/sKy8g3QzRLophaQiVyA6/wtAq0pJZIwDWvyLihwXPhMEStiEcMNLh9QM86GtNfhFrPqtE3O0BpSjAMQw0xsXJlDGPHHGsiOrs/MEC9KrUXyOFKyUzNTMi+HMn+RGoRxKoyzK0JIP6htHckRNc1RNwEOJdPw1zHoQkVKC8Su/SQweIDBCDSka9dtBJMnHx2sebQvIJlozB7O8s0RLVvy8CYRIuWS3+Omiv5DL6JzOrmoMpFpFVUgtpeof2bqmj2zAFhPGFBvGw0QxBrzA0/9bSd4IPjqETJlEAMmkzFhzGLzCjvrYTPz8BYjrTGPwz/AYofQCzdAczagoUGYpTURMyqVMTdcEPAclKWdjxxO4AlzAspQ7hMLrL95Ewn0MIq4ktEMaloIEpuJcMEUyy+S0wrX0precAzUoBPCU0ReN0RcFsS6ayFrkjLvMy1SQBVnYGkTzEuGSTjVQQ3K6OsegN8O0t2M8PSLogJasQ/ik0vjUgckkwZusPryaj/6EtYZK0P98pFgb0AMtUNE0RDE9Te5bAgZt0AfNSnkkifEjtpSzhzMAKUskGqjcld/0mWDjR5wgNM5imeEUS+MsyxRNSNJCxRVdTuZUm8CMphj//cW4jIPA/EgjzdS86AIvYBICvM5UyM5XAFIgXcW7EQS/RMbvRLpAgNQlBUxwQTr0XLcn2QIbIxiXRICYrNKYhEZpLDX7nAbv2E8AjZgxRdZk5TmiLFMzjQo0BccEXc0FndbVpAkIZbxm80HY5Ag6HUJy2KMe4tMI/S8/NVefQTPJK1RDPdGy1KCbEpZjWkW13MsyJKdNlc740SqtAs/p3FR8ZYsuCtXs/NE6C5+0nARVXVUYxSZ485sAqlE5CExaLdJo+tS/+IENkNL23JMA8FgqLSv5FMT1EtYwfTiTTdaRHU1mbdYYgdajLM1qjYKZbVOZtVbBsywi2tY+1UfZ/wSJE9iD2swyLutWrOTQH7LH3zzXDBFUhr2KkxFOJGIhBPOJqkVUhITX5BRVFm29QLNYNWCqR3iETYiFsb0RV/QESgXYr6XFL8xLgy3YuN1OzFhYM3RSp4PVcPlUJuHbEGBJjuXV94RPaJxP+rRMQEFZNRWhxEVZhGLZxx2msYzcZ3VWy1lNN7XZavXNnAUiAdtZW5rN2WQDodUyRMhNOUXdmUha9mNdzk1CD9UspCmR7QsVScDSZdiKn5DadbVJbCtFtPQFR2XLjoShwoBRT3gErlhRVxDbR4gDL4hRGJVeNfDUaEINpCpYZtDe7Q0fPEOqS9Oi50yuUaJYLaqfpv9jW74dmyaQghrQ2OATXJCVyY9FOF8qhiwtocpplmLlX/5lXMaFDuKE3JU105ct2fe4XDdVYJu9Vtfc0AAbV3Yctm9NtsITgtiUR8+FCB7k4AtpXdc1LAxe2l8xpSyYWcAikV5KGlGLWoD8pAYzpuW4vN/tnlfgtlH1PL40ugwD2x5VS18A4h+2QudNWxj9yE0dE0rwBYPdhSbm3jo71RYFoyb52llFzDjigy36y35VH8hblQyE3zAOXPkdXOITNfzNX1G0Nf60GC8tVgD+zOUw4AEu4DpGQQTOXNXUXMADYffbVj61GXdMvNn0QZPqiBfgWSr7YA9W5M8NtqZlntT/fK87qN2n/ZNj+KUY3oZsi7ManqIo1uEByipIUMsfDl4hBuKtKNtA4GKLvV5RlbBraIdreGI724Tvpdtncp+vzTrBvCowei2ns9gHLrO6AGMxjt+PJav6VTtGwkmNY5bFdTvQyc/+fWM43iQ71mbKtWPNOU09rtlwXuBe2wE97uPO7dn+mix9jE0gFGTGMl0RVoIW2FMN3twNPufWnWcRBlTI60dJfq9J7isVtt1aWDjWsVrgDVKHbKrfckXMmLrm9eFTLuU8cwVRxQRfeIS07aKPrINCCIRNYOJ1WId8GIdaPmVeVJuLlRIjvWLWSt+YlumxKRq4qIubFoL1RObH/xxjeyJc43gP9Wq7n6TmarZmbI7jyaXjbV4wb85jcIbqRdYBbIXNRF5nwhs/QfYdnYnNkZpndXY2RlZdfB5r4BRUpsTBKLtB2lXhSugU3IUzhea/3QpbAopovKxoVa7o5k2jZ2neIwbpkBaHkh6HcSDpfFCGJ4YFWACSVM1lXYYmlzYukURfbdHiXV7fjthcnBYCEPBAnk5mgyG++53GoFzjaTZqN0ZqbtxSbZ5jbXZqcybnJaBnzDXHFqDnmSjnRS5r2B2z0B3dC9UyXLhgo81Wfv4ysB7r3O5tR6YsSN41Rfy4wELNtW6DSt6Jq5FXUGbouhZDiw63zsMR5X2WrP9w6Ih+6JCGBcMuaZImaVnm3sVebJVeaZZ2aSv22i1KPwphnx7a1hqwAROgi2MWpF4NbcdBuDpIq45j49T20tV25tZmam7eZm9uhtt+anpm7tne7XOmr54d4ZLgodElB+HWIcjSnf5CZOf2QdwuaxaH8RjnkLNm0watA/iaqBwPFRWeBO3ebvPu7qjby/AW4oq+mvJOI7QVIORNhXMobJPeB/cuaVpWbHq9t/pmaZDMb8yelS4PqRYX8DAXgRLgAArY1QJHc8dMZuviggU3yyaDD/518O5S3MZV1tKW4wnX89gG59p2CT+n7drO7Q7n7REGMEMev0TABVy4hvuSpd3/M26rLuQjWXHVHXQZl3GbaFq05j7azfFPh6jjzYrxRibybsggjzrPI3JS1+vyZkVPIN808gX2lnL2VobErnK6JhMcbZL2oUtz6zD9LpsuF3EHCfMSQPYS0ABl18AzN/ADd5x8AoXe1dL/rOZKqXMTtHA0Plw95zhE3O1AD3cOJ3cOL/RE9u18JIl2voII0a/bjGBy5Qjc1mzkzvR1fm7otnFyjCg16HedyG45kyLlRPWMxOtwa3Vo6byEZ8iyFaWQJgZlaO+Jl2UqP9hXuASObC5dZlsCTE/IJpthn9PQLdoLNvZj14Bl14AyP/OdNquXdPb4BbUFxyA5N2o73/Ys/2VtsnRtCidNaphq2iZ3QZdtDd8BAP/gqc7nP5X3el42DQ1ueNwWfHQJRK70Fe+IFqj3I7h0R2ZxIJgyEI2hatW1iGoekJ5MVkdFhSTvUk7y7h51VQfvIl9ehRde5HVeppp1KSdslE6FvOdhLv+W9Exfi5h0fibkFT92E1D2EOg9C4jSmH92aBckHnNzfnqYNsZ2/9X2zs95bpdwn99zholqFxd6ouf6uBAzQmd9D3/de8zW3dkdVZCFIpRnCeVnTHdksM93nCB7MYioXv4tteSKtffktQ9ivX51tFXA/jt4I7d7TGZ46CexjdaqVGCGJy9sJ9beUr3lK39RseHU9/9Zt5C/C7K++v/2wcV3fAtw/95r9slveQeqE8GdeWo/bc2/GM//fICgBm2gwIIGp1lLiE0hQ4blwqGDGFHiw4oWu3HzlhEjx4Y6loDcEfLIkhYkj5iEYjLkyhgiX8L0IRMJzZo/bCYRcnLnTSVHeBzxGfSkkqJGdY5JqhNoUKFMUT7l8eLnUyUpo2LNqpXn0Cpey4CF0mZMHkCizrJy5UvtMHDJ3vpy1tbtsWF278aVq7euq76sJnkCLJgRo7+Q0ppK3Hdx32XHFj9mHMtvLEqxDA8OBOkSMWaePxODJTpVKkqB5qCew2U1ay5dVq95nXq2mi22m+S0yXQq1hM1TAD/B67BhIXixiU8QKB8gIHmAZhDj958+QHq1a87L6D9QYc2nqRFayi+4K9g5c8jM6ae4HiEB9m/jy++o3uHFO/Du7hw/kaNDGV+BENMLBFYUksDAhjgTDjdxCBXRAjh1G5HURihhRc+uJOEVEllklVbgRgiV1aQmBQgh6kiCl5v0cUiXCvWlddezqglWWaDCWaYYpLxuONkP/plGWaCaTbJJqQhSdqOm0ByWmqtwRZlbFOiZgZrTOCG4W9bbhlcl8QZFyYEYyZHnXUCSJddmtixmR13WtAC3n5z+vfeeunB116eezZTn3x6+rlRfvjpV2h//CWYoIElLZpoCy4JCKmC/4lCWKmlDmKqk0+bcmrhURjmxqFQEvLGoYhQPWrSb6aeCsVXJo7yWTVutejii7W+GOMwbPH6I46//rUkW5E5plhklNk4yWTAQkIJk89S8oiRk0jbR5VQYisFbHJwW9uVl970ZXAvhGDBCOUKF2ZxZCJ35pptTgevvMy9+Z2c9EHEUJ/78svnn/4CHCid8RlacH341umfowgyClOqkkI8aYIZUtygxRIWJRWGFXYV6k8Zf5zhqSNjhXFuYJmlSmfEzHrrXLi6jJeujz32Y2A336ysjsIie2zPP/o65GDNOqtYtJr1kfST3rIGRA+uSaltbN9aKoO4JRAXwqPGlXuBuv8RsJuABAlY9+68Z69Zr2P3IjwNnv3+G7d8cAs8cEL9LlSwfnXzlxCCMT2sQ6SAD261xAsSgXimF1vaKVWhOu6U5I97CNSGG/KgKqtRad7qqGCRJcrKoeFFOlww5yozX0EyS9i0QvLs8zJA/gxksLe/bvTRevBe1tStPZ2t1MNjaUPVWCOP/Ndal7su2Owi127ZaD5n9vRma7cdCN6x3VG+dwccvtx+0m1fRX3r3bb6Cf/dfuESv2+4xOAubjFUP7VgsqY5fQ65/yA/jmQj61zJXJWxEoVuZbcyHYxipqu1QBBZf8lZznSGGGMxRnYSTEzQcnS0DxYtWk1y0rWgRAT/4UVtNZXyUvKa50IxiYldECAbDc3UJuphD21pAkEZbtE979EnbuX7153KRzdD1S196FufNeC3MMLFT36CeyLj7Jc4xFlxch3b4lCi8r8RVUWAYtyNhsbgqjyIrjN2UcUwTOcWBjZwZqtjTOtw5wrL9CiPtDNaZeyYGKKFUISaoQ22sIRC4i1lBsFZnvMqEL0xhW0BNZykDZeDwxzqkE0dUEMswqONbHAEiUQc4tzQQ8p9KQSJ60mlKBPmSr410YlSjKIsZynFKoYrlwDSJeYsF7Jf6i+AYPxl/kBEwFXdL3O6JOOIkjKGPaRxZeIQxxvbqMY4qo5GEOwgs3a2R8gk/+ZY3+xjtLiZO0EGwhO9iw3TqHZIbeVGkSIAkwUg+UhIig05kiwTmiipnEpeD5OZbM4m0/LJULZyPKe0E3pMSTdU5m1vB/GPRJd4sPnU0pa0jJhGFbfMj+7Sox7TEElHWrEA9nJzYwSpL4mCRpW1I6YynSZNRzcXbMZlMsQyDC26qaw8HiMtO9UjOallinMiFWkkbGchgYDCRC7yedFLztgIQEkH/FMA/vTnQAVqvYIe46BKBFQR/3WeXqDVoaSMaEUtOlFYti2jHZWrXFlqV5WiNK8m9Z9egXnMZLIqVci8qxcNmBRGrIwRe7AWI1zRmZmGBnXa1AsdpVVBD1pwnP+a3eMFc/e6pCKtEKphalNLCyEvaQB6AC2TAsy0VasGtKuyNcCbWOHJi0yEiQRZKEHQOovfptU8ZT3iWN1q3LrRdYrKTe5cCQvYZRYTc5Hb6zA/hdetdE5z2v2Q55KyB2JQwowgUcMazKAHx0IWjnfZS42AcZk6LstHyCKq7iyTWREOSZCTUNrSTPvU4hmPnmRarZsq2U+ywRbBs/Vq9rDjALCKNbcS/h5ZzQpc4L6Nt8UFFIXhKpBXUnGuObABc5vr3MH68lEp3cqomhJMEq30uh96gVWE8tcyjqEweeCu4GigAy5Aghn5WEdNXZaKtfDIssDiqWbpy0cOenNaOiL/GpGsVcLSwpNTWQ5wCTjAAekBtMA3PPAlCbBgBq+poLdFKJvZLDCA/eLCGBbfwTb8yg/fmaJ4Fg9zUdDcjQI6pCw1iaoIveLqPih/GSvmGDtnFQIWOn83LiBZRqGKUexYJiigQQc6cIQ+OIsY48gHP8QBRxlRhlq/klZafrqJcerxycpqFu5UbWsqE2ad5CWtCaW2hS1z+cv8DHNsyZzV2FYPzQJ9sBlsG+Fnuxl87jmlb+W8ygpPtM15Nq6e93yQQC833H2OImFFUkD8sZi6fQWmSZ8yaaxk1yeSdndhP3ZYlW1CNeECAb8F9EzSjGOm1JSRklLNalt7E9ZOxi+t/1d9a8UGgr9XzpYWKA7PFXY5bMSO15jPrOwGv4vZzob2hNvWJ7XyK87Wvja2WU7R80n7uN3+V3JHLCCbjxvcdk0VVQoNlHfvbylllDdR2r05n1OOXO4G+nWdCeo9aFFAIKBB8ZgwB0iAY8j5GHhcSDPHR/hqgwqfL5TLPuuzO7zhEp84xX/ddozXE8xqmvvcy3xgjycb5HlPGwj40EnwRGQbJO/w3Ro63LPO+bjpKU+e7MZhmSfMICH+s7hFTG6YnLhyTA8656GyKY0ZnSl/jTcBHy16em+FRGjItNYs5hJ+gwAG/O4ADODgC8+QOuAvWsuRF57HosEadw0X2q+Uqv9rXv8XkVfEWtylR3cG2x22e3/X9L36YED8nVCAL3k4yIPyxVu78Y4/eXAHotu4bdv8ZM25DHBe+eWWQPYbRfFdJe0UwfampEIH1UkFaPqqqAqPKZOIOBOM5UYMxF658BATyB7t2cBq2B4zpFdcIBlQ3dGrMUnYYWCQaCDxFZ/rgOB+rRM7WUkBFhLxuF0JCkEKcBnzDdjzVd/HyeCygQD2bZ/2RZv3GZ56gB/jXZTjFV75KR76/WD6FQT7UZ64xV/gXB5I+RyjXVe9fV7HHFDoeYxWqFgxPeGH3NiNlYgBOtMJxUYgvAIslFf7bRoKNIG2kKGQtcM5UGAFtpeTKdz/7Qxf8VVQCPKXHpAg8r2T8s0TcARi88Gg3s3gIVoPDejB2kiD4OFg9wThDqoV4eWg2zgUW5kcEXpY5LEHEkLRE0URE+7AlmQX6v1cMo0e6P2SqCCaACGdinHOz2FOABIdUThTuZgEHGiGqF2DZ1zaHqABgKQh7dneqAVcwIkG7+kR2LFOfNmXftXRzURcxKlTrikNIPhOtzgTPG2jlRDP8GSZ0/SAODoNjSlSxpWNIcZgISJi9WXAEShLNHyDOZSDIwZeyTGUcJWfy8lcM6AHJrbVv3SfEcbN+3GUJx7k4DwKim0e0p3iUTjahKBU1I1Ri0EaUJBLKSrTQlZFUYxB/wtsQEgygZXswSXsAjPIQkqGBiSsgQ8MI+2B2iXAwmNxnTKC0wZSmbQ8XB3dCM6AWtJY4whqYzd64zcWZdNECRyggVIeBTkKATq2ljpK5VS2I8gpAITZY8nho/cJgz4K1yZWIg+ukjsklCa2XLZRA0J+YkJKXaDRHylq1ykenRfu34u1lIj8hiiiyul1oUMyhUdmTvzVBBoslsqcJDO8AiTAARGk4aYBWZGYAk0mQxkWXDPiGk/i4Y3wTlAC5doNZQkeJTgaJWt0wRUspRuwARuY5hVoy2rCE3Gw1jpSZVUa4lXKQSzMo7Zt5UYYRFc+g4YBIZ38o/kEJxEmTIZB1P+hcMPkJSG4hWJbAh0yLWSpqJQAhhEzWaGWZMV2dUiH2J/G4B/+1SJJhaH85NIYXEIv+sHwkFj8xd5IcssaXp0Emk5lQaOqUWPr6KHrSMI16gFnemZ5EeVRhmaBgiNhAuMepKZrTkGDSgEQzAC5zNBsUig7Wuh0XF/2sVlW5tacmCVYEp4PslJAgqW0LZ740YlBNicSLiFHveWLbqRfeg52XmGjkYuNSRr+DWDm1JgUNoUZtQDzzF5ISkGzzEF7tucScgAKJODs2QAZkoZNMslO7ldgFElPdqZP/ueWAihQcks29iFokuDwGChSSsFq6uJiCQIwKmWbOiiECltUVuj/hc4phqLAIm7f4J0fb6IlirbS2wgKib5ZPg6nciqnWo6ic7beojIPXNaARsJopFanh9hljO2GzxVFdGlhYC4dunkRYMJeSIpqT6xGCqhQl22alw1pp6lhamhGklCLIOikUu0XrbqOrVppH/QnNeoql3amlX1pmAprmY6mUbDmmZ7mmiqrm6omaz5lubSLVcopndYphi7BJISV4Gnrtt5jWQIkJyYRhWHEbu2Zt8JZ+BWhoSKqigJao+roYEGqpPqf46iiK/IoSljnvMXiu4JUUZRXkAppFhqP03SBUnYBiRWHl/kZk6YhfE7JI0zpCK3pflULUPIqxF3sr/pqlwZo/7B6rICGabGKZmsiqy76wSBcgh+sKRwsKLJCZJy2FmtVUrW64wNcK4vMY86qA7eCkqH0rKEOKnEK6n0Up4n2YOJx20Ik6loqqii+D8A6rV6eIkPCa0Xyn8ccGl+i2xOeYqFR53bSJVk4hdYoxdXYQMEupnsu7MK2qK9BoFJNrPElzWJhrK3uZ8Z2aR6s3t7yLZX47ciKLOCyoSDIZMoqaMsy6GvWk3JQVeMyLlZNK7ViKDEGRox8AzuAg87y7M9ybucG7bcOrbkOhMqFwm+Rwm/5qUUxreU17esFjgkwIfPQ2HTG5SkChzLd6EpdjkrxK49CWu5uIaExmozSqAnyqP+8AawjIUcJfIraxh9roKrVMKBjXl2RyOrKzu2yxi3dfuA0amzdMlbH9m3fJoXg/qHLmmwiqG8isCmDLuUVwGnzTZXMRm5tQu52mBnkYkCnLUEZmIVQOUPmam41EDBZ9qzneuhvLkO5gi7MoaWgxlnpSvAqmEegAm0CS966ru5CPgzsejDUhgDsdrC4yOvUikiLSU6NTQ4QeAjw3ijt4g9Hck6+BpBD+qtSlG3yRs+SGocJlGOSnq0gHCyTdloRO+AD6mIZXpr6CtL15qQTd6/F0u0UT7GX7i026u34lq/5cvFroC/hXoLhuimavu+jCVvjOm79UiXkYhUGuPGDqUD/DkSBFvBBIUgCABdwHufmPMhDHxswAgOynRnq3kTwBKMVnv1x0SrwEbJr6z6nu4KwCJ8L1AKHkJYwvJnwAO4uGQUgdoYnb0xFjgIQv0YXKlZOyYjtXxImD1SAC/3GJN+uDcSy4ahqB3AHBRQxwwqIFJSkSr5CGDMxtASzMF/mCN3qr6rpFAPCYiEoYZJvFwtuyKLBsSJoMAPrajLzsSqS/KJxzGKoGuNvG7+xG2dABqhAHPuYq9TxHdvW2vDxO8AzH+dx5yLwHwuywfyWJugzBX+YPUNwfGhwu3JwBwdp1oBwwFoypLowRtZwVlQqq/SopnKhwG7kx+hrp8KbFyqF/+wuVqaaozl2WXHAnnxCKMIyKeyhwHC06POW5GH68i//8igAs0wT82VyL/hmbzJPsVJmMZUcqByQbGt4MdT89PjOLRMLgpu6qYJOc6aqajffrzfnb1TrbwbccjljdQecMzpHgRi0gR3YQSmQAlqcxdoQcF2A0gLTM+fSY1t36yCvtUCsgiH3AgOLLt04ZyM/rdN+8EAfNPMchyM1KlNUrehx5HgKYEoZhYfMm/1h6ncqGu3aH/Dy6M9dtEMrhbCFQFOrWEYmbNxxB9YYzxxMARfIsgW0EAshz290gSDwYi+GxkzTdEzPNjGrqcTC7faKb1OvHjWjL8ieaXDLhpWYpv8ZGPUexK36WtncKqWaJqviwiVrPZikWUDMhgAFtPEGXPeDcYAP2AannXM6ixcU9G9SgLUVmIVZ1AhkZOtZz3MBu7U/N3BEPYMtzPU+9vNaA/IiC0MGOzJb7vVKH3SqIHTzKC9VtXIIz/Lt5u5UhDIswiK9QVqmSoWNydv9ZaTvVrS+9i4XZvKOPk5SQGsI589H6/BnD8eDMngKlDSYlIBKf3DyPKAbmOQ1wHZKqkKO57gSy7Yw67RO4zQ2AmtPF/dvQzPUyIZRB/NMK3UiqEI2L2UvJ7VpliQYJ0ITSEABYAAP7C0bKAEHPFhRPFIwPsBmA2sDmkRHP8oS5AHUOR3/IxwWMALCrkBZWAlwAd/5zvoxPe+553alfdv3Vx6KfhOyPy6yQAS0QAsWJJO4kAZ2u2S3qi44dfKcZH/I/wUW52iepzp47XIqdy406clw6VUIZ2sNjXk516S4H2RCIEBoLD/oNmvArKu28oSwEsCBk1/DOth4aOg4jsM0bVvz9SJ3bnuvc2ux3yb7cINmks/G+xIu+0J7GCs1Z1xCta/k+/6ywcoqEFBADeyBCSyvaj5YSYZAa3GAILAyWVx37fVBAx6BpZkeYvWBUIyCm997ULyCKziTegcVMGTDMcSzzsIzWx9wn3PDvtCCVwr6txp8EFWwbyJ6onOUgP91wAb2/4FTNbor+Jd0pAt7etf2HP5ICBRmpIc3NqnoaKWPelCcnv7gcLFbhaq+wBV4uW+gCxA0KBFkjZdBgA/DbwoE4tDHuEqr9AtgASLY+DqsAy7Iwi7gOLALu20b+7EL+fhyi/sqe2lOCdd7/bPnuhibZmqIcRLLwisojbWMwjXIghCvQdi3aR8kJhEoJXa3lhIkgiOxgSq8gHKke+b0AQ+E9hZAggycekl+5KPAATGIgkp82h6QxCVA/hiojFJkgRrsex3XMTCE1TG48zvkrHsvcDUgfH/3pnDRQimYvsHLtwOXj16zLoBbfIEbuPLOb21SgOyeHmGfYkaWOKXfBKO1mP/Id8gmg+fwCv/wWs5ha+GK3TAI274DWIAQnMAPA4dmP/UD/Pw8lfQgpnYL9bDNW4KNXwMuOP2v7zht03QT47bVg73Hjm/Bom2wfv00z0Zz/3JSa4b2wgJABIIDRxCsV5f6DJQDR5WsV5TgSOmy6dJCNHsMormUqEaLEBWU7AnhAE7FDg84CBISQhCaDS9hmIEBIsQagnA8tsA4akyLI3v2+EiCkIeSV6rWHEFyRI8sU1naQGnjyZMrSYAkSRp2bNmyal/ffRX7FdgzbGfRClNLq5ZaamizufvqTm5cuuW6wX371i03tTuWwNgRQ8dgH4RlJFaMuLDgEowZh4js0UT/i8ohJGPWzKHCy84UJDxwMFpB6QKnUVfQbIJH66KsXb9wzaPFC48/XA8+ctt2bZ9KftP2OVwp79uth9um3Xt3Ud7Al/v2qXQ29aJjlID4DHp7CA2ST/QA0sOEhg4QOFv4LuKKFNgi4M8o/5j+d/us1XMecQXRrmvXcNllF4caKvCogzaiiBJIBJkkkAcTAirChNDIo0KL0Ohijgw1xLDDDTvsUCGF9thElpbiMDGSS2ARqMWBFKyIRAQRsomiCwUhZiNZEIkIuytEogANNwKRAaVAZhBykyNoapKmPTLcQwnbNAKqhp9EguKVPmJggqI+lkJCkFEoKaOKKtYwRQ81/8togw9TGCkEq6yq2eqYO8kai6y1SmmrlL3iCvSubKoZNK+0+AKUm9sMa/SwxSCdTFLH6LMsJ80282w77kQjzTTUCBiNgiZZs+zK6lqzTbbqdKOOuNhSvQ04JWItjtVZp0sVOd9WJc43WpurbkrsaPVINe9gE84C+DR0o4f1LCjhhSkQGeQFETSw74Ue3MM2W2nLy09c9Jblz791cCFQlQPZZXfBBuGdMMI5KLxwQxDxzfdeEUcksSBYBoLlxJJaLEgghhIpCcooVRFkTIU2GqiPRE7EqGESEQGiJomk2KAEJDMIoQ9GmKSBJo9aCkm2Fi66CAqdgvqhIhB8gIQgpf/GgGgTM85khCdXIDFzjC2h0qJNUYZRMytRSinLqzyBEYVPt56eqy5DD0VU0bcCc9RrShubVOyOLL0UU+84447T0EJDwFNQUXNg1FJXRc653OzGTW/hrAuWtiNkU24635BTbsrkfP1N8OmUi642VF1TYgw0JG9ttfZOmC89DQgS79poZ5jihWzRkwA9E9qTAgj5voVP3HEbiCAEJcA4F0Bi1DWQwAQZZHDieee18N5+hyfe+HoHKqiiHBPRkMWAURw44osMHlOQhFikKPvrj5KwxIuhlILLj7fIwOM8wJyJph+CVlkyoMaAkmVGCHvFDA5kQPGH2VuqKIkkGOQlnkD/YWiSWEKYCGiKYQCiTW6ygyOwUgqp0YIVFZRa1KRWNbFcDWt60ZowHPO1SIGNhCU02wnP9pFNsY2FbjONA+IGt1FpZjZ1OxXkWoUzXeXqbz0cnHB4lZPl2OpvsxIOdHZDOLz1LVUZGlaxLOAatFlAdhGQgAjIEzoskEc9EJBAAtzGNgh8SwjbEkEJskU6Klaxi6FRz7QS4Z//XAN3BFIXjd51PXnVi0LIO94fJeavjJgIRQaJA8II4pREJu9LO4HSgVhUMTbIQpLfS9jAdiaFoKmQBj4jQpOswBGdoOF9QXEZUB5jkpqJjwkcYOUlxoCbUUhpZEIjGhRwmUufAUIM/710kwPt8MBgSpCYoiDUMcFSqEJ1EJlxUZQIwwaZsVXKhJdJYabUtjbRsM2FMCzA274ptxlmBm883Fve/labYkHHhrfqDRJz80Pp+GRbOVEVD3N1nOtIjnJF6WcNPuPG16ExAhrowRREN4MLWECMp2Md6K4V0ddNlIrbMQEbEPGfddzujgbZUYLiJa+L+DGQJe3jhErKhggdhCEDa2kibWa9RRKEpcprCSUd1hCHTbKS/UnEv8b0kC0loQUweZAPaCIHUfZBJCzJEk9QKbP71ewHUrjfGqTwExl4DJYtGFostzAKPeAml7mEhFgb6Eu1qlWYjiAFMfVUjXfMY5nNtP9rV94STb2OcK/TRAwKsamphrKQm54SJ2gMO05y3pCx5xQiEwcHrNfEk1aqmmwQm/O45MjGiPdkVQ2v809/XoFy4cqPCU6ABWeJoKBYxMIg3ICtCLCRWoO4AukucAEsXuEEXZztb4FbOi+CDiPrMO6AMpHcSHp0Iw4LqUhTKjEI3YQgB3NDdZnqvXVZTCAUqwjF/ECwnA4sEDilhENcRIzx/tRizi3RLn4qsLNCckOxJMz1BDMm7JSINhpB2UhT2TEiCKJLpISDDWTQh4/wQEqSQ4pP1CQUpRzQrKZoIC7XuoQMh0EMdvjDA90qwWoYk2nq+MaJ48FMtIQQmnx18Qj/L2XNFK5Qm4TlJmE/401xmm6xyWJscD5buOHIs1bpzOw9ccXOXb3TI0jUZ+QUJzlaMfSiP71CZSpqAiCwYbXhMl0P3EAF8Sz0jfVkqHBPgDkyr9GKbR6uF8U4LVkoY6MD2p1yQepePUoXuifNbhy6O11BAwW9LOLegCAh3zjAghkCe4WOmFrHRxdM0ZfA3Xr1CN72UuTRP12QHuTABKXKxGcr3U38aBO/qKZiqgS2QUTGV6QNqLoPgJDfDiCyNyu4qoC4FFqbghnsNgz7DhnGQ7A7sYpiahDFG8SrCftaTRijUFkzprE2EYsSue0YNA3wTKdeqNgRNK6x+MRhkIs8/7jjPO6yhBPiylZWuJUpcTZSnnIFxv0C7IRHXKYd7jY1dNAxZysBbTN4wQuaLd2SObgQmK3p4Lw5HgBpF8YdB4/wzF49D/pgfuYzhCAEaJAzAiiJRoTP2CVphNiUQYZ0hXoblAr19gGnDlK0fJ1LyPI+hBIyb3TPE2RzUE8CCShAQf7kAIL45YTmXBLCzADokZu8r6gZosmsFSyyPFD4CCQH1hhEISVf22HsZA9mh9dqhwyrvcMgVnafmBZ3ubM42tB+sZEBizYVdsbbECesOAHPbe5YID3ZPo3cMNXOGyrenK4q57pjFe/EFStywJGnOpssZMmGFg204cBi06y68v/A+YsQT4B6tCXwz/l9uArXwBgnAJ/cvv7NDrd9m888qtBFQhl0VoZDEpHnjXMc5MU3/vH3wAiUN6zlCXJ5IIDeoEmkIhXTb1HvIA2LZDyCe75YkParP9+KHQX7P2duopnxfTUgGAUPUjoljkgMp7PalUG6SMd0InUlgCYDSweBlNZHJx7sCOKHEYRGKsYgmMrK7M6O7cRAKjaMw3oJD/CgERrh7ZQt7lqg7vzKMY6umjCFbM6m8K7NjbBtbbKJBEMjNfID8hrr3NLJ3MqpiBqvKAIniZrsyVwFcWYwVZSgn36Qt1ZjBg4qdVrPPAxqCuLgWbJlt8LrAhaAXAyqCKH/sPV0S3QWquG0kPQMyg98D7n8QOOGD/meS+TIUI9IbhQgLbuGb3sehPrOCxYWZBKiT74eJNE24REszSDi8Pr4sOXMD/y0T0fscCC4rwbMIChmgge2JMBmTRAwA9U8pqmC4iUwYAlIZpRyKOz2SxUAgYDAagHNTiogUNhM0QE3LJgaYZhWwQI5sAMj5QPLptpGULD6rgL6TvBSELFOMAIKz5sIIFTG6QWvpPFqEAbjibMYZRkBZ0pOjfKYg92Og9yoIwjLqPMsJ/dmYBC4UaFcjz3CbAnTqLVga3S+UbZqr6C4jATQcQv9ruAQbhuVIRfQBQzbUBDM8Pjy8QyTr+Qo/4nn/gzkzqp36HATXAEOe+cgow8SCjIP/0UQHRIhrS8PTQQiqe8P8dAijEXpmuAxQo0CJk47frCoaiIHLXHWPKIM+ggKaIYNP3HCcglYyO4BSfEUTTEV1erYhO3YltHufPIDc8ADy+aajoXwStAEKQADdjGbtI2wjBKx4gYlJCNZjrEjqoPxygmeGEezNKs5BMduHkfJEMec+IlysKltLGB1tMxzyOiMCMrh4hELMAcdwSgBFqAuwQj2Ckq3PuADgCt27jIKHwAv3eaiwswSfG9FwjDnFvMO2dAxn0sg46V3SkQN/3F7KNN3GpIi83Az55Ahoe8zg28YJJIiPdMgL/8SIVWTIPNgC4ggBrQDJq7u6hRLM7hDKZUyNjfAZJzEY7rmZKYjFMsKrMiOFBPwJnHSlzwMD5TzFWFxMT6QbzJjxj5i755yF7UNBVnoBJGybVCj4I6FB4mxB81JViILOo4DWIKI3V7jK/lGVXDlKn+QVmhsotaSHRmu9NxGMG1PA7CIHV0nMBFujPRyL8fNL38rLxUUAQQAAcaIBBDqoAbBP+wxDDehMTeOMu/wuRIyM2NO0v6xQ0WUM0XzDglyRIGm5wYSRedQQUTTRTMzIYhq77rDM2hUsLJJBcxnRz0jN5XyUriurBbQ13KpAdsOJx1Q7dTOOX8yMWRRKK8JM47/RVOOkheZEjttzHRIEJx4bCqtEhlP5RiFCD2HyLISRzqSKFZeZVf8poyE4H8mJzvskzXMEaLmkrXSEfVer8ymAAymYKGi8LfgAwtuIEEj4ANSa4uqMDD9kwRor6BuwA3C66AkFRfQBeOS66c0lUE0FUM9FF5GNFStZzFLVFRB80QdxFRLVUU/k0QHUiHzaEWhZEZ1UzdVA0dxlUc1RUdx1GRawAhCgAaMIEhhsuxOMRWZ8+ySNZiYtEmnLUoD6yh18UrVZpuydIVc6PC69EoqYzxxaCuLzIdi0LJiJcnW1PJ24wbRDTuq7Y0yhDzQiPZ0yw0swQ9SILiSEAuBy6Co/4AKvGW2JiD2xi0CAhMwV+AM2ACh/vRBw+xZbi9bwMwLSCuR6szOdoQbFzNjGTMzY7VESi5WV5RUX1REU5Vjw7BkGdJVW/U0VbZlF4QiQUrscONGc3UXdZVKc9NGiwomfIJYpcImjxXt2ArtlrRZfVJsiFKFpNQzrrNKsZRauzOgwKnvogU82JOxqPHxpGN14vM3zLNW8Ilx2hQZpeye0AY/yMWL9vMGBqILmBBgFw64vshBIxZAc6vhABMwPyD2bkBRFW4CqKhg97NR3dY/3aDicqH3MC5BNtX5RFZVTzQiPe1lIZdkT3VVMXchV5ZyXTRFOTdByIS9+mlpVTBXef91A3K2Znf1V4EUl6ZDAYFWJz3sSJVUSY32aIEUhcIzU2j2aX33Sh/gWrFVho6lVMA0sniFPKnDcJaDyXpDnYqDnoyshyDHGofFy/ST9KzwP73l9fBSQE8vYHPrQEcgCxvALvM2dn4r9hB1b70XfOGXik7PC8IwEyoODBnXcS/0ZBt3c1n1cSXXfwV4gAn4cw2Yc2E1+BQ4dIEudJvLLDejVlUXZ1G3gmlCR1UAg0FABUCABn5Uw6bjZ2E3aIlWSduO7l7MWXNXd6f0VnvXaX9XeJ82GGmYAMLTx5KRenPYiPTJq9IUiMbUOaTXOvIJBoOwstpjynLPCscM9lTvX9P/saDKF3ADNlH9lGDzdgJWAAyCoLfUd16xYG+xWHAbdD8L7vWccBfoEUAswRL0N39jBEZfFHTjWI4PuHJX9I4pIRbs2IAV8hISuI7jGI4jwvNqVHUlOHUlOIM3gIMzeFjzSYR3ku2CVtha7DmlaSihdUpJd1MmOIZBGVuBkQDUF/VogyqvlnrdTbLoid6KAnCELAdf5YfAtGybDEiah83GKAXAoFocVV4vIFK7UZfTspfZgASweLZGoF+9GLhO4Ab6cozv8gPOgIvxE4sbNH4L7gqua1volUKRa0XeWJBblo7JmUVdtoD1+GUDWZBXk5zJhEzWJXsoAQBns5Nr9nRT/7dXe3NnjWBYu8ZYTVF2246SLxmFbzdpqzNaPbkEHTqUZxg1AOCbtpU1cHhw6unxliwnLK+jP8uHMW9Na5mfDNkCrqB5/I17dRmM2KMcoThaVgCaARebBWACsGCLTkCM0xcwBSAwPeCnERUMqIAF3rdgo/AuJSAJYYu32KDi6mxxP4qezblDp9qczxk1rxpWTQGrt7qrDdKrv3oUAvmP4Rme4XAUsmeWSKk3PebzqFQ3FfmtX4KDA8sIXoLCfAJoadcmD5qaVFgET4iTO+MplbahlxKiZfhaBxNuEA8zcLidaFlXoqPewNU84S2ziMhWqpKf6HM0ROYKxuNzKgq47P+y9NLoPzNnpbP5fLOZL/syPCagp1nbqBmgYLWYCr6AqCEgfjXAjHd5BLwICw5BQPbhUg2E+tJ6kCnCQneEq8sarOtYq6UbrMUarBVyusn6IK06u90ZrSMpY3R2aWdTU2w1ZzEAAyT4bID1Vz3mnwFaoGuXr/s6oVdYSiPYvm91sF+4aesThqM2S42Shg9PbqrWoi86stGJUermedFzFn/Fydg0wuuNXfl7W3hrBNBWe9fIP5twWnrgBBiOtrXwAsIDUVegttM39jxgBTxgAqJwAn469qqwpqcAmRn0Lg+AlE3nA/p2CuJoHJ4646J6nJMbkM/auYscyT33IJmc+pr//Mmh/MmVnLvN+ciTGxFGoVp4QL95l6EpuEdj82wCIwTGfAmAFYSng63OLu2YNZNvV5oAe5PxG5/3W0sPe4KtFWqzdJRteFQKnJ7g0xihLN7YtLIyb4gmW4eJGLMrj8JNmcuyCMwQ4bbScQQidQpMQFD3g0gQFkGd+aaheX1P4AzO4MRT3AVugMVRvKdjzwvcoMVdDwIc9FHx0gJSK2FLwqkt9hLEmdcxwXG1G7mFfdiJPcrD2smNPdmV/ci12sjxSNhjBEHm2coAijtqEZ8bmUrp+q2jdL29HViH9QHZ3IQtOYX/ur5rsa39PL8Le7D7ewNu8ZNDWZzO90oZu3hr/8DA6RQGNwsHFc9bHYsYH0XXylb0pIDLtlw9TqBEUnvDDwqa1UjWIwAL5gwMHHWmGeBQg0CmEzR2buAMujia9ba2y7iMGWAFhiCmWYDFU332XBzHYf4CrkC1JhYxLa6Nf93XdV57ir3nfX7ZgR7Zm5w0mV3oe97ZkT7nL3R0KaA0pLJ3xVuCuR0m2jpKx/yfWzeX1EqSg83c3zzvrG2hZXOK3n2C492/ufMWqQic+pwzvDTfwXTJ4t5rAP5LB57gKedwJup8NUCoL3zDSaf2Ck4EbuDDDxRwMz7x4bdBgzk8YlrkSz7yWb22J4AFJnQQZg9+SR599+PKIKAH1Hgd9v9BcVek142c538+9aHc6KX8FbYC2Yk+6IfeXZLe0SLGPT4C3FiQBDuAvH1/R6ezre0a7E/ozEG4rB6Q3B0QoQee+esOWud8v6uzO+r87O8cog+LartNwIWxanWrnMhtlrc24Ome/O3+/O+eCOC0pOHM20iZNUw8c0L8CEe8xO92tr83fM/3tUMeID4wYCBgIEGDCBdo8HDjw4UJCyJKRCggQQMIERYg0MAmkRtYytatG8csk8lMm1JigsUylcuXMGO6kjmzJk2XM4cdi6lT56hXw37aHBrz0iVVqo4aXRqoC5ESEB5IRUC1qgEFUjlUoLChq1cQX8GKDUG2rNkWZ9H/qlW7BO2SJUaMtIAiBgpdMXbs0M2L146Mv4BhBB4cQ7AOw4gLF057dgPZriEch91KuULkyl4xZ+bKWXPnzxQuShhNWoLoixYqRNhKoIDrAg5GWw5hgkftGrht5+bx4kiL3nN97x5O/McOxcUJ+zCuG4mS5y0qk0ad2kSPKytu9CCx/QIEDeAjaBhxY0oPERHEXxjBnv3D9AkjfDjhMP38IWeGCIwf3yIDEQB6MAFEFF1koEUWXZDaeB+FtM4uzMiCUlE3UVihhUS5FNRQPnUoFFA8SagUUh65IYUQJkCQgVUsXgVbVp5tJplkjJWlFg9r5aiWEXC9tcFbdYlRFxR2/+BlV1/IHabkkokd16Ria9X42GyQVXbZZTLGiGWMoHXZpQNgxjYdVxex9tqLXJmFG1m4AWfbb8HByRxgcyan3G6D1fmCEmhAp5VqFtxmgRKCYHFFCgCuMMggLwwI33iD4HIIFg9poN4FQSyKxQgTwBfRBWeQscIH9TEwgQcuBCEgfwVKdOoK9AlUkAATsOfQgQlYxUEKXfixyzgjEdMSTBleaOyxG8oUFIg2MeuSLNAmhYggcABRQ2otuqittjB6WSWNUupIm7hsBQfFXHLZdZdeRAqZ13JMxvvkk+Ga5dhjW251pWaRpcZllv962xlpsYFZ2mj+SuDAmQWMBgKbbf++ICcPR0isxJtH6KmxnRzfyRufz5GVGg9YsIEFb4euBx6DJopg6acikMBpRhBEhMACJIABBhX0vWcQqQR6epELRYy6H6sTDVTrCbAGEcQJjgqNoFQSaNBFFwDGIcuDzIzjC0xfa1gshq8Ua1OyZ6PtLIgfviIiJdSeeBlWCmxr9wB4v9atwOCehSO5Of69VrriDnnkEkXe5fGdTtK7WL39Wgbut1PmC3DAl18u5sEKN0A1ZWUufKaYFkAMscRwuhXcxh3nluTizD03xhXQmVC6EkzbTjPNCl/ghxvmuWxpelX556pD6zHdg3cGNt98RaRG70GpSBtU0H1kBKF0qwn/lFaCCR1QBQRIECYzLE5jk82T2Dutzeyy77vf0h596j7VAQzfrT9WpWXed1rX0pHgADeXtrjFgOaii7qEtLjXwctxJYhSje7Vr7JQ0DOWw5wG+eYlznlJdHrTSllMcCMcKeE3JmydCh2YpzntCQ20AwLtdBeCi1BlNBGpmQUqFTNYeUdoNcthpeBDHio8jXnVa16tpke9pA2kIAYiVax+uLsgFu9mKLBBr1oStvN5UW0XAmPb5EdGtyEFEtX6gb/ClD/9BeCNcOTW3jojQsiNy0YCfBO55KI6IC0wSEKqi7wGScgISrAxlRuL5CJ3Lw1uKYMb5CBoPAia1hQAAG9M/xNtasNJ3sxlhYyLICiJI7uL8WAUiTgBDxRkAd6JJz2tBE8KZEaC7EzhBkjMIQmwcAYwrICK86GCE3bWkCRWhAHTS2ZCZpW0CRBtCEyL5gjgM6bvXQcOfliK+lzRRV+ErSZdXF+G4FdGlkTLKE2RAbbuR5U2xvGd8Kwb/8TkrQrWqFwtqEG59DhA1eVTgAtslwIJ2bgdGLCg+gQcvuxlz4c10nKQjKRE/Rc6Sn4JhK5xQHXyeZsR/E2frmvgmkb5z+PoCWQt2EMi6NcRNuguli/glAZ64AUWLG88KwADIn6JkVfu0ohQo5lBgqAIXLjhaElEVTJjlcQJBMEJT3MITf+nMM3vlEAK2EyEScyJki9+EZzoC2uz0gbGoJBTm+hEwwygcr/9uTOOmIxnmOY4o4dBDp/+LKHq+hmnA7blLXPZK0IH+8DXkStcFNwXjRabuYj677Ga658HRVMZMDGMTCMki5uIA5hOfo+FohwORzsmBD6hDDtXYMMegBBLC0wBETvFaQoGBB6FUGEQPKNteoboRAGMAAtOM1rQWIWqIehnekybXhKJh4AIYGFaqnWDIFbCEkuM6BVG4aL8xnq+cMZPnGYFEVKS8rur2U5h8kwv/twYVzhisr3vpFoG6nmlcOVVsPgtKcZ041e48HGgYiCsgAt62Ana1aF1XOREJaf/rwU7eGCl2ZxsEoZRApBOs6MNaWdDOVLk6DWhLGwODG2DhtWuBwvnsRSAGvKoFidABFOoaXd8dkwgdso+84necK13kVOhCgewCnITbXhMDVjHDYOwhJKVzFXsUhdsa/NuN2dyPu5+VycsMV9QVkrVEmjATPvLFlzf+N4yy/VzAgsXiAEnuAHy9aN/A6yc+1jYAQ+ywIg8cB0Z2dgGPxiyC46wwSRLYb29qHRqCrFySsroGHQyv8kp7QxTe0LajOAKKYNlb3P4HYVcIMgkaCXyHIUQob1KVUOGokGcClVbBfdWpnpVdGG7ZOs6Ga1kC6+yvhlWcpZ1fX2AgxS8jF4xp7uzna4ps7KXHd8byoa+d+UnpDHGaBzxM84FDOy0CVpnRkPuoQhu6Lcc+WeJlulLk/XeGhl24QwT5jahjbe7XcdR/GbMLRmTHQ8CxUqY/i7Uw+vt8MDzkB6a7Ii6dRRSB0IqhqwKade7VUFWkJ+n4ecMZ1gUrY/C5K1e96vlBKt2yRq/9uGkD2Z4CgXY6dZjw3XZypars/kGuX7yV9rX9jYBC2gXtQQEACH5BAQEAP8ALAAAAADgAQ4Bhx8NAyIPBC0kDy4XBzMZBjUaCDkiDDkqFjsyHDtEKjw3Iz8vIEclDEc0G0gdBUg5JUoqFE08L1JLNFQrFlcqDFcuGVg6JVhJNFktFlkzG1lEK1pZQ1ttUF1+YGAfAGQ2G2g7JGhWOmpEKmpLM2pcQ2phPmplSWtRLmtzVmuOa20xC22XcnGDXXM9JnRbQnR8YnVFJnVFKnVJK3VKM3VVO3Y7FndCG3d2WXeHaHiXd3lGKnlKNHlkSXlsU3pJKnpLNHpcQntRLnxTO3yfgHymg31SNH/BjYI+D4JONYNTNoRVOoVPNIVcQoZLKIZYN4ZZO4dlSIeYeIhsUoh8YoiGaIlIFIlIF4lWOYl1WYpVNYtTKYtZNYtaOotiPYtxTo6ifo+dgpHDmZJOF5JOJZKvj5RbOZReQZRlRJSTdZZtUZZ9YpdkOpdpR5eGaJhWKJiDXJlVG5l2Vpm+oZrIpZxtS5xyS51iLJ9hHqJaM6JtTKNcHaNdJqNuT6VrRKV0S6Z+Yqd5VqhhHqhpN6iUdapkKKqCXKqGZaqje6u9oqxxO62cg62zlLDDnLLNrLRrLLRtM7R8VbaOWLd6RreLZreniLh1ObiGWbjiu7tzLbuTbLuZdbujebx0NLyCSr3jwr6APsF5LsJ+UcN6NcN9RMONY8Sbc8V7OMV8OsWdgseKV8fYuciCOsiWaciadcijeMmnhcnKq8newcqGR8qTW8uDO86RS862lc+7otCHPdGqdNHivdHpytKKPdONU9Odc9PFltSMQ9SNStWSStWrhdXRr9aNRNaRRdabZ9e1itiRPtiWVtildtmka9qTRdyVSt2aU96ZTN6hWuGXS+KdYuObTeSdUuS+ouWeV+WjW+ahU+apXOegTuenZ+erdOiiTui2iOjdxej84unGl+q0d+q6j+ukVOulWu2oVu2qW+2rY+2yaO6wXe7v0u/SqfCmV/GtcfKqVvKtY/KtavOtWvWxXPWzY/a3a/bKlve7dPiyXfjkufm1Y/rHh/zDeP385/7AbQj/ANmsmfStoMGC9xK2u6dPX8KErPysmWiH4sQyZdxswaili5aPIIMkaRKyTB9JgvDgGWOlpRg3ghI9ilnp1CpZzp5l27bTW0+eQH+WG0rUndGi6ObRW8e0qdOmPZvlzJktKVFqWIUFw2VKFChTOkeN4tlLWrViZo1OM8u2bbW3cJHG1UkXml2pXHmhnYpV6LWic//GjSePsDnDiNMlJlzPnuPGhRk/doyvMr/L/fAVxsZZsWergnV+Hk269OfOnU3vfCZsFSZMMj81U3xNmeBThAjxWu2Wb++sfQML9x34qPHDkR0XxEeOX/PMmR0/46bOMebrmBNiv/6OGzPF475p/45M3XTkyvhMlrp8j5x75w/bOVTYPqJFihox6t8S8qPI/iSZ1EdKGrHkEk2PVCIJTnz55Fdwwcl12DkUWqXUUxjWwxRcxA1V1128dOVVVmP5FsxfatX223DCkXUXXnrhJVWELdaI4mKmXZjYYztORhl00dGmGmeDTWiheUmdhlpq5NHGmiw3OYLJJzdF4+RteujmIXBcrkhjaGBy+GWRRu74DnpoouedMt9Vl+Z2cF5mj3flobkZitwcVp5nhVWmhR/LPCTooO0Ues9C5Nh330QFctQRfwCSJGkWAhIIh4Et4ZHIgjgFQ5VdH4I6poMSVphkhjyqAxU2L4rqalYiiv/iqVijBBNKMbRSdZQ0t3pZ46utNhOjjKPaSGaZyB5p5rI/ZoZZZkheiaeRSypb7YRM8kmkVlG+RiUwtfCUpzKfOqIHJtCYI6av7P7abpjT8ukjj4JNU52bb8b5rDzYtDnvuNjmqae88mwBSC7iHDRofIImmhJ+FeWXn6MgWSHpxWPA9LBKbsDhEkw1aWXbg0GVPCq1ykKGqsqIBduhM1uJeKJNotTKq826ttvlui4b4/OweBXLs43JWhutZMmhCWRiRRMZL1HXqhv1tbTVAqVr3nJSpZUAa3UNN8Hsce7QO5dtLNlmE11mkyp+TXCzln3DD3PQiSewYuPdCSbVnw3/lEskgBSSC0ILG6odK4va0fHEHVMcaROZamrp4iDXRC5rTpOsOak6dr4Ujvc2FbqG2vTcoF1Y16zMKd7iPJbNHHqqM4QmcvuzjHu55a7QKBd9dJN9vsly05lL7de1cEXz4ZLQWO3VlDXfBAxd2lTPqsiKAeMxWKHN7v1bxALr695Pr0VNWfHee+Y4abbf3ciUdQcwvORbD2guXdigRSS5sFe4oLN4GH42wp8CaUFx/bGYSxYoNspdihAJqtXIpgUYUh2vVJ5j2eg2CDrW9IxIV3tNWUYhpa6EIldeMkvu2jWVGeHuduBKhguFRsPV9M5op0IS3Ow0JOOdzV2hUt6T/54HPdlNUEgiK0s6sEGLS50ic2b7Hu2AJsVipahGe1KfFjXDPvnhaTxXpB/ZJsGKUgSBAjZIxDgGxT7/PYQZElmDRiqSEQTCpD+KW6AeO9bA3ORGQZ06YvEsiEGk9KgxSgPSP0KXw8+Y7kXd4t4oxPaVXOVKRdJYIbtqFyy9AC2GVdRd/YxHPBy+rX04atoPg+hBr8HMas7jhNa2tqQ9PQknX6MGJ+CwB2csEW1RDCasZmgiYdYwLRRcWxaBZz636U2MZNNJLpbBDC2gURAIE9Q4urFG/32DFQJ0IOUMaMcDaoQQMIFgbGqyIJsEcoJvIeUFC2kUpO3jnnDrx7MWqf+qRl7pheDCyU1S14te7DJLJozZXsrC0EyiRZMr4iQMPwlRYI6vJ1MrpT+D9y+m3RCIrGwhLGE5UHYaQzRsq9pWArkWR4jBEfBkYTGDyZW2zNSYouze3sLou/I005nzsyiwkCEOZqzBBjboRP+0OU038iOAEIuYHe8gVTvQRBJYPaFYTljQWXnViKKqiqnmSc/O4bNZ2Fka8P4po5JmTUolculLTEgrsYTvlQslpkRbKENPUjRGOH2Z2uR5pBu+TYM9JKzyfCK+TtqupO4UxnSGRC6BsrQYgRCDKHSq19/ctDd93RlfGyvUDkFzam0zi0+7l0LxXWYZnRCEH47h1G7/MIObbjxGIiJGVcpVJDdrQFAnrHa5rhq3LV8FK6joydx6Suas+VRkdOa1lGBB6TUzkVIJQ+GOUJhrrnWNLCgd+ldhddaFj/XrQ+9K2iomM6OGLQ1ilQQa6rnokSIjaYhcEzJf4o2ZmITSV21zCidCUaYIxsVuRGvTBp/OvacdLGcjel45TXMZ+uSObW+Lj4RU5hixvU9MYtKJT8T2W7UobnGb2dUYulhkph1rc5V5SOnamIfVfVEspRSIHkOwZvIwqB5e4ojw1nW8AAVrkgGq4PJWlMGClfAgxRrfo+EQo7wx3c/0S4uBKliyh/0liQLaYvQdVBY+pPB5oRwiGSL3/7xrnumTZRpSeHkWvyJ7jr40ozwOb5Mbs0hFiU1M6KwKWHopXizmWEve5HrKZx2qEFkxaNYmQSa6qKRXK7uM3U7DdRonHDIc4CoWuor30UtOtVYm2mTzpprNUW7RlGddvNRc+dZZ/lB+YeniJjMIG/hKldTwetmt2EYYLtUSJuPs4AerMBldZra05YzqZ9+5vVF26CYd28U/L5MZdZmgistcUMsiecLogxkuGu3kdM24yqfJIMEWmWnogrDL+Ob0p0MtBs2689+xct16kexoR/uaFgSnaCbVHOtVThq+8JZnYyFtNU96mbjVix/bWjngcRl7GgYdNZgXDmWGd1LhcP+2dpyLoZcuKXmv057etWE+G4EJ8XJCJG6Zxz1uXp972STXdlvb3FcqQpywzo1H0jeDmErP60f/UhEMQ7jV7/rbyAEHhsBxpd4XGxxcFx941wEq9DU7/OFo/6hiXQVjJiM60RzsZ/ccba+z/DpsIgd6zGkuPb1Oe+Ysd/PeR4vXYhK82TC/xjHC3fPitr3toSo8xWnq9rG3XMbvVjroUqmjp9c7zR6UhSyhZ/UiY73Up+51q73O+oNH24WW97u0WSkmG5osKLSmsmKnrGvHHhruW3xm74ubp6sdexVD3qzeXRZ0mmu972RnL83Z/VlNwl7V1aZi2RPfNY57H/Lfl2j/wt3ZfJV3fezl0DxPZyxvz6UMuhoXNm8qa64s5UbUhLDr6VMf+GaI9/xg53qvN3kAGFrmx2x1FhTLk3a5V2u5hl+glBRR5zQr1iGLxzrTkycFtgdPtHzTR235Fn2yx15iJ4LbR4Jed4D9dwonSHgtdGAQCFh2N3BTVIKBZ1c2xYI6KA06GICuRw3H8V5ysRjtdyFVdmlP1zKhV38+liW8ZGqol1DJtV81dYMFGIKr10Kuh34u2IXVByyKtjlnl1rtlX0oJWz/9H0V2BoJAmar84QeOHgq9xXtVoJeWHkrZIYEaIU0yIONZgqCd4C1U22gp2V+BT59WIN2yIPkl4Pm/7eF3KN+QdgiRrh57ldY1pND+GRPoMGG2uUIHINQW3V6racXXZEXqweIqkiFB6dkkIhy2IdtkcdYCRhhtYdu1VcV/7VxjteFxxdB6UYIVaBsiLdyzTaANGiDKbhksbd9rYc7PTg9NsGIfghtbbGD11d4JQKDhrhuiLiI30gsYEczbQYUvRKNPviDmFhBZMJ5TYdruleEnTh6IvKJpndCt3I14VWKrEiO0LaK0TZ2WoiFWBiLBGhysnhMpdVeeLJBq4U5lVVw+ZVduMQawugIsxGHxShnXpGF2Nd/zOhX6AhtXAeSyjiNL+aHLEiNYFGNd5V9H1eIikh0q9GM4UhMr//XiApYja/YZGo3T+74jscBGlATjz3ECyUUcLHSK2ZRWf92julYdFv4j1Mpc8XVk8hokHf4hWA4hglJPcsUOswTfnp4XRB0IrUhC8knDUrnclvpgjIjlVnoZCeJkoBocTZ4Cvx4lwC3ktOoiiS3kslog21JNqN1iFJnki+nmAiHKwF3jOqVb30niZNoQUFJOpdYWFiWcZlIX6nTl6NYbuW2j1/Hh+PYl9GGkqAlmXRIdAY4UVP3VW/ZlV5pX2TISnRCMEryFsdGbhS3althLkU2HZW1B5pVd245m65EM2F3haXoVXeJl4fol9RnkjlZkjrInC0pIi1YmsWgeRP2iNP/uCWvdpPaCJBdgUwqiZ6oCAq7QZlhFCHyOJ/saJTwmT30CJqnx06A5HPeKZ3s+XPkxZpe5pHA+YwSCX5gGFO3eHYL2JBrxQ2MF5EH6p/Og06P4IatsZZitpHZOJDPc51VCaClCJDSWXYn2Z7oqJ3cSZ3PhqAwA4hKIZNcAiPTM2zleT4oF5fZ6WA9SYfpV5nFMZ/5UKSZKXH2iYmi1zr6SUR+pE654pvKCKABKaB4xWmukaUGGpswaqGVhXMPGqZiWi925ja5KT8P2XiP5Z9miVAaukvHqZEfKnkx6i1TSZAjGpUiaop+yXL/R6XRKJh/yaI9ypM3WCuIigvgSXnC/zKe7uByReeKJjmgfaWT6ymZ+AaklWgcNEKkmHmkW4J7lFYNnzmo/5ZdDdRvmqJ/CaqCXHdqUbYVrNiaW+piv0dmhyZospAKvJpiGIdz5mMvafoXi+eAXzMNyHoMeaKsdCKs5YGmy6qm/9mmw3lzcqV8coqCKkRCIqSieIqVCEcz7imS7Lmi6Uig2RmFgMmIO0h+ifqu2NiJsOZXFGKek6qjtaqnyGVxBPoVQMh0i9qpS6d5RvqpoPpw8zglIqmPRJQS/WYDVQAHm1JiAsZQvUinX4VyPCOXBfplIrVSxmdsIIuPJLurvVCszkodtrU+3cFNfSIPLtuszgqtMruyNv+brDIbrFJqbrbqGnfwhOhjPtcaGmUxp+L4sbHyqpiqj1t4aNqporNKoqkIri2qiulJmo7ZZKyqdc9nhLA2oEBYr666QnKJh3cJHOeaqf7qXEI6LUXYGAV7n5Jme0NYNXDFZZCFEpYCsRJbYpFQseJ2rG/WUInIFhXIGlSJroNpbp3CVfg4IJCQVZFrssfArC4rHsyxTdu0HOFhNyz7uS0bsy47ui7rrGzSc1/HuJ/gR5xwsoJrUBE7CiBXZlopO+IqKz54ikvbsfrprR3Lp1RLkFarlEmLKyyJFrWCndrptZTXamILqYiZuPkqvS/qu88DDEuHLXPBthkUt5KxqUT/KbDIIgpF1rOQ1RUjthJVALFWJRMDMrGBFLTEiqyCe5uBu4bSK5kDl7oCRbJ9wAd8AAkAHMCRCwm8WkaX6x7hwU0K4x4ObBDvcBB2A8GkK7o4u3jGNZotZr6yUGLCWQmJVi+9IIxiIAmXk7wwCY62Qr5FpLi8e75cUbwuzIpSC4m6O7ymSrz/CHB+6o8Kxqnz+nrw8Lwn91dVap08XL3W669CiaNF8rbDA75zC5RJgWwKC5wM+zzumxtigFQ2wEu9xUvCZWjGdSunO0H0m8Z2Fqkgu4xe965b8biSEMADXMdYZcCkwAqV6wvc5At8LMGAHMiCLMHDIB524wvJ+qUZ/8y4AXhdj/CEqRC4oOYxx0m7ZQlRwAAKSXnDnPzCMKzD3xqgu+vJPBwr7Hq1jtnJqkyjNcrGQ5xl1xe9JIrEVYq2mPoVuBwMQlmYy+VPUCzFmHcs6ECqj/B2WTx62ZUSdoBUKgCxkFMFC5QxvrUHySwJdEWyxrV42oysafp4XNW462VuGuy/dFzHA3zHkXvAfrzO7LzOhTzIgMzA8Ty6ybrHi9zGuerBfoRm80uso9DFcCBBhHvJ2afJgVBJODzDXkaopczJwBu8MTy8+6XK6Zp1Fc3Q0AS9jUnEGr1gRFeQHJwXAxm1uDwWz6Q3YfvK7we33uu1wSzMw4yBjEuP2f8FigRyB+urAlXwEQsEsdB8BB/DEtIszWKjzJIzsYYWyZejzYf7sambj8Ymx+Y81XngB1ZtwJYwCalARnnc1Xvsx90wDGId1i5byPJ8EGddEBXsxxjcqzvbwTMhcraRs9dgCgBdIummjExmLgid0KC80J/8bwqNilGbqXfq1zssw4SatWpbph29YBw90llZwwsbglmxxExcmGx7PL/8OcBsazBtDFcMsjUxek86OV58QDGBTg8L1K59BEMd27ItzXXUOGNcsY17v+BMbJZEzlRd1cAN3JBQCFld3Fzt1e48DGE91mLd3BJM1spNTWH9DdHdx9vcC6Rwz7oaW380Fmr/nMb/fAR6ILsqYsmM2cObzNAurKXqbb2jPNEUTdHwHd/qTbzcaUxDB9nkeZiuybHf6ruXvcQZqr1C6DudHV+cvUQxvGWpI5yZ9UePPAY20MwvxSklZtQZ89oaruEP2xI10BLPHNsPVNS3bbJq7M0D5tsDbAZ0ENwtLtwFbNxl1ArJ3dzD4AvMDd03juM4vuM83s7tvHjZXW5uratPWivfDd53feIj3XosXK46XBPsfb70/d5Wvt5VXt/2rcMJCSM3kdI7GcveSNmAmrTgo2Cc/BXDeSfIJLcrTZ9jRTqc/QwdGTOsUwnZ5YS8VGQRXgMfDkHDFWhQglV6m0cevuF+/34EiZ7oPw3iGd5vqjriJB5BXAumbWOxx8aroSDAv/3iLx44wz0Jot7VNO4LqIAKPX7jYp3qNr7jr8DONJ7HND4NQO7Hs3AMvXoruS56HVPMp4uztNFSkJ4K0RqOV6jmHanlga3szE6rWN7sz9fsW/6YYfWA6iadFlR+Xp7f/02l/nrmxIsJHMiWM6or3/vZK2Owce7SzFPn12UKcZ2qWVLMleAG6/vF+TdSJDXoW9zhiK7oi45Ur/3oegTplKzn3S3Q9zu/gUYKMd7pMG4Io05Gpd4KqH7qpo7qNp7q1ITx61zxx9AKeRwKqBAKtq7H2Z3rKn9C7hsKv57kEloJw/+uNwd6hT/G7Ogq7bcrM7777DmvnVg37UKfnjkT5gEuxK+cnFQpeGTu7UB6FhSdG9i7GQ2SKp7ty+/o5hoF9eNY2vGO8PTexUj1hJGAuoNOaOkbihkT4grkEpDD4QVv8JfyEvhnjyhMDWq8x9k93H/Q6aAu8bI+44Ff68tg8R0P8rA++DN+4yRv66Ew8iu/IIKWVbOw1MDeLzEP6cpK8+cdM9iV5aMM7agJ5T4/+jiv80opg9Z+9Bud7YwFe5M9w/6dy48a7bEi7mMTsOROXRmS9VGMeeu4RJF1u7jvhAmPCV0csTERwroGnYUmFgnyvuk7/Ubt7wwk71ki92AM6UX/rTVmXM++0NUFDAgA3PflHzhcTeOlsP4ir/gVjwqy/vEfH+usMPgmj8D3H/L1D/mCBhCpJAmUVFBWqlTHZik7No1bw2vYmCkkVKWKm1TvNEasFsxjMV4gm4k0hckRJlO4TskCttJlylUvY9KSecrUKJw5cfKSydNnTZozgQYdWhMnTJ1AYS4V1dRmzEohnXnbRq0qNKwjpY0MGTQZ1WxXrY51VtZnsq9ouxIVuhbYT1Bxm7m7Fuzo05KB9DhyNi+euY5lr8Xbh8+wvX2J062rR5gxOsd+I+eLfE4bYMiZMQN2ZvOtzUqiHu3RU5r0SZy9HIk5IiZQ1GdYxWbVqrbW/23ct1nu5o0QoaxRo0vDIV6c0GnkpIeTFtPcokXTqCVFslQd0nVIfABt1w5p0vdM4VmNJ0+qlfjz6dWXYt/efXnz58n7oh/qvH1S+fOH4o/dIPBOfGuIGwKjMTAaWe6AThZ78OmmQLM+0go0TmB666OiMkytFw57kUaZD4URUcKWlFLpRA1TxOulpJiiMLi2ZgoJLNpqXCumrywLa8dqyOJqFanUYmtIt+ACpRiO+LurKUxIM6WavziaCrIGD/sHscbU0XIxLrNUrLLNdOQyM27swjA00ZTbA49HQuMwONbgcATIAw2kKisfb4MGN8E6/KhDEEcE8ag2OSnU0Jucov+wUOGGcw464wQRxA9JuLP0D/DGE2/TTPNTTz/4QiWvFP06JQU/+uSb79TrCmrV1U4CnKWhAbWZSJlO4LDBBowOg9CsCIFrCpiy/IyQTxJJ3IqjAh2Sh0Bo0+FIyhCTlYo3ALHVScmkuvW2JEmMQrMnY2SbjbYbccmRxx7z/OlHImMsUqW4RpGGrq2WBMWR0vgikLNl/bLySiy39HKyLyUTM8wxr6HJI6hCa3SPCkf5DRQ9oMOEWHNp9NHjWvCUbeTYSq6TWkGLDdRDlTs8al9+HW2OuDHccGONRPLQuTtAvvuUU/CCFjq/oYsO+g9IkL7uD6RRQSW+VlL1Zb9XXfX/g1JZF6L1VlxZs0iSXMYRmxuUzXpKmIigfdAhttt2m21z1NZobroffJawu+uONsprFAIRxGkYenvalj3q8EMluf02NW0f7tjGeXmpCht23fVKyCFBifdGp+6NRxolEzVJLz1EabZdq+Kxsh/W+ylYnoMLTlizcignk0toLFw0Zif5w1WUjF3beCo7daRxXY+T5/F0humatnZmA39b2rpW3o1Jfo+z+eartesO0/bCA88STI+eRGmj0wdPae3Y2Jlp/lSNOtX8rru6Ukr7wLq6hLZmppZEVGFXPhAEK8bBj42gLitnc5bYHKQ3uc3NWQTS24MsuDa5RZBuvmrQ2DaI/w9yfAOEIPxGCT34rI1AkEPS+1sLAWW9IJHFKrXBHJDQorxqwUtdOhRKveSFIgu543O9eBmjSgOKwUiPLOaoUuucyEHYyW52tNvMmMwEMUSlqV846cgpAjEzToQMLOsYIw6VR6OFKUyNa2RjZNzoGOoRbkRvgdV1+PO98JzHfIbg43f4mDSmBbKPg+zj+QpBvuoUYjtn4MITHGmGM2xHkK1w2nhUZZ2rKTIROdtfJyLBChDdyg672pUWJCG2cfyqZHNsyAUtuDWH+K4XbQMURGbJNoWQQnBv84VDXDm3EoYwmMIkZjGNeUxkmlCEy1zdA1EYw3PRMF3IUyA14CWKHf+mS3Ob8wotkiE6IU7DHXZR1En65Tl8CQYbAnti66zUxHdOEXpxaxiOyImoiT0iFLOEk2tSsiPGeIOMxjuj8i5jmccorDGSid0bHdql21VxMREpi29YtbRSle+PhTCEJAGZtPPlJ5DY4ShJE+nROKSBkTJg6Qx24Eg+pEGQ3jHVRfHHye7VIWu06kQTaqCCGgR1Dccw4elcuLLxvClW2UocTrjVJknhQapsmtQj9Kc/V5FUQOOBpQWHSQ5+hPUeYx0rMct6D7CSNYRoFaZa00pWuMI1rfwgh1Y+Jk0dQrOaZnOKNmPkwxNxjoGA0VebSDcK5+0VMu10Z8GaKcU40hP/jtVYyWfwybs57VMZwLuI5JI4UNAWtKAIhYdCKdPG06I2oaql4mZKNotQlEqPM+1ZSSXZ0aUhjX20vRRKu5CEH7BUBCAY7gheygTkpkE7uEXkJFhx0k1Gt6pYmw5B4KACClBABdttgiQM6MqH/O9No7HD9mhWszE0B701a016j/Be+MY3qD+db1Ct0AT81kyqZbhqH1qFkPH0chkDftA3HjSMryY4mQuea1gbLExg5QmvRTKjNf0qWG4C0TOeiVJhzVm6JFK0T8/Qhjr+wdgOaumxVuKb7V53xYgZ9jivQazD9mARTlDjX60l6GgFulp6BNmhqR0ya2nHRtqZbBrH/xhGJXU70t4q0rYe/ehtbau0KbOhCDMYrgVA4OUvE9elyGWCcpe7HUuMpzp+wGkd6rBJN9+vIIKwAnax6wHtbiESyxAbgRsC29F4jZRABepPCw1foCKa0NtltAe26wFIR1rSjq7vfdurhZrxd1L9zal/69gfSPiGiPUD1dZW6D/6TORBvnjlMWq0rAhzpYY3VCxft3nhW3dTw998Sjg9zLu+JFaBaFvHidtpMHjGEzESheOFLCuxGc+JZaZoDl8c0rwyElTbaQQykVnrbSELubRC5PG4nTdPh0ytFbnVrZVxG2WUttukVeaoSk8gAg1YIAP7fkC/9Q1mFwQcCmbOZP/Q7JeINbCBkzjr3nUE4VMKQNoBE1eBnksFiURorwqM3i4pW2OF984MvXpIrx6mGm1+2UzRKpC0AyTN6PrWoAlWaIEPdHBz/C4hv0gYg857/nOd+9xmQi+DG5awPTxAsgxFXwNVGR5drOb01TSUtVp47U1qksyyl4uX5raZ63ddnW9LKtRhhc0jEUWj2K0Lq+uQHcVkFywiDEXMM+gkLETNeC8W41BFKEbidR5022OkR7ZDa27Efxvc4RZ34h1PF3PPsz4k5U4c1OBuKcNb84S07RmCgO98Z8DfFYBAA/wdgQiAIOBdYH2cOfod8l0t4XWY/VWz+nCJT3ziH2jCFhj/CVwbcLzQkKLquBbH9302VRJWnWrNfupoSLNc+B2nflBrfv2axzyoPvUpzY/Q/e5/vwXvlTn4SYnfm4Pc5vdFL363EusJW/0sS1ylrbH+GV3n/2HezHVKxr4omDmie7GdylE7ZjC2tnOm24E7yOqSZTMGlhARejGJJjmNUKgL4CmduZg7bOM20tKRx3u8xVO8ECS3waMnykm3UBipOIC3lGpBzestdxOaOOgCGfg3C+g309vBCejB0osA4xICGnCCgaMDNPuORWKD2VvCq8qOPDiDFoi4SHOA7FKBD7AzjrMIO9ikT+hCY3khanmeuqgepVIS/dmvnwO5I6i+6fsA/+sbP+2LQ/uSQzoctDqUuZsbA7zKIatDF72SoZFYEXXZNSL5OnqBi5VwDNBxEcyaknlCHcBpogTcEsnCm9cZE0u0B21AlhirwL9zmOx5knZ5RA8cN8YzxW5zvBE0shKEPFfkMYdABV9YQcyjrRe8RRj0nlu8rUwRnxo8gRwkPR0cRggwgAMwxn4zriBYxtajMj9QQkZawoTjtCdsgQ/4gCrEMymMOPvSAkLwwpAZkegRw1EcQ1jrERbyE9/gD0nog6hCLzU0NDYstOq7QzkktO2DQ3vUPqrrx65AkryyK7JYC7AzkoJ0kaWgl7mQh3EiOxnbO3JUoBIzMcY6qL2BKP+MxBK7k5AYI5052RNOIA5R7JFtC8HGa8WTRMVTXMmURMnWGpPwir1avLxcrDxdtEk6MEJeDI9KigMecIERCMZ/I0YBKEpjXIAcBMrgWsYz0EknbMpoZL2lk0adSTgnsLkagIGgcsPtawI3EARJMByJHEuypL9oOhal0onlq4RN2p4xIL+f0q7pm8t5nEtDo0OY6zg5tCYLA5Ybqrr3CyypOEfMOUgLeRfBFB0XKQbcwSKcoMDTGMmIrBOKTEAHuRWLxEgHjKKUebYmEUkJPI5HCIZy/MAfU0WV9AuXTM1VbMnVXKPFWLXnYpoza8GNwkWcdDOV2k3eVC7LGyQmoIH/gBPKBii9A0CA4zRKAygACNA3l1rKIGgk98mpqJxKq0w4qHSzNdiCLEC/9cM0/iqIVACcySzLc5yh8+RDa9EWM2Q+N3gUAQoqupxP+hS+SMsuueQ4fuxHaYqhgBSMq0CLuAA73SHQzFGUIGLIfCkiw9oiciQorCixY6NEAtyxBXxAWYgN/PuE0YGDQFiFsuCE1yCWBzXN0mpN12RNFV3RFC1BmJTNSXBCmrSyyrtF3bRRqIQCKGgkMgMCMrM34zIu1BtG5EzOAThSY4QAEWipZbQ5J6i9qlRCHp1K6YzKOJNS8GS4gTi18jTPvUpP9QwSkMCWPwEOglhLqFoTt1zT/5mzNLisAYuQrzcVvvzEx0Pblb7kT/n7TwCtCrXwId0BondBSARNUHyhF+zBLFFwRIASPLCQ0Cei0MxkNs5kCQ3lCQ71xA/tDJOgBQ48MtVkxdckQXAbVXg4zYiCFnWznxm1TXnD0d5UqTJbKS5rgRGoOSEUgi4bgQsIyiFdAGA9xqJE0gIwRg24NyY9gSTgAijNye2c0qVj1uuMsz7YzqoSNYioUOhBo9lIp7sCU760FrRcT6XKFlhZvnN1RzYTBDU5OdGMKqdjOpVTr/cUgza1ND11BjHd10H8w64A1EANWA1TTMVkTAUtBodUk8wq0YMymcpkHY2ExUo82FXCu/9GGZ5hgRJzQDIWNVWORdEWZUkgW8BuOIapYVUra1VYvVH38YLfQ65aDbPrC7Ok5NVfDVajJNYBQMpbFYEBYikibFYqhdZpzclnxJqFACUlI8DS7FZw/VaoVYvAFAmqJVdt0Q2DCMtsAZAX6ZbEWUcACY2CYMuMK687sJl8rbq/5FPB+FNAvTBBZYtCTZRwCgy8OAlFJc3lcVTlMYzGwkhKdYy3MBAIxFRDOaxAxAXAA9WObdyP9VjHdc0xmRt1q1GavLzLXdnd3FFH6txcjVkc5LdkDAEJuFlhHdYjDQCeHS4b8NnWjU6hhVailUrtHAi/ORmmbVqxcNqn5d33+93/qe1HcXW2OTIcMiXTfbraYvjC4s0Ni3WTtPXPqc0m4P3XAU3MecmQuUWsv1hQxdQ7QuALk2nU3HVYv73EyHIxRQRRypHAiEHcC6kdzQjVyA1ZyJVcke3Y2HylU7HcP4DBy43VNPACl31ZJ8hVpQTKLtM3YdxBILwA1MNZo0Rd5nRO1oWBJn3SloXGZ5Vd36NdrEpa8izAbTi7sfBdb60wqAVeFoacqu1MYykcGRZLlikW/izefY3eHJa/weSh6x3EgCVUgi1YRURYpsDbaPPUkpknbSMZtWuig0FB9VVQJb5UqIgZlIjAsJhf/K1f+yXVEz0tVK1fFOqGZVAImbwt/8vbDlgtYFn9LQSO4x0YAaAEsxwsxh28gA2A4AhQAGClYGI1vWMtLgxmyg3m4CldVu6s0mlMs9stHt2NZBQ+4VN12rNs4ae14RHTuvrb5EzGZLsKlHLR4RfWU/8kSIDdUHVRke3lXrpwzJL4ML34yLQjRXSrkymJp8liFjgCDsDTDZowFA8NIy3ODPwF2cc1wftFZvzdEhiVyZlSA5rEAgKuZh09A5fVUTkWTi4LQqX8MiJFvQ3YgJudYCQ9zubMN58lZNjNUWzm0QNmxgOm3YSz3fF9HBIewN3dZ33m5xK+F981yxVuW07GZ4P+5LWtXqmNXlL+x6o7UHGB6Lkt1P8iXhEZQ7lRjlBY7OR00GXN0Ngu2cgUBGYOnTEgsVQupt/8bc1lPmZv+0CXtodXYoU/ctXLC6Q2dmNt/twto4FuXtKACwE6zrdhRL0RGOdyXs6cLb19u+Cf1YLWQ+R4Bi5FDlppXQN7vmeBlmR/NuFz82ofU2EnhuSw9lIJa4ZwFUiFNmXpfegXDuYBndsSiWgmAVgErejdMSfRxCZgmdQkG9/zjVhebjY6CQuIgYpZ3g1H9GKXvl+TXOnIdeYBEylBwmk2tlEdzeZr5mbO5mYhDVJwvuPTo2Ny7mMJRuejNL1d/dl2lmqqzuB5tupEQIgRxmex7mp8AWv51Viu3lb/W2aX3wZu0fpkUJ66hmZrGuqhiS5UuV1uwKrbuRYdfsFiYvYIaNhtHqu/emCxeQBuvJEWX26Xw64ELFbsjRVVZnZsxl5vFTPjyuU8QAhga5bVa+bczvZsIdU31MNBBx7SpF5q4+Q3DRgg123t6nxt2IZq2g0QMdJqHzPhfp4cSy7h4PZtw7Nw8q3wE5RwCC9uhCblreDhIBnYIRbiEl9u0uywX8vbKn5FhhGx6+bu0vwSM4FEix3mE+FtMIbslu7Y9E7NMh6w2RqkNngDXJxvNpACJe/Rbf7pWxVKHNSA/ibS0w1kps6AQW7dp47qqMxgeY5ta6WUFXJw4X7Ffd7d/xQ2cwrH8NP8sQvfcA3Ptq4WaOJGa+RO6N/dIR8+cX1pbudOSHIjIoKFzPBFDfOW34224RSLI3TMm3IIb/E23CbJrAwNvJRWrdQK4x5P71KF7CzRCAMT8kzoo8s+ciU/9SVnch9d9aAW6qGOctEO59MW1uIMcDBzagymZyl1Ai1wUl8Hc2aVlLAkc+XRbQ4/9rH4ahdPvDdf81KMczY36zrHc8CUtcAMUwz7c0HU9kLVZ0E/YiTG22Gx7tQB3Ma0btghGzHEEroobDKU9PCFdPRm6U33dHsX2TIeh2EQdT+Kg44y9d7caVZv8gT21VjfQXQOVmAtVqVOeNPD8iVlqf8PYF1l1XVH8k5M04KqvmpJmW1ih/avPnZld3Y1jzwTHeNn59ton/OBnnYQF/F+lWhuLydwqWvFDAXYqYsVD/dxX95Gb6P2FQZ14e0ZZ8hxwiYpOZPDzeLr3vEvrvd7J+MU23d+H3UjB3glH+BUH/j7vm+DZ2CEL9IFOEoKTlJbn3hC3vIkz9F4trlfB3ZrhY0yJ0k5b3ZjX3bIxe6TZ/NKHm5KpvOB9gYdDl63LlA+P3yUsPksWvwLPNQhDndx56KAMfc4ksBaXmJlpqx/inTD3esUV+bHpXeoX+mXvvep33dK0gRfVCSs31yuD7iXCuo5hn3QHkoeNL0iNUaGB1b/Bqj14rRg0Fb71oPjLWtSJwX2q4YNbS15N2f+5rd7vDd56M98kK/7SQZ8MBXxUib87CXxm2iTmh90ClT8WEYNuoW8x0diqTJ/kRjAIosjx6G/yeJUgN4TINYiffKcv9h/pwcIeAIHEiw4zyC9hArzMRzYcKHDiAghHqxn7924b92QDWvl6uMgQ4XexPFS0qSUNClVSgHicgcNFy5lzqQpM0TMGSRmRLDg00KDoEIPEDVgAALSpBB+jmgqIsZTG0+DFHHS5SrWJFR9cKWq1SqXsGu42LGTKNWzbOXWojvnbe1bd3EFzq1Lt65duXr33jXYFy7gwILjEi5M7TBiaYqp/8lN7HjxNsiLk1FuxqvY5cyZLW/urJmXKdCmRo/mZNo06dSlRbFG7cg1atbX3E1zF0r169y58eQOHex32ngWhwsfjg0aZt/CmiF2F6/xKNnXlC1PfgqUIz16OAVz/rwi+PATx4svbz7iQ4rp1ZPHmPHbt4/yQxoqmeakl5UtoTDpL8RmTTXBdBOBIIigwU9CKahUUBM4WEFPLTg1gwwUTkUVVllp1ZVXXz0Bllhu2NFJNCVqY85ghuX1F19+tfjiijDKmKKKbz0mWXONRYbjZJhVxpllzP0IpGigiIaLaknGpiRsSzY5Wi963ZaablX2NoozwD2TDnH7dNlWMLSsIv8mZovtVU10xSgzXZayuHlddoGcIo058nj33XnskddeeOuR5+eeFMnzXnyTGKIJoiLVZx+jWLDE30sA+hfggP+9NCGCP2WwaYMPePpTT025UOkPW1XolYZObHhqhyBmuMWIJqI464ws1lhYrQXltSuNvd565o47AqsjncUG6xmyROLyGZliKombk9A+eSWU0EW32iNW9lYJMIoB19ZF9ngZrrjmWDbmZocRO5pkYY45mnZyzobnnXnqGai9gOq7r0LjXZTROMuIBIghgyS66H34sbRfpJLSVOnDAlp4YKaaMjWCgSLEFOClplYFIlhFcNhEqx++ugaJstI6rK0tx+j/cq42/urrzMQypuOwN28D7I/JLuvjz6AhuayzQz8b7ZOtIZ3aXlOWpm22hOSGJXWyMIfOoOOS+xw1R/5sbDVdS8em1UPHaSSKdtabr0D8so2nn27fG+hF8bECiH0ihVRSo/kxCinEM01KaU6W0mDhCBo85VTGOHHc36T+IeHxxyZ/uGrJrqoKa8qCxVxzyy6KzivoNAcG9nSz4ZzzsMoC3XOzvhld9NFLYwIK7rcrnfRooaTu9NNQS42aMNOVjU1xXZZ7nNBkQhM22aBQHbYx7sKrnSnT0bv92/jK/f3c4VeET0a+WOLHwnGI1AZJjvL9PsMOcyyhgIRjqtOo8kMK//n+k1eVueVENrLKBXBznWuL5wAzOnwtsFa4eqADYba6namughZknTuY5RnX0W52R8OW7Xa3tFH4LnogFB7xyNadOmlNXONCUTLeJabnQa8Yo+kWm9okJkzEqxjFWRv32OY98BGxe+D5l/nqQAeV8AAK6jME+9zHKPtASn+SCtx/DDehjQkucv1hmBeVkCoCqkqArPJQAbPghgMmsIG6YqAETfcyz8URgzOiE898Vj0OdvA6SrqWKbIVwhMuzXfWCl7UBFkl1pAwFNVxhlqUJ4/hREaGyQiW2EwRpcMA51pnwyMQX2SvP72tiOKTyBGROIk6oORwUmgfLOHnqCo+rv+LMylVpLKIuBG45Iv7oyV/9mcGL14lZJsroxk9ZsxjomwWsnIjNKPZwNJFMJqpo+Dn8rhB2DWvj378prROg7RHfFA1YAPkbhTJm9cMjzXTeOcj1yLJcp0LXY7xIyQng87tACOUojQie0wZ0FOicj2qzBsPaOA3WI5ElsBsIkRtiYTIafFwFPoPE/bzS8DxL5hO7GhYjolGypGxclroQqxMNEdpslRXpKNmzNzSRjuyDJvbaFbQ+OhNQIKTnIo0zWvKGc5vGgudUEvkldaUlnhyaWv07OY9NSmXXkijW4AMxHbopDZ/AtQ8Ao3bQLtqEfItIxMjKUR9XGISRb2hoX//i19EIxpGimpRVBlNiS/p2lGPnqGvZwjpMjHHIZGWjI0yPawo59JSF610posliE1p6isd6dE6wNjpKXgKTkLWzqcjnNM1jYrCR6yTNZuk3nJu1kIXZsMYOM0nPqvapnrGCRfyDKJzcivWsA70H2A1JXogUreOGOpQmfBCEJxInyhSkZZcjOtc9ZpFp+zVuTHhwkb549dhQo6wlOsKMj1UlTU+87HmbWw1z4vNO7IXk5XF7GY7y7toaTZJOPLkaH/KyNkcJ0upZaHyylFP5132dr/B0mULDAqsok1tuBXib4no23xMeMIG/apBAeaRTEwiE64wRDAP1r6UaDShOQEQ/xirK127ejGXGIUcd83QV+3GOLzfLen/vmJYxP7zvC59Kel8zDrF1LSNMrupHr0p1G/CRjeD5ER9iSqXUEwpv6/hDSMNCSamDseFXINqVVsDSRta53pz4qrcghvhNUe4wl7G8LjeQ1wOg0R9INHEovIDqYgeyHF77kF2VfxLtba4l4bmH0u2S2Mbe2ywOfZQSk8ERyG/sY6U5nE223us1wJNhu9SmlCBusigzveDoFSMaFFY2tHMC0XIqUX13hLgMBN4h3OiKpb2CQpIPli34EKgV1uoPC+pJz0WJvY/jk1hOC9bOO7pSCk8XApXDIMj1X6FJgahsJaQmAYZYIDi4v9KYr6qOMX8syW5faloGW+3VI5O5qM7RDItpGwd9kbsKC+NXn1jOtOa9ganmzetUjdp1J89+CnWhcjRthNLXELgI4uHNeKYy12aMcXwdGhDPzJYq732NbDLg2xhE/vCw2bIPnyb7JULm7fFXu03hpEL+Uy72tbGNp775igeiIABRzkBdMed7nG/1dyChrGMHwUFNjA9LKx6d7zlrQV6m+jek746NPfN7wtOsMgsax4wYP1pJw284EjdFjmhNYq0M7LtqSlqII+qreE18uEqjHUkf+itzFp1wfzMNU/llD0W9rjwqXwzyb90cmSzXNmKV7PJWxjzmdPc5rawRUdQoQn/NSRMDZxviQV8bgANQPdRL/YoSuCXbrVyO91Mv8+608AFUz39xo2eer2tjvXdX5r3CqymY4f1JjcpuBJlP/7ZreR2dLYmypk9dXSOKgoU9o4bxenvHmEdF4vk8PlhOhsJw38t7I2igkYMeeQTn/5mM77xI3d5+sM1eZr7otrkwHzm8QzF9cWB5982igUEnZ5lV+oljNIF2kp4VEbBXuz9VTLV3gBxyKlQne5dXXr4Xu+11L4F31/Amti5iWeJk/GZ3U8ln/IdHNuZkzSU0G2YYAlWyR70jpo83EEsVbrk3d31wigQAvndxj4RgsMZ3hChnPo9nhESofuVnL3BX+TJ/5+1LQMU2t/93Vwp0AdbeRsEGMXPxU+JESBKFCBeKWAwtYSiMWAavF6NPaDtSSCrUGAFWiAG+tgFshQE+Zut1EIqDF8nJMIj8OEL+qFpAOLcQY0IQVlsOF/vOFz0yd0L4oHgkdDNTJKrEQkNcc3eHRhWbYcPZlbcZZUQolmfFCHF0aDiHVsSRl6wNaF7xJzNSaE13BzO7Z9IpAEWIkUBHADpmZgQPJQYgqFfHSABskF/JJ0Zchd/5FirqCEbooozSRrvAVccQli/yZEdKlYudIMyzEIeSoIf9qE3/uEIJp/UyF0hBhIILV8JXcMikmMJbocMXoMk1uCr3aA8/oa7xP8JORkV9gSHM7LFypzHr80T4qWiQqhcQpwis2WYnL2CFJKDQ+LftUUbWo2EF3TBCWSADOAEgjSAxmCUGEIU6unHGTJgL4akExkgSabRRYkMMj4dDEDgFpQX5BFUNA7hvtAhB+akN7RDO9yD3UgCDwqCUHrjUILj2Y0jHqzTCwbPH6EjC8YdI1qJO4bfvMRjJdFjPX7fHmxlPnoSVxYDNoTlNP7jr5Xl4g1kEFlEKKYcQprlWa5llxCKtSEDOViDNTzkMDCk5s3iSQhBU5iEtkHBRYHkR/Zi+ghdSfKV7I0kA6qkRSkj4tTeLnZBM74hE9qky1mgvliaZP3ej73FOIj/A0/25DcwAyl0Ajd+oyCCY1C2Jnas2vRFX2w8giS0XQq+ozSMhpVJZVBBYlVaYoJtBvKIZZjxYLykoCPCAdrkJPqh31vWg9V9HCmKIlw+5zx1g1w6pF3e5StGpFmNhBJV5FXEgcFkW3184Z91AWGyXksAYxcSpuvNWBgh42O6ZIW8JH5iSBdkgjNa5mUyG2ZuJk4Cn1tURF5YQiQ40zJ8wz3oA2kuwzGkAjcWpWqqpmsSYggWnAi9nZqsIzuKWna8Rm7e2m+CCdHYEwKxid9t5fAkkhh4olqMpRBapzq4pY2mUkEqYXX+0BEqD6Fo53be5RRyRCkgTAGqTyZQwiaI/xgwyhV8dmHrXcWTLtqiidESKIEQMJq7Wch9dumFnAoQdEEkxGh0/qeZphmbQZ41EWjhxYUf4M2bQgIr+AJ8WANPOqQvRKgPUqjxDeUeqJNRiiDZLd+1VBJ2WNn0JRIQ+qDVRCJwWpLOsMkj3IFxcqWLEsK3iCVz3iha9tp0wo1wLQSP9iiNqgOh2Kk4pOp2DqkrmFUckIRJPJEhdBi2LVdz/dnjJGZhCo4YzmdLrmRkeqmXngBVNFGCVt2ZpqmyLquAZuA0VloevGmcTmsoSGE7COk0SKgkTKiF8kZRgsI6hUK24Nfx2ZdX7iYMSs+I3tr1nYjYCU010MozrEKlbv+lUm6lGDxCdyyVpsroP9boEh5hc0InwX5qsupoqQJMnapqXQrpXRLXq5JEHbSVhw1CeVrhH9xqr55eL+2quDXRc/nqrx7O4pTssEIFsSZXF7zBsTJDfx4ssyZkmjlrA0lrtPIBzuYsJFBZKNApOdyDkJZmHpKWt/6pUYrr2iFf7jAJupZgaU2H9/2mN7zrmDxPnUBtvYpItuABHLyovkIPmW6qPwbsKPonXJYSqY6qdf4o0GpnXb4tKhjK+xSCwdyZ/hUCnBadcwVdQklpx/ZtXEmK5IjXr96nyR5uyRKrC6xsJDSuy5YpzK5fzE4uzULTzV5uH2Ruzupsz/qs23b/AytQGdEOZR+kJml51g4GKiaM6/Lt5qGaYPm9CbumjTbMK9gRZzBEjYiICFK6QRVkFdiKLQcObFoSJBMibNpaxHuoak/aXF3eApG61cROArUxJKJ8ZyxpLOAKbi31R+DKhN+eni5laeEi7uEqLrGqJw+w7CHg4ePKrOTC75maV74JBOZq7v3e7856rk86JOjybChk7iPg7NqJq+pmKNkZXFSyExBWDWnkk6Q9A9WmlgR3QqXuLu/ugRi8KIkGr69w3dj2W8gRLwk7hNom7wk3VY1mxF2OJjLAafUuaSQ01Fptgl4iihXOrfZ2r/cWzkwE7veOrxD/T7CKQMaY7+L4/9nKsuyxQm7kUi4U06QUs1T+bm4VZy4emAEf7O+C/uw9+KT5AHAfeGMAV2jSgiNuBAK6vi5SisLe4Q4OlQPAzuOy0FAt6C4cYDAhcO0R5KssKFWMfrAHB7JnjrAh3yhAFSzaVoSpmiqD+qQLO+ATkQQlv2ohIAqRZgJ96PB9IObe2pIPW4r6ArGJRcz4NlrJ+sT5emkJBEEJAAElN+6YStoTR7Ett01NPqMWXzH+Zi67+XK04kHpymn92em14inP8sHpHrB+pVqiumA79iZ1EBU/uuu7QhJ1BKUel4UeVMER6IEkBAO/EjIm3cggi6150GBZzmTZFi9c1mg/8EPbpv9qOwwDH1jOX42nJWsCQ2ZycU2Rewbx3zaMwwh0Lm2pyDTFRTFOBhzxhSh0R77yK5NEJDDx89SyLd+yRpstvmjxL0cr03n0RwNzHgizFW9xzy6sXTpkMovrGCftGS/luWoLG+cXVd0jt1z0vU0wdVQCpe7xNnvz7/4xIAdyOfMIjoAwWR5y/WK02jayPB+zqtrCcdnnWnlYP2Mb/+mtJ9eSQT+X/BAOQgOr4X6AKq8y+iZXCZBEJrQVrNGy/Do1hu2WCV+dSJN0H+xySOOvXpN0X6N0KwyDMR9znlIZt5oun4YjPr5gOjmCH35CG2dLLZTIdRjfKmBziiLHu8Ba1k7/HTdbQR/rK1Vdk830CFJHVryyqXSC4o4O1Arngmjqg4P+gmja5SsIZgx8GwZgZBoUjA0T6SbILSuhJGLCFYr1cFgDiHKfsk74JVkbMQhsSkOj9UL3Eha0gaIg6CxgZ6cmb2u/XPzGtWZydELkNTD3dUiL9C97tF+fdLT27DCQw2ge8/9uK+lSqOkuNjSvLn/zpixwgzLE9GVXc9isApTd8R3k8dSJgRZYgRbYgRj0sRtwC1UplWlXxgZNBuqodto09RG5c7+g0msjA223g2zzJDHcqS0YghB8gIPIABPs8w276nAPoK56NUSBrE2QwHL3eEU9dyqbdXSf76jYFfh6/97+FYIlpAIzcLd3k61GUyfyOjE7QyN5r3d6/+IZ5MFHy1gWs9tIC7OXb+7OosLPmjhPgvE2EiWf3itj72YDK4Nim9aWpIOrjQmsCYKCTx3JOHiDO7ggEHUv4FpwVtZpk3Zqp9dq54va+oup5sIv/AIxxAI47AI4tEOKo7gmMAEIgFsdWKzBMKRwM90ASikCvid8ZpSPGw6PLzdMOPdCY4qQD7lD049Cv7pMvNL+tZWSs4KTT7moAjsUS/n8Bmgiq3cDgrmyezmYi7my47Xmdi6D8qSDgrGeCrCftrmFKvAivVOfbovE2XmAv0mCP3geb7CDb7DWuskmPrDsfIaGJ/81aqNzCXuqETXyOEQ6MUx6pYODv6f4vttCGhgIIFyvDWMbqevzxg40rkJU68UPq7/6BrR6kWORTMBErC/OpmgKdfMSgGB3xE4kk49Dd4fqEjqedxOhsAs7ItcylUPEsjNdXsc8zZvBl9t8zXO55up1ry/oPVD7g84Ct5bBfX9j0yb4J3j72eX01QrDJ4Dgnk+dDUw9aJ+UUIrfs+TUkCR119E7NNm7p+L7L+jDvk+6KlR6LKgCLBDDK06CFvMztlGC9XZBrLaVeFZkKPPwk34vxZvyqjM3Q2/8dCvOhNz6Sh4OLLNPdmu39aX8yiOvEj5+sDu+XDsxsdW8os08s2//fhkse1LGvM73ss3OKXyYeLWTwzCQgrbyIeu3fus79mo6NmTfASZMh/EZbW5MtvVVMGpC+J4HwdRT/dQN5TnizgP/yKHPe2duqjqDOECqwz9cY4mzA9qrgtpbv9qzvTUogufdMD/bwiY0FEWPWEs4t+HkKns2UYlVVP7shI9ffOEzNHRnSsc3t01Mwa6rj3YfA/QDRL19AwnmK7gOIb2B/w4KbPgQYkSFDidWpAfPYkaNGzcy7JjHzJmQbEKWEVkSpcmUKlmmxIOSD0gzefrQtBkTEKBJrZYNa9dOn75298gtO5bK0qdEiewIWuoUk6NEmJ5+iirVzp1ERys5IvSV/9CjSsGuTePWq1KnToLciNHy1kZcuTaswHGzJywnvaBMieLLC3AyaYMJF5bmrhrixIsVIy73GPK5yBgno7PsGLPjeIjnbfbc+bJkytpIq8s1DrU4oOxY74r1ulEjVbBg3bqFSlFuTZR4Z5o06I0XL13Y1DH+Rk0cKTyENAfSwsUOF0CoM6m+nEkPKMy5T4/u/DsJ6c7JOx8xIvqJ8yLYa2ifwYL79uzXnw8PJAQQLIbitEmeU61j0olHIooKNIggjzpCsKADGXyQo4QwihBCAxN6CKaVNNywJQ43vAlEnCAhpSdyfgpKH3GKyiUStZZqqqqntBIEqzscUaaXUcASi/+TUYQ55hhhTumklkTgcEsLK6yYS64qmhjjLh776guXKg3bBsssM9uSy8q8/NKcLjUbE7TQJCRtnFz66Ue1oFgLJxx2XLvkEtmIsQ233HLjzZDtmFOvOh7SiINQLwKlzrtEudtOCuygwE7RRMvzrrzm6lPPvQ80gA+++S4VIoQZ7EsUC/9MNeQPS1KZhRt5GrQQIQUvrPBVB2u1NcIJKaQV1lknOgnYkUjy0IwrjGXJpGM7/BCk4kL0A1pICmGlpxPZEWooccaZZS0an3pxR7CCNAUvKWXpBUdZfFzLCrjmUuGDD2qg68koR5nSx2au1NIbMcH8t1+AwxxYzM/cKfP/YAnVWZife+4BSh92/PEHTjjnVOWS2m5Dg2M0FLGFEv4gpeHRRQdNAzvoDg3U0eUa7S5S8MaT9LsdbL6UPU45lY++T++bLgQpTE0OVVVriUYdhhamyKOmlV7aHgtlxZVqiHa9ump6lg2W2GSR9brrrZ19NtqdkGkTxRR/yWWWQl4EF6w74HhkGrTMvTcYdddlK0kfmFQB3nnrelKqe/PVd19+GfP3GsYjC9hxxg0m+MJ/1lQNYoknZsdiTzyHrTZEKAGujUFyM2QQ/v4oFIuWG1Vj5JiZe9k662COeWbxSKCUUpzd29nTnkVdT9LlXNgvuSnUKNpoqA10eh3Lm06a/3qlra866qyx3v4hXxM8admtwy/jWGXDFluksZ+VdqdcchEnbaHEYaZbtpz6Su5H0H0Ej0dGCcVwp/CLJNSFhzE0oV1NgEEN4kWBwD2JcAREF1kSpzgsRQ6DAksY5ci0QTNdZmH/GAebHoaiN1lsTp97jSoagYhFUAINylPD0PiTvP4kr1FpmELsvOMnHmzHdpC6Hc0qVandiac+m1Kipngmn/oMT1T6MV6pZLi8VKmFVc5jmtOk10XrffF62NMe9xZ0K1pxDY0eMt8ayddGLoBtCcUi1rDUZ5yc8KEQeWwf2uSXizpoISuBzB+OKtG///2Pf05JhST4lkAY+A0DKv+gQLxqUK+wnAtdFVRcBjXYycZxsGAfXIeaUPMLU/7iRLqQk5x2Qac5vPISqnhNLBnhwhj2oHW5VMMOrSOFOKBqdbDLoaN+2J1iHvOYiAIPEc1TxJvNR4nuaaLPlinF2e2yiqsDBJGQFsZYRc+LXVzTOMcZxuyJcYxklJoZH/TGNL7TjShhYzzfWM84zjND6asjTuxIk0JEwhUmYk1QfpEIQK5BkBIchf8AyL9ypYV/Y3BkCygqSQeqoJJlcIMgJJjJahAGMpvkZCdHU1IuDQiUCCnN0iyzsDT1Y22M+AWdGkEnXdB0DmQgghHC8MrXzKkRsKhlDH9IxeQF0YbDzOX/y5DZ1KYyU3blQQ8UR3ABaV71qtTsIXVoR8UbylCPzIjVObmYNHGSE63l1CJZzchWqn3Te7xCJ4fqOT66lg+vecXnHPd5RztOC37XSlEkEGo/N6wiR4zsESGOJIY9iMWAUGrXESpKAct6AHA2OChD8xYMZwDjFMAQbZWsJBhNMiYbJPUgwiaHUg6WBrYrNU2a3FdL29IJt5d4ZRiIQIQV7HQOnnBNK1nYQhgu9YbKYWoOlbdD5PYAukf8oXSjyjvezWyZvsNqVkMQKhpE8btczU4Oi5nUG3bin+6bbQgdEs6z3iOtanWrq9o63/pGaGpy1e+r5Nhfu97VjXrNgoDt/7nXlOhzn3QwDh0K8T4UtSMTfhAEQu2gUKxUQQyOxYsBjyDRI3wYcB7wgAM8cNHBRUld+JoSX1hMpWTwIrQvLgbiTovak7YWx6HBRmzFujDYui8XMbUtI4K7WyPz1rc7vcRwXTOb2hzXl8hdKi6jLAXnto7KPTjilqlb3ajqblTaleYJLtBdM3e3CGiejlKFKcUrY4FQeUyvmpwHxvc2DM8Oa1g/voEP6Z1znYC2733LGtdAE5oibQQfF6BwPgI/2gmRhrR/0Tc2S9sEsA9mhoThQIhz6eguVejwhjNcFyXVIMQiJrGIMaqku+TFLwKUdaxp3WIZ62vGNa5xZj7J6/8d/5o0Ox7lwnr849MMmcg1xW1wdWvk3hJBNrtojSyDCgtF+AfOutQ2Lt+M5SxHl8tdVqaXe9e79fCMzGVWz5nNnOatPmqYRc12Luvwhn9GghXjDOGf3UvOPOv5cmgVtIEGfV+LKCi/Az80wmvF6P4yYdH/fTikJV1xiw+4wHXla0pC5BNwpCgVWRGEqjjRWAzrgbGl/jCIARfizGJYw2kJ4LqKcQrD3Dpxmrw5YGodmNFSkBpBF/ozhEH0Z0QD6T+GWo+JXdtfDBmWRpa6kaMNDtbQFBaLMB3pgjNvKlAhl2DHQnOh+zLo8sAE4Sb32qOzgalGoGdnVje70TyqYgr/x9vMlbJO8K1e1JiV3wyJ7+X0DHB+CBzQBFL4oetrzrUyPkGDBrDE6Unxi1te45k/cB+E1Sw+tOIeEfsGI4lUSFFXAeWpL7XK7RLqr9zNo4PhdZZASntdD33nqwCFVwLR+9dHJdaroMWsQyv8Whwt6a3iBjP+LlaxAtl9h1hELYvMbOtPPRYtVAVriouIL3hsdKb6ulG1Tfa8nx3talc/28OzA7eHed0hsKp96K5mk2GbymNH7qDa0Hc+j7B6nqZy/E0c/g3PDg8B12St6KtXIM8eHA+cIPDxbsXxNM/h6AkDJw7zLm8LOJDAPITz8okNLGEYhGIZJAEF90BJNCxu/35vLzAJk5ShLGaQBhvHgnIuYGrP9hYD93Avb4aP91RPCFPPRlxQBpHO+ZivG5Zw+aKBGZ4w+jaBEqbPc4KrEWDJc5ptt4KqhYhBF75QqMCAYw5BEbSO69pg/KZA7Mju7L4t7WggBN5Q3NYPqmrmPKQjDtMPDs+squovvO4Oh5RKqQil70zjzwLwH3JBGwQPAEfoF0joABMQ8bKHARuQ4Pws8B7wetjrECew4CKvHjTQ0TbQA0sR407RAs+n83zBYY6BkdjisWSusyboCGuwFnnQBnFRB3fx9nTxo3wRGpqhSvrCK4oRf/CCCGHkXJIuCaGQGZxwFiJBGvHtEDShGv8XQQ5iwxOu8AqZTQuzUZZugRG88Au9Dw3aIAqigAwPgWO+Lg2n4Abg0fzMDv1KgN3UTw/1sMt2x2b4ET2Uie7Ubf4uJT9MQN52aTnybhDjQBqBDDUy0azGSpwikSInMfE+A6UucSH6bU1O46wg0hPnS/DsYeJGkRSVACVNERVXMuPqCeJUcQ364Bi+gRsAKBVi0BYHJrUe4+iA0Sd3sAe9gRd9MaQApgdxbbSmxBGAT+ZmQRmcESqPwinVohOmUY9Mx4Vioxs9AQu/MTaESqbK8fvcMR3LsmPA7gbSErriMR4VEtzsES67LP3qcf02wLqgK7zYbe6sirvy8HVMZcr/AvNk5uzvGKbfBCKERogAK5LPLNJVWCokMfEjEU9N4styIDMyr0cUU7HyWpIlVRI0PVPRzIfSkCURLEEqUwFIzKIGge3XfvEnj/IwevEGi9I2bxMXXxM2PypvnBJHfnM1geQJWYEVplEt5KwQ7A05SsdjECE2stHIqlAO5IAMyMC2FmH6hGp0ouDrzPILvo871TK61vIF4LHs0nIu41Iudyc99VEu23BkzEwOz6PM5s8vjeoc8W/bFjK9LKcy1eohwQjwAo4x06rPMJESMxMTB68fTmNAGXTp9k0kNXEzObMzO5DAiiA0P5NDXfIlK9Q0R2RVemE1W3Mni7Ind1NF/4FyRWsTRWkPN3XyRE2URp0RSJxyFogzRyNhkaqSKhPBDz4hOIaUUNSgY4jgyLDwlcCADOSglrBzCrGTEcbSO6uTDL7g615ALdMu7cSzLemyBLiUy7QMPuHT/NSwTOFQDvVw7o7IC9yxHbcO2/ZTEI0DoH5BMRFPAKnHpfxNEvGBHwLUTxE0ajJS8dpLExk0Tx+UQfUtMr+HCSxUNE9yQzHUUk+yNEvTDdaAgEa0RGV0RkM1VIWuMVhU9l50KFs0RkW1RqNSR0cUKVQljzrBOGjVDxDqOIpUh3ZpCHhqOn21+qxUDrCRDKJ0EWDhSnOgLNNRSheBO3FAS18g7cpsA/82YC2xDD0NMkwNskyvtQe0tLnCdQpiCE3b0D21LFTsjopMx2O2LjewTVwFUzjqoBAZNPBi673G6fAQFBP/1M8SVCMXVF/jKwD91F/3VBMRNXskdVIbtlIflgPl6ENfclIFwQ9E9Cl1E3IkY2Nz0GN38lRVVWQVY2SFklVPlgZLVDhfNVZjVVr8Clpi1llOBmX07wWGQAyr89mmM6eE1Vmbs1mTtSyts4WuFFqhFQVMQAIkIAEkgANYgAWGFGqTFu3KtDzhsTzBdVzTkArINVq79DzFFNx4gNuM1GPWcR3ZlWv1T14HpT/1zTGVRrYSdVDx4UAX9GAVLlHx1vAsM0//Yepg5QsRyepCQdRhIRZxLa5YIG7S3MhiUZCAlE834eFjK1ekXLRUYXRxdi0Hk+5km5A1pyE4d5QUJkFaThdmZdY4hoM4zMB1vvUFxHAIno0ImvSVhFUOxJAMyWD6rhAMhkBZlTUMrrCWvhNqoZYDmHZprTUtqSBq34AFwjZa43VcZbdrZVdZoxUFyJMtx/R4Wsc/BqFdv5MM2xEw11Ds9C6H6q0T3MdeRzIiEZMT9ZRQBdYx64xuCQ/g4Etw2WScCpBAFRBhE3YgGPZwKTVxN7R2JFbjNpV87keCuGFyLZeCK9hUNTc3S9aCgc35QHdldTQUUDd1F8xZ0qcLKLZ2/4rJBLQUeFu4t4D1Sq0UDLrTOp9Up4CXSeeghYjsC3LgaFFgAxKgaSWgBG4AerP0eKMVXK+2esd1CJzXh5VYe1FgetH0iOJwe2XIXcUXPGMIWp1X/74OIaWM3ujVfd93gAG2fuvXx9KB6fo1URkwe+y38PpW4Az2AAV3Ag+YjxPYjxGYnhSpFj9ogwv5gl1Ug70B6Sh4x5yPNT+4dF02dd/phE94ZRJlAziAilfgt2a3t2yXDJSVd9EAB643hxGhZ3O2p2KDEZL1aDkgebcVat3xDZy3lrP2aqMVDF6gA3Dgd1Pgh3tZSzuAmKcXPeXTINUQHT0GDcbyiFkAib+Y/P+6rYzN+D8bs5wOU2/59V//TjdbxX4JlRPp9t8AeCgalSIBWI/ZygIB2TP/GJ5TsmEh+AiDTVQNGTdJVZ8PGZFTa5FZVYIDmglvNJJJQYRjgo5KUtLycjpyxwWqlQM6gJM5Oclql7eC12i7Mx3BwDlvN4bDoJaK1niRF5apeJbJ0ofHNXalOFqJmYqJWZh7GaaLWZiTtru4tXmVmSx/OInNkgpqGZuouYwbzCOxGW7hV2/5lJvx4R2i5hk9V6z8LAG7eY7puJz5l38V0KgTEICzOpurmiT7WKzjOYED7Anm2VtUc4I7lnLZelX5uZ+JMlT/2TUFpBtEF69d9mX5iST/gOisLc484s8FKKoFRgAEqhWiJXqiOzkHfCsHOJk60xEHgjcHangOiCwMvhOkGaGFMjsKjheWZ7mUJ9uXufN3W1iKZ3oDXiCiZxqmeZmYgfkGSGBpVziXsfYGRjuJTRqamVl8h2YN95MkCmETilqrl/ppCFiNm5qNfQyqu0Gqv9oeAlRgr7qO0Rm7K7Bwx/qdyRpxGVg0N9UpJMEpXdOt21q18Dk2M9ifzZuDn3E1e4EUJJmvT+KvNRS/g0C/9bs+QEDdQAAE+jCxF3uiKTsFKttodfvAbZf6YjikdzhZVyCJdTsKDpy0XfhmtTQFZDrDYZuYW/u1ZdumqVgRvBi3/1k6t0sZ/HgjN357hgJx/0jiDWbBuP2Wqvshjqn6McE6QpEORwbExjURAPVVz4LiugM3uwWUu5fcu5vcjcQ7ERDLczmWys/bpLpEveO6vaecgz3YF3o0hKUFodNAJCzuB/zGB2RAPdS8Z+IDwOEOBCIgAqxqwIG3wCmbBRD8l3EAmIFZlK1TaGt4h6lvpPuck/n8sSWctA/chRt9CDa8A2AZsVGAmB99tKGLCt5VLdG0a8UYDVc8SlmcHZcZXrXNl4ajIR30uPtXvtJ4xwG2jVM0qgMOuQ22jo88ySczm92ZyZ08ng9KowR5rdE7vfPZZNubRVE2TAQadEPXFz4YEv/CfMwltjn2+5GunT1s4D2iyc3lPD4iALE5wNAVewWM4M4jfNwZvTqX9QuoL6Qv24V82NANncBZQN1x1pP33LVXe7VjVwzhNTdiaHfasnpbXE8owRZs4RWgdDvlFDjUcIcCUST8IBKe8DJF6Manu8cjtI0P9dWpWoKJDvnMym//NhJTpPAicdUFFmpYPax5/VJ9XeYbdqPI2wlJY6Su/K2PPdmVfdmZfUDM4q4Jmr4RenGrHc0fSV48RVN2xuktAD7knFrFHdLJfaIl2sChtc8NnbLTsUltSyshPNEJfKLtndFnN2eTFbWLmaXBoMSDWg0UwTxxaQwPnhJQIeHznuH/+WSLxe/Fhal1C1H5OD7W08XHn4HpDPXj2djHj08GDfN9A+7WDQ/JHXV+wwnmM7/Jk6BDVbKNNqoPxgJp5sHK/2W1dt7nPxfom335dFRVUNfoj15UYmA+4CNedAb346MCdr/b5xyigVmmyV6Y+/xoZZv487zCh3b6wF4ra0log7fCHTt4PRnfq9+H8XyGZ7gMZ1hLy1YeS0c3XsE2xj/hWZzv0cAQSN3v3wwIusAO3oCboqG84Zv+gfP47h//sUEeBr9QAeIdvoEEC8rTFu1ZrYULuakj2C+ixIn8Kt6zaPEiRooU/6n7uK6cto//Spq8gtIJl5QsV7ps+RKmypk0/2vanBkkic6dN3v6/JmlzJagQvEk6qQM3bxz7kTC8yYSatSp5pparUo1azapW7d1/QoWqzmHZB1OMzvNly9SbCG5BcQnrpm5SoTsuCsjhogPH/ZayMD3bwYNgP82qPBXcOIIJDZw6JCig+QVkFdYlvyCRWYcmztz5hwldGgychiZZtQotepGjBbJIXOIdGwytMEQGYI7N5jdOXBEoUKld+8pm8Fk3oD8xZQpaKYoem4runTplKofGjQITZvtaLRr345lShwsUqQAsZtzjZ9O7NvLSsUw/sL3C9kzfEZWYMH9Bg8ihCZfNulAZBJHEmV0UYIbTUTgOPZ8lFA0StlD0P8/Ml34REwZasghUB5+CCKGLbnhRhlGVSKLMmddw6JWT70oVoxMuRgWV2EhhE2OI5W1TDc+/niMWm1Z8lZcacxlRl3nzcDkXiAEFthiUlrw5JQaXBBCCBxEJlllll2m2Q09mGBCDzd05tkKoo22yCKmqYZaaqchUhojc9wphxxgkHFbbkP49udwzYWG5gsdILeBmS+A8ZwiqExH3XPbbQdcpW189wYVb5CXKXkujCBCqDYEYccadtwhSKqJYPJIq62u2gmK781KnzAqyqPfNwPpyt9AuMbznzPA1LJKLRIWKNE4HGGk4IIGRuQgSBHiNyGFIW6I7bXagqjFtiIShRL/Hmz0IUkoZ5lFo4xKqTtjuxHa+N9XOGrDzI75/YjvMWyR8laRR9LFhBAtNOlklaGCQNiUGCAcgZUWYKklC5VN/GUKmpEpAaIoLKfcmWfiABwLwKFxSJuomRynnXO8yRqeevKZwxBqBhqzcMGhgaZkHDiW2XIkQwcpKoOooRxxnN1g6aSUcropD58WZsMHNkxdRdVWX10FHHDYkchR9sEHX623CkR2rwSRlM5/vKzySYrrINvPg8syu1FFySrbH7DxPgPNSPtY6G2HgV/bLU+GDw5TUSf2cu5VLsK4LuTpzuuuhJSXdS++3ailL5Ge+2EkwAEvCerBfR18MJWJDdaw/wWtPwz7lVo+1mUKtn8ZJpkNM0ZCeFiIiULwwn8cGiVtHo9I8qy5prLKedImh8wyp4DbCzXH/BkVnXHAfWfMNXoLIsYvUt1vhQKXKaZKa+ppCSMIRoEKUU89tfw2qCA//jXUkDWqsNI3i1mxLUWMOwvZyoZAgyAEGGzjRLGoFS24HahudnsWg3y1LoUIy3J1QZwHQ1S4LBxuhB8sSh/yIImxRW6F7HJc5GpUuRvZK22Zy5eQUuE5SYAuD3RgA12QUBe8tOBJqCti6hJDRIRV6UoSYGIIEvCYyNxuihdrDKho4AISQIE8ZiKTF8ukGZGh4QvIQ1lryHA8MqgMetHD3v/MfAMo6+VgN3Q0jnJ285zdUGGMeuyNxVgQvOIwahHX2Y3S3rApL3hhTCewwGEYAEmp5eQOYqikJS9pSTcQghCtkkQlJDFAUXxylKMIRQF/hcqyKVAZxGqbK/tWr4eYpIIRqaAtn9WrekAIGrzsZQezBcxgCrOEISSmCL1lIkGA8hjoauFSXOiuaMIwmvTCXC5qCCRW7Is9O6xDHUz1EvTQgGBGDNUGlPi+ISqxBReg0hWxBM8NSAAyLLBdPT/zAkZ+6jz83GIXSwDQDQAUBWHc43Vog8bk0Yk0aHxNnqKXpz75yTJwXBQeG8UoRmG0OZnpTaE0s8fdLMIWbbLOd4D/47tFAlQDjzQAJG2wBVitqmvKdJVNV7XJnOrUETx9xE5HEYwCssiACDxgOpihkAa+8lYg4Q8tocWrC+ZSl3uz1beuOswPequYJTRhChvnTGhKc6xUsdzlmHHNeuGrR8tghr7A5pZIgE49PhxKB+/yKb2UrpwgIMEQR9DOCwwxAu97p2Fnh5kwDm9M/RxdP83ktCxlaaCLBOml0FDGRUCvNQ/lE2meRxuJUu+O0BmpdU6rCDsaqgOGSlN3KCGdX/zCeJS4ztKaFtkTNIABB4BkJLXwhkgghVbEFeAnWpVTTZLoDnsgxHKbC91HlNKUvRAq5lCZo1ZyglVta4hDcoW3/7tBlUEFmqpSNCgMrP4Sq11or1Y9xNX4etCrjOsGDdMm1snpV0c4iqV/x8ENtAqYrcvQZg4jkQhv0tW9OmmSENEZKg0czK8bMKwL+jqCvF4xixwuwWPCmDsvZnF0JGaC0078RYCWgAfD48ylEppGN53xeUTwbGfJYJtATWGOe0peai86PjAY7cP0LB5sb3ELayiZGCS1TnbawKnIjpOlCOCtlSlgAz9EQj5BnU9xUTTKVPV0k8/VWiWjK91SVpeV57KvfxySVJt291bfjaB4pTrVs+kNQMZ4r5//PF+WpCoVYH2mofPLwstd15ppVcc1Hz3gtnbuc26pQ4LByeAgDP+MSVNeZxGvuOkr7qAFeeU0FjtMAhNwjwOA5EDwTtzY0UFh1uVR5CIZq2KAAnJjI4Oxacr4UNAy9DU4zvGfrFdHIWcm2a4tniJIKp0kS9sWJh1ap3AdggscprdWfqkftHmfNaO3y0F9TyjbM8pK+HQPZsbk1ngK1BQdQ0VIzZG0FtI1To7Su5rDM7TMxp8H7bkW6s2qwQFtE/kq/JgMt+tVF9c4/IZ1v2JppjUdnQtIR9rAlF6PgtdQ10yHeq+o26tfRb2DvLrALqfm53lS7cVXMzbW/zqSzWm9SC+8IbLuyzUYRVayzLqpNJ2tMUIRypvqVc96m2Et0/FpUTCUdKT/0UZypA7Rne6A53cq1i0EeutSAxTAAVguxCzmzUpnpN1WbC+GrYprbjDXqpSj4AQeSORuNC/TVmblRkJaOeZPdvkaNSwq2n4FcIGnjRoHLzjC17tVP5uIXMz81aETrS54KXrRGdf4xjnecdB1zQsgz3QQSUfyd15Y5SlvvcuFMGKXO22xMzcxkmqehtyf4Qy21vnOA+pzMI6sjApVKEIlivwh5NijcsRMlxKL7EEqwk1Wjw6SX3HaLxziC5RCX/tO4HWwh33sZZ+F+TfYdreTe/3DYqDdeyqrDV6jF3Q3hSnW3W4xaLJVA/QuUgMoCzi1SfxnXW72ZteFeImnN9fw/3gNSEI6wVUPCHkNtwQUCC6T5zb+gWhkRU2LZk30MmADBnqFUAigAxcnmAilh2kvQWLi5GCmlmGplnIt2HKyBwSzJya3Rmu7p3s91IM8qEjtxQPt9QbBt2I/RwWKICfKMyfHl3y4QUdQ6CcdFShOJ2SDZHVZCG1O9mOikTRQpk8PsG3jF3ZYpmUqMm5rx37GsIbqxm5aowfNJQrxJm7VVUrIhXdw+G6t8mX4F11AxWb0hhb2VhapZIjY5XiN54A9kRMS6IiEM3lfZXkT1y5kdV8XtyOepy/alAkHRoJwUQdvsAaiqILuZYo06IJYZGp4AXszyHI84IqyhnO9p3tmYP8kt+iDu2eKQ4hIPFCEKMBiKvVFXwALxPAmxbg8RxdaUrgnPQZsvHFHyTZ9WWh1aZR1evQbwOFRluIFK9VSAkCGkbQGW5aG6Kd+bIiO6RdUdecIeiAGRwCPVrMHaRYK1MVKdnhczkVJ+geHjjBTnuSG0KVcDiQ2gTgthIiAk6g3i7iIFVgEjwiR6iUUtliP76CBG1iJGckU16VWARaCAraJODQJnlOCcPEGddAJ3jRXpdhet+dDLzlrLvGQM6mKNXliXQB7IxaTtPaDPclDJ/STQAmTQtheuXdrkIVtG4ADjFCMpgELjaALjaCMU5knChULxRgL4RM+PtYojWI8svX/C7mwCWO5fV9QbF44MlAnMlTgKe3UAAggfuAoduI4XGpnjmuYjr3EZfmYf2c2gIBYh0Glbjz1hnqIZoIgkMuVKoJXkAZ5kNSSkOmgiAzpLYbTiIYjXzwRgQ9nFOZyFhjJge3CkR7JTJsDkiNIkiWpkiqZYN9UirrIBj0YB7eoiyohBLZZk7l5arQ2ay8pm7IZlOPim0OJLbNYHl20MyUgUChwCMX4lFC5C6zxWUQXbHWCCFgZC1mJCFtZHbbwKKhACY9iHbARCdzXBjhQMfaUPaABR1tnAlR2AHEpl2T3AWVQl3ppjsKSjsnQS/jJZ8NyCgFKmPrGXQFKQGsWmLKw/1065Y5lBgfyqH8nIne1wmWBiIYImTaUOZmVaZm2GZEf2hJ4UC7nMg3u8JmgqZEX11YeKWmtgJqpuUOtqZIn+XHCuZonCAifmKNGEoS09nq6uYNbFJvAmXvBaaQ8BJunKIS2hpS5JlBUwJSN8JSqoAuwwFl0YifJE2yswRrZCQtIVny1VVI/NkbpqSZmek8gExrdoX2HUFtgCJ9kKHYEMHb1eZ/oJw352Qx7yqd86p9qmI6y0H7GRahBNVQqQm51JwmICV2XdDX9KF2k9ErEZaiOyQ2JiKkbqi00OZMg6qlBUYFjcHfkYi4XSYmY9xH2pVYExlac2IlEoqP+4pqzWv+jNqqSO0qCqamaQ2qUOAmLtwmLxkmkRUqsR2qrL8kFvZkhs8YDOshzyulhN/AFTPmcVnqlyuMyd4KlVWmNz9EmZ/knU2SmFQNSRlYd4RkdbyoFumUAcUmn4EgAdHkff5qn9ZqX/YmvaKiG41ZuAjSYcahvBARB3XCPcbeghfmocAB//2igFFqpfJMjFqihE+gtl/mpF1uBkyeip1QVC6iRlxc5qQohAWaarTqSJ/uJn7NDpceaflAINLqa3oSrn4iyOupNRtmjwjqsuQicxnqsyPovtseswZhiZIIDiwALqvCcp9EIK+NQxHYbyUZHTzdHokUx4kpFcIQGCaWF3jn/NOs6hmD3rgVAtnXaBXeKp9Rgr37KtvnKN3qKl4Pqhg8qjwErbkHCTNPAZvAhSpuENX4pCNw1oQGirxI7sQ5ZsRhruBLpVaVaiKj6sROSDj9SZ20laa9as7Faqywbs507s/2Sq5p7s7zXe6Q7mzuLurlopEk6pLY4tE7jO2LyRSgQBVDJGnGyGqmRrXjyWcW2WtNDM1eLtStwTwZFdbJlDVb3Cq8AZSHgSLs1p2UbvXQpqG67tl5hvdlrl9sLt/0qoIHgqIBrf7WCdmextwqKf3ULb+NLKwhauIt7uJvaYBbrBPSruBiiOBt7ohKHeahauWjRoi9aCCm5q8M5owd8/6Of+7mha7O5d7oPDMGgmLo+SMEVbMC5qIs3iEU9wEXASCasRoxUqgu7sAvsQMInnJ2ecAmXcLtaWhtDABkUE8Mx8wU1PBo1fB1u2p3eWXXgOQjkAQXOO4bROwBFPKeRVARoyyL2qrba68T0qp9xuwqswlOGCakE6L7ly0p1B779eCoF6rAMUV3we78Um6k3Yb8cqrijOqKm2r8p+r8+wjnMMAuvysCi202KNKM2K8GzObMLzMCG8MeaC8EW3EO4eMiGvLoWDAVPYJNMKiYcYLRkkLQkzA7hYMLhEA67oMmajMKxICevYRuTIa6L0lBhYBpiiX2vkAuvIB3Ji2TIQP9t1hZZGWBlRCy9RuwAZPcE91kN9crEwfzEw9y93osLxyygg2lT/DehB7q3DeS3XryYDUuh7dUtp6ipZ2zGHpLGZfypo0ou9cW/p4oOREW5c7xNsBqrJEijMItIbzDAovvHgLzAkyDIhnDPJIjPgtzHdFDIE+yzinwkjnVqHAw8ZdI9lDzCC03Cm8zJnbzJKQzKUpljgHI9PcaU0SFbkGIL5LDR3kmW2mEeLuCWcmrEJ30AZMvLnQAf+PrLLy3MwwzTesq96rifbYegxiwLDbRdPR1/bGeHC5p/zbWw5uYHpeJwE2t7mOrNTZ2/bUwW5LyRdXYWvpAWN6SrORqrnVD/gt7E1W/A1fGMx/Os1SQY1rlqCfus1oaQ1n9gkhJsyKebyAJN10h6BqiIg8DYYgpNpSvs1ygM2BPNGraxfBftJlb6pZDy0WF5UOjDAtD6PkOMyyddxPTZBH5gLP1ZDk3M2V7Bn9mLvZ3N2TUNzKON02lroYj6dsi808l8oOoYkO7olwQKZt1iB0r9SwEDRNfSzdvs1EuQJMkEceN8qrhCuQ4RwHb8iSdJowMM1oiEkne8zjjqstNd1tJ9svbMz27dz3Jd190UnN4dlLSZJK8XjB6D3lGwCLnLwivcCH4NlRJ9u8R2dLtBGgp1GlaHDJTACGLZKOYTRu6zGFaWy2Ob/8tIjNnK4NKiLdMzzeAPXtpvK+Hcm9oTzrY6HcYFWwnRnEmadAyycCqZ6We6XWJM3aHoESK77ds38UMlYgYnUmiSw0KGZpGVyzngltUuu0NgnQhgfcfCJVyquUPUvaMmCMhprd1szd3ULd7f/ZPgzUNNXqw351ghkNfozQKYxaVz0LS767RwolAPVXxjPidlvn3Z8Rtgwj0lkDCOdMsFDufk1wQpJOFgAeELfud57uCmjdq/nNP9eszVG6hwN6/4uG6XlCOpgJgirrglDtwlniQq7nhNfb+R6LgYqTeS+w5tFsB1TJJFkqNnratAbgmkXiRDvqOgm+rSDQn5vORM7v/kc43I4z3rU17eeAF+ROsxVPALuqAKfu3Xu8uEWNrCZI4IS7iEYfAFX5IDxAsmLCDJVAa9kx3n0qsCWpDge/7SURHheK7n9brt2k7aqt2nrU0L4xtKx3zTtDKoCRqQcBAhnXDbt53U3kziokPiux3po9MSlC7piEvG21wG4RzjkbsUwJJKJRuSlNbqoR4JA8zVBwY2E+8WnmTxOgQJJpjxG6/qre7qbg3ysB7rUv7ks766rqvbP8Akk4XQYgKlumDC+sDQqrAaddIyxi7mq+HepjEHZNDsWAvgHCABj/TmciqXBe4ABXDtLP2Y327n2h7uUS/1D552/GruogQKWZ//7u3OfoQemOqWEH5XCSQyFIzOofxue0ggOv/OBPvu7ysO9xlbFHxY8AYfD7+STXh7fvABup5T6uxh6uY38XCF8R4HF+UCuh3v1okvq7Xu+LL+k00e0MT6Q+Rk5V6EBlDpD+zADv6gyZyfwrmrpdvqUPeNCBL963Ci7DbM+jgjyQkw7SZd7SfNAB+gBb489bnv9Lov7uOefueO9ayi9ZgwQOp+03wK/Mk/mO+Bt2j4EbOw6Cv4Xrr96JDO9vmOxm/vqT+kOJKQt2F1XwjP6WmhL6yEQ/3i96W+ZaUONoK/93xv8V6j8Trusop/3fcP1yNvrJ47+QCRJg+fPGfMPJkh/0LhwhAlHFKBpcsfu4n+woVjF27XRlWXGn1E1AjRSERyRppsFEvlyo4fQeZiFPPQly9oWDiU0ICBAZ4Fevr8eWCAUKAEfFLQ4qfWM6bVsjmlFhWq1G1Uq1rFOlWrtK1cnX31CvYrMF60zILClPaRWrSr3BZrJlauLFxm7YpytEcMHEKVOqWapU2w4FqCtLjZklixE8aNHSd5HFnJFcpPmFS+XBlJZs6aPUMGHVr0aNKTs5T+zHkJktVZELvBI0nWNHnpuLmbh053bnq70+XmVpvbtGm+ih87Nkt5pE7NIzF/HqmWdOXVlUdLrqy6LEmV/DaHFF78+PGAwptHn54goP/1dAa6fw8//nw/8u3X6YP/PnwzBAWaaSFAEEAg4YQLDCyBil/02ajBXS6CkKOQRFIpJU8ujOWSS1hiCaRbYAERFkZsoeSQQdrwogQNdArqJ6CIGsCnGGV04AMtJAkMGh2zKkerp3gEMquwhoyrSCODIcstU9Biy5G02uIlGbl21DGuspQ8JUs9xDiihiOsgG2dcwZjppY1DltMMjVNY7PN1DrbDM443RSCTtTuxNPOOU8ro09BcCTumt98I1Q34YQLNLvtuEtFFuoAq0W5SCfVbintKuXOO+8g4YNTT9c7Lz1RR2VPP/fY2A/VVOlbldX/+kvjoBZGEHAhDTRg4ZX/jjTEsNdeVUlJFQ5jAcfBlXqFRaSQbmnkF2JsWeTEN0wIYcUWe4LxAKG0nZFGG5VSBrsfgxyXSnKFnDIsuOZKUhQmm3wSlFWkNNJcKmu5K8tR8OLSAw9UqGFMMpnppAwt+lyziITXxKyzyw6CWDU9J86TtdZSq5hNhPH4U5jhBuWt0HriGTS44ZiJpikdJ41UukclpfS6pjDN1DuCJOk01FBJ5bnUVvlz1dSg8/v5vx2OnnXAWxtowARKGJkjDCOMiLrqS+bwKBYLheUwwmN7VRaRWz6EZewSUeRhhAx2uvZFt4vy9kZLy/Wm7nO7QtdeIsciC0krr4Q3Xijpjare/3v/rkvffQlxwwYV/BVYzJP9QPPghS+3880/UOFDCocpLi2IjDEeXTM/ZTumZJBHFhnRk1UWhmXZKaU99ktvp+sTTSX5tA+cOfWj9559Lnro+n423r5YgdjsaBcUWrqEp6ueuvqqLUzpI2B/5SjDXz8a+8ORbiHpRCyAUJttto3itkUZBZjRAQdUkDvcvHu0l+67YZ/S77r6hstZ3iU4d5mFcFdBIL0UeKVT9I07o0iEHdywF8kNJjisYAOaMJcnhnEmDbcAxy2W9znQXUx0pSNdCVeDmDIIIhGzMVnrWvcxbMBOdtBg2TPmxhRhzOx2satZIrpzM5yByog9a0/xkv8nNCYWL1YRcwHzjmagFWngEMTg1dWqZrWteQJYLvFiFzlkobIRI0Riu8XZzieCCqyvbW2DW43q1xX87S9/CMyb3/ymr/+1a4AE7FtY8JgMu22DcLVY4MrwBR5Z+EYdtunGN0hxpg2qsGGW4QwTpPAKdrBDEZnckyVRmEJRuqaFjwjX6lj3SBnuRlyKpFQ0EKk3/tkwSWm5GUGIlp8iBo94R/xl0VSlxCYCjSD9gVXEOEMDKjYgAVQQ1oN24SteidETLsFmI7LGtZUQIxbEAIcZyza2aKnhfBaAgBvhCCMZxU+O4LrGVuqIN/3db298CyAf+0iLP7bFFH30Ch4LWaX/AxpOGbY7aCpX+chIdsMSCCNlJTF5Sc78oR3+sMYfSJgxhY1SoiZkk+VaiCNVhqyV0SBM/l65Uh+ydFyxU1IRexmf3wEvZ8JLohKHyarjFXMNu4RVTgUSqxGeoAQnyIAGSsCICEGIml9byUfAtiFuVvWbIFIF+RRhPiCgc53wa5+L2jm/JlQioXa8oz3TBUQ/LkmfAuwnQO1YUHNdA6EJ/Q1D1dHQbszCMB+VaCYvk4ZXgMMfItzBRkvpUcbyCTZ9mA1wWFnB3qzOHCb9Uco0WzeXNmWzO0oZW2Panl0esVOnzVkwWTXMnRLTp8X7wx/iIFsv8AAnRj1ERjLyoHA8/3VYv+UQN8NpRuKOkxJoMOfz2vjVsTaXAPL7Vi/OSk+1ohWf+nJrdvMVV7mSS0pXMShVWrqOVZZpFsxZgx34BNLGuikzhN2qYcGhUcXKiTWZsdgo2avfUy7FspU1qch0U0MCzxN/Bu6KZie1iuYUkWgco+l7bIpToZ7Kwq1d4tD2s57Ybk4TrSiFIcwpBWqVoAeL2EUnU7zbp16Tm8bSRYzNyLVw6oK4xA2fItowBRJ7FVvqdK5RxirHTtivnkH6blrzuC/tNvmf2P3jP6MkFh/lUbxXlksN8ZWICEqwcutdLAcvs4M/gIMd4LDGmSnBhCgK9iBHu29+5awFyDRhzv8olHMoSXO6wPxXwH8ucI8EjWDq8i13Q3QhhEsbYQpXmLUYvk8cMrwq84gYFZd+xTBs8YoPn8/Eh4jxijPiVGpayIswlrE3YwwOVkcERN4kJxhGXC11AtkBQg6y/OiXCthVN8lKFlIwmOzkAhL7XcUmiyAFOtBBApug3mEcHPayl8PYGcx4Bt2Y02ANf3SbHWk0JxOOxmbQvdkypDkhR++839CI1IUwnCyg5S3owQz6yHoDoltGgTOOCaJPZ1i0hHem2lVBOqeOLvhA0JMJEKNC08iwxqYpgbY2EIMdoTbWRaa5EWoaq1gMknGxiHXV4pZtqzxGHwjSydwgd6sAHyj/A69VhuQdLVutdBF2sd26Frxwwp/ZPXaW/HY3ZldXKs6Q9rS1QG06N/3a2M7cmJmAior4I5ysRoUa6qRYdndd3evGk+VcmIoYkmzehbps2gVm7yOXayyHRrS/8fBvg2CYPQPv6XwebfBJy+eXkGA4pocRcWTYgkSDwAIVNqELFadYmrz1WscdxA59FKtY7RC5Kor7Ia0i3nNAcIEFfuy+ltOoRoKYBcoKbXNnH52BTQ6cz39ewJ/jYl1VLrp1r5x03jO9CWOAeukyU2aKdNv436Yv1+2bBGvXOd1f9+hIe1F2eQfY+mtnu3cR2a64b4zu6bXPhAmeKr4j3D2SRv8v/yPB8GG03/2F/8UrzqZ4xndy1BDymkY8MU3fxljFMda8ktu8EkEuc1KDE7A1ohCrXIO5pWg7ZeMK1sOyKAGcoHOSC+Q5ntO52QMGsMC91bMu3qsc4Ks2p/O69soMRTAs42NBcPgkJpgV5sEvsBON5vsBGjxBS4INF4KEPvOzs0O77JPAwyELJuOyRPOT7/s3niKtgJu0YFKV9AMEQ5iESVA4UtiEXMgFZHg/LnwFw3uFaKECRPA/+7s//uOVqGmEOdAmbNK8GGMQkds8kiCbZymRrRqEQYACClin0nOnGlgDmaulZiOkCBxCaWiGCvwjDGREDJw9f+pAciG03FOrpP8bg0v0PRN8OtcIvtAgNym4BRYUReQTNxiEMzkzN+cLnU7MQTQRBKWgvusDQiE8xMPBuVM4QjtIL4OBqC74vr4DRvSLDy8YqvSjwkyoQhDLhV/4hXHgQi+khC9cBEqYxkNgBDMMh4mIsUYwAiLwxm8cAnAkAzkgx5hghIgAQM0TkUVgxy8gg7EBkTTaKhFDvJVjuZabgCaAJ6OjRPFSxMBpRLXIwA2EREP8wAfUvdc4DDgoQTCxNhI8DVYMHU0ahBUURW+zhRF6GD1bRRyEvrCDDenrhh8kyeujxVr8G7rojkdwIdgIyS8TqaAKxr27sJokxjqYrUI4RmV0BVcYhnH/YMZfiLhf4MJNoIQ7NJFFgAX76545IAMy+MYUCEepDMeqrEqaOAQyMEdXg7WRIIOtosZF6Lwd07rRg6OWc4AJaAFAmTlaoitKTIay6CcnCQQ9CMgLfETssj2DjKenOEkJREkSFINqy8QVasXD7KhS3DopoITiu0irQwU3y7Mc9MjKHJ3TSZ2SnMW/tDJjcKCeE4RoU8jE0MTEWIO627ChMYibVBXWbKI3eI4P68ktJMrCE4d7CEpm5DSjPIQ2eAM0OMf/ExGayIEVMM7jRM7kHILijILmdEcyYMdzVMd1RAM0UARqPDw10E4XUMA4WkBcwzUK8IEXCq3Wo8Rx+UcM/wyEC6xL9gwcnQOGUbg93PtLzhzCS4TJEoTIJdhPy6yYxOIMUHxM4xMhUOLI/bLBjxylS/QTeNNMWVQ7++wKtqLALPGO0PSyEjyhL/NFuiumgjtNVAnREBUaNngD2OzJTHtGcRDKdnDR3PwFozTKE+kBBYlDYmCERSDO5DxOI1gBb1TOFXBOmiBS6Hy1splGMBgE64xGRZAtLIgAW3ub7xQy8fyLtuRH/UnP9ow9AoLP+YQKCa3PfrSXpdNP/ERTxOzErRMCAR1QF1zMGQyzjvTPO3nJjolF6zO7IAw0hCRCz7zFmsFQFuoCpxOd5uMCDyXRoiHRESVGgBOaNziEZf/cwmeEuNu8hxfNTUYwEU59AxZ4g18AwBzd0ebMAR891eoBR+ZkziElzuZ8R+JiRx2tzjw8ua6ikSml0iHzARwxz/1JTy8NOoJsIDDNLCFku2SV0MOhBsI80zQ1zARV09GYQTZVg1AcUFT4POWr0271VoT5k8x8UD7tUz+FJZwrQgvNRZd0uqb7PQ7dxUV9LS/oUIOoV1U5UZ3MBC0MSkstvHYQB2IA2NzchEMo2BNhATQgBgaJ0ep0zjAYxzCQ2Ooxgqdc1RwY0oyNAhzAATA4RyRVhAJsgzw0pxGwR131w+dKSytgy1/No8QZ1pjdwLjct6HjEWXFWdzQ2Zz1RyP/QdOffVeg7c/mk9aP/MQ2sEhRhFP8UszJdNqnlUjUAFdJENdxJZRyPdYJPZLPVEmfq4RB1UWFpDMr8IGgpbMOfYM+IFEuK9E1eIMR9UV6TQRifANDMMplHId+GJF+oFQvzIVXY8ZniVEZjYQTfYOAjdE2cE5YjYlFMAmJhVzIJYNXNVWM/QLL5ViOhU6t0rEp8Nw4wAIpCIGwQtld5YkMuJHpIrrsc4YKhau8NKB9Aihj7UuezdmdhYcIHTR8awahNdsz5c/WKNo1JbcoUsEBJYY2EKzl89YiuEHmS8zn5a+pJbuRVJ3NzNoHjB3PTMmu3Z21QML00tCydcjKWdtE/8OPIzzNt9XFNXhUEkVRZlzGX+gHZjTHoCzYLPyF+bVDg92EAowEZtwE36SCAqaC5qQE6FyEiIVcc5TYp1xcy5Xg4zxg7CyR0MVgGsgAtxEr0gXP8Ezdz7KnQqqjRHy9fLGLPorL2V0X2rXd281d3dXdo9vaZ/Xd/RxeyqyTjprM4mVMxxRFYpiCxdzhqINa6KVTBXUszIzF6yXXZSUo7hWtB1rJC1VffxPf8T3UO9DFT0jfI2zb9o1XX0zbOiiETXiFdhBcANxf+aWExJVUg8XbXODNTSjc30SGTTCEQjhRKngDAz5R63RHIsiByWVgp5zcygWDRZbgzO1YsbxgDP+GghFwEbBCWZdzOaQoMiwFzOwLINmlwADa2haWYsPxkRcetBiW4b+sYf38Xfz83dVogeejZQUtXhfogVsAYhYUoW1lWjltXukVZh6OPo6hWut1YpKst+zVWgAC1CL8Xk05QvWN1/zsghPthEKIhELIZp1MhEJg2zX4hF2kV7Rdv9kUh3YQ1XuIsfnl1GUcYMONBBk9BGSMDj6OhFyYBMPl59k60dk6YCIt0udMZEJmVctNZBy4gRcYBHbs3BvwHJ3AZJ7oTky2aE02stXNXsQJZVKORFJGxP6hsjDFXVROZezDWfAqklj+PbJNU8EU3ncN5sko4uUFginQ5cf0pB7/6IHlA2aoHWZiVuJr85NwRWZWauIn7syORhKc8wsq/t764LJ4NZh2TYToOK/oeI4G84MIWt+fSgQynmctzAUW1QU17gdduISghIlf4FQ0ELE4vudJ0Mm6LoRM4OP0Q79iBF3PddjKZVWDPmiMhWCOZQHFO0o0CF0eAIGfgJ/32VWLNgCMFmFJJOnCWeFAWqt7GuWRPunPLmlVhuFyGLDd9VmzlenUvuFpRbeajrNPRIWkNT4X7Ok2S6zmoYwjft6gRuLe5u3fzq8l/ilZkC6UCY6RPOofxNpAi2KmfgvZ6A6o5uqppuqQFCLlKAWyzgXsJoWs7gT9GOM10GayZsbb/7Qxs2bGS4BnLYxnfr5ju65CS6jrvONrnBQIz8XvAs7cFejYRg5s6Jxcw2ZSz6MBiYabx7bkdpJso0CKfdRoA+NsfArpzQ4vq1hllB5tDC9pzI4L1VZtl35poj3UWk7iIjbxT+RpEHpMF/RlrvNP4IZxOuWTn7IDF/qOWkAO6kNqbCjt2vWsZmZquIPuBiNynPG3I29f2GSF7N5uVtDu5FjyrQ5rrybG9eNX22TRwBVVZmwHmIgJLTzR55DnuoXvQiAen6lvvjbAAl5ojmVVMBDsN9/YG0ABLGDSc4IAyNbzPd9Vyga2ZXO7BWLqROrsQqcy0CZtDRftuln0Cx8opP/z8EiH5dQOgrL9vbKd6fxqWilI8V32tqwDPeX76d0G6hgXahr8t4WcoBrnsu64DqRGZh738R+fiu1F10DthOfuhE3pju4DP5zsBOlwci1EjiVPPWOfBXum8VfM5/0FynTOchj9hQ0Zh3FgBHiOBDQoXCrkdrtWjxL9j2I8Pw5bcypIvIBm1RRgAanMASrgb45FgRuYgh1TkbXZ8xhB8JRlnwxgWeX480MUdFAedEIPL7BAdEXf8EYP7XkCi0mX9Es/Akq3GGvLYRPv1q3DaU+fCBEKdQBt2qcldVPX7aCW1lRfOivgEpR3Sca58esw7uR4nXLloVJesAajYn0j8q7/7mq2DZ5g39dhR/buZgYttI7C/QRubvbbvE0XxU0tHBFKNSO3nt9cqFvY3GbY5GMzrw/iEVHURE1xTw+Axu8XcHd3T4GzV3dHZnMTiPfQvQAD33NLrugFZwDU9dV/r6eAT+ErcV0WpnDPPniEz/AZJqjgffjDt7PEv0FMh1px+wEpeu08yyRQ1Hhw4JxPnGUZHPWQL2KR9+06TcKGRFMuUXVC6ItPyPVG6aHsSKXhUDBbb+rckX1ctwTmCA+c4R2srg5i5+7zyvGhb/JoOOdfuIdMdVGml1//LVhKpWP2/l/D1cl8ne9hDHevN7gplC3t1H6/duR3V3sWQAHb4mkT/9AAIHO5fFdwup+jB1eXjkbhvXd/gt9sqhh8R7f/QI90K4h4xFd8gPAhUCCSJAUNIkzIhMnBhg6FQFy4A4gQKbfY+cuYkR07cIqguFgo8SFJJQV/oExJMEjJIi5VtlSIsMyaMm604Mw5ZqcWMVZ6+oQj1M5NQZyOdqql7Bo3Zk2fQQ0mVVmvqrKuSpJ0dWuwVLO8eo2UalKksqzOnmWG9uvXTmbRqs0lF9m9e+3E2b1779evXIcibTqE5hBhwoEDv3lTaHGkxYoB1YlMZzKbNJXPYLZ82TIfyJ7/gAatZjQaKlOm4EitmkVq1ixQmDDRg8eFBgcK4B6AW4Du3rwN5P/2TUA4AQcUtGhdWk3a8m3On0OnJt1ZM17Wr1tfpZ0Wd1zevxezXj3Z+OnmqTc7n219ufbu3JuDDw/dufjy7+Nnb74J//7++//0n38r9ZdSTBMhmOCBEblgkUYP+mPNHyGNVOGCJLEEk4YYImSgTFzQRJNOI4rRE4k4DeUGIYQ8khVXVnl1VSpcaZVUjF5RNQtcx/DolFprfXXWV2VZ4pZYrMiVSz94tdOkk3e1w5dfh8iFRiRvFHYYkYU89phnkmUWJmeU5ZHGZ5CFlqYho7GJBRWuvfbam3HKRpttwRH3W2566imccU34oZx50UlHKHXZbZdod+BhJx565aWnHjT/zBVaaH7zvVffpZhe6s1z6QkoYAuhFlgqgRl+GJFMHrqkRIUiWQQOhBndwpBIBUlkIUMNtbBDCxQx0WtBvQq7A0oUcXjhFSGWkcWIPEFbok43UXtHtYJgm0gl22ZViY034khVj+Mi6YuPP66llo5sDUmkH34wpuSTTdbVpDW22BIYMrkMlmVZhgC82JdkhlnwZpKdCYiaCq/5RxuAtNHmDRPHyQIPicV5Qwkn3MZnnh77FgBxwzFggyBKQWWpfs2dRx6iii7aqDGQ0iwppTd7unKn8+W8M3w5n0eqDkP3Nyp/oxpNrLGnKjvSgbeKNAUqt4DTkazggPMHrls3Peyv/0D8GvauSyub0ENbMNvsGM5Cy7a01aJoLdzZ0t0tWOQ6ZS7ee/cIVylBshVJJoEXCW8hmeRCV1700nuvK6/8sklibxA5CFmNQTLwZTV1gdkaXnyeGcIJZ146wwqfHnEbXmAxcQkW81ACDz3A3kMId/YJnO66h8ybyCOTbMMaKKtcPNCHvrydzC67/GjNkTpH3qTTG6qzez1z6vPPLQsdqtFNJH20+BuuWnZDtopEkRSjKWKNRrdIAZH5FIWNoNi/+kp+seY7mzZP/T3rWdQiihvWgC27eSUtfFvgufgmpGMALkjqIgXgtlQIweWCcU4Sh+P4EphBtIEwghOYwOIQGf/PcY5zbOic6EiXOtOR0BCnM2EcsOCF2ZUANiWQ3Q5jxzGQAa93QBwOyT5wspRZT2fjSZ6ilkc96CVjG1B8YhSZU8Xq6Yxn2dNeEqdDNKKZCnxhdMgXT7USs6nKJPJj1fnSByz0qQEVsrJGGtKYLPThL1jGAtsev0Y+/jkEbcz6TwAHSBQ7OAJed+vRMrrhyGXkLZJxYWDf/AYkHeUCcJlcVwUtEUNXIIMc87rXMKRkOU38ZYQkfBdlWJjCg43uTH8wXeYCNsPTrYl1s8HhDnsYO9wNZ4jBDCLwSnZEJHZxesBgoswmJb0nQnOKNsOi8ba3xfwcz3jS8N6Auum1Mpr/kWmtWmPXcAU1JkghflJo3y20ZqELkW1pYcPfRFqQxwSNjZzJ6t8gCckTotBNkTraGyQlqbcGFrRc57Ikjy4pQU6uJRNkmejlPHm4SZRiGNaoC16QgYxfiMMVmhjpJAA20cWACYVQcCUs82A41MG0dDB0oWhMSIUb9rKXPuQdMYf5u572xpipiAYy28OymzVKeczLJs6iKZ1nNvWJ1MTeNau6PW1Kp4ymIhrSxKjVr4oTjeVjoxrT6MZcmamOeNxVPtlYz3iCbSG9Ykj94ErWfS5LRE0IER7w0JlEXJAUDY1kN+ICyYMmFLHMOGwDK7k3hkJwFpuEqJDWtSULWiIT/60YBmc9Wsp9aVaimFvl5gzWUpfSFBAzTS1M4zC52PXyBDvUAE+BGjLblmx4RGXZypDKKOw8b5pIFW70pErc61EVm1hV2Uq+KsZhHa2r0o1Bc8Mq1rve9axnbWNbk4WrPAYrrmCzZ1xP0t1x4pWfzepMKNobCr01Mr65eCRj61tfvC1WgQvcEUQlW9n+SrSTmfUkgQcMiYmG9iylCC1ZSnjC0pp2MqykqQxX+y7W1jQOnctpCTSAgNraNsTB020yzbO85jm1qVBNsVOrhx6VWfWqy1UPGJ2LtK6Cb7rgtO51sVuSsWnXnPm81UPoh6z7JcieCDoy/eJ5Eu8G0gxShv+EL75h5WHQV771Lex9DbpfBZYrXWJ2rJj/S8H/FpjAFF0zgyVK2gi3MJZnkmlMJVHCQsiZdJLxwg5PIFva5q6nP9XNoEcm1KIylWZLHS6LbSaNFR9XmVBMrnJnXLzx2RisO4YBp2XgaR5DGbvnDPL8vvvkudaPj2918pN9HJMp+6Kz5tIyl7ms2C7rbcxq+fJgG7ou/gKYFWGxBJEGZ4mxpJnNGF0znvnQSjEh7K9ncnadLTzh0eUZpjgNwQUADWIR49ZkxCPUUYPL6EdbUdKNpk6k1zNNSveM3Ew13qYxXe+hdTrf+P70GXvs6iJ3l61ceyeGjLU1Ps4zvPRM1h//WYW+vLJ3GNPAMiQLS/H4DsMXtsa1YsmMpMeK+deRraxmAUfBACNbtGpGMFlYwfKTXhvaZPqSC62dsGhnO60mlIIPve3TQP9cN74D6qF3q0TfohjSkVq3o1tGvaNPutJTjXc27231q/O7uqgyCH8aLmpVGdxWA78j2XZlz4WLt66s1qfXoyxlPoQCFZy1r5ZnrXHE4t1HYGaoJXsRUV+bOfCkmMTdxOKVA7c88VResJBUjlKCuZRMJlytzWl+4WbHHOdf2nnsfP5t2w5dmBQQt9GTufRoPjNSkP7U6Vvvehjr58WwR+68ebtcrFN307rPejjd2tx//1jswrejrsIu/xL8zdVX5SXb/tqeXTMgwQxwj/Xc6V73vEsyLa7IbyVFPmbBixzAnDQLscFy7JMPvvHpbzDmqe3+93cmptXO3LUvr/n7v3/nHe6Yx4QJ7mEWgFCVXomxmNIZl6StmOq1nulBD7xNnaXpWwTyng18GgUORO5N4ATqT78lC9tFGSA9BPIFyzyJzdqxmgm+mvT9gay9gqzZ3fVhX/alxSxEA5IQ1VnUIGV539+h35npCOERzrGFQg8SIeNtSf0hofyhTuVpjoPREM4hIR3cEBOcgAZAwOf9H275gCUIitRJiqK9Hus5kQIuoH5o0bvR3gFmU+1RgwRqnQW+YQZiIO+xiv84OR9JQF+pCRzXKF8fTUSToeCGzMAgAh/EadYwWFkiXtk3sGCWvSD3dR9k7SD4CYnfoRkFHYkQtlwC9WAroIXLsZ/liaK0YdhnROEpomIrCYGHAUcWAuArBtEEaIElHANUeKF6JJ3sGQrzjKG53aKlAWPtueEwXiAcyuEc6psgKmMhEp8HvtqQfc1cjeAetZqCOBkh3uFBvF0oICIj+oKCdeOVXdx9QZZa5OBASeIl/dfIZeLgWRaBzUI7FiFasF8SKmHN1dIoplRkYJ7mRN4/spIqVgADYCEsuuIwHQcXsod9aMrRfWF5OBov9mLNQMcvsuEDHh3uFSMxHiMd/l7/Njoj2xXfeUHjH3qNwp1XNQYi8EmZ9CEiJJwBiHBBHhxYlZHDTTLiOHoiJAKer/nkJFKiQ7nj+RGhyVGQJ67fJHhGH9TfLN2jU94j/J0iP0JhQCLM5jwBx3xbQR5kcSSkcmBDQ4olG/piy5zYzJSlAxpVMD4dRuYMBVoBR8rlXCLjR66kk5EkwQVfqKHg/jTfMmKjSrrdgfEB9OnAEmxBf9RBJmhUR+kkY32cr6GjXACl+AklEQ6Y+c0j+rWCUzobHXxO5KkWLVnYTEklQL5LIuAfFIZmmNCACFzh5/VJV/rGnyQFUd2iuzlduuFi8uSi8+iiWlKdGEpRVLGlc9Bl/0cq5zBio1023HnhJTVK55DtYcEJJh/eZXOuJK6YSWfmQWJyWg3YAAbYwGJ21kblJAx+4yZNln8B3g5OEGYOpSam3GZ+YnvRH1Pq5+XlIxP648zh3Buk4lWWFl3FpkHSZhB9wBp0Qi1qw1jKWOwBpy46EzMZYKOZYYS2ZXGuobzJ20aCaHIuZ10C5nbqkbI038MJHB6hIHSW6ItGWRpMAmcZAhu4BKdhAHmCCCBkAk6mp3y5gkJJ1jFkUi702t5Zpnxy4uAR5SaeWSssHpO63wqtAUDmI2jQmeV95pgAaFUOaEqtFBVawFYmaBAZAOnhJnw8aBqWW3ApoIVGXdPhzP9w4uKGAuMVsZ5GiuieZufQMN91SqeQCSpf9uk1GiqMRqcKooJScgGviMAHgIAMhObhLAM5cFT1+Q26xKcOUqJRMml9AqF9hkJoWGVr8ueBVV6XQl5lWCVruuplPAEQjIAGZMC3+R9tMoAI1IFkpWl+DOBTgaGiNZH00KlZxqlDUiiHXiSlKB2fjuizauehLmPytagbmSQ1Qg2g2lXYIcFfFqoJLoQKmsHZqdFAQOqnfUATsIErWKpeeCNklsIkRSYPhpz6DSXhNamTbmZ+npb8zZJS6tmqAuTMaYtqEmhLqVQX3GgGANNslqmh1UAf0GBYWiSwSiSkvMyi2V5vOor/cSYazuCph5LbihljiMpAyTprXc6htDqZ0mTnSVInkVmnYKJat1ojyyIqrrSk0yzsB1AABYiADGTAz5bnRVnqPZDDviTJTuZCyTXtZYrfpw6bklItv16GH7Dq5QFsSZnmlApslwpoHRgshBlMmHYB/VjAgQYHV+KqA8CAJPAqhBarpyDPWZ7lnS6ReMwY3aqbW05KNkFVygpu0JLonwKqNL4ssnRrrkQnt3pg2YkgIH7rSoZrhcTkHHbBmjjBo8LhGdSklYXU3JVCkBYpvQYl4axZfRbl+pEqaIqOaI5m5pwUDH2tqrbqg4FpwZjta57AAzTsrT4sQSYBLf6q3O6i/90yisfSad6GLLImoJ2KLMimm1eZ7OCKKM6GnbAUi7fi5Ym2GuO66Alu78LtG83+pbcKmWH+CqsaQkbNHaMGQTImQRxs1k1W39J+I5Laa9WGalLu78l5JoRR5RJubX9uKdlyKcKMbR2EZkpVrsz6mc8SJE+xLYKGmHFsQYNGw5ouJAcvL/NerN5Gb2/NTMfO7fGqochWEUXuXnJS7+DGU/kOojT6EfYiSDWCL6H2pZL5ac76CrHQ1Q3rbB2BwASkKx0oTCnYAim9Aios2OXawHj+bBccYij9aJDS669R7Xw26eoqHmQI8AAvhgyVVMBU2BOOSYRdJZ55wRtgC+u4Uv/nhOka+dnPOkBx4LEFPywRGcfJMEM1UGwge/DHgnDHsltvnfCjGbKGttsIM52eWq8EiicP42zCUbIND99eWqetkG8Na0i0lij63goInKtLyKgmNLFnZRwgdMEJUMAHjCcMLKZJWbE3IqXpzue66GuC5Rop3PK9WlSZvJKcXZS1JbDoHHNkeMEJVekbxPEcs8QIzHAGMGwF7zEAui3cCrKabrOyTihFLhcjLzIjo9u5HauxNuCnoOyerjMxnp0ItHPutaw8JRzkXiPi3pPMimRIMt8lC+LKGq7BdW/leprNugo6MSYjasIfmFAXnKsFDjBGWfEytIJI3TLj5e/fIdj/J5Luev4vvtIflYYO+xKwSZnxf6ZxMjMwA78B6Li0HMdqEETwo1KzHbfiNYtYNvNIN/+icR7ysibTOLPpN/Omi4Hw7QkuJNcl4RZuDLuAXz41JuePXu4zhggLH4WXXIGyMnJvsQxZSxYjKX9ABsyAITRx/PyAwp4ABT4q4RpEFPvAYqoyJHW0gv0yKKrf6FY0RXs0ZsLcZ6oQajHMyqkZSiMsMnuBwTpzFyw2TNNA/NJ0Tdu0Hh9koRGHccCAQvI0fQwyCSsv0zFg1A01aFfoGCJ19RZuC6ssU7M2a2/1D3CvDWcvXQ2ZeYUvOSHZ9vLba2+ry6aolAlBDECqz05A/3GDQEVo2GM/9nhmgFhL9s8CbR0sRhVn3Fzs9V13Ypgxlif+8uyiNAEPmEnbkmEfjGmlEEsgi8I+tqcR7lj/bAP8rAHcMU4TGjH9CfF2MwczJLJurJzOHgnzwn+vpX+H8HagJTC+MGor+J6+MwZqL29vdVRjq/ZG4ztR9ePWTwk6Z9v5ticjwRsB93CLODY6gRzf0AkUcQUY97lmAETzo0R3o0dxN0bn9SNet7169+2yF2NQ1B/0uAyVKpx5jhyjikz7mZFDNuHSKsP+7NAS5HwHVQCuLWVTOUKewST0yDZvNgEe53DS3oqRs3FKZMw072mr9mqHJ4PrW4MD9Ay7QP/+QLjj4hO4NuPj9tHY6LYM97Bb+TOvpDdYE0ukSoRbn0BFLDNag4ANaEBrc1pFfJJjzvhdXzdfi25Gm1Qw/2fsWhSbHdgqoXHCPrByQ7afRTGpz3TQLroFUPPQjvXQFndxP/kdOwCUTzllWzYfYzYb1GRT8Hqv6zdvXUN/9/dPC/iAl/N/R+SYG3iyQuCZqzmaszmj8/C0S/Obx3Y/3/kI6hH6zLadO7X2Si5vs3mgwvmqfTgTeA45rVRwSzNNAy0UjMZCiMCSW8CRxy8FOvaVI4M12G8TR/qkt2ClI2WO+yN/KhviYakTkq0TjNNud1oVQqqif0CqT7wFLLqSH/n/vEeqkjv5rAdgrM83rVc5rhPk6GWBICTFTvs6rwdysLv8y492Cof5nAo76yUKJuC8dpS5f2eVs0egeObYs+ebxgvLxlPyU9cs0kt4byufVu+RioKkSoT7J4u7VMsPuqtV+ryzir96BXwNsJy6E8RBIbQyxtM0FGCULZADvw+DE69n2zdirOUvKXQt7ooxsb3cv3q6ZmDGE6h3hhx5FF+8q7f6qhu+qqO6vSe5qI+yqk8AA1zhk9c6uIX8rHuAB5DnXvXBELKFyrP8NLjDNIh+puz3y6Mh6c98zbubdYACzuc8dyC7T+OM0EeykttTe78zKbd7Xb25wfX+of4+2k31/1WDnbaW17XH+T+z7AMzfws4fgVYgNEf90jw7gmsFMRDd5O39Q/IaGMyccCzYHXnr1Jard2PDo//+Hh/Sbp3CHvnmwYwN5M3gKrT/6pfvL0zfv5DAWeoE0C0sFBhAgMGBQ4WUEhgQEOHDyEudOAAoYMJHiZ68PChRhMtZfpIkpSq17Fp096hfCePZUpuL6/FlFltJk2bM8uhy7lzmzSfPX/e5FmOmjReoDAlBbWKV7Ki8IYKDfqzmbOgNnzogJGVqwyvMbaGFTtWa1mwZFukPauWLQgQI9S6lWvBrQu7LVzs0LuXb98dQPC22CF4LxO8SIAgQfxDyWLFjCFDVgvYb//kH18xDyZsWfHmypCZmDH8lgmfP1AEj5hhl0neFhvkijgBpUuRExoy5NadW7bXtz/MTEJly1o7cda+fRu2fJgvVL6gt5o0CRKgOnTYZD+zXft174AKhRc/Hnz569trB/GtQQRW2QMpfNj94UT93u/rB6Gxn79+GjxoAwLA7NL4I440EIQCiBHggwChhSKKEMKHDCrIIg8o8ECFDWuAYQw3QBJklFBKCuUklVw6saYVZTLHnaiiekooomJ60ZmmkFqqqaZkhFGqoqyqKkhpzOqqSLSORBKt9tqKawawYpsLPrnY+suzz5jQ7LC89ArtSiE4w3KwLL/kKszPzDqzMDD/Q0sDCRAq+AAEM07TKy8u6XKrAQji+68LKOqorb4878NMsNJaIceaRZFjbrnnpKuuOuzQ+3MN7ij9zg/rzCvPvPPSywqrUdkjlT327EtV1fz622/AM6SIFcECD4wDEDXUSHDBGDIwiCKGIvwVwl99tWiCYzHAQIX4OKzBCo88wkNaPEIJicRUTDoxWxVVfNFFb7+FKpsZaSS3KFxEYUrdHYEa110fbRpS3iTpVdJesOBiEi7NnmQyrijd2i1OKtHUazMu/7Jy1yzVbPjMXb9yuGC+yrQsNDMEOnZOAVmbAYQICAqZgvhU8+pPBfe7T+WSf4Pij+EYdRRSSQ281NKb/y3tjsDvOj1Pu1BlGPUEoVdVj1X/jtbPiZPfaLpWQL2o1ZBJDLS1kDgM0WSSA1GWgk0LDgqgIQwSjkChBSJ44Ow4JyhgAgtWU6IFClTgqIUszGhCsCZEW2IJPJYIKQ8+QiGlcOhM2hYlbs1Z/KV5sGERXHKBQZeWy3c0Rsge34XXKB6HNHKt0e8tvcm3CEYdYD1D9nXg1ARDuOCFGZ64CDAlHkx3ycC6zPffeQd+9jAvHi2thf/i+OM4UQWiDUMUZJVjBkU4dWXUYxCCD1RQWZQ57kn5Q1I+bP7TiY+4wBlTTTfl9Oc/tVBP/vnzo39+pXlotbY//6sjE601obU2xP8BULXKxDAMYSsDvkI6CSyEJl5hiEEEMA0VmEgLzCArKYBtAq1ZAEIsgIW5hdB9MLDbDsCjuxaYpnjVWYIZqmMGNrSCFZAQCUl80Q1ureRELcEJuOTxrZoEg4jFwBEuMgcNznUOXkLaHJHqZSjTlW51+UoLwKZkIYpMBFl1cQFpnoQmw1DsMbnL3WGEl0Y1prFijEmMG4uHqDQAJgOrkcJp9hMBVHmBal4bVB15gIX8wQVVLFOZW+g0HHIMg3ut+IP4rCMa86knfnhbWs7WdymfVSp957NfCeyntC1wzFIDAsL+TlbATGztOlP7H6dspQlkaOJq1smaLSIYnkkwcmr/fxBOGkAAhNNoLFcWSYMiLKCQCvzhi7GCkwjAIwI5/eB/VyAMH4bBB78F5w8vbAUkvNmKMlzBDCAhBStSca2XwGQlPOyhiloSj3TEpIj1rBwSk0guIfIESD55ok+iKMUpKqk3gmlSvuYismMZZEJcHBghS1aZ0djOjMIDDGVEJ7o19k4rwmtjaErjppBmaTcRAEKssnQb+5wqN3uCgAY4NkjVzPR6h9reIsEXvppJ8nb3M5/6fqazn3oylPib5M1ehTNA0SZqWHMFK2sVS6rlSji8jKomrJFLpw5jlYPYZSsKpAnDEIQJfyBIGlDhAgccYJkuiEA335aBJ0zCB4h8/xnG0oJWUozxkYjJRDfN0ApU5M1vffAFKcYpCEGcE53YUsm2UoSimUxFGJrLXBH1Gbl9vsuflA0o6T6rr9OJdnWsS9ZC+ZSQCTXEInLRneySh8bXqtAwEDsjRi+6Ud1WtGGlGatCF1oBO6F0Py7NDV2OG4KZKjdl1usN9nqA1kai4pGPnNVRe3o7VD6BqV0oHyeBNr9KDlWpqYzaeWcVNac9UBNNm5pXtzbBWh6wFI70lGDr60BUcJVqsqQu92r1F03MTQ2KUENBLKAGwJxmIPQ5gwk/gCADqQWtpxHMI+/21xlwgYZ0kB8gaLgFN4yhDIYjRR+kJYnD3rAkMOFWL/+U8eIiygJzxRhSiyaX437uGKAD9fFYSHvF1QkMWallqLAoRJd8VeZgFEtMbdtIvMBMJoxV3u2VcWflMKVBNGkJmZRoegIhQAELghRBA5Q8AiBMYRBqYC57SJC/5lbvPXiRwgSnS92qcTlAPX2Cny8J0lSSt5L3A2WggeqFnaHXO+4NzxseqFUIuoLSB3pFm+OQ31fgilPSOeDWXiZpXr4Cgdb9gyIMYyA3o22Ydx6MnKgES8CskJZ/uDAgMkwHECRhOoDoKXUmMc4k5KGGvshDYlmB4mmp2BehKJw633kSGNP4njbu0UncMQ1wTS5elO1FRkP7Yyv2a8i6KbLr+GT/ACRDhIt02cuXYAfbMZppt4exd5SvzNF8l9GNkiQTwZjgtR2kDc5YSCAJSMAgC4QACwMMwQUGguYLLHXO7VFzWYXTyOpWjX9s8rgQEL1dQvtZlE8uL9SuE1UFigfSkE7gIHA5NVK3V5YyHwR4ZmmIS8+Xgf9LYKYjSDVFMFDnqJjqqVHBB7TiqoIgGAQQINCCRzJBTjWYZgLLepkVOtAwptl1Js5Qx5/LL4HBXhogEItOZENinCDCAx8O2wdli2REJpr23Wk8CszKBNvg0ja3KetPIwkNtAMNMrn/JaXTntvIDH0QsJA8EQtEwLUUZUvt6L1GKD85M/tmo77F1Jc2/7VmNHQBqcIjjuZYAciPaXapkWEK8sQQMm124cMgFDF0VBjYQCAFucgB9PHfE3q7ojy5ohltNU+RxxDj+eotXXFzSgSdgVizRSmK3vyMy1y/yCD1zKlG6ps/knvSrxpenq6xvkrTLT+AXllHg7WyAvNAbwH7BHzgQF4JAXpiVcx0rgASEMubwMmSRowPDEdaPmRaHkGx6K4SIJDaiIjvGEfb/k5yeCzcxA202K/ciMzIGk8iiGW1QOh1+gJhIAbKPG/eNAPzPA/0tIyiQGOpksd4QGYBumjyXgo3gglX8iL10EzikEs27CLhEM4u7ujUlLBmpkf2BE1AGoPktOuUAP9N5JTqDRhtvZxPl3qpC10p51xhlv5q+mQO+7KvFCLIqZ5K5/4KEF4Bl/br+h7JFmzh5qTvFv5LEY6J/IDpmV5mB2CN1wZjwlZoEHagQErDD+jj/oLAEJTATSggQDLhCWRDw9AubwKrm7ap7eCO7fDgQxYQFBVwD0jxEdJlRGDsJNrJhyyw71hE8H5sig4pyKQETh6gyFCr8YqlIrjoIITFodqPyt6NTGrrBQUkYTAKBl9w376keMZE0ACRIAiO8hgufyZPzRquDXhABydv4ZhO4dSMNb7opDiturzmTlyF9HwPeVrl0MjLu+wA+boAC+PAaVxuC/trOvJRglwJ+mD/Tg51jhLKMGt2DoK0j6twrtbeMPysCg596Q+Ig7rwEOkGIQ0nav0swH8G0dZAIA0y4cISUU6CjWwKQQZoowLOAEwMQQbwD+wwSKwyrACzYJsUY3vA6RNJLBRBUQx2Eg70YA8cwRFMARVjbBpMhCXmSceGiPA0cAPbzwMXDxd10cjUrULiaiIUohcfSnaOZzLwTU2EcRnF0mAsyhnVwmWoZuAIzhtzTwpGAOImjwfQQBuViwdp4I6wAPUeAG5kBQkbrszOER1JqQnDLGXkx+S6QFMK4RPegDGZjwv1MTJXaTIpcxLgC+YYaCEliOhk6ebCsL5ITR8Z6X9yTudKbTiM/+4PhsEaHvJlsioT5HDodK/51AAT/+rCwA7jqM4j08JArKMSw64IVrII6M8rSpICdgDskCCw8CotH2MmCatwMFEBdbInfRIOePJDfjIoR2Eona0oH8fFhgjcNnB0Dq+0AiYqU6sgQHAq11NksFIi3iY2ImpLvjJ4Zs22xjIGV9BifC9kkrD1ujEcL6B6bpEBDiAE2qANYiXh2CMDbvD12OoCSCCYgqkvCTMdBeTN6Kw3lOvQSsBSHG1E7zESTDQy4asyVTQTcI9FXdT7Jg004RD8Zg6Ccu6AYNT7mm85qIYUcCl8VtO+Qu2ReEn3ZnT3fJO6OCwTquOuMqBA0oJOCP9xJIVTNtigrOjjOJmgvWzJDETS16Dz2F4ocL5J2NrOAMtgxNTUJ91gD0RxAacFD0yRRMAziBhn8GKRA0cLPT8wuHDQPduzyBpkQvik8mTQTiYmLPeTPxlVGRVj9AbOtZBwV7oRAlzKpQzgAeoyBHpApvbEACw1VC11L/dSAz60Lq1HAi5gVVVjLRuswUogVk/pTwgEa7ywC1M0gFxUV/9nRXl1MnFv5t4QGbzvUWr0RumrqjQt53wBgaYjNHEUgKqKIS3TRjPT02TOEh4oJW8ngSLMEOQiDiJoKxgRXDvSOkSSwJoOA+jELSaBDcICCfrqUalD2Kblb5ZgAfH1TUX/ESet8yelRSiHsjudzdnKszz5VKFuUSoBNRcFtUEchLXiSi5QsC/uky9a41A1KvM4tj9lyE3+QuBIg/UGCQiTy0E1gEIDqeFC4FKvkQc6NfVWFS7ThlRt9kDZ6hb3ZGdnwx61cDpSVDh4dWh9dUVxD2jxDEYp7VGWVleRldJIczJbAQz5yxJKgVnF8H+4R+aq9vuUdTK5ihVcIZLO4DbpBAasjgteARAWMTgtgcCGCYXyygxGhgKuwNZUoJuqjtbMoEvCR1oI6zGkxW8+MU4Ldwz+Bk57kicZlwEFNhRMQSs65GBFC8gQrxbTs3UY9j1z0VjeM1SZh4McAkFNcHfI/1JjZyvfOm9RNW/MEgRB8GRA76zNNKBUceMucQ8LZhbO2uDpavcaOVWQdhbNDkAASlVnizd5lRdUh5dn5/ENNoESNgH3LtMy8YxosVdX86tXjZY0ew6CpDd6NyGAoFZqn6q+pJaXlqFqny8Me07jhFYfP/NraYirypcLHxHXkqUFtsb+6Hau4BYJ8I8j6eq0dACcaqBOficU6gQSkg4xAndw/SYn8dVwLbg6x4BxxUBaAHZaJpdy9dSghAxgBga4NEZUAzWFA3UvCcLxxobyfqNRLe+LLpZ1961N5ujVMga1RoDpShbOossLaOBBLQABGuACFrRTH+53m3dnByBnb/9WAJ64eB2ieBvAiNmKdHngEA7hDX+BgVo0jLW3FMI3e4u2env1Db93fMmXaBkLfdH3jeNXfrdXZugY2MSWFSZBbNcXakHzfCezPDwmAw4FkYQA/4Cpg/hghEbDS+uWXQXiY7FjCUiyuvo2LZ7zhSSYcAHnbwBnWhR3J0V5J0F5DEDYXsgNoaKkhCGWYV2ZARgPhWW5AnDwF/lkYEz3M7ikYmTLhmVYhj/uY4UATqRyL6mHBBoUHIEQU4/4VE1giJF3eZNXig8AbVRVAhBAmq3YUpPXACQA+dCAOMThFqQXz6avvsqYjbMXjs2YfIk1RzOTe+UZv9hZnldUj5/V6CT/s2i1tp5XtNe4DBDTk5hHiEoyd/FGRj4U2m6UxaBPaDMyeTr9ZhMNl5RHuV9H8ZT19HKxiJij0oRfeWRm2WH/FD4bygHcLQKAeU0MCnUj5qVXuj/ZZI5GCGReFXVwQ2VhdolxNmeNeGf1iEKjCwtIoHZ/+gEU4AEkwAQioJqrmUIptGaNN5upuqpNlQoYVC4pwRaIoR3wkNTOufzaeIz9WZ3X+fuWltLMOhPymKxVdJ/hGlv/+Z7pGp8rs/d0QD4+Oir1eq8Xb1kSWj42osjUAlr0BpMneqI7eRQ/mbEzWA/4VXE1OoT9pdw8WipDWqQze6QhNvLmM6YlyqV9mVH5/w0JpKBvI3VA10xAm6cHeneDmtdUdzqoZZsKiJqJVTUETOAGSGABlDcCNoAK0OAFNuDhkHqpF7RleZZBsfAGGu4VuvoWYDSdx7qe2/ms2Vmd59mf5TeuSQGuuxu865qf49e65Eaa/Dqu0vu0ADtZBpu991cgqs4jnrOx8WA6LfhwcZI6RxFxm9IpRzihbJFtQHqzPXezX3lYNKZAqyyiqowFFXW0HRW0IThj/6VjulFmcY8uU1bi4swFaPZTkZgKTGB3jViqp9l4N+CZeyAKcACbJYBTe0ACEiC2OdW5AVMRfkEciIEOL00TqJuN/diP3TqNxdbIuRuOWaGt9TiOm/+cMkvhu1WUsbz7ycmbn9GXlWhDLdYbWTDko9v7rzFgblqgve/GsAlXsQs3v0t5v/31EyebsgP8dUq4wF35zhH8lW0ZB1X6N75oNSJcwj/vl98EeZ4TMU9vLmSZeVOWU/PHuDv8iiHAqZ36CHUb4bCZqqmZmn270ld8AyCuZpuX0mVbubGADsXBOOqQe8p5ujZhjas71st6E56c1pWcyW/9jbN8j51ca+WYyoHdnqN81+ea13+JphOKwO1czN17fw1YWTBgI1RAyI4AsT2ZzQ/3TdecxJjyv+W8tFj5oJcdzzNbKzGbliFg3Qr1N9QsdlaDwm04TWA6MJJRonQlMHX/EIWv2AJ2d6l3OtSretKP2mZV9gY6FZuluNNNCgUgzrf9fbeVm9KxWHmNywTIrA0ooR2IocczU3p3r4wVYa3NeshH3tdv/eSTnK2lfMlpSI5b3tiNfdjH21dp6K5vrg37UNzHPVnCnNnZuwXe+wiaQOjf5G7KCdsdG5SlxdtlcU9X+cuYZ+fJferPvXUoQmzGpgKoUTWMEN47VtB7WZdlaDRcgMwOZARG1cN7tw0uQAjjzOAFyaiD8AECiQpm/KlJAAV6l6mT2qmDm7ibeqr16AXQ4JkzXdKzWd2SV9JNKlawAObaIfJ9/BXKOLtLHuWPPLv/WPOltvN7fdh1PfRf/37Jqbzzhb2f7RlY8Yv3+MB4Drqvu7yhMeAIKoDM6waw66b2Z5/om0AvPvnoQbmDMfpDmL7pocSys0jqqX75yV3dX8dQvT76fzkwKCo0RJYIEyjUu5EHsHrGVRWoW5wSfFfuNaDF7b7hFaB4y9/ui7upFyCpRT3FFZQKcIC3QV3SBUDiwX8KcgUgpGBpo4hYu1u2bL16VUpTKUqbIrpy2FBipk2sMl3UuNFhx4wVS4FsOFJjK42kSGZMebKly5EvVZb8yNEkzZgsUaHK9CcNkgoVQHwQOnSoig8YkirF0GIpUwweljad0KLFkaZNj1yt2gKJGTxgw4odO2YMWB860P/KUBujLYy3cNPGneuWa1ULRIsCzQu0r9+/TicIHkw4MIPCDiBASDxhQeHGjRkUGECZcuKhIzKLmMG5s+fPoH+IHk26tNzQO7ru2AGkRevUq2PLZsIkDRshFiAUYABlEBYXQEZYiHBBRIQHyBsoN3BAAw8eJJ67CHGcuHEEyhcgOCBAwIYePTaY2LChenftB7YrWH9cgQQTVNBQkbB8e3rsDZg3cI5FinApCVnTDjG3oKLIQxZ5FBFNNil4k0wiqeSgSx6VNBJLIF240kwkTXgSSzWlBOJJO5Fy4CRpYMUXUizuFdiLTgnVVVJTWWVXC2ORBZZZYrG11o8+1kXXkF3/3SgjjSvyBdhjMDJZmGJORimYAw5MZlliEci4WQg0dJYZaqaFKaZsorVFJldMsKYamT/QZsZtIkzAAAObbSZdCBfkhtyc9+G3nwZcgofncdwV2ucC1UUg3niK0qfdepBKIKkECUiwARU9SIrcfSVkykCh+uUXgRTyUWIQMdYsxNCEGDHoYYMRSqhhTDjRClNLGH5IioghegTiJDX5OqFOxA6ywwS5aalXi1SpGCOSKrLIFVNclcVVjjuGNcYSYQHpbZBCEumlkcomGRRgzEqprpRQDqYYY5H1VWVluwWF15f4gqnvmPvK5hoTRca2ZmxCuFmEUH4BId1z/Y2QXXYX/wTKgwYPAMpDfz2YMB5+kCJHXnkewwcGDoR2vMELKLywQceWmnADCZuGYIIE3D18HwQRmIBFHGkY8oo44hCDDEQULShRq7CyOqusLQ0yItO28vrS0xw+DavUFBb7BxN74ZUXwkhV9eJUz0pr11VbHbGt2mqXhYfbb5fFLY94iPut3XDVSe6KfunlIsJLriu4nE626xiy8s5rmWJe58tlv5DzyybArrnG5uS0CTGC5iNMMYghIYjAJUFT5KkBxQ2EcEMbbUzcHnIkHAJRG/S9PqoaU8xc8ndgTFFepZBysHICCqQnwHYhyKdxCZNSfHp79x1PwhS4C6TILUAjlKCCCf+y0qrR3kN9K9UwkX/rh7XKKjX5OBX9R0+p6Ya413wLRvZTT1mFJLVD3QhtE2qrShPKYhYCvg1beANXAvf2tb3UqG+AC5wEB7eud80JSsl6gG7otZsFaClfq3HBwC4XOTNJLkzfEs0TagMFhbVmc8JJlBQUoQYSCOdPXDKdzRqAhUG04WXkcVTFSKApSBXKBGAAz3hW9qjuHM+J0puZy6KgiEWw4ASnM6J9znOBi/2GBFJ4RTvaIY5fHO2MZ5RQhcTHRlu5cXwbmlqEkhaSrJEERV7gARYzMCcCEOAyGQhk2fYntnJ9TUtZMhK1ttKVATbhbUvYVra6dbcFiouB5pL/VpMmyEkKVpBxEXDXbugFShCMwIYjsFwJT8jKVqqwhWkSQQQtOKoWTkdSWXxYcpTzPECR4JdFBJWh0tOoDXAABSgIohPXczz1ONNSN0ADCzR1KGfWLGcO4w0lEjLGX5hxe2sMH0WWBkeT1LGNb5wVrOx4TmLxJA56FGQf/+jHC3ZSkwzcG7lqwE8bFakJSAAoAQ1oQAVaci56M2QmabSkWd7zoZ6EV7sEE8opBaAyOJNRlsblAhKu0pUoDJPBhGI4KCXnlM+BDp7y9CfnRYylCCDOL8uTJy02ETnVIc8xX4AyJtrUpi0L4k/Rox3mpGcEKn3DIX7RzW+Ks425KEVU/2PVznSKJFfog6NVSVS0hijCaYao4Qn4OE/JMMePk5mok1p0yELqk1zkAmgjHQk3HhWwkgY9zSXtolC/jS1dDoWoJ/9iQZO2K5QLoBIH58eVj4LUo6FJ4SszN8vhWNYFWJhCeDTWw9Lh1Hk9pAQVZvanC0QssyrT1O7AAAYi5hQFQwADBzpG259WalHBPF7zNpWe/BzgMCVowybEMUZxTHV7Vc1FVJfLiuNu1Xu+SF8ct+rOUqhKEz1pYZzKagArofW7h1GXX1uQSBDA9bxGkmsArSLQgEZyCdziVt2GhNe9JtS8h+xb/lw0wXQNdpPsKqxaRblYB6rSsY+VXJBGo/+wNEghTckypUA6KoXWlQCLJwguGsKDuv2EgAo+ZN6hJEAFStDQta+71MuA1zEOjIw8tR1qTMWDTOHRNIi1421+FJPhi2WCqWVEhnOfysbmUjW65ztykqGr1VtV14e/2e48vfvdKqdVSkdRilvLhd6qpOZsAESCl48Q0H/iIb7b4lF9DyqkvhpSKhCMs2D/GyWJJnbAieOgA+gHQgRDVsGSbdO/0hDL6rgAd2liaS7T04NDqIHDny1Zn6SXsYxpzKfuISp2mKkAlHHg05TCDvFsmwBifmcKrMX0LncMpRM8h48lGK43h3wrZhBZqkxuspFbgWQ30qrXLnEn/DJTgSn/W5nKVpboWv2GXy29tbHpLVJ6xSy3M8ctkvTVq7bFJctpKRSCC41gYAFM5yXZ89xq1ZNivauYD/r5z2Ba8Gf+xcKRgsA6iPWTfUYgBSVCx7TLaSZRK5ZjEtzg4CDTtDPZw56PFTHGztRtBFKmuxyv2lD21IAXNqFc5TZkyBg5xoWmumSoAfvkTEb51LIrNmN3F9kcPDa6CcNW/Oav2dKOdpd13oS51nW+bLavt4vSVob+rS+BHfecy/0kKDnmcHkm5b2q0ud3mzCkV//Ma4BDaM2poScxTOxv+ZSd4XjYZRnLIcU49gCZHTxPMp0CFXCQTOG9DuIzdtnGFi7qQ30H/4jjMe3dFdOuExShC28A1kTaCROOfxwjHVdyrFROeTcaqBUsB4EFj835mOsZz3COVlzJq/Oc75yuc4VvC8aw+rxu+/U4H3q0iK5JpC/99kwnTHhBDxTuUOaigDRl1WewpuHXKbLEz7ryhbQaFoKACah434MfXNH9EOd5aDdBj0H8hrVjh2IkIAgaSKsdSaGgiouYD95p++lFJRzvG+gAa4HYA83CrOyGh0LiDXGIrmLE8eYEef8HgFLVPej0EsAWEguBK3HgBEGgAXKyG2YFc54Xc8AHXvbEJM0WFLGHXquxJtL2gTfyZV7WeqxnLSb4eqchV0J3F22VX/g0Xrg3g/+3t3u8txhUhiWNkxmPM2/e8lHLp3Vp0ny1sRo942B/QENwlyUDMQUj0EVp10vRNFouBTuXtimcdgNfRQU0tX4IcDI8tVnh0YUQh1uI0mht0G+qMxAbMREGaBHQlUYBiGu75gpIRmuSt3jn5BtQsBY4SIGdRy8AMIgVKIEZuGwd2FiwITAkaBcCY3qcETAlyHoC1HqSqIKYiEkwKC2AYy6c5F+dlHsvMmAzp0GDkYODsYMmZHzHF4SdcYmuSDBQ4BPP92hcR30WcAEV9hsE12EapADx8QYao1qEUk3YEUTfYXejVobxF4Y9cEzJdHdaNADXdGiKQDQSgY1oJBHOZTT/cvh4efhxvWZrdwiOmuBDDShlafVy7MiOHHRRvxcAgziPMWcAM9dQHJiIpxeCkCiCxFdmjVSJ0OZ6maiJbpYBfKMk5EaDC/lfFsQYh3Mcvac4A0Al9iN8rfgjGbmRgYZ8HCWLArEa79Ma0XExLrCEosIxfiKFmIJiOBVqMTYpnyY8y2hEAncyVGB/NUaTDOcegfJ1B2JiC7g9eliUdXQ04sRctxaOR6aHb+Af6uaOgehd8CiPVjmP9BhzF8R7ojd60zaQ/vhlJJh8AemIArQEYEmQ9NWBbpYk0yJnDRmKcTlYiWGDTicYjpEsxUaR9eI1QsKKqxiYZOmR/zgbBvMl/ztgWRbAbz/0ftlxMwsHhf4WeEVEH7nVHCjQAcj0frTVTN+xMYrSO8KDAnInd4NwmpoglHa4mpfnhgP4mgOoXLPQf+BTR861DKzZlHoICHVwBjNAVlMZnFg5nFdZj/cYOHyljyVIemM5bbABif+keo2FlrColnJhkJuIkGx1Li1ndBrIkHM5lyV1WMnCl4aoij7IkemZFmwyQqxBJgYTSomCWDxgC6KlMf/GdxAzjPtBKko4Ke7RPB1zH8bUU6pWW9VRfmiwCKyFftdoNBDxCtjYmqzihlH1Pd9zEY63IEopjnW4EpEHCb5pAxjAXWk1ld3xXRdFnFg5AIRonDeIdBXKWZ0lKGZe9oH+uJyRmHNo2aMlGBAAIfkEBAQA/wAsAAAAAOABDgGHHg4CKhUJLRYGLiQQLxgGMxkGMxsKNRgGOCIMOSkVOzMcPDcjPS4hPUUpRR0GRyQMRzQcRzcoSDkmSioVSkkwVSsVVy4YVzokWCoLWEo0WUQqWVU6Wi0WWjIbW1pCW2ZIXEAeYB8BZTUbaDskaGA+aGVJaHNWaUUraVU6akszalxDa0Eda1EsbDEKbo5rcz0nc5JvdEUqdUUmdUosdjwXdkozdlY7dn1hd3VZeEcmeEo0eG1SeIlpeUMaeUYqeVEteVxCeWRIekosekw0e6WCfFM6fVE0gj8Mgk40g1M2hE80hFU6hVtChkQOhlg3hlk7h0soiEgXiIBfiJd4iVY5iWZIiWxSiXZZiX1iiYdoilU1i1Ioi1k1i1o6jHFOjJ2BjWE9kKF+kK2LkY5xkk0Xkk4kkp2Dk1w8lF5BlGRDlm1SloZnlqeIl1o0l2M7l2lIl5Z3mFYomH1imIJdmMScmVQbmXZXm21LnHFMnNClnWItolsyol0mo1wdpG1JpHxipnRLpnlWqGEeqGk3qJR2qKiJqYJcqYZmqmUoq25Iq3tVrHI6rXAurp2CrsKdr8+rsX9hsbGStGsstG0ztH1Vtrujt3pHt4pVt4tmuIZYuKJ8uXY5uph1u3Mtu5NsvHQ0vIJJvoA+wXkuw3s1w35RxHo4xH1ExXs6xZtzxZ6BxeG9x4I7x4pWx5Zqx5p1yKJ5yaiFyoI2yoZHypRpy5Jay72hzIQ7zMKdzpFNztCzztzB0YY90aZw0baT0oo+041L041T1IxD1NvC1ZJL1Ztn1oxE1pFF1quF2JZX2KV32pNF2qJq3JVK3ZpT3plM3qFa4JdK4b+h4p5i45tN5J1S5J5Y5aJb5qFT5qlc5qt25t3C56BO56Zm6KJO6LeI6buQ66RU66Va67R47MaW7atj7bBf7bFo7cF/7dGs7qlV7qpb8KZY8KdX8a5x8qtW8q1j8q5q861a9LRr9bFc9bNj9sqU97t09+zQ+LJe+LVj+Lpr+ciH+8N4/MBu/OS5//zoCP8APXEBlKyewXHj9ilEaNCfwYX7PC0C46YiFz1tLmbcyKVjxy1QQiYRGTLOnkSJJu3ZU4aMyyh1Bk1atGnTqljBhjmbdq0Zz57bggodChSc0aPpkqoj946p06dNoyalRlWZMavPilbd+cvWqVKiTkGrZsrUWGik0I5dV63tWapw3cqNS5er3au+rOpV9lPr0b51i1pbCrWwYcPw5ClebI+fY4WO5YXDNtjw4Llsl2bOLLVzU2nc2oamTNowsqs3GanGKboaM9Gj+gjia81n3Le4f+YOPHc33cmbuT1tTJwxcXJZmeorvu8b5OfQIbcb3a54Ys+Hr2ca6O1gQoYQG0L/pGWxvMY459ug/wiSZPst6lOurPMSJp+ZlmTpv7qTqG3AACJ1mVLYRUXPdfocqFlV/PX33zTMFCPLV6OcAgxaZpGS1lhpZbZVMb7xBtRdduW1F1a/iejgb8AVSBhiBhpoXGPPOfbUi09dRhWBLbLjYzybrdNUkK21aE6OPuFyU02dxMKajq/V1kkfkjgz2YMORhgigFtqGeCORRqJ4Iz6jJYVmfvQ2NxzznWXJjzcLCNcdeJcB5poQs5pmCFcGHJMc+CFJ95B59DCSHkYuWFSRvBp0Sh77om0knzzvVSHSTZdqNOD/nXaKY88yjjmgYtJBWGDWX5IoYXUgGUWiGmZ/8Wll18GluqJeJ1Yq62pCrggqDi6KKpijxVrz5HBIumXh2G2xayzOkZr5jDBePVJJ9iGsgqKo104WDGI9CHKNchhSaJvXX6Y7l/NBotguT4tRWZjbhL3Db2N1dmMnsfa2e6AT+mRhCG8eGKwOIEKSqihFSWKEXqLbvTwe5GWsdIgF/OhsUmITFIWMiDHu6ynvgLL2bDIXocyULquGCGFovzSalhiyfqVt7ute+q51Jros4S0qTjritL2mCyMKDMXmVMtjvYrtM9C3SxmyUFpjLXafkJhXlVT1syFwsnSRx2xFBVyzmjvPDSIOouIlGeYHWnccscyZ4831hGDjHDHMf9F9d+V9QDGJZcs8oMbvJzj3TmMe2eQN5ggOvGijZpEcRQkYW7xfJXK5rGs/0418uh5xqMgqaWOqrKoXmu56euuFfOVJKVIWAoiX2lo1s20QtN7ujzniivQuw5NNOnBiok0mksXZnRtvgotfVZJprbafptW1u0vOsEpNtla3ao28AASn3bxLEIJIZ7K07lcnXX3a2Zi8gPudjU5zIGKIT+ssMUlinvcORInqEItwmEdmRx84KNAzDmwCU2w2MYm2DELcS905OoG8koGpGHZrTqqi1FSqEVC1/1nQteqXav44Krd8S43bPudDH8nvOGhKHzj083xosbBXy2PfsXpW47/hhgtdrFlekm6Cy6qtYoUVih7pSnHkZ6hqe4hIzZ9kFlvxHe+tO0ihjBsW/q2AjXsgPCMqZMGyECzur8ZjypcoAUvDNEDDPTgEgkzBwEfYhBazAEjgBSYIBXYHvS4xCSX4thMZtJC/QADZ1Ir4gZDdTrURedNaXQeiZaYE+75wno2kw3NMvSxLs7wlD9LJRjfyMX7AeeVz6OkcuaVIAM5zYfsYmUOS0jCJTkRF/GyzNd6BjZgMCIm+9riKc/yGhl+6IvrM6UOxdiXIP1wWmsxlTJb6ZNFJO4SP8DA/wIoHV6YwzEPEQcrDjXIylXOkJfSg2pkwqSa5GdCu/MkiDT1/yBYii56PUyamqKDN/lp0nVMdFKFaHYtWbhGEmSg0qqgwbsLIhSMCM0oL/fySVWiaprc3FUkAVa05wnURbGU3i71uZ8lxUJr+kmOLYUTjurp0y3h6gSvpOm7MJ4Kmj0NKk+H+q+i3mkuylJXM33qDEN0hxeD6MEiWkHONPXjGXt8CMMCuSiuylOeNAGFIx9J1ipq1HzRzOA/ARrQYdFtoDUSYmeS2LMUSqJj2ToFKdZhCojGZFW5AxpGBTvYsw6vo50Ekc+GapfplfSxPvxhZG+Zy10KlbBX84pLt5XM1H0GeizlXjHHJhbQhpSpYTSRZZfJ2pY51i9UG9I2uXiixP+NIxmtuAQtxBGeAZ7pMWlCxgG9ipF5qmYTYhUrP89GK8x6UoakYat0O4iyAxEnrnarJZxaF6FPYiunOQXLXknhV0E0SXdl8UpiDWvDGuYKsYt1LWqFir4xLsufUTwa3HBZ2dW6N6E32U9lPItN7N2UGKeQjUNN29r5+k5CQKVvgye8zLT2xi04yxMZHawrhLEpruegjJzO2Y8y0QIUlqCJiu2J3OQa+GzMZa/5frfW6fpKWEDMbhDplg8FJdErx/0uXvXK1/KeF7Cn+OJ623vTXHHyvfCNIWI5LF9Xwva+JDXpXLV8pQ3LGLPq3RQ56tZGBnVFwKex6CRiUgx1uEX/wnCmspIpTOfCSvM/Ma4Llc/FOITx1jF9DrE5qLdGQi/x0C528Yt3kufLOvfR/cGvjamLY1HpeMc+dobtFKrQbJFCGuSlj0TTW5aFWvDRS3ZyaKM8Zb0oOb42fDA1SYdlLhMxv0/zL5gRu4qYDobA8OKKPotpUWZAtEoMpm2VJfxqjdaZ2XaO8ykf6WWMSlujeoyTnLBK6KwcOs0lhLFZh42X5TZaU6hOtZX4S6R2l25Ilc7xW+et3SuB+XYe09CaXaI1UuQOyaZINatVvd68DJyjrWbytV/b7Z5Qr9YpjfhfgodQWyT029ioLjbBfcHQPNcav8jpUpW6bH4yGyex/3b0wmWscoqXXNbRbtlGCz1MXNDi5t+euU4wjmco67x3465ZuvnSwZFO+t1IP9mo6I3pI2YU37m7K79JXWrACjzKOW+pxQEcZp8nXOYxH3l9GS7xx8Jl2iXEZyf3JUXU+Wsu46ZGubYFNluQFqQrX3nXFf5svrec78WW8sud3e08A3OjOaEr2q9u7Qfv+tWv3pG7pSZ5eGfHeZSWEdNr2eUf3/XzUq/DeTFU9cAWfOCoh2+A4wv5g/+dzuLr5wYlacRomYuGS864299uK2q1hhkBTmaCxTXbPQf1kZD3O9iZ/PXjx3zo5Jav36F3e56hmfAkF3yzVW6V1nu/MkWvcf9bscNuzWR+8/V+8zBOEXrZjE30pCz91k6v2S+uPrGp37qUWZ18mKcc9uZCa7UngIrncvzxDHwDbOpjF/wEWjAFGwqWbAB4fF+xfcpnZ4rlUdIHfRw4Y/83PAuIdltHPR44TekmdIOVT7LjfXNWOu2WPp4hJJkHb5KmPD3mWZmmabcjCDyICHvgfntAdWVhCVtjYNWievy3ekqof9yjJfanUK7HchPYcLJ3ZRpkhcVnQiY0YApIfSTIS3TFSMUEUbNhb9f2gU7oJM13ge3FatzXgYQlFhQ1h93nfLjif6ATgrg3ZT+FWbeRgQj3hHaGgizIKjTIQ4KhdDhWdkdRXT7/hg06eFdgIQp39YO0EytCaHpQFmYdtYS8tgv3l4L1N4rqxoandYpCQ4XV11gwKDcp4zfqp0TDw364M1oRFSXKlndcAYWsx3yCF4ipB2m+2FK+Q4iu5n/LB0adh3fAOCKQln2uBoqgmGQ35HiFKIgm01/JMoPcyF+VhzSaoWmS2EJQV0plRXXRl3+d6IlryHW8GGGIV4qDF1Kq6B+xt4rHwy/IQlJnpxdZt3NKIoladBqCIHrVUC6vB3RgRzNw2JDq6JBbR41CJ5HKQI0JWXFBtYwGqF5G0Yd8qC7aJ43YaGbRKIjYeIhR8xPbGINJJ35qtZIL4gxNlFfyF3Bl9Ujo/5iOSciOIpl73TWK7+iBcKiFU1iF3YaKRKMnbgeLXkhX6chJn1BBhZZgZDAKBxmLfZdZTaJKLKiBOol60BCMj7d9Erk1FGWRTdZT/rYNKKiRGwlNPQGMbOMWJ9iTchgUdGiXQOkLycMs1dSNKGV+Lvk25WdstFMzgCWE+lFq9/SP+LeTNxGU1fiTkSmZQkmMAsdksFNh1Vdt+MgirOMU25YkHGdwT/ZkoSByGHY7VXlUepeMo7CVXfmQY6mXYlmbhViEQleMHEiHMZlWt8KH6aA2H0mSoiiId5mXyMlpT6IyfvmXmQeY+zWY2UgavjCOACd/xiWGL+Z1eOGJarh9f/+4acwZnpdphAWHaIu2mecSgDiElHGhlK9oDaPplE+JmlPCQoUWcqR1J3GXjEQZmzC1l7N5cXEYkbZZoLVZlhWJmBTCm3J4nhB2l0VnPKlkC2sRTXxxhwwCj3IZoR4pkgQqmCn5jdIZnX6Ta4lYg9fwUi10lrZTapPQfpjSmI7pnUhogbenleUJa07WUuS2mKxgYP/IaI22U/fonkehlLdUeBx3aFt3mt5VkIiwYGpkTPzmmheJjDqYV+5IoAgapVoXpkFJm0+4UOQph7xTluOinBAGKxOqQhWaiwlloYRFl/13oCtokby5jszZJBl0iPd1oqszndEFJtUJiTRJjXv/SiEqEQf1EQeL4GI5R3FPFoVoU1c9KnBG2KlCagmgCgq6ValH6p6fCWNGOTVOim5SqiSfeEzmNQzUt04RVApXyqWA95PZklAiCqak6KvAWqDBCmCANYcPqqe2IzsVSXRAomcn9yQjtIuqtD636Y7M9KblaWrTgJIXRqKO2I3AAoP+ZAu7emaL6VI1gTGQ2gM9IKmKRla/h6pS2Ezn9p1gyh/lBqSihXxDqjuUEKqgOqQ4FzI0h6RJumFFclRaWoC8JKVqtyRU+gnAoKV8EEEL9nGmWIxhwZBWF6xkGpTDCpnAimQc+6bYmhds+oSUx4wlGRTRSpzdxzXTEIX2Koga//ql2jqdoElp3IgP1NWS1Akqz+CiiXWuWJOuPriufxVWmQKvMKaK8tqApOmUy7l3AOlJQAqkpsAK/wqqgPC1ikAJjnRzIaM3alSwPbeZF2Yb9qNGcBePcai1qel+ZgF3iHAEVTluwriQJVu1Htux4PmOIDuyQBmhKcugjOp9ErmyLDtlL3tYLVitfuqh7mhqbVZJsgWd0tljplNJ3kp7HKQM5ZpZo1hPM4ERTcCuHGM594EflEq2aNu22/SdWbt9oeWpjqQh/wq2XwuwArtG1BG8D0dovhO7xgt3pKm32HOhkRmVY1OLtwFqfYC3p/ZlfHuYurk1PVq42fm3OUqgFf8iuADXoN1bgUm2nKX1T3baUVeIlyQCXyHqlXp5rWemWaYWFtsqW3MaaS3pVob6PCKTZeQqsb1kcb6EtDJxTKnbAqobqaybwAkMsLl7k64BvAq7PS+Du9FntOb6qV3Lu1/rB34QsKQwC2bLL3UyHeaQDd1iG2ULMidMczEsbjfpsNVSu00ULn0QClAEgdRbwen4gZOIvSRbmUZ8xOXrvX8bvhU4jUh2lhNFvk48xcX6nI2rhu0Ls2EZsyVpngtKuYXLkC7YI5obg/OAuTwbfi+4osA3eh1sunclE+oaBez6QHZ8x2WwQA8MwZ8zhL8Lw3qjbTRXwxt8wyoYDLrzC7r/67Ui3MiOHAj/qiGsYMIsXCeWfDfiMGL7qEZHFcMX7J8ES8gdbMidZHGbkLSG+BumcARHoJ/UZo0hiXCgV76/hMTMCbjay73iu726vKy07Cppmr1JplL9EbOsITrBk3CTS38IOgohOYobKxbbhSeZO35onMaJel/BIJvnCsc5JRMssQXs2gNkMDkQBEE0EAXnDBOa0xKHxLrz0THywbT5RMFoW8hAo4KfysiO3M8oAcliO8l6kwyVXCd4Az8HzcJsJMgF3dAKPdAgM7C1m7WuOiU55S2SlGCtXLeO5pVWEZvmNUq23LwjXcTZy8vhqcu57MRJdr8UCTOyQ47mq72u/wKc64vF7vC4Hc28vXqyKY3F1GDM9puz1axN1nzNasyIupcOu7CV5mq6VOqDp9sSdawHAHtA9PESNLDV6wwFXc3ODpTHICHWiKQxUo0felVKFey2/GqyhCWkGoISct3PaODPifCvmSDQxEDQeOMNzqEQfp3Qfq3Q2eANe+3QyQAaZhvRAqueo7yYsJpvFjyrpVAHrTyxQIyMGkiJRIxPKF3SLk24n52t4UvFM/3L5CjSRWzT7+kzOD1x55KnPz2b5Xmtps3ZDlXU/+utPnvGvZ3USr0UMqk134m0OhxPEEwGqYs5k9rYKUYTPlgfW90D6JzOdYzO2L3cIeHAloMxrf/bx8VGw/ZMVkO6uyEswmmQ3mqA3v0ctmI70IedDMcQ2PTd14GdDPd9DIVdyYm9DPCNc43d1kA6o6072U0pCsq9B8DQFMx1myBdskmM2uSo0qMN2kMt0xKO4SZ9IiNyhcXsp57yvmS5zLRNtFVx2zsozc3aTJ17OuWH1Nyq1HuaUEjrfqLmMafMynhr1VnXr4sU3erM1dM95ESezjoeqWBtKYfkfuNoUQkbrzdnwlw71+yN3nVd1+1NCZmACUNqwgT95YU92NlwDPOt396g32NO5vzd3/A9C4TcrwLbV2a9tZ+sI8YEQYiwN1iZf9/FsaTNaTZh4RqOZBX+58I86Cb/reHRTI57MTTd0MW+EOJ3ocwkXuL4q0FxuioCmblRAuOk4dvn5+LALZgkZdp9ReCXAoQ4XgZHwMB/tZ5LFAo1XtbKvd3qvM64fuR4rORZnerfHej7OtkQ7easgAla7s9okOx+cOVZruVb3grQ7grQLt9kfuZ8zcJonu1pPuYE3ebE/kgBvkQpNufCfsF33gR8MAvTEYt8jjuGLuiJHu+FDu8ZXpMttOihvV7hA7nQ2uEwG56aVulMiH+dtgt4eb6AJQo8aPBD4iXyol2eHvH8xZThiMRMojFAWEF9RQbW3TG+Zp8GJ+v1BM5ctbqcwxI6ruvvHAc23usu0fLYKVoX/4xb5a0Icr3eyZ7zWH4HPH/X7r3lmRDt0U7tat7f2eAKcpLtRU/tX04M0u70AB7gKHYxZvFInqwjyxBy6hwHe7PueMqVArqVVBfoFt9E9K7h8/7u9G7viO4q+Z549kh0Qh3pyMyMIgmhIeunlw7FLA16pUNG9Cbxnm5rrwR83Xwtj2rjUsmf5HwfH299UPrYQ3jVk18Wa+bOlpLxiu/y7/fyL9+6JLzXUF/e/9zIzL7zdwDJqg8JmND6Qv/lTE/QSC/7S1/0Re/03W7CTk/e4I5iYvjCnbxtCJbVCq7C7H562MLNxLpZEj6EpOy3ab/25cv2bb/Sr+HhO92JuiTUkP/Oy0dI45fOV/LH2VRyuR5HG6hTYhAP4yI06qTeLc7MRPWE8XNOShAVQVXKnpbqmIcGELiACRw20KCsU5skIWK4sOFCSZ0mTaTIkE+dPnXIbGzCkUzGPgwTWbKUiRSkQH7UqGT5xuXLOysDKUKJydNNm61c7XSVjCfPZMeCCiValGhQpLNcESPGSimtgaykSp1Fi+lAptKkteP2bFnXZaDq9IjCh5Y4tNiqTXOmzJjbgsyMrZJ4KljcX3lNkUKY0NRdhLIE7y0G2CAyxGsVK27bTG5hX8FsSY68ynJfv5nt2tJcaq+pzqFFeyZdelfCysq6rXbWDS60tpVjzbbFFtz/bWq5dcOOTRsuZ9rBhVMmXkrUqF/S1lXjC5q0wz6iqpEjx3g6PX3ZtWvHbq77O/DfsccLH84abnXpq5unXu2yZL8TL4acSJhUqT5HmgjaJNhxa7d4A/A1gZ4ZxjZmECMowcQaS+wgwAaT0L8JS6nIoozIaKKjjTDSYySSRpoppZZgSmnEnHT66SefVtwplVd8Cqono5CaMamsmJqqqh2tykqrbMD6KqyxOmJFHH7M6Sq3x17DLMElp9NqoN2qrBJIbuDhKkiuutQSHvXWU6sZA/9jUC/B9MoLwjUJQ/MzOOOUszPQMPOtNdYGhE0231bDzcre7jwNOOEsGw6wQT2T/5It557LCJED19sNPO34sbQf7sTTlB7y5lEPPfbaAw+YzeDbxMKFMIpor4FMkUTDOjpZpaBras0TT1zzdM3BxWy1Tkr2rOx1WMUgdE4iDOMoQ1llB0nEDzT8SITElUqk6doUXdRJKZ64naVFGm/sicUaj1qGKR57dOpHLodUEhlGyCArCkuysfTd3R7r664svfS3X4DBynIrf/1tl8svv7Sny4Xb0W7LgQfust2JtfrRYiktPuxNCo0V7E5d9UwNZF/ZEpDPyCAjtNBDTSUNmuWYa9S4VPsIZuBfscP0Up7l8fnnTDVN7zyiw6SOnF/sKiyhU0XZ41HPWKmG1Ff3k/+V1pL9DHnrYYNN52uwy+t0ubCXE/XsoxdTEK74FhlED7j3gJYlamMa8Y+abMp2W76Xeupvv7V9hcVwkTIX3aegomoWpij26lxa+CCLLD3OWlhSM4fhTLB+20Hr34gdFxjjiEkPPXSGHUbSG28aXv0be1j/hvXYZ5ed9s9bX/j21icOEkstS5cytVxj+w1lX7YB9OSVUWa55ZWRgxm85o6jWRD6wgGPMTyz4/n7hoEOOp/xhi766IEHTZpm+S5CRNGBXt1IEllaU+t+rbnO3ys/yynbnbF5SoABJGB4hGZAIBXtPAriS4hAxBK63Q0lOEFFK3Jywb5l8Cbe4qAGO8j/LRwhzipT4QvjttIuyIFiCzSYHL2ykZYoZS4v7ELXYfhyQxzyCIfNGYlUbqguHrErS8l4IVpkt496jOMb9UBiEp04uybabolSpKLtnjg7JnoDifuYIuxiZw8CKU9Pe3KLL4ITmeWZbGmjYOMu1vi8Q01GjmwUhWpiBo3MRKRm01tLk2rlPfDdS3wLG1+nzoe+d0zjPUyrCH34MrVP1KEjn0jO/fwHtv1lMn//GyAAO4mPT5aPU/4TWwGNVh7cKAgYJaQEJaZVLQnyhIJ6gwQmaklLWXoQcBbkZS/9tjdiuGJdfyMhXyjhoxee6yugcEMPWtACDKygB244S++E5xgS/zrQbW9LxB4mITdw7kGc41QWR/SzrDJ0CJ1xaAM70SA3EJ3EJIpjXBGhWMUlJjGfT0SHPp3oT4Bi8Z9MHOgTX4MgkZUReWlkVPMoA0eIIicz09jefUojCuicght3TFBj1LMzS/VskJnSDnkOWR7IrO8TK4UOHyZhirWcQhCTVMbALolJTeaUk6HkqSlJ2clTEtBs5lHMxdAlz7t5AkaypGVTm+pLXELiKbeM6i6lCsxh6oQVNiHhjpS5DFoMwpkYIGsIWgAFPBDDiMmEHCtAwQhElHNy+mHhOel6Vxo885l5NeszQ/BXaP5VsHplIRQMa9hltcENi3UWTUyCiUtABf8TUDFh42zkjRfe7hisy8ZmMfvCo9gTd7z7nfEakzzUHm9kyUvjXAzVRudF1I2Egk1C+Dgz9mVve4B6RjlAuo9LjZSQw/0Z2hI2tQgxEjr0IwUkNyKIWADrpmXTaf926lNP9hS7ZBOqSbm7wKJaLJhIxRsnUqEUpzaVqurdqk1qMguqZiK9toSvVHU5FU9IloStJMniZrGIKAS2rA9oQQ8A8S0iNsUkbotDE1i41wfTda9lOAKFo3DXC9vVwkfQq2A97OG80gAKLOxBDg4rhMNqQcVcYLET2nkGZ0GrDW975wOfZeMb5zjH/XUrCaMilQCZdhvEI7IZU4bQfCXqPUr/lm0cbVtR3C63prvNV2u8E9KeHU24mQpVcatDIeAgyyKiaK57JBcdZhwSp2u27nWz+2btxhmon/punUEVXq0kgy95c4Ut10tLQ7SSJvSdr01O4udWEhqD9NWJfX/ZCqtcQtKTprRJ+jvpRGxBwBhwQKcJPE1AKELGFy6xXp+5oQp7SBDjvChL4zQSU3hTnOjUT2A/DNgCk/gFuu4Bryd32CiM+MSGrfCJg23sYQM7xcpScWIV24aTHS/aqSWygBDK5Ni+VrZv5CMe8zgJUWAvOnVm0oG8orMt3guRCivkdbITnqS9xWViRrNz650br7WZum6Wc7/nvFOAe/drCsTY/4z2fIiaIFzheFt4oA3hZ4hTAtEQjzjFGQ1fCmYQvZWWb8f5CwhQhFwReuDrXzkdgk6TVQS7frCpCzw/uL5UTjt85MZ+vEOSzJrYdF25y11OYl/33NdAvytej1DXCh+d50PntbChAA1qOylQxjPykcf4GNjK0U7N07aTE0KN3eL2evfGKa+w4T0kCtKmYiPfcbMkHmusSXOGovf7gIFHQZAhIh1VoL73ze/uwtnf2fW7+W5j5++Wzic1YbgEG47wazk8b4KeuC09DnlF+9mCwATcJTxRaf6G6NKDGLHPTV5W1O91kv3p2N3XUmatDJVYi4LGKmmeY53rh+V5dbkIhP/OQt//HujDJz7SWX70F5C6+MU/gtUPCqCRuWa1QVbjG33D9SbTJjOkANNyaqtcDNlRgR7tLbrTfrnzrDthbPcymC3D0vAjBj9k9xWbAf/vwffbk/bf/zr6z11D6orOOhfyuhsDdLzIgzxsobxrETQGtDi9YZxaUhGg4BvQs4RQA4QbIwlRa4MRkwEfyAHgE4EOgzB2YoRQWJD/0I2u4SiGKrcfQ4wb4q8Yyz3eyysS9CtTy0HC2qtci7ACC8IfZDoIG0Je2xXnUy2rQxlrU6PoeajsY5mJCrtvk4+Q0CjZS6VnqJXysxTgUrfe2qifCioDApN4KwjMQBb6SJBVaIj/YmjB+xM8OZxDOtSu/7tDPNwePcySo8pAO1CDA8QbBBzEQTvAyJuJvMEJDOozb6lAC6K0OQi0UHurDAS5DFwsTFQxEyu1X5sxS/CPBhEWFnxB3hAj3mgum2sVnLOEt4mrBuNEn4tFWexBH6w13jO1werB4UNCAnGSJFQf5zOZ07CeUsE+Y5wNOjKNbiuGKKuZOrqjrOHCs7MHLLuXLQxDSzKu9rsLzTEj+BM3SvqFThAE+hlFUIlDUMrDOsQ/O1RHdwzAiEmGphC1lrADObCDmRBEQ9zHQ0SJfsQbjPOEP0sFSDCvRhycwXnES5DESmzISlwEN4gJaTkDD1y2dnIW/1AoEDIZP3OkKBb0viYMybvzxTaRO8HoMZJQCD3QCGZRPuRruVnksAIzq74qwdPDAMK6RaAbMqh7vpQhHjICxpD0RmLEtmM8Be0LjelZDutrnzXMt4Ebk400h99KEiXJRrRJv+IyiD0RjG/EiOShi3JclHdMx3U8S7Rsx7LMw3iELw2USEAEREPEA3zkR370RxQJSIGsCfOChKXSFkVcSFCYxDm4RLp0m7eMyAdarC04QZLISKhIDI78ExdEMsu0tjcMypTazFQUiJBLyUVIhG1qRZcip4swJ1jRiFQrA8RCp53rNWniEAebqx5ALZ70xehTwmAsI2TMuqOMnmRstf+lpAZmbJuWGsu+o0z7oUqRuko1OymfYca1IUq4WkNlgK3rELi0zL/t7M7AY8ujYSu3hMs/DITyHJHyxEc/rEu7HBE/QMSNY7zGg4RGsK+MuwnQ08DQDE082E/+dBbFZAlu4jEquUYDrT9R9L51KLOQbNDCUCiSlDeTlJAIyUhZeEwMfcy9YMWJwKj6WKmZ06ZWdJYRZRaNMEXdzM2unK0HZZ7gnCOvA84XfZndKk7wyygGrT/w8ijmzLKzyTctkwf3SI5AgT+wRIZg+ITa0Eru9E4nbdK1NKBkWry3XAl8tFK8Sc/yjMv1ZM99fE9ALK+I+wMsnc9EFMxAW0iG/M///mzTuQlQaRkESYtMrDlQMYpGj0QyaERRB/XJCG0SvPjJjqkQCWmOEIWTmjsIICtU42QE2/TT3Zw+6mtK37w+o5zRi1pGG0UVbwqJ98nR+ovKMjk3H81KaxBDLVOkM0nD6rQ7y9hIOoNStXxSWi1LMMmzqmglDTxPMu1V9qRLLf1VL71LSmA4lFgJJgACJEjWaIlLfXQ8TMODwVwsuvQCiHyJQXAJxorIdbFTPI1GjgLJBr3MPu0oc72635BQdQ3UCW2T5vo+Q+1MvFiQ4kCtI7vXSFXRFe3NSu1X1BiNTL3V74sPPRqz+jFHUeVCHqVGtfvRQ/IZUETSefPUjzGG//P5zlqNUlmlVfAYInkUtBPx1WdFT/IE1sN0VruEOLxJVh14gRFIAZiFWR2wASBgAixVT0CYA/4sTJ0NTWrFg5990wDNyFDklTvNqTxV0Mo8WqYlRXSNtnOVoaiFWthg0HI9V3btyduE1GrTTdXi135lMoD1C2LkPjNsxuPkRoTNt1FtBnIoVcNjUjCxiwVCQ7pQCFVJkzSL1Y01S439274loLa0JfOMyzJ91i210mA13EDkM4Ik0ypoWZe9AMpNAcql3BdQASCwgpXwgs51U509WUwc3WzVVjfIVjkt2qZd3T+BGZOxzD3tNqcdV9qtMgch1yZ816vF2rmQvkmF0P+u9drjwdTNsFSx/Vfild2ZaSTskQS63chQJaprXEFAajsqq5W1Y4ZSeMO4QxOWipVZuYvsxNiMXcvy5U7w2JLxOhGU1Udf/cPPNVyYiF9ohZFeqM8/SNbJvVz+vdwTSAEbqALPBQMCLmBMPMyIHF0FVuDUbdviYd3Y1dM8RShxxV1yddpfsWANHspbodpeBN7gBeHhJUbiPY1NbTXiPYVlXF6IwBDpUY3oNbzWmMqdsd6ENZp4q1u9WKmMuBp+4Vt2nFXzDeLzxa4vGcDx5NV8fN/4beIBbmIDJISlqk85SFbLvVwLgIAI0OIJ6OIu1gAADoIC/gEDPmCgXWCKTAP/NF6ESzC3MWJdAYngjpxj7lIe5Vzbb81jPT48Or7M3/XgD9bMMcLXr01h0jheFDYOEvaMFdaMFh6zFl2MoNrRLiSk6/2j8gDFa7Dbu6VY/wDiIgbcULbVIz4XkM3SMM3Se4RfZBVgNfDcV3bll2hWicxSKU4FQlAD/R0BLN5iCYCALkYAYf5iFigCG3AxMi7jBEbjNEbjQUhBMnljrolj26jjPq5mO0a8O74z/uNmyiSbTUIQOd5dQP5gQtbM1QLbEkZk4iXhRn6OR3bDSA6VuNVha6jeRBpFsTnDWsG6TnbVYMA3/xvlISbowTvibCAGwnU8kZXfWJZlJ64CZk0C/2O2WVvO5WQFAhXgZV/uYmBOAGEOgGGGAJn9ARsw6WRWZmZeaRTEBWmurnFW2j2daW3uZpve5rJD2tW92l3p4D/9RTQiZCNTZ+EEDpdJ5EX2i4EmFRSO55dCFIGuZ6k0N0vGHLctLkiCEuQylep8j6j+Tr816MB1UoT+2IeToHtM61WGXysQYFr2AreOayZAgiFw2ReY2WRVAzmwgprV6CveYgb46AEYbAIQ5mEGY5pF6ZRW6TI24C5oZrhhY42E4BiGY5rO5po+vJv+O5zu7GzG5g32YF4M5HLWTXUGNxRmZ0VGapga6OqBZ6cuFYvF3knWYWd4W58hKtv4EvLQ3v9ZgcEwizm9ZQ/yDWvjfkd0FOsCmhheWOhAaDh7VOVXfmhZFuCJHuMhkFxe5mW81gGY1dyNptyOZgDCLuyRBuNiVmyTdrHGbrHHfm/4fm/GItpopuzMZtrMzu/NJm6o3GydDm1yFmEIndR0JmoQHVvWbrXWZkq0LVg9Upq3+GqTojK8uOTc2Gfp2eqHQpa6iJTiFmLkzlgiTkvqmNJHNE/ovsde5dzqrm6WrWhlBQK77gAar9wr/m4gEO/AVoAE4PHyNmwtjtkfSO/1Zm8j3wIjj28l/5BP9Fb88ebLRrxpgPL95mztVAz/nmYAd92e/mPhRWdB5RNDHnPUXm0QLdv/7GRqM3fwhjiV4cbkownAfnajBEWlzekjeaO75g1HUC4gsxxxUR7rv9WSZBocP2u8911lWOZc6pboF0/smp3Z7a7xK/ZfFcgAHedxHicAkTZvBAjy/2UBIi9yAv6BLSB1JY/vuHFU6D1H+9M3zI5y/a7yWfdspK3da9uac971MM+2hEhqM09wiagLV7OePLWoKmTziSqzjxKa29AL6pPwuGMj1/PnX9/zvS2lszzughZ0jj3ipNhLhZuDK9XSRW9rdG/rR89uZZ1ZmJ30XqZcCtiAjQbsHf/xToeADgj1HBD1UXcCgAd4Uw94gi/4gHfMUFwz/maHcN4kcK51ACo8/4XPb4GG6Q3G4GkTcOfr9dgCdmE/jlURdoFG9lZr4QcnjFI8oLTpRqv76j5S0mjm5GuPjvrRww9X7hH39lHSsgFsET87BHJf3Ct4aOrO6HZvdyEX8kn/5QjQcRTAdF8mb3w3AAPQYg1Ab34fcsNyAlNH6VM3eLAnYD0AhVa3cr+zLoePdYifeIqveFvf8nHlU6He9RRV7WAnxpBf7Qdfc9MAZ5JnH2Uvc2p4pGsIUqFRJOzUaiqzLRkK7itMDm3HeY7ldkAXvO5Ai3D3s+gWerhmcYlW94xmd++ecQDWXJiFeglwehXwAF/eYsLGd6u/gKxX7yQ4ddr/eooW+IAvYP8ugBuXvsZYBUCGH/7VcAe0f/i1T/7jt/j/Jtdxxsy5j35glFGk9viIwPthp4gDX/Dl6IzAP/ncEN+325TuK04Wreb1WB8YdozZ4oxUGcvIxy7KF3HJX24l6fmdEPegX9w3AAgrAgVWYWIQCMKENmqoSHHh4UOHGSBKoJjBA0YKETYySBBgAMiQEyZEZHFCxowcP1aybLllZZKYMn84qamHi00uekA963ktHDig6oauc2eUHdJ0R492Y7qtKNSoTZM6lao0KFWrRadtner1K9im3aaR5UrN7LqzVtU+LQsNmi9lceXOlWv3bty8tvbG6uv3FOBSnwQPnkT4MGJRig//S+rkWDBgUlCnkQpMeBLmxpobCy52Nhjon+/o6csn73Tpd9bo7q3LdlqwUnGbVWtmTBbuVbEQ9ekjSRnU0fGGE19a3Pi85MiXK2fe/PlR6NKdPxdu7rS4bMm2w3LlHdOh8HbGk7+ixkuV8wQPKkRYhOGIFBMp0t9Y8SFGD/Y3GgjZH+RIEaF00gwmCeGSSjDNpKAWMuGE004+YYMVUVqFtVxWFmJIlVhIXdiVhkl9mBaJZaWF1logtrUNXnjp5aIvfMn4l2WJDWYjY4/piJgppkBVWY2bCbkHZ6e89ctc1oyGGmmppRWjjMo4w9YvndFW2225dSJIHXwYGdxxYYo5/110ZJp5JpppWncddtzB0h0qnohnXnnqpWcne+8ppIMNKrwA0Qgb1QdBRRtlxBED/ymaAKOECkgDCy21pFKCDFqaE4Ss9FTOVZ1qZdxXVX26YYYhBhWqiheGRU2JZ73VKommsvgirTDOqBuNo+BYGI85GrZrYK9Ws06QmRkrpGDArAMMaMOw2iSTpMVzDWutTelqMYoZgy2SscWyJRmCeEYOuWCOmSZ1ZZ6rJrvT0ZMcm9lpx913c6JHp514trcQv/ymkMILKjQ0aKH7IdrRoggkAAFJgBJ44KSUVorggg1aHMclElJYYakbdujxx6imOrKJY4nsKYUrWsiqqanW+v/ybVDSiCvNu/IqSpE2MwbZKZINS6yvx2JG5K/KOtMtNEpCG204R0dJpbfMcAvaKp9IwqUoUo/abrpce/31u/C2mUycb3Ii5yHjeUHnvQOtty/cCv1b3wWOGozwAHgzqvBIjsZnYEoRSwxxxJfahIvGKI/6MaktK56yySgy7jjkK7+2sayz0grzLjPzVWOQOerM66+LLeZjrJYJKfRmpZDiM5JaW5caatQU8zS3riOD7VuB8SaJKdKoZp2563YNtrvJH6+u2Nnx0solhhzCyStn27t22/gWtK8KerqX0L8A09cBoeUjurdIfCNgAMMNxxdD4DO8x9KA8Us6hBFIOOj/oBuW7D7h4xonQFBNTlSRO2DHEqjAyjGQciva3G1s5TlZgK6CpMPZ6UbXK9SlBUiXWV1jiLQHnhnNdttS2tJqRxfASMkt2nLL7XokmN6UImnCKZ7xcqgcfCBPOjz8YQ+btwzoKWI8mKAeJ66XPfO8rV982hefuvevP1HEfI1a2Ej2lrBG9U1A8KsBGPNHP8ARroxi3N9OEKckjrFxgQMk4OTi2EDKORAcJWNRiSzXlr7IDIKe8xzPZBi0DKpOg5ERlgwdA0LWWak2JpRdCk1DDti0pllS65yRjnQkIF0NeDjU4fJ2qLwd9mOUQAyi2PqRDTkFgjx2IEQSW4k9tpUn/0/9ihsQ+KSDKZ4AUOXrW/u02B8tPgCLFYjACP42IH4VbmJm1N/+auI/a1BTKG18IzYNKEc31jFzeexmN/jIuT72ZRO5ulFgDFO61mnGkDcLFssSuchjEQkyPsOSMoBBmyUxrRoxs1bvFPPIHsUQZ4IQhY/gMbytgdKHpxxlKaUTUVE+tKKm1Ic4hmgItZ1HDuFZwxywVycmsgcFfcJlFHWZy/BBhHzAzOKisihT9/HSfs185hmhqdMtLOJ/1hxTNoOaoW1ijptuVNlTYLU4pPaxLuQ8p642mBhkudOCwiKL7+bZzpwFjxvSwKezlBKt06wGk7fzTLaA17sYJlIQB/+dhkJv2FDjsQlaFj1lKfMKRL3ig693PZ4k35UdTxQRe0HwwhrSFtKRchSXjmWIwPQ0t4dYMZjqe6n7lBlG+Z3RmTjV6Xt22tNlAPCaQBXqUEcUQIaKCZxJk5weTfZUvUB1RzbLzGVwxlVgSfWqPVKkViWxh3paqVy2GcYJwxHJslbSM6co2iZNEcPf2bAoC/2kDu2qXYdaNKIT/etcK4odwuIBe2B0JR4WO9Ltxc2WK32vLlk6vroFc6Z+u0BNwRi4ztq0v/j7bzTxsClOmXauqO3YNg+szVPFao6qGktTaVtb042OqrwFTOl6hUgPBndo7exRM8pFTWZEcJ92bVr/1GRB4lIgAnjOla7q+vCl62I3u4G9MY7DtldRelev/fAreIMMrVUWdqNAAIMX0rtR9HLUCo6FohNTykv8aqDKlP3lMe9bkvDZD8Bl9O9nddrTclyHxuFFbYILqOBujqyoCIywzEIhZ0Vuos6FWeedZzjPqmoYkVnVKs6IVtyFkhgXySWXtFDcGhUX42oyhrGR2upJRMu1xmzkMe22i2kdiy05P57Hjz8dZMBC6zrOW3JivWCD9Gx0DuodKUJMilIoR/kkVrZ1MjWQ610r06Sb/bWXwQxm0OpvEMgg8JnXTMClqFnZbG7gNsXZLJpd0M6YsXa1g4tB0eU2w5Z5LSc7/5yZ4RZJWXEF66FFjCUWVsnRrgOSIN3qOkvTm5Q5Hmt3Oe3pUPM70/peV77HdgnwTM8QC/FCeFBNHpCuR9ZBoPUtvQffmnK51v+KeJSD/V9hc1bjPtCfG9R4nVCiFjpGdfbJMccyByf1KjEztJYec23czlzmrAO0VAWJoyNtBcN7Zt2jT6FP6xy3xFMRDlhh7NaDylCevplxvS1tGn9rOsif7vfVc1wcuQY8hdrxBNiPyAk7IDnhCS8PSdvz8FhjvO3+qvhJZx33PAE4tBvXL8c1ngQ9aIob5jAwyc3UbJSnnOVuRhnMEx8KRjAC2zR3/M1/12ILy7PyOg8k6sItbv/NEFcWw1rSiJFryQGv+3bAYDENL+/oSf806sje9L2J8+8mURTrVJ897qvepjiBnRPHeEXaej8ntTUx7muPuHu9h/eLz529bTfI9gyyhOnn9O7A/qwuYxIh0iYbXYQn+VId/OxOPeMSuBj4nBm/iPXfvP3jljxVf/UrU3g75z778+aFCzwQC+/cR4tZC4kGit1O7/SGlzQdhtHQypmZ693b7XFd7uWV7QnZ1mmddtmDOHjDdvCe73lDL/xed8jJGuTLw21PZCVECbaH8xWB8+2Sr62a9DGBk9Hd93xPDEqfx91UDvKJNNEC93UKKn2fEI5fHaFDPYxDNhBDJqyfHgz/ghO6n/vBHwjxSP3lHCLln5A8nXSNy7n9BGvchlmoxu4UA5DwgRl2QmT81hmOS+sVmGlp2gNS1OxJYL/pWwTK3h1ihwZuIBIdgx+CICcQghyMx/akRxVElsMhxAwe3/ElX/i8R0EIRNzwYEI8wQ3i4P7cT951nEyAgR+gQjYEoVF4X8mRYuGdzOGhTDeMQz2ggz8c4THMAihYgiU84RNCHtBJofrVXIWpE+ZlHhZuhhYyWv8hXaHZgtGpBj7RnxkSF2HwhoyxhXK1oRuWlu7h2KVFoI/d2FDknjduWgbu4SuMoyscwzd8wzF8oPUQH0F4wQ4Ewa0pYjuuxwpC0Qn0/8klgg/zwaAlXiImVt9+bWL21UQXeAIvBB5CmmJCHliaddPAtQIveMM31IM/oIMGzgIrkEIiJIItss4T6qL+8aK3+SJvQYOPmOTm3VljCML+5cazGOM/tYYA1oYpiIIBniEGTYIZvtXPUKNPZuM1QmCFSBTsUeDsHCXshSMIkuOb9IIHqqMrNJl5MBEKXMADQAAKBMEOzOPbQF8hRqJBnEAKHFkN6uM+9iNaXmIRECR/kZEODqQRGAItAKEpiaJQKeRq0ZEDKQIoAIIh8KUrSOQ4oANhouPr0CIteqQTSl5HiqRI5lYiEJJJQhoWWs1KtiRBfZ7/5UaMsKEjMeNOEv/N0HSJWvWkaf7kUHJKUFbgXH3XN76mNkqkH3oHU5pjNIAgLBACqoGUHVhBVa5PAozlFWABE9Hj9hzWkUXiejCEIUJc3NlAP6IBWKJl/tRE4bRl/HzRQNrBJVxFXX6nHBpl951WQ6YiNwECeqYnJSgCJEDCLJijEUZDNHiDNJweYnKksTQmI9FftuVZFWaSzwWjcDEdcvVMdb0LtcCctRBFWfFGHDSjaJphHUzCLziS+KEmUs6edUmd8lAabH6oHv7hK/zhN8yniKaCJpxdqnkBC3QAcF4AELiNITrfVxaE9lgijc4ajlZBGryBJP7jgmiiGGWndq4EGIDBHHSnWIn/YniK5yhyF/MMYdQ1RXr6gZVWKRpQwuu850TCYhIepk52pH465uONJCEVS4d9UAgZKAVlEqWlg+boRjBMyVB4ldWEJoTyRrh8gk+dZl7SZdjElYY2IHiCaNeFowb+oTmWqFOio9mgTcJ5AQmswAQA5wSkwEAgZ/Fp6p00GViqnVdSp1fyaKhip5DeXZEaKZImqTVGaaF2WpMyKRBJ6Z9exZXeKpYGwpWSApeeo69+KS06IblNwkbSHH+SqWW+E+YphoAiC7NAxtCpW0xqDZYw3k2e4XCRwZ5eVTWZZ4oIZaUBpSh1YxBm6KEqpR/6aomi4we+SfX8pXgcoktVKgJo/4AK/ChY1qhyipRx5sl0+qN0kir0OYFA/pp2imWkrARiuVqrxqrDOunDviqt1qpS4OqtqoHF3iqvJkOX+uoQZeRG0p8TciRHaiQUKmv9NevqBA8uwBMKTci0+gQyyEKLNeGD4qm2ekmfth7k+OnhnVZqDurrDW3Esia4lhqiLup8+mq7+uE6kkcQtKhYLkQH4BcMOta+dpSn5mgazGNahurAFiyRHuxKkMDCXsJBEq3EFq14QizgpdzrAeHFZqzFogHJhiwrbMc5eqksHuZGkiyxBi6yJis6+RxLpmRmtBhLBo9cRFWFdmuCAhRtIMMm2KyE6kEz1sERTKiKWSjk9v+s50pjUb2puAZtanon2xotHoanHgrm3pbo0n5DuwLfkpWXEZiEDcyBIFoBGI1lQuQop/pocXotWZZgvwos8pKq2BJpwuLukbqakqrt2rot9bqqlAqeO9DtrdqtlUrnHkjn3dqtJbDCLGSDN7SiRWqg34ZssQou4T6m6+CfyrrYsw5G56KQ08ips9gGI2Bul/yv/5LB5krXlYTuAbkFAouu61Wj9HbN0X5oOyDq0sYu0/4eKxEfGNAEwjVCEo3gvzLi7xriQJBgjUKfvgSsj6ZBDKrwsJmqdjav2a5qxiwpRKXu9H7nQv7Q94HvG3hvxnIv9/oBGuzBlQ6CxnIpOkT/QxKjoxImAing1t3S37G+b9CwU/6NkD616WCElWr2RIFaEig4qP8+aP8K8BGUZgF7YQKv8eX4LKEyoKzCZgS7rnzC7jlGw+xigqstFmKRR+8Rgm4O4hV8KqjKoAjnS7+OKvL28HmogQpT56ne1BeZBAmsxGFJwRxkwcARrWvesCd/MtigbgMbBQ8DsfeeshB3rw+nMivv6uvYZmFK5Pri58nKX0ha8eYd1BhG1SiEBuRWC/8C8INugc0eweZS6P9Y6BprEjPfEYNhKAOLMg2DcoYimuse4TdY5ATPbu2W1xwk3CVoAgcTnCBvKntkbdsop/Fy5SLPaPTZHfbhzxc9/0zzHtwew0F3NnAnU3P1lqtFSfPx3IHd8jAr97AbCHEpp7IbBDFB/60Tk4IfKjFhWuSXUkL7uq+xHKto1rL7ZTFiPO4vV00w0ELlWu4WCLMxx4H/9KmrsAgz30UzI9U3eesCA9wDy+HQxks4siIravPSqiN4vBomALLYpejZ9SYhF/K+LrW+urMkWgEaNPI7DyknYic9927cIdYhJNYltEJdfagNU+9rjnIOB54jl3KPpjVCH/QQn3JbJ3RBB3EiuOcxSHRFjsNFBqstjuyx3jKyBleLOUvLJusqzKnfTZLtyCkrMML/boFj/0CXbEEUTPYgEDDvvHTntEhMw5ZeRv8zQN80aH91RIoDK3ogT/P0fJroBZOHISDR2azjq3WlLa1zvjb1YeGrCZ8ykFYfVY8twl5cJa/aN3O1QYoDBoJ1WBulBcYx4EkvWjOyDy+0W59BG1T3dK91dFuse87C+briXWdURur1yG40R5ep+iFChQ62sSCjiTFXy2IuGTi2ZJMBTWjrnjIakhBUZrNQZsP0Zp9IZ09p4IH2cIj2dQgmXrNiOabjHfcCKnSzHbT2iGoCbNcuw5lzCBvvkRovcmp4U0vnbl8fqsIPrk1ypPBLEAz3X6Kt+UZL27541/UzPxct+Ea3Wk93jeM4jhNxQ+OqIrTCono3NicDLbDCRhL/MbnRcnnTE3r7k2VOnjmdkDxwQ8vixiIMc2QLsGNraxtUNgIChlnxd3+30H+vnMiUZzVmBYGrbheT1nWcAzafth5PTyrACXm5Eia8AlD/ZYT3+Xp1eFkWLxg0Ygp2uL/+K/UBpMfh2vuYeL+wQIrzpiF0tZvbYVEmd77JOHOzrSmjwRnc+FvruHWP+qiH+vZirI/nOXz6A6sbofqK95gKDXAdixOSwsxugl+7qTlYQ26EcRyUQRnARA8Mew80ATGznyXsiji9dJlz9ilS7IY+MHZNiIcad8dOpBGiQlrDq5/vMZ2rY6t5M3rZCQifIKAfZ6Gnu6CrJVXD89udxAuU/ziXnTjbDSdXTzoxfPVyq+Y+wwuMg1e/zzim67hBi3qpUzfCezrBP3fGAqY5HqE/3MN3K2Gw0rKSM9LMtZiKnZ4UrrRXDYOcgcKVy3cdSDaxD/tJNyFuUZi2uMZmHzAR0htr4aHMq6aptfjryucRusIjE6SNjscawBIs9II67rFIbW1SlyWgSxzw2mAuGQRcYrXFnUQy7VqBADcjevuK+6CH7jumA7zXc+OmF+1ELfzCH3zCK7zamz0j062WGmQ2o8M9SLyXhjd+diSy52cZs6yHZcb9ziwo0CwfyDcU9MAPDPsKEDuw32zhtrzLP9CKqAysoCJNO46ZhWs2UrtOY//gPuzD3sqniaKBDtSPBn+zJ2jC0I8DLKSoqyUZv7Jz8YLq8aG4uj8WJV7fiV89rjnMvDuck+0ASIHU1h+bvt9VwMc48vfV8Qs82Nce24e6Fqy9dVMB9ae99bP9HWR/w789fGrD3N/1MSwDyLpB/+J9R/76FobptenO7lDQLDLClk/2ySe+4v9v44/5VUm+TAO4mQNEN3ADBRZcR/BguHQD3SVcqNBhxHcS101UF+8htnIb35kj51GePXHivu2rhw4lynHoeilSskJEhw4njHiZc0gTLJ2wNHkyNMeOF6F41FipYvQo0ipBmAJx+rTpUxtToUZlUlUqEB1GuBapMWT/6lexJ8iSHXEWbdkaVZFeWQP05qVLtDTKy3eXHr558/rtvduX41/BfPECHqwXceHDi/H6dfwY8t6GkRNXpuw4jZvMmzmfQfPZM2jPWtpQIX16dGrVollzvvMadmxFgShhgvUNnT/dutGN88br0qJBw4UTZ4ToeB1TwEhN2jNpkqlTy4ExXw5K+JYtUaD08N5DRAsa37fUiRN9+vRiythDc/9+m8GI8RNSQ5jxfkP5+flD9F8RowAFFNA/kAwUyZsEfUuJwWiiSYWJmEb4oQo71sCpl1504uQQuIQ6CsSlQkTKqqiYAoOqFLEqUaqtnNpKLBjHKiutGmdIQQe2rNgB/y6gDJHrkmfM0YfIvADrp68jy0HSSCORVJIxyxqLMrDLrBzwSikv6wwMLltrrTTTUDNttS9LC621N2Lz4zXa3LTNm5X8uece3sYhJrhB3CgOOUTMow469KQbdJPr9NCuh+7GA6+FFkTwrrsy9ECPlPXWg2+aTDWdhqL5PL1vv/5Exe+iTkstsKMDRzJpnFZR0gZWdLSJprde1ICJCTs84YTXDQnxiaigquhy2KuMBRGIpYxly0QUVGQxKxeL0OpGaWekUcKzLkjrK2ejumIHK9xy66cfWRGyyXSPfJLdkNplksp45c2S3isNsxLNMs0sc8zUxPSXin3TTIPNgmFzk/82THZ1dU7d7jREDzciRiTiP5mDzhLpSMm4lE8sYUWWReLgDoqScwCPg0YfFUK7San7BdOY2QmVvpqr+W9UmvXLGWdTHwqQm4+GHGnVVld6VRthlFbawWgg+cGIQ3jqVacO56jChg+JnWpZZoPYUdkTw44WCG+bfUoFFVJQW8Zuw6oBWxAumIlbHNdqyqgrwJWC7wt/BAUUZIIuknDE3j388MKnnHfxxuvF8vErvZzcTDL/vRzgzyxXQl/NPN9szTYRjuuVVumsc5xL3NhC4onjuC7QjTcZhA8+BsmY9u1M/g6D3h2loeQ2ENnkl+pgllnn+j5dftSdm+/ZZ6CFHlr/JASNvgVpWHNZOpdaUgmKk6lhiUQnD9PQ24sgunx2xa+v2iFZEcf2lqoSVLy/bbvHYoF//skCISbb2pZacGSDr4ULfXrr0U/kQpd0HQZx/JDgOSSYOMXFa10QjNwGKwOvLQkMhJnrAuZEyLl+PWFgrjHYCgFBlBYawhPHQMfp0KG6PbmuUqaIHe3IYB7o7GFkZdidDETQuxBgoFGJsl10QMYM91wKeQaxGfOeFz0rQs9n0yNa0UySklxsb2lLi0YtIvGHPzSiEeTjCU96ZKGrFWta+HsWE0YktvvR70VkUxvb2Oa2qeCIBRoQpAgEKcj/aYB/BjxgAtE3h7fE5W8H/xpSBPtBwX1UEJOZTNIFHbc4KEWuSpT5pJa0FMLOlZCEANvcCFl5yhSGzoV4CIQn6tEwdPACEDeMgx5ySDtJ8IEMTYhC7YBYh2AKc1EtOOIyxcOdXQpqF9FMT8emGc32xGxT16jiFbnZzVINLhtbFMc+FJQSWCVNabWIhjDGWAk0cqIRO+GJ1YYSFAvpLVrO0mf7xDY/9qUtjy/KHyABaYP+HbKQCc1AIk/EyDUosJGQvAQvJEm4CJoEoxidIJIoaJdUPRCknRSlSEkaUseItJWm5FcrWTqmVaaypaZU00xpCptLjGM3/kgGKCqGCJBZonZ9CGYPi9lD7hyBBo1aZv8IHHDEZhIVOaOQKjWpKQqrXtWqsbCmpaCYTfvY7KsIscjNrMGfwX3kVGm9IlrDKU5yHi176BSjMLyHRkLEc54hypo9gyIHNQj0j2tjX4hOFISw8HEqAMVf2nQgWII6FkcZKORMEgpIEpBgkUCBqFuy8Ei4MJCiFbXokywpwXpk9LQbrZ67PGpSTpY0g/cqqZYy2MGYptSVZ7qtS3mrBSe89LYC88Pn3qAZFxqCF7mpUzKyMwiQTcKYQw2qUaNwhCYkVZlGdKp3hnkeaC4nGOCV5nhHIU0odhWbm+KqL67Z3vSSFb5lxaJC5FugoLWVaOO4BVzBGMZ0ppMnhMCJThr/8dAPKZIp9UyfQQMLtawoZWwBpYpjc5QVCj92bQSVrAYoW8gNLBQFmGUKDjY7Lr9mwY0SpehIWEskSpoWtak1CSZb/NHW5gXHjNNHYJK0JB+LdJSN+yRrRqhSVAL3t0lG8pKLbGQ0rJCWDqMFxXAHTGEac7rC1DIyaYBMH8ZOFtDYmHrJnF4zn/mJxbCFVCXRCau22c1Z1Sp72Vsdr8Y3rF+NrzT4fF/8fuMbTYOVf/37xVq4kxByOKNd38JXv7YFnwxO7GCNYqI7yjFHioURjthGFn0elAKVjSwKRswjKTi6sw995CM7JBdenINoFSySgahXWladFtcZ1eSsad3r/5COtoM/htdrXRvku+C2ycleKZOV3OzeOju4yBauTWV4j9QtAjsju3IdkLNLLBNzeMJRT/GQUe5y4xkaB/HqmenD7jIrYxdSFUQf6F1ve8973h6r5nVk0e9gqBm8mNozN5Lx5zg5SFaE5p6hKxGJRGNB0Wa0mo86hD5x4dOw/Kw0/PypRwnHMdOcHvWnPRxIQW5An5dN8N5M3LdVm9hqh1hxrC04SXFwNMa31iiNb2xjA7k2MZvciJLa1XOg06O2RZJ2tI/MbKdDm+kyBd0scJoNWVhCZF8u1KD8Te5zfx2+6xZ7FN+jbrDmWZt6Vq8vYiGKX+L73nEPap/gjJ5PlP9CvF43nuCWUfBwAnoltALjP3RReIUfGo1ywELeIK7ovl7BjIp/PMZNVHnLZ0UqeAR5jkbORw0bMpCeDnEJRExivrk81atGsYXsEIhW84IX7KLxsCfpYhjnfMaqXS2Op+frk9q+5sM+3NB8/2vCLR2Ez3668qEOU+Sn8Ax+YEU4ifGxjIEMF8NoBtjT/ozue3/7ahe/2eMz9vKn++zpRztBNEXntmMVzn6KLnWNyu2557vud++YLGjR/1ckI04ADSVyQa4M77+WBvEeLm8u7tGcovEWDwLRh+OCQMT4qVk07dLQprE6LQU2LAUO6aBSrgSY4vTIBfXWINFeLvXKZaL/bs4eJMgFh8/mKkjXalC1ZK21ig8kFOPFepDXdrBKOEnplC3qmq75jhAJmY4IQ+h2kqH6QIYYiGHguq/8wO/8xK8gxO4Kzw4+yA8L044/vjDNAG6aPgE6ug2Y5k8NsYwNkQNwFAYA94tWZGXQDE8VFK4SEG0MJA9sxqUPGS8C8WnjAEqxAOps0OZFMHBa9ijDMKyyUCCRSi9ccAAuOusECQEOMHEP38LEWu9HUOHmSkv2KgnYhuT2avCSvGGjeK74SiXHWmwUJ2hJYpEVRav2YJFInOwMmI+VktAXf1EJ6QhM2sANLGEWQOZcpDBo8Iz9stD8nhEa1a8KR8U/1g/d/6ohm4yHUM4QDe9viRgB2y7BE/5PvxyEAOuw8O5Q4XLB4cbAHRUvEC1RAhkJXEgsfSiQEAsRK/Qxn6SFA0dN1PbpskZwB0zPElXPkQ5BExPNalTPE+cinERx14SOemDsFFPxBSUSB3WwMEhLkyaoo2hx10SrFHMRTJSQF4HRt1SS2UQjYJZulz4GGfmuvsKQCm8yGjnFPryQJ7VQZ8TQGukLKM2N63Ko34ySFWgB9mAvQ7DnVYRBru5QKgvNneRgDDTxHUsM4rQSn8KFKUgvH/kxsRjr40JujxoLIEMvEi8LwcLlBBHyruISExsy9dbATcZxVWgxBl+xIjdq51YrI/9HkiOB7wZ57sUKkySBrQiNsKVY0jFRUhhPcjT2IBGur9z6LGf2IyfRbzOnURqDshmH8hoHDjP7jM+isO9GAhZ44RZuIReyByqVZioJLRcqwQzcEQ5usxEyETdREA5UDcUgzhJxYBLhByxFcCBHcATrRywL0QPWRgUWSgckizpZgCDxUcQUKPV+kzszERPl8jcd0vES5tVOKy8R8wf78vZAEjBzrxYT0yNT0S9D8gXj85LQ0/hMUjKXrxcf0z+hDjSMZQlT43YyJnCWEWd+0hlD0yc/00FxUjQhNChJM2iWwTSlgaKWEvZgoTW3ByX8YSqlMkTt8BFs0wxO1B0LIRL/HCESCoE3eVMeseAGZpQ4i/M4w1I5sTMsERE694ixFqo6MwDljNNsTG8T3+IqEy1JwTM8xdMqD8HVNJIfYrDofI1IpBQw4/M9W6t67NMGdU8kJzK2OnLZGLMx/xNN+5MJFpMY96Qys08jahI/aGZBgXIL76xO8RQ0GVRCye8g+OxPSzMbCE4aBnVQNZQ1z6E1XfMO0UFE7zAPRtQOdcFEb/MLVNQRMrVFC4ENYLSzaNQEapQ4TeBGcVRHDdE4OU/TOs0DJKsDqXP0diBHOesdXzQFfRMrVe8gHc8q56AFLSkGxZT2HEMvszQwDXP3WitYL/I+bzAkmXUjD8SDIPNM/6s1TdN0TbOVyQi0QGkyQekUXK3xQe+0J/vUXO20NC+0zwwVQ2HvHHhBExbVNbfnUSH1ESR1KivVHc0gEko0UxuOU3NzCrKAB2Y0VG/gYCexVE2VYfMx054zbdaGOiUL5ZTzOrdzSXvTNzfWkVTwAR+yPBETBoEvPXHMWJPVI8DvI/CTS+3CL3ENZifS1mwwJBOTP631WnPWWgM0c4hxEPwgY5oBQcHwIRTUJhs0T8v1XJf2JpVHeUwzG1CTG1AzChH1FeaVXutVFfLgESJ1UvO1Uy2VXyPhFv51U79AYGGAB0j1A0JVYRe2YdPGYj2AbhfRR1u1VUfgw/Z2AwgSB/9IDwdSzTvjsklrVVdVUPIazVdXrLQsKfhaliRRFhvAD1088gUhVz11Dtc2yje8FGblsxaHkFpxVmdZEmpacmd9NhzRpWnnNHlAhVztFGmZlnbH70KjlmotNEOXMiewViof4V4hlWuD92sLr+FQFG3ZYEVZ9GzRdgqmgAjUlm1DlXpDdW4J8XplVTmt9wPklhDXhm6FlG7pdsRQ7G+xoLNs9UWR9EjbF0kf8GNlCRRJYllPtsas1KMkl3K9bxmQDkyTtS866j4/d3MLM/ea1SI38vhSl4FL14G3lQtQQ3UPNE4z04LHVU8xeE9rl0JPM3efAV7hVRM0YUVvgXjvFYX/uTYPuLZeDVBfBzYMVLRFIyEMath5nVd6P6Btq5dUtdd755Zt53YHyPeHx9eIibggeeBTDRI3X1Rj18BwoRghE1eBboKixuFY/7ckS9ZYQWJy91cjtBgXK4iAY3Y+DRiND2d0b/aBna0rgFFbYUp4ulVOt4mKkjaDI3Q05QuM97iDPVh3q5Z3RxhTgbdru3aFVxh4WZh4DW97KjULnreGmZcNwlYMxKCGYQBt1VZ6aRRUgzh7R5B7S4BUTYBuTdkDSO+Iu1eUD3aJjVR9a5U73RcuDxJ95Df2wJQ+D6dLcxB/e21y4VRIVhFZSfEUT8sfCDiNl1mN1ziCV5J021ia//9ljj/GQuu4aF+XeWZXjye0JlvXj78ud1HT/zyh/3aFV0h4RRc5kds5kQ3ZkQuvNsNWkmOYeQP2ktX2C6I3er9AbYkgejnZk0UVBz6Zh6u3bXdYhxe6BHS4lKlXiUU1fQc3V5/4fetyVx+tSz4Rv4J1LwFYcjnyFr+Ycut3ZEcx58rYPdmzmBOHjZ85mqd5mnXrOQIHvpxWm+8YjzW4aZnxJvn4Ji+zGpQxd2fBqI/6qBVmV+KyEDLVnZ96eEO0Eoz3hZ93hvE5k8NAnzVZk4nAn73aqwt2oAtWrHHgYF1gbQ86VBl6h6cXokFVCnhgDmwYE2tYinsTo2v5nrDGBv/AABAmyl3FyaNYzIvDj3+t4ax6Dx4Wm2SZ5JqHgdzcRYuJOaWVGdawWCJb1qWdOaZl2rPblI654aZzWqd3emmboaenELWBen8v07Uvs/+Q+qiTMhNqG0gU8q6UNxKg+qnxdZ6Rt56bGqtt+JKT94aJAJOTd0ZllKybm6zRWqxdgIcTmqHd+q3NegeUeKJzc66jGIrz+iBtmVpqYi76j38pqkKv+bH7L/va+zLx134Xuxy2z9+E1hT/92U117K1dCPRZYxh+qUD/LP/k1sTIRnv2Hnmq46JloNT24+B2rC/jr2r4xgrnLZtG8PL5RA6JDfFoBJWmA5ggAigGnjt8Iv/8pCeJVlgiVurNTkMLlkM6ADG0Rasvbqep6CrBZoHoJvHTUC6bwCtqdeh1XpGyzquLTGSn3cTkRy8YzSBZPUDZwIMFuFvACdw3HvC2xsXsK/r3rsdvvxkaxH8/q3O7ttyDVi/zdiAby5lVdZJkGTAPXum55gU+I4cENybXJd2+/iPRVu0W1uczY29aZsUQKbQM3w2AKFcegSKX5wO8gCgR9yd4blEdaE2URy491WSNcGGXTzGd3vGi/u4T5STS93UT93HXSCgfTzVedzVndsSp2CuS5DJm9x8i7NsLgACLAADfmBSwDEUxG0RZmfrrNzYu47/qsPPvlwVw/xyN8L7/4xhy/vNGTI3kwZYpf+SZUkateNBsuNcJd84CQD8t7Sj3KW5TYXnTUuTVBK8mxqcz0EYQQMZhD+43meh3KLQqJPyGC+cEv4dEgA+0REGDxi9YzsLBsQg0pG7neH5kU98Ny1V02+802t4xhsOxsWAhk/UuI27q0n91F99x0V+5AnWHQm25I8c9VT+9GrdfPXmsqzzBCRg141oBXqg/r6tDaPKQLk82du7UJmd5rq4sCF7zcJs6PCbWXNtpbOYFIuE253BvwW8s023+czdCbB+CWb6Zw3cW+er3cOeT8813uXdQvP9g2V70JE6KQNe4N9+4GMpltzAJioxyfc50p/6Xv/z8NLxuYmVnOJdnMVbNA/zsEQvmVMzPvEzHpNDfuRJPuXHQMdbnscJluWZXDi/m292hAQ2QG5o/gEeAANCHwNg4ju4y7q2rIeAHdmnvctvZtmTVX+HYRVqfxWMwb8bO79REYGdHl7a3LAvQs6tXsl+QOvH/dxX0oQcGLS9fmjtGM8ZXEIB/RnQHu3J2f/Wvrz5fRbgfuBpg4VgY08+hPz1hgeeV8TzXpENGXgL3504fuJhGPArnsUr2f5jvOEw/sPz8NEBwlEeOnTEwDiIEAYRHgsTunCxcAqPKRJhVOSBEaNEii6kZPH4EWRILGtGXrFSggQLDRAktJyA4MEDDD3/avZoYhPnkRY0ejYhEwfRpE2WLMlidRSULKNMgTmV1o5b1Knt7Fm9qs8ctmfGVoWKBRbXs2VS5fW7yi/tvrVs265VexatXLNarV1rNoxZM2tP+i5x4peKYMCBCxsmjDjx4MOIfwB2DHhLEsWTnUiuzEULZc2blXAe3CZ0Gz+JjEIlp85uuNWp07leBzv269m0Wdu+bReZ7t28dc/6TYyW8N/Di7O6hDw5UkXMIQV6fucOGtLS01h/AyZ7Gi9uuIPxXmUHDhwTvxA5T4TgwDyP2ld6X4mNGTNj6n8ZQ5+i/v1hOPb/AqB885khhhgByldgge9FYqBCCTWEEIQPWXRR/xYbXTThRzBksWF9I3lEUohyXIGDFzuoxFJME6woUwUrbKHHIHoIEmMffNyIIyI56qjjIIz8CORQPg5lCjDEVCNVklXNJU9dzdjyVSehHDXMM6iZBRdcb6n1ljhpYaXPl2C+s9VdeDGz2F9qdsYYm262+SZmk10mZ5xpngGaaIOURstpuIEDqGyClllboX/2JhZvxi0q3HGZKKecIZRQ8sdziuCBKRrXWYenptplx0SooooaRKk3AIjeeeoN9Mh7bERSSKzzyXHfffbxhyuubMQ34HwJ/lpgfwd9MexBCxFhnrHDWtihRhtlNCEJGYZE7YchjhcEihDAlEC3Kk6wAv8YkoLSFFNJMbXJJIzgWIeNPO6Yo1FOsbKbkvBQFdVWuHiV7iZe7WWlOeJ4OVdaBBccV8JjknmmMmva+fCdEEdsJ511Xjxxp3l2isYeg5Di55+DjnyNyIHeliSixc2LVMstPwpzzDFb0hxzgFTnaRcap/lYET4DocLPNqCgAgklIJsqeusVFCysA2JRq6258sehhRS9CmslBGktBqwGYpiQfg5CSCxCHFL00a0SSTGhFxN2GGLccl+BBYnZZpDiAAh4+624yR0FeOBFHnVKv0C+q2NQ7LbLR7+kmELKU37aW+a+/fqLS5VkZbMkwufIpTDCWZGZm8MZU3x66hivrrr/Z3d2vAdprKRssqGvlewa7iezxo00vuuGS6Msu4wUKZNOajwmMx9/Kc2AWKoGzppKLHT1OhStQ/bXE/2BCQqh9316dCB7YCG9qj31ftB+dKB8lWQdCa/Chq1r2RQSu3baa6Od/9thVzu3umGLBBq4AAT2hkC+PaADYLiE8DLnlLxE8BeAs8QpZFG4y6VLEu+qAxk++MF4QS6CurEG5cjBlX0FiUq6sZdcvAG60BWsSe+4V27ghMPW5RBiFpNTDz+TOjx5LHKUu43tdHc7JPLud8F5IPEc9TjjMW+KlHqeFa8YPU7pbDBG6KIXsweEGrBgjCpIgRnNmIHsmdEDbLxB/0OSlh4xnMcMsTLffDyUPqpl5AbjuZqsCPSr+ZitfgEyD/7up0f2pQ0jbGOkhQAYwI8MMAMuSaACF/gDBwoHUXrRywQFB7h/CU5difvgT0IoFH+1rIUBQ80z8BIKUjKCKPRqYVniMjCrRKUfAqNLVkQ3OhRSQ4fEbB2dLPZDyygmmdT7zB7cUJrJkeyI2KBm75iomydGkWZU7OYVb+YH7GAnnGgYVRJ+gM4ZqDMG7FTBC86YghdkQJ7xxFsEUpABNurzbUkryBwRxL886pEHJDCBQW+AHwG9KlgDqsjV/hMGhTb0fueDg0XxiFGRPBKP1hJg3eiGEpVUUm98M8ABMP9piE02TIIUbClLg7EvwqmLSCwEnikQ50FU2miWmAOYlZYRHAwuIkg9PQ2+8NXLpP5yhjasRjOLCdU4QYF1VAWiqJp5hiEaKV9GrF01CbU7lDHxiccrCjfNSonSfDM6mRLnpsqppiEIgZ0y6MEJZHDXEeh1rxfQawQuMM8XRECe+fwrBdqYkWMRoUBz9NXa1pcrq3HEoEYzwal6JR872i+iCGKoZjGLWTiwgRDyuWh/LrpRRW7EQyG5QQAHyIKRJhCBKFUpSzupDJe+1KWf4OCORFGkM7nUFBuMQ05R+SPMJQov+7KEjG7ko6LaknZfdeFSF1bDHaIuqtrlWWW6ONX/OTHTqkB0nXkldgbZ9ampXlVidWtzTWwS71xoDUQiqHNf/LLVrZzSohLkus67ikCvJxiwXjswgg781QJ9NeCCRxABSuqTjd6DEHrkeFkBVa1qz6ra+siDkQ+I+AYTSShofVUgBnWtswY6MWiDZdFGWBSi+lsbHOYwB4529CQ8JsEGQKCAAQiApAQwqYp+AAgHrhS3uW3ybo2RFwyWgoMePAIIb6TcTwp1XTa6clBmGThWFPe3NQ2OT19pwiRd6V5sbnMNydHd7cZZzhOr6nm5u8U9gUzN1uyza+LrO+JQwlFlza+h9Usd/oIqM1v8i/byamARdADBk2ZwpS3910z7/zXT+jSBhCCCHhJfrWog5gEW1ocRg6paxBsQcQZKwEeEmtizYqCDIxzhNYm6eECN0IQm6thrGRNi2Bmdw2mPbauRuHYkO8gWAQ9o0iJHOwEyYcEiapkXJ2sbytx+cktPQWWdHOEnjfvEBbENPMtxmXEe/LKQxtzlVMqLhGiut2ruzbs3v3nOeOaunf99Z8p0THbSnGZY4evKzQG1UcqbGTgH4dZE89etjeaZGl/A1wZf4NJ/hfDGMa1pCUxaAg3YgMk/4L+HnAfV4wFxqcmzahGzutUmN3kDRJyhKbAhxQuy9a1VLNGgAxtWvSZ6sHtNCIzGOMbDpuOIIomFlqdkA//QJjICTlptPyjZGVxnste7nW1nQDBzUiZlu91t7po+RTcyTdfiFMcj47a7XRzM8gR7w1zecCM1V9o7v/tN56d+F+CEZ1OniAiV9h58NntHoTmAuvBZENpmD3eD5TclvbcyxmePhvSmKd3gAzuY0g/eOAQoAILDojzlKk9IrFV9UJhTtgQzt7nNKdCA3Jd89ToXw3vycOtbA2vnKXYfHeEDH6LDIhVFPzqxmc6JXhdi2L0eA9Sjjq0gxLak0lbRCNLgwNt2fdthH/9yxw5TKRdO/RgEZUvxzoyym72Ux/WyUNbvfhbqtl6qCTzg/R9nngEZhUeAnOEx0VRwrUFNYqX/FY/XRJkwLpR3M/11eRWoaIfBeY8mRvGUcQmWcaWXaSFYeqnXaquHc633NnyUEikBeyawgrVXc7aHezOYex9AYjv3ez7nCAlSCPFRCAVhPsgnhJVQC71QCcvXCLBgdM4XfbHSCE4YbB4CdXZTAisRZFeHhQeAdTLgBuGXOdr2dU5mfl0HMJy0W4RzbhlEU2tXL06xFLJ0Izl1SsilQf4iSoFzW0jCF4L3f3zoh5MxgHUSiAVIXnmiZ3roeAroZ6lBFlqRDbwQHMhRMxKnRZ9iHVVgieaUgWIEYBvYgRq3aXwlih4oeqnHAid3gvwEA3zkAi74gq9Iey+oTzU3g7i3/wE0eHMTUiADMXxD6IuVkAtEWITD2AuRoIRKuIR1lIzBRh9y01FT1xJ6030FcFIu0oVfSIbZaH6+IHba6I1hCHajRH/tknZbdU2KAjlTVkpNIG7ulkpEYYf6J0F4sYd/2IcAiDpfVGflVYib0TGwE002RCbxsIAI54gLpzzQ01aVuEWZiImY6BebyIkaSGB8FVgG5HEfSEmguHF4Q3OpyHoqOIvcA4tTF4O2eIu4ZzQfoHsUYFAq11gJUgmtAh80mQutogu5oJM6OYzE2As/CZS9AAvvU4yR8JPGaHTWNyJS2FpRdzdVN40GIBMicI3Y+I1XqY1oxmTAg1taRjiiQP9lpnRlknBufTJd1WBTkKMuVQZCdJgueJiHyGCPf3ePhLiPrCNEAQkbA2lwBnmQQJWQ0LFfDEkYmbhFECmRE5lXizmKg3WRHedxGNdgeONxp+hjIDkhrpVqRUM0RkOSUyeLMXiLqMiSJciSquc9EIEqr9IerdkeuaAKOakLugCMyNeTt4mbuEmE79NrzSgHv1kSJREipfJj3EeNRoYB37d1WMmc5decXZl+gqOOOtKWjBNd88Z/aJmW61J/7xiP8hhBc4mPddkZXmSX/bhdHhM7RAQP0tCXfvmXkBiYmKIGD7lohemQOdMzc6WYdCWZFTkC89RXghWK/3kB+GRGehX/NLF1c5j5EK+3gpxZNCVQKhFKkiNJi7QoYjWImquHEWLgmiH6CLHpmsH4HrmJorhplFkTbEsJnMx2InkjjVH5AN8HCE7BnNvwnGeyZODobd9WOGDpW/AyUyNEb9qJDF1RXOzmne4XPHgiGW1AnodxVeN5nv22nqaQeHypiLbDdw3ogLOQkGxlmG9ScfvZiWEETycQT22aoG2qPRf3TnijRmHERg0qczKXmXzkikFjA6USRkPzp0OjEp25kq3mmaaZp7l3i6d5c55WayIqqa5JmylqqT5ZC0bnm0xJIiVAScY5jTXKBTfKo9NgqqeKqjuqqj6qW9HpFcTlL70Vq2qI/3/oFkGxNI50V3ffGU5SGqWM1oeaWKVWKojmeaXoiQaeoSdaSl3v5aVfKhWPGInkVKbopBgMCVebF6gSuaZuqoFm9K1rBEYT1j2t2IomIB6Aqq5AEyqC6q6GupLxmqfzinsyx6EfsFgz+Qjs0ZqqMKmtaZuXegvDGA1G+JNECCvRh0dyYH04oAKfmoXTFm0OIKqk6o2pqqMZm6OpGobQ0LFcOY9mOFy0ejmipGVrOXfWuau04Fy+OqVrIqztOqwBd5f8eKxZigyo8Z7wyTmAaQgTWK2L9lZDa5+HCVdh1K5x+gLvGqc6sLRNu6DXAzRSO6Gr54IG1WzNZp+XiJhMC/+LnvkBKzmvG1qD9opyu+gI7eGv/vqvAHuit5kLAxu3l2qERIdawHkiEsB9MzptmGSx9EgNGOuxgyu4hWu4gUu4pwqyXelJpdqN9HiGUPKqVLJ/R4GyV+YuvrMIeuCywDqlTOA6wzqzNesmdilEzzQJs6OzXaoa8Ikay5AMv6E8mVKmlvgG+0WJRCtOo4sEQ7CtKAC1wXs9VMuuE/qgIIau4VGfVpBFt7u8mDg0YBC9QBAEYQuLY5unnSZzqfkFkTqbbbuvrEKTt3BrA2u+KHqwRXmUSJd0wWkHQCBbESux1YgEf7sNgIK4+dsNh8u/naS/+rsbiruVkAt/5PdSdwj/ODAFskvalr4jZnpwTGcKeLxLwaR7rHKmnsy6uiZTDgrYd72TDLErplWEB5Z3B5trgYi2Vs4rcfTZvEWriWCkPaD7u78LRsVLoeJRIiAVPXbQw9FzMy/8kKVSBX9qNBV6vdg7tuaqc3QworogouLLryF6a3N7C49wC1Zsvo5QhFx8hEj5hDIWnB+hAhEAqlo4sfR7bYD7v23cv/zrxnHcuI/rbbIQDJIruTAVf60Kl3d3U+uGJHgxCL86XsE6uqBLs+fZuxd8uqbBVV3apfQArSkTHK3wKIAATfj1TZtsRRLIyeDUvBeYGNWzraTsrtRboTvAYz7MytDjyoKZRYaZ/7VIHIuuqMTlelA698Tu4YMEEb5RTJNcvMUDy8WvQL7kq4S1cIwJqwnt674osC0JkMZoPM0VIARap5Vy/MZwrM2Fy6p4XDhgIc5hYcB27AvmDJ60IFT3BgoQ7M6GLJ7eNXjWek7GSlWLfM8yi8iv8zGyMF0e3MHQGtCv27ORhxzfdAnNITMLDQoMvdDNk7sVWBg/Y076TMpBwLxewMobbSk/ewgd7crRodEibZ/rOsuU1acs2IITEQk7+Qi5liCr0h7AZ2taozXxQ77CHHzBR77xkzVK6GvOjGM7oAEVIBPSLM3UXM1CsMZcZybdjLFPzc1QLbgTlH6SOwqioNVZPf/OtsCN5IeGkzs49PKAuNM77QwjnmvBchazbZ3IiozPVLXPXBS6WXWI7AXQBDnQk9w7D4gcDU1FDi3Ygy2YEX2JFY3YpLKuGT3SHN3RzuHRkuLRsMzKGs0df5ot6boDPLDZJKDZ4iFAIAYHLa2T72NRD6Ug+rqv6hE/5YvTwefT8MOizndja4BjV5AC0SyxSa3UalxLUw3cwQ3A/ivAUebVYNEJya3cW83VX/11u3DHk8svPWIJZmnWWrG5cVDIa009FfzWF7zd322IloCIG7zX561mkdcogM3eC/0ykPI3j9LekphW4GTYVZoziV3SJtLYjg3SzRHZk40pP+vC32H/IphYKiaiylLg2aDtjB9BCD9ZC8KmNoCkNeqB4bXW2rENK/Hza7IdK9FHfYdwCLbtw3ljALw9zWjsADTxMWw8DesQ1Rp7sTRO1d7so1i93Duu1efcZN541dI9CXEQBUUeB4uwCde9DLSwuWkNz3fi1nM9zxdsulDaBnedgHmtb5ScTX8N3wwHRcIT5vENRexdFA83VIYNHly73w/Z32rw35BdM5Ui569M2V7g5qrMwyAFnH1u4ofQCEUoxsF5KylWELd26IeONR3e4SsmBr+2YkG9dO57BUFwAfK74tGmhS7y4jcu3FK9zXucuMVA6uG81TzO3M5d4+fc1fziQTXB/xOM54AyotZUrt+3LrNuMohTLt75LOWGOBTAwGfmPQ/E3ni9AzC48DdPxCgQRC9OxOxlTi5nvsITZ+1uZdm4Cx1xPudz/tEELil4QOCWjeduvsru2+d/kO6pIJSNUOJ2wLAWMmPmUwgKwoP1PnQM4msQFVGaEAbmM+KUfhLQrOKYvtRv4M9uLOOeDuqhPup8HN2lcOqontWq3nWq7uOvqvG4GgUtgAEPIOsCQwuW17nE+iaIDed/wARWkLTebes3e4jD/qWSzKUfnBvppknBQws5D+09/+w6r/PLYeZmdUXQZMJ47rxJj/S3ex0ubF/cPolxvsnj3lbmntHPQedZr//uv5mEzAcJ7/6i9hEG+85Z/zF0++7v/h4Gl/Afak9sQr0GdFMCBmTw8zux1pjwDP/pO0rqetz3pc7VQorq0K0MHGvxXJfxXW25elAHLdAC7xWt2dDOJW/yJz8qahAN6NAILr+fvP7yd4YEPCMa61nexl7zel0mr4R+6Ofzm6TOrA/0ZPcy0w6Pi3AzaU6fR6/tC6n0KW9fvh/1wW8zAj7gVW/uPaz1v7n1dM4J3w7vT0foptX2pDVjYUD9ak9jax8GyML2cC8FczDw2/IAvU3+aUwDbUAv3dzwe2/4hBtB0I3OgI/qyk3OhY+x3LgNX534GU92AAEKFCM+ceKlU4f/rRw5eNnEcUt0RiIVikssXnSSBONGjRwrMgEZEqQVdP+iqRHJBIkSlh47tnwZ06UWmjNh2qS5JU6bQYNYMQQaNOHCg0PfEbV27dnSYbie4YLqNCoyqs2aUpWaVSswrlxZff0qUKwlQGQBAVqE52zaO23VvoUb108gunUV2aV0F+9evXbhVkmDUs1gO4X//FFzODHhw4gLP368RvLkMZXhhLmcWfNmzFM6Z6ZM+YqXKhomIDiA2sDqAKxdu3ZA4wwoq9WUTqOWG7fu28529/7tO/huaMWZHVdWTDkzWbtOOd+1PNgpUaIkXe+UvXqs6MmLdwMfXnw3X8nBl/d+NarA/59GzTFs582Vn4/1cdr3mFJko3v/eg3W776bZBKwwPviGCSR9oAyqsGiGlSIKd+GsUqq2i7EMMMMq+qqOVnGsiTEs0aUq0QT+UqkLxXPWtEQF1886zG3BnuDMBltXAxHHSObo0fKLAOSM82y8MyzLI4MrcfRrijhAtWefC3K1DAQYbZmbBuOtyy3FG445IxLT7nnShkTOg9HqU6S7bbrzrjxxkPPTTm/5BAZot577yFvvGFlIvwMzC9AkP6I5p57GgEiJB0AJbAmRhutaKVIWzoDwQSrgUcoBx+EMMIuJbxSQ1FHrfAqWaDycCwSQaGLRRLlCmQuu1DMK8VaW+SrVf+6ZpzxMcdsjPXXHXn0cQ4kJzsWSCSnyMJYZomcwsdj5xhtBxQggFJKKR14YAQrsQxuHS25JHfcL6WjLl11bWE33TTXZDfO796cV15o7NUwKDyzkYYYVijx89FA8RuJEIO1uScaQQVuVNKGH3Z4wJza8GMRUuyUR9OjNO70NqaW+thjkUcmVb1UQRQxrVddBQTGVudKJGZFZJUVV5td9SvXWG/McUdegS02aGSFdvZZJGE4euglgzjhtGy1fW0C2VgJtVyrrz63GFPWJZNrd63TbpR45aQ3PF/O24bsT4VzauOnQNkklEX00IMLRyWG2IiM9h4YpEa00SYabf6554//RFMqQqWIFcc778YfX5yjON5IUJZmMmVw48w7Dicpz28DZ1zRSeYNVFNPHists+Dq0RCc/bp1xRQh0Vn213VezI/EdsZR95975TGQ1icjWmgpjD3yWaSPXfIKIJxEIAGoCdD2gR7cuGRt8dROu8vusUbX667FLpNMeLlbLks41caXOLZxWSW7grYgI4oodIKCovwndZxvm0KCRH/uAbhoGG5hjIsc/xaXQAZGDHKOksiluMGxTXEqKQn5XOgyqMHRlaxUvwhGCM9kCYuR0GKLQKHqUOgGQ7AKdpSQWYpcRbuc3c6GKqIdDX9Hox2+AQ08jEsN9eIjuhQPec0yVtCO/9c8KzBNetM7QGuiGLXrOeV73JuGMrIIpit20Uti4tonxnc+8q2JfOlTX9rKtr7jeJEZgqhD/cgQx/vhrwwP7F/fmPACOSDsH4SrRSAbYQUVHE5RDgQJHhfYQEVCSg+JAAUxKLg5SiLEkp3jYCY76MYLna5doQhRiE6IlhW6wQ0pxIPrbtgyHNJQLzKsIcxm2Ere+YyHaPhhjXQJl9rZ5RAuWoPwjGg0IiFpSVkYTQqcBsUpCqCZqVmBHqjmPSxi7YtgHGOaJiHGbYatjGZEXxrXaE330XGO57yjHRv5gzxyJFGw6M8f5ZmwRuByYescAiNxos+bRNBil5ukBdehuf9LahCTmiTnuVC1ik/GbRMphOgpTQmGU/JyZmVhEVnIkheO4mqVeHFlXYD4s1zicqR3EKIvVRqIXx5GmJcwIhKlcCQcNM8G0FvN06j3zGd2C3tVm9ecqkkuX3Dna+/KDnaSip1vgjOEQd3kULVXzjjEkX51UGdOWNIGyLGznR0JiRwKJU+yamOQiENgI12CT4hNrA1nuBRAA1pBziHUi+ZSqDFEyFC+xg2iETXl3Nxg0YveRUQq6miwYlazG+bQpYndYUlz6Ts87LKXimipXkLKUpgC83jF8sJneXAFHJTWtKbJqU55ytNuSROq5BHqazmZxaLGYk1KVRNucWtGpyr/R5xqnK1UdxNHq5bBuMdN590G5NWvEshvgyOrPANnQJEoQXGJVKAD+YkR7T6sIlugCVwhuSC6ltdBdgUO6dj2wb321a9/lWhPJvpIlmm0sC07rO1keTtKYMK/OZwVZX24y8n+bpYuo6VmN3sJUCjpsw6WgguUtAPT2qACsGGmFKeIgNbiQrb1Qptwa2tbpOrWxEzlLZuK8Vvgtni2s0VnVbGKXJZAAbx4Y65GcrzIjSwqJFaoRTyj+0dtUFclikrrWrubz+22swtvrZwk5zrXgaLXxabLK6qm4973krKUdJvo3PCgMpnFDoaa5SgsffdCzEJiFph4M4BfNuDA1BlA/ye9bGITvKI5gCK0pHkwhElb0yDgVLUZxkALfAJV4V55NyMu8VLVJIgTexNNKp6XlcdpthBzicZzVCeNa6xVta71yGEVxpDJWgs5HJKtS361gHQiXlpM8D3mrXIlNZ1QvbbXqHJ7718HYUownxKVsAzlRkNp2FitbL+G9e+b46xD35nUzrsEXi9h9KJf7llXfVZSKJYoBUAPegdMwlZqDs3Mbi3Cw1jU4oevDGlJy08SlL4OInSL1DO2KVwI2bSjBe4+ZhRXxnY07qhtXGq9QSyRPmbC31T9x0OhNdawvshKmIzAJFtXYlC+mK1xjetd43VCYfJ1KGzLCGA/1IQRBf+zmAOLUbMYVtm10p2zoQ3nVnhC2phYUVvSYM8CAzHPCK5dJlrpo8E+5s+ADkLUcbCB6D0gw6udIgamRs3Yspi2JJY0vjtBabHvtrfl+U0mAb5GtQec4KFG7qeTe3ElQxwIO5D4xGvRRItjvMkO9/ukqsoTd0t5yrouaFQJfvJeF3XEoAxFJ1p+woeiEBDGLjbdeuIqEbHq5jGs78577oqeQwLozQZina09mDUztkVKZ6WLyHKJ2MPeo3NgIbUG8/Qd8GAHUjeBBp62bqxrfdFcf/G86V3vSKcY0+kBrkHbvvY3lXy9yZH7p2u8cIYXoeENW5TdrRAJIUe3yE10WMf/A79+jDOu41owLuFrjblc17+ubed1Uxr/+FhA3v+UDyXAIjbNswQGs4QWOqwDPIvVWZm8iDbSG700Wyw/uLaiGwzFeqwEoz0E40DbmYMR8YLKWhLSqAIciLqoQwHhIz6sc6as64HjS76B+zqwszTnu7Qygo6nki3pcwe260EetDLGw76qgjsbE7WE4z6Fay6LCL9TKwIgmzj/wIJ7yq4lZD88shv5EzmCIqgLwqCDAsMgFKrGgx++MkPb8r80FKUUGkAw8wOByKiykD0Xui/GesDRK72+EDBeEbDEmIvdcT1FUDpuQ8AW2jbbu5lU+ovdI8EScEQKSLera8FJjCIH/zC+acIa9EqOdrFBo/LEHGwTNPo3/PtB8ShF+wNCgkuPIkS4hZs7hUtCK0QC7DoyOciFiTsUvnM1ugO89nsc+OMJS1iGLSQHTBKo+wOXqEI5x4uXMzQq1IG8lxMsutGJRbgEWhiLUEBAyFMLBpyhO5wFaaO9GNlD4LlANdM2DqRD2etAPVxERrQCvkOBDQCBJ5LEnaJES4QCS3i3GFyjTfRENnFGZhQh6TDIHSRFUwSPUxQXdljIxFPFIWxF7TNCJIxFJYQc74sJu6vFVFM1s6JCSrlCWcTCtzolVhhGYmxI89og9YpI/Uu5gVwolBEINiTAa1wGbFTDRTAEFPJGVv/qL5/Dwzxcix5yi8U6jNlplQXbM5dZx0R8R8JggqG7FtUYAHtkQXxcLQzYR6CSt3IhyOgAxbBEj4I8yDZKxlSkPg3qQYZcS4jcolVkxezbPli8yJG8rpC4OzMov7JqNfRDMl7UGyb7vvQbSbeKMvo7vC8MQ2WEyf1rxjNZhZkUiFXIxoEYsxS6RlqotZwUCAO8zPsSxP8SytE7vREZLGwjLMbKwJtpR1aCTQ9cmR3hO0NzDazUytxsJn2kDa90MRYDSLJUjrI8S5SDvtJJvNA5xepbSbVMLzBRhrksgzpyRSV4xbs8zCObxSa8u7wbMmGQAwoLSfUjzMP8OwgCOWT/aIctFDmVRMbnFMKylMwyDEvK/JDQ/Mxw5ExiyMmpAE3IOzMHzASeG0pEPBFF3JXZmR1IUMqj46+PKpEQhEf06wCrG4DUusd85M2qWDwZvKLghE5j6Lq8Os5Ma07nTE7lTFG7kstQsx8fcEWLXLgXwM7u08i8DAlC8MghiwRdvK7zLM8gJRAhZT8u2Alj409bW0/MYc/2nKCWVK9NlM/5LMhTSZX7DAv2YDCw2M9hXAb+5MyneApsFAhXogRSINBwLD3bexWjc9C+MIyUcpHYVCVV0rkI5SGQQK0nYYAMZS2u7M0Odbu4hL4R7TpRREsgPFFFNUW3dE5Crc5IjVEZ/+W+JGxCktROviME6DK/SJjCqNvFuiPSlxhV80TPwQqlMFXSJdUcJ82gtNQNxhtLK6VPx9Or9cBS+AEFsAjHL01SXwWZnBRWXGCwM50FUviKcITANb0o1ZzAZgtEzlIwdIxNBLXTa63T18HTXWqiEVgmDfPTngJUChHUr+Q045TS4kTXEs2NRVXRtnRUhYzXg4JUSV046rRXjYNRjTPP8OOxcwOCTVW1e2A1HzUkAfHXUl0u7dxO9jPJNhg8REChU+HMztwXJn1SLIFVgjPLjqXV9ZhJWt1VXgXTksWKYaQKYOVMUlBWYlBWCPyvu9jDBEFKDFypuqC2o1zNWHqVD/+czaisAgB5HqsrgKJljT4N1xYc10zcNBAVznWF2rRrTBSdV3elPuOw16zVWiGwMR9IWCvE0ZDAu76kuIJNlEsV1VLl2rVVWFjjWpi4sQiiH/uxn/jbg54IkTA1vIy1E1jtJDIEIZEVXFvA1fvUUpI1WX9ZCmBdCl5Y3HBMhmMgvcgNx9N8ldQMogbFIZUqR7eQU11pmbfI1rdgC9WsAj29MKNtDQbATXDVzT/tgUAluEEVzsh82jAJUTqRWlRkVHj1XXll0ejc2uG1ThrdV7blp7Z1QiYYP7L9I1aLOrtzHML82iRA3sHcSPOcCIgtQlCrAz7Qt4ml2JNN2ZIpSC3/A6EOKdzLpNhk7VWT7VJglV/+dIVjIIZjSAbSY9O3qDPKglbQTanO5UMAjiWfPVA6GzpdGloHULcoQdpw3VCv+01nIM6w/MSwjFrd3V1jrFrgpVrgEN6traN93drjHUkd8DG0vVHvG9voMpSEMbJQ1ciVAAK11bHrveEfrd7uCi+JmEginM4Y0wnN64m4QRVgSFKA6hesSF/1vVLD3dUj5lKsoAXFVdyK7cyS/VVpiNwuplzLFWDPtVmPCmMD+98RyVY7NZEEBgx7eoEK4JZnal3XfV1x3QJT4FAPvSKy/MRnvN117TqNfUgPHuQVfdTjgIK3vdfjhQK63Vp9xeEV/3aJhNVh7zuy7uTUeboHWAiQ/9k4JqReIxACG95h5ZVb6WzFGTsu8A1fU2jfOoGKr+AKKM7VKA7TLNZi+MXiKUbJfvFSL6bcY71cA3O9BnWlMjbjA1bmt7C4Cm3gBHgiaE7aKXKAFrjjPJbgdO3jWf3jEtXgUSzk3+3gqc0kRLZXEvbaHLCxOjLeREbnSB5Sv0vhxEEy/iDbInuBw5FkSIHkfsZefwbowIvbicKfiflhVR68hA7fbYqbZMvbrziVyuTlzqxiXxVW+NXlWL5GZK3oXwbmWbBTzHXWo2wlmUlQYk7mnf3ZRfShJ3DpxKlhb6XjaWYtEbjm0Skbbd5m9P8hyAz2ZuF6S0IW6uBdZHTu2qJ256P2AeO9XngG25T4g1rI5D9KhZDsrhoeAqxeFBolz1LOp67GiIeV1LizI+5N6LO+W0vB24d+31zmz199a7dO2SvGCv1c2ff1YvzN3zgTOjYeaW2ToZMSbJ1d6WVGYBtA7BowDQZWXZp+3Q4DKsfU6W3u6XQtjva5vqFSCkPm7EMmDrZN6nRu59Am7URGgnfu11JFKzUwmEYIMiL7A+nNuH3OaiJNlBfwahSe59pW3h7eXooswp1Aa4iFpLzNBPd167hehmTgT+aeX8fVYru+5Zal7vtt7mA+Tb9O4AGunRQZ7O8ukdKNC/E2XTD/SOwZcOasdGyj1bqfckkX42PKruBCjbfMbjQX++D8fk7iJe3RZlvRburs/eeGne1/XphCsoK8QxR6Jk/tdPCtRuF81m2Nq+QJ51evppSHPQPrRGW73YkiLm5WmAVfzYZkKHGPdu7nvu5cru6K1WWXfV+9NnG9dgXTk9kEpqhrE2O+2Cy3sECUTgsyM2ztpqjETm/1vlDHth43sCIJtmD5jpNOM9QpnyrQ6V39/s3STuotZ2QAR22nzhvVnsWU0MUdIBRtqGp/dUJSRuGzze02f/MZJtLtzYmxTmiKsTzEXfEUV/EVV25X+NK2FnRioIpZKHQXH/ET92L+TAVXIIVm/x26J9tulBpjAM5Z8OYV8S6ME0lNIm9pl2YBFtjTxl7vx44mWqia9w7OC7ZV5Ktv+nZ1cwXnoH7UIFRnpO7v421nplbn/wbzAf87jiTzRoAENChl9xvzUbXwJIvz3qaIiYhUiNU8OcwEvF7ua1dubOdz5U5xyk3uVpDrW0aGlnUIRadxf8nuSJd0O3vTmLklNdBxAyMzIf8LTweM0z3velzBOub3x35BTBw4p61sCtaic4WtED34WL/vzQ5nh/TsNcp1GN11LX9nX4dnNgf2BOpkWpRzX2xzkMBtxbHwgNZqNj9Vk6yYAuQ5XmB5YHb5bvdzbodxl2XuEY/ryZ356f9GdERfhj3BX/sNZr4+C3V3ghzfcZAKKXfnldUb6cw1YJZm43svcu8LdX0nWlLvdwg2viZX9W4+GyGk8rDntHId6lRUPF2PeND28rXv9Rn49QsHa8M8oOrazrRSYQoX+ZIf+YDme69+9h9SBGt/eWDWdsrt4ph3bkCn+W032Z67eZ1H9GPYE284dxhn0KEPGKO3Vsfq8cBeetPdodD6WRwfOsB46fOegRO4AAj4Vqx3fUrM+tfAgBMoPMkmy3tBO07D7HWV8u+ob3/Eci2xMkVO57Rn++N3+7cP6FBOMrqvLuenYaxO9o/f+xcw3uof+ZC/flBmMglvFMC/Xxkf/MH/v/Zt9/aZZ/nHf1+bB/f2b/9xv2JDD0dvKHf8nQX8ZVmh96G34huASPPmDh4/gSAd/JNQEcJEB9X4gThwIkWJFSvi8aLxokAwXZjYCFljZIoTJy5A6ABhAoKWLQkMiAlzJs2aNm8aoIlhxSBaz65RCwoO6NBt0JgpM5rUmdJuR7f5aup06dOpVJlafaq1qlOj075e3Va0W7qyY892/SoUrVooPt7GcJvjrdy5cO3KuKs3L98ZQv4OCZxksGAkhQ0TLpIYMWOQjkEieSwZcmPJjHWAfPECs47Onj8j/pwZCBDNSF4w2UxZcWIqaF77IZXqGG3ayW7jzq2b2O1lvn/n/yZGzBVv4a2OuyJufDkxn8hpHXcOXXgyb9aTFZc9axYpUIoA3fG4xQl5j24GPlz4EGEgg2raE3y9kaPA8By9nJ/IpMprJlTIF4FCSSddUOBKE0DgEk4LMtggAju54RNRExKllS8XKoPhVhkylWFWWHUY4oZZpUUhWB6qVZRZbHmVYosveoUXXYDRKGNfNuLoV42LXdbjYpY1xhllq3lGJGipUaYaaEsyWZphqKH2JBA+ttYfGomQUptuW3K5W2/GYccLc2NuV+Zxy5U5nZrZiOPNMdsRF+cskJBiiCF46OFGeXvWh8d6CbGXXkER+SEffR2Zhyh+iXpEJAsDEligBf8IsqSgAA5iiukDPSzSzE8mgsphVCOGRaqISY3qDIqlsrgqWWi16iKML+6V44221rojjYftyiSPna0GmZGPCRkZsMNiZqSvoEXZmWZIOntas0OioQRskKSSTXVc2qbtl2ECN2a44pIZXXTkUsfmbXJyh1BDeoIxHhfzmjfoe3/iS+ihVj7RL6NGACiSDY8SDOkIB0uKEksPPJCApTbJVECml1LM4E6WIPMpiydytaGop3qMYqqqkuwqrBxztfGsa638Va4v64hrzHHd2uuyvOJcmc5ABmlsssSOpiSVPeqwmbFQFj1lsUssbe2VWR7jbbdSdxscuMEVNxxz25Xbipj/06XJnLfawkkcKXO+Cy+fHk20XqDqwRefoYgS6a9iA5NUsEmQapBwBZQeuHDDD0/cYMU1OVDBD6D4Zg2FKof8sakhYqhhyZJjteJYIr6quYkglhh6izLPTHoMpcNcmM05I4sYtZHVXaSPpil7c8+oOVl0lM0ODfuV2Nbm5nVRa1k11uRy3bVyaprLPNe3qWumK+5S0p7ajX6U6Eb4/qkvfQD+EL74AuO9t0l9++03pQxXasDgDj9MeOEOVrBFJsQ4PlQ4+0N+leRUia5yArwc5lK0js11THQnapmsYFSX1KHOdBG0HdFyxpnLEMtnQRpW7Crowc8gzVjQSo0HV2Mt/4McwzrGs47wjJcMV+hmeWET07mUV0Nxacs2curO2+iWPUa1jXuCsoh+PvIXgs3AJCtQIsIK1MRJBW59lIKfS9r3PgW9JCfzy5TiLpEx/nkuVJErFQEFOMD/AbB/DXwR6NqowLZIsGZxPF3NBLO6D1Kpg3qEnQhdl0EKAks0UJoW7YzmK8j0BxNuqh6e7kAJTBCDhcPrVtbEZMkZPueSzTuT88B0G29oKxXJmZ67/hCR15wHe/TqCEUcki/vvYFfRkCiCFYggg5wAJdQTEkEpOhLKl5Ri1iEHzDlt8UFPch+X9Qf5FBWwMhdKBbSNOMzodE5dzDzjQzc5hpdNkc50v/xm6qzo1ssaLvW7dGPdatdIH2UpM1AyUmGVNrQYJOcNNCFT5nIxjf66aZXcKlrtKBhDVHBnE5Oxzdtuo5x6uSuQvGLUUAMYnuGeCjCzMWWt8QAR6NYqWAO7gAgjV8VhznMY9JPmdUAI0tBVaLLaTOa07QcyDiXzWaycSvcXJk4welTnwLydkXSI+52xiskdRCPQV2SIeF5wSBdCxN+cAJearkCMCgyGv5M4di+pTVOei2sX91kc5iXrjata06YqF7crgcvt/aJIBaND12LKD6+mKSjgDNAMflqTGEeALDEZIBgAYvSBonAfsvIXxhd6kxWdUimM6VpTd3Y2J1aU5v/moUgjViQA8/+9FYmAacdbbcsoYUmWL2b0h/ZGZqb5c60QWsnYhKZLU+ER1o9wEAHlODIQySjHvXo55bYpUmxEpSsBU0XKF/ICrQ9JJYSfWsqGWWv+LS1rtJt1F31ppL1tcSKhR1vYMnr1/Ia9rA3cYAIIrTMlvYPjavKkGRnihRn5rSbbCGjZjVrzW8COLR3BCGBNfjBER6LNbCjJ88+uCTXFhgzqDVk0WqLhkCMEg9GDN/BaikEMBxkFp8cB0MtecnjErSsm4QO2HhRneaqla32+aH24Fov7eKYlT6cJWG4e5ID9RW9hftretWLOAds6g2s8BRjL2uij41qvvWl/2w355tAx8LUv7LyWIC77NRwhtO00VqqzjY4pKe2TqlqDs2Xk7ofuXZBR/TyS4fD1wMouOES3hgHOoTbXBOjGKxn+qonOlkdNglnrd+Z8XT50+i44jjH2300f6wwMIWFVMgoJbKRF/QAEdxBQo/DMsrOKKopj2ybZ9TvYy3LQP56OdZgpjCtbUfPIz3YqEb9o4HFbNpnUdgzFPYPbKpFR4zKQAQcXUEPcNmCHxjCa8eoR5///MKvGjSTB3VeQqMXY4jSuLqTbnSk96UoRc3nClaoAhBQcDCWaDreFAPA4eRd5E6vdwWAeK+TxUjNkkmWpv5dNav5e2VVb4Wzsp41w//JzKRgFylK6xwCUmPHa4eLWTW19kxl+rOE/8TZNAczgoZZAAIO5OUHXACE18ZBYjcdA6AyH+VYlWvW4LQLPGkIt46ry3OMSHq75+6TRuyQEYmsuzQKu3e97c10fK93U6Dgd7/ZSF9qXl3g3Px3wSOn5S3Pd+EKF7AdN/7wp+Y6MEXddYNXKzuOv/ZmGn9SsDserCBiAqC41VNG50IePOSdhTp8BSoIj1yw8mKgM/wSLTLByJ6L24fkLre5dVwFudphDnJQw7o7H4R2980BTm866Z8OdS1iIAlebDI2wEjqU0ezGFnXupYHKBY1pjqzB39p5MYudryO9nQVjvuvSej/64rnke1L5Z2tT3PrCFuL2GeIQS5lwISDeCKFvaAN4aVq5x6soAUYYIEhYJFC4g4+uc2DziUWHybu6Bzy8qc05SkyN0dXGgwU0fwf5LB5dXuepZ0Ew4je6Bng6XkaBrTBc7Fe1XGM7FET7bnai9geTuXX7rmRUpSK79UIBzacZoCgsJEEZ8TTsxBYZsyTaLydaplZmmFcxqGdaDjGa7zALcVA9mCY+cHC9tGG92kUR2GVJxTensGci2WbzTXecz2X9MzJ/QndE9Jf/W1E5LHSomyEFMwBIWghIRwCAHZe56lACuASwxxgGZaexJyhpwkBJeBP6zVZV+AeBEJgli3Q/05VoBqNCGZNjlD8npedgLOEoNEM0u4kjQnqTq0F2/OlU8+QWd0xC/HpRWZokPQZH8BQnBXcQd71QjQcAyeslRf8gIetQBJk3iHYiYuhn+HZXJlgghBqxyhBAr/YX/5J3kRhHiDETdBV13xgT9H5nykeAhysgRd63pQcjMMEQDKmoRkuo6YsThtmkxvi4S/c1xwiHMJFxajglE1BQ+49FsHxYR+SXQ0EomakQIWNYLQ4CT21mYQt1a0l1SH1mu04IvQJWwjaHVV14MG8wQ5ywhuEhEfYksnVUhdI13hcwovBmCoK2nNsByTknC3OIt1EHpxVVHRdl3ZRof6BQRDoX//SVcEVrMFIBuMY/N8XguEIREABMmMztuRMIJnq8Zs00uR+tVoC0WFM0VdmTWNOjgzs7eTBeWAHflPw0RE8geCXxRM6AhsKHs0jylYMKoaw0BY9QmI9HokgSiLtSN8Q1GAt5RJvnUAV9F8VdJcS4ZJVbdRVtSIqdMvM0ZxDPuR21MlE2qX8YZcQZRdF0GJIciT+bQS7rdsOYOIacOEhDGPRoaTSVQBLvqRLNmPipAErNE4D3pQYBYXu4WROvtqFvEiseCNXZKMtkKYEsow3LRwNkN1RHkxS4qM5qmBpyKbIpUazJIvRVCIG8VGCJcvSSKWvnR2w4A5SIg1rSVx/fOX/COjSCIyESHwkGPwAWlqALnEUb/1AfVxC3plfboxSXMZlD0mE0RGEFfbceA6KXmYkLxZRL3qBR1YBYb7n532eFVyBHQQjMG6eHSymCgABpjnmSwJoSyQOHhjUYuVPTVrgSp1mZlbW7XUOhdAeaIZm5UzTNGHg6IgjzIiWCoicObbm3OmO0simcRrjC7LgIr6gVRbSkOAma71ZEnyo0DyKc3rBHHjBE5QELg3kjl7nGySEEL6Cy/2Td8rl23SPRnIkReHiK2VkRW7XDnTkXwomfA4mShomJ3DhSXJeMbZbSawEMwYoekmm1zQON5RpZcIXyygog7Jpg34mWghcgrZI/9ZNlsG1KTVk6E8ZJTl+aEnAU0mEqCC2YyEqzdyFkDyyoDspVXD2iMQNUoURIoVZGEAKBnNSKi2BAAiwwHsIoKYuUQ+A1hKxAKQF6TjwICyIEpGyQikBo50EgnhyhHku6awOUXrmRywF5l/aAH7gQHxWKZUGIOfZZ5bqZ7CCoYBMJxmKVJimYeKIwHV6URuaqTlwgxtWK/+s6YJm651Clr+l0baCHYVKkyjYV8EpqFbkqWgRp59qBoceImyyK2za5gkaKmbEliDppmIEUu1AmCCyGd1JWFMuZVMS35vtnJGYBHV+2h9yxqV1wChyZCj6RRJAJ8S6wiYKacylqne2Yv8rwk0uXtdFoueiHZ29qKeU7qqULuZiqqwc4GexgsQXOgZodQAB2iyS/WeYIhkH0MAW5Fm3lem0HhC4rtTQDi23bhOcXmi47sK4kquFPugbjchqfmA5/lSfuuZmxKsHfCXXlka93mvD4tqwyY5Tiig8Khijrt2A2aNsUSKxQYZyJmsENNEIAAG7zZKokqUhROfJhSVvFWQORoNWaWxybOzGUo+RGoSgMG7j4qKt3iX+daRGeGQQEOblwqd7SmlI8p8p6qflsttkQMYF5NLNKiuz4mwIhMADhMCzxkFsUAIrLKFwSEPtrsO13i4YkcPuHq1a+K7GaCtmvVHTjgK5Pq3/7H2F0SItx5jCU6SrugofOcYrcWZtjLarPK3jr/1mb14c0ywqs5hGirJtYbwo7fQfnwIqafSnSeANwFDV+VRndepoh/3hGxxCKgzu4MKcKB1ux3ps4n7HyKKnLvZlylJuYLZnYGqur7Zs/zkwSEpG0jms4Jzu6OUszt6s6mJAC7SAam5BHAyCJYgwKQCDtNYuN8BDCr/D7tou0Y7ayWiZ8gaFLRhv8Z4CVcjwWuyh8z5v1U5v9dLvEz3swYRhGI6ZCoJQ0DAYb7qgOand7swrcI5v2saSD1QfErxHl6aA+nJo+vwA5fbLo/itBpgPLVGcHVwsOqADcfHvxsKJJ/iv/5EGsF7W6nXhx0RWGgLzRxDocR872gLHrC8aHQTn8UBoBBN4KaXkLGQGFgHGLwdDMg14cBy0wR5YMpZ0BzBo8gmbKSe38LZaZg7rl/JmiNMSb8rkMGiiaw/fiPW6pvXmaN3+zd/0qRQzKq5VZdo6sfHlJgzecmntBxUoJ+sOgRp8XhEYo/rM8rOOxEYMzI6W8Z7qQBrcr/5qCf82Qv/GsasKkZ847nVZnn7w6jgrJkr6peRC5+YCZrpt6eWFp7BS7khcQAVrmmNSEQazLgZ8GgeI37LVkiSDHxSUgUBTsiUPQgiTcEJ58icf6CeL8jSww8kcbTFUaGnu3kOz6Q037/9/sXIru+YPx6gQT8DfOOvIpW86fm2JzlMKNlUUO/Ev60g6wvTxvYZXDjH7hoT6iiEDREAHoE8R4O2M6vSAkHE076kVYEstDG7hckJ3Jsc2zzFDdA+Tmqdd9qUf+7FHAHIeey7MujOnatd7lKXRDTK7iSFLdoD6XkBOTIBysrUFjMDCPGxm5NI/awEagCAUuIZAo0EZJMJfY3JEkAImJ4+2cMMXtYMnp3BDr+kKRzTRlmbTmmbRNrbSnsJl83BHs+ZmYG0Qe3ay4vMD0DJzAupIgCBpPAu0JE06iS++zrRpv/ZQ1TRmZHGIXp8cKF1R28AapAIhmGXe3G0QCEg0503/GZOGHHDCMeRvL7RxqsLxc/+vVA/w40KuIRvycxbyOWO1dn/kITT1c2se0Xk3fFTaH9yTsHpCIzS1eqtBXHNAMGNiaiSOpVXKBVjBC7S1GuTnG1CfhzGEV5Kje1iLEiCEtRQ4GqyVawg2b8guA4pDYp9wO0B4Q+8uPOTutsqhAJnCDcsKZQdvq2k28AHxwcRyh/3tSOPssuIsXGttSag0aUAis4ho0ry0Ldv4TC8YExjzfvRfakiK3bazydWvWRPISlwAHwc1oCp5Gcfo9e3g4PYCcyOuJ/pvdHOzN78qdRPwc5LnoqjsOqvzGsBxsRpdU5O5GuTdIVTE/abCIKNx/5s7MCfYAVD/QX/+jX6PtBo0wgjkxAXUeQdgonKewEEkG3MKYW2+QCK0ObEd+PRYS3KAnLVgx0HzQU9kAzGQcO2CktBOOAqrMAt3IzWemiw0LTRstJqmMgKZesINpYBttvBNb0grsyIvcuIUSLtGHCAyGPMhCTz18o07iyQC+zsiZw1KysJEAGbw5+chK/vo0oHoNrOjABnfOpNHSoHwZ1JDOap2J3RjQqteOZbDKhG5862Kc3brMXZzOa96dxeeORrjFllnGNJ5AnPDx5uTdQ6qQVPXZgVcnwU4gBqkAhCwRATU+Qj8eUFigg+MnHnzt2aoQSeeBhI0ep2jwT0N+P8dxNwZxEEZLCB3XHKWlJUmS7higzowWJOnaLKoB8Oqk4KCSsOFwxcpe8Wpt3po7amHxutnn/gs03qts3iLl7ZLk+2hfu+wR1hMl9Y7rpuxT+ezP6yST2kiC3oKoAB9loDVC3X5nEAtnU8GIMykoASQE0KUR8Op6p23v6zRvWq+V/ehXLU6x33RmXkpAiPgvcKdAJ56x7u8i5Ka+4krwMJCoOofFD7n6YCe4/cfNAIWALyfMwEHmNL84tMtiXV7Q3wqYEJtIsQNyjlqZHMgWOL9tsIZaAGezckstIHHDwKmW3IbTIJPNHjt0v4m0341rDypy8JWKK/MY/RWvPzNa6j/1SIlE/H80/s8rS9rvD1AtZ9jSrcTjD/JxDPlFC/99cd29j8YJR4iaavvlPj0Fl9BF077gFy9Floa+pBxyj7zSbi/GH5XwlzAFstBI0T5/Xdiev8vuLM9QASyMxDPHYNe3iR0kwYhmCoNGUb0EsRhxYcPLTZEiOcQp0NeDHF6JVKToTmNPtrx5AoTJ4EvWa6ECWugQFgsYcE69OePmj+prOjg+SeFgxF/gFRQQ0jHCBFPaTx9ifTFiz+YIP1BYhVSDCWu7IxY4gmrESFOyHpKQwWKn1ZuKZ2R6yqRFrtxEi2jlCgRKb9+gSGTNngwscDFZCX+S62atHXrHDuG/Dhc/2PGjaFlZqw5h4/Onj/HAC2DdOnRoU2nTn2iqlPXrjvErjCb9gTbtg0c0L3bwe4Aui1cGFEVyIumx3XoKJ6cORLnzaFHlz6duWgh1Idkxz4dyPPsTJioAQ++tXLwKVIIl6AhQhBCWIAAQZE+RRAV7CHchnABiBX781m7ID31CLwgAtvWq+KQXsZB55ZeRsJqpwnXMMmkmgpKCCKFHtLwog9BrCIjiRDayJBXXvlIkxRV0skOTTCx40SXXBQIk5taYWkgkSZs5Bgadcrqj0ZS4akRK9RQYwQVDgHiAQusgIQJDp4qDRLxmqyBK5+Y4Morl8SKMRD0kthJrSWoUEStVv8wQWOuupS4i5RkSBnEjz3w3GOSvv7yy5Q/fyEFGmAEtYywyCSjzFDLNptG0NNQs061SSWt1FLWWntNOCotqE2/TxHojTdRf3NgAvVa626544zbTrtXXY0VVutkvc7WWZMDL6HxmGgKNgZmU+9U+VDYAYsrUMAvvwcUyC8/A09IwYZp0cugwGsRXK/YBaPpBUKPJpxwqpcy9JBDERdyyNwkSzwI3XYzHGhGQzryxCQeT+JkjgVp9CgQSHi8UUJXIMzppp1g6UVcH7MqUg5CkCRkygrE0oq0qIY4BI0iqHqBy568LAIVJZfQmKiK/10iu0PaBNhNNOhiS2YtKJklkT3/yohD553zHMRnny35c7FDpWlnsHXgcewdRi9j+rFIoaa0KkgvXS1TTTvlwFNQb3sg1N7A9tq33igejjjilKuu1rVxVZtt7Fr9TlfxjAuPvA4OZGA/VAcUEMkr7FMW2mKDOkEDaVUgdoQIrl2PcWfz08CGkxKGkMKU5MWQoHglWtfzDtuFd47M14ClpIADWfHekg4xvcWhAj74xG+99bd2SFBKBUJCjkGpEY9Q6tICjzEZ4qkO0EoOZOJ1+HjMIcAsU0EnRLjIkyREiCFGH/xoEwqY/YiTLbmoSISlu8pQIuf12c+ZD0QkmeQToUkZzOh28FcaUacxIyVqqf9XNUtd/01TTuHU1j7ltSfZhmwJHBWVzBYftHkmOXFr263elsEaxKpusFIVGuhWN59QhXGDu8J77iOg+oxBYhpw4QtPuIYqnGBvkgsC4OZjIAmUEHI9fJLk1kASQhBEDmvQ3BHZBS/OFQSJ8drcvizUI+DBghAmidC8SBKSItHLdfyiVy+O0bAfZaUW0ZgQIVIRDZRYLhVtPJh4nGMv41Xvelb5Q1XUUDwmSMkn0RpZxYqQpKOs5RAx4ID2urRHNBgHE+F7zsvQALA7aSFnbWCfJdt3ST1JwhTz6xNk9McNRTHqUVMTIAADeMoCGlBrCHRl1xZ4m9mIjTedMpsFNZhLDOqyOv+4fAGv/PMCiu1xJ/LpmwqscCwbDMg2KVgDxP6jrRdC7ofxUUEKNmCtHW6zhwnwJgQQMKwqPKyK5EJiE52IxHGd00JQ1KJHcmKmeHKiF/pCETzD2CKdeOJHWDlGPnWXCn8qjBBV5IQaF1QkV6TiGL34nUB7ogaWrOxMAFPCCPJYlZ7whDV/TN44Z6CI7IwJA9DbWCTb0IIXUOINj6TCS5HQhlm4YmN3uUsbMMmzSr6vDn2ow07lJzTECIYb8DDq0iITmFSicqkDXCUrs/ZKWE5VllElFXAYZzYV+JKXXfWqdn45Hh3YMlfxMWaB9uOs3BQrcThMD9cW+LgLZCADyRL/HDch0CxqnopwdliDEUfHTnNiaCqG+Ndho5jYcNFLnikiCT9zQs+DJcxg9exIQ3/0T4SFEWDe2klD0wIwzs6zjd+K7MCu5ApwdWQJ1evKL3kiUiFw4g0ioEIhAxnJaAVCmDATSPfQcMgrubSmSvBDKuKiBTfhlLnf0xlzNcmHna4PT+8rBf3qRzRpmJKp3bUaq15zy8VFlbyzAdYsqVoBBdZGWAoE22zM5jb5Ksc4XP3qLjfYVTSBsEvcXVJ8/JOsZSEIQS7UVhB2kGBkdVMDG0BBCfDjwvnQFa89tPCzWEACkIyOw4EtbGI/vFhxXWJCJD5EhRhrphW15BUFuwkv/0xHCE/cAkYs9siMOUGWV4wxJ5lgcRj5aTl/BmmenADtSmLiTx0rIiFcMEQaOKDbHqwAD2H8UhWQV0iMLq8rSlGS1tIQiKdo7HhH8d5Lz9dcJeRpzexrM3XzNN0ykIHOdSZDH/R0Xfo11buqDO8tD0TevHmK0CFAbwLNK5sLxIZUphqeKc3TQfpGpzvytS+t7iurXhlXPOERz1aHE61kFvNZ7JHcFU5sV2kZS2LcFNANr5CBvKZ1PQk2Na0rbGG+7quKh5Dxid2ZYsYilmUtkZCIL2HiYk/IEyvK8YpQFG1N5JgXvKhx60ayY2OjwhuoMIRmsYKKfv4zQlm8EZAhm/+MleDox/dELWwN6IQUzSAJtLUtJoTJpeG9FikYmE0X8M2B4h0vyjT1DBXs9TLxLXzNVNhDnHq2U5zhLJN2pnN193BdSUyZz30uDXgJmNVFK7q8hDb5yWU5ckb/plTCGYG06jvf7RBnVTLHL6a/WgTmzG08xTEgguxQiI9MeK4nuOFfg0DhyD1sB0SnwDTTipv2wIfCFJCAXvM2a62H6lQ7QCNlNVHFYIfr2OFudmiVLaFk+5rs0Naxs5td4xWvnSQowgQhLtGKZKRI21hB8rrvGW0fu/vc2Sb3QgNfbpnQawZVilH2yLzHfEMCCcKNwVGMx4EQWEUIIsjEG1BTFuP/tkJ9zikuxBm+5oen7+ERr/ic7ew+PJWh4x6XQQpMmQECYo3k5zV5A9WLwPVW1apjOxV3keOquPX30pm++XTGQ7eSM6taKLgIC16oamomQAP/KcE12eNN8YcTcgeKAAU28H2rM06vDBj/BEIVKgmQgMORGMctTHf3Zav47c8+e7F/zdfSgixMLO7czf8GcNoIMO7+Li0Sz+9uJEJ27J/6afBYwsf4iU0Az91yBBUakAALoguMQASzZy1s6w6EqXmEaQRmiAVHwN8wwLZewLZ+CxCooAWQQBGExA2gYGpSD/XaAOLwRPVajwipK5MojuJyxr9sz7uuJgJmMDacQuUs/8D3UO4Kpco2Fo2BjK8D4kv50obSLsj5NM08Oq2V8CZYRuBwDOcEbADBlklZPqWH2DBxogmcvslx6opxnk4Fvs8D2M/93i+c5C8DFMwLpEATvOVbZAwBHfHZCmoAI3EAKfHtpC3w0G7Jzq4SPdDYPDFHtk21IDDJzO7vMFEDP1DtduIN+ku8WikKoaqVYBANVyB7yiy8IChu4uYHH44I8eQMWm/2lJB98CwJO4PjqEaVbg9TpGZxdi8NSW76ZsPQasPRiO8aq8pA4O+qTMXlYG7mbG4MydBVkIBXXsDlTOgKrMCu2JAiqiDBUsDCDgf89qZYsmAMBCytKKCtskDWIv9ArzygBG4APgIRAgyx6a5uP5wJhY4uEm7h/mLM/xQw2+Du7jyhEcliEtMCI1fE2i6RExewElsCAyHwE22sJEVyFDtxJVGRE68oDWDRC2NRNmhjFmXRJkUAJ1+xB5Gv9MRnCH9xD4DR9V4vzpaQCZuwGZ/RlqAxGrHwKaXK/DplGx9IODYIPb5x55IPOTZtHHHu+aQj+lox1FLAC4KpDTvANjRgDSLhPbTJ1AgnhXTIIK9AhqpuPehK1sZPbzzgHnEAC7JABQ5sDXbA6rQOBDRMCsyS1WrBQWrBYB7qEUWyETEyI0EyxyRRE/Mu70xSJVGyJT8zJS8zFUVzFXslUw7/qCZvspVaQCdd0xa1pgWOwAehwDtUr+FcjyijC2dqbxk9Trz+jCmd8gpjCSqLs6oCjSpZTgvJMiu58jl8rvm88ivD0hzjA/tEwMAIDA8nQFpKIMG+z9Sebi6bRfwyIAvcyh8FUQH2Mg/38Qaajq6e7ulmjT3tUwNIAB67jxDuDx0gshEAFBIzciI3MjNHcxN1jDNLcyUY9EBLkRRTsgMddDRVS0c6hlNmUjVTkxappDWrZEM5ICpeoDZJdCseCShzc/aO0M2QMSmZKjhhA6oCLS2h0jjT6+Su6jfgyylADdR+6W2kExzXpit3Dkl4JQ4vIL0OM8P+MJu4Uz/Y8/zm/zP9HmwDAnEA9CZLzy9L0e/7vu8f/7H92HMAsFTrJgcO6KlBHiQnAlQBCfQyK7MyKVHuJhQVK7RBJbQzZ8ETH/RAMdNPKXF5YEM4Sw5EaRI2o5BTWuB4QiAnZ5NE8wQNJi7OJk72kDAZXVRScE80/iwmXYNxClVDTy5UsRHRQJULWc7RXG6rjGk6vVLnigCEgukJQAcF5BEF1BHCFPI7/QPB1HPW8POaDPM9WWgNwlRLS6CIBLNMIyAgsyA+KcA+pXUvMcwGEFER0cEx2bRNJVISMVJO6bT/OIEWQDJPB3BPQbEBZ8oV1hUT2vVdzZU06/Qin62NeqK/hpPgDHVD9f9V80LA0Dw0J0UACo6ARFsl4hA2CRE2U5WRU3eP9/KVVEVVGhHtGpMTVZeTrF5gq64pvzz2Y8ESSEE2VrpEK/nrHMWCCSrEBrZQwrKAEyRGm/ZjH59JE2JNcFDgmewS6zJgIO2jIANSBQAxS7+JB8zgBkygBLJpAQhR/KR16aRAwejpFrLVW0xn2iJTMv8PUMvVTtE1Xc1VQsV2XTtwbMEWT9E2bdFWoJAMJbLibnBxXw+oXzXvgABWYI/AFmtzRH8yYSUuCZewN3+TGYNTJglVYmvURrEwRw/gVGTy5ZzTVUd2cntpaoh0bk4gLQ3gBIrIPrAv+2TNMPMqnGBNP7f/KViddNYQIAAkoC534A+PdT2xtEzrKpsE8q9IoAFmV0xHFzFRTYYSpxGyFSLzr+7eFFwpVAHVtgNDsULN1l3ZFXrZdWyll0Jz5E+x1yU70I0Qr8tucVDplkNXMzVbQ2sa1VENVvX+1m95U3ABiHCBc25jUm4Rl35l8UZLFb3GRlWbkzmkJRxh9VXxq+a+g79EwGsgwJoUWA65Rg/tMOnY7x+b1j7PL3SDdmhjdwE0eIM3eANM4B519WnxUwLiLwEMMh4TQAUIwSGH16GyVnmzF22nzQNRAYaX94ad12xjgmxnqod5GIdFM16pTSLbCCVe8HE/VNHClwM8tJX+dW6h/0Bfq0Rv93Z9KRXjGPZ9gbOAyDcaMzRU7Td/o/K8GPf4+vcqa2A+KBeAQ3ZtuGq/pK82/gsO50PATDhbpEnCjAVafxXrKvgf0S9pceAGMHiDKeADPgBpo1WDqTR1sbRYNqA98xCZ6rIReqGFKRJrGdCGG9QjaZiTszcm7rR5RXGmpJeHcxiIzzZBQXOI7xTx2sjeygZG5Td8DY0aMRRDeXJvC3ZEC3aXhXE39wBTZ+CU+IyADimZY/GLh3NUJ1Zx55DA1Ms3sMoqsRKN5ytI4caNt0OsAkQFmA49+qOgbABYZ7Yu10AuX+2ZADQIuIlx+vJoS+BYk7URpqCQF4ACkP82aRugPAegAfYRDnCAHcNPIQv6m8D5WOrS/vzzW+rVTT9ZXGnYFHlhlbe3lMn2lEtZo6H3755XlddWorn3bZUYYpc4Nuk3e3pwYHN5l0kUCioOcPHEmAeoYTFli5V5bg83YsEYDev30LDwVOFvf8vmmsVZgPVrCTDiPKQFPAbHPdIZm3SoLOOzwtyjLXFA6bJ0kD1APfPwC8ygBBD5WPu5TMeUTPX5WRNMwZJlPqcVof8ScE4oErLVQSB6ht/UlVGhojfxlUU5pMF2h6d3sFE5ldP2oynar7MoSbojLckGVU6abnHZUAkONQmWitNnRFd0fd23u3CalUAbfMWXmX//urSjsgoDLTdYDjiEQ/c6tnKbojgk6Je0eY2FtJg9iBXPQ+XMrzeA4D2iSTsPE1j9UGiNmw+P1WnJ9Dc8YKBNAAdMoKvd7zfIdLrLtJ81WAVuoBAioTCv7pvA22k3wNYgAAWEt0HsGmvhzhFpuL0jeq/xdKJXOZV1+IfrO5Tf270fy17mAAyWiUZpqXF5uqf91VBR0xbLTDZfesFzps0Utpiz2DcddillI1FzWQpJ27QrwAoTF383vFOouRv5ZoN+aavo62y2UnJx21bQxKlVbg4ZR5z/w0pdDeq2iQG69LgjwAColWh3vFm/E7o9oJCvm4MNGQdg962JtshNOK4J/4Fqh5ciE1u/9RozPVJC9bq+tdyH6VuxvdwRR+e/uTD+ujA/wth+dfpq/EtvNVuzS0/i1KeztXiLhwPDR3smj5iZpVLQnnlGbRQbQXy1+bc5zYrmaDsMVXyXWrwKiiNrgEWuFs0OedUKuBovsw+dIZiuiru4lQ5oCXlYm/sLxOAGjFyDsRSgjRz90i+EN9hpr9Rx8ooFvODJ1XQc9o7K9Xu++Vps/5qwC5tsc7jLef3Lw+5CxLyEkb3MCfw1+TWX1Zy7ojhE3ZzBfZH2aJqYrYbOpxiJD7WLoSrDz7zD9VeWHr0Kp1JsMpYDrDmCaNvQE33FKShX+KspYuP8/uvlsP9ADuJTWnRWZvcDnCMhEgiT/dZvB8ygLb+0IHGgEbAAEA1zAZrbBaLb6krd1J8W4kvguT9gkRl5yB9+LwfgATLsJMbBH+z6I3Mdy1O+sHPs1+2by13evWP5tD4CDLAPD5M953eD+NA8J/e1KqT92ZmQJ1/gUauY4t4c3uXcNLS9zqX4FfM8qsA93MU9Cz1FGxnXKAi93V/73cHS0/B1eKJEDoCgdqGu+8bALrmprlKo/ch0A+5xDNZxyMO0WfHZ4k2ACAh54yv+4rG7S5+bBz796Ta4PpuFr7yAZW3AE8ZhHLzh8U+xvfl68q3cy4V9y3092NvbYFIBZgfi2HW+AET/nwBGv/Qbl+fHN9w7VeiRckSnPX1gP3Aj/GE7NRcvvNuHJ2vA3c+pnjh9z8NVLsCB49GIg1Vrm43DUekVPT46bbbvXRu3zgBaN+1ft60Zp7q/iYIpbMjB8+N9nGgbYMjFf6zJuj6xWxDD3wSmIDC1tPBVVy2xz2tAwBCs9hiqbdjhm/IpH/OdFyBcCRxIsKBBVANhCcQkR42NEx0qPEBg4ABFAhgzatxosWOFjyA5WBBJsqTJkyNSjuDwgqXKFzBjypQJ5QiUm0rKKNmTs0yZGTKEBM0BVGiMoUR9HEUa9MTSmC9VimgpguRKqhFNrrSwdWTXrictMAgbsuxIs2gn/6h1oLZt2whtHRwIQJftBakeVKiocZSvjr9GAQse7Jew4aKEmehg8gIIGodArPxRcyFC5bcQMme+kEFDhhQqguxQkUGCac2nKXxGcTovFiw4SliOQGGB7du4GejO+6F3bQXAc+emUMKEhw2dJdRGPYEixQcQQLDwcojTq+vYWyHcrr07L17ew89CRYygeIPdxx806CmQlSIQJ04s0FEAfY74N0JPe7Y/Wa1SRdXSgDMVCEVMPfXkE1OINahUUgw6NVNUU0FVFUwipcSSVf516OGHIIbIX0huldjWBSPJRVddE1g2U2EwxijjjIc5OCMTOML0RyOT7QWRWMy1JlpoO/9ccUUWsiUAl2kbYAEHIVh4sFwGKjhpxpUfRCBcbgMw4MEHxh3325a3lQADHDeYUMIOsaWwXGYPSDfdHHNc4okm1nEHnp6caAfenXlyx+d6AnVHaHYE9fijfPXdN1d+kHrkFlpkVcVhB1NlaqGABeow000vIIFTTjgF9uCppkL4lIQCXkhhVpl2CBasYvkHFlz/jSjihxh8tJ98IeE6UkUrysXVCCkkmyyNMy7bl1+rMksjEw419sdkThISRGWVoYDDFShoQEIWSCIn7hVwZFFaZrVlEAS5o5kW3AAbsFFJITysS2aZLphgXHFi6kYmBTikiVyVWeyQAmcpVGFHdZr/IBrooYPyuWfF5yE0sSuwdCwQJ4a88VBE8jHa6Mn2rZjyyo2WrGulF2p61aacFhgqTEjcTJPOqqLas8+r0hwrpphKRTRXG3qlNNIZ7trhWCNC/bKvIP1qolokz/foAS2q5CyNLAD1tVMyRvtstDkjAUSoODr013vU2gEuROI+aYVnKJjrGXA7PFkCcqi9KTBwAzTgbwlpfjDmwB/cAMMNJUTO5nH7KqklAhD0TcghaxxCSJ+NXBexxKRjbDrFFWfHyeeHeDEyBiY7ijLLKQNgOwC0W+TyA2iFgFLMwMtc84s824wzggciD3SqzAv9qoZGW3qsVv1ddWmuTmef69W7/3eNolxb8y7CXWSH6izZytp4NtrSDgbEYlZUawWUyQ4ZrnL3K6BBZsEBp8HhQ1KNBAinAOXgRoC24U1vGsDAfX3pW7DxV5gWZ5sEKEkDoMGCdRoRutCl4oOpQ93p9vSdEZbwOxHbnNxqkLWWEeuFsrPP7WZ4O5XRp3tTK4n1gDe8HiIIZ2kz3oGSt7wiAs150Qse+b5CK2GVRFhO1F4OsVe1EvHOahPoALckAj7d8W6J5gPb2NZHxrMNoYxsw5FiGvY+bqWgSCqojAIQYME69g814pJcuDJgLtXYhoEUjIAHIOcbLTnwBmmiwAN58Dfe/K1IayDE5zqIHeyMTlAivP/Ydfy0HdJpkpMn9AQm8BAEFmiAZBc52UUGAMNH2U4ANKQhy5xjtV5RyncAKpoPW0U84+2seM0LZs+QGKBiQo9W/YHLVqw3PaadZVZUnOJJsFZF7p2oMsNKpe4qUKEx9sWbaCxj+9SIo5Rw6zQaiCS4OpOcO/bPMyRQTQmOBAfjqKZd7WrgAT0gQSnpc0t8rKAHClGIL5iBoBwsBJ40QUlLgnBjmUxdKA81UVDgQWQgWEsMZ7dRGeIulrKcJbCkmSFj0uykPvSUL3mmhOMJU5g2M2kSlVi9k0RxV1KTIgdyStJqjvQjW+yipLwGLfQZlUZklBbbBIMjT11Gi5tZQyRhoCSFMSApN/zTHwniBQHiZIEQOOiMHxsYyDKBaYIHNOTgdIMDNkQCoffi4AYdSldOGqR0mJyodUiYnfJoMhNv2MIKREJLbXb0sLAE6QwJgDuR0hFOPRXeLld6vOJRNlQBAQAh+QQEBAD/ACwAAAAA4AEOAYcfDgEsFwotFwcuJA8vGAYyFQczGQY0HAs2IQ44Gwg5JxQ6Ig07JQo7Mxw9NyM+LiE/QSpEMSRFHQZHJQxINBtIOSVKKhNOSDFSMw1UKxVXKAtXOSRYLRdYQytZMxpZSjRZbktcWEJlNRtoOiRqRCtqSzNqVDpqW0Nqi2VtMgtybFJzPSd0RSp1RSd1SSx1SzN1Vjt1XTd2PBd2jmt4STN4Ui14XEN5Qxp5RiZ5Rip5ZEl6SSt6SzR6z6B7emF7y518Uzp8q4R9UTWCPg2CTjSEUzaEVTqFgl2GTCiGWDeGWTuGXEKIRQ+ISBiIfGKJVjmJZkiKVTWKWTWKbFKKdVeLUyiLWjuLjm6MYj2NcU6PonyQxJuSTReSTiOTXkGUWzmUzKWVbVKVsI6WfWKXViiXaEeXiGeYYzqYeFeZVRqZck2ZlniadFOaglybYiybnIGbvqGfYB2hWzOjXB2jXSWkbEimdEunYR6nelenmXioaTaofWKop4eowZ6pcC6pgluph2WptpWqZSirbkiscjqshE+sonuuj2+uyqqwnYKxfGGyfFeyvqOzs4+0ayy0bTK1hVm2qYW3eka3gT63i2W31be4dTm5mHW5pnu6k2u7cy27g0q73sK8dDO84cTAj3DBeS7CflHDejfDfkTDjWTEezXEfDrFmnTGlWrHm3bHnYLHpXnIi1XJp4XKgjbKhDzKiEjLhDvLhUPLklrL3MPOkUzPvaLQz7PRhz3Rp2/Sij3SjVPSnXTStZTS58/UjEPUjUnWkkjWm2bWq4XYllbYpXfZpGnZs4rak0Xawp3clUrdmUvdmlPdolrd7eHgl0rinWLjm03jvqHknVLlnEzlnlflo1vlqV3moVPnoU7npmbnrHXook/otofo8ePrpFTrpVrrtHjru43r3MTs0avs69LtqVXtqlvtq2PtsmjusFzwplfxpljxrXLyq1byrWPyrmryx5TzrVv1sV31s2P1t2v2u3T4sl34tWP4wG/5wXP6yIb647f7w3r8++j905QI/wC7kZJiJ9y/g/ESJky2D+FBcv+S5SrkB4vFM26kkPnyZaMUjhariBxJEolJjoMGydFDJg2XJky4pKHTyZIkUziBBVuGLRo1n9mCAv3Zs2hRc+u+JVV6Tt47p0+j4pMKbyq4q9N8/kKmjJnRocqAjcJZSpTPsaGepaU2aiu7t9WIPpsbN2vdu3bB8twbTJeuZX/57s0rt7Ben9YSX0XHOGrTxlCp0pNctZ49y/b6ad6n2eq1xZCx3oVbDa7p09BQV0utWNvn0J+b1fr1apKm265qYXuMV1McTYSz0j1MnDje4UPjnjYNufLl59AZN2vGGHpmztizZ+/WTxw8Y8KqP/+v+ta1eenNvxeS8sfgP4gK43VP+BB+rkyTMGbE4qZ/Ro8dfVTSSSadJIdKK7X0kkxkCGIJLLvotJNXFBZn2FdMgUbZU5hVRl5TcXE1YYUVymKiKGUBMw1ac6UlIWl1ISfjcYQJtpNfugUWmFBEBedjXhnCJuSGjXno3HWb9VPPaxqCNlqQy0VZnmqtNZZYWLp04gpuuf0lGjFdgfOLIHOAUhqJM6ZpoY9pPvlkekbW45lX4lmnHXbi4KkkevBE51pp5Z13XlWFnFFDIbmskmguDMVjUD/JOITQRP71x59GAna0ERkDNlFggV/oIaocdHDaxUw0PRghiRjy6Oqr1Ej/WV6ctBp5lYhdCZYXbSiKolOvarU4Vo9xuShjmzXeqCOOyg7247NAVtkkb4/BSSRmSe5J7ZDRwpghlKy52dp0gL1iLig1aTJJLDsx2RNXV8Uyxx2/fGmhmsmxiSu+4io3rWPMgJnYZEe2A1034uSZGcL2dLNkeH1eRt6fZ/bLmBs1nEHJLOsVgkk4DTGkJH0OTZTfGfz5x6mlGnnU6aenkkrqTCs/Yokpq/bLTas878bcPZFdW+vEAedqdJhZjSWKI2ZVszSKoYyiFm0vhijhsYbp2mxfyzLrrL78HuXkv0Nei22Sk007tlI6V1xxuDVOJ9ts594ci4kjXpNOU0W3//tNKTIB8+e9WaOp5tVYQ2vxuEhba/DZ1kk8qOQUt11xDYdmst4NVRgC8kLh5NKPpI5CUpF+//XXssslweQ6TDGvPO9MNrfVeGtIfav77j9TJufjU9kqWWyAHe03MkozHSEod2iJk1rDIrdq4lgb/5fXIlL9NeHb2yXa9+AHbXaHkQu5drc0Fh6XwGDyxettmpibd2l7W1O8305zQa+91Pdf3Fb+U1++xHalxg2vQ48bz+NcQwxoRKwqcFMc+2pQhUysohA3wMCh3KMZfSRqdA7JRyZQhpGUYUp2phKJqTx1qhY2SFSOsJkM25Izy+2MdzgEWvCm8hyFKWyBGyrgjf+wNKIToQtno3DEvJiGlucFa1f78p/1cETFKgIQbIRbXPikZS0ORY5y2zof2wSYPuvBwohc2sVqBMWbvpwxGFdSoiCYMbi+Ve+OxMFbAMPWLxKxI1yOcc3eJlYZ1qjRgURLX4yOdYMz5CIcGNTgLA4yHw+KLh//AOFECIE6lanwkyvbFAxlWDu04A1CNURf7saIQ6L0bodI4kwmsaPAdwgSYEPklS5dQRYUMSMUcmTisEwpvSgW03ruo2K5rLhHPmoRRO7aFpzIt0Npno+MRFHjcCTEzbpNYl1hImTl6PbGxMBiDmkoxW6Shcd2IkZ7zcSiPAGFGiZZyTzQyKfAEPn/lDIaz3hV2ASkKFGFRuYiHpGi5KIwiRBI+sGToVSZGx46UUlY9I2onB6uuqnR4Shmla3UnfhgGcvt1DKQ71JWLHoVQ9ygCxbVAKZMmCasJiJuLsbM6RStyFN4ae1YxhwgsXAoxn8RTHjc8pY8uRmhX51oSynait4GiVJmUE2PYZIFOmPBN+4BFY/wxGk8xepOGzKOf2u0pT9/arRCTDIeJqNEOvRBH33kIxfgYejowsEKTkrUP6P0AyEGuwlUsg9MYLJd9phqPO8R8IYhHWmcnnMn61TTNVpxI1R907yWmiIU0EiiS8rURJwME3HaA6BqjTmbXDIzeztiK1lnq7iP/9r2tuCzZxejaU2e0RZ5YiVn3V6hmyIRcpGn1J79OjETXZwDuWC9aWZni4sr/nOsvw2qIiVYMRgVzkY8kVAmPqekR2omk5m863Tmate7zsKigw1sfG1SWMMi9r7bZKx0yRpZogqtYNn6YjWt9r6HkslBLQUtMNFJ2tI+T7GLjbBrc9la4WJPmToVq46WYbTa9uyxW5ySY5xCtq5isZtcSe5TAThV4a2vqVe9qSP0h4znTle2+/2tX2Kb3R77OMPC6Z6QPbrI72b4kgHuYD7UK7dH5uIauagFK+prosJSOblawy9OVythDSOGlf2F0n+P9MWTFnC46fJsaRY8Uwf3yv+JEr7whFW6Y/lN+Ho8BnKH2RctVn14GiHuXW+pxU5kahZ5J8LbwICXyKTp940NBIYguAAcIcr2x8/QaHW5fF1M55TTnraR1Ijs4xv/Mx3hCF3owPNkvMpNNxWG9X2lDOMKY9lwQE2trlcLaJCG+S2SDfZRIVe+tFXj0E/tVdTYnAZhujknu+7pVnQCIWTXWc7Spu4zNszhDnP3z+L6GW/DWGRDw3ba8qPT0OqoX/tRO2mlskShQ53dOpu70/je8q7pne8gP8MU/BbRZ1wtG3LF+n4It6OW6ZxLb+sF4EjE2aanvW0WkxiaYR6e+EQ8bPIJOG19a23ylj3jNkft2TT/jHG2o21hbPdU28jgtsOhJVQPyyrQVyr3Tu+WWup0vKpERJxrxAIheJep1wGPbpcy7GV+Yy/pQzwWhPV83VdzuOAJjzN4r/v0chGdLlHTN7ohznNm/RrMI55V2i8+TY9HB2iWDsZYPFuT0Wrp5Ep7c8rRfW1p81R+gKczL1/L9H5rDdwg9haVcDvvONt5vb/73T3nTSdijEVFcWHuHF7ReKrrePCF73KOte70LgNc7P9O8U/yzVirZ/ng6Tb110j/71HHatS4RzTOoI3hm39jqGJe+9qNGnmPeybnAZv7Eukwuzk4O++95Hvfpy/9lgc+xWXvkpw9T2+bq/KZnXe8/98IJnn00Gjmsrj7anahCRrfivXcd+r2QR3c0Z/70/sm/embfvr9x19urrd1hxYUMQdqBJh/ZOd/FZd6FbdLzMR23RVuwsdxg0aBJFV+yBc1ckQTzQcseBd9KkZ92Yc3gbcu13d/oDd/tGd4uvJtZtVn/tZt+DZ+xWdseNE+rZd8NSEL9zVpjqBNMAd1USV6K6h/V4VnMEdxXKZrUjNMTqSAXNdlaCWAO+ZTXZdfSoh9vZQ1D4YLCTh9vpd4wLZxbAeBOfRzA1YsZcFEG5gqy/ZsKCZ9gTd95zKHS2guI6iCRch9BOhMHhZ+MuhnLXZU0lFuB3c0lhBDPFgs6FRpMf8IdfczhLSXf4izf6VAeJN4h9tGFj/hhGxBFP1nXf2HU4qFdIfheHmma1K3WhCHPCnyDOwAimI3cRN3ifTkGkvBSt5ThrxohhlHJF3VS2TRUnIANWEHCx94eXFIh8w4eJjohYMXjbQofkTYZZfmh992jdFyS+KEfObWWhyWfg6CeZZHO6YIiUaTJaAwjeiGgtTYiqbQjFp3NawIZw/GFvAoFyLif6LIFvUiGqd4bl2SFA14hMckYZxYFuoUi51YkNDIe7boi7oYK9UibBKZW2ITbG30NAq5hgmWFmkBJsnIg8vYd4DnF9J4gnZUhymJiVxDiXemjdiIa372iBRSJbb/UkcKF5N00wmC4AcwtX6aZwrsRm/SpY7sWH0sp1q494R+B5MOCW34KIytiI+faExNaDuXN5FBaG8E6ZDwRGAZJolyIXFj95AKCYtpx5U+M4FueXG+lpG9aGPBAD8KCX2jEHahwApT5mAlKY8tyXNuZEYsmZJGOG1/OWdZ5z9r1YJZVnnc2A6T92IryVGDCQs+OY76BAxDiRW2Z3sBB1VJeYRK2Y6594VZAlzz2I6beFq1d5Vd+IlVyXSXF5FIEZDJlBtB8XsLWIC4IpYbBYJ3GStzIXHxiJbRGJHDp0oWOZdxKZcVOCbClICmhJemUDu1pl/NGJgUB0V1lpIpiIIY/4VRy9hwfMgv2lg022hckycM6imS5WlrwVR5v8BZsMAYDImO73OJgFl9nph6EPl3obiUW+iPXUiVVrl6+3Ka59ZPSxVzg7ebCmqNWRFjC6pOxQln/sh3x5mcrkCRDqpUvRY0zbmcYwSAq9RbpRBDaUmVvfSTo+Ige0mePHlGePiQ2Tdky1SY4SmDpLmUSol/2cVnNKlwpJZW7Gl+lNlUwmVr5MRZjsCDDDQKdBA4+tSVFFo0XphGAbqdp0eaoRhVqYlnrVia1OmKUymMsFmVT2iJEEZigFhnPjOhWcpMs4mhr6mgVAOeCulcJvplFalDb3mRYkhudTmdruhmjqAgDP9CCMcIaWFxiJcpglHknTzKe/Ton5YZguUpeloGFLJVpI7FRjo5a5s6qa8ApaWANL9UpXQQCrHYPgyIpagFgjh6o3kIjaqHpqsqpijpqwIph8CSkE6UpsYqm7NaWvAEp/dyf/lJpxFWoYRHncMZiyR4qx3pp1XFnMInqGlDqK0yaCsVPxCJl0rkEkwgA0xABo5KTJ+6k5NKfzb5ndw5IfE6njbKqZ26ZR3VTgpHpH4UgcbgjabKUfhaN41YYxVDpUNAB+RoLL1pf6Rol/TKndnnomrKn2KqsSmCqSTYoRl7l9SKoBkLoBIHog8qp+7Am7n5dNTnjgoJF8KanOgCaMv/6VHOSYbfSm49sy3MsKLa97GmlUQw1BI3sK6OelGXl0o3CK85iBgFu6e6Ooq5AqkmcrX5irXk9GhZKLHv+p4AWzGlCrbwea8n+U220RI09TYMOwegVSzUBWq12pEgW7eXykuJ6qIV56u/2p/IOaYd26JpSnYm+2DH2Ra2ybK4eW2rxH8uO7VTN3ZpSafYmq1/Cqhj2IvfurkVCT6Feg3LMJzCBX0yJAhGGxMwOkr0lVE5g1gDSy7cRaRXpYyJ1nTLOIIHe6rthm9hS7aC2LQ4OGfNiJmPcAfNRY5r1LZSo1F7x2lcRhZHZLd3i6vEyomuGFUpso5eiq19i7Hee6Zk/+GAuIC5J8a4twle02qYsAWReNqAfHpE7AAPUtItmVui4Pq55lCfnVBtmkWVjwBDHXEDMnC0KxQ7qTtDGMWXqdRAb7NG+nSl2fmjf4mrWpu7+KoTGrVwiNO7AMvBUZuYuHudcaA/+7uNppAGDatg3yi3rshE30u9eMixL9y9v6q9MPy+/PmQtUe31Ruydvs8awWtKqu4ybSn+kaLSZmt/Ci+dIuymUu/Fri5nAuX5yM3uyOadGY3S/O/AIzCKaCurxMTrmMSEdUfAHwzqwupkeae+YRPAShWM6q7uGvBqESjTFq2j9a6a4xPghIwbPzBrEnHgAcLhHBgjzA/Qrkgav8EksVZjVfkhZ31wjgsyTt8iTn8UlkSmD9Mw8RayQfayd5bcwFpvkRMjQVIqVKre0vcvdFbL/J7i/JQqPbbuSEll+8jf9eJxjG0Ev+rOjfwxU2QQjAxBMRMzGEczC70STLzv4MgChaltArsuvd1petXcU0VCnx3ZRd8ShESzavyxxHMVLPAxmysDdtwzuh8ztLxuu4ZtdtMnoF3RnWnmW7CfkPABXIAqx3FmqLHPExzyZVrgtPLwwyoxICbyTdMs0gMuTwsyS+MTTZCyp2nq6ecgqMpw5m1aYNH0K+sNm2ZO4FKooJKy0UFJSslmGg0z/H2vytEwI46WC09zOkKOwv/wkKglMxlbLowhMam1M0MDBeMbLBUxpd17M0NRAq7IAxKrdRu3Mbk3EDmnM5SPdXozGqs5s5OJcgnwnzj+NMN/AgvMUexOovihxN059AJ3dAIqnsHbcOTHLiWHNdqjbGePNde1bJeUsri6b63utAuWi/SWsMduY4h+tG+Zk0EM9K8mKLMCp1paaO6fGCzw8UuIcCc46h9KQlcTCquI8BNcLQDLMaiXSBh3EILYsC8/JPKFpJ3oce1YGXwpbRWxpfCMM5MXQwO4zDpbDC83dsGk9tUHdznfNXt7NNafbDF63x5Sc3jBNZD8AjUjHqauKIOotYBHb4n/b2FC9CCrdAG/+2hc+3Q4f3YAle+Vbiyeu2jugqWUyuHGl2zccHKCqmIVnKTE8jYIZ3YF9nYhl2XQbvVko0qNsESM60/khDN+arZpnu6MvDFDT7AoV3MEF7MNm3aLhE7NMPVH/nNmzkbsA1fKfHMhWXbTD3cU40wDIPiKp4w3XDOLT7VxTDcMc4LxE0Ms9DNEFLUTTqeBuYIB17O4XKlgkDM0B3dmiq5Lpxs441m4s3DCM3JkyzfS/69461duda3kLW4FF2x6iu1m1VjnYixSkSUDnp1TiEnVkHF+a3Yal7SWKFLkL00zDdaAq7ZXTAEKRDMQAl7mW0bD1XTr2PZMy3hFE7Thn7ap/+d4cqNFqtCa1ZmB3YwWHUw6XYg4pDACqiw1Jm+1Oi84iyO4qk248Ng4sVA46J+6jSu6Qiu49u8YG7o1EFuDe085EwA3e1Aze5d0WfNvU3e69n65Ovo3didE77e5NFL3j6l5b+a5YuLtxVtsTML34P7ZmNODeRBmfrN5rPc5mIUy9Pw5NQ+5x04d599z3FACIpWmYVlG/EFUYxq4adN6KPNIAyGTvE+OyuBybKwCRYF6ZI+KpRe6Rd16VMGCZdOCkod41M96i0+6qh+6ttg6g4/46a+1LVt3Aqc8TlOEaWiB20B6yB/8WcAE35gDJIZI9IXlf/c69dd7LnxUsEO5S7/P/NzjYRGtmXO2LijXHZRCe2SC7/WipzocgfNQzQ0CEuDOhnajnGMtxgvmd1bLO7MV0qTpq7KDWt6QWdUhraaHV8wNF9dDOj0vuBcLe50fuF1zu+EBellQEJtH+mSLgmQvgh0X/ezQAqZbup6H+PDMPF7D/GAT+rFkE8Xv9Sr7uiWMPU/vpdADuvliLoQE3e7lsutvJ/fTeUoN+ze3d1Qr/k0r3egX/Pn3Xj0yuw7X118DfVdbvkAF/QuWu1lDkdn3iHZLjRkiEPmh1HjGvX4Xt2/UvUzMQlYD7s+6qRfx+qsvgtzJ9llb8i8LEOkQvSAXt30Jfds3/ZvjzIBD+nW/28Hdr8xn4AKeJ/3f//3fX/+6H/+xXD+pJ7qFn/j8I/4Hs/4e9zG40QIMXEDekAMqQYQ2qxNW6YM2cFfzxC6AqUJlKlfESWOMkXRVayKGXFB1JhxFDBgoUAa3EVSlkRdKWOlBKWrYcuLpTLKXNnR5kycOUXt1EmT50+VugpGwzbUaNCg1L4tJdiUqMGCG10tZBnTas2TKKU+fMaOHTWKFnk6mnNnVLV374oOPUev3lu4+OS6Rde27l26c+XZZTqQLzjAajnCemVJ1KNHcuikmaO406hQzEKBSsOEi6BHsNga5dw52EGjtUSXJKas9GlmpUH2DNvatSPYsQ1L2kRbkv+dOnrK7NZd5wzvOsFxD8ezCNLxT6iUL0/Fy/lz6M6HTade3Xqx6duGSd/mXNj3WeEhhWdVvjyp7+mhrddmzH0z95a43LhszJ49gdWOan0JErVq/7IqaSTQAmSHPWjaUVAbeBrMz6+1AARpI6QKs0kW1zLUcEPWxLpQqKeyoYazCi/qqq8RFVLxIKyouurFlUqkCS12MtyJrDlEUcarcwj67Jt54NJnyPviyutIvfZSEsIem7xLmYpWs+SRGxejQ5CHRNrlsCGYmMORV0RrBpsxOzPzzNTS1I8t/SBU0yk43yxJQ/OOu0243YIrgxA9hSNuOOQyIYWUU5iDrrnotuP/TlHsGnV0u+t4QUWY5cITdDzySAlFPQQf1GYWP5qgzw1husGvLqegklIWYtDaJsG7EBSmTVkRbHBBXHN1MFa88OIxv89II41W/f4TVkstdwmFww2zEiulg0RMkcSqTIzzGdQMqgrarWC8SkaZpvFKWQ9xLAuYtHo0yhy38unnXSKNRFLedJn0q95rMHT2sZ2slCPLyEJxZL4vV1qGTISlVXhhhd9MuK97r2krMIorFmjii8f1KsUBzduEuDz1/E3kkIej5ORMCm1uZZVbbjk66YpZhWWYa6a0UvIwncVO9XB979VZ3Lhh6Co22cbUB9OMKqxdYLUHaV11ZXBBp3Nl/+/iqS/eZht0om4HnyKj7mZsr8u+VUEEjz1WtWOTCnHFbGQEEUW4F4qJvxd9euUicE+sZlmczD0r3bjZegtexMO+VfEkCUf4L1RjBKYwTRAzl46dqlGWsiEK3tFebhgWXcQyQ5cYciXTTV111ltn/VdglWVlk0VADk4PQkYOOc/ijBOU5eQGZa5S5WhmeRWZZ7Y5OpwzPU9483rupj343Nuki6GHJvVprgdS2qSmtw5nawapn3W982uVNTJhmgYPfWI4/TlrBbl/eh9xxME/f/779/9/APJPQWSrH9Tqhytu+U1ayxBKiRLYprqt5lvd0pu3toIMmpyoRuUSnFI2Bv+Vg92jHolLXFyKVKTG/SpihIsShm6EGCuBqWlbqgzmNGMNXpnjYaMzncJ06I7VBTFIIryHEPOiDiHyaHXAKg9thiMc3OVJinXoXaBahjKUMUd4w3NZ8bhovElxcWc6E5SmPFaeWZHvPe0LVQpkQLRN2Gd8SUuTsJxXm00QZll73GPtBjEI3OFOMYMkpBwQIwdA6oGPz1OPe8Q3tvztLx6TzB8lLTnJS/pvkuSo5D8s6clJgpKS/GNggVRUuLpVSIHTIooEaRKUm3xIchXkEVh+0hCyXOYXtXwbkA5HQhOekHF6YRLrJufKTljOSqJg3ygE0aVHfO4vP/xhD3lITST/GlGb25wH6lKnQibCwji42d0UhYMHLKZTncFjpxjZmU53ehF4mToZI+1knE0JQ43pkcR8NJACgMrgDLMIBwG3lh5ySUIPiiEDY5pQBYg2tAsTJcMQsIe9LmVUowEFKEfdqFEkdOELgwykbfIYHl6I72iQDGD/MjnKll7ypflD034SiJQUQVBpFIwIVihkwZ9iECcetOVPlJmGUvCyMxIj0rv28a50RFVIwpQXYCjGQpTIxBG4tNJHNDcwXeJQrKejZjZ0KLqysiubQOxmW936zbfGda3YhOuS1kOM8hwHD2HoE8kAlcVBrXOdWyTsYAFLqHgSjxLiYcVix3NPfLJi/1LmWwQZUqABzGZWoLPIxdGw077wOLMyQ3hjR03b0Yx+9LSo9ehlM/vay6L2jRYNKRKk0NCR9hU34wzFoEKhCN/2VnjALWx6wkgp5OrTPeVTY3dWVKAGdiUlcWsgTln53G7hoqdA9elPK1JUU7CjHTUCnE9g+KVVpmpM6SDSU6GKl6lSFV+9QgcGs5pM2CxTJH97Zo40SNa09jDAdGVrEbkpVwRPjK1KJDA61pPXcdaBryX76+/KKFgMqzOwhi1uO5unnJMdR8QRhswinjcLSVj2tRJgsQYEuojkHMc3DRXVaWeLBMuIirYTdWgM6cBQHs+nS24E6GuNHFAZiOCN2f8jGg5qS4Qi7CCkZPhCFKxM5SpnWTFRwO2W5TBSQmYZd3/0E5nNHF0SlZK60Cqlta77lF9MMM4VtGBHQJMRBXroMB1Uaoia0bX2vldri4vvfHeVrzD1NJmdaEhXTVKZTgCjKaAbcIMtbWAEY1quC+Z0pxtcrDFGuK9VzLCIUYYcVG9Y1RxetYfFaKkQ39OJtzGpcfTg2syyuMUy2METfL2DodnYMrj1AyEs9wjb8FHZfGwNIB0hh4nqeAim/edqAark0mabyW/E8QpWgOMufVujpE0tuUNKWlE1+dxPZncETblmNlv3lNOa8yu3ixHuvugZNKEINca7wYxQqdFlCa//Vd1kOHeVcNDwvZXqaBSXagiIMAEXxB0KVhrRmuVzKKr0peea4CRq2tNv9XSlQd1YRZiZir3L4oVPrVdApPrlGka1FV3ealcrVsSzvlOtZ/eF02pAAkbWgAhwjVoukGGrkjiJHZ3eKmLdtSTL7mMioR1ti5Y26LLFdpK1/fUVkBvsXxf72L8e0hWo2ZTRdZuL3o1dO98736wJV7r0fFT/VixCBVlvwt0r1dOdLl2HDkyD6MKMkyyNIZWr+JX8Q5m8t4njHR85ySsv8pBbXsBLMbm4wEMKRShiwoMoDiUuccWZwxyfI2Z9610v8wwLKhfK+c7sQz1iOyh0OLSJMBlW/yACo1Ob6P/kddIJAYvyGEundyUWK9HCfPLy8RnLQvYfgUzjGp82+CnYPpE/6m2yl93s2gb++JsQFewyEN5rVyUrkck3udc5b3pbpVioZC4w0Ui9Zeq7UwXtKfq6qoZ7h2BINH1ZvA5SlsZLCHAYkYehvMvrNMybQJCrvJIzuMCovVQAPTw4J0U4BJXJhEM4GeOIOZgzwdpBQd9ZPdf7A9ZjNcI6hdkLI+WgnQjrwCeiNd4DpCqDsm5rgaExuhurAtyxhORzmOZLwjdrvv3aI3JZNjMbKRrTuiKzNiuUAe+7wq8Dvo4SQm1zozeam3hju7bDKdCgN5eoIBbZt4oIqv+eqKDvqqW7S4yyyD+lGhP+6z/30oeoCjw/hBwj0QaJcyHGiwPGSLTEsEMM9LgDi0AKLLAKtMALbBJHkpRxCr2YSw5MBIQ96EQT5MRPTEETrKISxMTeKT3gSr1PAK5VbEUwmkHxkLE/wY1JKAQ1yL0d1JNfQ4LsqS0qUyTkC49q8B6OixOdWkL3g66zWEaRgELcUTpBqChpo0IrrEZr7KgjYy0s3MY1Q79SGsO1e4gHei7zgsO5K8eZ0D82DLijkqFFrCbSWS8SQqI/xBjBM7y3iDhJ+wxC1ASLuzhXgI1XIIp3dMQkMkiETEhJBKfyKQZUKMVNBMVNRCeJNMXQO0X/F8xIi0zBU0zFl/sEVWBFkBxJMAIxWbSDQrBFlOSTW9ytGwyOHpwo2zqDIjzC1HCTYiQqB0TGeUu/6ftJr6II//CYPFIoGKo4icK6+ZC2aVutIfsosds6rtPGoxCR6RpDNnMRNFuR/rC3NFRDCkLHdPw3hfCIY7uD2DgLyUsr/msLhcshi2G4+ko8fqQcP/jHSAsGh9AR/WMwhfzLSATMR2RIgSiGm9nI4mADjPTExWxMx+TIU0wnkdTE01MFywSeDQysEbNFlWxJY8vBU7Q+KcSdk0IjJNwhgtzJY+xJ1mS/51KIAFkb0dAXk5KEKTEzPgmkhWqosqAyK2moMLs+/6yLKFEpTlHJSnA0wxFpv1OCJfMSqlKwL+/6SrFMx7TQDw7KL8zgCjgBsL1jKsTpw3qMy7cgBroswL0xDHOZil94DGQQl2kSzLqSz8F8xAn8les8qPahhEtcTMVkzE4Mzb36z8c8RTRASUwMMUy8TFcMSVdMjkKJtZT8A+LITTXIgpZ8ot4RzUEozWHBQ9QMHdXkSRJFw7WDTYk4JhWdEM1gUT2qzbCwjdkwqQzpoxfFI0vo0NkwNjcwxDRAJayMiuSUN64sx7KMzlcaDLrTCXVsjT3DjN6kko17wIRBuHhxi7F6x8GDB8TbqX60OEFwFmk6SAk8ooWkT0hUyEeMFf/34MDEDAM4hdPHRIMDfdP/3K0CxcHSU9APBElVGMGNtMhQnFBI2D01YMkLpbAnOoMqsIPROM0Q1clr6aUS9UmudLcVTdHZdFE9Qr7V0JeQEMpQhQzZ7BhPPdXZmASYWJghFUOtBJEjFct9k859WVI1hIcPChzt9JxJ47wAa8tfgov5WqFbGYk1mTitqsNNvZf6TFPXOVNoLVM0XaKDkkU7lVM8GIM5VUw2kFM65Vb/tFNPDL2UuQTg+tOL1FZu/VaMJNTO9MzcYUndgkky2ARhzMNpaMtI7c5KZc03a826wdRgUZWBXTtTBR8tIViFFZNNbbuypJZx1Mr0o050ZEP/ueOIW5JVXMVOXd3V6HSYXzWK/kOhYRVAfTxW0Vg8vBzY+KzAZ43WaZXWwEwd8THMd73FOAVXT1TXPehWn8XZdQVXBDXQvSq9DSyjdIVTGxACIGjaJbCBJYACbBVQcmrJ38gC3dEt3ZCESZkFfD2Yfe1Xsf0KpgBYs33NmmLNbNkvY3W3MwmWm0JRVQJHiYUuirU3c8RYW80gsswJZWo8TWhbX/VO74GKc7gPPiS8RXwSiBAIbSHEaJShiMCGlk3IZoXZmD2wuqhZSsCNn81Zb83WAGXXRAXdz9XZ0S2OmEuFYbDMEezWp32BEiCBESCB2fU2qJ0C0K1an2VJLMAC/wtVVEWChPP5j3gM27IdUbIl2xFVzT47W0qF3rTt17d7W+iqyq1Uzro9iOq8pVmtt4zt3nCRw+xsvDvgzv96x+/EofdSXPisFwz5nLqkHIsLXIngvPm8XM3DXMvV3zJNl2q1g6vF0JzdK23l2dM13QRGXU+8zF6QhmEwV6WV3drdAAu+YAsuASCQ2iyAgt/94N8I4dIV4az1DRObFeMF2+htXrqZVAdc3hdWCklFxtVkYWMU0RV24VSaG0u127Ksrngz0VYV370VX664mPIai11Fy/MspiWp0mBAiyvFF4QZvIgbyMI9wLuMg3CRNLXKXMzjX5kF47TQz0IFWgUmUP/SjdPdSOPSVV3VBUEHboVE6NnY/T0M3oAIoAA+zmAT4GAQxoIOTtQQBmEp+oJz+o5myJZ1WWHmteFHjmEG08l1yMkQHcZLtmS6ieTkZVXpZU1Y9ca4FWK7lYmX6Er609vwFd9fWUclBlwmvl/4rJiJKVzTALR+yEfAmLRegRIvTo2Jw4gF3JsoJrAxPmYxJuNmLWOHFDHeLeCe7dkFHuQ2Nt1qRt1EuMxEkODYpV0M5mMLoIAFGOcM2AANjoFADuQ2MGQSLmQq8loQRRO0emROpmTlxWQPqmR7HlzKw2dNFpd93rx/dVu0pZb9oAYzfFXnNGVUzttVfmhTyOc5hA3/UABcZtKuaOHnRQRmyv0/NcmauohfCNouf0SqvVkJHFJmIGJElfZfZjaGMXrmAWXXaJbmny0D3bXmDgbknNXWD9zmTgwDqLUBE/iAC95jcVYApU6ABJgACrBdGIgBqcYCN5CCD8badibh28EdVkjhEi1bTg5rsSYqGK5ks6a0fu68sw5ZsQ1lgCXDbzxohJ7bamFo8YXOWxI4iPabJH4h7dzOzDklLTU4EBJWW05pLEU8VokQ8K04fomFEDLmmU3m/nVpmT0bw5wdHExjOP5WnQZdqcVpDzYCGOABHhjq3N2DMVDaoS6Bb34A2G6AAUCAA2BqBaAAc45qqa4BIUjn/6v93Twp5N8gzVrgaIfxs2Is638m67XU6EnGps177lZO7uUeW55EMzb7RhBxa7tVCZggYjiE6FP+Ca+ABoAzKtmQjYs23HtkHYkB5l3SZZ3KC2s4JmbwnpRFQMAe0y/eX/9tacueQMx+yNpZYNUeAwT2bDbmYKUN7dEWAhfw5gpeARuYgm6mAaKm4ArY8NtugAeY7dpGAKc253Pmbas+ceH+7d1IcULg2u+JXipdbk2uJel27rSu8eimbhy2boUA0jQz6JvKXrkB7zd86KWbEfPeHKPiKu18iO+a3MJznSye0vnWZZFOjfmdBBhyCAZkaWe9T8qubPn0Gc3WE85G8P81jlMHb3APfnAgYAE89oALpvDZNWoKJ2qj3vA9/nClBnHaDmdz5m1BR3HgTvFCD+GaXKoYt/GA1vGxZnTTcYcc/7TOa3QeyuHmbVXkPFGFvlsiv5Hw1Wt+07++ftImFzhcEOxnhV/0lF822RVmGF/49m7Gk9L+Nsj/FmP7DHO6uI/xyYXaIL0J01kCPXA1F22ebnMlWHanfXNv5oA5d+0L/oASOIEQoPY9j+0+D3Glxm3bFfQawAITP3SsZuczALPja+RFx0BLh3S/fHd3n0Qcl3SBrm5MH2hR1l4yDPKFLvLxNvJQ38vM8YpSx6/0Fkim6XIkMabtOsObxJf2XOz/Wa+IRhNIys1f+eT1XZ9WzIZpa4VmOk1w0G7znH5ak2/2F3D2Echjlt+AEHj5D4gAPc52P/9z3O6A2x13Qt8N3w7hqqZJMWEYGy9Iei/6SV/rjQkdeTdmpMfxSRdoHidRfqcKWZbbIfd3gB9vigb1xw4Fgi/1g1dvyFgRu1j46zQImaj6LEW8wPXSrcCRSLt1MNb4TAtwSGyQ8ekO3JtpNABQ0aXTnNZdkhf82G3a0jbtapfd2115C872DTdnmJf5PQ8A2qZ8yvdwObfdb6+CcK/qFf98nrcC0T/3nw/6da90qD/6pp931Z88pE992Ndh625VH+YWB5o/sWzord+q/yNftMeuiI3p67A/NoF7LhzCx7mAdebEQL0cSLdP1nMxK4yfbAC3e0d8i18XBlPj+74f3QMGfMHf6cEvfMOv88TPcBNY+Wyf+Qr4gJcPAfZXAMuv/G7P/M3f+UIf7Z4H3jgCiGYCvxE0x67gwYQK3XFj6PBhQ3PUEK6ruBAixogONXK8SDEbt4kbI4YsKbLgxGkpE6Zs6ZLaM5i6ZtKUSXMmMl3PbuK66eonUFOihpYqCkqUI6JHlR5NatRop6hShz5TKPSqVEePtm6V43TUKJvLrsEri+9sPbTvpv2K9bNtMGYqtVmr+6uTLGJylQFr+xOUozlpQCFDKO8hYneHFf/fY9zYMeTIiQ1Krmz58uPM78qGK+aZFCVKf/CQZlN6zJ49aEirDjPlNRTYsWcDgWFbiIkSujds0O17N+8NF4JXiBDi+IcIyhUwD3AAAXQLFjz0rkGiBnYsUqxgKdP9u3fu4se7qTUQ20eL4M6x92gyY3r3k9XDr/j+Pkr8+g++7F+NP3/+3ZRTTQQOyFNQCTJFlFMNLrigJlMtVRRYB4USClZZcbXhV2Et01dh7KWl1ojfGOjWL3z9998zQsW1V1+y9FRKYHOUAhJmOc63mI49ajaPZjpm1k44RXp2SiahncYaaqSN8SQaWcD2mmuz0VbbbSv0RtwIXAb3QXLDfXD/XAjFPXDmc8ypKR1vJJBwQ3bgfTdnEuNtt115510Tn3w7UuZnnyTRN9J+LvEJX0sB+rfQigQZWiCCkEaqIFZKPTLUpQ9aGqGDElIYSoBgYcohh3Rk6mEtMo6FDj0jurpZNH6hqEw0jcoKI4hXCeaILn8CCqSPwAYbJLHFDqtOOskauUouSQIy2h/PNgnlaVLGViVtS9iApW0mwFCClh94SdxwEVxgLpjHmblcdGtO54Gbb9aARQx1yunFF3bae6cU5u3576HydfRroIMaHLChHZXk66AJrySwoOyciJOBOQUz6YyUanpppxtP6GlRJ2HIIKlceXVqNXKByIyIJJ51/w5bM71Fa60pX7WXyjHSmMZgJx37c2XGCr3Y0JMBqWw4yeTCbCrO4gGIGVCfRi0b2E4JhbZZc4sbDbudUOa466Kb3HJnPtCumsoFF2+c49GprxRV4FlLLnoGXDDBHs03sHqCFoo3RSwxKjjg1Bx4OMUTa1wpUpg2/hXIET7eOFNhsbSpViWbmimLfL24GeivgvNhUMDMFfNRcqHn+Ss0CjLHHTeyymPeQRctbMu34657ZUh3tjSzTkcNCBpmrHb88dZaifW2zd/2vA1fn6AllxUQpxz22UO3vbsRcNAmduFrJ154b+/L7yYDtXc3oLXvHXHDCz98MP32HWrrNAAWvP8w4v1n/FTrGEc5DgEGch6LXMhSMrKiZK6BpPLKUEIBjZStTBuhEx0zZCUjldSsKC+ioDJEVSNRmG4zF6EdChkmJBQKqzH5GBrvdJSPfGxjacVoRSua9qwdIg95VPjh1WCjNeht7VvgGlcHKJC9JTaHe8yRTgTAFz4lGEFb+MJaeMpXpyKMrwpukEL6AKbCMbqvdnyzn/z2U8Yx8ml+fUtPSPwnR7fQ8SqiuiOEknIqT+1RUx7ij6gK6ECTcYUoEgQhzcjSKgxq0HQxocZVTCdJnSEFdpYLnd5YuDtNunCTnrzHy1oYQ8kYS1nDOGUOD6FKaVXLh9ai0hSGSEQsOa//a12qnhLXRIE1OdFd3xvBCsDFAyHUJmteyOISrrived3JDZNQX13ImMk1tk9h8UMjNuuzPohRxlD7k99bwom4xVUKj3vUCmD8qM7KVUglCxxkyTIXwZQhUnWLZGQ4c7ITCtEsJsB4p42qUpYUTnNHoySaKH+k0IMiJh00LBIqU3mJVZbmlVECIizDIMtZFvFr1LteLqHYxF5KxwLYG4FuplhFY7ptfHCTQgycabfAbZOaBH2fNq1pU2le0409xZE4JSUzcgpwU0jRY1M+ts7KtUgkLWIgPB/IsbBMUCUVPNqr1pIxVT01dSlSVSDvELv/mHA9Nz1rZECH1VZ9cqFu/w0lQ4X10BrmsGkTVaUZjFe12YThohmNZS2hZwMdQO8Fv3FTcDwQUuw90ZdK5MAvUZrSYj7hpZZNQhVq4AaZ1g2aPPUTsdaII0LpdKeFy883NxJUjBFVgJnimAOVulSm+FOBQolqPLcylF2sp56ruidaYjWjr3bVFP78ZyADwytozO6EaCUlW6ML14TSA6FomeF0QelW26V1rqu4qyrBq1eLYtSi2hKs85znrW0dFrEbeCx8Sypf5fxyAysIZjCbt1Irws2l58OTGibRWTF+1rTVLK2BT/tGBZdktbUg0E8moYnWRg62gzxgBEHmIstB8nG47Yoj5ABBEloQHXa52P/nGDncr9LoKKHIlSxEJVbCHKS5zzVrYjqZ3R1XV8c+fqF21bJd3jnUSBN1Uh7yEIkj+/VaVXqyawJrm21tlKPASSJ13ptlk3pPy2vzjX5ZKmYq+jcJ82KmdghRiEwYY6YFzvHtDgw/BCf4foSrX0NSMlSKDXUSrtCEhJXKRwnBM6mz1bBxJ/JisHDqw6QaSl7K+iEU/za6qHNRikAxh6+0BY+vi/RaClrQtbpMuj42tVuBrGpTp3XI9SBSOE7xrKrR+q7jdbJrygvYrr1gylUubK8NK+wvKdZ6XgImsoMZ7NrwYMzKXCa093WGQlB7wDVdYZ2zme0b45hwPr0f/2T/NolU6WIS5naFuTlF6HVHxdHpRDS87WhbqDoaxCib3YlTVOng7tMtOxnF62J3x+TSgcZq5TYnUQ1chR/G1KvGLsR53OqFYjccx0DFaGj9mqgd4tbktSh7dZNeKbM3sMPmTQe4RAL7rld6J+h1yYEg5mdzBwb2kvn4iDmnNlB7FtYmcIKNhdNti7rb7MOzoGCh9KWnyhJOn8rTH23h3MZWw31U57zrXaqvkJUd8ECkvikDK5uMItN02HQEzWnJrhf92tQt9UAZrvCI6wO7Ereuq+1RJIxrnF5UAETHNW4twQvRiL5mnpWtjNKUu8lbyyZ5mJ3N3yUQgfKV1Y7Mp/gd/2pTmxKeBXpcbXpGojMY6R5h+tLNTYjVP531U6V6A19XaENGJZCDoL1SEn1IRmt9Q3SQA6SVwVxJW+yDXg8VWGglil2JAkOB1LSNSnh8hLcHWdYndVbv3vDrX3eGdc/+wV0t17J0oxunwIMaaB0DEtggC6sZrysxivgS+BryUqYBs33TATdhp/6/hrnkJRN/VV5l6RwxMVO9pF8h8JzPfR4ZhR7pReDRTaA7tFkzzMImZOAmrJ4fdGDUaQjsyZ5YzZ7jAByjrRNMgMrI9N7WJR9Zjd2k4cRvdU7Z/dMjMB8eVVJAsZ3Rtd34gZ/cBSHErRqr5Y7ukJ/5VdQY2AD96f9ADz3hD2FLyE2ZDlThLI0ce9VGe7VcmD1eyU3eFJRBldDcSpmZGdZJAmLBAvLcJrDZzz0gBEognJkRBYKboPADOfxDPHTGBvqBG+gBIHJgIIagcskebuGebs1WO90WC2rF2XUChhySWuWbDOZPqCBXjRgQpqBdo/hgwsFdEG5f+AVZxGnfKL7Vq22D+YlG1RCPbThZKyWP8mChFY7cSkXeFAoT/8EA8/yf/y1BGGSRRg1RGaLhmSUgtfEc4C2NBV4fHE7cQYWWHJaettnhP+QhP/CDHhYDxunBHw7iIwwC7N2gCBpi1RnV801V7hnXQRxVI2aiKcDFC8IgiuGEJdL/IMCdnakwhRysXTT1oNsFpMPFnaVV3yn+2Kvp3Y4Z4UEqHKzxgpK0QZTEwPrNCxTKYuGdAJU1D0d2JJX1YpUJW/tR1vM4HkkKIBSI4TEN4wEOExe15G1oh0Sy4bP4XGc5Y45AYEIBDfXVoYIRCioEZTGEQzxkYx4egzCwAsANIiBqDiCW4+s0pTyNCjpeHQCFAjVgyDtmDtp12lzEHTbwxYqtCvIF3D6KgjjWCB28Qie+mUAiZBHiXUOCYo9hH6mhIkRB5CFAi0RmgRFBAQ9lXJPFBi1WIWDh4kcaU3qJ5PwV0daQ2fJ4wa65AAvsgErpHL3Uy0y2QXhlQgP+izrM/6FOQiP1SWOPUGP9wEfnRQslrMIxiMM/4CE5iMM2kIIktF5abohUGqIgnmMhMchRYR3vbaVykZCoCB9YCtee5U9VTUM+6uPJcMWupMg/stFzDaSpHZxBttURrpVc8lhC1hCSRAtrrgIl+GUZrBIrWU0tamT0uKcOXM22LI8VGpOVGJ4OZOYV1pIAjiG+UBFlBmiAqtR3uB9nJsksXODnheYKReOQNSi2eSJATmhi2MFoJGNptGYxiAM5zKY40GZS3qY4uh6ICcJuSt1rFdI5raMduQ5xotMuHOdXwsrExEWoTZAOQidXcsEOro5PfmJcbud3duddbh94AteyOM0yBv/PJXzXXe3VLLbnEXmLCgxWfNInSGYNrpUBLelnl2ZNYmbUAAoomRpg+x2BRAIeJqzpmjaDtZGm+MXpaEaoaP1oQ6CfhZZGnj4NaPDCMIiDNMSDNHQDN7LCIkiCN3rFU0olierW1GVFcL4WizLiiwIfX8joJGbQcpJFXSyDJZjl2SnqDfLoKOiFj1YnBRppkLpdXQIpd7ZqKCJpkRBqs4QGJBwCs7RCL4hDL/RCKt2aYTKPDpRAsX1AEB3rfS5ProFkEaEkGF7LMY1pmU4RLxqoRBoCmwIPM4Img8Ipkcqpt87pNNoBuZaruQ4CuqarBP0ph34ooSbliJooOG4FICL/xe1RHckgFYVkyIuGGAmFEKZNH8yQDoroCSx0AnSGqqJyARMIQl40CqpWk5CO4lt+Ik4O6ampqtzN6ikBz12tqWv2qq+aJ/FAKWH+kA10gAIUgAJ0wJRcqXzm50haCeH1omAlKzCqpH8CKEz2bHyi6bWyabYORN1067eCq4PGUJBM42SkXx04bTA+bbpKbR2oKy+oIqDGw4cOAwZKArrS69N9bTiaIIqmqB9tDnGayi48lVDwFqpezKzAyKcm7O85IhOQqupEbDelqigKabd90sW+qimmGqwRqtBmwkTl6jFIw8gymYHKH7EygAEYQAXAJ8zSJ2FhjbJajUsd3pz0/6LODiPlueSAmmm1vh8gYCvIYoK23mTgIu3Rvh3smibTPgTVRu3tUi3Vihi6sgIqqKLWuisvhKjr3WtulgxVQioANdpWeoXaOqe8zWgzwG3cZhA5kgH2Ym/dzsHdLhc9ocfbOsrpnCpPldV1aufrysPgxuo9lR+temyTMssxiCwqYcIh9JAZOMEUTI8FSC4DtKzlgmnmcqSw8hWW3iyW5mwwao0RDBPpwqRMzmTqrmkjeCwzFm36ct/sbjAH025Pug/u5q7uSq0cVK0cHJPUSgIpoAK7dqjWcuOFfK3xli0JjkraNhAsEIPSEYXbmpU1EOwr6BsxIGpU8gz2Oi/Dkv+BJazt9xZKrSwKhQpkxXLXXGJskabiMQxD6ypur2bxKaWCk/5B1IwxFBBr/+7S/+6fLdqsDXxHtSYwGxNwLAHWAqdkMhEB/i3bAdafDgBtkqlutrLutmawBhdyB8vug4rrBxsNCpeBCEttI+NLHTRyHfBu75LCn3aoh9YQK8hwOH7y8aIoydxBvyrXi8Xo0z0svk3vrVhvHPxh9iosw3LBI+Rw3v5jf9TWI41vFJemJrEqrGZsKbFKeHpxrtZVyL6mMYcx1EDJEpjxlijWdIAZlmCNzHnk5WKudljpNjur6EqrAz+wlWYB0JrBH2NCI7CuIF9wMxByBh8yIicy3hH/jAc/Y4VG6yR7Rz7rcz7vbr5U8ghXbSgogjD8aaB26LvGsDiWsDqKsiOWsjxR0FRIn4mxsszksCx44yvHsvYOwRAoMRPfMkjAhC6X9BN/m3wAJOBObDxb8cQSiRd/MTJ7sTQwbv1GpPqtHP1FCWGx3GS94gDXH84lcBXKLAEHILOJs5l2RzmbM7ZWMDp/l7aiQju7cwcDWUtn9ZzWsz0DiyMvsM7y8z7n8xf0c1lLckDXwSJgcqBKA0ITqm2Gwoh+8lbcJgE9NERrBTMkJSMG8VfuCengRS1YAkcXtkeDtKnmLUkXX2GYtDfZqRTDYRWzb+hYnGdkcfmh0qDuKq9G/1SS0FrVMOGZPgteBVF9fikVnnZR00YtVjNiju4Di3MMSElT/3EjpDMihMPqLs0svDM8/3bSKrLRRgY+8/MZqORZVy2+6MEVUXI/Vy10o/UgKMInDINbG+UeGgMGxuu8lqiJEiI8fbeJ8hYqT5UtV7SmLnEt+KERV4ERb1YTxDch2HJiPzEy+JNO6IRjk7RPoXTQTXZDGqQiKUsudMbiuu/iJoO7drEWZ4Jgpp+TcdyTmuxr06IAc/OF06JS63E1vwYVbCa2AjIm9EGB53YF50KCGrKKA7ecBqlWD3fowTiyhDVy0/hZ//NyN7eOO7dyQ/da+2lRZuM2CgMkiGh3n/8oeOeWeQz2B/o1qwC2ek/CK6eBe2dWfLt3fCP22q4MXMhRYz82N9GZLw9pFW8nWXRG0lgcZ7+moB54F5PsYJoGazpLX0qhht85nn/h6MYch5OkYR4BoF+BU6tuIDBjMug2VPvLimO1MF+xkLX4+lr1aL7qjkdrct/4ce94vvxnvpxwjvM41UICC38oOQh5diul14qYojLqOHIKIcSeI+xCUiIvcpbFYKM69spNld9AE2QWF5CBHkgC02HaivVExXw5f69DotzZnEkoaAU4xWqnIqF5MmB2Nwiq1gqqTfcqnA/egarner4s4mGha+e5yS1mOPd5Mb1GOa9BHkxwLvT/wW1XcB8kw277NilyH6PPw75HuqO/uKQD/IoXt43jeKUfvMEjd48HNGksAi9ce6mbejGE6CCcwZHjq+Y4LF9Lp1Y4uYml3hd1gRHzOsnLtx9YQg5SirEnDhQzezW6ZflG+y+zEKemQy7oA8cqs4JrbU1nbRY7rgJSAraC14MTnrkfPbkvm7Kpu2t/+ExqgdA/dbae+Imn+IpffaT3e6MHWZGyuMAnVCTrs9gb/Kd3OtkjPAoXN8OLegsb5WzWECSUayByd6PG06fN+omWKstowxArnR6IfBdgRxWQPMl70byqm1Gw/H0vPpi3EWQ/u/nKvBQrywwVSc7Hgx7yvLZ7//Fngzbifpf98mX8ZSQXkrtHuqflOnAWKj3Tj3Mb5JVTa8FTL00jkLgg2++D4bu/5/vW937XMzpPAvypoT3xm73x77inN3fyg7oj5ynbx0PEY3dtFrnX9uar66bTxR4Z5MXBmmMtJ7YsoDwh5HrgxzfhFz72NnTirzyy5zIv32M1lhZkhxr6Rr6A23yRcSxEsbm2A0S8ZOKkSTt2CdIfNGrYMEzVCuIpQG0ULrQYBuMUHVCW2PD4EeQLjyI9niA5siQNGy9IlmD5EuZLIDM7bjzS5ooZM3kMGSrUsxGmXI1yYQqKidKmWdfUNW2KD2rUe1OlUq16dV7We/msYu3qVf/rPK5fw5al6q4sWrVmybKd6qVMXLhn5sr18uUu3rx6n/D1uxfwXrl1CBc2bAcPpE+qukkjxw8yv3/7cs2aJWmQH82aCXXuvFmPoDlkZBFj9Ui0Z0ulq5levclPlS5IkNxoYvtGCty0u5B5ZElUKeGxiP/69YxacuXLqbFT/q31umrSwUHnZv26u+zQnXNn9x08dXPjvZMP/+48+vTonDJN9/59uHD9wiWTfwx/vHjHKGWCiB8/ShJjiCFAVoGoFYTauCgjKqZ4sCaQJETphApVGsmkCi0MaaWYYoIBRCA4igEKKnDaiaeeesJki1yKEgqTGIVqr722pBrLxqfcyhH/rK503HGqH+UBkkcgA7PryL/6UvKvJOvCa7C4CCPQjkEGWUQRUng55jF+yuGHHHL2ywUSNQhxg7PPUhOEjDRKgwW10IAbBRbTYKETNjJkuw23GzBIQTfbeqOjk+BMOdQ4XZBZhrnnuhMP0kfLm9S8SrGhVNJKh9wUHPXScw89+OKbj9R87gMwHnJWiQuQTE65JJOJGlooizYuaaWXXhKsiMEHIRxxwpIqTGlDDWUy6aQMYTLBJZdC/KhEKm4CRMVqj2rkKBlnFPIsHXHc6kaovu2xSKzGwvHbtdTllshyhSxDL47gjddJwJa8Fy98m+RrXrqiLCwMxATGcpVeUoXs/0sww0GlzDT9QPPhNEgzTc7X8BxltV0k0bMJ3nC4QQYRUhBBBBkElbhQOoFZeVFlkGs0m+3Cw26aSDGV+Wabq9v503N47lnUeuzRZ+hSAewG1X+OQQMLLLIgEIq4SmTD1oJzRUrWp7X+VSMdgg02QwtFKqHYDps9G21nQ+SoxJsK0aLaFbUlKka6XWSXLK70BjefvvtO529yywUL3XadWtfwwe+5C8kn69XXin0jl3xyeZGU8t+B//ijv1WS+ScyyP7RJ5MzQ3MDYolHofi3iyUBTpJQTuM4h9o/FhnQknnzTWWWXX4Z5utwbm664h2ldPicv9FO+Z45ZQ96+IreR/++fajXJ55Tj9Gvlz9q+B78JJye+pADdV1FwYa27oh9YMH+mgaVkFUpfpKQvT/t75/19YhCjoA7bnKbWziMQhRQ4W1vgfPbAhm4QG8JjlzjShzeJpgVCb6FXnPJ4OP8EgXILclekvNX5qQkMDQkhiKUyMUwHlOOLynNDlhA3QwlVic46QFPnTgTHXAYCj3QjjYr+BigNAAoGfCmh7tQIvCiQTziMU94M1PedmoGRU1JMXk58xTQglY0e2SvevPRB9JQZbBMfI8EJMAABtJYg6hxLiKwwoP6yvCrCL0Pj8Rayf32yBJjIQtta2PbgwqBk54AUIAywhYmkiGjcBjjRxf/PJfeGki0Sk4SguGiB+EqmDhzSRKDjRMh5fpSyg9+wYOmDKGTMIc5qhWIQH+4xPa89KVjFIIuD3NDGgQhCY21DmN0kBgPLSEHjs2mNiEjmQaKaDLZJJEY0/idNJsYPOE5cYo6y6IU12FFLTrPZ9GTjxf7QR/qjfM+ZByIOFZVgw5gYAJrZIEQptCqWSboEBfRGtvy2M8NxU9Z8hOoH9OmNhhsJFrSoogh4KYthy6SkeEIyiPfQ8FwXdKSGW1gJjWpuE56sl2jXOUqT5lKU550cimtnOPq8i8qae4YtZRMJqp0hh/2EDaO0IQf0sAFJvDyEcbsDTJvQ0RmNrNjaJKE/yxsyLJEKaoUimKiNbPJzZ+B06pXHdLOoneOoJVqaOKwB6nQiTSzIs0gf1DCBuApAqe1KhIRAQQgsuC19XXkWQf92gm8Jqw8yi9sIgmsSz6Atr4+aAyJRVEiYVTAoNAtRncTVSSjgtFyWq8fo7usRi3JUc96FEig5ORK4SVKkaI0cqiVgmpV2loNvvZfdAFYXPCAini4EEy5kMTpcHhD0fiUC8MU6hCIS1yjSgC5Rkyqb1J2qOEIBxTRla4rogpVapjiOFM93jWLl1UpbvGK3mUKV8UptLGK1ZzWG2c30mlWg2QCDSPQgAegYM9ERMQM+9RvFmZiUB5QSELDUsGw/v8I0JYkK2zMKkFh20g2uz5NsYs1Sh+2EJQXGcWRB4psLgD3HgeKy298Y+BlMTuZzWpUaJtU8YpZ3GLPfku0LAblBV1b45Hmq7Ws1fFqbbyvy7kUI5SIqZf+wYsf8i5PPf3pMHvqU+MCKgVHlUARlesbQeDQuVmmLnRBoYsu4wLMyEFGdpnIqGoCb1GJQnPLqNnm4kGjU12Fnni1wZRmgGqcX2QvOccqn22ctRcGGcYhYLABKFwiEqmAFa5aQddanXBBj4ZCXkGk4AD7FdMTStaymsXgDny6WR7xlWKppaJssQiiQ8HwhiXrYQXyDVxiGXGJ/1HrfZh4syl2cVjqsWv/jn64o74OtiYZt9LTdnDH4lP2spPdY37Fq7SuVEMhikGOF27CppvQtiCY0O3gjqbJxX0ylHUzhG/LoZdMbarvgCdVNq8Z3mc2s8sSxWVNTNcVYVYzM/jd75q9WaveqfPAITnwPB8c4X8GNICQYoMxtCISiZB4JHSVzwVNDQ06metCliAESxMU03wdcKbpV/I+DnbBDCZBYU1gg4SaodTWgqwY6lZzh2KiGS7iCuBeHeKeL/Cytr710DHrxV6rOHrCdkuMhw2VinZUtKSV+ih5bNJmMxvrWXetSBnnykyIYxz86MbrJjEJnjZhyXFQe7iDO8w1hWYQd2LFEqMJM+1a/xPv8pa3l0HhCNHMAfB0uMMddFr4e1/sTU7dhZinGZ3WCEMbxij4qPrs51GN6qxkPF8+y3dfVagi0XuYFQwcrASOOOiEYSA9pfXqNQITONMr8Kv8VhACZjH49oVluQ1UoNDFmrqAEXfohbXVjFronPIp3miH/ZaLBern1rY2cdHLGTh4hOodSmfLz5/e4co6vftL10qv0XVsUlY9tVpX//qxfmzBXA4S3ZAML1539rZzZqf3bu666f5vgOcdAKUjABtlzHBBOAYv8BJQAf/O8CyhdbSM3YIhmiYw5yZPG7bhAjGQ4DKQvc5qGD4Qn+YKViQO9MbAV6bAj3SAJDCurv/662tcD/YKTFhkjwZrj2xuLwR0D/dajvdMZAxKLUWEL+Ky5VoiC0ZcZCl4zrJkzfpMBeigz3pqbfqor7N0Tc7CyUasUIF4TgmVL9i48Ps6ioOc7erYzwybjeuiRBJ4QRy6gRW2zQ/mpKnm7f+awd/cjDm6AwAHEGbqsM1+YcucK7r87reazBC/LfAaMLpeAVHkbg4pUPIgzw4rUPIwsBi2oRhAED/QZw9M8Acn7hDyywRPcJAerK4Oq69gUAVjgK9YEfb0in6ExfZOYAV00NIUrPfQwAkSaw1SxBeFcG5OzQiRwhBmgcOWENjMi5JIjOimsPqecWiO7goRSBkZCAz/d24Jw+8aew4fyJDqyvAMw9Ebx3AQhKEbhEHbasEyIPFS2tEa3hEe7xAP7W4P+dAdA45mmOOpZKETDM/vErDtDtEQ/+7t+rG5tA0h1S0dWYEUUMEhhQEVPjBXEiSxEOsQ9mCuOjHCNi6xaCULUK9rUjEVXfGPTIImhkUlZE9ZZnH3VMBrXLL3dEIn8uANJM4XGevmhjFGXOX4wIqzMMrVxIhoiI7WqNDorHAavWrFllCMqvEnt9DDXM2Cvq8ebmwMcQwcxVErxzFe9CDuLGPuiEHy+I1m4pG7sIEO57EeG0UPvyPvlKe7tksfV0bdgmOnAFIgA3Lt1I4gQQPuCKFQ/14HSxICEjLxGAStEzUCsTxRFNWHCiYCMnURJLsGJo2FJJllj0huWDqkJFUABY7gJpzgJnKiF4PQJn8xCHPSoSiiEKjN+aDxKZMRG4eSGUvMKIsuGrWRspwyNi0LNndOKmVM+biyx9Av62hiK5MzcpaAOM9AKeauFibRLO/xLNtxLfXOHjOlLH+GOv1vOx3vD+nS3vTPLvMP//wSMGHHAdPzdTLDKxHDapLBFnohEfaga0TNJjJiWE5wMiczFVuuJAEUM8sGoFTyBitkDHKCNHuRQROhJvkAQoUPNeVGGLWlNdugfwzhNX+zN/Um+WqzxPjMKJES+7KP/KLxJzl01v84tIu80AuX0/yQLSuVcyuRjTlbS0+8ciELrjuzqDrP8u6yUy17lEiL1A/Bk/GmSUmDQVEkMDrVke6WCErlbhGqRDGshhykwRZAbw0eBCbx00FUcDNFrSJBEwq+dMAE9BZL0iNkb6DCRgek5Qp6EYB4okEfNBKIENFURAtK06FUpDX9hzWN8cRUdPmCRgkL9bLQa3pGVDev7/poU1F/UxlB9BmlEirFhaRqbEaTQAg+lUZDVQlg9EaZpDNiZ+7qLJuMVA+vky3z0TrlEg935i2PFEltVTpz1RoikRnqjN+EIZqg8xSKAa0c4xbm0xYSwRND8sH80+V88CPr6kx14Ev/A7RsMvNaRW4MGBRPIdRB36Bb+aAIMcFbA4hcGconCiEn/Kd/WnNDb7M3EXWTULQ2OfQZMUsatZE3LRXFKrVera9Fv29TZbRTRdVgR5VTPQgvvJIQlOLO4NFSzhJSYlVWK7ZWv9NihfRH91BXIdYYyFIbfpXgHLIYDKYgkuEWjlU+IS4P8qta81MUMXQXO9JB0LQVYxBnx0aPPKL3enHivLVce4LmIlRcsYVozTWAcIIijmASmsYPfqJ64JVFTzRf59VQ+UxSM9VFh4YZnREaE7Vrp1Z6TnQcc8w4DxZtSbVUdSxf5KROppM8fHRj/U9jJ5aqMJZiWTVv97aa+NZj/yNPOqGh4CSvGMxHPsMkZeXTFhjBFhqBD9ZAFEVTchVUJivXDCT3ZUECZ2Xx9QjMCXxW4o42aIc2ELDFdE33XHHSJyhCC5aWFWOgCvKAw+JhUrmWXrkR/IISa3PTRLWBN7c2UkU0s0ZHCnHtJ4tOCsXW+7qROBM2/dL2YNe2/f5CR6NzvCJWbvk2Y+u2YvFWb400ZsK3b2OmY/92AwnXMFMlZW8hSxmXceeTEcrVNB8XXL8VXBX0CmoWTV9y5EKucx2MCibOcY9WDGiugEu3aLGldBfYdMXV5gJICwoBBbCAFb/nJzKL+uD1UF20RY8SPgIXbHl3ayW1eItXaoMuef8d1YHK1myh14XREMfIYGFDw2Gvd27lVjvvlnu/V3tjdTywqYfFV4i7880iTxgMEz8cgxzWN3EZQWXXFxEQYXEXWHRrEk9pMieoAE23WBU71/ZCYArmVIBDF2jFQFwZGI3ReFz5QFsA9Qr8JwbWCANqwFbmA3k1ODe1toM9mD10VWhwsx2At1JNrISFDjZJzGthkyqdl5Fb2FNB9YWhF5UU9gtQxyvf9hp6FHunyFVveHs9eYhDWZSxc5SJlOAwsBvEQSCSYYkhYxyYGJZhmRECYZbFAFxvuU+tuBdnIItd0gd8GSaD2WZfryYbmIDNuHQrTAzSWI0b+LGAsScyoZD/jiAG3mmOY4DaQrToGPV2qVKQg5ePMxmE+waQRdhfC9mEa1edKbXXHLmRnzeS41nHZJhhrbeHvYmTS5mH/dZ7g9if9Xl8jdTgGmMgEPcWymEcxsEXXnl9aSGWU5aWA6GAcVkLrmAGLvqifcAHZuCXfVk0p0CjhVmkPVpcZ3mAwzUQxHUL+oDCmBmN87QIG2Fo+XRp5fh72sD5MricmTI4AzaQpdHO7NB6eW6n95XW0Fmn1/lq35mp5fmR5dkvfEMPLMEYM5m7Nrmblie8QPmfu5qrAdqrA1qs4REaNLAxspSVySHsfMEXaIGtHfqhbwERAgEOUvoNxCAIggCjUYCv/y8aBP4aBAbMo0VTo0O6o1UgpBFbNBMBfhHYQR+3J6iYpSuMrpdZotX4XGEaKI6iJwopf2vApglB57TZnHb3d6tQXiE1tYXaDiEJe9j5nNE5nUe0Q/v1bN25YJ36hSvZphpWLOMWh7VpUsB6h8PauNOSG8wslOWRqzAxlQ93iW+BFhSaFqrboeEarisBESpBuycaXC+arwE7sFEABD6TrwsbvdNbvX9Zo9+AEWaZfm/5cYk2mel6pan4jEWXvk0XkQzBDAphwDCgATDgBs4gE3TOi/bMgzkY6R514HqXgyfRNO7MdqvPqMtJtlN4nfvmGDEqtz9cK4ugBp56xItAnv9lmJ59iSyx+ptYvJOVm7i/OsY51g7z8M1QOZWzdIlpITKse32527qr2xbkGg5s+Q0sWq/9urzLe6/3Wgsu2qKbnKM/U6M52gmuIBBuIRBwmcsljoFXmrJZ+rIhNKX1G5qrpXVZEZ4YYI4LARXuptW+6qcJjhmelCw/Vs5U+6fDuc7vpFfpocJvl2ujMPpk+4T/pqLGVhnhmdF1W/1K3MSfWrcnuZLroLfiksWrClZnnNMzNohhvNPH+gLdSyCWeK3b2sfners5IcirO4rhANYLOK9nIMml3Naf3NYzeqMLWwwY18gXFJcTYYFhPZmLHIFTepkhVL6PFjXboHX5a43/BtwEJiFQp3QpqhpweTVYa4H/hrq8+sy000GouR2TBV14oxCpSfsn5aMpHtYpHR3e47ltv3LOtkm8sgp8Q/2GMdbMalx8kXtIA56s26ENUwVxIcMXEJ6tfUG739vhtzvIOYG7ESHWKTrXcT3XpdwHSLMmFxeXgX2/6bq+zRhCSR5oQZfZEelCqTna1+hpyw7mta01odPap3Qh/Zzbc67OAnnPw/09apzch9rcKxzd0/3Q2T2o39Fq4z3EIV3rnD6eZbjS4+7PM/3e81nf9z2LGMXfs/7fG8//ODBMxl6t2bocfOHsz16uX/3hVx3IJd7VIxpc9foNMt7uQfMIgJ2W/+83J6482Mlcv+c78O9Uftcgl/NXC45AwBmAzQmcFd0gBngKPdeT8mHn5h0xmiCp502bdzOZSdUtGKxh87M2bEv40B0oqLn+KZheHKsA6iN90j9IDqxk8eAMH7X66l18n3Xf68U6SGv1V/9MGvghoYufrb0E7Re+uiuBFibe4bkbDNwe7lOWEWQ9yfu6r5l8r3NiBt5ANBWUTsWV7/EX5QN/8O/XfuOmF80AgP4bNDuA8Seg8fvE22zD2/TSyuLQEpbKEQEClixYu4gJ09Yuob2FDBvWy/ewXrpr2JT9ejVpUrBm6SA67AdyX0iR+/6RPAlSn8qVLCNSbLYsJkd6Sf9q2rx5c4mSnTx74pTyM6iRoUKT1CiCNGiVKEyLOm0KNeqXKGS+yKmjZ1RBbefAeTXHLuw6d9++ghVr9iw2tWyzteVW1u1auW/j2r07Fy9danuz8f0LOHC0aYSrDS5s2BhCceT4jXs8rhy/cr588atcmZbmzZw4IWIE5/Nnz4g6IwokJvWMIDNQuHYN4vWMK7S1aKGN+8qYK2vWJEr05s2Y4cR7H/qN/Hfw5Hma934O/Y3y52aqW7eepQMDDAwmYMBwI7z48TKGDEmRwjwTJmkEPeo0aiCrWsDoS7Ik3yA0hfwVOpSIDky1vOJKgcvMhE9EDKHEIEopedTSQvQEiI3/gAda8xRRPum0YYYadpiUh0gtRWKIIkr1BIpTXTVIKPtR2NZY8tyFVlfW6JVXXTqClSOOPsL141yCDXkYYs8QwwxixhTTDWOQlQMlZZf5EiVntPjCWSWdmYYIGGB8BgccYgTB2mqutQZCbK3xZltvuDlB3HCArHHIHnGOYScgxB1SHSCHrHGdGW5WFx10zVmHW6BHmJFdd9thkEINbsRBaRdppLFepuqpxwUZ7r1nSaiijirqfNCc+iJ//8EToEUYwUcQMwipumCDDj74n4QTvhSTMsycmKIVIAIbbLE4HYXsUcQuq2KwLLbIFYxpkRUjjTvyiG2QN2rLbZFyefst/7jiJklYQUketE030jQWZZRUUgllZlpumeWWon3mZWpklrmma20Gp4VzgOqJJ3F7HJwnwgojXLAZBwc6HKJsAhqdxIEWosURMVzAwADdgecGIZuMHKofmpj8nnsqr0yHIC2zzPLLksRnLqqsKqjQRNrAJMsknfz8Cn2yzprrQrdGWDSANvbK7LBN26SsFMkiAdTTJoroRVNZW1WHJPoFOG21NV4rdrdmBxkukUcS9oza5CJ57pJNNhZZu3bHe0sfetPrCZZ+e5LlaWIEt9ptAfPGB3PO+bmwIo4jXMfjkgPSOMJ1Roy5ddTxlijEumH3AXeOQiqFJJCMjPom8w3Eev98+JXM8qUty36pp+05AmsoNUd7M+87MyOQKz/D+rVE4SRdNNKrUogMMFZ/+DyzJV79/NZay8EiumFvP7aPL1n7fY/en+2XkGm7XRjc6q9vUC7F9JIMOY9B6Y/dztzvjS+V6P0lGPMCDrjK4M8Z5cgbagAmhsQpUHF8klPlJgfBByrsEHWqIJ/0ZLEMfo42i6qODjogugRMwDtF+MMsTEUfgaQwhfFp3SiG9zPc4c5ldCDDpbjAnk7V8D2j0N3uUqWznQ3IFI9AmQoNso100MoeTRIHExuivOXxKnpVcxoVrxgVYGHvKluJVve4Nz6yfU+M5EOf+diGxiOZqyBsnAX/3JbkvvjJb35R8oY3ynFHOxYQX14KUx9LE8D74bEy+6vELZLRi0YEIhKMZGTiKOgwPCWscniQIOUiSEHHZdKCesqDBj/ZhhnEgAKOWoAIPZAESKCCGCdkHxvrswsVBq9npqhlD3s2s5LJYQ43zJTsHjEzWH7Nd9dgZahUZgnV0WdWtOoG8nCWNK9MA4vUPBERqhksIliPKV64yiKIMSuwkTGMMdpW2Ww0zr+g7YxpPMwr2zifeM7Cfe5TVzJuQY4r1e2OeMyjHTWzvy75caBe0pJBCaml0/zrOX/qJMEkGAaF4YENEKwk4yDIScsxDoOe81wbYkCCEI4ula0sKZLM/+WrlAYDlvVx4etidVKBPIIOOKypDltWxGTClCPR4lkRUUYI/CCJd/1JiBIBdLOjMiRBumKVV7AJVepVIWrQkyqKkDKVbXIoRFxrkfbE+UXwhQ9IYwQj+MJaxvK101vri+V8UscK1W0CFfSUIy1uoZlbVAZKgrTjP50BuEImNEyp2YJhD+u/Pg5OC7Pp3HX+YNFKRlaylK3sJR/nJ0poVpOY1exGNxqoDbahcxojZcdOS8JvwuSkrNxITFkKW5YS0WUy1EpKY+k62PXyprjLz1BbuwlL6GFlOh0mOoxKzOMqN6k4S9A7nhvV6ArlmtS1aoaqW11jWcVrLzLrOcv63f+zojWtRlJrr4rUxlCoN5emay9dc3GMY5CDHLcYR141g5kBDhAzBk2oQMckBjFt4QdbAHCbbMO566CBcpWtZEQH4TgIV1LCkvvDZilh4QtrWBGbhGScOmiGI4B4tCH+4GkRgOJT1sBrrV1f815cn5XKOLa0pGlNedlbYbZRt7v11KeCtkJROMJlvySeflCF5GtEi6jObXJS3yHdKIcIu9a9qpVV1DXuOnW84qVIl72bTrLiiEjmRW9MF8HeFtlBZKp03zGScc9b4PWunMFMfgFbr/5qqY9iSs2YWtMmQwTsUNaBLBrYQFHLQngQFF6Eox2N4cxqeNKUi7RG40TiTGP/R8QgEClqMSAEO6CQtTAu9YxjrFLczhRTm7qdTmGKW5n6YVK0oxQyRTXr2b0sd2tk37a2BbbnMhm6VZRyVY2dxStrF0VcBKcXwRxetqBznGFm57gMg8a2tlcSa+a2HQoxslWs4s3znbOVOmMlZ2AJoAalhSHxegv/9i81iRu0Ie6NiUtw1MGHTjSiGa0ICTc6wougtMENzrg2KHzhmg7xorAQAlJ6zAAUV7EdKGGhXpl646hONW6FPDscDoELOAaaK1cqC0LErtaxs9SuZxarNvr6bdj2irADhOyoCoF6Oz92spmFPa+eisvTjnbRZ/Rlcq7z2m876VtzaYeoS/3b/4BIxZvxWV8rrRuAgf2fJwJaGi3FW87tvutpItGKS/xGFYlgewX7HfV/T1Syix54hU8HCc1mIu8H92zC+61wNTCc4XByggo+EAEUT/wAjNfACrKyWo1LnuMvlvw7c8syULUwVrB+bcqPWUMbit6GNi3yS/NDkBWuUH1L1sayc+6hrfqkyrRXdoZWBK2EPJvo0O59tYEE/POxtenCOGFcZzb1qWu2FfCTs5zpvJnMAHDPpgH7vcKu58/YohFoV0UqvP/9t88d7nWQOx4E/uj0Ow4SGeb73vsOafZXtg1qqP+h/3AnJ0xhAw8IQAECsHgjJAJnAAmrN3ltc4Cltjbn8v9ONNZStLR5rZNSsuJ595Ey2LNbOXQ7mgdztBRknIdS1eB6rwd7VuRz1tVztTc9WiQHWrZ7RidtSCeDR6d05MV0DMhKx0cy3EYIUgdpl8B80iBn9nUlV2JnWNJ12ccIjIAaYhAIegOFoBEai6RA3meF4jd35YdoYVB+c4dm6Tdw8cd3Y3hwBWeGDUZ/94cH+WcDied/jAeHItQCZQAJzZBxCYiHC7g+7eRxD+hSMzUHP7ZTXHEqbrVegEh6NTVyG5gyQRUqBHJEwkQutkeCJmiJJVhNXOMi7WAz6ECDSUeDM/h7S1cR43JeTmd8qFMIduBtUucnmNB8kFE3meE3eJb/hPbSJU7oZ6nxBrwIMNLRHG3nfXXSYIiWhccYhuqHd2S4YeznJ2Mof5Vlf8ZIeGMQBhH3htl4SjJAgEIjNHm4cQioh+PYh5fXOp1AZL6EU0IlDAeRZNAQaz8zO+ZRerf2ajKnPpR4ifsoXSnoj5m4Ilx0Kls2XqF4Fl0hijBog2U2fMBjfOwXV+DGij5YcFZnC/P1GPx0P0eIGVy3Jf6lN08IB004OLPxi8chjPo2ftSIjOinjC8JboCwjMwIkZG2jMcIeIcWJ1Ogf/z3f3HIeBKQAThAh98IjuKIlEnJPirFlB53juhoY6UXiDxkKu6IZMAVKrxUj59yj52HJFWx/4LGgoknyHO1J5ZmqWwrojsD6Ym8h5AGOSMJqZCkeIM4eEIziXznR3WZEITz41d2tJHqFphImH3+BZJL6IvACIRXyGDUuIXUOAjmtwhRB5MzSZPNCFmZ+Wjjt4o5SQXDEQZT4IZAGZQWQAJYsAl3mIfo42JNeWp9eBEuJGQncwfpKDvY01ta0WuJUQ2xJI+VwojwsXkNmFXF9nNkWYnIyY/URGX6WCxVcRVawZZueZBvOYNyOZffoE5Lh5TYhooRCW7tpZd4QAmq0ArrAhne4A9/uZEcKS/9RS/Ohwi2YAtLuEjAaIXD6Dhzx4WP6W8HQ5EwGZGWSaDRCJNz15lpGP8GaGCNU+CgNmBKpBmUEiACJbQJB3KUSomHSaI+R+mAKDdLMNSIQ6Z5rkMzvfZWwkVkpleisjQIYIkFzqmcMyp7NOoU/7iCYSmjYomba0mQvmedQYqd2UmXDfmQcUWgFsWX8DNHduQPT/pXd4Y/WGKYYuduY0efWcp2jNQLreCllhZ3/SmZDXZ+ByqGBYqmBrqKcaegodlvDroBCSChPzkBFaoGF7qaRaKhcLNWbOOaf/qaM/ZaryQQJiqiojCcsCU8tvlLjVhLxUcINmScY2mjZYmW0aNN2COdPwqkcSmkMWiQC+kX52VmtWB8SGqZmfV9TBoZ7NmefnNn+cNu13f/L4yQSMjhpV3apYmgMG4qpmQKrOBGWWkakwWqmXTXmf75pqGJjXRKmhTaBSLDp6Rqihrap3yYoX86c3YZm6zzKviBeq/VCSp3Q7TzKTuzCXogqZMaeydYox3yrvE6o8a2NUHno2gFl5+ar9SpncFXitWKXvZRgNB4YZfwfV6aDH4JmO05fei2X5zQR16CGomTmMvhpRfLqwA6UdMYrA2WfqtYCJAlfyNbrDcZsif7sWwaeMvqpkDAARYgpzErs0FZoSIjE6QqfAdYl9cKsJO3ra3pmrMkgb8giayQlYmIQ2lQDcW3CW6go9Elr5WKls05IjWxFJdanD06nWaVkJ6q/69l8Ymi2rPAhaTzwXeokAlpe7C9AD9+qV9IKFAFJUDq5m7/tVgVMwbSAT+7+ji/KnjA6rGTaabsh7IiK7Kmc7LJV1nJ6p8OagIbYAETMLOTK5Q0cAZC4xcwMapju7M8y7mnOIEcmmrdGolEK7RDW4G2eSPouq7sKrWvm5xmiaNTa02Z2qMFYVRDuq/zwLtfO4p2YUalWgvKNAt8V7xqe7DDwLa2kJFvG1iKFWCVYGeecBoH5Ca1AR2J0AjmuaWOI3f2x5mBu5mOhrKIa7KEW7iF64WKG6bTyKyQG7mTS5pDSYAYypD3S62d27OeC7rAo6i0FAulAIlApnqkG67iqv9yhPE7kvC0Uha1Z0m7VMtzVGOpxnJNAdk1XdQ96sDBvuvB0badY+ad+Cu6qVi2pIDCKby2zZd1Rzh90BtgejOfeqNAhTIcwBgJXaqfh6aFHNuxm3msKZu+QyyNZJp8jQsFJZABMJtic0qnLAB5mmtt/Ku/VayngBqioKDFWlwgA2y6X2zALkQQ7Yhbc9Eqs9bAsAvBx/bAzCnBxxIV1FWjmriJwqa7H4zHYruzpipPKZzCavs+rdAI9Pl8Hgk4EYtY9LZAzvE5e4KSqqDDiUCM/unDZMpgFoa+Qsxt5kuZ5Ju4x9iSU9e4LwC58uvEjleUUmy/+8t0JEzFe1pqAVz/CjAECrgzywIcC7pguioVxiIaVLDQjsIAtspVC2icxmu8LG0sx8gcwRXszFTbTXIATAfRlrv7tXccNiEswq/sv33sx3+8tq2whIX8kYj8R9VLhW4yKIByw8cByTqcCXZCyZVsUSSrpuuLz1S3iq1ImeyLjOC7hVmQxPAboU5MpxPAAl7AYlPM0Kzs0NialA/YxZpA0bVcW7isywoIY976OkOGQ54yM8NMiE17zMwMu8pMqRpywdmVtXowCLvwgtWJx9isx58LTycEzmibCsXAfIQsGvCJyD1AYBGLCAZkw7qxB+7Mtl/amO47puQ5sucLhvnsz962mf58xIgGBQP9/x0jZNA/KUIIrdC1QHMPbcVXDMtYDIlbTNEyxNYYXXmT160DjI5cEB7p0QQirTMMXNJqDD0cAtiB/cbNPGWDXdjNKXtWAXm6Z80z/bvBi9YlnF7Fp9OVzQs9XZ+CBbERK9RgINSdfc6MwAcnSScomQjKy719a35/O1nph8lSPZ5Yzb6z/b2iXH9lwNVebcpgHYdi/dJl3cr/mr9nba3iOAptYwrPcMts7dZvndF4qMvR3cUEQq43oAHXXZ2zYgzq6rp+PSyAPVGB/a7PfNiGTd4srSFbBEwiqK+9i53uTaQ1pxfdOdygy8fzkdOVPQzMx3xLOBqc/dkB3gNEDSaLzP8cSw1+ERaaPVx+nfzaNYnJQRzKintoIkPbts3gt+0CHkBKkrvbFTezdTrWPNvQwV3fTYmUw4ncyr3czF3RWyzA2SrdXpyubsAEKaABMq3dddDX1LQEiiANvWCN433eRW7kOgHNK2IJrMDednzN8J3HOqLNwh3ZorvK35nC7WjZucpI/t0/XiLgAk7gn7FI3IeraycN++19AReZC15/lvWMF/bgQAxZb37hWY3nDf6YuK0EITVCHv7hTVxxjlcEogbcJc7NNq3ci57cK25LLf7iMP7co6rLgfFiMw5kAlEI1Z3d2i0MZ3CcJm2jWcMhihAZvSDYol7eKWLeR87qsif/qS4N088G5bXutVFepIku2TiNtpSt05e934rEBwFWUGAe5p+NyGBiq2knjPwNyWseYZEp7QBdz5iZyVRd27Pdg+27hRkedWUgNdwhAYGujUBJ6L9dXiZu1lYe0aGgRixuS/AO6ZEe4+J4PnEt3WC8Qqij48eVLpBQnDuazDoRBrbgD+OwB1OQ6vO66q0Oxyo92IrtNdV869eJ6+Al3xmf8VV+6KjY63QF8qcg8pd9q4kzUBDb2cduWPPWi064vc/epWoO7dHe4BRZ7XJuoMd65ztffw1eBj7fheC+4YA+7rxd7s9qATVrKuqu66/c6IZaS47u4vSOC0Rr7ww56TGR//Wk5kbuPSFKlEThUAyLMBWh7t3ivQSHMA7+IA1jYAMoXbUO/7rL/MZWYRWwQOtgYesXX9PsXt8tRtlazgupAPLc60jDHsOh4T8DLuYrjy8zEDB8MMi6mp/QPu1AH6B+h/NXjeE8n+cZjtvl5wWkrAFFL0LkjvQjwAOGjuhN37PNk9yPjqiyL+/0DtfAgICuTN/9u4fL1TvGUHxkb/bevcwRZQa2ACWJ8PZETthyz+rOz00sMuu7svcV/8HVMBbsDby6rq2iG8x0VXyDv9Pfl7zI0RySL4Vxa1g/sC9kkvhwQDFth+D5+QmPI+2YP6yatFmw/fkAYUegQDUE6xwkhP+wzEKGDRkSEZFBQgIDFCtaLBDgwEYBFzlmlJBhA486s4RVm4YtJTWWKluujOYypsxlMWvaxPlMpzJkwHSaAhq0lFCgz4aCQqpJ6VBcTXdmgxpV6tOaunb2pHqTmTJ69eChs7a11ihJeuSQiZK2iBG2bd0meQt3bVy6S+yqGmer1zh/0uz+/Ut37hPCgw0TEZz4MOLFhdVGIVNHj6Rd2uidk6dOs7nNmD1/ngf687VvnEuze5maJsytWlu7JlYzNjFhJmsL45VbdyreifL8/p2ID59AgeDAEXNczPIgzYPMSA6mT6A1a4T36qUquyruirx7P8imTpjwAvHsWQSJ0vr/9YDUQyqUHk8hg+fxiK+fv6Aah/29LIRCiIgmmMgjAz/q6MCMLBDBBTtIOWkq1nKisEILr/IJmFGQIUqUozo8aimkirLqKW5OlDArqGBzLRhlSGMGlk38oNENtKpA4jEdhZCrsR4VA2yJVvwpZxwjpQnDBiUDW2EJxpx8kjEfp1SMSh+/0IOQTYgBi7TQOvtSNDEzM+200lTDabULX+PJxdnexC2X3eQ8hTdVLsHzkEOse6PP3/x8g7nnnhNDi+gCGS6RXqThbrs71zvPoP32sy+99yylxFL58osUP0n5A9UhKEYNkq0XSLCAQIxWBUkjVxVckAMc7KglNglvbalE/1zX3AlED38FNtgQRywFKxNR3FVFZdsU5RFB6EgjWi6aQIILHHe0Mtu4ELMhEb788WccRoTbo1RupUR3xxqwTdetdt+FF8cvsCSEFcvALDNMMvcFR0wzzURTTRZfe9NNnmbZBeE4F96tTj3d22MMiMegmGInrriiUEFnmMHQ6RppBLtehuGOu08gjXS88iqt9FKXNeVUP/8aAoxHIUzA+VQSNlAVAZ9XHeBVBGGdwIMaLKnVtRWThUpXpps2KhZhiW226qmpLtbYgJlusWue5pDW2mmtxbGLx64tYt0fB1N7XZurdDIMcvzxhu5ywB2nkSRrjldbv/82jAwyzpissv8ux0Tc338B5ppgx9s02M2Eb2N4FTp5ezhizSvmfIYrOH6O40K10MIQPpIRWZpjSDY50/smBfWgTlt+eVOZxYN9ZiissAuGGmAgIXjhNyCego1+Hlro5Fu1SNYHeVpT15saf6mnX37p0JGkHHG2e+6vplpZ6pddeqWwxyYbbXbbBjwxJVW5G1z5wbVljFKhxN8xItifK8f2+4bX4LIkCy4dDl/8QuBo+rW4rfEKcrGxXoZqNUHboAIVlbNT5iKGhj2EgWJhoMIUpuAEH/jgcx3TAgo7ZjpGjGxRrHvUd1QWqvGE4T4si88f4AOzlH2KhqEiFe/corOdecCIGUBiqib/8JGgMbGJzINiqyagASRQxnHlk970xqcLXQiFWKDgXhjFCEasYU1rDRxfwHRyPrKloWxv9F+64rgYIPxtCVPoRTniN79wqWJvgYESAPv3P3cJMi3zIkOWtuSlxCUwgQyckAMfCDkJwuJ6FDTJBTFoQZR1yoYgBKUKVFDCI6CQdFcg3XCwM4yRDSM3pCCFDGfYENjhkIe3yx3NglhHnblgZxgAJoGEmYCeLc+YUSQASKaIBFo9Lo24sp4rpLm9MYJRjNr7XhmHhQw0Ui8b3GygMsYmOLN1wZzUylG15mjItVFpSWOYGx/llxdzGRIJ/INXIenYt7MRjjL3YmQjDahA/0hayJkFi+AlCYhJhV1wTpgDBHo8CUoQkkoHohwlxjSaykiEbJXDcCUrYvm6mZGnDvcxjy176MNQhYFUo4IBXIhIPOJhQJjDZNUxdaogBmCgCvXSIprIB80uTpOa17zDNa+pzREdq5vPpJC0yHlOOCLGbOwk5JISIc/5lSMRf2yX/oSwTh4MMp+EdMwXyOkGPyANoAJ15ALlWlCBeY2SCtUQMGqFME06dDedZAMeBgHKMpRKSRdVARU0irE8dLQVrVwdL0a6CJL6Z1IrUylBgLhLJfBSCL4U3i+TmMSeMcC0OU3QTpFpICoWYja4yuKuaFLUpBxVqUpl6lGOhZqnIv8LquaUKlXLWVXIoA2f/7MBt2yAR67Os1y9w+o+ozvdQxIOFsZIx0DfwQ64zhUldK2rXfVqSfKSN2F8hdBDUcGeiS7kP0E6rJISawaMmaGxkWgFSPUbisnaoT/koWXsKDW78tBMLjnL2fBGq0SKpOq0qIVValULRQ9UwYotgipMemJUpdwhqY5I6ocFcdtsDssUvZXtmWRCPeEC18Vn2d8cr0pd6QbGCbZoLt1UAUgao9VU0Z1XluyVXe2iY7vcPXJcuavi8IrXYOWFMgVrY0H1XoogD+HbZ2GA4BgcoQ1fvm9+xTyMWO5ws1j4b4AHfGVQCfF3JSjBCOI8Z5oqcYn/IVkA0B7c4AlnZLXJ66mF2bQ0Y8W2gbRdColF1OEvNvV6uwWvbyMt1KtUgZxEcDGmW1zcGPd4n2Xt3Ri+VTc+3qKi5+Lx+o4r3bKeVZBVCLJbiaxdJCdZcd/9Rjgf92SFvgKvDO2rZCVbZjM7xM2efUHOttzlL9v3EmLO7ytlSZ5RpTnNKfXvQsgjU9AGj6YVADcFxJ3nBRRTz8jbyBKFtm4//zmZ766ITyeRtAyrCdGLbnRug3XGlzDQHZJGkXfpmhVkwNGcxd20WjqNVc++LUq87N0hxkFqPo4jEb1zUiDtachWe1ot5CzcW7dr61oTdNKRLDSve/3r82ZyFg7l/yR4su1eIQ7xVC+42e9igDPFAgJPmGjFKkA6bEWEYhFAtLa2Z55LLIO2A8AUNxIjYIGoO7jcQ0N31tXNbq67+93L3NJryve01dC2tvnWN1DwCulI58vfYSlT2bGyabpj+guaXrin85fxJS0hEd4AvDxv8Vy+54/jrmY1VgcX5E2InOS2HqjABabhlLtp5Syf3Msh9AlO9tfA3Eb2zUX/uyy0wefP5o20v3N0pCc9d61ni2iDWXU7ax3QQyuQE7veZwNMIAUWngWGx/7U63FY31YxRfGT/4y1s33S5gj4kt8O/dnO/eCZ3nQ6Z5xOj8elZnicOMXlR4s/2qVJ0+14+v99LFYdnWUQJ5l1QEtu8n6tBNcor0r+l3H58V6y5QmDJc3rPMqqrMJwGxfQstEbvVGRmETAnAyClPhoPddTOjTAHSxImxxYgRE4IolQANOSgAeoPXLLugk7nhPEunaLMAJggGTqKQ/AgrALKhTLFeVjimmSmmJpih3Eq0tKKJ+YkOn7tyEkwsWRPsbJCeu7luHqNCbEtLwjK8Rrpx+zMVtwhsDjI1uYgr7rO43zwnRRP7OqMbbwAkNCpMnALlpTQ/pbsQvxwR9kuYVqOQgRQFiSJZU5tgP0pTdTQCAYFfTQkwfMhEEstgmkQCBKmw2MCNKaog90xFR5gNyDsNtDwRL/TEEJ47oXdIMLE77hAzid4CJpCkUeJMUefEN+uz8hBLgilDwktAklFC51qjsopMWHmwuI+0JugRIbuLHm8oavUoEsQzyHC8NbzEX246d5oZche6t+0QbHQyC4a7K7GkW9chHM+z/0CsD+wkMM1LJv7EOc+x0e+cM9cECHGcRM2CH6OEQ1Q0TZQ6KJWCKrC0EFcDARdER0QyZL5EdLxER4My0MuIEYNIlmmEHxaUNQrEZTZL7K05oMUREjVEVWbMV1YLKVUMK00L66075alEIrwcUlGAMrlCdvGIdDOIEu3LthzDvAKUMzFKBBmIVn3AYj+4o1bMY2vL8kXMgos8bz/zqv2gDAbVy9bvyRGkBApEzKpRQ9P7QhRcCTdNSTSzHEaqPA3fElI7qpKcKzR5THB4hEfJzEFEQAdetHf1RBeGNBDCCBM5DBTkyxGuSiU+Q3ZYHIupTIuKPI6MvLVlRIxojFjZRF7iNMj7TFOiokGsBFP7SLLezFkhyHN9hCJek46Eq8DGQbYvTIlzxGw5iXMhAyS0rDdiBNmnQ8GJHGnay+njSvn/xJYtgFodxGOwSP+2g6cGTK3FRMxfwPQJRKlIEEgTiDQ/wPAAGrU+GAeKy9rmzEECyQSCyABzDBDzwASTxLtFSegGzLtzzIuISalCO48MQQh5wJgbNI6tvL9P/syzNpk+FiwnsaAsIszPnMgSgMJMMLq/RbrjsiST7yBlq4uC4sxoZrSbPagcvUOJgcThthK0ugjMnhkpo0zWt4xgpNza3YyaoovrlsTUz6P9mcsto0yqPUTaY8gd1sTECMIfaqrKukOeiKs+TcSjwzt690TrDEUer8M+SZR5/Jx58xy+nsqe2kDaXxzupzSDhMUsgZT/tbT75UzyetQfmk0nRCpypFghW4J8W0zx8r0AENtVsQv3nyIwEdxgMtRjRlyTUNMnKiFuDKEgdlhYSpUAm1ULjD0LDYtZ6cU6D0UJcLwKL8vFYrUdFbgRNF0TuSKKhk1IhqUeOEVFEBjDj/40AZxamy/FEeLTexDEvp1L1KvM5+/EcX1M6QM9IjxaKFVNUlXdI0OcIohdVXXaDqKbjBJMwrhU8sNczOFIzK5E270IExEFOusjjLrJJO2800/cbzW9N8UsZLQ58XSwik2YQ5NcgifcY3yVOC8ck/5SvZnM1p84J5MVZDDa2k3MBEVdRFPYTVe1QAk1RzUcTkXLCy5NQl8tQMwEfphEQF8NTq/NQSfM5QpURSZUu3pDdPbBxVLcVVZdVCc1W9hFUoldJX1FUqjU8s1dIvdTVlDUmRpAUslJ8i2bG+a1aP1cyTbZdnNTjBoZaXtRbBoRFCcFBY6FNsvdPZ2AXXzEaE/5nDoaRN1nvRzsLNORMeGthAyjzUXwWhRZWoiFo6qxzaeppX0irL3APLA8hafy2Aq8uA6PzAsPTRTG0iggVVITUaP3Atg0RVWmVYHCzF5KPLuoSeiHWJ84y+WK3YnWhCwbzYLaWBLCWCjd3YfAJTY9W4dxrW+ambcSC8lbzM9FPTyY1cMzwDtWpZg2sCN+JcwWGrmUUaCNWGk9BZPzXdbAxXygKl90pcBTxXG1gBpE2u2W3Mp3RakrpcqR1Xw4pdpK3UeLRRTxXeE/zRfc1Rsj3b5DXbTDSttOVODKWet4XbhmXIhw0qbNDb7C0onfjbiy1cwK3PZi3XQio8JRHWPf8iEvqBApM91tBDFzTdAcpV2ZUdnEvLXPfs3M6V2WmVBGqd0yjr0wBG3dS1TdYl2tDrNjkLnheA3aUtvKa9XQscWjQ7tnSN3ROt2hE8nny8V3/VUa0F4bFFXrNV3p3yUec1CbgkqlGcXlGk3hKZW7o9VYqlYSl1xWfQ1Y3NYcKNsfgt0IyrTCo8zL37ixsbB/Q1SZSE3Mp13zBEWcOUkiDD3Pt9I/1lUM/9XLOI02nVEgH2WZEC49kM2sEaWkJ13Tnr3TRWSQiWqDEILJrbnZozgt1UxBGo40rtGQ0+3n8VYbAl2+Il4evcveMpmqNZ27bVUBZuYeq1XvJxPu214e//4l4r1eEevicepmTw9WHJ9TFi/D5FkYbwAzwtFEZmVS7EaJIliF0oaZLCdWLeTNYnjmJlnGL3zNy1wmWQ+9xBkIRNgASbJYa+siALmrI6HOPw2F1kFUfXZYFwfIs/JKmKAhDenSkjqikP0GMRBuRXAWRH7FQ/3uYRXl61NBAPGMh529beiiZFdthEvokscuQZvluJreG4C8LUqNJKtmQtxeQcCFxN3mQwHcMpBIzlEqFEkAbAc1xQgzgwLKvZXdqyimVZTlCKJoxk9luDQzhcloM4fVBNMgbsyo2QHmncoJwpI+BBqAMDVmaJDsemzEy70LbVvR8goEycKaIOZEQ+/2tOb3YVPvZjKLJOgA3qEg5kclZL38MBP4AFedZJhWRnF27nJgUngjM0p55Iep7nhJRPHf7eS+5qgA7osRZDxpBfh1PlgoavPbCFifuE8T1GZnUSZoVll5bcXJTl6sLojC4bzw0yXk4PWIqTYiDswibsyjHpYtZGVhBXjMbMZS5ayEbrzmpMXRpf4Mnp2dtKizitbubjrBXqECZb6/xg4iVBgkVqj8CAGnhLJ22yqJ7qeL5qLHLkra5nvXxqmABr+rzkfvZtfwZusr7Fsl41Y1TJIAkDB1SEwGjo5Fo4IE5rVZ5ou27p97UZj9XrceXrxZOdRWBsVsANaDDsYmAYkv9ObDlJbMUOVNtxKcem7lcm0I8FDM46YB7otg7cbM5W7UwV3q1N3qHWUer849I26kpM7bIUAUFL59yG6redy6CS4Xeu7Qm/bbzF295KJ8KtZMEFaxzw8A8P7hDf5KSsMYtGtZo+NV9VcVRb5b+Y6Iq2zOlG5SmcZZaVgy+QnV7+ZdsgacOGhmcsacNG7FwItgvqPG4cD/d+bxOnbBRnkuGpqeaURJ7S5io/W6zF13QL8A02bS4f5wPvvQprbQZniXWO7Xi2KwpfE6mo8Iu8Z6jYwK7W8N+O32YWcRDXzZR9bM3MuPO7n3rCTy9FXKTdHxlf8kNvYmf9zJMKQN0Y78P/FoZteHQgh3TzTm+THuYAfLkdwl2MRvT4nuwml+NUAy0RWEQNTksq3wigDgBW93KePlvpBPACx06kLhoFZ1vb5skzp2qvmW2dSKNHPhELt+dPtNjezuQ492o8t/Nm38M6F+7h/vSQLFzoQnFXc24/711EN/Ru//R0WXRFGIZuePTckPRyR3fy7vGRRm9iFsA55XSVTvJkJvQlhxvKjuOKjuX4NXWtNLdUT8sS5NpV92/lHfDR9vIgFWQw7ykccCsyL3Ml/c40p3j9o+2IXHNir2F11vDB3W1+7nBmv/MWEPmzru5x1HO41k8vhHHENTxv//ZE16cn+Y9FQAWS4YVh/zj3dJf00XV0IS9pTCdmlJ4FKxuI3aX3gJZvCmb6pn8pfa/znRGtf19BfWT1gTd4fgXViRBnLT9qhhdIQmiGXHdt9tQ/GP51eIbhi1dz/CvP26ZBOOdwaB/5kif5u8f7kt/zVyZxPg/iJW5f/DFj6f52iQ6kwlfWwtjdRch5nS938U53dgd6S890C9p0M0NmcoV6xkRuNIPjp396Xnr2nTF1DTD9RvSAqR9LjyDwQSbYrsd6WjfB1f4nsmdw8mR7NBdPi3cqJO039Cz2jKcQurf74if+vD9+ZSVrEwf1mV9MwRd8xJd+RF/JxSeFodv5yP/57V/3xEYvn433bmTpE/+vbAMrqeFkem67+36n19NnyxJYtqM1HgV5ouQd3is/bXNTAJD4bIAogGAgwQMFDR4cSGAhw4YJMNSQRKwZNooVv1UDNw0jtY3PliELCXKkLpIfR55MebKkSpEtU140x/ElN441b2bLqTMaz54Xfe7EIXToDqI5iiI12kLp0qZJXUCNKoQHEapVpz5FCgTrViNWr1JdArYrEbE0eCwx+xWtWrRrz761CjcuXbpGxD7Jm9eLlzqKhA0LzGtwscKGtx0uJgzw4sKNjQ02hmoyZVaQLm+CZGdzmTqdy/ANrUTv6NBQQJ/+jFr159NYoIzGulQEbQ62NeCeoJsC7w4lYNj/0AHDBAUGxh02VIAwgHLlzBMiVCAB+oLl1K1PwG59O3IDDDXgsDTRYkybHlG+fFZSF0v0y3auJxnfJX2g5mmaxwl0/873QbM6dRSATA1YoFZUAWhXWXi5pdZdCz4IoVcMulWhWRTKpWBdGnr11lVffDFIKKkcExhigQ3TjYrDIJaYYYTB2Ngpi5EyC2Y3craaaa6lteNqWQDJmhpDtgYbFrFFNYIIKdCWG24YWKCblBZ4QIKVMHSQ3XEDdMecQAYFECZ32lE33XbNIWAmmdd1+V14i5VnU37pyeceTPCxl6d7LrW3kUZz3gkof4P215GBUSGaaICKMprohhySFWlV/wxO2OCHHaY1qYOPQjqWgJ1e+kQdg5ASmIqndpNiNye2CKOrqMhYWY03ZsbZGarxxZppYfBaRq9CvnZrasEeGUMNx862pAdOOpkBlBNACSVvHvB2kHcJYLvcl9teRxCa3n6LXbjjstnmtSTYAaecMmHELqEosWdnoXnSO199ga7r00mFvsuvvwQe6hSyLAS8KKcHfxWhwguHGuqmmXoascQSrzAXghVLWlYUIJKq4mCUqaoqq68KUyNlJc+Sso2Y4SGJJDne+gWwvvZa88y4ZkEsFjHsPHCyGCz7JG63LQv0tNRWe1y2S4+pbbfUSRf1t2qSS662bU6Arrrsci3oS//tBbpSvWPbC3ZH7Xat79n+duQf2/8WHHejBjt6IMIWesgwWBjy3eOkE98dFsYZUmUDDZte6sUi3aRihxVRVHHGIqQAhmKrhMlq8mQ3srzZZnroIWyunpHumc2n08zrrUMOG2wSPt9Awg210W4btbfjnruUTF+7Lbe+N/108OEO37tCxl8rgiSQZfSn8/nyK5LZbcPLnivX1yv99G6zk/ZPb9/ZL78XL0o3wHMHHDioe2PafqVhYVih+hbTNThV9q+FhMZR+EXJGU8UZVSdKdWKIpO5WVFiZZwrhOdydDPThQGCEESdjnJGLGMNTARWshLtOlgbEtCmAyPoAAlJuIH/DfCGSkoDXvCKJ7wDmAlNVHuhuQwgAQ6kyxo6RNvzvEYn92QjJNbD3vbwszbvgS9s4lPbp5poviee74nzyxvg8OK+jP0NYm1BGOIMFxbBxY9+ibNDAjOBB5mFbnIvwhwpKHGZRSyQc3Z4GWcIcQZChI5IQqKgzVCjM50hy2cbtNLsaFPIQQ6ShBtUpAhPWIEU8i6SYGIhl9ZkNRo2rYbYwiHzeojE6O1pT0MkYhHDVyjo9aeU31uioeQGRaLErnwEmyUtCWc3wFFRY23hm6bYcqEwTpEHg8PYCoppywwNbmNlWIQqhsELzSzzVbzYnBvhaE08LAKb2cRDA9mgx9UJ/6l0ERRnHx+XhCNJQQo1eF0g20nIWMZOg4icJz1LsEET4BOEkPRdDFv4HEu6MKDIw5oHCqGNg/Lwk6AU4i/uJUTskRI91EtJEXeyyh8qMYnPcCVT4PnKWoL0lrbEn/wSlilLjaUrVvyiLykWzIoZ0wYwhakYwVIEK/CFEp+gBDfx8Alpbu6aPd3MUBuIKyyAUzV6JGc503lOdrYzlvW80iBD2hQTuACfxvrNcLTaVa3a85FRqg5ZI/lPgaI1k5pMHiSMoY2EolJt2tPTXEcZi3jJS6456dMpF6pRt02UehxtSuxg91GrijSYb+Gl3n7pIMSdBbIbsp9MJZtLvnDTV/8+TQVneaGKj7WxmkXtpue+6cek7nGcYfCROc8ZVcK+lgTtnO0LjjUcZN3WtsA5zRR6CxvDBccGUxAOCcdqVkoOlIXJ9SfvNCmBFrR1h9KF60XFRte6RhSw78revo54n+mBz6+tPFRsDzu3mQ6TpGJcL6iuaEXHrhSXdfEi/GC6BPUec3+j2yxnVfHZaYb2jaNVQ2ZNe9qYofaoOmqta/Xns0TRNpAwmAoWI3Vb4ATnNGjY8IZ9qwPeBvcFJDDucpW71hOb2Lk4iO50qVtd+XCXbMFACfi4613qzYsle/1IeHVyr8G6IJaGNa8xQ6pYWwIXbxlTGIWAyd5HFTkt+GX/7033skyd9jfL1VRET4uqWtOK7o83Ew2Dq+xgoUSYtkqAATrbHJvSGMlIwVXCh3GqYTOgAc/e9LCHDTfC44oJxSkWAKEF3SUJZI0Vbm2xQlPZUBnb2KI1zp6kxRtEHvd4XisBMpEZhV4js5ekU6avSbOoRb+hupdHRuYWa4qEZJJGcT/NMjW57OU9l/O0DEZngsmclyp4ClnAfh2wjbWznrH5qXFunY9A/Bpng7hXaPhDG6qNBt9i+zQjzs6gDe1tFE/ACqjYBqOvwegXPxrSInkbuvV0Y7/iNdM+puhJnBhFWXa6qkWe8pPxKxb8nfp9CIrvhw4n38DxW71m3otP/z/x31MEmKe3ntkfd+1UnCKYL6Spsm2HvXBzVvyPwxr5r3ibM2ij/M5tAAS12UCFl8P85UswAQqbW8NAF/rbgp4AFIQRDoSaO+hCfzG9bazdeZOnuvTSSaNNGe+/3osa9r43vvPNgt/MtLbslenhVhAcmlrM6waP7FaUjFKz51dBxKQB/sQ+S2RWJcrsS0sYFOFwLG95m5z5Zq9C7uY3g7xHZE5pEdZpZ10Ti+SpQx2RguT4xy/b5JLnsLXbEHMPh7U4gO4250ucYg3YoTBvDXrXmq6M0wODoY92+tGP2LZ6Md2HICmJvPOK6fFSndMgtScti7nvs+B3pn4mtTCzDv/8slcYpY61kJOFuaCvm4Xfcqms8//9odDYHe9uFG1PcU0zmi37f39nMp193aEd3JTCbv6MzJ6dWg7zCtfybzzrIF9BI53c8dUGxCFYngUVfNhw9dYJ6BO3dV7OHSAC9o4CegfoCQPQDV1cnUcouYSmsdtNRFpcIQM3VE/riVLUnUen5d4I/p7vsd16kRTXPVnXtVdjDdyjVJbxvWC/3dcwzR3d7YEi9N/2sVwOctP8LVjkjZ/6wVmqEZ6yJd79SZs3dR8TOuHe0d/j0R/45d+zBeARVFse5IEZ6Fm2BSBWeYCZJOAYMuBApcAiLFqcuNh39cTp9QsQVdpPLF3syZ7/EemEuuFLNZBg1e1h7/nep6Eg8a1XDUbfwQkcZFnWDLodXEjfXCwiEaiX4Pkgl1FiEwIhj2BiEbpWqQGew2ii4r0fHkybJVKeKMIf/NXfFDoeseRMAAJJb61c/3Vhtg2giEVAdZBhLnbHBIiAHcAKRUTgub3YBOqV7cXhXulY89QhfpCNKk1gH0Kjvv0h7/He72ndNQriXJCa292XhhDcL1nMSbEUI3odN55g8SFI2N2PTMldhtwFDlbiNpni6aBcyL1ZOqpUaViZxhUJkfjjPzohh2mTtZFiKRIJKqqir7ifa9TZa3yYDrycGQACF/qf/o1BLY4QtRigLgJPGV5L/9YUwmIcFAQGI6A0DzEGlh3qh3mA1zJOz9hcz4zhGEpuRDTy4U3SUjV+2to5YiNGlvRxBUuB4zu2Wv3cVzfCRTdm45Mt5YTAYzzaAR+lXCYiyTVSWD6aHBtoE1FhUw922Vd+pVf64ChS20B+peUlJBUKYQA+ZLRN2w4CAkJiW6aUQM2JIaJtnudNkvHckBVgk0i61aINXUn6SUYUZkoa40rKYQVqoKbVS3Z5oGF6BDtYHU5W3U7CVDXa0wiUYMXw3jlq4/GBXdpZWBedXVHGoE8ypfPZheDVXROqZSZ+GIa1GWzU1m1V1YRhgVbu4BhMIiWyHA9qRleKJVjiQVwe5/8oeiVBjiJCet/9WSFbnoYOACAUUMHk/QH/TeRF0mKfFeCU7M5d6qVy4aUGyEAVEMImzMIDjmR7Ap1kwmd8LqZEHSMb3t674ZhdgYImENF9ble92SQsWaZOFhln/uGnYZ0KEiANmmNQdkpJgUW/leOmMCgjiuZlmcZR9Qi0hZhu6eaaHQsHnVCVcKaVhMEhJEIrtEL/saj2ZcKLwqhYeqV2yuhyJmdZaqVzymWRyKYVSh7K5RmKymKHdad1AsF3gudG5iV5ItqTiEATSEF6QgIrqIxgvmd8dg8P0WTrQU9GVRcyYo8m8Cf20OGWvkSAWuZlNgUhmaDvleg0at2CXij/JB5fUxrcUV4I2qmPCsrX26nPhmrcruFFhnUoVmWVV20VCXTA7URJtABNCUwBILRCL/TCpA6Df2Hqw33CJVwCD7oRjV5GD9poWeIocxpkQPJoJv5oQyYh/vkmjRJptvHKcN3XBtjGWO3O1Yznl5Rnk2pACgwBDnQBGeiBiMDCLogkNCirsqJDe74DO1yp+KzhTJ7HOkymTfxCKezntpZCQ7EDfiLmKKjE1KFpmrJpmx7oZpbom9KAnHadFxFfI0oZ8Z3f3UwoJBYlaeIjlQEqXwiTBh1F2Y1ACARXMY0o7lAV7khLo4LnBkCqpEpDxEpDpWaqlnXqDnpqdpolqWrs/6hymB20AUBGYWy+oiu2Jf71KK/kYG+GwUXyRfxxZ1qEFcOG564uTXkySwowiQw0QROQAbEaayjswi5kBLM2a7PKZ9Jm6bRSa7VaK0fggrZyKy54l9eYqdSVq7n64bpiZokerO2Y4E96kX2p5r8VE70SnEuV49qqplU2Eb8KHhGIAG6wK0zJFAo5iwpFywllFd46Ks1OCQWMgA3w3zD0QsSmyKVq6ilwVoxm7IyKaiF0LMeK7JBcogW9hv1pbhX6qIbtAVz23xIGJBvYZl2SmM3yqq8+ic7+6s7GTs9ywbCikbGOgtAO7bIuaw8pre467WH6LjJcz7YCrynk4dNWw//apKS4fgQ0oum5Hqib8q3X2ioH3BAH8G2dNigLTlZlJeLdEOK9rtq+5o3Z2s7tcC2u6i1vRMsI2JM9MWqUFMfCNmmV1N2kIi6KqGjjMm7jOi4PRu6okqqOim4UQt7mLuQBr8a0vepYzuMeqOwejAEbRDAU+G2umsl0iGcCgKfQzC1uuK7v8az+6I/sgogcDEKxSgKVrudiJOsDFu2VMm1+LO3wQia1Gm/SngTxPoO4Zq3WXh0HHSjXSi/R4GX1boDvEWBqniCfrg/7rOAxfZ34um3agZrWmZoQGKgNGIE+bcAJQOR9RYD6YgAJQEFcwkC0/MZsjtjCppDemq9wfUL/L5BDxFJsJFzCZ3Gq/sboi4Yqtc2o5JIqyBbChlVu5RawAWPibjIwQr5qjubgWyInE7JsCeStBQzuFJzABmySkmwSBVDyQ1TJ46yAbYiADMjAXfie/niBxiCBCXdGNsnMIgxCiIgIGgrD7bJnOxhtOyDt7uou6slCuukwYyojlt6H8gJoD6up86or9CrJwVbwzeqG9Qrf2SaovnadDUZMvkrx2bYtFUMKXZYxIBjBBugG+0bqcBUX/ZoBFNQAG0PqddLconoAPRvNwt6O1x1CK0jDHFOqikaCKthxIuTxpsJop2osIHNsADvhII8uqh7y5krhHxR0jKIiJaiCA+Oa/yJ8VgTzZkVTwpGOABWw3ASPwEOs1lhtABpQ8kibYh20gCG9QA7mgIH6BYjkBZdtjE5/gRtpDBl8wWQMgiW4DHumzEGtykjiLrTCw7M69bMCMzDjAtUO8+0V89IeMzIvrzIjVoBUoxCva/neKq4CT/UOrohx1RNjY9yFLz4O38FUsVo3SOlC4ghkwO5sgHd+Z5Q0oHF8QPsOh6JW8PsyLJVAaoragi1MrOJWrMVmQh6YUSz230JXXrWB7EMfJIEdwREQcGf7I/9lQiRLait0IRvs8yXsmWdcQqVqNBrcsUCu6BK4dhhkZA5SyRgkAglgywaYgQ14gHU+MzbJAG3QwP+L1vUK4EFGX8VOVUUqLMJNcRaDFQMq/OywKhopDLXQ6jLubrfROrWyop516Ym4Ei1PZGnuXjW25vBW+7BNzhNYf20l4yoGbwuiRUCJovU3G+IUjWZbw6C/2rV8w6/DdvFsgiH6npBvfEAJeZWtrvPfMmwYd/GJRsLhSkP+tgJB6y8m5PHFvujKUTaIh2xmn6JzvuL8ofiQ7HMkA8lHw7YqfEIDk0grtHYmpIK0tUIq4LYqrNZ9hUFuW8AYtIINWEAC8LaI7QEM8KIIWAEl7ECJ2p0XsO8KhIFyV4xOL4Fzl4WKloFr4YEzgUjkzMoXdMEgDEIxhELtajc04DLuDu3/M6C36hFv6vHYt0LD0vYyVp9EKEwUuZ6XDzOzM5eo9Yp1YRuXGNb3fZ+tu07xOu73YnnzUopUXB+Tn5Jml4u09UIz1pGQCQQgGujAI1GLb+gAIKxBDJjQBXSAF9sAzRkNYVPAok6Lw0JkHtiCPytujgc043J4r+vUHwdwyDo0gTEysReyAG+YpKI2JIeupJqisl/CI9ddKqioGak4JhxkjgMCtWu0bKvCfdndGJjzBpDzCEDwiLaAO9MGkBwCG7AdlSeC/1y5IryAEUQ7C2T5jesmRZ9ClyNBGZCCT82yHMgBL0iCHECOHNhuUe9Cmqc5dyur7WbrR9RuneP5nV+8/2GaElcjFj3Bd0aWr6EfOqKnLjXr99jZa1n0t1x3c6MfDFH2CPQesXDNHBevukQSV4J/AHV2wCMxABrLHJZ87axD87SUAG6TQ9InA8Vi+Co4vdN7+HKKeFmOOLEPu7GX+Kkme+XdMXIeQn+RNhrQ+IZ1vXNL+yrAqCnaePwlt3O/NtvzeBlz4QtYshnQ/Yn+aynThrmr7LtPYjHpIL73++B+uNZtX5fjABkB/CLgtJYTwbCeuSIQvAk/giOo+cMvq9CmOTBU/O0tNbRitexxfFe/9/lO71gL+MhPEskb9rpKKDuyNVzHIFJiMzZTusv3q5Sd0AgRYIL7bTyz5YJDkv9xNEDxezKi1mUJEX1xtTGtQyyuA/TTYwLUR/1kV3bVt8Egm2qOlvj2L7SKstwpjP0lDAO1dao35XjDSfKKaif6rwLrYDSL8nj8rfiJbudvHIJdUzk5cwBA3BAhgsUKRWGW7CFCw+BBSkto7AHEgscpPCyUAMKD5gVGjZfKFHmCh1IZUiW/eOGFh0iULy5DqQpFpsuXLjXl5Mw5aNCjUaKA/gz1bCi7atCQIjUKbam2pUenRZX67BmOHFavYi24tYXWriuychU7FmzZEWfRjuCwlq0Ft2/hTkBgQYICCQUW3L2Lt66HgWZpdOTBkIYNIiuWgB28cHFjx4kP20Cs2DH/V8GVMWceTFEzkCWfP9uAMmXJiRUb4m7wUIECBdUbSlCRfcLEhQYNGOB2XYJ3Bw8dbASHUaKDb9eoWRtnHWE3FUy9pCVL1qvVKuvVrWPSnslQpkMa/7QRL77Q+DaFypsfn35j+PBo3MN33yoS/FWHzKC51OpjJjZoWrkEj0sE/O8Q/gDB5L39CGwwvFTqY0OiTPgLI5HvLplCvynKkhCGG1oYiAdAPtsjsRXGUCShMCK6qCI0RkiipIlkkNGOTIx4oQhFHlokEy+A5GWQllyySRGZoripJpyYpIkMOuhw5BGfRhkKml2QaqedLJl6CqovoSLGqx3I+srMM8tMc6u0/9BqC64MUnPLrrok6KvOOxPIUwIO0uJNMMR4oIyyzhajTDJCEe2Ms6sCa/Syx0BTbLTQRmDuteKE66AC2HQ4Io81TGhN1AvMyIPE1TrgDQYddKhNU1FhjbU14PSTTrpeMKFPu1139c5U94Blj7xhg1UPPPnaAC/APfYD5KNV/lBDOwkDLDWV9g4pEFo09AuQQW7ZSKTCMcZgEBAEI3G2QtC+C1StjBjag8MVwlCEXhM3IuFFEpboMQkSysADChzPKmmFOj7xoqVU6mi0SC8WufYlOVwiQskuLL74pjTmgFKOKUMJWeRulHpnKS/D3AVNMsNa2WU1xWKTzbbgrDmuOP/trBnOvfiC86xFy4ps0EQNk2zoRBctlFGkM4MINCgS+wsKieZ9rYQTxsiDCldfVWENM2L44NUPWFWBOFiB29oEV5cTFYK2b6Mgtxim7oUccpLRNdfses3DO+/Q04i8YoE1I9hikUWDkvvORfCP6sRLRcBsn23vFP8APGQj6wwsEMBW8JBIol4wvERdc6m2kJIdBjKpoxTBGhCskurV1yLEDlHiPxLQCGl1DUgguIiERSACJcaIjCLiQWwiQo4mb7JJ4427oKP6jzvxKWQsk9JSqe+NGlP8l8uCOebTZFaNZp0nYH9PuuZU4IEHdF5rAp7xymCDEfwU7mikT9SSyWj/JiyOQhTQDJjAxjjtMwgZQfuCMwXSrI0EqtEXDIqzmtYwgAExMAMKstAqsb0KLhxkgGougKnirDBWcZMVrSJxK+pgp1eY+BuBKIEhDDmLhzvk4R8AkZ/CDfFApquO5g6EIASZyzrK4g+FMhGt/ahBDQeiBLdUUSHRKdF02WrFMFKRw+9s7hIL8U6JCFa7e+3BRadQQ4xWl4WL/CFHf2CBBoAAEh4khAjAUxFlFBaFlvAokDpJ0vOk56TnXa961mukTrA3iFFwr3tOYYqYxme+TJJPZjNbH/vcFyedvcZ+dQpAz2AjlkMZhmlgMcwAmaaoR7nggJgRjRemQIO1nIVs/6KZ4Nks0AA5yakBK+ylCmJQG7m5BW2v2lQKiZNCtzFHVhvEAHDMgIlb4I06NWyQIbzZoBs6CIjlJKI5eXhEcbaCOvup0HUykYplNU5yYHzQKjpXoGaFjllcPJ23kLi5XlxrnotbggjKcAhX8qiNb7SCQpPQHn3ZMQNe+MRG6uUFPxLhLwcLJBHqICQiAKliE6OYIqMXved5TEmL5BjHoOQIoOyCktAgnyZfVoLTEGYFOk2LpdTCgQiwZaifBGWdPkk/n2lQTqj8WWEK48qjvdJQkykaoGYpy1gqMKsLxCVkSuMoGABBglBYG3JgdTXabKA4JuiU1pzJVrKpQAW2mf9VCskmNrhRc6+i6gAV8tAK6YRTnN807Dh/iE7ForOJ8eQb3yIHuMVFMZ7O+gMqGCdP95wiF88CDyT2WdAveieMAR2GYykBCTwU4hRYQKi9CgKIY6xOCa2FY7wUsQcOvGAPK8hAGNgwEA5AbCAqWosGRLBaRlk0YSl5yUhPajFI5mRJS6KuSzU2BC5st2PY88lNwRtehpglfTQr6vqGilSavS8C6n2LX+CbgTz1jE9gMY1UxRoYqRpNaIchTFcBHGACJsoIoAlDLjMaGFJSwAbZzIMOLsVWKpSqDWwrzhS0xrVUuVUHdm3NbT5whSPUNYUOMPGJXSiq9jEAAyZoQ67/ZEhDBkGIQJK7RHdumNjFjvE7TixdF20InkPkIopArGxljZzZbZHkPkyWrOSA2ERILG62i7tPajmL2Sun9j4QW50I8Mgfj5ThtiMIgyrCwCd7ccBEGnCzRdWyiCq4+c1fLp4i6gCRjyaPz84j0hemS93pUY+7gpYDiMRLPkTry0zjRd+jZ6aW8xq1fjar9M0w4JfWmNKpZaGqAgeIGKP9T8ADZtlWaemYPyMEIvtTH1ygkJ9fbqACJDhBq5SpYgqowAykOcEIP8zB2yhgAHMb4QfYtpy4EXvYuDFhDPJgCLvxA2+6ymKNE2FjxP5Nx0bmNmNNZ84eJytBQU4ydxTk/6zJPg5afyjEulGL2igX+bL2lGeNMZvvG2I2h3qkiOli54UNeEGhI/CCKg5qkNMoggfHRcKXKWGHVMvAIGFAAmLsdfE+Oy+6FPMzkaar0kET+nqHTrTLFs3JTraJ0ud935129vJLizLmp8wfm6CqQOEcKjBhJbWpgR50Wxo4aujNIKckWJsKonWZzVQrbaS57GaDGK+0CUEIlD0/Z5vQhMBhlaegI53qRCIRZCf7fQ4rxh6uXcfg6ZWzpkzudyP53H9T7ZRPgfe7G/nc1nlyFFWrb1LI0++kRcW+7T7GgJHZzAJfQhh2yiI+Qd7gaqFz1L6AUZbsVkK57SOfkKBx5P8hz+MfN2TJU1rdlq6+CydXtMohXamf8smo76P0em2P6fji7+Y/W8EJej5e/gJGMhDhqtADnLRSq3qPCOEBKa22trNumFXDSRVTXYjXZ3L4CFvzcAWgeYRfn/gCtAEBbVAsbLvahQIfmDAVdDCFc0mHHN3MdmHxz+0es33tydrb/6/M28op8Oht73IotQww7qZs8ChL7xCQEg4vAi8HhxJPAhHvE6JIYQKDIBiivoIqqGjGzUQgBURABv4CzDhABi4OBdmCIIJmCEJPgPrspAJN9Qbtukwu5cKL0XYw9trkLIZKfSbt0toi94hQ9+JLvvCnffZHUGjjUYyG51wJ1Zb/hgqFrsCcr0/4hVtapYJWyK08RfycyTVsYDZs4wt5rcOSo+qQCcVM7AJ84A1mgK7G7wJ0QMRCZVRuTTb4cA3spv5kbDtubBApkHK+Q+2+bT4ey9wS62/mDu6mTAFVCxIHcAEt8QAxsQL3LRMvEAM/QdsExudAkPYojc5MkRRPsQUHYghQMAYtJnlMygtoMNAELfVSyvVwceV+EARfbQiPcOZ+EZTYBy+IUX9+xjT0K6okRTF+bvk2wwqv8DOSsQQ84Gp64zc0xS42ALDawGyA7QKssTg2Jdh4DZm+8QyXo9gGwAFCAJl47QpCgA1zLdi8TjZaRQUEi5vow+zyL1v0/2//ALKH/pHHKpASJTESEdIgL5ETH5AhHdLuNDGeJlDxjEa4hMuoTJEFOYAE14IEOZL2WJAEYfDiKMOQOK4GdaJ6mmSlchFNeNAlySst6gsVher2grFmjJDmasbliDF/IqAJTQP4CuPW8IuVlKYKoTHVqhCBCKysbgkISMALm27F/MrroO77Nk1+1O/q1ub89KrZim3q3tDqxCbqUixW9GoCTiAPesEWkgFvpIEf/XGcckyyioz/1E3HDhHL4g4B8xITA0/dAPMhCfMhTwIiOxEDc4tqKnIUP0kjRTAyVRHMUkAykasES1D0TlIWadHQLkYndLAlYe8HPXAmicomb/8yqY7KLWqylIgRAFCpp3pKGY/PGZNP+Wzz1Bwm5x6P1R5PGisILqpybNYGmcaP6XSjmEoM/MhmBmbDDeenHVUA6+Tn6lTAB7Cur4ZNHZepOAHrD23B/sCJQPymEPeS7/5y7Xzl2+wyhwTzIReSLwtzPjPhMDvxyDjL8BwEIcpil1TRJlPgI0GyI9diCETQI1MQBkuyM1NykVZKJUWzB3VR9s7iP1HTJs/L5d7kvdaiqNrLAnqSL35yBEIgMIgyN1E0RaNRggLlBcowa6aA6WoNsNYAwtoP2U5ANswAbODmwvCQNSAgheJwBrKTOR4AAnzgCqbTxNbRAezwa0iMSXX/g+vmQlTKkK5q5W7CU2/68cfcUz050RDU7d0ikT4d8jBZAQLVNE3tkxLYtE3v0/DiFN+w7SDGIOEq1EJRMECPSwQt0qgEFDNLcCRBjkFXKiWrJ0IldBf9s1JG9DQvNFKBsX1UUwlDdKn8JFMdw0+SslOPMoF+8wWA0MwOAQqODjaus8NoDW2cIA/MwBvbxgTgTwVAQNnW8QRmADvjEcWKlNnCcgZEjK7MUW64U+raj9fIRUcjgZvs77BwDMd0KFr/MRERcy8b8lrXtDDRNCLldE4jsD7pkk5VIRFy66A8ME//9JME9DFPkPYMdAjg1b8YtORwMAcVdTQ9SS0qVPbO/+vVJPUmcSaYRkl9eC8B3KIJNXWWONVTka82vcqBOEAueOdOcW1TUAVWtPJGka36xJGtgm07B6D8ptPqrs5ItS5uyM/EQmAG1kALUOBtpE5+iDWYOOwE2i8PbIWbBpFX4lRa61JOrbUgzXRbibZo7dMCu7UQPbFbta3Grq23jJFR/3RdCXQjLZMtwAIkMxMwVoBeQ+66Wq9lJu5eY3JfP3BAz5Ym//X2KNXS6md+4ORDC5ZSj1FTKUhFGTa//GsxGAgKAoUJ0SeCbIA4PFY4m2ljp4Cu0CpjU+zErHNkqdMNgxSv3gYEQAAF4tGuCIAB7FAHZhYBqrQ6d5Qt70Yamv+VO/7Ghi4QE/sxaYUWMN8UTsG1aA0zTr91djtxArHt2qBgl/JVI9viIzkSQdlCJPuzXQd1CFZAeU8SkqTrejaJbGNPa/X0Qn1xbQHWbVGDLkJUAkaUfzI1YfG2YZNv9HouUjTtJ31JcMeAClZVDztla2gN2abACeDPfj/gZFU2Vanz6uLwDVTAZN8mBHzAB1AABC4AAootSKUzf28D/WR2r9iRD7PGFkpXVwyLZ1HXW3EXXCeyg0E4WxlwhJG2hEH4W2fBhHVXXGmMXCXvXFnuBIe3eD9JA6h2eQcVLJRXecuCUFXKkHJib3FqUcsWXWlGX8/WX7EXNTk0lN5rRNP/qwBgsxgRNnzH94pBjee8ShqDA3dqVK504BC+WK5YQwe45dfeF/ycoBFsgQ9sFvyWg4CVNHJVNg65kvwyV3PDEgJmwBCUNJm0D6+ysdk2AFkTd/7g8hh4VoM5WCIt8HYhmYRPIpLV9IRxV4Upmchul8asw8YkAiIidk8sKIYt1Gqtlk/VNQWRWIdX0fdGsixaynmWxAtwkYhl8jRU0TGPWG2XuJcNtwJoTy4KwOZ6LyrF12GRMm+b8XwRgjROwzQuxQJCLMPORvuWY1XlJ0dflSxPrALo+GTl5wquAARoNTtBVh33OHOvcw0iYQ3yNx21Mp43IEedYHBtIBHuRh+7/4OwEE8QJxCT6xOgBdqSB/p2NVki+7F3JMM130d9fPmIP7KVO+o0eLiiNe4mWgJjMEYDaxkm0WRCj/hPK4V6dfmhbzJDM0CpOpShi/F7rVFQ9GuZkxk3ybcGyARSjC9PqUm+IoAGfI1VgA0t26ZtyLLEGJdxHyBzpXM61+8B1NEB1rFJ1/ECQOBrXAU3xHJ+Fvgr73kVYqh084aRJfCfx1rf8K2gCfqDydoT17qsL2etc4FvTEehqTHTVmy+jFBtqbZqTZmvLfI0IM23svY0SBIsXFG6KOZlTi16PbpsSbp6HVOJTTp7nXiUqIn3jFGneOP3RK0jgM8okdlTxxano/9GYG2Pr+ZZWM1KhNaQ1orzK3H0194ZOrUO2RK4/NrRB4IAO2FWctNPY6EOZbVaqjMWR8kmm96y2uT6rfHvrR2ZuR85rScZrWfXrcV1xmzI3NgAKu36rk2oJ5v4oW9YuHiYoim6ogFDBpXkFWmpo8cHpFlQl43YNFGzpHvZQ4NpT5RqqPhbqPZiim1vf3xKs/VLKENbmUd7MBrooKBPqNgKNpygfW+NVdYgD964Y23gDWzhDcbgwsXm1nY0SpUNDt8AHt9mgFEgV83Zt3tbOZvz/PSYHUvWSOOZxTpgYDDhLcWuk7MsP23Mua0bujGZuof83n68afHDrEgAA+7HAKj/lIM218mLsdJQE5Vn+D8FdULT+wVDr2s1ur0Z25bhu5T19TEle7JTOhjr5AHuQr7S3MGLCrNHeTaP+cCxWDdxmtVeo6c1ZApow35ZG5u22ZnIBg/tStm8JhBqFCsjQFhnW+uQNAhotcVbfOoml5zLmStnHJ63jsGwwIwxoXSP4RiKQXKEvMdR3dSDvKCtWz/f+tVV4d4iAaA0YnC397u/W8p1Xcrz+qHj+68HO7AH1QWXl3mRwNhjUHrXZMzTlZeNWIntG83RCyfZK275hDmEOQCmOJiakPju3M4T/BkTozejhpf6XKdobX5Z4wA+wFW9b1U9NjdkdtjIhmSZ2mT1/1d/Cdhyz4/ShfsNURYEklQMfCDr0k/YboNuYiDTssBupEEcFJkXVv2t41rVX/3wNPni3XriYV3Vs6g6Yl1zlNwDmkrXodwAQpQAurdtqRxQb0+4cLmjdotrufYwin15jz3ZF9u9zQS+R/Gvfbd6aa9fpb0trpfNd9J730JDV76+ShQsFramwX3nleZpfDOsIqyaTkj6VAD+TgCbEf7f4/g6nWBJtQ7fWfz8zu+b/T0sy88HzF7sl4mDutsCSOBxRr3ULf7iM17j/f5yVmGsA5/vOz7VO14VesxvWWA1mhx0d10AVB7lI3/yidG9Wn5tYR4ksxYzab7zdZgIjB2m7/81Kid0f/6CXXfZP0u56G/vvA6ATnKGNVkalfbn6kT/22/TMa7qKYsGP2z91ovbbXD71ugqOBhdZJV07O237K9zxWl7frx57cUmq/+df7lyHlWM7lNJjvaDx/f+772f4g1/48P/+w8/3IyP5PMi1x8f8t2f8uE/9i8/UkX6eIHd83W4vLvc5sMcIHYIHNiioMGDKxKOWMiwoYiHDTlIXCiRw4iJFitq3MixY4aPHSN4BBkSpIWTJyOI3CBRgoQCMAtMyLChZsISLF7o3Mmzp8+cNIL+dEF0KIsVRFbYSGhjyZSgexLtCTOlagmVFGp+6FChgw4nR6ic+HCCypo1Oij/YK1QQcVZPk5CsH1AN4STRozeqJjroC+EvnQDh1ARIgQIECUuNAC8mPEFEFfeXCGsggoVHSQoKFi8wUSMLG0OZRqNKdUq07xQn0Z9qjWqXK5Zx0ZFe7Zt2K1Xt74kO9WlQ1NfXDzpMqZxAsiTC1jOXLlzmTNRkhzJIcVIiNizJ7SosLt370m7Ezw4vvz47w7Te8C+fjhDj+4zxqdOv/50kSalf9T/Ef+DA8dJwB1OBBpl4IEI0oCUUDws4cUSNDgVhg1TAJKHDlyxNYUZZqjQwQmEmbBVByTOkAcKW/Flgg5y8bXYABectcYMIv5lo42AQQDCDEH4AIIKIV6AY46A/41YgQIlmHFIhydQiMYhhpS2Siux9SYbbqbVdpttXJ6CZW6+tSImlbwBkkUNmRFXXAIBPtfcm2+yaYBL0Wlg53UcQYTRRBRdlB56CikIKHjmFYrDoTkgRMKif2r3np4UZZTnRCxpNJ99mGaqX3T6bYCfBS8ZZ4FNCxXYU1GLmmogUDzktCCDCkIolA0NTgHhCFXZsOJlNYLoBIYkCsnXADUAwqSIjb24WbIQPHYBWSAUNiRd0wJprbWITdvAAP8pcFJnSmISCW+XYNKKuGFa6WWWXar7Wm9falllaeT+dmaaDBigr5wA8nuccwAIAEDAAb+55kwCTmcdfPJlx90KfP/++fCgQQFasaEYK4peo44+Gt+ll2o6XX8ie7QpqC5l4F9NEawZAHQ0lQqUqqjWnCBPryZ6casR1hpUhU6MuOsJnnblorLcbvUskCIq9sCzKdoobF/PGuZDCIrhyG1gEAx2xRU0gvhj1A5kTdZXgKA7ppiJpDKub+7OG3eVqdVdN5ip5YKluMDx6gGo/iIgeL+EuynwwIgPHGcCDEzA+AJqjlzRwhg9VHlDG2NOMUOb75wxohp7x7F6ekoK8qQlS6566vkh3GlNnmYQKkwp20QzqqbOrPvuNzPolIM9F13TCRwCq1aGyTLQGAUXePaVDyr44IPSZv81dV+D9Rittlz/N+8hWyF8ba1lHCqZR5Tnjpmu3PDiFm9sesPdLt3xr/sHGlCU4Knjge9b+MuLS5wAEbc4133kTqor3Z4iprlGNVA8N9lcQj4HugqGbnSkC1nIJFWRDbLugwm7k4BCKJ2VsMRlMGsP71K1Qt7xDFaeg+GsHLSQlajEW2aIRB7AYgaxuOhZXfmAClDEFiGaYQ3TK6L1mqWtrl0LBNdrImeOEIkqWvGK5ZKSbsg1v7upSzdfOo37xmi31GQCD2ooQw3+lq82+u+NcGyO4gY4wAAMwGCNqxN/ELjAPD0wc93hHHoERTEKfo5RiMRgx/jUwQVGwE8fXF0kW7cfOvGHZbJDgOFMZHa7Tu7EVS6M4cVo1aqm6GoEa/nbBsj3NR0SbS5Va1oMPMQVb32AClcYCxCFtcRkNU96KgCBj+Tyl8IEZlkNuIAO1nBFcb0ti+hinyrWNzfavG9dXZQNHs5QhRtggH9xDKc46UjOABSsOXncoyQvZzo/aW4IfxQkeDqHlIAAACH5BAQEAP8ALAAAAADgAQ4Bhx8PASoXCS0VBi4lEC8YBjMZBjMcCzcZBzcgDjkqFjoiDTokCjokEjszHD03Iz4uID9BK0MvIUYlDEcdBkczHEg5JEhCLEkrFUxIMlUsFlc7JFgnC1hDK1hLNFkxDlkzG1osFlpSO1xYQlxiSGU1Gmg6JGlEK2lMM2lTOmlbQ2lkS2tBGm0xC3I9JnNwVXRFKnRUPHRbQnVFJ3VJLHVLM3c8FneednhKM3hZO3jHk3lGJnlGKnlSLXljSHmOaHmziXpDGnpJK3pMNHp9YntcQntgPHxTOn5SNYE/DoJONIRTNoRVOoVbQoZPM4ZYN4ZZOodLKIhFD4hIGIhmSIh9Y4lWNolWOYliPYmHaYpsUop0V4tTKYtZNYtaO4xyTY2Uco/GmpGtipJNGJNOJJOcgpReQZVbOZZtUpaXdpdjOpdoR5eEW5eHaJhXKZjNo5lVG5lyTZl2VpmjeZp9YpxiLKJbNKNcHaNdJaNsSKVuTaZ9Yad0Sqd6V6hhHqhpN6iXdqmDXKmleqnFmqplKKqHZqyRbq1xO62xjbC8orGcg7HTsbN9V7RrLLRtM7VuNbaFWrd6R7eohrfivLiLZbike7l2ObmQXbmYdbqSa7tzLbx0NLyCSrywe73kwb6BPsGOcsJ6LsJ/UcKNZ8N7NcN+RMR7OMR8OsWVa8WegcaadceKVsejesinhcmDO8m1kcqCNsqISMuSWsu8osyEO8yFQ86RS86pc8/iutCGPtDPrtDdxNHkx9KLPtKOU9OddNPEmtSMQ9SNSdaRRNaSS9ebZteldteqhde5ldiRP9iWVtija9mzi9qTRdyVSt2aU92iW96ZTOCaR+GXSuOcTeOdWuOeYuSdUuWjW+ahUuaqXeasduehTuemZuifUeiiT+i2iOndw+ukVOulWuuzeOvGl+yxXuy6jOzCe+2pVe2qW+2rY+2zZ+7SqvCmWPGtcvGuafKrVvKtY/OtW/WxXfWzY/XrzvbLlPe3afe7dPfiufizXvnIhvvAb/vDeP786f//8Qj/AL+t4lMFEzl77A7aU8gwX8KF9s6t8UTnSsWLbbho3Jhxi0aPILdAGQmlTR08dfzUaTNGjJSXbwY5qgQL2LBkzqzp3Mlzms+fQLsJbTeUqFF58ZIqXfeu6b2nUI82C0ZVWk+dOIGZ2lqqFLVepEhJCxbWKimjQ62qvcr2GbS3cIUxGyYXGa9advNODRquLV+e4gIb5aYuabvCS5Empue0MVR8kPvtk9zvqeDLiAUXPXy0s+fD1dRRI5ztmunSmdOVfoZ3VqtMsBm1gnbadE5ss/r0oRX4ds+9a4MG97sTOHGho1MvdfeU+T3CO51Gpjy5uvXr+EgXjmxZe2rv905h/1LDBdO38+bSkzNnbx/E9wvPWaKDMY1G+hU5fhTJg8dLkiWdBElKK93xhhgHyrRJLzj5hg1b20T4V1qbebacY481JpRxPzWoFlddjdWVWEKRqJZRYw2nYnFx5RQXXnrdVRdcFEK4ImagKbeYjhc6h48501VWmFDeDWlbdFJ5lhxng4VWW5HW0OVabJm80gpeDx45TWCa2DHIMKL5FlwzQIl5I1scTjgacmtWs6SGS/EkXZDYWacekN5B1pSROBb5DhxwOJEGJqcQYskly7DnHjmSwbfQOpZYlAZ9kmLE0qVb0AHSfyNJ0ZJJBWJ6h4I1NUjNcRL+1Jc3qVq4o2OwMv8ma5h7eUjmqTrRAiKDI5YlVlljVpXmihzOBaOMx85I3JmA4eiqatDyeCGdQuYYLY5s9rZmtm1ui+uTq7ml1WujxObJlbSF6yKumcTUDK2/0UjsXyrONe9w3mb7Ha5WZTPtONzdGaSeyfm4Z77dolbYFUfosAcmgDixRR6sKMoowI72Y8saleLXEReaYhoSp/8h0VKoMb3RBqkMfltbljDHXGFfTC4WlVLOxaphrrbaVJyuoATNq2y9kiVsiQymOGa8xgEXo4wxqkmvvKtelvCz1776WJDdOWt1jWBzy6+ZR9ZSkyawtaK2TTc987KLYIrGSBSMvDv2vUozzbS9ty7/jarYKLaMGWJNcWc4wHpy4wxhiPP5NsKmOcFDeavgsYIHXKzy3j7a2HJOoxDJpxKlmYZMX6YhjSwSp2OkxIhMrzMyU6kOvlz17bjjrthSW+vJXM5a40rX8E0DDUojZ4USe9G/mrhh3sGuRfxeMyabF9R4Cye1tm9CKS3hvfsu7ddh/w2308mcba7P6yp8KvGmIdPHG5rkW2b02XeI/bD5u/ztWn0C3+/W4TuAMeVbSclOmLR0nGesAAhwWEUx8MACzPlic537XHtCt4lJeWw/IDGdylBHH5nAbiZbCYsKaXG0E9kudzCkWc1mBRXquAdI4ttRYKZXF7a5BkQqnJ+X/1Yolrk4T2l8Kx4PnfY0qGHPRvyDEFqI0j3vBBA8GbrZvshXPigqURg1UVslxnium1wRG1KinThmEZNWhCuK+Itjru4Cvfwx625tmiH4BHgwrBCmazAj2/ne4gEgPGIZywAEEFjgh2Jsjim24MeiImKLTYzug6W7lMpK6AdD0CSMoKyKKI2VNHzF8JQy1BpkLIadHMZJeGkcUdq6grxQpE+IspEGEZOYIh+yDX1LHJ71qhc17fUPcnn02hmnRcMtchGPxkSiL1tzLrStDRs6go4zeqhGULRRW1STIxx/QkdxmvOYSnJfYbTjpAZZUW/yktfkTrEPc4wnDYd8ZDk8B/+6yVgSPyDzmMc62UmaqCIWtdimh3o2ylECkIuopJnWGBOZ61TncDtjYrmoFDSimQWXW9HlLtk3ll/yEphLtIuVnEjMeKL0jsgknzIH96psQpRNe2uoTVjIwldYk4WLU82e2PkgnvKUKqVpVx/sBk87Rq+cdRxncGwVVVNG54X+0wlRB+nSFkFDDZDQxkI6dwqxPlIZbvtcPz5XjFoY4pKDiCtBO3muTSwIFghdKEOnaVKrRlR3nFFlRVtpOEBSj1yZiKtiiVaNUJBifmIgGhFJMS5p2quvmOVma1jKTbtU9Zzmk9kL1fk9x830QV09LF9/KMYrua1H2oxSGoFqxmb/zC8T6UotaLkKRsy+FJgMZajfjJkTtwHGf3z6rFfjYglifGOD65kkZdZh3HKU43PlYI1dN0FGT5BRV9ulnSD3yteTRuimp1QKPCbqo8jgEKM3Q+24OLo8UriJFK9rowp7hQtTRK2zTSxvb1nLWc4OCxlVRc5DQwu4me4ua9e6nW4B7Mu1JdRfBHTM2IxG26MFww70C+SEdzuV/voWiVUt5VP7SmK9/W+cwWRGLIihjfPUWBs4/oY2mELdGZvKbcnIK4MOaraaGLnIZqttigV84lT+NZU1fZXhKsOPwsY3lq2lZSlC0VjI2mHL+5VlV5gcYDLfxcIU/m8vEXzSXjyv/4FZPa7LsIYUB69qwqvVFZpHk0WlbNhoSmYfLQ70iiwp99DBquyhzUtVy7IY0ak9Giw9vNwWyWXGaOUGMdCKE2I0CMmgxpJegzxkUFe60UnMc1/Rkc6ZOfnBUQZf+ODLmNKoNszUcKyXwRxm/uJC1WYuMi/WNuwCG/ikbCYlqqHZqu3pa1t25mKkAcxapKYDeK/ECq94ujiF4vVUpvimbCEt1RL/Gtm/PbCjm3zqdJOX0l+si6fRyulPCxNGquUqbwEMR51WVsDhqDN6AQvrgu9RVrO2Mq2qEhYt43fXkwWif4GtlYoDm9jGLjO5y93sv53STa1mYLqxzNPX6kxxf/8+muK47aYufakvI2f0iktxbnQDE8XwNlaycX5zlD5a5zy3uVzgJq6bwM/SySq6zHWe2ao8r4g7Zca5TcxSVoU8bHpMjB6j1cyEG5ZMju1KH2SXXwT1qtdFq7BrqF5gUGKc2G8BMM13bpbnqbvnzu5ig2Mq8pivOsNaXCCL4HekEL2PEe5Szcb9vlK6Cz3VSJw401NN0sf/fM1SD7rPSQrkfU+v2Ldit0/SLHWo250qav/12kFfMyXVaOuwh3DW+3zl24Qlv6MCsZfOjvajpp7tqwc9gTFOzJVO/fKUXzxxcar3vfcdzzw0DcJ3hsejF3cYtOw0MAaR+HHjfePB17z/5Znoy/82ffLBzvzjR1795fJ7GuXnm3zfv8LgmH6nwA9/6081xZnpUL0AGGGOQ0N9pi1hR3a4N3Yh0nspdHHFxlIPOHz7E4HGJ3lmAXU6FXO6lXdxJjbtp4HpAnha9IFGVytgARvBsCa5EWIbpnyWNQqNl3wymHNrdmwmdX7o54BqtnkkdWfTNmDSo349iHlJ1IAz928RyHqG0X+vF3sGJ3DoxXVdtxrd4HC0dFu8p2e+hnr4R4Fe+IVVh2UxiAw0t2JKc0QvsnToxGCDlya1ozBdYyRmEmNZETspCG6ERoLid2AwWHM3mH5acYZkeD1zh2JeMXeA6F+6ZBaKqIhB/2ci9tI8t+KD7tdDVjJ48ReEyTdxRXN6O+VfnDh3MNgNS8iEfOGEASiA6fWECyc7III2rqhCpaSFvuKAYwiGTac2FUhzhShSi2gWv0iE66dcHRhamkgmfQMuPLZFnsdDvBJXYnF44uaCPVcufahx2Kh+FggiCHaIZegVv2hmoNiIiziOjFhSwziKTYV0rLchXOiHnphqQIRgT4eOn7gVqudTpkCKpWiKOjF7rKiKoyV7fHJ7syRxwChsDVeLqvZ2xUZsxHdSw6ePvJhsnAiM5fgr5qeGMLUsjTaHP3ZwfRRb53Nv+EZNjSATF5Y+iHcHd7iHMFliQXN8GVeTjQiKKv91PSV1iOH4hxW3kxI3IoYojIJIWYpGiT94iTuUg5WnZjipS2S4j6eHj/nXX+DYj/azJYGViv8XYX8lkKbgioMYcRH3U75ni7oIkcJnfWCUlrsIjkMpeRhIekInR1A0avr2hgdHGmVjb/7GTYk1CNEojS4pGKBlcxRJkxC4mOX3izg5Ijppj5JpUlQZUhjJi2Jmj5cHdUKDFtEUFw9IIUy5Fg3HS48ZlYu4IWdplVY5k/zoes2ylQEJhdgiWqcFDaUgWSnUe5WAgDLxSapwZDM4YF4Id8UihvqoUpbpiwg5mWQWkzCFl20IGH7yHZ7ml38JI2bjci/nJrrEfV8SD97/iZHQuRf9lTZVyZj5WHpRB5nKiZrdGCI5+Y5TZ44ZqUveKJSOaJpcaESkEDT9gpSVuHbgNJpB6If4OJaYSZrs2ZpWYo2jIA1YiZQBF2v68IReE5sDKQ7Yd5CcGGZllyCddJbBZD3Bx3Yc+ZCJGYwMypxrtpo46FDK9z7J+GMaCiXOcJ05QWppFGrt6QktiVu18ViR5Wa55mggqBXomZ7paZnjYmKi6J5jJqVjuVpRWZlAKUvnuI0uanE2MYqGkSrRwIcEGjjkl4vwyY3KCZddOGwz+aCduSf++I9duTsXOqHQwmq2qUy0sKTN02tlFwWCKpiOVRPBuWxgB4Sr2W9Y/3alvXiO98mQgOicSoOoy2YqbWE1iqNNo8aFwhlKwwak4DkLP0YKCSI4SzacUrekKvqWE5mT3IiZFVmR8Bmf89mq+omf8qmr5CmXPXmawlChAup+ZRqPmbiTjpel7jl69winzgp7V/FgsHenXOmVexphEPqnuxlE3HcgQCAFggkJslhKegiCbbhZKxpSwFKOQCmpJzp5c4l8UUWjNlqvbcKXnYedJqmQRvWgQlRo+VoKCFI3X2FLLJqdTnOeb5qPrlqVlSlxg3il74maoph6UxqUYhaU/qmrpRkWPyms60iIzKCn+mOgEstm5Limu2qPsRo0AMqVzIeK1DoP1epk5/9VXX0iDCionf26kJc0BkjgKZ40tOL6K+RaXPkKkh/5bqxZCkX4ou7ar22HsOyXlzYKcveqaUSnr54KqqFqV4mlX/5TCS5BsDgRdpTan4d1PC6Lq7s4kRj7sFGZphUrq70kt46asRnLsVAZUk/KjRIqDxKmPZdVbFZXsoVrYiw7lnFZq1Dbh13RtjV7irM5s/SwXrRZNTQykLwgO2r3K7k5Eyk5OjVQA56iSSvzm0VLC0SGF0Jmr3LmP8LUsx1bhRqprUZ5ojDqpTKKjCXpdLDrnZ12NW5hKkLGszDqdmIEnshzXGBRtqVWnoWbmy47q8nplnCrt/j5nlMKCgpapd7/27IaS7Hgq6XzuLcRWyFelHmGS7JnGpmEWIg3KZePam4OWr1nIac1Q7nTSoDUepsyk6dhiS4clmUpOborsQVIULr/4RIw0TqgUkKNQLRFe1et+2Pt5CT1Fr3auJ+OJSIeS5X5h5O1CBafSodUMWTDu2kZ7CYsrME6yrWzRaJhdC6v0a3NK7uOIKij0DIGG45z+YKD8KaQKavYm72Z2bLzuaDkW7eVCat6u4AcG6tPzMRzeoyN576Wdlm7CqVYeobNWSJ/K2Yv+w6bIZ4aymoB2UyZa621AS1KSlu0SEujO7pmoMAsYLqrEwWmG7SC6sAIAsGXwkkFNRMV3Lo6uqkh/5kivGJLH8yuvUa7FTeuJ8zBltwyyfDCbuIOfKnBLpzJ9pY0Xbu797idiiWYAcomvXAHgloHQ8auQviHO6kb4Xu/4uuqUWzEa6qg1ku3TKy33JvLGRm34Disbdig0aDFzDq9bBqxj7qfFFuGd+uskbtlnIFAdUanagxh/tvGGXqzVkMuzYo2sBg7CNwGUsDAqUsfJePHffwSfxzII9Q6gqwSc4UHoru6R3aoGdwOj1yoo9yzBdxhpVZqLezJm7xjzJHQONbQOFYN2uDCbhK9Bb3PFg2q6iNX34ZcocDKdMMgP9yTXTi9rgiDIkzMKA3MsuqozszLK13EuRzTMm3ETv+7fMc8nwUadIorIvFLwuaYmRty0nsbpjqBp9vMzbNScK+meLG5DripCbRbzrnnOglcAywgtOH1s/DMwPD8x/5xIFAAyC0h1p+CIK5TXx7rWMnULz/MK12bwhTNo6DM0JxsQACjY+4wDjqG1zfW1w5dDA/tC5x2yRcd0GcGC72ZurSAtP7T0YJKWdUHzbG8Ufg700fMWnubn5jpvSorsZY9sTPNsXkbxS6I00wdaV2speQLwuXbzLbMtsHQR3QqK0ddGkdtcLW2f278xk/qdjOhWAlSB5DgCNzHx0CwBX6wIAhVE5b02+iczqWbx9863dPNx9a9wHp8umUdyFOde8j/Uxb/Y0sTjclxTdgtwzgOfdd2/Q0/cifoUdfpjWO+0DmCvWkIRWT4jVdEZqhubdGiegeacN5Ya4CDELT2VQ1GCskR+6Og0AcLe78OetkpDdNQPNrmS9rWu4ATbtldbC+fORdj2Bv387iYR6VPCcWd2Q1S56ZiNsT5S0W3ArNLXXBJvV4zfiTbzAufRIuxo3teIhvKIwZWDa6GsM8mrD4p6a3GTd0PVLrv7OR+vN0PLM8IonuwA2a6ZLDCq30JI9ErjN51jdfvvdfqnR7vbQyA3TloLtj0Xd+ehlCPcN9xnt/HW9DbpVimcFCanDCPZeDtRBQpIpcxUtm72bSGjr0b/17E1UuGRMzZvTyOHJ7ooU13Ijamlj6xxqxRs8DFcLuWKuqyQY12oesVSbHlCWQZ3syKNX5aX4PZIJKAujc7dRAFeUzkF+xt2+ldfhBXoiLke9zVJOPO8TzlVZ57xl7SY8bPBz1AzM7sBmRjYq5jxoAe1G5jDS3YgJ3t2L5pvnAKxCAelqAKj2AJcy7u+33Brns2zCveAn6v6fPcXhHRk6aeiUXo5/uwkp6t+k7Enk3N976bkT7TEGrSVVfpoBl8mb62m26/na6YLB3qrxiYdXPNJTh9lVuntS2QYYLvsBhXCUIqjt3KRb6SnTcVCklGb/VWnMTr9HHHEezAwy7PVv/u3Whz1ihEWcruycy+SmYO7TdmY2iuDUGP5t9A9NIu9Nie9EqvDN4uHqcg57EQ7gcl9fpd0Pc93KlLZBJNVGgFC94aVpw87xC4FcjeU/h+9vm+7ysVvlPq7zSN9mlfzfZOq1AVTdyLDAk/phHIvs4qgWpXzSgSlC0ZChTvTgVYrRifp8KqinqmhR3/8SDf51EQE2p0073lduHlXeIqrjUMC45F3AZyIKKfMrH+3YCqQo61CPzM7cqQ3j1P7dee7UK/5r6w5kJ/+52D9Evv9OLx7d7e7b0vCsIf7nEe5xaM30KmCmSk58Qg3oRxnfXmB/AM9iSZWWRvll8at0i8rX//Osbbn+G3/PYBP/5P7OGWT2AG/4ILz/cN7/CAT0WiTstuFvaTeOpQMYX4v+rRZg3qChCmBJpyNOjOmzsGG1UipSoUpDFRxNxhmMyiM2zTNELjGC1aLWEgnYkEWdJkrF4pLarsRYpgI0YwC8IEpamUS4c4b4ZypBPWw1ApYxGr5kvbUaRIvyX11dRpsadRjU01FjWV01OitGbN6usUsaZctcYSpcrSI7RmHa5F2XZtsmq9iFajy83uNWrKlMXyI8UvJG743NG11swwM2CJEeMaVZOW4mCRJT8mBQxn4seWSUmT5pIzNdChRXM+vBhZqdPITt/ExXjWwNcDXQp0fdO2/2zcuW/b3N07tuptG4WXXv1qFjKN4botL0y6NGuPmI3/nk5d+u7l7brptK2pjxhGm9vF0/5Z3Lt7gtWnp9ee/Lr37uW/TycOnXK89bPdJd9Sek9NYEooofBgscahQSSiyJRhCssouOE8yia6Z7YB7hlhoKnwIow69DC0lYYRccTJRPxJJ0d6gsQQSFr86RGtwLLqKKu+kgqrYqjSsaqnxBprErH08sqrIE9R66y1NtnkESWVVIUoYlB6aK668qpQL1Xo8GsMP5RRz67hJrMtstFG4vDMD0Vrpy532nTTTbvU0c8+5hx0jrMSISuxMj4p4w4ooLjzLTdaZjPuQgg7iv9OteqQw69OOxeDzjBeqKvu0uMyHagmZLSjJtDu+rDDDka6IQ8058bDpx9WW2VvPvRenW/O/Ow7dTxxKr3uJgFHLTAlUhgRIwpSGTTvwUQ9SlbZRZmt9Vk5bYX22TqH4S4PbPfQVtsWWzRLlCjd+iSVrcot16oba/zEXHZlvAoqeG2BSiy06nWRSSS5gnIuN5XB60pY2gBiYDpiGUewuyKNbEy6kHozsMHuividONl8+OKL43QTPnf0iSdWiqvEFb2L6ZOzmjWrrBJQUP/8qdDMXEM0TNMuPTZS5yo9lFJMe/5t15twBc3QABnxVZqOPSXzPPVcXe8ejmWFelY6qzb/2RmBrG2l6Jl81QQWoUqxQ0Fj1fQmUbTPhrDC4CZsez9ao5VnbrrlnvPqznDqCQ9tDeF72zxaXGRwwmHUCi12T3l3cXRx9NFcsrpSXN4ctTFGm294tCUrs5gU/F58I98X84ivdIYYiAYGYgvAzEG42pFgpgW0N48iWWOIqyldZTZ57/0o3N9Uz3Vzij/Y+OKTV375b5hXvk3dfZc+RNWqpxmxmhtNDtU7Jd0Z6OkaY8264oLWDlRejUaoFKFT/XjVfVp1GuT0nqY6NP3o01prm1JUf8En9aIgEwlPM2h3K7UtS4Fvu4+05mGy+EBQgnjTGyTyYAg/8M0QafBbtjxY/7hJEM5cixvXVRiHFXKVMHGTYGFX0pUjqtCISPXag+cA8TmH7Et30HuGv7DUFxbUQIgFG4c5QlYmlYxOL0RpCxNVEpSWJIllU5wSW/Y1Ooe5yXnJs8cWvfhFL+6DeK4TjPUQcz3s6UpnlbpZ92rTmpC80Ti38RlnbuOo8xGtaEfz1J3C0R75BfJVTbOffKwGQchsjWv/68lKxgaepdmtgW5LWyUn+UBMzqpuHtskJuHxSU8qjRSf+1sG1XDKv32wcItooQtNWCQTonCFrDyLJbZCrhM+hXKamyENCSc4K+6wdD8UAwuMaUwpQMIXSwFewkKEEs/5LYODyOCK/FAHbP9mE5vDEsMYvBmRb4azm1zKpiMCB0y22EgZmGseGM3RxXe+s4vwtAc9uTjPeuZTn/ssHnEOIxwzVk97dsLZGkeRKfD5rBU6u+NNOJPH3vyPfX28GT3gJ8g21Y+QUovbx+hznGYUapHqKxA1gtGIN0yEFCiT5CQT+NIGQuiSnaRpKDlpU5t6KlCAw0MafIpKD2aLD0NtpQofN8J1JZVdLOwc4mwkuaNODoaX6+UvPzc4sxClmfuCCAs28NUNBJELm8iiNpYYpWBdk5uqA0IQkfBWuMI1iMeka12N+dVjhhWZb5XCN7lAB59WE6tbIUuUmmJWeCHWGJlj7FSa51jmHaX/ncUTI2WXhz3M+jON1VsjL5jRxo0kRqHjs9RoU2O+dgBlNxKlBgKZY8BrrOOi85PtRgt5yNuFVEyLPJojicU+llotpmcbbnGJiw6c1jS5yg0lqpKkLaBGN6hCLerjorrUFoYQcdsF0lM/AQieagsQMEoFKqpiXiIdbnA1RGdWkXJWSJghCmClLwtYdxWzGklJjqjDsOq6ArYOjK9+icKACVxgBEdhrl6l7wYmUF+3CrEFA9MBFCy8BS5kWMMarsPfOtxTU3pYxNgM3Dkt+DlIDEXFho2SVjL72RdvNo4yA0b3AGra0ZKWQeVzaMe2E1GSSqN9r21QNuoXv/hNjX62/1Uy3G73ju3ETJE1MUixVAKKiYAiGGZ7FExd+mVQLlfMmmSu0p67reie8gzYWnMc9KCH6ioVE3KeZS3r5cs4p/ARe1DzFK7gZzUQNYXjSq9DrAoJpuYwetxAicAYDNYJRNoDW4DDUHsqML/8F8HeHNUdyuk/mTQEffzlkjcJnNevPtirq65BhCVcAxlIuMIVJvCFt2RrcFoYCba+cBNwfWHAtsEMwjYDB6/phxhrNsadhbGNLTPHHEfboaeZzWhyE6BOh2LIsEsHP1qVZI5pTGpNdrKSrZEZkEyZkZM5yCDE01pPgVneMw3zmO19bxCd+W9pVvNQ39xdo9I5uywkOP/B77xKp875lYBQwxWUEASIz4AHEp+Cm7uLCkKbUBS/ZC9WsxquUNQBCY92sIMjLQEPwHpgdmWBgqgZE0icCFAsoTlLoDjFPGwzIm/N639JYEwSCDHorwawhN/66rgiYcITRrrRmS7rgUlBBwG+dbKVravNwrHZd5KjGkuLY4fKBt55i6io+vDueCfLyN4WpN0i2OSR0U+3PKtEJqjsqyuvb8v4w9W8G1hvwIc58JkU8+BB2b6URBO6fe63v+GscIHP2eCT5+7BQSh5OfPhChAnwQc8/3kT0IAJWfD3IjCecXL5sr1r6SkUGHzXBscer0IkoCnekpJ8i4YwZSqTtqn/yN9smvrULBe6hFnw86YnX+lGF+LRmf90ohef+VZftmezZ33DEBlocIyNtKGdNbHHgzB6xPaotAwp7nHkGXI6MqugVjG5TdCjuX0MNNKtyCrb4fymUEgks+N3wbs3wzM8wiPAWxkaQ0Oznuo3N3s8zKM8CEQ4ywMvSxOvViovTAAvJwAwD+jAC/jAC+hADRA90hsqOdO4BNyDq8KqOoACJPiqCRu6V4M9vaqBvqKmTSCJNLEG3eM9guq9h+iMZMC5FcEmYQMnIbIrD2A5ukrC5IswV2u6nzu+KDS+Ftg66sO65+A+MuE6OuK+rwtD8ekNeCuPTfEfsyuV4EK/B1k//7ZDsvebFvmTFXT7j0yosgIKBlAwv//rQwAcQEAUwEA8PHHYvaYKL6EihIGTPAhUxAm8MwosPeqCPFZIBYY7AhnwPA+gAE4EwQ/8gNAzgkB7MxEKOLRQwRP7nP6CK2zytQuDOKqzsDZgkQDaQQdJPx8ELfP4DCG7uZaxJrUytZVjOb1iQmNswiQEurtSxgiTwSzMEM4yI7LDE2frjlLQstPSMd0YQ99on9yoA6PxmlAQMi5rQzdsO7hJx5aaP/TojAy5P0+wuzSssVdIiOPwwwAsM30URH4kxJjCEEOrwFTKAwdcl0LQLkckBAckxdJLSEl8SFK8hETAuDUogiIwgf8VoIAObIBOXAAFkIBP5IATqDhJrK5a6puOQ8kOQrNhy7BZW50tEDY/SDEOAY0uY0ObZENmcaM0qkPN8IluYREMooM2iElhfMJWO0biS8pVw6tVI75mqT6vc46skcacuUasRA0eew0w7D5u/EJv1KNwFBXU2LZ/VL/amh917Cj2UzLJiB2RusM0tL+i2bu+y8d9HMScMsDlwstHgaZFWLxA87cSOj2F/DeHPMyGpEDFHBzHOwOGvATzIgQvQAET4AAO2MhOTIAB8MhOHMElCDQ3I0gHpLzw2gQ4wKAmaZK+8SkM+6sOykHcoxad1MUI2Ulnk0o9eRmZqwRpwiA/qDL/ojSIYSvKlDow5NySbrq14aO9U4urZ1SjgPrCGvPCmnAM1MjOzvi6a/ONTjkVssPKmCCQs9uytLtJDymH2SK3jrIVkDm36oyjeJTLUZkdRbJLmtJL5dJP/gTEt7GIU1xAofoEY0AFw3TMEGJIx4RIBmXIiDTQVCiEKeCBFdCAD6gAjeRIDe1Mz+TEUDyDLGgzojK48UJNC4KD1EzRJXkEtmASPgssWhSK9IQbnaxR2PEjNNKTaNzNyeBNPzkRFEOx4IQJDPIfFVSRFkHSFAlOTzs24jzCqJTKHcOTHUsNxcATRrlO6NhK7vxKsPSx8EwfhRiE8+OydFybc3QVimkp/9yCmheDhbicx5C6x3X0y7zsTzztywnBC8B8UYIcHAhdFwcd1EGtwAZ9UAMt0EQgBBzAzA8IwQZYgA31SALgUE7UgBa4gdFrM8gcL8sLL9VckiMxiw2aRdlEk4ygTZiy0VTZRdzMzR0NKBKZMThNt1r1UcyQnT7xCbBRhWDwVWDF1RMBtejUQi+kxqvMyjvaTm3cRi/FyjIMT1AbywK6xZs0R7S8KPasGvckmfrDBniUx94yFifLUz01V3Stm/pYolgITGz5NwNNUMcjVH+LAzYbzUNloYlM1EXNAsvETAuogE2c1AEIAAPozAS41BYggk1tPE8drxpSSRW1hFHdoP++osmhsEXjsiRrvdFWdVUbw1KrvLo4mlVbvdVe3ZM8obm3BNaU2K0p1U1jpVIGidnsUVbsEEOcHRRTMUOiGU+SKhse3NhUVT9sUM/1gCBo8ShqWCi8MBF1szL/G49zvdOqtdOrvSm/rBg8e7w3e9d5DVt7RVGyHU17Ddt/29d+hYETAFgO2MxJNVhLvQALXVgmKANO9TfxQjOyjU1ViByy0BIgQLaMrUlkuVaZYlWP3Z7FhdVXvTpFidx/MpMGoR4SodzJ7R6T1VGZlVU7Ao6r1FLRpU6v3FnvjFaxjImxRI2KArOiNSCN2tZa0Z9WgC3vKb+vsZYiuxv+1Fp1pRv/rE3Xq7WLJdq4Qu1UetUDTs3boRrbe33XTj1IhewBGCiBtu0AgMVQCkhYSuVQA3iACIgATI0BTb3buxVNRAScUM0qIzGELVidv4WSD+FY+r1Rxa3N3IxSx5Vc/uXFD8nc/IVc3Oxc0LVSd6TS0Q070nXWZ4VW8Ezd8STLKx1a4aoVjCiyVfmSA0xVk/lWgKyFKSPLWsWI+vjd3s3Pv0vh4D3hrU1HZTiFBVXeCsTX413esS3bPgNRvN3UECUC7LVQzLzMH+5E7/Xe8B1f8iXfJPizvg0vDgIc2dQvgdkCPyhcVGXcx71fLVbcV62k28TiofVinAnZAMZCArY+WdXK/+lMYNP9SdNlY8dA3dkYKbM7qGZ7lLixjw+J3Q0m4Q6enaeVT/qs3cQ4WknK2v1cYUX23X6EG73ICsdUXhtuQAe9YR3G4UtuOEyMuExl2BMoAQ0Q3wrQAMzEXuzFUM4sYgRgAPBFYhp4ZSHggScAKpbEgwzqG28hik3oCyCgg01wIg/54gXaYhtlQ0ipX2QmWsTt2MYl4zKOVc7iyTSG4zeu5gbuMfJgVvE0Gm6miAk25PYEEYuIhwxe03+hYNotspEQhoWKR4VAN3Be5KxVDnlGZHnmGFsghj17Xub9Whm25EmeAsYzghnASFDG1E8O5U4UZQwIAYc+5Uj1SAZYZf/wjYAMIGW2heWJk2U1QyWfAlVEywr37WVAsOJgduZkJmZ8PM9VbelldmmYZlWUflwzzrpoFlkD5jFqHhNrvubNOBXyU90IXohvdqA8Poy1E4w+TgdDeg2jDdfvaAR4Rq5+vFoVrmd7W2R8xgTUvNdJpuSA9gJOFeuG8zOHw0RQ9ryDflQQvNRRbmiITmW5Tljxtd4TeOW7lrgjmOV+CzE1WEkVtIRNmGJPKKwNOWkyTmk/NObFZunjUmZ69rttgOyXJrKZfubqg9VozM6evg09emPeiGNcCWqhfueq9ONwbo7IsKjX6dhwSwaB8BD5dGcybWd0xmpG9sfHxm3hjRb/boAKVYAuGxbRs/3n5RXoTDZrI3CC5b7Mz7NQT2RlztxejuwAh0bliJbuD6xrFMjojd5oGEXRlUwlJdmzmDQEim0LxAbjxG1vlV5p+IZpyubW+a7sy6bpZ8TpKVXj4tDpavbv0U0RMuzDnS1t1R0f2DJqWlHt2FLqH3SPQnRq2YaZuiPLQ4lne1bkq+bt3NZLdaCRjTsDvAXR4X6zN7vhLJiCEEVuHTZfJsAB78ZI6Lbo7Z7ouU6AuL5xuqZbE0jiTd7kFeBoFE0D8R5IwSlKjEWTyGVv+3bvxsbj+P6k3f7Du9zT+mZyYb7vM/ZfA1bjZt1pBg7w0BYPn73GaTXw/9NGbaUtxNiBXTZPTwjHmtrlHnZeqD2yuxrbcOHV7T3PcKqePyxZhFMqgxH/6hMncURncRB1cSNg2+5mW1BO6FCedO3VXuwl2FVe5e0GzeVm7r1+XwDjgZ9iPKAKzGODBWBe72Ou7CeX8ig/zyqXcj7/w8NldeXI8o/Fdf1902bTTizVStbQss5mYEcQXQBRVnI8HyBD86qMJDLbD5NSjHPeHo552q+hc0HmZrtLcODFyw7XcA7nSw9foj0bdEInbshsszlY90QfPRVf9Bf3cbx+5RRQ4oT+YVPGAH3Hbhuf6IOVboz25C44a+YuOo4e9Y5GMzp4hCs22mWuYDyW9f/HfnWKn3VaR9yIr/Uxts2Z3nIbq1krHfZqPnacHV1tWxNt3mYDx/O3nIZuvZ85lXaH9205z3PKjQ25jIk87/Y+x2px//asXtPNCcxBD1EbNvF0b3ceXnS2zei7fnqov2u3ddtKn27O7HftduUn2DAncDgKu4Kf+inA5paMPewll++Mb3W0v8spt/hYf/u0j2ks919d33VolgYd7cpLEfmR55rQDg8HXg7SXnnbgCI3f3bBr9J/ohYQHoXKXefWeI09JEs373lwt3wPp5F2hS4mZt50n4N2B7R3F/EXv4EbaAERKIHUx9QOOGhHBeKqJ1irP9i2RmiG3fo/y/0/24L/icswIocDhP+bocCSK354iHf1lpZ45Y83th+Ptn9+7Yh+x5Z7MRaO17r+xr170ZJZvef7AofjMUetz75DoeavmCj8xYcVQyqMn8k+cM4IYMhd57JDUWEEXhhaFMZ8FvZ2oAcIeAL1zaNn0J02bcpU7YGj5uGUMxIn6qloMQvGiRiZZGQSI8YNkC1KkNRgsuTJCCpXJmjZwOWCmAsu0KxJEgYRj0y6XImYxiGcK1t48HByJQ3SpA8XWTqVLFasZ1KfQdtm9Wq7cFq3osuarutAgQK9ke1atttZq165og27VuxZuGznvqWLNS3ZaWit6d3L1y/gwNKQES5s+PBgZooL//PCVcoxLl6jSlGubLmypsyZNHPe7LlzZsuhvJIqjdkzI0epV1cO5YxWsGbW4h2sfe9dPGrNTFFuDEwxX3HCobXSNMwZ32bAaLVyDGqQHTujZNOW5/Z6WILYt3O3fr0g+PDiu39fh3vcuGKnHjWEyJHimYpx+MyJo0XjmSk7N3q84d9/CSkEKIJJHJgUwYEsxQTTAC3NRNMHEd6EQ05W8PSTGkcB5cUVRR31IYZ4POIUMVFNRdVddNUl11gstsgdVy6u+GJcK9olF1529fUXj4JJA5hvhwW5WGRBvnJkkUdetiRoTH7WGSOVRdmaV9LwBgplqK22ZWvJDPNbVbTdZv8bbdZIhiSYyFGzJjCZHcdXL8Ewd2V00unlHXl5kjcennz6+eee9+CDnkKTsNeefhLNIV988elhX6JZqNGRTh99RAMNKWiaAqYdGJhSgi852KCDEJ5UwgmYGrHEfj5B5JAfhjj0IYdprPGQiKcosxBUKO54o4oyylhjjC2WNSyxyeIIbIpz9fhslYKRNSS1iBGWJGS+Xelkk9w+OSWWl7m212lablkHuKQgxxwzs5E5Zm7MYJvmmoNl0oqayv02S3OM1AlMsXpqN7DA5WUHqHcIG4yQQrE88jCiijL6aHz15ZdRR/zl9F8LlsbQwgklIagBgivRJGqpGUioQaqqrmr/Ia24PhSiUiDiOuKuz/SqZjbYMGsj0MoKC+OyOQpd7NE6CpZVW9GyVa2Q8hqJZpK9cVvuZd9eTSXTpmVprmqsVcYmbNTBa1s49qIpW7273Zvvl8vx5q+dwvVZMN7hGazw3XsfbB566j3Mnkb0TTwf4hv5pHGlOV3asaUnfJpgBZVT8NLlolLAgQmpeo4ThazyJDNQ7dWclIZLYQJVVDv3bJbPwQaN7Oy10570z7cvjTTTTW9lJNTUVq3ktlc/afy9X4dm2Y9+lbtl2FxSVm8tYH71bpnCEA8bj20a91fccmfSR3SmaFVd3gTzvb764KUv3m0JCT44HxRZdLh9F2uk/1/jTEAeEhFCArJUoSQllrNcAypgoFRRSAgOBF2FRkc6NexBVrKymVJuprMNJuNEsbOb7EJINNrRCHfKIpbuguY72zUNeMGb2mQacyXnFA9r3bJh8pYnGsA8D3qN+GFqxnYNZ4TvGtV5V9r4tbbkXOlNcJJTcRpBPlBIQx256dv79NY+hA1siwnz4sLkJzhD0cd+FpkPxSyWMUltxGOXAmDkULCpVHnKgJXjAAbwyMAixLGBoXMVruAgKzjcCikgWkNPcAUIWzCyV1N53QdFSMJJAq1oYzlhJQMGFtjlboVrUuG8Xqit7dGwhqVQzSlPicogIo9JQiTX13wYNnRtif8UwagG9dhmRYPg42xmslpsmjc2VTwRis8pXzuuiMX1BYqLXQTjQKB5t/PILxWYMBQh0ni/xCWOQ5FiHAT980aQWKpjnQoZqBa4R8dRSI4wKMoRYrahDaHOZon0ghcwYYtlMLKf2bAiJNUyND1tMm/GOiHuKFnQTprwKqEs0r7mpMTmFGeipsQhKFA5Gc4oz5WvzIrXoidLIKYLl7lETjmw1w25FSkxcnpMB72kHK9NMRjoW2YWn+lMnfK0p3sDXDGCas1rZpMQaGQDIJDKTYkoLmONg6AbQQLA/3iucwXq3DrZiYN1wtMogaRnrUBEKy+sYQ2nWMYvfjEOtDIyZwH/XShcDUrQYykUhXVlIUPnQjV+uVCiFb0o8ljpiK0RtnkgvdJIV4MuWg6WFt0wqUv1Yp6z4UZqkAEOKcIVPmOeknzmu2klcVoen36RtD01iDThFzj1DLWoRzUq4iwGqW9qDHRQ1WpI4AhAFMyAtzfJKm5hwEAP3VOQ9augIQ0pVrJaIhCcSOsvluEKf7o1rqGVawpNONDtWre7cEXoQ4VBJL/+NYYeFexgudRYj7LXSjxUZWJHqi6AFnNNuBnTbdoxmGyxVLPho6kdGAEw0M7oes00rXVqg2B+EISyBB4tw4Ta2my+towTmS1tK7Wq21bqf+TMrXBDhtU98s+PJqaQ/zwbUj/lCoULH0pkIVZhi0MwkhLOpa553mpX7OZNuztWKJ7y+rO8hDeinvjrYCuh5CYtGb4iVeVGCetKw3YjFKYBG0lpyViY0nca1QNOOu4Lr/2aYl+cBZO8JHpMKj64mS86rYLhh1o4M1gfdY6z37QTYQkTtagUjsOGspC/pl6sP8D9iIalKs5FnxOrOEiUG/3YgxenTsWzonRPitCTNRQiEJ72tCUAQYgb72pXkPQuj+dawh+rGtVCVqFVityv4iWZyauMpSyj3FEdetQvVnZyfKFHmV5Uo0xU+fJxjmhs7fGmNHLrA5Zisxxj+itK9hVtwRqMvT/Nmc53xnMzV/9bDFas4pqF8DNsHYJPQWMYY/ohZ6R1AuLgfvhzLns3hyGdoUon7kOaNsoV/l3Wsp6bDWtAw8AtgWMQujrV3AVyq7n7aqBNVFvia7KttQbsXIfrvOvdYfOsNLdgn+sOoYFFN4wNDfGKV7IpRa2XJRqbzkLbNDbPqMmrSF+8FlTO2+52t789MAbzg+jaBvc0jx44Y4yb3JcoRJ//7E2MUb2NvGXgpLUa1anG+8SJptCk+Zfp4gLlQ0X5d8DHPvCyosHGlOBEP03NDSMy3OFypevD7Q5rpYGXXX6PosaXrHGS+pDjUl5SYn50ZZJHD13DLrbKWQ7m66mDiWV+doCbffP/8Q0CF3xpc9597mCgJ5j0dh560QX189KLnlBMnzDUny71SeOzm/ex+jqz/kbdar33+nngE3yvb/2kYXHuCThx0V6EtbOhEJGAbloZKb+5f6XuOTWo0QSq97t2cliw+D74v78JQ8g3bFAifOFZU+tUsn956xcXWn7tQ8ausvFTcizkr6gvenXZSkaOTiOUhs1l1hTNVzIF2XWlVGmtnumx3jOlHgQKXQOe1qCkhzWJmp8lwh8QgsGtW0Tcx6DpTwCFGNjpnm1FEDv1D+3lx4b1AIqVYNhFyqvIjL8BXDxtWll9WiCwwi+wgw+SAxCegxCOA/Wd2lsw0/YlYQJ2F0Ix/0uJPIUqiN/4xYpqkF/9oR8WQocW+tBptN/7IZ57VdnGkVwdmNyw6dx9UY9voJT+pdnMSZEZ3lwpaKEBshAWKWB4UNboKRsfnt7pReAELljgrEcZyda5nVu71V4I4l6qZJ0LctgfPRo70RYLvhsfXaIkDp8mIl/wdeIVwEE2OZ8r/AI5pFU+1AM75AIQ2kMp7oNCFKH15RkSKiEtTpwRwgUruuKuxMIU0gEVNp4VYmGWbSHHfSF7gdziBRuU3EHN2dK1teGQhElW7F8vkALd1AFlbF7mfVIshl4eMmAfhmMESmAgntYgPkK/fcQcHCKgeeBSdcQjupPjuKBWWSJHOP/iPX5TuyEfH+lHiemE2ImdJ44dH0AdJ4wi9KWVK5CbjOnK9MGiLP5NLU5kdl2SJX2XVeRDPthDPrADOezDQhgCUvgiFf6iMBIeMXLh+hkjrzVbGFpZ+onUFTJjNuLfEfXM/q0hNeifNfwaMzpeuZRPFS1hz5UDWIjetiVdIKbe0SFYTw1KMRgKIcFBFhDBTbzjutme4owgDNIjPurbTjgOJe6jCUYiQA5kJ76gEzwap12CLXDCcylkJKDBH9QlIVgCXp6CrshdUUYkHs6i3blPxGFkEzKhN4iCrnwDObBDR9oDP0EMHsSKSZ5ktQ3CuajkrfFaS1JJMjLelmQeu7D/ITRWnDSSDRzeAVCq0h28QefRnfV1Y5D9JTiKFlLuoQOGI+kBznqoG4eUQAZ0zqYp4lRqpSVuisf44xp95R+NZUTYYz2ySgtCpx/dYNp94ho0lw5+GhZ8wRcgFQaOiC14UKoBJi0K5lx5Evcd1B7Qx8MQg2L6YEd6pDaIAiRAQqzUJ2VqYaxYpkwqD0umUroIEWIpo0zaATa+VGyA1mb5RjJRjzX+pMkNI2sCTCQ1nFLO5oXWpm2WYx+uA4MRAyDwZg+YQIScgKYJZ2x1Uwz2UQrkRFX2QNUh5yXKqLs1p3N+nddt2Mtg4hQMHHf6AHcGaZAeYl7upVQY2Cy2z0Qq/ylF8hzesccmsCcgbAJ4moM5MCY7fAPT8aJ9VqEjGAKY+kFKTmatZWbGfWFnxqRMpoYZDoNpJBv6xJwM8QJ1ME0yzCGEliF//uR0DJFrWiiSaijo3Sa3dRvlEao5TpYvhGhWwoBJ7JEipiiGeaULkijLWIoLxqhzeuUm0mjvRaeOAp9aXsEa+ICpnup2ysEhrGokSFd0pYc//ZMCHphfkudONSlR4h170oeKqdjDnII2GINisuI3lIgqdKmY/lCy8qeX/mKXnh+06po2qumasqm1yRw3oE82jBedciM1WFmelqEj6KkY3AH++akkxWagrt66Iuqtcui2AdUk1I9GYP+KBqzAB5xA7SFVWQ2aI4YdSFAAAlCAvt5HpsYopQZcDMroiipnjjaQqL5gD9yKC5wq2x0C9JWiD8pneB5prcqmU6ZWkops3vHcdqznruZBQ6gsy+bBIoSCKAgrEFppw9inuC5WZH5ps4aC+fVsk0TJf3pm+h3o902G2UTekKArLFxjG0CoFIlBueLfr0jcobbrbVat1X4svG6bBYboUgnXCpjAEcQBujGVc2qBC2qAAhiAApgAjL5bcpZlV7powgofvbmMy5zo2skBwsnBQUIXO/TgxnokSDqFrP6l1hZqyL4rrmrSCKFsy+JBIEWuyr6se1opsSoETOKszuaBl/L/rM9qlOgG6Gn0gWdqxmdOhzFxj90YZfUoUS2ECXJoghau5k+K6WqKgYDxCLqabFeALIEBVIYyLoYC3WShByEW4iRQAiLBwaMBgrkV3GwhWhup7QEcAMG2qFhSat1K2txu73FqWKjiLYXU3qjdGPTlwi+oby6o72KmVSmeQ8ceLvEubv1KJMkOJlFix8pSrv/6L8wmhDlkrjEQg5V1ac46gn0+a+hiSSNk1AOzJLV6Zpz4VXDQ15dQlBPVAvlBR9Oi5k++QRS8wfd4qy3W3aAyXApjrbviZlNOlnkEFVF95xqI2iowJCs83dN1YFPdHgp8gASwLfZygBzJrVc+rPd2/92ngg75nh1zORdcJiR0RYLbjaIrwN2NmUjrDq/i2q8X52/jXofk9i/LTm4elEEZjLHK1sEY16cv+ALmeqQ5aG59rrHLem7o5jHpdpaaBlsfoEsFa54uFcQQMVu3ElElaGHTfjC5jnCZ8UzvZh+0hJAysfA0IW7WunALwzCsXqCf1XCMueoxGEMOP51WGqwJXMD1ysQFsExVJXESG7ESK/ERMDFRnF2PXufbcUIg2IIgHIIVu0IgIFxdftq54aUlEAP9cnEXN/MX4695hrEYT9AYp/EZ+681R6Yaw2w1vOcPFquVhcIi3LHK6nEenwb9VSvJwYKXbEuC9t+cHkctDP8CHdRzPTNy7uouO+eLs/jIJMPm/gbqrALvJrvw8QZrud0lNmHgDQvrMYyy0xlVRRicxRABB5gKEMdEhLgyLMOgxC5x14XTVk0nUczodbKBHHwaXXqawWHBwRUCXdqlQpuI8Lbwuz6zM4OxrWJbWFhzNlMzGktuUKMxG/90y4YCKsisHJuDMYSzlXku/W2c+cFXOquzOQegbjCHm8CpFWGDvmjwJtjzPTPyGEQBEkhHnJhw7OxI4oXc1AJ0QL9ZXxZ0QZuHljJS1DE0KxjDQ5MyKevwIf7ZxzwqRgjXpYL0LG9d5HjMVDVxO2WVC5Aq83UnGlT2H6R0Ma/0HxSp3Gn/8v1+tuIejDR3h1D7dBoPNcv6tBqXARurcRlG7iJ8wjcMrpU29QHj8VWjLiNUtW7r8WKZLvdk1slxNU7GsyFEx1g3rZiKARJIgbmmNSSDT1tHA3XLBltfsO9a8lHStWd3aEqt1TIYQyp48ncmdXiPcng3pOy51hSQILvFARvc3lYecTvNcoueoMes03DhBKZc3dlhYqkeXJBitnO5HRW7HRSPd2fvEmjjtINHc+LytMEA9TUHdR0EdWkPdRliuBqrbBq/bCgo9Td/Qzh/qbgSnlWnuJq25p3yGlcfW7MtrQjf8xbUeNM2tz7HVL149XQvho+79T+/JlwnzFxzd10D/85dDxVRTQIm7LVDnzdDyp5svegHLgo7iqBzhjSLMrFURU6mvBN/P9AtAxepdufB6SBcsmokqDlcxp0yVG2DP7icgzagugUN3vmdm4EfoDGG9zmHW3iHv+wnCCtjbqRjlsgBS2YwNqvQJtYgeMK6gMY+55huXJ4n5K6N84AU1LgUdDodQELsylSPE0ZilMJ+TXdgZHdce0V3sx4LAw7TKQMm6OXTjbd5uyqUR7TXXpoiEgIiEid9IzZ+kxPkcIqX9zfe8hYfDRyaHwJcCgIvR3sU/4Ig2AK1x50t4OE5EDS3x/mcY7JOg3smEwSeo3aGzMzMmAGfq/uFX/i6V/O7w/82sA4wfMqxL0AFJFTQhiu6MDIrlgWjZdbCM3iCZ/Bnc0CDrHIDLFRCLYT1Gzy8jQMBFGy6pxuCFApgqZuCyPFGjydGqqt6nR8gbhp5DK/WeNv6rYuyOfQ1QyKiO0ppNvUrUMh3sA+74xgnHAm7f4v58n1BSsMlXAbCdEE7L3saJxyCIEDf8/0CI1V7tnf7t0e9/UL9Tg/MuZe7umdI1m/9unc9a3v9UBu16sw7li71QlhZu/M7FqLGoqNkJsjzmk565bHLcUNtxEu8xDv3fRYtkyADx1s6qu9O94E8qw+qZ/+T/HwDrArVk6/8UrO8eM8rPk0K2Qa21OEHw9a3fYf/k7F/zDghO+iDzhqg7y9DO9IXPWYnfVqp7y/A3XONIiMts9TPvpxHOBeh+9WHPdjvPu9zfYZ3OMsyORzbA5Z2pJXee30iq0n6+0l2sIAN/CwZfLIpPMMvbRtswRvUuKYDAfd3+hZI5rNOGcdHVuIJPuGveuEbPuUhfkIsg+LHnUOvPOYeg5U+9Cib8qD5OmCnW6ABRBYvU3oUxHEwRkKFCxfCoJHwYQuFNESkeFjR4QmNQowQubLmixxOIwORDHRSTshAv37tE2SLUyCYI18uE5St3Lqc/PT1nOcTaM6gQ4PyJHoUqdCfROE1ZbrUKVSpU6lG9WlGjRqsZbRy9Vpm/+vXsGPFlhWLhyvaPHjY7smz6NGkVMW+sct3Nx87c8ZEWdoECZIhP4IJV8pUSfDhRosJ2xmUzBmsxYMoM2oEC/K1ZLAAN2ojZswW0UBIrzAtJXSdQZpYgyrlGvZrabNp1+52G3fudrrD9Xba29tu4cOJB0d3HHnyeMuXD5fX/Hk66dNx5lS3Tts47dpsFfNu7NuyY8fM6SV3fvwyvnritPfC59IqVpQuEVrj3v1AgQb582f4H6ITJGLooYw22sihIoq4T44GY0LpizVEOoQTWyg0CaWSfulOKaOA8jCpEEUc8Z4Rq7IKxRNVHKqrrMgyC6yvrDCDxhlnrKOMJmLc0f+srNZiy0e33AIEE1TAs+sudvQqhhi/CKODjsKkTGyQN+ioZbPKEtMEM2ciq4QzOkIbQwoeSjPtNChCW621117DBRhmmDHFNt7sFOdO4IwrTk8+lftTnXYCFZS66AYtFCdldNKOnG8aNQZS9cg7Ri92xiMnvVUw4QOOTr0gRL75CmEDP0/1IwhVAFUNMAWGWriBhlg1OnCGA09YEKSTSDpEVwp/EYSlBxvMEKWR1rFFJ6WSMgpEZZs1cahmn1V2qBShvTasFrWtEUZubewW3CDVAlINId9a5BNflrGrnnzqMW8ZW07xRLAop6ysyseyZLO1YDbjjBbJ3lBTitKAYIH/hRoURg211UwphRQ35Ywzt9nyHI4aP/vcsymNPQbUOXGgExnR6hZl1JzwVFbP0fMsNQe98erj1NNCWLlZU/vcU2M/VFNdddUbLIoohldjkBXpWTXqQYuSgL3lFkkEyeUXqM+5JZdbWPr1pFGJ1TWQZ0ym9qhpr122RHrSvtbaFavCtscWX/SWbjN05JbHvPP2ke9Of+QD8HSXIeeuetptlxxNH5EyysrEvHLfxWh5GBaAKzfkM9SgMLgGD0hYmGA/KI+YYjlDufjjj/f0LXU8Nw5Z40Ovm31R7PDR7pztVg4PPWOWPAY8VnT2NI74IM05P/36869VIoBuCPqEJELB/1bqmba5aqitFoT7XKiWhKVcuOeEwq+JrVAZZMnmiVn2PeTH7LPVnn/tEj0kW/635e8CXCb6r/tbAeTf3PDmlb6Jay2AAxwhikSewrWLHfb4hi0AkYZ6QYkyYhgEZuhlmU1UrjNgCkUoPBOagm2uBggDAQk+p6Yx3MERpPNXM2pTJ9RdbBuv61jrVuenkbnOOdCp3T1uV8SUnSNlu6MUOT6hh08YAxWo+AQmNtWemq0CeKK6j6kIghDnMe8/YITBQmBFRiHYigOz+sMhfuE98QmCE2EQBBgEEYg6xoQmeYRjSUoirJN0R33Uohb8dgI/Qx7SkOWIH9r0Ma1Ftg1/VP/50Ii2dRa9FVCA/LORAGsUQL1p64AJVKAeSOlEYxzDXYbLhz32YYk0YBCDVuIgmz5oGD84jIR3INPmNtcCEiAMYTVwYRvqYIpe9KKGFquYMnnYTGf+iXVAhB3JaDdEfPSjiPvYh6NUpjJMsceKZxCnOKfgBb/ZzBWiAkTyupggLyKkec8b49FaBasyGoh6JgjBCbLAhjaK7xC8+oIPCErQL9jgCyFJqIR09SCS+BEm6pMWsxrpE0ReVG2JVCT9ONpRj9avfvkTqSMJOMD/5SiTKQWgSV/kIwMicJSlBBWl3OUudpwiDVe44Bsu04tNrKaWlLlDMSFRhzGpqQVJTeH/BpiaMBcOpks2vCFunpkcHVa1dYWyJj6O2NVxJHF3SvrEGcrAhCMghAcKKsJ70KnO5F3hCh15pzzpKjS7Lo16zWNDJBAhCFcINKEFNWiDDqrQhQ7roSOJyR1fEsgOVXQpF8XmZCWLyI9eFrIWlaRIy2Y/zSIlp/yDq4sqeUmUqnSTqUVt3V4ayjPQTJwKlAu72mULODyJp7NkhCcyUaUoiKEOjvDDUTWXwl9uYALBhAKN/ACJGR6ThnKSRpz8laepWhW70cSqdrmr1a0ekavYxF14JAWzvZDVlyz8gGlMwAMvrMF4M+MiqtrrTuvRFXpCo6dcETKrVlEhWIAdqGAJ/2qDYR2YsAd26EMpBMhk8aSQFXVfZSlb4QljFsMcfeRmSZTZonyWpWrwH1xXWmLUOgHFqmXpij9JWteKk2+Y+EUq2aGMn94ySqqoRSWE+gYx/LYyYyoYEhTGAqYydQIbcGpqGvGw0Tk5NrJBxpQnJl2pdheaO5xmdAiF1WoOUTvXNIeYi/jVSHEzZZjAgQxM4wEJXGAFawXEHy5RHy20Z7TlVEMcCFKrWmXEnXXl734TpLQQZAENkfhFQNHQ6MAKFsEHzhBhVcJHmVxoFRwaYiETSWFsahPUFsaHZ92RYVN3dpIdTtuGe2JiTHaFbiqWdRW4YAUdzVqTLG4xuX5Erv9JFANJ+VDGHjAoQsz5+LdvcEzmhowEYCI5yUpmQbJVY5lRXNtNUdY2LujU7WRC49vRsLK4jTPVH3a5ddyYnbq3WkQyizc72oBUysbDijis2c0LoAAPGHiJSNwMEHo25xYBobMuFmiuX1R49Pjb8EJrZK+yiMQfGo0Fg2IhoQamYxgiLYiATjolw8J0hTKtaQhvdMKe7gcrWa5NUYf01PNjZE9OTsiYpzrVPJHbisv56rzhOsVBp7WtgZ5rXZf2pX9bhT1sSozHibAPP052H3wrdSIDE+vTZlgbKBOx0VEX7FQWe7jJXsMpvwLtruEFnNZeOnLbJmNUrYbspAlE2Yn/Td24I/OYy6w7X9DFHOkphBd44GYPwKB49YnPxNdQcPxscQ2k4vPCKR/PeQYa80S46616sIZI/PUPbMBC5DGe0AbRkXupryMYAtr6hqaEQSc5REQrdIrqdJqIuf8QP3L3aZezvOUv9yhzYC5zqYAIwu577M0lCSKe02jnOzf69LswdKFfv+jUH3G4XAwkOFiC6fUgR2A88Zfh/nbqdpC61UGz9aHuVobQhcw0rFH2b9/G/t8+u2uo3n9QWPswsC1gggHshuG57CTu6u8aFpAB1Y0b4i3MIlAC3WFllmFl7K0I3AwHGIjO6OxmBo8QCI9pfEbP5oCs5ml5nOfyMq/y/+5pjDxPVEIP40RPJRpE9eaIe+iI0T7u40aF9CSEfBTLFmKhO84hwg5pHZIPfnrP97Qp+ELN5YqofmiH+dinWhoJ94qP+SpK11isC6kv+7BPDLGPR7Zv1/rmEeoiH76BFMwP2TSoxxxnMZyrcnSsSzJDAfMwAfNPqvowD+mP/iYG7XrMMQqx/wrRMgDQTbyOdEjhAL0k7rJBURzQdipRO2oHAndHPeZDD2JlDlAhEUKxEESxlIpGCO5taQ6inLQgC8RIBS2PBZ1HIgbEI5hgDhZv4uxD9OKg0Qqh0eQgoDyOE9yAe4KRV1yPEk5ioSKvjxQLE4gw3pIQo05OJ5ZwHf/OYeV+D/ig0MK0UIjoITqO78JsTglzb9RIbfk+q/jA0OhcBCvYMQzH0PrmkR7ZcW7kxh0XoRjsgRyIwQ2VTXIqZwANEBILEg//cJn8UJmYKYcQUE8QEhtySNzWjv8S8RAN8Q1Bw8ccgxG0Lf7kDw+fYRIpcRLTR928I97A4wJTARNakRBCESYvwQQFohXba/L07Ito0gW+CBYvrydXUOEE4iU/sM4IwSjt4ygLQSl75STgqPWOERkzJPJGsRljwRJsL8yqkcI2zZCwURu5sRtLLVm+UVnWZysJqbIUiRojjObeR8JKagq+EB7lkS7rsS7lUsRgZA+I4Ru0wS/+goP/DrIBGTAiqaEgIdIhFZIhG3KZCtMxNyYQx44isa23CJH9NhIjE3Ex2qT8BDIwYwFLvAQ0kwE0laEafOE0vyNS+GJUikcUYRKc7sw9SGUOhocVb7MVe2AnW+UnV7CMRiy2Skkp66zOqGgSklI4J4HO6KMZ/y0SkJES/EgZgXAkntESnmEcXg6jtFIarykbnRA8o1D43oH4vowqzFHl0pMay5E9uVAu7XEu71I+q2+1pg/W7tGCRIEYamETRlMk8e4xCfMxETMQG3MxD5QxAfG6IDNB6482gGF0YMMiC3Ej2w/ZKlTZDLHrDmMwEoP8WuGDjqkXiIFEVVOKwMkob7GU/2pzRfVAIGhzDmbyNl1gJ8WoN+epnOIgOY2TRzHhKOMCLh6h4I6Tii6hWKLTOZE0GcunjwIh8uCLPizhOrMTG71TO7OQCb8zPMXT99xtCsdyfsBU5YywStNz05KQ5iDLfeDT50IrPuczHt+0Hb0wp9IAEkBTx5LBNAV0QPvUTgoU/xQyMQc1QLOLUHdjIYOBESGmFCaU6ywTMw9RqFZDSzw0hgBjEVQBXaYIFQrBRZmGCvopRu9sVFmxi0iQJk3VRn1zBYXyJYmzPoh0Enp0EuCiVm31R2e1SZWUVy3NJNaAoP7gKqUUO7MUkcazdpqQG7WJ77rUStHRPLnzWK+0K/+pFU13Ik07LS7vk7XSgFvlFE7D9QnGdS5JzFzxprkAMxYAlE97iEENFCIRFF7ntdyQw08JNRnE4SAhQ1FDQUQH0DPRrvwE1hNAtGAB82ATNjA6FFOHRC4SwT5aUQsUIlVVFUBAlRVpdFUxr3lE1YlEUSlnVUhlVWRtVRSmqC9uVWQ5gTh5NRnBJkMsYQ3iqvEsoeCK1cLKFFmllbJ+z0vDa+XCEkzLEz2rdbKq1AinFSyTtuaykIhczQtrDVzFlWrL9Vxp5HHslA5HtF0Z01DxtTEDlV4PNTga9F6tSzgice7Wthribl/B7TANUm4J0utGyPv4QC461QTDqGILAjf/tYBG/1ZjF4IJgEZUY7Ioc5VkSdZkU5ZkYTU6V4E5qRJmYe8+Ik9mp1TUdFZnoVUrjTZofzYKxTNtzpR+QJdLsYlnl/XTqtF0de8+wXWlqpZ2q7ZuBmMP6LA6vvZdB3UhFZRsK6Z3zZZAiddiMEZQ2pZt+fQZ4tYx/xN6NUNP+VVTg1QUjAQUQy8FDcIFcJMKqKBUteB7h2BGB9cVhfJjE/c4SckoF5dkHRd+ZbU4Fw9WqehrRmVU3itzkQWJUvdKS7fdtDPMnjV0vZHUUDd1izZ0wVL52pMe2BRqpbZ2J9jotg+Ca82CoCozdpd3h/dPgTd4Q/hsR3iqmtcbTBiF//s0hc/WAP2FMwoOXbBIVGgzN5enhrMAfEVvfHcY477XBVQAiJfnFkMRZanIidgXSOPCfZdYZOP3FIzziXk0ZC1hFJfSB9fpEfjXWanVaV1XdL849zr3HAF4jImoZ7c0Z432CSnrdZ9WdiWYguOYDHOkrCz4+m4XTPIVJ7rWg/sYhMNWhAOZeIkXYxo0GnIIEhM0G9yVeUVTFaT0iW7mOSkODUqVRgOXabr3e+cgh3uYh6mADIbgh4M4Ibp3r0JRihKhiJEThpWYiZt4VuE3imc5iqXUZm224NhAStfpSbOYHLxygbn4gD1qjH9WJ9QN78y4wg641FB3G/Mhjc8Yjf+FNvfemD7lGJvNiui0OR65ZTA+iF072I8/GJDBVngHGZ39dJHTFjgOOZ3NVpylt0StMhXS468mLhHIgDY/eYdjNEJ0mJ99eJSDGHxDURaiqImcKEiRuJVtuX1heVhtOWVpmVabuKEzdw0MIQ0yeg1sARvJwX+FeZjJ2JgDJXqvY4uLmaS/E/jWOGe/MoEP2JqzmabjFAwpQ4P32Kq8tnf95I9/upxJ+J2FGhvWeWzhlqjVmQFNMqLSQxZcAREmjgz02Z9Hb6p/kQz+mQ0qzvRCWZQvGYhTQJMN+qCJmKEBAVeTWK0tOoklOpbpmYqe2ColupVr1vHuYyDWIBZ+OZj/RZocL4s8S/qkcSKlmdlKv3IbQxqbWMlZSbfTZtoua1qyIbhDMUPd4hnLxnmog1qzNzupHfPtELlezzZ6vYMVyCN8vEcWojqrseB7yQAmr7q1OTkkXNsFhgC3R4A3xRpUh1gWDhqhS0llhfSi2/qWXdmtTxauY+EUlhuW67rgNmGdSGwNLMErXY6v/Vr52tgcj3mRAdQZCHs8i1lZW9qlpdnCYtqNITuyJ9u96eabseSyRxuz666zBfm+P7swQ9ud+3sb/LvclHoBTVI+juG3/0m185m2QXmrpxqUZdv0vmCgKwKIA3eTDRqVEwEVSCmhFxqtg3StHzrEJZqiYzmK/+f6Ef6CuGF4uuPKCyzBo322wrLTmBX4r9u4dva4eb1EGeDHsYlogIEZPFkpLxI7mo/cwtj7mpfcvZXApiGbmOJ7T6/KUMUZqE/Ys7Ncv40Xqffby5lByxVQEpUhO8TDwGWBanQBHHRBfBLBk7/XtfX5qhlcn0VZt0Xgtnk4RjW8rFG5iVBhhEo2iaX7w0fcuJN7lumZuVFcrXM3d590ZosAxsNMPIPcsnRvgMsYx890xzcYyQnYCZmOHyPIyDmXjck7yZW8yZ181e0Saw2hS+abkaucOvL7ysN8y98ZwE1YtD0b79SBLsZjaw5cF4pdF1jb0Vq7zh18BFzgB4YgsP9wG9p7WIdP+bdBkVNLaREAna1XfGTXGtwtwSoXfRKc+2ShmNFZ3PHiig6IpAjJFMizoxK5kzyblxt+fYgo8ct+dk+xRL4PG8mH3LxZ7mijud3MsdVpOq3O6r2jXHdlndYj3spxneKJetf/G+N/Gtx0HanvHfAshSUO3HuKfbVlW9mn2ge82sEhnNqXcTl/W5U5nMMbVxQCPUirN9xzvtxNfKJPvHp3eRFiyj6uQAbSStw5YcfXFd+B3STBu4X9fYOpUCzdAdXP8btrARhifVrdLb0HPviQPMc/F34SnuyfXB6Zq7lUgRiQOSLru5lYOOO7/NZzvU83PiLlftw03nn/IZLMv2rUqeYXFGHkdUEREEHiTH6qf+CqfcDApjoM5Ai253wG/0BXynoRIHbbUVbzT3aEglTF1bq4ER2ieR5+vx1vF0gLiF4GFgQQFHYTxF1ER9PfZ98zA/M/A5vqwXiM1aF5/V3rP13gWY7UCf7IcxzfvbPsJZvVsdlusLYO2MK5lte+JX7i6b7i4R4aeD2dLx7vf/oB/f4X2MGNRh4RjL3YEYHjZPsHsECfG/+qw4BXolqgRm/0lvPfIPYP9CARgr7mAUKUwIGiVKlahPBRwkd7+CxUCOjRJEsKDUqciDGjQFUCIXoExGfNGh4XPMhI44cOHUOeWHp6WSkmLUiV/zbZvGmzFqydO509U6bOHb6hRIsavbcum1KdPIc9u9cvqlGp+6patYc1K1arVIlKTars5zNs15RCdYI2rdq1XdpyYVvFLdy5dOvavYvXil4zfM34wYOHVDJuhMOJM3wYMbp2jBsnfrw4neJtlMlavlwZs+bJmztn/gwamujR00KTFm3aGuZn2sZ9I0fu169ctG8p0oU7ty5FiHqT+f2DzA8sZIgDJ5PoEPIwf76w0cKm0CVWrBKhSqQne/ZPGAmG2jhpk0eFCCE5HE8xfUaOGtujjwhyTZEFC0wG4bHlzZb9b/QPugOgSn4MGNMmNTXV1GCETcXgUEmVs5ROrbRSS/9ZUDVYVVRXacVVV1M9GNRYw4iWVF4myvXEiSrup0SLLsb14op7zcjXX6pUUxhkju3Io2SRcbaYZ0IOCWSRqWXGTGnRKClNk5SdhpqIZJ1GDVnKuEYOO7+wU5tuXuqWCyJhAPfDD0Oc6cNvvyXyGxpoEBLdH9NRRwkmE22H0CffcQdeLAYdhBCgHjX0HnoYXVToR/DJpwF9G7BQQ6RIRLECEJbWEEWmk04qxhuDMOISgjxRmIyCQp2K6lEgOiPhKBSaxSBXG8qaoYf83PpViFKWJWOKvS6hF7DC/kosjMbS2FcZdfgBSS+E5djjZNEaSWRZ1VJLLZOlXbbkk91qeyT/uFFauYxsXHb5Zbq4+aamcD/4kGabXzjXnHRzUrLKJXbiyWe/ohBDjHcWDbrHe+Il+lDC54HkkEPyeVBAfZVKMYYYUvBw6aYsQCppFJ6CSsqBo8Ykci/EPPsOqqeqOtZOL5FKzYLjeFUrrbTaeqGDq47ok4q+BlvssEHHGHSyNTKroFI6Tott0z8Gea3TQG4brpNWQ4m1uGVpAxs7Xt/Cjrpi9zZmuz/Y0CYb875pbyTUVadvIYf6+2/dAAfMnkc3Kao3fAcv3DDggjcUByBrnADxASA0kQZNNP3XR+QAdmpHf/5B/h8jnzqi+aeZDyiYsziOvvLMSJ1+Das7kdyT/8xGmaMhVTVLhWvtOdPzoGrNDDP0z0D3Dvyxwv+ObI2BJV0l0z4uDXXzzqMzVtRSI0Z11d5qnXX2umNzJWz5gLML+LuIrZsivPWGftlkwLv2vHLKyYorb6fS70R87vmvL76cEnDApxQkqIQ47CM2AYRN4LCJwClQgQ1pYHziwCgJRGwDXNjDTnDyspCVQhOgIBnJOgc5APVBJSOsXBtE6IjQmYx0KjtV7nTCQZmMCCitGQrsaGYr2jVIZ+o4jE9457MgBm+Id+lLSgxxI3dwoxvMk0cTpwfF50XRMNa73tXEtTvtVekn4yBHPupRj/GJj3znQx/ZxPQbH7xrCGuTk//b4reM+dmJO4vgTr/2pz+B6A9g/wMgeQpmHr8lECSDZBgDGdjARIYEgkf4gAQVBwULhuJPomIKLS6JSU1wrhGcxNzkLEe5j6VQhT4ZHY6U2BptLBGGlQBZ61w3FdjdUIe3UxXufAREIQrNd7zsJRGJRzQhGi0wJ4PWE5n2GSkqc5lTxJ4znVSqUmkve2L5xtfACMbxaXOb5duNGQ+hvna10Tpvo44xUEE/O97PXwHbozv72Df4EJKQg7SgIQOnyETCgQ/7hEM/TXAB+kwgA0moYy8OWgs/IXShojJFyB4K0U1y8oSdqmiAOEmKSR40mijbmSk6GapY+CRVtNyhLU//hxQf6nKlwPTlL4fXUuIdLRQKikcPkTlFpTFTpzt1WvWeCU1pZnGoP9RiWI7BJV2M8UvczI35vgnOdhWHXuSMXznzSLeB7O8T7vRFLPh3Co4EUIANOaAhAGEIOKyhkA7kZ8MaGId+xvUMdD0DDCTwSEg2K5p85euI/mpJTAp2sAgNmeYspinKfSqjCRILyp4Ri5B9yhAhHSksS4fSdaD0pCm1BktfaiL8BHO0pI1pE4p3vAXdFKdG6inzOtPTn4ZDtkANalFvyyrc/vAnxSBHLm6h1KYKV7joOwQ4w0mF973xnMxFZzrVqU48SvdufTzIWBmW1j2sVa17YEk/85mH//DCda51pSsTGkWfAww0kv/qq04AC9/4joyTIvvhQTknQlCOIUAAGmXrxrLK1YFUE5swiKlkhsqgKFjBm61lymz6WZeiCLQUlmmNaKraY7p2mTzdcBRp241n9sIa7i2xbiFrC2P4Fri/3U0nOjFc4YYpfYdIBJvWZB1XyM8YPGaF/p4LXedyR7pb9R94BpVAfXbXu0oGLx4cRt66TgGg6cWrBGSwB5GWmKjyDYaXh1HYiZrQlRstrGQ/CUo7DCgTL0uoJTt3wsXCQsuWfazSFvzgC+lZiU6MsGklXOHSFssvFkSehjvs4UMnuoohbvT2hArmMvtVt31VRopn02JdvP/YfIqAcYzLV9xD9MbGiHijOZsL5En4K0+T1FNWCzIRRCmkyWvI7h6+6+Rb89OfvNbCGZgA0LxOYL14MPBQ45ukZH8Z2QKuXGI7xcFlR/OSj/tPmvszCJdsYiYxsTa2OZmgu5USwFvrqE3zfO54+BnQ7A60oP9s4QElcbXHRHSRlqdo1k4PxNtrUmGNLWnAanmjPrE0UmsD406/WBLm64TCO91wh+fifMhh041/gwhXyOIYqIZueLKTsFAE6jv4A2De/pjkW/uTsktuMq9VrusoZ2HKGcCreiM20BYUe9JYO7YwgCFtv14yE/9BrMdEydgSw9DbnyQhZVMSwm+7BOD/PBNq6qwVs8PgGcLrbre73z3oC4sO3/lONNmfBsXqUdEbz9Rdqaid9IFvua+lSvHBcfNwiHN673tHRBlrLNWK65jj50TnHGP9EJCDXIALMQhBECUeRdr65ZRXQ+VhTl5gU2DYN8f5BGrQuID7HNnKHv1Bhw4KbyuWzHKf9oReImbLjZmiad5c0hMU6YRaPXl47vrX2XIEsAs/LzMdu77NXvZmOnr5Wnv7BR1HE40CvMSxAFgxjCGLpN5CEtzn+8PdoAg3uAER4x8/u9yEfjclYsc9Nvyd3HrIQ45nYOp5j1vFi/nLh7fXUo5BBPJqAAgggMO2ASdhEBWSPaWngFzW/2Wo51CDRQqXJG0r5FcGskknhIH6hViesiwYlROVFG5bpBrcAFPwZoInCBdM4HXAF3zuNlOnlHxnh3YyiHxNw3bMpy3TJnLQZx57EH00JW7UZ3Bhkxu2wXCc5gaSIH5LyIRgYH6IIC9UwAZzgAY5tnFyFGsqZ3lbaHn59FYIExEH80fh5RCAsX9meIZoCBhS1gIaEFCdF4AHYADDVgJpYAnvBSULOHpXxHNd5mWjAlEb5IFexlEnkwwC1kn5JQVHZ1Gg4kGsU0mRtkUlOHy/F1qVSImZuCx10Cykozw0OINOBIo1uHY3WFskdno7uGQDwoo0oQp0x1d+oj9Z8lsT1/9we6eEDAd+u8iEYRAG5+ccarN+hFd49IMQu8aFaZCMK4d/gJQwskYw/HSGlDeNcqVyWUAEMPAB/8d5cigAcZhzarAJkMYzzIAMeriHTEJpfviHcLdBd2BRd9AIEugMqVQNAMNQD9U5RkcxkiMgbFYg9EhwVZKJu2SQlihoLYiJxLIsO+eJMRiK+CaKo3h8U2OKOYhQBwF93YUHf9GKB4WPsVh9vrAMX3MLv8V9KclwR6iLS2hGvlhqyvEHamJjcER4W/Vxt6YGfHEFyriMyUiG5PE38uQ3+FSNR1l5KuiGAsiUcCiHdBh6kDVN6MhlztBzVZdbDWhYRZcpjVgJ9Cj/bqbkfK30SYkVOR6ISaLnDCzyFm15kL4HlwtZkHZhRJ1oZxA5kU9DkXtZin15kaFxUBpJEy03IChBIDfSP1IZFrKIVOwAPsCFGwunkt0Hfk9Ffpc5ajhWk7LQY+fEVXQkjT0pmqO5k0AJGM8ohopShquZlD9peTBQAhfwhnFIm984hxfQAlywbXiIlck2lXyYjuQIX+4oiKrHiLaXdCK4RWNpnJ9DE2n5XgiVBjzpliuIgggZaGVwWjUiGDAYLXlJg+C5POIJkX+Jg+JygBsJGH8BGH1xPAoFn/5Tkl6zVNs0mSrJd2YUk20iHTrWmZ4JmjpZndNJoD7Jhc7YN0MZ/zhnsEhRBgdTAKERKqEQupRNWZu0OVAkoARIJCW/mYNYhJGktztA144kGgyzsEGjkIie1F+jFHcU+HYTojkmhEKQiCA0sZPVGZc7qpBr0aNy+W51UJcHFoPz4CMQQp58yUx+WVsGIR6D2XLtmRIo4YOOB599NJ/fU5/jo5JJeJ+W2RvGxSZT+AeRMHg81n77EppcgB+kOZ09CZSA04MOBBEOI2UTegU4UAR6igM8gDgeIJtW5pQXGocXoKEFsyQdOk2naJVuF5ymt2wmKmCPyDkyEUMlI3espHpxVqlfeUkAswkpoaOWqIJvaapAOpep+oLG5GHimaSkaINY5CdjyP9yXXhE08ksfzKrfoIJq+BF7KCl4LBUL7aEEbdweFdc8jKFbJBjxChkFCGgbOGmB1pWx8ia+UdX2NgiMEAD3eqnJzAD4WoCJlChg2qhhEps46ioi8qouPWo72pfSudlgZiiMiRfH8WVirVmjiAWhqASbHmdAcuj7wawqRqkYuedSvqqRrqwFXmeQKVQN+FyauCRZRAYgYIoFMEKwKqluxBG2kSsYJADOSB+D+dp51M2a4MFZIoK/tl+6QQScPCmaTGaNWugbcWayRihSvkBPeuzHuCzFAC0gVplg2qbFypBi4M0jcq0HppF7eq0TUtUJrZFPucyrwedw+kIaGY5dLD/RGHhrwV7ql1XqgL7o6iKqsX3LOJgUwp7pAzrthR5g0yKPbMqlE2mhnmAsRVBEYVwDPkQrGFUD/4Asm5QJj+QA7/ofSg7VVQghWS6fv/5rPwkmm1ps24Bp10ojeWlBhKKFjgwro5kZaNLukVruucaAEcLjiCwA2kAC00LtbHbbyDqqFK7jsLJmxBIWNPWbfBYUQCmDLUQtmKLtkJUtmNbvMlbl6/btvnWvA2rpLF6inY7a2aFs3o7ctCICb/wRfUgrB8Lskp4Nof7A2FQfuPni1HIBsUxB3PQn5JrC2r6oJdbs74CoQd6p6XKp90quumlXjZ3uv4bMahLqKubm6+7/66y23azC7XwJbXDoLuvJ6kSSFjROW2QAHVXRxjCS7zKe6qlerzImxfbmbzBZESplTIalqRwy8LRK71NKij1tAjVKqfaawn9+UXhI1yd4AY5QL5hUCa+KMTKigVSOFXua2Pwa4xxRb/1iwN6cb/lNXP6KwTgGrpEC4cBLMBbbKGqa8CuWyoJzGgLzMBlTLuQKliuosavIME/58ZgFsE8YZUK5QmWoRTKsAn/OqoizMfDcrwhXMLJC8jFUwfvyaoU2cJxm3bb87CiYV1PqqAJER7hoSd7cnKFwA7gy6Wbpggj68Pke7jmK8RlU8SOK4WOi8TohApYGLOiiacQCsJEMP+hsKyCMRADVnwCJaAB/XuuWkwAAyzAAwDMXlybuBmVY0zGjWzGVQKcaCyjHQTNbCzNbGyicAx0KIq1rfCcPRG8axciedzBfdzHZRDCgyzOZiuXZrCdm2iX9Oaq0Au9i6zM6lgLlpCaRYl4z+hqGFEIuZDDXdrDnvzJoPwDTjjE8vIFqCyF7WtjVVUd++IFTuy52WjLsgzLFY3RKdABG90Bu7x5CgDSBPzLwTzSIl3A3zhsL3AF6tqoyLzML/3SV8SH18zGHMQIqQfN0cwL5zh6V6vNr9cI/pFCqqCXYbEHbRDO58xu2mnOSg2kSVC8beAX85iwb4ukEWnV8SzPypz/bHcIhhpRR/mMEZfwC2GUkkso0GkNygY9ysqRNsHYvlOoBw2dLxQR0Xm6pxSdjbGc0bacAn6NAiGw0RaAAbvshrPZy8Nc0rRp0sRsm1eWBoVmRdeiwGfsb1Vpzdic05rD2ZnAZtRMldiczYzwBpQCBPv1NA8SC3SQ1E79wX/s2nIJBVG9vGub1bftRInswnTL27Rrt0/Kt4XyjJOgB5iwDPkAXIKA1mmt1uTrw6Ocvu0S1wvdvtkhHZOwBvOb13yq19wN2Cjw1yIg2Bw92BVQAYX9fwxgob682AF80t74vybQBXvl0pVt2SSWjjStxp7N35sN2qGdzTDhBxZTA48y/4OEoQqs3dpkC8INHttEA9URLuEePKSHnA66jdu73dsNvKvBLWsdsWqSXNx/axvKzdwnjrgj+8MHjdCl7Gu+Vt2EACedu91GwK033tffPd4brQEiYN7mLd7mnQBDntjuTdLC/N7wnXNmINnhMluqoRn2LdOX7WXSYApW41Cbzd83rdNUOaK8INrZ7K9SsAIekNVgoQp77MG+pIJzrQfk3NQ+OuEtdVpCU+eBPAYIa9s/ctW5LRkYruFPvuHTBJ8eLuJ1lCcKM+LILQhC7IROeOIoHsQsjn5z4Lg94AIzB+MioQU9yQOfjuM33gIxMOo6vuPoLd7ijQGqXgFEXuRcXP/MSa66j10CVdDk0iPoUj7TEWiiV+7rKarlOf0KPD3ZTaJsYS5YoToIYrACVg0WrQEJC87gqAAOsvBrcS7nBDvna64XUu0X7ZzhF/7OWv3CZZyOf4Iwk4zo6854k+CYigBOj96Ey63WQFy+0I3QCe0CFd0Dmu4FEb2noI4CNPDX4JoC3Rre4U3e5Z3qDS/kCcDYEU/S7e2/jf3YhpoEO0ckuh6iVhOpwOBQTUIKzPDr/W3yHYQLO32OR3LsKr/TgNgShtDnCmaPeKDmD36QKpgIg4sKUxzhOA/0wnc0seDOMx/u5K4jzJfr5g4lhS7cHcHuiYcKXKIcvngI8j7v4if/0AQdTr9RxEW87/wOoT0Q8LiMyyUwrlZcAj7u4xzd8G+vAiqAAQ7wAA+A5K/OlHd/5BYP3xifZS0d5Rx/3yNP+CAf8oSf5cEOzTzdDFXj5ZF2hzvh5+mWMq0xCTZ/88Xr4ExwBuTgD+zw5tguzts+NHPu7UizWkZ/9IBe7lwNqbFQEY8MjVGfMJ+AVLJgY8ghJugjCMp9vgYNyjYAyl/QuGw0BHsa2CeAAnn9rWZvxSlQAh2tASfA4xEQAaseAm+v/dbv6np/0vTh/Xuf5BmA9n8P0/N8/lg08iJPr+dY8jjN5YtvCkB3RcX+LR5K+bhjjwGD+QDhRInAgQWXHCSY/1AhQoYLmTy8BK4euyxEHjY0aKWJxo0dMyYBifEjx5ElRW40Y8aPIVjc1qmLl05eOZkz59W0eROnTZzh0PnsJi7oUKBErR1FmhRaM6ZLl9YaVkvV1EdVrV5dNGlR1q1dvX46xs5VIrJlwxw6dBZtGLZkwrj9EeaHjbk27Nr44uNL3iFYhhRBEYJDhxOBUZzgccJE4cWMS2h4DFlDBMoVIhAWkVmzZssPPCNgMMCAaAKlF5wGXWC0adSnWSNgLUD2agOzD1woQQNOLGLUlP7GNk34cOLFjR9vKk2aKebNSzk3xQw6KFCMqF+Pzkz59m3dvUcDH158cqfOysekl17dNf9isabu8ZNmSxWHJk8+we/wIpNCZGXVq+cPi/a7zyP7QiqQpIUONJA+lSqJxaWXctqJwgp7+kmoojQ0CjjgyEtOqkeo2uSRErHaSiuvVjSGHFlYiSSRQ8oii4xEyMBxLzL8+qHHL+iywYe7gMzLhyGONAwzxxpjcjHJnpzMMykv2ywzDDojjbbQtEyNNtVc87K02QIYs8zaLvhghj1U6S04N5HzEM44lQsGmOVIme65PK+zDjtc7NSOu+/gDBTE8qBCj71gKnHEjzYenW8LKBisL8GEHjqDnXrA+c+fRGIYkECRLqK0VFNPmm8lCGG6sFULW92Qww7nPDREZqSaqsT/E1FUkasVt2pRLFdQIRaVsghhI9k55qCi2SN9gPbHIaHFC1ojh3BBBcEYO2xJJjl4soInp6yMsisnE6GzB0RjN0wwv4RXTNVik9fMeAuQIIMg9hAlmaSKkjPggOsEhpY79UQYOmQQxg5hQAUdtBtCJ4YGFlog8WOQNzYeQ4pIGzz1iJAzrccfAGVJ5IwziIBBVFJFNehjS2cOOaWVYHGG1Vd14nlnDGWl9bdabRUG102O1pXXX/XY6pNPjAnLnGOMQcXpTwrBWo9lt3a2Wb+wsDZssaEdQgVtCesgscJW8PaEcCm4IO515y43gnEr2zJLd8Osd2+/+z7gthW42MTf/+MkjlhggQvGM2HHH2f4OmQmh1jx8RIvbxCNOeZYCjFkBjlkkUdiIomLXCnZH384BQeclEMtndQbEPwIdNppFkJ0jWyGRBUJJ/ypZ5p8rinDWGcN2tCmGIcFaV1V+RVFprMy5htzpDanaqsn0UrrOJZVWQstXHBB/GbHFpv8bEMI4YS01S4M/m+j/CBuCe5nQAK6664f7y7J5BsAAwg42wSuNgU0YODy5QRAQMVylXsgUxjnHOr0iREXxKAjICe5QikHeeHBnOI4J4bPfcx2uhudffYzB4mkTnWqy4UepuCy29UwhbSzIQptaLNGQCIZLnFVEIUIsOSZx4hHfErRmP/nPEjsyleEiB6xrmcOqFHNanqAovfiEL4sdJF8WVAftnzgAmuREVrqOxvaGKNGGsDAjYqBDNzsh78tfYYBdfPf/wa4Rz7aC4H38wAdCleeCIbwOLzgRXOwk0FGYrBhkWNOoT5oyAeOsIRjMOGkNNkEHpiqkxn5JOmYkAgXvhCGkZgDDTsSu9wZpJU5hKUOd/cgnAFxiMQr3vGuUcShJVGJTGxi9IQZClRYD3tUNMYnuoLFPDSTiw/pAcuiqQL1kW8E2RrBCHygzWxaqX1pQ0wnUYADUM0Qjv2b4wS2RMc74nFueeujHwkYT3htwANbAMQz3lTIxU2OgnyqTiMdqQn/SEouO5MEISUDRsIScg6TmTyhLG94kSzIwpQXrYcrUqnK0H0sCK7EXSxfyZCUPEola/qhznDJk3b8TJe8NFxUfEmLVtB0E4wyxB6aGEzpfaV634AaMqu2Imc+U5qgSgGoqmnNbG6Tmt7kFvzGWYQu9uCccqTMOrW6v9CsCzTvpOc8xSpPeJFgC4Ok2OUUaqdXNCygbxWoBd3aMAh643CI4+dSHnrJvUoqohKdKIH0AI6LmrIeslgZR+kjUpMw1rGzbIOqeqFSISZKHCx9KUyVp8RZ2DSnK1kJJHTqFUJkEVjFPKYxVOs00jazDCrbD1Jlm9RuUhOb18xmkqRamCJQ/zULW7wqVtl5R612tatSgmdYx3pAsr7GrGjNKxGRIp1FViegcR1on+b6nLraNXF4zStf+/pQTfp1k3+d6A1TGDv2WiQS/4BvfA3LisQ+FrD2zUikHlQ4ymJ2Jpe9JdA0S7QJXswQGQMtHvYwWl915ROoXYb1VJtMZW6Fma5VQ2xjEM7Z0tZst9WWZgIDzsIchpw98II5JSPcdXq1xcf9KmiK+7fmLjeB9VqgxfiJUOkwh08WxG52IUc5DyLvu7w8znjfsAXxQgGTBRlpY2OWXvWGSgsWlW+WYwgzVEkZh/i93csclKqb2bK/lvUv0AS8z0MSmLM29cSBQZvgBfPBzv+kRe0UV1vhZTqzDH+G5g02zC3exoCaZqttlXTLxsOY7TAa4ACLJ6DOOlbaxXacsXJtfGNOm+a5SASvWosjXeW0Fa6M6MMF+5DqTKC6kduFYEtlbWR4ZJbHTGFyk8173o5sEsw51PAZOpVl1QVIsSUJ5a+NAOzSma4kJS0zZc+c5lmTmla9hApbO9u8OCM4DfFZiYLrzCJy6NmKv/IzoJeduzYSuo2zRXSIM5Mk932LSSgAV2fS2RoZv9jF/c60pjcdQAmwoA3QTWvEiFiw6sYVoNpNmHQkaZRa19q7F794tTG+8eLgerzm/fiTv+xrkKo32QgSNDSpgOVSwhexx77/b8l/TR9MSnbaN/8vh9aMcUIOY2hvpmlNjybnlXw7DWnAgxqSLm4FP22KVBzq9CycblbOrt3uTqqhU3BbEdO73h2ANNjDHkc5DhfgZ59xwGncaeayve3yksCnCSnqu4KX4dXdbt4jSYqJD0eXFgd84G0NMFuBHJO6drKBRG6gG87H5CPJXXuJQIVcEBu+roN57UDyUZkr29k21C/vcobmlQLYeIPvuEyzXTDWW6ymrTiaJ7pt9KPXXg1IV3pWjIlMPk9PDxiuutW9RYN7e7jrhunW1Z9kAnDlu+xoh3701b52t7+drPkSJKgVh7yimTrvsHYOnfheueNxfONqPv3C/5dn+JCTd9eM93yYV0jYwv6DHTIMVfw7r3+PtIEL0MYD39EZnKM2pLA2pXCz1iswbrsporO9B8QD3bse1Yq61joDdROZdru6NnqBDYS3EEsq5HO3ensbuEmA/DG7tJu+6KM+66s+HFuB7NO+7dunhWkr7xuFHKQOXNCTyVFA7eC71usF3xi18vMuwdO4JFS/QHE/9ku8J+S1zSM5/HKZQEsEy1MdcGAD2OGyL4OymBO0WNoIk6oDH3IJMzM9adM56dolNvMlJQI61ws6Bhw6jImPByypCMwzqiGmXpmePMBA4SM+JiG+GQindzO0InA0Q+uWRjSxbhE75zPBFFQ7Ff9MLj1qwYFzrjRAOIoxJAXctlD8wVEElDrpLqBIP7sCPG9AQlbMLO4IFCjcCFmEwsWbxZN7vM6TnTBzr5aLL8RCsfx7LM6Lsi/MxWZzrJRAidAiBndAQzVkFdT7kOUBOkQCRTm8mCaCD6O7wzxchJ+iwGXyPaX7s3W7gQ5Ex3RcDEPUQDfqLdnCgRJrH3kUwRUzwROsREq0xHURoEwUONaIwU6kuyLEq1sBRWsMlFJMyIVkSIj5O1c8wlRERSUMNQnitSZswij0tSAgxlz0SIwYkCwgpfo7rIqAHWdjGS9DuZAYqWIMKcXjIQF0xkR5RjVsw5t0w5lCyGvMNliYCm7/e48F8zZlLMNPMKZw9L2tAER1G0QmUUcOZEd3nKYTG7R5dMRHfDTLiBt8TMHV2McV7Ed/1MQD2ICAdCCFqjs6YT0fVMiGdMuG9LuJlMhWlMu5VD9axMu83MgMZDddNMfZ2cVgG0liCxCTTEn+M0bHEsOOAMCp6A2XmMnfiUbKwslrezNrxEYhtBip2ExtxIOi87+UUAVwvKKkBL7caYHccMrVjMplO6oOu8rYdD7j+h9LlL4uucS1w8SxFBwZnLuEOrKCVEtYpMYOekuDdMi6lEiItMvmFA7t0MvE85i8fLxXcklkDEyWFBWRdCH5ch0qOMkEsc6+3Dy/1E77KgOU/7CZzzSE3hlCZThDyTQzbqjM+pwug9zJOTQYgqkTn9zM9/DMPKiDAc2DUDDK6/EF1tKDq9mKC8yw0mnKxVDNp2xH1xyQ11zE2CTBybgAfrtN2wRLsQzLgRscgUxL76jI41TR4UTOvltDWaPLjIvRl/K46IzO8vwojrQ6l2wBlAwzL7SILkoE+suywwLPAblOhhhP8iTPHsVRlVTS27EZM/CrRwkt9+SN+NSGCaFPaujSI8rJy+zPzOyFMv3PUEBTz+zGMgwFX5giX0DT3ltKZIxQ1oxKDsxAqSynaZpKOEKb5uNQrhTUDyXU3QyA3DRU3ow73zzR4GRRHswOtmzRFf91UZ/IOYpkTuOZ0TVrhiqwUSiYzlClTsX8spHCzkATyfozGWDMvMQURBzNTsQsqVzzHI+BFM2pBFLwT39Rhsf0VX0iwn0yD1LczDoxUzP1z+ZJ0wBF06P0hQRF0z/MMDM4iB2I0NS00wq10NfsgfIRH5YRDECVRBBNuwigzdvkEr9J1LFcVBMNTp6T1D8pBbb8k52cVEotsjSsuEzl135FvWb4VE3aAbzU0YKFVSoDNhuyskjwRZOJhCM9zAXZvyUdCCetzl9LiaODlMPj2Fp9lDvA1djTMSQKViSKimLlzGNV2Z8kkTR12VD4KSp6VgU9zc3rwGyFygqVvBmagi7/0gI2wBZCY75x9dBC1ccV3M11ZdeAnMFGfdSd5K4erNe2xNe41NRNdcV9fciFi84elUWvTc293Mv1MkfXZNKVREloStXCAhBXMEzxLNsnPVu+zEA63dGJZcxZzaSN7RiGulXNudJc5Q19gk/67NWVRdZdTVaWLVMDTdNP6AVRcNOjpLAKm9NqtdanXMecxVN3rMKeFR9m6QGrdJ9InMSilb6tPFekLdR/hDsPMMvfRMt4ZUupndfowF2qXVGCVE5+xVoaBdiA1UsdFdiO5NEo/TwjiFVUHcwXKpl8IITwNM+5pd7qdVVY+j/5gCgnXLIt+NjuBVnJUtzETVk401U0/2XcMu2N9a0GXzCG3jjKOFXQ35tWT5WBdOTc/HVH5W0IqiSCLmqWLEiBemtEslMA1DVa1sXEBVbagWvXs3Ta5/TBG6TgUYDUCabdqgURFNXa3/VgvBpe4QWJ4h3Yx8JOl0xbtY0EiSgsVlUQKI1bg7XeE07GjFXGKuXbKuWYW+XhOZOznbqpTUhfluVV9m1fYvCFamhfZ6yemH3faL2w+i1Y/NXfuEUIaPJfeHw0JYEjLEFgfMRNcmXgMQ7jGhOr04hd2Z0YG2TjV2hjf8pgDd5gDha8rP1gGhVer4UCPS7hPc5cIWBHuT0JtF3JnQ1SVMiFFnohcCiE5f1R64Xku/+FZCm14fdzQu/l4Uy2Um/zAyB2j/VdX2044l9N4mpwh2dNYlE2Bm0AKtVqU8t1rf8DZBnWViu+Yg0DZLcZuz/tgHkEu9P94gRWYHQVOL1ZgLIUJAiOYERyY2bOwWaeWkmVY+KsO3/1V0ydFRG2WR1wsrAt4SmeAeL9SFv2y/3IAiqYA7IgUlngKJGS5El+Zyr8MyqlxUvm21nlHfd0TN44BVDu1X9G4oAG6H8uBm0w6IIuhgkrhlQQBZolR46Y5Vft3LLdD3WLLT9tPkYbsUAdZjEWZhZUrnc5jRpI5giW4Nqt4DjerJUeSN6lyzsmIj8eWG7mAZqeYj+WaRK+aVr/hme6rTIC0dN0JiwXtrpmo+Hgs9t3ptOkPk9Cztt5pud6xmRIyd5wa6KpkFxuQOitHuiu9mpbKIaBRmhWVq0EbWitqNmIDuQqNluKguqqGjRxbT55FDvV7WiP/mgyHktk7p25M7+Tlte2cmZ7nWY1PkU3McJrPsBwGI4c3ePifWybxulvpuyd5umL/ciHAEwCMUkm+ARZkAU9SN6DZcmeFmTATDlJHuQGMYNprcWN9V7eGS1VaOiA5gYk5mqCRuWv5m3dLoZWXq1T4J5H4IOHJgi1poHLbuuKVjouMkmM5mU14ui7zuvqbuB54utaiJMUHWzBVumT/k3lMexGVWxp/8Q4yLZsjozsnE5v5cZsnz7Gz2WCM/iElRnt6tVs0z5t/TaQeeakxBtQq14ErO5n3PaFg97t3vZtge7VBA9r327ihRbu7inu+o3htY5oNyLb+e5ZLQKfaCrdoY3u5rPrAw5mvLbuMqaXPlIgpv2XNe5uwhbvy2np7jpRmEaoaQhnyV7v9rbpP25v/jPqlJPv1Ebqo77b/I7nJWdycgYZG66DAo1TB8/tKs9tBqdyKjdwgj7ospZwCocDC7/wGWbuM1hQTCgtLQJxXx7xSAPmFEfx1nXdwEFm7X7xJURpaR7v8GbRPafBDnZOhKrpQWdvH//xyj70QH5v4x1n+e7CHf9F8iZ3tjDcPKZeciAdiD9TA+rx8rFGcCvPcgVfcLD27a328gm3s5rFXLYmCOb+s9+aBGK5hD/IGtEF8RHDaLIrcTinbjlf2jSIEF76bj5naT8vpEBf7O9KdEI39GUP8kU/7aVOYSJnr/ueYdSW6EvHdkm3dgTR9Dx4mk5/cK7WhgMf93NXBnQXdSxPd7Am61Y26+6huvyAbyZ1657NsBl6LSwqrf6gGrJAZyxgAy0Y4IyeDAPudV73dYGTABMwBF69td0dyGKfcRuf4/LOcZ5z9o3neHDWgR2XYVd1b0pHbSVXpeWNdEvndkm/dNOx4UVw305H8E+neXVvd5sPdVL/R3dtKGtUn3dHXi98J8ehVzp9fwg9SARWQIVCWJZCQIM/QAMBhkQome4TV/iFd92y9AOIB957pfiKN3anDRQ6Xk6T7o6OT3S0//hnr9i+BPIqk1tKP2FWqjppp+EMZ3mbLeps13sUfohvV+hV3m1yR3ecX/evPujEj/cGNW4rOPkyD/MLjHzYyncF8dnfYoM/uJGVqcpd9mKrv3qsZ3gZePhssE/uNk4JpvGE6yW6w3OrXcW/btRBX/vaB3nav/371f3c9/jkrveRH3OSX+q6r/TRjlXh53aVP8e+v06oLlCFHvwHF/dx33JRz/nE/3SzZvzGB7Rp5dm3VplUt7PJ/yd6jpDQ5ouBLABaqxqnrFsjN0/40Ffx+d80CeCBTYBPxO76rwd7gGAmENnAggajIZyGLRzDhgqbCUy4zSHFiRYfYsyIUQdHGTN4fPQYZGRHkTJWlCSZMiTLlkmEKIn5UohKmDNt3nzJhMkNnjyT7MzpU+fPnD1vzCxKEynTpk6fLmVKBOoSI0l1ljGTNZQvY8W8+tJWTOxXsWbJFvOlVlnatcqI2XIrd27bs219iXq0KA8eNX6zAvab5e/gM4YN80msZ2/iOHAIT+kSk8YMEyY0fMhsuUMHDRw4oIghOgWKExwoUGCAYLUC1q5fwzYQW/Xs2rYXuCagezfvAgd8S//QsUnZteIVK2qEhvAgxObJDRJk7jziQnHIqV+8/lyjt+4PQZpcGR7I+Jrlw7s0ijOqTaXqgxbd+dP9/KBA7x/F797ofvZUk+5XRhN15KFKV8t8k6CCCILVYF130fUWW3FF2JYt46Clliiq7PWXVl1oRZhgIyK2mIkm8gWZZCFZVgJmGVCgQYyeeRYaaaSddgFtt/HYo4+3+dabkL9tsIUlxFl3XDcLbTcdc88Jw4uUU0ZHHXNKbqddltx9Z56X54HXknjoieSfemf2d598aup0lVRW2cfmTe69+d96TbXQAhFT4RRfEmY00UQZeExijDkJQojgN2KBpVajFT44oaT/bK1TFoZtfXJKXnx4mFVkJPaFGByK8TEJIYsAciogiak4WWUtvpiZrDTSeJmMqOHWWq64Afejr7/mFuSQAgTpQRpwGdcQOt4t2WyTVTqXUUGtvEIlldJBRFE7WmbnrERcdrvRl+ehRCaY5qZnpp0ApjkUUgG6OVSaTSn17rp0tvBfUYKakYcv3/jSIRdpQBKLNocu+ChdFU4a6YOabsppp4TlweoZezxWIiEbm7pqY4RJdgRlLLo4q8kfXJCBZ6jhuqvLL882wI7A0izssL99oAYx1VCjLZbPWintQNUSDS22EinLrbdbgpvRuGOCVK6Y50Kt7rr30otf1nO6q3XX/2dejVS+N+iptVN7zhQoVosU84gSOkihAxdbQHEFIF2ZY8+hXjkIqYUUSpohppnqJfHEe7BKahykcvwIxx5nHJkTVbXkouUlkyBrypuzPHOvvLI2pGwy11zzzb1NAMIeO2ezrc9LWwN0k7MQXa3RRyuEpdJN8y4uemHyQN7vVU9d/H9jH29vm+8qZV+cQDlvVU/yCqX82WETkSfZ+OYEBb9qPGLJXlugRN4KHrzAh6EI723MMgr/3VbDDscF8SSMHV6x4oo3bmrHH//lCZOrHKwudzkYIbBzuxIW6Gw2Os+V7lenQ50E/ICkJOkud0yShpM6qByB1K5ouGtaBntnQv+NPI14xoPaC1roQqgwBXlJGJsMnzKv6kkPQNPzSfTABkMfXq2GaatCF/wiirRMQg1OMJ8H0Dequ+VNbwzim9/oRyGIxeJ/KRLRxRKnP8b5T4sYC+AAw9QijxiwBHmylaxQxrKW8cqBE4RgBB8YmwkSazcbWF2yXvczD0pkWiGcUrQKCcgSMg12vfsS8NAjNaqx8IVWI1tP8sWnHy4vP8yjXLs0yUMg2jBsmHSK90pphSLuIRWrwAQcABW1FcByBVfYw8bch7BjvE8ufYvfpDQVvvuxKlR+6Qsxhbk4UjnOfx5rVRkJiMY1QvOMHPjAZ6hJo9Q0UI6y+U0A6FhHOz7/UJs3Sx0fuGHOdPiRW9CRDjIGGaVCyk6D8rxIIk/otBSWKZL6dCQNd/BDJlhylD6Ez0Dns0P+WE+UAl1ooEAEPiWS5whXuAL5YrkCkXlkD4ZiBzvI0T6+7ZKX9itcMLkoKsdk7Jj9I2krJ+rSZjozmmiU5mamSSsKeEBH2RTnNnvq058C9Y5BxSNvghOLC6YzdooU5O0I4s5oAS069vzWVLeDT8ucpJHo2iq6JllJIcLQT+3ZpJriRD3qKXShap1hvhpaRCVyoSNxJU8TJeCBGmTOAyQAXyrc11FyTBGkvFzlSCGXsRCNiC+KXaxifpmYMZJxojBd4cicidWa1vRF/xLYKTfz6FmeDjW0osWjBIyE1KRucINOtRZ0RIgd3gHjdlWlKrNqCzR8anWfxbtsPyW51oWKVU5EOahZQXnD3zpFiGUN2WTOp1e9FlFkmXsXXxHk0Y/2zRYjtYT4IJeGnaThL4wdLzIN26mXwhQkGPVqZU/g3vfClzMnWMGLdNXZz+IXtKPVr09PVyRRnHNZSUPk0GjHWmtJKVvhSi1TZ7scqFY1Ov6c8FUhyVVzgRW517vXJ+XlvOJqMpRtOm6Gm9K9gaFYZJPLWKowsYpVnqEqMiwiIFBhjo7ekoqqHOkmVoW4MUrmCsMcJl8+9kXFHfa76J2cq9SrYvZSBgYggf8vfKdcGvdWU0f53TKX+evlORrrFKetDpnLrNQPrhYXaj5wQRZ8ZoxEiZDOsq3Q2mxPZx2EwhWunJ737MIalljDZprX13j4SRFj8rhrNWWQrxBLJ7R4Fbh8nzFSQYg4tPd8JGACKtaHY0qnpbDmDSCRWfzFij0RsuIN75LL+ORXG+G4OJAyrWddhFsXITS47sGepgADE6RmAvftMlGLbWwieQAOlGodaimC5jSz9rXbUI6bH5JmBavzwbSlczyl0eermtHP4cmXTHsLygwfNz7uWlMPn1cvr/3wt22dcZB5kNePOCEOLqb0pFnp61g6UZXum7QxWPFiTIhxVOFddWL/M3bkkjKc1a1mMqxjbXG0XbziMKm1F7ywho5PoeM9CHkWSr6nFmRG2MM+NstZToJyaqOPAp55tpsqbXo6w8wMsbacCczBn2+7aU9SyIUpK+4YyHS+MhU0ctE0veUSBV/vBmKJkQdorpUhKCa46MankJhLLAOXlLDEGtbgaFhahgl6cHEqLiFwgyOcpQ5feMeH+Zgfk2qMc4/sxItAtyLwwNW2xgHFM274jJMc5GV3jBYYb/Is7MRWWiY25Stv+QOkjm0BThKzfQ7Iqjr7Sn8EOulLDyU73/Pbwys668k9X7JZfYbyBm6eAPoe5Z2VrBtmukDh5ZdGkiDthHgfIFQM//jLKiHkLWZ72xGuKk4lWch1D2+qG7O4vYec7y+VaOABP7ldd78qhB88+Q/fa1wrPg5sIMQf2ND4x0N+NC+6PP15yuXMj2XzNB/wUk1P7f9PBDNMW7XxnFQ1S835X53JFgqpntE1IOtRxhrB3tLxXljNkEGdzYgdhaFV4A+Z29Xxh2RVRl5t1gagj9fFwfGdhEXhW8eVCsLB4PMBQuREFvUhjsdAHw1Kzor1Ha65lA9eAfehzVCMXxEKEPmFXBJ6gUt1XOM9zseVXBRG4VTIiGrUX8vdH+atwJHoX+ch0pvBlrYB4AHuXHMkGBn2XwLC2bUZDRh2wwM6IBxiGG9pT/80daDZ4Amf0BvzvEm7cc/WBFqiSeDUrYkQZIZz6RXySVTdKR1K4AAKlkohSGIMdojDvdQS1t0ToZQO9p3xxcStvRQohiKvTRQpIt6nMGESSg7IjVziedz6FYIezMEcSOFhaAHk0cCtbJbKfRYvctMvrlwwbllwPIJabJ4X8p8iueEYiqGblSG0KBUaguH/eVA7GZiaQdjPOYsctl43ltvr1WEgChpACRF9yEkfKhoorZXtac/WMBlN4ZtlqJfyfdzxPeLicMwkJtxjSFwq0uBjrKIIwlr4dd8l/iAQ7iAphpwoqmJDOuTIFcFCtiLJzcETHsYsTqFoUIZm+SLmAeP/R15eAxFj/p1TFyKjNPZMGmYjAT6YAEbjSzYJ6U1J0ZzhMr6kbnkjN8LeBH4jJd2h2OAh1iFUDz0dcolj7B1FDIRSyDlBez2Br00ZfVWTF2wMSETkExGC812C821MSimRQfbjxA2kq4FlWabiQ6IlKzrkRHnBRDpkFOIjwmFkLTakEcwXCQSbsOklSAojUDFQ6hyBGhQMspRkYTJbSqIkcmADmjEjdzhEM47eGs4kKLiWNtpkNOJkTnLVBCodZyYdUv5kVNRH1JnYH9aJOuYEWOlJoBGeX2jdR8AAwOFUTtnVxj2iC7KfPv6PxWAiE4Jl+c2akxUh95llcaZl9rlm/yai5Vmq5VkqX27KIi3C3+NpHQhkQAmWoEfyZV/+5QRsFgvIjR8YwiYclTkRR2HyTEqqp+tkG7e5pwG653PQDmXSZ022J9DppGZyVQl4pgSqESUZUDuG5qAVZaG5yYCO0iX5xxIkofhBJQ/EShOhBAeokZRdZRzkpiQmQiw+HydKX28Cnnq5BEvAiXOy5Yn6pvQ1JIkoZ4uyIsj1ZmS4ZYwm5yxapCvS5VSYgHXCCHb+RkduZ355pAmaIAvUwBakgSGMpyr0QjKwTs/wjEmyJ4P93zM448wFnc5pEDO8An3WpzDMU+ipoX6SKR2a6WemkVNWFu99DUx02Dkq6CVNnf9CgaANTcVOQF7tMcEZ6MEZYJVoyMdmAGrJrd0l/IGhcuilbSKINuhEBSc8vpcn+uPCpaiQWSpbemWmjsqiwqhg0GinpmhawuIfRKctXqR0kmPK+WiQCmke6eV1pg6RGumRIql4hsKtNmmURmk8qEOvnqQbNpsyJqZ18MIogEImfKkGYdBjJmBz5KeFaeaZmuldYkbw8ad7LVTZsJd+bKt/iOO5eaCAzomeBOoH6AmfpmCUaaTS8adoZIGNaiiHcupDBueUUWgBRerFmeWIXOr0pdQmAuymCqxXguqnNqqJNmRFIuqJ0KKp9mn85Ymq6hRIAimx7GXKbECsskCRksD/rEoB3bSBGdSBH0ACKYRCk+ZqSeqqeuacln7hsC4JLRjrl7okzC7jdDxrmYrEGZ2RGhlQBBoQj6aMuQaUBwJFiclpQnmSbSIoQ91pHkIPeKGcdWoAU9IArVmOyhAtETynHuQjIbif48moKNrrizSRZpjADuHppCInjC6hDf7rMW2i9aFU3c6r2xbsWyZnwsKrJJaqjeIjRsYYFa6qdhpuN32kd2IskWaOkc5qDXDEx47B5I6seA6CIxQMyj4pNxBDMvSRzE3plNpss6iZsa5ZbFnm6CqVQSRDZurszqJpNKWR5iiu1orr1dKLtrJX0g6agjKt7g6o1SFP5AGUfMTY/+WczbqqzJ96XVeaCNiKrUTWq0fQbk7hlAZc7dq27cCmVNntweIBAvgKrGEtntwG7L+6KN62rd5m4kV67fua79/OIkZeBgJt1pCuhgAormoobgTsIuPyaObUYQ3EDaONAYEUEyQsggIzKZPuzJM+QzasrK8mFQatJ0Sc7uneXOiKaTB4sLO67uuyKzT5bBphjv3uZeoQLXyVzfBWoDmOVe19K9iIIzkWL7vJR9ap0bv6qc8aQRYkwhzoqGWkABCjQiyaakbqWq79WmbkVMbalfVeAPZybS0yzvuulMeEr8esARfH7/fCwRp8L93O62Ok72DorZClCvQGLBbHb8eUyP9WGuqlLQEbaaQGcNOOvuoJoMwBgMAL8EQLmGDmHCk51p6AvEQTbNH4/EXd9EUbFAwsSLLnugPnQmklW/J68uomxwNi/hwpxBYw0EK0cRBMrmcHO0fOirB/lnArn7ATb8AFAKkKy+MJpICeiIbr4e4kzanRkmu3AvNTrObJZY8EWlIhViRAYUYEmOu70uKstWv80atS2kgHwMrm+Ch2TjEN7Cn8YnGGwmA4F4IlbMwaO+8Wd7H6lW/4mq+mtq/6nvEkyrHzopQeoEKf1q09W1rDut0lGBwrXIJheN0lROcclEDqxJhOaYBBX4AJJEYW3M8OCHAQoAoUrFEeJFFDVbT/GezFDpSBpRHR3BiJKKQBHYgsgBGDyTYpJk8wz3Ayr7rOB7fWtZTyJSMmB3OQTENECK/ymR5QBggtCh/uj9bIfJGGtvoucqUj0wlRhhlzUv4yMQ9uxCZQBDxABKCNRE6tBvjse8lfNa2MBMhydroMdkZACRDBHCTCWidC8xmqHI8dXG8ld3HXqnSxFqezOsstXnMv+rqtO2Oo86kfhlLCKtBtIRgDK10kJhAfVgY0Pt5zRR4xnn7CGQC1HiRCCaxGBsxBCmSAYZSAyiSGtd6Ai7FVC+TBPSfyJ0wCUFS2EEyBV8DVn+CFyNKNKBCDKvjByEICzzRwMsRcyk4wynpu/+wUGDYOQ01bR0py8DMWEk+X6Qib8CvbLzYPtatytQ/3UzB3ay+jplLrrvB+Vawdb8kwMwic9bW6V6+Z3K2oUY1AnmkEWx+L5P32yi6KNVqrtSvIgiy8zz/3c9v1MyXoYzmjMzqPkRezcxtr6vnabSGsgqLm81bW8yccsZF1Givgs76lAouhQhCjwj0Prj3HmIVngY4sdAxwNgwA9X9J9KatXRnwJ2ofsex5rWvzwQyogcHNtvp8AqAgaV6cgm3XQUqLLMkmQy+cbK72zM4kOZSm5wfL7CjLtDUst3VQME5DGHR7Y896+exqTnVbd19OMfZiq5quKdIFqlI37TgChf+95DBPEO1/wkBQ3Guda0Eh+ClouHdpuFFZ2zd+/yj/8i+Ko3Ui5AJH/YLYHVxhv1ijc2U5l90WGxYZ9zX32m0bEwKBB26kUwL4CvhiOAYf7Nj9jIoqeXiEq5Ko8+kxyGKI60Fol4AesHifBvAVbN1elUoP03hHt4DX7sASfEKOOwGqq1dWYkIXBEGQp1IeAIoZdDi/QLIq9IXJWru1C7dvo6zJhnJx76pLu7ToLiOXvy4JBy3tck7K6GXF5lF6d2a8kdtqtjnV+XK909tODC7ZMHO78oR7YY4GUAEhTAGv6aICuQyt0CZuiDU2p7tVn/UUFAJ/s0MuTBqAG1xhE/j/PCcqOk96Oi84g9vtOi/OOrudog64hseBYTtGyVua9QE0a7Oz26X62gWxYVSkLHitKxwqE2hADBQCi58BJtBA4+JV8EUnrefJibwEsCdBZZuAEyDcFHAEpGVlUyoBHCRRXnxIwJwSoOAB10/uAYfsyGIurjYprkpylUP5yk4wSho3ufP0l5+7/Yr5mFshXw6tdqd57gLvaXI3gmaP39OLoQ3umrMrUN+UnrhXFlCBFqDAZ8BRrqR72tpKWL+Rw18+9mbBKpADR5HDov/zxUO6PEs6O5dvpoN8XudzXhOCwc2gP18a7Oubnqd8KsxBhJcIQE/iqMg8ZMdiyee+ZG9o/yGEHCrcgLneeGbgVdIrEa1TBrrqAUAtRtoO+9MrakioytvMQKlAe0Z3v0ycElcswhg0QdiLfR2cv+X6ASNUAimUwpJ7+7eHAiZTsDI2A9yrsrm78nmnHEBkuDBQIMGBEhAqYLAw4QEBDhGCKDGRRkUhF29kvNGCSAuNST6CDIlRZMmRJ1Gm1OhxI8uNN5i4zMiESRaaHLOcYQLjBocIFDJU0DCUok8NMXJSYaOCQgOnCaDCcNGDgwQKJk6gSIGig4afXwl+rdB0YIcebCgd+7XWFSu3q+DCpTT3UiBMhQjlBQRozRq+fvf2/buXL2HDfAjHIcyG1SVAhS7djXOJFf/fyHHiNJ6MCbMeyHlX8c3cOFVkQnwmo5qz2rMxPXpQ/SEU6XWiOTSZELqkRIYJEiWEYCpDRE/MFq9z63y9I0kqPiScTFJDSAh0PtNl/EZc5dEnPFbK+CoOEnyZSb6+1xnTZn179+/fvKnDyJEjUqFCVdPvjv83bvHE0Y+aAQks0BrmdOgtiB0SfMFBBRuM0CMTIJyhwgcxxKqFiTjkEIQPCzIoxIgOYiiinyRw6KEJghrKQYs64ogkkWRSycYbVXKpxpM6yogl3G6CqabXjCDqgw9OIO6PLE4YioMk/0CjCA68emoKLbLwqSkXe9AiBhTGAousMSlYAKqrvFiDFXb/2PmlrbreoouuP+7Siy9LDssTMTbsJIRPNlBLDDHNKNOr0NQUawy0ziAb1M/R7lrlEsxGe221S5apzbFEEilEMz0wQwWT6iZagrrjzpgoDz1aKKO4VSl0ToYrJsmNCRLUgKMLQkjwgITrWshjEjOSMMM58qxoArxF0LOiPTPqiJY9+Ki9Y5D67sMPPwHd4ZYbAavpZsALyS03w3PR1bDDdY9sV6ANRCxRXhMJOnIgFVfMgKKKONqQJCJwDFjggVUCeCMigLTphg9LyGI1hYdCMgWbuBqqAqg6YOOLHoqo2OKLFyATBS+/bDLMk8ks08ymUFDzlzbdimQuueSsK7I6/3G2ZBK88uLZsEdF6+xnSWczhme3+vo0ldMwWdqLxzjjQ9JBV8HMNNTcstQzV/BS1GZFPXstFVTU2FBYB5crYbKMQEUsVjigKwSHM1KNYwohCDHBAxn42GGDJIYlYYdJ4nBQicOTtYLZPMqAQtk6lH12Wmrbu0PaaLUNJZnN9/tPnW8JlNDc0UlHd10PSwDxXYFYjDeh1w36KeIMJqg93w+K4igGgnnvPaUaZepI+J2SqCkm2Z9EmCYaJrJ33pBR6NiFqSqGSqF5v3pyKyo/TtkpoDwo66y0fiGnrcZqjiyyuSKVzbS7cO7ztPn9LMwvT9cnFGlMKkst/9OktoqdKf9qNHDwX6gqY6lCwcYxkHFL1HaGmGWkgm5Go4lnzIYJsyGmb0GgYNxocKUXdPARM/hbrXSwqypsoASB45CyyPOJVBALWmZYD3uIdUMctuEO65GWD9UDRPowohT36cURwaUf0ZWOiRRK14ZOhzt3gcgqqytI6wxConpN0Xb52pe/fDeTMI5kRy+5kUdiIrzi0YRJ++IXwrJABYANZSANqONVqGSB5KmgS1o4QeyuEr0UhOko2+teU76XMoKcIAt/UMta0qe+SEpSfXVazGDkZ6isXaI0nnoTXJhGmlQYjWpjA9vYOmMMpy3wNZ4CTQPHZjTdhE03qtSDMRrDv08s7Az/rOIIbPqmhA/uqiJ2y9sOAPECD3QhatMpAwsXcasNTLNY5MnDscqQuDY4i5vbBKLkvqmeIK5HDOWMj7WuZURqNHF0K2AnFKM4xQ9EQHVWrB3rRlSiEIHPXiq6J1HKeEZ+hURGxAOjS2L0kQldZHj9Mk6/hIRGiP6LjbjRSQzgCZw0sUELWuIeI9FQiI4KJXl/YEP1hoICF6zBBRYgkwXO0oMQuPRkDkDZmBbggaOsAZIyc0un8re+0kiKfe3LZJ7kR7SmySVOjgEE0R5TmqhOYi+6DGBhUmELy4QGMboR4FOdyr9lROpqTTvFKSR11qYBIgmvaZ7UgjnMSWxkMqk6/04LNkC333ggV9ppwodYiBkwLsI7NIFhE8bwuCZcDnKXe1w44WNOczp2iZV9JxT9ldnTpc5e8lwdPe0ZotBu0V0TeAhELgBQHNVodwrtkb8AlsYereQkGzJOGvulu8weTEYjqYlOprATKILlBGhhw91MYJQQ9JEqZMKBSVVgyDzS9ClmCoGXVBAC7YbJpt3tbpnkVQS0uOJl7MhFYzoVG0pyspLwywuefnZUr+IlUjtjX1VtgQn4mnWt+OXM2ABhQLPygb2PiKpzJqGo7qxigglW6iWKsVT4LTVsUPCNEyojA7yVzTxmM8YZQHADXxZnmic0mzQ/5KoNSWQ8jiNeNv+zeVgZP46x46QcfNRj2cuOriUZ3Ww9gWxFIWNxtEKmXRcPMJAOuZZ3uhWebXlbWzNC2aEPNRhDbbsji2ZhxR9CkUA0kBUT9OBKMn0S98h0piRFj2MzVdmZ4NwUPXagA1sRQQVmGufqmonPLZsMeWEWp0iMDU5FbS/P8ALfxxxVwfIDjCsJY9bS7De/YI20VCUs4QNXldBinfTY0PpgtcrwOrk6zUSApWINqOETtwrWhkhMzUUkAVU0qnWrfAllZcUYJI2FobQW29ga39g9Odbxjsv1QnY1L8jNBsE98dm6gnw2nxlwHkRQ6yKB8SRHCMvtk1uLkhjFCKJXBp5BxVj/PLrFxMvtSin3wsyx4JqsSk0J2Uu1y8foggmRTplzdseiRxEM/M4QcACf4YxwDvTABVjSgiPbJItj/LTQ650wffcLCJ3F16uU8NklQZPxShpmwgiuKlUPDEqqws/AgEAr/LKa1lGXfObuVUNGdCI4u8JkYYKbSBlSV2Kg44puvbxVWy2F4hZYmOmOQxayfB2tYAPbxu/54XqQ7U529nizs3N2kaVd5GobGcn/BKOPMJoj2pKb3L0l449s6+0n81yiEp3tSWgyHHYlCUs9aBL32KwFNrQ0fGTZYwfknBUXYAEL/JYzBrTS+O4mwAGQH4IPXEBnmlpApfy248IFPxXB/yfiGOadOGUGbWhJ0om+hdj4x/vEyQfGxZLy05l+N35yA6OcMC3vznlwf/udrZzl/K358I//ckwsAlRcZ/aRgg7k6P8Gigyrfj2p3wIkbMhxTicPsBdbhhoztthXzzqEgJAd0vmYXZ418pCh/f4MTDNe8LfdBBggOwqdwEbcpi1HbmuiAspHcsuhqCy2BjDdkOUmcgcp5g3erAIF0MA2zCyPkmQqNK8CXApJGI8rMOADOU+7QqABBoAEB8AAHGDxhoDxWkqPVkryxoRK+sjh5sAVIu58VE/1ICN+Xi+pmKqoCEFnfCaCeI/kfqY7eu/3hk/4lpAJke8JoZDmZGgKl/8vD+LACK6PYb6u2XrF2fYKRJDgNxzHI2YMcsRv6siPcqLl2M4PQ5wvnqIPtLbw/eTQyC4AXurvivAlyayNIlBAI8Ltd1qC7e7OjJgMtw5wEIXAOIQgARcQN2KgI4ykSuZJZfaIejpg86iLLMykARgOAz3QparLes5kLEJgekQgE+dMSxLp8+rM78JsDmTBvHLhGHDQ4kZOCFvvqHZxEl6PCYNQ5ODL95KQGJvQF48xGZUR92jO+NhLMjDDOKDP/b6uC7Fvr3qFBVSHBJAACrqx6Xpt/MSJWsTJ2NgQ2TKE/SLAQ9ptDu0wyFwnD4NCDpHsIZTMjdzI/wDRyWLiYG7/JAD70R8d6iUMJiBn5CCBCxLpTYvIRGJ6ILq6AijSrBQ5QI8gTytcIBVF8QG8C89AkPP2jd82cc/ubSFAajZKr6cCYSWF6tB+cQh7ESYNRfg0riZf8hEULRiRECedcBl9shmBkr+EElRiLHWezx1BxCi10BpZQBuvsRu5TxzH8ergAx3RcdkkYinhcQ7rkA6JjLTs6bRWRP/2LxLTjnnOcoxgwgANkqAEEN3K6LeIh41y4o9EJqaUK/A4JgVY0fD0DQMCTgVWEA3ujCO7awR8gAyGoDBtarmwYDE/8HsSDuHqaOG6BOLY5Bd+SmYMjfV85jOH8CV1UjR15hd78idP/1MUkBE19Sv5grLTJk0nWkIrabPZnFIbcRNEmtIpQSAMudH7FgsNxw+csO4crVL92E8pJcLr3gW0ulL+qFFEvtKKvqIeH6IPgQNGZsLtuJNgdK0QGXEuc+sfmUAN9K4EUoAIzkCkqORIZJANlgRMqIsDVsou+PJkYIrxsGAEOlIEfAAyAZMjMQAVJ+8BTlAFyOALvGSmNrIEq2tMzsILGG68Xkbicin1OjMme0YXOXT4RhM1U1M1Q1REWzM1X7M1Ye6sYJO9Ju017EoplfMaZRTIpikpJYIbPwQqo1IqfyiIzPE4k41Cuq55YlQDkPJI3/ECWifstghFTOu0JkD/YP/rYALREMVNRy5Cs9RIoQYRttyuYH5rxQZiCuITBZKLSk6gK7rHTDBABaYiJF1KeyJy8kpQBFgQ4GqKI0+wBOuU4BbvC3zApSgTp4SiSzjKTNngGHIh4ihOBy/OQ3fR9TBuNTvURH0yFoqPRDV1U12zvU40RfNHNZrvRo/SXaxxCzeAN0lVIrbvQ8aQDGsMscoviIC0N7QuSIe0/bISSbfxOVeHSeURzD6kdp50LLFzQ1JAy/yRttxStlqLJWSioLLstshT3dgNIRhpL2FRS+5Iz1JruR6yYyryzeCsBEOwzkQguxjTQDvSu0DSB9bABzJxFPEM8RRuLHJqDmSm9GD/ZmYc9VHjR0OJT1IlFWBZUzU3NQonwTU71RlH7dNYNDZQgWymEXW+cFeBTFVrFAR4U/tcVSK88RuXTnKGU5yM8ziTE0ZtFLSmb2WpcSvfD1gJIkqjNJ/EsnYASswqIlkxqmcF6qDWklkRqgC3tGDUzSZSh57WMUkQRltNQExIyixiAE2jRwtAEfEM0zA/UCMdYOBcYAWHgLtsCiRR0eAaAAJGYAREkAQTgAMkFLzszXquoo88qU0mjjMnCWAJtmCZsTT7lglHtDUxNWGdsGGDEhMGF0UzrZImllNIDKBKtTZPNWOtr/22D4q2bwxp7Oou52SvMldX1Shb9mUr0Veh/zNJXecrqKhY7XEdgUPMshOjHJHW0M0g2xLdDiYABQpItNSkSiYGJoMKPCowlSLzAk57sCAQDoENsDZMBpQKqCAjwyRdqUAxA/QwF3MEAvQEG/MLvkB69Qg/xxXOFm4OoPfh1MJuiSqoDE1vmTBTLVVhJyFxORVhV1Nxa86sBvf28sthW7JxPwEvuAzMOkSeLnYONTYpM7f6kOByRTaxIAeIHqtWcTVlUccrjFQrI5d0YTZm6RCQMDgo9hABUkvbsmIraCAt3RIQWwIj5u7/gpbucFfK1qiiIBFpneQEqKBMPSo9USpudzgR9nPgTkYEMnJes3ZAFTNt+dO7uHdPuf/XBTCvCBpO8FTAKMKkXCngFLWACpIiEthEfdMnv1zSfR/VcAmXYZGvYWvOFvrXf2cG1KTqNpqEdviQg3mV+i63cjsECqiv+4Cz+4qNgiu460L3kL2Ms+Ypj0/3g/FJtBb5XsQyyUhqyfqvS9OIRgDm3HRERoCHWc1ILneCOfFVA+Jg8L5ETfvyjlhmewiu4MQ2a7/CiNP2a9XWbKHYQR3UbE/ABdBAEL7AzfSsXAspBlIrUcuLHW5RB//1cNUYf9E4f2du0tw4f/Orf5VvLmQDNWIkAspOWLewC1U1gb8Qr8wZZDekG1lV+wQ5sQK5OAk5HfsYK4sUd0a3kb/OdBv/+csAyTkZoOxKmEN01iIgSlq/lCTUEpQRREiWZyKUtt0YQF+0h+Egsns+piLr7SggEollWZant5Yzson9zaZ2OZE6j2tbUU/jLP+AN00CobwgiRNkmi46yVPZ+GGNT5r912EftjRU9Kf/95ppLzLWwDwtpEQWYA+nk5FlNPtagAU0C3O5Dxwd5xsFmYk8V54tGJENeHaax0j1GZ8buWZr558jGgScMyuVdJLXMWcJ2smmdXYTWtyCqwU6C2rjre+yYCrMVyTVNAU0hgrwlOBS4C9jmSMvb7BHYAjIgAya2GzbFbLrtQgArkHNlbsosgHKdxVehhzcZKhtWsKwGad1//qZSZun5Ti1aY9m1OdRimAG5gl2kroAsO2OxdoLl3KzNMvCtC+duW/pli4JrlpZLGRBijurL0S3o6iAbbSzFBljuZBXw7o564hFahacUUSpA3qhBkqFFXquj9u4F7qGKWYj9E89p5YJOMrvtCIGQqoCA3MCycB4xQIDHi4SqIAxpxcLlpgx0dYFfgB83VWyR7pN3bSyG5OJs3hP+ax8C4FfbfEtVtSnRxu1UxuoLZwKTxuoVZvCO+k0JNQ3XofPSHy2afsA4g8s3dEasTH7lDuqF7j7Rna4w5uCX1xXpei57zk6pRuff+LZRKt2vBmcY3uEU2vJWiBZYxi8x8iGN//kJ4zgYdrbA9Fsh+VoTsO33r6iBFVQsAfuevHMv0k6ACBgCMw8bSOzQFsRAiyAzfMtMfdTAw+bMjsgxE8gDmyQHPS8GEBbwj5NqEnbpwN90Andw1X7gUTKbpILqU38xJWaAE5ci26bNn+jV248qqOat2ecxmscZW/8Yon0uWU0g3sVuvN50sXuntLan43cnl/31V/roBGayZnMWoULBvzwPpV2wUNgCKYCE6vEAIb5bE3Ra0P6Kx7UMM31ztpUbQsupb9nzDV7sb9XzVc6fHCHAzwgp7yAFY7BHL6Bzw1d0AFd0jg8q86d3NO9w9VdwokauYp8tht93iF9klMc1W3/1NIvHbgxHXOhcriZDrnJRdk+nfr2qq2zndSlaB2Tsg6VU+FR99RLHa2HfDrpUbstORJlvdaZrMlSwoaFwOhmh162ZB3HQqP3kkH7rYjTldmNeAXB9yM72kAHwM2ZGMyjXc3/e6PDN81KfG9wYA34Jy5AjRLOXbRv5sKB2hfUfd2V/tBbFIf1sLYdvd5PfJKxjUQ2FilZXHT3vd95O+yn2tYiRLyxut/n2YLZsauljzmZ2sefE4sYop/76Zu1Lct267stYu9nHSNepMb9/l8YGmmZgFMuymMq82PSs+HS01A7qhQ1cPHIIBFaapZTYAUTAQ0kb8Ahe9mzK7pwXucx/4CxseDXfV3XJQAPV8AsvMCAvCrmVhsTKKGa04r23disrpnp0/2n3Zj22f3CQZx5jqTsRtjqA+D4jR/rVV3F8dngXTzt0V7sM53WQAJoz379cpW5FXnts3LHm/vtxXrVqS1Yh5V1zzrMpnTj+X792Z9L3bC43w6OeII1lOIT5uCPMFgFsIQruhggtKgIcSJFDypohmCowJAhiiFUhqhY+KBiggdaXCEiM8IChI8OQkKoKFKEiyEuVKj0EcJjg5ciRWJQ4SIlhw4HBd7kwKPHmkKXKAlNRSmVLaNIk55ayrTpqaNMfaV6OlWqUqhJVxFVqpTPGRwmPmSQMKHsgbMECv+oXZu2rYC3cOOiPUv2woa7GUDo3Su27wcSfAGDKEGCcGHCLRIrXsw4MRLGUBovDkK5sgzLmHfc0Nxis2TEoEGLNfxXL+nTg1OrTh0hMN+8r2HLnh07b2vadi/orrtb9229uucKmJAXdAoam5MjXz6DufPOzKE7V069+hImX2/AYEKESJY5TERoGP89kZbx4ndqGGABSyCdHBo2JBmzQYiaLnwMBAmSvsghPqQ0Qk0qUUQBTAhGoKBuKBASyB+FsEEIUEMFxdWFUy2llVMaWtVhhhxSNdUlthS1CiusjFgIH1McYcJuZhkgo3Az1hjAjTjKxRZdElxQlm6vCebXYYL/ERlaCZ91luSSk1GX2ZOeNWbCYkdWeRpiGvzmWmwlaMmll7WFKSZutPEGZAa3tRbjW8SNh6QIicXwXHNTnlDnC3NOlyee1m2GXRabzQGeBif00F0K4zkk34EHLpAATj0YtN98JLn0kUcfdRCCCJyKwN9IIVVqkg+kqoTSCB24xChJhBLxk1AonghrhRhe9SFWIH6oa1UgmliUhRF6IURYZNFoI406AnCjsjm25WixZtIWJmpWHilZlIklka22TELprXJJTlntlaOZNuZq5453LpnsjplmXsRt8CNsCval5ly6uYkkDdLZSacJz/nL757LSdenn9wl/FVDGvSQRRYx/2S5YEMXvXRRQ5AKyGkKGLRkaX8lnSQRRfXRZxIWLrQ0YIAEoaCSQVpI+MesFsa6Ya0Y4nqrrUdpZZUtyvQsKyUrxkEEsQvQZeyxcTH7lrJQRy0Xb9FKa6S5Ro57bbZKct11kk5+y5nXYyNJpdZ/hZb22oMRNtpt6q4LApjt1q3lmWPh5WPVZ35w25ptIjawngMDfCfBYfN5cMJGKOamgikkIvkUMaiU6qqM3rRpqjicRAZHGGP6qUwi0CTg6CBjQBF7XwSChnuRSG5h7DX7rJWJOeMcFdA6/7xrUkcBAoiw8QWHb9JLz9j08lE77eyzVeu9JWBqH9Ztk59pG9nX2f9fJvaT2Ds+7tWque1XBKgBZ/6Qctft/rrExQ8jkPX2VSyPF6R9uMD8E2yw4tE52A0S1gL0SaxegvpDAhPRgYlpLlU06UEDK3IyKnhsIaIDWUhmchKNeeojH/SP6lQws9iZ8IRBmdXtdIczZXRIRDDkmdCOYok9wOEKJxAL8pL3PKY174dA7KECooeX6WnteuEjWwu2l8TEee+J3mKS2dBmvdaIZkxxew3d6Na+dt0tXvAKI/36liWzlIVN+TMODP5luP3x63+IS1xyCAguO8EsCy74zhwOWAFItaQDKfDYAxhQERdEAguWw+ClNGgSMkgkJRL5oKcq5gALhIAmXzgvxAlNODuh4A5YLLzQ73aXO6gAIg06AMz9eshDHwbxlUKEnvuKdEQkJlGJYNNWQAAAOw==";
const Rie = "_defaultRow_1syin_1", kie = "_dialogActions_1syin_10", wie = "_centerRow_1syin_19", Mie = "_textArea_1syin_28", el = {
  defaultRow: Rie,
  dialogActions: kie,
  centerRow: wie,
  textArea: Mie
};
function Pb(e, t) {
  return Pb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, r) {
    return i.__proto__ = r, i;
  }, Pb(e, t);
}
function Nie(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Pb(e, t);
}
var Tie = function(t, i) {
  return t === void 0 && (t = []), i === void 0 && (i = []), t.length !== i.length || t.some(function(r, n) {
    return !Object.is(r, i[n]);
  });
}, tw = {
  error: null
}, Bie = /* @__PURE__ */ function(e) {
  Nie(t, e);
  function t() {
    for (var r, n = arguments.length, o = new Array(n), s = 0; s < n; s++)
      o[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(o)) || this, r.state = tw, r.resetErrorBoundary = function() {
      for (var a, l = arguments.length, c = new Array(l), u = 0; u < l; u++)
        c[u] = arguments[u];
      r.props.onReset == null || (a = r.props).onReset.apply(a, c), r.reset();
    }, r;
  }
  t.getDerivedStateFromError = function(n) {
    return {
      error: n
    };
  };
  var i = t.prototype;
  return i.reset = function() {
    this.setState(tw);
  }, i.componentDidCatch = function(n, o) {
    var s, a;
    (s = (a = this.props).onError) == null || s.call(a, n, o);
  }, i.componentDidUpdate = function(n, o) {
    var s = this.state.error, a = this.props.resetKeys;
    if (s !== null && o.error !== null && Tie(n.resetKeys, a)) {
      var l, c;
      (l = (c = this.props).onResetKeysChange) == null || l.call(c, n.resetKeys, a), this.reset();
    }
  }, i.render = function() {
    var n = this.state.error, o = this.props, s = o.fallbackRender, a = o.FallbackComponent, l = o.fallback;
    if (n !== null) {
      var c = {
        error: n,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (/* @__PURE__ */ ft.isValidElement(l))
        return l;
      if (typeof s == "function")
        return s(c);
      if (a)
        return /* @__PURE__ */ ft.createElement(a, c);
      throw new Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");
    }
    return this.props.children;
  }, t;
}(ft.Component);
function Die({
  equation: e,
  inline: t,
  onDoubleClick: i
}) {
  const r = Ne(null);
  return be(() => {
    const n = r.current;
    n !== null && xD.render(e, n, {
      displayMode: !t,
      // true === block display //
      errorColor: "#cc0000",
      output: "html",
      strict: "warn",
      throwOnError: !1,
      trust: !1
    });
  }, [e, t]), // We use an empty image tag either side to ensure Android doesn't try and compose from the
  // inner text from Katex. There didn't seem to be any other way of making this work,
  // without having a physical space.
  /* @__PURE__ */ V(gt, { children: [
    /* @__PURE__ */ f("img", { src: "#", alt: "" }),
    /* @__PURE__ */ f("span", { role: "button", tabIndex: -1, onDoubleClick: i, ref: r }),
    /* @__PURE__ */ f("img", { src: "#", alt: "" })
  ] });
}
function Oie({ onConfirm: e, initialEquation: t = "" }) {
  const [i] = nt.useLexicalComposerContext(), [r, n] = se(t), [o, s] = se(!0), a = ye(() => {
    e(r, o);
  }, [e, r, o]), l = ye(() => {
    s(!o);
  }, [s, o]);
  return /* @__PURE__ */ V(gt, { children: [
    /* @__PURE__ */ V("div", { className: el.defaultRow, children: [
      "Inline",
      /* @__PURE__ */ f("input", { type: "checkbox", checked: o, onChange: l })
    ] }),
    /* @__PURE__ */ f("div", { className: el.defaultRow, children: "Equation " }),
    /* @__PURE__ */ f("div", { className: el.centerRow, children: o ? /* @__PURE__ */ f(
      "input",
      {
        onChange: (c) => {
          n(c.target.value);
        },
        value: r,
        className: el.textArea
      }
    ) : /* @__PURE__ */ f(
      "textarea",
      {
        onChange: (c) => {
          n(c.target.value);
        },
        value: r,
        className: el.textArea
      }
    ) }),
    /* @__PURE__ */ f("div", { className: el.defaultRow, children: "Visualization " }),
    /* @__PURE__ */ f("div", { className: el.centerRow, children: /* @__PURE__ */ f(Bie, { onError: (c) => i._onError(c), fallback: null, children: /* @__PURE__ */ f(Die, { equation: r, inline: !1, onDoubleClick: () => null }) }) }),
    /* @__PURE__ */ f("div", { className: el.dialogActions, children: /* @__PURE__ */ f(fo, { onClick: a, children: "Confirm" }) })
  ] });
}
const a8 = L.createCommand("INSERT_EQUATION_COMMAND");
function l8({
  activeEditor: e,
  onClose: t
}) {
  const i = ye(
    (r, n) => {
      e.dispatchCommand(a8, { equation: r, inline: n }), t();
    },
    [e, t]
  );
  return /* @__PURE__ */ f(Oie, { onConfirm: i });
}
function Fie() {
  const [e] = nt.useLexicalComposerContext();
  return be(() => {
    if (!e.hasNodes([Gl]))
      throw new Error("EquationsPlugins: EquationsNode not registered on editor");
    return e.registerCommand(
      a8,
      (t) => {
        const { equation: i, inline: r } = t, n = kf(i, r);
        return L.$insertNodes([n]), L.$isRootOrShadowRoot(n.getParentOrThrow()) && it.$wrapNodeInElement(n, L.$createParagraphNode).selectEnd(), !0;
      },
      L.COMMAND_PRIORITY_EDITOR
    );
  }, [e]), null;
}
const Vie = "data:image/jpeg;base64,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", qie = "data:image/jpeg;base64,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", jie = "_wrapper_17wgl_1", Lie = "_label_17wgl_8", Kie = "_input_17wgl_14", Ls = {
  wrapper: jie,
  label: Lie,
  input: Kie
};
function c8({ accept: e, label: t, onChange: i, "data-test-id": r }) {
  return /* @__PURE__ */ V("div", { className: Ls.wrapper, children: [
    /* @__PURE__ */ f("label", { className: Ls.label, children: t }),
    /* @__PURE__ */ f(
      "input",
      {
        type: "file",
        accept: e,
        className: Ls.input,
        onChange: (n) => i(n.target.files),
        "data-test-id": r
      }
    )
  ] });
}
function hs({
  label: e,
  value: t,
  onChange: i,
  placeholder: r = "",
  "data-test-id": n,
  type: o = "text"
}) {
  return /* @__PURE__ */ V("div", { className: Ls.wrapper, children: [
    /* @__PURE__ */ f("label", { className: Ls.label, children: e }),
    /* @__PURE__ */ f(
      "input",
      {
        type: o,
        className: Ls.input,
        placeholder: r,
        value: t,
        onChange: (s) => {
          i(s.target.value);
        },
        "data-test-id": n
      }
    )
  ] });
}
const Yie = (e) => iu ? (e || window).getSelection() : null, J0 = L.createCommand("INSERT_IMAGE_COMMAND");
function Uie({ onClick: e }) {
  const [t, i] = se(""), [r, n] = se("");
  return /* @__PURE__ */ V(gt, { children: [
    /* @__PURE__ */ f(
      hs,
      {
        label: "Image URL",
        placeholder: "i.e. https://source.unsplash.com/random",
        onChange: i,
        value: t,
        "data-test-id": "image-modal-url-input"
      }
    ),
    /* @__PURE__ */ f(
      hs,
      {
        label: "Alt Text",
        placeholder: "Random unsplash image",
        onChange: n,
        value: r,
        "data-test-id": "image-modal-alt-text-input"
      }
    ),
    /* @__PURE__ */ f(Zl, { children: /* @__PURE__ */ f(fo, { "data-test-id": "image-modal-confirm-btn", disabled: t === "", onClick: () => e({ altText: r, src: t }), children: "Confirm" }) })
  ] });
}
function Gie({ onClick: e }) {
  const [t, i] = se(""), [r, n] = se("");
  return /* @__PURE__ */ V(gt, { children: [
    /* @__PURE__ */ f(c8, { label: "Image Upload", onChange: (a) => {
      const l = new FileReader();
      l.onload = function() {
        return typeof l.result == "string" && i(l.result), "";
      }, a !== null && l.readAsDataURL(a[0]);
    }, accept: "image/*", "data-test-id": "image-modal-file-upload" }),
    /* @__PURE__ */ f(
      hs,
      {
        label: "Alt Text",
        placeholder: "Descriptive alternative text",
        onChange: n,
        value: r,
        "data-test-id": "image-modal-alt-text-input"
      }
    ),
    /* @__PURE__ */ f(Zl, { children: /* @__PURE__ */ f(
      fo,
      {
        "data-test-id": "image-modal-file-upload-btn",
        disabled: t === "",
        onClick: () => e({ altText: r, src: t }),
        children: "Confirm"
      }
    ) })
  ] });
}
function u8({
  activeEditor: e,
  onClose: t
}) {
  const [i, r] = se(null), n = Ne(!1);
  be(() => {
    n.current = !1;
    const s = (a) => {
      n.current = a.altKey;
    };
    return document.addEventListener("keydown", s), () => {
      document.removeEventListener("keydown", s);
    };
  }, [e]);
  const o = (s) => {
    e.dispatchCommand(J0, s), t();
  };
  return /* @__PURE__ */ V(gt, { children: [
    !i && /* @__PURE__ */ V(Wte, { children: [
      /* @__PURE__ */ f(
        fo,
        {
          "data-test-id": "image-modal-option-sample",
          onClick: () => o(
            n.current ? {
              altText: "Daylight fir trees forest glacier green high ice landscape",
              src: Vie
            } : {
              altText: "Yellow flower in tilt shift lens",
              src: qie
            }
          ),
          children: "Sample"
        }
      ),
      /* @__PURE__ */ f(fo, { "data-test-id": "image-modal-option-url", onClick: () => r("url"), children: "URL" }),
      /* @__PURE__ */ f(fo, { "data-test-id": "image-modal-option-file", onClick: () => r("file"), children: "File" })
    ] }),
    i === "url" && /* @__PURE__ */ f(Uie, { onClick: o }),
    i === "file" && /* @__PURE__ */ f(Gie, { onClick: o })
  ] });
}
function k1({ captionsEnabled: e }) {
  const [t] = nt.useLexicalComposerContext();
  return be(() => {
    if (!t.hasNodes([Wl]))
      throw new Error("ImagesPlugin: ImageNode not registered on editor");
    return it.mergeRegister(
      t.registerCommand(
        J0,
        (i) => {
          const r = Nf(i);
          return L.$insertNodes([r]), L.$isRootOrShadowRoot(r.getParentOrThrow()) && it.$wrapNodeInElement(r, L.$createParagraphNode).selectEnd(), !0;
        },
        L.COMMAND_PRIORITY_EDITOR
      ),
      t.registerCommand(
        L.DRAGSTART_COMMAND,
        (i) => Wie(i),
        L.COMMAND_PRIORITY_HIGH
      ),
      t.registerCommand(
        L.DRAGOVER_COMMAND,
        (i) => Zie(i),
        L.COMMAND_PRIORITY_LOW
      ),
      t.registerCommand(
        L.DROP_COMMAND,
        (i) => Jie(i, t),
        L.COMMAND_PRIORITY_HIGH
      )
    );
  }, [e, t]), null;
}
const Qie = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", zb = Wt("img");
zb && (zb.src = Qie);
function Wie(e) {
  const t = bx();
  if (!t)
    return !1;
  const i = e.dataTransfer;
  return i ? (i.setData("text/plain", "_"), i.setDragImage(zb, 0, 0), i.setData(
    "application/x-lexical-drag",
    JSON.stringify({
      data: {
        altText: t.__altText,
        caption: t.__caption,
        height: t.__height,
        key: t.getKey(),
        maxWidth: t.__maxWidth,
        showCaption: t.__showCaption,
        src: t.__src,
        width: t.__width
      },
      type: "image"
    })
  ), !0) : !1;
}
function Zie(e) {
  return bx() ? (d8(e) || e.preventDefault(), !0) : !1;
}
function Jie(e, t) {
  const i = bx();
  if (!i)
    return !1;
  const r = Pie(e);
  if (!r)
    return !1;
  if (e.preventDefault(), d8(e)) {
    const n = zie(e);
    i.remove();
    const o = L.$createRangeSelection();
    n != null && o.applyDOMRange(n), L.$setSelection(o), t.dispatchCommand(J0, r);
  }
  return !0;
}
function bx() {
  const e = L.$getSelection();
  if (!L.$isNodeSelection(e))
    return null;
  const i = e.getNodes()[0];
  return xm(i) ? i : null;
}
function Pie(e) {
  var n;
  const t = (n = e.dataTransfer) == null ? void 0 : n.getData("application/x-lexical-drag");
  if (!t)
    return null;
  const { type: i, data: r } = JSON.parse(t);
  return i !== "image" ? null : r;
}
function d8(e) {
  const t = e.target;
  return !!(t && t instanceof HTMLElement && !t.closest("code, span.editor-image") && t.parentElement && t.parentElement.closest("div.ContentEditable__root"));
}
function zie(e) {
  let t;
  const i = e.target, r = i == null ? null : i.nodeType === 9 ? i.defaultView : i.ownerDocument.defaultView, n = Yie(r);
  if (document.caretRangeFromPoint)
    t = document.caretRangeFromPoint(e.clientX, e.clientY);
  else if (e.rangeParent && n !== null)
    n.collapse(e.rangeParent, e.rangeOffset || 0), t = n.getRangeAt(0);
  else
    throw Error("Cannot get the selection when dragging");
  return t;
}
class Zc extends L.ElementNode {
  constructor(i, r) {
    super(r);
    Ze(this, "__templateColumns");
    this.__templateColumns = i;
  }
  static getType() {
    return "layout-container";
  }
  static clone(i) {
    return new Zc(i.__templateColumns, i.__key);
  }
  createDOM(i) {
    const r = Wt("div");
    return r.style.gridTemplateColumns = this.__templateColumns, typeof i.theme.layoutContainer == "string" && it.addClassNamesToElement(r, i.theme.layoutContainer), r;
  }
  updateDOM(i, r) {
    return i.__templateColumns !== this.__templateColumns && (r.style.gridTemplateColumns = this.__templateColumns), !1;
  }
  static importDOM() {
    return {};
  }
  static importJSON(i) {
    return m8(i.templateColumns);
  }
  canBeEmpty() {
    return !1;
  }
  exportJSON() {
    return ee(q({}, super.exportJSON()), {
      templateColumns: this.__templateColumns,
      type: "layout-container",
      version: 1
    });
  }
  getTemplateColumns() {
    return this.getLatest().__templateColumns;
  }
  setTemplateColumns(i) {
    this.getWritable().__templateColumns = i;
  }
}
function m8(e) {
  return new Zc(e);
}
function iw(e) {
  return e instanceof Zc;
}
class Jc extends L.ElementNode {
  static getType() {
    return "layout-item";
  }
  static clone(t) {
    return new Jc(t.__key);
  }
  createDOM(t) {
    const i = Wt("div");
    return typeof t.theme.layoutItem == "string" && it.addClassNamesToElement(i, t.theme.layoutItem), i;
  }
  updateDOM() {
    return !1;
  }
  static importDOM() {
    return {};
  }
  static importJSON() {
    return Hb();
  }
  isShadowRoot() {
    return !0;
  }
  exportJSON() {
    return ee(q({}, super.exportJSON()), {
      type: "layout-item",
      version: 1
    });
  }
}
function Hb() {
  return new Jc();
}
function rw(e) {
  return e instanceof Jc;
}
const g8 = L.createCommand(), Hie = L.createCommand();
function h8() {
  const [e] = nt.useLexicalComposerContext();
  return be(() => {
    if (!e.hasNodes([Zc, Jc]))
      throw new Error("LayoutPlugin: LayoutContainerNode, or LayoutItemNode not registered on editor");
    return it.mergeRegister(
      e.registerCommand(
        g8,
        (t) => (e.update(() => {
          const i = m8(t), r = fE(t);
          for (let n = 0; n < r; n++)
            i.append(Hb().append(L.$createParagraphNode()));
          it.$insertNodeToNearestRoot(i), i.selectStart();
        }), !0),
        L.COMMAND_PRIORITY_EDITOR
      ),
      e.registerCommand(
        Hie,
        ({ template: t, nodeKey: i }) => (e.update(() => {
          const r = L.$getNodeByKey(i);
          if (!iw(r))
            return;
          const n = fE(t), o = fE(r.getTemplateColumns());
          if (n > o)
            for (let s = o; s < n; s++)
              r.append(Hb().append(L.$createParagraphNode()));
          else if (n < o)
            for (let s = o; s < n; s++) {
              const a = r.getChildAtIndex(s);
              if (rw(a))
                for (const l of a.getChildren())
                  r.insertAfter(l);
            }
          r.setTemplateColumns(t);
        }), !0),
        L.COMMAND_PRIORITY_EDITOR
      ),
      // Structure enforcing transformers for each node type. In case nesting structure is not
      // "Container > Item" it'll unwrap nodes and convert it back
      // to regular content.
      e.registerNodeTransform(Jc, (t) => {
        const i = t.getParent();
        if (!iw(i)) {
          const r = t.getChildren();
          for (const n of r)
            t.insertBefore(n);
          t.remove();
        }
      }),
      e.registerNodeTransform(Zc, (t) => {
        const i = t.getChildren();
        if (!i.every(rw)) {
          for (const r of i)
            t.insertBefore(r);
          t.remove();
        }
      })
    );
  }, [e]), null;
}
function fE(e) {
  return e.trim().split(/\s+/).length;
}
const AE = [
  { label: "2 columns (equal width)", value: "1fr 1fr" },
  { label: "2 columns (25% - 75%)", value: "1fr 3fr" },
  { label: "3 columns (equal width)", value: "1fr 1fr 1fr" },
  { label: "3 columns (25% - 50% - 25%)", value: "1fr 2fr 1fr" },
  { label: "4 columns (equal width)", value: "1fr 1fr 1fr 1fr" }
];
function p8({
  activeEditor: e,
  onClose: t
}) {
  var s;
  const [i, r] = se(AE[0].value), n = (s = AE.find((a) => a.value === i)) == null ? void 0 : s.label, o = () => {
    e.dispatchCommand(g8, i), t();
  };
  return /* @__PURE__ */ V(gt, { children: [
    /* @__PURE__ */ f(Ia, { buttonClassName: "toolbar-item dialog-dropdown", buttonLabel: n, children: AE.map(({ label: a, value: l }) => /* @__PURE__ */ f(Yt, { className: "item", onClick: () => r(l), children: /* @__PURE__ */ f("span", { className: "text", children: a }) }, l)) }),
    /* @__PURE__ */ f(fo, { onClick: o, children: "Insert" })
  ] });
}
const Xie = "_pageBreak_aqha8_3", _ie = "_selected_aqha8_50", f8 = {
  pageBreak: Xie,
  selected: _ie
};
function $ie({ nodeKey: e }) {
  const [t] = nt.useLexicalComposerContext(), [i, r, n] = vg.useLexicalNodeSelection(e), o = ye(
    (s) => {
      if (s.preventDefault(), i && L.$isNodeSelection(L.$getSelection())) {
        const a = L.$getNodeByKey(e);
        if (tre(a))
          return a.remove(), !0;
      }
      return !1;
    },
    [i, e]
  );
  return be(() => it.mergeRegister(
    t.registerCommand(
      L.CLICK_COMMAND,
      (s) => {
        const a = t.getElementByKey(e);
        return s.target === a ? (s.shiftKey || n(), r(!i), !0) : !1;
      },
      L.COMMAND_PRIORITY_LOW
    ),
    t.registerCommand(L.KEY_DELETE_COMMAND, o, L.COMMAND_PRIORITY_LOW),
    t.registerCommand(L.KEY_BACKSPACE_COMMAND, o, L.COMMAND_PRIORITY_LOW)
  ), [n, t, i, e, o, r]), be(() => {
    const s = t.getElementByKey(e);
    s !== null && (s.className = i ? f8.selected : "");
  }, [t, i, e]), null;
}
class P0 extends L.DecoratorNode {
  static getType() {
    return "page-break";
  }
  static clone(t) {
    return new P0(t.__key);
  }
  static importJSON(t) {
    return Cx();
  }
  static importDOM() {
    return {
      figure: (t) => t.getAttribute("type") !== this.getType() ? null : {
        conversion: ere,
        priority: L.COMMAND_PRIORITY_HIGH
      }
    };
  }
  exportJSON() {
    return {
      type: this.getType(),
      version: 1
    };
  }
  createDOM() {
    const t = Wt("figure");
    return t.style.pageBreakAfter = "always", t.setAttribute("type", this.getType()), t.classList.add(f8.pageBreak), t;
  }
  getTextContent() {
    return `
`;
  }
  isInline() {
    return !1;
  }
  updateDOM() {
    return !1;
  }
  decorate() {
    return /* @__PURE__ */ f($ie, { nodeKey: this.__key });
  }
}
function ere() {
  return { node: Cx() };
}
function Cx() {
  return new P0();
}
function tre(e) {
  return e instanceof P0;
}
const xx = L.createCommand();
function ire() {
  const [e] = nt.useLexicalComposerContext();
  return be(() => {
    if (!e.hasNodes([P0]))
      throw new Error("PageBreakPlugin: PageBreakNode is not registered on editor");
    return it.mergeRegister(
      e.registerCommand(
        xx,
        () => {
          const t = L.$getSelection();
          if (!L.$isRangeSelection(t))
            return !1;
          if (t.focus.getNode() !== null) {
            const r = Cx();
            it.$insertNodeToNearestRoot(r);
          }
          return !0;
        },
        L.COMMAND_PRIORITY_EDITOR
      )
    );
  }, [e]), null;
}
const rre = ft.lazy(() => import("./PollComponent-f7c1b75b.js"));
function nre() {
  return Math.random().toString(36).replace(/[^a-z]+/g, "").substr(0, 5);
}
function nw(e = "") {
  return {
    text: e,
    uid: nre(),
    votes: []
  };
}
function ow(e, t, i) {
  return {
    text: t,
    uid: e.uid,
    votes: i || Array.from(e.votes)
  };
}
function ore(e) {
  const t = e.getAttribute("data-lexical-poll-question"), i = e.getAttribute("data-lexical-poll-options");
  return t !== null && i !== null ? { node: Ix(t, JSON.parse(i)) } : null;
}
class z0 extends L.DecoratorNode {
  constructor(i, r, n) {
    super(n);
    Ze(this, "__question");
    Ze(this, "__options");
    this.__question = i, this.__options = r;
  }
  static getType() {
    return "poll";
  }
  static clone(i) {
    return new z0(i.__question, i.__options, i.__key);
  }
  static importJSON(i) {
    const r = Ix(i.question, i.options);
    return i.options.forEach(r.addOption), r;
  }
  exportJSON() {
    return {
      options: this.__options,
      question: this.__question,
      type: "poll",
      version: 1
    };
  }
  addOption(i) {
    const r = this.getWritable(), n = Array.from(r.__options);
    n.push(i), r.__options = n;
  }
  deleteOption(i) {
    const r = this.getWritable(), n = Array.from(r.__options), o = n.indexOf(i);
    n.splice(o, 1), r.__options = n;
  }
  setOptionText(i, r) {
    const n = this.getWritable(), o = ow(i, r), s = Array.from(n.__options), a = s.indexOf(i);
    s[a] = o, n.__options = s;
  }
  toggleVote(i, r) {
    const n = this.getWritable(), o = i.votes, s = Array.from(o), a = o.indexOf(r);
    a === -1 ? s.push(r) : s.splice(a, 1);
    const l = ow(i, i.text, s), c = Array.from(n.__options), u = c.indexOf(i);
    c[u] = l, n.__options = c;
  }
  static importDOM() {
    return {
      span: (i) => i.hasAttribute("data-lexical-poll-question") ? {
        conversion: ore,
        priority: 2
      } : null
    };
  }
  exportDOM() {
    const i = Wt("span");
    return i.setAttribute("data-lexical-poll-question", this.__question), i.setAttribute("data-lexical-poll-options", JSON.stringify(this.__options)), { element: i };
  }
  createDOM() {
    const i = Wt("span");
    return i.style.display = "inline-block", i;
  }
  updateDOM() {
    return !1;
  }
  decorate() {
    return /* @__PURE__ */ f(Ll, { fallback: null, children: /* @__PURE__ */ f(rre, { question: this.__question, options: this.__options, nodeKey: this.__key }) });
  }
}
function Ix(e, t) {
  return new z0(e, t);
}
function Z5e(e) {
  return e instanceof z0;
}
const A8 = L.createCommand("INSERT_POLL_COMMAND");
function y8({
  activeEditor: e,
  onClose: t
}) {
  const [i, r] = se(""), n = () => {
    e.dispatchCommand(A8, i), t();
  };
  return /* @__PURE__ */ V(gt, { children: [
    /* @__PURE__ */ f(hs, { label: "Question", onChange: r, value: i }),
    /* @__PURE__ */ f(Zl, { children: /* @__PURE__ */ f(fo, { disabled: i.trim() === "", onClick: n, children: "Confirm" }) })
  ] });
}
function sre() {
  const [e] = nt.useLexicalComposerContext();
  return be(() => {
    if (!e.hasNodes([z0]))
      throw new Error("PollPlugin: PollNode not registered on editor");
    return e.registerCommand(
      A8,
      (t) => {
        const i = Ix(t, [nw(), nw()]);
        return L.$insertNodes([i]), L.$isRootOrShadowRoot(i.getParentOrThrow()) && it.$wrapNodeInElement(i, L.$createParagraphNode).selectEnd(), !0;
      },
      L.COMMAND_PRIORITY_EDITOR
    );
  }, [e]), null;
}
function E8(e, t, ...i) {
  if (!e)
    throw new Error(
      "Internal Lexical error: invariant() is meant to be replaced at compile time. There is no runtime version. Error: " + t
    );
}
const are = /* @__PURE__ */ new Map(), J5e = /* @__PURE__ */ new Map(), v8 = '{"root":{"children":[{"children":[],"direction":null,"format":"","indent":0,"type":"paragraph","version":1}],"direction":null,"format":"","indent":0,"type":"root","version":1}}', b8 = (e) => e === "" ? v8 : `{"root":{"children":[{"children":[{"detail":0,"format":0,"mode":"normal","style":"","text":${e},"type":"text","version":1}],"direction":"ltr","format":"","indent":0,"type":"paragraph","version":1}],"direction":"ltr","format":"","indent":0,"type":"root","version":1}}`, lre = ft.lazy(() => import("./TableComponent-ceddf277.js"));
function C8() {
  return Math.random().toString(36).replace(/[^a-z]+/g, "").substr(0, 5);
}
function xc(e) {
  return {
    colSpan: 1,
    id: C8(),
    json: v8,
    type: e,
    width: null
  };
}
function Pm() {
  return {
    cells: [],
    height: null,
    id: C8()
  };
}
function P5e(e) {
  const t = e.querySelectorAll("tr"), i = [];
  for (let r = 0; r < t.length; r++) {
    const o = t[r].querySelectorAll("td,th");
    if (!o || o.length === 0)
      continue;
    const s = [];
    for (let l = 0; l < o.length; l++) {
      const c = o[l], u = c.nodeName === "TH", m = xc(u ? "header" : "normal");
      m.json = b8(JSON.stringify(c.innerText.replace(/\n/g, " "))), s.push(m);
    }
    const a = Pm();
    a.cells = s, i.push(a);
  }
  return i;
}
function cre(e) {
  const t = e.querySelectorAll("tr");
  if (!t || t.length === 0)
    return null;
  const i = [];
  for (let r = 0; r < t.length; r++) {
    const o = t[r].querySelectorAll("td,th");
    if (!o || o.length === 0)
      continue;
    const s = [];
    for (let l = 0; l < o.length; l++) {
      const c = o[l], u = c.nodeName === "TH", m = xc(u ? "header" : "normal");
      m.json = b8(JSON.stringify(c.innerText.replace(/\n/g, " "))), s.push(m);
    }
    const a = Pm();
    a.cells = s, i.push(a);
  }
  return { node: x8(i) };
}
function ure(e, t) {
  const i = Wt("table"), r = Wt("colgroup"), n = Wt("tbody"), o = e[0];
  for (let s = t != null ? t.startX : 0; s < (t != null ? t.endX + 1 : o.cells.length); s++) {
    const a = Wt("col");
    r.append(a);
  }
  for (let s = t != null ? t.startY : 0; s < (t != null ? t.endY + 1 : e.length); s++) {
    const l = e[s].cells, c = Wt("tr");
    for (let u = t != null ? t.startX : 0; u < (t != null ? t.endX + 1 : l.length); u++) {
      const m = l[u], g = Wt(m.type === "header" ? "th" : "td");
      g.innerHTML = are.get(m.json) || "", c.appendChild(g);
    }
    n.appendChild(c);
  }
  return i.appendChild(r), i.appendChild(n), i;
}
class su extends L.DecoratorNode {
  constructor(i, r) {
    super(r);
    Ze(this, "__rows");
    this.__rows = i || [];
  }
  static getType() {
    return "tablesheet";
  }
  static clone(i) {
    return new su(Array.from(i.__rows), i.__key);
  }
  static importJSON(i) {
    return x8(i.rows);
  }
  exportJSON() {
    return {
      rows: this.__rows,
      type: "tablesheet",
      version: 1
    };
  }
  static importDOM() {
    return {
      table: (i) => ({
        conversion: cre,
        priority: 0
      })
    };
  }
  exportDOM() {
    return { element: ure(this.__rows) };
  }
  createDOM() {
    return Wt("div");
  }
  updateDOM() {
    return !1;
  }
  mergeRows(i, r, n) {
    const s = this.getWritable().__rows, a = Math.min(s.length, r + n.length);
    for (let l = r; l < a; l++) {
      const c = s[l], u = n[l - r], m = c.cells, g = Array.from(m), h = ee(q({}, c), { cells: g }), A = u.cells, y = Math.min(m.length, i + A.length);
      for (let E = i; E < y; E++) {
        const v = m[E], C = A[E - i], x = ee(q({}, v), { json: C.json, type: C.type });
        g[E] = x;
      }
      s[l] = h;
    }
  }
  updateCellJSON(i, r, n) {
    const s = this.getWritable().__rows, a = s[r], l = a.cells, c = l[i], u = Array.from(l), m = ee(q({}, c), { json: n }), g = ee(q({}, a), { cells: u });
    u[i] = m, s[r] = g;
  }
  updateCellType(i, r, n) {
    const s = this.getWritable().__rows, a = s[r], l = a.cells, c = l[i], u = Array.from(l), m = ee(q({}, c), { type: n }), g = ee(q({}, a), { cells: u });
    u[i] = m, s[r] = g;
  }
  insertColumnAt(i) {
    const n = this.getWritable().__rows;
    for (let o = 0; o < n.length; o++) {
      const s = n[o], a = s.cells, l = Array.from(a), c = ee(q({}, s), { cells: l }), u = (a[i] || a[i - 1]).type;
      l.splice(i, 0, xc(u)), n[o] = c;
    }
  }
  deleteColumnAt(i) {
    const n = this.getWritable().__rows;
    for (let o = 0; o < n.length; o++) {
      const s = n[o], a = s.cells, l = Array.from(a), c = ee(q({}, s), { cells: l });
      l.splice(i, 1), n[o] = c;
    }
  }
  addColumns(i) {
    const n = this.getWritable().__rows;
    for (let o = 0; o < n.length; o++) {
      const s = n[o], a = s.cells, l = Array.from(a), c = ee(q({}, s), { cells: l }), u = a[a.length - 1].type;
      for (let m = 0; m < i; m++)
        l.push(xc(u));
      n[o] = c;
    }
  }
  insertRowAt(i) {
    const n = this.getWritable().__rows, o = n[i] || n[i - 1], s = o.cells.length, a = Pm();
    for (let l = 0; l < s; l++) {
      const c = xc(o.cells[l].type);
      a.cells.push(c);
    }
    n.splice(i, 0, a);
  }
  deleteRowAt(i) {
    this.getWritable().__rows.splice(i, 1);
  }
  addRows(i) {
    const n = this.getWritable().__rows, o = n[n.length - 1], s = o.cells.length;
    for (let a = 0; a < i; a++) {
      const l = Pm();
      for (let c = 0; c < s; c++) {
        const u = xc(o.cells[c].type);
        l.cells.push(u);
      }
      n.push(l);
    }
  }
  updateColumnWidth(i, r) {
    const o = this.getWritable().__rows;
    for (let s = 0; s < o.length; s++) {
      const a = o[s], l = a.cells, c = Array.from(l), u = ee(q({}, a), { cells: c });
      c[i].width = r, o[s] = u;
    }
  }
  decorate(i, r) {
    return /* @__PURE__ */ f(Ll, { children: /* @__PURE__ */ f(lre, { nodeKey: this.__key, theme: r.theme, rows: this.__rows }) });
  }
  isInline() {
    return !1;
  }
}
function z5e(e) {
  return e instanceof su;
}
function x8(e) {
  return new su(e);
}
function dre(e, t, i = !0) {
  const r = [];
  for (let n = 0; n < t; n++) {
    const o = Pm();
    r.push(o);
    for (let s = 0; s < e; s++)
      o.cells.push(xc(i === !0 && (n === 0 || s === 0) ? "header" : "normal"));
  }
  return new su(r);
}
const I8 = L.createCommand("INSERT_NEW_TABLE_COMMAND"), S8 = Co({
  cellEditorConfig: null,
  cellEditorPlugins: null,
  set: () => {
  }
});
function mre({ children: e }) {
  const [t, i] = se({
    cellEditorConfig: null,
    cellEditorPlugins: null
  });
  return /* @__PURE__ */ f(
    S8.Provider,
    {
      value: we(
        () => ({
          cellEditorConfig: t.cellEditorConfig,
          cellEditorPlugins: t.cellEditorPlugins,
          set: (r, n) => {
            i({ cellEditorConfig: r, cellEditorPlugins: n });
          }
        }),
        [t.cellEditorConfig, t.cellEditorPlugins]
      ),
      children: e
    }
  );
}
function R8({
  activeEditor: e,
  onClose: t
}) {
  const [i, r] = se("5"), [n, o] = se("5"), [s, a] = se(!0);
  return be(() => {
    const c = Number(i), u = Number(n);
    c && c > 0 && c <= 500 && u && u > 0 && u <= 50 ? a(!1) : a(!0);
  }, [i, n]), /* @__PURE__ */ V(gt, { children: [
    /* @__PURE__ */ f(
      hs,
      {
        placeholder: "# of rows (1-500)",
        label: "Rows",
        onChange: r,
        value: i,
        "data-test-id": "table-modal-rows",
        type: "number"
      }
    ),
    /* @__PURE__ */ f(
      hs,
      {
        placeholder: "# of columns (1-50)",
        label: "Columns",
        onChange: o,
        value: n,
        "data-test-id": "table-modal-columns",
        type: "number"
      }
    ),
    /* @__PURE__ */ f(Zl, { "data-test-id": "table-model-confirm-insert", children: /* @__PURE__ */ f(fo, { disabled: s, onClick: () => {
      e.dispatchCommand(ct.INSERT_TABLE_COMMAND, {
        columns: n,
        rows: i
      }), t();
    }, children: "Confirm" }) })
  ] });
}
function k8({
  activeEditor: e,
  onClose: t
}) {
  const [i, r] = se(""), [n, o] = se(""), [s, a] = se(!0);
  return be(() => {
    const c = Number(i), u = Number(n);
    c && c > 0 && c <= 500 && u && u > 0 && u <= 50 ? a(!1) : a(!0);
  }, [i, n]), /* @__PURE__ */ V(gt, { children: [
    /* @__PURE__ */ f(
      hs,
      {
        placeholder: "# of rows (1-500)",
        label: "Rows",
        onChange: r,
        value: i,
        "data-test-id": "table-modal-rows",
        type: "number"
      }
    ),
    /* @__PURE__ */ f(
      hs,
      {
        placeholder: "# of columns (1-50)",
        label: "Columns",
        onChange: o,
        value: n,
        "data-test-id": "table-modal-columns",
        type: "number"
      }
    ),
    /* @__PURE__ */ f(Zl, { "data-test-id": "table-model-confirm-insert", children: /* @__PURE__ */ f(fo, { disabled: s, onClick: () => {
      e.dispatchCommand(I8, { columns: n, rows: i }), t();
    }, children: "Confirm" }) })
  ] });
}
function w8({
  cellEditorConfig: e,
  children: t
}) {
  const [i] = nt.useLexicalComposerContext(), r = sn(S8);
  return be(() => (i.hasNodes([su]) || E8(!1, "TablePlugin: TableNode is not registered on editor"), r.set(e, t), i.registerCommand(
    I8,
    ({ columns: n, rows: o, includeHeaders: s }) => {
      const a = dre(Number(o), Number(n), s);
      return L.$insertNodes([a]), !0;
    },
    L.COMMAND_PRIORITY_EDITOR
  )), [r, e, t, i]), null;
}
class mr extends y0.MenuOption {
  constructor(i, r) {
    super(i);
    // What shows up in the editor
    Ze(this, "title");
    // Icon for display
    Ze(this, "icon");
    // For extra searching.
    Ze(this, "keywords");
    // TBD
    Ze(this, "keyboardShortcut");
    // What happens when you select this option?
    Ze(this, "onSelect");
    this.title = i, this.keywords = r.keywords || [], this.icon = r.icon, this.keyboardShortcut = r.keyboardShortcut, this.onSelect = r.onSelect.bind(this);
  }
}
function gre({
  index: e,
  isSelected: t,
  onClick: i,
  onMouseEnter: r,
  option: n
}) {
  let o = "item";
  return t && (o += " selected"), /* @__PURE__ */ V(
    "li",
    {
      tabIndex: -1,
      className: o,
      ref: n.setRefElement,
      role: "option",
      "aria-selected": t,
      id: "typeahead-item-" + e,
      onMouseEnter: r,
      onClick: i,
      children: [
        n.icon,
        /* @__PURE__ */ f("span", { className: "text", children: n.title })
      ]
    },
    n.key
  );
}
function hre(e, t) {
  const i = [];
  if (t == null)
    return i;
  const r = t.match(/^([1-9]\d?)(?:x([1-9]\d?)?)?$/);
  if (r !== null) {
    const n = r[1], o = r[2] ? [r[2]] : [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(String);
    i.push(
      ...o.map(
        (s) => new mr(`${n}x${s} Table`, {
          icon: /* @__PURE__ */ f("i", { className: "icon table" }),
          keywords: ["table"],
          onSelect: () => e.dispatchCommand(ct.INSERT_TABLE_COMMAND, { columns: s, rows: n })
        })
      )
    );
  }
  return i;
}
function pre(e, t) {
  return [
    new mr("Paragraph", {
      icon: /* @__PURE__ */ f("i", { className: "icon paragraph" }),
      keywords: ["normal", "paragraph", "p", "text"],
      onSelect: () => e.update(() => {
        const i = L.$getSelection();
        L.$isRangeSelection(i) && wi.$setBlocksType(i, () => L.$createParagraphNode());
      })
    }),
    ...[1, 2, 3].map(
      (i) => new mr(`Heading ${i}`, {
        icon: /* @__PURE__ */ f("i", { className: `icon h${i}` }),
        keywords: ["heading", "header", `h${i}`],
        onSelect: () => e.update(() => {
          const r = L.$getSelection();
          L.$isRangeSelection(r) && wi.$setBlocksType(r, () => Jr.$createHeadingNode(`h${i}`));
        })
      })
    ),
    new mr("Table", {
      icon: /* @__PURE__ */ f("i", { className: "icon table" }),
      keywords: ["table", "grid", "spreadsheet", "rows", "columns"],
      onSelect: () => t("Insert Table", (i) => /* @__PURE__ */ f(R8, { activeEditor: e, onClose: i }))
    }),
    new mr("Table (Experimental)", {
      icon: /* @__PURE__ */ f("i", { className: "icon table" }),
      keywords: ["table", "grid", "spreadsheet", "rows", "columns"],
      onSelect: () => t("Insert Table", (i) => /* @__PURE__ */ f(k8, { activeEditor: e, onClose: i }))
    }),
    new mr("Numbered List", {
      icon: /* @__PURE__ */ f("i", { className: "icon number" }),
      keywords: ["numbered list", "ordered list", "ol"],
      onSelect: () => e.dispatchCommand(zi.INSERT_ORDERED_LIST_COMMAND, void 0)
    }),
    new mr("Bulleted List", {
      icon: /* @__PURE__ */ f("i", { className: "icon bullet" }),
      keywords: ["bulleted list", "unordered list", "ul"],
      onSelect: () => e.dispatchCommand(zi.INSERT_UNORDERED_LIST_COMMAND, void 0)
    }),
    new mr("Check List", {
      icon: /* @__PURE__ */ f("i", { className: "icon check" }),
      keywords: ["check list", "todo list"],
      onSelect: () => e.dispatchCommand(zi.INSERT_CHECK_LIST_COMMAND, void 0)
    }),
    new mr("Quote", {
      icon: /* @__PURE__ */ f("i", { className: "icon quote" }),
      keywords: ["block quote"],
      onSelect: () => e.update(() => {
        const i = L.$getSelection();
        L.$isRangeSelection(i) && wi.$setBlocksType(i, () => Jr.$createQuoteNode());
      })
    }),
    new mr("Code", {
      icon: /* @__PURE__ */ f("i", { className: "icon code" }),
      keywords: ["javascript", "python", "js", "codeblock"],
      onSelect: () => e.update(() => {
        const i = L.$getSelection();
        if (L.$isRangeSelection(i))
          if (i.isCollapsed())
            wi.$setBlocksType(i, () => nn.$createCodeNode());
          else {
            const r = i.getTextContent(), n = nn.$createCodeNode();
            i.insertNodes([n]), i.insertRawText(r);
          }
      })
    }),
    new mr("Divider", {
      icon: /* @__PURE__ */ f("i", { className: "icon horizontal-rule" }),
      keywords: ["horizontal rule", "divider", "hr"],
      onSelect: () => e.dispatchCommand(Il.INSERT_HORIZONTAL_RULE_COMMAND, void 0)
    }),
    new mr("Page Break", {
      icon: /* @__PURE__ */ f("i", { className: "icon page-break" }),
      keywords: ["page break", "divider"],
      onSelect: () => e.dispatchCommand(xx, void 0)
    }),
    new mr("Poll", {
      icon: /* @__PURE__ */ f("i", { className: "icon poll" }),
      keywords: ["poll", "vote"],
      onSelect: () => t("Insert Poll", (i) => /* @__PURE__ */ f(y8, { activeEditor: e, onClose: i }))
    }),
    ...hx.map(
      (i) => new mr(`Embed ${i.contentName}`, {
        icon: i.icon,
        keywords: [...i.keywords, "embed"],
        onSelect: () => e.dispatchCommand(l0.INSERT_EMBED_COMMAND, i.type)
      })
    ),
    new mr("Equation", {
      icon: /* @__PURE__ */ f("i", { className: "icon equation" }),
      keywords: ["equation", "latex", "math"],
      onSelect: () => t("Insert Equation", (i) => /* @__PURE__ */ f(l8, { activeEditor: e, onClose: i }))
    }),
    new mr("GIF", {
      icon: /* @__PURE__ */ f("i", { className: "icon gif" }),
      keywords: ["gif", "animate", "image", "file"],
      onSelect: () => e.dispatchCommand(J0, {
        altText: "Cat typing on a laptop",
        src: s8
      })
    }),
    new mr("Image", {
      icon: /* @__PURE__ */ f("i", { className: "icon image" }),
      keywords: ["image", "photo", "picture", "file"],
      onSelect: () => t("Insert Image", (i) => /* @__PURE__ */ f(u8, { activeEditor: e, onClose: i }))
    }),
    new mr("Collapsible", {
      icon: /* @__PURE__ */ f("i", { className: "icon caret-right" }),
      keywords: ["collapse", "collapsible", "toggle"],
      onSelect: () => e.dispatchCommand(vx, void 0)
    }),
    new mr("Columns Layout", {
      icon: /* @__PURE__ */ f("i", { className: "icon columns" }),
      keywords: ["columns", "layout", "grid"],
      onSelect: () => t("Insert Columns Layout", (i) => /* @__PURE__ */ f(p8, { activeEditor: e, onClose: i }))
    }),
    ...["left", "center", "right", "justify"].map(
      (i) => new mr(`Align ${i}`, {
        icon: /* @__PURE__ */ f("i", { className: `icon ${i}-align` }),
        keywords: ["align", "justify", i],
        onSelect: () => e.dispatchCommand(L.FORMAT_ELEMENT_COMMAND, i)
      })
    )
  ];
}
function fre() {
  const [e, t] = nt.useLexicalComposerContext(), [i, r] = Rg(), [n, o] = se(null), s = y0.useBasicTypeaheadTriggerMatch("/", {
    minLength: 0
  }), a = we(() => {
    const c = pre(e, r);
    if (!n)
      return c;
    const u = new RegExp(n, "i");
    return [
      ...hre(e, n),
      ...c.filter(
        (m) => u.test(m.title) || m.keywords.some((g) => u.test(g))
      )
    ];
  }, [e, n, r]), l = ye(
    (c, u, m, g) => {
      e.update(() => {
        u == null || u.remove(), c.onSelect(g), m();
      });
    },
    [e]
  );
  return /* @__PURE__ */ V(gt, { children: [
    i,
    /* @__PURE__ */ f(
      y0.LexicalTypeaheadMenuPlugin,
      {
        onQueryChange: o,
        onSelectOption: l,
        triggerFn: s,
        options: a,
        menuRenderFn: (c, { selectedIndex: u, selectOptionAndCleanUp: m, setHighlightedIndex: g }) => {
          var h;
          return c.current && a.length ? mg.createPortal(
            /* @__PURE__ */ f(
              "div",
              {
                className: me(
                  "typeahead-popover component-picker-menu",
                  (h = t.getTheme()) == null ? void 0 : h.typeaheadPopover
                ),
                children: /* @__PURE__ */ f("ul", { children: a.map((A, y) => /* @__PURE__ */ f(
                  gre,
                  {
                    index: y,
                    isSelected: u === y,
                    onClick: () => {
                      g(y), m(A);
                    },
                    onMouseEnter: () => {
                      g(y);
                    },
                    option: A
                  },
                  A.key
                )) })
              }
            ),
            c.current
          ) : null;
        }
      }
    )
  ] });
}
var Sx = {}, Rx = nt, Fi = X, sw = it, Kn = L, Are = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined" ? Fi.useLayoutEffect : Fi.useEffect;
let yre = class {
  constructor(t) {
    this.key = t, this.ref = { current: null }, this.setRefElement = this.setRefElement.bind(this);
  }
  setRefElement(t) {
    this.ref = { current: t };
  }
}, aw = (e) => {
  const t = document.getElementById("typeahead-menu");
  if (t) {
    var i = t.getBoundingClientRect();
    i.top + i.height > window.innerHeight && t.scrollIntoView({ block: "center" }), 0 > i.top && t.scrollIntoView({ block: "center" }), e.scrollIntoView({ block: "nearest" });
  }
};
function Ere(e) {
  var t = Kn.$getSelection();
  if (!Kn.$isRangeSelection(t) || !t.isCollapsed())
    return null;
  var i = t.anchor;
  if (i.type !== "text" || (t = i.getNode(), !t.isSimpleText()))
    return null;
  i = i.offset;
  let r = t.getTextContent().slice(0, i);
  var n = e.matchingString;
  e = e.replaceableString.length;
  for (let s = e; s <= n.length; s++)
    r.substr(-s) === n.substr(0, s) && (e = s);
  if (e = i - e, 0 > e)
    return null;
  let o;
  return e === 0 ? [o] = t.splitText(i) : [, o] = t.splitText(e, i), o;
}
function vre(e, t) {
  let i = getComputedStyle(e), r = i.position === "absolute";
  if (t = t ? /(auto|scroll|hidden)/ : /(auto|scroll)/, i.position === "fixed")
    return document.body;
  for (; e = e.parentElement; )
    if (i = getComputedStyle(e), (!r || i.position !== "static") && t.test(i.overflow + i.overflowY + i.overflowX))
      return e;
  return document.body;
}
function lw(e, t) {
  return e = e.getBoundingClientRect(), t = t.getBoundingClientRect(), e.top > t.top && e.top < t.bottom;
}
function bre(e, t, i, r) {
  let [n] = Rx.useLexicalComposerContext();
  Fi.useEffect(() => {
    if (t != null && e != null) {
      let o = n.getRootElement(), s = o != null ? vre(o, !1) : document.body, a = !1, l = lw(t, s), c = function() {
        a || (window.requestAnimationFrame(function() {
          i(), a = !1;
        }), a = !0);
        const m = lw(t, s);
        m !== l && (l = m, r != null && r(m));
      }, u = new ResizeObserver(i);
      return window.addEventListener("resize", i), document.addEventListener("scroll", c, { capture: !0, passive: !0 }), u.observe(t), () => {
        u.unobserve(t), window.removeEventListener("resize", i), document.removeEventListener(
          "scroll",
          c
        );
      };
    }
  }, [t, n, r, i, e]);
}
let cw = Kn.createCommand("SCROLL_TYPEAHEAD_OPTION_INTO_VIEW_COMMAND");
function Cre({ close: e, editor: t, anchorElementRef: i, resolution: r, options: n, menuRenderFn: o, onSelectOption: s, shouldSplitNodeWithQuery: a = !1 }) {
  let [l, c] = Fi.useState(null);
  Fi.useEffect(() => {
    c(0);
  }, [r.match && r.match.matchingString]);
  let u = Fi.useCallback((h) => {
    t.update(() => {
      const A = r.match != null && a ? Ere(r.match) : null;
      s(h, A, e, r.match ? r.match.matchingString : "");
    });
  }, [t, a, r.match, s, e]), m = Fi.useCallback((h) => {
    const A = t.getRootElement();
    A !== null && (A.setAttribute("aria-activedescendant", "typeahead-item-" + h), c(h));
  }, [t]);
  Fi.useEffect(() => () => {
    let h = t.getRootElement();
    h !== null && h.removeAttribute("aria-activedescendant");
  }, [t]), Are(() => {
    n === null ? c(null) : l === null && m(0);
  }, [n, l, m]), Fi.useEffect(() => sw.mergeRegister(t.registerCommand(cw, ({ option: h }) => h.ref && h.ref.current != null ? (aw(h.ref.current), !0) : !1, Kn.COMMAND_PRIORITY_LOW)), [t, m]), Fi.useEffect(() => sw.mergeRegister(t.registerCommand(Kn.KEY_ARROW_DOWN_COMMAND, (h) => {
    if (n !== null && n.length && l !== null) {
      let A = l !== n.length - 1 ? l + 1 : 0;
      m(A);
      let y = n[A];
      y.ref != null && y.ref.current && t.dispatchCommand(cw, { index: A, option: y }), h.preventDefault(), h.stopImmediatePropagation();
    }
    return !0;
  }, Kn.COMMAND_PRIORITY_LOW), t.registerCommand(Kn.KEY_ARROW_UP_COMMAND, (h) => {
    if (n !== null && n.length && l !== null) {
      var A = l !== 0 ? l - 1 : n.length - 1;
      m(A), A = n[A], A.ref != null && A.ref.current && aw(A.ref.current), h.preventDefault(), h.stopImmediatePropagation();
    }
    return !0;
  }, Kn.COMMAND_PRIORITY_LOW), t.registerCommand(Kn.KEY_ESCAPE_COMMAND, (h) => (h.preventDefault(), h.stopImmediatePropagation(), e(), !0), Kn.COMMAND_PRIORITY_LOW), t.registerCommand(Kn.KEY_TAB_COMMAND, (h) => n === null || l === null || n[l] == null ? !1 : (h.preventDefault(), h.stopImmediatePropagation(), u(n[l]), !0), Kn.COMMAND_PRIORITY_LOW), t.registerCommand(Kn.KEY_ENTER_COMMAND, (h) => n === null || l === null || n[l] == null ? !1 : (h !== null && (h.preventDefault(), h.stopImmediatePropagation()), u(n[l]), !0), Kn.COMMAND_PRIORITY_LOW)), [u, e, t, n, l, m]);
  let g = Fi.useMemo(() => ({ options: n, selectOptionAndCleanUp: u, selectedIndex: l, setHighlightedIndex: c }), [u, l, n]);
  return o(i, g, r.match ? r.match.matchingString : "");
}
function xre(e, t, i) {
  let [r] = Rx.useLexicalComposerContext(), n = Fi.useRef(document.createElement("div")), o = Fi.useCallback(() => {
    const a = r.getRootElement(), l = n.current;
    var c = l.firstChild;
    if (a !== null && e !== null) {
      const { left: m, top: g, width: h, height: A } = e.getRect();
      if (l.style.top = `${g + window.pageYOffset}px`, l.style.left = `${m + window.pageXOffset}px`, l.style.height = `${A}px`, l.style.width = `${h}px`, c !== null) {
        var u = c.getBoundingClientRect();
        c = u.height, u = u.width;
        const y = a.getBoundingClientRect();
        m + u > y.right && (l.style.left = `${y.right - u + window.pageXOffset}px`), (g + c > window.innerHeight || g + c > y.bottom) && g - y.top > c && (l.style.top = `${g - c + window.pageYOffset - (A + 10)}px`);
      }
      l.isConnected || (i != null && (l.className = i), l.setAttribute("aria-label", "Typeahead menu"), l.setAttribute("id", "typeahead-menu"), l.setAttribute("role", "listbox"), l.style.display = "block", l.style.position = "absolute", document.body.append(l)), n.current = l, a.setAttribute("aria-controls", "typeahead-menu");
    }
  }, [r, e, i]);
  Fi.useEffect(() => {
    let a = r.getRootElement();
    if (e !== null)
      return o(), () => {
        a !== null && a.removeAttribute("aria-controls");
        let l = n.current;
        l !== null && l.isConnected && l.remove();
      };
  }, [r, o, e]);
  let s = Fi.useCallback((a) => {
    e !== null && (a || t(null));
  }, [e, t]);
  return bre(e, n.current, o, s), n;
}
Sx.LexicalContextMenuPlugin = function({ options: e, onClose: t, onOpen: i, onSelectOption: r, menuRenderFn: n, anchorClassName: o }) {
  let [s] = Rx.useLexicalComposerContext(), [a, l] = Fi.useState(null), c = Fi.useRef(null);
  o = xre(a, l, o);
  let u = Fi.useCallback(() => {
    l(null), t != null && a !== null && t();
  }, [t, a]), m = Fi.useCallback((A) => {
    l(A), i != null && a === null && i(A);
  }, [i, a]), g = Fi.useCallback((A) => {
    A.preventDefault(), m({ getRect: () => new DOMRect(A.clientX, A.clientY, 1, 1) });
  }, [m]), h = Fi.useCallback((A) => {
    a === null || c.current == null || A.target == null || c.current.contains(A.target) || u();
  }, [u, a]);
  return Fi.useEffect(() => {
    let A = s.getRootElement();
    if (A)
      return A.addEventListener("contextmenu", g), () => A.removeEventListener("contextmenu", g);
  }, [s, g]), Fi.useEffect(() => (document.addEventListener("click", h), () => document.removeEventListener("click", h)), [s, h]), a === null || s === null ? null : Fi.createElement(Cre, { close: u, resolution: a, editor: s, anchorElementRef: o, options: e, menuRenderFn: (A, y) => n(A, y, { setMenuRef: (E) => {
    c.current = E;
  } }), onSelectOption: r });
};
Sx.MenuOption = yre;
const Ire = Sx;
var M8 = Ire;
function Sre({
  index: e,
  isSelected: t,
  onClick: i,
  onMouseEnter: r,
  option: n
}) {
  let o = "item";
  return t && (o += " selected"), /* @__PURE__ */ f(
    "li",
    {
      tabIndex: -1,
      className: o,
      ref: n.setRefElement,
      role: "option",
      "aria-selected": t,
      id: "typeahead-item-" + e,
      onMouseEnter: r,
      onClick: i,
      children: /* @__PURE__ */ f("span", { className: "text", children: n.title })
    },
    n.key
  );
}
function Rre({
  options: e,
  selectedItemIndex: t,
  onOptionClick: i,
  onOptionMouseEnter: r
}) {
  var o;
  const [, n] = nt.useLexicalComposerContext();
  return /* @__PURE__ */ f("div", { className: me("typeahead-popover", (o = n.getTheme()) == null ? void 0 : o.typeaheadPopover), children: /* @__PURE__ */ f("ul", { children: e.map((s, a) => /* @__PURE__ */ f(
    Sre,
    {
      index: a,
      isSelected: t === a,
      onClick: () => i(s, a),
      onMouseEnter: () => r(a),
      option: s
    },
    s.key
  )) }) });
}
class Td extends M8.MenuOption {
  constructor(i, r) {
    super(i);
    Ze(this, "title");
    Ze(this, "onSelect");
    this.title = i, this.onSelect = r.onSelect.bind(this);
  }
}
function N8() {
  const [e, t] = nt.useLexicalComposerContext(), i = we(() => [
    new Td("Copy", {
      onSelect: (n) => {
        e.dispatchCommand(L.COPY_COMMAND, null);
      }
    }),
    new Td("Cut", {
      onSelect: (n) => {
        e.dispatchCommand(L.CUT_COMMAND, null);
      }
    }),
    new Td("Paste", {
      onSelect: (n) => {
        navigator.clipboard.read().then((...o) => Lt(this, null, function* () {
          const s = new DataTransfer(), l = (yield navigator.clipboard.read())[0];
          if ((yield navigator.permissions.query({
            // @ts-ignore These types are incorrect.
            name: "clipboard-read"
          })).state === "denied") {
            alert("Not allowed to paste from clipboard.");
            return;
          }
          for (const m of l.types) {
            const g = yield (yield l.getType(m)).text();
            s.setData(m, g);
          }
          const u = new ClipboardEvent("paste", {
            clipboardData: s
          });
          e.dispatchCommand(L.PASTE_COMMAND, u);
        }));
      }
    }),
    new Td("Paste as Plain Text", {
      onSelect: (n) => {
        navigator.clipboard.read().then((...o) => Lt(this, null, function* () {
          if ((yield navigator.permissions.query({
            // @ts-ignore These types are incorrect.
            name: "clipboard-read"
          })).state === "denied") {
            alert("Not allowed to paste from clipboard.");
            return;
          }
          const a = new DataTransfer(), l = yield navigator.clipboard.readText();
          a.setData("text/plain", l);
          const c = new ClipboardEvent("paste", {
            clipboardData: a
          });
          e.dispatchCommand(L.PASTE_COMMAND, c);
        }));
      }
    }),
    new Td("Delete Node", {
      onSelect: (n) => {
        const o = L.$getSelection();
        if (L.$isRangeSelection(o)) {
          const a = o.anchor.getNode().getParents().at(-2);
          a == null || a.remove();
        }
      }
    })
  ], [e]), r = ye(
    (n, o, s) => {
      e.update(() => {
        n.onSelect(o), s();
      });
    },
    [e]
  );
  return /* @__PURE__ */ f(
    M8.LexicalContextMenuPlugin,
    {
      options: i,
      onSelectOption: r,
      menuRenderFn: (n, { selectedIndex: o, options: s, selectOptionAndCleanUp: a, setHighlightedIndex: l }, { setMenuRef: c }) => {
        var u;
        return n.current ? mg.createPortal(
          /* @__PURE__ */ f(
            "div",
            {
              className: me("typeahead-popover auto-embed-menu", (u = t.getTheme()) == null ? void 0 : u.typeaheadPopover),
              style: {
                marginLeft: n.current.style.width,
                userSelect: "none",
                width: 200
              },
              ref: c,
              children: /* @__PURE__ */ f(
                Rre,
                {
                  options: i,
                  selectedItemIndex: o,
                  onOptionClick: (m, g) => {
                    l(g), a(m);
                  },
                  onOptionMouseEnter: (m) => {
                    l(m);
                  }
                }
              )
            }
          ),
          n.current
        ) : null;
      }
    }
  );
}
const uw = ["image/", "image/heic", "image/heif", "image/gif", "image/webp"];
function kre() {
  const [e] = nt.useLexicalComposerContext();
  return be(() => e.registerCommand(
    Jr.DRAG_DROP_PASTE,
    (t) => (Lt(this, null, function* () {
      const i = yield it.mediaFileReader(
        t,
        [uw].flatMap((r) => r)
      );
      for (const { file: r, result: n } of i)
        it.isMimeType(r, uw) && e.dispatchCommand(J0, {
          altText: r.name,
          src: n
        });
    }), !0),
    L.COMMAND_PRIORITY_LOW
  ), [e]), null;
}
const wre = "_draggableBlockMenu_10amp_1", Mre = "_icon_10amp_18", Nre = "_draggableBlockTargetLine_10amp_31", yE = {
  draggableBlockMenu: wre,
  icon: Mre,
  draggableBlockTargetLine: Nre
};
function EE(e) {
  return e instanceof HTMLElement;
}
class T8 {
  constructor(t, i) {
    Ze(this, "_x");
    Ze(this, "_y");
    this._x = t, this._y = i;
  }
  get x() {
    return this._x;
  }
  get y() {
    return this._y;
  }
  equals({ x: t, y: i }) {
    return this.x === t && this.y === i;
  }
  calcDeltaXTo({ x: t }) {
    return this.x - t;
  }
  calcDeltaYTo({ y: t }) {
    return this.y - t;
  }
  calcHorizontalDistanceTo(t) {
    return Math.abs(this.calcDeltaXTo(t));
  }
  calcVerticalDistance(t) {
    return Math.abs(this.calcDeltaYTo(t));
  }
  calcDistanceTo(t) {
    return Math.sqrt(Math.pow(this.calcDeltaXTo(t), 2) + Math.pow(this.calcDeltaYTo(t), 2));
  }
}
function Tre(e) {
  return e instanceof T8;
}
class Ec {
  constructor(t, i, r, n) {
    Ze(this, "_left");
    Ze(this, "_top");
    Ze(this, "_right");
    Ze(this, "_bottom");
    const [o, s] = i <= n ? [i, n] : [n, i], [a, l] = t <= r ? [t, r] : [r, t];
    this._top = o, this._right = l, this._left = a, this._bottom = s;
  }
  get top() {
    return this._top;
  }
  get right() {
    return this._right;
  }
  get bottom() {
    return this._bottom;
  }
  get left() {
    return this._left;
  }
  get width() {
    return Math.abs(this._left - this._right);
  }
  get height() {
    return Math.abs(this._bottom - this._top);
  }
  equals({ top: t, left: i, bottom: r, right: n }) {
    return t === this._top && r === this._bottom && i === this._left && n === this._right;
  }
  contains(t) {
    if (Tre(t)) {
      const { x: i, y: r } = t, n = r < this._top, o = r > this._bottom, s = i < this._left, a = i > this._right;
      return {
        reason: {
          isOnBottomSide: o,
          isOnLeftSide: s,
          isOnRightSide: a,
          isOnTopSide: n
        },
        result: !n && !o && !s && !a
      };
    } else {
      const { top: i, left: r, bottom: n, right: o } = t;
      return i >= this._top && i <= this._bottom && n >= this._top && n <= this._bottom && r >= this._left && r <= this._right && o >= this._left && o <= this._right;
    }
  }
  intersectsWith(t) {
    const { left: i, top: r, width: n, height: o } = t, { left: s, top: a, width: l, height: c } = this, u = i + n >= s + l ? i + n : s + l, m = r + o >= a + c ? r + o : a + c, g = i <= s ? i : s, h = r <= a ? r : a;
    return u - g <= n + l && m - h <= o + c;
  }
  generateNewRect({ left: t = this.left, top: i = this.top, right: r = this.right, bottom: n = this.bottom }) {
    return new Ec(t, i, r, n);
  }
  static fromLTRB(t, i, r, n) {
    return new Ec(t, i, r, n);
  }
  static fromLWTH(t, i, r, n) {
    return new Ec(t, r, t + i, r + n);
  }
  static fromPoints(t, i) {
    const { y: r, x: n } = t, { y: o, x: s } = i;
    return Ec.fromLTRB(n, r, s, o);
  }
  static fromDOM(t) {
    const { top: i, width: r, left: n, height: o } = t.getBoundingClientRect();
    return Ec.fromLWTH(n, r, i, o);
  }
}
const Xb = 4, Bre = 2, Dre = "draggable-block-menu", dw = "application/x-lexical-drag-block", mw = 28, Ore = 1, Fre = -1, gw = 0;
let Wp = 1 / 0;
function Vre(e) {
  return e === 0 ? 1 / 0 : Wp >= 0 && Wp < e ? Wp : Math.floor(e / 2);
}
function qre(e) {
  return e.getEditorState().read(() => L.$getRoot().getChildrenKeys());
}
function B8(e) {
  const t = (l, c) => l ? parseFloat(window.getComputedStyle(l)[c]) : 0, { marginTop: i, marginBottom: r } = window.getComputedStyle(e), n = t(e.previousElementSibling, "marginBottom"), o = t(e.nextElementSibling, "marginTop"), s = Math.max(parseFloat(i), n);
  return { marginBottom: Math.max(parseFloat(r), o), marginTop: s };
}
function vE(e, t, i, r = !1) {
  const n = e.getBoundingClientRect(), o = qre(t);
  let s = null;
  return t.getEditorState().read(() => {
    if (r) {
      const [c, u] = [
        t.getElementByKey(o[0]),
        t.getElementByKey(o[o.length - 1])
      ], [m, g] = [c == null ? void 0 : c.getBoundingClientRect(), u == null ? void 0 : u.getBoundingClientRect()];
      if (m && g && (i.y < m.top ? s = c : i.y > g.bottom && (s = u), s))
        return;
    }
    let a = Vre(o.length), l = gw;
    for (; a >= 0 && a < o.length; ) {
      const c = o[a], u = t.getElementByKey(c);
      if (u === null)
        break;
      const m = new T8(i.x, i.y), g = Ec.fromDOM(u), { marginTop: h, marginBottom: A } = B8(u), y = g.generateNewRect({
        bottom: g.bottom + A,
        left: n.left,
        right: n.right,
        top: g.top - h
      }), {
        result: E,
        reason: { isOnTopSide: v, isOnBottomSide: C }
      } = y.contains(m);
      if (E) {
        s = u, Wp = a;
        break;
      }
      l === gw && (v ? l = Fre : C ? l = Ore : l = 1 / 0), a += l;
    }
  }), s;
}
function jre(e) {
  return !!e.closest(`.${Dre}`);
}
function Lre(e, t, i) {
  if (!e) {
    t.style.opacity = "0", t.style.transform = "translate(-10000px, -10000px)";
    return;
  }
  const r = e.getBoundingClientRect(), n = window.getComputedStyle(e), o = t.getBoundingClientRect(), s = i.getBoundingClientRect(), a = r.top + (parseInt(n.lineHeight, 10) - o.height) / 2 - s.top, l = Xb;
  t.style.opacity = "1", t.style.transform = `translate(${l}px, ${a}px)`;
}
function Kre(e, t) {
  const { transform: i } = t.style;
  t.style.transform = "translateZ(0)", e.setDragImage(t, 0, 0), setTimeout(() => {
    t.style.transform = i;
  });
}
function Yre(e, t, i, r) {
  const { top: n, height: o } = t.getBoundingClientRect(), { top: s, width: a } = r.getBoundingClientRect(), { marginTop: l, marginBottom: c } = B8(t);
  let u = n;
  i >= n ? u += o + c / 2 : u -= l / 2;
  const m = u - s - Bre, g = mw - Xb;
  e.style.transform = `translate(${g}px, ${m}px)`, e.style.width = `${a - (mw - Xb) * 2}px`, e.style.opacity = ".4";
}
function Ure(e) {
  e && (e.style.opacity = "0", e.style.transform = "translate(-10000px, -10000px)");
}
function Gre(e, t, i) {
  const r = t.parentElement, n = Ne(null), o = Ne(null), s = Ne(!1), [a, l] = se(null);
  be(() => {
    function m(h) {
      const A = h.target;
      if (!EE(A)) {
        l(null);
        return;
      }
      if (jre(A))
        return;
      const y = vE(t, e, h);
      l(y);
    }
    function g() {
      l(null);
    }
    return r == null || r.addEventListener("mousemove", m), r == null || r.addEventListener("mouseleave", g), () => {
      r == null || r.removeEventListener("mousemove", m), r == null || r.removeEventListener("mouseleave", g);
    };
  }, [r, t, e]), be(() => {
    n.current && Lre(a, n.current, t);
  }, [t, a]), be(() => {
    function m(h) {
      if (!s.current)
        return !1;
      const [A] = Jr.eventFiles(h);
      if (A)
        return !1;
      const { pageY: y, target: E } = h;
      if (!EE(E))
        return !1;
      const v = vE(t, e, h, !0), C = o.current;
      return v === null || C === null ? !1 : (Yre(C, v, y, t), h.preventDefault(), !0);
    }
    function g(h) {
      if (!s.current)
        return !1;
      const [A] = Jr.eventFiles(h);
      if (A)
        return !1;
      const { target: y, dataTransfer: E, pageY: v } = h, C = (E == null ? void 0 : E.getData(dw)) || "", x = L.$getNodeByKey(C);
      if (!x || !EE(y))
        return !1;
      const S = vE(t, e, h, !0);
      if (!S)
        return !1;
      const R = L.$getNearestNodeFromDOMNode(S);
      if (!R)
        return !1;
      if (R === x)
        return !0;
      const w = S.getBoundingClientRect().top;
      return v >= w ? R.insertAfter(x) : R.insertBefore(x), l(null), !0;
    }
    return it.mergeRegister(
      e.registerCommand(
        L.DRAGOVER_COMMAND,
        (h) => m(h),
        L.COMMAND_PRIORITY_LOW
      ),
      e.registerCommand(
        L.DROP_COMMAND,
        (h) => g(h),
        L.COMMAND_PRIORITY_HIGH
      )
    );
  }, [t, e]);
  function c(m) {
    const g = m.dataTransfer;
    if (!g || !a)
      return;
    Kre(g, a);
    let h = "";
    e.update(() => {
      const A = L.$getNearestNodeFromDOMNode(a);
      A && (h = A.getKey());
    }), s.current = !0, g.setData(dw, h);
  }
  function u() {
    s.current = !1, Ure(o.current);
  }
  return ps(
    /* @__PURE__ */ V(gt, { children: [
      /* @__PURE__ */ f(
        "div",
        {
          className: me("maxroll-rte-draggable-block-menu", yE.icon, yE.draggableBlockMenu),
          ref: n,
          draggable: !0,
          onDragStart: c,
          onDragEnd: u,
          children: /* @__PURE__ */ f("div", { className: i ? "icon" : "" })
        }
      ),
      /* @__PURE__ */ f("div", { className: yE.draggableBlockTargetLine, ref: o })
    ] }),
    t
  );
}
function Qre({
  anchorElem: e = document.body
}) {
  const [t] = nt.useLexicalComposerContext();
  return Gre(t, e, t._editable);
}
const Wre = "_linkEditor_yet9v_1", Zre = "_button_yet9v_17", Jre = "_hoveredButton_yet9v_27", Pre = "_actions_yet9v_35", zre = {
  linkEditor: Wre,
  button: Zre,
  hoveredButton: Jre,
  actions: Pre
};
function zm(e) {
  const t = e.anchor, i = e.focus, r = e.anchor.getNode(), n = e.focus.getNode();
  return r === n ? r : e.isBackward() ? wi.$isAtNodeEnd(i) ? r : n : wi.$isAtNodeEnd(t) ? r : n;
}
const Hre = 10, Xre = 5;
function hw(e, t, i, r = Hre, n = Xre) {
  const o = i.parentElement;
  if (e === null || !o) {
    t.style.opacity = "0", t.style.transform = "translate(-10000px, -10000px)";
    return;
  }
  const s = t.getBoundingClientRect(), a = i.getBoundingClientRect(), l = o.getBoundingClientRect();
  let c = e.top - r, u = e.left - n;
  c < l.top && (c += s.height + e.height + r * 2), u + s.width > l.right && (u = l.right - s.width - n), c -= a.top, u -= a.left, t.style.opacity = "1", t.style.transform = `translate(${u}px, ${c}px)`;
}
function _re({
  editor: e,
  isLink: t,
  setIsLink: i,
  anchorElem: r,
  isLinkEditMode: n,
  setIsLinkEditMode: o
}) {
  const s = Ne(null), a = Ne(null), [l, c] = se(""), [u, m] = se("https://"), [g, h] = se(null), A = ye(() => {
    var w, T;
    const v = L.$getSelection();
    if (L.$isRangeSelection(v)) {
      const N = zm(v), D = N.getParent();
      Ii.$isLinkNode(D) ? c(D.getURL()) : Ii.$isLinkNode(N) ? c(N.getURL()) : c("");
    }
    const C = s.current, x = window.getSelection(), S = document.activeElement;
    if (C === null)
      return;
    const R = e.getRootElement();
    if (v !== null && x !== null && R !== null && R.contains(x.anchorNode) && e.isEditable()) {
      const N = (T = (w = x.focusNode) == null ? void 0 : w.parentElement) == null ? void 0 : T.getBoundingClientRect();
      N && (N.y += 40, hw(N, C, r)), h(v);
    } else
      (!S || S.className !== "link-input") && (R !== null && hw(null, C, r), h(null), o(!1), c(""));
    return !0;
  }, [r, e, o]);
  be(() => {
    const v = r.parentElement, C = () => {
      e.getEditorState().read(() => {
        A();
      });
    };
    return window.addEventListener("resize", C), v && v.addEventListener("scroll", C), () => {
      window.removeEventListener("resize", C), v && v.removeEventListener("scroll", C);
    };
  }, [r.parentElement, e, A]), be(() => it.mergeRegister(
    e.registerUpdateListener(({ editorState: v }) => {
      v.read(() => {
        A();
      });
    }),
    e.registerCommand(
      L.SELECTION_CHANGE_COMMAND,
      () => (A(), !0),
      L.COMMAND_PRIORITY_LOW
    ),
    e.registerCommand(
      L.KEY_ESCAPE_COMMAND,
      () => t ? (i(!1), !0) : !1,
      L.COMMAND_PRIORITY_HIGH
    )
  ), [e, A, i, t]), be(() => {
    e.getEditorState().read(() => {
      A();
    });
  }, [e, A]), be(() => {
    n && a.current && a.current.focus();
  }, [n, t]);
  const y = (v) => {
    v.key === "Enter" ? (v.preventDefault(), E()) : v.key === "Escape" && (v.preventDefault(), o(!1));
  }, E = () => {
    g !== null && (l !== "" && e.dispatchCommand(Ii.TOGGLE_LINK_COMMAND, S1(u)), m("https://"), o(!1));
  };
  return /* @__PURE__ */ f("div", { ref: s, className: me("maxroll-link-editor", zre.linkEditor), children: t ? n ? /* @__PURE__ */ V(gt, { children: [
    /* @__PURE__ */ f(
      "input",
      {
        ref: a,
        className: "link-input",
        value: u,
        onChange: (v) => {
          m(v.target.value);
        },
        onKeyDown: (v) => {
          y(v);
        }
      }
    ),
    /* @__PURE__ */ V("div", { children: [
      /* @__PURE__ */ f(
        "div",
        {
          className: "link-cancel",
          role: "button",
          tabIndex: 0,
          onMouseDown: (v) => v.preventDefault(),
          onClick: () => {
            o(!1);
          }
        }
      ),
      /* @__PURE__ */ f(
        "div",
        {
          className: "link-confirm",
          role: "button",
          tabIndex: 0,
          onMouseDown: (v) => v.preventDefault(),
          onClick: E
        }
      )
    ] })
  ] }) : /* @__PURE__ */ V("div", { className: "link-view", children: [
    /* @__PURE__ */ f("a", { href: S1(l), target: "_blank", rel: "noopener noreferrer", children: l }),
    /* @__PURE__ */ f(
      "div",
      {
        className: "link-edit",
        role: "button",
        tabIndex: 0,
        onMouseDown: (v) => v.preventDefault(),
        onClick: () => {
          m(l), o(!0);
        }
      }
    ),
    /* @__PURE__ */ f(
      "div",
      {
        className: "link-trash",
        role: "button",
        tabIndex: 0,
        onMouseDown: (v) => v.preventDefault(),
        onClick: () => {
          e.dispatchCommand(Ii.TOGGLE_LINK_COMMAND, null);
        }
      }
    )
  ] }) : null });
}
function $re(e, t, i, r) {
  const [n, o] = se(e), [s, a] = se(!1);
  return be(() => {
    function l() {
      const c = L.$getSelection();
      if (L.$isRangeSelection(c)) {
        const u = zm(c), m = it.$findMatchingParent(u, Ii.$isLinkNode), g = it.$findMatchingParent(u, Ii.$isAutoLinkNode);
        a(m !== null && g === null);
      }
    }
    return it.mergeRegister(
      e.registerUpdateListener(({ editorState: c }) => {
        c.read(() => {
          l();
        });
      }),
      e.registerCommand(
        L.SELECTION_CHANGE_COMMAND,
        (c, u) => (l(), o(u), !1),
        L.COMMAND_PRIORITY_CRITICAL
      ),
      e.registerCommand(
        L.CLICK_COMMAND,
        (c) => {
          const u = L.$getSelection();
          if (L.$isRangeSelection(u)) {
            const m = zm(u), g = it.$findMatchingParent(m, Ii.$isLinkNode);
            if (Ii.$isLinkNode(g) && (c.metaKey || c.ctrlKey))
              return window.open(g.getURL(), "_blank"), !0;
          }
          return !1;
        },
        L.COMMAND_PRIORITY_LOW
      )
    );
  }, [e]), ps(
    /* @__PURE__ */ f(
      _re,
      {
        editor: n,
        isLink: s,
        anchorElem: t,
        setIsLink: a,
        isLinkEditMode: i,
        setIsLinkEditMode: r
      }
    ),
    t
  );
}
function D8({
  anchorElem: e = document.body,
  isLinkEditMode: t,
  setIsLinkEditMode: i
}) {
  const [r] = nt.useLexicalComposerContext();
  return $re(r, e, t, i);
}
const ene = "_floatingTextFormatPopup_mbjt4_1", tne = "_popupItem_mbjt4_16", ine = "_spaced_mbjt4_27", rne = "_format_mbjt4_30", nne = "_icon_mbjt4_39", one = "_active_mbjt4_45", sne = "_text_mbjt4_76", ane = "_inside_mbjt4_107", lne = "_divider_mbjt4_117", Qi = {
  floatingTextFormatPopup: ene,
  popupItem: tne,
  spaced: ine,
  format: rne,
  icon: nne,
  "font-color": "_font-color_mbjt4_39",
  active: one,
  "code-language": "_code-language_mbjt4_71",
  text: sne,
  "chevron-down": "_chevron-down_mbjt4_99",
  inside: ane,
  divider: lne,
  "insert-comment": "_insert-comment_mbjt4_126"
}, cne = "_colorPickerWrapper_5bkpn_1", une = "_colorPickerBasicColor_5bkpn_5", dne = "_active_5bkpn_19", mne = "_colorPickerSaturation_5bkpn_25", gne = "_colorPickerSaturationCursor_5bkpn_33", hne = "_colorPickerHue_5bkpn_44", pne = "_colorPickerHueCursor_5bkpn_63", fne = "_colorPickerColor_5bkpn_74", lc = {
  colorPickerWrapper: cne,
  colorPickerBasicColor: une,
  active: dne,
  colorPickerSaturation: mne,
  colorPickerSaturationCursor: gne,
  colorPickerHue: hne,
  colorPickerHueCursor: pne,
  colorPickerColor: fne
}, Ane = [
  {
    name: "Default",
    slug: "default",
    color: void 0
  }
], Bd = 214, pw = 150;
function O8({ color: e, onChange: t }) {
  var y;
  const [, i] = nt.useLexicalComposerContext(), [r, n] = se(qu("hex", e)), [o, s] = se(e), a = Ne(null), l = we(
    () => ({
      x: r.hsv.s / 100 * Bd,
      y: (100 - r.hsv.v) / 100 * pw
    }),
    [r.hsv.s, r.hsv.v]
  ), c = we(
    () => ({
      x: r.hsv.h / 360 * Bd
    }),
    [r.hsv]
  ), u = (E) => {
    if (s(E), /^#[0-9A-Fa-f]{6}$/i.test(E)) {
      const v = qu("hex", E);
      n(v);
    }
  }, m = ({ x: E, y: v }) => {
    const C = ee(q({}, r.hsv), {
      s: E / Bd * 100,
      v: 100 - v / pw * 100
    }), x = qu("hsv", C);
    n(x), s(x.hex);
  }, g = ({ x: E }) => {
    const v = ee(q({}, r.hsv), { h: E / Bd * 360 }), C = qu("hsv", v);
    n(C), s(C.hex);
  };
  be(() => {
    a.current !== null && t && (t(r.hex), s(r.hex));
  }, [r, t]), be(() => {
    if (e === void 0)
      return;
    const E = qu("hex", e);
    n(E), s(E.hex);
  }, [e]);
  const h = (y = i.getTheme()) == null ? void 0 : y.suggestedColors, A = we(() => [...Ane, ...h || []], [h]);
  return /* @__PURE__ */ V("div", { className: lc.colorPickerWrapper, style: { width: Bd }, ref: a, children: [
    /* @__PURE__ */ f(hs, { label: "Hex", onChange: u, value: o }),
    /* @__PURE__ */ f("div", { className: lc.colorPickerBasicColor, children: A.map((E) => /* @__PURE__ */ f(
      "button",
      {
        className: E.color === r.hex ? " active" : "",
        style: { backgroundColor: E.color },
        title: E.name,
        onClick: () => {
          E.color ? (s(E.color), n(qu("hex", E.color))) : t && t("");
        }
      },
      E.slug
    )) }),
    /* @__PURE__ */ f(
      fw,
      {
        className: lc.colorPickerSaturation,
        style: { backgroundColor: `hsl(${r.hsv.h}, 100%, 50%)` },
        onChange: m,
        children: /* @__PURE__ */ f(
          "div",
          {
            className: lc.colorPickerSaturationCursor,
            style: {
              backgroundColor: r.hex,
              left: l.x,
              top: l.y
            }
          }
        )
      }
    ),
    /* @__PURE__ */ f(fw, { className: lc.colorPickerHue, onChange: g, children: /* @__PURE__ */ f(
      "div",
      {
        className: lc.colorPickerHueCursor,
        style: {
          backgroundColor: `hsl(${r.hsv.h}, 100%, 50%)`,
          left: c.x
        }
      }
    ) }),
    /* @__PURE__ */ f("div", { className: lc.colorPickerColor, style: { backgroundColor: r.hex } })
  ] });
}
function fw({ className: e, style: t, onChange: i, children: r }) {
  const n = Ne(null), o = (a) => {
    if (n.current) {
      const { current: l } = n, { width: c, height: u, left: m, top: g } = l.getBoundingClientRect(), h = Aw(a.clientX - m, c, 0), A = Aw(a.clientY - g, u, 0);
      i({ x: h, y: A });
    }
  };
  return /* @__PURE__ */ f("div", { ref: n, className: e, style: t, onMouseDown: (a) => {
    if (a.button !== 0)
      return;
    o(a);
    const l = (u) => {
      o(u);
    }, c = (u) => {
      document.removeEventListener("mousemove", l, !1), document.removeEventListener("mouseup", c, !1), o(u);
    };
    document.addEventListener("mousemove", l, !1), document.addEventListener("mouseup", c, !1);
  }, children: r });
}
function Aw(e, t, i) {
  return e > t ? t : e < i ? i : e;
}
function yw(e) {
  if (e.startsWith("#")) {
    if (e.length === 4 || e.length === 5)
      return e = e.split("").map((t, i) => i ? t + t : "#").join(""), e;
    if (e.length === 7 || e.length === 9)
      return e;
  } else {
    const t = Wt("canvas").getContext("2d");
    if (!t)
      throw new Error("2d context not supported or canvas already initialized");
    return t.fillStyle = e, t.fillStyle;
  }
  return "#000000";
}
function Ew(e) {
  const t = (e.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (i, r, n, o) => "#" + r + r + n + n + o + o).substring(1).match(/.{2}/g) || []).map((i) => parseInt(i, 16));
  return {
    b: t[2],
    g: t[1],
    r: t[0]
  };
}
function bE({ r: e, g: t, b: i }) {
  e /= 255, t /= 255, i /= 255;
  const r = Math.max(e, t, i), n = r - Math.min(e, t, i), o = n ? (r === e ? (t - i) / n + (t < i ? 6 : 0) : r === t ? 2 + (i - e) / n : 4 + (e - t) / n) * 60 : 0, s = r ? n / r * 100 : 0, a = r * 100;
  return { h: o, s, v: a };
}
function yne({ h: e, s: t, v: i }) {
  t /= 100, i /= 100;
  const r = ~~(e / 60), n = e / 60 - r, o = i * (1 - t), s = i * (1 - t * n), a = i * (1 - t * (1 - n)), l = r % 6, c = Math.round([i, s, o, o, a, i][l] * 255), u = Math.round([a, i, i, s, o, o][l] * 255);
  return { b: Math.round([o, o, a, i, i, s][l] * 255), g: u, r: c };
}
function vw({ b: e, g: t, r: i }) {
  return "#" + [i, t, e].map((r) => r.toString(16).padStart(2, "0")).join("");
}
function qu(e, t) {
  let i = yw("#121212"), r = Ew(i), n = bE(r);
  return e === "hex" ? (i = yw(t), r = Ew(i), n = bE(r)) : e === "rgb" ? (r = t, i = vw(r), n = bE(r)) : e === "hsv" && (n = t, r = yne(n), i = vw(r)), { hex: i, hsv: n, rgb: r };
}
function _b(o) {
  var s = o, {
    disabled: e = !1,
    stopCloseOnClickSelf: t = !0,
    color: i,
    onChange: r
  } = s, n = Fe(s, [
    "disabled",
    "stopCloseOnClickSelf",
    "color",
    "onChange"
  ]);
  return /* @__PURE__ */ f(Ia, ee(q({}, n), { disabled: e, stopCloseOnClickSelf: t, children: /* @__PURE__ */ f(O8, { color: i, onChange: r }) }));
}
function Ene(e, t) {
  const i = e.getRangeAt(0);
  let r;
  if (e.anchorNode === t) {
    let n = t;
    for (; n.firstElementChild != null; )
      n = n.firstElementChild;
    r = n.getBoundingClientRect();
  } else
    r = i.getBoundingClientRect();
  return r;
}
const vne = 10, bne = 5;
function Cne(e, t, i, r = !1, n = vne, o = bne) {
  const s = i.parentElement;
  if (e === null || !s) {
    t.style.opacity = "0", t.style.transform = "translate(-10000px, -10000px)";
    return;
  }
  const a = t.getBoundingClientRect(), l = i.getBoundingClientRect(), c = s.getBoundingClientRect();
  let u = e.top - a.height - n, m = e.left - o;
  u < c.top && (u += a.height + e.height + n * (r ? 9 : 2)), m + a.width > c.right && (m = c.right - a.width - o), u -= l.top, m -= l.left, t.style.opacity = "1", t.style.transform = `translate(${m}px, ${u}px)`;
}
function xne({
  editor: e,
  anchorElem: t,
  isLink: i,
  isBold: r,
  isItalic: n,
  isUnderline: o,
  isCode: s,
  isStrikethrough: a,
  isSubscript: l,
  isSuperscript: c
}) {
  const [u] = se(e), m = Ne(null), g = ye(() => {
    i ? e.dispatchCommand(Ii.TOGGLE_LINK_COMMAND, null) : e.dispatchCommand(Ii.TOGGLE_LINK_COMMAND, "https://");
  }, [e, i]);
  function h(S) {
    if (m != null && m.current && (S.buttons === 1 || S.buttons === 3) && m.current.style.pointerEvents !== "none") {
      const R = S.clientX, w = S.clientY, T = document.elementFromPoint(R, w);
      m.current.contains(T) || (m.current.style.pointerEvents = "none");
    }
  }
  function A(S) {
    m != null && m.current && m.current.style.pointerEvents !== "auto" && (m.current.style.pointerEvents = "auto");
  }
  be(() => {
    if (m != null && m.current)
      return document.addEventListener("mousemove", h), document.addEventListener("mouseup", A), () => {
        document.removeEventListener("mousemove", h), document.removeEventListener("mouseup", A);
      };
  }, [m]);
  const y = ye(() => {
    const S = L.$getSelection();
    L.$isRangeSelection(S) && C(wi.$getSelectionStyleValueForProperty(S, "color", "#000"));
    const R = m.current, w = window.getSelection();
    if (R === null)
      return;
    const T = e.getRootElement();
    if (S !== null && w !== null && !w.isCollapsed && T !== null && T.contains(w.anchorNode)) {
      const N = Ene(w, T);
      Cne(N, R, t, i);
    }
  }, [e, t, i]);
  be(() => {
    const S = t.parentElement, R = () => {
      e.getEditorState().read(() => {
        y();
      });
    };
    return window.addEventListener("resize", R), S && S.addEventListener("scroll", R), () => {
      window.removeEventListener("resize", R), S && S.removeEventListener("scroll", R);
    };
  }, [e, y, t]), be(() => (e.getEditorState().read(() => {
    y();
  }), it.mergeRegister(
    e.registerUpdateListener(({ editorState: S }) => {
      S.read(() => {
        y();
      });
    }),
    e.registerCommand(
      L.SELECTION_CHANGE_COMMAND,
      () => (y(), !1),
      L.COMMAND_PRIORITY_LOW
    )
  )), [e, y]);
  const E = ye(
    (S) => {
      u.update(() => {
        const R = L.$getSelection();
        (L.$isRangeSelection(R) || L.DEPRECATED_$isGridSelection(R)) && wi.$patchStyleText(R, S);
      });
    },
    [u]
  ), [v, C] = se("#000"), x = ye(
    (S) => {
      E({ color: S });
    },
    [E]
  );
  return /* @__PURE__ */ f(
    "div",
    {
      ref: m,
      className: me("maxroll-rte-floating-text", Qi.floatingTextFormatPopup),
      children: e.isEditable() && /* @__PURE__ */ V(gt, { children: [
        /* @__PURE__ */ f(
          "button",
          {
            type: "button",
            onClick: () => {
              e.dispatchCommand(L.FORMAT_TEXT_COMMAND, "bold");
            },
            className: me(Qi.popupItem, Qi.spaced, r ? Qi.active : ""),
            "aria-label": "Format text as bold",
            children: /* @__PURE__ */ f("i", { className: me(Qi.format, "bold") })
          }
        ),
        /* @__PURE__ */ f(
          "button",
          {
            type: "button",
            onClick: () => {
              e.dispatchCommand(L.FORMAT_TEXT_COMMAND, "italic");
            },
            className: me(Qi.popupItem, Qi.spaced, n ? Qi.active : ""),
            "aria-label": "Format text as italics",
            children: /* @__PURE__ */ f("i", { className: me(Qi.format, "italic") })
          }
        ),
        /* @__PURE__ */ f(
          "button",
          {
            type: "button",
            onClick: () => {
              e.dispatchCommand(L.FORMAT_TEXT_COMMAND, "underline");
            },
            className: me(Qi.popupItem, Qi.spaced, o ? Qi.active : ""),
            "aria-label": "Format text to underlined",
            children: /* @__PURE__ */ f("i", { className: me(Qi.format, "underline") })
          }
        ),
        /* @__PURE__ */ f(
          _b,
          {
            buttonClassName: me("toolbar-item color-picker", Qi.popupItem, Qi.spaced),
            buttonAriaLabel: "Formatting text color",
            buttonIconClassName: "icon font-color",
            color: v,
            onChange: x,
            title: "text color"
          }
        ),
        /* @__PURE__ */ f(
          "button",
          {
            type: "button",
            onClick: () => {
              e.dispatchCommand(L.FORMAT_TEXT_COMMAND, "code");
            },
            className: me(Qi.popupItem, Qi.spaced, s ? Qi.active : ""),
            "aria-label": "Insert code block",
            children: /* @__PURE__ */ f("i", { className: me(Qi.format, "code") })
          }
        ),
        /* @__PURE__ */ f(
          "button",
          {
            type: "button",
            onClick: g,
            className: me(Qi.popupItem, Qi.spaced, i ? Qi.active : ""),
            "aria-label": "Insert link",
            children: /* @__PURE__ */ f("i", { className: me(Qi.format, "link") })
          }
        )
      ] })
    }
  );
}
function Ine(e, t) {
  const [i, r] = se(!1), [n, o] = se(!1), [s, a] = se(!1), [l, c] = se(!1), [u, m] = se(!1), [g, h] = se(!1), [A, y] = se(!1), [E, v] = se(!1), [C, x] = se(!1), S = ye(() => {
    e.getEditorState().read(() => {
      if (e.isComposing())
        return;
      const R = L.$getSelection(), w = window.getSelection(), T = e.getRootElement();
      if (w !== null && (!L.$isRangeSelection(R) || T === null || !T.contains(w.anchorNode))) {
        r(!1);
        return;
      }
      if (!L.$isRangeSelection(R))
        return;
      const N = zm(R);
      a(R.hasFormat("bold")), c(R.hasFormat("italic")), m(R.hasFormat("underline")), h(R.hasFormat("strikethrough")), y(R.hasFormat("subscript")), v(R.hasFormat("superscript")), x(R.hasFormat("code"));
      const D = N.getParent();
      Ii.$isLinkNode(D) || Ii.$isLinkNode(N) ? o(!0) : o(!1), !nn.$isCodeHighlightNode(R.anchor.getNode()) && R.getTextContent() !== "" ? r(L.$isTextNode(N) || L.$isParagraphNode(N)) : r(!1);
      const O = R.getTextContent().replace(/\n/g, "");
      if (!R.isCollapsed() && O === "") {
        r(!1);
        return;
      }
    });
  }, [e]);
  return be(() => (document.addEventListener("selectionchange", S), () => {
    document.removeEventListener("selectionchange", S);
  }), [S]), be(() => it.mergeRegister(
    e.registerUpdateListener(() => {
      S();
    }),
    e.registerRootListener(() => {
      e.getRootElement() === null && r(!1);
    })
  ), [e, S]), i ? ps(
    /* @__PURE__ */ f(
      xne,
      {
        editor: e,
        anchorElem: t,
        isLink: n,
        isBold: s,
        isItalic: l,
        isStrikethrough: g,
        isSubscript: A,
        isSuperscript: E,
        isUnderline: u,
        isCode: C
      }
    ),
    t
  ) : null;
}
function $b({
  anchorElem: e = document.body
}) {
  const [t] = nt.useLexicalComposerContext();
  return Ine(t, e);
}
const Sne = "_checkbox_yo7jr_1", F8 = {
  checkbox: Sne
}, Rne = "_contentEditable_9xrfd_1", kne = "_placeholder_9xrfd_20", bw = {
  contentEditable: Rne,
  placeholder: kne
}, wne = "_base_149us_1", Cw = {
  base: wne,
  default: "_default_149us_24"
};
function V8(n) {
  var o = n, { children: e, label: t, className: i } = o, r = Fe(o, ["children", "label", "className"]);
  return /* @__PURE__ */ V("div", { className: Ls.wrapper, children: [
    /* @__PURE__ */ f("label", { style: { marginTop: "-1em" }, className: Ls.label, children: t }),
    /* @__PURE__ */ f("select", ee(q({}, r), { className: me(Cw.base, i || Cw.default), children: e }))
  ] });
}
function Mne({
  altText: e,
  className: t,
  imageRef: i,
  src: r,
  width: n,
  height: o,
  position: s
}) {
  return /* @__PURE__ */ f(
    "img",
    {
      className: t || void 0,
      src: r,
      alt: e,
      ref: i,
      "data-position": s,
      style: {
        display: "block",
        height: o,
        width: n
      },
      draggable: "false"
    }
  );
}
function Nne({
  activeEditor: e,
  nodeKey: t,
  onClose: i
}) {
  const n = e.getEditorState().read(() => L.$getNodeByKey(t)), [o, s] = se(n.getAltText()), [a, l] = se(n.getShowCaption()), [c, u] = se(n.getPosition()), m = (A) => {
    l(A.target.checked);
  }, g = (A) => {
    u(A.target.value);
  }, h = () => {
    const A = { altText: o, position: c, showCaption: a };
    n && e.update(() => {
      n.update(A);
    }), i();
  };
  return /* @__PURE__ */ V(gt, { children: [
    /* @__PURE__ */ f("div", { style: { marginBottom: "1em" }, children: /* @__PURE__ */ f(
      hs,
      {
        label: "Alt Text",
        placeholder: "Descriptive alternative text",
        onChange: s,
        value: o,
        "data-test-id": "image-modal-alt-text-input"
      }
    ) }),
    /* @__PURE__ */ V(
      V8,
      {
        style: { marginBottom: "1em", width: "208px" },
        value: c,
        label: "Position",
        name: "position",
        id: "position-select",
        onChange: g,
        children: [
          /* @__PURE__ */ f("option", { value: "left", children: "Left" }),
          /* @__PURE__ */ f("option", { value: "right", children: "Right" }),
          /* @__PURE__ */ f("option", { value: "full", children: "Full Width" })
        ]
      }
    ),
    /* @__PURE__ */ V("div", { className: Ls.wrapper, children: [
      /* @__PURE__ */ f(
        "input",
        {
          id: "caption",
          className: F8.checkbox,
          type: "checkbox",
          checked: a,
          onChange: m
        }
      ),
      /* @__PURE__ */ f("label", { htmlFor: "caption", children: "Show Caption" })
    ] }),
    /* @__PURE__ */ f(Zl, { children: /* @__PURE__ */ f(fo, { "data-test-id": "image-modal-file-upload-btn", onClick: () => h(), children: "Confirm" }) })
  ] });
}
function Tne({
  src: e,
  altText: t,
  nodeKey: i,
  width: r,
  height: n,
  showCaption: o,
  caption: s,
  position: a
}) {
  const [l, c] = Rg(), u = Ne(null), m = Ne(null), [g, h, A] = vg.useLexicalNodeSelection(i), [y] = nt.useLexicalComposerContext(), [E, v] = se(null), C = Ne(null), x = ye(
    (N) => {
      if (g && L.$isNodeSelection(L.$getSelection())) {
        N.preventDefault();
        const O = L.$getNodeByKey(i);
        q8(O) && O.remove();
      }
      return !1;
    },
    [g, i]
  ), S = ye(
    (N) => {
      const D = L.$getSelection(), O = m.current;
      if (g && L.$isNodeSelection(D) && D.getNodes().length === 1) {
        if (o)
          return L.$setSelection(null), N.preventDefault(), s.focus(), !0;
        if (O !== null && O !== document.activeElement)
          return N.preventDefault(), O.focus(), !0;
      }
      return !1;
    },
    [s, g, o]
  ), R = ye(
    (N) => C.current === s || m.current === N.target ? (L.$setSelection(null), y.update(() => {
      h(!0);
      const D = y.getRootElement();
      D !== null && D.focus();
    }), !0) : !1,
    [s, y, h]
  );
  be(() => {
    let N = !0;
    const D = it.mergeRegister(
      y.registerUpdateListener(({ editorState: O }) => {
        N && v(O.read(() => L.$getSelection()));
      }),
      y.registerCommand(
        L.SELECTION_CHANGE_COMMAND,
        (O, F) => (C.current = F, !1),
        L.COMMAND_PRIORITY_LOW
      ),
      y.registerCommand(
        L.CLICK_COMMAND,
        (O) => {
          const F = O;
          return F.target === u.current ? (F.shiftKey ? h(!g) : (A(), h(!0)), !0) : !1;
        },
        L.COMMAND_PRIORITY_LOW
      ),
      y.registerCommand(
        L.DRAGSTART_COMMAND,
        (O) => O.target === u.current ? (O.preventDefault(), !0) : !1,
        L.COMMAND_PRIORITY_LOW
      ),
      y.registerCommand(L.KEY_DELETE_COMMAND, x, L.COMMAND_PRIORITY_LOW),
      y.registerCommand(L.KEY_BACKSPACE_COMMAND, x, L.COMMAND_PRIORITY_LOW),
      y.registerCommand(L.KEY_ENTER_COMMAND, S, L.COMMAND_PRIORITY_LOW),
      y.registerCommand(L.KEY_ESCAPE_COMMAND, R, L.COMMAND_PRIORITY_LOW)
    );
    return () => {
      N = !1, D();
    };
  }, [A, y, g, i, x, S, R, h]);
  const w = g && L.$isNodeSelection(E);
  return /* @__PURE__ */ V(Ll, { fallback: null, children: [
    /* @__PURE__ */ V(gt, { children: [
      /* @__PURE__ */ V("div", { draggable: w, children: [
        /* @__PURE__ */ f(
          "button",
          {
            className: "image-edit-button",
            ref: m,
            onClick: () => {
              c("Update Inline Image", (N) => /* @__PURE__ */ f(Nne, { activeEditor: y, nodeKey: i, onClose: N }));
            },
            children: "Edit"
          }
        ),
        /* @__PURE__ */ f(
          Mne,
          {
            className: g ? `focused ${L.$isNodeSelection(E) ? "draggable" : ""}` : null,
            src: e,
            altText: t,
            imageRef: u,
            width: r,
            height: n,
            position: a
          }
        )
      ] }),
      o && /* @__PURE__ */ f("div", { className: "image-caption-container", children: /* @__PURE__ */ V(kD.LexicalNestedComposer, { initialEditor: s, children: [
        /* @__PURE__ */ f(Ym.AutoFocusPlugin, {}),
        /* @__PURE__ */ f(A0, {}),
        /* @__PURE__ */ f(D8, { isLinkEditMode: !1, setIsLinkEditMode: () => {
        } }),
        /* @__PURE__ */ f($b, {}),
        /* @__PURE__ */ f(
          p0.RichTextPlugin,
          {
            contentEditable: /* @__PURE__ */ f(kl, { className: bw.contentEditable }),
            placeholder: /* @__PURE__ */ f(Mf, { className: bw.placeholder, children: "Enter a caption..." }),
            ErrorBoundary: xl
          }
        )
      ] }) })
    ] }),
    l
  ] });
}
function Bne(e) {
  if (e instanceof HTMLImageElement) {
    const { alt: t, src: i, width: r, height: n } = e;
    return { node: kx({ altText: t, height: n, src: i, width: r }) };
  }
  return null;
}
class H0 extends L.DecoratorNode {
  constructor(i, r, n, o, s, a, l, c) {
    super(c);
    Ze(this, "__src");
    Ze(this, "__altText");
    Ze(this, "__width");
    Ze(this, "__height");
    Ze(this, "__showCaption");
    Ze(this, "__caption");
    Ze(this, "__position");
    this.__src = i, this.__altText = r, this.__width = o || "inherit", this.__height = s || "inherit", this.__showCaption = a || !1, this.__caption = l || L.createEditor(), this.__position = n;
  }
  static getType() {
    return "inline-image";
  }
  static clone(i) {
    return new H0(
      i.__src,
      i.__altText,
      i.__position,
      i.__width,
      i.__height,
      i.__showCaption,
      i.__caption,
      i.__key
    );
  }
  static importJSON(i) {
    const { altText: r, height: n, width: o, caption: s, src: a, showCaption: l, position: c } = i, u = kx({
      altText: r,
      height: n,
      position: c,
      showCaption: l,
      src: a,
      width: o
    }), m = u.__caption, g = m.parseEditorState(s.editorState);
    return g.isEmpty() || m.setEditorState(g), u;
  }
  static importDOM() {
    return {
      img: (i) => ({
        conversion: Bne,
        priority: 0
      })
    };
  }
  exportDOM() {
    const i = Wt("img");
    return i.setAttribute("src", this.__src), i.setAttribute("alt", this.__altText), i.setAttribute("width", this.__width.toString()), i.setAttribute("height", this.__height.toString()), { element: i };
  }
  exportJSON() {
    return {
      altText: this.getAltText(),
      caption: this.__caption.toJSON(),
      height: this.__height === "inherit" ? 0 : this.__height,
      position: this.__position,
      showCaption: this.__showCaption,
      src: this.getSrc(),
      type: "inline-image",
      version: 1,
      width: this.__width === "inherit" ? 0 : this.__width
    };
  }
  getSrc() {
    return this.__src;
  }
  getAltText() {
    return this.__altText;
  }
  setAltText(i) {
    const r = this.getWritable();
    r.__altText = i;
  }
  setWidthAndHeight(i, r) {
    const n = this.getWritable();
    n.__width = i, n.__height = r;
  }
  getShowCaption() {
    return this.__showCaption;
  }
  setShowCaption(i) {
    const r = this.getWritable();
    r.__showCaption = i;
  }
  getPosition() {
    return this.__position;
  }
  setPosition(i) {
    const r = this.getWritable();
    r.__position = i;
  }
  update(i) {
    const r = this.getWritable(), { altText: n, showCaption: o, position: s } = i;
    n !== void 0 && (r.__altText = n), o !== void 0 && (r.__showCaption = o), s !== void 0 && (r.__position = s);
  }
  // View
  createDOM(i) {
    const r = Wt("span"), n = `${i.theme.inlineImage} position-${this.__position}`;
    return n !== void 0 && (r.className = n), r;
  }
  updateDOM(i, r, n) {
    const o = this.__position;
    if (o !== i.__position) {
      const s = `${n.theme.inlineImage} position-${o}`;
      s !== void 0 && (r.className = s);
    }
    return !1;
  }
  decorate() {
    return /* @__PURE__ */ f(Ll, { fallback: null, children: /* @__PURE__ */ f(
      Tne,
      {
        src: this.__src,
        altText: this.__altText,
        width: this.__width,
        height: this.__height,
        nodeKey: this.getKey(),
        showCaption: this.__showCaption,
        caption: this.__caption,
        position: this.__position
      }
    ) });
  }
}
function kx({
  altText: e,
  position: t,
  height: i,
  src: r,
  width: n,
  showCaption: o,
  caption: s,
  key: a
}) {
  return L.$applyNodeReplacement(new H0(r, e, t, n, i, o, s, a));
}
function q8(e) {
  return e instanceof H0;
}
const Dne = (e) => iu ? (e || window).getSelection() : null, wx = L.createCommand("INSERT_INLINE_IMAGE_COMMAND");
function One({
  activeEditor: e,
  onClose: t
}) {
  const i = Ne(!1), [r, n] = se(""), [o, s] = se(""), [a, l] = se(!1), [c, u] = se("left"), m = r === "", g = (E) => {
    l(E.target.checked);
  }, h = (E) => {
    u(E.target.value);
  }, A = (E) => {
    const v = new FileReader();
    v.onload = function() {
      return typeof v.result == "string" && n(v.result), "";
    }, E !== null && v.readAsDataURL(E[0]);
  };
  be(() => {
    i.current = !1;
    const E = (v) => {
      i.current = v.altKey;
    };
    return document.addEventListener("keydown", E), () => {
      document.removeEventListener("keydown", E);
    };
  }, [e]);
  const y = () => {
    const E = { altText: o, position: c, showCaption: a, src: r };
    e.dispatchCommand(wx, E), t();
  };
  return /* @__PURE__ */ V(gt, { children: [
    /* @__PURE__ */ f("div", { style: { marginBottom: "1em" }, children: /* @__PURE__ */ f(c8, { label: "Image Upload", onChange: A, accept: "image/*", "data-test-id": "image-modal-file-upload" }) }),
    /* @__PURE__ */ f("div", { style: { marginBottom: "1em" }, children: /* @__PURE__ */ f(
      hs,
      {
        label: "Alt Text",
        placeholder: "Descriptive alternative text",
        onChange: s,
        value: o,
        "data-test-id": "image-modal-alt-text-input"
      }
    ) }),
    /* @__PURE__ */ V(
      V8,
      {
        style: { marginBottom: "1em", width: "290px" },
        label: "Position",
        name: "position",
        id: "position-select",
        onChange: h,
        children: [
          /* @__PURE__ */ f("option", { value: "left", children: "Left" }),
          /* @__PURE__ */ f("option", { value: "right", children: "Right" }),
          /* @__PURE__ */ f("option", { value: "full", children: "Full Width" })
        ]
      }
    ),
    /* @__PURE__ */ V("div", { className: Ls.wrapper, children: [
      /* @__PURE__ */ f(
        "input",
        {
          id: "caption",
          className: F8.checkbox,
          type: "checkbox",
          checked: a,
          onChange: g
        }
      ),
      /* @__PURE__ */ f("label", { htmlFor: "caption", children: "Show Caption" })
    ] }),
    /* @__PURE__ */ f(Zl, { children: /* @__PURE__ */ f(fo, { "data-test-id": "image-modal-file-upload-btn", disabled: m, onClick: () => y(), children: "Confirm" }) })
  ] });
}
function j8() {
  const [e] = nt.useLexicalComposerContext();
  return be(() => {
    if (!e.hasNodes([H0]))
      throw new Error("ImagesPlugin: ImageNode not registered on editor");
    return it.mergeRegister(
      e.registerCommand(
        wx,
        (t) => {
          const i = kx(t);
          return L.$insertNodes([i]), L.$isRootOrShadowRoot(i.getParentOrThrow()) && it.$wrapNodeInElement(i, L.$createParagraphNode).selectEnd(), !0;
        },
        L.COMMAND_PRIORITY_EDITOR
      ),
      e.registerCommand(
        L.DRAGSTART_COMMAND,
        (t) => Vne(t),
        L.COMMAND_PRIORITY_HIGH
      ),
      e.registerCommand(
        L.DRAGOVER_COMMAND,
        (t) => qne(t),
        L.COMMAND_PRIORITY_LOW
      ),
      e.registerCommand(
        L.DROP_COMMAND,
        (t) => jne(t, e),
        L.COMMAND_PRIORITY_HIGH
      )
    );
  }, [e]), null;
}
const Fne = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", eC = Wt("img");
eC && (eC.src = Fne);
function Vne(e) {
  const t = Mx();
  if (!t)
    return !1;
  const i = e.dataTransfer;
  return i ? (i.setData("text/plain", "_"), i.setDragImage(eC, 0, 0), i.setData(
    "application/x-lexical-drag",
    JSON.stringify({
      data: {
        altText: t.__altText,
        caption: t.__caption,
        height: t.__height,
        key: t.getKey(),
        showCaption: t.__showCaption,
        src: t.__src,
        width: t.__width
      },
      type: "image"
    })
  ), !0) : !1;
}
function qne(e) {
  return Mx() ? (L8(e) || e.preventDefault(), !0) : !1;
}
function jne(e, t) {
  const i = Mx();
  if (!i)
    return !1;
  const r = Lne(e);
  if (!r)
    return !1;
  if (e.preventDefault(), L8(e)) {
    const n = Kne(e);
    i.remove();
    const o = L.$createRangeSelection();
    n != null && o.applyDOMRange(n), L.$setSelection(o), t.dispatchCommand(wx, r);
  }
  return !0;
}
function Mx() {
  const e = L.$getSelection();
  if (!L.$isNodeSelection(e))
    return null;
  const i = e.getNodes()[0];
  return q8(i) ? i : null;
}
function Lne(e) {
  var n;
  const t = (n = e.dataTransfer) == null ? void 0 : n.getData("application/x-lexical-drag");
  if (!t)
    return null;
  const { type: i, data: r } = JSON.parse(t);
  return i !== "image" ? null : r;
}
function L8(e) {
  const t = e.target;
  return !!(t && t instanceof HTMLElement && !t.closest("code, span.editor-image") && t.parentElement && t.parentElement.closest("div.ContentEditable__root"));
}
function Kne(e) {
  let t;
  const i = e.target, r = i == null ? null : i.nodeType === 9 ? i.defaultView : i.ownerDocument.defaultView, n = Dne(r);
  if (document.caretRangeFromPoint)
    t = document.caretRangeFromPoint(e.clientX, e.clientY);
  else if (e.rangeParent && n !== null)
    n.collapse(e.rangeParent, e.rangeOffset || 0), t = n.getRangeAt(0);
  else
    throw Error("Cannot get the selection when dragging");
  return t;
}
function Yne(e) {
  const t = e.getNodes();
  return t.length === 0 ? /* @__PURE__ */ new Set([e.anchor.getNode().getParentOrThrow(), e.focus.getNode().getParentOrThrow()]) : new Set(t.map((i) => L.$isElementNode(i) ? i : i.getParentOrThrow()));
}
function Une(e) {
  const t = L.$getSelection();
  if (!L.$isRangeSelection(t))
    return !1;
  const i = Yne(t);
  let r = 0;
  for (const n of i)
    if (zi.$isListNode(n))
      r = Math.max(zi.$getListDepth(n) + 1, r);
    else if (zi.$isListItemNode(n)) {
      const o = n.getParent();
      if (!zi.$isListNode(o))
        throw new Error("ListMaxIndentLevelPlugin: A ListItemNode must have a ListNode for a parent.");
      r = Math.max(zi.$getListDepth(o) + 1, r);
    }
  return r <= e;
}
function K8({ maxDepth: e }) {
  const [t] = nt.useLexicalComposerContext();
  return be(() => t.registerCommand(
    L.INDENT_CONTENT_COMMAND,
    () => !Une(e != null ? e : 7),
    L.COMMAND_PRIORITY_CRITICAL
  ), [t, e]), null;
}
var Nx = {}, Yi = {}, Jt = L, Im = nn, Dr = zi, vl = Jr, Gne = it, CE = Ii;
function tC(e, t) {
  let i = {};
  for (let r of e)
    e = t(r), i[e] ? i[e].push(r) : i[e] = [r];
  return i;
}
function Tx(e) {
  return e = tC(e, (t) => t.type), { element: e.element || [], textFormat: e["text-format"] || [], textMatch: e["text-match"] || [] };
}
let w1 = /[!-/:-@[-`{-~\s]/;
function Qne(e) {
  let t = Tx(e), i = t.textFormat.filter((r) => r.format.length === 1);
  return (r) => {
    let n = [];
    r = (r || Jt.$getRoot()).getChildren();
    for (let o of r)
      r = Wne(o, t.element, i, t.textMatch), r != null && n.push(r);
    return n.join(`

`);
  };
}
function Wne(e, t, i, r) {
  for (let n of t)
    if (t = n.export(e, (o) => M1(o, i, r)), t != null)
      return t;
  return Jt.$isElementNode(e) ? M1(e, i, r) : Jt.$isDecoratorNode(e) ? e.getTextContent() : null;
}
function M1(e, t, i) {
  let r = [];
  e = e.getChildren();
  e:
    for (let n of e) {
      for (let o of i)
        if (e = o.export(n, (s) => M1(s, t, i), (s, a) => xw(s, a, t)), e != null) {
          r.push(e);
          continue e;
        }
      Jt.$isLineBreakNode(n) ? r.push(`
`) : Jt.$isTextNode(n) ? r.push(xw(n, n.getTextContent(), t)) : Jt.$isElementNode(n) ? r.push(M1(n, t, i)) : Jt.$isDecoratorNode(n) && r.push(n.getTextContent());
    }
  return r.join("");
}
function xw(e, t, i) {
  let r = t.trim(), n = r, o = /* @__PURE__ */ new Set();
  for (let a of i) {
    i = a.format[0];
    let l = a.tag;
    if (xE(e, i) && !o.has(i)) {
      o.add(i);
      var s = Iw(e, !0);
      xE(s, i) || (n = l + n), s = Iw(e, !1), xE(s, i) || (n += l);
    }
  }
  return t.replace(r, n);
}
function Iw(e, t) {
  let i = t ? e.getPreviousSibling() : e.getNextSibling();
  for (i || (e = e.getParentOrThrow(), e.isInline() && (i = t ? e.getPreviousSibling() : e.getNextSibling())); i; ) {
    if (Jt.$isElementNode(i)) {
      if (!i.isInline())
        break;
      if (e = t ? i.getLastDescendant() : i.getFirstDescendant(), Jt.$isTextNode(e))
        return e;
      i = t ? i.getPreviousSibling() : i.getNextSibling();
    }
    if (Jt.$isTextNode(i))
      return i;
    if (!Jt.$isElementNode(i))
      break;
  }
  return null;
}
function xE(e, t) {
  return Jt.$isTextNode(e) && e.hasFormat(t);
}
let X0 = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined", Zne = X0 && "documentMode" in document ? document.documentMode : null;
X0 && "InputEvent" in window && !Zne && "getTargetRanges" in new window.InputEvent("input");
let Sw = X0 && /Version\/[\d.]+.*Safari/.test(navigator.userAgent), Rw = X0 && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, Jne = X0 && /^(?=.*Chrome).*/i.test(navigator.userAgent), kw = X0 && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && !Jne, Pne = /^\s{0,3}$/, ww = /^```(\w{1,10})?\s?$/;
function zne(e) {
  let t = Tx(e), i = Xne(t.textFormat);
  return (r, n) => {
    r = r.split(`
`);
    var o = r.length;
    n = n || Jt.$getRoot(), n.clear();
    for (let A = 0; A < o; A++) {
      var s = r[A];
      e: {
        var a = r, l = A, c = n, u = a[l].match(ww);
        if (u) {
          for (var m = l, g = a.length; ++m < g; )
            if (a[m].match(ww)) {
              u = Im.$createCodeNode(u[1]), a = Jt.$createTextNode(a.slice(l + 1, m).join(`
`)), u.append(a), c.append(u), c = [u, m];
              break e;
            }
        }
        c = [null, l];
      }
      let [y, E] = c;
      if (y != null)
        A = E;
      else {
        c = s, g = n;
        var h = t.element;
        m = i, a = t.textMatch, l = c.trim(), u = Jt.$createTextNode(l), s = Jt.$createParagraphNode(), s.append(u), g.append(s);
        for (let { regExp: v, replace: C } of h)
          if (g = c.match(v)) {
            u.setTextContent(c.slice(g[0].length)), C(s, [u], g, !0);
            break;
          }
        Zp(u, m, a), s.isAttached() && 0 < l.length && (c = s.getPreviousSibling(), Jt.$isParagraphNode(c) || vl.$isQuoteNode(c) || Dr.$isListNode(c)) && (m = c, Dr.$isListNode(c) && (c = c.getLastDescendant(), m = c == null ? null : Gne.$findMatchingParent(c, Dr.$isListItemNode)), m != null && 0 < m.getTextContentSize() && (m.splice(m.getChildrenSize(), 0, [Jt.$createLineBreakNode(), ...s.getChildren()]), s.remove()));
      }
    }
    r = n.getChildren();
    for (let A of r)
      r = A, Jt.$isParagraphNode(r) ? (o = r.getFirstChild(), r = o == null || r.getChildrenSize() === 1 && Jt.$isTextNode(o) && Pne.test(o.getTextContent())) : r = !1, r && A.remove();
    Jt.$getSelection() !== null && n.selectEnd();
  };
}
function Zp(e, t, i) {
  var r = e.getTextContent();
  let n = Hne(r, t);
  if (n) {
    var o, s;
    if (n[0] === r)
      var a = e;
    else {
      r = n.index || 0;
      let l = r + n[0].length;
      r === 0 ? [a, o] = e.splitText(l) : [s, a, o] = e.splitText(r, l);
    }
    if (a.setTextContent(n[2]), e = t.transformersByTag[n[1]])
      for (let l of e.format)
        a.hasFormat(l) || a.toggleFormat(l);
    a.hasFormat("code") || Zp(a, t, i), s && Zp(s, t, i), o && Zp(o, t, i);
  } else
    Y8(e, i);
}
function Y8(e, t) {
  e:
    for (; e; ) {
      for (let i of t) {
        let r = e.getTextContent().match(i.importRegExp);
        if (!r)
          continue;
        let n = r.index || 0, o = n + r[0].length, s, a, l;
        n === 0 ? [s, e] = e.splitText(o) : [a, s, l] = e.splitText(n, o), a && Y8(a, t), l && (e = l), i.replace(s, r);
        continue e;
      }
      break;
    }
}
function Hne(e, t) {
  var i = e.match(t.openTagsRegExp);
  if (i == null)
    return null;
  for (let o of i) {
    var r = o.replace(/^\s/, "");
    if (i = t.fullMatchRegExpByTag[r], i != null && (i = e.match(i), r = t.transformersByTag[r], i != null && r != null)) {
      if (r.intraword !== !1)
        return i;
      var { index: n = 0 } = i;
      if (r = e[n - 1], n = e[n + i[0].length], !(r && !w1.test(r) || n && !w1.test(n)))
        return i;
    }
  }
  return null;
}
function Xne(e) {
  let t = {}, i = {}, r = [];
  for (let n of e) {
    ({ tag: e } = n), t[e] = n;
    let o = e.replace(/(\*|\^|\+)/g, "\\$1");
    r.push(o), i[e] = Sw || Rw || kw ? new RegExp(`(${o})(?![${o}\\s])(.*?[^${o}\\s])${o}(?!${o})`) : new RegExp(`(?<![\\\\${o}])(${o})((\\\\${o})?.*?[^${o}\\s](\\\\${o})?)((?<!\\\\)|(?<=\\\\\\\\))(${o})(?![\\\\${o}])`);
  }
  return { fullMatchRegExpByTag: i, openTagsRegExp: new RegExp((Sw || Rw || kw ? "" : "(?<![\\\\])") + "(" + r.join("|") + ")", "g"), transformersByTag: t };
}
function Mw(e, t, i) {
  let r = i.length;
  for (; t >= r; t--) {
    let n = t - r;
    if (U8(e, n, i, 0, r) && e[n + r] !== " ")
      return n;
  }
  return -1;
}
function U8(e, t, i, r, n) {
  for (let o = 0; o < n; o++)
    if (e[t + o] !== i[r + o])
      return !1;
  return !0;
}
let G8 = (e) => (t, i, r) => {
  r = e(r), r.append(...i), t.replace(r), r.select(0, 0);
}, Bx = (e) => (t, i, r) => {
  var n = t.getPreviousSibling(), o = t.getNextSibling();
  const s = Dr.$createListItemNode(e === "check" ? r[3] === "x" : void 0);
  Dr.$isListNode(o) && o.getListType() === e ? (n = o.getFirstChild(), n !== null ? n.insertBefore(s) : o.append(s), t.remove()) : Dr.$isListNode(n) && n.getListType() === e ? (n.append(s), t.remove()) : (o = Dr.$createListNode(e, e === "number" ? Number(r[2]) : void 0), o.append(s), t.replace(o)), s.append(...i), s.select(0, 0), (t = Math.floor(r[1].length / 4)) && s.setIndent(t);
}, Df = (e, t, i) => {
  const r = [];
  var n = e.getChildren();
  let o = 0;
  for (const a of n)
    if (Dr.$isListItemNode(a)) {
      if (a.getChildrenSize() === 1 && (n = a.getFirstChild(), Dr.$isListNode(n))) {
        r.push(Df(n, t, i + 1));
        continue;
      }
      n = " ".repeat(4 * i);
      var s = e.getListType();
      s = s === "number" ? `${e.getStart() + o}. ` : s === "check" ? `- [${a.getChecked() ? "x" : " "}] ` : "- ", r.push(n + s + t(a)), o++;
    }
  return r.join(`
`);
}, Q8 = { dependencies: [vl.HeadingNode], export: (e, t) => {
  if (!vl.$isHeadingNode(e))
    return null;
  const i = Number(e.getTag().slice(1));
  return "#".repeat(i) + " " + t(e);
}, regExp: /^(#{1,6})\s/, replace: G8((e) => vl.$createHeadingNode("h" + e[1].length)), type: "element" }, W8 = { dependencies: [vl.QuoteNode], export: (e, t) => {
  if (!vl.$isQuoteNode(e))
    return null;
  e = t(e).split(`
`), t = [];
  for (const i of e)
    t.push("> " + i);
  return t.join(`
`);
}, regExp: /^>\s/, replace: (e, t, i, r) => {
  if (r && (i = e.getPreviousSibling(), vl.$isQuoteNode(i))) {
    i.splice(i.getChildrenSize(), 0, [Jt.$createLineBreakNode(), ...t]), i.select(0, 0), e.remove();
    return;
  }
  i = vl.$createQuoteNode(), i.append(...t), e.replace(i), i.select(0, 0);
}, type: "element" }, Z8 = { dependencies: [Im.CodeNode], export: (e) => {
  if (!Im.$isCodeNode(e))
    return null;
  const t = e.getTextContent();
  return "```" + (e.getLanguage() || "") + (t ? `
` + t : "") + "\n```";
}, regExp: /^```(\w{1,10})?\s/, replace: G8((e) => Im.$createCodeNode(e ? e[1] : void 0)), type: "element" }, J8 = { dependencies: [Dr.ListNode, Dr.ListItemNode], export: (e, t) => Dr.$isListNode(e) ? Df(e, t, 0) : null, regExp: /^(\s*)[-*+]\s/, replace: Bx("bullet"), type: "element" }, _ne = { dependencies: [Dr.ListNode, Dr.ListItemNode], export: (e, t) => Dr.$isListNode(e) ? Df(e, t, 0) : null, regExp: /^(\s*)(?:-\s)?\s?(\[(\s|x)?\])\s/i, replace: Bx("check"), type: "element" }, P8 = { dependencies: [Dr.ListNode, Dr.ListItemNode], export: (e, t) => Dr.$isListNode(e) ? Df(e, t, 0) : null, regExp: /^(\s*)(\d{1,})\.\s/, replace: Bx("number"), type: "element" }, z8 = { format: ["code"], tag: "`", type: "text-format" }, H8 = { format: ["highlight"], tag: "==", type: "text-format" }, X8 = { format: ["bold", "italic"], tag: "***", type: "text-format" }, _8 = { format: ["bold", "italic"], intraword: !1, tag: "___", type: "text-format" }, $8 = {
  format: ["bold"],
  tag: "**",
  type: "text-format"
}, eO = { format: ["bold"], intraword: !1, tag: "__", type: "text-format" }, tO = { format: ["strikethrough"], tag: "~~", type: "text-format" }, iO = { format: ["italic"], tag: "*", type: "text-format" }, rO = { format: ["italic"], intraword: !1, tag: "_", type: "text-format" }, nO = { dependencies: [CE.LinkNode], export: (e, t, i) => {
  if (!CE.$isLinkNode(e))
    return null;
  t = (t = e.getTitle()) ? `[${e.getTextContent()}](${e.getURL()} "${t}")` : `[${e.getTextContent()}](${e.getURL()})`;
  const r = e.getFirstChild();
  return e.getChildrenSize() === 1 && Jt.$isTextNode(r) ? i(r, t) : t;
}, importRegExp: /(?:\[([^[]+)\])(?:\((?:([^()\s]+)(?:\s"((?:[^"]*\\")*[^"]*)"\s*)?)\))/, regExp: /(?:\[([^[]+)\])(?:\((?:([^()\s]+)(?:\s"((?:[^"]*\\")*[^"]*)"\s*)?)\))$/, replace: (e, t) => {
  const [, i, r, n] = t;
  t = CE.$createLinkNode(r, { title: n });
  const o = Jt.$createTextNode(i);
  o.setFormat(e.getFormat()), t.append(o), e.replace(t);
}, trigger: ")", type: "text-match" }, oO = [Q8, W8, Z8, J8, P8], sO = [z8, X8, _8, $8, eO, H8, iO, rO, tO], aO = [nO], Of = [...oO, ...sO, ...aO];
Yi.$convertFromMarkdownString = function(e, t = Of, i) {
  return zne(t)(e, i);
};
Yi.$convertToMarkdownString = function(e = Of, t) {
  return Qne(e)(t);
};
Yi.BOLD_ITALIC_STAR = X8;
Yi.BOLD_ITALIC_UNDERSCORE = _8;
Yi.BOLD_STAR = $8;
Yi.BOLD_UNDERSCORE = eO;
Yi.CHECK_LIST = _ne;
Yi.CODE = Z8;
Yi.ELEMENT_TRANSFORMERS = oO;
Yi.HEADING = Q8;
Yi.HIGHLIGHT = H8;
Yi.INLINE_CODE = z8;
Yi.ITALIC_STAR = iO;
Yi.ITALIC_UNDERSCORE = rO;
Yi.LINK = nO;
Yi.ORDERED_LIST = P8;
Yi.QUOTE = W8;
Yi.STRIKETHROUGH = tO;
Yi.TEXT_FORMAT_TRANSFORMERS = sO;
Yi.TEXT_MATCH_TRANSFORMERS = aO;
Yi.TRANSFORMERS = Of;
Yi.UNORDERED_LIST = J8;
Yi.registerMarkdownShortcuts = function(e, t = Of) {
  let i = Tx(t), r = tC(i.textFormat, ({ tag: o }) => o[o.length - 1]), n = tC(i.textMatch, ({ trigger: o }) => o);
  for (let o of t)
    if (t = o.type, t === "element" || t === "text-match") {
      t = o.dependencies;
      for (let s of t)
        if (!e.hasNode(s))
          throw Error(`MarkdownShortcuts: missing dependency ${s.getType()} for transformer. Ensure node dependency is included in editor initial config.`);
    }
  return e.registerUpdateListener(({ tags: o, dirtyLeaves: s, editorState: a, prevEditorState: l }) => {
    if (!o.has("historic") && !e.isComposing()) {
      var c = a.read(Jt.$getSelection);
      if (o = l.read(Jt.$getSelection), Jt.$isRangeSelection(o) && Jt.$isRangeSelection(c) && c.isCollapsed()) {
        l = c.anchor.key;
        var u = c.anchor.offset, m = a._nodeMap.get(l);
        !Jt.$isTextNode(m) || !s.has(l) || u !== 1 && u > o.anchor.offset + 1 || e.update(() => {
          if (!m.hasFormat("code")) {
            var g = m.getParent();
            if (g !== null && !Im.$isCodeNode(g)) {
              var h = c.anchor.offset;
              e: {
                var A = i.element, y = g.getParent();
                if (Jt.$isRootOrShadowRoot(y) && g.getFirstChild() === m && (y = m.getTextContent(), y[h - 1] === " ")) {
                  for (let {
                    regExp: R,
                    replace: w
                  } of A)
                    if ((A = y.match(R)) && A[0].length === h) {
                      y = m.getNextSiblings();
                      let [T, N] = m.splitText(h);
                      T.remove(), y = N ? [N, ...y] : y, w(g, y, A, !1), g = !0;
                      break e;
                    }
                }
                g = !1;
              }
              if (!g) {
                e: {
                  if (A = m.getTextContent(), g = n[A[h - 1]], g != null) {
                    h < A.length && (A = A.slice(0, h));
                    for (v of g)
                      if (g = A.match(v.regExp), g !== null) {
                        A = g.index || 0, y = A + g[0].length;
                        var E = void 0;
                        A === 0 ? [E] = m.splitText(y) : [, E] = m.splitText(A, y), E.selectNext(0, 0), v.replace(E, g);
                        var v = !0;
                        break e;
                      }
                  }
                  v = !1;
                }
                if (!v)
                  e: {
                    y = m.getTextContent(), --h;
                    var C = y[h];
                    if (v = r[C])
                      for (let R of v) {
                        var { tag: x } = R;
                        v = x.length;
                        let w = h - v + 1;
                        if (!(1 < v && !U8(y, w, x, 0, v) || y[w - 1] === " ") && (E = y[h + 1], R.intraword !== !1 || !E || w1.test(E))) {
                          g = E = m, A = Mw(y, w, x);
                          for (var S = g; 0 > A && (S = S.getPreviousSibling()) && !Jt.$isLineBreakNode(S); )
                            Jt.$isTextNode(S) && (A = S.getTextContent(), g = S, A = Mw(A, A.length, x));
                          if (!(0 > A || g === E && A + v === w || (x = g.getTextContent(), 0 < A && x[A - 1] === C || (S = x[A - 1], R.intraword === !1 && S && !w1.test(S))))) {
                            y = E.getTextContent(), y = y.slice(0, w) + y.slice(h + 1), E.setTextContent(y), y = g === E ? y : x, g.setTextContent(y.slice(0, A) + y.slice(A + v)), y = Jt.$getSelection(), C = Jt.$createRangeSelection(), Jt.$setSelection(C), h = h - v * (g === E ? 2 : 1) + 1, C.anchor.set(g.__key, A, "text"), C.focus.set(E.__key, h, "text");
                            for (let T of R.format)
                              C.hasFormat(T) || C.formatText(T);
                            C.anchor.set(C.focus.key, C.focus.offset, C.focus.type);
                            for (let T of R.format)
                              C.hasFormat(T) && C.toggleFormat(T);
                            Jt.$isRangeSelection(y) && (C.format = y.format);
                            break e;
                          }
                        }
                      }
                  }
              }
            }
          }
        });
      }
    }
  });
};
const $ne = Yi;
var Ic = $ne, lO = Ic, eoe = nt, IE = Il, toe = X;
let cO = [{ dependencies: [IE.HorizontalRuleNode], export: (e) => IE.$isHorizontalRuleNode(e) ? "***" : null, regExp: /^(---|\*\*\*|___)\s?$/, replace: (e, t, i, r) => {
  t = IE.$createHorizontalRuleNode(), r || e.getNextSibling() != null ? e.replace(t) : e.insertBefore(t), t.selectNext();
}, type: "element" }, ...lO.TRANSFORMERS];
Nx.DEFAULT_TRANSFORMERS = cO;
Nx.MarkdownShortcutPlugin = function({ transformers: e = cO }) {
  let [t] = eoe.useLexicalComposerContext();
  return toe.useEffect(() => lO.registerMarkdownShortcuts(t, e), [t, e]), null;
};
const ioe = Nx;
var roe = ioe;
const noe = [
  {
    description: "grinning face",
    emoji: "😀",
    category: "Smileys & Emotion",
    aliases: ["grinning"],
    tags: ["smile", "happy"],
    unicode_version: "6.1",
    ios_version: "6.0"
  },
  {
    emoji: "😃",
    description: "grinning face with big eyes",
    category: "Smileys & Emotion",
    aliases: ["smiley"],
    tags: ["happy", "joy", "haha"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😄",
    description: "grinning face with smiling eyes",
    category: "Smileys & Emotion",
    aliases: ["smile"],
    tags: ["happy", "joy", "laugh", "pleased"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😁",
    description: "beaming face with smiling eyes",
    category: "Smileys & Emotion",
    aliases: ["grin"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😆",
    description: "grinning squinting face",
    category: "Smileys & Emotion",
    aliases: ["laughing", "satisfied"],
    tags: ["happy", "haha"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😅",
    description: "grinning face with sweat",
    category: "Smileys & Emotion",
    aliases: ["sweat_smile"],
    tags: ["hot"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🤣",
    description: "rolling on the floor laughing",
    category: "Smileys & Emotion",
    aliases: ["rofl"],
    tags: ["lol", "laughing"],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "😂",
    description: "face with tears of joy",
    category: "Smileys & Emotion",
    aliases: ["joy"],
    tags: ["tears"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🙂",
    description: "slightly smiling face",
    category: "Smileys & Emotion",
    aliases: ["slightly_smiling_face"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🙃",
    description: "upside-down face",
    category: "Smileys & Emotion",
    aliases: ["upside_down_face"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "😉",
    description: "winking face",
    category: "Smileys & Emotion",
    aliases: ["wink"],
    tags: ["flirt"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😊",
    description: "smiling face with smiling eyes",
    category: "Smileys & Emotion",
    aliases: ["blush"],
    tags: ["proud"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😇",
    description: "smiling face with halo",
    category: "Smileys & Emotion",
    aliases: ["innocent"],
    tags: ["angel"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥰",
    description: "smiling face with hearts",
    category: "Smileys & Emotion",
    aliases: ["smiling_face_with_three_hearts"],
    tags: ["love"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "😍",
    description: "smiling face with heart-eyes",
    category: "Smileys & Emotion",
    aliases: ["heart_eyes"],
    tags: ["love", "crush"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🤩",
    description: "star-struck",
    category: "Smileys & Emotion",
    aliases: ["star_struck"],
    tags: ["eyes"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "😘",
    description: "face blowing a kiss",
    category: "Smileys & Emotion",
    aliases: ["kissing_heart"],
    tags: ["flirt"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😗",
    description: "kissing face",
    category: "Smileys & Emotion",
    aliases: ["kissing"],
    tags: [],
    unicode_version: "6.1",
    ios_version: "6.0"
  },
  {
    emoji: "☺️",
    description: "smiling face",
    category: "Smileys & Emotion",
    aliases: ["relaxed"],
    tags: ["blush", "pleased"],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "😚",
    description: "kissing face with closed eyes",
    category: "Smileys & Emotion",
    aliases: ["kissing_closed_eyes"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😙",
    description: "kissing face with smiling eyes",
    category: "Smileys & Emotion",
    aliases: ["kissing_smiling_eyes"],
    tags: [],
    unicode_version: "6.1",
    ios_version: "6.0"
  },
  {
    emoji: "🥲",
    description: "smiling face with tear",
    category: "Smileys & Emotion",
    aliases: ["smiling_face_with_tear"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "😋",
    description: "face savoring food",
    category: "Smileys & Emotion",
    aliases: ["yum"],
    tags: ["tongue", "lick"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😛",
    description: "face with tongue",
    category: "Smileys & Emotion",
    aliases: ["stuck_out_tongue"],
    tags: [],
    unicode_version: "6.1",
    ios_version: "6.0"
  },
  {
    emoji: "😜",
    description: "winking face with tongue",
    category: "Smileys & Emotion",
    aliases: ["stuck_out_tongue_winking_eye"],
    tags: ["prank", "silly"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🤪",
    description: "zany face",
    category: "Smileys & Emotion",
    aliases: ["zany_face"],
    tags: ["goofy", "wacky"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "😝",
    description: "squinting face with tongue",
    category: "Smileys & Emotion",
    aliases: ["stuck_out_tongue_closed_eyes"],
    tags: ["prank"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🤑",
    description: "money-mouth face",
    category: "Smileys & Emotion",
    aliases: ["money_mouth_face"],
    tags: ["rich"],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🤗",
    description: "hugging face",
    category: "Smileys & Emotion",
    aliases: ["hugs"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🤭",
    description: "face with hand over mouth",
    category: "Smileys & Emotion",
    aliases: ["hand_over_mouth"],
    tags: ["quiet", "whoops"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🤫",
    description: "shushing face",
    category: "Smileys & Emotion",
    aliases: ["shushing_face"],
    tags: ["silence", "quiet"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🤔",
    description: "thinking face",
    category: "Smileys & Emotion",
    aliases: ["thinking"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🤐",
    description: "zipper-mouth face",
    category: "Smileys & Emotion",
    aliases: ["zipper_mouth_face"],
    tags: ["silence", "hush"],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🤨",
    description: "face with raised eyebrow",
    category: "Smileys & Emotion",
    aliases: ["raised_eyebrow"],
    tags: ["suspicious"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "😐",
    description: "neutral face",
    category: "Smileys & Emotion",
    aliases: ["neutral_face"],
    tags: ["meh"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😑",
    description: "expressionless face",
    category: "Smileys & Emotion",
    aliases: ["expressionless"],
    tags: [],
    unicode_version: "6.1",
    ios_version: "6.0"
  },
  {
    emoji: "😶",
    description: "face without mouth",
    category: "Smileys & Emotion",
    aliases: ["no_mouth"],
    tags: ["mute", "silence"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😶‍🌫️",
    description: "face in clouds",
    category: "Smileys & Emotion",
    aliases: ["face_in_clouds"],
    tags: [],
    unicode_version: "13.1",
    ios_version: "14.0"
  },
  {
    emoji: "😏",
    description: "smirking face",
    category: "Smileys & Emotion",
    aliases: ["smirk"],
    tags: ["smug"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😒",
    description: "unamused face",
    category: "Smileys & Emotion",
    aliases: ["unamused"],
    tags: ["meh"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🙄",
    description: "face with rolling eyes",
    category: "Smileys & Emotion",
    aliases: ["roll_eyes"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "😬",
    description: "grimacing face",
    category: "Smileys & Emotion",
    aliases: ["grimacing"],
    tags: [],
    unicode_version: "6.1",
    ios_version: "6.0"
  },
  {
    emoji: "😮‍💨",
    description: "face exhaling",
    category: "Smileys & Emotion",
    aliases: ["face_exhaling"],
    tags: [],
    unicode_version: "13.1",
    ios_version: "14.0"
  },
  {
    emoji: "🤥",
    description: "lying face",
    category: "Smileys & Emotion",
    aliases: ["lying_face"],
    tags: ["liar"],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "😌",
    description: "relieved face",
    category: "Smileys & Emotion",
    aliases: ["relieved"],
    tags: ["whew"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😔",
    description: "pensive face",
    category: "Smileys & Emotion",
    aliases: ["pensive"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😪",
    description: "sleepy face",
    category: "Smileys & Emotion",
    aliases: ["sleepy"],
    tags: ["tired"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🤤",
    description: "drooling face",
    category: "Smileys & Emotion",
    aliases: ["drooling_face"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "😴",
    description: "sleeping face",
    category: "Smileys & Emotion",
    aliases: ["sleeping"],
    tags: ["zzz"],
    unicode_version: "6.1",
    ios_version: "6.0"
  },
  {
    emoji: "😷",
    description: "face with medical mask",
    category: "Smileys & Emotion",
    aliases: ["mask"],
    tags: ["sick", "ill"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🤒",
    description: "face with thermometer",
    category: "Smileys & Emotion",
    aliases: ["face_with_thermometer"],
    tags: ["sick"],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🤕",
    description: "face with head-bandage",
    category: "Smileys & Emotion",
    aliases: ["face_with_head_bandage"],
    tags: ["hurt"],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🤢",
    description: "nauseated face",
    category: "Smileys & Emotion",
    aliases: ["nauseated_face"],
    tags: ["sick", "barf", "disgusted"],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🤮",
    description: "face vomiting",
    category: "Smileys & Emotion",
    aliases: ["vomiting_face"],
    tags: ["barf", "sick"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🤧",
    description: "sneezing face",
    category: "Smileys & Emotion",
    aliases: ["sneezing_face"],
    tags: ["achoo", "sick"],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🥵",
    description: "hot face",
    category: "Smileys & Emotion",
    aliases: ["hot_face"],
    tags: ["heat", "sweating"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🥶",
    description: "cold face",
    category: "Smileys & Emotion",
    aliases: ["cold_face"],
    tags: ["freezing", "ice"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🥴",
    description: "woozy face",
    category: "Smileys & Emotion",
    aliases: ["woozy_face"],
    tags: ["groggy"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "😵",
    description: "knocked-out face",
    category: "Smileys & Emotion",
    aliases: ["dizzy_face"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😵‍💫",
    description: "face with spiral eyes",
    category: "Smileys & Emotion",
    aliases: ["face_with_spiral_eyes"],
    tags: [],
    unicode_version: "13.1",
    ios_version: "14.0"
  },
  {
    emoji: "🤯",
    description: "exploding head",
    category: "Smileys & Emotion",
    aliases: ["exploding_head"],
    tags: ["mind", "blown"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🤠",
    description: "cowboy hat face",
    category: "Smileys & Emotion",
    aliases: ["cowboy_hat_face"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🥳",
    description: "partying face",
    category: "Smileys & Emotion",
    aliases: ["partying_face"],
    tags: ["celebration", "birthday"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🥸",
    description: "disguised face",
    category: "Smileys & Emotion",
    aliases: ["disguised_face"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "😎",
    description: "smiling face with sunglasses",
    category: "Smileys & Emotion",
    aliases: ["sunglasses"],
    tags: ["cool"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🤓",
    description: "nerd face",
    category: "Smileys & Emotion",
    aliases: ["nerd_face"],
    tags: ["geek", "glasses"],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🧐",
    description: "face with monocle",
    category: "Smileys & Emotion",
    aliases: ["monocle_face"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "😕",
    description: "confused face",
    category: "Smileys & Emotion",
    aliases: ["confused"],
    tags: [],
    unicode_version: "6.1",
    ios_version: "6.0"
  },
  {
    emoji: "😟",
    description: "worried face",
    category: "Smileys & Emotion",
    aliases: ["worried"],
    tags: ["nervous"],
    unicode_version: "6.1",
    ios_version: "6.0"
  },
  {
    emoji: "🙁",
    description: "slightly frowning face",
    category: "Smileys & Emotion",
    aliases: ["slightly_frowning_face"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "☹️",
    description: "frowning face",
    category: "Smileys & Emotion",
    aliases: ["frowning_face"],
    tags: [],
    unicode_version: "",
    ios_version: "9.1"
  },
  {
    emoji: "😮",
    description: "face with open mouth",
    category: "Smileys & Emotion",
    aliases: ["open_mouth"],
    tags: ["surprise", "impressed", "wow"],
    unicode_version: "6.1",
    ios_version: "6.0"
  },
  {
    emoji: "😯",
    description: "hushed face",
    category: "Smileys & Emotion",
    aliases: ["hushed"],
    tags: ["silence", "speechless"],
    unicode_version: "6.1",
    ios_version: "6.0"
  },
  {
    emoji: "😲",
    description: "astonished face",
    category: "Smileys & Emotion",
    aliases: ["astonished"],
    tags: ["amazed", "gasp"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😳",
    description: "flushed face",
    category: "Smileys & Emotion",
    aliases: ["flushed"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥺",
    description: "pleading face",
    category: "Smileys & Emotion",
    aliases: ["pleading_face"],
    tags: ["puppy", "eyes"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "😦",
    description: "frowning face with open mouth",
    category: "Smileys & Emotion",
    aliases: ["frowning"],
    tags: [],
    unicode_version: "6.1",
    ios_version: "6.0"
  },
  {
    emoji: "😧",
    description: "anguished face",
    category: "Smileys & Emotion",
    aliases: ["anguished"],
    tags: ["stunned"],
    unicode_version: "6.1",
    ios_version: "6.0"
  },
  {
    emoji: "😨",
    description: "fearful face",
    category: "Smileys & Emotion",
    aliases: ["fearful"],
    tags: ["scared", "shocked", "oops"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😰",
    description: "anxious face with sweat",
    category: "Smileys & Emotion",
    aliases: ["cold_sweat"],
    tags: ["nervous"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😥",
    description: "sad but relieved face",
    category: "Smileys & Emotion",
    aliases: ["disappointed_relieved"],
    tags: ["phew", "sweat", "nervous"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😢",
    description: "crying face",
    category: "Smileys & Emotion",
    aliases: ["cry"],
    tags: ["sad", "tear"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😭",
    description: "loudly crying face",
    category: "Smileys & Emotion",
    aliases: ["sob"],
    tags: ["sad", "cry", "bawling"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😱",
    description: "face screaming in fear",
    category: "Smileys & Emotion",
    aliases: ["scream"],
    tags: ["horror", "shocked"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😖",
    description: "confounded face",
    category: "Smileys & Emotion",
    aliases: ["confounded"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😣",
    description: "persevering face",
    category: "Smileys & Emotion",
    aliases: ["persevere"],
    tags: ["struggling"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😞",
    description: "disappointed face",
    category: "Smileys & Emotion",
    aliases: ["disappointed"],
    tags: ["sad"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😓",
    description: "downcast face with sweat",
    category: "Smileys & Emotion",
    aliases: ["sweat"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😩",
    description: "weary face",
    category: "Smileys & Emotion",
    aliases: ["weary"],
    tags: ["tired"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😫",
    description: "tired face",
    category: "Smileys & Emotion",
    aliases: ["tired_face"],
    tags: ["upset", "whine"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥱",
    description: "yawning face",
    category: "Smileys & Emotion",
    aliases: ["yawning_face"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "😤",
    description: "face with steam from nose",
    category: "Smileys & Emotion",
    aliases: ["triumph"],
    tags: ["smug"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😡",
    description: "pouting face",
    category: "Smileys & Emotion",
    aliases: ["rage", "pout"],
    tags: ["angry"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😠",
    description: "angry face",
    category: "Smileys & Emotion",
    aliases: ["angry"],
    tags: ["mad", "annoyed"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🤬",
    description: "face with symbols on mouth",
    category: "Smileys & Emotion",
    aliases: ["cursing_face"],
    tags: ["foul"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "😈",
    description: "smiling face with horns",
    category: "Smileys & Emotion",
    aliases: ["smiling_imp"],
    tags: ["devil", "evil", "horns"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👿",
    description: "angry face with horns",
    category: "Smileys & Emotion",
    aliases: ["imp"],
    tags: ["angry", "devil", "evil", "horns"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💀",
    description: "skull",
    category: "Smileys & Emotion",
    aliases: ["skull"],
    tags: ["dead", "danger", "poison"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "☠️",
    description: "skull and crossbones",
    category: "Smileys & Emotion",
    aliases: ["skull_and_crossbones"],
    tags: ["danger", "pirate"],
    unicode_version: "",
    ios_version: "9.1"
  },
  {
    emoji: "💩",
    description: "pile of poo",
    category: "Smileys & Emotion",
    aliases: ["hankey", "poop", "shit"],
    tags: ["crap"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🤡",
    description: "clown face",
    category: "Smileys & Emotion",
    aliases: ["clown_face"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "👹",
    description: "ogre",
    category: "Smileys & Emotion",
    aliases: ["japanese_ogre"],
    tags: ["monster"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👺",
    description: "goblin",
    category: "Smileys & Emotion",
    aliases: ["japanese_goblin"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👻",
    description: "ghost",
    category: "Smileys & Emotion",
    aliases: ["ghost"],
    tags: ["halloween"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👽",
    description: "alien",
    category: "Smileys & Emotion",
    aliases: ["alien"],
    tags: ["ufo"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👾",
    description: "alien monster",
    category: "Smileys & Emotion",
    aliases: ["space_invader"],
    tags: ["game", "retro"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🤖",
    description: "robot",
    category: "Smileys & Emotion",
    aliases: ["robot"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "😺",
    description: "grinning cat",
    category: "Smileys & Emotion",
    aliases: ["smiley_cat"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😸",
    description: "grinning cat with smiling eyes",
    category: "Smileys & Emotion",
    aliases: ["smile_cat"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😹",
    description: "cat with tears of joy",
    category: "Smileys & Emotion",
    aliases: ["joy_cat"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😻",
    description: "smiling cat with heart-eyes",
    category: "Smileys & Emotion",
    aliases: ["heart_eyes_cat"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😼",
    description: "cat with wry smile",
    category: "Smileys & Emotion",
    aliases: ["smirk_cat"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😽",
    description: "kissing cat",
    category: "Smileys & Emotion",
    aliases: ["kissing_cat"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🙀",
    description: "weary cat",
    category: "Smileys & Emotion",
    aliases: ["scream_cat"],
    tags: ["horror"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😿",
    description: "crying cat",
    category: "Smileys & Emotion",
    aliases: ["crying_cat_face"],
    tags: ["sad", "tear"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "😾",
    description: "pouting cat",
    category: "Smileys & Emotion",
    aliases: ["pouting_cat"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🙈",
    description: "see-no-evil monkey",
    category: "Smileys & Emotion",
    aliases: ["see_no_evil"],
    tags: ["monkey", "blind", "ignore"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🙉",
    description: "hear-no-evil monkey",
    category: "Smileys & Emotion",
    aliases: ["hear_no_evil"],
    tags: ["monkey", "deaf"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🙊",
    description: "speak-no-evil monkey",
    category: "Smileys & Emotion",
    aliases: ["speak_no_evil"],
    tags: ["monkey", "mute", "hush"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💋",
    description: "kiss mark",
    category: "Smileys & Emotion",
    aliases: ["kiss"],
    tags: ["lipstick"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💌",
    description: "love letter",
    category: "Smileys & Emotion",
    aliases: ["love_letter"],
    tags: ["email", "envelope"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💘",
    description: "heart with arrow",
    category: "Smileys & Emotion",
    aliases: ["cupid"],
    tags: ["love", "heart"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💝",
    description: "heart with ribbon",
    category: "Smileys & Emotion",
    aliases: ["gift_heart"],
    tags: ["chocolates"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💖",
    description: "sparkling heart",
    category: "Smileys & Emotion",
    aliases: ["sparkling_heart"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💗",
    description: "growing heart",
    category: "Smileys & Emotion",
    aliases: ["heartpulse"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💓",
    description: "beating heart",
    category: "Smileys & Emotion",
    aliases: ["heartbeat"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💞",
    description: "revolving hearts",
    category: "Smileys & Emotion",
    aliases: ["revolving_hearts"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💕",
    description: "two hearts",
    category: "Smileys & Emotion",
    aliases: ["two_hearts"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💟",
    description: "heart decoration",
    category: "Smileys & Emotion",
    aliases: ["heart_decoration"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "❣️",
    description: "heart exclamation",
    category: "Smileys & Emotion",
    aliases: ["heavy_heart_exclamation"],
    tags: [],
    unicode_version: "",
    ios_version: "9.1"
  },
  {
    emoji: "💔",
    description: "broken heart",
    category: "Smileys & Emotion",
    aliases: ["broken_heart"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "❤️‍🔥",
    description: "heart on fire",
    category: "Smileys & Emotion",
    aliases: ["heart_on_fire"],
    tags: [],
    unicode_version: "13.1",
    ios_version: "14.0"
  },
  {
    emoji: "❤️‍🩹",
    description: "mending heart",
    category: "Smileys & Emotion",
    aliases: ["mending_heart"],
    tags: [],
    unicode_version: "13.1",
    ios_version: "14.0"
  },
  {
    emoji: "❤️",
    description: "red heart",
    category: "Smileys & Emotion",
    aliases: ["heart"],
    tags: ["love"],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "🧡",
    description: "orange heart",
    category: "Smileys & Emotion",
    aliases: ["orange_heart"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "💛",
    description: "yellow heart",
    category: "Smileys & Emotion",
    aliases: ["yellow_heart"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💚",
    description: "green heart",
    category: "Smileys & Emotion",
    aliases: ["green_heart"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💙",
    description: "blue heart",
    category: "Smileys & Emotion",
    aliases: ["blue_heart"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💜",
    description: "purple heart",
    category: "Smileys & Emotion",
    aliases: ["purple_heart"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🤎",
    description: "brown heart",
    category: "Smileys & Emotion",
    aliases: ["brown_heart"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🖤",
    description: "black heart",
    category: "Smileys & Emotion",
    aliases: ["black_heart"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🤍",
    description: "white heart",
    category: "Smileys & Emotion",
    aliases: ["white_heart"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "💯",
    description: "hundred points",
    category: "Smileys & Emotion",
    aliases: ["100"],
    tags: ["score", "perfect"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💢",
    description: "anger symbol",
    category: "Smileys & Emotion",
    aliases: ["anger"],
    tags: ["angry"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💥",
    description: "collision",
    category: "Smileys & Emotion",
    aliases: ["boom", "collision"],
    tags: ["explode"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💫",
    description: "dizzy",
    category: "Smileys & Emotion",
    aliases: ["dizzy"],
    tags: ["star"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💦",
    description: "sweat droplets",
    category: "Smileys & Emotion",
    aliases: ["sweat_drops"],
    tags: ["water", "workout"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💨",
    description: "dashing away",
    category: "Smileys & Emotion",
    aliases: ["dash"],
    tags: ["wind", "blow", "fast"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕳️",
    description: "hole",
    category: "Smileys & Emotion",
    aliases: ["hole"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "💣",
    description: "bomb",
    category: "Smileys & Emotion",
    aliases: ["bomb"],
    tags: ["boom"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💬",
    description: "speech balloon",
    category: "Smileys & Emotion",
    aliases: ["speech_balloon"],
    tags: ["comment"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👁️‍🗨️",
    description: "eye in speech bubble",
    category: "Smileys & Emotion",
    aliases: ["eye_speech_bubble"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🗨️",
    description: "left speech bubble",
    category: "Smileys & Emotion",
    aliases: ["left_speech_bubble"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🗯️",
    description: "right anger bubble",
    category: "Smileys & Emotion",
    aliases: ["right_anger_bubble"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "💭",
    description: "thought balloon",
    category: "Smileys & Emotion",
    aliases: ["thought_balloon"],
    tags: ["thinking"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💤",
    description: "zzz",
    category: "Smileys & Emotion",
    aliases: ["zzz"],
    tags: ["sleeping"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👋",
    description: "waving hand",
    category: "People & Body",
    aliases: ["wave"],
    tags: ["goodbye"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🤚",
    description: "raised back of hand",
    category: "People & Body",
    aliases: ["raised_back_of_hand"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🖐️",
    description: "hand with fingers splayed",
    category: "People & Body",
    aliases: ["raised_hand_with_fingers_splayed"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1",
    skin_tones: !0
  },
  {
    emoji: "✋",
    description: "raised hand",
    category: "People & Body",
    aliases: ["hand", "raised_hand"],
    tags: ["highfive", "stop"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🖖",
    description: "vulcan salute",
    category: "People & Body",
    aliases: ["vulcan_salute"],
    tags: ["prosper", "spock"],
    unicode_version: "7.0",
    ios_version: "8.3",
    skin_tones: !0
  },
  {
    emoji: "👌",
    description: "OK hand",
    category: "People & Body",
    aliases: ["ok_hand"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🤌",
    description: "pinched fingers",
    category: "People & Body",
    aliases: ["pinched_fingers"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0",
    skin_tones: !0
  },
  {
    emoji: "🤏",
    description: "pinching hand",
    category: "People & Body",
    aliases: ["pinching_hand"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "✌️",
    description: "victory hand",
    category: "People & Body",
    aliases: ["v"],
    tags: ["victory", "peace"],
    unicode_version: "",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🤞",
    description: "crossed fingers",
    category: "People & Body",
    aliases: ["crossed_fingers"],
    tags: ["luck", "hopeful"],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🤟",
    description: "love-you gesture",
    category: "People & Body",
    aliases: ["love_you_gesture"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🤘",
    description: "sign of the horns",
    category: "People & Body",
    aliases: ["metal"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1",
    skin_tones: !0
  },
  {
    emoji: "🤙",
    description: "call me hand",
    category: "People & Body",
    aliases: ["call_me_hand"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👈",
    description: "backhand index pointing left",
    category: "People & Body",
    aliases: ["point_left"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👉",
    description: "backhand index pointing right",
    category: "People & Body",
    aliases: ["point_right"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👆",
    description: "backhand index pointing up",
    category: "People & Body",
    aliases: ["point_up_2"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🖕",
    description: "middle finger",
    category: "People & Body",
    aliases: ["middle_finger", "fu"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1",
    skin_tones: !0
  },
  {
    emoji: "👇",
    description: "backhand index pointing down",
    category: "People & Body",
    aliases: ["point_down"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "☝️",
    description: "index pointing up",
    category: "People & Body",
    aliases: ["point_up"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👍",
    description: "thumbs up",
    category: "People & Body",
    aliases: ["+1", "thumbsup"],
    tags: ["approve", "ok"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👎",
    description: "thumbs down",
    category: "People & Body",
    aliases: ["-1", "thumbsdown"],
    tags: ["disapprove", "bury"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "✊",
    description: "raised fist",
    category: "People & Body",
    aliases: ["fist_raised", "fist"],
    tags: ["power"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👊",
    description: "oncoming fist",
    category: "People & Body",
    aliases: ["fist_oncoming", "facepunch", "punch"],
    tags: ["attack"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🤛",
    description: "left-facing fist",
    category: "People & Body",
    aliases: ["fist_left"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🤜",
    description: "right-facing fist",
    category: "People & Body",
    aliases: ["fist_right"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👏",
    description: "clapping hands",
    category: "People & Body",
    aliases: ["clap"],
    tags: ["praise", "applause"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🙌",
    description: "raising hands",
    category: "People & Body",
    aliases: ["raised_hands"],
    tags: ["hooray"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👐",
    description: "open hands",
    category: "People & Body",
    aliases: ["open_hands"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🤲",
    description: "palms up together",
    category: "People & Body",
    aliases: ["palms_up_together"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🤝",
    description: "handshake",
    category: "People & Body",
    aliases: ["handshake"],
    tags: ["deal"],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🙏",
    description: "folded hands",
    category: "People & Body",
    aliases: ["pray"],
    tags: ["please", "hope", "wish"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "✍️",
    description: "writing hand",
    category: "People & Body",
    aliases: ["writing_hand"],
    tags: [],
    unicode_version: "",
    ios_version: "9.1",
    skin_tones: !0
  },
  {
    emoji: "💅",
    description: "nail polish",
    category: "People & Body",
    aliases: ["nail_care"],
    tags: ["beauty", "manicure"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🤳",
    description: "selfie",
    category: "People & Body",
    aliases: ["selfie"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "💪",
    description: "flexed biceps",
    category: "People & Body",
    aliases: ["muscle"],
    tags: ["flex", "bicep", "strong", "workout"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🦾",
    description: "mechanical arm",
    category: "People & Body",
    aliases: ["mechanical_arm"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🦿",
    description: "mechanical leg",
    category: "People & Body",
    aliases: ["mechanical_leg"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🦵",
    description: "leg",
    category: "People & Body",
    aliases: ["leg"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🦶",
    description: "foot",
    category: "People & Body",
    aliases: ["foot"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "👂",
    description: "ear",
    category: "People & Body",
    aliases: ["ear"],
    tags: ["hear", "sound", "listen"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🦻",
    description: "ear with hearing aid",
    category: "People & Body",
    aliases: ["ear_with_hearing_aid"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "👃",
    description: "nose",
    category: "People & Body",
    aliases: ["nose"],
    tags: ["smell"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🧠",
    description: "brain",
    category: "People & Body",
    aliases: ["brain"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🫀",
    description: "anatomical heart",
    category: "People & Body",
    aliases: ["anatomical_heart"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🫁",
    description: "lungs",
    category: "People & Body",
    aliases: ["lungs"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🦷",
    description: "tooth",
    category: "People & Body",
    aliases: ["tooth"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🦴",
    description: "bone",
    category: "People & Body",
    aliases: ["bone"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "👀",
    description: "eyes",
    category: "People & Body",
    aliases: ["eyes"],
    tags: ["look", "see", "watch"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👁️",
    description: "eye",
    category: "People & Body",
    aliases: ["eye"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "👅",
    description: "tongue",
    category: "People & Body",
    aliases: ["tongue"],
    tags: ["taste"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👄",
    description: "mouth",
    category: "People & Body",
    aliases: ["lips"],
    tags: ["kiss"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👶",
    description: "baby",
    category: "People & Body",
    aliases: ["baby"],
    tags: ["child", "newborn"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🧒",
    description: "child",
    category: "People & Body",
    aliases: ["child"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "👦",
    description: "boy",
    category: "People & Body",
    aliases: ["boy"],
    tags: ["child"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👧",
    description: "girl",
    category: "People & Body",
    aliases: ["girl"],
    tags: ["child"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🧑",
    description: "person",
    category: "People & Body",
    aliases: ["adult"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "👱",
    description: "person: blond hair",
    category: "People & Body",
    aliases: ["blond_haired_person"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👨",
    description: "man",
    category: "People & Body",
    aliases: ["man"],
    tags: ["mustache", "father", "dad"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🧔",
    description: "person: beard",
    category: "People & Body",
    aliases: ["bearded_person"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧔‍♂️",
    description: "man: beard",
    category: "People & Body",
    aliases: ["man_beard"],
    tags: [],
    unicode_version: "13.1",
    ios_version: "14.0",
    skin_tones: !0
  },
  {
    emoji: "🧔‍♀️",
    description: "woman: beard",
    category: "People & Body",
    aliases: ["woman_beard"],
    tags: [],
    unicode_version: "13.1",
    ios_version: "14.0",
    skin_tones: !0
  },
  {
    emoji: "👨‍🦰",
    description: "man: red hair",
    category: "People & Body",
    aliases: ["red_haired_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "👨‍🦱",
    description: "man: curly hair",
    category: "People & Body",
    aliases: ["curly_haired_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "👨‍🦳",
    description: "man: white hair",
    category: "People & Body",
    aliases: ["white_haired_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "👨‍🦲",
    description: "man: bald",
    category: "People & Body",
    aliases: ["bald_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "👩",
    description: "woman",
    category: "People & Body",
    aliases: ["woman"],
    tags: ["girls"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👩‍🦰",
    description: "woman: red hair",
    category: "People & Body",
    aliases: ["red_haired_woman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🦰",
    description: "person: red hair",
    category: "People & Body",
    aliases: ["person_red_hair"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍🦱",
    description: "woman: curly hair",
    category: "People & Body",
    aliases: ["curly_haired_woman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🦱",
    description: "person: curly hair",
    category: "People & Body",
    aliases: ["person_curly_hair"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍🦳",
    description: "woman: white hair",
    category: "People & Body",
    aliases: ["white_haired_woman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🦳",
    description: "person: white hair",
    category: "People & Body",
    aliases: ["person_white_hair"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍🦲",
    description: "woman: bald",
    category: "People & Body",
    aliases: ["bald_woman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🦲",
    description: "person: bald",
    category: "People & Body",
    aliases: ["person_bald"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👱‍♀️",
    description: "woman: blond hair",
    category: "People & Body",
    aliases: ["blond_haired_woman", "blonde_woman"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "👱‍♂️",
    description: "man: blond hair",
    category: "People & Body",
    aliases: ["blond_haired_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧓",
    description: "older person",
    category: "People & Body",
    aliases: ["older_adult"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "👴",
    description: "old man",
    category: "People & Body",
    aliases: ["older_man"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👵",
    description: "old woman",
    category: "People & Body",
    aliases: ["older_woman"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🙍",
    description: "person frowning",
    category: "People & Body",
    aliases: ["frowning_person"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🙍‍♂️",
    description: "man frowning",
    category: "People & Body",
    aliases: ["frowning_man"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "🙍‍♀️",
    description: "woman frowning",
    category: "People & Body",
    aliases: ["frowning_woman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🙎",
    description: "person pouting",
    category: "People & Body",
    aliases: ["pouting_face"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🙎‍♂️",
    description: "man pouting",
    category: "People & Body",
    aliases: ["pouting_man"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "🙎‍♀️",
    description: "woman pouting",
    category: "People & Body",
    aliases: ["pouting_woman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🙅",
    description: "person gesturing NO",
    category: "People & Body",
    aliases: ["no_good"],
    tags: ["stop", "halt", "denied"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🙅‍♂️",
    description: "man gesturing NO",
    category: "People & Body",
    aliases: ["no_good_man", "ng_man"],
    tags: ["stop", "halt", "denied"],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "🙅‍♀️",
    description: "woman gesturing NO",
    category: "People & Body",
    aliases: ["no_good_woman", "ng_woman"],
    tags: ["stop", "halt", "denied"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🙆",
    description: "person gesturing OK",
    category: "People & Body",
    aliases: ["ok_person"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🙆‍♂️",
    description: "man gesturing OK",
    category: "People & Body",
    aliases: ["ok_man"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "🙆‍♀️",
    description: "woman gesturing OK",
    category: "People & Body",
    aliases: ["ok_woman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "💁",
    description: "person tipping hand",
    category: "People & Body",
    aliases: ["tipping_hand_person", "information_desk_person"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "💁‍♂️",
    description: "man tipping hand",
    category: "People & Body",
    aliases: ["tipping_hand_man", "sassy_man"],
    tags: ["information"],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "💁‍♀️",
    description: "woman tipping hand",
    category: "People & Body",
    aliases: ["tipping_hand_woman", "sassy_woman"],
    tags: ["information"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🙋",
    description: "person raising hand",
    category: "People & Body",
    aliases: ["raising_hand"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🙋‍♂️",
    description: "man raising hand",
    category: "People & Body",
    aliases: ["raising_hand_man"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "🙋‍♀️",
    description: "woman raising hand",
    category: "People & Body",
    aliases: ["raising_hand_woman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧏",
    description: "deaf person",
    category: "People & Body",
    aliases: ["deaf_person"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "🧏‍♂️",
    description: "deaf man",
    category: "People & Body",
    aliases: ["deaf_man"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "🧏‍♀️",
    description: "deaf woman",
    category: "People & Body",
    aliases: ["deaf_woman"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "🙇",
    description: "person bowing",
    category: "People & Body",
    aliases: ["bow"],
    tags: ["respect", "thanks"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🙇‍♂️",
    description: "man bowing",
    category: "People & Body",
    aliases: ["bowing_man"],
    tags: ["respect", "thanks"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🙇‍♀️",
    description: "woman bowing",
    category: "People & Body",
    aliases: ["bowing_woman"],
    tags: ["respect", "thanks"],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "🤦",
    description: "person facepalming",
    category: "People & Body",
    aliases: ["facepalm"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🤦‍♂️",
    description: "man facepalming",
    category: "People & Body",
    aliases: ["man_facepalming"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🤦‍♀️",
    description: "woman facepalming",
    category: "People & Body",
    aliases: ["woman_facepalming"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🤷",
    description: "person shrugging",
    category: "People & Body",
    aliases: ["shrug"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🤷‍♂️",
    description: "man shrugging",
    category: "People & Body",
    aliases: ["man_shrugging"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🤷‍♀️",
    description: "woman shrugging",
    category: "People & Body",
    aliases: ["woman_shrugging"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧑‍⚕️",
    description: "health worker",
    category: "People & Body",
    aliases: ["health_worker"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍⚕️",
    description: "man health worker",
    category: "People & Body",
    aliases: ["man_health_worker"],
    tags: ["doctor", "nurse"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍⚕️",
    description: "woman health worker",
    category: "People & Body",
    aliases: ["woman_health_worker"],
    tags: ["doctor", "nurse"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🎓",
    description: "student",
    category: "People & Body",
    aliases: ["student"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍🎓",
    description: "man student",
    category: "People & Body",
    aliases: ["man_student"],
    tags: ["graduation"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍🎓",
    description: "woman student",
    category: "People & Body",
    aliases: ["woman_student"],
    tags: ["graduation"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🏫",
    description: "teacher",
    category: "People & Body",
    aliases: ["teacher"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍🏫",
    description: "man teacher",
    category: "People & Body",
    aliases: ["man_teacher"],
    tags: ["school", "professor"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍🏫",
    description: "woman teacher",
    category: "People & Body",
    aliases: ["woman_teacher"],
    tags: ["school", "professor"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧑‍⚖️",
    description: "judge",
    category: "People & Body",
    aliases: ["judge"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍⚖️",
    description: "man judge",
    category: "People & Body",
    aliases: ["man_judge"],
    tags: ["justice"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍⚖️",
    description: "woman judge",
    category: "People & Body",
    aliases: ["woman_judge"],
    tags: ["justice"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🌾",
    description: "farmer",
    category: "People & Body",
    aliases: ["farmer"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍🌾",
    description: "man farmer",
    category: "People & Body",
    aliases: ["man_farmer"],
    tags: [],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍🌾",
    description: "woman farmer",
    category: "People & Body",
    aliases: ["woman_farmer"],
    tags: [],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🍳",
    description: "cook",
    category: "People & Body",
    aliases: ["cook"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍🍳",
    description: "man cook",
    category: "People & Body",
    aliases: ["man_cook"],
    tags: ["chef"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍🍳",
    description: "woman cook",
    category: "People & Body",
    aliases: ["woman_cook"],
    tags: ["chef"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🔧",
    description: "mechanic",
    category: "People & Body",
    aliases: ["mechanic"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍🔧",
    description: "man mechanic",
    category: "People & Body",
    aliases: ["man_mechanic"],
    tags: [],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍🔧",
    description: "woman mechanic",
    category: "People & Body",
    aliases: ["woman_mechanic"],
    tags: [],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🏭",
    description: "factory worker",
    category: "People & Body",
    aliases: ["factory_worker"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍🏭",
    description: "man factory worker",
    category: "People & Body",
    aliases: ["man_factory_worker"],
    tags: [],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍🏭",
    description: "woman factory worker",
    category: "People & Body",
    aliases: ["woman_factory_worker"],
    tags: [],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧑‍💼",
    description: "office worker",
    category: "People & Body",
    aliases: ["office_worker"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍💼",
    description: "man office worker",
    category: "People & Body",
    aliases: ["man_office_worker"],
    tags: ["business"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍💼",
    description: "woman office worker",
    category: "People & Body",
    aliases: ["woman_office_worker"],
    tags: ["business"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🔬",
    description: "scientist",
    category: "People & Body",
    aliases: ["scientist"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍🔬",
    description: "man scientist",
    category: "People & Body",
    aliases: ["man_scientist"],
    tags: ["research"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍🔬",
    description: "woman scientist",
    category: "People & Body",
    aliases: ["woman_scientist"],
    tags: ["research"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧑‍💻",
    description: "technologist",
    category: "People & Body",
    aliases: ["technologist"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍💻",
    description: "man technologist",
    category: "People & Body",
    aliases: ["man_technologist"],
    tags: ["coder"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍💻",
    description: "woman technologist",
    category: "People & Body",
    aliases: ["woman_technologist"],
    tags: ["coder"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🎤",
    description: "singer",
    category: "People & Body",
    aliases: ["singer"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍🎤",
    description: "man singer",
    category: "People & Body",
    aliases: ["man_singer"],
    tags: ["rockstar"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍🎤",
    description: "woman singer",
    category: "People & Body",
    aliases: ["woman_singer"],
    tags: ["rockstar"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🎨",
    description: "artist",
    category: "People & Body",
    aliases: ["artist"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍🎨",
    description: "man artist",
    category: "People & Body",
    aliases: ["man_artist"],
    tags: ["painter"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍🎨",
    description: "woman artist",
    category: "People & Body",
    aliases: ["woman_artist"],
    tags: ["painter"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧑‍✈️",
    description: "pilot",
    category: "People & Body",
    aliases: ["pilot"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍✈️",
    description: "man pilot",
    category: "People & Body",
    aliases: ["man_pilot"],
    tags: [],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍✈️",
    description: "woman pilot",
    category: "People & Body",
    aliases: ["woman_pilot"],
    tags: [],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🚀",
    description: "astronaut",
    category: "People & Body",
    aliases: ["astronaut"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍🚀",
    description: "man astronaut",
    category: "People & Body",
    aliases: ["man_astronaut"],
    tags: ["space"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍🚀",
    description: "woman astronaut",
    category: "People & Body",
    aliases: ["woman_astronaut"],
    tags: ["space"],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🚒",
    description: "firefighter",
    category: "People & Body",
    aliases: ["firefighter"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍🚒",
    description: "man firefighter",
    category: "People & Body",
    aliases: ["man_firefighter"],
    tags: [],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👩‍🚒",
    description: "woman firefighter",
    category: "People & Body",
    aliases: ["woman_firefighter"],
    tags: [],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👮",
    description: "police officer",
    category: "People & Body",
    aliases: ["police_officer", "cop"],
    tags: ["law"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👮‍♂️",
    description: "man police officer",
    category: "People & Body",
    aliases: ["policeman"],
    tags: ["law", "cop"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "👮‍♀️",
    description: "woman police officer",
    category: "People & Body",
    aliases: ["policewoman"],
    tags: ["law", "cop"],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "🕵️",
    description: "detective",
    category: "People & Body",
    aliases: ["detective"],
    tags: ["sleuth"],
    unicode_version: "7.0",
    ios_version: "9.1",
    skin_tones: !0
  },
  {
    emoji: "🕵️‍♂️",
    description: "man detective",
    category: "People & Body",
    aliases: ["male_detective"],
    tags: ["sleuth"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🕵️‍♀️",
    description: "woman detective",
    category: "People & Body",
    aliases: ["female_detective"],
    tags: ["sleuth"],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "💂",
    description: "guard",
    category: "People & Body",
    aliases: ["guard"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "💂‍♂️",
    description: "man guard",
    category: "People & Body",
    aliases: ["guardsman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "💂‍♀️",
    description: "woman guard",
    category: "People & Body",
    aliases: ["guardswoman"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "🥷",
    description: "ninja",
    category: "People & Body",
    aliases: ["ninja"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0",
    skin_tones: !0
  },
  {
    emoji: "👷",
    description: "construction worker",
    category: "People & Body",
    aliases: ["construction_worker"],
    tags: ["helmet"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👷‍♂️",
    description: "man construction worker",
    category: "People & Body",
    aliases: ["construction_worker_man"],
    tags: ["helmet"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "👷‍♀️",
    description: "woman construction worker",
    category: "People & Body",
    aliases: ["construction_worker_woman"],
    tags: ["helmet"],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "🤴",
    description: "prince",
    category: "People & Body",
    aliases: ["prince"],
    tags: ["crown", "royal"],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "👸",
    description: "princess",
    category: "People & Body",
    aliases: ["princess"],
    tags: ["crown", "royal"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👳",
    description: "person wearing turban",
    category: "People & Body",
    aliases: ["person_with_turban"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👳‍♂️",
    description: "man wearing turban",
    category: "People & Body",
    aliases: ["man_with_turban"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "👳‍♀️",
    description: "woman wearing turban",
    category: "People & Body",
    aliases: ["woman_with_turban"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "👲",
    description: "person with skullcap",
    category: "People & Body",
    aliases: ["man_with_gua_pi_mao"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🧕",
    description: "woman with headscarf",
    category: "People & Body",
    aliases: ["woman_with_headscarf"],
    tags: ["hijab"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🤵",
    description: "person in tuxedo",
    category: "People & Body",
    aliases: ["person_in_tuxedo"],
    tags: ["groom", "marriage", "wedding"],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🤵‍♂️",
    description: "man in tuxedo",
    category: "People & Body",
    aliases: ["man_in_tuxedo"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0",
    skin_tones: !0
  },
  {
    emoji: "🤵‍♀️",
    description: "woman in tuxedo",
    category: "People & Body",
    aliases: ["woman_in_tuxedo"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0",
    skin_tones: !0
  },
  {
    emoji: "👰",
    description: "person with veil",
    category: "People & Body",
    aliases: ["person_with_veil"],
    tags: ["marriage", "wedding"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👰‍♂️",
    description: "man with veil",
    category: "People & Body",
    aliases: ["man_with_veil"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0",
    skin_tones: !0
  },
  {
    emoji: "👰‍♀️",
    description: "woman with veil",
    category: "People & Body",
    aliases: ["woman_with_veil", "bride_with_veil"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0",
    skin_tones: !0
  },
  {
    emoji: "🤰",
    description: "pregnant woman",
    category: "People & Body",
    aliases: ["pregnant_woman"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🤱",
    description: "breast-feeding",
    category: "People & Body",
    aliases: ["breast_feeding"],
    tags: ["nursing"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "👩‍🍼",
    description: "woman feeding baby",
    category: "People & Body",
    aliases: ["woman_feeding_baby"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0",
    skin_tones: !0
  },
  {
    emoji: "👨‍🍼",
    description: "man feeding baby",
    category: "People & Body",
    aliases: ["man_feeding_baby"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🍼",
    description: "person feeding baby",
    category: "People & Body",
    aliases: ["person_feeding_baby"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0",
    skin_tones: !0
  },
  {
    emoji: "👼",
    description: "baby angel",
    category: "People & Body",
    aliases: ["angel"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🎅",
    description: "Santa Claus",
    category: "People & Body",
    aliases: ["santa"],
    tags: ["christmas"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🤶",
    description: "Mrs. Claus",
    category: "People & Body",
    aliases: ["mrs_claus"],
    tags: ["santa"],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🎄",
    description: "mx claus",
    category: "People & Body",
    aliases: ["mx_claus"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0",
    skin_tones: !0
  },
  {
    emoji: "🦸",
    description: "superhero",
    category: "People & Body",
    aliases: ["superhero"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🦸‍♂️",
    description: "man superhero",
    category: "People & Body",
    aliases: ["superhero_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🦸‍♀️",
    description: "woman superhero",
    category: "People & Body",
    aliases: ["superhero_woman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🦹",
    description: "supervillain",
    category: "People & Body",
    aliases: ["supervillain"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🦹‍♂️",
    description: "man supervillain",
    category: "People & Body",
    aliases: ["supervillain_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🦹‍♀️",
    description: "woman supervillain",
    category: "People & Body",
    aliases: ["supervillain_woman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧙",
    description: "mage",
    category: "People & Body",
    aliases: ["mage"],
    tags: ["wizard"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧙‍♂️",
    description: "man mage",
    category: "People & Body",
    aliases: ["mage_man"],
    tags: ["wizard"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧙‍♀️",
    description: "woman mage",
    category: "People & Body",
    aliases: ["mage_woman"],
    tags: ["wizard"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧚",
    description: "fairy",
    category: "People & Body",
    aliases: ["fairy"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧚‍♂️",
    description: "man fairy",
    category: "People & Body",
    aliases: ["fairy_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧚‍♀️",
    description: "woman fairy",
    category: "People & Body",
    aliases: ["fairy_woman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧛",
    description: "vampire",
    category: "People & Body",
    aliases: ["vampire"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧛‍♂️",
    description: "man vampire",
    category: "People & Body",
    aliases: ["vampire_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧛‍♀️",
    description: "woman vampire",
    category: "People & Body",
    aliases: ["vampire_woman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧜",
    description: "merperson",
    category: "People & Body",
    aliases: ["merperson"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧜‍♂️",
    description: "merman",
    category: "People & Body",
    aliases: ["merman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧜‍♀️",
    description: "mermaid",
    category: "People & Body",
    aliases: ["mermaid"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧝",
    description: "elf",
    category: "People & Body",
    aliases: ["elf"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧝‍♂️",
    description: "man elf",
    category: "People & Body",
    aliases: ["elf_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧝‍♀️",
    description: "woman elf",
    category: "People & Body",
    aliases: ["elf_woman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧞",
    description: "genie",
    category: "People & Body",
    aliases: ["genie"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧞‍♂️",
    description: "man genie",
    category: "People & Body",
    aliases: ["genie_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧞‍♀️",
    description: "woman genie",
    category: "People & Body",
    aliases: ["genie_woman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧟",
    description: "zombie",
    category: "People & Body",
    aliases: ["zombie"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧟‍♂️",
    description: "man zombie",
    category: "People & Body",
    aliases: ["zombie_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧟‍♀️",
    description: "woman zombie",
    category: "People & Body",
    aliases: ["zombie_woman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "💆",
    description: "person getting massage",
    category: "People & Body",
    aliases: ["massage"],
    tags: ["spa"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "💆‍♂️",
    description: "man getting massage",
    category: "People & Body",
    aliases: ["massage_man"],
    tags: ["spa"],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "💆‍♀️",
    description: "woman getting massage",
    category: "People & Body",
    aliases: ["massage_woman"],
    tags: ["spa"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "💇",
    description: "person getting haircut",
    category: "People & Body",
    aliases: ["haircut"],
    tags: ["beauty"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "💇‍♂️",
    description: "man getting haircut",
    category: "People & Body",
    aliases: ["haircut_man"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "💇‍♀️",
    description: "woman getting haircut",
    category: "People & Body",
    aliases: ["haircut_woman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🚶",
    description: "person walking",
    category: "People & Body",
    aliases: ["walking"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🚶‍♂️",
    description: "man walking",
    category: "People & Body",
    aliases: ["walking_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🚶‍♀️",
    description: "woman walking",
    category: "People & Body",
    aliases: ["walking_woman"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "🧍",
    description: "person standing",
    category: "People & Body",
    aliases: ["standing_person"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "🧍‍♂️",
    description: "man standing",
    category: "People & Body",
    aliases: ["standing_man"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "🧍‍♀️",
    description: "woman standing",
    category: "People & Body",
    aliases: ["standing_woman"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "🧎",
    description: "person kneeling",
    category: "People & Body",
    aliases: ["kneeling_person"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "🧎‍♂️",
    description: "man kneeling",
    category: "People & Body",
    aliases: ["kneeling_man"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "🧎‍♀️",
    description: "woman kneeling",
    category: "People & Body",
    aliases: ["kneeling_woman"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🦯",
    description: "person with white cane",
    category: "People & Body",
    aliases: ["person_with_probing_cane"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍🦯",
    description: "man with white cane",
    category: "People & Body",
    aliases: ["man_with_probing_cane"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "👩‍🦯",
    description: "woman with white cane",
    category: "People & Body",
    aliases: ["woman_with_probing_cane"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🦼",
    description: "person in motorized wheelchair",
    category: "People & Body",
    aliases: ["person_in_motorized_wheelchair"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍🦼",
    description: "man in motorized wheelchair",
    category: "People & Body",
    aliases: ["man_in_motorized_wheelchair"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "👩‍🦼",
    description: "woman in motorized wheelchair",
    category: "People & Body",
    aliases: ["woman_in_motorized_wheelchair"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🦽",
    description: "person in manual wheelchair",
    category: "People & Body",
    aliases: ["person_in_manual_wheelchair"],
    tags: [],
    unicode_version: "12.1",
    ios_version: "13.2",
    skin_tones: !0
  },
  {
    emoji: "👨‍🦽",
    description: "man in manual wheelchair",
    category: "People & Body",
    aliases: ["man_in_manual_wheelchair"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "👩‍🦽",
    description: "woman in manual wheelchair",
    category: "People & Body",
    aliases: ["woman_in_manual_wheelchair"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "🏃",
    description: "person running",
    category: "People & Body",
    aliases: ["runner", "running"],
    tags: ["exercise", "workout", "marathon"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🏃‍♂️",
    description: "man running",
    category: "People & Body",
    aliases: ["running_man"],
    tags: ["exercise", "workout", "marathon"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🏃‍♀️",
    description: "woman running",
    category: "People & Body",
    aliases: ["running_woman"],
    tags: ["exercise", "workout", "marathon"],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "💃",
    description: "woman dancing",
    category: "People & Body",
    aliases: ["woman_dancing", "dancer"],
    tags: ["dress"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🕺",
    description: "man dancing",
    category: "People & Body",
    aliases: ["man_dancing"],
    tags: ["dancer"],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🕴️",
    description: "person in suit levitating",
    category: "People & Body",
    aliases: ["business_suit_levitating"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1",
    skin_tones: !0
  },
  {
    emoji: "👯",
    description: "people with bunny ears",
    category: "People & Body",
    aliases: ["dancers"],
    tags: ["bunny"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👯‍♂️",
    description: "men with bunny ears",
    category: "People & Body",
    aliases: ["dancing_men"],
    tags: ["bunny"],
    unicode_version: "6.0",
    ios_version: "10.0"
  },
  {
    emoji: "👯‍♀️",
    description: "women with bunny ears",
    category: "People & Body",
    aliases: ["dancing_women"],
    tags: ["bunny"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧖",
    description: "person in steamy room",
    category: "People & Body",
    aliases: ["sauna_person"],
    tags: ["steamy"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧖‍♂️",
    description: "man in steamy room",
    category: "People & Body",
    aliases: ["sauna_man"],
    tags: ["steamy"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧖‍♀️",
    description: "woman in steamy room",
    category: "People & Body",
    aliases: ["sauna_woman"],
    tags: ["steamy"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧗",
    description: "person climbing",
    category: "People & Body",
    aliases: ["climbing"],
    tags: ["bouldering"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧗‍♂️",
    description: "man climbing",
    category: "People & Body",
    aliases: ["climbing_man"],
    tags: ["bouldering"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧗‍♀️",
    description: "woman climbing",
    category: "People & Body",
    aliases: ["climbing_woman"],
    tags: ["bouldering"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🤺",
    description: "person fencing",
    category: "People & Body",
    aliases: ["person_fencing"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🏇",
    description: "horse racing",
    category: "People & Body",
    aliases: ["horse_racing"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "⛷️",
    description: "skier",
    category: "People & Body",
    aliases: ["skier"],
    tags: [],
    unicode_version: "5.2",
    ios_version: "9.1"
  },
  {
    emoji: "🏂",
    description: "snowboarder",
    category: "People & Body",
    aliases: ["snowboarder"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🏌️",
    description: "person golfing",
    category: "People & Body",
    aliases: ["golfing"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1",
    skin_tones: !0
  },
  {
    emoji: "🏌️‍♂️",
    description: "man golfing",
    category: "People & Body",
    aliases: ["golfing_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🏌️‍♀️",
    description: "woman golfing",
    category: "People & Body",
    aliases: ["golfing_woman"],
    tags: [],
    unicode_version: "",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "🏄",
    description: "person surfing",
    category: "People & Body",
    aliases: ["surfer"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🏄‍♂️",
    description: "man surfing",
    category: "People & Body",
    aliases: ["surfing_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🏄‍♀️",
    description: "woman surfing",
    category: "People & Body",
    aliases: ["surfing_woman"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "🚣",
    description: "person rowing boat",
    category: "People & Body",
    aliases: ["rowboat"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🚣‍♂️",
    description: "man rowing boat",
    category: "People & Body",
    aliases: ["rowing_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🚣‍♀️",
    description: "woman rowing boat",
    category: "People & Body",
    aliases: ["rowing_woman"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "🏊",
    description: "person swimming",
    category: "People & Body",
    aliases: ["swimmer"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🏊‍♂️",
    description: "man swimming",
    category: "People & Body",
    aliases: ["swimming_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🏊‍♀️",
    description: "woman swimming",
    category: "People & Body",
    aliases: ["swimming_woman"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "⛹️",
    description: "person bouncing ball",
    category: "People & Body",
    aliases: ["bouncing_ball_person"],
    tags: ["basketball"],
    unicode_version: "5.2",
    ios_version: "9.1",
    skin_tones: !0
  },
  {
    emoji: "⛹️‍♂️",
    description: "man bouncing ball",
    category: "People & Body",
    aliases: ["bouncing_ball_man", "basketball_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "⛹️‍♀️",
    description: "woman bouncing ball",
    category: "People & Body",
    aliases: ["bouncing_ball_woman", "basketball_woman"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "🏋️",
    description: "person lifting weights",
    category: "People & Body",
    aliases: ["weight_lifting"],
    tags: ["gym", "workout"],
    unicode_version: "7.0",
    ios_version: "9.1",
    skin_tones: !0
  },
  {
    emoji: "🏋️‍♂️",
    description: "man lifting weights",
    category: "People & Body",
    aliases: ["weight_lifting_man"],
    tags: ["gym", "workout"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🏋️‍♀️",
    description: "woman lifting weights",
    category: "People & Body",
    aliases: ["weight_lifting_woman"],
    tags: ["gym", "workout"],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "🚴",
    description: "person biking",
    category: "People & Body",
    aliases: ["bicyclist"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🚴‍♂️",
    description: "man biking",
    category: "People & Body",
    aliases: ["biking_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🚴‍♀️",
    description: "woman biking",
    category: "People & Body",
    aliases: ["biking_woman"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "🚵",
    description: "person mountain biking",
    category: "People & Body",
    aliases: ["mountain_bicyclist"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🚵‍♂️",
    description: "man mountain biking",
    category: "People & Body",
    aliases: ["mountain_biking_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🚵‍♀️",
    description: "woman mountain biking",
    category: "People & Body",
    aliases: ["mountain_biking_woman"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0",
    skin_tones: !0
  },
  {
    emoji: "🤸",
    description: "person cartwheeling",
    category: "People & Body",
    aliases: ["cartwheeling"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🤸‍♂️",
    description: "man cartwheeling",
    category: "People & Body",
    aliases: ["man_cartwheeling"],
    tags: [],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🤸‍♀️",
    description: "woman cartwheeling",
    category: "People & Body",
    aliases: ["woman_cartwheeling"],
    tags: [],
    unicode_version: "",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🤼",
    description: "people wrestling",
    category: "People & Body",
    aliases: ["wrestling"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🤼‍♂️",
    description: "men wrestling",
    category: "People & Body",
    aliases: ["men_wrestling"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🤼‍♀️",
    description: "women wrestling",
    category: "People & Body",
    aliases: ["women_wrestling"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🤽",
    description: "person playing water polo",
    category: "People & Body",
    aliases: ["water_polo"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🤽‍♂️",
    description: "man playing water polo",
    category: "People & Body",
    aliases: ["man_playing_water_polo"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🤽‍♀️",
    description: "woman playing water polo",
    category: "People & Body",
    aliases: ["woman_playing_water_polo"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🤾",
    description: "person playing handball",
    category: "People & Body",
    aliases: ["handball_person"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🤾‍♂️",
    description: "man playing handball",
    category: "People & Body",
    aliases: ["man_playing_handball"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🤾‍♀️",
    description: "woman playing handball",
    category: "People & Body",
    aliases: ["woman_playing_handball"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🤹",
    description: "person juggling",
    category: "People & Body",
    aliases: ["juggling_person"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🤹‍♂️",
    description: "man juggling",
    category: "People & Body",
    aliases: ["man_juggling"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🤹‍♀️",
    description: "woman juggling",
    category: "People & Body",
    aliases: ["woman_juggling"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2",
    skin_tones: !0
  },
  {
    emoji: "🧘",
    description: "person in lotus position",
    category: "People & Body",
    aliases: ["lotus_position"],
    tags: ["meditation"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧘‍♂️",
    description: "man in lotus position",
    category: "People & Body",
    aliases: ["lotus_position_man"],
    tags: ["meditation"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🧘‍♀️",
    description: "woman in lotus position",
    category: "People & Body",
    aliases: ["lotus_position_woman"],
    tags: ["meditation"],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "🛀",
    description: "person taking bath",
    category: "People & Body",
    aliases: ["bath"],
    tags: ["shower"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "🛌",
    description: "person in bed",
    category: "People & Body",
    aliases: ["sleeping_bed"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1",
    skin_tones: !0
  },
  {
    emoji: "🧑‍🤝‍🧑",
    description: "people holding hands",
    category: "People & Body",
    aliases: ["people_holding_hands"],
    tags: ["couple", "date"],
    unicode_version: "12.0",
    ios_version: "13.0",
    skin_tones: !0
  },
  {
    emoji: "👭",
    description: "women holding hands",
    category: "People & Body",
    aliases: ["two_women_holding_hands"],
    tags: ["couple", "date"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👫",
    description: "woman and man holding hands",
    category: "People & Body",
    aliases: ["couple"],
    tags: ["date"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👬",
    description: "men holding hands",
    category: "People & Body",
    aliases: ["two_men_holding_hands"],
    tags: ["couple", "date"],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "💏",
    description: "kiss",
    category: "People & Body",
    aliases: ["couplekiss"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👩‍❤️‍💋‍👨",
    description: "kiss: woman, man",
    category: "People & Body",
    aliases: ["couplekiss_man_woman"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "👨‍❤️‍💋‍👨",
    description: "kiss: man, man",
    category: "People & Body",
    aliases: ["couplekiss_man_man"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3",
    skin_tones: !0
  },
  {
    emoji: "👩‍❤️‍💋‍👩",
    description: "kiss: woman, woman",
    category: "People & Body",
    aliases: ["couplekiss_woman_woman"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3",
    skin_tones: !0
  },
  {
    emoji: "💑",
    description: "couple with heart",
    category: "People & Body",
    aliases: ["couple_with_heart"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0",
    skin_tones: !0
  },
  {
    emoji: "👩‍❤️‍👨",
    description: "couple with heart: woman, man",
    category: "People & Body",
    aliases: ["couple_with_heart_woman_man"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1",
    skin_tones: !0
  },
  {
    emoji: "👨‍❤️‍👨",
    description: "couple with heart: man, man",
    category: "People & Body",
    aliases: ["couple_with_heart_man_man"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3",
    skin_tones: !0
  },
  {
    emoji: "👩‍❤️‍👩",
    description: "couple with heart: woman, woman",
    category: "People & Body",
    aliases: ["couple_with_heart_woman_woman"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3",
    skin_tones: !0
  },
  {
    emoji: "👪",
    description: "family",
    category: "People & Body",
    aliases: ["family"],
    tags: ["home", "parents", "child"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👨‍👩‍👦",
    description: "family: man, woman, boy",
    category: "People & Body",
    aliases: ["family_man_woman_boy"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "👨‍👩‍👧",
    description: "family: man, woman, girl",
    category: "People & Body",
    aliases: ["family_man_woman_girl"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "👨‍👩‍👧‍👦",
    description: "family: man, woman, girl, boy",
    category: "People & Body",
    aliases: ["family_man_woman_girl_boy"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "👨‍👩‍👦‍👦",
    description: "family: man, woman, boy, boy",
    category: "People & Body",
    aliases: ["family_man_woman_boy_boy"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "👨‍👩‍👧‍👧",
    description: "family: man, woman, girl, girl",
    category: "People & Body",
    aliases: ["family_man_woman_girl_girl"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "👨‍👨‍👦",
    description: "family: man, man, boy",
    category: "People & Body",
    aliases: ["family_man_man_boy"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "👨‍👨‍👧",
    description: "family: man, man, girl",
    category: "People & Body",
    aliases: ["family_man_man_girl"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "👨‍👨‍👧‍👦",
    description: "family: man, man, girl, boy",
    category: "People & Body",
    aliases: ["family_man_man_girl_boy"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "👨‍👨‍👦‍👦",
    description: "family: man, man, boy, boy",
    category: "People & Body",
    aliases: ["family_man_man_boy_boy"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "👨‍👨‍👧‍👧",
    description: "family: man, man, girl, girl",
    category: "People & Body",
    aliases: ["family_man_man_girl_girl"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "👩‍👩‍👦",
    description: "family: woman, woman, boy",
    category: "People & Body",
    aliases: ["family_woman_woman_boy"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "👩‍👩‍👧",
    description: "family: woman, woman, girl",
    category: "People & Body",
    aliases: ["family_woman_woman_girl"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "👩‍👩‍👧‍👦",
    description: "family: woman, woman, girl, boy",
    category: "People & Body",
    aliases: ["family_woman_woman_girl_boy"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "👩‍👩‍👦‍👦",
    description: "family: woman, woman, boy, boy",
    category: "People & Body",
    aliases: ["family_woman_woman_boy_boy"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "👩‍👩‍👧‍👧",
    description: "family: woman, woman, girl, girl",
    category: "People & Body",
    aliases: ["family_woman_woman_girl_girl"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "👨‍👦",
    description: "family: man, boy",
    category: "People & Body",
    aliases: ["family_man_boy"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0"
  },
  {
    emoji: "👨‍👦‍👦",
    description: "family: man, boy, boy",
    category: "People & Body",
    aliases: ["family_man_boy_boy"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0"
  },
  {
    emoji: "👨‍👧",
    description: "family: man, girl",
    category: "People & Body",
    aliases: ["family_man_girl"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0"
  },
  {
    emoji: "👨‍👧‍👦",
    description: "family: man, girl, boy",
    category: "People & Body",
    aliases: ["family_man_girl_boy"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0"
  },
  {
    emoji: "👨‍👧‍👧",
    description: "family: man, girl, girl",
    category: "People & Body",
    aliases: ["family_man_girl_girl"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0"
  },
  {
    emoji: "👩‍👦",
    description: "family: woman, boy",
    category: "People & Body",
    aliases: ["family_woman_boy"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0"
  },
  {
    emoji: "👩‍👦‍👦",
    description: "family: woman, boy, boy",
    category: "People & Body",
    aliases: ["family_woman_boy_boy"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0"
  },
  {
    emoji: "👩‍👧",
    description: "family: woman, girl",
    category: "People & Body",
    aliases: ["family_woman_girl"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0"
  },
  {
    emoji: "👩‍👧‍👦",
    description: "family: woman, girl, boy",
    category: "People & Body",
    aliases: ["family_woman_girl_boy"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0"
  },
  {
    emoji: "👩‍👧‍👧",
    description: "family: woman, girl, girl",
    category: "People & Body",
    aliases: ["family_woman_girl_girl"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "10.0"
  },
  {
    emoji: "🗣️",
    description: "speaking head",
    category: "People & Body",
    aliases: ["speaking_head"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "👤",
    description: "bust in silhouette",
    category: "People & Body",
    aliases: ["bust_in_silhouette"],
    tags: ["user"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👥",
    description: "busts in silhouette",
    category: "People & Body",
    aliases: ["busts_in_silhouette"],
    tags: ["users", "group", "team"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🫂",
    description: "people hugging",
    category: "People & Body",
    aliases: ["people_hugging"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "👣",
    description: "footprints",
    category: "People & Body",
    aliases: ["footprints"],
    tags: ["feet", "tracks"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐵",
    description: "monkey face",
    category: "Animals & Nature",
    aliases: ["monkey_face"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐒",
    description: "monkey",
    category: "Animals & Nature",
    aliases: ["monkey"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🦍",
    description: "gorilla",
    category: "Animals & Nature",
    aliases: ["gorilla"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🦧",
    description: "orangutan",
    category: "Animals & Nature",
    aliases: ["orangutan"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🐶",
    description: "dog face",
    category: "Animals & Nature",
    aliases: ["dog"],
    tags: ["pet"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐕",
    description: "dog",
    category: "Animals & Nature",
    aliases: ["dog2"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🦮",
    description: "guide dog",
    category: "Animals & Nature",
    aliases: ["guide_dog"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🐕‍🦺",
    description: "service dog",
    category: "Animals & Nature",
    aliases: ["service_dog"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🐩",
    description: "poodle",
    category: "Animals & Nature",
    aliases: ["poodle"],
    tags: ["dog"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐺",
    description: "wolf",
    category: "Animals & Nature",
    aliases: ["wolf"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🦊",
    description: "fox",
    category: "Animals & Nature",
    aliases: ["fox_face"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🦝",
    description: "raccoon",
    category: "Animals & Nature",
    aliases: ["raccoon"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🐱",
    description: "cat face",
    category: "Animals & Nature",
    aliases: ["cat"],
    tags: ["pet"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐈",
    description: "cat",
    category: "Animals & Nature",
    aliases: ["cat2"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐈‍⬛",
    description: "black cat",
    category: "Animals & Nature",
    aliases: ["black_cat"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🦁",
    description: "lion",
    category: "Animals & Nature",
    aliases: ["lion"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🐯",
    description: "tiger face",
    category: "Animals & Nature",
    aliases: ["tiger"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐅",
    description: "tiger",
    category: "Animals & Nature",
    aliases: ["tiger2"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐆",
    description: "leopard",
    category: "Animals & Nature",
    aliases: ["leopard"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐴",
    description: "horse face",
    category: "Animals & Nature",
    aliases: ["horse"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐎",
    description: "horse",
    category: "Animals & Nature",
    aliases: ["racehorse"],
    tags: ["speed"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🦄",
    description: "unicorn",
    category: "Animals & Nature",
    aliases: ["unicorn"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🦓",
    description: "zebra",
    category: "Animals & Nature",
    aliases: ["zebra"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🦌",
    description: "deer",
    category: "Animals & Nature",
    aliases: ["deer"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🦬",
    description: "bison",
    category: "Animals & Nature",
    aliases: ["bison"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🐮",
    description: "cow face",
    category: "Animals & Nature",
    aliases: ["cow"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐂",
    description: "ox",
    category: "Animals & Nature",
    aliases: ["ox"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐃",
    description: "water buffalo",
    category: "Animals & Nature",
    aliases: ["water_buffalo"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐄",
    description: "cow",
    category: "Animals & Nature",
    aliases: ["cow2"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐷",
    description: "pig face",
    category: "Animals & Nature",
    aliases: ["pig"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐖",
    description: "pig",
    category: "Animals & Nature",
    aliases: ["pig2"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐗",
    description: "boar",
    category: "Animals & Nature",
    aliases: ["boar"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐽",
    description: "pig nose",
    category: "Animals & Nature",
    aliases: ["pig_nose"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐏",
    description: "ram",
    category: "Animals & Nature",
    aliases: ["ram"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐑",
    description: "ewe",
    category: "Animals & Nature",
    aliases: ["sheep"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐐",
    description: "goat",
    category: "Animals & Nature",
    aliases: ["goat"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐪",
    description: "camel",
    category: "Animals & Nature",
    aliases: ["dromedary_camel"],
    tags: ["desert"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐫",
    description: "two-hump camel",
    category: "Animals & Nature",
    aliases: ["camel"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🦙",
    description: "llama",
    category: "Animals & Nature",
    aliases: ["llama"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🦒",
    description: "giraffe",
    category: "Animals & Nature",
    aliases: ["giraffe"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🐘",
    description: "elephant",
    category: "Animals & Nature",
    aliases: ["elephant"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🦣",
    description: "mammoth",
    category: "Animals & Nature",
    aliases: ["mammoth"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🦏",
    description: "rhinoceros",
    category: "Animals & Nature",
    aliases: ["rhinoceros"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🦛",
    description: "hippopotamus",
    category: "Animals & Nature",
    aliases: ["hippopotamus"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🐭",
    description: "mouse face",
    category: "Animals & Nature",
    aliases: ["mouse"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐁",
    description: "mouse",
    category: "Animals & Nature",
    aliases: ["mouse2"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐀",
    description: "rat",
    category: "Animals & Nature",
    aliases: ["rat"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐹",
    description: "hamster",
    category: "Animals & Nature",
    aliases: ["hamster"],
    tags: ["pet"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐰",
    description: "rabbit face",
    category: "Animals & Nature",
    aliases: ["rabbit"],
    tags: ["bunny"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐇",
    description: "rabbit",
    category: "Animals & Nature",
    aliases: ["rabbit2"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐿️",
    description: "chipmunk",
    category: "Animals & Nature",
    aliases: ["chipmunk"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🦫",
    description: "beaver",
    category: "Animals & Nature",
    aliases: ["beaver"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🦔",
    description: "hedgehog",
    category: "Animals & Nature",
    aliases: ["hedgehog"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🦇",
    description: "bat",
    category: "Animals & Nature",
    aliases: ["bat"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🐻",
    description: "bear",
    category: "Animals & Nature",
    aliases: ["bear"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐻‍❄️",
    description: "polar bear",
    category: "Animals & Nature",
    aliases: ["polar_bear"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🐨",
    description: "koala",
    category: "Animals & Nature",
    aliases: ["koala"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐼",
    description: "panda",
    category: "Animals & Nature",
    aliases: ["panda_face"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🦥",
    description: "sloth",
    category: "Animals & Nature",
    aliases: ["sloth"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🦦",
    description: "otter",
    category: "Animals & Nature",
    aliases: ["otter"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🦨",
    description: "skunk",
    category: "Animals & Nature",
    aliases: ["skunk"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🦘",
    description: "kangaroo",
    category: "Animals & Nature",
    aliases: ["kangaroo"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🦡",
    description: "badger",
    category: "Animals & Nature",
    aliases: ["badger"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🐾",
    description: "paw prints",
    category: "Animals & Nature",
    aliases: ["feet", "paw_prints"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🦃",
    description: "turkey",
    category: "Animals & Nature",
    aliases: ["turkey"],
    tags: ["thanksgiving"],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🐔",
    description: "chicken",
    category: "Animals & Nature",
    aliases: ["chicken"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐓",
    description: "rooster",
    category: "Animals & Nature",
    aliases: ["rooster"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐣",
    description: "hatching chick",
    category: "Animals & Nature",
    aliases: ["hatching_chick"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐤",
    description: "baby chick",
    category: "Animals & Nature",
    aliases: ["baby_chick"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐥",
    description: "front-facing baby chick",
    category: "Animals & Nature",
    aliases: ["hatched_chick"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐦",
    description: "bird",
    category: "Animals & Nature",
    aliases: ["bird"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐧",
    description: "penguin",
    category: "Animals & Nature",
    aliases: ["penguin"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕊️",
    description: "dove",
    category: "Animals & Nature",
    aliases: ["dove"],
    tags: ["peace"],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🦅",
    description: "eagle",
    category: "Animals & Nature",
    aliases: ["eagle"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🦆",
    description: "duck",
    category: "Animals & Nature",
    aliases: ["duck"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🦢",
    description: "swan",
    category: "Animals & Nature",
    aliases: ["swan"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🦉",
    description: "owl",
    category: "Animals & Nature",
    aliases: ["owl"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🦤",
    description: "dodo",
    category: "Animals & Nature",
    aliases: ["dodo"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🪶",
    description: "feather",
    category: "Animals & Nature",
    aliases: ["feather"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🦩",
    description: "flamingo",
    category: "Animals & Nature",
    aliases: ["flamingo"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🦚",
    description: "peacock",
    category: "Animals & Nature",
    aliases: ["peacock"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🦜",
    description: "parrot",
    category: "Animals & Nature",
    aliases: ["parrot"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🐸",
    description: "frog",
    category: "Animals & Nature",
    aliases: ["frog"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐊",
    description: "crocodile",
    category: "Animals & Nature",
    aliases: ["crocodile"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐢",
    description: "turtle",
    category: "Animals & Nature",
    aliases: ["turtle"],
    tags: ["slow"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🦎",
    description: "lizard",
    category: "Animals & Nature",
    aliases: ["lizard"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🐍",
    description: "snake",
    category: "Animals & Nature",
    aliases: ["snake"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐲",
    description: "dragon face",
    category: "Animals & Nature",
    aliases: ["dragon_face"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐉",
    description: "dragon",
    category: "Animals & Nature",
    aliases: ["dragon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🦕",
    description: "sauropod",
    category: "Animals & Nature",
    aliases: ["sauropod"],
    tags: ["dinosaur"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🦖",
    description: "T-Rex",
    category: "Animals & Nature",
    aliases: ["t-rex"],
    tags: ["dinosaur"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🐳",
    description: "spouting whale",
    category: "Animals & Nature",
    aliases: ["whale"],
    tags: ["sea"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐋",
    description: "whale",
    category: "Animals & Nature",
    aliases: ["whale2"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐬",
    description: "dolphin",
    category: "Animals & Nature",
    aliases: ["dolphin", "flipper"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🦭",
    description: "seal",
    category: "Animals & Nature",
    aliases: ["seal"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🐟",
    description: "fish",
    category: "Animals & Nature",
    aliases: ["fish"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐠",
    description: "tropical fish",
    category: "Animals & Nature",
    aliases: ["tropical_fish"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐡",
    description: "blowfish",
    category: "Animals & Nature",
    aliases: ["blowfish"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🦈",
    description: "shark",
    category: "Animals & Nature",
    aliases: ["shark"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🐙",
    description: "octopus",
    category: "Animals & Nature",
    aliases: ["octopus"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐚",
    description: "spiral shell",
    category: "Animals & Nature",
    aliases: ["shell"],
    tags: ["sea", "beach"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐌",
    description: "snail",
    category: "Animals & Nature",
    aliases: ["snail"],
    tags: ["slow"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🦋",
    description: "butterfly",
    category: "Animals & Nature",
    aliases: ["butterfly"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🐛",
    description: "bug",
    category: "Animals & Nature",
    aliases: ["bug"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐜",
    description: "ant",
    category: "Animals & Nature",
    aliases: ["ant"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🐝",
    description: "honeybee",
    category: "Animals & Nature",
    aliases: ["bee", "honeybee"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🪲",
    description: "beetle",
    category: "Animals & Nature",
    aliases: ["beetle"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🐞",
    description: "lady beetle",
    category: "Animals & Nature",
    aliases: ["lady_beetle"],
    tags: ["bug"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🦗",
    description: "cricket",
    category: "Animals & Nature",
    aliases: ["cricket"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🪳",
    description: "cockroach",
    category: "Animals & Nature",
    aliases: ["cockroach"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🕷️",
    description: "spider",
    category: "Animals & Nature",
    aliases: ["spider"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🕸️",
    description: "spider web",
    category: "Animals & Nature",
    aliases: ["spider_web"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🦂",
    description: "scorpion",
    category: "Animals & Nature",
    aliases: ["scorpion"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🦟",
    description: "mosquito",
    category: "Animals & Nature",
    aliases: ["mosquito"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🪰",
    description: "fly",
    category: "Animals & Nature",
    aliases: ["fly"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🪱",
    description: "worm",
    category: "Animals & Nature",
    aliases: ["worm"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🦠",
    description: "microbe",
    category: "Animals & Nature",
    aliases: ["microbe"],
    tags: ["germ"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "💐",
    description: "bouquet",
    category: "Animals & Nature",
    aliases: ["bouquet"],
    tags: ["flowers"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌸",
    description: "cherry blossom",
    category: "Animals & Nature",
    aliases: ["cherry_blossom"],
    tags: ["flower", "spring"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💮",
    description: "white flower",
    category: "Animals & Nature",
    aliases: ["white_flower"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏵️",
    description: "rosette",
    category: "Animals & Nature",
    aliases: ["rosette"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🌹",
    description: "rose",
    category: "Animals & Nature",
    aliases: ["rose"],
    tags: ["flower"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥀",
    description: "wilted flower",
    category: "Animals & Nature",
    aliases: ["wilted_flower"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🌺",
    description: "hibiscus",
    category: "Animals & Nature",
    aliases: ["hibiscus"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌻",
    description: "sunflower",
    category: "Animals & Nature",
    aliases: ["sunflower"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌼",
    description: "blossom",
    category: "Animals & Nature",
    aliases: ["blossom"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌷",
    description: "tulip",
    category: "Animals & Nature",
    aliases: ["tulip"],
    tags: ["flower"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌱",
    description: "seedling",
    category: "Animals & Nature",
    aliases: ["seedling"],
    tags: ["plant"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🪴",
    description: "potted plant",
    category: "Animals & Nature",
    aliases: ["potted_plant"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🌲",
    description: "evergreen tree",
    category: "Animals & Nature",
    aliases: ["evergreen_tree"],
    tags: ["wood"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌳",
    description: "deciduous tree",
    category: "Animals & Nature",
    aliases: ["deciduous_tree"],
    tags: ["wood"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌴",
    description: "palm tree",
    category: "Animals & Nature",
    aliases: ["palm_tree"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌵",
    description: "cactus",
    category: "Animals & Nature",
    aliases: ["cactus"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌾",
    description: "sheaf of rice",
    category: "Animals & Nature",
    aliases: ["ear_of_rice"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌿",
    description: "herb",
    category: "Animals & Nature",
    aliases: ["herb"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "☘️",
    description: "shamrock",
    category: "Animals & Nature",
    aliases: ["shamrock"],
    tags: [],
    unicode_version: "4.1",
    ios_version: "9.1"
  },
  {
    emoji: "🍀",
    description: "four leaf clover",
    category: "Animals & Nature",
    aliases: ["four_leaf_clover"],
    tags: ["luck"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍁",
    description: "maple leaf",
    category: "Animals & Nature",
    aliases: ["maple_leaf"],
    tags: ["canada"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍂",
    description: "fallen leaf",
    category: "Animals & Nature",
    aliases: ["fallen_leaf"],
    tags: ["autumn"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍃",
    description: "leaf fluttering in wind",
    category: "Animals & Nature",
    aliases: ["leaves"],
    tags: ["leaf"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍇",
    description: "grapes",
    category: "Food & Drink",
    aliases: ["grapes"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍈",
    description: "melon",
    category: "Food & Drink",
    aliases: ["melon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍉",
    description: "watermelon",
    category: "Food & Drink",
    aliases: ["watermelon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍊",
    description: "tangerine",
    category: "Food & Drink",
    aliases: ["tangerine", "orange", "mandarin"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍋",
    description: "lemon",
    category: "Food & Drink",
    aliases: ["lemon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍌",
    description: "banana",
    category: "Food & Drink",
    aliases: ["banana"],
    tags: ["fruit"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍍",
    description: "pineapple",
    category: "Food & Drink",
    aliases: ["pineapple"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥭",
    description: "mango",
    category: "Food & Drink",
    aliases: ["mango"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🍎",
    description: "red apple",
    category: "Food & Drink",
    aliases: ["apple"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍏",
    description: "green apple",
    category: "Food & Drink",
    aliases: ["green_apple"],
    tags: ["fruit"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍐",
    description: "pear",
    category: "Food & Drink",
    aliases: ["pear"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍑",
    description: "peach",
    category: "Food & Drink",
    aliases: ["peach"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍒",
    description: "cherries",
    category: "Food & Drink",
    aliases: ["cherries"],
    tags: ["fruit"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍓",
    description: "strawberry",
    category: "Food & Drink",
    aliases: ["strawberry"],
    tags: ["fruit"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🫐",
    description: "blueberries",
    category: "Food & Drink",
    aliases: ["blueberries"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🥝",
    description: "kiwi fruit",
    category: "Food & Drink",
    aliases: ["kiwi_fruit"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🍅",
    description: "tomato",
    category: "Food & Drink",
    aliases: ["tomato"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🫒",
    description: "olive",
    category: "Food & Drink",
    aliases: ["olive"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🥥",
    description: "coconut",
    category: "Food & Drink",
    aliases: ["coconut"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🥑",
    description: "avocado",
    category: "Food & Drink",
    aliases: ["avocado"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🍆",
    description: "eggplant",
    category: "Food & Drink",
    aliases: ["eggplant"],
    tags: ["aubergine"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥔",
    description: "potato",
    category: "Food & Drink",
    aliases: ["potato"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🥕",
    description: "carrot",
    category: "Food & Drink",
    aliases: ["carrot"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🌽",
    description: "ear of corn",
    category: "Food & Drink",
    aliases: ["corn"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌶️",
    description: "hot pepper",
    category: "Food & Drink",
    aliases: ["hot_pepper"],
    tags: ["spicy"],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🫑",
    description: "bell pepper",
    category: "Food & Drink",
    aliases: ["bell_pepper"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🥒",
    description: "cucumber",
    category: "Food & Drink",
    aliases: ["cucumber"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🥬",
    description: "leafy green",
    category: "Food & Drink",
    aliases: ["leafy_green"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🥦",
    description: "broccoli",
    category: "Food & Drink",
    aliases: ["broccoli"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧄",
    description: "garlic",
    category: "Food & Drink",
    aliases: ["garlic"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🧅",
    description: "onion",
    category: "Food & Drink",
    aliases: ["onion"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🍄",
    description: "mushroom",
    category: "Food & Drink",
    aliases: ["mushroom"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥜",
    description: "peanuts",
    category: "Food & Drink",
    aliases: ["peanuts"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🌰",
    description: "chestnut",
    category: "Food & Drink",
    aliases: ["chestnut"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍞",
    description: "bread",
    category: "Food & Drink",
    aliases: ["bread"],
    tags: ["toast"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥐",
    description: "croissant",
    category: "Food & Drink",
    aliases: ["croissant"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🥖",
    description: "baguette bread",
    category: "Food & Drink",
    aliases: ["baguette_bread"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🫓",
    description: "flatbread",
    category: "Food & Drink",
    aliases: ["flatbread"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🥨",
    description: "pretzel",
    category: "Food & Drink",
    aliases: ["pretzel"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🥯",
    description: "bagel",
    category: "Food & Drink",
    aliases: ["bagel"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🥞",
    description: "pancakes",
    category: "Food & Drink",
    aliases: ["pancakes"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🧇",
    description: "waffle",
    category: "Food & Drink",
    aliases: ["waffle"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🧀",
    description: "cheese wedge",
    category: "Food & Drink",
    aliases: ["cheese"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🍖",
    description: "meat on bone",
    category: "Food & Drink",
    aliases: ["meat_on_bone"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍗",
    description: "poultry leg",
    category: "Food & Drink",
    aliases: ["poultry_leg"],
    tags: ["meat", "chicken"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥩",
    description: "cut of meat",
    category: "Food & Drink",
    aliases: ["cut_of_meat"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🥓",
    description: "bacon",
    category: "Food & Drink",
    aliases: ["bacon"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🍔",
    description: "hamburger",
    category: "Food & Drink",
    aliases: ["hamburger"],
    tags: ["burger"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍟",
    description: "french fries",
    category: "Food & Drink",
    aliases: ["fries"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍕",
    description: "pizza",
    category: "Food & Drink",
    aliases: ["pizza"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌭",
    description: "hot dog",
    category: "Food & Drink",
    aliases: ["hotdog"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🥪",
    description: "sandwich",
    category: "Food & Drink",
    aliases: ["sandwich"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🌮",
    description: "taco",
    category: "Food & Drink",
    aliases: ["taco"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🌯",
    description: "burrito",
    category: "Food & Drink",
    aliases: ["burrito"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🫔",
    description: "tamale",
    category: "Food & Drink",
    aliases: ["tamale"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🥙",
    description: "stuffed flatbread",
    category: "Food & Drink",
    aliases: ["stuffed_flatbread"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🧆",
    description: "falafel",
    category: "Food & Drink",
    aliases: ["falafel"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🥚",
    description: "egg",
    category: "Food & Drink",
    aliases: ["egg"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🍳",
    description: "cooking",
    category: "Food & Drink",
    aliases: ["fried_egg"],
    tags: ["breakfast"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥘",
    description: "shallow pan of food",
    category: "Food & Drink",
    aliases: ["shallow_pan_of_food"],
    tags: ["paella", "curry"],
    unicode_version: "",
    ios_version: "10.2"
  },
  {
    emoji: "🍲",
    description: "pot of food",
    category: "Food & Drink",
    aliases: ["stew"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🫕",
    description: "fondue",
    category: "Food & Drink",
    aliases: ["fondue"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🥣",
    description: "bowl with spoon",
    category: "Food & Drink",
    aliases: ["bowl_with_spoon"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🥗",
    description: "green salad",
    category: "Food & Drink",
    aliases: ["green_salad"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🍿",
    description: "popcorn",
    category: "Food & Drink",
    aliases: ["popcorn"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🧈",
    description: "butter",
    category: "Food & Drink",
    aliases: ["butter"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🧂",
    description: "salt",
    category: "Food & Drink",
    aliases: ["salt"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🥫",
    description: "canned food",
    category: "Food & Drink",
    aliases: ["canned_food"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🍱",
    description: "bento box",
    category: "Food & Drink",
    aliases: ["bento"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍘",
    description: "rice cracker",
    category: "Food & Drink",
    aliases: ["rice_cracker"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍙",
    description: "rice ball",
    category: "Food & Drink",
    aliases: ["rice_ball"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍚",
    description: "cooked rice",
    category: "Food & Drink",
    aliases: ["rice"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍛",
    description: "curry rice",
    category: "Food & Drink",
    aliases: ["curry"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍜",
    description: "steaming bowl",
    category: "Food & Drink",
    aliases: ["ramen"],
    tags: ["noodle"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍝",
    description: "spaghetti",
    category: "Food & Drink",
    aliases: ["spaghetti"],
    tags: ["pasta"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍠",
    description: "roasted sweet potato",
    category: "Food & Drink",
    aliases: ["sweet_potato"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍢",
    description: "oden",
    category: "Food & Drink",
    aliases: ["oden"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍣",
    description: "sushi",
    category: "Food & Drink",
    aliases: ["sushi"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍤",
    description: "fried shrimp",
    category: "Food & Drink",
    aliases: ["fried_shrimp"],
    tags: ["tempura"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍥",
    description: "fish cake with swirl",
    category: "Food & Drink",
    aliases: ["fish_cake"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥮",
    description: "moon cake",
    category: "Food & Drink",
    aliases: ["moon_cake"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🍡",
    description: "dango",
    category: "Food & Drink",
    aliases: ["dango"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥟",
    description: "dumpling",
    category: "Food & Drink",
    aliases: ["dumpling"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🥠",
    description: "fortune cookie",
    category: "Food & Drink",
    aliases: ["fortune_cookie"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🥡",
    description: "takeout box",
    category: "Food & Drink",
    aliases: ["takeout_box"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🦀",
    description: "crab",
    category: "Food & Drink",
    aliases: ["crab"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🦞",
    description: "lobster",
    category: "Food & Drink",
    aliases: ["lobster"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🦐",
    description: "shrimp",
    category: "Food & Drink",
    aliases: ["shrimp"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🦑",
    description: "squid",
    category: "Food & Drink",
    aliases: ["squid"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🦪",
    description: "oyster",
    category: "Food & Drink",
    aliases: ["oyster"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🍦",
    description: "soft ice cream",
    category: "Food & Drink",
    aliases: ["icecream"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍧",
    description: "shaved ice",
    category: "Food & Drink",
    aliases: ["shaved_ice"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍨",
    description: "ice cream",
    category: "Food & Drink",
    aliases: ["ice_cream"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍩",
    description: "doughnut",
    category: "Food & Drink",
    aliases: ["doughnut"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍪",
    description: "cookie",
    category: "Food & Drink",
    aliases: ["cookie"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎂",
    description: "birthday cake",
    category: "Food & Drink",
    aliases: ["birthday"],
    tags: ["party"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍰",
    description: "shortcake",
    category: "Food & Drink",
    aliases: ["cake"],
    tags: ["dessert"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🧁",
    description: "cupcake",
    category: "Food & Drink",
    aliases: ["cupcake"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🥧",
    description: "pie",
    category: "Food & Drink",
    aliases: ["pie"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🍫",
    description: "chocolate bar",
    category: "Food & Drink",
    aliases: ["chocolate_bar"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍬",
    description: "candy",
    category: "Food & Drink",
    aliases: ["candy"],
    tags: ["sweet"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍭",
    description: "lollipop",
    category: "Food & Drink",
    aliases: ["lollipop"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍮",
    description: "custard",
    category: "Food & Drink",
    aliases: ["custard"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍯",
    description: "honey pot",
    category: "Food & Drink",
    aliases: ["honey_pot"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍼",
    description: "baby bottle",
    category: "Food & Drink",
    aliases: ["baby_bottle"],
    tags: ["milk"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥛",
    description: "glass of milk",
    category: "Food & Drink",
    aliases: ["milk_glass"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "☕",
    description: "hot beverage",
    category: "Food & Drink",
    aliases: ["coffee"],
    tags: ["cafe", "espresso"],
    unicode_version: "4.0",
    ios_version: "6.0"
  },
  {
    emoji: "🫖",
    description: "teapot",
    category: "Food & Drink",
    aliases: ["teapot"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🍵",
    description: "teacup without handle",
    category: "Food & Drink",
    aliases: ["tea"],
    tags: ["green", "breakfast"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍶",
    description: "sake",
    category: "Food & Drink",
    aliases: ["sake"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍾",
    description: "bottle with popping cork",
    category: "Food & Drink",
    aliases: ["champagne"],
    tags: ["bottle", "bubbly", "celebration"],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🍷",
    description: "wine glass",
    category: "Food & Drink",
    aliases: ["wine_glass"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍸",
    description: "cocktail glass",
    category: "Food & Drink",
    aliases: ["cocktail"],
    tags: ["drink"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍹",
    description: "tropical drink",
    category: "Food & Drink",
    aliases: ["tropical_drink"],
    tags: ["summer", "vacation"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍺",
    description: "beer mug",
    category: "Food & Drink",
    aliases: ["beer"],
    tags: ["drink"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🍻",
    description: "clinking beer mugs",
    category: "Food & Drink",
    aliases: ["beers"],
    tags: ["drinks"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥂",
    description: "clinking glasses",
    category: "Food & Drink",
    aliases: ["clinking_glasses"],
    tags: ["cheers", "toast"],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🥃",
    description: "tumbler glass",
    category: "Food & Drink",
    aliases: ["tumbler_glass"],
    tags: ["whisky"],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🥤",
    description: "cup with straw",
    category: "Food & Drink",
    aliases: ["cup_with_straw"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧋",
    description: "bubble tea",
    category: "Food & Drink",
    aliases: ["bubble_tea"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🧃",
    description: "beverage box",
    category: "Food & Drink",
    aliases: ["beverage_box"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🧉",
    description: "mate",
    category: "Food & Drink",
    aliases: ["mate"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🧊",
    description: "ice",
    category: "Food & Drink",
    aliases: ["ice_cube"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🥢",
    description: "chopsticks",
    category: "Food & Drink",
    aliases: ["chopsticks"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🍽️",
    description: "fork and knife with plate",
    category: "Food & Drink",
    aliases: ["plate_with_cutlery"],
    tags: ["dining", "dinner"],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🍴",
    description: "fork and knife",
    category: "Food & Drink",
    aliases: ["fork_and_knife"],
    tags: ["cutlery"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥄",
    description: "spoon",
    category: "Food & Drink",
    aliases: ["spoon"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🔪",
    description: "kitchen knife",
    category: "Food & Drink",
    aliases: ["hocho", "knife"],
    tags: ["cut", "chop"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏺",
    description: "amphora",
    category: "Food & Drink",
    aliases: ["amphora"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🌍",
    description: "globe showing Europe-Africa",
    category: "Travel & Places",
    aliases: ["earth_africa"],
    tags: ["globe", "world", "international"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌎",
    description: "globe showing Americas",
    category: "Travel & Places",
    aliases: ["earth_americas"],
    tags: ["globe", "world", "international"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌏",
    description: "globe showing Asia-Australia",
    category: "Travel & Places",
    aliases: ["earth_asia"],
    tags: ["globe", "world", "international"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌐",
    description: "globe with meridians",
    category: "Travel & Places",
    aliases: ["globe_with_meridians"],
    tags: ["world", "global", "international"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🗺️",
    description: "world map",
    category: "Travel & Places",
    aliases: ["world_map"],
    tags: ["travel"],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🗾",
    description: "map of Japan",
    category: "Travel & Places",
    aliases: ["japan"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🧭",
    description: "compass",
    category: "Travel & Places",
    aliases: ["compass"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🏔️",
    description: "snow-capped mountain",
    category: "Travel & Places",
    aliases: ["mountain_snow"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "⛰️",
    description: "mountain",
    category: "Travel & Places",
    aliases: ["mountain"],
    tags: [],
    unicode_version: "5.2",
    ios_version: "9.1"
  },
  {
    emoji: "🌋",
    description: "volcano",
    category: "Travel & Places",
    aliases: ["volcano"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🗻",
    description: "mount fuji",
    category: "Travel & Places",
    aliases: ["mount_fuji"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏕️",
    description: "camping",
    category: "Travel & Places",
    aliases: ["camping"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🏖️",
    description: "beach with umbrella",
    category: "Travel & Places",
    aliases: ["beach_umbrella"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🏜️",
    description: "desert",
    category: "Travel & Places",
    aliases: ["desert"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🏝️",
    description: "desert island",
    category: "Travel & Places",
    aliases: ["desert_island"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🏞️",
    description: "national park",
    category: "Travel & Places",
    aliases: ["national_park"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🏟️",
    description: "stadium",
    category: "Travel & Places",
    aliases: ["stadium"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🏛️",
    description: "classical building",
    category: "Travel & Places",
    aliases: ["classical_building"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🏗️",
    description: "building construction",
    category: "Travel & Places",
    aliases: ["building_construction"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🧱",
    description: "brick",
    category: "Travel & Places",
    aliases: ["bricks"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🪨",
    description: "rock",
    category: "Travel & Places",
    aliases: ["rock"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🪵",
    description: "wood",
    category: "Travel & Places",
    aliases: ["wood"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🛖",
    description: "hut",
    category: "Travel & Places",
    aliases: ["hut"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🏘️",
    description: "houses",
    category: "Travel & Places",
    aliases: ["houses"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🏚️",
    description: "derelict house",
    category: "Travel & Places",
    aliases: ["derelict_house"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🏠",
    description: "house",
    category: "Travel & Places",
    aliases: ["house"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏡",
    description: "house with garden",
    category: "Travel & Places",
    aliases: ["house_with_garden"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏢",
    description: "office building",
    category: "Travel & Places",
    aliases: ["office"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏣",
    description: "Japanese post office",
    category: "Travel & Places",
    aliases: ["post_office"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏤",
    description: "post office",
    category: "Travel & Places",
    aliases: ["european_post_office"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏥",
    description: "hospital",
    category: "Travel & Places",
    aliases: ["hospital"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏦",
    description: "bank",
    category: "Travel & Places",
    aliases: ["bank"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏨",
    description: "hotel",
    category: "Travel & Places",
    aliases: ["hotel"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏩",
    description: "love hotel",
    category: "Travel & Places",
    aliases: ["love_hotel"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏪",
    description: "convenience store",
    category: "Travel & Places",
    aliases: ["convenience_store"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏫",
    description: "school",
    category: "Travel & Places",
    aliases: ["school"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏬",
    description: "department store",
    category: "Travel & Places",
    aliases: ["department_store"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏭",
    description: "factory",
    category: "Travel & Places",
    aliases: ["factory"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏯",
    description: "Japanese castle",
    category: "Travel & Places",
    aliases: ["japanese_castle"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏰",
    description: "castle",
    category: "Travel & Places",
    aliases: ["european_castle"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💒",
    description: "wedding",
    category: "Travel & Places",
    aliases: ["wedding"],
    tags: ["marriage"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🗼",
    description: "Tokyo tower",
    category: "Travel & Places",
    aliases: ["tokyo_tower"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🗽",
    description: "Statue of Liberty",
    category: "Travel & Places",
    aliases: ["statue_of_liberty"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "⛪",
    description: "church",
    category: "Travel & Places",
    aliases: ["church"],
    tags: [],
    unicode_version: "5.2",
    ios_version: "6.0"
  },
  {
    emoji: "🕌",
    description: "mosque",
    category: "Travel & Places",
    aliases: ["mosque"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🛕",
    description: "hindu temple",
    category: "Travel & Places",
    aliases: ["hindu_temple"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🕍",
    description: "synagogue",
    category: "Travel & Places",
    aliases: ["synagogue"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "⛩️",
    description: "shinto shrine",
    category: "Travel & Places",
    aliases: ["shinto_shrine"],
    tags: [],
    unicode_version: "5.2",
    ios_version: "9.1"
  },
  {
    emoji: "🕋",
    description: "kaaba",
    category: "Travel & Places",
    aliases: ["kaaba"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "⛲",
    description: "fountain",
    category: "Travel & Places",
    aliases: ["fountain"],
    tags: [],
    unicode_version: "5.2",
    ios_version: "6.0"
  },
  {
    emoji: "⛺",
    description: "tent",
    category: "Travel & Places",
    aliases: ["tent"],
    tags: ["camping"],
    unicode_version: "5.2",
    ios_version: "6.0"
  },
  {
    emoji: "🌁",
    description: "foggy",
    category: "Travel & Places",
    aliases: ["foggy"],
    tags: ["karl"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌃",
    description: "night with stars",
    category: "Travel & Places",
    aliases: ["night_with_stars"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏙️",
    description: "cityscape",
    category: "Travel & Places",
    aliases: ["cityscape"],
    tags: ["skyline"],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🌄",
    description: "sunrise over mountains",
    category: "Travel & Places",
    aliases: ["sunrise_over_mountains"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌅",
    description: "sunrise",
    category: "Travel & Places",
    aliases: ["sunrise"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌆",
    description: "cityscape at dusk",
    category: "Travel & Places",
    aliases: ["city_sunset"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌇",
    description: "sunset",
    category: "Travel & Places",
    aliases: ["city_sunrise"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌉",
    description: "bridge at night",
    category: "Travel & Places",
    aliases: ["bridge_at_night"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "♨️",
    description: "hot springs",
    category: "Travel & Places",
    aliases: ["hotsprings"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "🎠",
    description: "carousel horse",
    category: "Travel & Places",
    aliases: ["carousel_horse"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎡",
    description: "ferris wheel",
    category: "Travel & Places",
    aliases: ["ferris_wheel"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎢",
    description: "roller coaster",
    category: "Travel & Places",
    aliases: ["roller_coaster"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💈",
    description: "barber pole",
    category: "Travel & Places",
    aliases: ["barber"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎪",
    description: "circus tent",
    category: "Travel & Places",
    aliases: ["circus_tent"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚂",
    description: "locomotive",
    category: "Travel & Places",
    aliases: ["steam_locomotive"],
    tags: ["train"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚃",
    description: "railway car",
    category: "Travel & Places",
    aliases: ["railway_car"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚄",
    description: "high-speed train",
    category: "Travel & Places",
    aliases: ["bullettrain_side"],
    tags: ["train"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚅",
    description: "bullet train",
    category: "Travel & Places",
    aliases: ["bullettrain_front"],
    tags: ["train"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚆",
    description: "train",
    category: "Travel & Places",
    aliases: ["train2"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚇",
    description: "metro",
    category: "Travel & Places",
    aliases: ["metro"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚈",
    description: "light rail",
    category: "Travel & Places",
    aliases: ["light_rail"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚉",
    description: "station",
    category: "Travel & Places",
    aliases: ["station"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚊",
    description: "tram",
    category: "Travel & Places",
    aliases: ["tram"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚝",
    description: "monorail",
    category: "Travel & Places",
    aliases: ["monorail"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚞",
    description: "mountain railway",
    category: "Travel & Places",
    aliases: ["mountain_railway"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚋",
    description: "tram car",
    category: "Travel & Places",
    aliases: ["train"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚌",
    description: "bus",
    category: "Travel & Places",
    aliases: ["bus"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚍",
    description: "oncoming bus",
    category: "Travel & Places",
    aliases: ["oncoming_bus"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚎",
    description: "trolleybus",
    category: "Travel & Places",
    aliases: ["trolleybus"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚐",
    description: "minibus",
    category: "Travel & Places",
    aliases: ["minibus"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚑",
    description: "ambulance",
    category: "Travel & Places",
    aliases: ["ambulance"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚒",
    description: "fire engine",
    category: "Travel & Places",
    aliases: ["fire_engine"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚓",
    description: "police car",
    category: "Travel & Places",
    aliases: ["police_car"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚔",
    description: "oncoming police car",
    category: "Travel & Places",
    aliases: ["oncoming_police_car"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚕",
    description: "taxi",
    category: "Travel & Places",
    aliases: ["taxi"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚖",
    description: "oncoming taxi",
    category: "Travel & Places",
    aliases: ["oncoming_taxi"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚗",
    description: "automobile",
    category: "Travel & Places",
    aliases: ["car", "red_car"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚘",
    description: "oncoming automobile",
    category: "Travel & Places",
    aliases: ["oncoming_automobile"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚙",
    description: "sport utility vehicle",
    category: "Travel & Places",
    aliases: ["blue_car"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🛻",
    description: "pickup truck",
    category: "Travel & Places",
    aliases: ["pickup_truck"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🚚",
    description: "delivery truck",
    category: "Travel & Places",
    aliases: ["truck"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚛",
    description: "articulated lorry",
    category: "Travel & Places",
    aliases: ["articulated_lorry"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚜",
    description: "tractor",
    category: "Travel & Places",
    aliases: ["tractor"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏎️",
    description: "racing car",
    category: "Travel & Places",
    aliases: ["racing_car"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🏍️",
    description: "motorcycle",
    category: "Travel & Places",
    aliases: ["motorcycle"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🛵",
    description: "motor scooter",
    category: "Travel & Places",
    aliases: ["motor_scooter"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🦽",
    description: "manual wheelchair",
    category: "Travel & Places",
    aliases: ["manual_wheelchair"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🦼",
    description: "motorized wheelchair",
    category: "Travel & Places",
    aliases: ["motorized_wheelchair"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🛺",
    description: "auto rickshaw",
    category: "Travel & Places",
    aliases: ["auto_rickshaw"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🚲",
    description: "bicycle",
    category: "Travel & Places",
    aliases: ["bike"],
    tags: ["bicycle"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🛴",
    description: "kick scooter",
    category: "Travel & Places",
    aliases: ["kick_scooter"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🛹",
    description: "skateboard",
    category: "Travel & Places",
    aliases: ["skateboard"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🛼",
    description: "roller skate",
    category: "Travel & Places",
    aliases: ["roller_skate"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🚏",
    description: "bus stop",
    category: "Travel & Places",
    aliases: ["busstop"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🛣️",
    description: "motorway",
    category: "Travel & Places",
    aliases: ["motorway"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🛤️",
    description: "railway track",
    category: "Travel & Places",
    aliases: ["railway_track"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🛢️",
    description: "oil drum",
    category: "Travel & Places",
    aliases: ["oil_drum"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "⛽",
    description: "fuel pump",
    category: "Travel & Places",
    aliases: ["fuelpump"],
    tags: [],
    unicode_version: "5.2",
    ios_version: "6.0"
  },
  {
    emoji: "🚨",
    description: "police car light",
    category: "Travel & Places",
    aliases: ["rotating_light"],
    tags: ["911", "emergency"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚥",
    description: "horizontal traffic light",
    category: "Travel & Places",
    aliases: ["traffic_light"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚦",
    description: "vertical traffic light",
    category: "Travel & Places",
    aliases: ["vertical_traffic_light"],
    tags: ["semaphore"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🛑",
    description: "stop sign",
    category: "Travel & Places",
    aliases: ["stop_sign"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🚧",
    description: "construction",
    category: "Travel & Places",
    aliases: ["construction"],
    tags: ["wip"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "⚓",
    description: "anchor",
    category: "Travel & Places",
    aliases: ["anchor"],
    tags: ["ship"],
    unicode_version: "4.1",
    ios_version: "6.0"
  },
  {
    emoji: "⛵",
    description: "sailboat",
    category: "Travel & Places",
    aliases: ["boat", "sailboat"],
    tags: [],
    unicode_version: "5.2",
    ios_version: "6.0"
  },
  {
    emoji: "🛶",
    description: "canoe",
    category: "Travel & Places",
    aliases: ["canoe"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🚤",
    description: "speedboat",
    category: "Travel & Places",
    aliases: ["speedboat"],
    tags: ["ship"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🛳️",
    description: "passenger ship",
    category: "Travel & Places",
    aliases: ["passenger_ship"],
    tags: ["cruise"],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "⛴️",
    description: "ferry",
    category: "Travel & Places",
    aliases: ["ferry"],
    tags: [],
    unicode_version: "5.2",
    ios_version: "9.1"
  },
  {
    emoji: "🛥️",
    description: "motor boat",
    category: "Travel & Places",
    aliases: ["motor_boat"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🚢",
    description: "ship",
    category: "Travel & Places",
    aliases: ["ship"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "✈️",
    description: "airplane",
    category: "Travel & Places",
    aliases: ["airplane"],
    tags: ["flight"],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "🛩️",
    description: "small airplane",
    category: "Travel & Places",
    aliases: ["small_airplane"],
    tags: ["flight"],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🛫",
    description: "airplane departure",
    category: "Travel & Places",
    aliases: ["flight_departure"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🛬",
    description: "airplane arrival",
    category: "Travel & Places",
    aliases: ["flight_arrival"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🪂",
    description: "parachute",
    category: "Travel & Places",
    aliases: ["parachute"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "💺",
    description: "seat",
    category: "Travel & Places",
    aliases: ["seat"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚁",
    description: "helicopter",
    category: "Travel & Places",
    aliases: ["helicopter"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚟",
    description: "suspension railway",
    category: "Travel & Places",
    aliases: ["suspension_railway"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚠",
    description: "mountain cableway",
    category: "Travel & Places",
    aliases: ["mountain_cableway"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚡",
    description: "aerial tramway",
    category: "Travel & Places",
    aliases: ["aerial_tramway"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🛰️",
    description: "satellite",
    category: "Travel & Places",
    aliases: ["artificial_satellite"],
    tags: ["orbit", "space"],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🚀",
    description: "rocket",
    category: "Travel & Places",
    aliases: ["rocket"],
    tags: ["ship", "launch"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🛸",
    description: "flying saucer",
    category: "Travel & Places",
    aliases: ["flying_saucer"],
    tags: ["ufo"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🛎️",
    description: "bellhop bell",
    category: "Travel & Places",
    aliases: ["bellhop_bell"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🧳",
    description: "luggage",
    category: "Travel & Places",
    aliases: ["luggage"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "⌛",
    description: "hourglass done",
    category: "Travel & Places",
    aliases: ["hourglass"],
    tags: ["time"],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "⏳",
    description: "hourglass not done",
    category: "Travel & Places",
    aliases: ["hourglass_flowing_sand"],
    tags: ["time"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "⌚",
    description: "watch",
    category: "Travel & Places",
    aliases: ["watch"],
    tags: ["time"],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "⏰",
    description: "alarm clock",
    category: "Travel & Places",
    aliases: ["alarm_clock"],
    tags: ["morning"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "⏱️",
    description: "stopwatch",
    category: "Travel & Places",
    aliases: ["stopwatch"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.1"
  },
  {
    emoji: "⏲️",
    description: "timer clock",
    category: "Travel & Places",
    aliases: ["timer_clock"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.1"
  },
  {
    emoji: "🕰️",
    description: "mantelpiece clock",
    category: "Travel & Places",
    aliases: ["mantelpiece_clock"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🕛",
    description: "twelve o’clock",
    category: "Travel & Places",
    aliases: ["clock12"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕧",
    description: "twelve-thirty",
    category: "Travel & Places",
    aliases: ["clock1230"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕐",
    description: "one o’clock",
    category: "Travel & Places",
    aliases: ["clock1"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕜",
    description: "one-thirty",
    category: "Travel & Places",
    aliases: ["clock130"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕑",
    description: "two o’clock",
    category: "Travel & Places",
    aliases: ["clock2"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕝",
    description: "two-thirty",
    category: "Travel & Places",
    aliases: ["clock230"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕒",
    description: "three o’clock",
    category: "Travel & Places",
    aliases: ["clock3"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕞",
    description: "three-thirty",
    category: "Travel & Places",
    aliases: ["clock330"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕓",
    description: "four o’clock",
    category: "Travel & Places",
    aliases: ["clock4"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕟",
    description: "four-thirty",
    category: "Travel & Places",
    aliases: ["clock430"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕔",
    description: "five o’clock",
    category: "Travel & Places",
    aliases: ["clock5"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕠",
    description: "five-thirty",
    category: "Travel & Places",
    aliases: ["clock530"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕕",
    description: "six o’clock",
    category: "Travel & Places",
    aliases: ["clock6"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕡",
    description: "six-thirty",
    category: "Travel & Places",
    aliases: ["clock630"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕖",
    description: "seven o’clock",
    category: "Travel & Places",
    aliases: ["clock7"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕢",
    description: "seven-thirty",
    category: "Travel & Places",
    aliases: ["clock730"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕗",
    description: "eight o’clock",
    category: "Travel & Places",
    aliases: ["clock8"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕣",
    description: "eight-thirty",
    category: "Travel & Places",
    aliases: ["clock830"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕘",
    description: "nine o’clock",
    category: "Travel & Places",
    aliases: ["clock9"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕤",
    description: "nine-thirty",
    category: "Travel & Places",
    aliases: ["clock930"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕙",
    description: "ten o’clock",
    category: "Travel & Places",
    aliases: ["clock10"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕥",
    description: "ten-thirty",
    category: "Travel & Places",
    aliases: ["clock1030"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕚",
    description: "eleven o’clock",
    category: "Travel & Places",
    aliases: ["clock11"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕦",
    description: "eleven-thirty",
    category: "Travel & Places",
    aliases: ["clock1130"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌑",
    description: "new moon",
    category: "Travel & Places",
    aliases: ["new_moon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌒",
    description: "waxing crescent moon",
    category: "Travel & Places",
    aliases: ["waxing_crescent_moon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌓",
    description: "first quarter moon",
    category: "Travel & Places",
    aliases: ["first_quarter_moon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌔",
    description: "waxing gibbous moon",
    category: "Travel & Places",
    aliases: ["moon", "waxing_gibbous_moon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌕",
    description: "full moon",
    category: "Travel & Places",
    aliases: ["full_moon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌖",
    description: "waning gibbous moon",
    category: "Travel & Places",
    aliases: ["waning_gibbous_moon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌗",
    description: "last quarter moon",
    category: "Travel & Places",
    aliases: ["last_quarter_moon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌘",
    description: "waning crescent moon",
    category: "Travel & Places",
    aliases: ["waning_crescent_moon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌙",
    description: "crescent moon",
    category: "Travel & Places",
    aliases: ["crescent_moon"],
    tags: ["night"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌚",
    description: "new moon face",
    category: "Travel & Places",
    aliases: ["new_moon_with_face"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌛",
    description: "first quarter moon face",
    category: "Travel & Places",
    aliases: ["first_quarter_moon_with_face"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌜",
    description: "last quarter moon face",
    category: "Travel & Places",
    aliases: ["last_quarter_moon_with_face"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌡️",
    description: "thermometer",
    category: "Travel & Places",
    aliases: ["thermometer"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "☀️",
    description: "sun",
    category: "Travel & Places",
    aliases: ["sunny"],
    tags: ["weather"],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "🌝",
    description: "full moon face",
    category: "Travel & Places",
    aliases: ["full_moon_with_face"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌞",
    description: "sun with face",
    category: "Travel & Places",
    aliases: ["sun_with_face"],
    tags: ["summer"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🪐",
    description: "ringed planet",
    category: "Travel & Places",
    aliases: ["ringed_planet"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "⭐",
    description: "star",
    category: "Travel & Places",
    aliases: ["star"],
    tags: [],
    unicode_version: "5.1",
    ios_version: "6.0"
  },
  {
    emoji: "🌟",
    description: "glowing star",
    category: "Travel & Places",
    aliases: ["star2"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌠",
    description: "shooting star",
    category: "Travel & Places",
    aliases: ["stars"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌌",
    description: "milky way",
    category: "Travel & Places",
    aliases: ["milky_way"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "☁️",
    description: "cloud",
    category: "Travel & Places",
    aliases: ["cloud"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "⛅",
    description: "sun behind cloud",
    category: "Travel & Places",
    aliases: ["partly_sunny"],
    tags: ["weather", "cloud"],
    unicode_version: "5.2",
    ios_version: "6.0"
  },
  {
    emoji: "⛈️",
    description: "cloud with lightning and rain",
    category: "Travel & Places",
    aliases: ["cloud_with_lightning_and_rain"],
    tags: [],
    unicode_version: "5.2",
    ios_version: "9.1"
  },
  {
    emoji: "🌤️",
    description: "sun behind small cloud",
    category: "Travel & Places",
    aliases: ["sun_behind_small_cloud"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🌥️",
    description: "sun behind large cloud",
    category: "Travel & Places",
    aliases: ["sun_behind_large_cloud"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🌦️",
    description: "sun behind rain cloud",
    category: "Travel & Places",
    aliases: ["sun_behind_rain_cloud"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🌧️",
    description: "cloud with rain",
    category: "Travel & Places",
    aliases: ["cloud_with_rain"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🌨️",
    description: "cloud with snow",
    category: "Travel & Places",
    aliases: ["cloud_with_snow"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🌩️",
    description: "cloud with lightning",
    category: "Travel & Places",
    aliases: ["cloud_with_lightning"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🌪️",
    description: "tornado",
    category: "Travel & Places",
    aliases: ["tornado"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🌫️",
    description: "fog",
    category: "Travel & Places",
    aliases: ["fog"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🌬️",
    description: "wind face",
    category: "Travel & Places",
    aliases: ["wind_face"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🌀",
    description: "cyclone",
    category: "Travel & Places",
    aliases: ["cyclone"],
    tags: ["swirl"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌈",
    description: "rainbow",
    category: "Travel & Places",
    aliases: ["rainbow"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌂",
    description: "closed umbrella",
    category: "Travel & Places",
    aliases: ["closed_umbrella"],
    tags: ["weather", "rain"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "☂️",
    description: "umbrella",
    category: "Travel & Places",
    aliases: ["open_umbrella"],
    tags: [],
    unicode_version: "",
    ios_version: "9.1"
  },
  {
    emoji: "☔",
    description: "umbrella with rain drops",
    category: "Travel & Places",
    aliases: ["umbrella"],
    tags: ["rain", "weather"],
    unicode_version: "4.0",
    ios_version: "6.0"
  },
  {
    emoji: "⛱️",
    description: "umbrella on ground",
    category: "Travel & Places",
    aliases: ["parasol_on_ground"],
    tags: ["beach_umbrella"],
    unicode_version: "5.2",
    ios_version: "9.1"
  },
  {
    emoji: "⚡",
    description: "high voltage",
    category: "Travel & Places",
    aliases: ["zap"],
    tags: ["lightning", "thunder"],
    unicode_version: "4.0",
    ios_version: "6.0"
  },
  {
    emoji: "❄️",
    description: "snowflake",
    category: "Travel & Places",
    aliases: ["snowflake"],
    tags: ["winter", "cold", "weather"],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "☃️",
    description: "snowman",
    category: "Travel & Places",
    aliases: ["snowman_with_snow"],
    tags: ["winter", "christmas"],
    unicode_version: "",
    ios_version: "9.1"
  },
  {
    emoji: "⛄",
    description: "snowman without snow",
    category: "Travel & Places",
    aliases: ["snowman"],
    tags: ["winter"],
    unicode_version: "5.2",
    ios_version: "6.0"
  },
  {
    emoji: "☄️",
    description: "comet",
    category: "Travel & Places",
    aliases: ["comet"],
    tags: [],
    unicode_version: "",
    ios_version: "9.1"
  },
  {
    emoji: "🔥",
    description: "fire",
    category: "Travel & Places",
    aliases: ["fire"],
    tags: ["burn"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💧",
    description: "droplet",
    category: "Travel & Places",
    aliases: ["droplet"],
    tags: ["water"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🌊",
    description: "water wave",
    category: "Travel & Places",
    aliases: ["ocean"],
    tags: ["sea"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎃",
    description: "jack-o-lantern",
    category: "Activities",
    aliases: ["jack_o_lantern"],
    tags: ["halloween"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎄",
    description: "Christmas tree",
    category: "Activities",
    aliases: ["christmas_tree"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎆",
    description: "fireworks",
    category: "Activities",
    aliases: ["fireworks"],
    tags: ["festival", "celebration"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎇",
    description: "sparkler",
    category: "Activities",
    aliases: ["sparkler"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🧨",
    description: "firecracker",
    category: "Activities",
    aliases: ["firecracker"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "✨",
    description: "sparkles",
    category: "Activities",
    aliases: ["sparkles"],
    tags: ["shiny"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎈",
    description: "balloon",
    category: "Activities",
    aliases: ["balloon"],
    tags: ["party", "birthday"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎉",
    description: "party popper",
    category: "Activities",
    aliases: ["tada"],
    tags: ["hooray", "party"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎊",
    description: "confetti ball",
    category: "Activities",
    aliases: ["confetti_ball"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎋",
    description: "tanabata tree",
    category: "Activities",
    aliases: ["tanabata_tree"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎍",
    description: "pine decoration",
    category: "Activities",
    aliases: ["bamboo"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎎",
    description: "Japanese dolls",
    category: "Activities",
    aliases: ["dolls"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎏",
    description: "carp streamer",
    category: "Activities",
    aliases: ["flags"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎐",
    description: "wind chime",
    category: "Activities",
    aliases: ["wind_chime"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎑",
    description: "moon viewing ceremony",
    category: "Activities",
    aliases: ["rice_scene"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🧧",
    description: "red envelope",
    category: "Activities",
    aliases: ["red_envelope"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🎀",
    description: "ribbon",
    category: "Activities",
    aliases: ["ribbon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎁",
    description: "wrapped gift",
    category: "Activities",
    aliases: ["gift"],
    tags: ["present", "birthday", "christmas"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎗️",
    description: "reminder ribbon",
    category: "Activities",
    aliases: ["reminder_ribbon"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🎟️",
    description: "admission tickets",
    category: "Activities",
    aliases: ["tickets"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🎫",
    description: "ticket",
    category: "Activities",
    aliases: ["ticket"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎖️",
    description: "military medal",
    category: "Activities",
    aliases: ["medal_military"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🏆",
    description: "trophy",
    category: "Activities",
    aliases: ["trophy"],
    tags: ["award", "contest", "winner"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏅",
    description: "sports medal",
    category: "Activities",
    aliases: ["medal_sports"],
    tags: ["gold", "winner"],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🥇",
    description: "1st place medal",
    category: "Activities",
    aliases: ["1st_place_medal"],
    tags: ["gold"],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🥈",
    description: "2nd place medal",
    category: "Activities",
    aliases: ["2nd_place_medal"],
    tags: ["silver"],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🥉",
    description: "3rd place medal",
    category: "Activities",
    aliases: ["3rd_place_medal"],
    tags: ["bronze"],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "⚽",
    description: "soccer ball",
    category: "Activities",
    aliases: ["soccer"],
    tags: ["sports"],
    unicode_version: "5.2",
    ios_version: "6.0"
  },
  {
    emoji: "⚾",
    description: "baseball",
    category: "Activities",
    aliases: ["baseball"],
    tags: ["sports"],
    unicode_version: "5.2",
    ios_version: "6.0"
  },
  {
    emoji: "🥎",
    description: "softball",
    category: "Activities",
    aliases: ["softball"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🏀",
    description: "basketball",
    category: "Activities",
    aliases: ["basketball"],
    tags: ["sports"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏐",
    description: "volleyball",
    category: "Activities",
    aliases: ["volleyball"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🏈",
    description: "american football",
    category: "Activities",
    aliases: ["football"],
    tags: ["sports"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏉",
    description: "rugby football",
    category: "Activities",
    aliases: ["rugby_football"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎾",
    description: "tennis",
    category: "Activities",
    aliases: ["tennis"],
    tags: ["sports"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥏",
    description: "flying disc",
    category: "Activities",
    aliases: ["flying_disc"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🎳",
    description: "bowling",
    category: "Activities",
    aliases: ["bowling"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏏",
    description: "cricket game",
    category: "Activities",
    aliases: ["cricket_game"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🏑",
    description: "field hockey",
    category: "Activities",
    aliases: ["field_hockey"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🏒",
    description: "ice hockey",
    category: "Activities",
    aliases: ["ice_hockey"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🥍",
    description: "lacrosse",
    category: "Activities",
    aliases: ["lacrosse"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🏓",
    description: "ping pong",
    category: "Activities",
    aliases: ["ping_pong"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🏸",
    description: "badminton",
    category: "Activities",
    aliases: ["badminton"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🥊",
    description: "boxing glove",
    category: "Activities",
    aliases: ["boxing_glove"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🥋",
    description: "martial arts uniform",
    category: "Activities",
    aliases: ["martial_arts_uniform"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🥅",
    description: "goal net",
    category: "Activities",
    aliases: ["goal_net"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "⛳",
    description: "flag in hole",
    category: "Activities",
    aliases: ["golf"],
    tags: [],
    unicode_version: "5.2",
    ios_version: "6.0"
  },
  {
    emoji: "⛸️",
    description: "ice skate",
    category: "Activities",
    aliases: ["ice_skate"],
    tags: ["skating"],
    unicode_version: "5.2",
    ios_version: "9.1"
  },
  {
    emoji: "🎣",
    description: "fishing pole",
    category: "Activities",
    aliases: ["fishing_pole_and_fish"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🤿",
    description: "diving mask",
    category: "Activities",
    aliases: ["diving_mask"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🎽",
    description: "running shirt",
    category: "Activities",
    aliases: ["running_shirt_with_sash"],
    tags: ["marathon"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎿",
    description: "skis",
    category: "Activities",
    aliases: ["ski"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🛷",
    description: "sled",
    category: "Activities",
    aliases: ["sled"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🥌",
    description: "curling stone",
    category: "Activities",
    aliases: ["curling_stone"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🎯",
    description: "bullseye",
    category: "Activities",
    aliases: ["dart"],
    tags: ["target"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🪀",
    description: "yo-yo",
    category: "Activities",
    aliases: ["yo_yo"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🪁",
    description: "kite",
    category: "Activities",
    aliases: ["kite"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🎱",
    description: "pool 8 ball",
    category: "Activities",
    aliases: ["8ball"],
    tags: ["pool", "billiards"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔮",
    description: "crystal ball",
    category: "Activities",
    aliases: ["crystal_ball"],
    tags: ["fortune"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🪄",
    description: "magic wand",
    category: "Activities",
    aliases: ["magic_wand"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🧿",
    description: "nazar amulet",
    category: "Activities",
    aliases: ["nazar_amulet"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🎮",
    description: "video game",
    category: "Activities",
    aliases: ["video_game"],
    tags: ["play", "controller", "console"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕹️",
    description: "joystick",
    category: "Activities",
    aliases: ["joystick"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🎰",
    description: "slot machine",
    category: "Activities",
    aliases: ["slot_machine"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎲",
    description: "game die",
    category: "Activities",
    aliases: ["game_die"],
    tags: ["dice", "gambling"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🧩",
    description: "puzzle piece",
    category: "Activities",
    aliases: ["jigsaw"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧸",
    description: "teddy bear",
    category: "Activities",
    aliases: ["teddy_bear"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🪅",
    description: "piñata",
    category: "Activities",
    aliases: ["pinata"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🪆",
    description: "nesting dolls",
    category: "Activities",
    aliases: ["nesting_dolls"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "♠️",
    description: "spade suit",
    category: "Activities",
    aliases: ["spades"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "♥️",
    description: "heart suit",
    category: "Activities",
    aliases: ["hearts"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "♦️",
    description: "diamond suit",
    category: "Activities",
    aliases: ["diamonds"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "♣️",
    description: "club suit",
    category: "Activities",
    aliases: ["clubs"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "♟️",
    description: "chess pawn",
    category: "Activities",
    aliases: ["chess_pawn"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🃏",
    description: "joker",
    category: "Activities",
    aliases: ["black_joker"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🀄",
    description: "mahjong red dragon",
    category: "Activities",
    aliases: ["mahjong"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "🎴",
    description: "flower playing cards",
    category: "Activities",
    aliases: ["flower_playing_cards"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎭",
    description: "performing arts",
    category: "Activities",
    aliases: ["performing_arts"],
    tags: ["theater", "drama"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🖼️",
    description: "framed picture",
    category: "Activities",
    aliases: ["framed_picture"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🎨",
    description: "artist palette",
    category: "Activities",
    aliases: ["art"],
    tags: ["design", "paint"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🧵",
    description: "thread",
    category: "Activities",
    aliases: ["thread"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🪡",
    description: "sewing needle",
    category: "Activities",
    aliases: ["sewing_needle"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🧶",
    description: "yarn",
    category: "Activities",
    aliases: ["yarn"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🪢",
    description: "knot",
    category: "Activities",
    aliases: ["knot"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "👓",
    description: "glasses",
    category: "Objects",
    aliases: ["eyeglasses"],
    tags: ["glasses"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕶️",
    description: "sunglasses",
    category: "Objects",
    aliases: ["dark_sunglasses"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🥽",
    description: "goggles",
    category: "Objects",
    aliases: ["goggles"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🥼",
    description: "lab coat",
    category: "Objects",
    aliases: ["lab_coat"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🦺",
    description: "safety vest",
    category: "Objects",
    aliases: ["safety_vest"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "👔",
    description: "necktie",
    category: "Objects",
    aliases: ["necktie"],
    tags: ["shirt", "formal"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👕",
    description: "t-shirt",
    category: "Objects",
    aliases: ["shirt", "tshirt"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👖",
    description: "jeans",
    category: "Objects",
    aliases: ["jeans"],
    tags: ["pants"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🧣",
    description: "scarf",
    category: "Objects",
    aliases: ["scarf"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧤",
    description: "gloves",
    category: "Objects",
    aliases: ["gloves"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧥",
    description: "coat",
    category: "Objects",
    aliases: ["coat"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧦",
    description: "socks",
    category: "Objects",
    aliases: ["socks"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "👗",
    description: "dress",
    category: "Objects",
    aliases: ["dress"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👘",
    description: "kimono",
    category: "Objects",
    aliases: ["kimono"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥻",
    description: "sari",
    category: "Objects",
    aliases: ["sari"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🩱",
    description: "one-piece swimsuit",
    category: "Objects",
    aliases: ["one_piece_swimsuit"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🩲",
    description: "briefs",
    category: "Objects",
    aliases: ["swim_brief"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🩳",
    description: "shorts",
    category: "Objects",
    aliases: ["shorts"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "👙",
    description: "bikini",
    category: "Objects",
    aliases: ["bikini"],
    tags: ["beach"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👚",
    description: "woman’s clothes",
    category: "Objects",
    aliases: ["womans_clothes"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👛",
    description: "purse",
    category: "Objects",
    aliases: ["purse"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👜",
    description: "handbag",
    category: "Objects",
    aliases: ["handbag"],
    tags: ["bag"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👝",
    description: "clutch bag",
    category: "Objects",
    aliases: ["pouch"],
    tags: ["bag"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🛍️",
    description: "shopping bags",
    category: "Objects",
    aliases: ["shopping"],
    tags: ["bags"],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🎒",
    description: "backpack",
    category: "Objects",
    aliases: ["school_satchel"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🩴",
    description: "thong sandal",
    category: "Objects",
    aliases: ["thong_sandal"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "👞",
    description: "man’s shoe",
    category: "Objects",
    aliases: ["mans_shoe", "shoe"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👟",
    description: "running shoe",
    category: "Objects",
    aliases: ["athletic_shoe"],
    tags: ["sneaker", "sport", "running"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🥾",
    description: "hiking boot",
    category: "Objects",
    aliases: ["hiking_boot"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🥿",
    description: "flat shoe",
    category: "Objects",
    aliases: ["flat_shoe"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "👠",
    description: "high-heeled shoe",
    category: "Objects",
    aliases: ["high_heel"],
    tags: ["shoe"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👡",
    description: "woman’s sandal",
    category: "Objects",
    aliases: ["sandal"],
    tags: ["shoe"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🩰",
    description: "ballet shoes",
    category: "Objects",
    aliases: ["ballet_shoes"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "👢",
    description: "woman’s boot",
    category: "Objects",
    aliases: ["boot"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👑",
    description: "crown",
    category: "Objects",
    aliases: ["crown"],
    tags: ["king", "queen", "royal"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "👒",
    description: "woman’s hat",
    category: "Objects",
    aliases: ["womans_hat"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎩",
    description: "top hat",
    category: "Objects",
    aliases: ["tophat"],
    tags: ["hat", "classy"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎓",
    description: "graduation cap",
    category: "Objects",
    aliases: ["mortar_board"],
    tags: ["education", "college", "university", "graduation"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🧢",
    description: "billed cap",
    category: "Objects",
    aliases: ["billed_cap"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🪖",
    description: "military helmet",
    category: "Objects",
    aliases: ["military_helmet"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "⛑️",
    description: "rescue worker’s helmet",
    category: "Objects",
    aliases: ["rescue_worker_helmet"],
    tags: [],
    unicode_version: "5.2",
    ios_version: "9.1"
  },
  {
    emoji: "📿",
    description: "prayer beads",
    category: "Objects",
    aliases: ["prayer_beads"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "💄",
    description: "lipstick",
    category: "Objects",
    aliases: ["lipstick"],
    tags: ["makeup"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💍",
    description: "ring",
    category: "Objects",
    aliases: ["ring"],
    tags: ["wedding", "marriage", "engaged"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💎",
    description: "gem stone",
    category: "Objects",
    aliases: ["gem"],
    tags: ["diamond"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔇",
    description: "muted speaker",
    category: "Objects",
    aliases: ["mute"],
    tags: ["sound", "volume"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔈",
    description: "speaker low volume",
    category: "Objects",
    aliases: ["speaker"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔉",
    description: "speaker medium volume",
    category: "Objects",
    aliases: ["sound"],
    tags: ["volume"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔊",
    description: "speaker high volume",
    category: "Objects",
    aliases: ["loud_sound"],
    tags: ["volume"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📢",
    description: "loudspeaker",
    category: "Objects",
    aliases: ["loudspeaker"],
    tags: ["announcement"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📣",
    description: "megaphone",
    category: "Objects",
    aliases: ["mega"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📯",
    description: "postal horn",
    category: "Objects",
    aliases: ["postal_horn"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔔",
    description: "bell",
    category: "Objects",
    aliases: ["bell"],
    tags: ["sound", "notification"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔕",
    description: "bell with slash",
    category: "Objects",
    aliases: ["no_bell"],
    tags: ["volume", "off"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎼",
    description: "musical score",
    category: "Objects",
    aliases: ["musical_score"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎵",
    description: "musical note",
    category: "Objects",
    aliases: ["musical_note"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎶",
    description: "musical notes",
    category: "Objects",
    aliases: ["notes"],
    tags: ["music"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎙️",
    description: "studio microphone",
    category: "Objects",
    aliases: ["studio_microphone"],
    tags: ["podcast"],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🎚️",
    description: "level slider",
    category: "Objects",
    aliases: ["level_slider"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🎛️",
    description: "control knobs",
    category: "Objects",
    aliases: ["control_knobs"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🎤",
    description: "microphone",
    category: "Objects",
    aliases: ["microphone"],
    tags: ["sing"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎧",
    description: "headphone",
    category: "Objects",
    aliases: ["headphones"],
    tags: ["music", "earphones"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📻",
    description: "radio",
    category: "Objects",
    aliases: ["radio"],
    tags: ["podcast"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎷",
    description: "saxophone",
    category: "Objects",
    aliases: ["saxophone"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🪗",
    description: "accordion",
    category: "Objects",
    aliases: ["accordion"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🎸",
    description: "guitar",
    category: "Objects",
    aliases: ["guitar"],
    tags: ["rock"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎹",
    description: "musical keyboard",
    category: "Objects",
    aliases: ["musical_keyboard"],
    tags: ["piano"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎺",
    description: "trumpet",
    category: "Objects",
    aliases: ["trumpet"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎻",
    description: "violin",
    category: "Objects",
    aliases: ["violin"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🪕",
    description: "banjo",
    category: "Objects",
    aliases: ["banjo"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🥁",
    description: "drum",
    category: "Objects",
    aliases: ["drum"],
    tags: [],
    unicode_version: "",
    ios_version: "10.2"
  },
  {
    emoji: "🪘",
    description: "long drum",
    category: "Objects",
    aliases: ["long_drum"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "📱",
    description: "mobile phone",
    category: "Objects",
    aliases: ["iphone"],
    tags: ["smartphone", "mobile"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📲",
    description: "mobile phone with arrow",
    category: "Objects",
    aliases: ["calling"],
    tags: ["call", "incoming"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "☎️",
    description: "telephone",
    category: "Objects",
    aliases: ["phone", "telephone"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "📞",
    description: "telephone receiver",
    category: "Objects",
    aliases: ["telephone_receiver"],
    tags: ["phone", "call"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📟",
    description: "pager",
    category: "Objects",
    aliases: ["pager"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📠",
    description: "fax machine",
    category: "Objects",
    aliases: ["fax"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔋",
    description: "battery",
    category: "Objects",
    aliases: ["battery"],
    tags: ["power"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔌",
    description: "electric plug",
    category: "Objects",
    aliases: ["electric_plug"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💻",
    description: "laptop",
    category: "Objects",
    aliases: ["computer"],
    tags: ["desktop", "screen"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🖥️",
    description: "desktop computer",
    category: "Objects",
    aliases: ["desktop_computer"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🖨️",
    description: "printer",
    category: "Objects",
    aliases: ["printer"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "⌨️",
    description: "keyboard",
    category: "Objects",
    aliases: ["keyboard"],
    tags: [],
    unicode_version: "",
    ios_version: "9.1"
  },
  {
    emoji: "🖱️",
    description: "computer mouse",
    category: "Objects",
    aliases: ["computer_mouse"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🖲️",
    description: "trackball",
    category: "Objects",
    aliases: ["trackball"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "💽",
    description: "computer disk",
    category: "Objects",
    aliases: ["minidisc"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💾",
    description: "floppy disk",
    category: "Objects",
    aliases: ["floppy_disk"],
    tags: ["save"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💿",
    description: "optical disk",
    category: "Objects",
    aliases: ["cd"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📀",
    description: "dvd",
    category: "Objects",
    aliases: ["dvd"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🧮",
    description: "abacus",
    category: "Objects",
    aliases: ["abacus"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🎥",
    description: "movie camera",
    category: "Objects",
    aliases: ["movie_camera"],
    tags: ["film", "video"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎞️",
    description: "film frames",
    category: "Objects",
    aliases: ["film_strip"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "📽️",
    description: "film projector",
    category: "Objects",
    aliases: ["film_projector"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🎬",
    description: "clapper board",
    category: "Objects",
    aliases: ["clapper"],
    tags: ["film"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📺",
    description: "television",
    category: "Objects",
    aliases: ["tv"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📷",
    description: "camera",
    category: "Objects",
    aliases: ["camera"],
    tags: ["photo"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📸",
    description: "camera with flash",
    category: "Objects",
    aliases: ["camera_flash"],
    tags: ["photo"],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "📹",
    description: "video camera",
    category: "Objects",
    aliases: ["video_camera"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📼",
    description: "videocassette",
    category: "Objects",
    aliases: ["vhs"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔍",
    description: "magnifying glass tilted left",
    category: "Objects",
    aliases: ["mag"],
    tags: ["search", "zoom"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔎",
    description: "magnifying glass tilted right",
    category: "Objects",
    aliases: ["mag_right"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🕯️",
    description: "candle",
    category: "Objects",
    aliases: ["candle"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "💡",
    description: "light bulb",
    category: "Objects",
    aliases: ["bulb"],
    tags: ["idea", "light"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔦",
    description: "flashlight",
    category: "Objects",
    aliases: ["flashlight"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏮",
    description: "red paper lantern",
    category: "Objects",
    aliases: ["izakaya_lantern", "lantern"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🪔",
    description: "diya lamp",
    category: "Objects",
    aliases: ["diya_lamp"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "📔",
    description: "notebook with decorative cover",
    category: "Objects",
    aliases: ["notebook_with_decorative_cover"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📕",
    description: "closed book",
    category: "Objects",
    aliases: ["closed_book"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📖",
    description: "open book",
    category: "Objects",
    aliases: ["book", "open_book"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📗",
    description: "green book",
    category: "Objects",
    aliases: ["green_book"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📘",
    description: "blue book",
    category: "Objects",
    aliases: ["blue_book"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📙",
    description: "orange book",
    category: "Objects",
    aliases: ["orange_book"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📚",
    description: "books",
    category: "Objects",
    aliases: ["books"],
    tags: ["library"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📓",
    description: "notebook",
    category: "Objects",
    aliases: ["notebook"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📒",
    description: "ledger",
    category: "Objects",
    aliases: ["ledger"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📃",
    description: "page with curl",
    category: "Objects",
    aliases: ["page_with_curl"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📜",
    description: "scroll",
    category: "Objects",
    aliases: ["scroll"],
    tags: ["document"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📄",
    description: "page facing up",
    category: "Objects",
    aliases: ["page_facing_up"],
    tags: ["document"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📰",
    description: "newspaper",
    category: "Objects",
    aliases: ["newspaper"],
    tags: ["press"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🗞️",
    description: "rolled-up newspaper",
    category: "Objects",
    aliases: ["newspaper_roll"],
    tags: ["press"],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "📑",
    description: "bookmark tabs",
    category: "Objects",
    aliases: ["bookmark_tabs"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔖",
    description: "bookmark",
    category: "Objects",
    aliases: ["bookmark"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏷️",
    description: "label",
    category: "Objects",
    aliases: ["label"],
    tags: ["tag"],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "💰",
    description: "money bag",
    category: "Objects",
    aliases: ["moneybag"],
    tags: ["dollar", "cream"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🪙",
    description: "coin",
    category: "Objects",
    aliases: ["coin"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "💴",
    description: "yen banknote",
    category: "Objects",
    aliases: ["yen"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💵",
    description: "dollar banknote",
    category: "Objects",
    aliases: ["dollar"],
    tags: ["money"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💶",
    description: "euro banknote",
    category: "Objects",
    aliases: ["euro"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💷",
    description: "pound banknote",
    category: "Objects",
    aliases: ["pound"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💸",
    description: "money with wings",
    category: "Objects",
    aliases: ["money_with_wings"],
    tags: ["dollar"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💳",
    description: "credit card",
    category: "Objects",
    aliases: ["credit_card"],
    tags: ["subscription"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🧾",
    description: "receipt",
    category: "Objects",
    aliases: ["receipt"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "💹",
    description: "chart increasing with yen",
    category: "Objects",
    aliases: ["chart"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "✉️",
    description: "envelope",
    category: "Objects",
    aliases: ["envelope"],
    tags: ["letter", "email"],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "📧",
    description: "e-mail",
    category: "Objects",
    aliases: ["email", "e-mail"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📨",
    description: "incoming envelope",
    category: "Objects",
    aliases: ["incoming_envelope"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📩",
    description: "envelope with arrow",
    category: "Objects",
    aliases: ["envelope_with_arrow"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📤",
    description: "outbox tray",
    category: "Objects",
    aliases: ["outbox_tray"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📥",
    description: "inbox tray",
    category: "Objects",
    aliases: ["inbox_tray"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📦",
    description: "package",
    category: "Objects",
    aliases: ["package"],
    tags: ["shipping"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📫",
    description: "closed mailbox with raised flag",
    category: "Objects",
    aliases: ["mailbox"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📪",
    description: "closed mailbox with lowered flag",
    category: "Objects",
    aliases: ["mailbox_closed"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📬",
    description: "open mailbox with raised flag",
    category: "Objects",
    aliases: ["mailbox_with_mail"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📭",
    description: "open mailbox with lowered flag",
    category: "Objects",
    aliases: ["mailbox_with_no_mail"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📮",
    description: "postbox",
    category: "Objects",
    aliases: ["postbox"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🗳️",
    description: "ballot box with ballot",
    category: "Objects",
    aliases: ["ballot_box"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "✏️",
    description: "pencil",
    category: "Objects",
    aliases: ["pencil2"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "✒️",
    description: "black nib",
    category: "Objects",
    aliases: ["black_nib"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "🖋️",
    description: "fountain pen",
    category: "Objects",
    aliases: ["fountain_pen"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🖊️",
    description: "pen",
    category: "Objects",
    aliases: ["pen"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🖌️",
    description: "paintbrush",
    category: "Objects",
    aliases: ["paintbrush"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🖍️",
    description: "crayon",
    category: "Objects",
    aliases: ["crayon"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "📝",
    description: "memo",
    category: "Objects",
    aliases: ["memo", "pencil"],
    tags: ["document", "note"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💼",
    description: "briefcase",
    category: "Objects",
    aliases: ["briefcase"],
    tags: ["business"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📁",
    description: "file folder",
    category: "Objects",
    aliases: ["file_folder"],
    tags: ["directory"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📂",
    description: "open file folder",
    category: "Objects",
    aliases: ["open_file_folder"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🗂️",
    description: "card index dividers",
    category: "Objects",
    aliases: ["card_index_dividers"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "📅",
    description: "calendar",
    category: "Objects",
    aliases: ["date"],
    tags: ["calendar", "schedule"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📆",
    description: "tear-off calendar",
    category: "Objects",
    aliases: ["calendar"],
    tags: ["schedule"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🗒️",
    description: "spiral notepad",
    category: "Objects",
    aliases: ["spiral_notepad"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🗓️",
    description: "spiral calendar",
    category: "Objects",
    aliases: ["spiral_calendar"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "📇",
    description: "card index",
    category: "Objects",
    aliases: ["card_index"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📈",
    description: "chart increasing",
    category: "Objects",
    aliases: ["chart_with_upwards_trend"],
    tags: ["graph", "metrics"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📉",
    description: "chart decreasing",
    category: "Objects",
    aliases: ["chart_with_downwards_trend"],
    tags: ["graph", "metrics"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📊",
    description: "bar chart",
    category: "Objects",
    aliases: ["bar_chart"],
    tags: ["stats", "metrics"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📋",
    description: "clipboard",
    category: "Objects",
    aliases: ["clipboard"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📌",
    description: "pushpin",
    category: "Objects",
    aliases: ["pushpin"],
    tags: ["location"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📍",
    description: "round pushpin",
    category: "Objects",
    aliases: ["round_pushpin"],
    tags: ["location"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📎",
    description: "paperclip",
    category: "Objects",
    aliases: ["paperclip"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🖇️",
    description: "linked paperclips",
    category: "Objects",
    aliases: ["paperclips"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "📏",
    description: "straight ruler",
    category: "Objects",
    aliases: ["straight_ruler"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📐",
    description: "triangular ruler",
    category: "Objects",
    aliases: ["triangular_ruler"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "✂️",
    description: "scissors",
    category: "Objects",
    aliases: ["scissors"],
    tags: ["cut"],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "🗃️",
    description: "card file box",
    category: "Objects",
    aliases: ["card_file_box"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🗄️",
    description: "file cabinet",
    category: "Objects",
    aliases: ["file_cabinet"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🗑️",
    description: "wastebasket",
    category: "Objects",
    aliases: ["wastebasket"],
    tags: ["trash"],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🔒",
    description: "locked",
    category: "Objects",
    aliases: ["lock"],
    tags: ["security", "private"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔓",
    description: "unlocked",
    category: "Objects",
    aliases: ["unlock"],
    tags: ["security"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔏",
    description: "locked with pen",
    category: "Objects",
    aliases: ["lock_with_ink_pen"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔐",
    description: "locked with key",
    category: "Objects",
    aliases: ["closed_lock_with_key"],
    tags: ["security"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔑",
    description: "key",
    category: "Objects",
    aliases: ["key"],
    tags: ["lock", "password"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🗝️",
    description: "old key",
    category: "Objects",
    aliases: ["old_key"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🔨",
    description: "hammer",
    category: "Objects",
    aliases: ["hammer"],
    tags: ["tool"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🪓",
    description: "axe",
    category: "Objects",
    aliases: ["axe"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "⛏️",
    description: "pick",
    category: "Objects",
    aliases: ["pick"],
    tags: [],
    unicode_version: "5.2",
    ios_version: "9.1"
  },
  {
    emoji: "⚒️",
    description: "hammer and pick",
    category: "Objects",
    aliases: ["hammer_and_pick"],
    tags: [],
    unicode_version: "4.1",
    ios_version: "9.1"
  },
  {
    emoji: "🛠️",
    description: "hammer and wrench",
    category: "Objects",
    aliases: ["hammer_and_wrench"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🗡️",
    description: "dagger",
    category: "Objects",
    aliases: ["dagger"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "⚔️",
    description: "crossed swords",
    category: "Objects",
    aliases: ["crossed_swords"],
    tags: [],
    unicode_version: "4.1",
    ios_version: "9.1"
  },
  {
    emoji: "🔫",
    description: "water pistol",
    category: "Objects",
    aliases: ["gun"],
    tags: ["shoot", "weapon"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🪃",
    description: "boomerang",
    category: "Objects",
    aliases: ["boomerang"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🏹",
    description: "bow and arrow",
    category: "Objects",
    aliases: ["bow_and_arrow"],
    tags: ["archery"],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🛡️",
    description: "shield",
    category: "Objects",
    aliases: ["shield"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🪚",
    description: "carpentry saw",
    category: "Objects",
    aliases: ["carpentry_saw"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🔧",
    description: "wrench",
    category: "Objects",
    aliases: ["wrench"],
    tags: ["tool"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🪛",
    description: "screwdriver",
    category: "Objects",
    aliases: ["screwdriver"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🔩",
    description: "nut and bolt",
    category: "Objects",
    aliases: ["nut_and_bolt"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "⚙️",
    description: "gear",
    category: "Objects",
    aliases: ["gear"],
    tags: [],
    unicode_version: "4.1",
    ios_version: "9.1"
  },
  {
    emoji: "🗜️",
    description: "clamp",
    category: "Objects",
    aliases: ["clamp"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "⚖️",
    description: "balance scale",
    category: "Objects",
    aliases: ["balance_scale"],
    tags: [],
    unicode_version: "4.1",
    ios_version: "9.1"
  },
  {
    emoji: "🦯",
    description: "white cane",
    category: "Objects",
    aliases: ["probing_cane"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🔗",
    description: "link",
    category: "Objects",
    aliases: ["link"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "⛓️",
    description: "chains",
    category: "Objects",
    aliases: ["chains"],
    tags: [],
    unicode_version: "5.2",
    ios_version: "9.1"
  },
  {
    emoji: "🪝",
    description: "hook",
    category: "Objects",
    aliases: ["hook"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🧰",
    description: "toolbox",
    category: "Objects",
    aliases: ["toolbox"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧲",
    description: "magnet",
    category: "Objects",
    aliases: ["magnet"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🪜",
    description: "ladder",
    category: "Objects",
    aliases: ["ladder"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "⚗️",
    description: "alembic",
    category: "Objects",
    aliases: ["alembic"],
    tags: [],
    unicode_version: "4.1",
    ios_version: "9.1"
  },
  {
    emoji: "🧪",
    description: "test tube",
    category: "Objects",
    aliases: ["test_tube"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧫",
    description: "petri dish",
    category: "Objects",
    aliases: ["petri_dish"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧬",
    description: "dna",
    category: "Objects",
    aliases: ["dna"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🔬",
    description: "microscope",
    category: "Objects",
    aliases: ["microscope"],
    tags: ["science", "laboratory", "investigate"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔭",
    description: "telescope",
    category: "Objects",
    aliases: ["telescope"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📡",
    description: "satellite antenna",
    category: "Objects",
    aliases: ["satellite"],
    tags: ["signal"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💉",
    description: "syringe",
    category: "Objects",
    aliases: ["syringe"],
    tags: ["health", "hospital", "needle"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🩸",
    description: "drop of blood",
    category: "Objects",
    aliases: ["drop_of_blood"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "💊",
    description: "pill",
    category: "Objects",
    aliases: ["pill"],
    tags: ["health", "medicine"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🩹",
    description: "adhesive bandage",
    category: "Objects",
    aliases: ["adhesive_bandage"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🩺",
    description: "stethoscope",
    category: "Objects",
    aliases: ["stethoscope"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🚪",
    description: "door",
    category: "Objects",
    aliases: ["door"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🛗",
    description: "elevator",
    category: "Objects",
    aliases: ["elevator"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🪞",
    description: "mirror",
    category: "Objects",
    aliases: ["mirror"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🪟",
    description: "window",
    category: "Objects",
    aliases: ["window"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🛏️",
    description: "bed",
    category: "Objects",
    aliases: ["bed"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🛋️",
    description: "couch and lamp",
    category: "Objects",
    aliases: ["couch_and_lamp"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🪑",
    description: "chair",
    category: "Objects",
    aliases: ["chair"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🚽",
    description: "toilet",
    category: "Objects",
    aliases: ["toilet"],
    tags: ["wc"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🪠",
    description: "plunger",
    category: "Objects",
    aliases: ["plunger"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🚿",
    description: "shower",
    category: "Objects",
    aliases: ["shower"],
    tags: ["bath"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🛁",
    description: "bathtub",
    category: "Objects",
    aliases: ["bathtub"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🪤",
    description: "mouse trap",
    category: "Objects",
    aliases: ["mouse_trap"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🪒",
    description: "razor",
    category: "Objects",
    aliases: ["razor"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🧴",
    description: "lotion bottle",
    category: "Objects",
    aliases: ["lotion_bottle"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧷",
    description: "safety pin",
    category: "Objects",
    aliases: ["safety_pin"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧹",
    description: "broom",
    category: "Objects",
    aliases: ["broom"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧺",
    description: "basket",
    category: "Objects",
    aliases: ["basket"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧻",
    description: "roll of paper",
    category: "Objects",
    aliases: ["roll_of_paper"],
    tags: ["toilet"],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🪣",
    description: "bucket",
    category: "Objects",
    aliases: ["bucket"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🧼",
    description: "soap",
    category: "Objects",
    aliases: ["soap"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🪥",
    description: "toothbrush",
    category: "Objects",
    aliases: ["toothbrush"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🧽",
    description: "sponge",
    category: "Objects",
    aliases: ["sponge"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🧯",
    description: "fire extinguisher",
    category: "Objects",
    aliases: ["fire_extinguisher"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🛒",
    description: "shopping cart",
    category: "Objects",
    aliases: ["shopping_cart"],
    tags: [],
    unicode_version: "9.0",
    ios_version: "10.2"
  },
  {
    emoji: "🚬",
    description: "cigarette",
    category: "Objects",
    aliases: ["smoking"],
    tags: ["cigarette"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "⚰️",
    description: "coffin",
    category: "Objects",
    aliases: ["coffin"],
    tags: ["funeral"],
    unicode_version: "4.1",
    ios_version: "9.1"
  },
  {
    emoji: "🪦",
    description: "headstone",
    category: "Objects",
    aliases: ["headstone"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "⚱️",
    description: "funeral urn",
    category: "Objects",
    aliases: ["funeral_urn"],
    tags: [],
    unicode_version: "4.1",
    ios_version: "9.1"
  },
  {
    emoji: "🗿",
    description: "moai",
    category: "Objects",
    aliases: ["moyai"],
    tags: ["stone"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🪧",
    description: "placard",
    category: "Objects",
    aliases: ["placard"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🏧",
    description: "ATM sign",
    category: "Symbols",
    aliases: ["atm"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚮",
    description: "litter in bin sign",
    category: "Symbols",
    aliases: ["put_litter_in_its_place"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚰",
    description: "potable water",
    category: "Symbols",
    aliases: ["potable_water"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "♿",
    description: "wheelchair symbol",
    category: "Symbols",
    aliases: ["wheelchair"],
    tags: ["accessibility"],
    unicode_version: "4.1",
    ios_version: "6.0"
  },
  {
    emoji: "🚹",
    description: "men’s room",
    category: "Symbols",
    aliases: ["mens"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚺",
    description: "women’s room",
    category: "Symbols",
    aliases: ["womens"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚻",
    description: "restroom",
    category: "Symbols",
    aliases: ["restroom"],
    tags: ["toilet"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚼",
    description: "baby symbol",
    category: "Symbols",
    aliases: ["baby_symbol"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚾",
    description: "water closet",
    category: "Symbols",
    aliases: ["wc"],
    tags: ["toilet", "restroom"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🛂",
    description: "passport control",
    category: "Symbols",
    aliases: ["passport_control"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🛃",
    description: "customs",
    category: "Symbols",
    aliases: ["customs"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🛄",
    description: "baggage claim",
    category: "Symbols",
    aliases: ["baggage_claim"],
    tags: ["airport"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🛅",
    description: "left luggage",
    category: "Symbols",
    aliases: ["left_luggage"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "⚠️",
    description: "warning",
    category: "Symbols",
    aliases: ["warning"],
    tags: ["wip"],
    unicode_version: "4.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚸",
    description: "children crossing",
    category: "Symbols",
    aliases: ["children_crossing"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "⛔",
    description: "no entry",
    category: "Symbols",
    aliases: ["no_entry"],
    tags: ["limit"],
    unicode_version: "5.2",
    ios_version: "6.0"
  },
  {
    emoji: "🚫",
    description: "prohibited",
    category: "Symbols",
    aliases: ["no_entry_sign"],
    tags: ["block", "forbidden"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚳",
    description: "no bicycles",
    category: "Symbols",
    aliases: ["no_bicycles"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚭",
    description: "no smoking",
    category: "Symbols",
    aliases: ["no_smoking"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚯",
    description: "no littering",
    category: "Symbols",
    aliases: ["do_not_litter"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚱",
    description: "non-potable water",
    category: "Symbols",
    aliases: ["non-potable_water"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚷",
    description: "no pedestrians",
    category: "Symbols",
    aliases: ["no_pedestrians"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📵",
    description: "no mobile phones",
    category: "Symbols",
    aliases: ["no_mobile_phones"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔞",
    description: "no one under eighteen",
    category: "Symbols",
    aliases: ["underage"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "☢️",
    description: "radioactive",
    category: "Symbols",
    aliases: ["radioactive"],
    tags: [],
    unicode_version: "",
    ios_version: "9.1"
  },
  {
    emoji: "☣️",
    description: "biohazard",
    category: "Symbols",
    aliases: ["biohazard"],
    tags: [],
    unicode_version: "",
    ios_version: "9.1"
  },
  {
    emoji: "⬆️",
    description: "up arrow",
    category: "Symbols",
    aliases: ["arrow_up"],
    tags: [],
    unicode_version: "4.0",
    ios_version: "6.0"
  },
  {
    emoji: "↗️",
    description: "up-right arrow",
    category: "Symbols",
    aliases: ["arrow_upper_right"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "➡️",
    description: "right arrow",
    category: "Symbols",
    aliases: ["arrow_right"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "↘️",
    description: "down-right arrow",
    category: "Symbols",
    aliases: ["arrow_lower_right"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "⬇️",
    description: "down arrow",
    category: "Symbols",
    aliases: ["arrow_down"],
    tags: [],
    unicode_version: "4.0",
    ios_version: "6.0"
  },
  {
    emoji: "↙️",
    description: "down-left arrow",
    category: "Symbols",
    aliases: ["arrow_lower_left"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "⬅️",
    description: "left arrow",
    category: "Symbols",
    aliases: ["arrow_left"],
    tags: [],
    unicode_version: "4.0",
    ios_version: "6.0"
  },
  {
    emoji: "↖️",
    description: "up-left arrow",
    category: "Symbols",
    aliases: ["arrow_upper_left"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "↕️",
    description: "up-down arrow",
    category: "Symbols",
    aliases: ["arrow_up_down"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "↔️",
    description: "left-right arrow",
    category: "Symbols",
    aliases: ["left_right_arrow"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "↩️",
    description: "right arrow curving left",
    category: "Symbols",
    aliases: ["leftwards_arrow_with_hook"],
    tags: ["return"],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "↪️",
    description: "left arrow curving right",
    category: "Symbols",
    aliases: ["arrow_right_hook"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "⤴️",
    description: "right arrow curving up",
    category: "Symbols",
    aliases: ["arrow_heading_up"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "⤵️",
    description: "right arrow curving down",
    category: "Symbols",
    aliases: ["arrow_heading_down"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "🔃",
    description: "clockwise vertical arrows",
    category: "Symbols",
    aliases: ["arrows_clockwise"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔄",
    description: "counterclockwise arrows button",
    category: "Symbols",
    aliases: ["arrows_counterclockwise"],
    tags: ["sync"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔙",
    description: "BACK arrow",
    category: "Symbols",
    aliases: ["back"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔚",
    description: "END arrow",
    category: "Symbols",
    aliases: ["end"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔛",
    description: "ON! arrow",
    category: "Symbols",
    aliases: ["on"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔜",
    description: "SOON arrow",
    category: "Symbols",
    aliases: ["soon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔝",
    description: "TOP arrow",
    category: "Symbols",
    aliases: ["top"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🛐",
    description: "place of worship",
    category: "Symbols",
    aliases: ["place_of_worship"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "⚛️",
    description: "atom symbol",
    category: "Symbols",
    aliases: ["atom_symbol"],
    tags: [],
    unicode_version: "4.1",
    ios_version: "9.1"
  },
  {
    emoji: "🕉️",
    description: "om",
    category: "Symbols",
    aliases: ["om"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "✡️",
    description: "star of David",
    category: "Symbols",
    aliases: ["star_of_david"],
    tags: [],
    unicode_version: "",
    ios_version: "9.1"
  },
  {
    emoji: "☸️",
    description: "wheel of dharma",
    category: "Symbols",
    aliases: ["wheel_of_dharma"],
    tags: [],
    unicode_version: "",
    ios_version: "9.1"
  },
  {
    emoji: "☯️",
    description: "yin yang",
    category: "Symbols",
    aliases: ["yin_yang"],
    tags: [],
    unicode_version: "",
    ios_version: "9.1"
  },
  {
    emoji: "✝️",
    description: "latin cross",
    category: "Symbols",
    aliases: ["latin_cross"],
    tags: [],
    unicode_version: "",
    ios_version: "9.1"
  },
  {
    emoji: "☦️",
    description: "orthodox cross",
    category: "Symbols",
    aliases: ["orthodox_cross"],
    tags: [],
    unicode_version: "",
    ios_version: "9.1"
  },
  {
    emoji: "☪️",
    description: "star and crescent",
    category: "Symbols",
    aliases: ["star_and_crescent"],
    tags: [],
    unicode_version: "",
    ios_version: "9.1"
  },
  {
    emoji: "☮️",
    description: "peace symbol",
    category: "Symbols",
    aliases: ["peace_symbol"],
    tags: [],
    unicode_version: "",
    ios_version: "9.1"
  },
  {
    emoji: "🕎",
    description: "menorah",
    category: "Symbols",
    aliases: ["menorah"],
    tags: [],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🔯",
    description: "dotted six-pointed star",
    category: "Symbols",
    aliases: ["six_pointed_star"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "♈",
    description: "Aries",
    category: "Symbols",
    aliases: ["aries"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "♉",
    description: "Taurus",
    category: "Symbols",
    aliases: ["taurus"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "♊",
    description: "Gemini",
    category: "Symbols",
    aliases: ["gemini"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "♋",
    description: "Cancer",
    category: "Symbols",
    aliases: ["cancer"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "♌",
    description: "Leo",
    category: "Symbols",
    aliases: ["leo"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "♍",
    description: "Virgo",
    category: "Symbols",
    aliases: ["virgo"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "♎",
    description: "Libra",
    category: "Symbols",
    aliases: ["libra"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "♏",
    description: "Scorpio",
    category: "Symbols",
    aliases: ["scorpius"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "♐",
    description: "Sagittarius",
    category: "Symbols",
    aliases: ["sagittarius"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "♑",
    description: "Capricorn",
    category: "Symbols",
    aliases: ["capricorn"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "♒",
    description: "Aquarius",
    category: "Symbols",
    aliases: ["aquarius"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "♓",
    description: "Pisces",
    category: "Symbols",
    aliases: ["pisces"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "⛎",
    description: "Ophiuchus",
    category: "Symbols",
    aliases: ["ophiuchus"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔀",
    description: "shuffle tracks button",
    category: "Symbols",
    aliases: ["twisted_rightwards_arrows"],
    tags: ["shuffle"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔁",
    description: "repeat button",
    category: "Symbols",
    aliases: ["repeat"],
    tags: ["loop"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔂",
    description: "repeat single button",
    category: "Symbols",
    aliases: ["repeat_one"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "▶️",
    description: "play button",
    category: "Symbols",
    aliases: ["arrow_forward"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "⏩",
    description: "fast-forward button",
    category: "Symbols",
    aliases: ["fast_forward"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "⏭️",
    description: "next track button",
    category: "Symbols",
    aliases: ["next_track_button"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.1"
  },
  {
    emoji: "⏯️",
    description: "play or pause button",
    category: "Symbols",
    aliases: ["play_or_pause_button"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.1"
  },
  {
    emoji: "◀️",
    description: "reverse button",
    category: "Symbols",
    aliases: ["arrow_backward"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "⏪",
    description: "fast reverse button",
    category: "Symbols",
    aliases: ["rewind"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "⏮️",
    description: "last track button",
    category: "Symbols",
    aliases: ["previous_track_button"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.1"
  },
  {
    emoji: "🔼",
    description: "upwards button",
    category: "Symbols",
    aliases: ["arrow_up_small"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "⏫",
    description: "fast up button",
    category: "Symbols",
    aliases: ["arrow_double_up"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔽",
    description: "downwards button",
    category: "Symbols",
    aliases: ["arrow_down_small"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "⏬",
    description: "fast down button",
    category: "Symbols",
    aliases: ["arrow_double_down"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "⏸️",
    description: "pause button",
    category: "Symbols",
    aliases: ["pause_button"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "⏹️",
    description: "stop button",
    category: "Symbols",
    aliases: ["stop_button"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "⏺️",
    description: "record button",
    category: "Symbols",
    aliases: ["record_button"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "⏏️",
    description: "eject button",
    category: "Symbols",
    aliases: ["eject_button"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🎦",
    description: "cinema",
    category: "Symbols",
    aliases: ["cinema"],
    tags: ["film", "movie"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔅",
    description: "dim button",
    category: "Symbols",
    aliases: ["low_brightness"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔆",
    description: "bright button",
    category: "Symbols",
    aliases: ["high_brightness"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📶",
    description: "antenna bars",
    category: "Symbols",
    aliases: ["signal_strength"],
    tags: ["wifi"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📳",
    description: "vibration mode",
    category: "Symbols",
    aliases: ["vibration_mode"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📴",
    description: "mobile phone off",
    category: "Symbols",
    aliases: ["mobile_phone_off"],
    tags: ["mute", "off"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "♀️",
    description: "female sign",
    category: "Symbols",
    aliases: ["female_sign"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "♂️",
    description: "male sign",
    category: "Symbols",
    aliases: ["male_sign"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "⚧️",
    description: "transgender symbol",
    category: "Symbols",
    aliases: ["transgender_symbol"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "✖️",
    description: "multiply",
    category: "Symbols",
    aliases: ["heavy_multiplication_x"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "➕",
    description: "plus",
    category: "Symbols",
    aliases: ["heavy_plus_sign"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "➖",
    description: "minus",
    category: "Symbols",
    aliases: ["heavy_minus_sign"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "➗",
    description: "divide",
    category: "Symbols",
    aliases: ["heavy_division_sign"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "♾️",
    description: "infinity",
    category: "Symbols",
    aliases: ["infinity"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "‼️",
    description: "double exclamation mark",
    category: "Symbols",
    aliases: ["bangbang"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "⁉️",
    description: "exclamation question mark",
    category: "Symbols",
    aliases: ["interrobang"],
    tags: [],
    unicode_version: "3.0",
    ios_version: "6.0"
  },
  {
    emoji: "❓",
    description: "red question mark",
    category: "Symbols",
    aliases: ["question"],
    tags: ["confused"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "❔",
    description: "white question mark",
    category: "Symbols",
    aliases: ["grey_question"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "❕",
    description: "white exclamation mark",
    category: "Symbols",
    aliases: ["grey_exclamation"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "❗",
    description: "red exclamation mark",
    category: "Symbols",
    aliases: ["exclamation", "heavy_exclamation_mark"],
    tags: ["bang"],
    unicode_version: "5.2",
    ios_version: "6.0"
  },
  {
    emoji: "〰️",
    description: "wavy dash",
    category: "Symbols",
    aliases: ["wavy_dash"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "💱",
    description: "currency exchange",
    category: "Symbols",
    aliases: ["currency_exchange"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💲",
    description: "heavy dollar sign",
    category: "Symbols",
    aliases: ["heavy_dollar_sign"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "⚕️",
    description: "medical symbol",
    category: "Symbols",
    aliases: ["medical_symbol"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "♻️",
    description: "recycling symbol",
    category: "Symbols",
    aliases: ["recycle"],
    tags: ["environment", "green"],
    unicode_version: "3.2",
    ios_version: "6.0"
  },
  {
    emoji: "⚜️",
    description: "fleur-de-lis",
    category: "Symbols",
    aliases: ["fleur_de_lis"],
    tags: [],
    unicode_version: "4.1",
    ios_version: "9.1"
  },
  {
    emoji: "🔱",
    description: "trident emblem",
    category: "Symbols",
    aliases: ["trident"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "📛",
    description: "name badge",
    category: "Symbols",
    aliases: ["name_badge"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔰",
    description: "Japanese symbol for beginner",
    category: "Symbols",
    aliases: ["beginner"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "⭕",
    description: "hollow red circle",
    category: "Symbols",
    aliases: ["o"],
    tags: [],
    unicode_version: "5.2",
    ios_version: "6.0"
  },
  {
    emoji: "✅",
    description: "check mark button",
    category: "Symbols",
    aliases: ["white_check_mark"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "☑️",
    description: "check box with check",
    category: "Symbols",
    aliases: ["ballot_box_with_check"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "✔️",
    description: "check mark",
    category: "Symbols",
    aliases: ["heavy_check_mark"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "❌",
    description: "cross mark",
    category: "Symbols",
    aliases: ["x"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "❎",
    description: "cross mark button",
    category: "Symbols",
    aliases: ["negative_squared_cross_mark"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "➰",
    description: "curly loop",
    category: "Symbols",
    aliases: ["curly_loop"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "➿",
    description: "double curly loop",
    category: "Symbols",
    aliases: ["loop"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "〽️",
    description: "part alternation mark",
    category: "Symbols",
    aliases: ["part_alternation_mark"],
    tags: [],
    unicode_version: "3.2",
    ios_version: "6.0"
  },
  {
    emoji: "✳️",
    description: "eight-spoked asterisk",
    category: "Symbols",
    aliases: ["eight_spoked_asterisk"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "✴️",
    description: "eight-pointed star",
    category: "Symbols",
    aliases: ["eight_pointed_black_star"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "❇️",
    description: "sparkle",
    category: "Symbols",
    aliases: ["sparkle"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "©️",
    description: "copyright",
    category: "Symbols",
    aliases: ["copyright"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "®️",
    description: "registered",
    category: "Symbols",
    aliases: ["registered"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "™️",
    description: "trade mark",
    category: "Symbols",
    aliases: ["tm"],
    tags: ["trademark"],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "#️⃣",
    description: "keycap: #",
    category: "Symbols",
    aliases: ["hash"],
    tags: ["number"],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "*️⃣",
    description: "keycap: *",
    category: "Symbols",
    aliases: ["asterisk"],
    tags: [],
    unicode_version: "",
    ios_version: "9.1"
  },
  {
    emoji: "0️⃣",
    description: "keycap: 0",
    category: "Symbols",
    aliases: ["zero"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "1️⃣",
    description: "keycap: 1",
    category: "Symbols",
    aliases: ["one"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "2️⃣",
    description: "keycap: 2",
    category: "Symbols",
    aliases: ["two"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "3️⃣",
    description: "keycap: 3",
    category: "Symbols",
    aliases: ["three"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "4️⃣",
    description: "keycap: 4",
    category: "Symbols",
    aliases: ["four"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "5️⃣",
    description: "keycap: 5",
    category: "Symbols",
    aliases: ["five"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "6️⃣",
    description: "keycap: 6",
    category: "Symbols",
    aliases: ["six"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "7️⃣",
    description: "keycap: 7",
    category: "Symbols",
    aliases: ["seven"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "8️⃣",
    description: "keycap: 8",
    category: "Symbols",
    aliases: ["eight"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "9️⃣",
    description: "keycap: 9",
    category: "Symbols",
    aliases: ["nine"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "🔟",
    description: "keycap: 10",
    category: "Symbols",
    aliases: ["keycap_ten"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔠",
    description: "input latin uppercase",
    category: "Symbols",
    aliases: ["capital_abcd"],
    tags: ["letters"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔡",
    description: "input latin lowercase",
    category: "Symbols",
    aliases: ["abcd"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔢",
    description: "input numbers",
    category: "Symbols",
    aliases: ["1234"],
    tags: ["numbers"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔣",
    description: "input symbols",
    category: "Symbols",
    aliases: ["symbols"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔤",
    description: "input latin letters",
    category: "Symbols",
    aliases: ["abc"],
    tags: ["alphabet"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🅰️",
    description: "A button (blood type)",
    category: "Symbols",
    aliases: ["a"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🆎",
    description: "AB button (blood type)",
    category: "Symbols",
    aliases: ["ab"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🅱️",
    description: "B button (blood type)",
    category: "Symbols",
    aliases: ["b"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🆑",
    description: "CL button",
    category: "Symbols",
    aliases: ["cl"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🆒",
    description: "COOL button",
    category: "Symbols",
    aliases: ["cool"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🆓",
    description: "FREE button",
    category: "Symbols",
    aliases: ["free"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "ℹ️",
    description: "information",
    category: "Symbols",
    aliases: ["information_source"],
    tags: [],
    unicode_version: "3.0",
    ios_version: "6.0"
  },
  {
    emoji: "🆔",
    description: "ID button",
    category: "Symbols",
    aliases: ["id"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "Ⓜ️",
    description: "circled M",
    category: "Symbols",
    aliases: ["m"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "🆕",
    description: "NEW button",
    category: "Symbols",
    aliases: ["new"],
    tags: ["fresh"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🆖",
    description: "NG button",
    category: "Symbols",
    aliases: ["ng"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🅾️",
    description: "O button (blood type)",
    category: "Symbols",
    aliases: ["o2"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🆗",
    description: "OK button",
    category: "Symbols",
    aliases: ["ok"],
    tags: ["yes"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🅿️",
    description: "P button",
    category: "Symbols",
    aliases: ["parking"],
    tags: [],
    unicode_version: "5.2",
    ios_version: "6.0"
  },
  {
    emoji: "🆘",
    description: "SOS button",
    category: "Symbols",
    aliases: ["sos"],
    tags: ["help", "emergency"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🆙",
    description: "UP! button",
    category: "Symbols",
    aliases: ["up"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🆚",
    description: "VS button",
    category: "Symbols",
    aliases: ["vs"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🈁",
    description: "Japanese “here” button",
    category: "Symbols",
    aliases: ["koko"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🈂️",
    description: "Japanese “service charge” button",
    category: "Symbols",
    aliases: ["sa"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🈷️",
    description: "Japanese “monthly amount” button",
    category: "Symbols",
    aliases: ["u6708"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🈶",
    description: "Japanese “not free of charge” button",
    category: "Symbols",
    aliases: ["u6709"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🈯",
    description: "Japanese “reserved” button",
    category: "Symbols",
    aliases: ["u6307"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "🉐",
    description: "Japanese “bargain” button",
    category: "Symbols",
    aliases: ["ideograph_advantage"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🈹",
    description: "Japanese “discount” button",
    category: "Symbols",
    aliases: ["u5272"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🈚",
    description: "Japanese “free of charge” button",
    category: "Symbols",
    aliases: ["u7121"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "🈲",
    description: "Japanese “prohibited” button",
    category: "Symbols",
    aliases: ["u7981"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🉑",
    description: "Japanese “acceptable” button",
    category: "Symbols",
    aliases: ["accept"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🈸",
    description: "Japanese “application” button",
    category: "Symbols",
    aliases: ["u7533"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🈴",
    description: "Japanese “passing grade” button",
    category: "Symbols",
    aliases: ["u5408"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🈳",
    description: "Japanese “vacancy” button",
    category: "Symbols",
    aliases: ["u7a7a"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "㊗️",
    description: "Japanese “congratulations” button",
    category: "Symbols",
    aliases: ["congratulations"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "㊙️",
    description: "Japanese “secret” button",
    category: "Symbols",
    aliases: ["secret"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "🈺",
    description: "Japanese “open for business” button",
    category: "Symbols",
    aliases: ["u55b6"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🈵",
    description: "Japanese “no vacancy” button",
    category: "Symbols",
    aliases: ["u6e80"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔴",
    description: "red circle",
    category: "Symbols",
    aliases: ["red_circle"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🟠",
    description: "orange circle",
    category: "Symbols",
    aliases: ["orange_circle"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🟡",
    description: "yellow circle",
    category: "Symbols",
    aliases: ["yellow_circle"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🟢",
    description: "green circle",
    category: "Symbols",
    aliases: ["green_circle"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🔵",
    description: "blue circle",
    category: "Symbols",
    aliases: ["large_blue_circle"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🟣",
    description: "purple circle",
    category: "Symbols",
    aliases: ["purple_circle"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🟤",
    description: "brown circle",
    category: "Symbols",
    aliases: ["brown_circle"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "⚫",
    description: "black circle",
    category: "Symbols",
    aliases: ["black_circle"],
    tags: [],
    unicode_version: "4.1",
    ios_version: "6.0"
  },
  {
    emoji: "⚪",
    description: "white circle",
    category: "Symbols",
    aliases: ["white_circle"],
    tags: [],
    unicode_version: "4.1",
    ios_version: "6.0"
  },
  {
    emoji: "🟥",
    description: "red square",
    category: "Symbols",
    aliases: ["red_square"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🟧",
    description: "orange square",
    category: "Symbols",
    aliases: ["orange_square"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🟨",
    description: "yellow square",
    category: "Symbols",
    aliases: ["yellow_square"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🟩",
    description: "green square",
    category: "Symbols",
    aliases: ["green_square"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🟦",
    description: "blue square",
    category: "Symbols",
    aliases: ["blue_square"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🟪",
    description: "purple square",
    category: "Symbols",
    aliases: ["purple_square"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "🟫",
    description: "brown square",
    category: "Symbols",
    aliases: ["brown_square"],
    tags: [],
    unicode_version: "12.0",
    ios_version: "13.0"
  },
  {
    emoji: "⬛",
    description: "black large square",
    category: "Symbols",
    aliases: ["black_large_square"],
    tags: [],
    unicode_version: "5.1",
    ios_version: "6.0"
  },
  {
    emoji: "⬜",
    description: "white large square",
    category: "Symbols",
    aliases: ["white_large_square"],
    tags: [],
    unicode_version: "5.1",
    ios_version: "6.0"
  },
  {
    emoji: "◼️",
    description: "black medium square",
    category: "Symbols",
    aliases: ["black_medium_square"],
    tags: [],
    unicode_version: "3.2",
    ios_version: "6.0"
  },
  {
    emoji: "◻️",
    description: "white medium square",
    category: "Symbols",
    aliases: ["white_medium_square"],
    tags: [],
    unicode_version: "3.2",
    ios_version: "6.0"
  },
  {
    emoji: "◾",
    description: "black medium-small square",
    category: "Symbols",
    aliases: ["black_medium_small_square"],
    tags: [],
    unicode_version: "3.2",
    ios_version: "6.0"
  },
  {
    emoji: "◽",
    description: "white medium-small square",
    category: "Symbols",
    aliases: ["white_medium_small_square"],
    tags: [],
    unicode_version: "3.2",
    ios_version: "6.0"
  },
  {
    emoji: "▪️",
    description: "black small square",
    category: "Symbols",
    aliases: ["black_small_square"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "▫️",
    description: "white small square",
    category: "Symbols",
    aliases: ["white_small_square"],
    tags: [],
    unicode_version: "",
    ios_version: "6.0"
  },
  {
    emoji: "🔶",
    description: "large orange diamond",
    category: "Symbols",
    aliases: ["large_orange_diamond"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔷",
    description: "large blue diamond",
    category: "Symbols",
    aliases: ["large_blue_diamond"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔸",
    description: "small orange diamond",
    category: "Symbols",
    aliases: ["small_orange_diamond"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔹",
    description: "small blue diamond",
    category: "Symbols",
    aliases: ["small_blue_diamond"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔺",
    description: "red triangle pointed up",
    category: "Symbols",
    aliases: ["small_red_triangle"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔻",
    description: "red triangle pointed down",
    category: "Symbols",
    aliases: ["small_red_triangle_down"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "💠",
    description: "diamond with a dot",
    category: "Symbols",
    aliases: ["diamond_shape_with_a_dot_inside"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔘",
    description: "radio button",
    category: "Symbols",
    aliases: ["radio_button"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔳",
    description: "white square button",
    category: "Symbols",
    aliases: ["white_square_button"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🔲",
    description: "black square button",
    category: "Symbols",
    aliases: ["black_square_button"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏁",
    description: "chequered flag",
    category: "Flags",
    aliases: ["checkered_flag"],
    tags: ["milestone", "finish"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🚩",
    description: "triangular flag",
    category: "Flags",
    aliases: ["triangular_flag_on_post"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🎌",
    description: "crossed flags",
    category: "Flags",
    aliases: ["crossed_flags"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🏴",
    description: "black flag",
    category: "Flags",
    aliases: ["black_flag"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🏳️",
    description: "white flag",
    category: "Flags",
    aliases: ["white_flag"],
    tags: [],
    unicode_version: "7.0",
    ios_version: "9.1"
  },
  {
    emoji: "🏳️‍🌈",
    description: "rainbow flag",
    category: "Flags",
    aliases: ["rainbow_flag"],
    tags: ["pride"],
    unicode_version: "6.0",
    ios_version: "10.0"
  },
  {
    emoji: "🏳️‍⚧️",
    description: "transgender flag",
    category: "Flags",
    aliases: ["transgender_flag"],
    tags: [],
    unicode_version: "13.0",
    ios_version: "14.0"
  },
  {
    emoji: "🏴‍☠️",
    description: "pirate flag",
    category: "Flags",
    aliases: ["pirate_flag"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🇦🇨",
    description: "flag: Ascension Island",
    category: "Flags",
    aliases: ["ascension_island"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🇦🇩",
    description: "flag: Andorra",
    category: "Flags",
    aliases: ["andorra"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇦🇪",
    description: "flag: United Arab Emirates",
    category: "Flags",
    aliases: ["united_arab_emirates"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇦🇫",
    description: "flag: Afghanistan",
    category: "Flags",
    aliases: ["afghanistan"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇦🇬",
    description: "flag: Antigua & Barbuda",
    category: "Flags",
    aliases: ["antigua_barbuda"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇦🇮",
    description: "flag: Anguilla",
    category: "Flags",
    aliases: ["anguilla"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇦🇱",
    description: "flag: Albania",
    category: "Flags",
    aliases: ["albania"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇦🇲",
    description: "flag: Armenia",
    category: "Flags",
    aliases: ["armenia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇦🇴",
    description: "flag: Angola",
    category: "Flags",
    aliases: ["angola"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇦🇶",
    description: "flag: Antarctica",
    category: "Flags",
    aliases: ["antarctica"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇦🇷",
    description: "flag: Argentina",
    category: "Flags",
    aliases: ["argentina"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇦🇸",
    description: "flag: American Samoa",
    category: "Flags",
    aliases: ["american_samoa"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇦🇹",
    description: "flag: Austria",
    category: "Flags",
    aliases: ["austria"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇦🇺",
    description: "flag: Australia",
    category: "Flags",
    aliases: ["australia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇦🇼",
    description: "flag: Aruba",
    category: "Flags",
    aliases: ["aruba"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇦🇽",
    description: "flag: Åland Islands",
    category: "Flags",
    aliases: ["aland_islands"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇦🇿",
    description: "flag: Azerbaijan",
    category: "Flags",
    aliases: ["azerbaijan"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇦",
    description: "flag: Bosnia & Herzegovina",
    category: "Flags",
    aliases: ["bosnia_herzegovina"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇧",
    description: "flag: Barbados",
    category: "Flags",
    aliases: ["barbados"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇩",
    description: "flag: Bangladesh",
    category: "Flags",
    aliases: ["bangladesh"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇪",
    description: "flag: Belgium",
    category: "Flags",
    aliases: ["belgium"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇫",
    description: "flag: Burkina Faso",
    category: "Flags",
    aliases: ["burkina_faso"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇬",
    description: "flag: Bulgaria",
    category: "Flags",
    aliases: ["bulgaria"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇭",
    description: "flag: Bahrain",
    category: "Flags",
    aliases: ["bahrain"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇮",
    description: "flag: Burundi",
    category: "Flags",
    aliases: ["burundi"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇯",
    description: "flag: Benin",
    category: "Flags",
    aliases: ["benin"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇱",
    description: "flag: St. Barthélemy",
    category: "Flags",
    aliases: ["st_barthelemy"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇧🇲",
    description: "flag: Bermuda",
    category: "Flags",
    aliases: ["bermuda"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇳",
    description: "flag: Brunei",
    category: "Flags",
    aliases: ["brunei"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇴",
    description: "flag: Bolivia",
    category: "Flags",
    aliases: ["bolivia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇶",
    description: "flag: Caribbean Netherlands",
    category: "Flags",
    aliases: ["caribbean_netherlands"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇧🇷",
    description: "flag: Brazil",
    category: "Flags",
    aliases: ["brazil"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇸",
    description: "flag: Bahamas",
    category: "Flags",
    aliases: ["bahamas"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇹",
    description: "flag: Bhutan",
    category: "Flags",
    aliases: ["bhutan"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇻",
    description: "flag: Bouvet Island",
    category: "Flags",
    aliases: ["bouvet_island"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🇧🇼",
    description: "flag: Botswana",
    category: "Flags",
    aliases: ["botswana"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇾",
    description: "flag: Belarus",
    category: "Flags",
    aliases: ["belarus"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇧🇿",
    description: "flag: Belize",
    category: "Flags",
    aliases: ["belize"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇨🇦",
    description: "flag: Canada",
    category: "Flags",
    aliases: ["canada"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇨🇨",
    description: "flag: Cocos (Keeling) Islands",
    category: "Flags",
    aliases: ["cocos_islands"],
    tags: ["keeling"],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇨🇩",
    description: "flag: Congo - Kinshasa",
    category: "Flags",
    aliases: ["congo_kinshasa"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇨🇫",
    description: "flag: Central African Republic",
    category: "Flags",
    aliases: ["central_african_republic"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇨🇬",
    description: "flag: Congo - Brazzaville",
    category: "Flags",
    aliases: ["congo_brazzaville"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇨🇭",
    description: "flag: Switzerland",
    category: "Flags",
    aliases: ["switzerland"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇨🇮",
    description: "flag: Côte d’Ivoire",
    category: "Flags",
    aliases: ["cote_divoire"],
    tags: ["ivory"],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇨🇰",
    description: "flag: Cook Islands",
    category: "Flags",
    aliases: ["cook_islands"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇨🇱",
    description: "flag: Chile",
    category: "Flags",
    aliases: ["chile"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇨🇲",
    description: "flag: Cameroon",
    category: "Flags",
    aliases: ["cameroon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇨🇳",
    description: "flag: China",
    category: "Flags",
    aliases: ["cn"],
    tags: ["china"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🇨🇴",
    description: "flag: Colombia",
    category: "Flags",
    aliases: ["colombia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇨🇵",
    description: "flag: Clipperton Island",
    category: "Flags",
    aliases: ["clipperton_island"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🇨🇷",
    description: "flag: Costa Rica",
    category: "Flags",
    aliases: ["costa_rica"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇨🇺",
    description: "flag: Cuba",
    category: "Flags",
    aliases: ["cuba"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇨🇻",
    description: "flag: Cape Verde",
    category: "Flags",
    aliases: ["cape_verde"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇨🇼",
    description: "flag: Curaçao",
    category: "Flags",
    aliases: ["curacao"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇨🇽",
    description: "flag: Christmas Island",
    category: "Flags",
    aliases: ["christmas_island"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇨🇾",
    description: "flag: Cyprus",
    category: "Flags",
    aliases: ["cyprus"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇨🇿",
    description: "flag: Czechia",
    category: "Flags",
    aliases: ["czech_republic"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇩🇪",
    description: "flag: Germany",
    category: "Flags",
    aliases: ["de"],
    tags: ["flag", "germany"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🇩🇬",
    description: "flag: Diego Garcia",
    category: "Flags",
    aliases: ["diego_garcia"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🇩🇯",
    description: "flag: Djibouti",
    category: "Flags",
    aliases: ["djibouti"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇩🇰",
    description: "flag: Denmark",
    category: "Flags",
    aliases: ["denmark"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇩🇲",
    description: "flag: Dominica",
    category: "Flags",
    aliases: ["dominica"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇩🇴",
    description: "flag: Dominican Republic",
    category: "Flags",
    aliases: ["dominican_republic"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇩🇿",
    description: "flag: Algeria",
    category: "Flags",
    aliases: ["algeria"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇪🇦",
    description: "flag: Ceuta & Melilla",
    category: "Flags",
    aliases: ["ceuta_melilla"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🇪🇨",
    description: "flag: Ecuador",
    category: "Flags",
    aliases: ["ecuador"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇪🇪",
    description: "flag: Estonia",
    category: "Flags",
    aliases: ["estonia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇪🇬",
    description: "flag: Egypt",
    category: "Flags",
    aliases: ["egypt"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇪🇭",
    description: "flag: Western Sahara",
    category: "Flags",
    aliases: ["western_sahara"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇪🇷",
    description: "flag: Eritrea",
    category: "Flags",
    aliases: ["eritrea"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇪🇸",
    description: "flag: Spain",
    category: "Flags",
    aliases: ["es"],
    tags: ["spain"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🇪🇹",
    description: "flag: Ethiopia",
    category: "Flags",
    aliases: ["ethiopia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇪🇺",
    description: "flag: European Union",
    category: "Flags",
    aliases: ["eu", "european_union"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇫🇮",
    description: "flag: Finland",
    category: "Flags",
    aliases: ["finland"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇫🇯",
    description: "flag: Fiji",
    category: "Flags",
    aliases: ["fiji"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇫🇰",
    description: "flag: Falkland Islands",
    category: "Flags",
    aliases: ["falkland_islands"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇫🇲",
    description: "flag: Micronesia",
    category: "Flags",
    aliases: ["micronesia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇫🇴",
    description: "flag: Faroe Islands",
    category: "Flags",
    aliases: ["faroe_islands"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇫🇷",
    description: "flag: France",
    category: "Flags",
    aliases: ["fr"],
    tags: ["france", "french"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🇬🇦",
    description: "flag: Gabon",
    category: "Flags",
    aliases: ["gabon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇬🇧",
    description: "flag: United Kingdom",
    category: "Flags",
    aliases: ["gb", "uk"],
    tags: ["flag", "british"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🇬🇩",
    description: "flag: Grenada",
    category: "Flags",
    aliases: ["grenada"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇬🇪",
    description: "flag: Georgia",
    category: "Flags",
    aliases: ["georgia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇬🇫",
    description: "flag: French Guiana",
    category: "Flags",
    aliases: ["french_guiana"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇬🇬",
    description: "flag: Guernsey",
    category: "Flags",
    aliases: ["guernsey"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇬🇭",
    description: "flag: Ghana",
    category: "Flags",
    aliases: ["ghana"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇬🇮",
    description: "flag: Gibraltar",
    category: "Flags",
    aliases: ["gibraltar"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇬🇱",
    description: "flag: Greenland",
    category: "Flags",
    aliases: ["greenland"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇬🇲",
    description: "flag: Gambia",
    category: "Flags",
    aliases: ["gambia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇬🇳",
    description: "flag: Guinea",
    category: "Flags",
    aliases: ["guinea"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇬🇵",
    description: "flag: Guadeloupe",
    category: "Flags",
    aliases: ["guadeloupe"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇬🇶",
    description: "flag: Equatorial Guinea",
    category: "Flags",
    aliases: ["equatorial_guinea"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇬🇷",
    description: "flag: Greece",
    category: "Flags",
    aliases: ["greece"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇬🇸",
    description: "flag: South Georgia & South Sandwich Islands",
    category: "Flags",
    aliases: ["south_georgia_south_sandwich_islands"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇬🇹",
    description: "flag: Guatemala",
    category: "Flags",
    aliases: ["guatemala"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇬🇺",
    description: "flag: Guam",
    category: "Flags",
    aliases: ["guam"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇬🇼",
    description: "flag: Guinea-Bissau",
    category: "Flags",
    aliases: ["guinea_bissau"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇬🇾",
    description: "flag: Guyana",
    category: "Flags",
    aliases: ["guyana"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇭🇰",
    description: "flag: Hong Kong SAR China",
    category: "Flags",
    aliases: ["hong_kong"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇭🇲",
    description: "flag: Heard & McDonald Islands",
    category: "Flags",
    aliases: ["heard_mcdonald_islands"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🇭🇳",
    description: "flag: Honduras",
    category: "Flags",
    aliases: ["honduras"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇭🇷",
    description: "flag: Croatia",
    category: "Flags",
    aliases: ["croatia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇭🇹",
    description: "flag: Haiti",
    category: "Flags",
    aliases: ["haiti"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇭🇺",
    description: "flag: Hungary",
    category: "Flags",
    aliases: ["hungary"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇮🇨",
    description: "flag: Canary Islands",
    category: "Flags",
    aliases: ["canary_islands"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇮🇩",
    description: "flag: Indonesia",
    category: "Flags",
    aliases: ["indonesia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇮🇪",
    description: "flag: Ireland",
    category: "Flags",
    aliases: ["ireland"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇮🇱",
    description: "flag: Israel",
    category: "Flags",
    aliases: ["israel"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇮🇲",
    description: "flag: Isle of Man",
    category: "Flags",
    aliases: ["isle_of_man"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇮🇳",
    description: "flag: India",
    category: "Flags",
    aliases: ["india"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇮🇴",
    description: "flag: British Indian Ocean Territory",
    category: "Flags",
    aliases: ["british_indian_ocean_territory"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇮🇶",
    description: "flag: Iraq",
    category: "Flags",
    aliases: ["iraq"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇮🇷",
    description: "flag: Iran",
    category: "Flags",
    aliases: ["iran"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇮🇸",
    description: "flag: Iceland",
    category: "Flags",
    aliases: ["iceland"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇮🇹",
    description: "flag: Italy",
    category: "Flags",
    aliases: ["it"],
    tags: ["italy"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🇯🇪",
    description: "flag: Jersey",
    category: "Flags",
    aliases: ["jersey"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇯🇲",
    description: "flag: Jamaica",
    category: "Flags",
    aliases: ["jamaica"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇯🇴",
    description: "flag: Jordan",
    category: "Flags",
    aliases: ["jordan"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇯🇵",
    description: "flag: Japan",
    category: "Flags",
    aliases: ["jp"],
    tags: ["japan"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🇰🇪",
    description: "flag: Kenya",
    category: "Flags",
    aliases: ["kenya"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇰🇬",
    description: "flag: Kyrgyzstan",
    category: "Flags",
    aliases: ["kyrgyzstan"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇰🇭",
    description: "flag: Cambodia",
    category: "Flags",
    aliases: ["cambodia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇰🇮",
    description: "flag: Kiribati",
    category: "Flags",
    aliases: ["kiribati"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇰🇲",
    description: "flag: Comoros",
    category: "Flags",
    aliases: ["comoros"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇰🇳",
    description: "flag: St. Kitts & Nevis",
    category: "Flags",
    aliases: ["st_kitts_nevis"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇰🇵",
    description: "flag: North Korea",
    category: "Flags",
    aliases: ["north_korea"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇰🇷",
    description: "flag: South Korea",
    category: "Flags",
    aliases: ["kr"],
    tags: ["korea"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🇰🇼",
    description: "flag: Kuwait",
    category: "Flags",
    aliases: ["kuwait"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇰🇾",
    description: "flag: Cayman Islands",
    category: "Flags",
    aliases: ["cayman_islands"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇰🇿",
    description: "flag: Kazakhstan",
    category: "Flags",
    aliases: ["kazakhstan"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇱🇦",
    description: "flag: Laos",
    category: "Flags",
    aliases: ["laos"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇱🇧",
    description: "flag: Lebanon",
    category: "Flags",
    aliases: ["lebanon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇱🇨",
    description: "flag: St. Lucia",
    category: "Flags",
    aliases: ["st_lucia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇱🇮",
    description: "flag: Liechtenstein",
    category: "Flags",
    aliases: ["liechtenstein"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇱🇰",
    description: "flag: Sri Lanka",
    category: "Flags",
    aliases: ["sri_lanka"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇱🇷",
    description: "flag: Liberia",
    category: "Flags",
    aliases: ["liberia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇱🇸",
    description: "flag: Lesotho",
    category: "Flags",
    aliases: ["lesotho"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇱🇹",
    description: "flag: Lithuania",
    category: "Flags",
    aliases: ["lithuania"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇱🇺",
    description: "flag: Luxembourg",
    category: "Flags",
    aliases: ["luxembourg"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇱🇻",
    description: "flag: Latvia",
    category: "Flags",
    aliases: ["latvia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇱🇾",
    description: "flag: Libya",
    category: "Flags",
    aliases: ["libya"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇦",
    description: "flag: Morocco",
    category: "Flags",
    aliases: ["morocco"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇨",
    description: "flag: Monaco",
    category: "Flags",
    aliases: ["monaco"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇲🇩",
    description: "flag: Moldova",
    category: "Flags",
    aliases: ["moldova"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇪",
    description: "flag: Montenegro",
    category: "Flags",
    aliases: ["montenegro"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇫",
    description: "flag: St. Martin",
    category: "Flags",
    aliases: ["st_martin"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🇲🇬",
    description: "flag: Madagascar",
    category: "Flags",
    aliases: ["madagascar"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇭",
    description: "flag: Marshall Islands",
    category: "Flags",
    aliases: ["marshall_islands"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇲🇰",
    description: "flag: North Macedonia",
    category: "Flags",
    aliases: ["macedonia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇱",
    description: "flag: Mali",
    category: "Flags",
    aliases: ["mali"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇲",
    description: "flag: Myanmar (Burma)",
    category: "Flags",
    aliases: ["myanmar"],
    tags: ["burma"],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇳",
    description: "flag: Mongolia",
    category: "Flags",
    aliases: ["mongolia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇴",
    description: "flag: Macao SAR China",
    category: "Flags",
    aliases: ["macau"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇵",
    description: "flag: Northern Mariana Islands",
    category: "Flags",
    aliases: ["northern_mariana_islands"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇶",
    description: "flag: Martinique",
    category: "Flags",
    aliases: ["martinique"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇲🇷",
    description: "flag: Mauritania",
    category: "Flags",
    aliases: ["mauritania"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇸",
    description: "flag: Montserrat",
    category: "Flags",
    aliases: ["montserrat"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇹",
    description: "flag: Malta",
    category: "Flags",
    aliases: ["malta"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇺",
    description: "flag: Mauritius",
    category: "Flags",
    aliases: ["mauritius"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇲🇻",
    description: "flag: Maldives",
    category: "Flags",
    aliases: ["maldives"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇼",
    description: "flag: Malawi",
    category: "Flags",
    aliases: ["malawi"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇽",
    description: "flag: Mexico",
    category: "Flags",
    aliases: ["mexico"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇾",
    description: "flag: Malaysia",
    category: "Flags",
    aliases: ["malaysia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇲🇿",
    description: "flag: Mozambique",
    category: "Flags",
    aliases: ["mozambique"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇳🇦",
    description: "flag: Namibia",
    category: "Flags",
    aliases: ["namibia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇳🇨",
    description: "flag: New Caledonia",
    category: "Flags",
    aliases: ["new_caledonia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇳🇪",
    description: "flag: Niger",
    category: "Flags",
    aliases: ["niger"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇳🇫",
    description: "flag: Norfolk Island",
    category: "Flags",
    aliases: ["norfolk_island"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇳🇬",
    description: "flag: Nigeria",
    category: "Flags",
    aliases: ["nigeria"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇳🇮",
    description: "flag: Nicaragua",
    category: "Flags",
    aliases: ["nicaragua"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇳🇱",
    description: "flag: Netherlands",
    category: "Flags",
    aliases: ["netherlands"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇳🇴",
    description: "flag: Norway",
    category: "Flags",
    aliases: ["norway"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇳🇵",
    description: "flag: Nepal",
    category: "Flags",
    aliases: ["nepal"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇳🇷",
    description: "flag: Nauru",
    category: "Flags",
    aliases: ["nauru"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇳🇺",
    description: "flag: Niue",
    category: "Flags",
    aliases: ["niue"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇳🇿",
    description: "flag: New Zealand",
    category: "Flags",
    aliases: ["new_zealand"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇴🇲",
    description: "flag: Oman",
    category: "Flags",
    aliases: ["oman"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇵🇦",
    description: "flag: Panama",
    category: "Flags",
    aliases: ["panama"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇵🇪",
    description: "flag: Peru",
    category: "Flags",
    aliases: ["peru"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇵🇫",
    description: "flag: French Polynesia",
    category: "Flags",
    aliases: ["french_polynesia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇵🇬",
    description: "flag: Papua New Guinea",
    category: "Flags",
    aliases: ["papua_new_guinea"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇵🇭",
    description: "flag: Philippines",
    category: "Flags",
    aliases: ["philippines"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇵🇰",
    description: "flag: Pakistan",
    category: "Flags",
    aliases: ["pakistan"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇵🇱",
    description: "flag: Poland",
    category: "Flags",
    aliases: ["poland"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇵🇲",
    description: "flag: St. Pierre & Miquelon",
    category: "Flags",
    aliases: ["st_pierre_miquelon"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇵🇳",
    description: "flag: Pitcairn Islands",
    category: "Flags",
    aliases: ["pitcairn_islands"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇵🇷",
    description: "flag: Puerto Rico",
    category: "Flags",
    aliases: ["puerto_rico"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇵🇸",
    description: "flag: Palestinian Territories",
    category: "Flags",
    aliases: ["palestinian_territories"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇵🇹",
    description: "flag: Portugal",
    category: "Flags",
    aliases: ["portugal"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇵🇼",
    description: "flag: Palau",
    category: "Flags",
    aliases: ["palau"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇵🇾",
    description: "flag: Paraguay",
    category: "Flags",
    aliases: ["paraguay"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇶🇦",
    description: "flag: Qatar",
    category: "Flags",
    aliases: ["qatar"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇷🇪",
    description: "flag: Réunion",
    category: "Flags",
    aliases: ["reunion"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇷🇴",
    description: "flag: Romania",
    category: "Flags",
    aliases: ["romania"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇷🇸",
    description: "flag: Serbia",
    category: "Flags",
    aliases: ["serbia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇷🇺",
    description: "flag: Russia",
    category: "Flags",
    aliases: ["ru"],
    tags: ["russia"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🇷🇼",
    description: "flag: Rwanda",
    category: "Flags",
    aliases: ["rwanda"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇦",
    description: "flag: Saudi Arabia",
    category: "Flags",
    aliases: ["saudi_arabia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇧",
    description: "flag: Solomon Islands",
    category: "Flags",
    aliases: ["solomon_islands"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇨",
    description: "flag: Seychelles",
    category: "Flags",
    aliases: ["seychelles"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇩",
    description: "flag: Sudan",
    category: "Flags",
    aliases: ["sudan"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇪",
    description: "flag: Sweden",
    category: "Flags",
    aliases: ["sweden"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇬",
    description: "flag: Singapore",
    category: "Flags",
    aliases: ["singapore"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇭",
    description: "flag: St. Helena",
    category: "Flags",
    aliases: ["st_helena"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇸🇮",
    description: "flag: Slovenia",
    category: "Flags",
    aliases: ["slovenia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇯",
    description: "flag: Svalbard & Jan Mayen",
    category: "Flags",
    aliases: ["svalbard_jan_mayen"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🇸🇰",
    description: "flag: Slovakia",
    category: "Flags",
    aliases: ["slovakia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇱",
    description: "flag: Sierra Leone",
    category: "Flags",
    aliases: ["sierra_leone"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇲",
    description: "flag: San Marino",
    category: "Flags",
    aliases: ["san_marino"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇳",
    description: "flag: Senegal",
    category: "Flags",
    aliases: ["senegal"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇴",
    description: "flag: Somalia",
    category: "Flags",
    aliases: ["somalia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇷",
    description: "flag: Suriname",
    category: "Flags",
    aliases: ["suriname"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇸",
    description: "flag: South Sudan",
    category: "Flags",
    aliases: ["south_sudan"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇹",
    description: "flag: São Tomé & Príncipe",
    category: "Flags",
    aliases: ["sao_tome_principe"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇻",
    description: "flag: El Salvador",
    category: "Flags",
    aliases: ["el_salvador"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇽",
    description: "flag: Sint Maarten",
    category: "Flags",
    aliases: ["sint_maarten"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇾",
    description: "flag: Syria",
    category: "Flags",
    aliases: ["syria"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇸🇿",
    description: "flag: Eswatini",
    category: "Flags",
    aliases: ["swaziland"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇹🇦",
    description: "flag: Tristan da Cunha",
    category: "Flags",
    aliases: ["tristan_da_cunha"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🇹🇨",
    description: "flag: Turks & Caicos Islands",
    category: "Flags",
    aliases: ["turks_caicos_islands"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇹🇩",
    description: "flag: Chad",
    category: "Flags",
    aliases: ["chad"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇹🇫",
    description: "flag: French Southern Territories",
    category: "Flags",
    aliases: ["french_southern_territories"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇹🇬",
    description: "flag: Togo",
    category: "Flags",
    aliases: ["togo"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇹🇭",
    description: "flag: Thailand",
    category: "Flags",
    aliases: ["thailand"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇹🇯",
    description: "flag: Tajikistan",
    category: "Flags",
    aliases: ["tajikistan"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇹🇰",
    description: "flag: Tokelau",
    category: "Flags",
    aliases: ["tokelau"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇹🇱",
    description: "flag: Timor-Leste",
    category: "Flags",
    aliases: ["timor_leste"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇹🇲",
    description: "flag: Turkmenistan",
    category: "Flags",
    aliases: ["turkmenistan"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇹🇳",
    description: "flag: Tunisia",
    category: "Flags",
    aliases: ["tunisia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇹🇴",
    description: "flag: Tonga",
    category: "Flags",
    aliases: ["tonga"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇹🇷",
    description: "flag: Turkey",
    category: "Flags",
    aliases: ["tr"],
    tags: ["turkey"],
    unicode_version: "8.0",
    ios_version: "9.1"
  },
  {
    emoji: "🇹🇹",
    description: "flag: Trinidad & Tobago",
    category: "Flags",
    aliases: ["trinidad_tobago"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇹🇻",
    description: "flag: Tuvalu",
    category: "Flags",
    aliases: ["tuvalu"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇹🇼",
    description: "flag: Taiwan",
    category: "Flags",
    aliases: ["taiwan"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇹🇿",
    description: "flag: Tanzania",
    category: "Flags",
    aliases: ["tanzania"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇺🇦",
    description: "flag: Ukraine",
    category: "Flags",
    aliases: ["ukraine"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇺🇬",
    description: "flag: Uganda",
    category: "Flags",
    aliases: ["uganda"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇺🇲",
    description: "flag: U.S. Outlying Islands",
    category: "Flags",
    aliases: ["us_outlying_islands"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🇺🇳",
    description: "flag: United Nations",
    category: "Flags",
    aliases: ["united_nations"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🇺🇸",
    description: "flag: United States",
    category: "Flags",
    aliases: ["us"],
    tags: ["flag", "united", "america"],
    unicode_version: "6.0",
    ios_version: "6.0"
  },
  {
    emoji: "🇺🇾",
    description: "flag: Uruguay",
    category: "Flags",
    aliases: ["uruguay"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇺🇿",
    description: "flag: Uzbekistan",
    category: "Flags",
    aliases: ["uzbekistan"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇻🇦",
    description: "flag: Vatican City",
    category: "Flags",
    aliases: ["vatican_city"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇻🇨",
    description: "flag: St. Vincent & Grenadines",
    category: "Flags",
    aliases: ["st_vincent_grenadines"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇻🇪",
    description: "flag: Venezuela",
    category: "Flags",
    aliases: ["venezuela"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇻🇬",
    description: "flag: British Virgin Islands",
    category: "Flags",
    aliases: ["british_virgin_islands"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇻🇮",
    description: "flag: U.S. Virgin Islands",
    category: "Flags",
    aliases: ["us_virgin_islands"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇻🇳",
    description: "flag: Vietnam",
    category: "Flags",
    aliases: ["vietnam"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇻🇺",
    description: "flag: Vanuatu",
    category: "Flags",
    aliases: ["vanuatu"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇼🇫",
    description: "flag: Wallis & Futuna",
    category: "Flags",
    aliases: ["wallis_futuna"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇼🇸",
    description: "flag: Samoa",
    category: "Flags",
    aliases: ["samoa"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇽🇰",
    description: "flag: Kosovo",
    category: "Flags",
    aliases: ["kosovo"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇾🇪",
    description: "flag: Yemen",
    category: "Flags",
    aliases: ["yemen"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇾🇹",
    description: "flag: Mayotte",
    category: "Flags",
    aliases: ["mayotte"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "9.0"
  },
  {
    emoji: "🇿🇦",
    description: "flag: South Africa",
    category: "Flags",
    aliases: ["south_africa"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇿🇲",
    description: "flag: Zambia",
    category: "Flags",
    aliases: ["zambia"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🇿🇼",
    description: "flag: Zimbabwe",
    category: "Flags",
    aliases: ["zimbabwe"],
    tags: [],
    unicode_version: "6.0",
    ios_version: "8.3"
  },
  {
    emoji: "🏴󠁧󠁢󠁥󠁮󠁧󠁿",
    description: "flag: England",
    category: "Flags",
    aliases: ["england"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
    description: "flag: Scotland",
    category: "Flags",
    aliases: ["scotland"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  },
  {
    emoji: "🏴󠁧󠁢󠁷󠁬󠁳󠁿",
    description: "flag: Wales",
    category: "Flags",
    aliases: ["wales"],
    tags: [],
    unicode_version: "11.0",
    ios_version: "12.1"
  }
], ooe = {
  dependencies: [Il.HorizontalRuleNode],
  export: (e) => Il.$isHorizontalRuleNode(e) ? "***" : null,
  regExp: /^(---|\*\*\*|___)\s?$/,
  replace: (e, t, i, r) => {
    const n = Il.$createHorizontalRuleNode();
    r || e.getNextSibling() != null ? e.replace(n) : e.insertBefore(n), n.selectNext();
  },
  type: "element"
}, soe = {
  dependencies: [Wl],
  export: (e) => xm(e) ? `![${e.getAltText()}](${e.getSrc()})` : null,
  importRegExp: /!(?:\[([^[]*)\])(?:\(([^(]+)\))/,
  regExp: /!(?:\[([^[]*)\])(?:\(([^(]+)\))$/,
  replace: (e, t) => {
    const [, i, r] = t, n = Nf({
      altText: i,
      maxWidth: 800,
      src: r
    });
    e.replace(n);
  },
  trigger: ")",
  type: "text-match"
}, aoe = {
  dependencies: [],
  export: () => null,
  importRegExp: /:([a-z0-9_]+):/,
  regExp: /:([a-z0-9_]+):/,
  replace: (e, [, t]) => {
    var r;
    const i = (r = noe.find((n) => n.aliases.includes(t))) == null ? void 0 : r.emoji;
    i && e.replace(L.$createTextNode(i));
  },
  trigger: ":",
  type: "text-match"
}, loe = {
  dependencies: [Gl],
  export: (e) => P$(e) ? `$${e.getEquation()}$` : null,
  importRegExp: /\$([^$]+?)\$/,
  regExp: /\$([^$]+?)\$$/,
  replace: (e, t) => {
    const [, i] = t, r = kf(i, !0);
    e.replace(r);
  },
  trigger: "$",
  type: "text-match"
}, coe = {
  dependencies: [ou],
  export: (e) => eie(e) ? `<tweet id="${e.getId()}" />` : null,
  regExp: /<tweet id="([^"]+?)"\s?\/>\s?$/,
  replace: (e, t, i) => {
    const [, r] = i, n = Bf(r);
    e.replace(n);
  },
  type: "element"
}, uO = /^(?:\|)(.+)(?:\|)\s?$/, uoe = /^(\| ?:?-*:? ?)+\|\s?$/, doe = {
  dependencies: [ct.TableNode, ct.TableRowNode, ct.TableCellNode],
  export: (e) => {
    if (!ct.$isTableNode(e))
      return null;
    const t = [];
    for (const i of e.getChildren()) {
      const r = [];
      if (!ct.$isTableRowNode(i))
        continue;
      let n = !1;
      for (const o of i.getChildren())
        ct.$isTableCellNode(o) && (r.push(Ic.$convertToMarkdownString(Dx, o).replace(/\n/g, "\\n")), o.__headerState === ct.TableCellHeaderStates.ROW && (n = !0));
      t.push(`| ${r.join(" | ")} |`), n && t.push(`| ${r.map((o) => "---").join(" | ")} |`);
    }
    return t.join(`
`);
  },
  regExp: uO,
  replace: (e, t, i) => {
    if (uoe.test(i[0])) {
      const c = e.getPreviousSibling();
      if (!c || !ct.$isTableNode(c))
        return;
      const u = c.getChildren(), m = u[u.length - 1];
      if (!m || !ct.$isTableRowNode(m))
        return;
      m.getChildren().forEach((g) => {
        ct.$isTableCellNode(g) && g.toggleHeaderStyle(ct.TableCellHeaderStates.ROW);
      }), e.remove();
      return;
    }
    const r = Nw(i[0]);
    if (r == null)
      return;
    const n = [r];
    let o = e.getPreviousSibling(), s = r.length;
    for (; o && !(!L.$isParagraphNode(o) || o.getChildrenSize() !== 1); ) {
      const c = o.getFirstChild();
      if (!L.$isTextNode(c))
        break;
      const u = Nw(c.getTextContent());
      if (u == null)
        break;
      s = Math.max(s, u.length), n.unshift(u);
      const m = o.getPreviousSibling();
      o.remove(), o = m;
    }
    const a = ct.$createTableNode();
    for (const c of n) {
      const u = ct.$createTableRowNode();
      a.append(u);
      for (let m = 0; m < s; m++)
        u.append(m < c.length ? c[m] : dO(""));
    }
    const l = e.getPreviousSibling();
    ct.$isTableNode(l) && moe(l) === s ? (l.append(...a.getChildren()), e.remove()) : e.replace(a), a.selectEnd();
  },
  type: "element"
};
function moe(e) {
  const t = e.getFirstChild();
  return ct.$isTableRowNode(t) ? t.getChildrenSize() : 0;
}
const dO = (e) => {
  e = e.replace(/\\n/g, `
`);
  const t = ct.$createTableCellNode(ct.TableCellHeaderStates.NO_STATUS);
  return Ic.$convertFromMarkdownString(e, Dx, t), t;
}, Nw = (e) => {
  const t = e.match(uO);
  return !t || !t[1] ? null : t[1].split("|").map((i) => dO(i));
}, Dx = [
  doe,
  ooe,
  soe,
  aoe,
  loe,
  coe,
  Ic.CHECK_LIST,
  ...Ic.ELEMENT_TRANSFORMERS,
  ...Ic.TEXT_FORMAT_TRANSFORMERS,
  ...Ic.TEXT_MATCH_TRANSFORMERS
];
function mO() {
  return /* @__PURE__ */ f(roe.MarkdownShortcutPlugin, { transformers: Dx });
}
function gO({ maxLength: e }) {
  const [t] = nt.useLexicalComposerContext();
  return be(() => {
    let i = null;
    return t.registerNodeTransform(L.RootNode, (r) => {
      const n = L.$getSelection();
      if (!L.$isRangeSelection(n) || !n.isCollapsed())
        return;
      const o = t.getEditorState(), s = o.read(() => r.getTextContentSize()), a = r.getTextContentSize();
      if (s !== a) {
        const l = a - e, c = n.anchor;
        l > 0 && (s === e && i !== o ? (i = o, it.$restoreEditorState(t, o)) : wi.trimTextContentFromAnchor(t, c, l));
      }
    });
  }, [t, e]), null;
}
const Tw = () => {
  let e = document.getElementById("report-container");
  return e === null && (e = Wt("div"), e.id = "report-container", e.style.position = "fixed", e.style.top = "50%", e.style.left = "50%", e.style.fontSize = "32px", e.style.transform = "translate(-50%, -50px)", e.style.padding = "20px", e.style.background = "rgba(240, 240, 240, 0.4)", e.style.borderRadius = "20px", document.body && document.body.appendChild(e)), e;
};
function goe() {
  const e = Ne(null), t = ye(() => {
    e !== null && clearTimeout(e.current), document.body && document.body.removeChild(Tw());
  }, []);
  return be(() => t, [t]), ye(
    (i) => {
      const r = Tw();
      return clearTimeout(e.current), r.innerHTML = i, e.current = setTimeout(t, 1e3), e.current;
    },
    [t]
  );
}
const hoe = L.createCommand("SPEECH_TO_TEXT_COMMAND"), poe = {
  "\n": ({ selection: e }) => {
    e.insertParagraph();
  },
  redo: ({ editor: e }) => {
    e.dispatchCommand(L.REDO_COMMAND, void 0);
  },
  undo: ({ editor: e }) => {
    e.dispatchCommand(L.UNDO_COMMAND, void 0);
  }
}, foe = typeof window != "undefined" && ("SpeechRecognition" in window || "webkitSpeechRecognition" in window);
function Aoe() {
  const [e] = nt.useLexicalComposerContext(), [t, i] = se(!1), r = (
    // @ts-ignore
    typeof window != "undefined" && (window.SpeechRecognition || window.webkitSpeechRecognition)
  ), n = Ne(null), o = goe();
  return be(() => (t && n.current === null && (n.current = new r(), n.current.continuous = !0, n.current.interimResults = !0, n.current.addEventListener("result", (s) => {
    const a = s.results.item(s.resultIndex), { transcript: l } = a.item(0);
    o(l), a.isFinal && e.update(() => {
      const c = L.$getSelection();
      if (L.$isRangeSelection(c)) {
        const u = poe[l.toLowerCase().trim()];
        u ? u({
          editor: e,
          selection: c
        }) : l.match(/\s*\n\s*/) ? c.insertParagraph() : c.insertText(l);
      }
    });
  })), n.current && (t ? n.current.start() : n.current.stop()), () => {
    n.current !== null && n.current.stop();
  }), [r, e, t, o]), be(() => e.registerCommand(
    hoe,
    (s) => (i(s), !0),
    L.COMMAND_PRIORITY_EDITOR
  ), [e]), null;
}
const yoe = foe ? Aoe : () => null, Eoe = 1, voe = 100;
let hO = 0, Bw = !1;
function boe() {
  window.addEventListener(
    "keydown",
    (e) => {
      e.key === "Tab" && (hO = e.timeStamp);
    },
    !0
  );
}
function pO() {
  const [e] = nt.useLexicalComposerContext();
  return be(() => (Bw || (boe(), Bw = !0), e.registerCommand(
    L.FOCUS_COMMAND,
    (t) => {
      const i = L.$getSelection();
      return L.$isRangeSelection(i) && hO + voe > t.timeStamp && L.$setSelection(i.clone()), !1;
    },
    Eoe
  )), [e]), null;
}
function SE(e) {
  const t = e.getShape();
  return {
    columns: t.toX - t.fromX + 1,
    rows: t.toY - t.fromY + 1
  };
}
function Coe(e) {
  const t = e.getNodes(), i = [];
  let r = null, n = null, o = 0;
  for (let s = 0; s < t.length; s++) {
    const a = t[s];
    if (ct.$isTableCellNode(a)) {
      const l = a.getParentOrThrow();
      if (E8(ct.$isTableRowNode(l), "Expected CellNode to have a RowNode parent"), r !== l) {
        if (n !== null && o !== n)
          return !1;
        r !== null && (n = o), r = l, o = 0;
      }
      const c = a.__colSpan;
      for (let u = 0; u < c; u++)
        i[o + u] === void 0 && (i[o + u] = 0), i[o + u] += a.__rowSpan;
      o += c;
    }
  }
  return (n === null || o === n) && i.every((s) => s === i[0]);
}
function xoe() {
  const e = L.$getSelection();
  if (L.$isRangeSelection(e) && !e.isCollapsed() || L.DEPRECATED_$isGridSelection(e) && !e.anchor.is(e.focus) || !L.$isRangeSelection(e) && !L.DEPRECATED_$isGridSelection(e))
    return !1;
  const [t] = L.DEPRECATED_$getNodeTriplet(e.anchor);
  return t.__colSpan > 1 || t.__rowSpan > 1;
}
function Dw(e) {
  if (e.getChildrenSize() !== 1)
    return !1;
  const t = e.getFirstChildOrThrow();
  return !(!L.$isParagraphNode(t) || !t.isEmpty());
}
function Ioe(e) {
  const t = e.getLastDescendant();
  L.$isTextNode(t) ? t.select() : L.$isElementNode(t) ? t.selectEnd() : t !== null && t.selectNext();
}
function Ow(e) {
  return e.getEditorState().read(() => {
    const t = L.$getSelection();
    if (L.$isRangeSelection(t) || L.DEPRECATED_$isGridSelection(t)) {
      const [i] = L.DEPRECATED_$getNodeTriplet(t.anchor);
      if (ct.$isTableCellNode(i))
        return i.getBackgroundColor();
    }
    return null;
  });
}
function Soe({
  onClose: e,
  tableCellNode: t,
  setIsMenuOpen: i,
  contextRef: r,
  cellMerge: n,
  showColorPickerModal: o
}) {
  const [s] = nt.useLexicalComposerContext(), a = Ne(null), [l, c] = se(t), [u, m] = se({
    columns: 1,
    rows: 1
  }), [g, h] = se(!1), [A, y] = se(!1), [E, v] = se(() => Ow(s) || "");
  be(() => s.registerMutationListener(ct.TableCellNode, (z) => {
    z.get(l.getKey()) === "updated" && (s.getEditorState().read(() => {
      c(l.getLatest());
    }), v(Ow(s) || ""));
  }), [s, l]), be(() => {
    s.getEditorState().read(() => {
      const z = L.$getSelection();
      if (L.DEPRECATED_$isGridSelection(z)) {
        const W = SE(z);
        m(SE(z)), h(
          Coe(z) && (W.columns > 1 || W.rows > 1)
        );
      }
      y(xoe());
    });
  }, [s]), be(() => {
    const z = r.current, W = a.current, H = s.getRootElement();
    if (z != null && W != null && H != null) {
      const Q = H.getBoundingClientRect(), $ = z.getBoundingClientRect();
      W.style.opacity = "1";
      const le = W.getBoundingClientRect(), he = 5;
      let oe = $.right + he;
      if (oe + le.width > window.innerWidth || oe + le.width > Q.right) {
        const Ae = $.left - le.width - he;
        oe = (Ae < 0 ? he : Ae) + window.pageXOffset;
      }
      W.style.left = `${oe + window.pageXOffset}px`;
      let ue = $.top;
      if (ue + le.height > window.innerHeight) {
        const Ae = $.bottom - le.height;
        ue = (Ae < 0 ? he : Ae) + window.pageYOffset;
      }
      W.style.top = `${ue + +window.pageYOffset}px`;
    }
  }, [r, a, s]), be(() => {
    function z(W) {
      a.current != null && r.current != null && !a.current.contains(W.target) && !r.current.contains(W.target) && i(!1);
    }
    return window.addEventListener("click", z), () => window.removeEventListener("click", z);
  }, [i, r]);
  const C = ye(() => {
    s.update(() => {
      if (l.isAttached()) {
        const W = ct.$getTableNodeFromLexicalNodeOrThrow(l), H = s.getElementByKey(W.getKey());
        if (!H)
          throw new Error("Expected to find tableElement in DOM");
        const Q = ct.getTableSelectionFromTableElement(H);
        Q !== null && Q.clearHighlight(), W.markDirty(), c(l.getLatest());
      }
      L.$getRoot().selectStart();
    });
  }, [s, l]), x = () => {
    s.update(() => {
      const z = L.$getSelection();
      if (L.DEPRECATED_$isGridSelection(z)) {
        const { columns: W, rows: H } = SE(z), Q = z.getNodes();
        let $ = null;
        for (let le = 0; le < Q.length; le++) {
          const he = Q[le];
          if (L.DEPRECATED_$isGridCellNode(he))
            if ($ === null) {
              he.setColSpan(W).setRowSpan(H), $ = he;
              const oe = Dw(he);
              let ue;
              oe && L.$isParagraphNode(ue = he.getFirstChild()) && ue.remove();
            } else
              L.DEPRECATED_$isGridCellNode($) && (Dw(he) || $.append(...he.getChildren()), he.remove());
        }
        $ !== null && ($.getChildrenSize() === 0 && $.append(L.$createParagraphNode()), Ioe($)), e();
      }
    });
  }, S = () => {
    s.update(() => {
      ct.$unmergeCell();
    });
  }, R = ye(
    (z) => {
      s.update(() => {
        ct.$insertTableRow__EXPERIMENTAL(z), e();
      });
    },
    [s, e]
  ), w = ye(
    (z) => {
      s.update(() => {
        for (let W = 0; W < u.columns; W++)
          ct.$insertTableColumn__EXPERIMENTAL(z);
        e();
      });
    },
    [s, e, u.columns]
  ), T = ye(() => {
    s.update(() => {
      ct.$deleteTableRow__EXPERIMENTAL(), e();
    });
  }, [s, e]), N = ye(() => {
    s.update(() => {
      ct.$getTableNodeFromLexicalNodeOrThrow(l).remove(), C(), e();
    });
  }, [s, l, C, e]), D = ye(() => {
    s.update(() => {
      ct.$deleteTableColumn__EXPERIMENTAL(), e();
    });
  }, [s, e]), O = ye(() => {
    s.update(() => {
      const z = ct.$getTableNodeFromLexicalNodeOrThrow(l), W = ct.$getTableRowIndexFromTableCellNode(l), H = z.getChildren();
      if (W >= H.length || W < 0)
        throw new Error("Expected table cell to be inside of table row.");
      const Q = H[W];
      if (!ct.$isTableRowNode(Q))
        throw new Error("Expected table row");
      Q.getChildren().forEach(($) => {
        if (!ct.$isTableCellNode($))
          throw new Error("Expected table cell");
        $.toggleHeaderStyle(ct.TableCellHeaderStates.ROW);
      }), C(), e();
    });
  }, [s, l, C, e]), F = ye(() => {
    s.update(() => {
      const z = ct.$getTableNodeFromLexicalNodeOrThrow(l), W = ct.$getTableColumnIndexFromTableCellNode(l), H = z.getChildren();
      for (let Q = 0; Q < H.length; Q++) {
        const $ = H[Q];
        if (!ct.$isTableRowNode($))
          throw new Error("Expected table row");
        const le = $.getChildren();
        if (W >= le.length || W < 0)
          throw new Error("Expected table cell to be inside of table row.");
        const he = le[W];
        if (!ct.$isTableCellNode(he))
          throw new Error("Expected table cell");
        he.toggleHeaderStyle(ct.TableCellHeaderStates.COLUMN);
      }
      C(), e();
    });
  }, [s, l, C, e]), Y = ye(
    (z) => {
      s.update(() => {
        const W = L.$getSelection();
        if (L.$isRangeSelection(W) || L.DEPRECATED_$isGridSelection(W)) {
          const [H] = L.DEPRECATED_$getNodeTriplet(W.anchor);
          ct.$isTableCellNode(H) && H.setBackgroundColor(z);
        }
      });
    },
    [s]
  );
  let P = null;
  return n && (g ? P = /* @__PURE__ */ f("button", { className: "item", onClick: () => x(), "data-test-id": "table-merge-cells", children: "Merge cells" }) : A && (P = /* @__PURE__ */ f("button", { className: "item", onClick: () => S(), "data-test-id": "table-unmerge-cells", children: "Unmerge cells" }))), ps(
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ V(
      "div",
      {
        className: "maxroll-rich-text-editor-dropdown",
        ref: a,
        onClick: (z) => {
          z.stopPropagation();
        },
        children: [
          P,
          /* @__PURE__ */ f(
            "button",
            {
              className: "item",
              onClick: () => o("Cell background color", () => /* @__PURE__ */ f(O8, { color: E, onChange: Y })),
              "data-test-id": "table-background-color",
              children: /* @__PURE__ */ f("span", { className: "text", children: "Background color" })
            }
          ),
          /* @__PURE__ */ f("hr", {}),
          /* @__PURE__ */ f("button", { className: "item", onClick: () => R(!1), "data-test-id": "table-insert-row-above", children: /* @__PURE__ */ V("span", { className: "text", children: [
            "Insert ",
            u.rows === 1 ? "row" : `${u.rows} rows`,
            " above"
          ] }) }),
          /* @__PURE__ */ f("button", { className: "item", onClick: () => R(!0), "data-test-id": "table-insert-row-below", children: /* @__PURE__ */ V("span", { className: "text", children: [
            "Insert ",
            u.rows === 1 ? "row" : `${u.rows} rows`,
            " below"
          ] }) }),
          /* @__PURE__ */ f("hr", {}),
          /* @__PURE__ */ f(
            "button",
            {
              className: "item",
              onClick: () => w(!1),
              "data-test-id": "table-insert-column-before",
              children: /* @__PURE__ */ V("span", { className: "text", children: [
                "Insert ",
                u.columns === 1 ? "column" : `${u.columns} columns`,
                " left"
              ] })
            }
          ),
          /* @__PURE__ */ f(
            "button",
            {
              className: "item",
              onClick: () => w(!0),
              "data-test-id": "table-insert-column-after",
              children: /* @__PURE__ */ V("span", { className: "text", children: [
                "Insert ",
                u.columns === 1 ? "column" : `${u.columns} columns`,
                " right"
              ] })
            }
          ),
          /* @__PURE__ */ f("hr", {}),
          /* @__PURE__ */ f("button", { className: "item", onClick: () => D(), "data-test-id": "table-delete-columns", children: /* @__PURE__ */ f("span", { className: "text", children: "Delete column" }) }),
          /* @__PURE__ */ f("button", { className: "item", onClick: () => T(), "data-test-id": "table-delete-rows", children: /* @__PURE__ */ f("span", { className: "text", children: "Delete row" }) }),
          /* @__PURE__ */ f("button", { className: "item", onClick: () => N(), "data-test-id": "table-delete", children: /* @__PURE__ */ f("span", { className: "text", children: "Delete table" }) }),
          /* @__PURE__ */ f("hr", {}),
          /* @__PURE__ */ f("button", { className: "item", onClick: () => O(), children: /* @__PURE__ */ V("span", { className: "text", children: [
            (l.__headerState & ct.TableCellHeaderStates.ROW) === ct.TableCellHeaderStates.ROW ? "Remove" : "Add",
            " ",
            "row header"
          ] }) }),
          /* @__PURE__ */ f("button", { className: "item", onClick: () => F(), children: /* @__PURE__ */ V("span", { className: "text", children: [
            (l.__headerState & ct.TableCellHeaderStates.COLUMN) === ct.TableCellHeaderStates.COLUMN ? "Remove" : "Add",
            " ",
            "column header"
          ] }) })
        ]
      }
    ),
    document.body
  );
}
function Roe({
  anchorElem: e,
  cellMerge: t
}) {
  const [i] = nt.useLexicalComposerContext(), r = Ne(null), n = Ne(null), [o, s] = se(!1), [a, l] = se(null), [c, u] = Rg(), m = ye(() => {
    const h = r.current, A = L.$getSelection(), y = window.getSelection(), E = document.activeElement;
    if (A == null || h == null) {
      l(null);
      return;
    }
    const v = i.getRootElement();
    if (L.$isRangeSelection(A) && v !== null && y !== null && v.contains(y.anchorNode)) {
      const C = ct.$getTableCellNodeFromLexicalNode(A.anchor.getNode());
      if (C == null) {
        l(null);
        return;
      }
      if (i.getElementByKey(C.getKey()) == null) {
        l(null);
        return;
      }
      l(C);
    } else
      E || l(null);
  }, [i]);
  be(() => i.registerUpdateListener(() => {
    i.getEditorState().read(() => {
      m();
    });
  })), be(() => {
    const h = r.current;
    if (h != null && a != null) {
      const A = i.getElementByKey(a.getKey());
      if (A != null) {
        const y = A.getBoundingClientRect(), E = h.getBoundingClientRect(), v = e.getBoundingClientRect(), C = y.top - v.top + 4, x = y.right - E.width - 10 - v.left;
        h.style.opacity = "1", h.style.transform = `translate(${x}px, ${C}px)`;
      } else
        h.style.opacity = "0", h.style.transform = "translate(-10000px, -10000px)";
    }
  }, [r, a, i, e]);
  const g = Ne(a);
  return be(() => {
    g.current !== a && s(!1), g.current = a;
  }, [g, a]), /* @__PURE__ */ f("div", { className: "table-cell-action-button-container", ref: r, children: a != null && /* @__PURE__ */ V(gt, { children: [
    /* @__PURE__ */ f(
      "button",
      {
        className: "table-cell-action-button chevron-down",
        onClick: (h) => {
          h.stopPropagation(), s(!o);
        },
        ref: n,
        children: /* @__PURE__ */ f("i", { className: "chevron-down" })
      }
    ),
    c,
    o && /* @__PURE__ */ f(
      Soe,
      {
        contextRef: n,
        setIsMenuOpen: s,
        onClose: () => s(!1),
        tableCellNode: a,
        cellMerge: t,
        showColorPickerModal: u
      }
    )
  ] }) });
}
function koe({
  anchorElem: e = document.body,
  cellMerge: t = !1
}) {
  const i = Af();
  return ps(
    i ? /* @__PURE__ */ f(Roe, { anchorElem: e, cellMerge: t }) : null,
    e
  );
}
const woe = "_resizer_ccf3j_1", Fw = {
  resizer: woe
}, Moe = 33, Noe = 50;
function Toe({ editor: e }) {
  const t = Ne(null), i = Ne(null), r = Ne(null), n = Ne(null), [o, s] = se(null), [a, l] = se(null), [c, u] = se(!1), [m, g] = se(null);
  be(() => e.registerCommand(
    L.SELECTION_CHANGE_COMMAND,
    (R) => {
      const w = L.$getSelection(), T = L.DEPRECATED_$isGridSelection(w);
      return c !== T && u(T), !1;
    },
    L.COMMAND_PRIORITY_HIGH
  ));
  const h = ye(() => {
    l(null), t.current = null, g(null), n.current = null, r.current = null;
  }, []);
  be(() => {
    const R = (w) => {
      setTimeout(() => {
        const T = w.target;
        if (m) {
          s({
            x: w.clientX,
            y: w.clientY
          });
          return;
        }
        if (!(i.current && i.current.contains(T)) && t.current !== T) {
          t.current = T;
          const N = ct.getCellFromTarget(T);
          N && a !== N ? e.update(() => {
            const D = L.$getNearestNodeFromDOMNode(N.elem);
            if (!D)
              throw new Error("TableCellResizer: Table cell node not found.");
            const O = ct.$getTableNodeFromLexicalNodeOrThrow(D), F = e.getElementByKey(O.getKey());
            if (!F)
              throw new Error("TableCellResizer: Table element not found.");
            t.current = T, r.current = F.getBoundingClientRect(), l(N);
          }) : N == null && h();
        }
      }, 0);
    };
    return document.addEventListener("mousemove", R), () => {
      document.removeEventListener("mousemove", R);
    };
  }, [a, m, e, h]);
  const A = (R) => R === "bottom", y = ye(
    (R) => {
      if (!a)
        throw new Error("TableCellResizer: Expected active cell.");
      e.update(() => {
        const w = L.$getNearestNodeFromDOMNode(a.elem);
        if (!ct.$isTableCellNode(w))
          throw new Error("TableCellResizer: Table cell node not found.");
        const T = ct.$getTableNodeFromLexicalNodeOrThrow(w), N = ct.$getTableRowIndexFromTableCellNode(w), D = T.getChildren();
        if (N >= D.length || N < 0)
          throw new Error("Expected table cell to be inside of table row.");
        const O = D[N];
        if (!ct.$isTableRowNode(O))
          throw new Error("Expected table row");
        O.setHeight(R);
      });
    },
    [a, e]
  ), E = ye(
    (R) => {
      if (!a)
        throw new Error("TableCellResizer: Expected active cell.");
      e.update(() => {
        const w = L.$getNearestNodeFromDOMNode(a.elem);
        if (!ct.$isTableCellNode(w))
          throw new Error("TableCellResizer: Table cell node not found.");
        const T = ct.$getTableNodeFromLexicalNodeOrThrow(w), N = ct.$getTableColumnIndexFromTableCellNode(w), D = T.getChildren();
        for (let O = 0; O < D.length; O++) {
          const F = D[O];
          if (!ct.$isTableRowNode(F))
            throw new Error("Expected table row");
          const Y = F.getChildren(), W = Y.map((Q) => Q.getColSpan()).reduce((Q, $) => {
            var he;
            const le = (he = Q.at(-1)) != null ? he : 0;
            return Q.push(le + $), Q;
          }, []).findIndex((Q) => Q > N);
          if (W >= Y.length || W < 0)
            throw new Error("Expected table cell to be inside of table row.");
          const H = Y[W];
          if (!ct.$isTableCellNode(H))
            throw new Error("Expected table cell");
          H.setWidth(R);
        }
      });
    },
    [a, e]
  ), v = ye(
    (R) => {
      const w = (T) => {
        if (T.preventDefault(), T.stopPropagation(), !a)
          throw new Error("TableCellResizer: Expected active cell.");
        if (n.current) {
          const { x: N, y: D } = n.current;
          if (a === null)
            return;
          if (A(R)) {
            const O = a.elem.getBoundingClientRect().height, F = Math.abs(T.clientY - D), Y = R === "bottom" && D > T.clientY;
            y(Math.max(Y ? O - F : F + O, Moe));
          } else {
            const O = getComputedStyle(a.elem);
            let F = a.elem.clientWidth;
            F -= parseFloat(O.paddingLeft) + parseFloat(O.paddingRight);
            const Y = Math.abs(T.clientX - N), P = R === "right" && N > T.clientX;
            E(Math.max(P ? F - Y : Y + F, Noe));
          }
          h(), document.removeEventListener("mouseup", w);
        }
      };
      return w;
    },
    [a, h, E, y]
  ), C = ye(
    (R) => (w) => {
      if (w.preventDefault(), w.stopPropagation(), !a)
        throw new Error("TableCellResizer: Expected active cell.");
      n.current = {
        x: w.clientX,
        y: w.clientY
      }, s(n.current), g(R), document.addEventListener("mouseup", v(R));
    },
    [a, m, h, E, y, v]
  ), S = ye(() => {
    if (a) {
      const { height: R, width: w, top: T, left: N } = a.elem.getBoundingClientRect(), D = {
        bottom: {
          backgroundColor: "none",
          cursor: "row-resize",
          height: "10px",
          left: `${window.pageXOffset + N}px`,
          top: `${window.pageYOffset + T + R}px`,
          width: `${w}px`
        },
        right: {
          backgroundColor: "none",
          cursor: "col-resize",
          height: `${R}px`,
          left: `${window.pageXOffset + N + w}px`,
          top: `${window.pageYOffset + T}px`,
          width: "10px"
        }
      }, O = r.current;
      return m && o && O && (A(m) ? (D[m].left = `${window.pageXOffset + O.left}px`, D[m].top = `${window.pageYOffset + o.y}px`, D[m].height = "3px", D[m].width = `${O.width}px`) : (D[m].top = `${window.pageYOffset + O.top}px`, D[m].left = `${window.pageXOffset + o.x}px`, D[m].width = "3px", D[m].height = `${O.height}px`), D[m].backgroundColor = "#adf"), D;
    }
    return {
      bottom: null,
      left: null,
      right: null,
      top: null
    };
  }, [a, m, o])();
  return /* @__PURE__ */ f("div", { ref: i, children: a != null && !c && /* @__PURE__ */ V(gt, { children: [
    /* @__PURE__ */ f(
      "div",
      {
        className: me(Fw.resizer, "TableCellResizer__ui"),
        style: S.right || void 0,
        onMouseDown: C("right")
      }
    ),
    /* @__PURE__ */ f(
      "div",
      {
        className: me(Fw.resizer, "TableCellResizer__ui"),
        style: S.bottom || void 0,
        onMouseDown: C("bottom")
      }
    )
  ] }) });
}
function fO() {
  const [e] = nt.useLexicalComposerContext(), t = Af();
  return we(
    () => t ? ps(/* @__PURE__ */ f(Toe, { editor: e }), document.body) : null,
    [e, t]
  );
}
const Boe = "_tableOfContents_16xw1_1", Doe = "_heading2_16xw1_14", Ooe = "_heading3_16xw1_18", Foe = "_selectedHeading_16xw1_23", Voe = "_selectedHeadingWrapper_16xw1_28", qoe = "_normalHeading_16xw1_42", joe = "_normalHeadingWrapper_16xw1_48", Loe = "_firstHeading_16xw1_53", Koe = "_headings_16xw1_59", Ss = {
  tableOfContents: Boe,
  heading2: Doe,
  heading3: Ooe,
  selectedHeading: Foe,
  selectedHeadingWrapper: Voe,
  normalHeading: qoe,
  normalHeadingWrapper: joe,
  firstHeading: Loe,
  headings: Koe
};
var Yoe = nt, Dd = Jr, Od = L, Vw = X;
function RE(e) {
  return [e.getKey(), e.getTextContent(), e.getTag()];
}
var Uoe = function({ children: e }) {
  let [t, i] = Vw.useState([]), [r] = Yoe.useLexicalComposerContext();
  return Vw.useEffect(() => {
    let n = [];
    r.getEditorState().read(() => {
      let a = Od.$getRoot().getChildren();
      for (let l of a)
        Dd.$isHeadingNode(l) && n.push([l.getKey(), l.getTextContent(), l.getTag()]);
      i(n);
    });
    let o = r.registerMutationListener(Dd.HeadingNode, (a) => {
      r.getEditorState().read(() => {
        for (const [h, A] of a)
          if (A === "created") {
            var l = Od.$getNodeByKey(h);
            if (l !== null) {
              for (var c = l.getPreviousSibling(); c !== null && !Dd.$isHeadingNode(c); )
                c = c.getPreviousSibling();
              var u = n;
              if (l === null)
                n = u;
              else {
                var m = RE(l), g = [];
                if (c === null)
                  g = [m, ...u];
                else
                  for (let y = 0; y < u.length; y++) {
                    let E = u[y][0];
                    g.push(u[y]), E === c.getKey() && E !== l.getKey() && g.push(m);
                  }
                n = g;
              }
            }
          } else if (A === "destroyed") {
            c = h, l = n, u = [];
            for (let y of l)
              y[0] !== c && u.push(y);
            n = u;
          } else if (A === "updated" && (l = Od.$getNodeByKey(h), l !== null)) {
            for (c = l.getPreviousSibling(); c !== null && !Dd.$isHeadingNode(c); )
              c = c.getPreviousSibling();
            u = n, m = [], g = RE(l), c || m.push(g);
            for (let y of u)
              y[0] !== l.getKey() && (m.push(y), c && y[0] === c.getKey() && m.push(g));
            n = m;
          }
        i(n);
      });
    }), s = r.registerMutationListener(Od.TextNode, (a) => {
      r.getEditorState().read(() => {
        for (const [u, m] of a)
          if (m === "updated") {
            var l = Od.$getNodeByKey(u);
            if (l !== null && (l = l.getParentOrThrow(), Dd.$isHeadingNode(l))) {
              var c = n;
              let g = [];
              for (let h of c)
                h[0] === l.getKey() ? g.push(RE(l)) : g.push(h);
              n = g, i(n);
            }
          }
      });
    });
    return () => {
      o(), s();
    };
  }, [r]), e(t, r);
};
const Goe = Uoe;
var Qoe = Goe;
const Woe = /* @__PURE__ */ Ho(Qoe), N1 = 624, AO = 9;
function Zoe(e) {
  if (e === "h2")
    return Ss.heading2;
  if (e === "h3")
    return Ss.heading3;
}
function Joe(e) {
  const t = e == null ? void 0 : e.getClientRects()[0].y;
  return t >= N1 && t <= N1 + AO;
}
function gp(e) {
  return (e == null ? void 0 : e.getClientRects()[0].y) < N1;
}
function kE(e) {
  return (e == null ? void 0 : e.getClientRects()[0].y) >= N1 + AO;
}
function Poe({ tableOfContents: e }) {
  const [t, i] = se(""), r = Ne(0), [n] = nt.useLexicalComposerContext();
  function o(s, a) {
    n.getEditorState().read(() => {
      const l = n.getElementByKey(s);
      l !== null && (l.scrollIntoView(), i(s), r.current = a);
    });
  }
  return be(() => {
    function s() {
      if (e.length !== 0 && r.current < e.length - 1) {
        let u = n.getElementByKey(e[r.current][0]);
        if (u !== null) {
          if (kE(u)) {
            for (; u !== null && kE(u) && r.current > 0; ) {
              const g = n.getElementByKey(e[r.current - 1][0]);
              g !== null && (gp(g) || kE(g)) && r.current--, u = g;
            }
            const m = e[r.current][0];
            i(m);
          } else if (gp(u)) {
            for (; u !== null && gp(u) && r.current < e.length - 1; ) {
              const g = n.getElementByKey(e[r.current + 1][0]);
              g !== null && (Joe(g) || gp(g)) && r.current++, u = g;
            }
            const m = e[r.current][0];
            i(m);
          }
        }
      } else
        r.current = 0;
    }
    let a;
    function l(u, m) {
      clearTimeout(a), a = setTimeout(u, m);
    }
    function c() {
      l(s, 10);
    }
    return document.addEventListener("scroll", c), () => document.removeEventListener("scroll", c);
  }, [e, n]), /* @__PURE__ */ f("div", { className: Ss.tableOfContents, children: /* @__PURE__ */ f("ul", { className: Ss.headings, children: e.map(([s, a, l], c) => c === 0 ? /* @__PURE__ */ V("div", { className: Ss.normalHeadingWrapper, children: [
    /* @__PURE__ */ f(
      "div",
      {
        className: Ss.firstHeading,
        onClick: () => o(s, c),
        role: "button",
        tabIndex: 0,
        children: ("" + a).length > 20 ? a.substring(0, 20) + "..." : a
      }
    ),
    /* @__PURE__ */ f("br", {})
  ] }, s) : /* @__PURE__ */ f(
    "div",
    {
      className: me(
        Ss.normalHeadingWrapper,
        t === s ? Ss.selectedHeadingWrapper : ""
      ),
      children: /* @__PURE__ */ f("div", { onClick: () => o(s, c), role: "button", className: Zoe(l), tabIndex: 0, children: /* @__PURE__ */ f("li", { className: me(Ss.normalHeading, t === s ? Ss.selectedHeading : ""), children: ("" + a).length > 27 ? a.substring(0, 27) + "..." : a }) })
    },
    s
  )) }) });
}
function yO() {
  return /* @__PURE__ */ f(Woe, { children: (e) => /* @__PURE__ */ f(Poe, { tableOfContents: e }) });
}
const zoe = iu && "documentMode" in document ? document.documentMode : null, tl = iu && /Mac|iPod|iPhone|iPad/.test(navigator.platform);
iu && "InputEvent" in window && !zoe && "getTargetRanges" in new window.InputEvent("input");
const Hoe = ft.lazy(() => import("./StickyComponent-feb150f9.js"));
class E0 extends L.DecoratorNode {
  constructor(i, r, n, o, s) {
    super(s);
    Ze(this, "__x");
    Ze(this, "__y");
    Ze(this, "__color");
    Ze(this, "__caption");
    this.__x = i, this.__y = r, this.__caption = o || L.createEditor(), this.__color = n;
  }
  static getType() {
    return "sticky";
  }
  static clone(i) {
    return new E0(i.__x, i.__y, i.__color, i.__caption, i.__key);
  }
  static importJSON(i) {
    const r = new E0(i.xOffset, i.yOffset, i.color), n = i.caption, o = r.__caption, s = o.parseEditorState(n.editorState);
    return s.isEmpty() || o.setEditorState(s), r;
  }
  exportJSON() {
    return {
      caption: this.__caption.toJSON(),
      color: this.__color,
      type: "sticky",
      version: 1,
      xOffset: this.__x,
      yOffset: this.__y
    };
  }
  createDOM(i) {
    const r = Wt("div");
    return r.style.display = "contents", r;
  }
  updateDOM() {
    return !1;
  }
  setPosition(i, r) {
    const n = this.getWritable();
    n.__x = i, n.__y = r, L.$setSelection(null);
  }
  toggleColor() {
    const i = this.getWritable();
    i.__color = i.__color === "pink" ? "yellow" : "pink";
  }
  decorate(i, r) {
    return ps(
      /* @__PURE__ */ f(Ll, { fallback: null, children: /* @__PURE__ */ f(
        Hoe,
        {
          color: this.__color,
          x: this.__x,
          y: this.__y,
          nodeKey: this.getKey(),
          caption: this.__caption
        }
      ) }),
      document.body
    );
  }
  isIsolated() {
    return !0;
  }
}
function X5e(e) {
  return e instanceof E0;
}
function Xoe(e, t) {
  return new E0(e, t, "yellow");
}
const iC = {
  bullet: "Bulleted List",
  check: "Check List",
  code: "Code Block",
  h1: "Heading 1",
  h2: "Heading 2",
  h3: "Heading 3",
  h4: "Heading 4",
  h5: "Heading 5",
  h6: "Heading 6",
  number: "Numbered List",
  paragraph: "Normal",
  quote: "Quote"
};
function _oe() {
  const e = [];
  for (const [t, i] of Object.entries(nn.CODE_LANGUAGE_FRIENDLY_NAME_MAP))
    e.push([t, i]);
  return e;
}
const $oe = _oe(), ese = [
  ["Arial", "Arial"],
  ["Courier New", "Courier New"],
  ["Georgia", "Georgia"],
  ["Times New Roman", "Times New Roman"],
  ["Trebuchet MS", "Trebuchet MS"],
  ["Verdana", "Verdana"]
], tse = [
  ["10px", "10px"],
  ["11px", "11px"],
  ["12px", "12px"],
  ["13px", "13px"],
  ["14px", "14px"],
  ["15px", "15px"],
  ["16px", "16px"],
  ["17px", "17px"],
  ["18px", "18px"],
  ["19px", "19px"],
  ["20px", "20px"]
], Fd = {
  center: {
    icon: "center-align",
    iconRTL: "right-align",
    name: "Center Align"
  },
  end: {
    icon: "right-align",
    iconRTL: "left-align",
    name: "End Align"
  },
  justify: {
    icon: "justify-align",
    iconRTL: "justify-align",
    name: "Justify Align"
  },
  left: {
    icon: "left-align",
    iconRTL: "left-align",
    name: "Left Align"
  },
  right: {
    icon: "right-align",
    iconRTL: "left-align",
    name: "Right Align"
  },
  start: {
    icon: "left-align",
    iconRTL: "right-align",
    name: "Start Align"
  }
};
function Un(e) {
  return e ? "active dropdown-item-active" : "";
}
function ise({
  editor: e,
  blockType: t,
  rootType: i,
  disabled: r = !1
}) {
  const n = () => {
    e.update(() => {
      const m = L.$getSelection();
      (L.$isRangeSelection(m) || L.DEPRECATED_$isGridSelection(m)) && wi.$setBlocksType(m, () => L.$createParagraphNode());
    });
  }, o = (m) => {
    t !== m && e.update(() => {
      const g = L.$getSelection();
      (L.$isRangeSelection(g) || L.DEPRECATED_$isGridSelection(g)) && wi.$setBlocksType(g, () => Jr.$createHeadingNode(m));
    });
  }, s = () => {
    t !== "bullet" ? e.dispatchCommand(zi.INSERT_UNORDERED_LIST_COMMAND, void 0) : e.dispatchCommand(zi.REMOVE_LIST_COMMAND, void 0);
  }, a = () => {
    t !== "check" ? e.dispatchCommand(zi.INSERT_CHECK_LIST_COMMAND, void 0) : e.dispatchCommand(zi.REMOVE_LIST_COMMAND, void 0);
  }, l = () => {
    t !== "number" ? e.dispatchCommand(zi.INSERT_ORDERED_LIST_COMMAND, void 0) : e.dispatchCommand(zi.REMOVE_LIST_COMMAND, void 0);
  }, c = () => {
    t !== "quote" && e.update(() => {
      const m = L.$getSelection();
      (L.$isRangeSelection(m) || L.DEPRECATED_$isGridSelection(m)) && wi.$setBlocksType(m, () => Jr.$createQuoteNode());
    });
  }, u = () => {
    t !== "code" && e.update(() => {
      let m = L.$getSelection();
      if (L.$isRangeSelection(m) || L.DEPRECATED_$isGridSelection(m))
        if (m.isCollapsed())
          wi.$setBlocksType(m, () => nn.$createCodeNode());
        else {
          const g = m.getTextContent(), h = nn.$createCodeNode();
          m.insertNodes([h]), m = L.$getSelection(), L.$isRangeSelection(m) && m.insertRawText(g);
        }
    });
  };
  return /* @__PURE__ */ V(
    Ia,
    {
      disabled: r,
      buttonClassName: "toolbar-item block-controls",
      buttonIconClassName: "icon block-type " + t,
      buttonLabel: iC[t],
      buttonAriaLabel: "Formatting options for text style",
      children: [
        /* @__PURE__ */ V(Yt, { className: "item " + Un(t === "paragraph"), onClick: n, children: [
          /* @__PURE__ */ f("i", { className: "icon paragraph" }),
          /* @__PURE__ */ f("span", { className: "text", children: "Normal" })
        ] }),
        /* @__PURE__ */ V(Yt, { className: "item " + Un(t === "h1"), onClick: () => o("h1"), children: [
          /* @__PURE__ */ f("i", { className: "icon h1" }),
          /* @__PURE__ */ f("span", { className: "text", children: "Heading 1" })
        ] }),
        /* @__PURE__ */ V(Yt, { className: "item " + Un(t === "h2"), onClick: () => o("h2"), children: [
          /* @__PURE__ */ f("i", { className: "icon h2" }),
          /* @__PURE__ */ f("span", { className: "text", children: "Heading 2" })
        ] }),
        /* @__PURE__ */ V(Yt, { className: "item " + Un(t === "h3"), onClick: () => o("h3"), children: [
          /* @__PURE__ */ f("i", { className: "icon h3" }),
          /* @__PURE__ */ f("span", { className: "text", children: "Heading 3" })
        ] }),
        /* @__PURE__ */ V(Yt, { className: "item " + Un(t === "bullet"), onClick: s, children: [
          /* @__PURE__ */ f("i", { className: "icon bullet-list" }),
          /* @__PURE__ */ f("span", { className: "text", children: "Bullet List" })
        ] }),
        /* @__PURE__ */ V(Yt, { className: "item " + Un(t === "number"), onClick: l, children: [
          /* @__PURE__ */ f("i", { className: "icon numbered-list" }),
          /* @__PURE__ */ f("span", { className: "text", children: "Numbered List" })
        ] }),
        /* @__PURE__ */ V(Yt, { className: "item " + Un(t === "check"), onClick: a, children: [
          /* @__PURE__ */ f("i", { className: "icon check-list" }),
          /* @__PURE__ */ f("span", { className: "text", children: "Check List" })
        ] }),
        /* @__PURE__ */ V(Yt, { className: "item " + Un(t === "quote"), onClick: c, children: [
          /* @__PURE__ */ f("i", { className: "icon quote" }),
          /* @__PURE__ */ f("span", { className: "text", children: "Quote" })
        ] }),
        /* @__PURE__ */ V(Yt, { className: "item " + Un(t === "code"), onClick: u, children: [
          /* @__PURE__ */ f("i", { className: "icon code" }),
          /* @__PURE__ */ f("span", { className: "text", children: "Code Block" })
        ] })
      ]
    }
  );
}
function ml() {
  return /* @__PURE__ */ f("div", { className: "divider" });
}
function qw({
  editor: e,
  value: t,
  style: i,
  disabled: r = !1
}) {
  const n = ye(
    (s) => {
      e.update(() => {
        const a = L.$getSelection();
        (L.$isRangeSelection(a) || L.DEPRECATED_$isGridSelection(a)) && wi.$patchStyleText(a, {
          [i]: s
        });
      });
    },
    [e, i]
  ), o = i === "font-family" ? "Formatting options for font family" : "Formatting options for font size";
  return /* @__PURE__ */ f(
    Ia,
    {
      disabled: r,
      buttonClassName: "toolbar-item " + i,
      buttonLabel: t,
      buttonIconClassName: i === "font-family" ? "icon block-type font-family" : "",
      buttonAriaLabel: o,
      children: (i === "font-family" ? ese : tse).map(([s, a]) => /* @__PURE__ */ f(
        Yt,
        {
          className: `item ${Un(t === s)} ${i === "font-size" ? "fontsize-item" : ""}`,
          onClick: () => n(s),
          children: /* @__PURE__ */ f("span", { className: "text", children: a })
        },
        s
      ))
    }
  );
}
function rse({
  editor: e,
  value: t,
  isRTL: i,
  disabled: r = !1
}) {
  const n = Fd[t || "left"];
  return /* @__PURE__ */ V(
    Ia,
    {
      disabled: r,
      buttonLabel: n.name,
      buttonIconClassName: `icon ${i ? n.iconRTL : n.icon}`,
      buttonClassName: "toolbar-item spaced alignment",
      buttonAriaLabel: "Formatting options for text alignment",
      children: [
        /* @__PURE__ */ V(
          Yt,
          {
            onClick: () => {
              e.dispatchCommand(L.FORMAT_ELEMENT_COMMAND, "left");
            },
            className: "item",
            children: [
              /* @__PURE__ */ f("i", { className: "icon left-align" }),
              /* @__PURE__ */ f("span", { className: "text", children: "Left Align" })
            ]
          }
        ),
        /* @__PURE__ */ V(
          Yt,
          {
            onClick: () => {
              e.dispatchCommand(L.FORMAT_ELEMENT_COMMAND, "center");
            },
            className: "item",
            children: [
              /* @__PURE__ */ f("i", { className: "icon center-align" }),
              /* @__PURE__ */ f("span", { className: "text", children: "Center Align" })
            ]
          }
        ),
        /* @__PURE__ */ V(
          Yt,
          {
            onClick: () => {
              e.dispatchCommand(L.FORMAT_ELEMENT_COMMAND, "right");
            },
            className: "item",
            children: [
              /* @__PURE__ */ f("i", { className: "icon right-align" }),
              /* @__PURE__ */ f("span", { className: "text", children: "Right Align" })
            ]
          }
        ),
        /* @__PURE__ */ V(
          Yt,
          {
            onClick: () => {
              e.dispatchCommand(L.FORMAT_ELEMENT_COMMAND, "justify");
            },
            className: "item",
            children: [
              /* @__PURE__ */ f("i", { className: "icon justify-align" }),
              /* @__PURE__ */ f("span", { className: "text", children: "Justify Align" })
            ]
          }
        ),
        /* @__PURE__ */ V(
          Yt,
          {
            onClick: () => {
              e.dispatchCommand(L.FORMAT_ELEMENT_COMMAND, "start");
            },
            className: "item",
            children: [
              /* @__PURE__ */ f("i", { className: `icon ${i ? Fd.start.iconRTL : Fd.start.icon}` }),
              /* @__PURE__ */ f("span", { className: "text", children: "Start Align" })
            ]
          }
        ),
        /* @__PURE__ */ V(
          Yt,
          {
            onClick: () => {
              e.dispatchCommand(L.FORMAT_ELEMENT_COMMAND, "end");
            },
            className: "item",
            children: [
              /* @__PURE__ */ f("i", { className: `icon ${i ? Fd.end.iconRTL : Fd.end.icon}` }),
              /* @__PURE__ */ f("span", { className: "text", children: "End Align" })
            ]
          }
        ),
        /* @__PURE__ */ f(ml, {}),
        /* @__PURE__ */ V(
          Yt,
          {
            onClick: () => {
              e.dispatchCommand(L.OUTDENT_CONTENT_COMMAND, void 0);
            },
            className: "item",
            children: [
              /* @__PURE__ */ f("i", { className: "icon " + (i ? "indent" : "outdent") }),
              /* @__PURE__ */ f("span", { className: "text", children: "Outdent" })
            ]
          }
        ),
        /* @__PURE__ */ V(
          Yt,
          {
            onClick: () => {
              e.dispatchCommand(L.INDENT_CONTENT_COMMAND, void 0);
            },
            className: "item",
            children: [
              /* @__PURE__ */ f("i", { className: "icon " + (i ? "outdent" : "indent") }),
              /* @__PURE__ */ f("span", { className: "text", children: "Indent" })
            ]
          }
        )
      ]
    }
  );
}
function nse({
  setIsLinkEditMode: e,
  isRestricted: t
}) {
  const [i] = nt.useLexicalComposerContext(), [r, n] = se(i), [o, s] = se("paragraph"), [a, l] = se("root"), [c, u] = se(null), [m, g] = se("15px"), [h, A] = se("#000"), [y, E] = se("#fff"), [v, C] = se("Arial"), [x, S] = se("left"), [R, w] = se(!1), [T, N] = se(!1), [D, O] = se(!1), [F, Y] = se(!1), [P, z] = se(!1), [W, H] = se(!1), [Q, $] = se(!1), [, le] = se(!1), [he, oe] = se(!1), [ue, Ae] = se(!1), [de, fe] = Rg(), [Re, qe] = se(!1), [Oe, Xe] = se(""), [Qe, Pe] = se(() => i.isEditable()), et = we(() => r._config.theme.embedToolbar, [r]), At = ye(() => {
    const Ke = L.$getSelection();
    if (L.$isRangeSelection(Ke)) {
      const dt = Ke.anchor.getNode();
      let kt = dt.getKey() === "root" ? dt : it.$findMatchingParent(dt, (fr) => {
        const Sr = fr.getParent();
        return Sr !== null && L.$isRootOrShadowRoot(Sr);
      });
      kt === null && (kt = dt.getTopLevelElementOrThrow());
      const si = kt.getKey(), Dt = r.getElementByKey(si);
      N(Ke.hasFormat("bold")), O(Ke.hasFormat("italic")), Y(Ke.hasFormat("underline")), z(Ke.hasFormat("strikethrough")), H(Ke.hasFormat("subscript")), $(Ke.hasFormat("superscript")), le(Ke.hasFormat("code")), qe(wi.$isParentElementRTL(Ke));
      const yi = zm(Ke), ei = yi.getParent();
      Ii.$isLinkNode(ei) || Ii.$isLinkNode(yi) ? w(!0) : w(!1);
      const nr = it.$findMatchingParent(yi, ct.$isTableNode);
      if (ct.$isTableNode(nr) ? l("table") : l("root"), Dt !== null)
        if (u(si), zi.$isListNode(kt)) {
          const fr = it.$getNearestNodeOfType(dt, zi.ListNode), Sr = fr ? fr.getListType() : kt.getListType();
          s(Sr);
        } else {
          const fr = Jr.$isHeadingNode(kt) ? kt.getTag() : kt.getType();
          if (fr in iC && s(fr), nn.$isCodeNode(kt)) {
            const Sr = kt.getLanguage();
            Xe(Sr ? nn.CODE_LANGUAGE_MAP[Sr] || Sr : "");
            return;
          }
        }
      g(wi.$getSelectionStyleValueForProperty(Ke, "font-size", "15px")), A(wi.$getSelectionStyleValueForProperty(Ke, "color", "#000")), E(wi.$getSelectionStyleValueForProperty(Ke, "background-color", "#fff")), C(wi.$getSelectionStyleValueForProperty(Ke, "font-family", "Arial")), S((L.$isElementNode(yi) ? yi.getFormatType() : ei == null ? void 0 : ei.getFormatType()) || "left");
    }
  }, [r]);
  be(() => i.registerCommand(
    L.SELECTION_CHANGE_COMMAND,
    (Ke, dt) => (At(), n(dt), !1),
    L.COMMAND_PRIORITY_CRITICAL
  ), [i, At]), be(() => it.mergeRegister(
    i.registerEditableListener((Ke) => {
      Pe(Ke);
    }),
    r.registerUpdateListener(({ editorState: Ke }) => {
      Ke.read(() => {
        At();
      });
    }),
    r.registerCommand(
      L.CAN_UNDO_COMMAND,
      (Ke) => (oe(Ke), !1),
      L.COMMAND_PRIORITY_CRITICAL
    ),
    r.registerCommand(
      L.CAN_REDO_COMMAND,
      (Ke) => (Ae(Ke), !1),
      L.COMMAND_PRIORITY_CRITICAL
    )
  ), [At, r, i]), be(() => r.registerCommand(
    L.KEY_MODIFIER_COMMAND,
    (Ke) => {
      const dt = Ke, { code: kt, ctrlKey: si, metaKey: Dt } = dt;
      return kt === "KeyK" && (si || Dt) ? (dt.preventDefault(), e(!R), r.dispatchCommand(Ii.TOGGLE_LINK_COMMAND, S1("https://"))) : !1;
    },
    L.COMMAND_PRIORITY_NORMAL
  ), [r, R, e]);
  const Et = ye(
    (Ke) => {
      r.update(() => {
        const dt = L.$getSelection();
        (L.$isRangeSelection(dt) || L.DEPRECATED_$isGridSelection(dt)) && wi.$patchStyleText(dt, Ke);
      });
    },
    [r]
  ), oi = ye(() => {
    r.update(() => {
      const Ke = L.$getSelection();
      if (L.$isRangeSelection(Ke)) {
        const dt = Ke.anchor, kt = Ke.focus, si = Ke.getNodes();
        if (dt.key === kt.key && dt.offset === kt.offset)
          return;
        si.forEach((Dt, yi) => {
          L.$isTextNode(Dt) ? (yi === 0 && dt.offset !== 0 && (Dt = Dt.splitText(dt.offset)[1] || Dt), yi === si.length - 1 && (Dt = Dt.splitText(kt.offset)[0] || Dt), Dt.__style !== "" && Dt.setStyle(""), Dt.__format !== 0 && (Dt.setFormat(0), it.$getNearestBlockElementAncestorOrThrow(Dt).setFormat(""))) : Jr.$isHeadingNode(Dt) || Jr.$isQuoteNode(Dt) ? Dt.replace(L.$createParagraphNode(), !0) : Tf.$isDecoratorBlockNode(Dt) && Dt.setFormat("");
        });
      }
    });
  }, [r]), Ai = ye(
    (Ke) => {
      Et({ color: Ke });
    },
    [Et]
  ), ut = ye(
    (Ke) => {
      Et({ "background-color": Ke });
    },
    [Et]
  ), qt = ye(() => {
    R ? i.dispatchCommand(Ii.TOGGLE_LINK_COMMAND, null) : i.dispatchCommand(Ii.TOGGLE_LINK_COMMAND, S1("https://"));
  }, [i, R]), Ht = ye(
    (Ke) => {
      r.update(() => {
        if (c !== null) {
          const dt = L.$getNodeByKey(c);
          nn.$isCodeNode(dt) && dt.setLanguage(Ke);
        }
      });
    },
    [r, c]
  ), ri = (Ke) => {
    r.dispatchCommand(J0, Ke);
  };
  return /* @__PURE__ */ V("div", { className: "toolbar", children: [
    /* @__PURE__ */ f(
      "button",
      {
        disabled: !he || !Qe,
        onClick: () => {
          r.dispatchCommand(L.UNDO_COMMAND, void 0);
        },
        title: tl ? "Undo (⌘Z)" : "Undo (Ctrl+Z)",
        type: "button",
        className: "toolbar-item spaced",
        "aria-label": "Undo",
        children: /* @__PURE__ */ f("i", { className: "format undo" })
      }
    ),
    /* @__PURE__ */ f(
      "button",
      {
        disabled: !ue || !Qe,
        onClick: () => {
          r.dispatchCommand(L.REDO_COMMAND, void 0);
        },
        title: tl ? "Redo (⌘Y)" : "Redo (Ctrl+Y)",
        type: "button",
        className: "toolbar-item",
        "aria-label": "Redo",
        children: /* @__PURE__ */ f("i", { className: "format redo" })
      }
    ),
    /* @__PURE__ */ f(ml, {}),
    o in iC && r === i && !t && /* @__PURE__ */ V(gt, { children: [
      /* @__PURE__ */ f(ise, { disabled: !Qe, blockType: o, rootType: a, editor: i }),
      /* @__PURE__ */ f(ml, {})
    ] }),
    o === "code" ? /* @__PURE__ */ f(
      Ia,
      {
        disabled: !Qe,
        buttonClassName: "toolbar-item code-language",
        buttonLabel: nn.getLanguageFriendlyName(Oe),
        buttonAriaLabel: "Select language",
        children: $oe.map(([Ke, dt]) => /* @__PURE__ */ f(
          Yt,
          {
            className: `item ${Un(Ke === Oe)}`,
            onClick: () => Ht(Ke),
            children: /* @__PURE__ */ f("span", { className: "text", children: dt })
          },
          Ke
        ))
      }
    ) : /* @__PURE__ */ V(gt, { children: [
      t ? null : /* @__PURE__ */ f(qw, { disabled: !Qe, style: "font-family", value: v, editor: i }),
      /* @__PURE__ */ f(qw, { disabled: !Qe, style: "font-size", value: m, editor: i }),
      /* @__PURE__ */ f(ml, {}),
      /* @__PURE__ */ f(
        "button",
        {
          disabled: !Qe,
          onClick: () => {
            r.dispatchCommand(L.FORMAT_TEXT_COMMAND, "bold");
          },
          className: "toolbar-item spaced " + (T ? "active" : ""),
          title: tl ? "Bold (⌘B)" : "Bold (Ctrl+B)",
          type: "button",
          "aria-label": `Format text as bold. Shortcut: ${tl ? "⌘B" : "Ctrl+B"}`,
          children: /* @__PURE__ */ f("i", { className: "format bold" })
        }
      ),
      /* @__PURE__ */ f(
        "button",
        {
          disabled: !Qe,
          onClick: () => {
            r.dispatchCommand(L.FORMAT_TEXT_COMMAND, "italic");
          },
          className: "toolbar-item spaced " + (D ? "active" : ""),
          title: tl ? "Italic (⌘I)" : "Italic (Ctrl+I)",
          type: "button",
          "aria-label": `Format text as italics. Shortcut: ${tl ? "⌘I" : "Ctrl+I"}`,
          children: /* @__PURE__ */ f("i", { className: "format italic" })
        }
      ),
      /* @__PURE__ */ f(
        "button",
        {
          disabled: !Qe,
          onClick: () => {
            r.dispatchCommand(L.FORMAT_TEXT_COMMAND, "underline");
          },
          className: "toolbar-item spaced " + (F ? "active" : ""),
          title: tl ? "Underline (⌘U)" : "Underline (Ctrl+U)",
          type: "button",
          "aria-label": `Format text to underlined. Shortcut: ${tl ? "⌘U" : "Ctrl+U"}`,
          children: /* @__PURE__ */ f("i", { className: "format underline" })
        }
      ),
      t ? null : /* @__PURE__ */ V(gt, { children: [
        /* @__PURE__ */ f(
          "button",
          {
            disabled: !Qe,
            onClick: qt,
            className: "toolbar-item spaced " + (R ? "active" : ""),
            "aria-label": "Insert link",
            title: "Insert link",
            type: "button",
            children: /* @__PURE__ */ f("i", { className: "format link" })
          }
        ),
        /* @__PURE__ */ f(
          _b,
          {
            disabled: !Qe,
            buttonClassName: "toolbar-item color-picker",
            buttonAriaLabel: "Formatting text color",
            buttonIconClassName: "icon font-color",
            color: h,
            onChange: Ai,
            title: "text color"
          }
        ),
        /* @__PURE__ */ f(
          _b,
          {
            disabled: !Qe,
            buttonClassName: "toolbar-item color-picker",
            buttonAriaLabel: "Formatting background color",
            buttonIconClassName: "icon bg-color",
            color: y,
            onChange: ut,
            title: "bg color"
          }
        )
      ] }),
      /* @__PURE__ */ V(
        Ia,
        {
          disabled: !Qe,
          buttonClassName: "toolbar-item spaced",
          buttonLabel: "",
          buttonAriaLabel: "Formatting options for additional text styles",
          buttonIconClassName: "icon dropdown-more",
          children: [
            /* @__PURE__ */ V(
              Yt,
              {
                onClick: () => {
                  r.dispatchCommand(L.FORMAT_TEXT_COMMAND, "strikethrough");
                },
                className: "item " + Un(P),
                title: "Strikethrough",
                "aria-label": "Format text with a strikethrough",
                children: [
                  /* @__PURE__ */ f("i", { className: "icon strikethrough" }),
                  /* @__PURE__ */ f("span", { className: "text", children: "Strikethrough" })
                ]
              }
            ),
            /* @__PURE__ */ V(
              Yt,
              {
                onClick: () => {
                  r.dispatchCommand(L.FORMAT_TEXT_COMMAND, "subscript");
                },
                className: "item " + Un(W),
                title: "Subscript",
                "aria-label": "Format text with a subscript",
                children: [
                  /* @__PURE__ */ f("i", { className: "icon subscript" }),
                  /* @__PURE__ */ f("span", { className: "text", children: "Subscript" })
                ]
              }
            ),
            /* @__PURE__ */ V(
              Yt,
              {
                onClick: () => {
                  r.dispatchCommand(L.FORMAT_TEXT_COMMAND, "superscript");
                },
                className: "item " + Un(Q),
                title: "Superscript",
                "aria-label": "Format text with a superscript",
                children: [
                  /* @__PURE__ */ f("i", { className: "icon superscript" }),
                  /* @__PURE__ */ f("span", { className: "text", children: "Superscript" })
                ]
              }
            ),
            /* @__PURE__ */ V(
              Yt,
              {
                onClick: oi,
                className: "item",
                title: "Clear text formatting",
                "aria-label": "Clear all text formatting",
                children: [
                  /* @__PURE__ */ f("i", { className: "icon clear" }),
                  /* @__PURE__ */ f("span", { className: "text", children: "Clear Formatting" })
                ]
              }
            )
          ]
        }
      ),
      a === "table" && /* @__PURE__ */ V(gt, { children: [
        /* @__PURE__ */ f(ml, {}),
        /* @__PURE__ */ f(
          Ia,
          {
            disabled: !Qe,
            buttonClassName: "toolbar-item spaced",
            buttonLabel: "Table",
            buttonAriaLabel: "Open table toolkit",
            buttonIconClassName: "icon table secondary",
            children: /* @__PURE__ */ f(
              Yt,
              {
                onClick: () => {
                },
                className: "item",
                children: /* @__PURE__ */ f("span", { className: "text", children: "TODO" })
              }
            )
          }
        )
      ] }),
      t ? null : /* @__PURE__ */ V(gt, { children: [
        " ",
        /* @__PURE__ */ f(ml, {}),
        /* @__PURE__ */ V(
          Ia,
          {
            disabled: !Qe,
            buttonClassName: "toolbar-item spaced",
            buttonLabel: "Insert",
            buttonAriaLabel: "Insert specialized editor node",
            buttonIconClassName: "icon plus",
            children: [
              /* @__PURE__ */ V(
                Yt,
                {
                  onClick: () => {
                    r.dispatchCommand(Il.INSERT_HORIZONTAL_RULE_COMMAND, void 0);
                  },
                  className: "item",
                  children: [
                    /* @__PURE__ */ f("i", { className: "icon horizontal-rule" }),
                    /* @__PURE__ */ f("span", { className: "text", children: "Horizontal Rule" })
                  ]
                }
              ),
              /* @__PURE__ */ V(
                Yt,
                {
                  onClick: () => {
                    r.dispatchCommand(xx, void 0);
                  },
                  className: "item",
                  children: [
                    /* @__PURE__ */ f("i", { className: "icon page-break" }),
                    /* @__PURE__ */ f("span", { className: "text", children: "Page Break" })
                  ]
                }
              ),
              /* @__PURE__ */ V(
                Yt,
                {
                  onClick: () => {
                    fe("Insert Image", (Ke) => /* @__PURE__ */ f(u8, { activeEditor: r, onClose: Ke }));
                  },
                  className: "item",
                  children: [
                    /* @__PURE__ */ f("i", { className: "icon image" }),
                    /* @__PURE__ */ f("span", { className: "text", children: "Image" })
                  ]
                }
              ),
              /* @__PURE__ */ V(
                Yt,
                {
                  onClick: () => {
                    fe("Insert Inline Image", (Ke) => /* @__PURE__ */ f(One, { activeEditor: r, onClose: Ke }));
                  },
                  className: "item",
                  children: [
                    /* @__PURE__ */ f("i", { className: "icon image" }),
                    /* @__PURE__ */ f("span", { className: "text", children: "Inline Image" })
                  ]
                }
              ),
              /* @__PURE__ */ V(
                Yt,
                {
                  onClick: () => ri({
                    altText: "Cat typing on a laptop",
                    src: s8
                  }),
                  className: "item",
                  children: [
                    /* @__PURE__ */ f("i", { className: "icon gif" }),
                    /* @__PURE__ */ f("span", { className: "text", children: "GIF" })
                  ]
                }
              ),
              /* @__PURE__ */ V(
                Yt,
                {
                  onClick: () => {
                    fe("Insert Table", (Ke) => /* @__PURE__ */ f(R8, { activeEditor: r, onClose: Ke }));
                  },
                  className: "item",
                  children: [
                    /* @__PURE__ */ f("i", { className: "icon table" }),
                    /* @__PURE__ */ f("span", { className: "text", children: "Table" })
                  ]
                }
              ),
              /* @__PURE__ */ V(
                Yt,
                {
                  onClick: () => {
                    fe("Insert Table", (Ke) => /* @__PURE__ */ f(k8, { activeEditor: r, onClose: Ke }));
                  },
                  className: "item",
                  children: [
                    /* @__PURE__ */ f("i", { className: "icon table" }),
                    /* @__PURE__ */ f("span", { className: "text", children: "Table (Experimental)" })
                  ]
                }
              ),
              /* @__PURE__ */ V(
                Yt,
                {
                  onClick: () => {
                    fe("Insert Poll", (Ke) => /* @__PURE__ */ f(y8, { activeEditor: r, onClose: Ke }));
                  },
                  className: "item",
                  children: [
                    /* @__PURE__ */ f("i", { className: "icon poll" }),
                    /* @__PURE__ */ f("span", { className: "text", children: "Poll" })
                  ]
                }
              ),
              /* @__PURE__ */ V(
                Yt,
                {
                  onClick: () => {
                    fe("Insert Columns Layout", (Ke) => /* @__PURE__ */ f(p8, { activeEditor: r, onClose: Ke }));
                  },
                  className: "item",
                  children: [
                    /* @__PURE__ */ f("i", { className: "icon columns" }),
                    /* @__PURE__ */ f("span", { className: "text", children: "Columns Layout" })
                  ]
                }
              ),
              /* @__PURE__ */ V(
                Yt,
                {
                  onClick: () => {
                    fe("Insert Equation", (Ke) => /* @__PURE__ */ f(l8, { activeEditor: r, onClose: Ke }));
                  },
                  className: "item",
                  children: [
                    /* @__PURE__ */ f("i", { className: "icon equation" }),
                    /* @__PURE__ */ f("span", { className: "text", children: "Equation" })
                  ]
                }
              ),
              /* @__PURE__ */ V(
                Yt,
                {
                  onClick: () => {
                    i.update(() => {
                      const Ke = L.$getRoot(), dt = Xoe(0, 0);
                      Ke.append(dt);
                    });
                  },
                  className: "item",
                  children: [
                    /* @__PURE__ */ f("i", { className: "icon sticky" }),
                    /* @__PURE__ */ f("span", { className: "text", children: "Sticky Note" })
                  ]
                }
              ),
              /* @__PURE__ */ V(
                Yt,
                {
                  onClick: () => {
                    i.dispatchCommand(vx, void 0);
                  },
                  className: "item",
                  children: [
                    /* @__PURE__ */ f("i", { className: "icon caret-right" }),
                    /* @__PURE__ */ f("span", { className: "text", children: "Collapsible container" })
                  ]
                }
              ),
              hx.map((Ke) => /* @__PURE__ */ V(
                Yt,
                {
                  onClick: () => {
                    r.dispatchCommand(l0.INSERT_EMBED_COMMAND, Ke.type);
                  },
                  className: "item",
                  children: [
                    Ke.icon,
                    /* @__PURE__ */ f("span", { className: "text", children: Ke.contentName })
                  ]
                },
                Ke.type
              ))
            ]
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ f(ml, {}),
    /* @__PURE__ */ f(rse, { disabled: !Qe, value: x, editor: i, isRTL: Re }),
    t ? null : /* @__PURE__ */ V(gt, { children: [
      /* @__PURE__ */ f(ml, {}),
      /* @__PURE__ */ V(
        "button",
        {
          disabled: !Qe,
          onClick: () => {
            r.dispatchCommand(V5, { type: "dynamic" });
          },
          className: "toolbar-item spaced",
          title: "Insert Ad",
          type: "button",
          "aria-label": "Insert ad",
          children: [
            /* @__PURE__ */ f("span", { className: "icon plus", style: { marginRight: "4px" } }),
            /* @__PURE__ */ f("span", { className: "text", children: "AD" })
          ]
        }
      )
    ] }),
    et ? Ei(et, { isEditable: Qe, activeEditor: r }) : null,
    de
  ] });
}
function ose({
  theme: e,
  customPlugins: t,
  isRestricted: i
}) {
  const { historyState: r } = L2(), {
    settings: {
      isAutocomplete: n,
      isMaxLength: o,
      isCharLimit: s,
      isCharLimitUtf8: a,
      isRichText: l,
      showTreeView: c,
      showTableOfContents: u,
      shouldUseLexicalContextMenu: m,
      tableCellMerge: g,
      tableCellBackgroundColor: h
    }
  } = j2(), A = Af(), E = /* @__PURE__ */ f(Mf, { children: l ? "Enter some rich text..." : "Enter some plain text..." }), [v, C] = se(null), [x, S] = se(!1), [R, w] = se(!1), T = (D) => {
    D !== null && C(D);
  }, N = {
    namespace: "Maxroll",
    nodes: [...UD],
    onError: (D) => {
      throw D;
    },
    theme: e
  };
  return be(() => {
    const D = () => {
      const O = iu && window.matchMedia("(max-width: 1025px)").matches;
      O !== x && S(O);
    };
    return D(), window.addEventListener("resize", D), () => {
      window.removeEventListener("resize", D);
    };
  }, [x]), /* @__PURE__ */ V(gt, { children: [
    l && /* @__PURE__ */ f(nse, { setIsLinkEditMode: w, isRestricted: i }),
    /* @__PURE__ */ V(
      "div",
      {
        className: me(
          "editor-container",
          e.editorContainer,
          A && e.editorContainerEditable,
          c && e.editorContainerTreeView,
          !l && e.editorContainerPlainText
        ),
        children: [
          o && /* @__PURE__ */ f(gO, { maxLength: 30 }),
          i ? null : /* @__PURE__ */ f(kre, {}),
          /* @__PURE__ */ f(Ym.AutoFocusPlugin, {}),
          /* @__PURE__ */ f(Az.ClearEditorPlugin, {}),
          i ? null : /* @__PURE__ */ V(gt, { children: [
            /* @__PURE__ */ f(fre, {}),
            /* @__PURE__ */ f($D, {}),
            /* @__PURE__ */ f(Qb, {}),
            /* @__PURE__ */ f(fB.HashtagPlugin, {}),
            /* @__PURE__ */ f(yoe, {})
          ] }),
          /* @__PURE__ */ f(yie, {}),
          l ? /* @__PURE__ */ V(gt, { children: [
            /* @__PURE__ */ f(Mc.HistoryPlugin, { externalHistoryState: r }),
            /* @__PURE__ */ f(
              p0.RichTextPlugin,
              {
                contentEditable: /* @__PURE__ */ f("div", { className: me("editor-scroller", e.editorScroller), children: /* @__PURE__ */ f("div", { className: me("editor", e.editor), ref: T, children: /* @__PURE__ */ f(kl, {}) }) }),
                placeholder: E,
                ErrorBoundary: xl
              }
            ),
            i ? null : /* @__PURE__ */ V(gt, { children: [
              /* @__PURE__ */ f(mO, {}),
              /* @__PURE__ */ f(r8, {})
            ] }),
            /* @__PURE__ */ f(IB.ListPlugin, {}),
            /* @__PURE__ */ f(oB.CheckListPlugin, {}),
            /* @__PURE__ */ f(K8, { maxDepth: 7 }),
            i ? null : /* @__PURE__ */ V(gt, { children: [
              /* @__PURE__ */ f(l7.TablePlugin, { hasCellMerge: g, hasCellBackgroundColor: h }),
              /* @__PURE__ */ f(fO, {}),
              /* @__PURE__ */ V(w8, { cellEditorConfig: N, children: [
                /* @__PURE__ */ f(Ym.AutoFocusPlugin, {}),
                /* @__PURE__ */ f(
                  p0.RichTextPlugin,
                  {
                    contentEditable: /* @__PURE__ */ f(kl, { className: "TableNode__contentEditable" }),
                    placeholder: null,
                    ErrorBoundary: xl
                  }
                ),
                /* @__PURE__ */ f(Qb, {}),
                /* @__PURE__ */ f(Mc.HistoryPlugin, {}),
                /* @__PURE__ */ f(k1, { captionsEnabled: !1 }),
                /* @__PURE__ */ f(A0, {}),
                /* @__PURE__ */ f(Sb, {}),
                /* @__PURE__ */ f($b, {})
              ] }),
              /* @__PURE__ */ f(k1, {}),
              /* @__PURE__ */ f(j8, {})
            ] }),
            i ? void 0 : /* @__PURE__ */ f(A0, {}),
            i ? void 0 : /* @__PURE__ */ V(gt, { children: [
              /* @__PURE__ */ f(sre, {}),
              /* @__PURE__ */ f(HD, {}),
              /* @__PURE__ */ f(_D, {}),
              !A && /* @__PURE__ */ f(Sb, {}),
              /* @__PURE__ */ f(bB.HorizontalRulePlugin, {}),
              /* @__PURE__ */ f(Fie, {}),
              /* @__PURE__ */ f(pO, {}),
              /* @__PURE__ */ f(XB.TabIndentationPlugin, {}),
              /* @__PURE__ */ f(o8, {}),
              /* @__PURE__ */ f(ire, {}),
              /* @__PURE__ */ f(h8, {})
            ] }),
            v && !x && !i && /* @__PURE__ */ V(gt, { children: [
              /* @__PURE__ */ f(Qre, { anchorElem: v }),
              /* @__PURE__ */ f(
                D8,
                {
                  anchorElem: v,
                  isLinkEditMode: R,
                  setIsLinkEditMode: w
                }
              ),
              /* @__PURE__ */ f(koe, { anchorElem: v, cellMerge: !0 }),
              /* @__PURE__ */ f($b, { anchorElem: v })
            ] })
          ] }) : /* @__PURE__ */ V(gt, { children: [
            /* @__PURE__ */ f(
              QB.PlainTextPlugin,
              {
                contentEditable: /* @__PURE__ */ f(kl, {}),
                placeholder: E,
                ErrorBoundary: xl
              }
            ),
            /* @__PURE__ */ f(Mc.HistoryPlugin, { externalHistoryState: r })
          ] }),
          (s || a) && /* @__PURE__ */ f(H5.CharacterLimitPlugin, { charset: s ? "UTF-16" : "UTF-8", maxLength: 5 }),
          n && /* @__PURE__ */ f(S7, {}),
          /* @__PURE__ */ f("div", { children: u && /* @__PURE__ */ f(yO, {}) }),
          m && /* @__PURE__ */ f(N8, {}),
          /* @__PURE__ */ f(q5, {}),
          t
        ]
      }
    ),
    c && /* @__PURE__ */ f(KD, {})
  ] });
}
const sse = [
  // Common
  {
    name: "Font Color",
    slug: "light-gray",
    color: "#e3e3e3"
  },
  {
    name: "Background",
    slug: "near-black",
    color: "#0C0E0F"
  },
  {
    name: "Maxroll Blue",
    slug: "mid-blue",
    color: "#057af0"
  },
  {
    name: "Green + / Zones / Pros",
    slug: "mid-grean",
    color: "#4B9257"
  },
  {
    name: "Red - / Life / Vitality",
    slug: "mid-red",
    color: "#851522"
  },
  {
    name: "For embed items in accordions e.g. mechanics",
    slug: "really-black",
    color: "#131313"
  },
  // PoE
  {
    name: "Magic item",
    slug: "poe-magic-item",
    color: "#8888ff"
  },
  {
    name: "Rare item",
    slug: "poe-rare-item",
    color: "#ffff77"
  },
  {
    name: "Unique item",
    slug: "poe-unique-item",
    color: "#af6025"
  },
  {
    name: "Skill gem",
    slug: "poe-skill-gem",
    color: "#1ba29b"
  },
  {
    name: "Currency",
    slug: "poe-currency",
    color: "#aa9e82"
  },
  {
    name: "Quest item",
    slug: "poe-quest-item",
    color: "#4ae63a"
  },
  {
    name: "Divination Card",
    slug: "poe-divination-card",
    color: "#0ebaff"
  },
  {
    name: "Fire damage",
    slug: "poe-fire-damage",
    color: "#960000"
  },
  {
    name: "Cold damage",
    slug: "poe-cold-damage",
    color: "#366492"
  },
  {
    name: "Lightning damage",
    slug: "poe-lighning-damage",
    color: "#ffd700"
  },
  {
    name: "Chaos damage",
    slug: "poe-chaos-damage",
    color: "#d02090"
  },
  {
    name: "Corrupted",
    slug: "poe-corrupted",
    color: "#d20000"
  },
  {
    name: "Crafted mod",
    slug: "poe-crafted-mod",
    color: "#b8daf2"
  },
  {
    name: "Scourge Orange",
    slug: "poe-scourge-orange",
    color: "#ff6e25"
  },
  {
    name: "Essence Blue",
    slug: "poe-essence-blue",
    color: "#33d7ff"
  },
  {
    name: "Prophecy Purple",
    slug: "poe-prophecy-purple",
    color: "#b44bff"
  },
  {
    name: "Tooltip Beige",
    slug: "poe-tooltip-beige",
    color: "#f8e6ca"
  },
  {
    name: "White Rarity Item",
    slug: "poe-white-rarity-item",
    color: "#c8c8c8"
  },
  {
    name: "Grey Tooltip Comment",
    slug: "poe-grey-tooltip-comment",
    color: "#7f7f7f"
  },
  {
    name: "Harvest Blue Seed",
    slug: "poe-harvest-blue-seed",
    color: "#00f5ff"
  },
  {
    name: "Harvest Yellow Seed",
    slug: "poe-harvest-yellow-seed",
    color: "#fffa00"
  },
  {
    name: "Harvest Purple Seed",
    slug: "poe-harvest-purple-seed",
    color: "#ff00eb"
  }
];
function ase(e) {
  var t, i;
  try {
    const r = e, n = L.$createTextNode(e.textContent || "");
    for (const o of sse)
      r.classList.contains(`has-${o.slug}-color`) && (n.setStyle(`color: ${o.color};`), n.getTextContent().startsWith(" ") || n.setTextContent(` ${n.getTextContent()}`), !((i = (t = e.nextSibling) == null ? void 0 : t.textContent) != null && i.startsWith(",")) && !n.getTextContent().endsWith(" ") && n.setTextContent(`${n.getTextContent()} `));
    return { node: n };
  } catch (r) {
    console.log(r);
  }
  return null;
}
class T1 extends L.ElementNode {
  static getType() {
    return "custom-mark";
  }
  static clone(t) {
    return new T1();
  }
  static importDOM() {
    return {
      mark: (t) => t.classList.contains("has-inline-color") ? {
        conversion: ase,
        priority: 3
      } : null
    };
  }
  static importJSON(t) {
    return new T1();
  }
  exportJSON() {
    return ee(q({}, super.exportJSON()), {
      type: "custom-mark"
    });
  }
}
const lse = [
  Jr.HeadingNode,
  zi.ListNode,
  zi.ListItemNode,
  Jr.QuoteNode,
  nn.CodeNode,
  su,
  ct.TableNode,
  ct.TableCellNode,
  ct.TableRowNode,
  A2.HashtagNode,
  nn.CodeHighlightNode,
  Ii.AutoLinkNode,
  Ii.LinkNode,
  J5.OverflowNode,
  z0,
  E0,
  Wl,
  H0,
  Ig,
  Q0,
  Gl,
  G0,
  // KeywordNode,
  Il.HorizontalRuleNode,
  ou,
  kg,
  FD.MarkNode,
  Gc,
  Qc,
  Wc,
  P0,
  Zc,
  Jc,
  g0,
  T1
], cse = "_ltr_1skaa_1", use = "_rtl_1skaa_4", dse = "_paragraph_1skaa_7", mse = "_quote_1skaa_11", gse = "_h1_1skaa_22", hse = "_h2_1skaa_28", pse = "_h3_1skaa_35", fse = "_indent_1skaa_40", Ase = "_textBold_1skaa_43", yse = "_textItalic_1skaa_46", Ese = "_textUnderline_1skaa_49", vse = "_textStrikethrough_1skaa_52", bse = "_textUnderlineStrikethrough_1skaa_55", Cse = "_textSubscript_1skaa_58", xse = "_textSuperscript_1skaa_62", Ise = "_textCode_1skaa_66", Sse = "_hashtag_1skaa_72", Rse = "_link_1skaa_76", kse = "_code_1skaa_84", wse = "_table_1skaa_111", Mse = "_tableSelection_1skaa_120", Nse = "_tableSelected_1skaa_123", Tse = "_tableCell_1skaa_126", Bse = "_tableCellSortedIndicator_1skaa_136", Dse = "_tableCellResizer_1skaa_146", Ose = "_tableCellHeader_1skaa_155", Fse = "_tableCellSelected_1skaa_159", Vse = "_tableCellPrimarySelected_1skaa_162", qse = "_tableCellEditing_1skaa_172", jse = "_tableAddColumns_1skaa_176", Lse = "_tableAddRows_1skaa_204", Kse = "_tableCellResizeRuler_1skaa_240", Yse = "_tableCellActionButtonContainer_1skaa_248", Use = "_tableCellActionButton_1skaa_248", Gse = "_characterLimit_1skaa_270", Qse = "_ol1_1skaa_274", Wse = "_ol2_1skaa_279", Zse = "_ol3_1skaa_285", Jse = "_ol4_1skaa_291", Pse = "_ol5_1skaa_297", zse = "_ul_1skaa_303", Hse = "_listItem_1skaa_308", Xse = "_listItemChecked_1skaa_311", _se = "_listItemUnchecked_1skaa_312", $se = "_nestedListItem_1skaa_371", eae = "_tokenComment_1skaa_378", tae = "_tokenPunctuation_1skaa_381", iae = "_tokenProperty_1skaa_384", rae = "_tokenSelector_1skaa_387", nae = "_tokenOperator_1skaa_390", oae = "_tokenAttr_1skaa_393", sae = "_tokenVariable_1skaa_396", aae = "_tokenFunction_1skaa_399", lae = "_mark_1skaa_402", cae = "_markOverlap_1skaa_407", uae = "_selected_1skaa_411", dae = "_embedBlock_1skaa_419", mae = "_embedBlockFocus_1skaa_422", gae = "_layoutContainer_1skaa_425", Je = {
  ltr: cse,
  rtl: use,
  paragraph: dse,
  quote: mse,
  h1: gse,
  h2: hse,
  h3: pse,
  indent: fse,
  textBold: Ase,
  textItalic: yse,
  textUnderline: Ese,
  textStrikethrough: vse,
  textUnderlineStrikethrough: bse,
  textSubscript: Cse,
  textSuperscript: xse,
  textCode: Ise,
  hashtag: Sse,
  link: Rse,
  code: kse,
  table: wse,
  tableSelection: Mse,
  tableSelected: Nse,
  tableCell: Tse,
  tableCellSortedIndicator: Bse,
  tableCellResizer: Dse,
  tableCellHeader: Ose,
  tableCellSelected: Fse,
  tableCellPrimarySelected: Vse,
  tableCellEditing: qse,
  tableAddColumns: jse,
  "table-controls": "_table-controls_1skaa_1",
  tableAddRows: Lse,
  tableCellResizeRuler: Kse,
  tableCellActionButtonContainer: Yse,
  tableCellActionButton: Use,
  characterLimit: Gse,
  ol1: Qse,
  ol2: Wse,
  ol3: Zse,
  ol4: Jse,
  ol5: Pse,
  ul: zse,
  listItem: Hse,
  listItemChecked: Xse,
  listItemUnchecked: _se,
  nestedListItem: $se,
  tokenComment: eae,
  tokenPunctuation: tae,
  tokenProperty: iae,
  tokenSelector: rae,
  tokenOperator: nae,
  tokenAttr: oae,
  tokenVariable: sae,
  tokenFunction: aae,
  mark: lae,
  markOverlap: cae,
  selected: uae,
  embedBlock: dae,
  embedBlockFocus: mae,
  layoutContainer: gae
}, hae = {
  blockCursor: Je.blockCursor,
  characterLimit: Je.characterLimit,
  code: Je.code,
  codeHighlight: {
    atrule: Je.tokenAttr,
    attr: Je.tokenAttr,
    boolean: Je.tokenProperty,
    builtin: Je.tokenSelector,
    cdata: Je.tokenComment,
    char: Je.tokenSelector,
    class: Je.tokenFunction,
    "class-name": Je.tokenFunction,
    comment: Je.tokenComment,
    constant: Je.tokenProperty,
    deleted: Je.tokenProperty,
    doctype: Je.tokenComment,
    entity: Je.tokenOperator,
    function: Je.tokenFunction,
    important: Je.tokenVariable,
    inserted: Je.tokenSelector,
    keyword: Je.tokenAttr,
    namespace: Je.tokenVariable,
    number: Je.tokenProperty,
    operator: Je.tokenOperator,
    prolog: Je.tokenComment,
    property: Je.tokenProperty,
    punctuation: Je.tokenPunctuation,
    regex: Je.tokenVariable,
    selector: Je.tokenSelector,
    string: Je.tokenSelector,
    symbol: Je.tokenProperty,
    tag: Je.tokenProperty,
    url: Je.tokenOperator,
    variable: Je.tokenVariable
  },
  embedWrapper: Je.embedWrapper,
  embedBlock: {
    base: Je.embedBlock,
    focus: Je.embedBlockFocus
  },
  hashtag: Je.hashtag,
  heading: {
    h1: Je.h1,
    h2: Je.h2,
    h3: Je.h3,
    h4: Je.h4,
    h5: Je.h5,
    h6: Je.h6
  },
  image: `editor-image ${Je.editorImage}`,
  indent: Je.indent,
  inlineImage: `inline-editor-image ${Je.inlineEditorImage}`,
  layoutContainer: Je.layoutContainer,
  layoutItem: Je.layoutItem,
  link: Je.link,
  list: {
    listitem: Je.listItem,
    listitemChecked: Je.listItemChecked,
    listitemUnchecked: Je.listItemUnchecked,
    nested: {
      listitem: Je.nestedListItem
    },
    olDepth: [Je.ol1, Je.ol2, Je.ol3, Je.ol4, Je.ol5],
    ul: Je.ul
  },
  ltr: Je.ltr,
  mark: Je.mark,
  markOverlap: Je.markOverlap,
  paragraph: Je.paragraph,
  quote: Je.quote,
  rtl: Je.rtl,
  table: Je.table,
  tableAddColumns: Je.tableAddColumns,
  tableAddRows: Je.tableAddRows,
  tableCell: Je.tableCell,
  tableCellActionButton: Je.tableCellActionButton,
  tableCellActionButtonContainer: Je.tableCellActionButtonContainer,
  tableCellEditing: Je.tableCellEditing,
  tableCellHeader: Je.tableCellHeader,
  tableCellPrimarySelected: Je.tableCellPrimarySelected,
  tableCellResizer: Je.tableCellResizer,
  tableCellSelected: Je.tableCellSelected,
  tableCellSortedIndicator: Je.tableCellSortedIndicator,
  tableResizeRuler: Je.tableCellResizeRuler,
  tableSelected: Je.tableSelected,
  tableSelection: Je.tableSelection,
  text: {
    bold: Je.textBold,
    code: Je.textCode,
    italic: Je.textItalic,
    strikethrough: Je.textStrikethrough,
    subscript: Je.textSubscript,
    superscript: Je.textSuperscript,
    underline: Je.textUnderline,
    underlineStrikethrough: Je.textUnderlineStrikethrough
  }
};
function pae({ value: e }) {
  const [t] = nt.useLexicalComposerContext();
  return X.useEffect(() => {
    if (e)
      try {
        let i;
        if (typeof e == "string") {
          const n = JSON.parse(e);
          i = t.parseEditorState(n);
        } else
          e.root && (i = t.parseEditorState(JSON.stringify(e)));
        const r = setTimeout(() => {
          i && t.setEditorState(i);
        }, 50);
        return () => {
          clearTimeout(r);
        };
      } catch (i) {
        console.log("Invalid JSON provided, resetting content");
      }
  }, []), null;
}
function fae({ value: e }) {
  const [t] = nt.useLexicalComposerContext();
  return X.useEffect(() => {
    e !== void 0 && t.setEditable(e);
  }, [e]), null;
}
function Aae({
  theme: e,
  customPlugins: t
}) {
  const { historyState: i } = L2(), {
    settings: {
      isAutocomplete: r,
      isMaxLength: n,
      isCharLimit: o,
      isCharLimitUtf8: s,
      isRichText: a,
      showTreeView: l,
      showTableOfContents: c,
      shouldUseLexicalContextMenu: u,
      tableCellMerge: m,
      tableCellBackgroundColor: g
    }
  } = j2(), h = Af(), y = /* @__PURE__ */ f(Mf, { children: a ? "Enter some rich text..." : "Enter some plain text..." }), [E, v] = se(!1), C = {
    namespace: "Maxroll",
    nodes: [...UD],
    onError: (x) => {
      throw x;
    },
    theme: e
  };
  return be(() => {
    const x = () => {
      const S = iu && window.matchMedia("(max-width: 1025px)").matches;
      S !== E && v(S);
    };
    return x(), window.addEventListener("resize", x), () => {
      window.removeEventListener("resize", x);
    };
  }, [E]), /* @__PURE__ */ f(gt, { children: /* @__PURE__ */ V(
    "div",
    {
      className: me(
        "editor-container",
        e.editorContainer,
        h && e.editorContainerEditable,
        l && e.editorContainerTreeView,
        !a && e.editorContainerPlainText
      ),
      children: [
        n && /* @__PURE__ */ f(gO, { maxLength: 30 }),
        /* @__PURE__ */ f($D, {}),
        a ? /* @__PURE__ */ V(gt, { children: [
          /* @__PURE__ */ f(
            p0.RichTextPlugin,
            {
              contentEditable: /* @__PURE__ */ f("div", { className: me("editor", e.editor), children: /* @__PURE__ */ f(kl, {}) }),
              placeholder: y,
              ErrorBoundary: xl
            }
          ),
          /* @__PURE__ */ f(mO, {}),
          /* @__PURE__ */ f(r8, {}),
          /* @__PURE__ */ f(IB.ListPlugin, {}),
          /* @__PURE__ */ f(oB.CheckListPlugin, {}),
          /* @__PURE__ */ f(K8, { maxDepth: 7 }),
          /* @__PURE__ */ f(l7.TablePlugin, { hasCellMerge: m, hasCellBackgroundColor: g }),
          /* @__PURE__ */ f(fO, {}),
          /* @__PURE__ */ V(w8, { cellEditorConfig: C, children: [
            /* @__PURE__ */ f(Ym.AutoFocusPlugin, {}),
            /* @__PURE__ */ f(
              p0.RichTextPlugin,
              {
                contentEditable: /* @__PURE__ */ f(kl, { className: "TableNode__contentEditable" }),
                placeholder: null,
                ErrorBoundary: xl
              }
            ),
            /* @__PURE__ */ f(Mc.HistoryPlugin, {}),
            /* @__PURE__ */ f(k1, { captionsEnabled: !1 }),
            /* @__PURE__ */ f(A0, {}),
            /* @__PURE__ */ f(Sb, {})
          ] }),
          /* @__PURE__ */ f(k1, {}),
          /* @__PURE__ */ f(j8, {}),
          /* @__PURE__ */ f(A0, {}),
          /* @__PURE__ */ f(HD, {}),
          /* @__PURE__ */ f(_D, {}),
          /* @__PURE__ */ f(bB.HorizontalRulePlugin, {}),
          /* @__PURE__ */ f(pO, {}),
          /* @__PURE__ */ f(XB.TabIndentationPlugin, {}),
          /* @__PURE__ */ f(o8, {}),
          /* @__PURE__ */ f(h8, {})
        ] }) : /* @__PURE__ */ V(gt, { children: [
          /* @__PURE__ */ f(
            QB.PlainTextPlugin,
            {
              contentEditable: /* @__PURE__ */ f(kl, {}),
              placeholder: y,
              ErrorBoundary: xl
            }
          ),
          /* @__PURE__ */ f(Mc.HistoryPlugin, { externalHistoryState: i })
        ] }),
        (o || s) && /* @__PURE__ */ f(H5.CharacterLimitPlugin, { charset: o ? "UTF-16" : "UTF-8", maxLength: 5 }),
        r && /* @__PURE__ */ f(S7, {}),
        /* @__PURE__ */ f("div", { children: c && /* @__PURE__ */ f(yO, {}) }),
        u && /* @__PURE__ */ f(N8, {}),
        /* @__PURE__ */ f(q5, {}),
        t
      ]
    }
  ) });
}
const yae = "_editorShell_1sezw_1", Eae = "_editorContainerEditable_1sezw_8", vae = "_editorContainerTreeView_1sezw_14", bae = "_editorContainerPlainText_1sezw_17", Cae = "_layoutContainer_1sezw_22", xae = "_layoutItem_1sezw_23", Iae = "_embedWrapper_1sezw_28", Sae = "_quote_1sezw_34", Rae = "_editorScroller_1sezw_42", kae = "_editor_1sezw_1", wae = "_treeViewOutput_1sezw_63", Mae = "_typeaheadPopover_1sezw_94", Nae = "_selected_1sezw_121", Tae = "_active_1sezw_141", Bae = {
  editorShell: yae,
  editorContainerEditable: Eae,
  editorContainerTreeView: vae,
  editorContainerPlainText: bae,
  layoutContainer: Cae,
  layoutItem: xae,
  embedWrapper: Iae,
  quote: Sae,
  editorScroller: Rae,
  editor: kae,
  treeViewOutput: wae,
  typeaheadPopover: Mae,
  selected: Nae,
  active: Tae
}, Dae = "_editorShell_153k9_1", Oae = "_editorContainerEditable_153k9_4", Fae = "_treeViewOutput_153k9_9", Vae = "_typeaheadPopover_153k9_23", qae = "_selected_153k9_26", jae = {
  editorShell: Dae,
  editorContainerEditable: Oae,
  treeViewOutput: Fae,
  typeaheadPopover: Vae,
  selected: qae
};
function _5e({
  uniqueId: e,
  value: t,
  onChange: i,
  isEditing: r = !1,
  settings: n,
  theme: o,
  darkTheme: s = !0,
  className: a,
  suggestedColors: l,
  customNodes: c,
  customPlugins: u,
  isRestricted: m = !1
}) {
  const [g, h] = se(!0);
  be(() => {
    h(!0);
    const v = setTimeout(() => {
      h(!1);
    }, 100);
    return () => {
      clearTimeout(v);
    };
  }, [e]);
  const A = we(() => Ut.mergeWith(
    { suggestedColors: l },
    hae,
    Bae,
    s ? jae : void 0,
    o,
    (v, C) => v === void 0 ? C : v.indexOf(C) > -1 ? v : `${v} ${C}`
  ), [o]), y = {
    editorState: void 0,
    namespace: "Maxroll",
    editable: r,
    nodes: [...lse, ...c || []],
    onError: (v) => {
      throw v;
    },
    theme: A
  }, E = we(() => e || go(), [e]);
  return /* @__PURE__ */ f(BX, { initialSettings: n, children: /* @__PURE__ */ f("div", { className: me("maxroll-rich-text-editor", a), children: /* @__PURE__ */ f(qP.LexicalComposer, { initialConfig: y, children: /* @__PURE__ */ f(DX, { children: /* @__PURE__ */ f(mre, { children: /* @__PURE__ */ V(UX, { children: [
    /* @__PURE__ */ f("div", { className: me("editor-shell", A.editorShell), children: r ? /* @__PURE__ */ f(ose, { theme: A, customPlugins: u, isRestricted: m }) : /* @__PURE__ */ f(Aae, { theme: A, customPlugins: u }) }),
    /* @__PURE__ */ f(pae, { value: t }),
    /* @__PURE__ */ f(fae, { value: r }),
    i && /* @__PURE__ */ f(
      YP.OnChangePlugin,
      {
        onChange: (v) => {
          g || i(v.toJSON());
        }
      }
    )
  ] }) }) }) }, E) }) });
}
class Lae {
  constructor({ maxrollApiPath: t }) {
    Ze(this, "api");
    this.api = t;
  }
  fetch(t, i, r) {
    return Lt(this, null, function* () {
      return fetch(`${this.api}/${t}`, q({
        method: i || "GET",
        credentials: "include",
        headers: { "Content-Type": "application/json" }
      }, r !== void 0 ? { body: JSON.stringify(r) } : {})).then((n) => n.json());
    });
  }
  fetchUser() {
    return Lt(this, null, function* () {
      return this.fetch("me").then((t) => {
        if ("error" in t) {
          if (t.error === "Not authenticated")
            return;
          throw new Error(t.error);
        }
        return t;
      });
    });
  }
}
function Kae() {
  function e(r) {
    const n = Ne(r), o = Ne(/* @__PURE__ */ new Set()), s = ye(() => n.current, []), a = ye((u) => {
      const m = n.current;
      n.current = q(q({}, n.current), u), o.current.forEach((g) => g(m));
    }, []), l = ye((u) => {
      const m = n.current;
      n.current = q(q({}, n.current), u(m)), o.current.forEach((g) => g(m));
    }, []), c = ye((u) => (o.current.add(u), () => o.current.delete(u)), []);
    return { get: s, set: a, update: l, subscribe: c };
  }
  const t = Co(null);
  function i(r) {
    const n = sn(t);
    if (!n)
      throw new Error("Store state not found!");
    const [o, s] = se(r(n.get()));
    return be(() => n.subscribe((a) => {
      const l = r(a), c = r(n.get());
      JSON.stringify(l) != JSON.stringify(c) && s(c);
    }), []), [o, n.set, n.update];
  }
  return { useStoreData: e, useStore: i, StoreContext: t };
}
function Yae(e) {
  const t = e ? 360 : 1920;
  return ee(q({
    width: t,
    loaded: !1,
    hasPointer: !1
  }, rC(t)), {
    threshold: nC(t)
  });
}
function Uae(e) {
  be(() => {
    e.set({
      viewport: ee(q({
        width: window.innerWidth,
        loaded: !0,
        hasPointer: window.matchMedia("(pointer:fine)").matches
      }, rC(window.innerWidth)), {
        threshold: nC(window.innerWidth)
      })
    });
    const t = () => {
      window.innerWidth != e.get().viewport.width && e.set({
        viewport: ee(q({
          width: window.innerWidth,
          loaded: !0,
          hasPointer: window.matchMedia("(pointer:fine)").matches
        }, rC(window.innerWidth)), {
          threshold: nC(window.innerWidth)
        })
      });
    }, i = (n) => {
      e.set({
        cursor: { x: n.clientX, y: n.clientY }
      });
    }, r = (n) => {
      e.set({
        scrollY: window.scrollY
      });
    };
    return window.addEventListener("resize", t), window.addEventListener("mousemove", i), window.addEventListener("scroll", r), () => {
      window.removeEventListener("resize", t), window.removeEventListener("mousemove", i), window.removeEventListener("scroll", r);
    };
  }, []);
}
function rC(e) {
  return {
    mobile: e < 640,
    sm: e >= 640,
    md: e >= 768,
    lg: e >= 1024,
    xl: e >= 1280,
    "2xl": e >= 1536,
    "3xl": e >= 1900,
    "4xl": e >= 2300
  };
}
function nC(e) {
  return e >= 2300 ? "4xl" : e >= 1900 ? "3xl" : e >= 1536 ? "2xl" : e >= 1280 ? "xl" : e >= 1024 ? "lg" : e >= 768 ? "md" : e >= 640 ? "sm" : "mobile";
}
const { useStoreData: Gae, useStore: gi, StoreContext: Qae } = Kae();
function $5e({
  children: e,
  isMobile: t,
  user: i,
  userLoaded: r,
  userHasSub: n,
  fetchUser: o = !1,
  isDev: s = !1,
  proxyApi: a = !1
}) {
  const l = Gae({
    primaryFilter: void 0,
    teamPageFilter: "d4",
    viewport: Yae(t),
    scale: void 0,
    scrollYDiff: 0,
    user: i,
    userLoaded: r,
    userHasSub: n,
    isDev: s,
    proxyApi: a
  });
  Uae(l), be(() => {
    l.set({ user: i });
  }, [i]), be(() => {
    l.set({ userLoaded: r });
  }, [r]), be(() => {
    l.set({ userHasSub: n });
  }, [n]);
  const c = we(
    () => new Lae({ maxrollApiPath: a ? "/maxroll-api" : "https://maxroll.gg/api" }),
    [a]
  ), u = Ne(!1);
  return be(() => {
    !o || u.current || (u.current = !0, c.fetchUser().then((m) => {
      m != null && m.user && l.set({ user: m.user });
    }).finally(() => {
      l.set({ userLoaded: !0 });
    }));
  }, [c, o]), /* @__PURE__ */ f(Qae.Provider, { value: l, children: e });
}
const B1 = {
  blue: "#057AF0",
  purple: "#B818F0",
  orange: "#F09A18",
  red: "#F00505",
  green: "#199F2F",
  green2: "#21C513"
}, Wae = "_checkbox_1mljs_1", Zae = "_checkboxContainer_1mljs_11", Jae = "_box_1mljs_18", Pae = "_label_1mljs_34", zae = "_sm_1mljs_41", Hae = "_md_1mljs_56", Xae = "_lg_1mljs_71", _ae = "_disabled_1mljs_86", $ae = "_unchecked_1mljs_90", ele = "_checked_1mljs_107", tle = "_blue_1mljs_117", ile = "_green_1mljs_123", da = {
  checkbox: Wae,
  checkboxContainer: Zae,
  box: Jae,
  label: Pae,
  sm: zae,
  md: Hae,
  lg: Xae,
  disabled: _ae,
  unchecked: $ae,
  checked: ele,
  blue: tle,
  green: ile
};
function Ka({
  value: e,
  label: t,
  type: i = "md",
  color: r = "blue",
  disabled: n = !1,
  onChange: o
}) {
  return /* @__PURE__ */ V("div", { className: da.checkbox, children: [
    /* @__PURE__ */ f("input", { type: "checkbox", checked: e, disabled: n, readOnly: !0 }),
    /* @__PURE__ */ V(
      "div",
      {
        className: me(
          da.checkboxContainer,
          da[i],
          da[r],
          n ? da.disabled : e ? da.checked : da.unchecked
        ),
        onClick: o ? (s) => o(!e, s) : void 0,
        children: [
          /* @__PURE__ */ f("div", { className: da.box }),
          t && /* @__PURE__ */ f("label", { className: da.label, children: t })
        ]
      }
    )
  ] });
}
const rle = "_input_1c119_1", nle = "_md_1c119_31", jw = {
  input: rle,
  "sm-md": "_sm-md_1c119_27",
  md: nle
}, kn = T0(
  (a, s) => {
    var l = a, { value: e, type: t = "text", onChange: i, size: r = "md", className: n } = l, o = Fe(l, ["value", "type", "onChange", "size", "className"]);
    const [c, u] = se(e != null ? e : ""), m = Ne(c);
    m.current = c, be(() => {
      e != null && e !== m.current && u(e);
    }, [e]);
    const g = ye(
      (h) => {
        const A = h.target.value;
        u(A), i == null || i(A);
      },
      [i]
    );
    return /* @__PURE__ */ f(
      "input",
      q({
        ref: s,
        type: t,
        value: c || "",
        onChange: g,
        className: me(jw.input, jw[r], n)
      }, o)
    );
  }
);
function EO(e, t) {
  let i = 0, r = t.length;
  for (; r - i > 1; ) {
    const n = i + r - 1 >> 1;
    t[n] < e ? i = n + 1 : r = n + 1;
  }
  return i;
}
function vO(e, t) {
  const i = EO(e, t);
  return i === 0 ? 0 : e >= (t[i] + t[i - 1]) * 0.5 ? i : i - 1;
}
function ole(e, t) {
  return t[vO(e, t)];
}
function Lw(e, t, i) {
  let r = 0, n = t.length >> 1;
  for (; n - r > 1; ) {
    const o = r + n - 1 >> 1;
    t[o + o + 1] < e ? r = o + 1 : n = o + 1;
  }
  return r *= 2, e >= t[r] && e <= t[r + 1] ? e : e > t[r + 1] ? t[r + 1] : r > 0 && i > e ? t[r - 1] : t[r];
}
function eBe(e) {
  const t = [];
  for (let r = 0; r < e.length; r += 2)
    t.push(e.slice(r, r + 2));
  t.sort((r, n) => r[0] - n[0]);
  const i = [];
  for (const [r, n] of t)
    i.length && r <= i[i.length - 1] + 1 ? i[i.length - 1] = Math.max(i[i.length - 1], n) : i.push(r, n);
  return i;
}
function bO(e) {
  return {
    move(t, i) {
      var n, o;
      const r = vO(t, e);
      return i >= 0 ? (n = e[r + 1]) != null ? n : t : (o = e[r - 1]) != null ? o : t;
    },
    nearest(t, i) {
      if (i == null)
        return ole(t, e);
      const r = EO(t, e);
      return t === e[r] || i < t || !r ? e[r] : e[r - 1];
    },
    min: e[0],
    max: e[e.length - 1]
  };
}
function CO(e) {
  return {
    move(t, i) {
      return Lw(t + i, e, t);
    },
    nearest(t, i) {
      return Lw(t, e, i != null ? i : t);
    },
    min: e[0],
    max: e[e.length - 1]
  };
}
function xO(e, t) {
  return {
    move(i, r) {
      return i += r, e != null && (i = Math.max(i, e)), t != null && (i = Math.min(i, t)), i;
    },
    nearest(i) {
      return e != null && (i = Math.max(i, e)), t != null && (i = Math.min(i, t)), i;
    },
    min: e,
    max: t
  };
}
function tBe(e, t, i, r) {
  function n(s) {
    return i != null && (s = Math.max(s, i)), r != null && (s = Math.min(s, r)), s;
  }
  const o = (s) => n(t(s));
  return {
    move(s, a) {
      const l = o(s);
      return a >= 0 ? e(n(l + 1)) : e(n(l - 1));
    },
    nearest(s, a) {
      if (a == null)
        return o(s);
      const l = o(s);
      return s === e(l) || a < s || !l ? e(l) : e(n(l - 1));
    },
    transform: e,
    untransform: o,
    min: i !== void 0 ? e(i) : void 0,
    max: r !== void 0 ? e(r) : void 0
  };
}
const sle = "_input_uh6zr_1", ale = "_md_uh6zr_31", Kw = {
  input: sle,
  "sm-md": "_sm-md_uh6zr_27",
  md: ale
}, Yw = (e, t, i) => i ? parseFloat(e.toFixed(t)).toString() : e.toFixed(t), iBe = X.forwardRef(function(S, x) {
  var R = S, {
    digits: t = 2,
    value: i = 0,
    onChange: r,
    onEnter: n,
    className: o,
    inputSize: s = "md",
    values: a,
    ranges: l,
    filter: c,
    onFocus: u,
    onBlur: m,
    onlyFinal: g,
    trim: h = !0,
    text: A,
    time: y,
    min: E,
    max: v
  } = R, C = Fe(R, [
    "digits",
    "value",
    "onChange",
    "onEnter",
    "className",
    "inputSize",
    "values",
    "ranges",
    "filter",
    "onFocus",
    "onBlur",
    "onlyFinal",
    "trim",
    "text",
    "time",
    "min",
    "max"
  ]);
  const w = C.disabled, T = E === void 0 ? void 0 : Number(E), N = v === void 0 ? void 0 : Number(v), D = C.step === void 0 ? 1 : Number(C.step), [O, F] = se(!0), [Y, P] = se(0), z = Ne(i), W = Ne(null), H = we(() => c || (a ? bO(a) : l ? CO(l) : xO(T, N)), [c, T, N, a, l]), Q = ye(
    (fe) => {
      if (y) {
        const Re = Math.floor(fe / 60);
        let qe = Yw(fe - Re * 60, t, h);
        return qe.match(/^\d(?:\.|$)/) && (qe = "0" + qe), `${Re}:${qe}`;
      } else
        return Yw(fe, t, h);
    },
    [h, t, y]
  ), $ = ye(
    (fe) => {
      if (y) {
        let Re = 0;
        for (const qe of fe.split(":"))
          Re = Re * 60 + parseFloat(qe);
        return Re;
      } else
        return parseFloat(fe);
    },
    [y]
  );
  B0(() => {
    z.current !== i && (z.current = i, W.current.value = Q(i), F(!0));
  }, [i, Y, Q]);
  const le = ye(
    (fe) => {
      W.current.select(), u && u(fe);
    },
    [u]
  ), he = ye(
    (fe) => {
      const Re = fe.target.value.replace(y ? /[^\-\d.:]/g : /[^\-\d.]/g, "");
      fe.target.value !== Re && (fe.target.value = Re);
      const qe = Re.match(y ? /^(?:\d+:)?(\d*)(?:\.(\d*))?$/ : /^-?(\d*)(?:\.(\d*))?$/), Oe = $(fe.target.value);
      if (!qe || isNaN(Oe))
        F(!1), z.current = void 0;
      else {
        const Xe = Math.max(t, qe[2] ? qe[2].length : 0), Qe = Math.exp(-Math.LN10 * Xe) * 0.51;
        let Pe = Oe;
        D && (Pe = Math.round(Pe / D) * D), Pe = H.nearest(Pe, i), Math.abs(Pe - Oe) > Qe ? O && Math.abs(Oe - i) === D ? (W.current.value = Q(Pe), z.current = Pe, F(!0), g || r(Pe)) : (z.current = void 0, F(!1)) : (z.current = Pe, F(!0), g || r(Pe));
      }
    },
    [t, H, D, r, i, O, g, Q, $, y]
  );
  be(() => {
    if (w)
      return;
    function fe(qe) {
      if (qe.shiftKey)
        return;
      qe.preventDefault(), qe.stopPropagation();
      const Oe = H.move(i, (qe.deltaY > 0 ? -1 : 1) * (D || 1));
      W.current.value = Q(Oe), z.current = Oe, r(Oe), F(!0);
    }
    const Re = W.current;
    return Re.addEventListener("wheel", fe, { passive: !1 }), () => Re.removeEventListener("wheel", fe);
  }, [i, r, H, D, Q, w]);
  const oe = ye(
    (fe) => {
      let Re = $(W.current.value);
      isNaN(Re) ? (z.current = i, W.current.value = Q(i), F(!0)) : (D && (Re = Math.round(Re / D) * D), Re = H.nearest(Re, i), z.current = Re, W.current.value = Q(Re), F(!0), r(Re), P((qe) => qe + 1)), m && m(fe);
    },
    [H, D, i, r, m, Q, $]
  ), ue = ye(() => {
    z.current = i, W.current.value = Q(i), F(!0);
  }, [i, Q]), Ae = ye(
    (fe) => {
      if (!w)
        switch (fe.key) {
          case "Enter":
            W.current.blur(), n && n(z.current);
            break;
          case "Esc":
          case "Escape":
            ue(), W.current.blur();
            break;
        }
    },
    [w, n, ue]
  ), de = we(() => sf(W, x), [W, x]);
  return /* @__PURE__ */ f(
    "input",
    q({
      type: A ? "text" : "number",
      defaultValue: Q(i),
      onChange: he,
      onKeyDown: Ae,
      onFocus: le,
      onBlur: oe,
      className: me(Kw.input, Kw[s], o, { invalid: !O }),
      ref: de,
      min: H.min,
      max: H.max
    }, C)
  );
}), lle = "_wrapper_h2kih_1", cle = "_search_h2kih_7", ule = "_searchIcon_h2kih_15", dle = "_collapsed_h2kih_34", mle = "_sm_h2kih_41", gle = "_md_h2kih_47", Vd = {
  wrapper: lle,
  search: cle,
  searchIcon: ule,
  collapsed: dle,
  sm: mle,
  "sm-md": "_sm-md_h2kih_44",
  md: gle
};
function wg(a) {
  var l = a, {
    size: e = "md",
    collapsible: t = !1,
    value: i,
    className: r,
    innerClass: n,
    onBlur: o
  } = l, s = Fe(l, [
    "size",
    "collapsible",
    "value",
    "className",
    "innerClass",
    "onBlur"
  ]);
  const [c, u] = se(t === !0), [m, g] = se(t === !0 && (i === void 0 || i === ""));
  return be(() => {
    const h = i !== void 0 && i !== "";
    h ? u(!1) : t && u(!0), g(t && !h);
  }, [t, i]), /* @__PURE__ */ V(
    "div",
    {
      className: me(Vd.wrapper, Vd[e], c && Vd.collapsed, r),
      onClick: () => {
        c === !0 && u(!1);
      },
      children: [
        /* @__PURE__ */ f(
          kn,
          q({
            className: me(Vd.search, n),
            size: e,
            onBlur: (h) => {
              m && u(!0), o && o(h);
            },
            value: i
          }, s)
        ),
        /* @__PURE__ */ f("span", { className: Vd.searchIcon })
      ]
    }
  );
}
var hle = Object.defineProperty, ple = (e, t, i) => t in e ? hle(e, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[t] = i, wE = (e, t, i) => (ple(e, typeof t != "symbol" ? t + "" : t, i), i);
let fle = class {
  constructor() {
    wE(this, "current", this.detect()), wE(this, "handoffState", "pending"), wE(this, "currentId", 0);
  }
  set(t) {
    this.current !== t && (this.handoffState = "pending", this.currentId = 0, this.current = t);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window == "undefined" || typeof document == "undefined" ? "server" : "client";
  }
  handoff() {
    this.handoffState === "pending" && (this.handoffState = "complete");
  }
  get isHandoffComplete() {
    return this.handoffState === "complete";
  }
}, Bc = new fle(), Ao = (e, t) => {
  Bc.isServer ? be(e, t) : B0(e, t);
};
function Mg(e) {
  let t = Ne(e);
  return Ao(() => {
    t.current = e;
  }, [e]), t;
}
function Ox(e, t) {
  let [i, r] = se(e), n = Mg(e);
  return Ao(() => r(n.current), [n, r, ...t]), i;
}
function Ale(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((t) => setTimeout(() => {
    throw t;
  }));
}
function D1() {
  let e = [], t = { addEventListener(i, r, n, o) {
    return i.addEventListener(r, n, o), t.add(() => i.removeEventListener(r, n, o));
  }, requestAnimationFrame(...i) {
    let r = requestAnimationFrame(...i);
    return t.add(() => cancelAnimationFrame(r));
  }, nextFrame(...i) {
    return t.requestAnimationFrame(() => t.requestAnimationFrame(...i));
  }, setTimeout(...i) {
    let r = setTimeout(...i);
    return t.add(() => clearTimeout(r));
  }, microTask(...i) {
    let r = { current: !0 };
    return Ale(() => {
      r.current && i[0]();
    }), t.add(() => {
      r.current = !1;
    });
  }, style(i, r, n) {
    let o = i.style.getPropertyValue(r);
    return Object.assign(i.style, { [r]: n }), this.add(() => {
      Object.assign(i.style, { [r]: o });
    });
  }, group(i) {
    let r = D1();
    return i(r), this.add(() => r.dispose());
  }, add(i) {
    return e.push(i), () => {
      let r = e.indexOf(i);
      if (r >= 0)
        for (let n of e.splice(r, 1))
          n();
    };
  }, dispose() {
    for (let i of e.splice(0))
      i();
  } };
  return t;
}
function Fx() {
  let [e] = se(D1);
  return be(() => () => e.dispose(), [e]), e;
}
let xi = function(e) {
  let t = Mg(e);
  return X.useCallback((...i) => t.current(...i), [t]);
};
function yle() {
  let e = typeof document == "undefined";
  return "useSyncExternalStore" in ft ? ((t) => t.useSyncExternalStore)(ft)(() => () => {
  }, () => !1, () => !e) : !1;
}
function Ele() {
  let e = yle(), [t, i] = ft.useState(Bc.isHandoffComplete);
  return t && Bc.isHandoffComplete === !1 && i(!1), ft.useEffect(() => {
    t !== !0 && i(!0);
  }, [t]), ft.useEffect(() => Bc.handoff(), []), e ? !1 : t;
}
var Uw;
let Ng = (Uw = X.useId) != null ? Uw : function() {
  let e = Ele(), [t, i] = X.useState(e ? () => Bc.nextId() : null);
  return Ao(() => {
    t === null && i(Bc.nextId());
  }, [t]), t != null ? "" + t : void 0;
};
function Na(e, t, ...i) {
  if (e in t) {
    let n = t[e];
    return typeof n == "function" ? n(...i) : n;
  }
  let r = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((n) => `"${n}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(r, Na), r;
}
function Vx(e) {
  return Bc.isServer ? null : e instanceof Node ? e.ownerDocument : e != null && e.hasOwnProperty("current") && e.current instanceof Node ? e.current.ownerDocument : document;
}
let Gw = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var vle = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e))(vle || {}), ble = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(ble || {}), Cle = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(Cle || {}), IO = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(IO || {});
function xle(e, t = 0) {
  var i;
  return e === ((i = Vx(e)) == null ? void 0 : i.body) ? !1 : Na(t, { 0() {
    return e.matches(Gw);
  }, 1() {
    let r = e;
    for (; r !== null; ) {
      if (r.matches(Gw))
        return !0;
      r = r.parentElement;
    }
    return !1;
  } });
}
var Ile = ((e) => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(Ile || {});
typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("keydown", (e) => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e) => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function Sle(e, t = (i) => i) {
  return e.slice().sort((i, r) => {
    let n = t(i), o = t(r);
    if (n === null || o === null)
      return 0;
    let s = n.compareDocumentPosition(o);
    return s & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : s & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function hp(e, t, i) {
  let r = Mg(t);
  be(() => {
    function n(o) {
      r.current(o);
    }
    return document.addEventListener(e, n, i), () => document.removeEventListener(e, n, i);
  }, [e, i]);
}
function Rle(e, t, i) {
  let r = Mg(t);
  be(() => {
    function n(o) {
      r.current(o);
    }
    return window.addEventListener(e, n, i), () => window.removeEventListener(e, n, i);
  }, [e, i]);
}
function kle(e, t, i = !0) {
  let r = Ne(!1);
  be(() => {
    requestAnimationFrame(() => {
      r.current = i;
    });
  }, [i]);
  function n(s, a) {
    if (!r.current || s.defaultPrevented)
      return;
    let l = a(s);
    if (l === null || !l.getRootNode().contains(l) || !l.isConnected)
      return;
    let c = function u(m) {
      return typeof m == "function" ? u(m()) : Array.isArray(m) || m instanceof Set ? m : [m];
    }(e);
    for (let u of c) {
      if (u === null)
        continue;
      let m = u instanceof HTMLElement ? u : u.current;
      if (m != null && m.contains(l) || s.composed && s.composedPath().includes(m))
        return;
    }
    return !xle(l, IO.Loose) && l.tabIndex !== -1 && s.preventDefault(), t(s, l);
  }
  let o = Ne(null);
  hp("pointerdown", (s) => {
    var a, l;
    r.current && (o.current = ((l = (a = s.composedPath) == null ? void 0 : a.call(s)) == null ? void 0 : l[0]) || s.target);
  }, !0), hp("mousedown", (s) => {
    var a, l;
    r.current && (o.current = ((l = (a = s.composedPath) == null ? void 0 : a.call(s)) == null ? void 0 : l[0]) || s.target);
  }, !0), hp("click", (s) => {
    o.current && (n(s, () => o.current), o.current = null);
  }, !0), hp("touchend", (s) => n(s, () => s.target instanceof HTMLElement ? s.target : null), !0), Rle("blur", (s) => n(s, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function Qw(e) {
  var t;
  if (e.type)
    return e.type;
  let i = (t = e.as) != null ? t : "button";
  if (typeof i == "string" && i.toLowerCase() === "button")
    return "button";
}
function wle(e, t) {
  let [i, r] = se(() => Qw(e));
  return Ao(() => {
    r(Qw(e));
  }, [e.type, e.as]), Ao(() => {
    i || t.current && t.current instanceof HTMLButtonElement && !t.current.hasAttribute("type") && r("button");
  }, [i, t]), i;
}
let Mle = Symbol();
function Tg(...e) {
  let t = Ne(e);
  be(() => {
    t.current = e;
  }, [e]);
  let i = xi((r) => {
    for (let n of t.current)
      n != null && (typeof n == "function" ? n(r) : n.current = r);
  });
  return e.every((r) => r == null || (r == null ? void 0 : r[Mle])) ? void 0 : i;
}
function Nle({ container: e, accept: t, walk: i, enabled: r = !0 }) {
  let n = Ne(t), o = Ne(i);
  be(() => {
    n.current = t, o.current = i;
  }, [t, i]), Ao(() => {
    if (!e || !r)
      return;
    let s = Vx(e);
    if (!s)
      return;
    let a = n.current, l = o.current, c = Object.assign((m) => a(m), { acceptNode: a }), u = s.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, c, !1);
    for (; u.nextNode(); )
      l(u.currentNode);
  }, [e, r, n, o]);
}
function Tle(e) {
  throw new Error("Unexpected object: " + e);
}
var Qr = ((e) => (e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))(Qr || {});
function Ble(e, t) {
  let i = t.resolveItems();
  if (i.length <= 0)
    return null;
  let r = t.resolveActiveIndex(), n = r != null ? r : -1, o = (() => {
    switch (e.focus) {
      case 0:
        return i.findIndex((s) => !t.resolveDisabled(s));
      case 1: {
        let s = i.slice().reverse().findIndex((a, l, c) => n !== -1 && c.length - l - 1 >= n ? !1 : !t.resolveDisabled(a));
        return s === -1 ? s : i.length - 1 - s;
      }
      case 2:
        return i.findIndex((s, a) => a <= n ? !1 : !t.resolveDisabled(s));
      case 3: {
        let s = i.slice().reverse().findIndex((a) => !t.resolveDisabled(a));
        return s === -1 ? s : i.length - 1 - s;
      }
      case 4:
        return i.findIndex((s) => t.resolveId(s) === e.id);
      case 5:
        return null;
      default:
        Tle(e);
    }
  })();
  return o === -1 ? r : o;
}
function Ww(...e) {
  return Array.from(new Set(e.flatMap((t) => typeof t == "string" ? t.split(" ") : []))).filter(Boolean).join(" ");
}
var oC = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(oC || {}), Dle = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(Dle || {});
function au({ ourProps: e, theirProps: t, slot: i, defaultTag: r, features: n, visible: o = !0, name: s }) {
  let a = SO(t, e);
  if (o)
    return pp(a, i, r, s);
  let l = n != null ? n : 0;
  if (l & 2) {
    let c = a, { static: m = !1 } = c, g = Fe(c, ["static"]);
    if (m)
      return pp(g, i, r, s);
  }
  if (l & 1) {
    let u = a, { unmount: m = !0 } = u, g = Fe(u, ["unmount"]);
    return Na(m ? 0 : 1, { 0() {
      return null;
    }, 1() {
      return pp(ee(q({}, g), { hidden: !0, style: { display: "none" } }), i, r, s);
    } });
  }
  return pp(a, i, r, s);
}
function pp(e, t = {}, i, r) {
  let m = ME(e, ["unmount", "static"]), { as: n = i, children: o, refName: s = "ref" } = m, a = Fe(m, ["as", "children", "refName"]), l = e.ref !== void 0 ? { [s]: e.ref } : {}, c = typeof o == "function" ? o(t) : o;
  "className" in a && a.className && typeof a.className == "function" && (a.className = a.className(t));
  let u = {};
  if (t) {
    let g = !1, h = [];
    for (let [A, y] of Object.entries(t))
      typeof y == "boolean" && (g = !0), y === !0 && h.push(A);
    g && (u["data-headlessui-state"] = h.join(" "));
  }
  if (n === bl && Object.keys(sC(a)).length > 0) {
    if (!ug(c) || Array.isArray(c) && c.length > 1)
      throw new Error(['Passing props on "Fragment"!', "", `The current component <${r} /> is rendering a "Fragment".`, "However we need to passthrough the following props:", Object.keys(a).map((y) => `  - ${y}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map((y) => `  - ${y}`).join(`
`)].join(`
`));
    let g = c.props, h = typeof (g == null ? void 0 : g.className) == "function" ? (...y) => Ww(g == null ? void 0 : g.className(...y), a.className) : Ww(g == null ? void 0 : g.className, a.className), A = h ? { className: h } : {};
    return dg(c, Object.assign({}, SO(c.props, sC(ME(a, ["ref"]))), u, l, Ole(c.ref, l.ref), A));
  }
  return Ei(n, Object.assign({}, ME(a, ["ref"]), n !== bl && l, n !== bl && u), c);
}
function Ole(...e) {
  return { ref: e.every((t) => t == null) ? void 0 : (t) => {
    for (let i of e)
      i != null && (typeof i == "function" ? i(t) : i.current = t);
  } };
}
function SO(...e) {
  if (e.length === 0)
    return {};
  if (e.length === 1)
    return e[0];
  let t = {}, i = {};
  for (let r of e)
    for (let n in r)
      n.startsWith("on") && typeof r[n] == "function" ? (i[n] != null || (i[n] = []), i[n].push(r[n])) : t[n] = r[n];
  if (t.disabled || t["aria-disabled"])
    return Object.assign(t, Object.fromEntries(Object.keys(i).map((r) => [r, void 0])));
  for (let r in i)
    Object.assign(t, { [r](n, ...o) {
      let s = i[r];
      for (let a of s) {
        if ((n instanceof Event || (n == null ? void 0 : n.nativeEvent) instanceof Event) && n.defaultPrevented)
          return;
        a(n, ...o);
      }
    } });
  return t;
}
function lu(e) {
  var t;
  return Object.assign(T0(e), { displayName: (t = e.displayName) != null ? t : e.name });
}
function sC(e) {
  let t = Object.assign({}, e);
  for (let i in t)
    t[i] === void 0 && delete t[i];
  return t;
}
function ME(e, t = []) {
  let i = Object.assign({}, e);
  for (let r of t)
    r in i && delete i[r];
  return i;
}
function Fle(e) {
  let t = e.parentElement, i = null;
  for (; t && !(t instanceof HTMLFieldSetElement); )
    t instanceof HTMLLegendElement && (i = t), t = t.parentElement;
  let r = (t == null ? void 0 : t.getAttribute("disabled")) === "";
  return r && Vle(i) ? !1 : r;
}
function Vle(e) {
  if (!e)
    return !1;
  let t = e.previousElementSibling;
  for (; t !== null; ) {
    if (t instanceof HTMLLegendElement)
      return !1;
    t = t.previousElementSibling;
  }
  return !0;
}
function RO(e = {}, t = null, i = []) {
  for (let [r, n] of Object.entries(e))
    wO(i, kO(t, r), n);
  return i;
}
function kO(e, t) {
  return e ? e + "[" + t + "]" : t;
}
function wO(e, t, i) {
  if (Array.isArray(i))
    for (let [r, n] of i.entries())
      wO(e, kO(t, r.toString()), n);
  else
    i instanceof Date ? e.push([t, i.toISOString()]) : typeof i == "boolean" ? e.push([t, i ? "1" : "0"]) : typeof i == "string" ? e.push([t, i]) : typeof i == "number" ? e.push([t, `${i}`]) : i == null ? e.push([t, ""]) : RO(i, t, e);
}
let qle = "div";
var MO = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(MO || {});
function jle(e, t) {
  let o = e, { features: i = 1 } = o, r = Fe(o, ["features"]), n = { ref: t, "aria-hidden": (i & 2) === 2 ? !0 : void 0, style: q({ position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0" }, (i & 4) === 4 && (i & 2) !== 2 && { display: "none" }) };
  return au({ ourProps: n, theirProps: r, slot: {}, defaultTag: qle, name: "Hidden" });
}
let Lle = lu(jle), qx = Co(null);
qx.displayName = "OpenClosedContext";
var Hm = ((e) => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(Hm || {});
function Kle() {
  return sn(qx);
}
function Yle({ value: e, children: t }) {
  return X.createElement(qx.Provider, { value: e }, t);
}
var co = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(co || {});
function Ule(e, t, i) {
  let [r, n] = se(i), o = e !== void 0, s = Ne(o), a = Ne(!1), l = Ne(!1);
  return o && !s.current && !a.current ? (a.current = !0, s.current = o, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !o && s.current && !l.current && (l.current = !0, s.current = o, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [o ? e : r, xi((c) => (o || n(c), t == null ? void 0 : t(c)))];
}
function Zw(e, t) {
  let i = Ne([]), r = xi(e);
  be(() => {
    let n = [...i.current];
    for (let [o, s] of t.entries())
      if (i.current[o] !== s) {
        let a = r(t, n);
        return i.current = t, a;
      }
  }, [r, ...t]);
}
function Jw(e) {
  return [e.screenX, e.screenY];
}
function Gle() {
  let e = Ne([-1, -1]);
  return { wasMoved(t) {
    let i = Jw(t);
    return e.current[0] === i[0] && e.current[1] === i[1] ? !1 : (e.current = i, !0);
  }, update(t) {
    e.current = Jw(t);
  } };
}
function Qle() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function Wle() {
  return /Android/gi.test(window.navigator.userAgent);
}
function Zle() {
  return Qle() || Wle();
}
function Jle(...e) {
  return we(() => Vx(...e), [...e]);
}
var Ple = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(Ple || {}), zle = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(zle || {}), Hle = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(Hle || {}), Xle = ((e) => (e[e.OpenCombobox = 0] = "OpenCombobox", e[e.CloseCombobox = 1] = "CloseCombobox", e[e.GoToOption = 2] = "GoToOption", e[e.RegisterOption = 3] = "RegisterOption", e[e.UnregisterOption = 4] = "UnregisterOption", e[e.RegisterLabel = 5] = "RegisterLabel", e))(Xle || {});
function NE(e, t = (i) => i) {
  let i = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null, r = Sle(t(e.options.slice()), (o) => o.dataRef.current.domRef.current), n = i ? r.indexOf(i) : null;
  return n === -1 && (n = null), { options: r, activeOptionIndex: n };
}
let _le = { 1(e) {
  var t;
  return (t = e.dataRef.current) != null && t.disabled || e.comboboxState === 1 ? e : ee(q({}, e), { activeOptionIndex: null, comboboxState: 1 });
}, 0(e) {
  var t;
  if ((t = e.dataRef.current) != null && t.disabled || e.comboboxState === 0)
    return e;
  let i = e.activeOptionIndex;
  if (e.dataRef.current) {
    let { isSelected: r } = e.dataRef.current, n = e.options.findIndex((o) => r(o.dataRef.current.value));
    n !== -1 && (i = n);
  }
  return ee(q({}, e), { comboboxState: 0, activeOptionIndex: i });
}, 2(e, t) {
  var i, r, n, o;
  if ((i = e.dataRef.current) != null && i.disabled || (r = e.dataRef.current) != null && r.optionsRef.current && !((n = e.dataRef.current) != null && n.optionsPropsRef.current.static) && e.comboboxState === 1)
    return e;
  let s = NE(e);
  if (s.activeOptionIndex === null) {
    let l = s.options.findIndex((c) => !c.dataRef.current.disabled);
    l !== -1 && (s.activeOptionIndex = l);
  }
  let a = Ble(t, { resolveItems: () => s.options, resolveActiveIndex: () => s.activeOptionIndex, resolveId: (l) => l.id, resolveDisabled: (l) => l.dataRef.current.disabled });
  return ee(q(q({}, e), s), { activeOptionIndex: a, activationTrigger: (o = t.trigger) != null ? o : 1 });
}, 3: (e, t) => {
  var i, r;
  let n = { id: t.id, dataRef: t.dataRef }, o = NE(e, (a) => [...a, n]);
  e.activeOptionIndex === null && (i = e.dataRef.current) != null && i.isSelected(t.dataRef.current.value) && (o.activeOptionIndex = o.options.indexOf(n));
  let s = ee(q(q({}, e), o), { activationTrigger: 1 });
  return (r = e.dataRef.current) != null && r.__demoMode && e.dataRef.current.value === void 0 && (s.activeOptionIndex = 0), s;
}, 4: (e, t) => {
  let i = NE(e, (r) => {
    let n = r.findIndex((o) => o.id === t.id);
    return n !== -1 && r.splice(n, 1), r;
  });
  return ee(q(q({}, e), i), { activationTrigger: 1 });
}, 5: (e, t) => ee(q({}, e), { labelId: t.id }) }, jx = Co(null);
jx.displayName = "ComboboxActionsContext";
function Bg(e) {
  let t = sn(jx);
  if (t === null) {
    let i = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(i, Bg), i;
  }
  return t;
}
let Lx = Co(null);
Lx.displayName = "ComboboxDataContext";
function _0(e) {
  let t = sn(Lx);
  if (t === null) {
    let i = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(i, _0), i;
  }
  return t;
}
function $le(e, t) {
  return Na(t.type, _le, e, t);
}
let ece = bl;
function tce(e, t) {
  let de = e, { value: i, defaultValue: r, onChange: n, form: o, name: s, by: a = (fe, Re) => fe === Re, disabled: l = !1, __demoMode: c = !1, nullable: u = !1, multiple: m = !1 } = de, g = Fe(de, ["value", "defaultValue", "onChange", "form", "name", "by", "disabled", "__demoMode", "nullable", "multiple"]), [h = m ? [] : void 0, A] = Ule(i, n, r), [y, E] = RN($le, { dataRef: wW(), comboboxState: c ? 0 : 1, options: [], activeOptionIndex: null, activationTrigger: 1, labelId: null }), v = Ne(!1), C = Ne({ static: !1, hold: !1 }), x = Ne(null), S = Ne(null), R = Ne(null), w = Ne(null), T = xi(typeof a == "string" ? (fe, Re) => {
    let qe = a;
    return (fe == null ? void 0 : fe[qe]) === (Re == null ? void 0 : Re[qe]);
  } : a), N = ye((fe) => Na(D.mode, { 1: () => h.some((Re) => T(Re, fe)), 0: () => T(h, fe) }), [h]), D = we(() => ee(q({}, y), { optionsPropsRef: C, labelRef: x, inputRef: S, buttonRef: R, optionsRef: w, value: h, defaultValue: r, disabled: l, mode: m ? 1 : 0, get activeOptionIndex() {
    if (v.current && y.activeOptionIndex === null && y.options.length > 0) {
      let fe = y.options.findIndex((Re) => !Re.dataRef.current.disabled);
      if (fe !== -1)
        return fe;
    }
    return y.activeOptionIndex;
  }, compare: T, isSelected: N, nullable: u, __demoMode: c }), [h, r, l, m, u, c, y]), O = Ne(D.activeOptionIndex !== null ? D.options[D.activeOptionIndex] : null);
  be(() => {
    let fe = D.activeOptionIndex !== null ? D.options[D.activeOptionIndex] : null;
    O.current !== fe && (O.current = fe);
  }), Ao(() => {
    y.dataRef.current = D;
  }, [D]), kle([D.buttonRef, D.inputRef, D.optionsRef], () => he.closeCombobox(), D.comboboxState === 0);
  let F = we(() => ({ open: D.comboboxState === 0, disabled: l, activeIndex: D.activeOptionIndex, activeOption: D.activeOptionIndex === null ? null : D.options[D.activeOptionIndex].dataRef.current.value, value: h }), [D, l, h]), Y = xi((fe) => {
    let Re = D.options.find((qe) => qe.id === fe);
    Re && le(Re.dataRef.current.value);
  }), P = xi(() => {
    if (D.activeOptionIndex !== null) {
      let { dataRef: fe, id: Re } = D.options[D.activeOptionIndex];
      le(fe.current.value), he.goToOption(Qr.Specific, Re);
    }
  }), z = xi(() => {
    E({ type: 0 }), v.current = !0;
  }), W = xi(() => {
    E({ type: 1 }), v.current = !1;
  }), H = xi((fe, Re, qe) => (v.current = !1, fe === Qr.Specific ? E({ type: 2, focus: Qr.Specific, id: Re, trigger: qe }) : E({ type: 2, focus: fe, trigger: qe }))), Q = xi((fe, Re) => (E({ type: 3, id: fe, dataRef: Re }), () => {
    var qe;
    ((qe = O.current) == null ? void 0 : qe.id) === fe && (v.current = !0), E({ type: 4, id: fe });
  })), $ = xi((fe) => (E({ type: 5, id: fe }), () => E({ type: 5, id: null }))), le = xi((fe) => Na(D.mode, { 0() {
    return A == null ? void 0 : A(fe);
  }, 1() {
    let Re = D.value.slice(), qe = Re.findIndex((Oe) => T(Oe, fe));
    return qe === -1 ? Re.push(fe) : Re.splice(qe, 1), A == null ? void 0 : A(Re);
  } })), he = we(() => ({ onChange: le, registerOption: Q, registerLabel: $, goToOption: H, closeCombobox: W, openCombobox: z, selectActiveOption: P, selectOption: Y }), []), oe = t === null ? {} : { ref: t }, ue = Ne(null), Ae = Fx();
  return be(() => {
    ue.current && r !== void 0 && Ae.addEventListener(ue.current, "reset", () => {
      A == null || A(r);
    });
  }, [ue, A]), X.createElement(jx.Provider, { value: he }, X.createElement(Lx.Provider, { value: D }, X.createElement(Yle, { value: Na(D.comboboxState, { 0: Hm.Open, 1: Hm.Closed }) }, s != null && h != null && RO({ [s]: h }).map(([fe, Re], qe) => X.createElement(Lle, q({ features: MO.Hidden, ref: qe === 0 ? (Oe) => {
    var Xe;
    ue.current = (Xe = Oe == null ? void 0 : Oe.closest("form")) != null ? Xe : null;
  } : void 0 }, sC({ key: fe, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: o, name: fe, value: Re })))), au({ ourProps: oe, theirProps: g, slot: F, defaultTag: ece, name: "Combobox" }))));
}
let ice = "input";
function rce(e, t) {
  var i, r, n, o;
  let s = Ng(), P = e, { id: a = `headlessui-combobox-input-${s}`, onChange: l, displayValue: c, type: u = "text" } = P, m = Fe(P, ["id", "onChange", "displayValue", "type"]), g = _0("Combobox.Input"), h = Bg("Combobox.Input"), A = Tg(g.inputRef, t), y = Jle(g.inputRef), E = Ne(!1), v = Fx(), C = xi(() => {
    h.onChange(null), g.optionsRef.current && (g.optionsRef.current.scrollTop = 0), h.goToOption(Qr.Nothing);
  }), x = function() {
    var z;
    return typeof c == "function" && g.value !== void 0 ? (z = c(g.value)) != null ? z : "" : typeof g.value == "string" ? g.value : "";
  }();
  Zw(([z, W], [H, Q]) => {
    if (E.current)
      return;
    let $ = g.inputRef.current;
    $ && ((Q === 0 && W === 1 || z !== H) && ($.value = z), requestAnimationFrame(() => {
      if (E.current || !$ || (y == null ? void 0 : y.activeElement) !== $)
        return;
      let { selectionStart: le, selectionEnd: he } = $;
      Math.abs((he != null ? he : 0) - (le != null ? le : 0)) === 0 && le === 0 && $.setSelectionRange($.value.length, $.value.length);
    }));
  }, [x, g.comboboxState, y]), Zw(([z], [W]) => {
    if (z === 0 && W === 1) {
      if (E.current)
        return;
      let H = g.inputRef.current;
      if (!H)
        return;
      let Q = H.value, { selectionStart: $, selectionEnd: le, selectionDirection: he } = H;
      H.value = "", H.value = Q, he !== null ? H.setSelectionRange($, le, he) : H.setSelectionRange($, le);
    }
  }, [g.comboboxState]);
  let S = Ne(!1), R = xi(() => {
    S.current = !0;
  }), w = xi(() => {
    v.nextFrame(() => {
      S.current = !1;
    });
  }), T = xi((z) => {
    switch (E.current = !0, z.key) {
      case co.Enter:
        if (E.current = !1, g.comboboxState !== 0 || S.current)
          return;
        if (z.preventDefault(), z.stopPropagation(), g.activeOptionIndex === null) {
          h.closeCombobox();
          return;
        }
        h.selectActiveOption(), g.mode === 0 && h.closeCombobox();
        break;
      case co.ArrowDown:
        return E.current = !1, z.preventDefault(), z.stopPropagation(), Na(g.comboboxState, { 0: () => {
          h.goToOption(Qr.Next);
        }, 1: () => {
          h.openCombobox();
        } });
      case co.ArrowUp:
        return E.current = !1, z.preventDefault(), z.stopPropagation(), Na(g.comboboxState, { 0: () => {
          h.goToOption(Qr.Previous);
        }, 1: () => {
          h.openCombobox(), v.nextFrame(() => {
            g.value || h.goToOption(Qr.Last);
          });
        } });
      case co.Home:
        if (z.shiftKey)
          break;
        return E.current = !1, z.preventDefault(), z.stopPropagation(), h.goToOption(Qr.First);
      case co.PageUp:
        return E.current = !1, z.preventDefault(), z.stopPropagation(), h.goToOption(Qr.First);
      case co.End:
        if (z.shiftKey)
          break;
        return E.current = !1, z.preventDefault(), z.stopPropagation(), h.goToOption(Qr.Last);
      case co.PageDown:
        return E.current = !1, z.preventDefault(), z.stopPropagation(), h.goToOption(Qr.Last);
      case co.Escape:
        return E.current = !1, g.comboboxState !== 0 ? void 0 : (z.preventDefault(), g.optionsRef.current && !g.optionsPropsRef.current.static && z.stopPropagation(), g.nullable && g.mode === 0 && g.value === null && C(), h.closeCombobox());
      case co.Tab:
        if (E.current = !1, g.comboboxState !== 0)
          return;
        g.mode === 0 && h.selectActiveOption(), h.closeCombobox();
        break;
    }
  }), N = xi((z) => {
    l == null || l(z), g.nullable && g.mode === 0 && z.target.value === "" && C(), h.openCombobox();
  }), D = xi(() => {
    E.current = !1;
  }), O = Ox(() => {
    if (g.labelId)
      return [g.labelId].join(" ");
  }, [g.labelId]), F = we(() => ({ open: g.comboboxState === 0, disabled: g.disabled }), [g]), Y = { ref: A, id: a, role: "combobox", type: u, "aria-controls": (i = g.optionsRef.current) == null ? void 0 : i.id, "aria-expanded": g.comboboxState === 0, "aria-activedescendant": g.activeOptionIndex === null || (r = g.options[g.activeOptionIndex]) == null ? void 0 : r.id, "aria-labelledby": O, "aria-autocomplete": "list", defaultValue: (o = (n = e.defaultValue) != null ? n : g.defaultValue !== void 0 ? c == null ? void 0 : c(g.defaultValue) : null) != null ? o : g.defaultValue, disabled: g.disabled, onCompositionStart: R, onCompositionEnd: w, onKeyDown: T, onChange: N, onBlur: D };
  return au({ ourProps: Y, theirProps: m, slot: F, defaultTag: ice, name: "Combobox.Input" });
}
let nce = "button";
function oce(e, t) {
  var i;
  let r = _0("Combobox.Button"), n = Bg("Combobox.Button"), o = Tg(r.buttonRef, t), s = Ng(), y = e, { id: a = `headlessui-combobox-button-${s}` } = y, l = Fe(y, ["id"]), c = Fx(), u = xi((E) => {
    switch (E.key) {
      case co.ArrowDown:
        return E.preventDefault(), E.stopPropagation(), r.comboboxState === 1 && n.openCombobox(), c.nextFrame(() => {
          var v;
          return (v = r.inputRef.current) == null ? void 0 : v.focus({ preventScroll: !0 });
        });
      case co.ArrowUp:
        return E.preventDefault(), E.stopPropagation(), r.comboboxState === 1 && (n.openCombobox(), c.nextFrame(() => {
          r.value || n.goToOption(Qr.Last);
        })), c.nextFrame(() => {
          var v;
          return (v = r.inputRef.current) == null ? void 0 : v.focus({ preventScroll: !0 });
        });
      case co.Escape:
        return r.comboboxState !== 0 ? void 0 : (E.preventDefault(), r.optionsRef.current && !r.optionsPropsRef.current.static && E.stopPropagation(), n.closeCombobox(), c.nextFrame(() => {
          var v;
          return (v = r.inputRef.current) == null ? void 0 : v.focus({ preventScroll: !0 });
        }));
      default:
        return;
    }
  }), m = xi((E) => {
    if (Fle(E.currentTarget))
      return E.preventDefault();
    r.comboboxState === 0 ? n.closeCombobox() : (E.preventDefault(), n.openCombobox()), c.nextFrame(() => {
      var v;
      return (v = r.inputRef.current) == null ? void 0 : v.focus({ preventScroll: !0 });
    });
  }), g = Ox(() => {
    if (r.labelId)
      return [r.labelId, a].join(" ");
  }, [r.labelId, a]), h = we(() => ({ open: r.comboboxState === 0, disabled: r.disabled, value: r.value }), [r]), A = { ref: o, id: a, type: wle(e, r.buttonRef), tabIndex: -1, "aria-haspopup": "listbox", "aria-controls": (i = r.optionsRef.current) == null ? void 0 : i.id, "aria-expanded": r.comboboxState === 0, "aria-labelledby": g, disabled: r.disabled, onClick: m, onKeyDown: u };
  return au({ ourProps: A, theirProps: l, slot: h, defaultTag: nce, name: "Combobox.Button" });
}
let sce = "label";
function ace(e, t) {
  let i = Ng(), u = e, { id: r = `headlessui-combobox-label-${i}` } = u, n = Fe(u, ["id"]), o = _0("Combobox.Label"), s = Bg("Combobox.Label"), a = Tg(o.labelRef, t);
  Ao(() => s.registerLabel(r), [r]);
  let l = xi(() => {
    var m;
    return (m = o.inputRef.current) == null ? void 0 : m.focus({ preventScroll: !0 });
  }), c = we(() => ({ open: o.comboboxState === 0, disabled: o.disabled }), [o]);
  return au({ ourProps: { ref: a, id: r, onClick: l }, theirProps: n, slot: c, defaultTag: sce, name: "Combobox.Label" });
}
let lce = "ul", cce = oC.RenderStrategy | oC.Static;
function uce(e, t) {
  let i = Ng(), h = e, { id: r = `headlessui-combobox-options-${i}`, hold: n = !1 } = h, o = Fe(h, ["id", "hold"]), s = _0("Combobox.Options"), a = Tg(s.optionsRef, t), l = Kle(), c = (() => l !== null ? (l & Hm.Open) === Hm.Open : s.comboboxState === 0)();
  Ao(() => {
    var A;
    s.optionsPropsRef.current.static = (A = e.static) != null ? A : !1;
  }, [s.optionsPropsRef, e.static]), Ao(() => {
    s.optionsPropsRef.current.hold = n;
  }, [s.optionsPropsRef, n]), Nle({ container: s.optionsRef.current, enabled: s.comboboxState === 0, accept(A) {
    return A.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : A.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(A) {
    A.setAttribute("role", "none");
  } });
  let u = Ox(() => {
    var A, y;
    return (y = s.labelId) != null ? y : (A = s.buttonRef.current) == null ? void 0 : A.id;
  }, [s.labelId, s.buttonRef.current]), m = we(() => ({ open: s.comboboxState === 0 }), [s]), g = { "aria-labelledby": u, role: "listbox", "aria-multiselectable": s.mode === 1 ? !0 : void 0, id: r, ref: a };
  return au({ ourProps: g, theirProps: o, slot: m, defaultTag: lce, features: cce, visible: c, name: "Combobox.Options" });
}
let dce = "li";
function mce(e, t) {
  var i, r;
  let n = Ng(), D = e, { id: o = `headlessui-combobox-option-${n}`, disabled: s = !1, value: a } = D, l = Fe(D, ["id", "disabled", "value"]), c = _0("Combobox.Option"), u = Bg("Combobox.Option"), m = c.activeOptionIndex !== null ? c.options[c.activeOptionIndex].id === o : !1, g = c.isSelected(a), h = Ne(null), A = Mg({ disabled: s, value: a, domRef: h, textValue: (r = (i = h.current) == null ? void 0 : i.textContent) == null ? void 0 : r.toLowerCase() }), y = Tg(t, h), E = xi(() => u.selectOption(o));
  Ao(() => u.registerOption(o, A), [A, o]);
  let v = Ne(!c.__demoMode);
  Ao(() => {
    if (!c.__demoMode)
      return;
    let O = D1();
    return O.requestAnimationFrame(() => {
      v.current = !0;
    }), O.dispose;
  }, []), Ao(() => {
    if (c.comboboxState !== 0 || !m || !v.current || c.activationTrigger === 0)
      return;
    let O = D1();
    return O.requestAnimationFrame(() => {
      var F, Y;
      (Y = (F = h.current) == null ? void 0 : F.scrollIntoView) == null || Y.call(F, { block: "nearest" });
    }), O.dispose;
  }, [h, m, c.comboboxState, c.activationTrigger, c.activeOptionIndex]);
  let C = xi((O) => {
    if (s)
      return O.preventDefault();
    E(), c.mode === 0 && u.closeCombobox(), Zle() || requestAnimationFrame(() => {
      var F;
      return (F = c.inputRef.current) == null ? void 0 : F.focus();
    });
  }), x = xi(() => {
    if (s)
      return u.goToOption(Qr.Nothing);
    u.goToOption(Qr.Specific, o);
  }), S = Gle(), R = xi((O) => S.update(O)), w = xi((O) => {
    S.wasMoved(O) && (s || m || u.goToOption(Qr.Specific, o, 0));
  }), T = xi((O) => {
    S.wasMoved(O) && (s || m && (c.optionsPropsRef.current.hold || u.goToOption(Qr.Nothing)));
  }), N = we(() => ({ active: m, selected: g, disabled: s }), [m, g, s]);
  return au({ ourProps: { id: o, ref: y, role: "option", tabIndex: s === !0 ? void 0 : -1, "aria-disabled": s === !0 ? !0 : void 0, "aria-selected": g, disabled: void 0, onClick: C, onFocus: x, onPointerEnter: R, onMouseEnter: R, onPointerMove: w, onMouseMove: w, onPointerLeave: T, onMouseLeave: T }, theirProps: l, slot: N, defaultTag: dce, name: "Combobox.Option" });
}
let gce = lu(tce), hce = lu(oce), pce = lu(rce), fce = lu(ace), Ace = lu(uce), yce = lu(mce), Xm = Object.assign(gce, { Input: pce, Button: hce, Label: fce, Options: Ace, Option: yce });
var Pw = function(t) {
  return t.reduce(function(i, r) {
    var n = r[0], o = r[1];
    return i[n] = o, i;
  }, {});
}, zw = typeof window != "undefined" && window.document && window.document.createElement ? ft.useLayoutEffect : ft.useEffect, Jn = "top", Po = "bottom", zo = "right", Pn = "left", Kx = "auto", Dg = [Jn, Po, zo, Pn], v0 = "start", _m = "end", Ece = "clippingParents", NO = "viewport", qd = "popper", vce = "reference", Hw = /* @__PURE__ */ Dg.reduce(function(e, t) {
  return e.concat([t + "-" + v0, t + "-" + _m]);
}, []), TO = /* @__PURE__ */ [].concat(Dg, [Kx]).reduce(function(e, t) {
  return e.concat([t, t + "-" + v0, t + "-" + _m]);
}, []), bce = "beforeRead", Cce = "read", xce = "afterRead", Ice = "beforeMain", Sce = "main", Rce = "afterMain", kce = "beforeWrite", wce = "write", Mce = "afterWrite", Nce = [bce, Cce, xce, Ice, Sce, Rce, kce, wce, Mce];
function Qs(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function bo(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Pc(e) {
  var t = bo(e).Element;
  return e instanceof t || e instanceof Element;
}
function Qo(e) {
  var t = bo(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function Yx(e) {
  if (typeof ShadowRoot == "undefined")
    return !1;
  var t = bo(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function Tce(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(i) {
    var r = t.styles[i] || {}, n = t.attributes[i] || {}, o = t.elements[i];
    !Qo(o) || !Qs(o) || (Object.assign(o.style, r), Object.keys(n).forEach(function(s) {
      var a = n[s];
      a === !1 ? o.removeAttribute(s) : o.setAttribute(s, a === !0 ? "" : a);
    }));
  });
}
function Bce(e) {
  var t = e.state, i = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, i.popper), t.styles = i, t.elements.arrow && Object.assign(t.elements.arrow.style, i.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var n = t.elements[r], o = t.attributes[r] || {}, s = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : i[r]), a = s.reduce(function(l, c) {
        return l[c] = "", l;
      }, {});
      !Qo(n) || !Qs(n) || (Object.assign(n.style, a), Object.keys(o).forEach(function(l) {
        n.removeAttribute(l);
      }));
    });
  };
}
const Dce = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Tce,
  effect: Bce,
  requires: ["computeStyles"]
};
function Ks(e) {
  return e.split("-")[0];
}
var Dc = Math.max, O1 = Math.min, b0 = Math.round;
function aC() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function BO() {
  return !/^((?!chrome|android).)*safari/i.test(aC());
}
function C0(e, t, i) {
  t === void 0 && (t = !1), i === void 0 && (i = !1);
  var r = e.getBoundingClientRect(), n = 1, o = 1;
  t && Qo(e) && (n = e.offsetWidth > 0 && b0(r.width) / e.offsetWidth || 1, o = e.offsetHeight > 0 && b0(r.height) / e.offsetHeight || 1);
  var s = Pc(e) ? bo(e) : window, a = s.visualViewport, l = !BO() && i, c = (r.left + (l && a ? a.offsetLeft : 0)) / n, u = (r.top + (l && a ? a.offsetTop : 0)) / o, m = r.width / n, g = r.height / o;
  return {
    width: m,
    height: g,
    top: u,
    right: c + m,
    bottom: u + g,
    left: c,
    x: c,
    y: u
  };
}
function Ux(e) {
  var t = C0(e), i = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - i) <= 1 && (i = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: i,
    height: r
  };
}
function DO(e, t) {
  var i = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (i && Yx(i)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function Oa(e) {
  return bo(e).getComputedStyle(e);
}
function Oce(e) {
  return ["table", "td", "th"].indexOf(Qs(e)) >= 0;
}
function Jl(e) {
  return ((Pc(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Ff(e) {
  return Qs(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Yx(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Jl(e)
  );
}
function Xw(e) {
  return !Qo(e) || // https://github.com/popperjs/popper-core/issues/837
  Oa(e).position === "fixed" ? null : e.offsetParent;
}
function Fce(e) {
  var t = /firefox/i.test(aC()), i = /Trident/i.test(aC());
  if (i && Qo(e)) {
    var r = Oa(e);
    if (r.position === "fixed")
      return null;
  }
  var n = Ff(e);
  for (Yx(n) && (n = n.host); Qo(n) && ["html", "body"].indexOf(Qs(n)) < 0; ) {
    var o = Oa(n);
    if (o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || ["transform", "perspective"].indexOf(o.willChange) !== -1 || t && o.willChange === "filter" || t && o.filter && o.filter !== "none")
      return n;
    n = n.parentNode;
  }
  return null;
}
function Og(e) {
  for (var t = bo(e), i = Xw(e); i && Oce(i) && Oa(i).position === "static"; )
    i = Xw(i);
  return i && (Qs(i) === "html" || Qs(i) === "body" && Oa(i).position === "static") ? t : i || Fce(e) || t;
}
function Gx(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Sm(e, t, i) {
  return Dc(e, O1(t, i));
}
function Vce(e, t, i) {
  var r = Sm(e, t, i);
  return r > i ? i : r;
}
function OO() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function FO(e) {
  return Object.assign({}, OO(), e);
}
function VO(e, t) {
  return t.reduce(function(i, r) {
    return i[r] = e, i;
  }, {});
}
var qce = function(t, i) {
  return t = typeof t == "function" ? t(Object.assign({}, i.rects, {
    placement: i.placement
  })) : t, FO(typeof t != "number" ? t : VO(t, Dg));
};
function jce(e) {
  var t, i = e.state, r = e.name, n = e.options, o = i.elements.arrow, s = i.modifiersData.popperOffsets, a = Ks(i.placement), l = Gx(a), c = [Pn, zo].indexOf(a) >= 0, u = c ? "height" : "width";
  if (!(!o || !s)) {
    var m = qce(n.padding, i), g = Ux(o), h = l === "y" ? Jn : Pn, A = l === "y" ? Po : zo, y = i.rects.reference[u] + i.rects.reference[l] - s[l] - i.rects.popper[u], E = s[l] - i.rects.reference[l], v = Og(o), C = v ? l === "y" ? v.clientHeight || 0 : v.clientWidth || 0 : 0, x = y / 2 - E / 2, S = m[h], R = C - g[u] - m[A], w = C / 2 - g[u] / 2 + x, T = Sm(S, w, R), N = l;
    i.modifiersData[r] = (t = {}, t[N] = T, t.centerOffset = T - w, t);
  }
}
function Lce(e) {
  var t = e.state, i = e.options, r = i.element, n = r === void 0 ? "[data-popper-arrow]" : r;
  n != null && (typeof n == "string" && (n = t.elements.popper.querySelector(n), !n) || DO(t.elements.popper, n) && (t.elements.arrow = n));
}
const Kce = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: jce,
  effect: Lce,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function x0(e) {
  return e.split("-")[1];
}
var Yce = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Uce(e, t) {
  var i = e.x, r = e.y, n = t.devicePixelRatio || 1;
  return {
    x: b0(i * n) / n || 0,
    y: b0(r * n) / n || 0
  };
}
function _w(e) {
  var t, i = e.popper, r = e.popperRect, n = e.placement, o = e.variation, s = e.offsets, a = e.position, l = e.gpuAcceleration, c = e.adaptive, u = e.roundOffsets, m = e.isFixed, g = s.x, h = g === void 0 ? 0 : g, A = s.y, y = A === void 0 ? 0 : A, E = typeof u == "function" ? u({
    x: h,
    y
  }) : {
    x: h,
    y
  };
  h = E.x, y = E.y;
  var v = s.hasOwnProperty("x"), C = s.hasOwnProperty("y"), x = Pn, S = Jn, R = window;
  if (c) {
    var w = Og(i), T = "clientHeight", N = "clientWidth";
    if (w === bo(i) && (w = Jl(i), Oa(w).position !== "static" && a === "absolute" && (T = "scrollHeight", N = "scrollWidth")), w = w, n === Jn || (n === Pn || n === zo) && o === _m) {
      S = Po;
      var D = m && w === R && R.visualViewport ? R.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        w[T]
      );
      y -= D - r.height, y *= l ? 1 : -1;
    }
    if (n === Pn || (n === Jn || n === Po) && o === _m) {
      x = zo;
      var O = m && w === R && R.visualViewport ? R.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        w[N]
      );
      h -= O - r.width, h *= l ? 1 : -1;
    }
  }
  var F = Object.assign({
    position: a
  }, c && Yce), Y = u === !0 ? Uce({
    x: h,
    y
  }, bo(i)) : {
    x: h,
    y
  };
  if (h = Y.x, y = Y.y, l) {
    var P;
    return Object.assign({}, F, (P = {}, P[S] = C ? "0" : "", P[x] = v ? "0" : "", P.transform = (R.devicePixelRatio || 1) <= 1 ? "translate(" + h + "px, " + y + "px)" : "translate3d(" + h + "px, " + y + "px, 0)", P));
  }
  return Object.assign({}, F, (t = {}, t[S] = C ? y + "px" : "", t[x] = v ? h + "px" : "", t.transform = "", t));
}
function Gce(e) {
  var t = e.state, i = e.options, r = i.gpuAcceleration, n = r === void 0 ? !0 : r, o = i.adaptive, s = o === void 0 ? !0 : o, a = i.roundOffsets, l = a === void 0 ? !0 : a, c = {
    placement: Ks(t.placement),
    variation: x0(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: n,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, _w(Object.assign({}, c, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: s,
    roundOffsets: l
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, _w(Object.assign({}, c, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const Qce = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Gce,
  data: {}
};
var fp = {
  passive: !0
};
function Wce(e) {
  var t = e.state, i = e.instance, r = e.options, n = r.scroll, o = n === void 0 ? !0 : n, s = r.resize, a = s === void 0 ? !0 : s, l = bo(t.elements.popper), c = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return o && c.forEach(function(u) {
    u.addEventListener("scroll", i.update, fp);
  }), a && l.addEventListener("resize", i.update, fp), function() {
    o && c.forEach(function(u) {
      u.removeEventListener("scroll", i.update, fp);
    }), a && l.removeEventListener("resize", i.update, fp);
  };
}
const Zce = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Wce,
  data: {}
};
var Jce = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Jp(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return Jce[t];
  });
}
var Pce = {
  start: "end",
  end: "start"
};
function $w(e) {
  return e.replace(/start|end/g, function(t) {
    return Pce[t];
  });
}
function Qx(e) {
  var t = bo(e), i = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: i,
    scrollTop: r
  };
}
function Wx(e) {
  return C0(Jl(e)).left + Qx(e).scrollLeft;
}
function zce(e, t) {
  var i = bo(e), r = Jl(e), n = i.visualViewport, o = r.clientWidth, s = r.clientHeight, a = 0, l = 0;
  if (n) {
    o = n.width, s = n.height;
    var c = BO();
    (c || !c && t === "fixed") && (a = n.offsetLeft, l = n.offsetTop);
  }
  return {
    width: o,
    height: s,
    x: a + Wx(e),
    y: l
  };
}
function Hce(e) {
  var t, i = Jl(e), r = Qx(e), n = (t = e.ownerDocument) == null ? void 0 : t.body, o = Dc(i.scrollWidth, i.clientWidth, n ? n.scrollWidth : 0, n ? n.clientWidth : 0), s = Dc(i.scrollHeight, i.clientHeight, n ? n.scrollHeight : 0, n ? n.clientHeight : 0), a = -r.scrollLeft + Wx(e), l = -r.scrollTop;
  return Oa(n || i).direction === "rtl" && (a += Dc(i.clientWidth, n ? n.clientWidth : 0) - o), {
    width: o,
    height: s,
    x: a,
    y: l
  };
}
function Zx(e) {
  var t = Oa(e), i = t.overflow, r = t.overflowX, n = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(i + n + r);
}
function qO(e) {
  return ["html", "body", "#document"].indexOf(Qs(e)) >= 0 ? e.ownerDocument.body : Qo(e) && Zx(e) ? e : qO(Ff(e));
}
function Rm(e, t) {
  var i;
  t === void 0 && (t = []);
  var r = qO(e), n = r === ((i = e.ownerDocument) == null ? void 0 : i.body), o = bo(r), s = n ? [o].concat(o.visualViewport || [], Zx(r) ? r : []) : r, a = t.concat(s);
  return n ? a : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    a.concat(Rm(Ff(s)))
  );
}
function lC(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function Xce(e, t) {
  var i = C0(e, !1, t === "fixed");
  return i.top = i.top + e.clientTop, i.left = i.left + e.clientLeft, i.bottom = i.top + e.clientHeight, i.right = i.left + e.clientWidth, i.width = e.clientWidth, i.height = e.clientHeight, i.x = i.left, i.y = i.top, i;
}
function e6(e, t, i) {
  return t === NO ? lC(zce(e, i)) : Pc(t) ? Xce(t, i) : lC(Hce(Jl(e)));
}
function _ce(e) {
  var t = Rm(Ff(e)), i = ["absolute", "fixed"].indexOf(Oa(e).position) >= 0, r = i && Qo(e) ? Og(e) : e;
  return Pc(r) ? t.filter(function(n) {
    return Pc(n) && DO(n, r) && Qs(n) !== "body";
  }) : [];
}
function $ce(e, t, i, r) {
  var n = t === "clippingParents" ? _ce(e) : [].concat(t), o = [].concat(n, [i]), s = o[0], a = o.reduce(function(l, c) {
    var u = e6(e, c, r);
    return l.top = Dc(u.top, l.top), l.right = O1(u.right, l.right), l.bottom = O1(u.bottom, l.bottom), l.left = Dc(u.left, l.left), l;
  }, e6(e, s, r));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}
function jO(e) {
  var t = e.reference, i = e.element, r = e.placement, n = r ? Ks(r) : null, o = r ? x0(r) : null, s = t.x + t.width / 2 - i.width / 2, a = t.y + t.height / 2 - i.height / 2, l;
  switch (n) {
    case Jn:
      l = {
        x: s,
        y: t.y - i.height
      };
      break;
    case Po:
      l = {
        x: s,
        y: t.y + t.height
      };
      break;
    case zo:
      l = {
        x: t.x + t.width,
        y: a
      };
      break;
    case Pn:
      l = {
        x: t.x - i.width,
        y: a
      };
      break;
    default:
      l = {
        x: t.x,
        y: t.y
      };
  }
  var c = n ? Gx(n) : null;
  if (c != null) {
    var u = c === "y" ? "height" : "width";
    switch (o) {
      case v0:
        l[c] = l[c] - (t[u] / 2 - i[u] / 2);
        break;
      case _m:
        l[c] = l[c] + (t[u] / 2 - i[u] / 2);
        break;
    }
  }
  return l;
}
function $m(e, t) {
  t === void 0 && (t = {});
  var i = t, r = i.placement, n = r === void 0 ? e.placement : r, o = i.strategy, s = o === void 0 ? e.strategy : o, a = i.boundary, l = a === void 0 ? Ece : a, c = i.rootBoundary, u = c === void 0 ? NO : c, m = i.elementContext, g = m === void 0 ? qd : m, h = i.altBoundary, A = h === void 0 ? !1 : h, y = i.padding, E = y === void 0 ? 0 : y, v = FO(typeof E != "number" ? E : VO(E, Dg)), C = g === qd ? vce : qd, x = e.rects.popper, S = e.elements[A ? C : g], R = $ce(Pc(S) ? S : S.contextElement || Jl(e.elements.popper), l, u, s), w = C0(e.elements.reference), T = jO({
    reference: w,
    element: x,
    strategy: "absolute",
    placement: n
  }), N = lC(Object.assign({}, x, T)), D = g === qd ? N : w, O = {
    top: R.top - D.top + v.top,
    bottom: D.bottom - R.bottom + v.bottom,
    left: R.left - D.left + v.left,
    right: D.right - R.right + v.right
  }, F = e.modifiersData.offset;
  if (g === qd && F) {
    var Y = F[n];
    Object.keys(O).forEach(function(P) {
      var z = [zo, Po].indexOf(P) >= 0 ? 1 : -1, W = [Jn, Po].indexOf(P) >= 0 ? "y" : "x";
      O[P] += Y[W] * z;
    });
  }
  return O;
}
function eue(e, t) {
  t === void 0 && (t = {});
  var i = t, r = i.placement, n = i.boundary, o = i.rootBoundary, s = i.padding, a = i.flipVariations, l = i.allowedAutoPlacements, c = l === void 0 ? TO : l, u = x0(r), m = u ? a ? Hw : Hw.filter(function(A) {
    return x0(A) === u;
  }) : Dg, g = m.filter(function(A) {
    return c.indexOf(A) >= 0;
  });
  g.length === 0 && (g = m);
  var h = g.reduce(function(A, y) {
    return A[y] = $m(e, {
      placement: y,
      boundary: n,
      rootBoundary: o,
      padding: s
    })[Ks(y)], A;
  }, {});
  return Object.keys(h).sort(function(A, y) {
    return h[A] - h[y];
  });
}
function tue(e) {
  if (Ks(e) === Kx)
    return [];
  var t = Jp(e);
  return [$w(e), t, $w(t)];
}
function iue(e) {
  var t = e.state, i = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var n = i.mainAxis, o = n === void 0 ? !0 : n, s = i.altAxis, a = s === void 0 ? !0 : s, l = i.fallbackPlacements, c = i.padding, u = i.boundary, m = i.rootBoundary, g = i.altBoundary, h = i.flipVariations, A = h === void 0 ? !0 : h, y = i.allowedAutoPlacements, E = t.options.placement, v = Ks(E), C = v === E, x = l || (C || !A ? [Jp(E)] : tue(E)), S = [E].concat(x).reduce(function(de, fe) {
      return de.concat(Ks(fe) === Kx ? eue(t, {
        placement: fe,
        boundary: u,
        rootBoundary: m,
        padding: c,
        flipVariations: A,
        allowedAutoPlacements: y
      }) : fe);
    }, []), R = t.rects.reference, w = t.rects.popper, T = /* @__PURE__ */ new Map(), N = !0, D = S[0], O = 0; O < S.length; O++) {
      var F = S[O], Y = Ks(F), P = x0(F) === v0, z = [Jn, Po].indexOf(Y) >= 0, W = z ? "width" : "height", H = $m(t, {
        placement: F,
        boundary: u,
        rootBoundary: m,
        altBoundary: g,
        padding: c
      }), Q = z ? P ? zo : Pn : P ? Po : Jn;
      R[W] > w[W] && (Q = Jp(Q));
      var $ = Jp(Q), le = [];
      if (o && le.push(H[Y] <= 0), a && le.push(H[Q] <= 0, H[$] <= 0), le.every(function(de) {
        return de;
      })) {
        D = F, N = !1;
        break;
      }
      T.set(F, le);
    }
    if (N)
      for (var he = A ? 3 : 1, oe = function(fe) {
        var Re = S.find(function(qe) {
          var Oe = T.get(qe);
          if (Oe)
            return Oe.slice(0, fe).every(function(Xe) {
              return Xe;
            });
        });
        if (Re)
          return D = Re, "break";
      }, ue = he; ue > 0; ue--) {
        var Ae = oe(ue);
        if (Ae === "break")
          break;
      }
    t.placement !== D && (t.modifiersData[r]._skip = !0, t.placement = D, t.reset = !0);
  }
}
const rue = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: iue,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function t6(e, t, i) {
  return i === void 0 && (i = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - i.y,
    right: e.right - t.width + i.x,
    bottom: e.bottom - t.height + i.y,
    left: e.left - t.width - i.x
  };
}
function i6(e) {
  return [Jn, zo, Po, Pn].some(function(t) {
    return e[t] >= 0;
  });
}
function nue(e) {
  var t = e.state, i = e.name, r = t.rects.reference, n = t.rects.popper, o = t.modifiersData.preventOverflow, s = $m(t, {
    elementContext: "reference"
  }), a = $m(t, {
    altBoundary: !0
  }), l = t6(s, r), c = t6(a, n, o), u = i6(l), m = i6(c);
  t.modifiersData[i] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: c,
    isReferenceHidden: u,
    hasPopperEscaped: m
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": m
  });
}
const oue = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: nue
};
function sue(e, t, i) {
  var r = Ks(e), n = [Pn, Jn].indexOf(r) >= 0 ? -1 : 1, o = typeof i == "function" ? i(Object.assign({}, t, {
    placement: e
  })) : i, s = o[0], a = o[1];
  return s = s || 0, a = (a || 0) * n, [Pn, zo].indexOf(r) >= 0 ? {
    x: a,
    y: s
  } : {
    x: s,
    y: a
  };
}
function aue(e) {
  var t = e.state, i = e.options, r = e.name, n = i.offset, o = n === void 0 ? [0, 0] : n, s = TO.reduce(function(u, m) {
    return u[m] = sue(m, t.rects, o), u;
  }, {}), a = s[t.placement], l = a.x, c = a.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += c), t.modifiersData[r] = s;
}
const lue = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: aue
};
function cue(e) {
  var t = e.state, i = e.name;
  t.modifiersData[i] = jO({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const uue = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: cue,
  data: {}
};
function due(e) {
  return e === "x" ? "y" : "x";
}
function mue(e) {
  var t = e.state, i = e.options, r = e.name, n = i.mainAxis, o = n === void 0 ? !0 : n, s = i.altAxis, a = s === void 0 ? !1 : s, l = i.boundary, c = i.rootBoundary, u = i.altBoundary, m = i.padding, g = i.tether, h = g === void 0 ? !0 : g, A = i.tetherOffset, y = A === void 0 ? 0 : A, E = $m(t, {
    boundary: l,
    rootBoundary: c,
    padding: m,
    altBoundary: u
  }), v = Ks(t.placement), C = x0(t.placement), x = !C, S = Gx(v), R = due(S), w = t.modifiersData.popperOffsets, T = t.rects.reference, N = t.rects.popper, D = typeof y == "function" ? y(Object.assign({}, t.rects, {
    placement: t.placement
  })) : y, O = typeof D == "number" ? {
    mainAxis: D,
    altAxis: D
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, D), F = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, Y = {
    x: 0,
    y: 0
  };
  if (w) {
    if (o) {
      var P, z = S === "y" ? Jn : Pn, W = S === "y" ? Po : zo, H = S === "y" ? "height" : "width", Q = w[S], $ = Q + E[z], le = Q - E[W], he = h ? -N[H] / 2 : 0, oe = C === v0 ? T[H] : N[H], ue = C === v0 ? -N[H] : -T[H], Ae = t.elements.arrow, de = h && Ae ? Ux(Ae) : {
        width: 0,
        height: 0
      }, fe = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : OO(), Re = fe[z], qe = fe[W], Oe = Sm(0, T[H], de[H]), Xe = x ? T[H] / 2 - he - Oe - Re - O.mainAxis : oe - Oe - Re - O.mainAxis, Qe = x ? -T[H] / 2 + he + Oe + qe + O.mainAxis : ue + Oe + qe + O.mainAxis, Pe = t.elements.arrow && Og(t.elements.arrow), et = Pe ? S === "y" ? Pe.clientTop || 0 : Pe.clientLeft || 0 : 0, At = (P = F == null ? void 0 : F[S]) != null ? P : 0, Et = Q + Xe - At - et, oi = Q + Qe - At, Ai = Sm(h ? O1($, Et) : $, Q, h ? Dc(le, oi) : le);
      w[S] = Ai, Y[S] = Ai - Q;
    }
    if (a) {
      var ut, qt = S === "x" ? Jn : Pn, Ht = S === "x" ? Po : zo, ri = w[R], Ke = R === "y" ? "height" : "width", dt = ri + E[qt], kt = ri - E[Ht], si = [Jn, Pn].indexOf(v) !== -1, Dt = (ut = F == null ? void 0 : F[R]) != null ? ut : 0, yi = si ? dt : ri - T[Ke] - N[Ke] - Dt + O.altAxis, ei = si ? ri + T[Ke] + N[Ke] - Dt - O.altAxis : kt, nr = h && si ? Vce(yi, ri, ei) : Sm(h ? yi : dt, ri, h ? ei : kt);
      w[R] = nr, Y[R] = nr - ri;
    }
    t.modifiersData[r] = Y;
  }
}
const gue = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: mue,
  requiresIfExists: ["offset"]
};
function hue(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function pue(e) {
  return e === bo(e) || !Qo(e) ? Qx(e) : hue(e);
}
function fue(e) {
  var t = e.getBoundingClientRect(), i = b0(t.width) / e.offsetWidth || 1, r = b0(t.height) / e.offsetHeight || 1;
  return i !== 1 || r !== 1;
}
function Aue(e, t, i) {
  i === void 0 && (i = !1);
  var r = Qo(t), n = Qo(t) && fue(t), o = Jl(t), s = C0(e, n, i), a = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (r || !r && !i) && ((Qs(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Zx(o)) && (a = pue(t)), Qo(t) ? (l = C0(t, !0), l.x += t.clientLeft, l.y += t.clientTop) : o && (l.x = Wx(o))), {
    x: s.left + a.scrollLeft - l.x,
    y: s.top + a.scrollTop - l.y,
    width: s.width,
    height: s.height
  };
}
function yue(e) {
  var t = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(o) {
    t.set(o.name, o);
  });
  function n(o) {
    i.add(o.name);
    var s = [].concat(o.requires || [], o.requiresIfExists || []);
    s.forEach(function(a) {
      if (!i.has(a)) {
        var l = t.get(a);
        l && n(l);
      }
    }), r.push(o);
  }
  return e.forEach(function(o) {
    i.has(o.name) || n(o);
  }), r;
}
function Eue(e) {
  var t = yue(e);
  return Nce.reduce(function(i, r) {
    return i.concat(t.filter(function(n) {
      return n.phase === r;
    }));
  }, []);
}
function vue(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(i) {
      Promise.resolve().then(function() {
        t = void 0, i(e());
      });
    })), t;
  };
}
function bue(e) {
  var t = e.reduce(function(i, r) {
    var n = i[r.name];
    return i[r.name] = n ? Object.assign({}, n, r, {
      options: Object.assign({}, n.options, r.options),
      data: Object.assign({}, n.data, r.data)
    }) : r, i;
  }, {});
  return Object.keys(t).map(function(i) {
    return t[i];
  });
}
var r6 = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function n6() {
  for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++)
    t[i] = arguments[i];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function Cue(e) {
  e === void 0 && (e = {});
  var t = e, i = t.defaultModifiers, r = i === void 0 ? [] : i, n = t.defaultOptions, o = n === void 0 ? r6 : n;
  return function(a, l, c) {
    c === void 0 && (c = o);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, r6, o),
      modifiersData: {},
      elements: {
        reference: a,
        popper: l
      },
      attributes: {},
      styles: {}
    }, m = [], g = !1, h = {
      state: u,
      setOptions: function(v) {
        var C = typeof v == "function" ? v(u.options) : v;
        y(), u.options = Object.assign({}, o, u.options, C), u.scrollParents = {
          reference: Pc(a) ? Rm(a) : a.contextElement ? Rm(a.contextElement) : [],
          popper: Rm(l)
        };
        var x = Eue(bue([].concat(r, u.options.modifiers)));
        return u.orderedModifiers = x.filter(function(S) {
          return S.enabled;
        }), A(), h.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!g) {
          var v = u.elements, C = v.reference, x = v.popper;
          if (n6(C, x)) {
            u.rects = {
              reference: Aue(C, Og(x), u.options.strategy === "fixed"),
              popper: Ux(x)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(O) {
              return u.modifiersData[O.name] = Object.assign({}, O.data);
            });
            for (var S = 0; S < u.orderedModifiers.length; S++) {
              if (u.reset === !0) {
                u.reset = !1, S = -1;
                continue;
              }
              var R = u.orderedModifiers[S], w = R.fn, T = R.options, N = T === void 0 ? {} : T, D = R.name;
              typeof w == "function" && (u = w({
                state: u,
                options: N,
                name: D,
                instance: h
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: vue(function() {
        return new Promise(function(E) {
          h.forceUpdate(), E(u);
        });
      }),
      destroy: function() {
        y(), g = !0;
      }
    };
    if (!n6(a, l))
      return h;
    h.setOptions(c).then(function(E) {
      !g && c.onFirstUpdate && c.onFirstUpdate(E);
    });
    function A() {
      u.orderedModifiers.forEach(function(E) {
        var v = E.name, C = E.options, x = C === void 0 ? {} : C, S = E.effect;
        if (typeof S == "function") {
          var R = S({
            state: u,
            name: v,
            instance: h,
            options: x
          }), w = function() {
          };
          m.push(R || w);
        }
      });
    }
    function y() {
      m.forEach(function(E) {
        return E();
      }), m = [];
    }
    return h;
  };
}
var xue = [Zce, uue, Qce, Dce, lue, rue, gue, Kce, oue], Iue = /* @__PURE__ */ Cue({
  defaultModifiers: xue
}), Sue = typeof Element != "undefined", Rue = typeof Map == "function", kue = typeof Set == "function", wue = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function Pp(e, t) {
  if (e === t)
    return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor)
      return !1;
    var i, r, n;
    if (Array.isArray(e)) {
      if (i = e.length, i != t.length)
        return !1;
      for (r = i; r-- !== 0; )
        if (!Pp(e[r], t[r]))
          return !1;
      return !0;
    }
    var o;
    if (Rue && e instanceof Map && t instanceof Map) {
      if (e.size !== t.size)
        return !1;
      for (o = e.entries(); !(r = o.next()).done; )
        if (!t.has(r.value[0]))
          return !1;
      for (o = e.entries(); !(r = o.next()).done; )
        if (!Pp(r.value[1], t.get(r.value[0])))
          return !1;
      return !0;
    }
    if (kue && e instanceof Set && t instanceof Set) {
      if (e.size !== t.size)
        return !1;
      for (o = e.entries(); !(r = o.next()).done; )
        if (!t.has(r.value[0]))
          return !1;
      return !0;
    }
    if (wue && ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      if (i = e.length, i != t.length)
        return !1;
      for (r = i; r-- !== 0; )
        if (e[r] !== t[r])
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf && typeof e.valueOf == "function" && typeof t.valueOf == "function")
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString && typeof e.toString == "function" && typeof t.toString == "function")
      return e.toString() === t.toString();
    if (n = Object.keys(e), i = n.length, i !== Object.keys(t).length)
      return !1;
    for (r = i; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, n[r]))
        return !1;
    if (Sue && e instanceof Element)
      return !1;
    for (r = i; r-- !== 0; )
      if (!((n[r] === "_owner" || n[r] === "__v" || n[r] === "__o") && e.$$typeof) && !Pp(e[n[r]], t[n[r]]))
        return !1;
    return !0;
  }
  return e !== e && t !== t;
}
var Jx = function(t, i) {
  try {
    return Pp(t, i);
  } catch (r) {
    if ((r.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw r;
  }
};
const Mue = /* @__PURE__ */ Ho(Jx);
var Nue = [], Tue = function(t, i, r) {
  r === void 0 && (r = {});
  var n = ft.useRef(null), o = {
    onFirstUpdate: r.onFirstUpdate,
    placement: r.placement || "bottom",
    strategy: r.strategy || "absolute",
    modifiers: r.modifiers || Nue
  }, s = ft.useState({
    styles: {
      popper: {
        position: o.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), a = s[0], l = s[1], c = ft.useMemo(function() {
    return {
      name: "updateState",
      enabled: !0,
      phase: "write",
      fn: function(h) {
        var A = h.state, y = Object.keys(A.elements);
        mg.flushSync(function() {
          l({
            styles: Pw(y.map(function(E) {
              return [E, A.styles[E] || {}];
            })),
            attributes: Pw(y.map(function(E) {
              return [E, A.attributes[E]];
            }))
          });
        });
      },
      requires: ["computeStyles"]
    };
  }, []), u = ft.useMemo(function() {
    var g = {
      onFirstUpdate: o.onFirstUpdate,
      placement: o.placement,
      strategy: o.strategy,
      modifiers: [].concat(o.modifiers, [c, {
        name: "applyStyles",
        enabled: !1
      }])
    };
    return Mue(n.current, g) ? n.current || g : (n.current = g, g);
  }, [o.onFirstUpdate, o.placement, o.strategy, o.modifiers, c]), m = ft.useRef();
  return zw(function() {
    m.current && m.current.setOptions(u);
  }, [u]), zw(function() {
    if (!(t == null || i == null)) {
      var g = r.createPopper || Iue, h = g(t, i, u);
      return m.current = h, function() {
        h.destroy(), m.current = null;
      };
    }
  }, [t, i, r.createPopper]), {
    state: m.current ? m.current.state : null,
    styles: a.styles,
    attributes: a.attributes,
    update: m.current ? m.current.update : null,
    forceUpdate: m.current ? m.current.forceUpdate : null
  };
};
const Bue = "_tooltip_1qh4a_1", Due = {
  tooltip: Bue
};
function Fg({
  referenceElement: e,
  options: t,
  className: i,
  style: r,
  visible: n = !1,
  watchForUpdate: o,
  children: s
}) {
  const [a, l] = se(), { styles: c, attributes: u, update: m } = Tue(e, a, t);
  return be(() => {
    m && m();
  }, [n, o]), typeof document != "undefined" && n ? ps(
    /* @__PURE__ */ f(
      "div",
      ee(q({
        className: me(Due.tooltip, i),
        ref: l,
        style: q(q({}, c.popper), r)
      }, u.popper), {
        children: s
      })
    ),
    document.querySelector("body")
  ) : null;
}
const Oue = {
  assetPath: "https://assets-ng.maxroll.gg",
  apiUrl: "https://backend-staging.maxroll.net",
  plannersApiPath: "https://planners.maxroll.gg",
  meilisearchPath: "https://meilisearch-proxy.maxroll.gg",
  frontendPath: "https://maxroll.gg"
};
function fi() {
  return Oue;
}
const Fue = "_icon_oogph_1", Vue = {
  icon: Fue
};
function Mt(a) {
  var l = a, { icon: e, width: t, height: i, color: r, className: n, style: o } = l, s = Fe(l, ["icon", "width", "height", "color", "className", "style"]);
  const { assetPath: c } = fi();
  return /* @__PURE__ */ f(
    "span",
    q({
      style: q({
        maskImage: `url(${c}/images/${e}?scope=mask)`,
        WebkitMaskImage: `url(${c}/images/${e}?scope=mask)`,
        width: t,
        height: i,
        backgroundColor: r
      }, o),
      className: me(Vue.icon, n)
    }, s)
  );
}
const que = "_ScrollBox_zbxir_1", jue = "_ScrollBox__inner_zbxir_5", Ap = {
  ScrollBox: que,
  ScrollBox__inner: jue,
  "ScrollBox--vertical": "_ScrollBox--vertical_zbxir_28",
  "ScrollBox__inner--vertical": "_ScrollBox__inner--vertical_zbxir_32",
  "ScrollBox--horizontal": "_ScrollBox--horizontal_zbxir_45",
  "ScrollBox__inner--horizontal": "_ScrollBox__inner--horizontal_zbxir_49"
}, Lue = (l, a) => {
  var c = l, { type: e = "vertical", className: t, innerClassName: i, innerStyle: r, children: n, onScroll: o } = c, s = Fe(c, ["type", "className", "innerClassName", "innerStyle", "children", "onScroll"]);
  return /* @__PURE__ */ f("div", ee(q({ className: me(Ap.ScrollBox, Ap[`ScrollBox--${e}`], t) }, s), { children: /* @__PURE__ */ f(
    "div",
    {
      className: me(Ap.ScrollBox__inner, Ap[`ScrollBox__inner--${e}`], i),
      style: r,
      ref: a,
      onScroll: o,
      children: n
    }
  ) }));
}, Pr = T0(Lue), Kue = "_wrapper_gu7k1_1", Yue = "_select_gu7k1_4", Uue = "_searchInput_gu7k1_18", Gue = "_valueWrapper_gu7k1_33", Que = "_value_gu7k1_33", Wue = "_buttonWrapper_gu7k1_59", Zue = "_button_gu7k1_59", Jue = "_chevron_gu7k1_78", Pue = "_testEnabled_gu7k1_87", zue = "_testDisabled_gu7k1_90", Hue = "_open_gu7k1_93", Xue = "_optionsWrapper_gu7k1_113", _ue = "_scrollBox_gu7k1_117", $ue = "_options_gu7k1_113", e0e = "_noOptions_gu7k1_130", t0e = "_option_gu7k1_113", i0e = "_optionContent_gu7k1_146", r0e = "_optionText_gu7k1_151", n0e = "_optionCheckbox_gu7k1_160", o0e = "_activeOption_gu7k1_167", s0e = "_selectedOption_gu7k1_179", a0e = "_md_gu7k1_222", cr = {
  wrapper: Kue,
  select: Yue,
  searchInput: Uue,
  valueWrapper: Gue,
  value: Que,
  buttonWrapper: Wue,
  button: Zue,
  chevron: Jue,
  testEnabled: Pue,
  testDisabled: zue,
  open: Hue,
  optionsWrapper: Xue,
  scrollBox: _ue,
  options: $ue,
  noOptions: e0e,
  option: t0e,
  optionContent: i0e,
  optionText: r0e,
  optionCheckbox: n0e,
  activeOption: o0e,
  selectedOption: s0e,
  "sm-md": "_sm-md_gu7k1_198",
  md: a0e
};
function Oc(e, t) {
  if (e !== void 0) {
    if (t && Array.isArray(e))
      return e;
    if (!t && !Array.isArray(e))
      return e;
  }
  return t ? [] : void 0;
}
function I0(e, t, i) {
  return i ? !e || !Array.isArray(e) ? void 0 : t.filter((r) => e.includes(r.value)) : t.find((r) => r.value === e);
}
const l0e = "_clear_301fu_1", c0e = "_icon_301fu_8", u0e = "_count_301fu_12", TE = {
  clear: l0e,
  icon: c0e,
  count: u0e
}, d0e = ({
  className: e,
  isMulti: t,
  count: i = 0,
  onClick: r
}) => /* @__PURE__ */ V("span", { className: TE.clear, onClick: r, children: [
  /* @__PURE__ */ f(Mt, { className: TE.icon, icon: "clear.svg", width: 10, height: 10 }),
  t && /* @__PURE__ */ f("span", { className: TE.count, children: i })
] });
function m0e({
  open: e,
  selectRef: t,
  query: i,
  filteredOptions: r,
  isMulti: n
}) {
  return /* @__PURE__ */ f(
    Fg,
    {
      referenceElement: t,
      visible: e,
      options: {
        placement: "bottom-start",
        modifiers: [
          { name: "offset", options: { offset: [0, 4] } },
          { name: "flip", options: { fallbackPlacements: ["top"] } },
          { name: "preventOverflow" }
        ]
      },
      children: /* @__PURE__ */ f(Xm.Options, { style: { width: t == null ? void 0 : t.offsetWidth }, className: cr.optionsWrapper, children: /* @__PURE__ */ f(Pr, { className: cr.scrollBox, innerClassName: cr.options, children: r.length === 0 && i !== "" ? /* @__PURE__ */ f("div", { className: cr.noOptions, children: "No options found" }) : r.map((o) => /* @__PURE__ */ f(
        Xm.Option,
        {
          className: ({ selected: s, active: a }) => me(cr.option, a && cr.activeOption, s && cr.selectedOption),
          value: o.value,
          children: ({ selected: s }) => /* @__PURE__ */ V(gt, { children: [
            /* @__PURE__ */ V("span", { className: cr.optionContent, children: [
              o.icon ? o.icon : null,
              /* @__PURE__ */ f("span", { className: me(cr.optionText), children: o.renderCallback ? o.renderCallback({ selected: s }) : o.label })
            ] }),
            n && /* @__PURE__ */ f("span", { className: cr.optionCheckbox, children: /* @__PURE__ */ f(Ka, { value: s, type: "sm", "aria-hidden": "true" }) })
          ] })
        },
        o.value || "none"
      )) }) })
    }
  );
}
function g0e({
  open: e,
  isSearchable: t = !1,
  isClearable: i = !1,
  options: r,
  selectedValue: n,
  required: o = !1,
  isMulti: s = !1,
  placeholder: a,
  isDisabled: l,
  size: c = "md",
  className: u,
  multiSelectionPreview: m = (E) => `${E.length} option${E.length > 1 ? "s" : ""} selected`,
  popperWrapper: g = (E) => E,
  updateSelectedValue: h,
  query: A,
  setQuery: y
}) {
  const E = we(() => A === "" ? r : r.filter((R) => R.label.toLowerCase().includes(A.toLowerCase())), [r, A]), v = we(() => I0(n, r, s), [n, r, s]), [C, x] = se(null), S = we(() => Array.isArray(v) && v.length > 0 ? m(v) : !Array.isArray(v) && (v == null ? void 0 : v.label) !== void 0 ? v.label : a, [m, a, v]);
  return be(() => {
    !e && !s && n !== void 0 && y("");
  }, [s, e, n, y]), /* @__PURE__ */ V("div", { className: me(cr.wrapper, cr[c], u), children: [
    /* @__PURE__ */ V("div", { ref: x, className: cr.select, children: [
      t ? /* @__PURE__ */ f(
        Xm.Input,
        {
          className: cr.searchInput,
          displayValue: () => A,
          placeholder: S,
          required: o,
          onChange: (R) => {
            t && y(R.target.value);
          }
        }
      ) : /* @__PURE__ */ f("span", { className: cr.valueWrapper, children: /* @__PURE__ */ f("span", { className: cr.value, children: !Array.isArray(v) && (v == null ? void 0 : v.label) || a || "" }) }),
      /* @__PURE__ */ f(Xm.Button, { className: cr.buttonWrapper, children: /* @__PURE__ */ V("span", { className: cr.button, children: [
        i && n != null && !(Array.isArray(n) && n.length == 0) && /* @__PURE__ */ f(
          d0e,
          {
            onClick: (R) => {
              R.preventDefault(), R.stopPropagation(), h(s ? [] : void 0);
            },
            isMulti: s,
            count: Array.isArray(v) ? v.length : 0
          }
        ),
        /* @__PURE__ */ f("span", { className: cr.chevron, children: /* @__PURE__ */ f(
          Mt,
          {
            icon: "chevron-right.svg",
            className: l ? cr.testDisabled : cr.testEnabled,
            width: 20,
            height: 20
          }
        ) })
      ] }) })
    ] }),
    g(
      /* @__PURE__ */ f(
        m0e,
        {
          open: e,
          selectRef: C,
          query: A,
          filteredOptions: E,
          isMulti: s
        }
      )
    )
  ] });
}
function LO({
  value: e,
  options: t,
  isClearable: i = !1,
  isSearchable: r = !1,
  onChange: n,
  required: o = !1,
  placeholder: s = "Select",
  isMulti: a = !1,
  isDisabled: l = !1,
  size: c = "md",
  className: u,
  multiSelectionPreview: m = (h) => `${h.length} option${h.length > 1 ? "s" : ""} selected`,
  popperWrapper: g = (h) => h
}) {
  const [h, A] = se(""), [y, E] = se(Oc(e, a));
  be(() => {
    E(Oc(e, a)), a === !1 && e !== void 0 && A("");
  }, [e, a]);
  const v = ye(
    (C) => {
      const x = Oc(C, a);
      E(x), a === !1 && A(""), n && n(I0(x, t, a));
    },
    [t, a, n, A]
  );
  return /* @__PURE__ */ f(
    Xm,
    ee(q({
      value: y || "",
      onChange: (C) => {
        v(C === null ? a ? [] : void 0 : C);
      }
    }, q(q({}, Hk(i, "nullable", !0)), Hk(a, "multiple", !0))), {
      children: ({ open: C }) => /* @__PURE__ */ f(
        g0e,
        {
          open: C,
          isSearchable: r,
          isClearable: i,
          options: t,
          selectedValue: y,
          required: o,
          isMulti: a,
          placeholder: s,
          isDisabled: l,
          size: c,
          className: u,
          multiSelectionPreview: m,
          popperWrapper: g,
          query: h,
          updateSelectedValue: v,
          setQuery: A
        }
      )
    })
  );
}
function _s(i) {
  var r = i, { onChange: e } = r, t = Fe(r, ["onChange"]);
  return /* @__PURE__ */ f(
    LO,
    q({
      isMulti: !1,
      onChange: (n) => {
        e && e(n);
      }
    }, t)
  );
}
function nBe(i) {
  var r = i, { onChange: e } = r, t = Fe(r, ["onChange"]);
  return /* @__PURE__ */ f(
    LO,
    q({
      isMulti: !0,
      onChange: (n) => {
        e && e(n);
      }
    }, t)
  );
}
const KO = Co(null);
function oBe({
  children: e,
  value: t
}) {
  return /* @__PURE__ */ f(KO.Provider, { value: t, children: e });
}
function Ui() {
  return sn(KO);
}
function sBe(i) {
  var r = i, {
    entity: e
  } = r, t = Fe(r, [
    "entity"
  ]);
  const { layoutComponents: n } = Ui(), o = n.card(e);
  return o ? Ei(o, q({ entity: e }, t)) : null;
}
const h0e = "_inline_cydjq_1", p0e = "_icon_cydjq_6", f0e = "_noText_cydjq_11", BE = {
  inline: h0e,
  icon: p0e,
  noText: f0e
};
function A0e(g, m) {
  var h = g, {
    icon: e,
    iconSize: t = 20,
    iconSpacing: i = 4,
    iconStyle: r,
    entity: n,
    displayIcon: o = !0,
    displayText: s = !0,
    className: a,
    style: l,
    children: c
  } = h, u = Fe(h, [
    "icon",
    "iconSize",
    "iconSpacing",
    "iconStyle",
    "entity",
    "displayIcon",
    "displayText",
    "className",
    "style",
    "children"
  ]);
  const A = Ui();
  let y = e;
  !y && (n != null && n._icon) && (y = A != null && A.iconsPath ? `${A.iconsPath}/${n._icon}` : n._icon);
  const E = s ? c || (n == null ? void 0 : n._display) : null, v = !!E;
  return /* @__PURE__ */ V(
    "span",
    ee(q({
      ref: m,
      style: q({ gap: i }, l),
      className: me(BE.inline, !v && BE.noText, a)
    }, u), {
      children: [
        o && y && n && /* @__PURE__ */ f(
          "img",
          {
            className: BE.icon,
            width: t,
            height: t,
            style: r,
            src: y
          },
          `${n._identity}-icon`
        ),
        v ? /* @__PURE__ */ f("span", { children: E }) : null
      ]
    })
  );
}
const aBe = X.forwardRef(A0e);
function y0e(i) {
  var r = i, {
    entity: e
  } = r, t = Fe(r, [
    "entity"
  ]);
  const { layoutComponents: n } = Ui(), o = n.page(e);
  return o ? Ei(o, q({ entity: e }, t)) : null;
}
function lBe(i) {
  var r = i, {
    entities: e
  } = r, t = Fe(r, [
    "entities"
  ]);
  const { layoutComponents: n } = Ui();
  if (e.length === 0)
    return;
  const o = e[0], s = n.table(o);
  return s ? Ei(s, q({ entities: e }, t)) : void 0;
}
function cBe({ entity: e }) {
  const { layoutComponents: t } = Ui(), i = t.tooltip(e);
  return i ? Ei(i, { entity: e }) : null;
}
const E0e = "_card_1onn2_1", v0e = "_interactable_1onn2_14", cC = {
  card: E0e,
  interactable: v0e
};
function uBe(o) {
  var s = o, {
    entity: e,
    customIcon: t,
    children: i,
    onClick: r
  } = s, n = Fe(s, [
    "entity",
    "customIcon",
    "children",
    "onClick"
  ]);
  const a = t || (e == null ? void 0 : e._icon);
  return /* @__PURE__ */ f("div", ee(q({ className: me(cC.card, r && cC.interactable), onClick: r }, n), { children: /* @__PURE__ */ V("span", { children: [
    a && /* @__PURE__ */ f("img", { width: 48, height: 48, src: a }),
    /* @__PURE__ */ f("span", { children: i || (e == null ? void 0 : e._display) || "" })
  ] }) }));
}
const dBe = cC, b0e = "_page_tmugh_1", C0e = "_pageContent_tmugh_7", x0e = "_titleBoxWrapper_tmugh_13", I0e = "_title_tmugh_13", S0e = "_titleButton_tmugh_19", R0e = "_section_tmugh_32", k0e = "_split_tmugh_41", w0e = "_cardContainer_tmugh_50", Ju = {
  page: b0e,
  pageContent: C0e,
  titleBoxWrapper: x0e,
  title: I0e,
  titleButton: S0e,
  section: R0e,
  split: k0e,
  cardContainer: w0e
};
function mBe(a) {
  var l = a, {
    entity: e,
    subtitle: t,
    titleExtra: i,
    image: r,
    children: n,
    className: o
  } = l, s = Fe(l, [
    "entity",
    "subtitle",
    "titleExtra",
    "image",
    "children",
    "className"
  ]);
  return /* @__PURE__ */ V("div", ee(q({ className: me(Ju.page, o) }, s), { children: [
    /* @__PURE__ */ V("div", { className: Ju.titleBoxWrapper, children: [
      /* @__PURE__ */ f(
        mIe,
        {
          className: Ju.title,
          title: e._display,
          headingLevel: 2,
          subTitle: t,
          titleStart: /* @__PURE__ */ f(
            Kt,
            {
              size: "sm",
              className: Ju.titleButton,
              iconProps: {
                icon: "chevron-right.svg",
                style: { rotate: "180deg", marginLeft: "-4px" },
                width: 16,
                height: 16
              },
              onClick: () => {
                window.history.back();
              },
              children: "Back"
            }
          ),
          titleEnd: i
        }
      ),
      r
    ] }),
    /* @__PURE__ */ f("div", { className: Ju.pageContent, children: n })
  ] }));
}
const gBe = Ju, M0e = "_pagination_17efa_1", N0e = "_navDisabled_17efa_17", DE = {
  pagination: M0e,
  navDisabled: N0e
}, T0e = (e) => {
  const { page: t, maxPage: i, nextPage: r, prevPage: n, itemsPerPage: o, setItemsPerPage: s } = e, a = () => {
    t < i && r();
  }, l = () => {
    t > 1 && n();
  };
  return /* @__PURE__ */ V("div", { className: me(DE.pagination), children: [
    /* @__PURE__ */ f("span", { className: me(t <= 1 && DE.navDisabled), onClick: l, children: "Prev" }),
    `${t}/${i}`,
    /* @__PURE__ */ f("span", { className: me(t >= i && DE.navDisabled), onClick: a, children: "Next" }),
    s && /* @__PURE__ */ f(
      _s,
      {
        options: [
          { value: 10, label: "10" },
          { value: 25, label: "25" },
          { value: 50, label: "50" },
          { value: 100, label: "100" }
        ],
        size: "sm",
        isClearable: !1,
        onChange: (c) => {
          s((c == null ? void 0 : c.value) || 10);
        },
        value: o
      }
    )
  ] });
};
function Px(e, t = 10, i = !0) {
  const [r, n] = se(t), [o, s] = se(1), [a, l] = se(e.slice(0, r)), c = we(
    () => Math.floor(e.length / r) + (e.length % r != 0 ? 1 : 0),
    [e, r]
  );
  return be(() => {
    s(1);
  }, [e, r]), be(() => {
    l(e.slice((o - 1) * r, o * r)), e.length !== 0 && fb("page", `${o}`);
  }, [e, o, r]), {
    pagItems: a,
    pagesCount: c,
    pagNav: e.length > 0 ? /* @__PURE__ */ f(
      T0e,
      {
        page: o,
        maxPage: c,
        nextPage: () => s(o + 1),
        prevPage: () => s(o - 1),
        itemsPerPage: r,
        setItemsPerPage: i ? n : void 0
      }
    ) : void 0
  };
}
const B0e = "_table_b8wc8_1", D0e = "_verticalBorders_b8wc8_57", o6 = {
  table: B0e,
  verticalBorders: D0e
};
function zx(r) {
  var n = r, { className: e, verticalBorders: t = !0 } = n, i = Fe(n, ["className", "verticalBorders"]);
  return /* @__PURE__ */ f(
    "table",
    q({
      className: me(o6.table, t && o6.verticalBorders, e)
    }, i)
  );
}
const O0e = "_wrapper_1k51d_1", F0e = "_table_1k51d_5", V0e = "_sortableHeader_1k51d_14", q0e = "_interactable_1k51d_23", yp = {
  wrapper: O0e,
  table: F0e,
  sortableHeader: V0e,
  interactable: q0e
};
function YO(s) {
  var a = s, {
    items: e,
    fields: t,
    rowRenderer: i,
    className: r,
    paginate: n = !0
  } = a, o = Fe(a, [
    "items",
    "fields",
    "rowRenderer",
    "className",
    "paginate"
  ]);
  const [l, c] = se(void 0), u = ye(
    (A) => {
      (l == null ? void 0 : l.field) !== A ? c({ field: A, order: "asc" }) : l.order === "asc" ? c({ field: A, order: "desc" }) : c(void 0);
    },
    [l]
  ), m = we(() => {
    var y;
    if (!l)
      return e;
    const A = (y = t.find((E) => E.field === l.field)) == null ? void 0 : y.sortScore;
    return [...e].sort((E, v) => {
      if (A) {
        const C = A(E), x = A(v);
        return pb(C, x, l.order === "desc");
      }
      return pb(E[l.field], v[l.field], l.order === "desc");
    });
  }, [e, l, t]);
  be(() => {
    fb("sort", l ? String(l.field) : void 0), fb("order", l ? l.order : void 0);
  }, [l]);
  const { pagItems: g, pagNav: h } = Px(m, 50);
  return /* @__PURE__ */ V(gt, { children: [
    /* @__PURE__ */ f("div", { className: yp.wrapper, children: /* @__PURE__ */ V(zx, ee(q({ className: me(yp.table, r), verticalBorders: !1 }, o), { children: [
      /* @__PURE__ */ f("thead", { children: /* @__PURE__ */ f("tr", { children: t.map((A, y) => /* @__PURE__ */ f(
        "th",
        {
          style: A.style,
          className: me(A.sortable !== !1 ? yp.sortableHeader : void 0, A.className),
          onClick: A.sortable !== !1 ? () => {
            u(A.field);
          } : void 0,
          children: /* @__PURE__ */ V("span", { children: [
            A.sortable !== !1 && /* @__PURE__ */ f("span", { children: (l == null ? void 0 : l.field) === A.field ? l.order === "asc" ? "⇧" : "⇩" : "⇳" }),
            A.header
          ] })
        },
        y
      )) }) }),
      /* @__PURE__ */ f("tbody", { children: (n ? g : m).map((A, y) => {
        const E = t.find((v) => v.onClick) !== void 0;
        return i ? i(A) : /* @__PURE__ */ f("tr", { className: me(E && yp.interactable), children: t.map((v, C) => /* @__PURE__ */ f(
          "td",
          {
            style: v.style,
            className: v.className,
            onClick: v.onClick ? () => {
              v.onClick && v.onClick(A);
            } : void 0,
            children: v.content ? v.content(A) : A[v.field]
          },
          C
        )) }, y);
      }) })
    ] })) }),
    n && h
  ] });
}
const j0e = "_container_u7mbu_1", L0e = "_filters_u7mbu_8", zp = {
  container: j0e,
  filters: L0e
}, K0e = "_MoreDots_1x8kf_1", Y0e = "_MoreDots__dot_1x8kf_9", Ep = {
  MoreDots: K0e,
  MoreDots__dot: Y0e
};
function U0e(i) {
  var r = i, { className: e } = r, t = Fe(r, ["className"]);
  return /* @__PURE__ */ V("span", ee(q({ className: me(Ep.MoreDots, e) }, t), { children: [
    /* @__PURE__ */ f("span", { className: Ep.MoreDots__dot }),
    /* @__PURE__ */ f("span", { className: Ep.MoreDots__dot }),
    /* @__PURE__ */ f("span", { className: Ep.MoreDots__dot })
  ] }));
}
const G0e = "_button_aqxx1_1", Q0e = "_buttonInner_aqxx1_15", W0e = "_buttonIcon_aqxx1_21", Z0e = "_active_aqxx1_39", J0e = "_sm_aqxx1_54", P0e = "_md_aqxx1_62", z0e = "_primary_aqxx1_67", H0e = "_primary2_aqxx1_94", X0e = "_danger_aqxx1_124", _0e = "_danger2_aqxx1_151", $0e = "_moreDots_aqxx1_182", cc = {
  button: G0e,
  buttonInner: Q0e,
  buttonIcon: W0e,
  active: Z0e,
  sm: J0e,
  "sm-md": "_sm-md_aqxx1_58",
  md: P0e,
  primary: z0e,
  primary2: H0e,
  danger: X0e,
  danger2: _0e,
  moreDots: $0e
};
function ede(c, l) {
  var u = c, {
    className: e,
    active: t,
    size: i = "sm-md",
    buttonStyle: r = "default",
    iconProps: n,
    onMoreClick: o,
    children: s
  } = u, a = Fe(u, [
    "className",
    "active",
    "size",
    "buttonStyle",
    "iconProps",
    "onMoreClick",
    "children"
  ]);
  return /* @__PURE__ */ V(
    "button",
    ee(q({
      ref: l,
      className: me(cc.button, cc[i], cc[r], t && cc.active, e)
    }, a), {
      children: [
        n ? /* @__PURE__ */ V("span", { className: cc.buttonInner, children: [
          /* @__PURE__ */ f(Mt, ee(q({}, n), { className: me(cc.buttonIcon, n.className) })),
          s
        ] }) : s,
        o ? /* @__PURE__ */ f(U0e, { className: cc.moreDots, onClick: o }) : null
      ]
    })
  );
}
const Kt = T0(ede);
function tde(e) {
  return `[${e._type} id=${e._identity}]${e._display}[/${e._type}]`;
}
function ide(e, t) {
  return `[${t.type} id=${t.id} profile=${e.id}][/${t.type}]`;
}
function UO(e) {
  e.length > 0 ? window.history.pushState(null, "", `?${e.map((t) => t.join("=")).join("&")}`) : window.history.pushState(null, "", window.location.href.split("?")[0]);
}
function hBe(e, t) {
  const i = PT(window.location.href);
  t !== void 0 ? i[e] = t : delete i[e], UO(Object.entries(i));
}
function rde(e) {
  const t = window.location.href.split("/database"), i = `${Ut.trim(t[0], " /")}/database`, r = e.map(([, n]) => n).join("/");
  e.length > 0 ? window.history.pushState(null, "", `${i}/${r}`) : window.history.pushState(null, "", i);
}
function nde(e) {
  const t = (i, r) => {
    const n = [];
    for (const o of i)
      n.push([o, r]), o.children && n.push(...t(o.children, o.id));
    return n;
  };
  return t(e);
}
function pBe({
  gameData: e,
  navigationData: t,
  list: i,
  id: r,
  url: n,
  branchName: o,
  getSeo: s,
  getEntitySeoDescription: a
}) {
  var m, g;
  let l;
  const u = nde(t).find(([h, A]) => h.id === i);
  if (i && u) {
    const h = (g = (m = u[0]).content) == null ? void 0 : g.call(m), A = h == null ? void 0 : h.find((y) => y._identity === r);
    r && A ? (l = {
      title: `${A._display} - ${o} Database`,
      description: a(e, A)
    }, A._icon && (l.icon = `https://assets-ng.maxroll.gg/ern-tools/assets/db/${A._icon}`)) : l = {
      title: `List of ${u[0].title} - ${o} Database`,
      description: s(e, u[0].id, "description")
    }, l.url = n;
  }
  return l;
}
const ode = "_tooltip_zvlor_1", sde = {
  tooltip: ode
};
function ade({
  entity: e,
  moreOptions: t
}) {
  const { generateShortcode: i } = Ui(), [r, n] = se(null), [o, s] = se(!1), a = we(() => {
    if (t)
      return (l) => {
        l.preventDefault(), l.stopPropagation(), s((c) => !c);
      };
  }, [t]);
  return /* @__PURE__ */ V(gt, { children: [
    /* @__PURE__ */ f(
      Kt,
      {
        ref: n,
        onClick: () => {
          navigator.clipboard.writeText(i ? i({ entity: e }) : tde(e));
        },
        onMoreClick: a,
        children: /* @__PURE__ */ f("span", { children: "Copy" })
      }
    ),
    /* @__PURE__ */ f(
      Fg,
      {
        referenceElement: r,
        className: sde.tooltip,
        visible: o,
        options: {
          placement: "right",
          modifiers: [
            { name: "offset", options: { offset: [0, 10] } },
            {
              name: "flip",
              options: {
                fallbackPlacements: ["left", "bottom", "top"]
              }
            },
            {
              name: "preventOverflow"
            }
          ]
        },
        children: t == null ? void 0 : t({ entity: e, close: () => s(!1) })
      }
    )
  ] });
}
function fBe(u) {
  var m = u, {
    entities: e,
    fields: t,
    filters: i,
    paginate: r = !0,
    activeLayout: n,
    setActiveLayout: o,
    searchQuery: s,
    setSearchQuery: a,
    className: l
  } = m, c = Fe(m, [
    "entities",
    "fields",
    "filters",
    "paginate",
    "activeLayout",
    "setActiveLayout",
    "searchQuery",
    "setSearchQuery",
    "className"
  ]);
  const { copyTooltip: g, showEntityId: h } = Ui();
  return /* @__PURE__ */ V("div", ee(q({ className: me(zp.container, l) }, c), { children: [
    i ? /* @__PURE__ */ f(Pr, { type: "horizontal", innerClassName: zp.filters, children: i }) : void 0,
    /* @__PURE__ */ f(Pr, { className: me(zp.tableContent), type: "vertical", children: /* @__PURE__ */ f(
      YO,
      {
        paginate: r,
        items: e,
        fields: [
          ...cm(!!(g != null && g.show), {
            field: "",
            header: "",
            content: (A) => /* @__PURE__ */ f(ade, { entity: A, moreOptions: g == null ? void 0 : g.moreOptions }),
            sortable: !1,
            style: { width: 0 }
          }),
          ...cm(h === !0, {
            field: "_identity",
            header: "ID",
            content: (A) => A._identity,
            sortable: !0,
            style: { width: 0 }
          }),
          ...t
        ]
      }
    ) })
  ] }));
}
const ABe = zp, GO = Co(null);
function lde() {
  return {
    assetPath: "https://assets-ng.maxroll.gg",
    commonLibsAssetPath: "https://assets-ng.maxroll.gg/common-libs/assets/images"
  };
}
const cde = ({ children: e }) => /* @__PURE__ */ f(GO.Provider, { value: lde(), children: e }), QO = () => sn(GO);
function ude(o) {
  var s = o, {
    entity: e,
    entities: t,
    layout: i,
    selectedItem: r
  } = s, n = Fe(s, [
    "entity",
    "entities",
    "layout",
    "selectedItem"
  ]);
  const { layoutComponents: a } = Ui(), l = a[i](e || t[0], r);
  return l ? Ei(l, q({ entity: e, entities: t, selectedItem: r }, n)) : void 0;
}
const dde = "_Codex_12w27_1", mde = "_Codex__scrollRef_12w27_8", gde = "_Codex__content_12w27_14", vp = {
  Codex: dde,
  Codex__scrollRef: mde,
  Codex__content: gde,
  "Codex--v2": "_Codex--v2_12w27_48"
}, hde = "_navigation_y00gi_1", pde = "_navInner_y00gi_11", fde = "_scrollBox_y00gi_16", Ade = "_scrollBoxInner_y00gi_19", yde = "_item_y00gi_25", Ede = "_navButton_y00gi_28", vde = "_chevron_y00gi_41", bde = "_placeholder_y00gi_46", Cde = "_active_y00gi_55", xde = "_isInteractable_y00gi_58", Ide = "_children_y00gi_66", Sde = "_collapsed_y00gi_71", Rde = "_img_y00gi_119", Gn = {
  navigation: hde,
  navInner: pde,
  scrollBox: fde,
  scrollBoxInner: Ade,
  item: yde,
  navButton: Ede,
  chevron: vde,
  placeholder: bde,
  active: Cde,
  isInteractable: xde,
  children: Ide,
  collapsed: Sde,
  img: Rde
}, s6 = ({ size: e, imgSize: t, src: i, style: r }) => /* @__PURE__ */ f("span", { className: Gn.img, style: q({ width: `${e}px`, height: `${e}px` }, r), children: /* @__PURE__ */ f("img", { width: t || e, src: i }) });
function WO(e, t) {
  if (e === void 0)
    return [];
  for (const i of t) {
    if (i.id === e)
      return [i.id];
    if (i.children) {
      const r = WO(e, i.children);
      if (r.length > 0)
        return [i.id, ...r];
    }
  }
  return [];
}
function ZO({
  selectedItem: e,
  setSelectedItem: t,
  items: i,
  depth: r,
  initialExpandedItems: n
}) {
  const { commonLibsAssetPath: o } = QO(), [s, a] = se(() => {
    const c = i == null ? void 0 : i.find((u) => n.includes(u.id));
    return c ? { [c.id]: !1 } : {};
  }), l = ye(
    (c, u) => a((m) => ee(q({}, m), { [c]: u })),
    [s]
  );
  return i == null ? void 0 : i.map((c, u) => {
    var v, C, x;
    const m = e === c.id, g = c.children !== void 0, h = (v = c.collapsable) != null ? v : !1, A = h ? (C = s[c.id]) != null ? C : !0 : !1, y = "content" in c, E = ((x = c.children) == null ? void 0 : x.find((S) => S.icon !== void 0)) !== void 0;
    return /* @__PURE__ */ V("div", { className: Gn.item, children: [
      g || y ? /* @__PURE__ */ V(
        "button",
        {
          className: me(
            Gn.navButton,
            (h && g || y) && Gn.isInteractable,
            m && !g && Gn.active
          ),
          onClick: h && g ? () => l(c.id, !A) : y ? () => t(c.id) : void 0,
          children: [
            g && h ? /* @__PURE__ */ f(Mt, { icon: "chevron-right.svg", className: Gn.chevron, width: 16, height: 16 }) : void 0,
            c.icon ? /* @__PURE__ */ f(s6, { size: 20, src: `${c.icon}` }) : void 0,
            c.title
          ]
        }
      ) : /* @__PURE__ */ f("span", { children: c.title }),
      !A && /* @__PURE__ */ V("div", { className: Gn.children, children: [
        g && y && /* @__PURE__ */ f("div", { className: Gn.item, children: /* @__PURE__ */ V(
          "button",
          {
            className: me(Gn.navButton, m && Gn.active),
            onClick: c.content ? () => t(c.id) : void 0,
            children: [
              E && /* @__PURE__ */ f(s6, { size: 20, imgSize: 18, src: `${o}/icons/all.png` }),
              "All ",
              c.title
            ]
          }
        ) }),
        /* @__PURE__ */ f(
          ZO,
          {
            items: c.children,
            selectedItem: e,
            setSelectedItem: t,
            depth: r + 1,
            initialExpandedItems: n
          }
        )
      ] })
    ] }, u);
  });
}
function kde({
  selectedItem: e,
  setSelectedItem: t,
  navigationCategories: i,
  navFlatMap: r
}) {
  const { siteId: n } = Ui(), [g] = gi((A) => ({
    loaded: A.viewport.loaded,
    lg: A.viewport.lg,
    scrollYDiff: A.scrollYDiff
  })), h = g, { scrollYDiff: o } = h, s = Fe(h, ["scrollYDiff"]), a = n === "d4" ? 130 : 90, l = n === "d4" ? 99 : 60, [c, u] = se(l);
  be(() => {
    const y = Math.max(n === "d4" ? 18 : -22, Math.min(c + o, l));
    y !== c && u(y);
  }, [scrollY, o, n]);
  const [m] = se(WO(e, i));
  return /* @__PURE__ */ f("div", { style: { top: s.lg ? a : c }, className: Gn.navigation, children: /* @__PURE__ */ f("div", { className: Gn.navInner, children: s.lg ? /* @__PURE__ */ f(Pr, { className: Gn.scrollBox, innerClassName: Gn.scrollBoxInner, type: "vertical", children: /* @__PURE__ */ f(
    ZO,
    {
      selectedItem: e,
      setSelectedItem: t,
      items: i,
      depth: 0,
      initialExpandedItems: m
    }
  ) }) : /* @__PURE__ */ f(
    _s,
    {
      value: e,
      options: r.filter(([A]) => A.content !== void 0).map(([A, y]) => {
        const E = y ? r.find(([C]) => C.id === y) : void 0, v = E ? r.find(([C]) => C.id === E[1]) : void 0;
        return {
          value: A.id,
          label: `${v ? `${v[0].title} - ` : ""}${E ? `${E[0].title} - ` : ""}${A.title}`
        };
      }),
      onChange: (A) => {
        A != null && A.value && t(A == null ? void 0 : A.value);
      }
    }
  ) }) });
}
const wde = "_topBar_ujqi3_1", Mde = "_right_ujqi3_9", a6 = {
  topBar: wde,
  right: Mde
};
function Nde({ gameLocales: e }) {
  const { locale: t, gameData: i } = Ui();
  return /* @__PURE__ */ V("div", { className: a6.topBar, children: [
    /* @__PURE__ */ f("span", {}),
    /* @__PURE__ */ V("span", { className: a6.right, children: [
      e.length > 1 && /* @__PURE__ */ f(
        _s,
        {
          value: t[0],
          options: e.map((r) => ({
            value: r.id,
            label: r.name
          })),
          onChange: (r) => {
            t[1]((r == null ? void 0 : r.value) || "en_US");
          },
          isClearable: !1
        }
      ),
      "Game Version: ",
      /* @__PURE__ */ f("span", { children: i.apiext_version })
    ] })
  ] });
}
const l6 = (e) => typeof e == "object" && e != null && e.nodeType === 1, c6 = (e, t) => (!t || e !== "hidden") && e !== "visible" && e !== "clip", OE = (e, t) => {
  if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
    const i = getComputedStyle(e, null);
    return c6(i.overflowY, t) || c6(i.overflowX, t) || ((r) => {
      const n = ((o) => {
        if (!o.ownerDocument || !o.ownerDocument.defaultView)
          return null;
        try {
          return o.ownerDocument.defaultView.frameElement;
        } catch (s) {
          return null;
        }
      })(r);
      return !!n && (n.clientHeight < r.scrollHeight || n.clientWidth < r.scrollWidth);
    })(e);
  }
  return !1;
}, bp = (e, t, i, r, n, o, s, a) => o < e && s > t || o > e && s < t ? 0 : o <= e && a <= i || s >= t && a >= i ? o - e - r : s > t && a < i || o < e && a > i ? s - t + n : 0, Tde = (e) => {
  const t = e.parentElement;
  return t == null ? e.getRootNode().host || null : t;
}, u6 = (e, t) => {
  var i, r, n, o;
  if (typeof document == "undefined")
    return [];
  const { scrollMode: s, block: a, inline: l, boundary: c, skipOverflowHiddenElements: u } = t, m = typeof c == "function" ? c : (H) => H !== c;
  if (!l6(e))
    throw new TypeError("Invalid target");
  const g = document.scrollingElement || document.documentElement, h = [];
  let A = e;
  for (; l6(A) && m(A); ) {
    if (A = Tde(A), A === g) {
      h.push(A);
      break;
    }
    A != null && A === document.body && OE(A) && !OE(document.documentElement) || A != null && OE(A, u) && h.push(A);
  }
  const y = (r = (i = window.visualViewport) == null ? void 0 : i.width) != null ? r : innerWidth, E = (o = (n = window.visualViewport) == null ? void 0 : n.height) != null ? o : innerHeight, { scrollX: v, scrollY: C } = window, { height: x, width: S, top: R, right: w, bottom: T, left: N } = e.getBoundingClientRect(), { top: D, right: O, bottom: F, left: Y } = ((H) => {
    const Q = window.getComputedStyle(H);
    return { top: parseFloat(Q.scrollMarginTop) || 0, right: parseFloat(Q.scrollMarginRight) || 0, bottom: parseFloat(Q.scrollMarginBottom) || 0, left: parseFloat(Q.scrollMarginLeft) || 0 };
  })(e);
  let P = a === "start" || a === "nearest" ? R - D : a === "end" ? T + F : R + x / 2 - D + F, z = l === "center" ? N + S / 2 - Y + O : l === "end" ? w + O : N - Y;
  const W = [];
  for (let H = 0; H < h.length; H++) {
    const Q = h[H], { height: $, width: le, top: he, right: oe, bottom: ue, left: Ae } = Q.getBoundingClientRect();
    if (s === "if-needed" && R >= 0 && N >= 0 && T <= E && w <= y && R >= he && T <= ue && N >= Ae && w <= oe)
      return W;
    const de = getComputedStyle(Q), fe = parseInt(de.borderLeftWidth, 10), Re = parseInt(de.borderTopWidth, 10), qe = parseInt(de.borderRightWidth, 10), Oe = parseInt(de.borderBottomWidth, 10);
    let Xe = 0, Qe = 0;
    const Pe = "offsetWidth" in Q ? Q.offsetWidth - Q.clientWidth - fe - qe : 0, et = "offsetHeight" in Q ? Q.offsetHeight - Q.clientHeight - Re - Oe : 0, At = "offsetWidth" in Q ? Q.offsetWidth === 0 ? 0 : le / Q.offsetWidth : 0, Et = "offsetHeight" in Q ? Q.offsetHeight === 0 ? 0 : $ / Q.offsetHeight : 0;
    if (g === Q)
      Xe = a === "start" ? P : a === "end" ? P - E : a === "nearest" ? bp(C, C + E, E, Re, Oe, C + P, C + P + x, x) : P - E / 2, Qe = l === "start" ? z : l === "center" ? z - y / 2 : l === "end" ? z - y : bp(v, v + y, y, fe, qe, v + z, v + z + S, S), Xe = Math.max(0, Xe + C), Qe = Math.max(0, Qe + v);
    else {
      Xe = a === "start" ? P - he - Re : a === "end" ? P - ue + Oe + et : a === "nearest" ? bp(he, ue, $, Re, Oe + et, P, P + x, x) : P - (he + $ / 2) + et / 2, Qe = l === "start" ? z - Ae - fe : l === "center" ? z - (Ae + le / 2) + Pe / 2 : l === "end" ? z - oe + qe + Pe : bp(Ae, oe, le, fe, qe + Pe, z, z + S, S);
      const { scrollLeft: oi, scrollTop: Ai } = Q;
      Xe = Et === 0 ? 0 : Math.max(0, Math.min(Ai + Xe / Et, Q.scrollHeight - $ / Et + et)), Qe = At === 0 ? 0 : Math.max(0, Math.min(oi + Qe / At, Q.scrollWidth - le / At + Pe)), P += Ai - Xe, z += oi - Qe;
    }
    W.push({ el: Q, top: Xe, left: Qe });
  }
  return W;
}, Bde = (e) => e === !1 ? { block: "end", inline: "nearest" } : ((t) => t === Object(t) && Object.keys(t).length !== 0)(e) ? e : { block: "start", inline: "nearest" };
function Hx(e, t) {
  if (!e.isConnected || !((n) => {
    let o = n;
    for (; o && o.parentNode; ) {
      if (o.parentNode === document)
        return !0;
      o = o.parentNode instanceof ShadowRoot ? o.parentNode.host : o.parentNode;
    }
    return !1;
  })(e))
    return;
  const i = ((n) => {
    const o = window.getComputedStyle(n);
    return { top: parseFloat(o.scrollMarginTop) || 0, right: parseFloat(o.scrollMarginRight) || 0, bottom: parseFloat(o.scrollMarginBottom) || 0, left: parseFloat(o.scrollMarginLeft) || 0 };
  })(e);
  if (((n) => typeof n == "object" && typeof n.behavior == "function")(t))
    return t.behavior(u6(e, t));
  const r = typeof t == "boolean" || t == null ? void 0 : t.behavior;
  for (const { el: n, top: o, left: s } of u6(e, Bde(t))) {
    const a = o - i.top + i.bottom, l = s - i.left + i.right;
    n.scroll({ top: a, left: l, behavior: r });
  }
}
function d6(e, t, i) {
  const r = [];
  e !== void 0 && r.push(["list", e]), t !== void 0 && r.push(["id", t._identity]), i === "v1" ? UO(r) : rde(r);
}
function m6(e, t) {
  var i, r, n, o, s;
  if (typeof window != "undefined")
    if (t === "v1") {
      const a = PT(window.location.href);
      if (!a.list)
        return;
      const l = e.find(([m, g]) => m.id === a.list);
      if (l === void 0)
        return;
      const c = (r = (i = l[0]).content) == null ? void 0 : r.call(i), u = a.id ? c == null ? void 0 : c.find((m) => m._identity === a.id) : void 0;
      return { selectedItem: l[0].id, selectedEntity: u };
    } else {
      const a = window.location.href.split("/database"), l = Ut.trim((n = a[1]) != null ? n : "", " /");
      if (!l)
        return;
      const c = l.split("?")[0].split("/");
      if (c.length === 0 || c.length > 2)
        return;
      const u = e.find(([h, A]) => h.id === c[0]);
      if (u === void 0)
        return;
      const m = (s = (o = u[0]).content) == null ? void 0 : s.call(o), g = c[1] ? m == null ? void 0 : m.find((h) => h._identity === c[1]) : void 0;
      return { selectedItem: u[0].id, selectedEntity: g };
    }
}
const Dde = kde;
function yBe(u) {
  var m = u, {
    navigationData: e,
    getNavItemFromEntity: t,
    initialSelectedItem: i,
    showTopBar: r = !0,
    header: n,
    navigationComponent: o,
    searchQuery: s,
    codexVersion: a = "v1",
    className: l
  } = m, c = Fe(m, [
    "navigationData",
    "getNavItemFromEntity",
    "initialSelectedItem",
    "showTopBar",
    "header",
    "navigationComponent",
    "searchQuery",
    "codexVersion",
    "className"
  ]);
  const { gameData: g, gameLocales: h, codexEntityLayout: A } = Ui(), [y, E] = se(A || "table"), [v, C] = se(null), x = we(() => e(g), [g, e]), S = we(() => {
    const P = (z, W) => {
      const H = [];
      for (const Q of z)
        H.push([Q, W]), Q.children && H.push(...P(Q.children, Q.id));
      return H;
    };
    return P(x);
  }, [x]), [R] = se(m6(S, a)), [w, T] = se((R == null ? void 0 : R.selectedItem) || i), [N, D] = se(R == null ? void 0 : R.selectedEntity);
  be(() => {
    if (typeof window == "undefined")
      return;
    const P = () => {
      const z = m6(S, a);
      if (!z) {
        T((R == null ? void 0 : R.selectedItem) || i), D(R == null ? void 0 : R.selectedEntity);
        return;
      }
      T(z.selectedItem), D(z.selectedEntity);
    };
    return window.addEventListener("popstate", P), () => {
      window.removeEventListener("popstate", P);
    };
  }, [S, R, i, a]);
  const O = ye(
    (P) => {
      T(P), D(void 0), d6(P, void 0, a), window.scrollY > 500 && (v == null || v.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" }));
    },
    [a, v]
  ), F = ye(
    (P) => {
      let z = w;
      N !== void 0 && (P == null ? void 0 : P._type) != (N == null ? void 0 : N._type) && (z = t(P), T(z));
      const W = t(P);
      D(P), d6(W, P, a);
      const H = document.getElementById("database-header-filters");
      H && Hx(H, {
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      });
    },
    [w, N, a, t]
  ), Y = we(() => {
    let P = S.find(([z, W]) => z.id === w);
    for (; P !== void 0; ) {
      if (P[0].content)
        return P[0].content() || [];
      P = S.find(([z, W]) => z.id === (P == null ? void 0 : P[1]));
    }
    return [];
  }, [S, w]);
  return /* @__PURE__ */ f(cde, { children: /* @__PURE__ */ V("div", ee(q({ className: me(l, vp.Codex, vp[`Codex--${a}`]) }, c), { children: [
    /* @__PURE__ */ f("div", { ref: C, className: vp.Codex__scrollRef }),
    r && /* @__PURE__ */ f(Nde, { gameLocales: h }),
    n,
    /* @__PURE__ */ V("div", { className: vp.Codex__content, children: [
      Ei(o || Dde, {
        navigationCategories: x,
        navFlatMap: S,
        selectedItem: w,
        setSelectedItem: O,
        selectedEntity: N
      }),
      /* @__PURE__ */ V("div", { children: [
        Y.length > 0 && !N && /* @__PURE__ */ f(
          ude,
          {
            layout: y,
            setActiveLayout: E,
            selectedItem: w,
            entities: Y,
            onItemClick: F,
            searchQuery: s
          }
        ),
        N && /* @__PURE__ */ f(y0e, { entity: N, onEntitySelect: F })
      ] })
    ] })
  ] })) });
}
const Ode = "_Navigation_142p1_1", Fde = "_Navigation__inner_142p1_14", Vde = "_Navigation__scrollBox_142p1_20", qde = "_Navigation__scrollBoxInner_142p1_25", jde = "_Navigation__item_142p1_34", Lde = "_Navigation__button_142p1_39", Kde = "_Navigation__chevron_142p1_63", Yde = "_Navigation__buttonMain_142p1_77", Ude = "_Navigation__verticalLine_142p1_84", Gde = "_Navigation__children_142p1_112", Qde = "_Navigation__img_142p1_118", Ji = {
  Navigation: Ode,
  Navigation__inner: Fde,
  Navigation__scrollBox: Vde,
  Navigation__scrollBoxInner: qde,
  Navigation__item: jde,
  Navigation__button: Lde,
  "Navigation__button--active": "_Navigation__button--active_142p1_59",
  Navigation__chevron: Kde,
  "Navigation__button--interactable": "_Navigation__button--interactable_142p1_67",
  Navigation__buttonMain: Yde,
  Navigation__verticalLine: Ude,
  Navigation__children: Gde,
  Navigation__img: Qde,
  "Navigation__item--linkedLines": "_Navigation__item--linkedLines_142p1_125",
  "Navigation__item--collapsed": "_Navigation__item--collapsed_142p1_178"
}, g6 = ({ size: e, imgSize: t, src: i, style: r }) => /* @__PURE__ */ f("span", { className: Ji.Navigation__img, style: q({ width: `${e}px`, height: `${e}px` }, r), children: /* @__PURE__ */ f("img", { width: t || e, src: i }) });
function JO(e, t) {
  if (e === void 0)
    return [];
  for (const i of t) {
    if (i.id === e)
      return [i.id];
    if (i.children) {
      const r = JO(e, i.children);
      if (r.length > 0)
        return [i.id, ...r];
    }
  }
  return [];
}
function PO({
  selectedItem: e,
  setSelectedItem: t,
  selectedEntity: i,
  items: r,
  depth: n,
  initialExpandedItems: o,
  parentColor: s
}) {
  const { commonLibsAssetPath: a } = QO(), [l, c] = se(() => {
    const g = r == null ? void 0 : r.find((h) => o.includes(h.id));
    return g ? { [g.id]: !1 } : {};
  }), u = ye(
    (g, h) => c((A) => ee(q({}, A), { [g]: h })),
    []
  ), m = ye(
    ({
      item: g,
      isCollapsable: h,
      isCollpased: A,
      hasChildren: y,
      hasContent: E
    }) => () => {
      h && y ? (u(g.id, !A), E && !i && A && t(g.id)) : E && t(g.id);
    },
    [i, u, t]
  );
  return r == null ? void 0 : r.map((g, h) => {
    var T, N, D, O, F, Y;
    const A = e === g.id, y = g.children !== void 0, E = (T = g.collapsable) != null ? T : !1, v = E ? (N = l[g.id]) != null ? N : !0 : !1, C = "content" in g, x = ((D = g.children) == null ? void 0 : D.find((P) => P.icon !== void 0)) !== void 0, S = ((O = g.children) == null ? void 0 : O.find((P) => P.children !== void 0)) !== void 0, R = (F = g.children) == null ? void 0 : F.some(
      (P) => {
        var z;
        return P.id === e || ((z = P.children) == null ? void 0 : z.some(
          (W) => {
            var H;
            return W.id === e || ((H = W.children) == null ? void 0 : H.find((Q) => {
              var $;
              return ($ = Q.children) == null ? void 0 : $.some((le) => le.id === e);
            }));
          }
        ));
      }
    ), w = (Y = g.color) != null ? Y : s;
    return /* @__PURE__ */ V(
      "div",
      {
        className: me(
          Ji.Navigation__item,
          E && !v && Ji["Navigation__item--collapsable"],
          v && Ji["Navigation__item--collapsed"],
          E && !v && !S && Ji["Navigation__item--linkedLines"]
        ),
        children: [
          y || C ? /* @__PURE__ */ V(
            "button",
            {
              className: me(
                Ji.Navigation__button,
                E && y && Ji["Navigation__button--hasChildren"],
                (E && y || C) && Ji["Navigation__button--interactable"],
                (A || R) && Ji["Navigation__button--active"]
              ),
              onClick: m({ item: g, isCollapsable: E, isCollpased: v, hasChildren: y, hasContent: C }),
              children: [
                /* @__PURE__ */ V("div", { className: Ji.Navigation__buttonMain, children: [
                  /* @__PURE__ */ f("div", { style: { backgroundColor: w }, className: Ji.Navigation__verticalLine }),
                  g.icon ? /* @__PURE__ */ f(g6, { size: 20, src: `${g.icon}` }) : void 0,
                  /* @__PURE__ */ f("span", { children: g.title })
                ] }),
                y && E ? /* @__PURE__ */ f(Mt, { icon: "chevron-right.svg", className: Ji.Navigation__chevron, width: 16, height: 16 }) : void 0
              ]
            }
          ) : /* @__PURE__ */ f("span", { children: g.title }),
          !v && y && /* @__PURE__ */ V("div", { className: Ji.Navigation__children, children: [
            C && /* @__PURE__ */ f("div", { className: Ji.Navigation__item, children: /* @__PURE__ */ V(
              "button",
              {
                className: me(
                  Ji.Navigation__button,
                  Ji["Navigation__button--interactable"],
                  A && Ji["Navigation__button--active"]
                ),
                onClick: m({
                  item: g,
                  isCollapsable: !1,
                  isCollpased: !1,
                  hasChildren: !1,
                  hasContent: !0
                }),
                children: [
                  /* @__PURE__ */ V("div", { className: Ji.Navigation__buttonMain, children: [
                    /* @__PURE__ */ f("div", { style: { backgroundColor: w }, className: Ji.Navigation__verticalLine }),
                    x && /* @__PURE__ */ f(g6, { size: 20, imgSize: 16, src: `${a}/icons/all.png` }),
                    /* @__PURE__ */ V("span", { children: [
                      "All ",
                      g.title
                    ] })
                  ] }),
                  /* @__PURE__ */ f("div", {})
                ]
              }
            ) }),
            /* @__PURE__ */ f(
              PO,
              {
                items: g.children,
                selectedItem: e,
                setSelectedItem: t,
                selectedEntity: i,
                depth: n + 1,
                initialExpandedItems: o,
                parentColor: w,
                isParentActive: A
              }
            )
          ] })
        ]
      },
      h
    );
  });
}
function EBe({
  selectedItem: e,
  setSelectedItem: t,
  selectedEntity: i,
  navigationCategories: r,
  navFlatMap: n
}) {
  const { siteId: o } = Ui(), [A] = gi((E) => ({
    loaded: E.viewport.loaded,
    lg: E.viewport.lg,
    scrollYDiff: E.scrollYDiff
  })), y = A, { scrollYDiff: s } = y, a = Fe(y, ["scrollYDiff"]), l = we(() => o === "d4" ? 130 : 90, [o]), c = we(() => o === "d4" ? 99 : 60, [o]), u = we(() => o === "d4" ? 18 : -22, [o]), [m, g] = se(c);
  be(() => {
    const E = Math.max(u, Math.min(m + s, c));
    E !== m && g(E);
  }, [c, u, m, s]);
  const [h] = se(JO(e, r));
  return /* @__PURE__ */ f("div", { style: { top: a.lg ? l : m }, className: Ji.Navigation, children: /* @__PURE__ */ f("div", { className: Ji.Navigation__inner, children: a.lg ? /* @__PURE__ */ f(
    Pr,
    {
      className: Ji.Navigation__scrollBox,
      innerClassName: Ji.Navigation__scrollBoxInner,
      type: "vertical",
      children: /* @__PURE__ */ f(
        PO,
        {
          selectedItem: e,
          setSelectedItem: t,
          selectedEntity: i,
          items: r,
          depth: 0,
          initialExpandedItems: h
        }
      )
    }
  ) : /* @__PURE__ */ f(
    _s,
    {
      value: e,
      options: n.filter(([E]) => E.content !== void 0).map(([E, v]) => {
        const C = v ? n.find(([S]) => S.id === v) : void 0, x = C ? n.find(([S]) => S.id === C[1]) : void 0;
        return {
          value: E.id,
          label: `${x ? `${x[0].title} - ` : ""}${C ? `${C[0].title} - ` : ""}${E.title}`
        };
      }),
      onChange: (E) => {
        E != null && E.value && t(E == null ? void 0 : E.value);
      }
    }
  ) }) });
}
const Wde = {
  leaderboard: {
    width: "728",
    height: "90",
    mq: [
      {
        type: "min",
        val: "801"
      }
    ]
  },
  "large-leaderboard": {
    width: "970",
    height: "90",
    mq: [
      {
        type: "min",
        val: "801"
      }
    ],
    subsizes: [
      {
        width: "728",
        height: "90"
      }
    ]
  },
  billboard: {
    width: "970",
    height: "250",
    mq: [
      {
        type: "min",
        val: "801"
      }
    ],
    subsizes: [
      {
        width: "970",
        height: "90"
      },
      {
        width: "728",
        height: "90"
      }
    ]
  },
  rectangle: {
    width: "300",
    height: "250"
  },
  "medium-rectangle": {
    width: "300",
    height: "250",
    mq: [
      {
        type: "min",
        val: "801"
      }
    ]
  },
  "mobile-banner": {
    width: "320",
    height: "50",
    mq: [
      {
        type: "max",
        val: "800"
      }
    ]
  },
  "mobile-medium-rectangle": {
    width: "300",
    height: "250",
    mq: [
      {
        type: "max",
        val: "800"
      }
    ],
    subsizes: [
      {
        width: "320",
        height: "50"
      }
    ]
  },
  "wide-skyscraper": {
    width: "160",
    height: "600",
    mq: [
      {
        type: "min",
        val: "801"
      }
    ]
  },
  "half-page": {
    width: "300",
    height: "600",
    mq: [
      {
        type: "min",
        val: "801"
      }
    ],
    subsizes: [
      {
        width: "300",
        height: "250"
      },
      {
        width: "160",
        height: "600"
      }
    ]
  },
  dynamic: {
    mq: [
      {
        type: "min",
        val: "801"
      }
    ]
  },
  video: {},
  anchor: {},
  floating: {}
};
function Zde(e) {
  var o;
  const t = Wde[e];
  if (!t)
    return {};
  const i = t.subsizes ? t.subsizes.map((s) => [s.width, s.height]) : t.width && t.height ? [[t.width, t.height]] : [];
  t.width && t.height && i.unshift([t.width, t.height]);
  const r = (o = t.mq) == null ? void 0 : o.map((s) => `(${s.type}-width: ${s.val}px)`), n = (r == null ? void 0 : r.join(" and ")) || "";
  return {
    sizes: i,
    mediaQuery: n
  };
}
function Jde(e, t = "leaderboard", i, r, n = !1) {
  let o = {};
  t && (o = Zde(t));
  const s = {
    enabled: !0,
    wording: "Report Ad",
    position: "top-right",
    icon: !1
  };
  t === "anchor" ? o = {
    format: "anchor",
    renderVisibleOnly: !1,
    refreshVisibleOnly: !1,
    anchor: "bottom",
    anchorPersistClose: !1,
    anchorBgColor: "#0a0a0a",
    mediaQuery: "(min-width: 320px) and (max-width: 767px)"
  } : t === "floating" && (o = {
    format: "floating"
  });
  let a = {};
  if (r)
    a = {
      format: n ? "video" : "video-nc",
      video: { hidePlaylist: !0 },
      report: s
    };
  else if (t === "floating") {
    const l = i.reduceMobileSize ? {
      floating: {
        reduceMobileSize: !0,
        position: "left"
      }
    } : {};
    a = q(q({
      format: "floating",
      report: ee(q({}, s), {
        position: "top-left"
      }),
      mediaQuery: "(min-width: 1025px)",
      refreshLimit: 0,
      refreshTime: 60
    }, i), l);
  } else
    a = Object.assign(
      {
        mediaQuery: "(min-width: 801px)",
        refreshLimit: 0,
        refreshTime: 60,
        renderVisibleOnly: !0,
        refreshVisibleOnly: !0,
        delayloading: !0,
        report: s,
        demo: !1
      },
      o,
      i
    );
  if (window.nitroAds)
    try {
      return window.nitroAds.createAd(e, q({}, a)), !0;
    } catch (l) {
      console.error(l);
    }
  return !1;
}
function Pde({ nitroPayAdProps: e }) {
  const [t] = gi((o) => ({
    loaded: o.viewport.loaded,
    mobile: o.viewport.mobile
  })), [i, r] = se(!1);
  be(() => {
    var l;
    if (!t.loaded || i)
      return;
    window.nitroAds = window.nitroAds || {
      createAd: function() {
        return new Promise((c) => {
          var u;
          (u = window.nitroAds) == null || u.queue.push(["createAd", arguments, c]);
        });
      },
      addUserToken: function() {
        var c;
        (c = window.nitroAds) == null || c.queue.push(["addUserToken", arguments]);
      },
      queue: []
    };
    let o = e.type || null;
    const s = e.type;
    t.mobile && o && !s.startsWith("mobile") && s !== "anchor" && s !== "floating" && e.reduceMobileSize && (o = (l = e.mobileFallbackType) != null ? l : "mobile-medium-rectangle");
    const a = ee(q({}, e), {
      demo: e.demoMode || !1
    });
    r(
      Jde(e.id, o, a, e.isVideo || !1, e.isNewVideoFormat)
    );
  }, [e.id, e, t.mobile, t.loaded, i]);
  const n = !["floating", "anchor"].includes(e.type) && !(e.isVideo && t.mobile);
  return /* @__PURE__ */ f("div", { style: n ? {} : { display: "none" }, children: n ? /* @__PURE__ */ f("div", { id: e.id, className: e.className, style: e.style }) : null });
}
function Vf(n) {
  var o = n, { demoMode: e, type: t, isVideo: i } = o, r = Fe(o, ["demoMode", "type", "isVideo"]);
  const [{ viewportLoaded: s, threshold: a, userHasSub: l, isDev: c }] = gi((S) => ({
    viewportLoaded: S.viewport.loaded,
    threshold: S.viewport.threshold,
    userHasSub: S.userHasSub,
    isDev: S.isDev
  })), [u, m] = se(!1), g = ye(
    Ut.debounce(() => {
      m(!1);
    }, 1e3),
    []
  ), [h, A] = se(void 0);
  be(() => {
    s && (h === void 0 ? A(a) : h !== a && (A(a), m(!0)), g());
  }, [s, a, h, g]);
  const y = we(() => e || !!c, [e, c]), E = we(() => t !== "floating" && !i, [t, i]), v = we(() => E ? a : "fixed", [E, a]);
  return s && !(E && u) && l !== void 0 && !l ? /* @__PURE__ */ f(Pde, { nitroPayAdProps: q({ demoMode: y, type: t, isVideo: i }, r) }, `${r.id}-${v}`) : /* @__PURE__ */ f("div", { style: { display: "none" } });
}
const zde = "_modal_fumir_1", Hde = "_content_fumir_15", Xde = "_close_fumir_29", FE = {
  modal: zde,
  content: Hde,
  close: Xde
};
function qf(s) {
  var a = s, {
    onClose: e,
    className: t,
    innerClassName: i,
    children: r,
    visible: n = !0
  } = a, o = Fe(a, [
    "onClose",
    "className",
    "innerClassName",
    "children",
    "visible"
  ]);
  return typeof document != "undefined" && n ? ps(
    /* @__PURE__ */ f("div", { className: me(FE.modal, t), children: /* @__PURE__ */ V("div", ee(q({ className: me(FE.content, i) }, o), { children: [
      /* @__PURE__ */ f(
        "span",
        {
          className: FE.close,
          onClick: () => {
            e && e();
          },
          children: /* @__PURE__ */ f("span", {})
        }
      ),
      r
    ] })) }),
    document.querySelector("body")
  ) : null;
}
const _de = "_Widget_1ec30_1", $de = "_Widget__titleBox_1ec30_10", eme = "_Widget__left_1ec30_17", tme = "_Widget__title_1ec30_10", ime = "_Widget__right_1ec30_38", Ms = {
  Widget: _de,
  Widget__titleBox: $de,
  Widget__left: eme,
  Widget__title: tme,
  Widget__right: ime
}, h6 = {
  edit: /* @__PURE__ */ f(Mt, { className: Ms.Widget__icon, icon: "icons/edit-3.svg", width: 13, height: 13 }),
  expand: /* @__PURE__ */ f(Mt, { className: Ms.Widget__icon, icon: "icons/expand.svg", width: 8, height: 8 }),
  shortcode: /* @__PURE__ */ f(Mt, { className: Ms.Widget__icon, icon: "icons/shortcode.svg", width: 16, height: 10 })
}, rme = "_ActionBtn_p7rc3_1", nme = "_ActionBtn__icon_p7rc3_7", ome = "_ActionBtn__label_p7rc3_11", sme = "_Modal_p7rc3_30", ame = "_Modal__inner_p7rc3_31", lme = "_Modal__content_p7rc3_35", cme = "_Modal__actions_p7rc3_39", uc = {
  ActionBtn: rme,
  ActionBtn__icon: nme,
  ActionBtn__label: ome,
  Modal: sme,
  Modal__inner: ame,
  Modal__content: lme,
  Modal__actions: cme
};
function uC({
  children: e,
  modalToggleCallback: t,
  icon: i,
  label: r,
  modalConfirmButton: n
}) {
  const [o, s] = se(!1), a = ye(
    (l) => {
      t && t(l), s(l);
    },
    [s, t]
  );
  return /* @__PURE__ */ V(gt, { children: [
    /* @__PURE__ */ V(
      Kt,
      {
        size: "sm",
        buttonStyle: "primary2",
        className: uc.ActionBtn,
        onClick: () => {
          a(!0);
        },
        children: [
          i ? /* @__PURE__ */ f("span", { className: uc.ActionBtn__icon, children: typeof i == "string" && i in h6 ? h6[i] : i }) : null,
          r && /* @__PURE__ */ f("span", { className: uc.ActionBtn__label, children: r })
        ]
      }
    ),
    /* @__PURE__ */ f(
      qf,
      {
        className: uc.Modal,
        innerClassName: uc.Modal__inner,
        visible: o,
        onClose: () => {
          a(!1);
        },
        children: /* @__PURE__ */ V("div", { className: uc.Modal__content, children: [
          e,
          n && /* @__PURE__ */ f("div", { className: uc.Modal__actions, children: /* @__PURE__ */ f(
            Kt,
            {
              buttonStyle: "primary",
              onClick: () => {
                a(!1);
              },
              children: "Confirm"
            }
          ) })
        ] })
      }
    )
  ] });
}
function $0(c) {
  var u = c, {
    title: e,
    children: t,
    editSection: i,
    actionsSection: r,
    leftSection: n,
    modalToggleCallback: o,
    className: s,
    onCopy: a
  } = u, l = Fe(u, [
    "title",
    "children",
    "editSection",
    "actionsSection",
    "leftSection",
    "modalToggleCallback",
    "className",
    "onCopy"
  ]);
  return /* @__PURE__ */ V("div", ee(q({ className: me(Ms.Widget, s) }, l), { children: [
    e ? /* @__PURE__ */ V("div", { className: Ms.Widget__titleBox, children: [
      /* @__PURE__ */ V("div", { className: Ms.Widget__left, children: [
        a ? /* @__PURE__ */ V(Kt, { onClick: a, children: [
          /* @__PURE__ */ f("span", { children: /* @__PURE__ */ f(Mt, { className: Ms.Widget__icon, icon: "icons/edit-3.svg", width: 9, height: 9 }) }),
          /* @__PURE__ */ f("span", { children: "Copy" })
        ] }) : void 0,
        n
      ] }),
      /* @__PURE__ */ f("span", { className: Ms.Widget__title, children: e }),
      /* @__PURE__ */ V("div", { className: Ms.Widget__right, children: [
        r,
        i && /* @__PURE__ */ f(
          uC,
          {
            icon: "edit",
            label: "Edit",
            modalConfirmButton: !0,
            modalToggleCallback: o,
            children: i
          }
        )
      ] })
    ] }) : null,
    /* @__PURE__ */ f("div", { className: Ms.Widget__content, children: t })
  ] }));
}
const ume = "_Select_spmjg_1", dme = "_Select__optionContent_spmjg_7", mme = "_Select__optionText_spmjg_13", VE = {
  Select: ume,
  Select__optionContent: dme,
  Select__optionText: mme
};
function zO({
  value: e,
  options: t,
  isClearable: i = !1,
  onChange: r,
  isMulti: n = !1,
  isDisabled: o = !1,
  size: s = "md",
  activeButtonStyle: a = "primary2",
  className: l
}) {
  const c = we(() => Oc(e, n), [e, n]), u = ye(
    (g) => {
      const h = Oc(g, n);
      r && r(I0(h, t, n));
    },
    [t, n, r]
  ), m = we(() => I0(c, t, n), [c, t, n]);
  return /* @__PURE__ */ f("div", { className: me(VE.Select, l), children: t.map((g, h) => {
    const A = Array.isArray(m) ? m.some((y) => y.value === g.value) : (m == null ? void 0 : m.value) === g.value;
    return /* @__PURE__ */ f(
      Kt,
      {
        buttonStyle: a,
        active: A,
        disabled: o,
        size: s,
        onClick: o ? void 0 : (y) => {
          if (y.preventDefault(), y.stopPropagation(), n) {
            let E = c ? [...c] : [];
            if (A) {
              const v = E.findIndex((C) => C === g.value);
              v !== -1 && E.splice(v, 1);
            } else
              E = [...E, g.value];
            u(E);
          } else
            u(A && i ? void 0 : g.value);
        },
        children: /* @__PURE__ */ V("span", { className: VE.Select__optionContent, children: [
          g.icon ? g.icon : null,
          /* @__PURE__ */ f("span", { className: me(VE.Select__optionText), children: g.label })
        ] })
      },
      h
    );
  }) });
}
function HO(i) {
  var r = i, {
    onChange: e
  } = r, t = Fe(r, [
    "onChange"
  ]);
  return /* @__PURE__ */ f(
    zO,
    q({
      isMulti: !1,
      onChange: (n) => {
        e && e(n);
      }
    }, t)
  );
}
function vBe(i) {
  var r = i, {
    onChange: e
  } = r, t = Fe(r, [
    "onChange"
  ]);
  return /* @__PURE__ */ f(
    zO,
    q({
      isMulti: !0,
      onChange: (n) => {
        e && e(n);
      }
    }, t)
  );
}
var XO = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, p6 = X.createContext && /* @__PURE__ */ X.createContext(XO), gme = ["attr", "size", "title"];
function hme(e, t) {
  if (e == null)
    return {};
  var i = pme(e, t), r, n;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (n = 0; n < o.length; n++)
      r = o[n], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
  }
  return i;
}
function pme(e, t) {
  if (e == null)
    return {};
  var i = {};
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) >= 0)
        continue;
      i[r] = e[r];
    }
  return i;
}
function F1() {
  return F1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = arguments[t];
      for (var r in i)
        Object.prototype.hasOwnProperty.call(i, r) && (e[r] = i[r]);
    }
    return e;
  }, F1.apply(this, arguments);
}
function f6(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), i.push.apply(i, r);
  }
  return i;
}
function V1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? f6(Object(i), !0).forEach(function(r) {
      fme(e, r, i[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : f6(Object(i)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(i, r));
    });
  }
  return e;
}
function fme(e, t, i) {
  return t = Ame(t), t in e ? Object.defineProperty(e, t, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = i, e;
}
function Ame(e) {
  var t = yme(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function yme(e, t) {
  if (typeof e != "object" || !e)
    return e;
  var i = e[Symbol.toPrimitive];
  if (i !== void 0) {
    var r = i.call(e, t || "default");
    if (typeof r != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function _O(e) {
  return e && e.map((t, i) => /* @__PURE__ */ X.createElement(t.tag, V1({
    key: i
  }, t.attr), _O(t.child)));
}
function Xx(e) {
  return (t) => /* @__PURE__ */ X.createElement(Eme, F1({
    attr: V1({}, e.attr)
  }, t), _O(e.child));
}
function Eme(e) {
  var t = (i) => {
    var {
      attr: r,
      size: n,
      title: o
    } = e, s = hme(e, gme), a = n || i.size || "1em", l;
    return i.className && (l = i.className), e.className && (l = (l ? l + " " : "") + e.className), /* @__PURE__ */ X.createElement("svg", F1({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, i.attr, r, s, {
      className: l,
      style: V1(V1({
        color: e.color || i.color
      }, i.style), e.style),
      height: a,
      width: a,
      xmlns: "http://www.w3.org/2000/svg"
    }), o && /* @__PURE__ */ X.createElement("title", null, o), e.children);
  };
  return p6 !== void 0 ? /* @__PURE__ */ X.createElement(p6.Consumer, null, (i) => t(i)) : t(XO);
}
function vme(e) {
  return Xx({ tag: "svg", attr: { fill: "currentColor", viewBox: "0 0 16 16" }, child: [{ tag: "path", attr: { d: "M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5zm8 0A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5z" }, child: [] }] })(e);
}
function bme(e) {
  return Xx({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M80 368H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm0-320H16A16 16 0 0 0 0 64v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16zm0 160H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm416 176H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z" }, child: [] }] })(e);
}
function Cme(e) {
  return Xx({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0V0z" }, child: [] }, { tag: "path", attr: { d: "M12 9c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 8.55C9.64 9.35 6.48 8 3 8v11c3.48 0 6.64 1.35 9 3.55 2.36-2.19 5.52-3.55 9-3.55V8c-3.48 0-6.64 1.35-9 3.55zm7 5.58c-2.53.34-4.93 1.3-7 2.82a15.2 15.2 0 0 0-7-2.83v-6.95c2.1.38 4.05 1.35 5.64 2.83L12 14.28l1.36-1.27A11.18 11.18 0 0 1 19 10.18v6.95z" }, child: [] }] })(e);
}
const xme = "_Header_1xhfn_1", Ime = "_Header__main_1xhfn_6", Sme = "_Header__banner_1xhfn_13", Rme = "_Header__bannerInner_1xhfn_21", kme = "_Header__titleWrapper_1xhfn_29", wme = "_Header__titleIcon_1xhfn_34", Mme = "_Header__title_1xhfn_29", Nme = "_Header__description_1xhfn_57", Tme = "_Header__filters_1xhfn_63", Bme = "_Header__search_1xhfn_69", Dme = "_Header__layoutSelector_1xhfn_73", Ome = "_Header__adWrapper_1xhfn_76", Fme = "_Header__adInner_1xhfn_80", ro = {
  Header: xme,
  Header__main: Ime,
  Header__banner: Sme,
  Header__bannerInner: Rme,
  Header__titleWrapper: kme,
  Header__titleIcon: wme,
  Header__title: Mme,
  Header__description: Nme,
  Header__filters: Tme,
  Header__search: Bme,
  Header__layoutSelector: Dme,
  Header__adWrapper: Ome,
  Header__adInner: Fme
}, Vme = [
  { value: "table", label: "Table", icon: /* @__PURE__ */ f(bme, { size: 14 }) },
  { value: "card-listing", label: "Cards", icon: /* @__PURE__ */ f(vme, { size: 14 }) }
];
function bBe({
  title: e,
  description: t,
  background: i,
  searchQuery: r,
  onSetSearchQuery: n,
  layout: o,
  onSetLayout: s
}) {
  const { siteId: a } = Ui(), [l] = gi((u) => ({
    md: u.viewport.md
  })), c = ye(
    (u) => {
      u != null && u.value && s && s(u.value);
    },
    [s]
  );
  return /* @__PURE__ */ V("div", { className: ro.Header, children: [
    /* @__PURE__ */ V("div", { className: ro.Header__main, children: [
      /* @__PURE__ */ V("div", { className: ro.Header__banner, children: [
        i,
        /* @__PURE__ */ V("div", { className: ro.Header__bannerInner, children: [
          /* @__PURE__ */ V("div", { className: ro.Header__titleWrapper, children: [
            /* @__PURE__ */ f("div", { className: ro.Header__titleIcon, children: /* @__PURE__ */ f(Cme, { color: "rgb(var(--maxroll-color-blue))", size: 34 }) }),
            /* @__PURE__ */ f("h3", { className: ro.Header__title, children: e })
          ] }),
          t ? /* @__PURE__ */ f("div", { className: ro.Header__description, children: t }) : null
        ] })
      ] }),
      /* @__PURE__ */ V("div", { id: "database-header-filters", className: ro.Header__filters, children: [
        /* @__PURE__ */ f(
          wg,
          {
            size: "sm-md",
            className: ro.Header__search,
            value: r,
            onChange: n,
            placeholder: "Search in Database..."
          }
        ),
        s ? /* @__PURE__ */ f(
          HO,
          {
            size: "sm-md",
            className: ro.Header__layoutSelector,
            value: o,
            options: Vme,
            onChange: c,
            isClearable: !1
          }
        ) : null
      ] })
    ] }),
    l.md && /* @__PURE__ */ f("div", { className: ro.Header__adWrapper, children: /* @__PURE__ */ f($0, { className: ro.Header__adInner, title: "Advertisement", children: /* @__PURE__ */ f(Vf, { id: `${a}-database`, isVideo: !0 }) }) })
  ] });
}
const qme = "_Placeholder_lubal_1", jme = {
  Placeholder: qme
};
function CBe({ metadata: e }) {
  return /* @__PURE__ */ V("div", { className: jme.Placeholder, children: [
    /* @__PURE__ */ V("h1", { children: [
      /* @__PURE__ */ f("img", { src: e == null ? void 0 : e.icon, alt: "" }),
      e == null ? void 0 : e.title
    ] }),
    /* @__PURE__ */ f("p", { children: e == null ? void 0 : e.description })
  ] });
}
const Lme = "_TitleV3_ep2zf_1", Kme = "_TitleV3__top_ep2zf_6", Yme = "_TitleV3__topLeft_ep2zf_19", Ume = "_TitleV3__titleLine_ep2zf_26", Gme = "_TitleV3__heading_ep2zf_33", Qme = "_TitleV3__bottom_ep2zf_58", Wme = "_TitleV3__bottomText_ep2zf_64", il = {
  TitleV3: Lme,
  TitleV3__top: Kme,
  TitleV3__topLeft: Yme,
  TitleV3__titleLine: Ume,
  TitleV3__heading: Gme,
  "TitleV3__heading--h2": "_TitleV3__heading--h2_ep2zf_42",
  "TitleV3__heading--h3": "_TitleV3__heading--h3_ep2zf_45",
  "TitleV3__heading--h4": "_TitleV3__heading--h4_ep2zf_48",
  "TitleV3__heading--h5": "_TitleV3__heading--h5_ep2zf_51",
  "TitleV3__heading--h6": "_TitleV3__heading--h6_ep2zf_54",
  TitleV3__bottom: Qme,
  TitleV3__bottomText: Wme
};
function Zme(l) {
  var c = l, {
    title: e,
    titleStart: t,
    titleEnd: i,
    color: r,
    subTitle: n,
    headingLevel: o = 2,
    className: s
  } = c, a = Fe(c, [
    "title",
    "titleStart",
    "titleEnd",
    "color",
    "subTitle",
    "headingLevel",
    "className"
  ]);
  const u = we(() => o === void 0 ? "h2" : `h${Ut.clamp(o, 1, 6)}`, [o]);
  return /* @__PURE__ */ V("div", ee(q({ className: me(il.TitleV3, s) }, a), { children: [
    /* @__PURE__ */ V("div", { className: il.TitleV3__top, children: [
      /* @__PURE__ */ V("div", { className: il.TitleV3__topLeft, children: [
        r ? /* @__PURE__ */ f("span", { style: { backgroundColor: r }, className: il.TitleV3__titleLine }) : void 0,
        t ? /* @__PURE__ */ f("span", { children: t }) : null,
        Ei(u, {
          className: me(il.TitleV3__heading, il[`TitleV3__heading--${u}`]),
          id: XT(`${e}-header`),
          children: e
        })
      ] }),
      i ? /* @__PURE__ */ f("span", { children: i }) : null
    ] }),
    /* @__PURE__ */ f("div", { className: il.TitleV3__bottom, children: n ? /* @__PURE__ */ f("span", { className: il.TitleV3__bottomText, children: n }) : null })
  ] }));
}
const Jme = "_Header_1iqon_1", Pme = "_Header__description_1iqon_2", A6 = {
  Header: Jme,
  Header__description: Pme
};
function xBe({
  entityType: e,
  selectedItem: t
}) {
  const { gameData: i, getSeo: r, entityData: n } = Ui(), o = n == null ? void 0 : n[e];
  return o ? /* @__PURE__ */ V("div", { className: A6.Header, children: [
    /* @__PURE__ */ f(Zme, { title: o.pluralName, headingLevel: 2, color: n[e].color }),
    r ? /* @__PURE__ */ f("p", { className: A6.Header__description, children: r(i, t != null ? t : o.list, "description") }) : void 0
  ] }) : void 0;
}
const ju = {}, y6 = ["data", "metadata", "tags"];
class $O {
  constructor({ game: t, plannersApiPath: i, hooks: r }) {
    Ze(this, "api");
    Ze(this, "game");
    Ze(this, "hooks");
    this.api = i, this.game = t, this.hooks = r != null ? r : [];
  }
  fetch(t, i, r) {
    return Lt(this, null, function* () {
      return fetch(`${this.api}/${t}`, q({
        method: i || "GET",
        credentials: "include",
        headers: i === "DELETE" ? void 0 : { "Content-Type": "application/json" }
      }, r !== void 0 ? { body: JSON.stringify(r) } : {})).then((n) => {
        if (n.ok)
          return n.json();
        throw "error" in n ? new Error(n.error) : new Error(`Failed to fetch ${t}: ${n.statusText}`);
      });
    });
  }
  parseProfile(t) {
    var n, o, s;
    const i = {};
    for (const a of y6)
      if (t[a] !== void 0)
        try {
          i[a] = JSON.parse(t[a]);
        } catch (l) {
        }
    let r = q(ee(q(ee(q({
      id: t.id,
      name: (n = t.name) != null ? n : t.value,
      folder: t.folder,
      public: t.public,
      userId: (o = t.user) == null ? void 0 : o.id,
      date: t.date
    }, t.average_rating ? { average_rating: t.average_rating || 0 } : void 0), {
      userRating: ((s = t == null ? void 0 : t.userRating) == null ? void 0 : s.rating) || 0,
      season: t.season
    }), t.category ? { category: t.category } : {}), {
      class: t.class
    }), i);
    for (const a of this.hooks)
      a.type === "postLoad" && (r = a.callback(r));
    return r;
  }
  fetchFolders() {
    return Lt(this, null, function* () {
      return this.fetch(`folders/${this.game}`).then((t) => {
        if ("error" in t)
          throw new Error(t.error);
        const i = Array.isArray(t) ? [] : JSON.parse(t.body);
        return Object.entries(i).map(([r, n]) => q({ id: parseInt(r) }, n));
      });
    });
  }
  saveFolders(t) {
    return Lt(this, null, function* () {
      const i = t.reduce((r, n) => {
        const a = n, { id: o } = a, s = Fe(a, ["id"]);
        return r[o] = s, r;
      }, {});
      return this.fetch(`folders/${this.game}`, "POST", {
        body: JSON.stringify(i)
      }).then((r) => {
        if ("error" in r)
          throw new Error(r.error);
      });
    });
  }
  fetchProfiles(i) {
    return Lt(this, arguments, function* ({ userPlannerId: t }) {
      return this.fetch(`search/legacy/${this.game}`).then((r) => {
        if (!Array.isArray(r) && "error" in r)
          throw new Error(r.error);
        return r.map((n) => this.parseProfile(n)).map((n) => ee(q({}, n), { userId: t }));
      });
    });
  }
  fetchProfile(r) {
    return Lt(this, arguments, function* ({ id: t, cached: i = !1 }) {
      let n = ju[t];
      return n === void 0 && (n = this.fetch(`profiles/${i ? "load/" : ""}${this.game}/${t}`).then(
        (o) => this.parseProfile(o)
      ), ju[t] = n), n;
    });
  }
  saveProfile(i) {
    return Lt(this, arguments, function* ({ profile: t }) {
      let r = t;
      for (const o of this.hooks)
        o.type === "preSave" && (r = o.callback(r));
      const n = {};
      for (const o of y6)
        r[o] !== void 0 && (n[o] = JSON.stringify(r[o]));
      return this.fetch(`profiles/${this.game}`, "POST", q(q({}, r), n)).then((o) => (delete ju[o.id], this.fetchProfile({ id: o.id })));
    });
  }
  renameProfile(r) {
    return Lt(this, arguments, function* ({ id: t, name: i }) {
      return this.fetch("profiles/rename", "POST", { id: t, name: i }).then(() => (delete ju[t], this.fetchProfile({ id: t })));
    });
  }
  moveProfile(r) {
    return Lt(this, arguments, function* ({ id: t, to: i }) {
      return this.fetch("profiles/move", "POST", { id: t, to: i, game: this.game }).then(() => {
        delete ju[t];
      });
    });
  }
  deleteProfile(i) {
    return Lt(this, arguments, function* ({ id: t }) {
      return this.fetch(`profiles/${t}`, "DELETE").then(() => {
        delete ju[t];
      });
    });
  }
  deleteProfilesInFolder(i) {
    return Lt(this, arguments, function* ({ id: t }) {
      return this.fetch(`profiles/by-folder/${this.game}/${t}`, "DELETE");
    });
  }
  rateProfile(r) {
    return Lt(this, arguments, function* ({ id: t, rating: i }) {
      return this.fetch(`rating/${t}/${i}`, "POST", {});
    });
  }
  // Not sure how this method is supposed to know which game to move the folders from to...
  // It might actually update all of them which is bad.
  //   async moveProfiles({ from, to }: { from: number; to: number }) {
  //     return this.fetch(`profiles/move`, { from, to, game: this.game })
  //   }
  adminUnlistProfile(t) {
    return Lt(this, null, function* () {
      const i = yield this.fetch(`profiles/admin/${t}`, "POST", { public: 0 });
      if (!i || i.code !== "OK")
        throw Error((i == null ? void 0 : i.error) || "Failed to save profile.");
      return i.id;
    });
  }
  adminDeleteProfile(t) {
    return Lt(this, null, function* () {
      const i = yield this.fetch(`profiles/admin/${t}`, "DELETE");
      if (!i || i.code !== "OK")
        throw Error((i == null ? void 0 : i.error) || "Failed to delete profile.");
      return !0;
    });
  }
}
function zme({ siteId: e }) {
  const [{ proxyApi: t }] = gi((r) => ({ proxyApi: r.proxyApi }));
  return { api: we(
    () => new $O({
      game: e,
      plannersApiPath: t ? "/planners-api" : "https://planners.maxroll.gg"
    }),
    [e, t]
  ) };
}
function cu() {
  const { siteId: e, hooks: t } = Ui(), [{ proxyApi: i }] = gi((n) => ({ proxyApi: n.proxyApi }));
  return { api: we(
    () => new $O({
      game: e,
      plannersApiPath: i ? "/planners-api" : "https://planners.maxroll.gg",
      hooks: t
    }),
    [e, i, t]
  ) };
}
function _x() {
  const [, , e] = gi((r) => ({ profiles: r.userGameProfiles })), t = ye(
    (r) => {
      e((n) => {
        var a;
        const o = Ut.cloneDeep(n.userGameProfiles) || [], s = (a = o == null ? void 0 : o.findIndex((l) => l.id === r.id)) != null ? a : -1;
        return s !== -1 ? o[s] = r : o.push(r), { userGameProfiles: o };
      });
    },
    [e]
  ), i = ye(
    (r) => {
      e((n) => {
        var a;
        const o = Ut.cloneDeep(n.userGameProfiles) || [], s = (a = o == null ? void 0 : o.findIndex((l) => l.id === r)) != null ? a : -1;
        return s !== -1 && o.splice(s, 1), { userGameProfiles: o };
      });
    },
    [e]
  );
  return { updateProfileInStore: t, removeProfileFromStore: i };
}
function Hme({ profileId: e, embedId: t, cached: i }) {
  const { api: r } = cu(), [{ profiles: n }] = gi((l) => ({
    profiles: l.userGameProfiles
  })), { updateProfileInStore: o } = _x(), s = we(() => n == null ? void 0 : n.find((l) => l.id === e), [n, e]), a = we(() => {
    var l, c;
    return (c = (l = s == null ? void 0 : s.data) == null ? void 0 : l.embeds) == null ? void 0 : c.find((u) => u.id === t);
  }, [s, t]);
  return be(() => {
    s === void 0 && r.fetchProfile({ id: e, cached: i }).then((l) => {
      o(l);
    });
  }, [s, r, e, o, i]), { embed: a };
}
function IBe({ profileId: e, cached: t = !1 }) {
  const { api: i } = cu(), [{ profiles: r }] = gi((s) => ({
    profiles: s.userGameProfiles
  })), { updateProfileInStore: n } = _x(), o = we(() => r == null ? void 0 : r.find((s) => s.id === e), [r, e]);
  return be(() => {
    o === void 0 && i.fetchProfile({ id: e, cached: t }).then((s) => {
      n(s);
    });
  }, [o, i, e, n, t]), { profile: o };
}
function SBe({
  profileId: e,
  embedId: t,
  rendererProps: i,
  customRenderer: r
}) {
  const { embedTypes: n } = Ui(), { embed: o } = Hme({ profileId: e, embedId: t, cached: !0 }), s = we(() => n == null ? void 0 : n.find((c) => c.id === (o == null ? void 0 : o.type)), [n, o]), a = r != null ? r : s == null ? void 0 : s.component;
  return o !== void 0 && a !== void 0 ? Ei(a, q({ embed: o, setEmbed: () => {
  }, mode: "view" }, i)) : null;
}
const Xme = "_selector_78vgk_1", _me = "_entity_78vgk_10", $me = "_emptyTh_78vgk_14", ege = "_pagination_78vgk_19", tge = "_embedSlotElem_78vgk_27", ige = "_customizeButton_78vgk_28", pl = {
  selector: Xme,
  entity: _me,
  emptyTh: $me,
  pagination: ege,
  embedSlotElem: tge,
  customizeButton: ige
};
function rge({
  entities: e,
  query: t,
  allowedTypes: i,
  limit: r,
  recursive: n = !1
}) {
  const [o, s] = se([]), a = we(() => e !== void 0 ? e : [], [e]), l = zT(() => {
    const c = [];
    let u = 0;
    for (; u < a.length && (r === void 0 || c.length < r); ) {
      const m = a[u];
      (!t || of(m, t, n)) && c.push(m), u += 1;
    }
    s(c);
  }, 100);
  return be(() => {
    l();
  }, [t, i, l, e]), { results: o };
}
function $x({
  viewport: e
}) {
  return {
    placement: e.md ? "right" : "bottom",
    modifiers: [
      { name: "offset", options: { offset: [0, 10] } },
      {
        name: "flip",
        options: {
          fallbackPlacements: ["bottom", "right", "left", "top"]
        }
      },
      {
        name: "preventOverflow"
      }
    ]
  };
}
function nge({
  value: e,
  onUpdate: t,
  entities: i,
  selectorVisible: r,
  setSelectorVisible: n,
  rendererElem: o,
  searchRecursive: s = !1
}) {
  const [a] = gi((x) => ({ md: x.viewport.md })), [l, c] = se(""), { results: u } = rge({ entities: i, query: l, recursive: s }), { pagItems: m, pagNav: g, pagesCount: h } = Px(u, 10, !1), [A, y] = se(null), E = ye(() => {
    n(!1);
  }, [n]);
  HT(A, E);
  const { layoutComponents: v } = Ui(), C = v.inline(void 0);
  return /* @__PURE__ */ f(Fg, { visible: r, referenceElement: o, options: $x({ viewport: a }), children: /* @__PURE__ */ V("div", { ref: y, className: pl.selector, children: [
    /* @__PURE__ */ f(kn, { size: "sm", value: l, onChange: c, placeholder: "Search..." }),
    /* @__PURE__ */ V(zx, { children: [
      /* @__PURE__ */ f("thead", { children: /* @__PURE__ */ f("tr", { children: /* @__PURE__ */ f("th", { className: pl.emptyTh }) }) }),
      /* @__PURE__ */ V("tbody", { children: [
        e !== void 0 ? /* @__PURE__ */ f(
          "tr",
          {
            className: pl.entity,
            onClick: () => {
              t && t(void 0), n(!1);
            },
            children: /* @__PURE__ */ f("td", { children: "Clear" })
          }
        ) : null,
        m.map((x) => /* @__PURE__ */ f(
          "tr",
          {
            className: pl.entity,
            onClick: () => {
              t && t({ type: x._type, id: x._identity }), n(!1);
            },
            children: /* @__PURE__ */ f("td", { children: C ? Ei(C, { entity: x }) : null })
          },
          x._identity
        ))
      ] })
    ] }),
    h > 1 && /* @__PURE__ */ f("div", { className: pl.pagination, children: g })
  ] }) });
}
function oge(l) {
  var c = l, {
    value: e,
    onUpdate: t,
    renderer: i,
    rendererExtraProps: r,
    entities: n,
    customize: o,
    className: s
  } = c, a = Fe(c, [
    "value",
    "onUpdate",
    "renderer",
    "rendererExtraProps",
    "entities",
    "customize",
    "className"
  ]);
  const [u] = gi((x) => ({ md: x.viewport.md })), [m, g] = se(null), [h, A] = se(!1), [y, E] = se(null), [v, C] = se(!1);
  return /* @__PURE__ */ V(gt, { children: [
    Ei(i, q(ee(q({
      ref: g,
      value: e,
      className: me(pl.embedSlotElem, s)
    }, a), {
      onClick: () => {
        C(!1), A((x) => !x);
      },
      children: o !== void 0 && e ? /* @__PURE__ */ f(
        Kt,
        {
          size: "sm",
          className: pl.customizeButton,
          onClick: (x) => {
            x.preventDefault(), x.stopPropagation(), A(!1), C((S) => !S);
          },
          children: /* @__PURE__ */ f(Mt, { width: 10, height: 10, icon: "icons/edit-2.svg", color: "rgb(var(--maxroll-color-white-1))" })
        }
      ) : null
    }), r)),
    /* @__PURE__ */ f(
      nge,
      {
        value: e,
        onUpdate: t,
        entities: n,
        selectorVisible: h,
        setSelectorVisible: A,
        rendererElem: m
      }
    ),
    o !== void 0 && /* @__PURE__ */ f(
      Fg,
      {
        visible: v,
        referenceElement: m,
        options: $x({ viewport: u }),
        children: /* @__PURE__ */ f("div", { ref: E, className: pl.selector, children: Ei(o, { value: e, onUpdate: t }) })
      }
    )
  ] });
}
function sge(r) {
  var n = r, {
    renderer: e,
    rendererExtraProps: t
  } = n, i = Fe(n, [
    "renderer",
    "rendererExtraProps"
  ]);
  return Ei(e, q(q({}, i), t));
}
function RBe(s) {
  var a = s, {
    mode: e,
    value: t,
    onUpdate: i,
    renderer: r,
    entities: n
  } = a, o = Fe(a, [
    "mode",
    "value",
    "onUpdate",
    "renderer",
    "entities"
  ]);
  return e === "view" ? /* @__PURE__ */ f(sge, q({ value: t, renderer: r }, o)) : /* @__PURE__ */ f(oge, q({ value: t, onUpdate: i, renderer: r, entities: n }, o));
}
const age = "_scrollBox_7vwnc_1", lge = "_headersWrapper_7vwnc_4", cge = "_headers_7vwnc_4", uge = "_header_7vwnc_4", dge = "_headerText_7vwnc_17", mge = "_headerActive_7vwnc_30", gge = "_headerInactive_7vwnc_35", hge = "_container_7vwnc_97", pge = "_tab_7vwnc_98", fge = "_visible_7vwnc_100", Do = {
  scrollBox: age,
  headersWrapper: lge,
  headers: cge,
  header: uge,
  headerText: dge,
  headerActive: mge,
  headerInactive: gge,
  "justify-between": "_justify-between_7vwnc_45",
  "equal-spacing": "_equal-spacing_7vwnc_50",
  "scrollBox--default": "_scrollBox--default_7vwnc_66",
  "scrollBox--simple": "_scrollBox--simple_7vwnc_93",
  container: hge,
  tab: pge,
  visible: fge
}, Age = (e, t) => {
  const [i, r] = se(void 0);
  return be(() => {
    const n = () => {
      if (!e.current)
        return;
      const o = e.current.scrollWidth > e.current.clientWidth;
      r(o), t && t(o);
    };
    return n(), window.addEventListener("resize", n), () => {
      window.removeEventListener("resize", n);
    };
  }, [t, e]), i;
};
function yge(e, t = !1) {
  let i = getComputedStyle(e);
  const r = i.position === "absolute", n = t ? /(auto|scroll|hidden)/ : /(auto|scroll)/;
  if (i.position === "fixed")
    return document.body;
  let o = e;
  for (; o = o.parentElement; ) {
    if (o === null)
      return;
    if (i = getComputedStyle(o), !(r && i.position === "static") && n.test(i.overflow + i.overflowY + i.overflowX))
      return o;
  }
  return document.body;
}
function Ege({
  scrollOnTabChange: e,
  elem: t
}) {
  if (e && t) {
    const { disableMobileAnimation: i, type: r, leftOffset: n, topOffset: o } = e, s = i === !0 ? window.innerWidth >= 768 ? "smooth" : "instant" : "smooth", a = t.getBoundingClientRect(), l = yge(t);
    if (l) {
      const c = l.getBoundingClientRect();
      let u = a.left - c.left + l.scrollLeft;
      if (r === "center" && (u = u - (c.width - a.width) / 2), n !== void 0 && l.scrollTo({
        left: u - (n || 0),
        behavior: s
      }), o !== void 0) {
        const m = a.top + window.scrollY;
        window.scrollTo({
          top: m - (o || 0),
          behavior: s
        });
      }
    } else
      t.scrollIntoView({
        behavior: s,
        inline: "center",
        block: "start"
      });
  }
}
function eF({ selector: e, isActive: t }) {
  return typeof e == "function" ? e({ isActive: t }) : e;
}
function eI({
  tabs: e,
  sideTabs: t,
  initialTab: i = 0,
  headerSpacing: r = { type: "fixed", value: 80 },
  onTabClick: n = void 0,
  scrollOnTabChange: o,
  headersClassName: s,
  containerClassName: a,
  tabsStyle: l = "default"
}) {
  const [c, u] = se(i), m = Ne({});
  be(() => {
    u(i);
  }, [i]);
  const g = ye(
    (h) => {
      const A = h < e.length ? e[h] : t == null ? void 0 : t[h];
      (!A || A && !A.disableTabChange) && u(h), A != null && A.onTabClick && A.onTabClick(h), n && n(h), Ege({ scrollOnTabChange: o, elem: m.current[h] });
    },
    [n, o, t, e]
  );
  return /* @__PURE__ */ V(gt, { children: [
    /* @__PURE__ */ f(
      Pr,
      {
        className: me(Do.scrollBox, Do[`scrollBox--${l}`], s),
        type: "horizontal",
        children: /* @__PURE__ */ f("div", { className: Do.headersWrapper, style: { gap: r.value }, children: [e, t].map(
          (h, A) => h ? /* @__PURE__ */ f(
            "div",
            {
              style: { gap: r.value },
              className: me(Do.headers, Do[r.type]),
              children: h.map((y, E) => {
                const v = E + A * e.length;
                return /* @__PURE__ */ f(
                  "div",
                  {
                    ref: (C) => {
                      C && (m.current[v] = C);
                    },
                    className: me(
                      Do.header,
                      v === c ? Do.headerActive : Do.headerInactive
                    ),
                    onClick: () => {
                      g(v);
                    },
                    children: /* @__PURE__ */ f("span", { className: me(Do.headerText), children: /* @__PURE__ */ f(eF, { selector: y.selector, isActive: v === c }) })
                  },
                  v
                );
              })
            },
            A
          ) : null
        ) })
      }
    ),
    /* @__PURE__ */ f("div", { className: me(Do.container, a), children: [e, t].map(
      (h, A) => h ? h.map((y, E) => {
        const v = E + A * e.length;
        return /* @__PURE__ */ f("div", { className: me(Do.tab, v === c ? Do.visible : void 0), children: y.content }, v);
      }) : null
    ) })
  ] });
}
function tF(e) {
  var t, i, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var n = e.length;
      for (t = 0; t < n; t++)
        e[t] && (i = tF(e[t])) && (r && (r += " "), r += i);
    } else
      for (i in e)
        e[i] && (r && (r += " "), r += i);
  return r;
}
function Fc() {
  for (var e, t, i = 0, r = "", n = arguments.length; i < n; i++)
    (e = arguments[i]) && (t = tF(e)) && (r && (r += " "), r += t);
  return r;
}
var Vg = (e) => typeof e == "number" && !isNaN(e), zc = (e) => typeof e == "string", Fa = (e) => typeof e == "function", vge = (e) => zc(e) || Vg(e), dC = (e) => zc(e) || Fa(e) ? e : null, bge = (e, t) => e === !1 || Vg(e) && e > 0 ? e : t, mC = (e) => ug(e) || zc(e) || Fa(e) || Vg(e);
function Cge(e, t, i = 300) {
  let { scrollHeight: r, style: n } = e;
  requestAnimationFrame(() => {
    n.minHeight = "initial", n.height = r + "px", n.transition = `all ${i}ms`, requestAnimationFrame(() => {
      n.height = "0", n.padding = "0", n.margin = "0", setTimeout(t, i);
    });
  });
}
function xge({ enter: e, exit: t, appendPosition: i = !1, collapse: r = !0, collapseDuration: n = 300 }) {
  return function({ children: o, position: s, preventExitTransition: a, done: l, nodeRef: c, isIn: u, playToast: m }) {
    let g = i ? `${e}--${s}` : e, h = i ? `${t}--${s}` : t, A = Ne(0);
    return B0(() => {
      let y = c.current, E = g.split(" "), v = (C) => {
        C.target === c.current && (m(), y.removeEventListener("animationend", v), y.removeEventListener("animationcancel", v), A.current === 0 && C.type !== "animationcancel" && y.classList.remove(...E));
      };
      y.classList.add(...E), y.addEventListener("animationend", v), y.addEventListener("animationcancel", v);
    }, []), be(() => {
      let y = c.current, E = () => {
        y.removeEventListener("animationend", E), r ? Cge(y, l, n) : l();
      };
      u || (a ? E() : (A.current = 1, y.className += ` ${h}`, y.addEventListener("animationend", E)));
    }, [u]), X.createElement(X.Fragment, null, o);
  };
}
function E6(e, t) {
  return { content: iF(e.content, e.props), containerId: e.props.containerId, id: e.props.toastId, theme: e.props.theme, type: e.props.type, data: e.props.data || {}, isLoading: e.props.isLoading, icon: e.props.icon, reason: e.removalReason, status: t };
}
function iF(e, t, i = !1) {
  return ug(e) && !zc(e.type) ? dg(e, { closeToast: t.closeToast, toastProps: t, data: t.data, isPaused: i }) : Fa(e) ? e({ closeToast: t.closeToast, toastProps: t, data: t.data, isPaused: i }) : e;
}
function Ige({ closeToast: e, theme: t, ariaLabel: i = "close" }) {
  return X.createElement("button", { className: `Toastify__close-button Toastify__close-button--${t}`, type: "button", onClick: (r) => {
    r.stopPropagation(), e(!0);
  }, "aria-label": i }, X.createElement("svg", { "aria-hidden": "true", viewBox: "0 0 14 16" }, X.createElement("path", { fillRule: "evenodd", d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z" })));
}
function Sge({ delay: e, isRunning: t, closeToast: i, type: r = "default", hide: n, className: o, controlledProgress: s, progress: a, rtl: l, isIn: c, theme: u }) {
  let m = n || s && a === 0, g = { animationDuration: `${e}ms`, animationPlayState: t ? "running" : "paused" };
  s && (g.transform = `scaleX(${a})`);
  let h = Fc("Toastify__progress-bar", s ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${u}`, `Toastify__progress-bar--${r}`, { "Toastify__progress-bar--rtl": l }), A = Fa(o) ? o({ rtl: l, type: r, defaultClassName: h }) : Fc(h, o), y = { [s && a >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: s && a < 1 ? null : () => {
    c && i();
  } };
  return X.createElement("div", { className: "Toastify__progress-bar--wrp", "data-hidden": m }, X.createElement("div", { className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${u} Toastify__progress-bar--${r}` }), X.createElement("div", q({ role: "progressbar", "aria-hidden": m ? "true" : "false", "aria-label": "notification timer", className: A, style: g }, y)));
}
var Rge = 1, rF = () => `${Rge++}`;
function kge(e, t, i) {
  let r = 1, n = 0, o = [], s = [], a = t, l = /* @__PURE__ */ new Map(), c = /* @__PURE__ */ new Set(), u = (C) => (c.add(C), () => c.delete(C)), m = () => {
    s = Array.from(l.values()), c.forEach((C) => C());
  }, g = ({ containerId: C, toastId: x, updateId: S }) => {
    let R = C ? C !== e : e !== 1, w = l.has(x) && S == null;
    return R || w;
  }, h = (C, x) => {
    l.forEach((S) => {
      var R;
      (x == null || x === S.props.toastId) && ((R = S.toggle) == null || R.call(S, C));
    });
  }, A = (C) => {
    var x, S;
    (S = (x = C.props) == null ? void 0 : x.onClose) == null || S.call(x, C.removalReason), C.isActive = !1;
  }, y = (C) => {
    if (C == null)
      l.forEach(A);
    else {
      let x = l.get(C);
      x && A(x);
    }
    m();
  }, E = () => {
    n -= o.length, o = [];
  }, v = (C) => {
    var x, S;
    let { toastId: R, updateId: w } = C.props, T = w == null;
    C.staleId && l.delete(C.staleId), C.isActive = !0, l.set(R, C), m(), i(E6(C, T ? "added" : "updated")), T && ((S = (x = C.props).onOpen) == null || S.call(x));
  };
  return { id: e, props: a, observe: u, toggle: h, removeToast: y, toasts: l, clearQueue: E, buildToast: (C, x) => {
    if (g(x))
      return;
    let { toastId: S, updateId: R, data: w, staleId: T, delay: N } = x, D = R == null;
    D && n++;
    let O = ee(q(ee(q({}, a), { style: a.toastStyle, key: r++ }), Object.fromEntries(Object.entries(x).filter(([Y, P]) => P != null))), { toastId: S, updateId: R, data: w, isIn: !1, className: dC(x.className || a.toastClassName), progressClassName: dC(x.progressClassName || a.progressClassName), autoClose: x.isLoading ? !1 : bge(x.autoClose, a.autoClose), closeToast(Y) {
      l.get(S).removalReason = Y, y(S);
    }, deleteToast() {
      let Y = l.get(S);
      if (Y != null) {
        if (i(E6(Y, "removed")), l.delete(S), n--, n < 0 && (n = 0), o.length > 0) {
          v(o.shift());
          return;
        }
        m();
      }
    } });
    O.closeButton = a.closeButton, x.closeButton === !1 || mC(x.closeButton) ? O.closeButton = x.closeButton : x.closeButton === !0 && (O.closeButton = mC(a.closeButton) ? a.closeButton : !0);
    let F = { content: C, props: O, staleId: T };
    a.limit && a.limit > 0 && n > a.limit && D ? o.push(F) : Vg(N) ? setTimeout(() => {
      v(F);
    }, N) : v(F);
  }, setProps(C) {
    a = C;
  }, setToggle: (C, x) => {
    let S = l.get(C);
    S && (S.toggle = x);
  }, isToastActive: (C) => {
    var x;
    return (x = l.get(C)) == null ? void 0 : x.isActive;
  }, getSnapshot: () => s };
}
var Rn = /* @__PURE__ */ new Map(), eg = [], gC = /* @__PURE__ */ new Set(), wge = (e) => gC.forEach((t) => t(e)), nF = () => Rn.size > 0;
function Mge() {
  eg.forEach((e) => sF(e.content, e.options)), eg = [];
}
var Nge = (e, { containerId: t }) => {
  var i;
  return (i = Rn.get(t || 1)) == null ? void 0 : i.toasts.get(e);
};
function oF(e, t) {
  var i;
  if (t)
    return !!((i = Rn.get(t)) != null && i.isToastActive(e));
  let r = !1;
  return Rn.forEach((n) => {
    n.isToastActive(e) && (r = !0);
  }), r;
}
function Tge(e) {
  if (!nF()) {
    eg = eg.filter((t) => e != null && t.options.toastId !== e);
    return;
  }
  if (e == null || vge(e))
    Rn.forEach((t) => {
      t.removeToast(e);
    });
  else if (e && ("containerId" in e || "id" in e)) {
    let t = Rn.get(e.containerId);
    t ? t.removeToast(e.id) : Rn.forEach((i) => {
      i.removeToast(e.id);
    });
  }
}
var Bge = (e = {}) => {
  Rn.forEach((t) => {
    t.props.limit && (!e.containerId || t.id === e.containerId) && t.clearQueue();
  });
};
function sF(e, t) {
  mC(e) && (nF() || eg.push({ content: e, options: t }), Rn.forEach((i) => {
    i.buildToast(e, t);
  }));
}
function Dge(e) {
  var t;
  (t = Rn.get(e.containerId || 1)) == null || t.setToggle(e.id, e.fn);
}
function aF(e, t) {
  Rn.forEach((i) => {
    (t == null || !(t != null && t.containerId) || (t == null ? void 0 : t.containerId) === i.id) && i.toggle(e, t == null ? void 0 : t.id);
  });
}
function Oge(e) {
  let t = e.containerId || 1;
  return { subscribe(i) {
    let r = kge(t, e, wge);
    Rn.set(t, r);
    let n = r.observe(i);
    return Mge(), () => {
      n(), Rn.delete(t);
    };
  }, setProps(i) {
    var r;
    (r = Rn.get(t)) == null || r.setProps(i);
  }, getSnapshot() {
    var i;
    return (i = Rn.get(t)) == null ? void 0 : i.getSnapshot();
  } };
}
function Fge(e) {
  return gC.add(e), () => {
    gC.delete(e);
  };
}
function Vge(e) {
  return e && (zc(e.toastId) || Vg(e.toastId)) ? e.toastId : rF();
}
function qg(e, t) {
  return sF(e, t), t.toastId;
}
function jf(e, t) {
  return ee(q({}, t), { type: t && t.type || e, toastId: Vge(t) });
}
function Lf(e) {
  return (t, i) => qg(t, jf(e, i));
}
function _t(e, t) {
  return qg(e, jf("default", t));
}
_t.loading = (e, t) => qg(e, jf("default", q({ isLoading: !0, autoClose: !1, closeOnClick: !1, closeButton: !1, draggable: !1 }, t)));
function qge(e, { pending: t, error: i, success: r }, n) {
  let o;
  t && (o = zc(t) ? _t.loading(t, n) : _t.loading(t.render, q(q({}, n), t)));
  let s = { isLoading: null, autoClose: null, closeOnClick: null, closeButton: null, draggable: null }, a = (c, u, m) => {
    if (u == null) {
      _t.dismiss(o);
      return;
    }
    let g = ee(q(q({ type: c }, s), n), { data: m }), h = zc(u) ? { render: u } : u;
    return o ? _t.update(o, q(q({}, g), h)) : _t(h.render, q(q({}, g), h)), m;
  }, l = Fa(e) ? e() : e;
  return l.then((c) => a("success", r, c)).catch((c) => a("error", i, c)), l;
}
_t.promise = qge;
_t.success = Lf("success");
_t.info = Lf("info");
_t.error = Lf("error");
_t.warning = Lf("warning");
_t.warn = _t.warning;
_t.dark = (e, t) => qg(e, jf("default", q({ theme: "dark" }, t)));
function jge(e) {
  Tge(e);
}
_t.dismiss = jge;
_t.clearWaitingQueue = Bge;
_t.isActive = oF;
_t.update = (e, t = {}) => {
  let i = Nge(e, t);
  if (i) {
    let { props: r, content: n } = i, o = ee(q(q({ delay: 100 }, r), t), { toastId: t.toastId || e, updateId: rF() });
    o.toastId !== e && (o.staleId = e);
    let s = o.render || n;
    delete o.render, qg(s, o);
  }
};
_t.done = (e) => {
  _t.update(e, { progress: 1 });
};
_t.onChange = Fge;
_t.play = (e) => aF(!0, e);
_t.pause = (e) => aF(!1, e);
function Lge(e) {
  var t;
  let { subscribe: i, getSnapshot: r, setProps: n } = Ne(Oge(e)).current;
  n(e);
  let o = (t = MW(i, r, r)) == null ? void 0 : t.slice();
  function s(a) {
    if (!o)
      return [];
    let l = /* @__PURE__ */ new Map();
    return e.newestOnTop && o.reverse(), o.forEach((c) => {
      let { position: u } = c.props;
      l.has(u) || l.set(u, []), l.get(u).push(c);
    }), Array.from(l, (c) => a(c[0], c[1]));
  }
  return { getToastToRender: s, isToastActive: oF, count: o == null ? void 0 : o.length };
}
function Kge(e) {
  let [t, i] = se(!1), [r, n] = se(!1), o = Ne(null), s = Ne({ start: 0, delta: 0, removalDistance: 0, canCloseOnClick: !0, canDrag: !1, didMove: !1 }).current, { autoClose: a, pauseOnHover: l, closeToast: c, onClick: u, closeOnClick: m } = e;
  Dge({ id: e.toastId, containerId: e.containerId, fn: i }), be(() => {
    if (e.pauseOnFocusLoss)
      return g(), () => {
        h();
      };
  }, [e.pauseOnFocusLoss]);
  function g() {
    document.hasFocus() || v(), window.addEventListener("focus", E), window.addEventListener("blur", v);
  }
  function h() {
    window.removeEventListener("focus", E), window.removeEventListener("blur", v);
  }
  function A(T) {
    if (e.draggable === !0 || e.draggable === T.pointerType) {
      C();
      let N = o.current;
      s.canCloseOnClick = !0, s.canDrag = !0, N.style.transition = "none", e.draggableDirection === "x" ? (s.start = T.clientX, s.removalDistance = N.offsetWidth * (e.draggablePercent / 100)) : (s.start = T.clientY, s.removalDistance = N.offsetHeight * (e.draggablePercent === 80 ? e.draggablePercent * 1.5 : e.draggablePercent) / 100);
    }
  }
  function y(T) {
    let { top: N, bottom: D, left: O, right: F } = o.current.getBoundingClientRect();
    T.nativeEvent.type !== "touchend" && e.pauseOnHover && T.clientX >= O && T.clientX <= F && T.clientY >= N && T.clientY <= D ? v() : E();
  }
  function E() {
    i(!0);
  }
  function v() {
    i(!1);
  }
  function C() {
    s.didMove = !1, document.addEventListener("pointermove", S), document.addEventListener("pointerup", R);
  }
  function x() {
    document.removeEventListener("pointermove", S), document.removeEventListener("pointerup", R);
  }
  function S(T) {
    let N = o.current;
    if (s.canDrag && N) {
      s.didMove = !0, t && v(), e.draggableDirection === "x" ? s.delta = T.clientX - s.start : s.delta = T.clientY - s.start, s.start !== T.clientX && (s.canCloseOnClick = !1);
      let D = e.draggableDirection === "x" ? `${s.delta}px, var(--y)` : `0, calc(${s.delta}px + var(--y))`;
      N.style.transform = `translate3d(${D},0)`, N.style.opacity = `${1 - Math.abs(s.delta / s.removalDistance)}`;
    }
  }
  function R() {
    x();
    let T = o.current;
    if (s.canDrag && s.didMove && T) {
      if (s.canDrag = !1, Math.abs(s.delta) > s.removalDistance) {
        n(!0), e.closeToast(!0), e.collapseAll();
        return;
      }
      T.style.transition = "transform 0.2s, opacity 0.2s", T.style.removeProperty("transform"), T.style.removeProperty("opacity");
    }
  }
  let w = { onPointerDown: A, onPointerUp: y };
  return a && l && (w.onMouseEnter = v, e.stacked || (w.onMouseLeave = E)), m && (w.onClick = (T) => {
    u && u(T), s.canCloseOnClick && c(!0);
  }), { playToast: E, pauseToast: v, isRunning: t, preventExitTransition: r, toastRef: o, eventHandlers: w };
}
var Yge = typeof window != "undefined" ? B0 : be, Kf = (n) => {
  var o = n, { theme: e, type: t, isLoading: i } = o, r = Fe(o, ["theme", "type", "isLoading"]);
  return X.createElement("svg", q({ viewBox: "0 0 24 24", width: "100%", height: "100%", fill: e === "colored" ? "currentColor" : `var(--toastify-icon-color-${t})` }, r));
};
function Uge(e) {
  return X.createElement(Kf, q({}, e), X.createElement("path", { d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z" }));
}
function Gge(e) {
  return X.createElement(Kf, q({}, e), X.createElement("path", { d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z" }));
}
function Qge(e) {
  return X.createElement(Kf, q({}, e), X.createElement("path", { d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z" }));
}
function Wge(e) {
  return X.createElement(Kf, q({}, e), X.createElement("path", { d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z" }));
}
function Zge() {
  return X.createElement("div", { className: "Toastify__spinner" });
}
var hC = { info: Gge, warning: Uge, success: Qge, error: Wge, spinner: Zge }, Jge = (e) => e in hC;
function Pge({ theme: e, type: t, isLoading: i, icon: r }) {
  let n = null, o = { theme: e, type: t };
  return r === !1 || (Fa(r) ? n = r(ee(q({}, o), { isLoading: i })) : ug(r) ? n = dg(r, o) : i ? n = hC.spinner() : Jge(t) && (n = hC[t](o))), n;
}
var zge = (e) => {
  let { isRunning: t, preventExitTransition: i, toastRef: r, eventHandlers: n, playToast: o } = Kge(e), { closeButton: s, children: a, autoClose: l, onClick: c, type: u, hideProgressBar: m, closeToast: g, transition: h, position: A, className: y, style: E, progressClassName: v, updateId: C, role: x, progress: S, rtl: R, toastId: w, deleteToast: T, isIn: N, isLoading: D, closeOnClick: O, theme: F, ariaLabel: Y } = e, P = Fc("Toastify__toast", `Toastify__toast-theme--${F}`, `Toastify__toast--${u}`, { "Toastify__toast--rtl": R }, { "Toastify__toast--close-on-click": O }), z = Fa(y) ? y({ rtl: R, position: A, type: u, defaultClassName: P }) : Fc(P, y), W = Pge(e), H = !!S || !l, Q = { closeToast: g, type: u, theme: F }, $ = null;
  return s === !1 || (Fa(s) ? $ = s(Q) : ug(s) ? $ = dg(s, Q) : $ = Ige(Q)), X.createElement(h, { isIn: N, done: T, position: A, preventExitTransition: i, nodeRef: r, playToast: o }, X.createElement("div", q(ee(q({ id: w, tabIndex: 0, onClick: c, "data-in": N, className: z }, n), { style: E, ref: r }), N && { role: x, "aria-label": Y }), W != null && X.createElement("div", { className: Fc("Toastify__toast-icon", { "Toastify--animate-icon Toastify__zoom-enter": !D }) }, W), iF(a, e, !t), $, !e.customProgressBar && X.createElement(Sge, ee(q({}, C && !H ? { key: `p-${C}` } : {}), { rtl: R, theme: F, delay: l, isRunning: t, isIn: N, closeToast: g, hide: m, type: u, className: v, controlledProgress: H, progress: S || 0 }))));
}, Hge = (e, t = !1) => ({ enter: `Toastify--animate Toastify__${e}-enter`, exit: `Toastify--animate Toastify__${e}-exit`, appendPosition: t }), Xge = xge(Hge("bounce", !0)), _ge = { position: "top-right", transition: Xge, autoClose: 5e3, closeButton: !0, pauseOnHover: !0, pauseOnFocusLoss: !0, draggable: "touch", draggablePercent: 80, draggableDirection: "x", role: "alert", theme: "light", "aria-label": "Notifications Alt+T", hotKeys: (e) => e.altKey && e.code === "KeyT" };
function $ge(e) {
  let t = q(q({}, _ge), e), i = e.stacked, [r, n] = se(!0), o = Ne(null), { getToastToRender: s, isToastActive: a, count: l } = Lge(t), { className: c, style: u, rtl: m, containerId: g, hotKeys: h } = t;
  function A(E) {
    let v = Fc("Toastify__toast-container", `Toastify__toast-container--${E}`, { "Toastify__toast-container--rtl": m });
    return Fa(c) ? c({ position: E, rtl: m, defaultClassName: v }) : Fc(v, dC(c));
  }
  function y() {
    i && (n(!0), _t.play());
  }
  return Yge(() => {
    var E;
    if (i) {
      let v = o.current.querySelectorAll('[data-in="true"]'), C = 12, x = (E = t.position) == null ? void 0 : E.includes("top"), S = 0, R = 0;
      Array.from(v).reverse().forEach((w, T) => {
        let N = w;
        N.classList.add("Toastify__toast--stacked"), T > 0 && (N.dataset.collapsed = `${r}`), N.dataset.pos || (N.dataset.pos = x ? "top" : "bot");
        let D = S * (r ? 0.2 : 1) + (r ? 0 : C * T);
        N.style.setProperty("--y", `${x ? D : D * -1}px`), N.style.setProperty("--g", `${C}`), N.style.setProperty("--s", `${1 - (r ? R : 0)}`), S += N.offsetHeight, R += 0.025;
      });
    }
  }, [r, l, i]), be(() => {
    function E(v) {
      var C;
      let x = o.current;
      h(v) && ((C = x.querySelector('[tabIndex="0"]')) == null || C.focus(), n(!1), _t.pause()), v.key === "Escape" && (document.activeElement === x || x != null && x.contains(document.activeElement)) && (n(!0), _t.play());
    }
    return document.addEventListener("keydown", E), () => {
      document.removeEventListener("keydown", E);
    };
  }, [h]), X.createElement("section", { ref: o, className: "Toastify", id: g, onMouseEnter: () => {
    i && (n(!1), _t.pause());
  }, onMouseLeave: y, "aria-live": "polite", "aria-atomic": "false", "aria-relevant": "additions text", "aria-label": t["aria-label"] }, s((E, v) => {
    let C = v.length ? q({}, u) : ee(q({}, u), { pointerEvents: "none" });
    return X.createElement("div", { tabIndex: -1, className: A(E), "data-stacked": i, style: C, key: `c-${E}` }, v.map(({ content: x, props: S }) => X.createElement(zge, ee(q({}, S), { stacked: i, collapseAll: y, isIn: a(S.toastId, S.containerId), key: `t-${S.key}` }), x)));
  }));
}
const ehe = {
  stacked: !1,
  position: "top-right"
}, c0 = {
  theme: "dark",
  autoClose: 5e3,
  pauseOnHover: !0,
  pauseOnFocusLoss: !0,
  hideProgressBar: !0,
  type: "info"
}, the = {
  success: `${fi().assetPath}/images/icons/success-icon.svg`,
  warning: `${fi().assetPath}/images/icons/warning-icon.svg`,
  error: `${fi().assetPath}/images/icons/error.svg`,
  default: void 0,
  info: `${fi().assetPath}/images/icons/info.svg`
}, lF = (e) => {
  const t = sn(cF);
  if (!t)
    throw new Error("notificationStoreContext must be use within NotificationStoreProvider");
  return DW(t, e);
}, ihe = "_CloseButton_1dgms_1", rhe = "_CloseButton__iconContainer_1dgms_7", v6 = {
  CloseButton: ihe,
  CloseButton__iconContainer: rhe
}, nhe = NW(({ closeToast: e }) => /* @__PURE__ */ f("div", { className: v6.CloseButton, children: /* @__PURE__ */ f("div", { className: v6.CloseButton__iconContainer, onClick: e, children: /* @__PURE__ */ f(Mt, { icon: "clear.svg", width: 12, height: 12, color: "rgb(var(--maxroll-color-white-1))" }) }) })), ohe = "_LoadingSpinner_h6tec_1", she = "_LoadingSpinner__spinner_h6tec_7", b6 = {
  LoadingSpinner: ohe,
  LoadingSpinner__spinner: she,
  "maxroll-loader-rotation": "_maxroll-loader-rotation_h6tec_1"
}, ahe = ({ width: e, height: t, color: i, lineWidth: r }) => {
  const n = {
    width: e ? `${e}px` : "20px",
    height: t ? `${t}px` : "20px",
    borderColor: i || "#FFFFFF transparent",
    borderWidth: r ? `${r}px` : "2px"
  };
  return /* @__PURE__ */ f("div", { className: b6.LoadingSpinner, children: /* @__PURE__ */ f("span", { className: b6.LoadingSpinner__spinner, style: n }) });
}, lhe = "_NotificationIcon_1r4xd_1", C6 = {
  NotificationIcon: lhe
}, che = ({ type: e, isLoading: t, width: i, height: r }) => {
  const n = the[e];
  return t ? (() => /* @__PURE__ */ f("div", { className: C6.NotificationIcon, children: /* @__PURE__ */ f(
    ahe,
    {
      color: "rgb(var(--maxroll-color-white-1)) rgb(var(--maxroll-color-grey-3)) rgb(var(--maxroll-color-grey-3)) rgb(var(--maxroll-color-grey-3))"
    }
  ) }))() : (() => n && /* @__PURE__ */ f("div", { className: C6.NotificationIcon, children: /* @__PURE__ */ f("img", { src: n, alt: `${e} notification icon`, width: i != null ? i : 20, height: r != null ? r : 20 }) }))();
}, uhe = "_NotificationContainer__notification_1gip3_1", dhe = {
  NotificationContainer__notification: uhe
}, mhe = ({ config: e }) => /* @__PURE__ */ f(
  $ge,
  ee(q({}, e), {
    toastClassName: dhe.NotificationContainer__notification,
    icon: che,
    closeButton: nhe
  })
), ghe = () => {
  const e = lF((i) => i.defaultContainer), t = we(
    () => q(q({}, ehe), e),
    [e]
  );
  return /* @__PURE__ */ f(mhe, { config: t });
};
function hhe(e, t) {
  let i;
  try {
    i = e();
  } catch (n) {
    return;
  }
  return {
    getItem: (n) => {
      var o;
      const s = (l) => l === null ? null : JSON.parse(l, t == null ? void 0 : t.reviver), a = (o = i.getItem(n)) != null ? o : null;
      return a instanceof Promise ? a.then(s) : s(a);
    },
    setItem: (n, o) => i.setItem(
      n,
      JSON.stringify(o, t == null ? void 0 : t.replacer)
    ),
    removeItem: (n) => i.removeItem(n)
  };
}
const pC = (e) => (t) => {
  try {
    const i = e(t);
    return i instanceof Promise ? i : {
      then(r) {
        return pC(r)(i);
      },
      catch(r) {
        return this;
      }
    };
  } catch (i) {
    return {
      then(r) {
        return this;
      },
      catch(r) {
        return pC(r)(i);
      }
    };
  }
}, phe = (e, t) => (i, r, n) => {
  let o = q({
    storage: hhe(() => localStorage),
    partialize: (y) => y,
    version: 0,
    merge: (y, E) => q(q({}, E), y)
  }, t), s = !1;
  const a = /* @__PURE__ */ new Set(), l = /* @__PURE__ */ new Set();
  let c = o.storage;
  if (!c)
    return e(
      (...y) => {
        console.warn(
          `[zustand persist middleware] Unable to update item '${o.name}', the given storage is currently unavailable.`
        ), i(...y);
      },
      r,
      n
    );
  const u = () => {
    const y = o.partialize(q({}, r()));
    return c.setItem(o.name, {
      state: y,
      version: o.version
    });
  }, m = n.setState;
  n.setState = (y, E) => {
    m(y, E), u();
  };
  const g = e(
    (...y) => {
      i(...y), u();
    },
    r,
    n
  );
  n.getInitialState = () => g;
  let h;
  const A = () => {
    var y, E;
    if (!c)
      return;
    s = !1, a.forEach((C) => {
      var x;
      return C((x = r()) != null ? x : g);
    });
    const v = ((E = o.onRehydrateStorage) == null ? void 0 : E.call(o, (y = r()) != null ? y : g)) || void 0;
    return pC(c.getItem.bind(c))(o.name).then((C) => {
      if (C)
        if (typeof C.version == "number" && C.version !== o.version) {
          if (o.migrate) {
            const x = o.migrate(
              C.state,
              C.version
            );
            return x instanceof Promise ? x.then((S) => [!0, S]) : [!0, x];
          }
          console.error(
            "State loaded from storage couldn't be migrated since no migrate function was provided"
          );
        } else
          return [!1, C.state];
      return [!1, void 0];
    }).then((C) => {
      var x;
      const [S, R] = C;
      if (h = o.merge(
        R,
        (x = r()) != null ? x : g
      ), i(h, !0), S)
        return u();
    }).then(() => {
      v == null || v(h, void 0), h = r(), s = !0, l.forEach((C) => C(h));
    }).catch((C) => {
      v == null || v(void 0, C);
    });
  };
  return n.persist = {
    setOptions: (y) => {
      o = q(q({}, o), y), y.storage && (c = y.storage);
    },
    clearStorage: () => {
      c == null || c.removeItem(o.name);
    },
    getOptions: () => o,
    rehydrate: () => A(),
    hasHydrated: () => s,
    onHydrate: (y) => (a.add(y), () => {
      a.delete(y);
    }),
    onFinishHydration: (y) => (l.add(y), () => {
      l.delete(y);
    })
  }, o.skipHydration || A(), h || g;
}, fhe = phe, x6 = (e) => {
  switch (e) {
    case "info":
      return "--maxroll-color-blue";
    case "success":
      return "--maxroll-color-green";
    case "warning":
      return "--maxroll-color-orange";
    case "error":
      return "--maxroll-color-red";
    default:
      return;
  }
};
const Ahe = "_Notification_1y59r_1", yhe = "_Notification__content_1y59r_9", Ehe = "_Notification__action_1y59r_13", qE = {
  Notification: Ahe,
  Notification__content: yhe,
  Notification__action: Ehe
};
function vhe(e) {
  const { content: t, data: i, action: r, closeToast: n } = e, o = we(
    () => ({
      data: i,
      closeToast: n
    }),
    [i, n]
  );
  return /* @__PURE__ */ V("div", { className: qE.Notification, children: [
    /* @__PURE__ */ f("div", { className: qE.Notification__content, children: typeof t == "function" ? t(o) : t }),
    r && /* @__PURE__ */ f("div", { className: qE.Notification__action, children: typeof r == "function" ? r(o) : r })
  ] });
}
function Hp({ content: e, action: t }) {
  return (i) => /* @__PURE__ */ f(vhe, ee(q({}, i), { content: e, action: t }));
}
const kBe = {
  MAXROLL: "maxroll",
  POEXCHANGE: "poexchange"
}, wBe = {
  POE: "poe",
  POE2: "poe2"
}, MBe = {
  MARKED_AS_READ: "markedAsRead",
  MARKED_ALL_AS_READ: "markedAllAsRead",
  REMOVED: "removed",
  REMOVED_ALL: "removedAll",
  REMOVED_READ: "removedRead"
}, bhe = (e) => {
  const t = {};
  return Promise.race([e, t]).then(
    (i) => i === t ? "pending" : "fulfilled",
    () => "rejected"
  );
}, Che = () => {
  const e = {
    notifications: [],
    activeNotifications: [],
    activePromises: [],
    notificationsToDisplay: [],
    defaultContainer: {
      containerId: "body-wrapper",
      stacked: !1,
      position: "top-right"
    },
    displayBlocked: !1,
    maxActiveToasts: 4,
    activeEventListeners: {
      markedAsRead: [],
      markedAllAsRead: [],
      removed: [],
      removedAll: [],
      removedRead: []
    }
  };
  return OW()(
    fhe(
      (t, i) => ee(q({}, e), {
        addNotification: (r, n) => {
          var z, W, H;
          const P = n || {}, {
            notificationId: o,
            toastId: s,
            type: a,
            read: l,
            display: c,
            store: u,
            createdAt: m,
            action: g,
            app: h,
            game: A,
            notificationCenter: y
          } = P, E = Fe(P, [
            "notificationId",
            "toastId",
            "type",
            "read",
            "display",
            "store",
            "createdAt",
            "action",
            "app",
            "game",
            "notificationCenter"
          ]), v = s != null ? s : go(), C = o != null ? o : go(), x = i();
          if (v && x.notifications.some((Q) => {
            var $;
            return (($ = Q.options) == null ? void 0 : $.toastId) === v && !Q.displayed;
          })) {
            console.warn(`Notification with id ${v} is already displayed`);
            return;
          }
          const S = a != null ? a : c0.type, R = u != null ? u : !0, w = (c != null ? c : !0) && !l && !x.displayBlocked && r, T = x6(S), N = ee(q(ee(q({}, c0), {
            style: T ? {
              background: `linear-gradient(to right, transparent 50%, rgba(var(${T}), 0.3) 100%)`
            } : void 0
          }), E), {
            toastId: v,
            type: S,
            containerId: (z = E.containerId) != null ? z : x.defaultContainer.containerId
          });
          let D = x.notificationsToDisplay;
          const O = {
            id: C,
            type: S,
            content: r,
            options: N,
            read: l != null ? l : !1,
            displayed: !w,
            store: R,
            createdAt: m != null ? m : (/* @__PURE__ */ new Date()).getTime(),
            action: g,
            app: h,
            game: A,
            notificationCenter: R ? {
              content: (W = y == null ? void 0 : y.content) != null ? W : typeof r == "function" ? r({ data: n == null ? void 0 : n.data, closeToast: () => {
              } }) : r,
              actions: (H = y == null ? void 0 : y.actions) != null ? H : typeof g == "function" ? g({ data: n == null ? void 0 : n.data, closeToast: () => {
              } }) : g,
              bottomAction: y == null ? void 0 : y.bottomAction,
              hideDeleteButton: y == null ? void 0 : y.hideDeleteButton
            } : void 0
          }, F = [O, ...x.notifications].sort(
            (Q, $) => new Date($.createdAt).getTime() - new Date(Q.createdAt).getTime()
          ), Y = [];
          return w && (x.activeNotifications.length < x.maxActiveToasts ? Y.push(O) : D = [...D, O.id]), t({ notifications: F, notificationsToDisplay: D }), Y.forEach((Q) => {
            i().showToast(Q);
          }), O;
        },
        composedonOpen: (r) => {
          var n, o;
          i().handleToastOpen(r.id), (o = (n = r.options) == null ? void 0 : n.onOpen) == null || o.call(n);
        },
        composedonClose: (r, n) => {
          var o, s;
          i().handleToastClose(r.id, n), n && i().markAsRead([r.id], !0), (s = (o = r.options) == null ? void 0 : o.onClose) == null || s.call(o, n);
        },
        handleToastOpen: (r) => t((n) => n.activeNotifications.includes(r) ? {} : { activeNotifications: [...n.activeNotifications, r] }),
        handleToastClose: (r) => {
          const n = [];
          t((o) => {
            const s = o.activeNotifications.filter(
              (c) => c !== r
            ), a = o.notifications.map(
              (c) => c.id === r ? ee(q({}, c), { displayed: !0 }) : c
            );
            let l = o.notificationsToDisplay;
            if (s.length < o.maxActiveToasts && l.length > 0) {
              l = [...l];
              const c = l.shift(), u = o.notifications.find((m) => m.id === c);
              u && (s.includes(u.id) || s.push(u.id), n.push(u));
            }
            return { activeNotifications: s, notifications: a, notificationsToDisplay: l };
          }), n.forEach((o) => {
            i().showToast(o);
          });
        },
        addPromiseNotification: (r) => {
          var c, u, m, g;
          const n = r.id ? `${go()}__${r.id}` : `${go()}__`, o = (u = (c = r.options) == null ? void 0 : c.containerId) != null ? u : i().defaultContainer.containerId, s = (g = (m = r.options) == null ? void 0 : m.type) != null ? g : "default", a = x6(s), l = ee(q({}, r), {
            options: ee(q(ee(q({}, c0), {
              style: a ? {
                background: `linear-gradient(to right, transparent 50%, rgba(var(${a}), 0.3) 100%)`
              } : void 0
            }), r.options), {
              toastId: n,
              type: s,
              containerId: o
            }),
            id: n
          });
          return r.promise.finally(() => {
            t((h) => {
              const A = h.activePromises.findIndex((E) => E.id === l.id);
              let y = h.activePromises;
              return A > -1 && (y = [...h.activePromises], y.splice(A, 1)), { activePromises: y };
            });
          }), t((h) => ({ activePromises: [...h.activePromises, l] })), _t.promise(l.promise, l.toastContent, l.options);
        },
        showToast: (r) => {
          const n = Hp({ content: r.content, action: r.action });
          _t(n, ee(q({}, r.options), {
            onOpen: () => i().composedonOpen(r),
            onClose: (o) => i().composedonClose(r, o)
          }));
        },
        dismissToast: (r) => {
          t((n) => {
            const o = Array.isArray(r) ? r : [r];
            return n.notifications.forEach((s) => {
              o.includes(s.id) && _t.dismiss(s.options.toastId);
            }), {
              notificationsToDisplay: n.notificationsToDisplay.filter(
                (s) => !o.includes(s)
              )
            };
          });
        },
        blockToastContainer: () => {
          const r = [], n = i().activePromises.map((a) => {
            r.push(a.id);
            const l = a.id.split("__")[1], c = `${go()}__${l}`;
            return ee(q({}, a), {
              id: c,
              options: ee(q({}, a.options), { toastId: c })
            });
          });
          t((a) => {
            let l = a.notifications, c = a.notificationsToDisplay;
            return a.notificationsToDisplay.length > 0 && (c = [], l = l.map((u) => a.notificationsToDisplay.includes(u.id) ? ee(q({}, u), { displayed: !0 }) : u)), {
              notifications: l,
              notificationsToDisplay: c,
              displayBlocked: !0,
              activePromises: n
            };
          });
          const { activeNotifications: o, notifications: s } = i();
          r.forEach((a) => _t.dismiss(a)), o.forEach((a) => {
            const l = s.find((c) => c.id === a);
            l && _t.dismiss(l.options.toastId);
          });
        },
        unblockToastContainer: () => {
          i().displayBlocked && (t({ displayBlocked: !1 }), i().activePromises.map((l) => Lt(void 0, [l], function* ({ id: n, promise: o, toastContent: s, options: a }) {
            (yield bhe(o)) === "pending" && !_t.isActive(n) && _t.promise(o, s, a);
          })));
        },
        markAsRead: (r, n) => {
          const o = [];
          t((s) => {
            const a = [];
            return s.notifications.forEach((l) => {
              r.includes(l.id) && !l.read ? (a.push(ee(q({}, l), { read: !0 })), o.push(l)) : a.push(l);
            }), { notifications: a };
          }), o.length !== 0 && i().activeEventListeners.markedAsRead.forEach((s) => s(o, n));
        },
        markAllAsRead: (r) => {
          const n = [];
          t((o) => {
            const s = [];
            return o.notifications.forEach((a) => {
              a.read ? s.push(a) : (s.push(ee(q({}, a), { read: !0 })), n.push(a));
            }), { notifications: s };
          }), n.length !== 0 && i().activeEventListeners.markedAllAsRead.forEach((o) => o(n, r));
        },
        remove: (r, n) => {
          const o = [];
          t((s) => {
            const a = [];
            return s.notifications.forEach((l) => {
              r.includes(l.id) ? o.push(l) : a.push(l);
            }), { notifications: a };
          }), o.length !== 0 && i().activeEventListeners.removed.forEach((s) => s(o, n));
        },
        clear: (r) => {
          const n = [...i().notifications];
          t({ notifications: [] }), n.length !== 0 && i().activeEventListeners.removedAll.forEach((o) => o(n, r));
        },
        clearRead: (r) => {
          const n = [];
          t((o) => {
            const s = [];
            return o.notifications.forEach((a) => {
              a.read ? n.push(a) : s.push(a);
            }), { notifications: s };
          }), n.length !== 0 && i().activeEventListeners.removedRead.forEach((o) => o(n, r));
        },
        getNotifications: () => i().notifications,
        addEventListener: (r, n) => (t((o) => ({
          activeEventListeners: ee(q({}, o.activeEventListeners), {
            [r]: [...o.activeEventListeners[r], n]
          })
        })), () => {
          t((o) => ({
            activeEventListeners: ee(q({}, o.activeEventListeners), {
              [r]: o.activeEventListeners[r].filter((s) => s !== n)
            })
          }));
        }),
        setMaxActiveToasts: (r) => t({ maxActiveToasts: r }),
        setStackedToasts: (r) => t({ defaultContainer: ee(q({}, i().defaultContainer), { stacked: r }) }),
        setToastPosition: (r) => t({ defaultContainer: ee(q({}, i().defaultContainer), { position: r }) })
      }),
      {
        name: "notification-storage",
        partialize: (t) => ({
          maxActiveToasts: t.maxActiveToasts,
          defaultContainer: t.defaultContainer
        }),
        version: 1
      }
    )
  );
}, cF = Co(null), NBe = ({
  children: e,
  withNotificationContainer: t = !0
}) => {
  const i = Ne();
  return i.current || (i.current = Che()), /* @__PURE__ */ V(cF.Provider, { value: i.current, children: [
    t && /* @__PURE__ */ f(ghe, {}),
    e
  ] });
}, xhe = (e) => {
  var i, r;
  return ee(q(q({}, c0), e), {
    data: e.data,
    type: (i = e.type) != null ? i : c0.type,
    autoClose: (r = e.autoClose) != null ? r : c0.autoClose
  });
}, Ihe = ({
  content: e
}) => {
  const { pending: t, success: i, error: r } = e;
  return {
    pending: {
      type: "info",
      isLoading: !0,
      render: Hp({ content: t.content, action: t.action })
    },
    success: {
      type: "success",
      isLoading: !1,
      closeButton: !0,
      render: Hp({ content: i.content, action: i.action })
    },
    error: {
      type: "error",
      isLoading: !1,
      closeButton: !0,
      render: Hp({ content: r.content, action: r.action })
    }
  };
}, I6 = (e) => Symbol.iterator in e, S6 = (e) => (
  // HACK: avoid checking entries type
  "entries" in e
), R6 = (e, t) => {
  const i = e instanceof Map ? e : new Map(e.entries()), r = t instanceof Map ? t : new Map(t.entries());
  if (i.size !== r.size)
    return !1;
  for (const [n, o] of i)
    if (!Object.is(o, r.get(n)))
      return !1;
  return !0;
}, She = (e, t) => {
  const i = e[Symbol.iterator](), r = t[Symbol.iterator]();
  let n = i.next(), o = r.next();
  for (; !n.done && !o.done; ) {
    if (!Object.is(n.value, o.value))
      return !1;
    n = i.next(), o = r.next();
  }
  return !!n.done && !!o.done;
};
function Rhe(e, t) {
  return Object.is(e, t) ? !0 : typeof e != "object" || e === null || typeof t != "object" || t === null ? !1 : !I6(e) || !I6(t) ? R6(
    { entries: () => Object.entries(e) },
    { entries: () => Object.entries(t) }
  ) : S6(e) && S6(t) ? R6(e, t) : She(e, t);
}
function khe(e) {
  const t = X.useRef(void 0);
  return (i) => {
    const r = e(i);
    return Rhe(t.current, r) ? t.current : t.current = r;
  };
}
const Yf = () => {
  const { addNotification: e, addPromiseNotification: t, dismissToast: i } = lF(
    khe((c) => ({
      addNotification: c.addNotification,
      addPromiseNotification: c.addPromiseNotification,
      dismissToast: c.dismissToast
    }))
  ), r = ye(
    (c) => e(c.content, c),
    [e]
  ), n = ye(
    (c, u) => t({
      promise: c,
      toastContent: Ihe({ content: u.content }),
      options: xhe(u)
    }),
    [t]
  ), o = ye(
    (c, u) => r(q({ content: c, type: "info" }, u)),
    [r]
  ), s = ye(
    (c, u) => r(q({ content: c, type: "success" }, u)),
    [r]
  ), a = ye(
    (c, u) => r(q({ content: c, type: "error" }, u)),
    [r]
  ), l = ye(
    (c, u) => r(q({ content: c, type: "warning" }, u)),
    [r]
  );
  return {
    notifyInfo: o,
    notifySuccess: s,
    notifyError: a,
    notifyWarning: l,
    notify: r,
    notifyWithPromise: n,
    dismiss: i,
    customNotify: e,
    customNotifyWithPromise: t
  };
};
function whe(e, t, i) {
  const r = Ut.cloneDeep(e), n = [], o = {}, s = [];
  for (let a = 0; a < r.length; a += 1) {
    const l = ee(q({}, r[a]), {
      children: []
    });
    o[l[t]] = a, n.push(l);
  }
  for (let a = 0; a < n.length; a += 1) {
    const l = n[a], c = l[i], u = o[c];
    if (!c || u === void 0) {
      s.push(l);
      continue;
    }
    n[u].children.push(l);
  }
  return s;
}
const Ra = { id: 0, name: "My Profiles", children: [] }, tI = Co(void 0), uF = ({ children: e }) => {
  const [{ isDev: t, user: i }] = gi((g) => ({ isDev: g.isDev, user: g.user })), { api: r } = cu(), [n, o] = se(void 0), [s, a] = se(Ra), l = Ne(!1), c = we(() => whe(n || [], "id", "parent"), [n]), { notifyError: u } = Yf(), m = we(
    () => ({
      folders: n,
      foldersTree: c,
      activeFolder: s,
      setFolders: o,
      setActiveFolder: a
    }),
    [n, c, s]
  );
  return be(() => {
    const g = i === void 0, h = n !== void 0, A = l.current;
    if (g || h || A)
      return;
    l.current = !0, (() => Lt(void 0, null, function* () {
      try {
        const E = yield r.fetchFolders();
        o(E);
      } catch (E) {
        t && console.log(E), o([]), u("Failed to fetch folders, please refresh the page.");
      }
    }))();
  }, [r, n, t, u, i]), /* @__PURE__ */ f(tI.Provider, { value: m, children: e });
}, Mhe = "_modal_1hgcv_1", Nhe = "_content_1hgcv_9", The = "_actions_1hgcv_14", jE = {
  modal: Mhe,
  content: Nhe,
  actions: The
};
function Bhe() {
  let e;
  return [
    new Promise((t, i) => {
      e = t;
    }),
    e
  ];
}
function iI() {
  const [e, t] = se(!1), i = Ne(void 0), [r, n] = se(null), o = ye(({ content: l }) => {
    n(l), t(!0);
    const [c, u] = Bhe();
    return i.current = u, c;
  }, []), s = (l) => Lt(this, null, function* () {
    t(!1), i.current && i.current(l);
  });
  return { getConfirmation: o, ConfirmationModal: () => /* @__PURE__ */ f(
    qf,
    {
      visible: e,
      onClose: () => {
        s(!1);
      },
      children: /* @__PURE__ */ V("div", { className: jE.modal, children: [
        /* @__PURE__ */ f("div", { className: jE.content, children: r }),
        /* @__PURE__ */ V("div", { className: jE.actions, children: [
          /* @__PURE__ */ f(
            Kt,
            {
              onClick: () => {
                s(!1);
              },
              children: "Cancel"
            }
          ),
          /* @__PURE__ */ f(
            Kt,
            {
              buttonStyle: "danger",
              onClick: () => {
                s(!0);
              },
              children: "Yes"
            }
          )
        ] })
      ] })
    }
  ) };
}
const Dhe = "_loadingFilter_1dqr2_1", Ohe = "_loader_1dqr2_9", k6 = {
  loadingFilter: Dhe,
  loader: Ohe,
  "maxroll-loader-rotation": "_maxroll-loader-rotation_1dqr2_1"
};
function dF() {
  return /* @__PURE__ */ f("div", { className: k6.loadingFilter, children: /* @__PURE__ */ f("span", { className: k6.loader }) });
}
const mF = Co(void 0), gF = ({
  children: e,
  supportCommunityBuilds: t = !1
}) => {
  const [{ isDev: i, user: r }] = gi((W) => ({ isDev: W.isDev, user: W.user })), { api: n } = cu(), { getConfirmation: o, ConfirmationModal: s } = iI(), { notifyError: a } = Yf(), [{ profiles: l }] = gi((W) => ({ profiles: W.userGameProfiles })), { updateProfileInStore: c, removeProfileFromStore: u } = _x(), m = we(
    () => ({
      id: "",
      name: "New Profile",
      folder: 0,
      public: !1,
      userId: r == null ? void 0 : r.plannerId,
      data: {}
    }),
    [r == null ? void 0 : r.plannerId]
  ), [g, h] = se("idle"), [A, y] = se(), E = we(
    () => A ? l == null ? void 0 : l.find((W) => W.id === A) : void 0,
    [l, A]
  ), [v, C] = se(Ut.cloneDeep(m));
  be(() => {
    C((W) => W.userId !== void 0 && W !== null ? W : ee(q({}, W), { userId: r == null ? void 0 : r.plannerId }));
  }, [r == null ? void 0 : r.plannerId]);
  const x = we(() => v.id === "" ? JSON.stringify(v) !== JSON.stringify(m) : E ? JSON.stringify(v) !== JSON.stringify(E) : !0, [v, m, E]), S = we(
    () => !v.userId || (r == null ? void 0 : r.plannerId) === v.userId,
    [v.userId, r == null ? void 0 : r.plannerId]
  ), R = ye(
    ({ profile: W, skipConfirmation: H = !1 }) => {
      const Q = () => {
        y(W.id || void 0), C(Ut.cloneDeep(W));
      };
      x && !H ? o({
        content: /* @__PURE__ */ V("span", { children: [
          "You have some unsaved changes. ",
          /* @__PURE__ */ f("br", {}),
          "Loading a different profile will discard them. ",
          /* @__PURE__ */ f("br", {}),
          "Are you sure you want to continue?"
        ] })
      }).then(($) => {
        $ && Q();
      }) : Q();
    },
    [x, o, y, C]
  ), w = ye(
    ({ id: W }) => {
      if (g !== "idle")
        return;
      const H = () => {
        h("loading"), n.fetchProfile({ id: W }).then((Q) => {
          c(Q), R({ profile: Q, skipConfirmation: !0 });
        }).catch((Q) => {
          i && console.log(Q), a("Failed to load profile, please refresh the page & try again.");
        }).finally(() => {
          h("idle");
        });
      };
      x ? o({
        content: /* @__PURE__ */ V("span", { children: [
          "You have some unsaved changes. ",
          /* @__PURE__ */ f("br", {}),
          "Loading a different profile will discard them. ",
          /* @__PURE__ */ f("br", {}),
          "Are you sure you want to continue?"
        ] })
      }).then((Q) => {
        Q && H();
      }) : H();
    },
    [g, x, n, c, R, i, a, o]
  ), T = ye(
    (W = {}) => {
      const H = () => {
        const Q = q(q({}, m), W);
        R({ profile: Q, skipConfirmation: !0 });
        const $ = new URL(window.location.href);
        window.history.replaceState({}, "", $);
      };
      x ? o({
        content: /* @__PURE__ */ V("span", { children: [
          "You have some unsaved changes.",
          /* @__PURE__ */ f("br", {}),
          " Are you sure you want to discard them?"
        ] })
      }).then((Q) => {
        Q && H();
      }) : H();
    },
    [x, m, R, o]
  ), N = ye(() => {
    var he;
    if (!x || g !== "idle")
      return;
    const W = q({}, v), H = "id" in W && !!W.id;
    H || delete W.id;
    const Q = !H || W.userId === (r == null ? void 0 : r.plannerId);
    Q || (delete W.id, W.folder = 0), !(i || typeof window != "undefined" && window.location.host.includes("backend")) && !Q && ((he = W.data) == null || delete he.embeds), h("loading"), n.saveProfile({ profile: W }).then((oe) => {
      c(oe), R({ profile: oe, skipConfirmation: !0 });
    }).catch((oe) => {
      i && console.log(oe), a("Failed to save the profile.");
    }).finally(() => {
      h("idle");
    });
  }, [
    r,
    x,
    g,
    v,
    n,
    c,
    R,
    i,
    a
  ]), D = ye(
    (W, H) => {
      g === "idle" && (h("loading"), n.moveProfile({ id: W, to: H }).then(() => {
        const Q = l == null ? void 0 : l.find(($) => $.id === W);
        if (Q) {
          const $ = ee(q({}, Q), { folder: H });
          c($), v.id === W && R({ profile: $, skipConfirmation: !0 });
        }
      }).catch((Q) => {
        i && console.log(Q), a("Failed to save the profile.");
      }).finally(() => {
        h("idle");
      }));
    },
    [n, v.id, i, a, l, R, g, c]
  ), O = ye(
    (W, H) => {
      g === "idle" && (h("loading"), n.renameProfile({ id: W, name: H }).then((Q) => {
        c(Q), v.id === W && R({ profile: Q, skipConfirmation: !0 });
      }).catch((Q) => {
        i && console.log(Q), a("Failed to save the profile.");
      }).finally(() => {
        h("idle");
      }));
    },
    [g, n, c, v.id, R, i, a]
  ), F = ye(
    (W) => {
      if (g !== "idle")
        return;
      const H = l == null ? void 0 : l.find(($) => $.id === W);
      if (!H) {
        a("Profile not found.");
        return;
      }
      h("loading");
      const Q = Ut.cloneDeep(H);
      delete Q.id, Q.name.endsWith("Clone") || (Q.name = `${Q.name} Clone`), n.saveProfile({ profile: Q }).then(($) => {
        c($);
      }).catch(($) => {
        i && console.log($), a("Failed to save the profile.");
      }).finally(() => {
        h("idle");
      });
    },
    [g, n, l, a, h, c, i]
  ), Y = ye(
    (W) => {
      if (g !== "idle")
        return;
      const H = () => {
        h("loading"), n.deleteProfile({ id: W }).then(() => {
          A === W && R({ profile: m, skipConfirmation: !0 }), u(W);
        }).catch((Q) => {
          i && console.log(Q), a("Failed to delete the profile.");
        }).finally(() => {
          h("idle");
        });
      };
      o({
        content: /* @__PURE__ */ V("span", { children: [
          "Are you sure you want to delete the following profile: ",
          v.name,
          "?"
        ] })
      }).then((Q) => {
        Q && H();
      });
    },
    [
      g,
      o,
      v.name,
      n,
      A,
      u,
      R,
      m,
      i,
      a
    ]
  ), P = ye(
    (W, H) => {
      g === "idle" && (h("loading"), n.rateProfile({ id: W, rating: H }).then(() => {
        C((Q) => ee(q({}, Q), { userRating: H }));
      }).catch((Q) => {
        i && console.log(Q), a("Failed to rate the profile.");
      }).finally(() => {
        h("idle");
      }));
    },
    [g, n, i, a]
  );
  be(() => {
    i && console.log("Profile updated:", v);
  }, [v, i]);
  const z = we(
    () => ({
      editedProfile: v,
      setEditedProfile: C,
      status: g,
      updateProfileFolder: D,
      loadProfileForEditing: w,
      setProfileForEditing: R,
      createNewProfile: T,
      saveEditedProfile: N,
      renameProfile: O,
      duplicateProfile: F,
      deleteProfile: Y,
      hasUnsavedChanges: x,
      ConfirmationModal: s,
      isOwnedProfile: S,
      supportCommunityBuilds: t,
      rateProfile: P
    }),
    [
      v,
      g,
      D,
      w,
      R,
      T,
      N,
      O,
      F,
      Y,
      x,
      s,
      S,
      t,
      P
    ]
  );
  return /* @__PURE__ */ f(mF.Provider, { value: z, children: e });
};
function on() {
  const e = sn(mF);
  if (!e)
    throw new Error("useProfileEditingContext must be used within a ProfileEditingContextProvider");
  return e;
}
const Fhe = "_embedsManager_8r4ys_1", Vhe = "_list_8r4ys_6", qhe = "_noEmbeds_8r4ys_18", jhe = "_listItem_8r4ys_24", Lhe = "_embedName_8r4ys_31", Khe = "_embedActions_8r4ys_34", Yhe = "_duplicate_8r4ys_46", Uhe = "_addButton_8r4ys_63", Ghe = "_editingArea_8r4ys_70", Qhe = "_embedEditorTitle_8r4ys_76", Whe = "_rename_8r4ys_84", Zhe = "_embedEditorWrapper_8r4ys_91", no = {
  embedsManager: Fhe,
  list: Vhe,
  noEmbeds: qhe,
  listItem: jhe,
  embedName: Lhe,
  embedActions: Khe,
  duplicate: Yhe,
  delete: "_delete_8r4ys_51",
  addButton: Uhe,
  editingArea: Ghe,
  embedEditorTitle: Qhe,
  rename: Whe,
  embedEditorWrapper: Zhe
};
function Jhe() {
  var C;
  const { getConfirmation: e, ConfirmationModal: t } = iI(), { editedProfile: i, setEditedProfile: r, status: n } = on(), { embedTypes: o } = Ui(), s = we(() => {
    var x;
    return ((x = i.data) == null ? void 0 : x.embeds) || [];
  }, [(C = i.data) == null ? void 0 : C.embeds]), [a, l] = se(void 0), c = we(() => s.find((x) => x.id === a), [s, a]), u = we(
    () => c ? o == null ? void 0 : o.find((x) => x.id === c.type) : void 0,
    [c, o]
  ), m = ye(() => {
    const x = go();
    r((S) => {
      var T;
      const R = Ut.cloneDeep(S), w = ((T = R.data) == null ? void 0 : T.embeds) || [];
      return w.push({ id: x, type: "" }), ee(q({}, R), { data: ee(q({}, R.data), { embeds: w }) });
    }), l(x);
  }, [r]), g = ye(
    (x) => {
      r((S) => {
        var N;
        const R = Ut.cloneDeep(S), w = ((N = R.data) == null ? void 0 : N.embeds) || [], T = w.findIndex((D) => D.id === x.id);
        return w[T] = q({}, x), ee(q({}, R), { data: ee(q({}, R.data), { embeds: w }) });
      });
    },
    [r]
  ), h = ye(
    (x) => {
      r((S) => {
        var N;
        const R = Ut.cloneDeep(S), w = ((N = R.data) == null ? void 0 : N.embeds) || [], T = w.findIndex((D) => D.id === x);
        return T !== -1 && w.splice(T, 1), ee(q({}, R), { data: ee(q({}, R.data), { embeds: w }) });
      });
    },
    [r]
  ), A = ye(
    (x) => {
      const S = go();
      r((R) => {
        var D;
        const w = Ut.cloneDeep(R), T = ((D = w.data) == null ? void 0 : D.embeds) || [], N = T.find((O) => O.id === x);
        if (N !== void 0) {
          const O = Ut.cloneDeep(N);
          T.push(ee(q({}, O), { id: S }));
        }
        return ee(q({}, w), { data: ee(q({}, w.data), { embeds: T }) });
      }), l(S);
    },
    [r]
  ), y = ye(
    (x) => {
      if (c === void 0)
        return;
      const S = typeof x == "function" ? x(Ut.cloneDeep(c)) : x;
      g(S);
    },
    [c, g]
  ), [E, v] = se(!1);
  return /* @__PURE__ */ V("div", { className: no.embedsManager, children: [
    /* @__PURE__ */ V("div", { className: no.list, children: [
      s.length === 0 && /* @__PURE__ */ f("div", { className: no.noEmbeds, children: "No embeds in this profile" }),
      s.map((x, S) => {
        const R = o == null ? void 0 : o.find((T) => T.id === x.type), w = x.name || (R == null ? void 0 : R.name) || "New Embed";
        return /* @__PURE__ */ V(
          "div",
          {
            className: no.listItem,
            onClick: () => {
              l(x.id);
            },
            children: [
              /* @__PURE__ */ f("span", { className: no.embedName, children: w }),
              /* @__PURE__ */ V("span", { className: no.embedActions, children: [
                /* @__PURE__ */ f(
                  "span",
                  {
                    className: no.duplicate,
                    onClick: (T) => {
                      T.preventDefault(), T.stopPropagation(), A(x.id);
                    },
                    children: /* @__PURE__ */ f(Mt, { width: 18, height: 18, icon: "icons/copy.svg" })
                  }
                ),
                /* @__PURE__ */ f(
                  "span",
                  {
                    className: no.delete,
                    onClick: (T) => {
                      T.preventDefault(), T.stopPropagation(), e({
                        content: /* @__PURE__ */ V("span", { children: [
                          'Are you sure you want to delete the "',
                          w,
                          '" embed?'
                        ] })
                      }).then((N) => {
                        N && h(x.id);
                      });
                    },
                    children: /* @__PURE__ */ f(Mt, { width: 20, height: 20, icon: "icons/delete-icon-2.svg" })
                  }
                )
              ] })
            ]
          },
          S
        );
      }),
      /* @__PURE__ */ f("div", { className: no.addButton, children: /* @__PURE__ */ f(
        Kt,
        {
          buttonStyle: "primary",
          onClick: () => {
            m();
          },
          children: "Add new"
        }
      ) })
    ] }),
    /* @__PURE__ */ f("div", { className: no.editingArea, children: c === void 0 ? /* @__PURE__ */ f("span", { children: "Select or create a new embed" }) : u === void 0 ? /* @__PURE__ */ f("div", { children: /* @__PURE__ */ f(
      _s,
      {
        options: (o == null ? void 0 : o.map((x) => ({ value: x.id, label: x.name }))) || [],
        placeholder: "Select embed type",
        onChange: (x) => {
          g(ee(q({}, c), { type: (x == null ? void 0 : x.value) || "" }));
        }
      }
    ) }) : u.component === void 0 ? /* @__PURE__ */ f("span", { children: "Invalid embed type" }) : /* @__PURE__ */ V(gt, { children: [
      /* @__PURE__ */ V("div", { className: no.embedEditorTitle, children: [
        E ? /* @__PURE__ */ V(gt, { children: [
          /* @__PURE__ */ f(
            kn,
            {
              size: "sm-md",
              value: c.name || "",
              onChange: (x) => {
                if (x)
                  g(ee(q({}, c), { name: x }));
                else {
                  const S = q({}, c);
                  delete S.name, g(S);
                }
              },
              placeholder: u.name
            }
          ),
          /* @__PURE__ */ f(
            Kt,
            {
              onClick: () => {
                v(!1);
              },
              children: "Save"
            }
          )
        ] }) : /* @__PURE__ */ V(gt, { children: [
          /* @__PURE__ */ f("span", { children: c.name || u.name }),
          /* @__PURE__ */ f(
            "span",
            {
              className: no.rename,
              onClick: (x) => {
                x.preventDefault(), x.stopPropagation(), v(!0);
              },
              children: /* @__PURE__ */ f(Mt, { width: 18, height: 18, icon: "icons/edit-2.svg" })
            }
          )
        ] }),
        c.id && i.id ? u.customCopyButton ? Ei(u.customCopyButton, { editedProfile: i, selectedEmbed: c }) : /* @__PURE__ */ f(
          Kt,
          {
            onClick: () => {
              navigator.clipboard.writeText(ide(i, c));
            },
            children: "Copy"
          }
        ) : null
      ] }),
      /* @__PURE__ */ f("div", { className: no.embedEditorWrapper, children: Ei(u.component, { embed: c, setEmbed: y, mode: "edit" }) })
    ] }) }),
    /* @__PURE__ */ f(t, {}),
    n !== "idle" && /* @__PURE__ */ f(dF, {})
  ] });
}
const Phe = "_planner_orlg9_1", zhe = "_tabContent_orlg9_9", Hhe = "_quickSave_orlg9_14", Xhe = "_frontendQuickSave_orlg9_20", _he = "_profilesManagerModal_orlg9_32", fl = {
  planner: Phe,
  tabContent: zhe,
  quickSave: Hhe,
  frontendQuickSave: Xhe,
  profilesManagerModal: _he
}, $he = "_titleBox_17dyu_1", epe = "_top_17dyu_8", tpe = "_left_17dyu_13", ipe = "_titleWrapper_17dyu_20", rpe = "_accent_17dyu_25", npe = "_text_17dyu_30", ope = "_right_17dyu_43", spe = "_content_17dyu_48", ape = "_pager_17dyu_53", lpe = "_icon_17dyu_57", cpe = "_disabledIcon_17dyu_62", oo = {
  titleBox: $he,
  top: epe,
  left: tpe,
  titleWrapper: ipe,
  accent: rpe,
  text: npe,
  right: ope,
  content: spe,
  pager: ape,
  icon: lpe,
  disabledIcon: cpe
};
function upe(u) {
  var m = u, {
    title: e,
    accentColor: t,
    filters: i,
    showPager: r = !1,
    onNext: n,
    onPrev: o,
    filtersOnBottom: s = !1,
    className: a,
    children: l
  } = m, c = Fe(m, [
    "title",
    "accentColor",
    "filters",
    "showPager",
    "onNext",
    "onPrev",
    "filtersOnBottom",
    "className",
    "children"
  ]);
  return /* @__PURE__ */ V("div", ee(q({ className: me(oo.titleBox, a) }, c), { children: [
    /* @__PURE__ */ V("div", { className: oo.top, children: [
      /* @__PURE__ */ V("div", { className: oo.left, children: [
        /* @__PURE__ */ V("div", { className: oo.titleWrapper, children: [
          /* @__PURE__ */ f(
            "span",
            {
              style: { backgroundColor: t && B1[t] },
              className: oo.accent
            }
          ),
          /* @__PURE__ */ f("h2", { className: oo.text, children: e })
        ] }),
        !s && i
      ] }),
      /* @__PURE__ */ V("div", { className: oo.right, children: [
        /* @__PURE__ */ f("div", { className: oo.content, children: l }),
        r && /* @__PURE__ */ V("div", { className: oo.pager, children: [
          /* @__PURE__ */ f(
            Mt,
            {
              icon: "blue-arrow-left.svg",
              width: 10,
              height: 10,
              className: me(o ? oo.icon : oo.disiabledIcon),
              onClick: () => {
                o && o();
              }
            }
          ),
          /* @__PURE__ */ f(
            Mt,
            {
              icon: "blue-arrow-right.svg",
              width: 10,
              height: 10,
              className: me(n ? oo.icon : oo.disiabledIcon),
              onClick: () => {
                n && n();
              }
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ f(Pr, { type: "horizontal", children: s && i })
  ] }));
}
const jg = () => {
  const e = sn(tI);
  if (!e)
    throw new Error("useGameFolders must be used within a GameFoldersContextProvider");
  return {
    folders: e.folders || [],
    foldersTree: e.foldersTree,
    activeFolder: e.activeFolder,
    setActiveFolder: e.setActiveFolder
  };
}, dpe = "_main_1smxk_1", mpe = "_activeProfile_1smxk_8", gpe = "_profileName_1smxk_13", hpe = "_actions_1smxk_23", ppe = "_profileBrowser_1smxk_31", fpe = "_folders_1smxk_36", Ape = "_createFolderForm_1smxk_48", ype = "_foldersTitle_1smxk_55", Epe = "_folder_1smxk_36", vpe = "_folderHeader_1smxk_64", bpe = "_folderActions_1smxk_65", Cpe = "_actionBtn_1smxk_70", xpe = "_actionIcon_1smxk_71", Ipe = "_activeFolder_1smxk_82", Spe = "_expandFolderIcon_1smxk_92", Rpe = "_expanded_1smxk_97", kpe = "_folderName_1smxk_101", wpe = "_editing_1smxk_108", Mpe = "_folderNameInput_1smxk_116", Npe = "_folderNameText_1smxk_122", Tpe = "_subfolderContainer_1smxk_128", Bpe = "_profiles_1smxk_134", Dpe = "_profilesHeader_1smxk_138", Ope = "_profilesTable_1smxk_148", Fpe = "_fullWidth_1smxk_151", Vpe = "_profile_1smxk_13", qpe = "_profileRenaming_1smxk_158", jpe = "_actionsCell_1smxk_163", di = {
  main: dpe,
  activeProfile: mpe,
  profileName: gpe,
  actions: hpe,
  profileBrowser: ppe,
  folders: fpe,
  createFolderForm: Ape,
  foldersTitle: ype,
  folder: Epe,
  folderHeader: vpe,
  folderActions: bpe,
  actionBtn: Cpe,
  actionIcon: xpe,
  activeFolder: Ipe,
  expandFolderIcon: Spe,
  expanded: Rpe,
  folderName: kpe,
  editing: wpe,
  folderNameInput: Mpe,
  folderNameText: Npe,
  subfolderContainer: Tpe,
  profiles: Bpe,
  profilesHeader: Dpe,
  profilesTable: Ope,
  fullWidth: Fpe,
  profile: Vpe,
  profileRenaming: qpe,
  actionsCell: jpe
};
function Lpe() {
  const { editedProfile: e, setEditedProfile: t, hasUnsavedChanges: i, createNewProfile: r, saveEditedProfile: n, isOwnedProfile: o } = on(), { activeFolder: s } = jg(), a = ye(
    (m) => {
      t((g) => ee(q({}, g), { name: m }));
    },
    [t]
  ), l = we(() => JSON.stringify(e.data) === "{}", [e]), c = we(() => o ? !i || !e.name : l, [o, l, i, e.name]), u = we(() => o ? i ? e.name ? "Save" : "Enter a profile name" : l ? "Cannot Save Empty Profile" : "Already Saved" : l ? "Cannot Save Empty Profile" : "Save a copy", [e.name, i, l, o]);
  return /* @__PURE__ */ f("div", { className: di.activeProfile, children: /* @__PURE__ */ V("div", { className: di.actions, children: [
    /* @__PURE__ */ V("div", { className: di.actions, children: [
      /* @__PURE__ */ f(kn, { value: e.name, onChange: a, size: "sm-md", placeholder: "New profile" }),
      /* @__PURE__ */ f(
        Kt,
        {
          style: c ? { color: "rgb(var(--maxroll-color-grey-3))" } : void 0,
          buttonStyle: i ? "primary" : "default",
          disabled: c,
          onClick: () => {
            n();
          },
          children: u
        }
      )
    ] }),
    /* @__PURE__ */ V(
      Kt,
      {
        buttonStyle: "primary",
        onClick: () => {
          r({ folder: s.id });
        },
        children: [
          /* @__PURE__ */ f(
            Mt,
            {
              style: { background: "white", marginRight: "8px" },
              icon: "icons/plus-icon.webp",
              width: 12,
              height: 12
            }
          ),
          "New profile"
        ]
      }
    )
  ] }) });
}
const hF = () => {
  const e = sn(tI);
  if (!e)
    throw new Error("useGameFoldersActions must be used within a GameFoldersContextProvider");
  const { api: t } = cu(), [i, r] = se(), { notifyError: n } = Yf();
  be(() => {
    i && (n(i.message), r(void 0));
  }, [i, n]);
  const o = ye(
    (c) => Lt(void 0, null, function* () {
      try {
        yield t.saveFolders(c), e.setFolders(c);
      } catch (u) {
        r(u);
      }
    }),
    [t, e]
  ), s = ye(
    (c) => Lt(void 0, null, function* () {
      try {
        const u = [...e.folders || [], c];
        yield o(u);
      } catch (u) {
        r(u);
      }
    }),
    [o, e.folders]
  ), a = ye(
    (c) => Lt(void 0, null, function* () {
      try {
        if (!e.folders || !e.folders.length)
          return;
        const u = e.folders.filter((m) => !c.includes(m.id));
        yield o(u);
      } catch (u) {
        r(u);
      }
    }),
    [o, e.folders]
  ), l = ye(
    (c, u) => Lt(void 0, null, function* () {
      try {
        if (!e.folders || !e.folders.length)
          return;
        const m = e.folders.map(
          (g) => g.id === c ? q(q({}, g), u) : g
        );
        yield o(m);
      } catch (m) {
        r(m);
      }
    }),
    [o, e.folders]
  );
  return {
    addFolder: s,
    updateFolder: l,
    deleteFolders: a
  };
}, rI = (e) => {
  const t = [];
  return e.children.forEach((i) => {
    t.push(i.id), t.push(...rI(i));
  }), t;
}, Kpe = "_modal_1pn2e_1", Ype = "_content_1pn2e_9", Upe = "_actions_1pn2e_17", LE = {
  modal: Kpe,
  content: Ype,
  actions: Upe
};
function Gpe({ folder: e, onCancel: t, onConfirm: i }) {
  const [r, n] = se(!1), o = () => {
    i({ deleteContent: r });
  };
  return /* @__PURE__ */ f(qf, { onClose: t, children: /* @__PURE__ */ V("div", { className: LE.modal, children: [
    /* @__PURE__ */ V("div", { className: LE.content, children: [
      /* @__PURE__ */ V("span", { children: [
        'Are you sure you want to delete the following folder: "',
        e.name,
        '"?'
      ] }),
      /* @__PURE__ */ f(
        Ka,
        {
          value: r,
          onChange: (s) => n(s),
          label: "Delete all items in this folder"
        }
      )
    ] }),
    /* @__PURE__ */ V("div", { className: LE.actions, children: [
      /* @__PURE__ */ f(Kt, { onClick: t, children: "Cancel" }),
      /* @__PURE__ */ f(Kt, { buttonStyle: "danger", onClick: o, children: "Confirm" })
    ] })
  ] }) });
}
const Xp = {
  PROFILE: "PROFILE",
  FOLDER: "FOLDER"
}, Qpe = (e, t) => e.id === t.id ? !0 : rI(t).includes(e.id);
function fC(n) {
  var o = n, { folder: e, onDelete: t, className: i } = o, r = Fe(o, ["folder", "onDelete", "className"]);
  const { activeFolder: s, setActiveFolder: a } = jg(), { updateFolder: l } = hF(), { updateProfileFolder: c } = on(), [u, m] = se(!1), [g, h] = se(!1), A = Ne(null), [{ isDragging: y }, E] = wN(
    () => ({
      type: Xp.FOLDER,
      collect: (D) => ({
        isDragging: D.isDragging()
      }),
      canDrag: () => e.id !== 0 && !g,
      item: { folder: e }
    }),
    [e, g]
  ), [{ isOver: v, canDrop: C }, x] = BW(
    () => ({
      accept: [Xp.FOLDER, Xp.PROFILE],
      drop: (D) => {
        D.folder && l(D.folder.id, { parent: e.id }), D.profile && D.profile.folder !== e.id && c(D.profile.id, e.id);
      },
      canDrop: (D) => {
        if (D.folder) {
          const O = e.id !== D.folder.parent;
          return !Qpe(e, D.folder) && O;
        }
        return !!D.profile;
      },
      collect: (D) => ({
        isOver: D.isOver(),
        canDrop: D.canDrop()
      })
    }),
    [e, l, c]
  ), S = e.children, R = !!S.length, w = s.id === e.id, T = e.id === Ra.id, N = () => {
    var O;
    h((F) => !F);
    const D = (O = A.current) == null ? void 0 : O.value;
    g && D && D !== e.name && l(e.id, { name: D });
  };
  return /* @__PURE__ */ V("div", ee(q({ className: me(di.folder, i) }, r), { children: [
    /* @__PURE__ */ V(
      "div",
      {
        className: me(di.folderHeader, w ? di.activeFolder : ""),
        ref: x,
        style: {
          opacity: y || v ? 0.7 : 1,
          border: v ? `2px dashed ${C ? "rgb(var(--maxroll-color-blue-2))" : "rgb(var(--maxroll-color-red-2))"}` : "2px dashed transparent",
          borderRadius: "4px"
        },
        children: [
          /* @__PURE__ */ V(
            "div",
            {
              className: me(di.folderName, g ? di.editing : ""),
              ref: E,
              onClick: (D) => {
                D.preventDefault(), D.stopPropagation(), !g && a(e);
              },
              children: [
                T ? null : /* @__PURE__ */ f(
                  Mt,
                  {
                    width: 20,
                    height: 20,
                    icon: R ? u ? "icons/close-folder.svg" : "icons/open-folder.svg" : "icons/default-folder.svg",
                    className: me(di.expandFolderIcon, u ? di.expanded : ""),
                    color: "rgb(var(--maxroll-color-blue-2))",
                    onClick: (D) => {
                      R && (D.preventDefault(), D.stopPropagation(), m((O) => !O));
                    }
                  }
                ),
                g ? /* @__PURE__ */ f(
                  kn,
                  {
                    ref: A,
                    className: di.folderNameInput,
                    onKeyDown: (D) => {
                      D.key === "Enter" && N(), D.key === "Escape" && h(!1);
                    },
                    value: e.name,
                    onClick: (D) => D.stopPropagation()
                  }
                ) : /* @__PURE__ */ f("span", { className: di.folderNameText, style: { padding: "2px" }, children: e.name })
              ]
            }
          ),
          !!e.id && /* @__PURE__ */ V("div", { className: di.folderActions, children: [
            /* @__PURE__ */ f(
              Kt,
              {
                size: "sm",
                className: di.actionBtn,
                style: { padding: "0 8px" },
                buttonStyle: "default",
                onClick: N,
                children: /* @__PURE__ */ f(
                  Mt,
                  {
                    width: 16,
                    height: 16,
                    icon: "icons/edit-2.svg",
                    color: "rgb(var(--maxroll-color-white-1))",
                    className: di.actionIcon
                  }
                )
              }
            ),
            /* @__PURE__ */ f(
              Kt,
              {
                size: "sm",
                className: di.actionBtn,
                style: { padding: "0 8px" },
                buttonStyle: "danger",
                onClick: () => t(e),
                children: /* @__PURE__ */ f(
                  Mt,
                  {
                    width: 16,
                    height: 16,
                    icon: "icons/delete-icon-2.svg",
                    color: "rgb(var(--maxroll-color-white-1))",
                    className: di.actionIcon
                  }
                )
              }
            )
          ] })
        ]
      }
    ),
    u && R && /* @__PURE__ */ f(gt, { children: S.map((D) => /* @__PURE__ */ f("div", { className: di.subfolderContainer, children: /* @__PURE__ */ f(fC, { folder: D, onDelete: t }) }, D.id)) })
  ] }));
}
function Wpe({ onDeleteFoldersContent: e, onDeleteFolders: t }) {
  const { folders: i, foldersTree: r, activeFolder: n, setActiveFolder: o } = jg(), { addFolder: s, deleteFolders: a } = hF(), [l, c] = se(void 0), u = we(() => i.map((E) => E.id), [i]), m = () => {
    const E = Math.floor(Math.random() * 1e9);
    return u.includes(E) ? m() : E;
  }, g = (E) => {
    E.preventDefault();
    const C = new FormData(E.currentTarget).get("name"), x = m();
    s({ id: x, name: C });
  }, h = (E) => {
    c(E);
  }, A = () => {
    c(void 0);
  }, y = (E) => Lt(this, null, function* () {
    if (l === void 0)
      return;
    c(void 0);
    const v = [l.id, ...rI(l)];
    yield a(v), t(v), v.includes(n.id) && o(Ra), E.deleteContent && e(v);
  });
  return /* @__PURE__ */ V("div", { className: di.folders, children: [
    /* @__PURE__ */ f(fC, { style: { marginLeft: 0 }, folder: Ra, onDelete: h }),
    r.map((E) => /* @__PURE__ */ f(fC, { folder: E, onDelete: h }, E.id)),
    l && /* @__PURE__ */ f(
      Gpe,
      {
        folder: l,
        onConfirm: y,
        onCancel: A
      }
    ),
    /* @__PURE__ */ V("form", { onSubmit: g, className: di.createFolderForm, children: [
      /* @__PURE__ */ f(kn, { size: "sm-md", placeholder: "New folder name", name: "name", required: !0 }),
      /* @__PURE__ */ f(Kt, { buttonStyle: "primary2", type: "submit", children: "Add" })
    ] })
  ] });
}
function Zpe({ profile: e, onSelect: t }) {
  const { deleteProfile: i, renameProfile: r, duplicateProfile: n, ConfirmationModal: o } = on(), { folders: s, setActiveFolder: a } = jg(), [l, c] = se(!1), [{ isDragging: u }, m] = wN(
    () => ({
      type: Xp.PROFILE,
      collect: (E) => ({
        isDragging: E.isDragging()
      }),
      canDrag: () => !l,
      item: { profile: e }
    }),
    [e, l]
  ), g = we(() => {
    if (e.folder === Ra.id)
      return Ra.name;
    const E = s.find((v) => v.id === e.folder);
    return (E == null ? void 0 : E.name) || "-";
  }, [e, s]), h = (E) => {
    if (E === Ra.id) {
      a(Ra);
      return;
    }
    const v = s.find((C) => C.id === E);
    v !== void 0 && a(v);
  }, [A, y] = se("");
  return /* @__PURE__ */ V(gt, { children: [
    /* @__PURE__ */ V(
      "tr",
      {
        style: { opacity: u ? 0.3 : 1 },
        className: di.profile,
        onClick: (E) => {
          E.preventDefault(), E.stopPropagation(), t !== void 0 && t(e.id);
        },
        children: [
          /* @__PURE__ */ f("td", { ref: m, children: l ? /* @__PURE__ */ V(
            "div",
            {
              className: di.profileRenaming,
              onClick: (E) => {
                E.preventDefault(), E.stopPropagation();
              },
              children: [
                /* @__PURE__ */ f(
                  kn,
                  {
                    size: "sm-md",
                    value: A,
                    onChange: (E) => {
                      y(E);
                    }
                  }
                ),
                /* @__PURE__ */ f(
                  Kt,
                  {
                    onClick: () => {
                      c(!1), r(e.id, A), y("");
                    },
                    children: "Save"
                  }
                )
              ]
            }
          ) : e.name || "-" }),
          /* @__PURE__ */ f("td", { children: /* @__PURE__ */ f(
            Kt,
            {
              size: "sm",
              onClick: (E) => {
                E.stopPropagation(), h(e.folder);
              },
              children: g
            }
          ) }),
          /* @__PURE__ */ f("td", { className: di.actionsCell, children: /* @__PURE__ */ V("div", { children: [
            /* @__PURE__ */ f(
              Kt,
              {
                size: "sm",
                onClick: (E) => {
                  E.preventDefault(), E.stopPropagation(), y(e.name), c(!0);
                },
                children: /* @__PURE__ */ f(Mt, { width: 18, height: 18, icon: "icons/edit-2.svg" })
              }
            ),
            /* @__PURE__ */ f(
              Kt,
              {
                size: "sm",
                onClick: (E) => {
                  E.preventDefault(), E.stopPropagation(), n(e.id);
                },
                children: /* @__PURE__ */ f(Mt, { width: 18, height: 18, icon: "icons/copy.svg" })
              }
            ),
            /* @__PURE__ */ f(
              Kt,
              {
                size: "sm",
                buttonStyle: "danger",
                onClick: (E) => {
                  E.preventDefault(), E.stopPropagation(), i(e.id);
                },
                children: /* @__PURE__ */ f(Mt, { width: 18, height: 18, icon: "icons/delete-icon-2.svg" })
              }
            )
          ] }) })
        ]
      }
    ),
    /* @__PURE__ */ f(o, {})
  ] });
}
function Jpe({ profiles: e, onProfileSelect: t, headerRightChildren: i }) {
  const [r, n] = se(""), o = we(() => r === "" ? e : e.filter((a) => a.name.toLowerCase().includes(r.toLowerCase())), [e, r]), s = (a) => {
    n(a);
  };
  return /* @__PURE__ */ V(gt, { children: [
    /* @__PURE__ */ V("div", { className: di.profilesHeader, children: [
      /* @__PURE__ */ f(
        wg,
        {
          size: "sm-md",
          type: "text",
          placeholder: "Search...",
          onChange: s,
          className: di.searchInput
        }
      ),
      /* @__PURE__ */ f("div", { children: i })
    ] }),
    /* @__PURE__ */ f(
      YO,
      {
        items: o,
        className: di.profilesTable,
        fields: [
          { field: "name", header: "Name" },
          { field: "folder", header: "Folder", sortable: !1, style: { width: "100px" } },
          { field: "id", header: "Actions", sortable: !1, style: { width: 0 } }
        ],
        rowRenderer: (a) => /* @__PURE__ */ f(Zpe, { profile: a, onSelect: t }, a.id)
      }
    )
  ] });
}
function pF({
  title: e = /* @__PURE__ */ f(upe, { title: "Profiles Manager", accentColor: "blue" })
}) {
  const [{ isDev: t, profiles: i, user: r }, , n] = gi((x) => ({
    isDev: x.isDev,
    profiles: x.userGameProfiles,
    user: x.user
  })), o = we(
    () => (i == null ? void 0 : i.filter((x) => x.userId === (r == null ? void 0 : r.plannerId))) || [],
    [i, r]
  ), { api: s } = cu(), { activeFolder: a } = jg(), l = we(() => o.filter((x) => a.id === x.folder), [o, a]), c = Ne(!1), [u, m] = se(!1);
  be(() => {
    c.current === !0 || r === void 0 || r.plannerId === void 0 || (c.current = !0, s.fetchProfiles({ userPlannerId: r.plannerId }).then((x) => {
      n((S) => {
        const R = Ut.cloneDeep(S.userGameProfiles) || [];
        for (const w of x) {
          const T = w, { data: N } = T, D = Fe(T, ["data"]);
          const O = R.findIndex((F) => F.id === D.id);
          O !== -1 ? R[O] = q(q({}, R[O]), D) : R.push(D);
        }
        return { userGameProfiles: R };
      });
    }));
  }, [s, r, n]);
  const { status: g, loadProfileForEditing: h, ConfirmationModal: A, updateProfileFolder: y } = on(), E = (x) => Lt(this, null, function* () {
    if ((r == null ? void 0 : r.plannerId) === void 0)
      return;
    for (const R of x)
      yield s.deleteProfilesInFolder({ id: R });
    const S = yield s.fetchProfiles({ userPlannerId: r == null ? void 0 : r.plannerId });
    n((R) => {
      const w = Ut.cloneDeep(R.userGameProfiles) || [];
      for (const T of S) {
        const N = T, { data: D } = N, O = Fe(N, ["data"]);
        const F = w.findIndex((Y) => Y.id === O.id);
        F !== -1 ? w[F] = q(q({}, w[F]), O) : w.push(O);
      }
      return { userGameProfiles: w };
    });
  }), v = (x) => {
    const S = (o == null ? void 0 : o.filter((R) => x.includes(R.folder))) || [];
    for (const R of S)
      y(R.id, Ra.id);
  }, C = ye(
    (x) => {
      h({ id: x });
    },
    [h]
  );
  return be(() => {
    t && console.log("Profiles updated:", o);
  }, [o, t]), r !== void 0 ? /* @__PURE__ */ f(jC, { backend: LC, children: /* @__PURE__ */ V("div", { className: di.main, children: [
    e,
    /* @__PURE__ */ f(Lpe, {}),
    /* @__PURE__ */ V("div", { className: di.profileBrowser, children: [
      /* @__PURE__ */ f("div", { children: /* @__PURE__ */ f(Wpe, { onDeleteFoldersContent: E, onDeleteFolders: v }) }),
      /* @__PURE__ */ f("div", { className: di.profiles, children: /* @__PURE__ */ f(
        Jpe,
        {
          profiles: u ? o || [] : l,
          onProfileSelect: C,
          headerRightChildren: /* @__PURE__ */ f("div", { children: /* @__PURE__ */ f(Ka, { label: "Show all", value: u, onChange: m }) })
        }
      ) })
    ] }),
    /* @__PURE__ */ f(A, {}),
    g !== "idle" && /* @__PURE__ */ f(dF, {})
  ] }) }) : /* @__PURE__ */ f("div", { className: di.main, children: /* @__PURE__ */ V("span", { children: [
    "Please login at",
    " ",
    /* @__PURE__ */ f("a", { href: "https://maxroll.gg/auth/login", target: "_blank", rel: "noopener noreferrer", children: "maxroll.gg" }),
    " ",
    "first."
  ] }) });
}
function Ppe({ tabsProps: e }) {
  const [{ user: t }] = gi((m) => ({ user: m.user })), { gameCodex: i } = Ui(), { saveEditedProfile: r, hasUnsavedChanges: n } = on(), u = we(() => q({ tabs: [], sideTabs: [] }, e), [e]), { tabs: o, sideTabs: s } = u, a = Fe(u, ["tabs", "sideTabs"]), l = we(
    () => [
      ...i !== void 0 ? [
        {
          selector: "Codex",
          content: /* @__PURE__ */ f("div", { className: fl.tabContent, children: Ei(i, { showTopBar: !1 }) })
        }
      ] : [],
      ...t !== void 0 ? [
        {
          selector: "Embeds",
          content: /* @__PURE__ */ f("div", { className: fl.tabContent, children: /* @__PURE__ */ f(Jhe, {}) })
        }
      ] : [],
      ...o
    ],
    [i, o, t]
  ), c = we(
    () => [
      ...s,
      ...t !== void 0 ? [
        {
          selector: /* @__PURE__ */ f("div", { className: fl.frontendQuickSave, onClick: r, children: /* @__PURE__ */ f(Kt, { buttonStyle: n ? "primary" : "default", disabled: !n, children: "Save Profile" }) }),
          content: "Invalid Tab",
          disableTabChange: !0
        }
      ] : [],
      {
        selector: "Profile Manager",
        content: /* @__PURE__ */ f("div", { className: fl.tabContent, children: /* @__PURE__ */ f(uF, { children: /* @__PURE__ */ f(pF, { title: null }) }) })
      }
    ],
    [n, r, s, t]
  );
  return /* @__PURE__ */ f("div", { className: fl.planner, children: /* @__PURE__ */ f(eI, q({ tabs: l, sideTabs: c }, a)) });
}
function TBe({ tabsProps: e }) {
  return /* @__PURE__ */ f(gF, { children: /* @__PURE__ */ f(Ppe, { tabsProps: e }) });
}
function zpe({ tabsProps: e }) {
  const [{ user: t }] = gi((u) => ({ user: u.user })), { saveEditedProfile: i, hasUnsavedChanges: r } = on(), c = we(() => q({ tabs: [], sideTabs: [] }, e), [e]), { tabs: n, sideTabs: o } = c, s = Fe(c, ["tabs", "sideTabs"]), a = ye(
    (u) => {
      u.preventDefault(), u.stopPropagation(), i();
    },
    [i]
  ), l = we(
    () => [
      ...o,
      ...t !== void 0 ? [
        {
          selector: /* @__PURE__ */ f("div", { className: fl.frontendQuickSave, onClick: a, children: /* @__PURE__ */ f(Kt, { buttonStyle: r ? "primary" : "default", disabled: !r, children: "Save Profile" }) }),
          content: "Invalid Tab",
          disableTabChange: !0
        }
      ] : [],
      {
        selector: "Profile Manager",
        content: /* @__PURE__ */ f("div", { className: fl.tabContent, children: /* @__PURE__ */ f(uF, { children: /* @__PURE__ */ f(pF, { title: null }) }) })
      }
    ],
    [r, a, o, t]
  );
  return /* @__PURE__ */ f("div", { className: fl.planner, children: /* @__PURE__ */ f(eI, q({ tabs: n, sideTabs: l }, s)) });
}
function BBe({
  tabsProps: e,
  supportCommunityBuilds: t
}) {
  return /* @__PURE__ */ f(gF, { supportCommunityBuilds: t, children: /* @__PURE__ */ f(zpe, { tabsProps: e }) });
}
const Hpe = "_Disclaimer_jw1kp_1", Xpe = "_Disclaimer__top_jw1kp_11", _pe = "_Disclaimer__icon_jw1kp_16", $pe = "_Disclaimer__iconContent_jw1kp_27", e1e = "_Disclaimer__title_jw1kp_36", t1e = "_Disclaimer__bottom_jw1kp_42", i1e = "_Disclaimer__content_jw1kp_47", r1e = "_Disclaimer__iconImg_jw1kp_60", ma = {
  Disclaimer: Hpe,
  Disclaimer__top: Xpe,
  Disclaimer__icon: _pe,
  Disclaimer__iconContent: $pe,
  Disclaimer__title: e1e,
  Disclaimer__bottom: t1e,
  Disclaimer__content: i1e,
  "Disclaimer--note": "_Disclaimer--note_jw1kp_52",
  Disclaimer__iconImg: r1e,
  "Disclaimer--quote": "_Disclaimer--quote_jw1kp_67",
  "Disclaimer--warning": "_Disclaimer--warning_jw1kp_82"
}, w6 = {
  note: { defaultTitle: "Note", icon: "icons/megaphone.svg", iconWidth: 18, iconHeight: 20 },
  quote: { defaultTitle: "Quote", icon: "icons/quote.svg", iconWidth: 18, iconHeight: 14 },
  warning: { defaultTitle: "Warning", icon: "icons/warning.svg", iconWidth: 32, iconHeight: 32, iconContent: "!" }
};
function n1e(o) {
  var s = o, { title: e, children: t, type: i = "note", className: r } = s, n = Fe(s, ["title", "children", "type", "className"]);
  const a = i in w6 ? i : "note", l = w6[a];
  return /* @__PURE__ */ V("div", ee(q({ className: me(ma.Disclaimer, ma[`Disclaimer--${a}`], r) }, n), { children: [
    /* @__PURE__ */ V("div", { className: ma.Disclaimer__top, children: [
      /* @__PURE__ */ V("div", { className: ma.Disclaimer__icon, children: [
        /* @__PURE__ */ f(
          Mt,
          {
            className: ma.Disclaimer__iconImg,
            icon: `${l.icon}`,
            width: l.iconWidth,
            height: l.iconHeight
          }
        ),
        l.iconContent ? /* @__PURE__ */ f("span", { className: ma.Disclaimer__iconContent, children: l.iconContent }) : null
      ] }),
      /* @__PURE__ */ f("span", { className: ma.Disclaimer__title, children: e || l.defaultTitle })
    ] }),
    t ? /* @__PURE__ */ f("div", { className: ma.Disclaimer__bottom, children: /* @__PURE__ */ f("div", { className: ma.Disclaimer__content, children: t }) }) : null
  ] }));
}
function o1e({ onThresholdReached: e }) {
  const t = Ne(null);
  return be(() => {
    const i = () => {
      if (!t.current)
        return;
      const r = t.current.getBoundingClientRect(), n = document.documentElement.clientHeight;
      r.top <= n && r.bottom >= 0 && e();
    };
    return document.addEventListener("scroll", i), () => document.removeEventListener("scroll", i);
  }, [e]), /* @__PURE__ */ f("div", { ref: t });
}
class fF {
  constructor({ index: t, meilisearchApiPath: i }) {
    Ze(this, "api");
    Ze(this, "index");
    this.api = i, this.index = t;
  }
  fetch(t, i) {
    return Lt(this, null, function* () {
      return fetch(`${this.api}/indexes/${this.index}/${t}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer 35679298edc476d0b9f9638cdb90d362235a62550bea39d59544f694cc9d90b9"
        },
        body: JSON.stringify(i)
      }).then((r) => {
        if (r.ok)
          return r.json();
        throw "error" in r ? new Error(r.error) : new Error(`Failed to fetch ${t}: ${r.statusText}`);
      });
    });
  }
  search(i) {
    return Lt(this, arguments, function* ({ body: t }) {
      return this.fetch("search", t).then((r) => {
        if (!Array.isArray(r) && "error" in r)
          throw new Error(r.error);
        return r;
      });
    });
  }
  facetSearch(i) {
    return Lt(this, arguments, function* ({ body: t }) {
      return this.fetch("facet-search", t).then((r) => {
        if (!Array.isArray(r) && "error" in r)
          throw new Error(r.error);
        return r;
      });
    });
  }
}
function AF({ siteId: e }) {
  const [{ proxyApi: t }] = gi((r) => ({ proxyApi: r.proxyApi }));
  return { api: we(
    () => new fF({
      index: `planner-profiles-${e}`,
      meilisearchApiPath: t ? "/meilisearch-api" : fi().meilisearchPath
    }),
    [t, e]
  ) };
}
const s1e = "_PlannerBuilds_1k1f7_1", a1e = "_PlannerBuilds__header_1k1f7_6", l1e = "_PlannerBuilds__filters_1k1f7_11", c1e = "_PlannerBuilds__filterRow_1k1f7_19", u1e = "_PlannerBuilds__mainFilter_1k1f7_25", d1e = "_PlannerBuilds__primaryFilter_1k1f7_32", m1e = "_PlannerBuilds__primarySubFilter_1k1f7_37", g1e = "_PlannerBuilds__search_1k1f7_41", h1e = "_PlannerBuilds__tagGroup_1k1f7_44", p1e = "_PlannerBuilds__ad_1k1f7_52", f1e = "_PlannerBuilds__adInner_1k1f7_56", A1e = "_PlannerBuilds__builds_1k1f7_60", Ln = {
  PlannerBuilds: s1e,
  PlannerBuilds__header: a1e,
  PlannerBuilds__filters: l1e,
  PlannerBuilds__filterRow: c1e,
  PlannerBuilds__mainFilter: u1e,
  PlannerBuilds__primaryFilter: d1e,
  PlannerBuilds__primarySubFilter: m1e,
  PlannerBuilds__search: g1e,
  PlannerBuilds__tagGroup: h1e,
  PlannerBuilds__ad: p1e,
  PlannerBuilds__adInner: f1e,
  PlannerBuilds__builds: A1e
};
function y1e({ api: e, body: t }) {
  const i = Ne([]), [r, n] = se("idle"), [o, s] = se(void 0), [a, l] = se(0);
  be(() => {
    l(0), s(void 0), n("idle"), i.current = [], g.current = !0;
  }, [e, t]);
  const c = ye(
    (h) => {
      var y;
      if (i.current.includes(h) || r !== "idle" || h <= a)
        return;
      i.current.push(h);
      const A = (h - 1) * ((y = t.limit) != null ? y : 20);
      e.search({ body: ee(q({}, t), { offset: A }) }).then((E) => {
        s((v) => {
          const C = [...(v == null ? void 0 : v.hits) || []], x = Math.floor(E.offset / t.limit) + 1 || 0;
          for (; x < C.length; )
            C.push([]);
          return C[x - 1] = E.hits, l((S) => Math.max(S, x)), {
            hits: C,
            hitsPerPage: t.limit || 0,
            page: x,
            totalHits: E.estimatedTotalHits || 0,
            totalPages: Math.ceil((E.estimatedTotalHits || 0) / t.limit)
          };
        });
      }).finally(() => {
        n("idle");
      });
    },
    [e, t, a, r]
  ), u = ye(() => {
    c(a + 1);
  }, [c, a]), m = we(() => a < ((o == null ? void 0 : o.totalPages) || 1), [a, o == null ? void 0 : o.totalPages]), g = Ne(!0);
  return be(() => {
    !g.current || a !== 0 || (g.current = !1, c(1));
  }, [c, t, a]), { results: o, showMore: u, hasMorePages: m };
}
const E1e = ({
  siteId: e,
  type: t,
  category: i,
  tags: r,
  primaryFilter: n,
  primarySubFilter: o
}) => {
  const s = [], a = t === "team-darkside-builds" || t === "maxroll-builds" || t === "maxroll-planners";
  s.push(`groups ${a ? "" : "!"}= "${e}"`), i && s.push(`category = "${i}"`);
  const l = Object.values(r).filter((c) => c !== void 0) || [];
  return o ? l.push(o) : n && l.push(n), l.length > 0 && s.push(`tags = ${l.map((c) => `"${c}"`).join(",")}`), { filter: s };
};
function M6({
  category: e,
  onChangeCategory: t,
  plannerCategories: i
}) {
  return i.type === "select" ? /* @__PURE__ */ f(
    _s,
    {
      size: "sm-md",
      value: e,
      options: i.categories,
      onChange: t,
      isClearable: !0
    }
  ) : /* @__PURE__ */ f("div", { className: Ln.PlannerBuilds__tagGroup, children: i.categories.map((r) => /* @__PURE__ */ f(
    Ka,
    {
      value: e === r.value,
      label: r.label,
      onChange: () => {
        t(r);
      }
    },
    r.value
  )) });
}
function DBe({
  siteId: e,
  type: t,
  plannerCategories: i,
  categoryFilterPosition: r,
  plannerTagSets: n,
  buildComponent: o,
  primaryFilterSelector: s,
  primarySubFilterSelector: a,
  getSearchParams: l = E1e
}) {
  const [c] = gi((Q) => ({ md: Q.viewport.md })), { api: u } = AF({ siteId: e }), [m] = gi((Q) => ({ api: Q.proxyApi })), [g, h] = se(void 0), A = ye((Q) => {
    h(($) => $ === Q ? void 0 : Q);
  }, []), [y, E] = se(void 0), v = ye((Q) => {
    E(($) => $ === Q ? void 0 : Q);
  }, []), [C, x] = se(""), [S, R] = se(void 0), [w, T] = se({}), N = ye((Q) => {
    R(Q == null ? void 0 : Q.value);
  }, []), D = ye(
    (Q) => ($) => {
      T((le) => ee(q({}, le), { [`${Q}`]: le[`${Q}`] === ($ == null ? void 0 : $.value) || $ == null ? void 0 : $.value }));
    },
    []
  ), O = ye(
    (Q, $) => () => {
      T((le) => ee(q({}, le), { [`${Q}`]: le[`${Q}`] === $ ? void 0 : $ }));
    },
    []
  ), F = we(() => {
    const { filter: Q } = l({ siteId: e, type: t, category: S, tags: w, primaryFilter: g, primarySubFilter: y });
    return ee(q({}, C.trim() ? { q: C } : {}), {
      limit: 20,
      filter: ["public = 1", ...Q].join(" AND "),
      sort: t === "community-builds" ? ["total_ratings:desc", "average_rating:desc", "date:desc"] : ["date:desc"],
      distinct: "user.username"
    });
  }, [l, e, t, S, w, g, y, C]), { results: Y, showMore: P, hasMorePages: z } = y1e({ api: u, body: F }), [W, H] = se({});
  return be(() => {
    var le;
    const Q = [];
    for (const he of (le = Y == null ? void 0 : Y.hits) != null ? le : [])
      for (const oe of he)
        oe.user.username in W || Q.push(oe.user.username);
    if (Q.length === 0)
      return;
    new fF({
      index: `planner-profiles-${e}`,
      meilisearchApiPath: m.api ? "/meilisearch-api" : "https://meilisearch.maxroll.gg"
    }).facetSearch({
      body: {
        filter: [`public = 1 AND user.username IN [${Q.map((he) => `"${he}"`).join(", ")}]`],
        facetName: "user.username"
      }
    }).then((he) => {
      H((oe) => {
        const ue = Ut.cloneDeep(oe);
        for (const Ae of he.facetHits)
          ue[Ae.value] = Ae.count;
        return ue;
      });
    });
  }, [u, W, m.api, Y, e]), /* @__PURE__ */ V("div", { className: Ln.PlannerBuilds, children: [
    /* @__PURE__ */ V("div", { className: Ln.PlannerBuilds__header, children: [
      /* @__PURE__ */ V("div", { className: Ln.PlannerBuilds__filters, children: [
        /* @__PURE__ */ V("div", { className: Ln.PlannerBuilds__mainFilter, children: [
          /* @__PURE__ */ f("div", { className: Ln.PlannerBuilds__primaryFilter, children: Ei(s, { value: g, onChange: A }) }),
          a ? /* @__PURE__ */ f("div", { className: Ln.PlannerBuilds__primarySubFilter, children: Ei(a, {
            value: y,
            parentValue: g,
            onChange: v
          }) }) : void 0
        ] }),
        /* @__PURE__ */ V("div", { className: Ln.PlannerBuilds__filterRow, children: [
          r === void 0 ? /* @__PURE__ */ f(
            M6,
            {
              category: S,
              onChangeCategory: N,
              plannerCategories: i
            }
          ) : void 0,
          n.map((Q, $) => /* @__PURE__ */ V(bl, { children: [
            r === $ ? /* @__PURE__ */ f(
              M6,
              {
                category: S,
                onChangeCategory: N,
                plannerCategories: i
              }
            ) : void 0,
            Q.type === "select" ? /* @__PURE__ */ f(
              _s,
              {
                size: "sm-md",
                value: w[$],
                options: Q.tags,
                onChange: D($),
                isClearable: !0
              }
            ) : /* @__PURE__ */ f("div", { className: Ln.PlannerBuilds__tagGroup, children: Q.tags.map((le) => /* @__PURE__ */ f(
              Ka,
              {
                value: w[$] === le.value,
                label: le.label,
                onChange: O($, le.value)
              },
              le.value
            )) })
          ] }, $)),
          /* @__PURE__ */ f(
            wg,
            {
              className: Ln.PlannerBuilds__search,
              size: "sm-md",
              value: C,
              onChange: x,
              placeholder: "Search"
            }
          )
        ] })
      ] }),
      c.md && /* @__PURE__ */ f("div", { className: Ln.PlannerBuilds__ad, children: /* @__PURE__ */ f($0, { className: Ln.PlannerBuilds__adInner, title: "Advertisement", children: /* @__PURE__ */ f(Vf, { id: `${e}-${t}`, isVideo: !0 }) }) })
    ] }),
    t === "community-builds" && /* @__PURE__ */ f(n1e, { className: Ln.PlannerBuilds__disclaimer, type: "note", children: "These are community builds where anyone can make a build - Remember to rate a build if you like or dislike it!" }),
    /* @__PURE__ */ V("div", { className: Ln.PlannerBuilds__builds, children: [
      Y == null ? void 0 : Y.hits.map((Q, $) => /* @__PURE__ */ f(bl, { children: Q.map(
        (le, he) => {
          var oe;
          return Ei(o, {
            key: he,
            profile: le,
            profilesByAuthorCount: Math.max(0, ((oe = W[le.user.username]) != null ? oe : 1) - 1),
            type: t,
            siteId: e,
            plannerCategories: i,
            plannerTagSets: n,
            buildComponent: o
          });
        }
      ) }, $)),
      z && /* @__PURE__ */ f(o1e, { onThresholdReached: P })
    ] })
  ] });
}
const v1e = "_AdminTools_zpd40_1", b1e = "_AdminTools__btn_zpd40_4", C1e = "_AdminTools__icon_zpd40_16", x1e = "_Modal_zpd40_23", I1e = "_Modal__content_zpd40_24", S1e = "_Modal__title_zpd40_28", R1e = "_Modal__error_zpd40_34", k1e = "_Modal__actions_zpd40_38", is = {
  AdminTools: v1e,
  AdminTools__btn: b1e,
  AdminTools__icon: C1e,
  Modal: x1e,
  Modal__content: I1e,
  Modal__title: S1e,
  Modal__error: R1e,
  Modal__actions: k1e
};
function yF({ profileId: e, api: t }) {
  const { notifySuccess: i } = Yf(), { getConfirmation: r, ConfirmationModal: n } = iI(), [o, s] = se(void 0), [{ userLevel: a }] = gi((A) => {
    var y;
    return { userLevel: (y = A.user) == null ? void 0 : y.userLevel };
  }), l = we(() => a && a >= 10, [a]), [c, u] = se(!1), m = ye(
    (A) => {
      u(A);
    },
    [u]
  ), g = ye(() => {
    t.adminUnlistProfile(e).catch((A) => {
      s(A.message);
    }).then(() => {
      m(!1), i("Profile unlisted succesfully!");
    });
  }, [t, e, m, i]), h = ye(() => {
    t.adminDeleteProfile(e).catch((A) => {
      s(A.message);
    }).then(() => {
      m(!1), i("Profile deleted succesfully!");
    });
  }, [t, e, m, i]);
  return l ? /* @__PURE__ */ V("div", { className: is.AdminTools, children: [
    /* @__PURE__ */ f(
      Kt,
      {
        buttonStyle: "primary2",
        className: is.AdminTools__btn,
        size: "sm",
        onClick: (A) => {
          A.preventDefault(), A.stopPropagation(), m(!0);
        },
        children: /* @__PURE__ */ f(Mt, { className: is.AdminTools__icon, width: 24, height: 20, icon: "icons/toolbox.svg" })
      }
    ),
    /* @__PURE__ */ f(
      qf,
      {
        className: is.Modal,
        innerClassName: is.Modal__contentWrapper,
        visible: c,
        onClick: (A) => {
          A.preventDefault(), A.stopPropagation();
        },
        onClose: () => {
          m(!1);
        },
        children: /* @__PURE__ */ V("div", { className: is.Modal__content, children: [
          /* @__PURE__ */ V("div", { className: is.Modal__body, children: [
            /* @__PURE__ */ f("h3", { className: is.Modal__title, children: "Admin Tools" }),
            /* @__PURE__ */ V("div", { className: is.Modal__actions, children: [
              /* @__PURE__ */ f(
                Kt,
                {
                  size: "md",
                  onClick: (A) => {
                    A.preventDefault(), A.stopPropagation(), g();
                  },
                  children: "Unlist Profile"
                }
              ),
              /* @__PURE__ */ f(
                Kt,
                {
                  size: "md",
                  buttonStyle: "danger",
                  onClick: (A) => {
                    A.preventDefault(), A.stopPropagation(), r({
                      content: /* @__PURE__ */ V("span", { style: { fontSize: "18px" }, children: [
                        "Are you sure you want to ",
                        /* @__PURE__ */ f("strong", { children: "DELETE" }),
                        " this profile?"
                      ] })
                    }).then((y) => {
                      y && h();
                    });
                  },
                  children: "Delete Profile"
                }
              )
            ] }),
            /* @__PURE__ */ f("p", { className: is.Modal__error, children: o })
          ] }),
          /* @__PURE__ */ f("div", { className: is.Modal__Actions, children: /* @__PURE__ */ f(
            Kt,
            {
              buttonStyle: "primary",
              onClick: () => {
                m(!1);
              },
              children: "Close"
            }
          ) }),
          /* @__PURE__ */ f(n, {})
        ] })
      }
    )
  ] }) : void 0;
}
function w1e({ profileId: e, siteId: t }) {
  const { api: i } = zme({ siteId: t });
  return /* @__PURE__ */ f(yF, { profileId: e, api: i });
}
function OBe({ profileId: e }) {
  const { api: t } = cu();
  return /* @__PURE__ */ f(yF, { profileId: e, api: t });
}
const M1e = "_Badge_keys0_1", N1e = "_Badge__icon_keys0_9", N6 = {
  Badge: M1e,
  Badge__icon: N1e
};
function T1e(i) {
  var r = i, { className: e } = r, t = Fe(r, ["className"]);
  return /* @__PURE__ */ V("span", ee(q({ className: me(N6.Badge, e) }, t), { children: [
    /* @__PURE__ */ f(Mt, { className: N6.Badge__icon, width: 10, height: 11, icon: "maxroll-mark-icon.svg" }),
    /* @__PURE__ */ f("svg", { width: "16", height: "17", viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f(
      "path",
      {
        d: "M11.2875 2.07823C9.63203 1.08503 9.60913 0 7.99947 0C6.38981 0 6.3669 1.08163 4.71144 2.07823C3.05598 3.07483 2.14319 2.55102 1.33836 4C0.533526 5.44898 1.42342 6.01361 1.42342 8C1.42342 9.98639 0.530255 10.5476 1.33836 12C2.14646 13.4524 3.05598 12.9286 4.71144 13.9218C6.3669 14.915 6.38981 16 7.99947 16C9.60913 16 9.63203 14.9184 11.2875 13.9218C12.943 12.9252 13.8525 13.4558 14.6606 12C15.4621 10.5544 14.5755 9.9898 14.5755 8C14.5755 6.0102 15.4687 5.45578 14.6638 4.0068C13.859 2.55442 12.943 3.07143 11.2875 2.07823Z",
        fill: "#057AF0"
      }
    ) })
  ] }));
}
const B1e = [
  {
    slug: "d4",
    title: "Diablo IV",
    members: [
      {
        slug: "wudijo",
        title: "Director"
      },
      {
        slug: "echohack"
      },
      {
        slug: "macrobioboi"
      },
      {
        slug: "chewingnom"
      },
      {
        slug: "northwar"
      },
      {
        slug: "dieoxide"
      },
      {
        slug: "boiler"
      },
      {
        slug: "snail"
      },
      {
        slug: "chronikz"
      },
      {
        slug: "luckyluciano"
      },
      {
        slug: "avarilyn"
      },
      {
        slug: "kondyss"
      },
      {
        slug: "pandaglassjaw"
      },
      {
        slug: "beatdropper"
      },
      {
        slug: "deezythemonster"
      },
      {
        slug: "insnebob"
      },
      {
        slug: "serocifkre"
      },
      {
        slug: "lordxsaura"
      },
      {
        slug: "danger"
      },
      {
        slug: "icytroll"
      },
      {
        slug: "aoinomiku"
      }
    ]
  },
  {
    slug: "d2",
    title: "Diablo II",
    members: [
      {
        slug: "teo1904"
      },
      {
        slug: "macrobioboi"
      },
      {
        slug: "jymnasium"
      }
    ]
  },
  {
    slug: "d3",
    title: "Diablo III",
    members: [
      {
        slug: "wudijo"
      },
      {
        slug: "northwar"
      },
      {
        slug: "chewingnom"
      }
    ]
  },
  {
    slug: "poe",
    title: "PoE",
    members: [
      {
        slug: "crouchingtuna",
        title: "Director"
      },
      {
        slug: "zizaran",
        title: "Director"
      },
      {
        slug: "palsteron"
      },
      {
        slug: "tripolarbear"
      },
      {
        slug: "tytykiller"
      },
      {
        slug: "spicysushi"
      },
      {
        slug: "aer0"
      },
      {
        slug: "milkybk"
      },
      {
        slug: "zenm"
      },
      {
        slug: "subtractem"
      },
      {
        slug: "void241"
      },
      {
        slug: "cptngarbage"
      },
      {
        slug: "helmbreaker"
      },
      {
        slug: "carn"
      },
      {
        slug: "goratha"
      },
      {
        slug: "havoc"
      },
      {
        slug: "ventrua"
      },
      {
        slug: "ziggyd"
      },
      {
        slug: "steelmage"
      },
      {
        slug: "velyna"
      }
    ]
  },
  {
    slug: "poe2",
    title: "PoE 2",
    members: [
      {
        slug: "crouchingtuna",
        title: "Director"
      },
      {
        slug: "zizaran",
        title: "Director"
      },
      {
        slug: "steelmage"
      },
      {
        slug: "ziggyd"
      },
      {
        slug: "palsteron"
      },
      {
        slug: "goratha"
      },
      {
        slug: "ventrua"
      },
      {
        slug: "captainlance"
      },
      {
        slug: "tytykiller"
      },
      {
        slug: "havoc"
      },
      {
        slug: "carn"
      },
      {
        slug: "subtractem"
      },
      {
        slug: "cptngarbage"
      },
      {
        slug: "void241"
      },
      {
        slug: "helmbreaker"
      },
      {
        slug: "zenm"
      },
      {
        slug: "milkybk"
      },
      {
        slug: "spicysushi"
      },
      {
        slug: "aer0"
      },
      {
        slug: "tripolarbear"
      },
      {
        slug: "chronikz"
      }
    ]
  },
  {
    slug: "le",
    title: "Last Epoch",
    members: [
      {
        slug: "lizard"
      },
      {
        slug: "mcfluffin"
      },
      {
        slug: "terek"
      },
      {
        slug: "volca"
      },
      {
        slug: "binashole"
      },
      {
        slug: "boardman21"
      },
      {
        slug: "visiongl"
      },
      {
        slug: "amarathy"
      }
    ]
  },
  {
    slug: "la",
    title: "Lost Ark",
    members: [
      {
        slug: "perciculum"
      },
      {
        slug: "choilicious"
      },
      {
        slug: "starlast"
      },
      {
        slug: "raeinor"
      },
      {
        slug: "civo"
      },
      {
        slug: "sekwah"
      }
    ]
  },
  {
    slug: "destiny-2",
    title: "Destiny 2",
    members: [
      {
        slug: "xtra37"
      }
    ]
  },
  {
    slug: "tal",
    title: "Throne and Liberty",
    members: [
      {
        slug: "yaen",
        title: "Team Lead"
      },
      {
        slug: "bloo"
      },
      {
        slug: "nymm"
      },
      {
        slug: "elie"
      },
      {
        slug: "grenton"
      },
      {
        slug: "tweekz"
      }
    ]
  },
  {
    slug: "affiliate",
    title: "Affiliate",
    members: [
      {
        slug: "annacake"
      },
      {
        slug: "rhykker"
      },
      {
        slug: "moxsy"
      },
      {
        slug: "barricade"
      }
    ]
  },
  {
    slug: "staff",
    title: "Staff",
    members: [
      {
        slug: "d07riv"
      },
      {
        slug: "vortimor"
      },
      {
        slug: "tenkiei",
        title: "Content Management"
      },
      {
        slug: "lotware"
      },
      {
        slug: "spirit"
      },
      {
        slug: "whitefox"
      },
      {
        slug: "dredscythe",
        title: "Content Management"
      }
    ]
  },
  {
    slug: "management",
    title: "Management",
    members: [
      {
        slug: "silent"
      },
      {
        slug: "wudijo",
        title: "Director of Diablo Franchise"
      }
    ]
  }
], D1e = {
  maxroll: {
    image: "maxroll-mark-icon.svg",
    name: "Maxroll",
    nickname: "Maxroll"
  },
  raxxanterax: {
    image: "legacy/team/ryan-profile.png",
    name: "Ryan S.",
    nickname: "Raxxanterax",
    title: "Content Creator",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/raxxanterax",
      youtube: "https://www.youtube.com/raxxanterax",
      twitter: "https://twitter.com/raxxanterax",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  wudijo: {
    image: "legacy/team/max-profile.png",
    name: "Max R.",
    nickname: "wudijo",
    title: "Team Lead",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/wudijo",
      youtube: "https://www.youtube.com/c/wudijo",
      twitter: "https://twitter.com/wudijo",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Father of the famous Ball Lightning build of Season 1, Demon Hunter extraordinaire and a curiosity-driven theorycrafter by heart, wudijo has shown his creativity and passion for the game time and time again. He has played Diablo III since its inception, finishing the punishing Inferno difficulty on Hardcore early on and always striving to create the best possible setups ever since. Today he is known for his manic solo pushes that regularly expand the limits of what’s possible at the highest levels, achieving top placements on the leaderboards season after season even without the endless grind. When in doubt, you will usually find him hunting for his next Rank 1 clear on EU."
  },
  northwar: {
    image: "legacy/team/sergei-profile.png",
    name: "Sergei Z.",
    nickname: "Northwar",
    title: "Content Creator",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/northwar",
      youtube: "https://www.youtube.com/user/Northwar1000",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  d07riv: {
    image: "legacy/team/andrey-profile.png",
    name: "Andrey K.",
    nickname: "Riv",
    title: "Full Stack Developer",
    email: "",
    social: {
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Owner of Planners"
  },
  silent: {
    image: "legacy/team/stephen-profile.png",
    name: "Stephen H.",
    nickname: "Silent",
    title: "CTO",
    email: "silent@maxroll.gg",
    social: {
      twitter: "https://twitter.com/thecodeassassin",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  yarp: {
    image: "legacy/team/dan-profile.png",
    title: "Creative Director",
    name: "Daniel O.",
    nickname: "Yarp",
    email: "dan.oppel@gmail.com",
    social: {
      twitch: "https://www.twitch.tv/yarp",
      twitter: "https://twitter.com/yarpgg",
      discord: "https://discord.gg/WBBwg5X",
      dribbble: "https://dribbble.com/DanOppel"
    },
    bio: "Coming Soon"
  },
  rhykker: {
    image: "legacy/team/cj-profile.png",
    title: "Content Creator",
    name: "CJ M.",
    nickname: "Rhykker",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/rhykker",
      youtube: "https://www.youtube.com/user/Rhykker",
      twitter: "https://twitter.com/rhykker",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  chewingnom: {
    image: "legacy/team/chewi-profile.png",
    title: "Content Creator",
    name: "Jonathan M.",
    nickname: "Chewi",
    email: "",
    social: {
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/channel/UCH_RsqMBFy0dA_53cqXa8mQ"
    },
    bio: "Coming Soon"
  },
  rogga: {
    image: "legacy/team/rogga-profile.png",
    title: "Discord Admin",
    name: "Roger B.",
    nickname: "Rogga",
    email: "contact@maxroll.gg",
    social: {
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  teo1904: {
    image: "legacy/team/teo-profilemxr.png",
    title: "Content Creator",
    name: "Pascal F.",
    nickname: "Teo1904",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/teo1904",
      youtube: "https://www.youtube.com/channel/UCVQ58eU1mvsjyeg9okN-TrA",
      twitter: "https://twitter.com/Teo_1904",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  macrobioboi: {
    image: "legacy/team/Mac_profilemxr.png",
    title: "Content Creator",
    name: "Marco C.",
    nickname: "MacroBioBoi",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/macrobioboi",
      youtube: "https://www.youtube.com/channel/UCcGVtNmgZsQ5wXETTGyMQGQ",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  btneandertha1: {
    image: "legacy/team/BT_profilemxr.png",
    title: "Content Creator",
    name: "Timothy S.",
    nickname: "BTNeandertha1",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/btneandertha1",
      youtube: "https://www.youtube.com/c/BTNeanderthal",
      twitter: "https://www.twitter.com/BTNeandertha1",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  darkhumility: {
    image: "legacy/team/dark_humlity_profilemxr.png",
    title: "Content Creator",
    name: "Jeffrey H.",
    nickname: "DarkHumility",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/darkhumility",
      youtube: "https://www.youtube.com/channel/UCNOyFRjhyQ6yM1OvNSc5TGQ",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  coooley: {
    image: "legacy/team/Coooley_profilemxr.png",
    title: "PvP Guides",
    name: "Michael C.",
    nickname: "Coooley",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/coooley",
      youtube: "https://www.youtube.com/channel/UCTy-9QNmP0Gekdrf6YwA2yA",
      twitter: "https://twitter.com/coooley",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  vortimor: {
    image: "legacy/team/Marti-hexagon.png",
    title: "Asset-Design",
    name: "Martin P.",
    nickname: "Vortimor",
    email: "vortimor9@gmail.com",
    social: {
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  annacake: {
    image: "legacy/team/anna-profile.png",
    title: "Streamer",
    name: "Anna N.",
    nickname: "AnnacakeLIVE",
    email: "annacakes@outlook.de",
    social: {
      twitch: "https://www.twitch.tv/annacakelive",
      youtube: "https://www.youtube.com/channel/UCXnvQfYT38UEeagoLxuqBkg",
      twitter: "https://twitter.com/annacakel",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  echohack: {
    image: "team/echohack3.png",
    customImageWidth: 188,
    title: "Content Creator",
    name: "David E.",
    nickname: "echohack",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/echohack",
      twitter: "https://www.twitter.com/echohack",
      discord: "https://discord.gg/XNxrHCmyjt",
      youtube: "https://youtube.com/echohack"
    },
    bio: "Coming Soon"
  },
  dredscythe: {
    image: "legacy/team/dredscythe-profile.png",
    title: "Content Creator",
    name: "Robert G.",
    nickname: "dredscythe",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/dred_scythe",
      youtube: "https://www.youtube.com/channel/UCIIeik9pbZMwLkwbWeRXLwQ",
      twitter: "https://twitter.com/Dredscythe",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  lotware: {
    image: "legacy/team/Lotware.png",
    title: "Discord Moderator",
    name: "Bosco L.",
    nickname: "Lotware",
    email: "",
    social: {
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  mbxtreme: {
    image: "legacy/team/mbx.png",
    title: "Team Lead",
    name: "Mario B.",
    nickname: "mbXtreme",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/mbXtreme",
      youtube: "https://www.youtube.com/c/mbxtreme",
      twitter: "https://twitter.com/mbXtreme",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  choilicious: {
    image: "legacy/team/choi.png",
    title: "Content Creator",
    name: "Edmunds R.",
    nickname: "Choilicious",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/Choilicious",
      youtube: "https://www.youtube.com/choilicious",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  perciculum: {
    image: "legacy/team/perci.png",
    title: "Team Lead",
    name: "Darlsan A.",
    nickname: "Perciculum",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/perciculum",
      youtube: "https://www.youtube.com/channel/UCqOs7pai63F79iB2gkXBH4g",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  yaen: {
    image: "team/yaen.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "Richard C.",
    nickname: "Yaen",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/yaen__",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  reitear: {
    image: "legacy/team/reitear-profile.png",
    title: "Content Creator",
    name: "Ong H.",
    nickname: "Reitear",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/reitear",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  starlast: {
    image: "legacy/team/starlast-profile.png",
    title: "Content Creator",
    name: "Kevin L.",
    nickname: "Starlast",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/starlast7",
      youtube: "https://www.youtube.com/channel/UCGQV38YAuw2Hep3aOvGM9gg",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  palsteron: {
    image: "legacy/team/palsteron-profile.png",
    title: "Content Creator",
    name: "Daniel S.",
    nickname: "Palsteron",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/palsteron",
      youtube: "https://www.youtube.com/c/Palsteron",
      twitter: "https://twitter.com/palsteron",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  lizard: {
    image: "legacy/team/lizardirl-profile.png",
    title: "Team Lead",
    name: "Joan F.V.",
    nickname: "LizardIRL",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/lizard_irl",
      youtube: "https://www.youtube.com/channel/UCGGBPmPIR378tE-LK5wr88w",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  mcfluffin: {
    image: "legacy/team/mcfluffin-profile.png",
    title: "Content Creator",
    name: "Raith B.",
    nickname: "McFluffin",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/lonestar_mcfluffin",
      youtube: "https://www.youtube.com/@McFluffinGaming",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  terek: {
    image: "legacy/team/terek-profile.png",
    title: "Content Creator",
    name: "Romain V.",
    nickname: "Terek",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/ter3k",
      youtube: "https://www.youtube.com/@Terek_LE",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  crouchingtuna: {
    image: "legacy/team/crouching_tuna-profile.png",
    title: "Director of POE Franchise",
    name: "Joshua C.",
    nickname: "Crouching_Tuna",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/crouching_tuna",
      youtube: "https://www.youtube.com/CrouchingTuna",
      twitter: "https://twitter.com/TunaCrouching",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  grimro: {
    image: "legacy/team/grimro-profile.png",
    title: "Content Creator",
    name: "Daniel H.",
    nickname: "Grimro",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/grimro",
      youtube: "https://www.youtube.com/grimro",
      twitter: "https://twitter.com/grimropoe",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  tripolarbear: {
    image: "legacy/team/tripolarbear-profile.png",
    title: "Content Creator",
    name: "TriPolarBear",
    nickname: "TriPolarBear",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/TriPolarBear",
      youtube: "https://www.youtube.com/tripolarbear",
      twitter: "https://twitter.com/trip0larbear",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  tytykiller: {
    image: "legacy/team/tytykiller-profile.png",
    title: "Content Creator",
    name: "Tyler P.",
    nickname: "Tytykiller",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/tytykiller",
      youtube: "https://www.youtube.com/Tytykiller",
      twitter: "https://twitter.com/Tytykiller_",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  spicysushi: {
    image: "legacy/team/spicysushi-profile.png",
    title: "Content Creator",
    name: "Ian S.",
    nickname: "Spicysushi",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/spicysushi_poe",
      youtube: "https://www.youtube.com/c/SpicysushiPoE",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  aristotelian: {
    image: "team/aristotelian.png",
    customImageWidth: 188,
    title: "Editor",
    name: "Aristotelian",
    nickname: "Aristotelian",
    email: "",
    social: {
      twitch: "https://twitch.tv/thearistotelian",
      youtube: "https://www.youtube.com/@thearistotelianYT",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  dieoxide: {
    image: "legacy/team/dieoxide-profile.png",
    title: "Content Creator",
    name: "Travis S.",
    nickname: "DiEoxidE",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/dieoxide",
      youtube: "https://www.youtube.com/c/dieoxide",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  jymnasium: {
    image: "legacy/team/jymnasium-profile_new.png",
    title: "Content Creator",
    name: "Barry M.",
    nickname: "Jymnasium",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/jymnasium",
      youtube: "https://www.youtube.com/@jymnasium/featured",
      twitter: "https://twitter.com/Jymnasium_D2",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  tenkiei: {
    image: "team/tenkiei.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "Tenkiei",
    nickname: "Tenkiei",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/tenkiei",
      youtube: "https://www.youtube.com/@Tenkiei",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming soon"
  },
  milkybk: {
    image: "legacy/team/milkybk.png",
    title: "Content Creator",
    name: "Josh K.",
    nickname: "Milkybk_",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/milkybk_",
      youtube: "https://www.youtube.com/@Milkybk_",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming soon"
  },
  xtra37: {
    image: "legacy/team/xtra3737.png",
    title: "Content Creator",
    name: "Xtra37",
    nickname: "Xtra37",
    email: "",
    social: {
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming soon"
  },
  lizexmachina: {
    image: "generic_profile.png",
    customImageWidth: 188,
    title: "Content Creator",
    name: "Liz P.",
    nickname: "LizExMachina",
    email: "",
    social: {
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming soon"
  },
  zenm: {
    image: "team/zen_m.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "Przemyslaw P.",
    nickname: "Zen_M",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/zen_m",
      youtube: "https://www.youtube.com/channel/UCWVDXpdRWYf2oKXfIP2cR6w",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming soon"
  },
  aer0: {
    image: "legacy/team/aer0.png",
    title: "Content Creator",
    name: "aer0",
    nickname: "aer0",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/aer0__",
      twitter: "https://twitter.com/aer0ttv",
      youtube: "https://www.youtube.com/@aer0/videos",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  volca: {
    image: "team/volca.png",
    customImageWidth: 188,
    title: "Content Creator",
    name: "Aleksi L.",
    nickname: "Volca",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/volca_",
      youtube: "https://www.youtube.com/user/volcavids",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  spirit: {
    image: "team/spirit.webp",
    customImageWidth: 188,
    title: "Full Stack Developer",
    name: "Lorand K.",
    nickname: "Spirit",
    email: "",
    social: {
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  boiler: {
    image: "team/boiler.webp",
    title: "Content Creator",
    name: "Evan G.",
    nickname: "IBoilerUp",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/iboilerup",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  snail: {
    image: "generic_profile.png",
    customImageWidth: 188,
    title: "Content Creator",
    name: "Drew Y.",
    nickname: "Snail",
    email: "",
    social: {
      twitch: "http://twitch.com/insectpolitics",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  binashole: {
    image: "team/binashole.png",
    customImageWidth: 188,
    title: "Content Creator",
    name: "Bernard L.",
    nickname: "BinaQc",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/binaqc",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/@BinaQc"
    },
    bio: "Coming Soon"
  },
  subtractem: {
    image: "team/subtractem.jpg",
    customImageWidth: 188,
    title: "Content Creator",
    name: "Adam C.",
    nickname: "Subtractem",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/subtractem",
      discord: "https://discord.gg/4zBcP79gBU",
      youtube: "https://www.youtube.com/channel/UCkjbN2BlTwm7XknNjLOj7Hg"
    },
    bio: "Coming Soon"
  },
  boardman21: {
    image: "team/boardman.jpg",
    customImageWidth: 188,
    title: "Content Creator",
    name: "Nathaniel B.",
    nickname: "Boardman21",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/boardman21",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/channel/UCcKCZPldPq-8YRTLxUF0t4A"
    },
    bio: "Coming Soon"
  },
  slothmaster: {
    image: "team/slothmaster.jpeg",
    customImageWidth: 188,
    title: "Content Creator",
    name: "Cyprian T.",
    nickname: "Slothmaster",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/professorslothmaster",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/channel/UC-Y8U34S6nUkmTQUJ1ELiSw"
    },
    bio: "Coming Soon"
  },
  chronikz: {
    image: "team/chronikz.png",
    customImageWidth: 188,
    title: "Content Creator",
    name: "Erik R.",
    nickname: "Chronikz",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/chronikz",
      discord: "https://discord.gg/2je9aWrqdt",
      youtube: "https://www.youtube.com/Chronikz",
      twitter: "https://twitter.com/ChronikzTR"
    },
    bio: "Coming Soon"
  },
  moxsy: {
    image: "team/moxsy.png",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "Moxsy",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/moxsy",
      discord: "https://discord.com/invite/moxsy",
      youtube: "https://www.youtube.com/channel/UCqUYttljh7bvi6mvHzpiMIA",
      twitter: "https://twitter.com/MoxsyOG"
    },
    bio: "Coming Soon"
  },
  void241: {
    image: "team/void.png",
    customImageWidth: 188,
    title: "Content Creator",
    name: "Jordan L.",
    nickname: "Void241",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/void241",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/@void2412"
    },
    bio: "Coming Soon"
  },
  raeinor: {
    image: "team/raeinor.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "Raeinor",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/raeinor",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/@raeinor"
    },
    bio: "Coming Soon"
  },
  civo: {
    image: "team/civo.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "Civo",
    email: "",
    social: {
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  sekwah: {
    image: "team/sekwah.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "Sekwah",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/sekwah",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/@SekwahAR"
    },
    bio: "Coming Soon"
  },
  luckyluciano: {
    image: "team/luckyluciano.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "Lucky Luciano",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/luckyluciano",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/LuckyLuciano6",
      twitter: "https://twitter.com/LuckyLuciano610"
    },
    bio: "Coming Soon"
  },
  visiongl: {
    image: "team/visiongl.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "Matt D.",
    nickname: "VisionGL",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/VisionGL",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/@Vision_GL",
      twitter: "https://twitter.com/thevisiongl"
    },
    bio: "Coming Soon"
  },
  avarilyn: {
    image: "generic_profile.png",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "Avarilyn",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/avarilyn",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/@avarilyn"
    },
    bio: "Coming Soon"
  },
  zizaran: {
    image: "team/zizaran.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "Kjetil K.",
    nickname: "Zizaran",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/zizaran",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/zizaran",
      twitter: "https://twitter.com/zizaran"
    },
    bio: "Coming Soon"
  },
  cptngarbage: {
    image: "team/cptn-garbage.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "Cptn Garbage",
    email: "",
    social: {
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  whitefox: {
    image: "team/daniele.jpg",
    customImageWidth: 188,
    title: "Frontend Developer",
    name: "Daniele O.",
    nickname: "Whitefox",
    email: "",
    social: {
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  byrdman: {
    image: "team/byrdman.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "Byrdman",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/byrdman778",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/@byrdman",
      twitter: "https://twitter.com/Byrdman778"
    },
    bio: "Coming Soon"
  },
  chadly: {
    image: "team/chadly.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "Chadly",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/chadly99",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/@Chadly99",
      twitter: "https://twitter.com/Chadly_99"
    },
    bio: "Coming Soon"
  },
  mkaytea: {
    image: "team/mkt1.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "mkaytea",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/mkaytea",
      discord: "https://discord.gg/WBBwg5X",
      twitter: "https://twitter.com/mkayteaTTV"
    },
    bio: "Coming Soon"
  },
  soapgod: {
    image: "team/soapgod.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "Soap GOD",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/soap_god",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/@SoapGOD",
      twitter: "https://twitter.com/Soap_GOD"
    },
    bio: "Coming Soon"
  },
  kondyss: {
    image: "team/kondyss.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "Kondyss",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/kondyss",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/@Kondyss",
      twitter: "https://twitter.com/Kondyss"
    },
    bio: "Coming Soon"
  },
  blamefrost: {
    image: "team/frost.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "Frost",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/blamefrost",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/@BlameFrost",
      twitter: "https://twitter.com/BlameFrost"
    },
    bio: "Coming Soon"
  },
  brozime: {
    image: "team/brozime.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "Brozime",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/Brozime",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/Brozime",
      twitter: "https://twitter.com/Brozime"
    },
    bio: "Coming Soon"
  },
  iamsaruh: {
    image: "team/iamsaruh.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "iAmSaruh",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/iamsaruh",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  ehtoka: {
    image: "team/ehtoka.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "ehtoka",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/ehtoka",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  coffeebns: {
    image: "team/coffee-bns.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "CoffeeBns",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/CoffeeBns",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/@CoffeeBns"
    },
    bio: "Coming Soon"
  },
  amarathy: {
    image: "team/amarathy.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "Amarathy",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/amarathy",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/@amityqt"
    },
    bio: "Coming Soon"
  },
  helmbreaker: {
    image: "team/helm-breaker.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "Helm Breaker",
    email: "",
    social: {
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/@HelmBreaker594"
    },
    bio: "Coming Soon"
  },
  carn: {
    image: "team/carn.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "cArn_",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/carn_",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/@CARNDARAK",
      twitter: "https://twitter.com/CARNDARAK"
    },
    bio: "Coming Soon"
  },
  pandaglassjaw: {
    image: "team/pandaglassjaw.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "pandaglassjaw",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/pandaglassjaw",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/@pandaglassjaw"
    },
    bio: "Coming Soon"
  },
  nymm: {
    image: "team/nymm.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "Nymphellas",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/nymphellas",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  grenton: {
    image: "team/grenton.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "Grenton",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/notgrenton",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/grentoncasts",
      twitter: "https://x.com/notgrenton"
    },
    bio: "Coming Soon"
  },
  elie: {
    image: "team/elie.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "Eli",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/elielii",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/@EliEli.MMOPVP"
    },
    bio: "Coming Soon"
  },
  bloo: {
    image: "team/bloo.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "Bloo",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/itmebloo",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/BDOBloo",
      twitter: "https://x.com/bdobloo"
    },
    bio: "Coming Soon"
  },
  abbyhour: {
    image: "team/abbyhour.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "AbbyHour",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/abbyhour",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/@AbbyHour",
      twitter: "https://x.com/AbbyHour"
    },
    bio: "Coming Soon"
  },
  goratha: {
    image: "team/goratha.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "Goratha",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/goratha",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/@goratha",
      twitter: "https://x.com/gorathapoe"
    },
    bio: "Coming Soon"
  },
  havoc: {
    image: "team/havoc616.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "havoc616",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/havoc616",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/@havoc616VODS",
      twitter: "https://x.com/Havoc616_"
    },
    bio: "Coming Soon"
  },
  haaaterade: {
    image: "team/haaaterade.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "Haaaterade",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/haaaterade",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/@Haaaterade",
      twitter: "https://x.com/_haaaterade_"
    },
    bio: "Coming Soon"
  },
  beatdropper: {
    image: "team/beatdropper.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "Beatdropper",
    email: "",
    social: {
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/@BeatdropperFR"
    },
    bio: "Coming Soon"
  },
  insnebob: {
    image: "generic_profile.png",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "Insnebob",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/insnebob",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/@Insnebob",
      twitter: "https://x.com/insnebob"
    },
    bio: "Coming Soon"
  },
  deezythemonster: {
    image: "team/deezy.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "DeezyTheMonster",
    email: "",
    social: {
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/@deezythemonster"
    },
    bio: "Coming Soon"
  },
  lordxsaura: {
    image: "team/lordxsaura.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "LordxSaura",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/lordxsaura",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/@LordxSaura"
    },
    bio: "Coming Soon"
  },
  serocifkre: {
    image: "team/serocifkre.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "Seroc Ifkre",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/serocifkre",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/@serocifkre",
      twitter: "https://x.com/SIfkre47497"
    },
    bio: "Coming Soon"
  },
  tweekz: {
    image: "team/tweekz.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "tweekz",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/tweeekz",
      discord: "https://discord.gg/WBBwg5X"
    },
    bio: "Coming Soon"
  },
  danger: {
    image: "team/danger.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "Danger",
    email: "",
    social: {
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/@dangerstin201"
    },
    bio: "Coming Soon"
  },
  ventrua: {
    image: "team/ventrua.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "Ventrua",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/ventrua",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/@Ventrua",
      twitter: "https://x.com/TheVentrua"
    },
    bio: "Coming Soon"
  },
  ziggyd: {
    image: "team/ziggyd.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "ZiggyD",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/ziggydlive",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/@ZiggyDGaming",
      twitter: "https://x.com/ZiggyDStarcraft"
    },
    bio: "Coming Soon"
  },
  captainlance: {
    image: "team/captainlance.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "CaptainLance9",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/captainlance9",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/@CaptainLance9"
    },
    bio: "Coming Soon"
  },
  steelmage: {
    image: "team/steelmage.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "Steelmage",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/steelmage",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/@Steelmage",
      twitter: "https://x.com/Steelmage2"
    },
    bio: "Coming Soon"
  },
  icytroll: {
    image: "team/icytroll.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "Icytroll",
    email: "",
    social: {
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/@Icytroll"
    },
    bio: "Coming Soon"
  },
  aoinomiku: {
    image: "team/aoinomiku.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "AoinoMiku",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/aoinomiku",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/@aoinomiku",
      twitter: "https://x.com/AoinoMiku"
    },
    bio: "Coming Soon"
  },
  barricade: {
    image: "team/barricade.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "Barricade",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/barricade",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/@barricadettv",
      twitter: "https://x.com/BarricadeTTV"
    },
    bio: "Coming Soon"
  },
  sirfreeforall: {
    image: "team/sirfreeforall.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "SirFreeforall",
    email: "",
    social: {
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/@SirFreeForAllYT"
    },
    bio: "Coming Soon"
  },
  velyna: {
    image: "team/velyna.webp",
    customImageWidth: 188,
    title: "Content Creator",
    name: "",
    nickname: "Velyna",
    email: "",
    social: {
      twitch: "https://www.twitch.tv/velyna",
      discord: "https://discord.gg/WBBwg5X",
      youtube: "https://www.youtube.com/Velyna",
      twitter: "https://x.com/AdequateVelyna"
    },
    bio: "Coming Soon"
  }
}, O1e = {
  tabs: B1e,
  team: D1e
}, Uf = O1e;
function F1e(e, t) {
  return Lt(this, null, function* () {
    try {
      return (yield (yield fetch(`https://${t}/api/twitch?channel=${e}`)).json()).isLive;
    } catch (i) {
    }
    return !1;
  });
}
const nI = ["twitch", "twitter", "youtube"], V1e = {
  twitch: /^(www\.)?twitch\.tv$/,
  twitter: /^(www\.)?(twitter|x)\.com$/,
  youtube: /^(www\.)?youtube\.com$/
};
function q1e(e, t) {
  e.match(/^(\w*:)?\/\//) || (e = "https://" + e);
  try {
    const i = new URL(e);
    if (i.hostname.match(t))
      return i.href;
  } catch (i) {
  }
}
function EF(e) {
  const t = e != null && e.contentCreator ? Uf.team[e.contentCreator] : e == null ? void 0 : e.user;
  return we(() => {
    var r;
    if (!t)
      return;
    const i = ee(q({}, t), { social: q({}, t.social) });
    for (const n of nI) {
      const o = (r = i.social) == null ? void 0 : r[n];
      o && (i.social[n] = q1e(o, V1e[n]));
    }
    return i;
  }, [t]);
}
const j1e = "_Build_ds2vo_1", L1e = "_Build__instance_ds2vo_6", K1e = "_Build__inner_ds2vo_24", Y1e = "_Build__class_ds2vo_34", U1e = "_Build__data_ds2vo_46", G1e = "_Build__dataTop_ds2vo_54", Q1e = "_Build__name_ds2vo_60", W1e = "_Build__info_ds2vo_65", Z1e = "_Build__socials_ds2vo_76", J1e = "_Build__tagsWrapper_ds2vo_79", P1e = "_Build__plannerBuildTag_ds2vo_85", z1e = "_Build__ratings_ds2vo_96", H1e = "_Build__average_ds2vo_98", X1e = "_Build__bar_ds2vo_103", _1e = "_Build__active_ds2vo_107", $1e = "_Build__total_ds2vo_112", efe = "_Build__rated_ds2vo_117", tfe = "_Build__build_ds2vo_125", ife = "_Build__rating_ds2vo_96", rfe = "_Build__ratingStar_ds2vo_148", nfe = "_Build__expandBtn_ds2vo_157", ofe = "_Build__expandBtnIcon_ds2vo_177", sfe = "_Build__buildsCollapsed_ds2vo_182", afe = "_Build__buildsAuthor_ds2vo_198", lfe = "_Build__buildsExpanded_ds2vo_203", cfe = "_Build__buildsCollapseBtn_ds2vo_216", ufe = "_Build__collapseBtnIcon_ds2vo_234", dfe = "_Build__skillsSlotWrapper_ds2vo_239", Wi = {
  Build: j1e,
  Build__instance: L1e,
  Build__inner: K1e,
  Build__class: Y1e,
  Build__data: U1e,
  Build__dataTop: G1e,
  Build__name: Q1e,
  Build__info: W1e,
  Build__socials: Z1e,
  Build__tagsWrapper: J1e,
  Build__plannerBuildTag: P1e,
  Build__ratings: z1e,
  Build__average: H1e,
  Build__bar: X1e,
  Build__active: _1e,
  Build__total: $1e,
  Build__rated: efe,
  Build__build: tfe,
  Build__rating: ife,
  Build__ratingStar: rfe,
  Build__expandBtn: nfe,
  Build__expandBtnIcon: ofe,
  Build__buildsCollapsed: sfe,
  Build__buildsAuthor: afe,
  Build__buildsExpanded: lfe,
  Build__buildsCollapseBtn: cfe,
  Build__collapseBtnIcon: ufe,
  Build__skillsSlotWrapper: dfe,
  "Build--expanded": "_Build--expanded_ds2vo_244",
  "Build--extraBuildsHovered": "_Build--extraBuildsHovered_ds2vo_252"
};
function FBe(e) {
  var W;
  const z = e, {
    profile: t,
    profilesByAuthorCount: i,
    type: r,
    siteId: n,
    plannerCategories: o,
    plannerTagSets: s,
    background: a,
    innerStart: l,
    className: c,
    buildComponent: u,
    skillsSlot: m
  } = z, g = Fe(z, [
    "profile",
    "profilesByAuthorCount",
    "type",
    "siteId",
    "plannerCategories",
    "plannerTagSets",
    "background",
    "innerStart",
    "className",
    "buildComponent",
    "skillsSlot"
  ]), [h] = gi((H) => ({ md: H.viewport.md, lg: H.viewport.lg })), { api: A } = AF({ siteId: n }), [y, E] = se([]), v = Ne(!1), C = ye(() => {
    v.current !== !0 && (v.current = !0, A.search({
      body: {
        limit: 100,
        filter: `public = 1 AND user.username = "${t.user.username}"`,
        sort: r === "community-builds" ? ["total_ratings:desc", "average_rating:desc", "date:desc"] : ["date:desc"]
      }
    }).then((H) => {
      E(H.hits.filter((Q) => Q.id !== t.id));
    }));
  }, [A, t.id, t.user.username, r]), [x, S] = se(!1), R = ye(
    (H) => {
      H.preventDefault(), H.stopPropagation(), C(), S((Q) => !Q);
    },
    [C]
  ), [w, T] = se(!1), N = ye(
    (H) => () => {
      T(H);
    },
    []
  ), D = we(
    () => t.metadata ? JSON.parse(t.metadata) : void 0,
    [t.metadata]
  ), O = we(() => {
    const H = [], Q = o.categories.find((le) => le.value === t.category);
    Q && H.push(Q.label);
    const $ = s.map((le) => le.tags).flat();
    for (const le of t.tags || []) {
      const he = $.find((oe) => oe.value === le);
      he && H.push(he.label);
    }
    return H;
  }, [o, s, t.category, t.tags]), F = EF(D == null ? void 0 : D.author), Y = we(
    () => {
      var H;
      return F && ((H = D == null ? void 0 : D.author) == null ? void 0 : H.contentCreator) != null;
    },
    [F, (W = D == null ? void 0 : D.author) == null ? void 0 : W.contentCreator]
  ), P = [];
  return F != null && F.nickname && P.push(
    /* @__PURE__ */ V(gt, { children: [
      "By ",
      /* @__PURE__ */ f("b", { children: F == null ? void 0 : F.nickname })
    ] })
  ), Y && P.push(/* @__PURE__ */ f(T1e, {})), P.length > 0 && P.push(" | "), t.date && P.push(/* @__PURE__ */ V(gt, { children: [
    "Updated on ",
    Gs(t.date)
  ] })), /* @__PURE__ */ V(
    "div",
    {
      className: me(
        Wi.Build,
        x && Wi["Build--expanded"],
        w && Wi["Build--extraBuildsHovered"]
      ),
      children: [
        /* @__PURE__ */ V(
          "a",
          ee(q({
            className: me(Wi.Build__instance, c),
            href: `/${n}/planner?profile=${t.id}`
          }, g), {
            children: [
              a,
              /* @__PURE__ */ V("div", { className: Wi.Build__inner, children: [
                l,
                /* @__PURE__ */ V("div", { className: Wi.Build__data, children: [
                  /* @__PURE__ */ V("div", { className: Wi.Build__dataTop, children: [
                    /* @__PURE__ */ f("div", { className: Wi.Build__name, children: t.name }),
                    /* @__PURE__ */ f("div", { className: Wi.Build__info, children: P.map((H, Q) => /* @__PURE__ */ f(bl, { children: H }, Q)) }),
                    r !== "team-darkside-builds" && r !== "maxroll-builds" ? /* @__PURE__ */ V("div", { className: Wi.Build__rating, children: [
                      /* @__PURE__ */ f("span", { children: "Rating" }),
                      /* @__PURE__ */ f("span", { children: (t.average_rating || 0).toFixed(1) }),
                      /* @__PURE__ */ f(Mt, { className: Wi.Build__ratingStar, icon: "icons/star.svg", width: 11, height: 11 })
                    ] }) : null
                  ] }),
                  /* @__PURE__ */ f("div", { className: Wi.Build__tagsWrapper, children: O.map((H, Q) => /* @__PURE__ */ f("span", { className: Wi.Build__plannerBuildTag, children: Ut.upperFirst(H) }, Q)) }),
                  h.md && !h.lg ? m : null
                ] }),
                h.lg ? m : /* @__PURE__ */ f("div", {})
              ] }),
              i > 0 ? /* @__PURE__ */ f(
                "div",
                {
                  className: Wi.Build__expandBtn,
                  onClick: R,
                  onMouseEnter: N(!0),
                  onMouseLeave: N(!1),
                  children: /* @__PURE__ */ f(Mt, { icon: "chevron-right.svg", className: Wi.Build__expandBtnIcon, width: 24, height: 24 })
                }
              ) : null,
              h.md ? null : /* @__PURE__ */ f("div", { className: Wi.Build__skillsSlotWrapper, children: m }),
              /* @__PURE__ */ f(w1e, { profileId: t.id, siteId: n })
            ]
          })
        ),
        i > 0 ? x ? /* @__PURE__ */ V("div", { className: Wi.Build__buildsExpanded, children: [
          u ? y.map(
            (H, Q) => Ei(u, {
              key: Q,
              profile: H,
              profilesByAuthorCount: 0,
              type: r,
              siteId: n,
              plannerCategories: o,
              plannerTagSets: s
            })
          ) : null,
          /* @__PURE__ */ V("div", { className: Wi.Build__buildsCollapseBtn, onClick: R, children: [
            /* @__PURE__ */ V("span", { children: [
              "Close builds from ",
              F ? F == null ? void 0 : F.nickname : "this author"
            ] }),
            /* @__PURE__ */ f(Mt, { icon: "chevron-right.svg", className: Wi.Build__collapseBtnIcon, width: 16, height: 16 })
          ] })
        ] }) : /* @__PURE__ */ V("div", { className: Wi.Build__buildsCollapsed, onClick: R, children: [
          /* @__PURE__ */ V("span", { className: Wi.Build__buildsText, children: [
            "+",
            i,
            " more build",
            i > 1 ? "s" : "",
            " by",
            " "
          ] }),
          F ? /* @__PURE__ */ f("span", { className: Wi.Build__buildsAuthor, children: F == null ? void 0 : F.nickname }) : /* @__PURE__ */ f("span", { className: Wi.Build__buildsText, children: "this author" })
        ] }) : null
      ]
    }
  );
}
const mfe = "_Filter_ztkjj_1", gfe = "_Filter__title_ztkjj_14", hfe = "_Filter__content_ztkjj_23", pfe = "_Filter__item_ztkjj_29", ffe = "_Filter__itemIcon_ztkjj_38", Afe = "_Filter__itemText_ztkjj_53", rl = {
  Filter: mfe,
  Filter__title: gfe,
  Filter__content: hfe,
  Filter__item: pfe,
  Filter__itemIcon: ffe,
  Filter__itemText: Afe,
  "Filter__item--active": "_Filter__item--active_ztkjj_67",
  "Filter__item--disabled": "_Filter__item--disabled_ztkjj_67"
};
function VBe({
  value: e,
  onChange: t,
  options: i,
  title: r,
  background: n,
  className: o
}) {
  return /* @__PURE__ */ V("div", { className: me(rl.Filter, o), children: [
    n,
    /* @__PURE__ */ f("div", { className: rl.Filter__title, children: r }),
    /* @__PURE__ */ f(Pr, { type: "horizontal", innerClassName: rl.Filter__content, children: i.map((s, a) => /* @__PURE__ */ V(
      "div",
      {
        className: me(rl.Filter__item, e === `${s.value}` && rl["Filter__item--active"]),
        onClick: () => {
          t(s.value);
        },
        children: [
          /* @__PURE__ */ f("div", { className: rl.Filter__itemIcon, children: typeof s.icon == "string" ? /* @__PURE__ */ f("img", { width: 44, height: 44, src: s.icon, alt: s.label, className: rl.Image }) : s.icon }),
          /* @__PURE__ */ f("div", { className: rl.Filter__itemText, children: s.label })
        ]
      },
      a
    )) })
  ] });
}
function An(e) {
  return `Minified Redux error #${e}; visit https://redux.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `;
}
var yfe = /* @__PURE__ */ (() => typeof Symbol == "function" && Symbol.observable || "@@observable")(), T6 = yfe, KE = () => Math.random().toString(36).substring(7).split("").join("."), Efe = {
  INIT: `@@redux/INIT${KE()}`,
  REPLACE: `@@redux/REPLACE${KE()}`,
  PROBE_UNKNOWN_ACTION: () => `@@redux/PROBE_UNKNOWN_ACTION${KE()}`
}, B6 = Efe;
function vfe(e) {
  if (typeof e != "object" || e === null)
    return !1;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t || Object.getPrototypeOf(e) === null;
}
function vF(e, t, i) {
  if (typeof e != "function")
    throw new Error(An(2));
  if (typeof t == "function" && typeof i == "function" || typeof i == "function" && typeof arguments[3] == "function")
    throw new Error(An(0));
  if (typeof t == "function" && typeof i == "undefined" && (i = t, t = void 0), typeof i != "undefined") {
    if (typeof i != "function")
      throw new Error(An(1));
    return i(vF)(e, t);
  }
  let r = e, n = t, o = /* @__PURE__ */ new Map(), s = o, a = 0, l = !1;
  function c() {
    s === o && (s = /* @__PURE__ */ new Map(), o.forEach((E, v) => {
      s.set(v, E);
    }));
  }
  function u() {
    if (l)
      throw new Error(An(3));
    return n;
  }
  function m(E) {
    if (typeof E != "function")
      throw new Error(An(4));
    if (l)
      throw new Error(An(5));
    let v = !0;
    c();
    const C = a++;
    return s.set(C, E), function() {
      if (v) {
        if (l)
          throw new Error(An(6));
        v = !1, c(), s.delete(C), o = null;
      }
    };
  }
  function g(E) {
    if (!vfe(E))
      throw new Error(An(7));
    if (typeof E.type == "undefined")
      throw new Error(An(8));
    if (typeof E.type != "string")
      throw new Error(An(17));
    if (l)
      throw new Error(An(9));
    try {
      l = !0, n = r(n, E);
    } finally {
      l = !1;
    }
    return (o = s).forEach((C) => {
      C();
    }), E;
  }
  function h(E) {
    if (typeof E != "function")
      throw new Error(An(10));
    r = E, g({
      type: B6.REPLACE
    });
  }
  function A() {
    const E = m;
    return {
      /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe(v) {
        if (typeof v != "object" || v === null)
          throw new Error(An(11));
        function C() {
          const S = v;
          S.next && S.next(u());
        }
        return C(), {
          unsubscribe: E(C)
        };
      },
      [T6]() {
        return this;
      }
    };
  }
  return g({
    type: B6.INIT
  }), {
    dispatch: g,
    subscribe: m,
    getState: u,
    replaceReducer: h,
    [T6]: A
  };
}
function D6(e, t) {
  return function(...i) {
    return t(e.apply(this, i));
  };
}
function O6(e, t) {
  if (typeof e == "function")
    return D6(e, t);
  if (typeof e != "object" || e === null)
    throw new Error(An(16));
  const i = {};
  for (const r in e) {
    const n = e[r];
    typeof n == "function" && (i[r] = D6(n, t));
  }
  return i;
}
function bF(...e) {
  return e.length === 0 ? (t) => t : e.length === 1 ? e[0] : e.reduce((t, i) => (...r) => t(i(...r)));
}
function bfe(...e) {
  return (t) => (i, r) => {
    const n = t(i, r);
    let o = () => {
      throw new Error(An(15));
    };
    const s = {
      getState: n.getState,
      dispatch: (l, ...c) => o(l, ...c)
    }, a = e.map((l) => l(s));
    return o = bF(...a)(n.dispatch), ee(q({}, n), {
      dispatch: o
    });
  };
}
var Cfe = {};
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Lg = X;
function xfe(e, t) {
  return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
var Ife = typeof Object.is == "function" ? Object.is : xfe, Sfe = Lg.useSyncExternalStore, Rfe = Lg.useRef, kfe = Lg.useEffect, wfe = Lg.useMemo, Mfe = Lg.useDebugValue;
Cfe.useSyncExternalStoreWithSelector = function(e, t, i, r, n) {
  var o = Rfe(null);
  if (o.current === null) {
    var s = { hasValue: !1, value: null };
    o.current = s;
  } else
    s = o.current;
  o = wfe(
    function() {
      function l(h) {
        if (!c) {
          if (c = !0, u = h, h = r(h), n !== void 0 && s.hasValue) {
            var A = s.value;
            if (n(A, h))
              return m = A;
          }
          return m = h;
        }
        if (A = m, Ife(u, h))
          return A;
        var y = r(h);
        return n !== void 0 && n(A, y) ? (u = h, A) : (u = h, m = y);
      }
      var c = !1, u, m, g = i === void 0 ? null : i;
      return [
        function() {
          return l(t());
        },
        g === null ? void 0 : function() {
          return l(g());
        }
      ];
    },
    [t, i, r, n]
  );
  var a = Sfe(e, o[0], o[1]);
  return kfe(
    function() {
      s.hasValue = !0, s.value = a;
    },
    [a]
  ), Mfe(a), a;
};
var Nfe = /* @__PURE__ */ ft.version.startsWith("19"), Tfe = /* @__PURE__ */ Symbol.for(
  Nfe ? "react.transitional.element" : "react.element"
), Bfe = /* @__PURE__ */ Symbol.for("react.portal"), Dfe = /* @__PURE__ */ Symbol.for("react.fragment"), Ofe = /* @__PURE__ */ Symbol.for("react.strict_mode"), Ffe = /* @__PURE__ */ Symbol.for("react.profiler"), Vfe = /* @__PURE__ */ Symbol.for("react.consumer"), qfe = /* @__PURE__ */ Symbol.for("react.context"), CF = /* @__PURE__ */ Symbol.for("react.forward_ref"), jfe = /* @__PURE__ */ Symbol.for("react.suspense"), Lfe = /* @__PURE__ */ Symbol.for(
  "react.suspense_list"
), oI = /* @__PURE__ */ Symbol.for("react.memo"), Kfe = /* @__PURE__ */ Symbol.for("react.lazy"), Yfe = CF, Ufe = oI;
function Gfe(e) {
  if (typeof e == "object" && e !== null) {
    const { $$typeof: t } = e;
    switch (t) {
      case Tfe:
        switch (e = e.type, e) {
          case Dfe:
          case Ffe:
          case Ofe:
          case jfe:
          case Lfe:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case qfe:
              case CF:
              case Kfe:
              case oI:
                return e;
              case Vfe:
                return e;
              default:
                return t;
            }
        }
      case Bfe:
        return t;
    }
  }
}
function Qfe(e) {
  return Gfe(e) === oI;
}
function Wfe(e, t, i, r, {
  areStatesEqual: n,
  areOwnPropsEqual: o,
  areStatePropsEqual: s
}) {
  let a = !1, l, c, u, m, g;
  function h(C, x) {
    return l = C, c = x, u = e(l, c), m = t(r, c), g = i(u, m, c), a = !0, g;
  }
  function A() {
    return u = e(l, c), t.dependsOnOwnProps && (m = t(r, c)), g = i(u, m, c), g;
  }
  function y() {
    return e.dependsOnOwnProps && (u = e(l, c)), t.dependsOnOwnProps && (m = t(r, c)), g = i(u, m, c), g;
  }
  function E() {
    const C = e(l, c), x = !s(C, u);
    return u = C, x && (g = i(u, m, c)), g;
  }
  function v(C, x) {
    const S = !o(x, c), R = !n(
      C,
      l,
      x,
      c
    );
    return l = C, c = x, S && R ? A() : S ? y() : R ? E() : g;
  }
  return function(x, S) {
    return a ? v(x, S) : h(x, S);
  };
}
function Zfe(e, o) {
  var s = o, {
    initMapStateToProps: t,
    initMapDispatchToProps: i,
    initMergeProps: r
  } = s, n = Fe(s, [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
  ]);
  const a = t(e, n), l = i(e, n), c = r(e, n);
  return Wfe(a, l, c, e, n);
}
function Jfe(e, t) {
  const i = {};
  for (const r in e) {
    const n = e[r];
    typeof n == "function" && (i[r] = (...o) => t(n(...o)));
  }
  return i;
}
function AC(e) {
  return function(i) {
    const r = e(i);
    function n() {
      return r;
    }
    return n.dependsOnOwnProps = !1, n;
  };
}
function F6(e) {
  return e.dependsOnOwnProps ? !!e.dependsOnOwnProps : e.length !== 1;
}
function xF(e, t) {
  return function(r, { displayName: n }) {
    const o = function(a, l) {
      return o.dependsOnOwnProps ? o.mapToProps(a, l) : o.mapToProps(a, void 0);
    };
    return o.dependsOnOwnProps = !0, o.mapToProps = function(a, l) {
      o.mapToProps = e, o.dependsOnOwnProps = F6(e);
      let c = o(a, l);
      return typeof c == "function" && (o.mapToProps = c, o.dependsOnOwnProps = F6(c), c = o(a, l)), c;
    }, o;
  };
}
function sI(e, t) {
  return (i, r) => {
    throw new Error(
      `Invalid value of type ${typeof e} for ${t} argument when connecting component ${r.wrappedComponentName}.`
    );
  };
}
function Pfe(e) {
  return e && typeof e == "object" ? AC(
    (t) => (
      // @ts-ignore
      Jfe(e, t)
    )
  ) : e ? typeof e == "function" ? (
    // @ts-ignore
    xF(e)
  ) : sI(e, "mapDispatchToProps") : AC((t) => ({
    dispatch: t
  }));
}
function zfe(e) {
  return e ? typeof e == "function" ? (
    // @ts-ignore
    xF(e)
  ) : sI(e, "mapStateToProps") : AC(() => ({}));
}
function Hfe(e, t, i) {
  return q(q(q({}, i), e), t);
}
function Xfe(e) {
  return function(i, { displayName: r, areMergedPropsEqual: n }) {
    let o = !1, s;
    return function(l, c, u) {
      const m = e(l, c, u);
      return o ? n(m, s) || (s = m) : (o = !0, s = m), s;
    };
  };
}
function _fe(e) {
  return e ? typeof e == "function" ? Xfe(e) : sI(e, "mergeProps") : () => Hfe;
}
function $fe(e) {
  e();
}
function eAe() {
  let e = null, t = null;
  return {
    clear() {
      e = null, t = null;
    },
    notify() {
      $fe(() => {
        let i = e;
        for (; i; )
          i.callback(), i = i.next;
      });
    },
    get() {
      const i = [];
      let r = e;
      for (; r; )
        i.push(r), r = r.next;
      return i;
    },
    subscribe(i) {
      let r = !0;
      const n = t = {
        callback: i,
        next: null,
        prev: t
      };
      return n.prev ? n.prev.next = n : e = n, function() {
        !r || e === null || (r = !1, n.next ? n.next.prev = n.prev : t = n.prev, n.prev ? n.prev.next = n.next : e = n.next);
      };
    }
  };
}
var V6 = {
  notify() {
  },
  get: () => []
};
function IF(e, t) {
  let i, r = V6, n = 0, o = !1;
  function s(y) {
    u();
    const E = r.subscribe(y);
    let v = !1;
    return () => {
      v || (v = !0, E(), m());
    };
  }
  function a() {
    r.notify();
  }
  function l() {
    A.onStateChange && A.onStateChange();
  }
  function c() {
    return o;
  }
  function u() {
    n++, i || (i = t ? t.addNestedSub(l) : e.subscribe(l), r = eAe());
  }
  function m() {
    n--, i && n === 0 && (i(), i = void 0, r.clear(), r = V6);
  }
  function g() {
    o || (o = !0, u());
  }
  function h() {
    o && (o = !1, m());
  }
  const A = {
    addNestedSub: s,
    notifyNestedSubs: a,
    handleChangeWrapper: l,
    isSubscribed: c,
    trySubscribe: g,
    tryUnsubscribe: h,
    getListeners: () => r
  };
  return A;
}
var tAe = () => typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined", iAe = /* @__PURE__ */ tAe(), rAe = () => typeof navigator != "undefined" && navigator.product === "ReactNative", nAe = /* @__PURE__ */ rAe(), oAe = () => iAe || nAe ? ft.useLayoutEffect : ft.useEffect, q1 = /* @__PURE__ */ oAe();
function q6(e, t) {
  return e === t ? e !== 0 || t !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function YE(e, t) {
  if (q6(e, t))
    return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  const i = Object.keys(e), r = Object.keys(t);
  if (i.length !== r.length)
    return !1;
  for (let n = 0; n < i.length; n++)
    if (!Object.prototype.hasOwnProperty.call(t, i[n]) || !q6(e[i[n]], t[i[n]]))
      return !1;
  return !0;
}
var sAe = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, aAe = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, lAe = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, SF = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, cAe = {
  [Yfe]: lAe,
  [Ufe]: SF
};
function j6(e) {
  return Qfe(e) ? SF : cAe[e.$$typeof] || sAe;
}
var uAe = Object.defineProperty, dAe = Object.getOwnPropertyNames, L6 = Object.getOwnPropertySymbols, mAe = Object.getOwnPropertyDescriptor, gAe = Object.getPrototypeOf, K6 = Object.prototype;
function yC(e, t) {
  if (typeof t != "string") {
    if (K6) {
      const o = gAe(t);
      o && o !== K6 && yC(e, o);
    }
    let i = dAe(t);
    L6 && (i = i.concat(L6(t)));
    const r = j6(e), n = j6(t);
    for (let o = 0; o < i.length; ++o) {
      const s = i[o];
      if (!aAe[s] && !(n && n[s]) && !(r && r[s])) {
        const a = mAe(t, s);
        try {
          uAe(e, s, a);
        } catch (l) {
        }
      }
    }
  }
  return e;
}
var UE = /* @__PURE__ */ Symbol.for("react-redux-context"), GE = typeof globalThis != "undefined" ? globalThis : (
  /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
  {}
);
function hAe() {
  var i;
  if (!ft.createContext)
    return {};
  const e = (i = GE[UE]) != null ? i : GE[UE] = /* @__PURE__ */ new Map();
  let t = e.get(ft.createContext);
  return t || (t = ft.createContext(
    null
  ), e.set(ft.createContext, t)), t;
}
var RF = /* @__PURE__ */ hAe(), pAe = [null, null];
function fAe(e, t, i) {
  q1(() => e(...t), i);
}
function AAe(e, t, i, r, n, o) {
  e.current = r, i.current = !1, n.current && (n.current = null, o());
}
function yAe(e, t, i, r, n, o, s, a, l, c, u) {
  if (!e)
    return () => {
    };
  let m = !1, g = null;
  const h = () => {
    if (m || !a.current)
      return;
    const y = t.getState();
    let E, v;
    try {
      E = r(
        y,
        n.current
      );
    } catch (C) {
      v = C, g = C;
    }
    v || (g = null), E === o.current ? s.current || c() : (o.current = E, l.current = E, s.current = !0, u());
  };
  return i.onStateChange = h, i.trySubscribe(), h(), () => {
    if (m = !0, i.tryUnsubscribe(), i.onStateChange = null, g)
      throw g;
  };
}
function EAe(e, t) {
  return e === t;
}
function vAe(e, t, i, {
  // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
  // @ts-ignore
  pure: r,
  areStatesEqual: n = EAe,
  areOwnPropsEqual: o = YE,
  areStatePropsEqual: s = YE,
  areMergedPropsEqual: a = YE,
  // use React's forwardRef to expose a ref of the wrapped component
  forwardRef: l = !1,
  // the context consumer to use
  context: c = RF
} = {}) {
  const u = c, m = zfe(e), g = Pfe(t), h = _fe(i), A = !!e;
  return (E) => {
    const v = E.displayName || E.name || "Component", C = `Connect(${v})`, x = {
      shouldHandleStateChanges: A,
      displayName: C,
      wrappedComponentName: v,
      WrappedComponent: E,
      // @ts-ignore
      initMapStateToProps: m,
      initMapDispatchToProps: g,
      initMergeProps: h,
      areStatesEqual: n,
      areStatePropsEqual: s,
      areOwnPropsEqual: o,
      areMergedPropsEqual: a
    };
    function S(T) {
      const [N, D, O] = ft.useMemo(() => {
        const Et = T, { reactReduxForwardedRef: et } = Et, At = Fe(Et, ["reactReduxForwardedRef"]);
        return [T.context, et, At];
      }, [T]), F = ft.useMemo(() => {
        let et = u;
        return N != null && N.Consumer, et;
      }, [N, u]), Y = ft.useContext(F), P = !!T.store && !!T.store.getState && !!T.store.dispatch, z = !!Y && !!Y.store, W = P ? T.store : Y.store, H = z ? Y.getServerState : W.getState, Q = ft.useMemo(() => Zfe(W.dispatch, x), [W]), [$, le] = ft.useMemo(() => {
        if (!A)
          return pAe;
        const et = IF(
          W,
          P ? void 0 : Y.subscription
        ), At = et.notifyNestedSubs.bind(et);
        return [et, At];
      }, [W, P, Y]), he = ft.useMemo(() => P ? Y : ee(q({}, Y), {
        subscription: $
      }), [P, Y, $]), oe = ft.useRef(void 0), ue = ft.useRef(O), Ae = ft.useRef(void 0), de = ft.useRef(!1), fe = ft.useRef(!1), Re = ft.useRef(
        void 0
      );
      q1(() => (fe.current = !0, () => {
        fe.current = !1;
      }), []);
      const qe = ft.useMemo(() => () => Ae.current && O === ue.current ? Ae.current : Q(W.getState(), O), [W, O]), Oe = ft.useMemo(() => (At) => $ ? yAe(
        A,
        W,
        $,
        // @ts-ignore
        Q,
        ue,
        oe,
        de,
        fe,
        Ae,
        le,
        At
      ) : () => {
      }, [$]);
      fAe(AAe, [
        ue,
        oe,
        de,
        O,
        Ae,
        le
      ]);
      let Xe;
      try {
        Xe = ft.useSyncExternalStore(
          // TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
          Oe,
          // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
          // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
          qe,
          H ? () => Q(H(), O) : qe
        );
      } catch (et) {
        throw Re.current && (et.message += `
The error may be correlated with this previous error:
${Re.current.stack}

`), et;
      }
      q1(() => {
        Re.current = void 0, Ae.current = void 0, oe.current = Xe;
      });
      const Qe = ft.useMemo(() => (
        // @ts-ignore
        /* @__PURE__ */ ft.createElement(
          E,
          ee(q({}, Xe), {
            ref: D
          })
        )
      ), [D, E, Xe]);
      return ft.useMemo(() => A ? /* @__PURE__ */ ft.createElement(F.Provider, { value: he }, Qe) : Qe, [F, Qe, he]);
    }
    const w = ft.memo(S);
    if (w.WrappedComponent = E, w.displayName = S.displayName = C, l) {
      const N = ft.forwardRef(
        function(O, F) {
          return /* @__PURE__ */ ft.createElement(w, ee(q({}, O), { reactReduxForwardedRef: F }));
        }
      );
      return N.displayName = C, N.WrappedComponent = E, /* @__PURE__ */ yC(N, E);
    }
    return /* @__PURE__ */ yC(w, E);
  };
}
var kF = vAe;
function bAe(e) {
  const { children: t, context: i, serverState: r, store: n } = e, o = ft.useMemo(() => {
    const l = IF(n);
    return {
      store: n,
      subscription: l,
      getServerState: r ? () => r : void 0
    };
  }, [n, r]), s = ft.useMemo(() => n.getState(), [n]);
  q1(() => {
    const { subscription: l } = o;
    return l.onStateChange = l.notifyNestedSubs, l.trySubscribe(), s !== n.getState() && l.notifyNestedSubs(), () => {
      l.tryUnsubscribe(), l.onStateChange = void 0;
    };
  }, [o, s]);
  const a = i || RF;
  return /* @__PURE__ */ ft.createElement(a.Provider, { value: o }, t);
}
var CAe = bAe, xAe = !0, QE = "Invariant failed";
function IAe(e, t) {
  if (!e) {
    if (xAe)
      throw new Error(QE);
    var i = typeof t == "function" ? t() : t, r = i ? "".concat(QE, ": ").concat(i) : QE;
    throw new Error(r);
  }
}
var ds = function(t) {
  var i = t.top, r = t.right, n = t.bottom, o = t.left, s = r - o, a = n - i, l = {
    top: i,
    right: r,
    bottom: n,
    left: o,
    width: s,
    height: a,
    x: o,
    y: i,
    center: {
      x: (r + o) / 2,
      y: (n + i) / 2
    }
  };
  return l;
}, aI = function(t, i) {
  return {
    top: t.top - i.top,
    left: t.left - i.left,
    bottom: t.bottom + i.bottom,
    right: t.right + i.right
  };
}, Y6 = function(t, i) {
  return {
    top: t.top + i.top,
    left: t.left + i.left,
    bottom: t.bottom - i.bottom,
    right: t.right - i.right
  };
}, SAe = function(t, i) {
  return {
    top: t.top + i.y,
    left: t.left + i.x,
    bottom: t.bottom + i.y,
    right: t.right + i.x
  };
}, WE = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
}, lI = function(t) {
  var i = t.borderBox, r = t.margin, n = r === void 0 ? WE : r, o = t.border, s = o === void 0 ? WE : o, a = t.padding, l = a === void 0 ? WE : a, c = ds(aI(i, n)), u = ds(Y6(i, s)), m = ds(Y6(u, l));
  return {
    marginBox: c,
    borderBox: ds(i),
    paddingBox: u,
    contentBox: m,
    margin: n,
    border: s,
    padding: l
  };
}, Oo = function(t) {
  var i = t.slice(0, -2), r = t.slice(-2);
  if (r !== "px")
    return 0;
  var n = Number(i);
  return isNaN(n) && IAe(!1), n;
}, RAe = function() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
}, j1 = function(t, i) {
  var r = t.borderBox, n = t.border, o = t.margin, s = t.padding, a = SAe(r, i);
  return lI({
    borderBox: a,
    border: n,
    margin: o,
    padding: s
  });
}, L1 = function(t, i) {
  return i === void 0 && (i = RAe()), j1(t, i);
}, wF = function(t, i) {
  var r = {
    top: Oo(i.marginTop),
    right: Oo(i.marginRight),
    bottom: Oo(i.marginBottom),
    left: Oo(i.marginLeft)
  }, n = {
    top: Oo(i.paddingTop),
    right: Oo(i.paddingRight),
    bottom: Oo(i.paddingBottom),
    left: Oo(i.paddingLeft)
  }, o = {
    top: Oo(i.borderTopWidth),
    right: Oo(i.borderRightWidth),
    bottom: Oo(i.borderBottomWidth),
    left: Oo(i.borderLeftWidth)
  };
  return lI({
    borderBox: t,
    margin: r,
    padding: n,
    border: o
  });
}, MF = function(t) {
  var i = t.getBoundingClientRect(), r = window.getComputedStyle(t);
  return wF(i, r);
}, kAe = function(t) {
  var i = [], r = null, n = function() {
    for (var s = arguments.length, a = new Array(s), l = 0; l < s; l++)
      a[l] = arguments[l];
    i = a, !r && (r = requestAnimationFrame(function() {
      r = null, t.apply(void 0, i);
    }));
  };
  return n.cancel = function() {
    r && (cancelAnimationFrame(r), r = null);
  }, n;
};
const tg = kAe;
function K1() {
  return K1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var i = arguments[t];
      for (var r in i)
        ({}).hasOwnProperty.call(i, r) && (e[r] = i[r]);
    }
    return e;
  }, K1.apply(null, arguments);
}
function NF(e, t) {
}
NF.bind(null, "warn");
NF.bind(null, "error");
function wl() {
}
function wAe(e, t) {
  return q(q({}, e), t);
}
function Uo(e, t, i) {
  const r = t.map((n) => {
    const o = wAe(i, n.options);
    return e.addEventListener(n.eventName, n.fn, o), function() {
      e.removeEventListener(n.eventName, n.fn, o);
    };
  });
  return function() {
    r.forEach((o) => {
      o();
    });
  };
}
const MAe = "Invariant failed";
class Y1 extends Error {
}
Y1.prototype.toString = function() {
  return this.message;
};
function ze(e, t) {
  throw new Y1(MAe);
}
class NAe extends X.Component {
  constructor(...t) {
    super(...t), this.callbacks = null, this.unbind = wl, this.onWindowError = (i) => {
      const r = this.getCallbacks();
      r.isDragging() && r.tryAbort(), i.error instanceof Y1 && i.preventDefault();
    }, this.getCallbacks = () => {
      if (!this.callbacks)
        throw new Error("Unable to find AppCallbacks in <ErrorBoundary/>");
      return this.callbacks;
    }, this.setCallbacks = (i) => {
      this.callbacks = i;
    };
  }
  componentDidMount() {
    this.unbind = Uo(window, [{
      eventName: "error",
      fn: this.onWindowError
    }]);
  }
  componentDidCatch(t) {
    if (t instanceof Y1) {
      this.setState({});
      return;
    }
    throw t;
  }
  componentWillUnmount() {
    this.unbind();
  }
  render() {
    return this.props.children(this.setCallbacks);
  }
}
const TAe = `
  Press space bar to start a drag.
  When dragging you can use the arrow keys to move the item around and escape to cancel.
  Some screen readers may require you to be in focus mode or to use your pass through key
`, U1 = (e) => e + 1, BAe = (e) => `
  You have lifted an item in position ${U1(e.source.index)}
`, TF = (e, t) => {
  const i = e.droppableId === t.droppableId, r = U1(e.index), n = U1(t.index);
  return i ? `
      You have moved the item from position ${r}
      to position ${n}
    ` : `
    You have moved the item from position ${r}
    in list ${e.droppableId}
    to list ${t.droppableId}
    in position ${n}
  `;
}, BF = (e, t, i) => t.droppableId === i.droppableId ? `
      The item ${e}
      has been combined with ${i.draggableId}` : `
      The item ${e}
      in list ${t.droppableId}
      has been combined with ${i.draggableId}
      in list ${i.droppableId}
    `, DAe = (e) => {
  const t = e.destination;
  if (t)
    return TF(e.source, t);
  const i = e.combine;
  return i ? BF(e.draggableId, e.source, i) : "You are over an area that cannot be dropped on";
}, U6 = (e) => `
  The item has returned to its starting position
  of ${U1(e.index)}
`, OAe = (e) => {
  if (e.reason === "CANCEL")
    return `
      Movement cancelled.
      ${U6(e.source)}
    `;
  const t = e.destination, i = e.combine;
  return t ? `
      You have dropped the item.
      ${TF(e.source, t)}
    ` : i ? `
      You have dropped the item.
      ${BF(e.draggableId, e.source, i)}
    ` : `
    The item has been dropped while not over a drop area.
    ${U6(e.source)}
  `;
}, _p = {
  dragHandleUsageInstructions: TAe,
  onDragStart: BAe,
  onDragUpdate: DAe,
  onDragEnd: OAe
};
function FAe(e, t) {
  return !!(e === t || Number.isNaN(e) && Number.isNaN(t));
}
function DF(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let i = 0; i < e.length; i++)
    if (!FAe(e[i], t[i]))
      return !1;
  return !0;
}
function $t(e, t) {
  const i = se(() => ({
    inputs: t,
    result: e()
  }))[0], r = Ne(!0), n = Ne(i), s = r.current || !!(t && n.current.inputs && DF(t, n.current.inputs)) ? n.current : {
    inputs: t,
    result: e()
  };
  return be(() => {
    r.current = !1, n.current = s;
  }, [s]), s.result;
}
function pt(e, t) {
  return $t(() => e, t);
}
const Fr = {
  x: 0,
  y: 0
}, Zr = (e, t) => ({
  x: e.x + t.x,
  y: e.y + t.y
}), ho = (e, t) => ({
  x: e.x - t.x,
  y: e.y - t.y
}), Ml = (e, t) => e.x === t.x && e.y === t.y, ed = (e) => ({
  x: e.x !== 0 ? -e.x : 0,
  y: e.y !== 0 ? -e.y : 0
}), Hc = (e, t, i = 0) => e === "x" ? {
  x: t,
  y: i
} : {
  x: i,
  y: t
}, ig = (e, t) => Math.sqrt(Gh(t.x - e.x, 2) + Gh(t.y - e.y, 2)), G6 = (e, t) => Math.min(...t.map((i) => ig(e, i))), OF = (e) => (t) => ({
  x: e(t.x),
  y: e(t.y)
});
var VAe = (e, t) => {
  const i = ds({
    top: Math.max(t.top, e.top),
    right: Math.min(t.right, e.right),
    bottom: Math.min(t.bottom, e.bottom),
    left: Math.max(t.left, e.left)
  });
  return i.width <= 0 || i.height <= 0 ? null : i;
};
const Kg = (e, t) => ({
  top: e.top + t.y,
  left: e.left + t.x,
  bottom: e.bottom + t.y,
  right: e.right + t.x
}), Q6 = (e) => [{
  x: e.left,
  y: e.top
}, {
  x: e.right,
  y: e.top
}, {
  x: e.left,
  y: e.bottom
}, {
  x: e.right,
  y: e.bottom
}], qAe = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
}, jAe = (e, t) => t ? Kg(e, t.scroll.diff.displacement) : e, LAe = (e, t, i) => i && i.increasedBy ? ee(q({}, e), {
  [t.end]: e[t.end] + i.increasedBy[t.line]
}) : e, KAe = (e, t) => t && t.shouldClipSubject ? VAe(t.pageMarginBox, e) : ds(e);
var S0 = ({
  page: e,
  withPlaceholder: t,
  axis: i,
  frame: r
}) => {
  const n = jAe(e.marginBox, r), o = LAe(n, i, t), s = KAe(o, r);
  return {
    page: e,
    withPlaceholder: t,
    active: s
  };
}, cI = (e, t) => {
  e.frame || ze();
  const i = e.frame, r = ho(t, i.scroll.initial), n = ed(r), o = ee(q({}, i), {
    scroll: {
      initial: i.scroll.initial,
      current: t,
      diff: {
        value: r,
        displacement: n
      },
      max: i.scroll.max
    }
  }), s = S0({
    page: e.subject.page,
    withPlaceholder: e.subject.withPlaceholder,
    axis: e.axis,
    frame: o
  });
  return ee(q({}, e), {
    frame: o,
    subject: s
  });
};
function Or(e, t = DF) {
  let i = null;
  function r(...n) {
    if (i && i.lastThis === this && t(n, i.lastArgs))
      return i.lastResult;
    const o = e.apply(this, n);
    return i = {
      lastResult: o,
      lastArgs: n,
      lastThis: this
    }, o;
  }
  return r.clear = function() {
    i = null;
  }, r;
}
const FF = Or((e) => e.reduce((t, i) => (t[i.descriptor.id] = i, t), {})), VF = Or((e) => e.reduce((t, i) => (t[i.descriptor.id] = i, t), {})), Gf = Or((e) => Object.values(e)), YAe = Or((e) => Object.values(e));
var td = Or((e, t) => YAe(t).filter((r) => e === r.descriptor.droppableId).sort((r, n) => r.descriptor.index - n.descriptor.index));
function uI(e) {
  return e.at && e.at.type === "REORDER" ? e.at.destination : null;
}
function Qf(e) {
  return e.at && e.at.type === "COMBINE" ? e.at.combine : null;
}
var Wf = Or((e, t) => t.filter((i) => i.descriptor.id !== e.descriptor.id)), UAe = ({
  isMovingForward: e,
  draggable: t,
  destination: i,
  insideDestination: r,
  previousImpact: n
}) => {
  if (!i.isCombineEnabled || !uI(n))
    return null;
  function s(h) {
    const A = {
      type: "COMBINE",
      combine: {
        draggableId: h,
        droppableId: i.descriptor.id
      }
    };
    return ee(q({}, n), {
      at: A
    });
  }
  const a = n.displaced.all, l = a.length ? a[0] : null;
  if (e)
    return l ? s(l) : null;
  const c = Wf(t, r);
  if (!l) {
    if (!c.length)
      return null;
    const h = c[c.length - 1];
    return s(h.descriptor.id);
  }
  const u = c.findIndex((h) => h.descriptor.id === l);
  u === -1 && ze();
  const m = u - 1;
  if (m < 0)
    return null;
  const g = c[m];
  return s(g.descriptor.id);
}, id = (e, t) => e.descriptor.droppableId === t.descriptor.id;
const qF = {
  point: Fr,
  value: 0
}, rg = {
  invisible: {},
  visible: {},
  all: []
}, GAe = {
  displaced: rg,
  displacedBy: qF,
  at: null
};
var Wo = (e, t) => (i) => e <= i && i <= t, jF = (e) => {
  const t = Wo(e.top, e.bottom), i = Wo(e.left, e.right);
  return (r) => {
    if (t(r.top) && t(r.bottom) && i(r.left) && i(r.right))
      return !0;
    const o = t(r.top) || t(r.bottom), s = i(r.left) || i(r.right);
    if (o && s)
      return !0;
    const l = r.top < e.top && r.bottom > e.bottom, c = r.left < e.left && r.right > e.right;
    return l && c ? !0 : l && s || c && o;
  };
}, QAe = (e) => {
  const t = Wo(e.top, e.bottom), i = Wo(e.left, e.right);
  return (r) => t(r.top) && t(r.bottom) && i(r.left) && i(r.right);
};
const dI = {
  direction: "vertical",
  line: "y",
  crossAxisLine: "x",
  start: "top",
  end: "bottom",
  size: "height",
  crossAxisStart: "left",
  crossAxisEnd: "right",
  crossAxisSize: "width"
}, LF = {
  direction: "horizontal",
  line: "x",
  crossAxisLine: "y",
  start: "left",
  end: "right",
  size: "width",
  crossAxisStart: "top",
  crossAxisEnd: "bottom",
  crossAxisSize: "height"
};
var WAe = (e) => (t) => {
  const i = Wo(t.top, t.bottom), r = Wo(t.left, t.right);
  return (n) => e === dI ? i(n.top) && i(n.bottom) : r(n.left) && r(n.right);
};
const ZAe = (e, t) => {
  const i = t.frame ? t.frame.scroll.diff.displacement : Fr;
  return Kg(e, i);
}, JAe = (e, t, i) => t.subject.active ? i(t.subject.active)(e) : !1, PAe = (e, t, i) => i(t)(e), mI = ({
  target: e,
  destination: t,
  viewport: i,
  withDroppableDisplacement: r,
  isVisibleThroughFrameFn: n
}) => {
  const o = r ? ZAe(e, t) : e;
  return JAe(o, t, n) && PAe(o, i, n);
}, zAe = (e) => mI(ee(q({}, e), {
  isVisibleThroughFrameFn: jF
})), KF = (e) => mI(ee(q({}, e), {
  isVisibleThroughFrameFn: QAe
})), HAe = (e) => mI(ee(q({}, e), {
  isVisibleThroughFrameFn: WAe(e.destination.axis)
})), XAe = (e, t, i) => {
  if (typeof i == "boolean")
    return i;
  if (!t)
    return !0;
  const {
    invisible: r,
    visible: n
  } = t;
  if (r[e])
    return !1;
  const o = n[e];
  return o ? o.shouldAnimate : !0;
};
function _Ae(e, t) {
  const i = e.page.marginBox, r = {
    top: t.point.y,
    right: 0,
    bottom: 0,
    left: t.point.x
  };
  return ds(aI(i, r));
}
function ng({
  afterDragging: e,
  destination: t,
  displacedBy: i,
  viewport: r,
  forceShouldAnimate: n,
  last: o
}) {
  return e.reduce(function(a, l) {
    const c = _Ae(l, i), u = l.descriptor.id;
    if (a.all.push(u), !zAe({
      target: c,
      destination: t,
      viewport: r,
      withDroppableDisplacement: !0
    }))
      return a.invisible[l.descriptor.id] = !0, a;
    const g = XAe(u, o, n), h = {
      draggableId: u,
      shouldAnimate: g
    };
    return a.visible[u] = h, a;
  }, {
    all: [],
    visible: {},
    invisible: {}
  });
}
function $Ae(e, t) {
  if (!e.length)
    return 0;
  const i = e[e.length - 1].descriptor.index;
  return t.inHomeList ? i : i + 1;
}
function W6({
  insideDestination: e,
  inHomeList: t,
  displacedBy: i,
  destination: r
}) {
  const n = $Ae(e, {
    inHomeList: t
  });
  return {
    displaced: rg,
    displacedBy: i,
    at: {
      type: "REORDER",
      destination: {
        droppableId: r.descriptor.id,
        index: n
      }
    }
  };
}
function G1({
  draggable: e,
  insideDestination: t,
  destination: i,
  viewport: r,
  displacedBy: n,
  last: o,
  index: s,
  forceShouldAnimate: a
}) {
  const l = id(e, i);
  if (s == null)
    return W6({
      insideDestination: t,
      inHomeList: l,
      displacedBy: n,
      destination: i
    });
  const c = t.find((A) => A.descriptor.index === s);
  if (!c)
    return W6({
      insideDestination: t,
      inHomeList: l,
      displacedBy: n,
      destination: i
    });
  const u = Wf(e, t), m = t.indexOf(c), g = u.slice(m);
  return {
    displaced: ng({
      afterDragging: g,
      destination: i,
      displacedBy: n,
      last: o,
      viewport: r.frame,
      forceShouldAnimate: a
    }),
    displacedBy: n,
    at: {
      type: "REORDER",
      destination: {
        droppableId: i.descriptor.id,
        index: s
      }
    }
  };
}
function jl(e, t) {
  return !!t.effected[e];
}
var eye = ({
  isMovingForward: e,
  destination: t,
  draggables: i,
  combine: r,
  afterCritical: n
}) => {
  if (!t.isCombineEnabled)
    return null;
  const o = r.draggableId, a = i[o].descriptor.index;
  return jl(o, n) ? e ? a : a - 1 : e ? a + 1 : a;
}, tye = ({
  isMovingForward: e,
  isInHomeList: t,
  insideDestination: i,
  location: r
}) => {
  if (!i.length)
    return null;
  const n = r.index, o = e ? n + 1 : n - 1, s = i[0].descriptor.index, a = i[i.length - 1].descriptor.index, l = t ? a : a + 1;
  return o < s || o > l ? null : o;
}, iye = ({
  isMovingForward: e,
  isInHomeList: t,
  draggable: i,
  draggables: r,
  destination: n,
  insideDestination: o,
  previousImpact: s,
  viewport: a,
  afterCritical: l
}) => {
  const c = s.at;
  if (c || ze(), c.type === "REORDER") {
    const m = tye({
      isMovingForward: e,
      isInHomeList: t,
      location: c.destination,
      insideDestination: o
    });
    return m == null ? null : G1({
      draggable: i,
      insideDestination: o,
      destination: n,
      viewport: a,
      last: s.displaced,
      displacedBy: s.displacedBy,
      index: m
    });
  }
  const u = eye({
    isMovingForward: e,
    destination: n,
    displaced: s.displaced,
    draggables: r,
    combine: c.combine,
    afterCritical: l
  });
  return u == null ? null : G1({
    draggable: i,
    insideDestination: o,
    destination: n,
    viewport: a,
    last: s.displaced,
    displacedBy: s.displacedBy,
    index: u
  });
}, rye = ({
  displaced: e,
  afterCritical: t,
  combineWith: i,
  displacedBy: r
}) => {
  const n = !!(e.visible[i] || e.invisible[i]);
  return jl(i, t) ? n ? Fr : ed(r.point) : n ? r.point : Fr;
}, nye = ({
  afterCritical: e,
  impact: t,
  draggables: i
}) => {
  const r = Qf(t);
  r || ze();
  const n = r.draggableId, o = i[n].page.borderBox.center, s = rye({
    displaced: t.displaced,
    afterCritical: e,
    combineWith: n,
    displacedBy: t.displacedBy
  });
  return Zr(o, s);
};
const YF = (e, t) => t.margin[e.start] + t.borderBox[e.size] / 2, oye = (e, t) => t.margin[e.end] + t.borderBox[e.size] / 2, gI = (e, t, i) => t[e.crossAxisStart] + i.margin[e.crossAxisStart] + i.borderBox[e.crossAxisSize] / 2, Z6 = ({
  axis: e,
  moveRelativeTo: t,
  isMoving: i
}) => Hc(e.line, t.marginBox[e.end] + YF(e, i), gI(e, t.marginBox, i)), J6 = ({
  axis: e,
  moveRelativeTo: t,
  isMoving: i
}) => Hc(e.line, t.marginBox[e.start] - oye(e, i), gI(e, t.marginBox, i)), sye = ({
  axis: e,
  moveInto: t,
  isMoving: i
}) => Hc(e.line, t.contentBox[e.start] + YF(e, i), gI(e, t.contentBox, i));
var aye = ({
  impact: e,
  draggable: t,
  draggables: i,
  droppable: r,
  afterCritical: n
}) => {
  const o = td(r.descriptor.id, i), s = t.page, a = r.axis;
  if (!o.length)
    return sye({
      axis: a,
      moveInto: r.page,
      isMoving: s
    });
  const {
    displaced: l,
    displacedBy: c
  } = e, u = l.all[0];
  if (u) {
    const g = i[u];
    if (jl(u, n))
      return J6({
        axis: a,
        moveRelativeTo: g.page,
        isMoving: s
      });
    const h = j1(g.page, c.point);
    return J6({
      axis: a,
      moveRelativeTo: h,
      isMoving: s
    });
  }
  const m = o[o.length - 1];
  if (m.descriptor.id === t.descriptor.id)
    return s.borderBox.center;
  if (jl(m.descriptor.id, n)) {
    const g = j1(m.page, ed(n.displacedBy.point));
    return Z6({
      axis: a,
      moveRelativeTo: g,
      isMoving: s
    });
  }
  return Z6({
    axis: a,
    moveRelativeTo: m.page,
    isMoving: s
  });
}, EC = (e, t) => {
  const i = e.frame;
  return i ? Zr(t, i.scroll.diff.displacement) : t;
};
const lye = ({
  impact: e,
  draggable: t,
  droppable: i,
  draggables: r,
  afterCritical: n
}) => {
  const o = t.page.borderBox.center, s = e.at;
  return !i || !s ? o : s.type === "REORDER" ? aye({
    impact: e,
    draggable: t,
    draggables: r,
    droppable: i,
    afterCritical: n
  }) : nye({
    impact: e,
    draggables: r,
    afterCritical: n
  });
};
var Zf = (e) => {
  const t = lye(e), i = e.droppable;
  return i ? EC(i, t) : t;
}, UF = (e, t) => {
  const i = ho(t, e.scroll.initial), r = ed(i);
  return {
    frame: ds({
      top: t.y,
      bottom: t.y + e.frame.height,
      left: t.x,
      right: t.x + e.frame.width
    }),
    scroll: {
      initial: e.scroll.initial,
      max: e.scroll.max,
      current: t,
      diff: {
        value: i,
        displacement: r
      }
    }
  };
};
function P6(e, t) {
  return e.map((i) => t[i]);
}
function cye(e, t) {
  for (let i = 0; i < t.length; i++) {
    const r = t[i].visible[e];
    if (r)
      return r;
  }
  return null;
}
var uye = ({
  impact: e,
  viewport: t,
  destination: i,
  draggables: r,
  maxScrollChange: n
}) => {
  const o = UF(t, Zr(t.scroll.current, n)), s = i.frame ? cI(i, Zr(i.frame.scroll.current, n)) : i, a = e.displaced, l = ng({
    afterDragging: P6(a.all, r),
    destination: i,
    displacedBy: e.displacedBy,
    viewport: o.frame,
    last: a,
    forceShouldAnimate: !1
  }), c = ng({
    afterDragging: P6(a.all, r),
    destination: s,
    displacedBy: e.displacedBy,
    viewport: t.frame,
    last: a,
    forceShouldAnimate: !1
  }), u = {}, m = {}, g = [a, l, c];
  return a.all.forEach((A) => {
    const y = cye(A, g);
    if (y) {
      m[A] = y;
      return;
    }
    u[A] = !0;
  }), ee(q({}, e), {
    displaced: {
      all: a.all,
      invisible: u,
      visible: m
    }
  });
}, dye = (e, t) => Zr(e.scroll.diff.displacement, t), hI = ({
  pageBorderBoxCenter: e,
  draggable: t,
  viewport: i
}) => {
  const r = dye(i, e), n = ho(r, t.page.borderBox.center);
  return Zr(t.client.borderBox.center, n);
}, GF = ({
  draggable: e,
  destination: t,
  newPageBorderBoxCenter: i,
  viewport: r,
  withDroppableDisplacement: n,
  onlyOnMainAxis: o = !1
}) => {
  const s = ho(i, e.page.borderBox.center), l = {
    target: Kg(e.page.borderBox, s),
    destination: t,
    withDroppableDisplacement: n,
    viewport: r
  };
  return o ? HAe(l) : KF(l);
}, mye = ({
  isMovingForward: e,
  draggable: t,
  destination: i,
  draggables: r,
  previousImpact: n,
  viewport: o,
  previousPageBorderBoxCenter: s,
  previousClientSelection: a,
  afterCritical: l
}) => {
  if (!i.isEnabled)
    return null;
  const c = td(i.descriptor.id, r), u = id(t, i), m = UAe({
    isMovingForward: e,
    draggable: t,
    destination: i,
    insideDestination: c,
    previousImpact: n
  }) || iye({
    isMovingForward: e,
    isInHomeList: u,
    draggable: t,
    draggables: r,
    destination: i,
    insideDestination: c,
    previousImpact: n,
    viewport: o,
    afterCritical: l
  });
  if (!m)
    return null;
  const g = Zf({
    impact: m,
    draggable: t,
    droppable: i,
    draggables: r,
    afterCritical: l
  });
  if (GF({
    draggable: t,
    destination: i,
    newPageBorderBoxCenter: g,
    viewport: o.frame,
    withDroppableDisplacement: !1,
    onlyOnMainAxis: !0
  }))
    return {
      clientSelection: hI({
        pageBorderBoxCenter: g,
        draggable: t,
        viewport: o
      }),
      impact: m,
      scrollJumpRequest: null
    };
  const A = ho(g, s), y = uye({
    impact: m,
    viewport: o,
    destination: i,
    draggables: r,
    maxScrollChange: A
  });
  return {
    clientSelection: a,
    impact: y,
    scrollJumpRequest: A
  };
};
const gn = (e) => {
  const t = e.subject.active;
  return t || ze(), t;
};
var gye = ({
  isMovingForward: e,
  pageBorderBoxCenter: t,
  source: i,
  droppables: r,
  viewport: n
}) => {
  const o = i.subject.active;
  if (!o)
    return null;
  const s = i.axis, a = Wo(o[s.start], o[s.end]), l = Gf(r).filter((u) => u !== i).filter((u) => u.isEnabled).filter((u) => !!u.subject.active).filter((u) => jF(n.frame)(gn(u))).filter((u) => {
    const m = gn(u);
    return e ? o[s.crossAxisEnd] < m[s.crossAxisEnd] : m[s.crossAxisStart] < o[s.crossAxisStart];
  }).filter((u) => {
    const m = gn(u), g = Wo(m[s.start], m[s.end]);
    return a(m[s.start]) || a(m[s.end]) || g(o[s.start]) || g(o[s.end]);
  }).sort((u, m) => {
    const g = gn(u)[s.crossAxisStart], h = gn(m)[s.crossAxisStart];
    return e ? g - h : h - g;
  }).filter((u, m, g) => gn(u)[s.crossAxisStart] === gn(g[0])[s.crossAxisStart]);
  if (!l.length)
    return null;
  if (l.length === 1)
    return l[0];
  const c = l.filter((u) => Wo(gn(u)[s.start], gn(u)[s.end])(t[s.line]));
  return c.length === 1 ? c[0] : c.length > 1 ? c.sort((u, m) => gn(u)[s.start] - gn(m)[s.start])[0] : l.sort((u, m) => {
    const g = G6(t, Q6(gn(u))), h = G6(t, Q6(gn(m)));
    return g !== h ? g - h : gn(u)[s.start] - gn(m)[s.start];
  })[0];
};
const z6 = (e, t) => {
  const i = e.page.borderBox.center;
  return jl(e.descriptor.id, t) ? ho(i, t.displacedBy.point) : i;
}, hye = (e, t) => {
  const i = e.page.borderBox;
  return jl(e.descriptor.id, t) ? Kg(i, ed(t.displacedBy.point)) : i;
};
var pye = ({
  pageBorderBoxCenter: e,
  viewport: t,
  destination: i,
  insideDestination: r,
  afterCritical: n
}) => r.filter((s) => KF({
  target: hye(s, n),
  destination: i,
  viewport: t.frame,
  withDroppableDisplacement: !0
})).sort((s, a) => {
  const l = ig(e, EC(i, z6(s, n))), c = ig(e, EC(i, z6(a, n)));
  return l < c ? -1 : c < l ? 1 : s.descriptor.index - a.descriptor.index;
})[0] || null, Yg = Or(function(t, i) {
  const r = i[t.line];
  return {
    value: r,
    point: Hc(t.line, r)
  };
});
const fye = (e, t, i) => {
  const r = e.axis;
  if (e.descriptor.mode === "virtual")
    return Hc(r.line, t[r.line]);
  const n = e.subject.page.contentBox[r.size], l = td(e.descriptor.id, i).reduce((c, u) => c + u.client.marginBox[r.size], 0) + t[r.line] - n;
  return l <= 0 ? null : Hc(r.line, l);
}, QF = (e, t) => ee(q({}, e), {
  scroll: ee(q({}, e.scroll), {
    max: t
  })
}), WF = (e, t, i) => {
  const r = e.frame;
  id(t, e) && ze(), e.subject.withPlaceholder && ze();
  const n = Yg(e.axis, t.displaceBy).point, o = fye(e, n, i), s = {
    placeholderSize: n,
    increasedBy: o,
    oldFrameMaxScroll: e.frame ? e.frame.scroll.max : null
  };
  if (!r) {
    const u = S0({
      page: e.subject.page,
      withPlaceholder: s,
      axis: e.axis,
      frame: e.frame
    });
    return ee(q({}, e), {
      subject: u
    });
  }
  const a = o ? Zr(r.scroll.max, o) : r.scroll.max, l = QF(r, a), c = S0({
    page: e.subject.page,
    withPlaceholder: s,
    axis: e.axis,
    frame: l
  });
  return ee(q({}, e), {
    subject: c,
    frame: l
  });
}, Aye = (e) => {
  const t = e.subject.withPlaceholder;
  t || ze();
  const i = e.frame;
  if (!i) {
    const s = S0({
      page: e.subject.page,
      axis: e.axis,
      frame: null,
      withPlaceholder: null
    });
    return ee(q({}, e), {
      subject: s
    });
  }
  const r = t.oldFrameMaxScroll;
  r || ze();
  const n = QF(i, r), o = S0({
    page: e.subject.page,
    axis: e.axis,
    frame: n,
    withPlaceholder: null
  });
  return ee(q({}, e), {
    subject: o,
    frame: n
  });
};
var yye = ({
  previousPageBorderBoxCenter: e,
  moveRelativeTo: t,
  insideDestination: i,
  draggable: r,
  draggables: n,
  destination: o,
  viewport: s,
  afterCritical: a
}) => {
  if (!t) {
    if (i.length)
      return null;
    const m = {
      displaced: rg,
      displacedBy: qF,
      at: {
        type: "REORDER",
        destination: {
          droppableId: o.descriptor.id,
          index: 0
        }
      }
    }, g = Zf({
      impact: m,
      draggable: r,
      droppable: o,
      draggables: n,
      afterCritical: a
    }), h = id(r, o) ? o : WF(o, r, n);
    return GF({
      draggable: r,
      destination: h,
      newPageBorderBoxCenter: g,
      viewport: s.frame,
      withDroppableDisplacement: !1,
      onlyOnMainAxis: !0
    }) ? m : null;
  }
  const l = e[o.axis.line] <= t.page.borderBox.center[o.axis.line], c = (() => {
    const m = t.descriptor.index;
    return t.descriptor.id === r.descriptor.id || l ? m : m + 1;
  })(), u = Yg(o.axis, r.displaceBy);
  return G1({
    draggable: r,
    insideDestination: i,
    destination: o,
    viewport: s,
    displacedBy: u,
    last: rg,
    index: c
  });
}, Eye = ({
  isMovingForward: e,
  previousPageBorderBoxCenter: t,
  draggable: i,
  isOver: r,
  draggables: n,
  droppables: o,
  viewport: s,
  afterCritical: a
}) => {
  const l = gye({
    isMovingForward: e,
    pageBorderBoxCenter: t,
    source: r,
    droppables: o,
    viewport: s
  });
  if (!l)
    return null;
  const c = td(l.descriptor.id, n), u = pye({
    pageBorderBoxCenter: t,
    viewport: s,
    destination: l,
    insideDestination: c,
    afterCritical: a
  }), m = yye({
    previousPageBorderBoxCenter: t,
    destination: l,
    draggable: i,
    draggables: n,
    moveRelativeTo: u,
    insideDestination: c,
    viewport: s,
    afterCritical: a
  });
  if (!m)
    return null;
  const g = Zf({
    impact: m,
    draggable: i,
    droppable: l,
    draggables: n,
    afterCritical: a
  });
  return {
    clientSelection: hI({
      pageBorderBoxCenter: g,
      draggable: i,
      viewport: s
    }),
    impact: m,
    scrollJumpRequest: null
  };
}, yo = (e) => {
  const t = e.at;
  return t ? t.type === "REORDER" ? t.destination.droppableId : t.combine.droppableId : null;
};
const vye = (e, t) => {
  const i = yo(e);
  return i ? t[i] : null;
};
var bye = ({
  state: e,
  type: t
}) => {
  const i = vye(e.impact, e.dimensions.droppables), r = !!i, n = e.dimensions.droppables[e.critical.droppable.id], o = i || n, s = o.axis.direction, a = s === "vertical" && (t === "MOVE_UP" || t === "MOVE_DOWN") || s === "horizontal" && (t === "MOVE_LEFT" || t === "MOVE_RIGHT");
  if (a && !r)
    return null;
  const l = t === "MOVE_DOWN" || t === "MOVE_RIGHT", c = e.dimensions.draggables[e.critical.draggable.id], u = e.current.page.borderBoxCenter, {
    draggables: m,
    droppables: g
  } = e.dimensions;
  return a ? mye({
    isMovingForward: l,
    previousPageBorderBoxCenter: u,
    draggable: c,
    destination: o,
    draggables: m,
    viewport: e.viewport,
    previousClientSelection: e.current.client.selection,
    previousImpact: e.impact,
    afterCritical: e.afterCritical
  }) : Eye({
    isMovingForward: l,
    previousPageBorderBoxCenter: u,
    draggable: c,
    isOver: o,
    draggables: m,
    droppables: g,
    viewport: e.viewport,
    afterCritical: e.afterCritical
  });
};
function pc(e) {
  return e.phase === "DRAGGING" || e.phase === "COLLECTING";
}
function ZF(e) {
  const t = Wo(e.top, e.bottom), i = Wo(e.left, e.right);
  return function(n) {
    return t(n.y) && i(n.x);
  };
}
function Cye(e, t) {
  return e.left < t.right && e.right > t.left && e.top < t.bottom && e.bottom > t.top;
}
function xye({
  pageBorderBox: e,
  draggable: t,
  candidates: i
}) {
  const r = t.page.borderBox.center, n = i.map((o) => {
    const s = o.axis, a = Hc(o.axis.line, e.center[s.line], o.page.borderBox.center[s.crossAxisLine]);
    return {
      id: o.descriptor.id,
      distance: ig(r, a)
    };
  }).sort((o, s) => s.distance - o.distance);
  return n[0] ? n[0].id : null;
}
function Iye({
  pageBorderBox: e,
  draggable: t,
  droppables: i
}) {
  const r = Gf(i).filter((n) => {
    if (!n.isEnabled)
      return !1;
    const o = n.subject.active;
    if (!o || !Cye(e, o))
      return !1;
    if (ZF(o)(e.center))
      return !0;
    const s = n.axis, a = o.center[s.crossAxisLine], l = e[s.crossAxisStart], c = e[s.crossAxisEnd], u = Wo(o[s.crossAxisStart], o[s.crossAxisEnd]), m = u(l), g = u(c);
    return !m && !g ? !0 : m ? l < a : c > a;
  });
  return r.length ? r.length === 1 ? r[0].descriptor.id : xye({
    pageBorderBox: e,
    draggable: t,
    candidates: r
  }) : null;
}
const JF = (e, t) => ds(Kg(e, t));
var Sye = (e, t) => {
  const i = e.frame;
  return i ? JF(t, i.scroll.diff.value) : t;
};
function PF({
  displaced: e,
  id: t
}) {
  return !!(e.visible[t] || e.invisible[t]);
}
function Rye({
  draggable: e,
  closest: t,
  inHomeList: i
}) {
  return t ? i && t.descriptor.index > e.descriptor.index ? t.descriptor.index - 1 : t.descriptor.index : null;
}
var kye = ({
  pageBorderBoxWithDroppableScroll: e,
  draggable: t,
  destination: i,
  insideDestination: r,
  last: n,
  viewport: o,
  afterCritical: s
}) => {
  const a = i.axis, l = Yg(i.axis, t.displaceBy), c = l.value, u = e[a.start], m = e[a.end], h = Wf(t, r).find((y) => {
    const E = y.descriptor.id, v = y.page.borderBox.center[a.line], C = jl(E, s), x = PF({
      displaced: n,
      id: E
    });
    return C ? x ? m <= v : u < v - c : x ? m <= v + c : u < v;
  }) || null, A = Rye({
    draggable: t,
    closest: h,
    inHomeList: id(t, i)
  });
  return G1({
    draggable: t,
    insideDestination: r,
    destination: i,
    viewport: o,
    last: n,
    displacedBy: l,
    index: A
  });
};
const wye = 4;
var Mye = ({
  draggable: e,
  pageBorderBoxWithDroppableScroll: t,
  previousImpact: i,
  destination: r,
  insideDestination: n,
  afterCritical: o
}) => {
  if (!r.isCombineEnabled)
    return null;
  const s = r.axis, a = Yg(r.axis, e.displaceBy), l = a.value, c = t[s.start], u = t[s.end], g = Wf(e, n).find((A) => {
    const y = A.descriptor.id, E = A.page.borderBox, C = E[s.size] / wye, x = jl(y, o), S = PF({
      displaced: i.displaced,
      id: y
    });
    return x ? S ? u > E[s.start] + C && u < E[s.end] - C : c > E[s.start] - l + C && c < E[s.end] - l - C : S ? u > E[s.start] + l + C && u < E[s.end] + l - C : c > E[s.start] + C && c < E[s.end] - C;
  });
  return g ? {
    displacedBy: a,
    displaced: i.displaced,
    at: {
      type: "COMBINE",
      combine: {
        draggableId: g.descriptor.id,
        droppableId: r.descriptor.id
      }
    }
  } : null;
}, zF = ({
  pageOffset: e,
  draggable: t,
  draggables: i,
  droppables: r,
  previousImpact: n,
  viewport: o,
  afterCritical: s
}) => {
  const a = JF(t.page.borderBox, e), l = Iye({
    pageBorderBox: a,
    draggable: t,
    droppables: r
  });
  if (!l)
    return GAe;
  const c = r[l], u = td(c.descriptor.id, i), m = Sye(c, a);
  return Mye({
    pageBorderBoxWithDroppableScroll: m,
    draggable: t,
    previousImpact: n,
    destination: c,
    insideDestination: u,
    afterCritical: s
  }) || kye({
    pageBorderBoxWithDroppableScroll: m,
    draggable: t,
    destination: c,
    insideDestination: u,
    last: n.displaced,
    viewport: o,
    afterCritical: s
  });
}, pI = (e, t) => ee(q({}, e), {
  [t.descriptor.id]: t
});
const Nye = ({
  previousImpact: e,
  impact: t,
  droppables: i
}) => {
  const r = yo(e), n = yo(t);
  if (!r || r === n)
    return i;
  const o = i[r];
  if (!o.subject.withPlaceholder)
    return i;
  const s = Aye(o);
  return pI(i, s);
};
var Tye = ({
  draggable: e,
  draggables: t,
  droppables: i,
  previousImpact: r,
  impact: n
}) => {
  const o = Nye({
    previousImpact: r,
    impact: n,
    droppables: i
  }), s = yo(n);
  if (!s)
    return o;
  const a = i[s];
  if (id(e, a) || a.subject.withPlaceholder)
    return o;
  const l = WF(a, e, t);
  return pI(o, l);
}, km = ({
  state: e,
  clientSelection: t,
  dimensions: i,
  viewport: r,
  impact: n,
  scrollJumpRequest: o
}) => {
  const s = r || e.viewport, a = i || e.dimensions, l = t || e.current.client.selection, c = ho(l, e.initial.client.selection), u = {
    offset: c,
    selection: l,
    borderBoxCenter: Zr(e.initial.client.borderBoxCenter, c)
  }, m = {
    selection: Zr(u.selection, s.scroll.current),
    borderBoxCenter: Zr(u.borderBoxCenter, s.scroll.current),
    offset: Zr(u.offset, s.scroll.diff.value)
  }, g = {
    client: u,
    page: m
  };
  if (e.phase === "COLLECTING")
    return ee(q({}, e), {
      dimensions: a,
      viewport: s,
      current: g
    });
  const h = a.draggables[e.critical.draggable.id], A = n || zF({
    pageOffset: m.offset,
    draggable: h,
    draggables: a.draggables,
    droppables: a.droppables,
    previousImpact: e.impact,
    viewport: s,
    afterCritical: e.afterCritical
  }), y = Tye({
    draggable: h,
    impact: A,
    previousImpact: e.impact,
    draggables: a.draggables,
    droppables: a.droppables
  });
  return ee(q({}, e), {
    current: g,
    dimensions: {
      draggables: a.draggables,
      droppables: y
    },
    impact: A,
    viewport: s,
    scrollJumpRequest: o || null,
    forceShouldAnimate: o ? !1 : null
  });
};
function Bye(e, t) {
  return e.map((i) => t[i]);
}
var HF = ({
  impact: e,
  viewport: t,
  draggables: i,
  destination: r,
  forceShouldAnimate: n
}) => {
  const o = e.displaced, s = Bye(o.all, i), a = ng({
    afterDragging: s,
    destination: r,
    displacedBy: e.displacedBy,
    viewport: t.frame,
    forceShouldAnimate: n,
    last: o
  });
  return ee(q({}, e), {
    displaced: a
  });
}, XF = ({
  impact: e,
  draggable: t,
  droppable: i,
  draggables: r,
  viewport: n,
  afterCritical: o
}) => {
  const s = Zf({
    impact: e,
    draggable: t,
    draggables: r,
    droppable: i,
    afterCritical: o
  });
  return hI({
    pageBorderBoxCenter: s,
    draggable: t,
    viewport: n
  });
}, _F = ({
  state: e,
  dimensions: t,
  viewport: i
}) => {
  e.movementMode !== "SNAP" && ze();
  const r = e.impact, n = i || e.viewport, o = t || e.dimensions, {
    draggables: s,
    droppables: a
  } = o, l = s[e.critical.draggable.id], c = yo(r);
  c || ze();
  const u = a[c], m = HF({
    impact: r,
    viewport: n,
    destination: u,
    draggables: s
  }), g = XF({
    impact: m,
    draggable: l,
    droppable: u,
    draggables: s,
    viewport: n,
    afterCritical: e.afterCritical
  });
  return km({
    impact: m,
    clientSelection: g,
    state: e,
    dimensions: o,
    viewport: n
  });
}, Dye = (e) => ({
  index: e.index,
  droppableId: e.droppableId
}), $F = ({
  draggable: e,
  home: t,
  draggables: i,
  viewport: r
}) => {
  const n = Yg(t.axis, e.displaceBy), o = td(t.descriptor.id, i), s = o.indexOf(e);
  s === -1 && ze();
  const a = o.slice(s + 1), l = a.reduce((g, h) => (g[h.descriptor.id] = !0, g), {}), c = {
    inVirtualList: t.descriptor.mode === "virtual",
    displacedBy: n,
    effected: l
  };
  return {
    impact: {
      displaced: ng({
        afterDragging: a,
        destination: t,
        displacedBy: n,
        last: null,
        viewport: r.frame,
        forceShouldAnimate: !1
      }),
      displacedBy: n,
      at: {
        type: "REORDER",
        destination: Dye(e.descriptor)
      }
    },
    afterCritical: c
  };
}, Oye = (e, t) => ({
  draggables: e.draggables,
  droppables: pI(e.droppables, t)
}), Fye = ({
  draggable: e,
  offset: t,
  initialWindowScroll: i
}) => {
  const r = j1(e.client, t), n = L1(r, i);
  return ee(q({}, e), {
    placeholder: ee(q({}, e.placeholder), {
      client: r
    }),
    client: r,
    page: n
  });
}, Vye = (e) => {
  const t = e.frame;
  return t || ze(), t;
}, qye = ({
  additions: e,
  updatedDroppables: t,
  viewport: i
}) => {
  const r = i.scroll.diff.value;
  return e.map((n) => {
    const o = n.descriptor.droppableId, s = t[o], l = Vye(s).scroll.diff.value, c = Zr(r, l);
    return Fye({
      draggable: n,
      offset: c,
      initialWindowScroll: i.scroll.initial
    });
  });
}, jye = ({
  state: e,
  published: t
}) => {
  const i = t.modified.map((v) => {
    const C = e.dimensions.droppables[v.droppableId];
    return cI(C, v.scroll);
  }), r = q(q({}, e.dimensions.droppables), FF(i)), n = VF(qye({
    additions: t.additions,
    updatedDroppables: r,
    viewport: e.viewport
  })), o = q(q({}, e.dimensions.draggables), n);
  t.removals.forEach((v) => {
    delete o[v];
  });
  const s = {
    droppables: r,
    draggables: o
  }, a = yo(e.impact), l = a ? s.droppables[a] : null, c = s.draggables[e.critical.draggable.id], u = s.droppables[e.critical.droppable.id], {
    impact: m,
    afterCritical: g
  } = $F({
    draggable: c,
    home: u,
    draggables: o,
    viewport: e.viewport
  }), h = l && l.isCombineEnabled ? e.impact : m, A = zF({
    pageOffset: e.current.page.offset,
    draggable: s.draggables[e.critical.draggable.id],
    draggables: s.draggables,
    droppables: s.droppables,
    previousImpact: h,
    viewport: e.viewport,
    afterCritical: g
  }), y = ee(q({}, e), {
    phase: "DRAGGING",
    impact: A,
    onLiftImpact: m,
    dimensions: s,
    afterCritical: g,
    forceShouldAnimate: !1
  });
  return e.phase === "COLLECTING" ? y : ee(q({}, y), {
    phase: "DROP_PENDING",
    reason: e.reason,
    isWaiting: !1
  });
};
const vC = (e) => e.movementMode === "SNAP", ZE = (e, t, i) => {
  const r = Oye(e.dimensions, t);
  return !vC(e) || i ? km({
    state: e,
    dimensions: r
  }) : _F({
    state: e,
    dimensions: r
  });
};
function JE(e) {
  return e.isDragging && e.movementMode === "SNAP" ? ee(q({}, e), {
    scrollJumpRequest: null
  }) : e;
}
const H6 = {
  phase: "IDLE",
  completed: null,
  shouldFlush: !1
};
var Lye = (e = H6, t) => {
  if (t.type === "FLUSH")
    return ee(q({}, H6), {
      shouldFlush: !0
    });
  if (t.type === "INITIAL_PUBLISH") {
    e.phase !== "IDLE" && ze();
    const {
      critical: i,
      clientSelection: r,
      viewport: n,
      dimensions: o,
      movementMode: s
    } = t.payload, a = o.draggables[i.draggable.id], l = o.droppables[i.droppable.id], c = {
      selection: r,
      borderBoxCenter: a.client.borderBox.center,
      offset: Fr
    }, u = {
      client: c,
      page: {
        selection: Zr(c.selection, n.scroll.initial),
        borderBoxCenter: Zr(c.selection, n.scroll.initial),
        offset: Zr(c.selection, n.scroll.diff.value)
      }
    }, m = Gf(o.droppables).every((y) => !y.isFixedOnPage), {
      impact: g,
      afterCritical: h
    } = $F({
      draggable: a,
      home: l,
      draggables: o.draggables,
      viewport: n
    });
    return {
      phase: "DRAGGING",
      isDragging: !0,
      critical: i,
      movementMode: s,
      dimensions: o,
      initial: u,
      current: u,
      isWindowScrollAllowed: m,
      impact: g,
      afterCritical: h,
      onLiftImpact: g,
      viewport: n,
      scrollJumpRequest: null,
      forceShouldAnimate: null
    };
  }
  if (t.type === "COLLECTION_STARTING")
    return e.phase === "COLLECTING" || e.phase === "DROP_PENDING" ? e : (e.phase !== "DRAGGING" && ze(), ee(q({}, e), {
      phase: "COLLECTING"
    }));
  if (t.type === "PUBLISH_WHILE_DRAGGING")
    return e.phase === "COLLECTING" || e.phase === "DROP_PENDING" || ze(), jye({
      state: e,
      published: t.payload
    });
  if (t.type === "MOVE") {
    if (e.phase === "DROP_PENDING")
      return e;
    pc(e) || ze();
    const {
      client: i
    } = t.payload;
    return Ml(i, e.current.client.selection) ? e : km({
      state: e,
      clientSelection: i,
      impact: vC(e) ? e.impact : null
    });
  }
  if (t.type === "UPDATE_DROPPABLE_SCROLL") {
    if (e.phase === "DROP_PENDING" || e.phase === "COLLECTING")
      return JE(e);
    pc(e) || ze();
    const {
      id: i,
      newScroll: r
    } = t.payload, n = e.dimensions.droppables[i];
    if (!n)
      return e;
    const o = cI(n, r);
    return ZE(e, o, !1);
  }
  if (t.type === "UPDATE_DROPPABLE_IS_ENABLED") {
    if (e.phase === "DROP_PENDING")
      return e;
    pc(e) || ze();
    const {
      id: i,
      isEnabled: r
    } = t.payload, n = e.dimensions.droppables[i];
    n || ze(), n.isEnabled === r && ze();
    const o = ee(q({}, n), {
      isEnabled: r
    });
    return ZE(e, o, !0);
  }
  if (t.type === "UPDATE_DROPPABLE_IS_COMBINE_ENABLED") {
    if (e.phase === "DROP_PENDING")
      return e;
    pc(e) || ze();
    const {
      id: i,
      isCombineEnabled: r
    } = t.payload, n = e.dimensions.droppables[i];
    n || ze(), n.isCombineEnabled === r && ze();
    const o = ee(q({}, n), {
      isCombineEnabled: r
    });
    return ZE(e, o, !0);
  }
  if (t.type === "MOVE_BY_WINDOW_SCROLL") {
    if (e.phase === "DROP_PENDING" || e.phase === "DROP_ANIMATING")
      return e;
    pc(e) || ze(), e.isWindowScrollAllowed || ze();
    const i = t.payload.newScroll;
    if (Ml(e.viewport.scroll.current, i))
      return JE(e);
    const r = UF(e.viewport, i);
    return vC(e) ? _F({
      state: e,
      viewport: r
    }) : km({
      state: e,
      viewport: r
    });
  }
  if (t.type === "UPDATE_VIEWPORT_MAX_SCROLL") {
    if (!pc(e))
      return e;
    const i = t.payload.maxScroll;
    if (Ml(i, e.viewport.scroll.max))
      return e;
    const r = ee(q({}, e.viewport), {
      scroll: ee(q({}, e.viewport.scroll), {
        max: i
      })
    });
    return ee(q({}, e), {
      viewport: r
    });
  }
  if (t.type === "MOVE_UP" || t.type === "MOVE_DOWN" || t.type === "MOVE_LEFT" || t.type === "MOVE_RIGHT") {
    if (e.phase === "COLLECTING" || e.phase === "DROP_PENDING")
      return e;
    e.phase !== "DRAGGING" && ze();
    const i = bye({
      state: e,
      type: t.type
    });
    return i ? km({
      state: e,
      impact: i.impact,
      clientSelection: i.clientSelection,
      scrollJumpRequest: i.scrollJumpRequest
    }) : e;
  }
  if (t.type === "DROP_PENDING") {
    const i = t.payload.reason;
    return e.phase !== "COLLECTING" && ze(), ee(q({}, e), {
      phase: "DROP_PENDING",
      isWaiting: !0,
      reason: i
    });
  }
  if (t.type === "DROP_ANIMATE") {
    const {
      completed: i,
      dropDuration: r,
      newHomeClientOffset: n
    } = t.payload;
    return e.phase === "DRAGGING" || e.phase === "DROP_PENDING" || ze(), {
      phase: "DROP_ANIMATING",
      completed: i,
      dropDuration: r,
      newHomeClientOffset: n,
      dimensions: e.dimensions
    };
  }
  if (t.type === "DROP_COMPLETE") {
    const {
      completed: i
    } = t.payload;
    return {
      phase: "IDLE",
      completed: i,
      shouldFlush: !1
    };
  }
  return e;
};
function mi(e, t) {
  return e instanceof Object && "type" in e && e.type === t;
}
const Kye = (e) => ({
  type: "BEFORE_INITIAL_CAPTURE",
  payload: e
}), Yye = (e) => ({
  type: "LIFT",
  payload: e
}), Uye = (e) => ({
  type: "INITIAL_PUBLISH",
  payload: e
}), Gye = (e) => ({
  type: "PUBLISH_WHILE_DRAGGING",
  payload: e
}), Qye = () => ({
  type: "COLLECTION_STARTING",
  payload: null
}), Wye = (e) => ({
  type: "UPDATE_DROPPABLE_SCROLL",
  payload: e
}), Zye = (e) => ({
  type: "UPDATE_DROPPABLE_IS_ENABLED",
  payload: e
}), Jye = (e) => ({
  type: "UPDATE_DROPPABLE_IS_COMBINE_ENABLED",
  payload: e
}), eV = (e) => ({
  type: "MOVE",
  payload: e
}), Pye = (e) => ({
  type: "MOVE_BY_WINDOW_SCROLL",
  payload: e
}), zye = (e) => ({
  type: "UPDATE_VIEWPORT_MAX_SCROLL",
  payload: e
}), Hye = () => ({
  type: "MOVE_UP",
  payload: null
}), Xye = () => ({
  type: "MOVE_DOWN",
  payload: null
}), _ye = () => ({
  type: "MOVE_RIGHT",
  payload: null
}), $ye = () => ({
  type: "MOVE_LEFT",
  payload: null
}), fI = () => ({
  type: "FLUSH",
  payload: null
}), eEe = (e) => ({
  type: "DROP_ANIMATE",
  payload: e
}), AI = (e) => ({
  type: "DROP_COMPLETE",
  payload: e
}), tV = (e) => ({
  type: "DROP",
  payload: e
}), tEe = (e) => ({
  type: "DROP_PENDING",
  payload: e
}), iV = () => ({
  type: "DROP_ANIMATION_FINISHED",
  payload: null
});
var iEe = (e) => ({
  getState: t,
  dispatch: i
}) => (r) => (n) => {
  if (!mi(n, "LIFT")) {
    r(n);
    return;
  }
  const {
    id: o,
    clientSelection: s,
    movementMode: a
  } = n.payload, l = t();
  l.phase === "DROP_ANIMATING" && i(AI({
    completed: l.completed
  })), t().phase !== "IDLE" && ze(), i(fI()), i(Kye({
    draggableId: o,
    movementMode: a
  }));
  const u = {
    draggableId: o,
    scrollOptions: {
      shouldPublishImmediately: a === "SNAP"
    }
  }, {
    critical: m,
    dimensions: g,
    viewport: h
  } = e.startPublishing(u);
  i(Uye({
    critical: m,
    dimensions: g,
    clientSelection: s,
    movementMode: a,
    viewport: h
  }));
}, rEe = (e) => () => (t) => (i) => {
  mi(i, "INITIAL_PUBLISH") && e.dragging(), mi(i, "DROP_ANIMATE") && e.dropping(i.payload.completed.result.reason), (mi(i, "FLUSH") || mi(i, "DROP_COMPLETE")) && e.resting(), t(i);
};
const yI = {
  outOfTheWay: "cubic-bezier(0.2, 0, 0, 1)",
  drop: "cubic-bezier(.2,1,.1,1)"
}, og = {
  opacity: {
    drop: 0,
    combining: 0.7
  },
  scale: {
    drop: 0.75
  }
}, rV = {
  outOfTheWay: 0.2,
  minDropTime: 0.33,
  maxDropTime: 0.55
}, dc = `${rV.outOfTheWay}s ${yI.outOfTheWay}`, wm = {
  fluid: `opacity ${dc}`,
  snap: `transform ${dc}, opacity ${dc}`,
  drop: (e) => {
    const t = `${e}s ${yI.drop}`;
    return `transform ${t}, opacity ${t}`;
  },
  outOfTheWay: `transform ${dc}`,
  placeholder: `height ${dc}, width ${dc}, margin ${dc}`
}, X6 = (e) => Ml(e, Fr) ? void 0 : `translate(${e.x}px, ${e.y}px)`, bC = {
  moveTo: X6,
  drop: (e, t) => {
    const i = X6(e);
    if (i)
      return t ? `${i} scale(${og.scale.drop})` : i;
  }
}, {
  minDropTime: CC,
  maxDropTime: nV
} = rV, nEe = nV - CC, _6 = 1500, oEe = 0.6;
var sEe = ({
  current: e,
  destination: t,
  reason: i
}) => {
  const r = ig(e, t);
  if (r <= 0)
    return CC;
  if (r >= _6)
    return nV;
  const n = r / _6, o = CC + nEe * n, s = i === "CANCEL" ? o * oEe : o;
  return Number(s.toFixed(2));
}, aEe = ({
  impact: e,
  draggable: t,
  dimensions: i,
  viewport: r,
  afterCritical: n
}) => {
  const {
    draggables: o,
    droppables: s
  } = i, a = yo(e), l = a ? s[a] : null, c = s[t.descriptor.droppableId], u = XF({
    impact: e,
    draggable: t,
    draggables: o,
    afterCritical: n,
    droppable: l || c,
    viewport: r
  });
  return ho(u, t.client.borderBox.center);
}, lEe = ({
  draggables: e,
  reason: t,
  lastImpact: i,
  home: r,
  viewport: n,
  onLiftImpact: o
}) => !i.at || t !== "DROP" ? {
  impact: HF({
    draggables: e,
    impact: o,
    destination: r,
    viewport: n,
    forceShouldAnimate: !0
  }),
  didDropInsideDroppable: !1
} : i.at.type === "REORDER" ? {
  impact: i,
  didDropInsideDroppable: !0
} : {
  impact: ee(q({}, i), {
    displaced: rg
  }),
  didDropInsideDroppable: !0
};
const cEe = ({
  getState: e,
  dispatch: t
}) => (i) => (r) => {
  if (!mi(r, "DROP")) {
    i(r);
    return;
  }
  const n = e(), o = r.payload.reason;
  if (n.phase === "COLLECTING") {
    t(tEe({
      reason: o
    }));
    return;
  }
  if (n.phase === "IDLE")
    return;
  n.phase === "DROP_PENDING" && n.isWaiting && ze(), n.phase === "DRAGGING" || n.phase === "DROP_PENDING" || ze();
  const a = n.critical, l = n.dimensions, c = l.draggables[n.critical.draggable.id], {
    impact: u,
    didDropInsideDroppable: m
  } = lEe({
    reason: o,
    lastImpact: n.impact,
    afterCritical: n.afterCritical,
    onLiftImpact: n.onLiftImpact,
    home: n.dimensions.droppables[n.critical.droppable.id],
    viewport: n.viewport,
    draggables: n.dimensions.draggables
  }), g = m ? uI(u) : null, h = m ? Qf(u) : null, A = {
    index: a.draggable.index,
    droppableId: a.droppable.id
  }, y = {
    draggableId: c.descriptor.id,
    type: c.descriptor.type,
    source: A,
    reason: o,
    mode: n.movementMode,
    destination: g,
    combine: h
  }, E = aEe({
    impact: u,
    draggable: c,
    dimensions: l,
    viewport: n.viewport,
    afterCritical: n.afterCritical
  }), v = {
    critical: n.critical,
    afterCritical: n.afterCritical,
    result: y,
    impact: u
  };
  if (!(!Ml(n.current.client.offset, E) || !!y.combine)) {
    t(AI({
      completed: v
    }));
    return;
  }
  const x = sEe({
    current: n.current.client.offset,
    destination: E,
    reason: o
  });
  t(eEe({
    newHomeClientOffset: E,
    dropDuration: x,
    completed: v
  }));
};
var oV = () => ({
  x: window.pageXOffset,
  y: window.pageYOffset
});
function uEe(e) {
  return {
    eventName: "scroll",
    options: {
      passive: !0,
      capture: !1
    },
    fn: (t) => {
      t.target !== window && t.target !== window.document || e();
    }
  };
}
function dEe({
  onWindowScroll: e
}) {
  function t() {
    e(oV());
  }
  const i = tg(t), r = uEe(i);
  let n = wl;
  function o() {
    return n !== wl;
  }
  function s() {
    o() && ze(), n = Uo(window, [r]);
  }
  function a() {
    o() || ze(), i.cancel(), n(), n = wl;
  }
  return {
    start: s,
    stop: a,
    isActive: o
  };
}
const mEe = (e) => mi(e, "DROP_COMPLETE") || mi(e, "DROP_ANIMATE") || mi(e, "FLUSH"), gEe = (e) => {
  const t = dEe({
    onWindowScroll: (i) => {
      e.dispatch(Pye({
        newScroll: i
      }));
    }
  });
  return (i) => (r) => {
    !t.isActive() && mi(r, "INITIAL_PUBLISH") && t.start(), t.isActive() && mEe(r) && t.stop(), i(r);
  };
};
var hEe = (e) => {
  let t = !1, i = !1;
  const r = setTimeout(() => {
    i = !0;
  }), n = (o) => {
    t || i || (t = !0, e(o), clearTimeout(r));
  };
  return n.wasCalled = () => t, n;
}, pEe = () => {
  const e = [], t = (n) => {
    const o = e.findIndex((a) => a.timerId === n);
    o === -1 && ze();
    const [s] = e.splice(o, 1);
    s.callback();
  };
  return {
    add: (n) => {
      const o = setTimeout(() => t(o)), s = {
        timerId: o,
        callback: n
      };
      e.push(s);
    },
    flush: () => {
      if (!e.length)
        return;
      const n = [...e];
      e.length = 0, n.forEach((o) => {
        clearTimeout(o.timerId), o.callback();
      });
    }
  };
};
const fEe = (e, t) => e == null && t == null ? !0 : e == null || t == null ? !1 : e.droppableId === t.droppableId && e.index === t.index, AEe = (e, t) => e == null && t == null ? !0 : e == null || t == null ? !1 : e.draggableId === t.draggableId && e.droppableId === t.droppableId, yEe = (e, t) => {
  if (e === t)
    return !0;
  const i = e.draggable.id === t.draggable.id && e.draggable.droppableId === t.draggable.droppableId && e.draggable.type === t.draggable.type && e.draggable.index === t.draggable.index, r = e.droppable.id === t.droppable.id && e.droppable.type === t.droppable.type;
  return i && r;
}, jd = (e, t) => {
  t();
}, Cp = (e, t) => ({
  draggableId: e.draggable.id,
  type: e.droppable.type,
  source: {
    droppableId: e.droppable.id,
    index: e.draggable.index
  },
  mode: t
});
function PE(e, t, i, r) {
  if (!e) {
    i(r(t));
    return;
  }
  const n = hEe(i);
  e(t, {
    announce: n
  }), n.wasCalled() || i(r(t));
}
var EEe = (e, t) => {
  const i = pEe();
  let r = null;
  const n = (m, g) => {
    r && ze(), jd("onBeforeCapture", () => {
      const h = e().onBeforeCapture;
      h && h({
        draggableId: m,
        mode: g
      });
    });
  }, o = (m, g) => {
    r && ze(), jd("onBeforeDragStart", () => {
      const h = e().onBeforeDragStart;
      h && h(Cp(m, g));
    });
  }, s = (m, g) => {
    r && ze();
    const h = Cp(m, g);
    r = {
      mode: g,
      lastCritical: m,
      lastLocation: h.source,
      lastCombine: null
    }, i.add(() => {
      jd("onDragStart", () => PE(e().onDragStart, h, t, _p.onDragStart));
    });
  }, a = (m, g) => {
    const h = uI(g), A = Qf(g);
    r || ze();
    const y = !yEe(m, r.lastCritical);
    y && (r.lastCritical = m);
    const E = !fEe(r.lastLocation, h);
    E && (r.lastLocation = h);
    const v = !AEe(r.lastCombine, A);
    if (v && (r.lastCombine = A), !y && !E && !v)
      return;
    const C = ee(q({}, Cp(m, r.mode)), {
      combine: A,
      destination: h
    });
    i.add(() => {
      jd("onDragUpdate", () => PE(e().onDragUpdate, C, t, _p.onDragUpdate));
    });
  }, l = () => {
    r || ze(), i.flush();
  }, c = (m) => {
    r || ze(), r = null, jd("onDragEnd", () => PE(e().onDragEnd, m, t, _p.onDragEnd));
  };
  return {
    beforeCapture: n,
    beforeStart: o,
    start: s,
    update: a,
    flush: l,
    drop: c,
    abort: () => {
      if (!r)
        return;
      const m = ee(q({}, Cp(r.lastCritical, r.mode)), {
        combine: null,
        destination: null,
        reason: "CANCEL"
      });
      c(m);
    }
  };
}, vEe = (e, t) => {
  const i = EEe(e, t);
  return (r) => (n) => (o) => {
    if (mi(o, "BEFORE_INITIAL_CAPTURE")) {
      i.beforeCapture(o.payload.draggableId, o.payload.movementMode);
      return;
    }
    if (mi(o, "INITIAL_PUBLISH")) {
      const a = o.payload.critical;
      i.beforeStart(a, o.payload.movementMode), n(o), i.start(a, o.payload.movementMode);
      return;
    }
    if (mi(o, "DROP_COMPLETE")) {
      const a = o.payload.completed.result;
      i.flush(), n(o), i.drop(a);
      return;
    }
    if (n(o), mi(o, "FLUSH")) {
      i.abort();
      return;
    }
    const s = r.getState();
    s.phase === "DRAGGING" && i.update(s.critical, s.impact);
  };
};
const bEe = (e) => (t) => (i) => {
  if (!mi(i, "DROP_ANIMATION_FINISHED")) {
    t(i);
    return;
  }
  const r = e.getState();
  r.phase !== "DROP_ANIMATING" && ze(), e.dispatch(AI({
    completed: r.completed
  }));
}, CEe = (e) => {
  let t = null, i = null;
  function r() {
    i && (cancelAnimationFrame(i), i = null), t && (t(), t = null);
  }
  return (n) => (o) => {
    if ((mi(o, "FLUSH") || mi(o, "DROP_COMPLETE") || mi(o, "DROP_ANIMATION_FINISHED")) && r(), n(o), !mi(o, "DROP_ANIMATE"))
      return;
    const s = {
      eventName: "scroll",
      options: {
        capture: !0,
        passive: !1,
        once: !0
      },
      fn: function() {
        e.getState().phase === "DROP_ANIMATING" && e.dispatch(iV());
      }
    };
    i = requestAnimationFrame(() => {
      i = null, t = Uo(window, [s]);
    });
  };
};
var xEe = (e) => () => (t) => (i) => {
  (mi(i, "DROP_COMPLETE") || mi(i, "FLUSH") || mi(i, "DROP_ANIMATE")) && e.stopPublishing(), t(i);
}, IEe = (e) => {
  let t = !1;
  return () => (i) => (r) => {
    if (mi(r, "INITIAL_PUBLISH")) {
      t = !0, e.tryRecordFocus(r.payload.critical.draggable.id), i(r), e.tryRestoreFocusRecorded();
      return;
    }
    if (i(r), !!t) {
      if (mi(r, "FLUSH")) {
        t = !1, e.tryRestoreFocusRecorded();
        return;
      }
      if (mi(r, "DROP_COMPLETE")) {
        t = !1;
        const n = r.payload.completed.result;
        n.combine && e.tryShiftRecord(n.draggableId, n.combine.draggableId), e.tryRestoreFocusRecorded();
      }
    }
  };
};
const SEe = (e) => mi(e, "DROP_COMPLETE") || mi(e, "DROP_ANIMATE") || mi(e, "FLUSH");
var REe = (e) => (t) => (i) => (r) => {
  if (SEe(r)) {
    e.stop(), i(r);
    return;
  }
  if (mi(r, "INITIAL_PUBLISH")) {
    i(r);
    const n = t.getState();
    n.phase !== "DRAGGING" && ze(), e.start(n);
    return;
  }
  i(r), e.scroll(t.getState());
};
const kEe = (e) => (t) => (i) => {
  if (t(i), !mi(i, "PUBLISH_WHILE_DRAGGING"))
    return;
  const r = e.getState();
  r.phase === "DROP_PENDING" && (r.isWaiting || e.dispatch(tV({
    reason: r.reason
  })));
}, wEe = bF;
var MEe = ({
  dimensionMarshal: e,
  focusMarshal: t,
  styleMarshal: i,
  getResponders: r,
  announce: n,
  autoScroller: o
}) => vF(Lye, wEe(bfe(rEe(i), xEe(e), iEe(e), cEe, bEe, CEe, kEe, REe(o), gEe, IEe(t), vEe(r, n))));
const zE = () => ({
  additions: {},
  removals: {},
  modified: {}
});
function NEe({
  registry: e,
  callbacks: t
}) {
  let i = zE(), r = null;
  const n = () => {
    r || (t.collectionStarting(), r = requestAnimationFrame(() => {
      r = null;
      const {
        additions: l,
        removals: c,
        modified: u
      } = i, m = Object.keys(l).map((A) => e.draggable.getById(A).getDimension(Fr)).sort((A, y) => A.descriptor.index - y.descriptor.index), g = Object.keys(u).map((A) => {
        const E = e.droppable.getById(A).callbacks.getScrollWhileDragging();
        return {
          droppableId: A,
          scroll: E
        };
      }), h = {
        additions: m,
        removals: Object.keys(c),
        modified: g
      };
      i = zE(), t.publish(h);
    }));
  };
  return {
    add: (l) => {
      const c = l.descriptor.id;
      i.additions[c] = l, i.modified[l.descriptor.droppableId] = !0, i.removals[c] && delete i.removals[c], n();
    },
    remove: (l) => {
      const c = l.descriptor;
      i.removals[c.id] = !0, i.modified[c.droppableId] = !0, i.additions[c.id] && delete i.additions[c.id], n();
    },
    stop: () => {
      r && (cancelAnimationFrame(r), r = null, i = zE());
    }
  };
}
var sV = ({
  scrollHeight: e,
  scrollWidth: t,
  height: i,
  width: r
}) => {
  const n = ho({
    x: t,
    y: e
  }, {
    x: r,
    y: i
  });
  return {
    x: Math.max(0, n.x),
    y: Math.max(0, n.y)
  };
}, aV = () => {
  const e = document.documentElement;
  return e || ze(), e;
}, lV = () => {
  const e = aV();
  return sV({
    scrollHeight: e.scrollHeight,
    scrollWidth: e.scrollWidth,
    width: e.clientWidth,
    height: e.clientHeight
  });
}, TEe = () => {
  const e = oV(), t = lV(), i = e.y, r = e.x, n = aV(), o = n.clientWidth, s = n.clientHeight, a = r + o, l = i + s;
  return {
    frame: ds({
      top: i,
      left: r,
      right: a,
      bottom: l
    }),
    scroll: {
      initial: e,
      current: e,
      max: t,
      diff: {
        value: Fr,
        displacement: Fr
      }
    }
  };
}, BEe = ({
  critical: e,
  scrollOptions: t,
  registry: i
}) => {
  const r = TEe(), n = r.scroll.current, o = e.droppable, s = i.droppable.getAllByType(o.type).map((u) => u.callbacks.getDimensionAndWatchScroll(n, t)), a = i.draggable.getAllByType(e.draggable.type).map((u) => u.getDimension(n));
  return {
    dimensions: {
      draggables: VF(a),
      droppables: FF(s)
    },
    critical: e,
    viewport: r
  };
};
function $6(e, t, i) {
  return !(i.descriptor.id === t.id || i.descriptor.type !== t.type || e.droppable.getById(i.descriptor.droppableId).descriptor.mode !== "virtual");
}
var DEe = (e, t) => {
  let i = null;
  const r = NEe({
    callbacks: {
      publish: t.publishWhileDragging,
      collectionStarting: t.collectionStarting
    },
    registry: e
  }), n = (g, h) => {
    e.droppable.exists(g) || ze(), i && t.updateDroppableIsEnabled({
      id: g,
      isEnabled: h
    });
  }, o = (g, h) => {
    i && (e.droppable.exists(g) || ze(), t.updateDroppableIsCombineEnabled({
      id: g,
      isCombineEnabled: h
    }));
  }, s = (g, h) => {
    i && (e.droppable.exists(g) || ze(), t.updateDroppableScroll({
      id: g,
      newScroll: h
    }));
  }, a = (g, h) => {
    i && e.droppable.getById(g).callbacks.scroll(h);
  }, l = () => {
    if (!i)
      return;
    r.stop();
    const g = i.critical.droppable;
    e.droppable.getAllByType(g.type).forEach((h) => h.callbacks.dragStopped()), i.unsubscribe(), i = null;
  }, c = (g) => {
    i || ze();
    const h = i.critical.draggable;
    g.type === "ADDITION" && $6(e, h, g.value) && r.add(g.value), g.type === "REMOVAL" && $6(e, h, g.value) && r.remove(g.value);
  };
  return {
    updateDroppableIsEnabled: n,
    updateDroppableIsCombineEnabled: o,
    scrollDroppable: a,
    updateDroppableScroll: s,
    startPublishing: (g) => {
      i && ze();
      const h = e.draggable.getById(g.draggableId), A = e.droppable.getById(h.descriptor.droppableId), y = {
        draggable: h.descriptor,
        droppable: A.descriptor
      }, E = e.subscribe(c);
      return i = {
        critical: y,
        unsubscribe: E
      }, BEe({
        critical: y,
        registry: e,
        scrollOptions: g.scrollOptions
      });
    },
    stopPublishing: l
  };
}, cV = (e, t) => e.phase === "IDLE" ? !0 : e.phase !== "DROP_ANIMATING" || e.completed.result.draggableId === t ? !1 : e.completed.result.reason === "DROP", OEe = (e) => {
  window.scrollBy(e.x, e.y);
};
const FEe = Or((e) => Gf(e).filter((t) => !(!t.isEnabled || !t.frame))), VEe = (e, t) => FEe(t).find((r) => (r.frame || ze(), ZF(r.frame.pageMarginBox)(e))) || null;
var qEe = ({
  center: e,
  destination: t,
  droppables: i
}) => {
  if (t) {
    const n = i[t];
    return n.frame ? n : null;
  }
  return VEe(e, i);
};
const sg = {
  startFromPercentage: 0.25,
  maxScrollAtPercentage: 0.05,
  maxPixelScroll: 28,
  ease: (e) => Gh(e, 2),
  durationDampening: {
    stopDampeningAt: 1200,
    accelerateAt: 360
  },
  disabled: !1
};
var jEe = (e, t, i = () => sg) => {
  const r = i(), n = e[t.size] * r.startFromPercentage, o = e[t.size] * r.maxScrollAtPercentage;
  return {
    startScrollingFrom: n,
    maxScrollValueAt: o
  };
}, uV = ({
  startOfRange: e,
  endOfRange: t,
  current: i
}) => {
  const r = t - e;
  return r === 0 ? 0 : (i - e) / r;
}, EI = 1, LEe = (e, t, i = () => sg) => {
  const r = i();
  if (e > t.startScrollingFrom)
    return 0;
  if (e <= t.maxScrollValueAt)
    return r.maxPixelScroll;
  if (e === t.startScrollingFrom)
    return EI;
  const o = 1 - uV({
    startOfRange: t.maxScrollValueAt,
    endOfRange: t.startScrollingFrom,
    current: e
  }), s = r.maxPixelScroll * r.ease(o);
  return Math.ceil(s);
}, KEe = (e, t, i) => {
  const r = i(), n = r.durationDampening.accelerateAt, o = r.durationDampening.stopDampeningAt, s = t, a = o, c = Date.now() - s;
  if (c >= o)
    return e;
  if (c < n)
    return EI;
  const u = uV({
    startOfRange: n,
    endOfRange: a,
    current: c
  }), m = e * r.ease(u);
  return Math.ceil(m);
}, eM = ({
  distanceToEdge: e,
  thresholds: t,
  dragStartTime: i,
  shouldUseTimeDampening: r,
  getAutoScrollerOptions: n
}) => {
  const o = LEe(e, t, n);
  return o === 0 ? 0 : r ? Math.max(KEe(o, i, n), EI) : o;
}, tM = ({
  container: e,
  distanceToEdges: t,
  dragStartTime: i,
  axis: r,
  shouldUseTimeDampening: n,
  getAutoScrollerOptions: o
}) => {
  const s = jEe(e, r, o);
  return t[r.end] < t[r.start] ? eM({
    distanceToEdge: t[r.end],
    thresholds: s,
    dragStartTime: i,
    shouldUseTimeDampening: n,
    getAutoScrollerOptions: o
  }) : -1 * eM({
    distanceToEdge: t[r.start],
    thresholds: s,
    dragStartTime: i,
    shouldUseTimeDampening: n,
    getAutoScrollerOptions: o
  });
}, YEe = ({
  container: e,
  subject: t,
  proposedScroll: i
}) => {
  const r = t.height > e.height, n = t.width > e.width;
  return !n && !r ? i : n && r ? null : {
    x: n ? 0 : i.x,
    y: r ? 0 : i.y
  };
};
const UEe = OF((e) => e === 0 ? 0 : e);
var dV = ({
  dragStartTime: e,
  container: t,
  subject: i,
  center: r,
  shouldUseTimeDampening: n,
  getAutoScrollerOptions: o
}) => {
  const s = {
    top: r.y - t.top,
    right: t.right - r.x,
    bottom: t.bottom - r.y,
    left: r.x - t.left
  }, a = tM({
    container: t,
    distanceToEdges: s,
    dragStartTime: e,
    axis: dI,
    shouldUseTimeDampening: n,
    getAutoScrollerOptions: o
  }), l = tM({
    container: t,
    distanceToEdges: s,
    dragStartTime: e,
    axis: LF,
    shouldUseTimeDampening: n,
    getAutoScrollerOptions: o
  }), c = UEe({
    x: l,
    y: a
  });
  if (Ml(c, Fr))
    return null;
  const u = YEe({
    container: t,
    subject: i,
    proposedScroll: c
  });
  return u ? Ml(u, Fr) ? null : u : null;
};
const GEe = OF((e) => e === 0 ? 0 : e > 0 ? 1 : -1), vI = (() => {
  const e = (t, i) => t < 0 ? t : t > i ? t - i : 0;
  return ({
    current: t,
    max: i,
    change: r
  }) => {
    const n = Zr(t, r), o = {
      x: e(n.x, i.x),
      y: e(n.y, i.y)
    };
    return Ml(o, Fr) ? null : o;
  };
})(), mV = ({
  max: e,
  current: t,
  change: i
}) => {
  const r = {
    x: Math.max(t.x, e.x),
    y: Math.max(t.y, e.y)
  }, n = GEe(i), o = vI({
    max: r,
    current: t,
    change: n
  });
  return !o || n.x !== 0 && o.x === 0 || n.y !== 0 && o.y === 0;
}, bI = (e, t) => mV({
  current: e.scroll.current,
  max: e.scroll.max,
  change: t
}), QEe = (e, t) => {
  if (!bI(e, t))
    return null;
  const i = e.scroll.max, r = e.scroll.current;
  return vI({
    current: r,
    max: i,
    change: t
  });
}, CI = (e, t) => {
  const i = e.frame;
  return i ? mV({
    current: i.scroll.current,
    max: i.scroll.max,
    change: t
  }) : !1;
}, WEe = (e, t) => {
  const i = e.frame;
  return !i || !CI(e, t) ? null : vI({
    current: i.scroll.current,
    max: i.scroll.max,
    change: t
  });
};
var ZEe = ({
  viewport: e,
  subject: t,
  center: i,
  dragStartTime: r,
  shouldUseTimeDampening: n,
  getAutoScrollerOptions: o
}) => {
  const s = dV({
    dragStartTime: r,
    container: e.frame,
    subject: t,
    center: i,
    shouldUseTimeDampening: n,
    getAutoScrollerOptions: o
  });
  return s && bI(e, s) ? s : null;
}, JEe = ({
  droppable: e,
  subject: t,
  center: i,
  dragStartTime: r,
  shouldUseTimeDampening: n,
  getAutoScrollerOptions: o
}) => {
  const s = e.frame;
  if (!s)
    return null;
  const a = dV({
    dragStartTime: r,
    container: s.pageMarginBox,
    subject: t,
    center: i,
    shouldUseTimeDampening: n,
    getAutoScrollerOptions: o
  });
  return a && CI(e, a) ? a : null;
}, iM = ({
  state: e,
  dragStartTime: t,
  shouldUseTimeDampening: i,
  scrollWindow: r,
  scrollDroppable: n,
  getAutoScrollerOptions: o
}) => {
  const s = e.current.page.borderBoxCenter, l = e.dimensions.draggables[e.critical.draggable.id].page.marginBox;
  if (e.isWindowScrollAllowed) {
    const m = e.viewport, g = ZEe({
      dragStartTime: t,
      viewport: m,
      subject: l,
      center: s,
      shouldUseTimeDampening: i,
      getAutoScrollerOptions: o
    });
    if (g) {
      r(g);
      return;
    }
  }
  const c = qEe({
    center: s,
    destination: yo(e.impact),
    droppables: e.dimensions.droppables
  });
  if (!c)
    return;
  const u = JEe({
    dragStartTime: t,
    droppable: c,
    subject: l,
    center: s,
    shouldUseTimeDampening: i,
    getAutoScrollerOptions: o
  });
  u && n(c.descriptor.id, u);
}, PEe = ({
  scrollWindow: e,
  scrollDroppable: t,
  getAutoScrollerOptions: i = () => sg
}) => {
  const r = tg(e), n = tg(t);
  let o = null;
  const s = (c) => {
    o || ze();
    const {
      shouldUseTimeDampening: u,
      dragStartTime: m
    } = o;
    iM({
      state: c,
      scrollWindow: r,
      scrollDroppable: n,
      dragStartTime: m,
      shouldUseTimeDampening: u,
      getAutoScrollerOptions: i
    });
  };
  return {
    start: (c) => {
      o && ze();
      const u = Date.now();
      let m = !1;
      const g = () => {
        m = !0;
      };
      iM({
        state: c,
        dragStartTime: 0,
        shouldUseTimeDampening: !1,
        scrollWindow: g,
        scrollDroppable: g,
        getAutoScrollerOptions: i
      }), o = {
        dragStartTime: u,
        shouldUseTimeDampening: m
      }, m && s(c);
    },
    stop: () => {
      o && (r.cancel(), n.cancel(), o = null);
    },
    scroll: s
  };
}, zEe = ({
  move: e,
  scrollDroppable: t,
  scrollWindow: i
}) => {
  const r = (a, l) => {
    const c = Zr(a.current.client.selection, l);
    e({
      client: c
    });
  }, n = (a, l) => {
    if (!CI(a, l))
      return l;
    const c = WEe(a, l);
    if (!c)
      return t(a.descriptor.id, l), null;
    const u = ho(l, c);
    return t(a.descriptor.id, u), ho(l, u);
  }, o = (a, l, c) => {
    if (!a || !bI(l, c))
      return c;
    const u = QEe(l, c);
    if (!u)
      return i(c), null;
    const m = ho(c, u);
    return i(m), ho(c, m);
  };
  return (a) => {
    const l = a.scrollJumpRequest;
    if (!l)
      return;
    const c = yo(a.impact);
    c || ze();
    const u = n(a.dimensions.droppables[c], l);
    if (!u)
      return;
    const m = a.viewport, g = o(a.isWindowScrollAllowed, m, u);
    g && r(a, g);
  };
}, HEe = ({
  scrollDroppable: e,
  scrollWindow: t,
  move: i,
  getAutoScrollerOptions: r
}) => {
  const n = PEe({
    scrollWindow: t,
    scrollDroppable: e,
    getAutoScrollerOptions: r
  }), o = zEe({
    move: i,
    scrollWindow: t,
    scrollDroppable: e
  });
  return {
    scroll: (l) => {
      if (!(r().disabled || l.phase !== "DRAGGING")) {
        if (l.movementMode === "FLUID") {
          n.scroll(l);
          return;
        }
        l.scrollJumpRequest && o(l);
      }
    },
    start: n.start,
    stop: n.stop
  };
};
const R0 = "data-rfd", k0 = (() => {
  const e = `${R0}-drag-handle`;
  return {
    base: e,
    draggableId: `${e}-draggable-id`,
    contextId: `${e}-context-id`
  };
})(), xC = (() => {
  const e = `${R0}-draggable`;
  return {
    base: e,
    contextId: `${e}-context-id`,
    id: `${e}-id`
  };
})(), XEe = (() => {
  const e = `${R0}-droppable`;
  return {
    base: e,
    contextId: `${e}-context-id`,
    id: `${e}-id`
  };
})(), rM = {
  contextId: `${R0}-scroll-container-context-id`
}, _Ee = (e) => (t) => `[${t}="${e}"]`, Ld = (e, t) => e.map((i) => {
  const r = i.styles[t];
  return r ? `${i.selector} { ${r} }` : "";
}).join(" "), $Ee = "pointer-events: none;";
var eve = (e) => {
  const t = _Ee(e), i = (() => {
    const a = `
      cursor: -webkit-grab;
      cursor: grab;
    `;
    return {
      selector: t(k0.contextId),
      styles: {
        always: `
          -webkit-touch-callout: none;
          -webkit-tap-highlight-color: rgba(0,0,0,0);
          touch-action: manipulation;
        `,
        resting: a,
        dragging: $Ee,
        dropAnimating: a
      }
    };
  })(), r = (() => {
    const a = `
      transition: ${wm.outOfTheWay};
    `;
    return {
      selector: t(xC.contextId),
      styles: {
        dragging: a,
        dropAnimating: a,
        userCancel: a
      }
    };
  })(), n = {
    selector: t(XEe.contextId),
    styles: {
      always: "overflow-anchor: none;"
    }
  }, s = [r, i, n, {
    selector: "body",
    styles: {
      dragging: `
        cursor: grabbing;
        cursor: -webkit-grabbing;
        user-select: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        overflow-anchor: none;
      `
    }
  }];
  return {
    always: Ld(s, "always"),
    resting: Ld(s, "resting"),
    dragging: Ld(s, "dragging"),
    dropAnimating: Ld(s, "dropAnimating"),
    userCancel: Ld(s, "userCancel")
  };
};
const Eo = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined" ? B0 : be, HE = () => {
  const e = document.querySelector("head");
  return e || ze(), e;
}, nM = (e) => {
  const t = document.createElement("style");
  return e && t.setAttribute("nonce", e), t.type = "text/css", t;
};
function tve(e, t) {
  const i = $t(() => eve(e), [e]), r = Ne(null), n = Ne(null), o = pt(Or((m) => {
    const g = n.current;
    g || ze(), g.textContent = m;
  }), []), s = pt((m) => {
    const g = r.current;
    g || ze(), g.textContent = m;
  }, []);
  Eo(() => {
    !r.current && !n.current || ze();
    const m = nM(t), g = nM(t);
    return r.current = m, n.current = g, m.setAttribute(`${R0}-always`, e), g.setAttribute(`${R0}-dynamic`, e), HE().appendChild(m), HE().appendChild(g), s(i.always), o(i.resting), () => {
      const h = (A) => {
        const y = A.current;
        y || ze(), HE().removeChild(y), A.current = null;
      };
      h(r), h(n);
    };
  }, [t, s, o, i.always, i.resting, e]);
  const a = pt(() => o(i.dragging), [o, i.dragging]), l = pt((m) => {
    if (m === "DROP") {
      o(i.dropAnimating);
      return;
    }
    o(i.userCancel);
  }, [o, i.dropAnimating, i.userCancel]), c = pt(() => {
    n.current && o(i.resting);
  }, [o, i.resting]);
  return $t(() => ({
    dragging: a,
    dropping: l,
    resting: c
  }), [a, l, c]);
}
function gV(e, t) {
  return Array.from(e.querySelectorAll(t));
}
var hV = (e) => e && e.ownerDocument && e.ownerDocument.defaultView ? e.ownerDocument.defaultView : window;
function Jf(e) {
  return e instanceof hV(e).HTMLElement;
}
function ive(e, t) {
  const i = `[${k0.contextId}="${e}"]`, r = gV(document, i);
  if (!r.length)
    return null;
  const n = r.find((o) => o.getAttribute(k0.draggableId) === t);
  return !n || !Jf(n) ? null : n;
}
function rve(e) {
  const t = Ne({}), i = Ne(null), r = Ne(null), n = Ne(!1), o = pt(function(g, h) {
    const A = {
      id: g,
      focus: h
    };
    return t.current[g] = A, function() {
      const E = t.current;
      E[g] !== A && delete E[g];
    };
  }, []), s = pt(function(g) {
    const h = ive(e, g);
    h && h !== document.activeElement && h.focus();
  }, [e]), a = pt(function(g, h) {
    i.current === g && (i.current = h);
  }, []), l = pt(function() {
    r.current || n.current && (r.current = requestAnimationFrame(() => {
      r.current = null;
      const g = i.current;
      g && s(g);
    }));
  }, [s]), c = pt(function(g) {
    i.current = null;
    const h = document.activeElement;
    h && h.getAttribute(k0.draggableId) === g && (i.current = g);
  }, []);
  return Eo(() => (n.current = !0, function() {
    n.current = !1;
    const g = r.current;
    g && cancelAnimationFrame(g);
  }), []), $t(() => ({
    register: o,
    tryRecordFocus: c,
    tryRestoreFocusRecorded: l,
    tryShiftRecord: a
  }), [o, c, l, a]);
}
function nve() {
  const e = {
    draggables: {},
    droppables: {}
  }, t = [];
  function i(m) {
    return t.push(m), function() {
      const h = t.indexOf(m);
      h !== -1 && t.splice(h, 1);
    };
  }
  function r(m) {
    t.length && t.forEach((g) => g(m));
  }
  function n(m) {
    return e.draggables[m] || null;
  }
  function o(m) {
    const g = n(m);
    return g || ze(), g;
  }
  const s = {
    register: (m) => {
      e.draggables[m.descriptor.id] = m, r({
        type: "ADDITION",
        value: m
      });
    },
    update: (m, g) => {
      const h = e.draggables[g.descriptor.id];
      h && h.uniqueId === m.uniqueId && (delete e.draggables[g.descriptor.id], e.draggables[m.descriptor.id] = m);
    },
    unregister: (m) => {
      const g = m.descriptor.id, h = n(g);
      h && m.uniqueId === h.uniqueId && (delete e.draggables[g], e.droppables[m.descriptor.droppableId] && r({
        type: "REMOVAL",
        value: m
      }));
    },
    getById: o,
    findById: n,
    exists: (m) => !!n(m),
    getAllByType: (m) => Object.values(e.draggables).filter((g) => g.descriptor.type === m)
  };
  function a(m) {
    return e.droppables[m] || null;
  }
  function l(m) {
    const g = a(m);
    return g || ze(), g;
  }
  const c = {
    register: (m) => {
      e.droppables[m.descriptor.id] = m;
    },
    unregister: (m) => {
      const g = a(m.descriptor.id);
      g && m.uniqueId === g.uniqueId && delete e.droppables[m.descriptor.id];
    },
    getById: l,
    findById: a,
    exists: (m) => !!a(m),
    getAllByType: (m) => Object.values(e.droppables).filter((g) => g.descriptor.type === m)
  };
  function u() {
    e.draggables = {}, e.droppables = {}, t.length = 0;
  }
  return {
    draggable: s,
    droppable: c,
    subscribe: i,
    clean: u
  };
}
function ove() {
  const e = $t(nve, []);
  return be(() => function() {
    e.clean();
  }, [e]), e;
}
var xI = X.createContext(null), Q1 = () => {
  const e = document.body;
  return e || ze(), e;
};
const sve = {
  position: "absolute",
  width: "1px",
  height: "1px",
  margin: "-1px",
  border: "0",
  padding: "0",
  overflow: "hidden",
  clip: "rect(0 0 0 0)",
  "clip-path": "inset(100%)"
}, ave = (e) => `rfd-announcement-${e}`;
function lve(e) {
  const t = $t(() => ave(e), [e]), i = Ne(null);
  return be(function() {
    const o = document.createElement("div");
    return i.current = o, o.id = t, o.setAttribute("aria-live", "assertive"), o.setAttribute("aria-atomic", "true"), K1(o.style, sve), Q1().appendChild(o), function() {
      setTimeout(function() {
        const l = Q1();
        l.contains(o) && l.removeChild(o), o === i.current && (i.current = null);
      });
    };
  }, [t]), pt((n) => {
    const o = i.current;
    if (o) {
      o.textContent = n;
      return;
    }
  }, []);
}
const cve = {
  separator: "::"
};
function II(e, t = cve) {
  const i = X.useId();
  return $t(() => `${e}${t.separator}${i}`, [t.separator, e, i]);
}
function uve({
  contextId: e,
  uniqueId: t
}) {
  return `rfd-hidden-text-${e}-${t}`;
}
function dve({
  contextId: e,
  text: t
}) {
  const i = II("hidden-text", {
    separator: "-"
  }), r = $t(() => uve({
    contextId: e,
    uniqueId: i
  }), [i, e]);
  return be(function() {
    const o = document.createElement("div");
    return o.id = r, o.textContent = t, o.style.display = "none", Q1().appendChild(o), function() {
      const a = Q1();
      a.contains(o) && a.removeChild(o);
    };
  }, [r, t]), r;
}
var Pf = X.createContext(null);
function pV(e) {
  const t = Ne(e);
  return be(() => {
    t.current = e;
  }), t;
}
function mve() {
  let e = null;
  function t() {
    return !!e;
  }
  function i(s) {
    return s === e;
  }
  function r(s) {
    e && ze();
    const a = {
      abandon: s
    };
    return e = a, a;
  }
  function n() {
    e || ze(), e = null;
  }
  function o() {
    e && (e.abandon(), n());
  }
  return {
    isClaimed: t,
    isActive: i,
    claim: r,
    release: n,
    tryAbandon: o
  };
}
function ag(e) {
  return e.phase === "IDLE" || e.phase === "DROP_ANIMATING" ? !1 : e.isDragging;
}
const gve = 9, hve = 13, SI = 27, fV = 32, pve = 33, fve = 34, Ave = 35, yve = 36, Eve = 37, vve = 38, bve = 39, Cve = 40, xve = {
  [hve]: !0,
  [gve]: !0
};
var AV = (e) => {
  xve[e.keyCode] && e.preventDefault();
};
const zf = (() => {
  const e = "visibilitychange";
  return typeof document == "undefined" ? e : [e, `ms${e}`, `webkit${e}`, `moz${e}`, `o${e}`].find((r) => `on${r}` in document) || e;
})(), yV = 0, oM = 5;
function Ive(e, t) {
  return Math.abs(t.x - e.x) >= oM || Math.abs(t.y - e.y) >= oM;
}
const sM = {
  type: "IDLE"
};
function Sve({
  cancel: e,
  completed: t,
  getPhase: i,
  setPhase: r
}) {
  return [{
    eventName: "mousemove",
    fn: (n) => {
      const {
        button: o,
        clientX: s,
        clientY: a
      } = n;
      if (o !== yV)
        return;
      const l = {
        x: s,
        y: a
      }, c = i();
      if (c.type === "DRAGGING") {
        n.preventDefault(), c.actions.move(l);
        return;
      }
      c.type !== "PENDING" && ze();
      const u = c.point;
      if (!Ive(u, l))
        return;
      n.preventDefault();
      const m = c.actions.fluidLift(l);
      r({
        type: "DRAGGING",
        actions: m
      });
    }
  }, {
    eventName: "mouseup",
    fn: (n) => {
      const o = i();
      if (o.type !== "DRAGGING") {
        e();
        return;
      }
      n.preventDefault(), o.actions.drop({
        shouldBlockNextClick: !0
      }), t();
    }
  }, {
    eventName: "mousedown",
    fn: (n) => {
      i().type === "DRAGGING" && n.preventDefault(), e();
    }
  }, {
    eventName: "keydown",
    fn: (n) => {
      if (i().type === "PENDING") {
        e();
        return;
      }
      if (n.keyCode === SI) {
        n.preventDefault(), e();
        return;
      }
      AV(n);
    }
  }, {
    eventName: "resize",
    fn: e
  }, {
    eventName: "scroll",
    options: {
      passive: !0,
      capture: !1
    },
    fn: () => {
      i().type === "PENDING" && e();
    }
  }, {
    eventName: "webkitmouseforcedown",
    fn: (n) => {
      const o = i();
      if (o.type === "IDLE" && ze(), o.actions.shouldRespectForcePress()) {
        e();
        return;
      }
      n.preventDefault();
    }
  }, {
    eventName: zf,
    fn: e
  }];
}
function Rve(e) {
  const t = Ne(sM), i = Ne(wl), r = $t(() => ({
    eventName: "mousedown",
    fn: function(m) {
      if (m.defaultPrevented || m.button !== yV || m.ctrlKey || m.metaKey || m.shiftKey || m.altKey)
        return;
      const g = e.findClosestDraggableId(m);
      if (!g)
        return;
      const h = e.tryGetLock(g, s, {
        sourceEvent: m
      });
      if (!h)
        return;
      m.preventDefault();
      const A = {
        x: m.clientX,
        y: m.clientY
      };
      i.current(), c(h, A);
    }
  }), [e]), n = $t(() => ({
    eventName: "webkitmouseforcewillbegin",
    fn: (u) => {
      if (u.defaultPrevented)
        return;
      const m = e.findClosestDraggableId(u);
      if (!m)
        return;
      const g = e.findOptionsForDraggable(m);
      g && (g.shouldRespectForcePress || e.canGetLock(m) && u.preventDefault());
    }
  }), [e]), o = pt(function() {
    const m = {
      passive: !1,
      capture: !0
    };
    i.current = Uo(window, [n, r], m);
  }, [n, r]), s = pt(() => {
    t.current.type !== "IDLE" && (t.current = sM, i.current(), o());
  }, [o]), a = pt(() => {
    const u = t.current;
    s(), u.type === "DRAGGING" && u.actions.cancel({
      shouldBlockNextClick: !0
    }), u.type === "PENDING" && u.actions.abort();
  }, [s]), l = pt(function() {
    const m = {
      capture: !0,
      passive: !1
    }, g = Sve({
      cancel: a,
      completed: s,
      getPhase: () => t.current,
      setPhase: (h) => {
        t.current = h;
      }
    });
    i.current = Uo(window, g, m);
  }, [a, s]), c = pt(function(m, g) {
    t.current.type !== "IDLE" && ze(), t.current = {
      type: "PENDING",
      point: g,
      actions: m
    }, l();
  }, [l]);
  Eo(function() {
    return o(), function() {
      i.current();
    };
  }, [o]);
}
function kve() {
}
const wve = {
  [fve]: !0,
  [pve]: !0,
  [yve]: !0,
  [Ave]: !0
};
function Mve(e, t) {
  function i() {
    t(), e.cancel();
  }
  function r() {
    t(), e.drop();
  }
  return [{
    eventName: "keydown",
    fn: (n) => {
      if (n.keyCode === SI) {
        n.preventDefault(), i();
        return;
      }
      if (n.keyCode === fV) {
        n.preventDefault(), r();
        return;
      }
      if (n.keyCode === Cve) {
        n.preventDefault(), e.moveDown();
        return;
      }
      if (n.keyCode === vve) {
        n.preventDefault(), e.moveUp();
        return;
      }
      if (n.keyCode === bve) {
        n.preventDefault(), e.moveRight();
        return;
      }
      if (n.keyCode === Eve) {
        n.preventDefault(), e.moveLeft();
        return;
      }
      if (wve[n.keyCode]) {
        n.preventDefault();
        return;
      }
      AV(n);
    }
  }, {
    eventName: "mousedown",
    fn: i
  }, {
    eventName: "mouseup",
    fn: i
  }, {
    eventName: "click",
    fn: i
  }, {
    eventName: "touchstart",
    fn: i
  }, {
    eventName: "resize",
    fn: i
  }, {
    eventName: "wheel",
    fn: i,
    options: {
      passive: !0
    }
  }, {
    eventName: zf,
    fn: i
  }];
}
function Nve(e) {
  const t = Ne(kve), i = $t(() => ({
    eventName: "keydown",
    fn: function(o) {
      if (o.defaultPrevented || o.keyCode !== fV)
        return;
      const s = e.findClosestDraggableId(o);
      if (!s)
        return;
      const a = e.tryGetLock(s, u, {
        sourceEvent: o
      });
      if (!a)
        return;
      o.preventDefault();
      let l = !0;
      const c = a.snapLift();
      t.current();
      function u() {
        l || ze(), l = !1, t.current(), r();
      }
      t.current = Uo(window, Mve(c, u), {
        capture: !0,
        passive: !1
      });
    }
  }), [e]), r = pt(function() {
    const o = {
      passive: !1,
      capture: !0
    };
    t.current = Uo(window, [i], o);
  }, [i]);
  Eo(function() {
    return r(), function() {
      t.current();
    };
  }, [r]);
}
const XE = {
  type: "IDLE"
}, Tve = 120, Bve = 0.15;
function Dve({
  cancel: e,
  getPhase: t
}) {
  return [{
    eventName: "orientationchange",
    fn: e
  }, {
    eventName: "resize",
    fn: e
  }, {
    eventName: "contextmenu",
    fn: (i) => {
      i.preventDefault();
    }
  }, {
    eventName: "keydown",
    fn: (i) => {
      if (t().type !== "DRAGGING") {
        e();
        return;
      }
      i.keyCode === SI && i.preventDefault(), e();
    }
  }, {
    eventName: zf,
    fn: e
  }];
}
function Ove({
  cancel: e,
  completed: t,
  getPhase: i
}) {
  return [{
    eventName: "touchmove",
    options: {
      capture: !1
    },
    fn: (r) => {
      const n = i();
      if (n.type !== "DRAGGING") {
        e();
        return;
      }
      n.hasMoved = !0;
      const {
        clientX: o,
        clientY: s
      } = r.touches[0], a = {
        x: o,
        y: s
      };
      r.preventDefault(), n.actions.move(a);
    }
  }, {
    eventName: "touchend",
    fn: (r) => {
      const n = i();
      if (n.type !== "DRAGGING") {
        e();
        return;
      }
      r.preventDefault(), n.actions.drop({
        shouldBlockNextClick: !0
      }), t();
    }
  }, {
    eventName: "touchcancel",
    fn: (r) => {
      if (i().type !== "DRAGGING") {
        e();
        return;
      }
      r.preventDefault(), e();
    }
  }, {
    eventName: "touchforcechange",
    fn: (r) => {
      const n = i();
      n.type === "IDLE" && ze();
      const o = r.touches[0];
      if (!o || !(o.force >= Bve))
        return;
      const a = n.actions.shouldRespectForcePress();
      if (n.type === "PENDING") {
        a && e();
        return;
      }
      if (a) {
        if (n.hasMoved) {
          r.preventDefault();
          return;
        }
        e();
        return;
      }
      r.preventDefault();
    }
  }, {
    eventName: zf,
    fn: e
  }];
}
function Fve(e) {
  const t = Ne(XE), i = Ne(wl), r = pt(function() {
    return t.current;
  }, []), n = pt(function(h) {
    t.current = h;
  }, []), o = $t(() => ({
    eventName: "touchstart",
    fn: function(h) {
      if (h.defaultPrevented)
        return;
      const A = e.findClosestDraggableId(h);
      if (!A)
        return;
      const y = e.tryGetLock(A, a, {
        sourceEvent: h
      });
      if (!y)
        return;
      const E = h.touches[0], {
        clientX: v,
        clientY: C
      } = E, x = {
        x: v,
        y: C
      };
      i.current(), m(y, x);
    }
  }), [e]), s = pt(function() {
    const h = {
      capture: !0,
      passive: !1
    };
    i.current = Uo(window, [o], h);
  }, [o]), a = pt(() => {
    const g = t.current;
    g.type !== "IDLE" && (g.type === "PENDING" && clearTimeout(g.longPressTimerId), n(XE), i.current(), s());
  }, [s, n]), l = pt(() => {
    const g = t.current;
    a(), g.type === "DRAGGING" && g.actions.cancel({
      shouldBlockNextClick: !0
    }), g.type === "PENDING" && g.actions.abort();
  }, [a]), c = pt(function() {
    const h = {
      capture: !0,
      passive: !1
    }, A = {
      cancel: l,
      completed: a,
      getPhase: r
    }, y = Uo(window, Ove(A), h), E = Uo(window, Dve(A), h);
    i.current = function() {
      y(), E();
    };
  }, [l, r, a]), u = pt(function() {
    const h = r();
    h.type !== "PENDING" && ze();
    const A = h.actions.fluidLift(h.point);
    n({
      type: "DRAGGING",
      actions: A,
      hasMoved: !1
    });
  }, [r, n]), m = pt(function(h, A) {
    r().type !== "IDLE" && ze();
    const y = setTimeout(u, Tve);
    n({
      type: "PENDING",
      point: A,
      actions: h,
      longPressTimerId: y
    }), c();
  }, [c, r, n, u]);
  Eo(function() {
    return s(), function() {
      i.current();
      const A = r();
      A.type === "PENDING" && (clearTimeout(A.longPressTimerId), n(XE));
    };
  }, [r, s, n]), Eo(function() {
    return Uo(window, [{
      eventName: "touchmove",
      fn: () => {
      },
      options: {
        capture: !1,
        passive: !1
      }
    }]);
  }, []);
}
const Vve = ["input", "button", "textarea", "select", "option", "optgroup", "video", "audio"];
function EV(e, t) {
  if (t == null)
    return !1;
  if (Vve.includes(t.tagName.toLowerCase()))
    return !0;
  const r = t.getAttribute("contenteditable");
  return r === "true" || r === "" ? !0 : t === e ? !1 : EV(e, t.parentElement);
}
function qve(e, t) {
  const i = t.target;
  return Jf(i) ? EV(e, i) : !1;
}
var jve = (e) => ds(e.getBoundingClientRect()).center;
function Lve(e) {
  return e instanceof hV(e).Element;
}
const Kve = (() => {
  const e = "matches";
  return typeof document == "undefined" ? e : [e, "msMatchesSelector", "webkitMatchesSelector"].find((r) => r in Element.prototype) || e;
})();
function vV(e, t) {
  return e == null ? null : e[Kve](t) ? e : vV(e.parentElement, t);
}
function Yve(e, t) {
  return e.closest ? e.closest(t) : vV(e, t);
}
function Uve(e) {
  return `[${k0.contextId}="${e}"]`;
}
function Gve(e, t) {
  const i = t.target;
  if (!Lve(i))
    return null;
  const r = Uve(e), n = Yve(i, r);
  return !n || !Jf(n) ? null : n;
}
function Qve(e, t) {
  const i = Gve(e, t);
  return i ? i.getAttribute(k0.draggableId) : null;
}
function Wve(e, t) {
  const i = `[${xC.contextId}="${e}"]`, n = gV(document, i).find((o) => o.getAttribute(xC.id) === t);
  return !n || !Jf(n) ? null : n;
}
function Zve(e) {
  e.preventDefault();
}
function xp({
  expected: e,
  phase: t,
  isLockActive: i,
  shouldWarn: r
}) {
  return !(!i() || e !== t);
}
function bV({
  lockAPI: e,
  store: t,
  registry: i,
  draggableId: r
}) {
  if (e.isClaimed())
    return !1;
  const n = i.draggable.findById(r);
  return !(!n || !n.options.isEnabled || !cV(t.getState(), r));
}
function Jve({
  lockAPI: e,
  contextId: t,
  store: i,
  registry: r,
  draggableId: n,
  forceSensorStop: o,
  sourceEvent: s
}) {
  if (!bV({
    lockAPI: e,
    store: i,
    registry: r,
    draggableId: n
  }))
    return null;
  const l = r.draggable.getById(n), c = Wve(t, l.descriptor.id);
  if (!c || s && !l.options.canDragInteractiveElements && qve(c, s))
    return null;
  const u = e.claim(o || wl);
  let m = "PRE_DRAG";
  function g() {
    return l.options.shouldRespectForcePress;
  }
  function h() {
    return e.isActive(u);
  }
  function A(R, w) {
    xp({
      expected: R,
      phase: m,
      isLockActive: h,
      shouldWarn: !0
    }) && i.dispatch(w());
  }
  const y = A.bind(null, "DRAGGING");
  function E(R) {
    function w() {
      e.release(), m = "COMPLETED";
    }
    m !== "PRE_DRAG" && (w(), ze()), i.dispatch(Yye(R.liftActionArgs)), m = "DRAGGING";
    function T(N, D = {
      shouldBlockNextClick: !1
    }) {
      if (R.cleanup(), D.shouldBlockNextClick) {
        const O = Uo(window, [{
          eventName: "click",
          fn: Zve,
          options: {
            once: !0,
            passive: !1,
            capture: !0
          }
        }]);
        setTimeout(O);
      }
      w(), i.dispatch(tV({
        reason: N
      }));
    }
    return q({
      isActive: () => xp({
        expected: "DRAGGING",
        phase: m,
        isLockActive: h,
        shouldWarn: !1
      }),
      shouldRespectForcePress: g,
      drop: (N) => T("DROP", N),
      cancel: (N) => T("CANCEL", N)
    }, R.actions);
  }
  function v(R) {
    const w = tg((N) => {
      y(() => eV({
        client: N
      }));
    }), T = E({
      liftActionArgs: {
        id: n,
        clientSelection: R,
        movementMode: "FLUID"
      },
      cleanup: () => w.cancel(),
      actions: {
        move: w
      }
    });
    return ee(q({}, T), {
      move: w
    });
  }
  function C() {
    const R = {
      moveUp: () => y(Hye),
      moveRight: () => y(_ye),
      moveDown: () => y(Xye),
      moveLeft: () => y($ye)
    };
    return E({
      liftActionArgs: {
        id: n,
        clientSelection: jve(c),
        movementMode: "SNAP"
      },
      cleanup: wl,
      actions: R
    });
  }
  function x() {
    xp({
      expected: "PRE_DRAG",
      phase: m,
      isLockActive: h,
      shouldWarn: !0
    }) && e.release();
  }
  return {
    isActive: () => xp({
      expected: "PRE_DRAG",
      phase: m,
      isLockActive: h,
      shouldWarn: !1
    }),
    shouldRespectForcePress: g,
    fluidLift: v,
    snapLift: C,
    abort: x
  };
}
const Pve = [Rve, Nve, Fve];
function zve({
  contextId: e,
  store: t,
  registry: i,
  customSensors: r,
  enableDefaultSensors: n
}) {
  const o = [...n ? Pve : [], ...r || []], s = se(() => mve())[0], a = pt(function(E, v) {
    ag(E) && !ag(v) && s.tryAbandon();
  }, [s]);
  Eo(function() {
    let E = t.getState();
    return t.subscribe(() => {
      const C = t.getState();
      a(E, C), E = C;
    });
  }, [s, t, a]), Eo(() => s.tryAbandon, [s.tryAbandon]);
  const l = pt((y) => bV({
    lockAPI: s,
    registry: i,
    store: t,
    draggableId: y
  }), [s, i, t]), c = pt((y, E, v) => Jve({
    lockAPI: s,
    registry: i,
    contextId: e,
    store: t,
    draggableId: y,
    forceSensorStop: E || null,
    sourceEvent: v && v.sourceEvent ? v.sourceEvent : null
  }), [e, s, i, t]), u = pt((y) => Qve(e, y), [e]), m = pt((y) => {
    const E = i.draggable.findById(y);
    return E ? E.options : null;
  }, [i.draggable]), g = pt(function() {
    s.isClaimed() && (s.tryAbandon(), t.getState().phase !== "IDLE" && t.dispatch(fI()));
  }, [s, t]), h = pt(() => s.isClaimed(), [s]), A = $t(() => ({
    canGetLock: l,
    tryGetLock: c,
    findClosestDraggableId: u,
    findOptionsForDraggable: m,
    tryReleaseLock: g,
    isLockClaimed: h
  }), [l, c, u, m, g, h]);
  for (let y = 0; y < o.length; y++)
    o[y](A);
}
const Hve = (e) => ({
  onBeforeCapture: (t) => {
    kN(() => {
      e.onBeforeCapture && e.onBeforeCapture(t);
    });
  },
  onBeforeDragStart: e.onBeforeDragStart,
  onDragStart: e.onDragStart,
  onDragEnd: e.onDragEnd,
  onDragUpdate: e.onDragUpdate
}), Xve = (e) => ee(q(q({}, sg), e.autoScrollerOptions), {
  durationDampening: q(q({}, sg.durationDampening), e.autoScrollerOptions)
});
function Kd(e) {
  return e.current || ze(), e.current;
}
function _ve(e) {
  const {
    contextId: t,
    setCallbacks: i,
    sensors: r,
    nonce: n,
    dragHandleUsageInstructions: o
  } = e, s = Ne(null), a = pV(e), l = pt(() => Hve(a.current), [a]), c = pt(() => Xve(a.current), [a]), u = lve(t), m = dve({
    contextId: t,
    text: o
  }), g = tve(t, n), h = pt((O) => {
    Kd(s).dispatch(O);
  }, []), A = $t(() => O6({
    publishWhileDragging: Gye,
    updateDroppableScroll: Wye,
    updateDroppableIsEnabled: Zye,
    updateDroppableIsCombineEnabled: Jye,
    collectionStarting: Qye
  }, h), [h]), y = ove(), E = $t(() => DEe(y, A), [y, A]), v = $t(() => HEe(q({
    scrollWindow: OEe,
    scrollDroppable: E.scrollDroppable,
    getAutoScrollerOptions: c
  }, O6({
    move: eV
  }, h))), [E.scrollDroppable, h, c]), C = rve(t), x = $t(() => MEe({
    announce: u,
    autoScroller: v,
    dimensionMarshal: E,
    focusMarshal: C,
    getResponders: l,
    styleMarshal: g
  }), [u, v, E, C, l, g]);
  s.current = x;
  const S = pt(() => {
    const O = Kd(s);
    O.getState().phase !== "IDLE" && O.dispatch(fI());
  }, []), R = pt(() => {
    const O = Kd(s).getState();
    return O.phase === "DROP_ANIMATING" ? !0 : O.phase === "IDLE" ? !1 : O.isDragging;
  }, []), w = $t(() => ({
    isDragging: R,
    tryAbort: S
  }), [R, S]);
  i(w);
  const T = pt((O) => cV(Kd(s).getState(), O), []), N = pt(() => pc(Kd(s).getState()), []), D = $t(() => ({
    marshal: E,
    focus: C,
    contextId: t,
    canLift: T,
    isMovementAllowed: N,
    dragHandleUsageInstructionsId: m,
    registry: y
  }), [t, E, m, C, T, N, y]);
  return zve({
    contextId: t,
    store: x,
    registry: y,
    customSensors: r || null,
    enableDefaultSensors: e.enableDefaultSensors !== !1
  }), be(() => S, [S]), X.createElement(Pf.Provider, {
    value: D
  }, X.createElement(CAe, {
    context: xI,
    store: x
  }, e.children));
}
function $ve() {
  return X.useId();
}
function ebe(e) {
  const t = $ve(), i = e.dragHandleUsageInstructions || _p.dragHandleUsageInstructions;
  return X.createElement(NAe, null, (r) => X.createElement(_ve, {
    nonce: e.nonce,
    contextId: t,
    setCallbacks: r,
    dragHandleUsageInstructions: i,
    enableDefaultSensors: e.enableDefaultSensors,
    sensors: e.sensors,
    onBeforeCapture: e.onBeforeCapture,
    onBeforeDragStart: e.onBeforeDragStart,
    onDragStart: e.onDragStart,
    onDragUpdate: e.onDragUpdate,
    onDragEnd: e.onDragEnd,
    autoScrollerOptions: e.autoScrollerOptions
  }, e.children));
}
const aM = {
  dragging: 5e3,
  dropAnimating: 4500
}, tbe = (e, t) => t ? wm.drop(t.duration) : e ? wm.snap : wm.fluid, ibe = (e, t) => {
  if (e)
    return t ? og.opacity.drop : og.opacity.combining;
}, rbe = (e) => e.forceShouldAnimate != null ? e.forceShouldAnimate : e.mode === "SNAP";
function nbe(e) {
  const i = e.dimension.client, {
    offset: r,
    combineWith: n,
    dropping: o
  } = e, s = !!n, a = rbe(e), l = !!o, c = l ? bC.drop(r, s) : bC.moveTo(r);
  return {
    position: "fixed",
    top: i.marginBox.top,
    left: i.marginBox.left,
    boxSizing: "border-box",
    width: i.borderBox.width,
    height: i.borderBox.height,
    transition: tbe(a, o),
    transform: c,
    opacity: ibe(s, l),
    zIndex: l ? aM.dropAnimating : aM.dragging,
    pointerEvents: "none"
  };
}
function obe(e) {
  return {
    transform: bC.moveTo(e.offset),
    transition: e.shouldAnimateDisplacement ? void 0 : "none"
  };
}
function sbe(e) {
  return e.type === "DRAGGING" ? nbe(e) : obe(e);
}
function abe(e, t, i = Fr) {
  const r = window.getComputedStyle(t), n = t.getBoundingClientRect(), o = wF(n, r), s = L1(o, i), a = {
    client: o,
    tagName: t.tagName.toLowerCase(),
    display: r.display
  }, l = {
    x: o.marginBox.width,
    y: o.marginBox.height
  };
  return {
    descriptor: e,
    placeholder: a,
    displaceBy: l,
    client: o,
    page: s
  };
}
function lbe(e) {
  const t = II("draggable"), {
    descriptor: i,
    registry: r,
    getDraggableRef: n,
    canDragInteractiveElements: o,
    shouldRespectForcePress: s,
    isEnabled: a
  } = e, l = $t(() => ({
    canDragInteractiveElements: o,
    shouldRespectForcePress: s,
    isEnabled: a
  }), [o, a, s]), c = pt((h) => {
    const A = n();
    return A || ze(), abe(i, A, h);
  }, [i, n]), u = $t(() => ({
    uniqueId: t,
    descriptor: i,
    options: l,
    getDimension: c
  }), [i, c, l, t]), m = Ne(u), g = Ne(!0);
  Eo(() => (r.draggable.register(m.current), () => r.draggable.unregister(m.current)), [r.draggable]), Eo(() => {
    if (g.current) {
      g.current = !1;
      return;
    }
    const h = m.current;
    m.current = u, r.draggable.update(u, h);
  }, [u, r.draggable]);
}
var RI = X.createContext(null);
function W1(e) {
  const t = sn(e);
  return t || ze(), t;
}
function cbe(e) {
  e.preventDefault();
}
const ube = (e) => {
  const t = Ne(null), i = pt((w = null) => {
    t.current = w;
  }, []), r = pt(() => t.current, []), {
    contextId: n,
    dragHandleUsageInstructionsId: o,
    registry: s
  } = W1(Pf), {
    type: a,
    droppableId: l
  } = W1(RI), c = $t(() => ({
    id: e.draggableId,
    index: e.index,
    type: a,
    droppableId: l
  }), [e.draggableId, e.index, a, l]), {
    children: u,
    draggableId: m,
    isEnabled: g,
    shouldRespectForcePress: h,
    canDragInteractiveElements: A,
    isClone: y,
    mapped: E,
    dropAnimationFinished: v
  } = e;
  if (!y) {
    const w = $t(() => ({
      descriptor: c,
      registry: s,
      getDraggableRef: r,
      canDragInteractiveElements: A,
      shouldRespectForcePress: h,
      isEnabled: g
    }), [c, s, r, A, h, g]);
    lbe(w);
  }
  const C = $t(() => g ? {
    tabIndex: 0,
    role: "button",
    "aria-describedby": o,
    "data-rfd-drag-handle-draggable-id": m,
    "data-rfd-drag-handle-context-id": n,
    draggable: !1,
    onDragStart: cbe
  } : null, [n, o, m, g]), x = pt((w) => {
    E.type === "DRAGGING" && E.dropping && w.propertyName === "transform" && kN(v);
  }, [v, E]), S = $t(() => {
    const w = sbe(E), T = E.type === "DRAGGING" && E.dropping ? x : void 0;
    return {
      innerRef: i,
      draggableProps: {
        "data-rfd-draggable-context-id": n,
        "data-rfd-draggable-id": m,
        style: w,
        onTransitionEnd: T
      },
      dragHandleProps: C
    };
  }, [n, C, m, E, x, i]), R = $t(() => ({
    draggableId: c.id,
    type: c.type,
    source: {
      index: c.index,
      droppableId: c.droppableId
    }
  }), [c.droppableId, c.id, c.index, c.type]);
  return X.createElement(X.Fragment, null, u(S, E.snapshot, R));
};
var CV = (e, t) => e === t, xV = (e) => {
  const {
    combine: t,
    destination: i
  } = e;
  return i ? i.droppableId : t ? t.droppableId : null;
};
const dbe = (e) => e.combine ? e.combine.draggableId : null, mbe = (e) => e.at && e.at.type === "COMBINE" ? e.at.combine.draggableId : null;
function gbe() {
  const e = Or((n, o) => ({
    x: n,
    y: o
  })), t = Or((n, o, s = null, a = null, l = null) => ({
    isDragging: !0,
    isClone: o,
    isDropAnimating: !!l,
    dropAnimation: l,
    mode: n,
    draggingOver: s,
    combineWith: a,
    combineTargetFor: null
  })), i = Or((n, o, s, a, l = null, c = null, u = null) => ({
    mapped: {
      type: "DRAGGING",
      dropping: null,
      draggingOver: l,
      combineWith: c,
      mode: o,
      offset: n,
      dimension: s,
      forceShouldAnimate: u,
      snapshot: t(o, a, l, c, null)
    }
  }));
  return (n, o) => {
    if (ag(n)) {
      if (n.critical.draggable.id !== o.draggableId)
        return null;
      const s = n.current.client.offset, a = n.dimensions.draggables[o.draggableId], l = yo(n.impact), c = mbe(n.impact), u = n.forceShouldAnimate;
      return i(e(s.x, s.y), n.movementMode, a, o.isClone, l, c, u);
    }
    if (n.phase === "DROP_ANIMATING") {
      const s = n.completed;
      if (s.result.draggableId !== o.draggableId)
        return null;
      const a = o.isClone, l = n.dimensions.draggables[o.draggableId], c = s.result, u = c.mode, m = xV(c), g = dbe(c), A = {
        duration: n.dropDuration,
        curve: yI.drop,
        moveTo: n.newHomeClientOffset,
        opacity: g ? og.opacity.drop : null,
        scale: g ? og.scale.drop : null
      };
      return {
        mapped: {
          type: "DRAGGING",
          offset: n.newHomeClientOffset,
          dimension: l,
          dropping: A,
          draggingOver: m,
          combineWith: g,
          mode: u,
          forceShouldAnimate: null,
          snapshot: t(u, a, m, g, A)
        }
      };
    }
    return null;
  };
}
function IV(e = null) {
  return {
    isDragging: !1,
    isDropAnimating: !1,
    isClone: !1,
    dropAnimation: null,
    mode: null,
    draggingOver: null,
    combineTargetFor: e,
    combineWith: null
  };
}
const hbe = {
  mapped: {
    type: "SECONDARY",
    offset: Fr,
    combineTargetFor: null,
    shouldAnimateDisplacement: !0,
    snapshot: IV(null)
  }
};
function pbe() {
  const e = Or((s, a) => ({
    x: s,
    y: a
  })), t = Or(IV), i = Or((s, a = null, l) => ({
    mapped: {
      type: "SECONDARY",
      offset: s,
      combineTargetFor: a,
      shouldAnimateDisplacement: l,
      snapshot: t(a)
    }
  })), r = (s) => s ? i(Fr, s, !0) : null, n = (s, a, l, c) => {
    const u = l.displaced.visible[s], m = !!(c.inVirtualList && c.effected[s]), g = Qf(l), h = g && g.draggableId === s ? a : null;
    if (!u) {
      if (!m)
        return r(h);
      if (l.displaced.invisible[s])
        return null;
      const E = ed(c.displacedBy.point), v = e(E.x, E.y);
      return i(v, h, !0);
    }
    if (m)
      return r(h);
    const A = l.displacedBy.point, y = e(A.x, A.y);
    return i(y, h, u.shouldAnimate);
  };
  return (s, a) => {
    if (ag(s))
      return s.critical.draggable.id === a.draggableId ? null : n(a.draggableId, s.critical.draggable.id, s.impact, s.afterCritical);
    if (s.phase === "DROP_ANIMATING") {
      const l = s.completed;
      return l.result.draggableId === a.draggableId ? null : n(a.draggableId, l.result.draggableId, l.impact, l.afterCritical);
    }
    return null;
  };
}
const fbe = () => {
  const e = gbe(), t = pbe();
  return (r, n) => e(r, n) || t(r, n) || hbe;
}, Abe = {
  dropAnimationFinished: iV
}, ybe = kF(fbe, Abe, null, {
  context: xI,
  areStatePropsEqual: CV
})(ube);
function SV(e) {
  return W1(RI).isUsingCloneFor === e.draggableId && !e.isClone ? null : X.createElement(ybe, e);
}
function Ebe(e) {
  const t = typeof e.isDragDisabled == "boolean" ? !e.isDragDisabled : !0, i = !!e.disableInteractiveElementBlocking, r = !!e.shouldRespectForcePress;
  return X.createElement(SV, K1({}, e, {
    isClone: !1,
    isEnabled: t,
    canDragInteractiveElements: i,
    shouldRespectForcePress: r
  }));
}
const RV = (e) => (t) => e === t, vbe = RV("scroll"), bbe = RV("auto"), lM = (e, t) => t(e.overflowX) || t(e.overflowY), Cbe = (e) => {
  const t = window.getComputedStyle(e), i = {
    overflowX: t.overflowX,
    overflowY: t.overflowY
  };
  return lM(i, vbe) || lM(i, bbe);
}, xbe = () => !1, kV = (e) => e == null ? null : e === document.body ? xbe() ? e : null : e === document.documentElement ? null : Cbe(e) ? e : kV(e.parentElement);
var IC = (e) => ({
  x: e.scrollLeft,
  y: e.scrollTop
});
const wV = (e) => e ? window.getComputedStyle(e).position === "fixed" ? !0 : wV(e.parentElement) : !1;
var Ibe = (e) => {
  const t = kV(e), i = wV(e);
  return {
    closestScrollable: t,
    isFixedOnPage: i
  };
}, Sbe = ({
  descriptor: e,
  isEnabled: t,
  isCombineEnabled: i,
  isFixedOnPage: r,
  direction: n,
  client: o,
  page: s,
  closest: a
}) => {
  const l = (() => {
    if (!a)
      return null;
    const {
      scrollSize: g,
      client: h
    } = a, A = sV({
      scrollHeight: g.scrollHeight,
      scrollWidth: g.scrollWidth,
      height: h.paddingBox.height,
      width: h.paddingBox.width
    });
    return {
      pageMarginBox: a.page.marginBox,
      frameClient: h,
      scrollSize: g,
      shouldClipSubject: a.shouldClipSubject,
      scroll: {
        initial: a.scroll,
        current: a.scroll,
        max: A,
        diff: {
          value: Fr,
          displacement: Fr
        }
      }
    };
  })(), c = n === "vertical" ? dI : LF, u = S0({
    page: s,
    withPlaceholder: null,
    axis: c,
    frame: l
  });
  return {
    descriptor: e,
    isCombineEnabled: i,
    isFixedOnPage: r,
    axis: c,
    isEnabled: t,
    client: o,
    page: s,
    frame: l,
    subject: u
  };
};
const Rbe = (e, t) => {
  const i = MF(e);
  if (!t || e !== t)
    return i;
  const r = i.paddingBox.top - t.scrollTop, n = i.paddingBox.left - t.scrollLeft, o = r + t.scrollHeight, s = n + t.scrollWidth, l = aI({
    top: r,
    right: s,
    bottom: o,
    left: n
  }, i.border);
  return lI({
    borderBox: l,
    margin: i.margin,
    border: i.border,
    padding: i.padding
  });
};
var kbe = ({
  ref: e,
  descriptor: t,
  env: i,
  windowScroll: r,
  direction: n,
  isDropDisabled: o,
  isCombineEnabled: s,
  shouldClipSubject: a
}) => {
  const l = i.closestScrollable, c = Rbe(e, l), u = L1(c, r), m = (() => {
    if (!l)
      return null;
    const h = MF(l), A = {
      scrollHeight: l.scrollHeight,
      scrollWidth: l.scrollWidth
    };
    return {
      client: h,
      page: L1(h, r),
      scroll: IC(l),
      scrollSize: A,
      shouldClipSubject: a
    };
  })();
  return Sbe({
    descriptor: t,
    isEnabled: !o,
    isCombineEnabled: s,
    isFixedOnPage: i.isFixedOnPage,
    direction: n,
    client: c,
    page: u,
    closest: m
  });
};
const wbe = {
  passive: !1
}, Mbe = {
  passive: !0
};
var cM = (e) => e.shouldPublishImmediately ? wbe : Mbe;
const Ip = (e) => e && e.env.closestScrollable || null;
function Nbe(e) {
  const t = Ne(null), i = W1(Pf), r = II("droppable"), {
    registry: n,
    marshal: o
  } = i, s = pV(e), a = $t(() => ({
    id: e.droppableId,
    type: e.type,
    mode: e.mode
  }), [e.droppableId, e.mode, e.type]), l = Ne(a), c = $t(() => Or((S, R) => {
    t.current || ze();
    const w = {
      x: S,
      y: R
    };
    o.updateDroppableScroll(a.id, w);
  }), [a.id, o]), u = pt(() => {
    const S = t.current;
    return !S || !S.env.closestScrollable ? Fr : IC(S.env.closestScrollable);
  }, []), m = pt(() => {
    const S = u();
    c(S.x, S.y);
  }, [u, c]), g = $t(() => tg(m), [m]), h = pt(() => {
    const S = t.current, R = Ip(S);
    if (S && R || ze(), S.scrollOptions.shouldPublishImmediately) {
      m();
      return;
    }
    g();
  }, [g, m]), A = pt((S, R) => {
    t.current && ze();
    const w = s.current, T = w.getDroppableRef();
    T || ze();
    const N = Ibe(T), D = {
      ref: T,
      descriptor: a,
      env: N,
      scrollOptions: R
    };
    t.current = D;
    const O = kbe({
      ref: T,
      descriptor: a,
      env: N,
      windowScroll: S,
      direction: w.direction,
      isDropDisabled: w.isDropDisabled,
      isCombineEnabled: w.isCombineEnabled,
      shouldClipSubject: !w.ignoreContainerClipping
    }), F = N.closestScrollable;
    return F && (F.setAttribute(rM.contextId, i.contextId), F.addEventListener("scroll", h, cM(D.scrollOptions))), O;
  }, [i.contextId, a, h, s]), y = pt(() => {
    const S = t.current, R = Ip(S);
    return S && R || ze(), IC(R);
  }, []), E = pt(() => {
    const S = t.current;
    S || ze();
    const R = Ip(S);
    t.current = null, R && (g.cancel(), R.removeAttribute(rM.contextId), R.removeEventListener("scroll", h, cM(S.scrollOptions)));
  }, [h, g]), v = pt((S) => {
    const R = t.current;
    R || ze();
    const w = Ip(R);
    w || ze(), w.scrollTop += S.y, w.scrollLeft += S.x;
  }, []), C = $t(() => ({
    getDimensionAndWatchScroll: A,
    getScrollWhileDragging: y,
    dragStopped: E,
    scroll: v
  }), [E, A, y, v]), x = $t(() => ({
    uniqueId: r,
    descriptor: a,
    callbacks: C
  }), [C, a, r]);
  Eo(() => (l.current = x.descriptor, n.droppable.register(x), () => {
    t.current && E(), n.droppable.unregister(x);
  }), [C, a, E, x, o, n.droppable]), Eo(() => {
    t.current && o.updateDroppableIsEnabled(l.current.id, !e.isDropDisabled);
  }, [e.isDropDisabled, o]), Eo(() => {
    t.current && o.updateDroppableIsCombineEnabled(l.current.id, e.isCombineEnabled);
  }, [e.isCombineEnabled, o]);
}
function _E() {
}
const uM = {
  width: 0,
  height: 0,
  margin: qAe
}, Tbe = ({
  isAnimatingOpenOnMount: e,
  placeholder: t,
  animate: i
}) => e || i === "close" ? uM : {
  height: t.client.borderBox.height,
  width: t.client.borderBox.width,
  margin: t.client.margin
}, Bbe = ({
  isAnimatingOpenOnMount: e,
  placeholder: t,
  animate: i
}) => {
  const r = Tbe({
    isAnimatingOpenOnMount: e,
    placeholder: t,
    animate: i
  });
  return {
    display: t.display,
    boxSizing: "border-box",
    width: r.width,
    height: r.height,
    marginTop: r.margin.top,
    marginRight: r.margin.right,
    marginBottom: r.margin.bottom,
    marginLeft: r.margin.left,
    flexShrink: "0",
    flexGrow: "0",
    pointerEvents: "none",
    transition: i !== "none" ? wm.placeholder : null
  };
}, Dbe = (e) => {
  const t = Ne(null), i = pt(() => {
    t.current && (clearTimeout(t.current), t.current = null);
  }, []), {
    animate: r,
    onTransitionEnd: n,
    onClose: o,
    contextId: s
  } = e, [a, l] = se(e.animate === "open");
  be(() => a ? r !== "open" ? (i(), l(!1), _E) : t.current ? _E : (t.current = setTimeout(() => {
    t.current = null, l(!1);
  }), i) : _E, [r, a, i]);
  const c = pt((m) => {
    m.propertyName === "height" && (n(), r === "close" && o());
  }, [r, o, n]), u = Bbe({
    isAnimatingOpenOnMount: a,
    animate: e.animate,
    placeholder: e.placeholder
  });
  return X.createElement(e.placeholder.tagName, {
    style: u,
    "data-rfd-placeholder-context-id": s,
    onTransitionEnd: c,
    ref: e.innerRef
  });
};
var Obe = X.memo(Dbe);
class Fbe extends X.PureComponent {
  constructor(...t) {
    super(...t), this.state = {
      isVisible: !!this.props.on,
      data: this.props.on,
      animate: this.props.shouldAnimate && this.props.on ? "open" : "none"
    }, this.onClose = () => {
      this.state.animate === "close" && this.setState({
        isVisible: !1
      });
    };
  }
  static getDerivedStateFromProps(t, i) {
    return t.shouldAnimate ? t.on ? {
      isVisible: !0,
      data: t.on,
      animate: "open"
    } : i.isVisible ? {
      isVisible: !0,
      data: i.data,
      animate: "close"
    } : {
      isVisible: !1,
      animate: "close",
      data: null
    } : {
      isVisible: !!t.on,
      data: t.on,
      animate: "none"
    };
  }
  render() {
    if (!this.state.isVisible)
      return null;
    const t = {
      onClose: this.onClose,
      data: this.state.data,
      animate: this.state.animate
    };
    return this.props.children(t);
  }
}
const Vbe = (e) => {
  const t = sn(Pf);
  t || ze();
  const {
    contextId: i,
    isMovementAllowed: r
  } = t, n = Ne(null), o = Ne(null), {
    children: s,
    droppableId: a,
    type: l,
    mode: c,
    direction: u,
    ignoreContainerClipping: m,
    isDropDisabled: g,
    isCombineEnabled: h,
    snapshot: A,
    useClone: y,
    updateViewportMaxScroll: E,
    getContainerForClone: v
  } = e, C = pt(() => n.current, []), x = pt((F = null) => {
    n.current = F;
  }, []);
  pt(() => o.current, []);
  const S = pt((F = null) => {
    o.current = F;
  }, []), R = pt(() => {
    r() && E({
      maxScroll: lV()
    });
  }, [r, E]);
  Nbe({
    droppableId: a,
    type: l,
    mode: c,
    direction: u,
    isDropDisabled: g,
    isCombineEnabled: h,
    ignoreContainerClipping: m,
    getDroppableRef: C
  });
  const w = $t(() => X.createElement(Fbe, {
    on: e.placeholder,
    shouldAnimate: e.shouldAnimatePlaceholder
  }, ({
    onClose: F,
    data: Y,
    animate: P
  }) => X.createElement(Obe, {
    placeholder: Y,
    onClose: F,
    innerRef: S,
    animate: P,
    contextId: i,
    onTransitionEnd: R
  })), [i, R, e.placeholder, e.shouldAnimatePlaceholder, S]), T = $t(() => ({
    innerRef: x,
    placeholder: w,
    droppableProps: {
      "data-rfd-droppable-id": a,
      "data-rfd-droppable-context-id": i
    }
  }), [i, a, w, x]), N = y ? y.dragging.draggableId : null, D = $t(() => ({
    droppableId: a,
    type: l,
    isUsingCloneFor: N
  }), [a, N, l]);
  function O() {
    if (!y)
      return null;
    const {
      dragging: F,
      render: Y
    } = y, P = X.createElement(SV, {
      draggableId: F.draggableId,
      index: F.source.index,
      isClone: !0,
      isEnabled: !0,
      shouldRespectForcePress: !1,
      canDragInteractiveElements: !0
    }, (z, W) => Y(z, W, F));
    return Kl.createPortal(P, v());
  }
  return X.createElement(RI.Provider, {
    value: D
  }, s(T, A), O());
};
function qbe() {
  return document.body || ze(), document.body;
}
const dM = {
  mode: "standard",
  type: "DEFAULT",
  direction: "vertical",
  isDropDisabled: !1,
  isCombineEnabled: !1,
  ignoreContainerClipping: !1,
  renderClone: null,
  getContainerForClone: qbe
}, MV = (e) => {
  let t = q({}, e), i;
  for (i in dM)
    e[i] === void 0 && (t = ee(q({}, t), {
      [i]: dM[i]
    }));
  return t;
}, $E = (e, t) => e === t.droppable.type, mM = (e, t) => t.draggables[e.draggable.id], jbe = () => {
  const e = {
    placeholder: null,
    shouldAnimatePlaceholder: !0,
    snapshot: {
      isDraggingOver: !1,
      draggingOverWith: null,
      draggingFromThisWith: null,
      isUsingPlaceholder: !1
    },
    useClone: null
  }, t = ee(q({}, e), {
    shouldAnimatePlaceholder: !1
  }), i = Or((o) => ({
    draggableId: o.id,
    type: o.type,
    source: {
      index: o.index,
      droppableId: o.droppableId
    }
  })), r = Or((o, s, a, l, c, u) => {
    const m = c.descriptor.id;
    if (c.descriptor.droppableId === o) {
      const A = u ? {
        render: u,
        dragging: i(c.descriptor)
      } : null, y = {
        isDraggingOver: a,
        draggingOverWith: a ? m : null,
        draggingFromThisWith: m,
        isUsingPlaceholder: !0
      };
      return {
        placeholder: c.placeholder,
        shouldAnimatePlaceholder: !1,
        snapshot: y,
        useClone: A
      };
    }
    if (!s)
      return t;
    if (!l)
      return e;
    const h = {
      isDraggingOver: a,
      draggingOverWith: m,
      draggingFromThisWith: null,
      isUsingPlaceholder: !0
    };
    return {
      placeholder: c.placeholder,
      shouldAnimatePlaceholder: !0,
      snapshot: h,
      useClone: null
    };
  });
  return (o, s) => {
    const a = MV(s), l = a.droppableId, c = a.type, u = !a.isDropDisabled, m = a.renderClone;
    if (ag(o)) {
      const g = o.critical;
      if (!$E(c, g))
        return t;
      const h = mM(g, o.dimensions), A = yo(o.impact) === l;
      return r(l, u, A, A, h, m);
    }
    if (o.phase === "DROP_ANIMATING") {
      const g = o.completed;
      if (!$E(c, g.critical))
        return t;
      const h = mM(g.critical, o.dimensions);
      return r(l, u, xV(g.result) === l, yo(g.impact) === l, h, m);
    }
    if (o.phase === "IDLE" && o.completed && !o.shouldFlush) {
      const g = o.completed;
      if (!$E(c, g.critical))
        return t;
      const h = yo(g.impact) === l, A = !!(g.impact.at && g.impact.at.type === "COMBINE"), y = g.critical.droppable.id === l;
      return h ? A ? e : t : y ? e : t;
    }
    return t;
  };
}, Lbe = {
  updateViewportMaxScroll: zye
}, Kbe = kF(jbe, Lbe, (e, t, i) => q(q(q({}, MV(i)), e), t), {
  context: xI,
  areStatePropsEqual: CV
})(Vbe), Ybe = "_List_al3o0_1", Ube = "_List__subtitle_al3o0_6", Gbe = "_List__main_al3o0_12", Qbe = "_List__input_al3o0_27", Wbe = "_List__deleteIcon_al3o0_31", Zbe = "_List__cloneIcon_al3o0_32", Jbe = "_List__dragIcon_al3o0_33", Pbe = "_List__iconDisabled_al3o0_36", zbe = "_disabled_al3o0_50", ga = {
  List: Ybe,
  List__subtitle: Ube,
  List__main: Gbe,
  List__input: Qbe,
  List__deleteIcon: Wbe,
  List__cloneIcon: Zbe,
  List__dragIcon: Jbe,
  List__iconDisabled: Pbe,
  disabled: zbe
};
function gM(m) {
  var g = m, {
    label: e,
    placeholder: t,
    items: i,
    onAdd: r,
    onDelete: n,
    onEdit: o,
    onMove: s,
    onClone: a,
    renderer: l,
    className: c
  } = g, u = Fe(g, [
    "label",
    "placeholder",
    "items",
    "onAdd",
    "onDelete",
    "onEdit",
    "onMove",
    "onClone",
    "renderer",
    "className"
  ]);
  const h = !!s, A = !!a, y = X.useCallback(
    ({ destination: E, source: v }) => {
      !E || v.index === E.index || s == null || s(v.index, E.index);
    },
    [s]
  );
  return /* @__PURE__ */ V("div", ee(q({ className: me(ga.List, c) }, u), { children: [
    e && /* @__PURE__ */ f("span", { className: ga.List__subtitle, children: e }),
    /* @__PURE__ */ f(ebe, { onDragEnd: y, children: /* @__PURE__ */ f(Kbe, { droppableId: "planner-edit-list", children: (E) => /* @__PURE__ */ V("ul", ee(q({ className: ga.List__main }, E.droppableProps), { ref: E.innerRef, children: [
      i.map((v, C) => /* @__PURE__ */ f(Ebe, { draggableId: C.toString(), isDragDisabled: !h, index: C, children: (x) => /* @__PURE__ */ V("li", ee(q({}, x.draggableProps), { ref: x.innerRef, children: [
        h && /* @__PURE__ */ f("div", ee(q({}, x.dragHandleProps), { children: /* @__PURE__ */ f(Mt, { className: ga.List__dragIcon, icon: "icons/drag-2.svg", width: 11, height: 15 }) })),
        l ? l({ item: v, index: C }) : /* @__PURE__ */ f(
          kn,
          {
            className: ga.List__input,
            size: "sm-md",
            placeholder: t || "Enter text",
            disabled: !o,
            value: v,
            onChange: (S) => {
              o == null || o(C, S);
            }
          }
        ),
        A && /* @__PURE__ */ f(
          Mt,
          {
            className: ga.List__cloneIcon,
            icon: "icons/copy.svg",
            width: 16,
            height: 16,
            onClick: () => {
              a(C);
            }
          }
        ),
        /* @__PURE__ */ f(
          Mt,
          {
            className: me(ga.List__deleteIcon, !n && ga.List__iconDisabled),
            icon: "icons/delete-icon-2.svg",
            width: 16,
            height: 16,
            onClick: () => {
              n == null || n(C);
            }
          }
        )
      ] })) }, C)),
      E.placeholder
    ] })) }) }),
    /* @__PURE__ */ f("div", { className: ga.List__addBtn, children: /* @__PURE__ */ f(
      Kt,
      {
        disabled: !r,
        onClick: () => {
          r == null || r();
        },
        children: "Add"
      }
    ) })
  ] }));
}
const Hbe = "_link_1z5lf_1", Xbe = {
  link: Hbe
};
function Z1(n) {
  var o = n, {
    to: e,
    className: t,
    onClick: i
  } = o, r = Fe(o, [
    "to",
    "className",
    "onClick"
  ]);
  return /* @__PURE__ */ f(
    "a",
    q({
      className: me(Xbe.link, t),
      href: e,
      target: "_blank",
      rel: "noopener",
      onClick: (s) => {
        i && (s.preventDefault(), s.stopPropagation(), i(s));
      }
    }, r)
  );
}
function _be(i) {
  var r = i, { to: e } = r, t = Fe(r, ["to"]);
  return /* @__PURE__ */ f("a", q({ href: e }, t));
}
function $be(r) {
  var n = r, { to: e, openInNewTab: t = !1 } = n, i = Fe(n, ["to", "openInNewTab"]);
  return t ? /* @__PURE__ */ f(Z1, q({ to: e }, i)) : /* @__PURE__ */ f(_be, q({ to: e }, i));
}
function NV() {
  const { editedProfile: e, setEditedProfile: t } = on(), i = we(() => {
    var n;
    return (n = e.data) == null ? void 0 : n.planner;
  }, [e]), r = ye(
    (n) => {
      t((o) => {
        var c, u;
        const s = Ut.cloneDeep(o);
        if (!((c = s.data) != null && c.planner))
          return o;
        const a = (u = s.data) == null ? void 0 : u.planner, l = typeof n == "function" ? n(a) : n;
        return ee(q({}, s), { data: ee(q({}, s.data), { planner: l }) });
      });
    },
    [t]
  );
  return { planner: i, setPlanner: r };
}
const eCe = "_Author_8eur5_1", tCe = "_Author__input_8eur5_5", iCe = "_Author__title_8eur5_14", rCe = "_Author__labels_8eur5_21", nCe = "_Author__label_8eur5_21", oCe = "_Author__labelText_8eur5_33", rs = {
  Author: eCe,
  Author__input: tCe,
  "Author__input--valid": "_Author__input--valid_8eur5_6",
  "Author__input--invalid": "_Author__input--invalid_8eur5_9",
  Author__title: iCe,
  Author__labels: rCe,
  Author__label: nCe,
  Author__labelText: oCe
};
var SN;
const sCe = (SN = Object.entries(Uf.team).map(([e, t]) => ({
  value: e,
  label: t.nickname
}))) != null ? SN : [], aCe = {
  twitch: /^(https:\/\/)?(www\.)?twitch\.tv\/.*/i,
  youtube: /^(https:\/\/)?(www\.)?youtube\.com\/.*/i,
  twitter: /^(https:\/\/)?(www\.)?(x|twitter)\.com\/.*/i
};
function lCe() {
  var a;
  const [{ isContentCreator: e }] = gi((l) => {
    var c, u;
    return {
      isContentCreator: ((u = (c = l.user) == null ? void 0 : c.metadata_public) == null ? void 0 : u.role) === "content-creator"
    };
  }), { planner: t, setPlanner: i } = NV(), r = t == null ? void 0 : t.author, n = ye(
    (l) => {
      i((c) => ee(q({}, c), { author: { contentCreator: l } }));
    },
    [i]
  ), o = ye(
    (l, c) => {
      i((u) => {
        var m;
        return ee(q({}, u), { author: { user: ee(q({ nickname: "" }, (m = u.author) == null ? void 0 : m.user), { [c]: l }) } });
      });
    },
    [i]
  ), s = ye(
    (l, c) => {
      i((u) => {
        var m, g, h;
        return u = q({}, u), u.author = {
          user: ee(q({
            nickname: ""
          }, (m = u.author) == null ? void 0 : m.user), {
            social: ee(q({}, (h = (g = u.author) == null ? void 0 : g.user) == null ? void 0 : h.social), { [c]: l })
          })
        }, u;
      });
    },
    [i]
  );
  return /* @__PURE__ */ V("div", { className: rs.Author, children: [
    /* @__PURE__ */ f("div", { className: rs.Author__title, children: /* @__PURE__ */ f("span", { children: "Edit Author" }) }),
    /* @__PURE__ */ f("div", { className: rs.Author__body, children: e ? /* @__PURE__ */ f("div", { children: /* @__PURE__ */ f(
      _s,
      {
        size: "sm-md",
        value: (r == null ? void 0 : r.contentCreator) || "maxroll",
        options: sCe,
        onChange: (l) => {
          n(l == null ? void 0 : l.value);
        }
      }
    ) }) : /* @__PURE__ */ V("div", { className: rs.Author__labels, children: [
      /* @__PURE__ */ V("label", { className: rs.Author__label, children: [
        /* @__PURE__ */ f("span", { className: rs.Author__labelText, children: "Name" }),
        /* @__PURE__ */ f(
          kn,
          {
            size: "sm-md",
            value: (a = r == null ? void 0 : r.user) == null ? void 0 : a.nickname,
            onChange: (l) => {
              o(l || void 0, "nickname");
            },
            placeholder: "or nickname..."
          }
        )
      ] }),
      nI.map((l) => {
        var u, m;
        const c = (m = (u = r == null ? void 0 : r.user) == null ? void 0 : u.social) == null ? void 0 : m[l];
        return /* @__PURE__ */ V("label", { className: rs.Author__label, children: [
          /* @__PURE__ */ f("span", { className: rs.Author__labelText, children: l === "twitter" ? "x.com" : Ut.upperFirst(l) }),
          /* @__PURE__ */ f(
            kn,
            {
              className: me(
                rs.Author__input,
                c != null && c.match(aCe[l]) ? rs["Author__input--valid"] : rs["Author__input--invalid"]
              ),
              size: "sm-md",
              value: c,
              onChange: (g) => {
                s(g || void 0, l);
              },
              required: !0,
              placeholder: l === "twitch" ? "https://www.twitch.tv/..." : l === "youtube" ? "https://www.youtube.com/..." : "https://x.com/..."
            }
          )
        ] }, l);
      })
    ] }) })
  ] });
}
const cCe = "_Author_4ostg_1", uCe = "_Author__author_4ostg_7", dCe = "_Author__main_4ostg_17", mCe = "_Author__mainTop_4ostg_25", gCe = "_Author__imgWrapper_4ostg_35", hCe = "_Author__placeholder_4ostg_61", pCe = "_Author__nameWrapper_4ostg_68", fCe = "_Author__name_4ostg_68", ACe = "_Author__liveText_4ostg_96", yCe = "_Author__socials_4ostg_106", ECe = "_Author__extra_4ostg_114", vCe = "_Author__extraInner_4ostg_120", bCe = "_Socials_4ostg_153", CCe = "_Socials__link_4ostg_161", Gr = {
  Author: cCe,
  Author__author: uCe,
  Author__main: dCe,
  Author__mainTop: mCe,
  Author__imgWrapper: gCe,
  "Author__imgWrapper--live": "_Author__imgWrapper--live_4ostg_55",
  Author__placeholder: hCe,
  Author__nameWrapper: pCe,
  Author__name: fCe,
  Author__liveText: ACe,
  Author__socials: yCe,
  Author__extra: ECe,
  Author__extraInner: vCe,
  Socials: bCe,
  Socials__link: CCe
};
function xCe({
  authorData: e,
  isContentCreator: t = !1
}) {
  const { assetPath: i } = fi();
  return /* @__PURE__ */ V("div", { className: Gr.Socials, children: [
    nI.map((r) => {
      var o;
      if (!(r in (e.social || {})))
        return null;
      let n = (o = e.social) == null ? void 0 : o[r];
      return n != null && n.startsWith("www") && (n = `https://${n}`), /* @__PURE__ */ f(Z1, { className: Gr.Socials__link, to: n, children: /* @__PURE__ */ f(
        "span",
        {
          style: {
            maskImage: `url(${i}/images/${r === "twitter" ? "twitter-x" : r}-logo-gray.svg?scope=mask)`,
            WebkitMaskImage: `url(${i}/images/${r === "twitter" ? "twitter-x" : r}-logo-gray.svg?scope=mask)`,
            width: "20px",
            height: "20px"
          }
        }
      ) }, r);
    }),
    t ? /* @__PURE__ */ f(Z1, { className: Gr.Socials__link, to: "https://discord.gg/WBBwg5X", children: /* @__PURE__ */ f(
      "span",
      {
        style: {
          maskImage: `url(${i}/images/discord-logo-gray.svg?scope=mask)`,
          WebkitMaskImage: `url(${i}/images/discord-logo-gray.svg?scope=mask)`,
          width: "20px",
          height: "20px"
        }
      }
    ) }) : null
  ] });
}
function ICe({ authorData: e, contentCreator: t }) {
  var a, l;
  const { assetPath: i, frontendPath: r } = fi(), [n, o] = se(!1);
  be(() => {
    var u;
    const c = r.split("//")[1];
    if (o(!1), e.nickname !== "Maxroll" && ((u = e.social) != null && u.twitch)) {
      const m = e.social.twitch;
      F1e(m.split("twitch.tv/")[1], c).then((g) => {
        o(g);
      });
    }
  }, [e, r]);
  const s = we(() => {
    var c;
    return (c = Uf.tabs.find((u) => u.slug === "poe2")) == null ? void 0 : c.members.find((u) => u.slug === t);
  }, [t]);
  return /* @__PURE__ */ f("div", { className: me(Gr.Author__author, Gr.Author__authorBox), children: /* @__PURE__ */ V("div", { className: Gr.Author__main, children: [
    /* @__PURE__ */ V(
      "div",
      {
        style: {
          backgroundImage: `linear-gradient(90deg, rgba(18, 19, 20, 0.4) 0%, #121314 140%), url("${i}/images/poe2/build-guides/poe2-pattern.webp")`
        },
        className: Gr.Author__mainTop,
        children: [
          e.image ? /* @__PURE__ */ f(
            "div",
            {
              className: me(Gr.Author__imgWrapper, n ? Gr["Author__imgWrapper--live"] : void 0),
              style: e.nickname == "Maxroll" ? {} : { background: "#0a0a0a", borderRadius: "100%" },
              children: /* @__PURE__ */ f(
                "img",
                {
                  style: e.nickname == "Maxroll" || e.customImageWidth ? { width: "100%", height: "100%" } : { width: "62px" },
                  src: `${i}/images/${e.image}`,
                  alt: e.nickname
                }
              )
            }
          ) : /* @__PURE__ */ f("div", { className: Gr.Author__placeholder }),
          /* @__PURE__ */ f("div", { className: Gr.Author__nameWrapper, children: /* @__PURE__ */ V("span", { className: Gr.Author__name, children: [
            /* @__PURE__ */ f("span", { children: e.nickname }),
            s && /* @__PURE__ */ f("span", { children: "Content Creator" })
          ] }) }),
          n ? /* @__PURE__ */ f(
            "a",
            {
              target: "_blank",
              rel: "noopener noreferrer",
              href: (a = e.social) == null ? void 0 : a.twitch,
              className: Gr.Author__liveText,
              children: "Now Live!"
            }
          ) : null
        ]
      }
    ),
    e.social ? /* @__PURE__ */ V("div", { className: Gr.Author__socials, children: [
      /* @__PURE__ */ f(xCe, { authorData: e, isContentCreator: !!s }),
      ((l = e.social) == null ? void 0 : l.twitch) && /* @__PURE__ */ f(Z1, { to: e.social.twitch, className: Gr.Author__extra, children: /* @__PURE__ */ V("div", { className: Gr.Author__extraInner, children: [
        /* @__PURE__ */ f("span", { children: "Stay Connected" }),
        /* @__PURE__ */ f("span", {}),
        /* @__PURE__ */ f("span", { children: "Drop a Follow!" })
      ] }) })
    ] }) : null
  ] }) });
}
function qBe() {
  var o, s;
  const { isOwnedProfile: e, editedProfile: t } = on(), i = (s = (o = t.data) == null ? void 0 : o.planner) == null ? void 0 : s.author, r = EF(i);
  return !!r || e ? /* @__PURE__ */ f(
    $0,
    {
      className: Gr.Author,
      title: "Author",
      editSection: e ? /* @__PURE__ */ f(lCe, {}) : void 0,
      children: r ? /* @__PURE__ */ f(ICe, { authorData: r, contentCreator: i == null ? void 0 : i.contentCreator }) : null
    }
  ) : null;
}
const SCe = "_Showcase_1800q_1", RCe = "_Showcase__title_1800q_5", kCe = "_Showcase__label_1800q_12", Sp = {
  Showcase: SCe,
  Showcase__title: RCe,
  Showcase__label: kCe
}, wCe = "_Showcase_1otma_1", MCe = "_Showcase__video_1otma_9", hM = {
  Showcase: wCe,
  Showcase__video: MCe
};
function TV({ showcaseVideo: e }) {
  return /* @__PURE__ */ f("div", { className: hM.Showcase, children: /* @__PURE__ */ f("div", { className: hM.Showcase__video, children: /* @__PURE__ */ f(
    "iframe",
    {
      title: "YouTube video player",
      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
      allowFullScreen: !0,
      src: `https://www.youtube.com/embed/${e}`
    }
  ) }) });
}
function NCe() {
  const { planner: e, setPlanner: t } = NV(), i = e == null ? void 0 : e.showcaseVideo, r = ye(
    (n) => {
      t((o) => ee(q({}, o), { showcaseVideo: n }));
    },
    [t]
  );
  return /* @__PURE__ */ V("div", { className: Sp.Showcase, children: [
    /* @__PURE__ */ f("div", { className: Sp.Showcase__title, children: /* @__PURE__ */ f("span", { children: "Configure Build Showcase" }) }),
    /* @__PURE__ */ V("div", { className: Sp.Showcase__body, children: [
      /* @__PURE__ */ V("label", { className: Sp.Showcase__label, children: [
        /* @__PURE__ */ f("span", { children: "Build Showcase URL" }),
        /* @__PURE__ */ f(
          kn,
          {
            size: "sm-md",
            value: i ? `https://www.youtube.com/embed/${i}` : "",
            onChange: (n) => {
              r(q9(n) || void 0);
            },
            placeholder: "https://www.youtube.com/watch?v=..."
          }
        )
      ] }),
      i ? /* @__PURE__ */ f(TV, { showcaseVideo: i }) : null
    ] })
  ] });
}
const TCe = "_Showcase_gn870_1", BCe = {
  Showcase: TCe
};
function jBe() {
  var o, s;
  const { isOwnedProfile: e } = on(), { editedProfile: t } = on(), i = (s = (o = t.data) == null ? void 0 : o.planner) == null ? void 0 : s.showcaseVideo, r = e;
  return !!i || r ? /* @__PURE__ */ f(
    $0,
    {
      className: BCe.Showcase,
      title: "Build Showcase",
      editSection: r ? /* @__PURE__ */ f(NCe, {}) : void 0,
      children: i ? /* @__PURE__ */ f(TV, { showcaseVideo: i }) : null
    }
  ) : null;
}
const DCe = "_Header_12ndm_1", OCe = "_Header__left_12ndm_16", FCe = "_Header__topLeft_12ndm_23", VCe = "_Header__image_12ndm_29", qCe = "_Header__content_12ndm_42", jCe = "_Header__title_12ndm_48", LCe = "_Header__details_12ndm_62", KCe = "_Header__detailsHighlight_12ndm_73", YCe = "_Header__detailsHighlight2_12ndm_77", UCe = "_Header__meta_12ndm_81", GCe = "_Header__right_12ndm_87", QCe = "_Header__bottomRight_12ndm_95", Fn = {
  Header: DCe,
  Header__left: OCe,
  Header__topLeft: FCe,
  Header__image: VCe,
  Header__content: qCe,
  Header__title: jCe,
  Header__details: LCe,
  Header__detailsHighlight: KCe,
  Header__detailsHighlight2: YCe,
  Header__meta: UCe,
  Header__right: GCe,
  Header__bottomRight: QCe
};
function Ug(e, t, i) {
  be(() => {
    if (!(typeof window == "undefined" || !t))
      return window.addEventListener(e, t, i), () => {
        window.removeEventListener(e, t, i);
      };
  }, [e, t, i]);
}
const LBe = (e, t) => {
  Ug("resize", () => e({ width: window.innerWidth, height: window.innerHeight }), t);
}, KBe = (e, t) => {
  Ug("scroll", () => e({ scrollX: window.scrollX, scrollY: window.scrollY }), t);
}, YBe = (e, t) => {
  Ug("mousemove", ({ clientX: i, clientY: r }) => e({ x: i, y: r }), t);
}, UBe = (e, t) => {
  Ug("mousedown", (i) => e(i), t);
}, WCe = (e) => (Ug("request-login", e), { dispatch: ye(() => {
  const i = new CustomEvent("request-login");
  window.dispatchEvent(i);
}, []) }), ZCe = "_Rating_1ln2p_1", JCe = "_Rating__value_1ln2p_7", PCe = "_Rating__stars_1ln2p_11", zCe = "_Rating_star_1ln2p_15", HCe = "_Rating__check_1ln2p_38", nl = {
  Rating: ZCe,
  Rating__value: JCe,
  Rating__stars: PCe,
  Rating_star: zCe,
  "Rating_star--active": "_Rating_star--active_1ln2p_19",
  "Rating__stars--disabled": "_Rating__stars--disabled_1ln2p_24",
  Rating__check: HCe
};
function XCe() {
  var c, u, m;
  const [{ user: e }] = gi((g) => ({ user: g.user })), { siteId: t } = Ui(), { editedProfile: i, isOwnedProfile: r, rateProfile: n } = on(), { dispatch: o } = WCe(), s = we(() => {
    var g;
    return (g = Uf.tabs.find((h) => h.slug === t)) == null ? void 0 : g.members.find((h) => {
      var A, y, E;
      return h.slug === ((E = (y = (A = i.data) == null ? void 0 : A.planner) == null ? void 0 : y.author) == null ? void 0 : E.contentCreator);
    });
  }, [(m = (u = (c = i.data) == null ? void 0 : c.planner) == null ? void 0 : u.author) == null ? void 0 : m.contentCreator, t]), a = we(
    () => (e == null ? void 0 : e.plannerId) !== (i == null ? void 0 : i.userId),
    [i == null ? void 0 : i.userId, e == null ? void 0 : e.plannerId]
  ), l = ye(
    (g) => {
      if (!r) {
        if (!(e != null && e.id)) {
          o();
          return;
        }
        n(i.id, g);
      }
    },
    [o, i.id, r, n, e == null ? void 0 : e.id]
  );
  return s ? null : /* @__PURE__ */ V("div", { className: nl.Rating, children: [
    /* @__PURE__ */ f("span", { className: nl.Rating__text, children: "Rating" }),
    /* @__PURE__ */ f("span", { className: nl.Rating__value, children: (i.average_rating || 0).toFixed(1) }),
    !r && /* @__PURE__ */ f("span", { className: me(nl.Rating__stars, !a && nl["Rating__stars--disabled"]), children: [1, 2, 3, 4, 5].map((g) => {
      var h;
      return /* @__PURE__ */ f(
        Mt,
        {
          className: me(
            nl.Rating_star,
            ((h = i.userRating) != null ? h : 0) >= g && nl["Rating_star--active"]
          ),
          onClick: a ? () => l(g) : void 0,
          icon: "icons/star.svg",
          width: 11,
          height: 11
        },
        g
      );
    }) }),
    i.userRating ? /* @__PURE__ */ f(Mt, { className: nl.Rating__check, icon: "check-icon.svg", width: 10, height: 10 }) : null
  ] });
}
const _Ce = "_Tag_1ub4k_1", $Ce = {
  Tag: _Ce
};
function $p(r) {
  var n = r, { className: e, children: t } = n, i = Fe(n, ["className", "children"]);
  return /* @__PURE__ */ f("span", ee(q({ className: me($Ce.Tag, e) }, i), { children: t }));
}
const e2e = "_Tags_16ei5_1", t2e = "_Tags__categorySelect_16ei5_7", i2e = "_Tags__removeTag_16ei5_11", r2e = "_Tags__addBtn_16ei5_14", n2e = "_Tags__removeIcon_16ei5_22", o2e = "_Tags__plusIcon_16ei5_25", Lu = {
  Tags: e2e,
  Tags__categorySelect: t2e,
  Tags__removeTag: i2e,
  Tags__addBtn: r2e,
  Tags__removeIcon: n2e,
  Tags__plusIcon: o2e
};
function s2e({
  categories: e,
  tagSets: t
}) {
  const { editedProfile: i, isOwnedProfile: r, setEditedProfile: n } = on(), [o, s] = se(!1), [a, l] = se(null), c = we(() => t.flat(), [t]), u = we(
    () => t.reduce((E, v) => {
      const C = v.reduce((x, S) => (x[S.value] = v, x), {});
      return q(q({}, E), C);
    }, {}),
    [t]
  ), m = we(
    () => e.find((E) => E.value === i.category),
    [e, i.category]
  ), g = ye(
    (E) => {
      E && n((v) => ee(q({}, v), { category: E.value }));
    },
    [n]
  ), h = we(() => {
    var v;
    const E = (v = i.tags) == null ? void 0 : v.map((C) => c.find((x) => x.value === C)).filter((C) => C !== void 0);
    return E == null || E.sort((C, x) => C.order - x.order), E;
  }, [c, i.tags]), A = ye(
    (E) => {
      E && n((v) => {
        const C = [...v.tags || []];
        if (C.includes(E.value))
          return v;
        const x = u[E.value];
        for (const S of x) {
          const R = C.findIndex((w) => w === S.value);
          R !== -1 && C.splice(R, 1);
        }
        return C.push(E.value), ee(q({}, v), { tags: C });
      });
    },
    [n, u]
  ), y = ye(
    (E) => () => {
      E && n((v) => {
        const C = [...v.tags || []], x = C.findIndex((S) => S === E.value);
        return x !== -1 && C.splice(x, 1), ee(q({}, v), { tags: C });
      });
    },
    [n]
  );
  return /* @__PURE__ */ f("div", { className: Lu.Tags, children: r ? /* @__PURE__ */ V(gt, { children: [
    e.length > 0 ? /* @__PURE__ */ f(
      _s,
      {
        size: "sm",
        className: Lu.Tags__categorySelect,
        value: i.category,
        options: e,
        onChange: g,
        isClearable: !1
      }
    ) : null,
    h == null ? void 0 : h.map((E, v) => /* @__PURE__ */ V($p, { children: [
      /* @__PURE__ */ f("span", { children: E.label }),
      /* @__PURE__ */ f("span", { className: Lu.Tags__removeTag, onClick: y(E), children: /* @__PURE__ */ f(Mt, { className: Lu.Tags__removeIcon, width: 10, height: 10, icon: "icons/clear-2.svg" }) })
    ] }, v)),
    (t == null ? void 0 : t.length) > 0 ? /* @__PURE__ */ V(gt, { children: [
      /* @__PURE__ */ V(
        Kt,
        {
          size: "sm",
          ref: l,
          buttonStyle: "primary2",
          className: Lu.Tags__addBtn,
          onClick: () => {
            s(!0);
          },
          children: [
            /* @__PURE__ */ f(Mt, { className: Lu.Tags__plusIcon, width: 8, height: 8, icon: "icons/plus-icon.webp" }),
            /* @__PURE__ */ f("span", { children: "Add Tag" })
          ]
        }
      ),
      /* @__PURE__ */ f(
        j2e,
        {
          value: void 0,
          options: c,
          onUpdate: A,
          selectorVisible: o,
          setSelectorVisible: s,
          rendererElem: a
        }
      )
    ] }) : null
  ] }) : /* @__PURE__ */ V(gt, { children: [
    m ? /* @__PURE__ */ f($p, { children: m.label }) : null,
    h == null ? void 0 : h.map((E, v) => /* @__PURE__ */ f($p, { children: /* @__PURE__ */ f("span", { children: E.label }) }, v))
  ] }) });
}
function GBe({
  fallbackTitle: e,
  categories: t,
  tagSets: i,
  image: r,
  imageOverride: n,
  background: o,
  bottomRightSlot: s,
  className: a
}) {
  const { editedProfile: l, setEditedProfile: c, isOwnedProfile: u } = on(), m = ye(
    (g) => {
      c((h) => g === h.public ? h : ee(q({}, h), { public: g }));
    },
    [c]
  );
  return /* @__PURE__ */ V("div", { className: me(Fn.Header, a), children: [
    o,
    /* @__PURE__ */ V("div", { className: Fn.Header__left, children: [
      /* @__PURE__ */ V("div", { className: Fn.Header__topLeft, children: [
        n || (r ? /* @__PURE__ */ f("div", { className: Fn.Header__image, children: r }) : null),
        /* @__PURE__ */ V("div", { className: Fn.Header__content, children: [
          /* @__PURE__ */ f("div", { className: Fn.Header__title, children: l.name || e }),
          /* @__PURE__ */ V("div", { className: Fn.Header__details, children: [
            /* @__PURE__ */ f("div", { className: Fn.Header__meta, children: l.date ? /* @__PURE__ */ V("span", { children: [
              "Updated ",
              /* @__PURE__ */ f("span", { className: Fn.Header__detailsHighlight2, children: Gs(l.date) })
            ] }) : null }),
            /* @__PURE__ */ f(XCe, {})
          ] })
        ] })
      ] }),
      /* @__PURE__ */ f(s2e, { categories: t, tagSets: i })
    ] }),
    /* @__PURE__ */ f("div", { className: Fn.Header__center }),
    /* @__PURE__ */ V("div", { className: Fn.Header__right, children: [
      /* @__PURE__ */ f("div", { children: !u && /* @__PURE__ */ f("div", { className: Fn.Header_favorite }) }),
      /* @__PURE__ */ V("div", { className: Fn.Header__bottomRight, children: [
        s,
        u && /* @__PURE__ */ f("div", { className: Fn.Header_public, children: /* @__PURE__ */ V($p, { children: [
          /* @__PURE__ */ f(Ka, { type: "sm", value: l.public, onChange: m }),
          " Public Profile"
        ] }) })
      ] })
    ] })
  ] });
}
const a2e = "_Notes_1o58e_1", l2e = "_Notes__title_1o58e_6", ev = {
  Notes: a2e,
  Notes__title: l2e
};
function c2e({
  notes: e,
  onChange: t,
  isContentCreator: i
}) {
  const { rte: r } = Ui(), n = ye(
    (o) => {
      t(q({}, o));
    },
    [t]
  );
  return r ? /* @__PURE__ */ V("div", { className: ev.Notes, children: [
    /* @__PURE__ */ f("div", { className: ev.Notes__title, children: /* @__PURE__ */ f("span", { children: "Edit Notes" }) }),
    /* @__PURE__ */ f("div", { className: ev.Notes__body, children: Ei(r, { value: e, isEditing: !0, isRestricted: !i, onChange: n }) })
  ] }) : null;
}
const u2e = "_Notes_g6hev_1", d2e = "_Notes__box_g6hev_9", m2e = "_Notes__inner_g6hev_14", tv = {
  Notes: u2e,
  Notes__box: d2e,
  Notes__inner: m2e
}, g2e = "_Notes_z8qyx_1", h2e = "_Notes__title_z8qyx_6", p2e = "_Notes__body_z8qyx_13", iv = {
  Notes: g2e,
  Notes__title: h2e,
  Notes__body: p2e
};
function f2e({ notes: e }) {
  const { rte: t } = Ui();
  return t ? /* @__PURE__ */ V("div", { className: iv.Notes, children: [
    /* @__PURE__ */ f("div", { className: iv.Notes__title, children: /* @__PURE__ */ f("span", { children: "Notes" }) }),
    /* @__PURE__ */ f("div", { className: iv.Notes__body, children: Ei(t, { value: e, isEditing: !1 }) })
  ] }) : null;
}
function QBe({
  notes: e,
  onChange: t,
  title: i,
  notesClassName: r
}) {
  const [{ isContentCreator: n }] = gi((A) => {
    var y, E;
    return {
      isContentCreator: ((E = (y = A.user) == null ? void 0 : y.metadata_public) == null ? void 0 : E.role) === "content-creator"
    };
  }), { rte: o } = Ui(), { isOwnedProfile: s, editedProfile: a } = on(), [l, c] = se(!0), u = ye(
    (A) => {
      c(A);
    },
    [c]
  );
  be(() => {
    c(!0);
    const A = setTimeout(() => {
      c(!1);
    }, 300);
    return () => {
      clearTimeout(A);
    };
  }, [a.id]);
  const m = we(() => s ? /* @__PURE__ */ f(uC, { label: "Edit", icon: "edit", modalConfirmButton: !0, modalToggleCallback: u, children: /* @__PURE__ */ f(c2e, { notes: e, onChange: t, isContentCreator: n }) }) : /* @__PURE__ */ f(uC, { icon: "expand", children: /* @__PURE__ */ f(f2e, { notes: e }) }), [n, s, u, e, t]), g = we(() => {
    var y, E;
    if (!e || JSON.stringify(e) === "{}")
      return !0;
    const A = (E = (y = e == null ? void 0 : e.root) == null ? void 0 : y.children) == null ? void 0 : E[0];
    return !A || (A == null ? void 0 : A.children.length) === 0;
  }, [e]);
  return o && (!g || s) ? /* @__PURE__ */ f($0, { title: i != null ? i : "Notes", actionsSection: m, children: /* @__PURE__ */ f("div", { className: me(tv.Notes, r), children: /* @__PURE__ */ f(Pr, { className: tv.Notes__box, innerClassName: tv.Notes__inner, type: "vertical", children: l ? null : Ei(o, { value: e, isEditing: !1 }) }) }) }) : null;
}
const A2e = "_StrAndWeak_160zg_1", y2e = "_title_160zg_11", E2e = "_inner_160zg_23", v2e = "_strengths_160zg_32", b2e = "_weaknesses_160zg_33", C2e = "_subtitle_160zg_39", ol = {
  StrAndWeak: A2e,
  "StrAndWeak--icons": "_StrAndWeak--icons_160zg_7",
  title: y2e,
  inner: E2e,
  strengths: v2e,
  weaknesses: b2e,
  subtitle: C2e,
  "StrAndWeak--lines": "_StrAndWeak--lines_160zg_109"
};
function x2e(l) {
  var c = l, {
    type: e = "icons",
    title: t = "Strengths And Weaknesses",
    strengthsTitle: i = "Strengths",
    strengths: r,
    weaknessesTitle: n = "Weaknesses",
    weaknesses: o,
    className: s
  } = c, a = Fe(c, [
    "type",
    "title",
    "strengthsTitle",
    "strengths",
    "weaknessesTitle",
    "weaknesses",
    "className"
  ]);
  return /* @__PURE__ */ V("div", ee(q({ className: me(ol.StrAndWeak, ol[`StrAndWeak--${e}`], s) }, a), { children: [
    t !== "" && /* @__PURE__ */ f("div", { className: ol.title, children: t }),
    /* @__PURE__ */ V("div", { className: ol.inner, children: [
      /* @__PURE__ */ V("div", { className: ol.strengths, children: [
        e === "icons" ? /* @__PURE__ */ f("span", { className: ol.subtitle, children: i }) : null,
        /* @__PURE__ */ f("ul", { children: r == null ? void 0 : r.map((u, m) => /* @__PURE__ */ f("li", { children: u }, m)) })
      ] }),
      /* @__PURE__ */ V("div", { className: ol.weaknesses, children: [
        e === "icons" ? /* @__PURE__ */ f("span", { className: ol.subtitle, children: n }) : null,
        /* @__PURE__ */ f("ul", { children: o == null ? void 0 : o.map((u, m) => /* @__PURE__ */ f("li", { children: u }, m)) })
      ] })
    ] })
  ] }));
}
const I2e = "_Edit_8qymj_1", S2e = "_Edit__title_8qymj_5", R2e = "_Edit__content_8qymj_13", rv = {
  Edit: I2e,
  Edit__title: S2e,
  Edit__content: R2e
}, k2e = { strengths: [], weaknesses: [] }, Yd = (e, t) => (e = q({}, e != null ? e : k2e), e[t] = [...e[t]], e);
function w2e({
  data: e,
  onChange: t
}) {
  const i = ye(
    (a) => t((l) => (l = Yd(l, a), l[a].push(""), l)),
    [t]
  ), r = ye(
    (a, l) => t((c) => (c = Yd(c, l), c[l].splice(a, 1), c)),
    [t]
  ), n = ye(
    (a, l, c) => t((u) => (u = Yd(u, c), u[c][a] = l, u)),
    [t]
  ), o = ye(
    (a, l, c) => t((u) => {
      u = Yd(u, c);
      const m = u[c], g = m[a];
      return m.splice(a, 1), m.splice(l, 0, g), u;
    }),
    [t]
  ), s = ye(
    (a, l) => t((c) => {
      c = Yd(c, l);
      const u = c[l][a];
      return c[l].splice(a, 0, u), c;
    }),
    [t]
  );
  return /* @__PURE__ */ V("div", { className: rv.Edit, children: [
    /* @__PURE__ */ f("div", { className: rv.Edit__title, children: /* @__PURE__ */ f("span", { children: "Configure Strengths and Weaknesses" }) }),
    /* @__PURE__ */ V("div", { className: rv.Edit__content, children: [
      /* @__PURE__ */ f(
        gM,
        {
          label: "Strengths",
          items: (e == null ? void 0 : e.strengths) || [],
          onAdd: () => {
            i("strengths");
          },
          onDelete: (a) => {
            r(a, "strengths");
          },
          onEdit: (a, l) => {
            n(a, l, "strengths");
          },
          onMove: (a, l) => {
            o(a, l, "strengths");
          },
          onClone: (a) => {
            s(a, "strengths");
          }
        }
      ),
      /* @__PURE__ */ f(
        gM,
        {
          label: "Weaknesses",
          items: (e == null ? void 0 : e.weaknesses) || [],
          onAdd: () => {
            i("weaknesses");
          },
          onDelete: (a) => {
            r(a, "weaknesses");
          },
          onEdit: (a, l) => {
            n(a, l, "weaknesses");
          },
          onMove: (a, l) => {
            o(a, l, "weaknesses");
          },
          onClone: (a) => {
            s(a, "weaknesses");
          }
        }
      )
    ] })
  ] });
}
const M2e = "_StrAndWeak_181rb_1", N2e = "_StrAndWeak__inner_181rb_2", pM = {
  StrAndWeak: M2e,
  StrAndWeak__inner: N2e
};
function WBe({
  data: e,
  onChange: t
}) {
  const { isOwnedProfile: i } = on();
  return (e == null ? void 0 : e.strengths.length) || (e == null ? void 0 : e.weaknesses.length) || i ? /* @__PURE__ */ f(
    $0,
    {
      title: "Strengths and Weaknesses",
      editSection: i ? /* @__PURE__ */ f(w2e, { data: e, onChange: t }) : void 0,
      children: /* @__PURE__ */ f("div", { className: pM.StrAndWeak, children: /* @__PURE__ */ f("div", { className: pM.StrAndWeak__inner, children: /* @__PURE__ */ f(
        x2e,
        {
          title: "",
          type: "lines",
          strengths: e == null ? void 0 : e.strengths.filter((o) => !!o),
          weaknesses: e == null ? void 0 : e.weaknesses.filter((o) => !!o)
        }
      ) }) })
    }
  ) : null;
}
const T2e = (e) => `<?xml version="1.0" encoding="UTF-8"?>
  <urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
  ${e.map(
  (i) => `    <url><loc>${i.loc}</loc><lastmod>${i.lastmod}</lastmod><changefreq>${i.changefreq || "weekly"}</changefreq>${i.priority ? `<priority>${i.priority}</priority>` : ""}</url>`
).join(`
`)}
  </urlset>`, fM = "https://maxroll.gg", B2e = (e, t) => {
  var r, n;
  const i = Wt("a");
  i.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(t || "")), i.setAttribute("download", e), i.style.display = "none", (r = document.body) == null || r.appendChild(i), i.click(), (n = document.body) == null || n.removeChild(i);
};
function ZBe() {
  const { siteId: e, gameData: t, navigationData: i, liveAssetPath: r } = Ui(), n = we(() => `${fM}/${e}/database`, [e]), o = we(
    () => {
      var l;
      return (l = i == null ? void 0 : i(r || "", !1)(t)) != null ? l : [];
    },
    [t, r, i]
  ), s = we(() => {
    const l = (c, u) => {
      const m = [];
      for (const g of c)
        m.push([g, u]), g.children && m.push(...l(g.children, g.id));
      return m;
    };
    return l(o);
  }, [o]), a = ye(() => {
    const l = [], c = [], u = (h) => {
      var E;
      const A = eu(h.loc);
      if (A.includes("http"))
        return;
      let y = `${fM}${A}`;
      y.endsWith("/") && (y = y.slice(0, -1)), c.includes(y) || (c.push(y), l.push(ee(q({}, h), { loc: y, lastmod: (E = h.lastmod) == null ? void 0 : E.split("T")[0] })));
    }, m = {};
    for (const [h, A] of s)
      m[h.id] = `${n}/${h.id}`, u({
        loc: m[h.id],
        lastmod: (/* @__PURE__ */ new Date()).toISOString(),
        priority: "1.0",
        changefreq: "daily"
      });
    for (const h of o) {
      if (!(h != null && h.content))
        continue;
      const A = h.content();
      for (const y of A)
        u({
          loc: `${m[h.id]}/${y._identity}`,
          lastmod: (/* @__PURE__ */ new Date()).toISOString(),
          priority: "1.0",
          changefreq: "weekly"
        });
    }
    const g = T2e(l);
    B2e("sitemap.xml", g);
  }, [n, o, s]);
  return /* @__PURE__ */ f("div", { children: /* @__PURE__ */ f(Kt, { onClick: a, children: "Generate Sitemap" }) });
}
const D2e = "_selector_18f9j_1", O2e = "_entity_18f9j_10", F2e = "_emptyTh_18f9j_14", V2e = "_pagination_18f9j_19", Ud = {
  selector: D2e,
  entity: O2e,
  emptyTh: F2e,
  pagination: V2e
};
function q2e({
  options: e,
  query: t,
  limit: i
}) {
  const [r, n] = se([]), o = zT(() => {
    const s = [];
    let a = 0;
    for (; a < e.length && (i === void 0 || s.length < i); ) {
      const l = e[a];
      (!t || of(l, t)) && s.push(l), a += 1;
    }
    n(s);
  }, 100);
  return be(() => {
    o();
  }, [t, o]), { results: r };
}
function j2e({
  value: e,
  onUpdate: t,
  options: i,
  selectorVisible: r,
  setSelectorVisible: n,
  rendererElem: o
}) {
  const [s] = gi((E) => ({ md: E.viewport.md })), [a, l] = se(""), { results: c } = q2e({ options: i, query: a }), { pagItems: u, pagNav: m, pagesCount: g } = Px(c, 10, !1), [h, A] = se(null), y = ye(() => {
    n(!1);
  }, [n]);
  return HT(h, y), /* @__PURE__ */ f(Fg, { visible: r, referenceElement: o, options: $x({ viewport: s }), children: /* @__PURE__ */ V("div", { ref: A, className: Ud.selector, children: [
    /* @__PURE__ */ f(kn, { size: "sm", value: a, onChange: l, placeholder: "Search..." }),
    /* @__PURE__ */ V(zx, { children: [
      /* @__PURE__ */ f("thead", { children: /* @__PURE__ */ f("tr", { children: /* @__PURE__ */ f("th", { className: Ud.emptyTh }) }) }),
      /* @__PURE__ */ V("tbody", { children: [
        e !== void 0 ? /* @__PURE__ */ f(
          "tr",
          {
            className: Ud.entity,
            onClick: () => {
              t && t(void 0), n(!1);
            },
            children: /* @__PURE__ */ f("td", { children: "Clear" })
          }
        ) : null,
        u.map((E, v) => /* @__PURE__ */ f(
          "tr",
          {
            className: Ud.entity,
            onClick: () => {
              t && t(E), n(!1);
            },
            children: /* @__PURE__ */ f("td", { children: E.label })
          },
          v
        ))
      ] })
    ] }),
    g > 1 && /* @__PURE__ */ f("div", { className: Ud.pagination, children: m })
  ] }) });
}
const L2e = "_Select_pj04c_1", K2e = "_Select__option_pj04c_7", Y2e = "_Select__optionText_pj04c_16", U2e = "_Select__optionContent_pj04c_30", Ku = {
  Select: L2e,
  Select__option: K2e,
  "Select__option--selected": "_Select__option--selected_pj04c_13",
  Select__optionText: Y2e,
  "Select__option--disabled": "_Select__option--disabled_pj04c_20",
  Select__optionContent: U2e
};
function BV({
  value: e,
  options: t,
  isClearable: i = !1,
  onChange: r,
  isMulti: n = !1,
  isDisabled: o = !1,
  className: s
}) {
  const a = we(() => Oc(e, n), [e, n]), l = ye(
    (m) => {
      const g = Oc(m, n);
      r && r(I0(g, t, n));
    },
    [t, n, r]
  ), c = we(() => I0(a, t, n), [a, t, n]), u = ye(
    (m) => {
      const g = Array.isArray(c) ? c.some((h) => h.value === m.value) : (c == null ? void 0 : c.value) === m.value;
      return o || m.disabled ? void 0 : (h) => {
        if (h.preventDefault(), h.stopPropagation(), n) {
          let A = a ? [...a] : [];
          if (g) {
            const y = A.findIndex((E) => E === m.value);
            y !== -1 && A.splice(y, 1);
          } else
            A = [...A, m.value];
          l(A);
        } else
          l(g && i ? void 0 : m.value);
      };
    },
    [i, o, n, a, c, l]
  );
  return /* @__PURE__ */ f("div", { className: me(Ku.Select, s), children: t.map((m, g) => {
    const h = Array.isArray(c) ? c.some((A) => A.value === m.value) : (c == null ? void 0 : c.value) === m.value;
    return /* @__PURE__ */ f(
      "div",
      {
        className: me(
          Ku.Select__option,
          h && Ku["Select__option--selected"],
          (o || m.disabled) && Ku["Select__option--disabled"]
        ),
        onClick: u(m),
        children: /* @__PURE__ */ V("span", { className: Ku.Select__optionContent, children: [
          m.icon ? m.icon : null,
          /* @__PURE__ */ f("span", { className: me(Ku.Select__optionText), children: m.label })
        ] })
      },
      g
    );
  }) });
}
function JBe(i) {
  var r = i, {
    onChange: e
  } = r, t = Fe(r, [
    "onChange"
  ]);
  return /* @__PURE__ */ f(
    BV,
    q({
      isMulti: !1,
      onChange: (n) => {
        e && e(n);
      }
    }, t)
  );
}
function PBe(i) {
  var r = i, {
    onChange: e
  } = r, t = Fe(r, [
    "onChange"
  ]);
  return /* @__PURE__ */ f(
    BV,
    q({
      isMulti: !0,
      onChange: (n) => {
        e && e(n);
      }
    }, t)
  );
}
var DV = { exports: {} };
function G2e(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var nv = { exports: {} };
const Q2e = {}, W2e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Q2e
}, Symbol.toStringTag, { value: "Module" })), Z2e = /* @__PURE__ */ NN(W2e);
var AM;
function zt() {
  return AM || (AM = 1, function(e, t) {
    (function(i, r) {
      e.exports = r();
    })(yt, function() {
      var i = i || function(r, n) {
        var o;
        if (typeof window != "undefined" && window.crypto && (o = window.crypto), typeof self != "undefined" && self.crypto && (o = self.crypto), typeof globalThis != "undefined" && globalThis.crypto && (o = globalThis.crypto), !o && typeof window != "undefined" && window.msCrypto && (o = window.msCrypto), !o && typeof yt != "undefined" && yt.crypto && (o = yt.crypto), !o && typeof G2e == "function")
          try {
            o = Z2e;
          } catch (C) {
          }
        var s = function() {
          if (o) {
            if (typeof o.getRandomValues == "function")
              try {
                return o.getRandomValues(new Uint32Array(1))[0];
              } catch (C) {
              }
            if (typeof o.randomBytes == "function")
              try {
                return o.randomBytes(4).readInt32LE();
              } catch (C) {
              }
          }
          throw new Error("Native crypto module could not be used to get secure random number.");
        }, a = Object.create || function() {
          function C() {
          }
          return function(x) {
            var S;
            return C.prototype = x, S = new C(), C.prototype = null, S;
          };
        }(), l = {}, c = l.lib = {}, u = c.Base = function() {
          return {
            /**
             * Creates a new object that inherits from this object.
             *
             * @param {Object} overrides Properties to copy into the new object.
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         field: 'value',
             *
             *         method: function () {
             *         }
             *     });
             */
            extend: function(C) {
              var x = a(this);
              return C && x.mixIn(C), (!x.hasOwnProperty("init") || this.init === x.init) && (x.init = function() {
                x.$super.init.apply(this, arguments);
              }), x.init.prototype = x, x.$super = this, x;
            },
            /**
             * Extends this object and runs the init method.
             * Arguments to create() will be passed to init().
             *
             * @return {Object} The new object.
             *
             * @static
             *
             * @example
             *
             *     var instance = MyType.create();
             */
            create: function() {
              var C = this.extend();
              return C.init.apply(C, arguments), C;
            },
            /**
             * Initializes a newly created object.
             * Override this method to add some logic when your objects are created.
             *
             * @example
             *
             *     var MyType = CryptoJS.lib.Base.extend({
             *         init: function () {
             *             // ...
             *         }
             *     });
             */
            init: function() {
            },
            /**
             * Copies properties into this object.
             *
             * @param {Object} properties The properties to mix in.
             *
             * @example
             *
             *     MyType.mixIn({
             *         field: 'value'
             *     });
             */
            mixIn: function(C) {
              for (var x in C)
                C.hasOwnProperty(x) && (this[x] = C[x]);
              C.hasOwnProperty("toString") && (this.toString = C.toString);
            },
            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = instance.clone();
             */
            clone: function() {
              return this.init.prototype.extend(this);
            }
          };
        }(), m = c.WordArray = u.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of 32-bit words.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.create();
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
           *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
           */
          init: function(C, x) {
            C = this.words = C || [], x != n ? this.sigBytes = x : this.sigBytes = C.length * 4;
          },
          /**
           * Converts this word array to a string.
           *
           * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
           *
           * @return {string} The stringified word array.
           *
           * @example
           *
           *     var string = wordArray + '';
           *     var string = wordArray.toString();
           *     var string = wordArray.toString(CryptoJS.enc.Utf8);
           */
          toString: function(C) {
            return (C || h).stringify(this);
          },
          /**
           * Concatenates a word array to this word array.
           *
           * @param {WordArray} wordArray The word array to append.
           *
           * @return {WordArray} This word array.
           *
           * @example
           *
           *     wordArray1.concat(wordArray2);
           */
          concat: function(C) {
            var x = this.words, S = C.words, R = this.sigBytes, w = C.sigBytes;
            if (this.clamp(), R % 4)
              for (var T = 0; T < w; T++) {
                var N = S[T >>> 2] >>> 24 - T % 4 * 8 & 255;
                x[R + T >>> 2] |= N << 24 - (R + T) % 4 * 8;
              }
            else
              for (var D = 0; D < w; D += 4)
                x[R + D >>> 2] = S[D >>> 2];
            return this.sigBytes += w, this;
          },
          /**
           * Removes insignificant bits.
           *
           * @example
           *
           *     wordArray.clamp();
           */
          clamp: function() {
            var C = this.words, x = this.sigBytes;
            C[x >>> 2] &= 4294967295 << 32 - x % 4 * 8, C.length = r.ceil(x / 4);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {WordArray} The clone.
           *
           * @example
           *
           *     var clone = wordArray.clone();
           */
          clone: function() {
            var C = u.clone.call(this);
            return C.words = this.words.slice(0), C;
          },
          /**
           * Creates a word array filled with random bytes.
           *
           * @param {number} nBytes The number of random bytes to generate.
           *
           * @return {WordArray} The random word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.lib.WordArray.random(16);
           */
          random: function(C) {
            for (var x = [], S = 0; S < C; S += 4)
              x.push(s());
            return new m.init(x, C);
          }
        }), g = l.enc = {}, h = g.Hex = {
          /**
           * Converts a word array to a hex string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The hex string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
           */
          stringify: function(C) {
            for (var x = C.words, S = C.sigBytes, R = [], w = 0; w < S; w++) {
              var T = x[w >>> 2] >>> 24 - w % 4 * 8 & 255;
              R.push((T >>> 4).toString(16)), R.push((T & 15).toString(16));
            }
            return R.join("");
          },
          /**
           * Converts a hex string to a word array.
           *
           * @param {string} hexStr The hex string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
           */
          parse: function(C) {
            for (var x = C.length, S = [], R = 0; R < x; R += 2)
              S[R >>> 3] |= parseInt(C.substr(R, 2), 16) << 24 - R % 8 * 4;
            return new m.init(S, x / 2);
          }
        }, A = g.Latin1 = {
          /**
           * Converts a word array to a Latin1 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Latin1 string.
           *
           * @static
           *
           * @example
           *
           *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
           */
          stringify: function(C) {
            for (var x = C.words, S = C.sigBytes, R = [], w = 0; w < S; w++) {
              var T = x[w >>> 2] >>> 24 - w % 4 * 8 & 255;
              R.push(String.fromCharCode(T));
            }
            return R.join("");
          },
          /**
           * Converts a Latin1 string to a word array.
           *
           * @param {string} latin1Str The Latin1 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
           */
          parse: function(C) {
            for (var x = C.length, S = [], R = 0; R < x; R++)
              S[R >>> 2] |= (C.charCodeAt(R) & 255) << 24 - R % 4 * 8;
            return new m.init(S, x);
          }
        }, y = g.Utf8 = {
          /**
           * Converts a word array to a UTF-8 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-8 string.
           *
           * @static
           *
           * @example
           *
           *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
           */
          stringify: function(C) {
            try {
              return decodeURIComponent(escape(A.stringify(C)));
            } catch (x) {
              throw new Error("Malformed UTF-8 data");
            }
          },
          /**
           * Converts a UTF-8 string to a word array.
           *
           * @param {string} utf8Str The UTF-8 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
           */
          parse: function(C) {
            return A.parse(unescape(encodeURIComponent(C)));
          }
        }, E = c.BufferedBlockAlgorithm = u.extend({
          /**
           * Resets this block algorithm's data buffer to its initial state.
           *
           * @example
           *
           *     bufferedBlockAlgorithm.reset();
           */
          reset: function() {
            this._data = new m.init(), this._nDataBytes = 0;
          },
          /**
           * Adds new data to this block algorithm's buffer.
           *
           * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
           *
           * @example
           *
           *     bufferedBlockAlgorithm._append('data');
           *     bufferedBlockAlgorithm._append(wordArray);
           */
          _append: function(C) {
            typeof C == "string" && (C = y.parse(C)), this._data.concat(C), this._nDataBytes += C.sigBytes;
          },
          /**
           * Processes available data blocks.
           *
           * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
           *
           * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
           *
           * @return {WordArray} The processed data.
           *
           * @example
           *
           *     var processedData = bufferedBlockAlgorithm._process();
           *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
           */
          _process: function(C) {
            var x, S = this._data, R = S.words, w = S.sigBytes, T = this.blockSize, N = T * 4, D = w / N;
            C ? D = r.ceil(D) : D = r.max((D | 0) - this._minBufferSize, 0);
            var O = D * T, F = r.min(O * 4, w);
            if (O) {
              for (var Y = 0; Y < O; Y += T)
                this._doProcessBlock(R, Y);
              x = R.splice(0, O), S.sigBytes -= F;
            }
            return new m.init(x, F);
          },
          /**
           * Creates a copy of this object.
           *
           * @return {Object} The clone.
           *
           * @example
           *
           *     var clone = bufferedBlockAlgorithm.clone();
           */
          clone: function() {
            var C = u.clone.call(this);
            return C._data = this._data.clone(), C;
          },
          _minBufferSize: 0
        });
        c.Hasher = E.extend({
          /**
           * Configuration options.
           */
          cfg: u.extend(),
          /**
           * Initializes a newly created hasher.
           *
           * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
           *
           * @example
           *
           *     var hasher = CryptoJS.algo.SHA256.create();
           */
          init: function(C) {
            this.cfg = this.cfg.extend(C), this.reset();
          },
          /**
           * Resets this hasher to its initial state.
           *
           * @example
           *
           *     hasher.reset();
           */
          reset: function() {
            E.reset.call(this), this._doReset();
          },
          /**
           * Updates this hasher with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {Hasher} This hasher.
           *
           * @example
           *
           *     hasher.update('message');
           *     hasher.update(wordArray);
           */
          update: function(C) {
            return this._append(C), this._process(), this;
          },
          /**
           * Finalizes the hash computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The hash.
           *
           * @example
           *
           *     var hash = hasher.finalize();
           *     var hash = hasher.finalize('message');
           *     var hash = hasher.finalize(wordArray);
           */
          finalize: function(C) {
            C && this._append(C);
            var x = this._doFinalize();
            return x;
          },
          blockSize: 16,
          /**
           * Creates a shortcut function to a hasher's object interface.
           *
           * @param {Hasher} hasher The hasher to create a helper for.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
           */
          _createHelper: function(C) {
            return function(x, S) {
              return new C.init(S).finalize(x);
            };
          },
          /**
           * Creates a shortcut function to the HMAC's object interface.
           *
           * @param {Hasher} hasher The hasher to use in this HMAC helper.
           *
           * @return {Function} The shortcut function.
           *
           * @static
           *
           * @example
           *
           *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
           */
          _createHmacHelper: function(C) {
            return function(x, S) {
              return new v.HMAC.init(C, S).finalize(x);
            };
          }
        });
        var v = l.algo = {};
        return l;
      }(Math);
      return i;
    });
  }(nv)), nv.exports;
}
var ov = { exports: {} }, yM;
function Hf() {
  return yM || (yM = 1, function(e, t) {
    (function(i, r) {
      e.exports = r(zt());
    })(yt, function(i) {
      return function(r) {
        var n = i, o = n.lib, s = o.Base, a = o.WordArray, l = n.x64 = {};
        l.Word = s.extend({
          /**
           * Initializes a newly created 64-bit word.
           *
           * @param {number} high The high 32 bits.
           * @param {number} low The low 32 bits.
           *
           * @example
           *
           *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
           */
          init: function(c, u) {
            this.high = c, this.low = u;
          }
          /**
           * Bitwise NOTs this word.
           *
           * @return {X64Word} A new x64-Word object after negating.
           *
           * @example
           *
           *     var negated = x64Word.not();
           */
          // not: function () {
          // var high = ~this.high;
          // var low = ~this.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise ANDs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to AND with this word.
           *
           * @return {X64Word} A new x64-Word object after ANDing.
           *
           * @example
           *
           *     var anded = x64Word.and(anotherX64Word);
           */
          // and: function (word) {
          // var high = this.high & word.high;
          // var low = this.low & word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise ORs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to OR with this word.
           *
           * @return {X64Word} A new x64-Word object after ORing.
           *
           * @example
           *
           *     var ored = x64Word.or(anotherX64Word);
           */
          // or: function (word) {
          // var high = this.high | word.high;
          // var low = this.low | word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Bitwise XORs this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to XOR with this word.
           *
           * @return {X64Word} A new x64-Word object after XORing.
           *
           * @example
           *
           *     var xored = x64Word.xor(anotherX64Word);
           */
          // xor: function (word) {
          // var high = this.high ^ word.high;
          // var low = this.low ^ word.low;
          // return X64Word.create(high, low);
          // },
          /**
           * Shifts this word n bits to the left.
           *
           * @param {number} n The number of bits to shift.
           *
           * @return {X64Word} A new x64-Word object after shifting.
           *
           * @example
           *
           *     var shifted = x64Word.shiftL(25);
           */
          // shiftL: function (n) {
          // if (n < 32) {
          // var high = (this.high << n) | (this.low >>> (32 - n));
          // var low = this.low << n;
          // } else {
          // var high = this.low << (n - 32);
          // var low = 0;
          // }
          // return X64Word.create(high, low);
          // },
          /**
           * Shifts this word n bits to the right.
           *
           * @param {number} n The number of bits to shift.
           *
           * @return {X64Word} A new x64-Word object after shifting.
           *
           * @example
           *
           *     var shifted = x64Word.shiftR(7);
           */
          // shiftR: function (n) {
          // if (n < 32) {
          // var low = (this.low >>> n) | (this.high << (32 - n));
          // var high = this.high >>> n;
          // } else {
          // var low = this.high >>> (n - 32);
          // var high = 0;
          // }
          // return X64Word.create(high, low);
          // },
          /**
           * Rotates this word n bits to the left.
           *
           * @param {number} n The number of bits to rotate.
           *
           * @return {X64Word} A new x64-Word object after rotating.
           *
           * @example
           *
           *     var rotated = x64Word.rotL(25);
           */
          // rotL: function (n) {
          // return this.shiftL(n).or(this.shiftR(64 - n));
          // },
          /**
           * Rotates this word n bits to the right.
           *
           * @param {number} n The number of bits to rotate.
           *
           * @return {X64Word} A new x64-Word object after rotating.
           *
           * @example
           *
           *     var rotated = x64Word.rotR(7);
           */
          // rotR: function (n) {
          // return this.shiftR(n).or(this.shiftL(64 - n));
          // },
          /**
           * Adds this word with the passed word.
           *
           * @param {X64Word} word The x64-Word to add with this word.
           *
           * @return {X64Word} A new x64-Word object after adding.
           *
           * @example
           *
           *     var added = x64Word.add(anotherX64Word);
           */
          // add: function (word) {
          // var low = (this.low + word.low) | 0;
          // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
          // var high = (this.high + word.high + carry) | 0;
          // return X64Word.create(high, low);
          // }
        }), l.WordArray = s.extend({
          /**
           * Initializes a newly created word array.
           *
           * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
           * @param {number} sigBytes (Optional) The number of significant bytes in the words.
           *
           * @example
           *
           *     var wordArray = CryptoJS.x64.WordArray.create();
           *
           *     var wordArray = CryptoJS.x64.WordArray.create([
           *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
           *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
           *     ]);
           *
           *     var wordArray = CryptoJS.x64.WordArray.create([
           *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
           *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
           *     ], 10);
           */
          init: function(c, u) {
            c = this.words = c || [], u != r ? this.sigBytes = u : this.sigBytes = c.length * 8;
          },
          /**
           * Converts this 64-bit word array to a 32-bit word array.
           *
           * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
           *
           * @example
           *
           *     var x32WordArray = x64WordArray.toX32();
           */
          toX32: function() {
            for (var c = this.words, u = c.length, m = [], g = 0; g < u; g++) {
              var h = c[g];
              m.push(h.high), m.push(h.low);
            }
            return a.create(m, this.sigBytes);
          },
          /**
           * Creates a copy of this word array.
           *
           * @return {X64WordArray} The clone.
           *
           * @example
           *
           *     var clone = x64WordArray.clone();
           */
          clone: function() {
            for (var c = s.clone.call(this), u = c.words = this.words.slice(0), m = u.length, g = 0; g < m; g++)
              u[g] = u[g].clone();
            return c;
          }
        });
      }(), i;
    });
  }(ov)), ov.exports;
}
var sv = { exports: {} }, EM;
function J2e() {
  return EM || (EM = 1, function(e, t) {
    (function(i, r) {
      e.exports = r(zt());
    })(yt, function(i) {
      return function() {
        if (typeof ArrayBuffer == "function") {
          var r = i, n = r.lib, o = n.WordArray, s = o.init, a = o.init = function(l) {
            if (l instanceof ArrayBuffer && (l = new Uint8Array(l)), (l instanceof Int8Array || typeof Uint8ClampedArray != "undefined" && l instanceof Uint8ClampedArray || l instanceof Int16Array || l instanceof Uint16Array || l instanceof Int32Array || l instanceof Uint32Array || l instanceof Float32Array || l instanceof Float64Array) && (l = new Uint8Array(l.buffer, l.byteOffset, l.byteLength)), l instanceof Uint8Array) {
              for (var c = l.byteLength, u = [], m = 0; m < c; m++)
                u[m >>> 2] |= l[m] << 24 - m % 4 * 8;
              s.call(this, u, c);
            } else
              s.apply(this, arguments);
          };
          a.prototype = o;
        }
      }(), i.lib.WordArray;
    });
  }(sv)), sv.exports;
}
var av = { exports: {} }, vM;
function P2e() {
  return vM || (vM = 1, function(e, t) {
    (function(i, r) {
      e.exports = r(zt());
    })(yt, function(i) {
      return function() {
        var r = i, n = r.lib, o = n.WordArray, s = r.enc;
        s.Utf16 = s.Utf16BE = {
          /**
           * Converts a word array to a UTF-16 BE string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-16 BE string.
           *
           * @static
           *
           * @example
           *
           *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
           */
          stringify: function(l) {
            for (var c = l.words, u = l.sigBytes, m = [], g = 0; g < u; g += 2) {
              var h = c[g >>> 2] >>> 16 - g % 4 * 8 & 65535;
              m.push(String.fromCharCode(h));
            }
            return m.join("");
          },
          /**
           * Converts a UTF-16 BE string to a word array.
           *
           * @param {string} utf16Str The UTF-16 BE string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
           */
          parse: function(l) {
            for (var c = l.length, u = [], m = 0; m < c; m++)
              u[m >>> 1] |= l.charCodeAt(m) << 16 - m % 2 * 16;
            return o.create(u, c * 2);
          }
        }, s.Utf16LE = {
          /**
           * Converts a word array to a UTF-16 LE string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The UTF-16 LE string.
           *
           * @static
           *
           * @example
           *
           *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
           */
          stringify: function(l) {
            for (var c = l.words, u = l.sigBytes, m = [], g = 0; g < u; g += 2) {
              var h = a(c[g >>> 2] >>> 16 - g % 4 * 8 & 65535);
              m.push(String.fromCharCode(h));
            }
            return m.join("");
          },
          /**
           * Converts a UTF-16 LE string to a word array.
           *
           * @param {string} utf16Str The UTF-16 LE string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
           */
          parse: function(l) {
            for (var c = l.length, u = [], m = 0; m < c; m++)
              u[m >>> 1] |= a(l.charCodeAt(m) << 16 - m % 2 * 16);
            return o.create(u, c * 2);
          }
        };
        function a(l) {
          return l << 8 & 4278255360 | l >>> 8 & 16711935;
        }
      }(), i.enc.Utf16;
    });
  }(av)), av.exports;
}
var lv = { exports: {} }, bM;
function uu() {
  return bM || (bM = 1, function(e, t) {
    (function(i, r) {
      e.exports = r(zt());
    })(yt, function(i) {
      return function() {
        var r = i, n = r.lib, o = n.WordArray, s = r.enc;
        s.Base64 = {
          /**
           * Converts a word array to a Base64 string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @return {string} The Base64 string.
           *
           * @static
           *
           * @example
           *
           *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
           */
          stringify: function(l) {
            var c = l.words, u = l.sigBytes, m = this._map;
            l.clamp();
            for (var g = [], h = 0; h < u; h += 3)
              for (var A = c[h >>> 2] >>> 24 - h % 4 * 8 & 255, y = c[h + 1 >>> 2] >>> 24 - (h + 1) % 4 * 8 & 255, E = c[h + 2 >>> 2] >>> 24 - (h + 2) % 4 * 8 & 255, v = A << 16 | y << 8 | E, C = 0; C < 4 && h + C * 0.75 < u; C++)
                g.push(m.charAt(v >>> 6 * (3 - C) & 63));
            var x = m.charAt(64);
            if (x)
              for (; g.length % 4; )
                g.push(x);
            return g.join("");
          },
          /**
           * Converts a Base64 string to a word array.
           *
           * @param {string} base64Str The Base64 string.
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
           */
          parse: function(l) {
            var c = l.length, u = this._map, m = this._reverseMap;
            if (!m) {
              m = this._reverseMap = [];
              for (var g = 0; g < u.length; g++)
                m[u.charCodeAt(g)] = g;
            }
            var h = u.charAt(64);
            if (h) {
              var A = l.indexOf(h);
              A !== -1 && (c = A);
            }
            return a(l, c, m);
          },
          _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
        };
        function a(l, c, u) {
          for (var m = [], g = 0, h = 0; h < c; h++)
            if (h % 4) {
              var A = u[l.charCodeAt(h - 1)] << h % 4 * 2, y = u[l.charCodeAt(h)] >>> 6 - h % 4 * 2, E = A | y;
              m[g >>> 2] |= E << 24 - g % 4 * 8, g++;
            }
          return o.create(m, g);
        }
      }(), i.enc.Base64;
    });
  }(lv)), lv.exports;
}
var cv = { exports: {} }, CM;
function z2e() {
  return CM || (CM = 1, function(e, t) {
    (function(i, r) {
      e.exports = r(zt());
    })(yt, function(i) {
      return function() {
        var r = i, n = r.lib, o = n.WordArray, s = r.enc;
        s.Base64url = {
          /**
           * Converts a word array to a Base64url string.
           *
           * @param {WordArray} wordArray The word array.
           *
           * @param {boolean} urlSafe Whether to use url safe
           *
           * @return {string} The Base64url string.
           *
           * @static
           *
           * @example
           *
           *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
           */
          stringify: function(l, c) {
            c === void 0 && (c = !0);
            var u = l.words, m = l.sigBytes, g = c ? this._safe_map : this._map;
            l.clamp();
            for (var h = [], A = 0; A < m; A += 3)
              for (var y = u[A >>> 2] >>> 24 - A % 4 * 8 & 255, E = u[A + 1 >>> 2] >>> 24 - (A + 1) % 4 * 8 & 255, v = u[A + 2 >>> 2] >>> 24 - (A + 2) % 4 * 8 & 255, C = y << 16 | E << 8 | v, x = 0; x < 4 && A + x * 0.75 < m; x++)
                h.push(g.charAt(C >>> 6 * (3 - x) & 63));
            var S = g.charAt(64);
            if (S)
              for (; h.length % 4; )
                h.push(S);
            return h.join("");
          },
          /**
           * Converts a Base64url string to a word array.
           *
           * @param {string} base64Str The Base64url string.
           *
           * @param {boolean} urlSafe Whether to use url safe
           *
           * @return {WordArray} The word array.
           *
           * @static
           *
           * @example
           *
           *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
           */
          parse: function(l, c) {
            c === void 0 && (c = !0);
            var u = l.length, m = c ? this._safe_map : this._map, g = this._reverseMap;
            if (!g) {
              g = this._reverseMap = [];
              for (var h = 0; h < m.length; h++)
                g[m.charCodeAt(h)] = h;
            }
            var A = m.charAt(64);
            if (A) {
              var y = l.indexOf(A);
              y !== -1 && (u = y);
            }
            return a(l, u, g);
          },
          _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
          _safe_map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"
        };
        function a(l, c, u) {
          for (var m = [], g = 0, h = 0; h < c; h++)
            if (h % 4) {
              var A = u[l.charCodeAt(h - 1)] << h % 4 * 2, y = u[l.charCodeAt(h)] >>> 6 - h % 4 * 2, E = A | y;
              m[g >>> 2] |= E << 24 - g % 4 * 8, g++;
            }
          return o.create(m, g);
        }
      }(), i.enc.Base64url;
    });
  }(cv)), cv.exports;
}
var uv = { exports: {} }, xM;
function du() {
  return xM || (xM = 1, function(e, t) {
    (function(i, r) {
      e.exports = r(zt());
    })(yt, function(i) {
      return function(r) {
        var n = i, o = n.lib, s = o.WordArray, a = o.Hasher, l = n.algo, c = [];
        (function() {
          for (var y = 0; y < 64; y++)
            c[y] = r.abs(r.sin(y + 1)) * 4294967296 | 0;
        })();
        var u = l.MD5 = a.extend({
          _doReset: function() {
            this._hash = new s.init([
              1732584193,
              4023233417,
              2562383102,
              271733878
            ]);
          },
          _doProcessBlock: function(y, E) {
            for (var v = 0; v < 16; v++) {
              var C = E + v, x = y[C];
              y[C] = (x << 8 | x >>> 24) & 16711935 | (x << 24 | x >>> 8) & 4278255360;
            }
            var S = this._hash.words, R = y[E + 0], w = y[E + 1], T = y[E + 2], N = y[E + 3], D = y[E + 4], O = y[E + 5], F = y[E + 6], Y = y[E + 7], P = y[E + 8], z = y[E + 9], W = y[E + 10], H = y[E + 11], Q = y[E + 12], $ = y[E + 13], le = y[E + 14], he = y[E + 15], oe = S[0], ue = S[1], Ae = S[2], de = S[3];
            oe = m(oe, ue, Ae, de, R, 7, c[0]), de = m(de, oe, ue, Ae, w, 12, c[1]), Ae = m(Ae, de, oe, ue, T, 17, c[2]), ue = m(ue, Ae, de, oe, N, 22, c[3]), oe = m(oe, ue, Ae, de, D, 7, c[4]), de = m(de, oe, ue, Ae, O, 12, c[5]), Ae = m(Ae, de, oe, ue, F, 17, c[6]), ue = m(ue, Ae, de, oe, Y, 22, c[7]), oe = m(oe, ue, Ae, de, P, 7, c[8]), de = m(de, oe, ue, Ae, z, 12, c[9]), Ae = m(Ae, de, oe, ue, W, 17, c[10]), ue = m(ue, Ae, de, oe, H, 22, c[11]), oe = m(oe, ue, Ae, de, Q, 7, c[12]), de = m(de, oe, ue, Ae, $, 12, c[13]), Ae = m(Ae, de, oe, ue, le, 17, c[14]), ue = m(ue, Ae, de, oe, he, 22, c[15]), oe = g(oe, ue, Ae, de, w, 5, c[16]), de = g(de, oe, ue, Ae, F, 9, c[17]), Ae = g(Ae, de, oe, ue, H, 14, c[18]), ue = g(ue, Ae, de, oe, R, 20, c[19]), oe = g(oe, ue, Ae, de, O, 5, c[20]), de = g(de, oe, ue, Ae, W, 9, c[21]), Ae = g(Ae, de, oe, ue, he, 14, c[22]), ue = g(ue, Ae, de, oe, D, 20, c[23]), oe = g(oe, ue, Ae, de, z, 5, c[24]), de = g(de, oe, ue, Ae, le, 9, c[25]), Ae = g(Ae, de, oe, ue, N, 14, c[26]), ue = g(ue, Ae, de, oe, P, 20, c[27]), oe = g(oe, ue, Ae, de, $, 5, c[28]), de = g(de, oe, ue, Ae, T, 9, c[29]), Ae = g(Ae, de, oe, ue, Y, 14, c[30]), ue = g(ue, Ae, de, oe, Q, 20, c[31]), oe = h(oe, ue, Ae, de, O, 4, c[32]), de = h(de, oe, ue, Ae, P, 11, c[33]), Ae = h(Ae, de, oe, ue, H, 16, c[34]), ue = h(ue, Ae, de, oe, le, 23, c[35]), oe = h(oe, ue, Ae, de, w, 4, c[36]), de = h(de, oe, ue, Ae, D, 11, c[37]), Ae = h(Ae, de, oe, ue, Y, 16, c[38]), ue = h(ue, Ae, de, oe, W, 23, c[39]), oe = h(oe, ue, Ae, de, $, 4, c[40]), de = h(de, oe, ue, Ae, R, 11, c[41]), Ae = h(Ae, de, oe, ue, N, 16, c[42]), ue = h(ue, Ae, de, oe, F, 23, c[43]), oe = h(oe, ue, Ae, de, z, 4, c[44]), de = h(de, oe, ue, Ae, Q, 11, c[45]), Ae = h(Ae, de, oe, ue, he, 16, c[46]), ue = h(ue, Ae, de, oe, T, 23, c[47]), oe = A(oe, ue, Ae, de, R, 6, c[48]), de = A(de, oe, ue, Ae, Y, 10, c[49]), Ae = A(Ae, de, oe, ue, le, 15, c[50]), ue = A(ue, Ae, de, oe, O, 21, c[51]), oe = A(oe, ue, Ae, de, Q, 6, c[52]), de = A(de, oe, ue, Ae, N, 10, c[53]), Ae = A(Ae, de, oe, ue, W, 15, c[54]), ue = A(ue, Ae, de, oe, w, 21, c[55]), oe = A(oe, ue, Ae, de, P, 6, c[56]), de = A(de, oe, ue, Ae, he, 10, c[57]), Ae = A(Ae, de, oe, ue, F, 15, c[58]), ue = A(ue, Ae, de, oe, $, 21, c[59]), oe = A(oe, ue, Ae, de, D, 6, c[60]), de = A(de, oe, ue, Ae, H, 10, c[61]), Ae = A(Ae, de, oe, ue, T, 15, c[62]), ue = A(ue, Ae, de, oe, z, 21, c[63]), S[0] = S[0] + oe | 0, S[1] = S[1] + ue | 0, S[2] = S[2] + Ae | 0, S[3] = S[3] + de | 0;
          },
          _doFinalize: function() {
            var y = this._data, E = y.words, v = this._nDataBytes * 8, C = y.sigBytes * 8;
            E[C >>> 5] |= 128 << 24 - C % 32;
            var x = r.floor(v / 4294967296), S = v;
            E[(C + 64 >>> 9 << 4) + 15] = (x << 8 | x >>> 24) & 16711935 | (x << 24 | x >>> 8) & 4278255360, E[(C + 64 >>> 9 << 4) + 14] = (S << 8 | S >>> 24) & 16711935 | (S << 24 | S >>> 8) & 4278255360, y.sigBytes = (E.length + 1) * 4, this._process();
            for (var R = this._hash, w = R.words, T = 0; T < 4; T++) {
              var N = w[T];
              w[T] = (N << 8 | N >>> 24) & 16711935 | (N << 24 | N >>> 8) & 4278255360;
            }
            return R;
          },
          clone: function() {
            var y = a.clone.call(this);
            return y._hash = this._hash.clone(), y;
          }
        });
        function m(y, E, v, C, x, S, R) {
          var w = y + (E & v | ~E & C) + x + R;
          return (w << S | w >>> 32 - S) + E;
        }
        function g(y, E, v, C, x, S, R) {
          var w = y + (E & C | v & ~C) + x + R;
          return (w << S | w >>> 32 - S) + E;
        }
        function h(y, E, v, C, x, S, R) {
          var w = y + (E ^ v ^ C) + x + R;
          return (w << S | w >>> 32 - S) + E;
        }
        function A(y, E, v, C, x, S, R) {
          var w = y + (v ^ (E | ~C)) + x + R;
          return (w << S | w >>> 32 - S) + E;
        }
        n.MD5 = a._createHelper(u), n.HmacMD5 = a._createHmacHelper(u);
      }(Math), i.MD5;
    });
  }(uv)), uv.exports;
}
var dv = { exports: {} }, IM;
function OV() {
  return IM || (IM = 1, function(e, t) {
    (function(i, r) {
      e.exports = r(zt());
    })(yt, function(i) {
      return function() {
        var r = i, n = r.lib, o = n.WordArray, s = n.Hasher, a = r.algo, l = [], c = a.SHA1 = s.extend({
          _doReset: function() {
            this._hash = new o.init([
              1732584193,
              4023233417,
              2562383102,
              271733878,
              3285377520
            ]);
          },
          _doProcessBlock: function(u, m) {
            for (var g = this._hash.words, h = g[0], A = g[1], y = g[2], E = g[3], v = g[4], C = 0; C < 80; C++) {
              if (C < 16)
                l[C] = u[m + C] | 0;
              else {
                var x = l[C - 3] ^ l[C - 8] ^ l[C - 14] ^ l[C - 16];
                l[C] = x << 1 | x >>> 31;
              }
              var S = (h << 5 | h >>> 27) + v + l[C];
              C < 20 ? S += (A & y | ~A & E) + 1518500249 : C < 40 ? S += (A ^ y ^ E) + 1859775393 : C < 60 ? S += (A & y | A & E | y & E) - 1894007588 : S += (A ^ y ^ E) - 899497514, v = E, E = y, y = A << 30 | A >>> 2, A = h, h = S;
            }
            g[0] = g[0] + h | 0, g[1] = g[1] + A | 0, g[2] = g[2] + y | 0, g[3] = g[3] + E | 0, g[4] = g[4] + v | 0;
          },
          _doFinalize: function() {
            var u = this._data, m = u.words, g = this._nDataBytes * 8, h = u.sigBytes * 8;
            return m[h >>> 5] |= 128 << 24 - h % 32, m[(h + 64 >>> 9 << 4) + 14] = Math.floor(g / 4294967296), m[(h + 64 >>> 9 << 4) + 15] = g, u.sigBytes = m.length * 4, this._process(), this._hash;
          },
          clone: function() {
            var u = s.clone.call(this);
            return u._hash = this._hash.clone(), u;
          }
        });
        r.SHA1 = s._createHelper(c), r.HmacSHA1 = s._createHmacHelper(c);
      }(), i.SHA1;
    });
  }(dv)), dv.exports;
}
var mv = { exports: {} }, SM;
function kI() {
  return SM || (SM = 1, function(e, t) {
    (function(i, r) {
      e.exports = r(zt());
    })(yt, function(i) {
      return function(r) {
        var n = i, o = n.lib, s = o.WordArray, a = o.Hasher, l = n.algo, c = [], u = [];
        (function() {
          function h(v) {
            for (var C = r.sqrt(v), x = 2; x <= C; x++)
              if (!(v % x))
                return !1;
            return !0;
          }
          function A(v) {
            return (v - (v | 0)) * 4294967296 | 0;
          }
          for (var y = 2, E = 0; E < 64; )
            h(y) && (E < 8 && (c[E] = A(r.pow(y, 1 / 2))), u[E] = A(r.pow(y, 1 / 3)), E++), y++;
        })();
        var m = [], g = l.SHA256 = a.extend({
          _doReset: function() {
            this._hash = new s.init(c.slice(0));
          },
          _doProcessBlock: function(h, A) {
            for (var y = this._hash.words, E = y[0], v = y[1], C = y[2], x = y[3], S = y[4], R = y[5], w = y[6], T = y[7], N = 0; N < 64; N++) {
              if (N < 16)
                m[N] = h[A + N] | 0;
              else {
                var D = m[N - 15], O = (D << 25 | D >>> 7) ^ (D << 14 | D >>> 18) ^ D >>> 3, F = m[N - 2], Y = (F << 15 | F >>> 17) ^ (F << 13 | F >>> 19) ^ F >>> 10;
                m[N] = O + m[N - 7] + Y + m[N - 16];
              }
              var P = S & R ^ ~S & w, z = E & v ^ E & C ^ v & C, W = (E << 30 | E >>> 2) ^ (E << 19 | E >>> 13) ^ (E << 10 | E >>> 22), H = (S << 26 | S >>> 6) ^ (S << 21 | S >>> 11) ^ (S << 7 | S >>> 25), Q = T + H + P + u[N] + m[N], $ = W + z;
              T = w, w = R, R = S, S = x + Q | 0, x = C, C = v, v = E, E = Q + $ | 0;
            }
            y[0] = y[0] + E | 0, y[1] = y[1] + v | 0, y[2] = y[2] + C | 0, y[3] = y[3] + x | 0, y[4] = y[4] + S | 0, y[5] = y[5] + R | 0, y[6] = y[6] + w | 0, y[7] = y[7] + T | 0;
          },
          _doFinalize: function() {
            var h = this._data, A = h.words, y = this._nDataBytes * 8, E = h.sigBytes * 8;
            return A[E >>> 5] |= 128 << 24 - E % 32, A[(E + 64 >>> 9 << 4) + 14] = r.floor(y / 4294967296), A[(E + 64 >>> 9 << 4) + 15] = y, h.sigBytes = A.length * 4, this._process(), this._hash;
          },
          clone: function() {
            var h = a.clone.call(this);
            return h._hash = this._hash.clone(), h;
          }
        });
        n.SHA256 = a._createHelper(g), n.HmacSHA256 = a._createHmacHelper(g);
      }(Math), i.SHA256;
    });
  }(mv)), mv.exports;
}
var gv = { exports: {} }, RM;
function H2e() {
  return RM || (RM = 1, function(e, t) {
    (function(i, r, n) {
      e.exports = r(zt(), kI());
    })(yt, function(i) {
      return function() {
        var r = i, n = r.lib, o = n.WordArray, s = r.algo, a = s.SHA256, l = s.SHA224 = a.extend({
          _doReset: function() {
            this._hash = new o.init([
              3238371032,
              914150663,
              812702999,
              4144912697,
              4290775857,
              1750603025,
              1694076839,
              3204075428
            ]);
          },
          _doFinalize: function() {
            var c = a._doFinalize.call(this);
            return c.sigBytes -= 4, c;
          }
        });
        r.SHA224 = a._createHelper(l), r.HmacSHA224 = a._createHmacHelper(l);
      }(), i.SHA224;
    });
  }(gv)), gv.exports;
}
var hv = { exports: {} }, kM;
function FV() {
  return kM || (kM = 1, function(e, t) {
    (function(i, r, n) {
      e.exports = r(zt(), Hf());
    })(yt, function(i) {
      return function() {
        var r = i, n = r.lib, o = n.Hasher, s = r.x64, a = s.Word, l = s.WordArray, c = r.algo;
        function u() {
          return a.create.apply(a, arguments);
        }
        var m = [
          u(1116352408, 3609767458),
          u(1899447441, 602891725),
          u(3049323471, 3964484399),
          u(3921009573, 2173295548),
          u(961987163, 4081628472),
          u(1508970993, 3053834265),
          u(2453635748, 2937671579),
          u(2870763221, 3664609560),
          u(3624381080, 2734883394),
          u(310598401, 1164996542),
          u(607225278, 1323610764),
          u(1426881987, 3590304994),
          u(1925078388, 4068182383),
          u(2162078206, 991336113),
          u(2614888103, 633803317),
          u(3248222580, 3479774868),
          u(3835390401, 2666613458),
          u(4022224774, 944711139),
          u(264347078, 2341262773),
          u(604807628, 2007800933),
          u(770255983, 1495990901),
          u(1249150122, 1856431235),
          u(1555081692, 3175218132),
          u(1996064986, 2198950837),
          u(2554220882, 3999719339),
          u(2821834349, 766784016),
          u(2952996808, 2566594879),
          u(3210313671, 3203337956),
          u(3336571891, 1034457026),
          u(3584528711, 2466948901),
          u(113926993, 3758326383),
          u(338241895, 168717936),
          u(666307205, 1188179964),
          u(773529912, 1546045734),
          u(1294757372, 1522805485),
          u(1396182291, 2643833823),
          u(1695183700, 2343527390),
          u(1986661051, 1014477480),
          u(2177026350, 1206759142),
          u(2456956037, 344077627),
          u(2730485921, 1290863460),
          u(2820302411, 3158454273),
          u(3259730800, 3505952657),
          u(3345764771, 106217008),
          u(3516065817, 3606008344),
          u(3600352804, 1432725776),
          u(4094571909, 1467031594),
          u(275423344, 851169720),
          u(430227734, 3100823752),
          u(506948616, 1363258195),
          u(659060556, 3750685593),
          u(883997877, 3785050280),
          u(958139571, 3318307427),
          u(1322822218, 3812723403),
          u(1537002063, 2003034995),
          u(1747873779, 3602036899),
          u(1955562222, 1575990012),
          u(2024104815, 1125592928),
          u(2227730452, 2716904306),
          u(2361852424, 442776044),
          u(2428436474, 593698344),
          u(2756734187, 3733110249),
          u(3204031479, 2999351573),
          u(3329325298, 3815920427),
          u(3391569614, 3928383900),
          u(3515267271, 566280711),
          u(3940187606, 3454069534),
          u(4118630271, 4000239992),
          u(116418474, 1914138554),
          u(174292421, 2731055270),
          u(289380356, 3203993006),
          u(460393269, 320620315),
          u(685471733, 587496836),
          u(852142971, 1086792851),
          u(1017036298, 365543100),
          u(1126000580, 2618297676),
          u(1288033470, 3409855158),
          u(1501505948, 4234509866),
          u(1607167915, 987167468),
          u(1816402316, 1246189591)
        ], g = [];
        (function() {
          for (var A = 0; A < 80; A++)
            g[A] = u();
        })();
        var h = c.SHA512 = o.extend({
          _doReset: function() {
            this._hash = new l.init([
              new a.init(1779033703, 4089235720),
              new a.init(3144134277, 2227873595),
              new a.init(1013904242, 4271175723),
              new a.init(2773480762, 1595750129),
              new a.init(1359893119, 2917565137),
              new a.init(2600822924, 725511199),
              new a.init(528734635, 4215389547),
              new a.init(1541459225, 327033209)
            ]);
          },
          _doProcessBlock: function(A, y) {
            for (var E = this._hash.words, v = E[0], C = E[1], x = E[2], S = E[3], R = E[4], w = E[5], T = E[6], N = E[7], D = v.high, O = v.low, F = C.high, Y = C.low, P = x.high, z = x.low, W = S.high, H = S.low, Q = R.high, $ = R.low, le = w.high, he = w.low, oe = T.high, ue = T.low, Ae = N.high, de = N.low, fe = D, Re = O, qe = F, Oe = Y, Xe = P, Qe = z, Pe = W, et = H, At = Q, Et = $, oi = le, Ai = he, ut = oe, qt = ue, Ht = Ae, ri = de, Ke = 0; Ke < 80; Ke++) {
              var dt, kt, si = g[Ke];
              if (Ke < 16)
                kt = si.high = A[y + Ke * 2] | 0, dt = si.low = A[y + Ke * 2 + 1] | 0;
              else {
                var Dt = g[Ke - 15], yi = Dt.high, ei = Dt.low, nr = (yi >>> 1 | ei << 31) ^ (yi >>> 8 | ei << 24) ^ yi >>> 7, fr = (ei >>> 1 | yi << 31) ^ (ei >>> 8 | yi << 24) ^ (ei >>> 7 | yi << 25), Sr = g[Ke - 2], As = Sr.high, $s = Sr.low, od = (As >>> 19 | $s << 13) ^ (As << 3 | $s >>> 29) ^ As >>> 6, mu = ($s >>> 19 | As << 13) ^ ($s << 3 | As >>> 29) ^ ($s >>> 6 | As << 26), gu = g[Ke - 7], sd = gu.high, ad = gu.low, Jg = g[Ke - 16], uA = Jg.high, Pg = Jg.low;
                dt = fr + ad, kt = nr + sd + (dt >>> 0 < fr >>> 0 ? 1 : 0), dt = dt + mu, kt = kt + od + (dt >>> 0 < mu >>> 0 ? 1 : 0), dt = dt + Pg, kt = kt + uA + (dt >>> 0 < Pg >>> 0 ? 1 : 0), si.high = kt, si.low = dt;
              }
              var zg = At & oi ^ ~At & ut, ld = Et & Ai ^ ~Et & qt, dA = fe & qe ^ fe & Xe ^ qe & Xe, mA = Re & Oe ^ Re & Qe ^ Oe & Qe, gA = (fe >>> 28 | Re << 4) ^ (fe << 30 | Re >>> 2) ^ (fe << 25 | Re >>> 7), Hg = (Re >>> 28 | fe << 4) ^ (Re << 30 | fe >>> 2) ^ (Re << 25 | fe >>> 7), Xg = (At >>> 14 | Et << 18) ^ (At >>> 18 | Et << 14) ^ (At << 23 | Et >>> 9), hA = (Et >>> 14 | At << 18) ^ (Et >>> 18 | At << 14) ^ (Et << 23 | At >>> 9), _g = m[Ke], pA = _g.high, hu = _g.low, ln = ri + hA, Io = Ht + Xg + (ln >>> 0 < ri >>> 0 ? 1 : 0), ln = ln + ld, Io = Io + zg + (ln >>> 0 < ld >>> 0 ? 1 : 0), ln = ln + hu, Io = Io + pA + (ln >>> 0 < hu >>> 0 ? 1 : 0), ln = ln + dt, Io = Io + kt + (ln >>> 0 < dt >>> 0 ? 1 : 0), $g = Hg + mA, fA = gA + dA + ($g >>> 0 < Hg >>> 0 ? 1 : 0);
              Ht = ut, ri = qt, ut = oi, qt = Ai, oi = At, Ai = Et, Et = et + ln | 0, At = Pe + Io + (Et >>> 0 < et >>> 0 ? 1 : 0) | 0, Pe = Xe, et = Qe, Xe = qe, Qe = Oe, qe = fe, Oe = Re, Re = ln + $g | 0, fe = Io + fA + (Re >>> 0 < ln >>> 0 ? 1 : 0) | 0;
            }
            O = v.low = O + Re, v.high = D + fe + (O >>> 0 < Re >>> 0 ? 1 : 0), Y = C.low = Y + Oe, C.high = F + qe + (Y >>> 0 < Oe >>> 0 ? 1 : 0), z = x.low = z + Qe, x.high = P + Xe + (z >>> 0 < Qe >>> 0 ? 1 : 0), H = S.low = H + et, S.high = W + Pe + (H >>> 0 < et >>> 0 ? 1 : 0), $ = R.low = $ + Et, R.high = Q + At + ($ >>> 0 < Et >>> 0 ? 1 : 0), he = w.low = he + Ai, w.high = le + oi + (he >>> 0 < Ai >>> 0 ? 1 : 0), ue = T.low = ue + qt, T.high = oe + ut + (ue >>> 0 < qt >>> 0 ? 1 : 0), de = N.low = de + ri, N.high = Ae + Ht + (de >>> 0 < ri >>> 0 ? 1 : 0);
          },
          _doFinalize: function() {
            var A = this._data, y = A.words, E = this._nDataBytes * 8, v = A.sigBytes * 8;
            y[v >>> 5] |= 128 << 24 - v % 32, y[(v + 128 >>> 10 << 5) + 30] = Math.floor(E / 4294967296), y[(v + 128 >>> 10 << 5) + 31] = E, A.sigBytes = y.length * 4, this._process();
            var C = this._hash.toX32();
            return C;
          },
          clone: function() {
            var A = o.clone.call(this);
            return A._hash = this._hash.clone(), A;
          },
          blockSize: 1024 / 32
        });
        r.SHA512 = o._createHelper(h), r.HmacSHA512 = o._createHmacHelper(h);
      }(), i.SHA512;
    });
  }(hv)), hv.exports;
}
var pv = { exports: {} }, wM;
function X2e() {
  return wM || (wM = 1, function(e, t) {
    (function(i, r, n) {
      e.exports = r(zt(), Hf(), FV());
    })(yt, function(i) {
      return function() {
        var r = i, n = r.x64, o = n.Word, s = n.WordArray, a = r.algo, l = a.SHA512, c = a.SHA384 = l.extend({
          _doReset: function() {
            this._hash = new s.init([
              new o.init(3418070365, 3238371032),
              new o.init(1654270250, 914150663),
              new o.init(2438529370, 812702999),
              new o.init(355462360, 4144912697),
              new o.init(1731405415, 4290775857),
              new o.init(2394180231, 1750603025),
              new o.init(3675008525, 1694076839),
              new o.init(1203062813, 3204075428)
            ]);
          },
          _doFinalize: function() {
            var u = l._doFinalize.call(this);
            return u.sigBytes -= 16, u;
          }
        });
        r.SHA384 = l._createHelper(c), r.HmacSHA384 = l._createHmacHelper(c);
      }(), i.SHA384;
    });
  }(pv)), pv.exports;
}
var fv = { exports: {} }, MM;
function _2e() {
  return MM || (MM = 1, function(e, t) {
    (function(i, r, n) {
      e.exports = r(zt(), Hf());
    })(yt, function(i) {
      return function(r) {
        var n = i, o = n.lib, s = o.WordArray, a = o.Hasher, l = n.x64, c = l.Word, u = n.algo, m = [], g = [], h = [];
        (function() {
          for (var E = 1, v = 0, C = 0; C < 24; C++) {
            m[E + 5 * v] = (C + 1) * (C + 2) / 2 % 64;
            var x = v % 5, S = (2 * E + 3 * v) % 5;
            E = x, v = S;
          }
          for (var E = 0; E < 5; E++)
            for (var v = 0; v < 5; v++)
              g[E + 5 * v] = v + (2 * E + 3 * v) % 5 * 5;
          for (var R = 1, w = 0; w < 24; w++) {
            for (var T = 0, N = 0, D = 0; D < 7; D++) {
              if (R & 1) {
                var O = (1 << D) - 1;
                O < 32 ? N ^= 1 << O : T ^= 1 << O - 32;
              }
              R & 128 ? R = R << 1 ^ 113 : R <<= 1;
            }
            h[w] = c.create(T, N);
          }
        })();
        var A = [];
        (function() {
          for (var E = 0; E < 25; E++)
            A[E] = c.create();
        })();
        var y = u.SHA3 = a.extend({
          /**
           * Configuration options.
           *
           * @property {number} outputLength
           *   The desired number of bits in the output hash.
           *   Only values permitted are: 224, 256, 384, 512.
           *   Default: 512
           */
          cfg: a.cfg.extend({
            outputLength: 512
          }),
          _doReset: function() {
            for (var E = this._state = [], v = 0; v < 25; v++)
              E[v] = new c.init();
            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
          },
          _doProcessBlock: function(E, v) {
            for (var C = this._state, x = this.blockSize / 2, S = 0; S < x; S++) {
              var R = E[v + 2 * S], w = E[v + 2 * S + 1];
              R = (R << 8 | R >>> 24) & 16711935 | (R << 24 | R >>> 8) & 4278255360, w = (w << 8 | w >>> 24) & 16711935 | (w << 24 | w >>> 8) & 4278255360;
              var T = C[S];
              T.high ^= w, T.low ^= R;
            }
            for (var N = 0; N < 24; N++) {
              for (var D = 0; D < 5; D++) {
                for (var O = 0, F = 0, Y = 0; Y < 5; Y++) {
                  var T = C[D + 5 * Y];
                  O ^= T.high, F ^= T.low;
                }
                var P = A[D];
                P.high = O, P.low = F;
              }
              for (var D = 0; D < 5; D++)
                for (var z = A[(D + 4) % 5], W = A[(D + 1) % 5], H = W.high, Q = W.low, O = z.high ^ (H << 1 | Q >>> 31), F = z.low ^ (Q << 1 | H >>> 31), Y = 0; Y < 5; Y++) {
                  var T = C[D + 5 * Y];
                  T.high ^= O, T.low ^= F;
                }
              for (var $ = 1; $ < 25; $++) {
                var O, F, T = C[$], le = T.high, he = T.low, oe = m[$];
                oe < 32 ? (O = le << oe | he >>> 32 - oe, F = he << oe | le >>> 32 - oe) : (O = he << oe - 32 | le >>> 64 - oe, F = le << oe - 32 | he >>> 64 - oe);
                var ue = A[g[$]];
                ue.high = O, ue.low = F;
              }
              var Ae = A[0], de = C[0];
              Ae.high = de.high, Ae.low = de.low;
              for (var D = 0; D < 5; D++)
                for (var Y = 0; Y < 5; Y++) {
                  var $ = D + 5 * Y, T = C[$], fe = A[$], Re = A[(D + 1) % 5 + 5 * Y], qe = A[(D + 2) % 5 + 5 * Y];
                  T.high = fe.high ^ ~Re.high & qe.high, T.low = fe.low ^ ~Re.low & qe.low;
                }
              var T = C[0], Oe = h[N];
              T.high ^= Oe.high, T.low ^= Oe.low;
            }
          },
          _doFinalize: function() {
            var E = this._data, v = E.words;
            this._nDataBytes * 8;
            var C = E.sigBytes * 8, x = this.blockSize * 32;
            v[C >>> 5] |= 1 << 24 - C % 32, v[(r.ceil((C + 1) / x) * x >>> 5) - 1] |= 128, E.sigBytes = v.length * 4, this._process();
            for (var S = this._state, R = this.cfg.outputLength / 8, w = R / 8, T = [], N = 0; N < w; N++) {
              var D = S[N], O = D.high, F = D.low;
              O = (O << 8 | O >>> 24) & 16711935 | (O << 24 | O >>> 8) & 4278255360, F = (F << 8 | F >>> 24) & 16711935 | (F << 24 | F >>> 8) & 4278255360, T.push(F), T.push(O);
            }
            return new s.init(T, R);
          },
          clone: function() {
            for (var E = a.clone.call(this), v = E._state = this._state.slice(0), C = 0; C < 25; C++)
              v[C] = v[C].clone();
            return E;
          }
        });
        n.SHA3 = a._createHelper(y), n.HmacSHA3 = a._createHmacHelper(y);
      }(Math), i.SHA3;
    });
  }(fv)), fv.exports;
}
var Av = { exports: {} }, NM;
function $2e() {
  return NM || (NM = 1, function(e, t) {
    (function(i, r) {
      e.exports = r(zt());
    })(yt, function(i) {
      /** @preserve
      			(c) 2012 by Cédric Mesnil. All rights reserved.
      
      			Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
      
      			    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
      			    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
      
      			THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
      			*/
      return function(r) {
        var n = i, o = n.lib, s = o.WordArray, a = o.Hasher, l = n.algo, c = s.create([
          0,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          7,
          4,
          13,
          1,
          10,
          6,
          15,
          3,
          12,
          0,
          9,
          5,
          2,
          14,
          11,
          8,
          3,
          10,
          14,
          4,
          9,
          15,
          8,
          1,
          2,
          7,
          0,
          6,
          13,
          11,
          5,
          12,
          1,
          9,
          11,
          10,
          0,
          8,
          12,
          4,
          13,
          3,
          7,
          15,
          14,
          5,
          6,
          2,
          4,
          0,
          5,
          9,
          7,
          12,
          2,
          10,
          14,
          1,
          3,
          8,
          11,
          6,
          15,
          13
        ]), u = s.create([
          5,
          14,
          7,
          0,
          9,
          2,
          11,
          4,
          13,
          6,
          15,
          8,
          1,
          10,
          3,
          12,
          6,
          11,
          3,
          7,
          0,
          13,
          5,
          10,
          14,
          15,
          8,
          12,
          4,
          9,
          1,
          2,
          15,
          5,
          1,
          3,
          7,
          14,
          6,
          9,
          11,
          8,
          12,
          2,
          10,
          0,
          4,
          13,
          8,
          6,
          4,
          1,
          3,
          11,
          15,
          0,
          5,
          12,
          2,
          13,
          9,
          7,
          10,
          14,
          12,
          15,
          10,
          4,
          1,
          5,
          8,
          7,
          6,
          2,
          13,
          14,
          0,
          3,
          9,
          11
        ]), m = s.create([
          11,
          14,
          15,
          12,
          5,
          8,
          7,
          9,
          11,
          13,
          14,
          15,
          6,
          7,
          9,
          8,
          7,
          6,
          8,
          13,
          11,
          9,
          7,
          15,
          7,
          12,
          15,
          9,
          11,
          7,
          13,
          12,
          11,
          13,
          6,
          7,
          14,
          9,
          13,
          15,
          14,
          8,
          13,
          6,
          5,
          12,
          7,
          5,
          11,
          12,
          14,
          15,
          14,
          15,
          9,
          8,
          9,
          14,
          5,
          6,
          8,
          6,
          5,
          12,
          9,
          15,
          5,
          11,
          6,
          8,
          13,
          12,
          5,
          12,
          13,
          14,
          11,
          8,
          5,
          6
        ]), g = s.create([
          8,
          9,
          9,
          11,
          13,
          15,
          15,
          5,
          7,
          7,
          8,
          11,
          14,
          14,
          12,
          6,
          9,
          13,
          15,
          7,
          12,
          8,
          9,
          11,
          7,
          7,
          12,
          7,
          6,
          15,
          13,
          11,
          9,
          7,
          15,
          11,
          8,
          6,
          6,
          14,
          12,
          13,
          5,
          14,
          13,
          13,
          7,
          5,
          15,
          5,
          8,
          11,
          14,
          14,
          6,
          14,
          6,
          9,
          12,
          9,
          12,
          5,
          15,
          8,
          8,
          5,
          12,
          9,
          12,
          5,
          14,
          6,
          8,
          13,
          6,
          5,
          15,
          13,
          11,
          11
        ]), h = s.create([0, 1518500249, 1859775393, 2400959708, 2840853838]), A = s.create([1352829926, 1548603684, 1836072691, 2053994217, 0]), y = l.RIPEMD160 = a.extend({
          _doReset: function() {
            this._hash = s.create([1732584193, 4023233417, 2562383102, 271733878, 3285377520]);
          },
          _doProcessBlock: function(w, T) {
            for (var N = 0; N < 16; N++) {
              var D = T + N, O = w[D];
              w[D] = (O << 8 | O >>> 24) & 16711935 | (O << 24 | O >>> 8) & 4278255360;
            }
            var F = this._hash.words, Y = h.words, P = A.words, z = c.words, W = u.words, H = m.words, Q = g.words, $, le, he, oe, ue, Ae, de, fe, Re, qe;
            Ae = $ = F[0], de = le = F[1], fe = he = F[2], Re = oe = F[3], qe = ue = F[4];
            for (var Oe, N = 0; N < 80; N += 1)
              Oe = $ + w[T + z[N]] | 0, N < 16 ? Oe += E(le, he, oe) + Y[0] : N < 32 ? Oe += v(le, he, oe) + Y[1] : N < 48 ? Oe += C(le, he, oe) + Y[2] : N < 64 ? Oe += x(le, he, oe) + Y[3] : Oe += S(le, he, oe) + Y[4], Oe = Oe | 0, Oe = R(Oe, H[N]), Oe = Oe + ue | 0, $ = ue, ue = oe, oe = R(he, 10), he = le, le = Oe, Oe = Ae + w[T + W[N]] | 0, N < 16 ? Oe += S(de, fe, Re) + P[0] : N < 32 ? Oe += x(de, fe, Re) + P[1] : N < 48 ? Oe += C(de, fe, Re) + P[2] : N < 64 ? Oe += v(de, fe, Re) + P[3] : Oe += E(de, fe, Re) + P[4], Oe = Oe | 0, Oe = R(Oe, Q[N]), Oe = Oe + qe | 0, Ae = qe, qe = Re, Re = R(fe, 10), fe = de, de = Oe;
            Oe = F[1] + he + Re | 0, F[1] = F[2] + oe + qe | 0, F[2] = F[3] + ue + Ae | 0, F[3] = F[4] + $ + de | 0, F[4] = F[0] + le + fe | 0, F[0] = Oe;
          },
          _doFinalize: function() {
            var w = this._data, T = w.words, N = this._nDataBytes * 8, D = w.sigBytes * 8;
            T[D >>> 5] |= 128 << 24 - D % 32, T[(D + 64 >>> 9 << 4) + 14] = (N << 8 | N >>> 24) & 16711935 | (N << 24 | N >>> 8) & 4278255360, w.sigBytes = (T.length + 1) * 4, this._process();
            for (var O = this._hash, F = O.words, Y = 0; Y < 5; Y++) {
              var P = F[Y];
              F[Y] = (P << 8 | P >>> 24) & 16711935 | (P << 24 | P >>> 8) & 4278255360;
            }
            return O;
          },
          clone: function() {
            var w = a.clone.call(this);
            return w._hash = this._hash.clone(), w;
          }
        });
        function E(w, T, N) {
          return w ^ T ^ N;
        }
        function v(w, T, N) {
          return w & T | ~w & N;
        }
        function C(w, T, N) {
          return (w | ~T) ^ N;
        }
        function x(w, T, N) {
          return w & N | T & ~N;
        }
        function S(w, T, N) {
          return w ^ (T | ~N);
        }
        function R(w, T) {
          return w << T | w >>> 32 - T;
        }
        n.RIPEMD160 = a._createHelper(y), n.HmacRIPEMD160 = a._createHmacHelper(y);
      }(), i.RIPEMD160;
    });
  }(Av)), Av.exports;
}
var yv = { exports: {} }, TM;
function wI() {
  return TM || (TM = 1, function(e, t) {
    (function(i, r) {
      e.exports = r(zt());
    })(yt, function(i) {
      (function() {
        var r = i, n = r.lib, o = n.Base, s = r.enc, a = s.Utf8, l = r.algo;
        l.HMAC = o.extend({
          /**
           * Initializes a newly created HMAC.
           *
           * @param {Hasher} hasher The hash algorithm to use.
           * @param {WordArray|string} key The secret key.
           *
           * @example
           *
           *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
           */
          init: function(c, u) {
            c = this._hasher = new c.init(), typeof u == "string" && (u = a.parse(u));
            var m = c.blockSize, g = m * 4;
            u.sigBytes > g && (u = c.finalize(u)), u.clamp();
            for (var h = this._oKey = u.clone(), A = this._iKey = u.clone(), y = h.words, E = A.words, v = 0; v < m; v++)
              y[v] ^= 1549556828, E[v] ^= 909522486;
            h.sigBytes = A.sigBytes = g, this.reset();
          },
          /**
           * Resets this HMAC to its initial state.
           *
           * @example
           *
           *     hmacHasher.reset();
           */
          reset: function() {
            var c = this._hasher;
            c.reset(), c.update(this._iKey);
          },
          /**
           * Updates this HMAC with a message.
           *
           * @param {WordArray|string} messageUpdate The message to append.
           *
           * @return {HMAC} This HMAC instance.
           *
           * @example
           *
           *     hmacHasher.update('message');
           *     hmacHasher.update(wordArray);
           */
          update: function(c) {
            return this._hasher.update(c), this;
          },
          /**
           * Finalizes the HMAC computation.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} messageUpdate (Optional) A final message update.
           *
           * @return {WordArray} The HMAC.
           *
           * @example
           *
           *     var hmac = hmacHasher.finalize();
           *     var hmac = hmacHasher.finalize('message');
           *     var hmac = hmacHasher.finalize(wordArray);
           */
          finalize: function(c) {
            var u = this._hasher, m = u.finalize(c);
            u.reset();
            var g = u.finalize(this._oKey.clone().concat(m));
            return g;
          }
        });
      })();
    });
  }(yv)), yv.exports;
}
var Ev = { exports: {} }, BM;
function exe() {
  return BM || (BM = 1, function(e, t) {
    (function(i, r, n) {
      e.exports = r(zt(), kI(), wI());
    })(yt, function(i) {
      return function() {
        var r = i, n = r.lib, o = n.Base, s = n.WordArray, a = r.algo, l = a.SHA256, c = a.HMAC, u = a.PBKDF2 = o.extend({
          /**
           * Configuration options.
           *
           * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
           * @property {Hasher} hasher The hasher to use. Default: SHA256
           * @property {number} iterations The number of iterations to perform. Default: 250000
           */
          cfg: o.extend({
            keySize: 128 / 32,
            hasher: l,
            iterations: 25e4
          }),
          /**
           * Initializes a newly created key derivation function.
           *
           * @param {Object} cfg (Optional) The configuration options to use for the derivation.
           *
           * @example
           *
           *     var kdf = CryptoJS.algo.PBKDF2.create();
           *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
           *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
           */
          init: function(m) {
            this.cfg = this.cfg.extend(m);
          },
          /**
           * Computes the Password-Based Key Derivation Function 2.
           *
           * @param {WordArray|string} password The password.
           * @param {WordArray|string} salt A salt.
           *
           * @return {WordArray} The derived key.
           *
           * @example
           *
           *     var key = kdf.compute(password, salt);
           */
          compute: function(m, g) {
            for (var h = this.cfg, A = c.create(h.hasher, m), y = s.create(), E = s.create([1]), v = y.words, C = E.words, x = h.keySize, S = h.iterations; v.length < x; ) {
              var R = A.update(g).finalize(E);
              A.reset();
              for (var w = R.words, T = w.length, N = R, D = 1; D < S; D++) {
                N = A.finalize(N), A.reset();
                for (var O = N.words, F = 0; F < T; F++)
                  w[F] ^= O[F];
              }
              y.concat(R), C[0]++;
            }
            return y.sigBytes = x * 4, y;
          }
        });
        r.PBKDF2 = function(m, g, h) {
          return u.create(h).compute(m, g);
        };
      }(), i.PBKDF2;
    });
  }(Ev)), Ev.exports;
}
var vv = { exports: {} }, DM;
function Pl() {
  return DM || (DM = 1, function(e, t) {
    (function(i, r, n) {
      e.exports = r(zt(), OV(), wI());
    })(yt, function(i) {
      return function() {
        var r = i, n = r.lib, o = n.Base, s = n.WordArray, a = r.algo, l = a.MD5, c = a.EvpKDF = o.extend({
          /**
           * Configuration options.
           *
           * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
           * @property {Hasher} hasher The hash algorithm to use. Default: MD5
           * @property {number} iterations The number of iterations to perform. Default: 1
           */
          cfg: o.extend({
            keySize: 128 / 32,
            hasher: l,
            iterations: 1
          }),
          /**
           * Initializes a newly created key derivation function.
           *
           * @param {Object} cfg (Optional) The configuration options to use for the derivation.
           *
           * @example
           *
           *     var kdf = CryptoJS.algo.EvpKDF.create();
           *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
           *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
           */
          init: function(u) {
            this.cfg = this.cfg.extend(u);
          },
          /**
           * Derives a key from a password.
           *
           * @param {WordArray|string} password The password.
           * @param {WordArray|string} salt A salt.
           *
           * @return {WordArray} The derived key.
           *
           * @example
           *
           *     var key = kdf.compute(password, salt);
           */
          compute: function(u, m) {
            for (var g, h = this.cfg, A = h.hasher.create(), y = s.create(), E = y.words, v = h.keySize, C = h.iterations; E.length < v; ) {
              g && A.update(g), g = A.update(u).finalize(m), A.reset();
              for (var x = 1; x < C; x++)
                g = A.finalize(g), A.reset();
              y.concat(g);
            }
            return y.sigBytes = v * 4, y;
          }
        });
        r.EvpKDF = function(u, m, g) {
          return c.create(g).compute(u, m);
        };
      }(), i.EvpKDF;
    });
  }(vv)), vv.exports;
}
var bv = { exports: {} }, OM;
function qr() {
  return OM || (OM = 1, function(e, t) {
    (function(i, r, n) {
      e.exports = r(zt(), Pl());
    })(yt, function(i) {
      i.lib.Cipher || function(r) {
        var n = i, o = n.lib, s = o.Base, a = o.WordArray, l = o.BufferedBlockAlgorithm, c = n.enc;
        c.Utf8;
        var u = c.Base64, m = n.algo, g = m.EvpKDF, h = o.Cipher = l.extend({
          /**
           * Configuration options.
           *
           * @property {WordArray} iv The IV to use for this operation.
           */
          cfg: s.extend(),
          /**
           * Creates this cipher in encryption mode.
           *
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {Cipher} A cipher instance.
           *
           * @static
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
           */
          createEncryptor: function(O, F) {
            return this.create(this._ENC_XFORM_MODE, O, F);
          },
          /**
           * Creates this cipher in decryption mode.
           *
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {Cipher} A cipher instance.
           *
           * @static
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
           */
          createDecryptor: function(O, F) {
            return this.create(this._DEC_XFORM_MODE, O, F);
          },
          /**
           * Initializes a newly created cipher.
           *
           * @param {number} xformMode Either the encryption or decryption transormation mode constant.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @example
           *
           *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
           */
          init: function(O, F, Y) {
            this.cfg = this.cfg.extend(Y), this._xformMode = O, this._key = F, this.reset();
          },
          /**
           * Resets this cipher to its initial state.
           *
           * @example
           *
           *     cipher.reset();
           */
          reset: function() {
            l.reset.call(this), this._doReset();
          },
          /**
           * Adds data to be encrypted or decrypted.
           *
           * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
           *
           * @return {WordArray} The data after processing.
           *
           * @example
           *
           *     var encrypted = cipher.process('data');
           *     var encrypted = cipher.process(wordArray);
           */
          process: function(O) {
            return this._append(O), this._process();
          },
          /**
           * Finalizes the encryption or decryption process.
           * Note that the finalize operation is effectively a destructive, read-once operation.
           *
           * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
           *
           * @return {WordArray} The data after final processing.
           *
           * @example
           *
           *     var encrypted = cipher.finalize();
           *     var encrypted = cipher.finalize('data');
           *     var encrypted = cipher.finalize(wordArray);
           */
          finalize: function(O) {
            O && this._append(O);
            var F = this._doFinalize();
            return F;
          },
          keySize: 128 / 32,
          ivSize: 128 / 32,
          _ENC_XFORM_MODE: 1,
          _DEC_XFORM_MODE: 2,
          /**
           * Creates shortcut functions to a cipher's object interface.
           *
           * @param {Cipher} cipher The cipher to create a helper for.
           *
           * @return {Object} An object with encrypt and decrypt shortcut functions.
           *
           * @static
           *
           * @example
           *
           *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
           */
          _createHelper: function() {
            function O(F) {
              return typeof F == "string" ? D : w;
            }
            return function(F) {
              return {
                encrypt: function(Y, P, z) {
                  return O(P).encrypt(F, Y, P, z);
                },
                decrypt: function(Y, P, z) {
                  return O(P).decrypt(F, Y, P, z);
                }
              };
            };
          }()
        });
        o.StreamCipher = h.extend({
          _doFinalize: function() {
            var O = this._process(!0);
            return O;
          },
          blockSize: 1
        });
        var A = n.mode = {}, y = o.BlockCipherMode = s.extend({
          /**
           * Creates this mode for encryption.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @static
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
           */
          createEncryptor: function(O, F) {
            return this.Encryptor.create(O, F);
          },
          /**
           * Creates this mode for decryption.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @static
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
           */
          createDecryptor: function(O, F) {
            return this.Decryptor.create(O, F);
          },
          /**
           * Initializes a newly created mode.
           *
           * @param {Cipher} cipher A block cipher instance.
           * @param {Array} iv The IV words.
           *
           * @example
           *
           *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
           */
          init: function(O, F) {
            this._cipher = O, this._iv = F;
          }
        }), E = A.CBC = function() {
          var O = y.extend();
          O.Encryptor = O.extend({
            /**
             * Processes the data block at offset.
             *
             * @param {Array} words The data words to operate on.
             * @param {number} offset The offset where the block starts.
             *
             * @example
             *
             *     mode.processBlock(data.words, offset);
             */
            processBlock: function(Y, P) {
              var z = this._cipher, W = z.blockSize;
              F.call(this, Y, P, W), z.encryptBlock(Y, P), this._prevBlock = Y.slice(P, P + W);
            }
          }), O.Decryptor = O.extend({
            /**
             * Processes the data block at offset.
             *
             * @param {Array} words The data words to operate on.
             * @param {number} offset The offset where the block starts.
             *
             * @example
             *
             *     mode.processBlock(data.words, offset);
             */
            processBlock: function(Y, P) {
              var z = this._cipher, W = z.blockSize, H = Y.slice(P, P + W);
              z.decryptBlock(Y, P), F.call(this, Y, P, W), this._prevBlock = H;
            }
          });
          function F(Y, P, z) {
            var W, H = this._iv;
            H ? (W = H, this._iv = r) : W = this._prevBlock;
            for (var Q = 0; Q < z; Q++)
              Y[P + Q] ^= W[Q];
          }
          return O;
        }(), v = n.pad = {}, C = v.Pkcs7 = {
          /**
           * Pads data using the algorithm defined in PKCS #5/7.
           *
           * @param {WordArray} data The data to pad.
           * @param {number} blockSize The multiple that the data should be padded to.
           *
           * @static
           *
           * @example
           *
           *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
           */
          pad: function(O, F) {
            for (var Y = F * 4, P = Y - O.sigBytes % Y, z = P << 24 | P << 16 | P << 8 | P, W = [], H = 0; H < P; H += 4)
              W.push(z);
            var Q = a.create(W, P);
            O.concat(Q);
          },
          /**
           * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
           *
           * @param {WordArray} data The data to unpad.
           *
           * @static
           *
           * @example
           *
           *     CryptoJS.pad.Pkcs7.unpad(wordArray);
           */
          unpad: function(O) {
            var F = O.words[O.sigBytes - 1 >>> 2] & 255;
            O.sigBytes -= F;
          }
        };
        o.BlockCipher = h.extend({
          /**
           * Configuration options.
           *
           * @property {Mode} mode The block mode to use. Default: CBC
           * @property {Padding} padding The padding strategy to use. Default: Pkcs7
           */
          cfg: h.cfg.extend({
            mode: E,
            padding: C
          }),
          reset: function() {
            var O;
            h.reset.call(this);
            var F = this.cfg, Y = F.iv, P = F.mode;
            this._xformMode == this._ENC_XFORM_MODE ? O = P.createEncryptor : (O = P.createDecryptor, this._minBufferSize = 1), this._mode && this._mode.__creator == O ? this._mode.init(this, Y && Y.words) : (this._mode = O.call(P, this, Y && Y.words), this._mode.__creator = O);
          },
          _doProcessBlock: function(O, F) {
            this._mode.processBlock(O, F);
          },
          _doFinalize: function() {
            var O, F = this.cfg.padding;
            return this._xformMode == this._ENC_XFORM_MODE ? (F.pad(this._data, this.blockSize), O = this._process(!0)) : (O = this._process(!0), F.unpad(O)), O;
          },
          blockSize: 128 / 32
        });
        var x = o.CipherParams = s.extend({
          /**
           * Initializes a newly created cipher params object.
           *
           * @param {Object} cipherParams An object with any of the possible cipher parameters.
           *
           * @example
           *
           *     var cipherParams = CryptoJS.lib.CipherParams.create({
           *         ciphertext: ciphertextWordArray,
           *         key: keyWordArray,
           *         iv: ivWordArray,
           *         salt: saltWordArray,
           *         algorithm: CryptoJS.algo.AES,
           *         mode: CryptoJS.mode.CBC,
           *         padding: CryptoJS.pad.PKCS7,
           *         blockSize: 4,
           *         formatter: CryptoJS.format.OpenSSL
           *     });
           */
          init: function(O) {
            this.mixIn(O);
          },
          /**
           * Converts this cipher params object to a string.
           *
           * @param {Format} formatter (Optional) The formatting strategy to use.
           *
           * @return {string} The stringified cipher params.
           *
           * @throws Error If neither the formatter nor the default formatter is set.
           *
           * @example
           *
           *     var string = cipherParams + '';
           *     var string = cipherParams.toString();
           *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
           */
          toString: function(O) {
            return (O || this.formatter).stringify(this);
          }
        }), S = n.format = {}, R = S.OpenSSL = {
          /**
           * Converts a cipher params object to an OpenSSL-compatible string.
           *
           * @param {CipherParams} cipherParams The cipher params object.
           *
           * @return {string} The OpenSSL-compatible string.
           *
           * @static
           *
           * @example
           *
           *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
           */
          stringify: function(O) {
            var F, Y = O.ciphertext, P = O.salt;
            return P ? F = a.create([1398893684, 1701076831]).concat(P).concat(Y) : F = Y, F.toString(u);
          },
          /**
           * Converts an OpenSSL-compatible string to a cipher params object.
           *
           * @param {string} openSSLStr The OpenSSL-compatible string.
           *
           * @return {CipherParams} The cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
           */
          parse: function(O) {
            var F, Y = u.parse(O), P = Y.words;
            return P[0] == 1398893684 && P[1] == 1701076831 && (F = a.create(P.slice(2, 4)), P.splice(0, 4), Y.sigBytes -= 16), x.create({ ciphertext: Y, salt: F });
          }
        }, w = o.SerializableCipher = s.extend({
          /**
           * Configuration options.
           *
           * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
           */
          cfg: s.extend({
            format: R
          }),
          /**
           * Encrypts a message.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {WordArray|string} message The message to encrypt.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {CipherParams} A cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           */
          encrypt: function(O, F, Y, P) {
            P = this.cfg.extend(P);
            var z = O.createEncryptor(Y, P), W = z.finalize(F), H = z.cfg;
            return x.create({
              ciphertext: W,
              key: Y,
              iv: H.iv,
              algorithm: O,
              mode: H.mode,
              padding: H.padding,
              blockSize: O.blockSize,
              formatter: P.format
            });
          },
          /**
           * Decrypts serialized ciphertext.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
           * @param {WordArray} key The key.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {WordArray} The plaintext.
           *
           * @static
           *
           * @example
           *
           *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
           */
          decrypt: function(O, F, Y, P) {
            P = this.cfg.extend(P), F = this._parse(F, P.format);
            var z = O.createDecryptor(Y, P).finalize(F.ciphertext);
            return z;
          },
          /**
           * Converts serialized ciphertext to CipherParams,
           * else assumed CipherParams already and returns ciphertext unchanged.
           *
           * @param {CipherParams|string} ciphertext The ciphertext.
           * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
           *
           * @return {CipherParams} The unserialized ciphertext.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
           */
          _parse: function(O, F) {
            return typeof O == "string" ? F.parse(O, this) : O;
          }
        }), T = n.kdf = {}, N = T.OpenSSL = {
          /**
           * Derives a key and IV from a password.
           *
           * @param {string} password The password to derive from.
           * @param {number} keySize The size in words of the key to generate.
           * @param {number} ivSize The size in words of the IV to generate.
           * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
           *
           * @return {CipherParams} A cipher params object with the key, IV, and salt.
           *
           * @static
           *
           * @example
           *
           *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
           *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
           */
          execute: function(O, F, Y, P, z) {
            if (P || (P = a.random(64 / 8)), z)
              var W = g.create({ keySize: F + Y, hasher: z }).compute(O, P);
            else
              var W = g.create({ keySize: F + Y }).compute(O, P);
            var H = a.create(W.words.slice(F), Y * 4);
            return W.sigBytes = F * 4, x.create({ key: W, iv: H, salt: P });
          }
        }, D = o.PasswordBasedCipher = w.extend({
          /**
           * Configuration options.
           *
           * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
           */
          cfg: w.cfg.extend({
            kdf: N
          }),
          /**
           * Encrypts a message using a password.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {WordArray|string} message The message to encrypt.
           * @param {string} password The password.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {CipherParams} A cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
           *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
           */
          encrypt: function(O, F, Y, P) {
            P = this.cfg.extend(P);
            var z = P.kdf.execute(Y, O.keySize, O.ivSize, P.salt, P.hasher);
            P.iv = z.iv;
            var W = w.encrypt.call(this, O, F, z.key, P);
            return W.mixIn(z), W;
          },
          /**
           * Decrypts serialized ciphertext using a password.
           *
           * @param {Cipher} cipher The cipher algorithm to use.
           * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
           * @param {string} password The password.
           * @param {Object} cfg (Optional) The configuration options to use for this operation.
           *
           * @return {WordArray} The plaintext.
           *
           * @static
           *
           * @example
           *
           *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
           *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
           */
          decrypt: function(O, F, Y, P) {
            P = this.cfg.extend(P), F = this._parse(F, P.format);
            var z = P.kdf.execute(Y, O.keySize, O.ivSize, F.salt, P.hasher);
            P.iv = z.iv;
            var W = w.decrypt.call(this, O, F, z.key, P);
            return W;
          }
        });
      }();
    });
  }(bv)), bv.exports;
}
var Cv = { exports: {} }, FM;
function txe() {
  return FM || (FM = 1, function(e, t) {
    (function(i, r, n) {
      e.exports = r(zt(), qr());
    })(yt, function(i) {
      return i.mode.CFB = function() {
        var r = i.lib.BlockCipherMode.extend();
        r.Encryptor = r.extend({
          processBlock: function(o, s) {
            var a = this._cipher, l = a.blockSize;
            n.call(this, o, s, l, a), this._prevBlock = o.slice(s, s + l);
          }
        }), r.Decryptor = r.extend({
          processBlock: function(o, s) {
            var a = this._cipher, l = a.blockSize, c = o.slice(s, s + l);
            n.call(this, o, s, l, a), this._prevBlock = c;
          }
        });
        function n(o, s, a, l) {
          var c, u = this._iv;
          u ? (c = u.slice(0), this._iv = void 0) : c = this._prevBlock, l.encryptBlock(c, 0);
          for (var m = 0; m < a; m++)
            o[s + m] ^= c[m];
        }
        return r;
      }(), i.mode.CFB;
    });
  }(Cv)), Cv.exports;
}
var xv = { exports: {} }, VM;
function ixe() {
  return VM || (VM = 1, function(e, t) {
    (function(i, r, n) {
      e.exports = r(zt(), qr());
    })(yt, function(i) {
      return i.mode.CTR = function() {
        var r = i.lib.BlockCipherMode.extend(), n = r.Encryptor = r.extend({
          processBlock: function(o, s) {
            var a = this._cipher, l = a.blockSize, c = this._iv, u = this._counter;
            c && (u = this._counter = c.slice(0), this._iv = void 0);
            var m = u.slice(0);
            a.encryptBlock(m, 0), u[l - 1] = u[l - 1] + 1 | 0;
            for (var g = 0; g < l; g++)
              o[s + g] ^= m[g];
          }
        });
        return r.Decryptor = n, r;
      }(), i.mode.CTR;
    });
  }(xv)), xv.exports;
}
var Iv = { exports: {} }, qM;
function rxe() {
  return qM || (qM = 1, function(e, t) {
    (function(i, r, n) {
      e.exports = r(zt(), qr());
    })(yt, function(i) {
      /** @preserve
       * Counter block mode compatible with  Dr Brian Gladman fileenc.c
       * derived from CryptoJS.mode.CTR
       * Jan Hruby jhruby.web@gmail.com
       */
      return i.mode.CTRGladman = function() {
        var r = i.lib.BlockCipherMode.extend();
        function n(a) {
          if ((a >> 24 & 255) === 255) {
            var l = a >> 16 & 255, c = a >> 8 & 255, u = a & 255;
            l === 255 ? (l = 0, c === 255 ? (c = 0, u === 255 ? u = 0 : ++u) : ++c) : ++l, a = 0, a += l << 16, a += c << 8, a += u;
          } else
            a += 1 << 24;
          return a;
        }
        function o(a) {
          return (a[0] = n(a[0])) === 0 && (a[1] = n(a[1])), a;
        }
        var s = r.Encryptor = r.extend({
          processBlock: function(a, l) {
            var c = this._cipher, u = c.blockSize, m = this._iv, g = this._counter;
            m && (g = this._counter = m.slice(0), this._iv = void 0), o(g);
            var h = g.slice(0);
            c.encryptBlock(h, 0);
            for (var A = 0; A < u; A++)
              a[l + A] ^= h[A];
          }
        });
        return r.Decryptor = s, r;
      }(), i.mode.CTRGladman;
    });
  }(Iv)), Iv.exports;
}
var Sv = { exports: {} }, jM;
function nxe() {
  return jM || (jM = 1, function(e, t) {
    (function(i, r, n) {
      e.exports = r(zt(), qr());
    })(yt, function(i) {
      return i.mode.OFB = function() {
        var r = i.lib.BlockCipherMode.extend(), n = r.Encryptor = r.extend({
          processBlock: function(o, s) {
            var a = this._cipher, l = a.blockSize, c = this._iv, u = this._keystream;
            c && (u = this._keystream = c.slice(0), this._iv = void 0), a.encryptBlock(u, 0);
            for (var m = 0; m < l; m++)
              o[s + m] ^= u[m];
          }
        });
        return r.Decryptor = n, r;
      }(), i.mode.OFB;
    });
  }(Sv)), Sv.exports;
}
var Rv = { exports: {} }, LM;
function oxe() {
  return LM || (LM = 1, function(e, t) {
    (function(i, r, n) {
      e.exports = r(zt(), qr());
    })(yt, function(i) {
      return i.mode.ECB = function() {
        var r = i.lib.BlockCipherMode.extend();
        return r.Encryptor = r.extend({
          processBlock: function(n, o) {
            this._cipher.encryptBlock(n, o);
          }
        }), r.Decryptor = r.extend({
          processBlock: function(n, o) {
            this._cipher.decryptBlock(n, o);
          }
        }), r;
      }(), i.mode.ECB;
    });
  }(Rv)), Rv.exports;
}
var kv = { exports: {} }, KM;
function sxe() {
  return KM || (KM = 1, function(e, t) {
    (function(i, r, n) {
      e.exports = r(zt(), qr());
    })(yt, function(i) {
      return i.pad.AnsiX923 = {
        pad: function(r, n) {
          var o = r.sigBytes, s = n * 4, a = s - o % s, l = o + a - 1;
          r.clamp(), r.words[l >>> 2] |= a << 24 - l % 4 * 8, r.sigBytes += a;
        },
        unpad: function(r) {
          var n = r.words[r.sigBytes - 1 >>> 2] & 255;
          r.sigBytes -= n;
        }
      }, i.pad.Ansix923;
    });
  }(kv)), kv.exports;
}
var wv = { exports: {} }, YM;
function axe() {
  return YM || (YM = 1, function(e, t) {
    (function(i, r, n) {
      e.exports = r(zt(), qr());
    })(yt, function(i) {
      return i.pad.Iso10126 = {
        pad: function(r, n) {
          var o = n * 4, s = o - r.sigBytes % o;
          r.concat(i.lib.WordArray.random(s - 1)).concat(i.lib.WordArray.create([s << 24], 1));
        },
        unpad: function(r) {
          var n = r.words[r.sigBytes - 1 >>> 2] & 255;
          r.sigBytes -= n;
        }
      }, i.pad.Iso10126;
    });
  }(wv)), wv.exports;
}
var Mv = { exports: {} }, UM;
function lxe() {
  return UM || (UM = 1, function(e, t) {
    (function(i, r, n) {
      e.exports = r(zt(), qr());
    })(yt, function(i) {
      return i.pad.Iso97971 = {
        pad: function(r, n) {
          r.concat(i.lib.WordArray.create([2147483648], 1)), i.pad.ZeroPadding.pad(r, n);
        },
        unpad: function(r) {
          i.pad.ZeroPadding.unpad(r), r.sigBytes--;
        }
      }, i.pad.Iso97971;
    });
  }(Mv)), Mv.exports;
}
var Nv = { exports: {} }, GM;
function cxe() {
  return GM || (GM = 1, function(e, t) {
    (function(i, r, n) {
      e.exports = r(zt(), qr());
    })(yt, function(i) {
      return i.pad.ZeroPadding = {
        pad: function(r, n) {
          var o = n * 4;
          r.clamp(), r.sigBytes += o - (r.sigBytes % o || o);
        },
        unpad: function(r) {
          for (var n = r.words, o = r.sigBytes - 1, o = r.sigBytes - 1; o >= 0; o--)
            if (n[o >>> 2] >>> 24 - o % 4 * 8 & 255) {
              r.sigBytes = o + 1;
              break;
            }
        }
      }, i.pad.ZeroPadding;
    });
  }(Nv)), Nv.exports;
}
var Tv = { exports: {} }, QM;
function uxe() {
  return QM || (QM = 1, function(e, t) {
    (function(i, r, n) {
      e.exports = r(zt(), qr());
    })(yt, function(i) {
      return i.pad.NoPadding = {
        pad: function() {
        },
        unpad: function() {
        }
      }, i.pad.NoPadding;
    });
  }(Tv)), Tv.exports;
}
var Bv = { exports: {} }, WM;
function dxe() {
  return WM || (WM = 1, function(e, t) {
    (function(i, r, n) {
      e.exports = r(zt(), qr());
    })(yt, function(i) {
      return function(r) {
        var n = i, o = n.lib, s = o.CipherParams, a = n.enc, l = a.Hex, c = n.format;
        c.Hex = {
          /**
           * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
           *
           * @param {CipherParams} cipherParams The cipher params object.
           *
           * @return {string} The hexadecimally encoded string.
           *
           * @static
           *
           * @example
           *
           *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
           */
          stringify: function(u) {
            return u.ciphertext.toString(l);
          },
          /**
           * Converts a hexadecimally encoded ciphertext string to a cipher params object.
           *
           * @param {string} input The hexadecimally encoded string.
           *
           * @return {CipherParams} The cipher params object.
           *
           * @static
           *
           * @example
           *
           *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
           */
          parse: function(u) {
            var m = l.parse(u);
            return s.create({ ciphertext: m });
          }
        };
      }(), i.format.Hex;
    });
  }(Bv)), Bv.exports;
}
var Dv = { exports: {} }, ZM;
function mxe() {
  return ZM || (ZM = 1, function(e, t) {
    (function(i, r, n) {
      e.exports = r(zt(), uu(), du(), Pl(), qr());
    })(yt, function(i) {
      return function() {
        var r = i, n = r.lib, o = n.BlockCipher, s = r.algo, a = [], l = [], c = [], u = [], m = [], g = [], h = [], A = [], y = [], E = [];
        (function() {
          for (var x = [], S = 0; S < 256; S++)
            S < 128 ? x[S] = S << 1 : x[S] = S << 1 ^ 283;
          for (var R = 0, w = 0, S = 0; S < 256; S++) {
            var T = w ^ w << 1 ^ w << 2 ^ w << 3 ^ w << 4;
            T = T >>> 8 ^ T & 255 ^ 99, a[R] = T, l[T] = R;
            var N = x[R], D = x[N], O = x[D], F = x[T] * 257 ^ T * 16843008;
            c[R] = F << 24 | F >>> 8, u[R] = F << 16 | F >>> 16, m[R] = F << 8 | F >>> 24, g[R] = F;
            var F = O * 16843009 ^ D * 65537 ^ N * 257 ^ R * 16843008;
            h[T] = F << 24 | F >>> 8, A[T] = F << 16 | F >>> 16, y[T] = F << 8 | F >>> 24, E[T] = F, R ? (R = N ^ x[x[x[O ^ N]]], w ^= x[x[w]]) : R = w = 1;
          }
        })();
        var v = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], C = s.AES = o.extend({
          _doReset: function() {
            var x;
            if (!(this._nRounds && this._keyPriorReset === this._key)) {
              for (var S = this._keyPriorReset = this._key, R = S.words, w = S.sigBytes / 4, T = this._nRounds = w + 6, N = (T + 1) * 4, D = this._keySchedule = [], O = 0; O < N; O++)
                O < w ? D[O] = R[O] : (x = D[O - 1], O % w ? w > 6 && O % w == 4 && (x = a[x >>> 24] << 24 | a[x >>> 16 & 255] << 16 | a[x >>> 8 & 255] << 8 | a[x & 255]) : (x = x << 8 | x >>> 24, x = a[x >>> 24] << 24 | a[x >>> 16 & 255] << 16 | a[x >>> 8 & 255] << 8 | a[x & 255], x ^= v[O / w | 0] << 24), D[O] = D[O - w] ^ x);
              for (var F = this._invKeySchedule = [], Y = 0; Y < N; Y++) {
                var O = N - Y;
                if (Y % 4)
                  var x = D[O];
                else
                  var x = D[O - 4];
                Y < 4 || O <= 4 ? F[Y] = x : F[Y] = h[a[x >>> 24]] ^ A[a[x >>> 16 & 255]] ^ y[a[x >>> 8 & 255]] ^ E[a[x & 255]];
              }
            }
          },
          encryptBlock: function(x, S) {
            this._doCryptBlock(x, S, this._keySchedule, c, u, m, g, a);
          },
          decryptBlock: function(x, S) {
            var R = x[S + 1];
            x[S + 1] = x[S + 3], x[S + 3] = R, this._doCryptBlock(x, S, this._invKeySchedule, h, A, y, E, l);
            var R = x[S + 1];
            x[S + 1] = x[S + 3], x[S + 3] = R;
          },
          _doCryptBlock: function(x, S, R, w, T, N, D, O) {
            for (var F = this._nRounds, Y = x[S] ^ R[0], P = x[S + 1] ^ R[1], z = x[S + 2] ^ R[2], W = x[S + 3] ^ R[3], H = 4, Q = 1; Q < F; Q++) {
              var $ = w[Y >>> 24] ^ T[P >>> 16 & 255] ^ N[z >>> 8 & 255] ^ D[W & 255] ^ R[H++], le = w[P >>> 24] ^ T[z >>> 16 & 255] ^ N[W >>> 8 & 255] ^ D[Y & 255] ^ R[H++], he = w[z >>> 24] ^ T[W >>> 16 & 255] ^ N[Y >>> 8 & 255] ^ D[P & 255] ^ R[H++], oe = w[W >>> 24] ^ T[Y >>> 16 & 255] ^ N[P >>> 8 & 255] ^ D[z & 255] ^ R[H++];
              Y = $, P = le, z = he, W = oe;
            }
            var $ = (O[Y >>> 24] << 24 | O[P >>> 16 & 255] << 16 | O[z >>> 8 & 255] << 8 | O[W & 255]) ^ R[H++], le = (O[P >>> 24] << 24 | O[z >>> 16 & 255] << 16 | O[W >>> 8 & 255] << 8 | O[Y & 255]) ^ R[H++], he = (O[z >>> 24] << 24 | O[W >>> 16 & 255] << 16 | O[Y >>> 8 & 255] << 8 | O[P & 255]) ^ R[H++], oe = (O[W >>> 24] << 24 | O[Y >>> 16 & 255] << 16 | O[P >>> 8 & 255] << 8 | O[z & 255]) ^ R[H++];
            x[S] = $, x[S + 1] = le, x[S + 2] = he, x[S + 3] = oe;
          },
          keySize: 256 / 32
        });
        r.AES = o._createHelper(C);
      }(), i.AES;
    });
  }(Dv)), Dv.exports;
}
var Ov = { exports: {} }, JM;
function gxe() {
  return JM || (JM = 1, function(e, t) {
    (function(i, r, n) {
      e.exports = r(zt(), uu(), du(), Pl(), qr());
    })(yt, function(i) {
      return function() {
        var r = i, n = r.lib, o = n.WordArray, s = n.BlockCipher, a = r.algo, l = [
          57,
          49,
          41,
          33,
          25,
          17,
          9,
          1,
          58,
          50,
          42,
          34,
          26,
          18,
          10,
          2,
          59,
          51,
          43,
          35,
          27,
          19,
          11,
          3,
          60,
          52,
          44,
          36,
          63,
          55,
          47,
          39,
          31,
          23,
          15,
          7,
          62,
          54,
          46,
          38,
          30,
          22,
          14,
          6,
          61,
          53,
          45,
          37,
          29,
          21,
          13,
          5,
          28,
          20,
          12,
          4
        ], c = [
          14,
          17,
          11,
          24,
          1,
          5,
          3,
          28,
          15,
          6,
          21,
          10,
          23,
          19,
          12,
          4,
          26,
          8,
          16,
          7,
          27,
          20,
          13,
          2,
          41,
          52,
          31,
          37,
          47,
          55,
          30,
          40,
          51,
          45,
          33,
          48,
          44,
          49,
          39,
          56,
          34,
          53,
          46,
          42,
          50,
          36,
          29,
          32
        ], u = [1, 2, 4, 6, 8, 10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28], m = [
          {
            0: 8421888,
            268435456: 32768,
            536870912: 8421378,
            805306368: 2,
            1073741824: 512,
            1342177280: 8421890,
            1610612736: 8389122,
            1879048192: 8388608,
            2147483648: 514,
            2415919104: 8389120,
            2684354560: 33280,
            2952790016: 8421376,
            3221225472: 32770,
            3489660928: 8388610,
            3758096384: 0,
            4026531840: 33282,
            134217728: 0,
            402653184: 8421890,
            671088640: 33282,
            939524096: 32768,
            1207959552: 8421888,
            1476395008: 512,
            1744830464: 8421378,
            2013265920: 2,
            2281701376: 8389120,
            2550136832: 33280,
            2818572288: 8421376,
            3087007744: 8389122,
            3355443200: 8388610,
            3623878656: 32770,
            3892314112: 514,
            4160749568: 8388608,
            1: 32768,
            268435457: 2,
            536870913: 8421888,
            805306369: 8388608,
            1073741825: 8421378,
            1342177281: 33280,
            1610612737: 512,
            1879048193: 8389122,
            2147483649: 8421890,
            2415919105: 8421376,
            2684354561: 8388610,
            2952790017: 33282,
            3221225473: 514,
            3489660929: 8389120,
            3758096385: 32770,
            4026531841: 0,
            134217729: 8421890,
            402653185: 8421376,
            671088641: 8388608,
            939524097: 512,
            1207959553: 32768,
            1476395009: 8388610,
            1744830465: 2,
            2013265921: 33282,
            2281701377: 32770,
            2550136833: 8389122,
            2818572289: 514,
            3087007745: 8421888,
            3355443201: 8389120,
            3623878657: 0,
            3892314113: 33280,
            4160749569: 8421378
          },
          {
            0: 1074282512,
            16777216: 16384,
            33554432: 524288,
            50331648: 1074266128,
            67108864: 1073741840,
            83886080: 1074282496,
            100663296: 1073758208,
            117440512: 16,
            134217728: 540672,
            150994944: 1073758224,
            167772160: 1073741824,
            184549376: 540688,
            201326592: 524304,
            218103808: 0,
            234881024: 16400,
            251658240: 1074266112,
            8388608: 1073758208,
            25165824: 540688,
            41943040: 16,
            58720256: 1073758224,
            75497472: 1074282512,
            92274688: 1073741824,
            109051904: 524288,
            125829120: 1074266128,
            142606336: 524304,
            159383552: 0,
            176160768: 16384,
            192937984: 1074266112,
            209715200: 1073741840,
            226492416: 540672,
            243269632: 1074282496,
            260046848: 16400,
            268435456: 0,
            285212672: 1074266128,
            301989888: 1073758224,
            318767104: 1074282496,
            335544320: 1074266112,
            352321536: 16,
            369098752: 540688,
            385875968: 16384,
            402653184: 16400,
            419430400: 524288,
            436207616: 524304,
            452984832: 1073741840,
            469762048: 540672,
            486539264: 1073758208,
            503316480: 1073741824,
            520093696: 1074282512,
            276824064: 540688,
            293601280: 524288,
            310378496: 1074266112,
            327155712: 16384,
            343932928: 1073758208,
            360710144: 1074282512,
            377487360: 16,
            394264576: 1073741824,
            411041792: 1074282496,
            427819008: 1073741840,
            444596224: 1073758224,
            461373440: 524304,
            478150656: 0,
            494927872: 16400,
            511705088: 1074266128,
            528482304: 540672
          },
          {
            0: 260,
            1048576: 0,
            2097152: 67109120,
            3145728: 65796,
            4194304: 65540,
            5242880: 67108868,
            6291456: 67174660,
            7340032: 67174400,
            8388608: 67108864,
            9437184: 67174656,
            10485760: 65792,
            11534336: 67174404,
            12582912: 67109124,
            13631488: 65536,
            14680064: 4,
            15728640: 256,
            524288: 67174656,
            1572864: 67174404,
            2621440: 0,
            3670016: 67109120,
            4718592: 67108868,
            5767168: 65536,
            6815744: 65540,
            7864320: 260,
            8912896: 4,
            9961472: 256,
            11010048: 67174400,
            12058624: 65796,
            13107200: 65792,
            14155776: 67109124,
            15204352: 67174660,
            16252928: 67108864,
            16777216: 67174656,
            17825792: 65540,
            18874368: 65536,
            19922944: 67109120,
            20971520: 256,
            22020096: 67174660,
            23068672: 67108868,
            24117248: 0,
            25165824: 67109124,
            26214400: 67108864,
            27262976: 4,
            28311552: 65792,
            29360128: 67174400,
            30408704: 260,
            31457280: 65796,
            32505856: 67174404,
            17301504: 67108864,
            18350080: 260,
            19398656: 67174656,
            20447232: 0,
            21495808: 65540,
            22544384: 67109120,
            23592960: 256,
            24641536: 67174404,
            25690112: 65536,
            26738688: 67174660,
            27787264: 65796,
            28835840: 67108868,
            29884416: 67109124,
            30932992: 67174400,
            31981568: 4,
            33030144: 65792
          },
          {
            0: 2151682048,
            65536: 2147487808,
            131072: 4198464,
            196608: 2151677952,
            262144: 0,
            327680: 4198400,
            393216: 2147483712,
            458752: 4194368,
            524288: 2147483648,
            589824: 4194304,
            655360: 64,
            720896: 2147487744,
            786432: 2151678016,
            851968: 4160,
            917504: 4096,
            983040: 2151682112,
            32768: 2147487808,
            98304: 64,
            163840: 2151678016,
            229376: 2147487744,
            294912: 4198400,
            360448: 2151682112,
            425984: 0,
            491520: 2151677952,
            557056: 4096,
            622592: 2151682048,
            688128: 4194304,
            753664: 4160,
            819200: 2147483648,
            884736: 4194368,
            950272: 4198464,
            1015808: 2147483712,
            1048576: 4194368,
            1114112: 4198400,
            1179648: 2147483712,
            1245184: 0,
            1310720: 4160,
            1376256: 2151678016,
            1441792: 2151682048,
            1507328: 2147487808,
            1572864: 2151682112,
            1638400: 2147483648,
            1703936: 2151677952,
            1769472: 4198464,
            1835008: 2147487744,
            1900544: 4194304,
            1966080: 64,
            2031616: 4096,
            1081344: 2151677952,
            1146880: 2151682112,
            1212416: 0,
            1277952: 4198400,
            1343488: 4194368,
            1409024: 2147483648,
            1474560: 2147487808,
            1540096: 64,
            1605632: 2147483712,
            1671168: 4096,
            1736704: 2147487744,
            1802240: 2151678016,
            1867776: 4160,
            1933312: 2151682048,
            1998848: 4194304,
            2064384: 4198464
          },
          {
            0: 128,
            4096: 17039360,
            8192: 262144,
            12288: 536870912,
            16384: 537133184,
            20480: 16777344,
            24576: 553648256,
            28672: 262272,
            32768: 16777216,
            36864: 537133056,
            40960: 536871040,
            45056: 553910400,
            49152: 553910272,
            53248: 0,
            57344: 17039488,
            61440: 553648128,
            2048: 17039488,
            6144: 553648256,
            10240: 128,
            14336: 17039360,
            18432: 262144,
            22528: 537133184,
            26624: 553910272,
            30720: 536870912,
            34816: 537133056,
            38912: 0,
            43008: 553910400,
            47104: 16777344,
            51200: 536871040,
            55296: 553648128,
            59392: 16777216,
            63488: 262272,
            65536: 262144,
            69632: 128,
            73728: 536870912,
            77824: 553648256,
            81920: 16777344,
            86016: 553910272,
            90112: 537133184,
            94208: 16777216,
            98304: 553910400,
            102400: 553648128,
            106496: 17039360,
            110592: 537133056,
            114688: 262272,
            118784: 536871040,
            122880: 0,
            126976: 17039488,
            67584: 553648256,
            71680: 16777216,
            75776: 17039360,
            79872: 537133184,
            83968: 536870912,
            88064: 17039488,
            92160: 128,
            96256: 553910272,
            100352: 262272,
            104448: 553910400,
            108544: 0,
            112640: 553648128,
            116736: 16777344,
            120832: 262144,
            124928: 537133056,
            129024: 536871040
          },
          {
            0: 268435464,
            256: 8192,
            512: 270532608,
            768: 270540808,
            1024: 268443648,
            1280: 2097152,
            1536: 2097160,
            1792: 268435456,
            2048: 0,
            2304: 268443656,
            2560: 2105344,
            2816: 8,
            3072: 270532616,
            3328: 2105352,
            3584: 8200,
            3840: 270540800,
            128: 270532608,
            384: 270540808,
            640: 8,
            896: 2097152,
            1152: 2105352,
            1408: 268435464,
            1664: 268443648,
            1920: 8200,
            2176: 2097160,
            2432: 8192,
            2688: 268443656,
            2944: 270532616,
            3200: 0,
            3456: 270540800,
            3712: 2105344,
            3968: 268435456,
            4096: 268443648,
            4352: 270532616,
            4608: 270540808,
            4864: 8200,
            5120: 2097152,
            5376: 268435456,
            5632: 268435464,
            5888: 2105344,
            6144: 2105352,
            6400: 0,
            6656: 8,
            6912: 270532608,
            7168: 8192,
            7424: 268443656,
            7680: 270540800,
            7936: 2097160,
            4224: 8,
            4480: 2105344,
            4736: 2097152,
            4992: 268435464,
            5248: 268443648,
            5504: 8200,
            5760: 270540808,
            6016: 270532608,
            6272: 270540800,
            6528: 270532616,
            6784: 8192,
            7040: 2105352,
            7296: 2097160,
            7552: 0,
            7808: 268435456,
            8064: 268443656
          },
          {
            0: 1048576,
            16: 33555457,
            32: 1024,
            48: 1049601,
            64: 34604033,
            80: 0,
            96: 1,
            112: 34603009,
            128: 33555456,
            144: 1048577,
            160: 33554433,
            176: 34604032,
            192: 34603008,
            208: 1025,
            224: 1049600,
            240: 33554432,
            8: 34603009,
            24: 0,
            40: 33555457,
            56: 34604032,
            72: 1048576,
            88: 33554433,
            104: 33554432,
            120: 1025,
            136: 1049601,
            152: 33555456,
            168: 34603008,
            184: 1048577,
            200: 1024,
            216: 34604033,
            232: 1,
            248: 1049600,
            256: 33554432,
            272: 1048576,
            288: 33555457,
            304: 34603009,
            320: 1048577,
            336: 33555456,
            352: 34604032,
            368: 1049601,
            384: 1025,
            400: 34604033,
            416: 1049600,
            432: 1,
            448: 0,
            464: 34603008,
            480: 33554433,
            496: 1024,
            264: 1049600,
            280: 33555457,
            296: 34603009,
            312: 1,
            328: 33554432,
            344: 1048576,
            360: 1025,
            376: 34604032,
            392: 33554433,
            408: 34603008,
            424: 0,
            440: 34604033,
            456: 1049601,
            472: 1024,
            488: 33555456,
            504: 1048577
          },
          {
            0: 134219808,
            1: 131072,
            2: 134217728,
            3: 32,
            4: 131104,
            5: 134350880,
            6: 134350848,
            7: 2048,
            8: 134348800,
            9: 134219776,
            10: 133120,
            11: 134348832,
            12: 2080,
            13: 0,
            14: 134217760,
            15: 133152,
            2147483648: 2048,
            2147483649: 134350880,
            2147483650: 134219808,
            2147483651: 134217728,
            2147483652: 134348800,
            2147483653: 133120,
            2147483654: 133152,
            2147483655: 32,
            2147483656: 134217760,
            2147483657: 2080,
            2147483658: 131104,
            2147483659: 134350848,
            2147483660: 0,
            2147483661: 134348832,
            2147483662: 134219776,
            2147483663: 131072,
            16: 133152,
            17: 134350848,
            18: 32,
            19: 2048,
            20: 134219776,
            21: 134217760,
            22: 134348832,
            23: 131072,
            24: 0,
            25: 131104,
            26: 134348800,
            27: 134219808,
            28: 134350880,
            29: 133120,
            30: 2080,
            31: 134217728,
            2147483664: 131072,
            2147483665: 2048,
            2147483666: 134348832,
            2147483667: 133152,
            2147483668: 32,
            2147483669: 134348800,
            2147483670: 134217728,
            2147483671: 134219808,
            2147483672: 134350880,
            2147483673: 134217760,
            2147483674: 134219776,
            2147483675: 0,
            2147483676: 133120,
            2147483677: 2080,
            2147483678: 131104,
            2147483679: 134350848
          }
        ], g = [
          4160749569,
          528482304,
          33030144,
          2064384,
          129024,
          8064,
          504,
          2147483679
        ], h = a.DES = s.extend({
          _doReset: function() {
            for (var v = this._key, C = v.words, x = [], S = 0; S < 56; S++) {
              var R = l[S] - 1;
              x[S] = C[R >>> 5] >>> 31 - R % 32 & 1;
            }
            for (var w = this._subKeys = [], T = 0; T < 16; T++) {
              for (var N = w[T] = [], D = u[T], S = 0; S < 24; S++)
                N[S / 6 | 0] |= x[(c[S] - 1 + D) % 28] << 31 - S % 6, N[4 + (S / 6 | 0)] |= x[28 + (c[S + 24] - 1 + D) % 28] << 31 - S % 6;
              N[0] = N[0] << 1 | N[0] >>> 31;
              for (var S = 1; S < 7; S++)
                N[S] = N[S] >>> (S - 1) * 4 + 3;
              N[7] = N[7] << 5 | N[7] >>> 27;
            }
            for (var O = this._invSubKeys = [], S = 0; S < 16; S++)
              O[S] = w[15 - S];
          },
          encryptBlock: function(v, C) {
            this._doCryptBlock(v, C, this._subKeys);
          },
          decryptBlock: function(v, C) {
            this._doCryptBlock(v, C, this._invSubKeys);
          },
          _doCryptBlock: function(v, C, x) {
            this._lBlock = v[C], this._rBlock = v[C + 1], A.call(this, 4, 252645135), A.call(this, 16, 65535), y.call(this, 2, 858993459), y.call(this, 8, 16711935), A.call(this, 1, 1431655765);
            for (var S = 0; S < 16; S++) {
              for (var R = x[S], w = this._lBlock, T = this._rBlock, N = 0, D = 0; D < 8; D++)
                N |= m[D][((T ^ R[D]) & g[D]) >>> 0];
              this._lBlock = T, this._rBlock = w ^ N;
            }
            var O = this._lBlock;
            this._lBlock = this._rBlock, this._rBlock = O, A.call(this, 1, 1431655765), y.call(this, 8, 16711935), y.call(this, 2, 858993459), A.call(this, 16, 65535), A.call(this, 4, 252645135), v[C] = this._lBlock, v[C + 1] = this._rBlock;
          },
          keySize: 64 / 32,
          ivSize: 64 / 32,
          blockSize: 64 / 32
        });
        function A(v, C) {
          var x = (this._lBlock >>> v ^ this._rBlock) & C;
          this._rBlock ^= x, this._lBlock ^= x << v;
        }
        function y(v, C) {
          var x = (this._rBlock >>> v ^ this._lBlock) & C;
          this._lBlock ^= x, this._rBlock ^= x << v;
        }
        r.DES = s._createHelper(h);
        var E = a.TripleDES = s.extend({
          _doReset: function() {
            var v = this._key, C = v.words;
            if (C.length !== 2 && C.length !== 4 && C.length < 6)
              throw new Error("Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.");
            var x = C.slice(0, 2), S = C.length < 4 ? C.slice(0, 2) : C.slice(2, 4), R = C.length < 6 ? C.slice(0, 2) : C.slice(4, 6);
            this._des1 = h.createEncryptor(o.create(x)), this._des2 = h.createEncryptor(o.create(S)), this._des3 = h.createEncryptor(o.create(R));
          },
          encryptBlock: function(v, C) {
            this._des1.encryptBlock(v, C), this._des2.decryptBlock(v, C), this._des3.encryptBlock(v, C);
          },
          decryptBlock: function(v, C) {
            this._des3.decryptBlock(v, C), this._des2.encryptBlock(v, C), this._des1.decryptBlock(v, C);
          },
          keySize: 192 / 32,
          ivSize: 64 / 32,
          blockSize: 64 / 32
        });
        r.TripleDES = s._createHelper(E);
      }(), i.TripleDES;
    });
  }(Ov)), Ov.exports;
}
var Fv = { exports: {} }, PM;
function hxe() {
  return PM || (PM = 1, function(e, t) {
    (function(i, r, n) {
      e.exports = r(zt(), uu(), du(), Pl(), qr());
    })(yt, function(i) {
      return function() {
        var r = i, n = r.lib, o = n.StreamCipher, s = r.algo, a = s.RC4 = o.extend({
          _doReset: function() {
            for (var u = this._key, m = u.words, g = u.sigBytes, h = this._S = [], A = 0; A < 256; A++)
              h[A] = A;
            for (var A = 0, y = 0; A < 256; A++) {
              var E = A % g, v = m[E >>> 2] >>> 24 - E % 4 * 8 & 255;
              y = (y + h[A] + v) % 256;
              var C = h[A];
              h[A] = h[y], h[y] = C;
            }
            this._i = this._j = 0;
          },
          _doProcessBlock: function(u, m) {
            u[m] ^= l.call(this);
          },
          keySize: 256 / 32,
          ivSize: 0
        });
        function l() {
          for (var u = this._S, m = this._i, g = this._j, h = 0, A = 0; A < 4; A++) {
            m = (m + 1) % 256, g = (g + u[m]) % 256;
            var y = u[m];
            u[m] = u[g], u[g] = y, h |= u[(u[m] + u[g]) % 256] << 24 - A * 8;
          }
          return this._i = m, this._j = g, h;
        }
        r.RC4 = o._createHelper(a);
        var c = s.RC4Drop = a.extend({
          /**
           * Configuration options.
           *
           * @property {number} drop The number of keystream words to drop. Default 192
           */
          cfg: a.cfg.extend({
            drop: 192
          }),
          _doReset: function() {
            a._doReset.call(this);
            for (var u = this.cfg.drop; u > 0; u--)
              l.call(this);
          }
        });
        r.RC4Drop = o._createHelper(c);
      }(), i.RC4;
    });
  }(Fv)), Fv.exports;
}
var Vv = { exports: {} }, zM;
function pxe() {
  return zM || (zM = 1, function(e, t) {
    (function(i, r, n) {
      e.exports = r(zt(), uu(), du(), Pl(), qr());
    })(yt, function(i) {
      return function() {
        var r = i, n = r.lib, o = n.StreamCipher, s = r.algo, a = [], l = [], c = [], u = s.Rabbit = o.extend({
          _doReset: function() {
            for (var g = this._key.words, h = this.cfg.iv, A = 0; A < 4; A++)
              g[A] = (g[A] << 8 | g[A] >>> 24) & 16711935 | (g[A] << 24 | g[A] >>> 8) & 4278255360;
            var y = this._X = [
              g[0],
              g[3] << 16 | g[2] >>> 16,
              g[1],
              g[0] << 16 | g[3] >>> 16,
              g[2],
              g[1] << 16 | g[0] >>> 16,
              g[3],
              g[2] << 16 | g[1] >>> 16
            ], E = this._C = [
              g[2] << 16 | g[2] >>> 16,
              g[0] & 4294901760 | g[1] & 65535,
              g[3] << 16 | g[3] >>> 16,
              g[1] & 4294901760 | g[2] & 65535,
              g[0] << 16 | g[0] >>> 16,
              g[2] & 4294901760 | g[3] & 65535,
              g[1] << 16 | g[1] >>> 16,
              g[3] & 4294901760 | g[0] & 65535
            ];
            this._b = 0;
            for (var A = 0; A < 4; A++)
              m.call(this);
            for (var A = 0; A < 8; A++)
              E[A] ^= y[A + 4 & 7];
            if (h) {
              var v = h.words, C = v[0], x = v[1], S = (C << 8 | C >>> 24) & 16711935 | (C << 24 | C >>> 8) & 4278255360, R = (x << 8 | x >>> 24) & 16711935 | (x << 24 | x >>> 8) & 4278255360, w = S >>> 16 | R & 4294901760, T = R << 16 | S & 65535;
              E[0] ^= S, E[1] ^= w, E[2] ^= R, E[3] ^= T, E[4] ^= S, E[5] ^= w, E[6] ^= R, E[7] ^= T;
              for (var A = 0; A < 4; A++)
                m.call(this);
            }
          },
          _doProcessBlock: function(g, h) {
            var A = this._X;
            m.call(this), a[0] = A[0] ^ A[5] >>> 16 ^ A[3] << 16, a[1] = A[2] ^ A[7] >>> 16 ^ A[5] << 16, a[2] = A[4] ^ A[1] >>> 16 ^ A[7] << 16, a[3] = A[6] ^ A[3] >>> 16 ^ A[1] << 16;
            for (var y = 0; y < 4; y++)
              a[y] = (a[y] << 8 | a[y] >>> 24) & 16711935 | (a[y] << 24 | a[y] >>> 8) & 4278255360, g[h + y] ^= a[y];
          },
          blockSize: 128 / 32,
          ivSize: 64 / 32
        });
        function m() {
          for (var g = this._X, h = this._C, A = 0; A < 8; A++)
            l[A] = h[A];
          h[0] = h[0] + 1295307597 + this._b | 0, h[1] = h[1] + 3545052371 + (h[0] >>> 0 < l[0] >>> 0 ? 1 : 0) | 0, h[2] = h[2] + 886263092 + (h[1] >>> 0 < l[1] >>> 0 ? 1 : 0) | 0, h[3] = h[3] + 1295307597 + (h[2] >>> 0 < l[2] >>> 0 ? 1 : 0) | 0, h[4] = h[4] + 3545052371 + (h[3] >>> 0 < l[3] >>> 0 ? 1 : 0) | 0, h[5] = h[5] + 886263092 + (h[4] >>> 0 < l[4] >>> 0 ? 1 : 0) | 0, h[6] = h[6] + 1295307597 + (h[5] >>> 0 < l[5] >>> 0 ? 1 : 0) | 0, h[7] = h[7] + 3545052371 + (h[6] >>> 0 < l[6] >>> 0 ? 1 : 0) | 0, this._b = h[7] >>> 0 < l[7] >>> 0 ? 1 : 0;
          for (var A = 0; A < 8; A++) {
            var y = g[A] + h[A], E = y & 65535, v = y >>> 16, C = ((E * E >>> 17) + E * v >>> 15) + v * v, x = ((y & 4294901760) * y | 0) + ((y & 65535) * y | 0);
            c[A] = C ^ x;
          }
          g[0] = c[0] + (c[7] << 16 | c[7] >>> 16) + (c[6] << 16 | c[6] >>> 16) | 0, g[1] = c[1] + (c[0] << 8 | c[0] >>> 24) + c[7] | 0, g[2] = c[2] + (c[1] << 16 | c[1] >>> 16) + (c[0] << 16 | c[0] >>> 16) | 0, g[3] = c[3] + (c[2] << 8 | c[2] >>> 24) + c[1] | 0, g[4] = c[4] + (c[3] << 16 | c[3] >>> 16) + (c[2] << 16 | c[2] >>> 16) | 0, g[5] = c[5] + (c[4] << 8 | c[4] >>> 24) + c[3] | 0, g[6] = c[6] + (c[5] << 16 | c[5] >>> 16) + (c[4] << 16 | c[4] >>> 16) | 0, g[7] = c[7] + (c[6] << 8 | c[6] >>> 24) + c[5] | 0;
        }
        r.Rabbit = o._createHelper(u);
      }(), i.Rabbit;
    });
  }(Vv)), Vv.exports;
}
var qv = { exports: {} }, HM;
function fxe() {
  return HM || (HM = 1, function(e, t) {
    (function(i, r, n) {
      e.exports = r(zt(), uu(), du(), Pl(), qr());
    })(yt, function(i) {
      return function() {
        var r = i, n = r.lib, o = n.StreamCipher, s = r.algo, a = [], l = [], c = [], u = s.RabbitLegacy = o.extend({
          _doReset: function() {
            var g = this._key.words, h = this.cfg.iv, A = this._X = [
              g[0],
              g[3] << 16 | g[2] >>> 16,
              g[1],
              g[0] << 16 | g[3] >>> 16,
              g[2],
              g[1] << 16 | g[0] >>> 16,
              g[3],
              g[2] << 16 | g[1] >>> 16
            ], y = this._C = [
              g[2] << 16 | g[2] >>> 16,
              g[0] & 4294901760 | g[1] & 65535,
              g[3] << 16 | g[3] >>> 16,
              g[1] & 4294901760 | g[2] & 65535,
              g[0] << 16 | g[0] >>> 16,
              g[2] & 4294901760 | g[3] & 65535,
              g[1] << 16 | g[1] >>> 16,
              g[3] & 4294901760 | g[0] & 65535
            ];
            this._b = 0;
            for (var E = 0; E < 4; E++)
              m.call(this);
            for (var E = 0; E < 8; E++)
              y[E] ^= A[E + 4 & 7];
            if (h) {
              var v = h.words, C = v[0], x = v[1], S = (C << 8 | C >>> 24) & 16711935 | (C << 24 | C >>> 8) & 4278255360, R = (x << 8 | x >>> 24) & 16711935 | (x << 24 | x >>> 8) & 4278255360, w = S >>> 16 | R & 4294901760, T = R << 16 | S & 65535;
              y[0] ^= S, y[1] ^= w, y[2] ^= R, y[3] ^= T, y[4] ^= S, y[5] ^= w, y[6] ^= R, y[7] ^= T;
              for (var E = 0; E < 4; E++)
                m.call(this);
            }
          },
          _doProcessBlock: function(g, h) {
            var A = this._X;
            m.call(this), a[0] = A[0] ^ A[5] >>> 16 ^ A[3] << 16, a[1] = A[2] ^ A[7] >>> 16 ^ A[5] << 16, a[2] = A[4] ^ A[1] >>> 16 ^ A[7] << 16, a[3] = A[6] ^ A[3] >>> 16 ^ A[1] << 16;
            for (var y = 0; y < 4; y++)
              a[y] = (a[y] << 8 | a[y] >>> 24) & 16711935 | (a[y] << 24 | a[y] >>> 8) & 4278255360, g[h + y] ^= a[y];
          },
          blockSize: 128 / 32,
          ivSize: 64 / 32
        });
        function m() {
          for (var g = this._X, h = this._C, A = 0; A < 8; A++)
            l[A] = h[A];
          h[0] = h[0] + 1295307597 + this._b | 0, h[1] = h[1] + 3545052371 + (h[0] >>> 0 < l[0] >>> 0 ? 1 : 0) | 0, h[2] = h[2] + 886263092 + (h[1] >>> 0 < l[1] >>> 0 ? 1 : 0) | 0, h[3] = h[3] + 1295307597 + (h[2] >>> 0 < l[2] >>> 0 ? 1 : 0) | 0, h[4] = h[4] + 3545052371 + (h[3] >>> 0 < l[3] >>> 0 ? 1 : 0) | 0, h[5] = h[5] + 886263092 + (h[4] >>> 0 < l[4] >>> 0 ? 1 : 0) | 0, h[6] = h[6] + 1295307597 + (h[5] >>> 0 < l[5] >>> 0 ? 1 : 0) | 0, h[7] = h[7] + 3545052371 + (h[6] >>> 0 < l[6] >>> 0 ? 1 : 0) | 0, this._b = h[7] >>> 0 < l[7] >>> 0 ? 1 : 0;
          for (var A = 0; A < 8; A++) {
            var y = g[A] + h[A], E = y & 65535, v = y >>> 16, C = ((E * E >>> 17) + E * v >>> 15) + v * v, x = ((y & 4294901760) * y | 0) + ((y & 65535) * y | 0);
            c[A] = C ^ x;
          }
          g[0] = c[0] + (c[7] << 16 | c[7] >>> 16) + (c[6] << 16 | c[6] >>> 16) | 0, g[1] = c[1] + (c[0] << 8 | c[0] >>> 24) + c[7] | 0, g[2] = c[2] + (c[1] << 16 | c[1] >>> 16) + (c[0] << 16 | c[0] >>> 16) | 0, g[3] = c[3] + (c[2] << 8 | c[2] >>> 24) + c[1] | 0, g[4] = c[4] + (c[3] << 16 | c[3] >>> 16) + (c[2] << 16 | c[2] >>> 16) | 0, g[5] = c[5] + (c[4] << 8 | c[4] >>> 24) + c[3] | 0, g[6] = c[6] + (c[5] << 16 | c[5] >>> 16) + (c[4] << 16 | c[4] >>> 16) | 0, g[7] = c[7] + (c[6] << 8 | c[6] >>> 24) + c[5] | 0;
        }
        r.RabbitLegacy = o._createHelper(u);
      }(), i.RabbitLegacy;
    });
  }(qv)), qv.exports;
}
var jv = { exports: {} }, XM;
function Axe() {
  return XM || (XM = 1, function(e, t) {
    (function(i, r, n) {
      e.exports = r(zt(), uu(), du(), Pl(), qr());
    })(yt, function(i) {
      return function() {
        var r = i, n = r.lib, o = n.BlockCipher, s = r.algo;
        const a = 16, l = [
          608135816,
          2242054355,
          320440878,
          57701188,
          2752067618,
          698298832,
          137296536,
          3964562569,
          1160258022,
          953160567,
          3193202383,
          887688300,
          3232508343,
          3380367581,
          1065670069,
          3041331479,
          2450970073,
          2306472731
        ], c = [
          [
            3509652390,
            2564797868,
            805139163,
            3491422135,
            3101798381,
            1780907670,
            3128725573,
            4046225305,
            614570311,
            3012652279,
            134345442,
            2240740374,
            1667834072,
            1901547113,
            2757295779,
            4103290238,
            227898511,
            1921955416,
            1904987480,
            2182433518,
            2069144605,
            3260701109,
            2620446009,
            720527379,
            3318853667,
            677414384,
            3393288472,
            3101374703,
            2390351024,
            1614419982,
            1822297739,
            2954791486,
            3608508353,
            3174124327,
            2024746970,
            1432378464,
            3864339955,
            2857741204,
            1464375394,
            1676153920,
            1439316330,
            715854006,
            3033291828,
            289532110,
            2706671279,
            2087905683,
            3018724369,
            1668267050,
            732546397,
            1947742710,
            3462151702,
            2609353502,
            2950085171,
            1814351708,
            2050118529,
            680887927,
            999245976,
            1800124847,
            3300911131,
            1713906067,
            1641548236,
            4213287313,
            1216130144,
            1575780402,
            4018429277,
            3917837745,
            3693486850,
            3949271944,
            596196993,
            3549867205,
            258830323,
            2213823033,
            772490370,
            2760122372,
            1774776394,
            2652871518,
            566650946,
            4142492826,
            1728879713,
            2882767088,
            1783734482,
            3629395816,
            2517608232,
            2874225571,
            1861159788,
            326777828,
            3124490320,
            2130389656,
            2716951837,
            967770486,
            1724537150,
            2185432712,
            2364442137,
            1164943284,
            2105845187,
            998989502,
            3765401048,
            2244026483,
            1075463327,
            1455516326,
            1322494562,
            910128902,
            469688178,
            1117454909,
            936433444,
            3490320968,
            3675253459,
            1240580251,
            122909385,
            2157517691,
            634681816,
            4142456567,
            3825094682,
            3061402683,
            2540495037,
            79693498,
            3249098678,
            1084186820,
            1583128258,
            426386531,
            1761308591,
            1047286709,
            322548459,
            995290223,
            1845252383,
            2603652396,
            3431023940,
            2942221577,
            3202600964,
            3727903485,
            1712269319,
            422464435,
            3234572375,
            1170764815,
            3523960633,
            3117677531,
            1434042557,
            442511882,
            3600875718,
            1076654713,
            1738483198,
            4213154764,
            2393238008,
            3677496056,
            1014306527,
            4251020053,
            793779912,
            2902807211,
            842905082,
            4246964064,
            1395751752,
            1040244610,
            2656851899,
            3396308128,
            445077038,
            3742853595,
            3577915638,
            679411651,
            2892444358,
            2354009459,
            1767581616,
            3150600392,
            3791627101,
            3102740896,
            284835224,
            4246832056,
            1258075500,
            768725851,
            2589189241,
            3069724005,
            3532540348,
            1274779536,
            3789419226,
            2764799539,
            1660621633,
            3471099624,
            4011903706,
            913787905,
            3497959166,
            737222580,
            2514213453,
            2928710040,
            3937242737,
            1804850592,
            3499020752,
            2949064160,
            2386320175,
            2390070455,
            2415321851,
            4061277028,
            2290661394,
            2416832540,
            1336762016,
            1754252060,
            3520065937,
            3014181293,
            791618072,
            3188594551,
            3933548030,
            2332172193,
            3852520463,
            3043980520,
            413987798,
            3465142937,
            3030929376,
            4245938359,
            2093235073,
            3534596313,
            375366246,
            2157278981,
            2479649556,
            555357303,
            3870105701,
            2008414854,
            3344188149,
            4221384143,
            3956125452,
            2067696032,
            3594591187,
            2921233993,
            2428461,
            544322398,
            577241275,
            1471733935,
            610547355,
            4027169054,
            1432588573,
            1507829418,
            2025931657,
            3646575487,
            545086370,
            48609733,
            2200306550,
            1653985193,
            298326376,
            1316178497,
            3007786442,
            2064951626,
            458293330,
            2589141269,
            3591329599,
            3164325604,
            727753846,
            2179363840,
            146436021,
            1461446943,
            4069977195,
            705550613,
            3059967265,
            3887724982,
            4281599278,
            3313849956,
            1404054877,
            2845806497,
            146425753,
            1854211946
          ],
          [
            1266315497,
            3048417604,
            3681880366,
            3289982499,
            290971e4,
            1235738493,
            2632868024,
            2414719590,
            3970600049,
            1771706367,
            1449415276,
            3266420449,
            422970021,
            1963543593,
            2690192192,
            3826793022,
            1062508698,
            1531092325,
            1804592342,
            2583117782,
            2714934279,
            4024971509,
            1294809318,
            4028980673,
            1289560198,
            2221992742,
            1669523910,
            35572830,
            157838143,
            1052438473,
            1016535060,
            1802137761,
            1753167236,
            1386275462,
            3080475397,
            2857371447,
            1040679964,
            2145300060,
            2390574316,
            1461121720,
            2956646967,
            4031777805,
            4028374788,
            33600511,
            2920084762,
            1018524850,
            629373528,
            3691585981,
            3515945977,
            2091462646,
            2486323059,
            586499841,
            988145025,
            935516892,
            3367335476,
            2599673255,
            2839830854,
            265290510,
            3972581182,
            2759138881,
            3795373465,
            1005194799,
            847297441,
            406762289,
            1314163512,
            1332590856,
            1866599683,
            4127851711,
            750260880,
            613907577,
            1450815602,
            3165620655,
            3734664991,
            3650291728,
            3012275730,
            3704569646,
            1427272223,
            778793252,
            1343938022,
            2676280711,
            2052605720,
            1946737175,
            3164576444,
            3914038668,
            3967478842,
            3682934266,
            1661551462,
            3294938066,
            4011595847,
            840292616,
            3712170807,
            616741398,
            312560963,
            711312465,
            1351876610,
            322626781,
            1910503582,
            271666773,
            2175563734,
            1594956187,
            70604529,
            3617834859,
            1007753275,
            1495573769,
            4069517037,
            2549218298,
            2663038764,
            504708206,
            2263041392,
            3941167025,
            2249088522,
            1514023603,
            1998579484,
            1312622330,
            694541497,
            2582060303,
            2151582166,
            1382467621,
            776784248,
            2618340202,
            3323268794,
            2497899128,
            2784771155,
            503983604,
            4076293799,
            907881277,
            423175695,
            432175456,
            1378068232,
            4145222326,
            3954048622,
            3938656102,
            3820766613,
            2793130115,
            2977904593,
            26017576,
            3274890735,
            3194772133,
            1700274565,
            1756076034,
            4006520079,
            3677328699,
            720338349,
            1533947780,
            354530856,
            688349552,
            3973924725,
            1637815568,
            332179504,
            3949051286,
            53804574,
            2852348879,
            3044236432,
            1282449977,
            3583942155,
            3416972820,
            4006381244,
            1617046695,
            2628476075,
            3002303598,
            1686838959,
            431878346,
            2686675385,
            1700445008,
            1080580658,
            1009431731,
            832498133,
            3223435511,
            2605976345,
            2271191193,
            2516031870,
            1648197032,
            4164389018,
            2548247927,
            300782431,
            375919233,
            238389289,
            3353747414,
            2531188641,
            2019080857,
            1475708069,
            455242339,
            2609103871,
            448939670,
            3451063019,
            1395535956,
            2413381860,
            1841049896,
            1491858159,
            885456874,
            4264095073,
            4001119347,
            1565136089,
            3898914787,
            1108368660,
            540939232,
            1173283510,
            2745871338,
            3681308437,
            4207628240,
            3343053890,
            4016749493,
            1699691293,
            1103962373,
            3625875870,
            2256883143,
            3830138730,
            1031889488,
            3479347698,
            1535977030,
            4236805024,
            3251091107,
            2132092099,
            1774941330,
            1199868427,
            1452454533,
            157007616,
            2904115357,
            342012276,
            595725824,
            1480756522,
            206960106,
            497939518,
            591360097,
            863170706,
            2375253569,
            3596610801,
            1814182875,
            2094937945,
            3421402208,
            1082520231,
            3463918190,
            2785509508,
            435703966,
            3908032597,
            1641649973,
            2842273706,
            3305899714,
            1510255612,
            2148256476,
            2655287854,
            3276092548,
            4258621189,
            236887753,
            3681803219,
            274041037,
            1734335097,
            3815195456,
            3317970021,
            1899903192,
            1026095262,
            4050517792,
            356393447,
            2410691914,
            3873677099,
            3682840055
          ],
          [
            3913112168,
            2491498743,
            4132185628,
            2489919796,
            1091903735,
            1979897079,
            3170134830,
            3567386728,
            3557303409,
            857797738,
            1136121015,
            1342202287,
            507115054,
            2535736646,
            337727348,
            3213592640,
            1301675037,
            2528481711,
            1895095763,
            1721773893,
            3216771564,
            62756741,
            2142006736,
            835421444,
            2531993523,
            1442658625,
            3659876326,
            2882144922,
            676362277,
            1392781812,
            170690266,
            3921047035,
            1759253602,
            3611846912,
            1745797284,
            664899054,
            1329594018,
            3901205900,
            3045908486,
            2062866102,
            2865634940,
            3543621612,
            3464012697,
            1080764994,
            553557557,
            3656615353,
            3996768171,
            991055499,
            499776247,
            1265440854,
            648242737,
            3940784050,
            980351604,
            3713745714,
            1749149687,
            3396870395,
            4211799374,
            3640570775,
            1161844396,
            3125318951,
            1431517754,
            545492359,
            4268468663,
            3499529547,
            1437099964,
            2702547544,
            3433638243,
            2581715763,
            2787789398,
            1060185593,
            1593081372,
            2418618748,
            4260947970,
            69676912,
            2159744348,
            86519011,
            2512459080,
            3838209314,
            1220612927,
            3339683548,
            133810670,
            1090789135,
            1078426020,
            1569222167,
            845107691,
            3583754449,
            4072456591,
            1091646820,
            628848692,
            1613405280,
            3757631651,
            526609435,
            236106946,
            48312990,
            2942717905,
            3402727701,
            1797494240,
            859738849,
            992217954,
            4005476642,
            2243076622,
            3870952857,
            3732016268,
            765654824,
            3490871365,
            2511836413,
            1685915746,
            3888969200,
            1414112111,
            2273134842,
            3281911079,
            4080962846,
            172450625,
            2569994100,
            980381355,
            4109958455,
            2819808352,
            2716589560,
            2568741196,
            3681446669,
            3329971472,
            1835478071,
            660984891,
            3704678404,
            4045999559,
            3422617507,
            3040415634,
            1762651403,
            1719377915,
            3470491036,
            2693910283,
            3642056355,
            3138596744,
            1364962596,
            2073328063,
            1983633131,
            926494387,
            3423689081,
            2150032023,
            4096667949,
            1749200295,
            3328846651,
            309677260,
            2016342300,
            1779581495,
            3079819751,
            111262694,
            1274766160,
            443224088,
            298511866,
            1025883608,
            3806446537,
            1145181785,
            168956806,
            3641502830,
            3584813610,
            1689216846,
            3666258015,
            3200248200,
            1692713982,
            2646376535,
            4042768518,
            1618508792,
            1610833997,
            3523052358,
            4130873264,
            2001055236,
            3610705100,
            2202168115,
            4028541809,
            2961195399,
            1006657119,
            2006996926,
            3186142756,
            1430667929,
            3210227297,
            1314452623,
            4074634658,
            4101304120,
            2273951170,
            1399257539,
            3367210612,
            3027628629,
            1190975929,
            2062231137,
            2333990788,
            2221543033,
            2438960610,
            1181637006,
            548689776,
            2362791313,
            3372408396,
            3104550113,
            3145860560,
            296247880,
            1970579870,
            3078560182,
            3769228297,
            1714227617,
            3291629107,
            3898220290,
            166772364,
            1251581989,
            493813264,
            448347421,
            195405023,
            2709975567,
            677966185,
            3703036547,
            1463355134,
            2715995803,
            1338867538,
            1343315457,
            2802222074,
            2684532164,
            233230375,
            2599980071,
            2000651841,
            3277868038,
            1638401717,
            4028070440,
            3237316320,
            6314154,
            819756386,
            300326615,
            590932579,
            1405279636,
            3267499572,
            3150704214,
            2428286686,
            3959192993,
            3461946742,
            1862657033,
            1266418056,
            963775037,
            2089974820,
            2263052895,
            1917689273,
            448879540,
            3550394620,
            3981727096,
            150775221,
            3627908307,
            1303187396,
            508620638,
            2975983352,
            2726630617,
            1817252668,
            1876281319,
            1457606340,
            908771278,
            3720792119,
            3617206836,
            2455994898,
            1729034894,
            1080033504
          ],
          [
            976866871,
            3556439503,
            2881648439,
            1522871579,
            1555064734,
            1336096578,
            3548522304,
            2579274686,
            3574697629,
            3205460757,
            3593280638,
            3338716283,
            3079412587,
            564236357,
            2993598910,
            1781952180,
            1464380207,
            3163844217,
            3332601554,
            1699332808,
            1393555694,
            1183702653,
            3581086237,
            1288719814,
            691649499,
            2847557200,
            2895455976,
            3193889540,
            2717570544,
            1781354906,
            1676643554,
            2592534050,
            3230253752,
            1126444790,
            2770207658,
            2633158820,
            2210423226,
            2615765581,
            2414155088,
            3127139286,
            673620729,
            2805611233,
            1269405062,
            4015350505,
            3341807571,
            4149409754,
            1057255273,
            2012875353,
            2162469141,
            2276492801,
            2601117357,
            993977747,
            3918593370,
            2654263191,
            753973209,
            36408145,
            2530585658,
            25011837,
            3520020182,
            2088578344,
            530523599,
            2918365339,
            1524020338,
            1518925132,
            3760827505,
            3759777254,
            1202760957,
            3985898139,
            3906192525,
            674977740,
            4174734889,
            2031300136,
            2019492241,
            3983892565,
            4153806404,
            3822280332,
            352677332,
            2297720250,
            60907813,
            90501309,
            3286998549,
            1016092578,
            2535922412,
            2839152426,
            457141659,
            509813237,
            4120667899,
            652014361,
            1966332200,
            2975202805,
            55981186,
            2327461051,
            676427537,
            3255491064,
            2882294119,
            3433927263,
            1307055953,
            942726286,
            933058658,
            2468411793,
            3933900994,
            4215176142,
            1361170020,
            2001714738,
            2830558078,
            3274259782,
            1222529897,
            1679025792,
            2729314320,
            3714953764,
            1770335741,
            151462246,
            3013232138,
            1682292957,
            1483529935,
            471910574,
            1539241949,
            458788160,
            3436315007,
            1807016891,
            3718408830,
            978976581,
            1043663428,
            3165965781,
            1927990952,
            4200891579,
            2372276910,
            3208408903,
            3533431907,
            1412390302,
            2931980059,
            4132332400,
            1947078029,
            3881505623,
            4168226417,
            2941484381,
            1077988104,
            1320477388,
            886195818,
            18198404,
            3786409e3,
            2509781533,
            112762804,
            3463356488,
            1866414978,
            891333506,
            18488651,
            661792760,
            1628790961,
            3885187036,
            3141171499,
            876946877,
            2693282273,
            1372485963,
            791857591,
            2686433993,
            3759982718,
            3167212022,
            3472953795,
            2716379847,
            445679433,
            3561995674,
            3504004811,
            3574258232,
            54117162,
            3331405415,
            2381918588,
            3769707343,
            4154350007,
            1140177722,
            4074052095,
            668550556,
            3214352940,
            367459370,
            261225585,
            2610173221,
            4209349473,
            3468074219,
            3265815641,
            314222801,
            3066103646,
            3808782860,
            282218597,
            3406013506,
            3773591054,
            379116347,
            1285071038,
            846784868,
            2669647154,
            3771962079,
            3550491691,
            2305946142,
            453669953,
            1268987020,
            3317592352,
            3279303384,
            3744833421,
            2610507566,
            3859509063,
            266596637,
            3847019092,
            517658769,
            3462560207,
            3443424879,
            370717030,
            4247526661,
            2224018117,
            4143653529,
            4112773975,
            2788324899,
            2477274417,
            1456262402,
            2901442914,
            1517677493,
            1846949527,
            2295493580,
            3734397586,
            2176403920,
            1280348187,
            1908823572,
            3871786941,
            846861322,
            1172426758,
            3287448474,
            3383383037,
            1655181056,
            3139813346,
            901632758,
            1897031941,
            2986607138,
            3066810236,
            3447102507,
            1393639104,
            373351379,
            950779232,
            625454576,
            3124240540,
            4148612726,
            2007998917,
            544563296,
            2244738638,
            2330496472,
            2058025392,
            1291430526,
            424198748,
            50039436,
            29584100,
            3605783033,
            2429876329,
            2791104160,
            1057563949,
            3255363231,
            3075367218,
            3463963227,
            1469046755,
            985887462
          ]
        ];
        var u = {
          pbox: [],
          sbox: []
        };
        function m(E, v) {
          let C = v >> 24 & 255, x = v >> 16 & 255, S = v >> 8 & 255, R = v & 255, w = E.sbox[0][C] + E.sbox[1][x];
          return w = w ^ E.sbox[2][S], w = w + E.sbox[3][R], w;
        }
        function g(E, v, C) {
          let x = v, S = C, R;
          for (let w = 0; w < a; ++w)
            x = x ^ E.pbox[w], S = m(E, x) ^ S, R = x, x = S, S = R;
          return R = x, x = S, S = R, S = S ^ E.pbox[a], x = x ^ E.pbox[a + 1], { left: x, right: S };
        }
        function h(E, v, C) {
          let x = v, S = C, R;
          for (let w = a + 1; w > 1; --w)
            x = x ^ E.pbox[w], S = m(E, x) ^ S, R = x, x = S, S = R;
          return R = x, x = S, S = R, S = S ^ E.pbox[1], x = x ^ E.pbox[0], { left: x, right: S };
        }
        function A(E, v, C) {
          for (let T = 0; T < 4; T++) {
            E.sbox[T] = [];
            for (let N = 0; N < 256; N++)
              E.sbox[T][N] = c[T][N];
          }
          let x = 0;
          for (let T = 0; T < a + 2; T++)
            E.pbox[T] = l[T] ^ v[x], x++, x >= C && (x = 0);
          let S = 0, R = 0, w = 0;
          for (let T = 0; T < a + 2; T += 2)
            w = g(E, S, R), S = w.left, R = w.right, E.pbox[T] = S, E.pbox[T + 1] = R;
          for (let T = 0; T < 4; T++)
            for (let N = 0; N < 256; N += 2)
              w = g(E, S, R), S = w.left, R = w.right, E.sbox[T][N] = S, E.sbox[T][N + 1] = R;
          return !0;
        }
        var y = s.Blowfish = o.extend({
          _doReset: function() {
            if (this._keyPriorReset !== this._key) {
              var E = this._keyPriorReset = this._key, v = E.words, C = E.sigBytes / 4;
              A(u, v, C);
            }
          },
          encryptBlock: function(E, v) {
            var C = g(u, E[v], E[v + 1]);
            E[v] = C.left, E[v + 1] = C.right;
          },
          decryptBlock: function(E, v) {
            var C = h(u, E[v], E[v + 1]);
            E[v] = C.left, E[v + 1] = C.right;
          },
          blockSize: 64 / 32,
          keySize: 128 / 32,
          ivSize: 64 / 32
        });
        r.Blowfish = o._createHelper(y);
      }(), i.Blowfish;
    });
  }(jv)), jv.exports;
}
(function(e, t) {
  (function(i, r, n) {
    e.exports = r(zt(), Hf(), J2e(), P2e(), uu(), z2e(), du(), OV(), kI(), H2e(), FV(), X2e(), _2e(), $2e(), wI(), exe(), Pl(), qr(), txe(), ixe(), rxe(), nxe(), oxe(), sxe(), axe(), lxe(), cxe(), uxe(), dxe(), mxe(), gxe(), hxe(), pxe(), fxe(), Axe());
  })(yt, function(i) {
    return i;
  });
})(DV);
var _M = DV.exports;
const yxe = "_img_ra1fy_1", Exe = {
  img: yxe
}, vxe = (e) => _M.SHA256(e).toString(_M.enc.Hex);
function zBe(o) {
  var s = o, { email: e, className: t, fallback: i = "retro", alt: r } = s, n = Fe(s, ["email", "className", "fallback", "alt"]);
  const l = `https://secure.gravatar.com/avatar/${vxe(e.toLowerCase().trim())}?d=${i}`;
  return /* @__PURE__ */ f("img", q({ className: me(Exe.img, t), src: l, alt: r || "profile picture" }, n));
}
const bxe = "_collapsible_g1w1g_1", Cxe = "_head_g1w1g_8", xxe = "_header_g1w1g_17", Ixe = "_button_g1w1g_25", Sxe = "_img_g1w1g_36", Rxe = "_active_g1w1g_39", kxe = "_body_g1w1g_52", mc = {
  collapsible: bxe,
  head: Cxe,
  header: xxe,
  button: Ixe,
  img: Sxe,
  active: Rxe,
  body: kxe
};
function HBe(o) {
  var s = o, {
    title: e,
    className: t,
    children: i,
    isActive: r = !1
  } = s, n = Fe(s, [
    "title",
    "className",
    "children",
    "isActive"
  ]);
  const { assetPath: a } = fi(), [l, c] = se(r);
  return /* @__PURE__ */ V("div", ee(q({ className: me(mc.collapsible, t) }, n), { children: [
    /* @__PURE__ */ V(
      "div",
      {
        className: mc.head,
        onClick: () => {
          c(!l);
        },
        children: [
          typeof e == "string" ? /* @__PURE__ */ f("h2", { className: mc.header, children: e }) : e,
          /* @__PURE__ */ f("button", { className: mc.button, children: /* @__PURE__ */ f(
            "img",
            {
              className: me(mc.img, l ? mc.active : ""),
              style: { width: "16px", height: "9px" },
              src: `${a}/images/blue-arrow-down.svg`
            }
          ) })
        ]
      }
    ),
    /* @__PURE__ */ f("div", { className: mc.body, style: { display: l ? "block" : "none" }, children: i })
  ] }));
}
function wxe(n, r) {
  var o = n, { fallback: e, src: t } = o, i = Fe(o, ["fallback", "src"]);
  const [s, a] = se(t);
  return /* @__PURE__ */ f("img", q({ ref: r, src: s || e, onError: () => a(e) }, i));
}
const XBe = T0(wxe), Mxe = "_marquee_1hz0e_1", Nxe = "_content_1hz0e_16", Rp = {
  marquee: Mxe,
  content: Nxe,
  "marquee-slide": "_marquee-slide_1hz0e_1"
};
function _Be(l) {
  var c = l, {
    duration: e,
    children: t,
    style: i,
    className: r,
    innerClassName: n,
    stopOnGrab: o = !0,
    resumeOnRelease: s = !1
  } = c, a = Fe(c, [
    "duration",
    "children",
    "style",
    "className",
    "innerClassName",
    "stopOnGrab",
    "resumeOnRelease"
  ]);
  const [u, m] = se(null), [g, h] = se(!1);
  return /* @__PURE__ */ V(
    "div",
    ee(q({
      style: q({
        "--maxroll-marquee-length": `${u == null ? void 0 : u.clientWidth}px`,
        "--maxroll-marquee-duration": `${e}ms`
      }, i),
      className: me(Rp.marquee, r),
      onTouchStart: o ? () => {
        h(!0);
      } : void 0,
      onTouchEnd: s ? () => {
        h(!1);
      } : void 0
    }, a), {
      children: [
        /* @__PURE__ */ f(
          "div",
          {
            ref: m,
            className: me(Rp.content, n),
            style: { animationPlayState: g ? "paused" : "running" },
            children: t
          }
        ),
        /* @__PURE__ */ f("div", { className: me(Rp.content, n), children: t }),
        /* @__PURE__ */ f("div", { className: me(Rp.content, n), children: t })
      ]
    })
  );
}
const Txe = "_scrollDrag_1t7ax_1", Bxe = {
  scrollDrag: Txe
}, VV = T0(
  ({
    content: e,
    active: t = !0,
    className: i
  }, r) => {
    const n = X.createRef(), [o, s] = se({
      isScrolling: !1,
      clientX: 0,
      scrollX: 0
    }), a = (u) => {
      u.preventDefault(), n.current && (n.current.style.cursor = "grabbing"), s(ee(q({}, o), { isScrolling: !0, clientX: u.clientX }));
    }, l = () => {
      n.current && (n.current.style.cursor = "grab"), s(ee(q({}, o), { isScrolling: !1 }));
    }, c = (u) => {
      o.isScrolling && n.current && (o.scrollX += u.clientX - o.clientX, o.clientX = u.clientX, n.current.scrollLeft = o.scrollX);
    };
    return TW(r, () => ({
      onManualScroll(u) {
        if (n.current) {
          var m = n.current.scrollWidth - n.current.clientWidth;
          o.scrollX = Math.min(Math.max(0, o.scrollX + u), m), n.current.scrollLeft = o.scrollX;
        }
      }
    })), t ? /* @__PURE__ */ f(
      "div",
      {
        ref: n,
        onMouseDown: a,
        onMouseUp: l,
        onMouseMove: c,
        className: me(Bxe.scrollDrag, i),
        children: e
      }
    ) : e;
  }
);
VV.displayName = "ScrollDrag";
const Dxe = VV, Oxe = "_tabsBox_67wda_1", Fxe = "_headers_67wda_5", Vxe = "_content_67wda_9", kp = {
  tabsBox: Oxe,
  headers: Fxe,
  content: Vxe
};
function $Be(a) {
  var l = a, {
    tabs: e,
    sideTabs: t,
    initialTab: i,
    headerSpacing: r,
    onTabClick: n,
    className: o
  } = l, s = Fe(l, [
    "tabs",
    "sideTabs",
    "initialTab",
    "headerSpacing",
    "onTabClick",
    "className"
  ]);
  return /* @__PURE__ */ f("div", ee(q({ className: me(kp.tabsBox, o) }, s), { children: /* @__PURE__ */ f(
    eI,
    {
      headersClassName: kp.headers,
      tabs: e.map((c) => ee(q({}, c), { content: /* @__PURE__ */ f("div", { className: kp.content, children: c.content }) })),
      sideTabs: t == null ? void 0 : t.map((c) => ee(q({}, c), { content: /* @__PURE__ */ f("div", { className: kp.content, children: c.content }) })),
      initialTab: i,
      headerSpacing: r,
      onTabClick: n
    }
  ) }));
}
const qxe = "_scrollBar_crjkt_1", jxe = "_scrollBarInner_crjkt_5", Lxe = "_scrollTrack_crjkt_9", Kxe = "_scrollBarThumbWrapper_crjkt_17", Yxe = "_scrollBarThumbPivot_crjkt_25", Uxe = "_scrollBarThumb_crjkt_17", Yu = {
  scrollBar: qxe,
  scrollBarInner: jxe,
  scrollTrack: Lxe,
  scrollBarThumbWrapper: Kxe,
  scrollBarThumbPivot: Yxe,
  scrollBarThumb: Uxe
};
function Gxe(o) {
  var s = o, { itemsCount: e, activeItemIndex: t, setItem: i, className: r } = s, n = Fe(s, ["itemsCount", "activeItemIndex", "setItem", "className"]);
  const a = Ne(null), l = Ne(null), c = we(
    () => e < 2 ? 0 : t / (e - 1) * 100,
    [t, e]
  ), [u, m] = se(0), [g, h] = se(!1), A = ye((C) => C.preventDefault(), []), y = ye(
    (C) => {
      m(l.current.getBoundingClientRect().x - C.clientX), h(!0);
    },
    [m, h]
  ), E = ye(
    (C) => {
      h(!1);
    },
    [h]
  ), v = ye(
    (C) => {
      if (!g || !a.current)
        return;
      const x = a.current.getBoundingClientRect();
      if (x.width == 0)
        return;
      const S = u + C.clientX - x.x, R = Math.min(Math.max(S, 0) / x.width, 1), w = Math.round((e - 1) * R);
      i(w);
    },
    [g, u, e]
  );
  return be(() => (document.addEventListener("pointermove", v), document.addEventListener("pointerup", E), () => {
    document.removeEventListener("pointermove", v), document.removeEventListener("pointerup", E);
  }), [v, E]), e > 2 ? /* @__PURE__ */ f("div", ee(q({ className: me(Yu.scrollBar, r), role: "scrollbar" }, n), { children: /* @__PURE__ */ V("div", { className: Yu.scrollBarInner, children: [
    /* @__PURE__ */ f("div", { style: { cursor: g ? "grabbing" : void 0 }, className: Yu.scrollTrack }),
    /* @__PURE__ */ f("div", { ref: a, className: Yu.scrollBarThumbWrapper, children: /* @__PURE__ */ f(
      "div",
      {
        ref: l,
        style: { left: `${c}%`, cursor: g ? "grabbing" : "grab" },
        className: Yu.scrollBarThumbPivot,
        onPointerDown: y,
        onDragStart: A,
        children: /* @__PURE__ */ f("div", { className: Yu.scrollBarThumb })
      }
    ) })
  ] }) })) : null;
}
const Qxe = "_tabsV2_t39ri_1", Wxe = "_scrollBox_t39ri_2", Zxe = "_headersWrapper_t39ri_7", Jxe = "_headersInner_t39ri_15", Pxe = "_headers_t39ri_7", zxe = "_header_t39ri_7", Hxe = "_headerText_t39ri_39", Xxe = "_headerActive_t39ri_46", _xe = "_headerInactive_t39ri_55", $xe = "_scrollBarSection_t39ri_85", eIe = "_container_t39ri_90", tIe = "_tab_t39ri_1", iIe = "_visible_t39ri_97", Vn = {
  tabsV2: Qxe,
  scrollBox: Wxe,
  headersWrapper: Zxe,
  headersInner: Jxe,
  headers: Pxe,
  header: zxe,
  headerText: Hxe,
  headerActive: Xxe,
  headerInactive: _xe,
  "justify-between": "_justify-between_t39ri_59",
  "equal-spacing": "_equal-spacing_t39ri_67",
  scrollBarSection: $xe,
  container: eIe,
  tab: tIe,
  visible: iIe
}, rIe = {
  type: "left",
  leftOffset: 80,
  disableMobileAnimation: !0
}, nIe = {
  type: "fixed",
  value: 4
};
function $M({
  scrollOnTabChange: e,
  elem: t,
  parent: i
}) {
  if (e && t) {
    const { type: r, leftOffset: n, topOffset: o } = e, s = i.children[0], a = t.getBoundingClientRect(), l = s.getBoundingClientRect();
    let c = a.left - l.left;
    r === "center" && (c = c - (l.width - a.width) / 2), c -= n || 0;
    const u = s.clientWidth - i.clientWidth;
    if (c = Math.max(Math.min(c, u), 0), s.style.marginLeft = `-${c}px`, o !== void 0) {
      const m = a.top + window.scrollY;
      window.scrollTo({
        top: m - (o || 0),
        behavior: "smooth"
      });
    }
  }
}
function e7e({
  tabs: e,
  sideTabs: t,
  initialTab: i = 0,
  headerSpacing: r = nIe,
  onTabClick: n = void 0,
  scrollOnTabChange: o = rIe,
  headersClassName: s,
  containerClassName: a
}) {
  const [l, c] = se(i), u = Ne({}), m = Ne(null);
  be(() => {
    c(i);
  }, [i]);
  const g = ye(
    (E) => {
      c((v) => {
        const C = E >= e.length ? t == null ? void 0 : t[E - e.length] : e[E];
        return C != null && C.onTabClick && C.onTabClick(E), n && n(E), v !== E && $M({
          scrollOnTabChange: o,
          elem: u.current[E],
          parent: m.current
        }), E;
      });
    },
    [n, e, t, o, $M]
  ), h = Age(m), A = we(() => e.length + ((t == null ? void 0 : t.length) || 0), [e, t]), y = we(() => [e, t], [e, t]);
  return be(() => {
    const E = m.current.children[0];
    E.style.marginLeft = "0px";
  }, [h]), /* @__PURE__ */ V("div", { className: Vn.tabsV2, children: [
    /* @__PURE__ */ f("div", { className: me(Vn.scrollBox, s), children: /* @__PURE__ */ f("div", { ref: m, className: Vn.headersWrapper, children: /* @__PURE__ */ f("div", { className: Vn.headersInner, style: { gap: r.value }, children: y.map(
      (E, v) => E ? /* @__PURE__ */ f(
        "div",
        {
          style: { gap: r.value },
          className: me(Vn.headers, Vn[r.type]),
          children: E.map((C, x) => {
            const S = x + v * e.length, R = S === l;
            return /* @__PURE__ */ f(
              "div",
              {
                ref: (w) => {
                  w && (u.current[S] = w);
                },
                className: me(Vn.header, R ? Vn.headerActive : Vn.headerInactive),
                onClick: () => {
                  g(S);
                },
                children: /* @__PURE__ */ f("span", { className: me(Vn.headerText), children: /* @__PURE__ */ f(eF, { selector: C.selector, isActive: R }) })
              },
              S
            );
          })
        },
        v
      ) : null
    ) }) }) }),
    h ? /* @__PURE__ */ f(
      Gxe,
      {
        className: Vn.scrollBarSection,
        itemsCount: A,
        activeItemIndex: l,
        setItem: g
      }
    ) : null,
    /* @__PURE__ */ f("div", { className: me(Vn.container, a), children: y.map(
      (E, v) => E ? E.map((C, x) => {
        const S = x + v * e.length;
        return /* @__PURE__ */ f(
          "div",
          {
            className: me(Vn.tab, S === l ? Vn.visible : void 0),
            children: C.content
          },
          S
        );
      }) : null
    ) })
  ] });
}
const oIe = "_TitleV2_rpk9w_1", sIe = "_TitleV2__top_rpk9w_6", aIe = "_TitleV2__topLeft_rpk9w_19", lIe = "_TitleV2__heading_rpk9w_26", cIe = "_TitleV2__bottom_rpk9w_50", uIe = "_TitleV2__bottomText_rpk9w_56", dIe = "_TitleV2__bottomLine_rpk9w_64", sl = {
  TitleV2: oIe,
  TitleV2__top: sIe,
  TitleV2__topLeft: aIe,
  TitleV2__heading: lIe,
  "TitleV2__heading--h2": "_TitleV2__heading--h2_rpk9w_34",
  "TitleV2__heading--h3": "_TitleV2__heading--h3_rpk9w_37",
  "TitleV2__heading--h4": "_TitleV2__heading--h4_rpk9w_40",
  "TitleV2__heading--h5": "_TitleV2__heading--h5_rpk9w_43",
  "TitleV2__heading--h6": "_TitleV2__heading--h6_rpk9w_46",
  TitleV2__bottom: cIe,
  TitleV2__bottomText: uIe,
  TitleV2__bottomLine: dIe
};
function mIe(a) {
  var l = a, {
    title: e,
    titleStart: t,
    titleEnd: i,
    subTitle: r,
    headingLevel: n = 2,
    className: o
  } = l, s = Fe(l, [
    "title",
    "titleStart",
    "titleEnd",
    "subTitle",
    "headingLevel",
    "className"
  ]);
  const c = we(() => n === void 0 ? "h2" : `h${Ut.clamp(n, 1, 6)}`, [n]);
  return /* @__PURE__ */ V("div", ee(q({ className: me(sl.TitleV2, o) }, s), { children: [
    /* @__PURE__ */ V("div", { className: sl.TitleV2__top, children: [
      /* @__PURE__ */ V("div", { className: sl.TitleV2__topLeft, children: [
        t ? /* @__PURE__ */ f("span", { children: t }) : null,
        Ei(c, {
          className: me(sl.TitleV2__heading, sl[`TitleV2__heading--${c}`]),
          id: XT(`${e}-header`),
          children: e
        })
      ] }),
      i ? /* @__PURE__ */ f("span", { children: i }) : null
    ] }),
    /* @__PURE__ */ V("div", { className: sl.TitleV2__bottom, children: [
      r ? /* @__PURE__ */ f("span", { className: sl.TitleV2__bottomText, children: r }) : null,
      /* @__PURE__ */ f("span", { className: sl.TitleV2__bottomLine })
    ] })
  ] }));
}
const gIe = "_titleLinks_gy7rw_1", hIe = "_list_gy7rw_6", pIe = "_item_gy7rw_15", fIe = "_disabled_gy7rw_23", AIe = "_active_gy7rw_27", yIe = "_bar_gy7rw_38", vc = {
  titleLinks: gIe,
  list: hIe,
  item: pIe,
  disabled: fIe,
  active: AIe,
  default: "_default_gy7rw_30",
  bar: yIe
};
function eN({ link: e }) {
  return /* @__PURE__ */ V(
    "li",
    {
      className: me(
        vc.item,
        e.disabled ? vc.disabled : e.active ? vc.active : vc.default
      ),
      onClick: e.disabled ? void 0 : e.onClick,
      children: [
        e.label,
        e.active && /* @__PURE__ */ f("span", { className: vc.bar })
      ]
    }
  );
}
function t7e({ links: e, customGap: t, showAll: i = !0, onClear: r = () => {
} }) {
  const n = we(() => {
    for (const o of e)
      if (o.active === !0)
        return !1;
    return !0;
  }, [e]);
  return e !== void 0 && e.length > 0 ? /* @__PURE__ */ f("div", { className: vc.titleLinks, children: /* @__PURE__ */ V("ul", { style: { gap: t ? `${t}px` : void 0 }, className: vc.list, children: [
    i && /* @__PURE__ */ f(eN, { link: { label: "All", active: n, onClick: r } }),
    e.map((o, s) => /* @__PURE__ */ f(eN, { link: o }, s))
  ] }) }) : null;
}
const EIe = "_titleLinks2_1y1ts_1", vIe = "_list_1y1ts_6", bIe = "_item_1y1ts_15", CIe = "_disabled_1y1ts_24", xIe = "_active_1y1ts_28", IIe = "_titleLinks_1y1ts_1", _u = {
  titleLinks2: EIe,
  list: vIe,
  item: bIe,
  disabled: CIe,
  active: xIe,
  default: "_default_1y1ts_33",
  titleLinks: IIe
};
function tN({ link: e, highlightStyle: t }) {
  return /* @__PURE__ */ f(
    "li",
    {
      style: e.active && t ? t : void 0,
      className: me(
        _u.item,
        e.disabled ? _u.disabled : e.active ? _u.active : _u.default
      ),
      onClick: e.disabled ? void 0 : e.onClick,
      children: e.label
    }
  );
}
function SIe({
  links: e,
  highlightStyle: t,
  customGap: i,
  showAll: r = !0,
  onClear: n = () => {
  }
}) {
  const o = we(() => {
    for (const s of e)
      if (s.active === !0)
        return !1;
    return !0;
  }, [e]);
  return e !== void 0 && e.length > 0 ? /* @__PURE__ */ f("div", { className: _u.titleLinks2, children: /* @__PURE__ */ V("ul", { style: { gap: i ? `${i}px` : void 0 }, className: _u.list, children: [
    r && /* @__PURE__ */ f(tN, { link: { label: "All", active: o, onClick: n }, highlightStyle: t }),
    e.map((s, a) => /* @__PURE__ */ f(tN, { link: s, highlightStyle: t }, a))
  ] }) }) : null;
}
var qV = { exports: {} };
(function(e, t) {
  (function(i, r) {
    e.exports = r();
  })(yt, function() {
    var i = 1e3, r = 6e4, n = 36e5, o = "millisecond", s = "second", a = "minute", l = "hour", c = "day", u = "week", m = "month", g = "quarter", h = "year", A = "date", y = "Invalid Date", E = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, v = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, C = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(z) {
      var W = ["th", "st", "nd", "rd"], H = z % 100;
      return "[" + z + (W[(H - 20) % 10] || W[H] || W[0]) + "]";
    } }, x = function(z, W, H) {
      var Q = String(z);
      return !Q || Q.length >= W ? z : "" + Array(W + 1 - Q.length).join(H) + z;
    }, S = { s: x, z: function(z) {
      var W = -z.utcOffset(), H = Math.abs(W), Q = Math.floor(H / 60), $ = H % 60;
      return (W <= 0 ? "+" : "-") + x(Q, 2, "0") + ":" + x($, 2, "0");
    }, m: function z(W, H) {
      if (W.date() < H.date())
        return -z(H, W);
      var Q = 12 * (H.year() - W.year()) + (H.month() - W.month()), $ = W.clone().add(Q, m), le = H - $ < 0, he = W.clone().add(Q + (le ? -1 : 1), m);
      return +(-(Q + (H - $) / (le ? $ - he : he - $)) || 0);
    }, a: function(z) {
      return z < 0 ? Math.ceil(z) || 0 : Math.floor(z);
    }, p: function(z) {
      return { M: m, y: h, w: u, d: c, D: A, h: l, m: a, s, ms: o, Q: g }[z] || String(z || "").toLowerCase().replace(/s$/, "");
    }, u: function(z) {
      return z === void 0;
    } }, R = "en", w = {};
    w[R] = C;
    var T = "$isDayjsObject", N = function(z) {
      return z instanceof Y || !(!z || !z[T]);
    }, D = function z(W, H, Q) {
      var $;
      if (!W)
        return R;
      if (typeof W == "string") {
        var le = W.toLowerCase();
        w[le] && ($ = le), H && (w[le] = H, $ = le);
        var he = W.split("-");
        if (!$ && he.length > 1)
          return z(he[0]);
      } else {
        var oe = W.name;
        w[oe] = W, $ = oe;
      }
      return !Q && $ && (R = $), $ || !Q && R;
    }, O = function(z, W) {
      if (N(z))
        return z.clone();
      var H = typeof W == "object" ? W : {};
      return H.date = z, H.args = arguments, new Y(H);
    }, F = S;
    F.l = D, F.i = N, F.w = function(z, W) {
      return O(z, { locale: W.$L, utc: W.$u, x: W.$x, $offset: W.$offset });
    };
    var Y = function() {
      function z(H) {
        this.$L = D(H.locale, null, !0), this.parse(H), this.$x = this.$x || H.x || {}, this[T] = !0;
      }
      var W = z.prototype;
      return W.parse = function(H) {
        this.$d = function(Q) {
          var $ = Q.date, le = Q.utc;
          if ($ === null)
            return /* @__PURE__ */ new Date(NaN);
          if (F.u($))
            return /* @__PURE__ */ new Date();
          if ($ instanceof Date)
            return new Date($);
          if (typeof $ == "string" && !/Z$/i.test($)) {
            var he = $.match(E);
            if (he) {
              var oe = he[2] - 1 || 0, ue = (he[7] || "0").substring(0, 3);
              return le ? new Date(Date.UTC(he[1], oe, he[3] || 1, he[4] || 0, he[5] || 0, he[6] || 0, ue)) : new Date(he[1], oe, he[3] || 1, he[4] || 0, he[5] || 0, he[6] || 0, ue);
            }
          }
          return new Date($);
        }(H), this.init();
      }, W.init = function() {
        var H = this.$d;
        this.$y = H.getFullYear(), this.$M = H.getMonth(), this.$D = H.getDate(), this.$W = H.getDay(), this.$H = H.getHours(), this.$m = H.getMinutes(), this.$s = H.getSeconds(), this.$ms = H.getMilliseconds();
      }, W.$utils = function() {
        return F;
      }, W.isValid = function() {
        return this.$d.toString() !== y;
      }, W.isSame = function(H, Q) {
        var $ = O(H);
        return this.startOf(Q) <= $ && $ <= this.endOf(Q);
      }, W.isAfter = function(H, Q) {
        return O(H) < this.startOf(Q);
      }, W.isBefore = function(H, Q) {
        return this.endOf(Q) < O(H);
      }, W.$g = function(H, Q, $) {
        return F.u(H) ? this[Q] : this.set($, H);
      }, W.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, W.valueOf = function() {
        return this.$d.getTime();
      }, W.startOf = function(H, Q) {
        var $ = this, le = !!F.u(Q) || Q, he = F.p(H), oe = function(Xe, Qe) {
          var Pe = F.w($.$u ? Date.UTC($.$y, Qe, Xe) : new Date($.$y, Qe, Xe), $);
          return le ? Pe : Pe.endOf(c);
        }, ue = function(Xe, Qe) {
          return F.w($.toDate()[Xe].apply($.toDate("s"), (le ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(Qe)), $);
        }, Ae = this.$W, de = this.$M, fe = this.$D, Re = "set" + (this.$u ? "UTC" : "");
        switch (he) {
          case h:
            return le ? oe(1, 0) : oe(31, 11);
          case m:
            return le ? oe(1, de) : oe(0, de + 1);
          case u:
            var qe = this.$locale().weekStart || 0, Oe = (Ae < qe ? Ae + 7 : Ae) - qe;
            return oe(le ? fe - Oe : fe + (6 - Oe), de);
          case c:
          case A:
            return ue(Re + "Hours", 0);
          case l:
            return ue(Re + "Minutes", 1);
          case a:
            return ue(Re + "Seconds", 2);
          case s:
            return ue(Re + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, W.endOf = function(H) {
        return this.startOf(H, !1);
      }, W.$set = function(H, Q) {
        var $, le = F.p(H), he = "set" + (this.$u ? "UTC" : ""), oe = ($ = {}, $[c] = he + "Date", $[A] = he + "Date", $[m] = he + "Month", $[h] = he + "FullYear", $[l] = he + "Hours", $[a] = he + "Minutes", $[s] = he + "Seconds", $[o] = he + "Milliseconds", $)[le], ue = le === c ? this.$D + (Q - this.$W) : Q;
        if (le === m || le === h) {
          var Ae = this.clone().set(A, 1);
          Ae.$d[oe](ue), Ae.init(), this.$d = Ae.set(A, Math.min(this.$D, Ae.daysInMonth())).$d;
        } else
          oe && this.$d[oe](ue);
        return this.init(), this;
      }, W.set = function(H, Q) {
        return this.clone().$set(H, Q);
      }, W.get = function(H) {
        return this[F.p(H)]();
      }, W.add = function(H, Q) {
        var $, le = this;
        H = Number(H);
        var he = F.p(Q), oe = function(de) {
          var fe = O(le);
          return F.w(fe.date(fe.date() + Math.round(de * H)), le);
        };
        if (he === m)
          return this.set(m, this.$M + H);
        if (he === h)
          return this.set(h, this.$y + H);
        if (he === c)
          return oe(1);
        if (he === u)
          return oe(7);
        var ue = ($ = {}, $[a] = r, $[l] = n, $[s] = i, $)[he] || 1, Ae = this.$d.getTime() + H * ue;
        return F.w(Ae, this);
      }, W.subtract = function(H, Q) {
        return this.add(-1 * H, Q);
      }, W.format = function(H) {
        var Q = this, $ = this.$locale();
        if (!this.isValid())
          return $.invalidDate || y;
        var le = H || "YYYY-MM-DDTHH:mm:ssZ", he = F.z(this), oe = this.$H, ue = this.$m, Ae = this.$M, de = $.weekdays, fe = $.months, Re = $.meridiem, qe = function(Qe, Pe, et, At) {
          return Qe && (Qe[Pe] || Qe(Q, le)) || et[Pe].slice(0, At);
        }, Oe = function(Qe) {
          return F.s(oe % 12 || 12, Qe, "0");
        }, Xe = Re || function(Qe, Pe, et) {
          var At = Qe < 12 ? "AM" : "PM";
          return et ? At.toLowerCase() : At;
        };
        return le.replace(v, function(Qe, Pe) {
          return Pe || function(et) {
            switch (et) {
              case "YY":
                return String(Q.$y).slice(-2);
              case "YYYY":
                return F.s(Q.$y, 4, "0");
              case "M":
                return Ae + 1;
              case "MM":
                return F.s(Ae + 1, 2, "0");
              case "MMM":
                return qe($.monthsShort, Ae, fe, 3);
              case "MMMM":
                return qe(fe, Ae);
              case "D":
                return Q.$D;
              case "DD":
                return F.s(Q.$D, 2, "0");
              case "d":
                return String(Q.$W);
              case "dd":
                return qe($.weekdaysMin, Q.$W, de, 2);
              case "ddd":
                return qe($.weekdaysShort, Q.$W, de, 3);
              case "dddd":
                return de[Q.$W];
              case "H":
                return String(oe);
              case "HH":
                return F.s(oe, 2, "0");
              case "h":
                return Oe(1);
              case "hh":
                return Oe(2);
              case "a":
                return Xe(oe, ue, !0);
              case "A":
                return Xe(oe, ue, !1);
              case "m":
                return String(ue);
              case "mm":
                return F.s(ue, 2, "0");
              case "s":
                return String(Q.$s);
              case "ss":
                return F.s(Q.$s, 2, "0");
              case "SSS":
                return F.s(Q.$ms, 3, "0");
              case "Z":
                return he;
            }
            return null;
          }(Qe) || he.replace(":", "");
        });
      }, W.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, W.diff = function(H, Q, $) {
        var le, he = this, oe = F.p(Q), ue = O(H), Ae = (ue.utcOffset() - this.utcOffset()) * r, de = this - ue, fe = function() {
          return F.m(he, ue);
        };
        switch (oe) {
          case h:
            le = fe() / 12;
            break;
          case m:
            le = fe();
            break;
          case g:
            le = fe() / 3;
            break;
          case u:
            le = (de - Ae) / 6048e5;
            break;
          case c:
            le = (de - Ae) / 864e5;
            break;
          case l:
            le = de / n;
            break;
          case a:
            le = de / r;
            break;
          case s:
            le = de / i;
            break;
          default:
            le = de;
        }
        return $ ? le : F.a(le);
      }, W.daysInMonth = function() {
        return this.endOf(m).$D;
      }, W.$locale = function() {
        return w[this.$L];
      }, W.locale = function(H, Q) {
        if (!H)
          return this.$L;
        var $ = this.clone(), le = D(H, Q, !0);
        return le && ($.$L = le), $;
      }, W.clone = function() {
        return F.w(this.$d, this);
      }, W.toDate = function() {
        return new Date(this.valueOf());
      }, W.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, W.toISOString = function() {
        return this.$d.toISOString();
      }, W.toString = function() {
        return this.$d.toUTCString();
      }, z;
    }(), P = Y.prototype;
    return O.prototype = P, [["$ms", o], ["$s", s], ["$m", a], ["$H", l], ["$W", c], ["$M", m], ["$y", h], ["$D", A]].forEach(function(z) {
      P[z[1]] = function(W) {
        return this.$g(W, z[0], z[1]);
      };
    }), O.extend = function(z, W) {
      return z.$i || (z(W, Y, O), z.$i = !0), O;
    }, O.locale = D, O.isDayjs = N, O.unix = function(z) {
      return O(1e3 * z);
    }, O.en = w[R], O.Ls = w, O.p = {}, O;
  });
})(qV);
var RIe = qV.exports;
const MI = /* @__PURE__ */ Ho(RIe);
var jV = { exports: {} };
(function(e, t) {
  (function(i, r) {
    e.exports = r();
  })(yt, function() {
    var i, r, n = 1e3, o = 6e4, s = 36e5, a = 864e5, l = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, c = 31536e6, u = 2628e6, m = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/, g = { years: c, months: u, days: a, hours: s, minutes: o, seconds: n, milliseconds: 1, weeks: 6048e5 }, h = function(w) {
      return w instanceof S;
    }, A = function(w, T, N) {
      return new S(w, N, T.$l);
    }, y = function(w) {
      return r.p(w) + "s";
    }, E = function(w) {
      return w < 0;
    }, v = function(w) {
      return E(w) ? Math.ceil(w) : Math.floor(w);
    }, C = function(w) {
      return Math.abs(w);
    }, x = function(w, T) {
      return w ? E(w) ? { negative: !0, format: "" + C(w) + T } : { negative: !1, format: "" + w + T } : { negative: !1, format: "" };
    }, S = function() {
      function w(N, D, O) {
        var F = this;
        if (this.$d = {}, this.$l = O, N === void 0 && (this.$ms = 0, this.parseFromMilliseconds()), D)
          return A(N * g[y(D)], this);
        if (typeof N == "number")
          return this.$ms = N, this.parseFromMilliseconds(), this;
        if (typeof N == "object")
          return Object.keys(N).forEach(function(z) {
            F.$d[y(z)] = N[z];
          }), this.calMilliseconds(), this;
        if (typeof N == "string") {
          var Y = N.match(m);
          if (Y) {
            var P = Y.slice(2).map(function(z) {
              return z != null ? Number(z) : 0;
            });
            return this.$d.years = P[0], this.$d.months = P[1], this.$d.weeks = P[2], this.$d.days = P[3], this.$d.hours = P[4], this.$d.minutes = P[5], this.$d.seconds = P[6], this.calMilliseconds(), this;
          }
        }
        return this;
      }
      var T = w.prototype;
      return T.calMilliseconds = function() {
        var N = this;
        this.$ms = Object.keys(this.$d).reduce(function(D, O) {
          return D + (N.$d[O] || 0) * g[O];
        }, 0);
      }, T.parseFromMilliseconds = function() {
        var N = this.$ms;
        this.$d.years = v(N / c), N %= c, this.$d.months = v(N / u), N %= u, this.$d.days = v(N / a), N %= a, this.$d.hours = v(N / s), N %= s, this.$d.minutes = v(N / o), N %= o, this.$d.seconds = v(N / n), N %= n, this.$d.milliseconds = N;
      }, T.toISOString = function() {
        var N = x(this.$d.years, "Y"), D = x(this.$d.months, "M"), O = +this.$d.days || 0;
        this.$d.weeks && (O += 7 * this.$d.weeks);
        var F = x(O, "D"), Y = x(this.$d.hours, "H"), P = x(this.$d.minutes, "M"), z = this.$d.seconds || 0;
        this.$d.milliseconds && (z += this.$d.milliseconds / 1e3, z = Math.round(1e3 * z) / 1e3);
        var W = x(z, "S"), H = N.negative || D.negative || F.negative || Y.negative || P.negative || W.negative, Q = Y.format || P.format || W.format ? "T" : "", $ = (H ? "-" : "") + "P" + N.format + D.format + F.format + Q + Y.format + P.format + W.format;
        return $ === "P" || $ === "-P" ? "P0D" : $;
      }, T.toJSON = function() {
        return this.toISOString();
      }, T.format = function(N) {
        var D = N || "YYYY-MM-DDTHH:mm:ss", O = { Y: this.$d.years, YY: r.s(this.$d.years, 2, "0"), YYYY: r.s(this.$d.years, 4, "0"), M: this.$d.months, MM: r.s(this.$d.months, 2, "0"), D: this.$d.days, DD: r.s(this.$d.days, 2, "0"), H: this.$d.hours, HH: r.s(this.$d.hours, 2, "0"), m: this.$d.minutes, mm: r.s(this.$d.minutes, 2, "0"), s: this.$d.seconds, ss: r.s(this.$d.seconds, 2, "0"), SSS: r.s(this.$d.milliseconds, 3, "0") };
        return D.replace(l, function(F, Y) {
          return Y || String(O[F]);
        });
      }, T.as = function(N) {
        return this.$ms / g[y(N)];
      }, T.get = function(N) {
        var D = this.$ms, O = y(N);
        return O === "milliseconds" ? D %= 1e3 : D = O === "weeks" ? v(D / g[O]) : this.$d[O], D || 0;
      }, T.add = function(N, D, O) {
        var F;
        return F = D ? N * g[y(D)] : h(N) ? N.$ms : A(N, this).$ms, A(this.$ms + F * (O ? -1 : 1), this);
      }, T.subtract = function(N, D) {
        return this.add(N, D, !0);
      }, T.locale = function(N) {
        var D = this.clone();
        return D.$l = N, D;
      }, T.clone = function() {
        return A(this.$ms, this);
      }, T.humanize = function(N) {
        return i().add(this.$ms, "ms").locale(this.$l).fromNow(!N);
      }, T.valueOf = function() {
        return this.asMilliseconds();
      }, T.milliseconds = function() {
        return this.get("milliseconds");
      }, T.asMilliseconds = function() {
        return this.as("milliseconds");
      }, T.seconds = function() {
        return this.get("seconds");
      }, T.asSeconds = function() {
        return this.as("seconds");
      }, T.minutes = function() {
        return this.get("minutes");
      }, T.asMinutes = function() {
        return this.as("minutes");
      }, T.hours = function() {
        return this.get("hours");
      }, T.asHours = function() {
        return this.as("hours");
      }, T.days = function() {
        return this.get("days");
      }, T.asDays = function() {
        return this.as("days");
      }, T.weeks = function() {
        return this.get("weeks");
      }, T.asWeeks = function() {
        return this.as("weeks");
      }, T.months = function() {
        return this.get("months");
      }, T.asMonths = function() {
        return this.as("months");
      }, T.years = function() {
        return this.get("years");
      }, T.asYears = function() {
        return this.as("years");
      }, w;
    }(), R = function(w, T, N) {
      return w.add(T.years() * N, "y").add(T.months() * N, "M").add(T.days() * N, "d").add(T.hours() * N, "h").add(T.minutes() * N, "m").add(T.seconds() * N, "s").add(T.milliseconds() * N, "ms");
    };
    return function(w, T, N) {
      i = N, r = N().$utils(), N.duration = function(F, Y) {
        var P = N.locale();
        return A(F, { $l: P }, Y);
      }, N.isDuration = h;
      var D = T.prototype.add, O = T.prototype.subtract;
      T.prototype.add = function(F, Y) {
        return h(F) ? R(this, F, 1) : D.bind(this)(F, Y);
      }, T.prototype.subtract = function(F, Y) {
        return h(F) ? R(this, F, -1) : O.bind(this)(F, Y);
      };
    };
  });
})(jV);
var kIe = jV.exports;
const wIe = /* @__PURE__ */ Ho(kIe);
var LV = { exports: {} };
(function(e, t) {
  (function(i, r) {
    e.exports = r();
  })(yt, function() {
    return function(i, r, n) {
      i = i || {};
      var o = r.prototype, s = { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" };
      function a(c, u, m, g) {
        return o.fromToBase(c, u, m, g);
      }
      n.en.relativeTime = s, o.fromToBase = function(c, u, m, g, h) {
        for (var A, y, E, v = m.$locale().relativeTime || s, C = i.thresholds || [{ l: "s", r: 44, d: "second" }, { l: "m", r: 89 }, { l: "mm", r: 44, d: "minute" }, { l: "h", r: 89 }, { l: "hh", r: 21, d: "hour" }, { l: "d", r: 35 }, { l: "dd", r: 25, d: "day" }, { l: "M", r: 45 }, { l: "MM", r: 10, d: "month" }, { l: "y", r: 17 }, { l: "yy", d: "year" }], x = C.length, S = 0; S < x; S += 1) {
          var R = C[S];
          R.d && (A = g ? n(c).diff(m, R.d, !0) : m.diff(c, R.d, !0));
          var w = (i.rounding || Math.round)(Math.abs(A));
          if (E = A > 0, w <= R.r || !R.r) {
            w <= 1 && S > 0 && (R = C[S - 1]);
            var T = v[R.l];
            h && (w = h("" + w)), y = typeof T == "string" ? T.replace("%d", w) : T(w, u, R.l, E);
            break;
          }
        }
        if (u)
          return y;
        var N = E ? v.future : v.past;
        return typeof N == "function" ? N(y) : N.replace("%s", y);
      }, o.to = function(c, u) {
        return a(c, u, this, !0);
      }, o.from = function(c, u) {
        return a(c, u, this);
      };
      var l = function(c) {
        return c.$u ? n.utc() : n();
      };
      o.toNow = function(c) {
        return this.to(l(this), c);
      }, o.fromNow = function(c) {
        return this.from(l(this), c);
      };
    };
  });
})(LV);
var MIe = LV.exports;
const NIe = /* @__PURE__ */ Ho(MIe);
MI.extend(wIe);
MI.extend(NIe);
function i7e({ createdAt: e, className: t }) {
  const [, i] = RN((n) => n + 1, 0), r = Ne();
  return be(() => (r.current = setInterval(() => {
    i();
  }, 1e3), () => {
    clearInterval(r.current);
  }), []), /* @__PURE__ */ f("span", { className: t, children: MI(e).fromNow() });
}
const TIe = "_tag_1mb52_1", BIe = "_square_1mb52_10", DIe = "_text_1mb52_16", OIe = "_sm_1mb52_30", FIe = "_md_1mb52_49", VIe = "_highlighted_1mb52_69", qIe = "_highlighted2_1mb52_73", jIe = "_grey_1mb52_76", LIe = "_grey2_1mb52_89", KIe = "_grey3_1mb52_102", YIe = "_danger_1mb52_115", Gd = {
  tag: TIe,
  square: BIe,
  text: DIe,
  sm: OIe,
  "sm-md": "_sm-md_1mb52_33",
  md: FIe,
  default: "_default_1mb52_65",
  highlighted: VIe,
  highlighted2: qIe,
  grey: jIe,
  grey2: LIe,
  grey3: KIe,
  danger: YIe
};
function Xc(a) {
  var l = a, {
    tagStyle: e = "default",
    size: t = "sm",
    tagColor: i,
    customColor: r,
    className: n,
    children: o
  } = l, s = Fe(l, [
    "tagStyle",
    "size",
    "tagColor",
    "customColor",
    "className",
    "children"
  ]);
  e === "highlighted" && (e = "default");
  const c = r || (i ? B1[i] : void 0), u = e === "highlighted2" && i ? B1[i] : void 0;
  return /* @__PURE__ */ V(
    "span",
    ee(q({
      style: u ? { backgroundColor: u } : void 0,
      className: me(Gd.tag, Gd[t], Gd[e], n)
    }, s), {
      children: [
        c && !u && /* @__PURE__ */ f("span", { style: { backgroundColor: c }, className: Gd.square }),
        /* @__PURE__ */ f("span", { className: Gd.text, children: o })
      ]
    })
  );
}
const UIe = "_Timer_13bgx_1", GIe = "_Timer__col_13bgx_5", QIe = "_Timer__counterWrapper_13bgx_11", WIe = "_Timer__counter_13bgx_11", ZIe = "_Timer__counterInner_13bgx_43", JIe = "_Timer__number_13bgx_58", PIe = "_Timer__text_13bgx_64", Fo = {
  Timer: UIe,
  Timer__col: GIe,
  Timer__counterWrapper: QIe,
  Timer__counter: WIe,
  Timer__counterInner: ZIe,
  "Timer__counterInner--isChanging": "_Timer__counterInner--isChanging_13bgx_53",
  Timer__number: JIe,
  Timer__text: PIe
}, KV = { days: 0, hours: 0, min: 0, sec: 0 };
function zIe(e) {
  switch (e) {
    case "days":
      return 99;
    case "hours":
      return 24;
    case "min":
      return 60;
    case "sec":
      return 60;
  }
}
function Qd(e, t) {
  const i = zIe(t);
  return e = Number(e), e < 0 ? `${i + e}` : e == 0 ? "00" : e < 10 ? `0${e}` : e >= i ? `0${e % i}` : `${e}`;
}
function iN(e) {
  const t = +e - +/* @__PURE__ */ new Date();
  return t > 0 ? {
    days: Math.floor(t / (1e3 * 60 * 60 * 24)),
    hours: Math.floor(t / (1e3 * 60 * 60) % 24),
    min: Math.floor(t / (1e3 * 60) % 60),
    sec: Math.floor(t / 1e3 % 60)
  } : KV;
}
function r7e({ startTime: e, timerColor: t }) {
  const [i, r] = se(KV), n = we(() => i.days + i.hours + i.min + i.sec === 0, [i]), [o, s] = se(!1);
  be(() => {
    let l;
    r(iN(e));
    const c = setInterval(() => {
      s(!0), l = setTimeout(() => {
        s(!1), r(iN(e));
      }, 210);
    }, 1e3);
    return () => {
      clearInterval(c), clearTimeout(l);
    };
  }, [e]);
  const a = we(
    () => i.days !== 0 ? ["days", "hours", "min", "sec"] : ["hours", "min", "sec"],
    [i.days]
  );
  return /* @__PURE__ */ f("div", { className: Fo.Timer, children: a.map((l, c) => {
    const u = a.slice(c + 1).reduce((m, g) => m + i[g], 0);
    return /* @__PURE__ */ V("div", { className: Fo.Timer__col, children: [
      /* @__PURE__ */ f("div", { className: Fo.Timer__counterWrapper, children: /* @__PURE__ */ f("div", { className: Fo.Timer__counter, children: /* @__PURE__ */ V(
        "div",
        {
          style: { color: B1[t] },
          className: me(
            Fo.Timer__counterInner,
            !n && o && u === 0 ? Fo["Timer__counterInner--isChanging"] : void 0
          ),
          children: [
            /* @__PURE__ */ f("div", { className: Fo.Timer__number, children: Qd(i[l] - 2, l) }),
            /* @__PURE__ */ f("div", { className: Fo.Timer__number, children: Qd(i[l] - 1, l) }),
            /* @__PURE__ */ f("div", { className: Fo.Timer__number, children: Qd(i[l], l) }),
            /* @__PURE__ */ f("div", { className: Fo.Timer__number, children: Qd(i[l] + 1, l) }),
            /* @__PURE__ */ f("div", { className: Fo.Timer__number, children: Qd(i[l] + 2, l) })
          ]
        }
      ) }) }),
      /* @__PURE__ */ f("div", { className: Fo.Timer__text, children: l })
    ] }, l);
  }) });
}
const HIe = "_BlueTracker_b9xq2_1", XIe = "_BlueTracker__regionSelector_b9xq2_7", _Ie = "_BlueTracker__regionSelectorText_b9xq2_13", $Ie = "_BlueTracker__cols_b9xq2_18", eSe = "_BlueTracker__col_b9xq2_18", tSe = "_BlueTracker__post_b9xq2_33", iSe = "_BlueTracker__time_b9xq2_43", rSe = "_BlueTracker__flag_b9xq2_49", nSe = "_BlueTracker__title_b9xq2_53", xa = {
  BlueTracker: HIe,
  BlueTracker__regionSelector: XIe,
  BlueTracker__regionSelectorText: _Ie,
  BlueTracker__cols: $Ie,
  BlueTracker__col: eSe,
  BlueTracker__post: tSe,
  BlueTracker__time: iSe,
  BlueTracker__flag: rSe,
  BlueTracker__title: nSe
};
function oSe({ post: e }) {
  const t = V9(e.timestamp), i = !e.link.includes("maxroll.gg");
  return /* @__PURE__ */ V(
    "a",
    {
      className: xa.BlueTracker__post,
      href: e.link,
      title: e.topic_title,
      target: i ? "_blank" : void 0,
      rel: i ? "noopener noreferrer" : void 0,
      children: [
        /* @__PURE__ */ f("span", { className: xa.BlueTracker__time, children: t == null ? void 0 : t.short }),
        /* @__PURE__ */ f("span", { className: me(xa.BlueTracker__flag, `fi fi-${e.country}`) }),
        /* @__PURE__ */ f("span", { className: xa.BlueTracker__title, children: e.topic_title })
      ]
    }
  );
}
function n7e({
  posts: e,
  separator: t,
  scrollBoxProps: i
}) {
  const [r, n] = se(), o = we(() => r === void 0 ? e : e.map((s) => s.filter((a) => a.country === r)), [e, r]);
  return /* @__PURE__ */ V("div", { className: xa.BlueTracker, children: [
    /* @__PURE__ */ V("div", { className: xa.BlueTracker__regionSelector, children: [
      /* @__PURE__ */ f("span", { className: xa.BlueTracker__regionSelectorText, children: "Region: " }),
      /* @__PURE__ */ f(
        SIe,
        {
          links: [
            {
              label: "EU",
              active: r === "eu",
              onClick: () => {
                n("eu");
              }
            },
            {
              label: "US",
              active: r === "us",
              onClick: () => {
                n("us");
              }
            }
          ],
          onClear: () => {
            n(void 0);
          }
        }
      )
    ] }),
    /* @__PURE__ */ f(Pr, ee(q({}, i), { children: /* @__PURE__ */ f("div", { className: xa.BlueTracker__cols, children: o.map((s, a) => /* @__PURE__ */ f("div", { className: xa.BlueTracker__col, children: s.map((l, c) => /* @__PURE__ */ V(bl, { children: [
      c !== 0 ? t : null,
      /* @__PURE__ */ f(oSe, { post: l })
    ] }, c)) }, a)) }) }))
  ] });
}
const sSe = "_DifficultyBar_1ui5m_5", aSe = "_DifficultyBar__bars_1ui5m_9", lSe = "_DifficultyBar__bar_1ui5m_9", cSe = "_DifficultyBar__circleOuter_1ui5m_42", uSe = "_DifficultyBar__circleInner_1ui5m_77", dSe = "_DifficultyBar__circleInner2_1ui5m_85", mSe = "_DifficultyBar__text_1ui5m_104", gSe = "_DifficultyBar__addIcon_1ui5m_116", Er = {
  DifficultyBar: sSe,
  DifficultyBar__bars: aSe,
  DifficultyBar__bar: lSe,
  "DifficultyBar__bar--color-1": "_DifficultyBar__bar--color-1_1ui5m_22",
  "DifficultyBar__bar--color-2": "_DifficultyBar__bar--color-2_1ui5m_25",
  "DifficultyBar__bar--color-3": "_DifficultyBar__bar--color-3_1ui5m_28",
  "DifficultyBar__bar--color-4": "_DifficultyBar__bar--color-4_1ui5m_31",
  "DifficultyBar__bar--color-5": "_DifficultyBar__bar--color-5_1ui5m_34",
  "DifficultyBar__bar--color-add": "_DifficultyBar__bar--color-add_1ui5m_37",
  "DifficultyBar__bar--diff-1": "_DifficultyBar__bar--diff-1_1ui5m_41",
  DifficultyBar__circleOuter: cSe,
  "DifficultyBar__bar--diff-2": "_DifficultyBar__bar--diff-2_1ui5m_46",
  "DifficultyBar__bar--diff-3": "_DifficultyBar__bar--diff-3_1ui5m_51",
  "DifficultyBar__bar--diff-4": "_DifficultyBar__bar--diff-4_1ui5m_56",
  "DifficultyBar__bar--diff-5": "_DifficultyBar__bar--diff-5_1ui5m_61",
  DifficultyBar__circleInner: uSe,
  DifficultyBar__circleInner2: dSe,
  DifficultyBar__text: mSe,
  DifficultyBar__addIcon: gSe,
  "DifficultyBar__bar--action": "_DifficultyBar__bar--action_1ui5m_121"
};
function o7e({
  bars: e,
  backgroundColor: t,
  fullCircles: i = !1,
  maxDifficulty: r = 5,
  onAdd: n
}) {
  const o = Ne({});
  return /* @__PURE__ */ f("div", { className: Er.DifficultyBar, children: /* @__PURE__ */ V("div", { className: Er.DifficultyBar__bars, children: [
    e.map((s, a) => {
      const l = s.inverse ? r + 1 - s.difficulty : s.difficulty;
      return /* @__PURE__ */ V(
        "div",
        {
          ref: (c) => o.current[s.id] = c,
          className: me(
            Er.DifficultyBar__bar,
            s.onBarClick ? Er["DifficultyBar__bar--action"] : void 0,
            Er[`DifficultyBar__bar--diff-${i ? 5 : 5 - r + s.difficulty}`],
            s.difficulty > 0 && Er[`DifficultyBar__bar--color-${l}`]
          ),
          onClick: s.onBarClick ? () => {
            const c = o.current[s.id];
            s.onBarClick && c && s.onBarClick(s.id, c);
          } : void 0,
          children: [
            /* @__PURE__ */ f("div", { className: Er.DifficultyBar__circleOuter, children: /* @__PURE__ */ f("div", { style: { backgroundColor: t }, className: Er.DifficultyBar__circleInner, children: /* @__PURE__ */ f("div", { className: Er.DifficultyBar__circleInner2, children: s.icon ? /* @__PURE__ */ f("img", { width: 40, src: s.icon }) : s.difficulty }) }) }),
            /* @__PURE__ */ f("div", { className: Er.DifficultyBar__text, children: /* @__PURE__ */ f("span", { children: s.title }) })
          ]
        },
        a
      );
    }),
    n ? /* @__PURE__ */ V(
      "div",
      {
        className: me(
          Er.DifficultyBar__bar,
          Er["DifficultyBar__bar--action"],
          Er[`DifficultyBar__bar--diff-${r}`],
          Er["DifficultyBar__bar--color-add"]
        ),
        onClick: n,
        children: [
          /* @__PURE__ */ f("div", { className: Er.DifficultyBar__circleOuter, children: /* @__PURE__ */ f("div", { style: { backgroundColor: t }, className: Er.DifficultyBar__circleInner, children: /* @__PURE__ */ f("div", { className: Er.DifficultyBar__circleInner2, children: /* @__PURE__ */ f(Mt, { className: Er.DifficultyBar__addIcon, icon: "icons/add.svg", width: 12, height: 12 }) }) }) }),
          /* @__PURE__ */ f("div", { className: Er.DifficultyBar__text, children: /* @__PURE__ */ f("span", { children: "New" }) })
        ]
      }
    ) : null
  ] }) });
}
/*! Fast Average Color | © 2023 Denis Seleznev | MIT License | https://github.com/fast-average-color/fast-average-color */
function hSe(e) {
  var t = e.toString(16);
  return t.length === 1 ? "0" + t : t;
}
function rN(e) {
  return "#" + e.map(hSe).join("");
}
function pSe(e) {
  var t = (e[0] * 299 + e[1] * 587 + e[2] * 114) / 1e3;
  return t < 128;
}
function fSe(e) {
  return e ? ASe(e) ? e : [e] : [];
}
function ASe(e) {
  return Array.isArray(e[0]);
}
function NI(e, t, i) {
  for (var r = 0; r < i.length; r++)
    if (ySe(e, t, i[r]))
      return !0;
  return !1;
}
function ySe(e, t, i) {
  switch (i.length) {
    case 3:
      if (ESe(e, t, i))
        return !0;
      break;
    case 4:
      if (vSe(e, t, i))
        return !0;
      break;
    case 5:
      if (bSe(e, t, i))
        return !0;
      break;
    default:
      return !1;
  }
}
function ESe(e, t, i) {
  return e[t + 3] !== 255 || e[t] === i[0] && e[t + 1] === i[1] && e[t + 2] === i[2];
}
function vSe(e, t, i) {
  return e[t + 3] && i[3] ? e[t] === i[0] && e[t + 1] === i[1] && e[t + 2] === i[2] && e[t + 3] === i[3] : e[t + 3] === i[3];
}
function wp(e, t, i) {
  return e >= t - i && e <= t + i;
}
function bSe(e, t, i) {
  var r = i[0], n = i[1], o = i[2], s = i[3], a = i[4], l = e[t + 3], c = wp(l, s, a);
  return s ? !!(!l && c || wp(e[t], r, a) && wp(e[t + 1], n, a) && wp(e[t + 2], o, a) && c) : c;
}
var CSe = 24;
function xSe(e, t, i) {
  for (var r = {}, n = i.dominantDivider || CSe, o = i.ignoredColor, s = i.step, a = [0, 0, 0, 0, 0], l = 0; l < t; l += s) {
    var c = e[l], u = e[l + 1], m = e[l + 2], g = e[l + 3];
    if (!(o && NI(e, l, o))) {
      var h = Math.round(c / n) + "," + Math.round(u / n) + "," + Math.round(m / n);
      r[h] ? r[h] = [
        r[h][0] + c * g,
        r[h][1] + u * g,
        r[h][2] + m * g,
        r[h][3] + g,
        r[h][4] + 1
      ] : r[h] = [c * g, u * g, m * g, g, 1], a[4] < r[h][4] && (a = r[h]);
    }
  }
  var A = a[0], y = a[1], E = a[2], v = a[3], C = a[4];
  return v ? [
    Math.round(A / v),
    Math.round(y / v),
    Math.round(E / v),
    Math.round(v / C)
  ] : i.defaultColor;
}
function ISe(e, t, i) {
  for (var r = 0, n = 0, o = 0, s = 0, a = 0, l = i.ignoredColor, c = i.step, u = 0; u < t; u += c) {
    var m = e[u + 3], g = e[u] * m, h = e[u + 1] * m, A = e[u + 2] * m;
    l && NI(e, u, l) || (r += g, n += h, o += A, s += m, a++);
  }
  return s ? [
    Math.round(r / s),
    Math.round(n / s),
    Math.round(o / s),
    Math.round(s / a)
  ] : i.defaultColor;
}
function SSe(e, t, i) {
  for (var r = 0, n = 0, o = 0, s = 0, a = 0, l = i.ignoredColor, c = i.step, u = 0; u < t; u += c) {
    var m = e[u], g = e[u + 1], h = e[u + 2], A = e[u + 3];
    l && NI(e, u, l) || (r += m * m * A, n += g * g * A, o += h * h * A, s += A, a++);
  }
  return s ? [
    Math.round(Math.sqrt(r / s)),
    Math.round(Math.sqrt(n / s)),
    Math.round(Math.sqrt(o / s)),
    Math.round(s / a)
  ] : i.defaultColor;
}
function nN(e) {
  return im(e, "defaultColor", [0, 0, 0, 0]);
}
function im(e, t, i) {
  return e[t] === void 0 ? i : e[t];
}
var oN = 10, SC = 100;
function RSe(e) {
  return e.search(/\.svg(\?|$)/i) !== -1;
}
function kSe(e) {
  if (YV(e)) {
    var t = e.naturalWidth, i = e.naturalHeight;
    return !e.naturalWidth && RSe(e.src) && (t = i = SC), {
      width: t,
      height: i
    };
  }
  return MSe(e) ? {
    width: e.videoWidth,
    height: e.videoHeight
  } : {
    width: e.width,
    height: e.height
  };
}
function sN(e) {
  return NSe(e) ? "canvas" : wSe(e) ? "offscreencanvas" : TSe(e) ? "imagebitmap" : e.src;
}
function YV(e) {
  return typeof HTMLImageElement != "undefined" && e instanceof HTMLImageElement;
}
var UV = typeof OffscreenCanvas != "undefined";
function wSe(e) {
  return UV && e instanceof OffscreenCanvas;
}
function MSe(e) {
  return typeof HTMLVideoElement != "undefined" && e instanceof HTMLVideoElement;
}
function NSe(e) {
  return typeof HTMLCanvasElement != "undefined" && e instanceof HTMLCanvasElement;
}
function TSe(e) {
  return typeof ImageBitmap != "undefined" && e instanceof ImageBitmap;
}
function BSe(e, t) {
  var i = im(t, "left", 0), r = im(t, "top", 0), n = im(t, "width", e.width), o = im(t, "height", e.height), s = n, a = o;
  if (t.mode === "precision")
    return {
      srcLeft: i,
      srcTop: r,
      srcWidth: n,
      srcHeight: o,
      destWidth: s,
      destHeight: a
    };
  var l;
  return n > o ? (l = n / o, s = SC, a = Math.round(s / l)) : (l = o / n, a = SC, s = Math.round(a / l)), (s > n || a > o || s < oN || a < oN) && (s = n, a = o), {
    srcLeft: i,
    srcTop: r,
    srcWidth: n,
    srcHeight: o,
    destWidth: s,
    destHeight: a
  };
}
var DSe = typeof window == "undefined";
function OSe() {
  return DSe ? UV ? new OffscreenCanvas(1, 1) : null : document.createElement("canvas");
}
var FSe = "FastAverageColor: ";
function Cs(e) {
  return Error(FSe + e);
}
function Wd(e, t) {
  t || console.error(e);
}
var VSe = (
  /** @class */
  function() {
    function e() {
      this.canvas = null, this.ctx = null;
    }
    return e.prototype.getColorAsync = function(t, i) {
      if (!t)
        return Promise.reject(Cs("call .getColorAsync() without resource"));
      if (typeof t == "string") {
        if (typeof Image == "undefined")
          return Promise.reject(Cs("resource as string is not supported in this environment"));
        var r = new Image();
        return r.crossOrigin = i && i.crossOrigin || "", r.src = t, this.bindImageEvents(r, i);
      } else {
        if (YV(t) && !t.complete)
          return this.bindImageEvents(t, i);
        var n = this.getColor(t, i);
        return n.error ? Promise.reject(n.error) : Promise.resolve(n);
      }
    }, e.prototype.getColor = function(t, i) {
      i = i || {};
      var r = nN(i);
      if (!t) {
        var n = Cs("call .getColor() without resource");
        return Wd(n, i.silent), this.prepareResult(r, n);
      }
      var o = kSe(t), s = BSe(o, i);
      if (!s.srcWidth || !s.srcHeight || !s.destWidth || !s.destHeight) {
        var n = Cs('incorrect sizes for resource "'.concat(sN(t), '"'));
        return Wd(n, i.silent), this.prepareResult(r, n);
      }
      if (!this.canvas && (this.canvas = OSe(), !this.canvas)) {
        var n = Cs("OffscreenCanvas is not supported in this browser");
        return Wd(n, i.silent), this.prepareResult(r, n);
      }
      if (!this.ctx) {
        if (this.ctx = this.canvas.getContext("2d", { willReadFrequently: !0 }), !this.ctx) {
          var n = Cs("Canvas Context 2D is not supported in this browser");
          return Wd(n, i.silent), this.prepareResult(r);
        }
        this.ctx.imageSmoothingEnabled = !1;
      }
      this.canvas.width = s.destWidth, this.canvas.height = s.destHeight;
      try {
        this.ctx.clearRect(0, 0, s.destWidth, s.destHeight), this.ctx.drawImage(t, s.srcLeft, s.srcTop, s.srcWidth, s.srcHeight, 0, 0, s.destWidth, s.destHeight);
        var a = this.ctx.getImageData(0, 0, s.destWidth, s.destHeight).data;
        return this.prepareResult(this.getColorFromArray4(a, i));
      } catch (l) {
        var n = Cs("security error (CORS) for resource ".concat(sN(t), `.
Details: https://developer.mozilla.org/en/docs/Web/HTML/CORS_enabled_image`));
        return Wd(n, i.silent), !i.silent && console.error(l), this.prepareResult(r, n);
      }
    }, e.prototype.getColorFromArray4 = function(t, i) {
      i = i || {};
      var r = 4, n = t.length, o = nN(i);
      if (n < r)
        return o;
      var s = n - n % r, a = (i.step || 1) * r, l;
      switch (i.algorithm || "sqrt") {
        case "simple":
          l = ISe;
          break;
        case "sqrt":
          l = SSe;
          break;
        case "dominant":
          l = xSe;
          break;
        default:
          throw Cs("".concat(i.algorithm, " is unknown algorithm"));
      }
      return l(t, s, {
        defaultColor: o,
        ignoredColor: fSe(i.ignoredColor),
        step: a,
        dominantDivider: i.dominantDivider
      });
    }, e.prototype.prepareResult = function(t, i) {
      var r = t.slice(0, 3), n = [t[0], t[1], t[2], t[3] / 255], o = pSe(t);
      return {
        value: [t[0], t[1], t[2], t[3]],
        rgb: "rgb(" + r.join(",") + ")",
        rgba: "rgba(" + n.join(",") + ")",
        hex: rN(r),
        hexa: rN(t),
        isDark: o,
        isLight: !o,
        error: i
      };
    }, e.prototype.destroy = function() {
      this.canvas && (this.canvas.width = 1, this.canvas.height = 1, this.canvas = null), this.ctx = null;
    }, e.prototype.bindImageEvents = function(t, i) {
      var r = this;
      return new Promise(function(n, o) {
        var s = function() {
          c();
          var u = r.getColor(t, i);
          u.error ? o(u.error) : n(u);
        }, a = function() {
          c(), o(Cs('Error loading image "'.concat(t.src, '"')));
        }, l = function() {
          c(), o(Cs('Image "'.concat(t.src, '" loading aborted')));
        }, c = function() {
          t.removeEventListener("load", s), t.removeEventListener("error", a), t.removeEventListener("abort", l);
        };
        t.addEventListener("load", s), t.addEventListener("error", a), t.addEventListener("abort", l);
      });
    }, e;
  }()
);
const qSe = "_difficultyBar_1tt2f_1", jSe = "_banner_1tt2f_7", LSe = "_image_1tt2f_22", KSe = "_logo_1tt2f_29", YSe = "_main_1tt2f_37", USe = "_mainBkg_1tt2f_44", GSe = "_mainInner_1tt2f_51", QSe = "_titleWrapper_1tt2f_60", WSe = "_titleBkg_1tt2f_64", ZSe = "_title_1tt2f_60", JSe = "_bars_1tt2f_83", PSe = "_barWrapper_1tt2f_88", zSe = "_barTitle_1tt2f_93", HSe = "_barSubTitle_1tt2f_101", XSe = "_bar_1tt2f_83", _Se = "_segment_1tt2f_113", $Se = "_grey_1tt2f_118", eRe = "_red_1tt2f_121", tRe = "_orange_1tt2f_124", iRe = "_green_1tt2f_127", rRe = "_withTitleBkg_1tt2f_151", vr = {
  difficultyBar: qSe,
  banner: jSe,
  image: LSe,
  logo: KSe,
  main: YSe,
  mainBkg: USe,
  mainInner: GSe,
  titleWrapper: QSe,
  titleBkg: WSe,
  title: ZSe,
  bars: JSe,
  barWrapper: PSe,
  barTitle: zSe,
  barSubTitle: HSe,
  bar: XSe,
  segment: _Se,
  grey: $Se,
  red: eRe,
  orange: tRe,
  green: iRe,
  withTitleBkg: rRe
}, nRe = [...Array(5).keys()], oRe = ["red", "red", "orange", "orange", "green", "green"];
function s7e(l) {
  var c = l, {
    title: e,
    image: t,
    logo: i,
    titleBkg: r,
    titleBkgWidth: n,
    bars: o,
    className: s
  } = c, a = Fe(c, [
    "title",
    "image",
    "logo",
    "titleBkg",
    "titleBkgWidth",
    "bars",
    "className"
  ]);
  const u = Ne(null), [m, g] = se(void 0);
  return be(() => {
    if (typeof window == "undefined" || !t)
      return;
    new VSe().getColorAsync(t).then((A) => {
      const E = `hsl(${F9(A.value[0], A.value[1], A.value[2])[0] * 360}, 28%, 8%)`;
      g(E);
    }).catch((A) => {
    });
  }, [t]), /* @__PURE__ */ V("div", ee(q({ className: me(vr.difficultyBar, s) }, a), { children: [
    t && /* @__PURE__ */ V("div", { className: vr.banner, children: [
      /* @__PURE__ */ f("img", { ref: u, width: 106, height: 414, className: vr.image, src: t }),
      i && /* @__PURE__ */ f("img", { width: 60, height: 60, className: vr.logo, src: i })
    ] }),
    /* @__PURE__ */ V("div", { style: { position: "relative" }, className: vr.main, children: [
      /* @__PURE__ */ f("div", { className: vr.mainBkg, style: { backgroundColor: m } }),
      /* @__PURE__ */ V("div", { style: { position: "relative" }, className: vr.mainInner, children: [
        e && /* @__PURE__ */ V("div", { className: me(vr.titleWrapper, !!r && vr.withTitleBkg), children: [
          r && /* @__PURE__ */ f(
            "div",
            {
              className: vr.titleBkg,
              style: { backgroundImage: `url("${r}")`, width: n }
            }
          ),
          /* @__PURE__ */ f("span", { className: vr.title, children: e })
        ] }),
        /* @__PURE__ */ f("div", { className: vr.bars, children: o.map((h, A) => {
          const y = h.inverse ? 5 - h.difficulty : h.difficulty, E = vr[oRe[y]];
          return /* @__PURE__ */ V("div", { className: vr.barWrapper, children: [
            /* @__PURE__ */ f("span", { className: vr.barTitle, children: h.title }),
            /* @__PURE__ */ f("div", { className: vr.bar, children: nRe.map((v) => /* @__PURE__ */ f(
              "div",
              {
                className: me(vr.segment, h.difficulty > v ? E : vr.grey)
              },
              v
            )) }),
            /* @__PURE__ */ f("span", { className: vr.barSubTitle, children: h.subTitle })
          ] }, A);
        }) })
      ] })
    ] })
  ] }));
}
const sRe = "_PodcastWidget_4cmpv_1", aRe = "_PodcastWidget__left_4cmpv_17", lRe = "_PodcastWidget__leftInner_4cmpv_28", cRe = "_PodcastWidget__leftInnerIcon_4cmpv_37", uRe = "_PodcastWidget__leftInnerText_4cmpv_41", dRe = "_PodcastWidget__right_4cmpv_48", mRe = "_PodcastWidget__rightPattern_4cmpv_60", gRe = "_PodcastWidget__rightContent_4cmpv_66", hRe = "_PodcastWidget__rightContentTop_4cmpv_75", pRe = "_PodcastWidget__rightTitle_4cmpv_82", fRe = "_PodcastWidget__rightImgWrapper_4cmpv_88", ARe = "_PodcastWidget__rightImg_4cmpv_88", yRe = "_PodcastWidget__rightContentBottom_4cmpv_102", qn = {
  PodcastWidget: sRe,
  "PodcastWidget--hasLink": "_PodcastWidget--hasLink_4cmpv_10",
  PodcastWidget__left: aRe,
  PodcastWidget__leftInner: lRe,
  PodcastWidget__leftInnerIcon: cRe,
  PodcastWidget__leftInnerText: uRe,
  PodcastWidget__right: dRe,
  PodcastWidget__rightPattern: mRe,
  PodcastWidget__rightContent: gRe,
  PodcastWidget__rightContentTop: hRe,
  PodcastWidget__rightTitle: pRe,
  PodcastWidget__rightImgWrapper: fRe,
  PodcastWidget__rightImg: ARe,
  PodcastWidget__rightContentBottom: yRe
}, ERe = {
  d4: { img: "images/banners/d4-podcast-banner.png", size: "275%", position: "-84px -36px" },
  d3: { img: "images/game-vertical-banners/diablo-iii-vert-banner-138x558.webp", size: "cover" },
  d2: { img: "images/game-vertical-banners/diablo-ii-vert-banner-138x558.webp", size: "cover" },
  "last-epoch": { img: "images/game-vertical-banners/last-epoch-vert-banner-138x558.webp", size: "cover" },
  poe: { img: "images/game-vertical-banners/poe-vert-banner-138x558.webp", size: "cover" },
  poe2: { img: "images/branch-banner/poe2-vertical-banner.webp", size: "cover" }
};
function a7e({ podcastsAndVideos: e, siteLong: t, defaultBanner: i = "" }) {
  const { assetPath: r } = fi(), n = we(
    () => (e || []).filter(
      (E) => E.type !== "Upcoming" && (t === "landing" || t === E.branch)
    ),
    [e, t]
  ), o = Ne(0), [s, a] = se(n == null ? void 0 : n[0]), [l, c] = se(!0);
  be(() => {
    let E;
    return n.length > 1 && (E = setInterval(() => {
      o.current = o.current + 1, a(n[o.current % n.length]), c(!1);
    }, 1e4)), () => {
      clearInterval(E);
    };
  }, [n]);
  const [u, m] = se(s), [g, h] = se(void 0);
  be(() => {
    let E;
    return typeof window != "undefined" && !l && (h({ opacity: "0" }), E = setTimeout(() => {
      m(s), h(void 0);
    }, 500)), () => {
      h(void 0), clearTimeout(E);
    };
  }, [s, l]);
  const A = (u == null ? void 0 : u.branch) || "landing", y = ERe[A] || i;
  return u ? /* @__PURE__ */ V(
    "a",
    {
      className: me(qn.PodcastWidget, u != null && u.link ? qn["PodcastWidget--hasLink"] : void 0),
      href: u.link,
      target: "_blank",
      rel: "noopener",
      children: [
        /* @__PURE__ */ f(
          "div",
          {
            style: q({
              transition: l ? void 0 : "opacity 0.5s",
              backgroundImage: `url("${r}/${y.img}")`,
              backgroundPosition: y.position,
              backgroundSize: y.size
            }, (s == null ? void 0 : s.branch) !== u.branch ? g : {}),
            className: qn.PodcastWidget__left,
            children: /* @__PURE__ */ V(
              "div",
              {
                style: q({
                  transition: l ? void 0 : "opacity 0.5s"
                }, (s == null ? void 0 : s.type) !== u.type ? g : {}),
                className: qn.PodcastWidget__leftInner,
                children: [
                  /* @__PURE__ */ f(
                    Mt,
                    {
                      className: qn.PodcastWidget__leftInnerIcon,
                      width: 23,
                      height: 27,
                      icon: u.type === "Podcast" ? "icons/podcast-2.svg" : "icons/youtube-play.svg"
                    }
                  ),
                  /* @__PURE__ */ f("span", { className: qn.PodcastWidget__leftInnerText, children: u.type === "Podcast" ? "Listen Now" : "Watch Now" })
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ V("div", { className: qn.PodcastWidget__right, children: [
          u.type === "Podcast" && /* @__PURE__ */ f(
            "img",
            {
              style: q({ transition: l ? void 0 : "opacity 0.5s" }, g),
              className: qn.PodcastWidget__rightPattern,
              width: 234,
              height: 64,
              src: `${r}/images/icons/podcast-wave-3.svg`,
              alt: ""
            }
          ),
          /* @__PURE__ */ V("div", { className: qn.PodcastWidget__rightContent, children: [
            /* @__PURE__ */ V("div", { className: qn.PodcastWidget__rightContentTop, children: [
              /* @__PURE__ */ f(
                "span",
                {
                  style: q({ transition: l ? void 0 : "opacity 0.5s" }, g),
                  className: qn.PodcastWidget__rightTitle,
                  children: u.type === "Podcast" ? "Latest Podcast" : "Latest Video"
                }
              ),
              /* @__PURE__ */ f(
                "div",
                {
                  style: q({ transition: l ? void 0 : "opacity 0.5s" }, g),
                  className: qn.PodcastWidget__rightImgWrapper,
                  children: /* @__PURE__ */ f(
                    "img",
                    {
                      className: qn.PodcastWidget__rightImg,
                      src: u.image,
                      alt: u.title
                    },
                    Math.random()
                  )
                }
              )
            ] }),
            /* @__PURE__ */ f(
              "span",
              {
                style: q({ transition: l ? void 0 : "opacity 0.5s" }, g),
                className: qn.PodcastWidget__rightContentBottom,
                children: u.title
              }
            )
          ] })
        ] })
      ]
    }
  ) : null;
}
var vRe = function(t, i, r) {
  var n = document.head || document.getElementsByTagName("head")[0], o = document.createElement("script");
  typeof i == "function" && (r = i, i = {}), i = i || {}, r = r || function() {
  }, o.type = i.type || "text/javascript", o.charset = i.charset || "utf8", o.async = "async" in i ? !!i.async : !0, o.src = t, i.attrs && bRe(o, i.attrs), i.text && (o.text = "" + i.text);
  var s = "onload" in o ? aN : CRe;
  s(o, r), o.onload || aN(o, r), n.appendChild(o);
};
function bRe(e, t) {
  for (var i in t)
    e.setAttribute(i, t[i]);
}
function aN(e, t) {
  e.onload = function() {
    this.onerror = this.onload = null, t(null, e);
  }, e.onerror = function() {
    this.onerror = this.onload = null, t(new Error("Failed to load " + this.src), e);
  };
}
function CRe(e, t) {
  e.onreadystatechange = function() {
    this.readyState != "complete" && this.readyState != "loaded" || (this.onreadystatechange = null, t(null, e));
  };
}
var xRe = function(t) {
  return IRe(t) && !SRe(t);
};
function IRe(e) {
  return !!e && typeof e == "object";
}
function SRe(e) {
  var t = Object.prototype.toString.call(e);
  return t === "[object RegExp]" || t === "[object Date]" || wRe(e);
}
var RRe = typeof Symbol == "function" && Symbol.for, kRe = RRe ? Symbol.for("react.element") : 60103;
function wRe(e) {
  return e.$$typeof === kRe;
}
function MRe(e) {
  return Array.isArray(e) ? [] : {};
}
function lg(e, t) {
  return t.clone !== !1 && t.isMergeableObject(e) ? w0(MRe(e), e, t) : e;
}
function NRe(e, t, i) {
  return e.concat(t).map(function(r) {
    return lg(r, i);
  });
}
function TRe(e, t) {
  if (!t.customMerge)
    return w0;
  var i = t.customMerge(e);
  return typeof i == "function" ? i : w0;
}
function BRe(e) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function(t) {
    return Object.propertyIsEnumerable.call(e, t);
  }) : [];
}
function lN(e) {
  return Object.keys(e).concat(BRe(e));
}
function GV(e, t) {
  try {
    return t in e;
  } catch (i) {
    return !1;
  }
}
function DRe(e, t) {
  return GV(e, t) && !(Object.hasOwnProperty.call(e, t) && Object.propertyIsEnumerable.call(e, t));
}
function ORe(e, t, i) {
  var r = {};
  return i.isMergeableObject(e) && lN(e).forEach(function(n) {
    r[n] = lg(e[n], i);
  }), lN(t).forEach(function(n) {
    DRe(e, n) || (GV(e, n) && i.isMergeableObject(t[n]) ? r[n] = TRe(n, i)(e[n], t[n], i) : r[n] = lg(t[n], i));
  }), r;
}
function w0(e, t, i) {
  i = i || {}, i.arrayMerge = i.arrayMerge || NRe, i.isMergeableObject = i.isMergeableObject || xRe, i.cloneUnlessOtherwiseSpecified = lg;
  var r = Array.isArray(t), n = Array.isArray(e), o = r === n;
  return o ? r ? i.arrayMerge(e, t, i) : ORe(e, t, i) : lg(t, i);
}
w0.all = function(t, i) {
  if (!Array.isArray(t))
    throw new Error("first argument should be an array");
  return t.reduce(function(r, n) {
    return w0(r, n, i);
  }, {});
};
var FRe = w0, QV = FRe, VRe = Object.create, Xf = Object.defineProperty, qRe = Object.getOwnPropertyDescriptor, jRe = Object.getOwnPropertyNames, LRe = Object.getPrototypeOf, KRe = Object.prototype.hasOwnProperty, YRe = (e, t) => {
  for (var i in t)
    Xf(e, i, { get: t[i], enumerable: !0 });
}, WV = (e, t, i, r) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let n of jRe(t))
      !KRe.call(e, n) && n !== i && Xf(e, n, { get: () => t[n], enumerable: !(r = qRe(t, n)) || r.enumerable });
  return e;
}, TI = (e, t, i) => (i = e != null ? VRe(LRe(e)) : {}, WV(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  t || !e || !e.__esModule ? Xf(i, "default", { value: e, enumerable: !0 }) : i,
  e
)), URe = (e) => WV(Xf({}, "__esModule", { value: !0 }), e), ZV = {};
YRe(ZV, {
  callPlayer: () => nke,
  getConfig: () => ike,
  getSDK: () => tke,
  isBlobUrl: () => ske,
  isMediaStream: () => oke,
  lazy: () => ZRe,
  omit: () => rke,
  parseEndTime: () => _Re,
  parseStartTime: () => XRe,
  queryString: () => eke,
  randomString: () => $Re,
  supportsWebKitPresentationMode: () => ake
});
var _f = URe(ZV), GRe = TI(X), QRe = TI(vRe), WRe = TI(QV);
const ZRe = (e) => GRe.default.lazy(() => Lt(void 0, null, function* () {
  const t = yield e();
  return typeof t.default == "function" ? t : t.default;
})), JRe = /[?&#](?:start|t)=([0-9hms]+)/, PRe = /[?&#]end=([0-9hms]+)/, RC = /(\d+)(h|m|s)/g, zRe = /^\d+$/;
function JV(e, t) {
  if (e instanceof Array)
    return;
  const i = e.match(t);
  if (i) {
    const r = i[1];
    if (r.match(RC))
      return HRe(r);
    if (zRe.test(r))
      return parseInt(r);
  }
}
function HRe(e) {
  let t = 0, i = RC.exec(e);
  for (; i !== null; ) {
    const [, r, n] = i;
    n === "h" && (t += parseInt(r, 10) * 60 * 60), n === "m" && (t += parseInt(r, 10) * 60), n === "s" && (t += parseInt(r, 10)), i = RC.exec(e);
  }
  return t;
}
function XRe(e) {
  return JV(e, JRe);
}
function _Re(e) {
  return JV(e, PRe);
}
function $Re() {
  return Math.random().toString(36).substr(2, 5);
}
function eke(e) {
  return Object.keys(e).map((t) => `${t}=${e[t]}`).join("&");
}
function Lv(e) {
  return window[e] ? window[e] : window.exports && window.exports[e] ? window.exports[e] : window.module && window.module.exports && window.module.exports[e] ? window.module.exports[e] : null;
}
const Uu = {}, tke = function(t, i, r = null, n = () => !0, o = QRe.default) {
  const s = Lv(i);
  return s && n(s) ? Promise.resolve(s) : new Promise((a, l) => {
    if (Uu[t]) {
      Uu[t].push({ resolve: a, reject: l });
      return;
    }
    Uu[t] = [{ resolve: a, reject: l }];
    const c = (u) => {
      Uu[t].forEach((m) => m.resolve(u));
    };
    if (r) {
      const u = window[r];
      window[r] = function() {
        u && u(), c(Lv(i));
      };
    }
    o(t, (u) => {
      u ? (Uu[t].forEach((m) => m.reject(u)), Uu[t] = null) : r || c(Lv(i));
    });
  });
};
function ike(e, t) {
  return (0, WRe.default)(t.config, e.config);
}
function rke(e, ...t) {
  const i = [].concat(...t), r = {}, n = Object.keys(e);
  for (const o of n)
    i.indexOf(o) === -1 && (r[o] = e[o]);
  return r;
}
function nke(e, ...t) {
  if (!this.player || !this.player[e]) {
    let i = `ReactPlayer: ${this.constructor.displayName} player could not call %c${e}%c – `;
    return this.player ? this.player[e] || (i += "The method was not available") : i += "The player was not available", console.warn(i, "font-weight: bold", ""), null;
  }
  return this.player[e](...t);
}
function oke(e) {
  return typeof window != "undefined" && typeof window.MediaStream != "undefined" && e instanceof window.MediaStream;
}
function ske(e) {
  return /^blob:/.test(e);
}
function ake(e = document.createElement("video")) {
  const t = /iPhone|iPod/.test(navigator.userAgent) === !1;
  return e.webkitSupportsPresentationMode && typeof e.webkitSetPresentationMode == "function" && t;
}
var BI = Object.defineProperty, lke = Object.getOwnPropertyDescriptor, cke = Object.getOwnPropertyNames, uke = Object.prototype.hasOwnProperty, dke = (e, t) => {
  for (var i in t)
    BI(e, i, { get: t[i], enumerable: !0 });
}, mke = (e, t, i, r) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let n of cke(t))
      !uke.call(e, n) && n !== i && BI(e, n, { get: () => t[n], enumerable: !(r = lke(t, n)) || r.enumerable });
  return e;
}, gke = (e) => mke(BI({}, "__esModule", { value: !0 }), e), PV = {};
dke(PV, {
  AUDIO_EXTENSIONS: () => DI,
  DASH_EXTENSIONS: () => lq,
  FLV_EXTENSIONS: () => cq,
  HLS_EXTENSIONS: () => FI,
  MATCH_URL_DAILYMOTION: () => nq,
  MATCH_URL_FACEBOOK: () => _V,
  MATCH_URL_FACEBOOK_WATCH: () => $V,
  MATCH_URL_KALTURA: () => aq,
  MATCH_URL_MIXCLOUD: () => oq,
  MATCH_URL_MUX: () => XV,
  MATCH_URL_SOUNDCLOUD: () => zV,
  MATCH_URL_STREAMABLE: () => eq,
  MATCH_URL_TWITCH_CHANNEL: () => rq,
  MATCH_URL_TWITCH_VIDEO: () => iq,
  MATCH_URL_VIDYARD: () => sq,
  MATCH_URL_VIMEO: () => HV,
  MATCH_URL_WISTIA: () => tq,
  MATCH_URL_YOUTUBE: () => kC,
  VIDEO_EXTENSIONS: () => OI,
  canPlay: () => pke
});
var hke = gke(PV), cN = _f;
const kC = /(?:youtu\.be\/|youtube(?:-nocookie|education)?\.com\/(?:embed\/|v\/|watch\/|watch\?v=|watch\?.+&v=|shorts\/|live\/))((\w|-){11})|youtube\.com\/playlist\?list=|youtube\.com\/user\//, zV = /(?:soundcloud\.com|snd\.sc)\/[^.]+$/, HV = /vimeo\.com\/(?!progressive_redirect).+/, XV = /stream\.mux\.com\/(?!\w+\.m3u8)(\w+)/, _V = /^https?:\/\/(www\.)?facebook\.com.*\/(video(s)?|watch|story)(\.php?|\/).+$/, $V = /^https?:\/\/fb\.watch\/.+$/, eq = /streamable\.com\/([a-z0-9]+)$/, tq = /(?:wistia\.(?:com|net)|wi\.st)\/(?:medias|embed)\/(?:iframe\/)?([^?]+)/, iq = /(?:www\.|go\.)?twitch\.tv\/videos\/(\d+)($|\?)/, rq = /(?:www\.|go\.)?twitch\.tv\/([a-zA-Z0-9_]+)($|\?)/, nq = /^(?:(?:https?):)?(?:\/\/)?(?:www\.)?(?:(?:dailymotion\.com(?:\/embed)?\/video)|dai\.ly)\/([a-zA-Z0-9]+)(?:_[\w_-]+)?(?:[\w.#_-]+)?/, oq = /mixcloud\.com\/([^/]+\/[^/]+)/, sq = /vidyard.com\/(?:watch\/)?([a-zA-Z0-9-_]+)/, aq = /^https?:\/\/[a-zA-Z]+\.kaltura.(com|org)\/p\/([0-9]+)\/sp\/([0-9]+)00\/embedIframeJs\/uiconf_id\/([0-9]+)\/partner_id\/([0-9]+)(.*)entry_id.([a-zA-Z0-9-_].*)$/, DI = /\.(m4a|m4b|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i, OI = /\.(mp4|og[gv]|webm|mov|m4v)(#t=[,\d+]+)?($|\?)/i, FI = /\.(m3u8)($|\?)/i, lq = /\.(mpd)($|\?)/i, cq = /\.(flv)($|\?)/i, wC = (e) => {
  if (e instanceof Array) {
    for (const t of e)
      if (typeof t == "string" && wC(t) || wC(t.src))
        return !0;
    return !1;
  }
  return (0, cN.isMediaStream)(e) || (0, cN.isBlobUrl)(e) ? !0 : DI.test(e) || OI.test(e) || FI.test(e) || lq.test(e) || cq.test(e);
}, pke = {
  youtube: (e) => e instanceof Array ? e.every((t) => kC.test(t)) : kC.test(e),
  soundcloud: (e) => zV.test(e) && !DI.test(e),
  vimeo: (e) => HV.test(e) && !OI.test(e) && !FI.test(e),
  mux: (e) => XV.test(e),
  facebook: (e) => _V.test(e) || $V.test(e),
  streamable: (e) => eq.test(e),
  wistia: (e) => tq.test(e),
  twitch: (e) => iq.test(e) || rq.test(e),
  dailymotion: (e) => nq.test(e),
  mixcloud: (e) => oq.test(e),
  vidyard: (e) => sq.test(e),
  kaltura: (e) => aq.test(e),
  file: wC
};
var VI = Object.defineProperty, fke = Object.getOwnPropertyDescriptor, Ake = Object.getOwnPropertyNames, yke = Object.prototype.hasOwnProperty, Eke = (e, t) => {
  for (var i in t)
    VI(e, i, { get: t[i], enumerable: !0 });
}, vke = (e, t, i, r) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let n of Ake(t))
      !yke.call(e, n) && n !== i && VI(e, n, { get: () => t[n], enumerable: !(r = fke(t, n)) || r.enumerable });
  return e;
}, bke = (e) => vke(VI({}, "__esModule", { value: !0 }), e), uq = {};
Eke(uq, {
  default: () => xke
});
var Cke = bke(uq), jn = _f, hn = hke, xke = [
  {
    key: "youtube",
    name: "YouTube",
    canPlay: hn.canPlay.youtube,
    lazyPlayer: (0, jn.lazy)(() => import(
      /* webpackChunkName: 'reactPlayerYouTube' */
      "./YouTube-93087f5f.js"
    ).then((e) => e.Y))
  },
  {
    key: "soundcloud",
    name: "SoundCloud",
    canPlay: hn.canPlay.soundcloud,
    lazyPlayer: (0, jn.lazy)(() => import(
      /* webpackChunkName: 'reactPlayerSoundCloud' */
      "./SoundCloud-a4cd4b73.js"
    ).then((e) => e.S))
  },
  {
    key: "vimeo",
    name: "Vimeo",
    canPlay: hn.canPlay.vimeo,
    lazyPlayer: (0, jn.lazy)(() => import(
      /* webpackChunkName: 'reactPlayerVimeo' */
      "./Vimeo-d78a7c95.js"
    ).then((e) => e.V))
  },
  {
    key: "mux",
    name: "Mux",
    canPlay: hn.canPlay.mux,
    lazyPlayer: (0, jn.lazy)(() => import(
      /* webpackChunkName: 'reactPlayerMux' */
      "./Mux-c8809fc6.js"
    ).then((e) => e.M))
  },
  {
    key: "facebook",
    name: "Facebook",
    canPlay: hn.canPlay.facebook,
    lazyPlayer: (0, jn.lazy)(() => import(
      /* webpackChunkName: 'reactPlayerFacebook' */
      "./Facebook-916383f3.js"
    ).then((e) => e.F))
  },
  {
    key: "streamable",
    name: "Streamable",
    canPlay: hn.canPlay.streamable,
    lazyPlayer: (0, jn.lazy)(() => import(
      /* webpackChunkName: 'reactPlayerStreamable' */
      "./Streamable-8151300b.js"
    ).then((e) => e.S))
  },
  {
    key: "wistia",
    name: "Wistia",
    canPlay: hn.canPlay.wistia,
    lazyPlayer: (0, jn.lazy)(() => import(
      /* webpackChunkName: 'reactPlayerWistia' */
      "./Wistia-41cea68c.js"
    ).then((e) => e.W))
  },
  {
    key: "twitch",
    name: "Twitch",
    canPlay: hn.canPlay.twitch,
    lazyPlayer: (0, jn.lazy)(() => import(
      /* webpackChunkName: 'reactPlayerTwitch' */
      "./Twitch-189a2ed7.js"
    ).then((e) => e.T))
  },
  {
    key: "dailymotion",
    name: "DailyMotion",
    canPlay: hn.canPlay.dailymotion,
    lazyPlayer: (0, jn.lazy)(() => import(
      /* webpackChunkName: 'reactPlayerDailyMotion' */
      "./DailyMotion-f60e8a6e.js"
    ).then((e) => e.D))
  },
  {
    key: "mixcloud",
    name: "Mixcloud",
    canPlay: hn.canPlay.mixcloud,
    lazyPlayer: (0, jn.lazy)(() => import(
      /* webpackChunkName: 'reactPlayerMixcloud' */
      "./Mixcloud-bde0219d.js"
    ).then((e) => e.M))
  },
  {
    key: "vidyard",
    name: "Vidyard",
    canPlay: hn.canPlay.vidyard,
    lazyPlayer: (0, jn.lazy)(() => import(
      /* webpackChunkName: 'reactPlayerVidyard' */
      "./Vidyard-baa44d60.js"
    ).then((e) => e.V))
  },
  {
    key: "kaltura",
    name: "Kaltura",
    canPlay: hn.canPlay.kaltura,
    lazyPlayer: (0, jn.lazy)(() => import(
      /* webpackChunkName: 'reactPlayerKaltura' */
      "./Kaltura-7ac6086a.js"
    ).then((e) => e.K))
  },
  {
    key: "file",
    name: "FilePlayer",
    canPlay: hn.canPlay.file,
    canEnablePIP: (e) => hn.canPlay.file(e) && (document.pictureInPictureEnabled || (0, jn.supportsWebKitPresentationMode)()) && !hn.AUDIO_EXTENSIONS.test(e),
    lazyPlayer: (0, jn.lazy)(() => import(
      /* webpackChunkName: 'reactPlayerFilePlayer' */
      "./FilePlayer-a31e7966.js"
    ).then((e) => e.F))
  }
], uN = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function Ike(e, t) {
  return !!(e === t || uN(e) && uN(t));
}
function Ske(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var i = 0; i < e.length; i++)
    if (!Ike(e[i], t[i]))
      return !1;
  return !0;
}
function Rke(e, t) {
  t === void 0 && (t = Ske);
  var i, r = [], n, o = !1;
  function s() {
    for (var a = [], l = 0; l < arguments.length; l++)
      a[l] = arguments[l];
    return o && i === this && t(a, r) || (n = e.apply(this, a), o = !0, i = this, r = a), n;
  }
  return s;
}
const kke = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Rke
}, Symbol.toStringTag, { value: "Module" })), wke = /* @__PURE__ */ NN(kke);
var dq = { exports: {} }, Mke = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED", Nke = Mke, Tke = Nke;
function mq() {
}
function gq() {
}
gq.resetWarningCache = mq;
var Bke = function() {
  function e(r, n, o, s, a, l) {
    if (l !== Tke) {
      var c = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      throw c.name = "Invariant Violation", c;
    }
  }
  e.isRequired = e;
  function t() {
    return e;
  }
  var i = {
    array: e,
    bigint: e,
    bool: e,
    func: e,
    number: e,
    object: e,
    string: e,
    symbol: e,
    any: e,
    arrayOf: t,
    element: e,
    elementType: e,
    instanceOf: t,
    node: e,
    objectOf: t,
    oneOf: t,
    oneOfType: t,
    shape: t,
    exact: t,
    checkPropTypes: gq,
    resetWarningCache: mq
  };
  return i.PropTypes = i, i;
};
dq.exports = Bke();
var qI = dq.exports, Dke = Object.create, $f = Object.defineProperty, Oke = Object.getOwnPropertyDescriptor, Fke = Object.getOwnPropertyNames, Vke = Object.getPrototypeOf, qke = Object.prototype.hasOwnProperty, jke = (e, t) => {
  for (var i in t)
    $f(e, i, { get: t[i], enumerable: !0 });
}, hq = (e, t, i, r) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let n of Fke(t))
      !qke.call(e, n) && n !== i && $f(e, n, { get: () => t[n], enumerable: !(r = Oke(t, n)) || r.enumerable });
  return e;
}, Lke = (e, t, i) => (i = e != null ? Dke(Vke(e)) : {}, hq(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  t || !e || !e.__esModule ? $f(i, "default", { value: e, enumerable: !0 }) : i,
  e
)), Kke = (e) => hq($f({}, "__esModule", { value: !0 }), e), pq = {};
jke(pq, {
  defaultProps: () => Gke,
  propTypes: () => Uke
});
var fq = Kke(pq), Yke = Lke(qI);
const { string: Kr, bool: pn, number: Gu, array: Kv, oneOfType: Zd, shape: so, object: $r, func: br, node: dN } = Yke.default, Uke = {
  url: Zd([Kr, Kv, $r]),
  playing: pn,
  loop: pn,
  controls: pn,
  volume: Gu,
  muted: pn,
  playbackRate: Gu,
  width: Zd([Kr, Gu]),
  height: Zd([Kr, Gu]),
  style: $r,
  progressInterval: Gu,
  playsinline: pn,
  pip: pn,
  stopOnUnmount: pn,
  light: Zd([pn, Kr, $r]),
  playIcon: dN,
  previewTabIndex: Gu,
  previewAriaLabel: Kr,
  fallback: dN,
  oEmbedUrl: Kr,
  wrapper: Zd([
    Kr,
    br,
    so({ render: br.isRequired })
  ]),
  config: so({
    soundcloud: so({
      options: $r
    }),
    youtube: so({
      playerVars: $r,
      embedOptions: $r,
      onUnstarted: br
    }),
    facebook: so({
      appId: Kr,
      version: Kr,
      playerId: Kr,
      attributes: $r
    }),
    dailymotion: so({
      params: $r
    }),
    vimeo: so({
      playerOptions: $r,
      title: Kr
    }),
    mux: so({
      attributes: $r,
      version: Kr
    }),
    file: so({
      attributes: $r,
      tracks: Kv,
      forceVideo: pn,
      forceAudio: pn,
      forceHLS: pn,
      forceSafariHLS: pn,
      forceDisableHls: pn,
      forceDASH: pn,
      forceFLV: pn,
      hlsOptions: $r,
      hlsVersion: Kr,
      dashVersion: Kr,
      flvVersion: Kr
    }),
    wistia: so({
      options: $r,
      playerId: Kr,
      customControls: Kv
    }),
    mixcloud: so({
      options: $r
    }),
    twitch: so({
      options: $r,
      playerId: Kr
    }),
    vidyard: so({
      options: $r
    })
  }),
  onReady: br,
  onStart: br,
  onPlay: br,
  onPause: br,
  onBuffer: br,
  onBufferEnd: br,
  onEnded: br,
  onError: br,
  onDuration: br,
  onSeek: br,
  onPlaybackRateChange: br,
  onPlaybackQualityChange: br,
  onProgress: br,
  onClickPreview: br,
  onEnablePIP: br,
  onDisablePIP: br
}, Yr = () => {
}, Gke = {
  playing: !1,
  loop: !1,
  controls: !1,
  volume: null,
  muted: !1,
  playbackRate: 1,
  width: "640px",
  height: "360px",
  style: {},
  progressInterval: 1e3,
  playsinline: !1,
  pip: !1,
  stopOnUnmount: !0,
  light: !1,
  fallback: null,
  wrapper: "div",
  previewTabIndex: 0,
  previewAriaLabel: "",
  oEmbedUrl: "https://noembed.com/embed?url={url}",
  config: {
    soundcloud: {
      options: {
        visual: !0,
        // Undocumented, but makes player fill container and look better
        buying: !1,
        liking: !1,
        download: !1,
        sharing: !1,
        show_comments: !1,
        show_playcount: !1
      }
    },
    youtube: {
      playerVars: {
        playsinline: 1,
        showinfo: 0,
        rel: 0,
        iv_load_policy: 3,
        modestbranding: 1
      },
      embedOptions: {},
      onUnstarted: Yr
    },
    facebook: {
      appId: "1309697205772819",
      version: "v3.3",
      playerId: null,
      attributes: {}
    },
    dailymotion: {
      params: {
        api: 1,
        "endscreen-enable": !1
      }
    },
    vimeo: {
      playerOptions: {
        autopause: !1,
        byline: !1,
        portrait: !1,
        title: !1
      },
      title: null
    },
    mux: {
      attributes: {},
      version: "2"
    },
    file: {
      attributes: {},
      tracks: [],
      forceVideo: !1,
      forceAudio: !1,
      forceHLS: !1,
      forceDASH: !1,
      forceFLV: !1,
      hlsOptions: {},
      hlsVersion: "1.1.4",
      dashVersion: "3.1.3",
      flvVersion: "1.5.0",
      forceDisableHls: !1
    },
    wistia: {
      options: {},
      playerId: null,
      customControls: null
    },
    mixcloud: {
      options: {
        hide_cover: 1
      }
    },
    twitch: {
      options: {},
      playerId: null
    },
    vidyard: {
      options: {}
    }
  },
  onReady: Yr,
  onStart: Yr,
  onPlay: Yr,
  onPause: Yr,
  onBuffer: Yr,
  onBufferEnd: Yr,
  onEnded: Yr,
  onError: Yr,
  onDuration: Yr,
  onSeek: Yr,
  onPlaybackRateChange: Yr,
  onPlaybackQualityChange: Yr,
  onProgress: Yr,
  onClickPreview: Yr,
  onEnablePIP: Yr,
  onDisablePIP: Yr
};
var Qke = Object.create, Gg = Object.defineProperty, Wke = Object.getOwnPropertyDescriptor, Zke = Object.getOwnPropertyNames, Jke = Object.getPrototypeOf, Pke = Object.prototype.hasOwnProperty, zke = (e, t, i) => t in e ? Gg(e, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[t] = i, Hke = (e, t) => {
  for (var i in t)
    Gg(e, i, { get: t[i], enumerable: !0 });
}, Aq = (e, t, i, r) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let n of Zke(t))
      !Pke.call(e, n) && n !== i && Gg(e, n, { get: () => t[n], enumerable: !(r = Wke(t, n)) || r.enumerable });
  return e;
}, yq = (e, t, i) => (i = e != null ? Qke(Jke(e)) : {}, Aq(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  t || !e || !e.__esModule ? Gg(i, "default", { value: e, enumerable: !0 }) : i,
  e
)), Xke = (e) => Aq(Gg({}, "__esModule", { value: !0 }), e), lr = (e, t, i) => (zke(e, typeof t != "symbol" ? t + "" : t, i), i), Eq = {};
Hke(Eq, {
  default: () => eA
});
var _ke = Xke(Eq), mN = yq(X), $ke = yq(Jx), vq = fq, e3e = _f;
const t3e = 5e3;
class eA extends mN.Component {
  constructor() {
    super(...arguments), lr(this, "mounted", !1), lr(this, "isReady", !1), lr(this, "isPlaying", !1), lr(this, "isLoading", !0), lr(this, "loadOnReady", null), lr(this, "startOnPlay", !0), lr(this, "seekOnPlay", null), lr(this, "onDurationCalled", !1), lr(this, "handlePlayerMount", (t) => {
      if (this.player) {
        this.progress();
        return;
      }
      this.player = t, this.player.load(this.props.url), this.progress();
    }), lr(this, "getInternalPlayer", (t) => this.player ? this.player[t] : null), lr(this, "progress", () => {
      if (this.props.url && this.player && this.isReady) {
        const t = this.getCurrentTime() || 0, i = this.getSecondsLoaded(), r = this.getDuration();
        if (r) {
          const n = {
            playedSeconds: t,
            played: t / r
          };
          i !== null && (n.loadedSeconds = i, n.loaded = i / r), (n.playedSeconds !== this.prevPlayed || n.loadedSeconds !== this.prevLoaded) && this.props.onProgress(n), this.prevPlayed = n.playedSeconds, this.prevLoaded = n.loadedSeconds;
        }
      }
      this.progressTimeout = setTimeout(this.progress, this.props.progressFrequency || this.props.progressInterval);
    }), lr(this, "handleReady", () => {
      if (!this.mounted)
        return;
      this.isReady = !0, this.isLoading = !1;
      const { onReady: t, playing: i, volume: r, muted: n } = this.props;
      t(), !n && r !== null && this.player.setVolume(r), this.loadOnReady ? (this.player.load(this.loadOnReady, !0), this.loadOnReady = null) : i && this.player.play(), this.handleDurationCheck();
    }), lr(this, "handlePlay", () => {
      this.isPlaying = !0, this.isLoading = !1;
      const { onStart: t, onPlay: i, playbackRate: r } = this.props;
      this.startOnPlay && (this.player.setPlaybackRate && r !== 1 && this.player.setPlaybackRate(r), t(), this.startOnPlay = !1), i(), this.seekOnPlay && (this.seekTo(this.seekOnPlay), this.seekOnPlay = null), this.handleDurationCheck();
    }), lr(this, "handlePause", (t) => {
      this.isPlaying = !1, this.isLoading || this.props.onPause(t);
    }), lr(this, "handleEnded", () => {
      const { activePlayer: t, loop: i, onEnded: r } = this.props;
      t.loopOnEnded && i && this.seekTo(0), i || (this.isPlaying = !1, r());
    }), lr(this, "handleError", (...t) => {
      this.isLoading = !1, this.props.onError(...t);
    }), lr(this, "handleDurationCheck", () => {
      clearTimeout(this.durationCheckTimeout);
      const t = this.getDuration();
      t ? this.onDurationCalled || (this.props.onDuration(t), this.onDurationCalled = !0) : this.durationCheckTimeout = setTimeout(this.handleDurationCheck, 100);
    }), lr(this, "handleLoaded", () => {
      this.isLoading = !1;
    });
  }
  componentDidMount() {
    this.mounted = !0;
  }
  componentWillUnmount() {
    clearTimeout(this.progressTimeout), clearTimeout(this.durationCheckTimeout), this.isReady && this.props.stopOnUnmount && (this.player.stop(), this.player.disablePIP && this.player.disablePIP()), this.mounted = !1;
  }
  componentDidUpdate(t) {
    if (!this.player)
      return;
    const { url: i, playing: r, volume: n, muted: o, playbackRate: s, pip: a, loop: l, activePlayer: c, disableDeferredLoading: u } = this.props;
    if (!(0, $ke.default)(t.url, i)) {
      if (this.isLoading && !c.forceLoad && !u && !(0, e3e.isMediaStream)(i)) {
        console.warn(`ReactPlayer: the attempt to load ${i} is being deferred until the player has loaded`), this.loadOnReady = i;
        return;
      }
      this.isLoading = !0, this.startOnPlay = !0, this.onDurationCalled = !1, this.player.load(i, this.isReady);
    }
    !t.playing && r && !this.isPlaying && this.player.play(), t.playing && !r && this.isPlaying && this.player.pause(), !t.pip && a && this.player.enablePIP && this.player.enablePIP(), t.pip && !a && this.player.disablePIP && this.player.disablePIP(), t.volume !== n && n !== null && this.player.setVolume(n), t.muted !== o && (o ? this.player.mute() : (this.player.unmute(), n !== null && setTimeout(() => this.player.setVolume(n)))), t.playbackRate !== s && this.player.setPlaybackRate && this.player.setPlaybackRate(s), t.loop !== l && this.player.setLoop && this.player.setLoop(l);
  }
  getDuration() {
    return this.isReady ? this.player.getDuration() : null;
  }
  getCurrentTime() {
    return this.isReady ? this.player.getCurrentTime() : null;
  }
  getSecondsLoaded() {
    return this.isReady ? this.player.getSecondsLoaded() : null;
  }
  seekTo(t, i, r) {
    if (!this.isReady) {
      t !== 0 && (this.seekOnPlay = t, setTimeout(() => {
        this.seekOnPlay = null;
      }, t3e));
      return;
    }
    if (i ? i === "fraction" : t > 0 && t < 1) {
      const o = this.player.getDuration();
      if (!o) {
        console.warn("ReactPlayer: could not seek using fraction – duration not yet available");
        return;
      }
      this.player.seekTo(o * t, r);
      return;
    }
    this.player.seekTo(t, r);
  }
  render() {
    const t = this.props.activePlayer;
    return t ? /* @__PURE__ */ mN.default.createElement(
      t,
      ee(q({}, this.props), {
        onMount: this.handlePlayerMount,
        onReady: this.handleReady,
        onPlay: this.handlePlay,
        onPause: this.handlePause,
        onEnded: this.handleEnded,
        onLoaded: this.handleLoaded,
        onError: this.handleError
      })
    ) : null;
  }
}
lr(eA, "displayName", "Player");
lr(eA, "propTypes", vq.propTypes);
lr(eA, "defaultProps", vq.defaultProps);
var i3e = Object.create, Qg = Object.defineProperty, r3e = Object.getOwnPropertyDescriptor, n3e = Object.getOwnPropertyNames, o3e = Object.getPrototypeOf, s3e = Object.prototype.hasOwnProperty, a3e = (e, t, i) => t in e ? Qg(e, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[t] = i, l3e = (e, t) => {
  for (var i in t)
    Qg(e, i, { get: t[i], enumerable: !0 });
}, bq = (e, t, i, r) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let n of n3e(t))
      !s3e.call(e, n) && n !== i && Qg(e, n, { get: () => t[n], enumerable: !(r = r3e(t, n)) || r.enumerable });
  return e;
}, Wg = (e, t, i) => (i = e != null ? i3e(o3e(e)) : {}, bq(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  t || !e || !e.__esModule ? Qg(i, "default", { value: e, enumerable: !0 }) : i,
  e
)), c3e = (e) => bq(Qg({}, "__esModule", { value: !0 }), e), ar = (e, t, i) => (a3e(e, typeof t != "symbol" ? t + "" : t, i), i), Cq = {};
l3e(Cq, {
  createReactPlayer: () => y3e
});
var u3e = c3e(Cq), Pu = Wg(X), d3e = Wg(QV), Yv = Wg(wke), gN = Wg(Jx), rm = fq, xq = _f, m3e = Wg(_ke);
const g3e = (0, xq.lazy)(() => import(
  /* webpackChunkName: 'reactPlayerPreview' */
  "./Preview-84333b62.js"
).then((e) => e.P)), h3e = typeof window != "undefined" && window.document && typeof document != "undefined", p3e = typeof yt != "undefined" && yt.window && yt.window.document, f3e = Object.keys(rm.propTypes), A3e = h3e || p3e ? Pu.Suspense : () => null, Jd = [], y3e = (e, t) => {
  var i;
  return i = class extends Pu.Component {
    constructor() {
      super(...arguments), ar(this, "state", {
        showPreview: !!this.props.light
      }), ar(this, "references", {
        wrapper: (r) => {
          this.wrapper = r;
        },
        player: (r) => {
          this.player = r;
        }
      }), ar(this, "handleClickPreview", (r) => {
        this.setState({ showPreview: !1 }), this.props.onClickPreview(r);
      }), ar(this, "showPreview", () => {
        this.setState({ showPreview: !0 });
      }), ar(this, "getDuration", () => this.player ? this.player.getDuration() : null), ar(this, "getCurrentTime", () => this.player ? this.player.getCurrentTime() : null), ar(this, "getSecondsLoaded", () => this.player ? this.player.getSecondsLoaded() : null), ar(this, "getInternalPlayer", (r = "player") => this.player ? this.player.getInternalPlayer(r) : null), ar(this, "seekTo", (r, n, o) => {
        if (!this.player)
          return null;
        this.player.seekTo(r, n, o);
      }), ar(this, "handleReady", () => {
        this.props.onReady(this);
      }), ar(this, "getActivePlayer", (0, Yv.default)((r) => {
        for (const n of [...Jd, ...e])
          if (n.canPlay(r))
            return n;
        return t || null;
      })), ar(this, "getConfig", (0, Yv.default)((r, n) => {
        const { config: o } = this.props;
        return d3e.default.all([
          rm.defaultProps.config,
          rm.defaultProps.config[n] || {},
          o,
          o[n] || {}
        ]);
      })), ar(this, "getAttributes", (0, Yv.default)((r) => (0, xq.omit)(this.props, f3e))), ar(this, "renderActivePlayer", (r) => {
        if (!r)
          return null;
        const n = this.getActivePlayer(r);
        if (!n)
          return null;
        const o = this.getConfig(r, n.key);
        return /* @__PURE__ */ Pu.default.createElement(
          m3e.default,
          ee(q({}, this.props), {
            key: n.key,
            ref: this.references.player,
            config: o,
            activePlayer: n.lazyPlayer || n,
            onReady: this.handleReady
          })
        );
      });
    }
    shouldComponentUpdate(r, n) {
      return !(0, gN.default)(this.props, r) || !(0, gN.default)(this.state, n);
    }
    componentDidUpdate(r) {
      const { light: n } = this.props;
      !r.light && n && this.setState({ showPreview: !0 }), r.light && !n && this.setState({ showPreview: !1 });
    }
    renderPreview(r) {
      if (!r)
        return null;
      const { light: n, playIcon: o, previewTabIndex: s, oEmbedUrl: a, previewAriaLabel: l } = this.props;
      return /* @__PURE__ */ Pu.default.createElement(
        g3e,
        {
          url: r,
          light: n,
          playIcon: o,
          previewTabIndex: s,
          previewAriaLabel: l,
          oEmbedUrl: a,
          onClick: this.handleClickPreview
        }
      );
    }
    render() {
      const { url: r, style: n, width: o, height: s, fallback: a, wrapper: l } = this.props, { showPreview: c } = this.state, u = this.getAttributes(r), m = typeof l == "string" ? this.references.wrapper : void 0;
      return /* @__PURE__ */ Pu.default.createElement(l, q({ ref: m, style: ee(q({}, n), { width: o, height: s }) }, u), /* @__PURE__ */ Pu.default.createElement(A3e, { fallback: a }, c ? this.renderPreview(r) : this.renderActivePlayer(r)));
    }
  }, ar(i, "displayName", "ReactPlayer"), ar(i, "propTypes", rm.propTypes), ar(i, "defaultProps", rm.defaultProps), ar(i, "addCustomPlayer", (r) => {
    Jd.push(r);
  }), ar(i, "removeCustomPlayers", () => {
    Jd.length = 0;
  }), ar(i, "canPlay", (r) => {
    for (const n of [...Jd, ...e])
      if (n.canPlay(r))
        return !0;
    return !1;
  }), ar(i, "canEnablePIP", (r) => {
    for (const n of [...Jd, ...e])
      if (n.canEnablePIP && n.canEnablePIP(r))
        return !0;
    return !1;
  }), i;
};
var E3e = Object.create, tA = Object.defineProperty, v3e = Object.getOwnPropertyDescriptor, b3e = Object.getOwnPropertyNames, C3e = Object.getPrototypeOf, x3e = Object.prototype.hasOwnProperty, I3e = (e, t) => {
  for (var i in t)
    tA(e, i, { get: t[i], enumerable: !0 });
}, Iq = (e, t, i, r) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let n of b3e(t))
      !x3e.call(e, n) && n !== i && tA(e, n, { get: () => t[n], enumerable: !(r = v3e(t, n)) || r.enumerable });
  return e;
}, S3e = (e, t, i) => (i = e != null ? E3e(C3e(e)) : {}, Iq(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  t || !e || !e.__esModule ? tA(i, "default", { value: e, enumerable: !0 }) : i,
  e
)), R3e = (e) => Iq(tA({}, "__esModule", { value: !0 }), e), Sq = {};
I3e(Sq, {
  default: () => N3e
});
var k3e = R3e(Sq), MC = S3e(Cke), w3e = u3e;
const M3e = MC.default[MC.default.length - 1];
var N3e = (0, w3e.createReactPlayer)(MC.default, M3e);
const T3e = /* @__PURE__ */ Ho(k3e), B3e = "_VideoSlideshow_em14x_1", D3e = "_VideoSlideshow__info_em14x_11", O3e = "_VideoSlideshow__imgWrapper_em14x_19", F3e = "_VideoSlideshow__img_em14x_19", V3e = "_VideoSlideshow__title_em14x_31", q3e = "_VideoSlideshow__videoWrapper_em14x_38", j3e = "_VideoSlideshow__video_em14x_38", L3e = "_VideoSlideshow__videoPlayer_em14x_48", K3e = "_VideoSlideshow__playIconWrapper_em14x_61", Y3e = "_VideoSlideshow__playIcon_em14x_61", Rs = {
  VideoSlideshow: B3e,
  VideoSlideshow__info: D3e,
  VideoSlideshow__imgWrapper: O3e,
  VideoSlideshow__img: F3e,
  VideoSlideshow__title: V3e,
  VideoSlideshow__videoWrapper: q3e,
  VideoSlideshow__video: j3e,
  VideoSlideshow__videoPlayer: L3e,
  VideoSlideshow__playIconWrapper: K3e,
  VideoSlideshow__playIcon: Y3e
};
function U3e() {
  return /* @__PURE__ */ f("div", { className: Rs.VideoSlideshow__playIconWrapper, children: /* @__PURE__ */ f(Mt, { className: Rs.VideoSlideshow__playIcon, width: 96, height: 96, icon: "youtube-logo-gray.svg" }) });
}
const NC = { transition: "opacity 0.5s" }, G3e = ee(q({}, NC), { opacity: "0" });
function l7e(n) {
  var o = n, { videos: e, maxVideoDuration: t = 10 * 1e3, className: i } = o, r = Fe(o, ["videos", "maxVideoDuration", "className"]);
  const [s, a] = se(!0), [l, c] = se(!0), [u, m] = se(0), g = we(() => e[u], [e, u]), h = Ne(), [A, y] = se(NC), E = ye(() => {
    typeof window != "undefined" && (y(G3e), c(!1), h.current = setTimeout(() => {
      m((v) => (v + 1) % e.length), c(!0), y(NC);
    }, 500));
  }, [e, m, s]);
  return be(() => {
    if (typeof window != "undefined" && !s)
      return;
    const v = setTimeout(E, t);
    return () => {
      clearTimeout(v);
    };
  }, [t, E, u]), be(
    () => () => {
      clearTimeout(h.current);
    },
    []
  ), /* @__PURE__ */ V("div", ee(q({ className: me(Rs.VideoSlideshow, i) }, r), { children: [
    /* @__PURE__ */ V("div", { className: Rs.VideoSlideshow__info, children: [
      g.image ? /* @__PURE__ */ f(
        "div",
        {
          style: q({ backgroundColor: g.bkgColor }, A),
          className: Rs.VideoSlideshow__imgWrapper,
          children: /* @__PURE__ */ f("img", { className: Rs.VideoSlideshow__img, height: 32, src: g.image })
        }
      ) : null,
      /* @__PURE__ */ f("div", { style: A, className: Rs.VideoSlideshow__title, children: g.title })
    ] }),
    /* @__PURE__ */ f("div", { className: Rs.VideoSlideshow__videoWrapper, children: /* @__PURE__ */ V(
      "div",
      {
        style: A,
        className: Rs.VideoSlideshow__video,
        onClick: () => {
          a(!1), c((v) => !v);
        },
        children: [
          /* @__PURE__ */ f(
            T3e,
            {
              className: Rs.VideoSlideshow__videoPlayer,
              width: "100%",
              height: "100%",
              playing: l,
              muted: !0,
              url: g.url,
              onEnded: () => {
                s && E();
              }
            }
          ),
          !l && !s ? /* @__PURE__ */ f(U3e, {}) : null
        ]
      }
    ) })
  ] }));
}
const TC = [
  {
    id: "StrIntFourb",
    name: "Druid",
    disabled: !0,
    ascendancies: [
      {
        id: "Druid1",
        name: "[DNT] Netter",
        flavour_colour: "207,189,138"
      },
      {
        id: "Druid2",
        name: "[DNT] Poacher",
        flavour_colour: "207,189,138"
      },
      {
        id: "Druid3",
        name: "[DNT] Wildfowler",
        flavour_colour: "207,189,138"
      }
    ]
  },
  {
    id: "StrDexFour",
    name: "Duelist",
    disabled: !0,
    ascendancies: [
      {
        id: "Duelist1",
        name: "[DNT] Giller",
        flavour_colour: "150,175,200"
      },
      {
        id: "Duelist2",
        name: "[DNT] Filleter",
        flavour_colour: "150,175,200"
      },
      {
        id: "Duelist3",
        name: "[DNT] Waterman",
        flavour_colour: "150,175,200"
      }
    ]
  },
  {
    id: "DexFourb",
    name: "Huntress",
    ascendancies: [
      {
        id: "Huntress1",
        name: "Amazon",
        flavour_colour: "220,245,203"
      },
      {
        id: "Huntress2",
        name: "[DNT] Harpooner",
        disabled: !0,
        flavour_colour: "124,179,118"
      },
      {
        id: "Huntress3",
        name: "Ritualist",
        flavour_colour: "240,229,255"
      }
    ]
  },
  {
    id: "StrFour",
    name: "Marauder",
    disabled: !0,
    ascendancies: [
      {
        id: "Marauder1",
        name: "[DNT] Bait Fisher",
        flavour_colour: "175,90,50"
      },
      {
        id: "Marauder2",
        name: "[DNT] Handliner",
        flavour_colour: "175,90,50"
      },
      {
        id: "Marauder3",
        name: "[DNT] Rodman",
        flavour_colour: "175,90,50"
      }
    ]
  },
  {
    id: "StrDexFourb",
    name: "Mercenary",
    ascendancies: [
      {
        id: "Mercenary1",
        name: "Tactician",
        flavour_colour: "240,230,174"
      },
      {
        id: "Mercenary2",
        name: "Witchhunter",
        flavour_colour: "189,233,225"
      },
      {
        id: "Mercenary3",
        name: "Gemling Legionnaire",
        flavour_colour: "224,221,179"
      }
    ]
  },
  {
    id: "DexIntFourb",
    name: "Monk",
    ascendancies: [
      {
        id: "Monk1",
        name: "Surf Caster",
        disabled: !0,
        flavour_colour: "114,129,141"
      },
      {
        id: "Monk2",
        name: "Invoker",
        flavour_colour: "199,184,238"
      },
      {
        id: "Monk3",
        name: "Acolyte of Chayula",
        flavour_colour: "255,211,220"
      }
    ]
  },
  {
    id: "DexFour",
    name: "Ranger",
    ascendancies: [
      {
        id: "Ranger1",
        name: "Deadeye",
        flavour_colour: "206,205,255"
      },
      {
        id: "Ranger2",
        name: "[DNT] Piscator",
        disabled: !0,
        flavour_colour: "124,179,118"
      },
      {
        id: "Ranger3",
        name: "Pathfinder",
        flavour_colour: "159,234,178"
      }
    ]
  },
  {
    id: "DexIntFour",
    name: "Shadow",
    disabled: !0,
    ascendancies: [
      {
        id: "Shadow1",
        name: "[DNT] Ice Fisher",
        flavour_colour: "114,129,141"
      },
      {
        id: "Shadow2",
        name: "[DNT] Longliner",
        flavour_colour: "114,129,141"
      },
      {
        id: "Shadow3",
        name: "[DNT] Dredger",
        flavour_colour: "114,129,141"
      }
    ]
  },
  {
    id: "IntFourb",
    name: "Sorceress",
    ascendancies: [
      {
        id: "Sorceress1",
        name: "Stormweaver",
        flavour_colour: "227,191,255"
      },
      {
        id: "Sorceress2",
        name: "Chronomancer",
        flavour_colour: "191,209,255"
      },
      {
        id: "Sorceress3",
        name: "[DNT] Kite Fisher",
        disabled: !0,
        flavour_colour: "154,195,201"
      }
    ]
  },
  {
    id: "StrIntFour",
    name: "Templar",
    disabled: !0,
    ascendancies: [
      {
        id: "Templar1",
        name: "[DNT] Seaman",
        flavour_colour: "207,189,138"
      },
      {
        id: "Templar2",
        name: "[DNT] Trawler",
        flavour_colour: "207,189,138"
      },
      {
        id: "Templar3",
        name: "[DNT] Boatman",
        flavour_colour: "207,189,138"
      }
    ]
  },
  {
    id: "StrFourb",
    name: "Warrior",
    ascendancies: [
      {
        id: "Warrior1",
        name: "Titan",
        flavour_colour: "246,184,138"
      },
      {
        id: "Warrior2",
        name: "Warbringer",
        flavour_colour: "221,193,163"
      },
      {
        id: "Warrior3",
        name: "Smith of Kitava",
        flavour_colour: "120,179,173"
      }
    ]
  },
  {
    id: "IntFour",
    name: "Witch",
    ascendancies: [
      {
        id: "Witch1",
        name: "Infernalist",
        flavour_colour: "255,165,126"
      },
      {
        id: "Witch2",
        name: "Blood Mage",
        flavour_colour: "234,213,159"
      },
      {
        id: "Witch3",
        name: "Lich",
        flavour_colour: "214,229,254"
      }
    ]
  }
], Rq = (e) => e.toLowerCase().split(" ").join("-"), kq = (e) => `${fi().assetPath}/images/poe2/ascendancy/${Rq(e)}.webp`, wq = (e) => `${fi().assetPath}/images/poe2/ascendancy-bkg/${Rq(e)}.webp`;
function Q3e(e) {
  let [t, i, r, n] = [0, 0, 0, 0];
  for (const o of Object.values(e.ascendancies)) {
    const s = o.flavour_colour.split(",").map(Number);
    t += s[0], i += s[1], r += s[2], n += 1;
  }
  return n ? [t, i, r].map((o) => Math.round(o / n)).join(",") : "255,255,255";
}
const W3e = "_AscendancySelect_rkjna_1", Z3e = "_AscendancySelect__patternBkg_rkjna_9", J3e = "_AscendancySelect__charBkg_rkjna_10", P3e = "_AscendancySelect__content_rkjna_30", z3e = "_AscendancySelect__title_rkjna_38", H3e = "_AscendancySelect__list_rkjna_46", X3e = "_AscendancySelect__item_rkjna_52", _3e = "_AscendancySelect__icon_rkjna_61", $3e = "_AscendancySelect__label_rkjna_73", xs = {
  AscendancySelect: W3e,
  AscendancySelect__patternBkg: Z3e,
  AscendancySelect__charBkg: J3e,
  AscendancySelect__content: P3e,
  AscendancySelect__title: z3e,
  AscendancySelect__list: H3e,
  AscendancySelect__item: X3e,
  AscendancySelect__icon: _3e,
  AscendancySelect__label: $3e,
  "AscendancySelect__item--active": "_AscendancySelect__item--active_rkjna_88"
}, e4e = (e) => e ? `linear-gradient(90deg, #0a0a0a 0%, transparent 50%, #0a0a0a 100%), url("${wq(e)}")` : void 0, t4e = () => `linear-gradient(90deg, rgb(10, 10, 10) 5%, transparent 10%), url("${fi().assetPath}/images/poe2/build-guides/poe2-passives-3.webp")`;
function c7e(o) {
  var s = o, {
    baseClass: e,
    value: t,
    onChange: i,
    className: r
  } = s, n = Fe(s, [
    "baseClass",
    "value",
    "onChange",
    "className"
  ]);
  const a = TC.find((u) => u.id === e), l = a == null ? void 0 : a.ascendancies.find((u) => u.id === t), c = we(() => ((a == null ? void 0 : a.ascendancies) || []).filter((u) => !u.name.includes("[DNT]") && !u.disabled).sort((u, m) => u.name.localeCompare(m.name)), [a]);
  return /* @__PURE__ */ V("div", ee(q({ className: me(xs.AscendancySelect, r) }, n), { children: [
    l != null && l.name ? /* @__PURE__ */ f(
      "div",
      {
        style: { backgroundImage: e4e(l.name) },
        className: xs.AscendancySelect__charBkg
      }
    ) : /* @__PURE__ */ f("div", { style: { backgroundImage: t4e() }, className: xs.AscendancySelect__patternBkg }),
    /* @__PURE__ */ V("div", { className: xs.AscendancySelect__content, children: [
      /* @__PURE__ */ f("div", { className: xs.AscendancySelect__title, children: "Select your Ascendancy" }),
      /* @__PURE__ */ f("div", { className: xs.AscendancySelect__list, children: c.map((u) => /* @__PURE__ */ V(
        "div",
        {
          style: { color: `rgb(${u.flavour_colour})` },
          className: me(
            xs.AscendancySelect__item,
            t === u.id && xs["AscendancySelect__item--active"]
          ),
          onClick: () => i(t === u.id ? void 0 : u.id),
          children: [
            /* @__PURE__ */ f(
              "div",
              {
                className: xs.AscendancySelect__icon,
                style: { backgroundImage: `url(${kq(u.name)})` }
              }
            ),
            /* @__PURE__ */ f("div", { className: xs.AscendancySelect__label, children: /* @__PURE__ */ f("span", { children: u.name }) })
          ]
        },
        u.id
      )) })
    ] })
  ] }));
}
const i4e = "_ClassSelect_1c0q3_1", r4e = "_ClassSelect__patternBkg_1c0q3_10", n4e = "_ClassSelect__charBkg_1c0q3_11", o4e = "_ClassSelect__content_1c0q3_29", s4e = "_ClassSelect__title_1c0q3_36", a4e = "_ClassSelect__list_1c0q3_43", l4e = "_ClassSelect__item_1c0q3_49", c4e = "_ClassSelect__icon_1c0q3_59", u4e = "_ClassSelect__label_1c0q3_70", ns = {
  ClassSelect: i4e,
  ClassSelect__patternBkg: r4e,
  ClassSelect__charBkg: n4e,
  ClassSelect__content: o4e,
  ClassSelect__title: s4e,
  ClassSelect__list: a4e,
  ClassSelect__item: l4e,
  "ClassSelect__item--disabled": "_ClassSelect__item--disabled_1c0q3_56",
  ClassSelect__icon: c4e,
  ClassSelect__label: u4e,
  "ClassSelect__item--active": "_ClassSelect__item--active_1c0q3_82"
}, d4e = (e) => e ? `linear-gradient(90deg, rgb(10, 10, 10) 5%, transparent 10%), url("${wq(e)}")` : void 0, m4e = () => `url("${fi().assetPath}/images/poe2/build-guides/poe2-default-class-icon.webp")`, g4e = () => `linear-gradient(90deg, rgb(10, 10, 10) 5%, transparent 10%), url("${fi().assetPath}/images/poe2/build-guides/poe2-passives-3.webp")`;
function u7e(n) {
  var o = n, {
    value: e,
    onChange: t,
    className: i
  } = o, r = Fe(o, [
    "value",
    "onChange",
    "className"
  ]);
  const s = TC.find((a) => a.id === e);
  return /* @__PURE__ */ V("div", ee(q({ className: me(ns.ClassSelect, i) }, r), { children: [
    /* @__PURE__ */ f("div", { style: { backgroundImage: g4e() }, className: ns.ClassSelect__patternBkg }),
    /* @__PURE__ */ f("div", { style: { backgroundImage: d4e(s == null ? void 0 : s.name) }, className: ns.ClassSelect__charBkg }),
    /* @__PURE__ */ V("div", { className: ns.ClassSelect__content, children: [
      /* @__PURE__ */ f("div", { className: ns.ClassSelect__title, children: "Select your Class" }),
      /* @__PURE__ */ f(Pr, { type: "horizontal", innerClassName: ns.ClassSelect__list, children: TC.map((a) => /* @__PURE__ */ V(
        "div",
        {
          style: { color: `rgb(${Q3e(a)})` },
          className: me(
            ns.ClassSelect__item,
            a.disabled && ns["ClassSelect__item--disabled"],
            e === a.id && ns["ClassSelect__item--active"]
          ),
          onClick: () => !a.disabled && t(e === a.id ? void 0 : a.id),
          children: [
            /* @__PURE__ */ f(
              "div",
              {
                className: ns.ClassSelect__icon,
                style: a.disabled ? { backgroundImage: m4e() } : { backgroundImage: `url(${kq(a.name)})` }
              }
            ),
            /* @__PURE__ */ f("div", { className: ns.ClassSelect__label, children: /* @__PURE__ */ f("span", { children: a.name }) })
          ]
        },
        a.id
      )) })
    ] })
  ] }));
}
const BC = [
  {
    id: "primalist",
    name: "Primalist",
    masteries: [
      {
        id: "beastmaster",
        name: "Beastmaster"
      },
      {
        id: "shaman",
        name: "Shaman"
      },
      {
        id: "druid",
        name: "Druid"
      }
    ]
  },
  {
    id: "mage",
    name: "Mage",
    masteries: [
      {
        id: "sorcerer",
        name: "Sorcerer"
      },
      {
        id: "spellblade",
        name: "Spellblade"
      },
      {
        id: "runemaster",
        name: "Runemaster"
      }
    ]
  },
  {
    id: "sentinel",
    name: "Sentinel",
    masteries: [
      {
        id: "void-knight",
        name: "Void Knight"
      },
      {
        id: "forge-guard",
        name: "Forge Guard"
      },
      {
        id: "paladin",
        name: "Paladin"
      }
    ]
  },
  {
    id: "acolyte",
    name: "Acolyte",
    masteries: [
      {
        id: "necromancer",
        name: "Necromancer"
      },
      {
        id: "lich",
        name: "Lich"
      },
      {
        id: "warlock",
        name: "Warlock"
      }
    ]
  },
  {
    id: "rogue",
    name: "Rogue",
    masteries: [
      {
        id: "bladedancer",
        name: "Bladedancer"
      },
      {
        id: "marksman",
        name: "Marksman"
      },
      {
        id: "falconer",
        name: "Falconer"
      }
    ]
  }
], Mq = (e) => e.toLowerCase().split(" ").join("-"), Nq = (e) => `${fi().assetPath}/images/icons/last-epoch/classes/${e === "Bladedancer" ? "blademaster" : Mq(e)}-icon.webp`, h4e = (e) => `${fi().assetPath}/leplanner/assets/images/banners/${Mq(e)}.webp`, p4e = "_ClassSelect_5yxu4_1", f4e = "_ClassSelect__charBkg_5yxu4_10", A4e = "_ClassSelect__content_5yxu4_23", y4e = "_ClassSelect__title_5yxu4_30", E4e = "_ClassSelect__list_5yxu4_37", v4e = "_ClassSelect__item_5yxu4_42", b4e = "_ClassSelect__icon_5yxu4_52", C4e = "_ClassSelect__label_5yxu4_64", ha = {
  ClassSelect: p4e,
  ClassSelect__charBkg: f4e,
  ClassSelect__content: A4e,
  ClassSelect__title: y4e,
  ClassSelect__list: E4e,
  ClassSelect__item: v4e,
  "ClassSelect__item--disabled": "_ClassSelect__item--disabled_5yxu4_49",
  ClassSelect__icon: b4e,
  ClassSelect__label: C4e,
  "ClassSelect__item--active": "_ClassSelect__item--active_5yxu4_76"
}, x4e = (e) => e ? `linear-gradient(90deg, rgb(10, 10, 10) 5%, transparent 10%), url("${h4e(e)}")` : void 0;
function d7e(n) {
  var o = n, {
    value: e,
    onChange: t,
    className: i
  } = o, r = Fe(o, [
    "value",
    "onChange",
    "className"
  ]);
  const s = BC.find((a) => a.id === e);
  return /* @__PURE__ */ V("div", ee(q({ className: me(ha.ClassSelect, i) }, r), { children: [
    /* @__PURE__ */ f("div", { style: { backgroundImage: x4e(s == null ? void 0 : s.name) }, className: ha.ClassSelect__charBkg }),
    /* @__PURE__ */ V("div", { className: ha.ClassSelect__content, children: [
      /* @__PURE__ */ f("div", { className: ha.ClassSelect__title, children: "Select your Class" }),
      /* @__PURE__ */ f(Pr, { type: "horizontal", innerClassName: ha.ClassSelect__list, children: BC.map((a) => /* @__PURE__ */ V(
        "div",
        {
          className: me(ha.ClassSelect__item, e === a.id && ha["ClassSelect__item--active"]),
          onClick: () => t(e === a.id ? void 0 : a.id),
          children: [
            /* @__PURE__ */ f(
              "div",
              {
                className: ha.ClassSelect__icon,
                style: { backgroundImage: `url(${Nq(a.name)})` }
              }
            ),
            /* @__PURE__ */ f("div", { className: ha.ClassSelect__label, children: /* @__PURE__ */ f("span", { children: a.name }) })
          ]
        },
        a.id
      )) })
    ] })
  ] }));
}
const I4e = "_MasterySelect_16asc_1", S4e = "_MasterySelect__patternBkg_16asc_9", R4e = "_MasterySelect__charBkg_16asc_10", k4e = "_MasterySelect__content_16asc_30", w4e = "_MasterySelect__title_16asc_38", M4e = "_MasterySelect__list_16asc_46", N4e = "_MasterySelect__item_16asc_52", T4e = "_MasterySelect__icon_16asc_61", B4e = "_MasterySelect__label_16asc_74", pa = {
  MasterySelect: I4e,
  MasterySelect__patternBkg: S4e,
  MasterySelect__charBkg: R4e,
  MasterySelect__content: k4e,
  MasterySelect__title: w4e,
  MasterySelect__list: M4e,
  MasterySelect__item: N4e,
  MasterySelect__icon: T4e,
  MasterySelect__label: B4e,
  "MasterySelect__item--active": "_MasterySelect__item--active_16asc_89"
}, D4e = () => `linear-gradient(90deg, rgb(10, 10, 10) 5%, transparent 10%), url("${fi().assetPath}/leplanner/assets/images/banners/ascendancy-base.webp")`;
function m7e(o) {
  var s = o, {
    baseClass: e,
    value: t,
    onChange: i,
    className: r
  } = s, n = Fe(s, [
    "baseClass",
    "value",
    "onChange",
    "className"
  ]);
  const a = BC.find((c) => c.id === e), l = we(() => (a == null ? void 0 : a.masteries) || [], [a]);
  return /* @__PURE__ */ V("div", ee(q({ className: me(pa.MasterySelect, r) }, n), { children: [
    /* @__PURE__ */ f("div", { style: { backgroundImage: D4e() }, className: pa.MasterySelect__patternBkg }),
    /* @__PURE__ */ V("div", { className: pa.MasterySelect__content, children: [
      /* @__PURE__ */ f("div", { className: pa.MasterySelect__title, children: "Select your Mastery" }),
      /* @__PURE__ */ f("div", { className: pa.MasterySelect__list, children: l.map((c) => /* @__PURE__ */ V(
        "div",
        {
          className: me(
            pa.MasterySelect__item,
            t === c.id && pa["MasterySelect__item--active"]
          ),
          onClick: () => i(t === c.id ? void 0 : c.id),
          children: [
            /* @__PURE__ */ f(
              "div",
              {
                className: pa.MasterySelect__icon,
                style: { backgroundImage: `url(${Nq(c.name)})` }
              }
            ),
            /* @__PURE__ */ f("div", { className: pa.MasterySelect__label, children: /* @__PURE__ */ f("span", { children: c.name }) })
          ]
        },
        c.id
      )) })
    ] })
  ] }));
}
const O4e = [
  { id: "2", name: "Barbarian", color: "126,34,34" },
  { id: "1", name: "Druid", color: "126,84,34" },
  { id: "4", name: "Necromancer", color: "34,126,65" },
  { id: "3", name: "Rogue", color: "93,37,165" },
  { id: "0", name: "Sorcerer", color: "35,84,158" },
  { id: "5", name: "Spiritborn", color: "0,167,108" }
], F4e = (e) => e.toLowerCase().split(" ").join("-"), V4e = (e) => `${fi().assetPath}/images/d4/classes/${F4e(e)}.webp?3`, q4e = "_ClassSelect_clgcr_1", j4e = "_ClassSelect__patternBkg_clgcr_10", L4e = "_ClassSelect__charBkg_clgcr_11", K4e = "_ClassSelect__content_clgcr_32", Y4e = "_ClassSelect__title_clgcr_39", U4e = "_ClassSelect__list_clgcr_46", G4e = "_ClassSelect__item_clgcr_51", Q4e = "_ClassSelect__icon_clgcr_60", W4e = "_ClassSelect__label_clgcr_71", fn = {
  ClassSelect: q4e,
  ClassSelect__patternBkg: j4e,
  ClassSelect__charBkg: L4e,
  ClassSelect__content: K4e,
  ClassSelect__title: Y4e,
  ClassSelect__list: U4e,
  ClassSelect__item: G4e,
  "ClassSelect__item--disabled": "_ClassSelect__item--disabled_clgcr_57",
  ClassSelect__icon: Q4e,
  ClassSelect__label: W4e,
  "ClassSelect__item--all": "_ClassSelect__item--all_clgcr_83",
  "ClassSelect__item--active": "_ClassSelect__item--active_clgcr_89"
}, Z4e = () => `linear-gradient(90deg, transparent 35%, rgb(10, 10, 10) 50%), url("${fi().assetPath}/images/d4/build-guides/d4-bkg-1.webp")`, J4e = () => `linear-gradient(90deg, rgb(10, 10, 10) 0%, transparent 50%), url("${fi().assetPath}/images/d4/build-guides/d4-classes-bkg-3.webp")`;
function g7e(n) {
  var o = n, {
    value: e,
    onChange: t,
    className: i
  } = o, r = Fe(o, [
    "value",
    "onChange",
    "className"
  ]);
  return /* @__PURE__ */ V("div", ee(q({ className: me(fn.ClassSelect, i) }, r), { children: [
    /* @__PURE__ */ f("div", { style: { backgroundImage: Z4e() }, className: fn.ClassSelect__patternBkg }),
    /* @__PURE__ */ f("div", { style: { backgroundImage: J4e() }, className: fn.ClassSelect__charBkg }),
    /* @__PURE__ */ V("div", { className: fn.ClassSelect__content, children: [
      /* @__PURE__ */ f("div", { className: fn.ClassSelect__title, children: "Select your Class" }),
      /* @__PURE__ */ V(Pr, { type: "horizontal", innerClassName: fn.ClassSelect__list, children: [
        /* @__PURE__ */ V(
          "div",
          {
            style: { color: "rgb(255,255,255)" },
            className: me(
              fn.ClassSelect__item,
              fn["ClassSelect__item--all"],
              e === void 0 && fn["ClassSelect__item--active"]
            ),
            onClick: () => t(void 0),
            children: [
              /* @__PURE__ */ f(
                "div",
                {
                  className: fn.ClassSelect__icon,
                  style: { backgroundImage: `url(${fi().assetPath}/images/d4/build-guides/d4-classes-bkg.webp)` }
                }
              ),
              /* @__PURE__ */ f("div", { className: fn.ClassSelect__label, children: /* @__PURE__ */ f("span", { children: "All Classes" }) })
            ]
          }
        ),
        O4e.map((s) => /* @__PURE__ */ V(
          "div",
          {
            style: { color: "rgb(255,255,255)" },
            className: me(fn.ClassSelect__item, e === s.id && fn["ClassSelect__item--active"]),
            onClick: () => t(e === s.id ? void 0 : s.id),
            children: [
              /* @__PURE__ */ f(
                "div",
                {
                  className: fn.ClassSelect__icon,
                  style: { backgroundImage: `url(${V4e(s.name)})` }
                }
              ),
              /* @__PURE__ */ f("div", { className: fn.ClassSelect__label, children: /* @__PURE__ */ f("span", { children: s.name }) })
            ]
          },
          s.id
        ))
      ] })
    ] })
  ] }));
}
function h7e() {
  if (typeof document == "undefined")
    return;
  const e = document.createElement("script");
  e.src = "https://s.nitropay.com/ads-1541.js", e.async = !0, e.setAttribute("data-cfasync", "false"), document.head.appendChild(e);
}
function P4e(e, t, i) {
  for (const r of t)
    if (r.accept(e))
      return Ei(r.render, { shortcode: e });
  return console.log("Missing handler for shortcode", e, `in text: ${i}`), e.content;
}
function p7e({ text: e, handlers: t }) {
  const i = _T(e);
  if (i.length === 0)
    return e;
  let r = [], n = e;
  return i.forEach((o) => {
    const s = P4e(o, t, e);
    let a;
    o.attributes.id !== void 0 ? a = new RegExp(
      `\\[${o.type} id=${o.attributes.id}.*?\\[\\/${o.type}\\]`,
      "g"
    ) : a = new RegExp(`\\[${o.type}.*?\\[\\/${o.type}\\]`, "g");
    const l = [...n.matchAll(a)][0];
    (l == null ? void 0 : l.index) !== void 0 && (r.push(n.substring(0, l.index)), r.push(s), n = n.substring(l.index + l[0].length));
  }), r.push(n), /* @__PURE__ */ f(gt, { children: r.map((o, s) => /* @__PURE__ */ f("span", { children: o }, s)) });
}
const f7e = (e) => {
  var t;
  return e ? ((t = e.subscription) == null ? void 0 : t.status) === "active" : !1;
};
var jI = {}, Zg = {}, ms = {};
Object.defineProperty(ms, "__esModule", {
  value: !0
});
ms.FrameContextConsumer = ms.FrameContextProvider = ms.useFrame = ms.FrameContext = void 0;
var z4e = X, Tq = H4e(z4e);
function H4e(e) {
  return e && e.__esModule ? e : { default: e };
}
var Bq = void 0, Dq = void 0;
typeof document != "undefined" && (Bq = document);
typeof window != "undefined" && (Dq = window);
var LI = ms.FrameContext = Tq.default.createContext({ document: Bq, window: Dq });
ms.useFrame = function() {
  return Tq.default.useContext(LI);
};
var X4e = LI.Provider, _4e = LI.Consumer;
ms.FrameContextProvider = X4e;
ms.FrameContextConsumer = _4e;
var KI = {};
Object.defineProperty(KI, "__esModule", {
  value: !0
});
var $4e = function() {
  function e(t, i) {
    for (var r = 0; r < i.length; r++) {
      var n = i[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
    }
  }
  return function(t, i, r) {
    return i && e(t.prototype, i), r && e(t, r), t;
  };
}(), DC = X;
Oq(DC);
var ewe = qI, Uv = Oq(ewe);
function Oq(e) {
  return e && e.__esModule ? e : { default: e };
}
function twe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function iwe(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function rwe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var Fq = function(e) {
  rwe(t, e);
  function t() {
    return twe(this, t), iwe(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
  }
  return $4e(t, [{
    key: "componentDidMount",
    value: function() {
      this.props.contentDidMount();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.props.contentDidUpdate();
    }
  }, {
    key: "render",
    value: function() {
      return DC.Children.only(this.props.children);
    }
  }]), t;
}(DC.Component);
Fq.propTypes = {
  children: Uv.default.element.isRequired,
  contentDidMount: Uv.default.func.isRequired,
  contentDidUpdate: Uv.default.func.isRequired
};
KI.default = Fq;
Object.defineProperty(Zg, "__esModule", {
  value: !0
});
Zg.Frame = void 0;
var OC = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t];
    for (var r in i)
      Object.prototype.hasOwnProperty.call(i, r) && (e[r] = i[r]);
  }
  return e;
}, nwe = function() {
  function e(t, i) {
    for (var r = 0; r < i.length; r++) {
      var n = i[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
    }
  }
  return function(t, i, r) {
    return i && e(t.prototype, i), r && e(t, r), t;
  };
}(), Vq = X, bc = iA(Vq), owe = Kl, hN = iA(owe), swe = qI, Is = iA(swe), awe = ms, lwe = KI, cwe = iA(lwe);
function iA(e) {
  return e && e.__esModule ? e : { default: e };
}
function uwe(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function dwe(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function mwe(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var YI = Zg.Frame = function(e) {
  mwe(t, e);
  function t(i, r) {
    uwe(this, t);
    var n = dwe(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, i, r));
    return n.setRef = function(o) {
      n.nodeRef.current = o;
      var s = n.props.forwardedRef;
      typeof s == "function" ? s(o) : s && (s.current = o);
    }, n.handleLoad = function() {
      clearInterval(n.loadCheck), n.state.iframeLoaded || n.setState({ iframeLoaded: !0 });
    }, n.loadCheck = function() {
      return setInterval(function() {
        n.handleLoad();
      }, 500);
    }, n._isMounted = !1, n.nodeRef = bc.default.createRef(), n.state = { iframeLoaded: !1 }, n;
  }
  return nwe(t, [{
    key: "componentDidMount",
    value: function() {
      this._isMounted = !0;
      var r = this.getDoc();
      r && this.nodeRef.current.contentWindow.addEventListener("DOMContentLoaded", this.handleLoad);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this._isMounted = !1, this.nodeRef.current.removeEventListener("DOMContentLoaded", this.handleLoad);
    }
  }, {
    key: "getDoc",
    value: function() {
      return this.nodeRef.current ? this.nodeRef.current.contentDocument : null;
    }
  }, {
    key: "getMountTarget",
    value: function() {
      var r = this.getDoc();
      return this.props.mountTarget ? r.querySelector(this.props.mountTarget) : r.body.children[0];
    }
    // In certain situations on a cold cache DOMContentLoaded never gets called
    // fallback to an interval to check if that's the case
  }, {
    key: "renderFrameContents",
    value: function() {
      if (!this._isMounted)
        return null;
      var r = this.getDoc();
      if (!r)
        return null;
      var n = this.props.contentDidMount, o = this.props.contentDidUpdate, s = r.defaultView || r.parentView, a = bc.default.createElement(
        cwe.default,
        {
          contentDidMount: n,
          contentDidUpdate: o
        },
        bc.default.createElement(
          awe.FrameContextProvider,
          { value: { document: r, window: s } },
          bc.default.createElement(
            "div",
            { className: "frame-content" },
            this.props.children
          )
        )
      ), l = this.getMountTarget();
      return l ? [hN.default.createPortal(this.props.head, this.getDoc().head), hN.default.createPortal(a, l)] : null;
    }
  }, {
    key: "render",
    value: function() {
      var r = OC({}, this.props, {
        srcDoc: this.props.initialContent,
        children: void 0
        // The iframe isn't ready so we drop children from props here. #12, #17
      });
      return delete r.head, delete r.initialContent, delete r.mountTarget, delete r.contentDidMount, delete r.contentDidUpdate, delete r.forwardedRef, bc.default.createElement(
        "iframe",
        OC({}, r, { ref: this.setRef, onLoad: this.handleLoad }),
        this.state.iframeLoaded && this.renderFrameContents()
      );
    }
  }]), t;
}(Vq.Component);
YI.propTypes = {
  style: Is.default.object,
  // eslint-disable-line
  head: Is.default.node,
  initialContent: Is.default.string,
  mountTarget: Is.default.string,
  contentDidMount: Is.default.func,
  contentDidUpdate: Is.default.func,
  children: Is.default.oneOfType([Is.default.element, Is.default.arrayOf(Is.default.element)])
};
YI.defaultProps = {
  style: {},
  head: null,
  children: void 0,
  mountTarget: void 0,
  contentDidMount: function() {
  },
  contentDidUpdate: function() {
  },
  initialContent: '<!DOCTYPE html><html><head></head><body><div class="frame-root"></div></body></html>'
};
Zg.default = bc.default.forwardRef(function(e, t) {
  return bc.default.createElement(YI, OC({}, e, { forwardedRef: t }));
});
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var t = Zg;
  Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return r(t).default;
    }
  });
  var i = ms;
  Object.defineProperty(e, "FrameContext", {
    enumerable: !0,
    get: function() {
      return i.FrameContext;
    }
  }), Object.defineProperty(e, "FrameContextConsumer", {
    enumerable: !0,
    get: function() {
      return i.FrameContextConsumer;
    }
  }), Object.defineProperty(e, "useFrame", {
    enumerable: !0,
    get: function() {
      return i.useFrame;
    }
  });
  function r(n) {
    return n && n.__esModule ? n : { default: n };
  }
})(jI);
const gwe = /* @__PURE__ */ Ho(jI), hwe = ({ children: e }) => {
  const { document: t, window: i } = jI.useFrame();
  return be(() => {
    const r = setTimeout(() => {
      if (t) {
        var n = t.createElement("style");
        n.innerHTML = `
body {
  margin: 0;
  overflow: auto;
}

#root {
  isolation: isolate;
  width: 100%;
  min-height: 100vh;
  margin: 0;
  padding: 20px;
  position: relative;
}

*,
:before,
:after {
  box-sizing: border-box;
  border-width: 0;
  border-style: solid;
  border-color: #e5e7eb;
}
`, t.head.appendChild(n);
        var o = t.createElement("link");
        o.href = `https://assets-ng.maxroll.gg/common-libs/assets/css/style.css?ver=${go()}`, o.rel = "stylesheet", o.type = "text/css", t.head.appendChild(o);
      }
    }, 1e3);
    return () => {
      clearTimeout(r);
    };
  }, [t]), /* @__PURE__ */ f(jC, { backend: LC, context: i, children: /* @__PURE__ */ f("div", { id: "root", children: e }) });
};
function A7e(i) {
  var r = i, { children: e } = r, t = Fe(r, ["children"]);
  return /* @__PURE__ */ f(gwe, ee(q({}, t), { children: /* @__PURE__ */ f(hwe, { children: e }) }));
}
function rd(n) {
  var o = n, { isLink: e = !0, to: t, openInNewTab: i } = o, r = Fe(o, ["isLink", "to", "openInNewTab"]);
  return e ? /* @__PURE__ */ f($be, q({ to: t, openInNewTab: i }, r)) : /* @__PURE__ */ f("div", q({}, r));
}
var rA = {}, nA = {};
Object.defineProperty(nA, "__esModule", { value: !0 });
nA.bodyRegExps = { xml: /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g, html4: /&notin;|&(?:nbsp|iexcl|cent|pound|curren|yen|brvbar|sect|uml|copy|ordf|laquo|not|shy|reg|macr|deg|plusmn|sup2|sup3|acute|micro|para|middot|cedil|sup1|ordm|raquo|frac14|frac12|frac34|iquest|Agrave|Aacute|Acirc|Atilde|Auml|Aring|AElig|Ccedil|Egrave|Eacute|Ecirc|Euml|Igrave|Iacute|Icirc|Iuml|ETH|Ntilde|Ograve|Oacute|Ocirc|Otilde|Ouml|times|Oslash|Ugrave|Uacute|Ucirc|Uuml|Yacute|THORN|szlig|agrave|aacute|acirc|atilde|auml|aring|aelig|ccedil|egrave|eacute|ecirc|euml|igrave|iacute|icirc|iuml|eth|ntilde|ograve|oacute|ocirc|otilde|ouml|divide|oslash|ugrave|uacute|ucirc|uuml|yacute|thorn|yuml|quot|amp|lt|gt|#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g, html5: /&centerdot;|&copysr;|&divideontimes;|&gtcc;|&gtcir;|&gtdot;|&gtlPar;|&gtquest;|&gtrapprox;|&gtrarr;|&gtrdot;|&gtreqless;|&gtreqqless;|&gtrless;|&gtrsim;|&ltcc;|&ltcir;|&ltdot;|&lthree;|&ltimes;|&ltlarr;|&ltquest;|&ltrPar;|&ltri;|&ltrie;|&ltrif;|&notin;|&notinE;|&notindot;|&notinva;|&notinvb;|&notinvc;|&notni;|&notniva;|&notnivb;|&notnivc;|&parallel;|&timesb;|&timesbar;|&timesd;|&(?:AElig|AMP|Aacute|Acirc|Agrave|Aring|Atilde|Auml|COPY|Ccedil|ETH|Eacute|Ecirc|Egrave|Euml|GT|Iacute|Icirc|Igrave|Iuml|LT|Ntilde|Oacute|Ocirc|Ograve|Oslash|Otilde|Ouml|QUOT|REG|THORN|Uacute|Ucirc|Ugrave|Uuml|Yacute|aacute|acirc|acute|aelig|agrave|amp|aring|atilde|auml|brvbar|ccedil|cedil|cent|copy|curren|deg|divide|eacute|ecirc|egrave|eth|euml|frac12|frac14|frac34|gt|iacute|icirc|iexcl|igrave|iquest|iuml|laquo|lt|macr|micro|middot|nbsp|not|ntilde|oacute|ocirc|ograve|ordf|ordm|oslash|otilde|ouml|para|plusmn|pound|quot|raquo|reg|sect|shy|sup1|sup2|sup3|szlig|thorn|times|uacute|ucirc|ugrave|uml|uuml|yacute|yen|yuml|#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g };
nA.namedReferences = { xml: { entities: { "&lt;": "<", "&gt;": ">", "&quot;": '"', "&apos;": "'", "&amp;": "&" }, characters: { "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&apos;", "&": "&amp;" } }, html4: { entities: { "&apos;": "'", "&nbsp": " ", "&nbsp;": " ", "&iexcl": "¡", "&iexcl;": "¡", "&cent": "¢", "&cent;": "¢", "&pound": "£", "&pound;": "£", "&curren": "¤", "&curren;": "¤", "&yen": "¥", "&yen;": "¥", "&brvbar": "¦", "&brvbar;": "¦", "&sect": "§", "&sect;": "§", "&uml": "¨", "&uml;": "¨", "&copy": "©", "&copy;": "©", "&ordf": "ª", "&ordf;": "ª", "&laquo": "«", "&laquo;": "«", "&not": "¬", "&not;": "¬", "&shy": "­", "&shy;": "­", "&reg": "®", "&reg;": "®", "&macr": "¯", "&macr;": "¯", "&deg": "°", "&deg;": "°", "&plusmn": "±", "&plusmn;": "±", "&sup2": "²", "&sup2;": "²", "&sup3": "³", "&sup3;": "³", "&acute": "´", "&acute;": "´", "&micro": "µ", "&micro;": "µ", "&para": "¶", "&para;": "¶", "&middot": "·", "&middot;": "·", "&cedil": "¸", "&cedil;": "¸", "&sup1": "¹", "&sup1;": "¹", "&ordm": "º", "&ordm;": "º", "&raquo": "»", "&raquo;": "»", "&frac14": "¼", "&frac14;": "¼", "&frac12": "½", "&frac12;": "½", "&frac34": "¾", "&frac34;": "¾", "&iquest": "¿", "&iquest;": "¿", "&Agrave": "À", "&Agrave;": "À", "&Aacute": "Á", "&Aacute;": "Á", "&Acirc": "Â", "&Acirc;": "Â", "&Atilde": "Ã", "&Atilde;": "Ã", "&Auml": "Ä", "&Auml;": "Ä", "&Aring": "Å", "&Aring;": "Å", "&AElig": "Æ", "&AElig;": "Æ", "&Ccedil": "Ç", "&Ccedil;": "Ç", "&Egrave": "È", "&Egrave;": "È", "&Eacute": "É", "&Eacute;": "É", "&Ecirc": "Ê", "&Ecirc;": "Ê", "&Euml": "Ë", "&Euml;": "Ë", "&Igrave": "Ì", "&Igrave;": "Ì", "&Iacute": "Í", "&Iacute;": "Í", "&Icirc": "Î", "&Icirc;": "Î", "&Iuml": "Ï", "&Iuml;": "Ï", "&ETH": "Ð", "&ETH;": "Ð", "&Ntilde": "Ñ", "&Ntilde;": "Ñ", "&Ograve": "Ò", "&Ograve;": "Ò", "&Oacute": "Ó", "&Oacute;": "Ó", "&Ocirc": "Ô", "&Ocirc;": "Ô", "&Otilde": "Õ", "&Otilde;": "Õ", "&Ouml": "Ö", "&Ouml;": "Ö", "&times": "×", "&times;": "×", "&Oslash": "Ø", "&Oslash;": "Ø", "&Ugrave": "Ù", "&Ugrave;": "Ù", "&Uacute": "Ú", "&Uacute;": "Ú", "&Ucirc": "Û", "&Ucirc;": "Û", "&Uuml": "Ü", "&Uuml;": "Ü", "&Yacute": "Ý", "&Yacute;": "Ý", "&THORN": "Þ", "&THORN;": "Þ", "&szlig": "ß", "&szlig;": "ß", "&agrave": "à", "&agrave;": "à", "&aacute": "á", "&aacute;": "á", "&acirc": "â", "&acirc;": "â", "&atilde": "ã", "&atilde;": "ã", "&auml": "ä", "&auml;": "ä", "&aring": "å", "&aring;": "å", "&aelig": "æ", "&aelig;": "æ", "&ccedil": "ç", "&ccedil;": "ç", "&egrave": "è", "&egrave;": "è", "&eacute": "é", "&eacute;": "é", "&ecirc": "ê", "&ecirc;": "ê", "&euml": "ë", "&euml;": "ë", "&igrave": "ì", "&igrave;": "ì", "&iacute": "í", "&iacute;": "í", "&icirc": "î", "&icirc;": "î", "&iuml": "ï", "&iuml;": "ï", "&eth": "ð", "&eth;": "ð", "&ntilde": "ñ", "&ntilde;": "ñ", "&ograve": "ò", "&ograve;": "ò", "&oacute": "ó", "&oacute;": "ó", "&ocirc": "ô", "&ocirc;": "ô", "&otilde": "õ", "&otilde;": "õ", "&ouml": "ö", "&ouml;": "ö", "&divide": "÷", "&divide;": "÷", "&oslash": "ø", "&oslash;": "ø", "&ugrave": "ù", "&ugrave;": "ù", "&uacute": "ú", "&uacute;": "ú", "&ucirc": "û", "&ucirc;": "û", "&uuml": "ü", "&uuml;": "ü", "&yacute": "ý", "&yacute;": "ý", "&thorn": "þ", "&thorn;": "þ", "&yuml": "ÿ", "&yuml;": "ÿ", "&quot": '"', "&quot;": '"', "&amp": "&", "&amp;": "&", "&lt": "<", "&lt;": "<", "&gt": ">", "&gt;": ">", "&OElig;": "Œ", "&oelig;": "œ", "&Scaron;": "Š", "&scaron;": "š", "&Yuml;": "Ÿ", "&circ;": "ˆ", "&tilde;": "˜", "&ensp;": " ", "&emsp;": " ", "&thinsp;": " ", "&zwnj;": "‌", "&zwj;": "‍", "&lrm;": "‎", "&rlm;": "‏", "&ndash;": "–", "&mdash;": "—", "&lsquo;": "‘", "&rsquo;": "’", "&sbquo;": "‚", "&ldquo;": "“", "&rdquo;": "”", "&bdquo;": "„", "&dagger;": "†", "&Dagger;": "‡", "&permil;": "‰", "&lsaquo;": "‹", "&rsaquo;": "›", "&euro;": "€", "&fnof;": "ƒ", "&Alpha;": "Α", "&Beta;": "Β", "&Gamma;": "Γ", "&Delta;": "Δ", "&Epsilon;": "Ε", "&Zeta;": "Ζ", "&Eta;": "Η", "&Theta;": "Θ", "&Iota;": "Ι", "&Kappa;": "Κ", "&Lambda;": "Λ", "&Mu;": "Μ", "&Nu;": "Ν", "&Xi;": "Ξ", "&Omicron;": "Ο", "&Pi;": "Π", "&Rho;": "Ρ", "&Sigma;": "Σ", "&Tau;": "Τ", "&Upsilon;": "Υ", "&Phi;": "Φ", "&Chi;": "Χ", "&Psi;": "Ψ", "&Omega;": "Ω", "&alpha;": "α", "&beta;": "β", "&gamma;": "γ", "&delta;": "δ", "&epsilon;": "ε", "&zeta;": "ζ", "&eta;": "η", "&theta;": "θ", "&iota;": "ι", "&kappa;": "κ", "&lambda;": "λ", "&mu;": "μ", "&nu;": "ν", "&xi;": "ξ", "&omicron;": "ο", "&pi;": "π", "&rho;": "ρ", "&sigmaf;": "ς", "&sigma;": "σ", "&tau;": "τ", "&upsilon;": "υ", "&phi;": "φ", "&chi;": "χ", "&psi;": "ψ", "&omega;": "ω", "&thetasym;": "ϑ", "&upsih;": "ϒ", "&piv;": "ϖ", "&bull;": "•", "&hellip;": "…", "&prime;": "′", "&Prime;": "″", "&oline;": "‾", "&frasl;": "⁄", "&weierp;": "℘", "&image;": "ℑ", "&real;": "ℜ", "&trade;": "™", "&alefsym;": "ℵ", "&larr;": "←", "&uarr;": "↑", "&rarr;": "→", "&darr;": "↓", "&harr;": "↔", "&crarr;": "↵", "&lArr;": "⇐", "&uArr;": "⇑", "&rArr;": "⇒", "&dArr;": "⇓", "&hArr;": "⇔", "&forall;": "∀", "&part;": "∂", "&exist;": "∃", "&empty;": "∅", "&nabla;": "∇", "&isin;": "∈", "&notin;": "∉", "&ni;": "∋", "&prod;": "∏", "&sum;": "∑", "&minus;": "−", "&lowast;": "∗", "&radic;": "√", "&prop;": "∝", "&infin;": "∞", "&ang;": "∠", "&and;": "∧", "&or;": "∨", "&cap;": "∩", "&cup;": "∪", "&int;": "∫", "&there4;": "∴", "&sim;": "∼", "&cong;": "≅", "&asymp;": "≈", "&ne;": "≠", "&equiv;": "≡", "&le;": "≤", "&ge;": "≥", "&sub;": "⊂", "&sup;": "⊃", "&nsub;": "⊄", "&sube;": "⊆", "&supe;": "⊇", "&oplus;": "⊕", "&otimes;": "⊗", "&perp;": "⊥", "&sdot;": "⋅", "&lceil;": "⌈", "&rceil;": "⌉", "&lfloor;": "⌊", "&rfloor;": "⌋", "&lang;": "〈", "&rang;": "〉", "&loz;": "◊", "&spades;": "♠", "&clubs;": "♣", "&hearts;": "♥", "&diams;": "♦" }, characters: { "'": "&apos;", " ": "&nbsp;", "¡": "&iexcl;", "¢": "&cent;", "£": "&pound;", "¤": "&curren;", "¥": "&yen;", "¦": "&brvbar;", "§": "&sect;", "¨": "&uml;", "©": "&copy;", ª: "&ordf;", "«": "&laquo;", "¬": "&not;", "­": "&shy;", "®": "&reg;", "¯": "&macr;", "°": "&deg;", "±": "&plusmn;", "²": "&sup2;", "³": "&sup3;", "´": "&acute;", µ: "&micro;", "¶": "&para;", "·": "&middot;", "¸": "&cedil;", "¹": "&sup1;", º: "&ordm;", "»": "&raquo;", "¼": "&frac14;", "½": "&frac12;", "¾": "&frac34;", "¿": "&iquest;", À: "&Agrave;", Á: "&Aacute;", Â: "&Acirc;", Ã: "&Atilde;", Ä: "&Auml;", Å: "&Aring;", Æ: "&AElig;", Ç: "&Ccedil;", È: "&Egrave;", É: "&Eacute;", Ê: "&Ecirc;", Ë: "&Euml;", Ì: "&Igrave;", Í: "&Iacute;", Î: "&Icirc;", Ï: "&Iuml;", Ð: "&ETH;", Ñ: "&Ntilde;", Ò: "&Ograve;", Ó: "&Oacute;", Ô: "&Ocirc;", Õ: "&Otilde;", Ö: "&Ouml;", "×": "&times;", Ø: "&Oslash;", Ù: "&Ugrave;", Ú: "&Uacute;", Û: "&Ucirc;", Ü: "&Uuml;", Ý: "&Yacute;", Þ: "&THORN;", ß: "&szlig;", à: "&agrave;", á: "&aacute;", â: "&acirc;", ã: "&atilde;", ä: "&auml;", å: "&aring;", æ: "&aelig;", ç: "&ccedil;", è: "&egrave;", é: "&eacute;", ê: "&ecirc;", ë: "&euml;", ì: "&igrave;", í: "&iacute;", î: "&icirc;", ï: "&iuml;", ð: "&eth;", ñ: "&ntilde;", ò: "&ograve;", ó: "&oacute;", ô: "&ocirc;", õ: "&otilde;", ö: "&ouml;", "÷": "&divide;", ø: "&oslash;", ù: "&ugrave;", ú: "&uacute;", û: "&ucirc;", ü: "&uuml;", ý: "&yacute;", þ: "&thorn;", ÿ: "&yuml;", '"': "&quot;", "&": "&amp;", "<": "&lt;", ">": "&gt;", Œ: "&OElig;", œ: "&oelig;", Š: "&Scaron;", š: "&scaron;", Ÿ: "&Yuml;", "ˆ": "&circ;", "˜": "&tilde;", " ": "&ensp;", " ": "&emsp;", " ": "&thinsp;", "‌": "&zwnj;", "‍": "&zwj;", "‎": "&lrm;", "‏": "&rlm;", "–": "&ndash;", "—": "&mdash;", "‘": "&lsquo;", "’": "&rsquo;", "‚": "&sbquo;", "“": "&ldquo;", "”": "&rdquo;", "„": "&bdquo;", "†": "&dagger;", "‡": "&Dagger;", "‰": "&permil;", "‹": "&lsaquo;", "›": "&rsaquo;", "€": "&euro;", ƒ: "&fnof;", Α: "&Alpha;", Β: "&Beta;", Γ: "&Gamma;", Δ: "&Delta;", Ε: "&Epsilon;", Ζ: "&Zeta;", Η: "&Eta;", Θ: "&Theta;", Ι: "&Iota;", Κ: "&Kappa;", Λ: "&Lambda;", Μ: "&Mu;", Ν: "&Nu;", Ξ: "&Xi;", Ο: "&Omicron;", Π: "&Pi;", Ρ: "&Rho;", Σ: "&Sigma;", Τ: "&Tau;", Υ: "&Upsilon;", Φ: "&Phi;", Χ: "&Chi;", Ψ: "&Psi;", Ω: "&Omega;", α: "&alpha;", β: "&beta;", γ: "&gamma;", δ: "&delta;", ε: "&epsilon;", ζ: "&zeta;", η: "&eta;", θ: "&theta;", ι: "&iota;", κ: "&kappa;", λ: "&lambda;", μ: "&mu;", ν: "&nu;", ξ: "&xi;", ο: "&omicron;", π: "&pi;", ρ: "&rho;", ς: "&sigmaf;", σ: "&sigma;", τ: "&tau;", υ: "&upsilon;", φ: "&phi;", χ: "&chi;", ψ: "&psi;", ω: "&omega;", ϑ: "&thetasym;", ϒ: "&upsih;", ϖ: "&piv;", "•": "&bull;", "…": "&hellip;", "′": "&prime;", "″": "&Prime;", "‾": "&oline;", "⁄": "&frasl;", "℘": "&weierp;", ℑ: "&image;", ℜ: "&real;", "™": "&trade;", ℵ: "&alefsym;", "←": "&larr;", "↑": "&uarr;", "→": "&rarr;", "↓": "&darr;", "↔": "&harr;", "↵": "&crarr;", "⇐": "&lArr;", "⇑": "&uArr;", "⇒": "&rArr;", "⇓": "&dArr;", "⇔": "&hArr;", "∀": "&forall;", "∂": "&part;", "∃": "&exist;", "∅": "&empty;", "∇": "&nabla;", "∈": "&isin;", "∉": "&notin;", "∋": "&ni;", "∏": "&prod;", "∑": "&sum;", "−": "&minus;", "∗": "&lowast;", "√": "&radic;", "∝": "&prop;", "∞": "&infin;", "∠": "&ang;", "∧": "&and;", "∨": "&or;", "∩": "&cap;", "∪": "&cup;", "∫": "&int;", "∴": "&there4;", "∼": "&sim;", "≅": "&cong;", "≈": "&asymp;", "≠": "&ne;", "≡": "&equiv;", "≤": "&le;", "≥": "&ge;", "⊂": "&sub;", "⊃": "&sup;", "⊄": "&nsub;", "⊆": "&sube;", "⊇": "&supe;", "⊕": "&oplus;", "⊗": "&otimes;", "⊥": "&perp;", "⋅": "&sdot;", "⌈": "&lceil;", "⌉": "&rceil;", "⌊": "&lfloor;", "⌋": "&rfloor;", "〈": "&lang;", "〉": "&rang;", "◊": "&loz;", "♠": "&spades;", "♣": "&clubs;", "♥": "&hearts;", "♦": "&diams;" } }, html5: { entities: { "&AElig": "Æ", "&AElig;": "Æ", "&AMP": "&", "&AMP;": "&", "&Aacute": "Á", "&Aacute;": "Á", "&Abreve;": "Ă", "&Acirc": "Â", "&Acirc;": "Â", "&Acy;": "А", "&Afr;": "𝔄", "&Agrave": "À", "&Agrave;": "À", "&Alpha;": "Α", "&Amacr;": "Ā", "&And;": "⩓", "&Aogon;": "Ą", "&Aopf;": "𝔸", "&ApplyFunction;": "⁡", "&Aring": "Å", "&Aring;": "Å", "&Ascr;": "𝒜", "&Assign;": "≔", "&Atilde": "Ã", "&Atilde;": "Ã", "&Auml": "Ä", "&Auml;": "Ä", "&Backslash;": "∖", "&Barv;": "⫧", "&Barwed;": "⌆", "&Bcy;": "Б", "&Because;": "∵", "&Bernoullis;": "ℬ", "&Beta;": "Β", "&Bfr;": "𝔅", "&Bopf;": "𝔹", "&Breve;": "˘", "&Bscr;": "ℬ", "&Bumpeq;": "≎", "&CHcy;": "Ч", "&COPY": "©", "&COPY;": "©", "&Cacute;": "Ć", "&Cap;": "⋒", "&CapitalDifferentialD;": "ⅅ", "&Cayleys;": "ℭ", "&Ccaron;": "Č", "&Ccedil": "Ç", "&Ccedil;": "Ç", "&Ccirc;": "Ĉ", "&Cconint;": "∰", "&Cdot;": "Ċ", "&Cedilla;": "¸", "&CenterDot;": "·", "&Cfr;": "ℭ", "&Chi;": "Χ", "&CircleDot;": "⊙", "&CircleMinus;": "⊖", "&CirclePlus;": "⊕", "&CircleTimes;": "⊗", "&ClockwiseContourIntegral;": "∲", "&CloseCurlyDoubleQuote;": "”", "&CloseCurlyQuote;": "’", "&Colon;": "∷", "&Colone;": "⩴", "&Congruent;": "≡", "&Conint;": "∯", "&ContourIntegral;": "∮", "&Copf;": "ℂ", "&Coproduct;": "∐", "&CounterClockwiseContourIntegral;": "∳", "&Cross;": "⨯", "&Cscr;": "𝒞", "&Cup;": "⋓", "&CupCap;": "≍", "&DD;": "ⅅ", "&DDotrahd;": "⤑", "&DJcy;": "Ђ", "&DScy;": "Ѕ", "&DZcy;": "Џ", "&Dagger;": "‡", "&Darr;": "↡", "&Dashv;": "⫤", "&Dcaron;": "Ď", "&Dcy;": "Д", "&Del;": "∇", "&Delta;": "Δ", "&Dfr;": "𝔇", "&DiacriticalAcute;": "´", "&DiacriticalDot;": "˙", "&DiacriticalDoubleAcute;": "˝", "&DiacriticalGrave;": "`", "&DiacriticalTilde;": "˜", "&Diamond;": "⋄", "&DifferentialD;": "ⅆ", "&Dopf;": "𝔻", "&Dot;": "¨", "&DotDot;": "⃜", "&DotEqual;": "≐", "&DoubleContourIntegral;": "∯", "&DoubleDot;": "¨", "&DoubleDownArrow;": "⇓", "&DoubleLeftArrow;": "⇐", "&DoubleLeftRightArrow;": "⇔", "&DoubleLeftTee;": "⫤", "&DoubleLongLeftArrow;": "⟸", "&DoubleLongLeftRightArrow;": "⟺", "&DoubleLongRightArrow;": "⟹", "&DoubleRightArrow;": "⇒", "&DoubleRightTee;": "⊨", "&DoubleUpArrow;": "⇑", "&DoubleUpDownArrow;": "⇕", "&DoubleVerticalBar;": "∥", "&DownArrow;": "↓", "&DownArrowBar;": "⤓", "&DownArrowUpArrow;": "⇵", "&DownBreve;": "̑", "&DownLeftRightVector;": "⥐", "&DownLeftTeeVector;": "⥞", "&DownLeftVector;": "↽", "&DownLeftVectorBar;": "⥖", "&DownRightTeeVector;": "⥟", "&DownRightVector;": "⇁", "&DownRightVectorBar;": "⥗", "&DownTee;": "⊤", "&DownTeeArrow;": "↧", "&Downarrow;": "⇓", "&Dscr;": "𝒟", "&Dstrok;": "Đ", "&ENG;": "Ŋ", "&ETH": "Ð", "&ETH;": "Ð", "&Eacute": "É", "&Eacute;": "É", "&Ecaron;": "Ě", "&Ecirc": "Ê", "&Ecirc;": "Ê", "&Ecy;": "Э", "&Edot;": "Ė", "&Efr;": "𝔈", "&Egrave": "È", "&Egrave;": "È", "&Element;": "∈", "&Emacr;": "Ē", "&EmptySmallSquare;": "◻", "&EmptyVerySmallSquare;": "▫", "&Eogon;": "Ę", "&Eopf;": "𝔼", "&Epsilon;": "Ε", "&Equal;": "⩵", "&EqualTilde;": "≂", "&Equilibrium;": "⇌", "&Escr;": "ℰ", "&Esim;": "⩳", "&Eta;": "Η", "&Euml": "Ë", "&Euml;": "Ë", "&Exists;": "∃", "&ExponentialE;": "ⅇ", "&Fcy;": "Ф", "&Ffr;": "𝔉", "&FilledSmallSquare;": "◼", "&FilledVerySmallSquare;": "▪", "&Fopf;": "𝔽", "&ForAll;": "∀", "&Fouriertrf;": "ℱ", "&Fscr;": "ℱ", "&GJcy;": "Ѓ", "&GT": ">", "&GT;": ">", "&Gamma;": "Γ", "&Gammad;": "Ϝ", "&Gbreve;": "Ğ", "&Gcedil;": "Ģ", "&Gcirc;": "Ĝ", "&Gcy;": "Г", "&Gdot;": "Ġ", "&Gfr;": "𝔊", "&Gg;": "⋙", "&Gopf;": "𝔾", "&GreaterEqual;": "≥", "&GreaterEqualLess;": "⋛", "&GreaterFullEqual;": "≧", "&GreaterGreater;": "⪢", "&GreaterLess;": "≷", "&GreaterSlantEqual;": "⩾", "&GreaterTilde;": "≳", "&Gscr;": "𝒢", "&Gt;": "≫", "&HARDcy;": "Ъ", "&Hacek;": "ˇ", "&Hat;": "^", "&Hcirc;": "Ĥ", "&Hfr;": "ℌ", "&HilbertSpace;": "ℋ", "&Hopf;": "ℍ", "&HorizontalLine;": "─", "&Hscr;": "ℋ", "&Hstrok;": "Ħ", "&HumpDownHump;": "≎", "&HumpEqual;": "≏", "&IEcy;": "Е", "&IJlig;": "Ĳ", "&IOcy;": "Ё", "&Iacute": "Í", "&Iacute;": "Í", "&Icirc": "Î", "&Icirc;": "Î", "&Icy;": "И", "&Idot;": "İ", "&Ifr;": "ℑ", "&Igrave": "Ì", "&Igrave;": "Ì", "&Im;": "ℑ", "&Imacr;": "Ī", "&ImaginaryI;": "ⅈ", "&Implies;": "⇒", "&Int;": "∬", "&Integral;": "∫", "&Intersection;": "⋂", "&InvisibleComma;": "⁣", "&InvisibleTimes;": "⁢", "&Iogon;": "Į", "&Iopf;": "𝕀", "&Iota;": "Ι", "&Iscr;": "ℐ", "&Itilde;": "Ĩ", "&Iukcy;": "І", "&Iuml": "Ï", "&Iuml;": "Ï", "&Jcirc;": "Ĵ", "&Jcy;": "Й", "&Jfr;": "𝔍", "&Jopf;": "𝕁", "&Jscr;": "𝒥", "&Jsercy;": "Ј", "&Jukcy;": "Є", "&KHcy;": "Х", "&KJcy;": "Ќ", "&Kappa;": "Κ", "&Kcedil;": "Ķ", "&Kcy;": "К", "&Kfr;": "𝔎", "&Kopf;": "𝕂", "&Kscr;": "𝒦", "&LJcy;": "Љ", "&LT": "<", "&LT;": "<", "&Lacute;": "Ĺ", "&Lambda;": "Λ", "&Lang;": "⟪", "&Laplacetrf;": "ℒ", "&Larr;": "↞", "&Lcaron;": "Ľ", "&Lcedil;": "Ļ", "&Lcy;": "Л", "&LeftAngleBracket;": "⟨", "&LeftArrow;": "←", "&LeftArrowBar;": "⇤", "&LeftArrowRightArrow;": "⇆", "&LeftCeiling;": "⌈", "&LeftDoubleBracket;": "⟦", "&LeftDownTeeVector;": "⥡", "&LeftDownVector;": "⇃", "&LeftDownVectorBar;": "⥙", "&LeftFloor;": "⌊", "&LeftRightArrow;": "↔", "&LeftRightVector;": "⥎", "&LeftTee;": "⊣", "&LeftTeeArrow;": "↤", "&LeftTeeVector;": "⥚", "&LeftTriangle;": "⊲", "&LeftTriangleBar;": "⧏", "&LeftTriangleEqual;": "⊴", "&LeftUpDownVector;": "⥑", "&LeftUpTeeVector;": "⥠", "&LeftUpVector;": "↿", "&LeftUpVectorBar;": "⥘", "&LeftVector;": "↼", "&LeftVectorBar;": "⥒", "&Leftarrow;": "⇐", "&Leftrightarrow;": "⇔", "&LessEqualGreater;": "⋚", "&LessFullEqual;": "≦", "&LessGreater;": "≶", "&LessLess;": "⪡", "&LessSlantEqual;": "⩽", "&LessTilde;": "≲", "&Lfr;": "𝔏", "&Ll;": "⋘", "&Lleftarrow;": "⇚", "&Lmidot;": "Ŀ", "&LongLeftArrow;": "⟵", "&LongLeftRightArrow;": "⟷", "&LongRightArrow;": "⟶", "&Longleftarrow;": "⟸", "&Longleftrightarrow;": "⟺", "&Longrightarrow;": "⟹", "&Lopf;": "𝕃", "&LowerLeftArrow;": "↙", "&LowerRightArrow;": "↘", "&Lscr;": "ℒ", "&Lsh;": "↰", "&Lstrok;": "Ł", "&Lt;": "≪", "&Map;": "⤅", "&Mcy;": "М", "&MediumSpace;": " ", "&Mellintrf;": "ℳ", "&Mfr;": "𝔐", "&MinusPlus;": "∓", "&Mopf;": "𝕄", "&Mscr;": "ℳ", "&Mu;": "Μ", "&NJcy;": "Њ", "&Nacute;": "Ń", "&Ncaron;": "Ň", "&Ncedil;": "Ņ", "&Ncy;": "Н", "&NegativeMediumSpace;": "​", "&NegativeThickSpace;": "​", "&NegativeThinSpace;": "​", "&NegativeVeryThinSpace;": "​", "&NestedGreaterGreater;": "≫", "&NestedLessLess;": "≪", "&NewLine;": `
`, "&Nfr;": "𝔑", "&NoBreak;": "⁠", "&NonBreakingSpace;": " ", "&Nopf;": "ℕ", "&Not;": "⫬", "&NotCongruent;": "≢", "&NotCupCap;": "≭", "&NotDoubleVerticalBar;": "∦", "&NotElement;": "∉", "&NotEqual;": "≠", "&NotEqualTilde;": "≂̸", "&NotExists;": "∄", "&NotGreater;": "≯", "&NotGreaterEqual;": "≱", "&NotGreaterFullEqual;": "≧̸", "&NotGreaterGreater;": "≫̸", "&NotGreaterLess;": "≹", "&NotGreaterSlantEqual;": "⩾̸", "&NotGreaterTilde;": "≵", "&NotHumpDownHump;": "≎̸", "&NotHumpEqual;": "≏̸", "&NotLeftTriangle;": "⋪", "&NotLeftTriangleBar;": "⧏̸", "&NotLeftTriangleEqual;": "⋬", "&NotLess;": "≮", "&NotLessEqual;": "≰", "&NotLessGreater;": "≸", "&NotLessLess;": "≪̸", "&NotLessSlantEqual;": "⩽̸", "&NotLessTilde;": "≴", "&NotNestedGreaterGreater;": "⪢̸", "&NotNestedLessLess;": "⪡̸", "&NotPrecedes;": "⊀", "&NotPrecedesEqual;": "⪯̸", "&NotPrecedesSlantEqual;": "⋠", "&NotReverseElement;": "∌", "&NotRightTriangle;": "⋫", "&NotRightTriangleBar;": "⧐̸", "&NotRightTriangleEqual;": "⋭", "&NotSquareSubset;": "⊏̸", "&NotSquareSubsetEqual;": "⋢", "&NotSquareSuperset;": "⊐̸", "&NotSquareSupersetEqual;": "⋣", "&NotSubset;": "⊂⃒", "&NotSubsetEqual;": "⊈", "&NotSucceeds;": "⊁", "&NotSucceedsEqual;": "⪰̸", "&NotSucceedsSlantEqual;": "⋡", "&NotSucceedsTilde;": "≿̸", "&NotSuperset;": "⊃⃒", "&NotSupersetEqual;": "⊉", "&NotTilde;": "≁", "&NotTildeEqual;": "≄", "&NotTildeFullEqual;": "≇", "&NotTildeTilde;": "≉", "&NotVerticalBar;": "∤", "&Nscr;": "𝒩", "&Ntilde": "Ñ", "&Ntilde;": "Ñ", "&Nu;": "Ν", "&OElig;": "Œ", "&Oacute": "Ó", "&Oacute;": "Ó", "&Ocirc": "Ô", "&Ocirc;": "Ô", "&Ocy;": "О", "&Odblac;": "Ő", "&Ofr;": "𝔒", "&Ograve": "Ò", "&Ograve;": "Ò", "&Omacr;": "Ō", "&Omega;": "Ω", "&Omicron;": "Ο", "&Oopf;": "𝕆", "&OpenCurlyDoubleQuote;": "“", "&OpenCurlyQuote;": "‘", "&Or;": "⩔", "&Oscr;": "𝒪", "&Oslash": "Ø", "&Oslash;": "Ø", "&Otilde": "Õ", "&Otilde;": "Õ", "&Otimes;": "⨷", "&Ouml": "Ö", "&Ouml;": "Ö", "&OverBar;": "‾", "&OverBrace;": "⏞", "&OverBracket;": "⎴", "&OverParenthesis;": "⏜", "&PartialD;": "∂", "&Pcy;": "П", "&Pfr;": "𝔓", "&Phi;": "Φ", "&Pi;": "Π", "&PlusMinus;": "±", "&Poincareplane;": "ℌ", "&Popf;": "ℙ", "&Pr;": "⪻", "&Precedes;": "≺", "&PrecedesEqual;": "⪯", "&PrecedesSlantEqual;": "≼", "&PrecedesTilde;": "≾", "&Prime;": "″", "&Product;": "∏", "&Proportion;": "∷", "&Proportional;": "∝", "&Pscr;": "𝒫", "&Psi;": "Ψ", "&QUOT": '"', "&QUOT;": '"', "&Qfr;": "𝔔", "&Qopf;": "ℚ", "&Qscr;": "𝒬", "&RBarr;": "⤐", "&REG": "®", "&REG;": "®", "&Racute;": "Ŕ", "&Rang;": "⟫", "&Rarr;": "↠", "&Rarrtl;": "⤖", "&Rcaron;": "Ř", "&Rcedil;": "Ŗ", "&Rcy;": "Р", "&Re;": "ℜ", "&ReverseElement;": "∋", "&ReverseEquilibrium;": "⇋", "&ReverseUpEquilibrium;": "⥯", "&Rfr;": "ℜ", "&Rho;": "Ρ", "&RightAngleBracket;": "⟩", "&RightArrow;": "→", "&RightArrowBar;": "⇥", "&RightArrowLeftArrow;": "⇄", "&RightCeiling;": "⌉", "&RightDoubleBracket;": "⟧", "&RightDownTeeVector;": "⥝", "&RightDownVector;": "⇂", "&RightDownVectorBar;": "⥕", "&RightFloor;": "⌋", "&RightTee;": "⊢", "&RightTeeArrow;": "↦", "&RightTeeVector;": "⥛", "&RightTriangle;": "⊳", "&RightTriangleBar;": "⧐", "&RightTriangleEqual;": "⊵", "&RightUpDownVector;": "⥏", "&RightUpTeeVector;": "⥜", "&RightUpVector;": "↾", "&RightUpVectorBar;": "⥔", "&RightVector;": "⇀", "&RightVectorBar;": "⥓", "&Rightarrow;": "⇒", "&Ropf;": "ℝ", "&RoundImplies;": "⥰", "&Rrightarrow;": "⇛", "&Rscr;": "ℛ", "&Rsh;": "↱", "&RuleDelayed;": "⧴", "&SHCHcy;": "Щ", "&SHcy;": "Ш", "&SOFTcy;": "Ь", "&Sacute;": "Ś", "&Sc;": "⪼", "&Scaron;": "Š", "&Scedil;": "Ş", "&Scirc;": "Ŝ", "&Scy;": "С", "&Sfr;": "𝔖", "&ShortDownArrow;": "↓", "&ShortLeftArrow;": "←", "&ShortRightArrow;": "→", "&ShortUpArrow;": "↑", "&Sigma;": "Σ", "&SmallCircle;": "∘", "&Sopf;": "𝕊", "&Sqrt;": "√", "&Square;": "□", "&SquareIntersection;": "⊓", "&SquareSubset;": "⊏", "&SquareSubsetEqual;": "⊑", "&SquareSuperset;": "⊐", "&SquareSupersetEqual;": "⊒", "&SquareUnion;": "⊔", "&Sscr;": "𝒮", "&Star;": "⋆", "&Sub;": "⋐", "&Subset;": "⋐", "&SubsetEqual;": "⊆", "&Succeeds;": "≻", "&SucceedsEqual;": "⪰", "&SucceedsSlantEqual;": "≽", "&SucceedsTilde;": "≿", "&SuchThat;": "∋", "&Sum;": "∑", "&Sup;": "⋑", "&Superset;": "⊃", "&SupersetEqual;": "⊇", "&Supset;": "⋑", "&THORN": "Þ", "&THORN;": "Þ", "&TRADE;": "™", "&TSHcy;": "Ћ", "&TScy;": "Ц", "&Tab;": "	", "&Tau;": "Τ", "&Tcaron;": "Ť", "&Tcedil;": "Ţ", "&Tcy;": "Т", "&Tfr;": "𝔗", "&Therefore;": "∴", "&Theta;": "Θ", "&ThickSpace;": "  ", "&ThinSpace;": " ", "&Tilde;": "∼", "&TildeEqual;": "≃", "&TildeFullEqual;": "≅", "&TildeTilde;": "≈", "&Topf;": "𝕋", "&TripleDot;": "⃛", "&Tscr;": "𝒯", "&Tstrok;": "Ŧ", "&Uacute": "Ú", "&Uacute;": "Ú", "&Uarr;": "↟", "&Uarrocir;": "⥉", "&Ubrcy;": "Ў", "&Ubreve;": "Ŭ", "&Ucirc": "Û", "&Ucirc;": "Û", "&Ucy;": "У", "&Udblac;": "Ű", "&Ufr;": "𝔘", "&Ugrave": "Ù", "&Ugrave;": "Ù", "&Umacr;": "Ū", "&UnderBar;": "_", "&UnderBrace;": "⏟", "&UnderBracket;": "⎵", "&UnderParenthesis;": "⏝", "&Union;": "⋃", "&UnionPlus;": "⊎", "&Uogon;": "Ų", "&Uopf;": "𝕌", "&UpArrow;": "↑", "&UpArrowBar;": "⤒", "&UpArrowDownArrow;": "⇅", "&UpDownArrow;": "↕", "&UpEquilibrium;": "⥮", "&UpTee;": "⊥", "&UpTeeArrow;": "↥", "&Uparrow;": "⇑", "&Updownarrow;": "⇕", "&UpperLeftArrow;": "↖", "&UpperRightArrow;": "↗", "&Upsi;": "ϒ", "&Upsilon;": "Υ", "&Uring;": "Ů", "&Uscr;": "𝒰", "&Utilde;": "Ũ", "&Uuml": "Ü", "&Uuml;": "Ü", "&VDash;": "⊫", "&Vbar;": "⫫", "&Vcy;": "В", "&Vdash;": "⊩", "&Vdashl;": "⫦", "&Vee;": "⋁", "&Verbar;": "‖", "&Vert;": "‖", "&VerticalBar;": "∣", "&VerticalLine;": "|", "&VerticalSeparator;": "❘", "&VerticalTilde;": "≀", "&VeryThinSpace;": " ", "&Vfr;": "𝔙", "&Vopf;": "𝕍", "&Vscr;": "𝒱", "&Vvdash;": "⊪", "&Wcirc;": "Ŵ", "&Wedge;": "⋀", "&Wfr;": "𝔚", "&Wopf;": "𝕎", "&Wscr;": "𝒲", "&Xfr;": "𝔛", "&Xi;": "Ξ", "&Xopf;": "𝕏", "&Xscr;": "𝒳", "&YAcy;": "Я", "&YIcy;": "Ї", "&YUcy;": "Ю", "&Yacute": "Ý", "&Yacute;": "Ý", "&Ycirc;": "Ŷ", "&Ycy;": "Ы", "&Yfr;": "𝔜", "&Yopf;": "𝕐", "&Yscr;": "𝒴", "&Yuml;": "Ÿ", "&ZHcy;": "Ж", "&Zacute;": "Ź", "&Zcaron;": "Ž", "&Zcy;": "З", "&Zdot;": "Ż", "&ZeroWidthSpace;": "​", "&Zeta;": "Ζ", "&Zfr;": "ℨ", "&Zopf;": "ℤ", "&Zscr;": "𝒵", "&aacute": "á", "&aacute;": "á", "&abreve;": "ă", "&ac;": "∾", "&acE;": "∾̳", "&acd;": "∿", "&acirc": "â", "&acirc;": "â", "&acute": "´", "&acute;": "´", "&acy;": "а", "&aelig": "æ", "&aelig;": "æ", "&af;": "⁡", "&afr;": "𝔞", "&agrave": "à", "&agrave;": "à", "&alefsym;": "ℵ", "&aleph;": "ℵ", "&alpha;": "α", "&amacr;": "ā", "&amalg;": "⨿", "&amp": "&", "&amp;": "&", "&and;": "∧", "&andand;": "⩕", "&andd;": "⩜", "&andslope;": "⩘", "&andv;": "⩚", "&ang;": "∠", "&ange;": "⦤", "&angle;": "∠", "&angmsd;": "∡", "&angmsdaa;": "⦨", "&angmsdab;": "⦩", "&angmsdac;": "⦪", "&angmsdad;": "⦫", "&angmsdae;": "⦬", "&angmsdaf;": "⦭", "&angmsdag;": "⦮", "&angmsdah;": "⦯", "&angrt;": "∟", "&angrtvb;": "⊾", "&angrtvbd;": "⦝", "&angsph;": "∢", "&angst;": "Å", "&angzarr;": "⍼", "&aogon;": "ą", "&aopf;": "𝕒", "&ap;": "≈", "&apE;": "⩰", "&apacir;": "⩯", "&ape;": "≊", "&apid;": "≋", "&apos;": "'", "&approx;": "≈", "&approxeq;": "≊", "&aring": "å", "&aring;": "å", "&ascr;": "𝒶", "&ast;": "*", "&asymp;": "≈", "&asympeq;": "≍", "&atilde": "ã", "&atilde;": "ã", "&auml": "ä", "&auml;": "ä", "&awconint;": "∳", "&awint;": "⨑", "&bNot;": "⫭", "&backcong;": "≌", "&backepsilon;": "϶", "&backprime;": "‵", "&backsim;": "∽", "&backsimeq;": "⋍", "&barvee;": "⊽", "&barwed;": "⌅", "&barwedge;": "⌅", "&bbrk;": "⎵", "&bbrktbrk;": "⎶", "&bcong;": "≌", "&bcy;": "б", "&bdquo;": "„", "&becaus;": "∵", "&because;": "∵", "&bemptyv;": "⦰", "&bepsi;": "϶", "&bernou;": "ℬ", "&beta;": "β", "&beth;": "ℶ", "&between;": "≬", "&bfr;": "𝔟", "&bigcap;": "⋂", "&bigcirc;": "◯", "&bigcup;": "⋃", "&bigodot;": "⨀", "&bigoplus;": "⨁", "&bigotimes;": "⨂", "&bigsqcup;": "⨆", "&bigstar;": "★", "&bigtriangledown;": "▽", "&bigtriangleup;": "△", "&biguplus;": "⨄", "&bigvee;": "⋁", "&bigwedge;": "⋀", "&bkarow;": "⤍", "&blacklozenge;": "⧫", "&blacksquare;": "▪", "&blacktriangle;": "▴", "&blacktriangledown;": "▾", "&blacktriangleleft;": "◂", "&blacktriangleright;": "▸", "&blank;": "␣", "&blk12;": "▒", "&blk14;": "░", "&blk34;": "▓", "&block;": "█", "&bne;": "=⃥", "&bnequiv;": "≡⃥", "&bnot;": "⌐", "&bopf;": "𝕓", "&bot;": "⊥", "&bottom;": "⊥", "&bowtie;": "⋈", "&boxDL;": "╗", "&boxDR;": "╔", "&boxDl;": "╖", "&boxDr;": "╓", "&boxH;": "═", "&boxHD;": "╦", "&boxHU;": "╩", "&boxHd;": "╤", "&boxHu;": "╧", "&boxUL;": "╝", "&boxUR;": "╚", "&boxUl;": "╜", "&boxUr;": "╙", "&boxV;": "║", "&boxVH;": "╬", "&boxVL;": "╣", "&boxVR;": "╠", "&boxVh;": "╫", "&boxVl;": "╢", "&boxVr;": "╟", "&boxbox;": "⧉", "&boxdL;": "╕", "&boxdR;": "╒", "&boxdl;": "┐", "&boxdr;": "┌", "&boxh;": "─", "&boxhD;": "╥", "&boxhU;": "╨", "&boxhd;": "┬", "&boxhu;": "┴", "&boxminus;": "⊟", "&boxplus;": "⊞", "&boxtimes;": "⊠", "&boxuL;": "╛", "&boxuR;": "╘", "&boxul;": "┘", "&boxur;": "└", "&boxv;": "│", "&boxvH;": "╪", "&boxvL;": "╡", "&boxvR;": "╞", "&boxvh;": "┼", "&boxvl;": "┤", "&boxvr;": "├", "&bprime;": "‵", "&breve;": "˘", "&brvbar": "¦", "&brvbar;": "¦", "&bscr;": "𝒷", "&bsemi;": "⁏", "&bsim;": "∽", "&bsime;": "⋍", "&bsol;": "\\", "&bsolb;": "⧅", "&bsolhsub;": "⟈", "&bull;": "•", "&bullet;": "•", "&bump;": "≎", "&bumpE;": "⪮", "&bumpe;": "≏", "&bumpeq;": "≏", "&cacute;": "ć", "&cap;": "∩", "&capand;": "⩄", "&capbrcup;": "⩉", "&capcap;": "⩋", "&capcup;": "⩇", "&capdot;": "⩀", "&caps;": "∩︀", "&caret;": "⁁", "&caron;": "ˇ", "&ccaps;": "⩍", "&ccaron;": "č", "&ccedil": "ç", "&ccedil;": "ç", "&ccirc;": "ĉ", "&ccups;": "⩌", "&ccupssm;": "⩐", "&cdot;": "ċ", "&cedil": "¸", "&cedil;": "¸", "&cemptyv;": "⦲", "&cent": "¢", "&cent;": "¢", "&centerdot;": "·", "&cfr;": "𝔠", "&chcy;": "ч", "&check;": "✓", "&checkmark;": "✓", "&chi;": "χ", "&cir;": "○", "&cirE;": "⧃", "&circ;": "ˆ", "&circeq;": "≗", "&circlearrowleft;": "↺", "&circlearrowright;": "↻", "&circledR;": "®", "&circledS;": "Ⓢ", "&circledast;": "⊛", "&circledcirc;": "⊚", "&circleddash;": "⊝", "&cire;": "≗", "&cirfnint;": "⨐", "&cirmid;": "⫯", "&cirscir;": "⧂", "&clubs;": "♣", "&clubsuit;": "♣", "&colon;": ":", "&colone;": "≔", "&coloneq;": "≔", "&comma;": ",", "&commat;": "@", "&comp;": "∁", "&compfn;": "∘", "&complement;": "∁", "&complexes;": "ℂ", "&cong;": "≅", "&congdot;": "⩭", "&conint;": "∮", "&copf;": "𝕔", "&coprod;": "∐", "&copy": "©", "&copy;": "©", "&copysr;": "℗", "&crarr;": "↵", "&cross;": "✗", "&cscr;": "𝒸", "&csub;": "⫏", "&csube;": "⫑", "&csup;": "⫐", "&csupe;": "⫒", "&ctdot;": "⋯", "&cudarrl;": "⤸", "&cudarrr;": "⤵", "&cuepr;": "⋞", "&cuesc;": "⋟", "&cularr;": "↶", "&cularrp;": "⤽", "&cup;": "∪", "&cupbrcap;": "⩈", "&cupcap;": "⩆", "&cupcup;": "⩊", "&cupdot;": "⊍", "&cupor;": "⩅", "&cups;": "∪︀", "&curarr;": "↷", "&curarrm;": "⤼", "&curlyeqprec;": "⋞", "&curlyeqsucc;": "⋟", "&curlyvee;": "⋎", "&curlywedge;": "⋏", "&curren": "¤", "&curren;": "¤", "&curvearrowleft;": "↶", "&curvearrowright;": "↷", "&cuvee;": "⋎", "&cuwed;": "⋏", "&cwconint;": "∲", "&cwint;": "∱", "&cylcty;": "⌭", "&dArr;": "⇓", "&dHar;": "⥥", "&dagger;": "†", "&daleth;": "ℸ", "&darr;": "↓", "&dash;": "‐", "&dashv;": "⊣", "&dbkarow;": "⤏", "&dblac;": "˝", "&dcaron;": "ď", "&dcy;": "д", "&dd;": "ⅆ", "&ddagger;": "‡", "&ddarr;": "⇊", "&ddotseq;": "⩷", "&deg": "°", "&deg;": "°", "&delta;": "δ", "&demptyv;": "⦱", "&dfisht;": "⥿", "&dfr;": "𝔡", "&dharl;": "⇃", "&dharr;": "⇂", "&diam;": "⋄", "&diamond;": "⋄", "&diamondsuit;": "♦", "&diams;": "♦", "&die;": "¨", "&digamma;": "ϝ", "&disin;": "⋲", "&div;": "÷", "&divide": "÷", "&divide;": "÷", "&divideontimes;": "⋇", "&divonx;": "⋇", "&djcy;": "ђ", "&dlcorn;": "⌞", "&dlcrop;": "⌍", "&dollar;": "$", "&dopf;": "𝕕", "&dot;": "˙", "&doteq;": "≐", "&doteqdot;": "≑", "&dotminus;": "∸", "&dotplus;": "∔", "&dotsquare;": "⊡", "&doublebarwedge;": "⌆", "&downarrow;": "↓", "&downdownarrows;": "⇊", "&downharpoonleft;": "⇃", "&downharpoonright;": "⇂", "&drbkarow;": "⤐", "&drcorn;": "⌟", "&drcrop;": "⌌", "&dscr;": "𝒹", "&dscy;": "ѕ", "&dsol;": "⧶", "&dstrok;": "đ", "&dtdot;": "⋱", "&dtri;": "▿", "&dtrif;": "▾", "&duarr;": "⇵", "&duhar;": "⥯", "&dwangle;": "⦦", "&dzcy;": "џ", "&dzigrarr;": "⟿", "&eDDot;": "⩷", "&eDot;": "≑", "&eacute": "é", "&eacute;": "é", "&easter;": "⩮", "&ecaron;": "ě", "&ecir;": "≖", "&ecirc": "ê", "&ecirc;": "ê", "&ecolon;": "≕", "&ecy;": "э", "&edot;": "ė", "&ee;": "ⅇ", "&efDot;": "≒", "&efr;": "𝔢", "&eg;": "⪚", "&egrave": "è", "&egrave;": "è", "&egs;": "⪖", "&egsdot;": "⪘", "&el;": "⪙", "&elinters;": "⏧", "&ell;": "ℓ", "&els;": "⪕", "&elsdot;": "⪗", "&emacr;": "ē", "&empty;": "∅", "&emptyset;": "∅", "&emptyv;": "∅", "&emsp13;": " ", "&emsp14;": " ", "&emsp;": " ", "&eng;": "ŋ", "&ensp;": " ", "&eogon;": "ę", "&eopf;": "𝕖", "&epar;": "⋕", "&eparsl;": "⧣", "&eplus;": "⩱", "&epsi;": "ε", "&epsilon;": "ε", "&epsiv;": "ϵ", "&eqcirc;": "≖", "&eqcolon;": "≕", "&eqsim;": "≂", "&eqslantgtr;": "⪖", "&eqslantless;": "⪕", "&equals;": "=", "&equest;": "≟", "&equiv;": "≡", "&equivDD;": "⩸", "&eqvparsl;": "⧥", "&erDot;": "≓", "&erarr;": "⥱", "&escr;": "ℯ", "&esdot;": "≐", "&esim;": "≂", "&eta;": "η", "&eth": "ð", "&eth;": "ð", "&euml": "ë", "&euml;": "ë", "&euro;": "€", "&excl;": "!", "&exist;": "∃", "&expectation;": "ℰ", "&exponentiale;": "ⅇ", "&fallingdotseq;": "≒", "&fcy;": "ф", "&female;": "♀", "&ffilig;": "ﬃ", "&fflig;": "ﬀ", "&ffllig;": "ﬄ", "&ffr;": "𝔣", "&filig;": "ﬁ", "&fjlig;": "fj", "&flat;": "♭", "&fllig;": "ﬂ", "&fltns;": "▱", "&fnof;": "ƒ", "&fopf;": "𝕗", "&forall;": "∀", "&fork;": "⋔", "&forkv;": "⫙", "&fpartint;": "⨍", "&frac12": "½", "&frac12;": "½", "&frac13;": "⅓", "&frac14": "¼", "&frac14;": "¼", "&frac15;": "⅕", "&frac16;": "⅙", "&frac18;": "⅛", "&frac23;": "⅔", "&frac25;": "⅖", "&frac34": "¾", "&frac34;": "¾", "&frac35;": "⅗", "&frac38;": "⅜", "&frac45;": "⅘", "&frac56;": "⅚", "&frac58;": "⅝", "&frac78;": "⅞", "&frasl;": "⁄", "&frown;": "⌢", "&fscr;": "𝒻", "&gE;": "≧", "&gEl;": "⪌", "&gacute;": "ǵ", "&gamma;": "γ", "&gammad;": "ϝ", "&gap;": "⪆", "&gbreve;": "ğ", "&gcirc;": "ĝ", "&gcy;": "г", "&gdot;": "ġ", "&ge;": "≥", "&gel;": "⋛", "&geq;": "≥", "&geqq;": "≧", "&geqslant;": "⩾", "&ges;": "⩾", "&gescc;": "⪩", "&gesdot;": "⪀", "&gesdoto;": "⪂", "&gesdotol;": "⪄", "&gesl;": "⋛︀", "&gesles;": "⪔", "&gfr;": "𝔤", "&gg;": "≫", "&ggg;": "⋙", "&gimel;": "ℷ", "&gjcy;": "ѓ", "&gl;": "≷", "&glE;": "⪒", "&gla;": "⪥", "&glj;": "⪤", "&gnE;": "≩", "&gnap;": "⪊", "&gnapprox;": "⪊", "&gne;": "⪈", "&gneq;": "⪈", "&gneqq;": "≩", "&gnsim;": "⋧", "&gopf;": "𝕘", "&grave;": "`", "&gscr;": "ℊ", "&gsim;": "≳", "&gsime;": "⪎", "&gsiml;": "⪐", "&gt": ">", "&gt;": ">", "&gtcc;": "⪧", "&gtcir;": "⩺", "&gtdot;": "⋗", "&gtlPar;": "⦕", "&gtquest;": "⩼", "&gtrapprox;": "⪆", "&gtrarr;": "⥸", "&gtrdot;": "⋗", "&gtreqless;": "⋛", "&gtreqqless;": "⪌", "&gtrless;": "≷", "&gtrsim;": "≳", "&gvertneqq;": "≩︀", "&gvnE;": "≩︀", "&hArr;": "⇔", "&hairsp;": " ", "&half;": "½", "&hamilt;": "ℋ", "&hardcy;": "ъ", "&harr;": "↔", "&harrcir;": "⥈", "&harrw;": "↭", "&hbar;": "ℏ", "&hcirc;": "ĥ", "&hearts;": "♥", "&heartsuit;": "♥", "&hellip;": "…", "&hercon;": "⊹", "&hfr;": "𝔥", "&hksearow;": "⤥", "&hkswarow;": "⤦", "&hoarr;": "⇿", "&homtht;": "∻", "&hookleftarrow;": "↩", "&hookrightarrow;": "↪", "&hopf;": "𝕙", "&horbar;": "―", "&hscr;": "𝒽", "&hslash;": "ℏ", "&hstrok;": "ħ", "&hybull;": "⁃", "&hyphen;": "‐", "&iacute": "í", "&iacute;": "í", "&ic;": "⁣", "&icirc": "î", "&icirc;": "î", "&icy;": "и", "&iecy;": "е", "&iexcl": "¡", "&iexcl;": "¡", "&iff;": "⇔", "&ifr;": "𝔦", "&igrave": "ì", "&igrave;": "ì", "&ii;": "ⅈ", "&iiiint;": "⨌", "&iiint;": "∭", "&iinfin;": "⧜", "&iiota;": "℩", "&ijlig;": "ĳ", "&imacr;": "ī", "&image;": "ℑ", "&imagline;": "ℐ", "&imagpart;": "ℑ", "&imath;": "ı", "&imof;": "⊷", "&imped;": "Ƶ", "&in;": "∈", "&incare;": "℅", "&infin;": "∞", "&infintie;": "⧝", "&inodot;": "ı", "&int;": "∫", "&intcal;": "⊺", "&integers;": "ℤ", "&intercal;": "⊺", "&intlarhk;": "⨗", "&intprod;": "⨼", "&iocy;": "ё", "&iogon;": "į", "&iopf;": "𝕚", "&iota;": "ι", "&iprod;": "⨼", "&iquest": "¿", "&iquest;": "¿", "&iscr;": "𝒾", "&isin;": "∈", "&isinE;": "⋹", "&isindot;": "⋵", "&isins;": "⋴", "&isinsv;": "⋳", "&isinv;": "∈", "&it;": "⁢", "&itilde;": "ĩ", "&iukcy;": "і", "&iuml": "ï", "&iuml;": "ï", "&jcirc;": "ĵ", "&jcy;": "й", "&jfr;": "𝔧", "&jmath;": "ȷ", "&jopf;": "𝕛", "&jscr;": "𝒿", "&jsercy;": "ј", "&jukcy;": "є", "&kappa;": "κ", "&kappav;": "ϰ", "&kcedil;": "ķ", "&kcy;": "к", "&kfr;": "𝔨", "&kgreen;": "ĸ", "&khcy;": "х", "&kjcy;": "ќ", "&kopf;": "𝕜", "&kscr;": "𝓀", "&lAarr;": "⇚", "&lArr;": "⇐", "&lAtail;": "⤛", "&lBarr;": "⤎", "&lE;": "≦", "&lEg;": "⪋", "&lHar;": "⥢", "&lacute;": "ĺ", "&laemptyv;": "⦴", "&lagran;": "ℒ", "&lambda;": "λ", "&lang;": "⟨", "&langd;": "⦑", "&langle;": "⟨", "&lap;": "⪅", "&laquo": "«", "&laquo;": "«", "&larr;": "←", "&larrb;": "⇤", "&larrbfs;": "⤟", "&larrfs;": "⤝", "&larrhk;": "↩", "&larrlp;": "↫", "&larrpl;": "⤹", "&larrsim;": "⥳", "&larrtl;": "↢", "&lat;": "⪫", "&latail;": "⤙", "&late;": "⪭", "&lates;": "⪭︀", "&lbarr;": "⤌", "&lbbrk;": "❲", "&lbrace;": "{", "&lbrack;": "[", "&lbrke;": "⦋", "&lbrksld;": "⦏", "&lbrkslu;": "⦍", "&lcaron;": "ľ", "&lcedil;": "ļ", "&lceil;": "⌈", "&lcub;": "{", "&lcy;": "л", "&ldca;": "⤶", "&ldquo;": "“", "&ldquor;": "„", "&ldrdhar;": "⥧", "&ldrushar;": "⥋", "&ldsh;": "↲", "&le;": "≤", "&leftarrow;": "←", "&leftarrowtail;": "↢", "&leftharpoondown;": "↽", "&leftharpoonup;": "↼", "&leftleftarrows;": "⇇", "&leftrightarrow;": "↔", "&leftrightarrows;": "⇆", "&leftrightharpoons;": "⇋", "&leftrightsquigarrow;": "↭", "&leftthreetimes;": "⋋", "&leg;": "⋚", "&leq;": "≤", "&leqq;": "≦", "&leqslant;": "⩽", "&les;": "⩽", "&lescc;": "⪨", "&lesdot;": "⩿", "&lesdoto;": "⪁", "&lesdotor;": "⪃", "&lesg;": "⋚︀", "&lesges;": "⪓", "&lessapprox;": "⪅", "&lessdot;": "⋖", "&lesseqgtr;": "⋚", "&lesseqqgtr;": "⪋", "&lessgtr;": "≶", "&lesssim;": "≲", "&lfisht;": "⥼", "&lfloor;": "⌊", "&lfr;": "𝔩", "&lg;": "≶", "&lgE;": "⪑", "&lhard;": "↽", "&lharu;": "↼", "&lharul;": "⥪", "&lhblk;": "▄", "&ljcy;": "љ", "&ll;": "≪", "&llarr;": "⇇", "&llcorner;": "⌞", "&llhard;": "⥫", "&lltri;": "◺", "&lmidot;": "ŀ", "&lmoust;": "⎰", "&lmoustache;": "⎰", "&lnE;": "≨", "&lnap;": "⪉", "&lnapprox;": "⪉", "&lne;": "⪇", "&lneq;": "⪇", "&lneqq;": "≨", "&lnsim;": "⋦", "&loang;": "⟬", "&loarr;": "⇽", "&lobrk;": "⟦", "&longleftarrow;": "⟵", "&longleftrightarrow;": "⟷", "&longmapsto;": "⟼", "&longrightarrow;": "⟶", "&looparrowleft;": "↫", "&looparrowright;": "↬", "&lopar;": "⦅", "&lopf;": "𝕝", "&loplus;": "⨭", "&lotimes;": "⨴", "&lowast;": "∗", "&lowbar;": "_", "&loz;": "◊", "&lozenge;": "◊", "&lozf;": "⧫", "&lpar;": "(", "&lparlt;": "⦓", "&lrarr;": "⇆", "&lrcorner;": "⌟", "&lrhar;": "⇋", "&lrhard;": "⥭", "&lrm;": "‎", "&lrtri;": "⊿", "&lsaquo;": "‹", "&lscr;": "𝓁", "&lsh;": "↰", "&lsim;": "≲", "&lsime;": "⪍", "&lsimg;": "⪏", "&lsqb;": "[", "&lsquo;": "‘", "&lsquor;": "‚", "&lstrok;": "ł", "&lt": "<", "&lt;": "<", "&ltcc;": "⪦", "&ltcir;": "⩹", "&ltdot;": "⋖", "&lthree;": "⋋", "&ltimes;": "⋉", "&ltlarr;": "⥶", "&ltquest;": "⩻", "&ltrPar;": "⦖", "&ltri;": "◃", "&ltrie;": "⊴", "&ltrif;": "◂", "&lurdshar;": "⥊", "&luruhar;": "⥦", "&lvertneqq;": "≨︀", "&lvnE;": "≨︀", "&mDDot;": "∺", "&macr": "¯", "&macr;": "¯", "&male;": "♂", "&malt;": "✠", "&maltese;": "✠", "&map;": "↦", "&mapsto;": "↦", "&mapstodown;": "↧", "&mapstoleft;": "↤", "&mapstoup;": "↥", "&marker;": "▮", "&mcomma;": "⨩", "&mcy;": "м", "&mdash;": "—", "&measuredangle;": "∡", "&mfr;": "𝔪", "&mho;": "℧", "&micro": "µ", "&micro;": "µ", "&mid;": "∣", "&midast;": "*", "&midcir;": "⫰", "&middot": "·", "&middot;": "·", "&minus;": "−", "&minusb;": "⊟", "&minusd;": "∸", "&minusdu;": "⨪", "&mlcp;": "⫛", "&mldr;": "…", "&mnplus;": "∓", "&models;": "⊧", "&mopf;": "𝕞", "&mp;": "∓", "&mscr;": "𝓂", "&mstpos;": "∾", "&mu;": "μ", "&multimap;": "⊸", "&mumap;": "⊸", "&nGg;": "⋙̸", "&nGt;": "≫⃒", "&nGtv;": "≫̸", "&nLeftarrow;": "⇍", "&nLeftrightarrow;": "⇎", "&nLl;": "⋘̸", "&nLt;": "≪⃒", "&nLtv;": "≪̸", "&nRightarrow;": "⇏", "&nVDash;": "⊯", "&nVdash;": "⊮", "&nabla;": "∇", "&nacute;": "ń", "&nang;": "∠⃒", "&nap;": "≉", "&napE;": "⩰̸", "&napid;": "≋̸", "&napos;": "ŉ", "&napprox;": "≉", "&natur;": "♮", "&natural;": "♮", "&naturals;": "ℕ", "&nbsp": " ", "&nbsp;": " ", "&nbump;": "≎̸", "&nbumpe;": "≏̸", "&ncap;": "⩃", "&ncaron;": "ň", "&ncedil;": "ņ", "&ncong;": "≇", "&ncongdot;": "⩭̸", "&ncup;": "⩂", "&ncy;": "н", "&ndash;": "–", "&ne;": "≠", "&neArr;": "⇗", "&nearhk;": "⤤", "&nearr;": "↗", "&nearrow;": "↗", "&nedot;": "≐̸", "&nequiv;": "≢", "&nesear;": "⤨", "&nesim;": "≂̸", "&nexist;": "∄", "&nexists;": "∄", "&nfr;": "𝔫", "&ngE;": "≧̸", "&nge;": "≱", "&ngeq;": "≱", "&ngeqq;": "≧̸", "&ngeqslant;": "⩾̸", "&nges;": "⩾̸", "&ngsim;": "≵", "&ngt;": "≯", "&ngtr;": "≯", "&nhArr;": "⇎", "&nharr;": "↮", "&nhpar;": "⫲", "&ni;": "∋", "&nis;": "⋼", "&nisd;": "⋺", "&niv;": "∋", "&njcy;": "њ", "&nlArr;": "⇍", "&nlE;": "≦̸", "&nlarr;": "↚", "&nldr;": "‥", "&nle;": "≰", "&nleftarrow;": "↚", "&nleftrightarrow;": "↮", "&nleq;": "≰", "&nleqq;": "≦̸", "&nleqslant;": "⩽̸", "&nles;": "⩽̸", "&nless;": "≮", "&nlsim;": "≴", "&nlt;": "≮", "&nltri;": "⋪", "&nltrie;": "⋬", "&nmid;": "∤", "&nopf;": "𝕟", "&not": "¬", "&not;": "¬", "&notin;": "∉", "&notinE;": "⋹̸", "&notindot;": "⋵̸", "&notinva;": "∉", "&notinvb;": "⋷", "&notinvc;": "⋶", "&notni;": "∌", "&notniva;": "∌", "&notnivb;": "⋾", "&notnivc;": "⋽", "&npar;": "∦", "&nparallel;": "∦", "&nparsl;": "⫽⃥", "&npart;": "∂̸", "&npolint;": "⨔", "&npr;": "⊀", "&nprcue;": "⋠", "&npre;": "⪯̸", "&nprec;": "⊀", "&npreceq;": "⪯̸", "&nrArr;": "⇏", "&nrarr;": "↛", "&nrarrc;": "⤳̸", "&nrarrw;": "↝̸", "&nrightarrow;": "↛", "&nrtri;": "⋫", "&nrtrie;": "⋭", "&nsc;": "⊁", "&nsccue;": "⋡", "&nsce;": "⪰̸", "&nscr;": "𝓃", "&nshortmid;": "∤", "&nshortparallel;": "∦", "&nsim;": "≁", "&nsime;": "≄", "&nsimeq;": "≄", "&nsmid;": "∤", "&nspar;": "∦", "&nsqsube;": "⋢", "&nsqsupe;": "⋣", "&nsub;": "⊄", "&nsubE;": "⫅̸", "&nsube;": "⊈", "&nsubset;": "⊂⃒", "&nsubseteq;": "⊈", "&nsubseteqq;": "⫅̸", "&nsucc;": "⊁", "&nsucceq;": "⪰̸", "&nsup;": "⊅", "&nsupE;": "⫆̸", "&nsupe;": "⊉", "&nsupset;": "⊃⃒", "&nsupseteq;": "⊉", "&nsupseteqq;": "⫆̸", "&ntgl;": "≹", "&ntilde": "ñ", "&ntilde;": "ñ", "&ntlg;": "≸", "&ntriangleleft;": "⋪", "&ntrianglelefteq;": "⋬", "&ntriangleright;": "⋫", "&ntrianglerighteq;": "⋭", "&nu;": "ν", "&num;": "#", "&numero;": "№", "&numsp;": " ", "&nvDash;": "⊭", "&nvHarr;": "⤄", "&nvap;": "≍⃒", "&nvdash;": "⊬", "&nvge;": "≥⃒", "&nvgt;": ">⃒", "&nvinfin;": "⧞", "&nvlArr;": "⤂", "&nvle;": "≤⃒", "&nvlt;": "<⃒", "&nvltrie;": "⊴⃒", "&nvrArr;": "⤃", "&nvrtrie;": "⊵⃒", "&nvsim;": "∼⃒", "&nwArr;": "⇖", "&nwarhk;": "⤣", "&nwarr;": "↖", "&nwarrow;": "↖", "&nwnear;": "⤧", "&oS;": "Ⓢ", "&oacute": "ó", "&oacute;": "ó", "&oast;": "⊛", "&ocir;": "⊚", "&ocirc": "ô", "&ocirc;": "ô", "&ocy;": "о", "&odash;": "⊝", "&odblac;": "ő", "&odiv;": "⨸", "&odot;": "⊙", "&odsold;": "⦼", "&oelig;": "œ", "&ofcir;": "⦿", "&ofr;": "𝔬", "&ogon;": "˛", "&ograve": "ò", "&ograve;": "ò", "&ogt;": "⧁", "&ohbar;": "⦵", "&ohm;": "Ω", "&oint;": "∮", "&olarr;": "↺", "&olcir;": "⦾", "&olcross;": "⦻", "&oline;": "‾", "&olt;": "⧀", "&omacr;": "ō", "&omega;": "ω", "&omicron;": "ο", "&omid;": "⦶", "&ominus;": "⊖", "&oopf;": "𝕠", "&opar;": "⦷", "&operp;": "⦹", "&oplus;": "⊕", "&or;": "∨", "&orarr;": "↻", "&ord;": "⩝", "&order;": "ℴ", "&orderof;": "ℴ", "&ordf": "ª", "&ordf;": "ª", "&ordm": "º", "&ordm;": "º", "&origof;": "⊶", "&oror;": "⩖", "&orslope;": "⩗", "&orv;": "⩛", "&oscr;": "ℴ", "&oslash": "ø", "&oslash;": "ø", "&osol;": "⊘", "&otilde": "õ", "&otilde;": "õ", "&otimes;": "⊗", "&otimesas;": "⨶", "&ouml": "ö", "&ouml;": "ö", "&ovbar;": "⌽", "&par;": "∥", "&para": "¶", "&para;": "¶", "&parallel;": "∥", "&parsim;": "⫳", "&parsl;": "⫽", "&part;": "∂", "&pcy;": "п", "&percnt;": "%", "&period;": ".", "&permil;": "‰", "&perp;": "⊥", "&pertenk;": "‱", "&pfr;": "𝔭", "&phi;": "φ", "&phiv;": "ϕ", "&phmmat;": "ℳ", "&phone;": "☎", "&pi;": "π", "&pitchfork;": "⋔", "&piv;": "ϖ", "&planck;": "ℏ", "&planckh;": "ℎ", "&plankv;": "ℏ", "&plus;": "+", "&plusacir;": "⨣", "&plusb;": "⊞", "&pluscir;": "⨢", "&plusdo;": "∔", "&plusdu;": "⨥", "&pluse;": "⩲", "&plusmn": "±", "&plusmn;": "±", "&plussim;": "⨦", "&plustwo;": "⨧", "&pm;": "±", "&pointint;": "⨕", "&popf;": "𝕡", "&pound": "£", "&pound;": "£", "&pr;": "≺", "&prE;": "⪳", "&prap;": "⪷", "&prcue;": "≼", "&pre;": "⪯", "&prec;": "≺", "&precapprox;": "⪷", "&preccurlyeq;": "≼", "&preceq;": "⪯", "&precnapprox;": "⪹", "&precneqq;": "⪵", "&precnsim;": "⋨", "&precsim;": "≾", "&prime;": "′", "&primes;": "ℙ", "&prnE;": "⪵", "&prnap;": "⪹", "&prnsim;": "⋨", "&prod;": "∏", "&profalar;": "⌮", "&profline;": "⌒", "&profsurf;": "⌓", "&prop;": "∝", "&propto;": "∝", "&prsim;": "≾", "&prurel;": "⊰", "&pscr;": "𝓅", "&psi;": "ψ", "&puncsp;": " ", "&qfr;": "𝔮", "&qint;": "⨌", "&qopf;": "𝕢", "&qprime;": "⁗", "&qscr;": "𝓆", "&quaternions;": "ℍ", "&quatint;": "⨖", "&quest;": "?", "&questeq;": "≟", "&quot": '"', "&quot;": '"', "&rAarr;": "⇛", "&rArr;": "⇒", "&rAtail;": "⤜", "&rBarr;": "⤏", "&rHar;": "⥤", "&race;": "∽̱", "&racute;": "ŕ", "&radic;": "√", "&raemptyv;": "⦳", "&rang;": "⟩", "&rangd;": "⦒", "&range;": "⦥", "&rangle;": "⟩", "&raquo": "»", "&raquo;": "»", "&rarr;": "→", "&rarrap;": "⥵", "&rarrb;": "⇥", "&rarrbfs;": "⤠", "&rarrc;": "⤳", "&rarrfs;": "⤞", "&rarrhk;": "↪", "&rarrlp;": "↬", "&rarrpl;": "⥅", "&rarrsim;": "⥴", "&rarrtl;": "↣", "&rarrw;": "↝", "&ratail;": "⤚", "&ratio;": "∶", "&rationals;": "ℚ", "&rbarr;": "⤍", "&rbbrk;": "❳", "&rbrace;": "}", "&rbrack;": "]", "&rbrke;": "⦌", "&rbrksld;": "⦎", "&rbrkslu;": "⦐", "&rcaron;": "ř", "&rcedil;": "ŗ", "&rceil;": "⌉", "&rcub;": "}", "&rcy;": "р", "&rdca;": "⤷", "&rdldhar;": "⥩", "&rdquo;": "”", "&rdquor;": "”", "&rdsh;": "↳", "&real;": "ℜ", "&realine;": "ℛ", "&realpart;": "ℜ", "&reals;": "ℝ", "&rect;": "▭", "&reg": "®", "&reg;": "®", "&rfisht;": "⥽", "&rfloor;": "⌋", "&rfr;": "𝔯", "&rhard;": "⇁", "&rharu;": "⇀", "&rharul;": "⥬", "&rho;": "ρ", "&rhov;": "ϱ", "&rightarrow;": "→", "&rightarrowtail;": "↣", "&rightharpoondown;": "⇁", "&rightharpoonup;": "⇀", "&rightleftarrows;": "⇄", "&rightleftharpoons;": "⇌", "&rightrightarrows;": "⇉", "&rightsquigarrow;": "↝", "&rightthreetimes;": "⋌", "&ring;": "˚", "&risingdotseq;": "≓", "&rlarr;": "⇄", "&rlhar;": "⇌", "&rlm;": "‏", "&rmoust;": "⎱", "&rmoustache;": "⎱", "&rnmid;": "⫮", "&roang;": "⟭", "&roarr;": "⇾", "&robrk;": "⟧", "&ropar;": "⦆", "&ropf;": "𝕣", "&roplus;": "⨮", "&rotimes;": "⨵", "&rpar;": ")", "&rpargt;": "⦔", "&rppolint;": "⨒", "&rrarr;": "⇉", "&rsaquo;": "›", "&rscr;": "𝓇", "&rsh;": "↱", "&rsqb;": "]", "&rsquo;": "’", "&rsquor;": "’", "&rthree;": "⋌", "&rtimes;": "⋊", "&rtri;": "▹", "&rtrie;": "⊵", "&rtrif;": "▸", "&rtriltri;": "⧎", "&ruluhar;": "⥨", "&rx;": "℞", "&sacute;": "ś", "&sbquo;": "‚", "&sc;": "≻", "&scE;": "⪴", "&scap;": "⪸", "&scaron;": "š", "&sccue;": "≽", "&sce;": "⪰", "&scedil;": "ş", "&scirc;": "ŝ", "&scnE;": "⪶", "&scnap;": "⪺", "&scnsim;": "⋩", "&scpolint;": "⨓", "&scsim;": "≿", "&scy;": "с", "&sdot;": "⋅", "&sdotb;": "⊡", "&sdote;": "⩦", "&seArr;": "⇘", "&searhk;": "⤥", "&searr;": "↘", "&searrow;": "↘", "&sect": "§", "&sect;": "§", "&semi;": ";", "&seswar;": "⤩", "&setminus;": "∖", "&setmn;": "∖", "&sext;": "✶", "&sfr;": "𝔰", "&sfrown;": "⌢", "&sharp;": "♯", "&shchcy;": "щ", "&shcy;": "ш", "&shortmid;": "∣", "&shortparallel;": "∥", "&shy": "­", "&shy;": "­", "&sigma;": "σ", "&sigmaf;": "ς", "&sigmav;": "ς", "&sim;": "∼", "&simdot;": "⩪", "&sime;": "≃", "&simeq;": "≃", "&simg;": "⪞", "&simgE;": "⪠", "&siml;": "⪝", "&simlE;": "⪟", "&simne;": "≆", "&simplus;": "⨤", "&simrarr;": "⥲", "&slarr;": "←", "&smallsetminus;": "∖", "&smashp;": "⨳", "&smeparsl;": "⧤", "&smid;": "∣", "&smile;": "⌣", "&smt;": "⪪", "&smte;": "⪬", "&smtes;": "⪬︀", "&softcy;": "ь", "&sol;": "/", "&solb;": "⧄", "&solbar;": "⌿", "&sopf;": "𝕤", "&spades;": "♠", "&spadesuit;": "♠", "&spar;": "∥", "&sqcap;": "⊓", "&sqcaps;": "⊓︀", "&sqcup;": "⊔", "&sqcups;": "⊔︀", "&sqsub;": "⊏", "&sqsube;": "⊑", "&sqsubset;": "⊏", "&sqsubseteq;": "⊑", "&sqsup;": "⊐", "&sqsupe;": "⊒", "&sqsupset;": "⊐", "&sqsupseteq;": "⊒", "&squ;": "□", "&square;": "□", "&squarf;": "▪", "&squf;": "▪", "&srarr;": "→", "&sscr;": "𝓈", "&ssetmn;": "∖", "&ssmile;": "⌣", "&sstarf;": "⋆", "&star;": "☆", "&starf;": "★", "&straightepsilon;": "ϵ", "&straightphi;": "ϕ", "&strns;": "¯", "&sub;": "⊂", "&subE;": "⫅", "&subdot;": "⪽", "&sube;": "⊆", "&subedot;": "⫃", "&submult;": "⫁", "&subnE;": "⫋", "&subne;": "⊊", "&subplus;": "⪿", "&subrarr;": "⥹", "&subset;": "⊂", "&subseteq;": "⊆", "&subseteqq;": "⫅", "&subsetneq;": "⊊", "&subsetneqq;": "⫋", "&subsim;": "⫇", "&subsub;": "⫕", "&subsup;": "⫓", "&succ;": "≻", "&succapprox;": "⪸", "&succcurlyeq;": "≽", "&succeq;": "⪰", "&succnapprox;": "⪺", "&succneqq;": "⪶", "&succnsim;": "⋩", "&succsim;": "≿", "&sum;": "∑", "&sung;": "♪", "&sup1": "¹", "&sup1;": "¹", "&sup2": "²", "&sup2;": "²", "&sup3": "³", "&sup3;": "³", "&sup;": "⊃", "&supE;": "⫆", "&supdot;": "⪾", "&supdsub;": "⫘", "&supe;": "⊇", "&supedot;": "⫄", "&suphsol;": "⟉", "&suphsub;": "⫗", "&suplarr;": "⥻", "&supmult;": "⫂", "&supnE;": "⫌", "&supne;": "⊋", "&supplus;": "⫀", "&supset;": "⊃", "&supseteq;": "⊇", "&supseteqq;": "⫆", "&supsetneq;": "⊋", "&supsetneqq;": "⫌", "&supsim;": "⫈", "&supsub;": "⫔", "&supsup;": "⫖", "&swArr;": "⇙", "&swarhk;": "⤦", "&swarr;": "↙", "&swarrow;": "↙", "&swnwar;": "⤪", "&szlig": "ß", "&szlig;": "ß", "&target;": "⌖", "&tau;": "τ", "&tbrk;": "⎴", "&tcaron;": "ť", "&tcedil;": "ţ", "&tcy;": "т", "&tdot;": "⃛", "&telrec;": "⌕", "&tfr;": "𝔱", "&there4;": "∴", "&therefore;": "∴", "&theta;": "θ", "&thetasym;": "ϑ", "&thetav;": "ϑ", "&thickapprox;": "≈", "&thicksim;": "∼", "&thinsp;": " ", "&thkap;": "≈", "&thksim;": "∼", "&thorn": "þ", "&thorn;": "þ", "&tilde;": "˜", "&times": "×", "&times;": "×", "&timesb;": "⊠", "&timesbar;": "⨱", "&timesd;": "⨰", "&tint;": "∭", "&toea;": "⤨", "&top;": "⊤", "&topbot;": "⌶", "&topcir;": "⫱", "&topf;": "𝕥", "&topfork;": "⫚", "&tosa;": "⤩", "&tprime;": "‴", "&trade;": "™", "&triangle;": "▵", "&triangledown;": "▿", "&triangleleft;": "◃", "&trianglelefteq;": "⊴", "&triangleq;": "≜", "&triangleright;": "▹", "&trianglerighteq;": "⊵", "&tridot;": "◬", "&trie;": "≜", "&triminus;": "⨺", "&triplus;": "⨹", "&trisb;": "⧍", "&tritime;": "⨻", "&trpezium;": "⏢", "&tscr;": "𝓉", "&tscy;": "ц", "&tshcy;": "ћ", "&tstrok;": "ŧ", "&twixt;": "≬", "&twoheadleftarrow;": "↞", "&twoheadrightarrow;": "↠", "&uArr;": "⇑", "&uHar;": "⥣", "&uacute": "ú", "&uacute;": "ú", "&uarr;": "↑", "&ubrcy;": "ў", "&ubreve;": "ŭ", "&ucirc": "û", "&ucirc;": "û", "&ucy;": "у", "&udarr;": "⇅", "&udblac;": "ű", "&udhar;": "⥮", "&ufisht;": "⥾", "&ufr;": "𝔲", "&ugrave": "ù", "&ugrave;": "ù", "&uharl;": "↿", "&uharr;": "↾", "&uhblk;": "▀", "&ulcorn;": "⌜", "&ulcorner;": "⌜", "&ulcrop;": "⌏", "&ultri;": "◸", "&umacr;": "ū", "&uml": "¨", "&uml;": "¨", "&uogon;": "ų", "&uopf;": "𝕦", "&uparrow;": "↑", "&updownarrow;": "↕", "&upharpoonleft;": "↿", "&upharpoonright;": "↾", "&uplus;": "⊎", "&upsi;": "υ", "&upsih;": "ϒ", "&upsilon;": "υ", "&upuparrows;": "⇈", "&urcorn;": "⌝", "&urcorner;": "⌝", "&urcrop;": "⌎", "&uring;": "ů", "&urtri;": "◹", "&uscr;": "𝓊", "&utdot;": "⋰", "&utilde;": "ũ", "&utri;": "▵", "&utrif;": "▴", "&uuarr;": "⇈", "&uuml": "ü", "&uuml;": "ü", "&uwangle;": "⦧", "&vArr;": "⇕", "&vBar;": "⫨", "&vBarv;": "⫩", "&vDash;": "⊨", "&vangrt;": "⦜", "&varepsilon;": "ϵ", "&varkappa;": "ϰ", "&varnothing;": "∅", "&varphi;": "ϕ", "&varpi;": "ϖ", "&varpropto;": "∝", "&varr;": "↕", "&varrho;": "ϱ", "&varsigma;": "ς", "&varsubsetneq;": "⊊︀", "&varsubsetneqq;": "⫋︀", "&varsupsetneq;": "⊋︀", "&varsupsetneqq;": "⫌︀", "&vartheta;": "ϑ", "&vartriangleleft;": "⊲", "&vartriangleright;": "⊳", "&vcy;": "в", "&vdash;": "⊢", "&vee;": "∨", "&veebar;": "⊻", "&veeeq;": "≚", "&vellip;": "⋮", "&verbar;": "|", "&vert;": "|", "&vfr;": "𝔳", "&vltri;": "⊲", "&vnsub;": "⊂⃒", "&vnsup;": "⊃⃒", "&vopf;": "𝕧", "&vprop;": "∝", "&vrtri;": "⊳", "&vscr;": "𝓋", "&vsubnE;": "⫋︀", "&vsubne;": "⊊︀", "&vsupnE;": "⫌︀", "&vsupne;": "⊋︀", "&vzigzag;": "⦚", "&wcirc;": "ŵ", "&wedbar;": "⩟", "&wedge;": "∧", "&wedgeq;": "≙", "&weierp;": "℘", "&wfr;": "𝔴", "&wopf;": "𝕨", "&wp;": "℘", "&wr;": "≀", "&wreath;": "≀", "&wscr;": "𝓌", "&xcap;": "⋂", "&xcirc;": "◯", "&xcup;": "⋃", "&xdtri;": "▽", "&xfr;": "𝔵", "&xhArr;": "⟺", "&xharr;": "⟷", "&xi;": "ξ", "&xlArr;": "⟸", "&xlarr;": "⟵", "&xmap;": "⟼", "&xnis;": "⋻", "&xodot;": "⨀", "&xopf;": "𝕩", "&xoplus;": "⨁", "&xotime;": "⨂", "&xrArr;": "⟹", "&xrarr;": "⟶", "&xscr;": "𝓍", "&xsqcup;": "⨆", "&xuplus;": "⨄", "&xutri;": "△", "&xvee;": "⋁", "&xwedge;": "⋀", "&yacute": "ý", "&yacute;": "ý", "&yacy;": "я", "&ycirc;": "ŷ", "&ycy;": "ы", "&yen": "¥", "&yen;": "¥", "&yfr;": "𝔶", "&yicy;": "ї", "&yopf;": "𝕪", "&yscr;": "𝓎", "&yucy;": "ю", "&yuml": "ÿ", "&yuml;": "ÿ", "&zacute;": "ź", "&zcaron;": "ž", "&zcy;": "з", "&zdot;": "ż", "&zeetrf;": "ℨ", "&zeta;": "ζ", "&zfr;": "𝔷", "&zhcy;": "ж", "&zigrarr;": "⇝", "&zopf;": "𝕫", "&zscr;": "𝓏", "&zwj;": "‍", "&zwnj;": "‌" }, characters: { Æ: "&AElig;", "&": "&amp;", Á: "&Aacute;", Ă: "&Abreve;", Â: "&Acirc;", А: "&Acy;", "𝔄": "&Afr;", À: "&Agrave;", Α: "&Alpha;", Ā: "&Amacr;", "⩓": "&And;", Ą: "&Aogon;", "𝔸": "&Aopf;", "⁡": "&af;", Å: "&angst;", "𝒜": "&Ascr;", "≔": "&coloneq;", Ã: "&Atilde;", Ä: "&Auml;", "∖": "&ssetmn;", "⫧": "&Barv;", "⌆": "&doublebarwedge;", Б: "&Bcy;", "∵": "&because;", ℬ: "&bernou;", Β: "&Beta;", "𝔅": "&Bfr;", "𝔹": "&Bopf;", "˘": "&breve;", "≎": "&bump;", Ч: "&CHcy;", "©": "&copy;", Ć: "&Cacute;", "⋒": "&Cap;", "ⅅ": "&DD;", ℭ: "&Cfr;", Č: "&Ccaron;", Ç: "&Ccedil;", Ĉ: "&Ccirc;", "∰": "&Cconint;", Ċ: "&Cdot;", "¸": "&cedil;", "·": "&middot;", Χ: "&Chi;", "⊙": "&odot;", "⊖": "&ominus;", "⊕": "&oplus;", "⊗": "&otimes;", "∲": "&cwconint;", "”": "&rdquor;", "’": "&rsquor;", "∷": "&Proportion;", "⩴": "&Colone;", "≡": "&equiv;", "∯": "&DoubleContourIntegral;", "∮": "&oint;", ℂ: "&complexes;", "∐": "&coprod;", "∳": "&awconint;", "⨯": "&Cross;", "𝒞": "&Cscr;", "⋓": "&Cup;", "≍": "&asympeq;", "⤑": "&DDotrahd;", Ђ: "&DJcy;", Ѕ: "&DScy;", Џ: "&DZcy;", "‡": "&ddagger;", "↡": "&Darr;", "⫤": "&DoubleLeftTee;", Ď: "&Dcaron;", Д: "&Dcy;", "∇": "&nabla;", Δ: "&Delta;", "𝔇": "&Dfr;", "´": "&acute;", "˙": "&dot;", "˝": "&dblac;", "`": "&grave;", "˜": "&tilde;", "⋄": "&diamond;", "ⅆ": "&dd;", "𝔻": "&Dopf;", "¨": "&uml;", "⃜": "&DotDot;", "≐": "&esdot;", "⇓": "&dArr;", "⇐": "&lArr;", "⇔": "&iff;", "⟸": "&xlArr;", "⟺": "&xhArr;", "⟹": "&xrArr;", "⇒": "&rArr;", "⊨": "&vDash;", "⇑": "&uArr;", "⇕": "&vArr;", "∥": "&spar;", "↓": "&downarrow;", "⤓": "&DownArrowBar;", "⇵": "&duarr;", "̑": "&DownBreve;", "⥐": "&DownLeftRightVector;", "⥞": "&DownLeftTeeVector;", "↽": "&lhard;", "⥖": "&DownLeftVectorBar;", "⥟": "&DownRightTeeVector;", "⇁": "&rightharpoondown;", "⥗": "&DownRightVectorBar;", "⊤": "&top;", "↧": "&mapstodown;", "𝒟": "&Dscr;", Đ: "&Dstrok;", Ŋ: "&ENG;", Ð: "&ETH;", É: "&Eacute;", Ě: "&Ecaron;", Ê: "&Ecirc;", Э: "&Ecy;", Ė: "&Edot;", "𝔈": "&Efr;", È: "&Egrave;", "∈": "&isinv;", Ē: "&Emacr;", "◻": "&EmptySmallSquare;", "▫": "&EmptyVerySmallSquare;", Ę: "&Eogon;", "𝔼": "&Eopf;", Ε: "&Epsilon;", "⩵": "&Equal;", "≂": "&esim;", "⇌": "&rlhar;", ℰ: "&expectation;", "⩳": "&Esim;", Η: "&Eta;", Ë: "&Euml;", "∃": "&exist;", "ⅇ": "&exponentiale;", Ф: "&Fcy;", "𝔉": "&Ffr;", "◼": "&FilledSmallSquare;", "▪": "&squf;", "𝔽": "&Fopf;", "∀": "&forall;", ℱ: "&Fscr;", Ѓ: "&GJcy;", ">": "&gt;", Γ: "&Gamma;", Ϝ: "&Gammad;", Ğ: "&Gbreve;", Ģ: "&Gcedil;", Ĝ: "&Gcirc;", Г: "&Gcy;", Ġ: "&Gdot;", "𝔊": "&Gfr;", "⋙": "&ggg;", "𝔾": "&Gopf;", "≥": "&geq;", "⋛": "&gtreqless;", "≧": "&geqq;", "⪢": "&GreaterGreater;", "≷": "&gtrless;", "⩾": "&ges;", "≳": "&gtrsim;", "𝒢": "&Gscr;", "≫": "&gg;", Ъ: "&HARDcy;", "ˇ": "&caron;", "^": "&Hat;", Ĥ: "&Hcirc;", ℌ: "&Poincareplane;", ℋ: "&hamilt;", ℍ: "&quaternions;", "─": "&boxh;", Ħ: "&Hstrok;", "≏": "&bumpeq;", Е: "&IEcy;", Ĳ: "&IJlig;", Ё: "&IOcy;", Í: "&Iacute;", Î: "&Icirc;", И: "&Icy;", İ: "&Idot;", ℑ: "&imagpart;", Ì: "&Igrave;", Ī: "&Imacr;", "ⅈ": "&ii;", "∬": "&Int;", "∫": "&int;", "⋂": "&xcap;", "⁣": "&ic;", "⁢": "&it;", Į: "&Iogon;", "𝕀": "&Iopf;", Ι: "&Iota;", ℐ: "&imagline;", Ĩ: "&Itilde;", І: "&Iukcy;", Ï: "&Iuml;", Ĵ: "&Jcirc;", Й: "&Jcy;", "𝔍": "&Jfr;", "𝕁": "&Jopf;", "𝒥": "&Jscr;", Ј: "&Jsercy;", Є: "&Jukcy;", Х: "&KHcy;", Ќ: "&KJcy;", Κ: "&Kappa;", Ķ: "&Kcedil;", К: "&Kcy;", "𝔎": "&Kfr;", "𝕂": "&Kopf;", "𝒦": "&Kscr;", Љ: "&LJcy;", "<": "&lt;", Ĺ: "&Lacute;", Λ: "&Lambda;", "⟪": "&Lang;", ℒ: "&lagran;", "↞": "&twoheadleftarrow;", Ľ: "&Lcaron;", Ļ: "&Lcedil;", Л: "&Lcy;", "⟨": "&langle;", "←": "&slarr;", "⇤": "&larrb;", "⇆": "&lrarr;", "⌈": "&lceil;", "⟦": "&lobrk;", "⥡": "&LeftDownTeeVector;", "⇃": "&downharpoonleft;", "⥙": "&LeftDownVectorBar;", "⌊": "&lfloor;", "↔": "&leftrightarrow;", "⥎": "&LeftRightVector;", "⊣": "&dashv;", "↤": "&mapstoleft;", "⥚": "&LeftTeeVector;", "⊲": "&vltri;", "⧏": "&LeftTriangleBar;", "⊴": "&trianglelefteq;", "⥑": "&LeftUpDownVector;", "⥠": "&LeftUpTeeVector;", "↿": "&upharpoonleft;", "⥘": "&LeftUpVectorBar;", "↼": "&lharu;", "⥒": "&LeftVectorBar;", "⋚": "&lesseqgtr;", "≦": "&leqq;", "≶": "&lg;", "⪡": "&LessLess;", "⩽": "&les;", "≲": "&lsim;", "𝔏": "&Lfr;", "⋘": "&Ll;", "⇚": "&lAarr;", Ŀ: "&Lmidot;", "⟵": "&xlarr;", "⟷": "&xharr;", "⟶": "&xrarr;", "𝕃": "&Lopf;", "↙": "&swarrow;", "↘": "&searrow;", "↰": "&lsh;", Ł: "&Lstrok;", "≪": "&ll;", "⤅": "&Map;", М: "&Mcy;", " ": "&MediumSpace;", ℳ: "&phmmat;", "𝔐": "&Mfr;", "∓": "&mp;", "𝕄": "&Mopf;", Μ: "&Mu;", Њ: "&NJcy;", Ń: "&Nacute;", Ň: "&Ncaron;", Ņ: "&Ncedil;", Н: "&Ncy;", "​": "&ZeroWidthSpace;", "\n": "&NewLine;", "𝔑": "&Nfr;", "⁠": "&NoBreak;", " ": "&nbsp;", ℕ: "&naturals;", "⫬": "&Not;", "≢": "&nequiv;", "≭": "&NotCupCap;", "∦": "&nspar;", "∉": "&notinva;", "≠": "&ne;", "≂̸": "&nesim;", "∄": "&nexists;", "≯": "&ngtr;", "≱": "&ngeq;", "≧̸": "&ngeqq;", "≫̸": "&nGtv;", "≹": "&ntgl;", "⩾̸": "&nges;", "≵": "&ngsim;", "≎̸": "&nbump;", "≏̸": "&nbumpe;", "⋪": "&ntriangleleft;", "⧏̸": "&NotLeftTriangleBar;", "⋬": "&ntrianglelefteq;", "≮": "&nlt;", "≰": "&nleq;", "≸": "&ntlg;", "≪̸": "&nLtv;", "⩽̸": "&nles;", "≴": "&nlsim;", "⪢̸": "&NotNestedGreaterGreater;", "⪡̸": "&NotNestedLessLess;", "⊀": "&nprec;", "⪯̸": "&npreceq;", "⋠": "&nprcue;", "∌": "&notniva;", "⋫": "&ntriangleright;", "⧐̸": "&NotRightTriangleBar;", "⋭": "&ntrianglerighteq;", "⊏̸": "&NotSquareSubset;", "⋢": "&nsqsube;", "⊐̸": "&NotSquareSuperset;", "⋣": "&nsqsupe;", "⊂⃒": "&vnsub;", "⊈": "&nsubseteq;", "⊁": "&nsucc;", "⪰̸": "&nsucceq;", "⋡": "&nsccue;", "≿̸": "&NotSucceedsTilde;", "⊃⃒": "&vnsup;", "⊉": "&nsupseteq;", "≁": "&nsim;", "≄": "&nsimeq;", "≇": "&ncong;", "≉": "&napprox;", "∤": "&nsmid;", "𝒩": "&Nscr;", Ñ: "&Ntilde;", Ν: "&Nu;", Œ: "&OElig;", Ó: "&Oacute;", Ô: "&Ocirc;", О: "&Ocy;", Ő: "&Odblac;", "𝔒": "&Ofr;", Ò: "&Ograve;", Ō: "&Omacr;", Ω: "&ohm;", Ο: "&Omicron;", "𝕆": "&Oopf;", "“": "&ldquo;", "‘": "&lsquo;", "⩔": "&Or;", "𝒪": "&Oscr;", Ø: "&Oslash;", Õ: "&Otilde;", "⨷": "&Otimes;", Ö: "&Ouml;", "‾": "&oline;", "⏞": "&OverBrace;", "⎴": "&tbrk;", "⏜": "&OverParenthesis;", "∂": "&part;", П: "&Pcy;", "𝔓": "&Pfr;", Φ: "&Phi;", Π: "&Pi;", "±": "&pm;", ℙ: "&primes;", "⪻": "&Pr;", "≺": "&prec;", "⪯": "&preceq;", "≼": "&preccurlyeq;", "≾": "&prsim;", "″": "&Prime;", "∏": "&prod;", "∝": "&vprop;", "𝒫": "&Pscr;", Ψ: "&Psi;", '"': "&quot;", "𝔔": "&Qfr;", ℚ: "&rationals;", "𝒬": "&Qscr;", "⤐": "&drbkarow;", "®": "&reg;", Ŕ: "&Racute;", "⟫": "&Rang;", "↠": "&twoheadrightarrow;", "⤖": "&Rarrtl;", Ř: "&Rcaron;", Ŗ: "&Rcedil;", Р: "&Rcy;", ℜ: "&realpart;", "∋": "&niv;", "⇋": "&lrhar;", "⥯": "&duhar;", Ρ: "&Rho;", "⟩": "&rangle;", "→": "&srarr;", "⇥": "&rarrb;", "⇄": "&rlarr;", "⌉": "&rceil;", "⟧": "&robrk;", "⥝": "&RightDownTeeVector;", "⇂": "&downharpoonright;", "⥕": "&RightDownVectorBar;", "⌋": "&rfloor;", "⊢": "&vdash;", "↦": "&mapsto;", "⥛": "&RightTeeVector;", "⊳": "&vrtri;", "⧐": "&RightTriangleBar;", "⊵": "&trianglerighteq;", "⥏": "&RightUpDownVector;", "⥜": "&RightUpTeeVector;", "↾": "&upharpoonright;", "⥔": "&RightUpVectorBar;", "⇀": "&rightharpoonup;", "⥓": "&RightVectorBar;", ℝ: "&reals;", "⥰": "&RoundImplies;", "⇛": "&rAarr;", ℛ: "&realine;", "↱": "&rsh;", "⧴": "&RuleDelayed;", Щ: "&SHCHcy;", Ш: "&SHcy;", Ь: "&SOFTcy;", Ś: "&Sacute;", "⪼": "&Sc;", Š: "&Scaron;", Ş: "&Scedil;", Ŝ: "&Scirc;", С: "&Scy;", "𝔖": "&Sfr;", "↑": "&uparrow;", Σ: "&Sigma;", "∘": "&compfn;", "𝕊": "&Sopf;", "√": "&radic;", "□": "&square;", "⊓": "&sqcap;", "⊏": "&sqsubset;", "⊑": "&sqsubseteq;", "⊐": "&sqsupset;", "⊒": "&sqsupseteq;", "⊔": "&sqcup;", "𝒮": "&Sscr;", "⋆": "&sstarf;", "⋐": "&Subset;", "⊆": "&subseteq;", "≻": "&succ;", "⪰": "&succeq;", "≽": "&succcurlyeq;", "≿": "&succsim;", "∑": "&sum;", "⋑": "&Supset;", "⊃": "&supset;", "⊇": "&supseteq;", Þ: "&THORN;", "™": "&trade;", Ћ: "&TSHcy;", Ц: "&TScy;", "	": "&Tab;", Τ: "&Tau;", Ť: "&Tcaron;", Ţ: "&Tcedil;", Т: "&Tcy;", "𝔗": "&Tfr;", "∴": "&therefore;", Θ: "&Theta;", "  ": "&ThickSpace;", " ": "&thinsp;", "∼": "&thksim;", "≃": "&simeq;", "≅": "&cong;", "≈": "&thkap;", "𝕋": "&Topf;", "⃛": "&tdot;", "𝒯": "&Tscr;", Ŧ: "&Tstrok;", Ú: "&Uacute;", "↟": "&Uarr;", "⥉": "&Uarrocir;", Ў: "&Ubrcy;", Ŭ: "&Ubreve;", Û: "&Ucirc;", У: "&Ucy;", Ű: "&Udblac;", "𝔘": "&Ufr;", Ù: "&Ugrave;", Ū: "&Umacr;", _: "&lowbar;", "⏟": "&UnderBrace;", "⎵": "&bbrk;", "⏝": "&UnderParenthesis;", "⋃": "&xcup;", "⊎": "&uplus;", Ų: "&Uogon;", "𝕌": "&Uopf;", "⤒": "&UpArrowBar;", "⇅": "&udarr;", "↕": "&varr;", "⥮": "&udhar;", "⊥": "&perp;", "↥": "&mapstoup;", "↖": "&nwarrow;", "↗": "&nearrow;", ϒ: "&upsih;", Υ: "&Upsilon;", Ů: "&Uring;", "𝒰": "&Uscr;", Ũ: "&Utilde;", Ü: "&Uuml;", "⊫": "&VDash;", "⫫": "&Vbar;", В: "&Vcy;", "⊩": "&Vdash;", "⫦": "&Vdashl;", "⋁": "&xvee;", "‖": "&Vert;", "∣": "&smid;", "|": "&vert;", "❘": "&VerticalSeparator;", "≀": "&wreath;", " ": "&hairsp;", "𝔙": "&Vfr;", "𝕍": "&Vopf;", "𝒱": "&Vscr;", "⊪": "&Vvdash;", Ŵ: "&Wcirc;", "⋀": "&xwedge;", "𝔚": "&Wfr;", "𝕎": "&Wopf;", "𝒲": "&Wscr;", "𝔛": "&Xfr;", Ξ: "&Xi;", "𝕏": "&Xopf;", "𝒳": "&Xscr;", Я: "&YAcy;", Ї: "&YIcy;", Ю: "&YUcy;", Ý: "&Yacute;", Ŷ: "&Ycirc;", Ы: "&Ycy;", "𝔜": "&Yfr;", "𝕐": "&Yopf;", "𝒴": "&Yscr;", Ÿ: "&Yuml;", Ж: "&ZHcy;", Ź: "&Zacute;", Ž: "&Zcaron;", З: "&Zcy;", Ż: "&Zdot;", Ζ: "&Zeta;", ℨ: "&zeetrf;", ℤ: "&integers;", "𝒵": "&Zscr;", á: "&aacute;", ă: "&abreve;", "∾": "&mstpos;", "∾̳": "&acE;", "∿": "&acd;", â: "&acirc;", а: "&acy;", æ: "&aelig;", "𝔞": "&afr;", à: "&agrave;", ℵ: "&aleph;", α: "&alpha;", ā: "&amacr;", "⨿": "&amalg;", "∧": "&wedge;", "⩕": "&andand;", "⩜": "&andd;", "⩘": "&andslope;", "⩚": "&andv;", "∠": "&angle;", "⦤": "&ange;", "∡": "&measuredangle;", "⦨": "&angmsdaa;", "⦩": "&angmsdab;", "⦪": "&angmsdac;", "⦫": "&angmsdad;", "⦬": "&angmsdae;", "⦭": "&angmsdaf;", "⦮": "&angmsdag;", "⦯": "&angmsdah;", "∟": "&angrt;", "⊾": "&angrtvb;", "⦝": "&angrtvbd;", "∢": "&angsph;", "⍼": "&angzarr;", ą: "&aogon;", "𝕒": "&aopf;", "⩰": "&apE;", "⩯": "&apacir;", "≊": "&approxeq;", "≋": "&apid;", "'": "&apos;", å: "&aring;", "𝒶": "&ascr;", "*": "&midast;", ã: "&atilde;", ä: "&auml;", "⨑": "&awint;", "⫭": "&bNot;", "≌": "&bcong;", "϶": "&bepsi;", "‵": "&bprime;", "∽": "&bsim;", "⋍": "&bsime;", "⊽": "&barvee;", "⌅": "&barwedge;", "⎶": "&bbrktbrk;", б: "&bcy;", "„": "&ldquor;", "⦰": "&bemptyv;", β: "&beta;", ℶ: "&beth;", "≬": "&twixt;", "𝔟": "&bfr;", "◯": "&xcirc;", "⨀": "&xodot;", "⨁": "&xoplus;", "⨂": "&xotime;", "⨆": "&xsqcup;", "★": "&starf;", "▽": "&xdtri;", "△": "&xutri;", "⨄": "&xuplus;", "⤍": "&rbarr;", "⧫": "&lozf;", "▴": "&utrif;", "▾": "&dtrif;", "◂": "&ltrif;", "▸": "&rtrif;", "␣": "&blank;", "▒": "&blk12;", "░": "&blk14;", "▓": "&blk34;", "█": "&block;", "=⃥": "&bne;", "≡⃥": "&bnequiv;", "⌐": "&bnot;", "𝕓": "&bopf;", "⋈": "&bowtie;", "╗": "&boxDL;", "╔": "&boxDR;", "╖": "&boxDl;", "╓": "&boxDr;", "═": "&boxH;", "╦": "&boxHD;", "╩": "&boxHU;", "╤": "&boxHd;", "╧": "&boxHu;", "╝": "&boxUL;", "╚": "&boxUR;", "╜": "&boxUl;", "╙": "&boxUr;", "║": "&boxV;", "╬": "&boxVH;", "╣": "&boxVL;", "╠": "&boxVR;", "╫": "&boxVh;", "╢": "&boxVl;", "╟": "&boxVr;", "⧉": "&boxbox;", "╕": "&boxdL;", "╒": "&boxdR;", "┐": "&boxdl;", "┌": "&boxdr;", "╥": "&boxhD;", "╨": "&boxhU;", "┬": "&boxhd;", "┴": "&boxhu;", "⊟": "&minusb;", "⊞": "&plusb;", "⊠": "&timesb;", "╛": "&boxuL;", "╘": "&boxuR;", "┘": "&boxul;", "└": "&boxur;", "│": "&boxv;", "╪": "&boxvH;", "╡": "&boxvL;", "╞": "&boxvR;", "┼": "&boxvh;", "┤": "&boxvl;", "├": "&boxvr;", "¦": "&brvbar;", "𝒷": "&bscr;", "⁏": "&bsemi;", "\\": "&bsol;", "⧅": "&bsolb;", "⟈": "&bsolhsub;", "•": "&bullet;", "⪮": "&bumpE;", ć: "&cacute;", "∩": "&cap;", "⩄": "&capand;", "⩉": "&capbrcup;", "⩋": "&capcap;", "⩇": "&capcup;", "⩀": "&capdot;", "∩︀": "&caps;", "⁁": "&caret;", "⩍": "&ccaps;", č: "&ccaron;", ç: "&ccedil;", ĉ: "&ccirc;", "⩌": "&ccups;", "⩐": "&ccupssm;", ċ: "&cdot;", "⦲": "&cemptyv;", "¢": "&cent;", "𝔠": "&cfr;", ч: "&chcy;", "✓": "&checkmark;", χ: "&chi;", "○": "&cir;", "⧃": "&cirE;", "ˆ": "&circ;", "≗": "&cire;", "↺": "&olarr;", "↻": "&orarr;", "Ⓢ": "&oS;", "⊛": "&oast;", "⊚": "&ocir;", "⊝": "&odash;", "⨐": "&cirfnint;", "⫯": "&cirmid;", "⧂": "&cirscir;", "♣": "&clubsuit;", ":": "&colon;", ",": "&comma;", "@": "&commat;", "∁": "&complement;", "⩭": "&congdot;", "𝕔": "&copf;", "℗": "&copysr;", "↵": "&crarr;", "✗": "&cross;", "𝒸": "&cscr;", "⫏": "&csub;", "⫑": "&csube;", "⫐": "&csup;", "⫒": "&csupe;", "⋯": "&ctdot;", "⤸": "&cudarrl;", "⤵": "&cudarrr;", "⋞": "&curlyeqprec;", "⋟": "&curlyeqsucc;", "↶": "&curvearrowleft;", "⤽": "&cularrp;", "∪": "&cup;", "⩈": "&cupbrcap;", "⩆": "&cupcap;", "⩊": "&cupcup;", "⊍": "&cupdot;", "⩅": "&cupor;", "∪︀": "&cups;", "↷": "&curvearrowright;", "⤼": "&curarrm;", "⋎": "&cuvee;", "⋏": "&cuwed;", "¤": "&curren;", "∱": "&cwint;", "⌭": "&cylcty;", "⥥": "&dHar;", "†": "&dagger;", ℸ: "&daleth;", "‐": "&hyphen;", "⤏": "&rBarr;", ď: "&dcaron;", д: "&dcy;", "⇊": "&downdownarrows;", "⩷": "&eDDot;", "°": "&deg;", δ: "&delta;", "⦱": "&demptyv;", "⥿": "&dfisht;", "𝔡": "&dfr;", "♦": "&diams;", ϝ: "&gammad;", "⋲": "&disin;", "÷": "&divide;", "⋇": "&divonx;", ђ: "&djcy;", "⌞": "&llcorner;", "⌍": "&dlcrop;", $: "&dollar;", "𝕕": "&dopf;", "≑": "&eDot;", "∸": "&minusd;", "∔": "&plusdo;", "⊡": "&sdotb;", "⌟": "&lrcorner;", "⌌": "&drcrop;", "𝒹": "&dscr;", ѕ: "&dscy;", "⧶": "&dsol;", đ: "&dstrok;", "⋱": "&dtdot;", "▿": "&triangledown;", "⦦": "&dwangle;", џ: "&dzcy;", "⟿": "&dzigrarr;", é: "&eacute;", "⩮": "&easter;", ě: "&ecaron;", "≖": "&eqcirc;", ê: "&ecirc;", "≕": "&eqcolon;", э: "&ecy;", ė: "&edot;", "≒": "&fallingdotseq;", "𝔢": "&efr;", "⪚": "&eg;", è: "&egrave;", "⪖": "&eqslantgtr;", "⪘": "&egsdot;", "⪙": "&el;", "⏧": "&elinters;", ℓ: "&ell;", "⪕": "&eqslantless;", "⪗": "&elsdot;", ē: "&emacr;", "∅": "&varnothing;", " ": "&emsp13;", " ": "&emsp14;", " ": "&emsp;", ŋ: "&eng;", " ": "&ensp;", ę: "&eogon;", "𝕖": "&eopf;", "⋕": "&epar;", "⧣": "&eparsl;", "⩱": "&eplus;", ε: "&epsilon;", "ϵ": "&varepsilon;", "=": "&equals;", "≟": "&questeq;", "⩸": "&equivDD;", "⧥": "&eqvparsl;", "≓": "&risingdotseq;", "⥱": "&erarr;", ℯ: "&escr;", η: "&eta;", ð: "&eth;", ë: "&euml;", "€": "&euro;", "!": "&excl;", ф: "&fcy;", "♀": "&female;", ﬃ: "&ffilig;", ﬀ: "&fflig;", ﬄ: "&ffllig;", "𝔣": "&ffr;", ﬁ: "&filig;", fj: "&fjlig;", "♭": "&flat;", ﬂ: "&fllig;", "▱": "&fltns;", ƒ: "&fnof;", "𝕗": "&fopf;", "⋔": "&pitchfork;", "⫙": "&forkv;", "⨍": "&fpartint;", "½": "&half;", "⅓": "&frac13;", "¼": "&frac14;", "⅕": "&frac15;", "⅙": "&frac16;", "⅛": "&frac18;", "⅔": "&frac23;", "⅖": "&frac25;", "¾": "&frac34;", "⅗": "&frac35;", "⅜": "&frac38;", "⅘": "&frac45;", "⅚": "&frac56;", "⅝": "&frac58;", "⅞": "&frac78;", "⁄": "&frasl;", "⌢": "&sfrown;", "𝒻": "&fscr;", "⪌": "&gtreqqless;", ǵ: "&gacute;", γ: "&gamma;", "⪆": "&gtrapprox;", ğ: "&gbreve;", ĝ: "&gcirc;", г: "&gcy;", ġ: "&gdot;", "⪩": "&gescc;", "⪀": "&gesdot;", "⪂": "&gesdoto;", "⪄": "&gesdotol;", "⋛︀": "&gesl;", "⪔": "&gesles;", "𝔤": "&gfr;", ℷ: "&gimel;", ѓ: "&gjcy;", "⪒": "&glE;", "⪥": "&gla;", "⪤": "&glj;", "≩": "&gneqq;", "⪊": "&gnapprox;", "⪈": "&gneq;", "⋧": "&gnsim;", "𝕘": "&gopf;", ℊ: "&gscr;", "⪎": "&gsime;", "⪐": "&gsiml;", "⪧": "&gtcc;", "⩺": "&gtcir;", "⋗": "&gtrdot;", "⦕": "&gtlPar;", "⩼": "&gtquest;", "⥸": "&gtrarr;", "≩︀": "&gvnE;", ъ: "&hardcy;", "⥈": "&harrcir;", "↭": "&leftrightsquigarrow;", ℏ: "&plankv;", ĥ: "&hcirc;", "♥": "&heartsuit;", "…": "&mldr;", "⊹": "&hercon;", "𝔥": "&hfr;", "⤥": "&searhk;", "⤦": "&swarhk;", "⇿": "&hoarr;", "∻": "&homtht;", "↩": "&larrhk;", "↪": "&rarrhk;", "𝕙": "&hopf;", "―": "&horbar;", "𝒽": "&hscr;", ħ: "&hstrok;", "⁃": "&hybull;", í: "&iacute;", î: "&icirc;", и: "&icy;", е: "&iecy;", "¡": "&iexcl;", "𝔦": "&ifr;", ì: "&igrave;", "⨌": "&qint;", "∭": "&tint;", "⧜": "&iinfin;", "℩": "&iiota;", ĳ: "&ijlig;", ī: "&imacr;", ı: "&inodot;", "⊷": "&imof;", Ƶ: "&imped;", "℅": "&incare;", "∞": "&infin;", "⧝": "&infintie;", "⊺": "&intercal;", "⨗": "&intlarhk;", "⨼": "&iprod;", ё: "&iocy;", į: "&iogon;", "𝕚": "&iopf;", ι: "&iota;", "¿": "&iquest;", "𝒾": "&iscr;", "⋹": "&isinE;", "⋵": "&isindot;", "⋴": "&isins;", "⋳": "&isinsv;", ĩ: "&itilde;", і: "&iukcy;", ï: "&iuml;", ĵ: "&jcirc;", й: "&jcy;", "𝔧": "&jfr;", "ȷ": "&jmath;", "𝕛": "&jopf;", "𝒿": "&jscr;", ј: "&jsercy;", є: "&jukcy;", κ: "&kappa;", ϰ: "&varkappa;", ķ: "&kcedil;", к: "&kcy;", "𝔨": "&kfr;", ĸ: "&kgreen;", х: "&khcy;", ќ: "&kjcy;", "𝕜": "&kopf;", "𝓀": "&kscr;", "⤛": "&lAtail;", "⤎": "&lBarr;", "⪋": "&lesseqqgtr;", "⥢": "&lHar;", ĺ: "&lacute;", "⦴": "&laemptyv;", λ: "&lambda;", "⦑": "&langd;", "⪅": "&lessapprox;", "«": "&laquo;", "⤟": "&larrbfs;", "⤝": "&larrfs;", "↫": "&looparrowleft;", "⤹": "&larrpl;", "⥳": "&larrsim;", "↢": "&leftarrowtail;", "⪫": "&lat;", "⤙": "&latail;", "⪭": "&late;", "⪭︀": "&lates;", "⤌": "&lbarr;", "❲": "&lbbrk;", "{": "&lcub;", "[": "&lsqb;", "⦋": "&lbrke;", "⦏": "&lbrksld;", "⦍": "&lbrkslu;", ľ: "&lcaron;", ļ: "&lcedil;", л: "&lcy;", "⤶": "&ldca;", "⥧": "&ldrdhar;", "⥋": "&ldrushar;", "↲": "&ldsh;", "≤": "&leq;", "⇇": "&llarr;", "⋋": "&lthree;", "⪨": "&lescc;", "⩿": "&lesdot;", "⪁": "&lesdoto;", "⪃": "&lesdotor;", "⋚︀": "&lesg;", "⪓": "&lesges;", "⋖": "&ltdot;", "⥼": "&lfisht;", "𝔩": "&lfr;", "⪑": "&lgE;", "⥪": "&lharul;", "▄": "&lhblk;", љ: "&ljcy;", "⥫": "&llhard;", "◺": "&lltri;", ŀ: "&lmidot;", "⎰": "&lmoustache;", "≨": "&lneqq;", "⪉": "&lnapprox;", "⪇": "&lneq;", "⋦": "&lnsim;", "⟬": "&loang;", "⇽": "&loarr;", "⟼": "&xmap;", "↬": "&rarrlp;", "⦅": "&lopar;", "𝕝": "&lopf;", "⨭": "&loplus;", "⨴": "&lotimes;", "∗": "&lowast;", "◊": "&lozenge;", "(": "&lpar;", "⦓": "&lparlt;", "⥭": "&lrhard;", "‎": "&lrm;", "⊿": "&lrtri;", "‹": "&lsaquo;", "𝓁": "&lscr;", "⪍": "&lsime;", "⪏": "&lsimg;", "‚": "&sbquo;", ł: "&lstrok;", "⪦": "&ltcc;", "⩹": "&ltcir;", "⋉": "&ltimes;", "⥶": "&ltlarr;", "⩻": "&ltquest;", "⦖": "&ltrPar;", "◃": "&triangleleft;", "⥊": "&lurdshar;", "⥦": "&luruhar;", "≨︀": "&lvnE;", "∺": "&mDDot;", "¯": "&strns;", "♂": "&male;", "✠": "&maltese;", "▮": "&marker;", "⨩": "&mcomma;", м: "&mcy;", "—": "&mdash;", "𝔪": "&mfr;", "℧": "&mho;", µ: "&micro;", "⫰": "&midcir;", "−": "&minus;", "⨪": "&minusdu;", "⫛": "&mlcp;", "⊧": "&models;", "𝕞": "&mopf;", "𝓂": "&mscr;", μ: "&mu;", "⊸": "&mumap;", "⋙̸": "&nGg;", "≫⃒": "&nGt;", "⇍": "&nlArr;", "⇎": "&nhArr;", "⋘̸": "&nLl;", "≪⃒": "&nLt;", "⇏": "&nrArr;", "⊯": "&nVDash;", "⊮": "&nVdash;", ń: "&nacute;", "∠⃒": "&nang;", "⩰̸": "&napE;", "≋̸": "&napid;", ŉ: "&napos;", "♮": "&natural;", "⩃": "&ncap;", ň: "&ncaron;", ņ: "&ncedil;", "⩭̸": "&ncongdot;", "⩂": "&ncup;", н: "&ncy;", "–": "&ndash;", "⇗": "&neArr;", "⤤": "&nearhk;", "≐̸": "&nedot;", "⤨": "&toea;", "𝔫": "&nfr;", "↮": "&nleftrightarrow;", "⫲": "&nhpar;", "⋼": "&nis;", "⋺": "&nisd;", њ: "&njcy;", "≦̸": "&nleqq;", "↚": "&nleftarrow;", "‥": "&nldr;", "𝕟": "&nopf;", "¬": "&not;", "⋹̸": "&notinE;", "⋵̸": "&notindot;", "⋷": "&notinvb;", "⋶": "&notinvc;", "⋾": "&notnivb;", "⋽": "&notnivc;", "⫽⃥": "&nparsl;", "∂̸": "&npart;", "⨔": "&npolint;", "↛": "&nrightarrow;", "⤳̸": "&nrarrc;", "↝̸": "&nrarrw;", "𝓃": "&nscr;", "⊄": "&nsub;", "⫅̸": "&nsubseteqq;", "⊅": "&nsup;", "⫆̸": "&nsupseteqq;", ñ: "&ntilde;", ν: "&nu;", "#": "&num;", "№": "&numero;", " ": "&numsp;", "⊭": "&nvDash;", "⤄": "&nvHarr;", "≍⃒": "&nvap;", "⊬": "&nvdash;", "≥⃒": "&nvge;", ">⃒": "&nvgt;", "⧞": "&nvinfin;", "⤂": "&nvlArr;", "≤⃒": "&nvle;", "<⃒": "&nvlt;", "⊴⃒": "&nvltrie;", "⤃": "&nvrArr;", "⊵⃒": "&nvrtrie;", "∼⃒": "&nvsim;", "⇖": "&nwArr;", "⤣": "&nwarhk;", "⤧": "&nwnear;", ó: "&oacute;", ô: "&ocirc;", о: "&ocy;", ő: "&odblac;", "⨸": "&odiv;", "⦼": "&odsold;", œ: "&oelig;", "⦿": "&ofcir;", "𝔬": "&ofr;", "˛": "&ogon;", ò: "&ograve;", "⧁": "&ogt;", "⦵": "&ohbar;", "⦾": "&olcir;", "⦻": "&olcross;", "⧀": "&olt;", ō: "&omacr;", ω: "&omega;", ο: "&omicron;", "⦶": "&omid;", "𝕠": "&oopf;", "⦷": "&opar;", "⦹": "&operp;", "∨": "&vee;", "⩝": "&ord;", ℴ: "&oscr;", ª: "&ordf;", º: "&ordm;", "⊶": "&origof;", "⩖": "&oror;", "⩗": "&orslope;", "⩛": "&orv;", ø: "&oslash;", "⊘": "&osol;", õ: "&otilde;", "⨶": "&otimesas;", ö: "&ouml;", "⌽": "&ovbar;", "¶": "&para;", "⫳": "&parsim;", "⫽": "&parsl;", п: "&pcy;", "%": "&percnt;", ".": "&period;", "‰": "&permil;", "‱": "&pertenk;", "𝔭": "&pfr;", φ: "&phi;", ϕ: "&varphi;", "☎": "&phone;", π: "&pi;", ϖ: "&varpi;", ℎ: "&planckh;", "+": "&plus;", "⨣": "&plusacir;", "⨢": "&pluscir;", "⨥": "&plusdu;", "⩲": "&pluse;", "⨦": "&plussim;", "⨧": "&plustwo;", "⨕": "&pointint;", "𝕡": "&popf;", "£": "&pound;", "⪳": "&prE;", "⪷": "&precapprox;", "⪹": "&prnap;", "⪵": "&prnE;", "⋨": "&prnsim;", "′": "&prime;", "⌮": "&profalar;", "⌒": "&profline;", "⌓": "&profsurf;", "⊰": "&prurel;", "𝓅": "&pscr;", ψ: "&psi;", " ": "&puncsp;", "𝔮": "&qfr;", "𝕢": "&qopf;", "⁗": "&qprime;", "𝓆": "&qscr;", "⨖": "&quatint;", "?": "&quest;", "⤜": "&rAtail;", "⥤": "&rHar;", "∽̱": "&race;", ŕ: "&racute;", "⦳": "&raemptyv;", "⦒": "&rangd;", "⦥": "&range;", "»": "&raquo;", "⥵": "&rarrap;", "⤠": "&rarrbfs;", "⤳": "&rarrc;", "⤞": "&rarrfs;", "⥅": "&rarrpl;", "⥴": "&rarrsim;", "↣": "&rightarrowtail;", "↝": "&rightsquigarrow;", "⤚": "&ratail;", "∶": "&ratio;", "❳": "&rbbrk;", "}": "&rcub;", "]": "&rsqb;", "⦌": "&rbrke;", "⦎": "&rbrksld;", "⦐": "&rbrkslu;", ř: "&rcaron;", ŗ: "&rcedil;", р: "&rcy;", "⤷": "&rdca;", "⥩": "&rdldhar;", "↳": "&rdsh;", "▭": "&rect;", "⥽": "&rfisht;", "𝔯": "&rfr;", "⥬": "&rharul;", ρ: "&rho;", ϱ: "&varrho;", "⇉": "&rrarr;", "⋌": "&rthree;", "˚": "&ring;", "‏": "&rlm;", "⎱": "&rmoustache;", "⫮": "&rnmid;", "⟭": "&roang;", "⇾": "&roarr;", "⦆": "&ropar;", "𝕣": "&ropf;", "⨮": "&roplus;", "⨵": "&rotimes;", ")": "&rpar;", "⦔": "&rpargt;", "⨒": "&rppolint;", "›": "&rsaquo;", "𝓇": "&rscr;", "⋊": "&rtimes;", "▹": "&triangleright;", "⧎": "&rtriltri;", "⥨": "&ruluhar;", "℞": "&rx;", ś: "&sacute;", "⪴": "&scE;", "⪸": "&succapprox;", š: "&scaron;", ş: "&scedil;", ŝ: "&scirc;", "⪶": "&succneqq;", "⪺": "&succnapprox;", "⋩": "&succnsim;", "⨓": "&scpolint;", с: "&scy;", "⋅": "&sdot;", "⩦": "&sdote;", "⇘": "&seArr;", "§": "&sect;", ";": "&semi;", "⤩": "&tosa;", "✶": "&sext;", "𝔰": "&sfr;", "♯": "&sharp;", щ: "&shchcy;", ш: "&shcy;", "­": "&shy;", σ: "&sigma;", ς: "&varsigma;", "⩪": "&simdot;", "⪞": "&simg;", "⪠": "&simgE;", "⪝": "&siml;", "⪟": "&simlE;", "≆": "&simne;", "⨤": "&simplus;", "⥲": "&simrarr;", "⨳": "&smashp;", "⧤": "&smeparsl;", "⌣": "&ssmile;", "⪪": "&smt;", "⪬": "&smte;", "⪬︀": "&smtes;", ь: "&softcy;", "/": "&sol;", "⧄": "&solb;", "⌿": "&solbar;", "𝕤": "&sopf;", "♠": "&spadesuit;", "⊓︀": "&sqcaps;", "⊔︀": "&sqcups;", "𝓈": "&sscr;", "☆": "&star;", "⊂": "&subset;", "⫅": "&subseteqq;", "⪽": "&subdot;", "⫃": "&subedot;", "⫁": "&submult;", "⫋": "&subsetneqq;", "⊊": "&subsetneq;", "⪿": "&subplus;", "⥹": "&subrarr;", "⫇": "&subsim;", "⫕": "&subsub;", "⫓": "&subsup;", "♪": "&sung;", "¹": "&sup1;", "²": "&sup2;", "³": "&sup3;", "⫆": "&supseteqq;", "⪾": "&supdot;", "⫘": "&supdsub;", "⫄": "&supedot;", "⟉": "&suphsol;", "⫗": "&suphsub;", "⥻": "&suplarr;", "⫂": "&supmult;", "⫌": "&supsetneqq;", "⊋": "&supsetneq;", "⫀": "&supplus;", "⫈": "&supsim;", "⫔": "&supsub;", "⫖": "&supsup;", "⇙": "&swArr;", "⤪": "&swnwar;", ß: "&szlig;", "⌖": "&target;", τ: "&tau;", ť: "&tcaron;", ţ: "&tcedil;", т: "&tcy;", "⌕": "&telrec;", "𝔱": "&tfr;", θ: "&theta;", ϑ: "&vartheta;", þ: "&thorn;", "×": "&times;", "⨱": "&timesbar;", "⨰": "&timesd;", "⌶": "&topbot;", "⫱": "&topcir;", "𝕥": "&topf;", "⫚": "&topfork;", "‴": "&tprime;", "▵": "&utri;", "≜": "&trie;", "◬": "&tridot;", "⨺": "&triminus;", "⨹": "&triplus;", "⧍": "&trisb;", "⨻": "&tritime;", "⏢": "&trpezium;", "𝓉": "&tscr;", ц: "&tscy;", ћ: "&tshcy;", ŧ: "&tstrok;", "⥣": "&uHar;", ú: "&uacute;", ў: "&ubrcy;", ŭ: "&ubreve;", û: "&ucirc;", у: "&ucy;", ű: "&udblac;", "⥾": "&ufisht;", "𝔲": "&ufr;", ù: "&ugrave;", "▀": "&uhblk;", "⌜": "&ulcorner;", "⌏": "&ulcrop;", "◸": "&ultri;", ū: "&umacr;", ų: "&uogon;", "𝕦": "&uopf;", υ: "&upsilon;", "⇈": "&uuarr;", "⌝": "&urcorner;", "⌎": "&urcrop;", ů: "&uring;", "◹": "&urtri;", "𝓊": "&uscr;", "⋰": "&utdot;", ũ: "&utilde;", ü: "&uuml;", "⦧": "&uwangle;", "⫨": "&vBar;", "⫩": "&vBarv;", "⦜": "&vangrt;", "⊊︀": "&vsubne;", "⫋︀": "&vsubnE;", "⊋︀": "&vsupne;", "⫌︀": "&vsupnE;", в: "&vcy;", "⊻": "&veebar;", "≚": "&veeeq;", "⋮": "&vellip;", "𝔳": "&vfr;", "𝕧": "&vopf;", "𝓋": "&vscr;", "⦚": "&vzigzag;", ŵ: "&wcirc;", "⩟": "&wedbar;", "≙": "&wedgeq;", "℘": "&wp;", "𝔴": "&wfr;", "𝕨": "&wopf;", "𝓌": "&wscr;", "𝔵": "&xfr;", ξ: "&xi;", "⋻": "&xnis;", "𝕩": "&xopf;", "𝓍": "&xscr;", ý: "&yacute;", я: "&yacy;", ŷ: "&ycirc;", ы: "&ycy;", "¥": "&yen;", "𝔶": "&yfr;", ї: "&yicy;", "𝕪": "&yopf;", "𝓎": "&yscr;", ю: "&yucy;", ÿ: "&yuml;", ź: "&zacute;", ž: "&zcaron;", з: "&zcy;", ż: "&zdot;", ζ: "&zeta;", "𝔷": "&zfr;", ж: "&zhcy;", "⇝": "&zigrarr;", "𝕫": "&zopf;", "𝓏": "&zscr;", "‍": "&zwj;", "‌": "&zwnj;" } } };
var UI = {};
Object.defineProperty(UI, "__esModule", { value: !0 });
UI.numericUnicodeMap = { 0: 65533, 128: 8364, 130: 8218, 131: 402, 132: 8222, 133: 8230, 134: 8224, 135: 8225, 136: 710, 137: 8240, 138: 352, 139: 8249, 140: 338, 142: 381, 145: 8216, 146: 8217, 147: 8220, 148: 8221, 149: 8226, 150: 8211, 151: 8212, 152: 732, 153: 8482, 154: 353, 155: 8250, 156: 339, 158: 382, 159: 376 };
var nd = {};
Object.defineProperty(nd, "__esModule", { value: !0 });
nd.fromCodePoint = String.fromCodePoint || function(e) {
  return String.fromCharCode(Math.floor((e - 65536) / 1024) + 55296, (e - 65536) % 1024 + 56320);
};
nd.getCodePoint = String.prototype.codePointAt ? function(e, t) {
  return e.codePointAt(t);
} : function(e, t) {
  return (e.charCodeAt(t) - 55296) * 1024 + e.charCodeAt(t + 1) - 56320 + 65536;
};
nd.highSurrogateFrom = 55296;
nd.highSurrogateTo = 56319;
var M0 = yt && yt.__assign || function() {
  return M0 = Object.assign || function(e) {
    for (var t, i = 1, r = arguments.length; i < r; i++) {
      t = arguments[i];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, M0.apply(this, arguments);
};
Object.defineProperty(rA, "__esModule", { value: !0 });
var Mm = nA, qq = UI, GI = nd, QI = M0(M0({}, Mm.namedReferences), { all: Mm.namedReferences.html5 }), pwe = {
  specialChars: /[<>'"&]/g,
  nonAscii: /[<>'"&\u0080-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/g,
  nonAsciiPrintable: /[<>'"&\x01-\x08\x11-\x15\x17-\x1F\x7f-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/g,
  nonAsciiPrintableOnly: /[\x01-\x08\x11-\x15\x17-\x1F\x7f-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/g,
  extensive: /[\x01-\x0c\x0e-\x1f\x21-\x2c\x2e-\x2f\x3a-\x40\x5b-\x60\x7b-\x7d\x7f-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/g
}, fwe = {
  mode: "specialChars",
  level: "all",
  numeric: "decimal"
};
function Awe(e, t) {
  var u = t === void 0 ? fwe : t, m = u.mode, i = m === void 0 ? "specialChars" : m, r = u.numeric, n = r === void 0 ? "decimal" : r, o = u.level, s = o === void 0 ? "all" : o;
  if (!e)
    return "";
  var a = pwe[i], l = QI[s].characters, c = n === "hexadecimal";
  a.lastIndex = 0;
  var u = a.exec(e), m;
  if (u) {
    m = "";
    var r = 0;
    do {
      r !== u.index && (m += e.substring(r, u.index));
      var o = u[0], g = l[o];
      if (!g) {
        var h = o.length > 1 ? GI.getCodePoint(o, 0) : o.charCodeAt(0);
        g = (c ? "&#x" + h.toString(16) : "&#" + h) + ";";
      }
      m += g, r = u.index + o.length;
    } while (u = a.exec(e));
    r !== e.length && (m += e.substring(r));
  } else
    m = e;
  return m;
}
rA.encode = Awe;
var ywe = {
  scope: "body",
  level: "all"
}, Gv = /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);/g, Qv = /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+)[;=]?/g, pN = {
  xml: {
    strict: Gv,
    attribute: Qv,
    body: Mm.bodyRegExps.xml
  },
  html4: {
    strict: Gv,
    attribute: Qv,
    body: Mm.bodyRegExps.html4
  },
  html5: {
    strict: Gv,
    attribute: Qv,
    body: Mm.bodyRegExps.html5
  }
}, Ewe = M0(M0({}, pN), { all: pN.html5 }), WI = String.fromCharCode, jq = WI(65533), vwe = {
  level: "all"
};
function bwe(e, t) {
  var r = (t === void 0 ? vwe : t).level, i = r === void 0 ? "all" : r;
  if (!e)
    return "";
  var r = e;
  e[e.length - 1];
  {
    var n = QI[i].entities[e];
    if (n)
      r = n;
    else if (e[0] === "&" && e[1] === "#") {
      var o = e[2], s = o == "x" || o == "X" ? parseInt(e.substr(3), 16) : parseInt(e.substr(2));
      r = s >= 1114111 ? jq : s > 65535 ? GI.fromCodePoint(s) : WI(qq.numericUnicodeMap[s] || s);
    }
  }
  return r;
}
rA.decodeEntity = bwe;
function Cwe(e, t) {
  var i = t === void 0 ? ywe : t, r = i.level, n = r === void 0 ? "all" : r, o = i.scope, s = o === void 0 ? n === "xml" ? "strict" : "body" : o;
  if (!e)
    return "";
  var a = Ewe[n][s], l = QI[n].entities, c = s === "attribute", u = s === "strict";
  a.lastIndex = 0;
  var m = a.exec(e), g;
  if (m) {
    g = "";
    var h = 0;
    do {
      h !== m.index && (g += e.substring(h, m.index));
      var A = m[0], y = A, E = A[A.length - 1];
      if (c && E === "=")
        y = A;
      else if (u && E !== ";")
        y = A;
      else {
        var v = l[A];
        if (v)
          y = v;
        else if (A[0] === "&" && A[1] === "#") {
          var C = A[2], x = C == "x" || C == "X" ? parseInt(A.substr(3), 16) : parseInt(A.substr(2));
          y = x >= 1114111 ? jq : x > 65535 ? GI.fromCodePoint(x) : WI(qq.numericUnicodeMap[x] || x);
        }
      }
      g += y, h = m.index + A.length;
    } while (m = a.exec(e));
    h !== e.length && (g += e.substring(h));
  } else
    g = e;
  return g;
}
var xwe = rA.decode = Cwe;
const Iwe = "_image_1ibf0_1", Swe = {
  image: Iwe
};
function oA({
  post: e,
  sizes: t = "669px",
  className: i,
  style: r
}) {
  var a, l, c, u;
  const { assetPath: n } = fi(), o = Ne(!1);
  let s;
  return e.images && (s = [
    `${Cc(e.images.thumbnail.source_url, n)} ${e.images.thumbnail.width}w`,
    `${Cc(e.images.medium.source_url, n)} ${e.images.medium.width}w`,
    `${Cc(e.images.large.source_url, n)} ${e.images.large.width}w`
  ].join(", ")), /* @__PURE__ */ f(
    "img",
    {
      className: me(Swe.image, i),
      style: r,
      src: Cc((l = (a = e.images) == null ? void 0 : a.full) == null ? void 0 : l.source_url, n),
      srcSet: s,
      sizes: t,
      alt: xwe(((u = (c = e.images) == null ? void 0 : c.full) == null ? void 0 : u.name) || e.post_title),
      onError: ({ currentTarget: m }) => {
        o.current || (o.current = !0, m.src = `${n}/images/empty-asset.webp`);
      }
    }
  );
}
const Rwe = "_post_bauh7_1", kwe = "_shadowOverlay_bauh7_13", wwe = "_imageContainer_bauh7_21", Mwe = "_image_bauh7_21", Nwe = "_contentOverlay_bauh7_29", Twe = "_contentOverlayCentered_bauh7_41", Bwe = "_content_bauh7_29", Dwe = "_top_bauh7_55", Owe = "_preTitle_bauh7_60", Fwe = "_titleWrapper_bauh7_68", Vwe = "_titleIcon_bauh7_72", qwe = "_title_bauh7_68", jwe = "_details_bauh7_91", Lwe = "_date_bauh7_102", Kwe = "_details2_bauh7_107", Ywe = "_text_bauh7_116", Uwe = "_bottom_bauh7_125", Gwe = "_subtitle_bauh7_190", Qwe = "_link_bauh7_235", er = {
  post: Rwe,
  shadowOverlay: kwe,
  imageContainer: wwe,
  image: Mwe,
  contentOverlay: Nwe,
  contentOverlayCentered: Twe,
  content: Bwe,
  top: Dwe,
  preTitle: Owe,
  titleWrapper: Fwe,
  titleIcon: Vwe,
  title: qwe,
  details: jwe,
  date: Lwe,
  details2: Kwe,
  text: Ywe,
  bottom: Uwe,
  "bottom-faded-to-black": "_bottom-faded-to-black_bauh7_134",
  "dark-inset-with-icon": "_dark-inset-with-icon_bauh7_160",
  subtitle: Gwe,
  "left-faded-to-black": "_left-faded-to-black_bauh7_200",
  link: Qwe
};
function Wwe(v) {
  var C = v, {
    post: e,
    tag: t,
    postStyle: i = "bottom-faded-to-black",
    preTitle: r,
    titleIcon: n,
    titleClass: o,
    subTitle: s,
    showDetails: a = !0,
    openInNewTab: l,
    shadowOverlay: c = !0,
    postAlignCenter: u = !1,
    customImgLeftOffset: m,
    customImgStyle: g,
    flipImg: h = !1,
    className: A,
    children: y
  } = C, E = Fe(C, [
    "post",
    "tag",
    "postStyle",
    "preTitle",
    "titleIcon",
    "titleClass",
    "subTitle",
    "showDetails",
    "openInNewTab",
    "shadowOverlay",
    "postAlignCenter",
    "customImgLeftOffset",
    "customImgStyle",
    "flipImg",
    "className",
    "children"
  ]);
  var D, O, F;
  const { assetPath: x, apiUrl: S } = fi(), R = Cc((O = (D = e == null ? void 0 : e.images) == null ? void 0 : D.full) == null ? void 0 : O.source_url, x), w = m ? `calc(-25% - ${m})` : "-25%", T = h ? "-90deg" : "90deg", N = h ? "60%" : "40%";
  return /* @__PURE__ */ V(
    "article",
    ee(q({
      className: me(er.post, er[i], e.permalink !== void 0 && er.link, A)
    }, E), {
      children: [
        /* @__PURE__ */ V(
          "div",
          {
            style: i === "left-faded-to-black" ? { right: w } : void 0,
            className: me(er.imageContainer),
            children: [
              ["bottom-faded-to-black", "dark-inset-with-icon"].includes(i) && // TODO: Replace this with a PostImage component
              /* @__PURE__ */ f(
                "div",
                {
                  className: er.image,
                  style: q({
                    backgroundImage: `linear-gradient(180deg, transparent 50%, rgb(0, 0, 0) 90%), url('${R}')`,
                    scale: h && i === "dark-inset-with-icon" ? "-100% 100%" : void 0
                  }, g)
                }
              ),
              i === "left-faded-to-black" && /* @__PURE__ */ f(
                oA,
                {
                  style: {
                    maskImage: `linear-gradient(${T}, transparent, rgba(var(--maxroll-color-dark-5), 50%) ${N})`,
                    WebkitMaskImage: `linear-gradient(${T}, transparent, rgba(var(--maxroll-color-dark-5), 50%) ${N})`,
                    scale: h ? "-100% 100%" : ""
                  },
                  className: er.image,
                  post: e
                }
              )
            ]
          }
        ),
        c && ["bottom-faded-to-black", "dark-inset-with-icon"].includes(i) && /* @__PURE__ */ f("div", { className: er.shadowOverlay }),
        /* @__PURE__ */ V(
          rd,
          {
            isLink: e.permalink !== void 0,
            openInNewTab: l,
            to: e.permalink && eu(e.permalink, S),
            className: me(er.contentOverlay, u && er.contentOverlayCentered),
            children: [
              t ? /* @__PURE__ */ f(Xc, q({}, t)) : /* @__PURE__ */ f("span", {}),
              /* @__PURE__ */ V("div", { className: er.content, children: [
                /* @__PURE__ */ V("div", { className: er.top, children: [
                  r !== void 0 && /* @__PURE__ */ f("span", { className: er.preTitle, children: r }),
                  /* @__PURE__ */ V("div", { className: er.titleWrapper, children: [
                    n ? /* @__PURE__ */ f("img", { className: er.titleIcon, src: `${n}` }) : null,
                    /* @__PURE__ */ V("h3", { title: e.post_title, className: er.title, children: [
                      /* @__PURE__ */ f("span", { className: o, children: e.post_title }),
                      s ? /* @__PURE__ */ f("span", { className: er.subtitle, children: s }) : null
                    ] })
                  ] }),
                  a && i !== "dark-inset-with-icon" && ((F = e == null ? void 0 : e.post_author) != null && F.display_name ? /* @__PURE__ */ V("span", { className: er.details, children: [
                    /* @__PURE__ */ V("span", { children: [
                      "by ",
                      e.post_author.display_name
                    ] }),
                    /* @__PURE__ */ f("span", { className: er.date, children: Gs(e.post_modified_formatted) })
                  ] }) : /* @__PURE__ */ V("span", { className: er.details2, children: [
                    /* @__PURE__ */ f("span", { className: er.text, children: "Last Updated:" }),
                    /* @__PURE__ */ f("span", { className: er.date, children: Gs(e.post_modified_formatted) })
                  ] }))
                ] }),
                y && /* @__PURE__ */ f("div", { className: er.bottom, children: y })
              ] })
            ]
          }
        )
      ]
    })
  );
}
const Zwe = "_mobileLayout_f1thf_1", Jwe = "_container_f1thf_5", Pwe = "_scrollDrag_f1thf_12", Mp = {
  mobileLayout: Zwe,
  container: Jwe,
  scrollDrag: Pwe
};
function y7e({ posts: e, className: t, children: i }) {
  return e.length > 0 ? /* @__PURE__ */ f("div", { className: me(Mp.mobileLayout, t), children: /* @__PURE__ */ f("div", { className: Mp.container, children: /* @__PURE__ */ f(
    Dxe,
    {
      className: Mp.scrollDrag,
      active: !0,
      content: /* @__PURE__ */ f(gt, { children: e.map((r) => /* @__PURE__ */ f(
        Wwe,
        {
          post: r,
          className: Mp.post,
          tag: { children: "Seasonal", tagStyle: "highlighted" }
        },
        r.id
      )) })
    }
  ) }) }) : null;
}
const zwe = "_post_5szt7_1", Hwe = "_link_5szt7_12", Xwe = "_imageContainer_5szt7_22", _we = "_image_5szt7_22", $we = "_tag_5szt7_35", e6e = "_shadowOverlay_5szt7_40", t6e = "_content_5szt7_48", i6e = "_title_5szt7_57", r6e = "_details_5szt7_66", n6e = "_date_5szt7_75", o6e = "_details2_5szt7_80", s6e = "_text_5szt7_87", ao = {
  post: zwe,
  link: Hwe,
  imageContainer: Xwe,
  image: _we,
  tag: $we,
  shadowOverlay: e6e,
  content: t6e,
  title: i6e,
  details: r6e,
  date: n6e,
  details2: o6e,
  text: s6e
};
function E7e(s) {
  var a = s, {
    post: e,
    tag: t,
    openInNewTab: i,
    shadowOverlay: r = !0,
    className: n
  } = a, o = Fe(a, [
    "post",
    "tag",
    "openInNewTab",
    "shadowOverlay",
    "className"
  ]);
  var c, u, m;
  const { apiUrl: l } = fi();
  return /* @__PURE__ */ f("article", ee(q({ className: me(ao.post, n) }, o), { children: /* @__PURE__ */ V(
    rd,
    {
      isLink: e.permalink !== void 0,
      openInNewTab: i,
      to: e.permalink && eu(e.permalink, l),
      className: ao.link,
      children: [
        /* @__PURE__ */ V("div", { className: ao.imageContainer, children: [
          /* @__PURE__ */ f(oA, { className: ao.image, post: e, sizes: "400px" }),
          ((u = (c = e.taxonomies) == null ? void 0 : c.category) == null ? void 0 : u[0]) && /* @__PURE__ */ f(Xc, { className: ao.tag, tagColor: t == null ? void 0 : t.tagColor, tagStyle: t == null ? void 0 : t.tagStyle, children: e.taxonomies.category[0] }),
          r && /* @__PURE__ */ f(
            "div",
            {
              className: ao.shadowOverlay
            }
          )
        ] }),
        /* @__PURE__ */ V("div", { className: ao.content, children: [
          /* @__PURE__ */ f("h3", { title: e.post_title, className: ao.title, children: e.post_title }),
          (m = e == null ? void 0 : e.post_author) != null && m.display_name ? /* @__PURE__ */ V("span", { className: ao.details, children: [
            /* @__PURE__ */ V("span", { children: [
              "by ",
              e.post_author.display_name
            ] }),
            /* @__PURE__ */ f("span", { className: ao.date, children: Gs(e.post_date_formatted) })
          ] }) : /* @__PURE__ */ V("span", { className: ao.details2, children: [
            /* @__PURE__ */ f("span", { className: ao.text, children: "Last Updated:" }),
            /* @__PURE__ */ f("span", { className: ao.date, children: Gs(e.post_date_formatted) })
          ] })
        ] })
      ]
    },
    e.id
  ) }));
}
const a6e = "_post_1ahtq_1", l6e = "_inner_1ahtq_9", c6e = "_imageContainer_1ahtq_15", u6e = "_category_1ahtq_38", d6e = "_shadowOverlay_1ahtq_44", m6e = "_content_1ahtq_53", g6e = "_top_1ahtq_62", h6e = "_text_1ahtq_71", p6e = "_title_1ahtq_75", f6e = "_titlePadding_1ahtq_84", A6e = "_summary_1ahtq_88", y6e = "_bottom_1ahtq_99", E6e = "_platforms_1ahtq_104", v6e = "_details_1ahtq_114", b6e = "_date_1ahtq_124", C6e = "_details2_1ahtq_129", x6e = "_link_1ahtq_148", I6e = "_image_1ahtq_15", tr = {
  post: a6e,
  inner: l6e,
  imageContainer: c6e,
  category: u6e,
  shadowOverlay: d6e,
  content: m6e,
  top: g6e,
  text: h6e,
  title: p6e,
  titlePadding: f6e,
  summary: A6e,
  bottom: y6e,
  platforms: E6e,
  details: v6e,
  date: b6e,
  details2: C6e,
  link: x6e,
  image: I6e
};
function v7e(s) {
  var a = s, {
    post: e,
    tag: t,
    openInNewTab: i,
    shadowOverlay: r = !0,
    className: n
  } = a, o = Fe(a, [
    "post",
    "tag",
    "openInNewTab",
    "shadowOverlay",
    "className"
  ]);
  var c;
  const { apiUrl: l } = fi();
  return /* @__PURE__ */ f("article", ee(q({ className: tr.post }, o), { children: /* @__PURE__ */ V(
    rd,
    {
      isLink: e.permalink !== void 0,
      openInNewTab: i,
      to: e.permalink && eu(e.permalink, l),
      className: me(tr.inner, e.permalink !== void 0 && tr.link),
      children: [
        /* @__PURE__ */ V("div", { className: tr.imageContainer, children: [
          /* @__PURE__ */ f(oA, { className: tr.image, post: e, sizes: "400px" }),
          (t == null ? void 0 : t.children) && /* @__PURE__ */ f("div", { className: tr.category, children: /* @__PURE__ */ f(Xc, { className: tr.tag, tagStyle: "highlighted", children: t.children }) }),
          r && /* @__PURE__ */ f(
            "div",
            {
              className: tr.shadowOverlay
            }
          )
        ] }),
        /* @__PURE__ */ V("div", { className: tr.content, children: [
          /* @__PURE__ */ V("div", { className: tr.top, children: [
            (t == null ? void 0 : t.children) && /* @__PURE__ */ f("div", { className: tr.category, children: /* @__PURE__ */ f(Xc, { className: tr.tag, tagStyle: "highlighted", children: t.children }) }),
            /* @__PURE__ */ V("div", { className: tr.text, children: [
              /* @__PURE__ */ f("h3", { title: e.post_title, className: me(tr.title), children: e.post_title }),
              e.excerpt && /* @__PURE__ */ f("p", { className: tr.summary, children: F5(e.excerpt) })
            ] })
          ] }),
          /* @__PURE__ */ V("div", { className: tr.bottom, children: [
            /* @__PURE__ */ f("div", { className: tr.platforms, children: /* @__PURE__ */ f(Mt, { icon: "icons/frontend/platform-icon-pc.webp", width: 20, height: 20 }) }),
            (c = e == null ? void 0 : e.post_author) != null && c.display_name ? /* @__PURE__ */ V("span", { className: tr.details, children: [
              /* @__PURE__ */ V("span", { children: [
                "by ",
                e.post_author.display_name
              ] }),
              /* @__PURE__ */ f("span", { className: tr.date, children: Gs(e.post_date_formatted) })
            ] }) : /* @__PURE__ */ V("span", { className: tr.details2, children: [
              /* @__PURE__ */ f("span", { className: tr.text, children: "Last Updated:" }),
              /* @__PURE__ */ f("span", { className: tr.date, children: Gs(e.post_date_formatted) })
            ] })
          ] })
        ] })
      ]
    },
    e.id
  ) }));
}
const S6e = "_post_1mhcx_1", R6e = "_link_1mhcx_12", k6e = "_pattern_1mhcx_21", w6e = "_imageWrapper_1mhcx_33", M6e = "_content_1mhcx_50", N6e = "_titleWrapper_1mhcx_60", T6e = "_title_1mhcx_60", B6e = "_details_1mhcx_76", D6e = "_tags_1mhcx_80", Aa = {
  post: S6e,
  link: R6e,
  pattern: k6e,
  imageWrapper: w6e,
  content: M6e,
  titleWrapper: N6e,
  title: T6e,
  details: B6e,
  tags: D6e
};
function fN({ tags: e }) {
  return /* @__PURE__ */ f("p", { className: Aa.tags, children: e == null ? void 0 : e.filter((t) => typeof t.name != "string" || !t.name.includes("Seasonal/Non-Seasonal Split")).map((t, i) => /* @__PURE__ */ f(Xc, { tagStyle: "grey3", children: t.name }, `${t.id}-${i}}`)) });
}
function b7e(l) {
  var c = l, {
    post: e,
    tags: t,
    tagsLocation: i = "top",
    openInNewTab: r,
    className: n,
    customImgLeftOffset: o,
    children: s
  } = c, a = Fe(c, [
    "post",
    "tags",
    "tagsLocation",
    "openInNewTab",
    "className",
    "customImgLeftOffset",
    "children"
  ]);
  var h, A;
  const { assetPath: u, apiUrl: m } = fi(), g = Cc((A = (h = e.images) == null ? void 0 : h.full) == null ? void 0 : A.source_url, u);
  return /* @__PURE__ */ f("article", ee(q({ className: me(Aa.post, n) }, a), { children: /* @__PURE__ */ V(
    rd,
    {
      isLink: e.permalink !== void 0,
      openInNewTab: r,
      to: e.permalink && eu(e.permalink, m),
      className: Aa.link,
      children: [
        /* @__PURE__ */ f("div", { style: { backgroundImage: `url('${u}/images/pattern-01.webp')` }, className: Aa.pattern }),
        /* @__PURE__ */ f("div", { className: Aa.imageWrapper, children: g ? /* @__PURE__ */ f(
          "img",
          {
            style: {
              maskImage: "linear-gradient(90deg, #FFFC 40%, transparent)",
              WebkitMaskImage: "linear-gradient(90deg, #FFFC 40%, transparent)",
              left: o
            },
            src: g,
            onError: ({ currentTarget: y }) => {
              y.onerror = null, y.src = `${u}/images/empty-asset.webp`;
            },
            alt: e.post_title
          }
        ) : null }),
        /* @__PURE__ */ V("div", { className: Aa.content, children: [
          /* @__PURE__ */ f("div", { className: Aa.titleWrapper, children: /* @__PURE__ */ f("h2", { title: e.post_title, className: Aa.title, children: e.post_title }) }),
          /* @__PURE__ */ V("div", { className: Aa.details, children: [
            i === "top" && /* @__PURE__ */ f(fN, { tags: t }),
            s,
            i === "bottom" && /* @__PURE__ */ f(fN, { tags: t })
          ] })
        ] })
      ]
    },
    e.id
  ) }));
}
const O6e = "_post_1ekf8_1", F6e = "_link_1ekf8_12", V6e = "_pattern_1ekf8_21", q6e = "_imageWrapper_1ekf8_33", j6e = "_content_1ekf8_47", L6e = "_titleWrapper_1ekf8_58", K6e = "_title_1ekf8_58", Y6e = "_titlePrimary_1ekf8_65", U6e = "_titleSecondary_1ekf8_74", G6e = "_details_1ekf8_87", Q6e = "_tags_1ekf8_91", W6e = "_flipped_1ekf8_111", lo = {
  post: O6e,
  link: F6e,
  pattern: V6e,
  imageWrapper: q6e,
  content: j6e,
  titleWrapper: L6e,
  title: K6e,
  titlePrimary: Y6e,
  titleSecondary: U6e,
  details: G6e,
  tags: Q6e,
  flipped: W6e
}, Np = (e, t) => t ? `calc(${e} - ${t})` : e;
function C7e(v) {
  var C = v, {
    post: e,
    title: t,
    subtitle: i,
    titleIcon: r,
    titleIconClass: n,
    tags: o,
    tagsLocation: s = "top",
    openInNewTab: a,
    backgroundImage: l,
    backgroundImageStyle: c,
    className: u,
    customImgLeftOffset: m,
    imgStyle: g,
    extraLayers: h,
    flip: A = !1,
    children: y
  } = C, E = Fe(C, [
    "post",
    "title",
    "subtitle",
    "titleIcon",
    "titleIconClass",
    "tags",
    "tagsLocation",
    "openInNewTab",
    "backgroundImage",
    "backgroundImageStyle",
    "className",
    "customImgLeftOffset",
    "imgStyle",
    "extraLayers",
    "flip",
    "children"
  ]);
  var N, D;
  const { assetPath: x, apiUrl: S } = fi(), R = Cc((D = (N = e.images) == null ? void 0 : N.full) == null ? void 0 : D.source_url, x), w = m, T = A ? `linear-gradient(-90deg, #FFFF ${Np("25%", w)}, transparent ${Np("75%", w)})` : `linear-gradient(90deg, #FFFF ${Np("25%", w)}, transparent ${Np("75%", w)})`;
  return /* @__PURE__ */ f("article", ee(q({ className: me(lo.post, u, A && lo.flipped) }, E), { children: /* @__PURE__ */ V(
    rd,
    {
      isLink: e.permalink !== void 0,
      openInNewTab: a,
      to: e.permalink && eu(e.permalink, S),
      className: lo.link,
      children: [
        /* @__PURE__ */ f(
          "div",
          {
            style: q({ backgroundImage: `url('${l}')` }, c),
            className: lo.pattern
          }
        ),
        h,
        /* @__PURE__ */ f("div", { className: lo.imageWrapper, children: R ? /* @__PURE__ */ f(
          "img",
          {
            style: q({ maskImage: T, WebkitMaskImage: T, left: m }, g),
            src: R,
            onError: ({ currentTarget: O }) => {
              O.onerror = null, O.src = `${x}/images/empty-asset.webp`;
            },
            alt: e.post_title
          }
        ) : null }),
        /* @__PURE__ */ V("div", { className: lo.content, children: [
          /* @__PURE__ */ V("div", { className: lo.titleWrapper, children: [
            r ? /* @__PURE__ */ f("img", { className: n, width: 40, height: 40, src: r }) : null,
            /* @__PURE__ */ V("h2", { title: e.post_title, className: lo.title, children: [
              /* @__PURE__ */ f("span", { className: lo.titlePrimary, children: t != null ? t : e.post_title }),
              /* @__PURE__ */ f("span", { className: lo.titleSecondary, children: i })
            ] })
          ] }),
          /* @__PURE__ */ V("div", { className: lo.details, children: [
            o && s === "top" ? /* @__PURE__ */ f("p", { className: lo.tags, children: o }) : null,
            y,
            o && s === "bottom" ? /* @__PURE__ */ f("p", { className: lo.tags, children: o }) : null
          ] })
        ] })
      ]
    },
    e.id
  ) }));
}
const Z6e = "_post_1pkl1_1", J6e = "_inner_1pkl1_7", P6e = "_imageContainer_1pkl1_14", z6e = "_image_1pkl1_14", H6e = "_tag_1pkl1_33", X6e = "_shadowOverlay_1pkl1_39", _6e = "_content_1pkl1_48", $6e = "_top_1pkl1_56", eMe = "_firstRow_1pkl1_60", tMe = "_category_1pkl1_67", iMe = "_categoryText_1pkl1_75", rMe = "_categoryTag_1pkl1_83", nMe = "_icon_1pkl1_94", oMe = "_categoryNoLink_1pkl1_98", sMe = "_rowRight_1pkl1_105", aMe = "_platforms_1pkl1_110", lMe = "_text_1pkl1_120", cMe = "_title_1pkl1_124", uMe = "_titlePadding_1pkl1_132", dMe = "_summary_1pkl1_136", mMe = "_bottom_1pkl1_147", gMe = "_details_1pkl1_152", hMe = "_date_1pkl1_162", pMe = "_details2_1pkl1_167", fMe = "_tags_1pkl1_183", AMe = "_link_1pkl1_195", pi = {
  post: Z6e,
  inner: J6e,
  imageContainer: P6e,
  image: z6e,
  tag: H6e,
  shadowOverlay: X6e,
  content: _6e,
  top: $6e,
  firstRow: eMe,
  category: tMe,
  categoryText: iMe,
  categoryTag: rMe,
  icon: nMe,
  categoryNoLink: oMe,
  rowRight: sMe,
  platforms: aMe,
  text: lMe,
  title: cMe,
  titlePadding: uMe,
  summary: dMe,
  bottom: mMe,
  details: gMe,
  date: hMe,
  details2: pMe,
  tags: fMe,
  link: AMe
};
function x7e(c) {
  var u = c, {
    post: e,
    tag: t,
    tags: i,
    category: r,
    openInNewTab: n,
    shadowOverlay: o = !0,
    showPlatforms: s = !0,
    className: a
  } = u, l = Fe(u, [
    "post",
    "tag",
    "tags",
    "category",
    "openInNewTab",
    "shadowOverlay",
    "showPlatforms",
    "className"
  ]);
  var h;
  const { apiUrl: m } = fi(), [g] = gi((A) => ({ md: A.viewport.md }));
  return /* @__PURE__ */ f("article", ee(q({ className: me(pi.post, o && pi.withShadow, a) }, l), { children: /* @__PURE__ */ V(
    rd,
    {
      isLink: e.permalink !== void 0,
      openInNewTab: n,
      to: e.permalink && eu(e.permalink, m),
      className: me(pi.inner, e.permalink !== void 0 && pi.link),
      children: [
        /* @__PURE__ */ V("div", { className: pi.imageContainer, children: [
          /* @__PURE__ */ f(oA, { className: pi.image, post: e, sizes: "400px" }),
          o && /* @__PURE__ */ f(
            "div",
            {
              className: pi.shadowOverlay
            }
          )
        ] }),
        /* @__PURE__ */ V("div", { className: pi.content, children: [
          /* @__PURE__ */ V("div", { className: pi.top, children: [
            /* @__PURE__ */ V("div", { className: pi.firstRow, children: [
              r ? /* @__PURE__ */ V(
                "span",
                {
                  onClick: r.link ? (A) => {
                    A == null || A.preventDefault(), A == null || A.stopPropagation(), typeof window != "undefined" && r.link && (window.location.href = r.link);
                  } : void 0,
                  className: me(pi.category, !r.link && pi.categoryNoLink),
                  children: [
                    r.tag ? /* @__PURE__ */ f("span", { className: pi.categoryTag, children: r.tag }) : null,
                    /* @__PURE__ */ f("span", { className: pi.categoryText, children: r.text }),
                    /* @__PURE__ */ f(Mt, { icon: "arrow-up-right.svg", width: 16, height: 16, className: pi.icon })
                  ]
                }
              ) : /* @__PURE__ */ f("span", {}),
              /* @__PURE__ */ V("div", { className: pi.rowRight, children: [
                i && g.md ? /* @__PURE__ */ f("p", { className: pi.tags, children: i.map((A, y) => /* @__PURE__ */ f(Xc, q({}, A), y)) }) : null,
                s ? /* @__PURE__ */ f("div", { className: pi.platforms, children: /* @__PURE__ */ f(Mt, { icon: "icons/frontend/platform-icon-pc.webp", width: 16, height: 16 }) }) : null
              ] })
            ] }),
            /* @__PURE__ */ V("div", { className: pi.text, children: [
              /* @__PURE__ */ f("h3", { title: e.post_title, className: me(pi.title, !r && pi.titlePadding), children: e.post_title }),
              i && !g.md ? /* @__PURE__ */ f("p", { className: pi.tags, children: i.map((A, y) => /* @__PURE__ */ f(Xc, q({}, A), y)) }) : null,
              e.excerpt && /* @__PURE__ */ f("p", { className: pi.summary, children: F5(e.excerpt) })
            ] })
          ] }),
          /* @__PURE__ */ f("div", { className: pi.bottom, children: (h = e == null ? void 0 : e.post_author) != null && h.display_name ? /* @__PURE__ */ V("span", { className: pi.details, children: [
            /* @__PURE__ */ V("span", { children: [
              "by ",
              e.post_author.display_name
            ] }),
            /* @__PURE__ */ f("span", { className: pi.date, children: Gs(e.post_date_formatted) })
          ] }) : /* @__PURE__ */ V("span", { className: pi.details2, children: [
            /* @__PURE__ */ f("span", { className: pi.text, children: "Last Updated:" }),
            /* @__PURE__ */ f("span", { className: pi.date, children: Gs(e.post_date_formatted) })
          ] }) })
        ] })
      ]
    },
    e.id
  ) }));
}
function cg(e, t, i) {
  var r;
  for (let n = 0; n < t.length; n++) {
    const o = t[n];
    if (o.id !== (i == null ? void 0 : i.id)) {
      if (o.id === e)
        return { item: o, index: n, parentList: t };
      if ("items" in o && ((r = o.items) != null && r.length)) {
        const s = cg(e, o.items, i);
        if (s !== void 0)
          return s;
      }
    }
  }
}
const ZI = (e) => "items" in e ? Ut.flatMapDeep(e.items, ZI) : e;
function sA(e, t, i) {
  if ("items" in e) {
    const r = e, n = [];
    for (const o of r.items || []) {
      const [s, a] = sA(o, t, i);
      t = a, n.push(s);
    }
    return [ee(q({}, r), { items: n, visible: !0 }), t];
  } else {
    const r = e;
    return [
      ee(q({}, r), { index: ++t, visible: !0, completed: i.includes(r.id) }),
      t
    ];
  }
}
function Lq(e) {
  const t = Ut.cloneDeep(e);
  if (delete t.index, delete t.visible, delete t.completed, "items" in t)
    for (const i in t.items)
      t.items[i] = Lq(t.items[i]);
  return t;
}
const yMe = "_Milestones_1skjq_1", EMe = "_Milestones__navigationTabs_1skjq_8", vMe = "_Milestones__navigationWrapper_1skjq_12", bMe = "_Milestones__cardsWrapper_1skjq_20", CMe = "_Milestones__cardsHeader_1skjq_28", xMe = "_Milestones__cardsCounterText_1skjq_36", IMe = "_Milestones__cardsCounter_1skjq_36", SMe = "_Milestones__cards_1skjq_20", RMe = "_Milestones__cardsScrollOuter_1skjq_60", kMe = "_Milestones__cardsScrollInner_1skjq_65", wMe = "_MilestonesContainer_1skjq_72", MMe = "_Milestones__tab_1skjq_87", NMe = "_Milestones__tabActive_1skjq_87", en = {
  Milestones: yMe,
  Milestones__navigationTabs: EMe,
  Milestones__navigationWrapper: vMe,
  Milestones__cardsWrapper: bMe,
  Milestones__cardsHeader: CMe,
  Milestones__cardsCounterText: xMe,
  Milestones__cardsCounter: IMe,
  Milestones__cards: SMe,
  Milestones__cardsScrollOuter: RMe,
  Milestones__cardsScrollInner: kMe,
  MilestonesContainer: wMe,
  Milestones__tab: MMe,
  Milestones__tabActive: NMe
}, TMe = "_Milestones__card_13muj_1", BMe = "_Milestones__cardTitleBox_13muj_22", DMe = "_Milestones__cardTitleLeft_13muj_30", OMe = "_Milestones__cardTitle_13muj_22", FMe = "_Milestones__cardContent_13muj_41", al = {
  Milestones__card: TMe,
  "Milestones__card--hidden": "_Milestones__card--hidden_13muj_14",
  "Milestones__card--highlighted": "_Milestones__card--highlighted_13muj_18",
  Milestones__cardTitleBox: BMe,
  Milestones__cardTitleLeft: DMe,
  Milestones__cardTitle: OMe,
  Milestones__cardContent: FMe
};
function Kq({
  milestone: e,
  updateMilestoneElem: t,
  toggleCompleted: i,
  updateSignal: r,
  children: n
}) {
  const [o, s] = se(!1), [a, l] = se(!1), c = Ne(!0);
  return be(() => {
    if (!r)
      return;
    if (c.current) {
      c.current = !1;
      return;
    }
    l(!0);
    const u = setTimeout(() => {
      l(!1);
    }, 500);
    return () => clearTimeout(u);
  }, [r]), /* @__PURE__ */ V(
    "div",
    {
      className: me(
        al.Milestones__card,
        a && al["Milestones__card--highlighted"],
        e.completed && al["Milestones__card--completed"],
        !e.visible && al["Milestones__card--hidden"]
      ),
      id: `milestone-${e.id}`,
      children: [
        /* @__PURE__ */ V("div", { className: al.Milestones__cardTitleBox, children: [
          /* @__PURE__ */ V("div", { className: al.Milestones__cardTitleLeft, children: [
            /* @__PURE__ */ f(
              Ka,
              {
                type: "md",
                color: "green",
                value: e.completed,
                onChange: () => {
                  i == null || i(e.id);
                }
              }
            ),
            /* @__PURE__ */ f("span", { className: al.Milestones__cardTitle, children: o ? /* @__PURE__ */ f(
              kn,
              {
                size: "sm",
                value: e.title,
                onChange: (u) => {
                  t && t(e.id, ee(q({}, e), { title: u }));
                }
              }
            ) : `${e.index}. ${e.title}` })
          ] }),
          /* @__PURE__ */ f("div", { children: !!t && (o ? /* @__PURE__ */ f(Kt, { style: { width: "40px" }, size: "sm", onClick: () => s(!1), children: /* @__PURE__ */ f(Mt, { icon: "clear.svg", width: 10, height: 10, color: "rgb(var(--maxroll-color-white-1))" }) }) : /* @__PURE__ */ f(
            Kt,
            {
              style: { width: "40px" },
              size: "sm",
              onClick: () => {
                s(!o);
              },
              children: /* @__PURE__ */ f(Mt, { icon: "icons/edit.svg", width: 14, height: 14, color: "rgb(var(--maxroll-color-white-1))" })
            }
          )) })
        ] }),
        /* @__PURE__ */ f("div", { className: al.Milestones__cardContent, children: n || null })
      ]
    }
  );
}
const VMe = () => ({ id: go(), title: "" }), qMe = () => ({ id: go(), title: "", items: [] }), jMe = "_Milestones__navigation_npjd2_1", LMe = "_Milestones__navGroup_npjd2_9", KMe = "_Milestones__navGroupLine_npjd2_19", YMe = "_Milestones__navGroupList_npjd2_26", UMe = "_Milestones__navGroupDropSpace_npjd2_33", GMe = "_Milestones__navItem_npjd2_43", QMe = "_Milestones__navItemText_npjd2_55", Vc = {
  Milestones__navigation: jMe,
  Milestones__navGroup: LMe,
  Milestones__navGroupLine: KMe,
  Milestones__navGroupList: YMe,
  Milestones__navGroupDropSpace: UMe,
  Milestones__navItem: GMe,
  Milestones__navItemText: QMe
};
let tn = null;
function Yq({
  milestone: e,
  updateOrder: t,
  updateMilestoneElem: i
}) {
  const r = (a) => {
    a.stopPropagation(), tn = e.id;
  }, n = (a) => {
    a.preventDefault(), tn = null;
  }, o = (a) => {
    a.stopPropagation(), a.preventDefault(), tn && tn !== e.id && t(tn, e.id);
  }, s = (a) => {
    a.preventDefault(), tn = null;
  };
  return /* @__PURE__ */ V(
    "div",
    {
      className: Vc.Milestones__navItem,
      draggable: !0,
      onDragStart: r,
      onDrop: n,
      onDragOver: o,
      onDragEnd: s,
      children: [
        /* @__PURE__ */ V("span", { className: Vc.Milestones__navItemText, children: [
          e.index,
          ".",
          /* @__PURE__ */ f(
            kn,
            {
              size: "sm",
              value: e.title,
              onChange: (a) => {
                i == null || i(e.id, ee(q({}, e), { title: a }));
              }
            }
          )
        ] }),
        /* @__PURE__ */ f("div", { children: /* @__PURE__ */ f(
          Kt,
          {
            size: "sm",
            onClick: () => {
              i == null || i(e.id, void 0);
            },
            children: /* @__PURE__ */ f(Mt, { icon: "clear.svg", width: 12, height: 12, color: "rgb(var(--maxroll-color-white-1))" })
          }
        ) })
      ]
    }
  );
}
function Uq({
  group: e,
  updateOrder: t,
  updateMilestoneElem: i
}) {
  const r = (a) => {
    a.stopPropagation(), tn = e.id;
  }, n = (a) => {
    a.preventDefault(), tn = null;
  }, o = (a) => {
    a.stopPropagation(), a.preventDefault(), tn && tn !== e.id && t(tn, e.id);
  }, s = (a) => {
    a.preventDefault(), tn = null;
  };
  return /* @__PURE__ */ V(
    "div",
    {
      className: Vc.Milestones__navGroup,
      children: [
        /* @__PURE__ */ V(
          "span",
          {
            className: Vc.Milestones__navGroupLine,
            draggable: !0,
            onDragStart: r,
            onDrop: n,
            onDragOver: o,
            onDragEnd: s,
            children: [
              /* @__PURE__ */ V("span", { children: [
                "+",
                " ",
                /* @__PURE__ */ f(
                  kn,
                  {
                    size: "sm",
                    value: e.title,
                    onChange: (a) => {
                      i == null || i(e.id, ee(q({}, e), { title: a }));
                    }
                  }
                )
              ] }),
              /* @__PURE__ */ f(
                Kt,
                {
                  size: "sm",
                  onClick: () => {
                    i == null || i(e.id, void 0);
                  },
                  children: /* @__PURE__ */ f(Mt, { icon: "clear.svg", width: 12, height: 12, color: "rgb(var(--maxroll-color-white-1))" })
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ V("div", { className: Vc.Milestones__navGroupList, children: [
          e.items.map(
            (a) => "items" in a ? /* @__PURE__ */ f(
              Uq,
              {
                group: a,
                updateOrder: t,
                updateMilestoneElem: i
              },
              a.id
            ) : /* @__PURE__ */ f(
              Yq,
              {
                milestone: a,
                updateOrder: t,
                updateMilestoneElem: i
              },
              a.id
            )
          ),
          /* @__PURE__ */ f("div", { children: /* @__PURE__ */ f(
            Kt,
            {
              size: "sm",
              onClick: () => {
                i == null || i(e.id, ee(q({}, e), { items: [...e.items, VMe()] }));
              },
              children: "Add milestone"
            }
          ) })
        ] })
      ]
    }
  );
}
function AN({
  element: e,
  updateOrder: t,
  insertAfter: i = !1
}) {
  const r = (o) => {
    o.preventDefault(), tn = null;
  }, n = (o) => {
    o.stopPropagation(), o.preventDefault(), !(!tn || !e) && (i ? t(e.id, tn) : t(tn, e.id));
  };
  return /* @__PURE__ */ f(
    "li",
    {
      className: Vc.Milestones__navGroupDropSpace,
      onDrop: r,
      onDragOver: n
    }
  );
}
function WMe({
  milestones: e,
  setMilestones: t,
  updateMilestoneElem: i
}) {
  const r = ye(
    (s, a) => {
      t && s !== a && t((l) => {
        const c = Ut.cloneDeep(l), u = cg(s, c), m = cg(a, c, u == null ? void 0 : u.item);
        if (!u || !m)
          return l;
        const { item: g, index: h, parentList: A } = u, { item: y, index: E, parentList: v } = m;
        return !g || !y ? l : (A === v ? (A[h] = y, A[E] = g) : (A.splice(h, 1), v.splice(E, 0, g)), c);
      });
    },
    [t]
  ), n = we(() => e[0], [e]), o = we(() => e[e.length - 1], [e]);
  return /* @__PURE__ */ V("div", { className: Vc.Milestones__navigation, children: [
    /* @__PURE__ */ f(AN, { element: n, updateOrder: r }),
    e.map(
      (s) => "items" in s ? /* @__PURE__ */ f(
        Uq,
        {
          group: s,
          updateOrder: r,
          updateMilestoneElem: i
        },
        s.id
      ) : /* @__PURE__ */ f(
        Yq,
        {
          milestone: s,
          updateOrder: r,
          updateMilestoneElem: i
        },
        s.id
      )
    ),
    /* @__PURE__ */ f("div", { children: /* @__PURE__ */ f(
      Kt,
      {
        size: "sm",
        onClick: () => {
          t && t((s) => [...s, qMe()]);
        },
        children: "Add group"
      }
    ) }),
    /* @__PURE__ */ f(AN, { element: o, updateOrder: r, insertAfter: !0 })
  ] });
}
const Nm = {
  GROUPS: "groups",
  CONTENT: "content"
}, ZMe = [
  { label: "Navigation", value: Nm.GROUPS },
  { label: "Content", value: Nm.CONTENT }
];
function JMe({
  milestones: e,
  updateMilestones: t,
  milestoneContent: i,
  milestoneItem: r
}) {
  const [n, o] = se(e), [s, a] = we(() => {
    const y = [];
    let E = 0;
    const v = Ut.cloneDeep(n);
    for (const C of v) {
      const [x, S] = sA(C, E, []);
      E = S, y.push(x);
    }
    return [y, E];
  }, [n]), [l, c] = se(Nm.GROUPS), [u, m] = se(""), g = we(() => Ut.flatMapDepth(s, ZI).filter((E) => !u || of(E, u, !0)), [s, u]), h = ye(
    (y, E) => {
      o((v) => {
        const C = Ut.cloneDeep(v), x = cg(y, C);
        if (!x)
          return v;
        const { index: S, parentList: R } = x;
        return E === void 0 ? R.splice(S, 1) : R[S] = Lq(E), C;
      });
    },
    [o]
  );
  be(() => {
    t && t(Ut.cloneDeep(n));
  }, [n]);
  const A = ye((y) => {
    y && c(y.value);
  }, [c]);
  return /* @__PURE__ */ f("div", { className: en.MilestonesContainer, children: /* @__PURE__ */ V("div", { className: en.Milestones, children: [
    /* @__PURE__ */ f("div", { className: en.Milestones__navigationTabs, children: /* @__PURE__ */ f(HO, { options: ZMe, value: l, onChange: A }) }),
    /* @__PURE__ */ V("div", { className: me(
      en.Milestones__navigationWrapper,
      en.Milestones__tab,
      l === Nm.GROUPS && en.Milestones__tabActive
    ), children: [
      /* @__PURE__ */ f(
        wg,
        {
          className: en.Milestones__cardsSearch,
          value: u,
          onChange: (y) => m(y),
          placeholder: "Search"
        }
      ),
      /* @__PURE__ */ f(Pr, { type: "vertical", children: /* @__PURE__ */ f(
        WMe,
        {
          milestones: s,
          setMilestones: o,
          updateMilestoneElem: h
        }
      ) })
    ] }),
    /* @__PURE__ */ V(
      "div",
      {
        className: me(
          en.Milestones__cardsWrapper,
          en.Milestones__tab,
          l === Nm.CONTENT && en.Milestones__tabActive
        ),
        children: [
          /* @__PURE__ */ f("div", { className: en.Milestones__cardsHeader, children: /* @__PURE__ */ f("div", { className: en.Milestones__cardsCounter, children: /* @__PURE__ */ V("span", { className: en.Milestones__cardsCounterText, children: [
            "Milestones: ",
            a
          ] }) }) }),
          /* @__PURE__ */ f("div", { className: en.Milestones__cards, children: /* @__PURE__ */ f(
            Pr,
            {
              className: en.Milestones__cardsScrollOuter,
              innerClassName: en.Milestones__cardsScrollInner,
              children: i ? i() : g.map((y) => /* @__PURE__ */ f(
                Kq,
                {
                  milestone: y,
                  updateMilestoneElem: h,
                  children: r ? r(y) : void 0
                },
                y.id
              ))
            }
          ) })
        ]
      }
    )
  ] }) });
}
function PMe(e, t) {
  if (typeof window == "undefined")
    return t;
  try {
    const i = window.localStorage.getItem(e);
    return i != null ? JSON.parse(i) : t;
  } catch (i) {
    return console.error(i), t;
  }
}
function zMe(e, t) {
  if (typeof window != "undefined")
    try {
      window.localStorage.setItem(e, JSON.stringify(t));
    } catch (i) {
      console.error(i);
    }
}
function HMe({ metadataKey: e }) {
  const t = Ne(PMe(e)), [i, r] = se(t.current);
  return be(() => {
    t.current !== i && zMe(e, i);
  }, [i, e]), [i, r];
}
function Gq({
  metadataKey: e
}) {
  const [t, i] = HMe({ metadataKey: e }), r = we(() => {
    var s;
    return (s = t == null ? void 0 : t.completed) != null ? s : [];
  }, [t]), n = ye(
    (s) => i((a) => (a ? a = Ut.cloneDeep(a) : a = { completed: [] }, typeof s == "function" && (s = s((a == null ? void 0 : a.completed) || [])), a.completed = s, a)),
    [i]
  ), o = ye(
    (s) => n((a) => {
      const l = [...a], c = l.indexOf(s);
      return c !== -1 ? l.splice(c, 1) : l.push(s), l;
    }),
    [n]
  );
  return [r, n, o];
}
const XMe = "_Milestones_mhba5_1", _Me = "_Milestones__navigationWrapper_mhba5_7", $Me = "_Milestones__cardsWrapper_mhba5_15", eNe = "_Milestones__cardsHeader_mhba5_22", tNe = "_Milestones__cardsCounterText_mhba5_30", iNe = "_Milestones__cardsSearch_mhba5_35", rNe = "_Milestones__cardsCounter_mhba5_30", nNe = "_Milestones__cards_mhba5_15", oNe = "_Milestones__cardsScrollOuter_mhba5_59", sNe = "_Milestones__cardsScrollInner_mhba5_64", os = {
  Milestones: XMe,
  Milestones__navigationWrapper: _Me,
  Milestones__cardsWrapper: $Me,
  Milestones__cardsHeader: eNe,
  Milestones__cardsCounterText: tNe,
  Milestones__cardsSearch: iNe,
  Milestones__cardsCounter: rNe,
  Milestones__cards: nNe,
  Milestones__cardsScrollOuter: oNe,
  Milestones__cardsScrollInner: sNe
}, aNe = "_Milestones__navigation_145sk_1", lNe = "_Milestones__navGroup_145sk_11", cNe = "_Milestones__navGroupLine_145sk_20", uNe = "_Milestones__navGroupList_145sk_30", dNe = "_Milestones__navGroupDropSpace_145sk_38", mNe = "_Milestones__navItem_145sk_48", qc = {
  Milestones__navigation: aNe,
  Milestones__navGroup: lNe,
  Milestones__navGroupLine: cNe,
  "Milestones__navGroup--hidden": "_Milestones__navGroup--hidden_145sk_26",
  Milestones__navGroupList: uNe,
  Milestones__navGroupDropSpace: dNe,
  Milestones__navItem: mNe,
  "Milestones__navItem--complete": "_Milestones__navItem--complete_145sk_58",
  "Milestones__navItem--hidden": "_Milestones__navItem--hidden_145sk_62"
};
function Qq(n) {
  var o = n, {
    milestone: e,
    onMilestoneClick: t,
    onMilestoneHover: i
  } = o, r = Fe(o, [
    "milestone",
    "onMilestoneClick",
    "onMilestoneHover"
  ]);
  return /* @__PURE__ */ f(
    "li",
    ee(q({
      className: me(
        qc.Milestones__navItem,
        e.completed && qc["Milestones__navItem--complete"],
        !e.visible && qc["Milestones__navItem--hidden"]
      ),
      onClick: () => {
        t == null || t(e.id);
      },
      onMouseEnter: () => {
        i == null || i(e.id);
      }
    }, r), {
      children: /* @__PURE__ */ V("span", { children: [
        e.index,
        ". ",
        e.title
      ] })
    })
  );
}
function Wq(i) {
  var r = i, { group: e } = r, t = Fe(r, ["group"]);
  return /* @__PURE__ */ V(
    "li",
    {
      className: me(
        qc.Milestones__navGroup,
        !e.visible && qc["Milestones__navGroup--hidden"]
      ),
      children: [
        /* @__PURE__ */ f("span", { children: e.title }),
        /* @__PURE__ */ f("ul", { className: qc.Milestones__navGroupList, children: e.items.map(
          (n) => "items" in n ? /* @__PURE__ */ f(Wq, q({ group: n }, t), n.id) : /* @__PURE__ */ f(Qq, q({ milestone: n }, t), n.id)
        ) })
      ]
    }
  );
}
function gNe(i) {
  var r = i, {
    milestones: e
  } = r, t = Fe(r, [
    "milestones"
  ]);
  return /* @__PURE__ */ f("ul", { className: qc.Milestones__navigation, children: e.map(
    (n) => "items" in n ? /* @__PURE__ */ f(Wq, q({ group: n }, t), n.id) : /* @__PURE__ */ f(Qq, q({ milestone: n }, t), n.id)
  ) });
}
function hNe({
  id: e,
  milestones: t,
  milestoneItem: i,
  onSearch: r,
  onShowCompleted: n,
  onVisibleMilestonesChanged: o
}) {
  const [s] = gi((N) => ({ md: N.viewport.md })), [a, , l] = Gq({
    metadataKey: `mxrl-milestones:${e}`
  }), [c, u] = we(() => {
    const N = [];
    let D = 0;
    const O = Ut.cloneDeep(t);
    for (const F of O) {
      const [Y, P] = sA(F, D, a);
      D = P, N.push(Y);
    }
    return [N, D];
  }, [t, a]), m = we(() => Ut.flatMapDepth(c, ZI), [c]), [g, h] = se(!1), A = ye(
    (N) => {
      h(N), n && n(N);
    },
    [n]
  ), [y, E] = se(""), v = ye(
    (N) => {
      E(N), r && r(N);
    },
    [r]
  ), C = we(() => {
    let N = m;
    return g || (N = N.filter((D) => !D.completed)), y && (N = N.filter((D) => !y || of(D, y, !0))), N;
  }, [m, g, y]);
  be(() => {
    o && o();
  }, [o, C]);
  const [x, S] = se({}), R = ye(
    (N) => S((D) => {
      var O;
      return D = q({}, D), D[N] = ((O = D[N]) != null ? O : 0) + 1, D;
    }),
    []
  ), w = Ne(), T = ye(
    (N) => {
      const D = cg(N, c);
      if (!D)
        return;
      D.item.completed && A(!0), clearTimeout(w.current), w.current = setTimeout(() => {
        if (R(N), typeof document != "undefined") {
          const F = document.getElementById(`milestone-${N}`);
          F && Hx(F, {
            behavior: "smooth",
            scrollMode: "if-needed",
            inline: "nearest",
            block: "nearest"
          });
        }
      }, 100);
    },
    [R, A, c]
  );
  return be(() => () => clearTimeout(w.current), []), /* @__PURE__ */ V("div", { className: os.Milestones, children: [
    s.md ? /* @__PURE__ */ V("div", { className: os.Milestones__navigationWrapper, children: [
      /* @__PURE__ */ f(
        wg,
        {
          className: os.Milestones__cardsSearch,
          value: y,
          onChange: (N) => {
            v(N);
          },
          placeholder: "Search"
        }
      ),
      /* @__PURE__ */ f(Pr, { type: "vertical", children: /* @__PURE__ */ f(
        gNe,
        {
          milestones: c,
          onMilestoneHover: R,
          onMilestoneClick: T
        }
      ) })
    ] }) : /* @__PURE__ */ f("div", { className: os.Milestones__mobileNavigationWrapper, children: /* @__PURE__ */ f(
      _s,
      {
        size: "md",
        placeholder: "Select a milestone...",
        options: C.map((N) => ({
          value: N.id,
          label: `${N.index}. ${N.title}`
        })),
        onChange: (N) => {
          N && T(N.value);
        }
      }
    ) }),
    /* @__PURE__ */ V("div", { className: os.Milestones__cardsWrapper, children: [
      /* @__PURE__ */ f("div", { className: os.Milestones__cardsHeader, children: /* @__PURE__ */ V("div", { className: os.Milestones__cardsCounter, children: [
        /* @__PURE__ */ V("span", { className: os.Milestones__cardsCounterText, children: [
          "Milestones: ",
          a.length,
          " / ",
          u
        ] }),
        /* @__PURE__ */ f(
          Ka,
          {
            label: "Show completed",
            value: g,
            onChange: (N) => {
              A(N);
            }
          }
        )
      ] }) }),
      /* @__PURE__ */ f("div", { className: os.Milestones__cards, children: /* @__PURE__ */ f(
        Pr,
        {
          className: os.Milestones__cardsScrollOuter,
          innerClassName: os.Milestones__cardsScrollInner,
          children: C.map((N) => /* @__PURE__ */ f(
            Kq,
            {
              milestone: N,
              toggleCompleted: l,
              updateSignal: x[N.id],
              children: i ? i(N) : void 0
            },
            N.id
          ))
        }
      ) })
    ] })
  ] });
}
const pNe = "_Checklist_13kgz_1", fNe = "_Checklist__items_13kgz_7", ANe = "_Checklist__title_13kgz_15", yNe = "_Checklist__list_13kgz_20", ENe = "_Checklist__innerListItem_13kgz_26", vNe = "_Checklist__innerListItemRoot_13kgz_31", bNe = "_Checklist__item_13kgz_7", CNe = "_Checklist__checkbox_13kgz_43", Nl = {
  Checklist: pNe,
  Checklist__items: fNe,
  Checklist__title: ANe,
  Checklist__list: yNe,
  Checklist__innerListItem: ENe,
  Checklist__innerListItemRoot: vNe,
  Checklist__item: bNe,
  Checklist__checkbox: CNe
};
function xNe({
  milestone: e,
  toggleCompleted: t = () => {
  },
  children: i
}) {
  const [r, n] = se(!1);
  return be(() => {
    n(e.completed);
  }, [e.completed]), /* @__PURE__ */ V("li", { className: Nl.Checklist__item, children: [
    /* @__PURE__ */ f("div", { className: Nl.Checklist__checkbox, children: /* @__PURE__ */ f(
      Ka,
      {
        type: "md",
        color: "green",
        value: r,
        onChange: () => t(e.id)
      }
    ) }),
    /* @__PURE__ */ f("div", { className: Nl.Checklist__cardContent, children: i })
  ] });
}
function INe({
  milestones: e,
  milestoneItem: t,
  toggleCompleted: i,
  isRoot: r = !1
}) {
  return /* @__PURE__ */ f("ol", { className: Nl.Checklist__list, children: e.map((n) => "items" in n ? /* @__PURE__ */ f("li", { className: me(
    Nl.Checklist__innerListItem,
    r ? Nl.Checklist__innerListItemRoot : ""
  ), children: /* @__PURE__ */ f(
    Zq,
    {
      id: n.id,
      isInnerGroup: !0,
      title: n.title,
      milestones: n.items,
      milestoneItem: t
    }
  ) }, n.id) : /* @__PURE__ */ f(
    xNe,
    {
      milestone: n,
      toggleCompleted: i,
      children: t ? t(n) : void 0
    },
    n.id
  )) });
}
function Zq({
  id: e,
  title: t,
  isInnerGroup: i,
  milestones: r,
  milestoneItem: n
}) {
  const [o, , s] = Gq({
    metadataKey: `mxrl-milestones:${e}`
  }), a = we(() => {
    const l = [];
    let c = 0;
    const u = Ut.cloneDeep(r);
    for (const m of u) {
      const [g, h] = sA(m, c, o);
      c = h, l.push(g);
    }
    return l;
  }, [r, o]);
  return /* @__PURE__ */ V("div", { className: Nl.Checklist, children: [
    t ? /* @__PURE__ */ f("span", { className: Nl.Checklist__title, children: t }) : null,
    /* @__PURE__ */ f(
      INe,
      {
        milestones: a,
        milestoneItem: n,
        toggleCompleted: s,
        isRoot: !i
      }
    )
  ] });
}
function I7e(e) {
  return e.mode === "edit" ? /* @__PURE__ */ f(JMe, q({}, e)) : e.type === "checklist" ? /* @__PURE__ */ f(Zq, q({}, e)) : /* @__PURE__ */ f(hNe, q({}, e));
}
const SNe = {
  "chevron-down": /* @__PURE__ */ f("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f("path", { d: "M6 9L12 15L18 9", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) }),
  "chevron-up": /* @__PURE__ */ f("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f("path", { d: "M18 15L12 9L6 15", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) }),
  "chevron-right": /* @__PURE__ */ f("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f("path", { d: "M9 18L15 12L9 6", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) }),
  "chevron-left": /* @__PURE__ */ f("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f("path", { d: "M15 6L9 12L15 18", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }) }),
  clear: /* @__PURE__ */ f("svg", { viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f("path", { d: `M9.78931 8.77957C9.92345 8.9137 9.99881 9.09563 9.99881 9.28533C9.99881 9.47503 9.92345 9.65696 9.78931
      9.7911C9.65518 9.92524 9.47325 10.0006 9.28355 10.0006C9.09385 10.0006 8.91192 9.92524 8.77778 9.7911L5
      6.01213L1.22103 9.78991C1.08689 9.92405 0.904962 9.9994 0.715262 9.9994C0.525563 9.9994 0.343633 9.92405
      0.209496 9.78991C0.0753579 9.65577 1.99881e-09 9.47384 0 9.28414C-1.99881e-09 9.09444 0.0753579 8.91251
      0.209496 8.77838L3.98847 5.0006L0.210685 1.22162C0.0765477 1.08749 0.00119006 0.905557 0.00119007
      0.715857C0.00119007 0.526158 0.0765477 0.344228 0.210685 0.21009C0.344823 0.0759528 0.526753 0.000594922
      0.716452 0.00059492C0.906152 0.000594918 1.08808 0.0759528 1.22222 0.21009L5 3.98906L8.77897 0.209495C8.91311
      0.0753577 9.09504 -3.16039e-09 9.28474 0C9.47444 3.16039e-09 9.65637 0.0753576 9.7905 0.209495C9.92464 0.343633
      10 0.525563 10 0.715262C10 0.904962 9.92464 1.08689 9.7905 1.22103L6.01153 5.0006L9.78931 8.77957Z`, fill: "currentColor" }) }),
  delete: /* @__PURE__ */ V("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ f("path", { d: `M15.6842 2.54996H14.0871C13.8234 1.26971 12.6481 0.307709 11.2393 0.307709H8.65514C7.2463 0.307709
      6.07102 1.27694 5.80734 2.54996H4.3081C2.10068 2.54996 0.307617 4.27866 0.307617 6.39795V6.57155C0.307617 6.8681
      0.563769 7.11403 0.872657 7.11403H2.79379L4.24783 19.215C4.27796 19.4898 4.51905 19.6923 4.81287
      19.6923H15.0966C15.3829 19.6923 15.624 19.4826 15.6616 19.215L17.1157 7.11403H19.1423C19.4512 7.11403 19.7073
      6.8681 19.7073 6.57155V6.39795C19.7073 4.27866 17.9143 2.54996 15.6993 2.54996H15.6842ZM8.65514
      1.39267H11.2393C12.0228 1.39267 12.6858 1.87729 12.9193 2.54996H6.97509C7.20864 1.87729 7.87915 1.39267 8.65514
      1.39267ZM14.5843 18.6074H5.3101L3.93141 7.11403H15.963L14.5843 18.6074ZM16.5958 6.02907H1.4603C1.64864 4.68372
      2.85406 3.64215 4.3081 3.64215H15.6842C17.1383 3.64215 18.3437 4.68372 18.532 6.02907H16.5958Z`, fill: "currentColor" }),
    /* @__PURE__ */ f("path", { d: `M9.95103 16.9655C10.2599 16.9655 10.5161 16.7195 10.5161 16.423V9.09589C10.5161 8.79933 10.2599 8.55341
      9.95103 8.55341C9.64214 8.55341 9.38599 8.79933 9.38599 9.09589V16.423C9.38599 16.7195 9.64214 16.9655 9.95103
      16.9655Z`, fill: "currentColor" }),
    /* @__PURE__ */ f("path", { d: `M7.40458 16.9655C7.40458 16.9655 7.43471 16.9655 7.44978 16.9655C7.75867 16.9438 7.99222 16.6834 7.96962
      16.3796L7.35937 9.0525C7.33677 8.75594 7.06555 8.53895 6.74913 8.55342C6.44024 8.57512 6.20669 8.83551 6.22929
      9.1393L6.83954 16.4664C6.86214 16.7485 7.11076 16.9655 7.40458 16.9655Z`, fill: "currentColor" }),
    /* @__PURE__ */ f("path", { d: `M12.5126 16.9655C12.5126 16.9655 12.5427 16.9655 12.5578 16.9655C12.8516 16.9655 13.1002 16.7485 13.1228
      16.4664L13.6954 9.1393C13.718 8.84275 13.4845 8.58235 13.1756 8.56066C12.8667 8.53896 12.5955 8.76318 12.5729
      9.05974L12.0003 16.3868C11.9777 16.6834 12.2112 16.9438 12.5201 16.9655H12.5126Z`, fill: "currentColor" })
  ] }),
  discord: /* @__PURE__ */ f("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f("path", { d: `M15.74,15.12c-1.11,0-2.02-1.02-2.02-2.26s0.89-2.26,2.02-2.26c1.13,0,2.04,1.03,2.02,2.26
      C17.76,14.1,16.87,15.12,15.74,15.12z M8.27,15.12c-1.11,0-2.02-1.02-2.02-2.26c0-1.25,0.89-2.26,2.02-2.26
      c1.13,0,2.04,1.03,2.02,2.26C10.29,14.1,9.4,15.12,8.27,15.12z M19.79,4.86c-1.43-0.66-2.97-1.14-4.57-1.42
      c-0.03-0.01-0.06,0.01-0.07,0.03c-0.2,0.35-0.42,0.81-0.57,1.17c-1.73-0.26-3.45-0.26-5.14,0C9.28,4.27,9.05,3.82,8.85,3.47
      C8.84,3.45,8.81,3.43,8.78,3.44C7.18,3.71,5.64,4.2,4.21,4.86C4.19,4.86,4.18,4.87,4.18,4.88c-2.91,4.35-3.71,8.6-3.32,12.79
      c0,0.02,0.01,0.04,0.03,0.05c1.92,1.41,3.78,2.27,5.61,2.84c0.03,0.01,0.06,0,0.08-0.03c0.43-0.59,0.82-1.21,1.15-1.87
      c0.02-0.04,0-0.08-0.04-0.1c-0.61-0.23-1.19-0.51-1.75-0.84c-0.04-0.03-0.05-0.09-0.01-0.12c0.12-0.09,0.24-0.18,0.35-0.27
      c0.02-0.02,0.05-0.02,0.07-0.01c3.68,1.68,7.66,1.68,11.29,0c0.02-0.01,0.05-0.01,0.07,0.01c0.11,0.09,0.23,0.19,0.35,0.27
      c0.04,0.03,0.04,0.09-0.01,0.12c-0.56,0.33-1.14,0.6-1.75,0.83c-0.04,0.02-0.06,0.06-0.04,0.1c0.34,0.65,0.72,1.28,1.15,1.87
      c0.02,0.02,0.05,0.04,0.08,0.03c1.84-0.57,3.7-1.42,5.62-2.84c0.02-0.01,0.03-0.03,0.03-0.05c0.47-4.85-0.78-9.06-3.32-12.79
      C19.81,4.87,19.8,4.86,19.79,4.86z`, fill: "currentColor" }) }),
  facebook: /* @__PURE__ */ f("svg", { viewBox: "0 0 15 27", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f("path", { d: `M11.2594 0C7.31523 0 5 2.00852 5 6.5804V10.6047H0V15.4237H5V27H10V15.431H13.9995L15 10.612H10V7.39932C10
      5.67426 10.5857 4.82143 12.2599 4.82143H15V0.201095C14.5349 0.138101 13.1498 0 11.2569 0H11.2594Z`, fill: "currentColor" }) }),
  favorite: /* @__PURE__ */ f("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f("path", { d: `M18.74,23.18c-0.12,0-0.24-0.03-0.35-0.09L12,19.73l-6.39,3.36c-0.25,0.13-0.56,0.11-0.79-0.06
      c-0.23-0.17-0.35-0.45-0.3-0.73l1.22-7.12l-5.17-5.04c-0.2-0.2-0.28-0.5-0.19-0.77C0.47,9.1,0.7,8.91,0.98,8.86l7.15-1.04l3.2-6.48
      c0.25-0.51,1.09-0.51,1.35,0l3.2,6.48l7.15,1.04c0.28,0.04,0.52,0.24,0.61,0.51c0.09,0.27,0.01,0.57-0.19,0.77l-5.17,5.04
      l1.22,7.12c0.05,0.28-0.07,0.57-0.3,0.73C19.05,23.13,18.9,23.18,18.74,23.18z M12,18.13c0.12,0,0.24,0.03,0.35,0.09l5.4,2.84
      l-1.03-6.01c-0.04-0.24,0.04-0.49,0.22-0.66l4.37-4.26l-6.03-0.88c-0.24-0.04-0.46-0.19-0.56-0.41L12,3.38L9.3,8.84
      C9.19,9.06,8.98,9.22,8.74,9.25L2.7,10.13l4.37,4.26c0.18,0.17,0.26,0.42,0.22,0.66l-1.03,6.01l5.4-2.84
      C11.76,18.16,11.88,18.13,12,18.13z`, fill: "currentColor" }) }),
  link: /* @__PURE__ */ V("svg", { viewBox: "0 0 28 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ f("path", { d: `M11.17 16.7901C10.98 16.7901 10.79 16.7201 10.64 16.5701C8.18001 14.1101 8.18001 10.1101 10.64 7.65012L16.45
      1.84012C18.91 -0.619883 22.91 -0.619883 25.37 1.84012C26.57 3.04012 27.23 4.62012 27.23 6.31012C27.23 8.00012 26.57
      9.58012 25.38 10.7701L23.37 12.7801C23.08 13.0701 22.6 13.0701 22.31 12.7801C22.02 12.4901 22.02 12.0101 22.31
      11.7201L24.32 9.71012C25.23 8.80012 25.73 7.59012 25.73 6.31012C25.73 5.03012 25.23 3.82012 24.32 2.91012C22.44
      1.03012 19.39 1.03012 17.51 2.91012L11.7 8.72012C9.82001 10.6001 9.82001 13.6501 11.7 15.5201C11.99 15.8101 11.99
      16.2901 11.7 16.5801C11.55 16.7301 11.36 16.8001 11.17 16.8001V16.7901Z`, fill: "currentColor" }),
    /* @__PURE__ */ f("path", { d: `M6.32 27.38C4.7 27.38 3.09 26.77 1.86 25.54C0.66 24.34 0 22.76 0 21.07C0 19.38 0.66 17.8 1.85 16.61L3.86
      14.6C4.15 14.31 4.63 14.31 4.92 14.6C5.21 14.89 5.21 15.37 4.92 15.66L2.91 17.67C2 18.58 1.5 19.79 1.5 21.07C1.5
      22.35 2 23.56 2.91 24.47C4.79 26.35 7.84 26.35 9.72 24.47L15.53 18.66C17.41 16.78 17.41 13.73 15.53 11.86C15.24
      11.57 15.24 11.09 15.53 10.8C15.82 10.51 16.3 10.51 16.59 10.8C17.78 11.99 18.44 13.58 18.44 15.26C18.44 16.94
      17.78 18.53 16.59 19.72L10.78 25.53C9.55 26.76 7.93 27.37 6.32 27.37V27.38Z`, fill: "currentColor" })
  ] }),
  lock: /* @__PURE__ */ f("svg", { viewBox: "0 0 19 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f("path", { d: `M0.698249 23.3029C1.16296 23.7676 1.72188 24 2.375 24H16.625C17.2789 24.0008 17.8382 23.7684 18.3029
      23.3029C18.7676 22.8374 19 22.2781 19 21.625V9.75C19.0008 9.09767 18.7684 8.53875 18.3029 8.07325C17.8374
      7.60775 17.2781 7.375 16.625 7.375H15.4375V6.1875C15.4391 4.54638 14.8604 3.14631 13.7014 1.98731C12.5424
      0.828314 11.1419 0.24921 9.5 0.250001C7.85808 0.250793 6.45802 0.829897 5.29981 1.98731C4.14161 3.14473 3.5625
      4.54479 3.5625 6.1875V7.375H2.375C1.72267 7.37579 1.16375 7.60854 0.698249 8.07325C0.232749 8.53796 0 9.09688
      0 9.75V21.625C0.000791667 22.2789 0.233541 22.8382 0.698249 23.3029ZM13.0625 6.1875V7.375H5.9375V6.1875C5.9375
      5.19792 6.28385 4.35677 6.97656 3.66406C7.66927 2.97136 8.51042 2.625 9.5 2.625C10.4896 2.625 11.3307 2.97136
      12.0234 3.66406C12.7161 4.35677 13.0625 5.19792 13.0625 6.1875ZM12.3426 14.4091C12.3426 14.9094 12.2109 15.4009
      11.9607 15.8341C11.7106 16.2674 11.3508 16.6272 10.9175 16.8773V18.6842C10.9175 19.0622 10.7674 19.4246 10.5002
      19.6919C10.2329 19.9591 9.87046 20.1093 9.49252 20.1093C9.11458 20.1093 8.75211 19.9591 8.48487 19.6919C8.21762
      19.4246 8.06749 19.0622 8.06749 18.6842V16.8773C7.52418 16.5636 7.09957 16.0794 6.8595 15.4997C6.61943 14.9201
      6.57732 14.2775 6.7397 13.6715C6.90207 13.0655 7.25987 12.53 7.75759 12.1481C8.25531 11.7661 8.86515 11.5591
      9.49252 11.5591C10.2484 11.5591 10.9733 11.8594 11.5078 12.3938C12.0423 12.9283 12.3426 13.6533 12.3426
      14.4091Z`, fill: "currentColor" }) }),
  plus: /* @__PURE__ */ f("svg", { viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f("path", { d: "M10 4H6V0H4V4H0V6H4V10H6V6H10V4Z", fill: "currentColor" }) }),
  search: /* @__PURE__ */ f("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f(
    "path",
    {
      d: `M17.7,16.34l0.27-0.35c1.3-1.68,1.99-3.68,1.99-5.78c0-5.23-4.25-9.48-9.48-9.48S1,4.98,1,10.2
      c0,5.23,4.25,9.48,9.48,9.48c1.83,0,3.62-0.53,5.16-1.54l0.34-0.22l5.02,5.02c0.44,0.44,1.21,0.44,1.65,0c0.46-0.46,0.46-1.2,0-1.65
      L17.7,16.34z M10.48,17.35c-3.94,0-7.14-3.2-7.14-7.14s3.2-7.14,7.14-7.14s7.14,3.2,7.14,7.14C17.62,14.14,14.42,17.35,10.48,17.35z`,
      fill: "currentColor"
    }
  ) }),
  twitch: /* @__PURE__ */ f("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f("path", { d: `M3.21,1.59L1.77,5.26l0,15.02h5.11l0,2.72h2.88l2.72-2.72h4.15l5.59-5.59l0-13.1H3.21z
      M20.31,13.73l-3.2,3.2H12l-2.72,2.72l0-2.72H4.97l0-13.42h15.34V13.73z M17.11,7.18v5.59H15.2l0-5.59H17.11z M12,7.18v5.59h-1.92
      l0-5.59H12z`, fill: "currentColor" }) }),
  twitter: /* @__PURE__ */ f("svg", { viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f("path", { d: `M17.9686 14.1623L26.7065 4H24.6358L17.0488 12.8238L10.9891 4H4L13.1634 17.3432L4 28H6.07069L14.0827
      18.6817L20.4822 28H27.4714L17.9681 14.1623H17.9686ZM15.1326 17.4607L14.2041 16.132L6.81679 5.55961H9.99723L15.9589
      14.0919L16.8873 15.4206L24.6368 26.5113H21.4564L15.1326 17.4612V17.4607Z`, fill: "currentColor" }) }),
  youtube: /* @__PURE__ */ f("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ f("path", { d: `M18.79,4.14c-3.22-0.22-10.38-0.22-13.59,0C1.73,4.37,1.32,6.47,1.3,12
      c0.03,5.52,0.43,7.63,3.91,7.86c3.21,0.22,10.37,0.22,13.59,0c3.48-0.24,3.89-2.34,3.91-7.86C22.68,6.48,22.27,4.37,18.79,4.14z
      M9.32,15.57l0-7.14l7.14,3.56L9.32,15.57z`, fill: "currentColor" }) })
}, RNe = "_icon_10x7k_1", kNe = {
  icon: RNe
};
function aA(r) {
  var n = r, { icon: e, className: t } = n, i = Fe(n, ["icon", "className"]);
  return dg(SNe[e], q({
    className: me(kNe.icon, t)
  }, i));
}
function S7e({
  className: e,
  visible: t,
  children: i,
  horizontal: r = !1,
  duration: n = 250,
  timing: o = "ease-out"
}) {
  const [s, a] = X.useState(t ? 0 : 2), [l, c] = X.useState(), u = X.useRef(null), m = X.useRef(), g = X.useRef(null);
  X.useLayoutEffect(() => {
    if (s === 0 && !t) {
      m.current && clearTimeout(m.current);
      const y = r ? g.current.offsetWidth : g.current.offsetHeight;
      u.current.style[r ? "maxWidth" : "maxHeight"] = y + "px", c(y), a(1), m.current = window.setTimeout(() => a(2), n);
    } else
      s !== 1 && t && (m.current && clearTimeout(m.current), a(0), m.current = void 0);
  }, [t, s, n, r]);
  const h = X.useRef();
  if (X.useLayoutEffect(() => {
    h.current && (clearTimeout(h.current), h.current = void 0), s === 0 ? (c(
      r ? g.current.offsetWidth : g.current.offsetHeight
    ), h.current = window.setTimeout(() => c(void 0), n)) : c(0);
  }, [r, s, t, n]), X.useEffect(
    () => () => {
      m.current && clearTimeout(m.current), h.current && clearTimeout(h.current);
    },
    []
  ), s === 2)
    return null;
  const A = {
    transition: `${r ? "max-width" : "max-height"} ${n}ms ${o}`
  };
  return l != null && (A[r ? "maxWidth" : "maxHeight"] = l + "px", A.overflow = "hidden"), /* @__PURE__ */ f("div", { style: A, ref: u, children: /* @__PURE__ */ f("div", { ref: g, className: e, children: i }) });
}
const wNe = X.createContext(!1);
function yN(e) {
  return !!(e.altKey || e.ctrlKey || e.metaKey || e.shiftKey);
}
function MNe(e, t, i) {
  const r = LC(e, t, i);
  r.altKeyPressed = !1;
  const n = r.handleTopDragEnter;
  r.handleTopDragEnter = (s) => {
    var a;
    yN(s) !== r.altKeyPressed && (r.altKeyPressed = !r.altKeyPressed, (a = i.setDragEffect) == null || a.call(i, r.altKeyPressed)), n.call(r, s);
  };
  const o = r.handleTopDragOver;
  return r.handleTopDragOver = (s) => {
    var a;
    yN(s) !== r.altKeyPressed && (r.altKeyPressed = !r.altKeyPressed, (a = i.setDragEffect) == null || a.call(i, r.altKeyPressed)), o.call(r, s);
  }, r;
}
function R7e({
  className: e,
  children: t
}) {
  const [i, r] = X.useState(null), [n, o] = X.useState(!1), s = X.useMemo(
    () => ({
      rootElement: i != null ? i : void 0,
      setDragEffect: o
    }),
    [i]
  ), a = X.useMemo(
    () => ({
      clearTimeout: window.clearTimeout.bind(window),
      document
    }),
    []
  );
  return /* @__PURE__ */ f("div", { ref: r, className: e, children: i && /* @__PURE__ */ f(wNe.Provider, { value: n, children: /* @__PURE__ */ f(
    jC,
    {
      backend: MNe,
      context: a,
      options: s,
      children: t
    }
  ) }) });
}
const NNe = X[typeof document != "undefined" && document.createElement !== void 0 ? "useLayoutEffect" : "useEffect"], TNe = NNe, BNe = (e) => {
  const t = ft.useRef(e);
  return ft.useEffect(() => {
    t.current = e;
  }), t;
}, DNe = BNe;
function ONe() {
}
function FNe(e, t, i = {}) {
  const r = qNe(i.polyfill), n = DNe(t);
  return TNe(() => {
    let o = !1;
    const s = e && "current" in e ? e.current : e;
    if (!s)
      return ONe;
    function a(l, c) {
      o || n.current(l, c);
    }
    return r.subscribe(s, a), () => {
      o = !0, r.unsubscribe(s, a);
    };
  }, [e, r, n]), r.observer;
}
function VNe(e) {
  let t = !1, i = [];
  const r = /* @__PURE__ */ new Map(), n = new (e || window.ResizeObserver)((o, s) => {
    i = i.concat(o);
    function a() {
      const l = /* @__PURE__ */ new Set();
      for (let c = 0; c < i.length; c++) {
        if (l.has(i[c].target))
          continue;
        l.add(i[c].target);
        const u = r.get(i[c].target);
        u == null || u.forEach((m) => m(i[c], s));
      }
      i = [], t = !1;
    }
    t || window.requestAnimationFrame(a), t = !0;
  });
  return {
    observer: n,
    subscribe(o, s) {
      var a;
      n.observe(o);
      const l = (a = r.get(o)) !== null && a !== void 0 ? a : [];
      l.push(s), r.set(o, l);
    },
    unsubscribe(o, s) {
      var a;
      const l = (a = r.get(o)) !== null && a !== void 0 ? a : [];
      if (l.length === 1) {
        n.unobserve(o), r.delete(o);
        return;
      }
      const c = l.indexOf(s);
      c !== -1 && l.splice(c, 1), r.set(o, l);
    }
  };
}
let Wv;
const qNe = (e) => Wv || (Wv = VNe(e));
function jNe(e) {
  const [t, i] = X.useState({ width: 0, height: 0 });
  return X.useLayoutEffect(() => {
    e.current && i({
      width: e.current.clientWidth,
      height: e.current.clientHeight
    });
  }, [e]), FNe(e, (r) => {
    const { inlineSize: n, blockSize: o } = r.borderBoxSize[0];
    i({ width: n, height: o });
  }), t;
}
const Tp = 11, FC = 1e-7, LNe = 4;
class KNe {
  constructor(t, i, r, n) {
    Ze(this, "ax");
    Ze(this, "bx");
    Ze(this, "cx");
    Ze(this, "ay");
    Ze(this, "by");
    Ze(this, "cy");
    Ze(this, "startGradient");
    Ze(this, "endGradient");
    Ze(this, "splineSamples", []);
    this.cx = 3 * t, this.bx = 3 * (r - t) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * i, this.by = 3 * (n - i) - this.cy, this.ay = 1 - this.cy - this.by, t > 0 ? this.startGradient = i / t : !i && r > 0 ? this.startGradient = n / r : !i && !n ? this.startGradient = 1 : this.startGradient = 0, r < 1 ? this.endGradient = (n - 1) / (r - 1) : n === 1 && t < 1 ? this.endGradient = (i - 1) / (t - 1) : n === 1 && i === 1 ? this.endGradient = 1 : this.endGradient = 0;
    const o = 1 / (Tp - 1);
    for (let s = 0; s < Tp; ++s)
      this.splineSamples[s] = this.sampleCurveX(s * o);
  }
  sampleCurveX(t) {
    return ((this.ax * t + this.bx) * t + this.cx) * t;
  }
  sampleCurveY(t) {
    return ((this.ay * t + this.by) * t + this.cy) * t;
  }
  sampleCurveDerivativeX(t) {
    return (3 * this.ax * t + 2 * this.bx) * t + this.cx;
  }
  // Given an x value, find a parametric value it came from.
  solveCurveX(t, i) {
    let r = 0, n = 0, o = t, s = 0, a = 0;
    const l = this.splineSamples, c = 1 / (Tp - 1);
    for (let m = 1; m < Tp; m++)
      if (t <= l[m]) {
        n = c * m, r = n - c, o = r + (n - r) * (t - l[m - 1]) / (l[m] - l[m - 1]);
        break;
      }
    const u = Math.min(FC, i);
    for (let m = 0; m < LNe; m++) {
      if (s = this.sampleCurveX(o) - t, Math.abs(s) < u)
        return o;
      if (a = this.sampleCurveDerivativeX(o), Math.abs(a) < FC)
        break;
      o = o - s / a;
    }
    if (Math.abs(s) < i)
      return o;
    for (; r < n; ) {
      if (s = this.sampleCurveX(o), Math.abs(s - t) < i)
        return o;
      t > s ? r = o : n = o, o = (n + r) * 0.5;
    }
    return o;
  }
  solve(t, i) {
    return t < 0 ? 0 + this.startGradient * t : t > 1 ? 1 + this.endGradient * (t - 1) : this.sampleCurveY(this.solveCurveX(t, i));
  }
}
function lA(e, t, i, r) {
  const n = new KNe(e, t, i, r);
  return (o) => n.solve(o, FC);
}
const YNe = (e) => e, k7e = lA(0.25, 0.1, 0.25, 1), w7e = lA(0.42, 0, 1, 1), M7e = lA(0, 0, 0.58, 1), N7e = lA(0.42, 0, 0.58, 1);
function Jq(e, t, i, r, n, o) {
  const s = o / e.scale;
  return {
    x: r - (t - e.x) * s,
    y: n - (i - e.y) * s,
    scale: o
  };
}
const Pq = {
  delta: 1.1
};
class zq {
  constructor(t, i, r, n) {
    Ze(this, "_setTransform");
    Ze(this, "containerRef");
    Ze(this, "parameterRef");
    Ze(this, "transformRef");
    Ze(this, "frame");
    Ze(this, "targetTransform");
    this._setTransform = t, this.containerRef = i, this.parameterRef = r, this.transformRef = n;
  }
  minScale() {
    const { dimensions: t, minScale: i } = this.parameterRef.current, r = this.containerRef.current;
    if (!r || i !== 0 || t.right <= t.left + 1e-3 || t.bottom <= t.top + 1e-3)
      return i;
    const n = r.clientWidth / (t.right - t.left), o = r.clientHeight / (t.bottom - t.top);
    return Math.max(i, Math.min(n, o));
  }
  applyBounds(t) {
    const { cover: i, dimensions: r, maxScale: n } = this.parameterRef.current, o = this.containerRef.current;
    if (!o)
      return t;
    if (i) {
      t.scale = Math.max(
        Math.min(t.scale, n),
        this.minScale()
      );
      const s = -r.left * t.scale, a = o.clientWidth - r.right * t.scale;
      a < s ? t.x = Math.max(Math.min(t.x, s), a) : t.x = (a + s) / 2;
      const l = -r.top * t.scale, c = o.clientHeight - r.bottom * t.scale;
      c < l ? t.y = Math.max(Math.min(t.y, l), c) : t.y = (c + l) / 2;
    } else
      t.x = Math.max(
        Math.min(
          t.x,
          o.clientWidth - r.left * t.scale
        ),
        -r.right * t.scale
      ), t.y = Math.max(
        Math.min(
          t.y,
          o.clientHeight - r.top * t.scale
        ),
        -r.bottom * t.scale
      );
    return t;
  }
  _zoomToFit(t) {
    const { maxScale: i } = this.parameterRef.current, r = this.containerRef.current, n = r.clientWidth, o = r.clientHeight;
    let s = i;
    return t.right > t.left && (s = Math.min(s, n / (t.right - t.left))), t.bottom > t.top && (s = Math.min(s, o / (t.bottom - t.top))), s = Math.max(this.minScale(), s), this.applyBounds({
      scale: s,
      x: n / 2 - (t.left + t.right) / 2 * s,
      y: o / 2 - (t.top + t.bottom) / 2 * s
    });
  }
  setTransform(t, i, r = YNe) {
    var c;
    this.frame != null && (window.cancelAnimationFrame(this.frame), this.frame = void 0);
    const n = this.transformRef.current, o = typeof t == "function" ? t((c = this.targetTransform) != null ? c : n) : t;
    if (!i)
      return this._setTransform(t), this.targetTransform = void 0, o;
    const s = performance.now(), a = s + i * 1e3;
    this.targetTransform = o;
    const l = (u) => {
      if (u >= a)
        this._setTransform(o), this.frame = void 0, this.targetTransform = void 0;
      else {
        const m = r(
          Math.max(u - s, 0) / (i * 1e3)
        );
        this._setTransform({
          scale: n.scale + (o.scale - n.scale) * m,
          x: n.x + (o.x - n.x) * m,
          y: n.y + (o.y - n.y) * m
        }), this.frame = window.requestAnimationFrame(l);
      }
    };
    return this.frame = window.requestAnimationFrame(l), o;
  }
  reset(t, i, r) {
    if (this.containerRef.current)
      return this.setTransform(
        this.applyBounds(t),
        i,
        r
      );
  }
  zoomToFit(t, i, r) {
    if (this.containerRef.current)
      return this.setTransform(this._zoomToFit(t), i, r);
  }
  zoomBy(t, i, r, n, o) {
    return this.setTransform(
      (s) => {
        const { maxScale: a } = this.parameterRef.current, l = this.containerRef.current;
        if (!l)
          return s;
        const c = Math.max(
          Math.min(t * s.scale, a),
          this.minScale()
        );
        return i == null && (i = l.clientWidth / 2), r == null && (r = l.clientHeight / 2), this.applyBounds(Jq(s, i, r, i, r, c));
      },
      n,
      o
    );
  }
  moveBy(t, i, r, n) {
    return this.setTransform(
      (o) => this.applyBounds(ee(q({}, o), {
        x: o.x + t,
        y: o.y + i
      })),
      r,
      n
    );
  }
  moveTo(t, i, r, n) {
    return this.setTransform(
      (o) => {
        const s = this.containerRef.current;
        return s ? this.applyBounds(ee(q({}, o), {
          x: s.clientWidth / 2 - t * o.scale,
          y: s.clientHeight / 2 - i * o.scale
        })) : o;
      },
      r,
      n
    );
  }
  moveToFit(t, i, r) {
    return this.setTransform(
      (n) => {
        const o = this.containerRef.current;
        if (!o)
          return n;
        const s = (t.right - t.left) * n.scale, a = (t.bottom - t.top) * n.scale;
        if (s > o.clientWidth || a > o.clientHeight)
          return this._zoomToFit(t);
        {
          const l = t.left * n.scale, c = t.top * n.scale;
          return this.applyBounds(ee(q({}, n), {
            x: Math.min(
              Math.max(n.x, -l),
              o.clientWidth - l - s
            ),
            y: Math.min(
              Math.max(n.y, -c),
              o.clientHeight - c - a
            )
          }));
        }
      },
      i,
      r
    );
  }
}
const UNe = {
  transform: { x: 0, y: 0, scale: 1 },
  size: { width: 0, height: 0 },
  container: void 0,
  controller: new zq(
    () => {
    },
    {
      current: null
    },
    {
      current: {
        dimensions: {
          left: 0,
          top: 0,
          right: 0,
          bottom: 0
        },
        minScale: 0.15,
        maxScale: 1,
        wheelZoom: Pq
      }
    },
    {
      current: {
        scale: 1,
        x: 0,
        y: 0
      }
    }
  )
};
function Bp(e) {
  if (!e.length)
    return;
  let t = 0, i = 0;
  for (const n of e)
    t += n.pos.x, i += n.pos.y;
  t /= e.length, i /= e.length;
  let r = 0;
  for (const n of e) {
    const o = n.pos.x - t, s = n.pos.y - i;
    r += Math.sqrt(o * o + s * s);
  }
  return {
    x: t,
    y: i,
    size: r / e.length
  };
}
function GNe({ x: e, y: t, scale: i }) {
  const r = e.toFixed(0), n = t.toFixed(0), o = i.toPrecision(6);
  return `translate(${r}px, ${n}px) scale(${o})`;
}
const Hq = X.createContext(UNe);
function QNe(e) {
  const t = e.current, { containerRef: i, transformRef: r, parameterRef: n } = t, o = i.current;
  if (!o)
    return;
  const s = [];
  let a, l = r.current;
  const c = Ut.debounce(g, 20, {
    trailing: !0,
    maxWait: 20
  });
  function u(y) {
    const E = o.getBoundingClientRect();
    return {
      x: y.clientX - E.left,
      y: y.clientY - E.top
    };
  }
  function m(y) {
    if (y.type === "mouse" && y.button !== 0)
      return;
    const E = u(y), v = {
      id: y.pointerId,
      pos: E,
      initial: E,
      capture: !1
    }, C = s.findIndex((x) => x.id === v.id);
    C >= 0 ? s[C] = v : s.push(v), a = Bp(s), l = r.current;
  }
  function g(y) {
    const E = s.findIndex((S) => S.id === y.pointerId);
    if (E < 0)
      return;
    const v = u(y), C = s[E];
    if (s[E].pos = v, !C.capture) {
      const S = v.x - C.initial.x, R = v.y - C.initial.y;
      S * S + R * R > 4 * 4 && (o.setPointerCapture(y.pointerId), C.capture = !0);
    }
    const x = Bp(s);
    if (x && a)
      if (s.length === 1 || a.size < 10 || x.size < 10) {
        const S = q({}, l);
        S.x += x.x - a.x, S.y += x.y - a.y, t.reset(S);
      } else {
        const { minScale: S, maxScale: R } = n.current, w = Math.max(
          Math.min(
            x.size / a.size * l.scale,
            R
          ),
          S
        ), T = Jq(
          l,
          a.x,
          a.y,
          x.x,
          x.y,
          w
        );
        t.reset(T);
      }
  }
  function h(y) {
    const E = s.findIndex((v) => v.id === y.pointerId);
    E < 0 || (s[E].capture && o.releasePointerCapture(y.pointerId), s.splice(E, 1), a = Bp(s), l = r.current);
  }
  function A(y) {
    const E = n.current.wheelZoom;
    y.preventDefault();
    const v = u(y), C = t.zoomBy(
      y.deltaY > 0 ? 1 / E.delta : E.delta,
      v.x,
      v.y,
      E.duration,
      E.timingFunction
    );
    a = Bp(s), l = C;
  }
  return o.addEventListener("pointerdown", m, { passive: !1 }), o.addEventListener("pointermove", c, {
    passive: !1
  }), o.addEventListener("pointerup", h, { passive: !1 }), o.addEventListener("pointercancel", h, { passive: !1 }), o.addEventListener("wheel", A, { passive: !1 }), () => {
    o.removeEventListener("pointerdown", m), o.removeEventListener("pointermove", c), o.removeEventListener("pointerup", h), o.removeEventListener("pointercancel", h), o.removeEventListener("wheel", A);
  };
}
const WNe = X.forwardRef(function({
  outerClass: t,
  dimensions: i,
  cover: r,
  initialTransform: n,
  minScale: o = 0.15,
  maxScale: s = 1,
  children: a,
  wheelZoom: l = Pq
}, c) {
  const u = X.useRef(null), m = X.useRef({
    dimensions: i,
    cover: r,
    minScale: o,
    maxScale: s,
    initialTransform: n,
    wheelZoom: l
  });
  m.current = {
    dimensions: i,
    cover: r,
    minScale: o,
    maxScale: s,
    initialTransform: n,
    wheelZoom: l
  };
  const g = jNe(u), [h, A] = X.useState({
    x: 0,
    y: 0,
    scale: 1
  }), y = X.useRef(h);
  y.current = h;
  const E = X.useRef(void 0);
  u.current || (E.current = new zq(
    A,
    u,
    m,
    y
  )), X.useImperativeHandle(
    c,
    () => ({
      get transform() {
        return y.current;
      },
      get container() {
        var x;
        return (x = u.current) != null ? x : void 0;
      },
      controller: E.current,
      get size() {
        const x = u.current;
        return x ? {
          width: x.clientWidth,
          height: x.clientHeight
        } : { width: 0, height: 0 };
      }
    }),
    []
  );
  const v = X.useRef(!1);
  X.useLayoutEffect(() => {
    if (v.current)
      return;
    const x = u.current;
    if (!x || x.clientWidth < 10 || x.clientHeight < 10)
      return;
    v.current = !0;
    let S = m.current.initialTransform;
    typeof S == "function" && (S = S(x)), S ? E.current.reset(S) : E.current.zoomToFit(m.current.dimensions);
  }), X.useEffect(() => QNe(E), []);
  const C = X.useMemo(
    () => ({
      get container() {
        var x;
        return (x = u.current) != null ? x : void 0;
      },
      controller: E.current,
      transform: h,
      size: g
    }),
    [h, g]
  );
  return /* @__PURE__ */ f(Hq.Provider, { value: C, children: /* @__PURE__ */ f("div", { className: t, ref: u, children: a }) });
});
function ZNe({
  className: e,
  children: t
}) {
  const i = X.useContext(Hq);
  return /* @__PURE__ */ f(
    "div",
    {
      className: e,
      style: {
        transform: GNe(i.transform),
        "--scale": i.transform.scale
      },
      children: t
    }
  );
}
const T7e = X.forwardRef(
  (n, r) => {
    var o = n, { innerClass: e, children: t } = o, i = Fe(o, ["innerClass", "children"]);
    return /* @__PURE__ */ f(WNe, ee(q({}, i), { ref: r, children: /* @__PURE__ */ f(ZNe, { className: e, children: t }) }));
  }
), hl = {
  alt: !1,
  shift: !1,
  ctrl: !1
}, Sc = {
  alt: [],
  shift: [],
  ctrl: []
};
function Zv(e) {
  if ("key" in e && e.key === "Alt" && Sc.alt.length && e.preventDefault(), e.altKey !== hl.alt) {
    hl.alt = e.altKey;
    for (const t of Sc.alt)
      t(e.altKey);
  }
  if (e.shiftKey !== hl.shift) {
    hl.shift = e.shiftKey;
    for (const t of Sc.shift)
      t(e.shiftKey);
  }
  if (e.ctrlKey !== hl.ctrl) {
    hl.ctrl = e.ctrlKey;
    for (const t of Sc.ctrl)
      t(e.ctrlKey);
  }
}
typeof document != "undefined" && (document.addEventListener("keydown", Zv, !0), document.addEventListener("keyup", Zv, !0), document.addEventListener("mousemove", Zv, !0));
function JI(e) {
  const [t, i] = X.useState(hl[e]);
  return X.useEffect(() => (i(hl[e]), Sc[e].push(i), () => {
    const r = Sc[e].indexOf(i);
    r >= 0 && Sc[e].splice(r, 1);
  }), [e]), t;
}
function B7e() {
  return JI("alt");
}
function D7e() {
  return JI("shift");
}
function O7e() {
  return JI("ctrl");
}
const EN = (e, t, i) => i ? parseFloat(e.toFixed(t)).toString() : e.toFixed(t), F7e = X.forwardRef(function(x, C) {
  var S = x, {
    digits: t = 2,
    value: i = 0,
    onChange: r,
    onEnter: n,
    className: o,
    values: s,
    ranges: a,
    filter: l,
    onFocus: c,
    onBlur: u,
    onlyFinal: m,
    trim: g = !0,
    text: h,
    time: A,
    min: y,
    max: E
  } = S, v = Fe(S, [
    "digits",
    "value",
    "onChange",
    "onEnter",
    "className",
    "values",
    "ranges",
    "filter",
    "onFocus",
    "onBlur",
    "onlyFinal",
    "trim",
    "text",
    "time",
    "min",
    "max"
  ]);
  const R = v.disabled, w = y === void 0 ? void 0 : Number(y), T = E === void 0 ? void 0 : Number(E), N = v.step === void 0 ? 1 : Number(v.step), [D, O] = se(!0), [F, Y] = se(0), P = Ne(i), z = Ne(null), W = we(() => l || (s ? bO(s) : a ? CO(a) : xO(w, T)), [l, w, T, s, a]), H = ye(
    (de) => {
      if (A) {
        const fe = Math.floor(de / 60);
        let Re = EN(de - fe * 60, t, g);
        return Re.match(/^\d(?:\.|$)/) && (Re = "0" + Re), `${fe}:${Re}`;
      } else
        return EN(de, t, g);
    },
    [g, t, A]
  ), Q = ye(
    (de) => {
      if (A) {
        let fe = 0;
        for (const Re of de.split(":"))
          fe = fe * 60 + parseFloat(Re);
        return fe;
      } else
        return parseFloat(de);
    },
    [A]
  );
  B0(() => {
    P.current !== i && (P.current = i, z.current.value = H(i), O(!0));
  }, [i, F, H]);
  const $ = ye(
    (de) => {
      z.current.select(), c && c(de);
    },
    [c]
  ), le = ye(
    (de) => {
      const fe = de.target.value.replace(
        A ? /[^\-\d.:]/g : /[^\-\d.]/g,
        ""
      );
      de.target.value !== fe && (de.target.value = fe);
      const Re = fe.match(
        A ? /^(?:\d+:)?(\d*)(?:\.(\d*))?$/ : /^-?(\d*)(?:\.(\d*))?$/
      ), qe = Q(de.target.value);
      if (!Re || isNaN(qe))
        O(!1), P.current = void 0;
      else {
        const Oe = Math.max(t, Re[2] ? Re[2].length : 0), Xe = Math.exp(-Math.LN10 * Oe) * 0.51;
        let Qe = qe;
        N && (Qe = Math.round(Qe / N) * N), Qe = W.nearest(Qe, i), Math.abs(Qe - qe) > Xe ? D && Math.abs(qe - i) === N ? (z.current.value = H(Qe), P.current = Qe, O(!0), m || r(Qe)) : (P.current = void 0, O(!1)) : (P.current = Qe, O(!0), m || r(Qe));
      }
    },
    [
      t,
      W,
      N,
      r,
      i,
      D,
      m,
      H,
      Q,
      A
    ]
  );
  be(() => {
    if (R)
      return;
    function de(Re) {
      if (Re.shiftKey)
        return;
      Re.preventDefault(), Re.stopPropagation();
      const qe = W.move(i, (Re.deltaY > 0 ? -1 : 1) * (N || 1));
      z.current.value = H(qe), P.current = qe, r(qe), O(!0);
    }
    const fe = z.current;
    return fe.addEventListener("wheel", de, { passive: !1 }), () => fe.removeEventListener("wheel", de);
  }, [i, r, W, N, H, R]);
  const he = ye(
    (de) => {
      let fe = Q(z.current.value);
      isNaN(fe) ? (P.current = i, z.current.value = H(i), O(!0)) : (N && (fe = Math.round(fe / N) * N), fe = W.nearest(fe, i), P.current = fe, z.current.value = H(fe), O(!0), r(fe), Y((Re) => Re + 1)), u && u(de);
    },
    [W, N, i, r, u, H, Q]
  ), oe = ye(() => {
    P.current = i, z.current.value = H(i), O(!0);
  }, [i, H]), ue = ye(
    (de) => {
      if (!R)
        switch (de.key) {
          case "Enter":
            z.current.blur(), n && n(P.current);
            break;
          case "Esc":
          case "Escape":
            oe(), z.current.blur();
            break;
        }
    },
    [R, n, oe]
  ), Ae = we(
    () => sf(z, C),
    [z, C]
  );
  return /* @__PURE__ */ f(
    "input",
    q({
      type: h ? "text" : "number",
      defaultValue: H(i),
      onChange: le,
      onKeyDown: ue,
      onFocus: $,
      onBlur: he,
      className: me(o, { invalid: !D }),
      ref: Ae,
      min: W.min,
      max: W.max
    }, v)
  );
}), JNe = "_OverlayRoot_ffrjq_1", PNe = "_Overlay_ffrjq_1", zNe = "_modal_ffrjq_24", HNe = "_PopupMenu_ffrjq_29", XNe = "_ErrorBox_ffrjq_46", _Ne = "_NotificationBox_ffrjq_47", $Ne = "_hasModal_ffrjq_79", cs = {
  OverlayRoot: JNe,
  Overlay: PNe,
  modal: zNe,
  PopupMenu: HNe,
  ErrorBox: XNe,
  NotificationBox: _Ne,
  hasModal: $Ne
}, eTe = (e) => ({
  left: e.clientX,
  top: e.clientY,
  right: e.clientX,
  bottom: e.clientY
}), tTe = ({
  items: e,
  onResolve: t = () => {
  }
}) => /* @__PURE__ */ f("ul", { className: cs.PopupMenu, children: e.map((i, r) => /* @__PURE__ */ f("li", { onClick: () => t(r), children: i }, r)) });
class Xq {
  constructor(t) {
    Ze(this, "nonModals", /* @__PURE__ */ new Map());
    Ze(this, "modals", []);
    Ze(this, "asyncKey", 0);
    Ze(this, "setState");
    this.setState = t;
  }
  get topModal() {
    return this.modals[this.modals.length - 1];
  }
  maxZIndex() {
    let t = 0;
    const i = this.topModal;
    i && (t = parseInt(i.style.zIndex));
    for (const [r, n] of this.nonModals)
      (!i || n === i) && (t = Math.max(t, parseInt(r.style.zIndex)));
    return t;
  }
  addOverlay(t, i, r) {
    var n, o;
    if (i)
      (n = this.topModal) == null || n.classList.remove(cs.modal), t.style.zIndex = (this.maxZIndex() + 1).toString(), t.classList.add(cs.modal), this.modals.push(t);
    else {
      const s = this.topModal;
      (!s || r === s) && (t.style.zIndex = (this.maxZIndex() + 1).toString()), this.nonModals.set(t, r);
    }
    this.modals.length && ((o = document.body) == null || o.classList.add(cs.hasModal));
  }
  removeOverlay(t) {
    var r, n;
    const i = this.modals.indexOf(t);
    i >= 0 ? (this.modals.splice(i, 1), (r = this.topModal) == null || r.classList.add(cs.modal)) : this.nonModals.delete(t), t.classList.remove(cs.modal), this.modals.length || (n = document.body) == null || n.classList.remove(cs.hasModal);
  }
  moveToTop(t) {
    if (!this.nonModals.has(t))
      return;
    const i = this.topModal;
    if (i && this.nonModals.get(t) !== i)
      return;
    const r = this.maxZIndex();
    r !== parseInt(t.style.zIndex) && (t.style.zIndex = `${r + 1}`);
  }
  async(t) {
    if (this.setState == null)
      throw Error("async overlays can only be created in OverlayRoot context");
    return new Promise((i, r) => {
      this.asyncKey += 1;
      const n = this.asyncKey.toString(), o = this.setState, s = () => this.setState((a) => {
        const l = a.findIndex((c) => c.key === n);
        return l < 0 || (a = [...a], a.splice(l, 1)), a;
      });
      t = X.cloneElement(t, {
        key: n,
        onResolve(a) {
          i(a), s();
        },
        onReject(a) {
          r(a), s();
        },
        onClose() {
          i(void 0), s();
        }
      }), o((a) => [...a, t]);
    });
  }
  popup(t, i) {
    const r = "getBoundingClientRect" in t ? t.getBoundingClientRect() : eTe(t);
    return this.async(/* @__PURE__ */ f(nTe, { alignPosition: r, children: i }));
  }
  menu(t, i) {
    return this.popup(t, /* @__PURE__ */ f(tTe, { items: i }));
  }
}
const _q = X.createContext(new Xq()), $q = X.createContext(
  void 0
);
function V7e({
  children: e,
  node: t
}) {
  const [i, r] = X.useState([]), [n] = X.useState(() => new Xq(r)), o = X.useRef(null), [s, a] = X.useState(t);
  return X.useEffect(() => {
    var l;
    a((l = o.current) != null ? l : t);
  }, [t]), /* @__PURE__ */ V(_q.Provider, { value: n, children: [
    /* @__PURE__ */ V($q.Provider, { value: s, children: [
      e,
      i
    ] }),
    !t && /* @__PURE__ */ f("div", { className: cs.OverlayRoot, ref: o })
  ] });
}
const vN = X.createContext(void 0);
function cA({
  children: e,
  modal: t = !1,
  onKeyDown: i,
  onMouseDown: r
}) {
  var c;
  const n = X.useContext(_q), o = (c = X.useContext($q)) != null ? c : document.body, s = X.useContext(vN), [a, l] = X.useState(null);
  return X.useEffect(() => {
    if (!a)
      return;
    const u = () => {
      n.moveToTop(a);
    };
    return a.addEventListener("mousedown", u), n.addOverlay(a, t, s), () => {
      a.removeEventListener("mousedown", u), n.removeOverlay(a);
    };
  }, [n, a, s, t]), Kl.createPortal(
    /* @__PURE__ */ f(
      "div",
      {
        className: cs.Overlay,
        ref: l,
        tabIndex: -1,
        onMouseDown: r,
        onKeyDown: i,
        children: /* @__PURE__ */ f(vN.Provider, { value: a != null ? a : void 0, children: e })
      }
    ),
    o
  );
}
const q7e = ({
  onClose: e,
  title: t,
  message: i
}) => /* @__PURE__ */ f(cA, { modal: !0, onMouseDown: e, children: /* @__PURE__ */ V("div", { className: cs.ErrorBox, children: [
  !!t && /* @__PURE__ */ f("h3", { children: t }),
  !!i && /* @__PURE__ */ f("p", { children: i })
] }) }), j7e = ({
  onClose: e,
  title: t,
  message: i
}) => /* @__PURE__ */ f(cA, { modal: !0, onMouseDown: e, children: /* @__PURE__ */ V("div", { className: cs.NotificationBox, children: [
  !!t && /* @__PURE__ */ f("h3", { children: t }),
  !!i && /* @__PURE__ */ f("p", { children: i })
] }) }), L7e = (e) => e != null && typeof e == "object", K7e = (e) => Array.isArray(e), Y7e = (e) => typeof e == "string", U7e = (e) => typeof e == "number", G7e = (e) => typeof e == "boolean", Q7e = (e) => typeof e == "number" || typeof e == "string" && !isNaN(Number(e)), W7e = (...e) => (t) => e.includes(t), Z7e = (e) => (t) => Array.isArray(t) && t.every(e), J7e = (e, t, i) => t in e && i(e[t]), P7e = (e, t, i) => t in e ? i(e[t]) : void 0, Dp = (e) => e != null, z7e = (e) => !!e;
function H7e(e, t) {
  return Array.isArray(e) ? e.filter(t) : [];
}
function X7e(e, t) {
  const i = {};
  if (e && typeof e == "object")
    for (const [r, n] of Object.entries(e))
      t(n) && (i[r] = n);
  return i;
}
function _7e(e, t, i) {
  const r = {};
  for (const [n, o] of Object.entries(e)) {
    const s = i ? i(n) : n;
    if (s === void 0)
      continue;
    const a = t(o);
    a !== void 0 && (r[s] = a);
  }
  return r;
}
function $7e(e, t, i) {
  const r = {};
  for (const [n, o] of Object.entries(e)) {
    const s = Number(n);
    if (isNaN(s))
      continue;
    const a = i ? i(s) : s;
    if (a === void 0)
      continue;
    const l = t(o);
    l !== void 0 && (r[a] = l);
  }
  return r;
}
function eDe(e, t) {
  const i = [];
  for (const r of e) {
    const n = t(r, i.length);
    n !== void 0 && i.push(n);
  }
  return i;
}
function tDe(e) {
  const t = {};
  for (const [i, r] of Object.entries(e))
    r !== void 0 && (t[i] = r);
  return t;
}
function iDe(e, t) {
  const i = {};
  for (const [r, n] of Object.entries(t))
    r in e && n(e[r]) && (i[r] = e[r]);
  return i;
}
const Jv = ({ left: e, top: t, right: i, bottom: r }) => ({ left: e, top: t, right: i, bottom: r }), bN = ({ left: e, top: t, right: i, bottom: r }, n = "") => {
  const o = n.includes("l") ? e : n.includes("r") ? i : (e + i) / 2, s = n.includes("t") ? t : n.includes("b") ? r : (t + r) / 2;
  return { x: o, y: s };
};
function ej(e, t, i, r, n) {
  if (!e || !t)
    return;
  const o = window.getComputedStyle(e).position;
  if (o !== "absolute" && o === "fixed")
    throw Error(`Element passed to alignElement must have position: absolute or fixed, not ${o}`);
  if (!(o === "absolute" ? e.offsetParent : document.documentElement))
    return;
  const a = Jv(t);
  typeof r == "number" ? (a.top -= r, a.right += r, a.bottom += r, a.left -= r) : Array.isArray(r) && (a.top -= [r[0], 0].find(Dp), a.right += [r[1], r[0], 0].find(Dp), a.bottom += [r[2], r[0], 0].find(Dp), a.left -= [r[3], r[1], r[0], 0].find(Dp)), e.style.left || (e.style.left = "0px"), e.style.top || (e.style.top = "0px");
  const l = Jv(e.getBoundingClientRect()), c = (g, h) => {
    const { from: A, to: y } = g, E = bN(l, A.toLowerCase()), v = bN(a, y.toLowerCase());
    let C = v.x - E.x, x = v.y - E.y;
    const S = h && Math.max(
      h.left - l.left - C,
      l.right + C - h.right,
      h.top - l.top - x,
      l.bottom + x - h.bottom
    );
    return n && h && (l.right + C - h.right > 0 && (C = h.right - l.right), l.bottom + x - h.bottom > 0 && (x = h.bottom - l.bottom), h.left - l.left - C > 0 && (C = h.left - l.left), h.top - l.top - x > 0 && (x = h.top - l.top)), { x: C, y: x, score: S, method: g };
  };
  let u;
  if (!Array.isArray(i))
    u = c(i);
  else {
    let g = e.parentElement, h = window.getComputedStyle(g);
    for (; g !== document.documentElement && h.overflow === "visible"; )
      g = g.parentElement, h = window.getComputedStyle(g);
    const A = Jv(g.getBoundingClientRect());
    A.left += (parseFloat(h.paddingLeft) || 0) + (parseFloat(h.borderLeftWidth) || 0), A.top += (parseFloat(h.paddingTop) || 0) + (parseFloat(h.borderTopWidth) || 0), A.right -= (parseFloat(h.paddingRight) || 0) + (parseFloat(h.borderRightWidth) || 0), A.bottom -= (parseFloat(h.paddingBottom) || 0) + (parseFloat(h.borderBottomWidth) || 0), i.some((y) => {
      const E = c(y, A);
      return (!u || E.score < u.score) && (u = E), E.score <= 0;
    });
  }
  if (!u)
    return;
  const m = {
    left: Math.round((parseFloat(e.style.left) || 0) + u.x) + "px",
    top: Math.round((parseFloat(e.style.top) || 0) + u.y) + "px"
  };
  return u.method.matchWidth && (m.width = Math.round(a.right - a.left) + "px"), u.method.matchHeight && (m.height = Math.round(a.bottom - a.top) + "px"), m;
}
const iTe = [
  { from: "tl", to: "tr" },
  { from: "bl", to: "br" },
  { from: "tr", to: "tl" },
  { from: "br", to: "bl" },
  { from: "tl", to: "bl" },
  { from: "tr", to: "br" },
  { from: "bl", to: "tl" },
  { from: "br", to: "tr" },
  { from: "l", to: "r" },
  { from: "r", to: "l" },
  { from: "b", to: "t" },
  { from: "t", to: "b" }
], rTe = [0, 20];
function nTe(o) {
  var s = o, {
    alignPosition: e,
    alignMethod: t = iTe,
    alignPadding: i = rTe,
    children: r
  } = s, n = Fe(s, [
    "alignPosition",
    "alignMethod",
    "alignPadding",
    "children"
  ]);
  const [a, l] = X.useState(), c = X.useRef(null), u = n.onClose;
  X.useLayoutEffect(() => {
    l(
      ej(c.current, e, t, i, !0)
    ), c.current.focus();
  }, [e, t, i]);
  const m = X.useCallback(
    (h) => {
      var A;
      (!h.relatedTarget || !((A = c.current) != null && A.contains(h.relatedTarget))) && u();
    },
    [u]
  ), g = X.useCallback(
    (h) => {
      (h.key === "Esc" || h.key === "Escape") && u();
    },
    [u]
  );
  return /* @__PURE__ */ f(cA, { children: /* @__PURE__ */ f(
    "div",
    {
      className: "ui-Popup",
      style: q({ position: "absolute", outline: "none" }, a),
      ref: c,
      tabIndex: -1,
      onBlur: m,
      onKeyDown: g,
      children: X.cloneElement(X.Children.only(r), n)
    }
  ) });
}
const Qn = 5, oTe = X.memo(
  ({
    items: e,
    renderItem: t,
    block: i
  }) => /* @__PURE__ */ f(gt, { children: e.slice(i * Qn, i * Qn + Qn).map((r, n) => t(r, n + i * Qn)) })
), tj = X.memo(
  ({
    items: e,
    renderItem: t,
    firstBlock: i,
    lastBlock: r
  }) => /* @__PURE__ */ f(gt, { children: r > i && [...Array(r - i)].map((n, o) => /* @__PURE__ */ f(
    oTe,
    {
      items: e,
      renderItem: t,
      block: o + i
    },
    o + i
  )) })
);
function rDe(a) {
  var l = a, {
    containerType: e = "ul",
    itemSelector: t = "li",
    items: i,
    renderItem: r,
    maxHeight: n,
    itemHeight: o = 18
  } = l, s = Fe(l, [
    "containerType",
    "itemSelector",
    "items",
    "renderItem",
    "maxHeight",
    "itemHeight"
  ]);
  const [c, u] = X.useState(0), m = X.useRef(null), g = X.useRef(o);
  X.useEffect(() => {
    const C = m.current.querySelector(t);
    C && (g.current = C.offsetHeight);
  }, [i, t]);
  const h = X.useCallback(() => {
    u(
      Math.max(
        Math.floor(
          m.current.scrollTop / g.current / Qn
        ) - 1,
        0
      )
    );
  }, []), A = Math.min(
    c + Math.ceil(n / g.current / Qn) + 4,
    Math.ceil(i.length / Qn)
  ), y = c * Qn, E = Math.min(
    y + (Math.ceil(n / g.current / Qn) + 4) * Qn,
    i.length
  ), v = e;
  return /* @__PURE__ */ f("div", ee(q({}, s), { ref: m, onScroll: h, children: /* @__PURE__ */ f(
    v,
    {
      style: {
        marginTop: y * g.current,
        marginBottom: (i.length - E) * g.current
      },
      children: /* @__PURE__ */ f(
        tj,
        {
          items: i,
          renderItem: r,
          firstBlock: c,
          lastBlock: A
        }
      )
    }
  ) }));
}
function nDe({
  containerType: e = "ul",
  itemSelector: t = "li",
  items: i,
  renderItem: r,
  itemHeight: n = 18,
  containerRect: o,
  className: s
}) {
  const [a, l] = X.useState(0), [c, u] = X.useState(0), [m, g] = X.useState(n), h = X.useRef(null);
  X.useLayoutEffect(() => {
    const R = h.current.querySelector(t);
    R && g(R.offsetHeight);
  }, [i, t]), X.useLayoutEffect(() => {
    if (!h.current || !o)
      return;
    const w = -(h.current.getBoundingClientRect().top - o.top);
    l(w), u(w + o.height);
  }, [o, i]);
  const A = Math.max(
    0,
    Math.min(Math.floor(a / m), i.length - 1)
  ), y = Math.max(
    0,
    Math.min(
      Math.ceil((c + Math.max(0, -a)) / m),
      i.length
    )
  ), E = Math.floor(A / Qn) - 1, v = Math.ceil(y / Qn) + 1, C = Math.max(0, E * Qn), x = Math.min(v * Qn, i.length);
  return /* @__PURE__ */ f(
    e,
    {
      ref: h,
      className: s,
      style: {
        paddingTop: C * m,
        paddingBottom: (i.length - x) * m
      },
      children: /* @__PURE__ */ f(
        tj,
        {
          items: i,
          renderItem: r,
          firstBlock: E,
          lastBlock: v
        }
      )
    }
  );
}
const sTe = "_Dialog_mg1ym_1", aTe = "_DialogFooter_mg1ym_12", lTe = "_DialogHeader_mg1ym_45", cTe = "_locked_mg1ym_57", uTe = "_DialogTitle_mg1ym_61", dTe = "_DialogButtons_mg1ym_66", $u = {
  Dialog: sTe,
  DialogFooter: aTe,
  DialogHeader: lTe,
  locked: cTe,
  DialogTitle: uTe,
  DialogButtons: dTe
}, mTe = "_Resizable_1ko3q_1", gTe = "_Resizable__handle_1ko3q_6", hTe = "_n_1ko3q_10", pTe = "_s_1ko3q_10", fTe = "_e_1ko3q_23", ATe = "_w_1ko3q_23", yTe = "_ne_1ko3q_36", ETe = "_nw_1ko3q_36", vTe = "_se_1ko3q_36", bTe = "_sw_1ko3q_36", VC = {
  Resizable: mTe,
  Resizable__handle: gTe,
  n: hTe,
  s: pTe,
  e: fTe,
  w: ATe,
  ne: yTe,
  nw: ETe,
  se: vTe,
  sw: bTe
};
function ll({
  side: e,
  x: t,
  y: i,
  onDrag: r
}) {
  const n = X.useRef(!1), o = X.useRef(null), s = X.useCallback(
    (c) => {
      o.current.setPointerCapture(c.pointerId), n.current = !0, r({
        x: c.clientX,
        y: c.clientY,
        sx: t,
        sy: i
      });
    },
    [r, t, i]
  ), a = X.useCallback(
    (c) => {
      o.current.releasePointerCapture(c.pointerId), n.current = !1, r(void 0);
    },
    [r]
  ), l = X.useCallback(
    (c) => {
      n.current && r({
        x: c.clientX,
        y: c.clientY,
        sx: t,
        sy: i
      });
    },
    [r, t, i]
  );
  return /* @__PURE__ */ f(
    "div",
    {
      className: `${VC.Resizable__handle} ${VC[e]}`,
      ref: o,
      onPointerDown: s,
      onPointerUp: a,
      onPointerMove: l
    }
  );
}
const CTe = X.forwardRef(function(h, g) {
  var A = h, {
    elementType: t = "div",
    side: i,
    className: r,
    style: n,
    children: o,
    width: s,
    setWidth: a,
    height: l,
    setHeight: c,
    onMove: u
  } = A, m = Fe(A, [
    "elementType",
    "side",
    "className",
    "style",
    "children",
    "width",
    "setWidth",
    "height",
    "setHeight",
    "onMove"
  ]);
  const [y, E] = X.useState(), v = i.includes("n"), C = i.includes("e"), x = i.includes("s"), S = i.includes("w"), R = C || S, w = v || x;
  s == null && y && (s = y.width), l == null && y && (l = y.height);
  const T = X.useRef(), N = X.useRef(null), D = X.useCallback(
    (F) => {
      if (F) {
        const Y = N.current.getBoundingClientRect();
        if (T.current) {
          const P = {}, z = window.getComputedStyle(N.current);
          if (R) {
            const W = parseInt(z.minWidth), H = parseInt(z.maxWidth);
            P.width = F.x * F.sx - T.current.x, isNaN(W) || (P.width = Math.max(P.width, W)), isNaN(H) || (P.width = Math.min(P.width, H));
          }
          if (w) {
            const W = parseInt(z.minHeight), H = parseInt(z.maxHeight);
            P.height = F.y * F.sy - T.current.y, isNaN(W) || (P.height = Math.max(P.height, W)), isNaN(H) || (P.height = Math.min(P.height, H));
          }
          if (a && a(P.width), c && c(P.height), E(P), u) {
            const W = F.sx < 0 ? T.current.rx - P.width : T.current.rx, H = F.sy < 0 ? T.current.ry - P.height : T.current.ry;
            u(W, H);
          }
        } else
          T.current = {
            x: F.x * F.sx - (Y.right - Y.left),
            y: F.y * F.sy - (Y.bottom - Y.top),
            rx: F.sx < 0 ? Y.right : Y.left,
            ry: F.sy < 0 ? Y.bottom : Y.top
          };
      } else
        T.current = void 0;
    },
    [R, w, a, c, u]
  ), O = X.useMemo(
    () => sf(N, g),
    [N, g]
  );
  return /* @__PURE__ */ V(
    t,
    ee(q({
      className: me(VC.Resizable, r),
      ref: O,
      style: ee(q({}, n), {
        width: R ? s : void 0,
        height: w ? l : void 0
      })
    }, m), {
      children: [
        o,
        v && /* @__PURE__ */ f(ll, { side: "n", x: 0, y: -1, onDrag: D }),
        C && /* @__PURE__ */ f(ll, { side: "e", x: 1, y: 0, onDrag: D }),
        x && /* @__PURE__ */ f(ll, { side: "s", x: 0, y: 1, onDrag: D }),
        S && /* @__PURE__ */ f(ll, { side: "w", x: -1, y: 0, onDrag: D }),
        v && C && /* @__PURE__ */ f(ll, { side: "ne", x: 1, y: -1, onDrag: D }),
        v && S && /* @__PURE__ */ f(ll, { side: "nw", x: -1, y: -1, onDrag: D }),
        x && C && /* @__PURE__ */ f(ll, { side: "se", x: 1, y: 1, onDrag: D }),
        x && S && /* @__PURE__ */ f(ll, { side: "sw", x: -1, y: 1, onDrag: D })
      ]
    })
  );
});
function xTe({
  title: e,
  onDrag: t,
  onClose: i,
  locked: r,
  buttons: n
}) {
  const [o, s] = X.useState(!1), a = X.useRef(null), l = X.useCallback(
    (m) => {
      m.target === a.current && (a.current.setPointerCapture(m.pointerId), s(!0), t && t({ x: m.clientX, y: m.clientY }));
    },
    [t]
  ), c = X.useCallback(
    (m) => {
      a.current.releasePointerCapture(m.pointerId), s(!1), t && t(void 0);
    },
    [t]
  ), u = X.useCallback(
    (m) => {
      t && t({ x: m.clientX, y: m.clientY });
    },
    [t]
  );
  return /* @__PURE__ */ V(
    "div",
    {
      className: me($u.DialogHeader, r && $u.locked),
      onPointerDown: r ? void 0 : l,
      onPointerUp: r ? void 0 : c,
      onPointerMove: o && !r ? u : void 0,
      ref: a,
      children: [
        /* @__PURE__ */ f("span", { className: $u.DialogTitle, children: e }),
        /* @__PURE__ */ V("span", { className: $u.DialogButtons, children: [
          n,
          !!i && /* @__PURE__ */ f("button", { onClick: i, children: /* @__PURE__ */ f(aA, { icon: "clear" }) })
        ] })
      ]
    }
  );
}
function ij(m) {
  var g = m, {
    modal: e,
    title: t,
    children: i,
    onClose: r,
    style: n,
    className: o,
    onKeyDown: s,
    resizable: a,
    buttons: l,
    locked: c
  } = g, u = Fe(g, [
    "modal",
    "title",
    "children",
    "onClose",
    "style",
    "className",
    "onKeyDown",
    "resizable",
    "buttons",
    "locked"
  ]);
  const [h, A] = X.useState(), y = X.useRef(), E = X.useRef(null), v = X.useCallback((T, N) => {
    const D = E.current.getBoundingClientRect(), O = document.documentElement.clientWidth - 10, F = document.documentElement.clientHeight - 10, Y = Math.min(
      Math.max(0, Math.round(T)),
      O - D.right + D.left
    ), P = Math.min(
      Math.max(0, Math.round(N)),
      F - D.bottom + D.top
    );
    A({ left: Y, top: P });
  }, []), C = X.useCallback((T) => {
    if (T) {
      const N = E.current.getBoundingClientRect(), D = document.documentElement.clientWidth - 10, O = document.documentElement.clientHeight - 10;
      if (y.current) {
        const F = Math.min(
          Math.max(0, Math.round(T.x - y.current.x)),
          D - N.right + N.left
        ), Y = Math.min(
          Math.max(0, Math.round(T.y - y.current.y)),
          O - N.bottom + N.top
        );
        A({ left: F, top: Y });
      } else
        y.current = {
          x: T.x - N.left,
          y: T.y - N.top
        };
    } else
      y.current = void 0;
  }, []);
  X.useLayoutEffect(() => {
    function T() {
      const N = E.current.getBoundingClientRect(), D = document.documentElement.clientWidth - 10, O = document.documentElement.clientHeight - 10;
      A({
        left: Math.round((D - N.right + N.left) / 2),
        top: Math.round((O - N.bottom + N.top) / 2)
      });
    }
    return T(), window.addEventListener("resize", T), () => window.removeEventListener("resize", T);
  }, []);
  const x = h != null;
  X.useLayoutEffect(() => {
    x && E.current.focus();
  }, [x]);
  const S = X.useCallback(
    (T) => {
      r && (T.key === "Esc" || T.key === "Escape") && r(), !e && s && s(T);
    },
    [r, e, s]
  );
  n = q({}, n), h ? (n.left = h.left, n.top = h.top) : n.visibility = "hidden";
  const R = q({
    className: me($u.Dialog, o),
    ref: E,
    style: n,
    tabIndex: -1,
    onKeyDown: (e ? void 0 : S) || s
  }, u), w = t ? /* @__PURE__ */ f(
    xTe,
    {
      title: t,
      onClose: r,
      onDrag: C,
      buttons: l,
      locked: c
    }
  ) : void 0;
  return /* @__PURE__ */ f(cA, { modal: e, onKeyDown: e ? S : void 0, children: a != null ? /* @__PURE__ */ V(CTe, ee(q({}, R), { side: a, onMove: v, children: [
    w,
    i
  ] })) : /* @__PURE__ */ V("div", ee(q({}, R), { children: [
    w,
    i
  ] })) });
}
ij.Content = X.forwardRef(
  ({ children: e, className: t }, i) => /* @__PURE__ */ f("div", { ref: i, className: t, children: e })
);
ij.Footer = ({ children: e, className: t }) => /* @__PURE__ */ f("div", { className: me($u.DialogFooter, t), children: e });
const ITe = (e, t) => {
  const i = (t && !e.match(/^\s/) ? "" : "\\b") + "(", r = ")" + (e.match(/\s$/) ? "\\b" : "");
  if (e = e.trim().replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&"), !!e)
    return new RegExp(i + e + r, "i");
};
function STe(e, t) {
  if (!t)
    return e;
  let i = !1;
  return e.split(t).map((r, n) => !i && r.match(t) ? (i = !0, /* @__PURE__ */ f("u", { children: r }, n)) : r);
}
const RTe = "_Select_x8w8f_1", kTe = "_portal_x8w8f_12", wTe = "_disabled_x8w8f_15", MTe = "_Select__arrow_x8w8f_15", NTe = "_dropBottom_x8w8f_22", TTe = "_dropTop_x8w8f_22", BTe = "_Select__value_x8w8f_22", DTe = "_Select__menu_x8w8f_32", OTe = "_dropTest_x8w8f_53", FTe = "_hasClear_x8w8f_76", VTe = "_empty_x8w8f_79", qTe = "_Select__clear_x8w8f_84", jTe = "_Select__menuScroll_x8w8f_120", LTe = "_Select__noResults_x8w8f_126", KTe = "_Select__search_x8w8f_140", YTe = "_Select__option_x8w8f_160", UTe = "_selected_x8w8f_167", GTe = "_Select__group_x8w8f_182", Ci = {
  Select: RTe,
  portal: kTe,
  disabled: wTe,
  Select__arrow: MTe,
  dropBottom: NTe,
  dropTop: TTe,
  Select__value: BTe,
  Select__menu: DTe,
  dropTest: OTe,
  hasClear: FTe,
  empty: VTe,
  Select__clear: qTe,
  Select__menuScroll: jTe,
  Select__noResults: LTe,
  "depth-1": "_depth-1_x8w8f_130",
  "depth-2": "_depth-2_x8w8f_133",
  "depth-3": "_depth-3_x8w8f_136",
  Select__search: KTe,
  Select__option: YTe,
  selected: UTe,
  Select__group: GTe
}, CN = (e) => typeof e == "object" ? e.id : e, xN = 24;
class QTe {
  constructor(t, i) {
    Ze(this, "heights", []);
    Ze(this, "ids", {});
    Ze(this, "recompute", !0);
    Ze(this, "pos", []);
    this.optionHeight = t, this.headerHeight = i;
  }
  setOptions(t) {
    const { optionHeight: i, headerHeight: r } = this, { heights: n, ids: o } = this, s = [], a = {};
    for (const l of t) {
      const c = l.key in o ? n[o[l.key]] : void 0;
      "value" in l ? i === "auto" ? (a[l.key] = s.length, s.push(c != null ? c : xN)) : typeof i == "function" ? s.push(c != null ? c : i(l.value)) : s.push(i) : r === "auto" ? (a[l.key] = s.length, s.push(c != null ? c : xN)) : s.push(r);
    }
    this.heights = s, this.ids = a, this.recompute = !0;
  }
  setHeight(t, i) {
    if (!(t in this.ids))
      return;
    const r = window.getComputedStyle(i), n = Math.max(
      parseFloat(r.marginTop),
      parseFloat(r.marginBottom)
    ), o = Math.round(i.offsetHeight + n), s = this.ids[t];
    o !== this.heights[s] && (this.heights[s] = o, this.recompute = !0);
  }
  get positions() {
    if (this.recompute) {
      const { pos: t } = this;
      let i = 0;
      t[0] = 0, t.length = 1;
      for (const r of this.heights)
        i += r, t.push(i);
      this.recompute = !1;
    }
    return this.pos;
  }
  locate(t) {
    const i = this.positions;
    let r = 0, n = i.length - 1;
    for (; n - r > 1; ) {
      const o = r + n >> 1;
      i[o] > t ? n = o : r = o;
    }
    return r;
  }
  distance(t, i) {
    const r = this.positions;
    return t < 0 && (t = 0), i >= r.length && (i = r.length - 1), i <= t ? 0 : r[i] - r[t];
  }
}
function WTe({
  optKey: e,
  id: t,
  depth: i,
  value: r,
  disabled: n,
  selected: o,
  setValue: s,
  setFocus: a,
  renderOption: l,
  search: c,
  calculator: u,
  className: m
}) {
  const g = X.useCallback(() => s(r), [r, s]), h = X.useCallback(() => a(t), [t, a]);
  return /* @__PURE__ */ f(
    "li",
    {
      className: me(
        Ci.Select__option,
        m,
        Ci[`depth-${i}`],
        o && Ci.selected,
        n && Ci.disabled
      ),
      onClick: n ? void 0 : g,
      onMouseOver: n ? void 0 : h,
      ref: u ? (A) => A && u.setHeight(e, A) : void 0,
      children: l(r, c)
    }
  );
}
function ZTe({
  id: e,
  depth: t,
  title: i,
  renderHeader: r,
  calculator: n,
  className: o
}) {
  return /* @__PURE__ */ f(
    "li",
    {
      className: me(Ci.Select__group, o, Ci[`depth-${t}`]),
      ref: n ? (s) => s && n.setHeight(e, s) : void 0,
      children: r(i)
    }
  );
}
function JTe(e, t) {
  for (; --t >= 0; ) {
    const i = e[t];
    if ("value" in i && !i.disabled)
      return t;
  }
  return -1;
}
function PTe(e, t) {
  for (; ++t < e.length; ) {
    const i = e[t];
    if ("value" in i && !i.disabled)
      return t;
  }
  return -1;
}
const zTe = X.forwardRef(
  ({ value: e, onChange: t }, i) => {
    const r = X.useCallback(
      (n) => t(n.target.value),
      [t]
    );
    return /* @__PURE__ */ V("div", { className: Ci.Select__search, children: [
      /* @__PURE__ */ f(
        "input",
        {
          type: "text",
          value: e,
          onChange: r,
          ref: i,
          spellCheck: !1
        }
      ),
      /* @__PURE__ */ f(aA, { icon: "search" })
    ] });
  }
), Qu = 10;
function IN({
  options: e,
  className: t,
  optionClass: i,
  groupClass: r,
  renderOption: n,
  isDisabled: o,
  renderHeader: s,
  value: a,
  setValue: l,
  searchMiddle: c,
  searchLimit: u,
  searchFunc: m,
  onClose: g,
  valueDiv: h,
  align: A,
  maxHeight: y,
  noResultsText: E,
  virtualScroll: v,
  menuBefore: C,
  menuRef: x,
  optionHeight: S,
  headerHeight: R,
  style: w
}) {
  const [T, N] = X.useState(""), [D, O] = X.useState(0), F = X.useMemo(
    () => typeof e == "function" ? e() : e,
    [e]
  ), { options: Y, enableSearch: P, search: z } = X.useMemo(() => {
    const Pe = (oi) => oi.reduce(
      (Ai, ut) => Ai + (typeof ut == "object" && "options" in ut ? Pe(ut.options) : 1),
      0
    ), et = u >= 0 && Pe(F) >= u, At = T && et ? ITe(T, c) : void 0, Et = (oi, Ai = ["_g"]) => oi.flatMap((ut) => {
      if (typeof ut == "object" && "options" in ut) {
        const qt = [...Ai, ut.title], Ht = Et(ut.options, qt);
        return Ht.length ? [
          {
            key: qt.join("."),
            depth: Ai.length - 1,
            title: ut.title
          },
          ...Ht
        ] : Ht;
      } else if (!At || m(ut, At)) {
        const qt = CN(ut);
        return {
          key: [...Ai, qt].join("."),
          id: qt,
          depth: Ai.length - 1,
          disabled: o(ut),
          value: ut
        };
      } else
        return [];
    });
    return { options: Et(F), enableSearch: et, search: At };
  }, [
    F,
    u,
    T,
    c,
    m,
    o
  ]), W = X.useRef(void 0);
  W.current || (W.current = new QTe(
    S,
    R
  ));
  const H = X.useRef();
  H.current !== Y && v && (H.current = Y, W.current.setOptions(Y));
  const [Q, $] = X.useState(
    a != null ? CN(a) : void 0
  ), le = X.useMemo(() => {
    const Pe = Y.findIndex(
      (et) => "id" in et && et.id === Q && !et.disabled
    );
    return Pe >= 0 ? Pe : Y.findIndex((et) => "id" in et && !et.disabled);
  }, [Q, Y]), he = X.useRef(null), oe = X.useRef(null), ue = X.useRef(null), Ae = X.useRef(-1), de = X.useCallback(() => {
    v && O(
      Math.max(
        Math.floor(
          W.current.locate(oe.current.scrollTop) / Qu
        ) - 1,
        0
      )
    );
  }, [v]);
  X.useLayoutEffect(() => {
    de();
  }, [Y, de]), X.useLayoutEffect(() => {
    if (!oe.current || v && Ae.current === le)
      return;
    const Pe = oe.current.querySelector(`li.${Ci.selected}`);
    if (Pe) {
      const et = Ae.current < 0 ? "center" : "nearest";
      Hx(Pe, {
        scrollMode: "if-needed",
        block: et,
        inline: et,
        boundary: oe.current
      }), Ae.current = le, de();
    } else
      O(Math.floor(le / Qu));
  }, [le, v, D, de]), X.useEffect(() => {
    A.includes(Ci.dropTest) || (ue.current ? (ue.current.setAttribute("readonly", "readonly"), ue.current.focus(), ue.current.removeAttribute("readonly")) : he.current && he.current.focus());
  }, [A]);
  const fe = X.useCallback(
    (Pe) => {
      (!Pe.relatedTarget || !(h.current.contains(Pe.relatedTarget) || he.current.contains(Pe.relatedTarget))) && g();
    },
    [h, g]
  ), Re = X.useCallback(
    (Pe) => {
      switch (Pe.key) {
        case "Up":
        case "ArrowUp":
          if (le >= 0) {
            const et = Y[JTe(Y, le)];
            et && "id" in et && $(et.id);
          }
          break;
        case "Down":
        case "ArrowDown":
          if (le >= 0) {
            const et = Y[PTe(Y, le)];
            et && "id" in et && $(et.id);
          }
          break;
        case "Esc":
        case "Escape":
          g(), h.current.focus();
          break;
        case "Enter": {
          const et = Y[le];
          et && "value" in et && l(et.value);
          break;
        }
      }
    },
    [le, Y, g, l, h]
  );
  let qe = Y, Oe = 0, Xe = Y.length;
  if (v) {
    Oe = D * Qu;
    const Pe = W.current.distance(0, Oe + Qu), et = W.current.locate(Pe + y);
    Xe = Math.min(
      (Math.ceil(et / Qu) + 2) * Qu,
      Y.length
    ), qe = Y.slice(Oe, Xe);
  }
  const Qe = X.useMemo(() => sf(he, x), [x]);
  return /* @__PURE__ */ V(
    "div",
    {
      ref: Qe,
      className: me(Ci.Select__menu, t),
      tabIndex: -1,
      onBlur: fe,
      onKeyDown: Re,
      style: q({ maxHeight: y }, w),
      children: [
        C,
        !!P && /* @__PURE__ */ f(zTe, { value: T, onChange: N, ref: ue }),
        /* @__PURE__ */ f(
          "div",
          {
            ref: oe,
            className: Ci.Select__menuScroll,
            onScroll: v ? de : void 0,
            children: Y.length ? /* @__PURE__ */ f(
              "ul",
              {
                style: v ? {
                  marginTop: W.current.distance(0, Oe),
                  marginBottom: W.current.distance(
                    Xe,
                    Y.length
                  )
                } : void 0,
                children: qe.map(
                  (Pe, et) => "value" in Pe ? /* @__PURE__ */ f(
                    WTe,
                    ee(q({
                      selected: le === et + Oe
                    }, Pe), {
                      optKey: Pe.key,
                      setValue: l,
                      setFocus: $,
                      renderOption: n,
                      search: z,
                      calculator: v ? W.current : void 0,
                      className: i
                    })
                  ) : /* @__PURE__ */ f(
                    ZTe,
                    {
                      id: Pe.key,
                      depth: Pe.depth,
                      title: Pe.title,
                      renderHeader: s,
                      calculator: v ? W.current : void 0,
                      className: r
                    },
                    Pe.key
                  )
                )
              }
            ) : /* @__PURE__ */ f("div", { className: Ci.Select__noResults, children: E(T) })
          }
        )
      ]
    }
  );
}
const Op = (e) => typeof e == "object" ? e.name : e.toString(), cl = {
  renderOption: (e, t) => /* @__PURE__ */ f("span", { children: t ? STe(Op(e), t) : Op(e) }),
  renderValue: (e) => /* @__PURE__ */ f("span", { children: Op(e) }),
  renderHeader: (e) => /* @__PURE__ */ f("span", { children: e }),
  renderArrow: (e, t) => /* @__PURE__ */ f(aA, { icon: e ? "lock" : "chevron-down", className: t }),
  searchFunc: (e, t) => Op(e).match(t) != null,
  placeholder: "Select option...",
  noResultsText: (e) => e ? `No results match "${e}"` : "No results",
  isDisabled: (e) => typeof e == "object" ? !!e.disabled : !1
};
function HTe({
  children: e,
  from: t,
  to: i,
  method: r,
  padding: n,
  onUpdate: o
}) {
  const s = X.useRef(0), [a, l] = X.useState({
    visibility: "hidden"
  });
  return X.useLayoutEffect(() => {
    let c = {
      visibility: "hidden"
    };
    function u() {
      if (t.current && (o && o(), t.current && i.current)) {
        const m = ee(q({}, ej(
          t.current,
          i.current.getBoundingClientRect(),
          r,
          n
        )), {
          zIndex: (parseInt(window.getComputedStyle(i.current).zIndex, 10) || 0) + 100
        });
        Ut.isEqual(c, m) || (l(m), c = m);
      }
      s.current = requestAnimationFrame(u);
    }
    return s.current = requestAnimationFrame(u), () => cancelAnimationFrame(s.current);
  }, [t, i, r, n, o]), e(a);
}
function XTe(Q, H) {
  var $ = Q, {
    options: e,
    width: t,
    renderOption: i = cl.renderOption,
    renderValue: r = cl.renderValue,
    isDisabled: n = cl.isDisabled,
    renderHeader: o = cl.renderHeader,
    renderArrow: s = cl.renderArrow,
    placeholder: a = cl.placeholder,
    menuBefore: l,
    value: c,
    onChange: u,
    className: m,
    valueClass: g,
    menuClass: h,
    optionClass: A,
    groupClass: y,
    portalTo: E,
    searchLimit: v = -1,
    searchMiddle: C = !1,
    searchFunc: x = cl.searchFunc,
    tabIndex: S = -1,
    maxHeight: R = 300,
    noResultsText: w = cl.noResultsText,
    virtualScroll: T = !1,
    allowEmpty: N = !1,
    disabled: D = !1,
    onOpen: O,
    onClose: F,
    children: Y,
    optionHeight: P = "auto",
    headerHeight: z = "auto"
  } = $, W = Fe($, [
    "options",
    "width",
    "renderOption",
    "renderValue",
    "isDisabled",
    "renderHeader",
    "renderArrow",
    "placeholder",
    "menuBefore",
    "value",
    "onChange",
    "className",
    "valueClass",
    "menuClass",
    "optionClass",
    "groupClass",
    "portalTo",
    "searchLimit",
    "searchMiddle",
    "searchFunc",
    "tabIndex",
    "maxHeight",
    "noResultsText",
    "virtualScroll",
    "allowEmpty",
    "disabled",
    "onOpen",
    "onClose",
    "children",
    "optionHeight",
    "headerHeight"
  ]);
  const [le, he] = X.useState(), oe = X.useCallback(() => {
    le || D ? (le && F && F(), he(void 0)) : (!le && O && O(), he(`${Ci.dropBottom} ${Ci.dropTest}`));
  }, [le, D, F, O]), ue = X.useCallback(() => {
    he(void 0), F && F();
  }, [F]), Ae = X.useRef(null), de = X.useRef(null);
  X.useLayoutEffect(() => {
    if (le && le.includes(Ci.dropTest) && de.current) {
      let Xe = E != null ? E : Ae.current.parentElement, Qe = window.getComputedStyle(Xe);
      for (; Xe !== document.documentElement && Qe.overflow === "visible"; )
        Xe = Xe.parentElement, Qe = window.getComputedStyle(Xe);
      const Pe = Xe.getBoundingClientRect(), et = Pe.top + (parseFloat(Qe.paddingTop) || 0) + (parseFloat(Qe.borderTopWidth) || 0), At = Pe.bottom - (parseFloat(Qe.paddingBottom) || 0) - (parseFloat(Qe.borderBottomWidth) || 0), Et = Ae.current.getBoundingClientRect(), oi = de.current.offsetHeight;
      Et.bottom + oi > At && Et.bottom - oi - At > et - Et.top - oi ? he(Ci.dropTop) : he(Ci.dropBottom);
    }
  }, [E, le]), X.useImperativeHandle(
    H,
    () => ({
      focus() {
        le || oe();
      }
    }),
    [le, oe]
  );
  const fe = X.useCallback(
    (Xe) => {
      he(void 0), u(Xe), Ae.current.focus(), F && F();
    },
    [u, F]
  ), Re = X.useCallback(
    (Xe) => {
      fe(void 0), Xe.stopPropagation();
    },
    [fe]
  ), qe = X.useCallback(
    (Xe) => {
      if (!D)
        switch (Xe.key) {
          case "Enter":
            oe();
            break;
          case "Del":
          case "Delete":
            N && c != null && fe(void 0);
            break;
        }
    },
    [oe, fe, N, c, D]
  );
  let Oe;
  if (le) {
    const Xe = {
      options: e,
      className: h,
      optionClass: A,
      groupClass: y,
      menuBefore: l,
      renderOption: i,
      isDisabled: n,
      renderHeader: o,
      value: c,
      setValue: fe,
      searchLimit: v,
      searchMiddle: C,
      searchFunc: x,
      onClose: ue,
      valueDiv: Ae,
      align: le,
      maxHeight: R,
      virtualScroll: T,
      noResultsText: w,
      menuRef: de,
      optionHeight: P,
      headerHeight: z
    };
    E ? Oe = Kl.createPortal(
      /* @__PURE__ */ f("div", { className: me(Ci.Select, Ci.portal, m, le), children: /* @__PURE__ */ f(
        HTe,
        {
          method: le === Ci.dropBottom ? { from: "tl", to: "bl", matchWidth: !0 } : { from: "bl", to: "tl", matchWidth: !0 },
          from: de,
          to: Ae,
          padding: [-2, 0],
          children: (Qe) => /* @__PURE__ */ f(IN, ee(q({}, Xe), { style: Qe }))
        }
      ) }),
      E
    ) : Oe = /* @__PURE__ */ f(IN, q({}, Xe));
  }
  return /* @__PURE__ */ V(
    "div",
    ee(q({
      className: me(Ci.Select, m, le),
      style: { width: t }
    }, W), {
      children: [
        /* @__PURE__ */ V(
          "div",
          {
            className: me(
              Ci.Select__value,
              g,
              c == null && Ci.empty,
              N && c != null && Ci.hasClear,
              D && Ci.disabled
            ),
            ref: Ae,
            onClick: oe,
            onKeyDown: qe,
            tabIndex: D ? void 0 : S,
            children: [
              c != null ? r(c) : a,
              s(D, Ci.Select__arrow),
              !!(N && c != null && !D) && /* @__PURE__ */ f(aA, { icon: "clear", className: Ci.Select__clear, onClick: Re })
            ]
          }
        ),
        Y,
        Oe
      ]
    })
  );
}
const oDe = X.forwardRef(XTe), _Te = "_Slider_18ij5_1", $Te = "_Slider__track_18ij5_8", e5e = "_Slider__thumb_18ij5_14", t5e = "_Slider__highlight_18ij5_35", N0 = {
  Slider: _Te,
  Slider__track: $Te,
  Slider__thumb: e5e,
  Slider__highlight: t5e
}, PI = (e, t) => [
  (Math.E * e - t) / (Math.E - 1),
  (t - e) / (Math.E - 1)
], qC = X.forwardRef(
  ({
    onChange: e,
    value: t,
    min: i,
    max: r,
    step: n,
    infinite: o,
    disabled: s,
    tabIndex: a
  }, l) => {
    const c = X.useCallback(
      (m) => {
        switch (m.key) {
          case "Down":
          case "ArrowDown":
          case "Left":
          case "ArrowLeft":
            t > i && e(Math.max(t - n, i));
            break;
          case "Up":
          case "ArrowUp":
          case "Right":
          case "ArrowRight":
            o ? e(t + n) : t < r && e(Math.min(t + n, r));
            break;
          case "Home":
            t > i && e(i);
            break;
          case "End":
            t < r && e(r);
            break;
        }
      },
      [i, r, n, o, t, e]
    );
    let u = Math.max(i, t);
    if (o) {
      const [m, g] = PI(i, r);
      u = 1 - g / (u - m);
    } else
      u = (u - i) / (r - i);
    return u = Math.min(1, u) * 100, /* @__PURE__ */ f(
      "span",
      {
        className: N0.Slider__thumb,
        style: { left: `${u.toFixed(2)}%` },
        tabIndex: s ? void 0 : a,
        onKeyDown: s ? void 0 : c,
        ref: l
      }
    );
  }
);
function i5e({
  value1: e,
  value2: t,
  min: i,
  max: r,
  infinite: n
}) {
  let o = Math.max(i, e), s = Math.max(i, t);
  if (n) {
    const [a, l] = PI(i, r);
    o = 1 - l / (o - a), s = 1 - l / (s - a);
  } else
    o = (o - i) / (r - i), s = (s - i) / (r - i);
  return o = Math.min(1, o) * 100, s = Math.min(1, s) * 100, /* @__PURE__ */ f(
    "span",
    {
      className: N0.Slider__highlight,
      style: {
        left: `${o.toFixed(2)}%`,
        width: `${(s - o).toFixed(2)}%`
      }
    }
  );
}
const rj = (e, t, i, r, n) => X.useCallback(
  (o) => {
    const s = e.current.getBoundingClientRect();
    let a = (o - s.left) / (s.right - s.left);
    a = Math.max(0, Math.min(1, a));
    let l;
    if (n) {
      const [c, u] = PI(t, i);
      l = c + u / (1 - Math.min(0.99, a));
    } else
      l = a * (i - t) + t;
    return r && !isNaN(r) && (l = Math.round(l / r) * r), l = Math.max(l, t), n || (l = Math.min(l, i)), l;
  },
  [e, t, i, r, n]
);
function sDe(u) {
  var m = u, {
    min: e,
    max: t,
    step: i = 1,
    infinite: r,
    value: n,
    onChange: o,
    tabIndex: s = -1,
    className: a,
    disabled: l
  } = m, c = Fe(m, [
    "min",
    "max",
    "step",
    "infinite",
    "value",
    "onChange",
    "tabIndex",
    "className",
    "disabled"
  ]);
  const g = X.useRef(null), h = X.useRef(null), A = X.useRef(), y = rj(g, e, t, i, r), E = X.useCallback(
    (R) => {
      A.current != null && o && o(y(R.clientX - A.current));
    },
    [y, o]
  ), v = X.useCallback(
    (R) => {
      if (R.target.classList.contains("ui-Slider-thumb")) {
        const w = R.target.getBoundingClientRect();
        A.current = R.clientX - (w.left + w.right) / 2;
      } else
        A.current = 0;
      h.current.focus(), g.current.setPointerCapture(R.pointerId), E(R);
    },
    [E]
  ), C = X.useCallback((R) => {
    A.current = void 0, g.current.releasePointerCapture(R.pointerId);
  }, []), x = X.useCallback(
    (R) => R.preventDefault(),
    []
  ), S = {};
  return l || (S.onPointerDown = v, S.onPointerUp = C, S.onPointerMove = E, S.onDragStart = x), /* @__PURE__ */ f("div", ee(q({ className: me(N0.Slider, a) }, c), { children: /* @__PURE__ */ f("div", ee(q({ className: N0.Slider__track, ref: g }, S), { children: /* @__PURE__ */ f(
    qC,
    {
      min: e,
      max: t,
      value: n,
      onChange: o,
      step: i,
      infinite: r,
      disabled: l,
      tabIndex: s,
      ref: h
    }
  ) })) }));
}
function aDe(g) {
  var h = g, {
    min: e,
    max: t,
    step: i = 1,
    infinite: r,
    value1: n,
    value2: o,
    onChange1: s,
    onChange2: a,
    tabIndex: l = -1,
    className: c,
    disabled: u
  } = h, m = Fe(h, [
    "min",
    "max",
    "step",
    "infinite",
    "value1",
    "value2",
    "onChange1",
    "onChange2",
    "tabIndex",
    "className",
    "disabled"
  ]);
  const A = X.useRef(null), y = X.useRef(null), E = X.useRef(null), v = X.useRef(), C = X.useRef(), x = rj(A, e, t, i, r), S = X.useCallback(
    (F) => {
      if (C.current == null)
        return;
      const Y = x(F.clientX - v.current);
      C.current === 1 ? s(Math.min(Y, o)) : C.current === 2 && a(Math.max(Y, n));
    },
    [s, a, n, o, x]
  ), R = X.useCallback(
    (F) => {
      if (F.target.classList.contains("ui-Slider-thumb")) {
        const P = F.target.getBoundingClientRect();
        v.current = F.clientX - (P.left + P.right) / 2;
      } else
        v.current = 0;
      const Y = x(F.clientX - v.current);
      Y < (n + o) / 2 ? (C.current = 1, y.current.focus(), s(Math.min(Y, o))) : (C.current = 2, E.current.focus(), a(Math.max(Y, n))), A.current.setPointerCapture(F.pointerId);
    },
    [x, s, a, n, o]
  ), w = X.useCallback((F) => {
    C.current = void 0, A.current.releasePointerCapture(F.pointerId);
  }, []), T = X.useCallback(
    (F) => F.preventDefault(),
    []
  ), N = X.useCallback(
    (F) => s(Math.min(F, o)),
    [s, o]
  ), D = X.useCallback(
    (F) => a(Math.max(F, n)),
    [a, n]
  ), O = {};
  return u || (O.onPointerDown = R, O.onPointerUp = w, O.onPointerMove = S, O.onDragStart = T), /* @__PURE__ */ f("div", ee(q({ className: me(N0.Slider, c) }, m), { children: /* @__PURE__ */ V("div", ee(q({ className: N0.Slider__track, ref: A }, O), { children: [
    /* @__PURE__ */ f(i5e, { min: e, max: t, value1: n, value2: o, infinite: r }),
    /* @__PURE__ */ f(
      qC,
      {
        min: e,
        max: t,
        value: n,
        onChange: N,
        step: i,
        infinite: r,
        disabled: u,
        tabIndex: l,
        ref: y
      }
    ),
    /* @__PURE__ */ f(
      qC,
      {
        min: e,
        max: t,
        value: o,
        onChange: D,
        step: i,
        infinite: r,
        disabled: u,
        tabIndex: l,
        ref: E
      }
    )
  ] })) }));
}
const r5e = "_Tabs_qxpip_1", n5e = "_TabsHeader_qxpip_6", o5e = "_TabsContent_qxpip_15", s5e = "_Tab_qxpip_1", a5e = "_active_qxpip_38", l5e = "_disabled_qxpip_52", c5e = "_TabLine_qxpip_61", u5e = "_vertical_qxpip_72", Ca = {
  Tabs: r5e,
  TabsHeader: n5e,
  TabsContent: o5e,
  Tab: s5e,
  active: a5e,
  disabled: l5e,
  TabLine: c5e,
  vertical: u5e
};
function d5e({
  value: e,
  onChange: t,
  tabs: i,
  vertical: r,
  tabsSide: n,
  className: o,
  activeClass: s
}) {
  const [a, l] = X.useState(), [c, u] = X.useState(), m = X.useRef(null), g = X.useRef(null);
  X.useEffect(() => {
    var A;
    if (g.current && ((A = m.current) != null && A.offsetParent)) {
      const y = g.current.getBoundingClientRect(), E = m.current.offsetParent.getBoundingClientRect(), v = {};
      r ? (v.top = y.top - E.top + 6, v.left = y.right - E.left, v.height = y.bottom - y.top - 12) : (v.left = y.left - E.left, v.top = y.bottom - E.top, v.width = y.right - y.left), u(v);
    }
  }, [e, a, r]);
  const h = a || e;
  return /* @__PURE__ */ V(
    "div",
    {
      className: me(
        Ca.TabsHeader,
        o,
        r && Ca.vertical
      ),
      children: [
        /* @__PURE__ */ f("ul", { children: i.map(({ id: A, name: y, disabled: E }) => /* @__PURE__ */ f(
          "li",
          {
            className: me(
              Ca.Tab,
              A === e && Ca.active,
              A === e && s,
              E && Ca.disabled
            ),
            onClick: () => !E && t(A),
            onMouseOver: () => !E && l(A),
            onMouseOut: () => l(void 0),
            children: /* @__PURE__ */ f("span", { ref: A === h ? g : null, children: y })
          },
          A
        )) }),
        n,
        /* @__PURE__ */ f("div", { className: Ca.TabLine, ref: m, style: c })
      ]
    }
  );
}
function lDe({
  value: e,
  onChange: t,
  tabs: i,
  className: r,
  contentClass: n,
  vertical: o,
  children: s,
  showIfSingleTab: a = !0,
  tabsSide: l
}) {
  const c = a || i.length > 1;
  return X.useEffect(() => {
    var u;
    ((u = i == null ? void 0 : i[0]) == null ? void 0 : u.id) !== void 0 && t(i[0].id);
  }, [c, t, i]), /* @__PURE__ */ V(
    "div",
    {
      className: me(Ca.Tabs, r, o && Ca.vertical),
      children: [
        c && /* @__PURE__ */ f(
          d5e,
          {
            tabs: i,
            onChange: t,
            value: e,
            tabsSide: l,
            vertical: o
          }
        ),
        /* @__PURE__ */ f("div", { className: me(Ca.TabsContent, n), children: s })
      ]
    }
  );
}
class m5e {
  constructor() {
    Ze(this, "stack", []);
    Ze(this, "keyHandler", (t) => {
      const i = this.stack[this.stack.length - 1];
      (i == null ? void 0 : i.lockKey) === "alt" && t.key === "Alt" && (t.preventDefault(), i.locked = !i.locked, this.updateHandlers());
    });
    Ze(this, "handlerInstalled", !1);
  }
  get root() {
    if (typeof document == "undefined")
      return;
    const t = document.getElementById("uitools-tooltip-root");
    if (t)
      return t;
    const i = document.createElement("div");
    return i.id = "uitools-tooltip-root", document.body.appendChild(i), i;
  }
  popUntil(t) {
    for (; this.stack.length > t; )
      this.stack.pop().handler(void 0);
  }
  updateHandlers() {
    const t = this.stack[this.stack.length - 1];
    for (let r = 0; r < this.stack.length; ++r) {
      const n = this.stack[r];
      n.handler({
        node: n.node,
        visible: n.locked || n === t,
        locked: n.locked,
        touch: n.touch,
        zIndex: 1e4 + r,
        active: n === t
      });
    }
    const i = (t == null ? void 0 : t.lockKey) === "alt";
    i !== this.handlerInstalled && (i ? document.addEventListener("keydown", this.keyHandler, !0) : document.removeEventListener("keydown", this.keyHandler, !0), this.handlerInstalled = i);
  }
  register({
    node: t,
    handler: i,
    touch: r,
    lockKey: n
  }) {
    var l;
    const o = (l = this.root) == null ? void 0 : l.contains(t);
    let s = this.stack.length;
    for (; s > 0; ) {
      const c = this.stack[s - 1];
      if (o && c.locked || (c.node.contains(t) || t.contains(c.node)) && !c.locked)
        break;
      s -= 1;
    }
    for (this.popUntil(s); s > 0; ) {
      const c = this.stack[s - 1];
      if (!t.contains(c.node))
        break;
      s -= 1;
    }
    const a = {
      handler: i,
      node: t,
      touch: r,
      locked: r,
      lockKey: n
    };
    return this.stack.splice(s, 0, a), this.updateHandlers(), () => {
      const c = this.stack.indexOf(a);
      c < 0 || (a.locked ? this.popUntil(c) : (this.stack.splice(c, 1), a.handler(void 0)), this.updateHandlers());
    };
  }
}
const u0 = new m5e();
function g5e({
  wrapper: e,
  node: t,
  align: i,
  padding: r = 0,
  touch: n,
  actions: o
}) {
  const s = t.getBoundingClientRect(), a = {
    left: 10,
    top: 10,
    right: document.documentElement.clientWidth - 10,
    bottom: document.documentElement.clientHeight - 10
  };
  let l = e.offsetWidth, c = e.offsetHeight;
  const u = {}, m = {};
  if (n && l > a.right - a.left) {
    const R = (a.right - a.left) / l;
    l = Math.round(l * R), c = Math.round(c * R), u.transform = `scale(${R.toFixed(3)})`, u.width = l, u.height = c;
  }
  const g = {
    left: 0,
    top: 0,
    right: l,
    bottom: c
  };
  if (n && o)
    return { fullscreen: !0, rect: g, style: u, positionerStyle: m };
  const h = ["right", "left", "top", "bottom"];
  if (i) {
    const R = h.indexOf(i);
    R >= 0 && (h[R] = h[0], h[0] = i);
  }
  const A = 5 + r, y = 5 + r;
  let E = Math.round((s.top + s.bottom - c) / 2);
  E = Math.min(E, a.bottom - c), E = Math.max(E, a.top);
  let v = Math.round((s.left + s.right - l) / 2);
  v = Math.min(v, a.right - l), v = Math.max(v, a.left);
  let C = 0, x = 0, S = !0;
  for (const R of h)
    if (R === "right") {
      if (s.right + A + l <= a.right) {
        C = s.right + A, x = E, S = !1;
        break;
      }
    } else if (R === "left") {
      if (s.left - A - l >= a.left) {
        C = s.left - A - l, x = E, S = !1;
        break;
      }
    } else if (R === "top") {
      if (s.top - y - c >= a.top) {
        C = v, x = s.top - y - c, S = !1;
        break;
      }
    } else if (R === "bottom" && s.bottom + y + c <= a.bottom) {
      C = v, x = s.bottom + y, S = !1;
      break;
    }
  return S && (a.right - s.right > s.left - a.left ? (C = s.right + A, x = E) : (C = s.left - y - l, x = E)), n && S ? { fullscreen: !0, rect: g, style: u, positionerStyle: m } : (g.left = C, g.top = x, g.right = l + C, g.bottom = c + C, {
    style: u,
    positionerStyle: m,
    rect: g,
    scroll: l > a.right - a.left || c > a.bottom - a.top ? { x: 0, y: 0 } : void 0
  });
}
function h5e(e, t) {
  const i = {
    left: 5,
    top: 5,
    right: document.documentElement.clientWidth - 5,
    bottom: document.documentElement.clientHeight - 5
  };
  if (!t.scroll)
    return;
  const r = q({}, t.scroll);
  if (t.rect.right - t.rect.left > i.right - i.left && (r.x = Math.max(
    t.rect.left - i.left,
    Math.min(t.rect.right - i.right, r.x + e.deltaX)
  )), t.rect.bottom - t.rect.top > i.bottom - i.top && (r.y = Math.max(
    t.rect.top - i.top,
    Math.min(t.rect.bottom - i.bottom, r.y + e.deltaY)
  )), r.x !== t.scroll.x || r.y !== t.scroll.y)
    return ee(q({}, t), {
      scroll: r
    });
}
const p5e = "_Tooltip_orqi6_2", f5e = "_hidden_orqi6_15", A5e = "_Tooltip__positioner_orqi6_18", y5e = "_Tooltip__wrapper_orqi6_21", E5e = "_locked_orqi6_24", v5e = "_fullscreen_orqi6_24", b5e = "_Tooltip__close_orqi6_41", C5e = "_Tooltip__actions_orqi6_60", x5e = "_TooltipPlain_orqi6_77", ss = {
  Tooltip: p5e,
  hidden: f5e,
  Tooltip__positioner: A5e,
  Tooltip__wrapper: y5e,
  locked: E5e,
  fullscreen: v5e,
  Tooltip__close: b5e,
  Tooltip__actions: C5e,
  TooltipPlain: x5e
}, I5e = {
  rect: { left: 0, top: 0, right: 0, bottom: 0 },
  style: {
    visibility: "hidden"
  },
  positionerStyle: {}
}, S5e = X.createContext(!1);
function nj({
  tooltip: e,
  align: t,
  padding: i,
  innerScrollSelector: r,
  actions: n,
  node: o,
  visible: s,
  locked: a,
  touch: l,
  zIndex: c,
  active: u,
  onClose: m
}) {
  var R, w, T, N;
  const [g, h] = X.useState(I5e), A = X.useRef(null), y = n != null;
  X.useLayoutEffect(() => {
    const D = g5e({
      wrapper: A.current,
      node: o,
      align: t,
      padding: i,
      touch: l,
      actions: y
    });
    h(D);
  }, [o, t, i, l, y]);
  const E = X.useRef(g);
  E.current = g;
  const v = u && g.scroll != null;
  X.useEffect(() => {
    function D(O) {
      if (r) {
        const F = A.current.querySelector(r);
        if (F && F.clientHeight < F.scrollHeight) {
          O.preventDefault(), O.stopPropagation();
          const Y = Math.max(
            0,
            Math.min(
              F.scrollHeight - F.clientHeight,
              F.scrollTop + O.deltaY
            )
          );
          if (Y !== F.scrollTop) {
            F.scrollTop = Y;
            return;
          }
        }
      }
      if (v) {
        const F = h5e(O, E.current);
        F && (O.stopPropagation(), O.preventDefault(), h(F));
      }
    }
    if (v || r)
      return document.addEventListener("wheel", D, {
        capture: !0,
        passive: !1
      }), () => {
        document.removeEventListener("wheel", D, {
          capture: !0
        });
      };
  }, [v, r]);
  const C = l && !g.fullscreen, x = X.useCallback((D) => {
    D.stopPropagation();
  }, []), S = X.useCallback(
    (D) => {
      var F;
      const O = D.target;
      (C || !((F = A.current) != null && F.contains(D.target))) && !O.closest(`.${ss.Tooltip__close}, .${ss.Tooltip__actions}`) && m(), D.stopPropagation();
    },
    [m, C]
  );
  return /* @__PURE__ */ V(
    "div",
    {
      className: me(
        ss.Tooltip,
        a && ss.locked,
        g.fullscreen && ss.fullscreen,
        !s && ss.hidden
      ),
      style: {
        zIndex: c
      },
      onMouseDown: S,
      onMouseMove: x,
      onMouseUp: x,
      onPointerDown: x,
      onPointerMove: x,
      onPointerUp: x,
      onClick: x,
      children: [
        /* @__PURE__ */ f(
          "div",
          {
            className: ss.Tooltip__positioner,
            style: q({
              left: g.rect.left - ((w = (R = g.scroll) == null ? void 0 : R.x) != null ? w : 0),
              top: g.rect.top - ((N = (T = g.scroll) == null ? void 0 : T.y) != null ? N : 0)
            }, g.positionerStyle),
            children: /* @__PURE__ */ V("div", { className: ss.Tooltip__wrapper, style: g.style, ref: A, children: [
              /* @__PURE__ */ f(S5e.Provider, { value: !0, children: e }),
              " "
            ] })
          }
        ),
        g.fullscreen && /* @__PURE__ */ f("div", { className: ss.Tooltip__close, onClick: m }),
        g.fullscreen && n && /* @__PURE__ */ f("ul", { className: ss.Tooltip__actions, children: n.map(({ text: D, action: O }, F) => /* @__PURE__ */ f(
          "li",
          {
            onClick: () => {
              O(), m();
            },
            children: D
          },
          F
        )) })
      ]
    }
  );
}
function R5e(o) {
  var s = o, {
    children: e,
    disabled: t,
    touchAction: i,
    lockKey: r
  } = s, n = Fe(s, [
    "children",
    "disabled",
    "touchAction",
    "lockKey"
  ]);
  const [a, l] = X.useState(), [c, u] = X.useState();
  X.useEffect(() => {
    if (a && !t)
      return u0.register({
        handler: u,
        node: a.node,
        touch: a.touch,
        lockKey: r
      });
  }, [a, r, t]);
  const m = X.useCallback(() => {
    l(void 0);
  }, []), g = X.useCallback(() => {
    c != null && c.locked || l(void 0);
  }, [c == null ? void 0 : c.locked]), h = X.useCallback(
    (w) => {
      w.pointerType !== "mouse" && i || l({
        node: w.currentTarget,
        touch: w.pointerType !== "mouse"
      });
    },
    [i]
  ), A = X.useRef(), y = X.useRef(), E = X.useCallback(
    (w) => {
      var T;
      if (i !== "none") {
        if (((T = w.touches) == null ? void 0 : T.length) === 1) {
          const N = w.touches[0];
          A.current = { x: N.clientX, y: N.clientY, time: Date.now() };
        } else
          A.current = void 0;
        if (i === "hold") {
          y.current != null && window.clearTimeout(y.current);
          const N = w.currentTarget;
          y.current = window.setTimeout(() => {
            l({
              node: N,
              touch: !0
            });
          }, 1e3);
        }
      }
    },
    [i]
  ), v = X.useCallback(
    (w) => {
      var T, N;
      if (i !== "none") {
        if (y.current != null && (window.clearTimeout(y.current), y.current = void 0), i === "hold") {
          if (!A.current)
            return;
          if (Date.now() - A.current.time < 1e3) {
            A.current = void 0;
            return;
          }
        }
        if (w.preventDefault(), ((T = w.touches) == null ? void 0 : T.length) === 0 && ((N = w.changedTouches) == null ? void 0 : N.length) === 1 && A.current) {
          const D = w.changedTouches[0], O = Math.abs(D.clientX - A.current.x), F = Math.abs(D.clientY - A.current.y);
          O < 50 && F < 50 && l({
            node: w.currentTarget,
            touch: !0
          });
        }
      }
      A.current = void 0;
    },
    [i]
  ), C = X.useCallback(
    (w) => {
      i === "hold" && y.current != null && w.preventDefault();
    },
    [i]
  );
  X.useEffect(() => () => {
    y.current != null && (window.clearTimeout(y.current), y.current = void 0);
  }, []);
  const x = X.Children.only(e), S = {
    onPointerEnter: h,
    onPointerLeave: g,
    onTouchStart: E,
    onTouchEnd: v,
    onContextMenu: C
  };
  for (const w in S)
    if (x.props[w]) {
      const T = S[w], N = x.props[w];
      S[w] = function(...D) {
        T.call(this, ...D), N.call(this, ...D);
      };
    }
  const R = c && u0.root && Kl.createPortal(
    /* @__PURE__ */ f(nj, ee(q(q({}, n), c), { onClose: m })),
    u0.root
  );
  return /* @__PURE__ */ V(X.Fragment, { children: [
    X.cloneElement(x, S),
    R
  ] });
}
function cDe(n) {
  var o = n, {
    nodeRef: e,
    lockKey: t,
    touch: i = !1
  } = o, r = Fe(o, [
    "nodeRef",
    "lockKey",
    "touch"
  ]);
  const [s, a] = X.useState();
  return X.useEffect(
    () => u0.register({
      handler: a,
      node: e.current,
      touch: i,
      lockKey: t
    }),
    [t, i, e]
  ), !s || !u0.root ? null : Kl.createPortal(
    /* @__PURE__ */ f(nj, q(q({}, r), s)),
    u0.root
  );
}
function uDe(r) {
  var n = r, {
    tooltip: e,
    touchAction: t
  } = n, i = Fe(n, [
    "tooltip",
    "touchAction"
  ]);
  return e && (e = /* @__PURE__ */ f("div", { className: ss.TooltipPlain, children: e })), /* @__PURE__ */ f(
    R5e,
    ee(q({}, i), {
      tooltip: e,
      touchAction: t != null ? t : "none"
    })
  );
}
export {
  P$ as $,
  _f as A,
  fo as B,
  iu as C,
  hke as D,
  Bie as E,
  Ia as F,
  DP as G,
  gi as H,
  tl as I,
  Kae as J,
  Die as K,
  nt as L,
  $5e as M,
  B1 as N,
  Ka as O,
  Mf as P,
  iBe as Q,
  _5e as R,
  wg as S,
  kn as T,
  nBe as U,
  _s as V,
  LO as W,
  j2e as X,
  vBe as Y,
  HO as Z,
  zO as _,
  L as a,
  cm as a$,
  PBe as a0,
  JBe as a1,
  BV as a2,
  zBe as a3,
  qf as a4,
  iI as a5,
  Kt as a6,
  HBe as a7,
  Mt as a8,
  XBe as a9,
  s7e as aA,
  n1e as aB,
  a7e as aC,
  x2e as aD,
  l7e as aE,
  TC as aF,
  c7e as aG,
  u7e as aH,
  BC as aI,
  d7e as aJ,
  m7e as aK,
  h4e as aL,
  Nq as aM,
  O4e as aN,
  g7e as aO,
  Pde as aP,
  Vf as aQ,
  h7e as aR,
  _T as aS,
  p7e as aT,
  XT as aU,
  V5e as aV,
  Gs as aW,
  Cc as aX,
  PT as aY,
  V9 as aZ,
  go as a_,
  Z1 as aa,
  $be as ab,
  _be as ac,
  ahe as ad,
  _Be as ae,
  U0e as af,
  T0e as ag,
  Px as ah,
  Fg as ai,
  Pr as aj,
  Dxe as ak,
  zx as al,
  YO as am,
  eI as an,
  $Be as ao,
  e7e as ap,
  upe as aq,
  mIe as ar,
  Zme as as,
  t7e as at,
  SIe as au,
  i7e as av,
  Xc as aw,
  r7e as ax,
  n7e as ay,
  o7e as az,
  it as b,
  $x as b$,
  of as b0,
  eu as b1,
  Hk as b2,
  F5e as b3,
  f7e as b4,
  Wt as b5,
  F5 as b6,
  j5e as b7,
  L5e as b8,
  A7e as b9,
  EBe as bA,
  kde as bB,
  bBe as bC,
  CBe as bD,
  xBe as bE,
  Hme as bF,
  IBe as bG,
  SBe as bH,
  RBe as bI,
  TBe as bJ,
  BBe as bK,
  DBe as bL,
  FBe as bM,
  VBe as bN,
  OBe as bO,
  w1e as bP,
  gM as bQ,
  $0 as bR,
  uC as bS,
  nge as bT,
  qBe as bU,
  EF as bV,
  jBe as bW,
  GBe as bX,
  QBe as bY,
  WBe as bZ,
  dF as b_,
  HT as ba,
  F1e as bb,
  Uf as bc,
  y7e as bd,
  E7e as be,
  v7e as bf,
  Wwe as bg,
  b7e as bh,
  C7e as bi,
  x7e as bj,
  I7e as bk,
  Kq as bl,
  aA as bm,
  sf as bn,
  sBe as bo,
  aBe as bp,
  y0e as bq,
  lBe as br,
  cBe as bs,
  uBe as bt,
  dBe as bu,
  mBe as bv,
  gBe as bw,
  fBe as bx,
  ABe as by,
  yBe as bz,
  Z5e as c,
  tTe as c$,
  $O as c0,
  gF as c1,
  on as c2,
  rge as c3,
  ZBe as c4,
  whe as c5,
  nde as c6,
  pBe as c7,
  hBe as c8,
  UO as c9,
  Hq as cA,
  WNe as cB,
  ZNe as cC,
  T7e as cD,
  lA as cE,
  YNe as cF,
  k7e as cG,
  w7e as cH,
  M7e as cI,
  N7e as cJ,
  B7e as cK,
  D7e as cL,
  O7e as cM,
  F7e as cN,
  nTe as cO,
  rDe as cP,
  nDe as cQ,
  ij as cR,
  CTe as cS,
  sDe as cT,
  aDe as cU,
  S5e as cV,
  R5e as cW,
  cDe as cX,
  uDe as cY,
  HTe as cZ,
  ej as c_,
  _x as ca,
  oBe as cb,
  Ui as cc,
  NBe as cd,
  mhe as ce,
  ghe as cf,
  che as cg,
  Yf as ch,
  lF as ci,
  kBe as cj,
  MBe as ck,
  wBe as cl,
  Ug as cm,
  LBe as cn,
  KBe as co,
  YBe as cp,
  UBe as cq,
  WCe as cr,
  zq as cs,
  UNe as ct,
  oDe as cu,
  lDe as cv,
  d5e as cw,
  S7e as cx,
  wNe as cy,
  R7e as cz,
  me as d,
  Xq as d0,
  _q as d1,
  $q as d2,
  V7e as d3,
  cA as d4,
  q7e as d5,
  j7e as d6,
  jNe as d7,
  vO as d8,
  ole as d9,
  tDe as dA,
  iDe as dB,
  Lw as da,
  eBe as db,
  bO as dc,
  CO as dd,
  xO as de,
  tBe as df,
  ITe as dg,
  STe as dh,
  L7e as di,
  K7e as dj,
  Y7e as dk,
  U7e as dl,
  G7e as dm,
  Q7e as dn,
  W7e as dp,
  Z7e as dq,
  J7e as dr,
  P7e as ds,
  Dp as dt,
  z7e as du,
  H7e as dv,
  X7e as dw,
  _7e as dx,
  $7e as dy,
  eDe as dz,
  H$ as e,
  nw as f,
  L2 as g,
  kD as h,
  Mc as i,
  QB as j,
  kl as k,
  xl as l,
  X5e as m,
  S8 as n,
  J5e as o,
  z5e as p,
  are as q,
  BB as r,
  KB as s,
  hae as t,
  vg as u,
  P5e as v,
  ure as w,
  Pm as x,
  C8 as y,
  Ho as z
};
